
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ebB0J", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $a53ecd55de691b29$export$6503ec6e8aabbaf; }, function (v) { return $a53ecd55de691b29$export$6503ec6e8aabbaf = v; });
var $a53ecd55de691b29$export$6503ec6e8aabbaf;
var $a53ecd55de691b29$export$f7ad0328861e2f03;
"use strict";
var $a53ecd55de691b29$var$mapping = new Map();
function $a53ecd55de691b29$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$a53ecd55de691b29$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $a53ecd55de691b29$var$resolve(id) {
    var resolved = $a53ecd55de691b29$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$a53ecd55de691b29$export$6503ec6e8aabbaf = $a53ecd55de691b29$var$register;
$a53ecd55de691b29$export$f7ad0328861e2f03 = $a53ecd55de691b29$var$resolve;

});

parcelRegister("6IstV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4e3cf1fd5d79c889$export$ffb0004e005737fa; }, function (v) { return $4e3cf1fd5d79c889$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4e3cf1fd5d79c889$export$34b9dba7ce09269b; }, function (v) { return $4e3cf1fd5d79c889$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4e3cf1fd5d79c889$export$25062201e9e25d76; }, function (v) { return $4e3cf1fd5d79c889$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4e3cf1fd5d79c889$export$ffb0004e005737fa;
var $4e3cf1fd5d79c889$export$34b9dba7ce09269b;
var $4e3cf1fd5d79c889$export$25062201e9e25d76;
'use strict';

var $8nGP5 = parcelRequire("8nGP5");
var $4e3cf1fd5d79c889$var$k = Symbol.for("react.element"), $4e3cf1fd5d79c889$var$l = Symbol.for("react.fragment"), $4e3cf1fd5d79c889$var$m = Object.prototype.hasOwnProperty, $4e3cf1fd5d79c889$var$n = $8nGP5.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4e3cf1fd5d79c889$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4e3cf1fd5d79c889$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4e3cf1fd5d79c889$var$m.call(a, b) && !$4e3cf1fd5d79c889$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4e3cf1fd5d79c889$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4e3cf1fd5d79c889$var$n.current
    };
}
$4e3cf1fd5d79c889$export$ffb0004e005737fa = $4e3cf1fd5d79c889$var$l;
$4e3cf1fd5d79c889$export$34b9dba7ce09269b = $4e3cf1fd5d79c889$var$q;
$4e3cf1fd5d79c889$export$25062201e9e25d76 = $4e3cf1fd5d79c889$var$q;

});
parcelRegister("8nGP5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kO00g"));

});
parcelRegister("kO00g", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $f2587acb1c26d227$export$dca3b0875bd9a954; }, function (v) { return $f2587acb1c26d227$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $f2587acb1c26d227$export$16fa2f45be04daa8; }, function (v) { return $f2587acb1c26d227$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f2587acb1c26d227$export$ffb0004e005737fa; }, function (v) { return $f2587acb1c26d227$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $f2587acb1c26d227$export$e2c29f18771995cb; }, function (v) { return $f2587acb1c26d227$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $f2587acb1c26d227$export$221d75b3f55bb0bd; }, function (v) { return $f2587acb1c26d227$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f2587acb1c26d227$export$5f8d39834fd61797; }, function (v) { return $f2587acb1c26d227$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f2587acb1c26d227$export$74bf444e3cd11ea5; }, function (v) { return $f2587acb1c26d227$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f2587acb1c26d227$export$ae55be85d98224ed; }, function (v) { return $f2587acb1c26d227$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $f2587acb1c26d227$export$e530037191fcd5d7; }, function (v) { return $f2587acb1c26d227$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $f2587acb1c26d227$export$fd42f52fd3ae1109; }, function (v) { return $f2587acb1c26d227$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $f2587acb1c26d227$export$c8a8987d4410bf2d; }, function (v) { return $f2587acb1c26d227$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $f2587acb1c26d227$export$d38cd72104c1f0e9; }, function (v) { return $f2587acb1c26d227$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $f2587acb1c26d227$export$7d1e3a5e95ceca43; }, function (v) { return $f2587acb1c26d227$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $f2587acb1c26d227$export$257a8862b851cb5b; }, function (v) { return $f2587acb1c26d227$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $f2587acb1c26d227$export$a8257692ac88316c; }, function (v) { return $f2587acb1c26d227$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $f2587acb1c26d227$export$488013bae63b21da; }, function (v) { return $f2587acb1c26d227$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $f2587acb1c26d227$export$7c73462e0d25e514; }, function (v) { return $f2587acb1c26d227$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $f2587acb1c26d227$export$7568632d0d33d16d; }, function (v) { return $f2587acb1c26d227$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $f2587acb1c26d227$export$88948ce120ea2619; }, function (v) { return $f2587acb1c26d227$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $f2587acb1c26d227$export$35808ee640e87ca7; }, function (v) { return $f2587acb1c26d227$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $f2587acb1c26d227$export$fae74005e78b1a27; }, function (v) { return $f2587acb1c26d227$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $f2587acb1c26d227$export$dc8fbce3eb94dc1e; }, function (v) { return $f2587acb1c26d227$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $f2587acb1c26d227$export$6a7bc4e911dc01cf; }, function (v) { return $f2587acb1c26d227$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $f2587acb1c26d227$export$6d9c69b0de29b591; }, function (v) { return $f2587acb1c26d227$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $f2587acb1c26d227$export$f680877a34711e37; }, function (v) { return $f2587acb1c26d227$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f2587acb1c26d227$export$d5a552a76deda3c2; }, function (v) { return $f2587acb1c26d227$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $f2587acb1c26d227$export$aaabe4eda9ed9969; }, function (v) { return $f2587acb1c26d227$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f2587acb1c26d227$export$e5c5a5f917a5871c; }, function (v) { return $f2587acb1c26d227$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $f2587acb1c26d227$export$1538c33de8887b59; }, function (v) { return $f2587acb1c26d227$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $f2587acb1c26d227$export$13e3392192263954; }, function (v) { return $f2587acb1c26d227$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $f2587acb1c26d227$export$b8f5890fc79d6aca; }, function (v) { return $f2587acb1c26d227$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $f2587acb1c26d227$export$60241385465d0a34; }, function (v) { return $f2587acb1c26d227$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $f2587acb1c26d227$export$306c0aa65ff9ec16; }, function (v) { return $f2587acb1c26d227$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $f2587acb1c26d227$export$7b286972b8d8ccbf; }, function (v) { return $f2587acb1c26d227$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $f2587acb1c26d227$export$83d89fbfd8236492; }, function (v) { return $f2587acb1c26d227$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f2587acb1c26d227$export$dca3b0875bd9a954;
var $f2587acb1c26d227$export$16fa2f45be04daa8;
var $f2587acb1c26d227$export$ffb0004e005737fa;
var $f2587acb1c26d227$export$e2c29f18771995cb;
var $f2587acb1c26d227$export$221d75b3f55bb0bd;
var $f2587acb1c26d227$export$5f8d39834fd61797;
var $f2587acb1c26d227$export$74bf444e3cd11ea5;
var $f2587acb1c26d227$export$ae55be85d98224ed;
var $f2587acb1c26d227$export$e530037191fcd5d7;
var $f2587acb1c26d227$export$fd42f52fd3ae1109;
var $f2587acb1c26d227$export$c8a8987d4410bf2d;
var $f2587acb1c26d227$export$d38cd72104c1f0e9;
var $f2587acb1c26d227$export$7d1e3a5e95ceca43;
var $f2587acb1c26d227$export$257a8862b851cb5b;
var $f2587acb1c26d227$export$a8257692ac88316c;
var $f2587acb1c26d227$export$488013bae63b21da;
var $f2587acb1c26d227$export$7c73462e0d25e514;
var $f2587acb1c26d227$export$7568632d0d33d16d;
var $f2587acb1c26d227$export$88948ce120ea2619;
var $f2587acb1c26d227$export$35808ee640e87ca7;
var $f2587acb1c26d227$export$fae74005e78b1a27;
var $f2587acb1c26d227$export$dc8fbce3eb94dc1e;
var $f2587acb1c26d227$export$6a7bc4e911dc01cf;
var $f2587acb1c26d227$export$6d9c69b0de29b591;
var $f2587acb1c26d227$export$f680877a34711e37;
var $f2587acb1c26d227$export$d5a552a76deda3c2;
var $f2587acb1c26d227$export$aaabe4eda9ed9969;
var $f2587acb1c26d227$export$e5c5a5f917a5871c;
var $f2587acb1c26d227$export$1538c33de8887b59;
var $f2587acb1c26d227$export$13e3392192263954;
var $f2587acb1c26d227$export$b8f5890fc79d6aca;
var $f2587acb1c26d227$export$60241385465d0a34;
var $f2587acb1c26d227$export$306c0aa65ff9ec16;
var $f2587acb1c26d227$export$7b286972b8d8ccbf;
var $f2587acb1c26d227$export$83d89fbfd8236492;
'use strict';
var $f2587acb1c26d227$var$l = Symbol.for("react.element"), $f2587acb1c26d227$var$n = Symbol.for("react.portal"), $f2587acb1c26d227$var$p = Symbol.for("react.fragment"), $f2587acb1c26d227$var$q = Symbol.for("react.strict_mode"), $f2587acb1c26d227$var$r = Symbol.for("react.profiler"), $f2587acb1c26d227$var$t = Symbol.for("react.provider"), $f2587acb1c26d227$var$u = Symbol.for("react.context"), $f2587acb1c26d227$var$v = Symbol.for("react.forward_ref"), $f2587acb1c26d227$var$w = Symbol.for("react.suspense"), $f2587acb1c26d227$var$x = Symbol.for("react.memo"), $f2587acb1c26d227$var$y = Symbol.for("react.lazy"), $f2587acb1c26d227$var$z = Symbol.iterator;
function $f2587acb1c26d227$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f2587acb1c26d227$var$z && a[$f2587acb1c26d227$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f2587acb1c26d227$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f2587acb1c26d227$var$C = Object.assign, $f2587acb1c26d227$var$D = {};
function $f2587acb1c26d227$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f2587acb1c26d227$var$D;
    this.updater = e || $f2587acb1c26d227$var$B;
}
$f2587acb1c26d227$var$E.prototype.isReactComponent = {};
$f2587acb1c26d227$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$f2587acb1c26d227$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $f2587acb1c26d227$var$F() {}
$f2587acb1c26d227$var$F.prototype = $f2587acb1c26d227$var$E.prototype;
function $f2587acb1c26d227$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f2587acb1c26d227$var$D;
    this.updater = e || $f2587acb1c26d227$var$B;
}
var $f2587acb1c26d227$var$H = $f2587acb1c26d227$var$G.prototype = new $f2587acb1c26d227$var$F;
$f2587acb1c26d227$var$H.constructor = $f2587acb1c26d227$var$G;
$f2587acb1c26d227$var$C($f2587acb1c26d227$var$H, $f2587acb1c26d227$var$E.prototype);
$f2587acb1c26d227$var$H.isPureReactComponent = !0;
var $f2587acb1c26d227$var$I = Array.isArray, $f2587acb1c26d227$var$J = Object.prototype.hasOwnProperty, $f2587acb1c26d227$var$K = {
    current: null
}, $f2587acb1c26d227$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f2587acb1c26d227$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$f2587acb1c26d227$var$J.call(b, d) && !$f2587acb1c26d227$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $f2587acb1c26d227$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $f2587acb1c26d227$var$K.current
    };
}
function $f2587acb1c26d227$var$N(a, b) {
    return {
        $$typeof: $f2587acb1c26d227$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $f2587acb1c26d227$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f2587acb1c26d227$var$l;
}
function $f2587acb1c26d227$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $f2587acb1c26d227$var$P = /\/+/g;
function $f2587acb1c26d227$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $f2587acb1c26d227$var$escape("" + a.key) : b.toString(36);
}
function $f2587acb1c26d227$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $f2587acb1c26d227$var$l:
                case $f2587acb1c26d227$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $f2587acb1c26d227$var$Q(h, 0) : d, $f2587acb1c26d227$var$I(c) ? (e = "", null != a && (e = a.replace($f2587acb1c26d227$var$P, "$&/") + "/"), $f2587acb1c26d227$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($f2587acb1c26d227$var$O(c) && (c = $f2587acb1c26d227$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($f2587acb1c26d227$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($f2587acb1c26d227$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $f2587acb1c26d227$var$Q(k, g);
        h += $f2587acb1c26d227$var$R(k, b, e, f, c);
    }
    else if (f = $f2587acb1c26d227$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $f2587acb1c26d227$var$Q(k, g++), h += $f2587acb1c26d227$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $f2587acb1c26d227$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $f2587acb1c26d227$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $f2587acb1c26d227$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $f2587acb1c26d227$var$U = {
    current: null
}, $f2587acb1c26d227$var$V = {
    transition: null
}, $f2587acb1c26d227$var$W = {
    ReactCurrentDispatcher: $f2587acb1c26d227$var$U,
    ReactCurrentBatchConfig: $f2587acb1c26d227$var$V,
    ReactCurrentOwner: $f2587acb1c26d227$var$K
};
$f2587acb1c26d227$export$dca3b0875bd9a954 = {
    map: $f2587acb1c26d227$var$S,
    forEach: function(a, b, e) {
        $f2587acb1c26d227$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $f2587acb1c26d227$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $f2587acb1c26d227$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$f2587acb1c26d227$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$f2587acb1c26d227$export$16fa2f45be04daa8 = $f2587acb1c26d227$var$E;
$f2587acb1c26d227$export$ffb0004e005737fa = $f2587acb1c26d227$var$p;
$f2587acb1c26d227$export$e2c29f18771995cb = $f2587acb1c26d227$var$r;
$f2587acb1c26d227$export$221d75b3f55bb0bd = $f2587acb1c26d227$var$G;
$f2587acb1c26d227$export$5f8d39834fd61797 = $f2587acb1c26d227$var$q;
$f2587acb1c26d227$export$74bf444e3cd11ea5 = $f2587acb1c26d227$var$w;
$f2587acb1c26d227$export$ae55be85d98224ed = $f2587acb1c26d227$var$W;
$f2587acb1c26d227$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $f2587acb1c26d227$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $f2587acb1c26d227$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$f2587acb1c26d227$var$J.call(b, f) && !$f2587acb1c26d227$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $f2587acb1c26d227$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$f2587acb1c26d227$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $f2587acb1c26d227$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $f2587acb1c26d227$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$f2587acb1c26d227$export$c8a8987d4410bf2d = $f2587acb1c26d227$var$M;
$f2587acb1c26d227$export$d38cd72104c1f0e9 = function(a) {
    var b = $f2587acb1c26d227$var$M.bind(null, a);
    b.type = a;
    return b;
};
$f2587acb1c26d227$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f2587acb1c26d227$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $f2587acb1c26d227$var$v,
        render: a
    };
};
$f2587acb1c26d227$export$a8257692ac88316c = $f2587acb1c26d227$var$O;
$f2587acb1c26d227$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $f2587acb1c26d227$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $f2587acb1c26d227$var$T
    };
};
$f2587acb1c26d227$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $f2587acb1c26d227$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$f2587acb1c26d227$export$7568632d0d33d16d = function(a) {
    var b = $f2587acb1c26d227$var$V.transition;
    $f2587acb1c26d227$var$V.transition = {};
    try {
        a();
    } finally{
        $f2587acb1c26d227$var$V.transition = b;
    }
};
$f2587acb1c26d227$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$f2587acb1c26d227$export$35808ee640e87ca7 = function(a, b) {
    return $f2587acb1c26d227$var$U.current.useCallback(a, b);
};
$f2587acb1c26d227$export$fae74005e78b1a27 = function(a) {
    return $f2587acb1c26d227$var$U.current.useContext(a);
};
$f2587acb1c26d227$export$dc8fbce3eb94dc1e = function() {};
$f2587acb1c26d227$export$6a7bc4e911dc01cf = function(a) {
    return $f2587acb1c26d227$var$U.current.useDeferredValue(a);
};
$f2587acb1c26d227$export$6d9c69b0de29b591 = function(a, b) {
    return $f2587acb1c26d227$var$U.current.useEffect(a, b);
};
$f2587acb1c26d227$export$f680877a34711e37 = function() {
    return $f2587acb1c26d227$var$U.current.useId();
};
$f2587acb1c26d227$export$d5a552a76deda3c2 = function(a, b, e) {
    return $f2587acb1c26d227$var$U.current.useImperativeHandle(a, b, e);
};
$f2587acb1c26d227$export$aaabe4eda9ed9969 = function(a, b) {
    return $f2587acb1c26d227$var$U.current.useInsertionEffect(a, b);
};
$f2587acb1c26d227$export$e5c5a5f917a5871c = function(a, b) {
    return $f2587acb1c26d227$var$U.current.useLayoutEffect(a, b);
};
$f2587acb1c26d227$export$1538c33de8887b59 = function(a, b) {
    return $f2587acb1c26d227$var$U.current.useMemo(a, b);
};
$f2587acb1c26d227$export$13e3392192263954 = function(a, b, e) {
    return $f2587acb1c26d227$var$U.current.useReducer(a, b, e);
};
$f2587acb1c26d227$export$b8f5890fc79d6aca = function(a) {
    return $f2587acb1c26d227$var$U.current.useRef(a);
};
$f2587acb1c26d227$export$60241385465d0a34 = function(a) {
    return $f2587acb1c26d227$var$U.current.useState(a);
};
$f2587acb1c26d227$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $f2587acb1c26d227$var$U.current.useSyncExternalStore(a, b, e);
};
$f2587acb1c26d227$export$7b286972b8d8ccbf = function() {
    return $f2587acb1c26d227$var$U.current.useTransition();
};
$f2587acb1c26d227$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("T5IcR", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "_getGlobalState", function () { return getGlobalState; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "toJS", function () { return toJS; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("fCKK7", function(module, exports) {
'use strict';
function $b5fea9c20eafce38$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b5fea9c20eafce38$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b5fea9c20eafce38$var$checkDCE();

module.exports = (parcelRequire("dmm2w"));

});
parcelRegister("dmm2w", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $9b9e6d0f6347a978$export$ae55be85d98224ed; }, function (v) { return $9b9e6d0f6347a978$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $9b9e6d0f6347a978$export$d39a5bbd09211389; }, function (v) { return $9b9e6d0f6347a978$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $9b9e6d0f6347a978$export$882461b6382ed46c; }, function (v) { return $9b9e6d0f6347a978$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $9b9e6d0f6347a978$export$466bfc07425424d5; }, function (v) { return $9b9e6d0f6347a978$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $9b9e6d0f6347a978$export$cd75ccfd720a3cd4; }, function (v) { return $9b9e6d0f6347a978$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $9b9e6d0f6347a978$export$fa8d919ba61d84db; }, function (v) { return $9b9e6d0f6347a978$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $9b9e6d0f6347a978$export$757ceba2d55c277e; }, function (v) { return $9b9e6d0f6347a978$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $9b9e6d0f6347a978$export$b3890eb0ae9dca99; }, function (v) { return $9b9e6d0f6347a978$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $9b9e6d0f6347a978$export$502457920280e6be; }, function (v) { return $9b9e6d0f6347a978$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $9b9e6d0f6347a978$export$c78a37762a8d58e1; }, function (v) { return $9b9e6d0f6347a978$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $9b9e6d0f6347a978$export$dc54d992c10e8a18; }, function (v) { return $9b9e6d0f6347a978$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $9b9e6d0f6347a978$export$83d89fbfd8236492; }, function (v) { return $9b9e6d0f6347a978$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $9b9e6d0f6347a978$export$ae55be85d98224ed;
var $9b9e6d0f6347a978$export$d39a5bbd09211389;
var $9b9e6d0f6347a978$export$882461b6382ed46c;
var $9b9e6d0f6347a978$export$466bfc07425424d5;
var $9b9e6d0f6347a978$export$cd75ccfd720a3cd4;
var $9b9e6d0f6347a978$export$fa8d919ba61d84db;
var $9b9e6d0f6347a978$export$757ceba2d55c277e;
var $9b9e6d0f6347a978$export$b3890eb0ae9dca99;
var $9b9e6d0f6347a978$export$502457920280e6be;
var $9b9e6d0f6347a978$export$c78a37762a8d58e1;
var $9b9e6d0f6347a978$export$dc54d992c10e8a18;
var $9b9e6d0f6347a978$export$83d89fbfd8236492;
'use strict';

var $8nGP5 = parcelRequire("8nGP5");

var $lC4Dh = parcelRequire("lC4Dh");
function $9b9e6d0f6347a978$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9b9e6d0f6347a978$var$da = new Set, $9b9e6d0f6347a978$var$ea = {};
function $9b9e6d0f6347a978$var$fa(a, b) {
    $9b9e6d0f6347a978$var$ha(a, b);
    $9b9e6d0f6347a978$var$ha(a + "Capture", b);
}
function $9b9e6d0f6347a978$var$ha(a, b) {
    $9b9e6d0f6347a978$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9b9e6d0f6347a978$var$da.add(b[a]);
}
var $9b9e6d0f6347a978$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9b9e6d0f6347a978$var$ja = Object.prototype.hasOwnProperty, $9b9e6d0f6347a978$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9b9e6d0f6347a978$var$la = {}, $9b9e6d0f6347a978$var$ma = {};
function $9b9e6d0f6347a978$var$oa(a) {
    if ($9b9e6d0f6347a978$var$ja.call($9b9e6d0f6347a978$var$ma, a)) return !0;
    if ($9b9e6d0f6347a978$var$ja.call($9b9e6d0f6347a978$var$la, a)) return !1;
    if ($9b9e6d0f6347a978$var$ka.test(a)) return $9b9e6d0f6347a978$var$ma[a] = !0;
    $9b9e6d0f6347a978$var$la[a] = !0;
    return !1;
}
function $9b9e6d0f6347a978$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9b9e6d0f6347a978$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9b9e6d0f6347a978$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9b9e6d0f6347a978$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9b9e6d0f6347a978$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9b9e6d0f6347a978$var$z[b] = new $9b9e6d0f6347a978$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9b9e6d0f6347a978$var$ra = /[\-:]([a-z])/g;
function $9b9e6d0f6347a978$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9b9e6d0f6347a978$var$ra, $9b9e6d0f6347a978$var$sa);
    $9b9e6d0f6347a978$var$z[b] = new $9b9e6d0f6347a978$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9b9e6d0f6347a978$var$ra, $9b9e6d0f6347a978$var$sa);
    $9b9e6d0f6347a978$var$z[b] = new $9b9e6d0f6347a978$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9b9e6d0f6347a978$var$ra, $9b9e6d0f6347a978$var$sa);
    $9b9e6d0f6347a978$var$z[b] = new $9b9e6d0f6347a978$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9b9e6d0f6347a978$var$z.xlinkHref = new $9b9e6d0f6347a978$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9b9e6d0f6347a978$var$ta(a, b, c, d) {
    var e = $9b9e6d0f6347a978$var$z.hasOwnProperty(b) ? $9b9e6d0f6347a978$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9b9e6d0f6347a978$var$qa(b, c, e, d) && (c = null), d || null === e ? $9b9e6d0f6347a978$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9b9e6d0f6347a978$var$ua = $8nGP5.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9b9e6d0f6347a978$var$va = Symbol.for("react.element"), $9b9e6d0f6347a978$var$wa = Symbol.for("react.portal"), $9b9e6d0f6347a978$var$ya = Symbol.for("react.fragment"), $9b9e6d0f6347a978$var$za = Symbol.for("react.strict_mode"), $9b9e6d0f6347a978$var$Aa = Symbol.for("react.profiler"), $9b9e6d0f6347a978$var$Ba = Symbol.for("react.provider"), $9b9e6d0f6347a978$var$Ca = Symbol.for("react.context"), $9b9e6d0f6347a978$var$Da = Symbol.for("react.forward_ref"), $9b9e6d0f6347a978$var$Ea = Symbol.for("react.suspense"), $9b9e6d0f6347a978$var$Fa = Symbol.for("react.suspense_list"), $9b9e6d0f6347a978$var$Ga = Symbol.for("react.memo"), $9b9e6d0f6347a978$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $9b9e6d0f6347a978$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $9b9e6d0f6347a978$var$Ja = Symbol.iterator;
function $9b9e6d0f6347a978$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9b9e6d0f6347a978$var$Ja && a[$9b9e6d0f6347a978$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9b9e6d0f6347a978$var$A = Object.assign, $9b9e6d0f6347a978$var$La;
function $9b9e6d0f6347a978$var$Ma(a) {
    if (void 0 === $9b9e6d0f6347a978$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9b9e6d0f6347a978$var$La = b && b[1] || "";
    }
    return "\n" + $9b9e6d0f6347a978$var$La + a;
}
var $9b9e6d0f6347a978$var$Na = !1;
function $9b9e6d0f6347a978$var$Oa(a, b) {
    if (!a || $9b9e6d0f6347a978$var$Na) return "";
    $9b9e6d0f6347a978$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9b9e6d0f6347a978$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9b9e6d0f6347a978$var$Ma(a) : "";
}
function $9b9e6d0f6347a978$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9b9e6d0f6347a978$var$Ma(a.type);
        case 16:
            return $9b9e6d0f6347a978$var$Ma("Lazy");
        case 13:
            return $9b9e6d0f6347a978$var$Ma("Suspense");
        case 19:
            return $9b9e6d0f6347a978$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9b9e6d0f6347a978$var$Oa(a.type, !1), a;
        case 11:
            return a = $9b9e6d0f6347a978$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9b9e6d0f6347a978$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9b9e6d0f6347a978$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9b9e6d0f6347a978$var$ya:
            return "Fragment";
        case $9b9e6d0f6347a978$var$wa:
            return "Portal";
        case $9b9e6d0f6347a978$var$Aa:
            return "Profiler";
        case $9b9e6d0f6347a978$var$za:
            return "StrictMode";
        case $9b9e6d0f6347a978$var$Ea:
            return "Suspense";
        case $9b9e6d0f6347a978$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9b9e6d0f6347a978$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9b9e6d0f6347a978$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9b9e6d0f6347a978$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9b9e6d0f6347a978$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9b9e6d0f6347a978$var$Qa(a.type) || "Memo";
        case $9b9e6d0f6347a978$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9b9e6d0f6347a978$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9b9e6d0f6347a978$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9b9e6d0f6347a978$var$Qa(b);
        case 8:
            return b === $9b9e6d0f6347a978$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9b9e6d0f6347a978$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9b9e6d0f6347a978$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9b9e6d0f6347a978$var$Ua(a) {
    var b = $9b9e6d0f6347a978$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9b9e6d0f6347a978$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9b9e6d0f6347a978$var$Ua(a));
}
function $9b9e6d0f6347a978$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9b9e6d0f6347a978$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9b9e6d0f6347a978$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9b9e6d0f6347a978$var$Ya(a, b) {
    var c = b.checked;
    return $9b9e6d0f6347a978$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9b9e6d0f6347a978$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9b9e6d0f6347a978$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9b9e6d0f6347a978$var$ab(a, b) {
    b = b.checked;
    null != b && $9b9e6d0f6347a978$var$ta(a, "checked", b, !1);
}
function $9b9e6d0f6347a978$var$bb(a, b) {
    $9b9e6d0f6347a978$var$ab(a, b);
    var c = $9b9e6d0f6347a978$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9b9e6d0f6347a978$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9b9e6d0f6347a978$var$cb(a, b.type, $9b9e6d0f6347a978$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9b9e6d0f6347a978$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9b9e6d0f6347a978$var$cb(a, b, c) {
    if ("number" !== b || $9b9e6d0f6347a978$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9b9e6d0f6347a978$var$eb = Array.isArray;
function $9b9e6d0f6347a978$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9b9e6d0f6347a978$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9b9e6d0f6347a978$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9b9e6d0f6347a978$var$p(91));
    return $9b9e6d0f6347a978$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9b9e6d0f6347a978$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9b9e6d0f6347a978$var$p(92));
            if ($9b9e6d0f6347a978$var$eb(c)) {
                if (1 < c.length) throw Error($9b9e6d0f6347a978$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9b9e6d0f6347a978$var$Sa(c)
    };
}
function $9b9e6d0f6347a978$var$ib(a, b) {
    var c = $9b9e6d0f6347a978$var$Sa(b.value), d = $9b9e6d0f6347a978$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9b9e6d0f6347a978$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9b9e6d0f6347a978$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9b9e6d0f6347a978$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9b9e6d0f6347a978$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9b9e6d0f6347a978$var$mb, $9b9e6d0f6347a978$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9b9e6d0f6347a978$var$mb = $9b9e6d0f6347a978$var$mb || document.createElement("div");
        $9b9e6d0f6347a978$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9b9e6d0f6347a978$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9b9e6d0f6347a978$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9b9e6d0f6347a978$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9b9e6d0f6347a978$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9b9e6d0f6347a978$var$pb).forEach(function(a) {
    $9b9e6d0f6347a978$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9b9e6d0f6347a978$var$pb[b] = $9b9e6d0f6347a978$var$pb[a];
    });
});
function $9b9e6d0f6347a978$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9b9e6d0f6347a978$var$pb.hasOwnProperty(a) && $9b9e6d0f6347a978$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9b9e6d0f6347a978$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9b9e6d0f6347a978$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9b9e6d0f6347a978$var$tb = $9b9e6d0f6347a978$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9b9e6d0f6347a978$var$ub(a, b) {
    if (b) {
        if ($9b9e6d0f6347a978$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9b9e6d0f6347a978$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9b9e6d0f6347a978$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9b9e6d0f6347a978$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9b9e6d0f6347a978$var$p(62));
    }
}
function $9b9e6d0f6347a978$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9b9e6d0f6347a978$var$wb = null;
function $9b9e6d0f6347a978$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9b9e6d0f6347a978$var$yb = null, $9b9e6d0f6347a978$var$zb = null, $9b9e6d0f6347a978$var$Ab = null;
function $9b9e6d0f6347a978$var$Bb(a) {
    if (a = $9b9e6d0f6347a978$var$Cb(a)) {
        if ("function" !== typeof $9b9e6d0f6347a978$var$yb) throw Error($9b9e6d0f6347a978$var$p(280));
        var b = a.stateNode;
        b && (b = $9b9e6d0f6347a978$var$Db(b), $9b9e6d0f6347a978$var$yb(a.stateNode, a.type, b));
    }
}
function $9b9e6d0f6347a978$var$Eb(a) {
    $9b9e6d0f6347a978$var$zb ? $9b9e6d0f6347a978$var$Ab ? $9b9e6d0f6347a978$var$Ab.push(a) : $9b9e6d0f6347a978$var$Ab = [
        a
    ] : $9b9e6d0f6347a978$var$zb = a;
}
function $9b9e6d0f6347a978$var$Fb() {
    if ($9b9e6d0f6347a978$var$zb) {
        var a = $9b9e6d0f6347a978$var$zb, b = $9b9e6d0f6347a978$var$Ab;
        $9b9e6d0f6347a978$var$Ab = $9b9e6d0f6347a978$var$zb = null;
        $9b9e6d0f6347a978$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9b9e6d0f6347a978$var$Bb(b[a]);
    }
}
function $9b9e6d0f6347a978$var$Gb(a, b) {
    return a(b);
}
function $9b9e6d0f6347a978$var$Hb() {}
var $9b9e6d0f6347a978$var$Ib = !1;
function $9b9e6d0f6347a978$var$Jb(a, b, c) {
    if ($9b9e6d0f6347a978$var$Ib) return a(b, c);
    $9b9e6d0f6347a978$var$Ib = !0;
    try {
        return $9b9e6d0f6347a978$var$Gb(a, b, c);
    } finally{
        if ($9b9e6d0f6347a978$var$Ib = !1, null !== $9b9e6d0f6347a978$var$zb || null !== $9b9e6d0f6347a978$var$Ab) $9b9e6d0f6347a978$var$Hb(), $9b9e6d0f6347a978$var$Fb();
    }
}
function $9b9e6d0f6347a978$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9b9e6d0f6347a978$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9b9e6d0f6347a978$var$p(231, b, typeof c));
    return c;
}
var $9b9e6d0f6347a978$var$Lb = !1;
if ($9b9e6d0f6347a978$var$ia) try {
    var $9b9e6d0f6347a978$var$Mb = {};
    Object.defineProperty($9b9e6d0f6347a978$var$Mb, "passive", {
        get: function() {
            $9b9e6d0f6347a978$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9b9e6d0f6347a978$var$Mb, $9b9e6d0f6347a978$var$Mb);
    window.removeEventListener("test", $9b9e6d0f6347a978$var$Mb, $9b9e6d0f6347a978$var$Mb);
} catch (a) {
    $9b9e6d0f6347a978$var$Lb = !1;
}
function $9b9e6d0f6347a978$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9b9e6d0f6347a978$var$Ob = !1, $9b9e6d0f6347a978$var$Pb = null, $9b9e6d0f6347a978$var$Qb = !1, $9b9e6d0f6347a978$var$Rb = null, $9b9e6d0f6347a978$var$Sb = {
    onError: function(a) {
        $9b9e6d0f6347a978$var$Ob = !0;
        $9b9e6d0f6347a978$var$Pb = a;
    }
};
function $9b9e6d0f6347a978$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9b9e6d0f6347a978$var$Ob = !1;
    $9b9e6d0f6347a978$var$Pb = null;
    $9b9e6d0f6347a978$var$Nb.apply($9b9e6d0f6347a978$var$Sb, arguments);
}
function $9b9e6d0f6347a978$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9b9e6d0f6347a978$var$Tb.apply(this, arguments);
    if ($9b9e6d0f6347a978$var$Ob) {
        if ($9b9e6d0f6347a978$var$Ob) {
            var l = $9b9e6d0f6347a978$var$Pb;
            $9b9e6d0f6347a978$var$Ob = !1;
            $9b9e6d0f6347a978$var$Pb = null;
        } else throw Error($9b9e6d0f6347a978$var$p(198));
        $9b9e6d0f6347a978$var$Qb || ($9b9e6d0f6347a978$var$Qb = !0, $9b9e6d0f6347a978$var$Rb = l);
    }
}
function $9b9e6d0f6347a978$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9b9e6d0f6347a978$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9b9e6d0f6347a978$var$Xb(a) {
    if ($9b9e6d0f6347a978$var$Vb(a) !== a) throw Error($9b9e6d0f6347a978$var$p(188));
}
function $9b9e6d0f6347a978$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9b9e6d0f6347a978$var$Vb(a);
        if (null === b) throw Error($9b9e6d0f6347a978$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9b9e6d0f6347a978$var$Xb(e), a;
                if (f === d) return $9b9e6d0f6347a978$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9b9e6d0f6347a978$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9b9e6d0f6347a978$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9b9e6d0f6347a978$var$p(190));
    }
    if (3 !== c.tag) throw Error($9b9e6d0f6347a978$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9b9e6d0f6347a978$var$Zb(a) {
    a = $9b9e6d0f6347a978$var$Yb(a);
    return null !== a ? $9b9e6d0f6347a978$var$$b(a) : null;
}
function $9b9e6d0f6347a978$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9b9e6d0f6347a978$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9b9e6d0f6347a978$var$ac = $lC4Dh.unstable_scheduleCallback, $9b9e6d0f6347a978$var$bc = $lC4Dh.unstable_cancelCallback, $9b9e6d0f6347a978$var$cc = $lC4Dh.unstable_shouldYield, $9b9e6d0f6347a978$var$dc = $lC4Dh.unstable_requestPaint, $9b9e6d0f6347a978$var$B = $lC4Dh.unstable_now, $9b9e6d0f6347a978$var$ec = $lC4Dh.unstable_getCurrentPriorityLevel, $9b9e6d0f6347a978$var$fc = $lC4Dh.unstable_ImmediatePriority, $9b9e6d0f6347a978$var$gc = $lC4Dh.unstable_UserBlockingPriority, $9b9e6d0f6347a978$var$hc = $lC4Dh.unstable_NormalPriority, $9b9e6d0f6347a978$var$ic = $lC4Dh.unstable_LowPriority, $9b9e6d0f6347a978$var$jc = $lC4Dh.unstable_IdlePriority, $9b9e6d0f6347a978$var$kc = null, $9b9e6d0f6347a978$var$lc = null;
function $9b9e6d0f6347a978$var$mc(a) {
    if ($9b9e6d0f6347a978$var$lc && "function" === typeof $9b9e6d0f6347a978$var$lc.onCommitFiberRoot) try {
        $9b9e6d0f6347a978$var$lc.onCommitFiberRoot($9b9e6d0f6347a978$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9b9e6d0f6347a978$var$oc = Math.clz32 ? Math.clz32 : $9b9e6d0f6347a978$var$nc, $9b9e6d0f6347a978$var$pc = Math.log, $9b9e6d0f6347a978$var$qc = Math.LN2;
function $9b9e6d0f6347a978$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9b9e6d0f6347a978$var$pc(a) / $9b9e6d0f6347a978$var$qc | 0) | 0;
}
var $9b9e6d0f6347a978$var$rc = 64, $9b9e6d0f6347a978$var$sc = 4194304;
function $9b9e6d0f6347a978$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9b9e6d0f6347a978$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9b9e6d0f6347a978$var$tc(h) : (f &= g, 0 !== f && (d = $9b9e6d0f6347a978$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9b9e6d0f6347a978$var$tc(g) : 0 !== f && (d = $9b9e6d0f6347a978$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9b9e6d0f6347a978$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9b9e6d0f6347a978$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9b9e6d0f6347a978$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9b9e6d0f6347a978$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9b9e6d0f6347a978$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9b9e6d0f6347a978$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9b9e6d0f6347a978$var$yc() {
    var a = $9b9e6d0f6347a978$var$rc;
    $9b9e6d0f6347a978$var$rc <<= 1;
    0 === ($9b9e6d0f6347a978$var$rc & 4194240) && ($9b9e6d0f6347a978$var$rc = 64);
    return a;
}
function $9b9e6d0f6347a978$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9b9e6d0f6347a978$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9b9e6d0f6347a978$var$oc(b);
    a[b] = c;
}
function $9b9e6d0f6347a978$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9b9e6d0f6347a978$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9b9e6d0f6347a978$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9b9e6d0f6347a978$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9b9e6d0f6347a978$var$C = 0;
function $9b9e6d0f6347a978$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9b9e6d0f6347a978$var$Ec, $9b9e6d0f6347a978$var$Fc, $9b9e6d0f6347a978$var$Gc, $9b9e6d0f6347a978$var$Hc, $9b9e6d0f6347a978$var$Ic, $9b9e6d0f6347a978$var$Jc = !1, $9b9e6d0f6347a978$var$Kc = [], $9b9e6d0f6347a978$var$Lc = null, $9b9e6d0f6347a978$var$Mc = null, $9b9e6d0f6347a978$var$Nc = null, $9b9e6d0f6347a978$var$Oc = new Map, $9b9e6d0f6347a978$var$Pc = new Map, $9b9e6d0f6347a978$var$Qc = [], $9b9e6d0f6347a978$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9b9e6d0f6347a978$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9b9e6d0f6347a978$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9b9e6d0f6347a978$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9b9e6d0f6347a978$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9b9e6d0f6347a978$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9b9e6d0f6347a978$var$Pc.delete(b.pointerId);
    }
}
function $9b9e6d0f6347a978$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9b9e6d0f6347a978$var$Cb(b), null !== b && $9b9e6d0f6347a978$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9b9e6d0f6347a978$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9b9e6d0f6347a978$var$Lc = $9b9e6d0f6347a978$var$Tc($9b9e6d0f6347a978$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9b9e6d0f6347a978$var$Mc = $9b9e6d0f6347a978$var$Tc($9b9e6d0f6347a978$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9b9e6d0f6347a978$var$Nc = $9b9e6d0f6347a978$var$Tc($9b9e6d0f6347a978$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9b9e6d0f6347a978$var$Oc.set(f, $9b9e6d0f6347a978$var$Tc($9b9e6d0f6347a978$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9b9e6d0f6347a978$var$Pc.set(f, $9b9e6d0f6347a978$var$Tc($9b9e6d0f6347a978$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9b9e6d0f6347a978$var$Vc(a) {
    var b = $9b9e6d0f6347a978$var$Wc(a.target);
    if (null !== b) {
        var c = $9b9e6d0f6347a978$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9b9e6d0f6347a978$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9b9e6d0f6347a978$var$Ic(a.priority, function() {
                        $9b9e6d0f6347a978$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9b9e6d0f6347a978$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9b9e6d0f6347a978$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9b9e6d0f6347a978$var$wb = d;
            c.target.dispatchEvent(d);
            $9b9e6d0f6347a978$var$wb = null;
        } else return b = $9b9e6d0f6347a978$var$Cb(c), null !== b && $9b9e6d0f6347a978$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9b9e6d0f6347a978$var$Zc(a, b, c) {
    $9b9e6d0f6347a978$var$Xc(a) && c.delete(b);
}
function $9b9e6d0f6347a978$var$$c() {
    $9b9e6d0f6347a978$var$Jc = !1;
    null !== $9b9e6d0f6347a978$var$Lc && $9b9e6d0f6347a978$var$Xc($9b9e6d0f6347a978$var$Lc) && ($9b9e6d0f6347a978$var$Lc = null);
    null !== $9b9e6d0f6347a978$var$Mc && $9b9e6d0f6347a978$var$Xc($9b9e6d0f6347a978$var$Mc) && ($9b9e6d0f6347a978$var$Mc = null);
    null !== $9b9e6d0f6347a978$var$Nc && $9b9e6d0f6347a978$var$Xc($9b9e6d0f6347a978$var$Nc) && ($9b9e6d0f6347a978$var$Nc = null);
    $9b9e6d0f6347a978$var$Oc.forEach($9b9e6d0f6347a978$var$Zc);
    $9b9e6d0f6347a978$var$Pc.forEach($9b9e6d0f6347a978$var$Zc);
}
function $9b9e6d0f6347a978$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9b9e6d0f6347a978$var$Jc || ($9b9e6d0f6347a978$var$Jc = !0, $lC4Dh.unstable_scheduleCallback($lC4Dh.unstable_NormalPriority, $9b9e6d0f6347a978$var$$c)));
}
function $9b9e6d0f6347a978$var$bd(a) {
    function b(b) {
        return $9b9e6d0f6347a978$var$ad(b, a);
    }
    if (0 < $9b9e6d0f6347a978$var$Kc.length) {
        $9b9e6d0f6347a978$var$ad($9b9e6d0f6347a978$var$Kc[0], a);
        for(var c = 1; c < $9b9e6d0f6347a978$var$Kc.length; c++){
            var d = $9b9e6d0f6347a978$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9b9e6d0f6347a978$var$Lc && $9b9e6d0f6347a978$var$ad($9b9e6d0f6347a978$var$Lc, a);
    null !== $9b9e6d0f6347a978$var$Mc && $9b9e6d0f6347a978$var$ad($9b9e6d0f6347a978$var$Mc, a);
    null !== $9b9e6d0f6347a978$var$Nc && $9b9e6d0f6347a978$var$ad($9b9e6d0f6347a978$var$Nc, a);
    $9b9e6d0f6347a978$var$Oc.forEach(b);
    $9b9e6d0f6347a978$var$Pc.forEach(b);
    for(c = 0; c < $9b9e6d0f6347a978$var$Qc.length; c++)d = $9b9e6d0f6347a978$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9b9e6d0f6347a978$var$Qc.length && (c = $9b9e6d0f6347a978$var$Qc[0], null === c.blockedOn);)$9b9e6d0f6347a978$var$Vc(c), null === c.blockedOn && $9b9e6d0f6347a978$var$Qc.shift();
}
var $9b9e6d0f6347a978$var$cd = $9b9e6d0f6347a978$var$ua.ReactCurrentBatchConfig, $9b9e6d0f6347a978$var$dd = !0;
function $9b9e6d0f6347a978$var$ed(a, b, c, d) {
    var e = $9b9e6d0f6347a978$var$C, f = $9b9e6d0f6347a978$var$cd.transition;
    $9b9e6d0f6347a978$var$cd.transition = null;
    try {
        $9b9e6d0f6347a978$var$C = 1, $9b9e6d0f6347a978$var$fd(a, b, c, d);
    } finally{
        $9b9e6d0f6347a978$var$C = e, $9b9e6d0f6347a978$var$cd.transition = f;
    }
}
function $9b9e6d0f6347a978$var$gd(a, b, c, d) {
    var e = $9b9e6d0f6347a978$var$C, f = $9b9e6d0f6347a978$var$cd.transition;
    $9b9e6d0f6347a978$var$cd.transition = null;
    try {
        $9b9e6d0f6347a978$var$C = 4, $9b9e6d0f6347a978$var$fd(a, b, c, d);
    } finally{
        $9b9e6d0f6347a978$var$C = e, $9b9e6d0f6347a978$var$cd.transition = f;
    }
}
function $9b9e6d0f6347a978$var$fd(a, b, c, d) {
    if ($9b9e6d0f6347a978$var$dd) {
        var e = $9b9e6d0f6347a978$var$Yc(a, b, c, d);
        if (null === e) $9b9e6d0f6347a978$var$hd(a, b, d, $9b9e6d0f6347a978$var$id, c), $9b9e6d0f6347a978$var$Sc(a, d);
        else if ($9b9e6d0f6347a978$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9b9e6d0f6347a978$var$Sc(a, d), b & 4 && -1 < $9b9e6d0f6347a978$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9b9e6d0f6347a978$var$Cb(e);
                null !== f && $9b9e6d0f6347a978$var$Ec(f);
                f = $9b9e6d0f6347a978$var$Yc(a, b, c, d);
                null === f && $9b9e6d0f6347a978$var$hd(a, b, d, $9b9e6d0f6347a978$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9b9e6d0f6347a978$var$hd(a, b, d, null, c);
    }
}
var $9b9e6d0f6347a978$var$id = null;
function $9b9e6d0f6347a978$var$Yc(a, b, c, d) {
    $9b9e6d0f6347a978$var$id = null;
    a = $9b9e6d0f6347a978$var$xb(d);
    a = $9b9e6d0f6347a978$var$Wc(a);
    if (null !== a) {
        if (b = $9b9e6d0f6347a978$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9b9e6d0f6347a978$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9b9e6d0f6347a978$var$id = a;
    return null;
}
function $9b9e6d0f6347a978$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9b9e6d0f6347a978$var$ec()){
                case $9b9e6d0f6347a978$var$fc:
                    return 1;
                case $9b9e6d0f6347a978$var$gc:
                    return 4;
                case $9b9e6d0f6347a978$var$hc:
                case $9b9e6d0f6347a978$var$ic:
                    return 16;
                case $9b9e6d0f6347a978$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9b9e6d0f6347a978$var$kd = null, $9b9e6d0f6347a978$var$ld = null, $9b9e6d0f6347a978$var$md = null;
function $9b9e6d0f6347a978$var$nd() {
    if ($9b9e6d0f6347a978$var$md) return $9b9e6d0f6347a978$var$md;
    var a, b = $9b9e6d0f6347a978$var$ld, c = b.length, d, e = "value" in $9b9e6d0f6347a978$var$kd ? $9b9e6d0f6347a978$var$kd.value : $9b9e6d0f6347a978$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9b9e6d0f6347a978$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9b9e6d0f6347a978$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9b9e6d0f6347a978$var$pd() {
    return !0;
}
function $9b9e6d0f6347a978$var$qd() {
    return !1;
}
function $9b9e6d0f6347a978$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9b9e6d0f6347a978$var$pd : $9b9e6d0f6347a978$var$qd;
        this.isPropagationStopped = $9b9e6d0f6347a978$var$qd;
        return this;
    }
    $9b9e6d0f6347a978$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $9b9e6d0f6347a978$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $9b9e6d0f6347a978$var$pd);
        },
        persist: function() {},
        isPersistent: $9b9e6d0f6347a978$var$pd
    });
    return b;
}
var $9b9e6d0f6347a978$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9b9e6d0f6347a978$var$td = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$sd), $9b9e6d0f6347a978$var$ud = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$sd, {
    view: 0,
    detail: 0
}), $9b9e6d0f6347a978$var$vd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$ud), $9b9e6d0f6347a978$var$wd, $9b9e6d0f6347a978$var$xd, $9b9e6d0f6347a978$var$yd, $9b9e6d0f6347a978$var$Ad = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9b9e6d0f6347a978$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9b9e6d0f6347a978$var$yd && ($9b9e6d0f6347a978$var$yd && "mousemove" === a.type ? ($9b9e6d0f6347a978$var$wd = a.screenX - $9b9e6d0f6347a978$var$yd.screenX, $9b9e6d0f6347a978$var$xd = a.screenY - $9b9e6d0f6347a978$var$yd.screenY) : $9b9e6d0f6347a978$var$xd = $9b9e6d0f6347a978$var$wd = 0, $9b9e6d0f6347a978$var$yd = a);
        return $9b9e6d0f6347a978$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $9b9e6d0f6347a978$var$xd;
    }
}), $9b9e6d0f6347a978$var$Bd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Ad), $9b9e6d0f6347a978$var$Cd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$Ad, {
    dataTransfer: 0
}), $9b9e6d0f6347a978$var$Dd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Cd), $9b9e6d0f6347a978$var$Ed = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$ud, {
    relatedTarget: 0
}), $9b9e6d0f6347a978$var$Fd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Ed), $9b9e6d0f6347a978$var$Gd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9b9e6d0f6347a978$var$Hd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Gd), $9b9e6d0f6347a978$var$Id = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9b9e6d0f6347a978$var$Jd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Id), $9b9e6d0f6347a978$var$Kd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$sd, {
    data: 0
}), $9b9e6d0f6347a978$var$Ld = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Kd), $9b9e6d0f6347a978$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9b9e6d0f6347a978$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9b9e6d0f6347a978$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9b9e6d0f6347a978$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9b9e6d0f6347a978$var$Od[a]) ? !!b[a] : !1;
}
function $9b9e6d0f6347a978$var$zd() {
    return $9b9e6d0f6347a978$var$Pd;
}
var $9b9e6d0f6347a978$var$Qd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $9b9e6d0f6347a978$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9b9e6d0f6347a978$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9b9e6d0f6347a978$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9b9e6d0f6347a978$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $9b9e6d0f6347a978$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $9b9e6d0f6347a978$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9b9e6d0f6347a978$var$Rd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Qd), $9b9e6d0f6347a978$var$Sd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9b9e6d0f6347a978$var$Td = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Sd), $9b9e6d0f6347a978$var$Ud = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9b9e6d0f6347a978$var$zd
}), $9b9e6d0f6347a978$var$Vd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Ud), $9b9e6d0f6347a978$var$Wd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9b9e6d0f6347a978$var$Xd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Wd), $9b9e6d0f6347a978$var$Yd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9b9e6d0f6347a978$var$Zd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Yd), $9b9e6d0f6347a978$var$$d = [
    9,
    13,
    27,
    32
], $9b9e6d0f6347a978$var$ae = $9b9e6d0f6347a978$var$ia && "CompositionEvent" in window, $9b9e6d0f6347a978$var$be = null;
$9b9e6d0f6347a978$var$ia && "documentMode" in document && ($9b9e6d0f6347a978$var$be = document.documentMode);
var $9b9e6d0f6347a978$var$ce = $9b9e6d0f6347a978$var$ia && "TextEvent" in window && !$9b9e6d0f6347a978$var$be, $9b9e6d0f6347a978$var$de = $9b9e6d0f6347a978$var$ia && (!$9b9e6d0f6347a978$var$ae || $9b9e6d0f6347a978$var$be && 8 < $9b9e6d0f6347a978$var$be && 11 >= $9b9e6d0f6347a978$var$be), $9b9e6d0f6347a978$var$ee = String.fromCharCode(32), $9b9e6d0f6347a978$var$fe = !1;
function $9b9e6d0f6347a978$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9b9e6d0f6347a978$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9b9e6d0f6347a978$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9b9e6d0f6347a978$var$ie = !1;
function $9b9e6d0f6347a978$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9b9e6d0f6347a978$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9b9e6d0f6347a978$var$fe = !0;
            return $9b9e6d0f6347a978$var$ee;
        case "textInput":
            return a = b.data, a === $9b9e6d0f6347a978$var$ee && $9b9e6d0f6347a978$var$fe ? null : a;
        default:
            return null;
    }
}
function $9b9e6d0f6347a978$var$ke(a, b) {
    if ($9b9e6d0f6347a978$var$ie) return "compositionend" === a || !$9b9e6d0f6347a978$var$ae && $9b9e6d0f6347a978$var$ge(a, b) ? (a = $9b9e6d0f6347a978$var$nd(), $9b9e6d0f6347a978$var$md = $9b9e6d0f6347a978$var$ld = $9b9e6d0f6347a978$var$kd = null, $9b9e6d0f6347a978$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9b9e6d0f6347a978$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9b9e6d0f6347a978$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9b9e6d0f6347a978$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9b9e6d0f6347a978$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9b9e6d0f6347a978$var$ne(a, b, c, d) {
    $9b9e6d0f6347a978$var$Eb(d);
    b = $9b9e6d0f6347a978$var$oe(b, "onChange");
    0 < b.length && (c = new $9b9e6d0f6347a978$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9b9e6d0f6347a978$var$pe = null, $9b9e6d0f6347a978$var$qe = null;
function $9b9e6d0f6347a978$var$re(a) {
    $9b9e6d0f6347a978$var$se(a, 0);
}
function $9b9e6d0f6347a978$var$te(a) {
    var b = $9b9e6d0f6347a978$var$ue(a);
    if ($9b9e6d0f6347a978$var$Wa(b)) return a;
}
function $9b9e6d0f6347a978$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9b9e6d0f6347a978$var$we = !1;
if ($9b9e6d0f6347a978$var$ia) {
    var $9b9e6d0f6347a978$var$xe;
    if ($9b9e6d0f6347a978$var$ia) {
        var $9b9e6d0f6347a978$var$ye = "oninput" in document;
        if (!$9b9e6d0f6347a978$var$ye) {
            var $9b9e6d0f6347a978$var$ze = document.createElement("div");
            $9b9e6d0f6347a978$var$ze.setAttribute("oninput", "return;");
            $9b9e6d0f6347a978$var$ye = "function" === typeof $9b9e6d0f6347a978$var$ze.oninput;
        }
        $9b9e6d0f6347a978$var$xe = $9b9e6d0f6347a978$var$ye;
    } else $9b9e6d0f6347a978$var$xe = !1;
    $9b9e6d0f6347a978$var$we = $9b9e6d0f6347a978$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9b9e6d0f6347a978$var$Ae() {
    $9b9e6d0f6347a978$var$pe && ($9b9e6d0f6347a978$var$pe.detachEvent("onpropertychange", $9b9e6d0f6347a978$var$Be), $9b9e6d0f6347a978$var$qe = $9b9e6d0f6347a978$var$pe = null);
}
function $9b9e6d0f6347a978$var$Be(a) {
    if ("value" === a.propertyName && $9b9e6d0f6347a978$var$te($9b9e6d0f6347a978$var$qe)) {
        var b = [];
        $9b9e6d0f6347a978$var$ne(b, $9b9e6d0f6347a978$var$qe, a, $9b9e6d0f6347a978$var$xb(a));
        $9b9e6d0f6347a978$var$Jb($9b9e6d0f6347a978$var$re, b);
    }
}
function $9b9e6d0f6347a978$var$Ce(a, b, c) {
    "focusin" === a ? ($9b9e6d0f6347a978$var$Ae(), $9b9e6d0f6347a978$var$pe = b, $9b9e6d0f6347a978$var$qe = c, $9b9e6d0f6347a978$var$pe.attachEvent("onpropertychange", $9b9e6d0f6347a978$var$Be)) : "focusout" === a && $9b9e6d0f6347a978$var$Ae();
}
function $9b9e6d0f6347a978$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9b9e6d0f6347a978$var$te($9b9e6d0f6347a978$var$qe);
}
function $9b9e6d0f6347a978$var$Ee(a, b) {
    if ("click" === a) return $9b9e6d0f6347a978$var$te(b);
}
function $9b9e6d0f6347a978$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9b9e6d0f6347a978$var$te(b);
}
function $9b9e6d0f6347a978$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9b9e6d0f6347a978$var$He = "function" === typeof Object.is ? Object.is : $9b9e6d0f6347a978$var$Ge;
function $9b9e6d0f6347a978$var$Ie(a, b) {
    if ($9b9e6d0f6347a978$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9b9e6d0f6347a978$var$ja.call(b, e) || !$9b9e6d0f6347a978$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9b9e6d0f6347a978$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9b9e6d0f6347a978$var$Ke(a, b) {
    var c = $9b9e6d0f6347a978$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9b9e6d0f6347a978$var$Je(c);
    }
}
function $9b9e6d0f6347a978$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9b9e6d0f6347a978$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9b9e6d0f6347a978$var$Me() {
    for(var a = window, b = $9b9e6d0f6347a978$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9b9e6d0f6347a978$var$Xa(a.document);
    }
    return b;
}
function $9b9e6d0f6347a978$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9b9e6d0f6347a978$var$Oe(a) {
    var b = $9b9e6d0f6347a978$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9b9e6d0f6347a978$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9b9e6d0f6347a978$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9b9e6d0f6347a978$var$Ke(c, f);
                var g = $9b9e6d0f6347a978$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9b9e6d0f6347a978$var$Pe = $9b9e6d0f6347a978$var$ia && "documentMode" in document && 11 >= document.documentMode, $9b9e6d0f6347a978$var$Qe = null, $9b9e6d0f6347a978$var$Re = null, $9b9e6d0f6347a978$var$Se = null, $9b9e6d0f6347a978$var$Te = !1;
function $9b9e6d0f6347a978$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9b9e6d0f6347a978$var$Te || null == $9b9e6d0f6347a978$var$Qe || $9b9e6d0f6347a978$var$Qe !== $9b9e6d0f6347a978$var$Xa(d) || (d = $9b9e6d0f6347a978$var$Qe, "selectionStart" in d && $9b9e6d0f6347a978$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9b9e6d0f6347a978$var$Se && $9b9e6d0f6347a978$var$Ie($9b9e6d0f6347a978$var$Se, d) || ($9b9e6d0f6347a978$var$Se = d, d = $9b9e6d0f6347a978$var$oe($9b9e6d0f6347a978$var$Re, "onSelect"), 0 < d.length && (b = new $9b9e6d0f6347a978$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9b9e6d0f6347a978$var$Qe)));
}
function $9b9e6d0f6347a978$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9b9e6d0f6347a978$var$We = {
    animationend: $9b9e6d0f6347a978$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9b9e6d0f6347a978$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9b9e6d0f6347a978$var$Ve("Animation", "AnimationStart"),
    transitionend: $9b9e6d0f6347a978$var$Ve("Transition", "TransitionEnd")
}, $9b9e6d0f6347a978$var$Xe = {}, $9b9e6d0f6347a978$var$Ye = {};
$9b9e6d0f6347a978$var$ia && ($9b9e6d0f6347a978$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9b9e6d0f6347a978$var$We.animationend.animation, delete $9b9e6d0f6347a978$var$We.animationiteration.animation, delete $9b9e6d0f6347a978$var$We.animationstart.animation), "TransitionEvent" in window || delete $9b9e6d0f6347a978$var$We.transitionend.transition);
function $9b9e6d0f6347a978$var$Ze(a) {
    if ($9b9e6d0f6347a978$var$Xe[a]) return $9b9e6d0f6347a978$var$Xe[a];
    if (!$9b9e6d0f6347a978$var$We[a]) return a;
    var b = $9b9e6d0f6347a978$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9b9e6d0f6347a978$var$Ye) return $9b9e6d0f6347a978$var$Xe[a] = b[c];
    return a;
}
var $9b9e6d0f6347a978$var$$e = $9b9e6d0f6347a978$var$Ze("animationend"), $9b9e6d0f6347a978$var$af = $9b9e6d0f6347a978$var$Ze("animationiteration"), $9b9e6d0f6347a978$var$bf = $9b9e6d0f6347a978$var$Ze("animationstart"), $9b9e6d0f6347a978$var$cf = $9b9e6d0f6347a978$var$Ze("transitionend"), $9b9e6d0f6347a978$var$df = new Map, $9b9e6d0f6347a978$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9b9e6d0f6347a978$var$ff(a, b) {
    $9b9e6d0f6347a978$var$df.set(a, b);
    $9b9e6d0f6347a978$var$fa(b, [
        a
    ]);
}
for(var $9b9e6d0f6347a978$var$gf = 0; $9b9e6d0f6347a978$var$gf < $9b9e6d0f6347a978$var$ef.length; $9b9e6d0f6347a978$var$gf++){
    var $9b9e6d0f6347a978$var$hf = $9b9e6d0f6347a978$var$ef[$9b9e6d0f6347a978$var$gf], $9b9e6d0f6347a978$var$jf = $9b9e6d0f6347a978$var$hf.toLowerCase(), $9b9e6d0f6347a978$var$kf = $9b9e6d0f6347a978$var$hf[0].toUpperCase() + $9b9e6d0f6347a978$var$hf.slice(1);
    $9b9e6d0f6347a978$var$ff($9b9e6d0f6347a978$var$jf, "on" + $9b9e6d0f6347a978$var$kf);
}
$9b9e6d0f6347a978$var$ff($9b9e6d0f6347a978$var$$e, "onAnimationEnd");
$9b9e6d0f6347a978$var$ff($9b9e6d0f6347a978$var$af, "onAnimationIteration");
$9b9e6d0f6347a978$var$ff($9b9e6d0f6347a978$var$bf, "onAnimationStart");
$9b9e6d0f6347a978$var$ff("dblclick", "onDoubleClick");
$9b9e6d0f6347a978$var$ff("focusin", "onFocus");
$9b9e6d0f6347a978$var$ff("focusout", "onBlur");
$9b9e6d0f6347a978$var$ff($9b9e6d0f6347a978$var$cf, "onTransitionEnd");
$9b9e6d0f6347a978$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9b9e6d0f6347a978$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9b9e6d0f6347a978$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9b9e6d0f6347a978$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9b9e6d0f6347a978$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9b9e6d0f6347a978$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9b9e6d0f6347a978$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9b9e6d0f6347a978$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9b9e6d0f6347a978$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9b9e6d0f6347a978$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9b9e6d0f6347a978$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9b9e6d0f6347a978$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9b9e6d0f6347a978$var$lf));
function $9b9e6d0f6347a978$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9b9e6d0f6347a978$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9b9e6d0f6347a978$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9b9e6d0f6347a978$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9b9e6d0f6347a978$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9b9e6d0f6347a978$var$Qb) throw a = $9b9e6d0f6347a978$var$Rb, $9b9e6d0f6347a978$var$Qb = !1, $9b9e6d0f6347a978$var$Rb = null, a;
}
function $9b9e6d0f6347a978$var$D(a, b) {
    var c = b[$9b9e6d0f6347a978$var$of];
    void 0 === c && (c = b[$9b9e6d0f6347a978$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9b9e6d0f6347a978$var$pf(b, a, 2, !1), c.add(d));
}
function $9b9e6d0f6347a978$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9b9e6d0f6347a978$var$pf(c, a, d, b);
}
var $9b9e6d0f6347a978$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9b9e6d0f6347a978$var$sf(a) {
    if (!a[$9b9e6d0f6347a978$var$rf]) {
        a[$9b9e6d0f6347a978$var$rf] = !0;
        $9b9e6d0f6347a978$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9b9e6d0f6347a978$var$mf.has(b) || $9b9e6d0f6347a978$var$qf(b, !1, a), $9b9e6d0f6347a978$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9b9e6d0f6347a978$var$rf] || (b[$9b9e6d0f6347a978$var$rf] = !0, $9b9e6d0f6347a978$var$qf("selectionchange", !1, b));
    }
}
function $9b9e6d0f6347a978$var$pf(a, b, c, d) {
    switch($9b9e6d0f6347a978$var$jd(b)){
        case 1:
            var e = $9b9e6d0f6347a978$var$ed;
            break;
        case 4:
            e = $9b9e6d0f6347a978$var$gd;
            break;
        default:
            e = $9b9e6d0f6347a978$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9b9e6d0f6347a978$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9b9e6d0f6347a978$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $9b9e6d0f6347a978$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $9b9e6d0f6347a978$var$Jb(function() {
        var d = f, e = $9b9e6d0f6347a978$var$xb(c), g = [];
        a: {
            var h = $9b9e6d0f6347a978$var$df.get(a);
            if (void 0 !== h) {
                var k = $9b9e6d0f6347a978$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9b9e6d0f6347a978$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9b9e6d0f6347a978$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9b9e6d0f6347a978$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9b9e6d0f6347a978$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9b9e6d0f6347a978$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9b9e6d0f6347a978$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9b9e6d0f6347a978$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9b9e6d0f6347a978$var$Vd;
                        break;
                    case $9b9e6d0f6347a978$var$$e:
                    case $9b9e6d0f6347a978$var$af:
                    case $9b9e6d0f6347a978$var$bf:
                        k = $9b9e6d0f6347a978$var$Hd;
                        break;
                    case $9b9e6d0f6347a978$var$cf:
                        k = $9b9e6d0f6347a978$var$Xd;
                        break;
                    case "scroll":
                        k = $9b9e6d0f6347a978$var$vd;
                        break;
                    case "wheel":
                        k = $9b9e6d0f6347a978$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9b9e6d0f6347a978$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9b9e6d0f6347a978$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9b9e6d0f6347a978$var$Kb(w, x), null != F && t.push($9b9e6d0f6347a978$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9b9e6d0f6347a978$var$wb && (n = c.relatedTarget || c.fromElement) && ($9b9e6d0f6347a978$var$Wc(n) || n[$9b9e6d0f6347a978$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $9b9e6d0f6347a978$var$Wc(n) : null, null !== n && (J = $9b9e6d0f6347a978$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $9b9e6d0f6347a978$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9b9e6d0f6347a978$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9b9e6d0f6347a978$var$ue(k);
                        u = null == n ? h : $9b9e6d0f6347a978$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9b9e6d0f6347a978$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9b9e6d0f6347a978$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9b9e6d0f6347a978$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9b9e6d0f6347a978$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9b9e6d0f6347a978$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9b9e6d0f6347a978$var$vf(t);
                                x = $9b9e6d0f6347a978$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9b9e6d0f6347a978$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9b9e6d0f6347a978$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $9b9e6d0f6347a978$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9b9e6d0f6347a978$var$ve;
                else if ($9b9e6d0f6347a978$var$me(h)) {
                    if ($9b9e6d0f6347a978$var$we) na = $9b9e6d0f6347a978$var$Fe;
                    else {
                        na = $9b9e6d0f6347a978$var$De;
                        var xa = $9b9e6d0f6347a978$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9b9e6d0f6347a978$var$Ee);
                if (na && (na = na(a, d))) {
                    $9b9e6d0f6347a978$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9b9e6d0f6347a978$var$cb(h, "number", h.value);
            }
            xa = d ? $9b9e6d0f6347a978$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($9b9e6d0f6347a978$var$me(xa) || "true" === xa.contentEditable) $9b9e6d0f6347a978$var$Qe = xa, $9b9e6d0f6347a978$var$Re = d, $9b9e6d0f6347a978$var$Se = null;
                    break;
                case "focusout":
                    $9b9e6d0f6347a978$var$Se = $9b9e6d0f6347a978$var$Re = $9b9e6d0f6347a978$var$Qe = null;
                    break;
                case "mousedown":
                    $9b9e6d0f6347a978$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9b9e6d0f6347a978$var$Te = !1;
                    $9b9e6d0f6347a978$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($9b9e6d0f6347a978$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9b9e6d0f6347a978$var$Ue(g, c, e);
            }
            var $a;
            if ($9b9e6d0f6347a978$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9b9e6d0f6347a978$var$ie ? $9b9e6d0f6347a978$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9b9e6d0f6347a978$var$de && "ko" !== c.locale && ($9b9e6d0f6347a978$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9b9e6d0f6347a978$var$ie && ($a = $9b9e6d0f6347a978$var$nd()) : ($9b9e6d0f6347a978$var$kd = e, $9b9e6d0f6347a978$var$ld = "value" in $9b9e6d0f6347a978$var$kd ? $9b9e6d0f6347a978$var$kd.value : $9b9e6d0f6347a978$var$kd.textContent, $9b9e6d0f6347a978$var$ie = !0)), xa = $9b9e6d0f6347a978$var$oe(d, ba), 0 < xa.length && (ba = new $9b9e6d0f6347a978$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9b9e6d0f6347a978$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9b9e6d0f6347a978$var$ce ? $9b9e6d0f6347a978$var$je(a, c) : $9b9e6d0f6347a978$var$ke(a, c)) d = $9b9e6d0f6347a978$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $9b9e6d0f6347a978$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $9b9e6d0f6347a978$var$se(g, b);
    });
}
function $9b9e6d0f6347a978$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9b9e6d0f6347a978$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9b9e6d0f6347a978$var$Kb(a, c), null != f && d.unshift($9b9e6d0f6347a978$var$tf(a, f, e)), f = $9b9e6d0f6347a978$var$Kb(a, b), null != f && d.push($9b9e6d0f6347a978$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $9b9e6d0f6347a978$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9b9e6d0f6347a978$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9b9e6d0f6347a978$var$Kb(c, f), null != k && g.unshift($9b9e6d0f6347a978$var$tf(c, k, h))) : e || (k = $9b9e6d0f6347a978$var$Kb(c, f), null != k && g.push($9b9e6d0f6347a978$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9b9e6d0f6347a978$var$xf = /\r\n?/g, $9b9e6d0f6347a978$var$yf = /\u0000|\uFFFD/g;
function $9b9e6d0f6347a978$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9b9e6d0f6347a978$var$xf, "\n").replace($9b9e6d0f6347a978$var$yf, "");
}
function $9b9e6d0f6347a978$var$Af(a, b, c) {
    b = $9b9e6d0f6347a978$var$zf(b);
    if ($9b9e6d0f6347a978$var$zf(a) !== b && c) throw Error($9b9e6d0f6347a978$var$p(425));
}
function $9b9e6d0f6347a978$var$Bf() {}
var $9b9e6d0f6347a978$var$Cf = null, $9b9e6d0f6347a978$var$Df = null;
function $9b9e6d0f6347a978$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9b9e6d0f6347a978$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9b9e6d0f6347a978$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9b9e6d0f6347a978$var$Hf = "function" === typeof Promise ? Promise : void 0, $9b9e6d0f6347a978$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9b9e6d0f6347a978$var$Hf ? function(a) {
    return $9b9e6d0f6347a978$var$Hf.resolve(null).then(a).catch($9b9e6d0f6347a978$var$If);
} : $9b9e6d0f6347a978$var$Ff;
function $9b9e6d0f6347a978$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9b9e6d0f6347a978$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9b9e6d0f6347a978$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9b9e6d0f6347a978$var$bd(b);
}
function $9b9e6d0f6347a978$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9b9e6d0f6347a978$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9b9e6d0f6347a978$var$Nf = Math.random().toString(36).slice(2), $9b9e6d0f6347a978$var$Of = "__reactFiber$" + $9b9e6d0f6347a978$var$Nf, $9b9e6d0f6347a978$var$Pf = "__reactProps$" + $9b9e6d0f6347a978$var$Nf, $9b9e6d0f6347a978$var$uf = "__reactContainer$" + $9b9e6d0f6347a978$var$Nf, $9b9e6d0f6347a978$var$of = "__reactEvents$" + $9b9e6d0f6347a978$var$Nf, $9b9e6d0f6347a978$var$Qf = "__reactListeners$" + $9b9e6d0f6347a978$var$Nf, $9b9e6d0f6347a978$var$Rf = "__reactHandles$" + $9b9e6d0f6347a978$var$Nf;
function $9b9e6d0f6347a978$var$Wc(a) {
    var b = a[$9b9e6d0f6347a978$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9b9e6d0f6347a978$var$uf] || c[$9b9e6d0f6347a978$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9b9e6d0f6347a978$var$Mf(a); null !== a;){
                if (c = a[$9b9e6d0f6347a978$var$Of]) return c;
                a = $9b9e6d0f6347a978$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9b9e6d0f6347a978$var$Cb(a) {
    a = a[$9b9e6d0f6347a978$var$Of] || a[$9b9e6d0f6347a978$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9b9e6d0f6347a978$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9b9e6d0f6347a978$var$p(33));
}
function $9b9e6d0f6347a978$var$Db(a) {
    return a[$9b9e6d0f6347a978$var$Pf] || null;
}
var $9b9e6d0f6347a978$var$Sf = [], $9b9e6d0f6347a978$var$Tf = -1;
function $9b9e6d0f6347a978$var$Uf(a) {
    return {
        current: a
    };
}
function $9b9e6d0f6347a978$var$E(a) {
    0 > $9b9e6d0f6347a978$var$Tf || (a.current = $9b9e6d0f6347a978$var$Sf[$9b9e6d0f6347a978$var$Tf], $9b9e6d0f6347a978$var$Sf[$9b9e6d0f6347a978$var$Tf] = null, $9b9e6d0f6347a978$var$Tf--);
}
function $9b9e6d0f6347a978$var$G(a, b) {
    $9b9e6d0f6347a978$var$Tf++;
    $9b9e6d0f6347a978$var$Sf[$9b9e6d0f6347a978$var$Tf] = a.current;
    a.current = b;
}
var $9b9e6d0f6347a978$var$Vf = {}, $9b9e6d0f6347a978$var$H = $9b9e6d0f6347a978$var$Uf($9b9e6d0f6347a978$var$Vf), $9b9e6d0f6347a978$var$Wf = $9b9e6d0f6347a978$var$Uf(!1), $9b9e6d0f6347a978$var$Xf = $9b9e6d0f6347a978$var$Vf;
function $9b9e6d0f6347a978$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9b9e6d0f6347a978$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9b9e6d0f6347a978$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9b9e6d0f6347a978$var$$f() {
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf);
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$H);
}
function $9b9e6d0f6347a978$var$ag(a, b, c) {
    if ($9b9e6d0f6347a978$var$H.current !== $9b9e6d0f6347a978$var$Vf) throw Error($9b9e6d0f6347a978$var$p(168));
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$H, b);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Wf, c);
}
function $9b9e6d0f6347a978$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9b9e6d0f6347a978$var$p(108, $9b9e6d0f6347a978$var$Ra(a) || "Unknown", e));
    return $9b9e6d0f6347a978$var$A({}, c, d);
}
function $9b9e6d0f6347a978$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9b9e6d0f6347a978$var$Vf;
    $9b9e6d0f6347a978$var$Xf = $9b9e6d0f6347a978$var$H.current;
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$H, a);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Wf, $9b9e6d0f6347a978$var$Wf.current);
    return !0;
}
function $9b9e6d0f6347a978$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9b9e6d0f6347a978$var$p(169));
    c ? (a = $9b9e6d0f6347a978$var$bg(a, b, $9b9e6d0f6347a978$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf), $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$H), $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$H, a)) : $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Wf, c);
}
var $9b9e6d0f6347a978$var$eg = null, $9b9e6d0f6347a978$var$fg = !1, $9b9e6d0f6347a978$var$gg = !1;
function $9b9e6d0f6347a978$var$hg(a) {
    null === $9b9e6d0f6347a978$var$eg ? $9b9e6d0f6347a978$var$eg = [
        a
    ] : $9b9e6d0f6347a978$var$eg.push(a);
}
function $9b9e6d0f6347a978$var$ig(a) {
    $9b9e6d0f6347a978$var$fg = !0;
    $9b9e6d0f6347a978$var$hg(a);
}
function $9b9e6d0f6347a978$var$jg() {
    if (!$9b9e6d0f6347a978$var$gg && null !== $9b9e6d0f6347a978$var$eg) {
        $9b9e6d0f6347a978$var$gg = !0;
        var a = 0, b = $9b9e6d0f6347a978$var$C;
        try {
            var c = $9b9e6d0f6347a978$var$eg;
            for($9b9e6d0f6347a978$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9b9e6d0f6347a978$var$eg = null;
            $9b9e6d0f6347a978$var$fg = !1;
        } catch (e) {
            throw null !== $9b9e6d0f6347a978$var$eg && ($9b9e6d0f6347a978$var$eg = $9b9e6d0f6347a978$var$eg.slice(a + 1)), $9b9e6d0f6347a978$var$ac($9b9e6d0f6347a978$var$fc, $9b9e6d0f6347a978$var$jg), e;
        } finally{
            $9b9e6d0f6347a978$var$C = b, $9b9e6d0f6347a978$var$gg = !1;
        }
    }
    return null;
}
var $9b9e6d0f6347a978$var$kg = [], $9b9e6d0f6347a978$var$lg = 0, $9b9e6d0f6347a978$var$mg = null, $9b9e6d0f6347a978$var$ng = 0, $9b9e6d0f6347a978$var$og = [], $9b9e6d0f6347a978$var$pg = 0, $9b9e6d0f6347a978$var$qg = null, $9b9e6d0f6347a978$var$rg = 1, $9b9e6d0f6347a978$var$sg = "";
function $9b9e6d0f6347a978$var$tg(a, b) {
    $9b9e6d0f6347a978$var$kg[$9b9e6d0f6347a978$var$lg++] = $9b9e6d0f6347a978$var$ng;
    $9b9e6d0f6347a978$var$kg[$9b9e6d0f6347a978$var$lg++] = $9b9e6d0f6347a978$var$mg;
    $9b9e6d0f6347a978$var$mg = a;
    $9b9e6d0f6347a978$var$ng = b;
}
function $9b9e6d0f6347a978$var$ug(a, b, c) {
    $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$rg;
    $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$sg;
    $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$qg;
    $9b9e6d0f6347a978$var$qg = a;
    var d = $9b9e6d0f6347a978$var$rg;
    a = $9b9e6d0f6347a978$var$sg;
    var e = 32 - $9b9e6d0f6347a978$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9b9e6d0f6347a978$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9b9e6d0f6347a978$var$rg = 1 << 32 - $9b9e6d0f6347a978$var$oc(b) + e | c << e | d;
        $9b9e6d0f6347a978$var$sg = f + a;
    } else $9b9e6d0f6347a978$var$rg = 1 << f | c << e | d, $9b9e6d0f6347a978$var$sg = a;
}
function $9b9e6d0f6347a978$var$vg(a) {
    null !== a.return && ($9b9e6d0f6347a978$var$tg(a, 1), $9b9e6d0f6347a978$var$ug(a, 1, 0));
}
function $9b9e6d0f6347a978$var$wg(a) {
    for(; a === $9b9e6d0f6347a978$var$mg;)$9b9e6d0f6347a978$var$mg = $9b9e6d0f6347a978$var$kg[--$9b9e6d0f6347a978$var$lg], $9b9e6d0f6347a978$var$kg[$9b9e6d0f6347a978$var$lg] = null, $9b9e6d0f6347a978$var$ng = $9b9e6d0f6347a978$var$kg[--$9b9e6d0f6347a978$var$lg], $9b9e6d0f6347a978$var$kg[$9b9e6d0f6347a978$var$lg] = null;
    for(; a === $9b9e6d0f6347a978$var$qg;)$9b9e6d0f6347a978$var$qg = $9b9e6d0f6347a978$var$og[--$9b9e6d0f6347a978$var$pg], $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg] = null, $9b9e6d0f6347a978$var$sg = $9b9e6d0f6347a978$var$og[--$9b9e6d0f6347a978$var$pg], $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg] = null, $9b9e6d0f6347a978$var$rg = $9b9e6d0f6347a978$var$og[--$9b9e6d0f6347a978$var$pg], $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg] = null;
}
var $9b9e6d0f6347a978$var$xg = null, $9b9e6d0f6347a978$var$yg = null, $9b9e6d0f6347a978$var$I = !1, $9b9e6d0f6347a978$var$zg = null;
function $9b9e6d0f6347a978$var$Ag(a, b) {
    var c = $9b9e6d0f6347a978$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9b9e6d0f6347a978$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9b9e6d0f6347a978$var$xg = a, $9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9b9e6d0f6347a978$var$xg = a, $9b9e6d0f6347a978$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9b9e6d0f6347a978$var$qg ? {
                id: $9b9e6d0f6347a978$var$rg,
                overflow: $9b9e6d0f6347a978$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9b9e6d0f6347a978$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $9b9e6d0f6347a978$var$xg = a, $9b9e6d0f6347a978$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9b9e6d0f6347a978$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9b9e6d0f6347a978$var$Eg(a) {
    if ($9b9e6d0f6347a978$var$I) {
        var b = $9b9e6d0f6347a978$var$yg;
        if (b) {
            var c = b;
            if (!$9b9e6d0f6347a978$var$Cg(a, b)) {
                if ($9b9e6d0f6347a978$var$Dg(a)) throw Error($9b9e6d0f6347a978$var$p(418));
                b = $9b9e6d0f6347a978$var$Lf(c.nextSibling);
                var d = $9b9e6d0f6347a978$var$xg;
                b && $9b9e6d0f6347a978$var$Cg(a, b) ? $9b9e6d0f6347a978$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9b9e6d0f6347a978$var$I = !1, $9b9e6d0f6347a978$var$xg = a);
            }
        } else {
            if ($9b9e6d0f6347a978$var$Dg(a)) throw Error($9b9e6d0f6347a978$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9b9e6d0f6347a978$var$I = !1;
            $9b9e6d0f6347a978$var$xg = a;
        }
    }
}
function $9b9e6d0f6347a978$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $9b9e6d0f6347a978$var$xg = a;
}
function $9b9e6d0f6347a978$var$Gg(a) {
    if (a !== $9b9e6d0f6347a978$var$xg) return !1;
    if (!$9b9e6d0f6347a978$var$I) return $9b9e6d0f6347a978$var$Fg(a), $9b9e6d0f6347a978$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9b9e6d0f6347a978$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9b9e6d0f6347a978$var$yg)) {
        if ($9b9e6d0f6347a978$var$Dg(a)) throw $9b9e6d0f6347a978$var$Hg(), Error($9b9e6d0f6347a978$var$p(418));
        for(; b;)$9b9e6d0f6347a978$var$Ag(a, b), b = $9b9e6d0f6347a978$var$Lf(b.nextSibling);
    }
    $9b9e6d0f6347a978$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9b9e6d0f6347a978$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9b9e6d0f6347a978$var$yg = null;
        }
    } else $9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$xg ? $9b9e6d0f6347a978$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9b9e6d0f6347a978$var$Hg() {
    for(var a = $9b9e6d0f6347a978$var$yg; a;)a = $9b9e6d0f6347a978$var$Lf(a.nextSibling);
}
function $9b9e6d0f6347a978$var$Ig() {
    $9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$xg = null;
    $9b9e6d0f6347a978$var$I = !1;
}
function $9b9e6d0f6347a978$var$Jg(a) {
    null === $9b9e6d0f6347a978$var$zg ? $9b9e6d0f6347a978$var$zg = [
        a
    ] : $9b9e6d0f6347a978$var$zg.push(a);
}
var $9b9e6d0f6347a978$var$Kg = $9b9e6d0f6347a978$var$ua.ReactCurrentBatchConfig;
function $9b9e6d0f6347a978$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $9b9e6d0f6347a978$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $9b9e6d0f6347a978$var$Mg = $9b9e6d0f6347a978$var$Uf(null), $9b9e6d0f6347a978$var$Ng = null, $9b9e6d0f6347a978$var$Og = null, $9b9e6d0f6347a978$var$Pg = null;
function $9b9e6d0f6347a978$var$Qg() {
    $9b9e6d0f6347a978$var$Pg = $9b9e6d0f6347a978$var$Og = $9b9e6d0f6347a978$var$Ng = null;
}
function $9b9e6d0f6347a978$var$Rg(a) {
    var b = $9b9e6d0f6347a978$var$Mg.current;
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Mg);
    a._currentValue = b;
}
function $9b9e6d0f6347a978$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $9b9e6d0f6347a978$var$Tg(a, b) {
    $9b9e6d0f6347a978$var$Ng = a;
    $9b9e6d0f6347a978$var$Pg = $9b9e6d0f6347a978$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9b9e6d0f6347a978$var$Ug = !0), a.firstContext = null);
}
function $9b9e6d0f6347a978$var$Vg(a) {
    var b = a._currentValue;
    if ($9b9e6d0f6347a978$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9b9e6d0f6347a978$var$Og) {
            if (null === $9b9e6d0f6347a978$var$Ng) throw Error($9b9e6d0f6347a978$var$p(308));
            $9b9e6d0f6347a978$var$Og = a;
            $9b9e6d0f6347a978$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9b9e6d0f6347a978$var$Og = $9b9e6d0f6347a978$var$Og.next = a;
    }
    return b;
}
var $9b9e6d0f6347a978$var$Wg = null;
function $9b9e6d0f6347a978$var$Xg(a) {
    null === $9b9e6d0f6347a978$var$Wg ? $9b9e6d0f6347a978$var$Wg = [
        a
    ] : $9b9e6d0f6347a978$var$Wg.push(a);
}
function $9b9e6d0f6347a978$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9b9e6d0f6347a978$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9b9e6d0f6347a978$var$Zg(a, d);
}
function $9b9e6d0f6347a978$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $9b9e6d0f6347a978$var$$g = !1;
function $9b9e6d0f6347a978$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9b9e6d0f6347a978$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9b9e6d0f6347a978$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9b9e6d0f6347a978$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9b9e6d0f6347a978$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9b9e6d0f6347a978$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9b9e6d0f6347a978$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9b9e6d0f6347a978$var$Zg(a, c);
}
function $9b9e6d0f6347a978$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9b9e6d0f6347a978$var$Cc(a, c);
    }
}
function $9b9e6d0f6347a978$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9b9e6d0f6347a978$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $9b9e6d0f6347a978$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9b9e6d0f6347a978$var$A({}, q, r);
                            break a;
                        case 2:
                            $9b9e6d0f6347a978$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9b9e6d0f6347a978$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9b9e6d0f6347a978$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9b9e6d0f6347a978$var$p(191, e));
            e.call(d);
        }
    }
}
var $9b9e6d0f6347a978$var$jh = (new $8nGP5.Component).refs;
function $9b9e6d0f6347a978$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9b9e6d0f6347a978$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9b9e6d0f6347a978$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $9b9e6d0f6347a978$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9b9e6d0f6347a978$var$L(), e = $9b9e6d0f6347a978$var$lh(a), f = $9b9e6d0f6347a978$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9b9e6d0f6347a978$var$dh(a, f, e);
        null !== b && ($9b9e6d0f6347a978$var$mh(b, a, e, d), $9b9e6d0f6347a978$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9b9e6d0f6347a978$var$L(), e = $9b9e6d0f6347a978$var$lh(a), f = $9b9e6d0f6347a978$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9b9e6d0f6347a978$var$dh(a, f, e);
        null !== b && ($9b9e6d0f6347a978$var$mh(b, a, e, d), $9b9e6d0f6347a978$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $9b9e6d0f6347a978$var$L(), d = $9b9e6d0f6347a978$var$lh(a), e = $9b9e6d0f6347a978$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9b9e6d0f6347a978$var$dh(a, e, d);
        null !== b && ($9b9e6d0f6347a978$var$mh(b, a, d, c), $9b9e6d0f6347a978$var$eh(b, a, d));
    }
};
function $9b9e6d0f6347a978$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9b9e6d0f6347a978$var$Ie(c, d) || !$9b9e6d0f6347a978$var$Ie(e, f) : !0;
}
function $9b9e6d0f6347a978$var$ph(a, b, c) {
    var d = !1, e = $9b9e6d0f6347a978$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9b9e6d0f6347a978$var$Vg(f) : (e = $9b9e6d0f6347a978$var$Zf(b) ? $9b9e6d0f6347a978$var$Xf : $9b9e6d0f6347a978$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9b9e6d0f6347a978$var$Yf(a, e) : $9b9e6d0f6347a978$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9b9e6d0f6347a978$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9b9e6d0f6347a978$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9b9e6d0f6347a978$var$nh.enqueueReplaceState(b, b.state, null);
}
function $9b9e6d0f6347a978$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $9b9e6d0f6347a978$var$jh;
    $9b9e6d0f6347a978$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9b9e6d0f6347a978$var$Vg(f) : (f = $9b9e6d0f6347a978$var$Zf(b) ? $9b9e6d0f6347a978$var$Xf : $9b9e6d0f6347a978$var$H.current, e.context = $9b9e6d0f6347a978$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9b9e6d0f6347a978$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9b9e6d0f6347a978$var$nh.enqueueReplaceState(e, e.state, null), $9b9e6d0f6347a978$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9b9e6d0f6347a978$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9b9e6d0f6347a978$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9b9e6d0f6347a978$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $9b9e6d0f6347a978$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9b9e6d0f6347a978$var$p(284));
        if (!c._owner) throw Error($9b9e6d0f6347a978$var$p(290, a));
    }
    return a;
}
function $9b9e6d0f6347a978$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9b9e6d0f6347a978$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9b9e6d0f6347a978$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $9b9e6d0f6347a978$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9b9e6d0f6347a978$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9b9e6d0f6347a978$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9b9e6d0f6347a978$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9b9e6d0f6347a978$var$Ha && $9b9e6d0f6347a978$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $9b9e6d0f6347a978$var$sh(a, b, c), d.return = a, d;
        d = $9b9e6d0f6347a978$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9b9e6d0f6347a978$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9b9e6d0f6347a978$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9b9e6d0f6347a978$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9b9e6d0f6347a978$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9b9e6d0f6347a978$var$va:
                    return c = $9b9e6d0f6347a978$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $9b9e6d0f6347a978$var$sh(a, null, b), c.return = a, c;
                case $9b9e6d0f6347a978$var$wa:
                    return b = $9b9e6d0f6347a978$var$zh(b, a.mode, c), b.return = a, b;
                case $9b9e6d0f6347a978$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9b9e6d0f6347a978$var$eb(b) || $9b9e6d0f6347a978$var$Ka(b)) return b = $9b9e6d0f6347a978$var$Ah(b, a.mode, c, null), b.return = a, b;
            $9b9e6d0f6347a978$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9b9e6d0f6347a978$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9b9e6d0f6347a978$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9b9e6d0f6347a978$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9b9e6d0f6347a978$var$eb(c) || $9b9e6d0f6347a978$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9b9e6d0f6347a978$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9b9e6d0f6347a978$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9b9e6d0f6347a978$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9b9e6d0f6347a978$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9b9e6d0f6347a978$var$eb(d) || $9b9e6d0f6347a978$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9b9e6d0f6347a978$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9b9e6d0f6347a978$var$Ka(h);
        if ("function" !== typeof l) throw Error($9b9e6d0f6347a978$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9b9e6d0f6347a978$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9b9e6d0f6347a978$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9b9e6d0f6347a978$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9b9e6d0f6347a978$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9b9e6d0f6347a978$var$Ha && $9b9e6d0f6347a978$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9b9e6d0f6347a978$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9b9e6d0f6347a978$var$ya ? (d = $9b9e6d0f6347a978$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $9b9e6d0f6347a978$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $9b9e6d0f6347a978$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $9b9e6d0f6347a978$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9b9e6d0f6347a978$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $9b9e6d0f6347a978$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9b9e6d0f6347a978$var$eb(f)) return n(a, d, f, h);
            if ($9b9e6d0f6347a978$var$Ka(f)) return t(a, d, f, h);
            $9b9e6d0f6347a978$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $9b9e6d0f6347a978$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9b9e6d0f6347a978$var$Bh = $9b9e6d0f6347a978$var$vh(!0), $9b9e6d0f6347a978$var$Ch = $9b9e6d0f6347a978$var$vh(!1), $9b9e6d0f6347a978$var$Dh = {}, $9b9e6d0f6347a978$var$Eh = $9b9e6d0f6347a978$var$Uf($9b9e6d0f6347a978$var$Dh), $9b9e6d0f6347a978$var$Fh = $9b9e6d0f6347a978$var$Uf($9b9e6d0f6347a978$var$Dh), $9b9e6d0f6347a978$var$Gh = $9b9e6d0f6347a978$var$Uf($9b9e6d0f6347a978$var$Dh);
function $9b9e6d0f6347a978$var$Hh(a) {
    if (a === $9b9e6d0f6347a978$var$Dh) throw Error($9b9e6d0f6347a978$var$p(174));
    return a;
}
function $9b9e6d0f6347a978$var$Ih(a, b) {
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Gh, b);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Fh, a);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Eh, $9b9e6d0f6347a978$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9b9e6d0f6347a978$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9b9e6d0f6347a978$var$lb(b, a);
    }
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Eh);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Eh, b);
}
function $9b9e6d0f6347a978$var$Jh() {
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Eh);
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Fh);
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Gh);
}
function $9b9e6d0f6347a978$var$Kh(a) {
    $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Gh.current);
    var b = $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Eh.current);
    var c = $9b9e6d0f6347a978$var$lb(b, a.type);
    b !== c && ($9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Fh, a), $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Eh, c));
}
function $9b9e6d0f6347a978$var$Lh(a) {
    $9b9e6d0f6347a978$var$Fh.current === a && ($9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Eh), $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Fh));
}
var $9b9e6d0f6347a978$var$M = $9b9e6d0f6347a978$var$Uf(0);
function $9b9e6d0f6347a978$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $9b9e6d0f6347a978$var$Nh = [];
function $9b9e6d0f6347a978$var$Oh() {
    for(var a = 0; a < $9b9e6d0f6347a978$var$Nh.length; a++)$9b9e6d0f6347a978$var$Nh[a]._workInProgressVersionPrimary = null;
    $9b9e6d0f6347a978$var$Nh.length = 0;
}
var $9b9e6d0f6347a978$var$Ph = $9b9e6d0f6347a978$var$ua.ReactCurrentDispatcher, $9b9e6d0f6347a978$var$Qh = $9b9e6d0f6347a978$var$ua.ReactCurrentBatchConfig, $9b9e6d0f6347a978$var$Rh = 0, $9b9e6d0f6347a978$var$N = null, $9b9e6d0f6347a978$var$O = null, $9b9e6d0f6347a978$var$P = null, $9b9e6d0f6347a978$var$Sh = !1, $9b9e6d0f6347a978$var$Th = !1, $9b9e6d0f6347a978$var$Uh = 0, $9b9e6d0f6347a978$var$Vh = 0;
function $9b9e6d0f6347a978$var$Q() {
    throw Error($9b9e6d0f6347a978$var$p(321));
}
function $9b9e6d0f6347a978$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9b9e6d0f6347a978$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9b9e6d0f6347a978$var$Xh(a, b, c, d, e, f) {
    $9b9e6d0f6347a978$var$Rh = f;
    $9b9e6d0f6347a978$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9b9e6d0f6347a978$var$Ph.current = null === a || null === a.memoizedState ? $9b9e6d0f6347a978$var$Yh : $9b9e6d0f6347a978$var$Zh;
    a = c(d, e);
    if ($9b9e6d0f6347a978$var$Th) {
        f = 0;
        do {
            $9b9e6d0f6347a978$var$Th = !1;
            $9b9e6d0f6347a978$var$Uh = 0;
            if (25 <= f) throw Error($9b9e6d0f6347a978$var$p(301));
            f += 1;
            $9b9e6d0f6347a978$var$P = $9b9e6d0f6347a978$var$O = null;
            b.updateQueue = null;
            $9b9e6d0f6347a978$var$Ph.current = $9b9e6d0f6347a978$var$$h;
            a = c(d, e);
        }while ($9b9e6d0f6347a978$var$Th);
    }
    $9b9e6d0f6347a978$var$Ph.current = $9b9e6d0f6347a978$var$ai;
    b = null !== $9b9e6d0f6347a978$var$O && null !== $9b9e6d0f6347a978$var$O.next;
    $9b9e6d0f6347a978$var$Rh = 0;
    $9b9e6d0f6347a978$var$P = $9b9e6d0f6347a978$var$O = $9b9e6d0f6347a978$var$N = null;
    $9b9e6d0f6347a978$var$Sh = !1;
    if (b) throw Error($9b9e6d0f6347a978$var$p(300));
    return a;
}
function $9b9e6d0f6347a978$var$bi() {
    var a = 0 !== $9b9e6d0f6347a978$var$Uh;
    $9b9e6d0f6347a978$var$Uh = 0;
    return a;
}
function $9b9e6d0f6347a978$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9b9e6d0f6347a978$var$P ? $9b9e6d0f6347a978$var$N.memoizedState = $9b9e6d0f6347a978$var$P = a : $9b9e6d0f6347a978$var$P = $9b9e6d0f6347a978$var$P.next = a;
    return $9b9e6d0f6347a978$var$P;
}
function $9b9e6d0f6347a978$var$di() {
    if (null === $9b9e6d0f6347a978$var$O) {
        var a = $9b9e6d0f6347a978$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9b9e6d0f6347a978$var$O.next;
    var b = null === $9b9e6d0f6347a978$var$P ? $9b9e6d0f6347a978$var$N.memoizedState : $9b9e6d0f6347a978$var$P.next;
    if (null !== b) $9b9e6d0f6347a978$var$P = b, $9b9e6d0f6347a978$var$O = a;
    else {
        if (null === a) throw Error($9b9e6d0f6347a978$var$p(310));
        $9b9e6d0f6347a978$var$O = a;
        a = {
            memoizedState: $9b9e6d0f6347a978$var$O.memoizedState,
            baseState: $9b9e6d0f6347a978$var$O.baseState,
            baseQueue: $9b9e6d0f6347a978$var$O.baseQueue,
            queue: $9b9e6d0f6347a978$var$O.queue,
            next: null
        };
        null === $9b9e6d0f6347a978$var$P ? $9b9e6d0f6347a978$var$N.memoizedState = $9b9e6d0f6347a978$var$P = a : $9b9e6d0f6347a978$var$P = $9b9e6d0f6347a978$var$P.next = a;
    }
    return $9b9e6d0f6347a978$var$P;
}
function $9b9e6d0f6347a978$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9b9e6d0f6347a978$var$fi(a) {
    var b = $9b9e6d0f6347a978$var$di(), c = b.queue;
    if (null === c) throw Error($9b9e6d0f6347a978$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9b9e6d0f6347a978$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9b9e6d0f6347a978$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9b9e6d0f6347a978$var$N.lanes |= m;
                $9b9e6d0f6347a978$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9b9e6d0f6347a978$var$He(d, b.memoizedState) || ($9b9e6d0f6347a978$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9b9e6d0f6347a978$var$N.lanes |= f, $9b9e6d0f6347a978$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9b9e6d0f6347a978$var$gi(a) {
    var b = $9b9e6d0f6347a978$var$di(), c = b.queue;
    if (null === c) throw Error($9b9e6d0f6347a978$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9b9e6d0f6347a978$var$He(f, b.memoizedState) || ($9b9e6d0f6347a978$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9b9e6d0f6347a978$var$hi() {}
function $9b9e6d0f6347a978$var$ii(a, b) {
    var c = $9b9e6d0f6347a978$var$N, d = $9b9e6d0f6347a978$var$di(), e = b(), f = !$9b9e6d0f6347a978$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9b9e6d0f6347a978$var$Ug = !0);
    d = d.queue;
    $9b9e6d0f6347a978$var$ji($9b9e6d0f6347a978$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9b9e6d0f6347a978$var$P && $9b9e6d0f6347a978$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9b9e6d0f6347a978$var$li(9, $9b9e6d0f6347a978$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $9b9e6d0f6347a978$var$R) throw Error($9b9e6d0f6347a978$var$p(349));
        0 !== ($9b9e6d0f6347a978$var$Rh & 30) || $9b9e6d0f6347a978$var$ni(c, b, e);
    }
    return e;
}
function $9b9e6d0f6347a978$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9b9e6d0f6347a978$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9b9e6d0f6347a978$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9b9e6d0f6347a978$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9b9e6d0f6347a978$var$oi(b) && $9b9e6d0f6347a978$var$pi(a);
}
function $9b9e6d0f6347a978$var$ki(a, b, c) {
    return c(function() {
        $9b9e6d0f6347a978$var$oi(b) && $9b9e6d0f6347a978$var$pi(a);
    });
}
function $9b9e6d0f6347a978$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9b9e6d0f6347a978$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9b9e6d0f6347a978$var$pi(a) {
    var b = $9b9e6d0f6347a978$var$Zg(a, 1);
    null !== b && $9b9e6d0f6347a978$var$mh(b, a, 1, -1);
}
function $9b9e6d0f6347a978$var$qi(a) {
    var b = $9b9e6d0f6347a978$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9b9e6d0f6347a978$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9b9e6d0f6347a978$var$ri.bind(null, $9b9e6d0f6347a978$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9b9e6d0f6347a978$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9b9e6d0f6347a978$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9b9e6d0f6347a978$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9b9e6d0f6347a978$var$si() {
    return $9b9e6d0f6347a978$var$di().memoizedState;
}
function $9b9e6d0f6347a978$var$ti(a, b, c, d) {
    var e = $9b9e6d0f6347a978$var$ci();
    $9b9e6d0f6347a978$var$N.flags |= a;
    e.memoizedState = $9b9e6d0f6347a978$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9b9e6d0f6347a978$var$ui(a, b, c, d) {
    var e = $9b9e6d0f6347a978$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9b9e6d0f6347a978$var$O) {
        var g = $9b9e6d0f6347a978$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $9b9e6d0f6347a978$var$Wh(d, g.deps)) {
            e.memoizedState = $9b9e6d0f6347a978$var$li(b, c, f, d);
            return;
        }
    }
    $9b9e6d0f6347a978$var$N.flags |= a;
    e.memoizedState = $9b9e6d0f6347a978$var$li(1 | b, c, f, d);
}
function $9b9e6d0f6347a978$var$vi(a, b) {
    return $9b9e6d0f6347a978$var$ti(8390656, 8, a, b);
}
function $9b9e6d0f6347a978$var$ji(a, b) {
    return $9b9e6d0f6347a978$var$ui(2048, 8, a, b);
}
function $9b9e6d0f6347a978$var$wi(a, b) {
    return $9b9e6d0f6347a978$var$ui(4, 2, a, b);
}
function $9b9e6d0f6347a978$var$xi(a, b) {
    return $9b9e6d0f6347a978$var$ui(4, 4, a, b);
}
function $9b9e6d0f6347a978$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9b9e6d0f6347a978$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9b9e6d0f6347a978$var$ui(4, 4, $9b9e6d0f6347a978$var$yi.bind(null, b, a), c);
}
function $9b9e6d0f6347a978$var$Ai() {}
function $9b9e6d0f6347a978$var$Bi(a, b) {
    var c = $9b9e6d0f6347a978$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9b9e6d0f6347a978$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9b9e6d0f6347a978$var$Ci(a, b) {
    var c = $9b9e6d0f6347a978$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9b9e6d0f6347a978$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9b9e6d0f6347a978$var$Di(a, b, c) {
    if (0 === ($9b9e6d0f6347a978$var$Rh & 21)) return a.baseState && (a.baseState = !1, $9b9e6d0f6347a978$var$Ug = !0), a.memoizedState = c;
    $9b9e6d0f6347a978$var$He(c, b) || (c = $9b9e6d0f6347a978$var$yc(), $9b9e6d0f6347a978$var$N.lanes |= c, $9b9e6d0f6347a978$var$hh |= c, a.baseState = !0);
    return b;
}
function $9b9e6d0f6347a978$var$Ei(a, b) {
    var c = $9b9e6d0f6347a978$var$C;
    $9b9e6d0f6347a978$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9b9e6d0f6347a978$var$Qh.transition;
    $9b9e6d0f6347a978$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9b9e6d0f6347a978$var$C = c, $9b9e6d0f6347a978$var$Qh.transition = d;
    }
}
function $9b9e6d0f6347a978$var$Fi() {
    return $9b9e6d0f6347a978$var$di().memoizedState;
}
function $9b9e6d0f6347a978$var$Gi(a, b, c) {
    var d = $9b9e6d0f6347a978$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9b9e6d0f6347a978$var$Hi(a)) $9b9e6d0f6347a978$var$Ii(b, c);
    else if (c = $9b9e6d0f6347a978$var$Yg(a, b, c, d), null !== c) {
        var e = $9b9e6d0f6347a978$var$L();
        $9b9e6d0f6347a978$var$mh(c, a, d, e);
        $9b9e6d0f6347a978$var$Ji(c, b, d);
    }
}
function $9b9e6d0f6347a978$var$ri(a, b, c) {
    var d = $9b9e6d0f6347a978$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9b9e6d0f6347a978$var$Hi(a)) $9b9e6d0f6347a978$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9b9e6d0f6347a978$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9b9e6d0f6347a978$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9b9e6d0f6347a978$var$Yg(a, b, e, d);
        null !== c && (e = $9b9e6d0f6347a978$var$L(), $9b9e6d0f6347a978$var$mh(c, a, d, e), $9b9e6d0f6347a978$var$Ji(c, b, d));
    }
}
function $9b9e6d0f6347a978$var$Hi(a) {
    var b = a.alternate;
    return a === $9b9e6d0f6347a978$var$N || null !== b && b === $9b9e6d0f6347a978$var$N;
}
function $9b9e6d0f6347a978$var$Ii(a, b) {
    $9b9e6d0f6347a978$var$Th = $9b9e6d0f6347a978$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9b9e6d0f6347a978$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9b9e6d0f6347a978$var$Cc(a, c);
    }
}
var $9b9e6d0f6347a978$var$ai = {
    readContext: $9b9e6d0f6347a978$var$Vg,
    useCallback: $9b9e6d0f6347a978$var$Q,
    useContext: $9b9e6d0f6347a978$var$Q,
    useEffect: $9b9e6d0f6347a978$var$Q,
    useImperativeHandle: $9b9e6d0f6347a978$var$Q,
    useInsertionEffect: $9b9e6d0f6347a978$var$Q,
    useLayoutEffect: $9b9e6d0f6347a978$var$Q,
    useMemo: $9b9e6d0f6347a978$var$Q,
    useReducer: $9b9e6d0f6347a978$var$Q,
    useRef: $9b9e6d0f6347a978$var$Q,
    useState: $9b9e6d0f6347a978$var$Q,
    useDebugValue: $9b9e6d0f6347a978$var$Q,
    useDeferredValue: $9b9e6d0f6347a978$var$Q,
    useTransition: $9b9e6d0f6347a978$var$Q,
    useMutableSource: $9b9e6d0f6347a978$var$Q,
    useSyncExternalStore: $9b9e6d0f6347a978$var$Q,
    useId: $9b9e6d0f6347a978$var$Q,
    unstable_isNewReconciler: !1
}, $9b9e6d0f6347a978$var$Yh = {
    readContext: $9b9e6d0f6347a978$var$Vg,
    useCallback: function(a, b) {
        $9b9e6d0f6347a978$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9b9e6d0f6347a978$var$Vg,
    useEffect: $9b9e6d0f6347a978$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9b9e6d0f6347a978$var$ti(4194308, 4, $9b9e6d0f6347a978$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $9b9e6d0f6347a978$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $9b9e6d0f6347a978$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $9b9e6d0f6347a978$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $9b9e6d0f6347a978$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9b9e6d0f6347a978$var$Gi.bind(null, $9b9e6d0f6347a978$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $9b9e6d0f6347a978$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9b9e6d0f6347a978$var$qi,
    useDebugValue: $9b9e6d0f6347a978$var$Ai,
    useDeferredValue: function(a) {
        return $9b9e6d0f6347a978$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $9b9e6d0f6347a978$var$qi(!1), b = a[0];
        a = $9b9e6d0f6347a978$var$Ei.bind(null, a[1]);
        $9b9e6d0f6347a978$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $9b9e6d0f6347a978$var$N, e = $9b9e6d0f6347a978$var$ci();
        if ($9b9e6d0f6347a978$var$I) {
            if (void 0 === c) throw Error($9b9e6d0f6347a978$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9b9e6d0f6347a978$var$R) throw Error($9b9e6d0f6347a978$var$p(349));
            0 !== ($9b9e6d0f6347a978$var$Rh & 30) || $9b9e6d0f6347a978$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9b9e6d0f6347a978$var$vi($9b9e6d0f6347a978$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9b9e6d0f6347a978$var$li(9, $9b9e6d0f6347a978$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $9b9e6d0f6347a978$var$ci(), b = $9b9e6d0f6347a978$var$R.identifierPrefix;
        if ($9b9e6d0f6347a978$var$I) {
            var c = $9b9e6d0f6347a978$var$sg;
            var d = $9b9e6d0f6347a978$var$rg;
            c = (d & ~(1 << 32 - $9b9e6d0f6347a978$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9b9e6d0f6347a978$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9b9e6d0f6347a978$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9b9e6d0f6347a978$var$Zh = {
    readContext: $9b9e6d0f6347a978$var$Vg,
    useCallback: $9b9e6d0f6347a978$var$Bi,
    useContext: $9b9e6d0f6347a978$var$Vg,
    useEffect: $9b9e6d0f6347a978$var$ji,
    useImperativeHandle: $9b9e6d0f6347a978$var$zi,
    useInsertionEffect: $9b9e6d0f6347a978$var$wi,
    useLayoutEffect: $9b9e6d0f6347a978$var$xi,
    useMemo: $9b9e6d0f6347a978$var$Ci,
    useReducer: $9b9e6d0f6347a978$var$fi,
    useRef: $9b9e6d0f6347a978$var$si,
    useState: function() {
        return $9b9e6d0f6347a978$var$fi($9b9e6d0f6347a978$var$ei);
    },
    useDebugValue: $9b9e6d0f6347a978$var$Ai,
    useDeferredValue: function(a) {
        var b = $9b9e6d0f6347a978$var$di();
        return $9b9e6d0f6347a978$var$Di(b, $9b9e6d0f6347a978$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $9b9e6d0f6347a978$var$fi($9b9e6d0f6347a978$var$ei)[0], b = $9b9e6d0f6347a978$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9b9e6d0f6347a978$var$hi,
    useSyncExternalStore: $9b9e6d0f6347a978$var$ii,
    useId: $9b9e6d0f6347a978$var$Fi,
    unstable_isNewReconciler: !1
}, $9b9e6d0f6347a978$var$$h = {
    readContext: $9b9e6d0f6347a978$var$Vg,
    useCallback: $9b9e6d0f6347a978$var$Bi,
    useContext: $9b9e6d0f6347a978$var$Vg,
    useEffect: $9b9e6d0f6347a978$var$ji,
    useImperativeHandle: $9b9e6d0f6347a978$var$zi,
    useInsertionEffect: $9b9e6d0f6347a978$var$wi,
    useLayoutEffect: $9b9e6d0f6347a978$var$xi,
    useMemo: $9b9e6d0f6347a978$var$Ci,
    useReducer: $9b9e6d0f6347a978$var$gi,
    useRef: $9b9e6d0f6347a978$var$si,
    useState: function() {
        return $9b9e6d0f6347a978$var$gi($9b9e6d0f6347a978$var$ei);
    },
    useDebugValue: $9b9e6d0f6347a978$var$Ai,
    useDeferredValue: function(a) {
        var b = $9b9e6d0f6347a978$var$di();
        return null === $9b9e6d0f6347a978$var$O ? b.memoizedState = a : $9b9e6d0f6347a978$var$Di(b, $9b9e6d0f6347a978$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $9b9e6d0f6347a978$var$gi($9b9e6d0f6347a978$var$ei)[0], b = $9b9e6d0f6347a978$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9b9e6d0f6347a978$var$hi,
    useSyncExternalStore: $9b9e6d0f6347a978$var$ii,
    useId: $9b9e6d0f6347a978$var$Fi,
    unstable_isNewReconciler: !1
};
function $9b9e6d0f6347a978$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $9b9e6d0f6347a978$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9b9e6d0f6347a978$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9b9e6d0f6347a978$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9b9e6d0f6347a978$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $9b9e6d0f6347a978$var$Oi(a, b, c) {
    c = $9b9e6d0f6347a978$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9b9e6d0f6347a978$var$Pi || ($9b9e6d0f6347a978$var$Pi = !0, $9b9e6d0f6347a978$var$Qi = d);
        $9b9e6d0f6347a978$var$Mi(a, b);
    };
    return c;
}
function $9b9e6d0f6347a978$var$Ri(a, b, c) {
    c = $9b9e6d0f6347a978$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9b9e6d0f6347a978$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9b9e6d0f6347a978$var$Mi(a, b);
        "function" !== typeof d && (null === $9b9e6d0f6347a978$var$Si ? $9b9e6d0f6347a978$var$Si = new Set([
            this
        ]) : $9b9e6d0f6347a978$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $9b9e6d0f6347a978$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9b9e6d0f6347a978$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9b9e6d0f6347a978$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $9b9e6d0f6347a978$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $9b9e6d0f6347a978$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9b9e6d0f6347a978$var$ch(-1, 1), b.tag = 2, $9b9e6d0f6347a978$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9b9e6d0f6347a978$var$Xi = $9b9e6d0f6347a978$var$ua.ReactCurrentOwner, $9b9e6d0f6347a978$var$Ug = !1;
function $9b9e6d0f6347a978$var$Yi(a, b, c, d) {
    b.child = null === a ? $9b9e6d0f6347a978$var$Ch(b, null, c, d) : $9b9e6d0f6347a978$var$Bh(b, a.child, c, d);
}
function $9b9e6d0f6347a978$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9b9e6d0f6347a978$var$Tg(b, e);
    d = $9b9e6d0f6347a978$var$Xh(a, b, c, d, f, e);
    c = $9b9e6d0f6347a978$var$bi();
    if (null !== a && !$9b9e6d0f6347a978$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9b9e6d0f6347a978$var$$i(a, b, e);
    $9b9e6d0f6347a978$var$I && c && $9b9e6d0f6347a978$var$vg(b);
    b.flags |= 1;
    $9b9e6d0f6347a978$var$Yi(a, b, d, e);
    return b.child;
}
function $9b9e6d0f6347a978$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9b9e6d0f6347a978$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9b9e6d0f6347a978$var$cj(a, b, f, d, e);
        a = $9b9e6d0f6347a978$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9b9e6d0f6347a978$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9b9e6d0f6347a978$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $9b9e6d0f6347a978$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $9b9e6d0f6347a978$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9b9e6d0f6347a978$var$Ie(f, d) && a.ref === b.ref) {
            if ($9b9e6d0f6347a978$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9b9e6d0f6347a978$var$Ug = !0);
            else return b.lanes = a.lanes, $9b9e6d0f6347a978$var$$i(a, b, e);
        }
    }
    return $9b9e6d0f6347a978$var$dj(a, b, c, d, e);
}
function $9b9e6d0f6347a978$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$fj, $9b9e6d0f6347a978$var$gj), $9b9e6d0f6347a978$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$fj, $9b9e6d0f6347a978$var$gj), $9b9e6d0f6347a978$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$fj, $9b9e6d0f6347a978$var$gj);
            $9b9e6d0f6347a978$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$fj, $9b9e6d0f6347a978$var$gj), $9b9e6d0f6347a978$var$gj |= d;
    $9b9e6d0f6347a978$var$Yi(a, b, e, c);
    return b.child;
}
function $9b9e6d0f6347a978$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9b9e6d0f6347a978$var$dj(a, b, c, d, e) {
    var f = $9b9e6d0f6347a978$var$Zf(c) ? $9b9e6d0f6347a978$var$Xf : $9b9e6d0f6347a978$var$H.current;
    f = $9b9e6d0f6347a978$var$Yf(b, f);
    $9b9e6d0f6347a978$var$Tg(b, e);
    c = $9b9e6d0f6347a978$var$Xh(a, b, c, d, f, e);
    d = $9b9e6d0f6347a978$var$bi();
    if (null !== a && !$9b9e6d0f6347a978$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9b9e6d0f6347a978$var$$i(a, b, e);
    $9b9e6d0f6347a978$var$I && d && $9b9e6d0f6347a978$var$vg(b);
    b.flags |= 1;
    $9b9e6d0f6347a978$var$Yi(a, b, c, e);
    return b.child;
}
function $9b9e6d0f6347a978$var$ij(a, b, c, d, e) {
    if ($9b9e6d0f6347a978$var$Zf(c)) {
        var f = !0;
        $9b9e6d0f6347a978$var$cg(b);
    } else f = !1;
    $9b9e6d0f6347a978$var$Tg(b, e);
    if (null === b.stateNode) $9b9e6d0f6347a978$var$jj(a, b), $9b9e6d0f6347a978$var$ph(b, c, d), $9b9e6d0f6347a978$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9b9e6d0f6347a978$var$Vg(l) : (l = $9b9e6d0f6347a978$var$Zf(c) ? $9b9e6d0f6347a978$var$Xf : $9b9e6d0f6347a978$var$H.current, l = $9b9e6d0f6347a978$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9b9e6d0f6347a978$var$qh(b, g, d, l);
        $9b9e6d0f6347a978$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $9b9e6d0f6347a978$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9b9e6d0f6347a978$var$Wf.current || $9b9e6d0f6347a978$var$$g ? ("function" === typeof m && ($9b9e6d0f6347a978$var$kh(b, c, m, d), k = b.memoizedState), (h = $9b9e6d0f6347a978$var$$g || $9b9e6d0f6347a978$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9b9e6d0f6347a978$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9b9e6d0f6347a978$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9b9e6d0f6347a978$var$Vg(k) : (k = $9b9e6d0f6347a978$var$Zf(c) ? $9b9e6d0f6347a978$var$Xf : $9b9e6d0f6347a978$var$H.current, k = $9b9e6d0f6347a978$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9b9e6d0f6347a978$var$qh(b, g, d, k);
        $9b9e6d0f6347a978$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $9b9e6d0f6347a978$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9b9e6d0f6347a978$var$Wf.current || $9b9e6d0f6347a978$var$$g ? ("function" === typeof y && ($9b9e6d0f6347a978$var$kh(b, c, y, d), n = b.memoizedState), (l = $9b9e6d0f6347a978$var$$g || $9b9e6d0f6347a978$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9b9e6d0f6347a978$var$kj(a, b, c, d, f, e);
}
function $9b9e6d0f6347a978$var$kj(a, b, c, d, e, f) {
    $9b9e6d0f6347a978$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9b9e6d0f6347a978$var$dg(b, c, !1), $9b9e6d0f6347a978$var$$i(a, b, f);
    d = b.stateNode;
    $9b9e6d0f6347a978$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9b9e6d0f6347a978$var$Bh(b, a.child, null, f), b.child = $9b9e6d0f6347a978$var$Bh(b, null, h, f)) : $9b9e6d0f6347a978$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9b9e6d0f6347a978$var$dg(b, c, !0);
    return b.child;
}
function $9b9e6d0f6347a978$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9b9e6d0f6347a978$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9b9e6d0f6347a978$var$ag(a, b.context, !1);
    $9b9e6d0f6347a978$var$Ih(a, b.containerInfo);
}
function $9b9e6d0f6347a978$var$mj(a, b, c, d, e) {
    $9b9e6d0f6347a978$var$Ig();
    $9b9e6d0f6347a978$var$Jg(e);
    b.flags |= 256;
    $9b9e6d0f6347a978$var$Yi(a, b, c, d);
    return b.child;
}
var $9b9e6d0f6347a978$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9b9e6d0f6347a978$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9b9e6d0f6347a978$var$pj(a, b, c) {
    var d = b.pendingProps, e = $9b9e6d0f6347a978$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, e & 1);
    if (null === a) {
        $9b9e6d0f6347a978$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9b9e6d0f6347a978$var$qj(g, d, 0, null), a = $9b9e6d0f6347a978$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $9b9e6d0f6347a978$var$oj(c), b.memoizedState = $9b9e6d0f6347a978$var$nj, a) : $9b9e6d0f6347a978$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9b9e6d0f6347a978$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9b9e6d0f6347a978$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9b9e6d0f6347a978$var$wh(h, f) : (f = $9b9e6d0f6347a978$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9b9e6d0f6347a978$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9b9e6d0f6347a978$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9b9e6d0f6347a978$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9b9e6d0f6347a978$var$rj(a, b) {
    b = $9b9e6d0f6347a978$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $9b9e6d0f6347a978$var$tj(a, b, c, d) {
    null !== d && $9b9e6d0f6347a978$var$Jg(d);
    $9b9e6d0f6347a978$var$Bh(b, a.child, null, c);
    a = $9b9e6d0f6347a978$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9b9e6d0f6347a978$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9b9e6d0f6347a978$var$Li(Error($9b9e6d0f6347a978$var$p(422))), $9b9e6d0f6347a978$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9b9e6d0f6347a978$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9b9e6d0f6347a978$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9b9e6d0f6347a978$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $9b9e6d0f6347a978$var$oj(g);
        b.memoizedState = $9b9e6d0f6347a978$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9b9e6d0f6347a978$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9b9e6d0f6347a978$var$p(419));
        d = $9b9e6d0f6347a978$var$Li(f, d, void 0);
        return $9b9e6d0f6347a978$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9b9e6d0f6347a978$var$Ug || h) {
        d = $9b9e6d0f6347a978$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9b9e6d0f6347a978$var$Zg(a, e), $9b9e6d0f6347a978$var$mh(d, a, e, -1));
        }
        $9b9e6d0f6347a978$var$uj();
        d = $9b9e6d0f6347a978$var$Li(Error($9b9e6d0f6347a978$var$p(421)));
        return $9b9e6d0f6347a978$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9b9e6d0f6347a978$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$Lf(e.nextSibling);
    $9b9e6d0f6347a978$var$xg = b;
    $9b9e6d0f6347a978$var$I = !0;
    $9b9e6d0f6347a978$var$zg = null;
    null !== a && ($9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$rg, $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$sg, $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$qg, $9b9e6d0f6347a978$var$rg = a.id, $9b9e6d0f6347a978$var$sg = a.overflow, $9b9e6d0f6347a978$var$qg = b);
    b = $9b9e6d0f6347a978$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9b9e6d0f6347a978$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9b9e6d0f6347a978$var$Sg(a.return, b, c);
}
function $9b9e6d0f6347a978$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9b9e6d0f6347a978$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9b9e6d0f6347a978$var$Yi(a, b, d.children, c);
    d = $9b9e6d0f6347a978$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9b9e6d0f6347a978$var$wj(a, c, b);
            else if (19 === a.tag) $9b9e6d0f6347a978$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9b9e6d0f6347a978$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9b9e6d0f6347a978$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9b9e6d0f6347a978$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9b9e6d0f6347a978$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $9b9e6d0f6347a978$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9b9e6d0f6347a978$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9b9e6d0f6347a978$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9b9e6d0f6347a978$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9b9e6d0f6347a978$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9b9e6d0f6347a978$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9b9e6d0f6347a978$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $9b9e6d0f6347a978$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $9b9e6d0f6347a978$var$lj(b);
            $9b9e6d0f6347a978$var$Ig();
            break;
        case 5:
            $9b9e6d0f6347a978$var$Kh(b);
            break;
        case 1:
            $9b9e6d0f6347a978$var$Zf(b.type) && $9b9e6d0f6347a978$var$cg(b);
            break;
        case 4:
            $9b9e6d0f6347a978$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, $9b9e6d0f6347a978$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9b9e6d0f6347a978$var$pj(a, b, c);
                $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, $9b9e6d0f6347a978$var$M.current & 1);
                a = $9b9e6d0f6347a978$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, $9b9e6d0f6347a978$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9b9e6d0f6347a978$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, $9b9e6d0f6347a978$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9b9e6d0f6347a978$var$ej(a, b, c);
    }
    return $9b9e6d0f6347a978$var$$i(a, b, c);
}
var $9b9e6d0f6347a978$var$Aj, $9b9e6d0f6347a978$var$Bj, $9b9e6d0f6347a978$var$Cj, $9b9e6d0f6347a978$var$Dj;
$9b9e6d0f6347a978$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$9b9e6d0f6347a978$var$Bj = function() {};
$9b9e6d0f6347a978$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9b9e6d0f6347a978$var$Ya(a, e);
                d = $9b9e6d0f6347a978$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9b9e6d0f6347a978$var$A({}, e, {
                    value: void 0
                });
                d = $9b9e6d0f6347a978$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9b9e6d0f6347a978$var$gb(a, e);
                d = $9b9e6d0f6347a978$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9b9e6d0f6347a978$var$Bf);
        }
        $9b9e6d0f6347a978$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9b9e6d0f6347a978$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9b9e6d0f6347a978$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9b9e6d0f6347a978$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9b9e6d0f6347a978$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9b9e6d0f6347a978$var$Ej(a, b) {
    if (!$9b9e6d0f6347a978$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9b9e6d0f6347a978$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9b9e6d0f6347a978$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $9b9e6d0f6347a978$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9b9e6d0f6347a978$var$S(b), null;
        case 1:
            return $9b9e6d0f6347a978$var$Zf(b.type) && $9b9e6d0f6347a978$var$$f(), $9b9e6d0f6347a978$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9b9e6d0f6347a978$var$Jh();
            $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf);
            $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$H);
            $9b9e6d0f6347a978$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9b9e6d0f6347a978$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9b9e6d0f6347a978$var$zg && ($9b9e6d0f6347a978$var$Gj($9b9e6d0f6347a978$var$zg), $9b9e6d0f6347a978$var$zg = null));
            $9b9e6d0f6347a978$var$Bj(a, b);
            $9b9e6d0f6347a978$var$S(b);
            return null;
        case 5:
            $9b9e6d0f6347a978$var$Lh(b);
            var e = $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9b9e6d0f6347a978$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9b9e6d0f6347a978$var$p(166));
                    $9b9e6d0f6347a978$var$S(b);
                    return null;
                }
                a = $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Eh.current);
                if ($9b9e6d0f6347a978$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9b9e6d0f6347a978$var$Of] = b;
                    d[$9b9e6d0f6347a978$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9b9e6d0f6347a978$var$D("cancel", d);
                            $9b9e6d0f6347a978$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9b9e6d0f6347a978$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9b9e6d0f6347a978$var$lf.length; e++)$9b9e6d0f6347a978$var$D($9b9e6d0f6347a978$var$lf[e], d);
                            break;
                        case "source":
                            $9b9e6d0f6347a978$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9b9e6d0f6347a978$var$D("error", d);
                            $9b9e6d0f6347a978$var$D("load", d);
                            break;
                        case "details":
                            $9b9e6d0f6347a978$var$D("toggle", d);
                            break;
                        case "input":
                            $9b9e6d0f6347a978$var$Za(d, f);
                            $9b9e6d0f6347a978$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9b9e6d0f6347a978$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9b9e6d0f6347a978$var$hb(d, f), $9b9e6d0f6347a978$var$D("invalid", d);
                    }
                    $9b9e6d0f6347a978$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9b9e6d0f6347a978$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9b9e6d0f6347a978$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9b9e6d0f6347a978$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9b9e6d0f6347a978$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9b9e6d0f6347a978$var$Va(d);
                            $9b9e6d0f6347a978$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9b9e6d0f6347a978$var$Va(d);
                            $9b9e6d0f6347a978$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9b9e6d0f6347a978$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9b9e6d0f6347a978$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9b9e6d0f6347a978$var$Of] = b;
                    a[$9b9e6d0f6347a978$var$Pf] = d;
                    $9b9e6d0f6347a978$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9b9e6d0f6347a978$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9b9e6d0f6347a978$var$D("cancel", a);
                                $9b9e6d0f6347a978$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9b9e6d0f6347a978$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9b9e6d0f6347a978$var$lf.length; e++)$9b9e6d0f6347a978$var$D($9b9e6d0f6347a978$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9b9e6d0f6347a978$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9b9e6d0f6347a978$var$D("error", a);
                                $9b9e6d0f6347a978$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9b9e6d0f6347a978$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9b9e6d0f6347a978$var$Za(a, d);
                                e = $9b9e6d0f6347a978$var$Ya(a, d);
                                $9b9e6d0f6347a978$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9b9e6d0f6347a978$var$A({}, d, {
                                    value: void 0
                                });
                                $9b9e6d0f6347a978$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9b9e6d0f6347a978$var$hb(a, d);
                                e = $9b9e6d0f6347a978$var$gb(a, d);
                                $9b9e6d0f6347a978$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9b9e6d0f6347a978$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9b9e6d0f6347a978$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9b9e6d0f6347a978$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9b9e6d0f6347a978$var$ob(a, k) : "number" === typeof k && $9b9e6d0f6347a978$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9b9e6d0f6347a978$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9b9e6d0f6347a978$var$D("scroll", a) : null != k && $9b9e6d0f6347a978$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9b9e6d0f6347a978$var$Va(a);
                                $9b9e6d0f6347a978$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9b9e6d0f6347a978$var$Va(a);
                                $9b9e6d0f6347a978$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9b9e6d0f6347a978$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9b9e6d0f6347a978$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9b9e6d0f6347a978$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9b9e6d0f6347a978$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9b9e6d0f6347a978$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9b9e6d0f6347a978$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9b9e6d0f6347a978$var$p(166));
                c = $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Gh.current);
                $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Eh.current);
                if ($9b9e6d0f6347a978$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9b9e6d0f6347a978$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9b9e6d0f6347a978$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9b9e6d0f6347a978$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9b9e6d0f6347a978$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9b9e6d0f6347a978$var$Of] = b, b.stateNode = d;
            }
            $9b9e6d0f6347a978$var$S(b);
            return null;
        case 13:
            $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9b9e6d0f6347a978$var$I && null !== $9b9e6d0f6347a978$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9b9e6d0f6347a978$var$Hg(), $9b9e6d0f6347a978$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9b9e6d0f6347a978$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9b9e6d0f6347a978$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9b9e6d0f6347a978$var$p(317));
                        f[$9b9e6d0f6347a978$var$Of] = b;
                    } else $9b9e6d0f6347a978$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9b9e6d0f6347a978$var$S(b);
                    f = !1;
                } else null !== $9b9e6d0f6347a978$var$zg && ($9b9e6d0f6347a978$var$Gj($9b9e6d0f6347a978$var$zg), $9b9e6d0f6347a978$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9b9e6d0f6347a978$var$M.current & 1) ? 0 === $9b9e6d0f6347a978$var$T && ($9b9e6d0f6347a978$var$T = 3) : $9b9e6d0f6347a978$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9b9e6d0f6347a978$var$S(b);
            return null;
        case 4:
            return $9b9e6d0f6347a978$var$Jh(), $9b9e6d0f6347a978$var$Bj(a, b), null === a && $9b9e6d0f6347a978$var$sf(b.stateNode.containerInfo), $9b9e6d0f6347a978$var$S(b), null;
        case 10:
            return $9b9e6d0f6347a978$var$Rg(b.type._context), $9b9e6d0f6347a978$var$S(b), null;
        case 17:
            return $9b9e6d0f6347a978$var$Zf(b.type) && $9b9e6d0f6347a978$var$$f(), $9b9e6d0f6347a978$var$S(b), null;
        case 19:
            $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M);
            f = b.memoizedState;
            if (null === f) return $9b9e6d0f6347a978$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9b9e6d0f6347a978$var$Ej(f, !1);
                else {
                    if (0 !== $9b9e6d0f6347a978$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9b9e6d0f6347a978$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9b9e6d0f6347a978$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, $9b9e6d0f6347a978$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9b9e6d0f6347a978$var$B() > $9b9e6d0f6347a978$var$Hj && (b.flags |= 128, d = !0, $9b9e6d0f6347a978$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9b9e6d0f6347a978$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9b9e6d0f6347a978$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9b9e6d0f6347a978$var$I) return $9b9e6d0f6347a978$var$S(b), null;
                    } else 2 * $9b9e6d0f6347a978$var$B() - f.renderingStartTime > $9b9e6d0f6347a978$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $9b9e6d0f6347a978$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9b9e6d0f6347a978$var$B(), b.sibling = null, c = $9b9e6d0f6347a978$var$M.current, $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, d ? c & 1 | 2 : c & 1), b;
            $9b9e6d0f6347a978$var$S(b);
            return null;
        case 22:
        case 23:
            return $9b9e6d0f6347a978$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9b9e6d0f6347a978$var$gj & 1073741824) && ($9b9e6d0f6347a978$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9b9e6d0f6347a978$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9b9e6d0f6347a978$var$p(156, b.tag));
}
function $9b9e6d0f6347a978$var$Jj(a, b) {
    $9b9e6d0f6347a978$var$wg(b);
    switch(b.tag){
        case 1:
            return $9b9e6d0f6347a978$var$Zf(b.type) && $9b9e6d0f6347a978$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9b9e6d0f6347a978$var$Jh(), $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf), $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$H), $9b9e6d0f6347a978$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9b9e6d0f6347a978$var$Lh(b), null;
        case 13:
            $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9b9e6d0f6347a978$var$p(340));
                $9b9e6d0f6347a978$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M), null;
        case 4:
            return $9b9e6d0f6347a978$var$Jh(), null;
        case 10:
            return $9b9e6d0f6347a978$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $9b9e6d0f6347a978$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9b9e6d0f6347a978$var$Kj = !1, $9b9e6d0f6347a978$var$U = !1, $9b9e6d0f6347a978$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $9b9e6d0f6347a978$var$V = null;
function $9b9e6d0f6347a978$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9b9e6d0f6347a978$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9b9e6d0f6347a978$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9b9e6d0f6347a978$var$W(a, b, d);
    }
}
var $9b9e6d0f6347a978$var$Oj = !1;
function $9b9e6d0f6347a978$var$Pj(a, b) {
    $9b9e6d0f6347a978$var$Cf = $9b9e6d0f6347a978$var$dd;
    a = $9b9e6d0f6347a978$var$Me();
    if ($9b9e6d0f6347a978$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9b9e6d0f6347a978$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9b9e6d0f6347a978$var$dd = !1;
    for($9b9e6d0f6347a978$var$V = b; null !== $9b9e6d0f6347a978$var$V;)if (b = $9b9e6d0f6347a978$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $9b9e6d0f6347a978$var$V = a;
    else for(; null !== $9b9e6d0f6347a978$var$V;){
        b = $9b9e6d0f6347a978$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9b9e6d0f6347a978$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9b9e6d0f6347a978$var$p(163));
            }
        } catch (F) {
            $9b9e6d0f6347a978$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $9b9e6d0f6347a978$var$V = a;
            break;
        }
        $9b9e6d0f6347a978$var$V = b.return;
    }
    n = $9b9e6d0f6347a978$var$Oj;
    $9b9e6d0f6347a978$var$Oj = !1;
    return n;
}
function $9b9e6d0f6347a978$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9b9e6d0f6347a978$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9b9e6d0f6347a978$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9b9e6d0f6347a978$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9b9e6d0f6347a978$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9b9e6d0f6347a978$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9b9e6d0f6347a978$var$Of], delete b[$9b9e6d0f6347a978$var$Pf], delete b[$9b9e6d0f6347a978$var$of], delete b[$9b9e6d0f6347a978$var$Qf], delete b[$9b9e6d0f6347a978$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9b9e6d0f6347a978$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9b9e6d0f6347a978$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $9b9e6d0f6347a978$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9b9e6d0f6347a978$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9b9e6d0f6347a978$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9b9e6d0f6347a978$var$Wj(a, b, c), a = a.sibling; null !== a;)$9b9e6d0f6347a978$var$Wj(a, b, c), a = a.sibling;
}
function $9b9e6d0f6347a978$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9b9e6d0f6347a978$var$Xj(a, b, c), a = a.sibling; null !== a;)$9b9e6d0f6347a978$var$Xj(a, b, c), a = a.sibling;
}
var $9b9e6d0f6347a978$var$X = null, $9b9e6d0f6347a978$var$Yj = !1;
function $9b9e6d0f6347a978$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$9b9e6d0f6347a978$var$ak(a, b, c), c = c.sibling;
}
function $9b9e6d0f6347a978$var$ak(a, b, c) {
    if ($9b9e6d0f6347a978$var$lc && "function" === typeof $9b9e6d0f6347a978$var$lc.onCommitFiberUnmount) try {
        $9b9e6d0f6347a978$var$lc.onCommitFiberUnmount($9b9e6d0f6347a978$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9b9e6d0f6347a978$var$U || $9b9e6d0f6347a978$var$Mj(c, b);
        case 6:
            var d = $9b9e6d0f6347a978$var$X, e = $9b9e6d0f6347a978$var$Yj;
            $9b9e6d0f6347a978$var$X = null;
            $9b9e6d0f6347a978$var$Zj(a, b, c);
            $9b9e6d0f6347a978$var$X = d;
            $9b9e6d0f6347a978$var$Yj = e;
            null !== $9b9e6d0f6347a978$var$X && ($9b9e6d0f6347a978$var$Yj ? (a = $9b9e6d0f6347a978$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9b9e6d0f6347a978$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9b9e6d0f6347a978$var$X && ($9b9e6d0f6347a978$var$Yj ? (a = $9b9e6d0f6347a978$var$X, c = c.stateNode, 8 === a.nodeType ? $9b9e6d0f6347a978$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9b9e6d0f6347a978$var$Kf(a, c), $9b9e6d0f6347a978$var$bd(a)) : $9b9e6d0f6347a978$var$Kf($9b9e6d0f6347a978$var$X, c.stateNode));
            break;
        case 4:
            d = $9b9e6d0f6347a978$var$X;
            e = $9b9e6d0f6347a978$var$Yj;
            $9b9e6d0f6347a978$var$X = c.stateNode.containerInfo;
            $9b9e6d0f6347a978$var$Yj = !0;
            $9b9e6d0f6347a978$var$Zj(a, b, c);
            $9b9e6d0f6347a978$var$X = d;
            $9b9e6d0f6347a978$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9b9e6d0f6347a978$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9b9e6d0f6347a978$var$Nj(c, b, g) : 0 !== (f & 4) && $9b9e6d0f6347a978$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9b9e6d0f6347a978$var$Zj(a, b, c);
            break;
        case 1:
            if (!$9b9e6d0f6347a978$var$U && ($9b9e6d0f6347a978$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9b9e6d0f6347a978$var$W(c, b, h);
            }
            $9b9e6d0f6347a978$var$Zj(a, b, c);
            break;
        case 21:
            $9b9e6d0f6347a978$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9b9e6d0f6347a978$var$U = (d = $9b9e6d0f6347a978$var$U) || null !== c.memoizedState, $9b9e6d0f6347a978$var$Zj(a, b, c), $9b9e6d0f6347a978$var$U = d) : $9b9e6d0f6347a978$var$Zj(a, b, c);
            break;
        default:
            $9b9e6d0f6347a978$var$Zj(a, b, c);
    }
}
function $9b9e6d0f6347a978$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9b9e6d0f6347a978$var$Lj);
        b.forEach(function(b) {
            var d = $9b9e6d0f6347a978$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9b9e6d0f6347a978$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9b9e6d0f6347a978$var$X = h.stateNode;
                        $9b9e6d0f6347a978$var$Yj = !1;
                        break a;
                    case 3:
                        $9b9e6d0f6347a978$var$X = h.stateNode.containerInfo;
                        $9b9e6d0f6347a978$var$Yj = !0;
                        break a;
                    case 4:
                        $9b9e6d0f6347a978$var$X = h.stateNode.containerInfo;
                        $9b9e6d0f6347a978$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $9b9e6d0f6347a978$var$X) throw Error($9b9e6d0f6347a978$var$p(160));
            $9b9e6d0f6347a978$var$ak(f, g, e);
            $9b9e6d0f6347a978$var$X = null;
            $9b9e6d0f6347a978$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $9b9e6d0f6347a978$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9b9e6d0f6347a978$var$ek(b, a), b = b.sibling;
}
function $9b9e6d0f6347a978$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            if (d & 4) {
                try {
                    $9b9e6d0f6347a978$var$Qj(3, a, a.return), $9b9e6d0f6347a978$var$Rj(3, a);
                } catch (t) {
                    $9b9e6d0f6347a978$var$W(a, a.return, t);
                }
                try {
                    $9b9e6d0f6347a978$var$Qj(5, a, a.return);
                } catch (t) {
                    $9b9e6d0f6347a978$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            d & 512 && null !== c && $9b9e6d0f6347a978$var$Mj(c, c.return);
            break;
        case 5:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            d & 512 && null !== c && $9b9e6d0f6347a978$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9b9e6d0f6347a978$var$ob(e, "");
                } catch (t) {
                    $9b9e6d0f6347a978$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9b9e6d0f6347a978$var$ab(e, f);
                    $9b9e6d0f6347a978$var$vb(h, g);
                    var l = $9b9e6d0f6347a978$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9b9e6d0f6347a978$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9b9e6d0f6347a978$var$nb(e, q) : "children" === m ? $9b9e6d0f6347a978$var$ob(e, q) : $9b9e6d0f6347a978$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9b9e6d0f6347a978$var$bb(e, f);
                            break;
                        case "textarea":
                            $9b9e6d0f6347a978$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9b9e6d0f6347a978$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9b9e6d0f6347a978$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9b9e6d0f6347a978$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9b9e6d0f6347a978$var$Pf] = f;
                } catch (t) {
                    $9b9e6d0f6347a978$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9b9e6d0f6347a978$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9b9e6d0f6347a978$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9b9e6d0f6347a978$var$bd(b.containerInfo);
            } catch (t) {
                $9b9e6d0f6347a978$var$W(a, a.return, t);
            }
            break;
        case 4:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            break;
        case 13:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9b9e6d0f6347a978$var$gk = $9b9e6d0f6347a978$var$B()));
            d & 4 && $9b9e6d0f6347a978$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9b9e6d0f6347a978$var$U = (l = $9b9e6d0f6347a978$var$U) || m, $9b9e6d0f6347a978$var$dk(b, a), $9b9e6d0f6347a978$var$U = l) : $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9b9e6d0f6347a978$var$V = a, m = a.child; null !== m;){
                    for(q = $9b9e6d0f6347a978$var$V = m; null !== $9b9e6d0f6347a978$var$V;){
                        r = $9b9e6d0f6347a978$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9b9e6d0f6347a978$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $9b9e6d0f6347a978$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9b9e6d0f6347a978$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9b9e6d0f6347a978$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9b9e6d0f6347a978$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $9b9e6d0f6347a978$var$V = y) : $9b9e6d0f6347a978$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9b9e6d0f6347a978$var$rb("display", g));
                            } catch (t) {
                                $9b9e6d0f6347a978$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9b9e6d0f6347a978$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            d & 4 && $9b9e6d0f6347a978$var$bk(a);
            break;
        case 21:
            break;
        default:
            $9b9e6d0f6347a978$var$dk(b, a), $9b9e6d0f6347a978$var$fk(a);
    }
}
function $9b9e6d0f6347a978$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($9b9e6d0f6347a978$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($9b9e6d0f6347a978$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9b9e6d0f6347a978$var$ob(e, ""), d.flags &= -33);
                    var f = $9b9e6d0f6347a978$var$Vj(a);
                    $9b9e6d0f6347a978$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9b9e6d0f6347a978$var$Vj(a);
                    $9b9e6d0f6347a978$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($9b9e6d0f6347a978$var$p(161));
            }
        } catch (k) {
            $9b9e6d0f6347a978$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9b9e6d0f6347a978$var$ik(a, b, c) {
    $9b9e6d0f6347a978$var$V = a;
    $9b9e6d0f6347a978$var$jk(a, b, c);
}
function $9b9e6d0f6347a978$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9b9e6d0f6347a978$var$V;){
        var e = $9b9e6d0f6347a978$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9b9e6d0f6347a978$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9b9e6d0f6347a978$var$U;
                h = $9b9e6d0f6347a978$var$Kj;
                var l = $9b9e6d0f6347a978$var$U;
                $9b9e6d0f6347a978$var$Kj = g;
                if (($9b9e6d0f6347a978$var$U = k) && !l) for($9b9e6d0f6347a978$var$V = e; null !== $9b9e6d0f6347a978$var$V;)g = $9b9e6d0f6347a978$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9b9e6d0f6347a978$var$kk(e) : null !== k ? (k.return = g, $9b9e6d0f6347a978$var$V = k) : $9b9e6d0f6347a978$var$kk(e);
                for(; null !== f;)$9b9e6d0f6347a978$var$V = f, $9b9e6d0f6347a978$var$jk(f, b, c), f = f.sibling;
                $9b9e6d0f6347a978$var$V = e;
                $9b9e6d0f6347a978$var$Kj = h;
                $9b9e6d0f6347a978$var$U = l;
            }
            $9b9e6d0f6347a978$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $9b9e6d0f6347a978$var$V = f) : $9b9e6d0f6347a978$var$lk(a, b, c);
    }
}
function $9b9e6d0f6347a978$var$lk(a) {
    for(; null !== $9b9e6d0f6347a978$var$V;){
        var b = $9b9e6d0f6347a978$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9b9e6d0f6347a978$var$U || $9b9e6d0f6347a978$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9b9e6d0f6347a978$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9b9e6d0f6347a978$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9b9e6d0f6347a978$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9b9e6d0f6347a978$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9b9e6d0f6347a978$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9b9e6d0f6347a978$var$p(163));
                }
                $9b9e6d0f6347a978$var$U || b.flags & 512 && $9b9e6d0f6347a978$var$Sj(b);
            } catch (r) {
                $9b9e6d0f6347a978$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $9b9e6d0f6347a978$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9b9e6d0f6347a978$var$V = c;
            break;
        }
        $9b9e6d0f6347a978$var$V = b.return;
    }
}
function $9b9e6d0f6347a978$var$hk(a) {
    for(; null !== $9b9e6d0f6347a978$var$V;){
        var b = $9b9e6d0f6347a978$var$V;
        if (b === a) {
            $9b9e6d0f6347a978$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9b9e6d0f6347a978$var$V = c;
            break;
        }
        $9b9e6d0f6347a978$var$V = b.return;
    }
}
function $9b9e6d0f6347a978$var$kk(a) {
    for(; null !== $9b9e6d0f6347a978$var$V;){
        var b = $9b9e6d0f6347a978$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $9b9e6d0f6347a978$var$Rj(4, b);
                    } catch (k) {
                        $9b9e6d0f6347a978$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9b9e6d0f6347a978$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $9b9e6d0f6347a978$var$Sj(b);
                    } catch (k) {
                        $9b9e6d0f6347a978$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $9b9e6d0f6347a978$var$Sj(b);
                    } catch (k) {
                        $9b9e6d0f6347a978$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9b9e6d0f6347a978$var$W(b, b.return, k);
        }
        if (b === a) {
            $9b9e6d0f6347a978$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $9b9e6d0f6347a978$var$V = h;
            break;
        }
        $9b9e6d0f6347a978$var$V = b.return;
    }
}
var $9b9e6d0f6347a978$var$mk = Math.ceil, $9b9e6d0f6347a978$var$nk = $9b9e6d0f6347a978$var$ua.ReactCurrentDispatcher, $9b9e6d0f6347a978$var$ok = $9b9e6d0f6347a978$var$ua.ReactCurrentOwner, $9b9e6d0f6347a978$var$pk = $9b9e6d0f6347a978$var$ua.ReactCurrentBatchConfig, $9b9e6d0f6347a978$var$K = 0, $9b9e6d0f6347a978$var$R = null, $9b9e6d0f6347a978$var$Y = null, $9b9e6d0f6347a978$var$Z = 0, $9b9e6d0f6347a978$var$gj = 0, $9b9e6d0f6347a978$var$fj = $9b9e6d0f6347a978$var$Uf(0), $9b9e6d0f6347a978$var$T = 0, $9b9e6d0f6347a978$var$qk = null, $9b9e6d0f6347a978$var$hh = 0, $9b9e6d0f6347a978$var$rk = 0, $9b9e6d0f6347a978$var$sk = 0, $9b9e6d0f6347a978$var$tk = null, $9b9e6d0f6347a978$var$uk = null, $9b9e6d0f6347a978$var$gk = 0, $9b9e6d0f6347a978$var$Hj = Infinity, $9b9e6d0f6347a978$var$vk = null, $9b9e6d0f6347a978$var$Pi = !1, $9b9e6d0f6347a978$var$Qi = null, $9b9e6d0f6347a978$var$Si = null, $9b9e6d0f6347a978$var$wk = !1, $9b9e6d0f6347a978$var$xk = null, $9b9e6d0f6347a978$var$yk = 0, $9b9e6d0f6347a978$var$zk = 0, $9b9e6d0f6347a978$var$Ak = null, $9b9e6d0f6347a978$var$Bk = -1, $9b9e6d0f6347a978$var$Ck = 0;
function $9b9e6d0f6347a978$var$L() {
    return 0 !== ($9b9e6d0f6347a978$var$K & 6) ? $9b9e6d0f6347a978$var$B() : -1 !== $9b9e6d0f6347a978$var$Bk ? $9b9e6d0f6347a978$var$Bk : $9b9e6d0f6347a978$var$Bk = $9b9e6d0f6347a978$var$B();
}
function $9b9e6d0f6347a978$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9b9e6d0f6347a978$var$K & 2) && 0 !== $9b9e6d0f6347a978$var$Z) return $9b9e6d0f6347a978$var$Z & -$9b9e6d0f6347a978$var$Z;
    if (null !== $9b9e6d0f6347a978$var$Kg.transition) return 0 === $9b9e6d0f6347a978$var$Ck && ($9b9e6d0f6347a978$var$Ck = $9b9e6d0f6347a978$var$yc()), $9b9e6d0f6347a978$var$Ck;
    a = $9b9e6d0f6347a978$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9b9e6d0f6347a978$var$jd(a.type);
    return a;
}
function $9b9e6d0f6347a978$var$mh(a, b, c, d) {
    if (50 < $9b9e6d0f6347a978$var$zk) throw $9b9e6d0f6347a978$var$zk = 0, $9b9e6d0f6347a978$var$Ak = null, Error($9b9e6d0f6347a978$var$p(185));
    $9b9e6d0f6347a978$var$Ac(a, c, d);
    if (0 === ($9b9e6d0f6347a978$var$K & 2) || a !== $9b9e6d0f6347a978$var$R) a === $9b9e6d0f6347a978$var$R && (0 === ($9b9e6d0f6347a978$var$K & 2) && ($9b9e6d0f6347a978$var$rk |= c), 4 === $9b9e6d0f6347a978$var$T && $9b9e6d0f6347a978$var$Dk(a, $9b9e6d0f6347a978$var$Z)), $9b9e6d0f6347a978$var$Ek(a, d), 1 === c && 0 === $9b9e6d0f6347a978$var$K && 0 === (b.mode & 1) && ($9b9e6d0f6347a978$var$Hj = $9b9e6d0f6347a978$var$B() + 500, $9b9e6d0f6347a978$var$fg && $9b9e6d0f6347a978$var$jg());
}
function $9b9e6d0f6347a978$var$Ek(a, b) {
    var c = a.callbackNode;
    $9b9e6d0f6347a978$var$wc(a, b);
    var d = $9b9e6d0f6347a978$var$uc(a, a === $9b9e6d0f6347a978$var$R ? $9b9e6d0f6347a978$var$Z : 0);
    if (0 === d) null !== c && $9b9e6d0f6347a978$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9b9e6d0f6347a978$var$bc(c);
        if (1 === b) 0 === a.tag ? $9b9e6d0f6347a978$var$ig($9b9e6d0f6347a978$var$Fk.bind(null, a)) : $9b9e6d0f6347a978$var$hg($9b9e6d0f6347a978$var$Fk.bind(null, a)), $9b9e6d0f6347a978$var$Jf(function() {
            0 === ($9b9e6d0f6347a978$var$K & 6) && $9b9e6d0f6347a978$var$jg();
        }), c = null;
        else {
            switch($9b9e6d0f6347a978$var$Dc(d)){
                case 1:
                    c = $9b9e6d0f6347a978$var$fc;
                    break;
                case 4:
                    c = $9b9e6d0f6347a978$var$gc;
                    break;
                case 16:
                    c = $9b9e6d0f6347a978$var$hc;
                    break;
                case 536870912:
                    c = $9b9e6d0f6347a978$var$jc;
                    break;
                default:
                    c = $9b9e6d0f6347a978$var$hc;
            }
            c = $9b9e6d0f6347a978$var$Gk(c, $9b9e6d0f6347a978$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9b9e6d0f6347a978$var$Hk(a, b) {
    $9b9e6d0f6347a978$var$Bk = -1;
    $9b9e6d0f6347a978$var$Ck = 0;
    if (0 !== ($9b9e6d0f6347a978$var$K & 6)) throw Error($9b9e6d0f6347a978$var$p(327));
    var c = a.callbackNode;
    if ($9b9e6d0f6347a978$var$Ik() && a.callbackNode !== c) return null;
    var d = $9b9e6d0f6347a978$var$uc(a, a === $9b9e6d0f6347a978$var$R ? $9b9e6d0f6347a978$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9b9e6d0f6347a978$var$Jk(a, d);
    else {
        b = d;
        var e = $9b9e6d0f6347a978$var$K;
        $9b9e6d0f6347a978$var$K |= 2;
        var f = $9b9e6d0f6347a978$var$Kk();
        if ($9b9e6d0f6347a978$var$R !== a || $9b9e6d0f6347a978$var$Z !== b) $9b9e6d0f6347a978$var$vk = null, $9b9e6d0f6347a978$var$Hj = $9b9e6d0f6347a978$var$B() + 500, $9b9e6d0f6347a978$var$Lk(a, b);
        for(;;)try {
            $9b9e6d0f6347a978$var$Mk();
            break;
        } catch (h) {
            $9b9e6d0f6347a978$var$Nk(a, h);
        }
        $9b9e6d0f6347a978$var$Qg();
        $9b9e6d0f6347a978$var$nk.current = f;
        $9b9e6d0f6347a978$var$K = e;
        null !== $9b9e6d0f6347a978$var$Y ? b = 0 : ($9b9e6d0f6347a978$var$R = null, $9b9e6d0f6347a978$var$Z = 0, b = $9b9e6d0f6347a978$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9b9e6d0f6347a978$var$xc(a), 0 !== e && (d = e, b = $9b9e6d0f6347a978$var$Ok(a, e)));
        if (1 === b) throw c = $9b9e6d0f6347a978$var$qk, $9b9e6d0f6347a978$var$Lk(a, 0), $9b9e6d0f6347a978$var$Dk(a, d), $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B()), c;
        if (6 === b) $9b9e6d0f6347a978$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9b9e6d0f6347a978$var$Pk(e) && (b = $9b9e6d0f6347a978$var$Jk(a, d), 2 === b && (f = $9b9e6d0f6347a978$var$xc(a), 0 !== f && (d = f, b = $9b9e6d0f6347a978$var$Ok(a, f))), 1 === b)) throw c = $9b9e6d0f6347a978$var$qk, $9b9e6d0f6347a978$var$Lk(a, 0), $9b9e6d0f6347a978$var$Dk(a, d), $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9b9e6d0f6347a978$var$p(345));
                case 2:
                    $9b9e6d0f6347a978$var$Qk(a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk);
                    break;
                case 3:
                    $9b9e6d0f6347a978$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $9b9e6d0f6347a978$var$gk + 500 - $9b9e6d0f6347a978$var$B(), 10 < b)) {
                        if (0 !== $9b9e6d0f6347a978$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9b9e6d0f6347a978$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9b9e6d0f6347a978$var$Ff($9b9e6d0f6347a978$var$Qk.bind(null, a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk), b);
                        break;
                    }
                    $9b9e6d0f6347a978$var$Qk(a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk);
                    break;
                case 4:
                    $9b9e6d0f6347a978$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9b9e6d0f6347a978$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9b9e6d0f6347a978$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9b9e6d0f6347a978$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9b9e6d0f6347a978$var$Ff($9b9e6d0f6347a978$var$Qk.bind(null, a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk), d);
                        break;
                    }
                    $9b9e6d0f6347a978$var$Qk(a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk);
                    break;
                case 5:
                    $9b9e6d0f6347a978$var$Qk(a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk);
                    break;
                default:
                    throw Error($9b9e6d0f6347a978$var$p(329));
            }
        }
    }
    $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B());
    return a.callbackNode === c ? $9b9e6d0f6347a978$var$Hk.bind(null, a) : null;
}
function $9b9e6d0f6347a978$var$Ok(a, b) {
    var c = $9b9e6d0f6347a978$var$tk;
    a.current.memoizedState.isDehydrated && ($9b9e6d0f6347a978$var$Lk(a, b).flags |= 256);
    a = $9b9e6d0f6347a978$var$Jk(a, b);
    2 !== a && (b = $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$uk = c, null !== b && $9b9e6d0f6347a978$var$Gj(b));
    return a;
}
function $9b9e6d0f6347a978$var$Gj(a) {
    null === $9b9e6d0f6347a978$var$uk ? $9b9e6d0f6347a978$var$uk = a : $9b9e6d0f6347a978$var$uk.push.apply($9b9e6d0f6347a978$var$uk, a);
}
function $9b9e6d0f6347a978$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9b9e6d0f6347a978$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $9b9e6d0f6347a978$var$Dk(a, b) {
    b &= ~$9b9e6d0f6347a978$var$sk;
    b &= ~$9b9e6d0f6347a978$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9b9e6d0f6347a978$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9b9e6d0f6347a978$var$Fk(a) {
    if (0 !== ($9b9e6d0f6347a978$var$K & 6)) throw Error($9b9e6d0f6347a978$var$p(327));
    $9b9e6d0f6347a978$var$Ik();
    var b = $9b9e6d0f6347a978$var$uc(a, 0);
    if (0 === (b & 1)) return $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B()), null;
    var c = $9b9e6d0f6347a978$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9b9e6d0f6347a978$var$xc(a);
        0 !== d && (b = d, c = $9b9e6d0f6347a978$var$Ok(a, d));
    }
    if (1 === c) throw c = $9b9e6d0f6347a978$var$qk, $9b9e6d0f6347a978$var$Lk(a, 0), $9b9e6d0f6347a978$var$Dk(a, b), $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B()), c;
    if (6 === c) throw Error($9b9e6d0f6347a978$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9b9e6d0f6347a978$var$Qk(a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk);
    $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B());
    return null;
}
function $9b9e6d0f6347a978$var$Rk(a, b) {
    var c = $9b9e6d0f6347a978$var$K;
    $9b9e6d0f6347a978$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9b9e6d0f6347a978$var$K = c, 0 === $9b9e6d0f6347a978$var$K && ($9b9e6d0f6347a978$var$Hj = $9b9e6d0f6347a978$var$B() + 500, $9b9e6d0f6347a978$var$fg && $9b9e6d0f6347a978$var$jg());
    }
}
function $9b9e6d0f6347a978$var$Sk(a) {
    null !== $9b9e6d0f6347a978$var$xk && 0 === $9b9e6d0f6347a978$var$xk.tag && 0 === ($9b9e6d0f6347a978$var$K & 6) && $9b9e6d0f6347a978$var$Ik();
    var b = $9b9e6d0f6347a978$var$K;
    $9b9e6d0f6347a978$var$K |= 1;
    var c = $9b9e6d0f6347a978$var$pk.transition, d = $9b9e6d0f6347a978$var$C;
    try {
        if ($9b9e6d0f6347a978$var$pk.transition = null, $9b9e6d0f6347a978$var$C = 1, a) return a();
    } finally{
        $9b9e6d0f6347a978$var$C = d, $9b9e6d0f6347a978$var$pk.transition = c, $9b9e6d0f6347a978$var$K = b, 0 === ($9b9e6d0f6347a978$var$K & 6) && $9b9e6d0f6347a978$var$jg();
    }
}
function $9b9e6d0f6347a978$var$Ij() {
    $9b9e6d0f6347a978$var$gj = $9b9e6d0f6347a978$var$fj.current;
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$fj);
}
function $9b9e6d0f6347a978$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9b9e6d0f6347a978$var$Gf(c));
    if (null !== $9b9e6d0f6347a978$var$Y) for(c = $9b9e6d0f6347a978$var$Y.return; null !== c;){
        var d = c;
        $9b9e6d0f6347a978$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9b9e6d0f6347a978$var$$f();
                break;
            case 3:
                $9b9e6d0f6347a978$var$Jh();
                $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf);
                $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$H);
                $9b9e6d0f6347a978$var$Oh();
                break;
            case 5:
                $9b9e6d0f6347a978$var$Lh(d);
                break;
            case 4:
                $9b9e6d0f6347a978$var$Jh();
                break;
            case 13:
                $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M);
                break;
            case 19:
                $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M);
                break;
            case 10:
                $9b9e6d0f6347a978$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $9b9e6d0f6347a978$var$Ij();
        }
        c = c.return;
    }
    $9b9e6d0f6347a978$var$R = a;
    $9b9e6d0f6347a978$var$Y = a = $9b9e6d0f6347a978$var$wh(a.current, null);
    $9b9e6d0f6347a978$var$Z = $9b9e6d0f6347a978$var$gj = b;
    $9b9e6d0f6347a978$var$T = 0;
    $9b9e6d0f6347a978$var$qk = null;
    $9b9e6d0f6347a978$var$sk = $9b9e6d0f6347a978$var$rk = $9b9e6d0f6347a978$var$hh = 0;
    $9b9e6d0f6347a978$var$uk = $9b9e6d0f6347a978$var$tk = null;
    if (null !== $9b9e6d0f6347a978$var$Wg) {
        for(b = 0; b < $9b9e6d0f6347a978$var$Wg.length; b++)if (c = $9b9e6d0f6347a978$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9b9e6d0f6347a978$var$Wg = null;
    }
    return a;
}
function $9b9e6d0f6347a978$var$Nk(a, b) {
    do {
        var c = $9b9e6d0f6347a978$var$Y;
        try {
            $9b9e6d0f6347a978$var$Qg();
            $9b9e6d0f6347a978$var$Ph.current = $9b9e6d0f6347a978$var$ai;
            if ($9b9e6d0f6347a978$var$Sh) {
                for(var d = $9b9e6d0f6347a978$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9b9e6d0f6347a978$var$Sh = !1;
            }
            $9b9e6d0f6347a978$var$Rh = 0;
            $9b9e6d0f6347a978$var$P = $9b9e6d0f6347a978$var$O = $9b9e6d0f6347a978$var$N = null;
            $9b9e6d0f6347a978$var$Th = !1;
            $9b9e6d0f6347a978$var$Uh = 0;
            $9b9e6d0f6347a978$var$ok.current = null;
            if (null === c || null === c.return) {
                $9b9e6d0f6347a978$var$T = 1;
                $9b9e6d0f6347a978$var$qk = b;
                $9b9e6d0f6347a978$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $9b9e6d0f6347a978$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9b9e6d0f6347a978$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9b9e6d0f6347a978$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $9b9e6d0f6347a978$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9b9e6d0f6347a978$var$Ti(f, l, b);
                            $9b9e6d0f6347a978$var$uj();
                            break a;
                        }
                        k = Error($9b9e6d0f6347a978$var$p(426));
                    }
                } else if ($9b9e6d0f6347a978$var$I && h.mode & 1) {
                    var J = $9b9e6d0f6347a978$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9b9e6d0f6347a978$var$Wi(J, g, h, f, b);
                        $9b9e6d0f6347a978$var$Jg($9b9e6d0f6347a978$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $9b9e6d0f6347a978$var$Ki(k, h);
                4 !== $9b9e6d0f6347a978$var$T && ($9b9e6d0f6347a978$var$T = 2);
                null === $9b9e6d0f6347a978$var$tk ? $9b9e6d0f6347a978$var$tk = [
                    f
                ] : $9b9e6d0f6347a978$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9b9e6d0f6347a978$var$Oi(f, k, b);
                            $9b9e6d0f6347a978$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9b9e6d0f6347a978$var$Si || !$9b9e6d0f6347a978$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9b9e6d0f6347a978$var$Ri(f, h, b);
                                $9b9e6d0f6347a978$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $9b9e6d0f6347a978$var$Tk(c);
        } catch (na) {
            b = na;
            $9b9e6d0f6347a978$var$Y === c && null !== c && ($9b9e6d0f6347a978$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $9b9e6d0f6347a978$var$Kk() {
    var a = $9b9e6d0f6347a978$var$nk.current;
    $9b9e6d0f6347a978$var$nk.current = $9b9e6d0f6347a978$var$ai;
    return null === a ? $9b9e6d0f6347a978$var$ai : a;
}
function $9b9e6d0f6347a978$var$uj() {
    if (0 === $9b9e6d0f6347a978$var$T || 3 === $9b9e6d0f6347a978$var$T || 2 === $9b9e6d0f6347a978$var$T) $9b9e6d0f6347a978$var$T = 4;
    null === $9b9e6d0f6347a978$var$R || 0 === ($9b9e6d0f6347a978$var$hh & 268435455) && 0 === ($9b9e6d0f6347a978$var$rk & 268435455) || $9b9e6d0f6347a978$var$Dk($9b9e6d0f6347a978$var$R, $9b9e6d0f6347a978$var$Z);
}
function $9b9e6d0f6347a978$var$Jk(a, b) {
    var c = $9b9e6d0f6347a978$var$K;
    $9b9e6d0f6347a978$var$K |= 2;
    var d = $9b9e6d0f6347a978$var$Kk();
    if ($9b9e6d0f6347a978$var$R !== a || $9b9e6d0f6347a978$var$Z !== b) $9b9e6d0f6347a978$var$vk = null, $9b9e6d0f6347a978$var$Lk(a, b);
    for(;;)try {
        $9b9e6d0f6347a978$var$Uk();
        break;
    } catch (e) {
        $9b9e6d0f6347a978$var$Nk(a, e);
    }
    $9b9e6d0f6347a978$var$Qg();
    $9b9e6d0f6347a978$var$K = c;
    $9b9e6d0f6347a978$var$nk.current = d;
    if (null !== $9b9e6d0f6347a978$var$Y) throw Error($9b9e6d0f6347a978$var$p(261));
    $9b9e6d0f6347a978$var$R = null;
    $9b9e6d0f6347a978$var$Z = 0;
    return $9b9e6d0f6347a978$var$T;
}
function $9b9e6d0f6347a978$var$Uk() {
    for(; null !== $9b9e6d0f6347a978$var$Y;)$9b9e6d0f6347a978$var$Vk($9b9e6d0f6347a978$var$Y);
}
function $9b9e6d0f6347a978$var$Mk() {
    for(; null !== $9b9e6d0f6347a978$var$Y && !$9b9e6d0f6347a978$var$cc();)$9b9e6d0f6347a978$var$Vk($9b9e6d0f6347a978$var$Y);
}
function $9b9e6d0f6347a978$var$Vk(a) {
    var b = $9b9e6d0f6347a978$var$Wk(a.alternate, a, $9b9e6d0f6347a978$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9b9e6d0f6347a978$var$Tk(a) : $9b9e6d0f6347a978$var$Y = b;
    $9b9e6d0f6347a978$var$ok.current = null;
}
function $9b9e6d0f6347a978$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $9b9e6d0f6347a978$var$Fj(c, b, $9b9e6d0f6347a978$var$gj), null !== c) {
                $9b9e6d0f6347a978$var$Y = c;
                return;
            }
        } else {
            c = $9b9e6d0f6347a978$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9b9e6d0f6347a978$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9b9e6d0f6347a978$var$T = 6;
                $9b9e6d0f6347a978$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9b9e6d0f6347a978$var$Y = b;
            return;
        }
        $9b9e6d0f6347a978$var$Y = b = a;
    }while (null !== b);
    0 === $9b9e6d0f6347a978$var$T && ($9b9e6d0f6347a978$var$T = 5);
}
function $9b9e6d0f6347a978$var$Qk(a, b, c) {
    var d = $9b9e6d0f6347a978$var$C, e = $9b9e6d0f6347a978$var$pk.transition;
    try {
        $9b9e6d0f6347a978$var$pk.transition = null, $9b9e6d0f6347a978$var$C = 1, $9b9e6d0f6347a978$var$Xk(a, b, c, d);
    } finally{
        $9b9e6d0f6347a978$var$pk.transition = e, $9b9e6d0f6347a978$var$C = d;
    }
    return null;
}
function $9b9e6d0f6347a978$var$Xk(a, b, c, d) {
    do $9b9e6d0f6347a978$var$Ik();
    while (null !== $9b9e6d0f6347a978$var$xk);
    if (0 !== ($9b9e6d0f6347a978$var$K & 6)) throw Error($9b9e6d0f6347a978$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9b9e6d0f6347a978$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9b9e6d0f6347a978$var$Bc(a, f);
    a === $9b9e6d0f6347a978$var$R && ($9b9e6d0f6347a978$var$Y = $9b9e6d0f6347a978$var$R = null, $9b9e6d0f6347a978$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9b9e6d0f6347a978$var$wk || ($9b9e6d0f6347a978$var$wk = !0, $9b9e6d0f6347a978$var$Gk($9b9e6d0f6347a978$var$hc, function() {
        $9b9e6d0f6347a978$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9b9e6d0f6347a978$var$pk.transition;
        $9b9e6d0f6347a978$var$pk.transition = null;
        var g = $9b9e6d0f6347a978$var$C;
        $9b9e6d0f6347a978$var$C = 1;
        var h = $9b9e6d0f6347a978$var$K;
        $9b9e6d0f6347a978$var$K |= 4;
        $9b9e6d0f6347a978$var$ok.current = null;
        $9b9e6d0f6347a978$var$Pj(a, c);
        $9b9e6d0f6347a978$var$ek(c, a);
        $9b9e6d0f6347a978$var$Oe($9b9e6d0f6347a978$var$Df);
        $9b9e6d0f6347a978$var$dd = !!$9b9e6d0f6347a978$var$Cf;
        $9b9e6d0f6347a978$var$Df = $9b9e6d0f6347a978$var$Cf = null;
        a.current = c;
        $9b9e6d0f6347a978$var$ik(c, a, e);
        $9b9e6d0f6347a978$var$dc();
        $9b9e6d0f6347a978$var$K = h;
        $9b9e6d0f6347a978$var$C = g;
        $9b9e6d0f6347a978$var$pk.transition = f;
    } else a.current = c;
    $9b9e6d0f6347a978$var$wk && ($9b9e6d0f6347a978$var$wk = !1, $9b9e6d0f6347a978$var$xk = a, $9b9e6d0f6347a978$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($9b9e6d0f6347a978$var$Si = null);
    $9b9e6d0f6347a978$var$mc(c.stateNode, d);
    $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9b9e6d0f6347a978$var$Pi) throw $9b9e6d0f6347a978$var$Pi = !1, a = $9b9e6d0f6347a978$var$Qi, $9b9e6d0f6347a978$var$Qi = null, a;
    0 !== ($9b9e6d0f6347a978$var$yk & 1) && 0 !== a.tag && $9b9e6d0f6347a978$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9b9e6d0f6347a978$var$Ak ? $9b9e6d0f6347a978$var$zk++ : ($9b9e6d0f6347a978$var$zk = 0, $9b9e6d0f6347a978$var$Ak = a) : $9b9e6d0f6347a978$var$zk = 0;
    $9b9e6d0f6347a978$var$jg();
    return null;
}
function $9b9e6d0f6347a978$var$Ik() {
    if (null !== $9b9e6d0f6347a978$var$xk) {
        var a = $9b9e6d0f6347a978$var$Dc($9b9e6d0f6347a978$var$yk), b = $9b9e6d0f6347a978$var$pk.transition, c = $9b9e6d0f6347a978$var$C;
        try {
            $9b9e6d0f6347a978$var$pk.transition = null;
            $9b9e6d0f6347a978$var$C = 16 > a ? 16 : a;
            if (null === $9b9e6d0f6347a978$var$xk) var d = !1;
            else {
                a = $9b9e6d0f6347a978$var$xk;
                $9b9e6d0f6347a978$var$xk = null;
                $9b9e6d0f6347a978$var$yk = 0;
                if (0 !== ($9b9e6d0f6347a978$var$K & 6)) throw Error($9b9e6d0f6347a978$var$p(331));
                var e = $9b9e6d0f6347a978$var$K;
                $9b9e6d0f6347a978$var$K |= 4;
                for($9b9e6d0f6347a978$var$V = a.current; null !== $9b9e6d0f6347a978$var$V;){
                    var f = $9b9e6d0f6347a978$var$V, g = f.child;
                    if (0 !== ($9b9e6d0f6347a978$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9b9e6d0f6347a978$var$V = l; null !== $9b9e6d0f6347a978$var$V;){
                                    var m = $9b9e6d0f6347a978$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9b9e6d0f6347a978$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $9b9e6d0f6347a978$var$V = q;
                                    else for(; null !== $9b9e6d0f6347a978$var$V;){
                                        m = $9b9e6d0f6347a978$var$V;
                                        var r = m.sibling, y = m.return;
                                        $9b9e6d0f6347a978$var$Tj(m);
                                        if (m === l) {
                                            $9b9e6d0f6347a978$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $9b9e6d0f6347a978$var$V = r;
                                            break;
                                        }
                                        $9b9e6d0f6347a978$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9b9e6d0f6347a978$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $9b9e6d0f6347a978$var$V = g;
                    else b: for(; null !== $9b9e6d0f6347a978$var$V;){
                        f = $9b9e6d0f6347a978$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9b9e6d0f6347a978$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $9b9e6d0f6347a978$var$V = x;
                            break b;
                        }
                        $9b9e6d0f6347a978$var$V = f.return;
                    }
                }
                var w = a.current;
                for($9b9e6d0f6347a978$var$V = w; null !== $9b9e6d0f6347a978$var$V;){
                    g = $9b9e6d0f6347a978$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $9b9e6d0f6347a978$var$V = u;
                    else b: for(g = w; null !== $9b9e6d0f6347a978$var$V;){
                        h = $9b9e6d0f6347a978$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9b9e6d0f6347a978$var$Rj(9, h);
                            }
                        } catch (na) {
                            $9b9e6d0f6347a978$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $9b9e6d0f6347a978$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $9b9e6d0f6347a978$var$V = F;
                            break b;
                        }
                        $9b9e6d0f6347a978$var$V = h.return;
                    }
                }
                $9b9e6d0f6347a978$var$K = e;
                $9b9e6d0f6347a978$var$jg();
                if ($9b9e6d0f6347a978$var$lc && "function" === typeof $9b9e6d0f6347a978$var$lc.onPostCommitFiberRoot) try {
                    $9b9e6d0f6347a978$var$lc.onPostCommitFiberRoot($9b9e6d0f6347a978$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9b9e6d0f6347a978$var$C = c, $9b9e6d0f6347a978$var$pk.transition = b;
        }
    }
    return !1;
}
function $9b9e6d0f6347a978$var$Yk(a, b, c) {
    b = $9b9e6d0f6347a978$var$Ki(c, b);
    b = $9b9e6d0f6347a978$var$Oi(a, b, 1);
    a = $9b9e6d0f6347a978$var$dh(a, b, 1);
    b = $9b9e6d0f6347a978$var$L();
    null !== a && ($9b9e6d0f6347a978$var$Ac(a, 1, b), $9b9e6d0f6347a978$var$Ek(a, b));
}
function $9b9e6d0f6347a978$var$W(a, b, c) {
    if (3 === a.tag) $9b9e6d0f6347a978$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9b9e6d0f6347a978$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9b9e6d0f6347a978$var$Si || !$9b9e6d0f6347a978$var$Si.has(d))) {
                a = $9b9e6d0f6347a978$var$Ki(c, a);
                a = $9b9e6d0f6347a978$var$Ri(b, a, 1);
                b = $9b9e6d0f6347a978$var$dh(b, a, 1);
                a = $9b9e6d0f6347a978$var$L();
                null !== b && ($9b9e6d0f6347a978$var$Ac(b, 1, a), $9b9e6d0f6347a978$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $9b9e6d0f6347a978$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $9b9e6d0f6347a978$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $9b9e6d0f6347a978$var$R === a && ($9b9e6d0f6347a978$var$Z & c) === c && (4 === $9b9e6d0f6347a978$var$T || 3 === $9b9e6d0f6347a978$var$T && ($9b9e6d0f6347a978$var$Z & 130023424) === $9b9e6d0f6347a978$var$Z && 500 > $9b9e6d0f6347a978$var$B() - $9b9e6d0f6347a978$var$gk ? $9b9e6d0f6347a978$var$Lk(a, 0) : $9b9e6d0f6347a978$var$sk |= c);
    $9b9e6d0f6347a978$var$Ek(a, b);
}
function $9b9e6d0f6347a978$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9b9e6d0f6347a978$var$sc, $9b9e6d0f6347a978$var$sc <<= 1, 0 === ($9b9e6d0f6347a978$var$sc & 130023424) && ($9b9e6d0f6347a978$var$sc = 4194304)));
    var c = $9b9e6d0f6347a978$var$L();
    a = $9b9e6d0f6347a978$var$Zg(a, b);
    null !== a && ($9b9e6d0f6347a978$var$Ac(a, b, c), $9b9e6d0f6347a978$var$Ek(a, c));
}
function $9b9e6d0f6347a978$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9b9e6d0f6347a978$var$Zk(a, c);
}
function $9b9e6d0f6347a978$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9b9e6d0f6347a978$var$p(314));
    }
    null !== d && d.delete(b);
    $9b9e6d0f6347a978$var$Zk(a, c);
}
var $9b9e6d0f6347a978$var$Wk;
$9b9e6d0f6347a978$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9b9e6d0f6347a978$var$Wf.current) $9b9e6d0f6347a978$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9b9e6d0f6347a978$var$Ug = !1, $9b9e6d0f6347a978$var$zj(a, b, c);
            $9b9e6d0f6347a978$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9b9e6d0f6347a978$var$Ug = !1, $9b9e6d0f6347a978$var$I && 0 !== (b.flags & 1048576) && $9b9e6d0f6347a978$var$ug(b, $9b9e6d0f6347a978$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9b9e6d0f6347a978$var$jj(a, b);
            a = b.pendingProps;
            var e = $9b9e6d0f6347a978$var$Yf(b, $9b9e6d0f6347a978$var$H.current);
            $9b9e6d0f6347a978$var$Tg(b, c);
            e = $9b9e6d0f6347a978$var$Xh(null, b, d, a, e, c);
            var f = $9b9e6d0f6347a978$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9b9e6d0f6347a978$var$Zf(d) ? (f = !0, $9b9e6d0f6347a978$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9b9e6d0f6347a978$var$ah(b), e.updater = $9b9e6d0f6347a978$var$nh, b.stateNode = e, e._reactInternals = b, $9b9e6d0f6347a978$var$rh(b, d, a, c), b = $9b9e6d0f6347a978$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $9b9e6d0f6347a978$var$I && f && $9b9e6d0f6347a978$var$vg(b), $9b9e6d0f6347a978$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9b9e6d0f6347a978$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9b9e6d0f6347a978$var$$k(d);
                a = $9b9e6d0f6347a978$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $9b9e6d0f6347a978$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9b9e6d0f6347a978$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9b9e6d0f6347a978$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9b9e6d0f6347a978$var$aj(null, b, d, $9b9e6d0f6347a978$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($9b9e6d0f6347a978$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b9e6d0f6347a978$var$Lg(d, e), $9b9e6d0f6347a978$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b9e6d0f6347a978$var$Lg(d, e), $9b9e6d0f6347a978$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $9b9e6d0f6347a978$var$lj(b);
                if (null === a) throw Error($9b9e6d0f6347a978$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9b9e6d0f6347a978$var$bh(a, b);
                $9b9e6d0f6347a978$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9b9e6d0f6347a978$var$Ki(Error($9b9e6d0f6347a978$var$p(423)), b);
                        b = $9b9e6d0f6347a978$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9b9e6d0f6347a978$var$Ki(Error($9b9e6d0f6347a978$var$p(424)), b);
                        b = $9b9e6d0f6347a978$var$mj(a, b, d, c, e);
                        break a;
                    } else for($9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$Lf(b.stateNode.containerInfo.firstChild), $9b9e6d0f6347a978$var$xg = b, $9b9e6d0f6347a978$var$I = !0, $9b9e6d0f6347a978$var$zg = null, c = $9b9e6d0f6347a978$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9b9e6d0f6347a978$var$Ig();
                    if (d === e) {
                        b = $9b9e6d0f6347a978$var$$i(a, b, c);
                        break a;
                    }
                    $9b9e6d0f6347a978$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9b9e6d0f6347a978$var$Kh(b), null === a && $9b9e6d0f6347a978$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9b9e6d0f6347a978$var$Ef(d, e) ? g = null : null !== f && $9b9e6d0f6347a978$var$Ef(d, f) && (b.flags |= 32), $9b9e6d0f6347a978$var$hj(a, b), $9b9e6d0f6347a978$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $9b9e6d0f6347a978$var$Eg(b), null;
        case 13:
            return $9b9e6d0f6347a978$var$pj(a, b, c);
        case 4:
            return $9b9e6d0f6347a978$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9b9e6d0f6347a978$var$Bh(b, null, d, c) : $9b9e6d0f6347a978$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b9e6d0f6347a978$var$Lg(d, e), $9b9e6d0f6347a978$var$Zi(a, b, d, e, c);
        case 7:
            return $9b9e6d0f6347a978$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9b9e6d0f6347a978$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9b9e6d0f6347a978$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9b9e6d0f6347a978$var$He(f.value, g)) {
                        if (f.children === e.children && !$9b9e6d0f6347a978$var$Wf.current) {
                            b = $9b9e6d0f6347a978$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9b9e6d0f6347a978$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9b9e6d0f6347a978$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($9b9e6d0f6347a978$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9b9e6d0f6347a978$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $9b9e6d0f6347a978$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9b9e6d0f6347a978$var$Tg(b, c), e = $9b9e6d0f6347a978$var$Vg(e), d = d(e), b.flags |= 1, $9b9e6d0f6347a978$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9b9e6d0f6347a978$var$Lg(d, b.pendingProps), e = $9b9e6d0f6347a978$var$Lg(d.type, e), $9b9e6d0f6347a978$var$aj(a, b, d, e, c);
        case 15:
            return $9b9e6d0f6347a978$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b9e6d0f6347a978$var$Lg(d, e), $9b9e6d0f6347a978$var$jj(a, b), b.tag = 1, $9b9e6d0f6347a978$var$Zf(d) ? (a = !0, $9b9e6d0f6347a978$var$cg(b)) : a = !1, $9b9e6d0f6347a978$var$Tg(b, c), $9b9e6d0f6347a978$var$ph(b, d, e), $9b9e6d0f6347a978$var$rh(b, d, e, c), $9b9e6d0f6347a978$var$kj(null, b, d, !0, a, c);
        case 19:
            return $9b9e6d0f6347a978$var$yj(a, b, c);
        case 22:
            return $9b9e6d0f6347a978$var$ej(a, b, c);
    }
    throw Error($9b9e6d0f6347a978$var$p(156, b.tag));
};
function $9b9e6d0f6347a978$var$Gk(a, b) {
    return $9b9e6d0f6347a978$var$ac(a, b);
}
function $9b9e6d0f6347a978$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9b9e6d0f6347a978$var$Bg(a, b, c, d) {
    return new $9b9e6d0f6347a978$var$al(a, b, c, d);
}
function $9b9e6d0f6347a978$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9b9e6d0f6347a978$var$$k(a) {
    if ("function" === typeof a) return $9b9e6d0f6347a978$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9b9e6d0f6347a978$var$Da) return 11;
        if (a === $9b9e6d0f6347a978$var$Ga) return 14;
    }
    return 2;
}
function $9b9e6d0f6347a978$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $9b9e6d0f6347a978$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9b9e6d0f6347a978$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9b9e6d0f6347a978$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9b9e6d0f6347a978$var$ya:
            return $9b9e6d0f6347a978$var$Ah(c.children, e, f, b);
        case $9b9e6d0f6347a978$var$za:
            g = 8;
            e |= 8;
            break;
        case $9b9e6d0f6347a978$var$Aa:
            return a = $9b9e6d0f6347a978$var$Bg(12, c, b, e | 2), a.elementType = $9b9e6d0f6347a978$var$Aa, a.lanes = f, a;
        case $9b9e6d0f6347a978$var$Ea:
            return a = $9b9e6d0f6347a978$var$Bg(13, c, b, e), a.elementType = $9b9e6d0f6347a978$var$Ea, a.lanes = f, a;
        case $9b9e6d0f6347a978$var$Fa:
            return a = $9b9e6d0f6347a978$var$Bg(19, c, b, e), a.elementType = $9b9e6d0f6347a978$var$Fa, a.lanes = f, a;
        case $9b9e6d0f6347a978$var$Ia:
            return $9b9e6d0f6347a978$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9b9e6d0f6347a978$var$Ba:
                    g = 10;
                    break a;
                case $9b9e6d0f6347a978$var$Ca:
                    g = 9;
                    break a;
                case $9b9e6d0f6347a978$var$Da:
                    g = 11;
                    break a;
                case $9b9e6d0f6347a978$var$Ga:
                    g = 14;
                    break a;
                case $9b9e6d0f6347a978$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9b9e6d0f6347a978$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $9b9e6d0f6347a978$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9b9e6d0f6347a978$var$Ah(a, b, c, d) {
    a = $9b9e6d0f6347a978$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9b9e6d0f6347a978$var$qj(a, b, c, d) {
    a = $9b9e6d0f6347a978$var$Bg(22, a, d, b);
    a.elementType = $9b9e6d0f6347a978$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9b9e6d0f6347a978$var$xh(a, b, c) {
    a = $9b9e6d0f6347a978$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9b9e6d0f6347a978$var$zh(a, b, c) {
    b = $9b9e6d0f6347a978$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9b9e6d0f6347a978$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9b9e6d0f6347a978$var$zc(0);
    this.expirationTimes = $9b9e6d0f6347a978$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9b9e6d0f6347a978$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9b9e6d0f6347a978$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $9b9e6d0f6347a978$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9b9e6d0f6347a978$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9b9e6d0f6347a978$var$ah(f);
    return a;
}
function $9b9e6d0f6347a978$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9b9e6d0f6347a978$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9b9e6d0f6347a978$var$el(a) {
    if (!a) return $9b9e6d0f6347a978$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9b9e6d0f6347a978$var$Vb(a) !== a || 1 !== a.tag) throw Error($9b9e6d0f6347a978$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9b9e6d0f6347a978$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($9b9e6d0f6347a978$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9b9e6d0f6347a978$var$Zf(c)) return $9b9e6d0f6347a978$var$bg(a, c, b);
    }
    return b;
}
function $9b9e6d0f6347a978$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $9b9e6d0f6347a978$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $9b9e6d0f6347a978$var$el(null);
    c = a.current;
    d = $9b9e6d0f6347a978$var$L();
    e = $9b9e6d0f6347a978$var$lh(c);
    f = $9b9e6d0f6347a978$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9b9e6d0f6347a978$var$dh(c, f, e);
    a.current.lanes = e;
    $9b9e6d0f6347a978$var$Ac(a, e, d);
    $9b9e6d0f6347a978$var$Ek(a, d);
    return a;
}
function $9b9e6d0f6347a978$var$gl(a, b, c, d) {
    var e = b.current, f = $9b9e6d0f6347a978$var$L(), g = $9b9e6d0f6347a978$var$lh(e);
    c = $9b9e6d0f6347a978$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9b9e6d0f6347a978$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9b9e6d0f6347a978$var$dh(e, b, g);
    null !== a && ($9b9e6d0f6347a978$var$mh(a, e, g, f), $9b9e6d0f6347a978$var$eh(a, e, g));
    return g;
}
function $9b9e6d0f6347a978$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9b9e6d0f6347a978$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9b9e6d0f6347a978$var$jl(a, b) {
    $9b9e6d0f6347a978$var$il(a, b);
    (a = a.alternate) && $9b9e6d0f6347a978$var$il(a, b);
}
function $9b9e6d0f6347a978$var$kl() {
    return null;
}
var $9b9e6d0f6347a978$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $9b9e6d0f6347a978$var$ml(a) {
    this._internalRoot = a;
}
$9b9e6d0f6347a978$var$nl.prototype.render = $9b9e6d0f6347a978$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9b9e6d0f6347a978$var$p(409));
    $9b9e6d0f6347a978$var$gl(a, b, null, null);
};
$9b9e6d0f6347a978$var$nl.prototype.unmount = $9b9e6d0f6347a978$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9b9e6d0f6347a978$var$Sk(function() {
            $9b9e6d0f6347a978$var$gl(null, a, null, null);
        });
        b[$9b9e6d0f6347a978$var$uf] = null;
    }
};
function $9b9e6d0f6347a978$var$nl(a) {
    this._internalRoot = a;
}
$9b9e6d0f6347a978$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9b9e6d0f6347a978$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9b9e6d0f6347a978$var$Qc.length && 0 !== b && b < $9b9e6d0f6347a978$var$Qc[c].priority; c++);
        $9b9e6d0f6347a978$var$Qc.splice(c, 0, a);
        0 === c && $9b9e6d0f6347a978$var$Vc(a);
    }
};
function $9b9e6d0f6347a978$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9b9e6d0f6347a978$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9b9e6d0f6347a978$var$ql() {}
function $9b9e6d0f6347a978$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $9b9e6d0f6347a978$var$hl(g);
                f.call(a);
            };
        }
        var g = $9b9e6d0f6347a978$var$fl(b, d, a, 0, null, !1, !1, "", $9b9e6d0f6347a978$var$ql);
        a._reactRootContainer = g;
        a[$9b9e6d0f6347a978$var$uf] = g.current;
        $9b9e6d0f6347a978$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9b9e6d0f6347a978$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $9b9e6d0f6347a978$var$hl(k);
            h.call(a);
        };
    }
    var k = $9b9e6d0f6347a978$var$cl(a, 0, !1, null, null, !1, !1, "", $9b9e6d0f6347a978$var$ql);
    a._reactRootContainer = k;
    a[$9b9e6d0f6347a978$var$uf] = k.current;
    $9b9e6d0f6347a978$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9b9e6d0f6347a978$var$Sk(function() {
        $9b9e6d0f6347a978$var$gl(b, k, c, d);
    });
    return k;
}
function $9b9e6d0f6347a978$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $9b9e6d0f6347a978$var$hl(g);
                h.call(a);
            };
        }
        $9b9e6d0f6347a978$var$gl(b, g, a, e);
    } else g = $9b9e6d0f6347a978$var$rl(c, b, a, e, d);
    return $9b9e6d0f6347a978$var$hl(g);
}
$9b9e6d0f6347a978$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9b9e6d0f6347a978$var$tc(b.pendingLanes);
                0 !== c && ($9b9e6d0f6347a978$var$Cc(b, c | 1), $9b9e6d0f6347a978$var$Ek(b, $9b9e6d0f6347a978$var$B()), 0 === ($9b9e6d0f6347a978$var$K & 6) && ($9b9e6d0f6347a978$var$Hj = $9b9e6d0f6347a978$var$B() + 500, $9b9e6d0f6347a978$var$jg()));
            }
            break;
        case 13:
            $9b9e6d0f6347a978$var$Sk(function() {
                var b = $9b9e6d0f6347a978$var$Zg(a, 1);
                if (null !== b) {
                    var c = $9b9e6d0f6347a978$var$L();
                    $9b9e6d0f6347a978$var$mh(b, a, 1, c);
                }
            }), $9b9e6d0f6347a978$var$jl(a, 1);
    }
};
$9b9e6d0f6347a978$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $9b9e6d0f6347a978$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $9b9e6d0f6347a978$var$L();
            $9b9e6d0f6347a978$var$mh(b, a, 134217728, c);
        }
        $9b9e6d0f6347a978$var$jl(a, 134217728);
    }
};
$9b9e6d0f6347a978$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $9b9e6d0f6347a978$var$lh(a), c = $9b9e6d0f6347a978$var$Zg(a, b);
        if (null !== c) {
            var d = $9b9e6d0f6347a978$var$L();
            $9b9e6d0f6347a978$var$mh(c, a, b, d);
        }
        $9b9e6d0f6347a978$var$jl(a, b);
    }
};
$9b9e6d0f6347a978$var$Hc = function() {
    return $9b9e6d0f6347a978$var$C;
};
$9b9e6d0f6347a978$var$Ic = function(a, b) {
    var c = $9b9e6d0f6347a978$var$C;
    try {
        return $9b9e6d0f6347a978$var$C = a, b();
    } finally{
        $9b9e6d0f6347a978$var$C = c;
    }
};
$9b9e6d0f6347a978$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $9b9e6d0f6347a978$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9b9e6d0f6347a978$var$Db(d);
                        if (!e) throw Error($9b9e6d0f6347a978$var$p(90));
                        $9b9e6d0f6347a978$var$Wa(d);
                        $9b9e6d0f6347a978$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9b9e6d0f6347a978$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9b9e6d0f6347a978$var$fb(a, !!c.multiple, b, !1);
    }
};
$9b9e6d0f6347a978$var$Gb = $9b9e6d0f6347a978$var$Rk;
$9b9e6d0f6347a978$var$Hb = $9b9e6d0f6347a978$var$Sk;
var $9b9e6d0f6347a978$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $9b9e6d0f6347a978$var$Cb,
        $9b9e6d0f6347a978$var$ue,
        $9b9e6d0f6347a978$var$Db,
        $9b9e6d0f6347a978$var$Eb,
        $9b9e6d0f6347a978$var$Fb,
        $9b9e6d0f6347a978$var$Rk
    ]
}, $9b9e6d0f6347a978$var$ul = {
    findFiberByHostInstance: $9b9e6d0f6347a978$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $9b9e6d0f6347a978$var$vl = {
    bundleType: $9b9e6d0f6347a978$var$ul.bundleType,
    version: $9b9e6d0f6347a978$var$ul.version,
    rendererPackageName: $9b9e6d0f6347a978$var$ul.rendererPackageName,
    rendererConfig: $9b9e6d0f6347a978$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9b9e6d0f6347a978$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $9b9e6d0f6347a978$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9b9e6d0f6347a978$var$ul.findFiberByHostInstance || $9b9e6d0f6347a978$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9b9e6d0f6347a978$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9b9e6d0f6347a978$var$wl.isDisabled && $9b9e6d0f6347a978$var$wl.supportsFiber) try {
        $9b9e6d0f6347a978$var$kc = $9b9e6d0f6347a978$var$wl.inject($9b9e6d0f6347a978$var$vl), $9b9e6d0f6347a978$var$lc = $9b9e6d0f6347a978$var$wl;
    } catch (a) {}
}
$9b9e6d0f6347a978$export$ae55be85d98224ed = $9b9e6d0f6347a978$var$tl;
$9b9e6d0f6347a978$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9b9e6d0f6347a978$var$ol(b)) throw Error($9b9e6d0f6347a978$var$p(200));
    return $9b9e6d0f6347a978$var$dl(a, b, null, c);
};
$9b9e6d0f6347a978$export$882461b6382ed46c = function(a, b) {
    if (!$9b9e6d0f6347a978$var$ol(a)) throw Error($9b9e6d0f6347a978$var$p(299));
    var c = !1, d = "", e = $9b9e6d0f6347a978$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9b9e6d0f6347a978$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$9b9e6d0f6347a978$var$uf] = b.current;
    $9b9e6d0f6347a978$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9b9e6d0f6347a978$var$ml(b);
};
$9b9e6d0f6347a978$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9b9e6d0f6347a978$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9b9e6d0f6347a978$var$p(268, a));
    }
    a = $9b9e6d0f6347a978$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9b9e6d0f6347a978$export$cd75ccfd720a3cd4 = function(a) {
    return $9b9e6d0f6347a978$var$Sk(a);
};
$9b9e6d0f6347a978$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9b9e6d0f6347a978$var$pl(b)) throw Error($9b9e6d0f6347a978$var$p(200));
    return $9b9e6d0f6347a978$var$sl(null, a, b, !0, c);
};
$9b9e6d0f6347a978$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9b9e6d0f6347a978$var$ol(a)) throw Error($9b9e6d0f6347a978$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9b9e6d0f6347a978$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9b9e6d0f6347a978$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9b9e6d0f6347a978$var$uf] = b.current;
    $9b9e6d0f6347a978$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9b9e6d0f6347a978$var$nl(b);
};
$9b9e6d0f6347a978$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9b9e6d0f6347a978$var$pl(b)) throw Error($9b9e6d0f6347a978$var$p(200));
    return $9b9e6d0f6347a978$var$sl(null, a, b, !1, c);
};
$9b9e6d0f6347a978$export$502457920280e6be = function(a) {
    if (!$9b9e6d0f6347a978$var$pl(a)) throw Error($9b9e6d0f6347a978$var$p(40));
    return a._reactRootContainer ? ($9b9e6d0f6347a978$var$Sk(function() {
        $9b9e6d0f6347a978$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9b9e6d0f6347a978$var$uf] = null;
        });
    }), !0) : !1;
};
$9b9e6d0f6347a978$export$c78a37762a8d58e1 = $9b9e6d0f6347a978$var$Rk;
$9b9e6d0f6347a978$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9b9e6d0f6347a978$var$pl(c)) throw Error($9b9e6d0f6347a978$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9b9e6d0f6347a978$var$p(38));
    return $9b9e6d0f6347a978$var$sl(a, b, c, !1, d);
};
$9b9e6d0f6347a978$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("lC4Dh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dqzhg"));

});
parcelRegister("dqzhg", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9c6911696f98b24c$export$c4744153514ff05d; }, function (v) { return $9c6911696f98b24c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9c6911696f98b24c$export$3e506c1ccc9cc1a7; }, function (v) { return $9c6911696f98b24c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9c6911696f98b24c$export$e26fe2ed2fa76875; }, function (v) { return $9c6911696f98b24c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9c6911696f98b24c$export$502329bbf4b505b1; }, function (v) { return $9c6911696f98b24c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9c6911696f98b24c$export$6e3807111c4874c4; }, function (v) { return $9c6911696f98b24c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9c6911696f98b24c$export$c27134553091fb3a; }, function (v) { return $9c6911696f98b24c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9c6911696f98b24c$export$33ee1acdc04fd2a2; }, function (v) { return $9c6911696f98b24c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9c6911696f98b24c$export$b00a404bbd5edef2; }, function (v) { return $9c6911696f98b24c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9c6911696f98b24c$export$8352ce38b91d0c62; }, function (v) { return $9c6911696f98b24c$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9c6911696f98b24c$export$d66a1c1c77bd778b; }, function (v) { return $9c6911696f98b24c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9c6911696f98b24c$export$d3dfb8e4810cb555; }, function (v) { return $9c6911696f98b24c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9c6911696f98b24c$export$839f9183b0465a69; }, function (v) { return $9c6911696f98b24c$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9c6911696f98b24c$export$72fdf0e06517287b; }, function (v) { return $9c6911696f98b24c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9c6911696f98b24c$export$4b844e58a3e414b4; }, function (v) { return $9c6911696f98b24c$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9c6911696f98b24c$export$816d2913ae6b83b1; }, function (v) { return $9c6911696f98b24c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9c6911696f98b24c$export$61bcfe829111a1d0; }, function (v) { return $9c6911696f98b24c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9c6911696f98b24c$export$7ee8c9beb337bc3f; }, function (v) { return $9c6911696f98b24c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9c6911696f98b24c$export$b5836b71941fa3ed; }, function (v) { return $9c6911696f98b24c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9c6911696f98b24c$export$cf845f2c119da08a; }, function (v) { return $9c6911696f98b24c$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9c6911696f98b24c$export$c4744153514ff05d;
var $9c6911696f98b24c$export$3e506c1ccc9cc1a7;
var $9c6911696f98b24c$export$e26fe2ed2fa76875;
var $9c6911696f98b24c$export$502329bbf4b505b1;
var $9c6911696f98b24c$export$6e3807111c4874c4;
var $9c6911696f98b24c$export$c27134553091fb3a;
var $9c6911696f98b24c$export$33ee1acdc04fd2a2;
var $9c6911696f98b24c$export$b00a404bbd5edef2;
var $9c6911696f98b24c$export$8352ce38b91d0c62;
var $9c6911696f98b24c$export$d66a1c1c77bd778b;
var $9c6911696f98b24c$export$d3dfb8e4810cb555;
var $9c6911696f98b24c$export$839f9183b0465a69;
var $9c6911696f98b24c$export$72fdf0e06517287b;
var $9c6911696f98b24c$export$4b844e58a3e414b4;
var $9c6911696f98b24c$export$816d2913ae6b83b1;
var $9c6911696f98b24c$export$61bcfe829111a1d0;
var $9c6911696f98b24c$export$7ee8c9beb337bc3f;
var $9c6911696f98b24c$export$b5836b71941fa3ed;
var $9c6911696f98b24c$export$cf845f2c119da08a;
'use strict';
function $9c6911696f98b24c$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9c6911696f98b24c$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9c6911696f98b24c$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9c6911696f98b24c$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9c6911696f98b24c$var$g(C, c)) n < e && 0 > $9c6911696f98b24c$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9c6911696f98b24c$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9c6911696f98b24c$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9c6911696f98b24c$var$l = performance;
    $9c6911696f98b24c$export$c4744153514ff05d = function() {
        return $9c6911696f98b24c$var$l.now();
    };
} else {
    var $9c6911696f98b24c$var$p = Date, $9c6911696f98b24c$var$q = $9c6911696f98b24c$var$p.now();
    $9c6911696f98b24c$export$c4744153514ff05d = function() {
        return $9c6911696f98b24c$var$p.now() - $9c6911696f98b24c$var$q;
    };
}
var $9c6911696f98b24c$var$r = [], $9c6911696f98b24c$var$t = [], $9c6911696f98b24c$var$u = 1, $9c6911696f98b24c$var$v = null, $9c6911696f98b24c$var$y = 3, $9c6911696f98b24c$var$z = !1, $9c6911696f98b24c$var$A = !1, $9c6911696f98b24c$var$B = !1, $9c6911696f98b24c$var$D = "function" === typeof setTimeout ? setTimeout : null, $9c6911696f98b24c$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9c6911696f98b24c$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9c6911696f98b24c$var$G(a) {
    for(var b = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t); null !== b;){
        if (null === b.callback) $9c6911696f98b24c$var$k($9c6911696f98b24c$var$t);
        else if (b.startTime <= a) $9c6911696f98b24c$var$k($9c6911696f98b24c$var$t), b.sortIndex = b.expirationTime, $9c6911696f98b24c$var$f($9c6911696f98b24c$var$r, b);
        else break;
        b = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t);
    }
}
function $9c6911696f98b24c$var$H(a) {
    $9c6911696f98b24c$var$B = !1;
    $9c6911696f98b24c$var$G(a);
    if (!$9c6911696f98b24c$var$A) {
        if (null !== $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r)) $9c6911696f98b24c$var$A = !0, $9c6911696f98b24c$var$I($9c6911696f98b24c$var$J);
        else {
            var b = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t);
            null !== b && $9c6911696f98b24c$var$K($9c6911696f98b24c$var$H, b.startTime - a);
        }
    }
}
function $9c6911696f98b24c$var$J(a, b) {
    $9c6911696f98b24c$var$A = !1;
    $9c6911696f98b24c$var$B && ($9c6911696f98b24c$var$B = !1, $9c6911696f98b24c$var$E($9c6911696f98b24c$var$L), $9c6911696f98b24c$var$L = -1);
    $9c6911696f98b24c$var$z = !0;
    var c = $9c6911696f98b24c$var$y;
    try {
        $9c6911696f98b24c$var$G(b);
        for($9c6911696f98b24c$var$v = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r); null !== $9c6911696f98b24c$var$v && (!($9c6911696f98b24c$var$v.expirationTime > b) || a && !$9c6911696f98b24c$var$M());){
            var d = $9c6911696f98b24c$var$v.callback;
            if ("function" === typeof d) {
                $9c6911696f98b24c$var$v.callback = null;
                $9c6911696f98b24c$var$y = $9c6911696f98b24c$var$v.priorityLevel;
                var e = d($9c6911696f98b24c$var$v.expirationTime <= b);
                b = $9c6911696f98b24c$export$c4744153514ff05d();
                "function" === typeof e ? $9c6911696f98b24c$var$v.callback = e : $9c6911696f98b24c$var$v === $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r) && $9c6911696f98b24c$var$k($9c6911696f98b24c$var$r);
                $9c6911696f98b24c$var$G(b);
            } else $9c6911696f98b24c$var$k($9c6911696f98b24c$var$r);
            $9c6911696f98b24c$var$v = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r);
        }
        if (null !== $9c6911696f98b24c$var$v) var w = !0;
        else {
            var m = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t);
            null !== m && $9c6911696f98b24c$var$K($9c6911696f98b24c$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9c6911696f98b24c$var$v = null, $9c6911696f98b24c$var$y = c, $9c6911696f98b24c$var$z = !1;
    }
}
var $9c6911696f98b24c$var$N = !1, $9c6911696f98b24c$var$O = null, $9c6911696f98b24c$var$L = -1, $9c6911696f98b24c$var$P = 5, $9c6911696f98b24c$var$Q = -1;
function $9c6911696f98b24c$var$M() {
    return $9c6911696f98b24c$export$c4744153514ff05d() - $9c6911696f98b24c$var$Q < $9c6911696f98b24c$var$P ? !1 : !0;
}
function $9c6911696f98b24c$var$R() {
    if (null !== $9c6911696f98b24c$var$O) {
        var a = $9c6911696f98b24c$export$c4744153514ff05d();
        $9c6911696f98b24c$var$Q = a;
        var b = !0;
        try {
            b = $9c6911696f98b24c$var$O(!0, a);
        } finally{
            b ? $9c6911696f98b24c$var$S() : ($9c6911696f98b24c$var$N = !1, $9c6911696f98b24c$var$O = null);
        }
    } else $9c6911696f98b24c$var$N = !1;
}
var $9c6911696f98b24c$var$S;
if ("function" === typeof $9c6911696f98b24c$var$F) $9c6911696f98b24c$var$S = function() {
    $9c6911696f98b24c$var$F($9c6911696f98b24c$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9c6911696f98b24c$var$T = new MessageChannel, $9c6911696f98b24c$var$U = $9c6911696f98b24c$var$T.port2;
    $9c6911696f98b24c$var$T.port1.onmessage = $9c6911696f98b24c$var$R;
    $9c6911696f98b24c$var$S = function() {
        $9c6911696f98b24c$var$U.postMessage(null);
    };
} else $9c6911696f98b24c$var$S = function() {
    $9c6911696f98b24c$var$D($9c6911696f98b24c$var$R, 0);
};
function $9c6911696f98b24c$var$I(a) {
    $9c6911696f98b24c$var$O = a;
    $9c6911696f98b24c$var$N || ($9c6911696f98b24c$var$N = !0, $9c6911696f98b24c$var$S());
}
function $9c6911696f98b24c$var$K(a, b) {
    $9c6911696f98b24c$var$L = $9c6911696f98b24c$var$D(function() {
        a($9c6911696f98b24c$export$c4744153514ff05d());
    }, b);
}
$9c6911696f98b24c$export$3e506c1ccc9cc1a7 = 5;
$9c6911696f98b24c$export$e26fe2ed2fa76875 = 1;
$9c6911696f98b24c$export$502329bbf4b505b1 = 4;
$9c6911696f98b24c$export$6e3807111c4874c4 = 3;
$9c6911696f98b24c$export$c27134553091fb3a = null;
$9c6911696f98b24c$export$33ee1acdc04fd2a2 = 2;
$9c6911696f98b24c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9c6911696f98b24c$export$8352ce38b91d0c62 = function() {
    $9c6911696f98b24c$var$A || $9c6911696f98b24c$var$z || ($9c6911696f98b24c$var$A = !0, $9c6911696f98b24c$var$I($9c6911696f98b24c$var$J));
};
$9c6911696f98b24c$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9c6911696f98b24c$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9c6911696f98b24c$export$d3dfb8e4810cb555 = function() {
    return $9c6911696f98b24c$var$y;
};
$9c6911696f98b24c$export$839f9183b0465a69 = function() {
    return $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r);
};
$9c6911696f98b24c$export$72fdf0e06517287b = function(a) {
    switch($9c6911696f98b24c$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9c6911696f98b24c$var$y;
    }
    var c = $9c6911696f98b24c$var$y;
    $9c6911696f98b24c$var$y = b;
    try {
        return a();
    } finally{
        $9c6911696f98b24c$var$y = c;
    }
};
$9c6911696f98b24c$export$4b844e58a3e414b4 = function() {};
$9c6911696f98b24c$export$816d2913ae6b83b1 = function() {};
$9c6911696f98b24c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9c6911696f98b24c$var$y;
    $9c6911696f98b24c$var$y = a;
    try {
        return b();
    } finally{
        $9c6911696f98b24c$var$y = c;
    }
};
$9c6911696f98b24c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9c6911696f98b24c$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9c6911696f98b24c$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9c6911696f98b24c$var$f($9c6911696f98b24c$var$t, a), null === $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r) && a === $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t) && ($9c6911696f98b24c$var$B ? ($9c6911696f98b24c$var$E($9c6911696f98b24c$var$L), $9c6911696f98b24c$var$L = -1) : $9c6911696f98b24c$var$B = !0, $9c6911696f98b24c$var$K($9c6911696f98b24c$var$H, c - d))) : (a.sortIndex = e, $9c6911696f98b24c$var$f($9c6911696f98b24c$var$r, a), $9c6911696f98b24c$var$A || $9c6911696f98b24c$var$z || ($9c6911696f98b24c$var$A = !0, $9c6911696f98b24c$var$I($9c6911696f98b24c$var$J)));
    return a;
};
$9c6911696f98b24c$export$b5836b71941fa3ed = $9c6911696f98b24c$var$M;
$9c6911696f98b24c$export$cf845f2c119da08a = function(a) {
    var b = $9c6911696f98b24c$var$y;
    return function() {
        var c = $9c6911696f98b24c$var$y;
        $9c6911696f98b24c$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9c6911696f98b24c$var$y = c;
        }
    };
};

});




parcelRegister("fgQ0V", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("eqWSa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $djlMn = parcelRequire("djlMn");
var $02b63657f85a6045$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $02b63657f85a6045$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$02b63657f85a6045$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($02b63657f85a6045$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($02b63657f85a6045$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($02b63657f85a6045$var$isNull(x) || !$02b63657f85a6045$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $02b63657f85a6045$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $djlMn !== 'undefined' && $djlMn.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $djlMn === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($djlMn.throwDeprecation) throw new Error(msg);
            else if ($djlMn.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $02b63657f85a6045$var$debugs = {};
var $02b63657f85a6045$var$debugEnvRegex = /^$/;
var $02b63657f85a6045$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$02b63657f85a6045$var$debugs[set]) {
        if ($02b63657f85a6045$var$debugEnvRegex.test(set)) {
            var pid = $djlMn.pid;
            $02b63657f85a6045$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $02b63657f85a6045$var$debugs[set] = function() {};
    }
    return $02b63657f85a6045$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $02b63657f85a6045$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $02b63657f85a6045$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($02b63657f85a6045$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($02b63657f85a6045$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($02b63657f85a6045$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($02b63657f85a6045$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($02b63657f85a6045$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $02b63657f85a6045$var$stylizeWithColor;
    return $02b63657f85a6045$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $02b63657f85a6045$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$02b63657f85a6045$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$02b63657f85a6045$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $02b63657f85a6045$var$stylizeWithColor(str, styleType) {
    var style = $02b63657f85a6045$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $02b63657f85a6045$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $02b63657f85a6045$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $02b63657f85a6045$var$stylizeNoColor(str, styleType) {
    return str;
}
function $02b63657f85a6045$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $02b63657f85a6045$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $02b63657f85a6045$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$02b63657f85a6045$var$isString(ret)) ret = $02b63657f85a6045$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $02b63657f85a6045$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $02b63657f85a6045$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($02b63657f85a6045$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $02b63657f85a6045$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($02b63657f85a6045$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($02b63657f85a6045$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($02b63657f85a6045$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($02b63657f85a6045$var$isError(value)) return $02b63657f85a6045$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($02b63657f85a6045$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($02b63657f85a6045$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($02b63657f85a6045$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($02b63657f85a6045$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($02b63657f85a6045$var$isError(value)) base = ' ' + $02b63657f85a6045$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($02b63657f85a6045$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $02b63657f85a6045$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $02b63657f85a6045$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $02b63657f85a6045$var$reduceToSingleString(output, base, braces);
}
function $02b63657f85a6045$var$formatPrimitive(ctx, value) {
    if ($02b63657f85a6045$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($02b63657f85a6045$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($02b63657f85a6045$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($02b63657f85a6045$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($02b63657f85a6045$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $02b63657f85a6045$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $02b63657f85a6045$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($02b63657f85a6045$var$hasOwnProperty(value, String(i))) output.push($02b63657f85a6045$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($02b63657f85a6045$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $02b63657f85a6045$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$02b63657f85a6045$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($02b63657f85a6045$var$isNull(recurseTimes)) str = $02b63657f85a6045$var$formatValue(ctx, desc.value, null);
            else str = $02b63657f85a6045$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($02b63657f85a6045$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $02b63657f85a6045$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("3alvF"));
function $02b63657f85a6045$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $02b63657f85a6045$var$isArray;
function $02b63657f85a6045$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $02b63657f85a6045$var$isBoolean;
function $02b63657f85a6045$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $02b63657f85a6045$var$isNull;
function $02b63657f85a6045$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $02b63657f85a6045$var$isNullOrUndefined;
function $02b63657f85a6045$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $02b63657f85a6045$var$isNumber;
function $02b63657f85a6045$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $02b63657f85a6045$var$isString;
function $02b63657f85a6045$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $02b63657f85a6045$var$isSymbol;
function $02b63657f85a6045$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $02b63657f85a6045$var$isUndefined;
function $02b63657f85a6045$var$isRegExp(re) {
    return $02b63657f85a6045$var$isObject(re) && $02b63657f85a6045$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $02b63657f85a6045$var$isRegExp;
module.exports.types.isRegExp = $02b63657f85a6045$var$isRegExp;
function $02b63657f85a6045$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $02b63657f85a6045$var$isObject;
function $02b63657f85a6045$var$isDate(d) {
    return $02b63657f85a6045$var$isObject(d) && $02b63657f85a6045$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $02b63657f85a6045$var$isDate;
module.exports.types.isDate = $02b63657f85a6045$var$isDate;
function $02b63657f85a6045$var$isError(e) {
    return $02b63657f85a6045$var$isObject(e) && ($02b63657f85a6045$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $02b63657f85a6045$var$isError;
module.exports.types.isNativeError = $02b63657f85a6045$var$isError;
function $02b63657f85a6045$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $02b63657f85a6045$var$isFunction;
function $02b63657f85a6045$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $02b63657f85a6045$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("04s3C"));
function $02b63657f85a6045$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $02b63657f85a6045$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $02b63657f85a6045$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $02b63657f85a6045$var$timestamp() {
    var d = new Date();
    var time = [
        $02b63657f85a6045$var$pad(d.getHours()),
        $02b63657f85a6045$var$pad(d.getMinutes()),
        $02b63657f85a6045$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $02b63657f85a6045$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $02b63657f85a6045$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("lBpnk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$02b63657f85a6045$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $02b63657f85a6045$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $02b63657f85a6045$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($02b63657f85a6045$var$kCustomPromisifiedSymbol && original[$02b63657f85a6045$var$kCustomPromisifiedSymbol]) {
        var fn = original[$02b63657f85a6045$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $02b63657f85a6045$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($02b63657f85a6045$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $02b63657f85a6045$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $02b63657f85a6045$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $02b63657f85a6045$var$kCustomPromisifiedSymbol;
function $02b63657f85a6045$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $02b63657f85a6045$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $djlMn.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $djlMn.nextTick($02b63657f85a6045$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $02b63657f85a6045$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $02b63657f85a6045$var$callbackify;

});
parcelRegister("djlMn", function(module, exports) {
// shim for using process in browser
var $9b0df1a1bca55960$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $9b0df1a1bca55960$var$cachedSetTimeout;
var $9b0df1a1bca55960$var$cachedClearTimeout;
function $9b0df1a1bca55960$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $9b0df1a1bca55960$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $9b0df1a1bca55960$var$cachedSetTimeout = setTimeout;
        else $9b0df1a1bca55960$var$cachedSetTimeout = $9b0df1a1bca55960$var$defaultSetTimout;
    } catch (e) {
        $9b0df1a1bca55960$var$cachedSetTimeout = $9b0df1a1bca55960$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $9b0df1a1bca55960$var$cachedClearTimeout = clearTimeout;
        else $9b0df1a1bca55960$var$cachedClearTimeout = $9b0df1a1bca55960$var$defaultClearTimeout;
    } catch (e) {
        $9b0df1a1bca55960$var$cachedClearTimeout = $9b0df1a1bca55960$var$defaultClearTimeout;
    }
})();
function $9b0df1a1bca55960$var$runTimeout(fun) {
    if ($9b0df1a1bca55960$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($9b0df1a1bca55960$var$cachedSetTimeout === $9b0df1a1bca55960$var$defaultSetTimout || !$9b0df1a1bca55960$var$cachedSetTimeout) && setTimeout) {
        $9b0df1a1bca55960$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $9b0df1a1bca55960$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $9b0df1a1bca55960$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $9b0df1a1bca55960$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $9b0df1a1bca55960$var$runClearTimeout(marker) {
    if ($9b0df1a1bca55960$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($9b0df1a1bca55960$var$cachedClearTimeout === $9b0df1a1bca55960$var$defaultClearTimeout || !$9b0df1a1bca55960$var$cachedClearTimeout) && clearTimeout) {
        $9b0df1a1bca55960$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $9b0df1a1bca55960$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $9b0df1a1bca55960$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $9b0df1a1bca55960$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $9b0df1a1bca55960$var$queue = [];
var $9b0df1a1bca55960$var$draining = false;
var $9b0df1a1bca55960$var$currentQueue;
var $9b0df1a1bca55960$var$queueIndex = -1;
function $9b0df1a1bca55960$var$cleanUpNextTick() {
    if (!$9b0df1a1bca55960$var$draining || !$9b0df1a1bca55960$var$currentQueue) return;
    $9b0df1a1bca55960$var$draining = false;
    if ($9b0df1a1bca55960$var$currentQueue.length) $9b0df1a1bca55960$var$queue = $9b0df1a1bca55960$var$currentQueue.concat($9b0df1a1bca55960$var$queue);
    else $9b0df1a1bca55960$var$queueIndex = -1;
    if ($9b0df1a1bca55960$var$queue.length) $9b0df1a1bca55960$var$drainQueue();
}
function $9b0df1a1bca55960$var$drainQueue() {
    if ($9b0df1a1bca55960$var$draining) return;
    var timeout = $9b0df1a1bca55960$var$runTimeout($9b0df1a1bca55960$var$cleanUpNextTick);
    $9b0df1a1bca55960$var$draining = true;
    var len = $9b0df1a1bca55960$var$queue.length;
    while(len){
        $9b0df1a1bca55960$var$currentQueue = $9b0df1a1bca55960$var$queue;
        $9b0df1a1bca55960$var$queue = [];
        while(++$9b0df1a1bca55960$var$queueIndex < len)if ($9b0df1a1bca55960$var$currentQueue) $9b0df1a1bca55960$var$currentQueue[$9b0df1a1bca55960$var$queueIndex].run();
        $9b0df1a1bca55960$var$queueIndex = -1;
        len = $9b0df1a1bca55960$var$queue.length;
    }
    $9b0df1a1bca55960$var$currentQueue = null;
    $9b0df1a1bca55960$var$draining = false;
    $9b0df1a1bca55960$var$runClearTimeout(timeout);
}
$9b0df1a1bca55960$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $9b0df1a1bca55960$var$queue.push(new $9b0df1a1bca55960$var$Item(fun, args));
    if ($9b0df1a1bca55960$var$queue.length === 1 && !$9b0df1a1bca55960$var$draining) $9b0df1a1bca55960$var$runTimeout($9b0df1a1bca55960$var$drainQueue);
};
// v8 likes predictible objects
function $9b0df1a1bca55960$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$9b0df1a1bca55960$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$9b0df1a1bca55960$var$process.title = 'browser';
$9b0df1a1bca55960$var$process.browser = true;
$9b0df1a1bca55960$var$process.env = {};
$9b0df1a1bca55960$var$process.argv = [];
$9b0df1a1bca55960$var$process.version = ''; // empty string to avoid regexp issues
$9b0df1a1bca55960$var$process.versions = {};
function $9b0df1a1bca55960$var$noop() {}
$9b0df1a1bca55960$var$process.on = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.addListener = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.once = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.off = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.removeListener = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.removeAllListeners = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.emit = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.prependListener = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.prependOnceListener = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.listeners = function(name) {
    return [];
};
$9b0df1a1bca55960$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$9b0df1a1bca55960$var$process.cwd = function() {
    return '/';
};
$9b0df1a1bca55960$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$9b0df1a1bca55960$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3alvF", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $dJCHm = parcelRequire("dJCHm");

var $jbZMF = parcelRequire("jbZMF");

var $bQ74u = parcelRequire("bQ74u");

var $d1mGn = parcelRequire("d1mGn");
function $24e2fdae4f4e3bf6$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $24e2fdae4f4e3bf6$var$BigIntSupported = typeof BigInt !== 'undefined';
var $24e2fdae4f4e3bf6$var$SymbolSupported = typeof Symbol !== 'undefined';
var $24e2fdae4f4e3bf6$var$ObjectToString = $24e2fdae4f4e3bf6$var$uncurryThis(Object.prototype.toString);
var $24e2fdae4f4e3bf6$var$numberValue = $24e2fdae4f4e3bf6$var$uncurryThis(Number.prototype.valueOf);
var $24e2fdae4f4e3bf6$var$stringValue = $24e2fdae4f4e3bf6$var$uncurryThis(String.prototype.valueOf);
var $24e2fdae4f4e3bf6$var$booleanValue = $24e2fdae4f4e3bf6$var$uncurryThis(Boolean.prototype.valueOf);
if ($24e2fdae4f4e3bf6$var$BigIntSupported) var $24e2fdae4f4e3bf6$var$bigIntValue = $24e2fdae4f4e3bf6$var$uncurryThis(BigInt.prototype.valueOf);
if ($24e2fdae4f4e3bf6$var$SymbolSupported) var $24e2fdae4f4e3bf6$var$symbolValue = $24e2fdae4f4e3bf6$var$uncurryThis(Symbol.prototype.valueOf);
function $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $dJCHm;
module.exports.isGeneratorFunction = $jbZMF;
module.exports.isTypedArray = $d1mGn;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $24e2fdae4f4e3bf6$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $24e2fdae4f4e3bf6$var$isPromise;
function $24e2fdae4f4e3bf6$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $d1mGn(value) || $24e2fdae4f4e3bf6$var$isDataView(value);
}
module.exports.isArrayBufferView = $24e2fdae4f4e3bf6$var$isArrayBufferView;
function $24e2fdae4f4e3bf6$var$isUint8Array(value) {
    return $bQ74u(value) === 'Uint8Array';
}
module.exports.isUint8Array = $24e2fdae4f4e3bf6$var$isUint8Array;
function $24e2fdae4f4e3bf6$var$isUint8ClampedArray(value) {
    return $bQ74u(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $24e2fdae4f4e3bf6$var$isUint8ClampedArray;
function $24e2fdae4f4e3bf6$var$isUint16Array(value) {
    return $bQ74u(value) === 'Uint16Array';
}
module.exports.isUint16Array = $24e2fdae4f4e3bf6$var$isUint16Array;
function $24e2fdae4f4e3bf6$var$isUint32Array(value) {
    return $bQ74u(value) === 'Uint32Array';
}
module.exports.isUint32Array = $24e2fdae4f4e3bf6$var$isUint32Array;
function $24e2fdae4f4e3bf6$var$isInt8Array(value) {
    return $bQ74u(value) === 'Int8Array';
}
module.exports.isInt8Array = $24e2fdae4f4e3bf6$var$isInt8Array;
function $24e2fdae4f4e3bf6$var$isInt16Array(value) {
    return $bQ74u(value) === 'Int16Array';
}
module.exports.isInt16Array = $24e2fdae4f4e3bf6$var$isInt16Array;
function $24e2fdae4f4e3bf6$var$isInt32Array(value) {
    return $bQ74u(value) === 'Int32Array';
}
module.exports.isInt32Array = $24e2fdae4f4e3bf6$var$isInt32Array;
function $24e2fdae4f4e3bf6$var$isFloat32Array(value) {
    return $bQ74u(value) === 'Float32Array';
}
module.exports.isFloat32Array = $24e2fdae4f4e3bf6$var$isFloat32Array;
function $24e2fdae4f4e3bf6$var$isFloat64Array(value) {
    return $bQ74u(value) === 'Float64Array';
}
module.exports.isFloat64Array = $24e2fdae4f4e3bf6$var$isFloat64Array;
function $24e2fdae4f4e3bf6$var$isBigInt64Array(value) {
    return $bQ74u(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $24e2fdae4f4e3bf6$var$isBigInt64Array;
function $24e2fdae4f4e3bf6$var$isBigUint64Array(value) {
    return $bQ74u(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $24e2fdae4f4e3bf6$var$isBigUint64Array;
function $24e2fdae4f4e3bf6$var$isMapToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object Map]';
}
$24e2fdae4f4e3bf6$var$isMapToString.working = typeof Map !== 'undefined' && $24e2fdae4f4e3bf6$var$isMapToString(new Map());
function $24e2fdae4f4e3bf6$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $24e2fdae4f4e3bf6$var$isMapToString.working ? $24e2fdae4f4e3bf6$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $24e2fdae4f4e3bf6$var$isMap;
function $24e2fdae4f4e3bf6$var$isSetToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object Set]';
}
$24e2fdae4f4e3bf6$var$isSetToString.working = typeof Set !== 'undefined' && $24e2fdae4f4e3bf6$var$isSetToString(new Set());
function $24e2fdae4f4e3bf6$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $24e2fdae4f4e3bf6$var$isSetToString.working ? $24e2fdae4f4e3bf6$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $24e2fdae4f4e3bf6$var$isSet;
function $24e2fdae4f4e3bf6$var$isWeakMapToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object WeakMap]';
}
$24e2fdae4f4e3bf6$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $24e2fdae4f4e3bf6$var$isWeakMapToString(new WeakMap());
function $24e2fdae4f4e3bf6$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $24e2fdae4f4e3bf6$var$isWeakMapToString.working ? $24e2fdae4f4e3bf6$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $24e2fdae4f4e3bf6$var$isWeakMap;
function $24e2fdae4f4e3bf6$var$isWeakSetToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object WeakSet]';
}
$24e2fdae4f4e3bf6$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $24e2fdae4f4e3bf6$var$isWeakSetToString(new WeakSet());
function $24e2fdae4f4e3bf6$var$isWeakSet(value) {
    return $24e2fdae4f4e3bf6$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $24e2fdae4f4e3bf6$var$isWeakSet;
function $24e2fdae4f4e3bf6$var$isArrayBufferToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$24e2fdae4f4e3bf6$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $24e2fdae4f4e3bf6$var$isArrayBufferToString(new ArrayBuffer());
function $24e2fdae4f4e3bf6$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $24e2fdae4f4e3bf6$var$isArrayBufferToString.working ? $24e2fdae4f4e3bf6$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $24e2fdae4f4e3bf6$var$isArrayBuffer;
function $24e2fdae4f4e3bf6$var$isDataViewToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object DataView]';
}
$24e2fdae4f4e3bf6$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $24e2fdae4f4e3bf6$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $24e2fdae4f4e3bf6$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $24e2fdae4f4e3bf6$var$isDataViewToString.working ? $24e2fdae4f4e3bf6$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $24e2fdae4f4e3bf6$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $24e2fdae4f4e3bf6$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $24e2fdae4f4e3bf6$var$isSharedArrayBuffer(value) {
    if (typeof $24e2fdae4f4e3bf6$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString.working === 'undefined') $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString.working = $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString(new $24e2fdae4f4e3bf6$var$SharedArrayBufferCopy());
    return $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString.working ? $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString(value) : value instanceof $24e2fdae4f4e3bf6$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $24e2fdae4f4e3bf6$var$isSharedArrayBuffer;
function $24e2fdae4f4e3bf6$var$isAsyncFunction(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $24e2fdae4f4e3bf6$var$isAsyncFunction;
function $24e2fdae4f4e3bf6$var$isMapIterator(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $24e2fdae4f4e3bf6$var$isMapIterator;
function $24e2fdae4f4e3bf6$var$isSetIterator(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $24e2fdae4f4e3bf6$var$isSetIterator;
function $24e2fdae4f4e3bf6$var$isGeneratorObject(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $24e2fdae4f4e3bf6$var$isGeneratorObject;
function $24e2fdae4f4e3bf6$var$isWebAssemblyCompiledModule(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $24e2fdae4f4e3bf6$var$isWebAssemblyCompiledModule;
function $24e2fdae4f4e3bf6$var$isNumberObject(value) {
    return $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, $24e2fdae4f4e3bf6$var$numberValue);
}
module.exports.isNumberObject = $24e2fdae4f4e3bf6$var$isNumberObject;
function $24e2fdae4f4e3bf6$var$isStringObject(value) {
    return $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, $24e2fdae4f4e3bf6$var$stringValue);
}
module.exports.isStringObject = $24e2fdae4f4e3bf6$var$isStringObject;
function $24e2fdae4f4e3bf6$var$isBooleanObject(value) {
    return $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, $24e2fdae4f4e3bf6$var$booleanValue);
}
module.exports.isBooleanObject = $24e2fdae4f4e3bf6$var$isBooleanObject;
function $24e2fdae4f4e3bf6$var$isBigIntObject(value) {
    return $24e2fdae4f4e3bf6$var$BigIntSupported && $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, $24e2fdae4f4e3bf6$var$bigIntValue);
}
module.exports.isBigIntObject = $24e2fdae4f4e3bf6$var$isBigIntObject;
function $24e2fdae4f4e3bf6$var$isSymbolObject(value) {
    return $24e2fdae4f4e3bf6$var$SymbolSupported && $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, $24e2fdae4f4e3bf6$var$symbolValue);
}
module.exports.isSymbolObject = $24e2fdae4f4e3bf6$var$isSymbolObject;
function $24e2fdae4f4e3bf6$var$isBoxedPrimitive(value) {
    return $24e2fdae4f4e3bf6$var$isNumberObject(value) || $24e2fdae4f4e3bf6$var$isStringObject(value) || $24e2fdae4f4e3bf6$var$isBooleanObject(value) || $24e2fdae4f4e3bf6$var$isBigIntObject(value) || $24e2fdae4f4e3bf6$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $24e2fdae4f4e3bf6$var$isBoxedPrimitive;
function $24e2fdae4f4e3bf6$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($24e2fdae4f4e3bf6$var$isArrayBuffer(value) || $24e2fdae4f4e3bf6$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $24e2fdae4f4e3bf6$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("dJCHm", function(module, exports) {
'use strict';

var $9ffd7f00e9f601d7$var$hasToStringTag = (parcelRequire("iK7BP"))();

var $9krxM = parcelRequire("9krxM");
var $9ffd7f00e9f601d7$var$$toString = $9krxM('Object.prototype.toString');
/** @type {import('.')} */ var $9ffd7f00e9f601d7$var$isStandardArguments = function isArguments(value) {
    if ($9ffd7f00e9f601d7$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $9ffd7f00e9f601d7$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $9ffd7f00e9f601d7$var$isLegacyArguments = function isArguments(value) {
    if ($9ffd7f00e9f601d7$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $9ffd7f00e9f601d7$var$$toString(value) !== '[object Array]' && 'callee' in value && $9ffd7f00e9f601d7$var$$toString(value.callee) === '[object Function]';
};
var $9ffd7f00e9f601d7$var$supportsStandardArguments = function() {
    return $9ffd7f00e9f601d7$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$9ffd7f00e9f601d7$var$isStandardArguments.isLegacyArguments = $9ffd7f00e9f601d7$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $9ffd7f00e9f601d7$var$supportsStandardArguments ? $9ffd7f00e9f601d7$var$isStandardArguments : $9ffd7f00e9f601d7$var$isLegacyArguments;

});
parcelRegister("iK7BP", function(module, exports) {
'use strict';

var $1TyHV = parcelRequire("1TyHV");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $1TyHV() && !!Symbol.toStringTag;
};

});
parcelRegister("1TyHV", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("9krxM", function(module, exports) {
'use strict';

var $fZZOm = parcelRequire("fZZOm");

var $56ErU = parcelRequire("56ErU");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $6cab58ed9df2c438$var$$indexOf = $56ErU([
    $fZZOm('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $fZZOm(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $6cab58ed9df2c438$var$$indexOf(name, '.prototype.') > -1) return $56ErU(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("fZZOm", function(module, exports) {
'use strict';
var $ba5c7fefb7eb6d38$var$undefined1;

var $irzZH = parcelRequire("irzZH");

var $b3OOB = parcelRequire("b3OOB");

var $f7H97 = parcelRequire("f7H97");

var $lkkeD = parcelRequire("lkkeD");

var $70nKc = parcelRequire("70nKc");

var $kAjA9 = parcelRequire("kAjA9");

var $eVc55 = parcelRequire("eVc55");

var $bgnWJ = parcelRequire("bgnWJ");

var $lGBPc = parcelRequire("lGBPc");

var $iXUzx = parcelRequire("iXUzx");

var $b0H3C = parcelRequire("b0H3C");

var $a9u1S = parcelRequire("a9u1S");

var $iBld1 = parcelRequire("iBld1");

var $1yRPh = parcelRequire("1yRPh");

var $a0Nga = parcelRequire("a0Nga");
var $ba5c7fefb7eb6d38$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $ba5c7fefb7eb6d38$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $ba5c7fefb7eb6d38$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $59bfT = parcelRequire("59bfT");

var $91w2b = parcelRequire("91w2b");
var $ba5c7fefb7eb6d38$var$throwTypeError = function() {
    throw new $eVc55();
};
var $ba5c7fefb7eb6d38$var$ThrowTypeError = $59bfT ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $ba5c7fefb7eb6d38$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $59bfT(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $ba5c7fefb7eb6d38$var$throwTypeError;
        }
    }
}() : $ba5c7fefb7eb6d38$var$throwTypeError;

var $ba5c7fefb7eb6d38$var$hasSymbols = (parcelRequire("lm6s4"))();

var $llhfI = parcelRequire("llhfI");

var $gB04n = parcelRequire("gB04n");

var $5I8jg = parcelRequire("5I8jg");

var $jcSia = parcelRequire("jcSia");

var $iKVNo = parcelRequire("iKVNo");
var $ba5c7fefb7eb6d38$var$needsEval = {};
var $ba5c7fefb7eb6d38$var$TypedArray = typeof Uint8Array === 'undefined' || !$llhfI ? undefined : $llhfI(Uint8Array);
var $ba5c7fefb7eb6d38$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $ba5c7fefb7eb6d38$var$hasSymbols && $llhfI ? $llhfI([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $ba5c7fefb7eb6d38$var$needsEval,
    '%AsyncGenerator%': $ba5c7fefb7eb6d38$var$needsEval,
    '%AsyncGeneratorFunction%': $ba5c7fefb7eb6d38$var$needsEval,
    '%AsyncIteratorPrototype%': $ba5c7fefb7eb6d38$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $b3OOB,
    '%eval%': eval,
    '%EvalError%': $f7H97,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $ba5c7fefb7eb6d38$var$$Function,
    '%GeneratorFunction%': $ba5c7fefb7eb6d38$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $ba5c7fefb7eb6d38$var$hasSymbols && $llhfI ? $llhfI($llhfI([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$ba5c7fefb7eb6d38$var$hasSymbols || !$llhfI ? undefined : $llhfI(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $irzZH,
    '%Object.getOwnPropertyDescriptor%': $59bfT,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $lkkeD,
    '%ReferenceError%': $70nKc,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$ba5c7fefb7eb6d38$var$hasSymbols || !$llhfI ? undefined : $llhfI(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $ba5c7fefb7eb6d38$var$hasSymbols && $llhfI ? $llhfI(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $ba5c7fefb7eb6d38$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $kAjA9,
    '%ThrowTypeError%': $ba5c7fefb7eb6d38$var$ThrowTypeError,
    '%TypedArray%': $ba5c7fefb7eb6d38$var$TypedArray,
    '%TypeError%': $eVc55,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $bgnWJ,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $iKVNo,
    '%Function.prototype.apply%': $jcSia,
    '%Object.defineProperty%': $91w2b,
    '%Object.getPrototypeOf%': $gB04n,
    '%Math.abs%': $lGBPc,
    '%Math.floor%': $iXUzx,
    '%Math.max%': $b0H3C,
    '%Math.min%': $a9u1S,
    '%Math.pow%': $iBld1,
    '%Math.round%': $1yRPh,
    '%Math.sign%': $a0Nga,
    '%Reflect.getPrototypeOf%': $5I8jg
};
if ($llhfI) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $ba5c7fefb7eb6d38$var$errorProto = $llhfI($llhfI(e));
    $ba5c7fefb7eb6d38$var$INTRINSICS['%Error.prototype%'] = $ba5c7fefb7eb6d38$var$errorProto;
}
var $ba5c7fefb7eb6d38$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $ba5c7fefb7eb6d38$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $ba5c7fefb7eb6d38$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $ba5c7fefb7eb6d38$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $llhfI) value = $llhfI(gen.prototype);
    }
    $ba5c7fefb7eb6d38$var$INTRINSICS[name] = value;
    return value;
};
var $ba5c7fefb7eb6d38$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $cX4h3 = parcelRequire("cX4h3");

var $5AOah = parcelRequire("5AOah");
var $ba5c7fefb7eb6d38$var$$concat = $cX4h3.call($iKVNo, Array.prototype.concat);
var $ba5c7fefb7eb6d38$var$$spliceApply = $cX4h3.call($jcSia, Array.prototype.splice);
var $ba5c7fefb7eb6d38$var$$replace = $cX4h3.call($iKVNo, String.prototype.replace);
var $ba5c7fefb7eb6d38$var$$strSlice = $cX4h3.call($iKVNo, String.prototype.slice);
var $ba5c7fefb7eb6d38$var$$exec = $cX4h3.call($iKVNo, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $ba5c7fefb7eb6d38$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $ba5c7fefb7eb6d38$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $ba5c7fefb7eb6d38$var$stringToPath = function stringToPath(string) {
    var first = $ba5c7fefb7eb6d38$var$$strSlice(string, 0, 1);
    var last = $ba5c7fefb7eb6d38$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $kAjA9('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $kAjA9('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $ba5c7fefb7eb6d38$var$$replace(string, $ba5c7fefb7eb6d38$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $ba5c7fefb7eb6d38$var$$replace(subString, $ba5c7fefb7eb6d38$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $ba5c7fefb7eb6d38$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($5AOah($ba5c7fefb7eb6d38$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $ba5c7fefb7eb6d38$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($5AOah($ba5c7fefb7eb6d38$var$INTRINSICS, intrinsicName)) {
        var value = $ba5c7fefb7eb6d38$var$INTRINSICS[intrinsicName];
        if (value === $ba5c7fefb7eb6d38$var$needsEval) value = $ba5c7fefb7eb6d38$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eVc55('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $kAjA9('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eVc55('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eVc55('"allowMissing" argument must be a boolean');
    if ($ba5c7fefb7eb6d38$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $kAjA9('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $ba5c7fefb7eb6d38$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $ba5c7fefb7eb6d38$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $ba5c7fefb7eb6d38$var$$spliceApply(parts, $ba5c7fefb7eb6d38$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $ba5c7fefb7eb6d38$var$$strSlice(part, 0, 1);
        var last = $ba5c7fefb7eb6d38$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $kAjA9('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($5AOah($ba5c7fefb7eb6d38$var$INTRINSICS, intrinsicRealName)) value = $ba5c7fefb7eb6d38$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eVc55('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($59bfT && i + 1 >= parts.length) {
                var desc = $59bfT(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $5AOah(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $ba5c7fefb7eb6d38$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("irzZH", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("b3OOB", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("f7H97", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("lkkeD", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("70nKc", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("kAjA9", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eVc55", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("bgnWJ", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("lGBPc", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("iXUzx", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("b0H3C", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("a9u1S", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("iBld1", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1yRPh", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("a0Nga", function(module, exports) {
'use strict';

var $e2QHU = parcelRequire("e2QHU");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($e2QHU(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("e2QHU", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("59bfT", function(module, exports) {
'use strict';

var $fHr4p = parcelRequire("fHr4p");
var $3bf686143fef81b6$require$$gOPD = $fHr4p;
if ($3bf686143fef81b6$require$$gOPD) try {
    $3bf686143fef81b6$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $3bf686143fef81b6$require$$gOPD = null;
}
module.exports = $3bf686143fef81b6$require$$gOPD;

});
parcelRegister("fHr4p", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("91w2b", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $691d0e5f67c57bad$var$$defineProperty = Object.defineProperty || false;
if ($691d0e5f67c57bad$var$$defineProperty) try {
    $691d0e5f67c57bad$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $691d0e5f67c57bad$var$$defineProperty = false;
}
module.exports = $691d0e5f67c57bad$var$$defineProperty;

});

parcelRegister("lm6s4", function(module, exports) {
'use strict';
var $f8c0a841901e2379$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $1TyHV = parcelRequire("1TyHV");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $f8c0a841901e2379$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $f8c0a841901e2379$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $1TyHV();
};

});

parcelRegister("llhfI", function(module, exports) {
'use strict';

var $5I8jg = parcelRequire("5I8jg");

var $gB04n = parcelRequire("gB04n");

var $4rbRz = parcelRequire("4rbRz");
/** @type {import('.')} */ module.exports = $5I8jg ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $5I8jg(O);
} : $gB04n ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $gB04n(O);
} : $4rbRz ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4rbRz(O);
} : null;

});
parcelRegister("5I8jg", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("gB04n", function(module, exports) {
'use strict';

var $irzZH = parcelRequire("irzZH");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $irzZH.getPrototypeOf || null;

});

parcelRegister("4rbRz", function(module, exports) {
'use strict';

var $56ErU = parcelRequire("56ErU");

var $59bfT = parcelRequire("59bfT");
var $33b2e2d05c543836$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $33b2e2d05c543836$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $33b2e2d05c543836$var$desc = !!$33b2e2d05c543836$var$hasProtoAccessor && $59bfT && $59bfT(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $33b2e2d05c543836$var$$Object = Object;
var $33b2e2d05c543836$var$$getPrototypeOf = $33b2e2d05c543836$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $33b2e2d05c543836$var$desc && typeof $33b2e2d05c543836$var$desc.get === 'function' ? $56ErU([
    $33b2e2d05c543836$var$desc.get
]) : typeof $33b2e2d05c543836$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $33b2e2d05c543836$var$$getPrototypeOf(value == null ? value : $33b2e2d05c543836$var$$Object(value));
} : false;

});
parcelRegister("56ErU", function(module, exports) {
'use strict';

var $cX4h3 = parcelRequire("cX4h3");

var $eVc55 = parcelRequire("eVc55");

var $iKVNo = parcelRequire("iKVNo");

var $hCCEd = parcelRequire("hCCEd");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eVc55('a function is required');
    return $hCCEd($cX4h3, $iKVNo, args);
};

});
parcelRegister("cX4h3", function(module, exports) {
'use strict';

var $fgaD7 = parcelRequire("fgaD7");
module.exports = Function.prototype.bind || $fgaD7;

});
parcelRegister("fgaD7", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $b1c0988399c7cbc0$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $b1c0988399c7cbc0$var$toStr = Object.prototype.toString;
var $b1c0988399c7cbc0$var$max = Math.max;
var $b1c0988399c7cbc0$var$funcType = '[object Function]';
var $b1c0988399c7cbc0$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $b1c0988399c7cbc0$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $b1c0988399c7cbc0$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $b1c0988399c7cbc0$var$toStr.apply(target) !== $b1c0988399c7cbc0$var$funcType) throw new TypeError($b1c0988399c7cbc0$var$ERROR_MESSAGE + target);
    var args = $b1c0988399c7cbc0$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $b1c0988399c7cbc0$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $b1c0988399c7cbc0$var$concatty(args, arguments));
    };
    var boundLength = $b1c0988399c7cbc0$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $b1c0988399c7cbc0$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("iKVNo", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("hCCEd", function(module, exports) {
'use strict';

var $cX4h3 = parcelRequire("cX4h3");

var $jcSia = parcelRequire("jcSia");

var $iKVNo = parcelRequire("iKVNo");

var $fyEu2 = parcelRequire("fyEu2");
/** @type {import('./actualApply')} */ module.exports = $fyEu2 || $cX4h3.call($iKVNo, $jcSia);

});
parcelRegister("jcSia", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("fyEu2", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("5AOah", function(module, exports) {
'use strict';
var $41273a3f227f6eab$var$call = Function.prototype.call;
var $41273a3f227f6eab$var$$hasOwn = Object.prototype.hasOwnProperty;

var $cX4h3 = parcelRequire("cX4h3");
/** @type {import('.')} */ module.exports = $cX4h3.call($41273a3f227f6eab$var$call, $41273a3f227f6eab$var$$hasOwn);

});




parcelRegister("jbZMF", function(module, exports) {
'use strict';

var $9krxM = parcelRequire("9krxM");

var $fErBy = parcelRequire("fErBy");
var $df8ef86a4f1c27fb$var$isFnRegex = $fErBy(/^\s*(?:function)?\*/);

var $df8ef86a4f1c27fb$var$hasToStringTag = (parcelRequire("iK7BP"))();

var $llhfI = parcelRequire("llhfI");
var $df8ef86a4f1c27fb$var$toStr = $9krxM('Object.prototype.toString');
var $df8ef86a4f1c27fb$var$fnToStr = $9krxM('Function.prototype.toString');
var $df8ef86a4f1c27fb$var$getGeneratorFunc = function() {
    if (!$df8ef86a4f1c27fb$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
/** @type {undefined | false | null | GeneratorFunctionConstructor} */ var $df8ef86a4f1c27fb$var$GeneratorFunction;
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($df8ef86a4f1c27fb$var$isFnRegex($df8ef86a4f1c27fb$var$fnToStr(fn))) return true;
    if (!$df8ef86a4f1c27fb$var$hasToStringTag) {
        var str = $df8ef86a4f1c27fb$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$llhfI) return false;
    if (typeof $df8ef86a4f1c27fb$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $df8ef86a4f1c27fb$var$getGeneratorFunc();
        $df8ef86a4f1c27fb$var$GeneratorFunction = generatorFunc ? /** @type {GeneratorFunctionConstructor} */ $llhfI(generatorFunc) : false;
    }
    return $llhfI(fn) === $df8ef86a4f1c27fb$var$GeneratorFunction;
};

});
parcelRegister("fErBy", function(module, exports) {
'use strict';

var $9krxM = parcelRequire("9krxM");

var $7GGSN = parcelRequire("7GGSN");
var $b6500127dff14772$var$$exec = $9krxM('RegExp.prototype.exec');

var $eVc55 = parcelRequire("eVc55");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$7GGSN(regex)) throw new $eVc55('`regex` must be a RegExp');
    return function test(s) {
        return $b6500127dff14772$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("7GGSN", function(module, exports) {
'use strict';

var $9krxM = parcelRequire("9krxM");

var $598db84e0e836efe$var$hasToStringTag = (parcelRequire("iK7BP"))();

var $5AOah = parcelRequire("5AOah");

var $59bfT = parcelRequire("59bfT");
/** @type {import('.')} */ var $598db84e0e836efe$var$fn;
if ($598db84e0e836efe$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $598db84e0e836efe$var$$exec = $9krxM('RegExp.prototype.exec');
    /** @type {object} */ var $598db84e0e836efe$var$isRegexMarker = {};
    var $598db84e0e836efe$var$throwRegexMarker = function() {
        throw $598db84e0e836efe$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $598db84e0e836efe$var$badStringifier = {
        toString: $598db84e0e836efe$var$throwRegexMarker,
        valueOf: $598db84e0e836efe$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $598db84e0e836efe$var$badStringifier[Symbol.toPrimitive] = $598db84e0e836efe$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $598db84e0e836efe$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $59bfT(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $5AOah(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $598db84e0e836efe$var$$exec(value, /** @type {unknown} */ $598db84e0e836efe$var$badStringifier);
        } catch (e) {
            return e === $598db84e0e836efe$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $598db84e0e836efe$var$$toString = $9krxM('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $598db84e0e836efe$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $598db84e0e836efe$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $598db84e0e836efe$var$$toString(value) === $598db84e0e836efe$var$regexClass;
    };
}
module.exports = $598db84e0e836efe$var$fn;

});



parcelRegister("bQ74u", function(module, exports) {
'use strict';

var $kT3R2 = parcelRequire("kT3R2");

var $1AU46 = parcelRequire("1AU46");

var $aebgU = parcelRequire("aebgU");

var $9krxM = parcelRequire("9krxM");

var $59bfT = parcelRequire("59bfT");

var $llhfI = parcelRequire("llhfI");
var $89ea0949ef56368a$var$$toString = $9krxM('Object.prototype.toString');

var $89ea0949ef56368a$var$hasToStringTag = (parcelRequire("iK7BP"))();
var $89ea0949ef56368a$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $89ea0949ef56368a$var$typedArrays = $1AU46();
var $89ea0949ef56368a$var$$slice = $9krxM('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $89ea0949ef56368a$var$$indexOf = $9krxM('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $89ea0949ef56368a$var$cache = {
    __proto__: null
};
if ($89ea0949ef56368a$var$hasToStringTag && $59bfT && $llhfI) $kT3R2($89ea0949ef56368a$var$typedArrays, function(typedArray) {
    var arr = new $89ea0949ef56368a$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $llhfI) {
        var proto = $llhfI(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $59bfT(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $llhfI(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $59bfT(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $89ea0949ef56368a$var$cache['$' + typedArray] = $aebgU(descriptor.get);
    }
});
else $kT3R2($89ea0949ef56368a$var$typedArrays, function(typedArray) {
    var arr = new $89ea0949ef56368a$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $89ea0949ef56368a$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $aebgU(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $89ea0949ef56368a$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $kT3R2(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $89ea0949ef56368a$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $89ea0949ef56368a$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $89ea0949ef56368a$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $kT3R2(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $89ea0949ef56368a$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $89ea0949ef56368a$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$89ea0949ef56368a$var$hasToStringTag) {
        /** @type {string} */ var tag = $89ea0949ef56368a$var$$slice($89ea0949ef56368a$var$$toString(value), 8, -1);
        if ($89ea0949ef56368a$var$$indexOf($89ea0949ef56368a$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $89ea0949ef56368a$var$trySlices(value);
    }
    if (!$59bfT) return null;
     // unknown engine
    return $89ea0949ef56368a$var$tryTypedArrays(value);
};

});
parcelRegister("kT3R2", function(module, exports) {
'use strict';

var $km88V = parcelRequire("km88V");
var $f34bef1ad0f2b173$var$toStr = Object.prototype.toString;
var $f34bef1ad0f2b173$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $f34bef1ad0f2b173$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($f34bef1ad0f2b173$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $f34bef1ad0f2b173$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $f34bef1ad0f2b173$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($f34bef1ad0f2b173$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $f34bef1ad0f2b173$var$isArray(x) {
    return $f34bef1ad0f2b173$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$km88V(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($f34bef1ad0f2b173$var$isArray(list)) $f34bef1ad0f2b173$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $f34bef1ad0f2b173$var$forEachString(list, iterator, receiver);
    else $f34bef1ad0f2b173$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("km88V", function(module, exports) {
'use strict';
var $ed1c2dc487bf6312$var$fnToStr = Function.prototype.toString;
var $ed1c2dc487bf6312$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $ed1c2dc487bf6312$var$badArrayLike;
var $ed1c2dc487bf6312$var$isCallableMarker;
if (typeof $ed1c2dc487bf6312$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $ed1c2dc487bf6312$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $ed1c2dc487bf6312$var$isCallableMarker;
        }
    });
    $ed1c2dc487bf6312$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $ed1c2dc487bf6312$var$reflectApply(function() {
        throw 42;
    }, null, $ed1c2dc487bf6312$var$badArrayLike);
} catch (_) {
    if (_ !== $ed1c2dc487bf6312$var$isCallableMarker) $ed1c2dc487bf6312$var$reflectApply = null;
}
else $ed1c2dc487bf6312$var$reflectApply = null;
var $ed1c2dc487bf6312$var$constructorRegex = /^\s*class\b/;
var $ed1c2dc487bf6312$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $ed1c2dc487bf6312$var$fnToStr.call(value);
        return $ed1c2dc487bf6312$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $ed1c2dc487bf6312$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($ed1c2dc487bf6312$var$isES6ClassFn(value)) return false;
        $ed1c2dc487bf6312$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $ed1c2dc487bf6312$var$toStr = Object.prototype.toString;
var $ed1c2dc487bf6312$var$objectClass = '[object Object]';
var $ed1c2dc487bf6312$var$fnClass = '[object Function]';
var $ed1c2dc487bf6312$var$genClass = '[object GeneratorFunction]';
var $ed1c2dc487bf6312$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $ed1c2dc487bf6312$var$ddaClass2 = '[object HTML document.all class]';
var $ed1c2dc487bf6312$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $ed1c2dc487bf6312$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $ed1c2dc487bf6312$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $ed1c2dc487bf6312$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $ed1c2dc487bf6312$var$all = document.all;
    if ($ed1c2dc487bf6312$var$toStr.call($ed1c2dc487bf6312$var$all) === $ed1c2dc487bf6312$var$toStr.call(document.all)) $ed1c2dc487bf6312$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($ed1c2dc487bf6312$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $ed1c2dc487bf6312$var$toStr.call(value);
            return (str === $ed1c2dc487bf6312$var$ddaClass || str === $ed1c2dc487bf6312$var$ddaClass2 || str === $ed1c2dc487bf6312$var$ddaClass3 // opera 12.16
             || str === $ed1c2dc487bf6312$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $ed1c2dc487bf6312$var$reflectApply ? function isCallable(value) {
    if ($ed1c2dc487bf6312$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $ed1c2dc487bf6312$var$reflectApply(value, null, $ed1c2dc487bf6312$var$badArrayLike);
    } catch (e) {
        if (e !== $ed1c2dc487bf6312$var$isCallableMarker) return false;
    }
    return !$ed1c2dc487bf6312$var$isES6ClassFn(value) && $ed1c2dc487bf6312$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($ed1c2dc487bf6312$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($ed1c2dc487bf6312$var$hasToStringTag) return $ed1c2dc487bf6312$var$tryFunctionObject(value);
    if ($ed1c2dc487bf6312$var$isES6ClassFn(value)) return false;
    var strClass = $ed1c2dc487bf6312$var$toStr.call(value);
    if (strClass !== $ed1c2dc487bf6312$var$fnClass && strClass !== $ed1c2dc487bf6312$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $ed1c2dc487bf6312$var$tryFunctionObject(value);
};

});


parcelRegister("1AU46", function(module, exports) {
'use strict';

var $aOIri = parcelRequire("aOIri");
var $1294a49f681f964c$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $aOIri.length; i++)if (typeof $1294a49f681f964c$var$g[$aOIri[i]] === 'function') // @ts-expect-error
    out[out.length] = $aOIri[i];
    return out;
};

});
parcelRegister("aOIri", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("aebgU", function(module, exports) {
'use strict';

var $ec05t = parcelRequire("ec05t");

var $91w2b = parcelRequire("91w2b");

var $56ErU = parcelRequire("56ErU");

var $kdhtO = parcelRequire("kdhtO");
module.exports = function callBind(originalFunction) {
    var func = $56ErU(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $ec05t(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($91w2b) $91w2b(module.exports, 'apply', {
    value: $kdhtO
});
else module.exports.apply = $kdhtO;

});
parcelRegister("ec05t", function(module, exports) {
'use strict';

var $fZZOm = parcelRequire("fZZOm");

var $2rrwJ = parcelRequire("2rrwJ");

var $a5524104db679972$var$hasDescriptors = (parcelRequire("dkM7t"))();

var $59bfT = parcelRequire("59bfT");

var $eVc55 = parcelRequire("eVc55");
var $a5524104db679972$var$$floor = $fZZOm('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eVc55('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $a5524104db679972$var$$floor(length) !== length) throw new $eVc55('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $59bfT) {
        var desc = $59bfT(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($a5524104db679972$var$hasDescriptors) $2rrwJ(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $2rrwJ(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("2rrwJ", function(module, exports) {
'use strict';

var $91w2b = parcelRequire("91w2b");

var $kAjA9 = parcelRequire("kAjA9");

var $eVc55 = parcelRequire("eVc55");

var $59bfT = parcelRequire("59bfT");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eVc55('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eVc55('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eVc55('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eVc55('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eVc55('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eVc55('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$59bfT && $59bfT(obj, property);
    if ($91w2b) $91w2b(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $kAjA9('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("dkM7t", function(module, exports) {
'use strict';

var $91w2b = parcelRequire("91w2b");
var $9b527828e9608f86$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$91w2b;
};
$9b527828e9608f86$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$91w2b) return null;
    try {
        return $91w2b([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $9b527828e9608f86$var$hasPropertyDescriptors;

});


parcelRegister("kdhtO", function(module, exports) {
'use strict';

var $cX4h3 = parcelRequire("cX4h3");

var $jcSia = parcelRequire("jcSia");

var $hCCEd = parcelRequire("hCCEd");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $hCCEd($cX4h3, $jcSia, arguments);
};

});



parcelRegister("d1mGn", function(module, exports) {
'use strict';

var $bQ74u = parcelRequire("bQ74u");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$bQ74u(value);
};

});


parcelRegister("04s3C", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("lBpnk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("gpaur", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $djlMn = parcelRequire("djlMn");
'use strict';
function $bf171e426cf417d8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bf171e426cf417d8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bf171e426cf417d8$var$_typeof(o);
}
function $bf171e426cf417d8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bf171e426cf417d8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bf171e426cf417d8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bf171e426cf417d8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bf171e426cf417d8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bf171e426cf417d8$var$_toPropertyKey(arg) {
    var key = $bf171e426cf417d8$var$_toPrimitive(arg, "string");
    return $bf171e426cf417d8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bf171e426cf417d8$var$_toPrimitive(input, hint) {
    if ($bf171e426cf417d8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bf171e426cf417d8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $bf171e426cf417d8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $84ZjD = parcelRequire("84ZjD");
var $bf171e426cf417d8$var$_require$codes = $84ZjD.codes, $bf171e426cf417d8$var$ERR_AMBIGUOUS_ARGUMENT = $bf171e426cf417d8$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE = $bf171e426cf417d8$var$_require$codes.ERR_INVALID_ARG_TYPE, $bf171e426cf417d8$var$ERR_INVALID_ARG_VALUE = $bf171e426cf417d8$var$_require$codes.ERR_INVALID_ARG_VALUE, $bf171e426cf417d8$var$ERR_INVALID_RETURN_VALUE = $bf171e426cf417d8$var$_require$codes.ERR_INVALID_RETURN_VALUE, $bf171e426cf417d8$var$ERR_MISSING_ARGS = $bf171e426cf417d8$var$_require$codes.ERR_MISSING_ARGS;

var $bZlr9 = parcelRequire("bZlr9");

var $eqWSa = parcelRequire("eqWSa");
var $bf171e426cf417d8$var$inspect = $eqWSa.inspect;

var $eqWSa = parcelRequire("eqWSa");
var $bf171e426cf417d8$require$_require$types = $eqWSa.types;
var $bf171e426cf417d8$var$isPromise = $bf171e426cf417d8$require$_require$types.isPromise, $bf171e426cf417d8$var$isRegExp = $bf171e426cf417d8$require$_require$types.isRegExp;

var $bf171e426cf417d8$var$objectAssign = (parcelRequire("lp0oE"))();

var $bf171e426cf417d8$var$objectIs = (parcelRequire("eoHrM"))();

var $bf171e426cf417d8$var$RegExpPrototypeTest = (parcelRequire("34Xrk"))('RegExp.prototype.test');
var $bf171e426cf417d8$var$errorCache = new Map();
var $bf171e426cf417d8$var$isDeepEqual;
var $bf171e426cf417d8$var$isDeepStrictEqual;
var $bf171e426cf417d8$var$parseExpressionAt;
var $bf171e426cf417d8$var$findNodeAround;
var $bf171e426cf417d8$var$decoder;

function $bf171e426cf417d8$var$lazyLoadComparison() {
    var comparison = (parcelRequire("cPQKq"));
    $bf171e426cf417d8$var$isDeepEqual = comparison.isDeepEqual;
    $bf171e426cf417d8$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $bf171e426cf417d8$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $bf171e426cf417d8$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $bf171e426cf417d8$var$escapeFn = function escapeFn(str) {
    return $bf171e426cf417d8$var$meta[str.charCodeAt(0)];
};
var $bf171e426cf417d8$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $bf171e426cf417d8$var$assert = module.exports = $bf171e426cf417d8$var$ok;
var $bf171e426cf417d8$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $bf171e426cf417d8$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $bZlr9(obj);
}
function $bf171e426cf417d8$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($bf171e426cf417d8$var$warned === false) {
            $bf171e426cf417d8$var$warned = true;
            var warn = $djlMn.emitWarning ? $djlMn.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $bf171e426cf417d8$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $bZlr9(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$bf171e426cf417d8$var$assert.fail = $bf171e426cf417d8$var$fail;
// The AssertionError is defined in internal/error.
$bf171e426cf417d8$var$assert.AssertionError = $bZlr9;
function $bf171e426cf417d8$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $bZlr9({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $bf171e426cf417d8$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $bf171e426cf417d8$var$innerOk.apply(void 0, [
        $bf171e426cf417d8$var$ok,
        args.length
    ].concat(args));
}
$bf171e426cf417d8$var$assert.ok = $bf171e426cf417d8$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $bf171e426cf417d8$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$bf171e426cf417d8$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$bf171e426cf417d8$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($bf171e426cf417d8$var$isDeepEqual === undefined) $bf171e426cf417d8$var$lazyLoadComparison();
    if (!$bf171e426cf417d8$var$isDeepEqual(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$bf171e426cf417d8$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($bf171e426cf417d8$var$isDeepEqual === undefined) $bf171e426cf417d8$var$lazyLoadComparison();
    if ($bf171e426cf417d8$var$isDeepEqual(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $bf171e426cf417d8$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($bf171e426cf417d8$var$isDeepEqual === undefined) $bf171e426cf417d8$var$lazyLoadComparison();
    if (!$bf171e426cf417d8$var$isDeepStrictEqual(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$bf171e426cf417d8$var$assert.notDeepStrictEqual = $bf171e426cf417d8$var$notDeepStrictEqual;
function $bf171e426cf417d8$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($bf171e426cf417d8$var$isDeepEqual === undefined) $bf171e426cf417d8$var$lazyLoadComparison();
    if ($bf171e426cf417d8$var$isDeepStrictEqual(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $bf171e426cf417d8$var$notDeepStrictEqual
    });
}
$bf171e426cf417d8$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$bf171e426cf417d8$var$objectIs(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$bf171e426cf417d8$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($bf171e426cf417d8$var$objectIs(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $bf171e426cf417d8$var$Comparison = /*#__PURE__*/ $bf171e426cf417d8$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $bf171e426cf417d8$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $bf171e426cf417d8$var$isRegExp(obj[key]) && $bf171e426cf417d8$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $bf171e426cf417d8$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$bf171e426cf417d8$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $bf171e426cf417d8$var$Comparison(actual, keys);
            var b = new $bf171e426cf417d8$var$Comparison(expected, keys, actual);
            var err = new $bZlr9({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $bf171e426cf417d8$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $bf171e426cf417d8$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($bf171e426cf417d8$var$isRegExp(expected)) return $bf171e426cf417d8$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($bf171e426cf417d8$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $bZlr9({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($bf171e426cf417d8$var$isDeepEqual === undefined) $bf171e426cf417d8$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $bf171e426cf417d8$var$isRegExp(expected[key]) && $bf171e426cf417d8$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $bf171e426cf417d8$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $bf171e426cf417d8$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $bf171e426cf417d8$var$NO_EXCEPTION_SENTINEL;
}
function $bf171e426cf417d8$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $bf171e426cf417d8$var$isPromise(obj) || obj !== null && $bf171e426cf417d8$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $bf171e426cf417d8$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$bf171e426cf417d8$var$checkIsPromise(resultPromise)) throw new $bf171e426cf417d8$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($bf171e426cf417d8$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $bf171e426cf417d8$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $bf171e426cf417d8$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($bf171e426cf417d8$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $bf171e426cf417d8$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $bf171e426cf417d8$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $bf171e426cf417d8$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $bf171e426cf417d8$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $bf171e426cf417d8$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$bf171e426cf417d8$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $bf171e426cf417d8$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $bf171e426cf417d8$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $bf171e426cf417d8$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $bf171e426cf417d8$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$bf171e426cf417d8$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $bf171e426cf417d8$var$expectsError.apply(void 0, [
        throws,
        $bf171e426cf417d8$var$getActual(promiseFn)
    ].concat(args));
};
$bf171e426cf417d8$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $bf171e426cf417d8$var$waitForActual(promiseFn).then(function(result) {
        return $bf171e426cf417d8$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$bf171e426cf417d8$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $bf171e426cf417d8$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $bf171e426cf417d8$var$getActual(fn)
    ].concat(args));
};
$bf171e426cf417d8$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $bf171e426cf417d8$var$waitForActual(fn).then(function(result) {
        return $bf171e426cf417d8$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$bf171e426cf417d8$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($bf171e426cf417d8$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $bf171e426cf417d8$var$inspect(err);
        var newErr = new $bZlr9({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $bf171e426cf417d8$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$bf171e426cf417d8$var$isRegExp(regexp)) throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $bf171e426cf417d8$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($bf171e426cf417d8$var$_typeof(string), " (").concat($bf171e426cf417d8$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($bf171e426cf417d8$var$inspect(regexp), ". Input:\n\n").concat($bf171e426cf417d8$var$inspect(string), "\n"));
        var err = new $bZlr9({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$bf171e426cf417d8$var$assert.match = function match(string, regexp, message) {
    $bf171e426cf417d8$var$internalMatch(string, regexp, message, match, 'match');
};
$bf171e426cf417d8$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $bf171e426cf417d8$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $bf171e426cf417d8$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $bf171e426cf417d8$var$innerOk.apply(void 0, [
        $bf171e426cf417d8$var$strict,
        args.length
    ].concat(args));
}
$bf171e426cf417d8$var$assert.strict = $bf171e426cf417d8$var$objectAssign($bf171e426cf417d8$var$strict, $bf171e426cf417d8$var$assert, {
    equal: $bf171e426cf417d8$var$assert.strictEqual,
    deepEqual: $bf171e426cf417d8$var$assert.deepStrictEqual,
    notEqual: $bf171e426cf417d8$var$assert.notStrictEqual,
    notDeepEqual: $bf171e426cf417d8$var$assert.notDeepStrictEqual
});
$bf171e426cf417d8$var$assert.strict.strict = $bf171e426cf417d8$var$assert.strict;

});
parcelRegister("84ZjD", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $5e1e427abaa94f3a$export$e45cb6485273080e; }, function (v) { return $5e1e427abaa94f3a$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $5e1e427abaa94f3a$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $5e1e427abaa94f3a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5e1e427abaa94f3a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5e1e427abaa94f3a$var$_typeof(o);
}
function $5e1e427abaa94f3a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5e1e427abaa94f3a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5e1e427abaa94f3a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5e1e427abaa94f3a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5e1e427abaa94f3a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5e1e427abaa94f3a$var$_toPropertyKey(arg) {
    var key = $5e1e427abaa94f3a$var$_toPrimitive(arg, "string");
    return $5e1e427abaa94f3a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5e1e427abaa94f3a$var$_toPrimitive(input, hint) {
    if ($5e1e427abaa94f3a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5e1e427abaa94f3a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5e1e427abaa94f3a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5e1e427abaa94f3a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5e1e427abaa94f3a$var$_setPrototypeOf(subClass, superClass);
}
function $5e1e427abaa94f3a$var$_setPrototypeOf(o, p) {
    $5e1e427abaa94f3a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5e1e427abaa94f3a$var$_setPrototypeOf(o, p);
}
function $5e1e427abaa94f3a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5e1e427abaa94f3a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5e1e427abaa94f3a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5e1e427abaa94f3a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5e1e427abaa94f3a$var$_possibleConstructorReturn(this, result);
    };
}
function $5e1e427abaa94f3a$var$_possibleConstructorReturn(self, call) {
    if (call && ($5e1e427abaa94f3a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5e1e427abaa94f3a$var$_assertThisInitialized(self);
}
function $5e1e427abaa94f3a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5e1e427abaa94f3a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5e1e427abaa94f3a$var$_getPrototypeOf(o) {
    $5e1e427abaa94f3a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5e1e427abaa94f3a$var$_getPrototypeOf(o);
}
var $5e1e427abaa94f3a$var$codes = {};
// Lazy loaded
var $5e1e427abaa94f3a$var$assert;
var $5e1e427abaa94f3a$var$util;
function $5e1e427abaa94f3a$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $5e1e427abaa94f3a$var$_inherits(NodeError, _Base);
        var _super = $5e1e427abaa94f3a$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $5e1e427abaa94f3a$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $5e1e427abaa94f3a$var$_createClass(NodeError);
    }(Base);
    $5e1e427abaa94f3a$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $5e1e427abaa94f3a$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $5e1e427abaa94f3a$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $5e1e427abaa94f3a$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $5e1e427abaa94f3a$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$5e1e427abaa94f3a$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$5e1e427abaa94f3a$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($5e1e427abaa94f3a$var$assert === undefined) $5e1e427abaa94f3a$var$assert = (parcelRequire("gpaur"));
    $5e1e427abaa94f3a$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $5e1e427abaa94f3a$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($5e1e427abaa94f3a$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($5e1e427abaa94f3a$var$oneOf(expected, 'type'));
    else {
        var type = $5e1e427abaa94f3a$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($5e1e427abaa94f3a$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($5e1e427abaa94f3a$var$_typeof(actual));
    return msg;
}, TypeError);

$5e1e427abaa94f3a$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($5e1e427abaa94f3a$var$util === undefined) $5e1e427abaa94f3a$var$util = (parcelRequire("eqWSa"));
    var inspected = $5e1e427abaa94f3a$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$5e1e427abaa94f3a$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($5e1e427abaa94f3a$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$5e1e427abaa94f3a$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($5e1e427abaa94f3a$var$assert === undefined) $5e1e427abaa94f3a$var$assert = (parcelRequire("gpaur"));
    $5e1e427abaa94f3a$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$5e1e427abaa94f3a$export$e45cb6485273080e = $5e1e427abaa94f3a$var$codes;

});

parcelRegister("bZlr9", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $djlMn = parcelRequire("djlMn");
'use strict';
function $8ba60529e2f61891$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ba60529e2f61891$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ba60529e2f61891$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8ba60529e2f61891$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ba60529e2f61891$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8ba60529e2f61891$var$_defineProperty(obj, key, value) {
    key = $8ba60529e2f61891$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8ba60529e2f61891$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8ba60529e2f61891$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8ba60529e2f61891$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8ba60529e2f61891$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8ba60529e2f61891$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8ba60529e2f61891$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8ba60529e2f61891$var$_toPropertyKey(arg) {
    var key = $8ba60529e2f61891$var$_toPrimitive(arg, "string");
    return $8ba60529e2f61891$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8ba60529e2f61891$var$_toPrimitive(input, hint) {
    if ($8ba60529e2f61891$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8ba60529e2f61891$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8ba60529e2f61891$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8ba60529e2f61891$var$_setPrototypeOf(subClass, superClass);
}
function $8ba60529e2f61891$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8ba60529e2f61891$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8ba60529e2f61891$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8ba60529e2f61891$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8ba60529e2f61891$var$_possibleConstructorReturn(this, result);
    };
}
function $8ba60529e2f61891$var$_possibleConstructorReturn(self, call) {
    if (call && ($8ba60529e2f61891$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8ba60529e2f61891$var$_assertThisInitialized(self);
}
function $8ba60529e2f61891$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8ba60529e2f61891$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $8ba60529e2f61891$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$8ba60529e2f61891$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $8ba60529e2f61891$var$_construct(Class, arguments, $8ba60529e2f61891$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $8ba60529e2f61891$var$_setPrototypeOf(Wrapper, Class);
    };
    return $8ba60529e2f61891$var$_wrapNativeSuper(Class);
}
function $8ba60529e2f61891$var$_construct(Parent, args, Class) {
    if ($8ba60529e2f61891$var$_isNativeReflectConstruct()) $8ba60529e2f61891$var$_construct = Reflect.construct.bind();
    else $8ba60529e2f61891$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $8ba60529e2f61891$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $8ba60529e2f61891$var$_construct.apply(null, arguments);
}
function $8ba60529e2f61891$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8ba60529e2f61891$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $8ba60529e2f61891$var$_setPrototypeOf(o, p) {
    $8ba60529e2f61891$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8ba60529e2f61891$var$_setPrototypeOf(o, p);
}
function $8ba60529e2f61891$var$_getPrototypeOf(o) {
    $8ba60529e2f61891$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8ba60529e2f61891$var$_getPrototypeOf(o);
}
function $8ba60529e2f61891$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8ba60529e2f61891$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8ba60529e2f61891$var$_typeof(o);
}

var $eqWSa = parcelRequire("eqWSa");
var $8ba60529e2f61891$var$inspect = $eqWSa.inspect;

var $84ZjD = parcelRequire("84ZjD");
var $8ba60529e2f61891$var$ERR_INVALID_ARG_TYPE = $84ZjD.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $8ba60529e2f61891$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $8ba60529e2f61891$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $8ba60529e2f61891$var$blue = '';
var $8ba60529e2f61891$var$green = '';
var $8ba60529e2f61891$var$red = '';
var $8ba60529e2f61891$var$white = '';
var $8ba60529e2f61891$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $8ba60529e2f61891$var$kMaxShortLength = 10;
function $8ba60529e2f61891$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $8ba60529e2f61891$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $8ba60529e2f61891$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $8ba60529e2f61891$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $8ba60529e2f61891$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $8ba60529e2f61891$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $8ba60529e2f61891$var$_typeof(actual) === 'object' && $8ba60529e2f61891$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $8ba60529e2f61891$var$kMaxShortLength) {
            if (($8ba60529e2f61891$var$_typeof(actual) !== 'object' || actual === null) && ($8ba60529e2f61891$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($8ba60529e2f61891$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $djlMn.stderr && $djlMn.stderr.isTTY ? $djlMn.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($8ba60529e2f61891$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($8ba60529e2f61891$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $8ba60529e2f61891$var$kReadableOperator[operator] + "\n".concat($8ba60529e2f61891$var$green, "+ actual").concat($8ba60529e2f61891$var$white, " ").concat($8ba60529e2f61891$var$red, "- expected").concat($8ba60529e2f61891$var$white);
    var skippedMsg = " ".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($8ba60529e2f61891$var$red, "-").concat($8ba60529e2f61891$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($8ba60529e2f61891$var$green, "+").concat($8ba60529e2f61891$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$8ba60529e2f61891$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $8ba60529e2f61891$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($8ba60529e2f61891$var$green, "+").concat($8ba60529e2f61891$var$white, " ").concat(actualLine);
                other += "\n".concat($8ba60529e2f61891$var$red, "-").concat($8ba60529e2f61891$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white).concat(other, "\n") + "".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $8ba60529e2f61891$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $8ba60529e2f61891$var$_inherits(AssertionError, _Error);
    var _super = $8ba60529e2f61891$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $8ba60529e2f61891$var$_classCallCheck(this, AssertionError);
        if ($8ba60529e2f61891$var$_typeof(options) !== 'object' || options === null) throw new $8ba60529e2f61891$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($djlMn.stderr && $djlMn.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($djlMn.stderr && $djlMn.stderr.getColorDepth && $djlMn.stderr.getColorDepth() !== 1) {
                    $8ba60529e2f61891$var$blue = "\x1B[34m";
                    $8ba60529e2f61891$var$green = "\x1B[32m";
                    $8ba60529e2f61891$var$white = "\x1B[39m";
                    $8ba60529e2f61891$var$red = "\x1B[31m";
                } else {
                    $8ba60529e2f61891$var$blue = '';
                    $8ba60529e2f61891$var$green = '';
                    $8ba60529e2f61891$var$white = '';
                    $8ba60529e2f61891$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($8ba60529e2f61891$var$_typeof(actual) === 'object' && actual !== null && $8ba60529e2f61891$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $8ba60529e2f61891$var$copyError(actual);
                expected = $8ba60529e2f61891$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $8ba60529e2f61891$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $8ba60529e2f61891$var$kReadableOperator[operator];
                var res = $8ba60529e2f61891$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $8ba60529e2f61891$var$_typeof(actual) === 'object' && actual !== null) base = $8ba60529e2f61891$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $8ba60529e2f61891$var$inspectValue(actual);
                var other = '';
                var knownOperators = $8ba60529e2f61891$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($8ba60529e2f61891$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($8ba60529e2f61891$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($8ba60529e2f61891$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($8ba60529e2f61891$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $8ba60529e2f61891$var$_possibleConstructorReturn(_this);
    }
    $8ba60529e2f61891$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $8ba60529e2f61891$var$inspect(this, $8ba60529e2f61891$var$_objectSpread($8ba60529e2f61891$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $8ba60529e2f61891$var$_wrapNativeSuper(Error), $8ba60529e2f61891$var$inspect.custom);
module.exports = $8ba60529e2f61891$var$AssertionError;

});

parcelRegister("lp0oE", function(module, exports) {
'use strict';

var $gibqm = parcelRequire("gibqm");
var $f94c3d8d0e8b40cb$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $f94c3d8d0e8b40cb$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $gibqm;
    if ($f94c3d8d0e8b40cb$var$lacksProperEnumerationOrder()) return $gibqm;
    if ($f94c3d8d0e8b40cb$var$assignHasPendingExceptions()) return $gibqm;
    return Object.assign;
};

});
parcelRegister("gibqm", function(module, exports) {
'use strict';

var $eYsiZ = parcelRequire("eYsiZ");

var $bdc730658ec9aab4$var$hasSymbols = (parcelRequire("1TyHV"))();

var $9krxM = parcelRequire("9krxM");

var $irzZH = parcelRequire("irzZH");
var $bdc730658ec9aab4$var$$push = $9krxM('Array.prototype.push');
var $bdc730658ec9aab4$var$$propIsEnumerable = $9krxM('Object.prototype.propertyIsEnumerable');
var $bdc730658ec9aab4$var$originalGetSymbols = $bdc730658ec9aab4$var$hasSymbols ? $irzZH.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $irzZH(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $irzZH(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $eYsiZ(from);
        var getSymbols = $bdc730658ec9aab4$var$hasSymbols && ($irzZH.getOwnPropertySymbols || $bdc730658ec9aab4$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($bdc730658ec9aab4$var$$propIsEnumerable(from, key)) $bdc730658ec9aab4$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($bdc730658ec9aab4$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("eYsiZ", function(module, exports) {
'use strict';
var $ae6ca0233735d307$var$slice = Array.prototype.slice;

var $jmQGs = parcelRequire("jmQGs");
var $ae6ca0233735d307$var$origKeys = Object.keys;

var $ae6ca0233735d307$var$keysShim = $ae6ca0233735d307$var$origKeys ? function keys(o) {
    return $ae6ca0233735d307$var$origKeys(o);
} : (parcelRequire("7I8vG"));
var $ae6ca0233735d307$var$originalKeys = Object.keys;
$ae6ca0233735d307$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($jmQGs(object)) return $ae6ca0233735d307$var$originalKeys($ae6ca0233735d307$var$slice.call(object));
            return $ae6ca0233735d307$var$originalKeys(object);
        };
    } else Object.keys = $ae6ca0233735d307$var$keysShim;
    return Object.keys || $ae6ca0233735d307$var$keysShim;
};
module.exports = $ae6ca0233735d307$var$keysShim;

});
parcelRegister("jmQGs", function(module, exports) {
'use strict';
var $e198f04eabdd4d1a$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $e198f04eabdd4d1a$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $e198f04eabdd4d1a$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("7I8vG", function(module, exports) {
'use strict';
var $59d33e6135c61ca9$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $59d33e6135c61ca9$var$has = Object.prototype.hasOwnProperty;
    var $59d33e6135c61ca9$var$toStr = Object.prototype.toString;
    var $59d33e6135c61ca9$var$isArgs = (parcelRequire("jmQGs")); // eslint-disable-line global-require
    var $59d33e6135c61ca9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $59d33e6135c61ca9$var$hasDontEnumBug = !$59d33e6135c61ca9$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $59d33e6135c61ca9$var$hasProtoEnumBug = $59d33e6135c61ca9$var$isEnumerable.call(function() {}, 'prototype');
    var $59d33e6135c61ca9$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $59d33e6135c61ca9$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $59d33e6135c61ca9$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $59d33e6135c61ca9$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$59d33e6135c61ca9$var$excludedKeys['$' + k] && $59d33e6135c61ca9$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $59d33e6135c61ca9$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $59d33e6135c61ca9$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$59d33e6135c61ca9$var$hasAutomationEqualityBug) return $59d33e6135c61ca9$var$equalsConstructorPrototype(o);
        try {
            return $59d33e6135c61ca9$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $59d33e6135c61ca9$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $59d33e6135c61ca9$var$toStr.call(object) === '[object Function]';
        var isArguments = $59d33e6135c61ca9$var$isArgs(object);
        var isString = isObject && $59d33e6135c61ca9$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $59d33e6135c61ca9$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$59d33e6135c61ca9$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $59d33e6135c61ca9$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($59d33e6135c61ca9$var$hasDontEnumBug) {
            var skipConstructor = $59d33e6135c61ca9$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $59d33e6135c61ca9$var$dontEnums.length; ++k)if (!(skipConstructor && $59d33e6135c61ca9$var$dontEnums[k] === 'constructor') && $59d33e6135c61ca9$var$has.call(object, $59d33e6135c61ca9$var$dontEnums[k])) theKeys.push($59d33e6135c61ca9$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $59d33e6135c61ca9$var$keysShim;

});




parcelRegister("eoHrM", function(module, exports) {
'use strict';

var $bF0Xx = parcelRequire("bF0Xx");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $bF0Xx;
};

});
parcelRegister("bF0Xx", function(module, exports) {
'use strict';
var $87d4448ae9927229$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($87d4448ae9927229$var$numberIsNaN(a) && $87d4448ae9927229$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("34Xrk", function(module, exports) {
'use strict';

var $fZZOm = parcelRequire("fZZOm");

var $aebgU = parcelRequire("aebgU");
var $23dfda4de8857a25$var$$indexOf = $aebgU($fZZOm('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $fZZOm(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $23dfda4de8857a25$var$$indexOf(name, '.prototype.') > -1) return $aebgU(intrinsic);
    return intrinsic;
};

});

parcelRegister("cPQKq", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $95832a0e0058e662$var$_slicedToArray(arr, i) {
    return $95832a0e0058e662$var$_arrayWithHoles(arr) || $95832a0e0058e662$var$_iterableToArrayLimit(arr, i) || $95832a0e0058e662$var$_unsupportedIterableToArray(arr, i) || $95832a0e0058e662$var$_nonIterableRest();
}
function $95832a0e0058e662$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $95832a0e0058e662$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $95832a0e0058e662$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $95832a0e0058e662$var$_arrayLikeToArray(o, minLen);
}
function $95832a0e0058e662$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $95832a0e0058e662$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $95832a0e0058e662$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $95832a0e0058e662$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $95832a0e0058e662$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $95832a0e0058e662$var$_typeof(o);
}
var $95832a0e0058e662$var$regexFlagsSupported = /a/g.flags !== undefined;
var $95832a0e0058e662$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $95832a0e0058e662$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $95832a0e0058e662$var$objectIs = Object.is ? Object.is : (parcelRequire("1Wpr8"));
var $95832a0e0058e662$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $95832a0e0058e662$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("80C6L"));
function $95832a0e0058e662$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $95832a0e0058e662$var$hasOwnProperty = $95832a0e0058e662$var$uncurryThis(Object.prototype.hasOwnProperty);
var $95832a0e0058e662$var$propertyIsEnumerable = $95832a0e0058e662$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $95832a0e0058e662$var$objectToString = $95832a0e0058e662$var$uncurryThis(Object.prototype.toString);

var $eqWSa = parcelRequire("eqWSa");
var $95832a0e0058e662$require$_require$types = $eqWSa.types;
var $95832a0e0058e662$var$isAnyArrayBuffer = $95832a0e0058e662$require$_require$types.isAnyArrayBuffer, $95832a0e0058e662$var$isArrayBufferView = $95832a0e0058e662$require$_require$types.isArrayBufferView, $95832a0e0058e662$var$isDate = $95832a0e0058e662$require$_require$types.isDate, $95832a0e0058e662$var$isMap = $95832a0e0058e662$require$_require$types.isMap, $95832a0e0058e662$var$isRegExp = $95832a0e0058e662$require$_require$types.isRegExp, $95832a0e0058e662$var$isSet = $95832a0e0058e662$require$_require$types.isSet, $95832a0e0058e662$var$isNativeError = $95832a0e0058e662$require$_require$types.isNativeError, $95832a0e0058e662$var$isBoxedPrimitive = $95832a0e0058e662$require$_require$types.isBoxedPrimitive, $95832a0e0058e662$var$isNumberObject = $95832a0e0058e662$require$_require$types.isNumberObject, $95832a0e0058e662$var$isStringObject = $95832a0e0058e662$require$_require$types.isStringObject, $95832a0e0058e662$var$isBooleanObject = $95832a0e0058e662$require$_require$types.isBooleanObject, $95832a0e0058e662$var$isBigIntObject = $95832a0e0058e662$require$_require$types.isBigIntObject, $95832a0e0058e662$var$isSymbolObject = $95832a0e0058e662$require$_require$types.isSymbolObject, $95832a0e0058e662$var$isFloat32Array = $95832a0e0058e662$require$_require$types.isFloat32Array, $95832a0e0058e662$var$isFloat64Array = $95832a0e0058e662$require$_require$types.isFloat64Array;
function $95832a0e0058e662$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $95832a0e0058e662$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($95832a0e0058e662$var$isNonIndex).concat($95832a0e0058e662$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $95832a0e0058e662$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $95832a0e0058e662$var$ONLY_ENUMERABLE = undefined;
var $95832a0e0058e662$var$kStrict = true;
var $95832a0e0058e662$var$kLoose = false;
var $95832a0e0058e662$var$kNoIterator = 0;
var $95832a0e0058e662$var$kIsArray = 1;
var $95832a0e0058e662$var$kIsSet = 2;
var $95832a0e0058e662$var$kIsMap = 3;
// Check if they have the same source and flags
function $95832a0e0058e662$var$areSimilarRegExps(a, b) {
    return $95832a0e0058e662$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $95832a0e0058e662$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $95832a0e0058e662$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $95832a0e0058e662$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $95832a0e0058e662$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $95832a0e0058e662$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $95832a0e0058e662$var$isEqualBoxedPrimitive(val1, val2) {
    if ($95832a0e0058e662$var$isNumberObject(val1)) return $95832a0e0058e662$var$isNumberObject(val2) && $95832a0e0058e662$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($95832a0e0058e662$var$isStringObject(val1)) return $95832a0e0058e662$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($95832a0e0058e662$var$isBooleanObject(val1)) return $95832a0e0058e662$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($95832a0e0058e662$var$isBigIntObject(val1)) return $95832a0e0058e662$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $95832a0e0058e662$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $95832a0e0058e662$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $95832a0e0058e662$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($95832a0e0058e662$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $95832a0e0058e662$var$numberIsNaN(val1) && $95832a0e0058e662$var$numberIsNaN(val2);
        if ($95832a0e0058e662$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $95832a0e0058e662$var$_typeof(val1) !== 'object') {
            if (val2 === null || $95832a0e0058e662$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $95832a0e0058e662$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $95832a0e0058e662$var$objectToString(val1);
    var val2Tag = $95832a0e0058e662$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $95832a0e0058e662$var$getOwnNonIndexProperties(val1, $95832a0e0058e662$var$ONLY_ENUMERABLE);
        var keys2 = $95832a0e0058e662$var$getOwnNonIndexProperties(val2, $95832a0e0058e662$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, $95832a0e0058e662$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$95832a0e0058e662$var$isMap(val1) && $95832a0e0058e662$var$isMap(val2) || !$95832a0e0058e662$var$isSet(val1) && $95832a0e0058e662$var$isSet(val2)) return false;
    }
    if ($95832a0e0058e662$var$isDate(val1)) {
        if (!$95832a0e0058e662$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($95832a0e0058e662$var$isRegExp(val1)) {
        if (!$95832a0e0058e662$var$isRegExp(val2) || !$95832a0e0058e662$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($95832a0e0058e662$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($95832a0e0058e662$var$isArrayBufferView(val1)) {
        if (!strict && ($95832a0e0058e662$var$isFloat32Array(val1) || $95832a0e0058e662$var$isFloat64Array(val1))) {
            if (!$95832a0e0058e662$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$95832a0e0058e662$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $95832a0e0058e662$var$getOwnNonIndexProperties(val1, $95832a0e0058e662$var$ONLY_ENUMERABLE);
        var _keys2 = $95832a0e0058e662$var$getOwnNonIndexProperties(val2, $95832a0e0058e662$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, $95832a0e0058e662$var$kNoIterator, _keys);
    } else if ($95832a0e0058e662$var$isSet(val1)) {
        if (!$95832a0e0058e662$var$isSet(val2) || val1.size !== val2.size) return false;
        return $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, $95832a0e0058e662$var$kIsSet);
    } else if ($95832a0e0058e662$var$isMap(val1)) {
        if (!$95832a0e0058e662$var$isMap(val2) || val1.size !== val2.size) return false;
        return $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, $95832a0e0058e662$var$kIsMap);
    } else if ($95832a0e0058e662$var$isAnyArrayBuffer(val1)) {
        if (!$95832a0e0058e662$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($95832a0e0058e662$var$isBoxedPrimitive(val1) && !$95832a0e0058e662$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, $95832a0e0058e662$var$kNoIterator);
}
function $95832a0e0058e662$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $95832a0e0058e662$var$propertyIsEnumerable(val, k);
    });
}
function $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$95832a0e0058e662$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $95832a0e0058e662$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($95832a0e0058e662$var$propertyIsEnumerable(val1, key)) {
                    if (!$95832a0e0058e662$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($95832a0e0058e662$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $95832a0e0058e662$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $95832a0e0058e662$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $95832a0e0058e662$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $95832a0e0058e662$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $95832a0e0058e662$var$kNoIterator || iterationType === $95832a0e0058e662$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $95832a0e0058e662$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $95832a0e0058e662$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $95832a0e0058e662$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($95832a0e0058e662$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $95832a0e0058e662$var$findLooseMatchingPrimitives(prim) {
    switch($95832a0e0058e662$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($95832a0e0058e662$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $95832a0e0058e662$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $95832a0e0058e662$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $95832a0e0058e662$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $95832a0e0058e662$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$95832a0e0058e662$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $95832a0e0058e662$var$innerDeepEqual(item, curB, false, memo);
}
function $95832a0e0058e662$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $95832a0e0058e662$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($95832a0e0058e662$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$95832a0e0058e662$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $95832a0e0058e662$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($95832a0e0058e662$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$95832a0e0058e662$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$95832a0e0058e662$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $95832a0e0058e662$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $95832a0e0058e662$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($95832a0e0058e662$var$innerDeepEqual(key1, key2, strict, memo) && $95832a0e0058e662$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $95832a0e0058e662$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $95832a0e0058e662$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $95832a0e0058e662$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($95832a0e0058e662$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$95832a0e0058e662$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$95832a0e0058e662$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $95832a0e0058e662$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $95832a0e0058e662$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($95832a0e0058e662$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$95832a0e0058e662$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$95832a0e0058e662$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$95832a0e0058e662$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $95832a0e0058e662$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $95832a0e0058e662$var$kIsSet) {
        if (!$95832a0e0058e662$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $95832a0e0058e662$var$kIsMap) {
        if (!$95832a0e0058e662$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $95832a0e0058e662$var$kIsArray) for(; i < a.length; i++){
        if ($95832a0e0058e662$var$hasOwnProperty(a, i)) {
            if (!$95832a0e0058e662$var$hasOwnProperty(b, i) || !$95832a0e0058e662$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($95832a0e0058e662$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$95832a0e0058e662$var$hasOwnProperty(b, key) || !$95832a0e0058e662$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$95832a0e0058e662$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $95832a0e0058e662$var$isDeepEqual(val1, val2) {
    return $95832a0e0058e662$var$innerDeepEqual(val1, val2, $95832a0e0058e662$var$kLoose);
}
function $95832a0e0058e662$var$isDeepStrictEqual(val1, val2) {
    return $95832a0e0058e662$var$innerDeepEqual(val1, val2, $95832a0e0058e662$var$kStrict);
}
module.exports = {
    isDeepEqual: $95832a0e0058e662$var$isDeepEqual,
    isDeepStrictEqual: $95832a0e0058e662$var$isDeepStrictEqual
};

});
parcelRegister("1Wpr8", function(module, exports) {
'use strict';

var $QqlOB = parcelRequire("QqlOB");

var $aebgU = parcelRequire("aebgU");

var $bF0Xx = parcelRequire("bF0Xx");

var $eoHrM = parcelRequire("eoHrM");

var $e0pCW = parcelRequire("e0pCW");
var $169ef06e1496fb76$var$polyfill = $aebgU($eoHrM(), Object);
$QqlOB($169ef06e1496fb76$var$polyfill, {
    getPolyfill: $eoHrM,
    implementation: $bF0Xx,
    shim: $e0pCW
});
module.exports = $169ef06e1496fb76$var$polyfill;

});
parcelRegister("QqlOB", function(module, exports) {
'use strict';

var $eYsiZ = parcelRequire("eYsiZ");
var $09d94c2cd5f62246$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $09d94c2cd5f62246$var$toStr = Object.prototype.toString;
var $09d94c2cd5f62246$var$concat = Array.prototype.concat;

var $2rrwJ = parcelRequire("2rrwJ");
var $09d94c2cd5f62246$var$isFunction = function(fn) {
    return typeof fn === 'function' && $09d94c2cd5f62246$var$toStr.call(fn) === '[object Function]';
};

var $09d94c2cd5f62246$var$supportsDescriptors = (parcelRequire("dkM7t"))();
var $09d94c2cd5f62246$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$09d94c2cd5f62246$var$isFunction(predicate) || !predicate()) return;
    }
    if ($09d94c2cd5f62246$var$supportsDescriptors) $2rrwJ(object, name, value, true);
    else $2rrwJ(object, name, value);
};
var $09d94c2cd5f62246$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $eYsiZ(map);
    if ($09d94c2cd5f62246$var$hasSymbols) props = $09d94c2cd5f62246$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$09d94c2cd5f62246$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$09d94c2cd5f62246$var$defineProperties.supportsDescriptors = !!$09d94c2cd5f62246$var$supportsDescriptors;
module.exports = $09d94c2cd5f62246$var$defineProperties;

});

parcelRegister("e0pCW", function(module, exports) {
'use strict';

var $eoHrM = parcelRequire("eoHrM");

var $QqlOB = parcelRequire("QqlOB");
module.exports = function shimObjectIs() {
    var polyfill = $eoHrM();
    $QqlOB(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("80C6L", function(module, exports) {
'use strict';

var $aebgU = parcelRequire("aebgU");

var $QqlOB = parcelRequire("QqlOB");

var $fKB3l = parcelRequire("fKB3l");

var $ic5eo = parcelRequire("ic5eo");

var $dtR1B = parcelRequire("dtR1B");
var $5d4be24a5caa8855$var$polyfill = $aebgU($ic5eo(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $QqlOB($5d4be24a5caa8855$var$polyfill, {
    getPolyfill: $ic5eo,
    implementation: $fKB3l,
    shim: $dtR1B
});
module.exports = $5d4be24a5caa8855$var$polyfill;

});
parcelRegister("fKB3l", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("ic5eo", function(module, exports) {
'use strict';

var $fKB3l = parcelRequire("fKB3l");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $fKB3l;
};

});

parcelRegister("dtR1B", function(module, exports) {
'use strict';

var $QqlOB = parcelRequire("QqlOB");

var $ic5eo = parcelRequire("ic5eo");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $ic5eo();
    $QqlOB(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("8wQss", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $635a00f27fafc33c$export$306c0aa65ff9ec16; }, function (v) { return $635a00f27fafc33c$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $635a00f27fafc33c$export$306c0aa65ff9ec16;
"use strict";

var $8nGP5 = parcelRequire("8nGP5");
function $635a00f27fafc33c$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $635a00f27fafc33c$var$objectIs = "function" === typeof Object.is ? Object.is : $635a00f27fafc33c$var$is, $635a00f27fafc33c$var$useState = $8nGP5.useState, $635a00f27fafc33c$var$useEffect = $8nGP5.useEffect, $635a00f27fafc33c$var$useLayoutEffect = $8nGP5.useLayoutEffect, $635a00f27fafc33c$var$useDebugValue = $8nGP5.useDebugValue;
function $635a00f27fafc33c$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $635a00f27fafc33c$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $635a00f27fafc33c$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $635a00f27fafc33c$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $635a00f27fafc33c$var$useEffect(function() {
        $635a00f27fafc33c$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $635a00f27fafc33c$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $635a00f27fafc33c$var$useDebugValue(value);
    return value;
}
function $635a00f27fafc33c$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$635a00f27fafc33c$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $635a00f27fafc33c$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $635a00f27fafc33c$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $635a00f27fafc33c$var$useSyncExternalStore$1 : $635a00f27fafc33c$var$useSyncExternalStore$2;
$635a00f27fafc33c$export$306c0aa65ff9ec16 = void 0 !== $8nGP5.useSyncExternalStore ? $8nGP5.useSyncExternalStore : $635a00f27fafc33c$var$shim;

});

parcelRegister("8tsi7", function(module, exports) {
function $62b6fa32bf2920ff$var$_extends() {
    return module.exports = $62b6fa32bf2920ff$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $62b6fa32bf2920ff$var$_extends.apply(null, arguments);
}
module.exports = $62b6fa32bf2920ff$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("68UY6", function(module, exports) {
function $478fae26ff98c896$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $478fae26ff98c896$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ebCsu", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a53fecd73fa4e68d$var$ReactIs, $a53fecd73fa4e68d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("3p0ZA"))();

});
parcelRegister("3p0ZA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $j82M4 = parcelRequire("j82M4");
function $27a479f8b1e67f1c$var$emptyFunction() {}
function $27a479f8b1e67f1c$var$emptyFunctionWithReset() {}
$27a479f8b1e67f1c$var$emptyFunctionWithReset.resetWarningCache = $27a479f8b1e67f1c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $j82M4) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $27a479f8b1e67f1c$var$emptyFunctionWithReset,
        resetWarningCache: $27a479f8b1e67f1c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("j82M4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $ded0ea9b72e1fb62$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $ded0ea9b72e1fb62$var$ReactPropTypesSecret;

});



parcelRegister("fX8pL", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("ajIhI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $3622a645c822ba87$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $3622a645c822ba87$export$2e2bcd8739ae039; });
function $3622a645c822ba87$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $3622a645c822ba87$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $3622a645c822ba87$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $3622a645c822ba87$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $3622a645c822ba87$export$2e2bcd8739ae039 = $3622a645c822ba87$export$4f5d2d50c9deca37;

});

parcelRegister("gdOjy", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $bcf4e3a3a1d5e159$export$a7c73072b1a182ae; }, function (v) { return $bcf4e3a3a1d5e159$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bcf4e3a3a1d5e159$export$9f27bc3417b4524d; }, function (v) { return $bcf4e3a3a1d5e159$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bcf4e3a3a1d5e159$export$db77ccec0bb4ccac; }, function (v) { return $bcf4e3a3a1d5e159$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bcf4e3a3a1d5e159$export$8392c0c9d3dcbd35; }, function (v) { return $bcf4e3a3a1d5e159$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bcf4e3a3a1d5e159$export$ffb0004e005737fa; }, function (v) { return $bcf4e3a3a1d5e159$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bcf4e3a3a1d5e159$export$b624eff549462981; }, function (v) { return $bcf4e3a3a1d5e159$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bcf4e3a3a1d5e159$export$7897aa7841a5380c; }, function (v) { return $bcf4e3a3a1d5e159$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bcf4e3a3a1d5e159$export$602eac185826482c; }, function (v) { return $bcf4e3a3a1d5e159$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bcf4e3a3a1d5e159$export$e2c29f18771995cb; }, function (v) { return $bcf4e3a3a1d5e159$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bcf4e3a3a1d5e159$export$5f8d39834fd61797; }, function (v) { return $bcf4e3a3a1d5e159$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bcf4e3a3a1d5e159$export$74bf444e3cd11ea5; }, function (v) { return $bcf4e3a3a1d5e159$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $bcf4e3a3a1d5e159$export$998bcd577473dd93; }, function (v) { return $bcf4e3a3a1d5e159$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $bcf4e3a3a1d5e159$export$92387174baf9b227; }, function (v) { return $bcf4e3a3a1d5e159$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $bcf4e3a3a1d5e159$export$ec112efeb987d9c6; }, function (v) { return $bcf4e3a3a1d5e159$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bcf4e3a3a1d5e159$export$b706b080d889d2c9; }, function (v) { return $bcf4e3a3a1d5e159$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bcf4e3a3a1d5e159$export$5be5a87408f70ddc; }, function (v) { return $bcf4e3a3a1d5e159$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bcf4e3a3a1d5e159$export$45a5e7f76e0caa8d; }, function (v) { return $bcf4e3a3a1d5e159$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bcf4e3a3a1d5e159$export$455c2e768291efa6; }, function (v) { return $bcf4e3a3a1d5e159$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bcf4e3a3a1d5e159$export$9522e17588c12572; }, function (v) { return $bcf4e3a3a1d5e159$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bcf4e3a3a1d5e159$export$2110ac352bb060b9; }, function (v) { return $bcf4e3a3a1d5e159$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bcf4e3a3a1d5e159$export$56885ab8b9c456ab; }, function (v) { return $bcf4e3a3a1d5e159$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bcf4e3a3a1d5e159$export$d927fcb6adf8f9de; }, function (v) { return $bcf4e3a3a1d5e159$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bcf4e3a3a1d5e159$export$b82d16f27459e05a; }, function (v) { return $bcf4e3a3a1d5e159$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bcf4e3a3a1d5e159$export$522c17b4f5e123e8; }, function (v) { return $bcf4e3a3a1d5e159$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bcf4e3a3a1d5e159$export$1aabd8a0274ecfd6; }, function (v) { return $bcf4e3a3a1d5e159$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $bcf4e3a3a1d5e159$export$3d6c20d97e46b957; }, function (v) { return $bcf4e3a3a1d5e159$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bcf4e3a3a1d5e159$export$9b621391a187a31a; }, function (v) { return $bcf4e3a3a1d5e159$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bcf4e3a3a1d5e159$export$f5bbd400c2f4426f; }, function (v) { return $bcf4e3a3a1d5e159$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcf4e3a3a1d5e159$export$a7c73072b1a182ae;
var $bcf4e3a3a1d5e159$export$9f27bc3417b4524d;
var $bcf4e3a3a1d5e159$export$db77ccec0bb4ccac;
var $bcf4e3a3a1d5e159$export$8392c0c9d3dcbd35;
var $bcf4e3a3a1d5e159$export$ffb0004e005737fa;
var $bcf4e3a3a1d5e159$export$b624eff549462981;
var $bcf4e3a3a1d5e159$export$7897aa7841a5380c;
var $bcf4e3a3a1d5e159$export$602eac185826482c;
var $bcf4e3a3a1d5e159$export$e2c29f18771995cb;
var $bcf4e3a3a1d5e159$export$5f8d39834fd61797;
var $bcf4e3a3a1d5e159$export$74bf444e3cd11ea5;
var $bcf4e3a3a1d5e159$export$998bcd577473dd93;
var $bcf4e3a3a1d5e159$export$92387174baf9b227;
var $bcf4e3a3a1d5e159$export$ec112efeb987d9c6;
var $bcf4e3a3a1d5e159$export$b706b080d889d2c9;
var $bcf4e3a3a1d5e159$export$5be5a87408f70ddc;
var $bcf4e3a3a1d5e159$export$45a5e7f76e0caa8d;
var $bcf4e3a3a1d5e159$export$455c2e768291efa6;
var $bcf4e3a3a1d5e159$export$9522e17588c12572;
var $bcf4e3a3a1d5e159$export$2110ac352bb060b9;
var $bcf4e3a3a1d5e159$export$56885ab8b9c456ab;
var $bcf4e3a3a1d5e159$export$d927fcb6adf8f9de;
var $bcf4e3a3a1d5e159$export$b82d16f27459e05a;
var $bcf4e3a3a1d5e159$export$522c17b4f5e123e8;
var $bcf4e3a3a1d5e159$export$1aabd8a0274ecfd6;
var $bcf4e3a3a1d5e159$export$3d6c20d97e46b957;
var $bcf4e3a3a1d5e159$export$9b621391a187a31a;
var $bcf4e3a3a1d5e159$export$f5bbd400c2f4426f;
'use strict';
var $bcf4e3a3a1d5e159$var$b = Symbol.for("react.element"), $bcf4e3a3a1d5e159$var$c = Symbol.for("react.portal"), $bcf4e3a3a1d5e159$var$d = Symbol.for("react.fragment"), $bcf4e3a3a1d5e159$var$e = Symbol.for("react.strict_mode"), $bcf4e3a3a1d5e159$var$f = Symbol.for("react.profiler"), $bcf4e3a3a1d5e159$var$g = Symbol.for("react.provider"), $bcf4e3a3a1d5e159$var$h = Symbol.for("react.context"), $bcf4e3a3a1d5e159$var$k = Symbol.for("react.server_context"), $bcf4e3a3a1d5e159$var$l = Symbol.for("react.forward_ref"), $bcf4e3a3a1d5e159$var$m = Symbol.for("react.suspense"), $bcf4e3a3a1d5e159$var$n = Symbol.for("react.suspense_list"), $bcf4e3a3a1d5e159$var$p = Symbol.for("react.memo"), $bcf4e3a3a1d5e159$var$q = Symbol.for("react.lazy"), $bcf4e3a3a1d5e159$var$t = Symbol.for("react.offscreen"), $bcf4e3a3a1d5e159$var$u;
$bcf4e3a3a1d5e159$var$u = Symbol.for("react.module.reference");
function $bcf4e3a3a1d5e159$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $bcf4e3a3a1d5e159$var$b:
                switch(a = a.type, a){
                    case $bcf4e3a3a1d5e159$var$d:
                    case $bcf4e3a3a1d5e159$var$f:
                    case $bcf4e3a3a1d5e159$var$e:
                    case $bcf4e3a3a1d5e159$var$m:
                    case $bcf4e3a3a1d5e159$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bcf4e3a3a1d5e159$var$k:
                            case $bcf4e3a3a1d5e159$var$h:
                            case $bcf4e3a3a1d5e159$var$l:
                            case $bcf4e3a3a1d5e159$var$q:
                            case $bcf4e3a3a1d5e159$var$p:
                            case $bcf4e3a3a1d5e159$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $bcf4e3a3a1d5e159$var$c:
                return r;
        }
    }
}
$bcf4e3a3a1d5e159$export$a7c73072b1a182ae = $bcf4e3a3a1d5e159$var$h;
$bcf4e3a3a1d5e159$export$9f27bc3417b4524d = $bcf4e3a3a1d5e159$var$g;
$bcf4e3a3a1d5e159$export$db77ccec0bb4ccac = $bcf4e3a3a1d5e159$var$b;
$bcf4e3a3a1d5e159$export$8392c0c9d3dcbd35 = $bcf4e3a3a1d5e159$var$l;
$bcf4e3a3a1d5e159$export$ffb0004e005737fa = $bcf4e3a3a1d5e159$var$d;
$bcf4e3a3a1d5e159$export$b624eff549462981 = $bcf4e3a3a1d5e159$var$q;
$bcf4e3a3a1d5e159$export$7897aa7841a5380c = $bcf4e3a3a1d5e159$var$p;
$bcf4e3a3a1d5e159$export$602eac185826482c = $bcf4e3a3a1d5e159$var$c;
$bcf4e3a3a1d5e159$export$e2c29f18771995cb = $bcf4e3a3a1d5e159$var$f;
$bcf4e3a3a1d5e159$export$5f8d39834fd61797 = $bcf4e3a3a1d5e159$var$e;
$bcf4e3a3a1d5e159$export$74bf444e3cd11ea5 = $bcf4e3a3a1d5e159$var$m;
$bcf4e3a3a1d5e159$export$998bcd577473dd93 = $bcf4e3a3a1d5e159$var$n;
$bcf4e3a3a1d5e159$export$92387174baf9b227 = function() {
    return !1;
};
$bcf4e3a3a1d5e159$export$ec112efeb987d9c6 = function() {
    return !1;
};
$bcf4e3a3a1d5e159$export$b706b080d889d2c9 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$h;
};
$bcf4e3a3a1d5e159$export$5be5a87408f70ddc = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$g;
};
$bcf4e3a3a1d5e159$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bcf4e3a3a1d5e159$var$b;
};
$bcf4e3a3a1d5e159$export$455c2e768291efa6 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$l;
};
$bcf4e3a3a1d5e159$export$9522e17588c12572 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$d;
};
$bcf4e3a3a1d5e159$export$2110ac352bb060b9 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$q;
};
$bcf4e3a3a1d5e159$export$56885ab8b9c456ab = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$p;
};
$bcf4e3a3a1d5e159$export$d927fcb6adf8f9de = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$c;
};
$bcf4e3a3a1d5e159$export$b82d16f27459e05a = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$f;
};
$bcf4e3a3a1d5e159$export$522c17b4f5e123e8 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$e;
};
$bcf4e3a3a1d5e159$export$1aabd8a0274ecfd6 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$m;
};
$bcf4e3a3a1d5e159$export$3d6c20d97e46b957 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$n;
};
$bcf4e3a3a1d5e159$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bcf4e3a3a1d5e159$var$d || a === $bcf4e3a3a1d5e159$var$f || a === $bcf4e3a3a1d5e159$var$e || a === $bcf4e3a3a1d5e159$var$m || a === $bcf4e3a3a1d5e159$var$n || a === $bcf4e3a3a1d5e159$var$t || "object" === typeof a && null !== a && (a.$$typeof === $bcf4e3a3a1d5e159$var$q || a.$$typeof === $bcf4e3a3a1d5e159$var$p || a.$$typeof === $bcf4e3a3a1d5e159$var$g || a.$$typeof === $bcf4e3a3a1d5e159$var$h || a.$$typeof === $bcf4e3a3a1d5e159$var$l || a.$$typeof === $bcf4e3a3a1d5e159$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$bcf4e3a3a1d5e159$export$f5bbd400c2f4426f = $bcf4e3a3a1d5e159$var$v;

});

parcelRegister("1xE3P", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("2HnWZ"));

});
parcelRegister("2HnWZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_tickFormat.default;
    }
});

var $1f722cf5b9592b65$var$_band = $1f722cf5b9592b65$var$_interopRequireWildcard((parcelRequire("bvS2B")));

var $1f722cf5b9592b65$var$_identity = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("j15Sh")));

var $1f722cf5b9592b65$var$_linear = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("8cBoe")));

var $1f722cf5b9592b65$var$_log = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("cw7m0")));

var $1f722cf5b9592b65$var$_symlog = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("3DXgb")));

var $1f722cf5b9592b65$var$_ordinal = $1f722cf5b9592b65$var$_interopRequireWildcard((parcelRequire("1gB5A")));

var $1f722cf5b9592b65$var$_pow = $1f722cf5b9592b65$var$_interopRequireWildcard((parcelRequire("6kjWv")));

var $1f722cf5b9592b65$var$_radial = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("kwNoN")));

var $1f722cf5b9592b65$var$_quantile = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("kEBaY")));

var $1f722cf5b9592b65$var$_quantize = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("5prmo")));

var $1f722cf5b9592b65$var$_threshold = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("81sXE")));

var $1f722cf5b9592b65$var$_time = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("3lv9c")));

var $1f722cf5b9592b65$var$_utcTime = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("k0gY2")));

var $1f722cf5b9592b65$var$_sequential = $1f722cf5b9592b65$var$_interopRequireWildcard((parcelRequire("bo5gu")));

var $1f722cf5b9592b65$var$_sequentialQuantile = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("5yyjd")));

var $1f722cf5b9592b65$var$_diverging = $1f722cf5b9592b65$var$_interopRequireWildcard((parcelRequire("8db3Z")));

var $1f722cf5b9592b65$var$_tickFormat = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("lIlUJ")));
function $1f722cf5b9592b65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1f722cf5b9592b65$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1f722cf5b9592b65$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1f722cf5b9592b65$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1f722cf5b9592b65$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("bvS2B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $861c825ee7e3af72$var$band;
module.exports.point = $861c825ee7e3af72$var$point;

var $dfXar = parcelRequire("dfXar");

var $ezRKk = parcelRequire("ezRKk");

var $861c825ee7e3af72$var$_ordinal = $861c825ee7e3af72$var$_interopRequireDefault((parcelRequire("1gB5A")));
function $861c825ee7e3af72$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $861c825ee7e3af72$var$band() {
    var scale = (0, $861c825ee7e3af72$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $dfXar.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $861c825ee7e3af72$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $ezRKk.initRange.apply(rescale(), arguments);
}
function $861c825ee7e3af72$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $861c825ee7e3af72$var$pointish(copy());
    };
    return scale;
}
function $861c825ee7e3af72$var$point() {
    return $861c825ee7e3af72$var$pointish($861c825ee7e3af72$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("dfXar", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $iw00b.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $6CV6g.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $6CV6g.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $iw00b.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $iw00b.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_zip.default;
    }
});

var $9a6a927f65e252c9$var$_bisect = $9a6a927f65e252c9$var$_interopRequireWildcard((parcelRequire("jZZ2P")));

var $9a6a927f65e252c9$var$_ascending = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $9a6a927f65e252c9$var$_bisector = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("efFsa")));

var $9a6a927f65e252c9$var$_count = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("jRmQq")));

var $9a6a927f65e252c9$var$_cross = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("id5o0")));

var $9a6a927f65e252c9$var$_cumsum = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("hMTdA")));

var $9a6a927f65e252c9$var$_descending = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("be4nB")));

var $9a6a927f65e252c9$var$_deviation = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("e0UhK")));

var $9a6a927f65e252c9$var$_extent = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("3oElc")));

var $iw00b = parcelRequire("iw00b");

var $9a6a927f65e252c9$var$_group = $9a6a927f65e252c9$var$_interopRequireWildcard((parcelRequire("lJvvG")));

var $9a6a927f65e252c9$var$_groupSort = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("4EzfP")));

var $9a6a927f65e252c9$var$_bin = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("hWMrk")));

var $9a6a927f65e252c9$var$_freedmanDiaconis = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("5jkYP")));

var $9a6a927f65e252c9$var$_scott = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("6h57H")));

var $9a6a927f65e252c9$var$_sturges = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("5A7VI")));

var $9a6a927f65e252c9$var$_max = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("93DHJ")));

var $9a6a927f65e252c9$var$_maxIndex = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("dpxdx")));

var $9a6a927f65e252c9$var$_mean = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("gd94P")));

var $9a6a927f65e252c9$var$_median = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("b3KGp")));

var $9a6a927f65e252c9$var$_merge = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("3wDu6")));

var $9a6a927f65e252c9$var$_min = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("5oxpw")));

var $9a6a927f65e252c9$var$_minIndex = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("32tGX")));

var $9a6a927f65e252c9$var$_mode = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("gnR5I")));

var $9a6a927f65e252c9$var$_nice = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("fBuXZ")));

var $9a6a927f65e252c9$var$_pairs = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("fPkBn")));

var $9a6a927f65e252c9$var$_permute = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("e5pcB")));

var $9a6a927f65e252c9$var$_quantile = $9a6a927f65e252c9$var$_interopRequireWildcard((parcelRequire("hSQ1l")));

var $9a6a927f65e252c9$var$_quickselect = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("l37BJ")));

var $9a6a927f65e252c9$var$_range = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("8b7pK")));

var $9a6a927f65e252c9$var$_rank = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("ejl42")));

var $9a6a927f65e252c9$var$_least = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("lw8Kx")));

var $9a6a927f65e252c9$var$_leastIndex = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("7mLIh")));

var $9a6a927f65e252c9$var$_greatest = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("5NlUE")));

var $9a6a927f65e252c9$var$_greatestIndex = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("eUrJc")));

var $9a6a927f65e252c9$var$_scan = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("kbw85")));

var $9a6a927f65e252c9$var$_shuffle = $9a6a927f65e252c9$var$_interopRequireWildcard((parcelRequire("33B7C")));

var $9a6a927f65e252c9$var$_sum = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("i2FN5")));

var $9a6a927f65e252c9$var$_ticks = $9a6a927f65e252c9$var$_interopRequireWildcard((parcelRequire("ctWaE")));

var $9a6a927f65e252c9$var$_transpose = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("evd6D")));

var $9a6a927f65e252c9$var$_variance = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("kFyIt")));

var $9a6a927f65e252c9$var$_zip = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("jWis9")));

var $9a6a927f65e252c9$var$_every = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("joCtP")));

var $9a6a927f65e252c9$var$_some = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("kDNkv")));

var $9a6a927f65e252c9$var$_filter = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("h8ZUA")));

var $9a6a927f65e252c9$var$_map = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("6LTkM")));

var $9a6a927f65e252c9$var$_reduce = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("lIMEs")));

var $9a6a927f65e252c9$var$_reverse = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("hkpgI")));

var $9a6a927f65e252c9$var$_sort = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("cZZyC")));

var $9a6a927f65e252c9$var$_difference = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("2pqEM")));

var $9a6a927f65e252c9$var$_disjoint = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("h2zcH")));

var $9a6a927f65e252c9$var$_intersection = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("aAVLd")));

var $9a6a927f65e252c9$var$_subset = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("11x46")));

var $9a6a927f65e252c9$var$_superset = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("l2doT")));

var $9a6a927f65e252c9$var$_union = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("gsNLm")));

var $6CV6g = parcelRequire("6CV6g");
function $9a6a927f65e252c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9a6a927f65e252c9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9a6a927f65e252c9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9a6a927f65e252c9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9a6a927f65e252c9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("jZZ2P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $e8f31103441a5e2f$var$_ascending = $e8f31103441a5e2f$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $e8f31103441a5e2f$var$_bisector = $e8f31103441a5e2f$var$_interopRequireDefault((parcelRequire("efFsa")));

var $e8f31103441a5e2f$var$_number = $e8f31103441a5e2f$var$_interopRequireDefault((parcelRequire("2mZc8")));
function $e8f31103441a5e2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e8f31103441a5e2f$var$ascendingBisect = (0, $e8f31103441a5e2f$var$_bisector.default)($e8f31103441a5e2f$var$_ascending.default);
const $e8f31103441a5e2f$var$bisectRight = $e8f31103441a5e2f$var$ascendingBisect.right;
module.exports.bisectRight = $e8f31103441a5e2f$var$bisectRight;
const $e8f31103441a5e2f$var$bisectLeft = $e8f31103441a5e2f$var$ascendingBisect.left;
module.exports.bisectLeft = $e8f31103441a5e2f$var$bisectLeft;
const $e8f31103441a5e2f$var$bisectCenter = (0, $e8f31103441a5e2f$var$_bisector.default)($e8f31103441a5e2f$var$_number.default).center;
module.exports.bisectCenter = $e8f31103441a5e2f$var$bisectCenter;
var $e8f31103441a5e2f$var$_default = $e8f31103441a5e2f$var$bisectRight;
module.exports.default = $e8f31103441a5e2f$var$_default;

});
parcelRegister("2WR5G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $225a2e403c3a7b10$var$ascending;
function $225a2e403c3a7b10$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("efFsa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6029f2bb71ed739$var$bisector;

var $a6029f2bb71ed739$var$_ascending = $a6029f2bb71ed739$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $a6029f2bb71ed739$var$_descending = $a6029f2bb71ed739$var$_interopRequireDefault((parcelRequire("be4nB")));
function $a6029f2bb71ed739$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a6029f2bb71ed739$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $a6029f2bb71ed739$var$_ascending.default;
        compare2 = (d, x)=>(0, $a6029f2bb71ed739$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $a6029f2bb71ed739$var$_ascending.default || f === $a6029f2bb71ed739$var$_descending.default ? f : $a6029f2bb71ed739$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $a6029f2bb71ed739$var$zero() {
    return 0;
}

});
parcelRegister("be4nB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $82c4663b6dc1fe62$var$descending;
function $82c4663b6dc1fe62$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("2mZc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b9d1ad9e2381454$var$number;
module.exports.numbers = $1b9d1ad9e2381454$var$numbers;
function $1b9d1ad9e2381454$var$number(x) {
    return x === null ? NaN : +x;
}
function* $1b9d1ad9e2381454$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("jRmQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e754affe87dcf7a5$var$count;
function $e754affe87dcf7a5$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("id5o0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d41d9e7dd7cdf881$var$cross;
function $d41d9e7dd7cdf881$var$length(array) {
    return array.length | 0;
}
function $d41d9e7dd7cdf881$var$empty(length) {
    return !(length > 0);
}
function $d41d9e7dd7cdf881$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $d41d9e7dd7cdf881$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $d41d9e7dd7cdf881$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $d41d9e7dd7cdf881$var$reducer(values.pop());
    values = values.map($d41d9e7dd7cdf881$var$arrayify);
    const lengths = values.map($d41d9e7dd7cdf881$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($d41d9e7dd7cdf881$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("hMTdA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf31c08bb05fdd8c$var$cumsum;
function $cf31c08bb05fdd8c$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("e0UhK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a33cb9d6c4f61289$var$deviation;

var $a33cb9d6c4f61289$var$_variance = $a33cb9d6c4f61289$var$_interopRequireDefault((parcelRequire("kFyIt")));
function $a33cb9d6c4f61289$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a33cb9d6c4f61289$var$deviation(values, valueof) {
    const v = (0, $a33cb9d6c4f61289$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("kFyIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f0c290f0737e21f3$var$variance;
function $f0c290f0737e21f3$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("3oElc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2792e7e121315c6e$var$extent;
function $2792e7e121315c6e$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("iw00b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $d7ab37905438cdae$var$fcumsum;
module.exports.fsum = $d7ab37905438cdae$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $d7ab37905438cdae$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $d7ab37905438cdae$var$Adder;
function $d7ab37905438cdae$var$fsum(values, valueof) {
    const adder = new $d7ab37905438cdae$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $d7ab37905438cdae$var$fcumsum(values, valueof) {
    const adder = new $d7ab37905438cdae$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("lJvvG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd263e28b3318028$var$group;
module.exports.flatGroup = $fd263e28b3318028$var$flatGroup;
module.exports.flatRollup = $fd263e28b3318028$var$flatRollup;
module.exports.groups = $fd263e28b3318028$var$groups;
module.exports.index = $fd263e28b3318028$var$index;
module.exports.indexes = $fd263e28b3318028$var$indexes;
module.exports.rollup = $fd263e28b3318028$var$rollup;
module.exports.rollups = $fd263e28b3318028$var$rollups;

var $6CV6g = parcelRequire("6CV6g");

var $fd263e28b3318028$var$_identity = $fd263e28b3318028$var$_interopRequireDefault((parcelRequire("8PKsP")));
function $fd263e28b3318028$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fd263e28b3318028$var$group(values, ...keys) {
    return $fd263e28b3318028$var$nest(values, $fd263e28b3318028$var$_identity.default, $fd263e28b3318028$var$_identity.default, keys);
}
function $fd263e28b3318028$var$groups(values, ...keys) {
    return $fd263e28b3318028$var$nest(values, Array.from, $fd263e28b3318028$var$_identity.default, keys);
}
function $fd263e28b3318028$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $fd263e28b3318028$var$flatGroup(values, ...keys) {
    return $fd263e28b3318028$var$flatten($fd263e28b3318028$var$groups(values, ...keys), keys);
}
function $fd263e28b3318028$var$flatRollup(values, reduce, ...keys) {
    return $fd263e28b3318028$var$flatten($fd263e28b3318028$var$rollups(values, reduce, ...keys), keys);
}
function $fd263e28b3318028$var$rollup(values, reduce, ...keys) {
    return $fd263e28b3318028$var$nest(values, $fd263e28b3318028$var$_identity.default, reduce, keys);
}
function $fd263e28b3318028$var$rollups(values, reduce, ...keys) {
    return $fd263e28b3318028$var$nest(values, Array.from, reduce, keys);
}
function $fd263e28b3318028$var$index(values, ...keys) {
    return $fd263e28b3318028$var$nest(values, $fd263e28b3318028$var$_identity.default, $fd263e28b3318028$var$unique, keys);
}
function $fd263e28b3318028$var$indexes(values, ...keys) {
    return $fd263e28b3318028$var$nest(values, Array.from, $fd263e28b3318028$var$unique, keys);
}
function $fd263e28b3318028$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $fd263e28b3318028$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $6CV6g.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("6CV6g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $4d3295934c897a36$var$InternMap extends Map {
    constructor(entries, key = $4d3295934c897a36$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($4d3295934c897a36$var$intern_get(this, key));
    }
    has(key) {
        return super.has($4d3295934c897a36$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($4d3295934c897a36$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($4d3295934c897a36$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $4d3295934c897a36$var$InternMap;
class $4d3295934c897a36$var$InternSet extends Set {
    constructor(values, key = $4d3295934c897a36$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($4d3295934c897a36$var$intern_get(this, value));
    }
    add(value) {
        return super.add($4d3295934c897a36$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($4d3295934c897a36$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $4d3295934c897a36$var$InternSet;
function $4d3295934c897a36$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $4d3295934c897a36$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $4d3295934c897a36$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $4d3295934c897a36$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("8PKsP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $66e720f0f3dbb675$var$identity;
function $66e720f0f3dbb675$var$identity(x) {
    return x;
}

});


parcelRegister("4EzfP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36363e9a0d3b50bf$var$groupSort;

var $36363e9a0d3b50bf$var$_ascending = $36363e9a0d3b50bf$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $36363e9a0d3b50bf$var$_group = $36363e9a0d3b50bf$var$_interopRequireWildcard((parcelRequire("lJvvG")));

var $36363e9a0d3b50bf$var$_sort = $36363e9a0d3b50bf$var$_interopRequireDefault((parcelRequire("cZZyC")));
function $36363e9a0d3b50bf$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($36363e9a0d3b50bf$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $36363e9a0d3b50bf$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $36363e9a0d3b50bf$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $36363e9a0d3b50bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36363e9a0d3b50bf$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $36363e9a0d3b50bf$var$_sort.default)((0, $36363e9a0d3b50bf$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $36363e9a0d3b50bf$var$_ascending.default)(av, bv) || (0, $36363e9a0d3b50bf$var$_ascending.default)(ak, bk)) : (0, $36363e9a0d3b50bf$var$_sort.default)((0, $36363e9a0d3b50bf$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $36363e9a0d3b50bf$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("cZZyC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $976aee89c8a80726$var$ascendingDefined;
module.exports.compareDefined = $976aee89c8a80726$var$compareDefined;
module.exports.default = $976aee89c8a80726$var$sort;

var $976aee89c8a80726$var$_ascending = $976aee89c8a80726$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $976aee89c8a80726$var$_permute = $976aee89c8a80726$var$_interopRequireDefault((parcelRequire("e5pcB")));
function $976aee89c8a80726$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $976aee89c8a80726$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $976aee89c8a80726$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$976aee89c8a80726$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $976aee89c8a80726$var$_permute.default)(values, index);
    }
    return values.sort($976aee89c8a80726$var$compareDefined(f));
}
function $976aee89c8a80726$var$compareDefined(compare = $976aee89c8a80726$var$_ascending.default) {
    if (compare === $976aee89c8a80726$var$_ascending.default) return $976aee89c8a80726$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $976aee89c8a80726$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("e5pcB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a41514f09fa09243$var$permute;
function $a41514f09fa09243$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("hWMrk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d10d6d99ee20fb61$var$bin;

var $5OlV7 = parcelRequire("5OlV7");

var $d10d6d99ee20fb61$var$_bisect = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("jZZ2P")));

var $d10d6d99ee20fb61$var$_constant = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("038iY")));

var $d10d6d99ee20fb61$var$_extent = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("3oElc")));

var $d10d6d99ee20fb61$var$_identity = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("8PKsP")));

var $d10d6d99ee20fb61$var$_nice = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("fBuXZ")));

var $d10d6d99ee20fb61$var$_ticks = $d10d6d99ee20fb61$var$_interopRequireWildcard((parcelRequire("ctWaE")));

var $d10d6d99ee20fb61$var$_sturges = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("5A7VI")));
function $d10d6d99ee20fb61$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d10d6d99ee20fb61$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d10d6d99ee20fb61$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d10d6d99ee20fb61$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d10d6d99ee20fb61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d10d6d99ee20fb61$var$bin() {
    var value = $d10d6d99ee20fb61$var$_identity.default, domain = $d10d6d99ee20fb61$var$_extent.default, threshold = $d10d6d99ee20fb61$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $d10d6d99ee20fb61$var$_extent.default) [x0, x1] = (0, $d10d6d99ee20fb61$var$_nice.default)(x0, x1, tn);
            tz = (0, $d10d6d99ee20fb61$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $d10d6d99ee20fb61$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $d10d6d99ee20fb61$var$_extent.default) {
                    const step = (0, $d10d6d99ee20fb61$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $d10d6d99ee20fb61$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $d10d6d99ee20fb61$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $d10d6d99ee20fb61$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $d10d6d99ee20fb61$var$_constant.default)($5OlV7.slice.call(_)) : (0, $d10d6d99ee20fb61$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("5OlV7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $43b2a032763efd3e$var$array = Array.prototype;
var $43b2a032763efd3e$var$slice = $43b2a032763efd3e$var$array.slice;
module.exports.slice = $43b2a032763efd3e$var$slice;
var $43b2a032763efd3e$var$map = $43b2a032763efd3e$var$array.map;
module.exports.map = $43b2a032763efd3e$var$map;

});

parcelRegister("038iY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0096b91f09323471$var$constant;
function $0096b91f09323471$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("fBuXZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5c25505cb2d4c7c$var$nice;

var $ctWaE = parcelRequire("ctWaE");
function $b5c25505cb2d4c7c$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $ctWaE.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("ctWaE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $916550fbad5b6b79$var$ticks;
module.exports.tickIncrement = $916550fbad5b6b79$var$tickIncrement;
module.exports.tickStep = $916550fbad5b6b79$var$tickStep;
var $916550fbad5b6b79$var$e10 = Math.sqrt(50), $916550fbad5b6b79$var$e5 = Math.sqrt(10), $916550fbad5b6b79$var$e2 = Math.sqrt(2);
function $916550fbad5b6b79$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $916550fbad5b6b79$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $916550fbad5b6b79$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $916550fbad5b6b79$var$e10 ? 10 : error >= $916550fbad5b6b79$var$e5 ? 5 : error >= $916550fbad5b6b79$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $916550fbad5b6b79$var$e10 ? 10 : error >= $916550fbad5b6b79$var$e5 ? 5 : error >= $916550fbad5b6b79$var$e2 ? 2 : 1);
}
function $916550fbad5b6b79$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $916550fbad5b6b79$var$e10) step1 *= 10;
    else if (error >= $916550fbad5b6b79$var$e5) step1 *= 5;
    else if (error >= $916550fbad5b6b79$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("5A7VI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4106773f512b7812$var$thresholdSturges;

var $4106773f512b7812$var$_count = $4106773f512b7812$var$_interopRequireDefault((parcelRequire("jRmQq")));
function $4106773f512b7812$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4106773f512b7812$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $4106773f512b7812$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("5jkYP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ddf0055491303c5$var$thresholdFreedmanDiaconis;

var $3ddf0055491303c5$var$_count = $3ddf0055491303c5$var$_interopRequireDefault((parcelRequire("jRmQq")));

var $3ddf0055491303c5$var$_quantile = $3ddf0055491303c5$var$_interopRequireDefault((parcelRequire("hSQ1l")));
function $3ddf0055491303c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3ddf0055491303c5$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $3ddf0055491303c5$var$_quantile.default)(values, 0.75) - (0, $3ddf0055491303c5$var$_quantile.default)(values, 0.25)) * Math.pow((0, $3ddf0055491303c5$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("hSQ1l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d04fd50f01c50432$var$quantile;
module.exports.quantileSorted = $d04fd50f01c50432$var$quantileSorted;

var $d04fd50f01c50432$var$_max = $d04fd50f01c50432$var$_interopRequireDefault((parcelRequire("93DHJ")));

var $d04fd50f01c50432$var$_min = $d04fd50f01c50432$var$_interopRequireDefault((parcelRequire("5oxpw")));

var $d04fd50f01c50432$var$_quickselect = $d04fd50f01c50432$var$_interopRequireDefault((parcelRequire("l37BJ")));

var $d04fd50f01c50432$var$_number = $d04fd50f01c50432$var$_interopRequireWildcard((parcelRequire("2mZc8")));
function $d04fd50f01c50432$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d04fd50f01c50432$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d04fd50f01c50432$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d04fd50f01c50432$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d04fd50f01c50432$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d04fd50f01c50432$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $d04fd50f01c50432$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $d04fd50f01c50432$var$_min.default)(values);
    if (p >= 1) return (0, $d04fd50f01c50432$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $d04fd50f01c50432$var$_max.default)((0, $d04fd50f01c50432$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $d04fd50f01c50432$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $d04fd50f01c50432$var$quantileSorted(values, p, valueof = $d04fd50f01c50432$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("93DHJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6983314ea78cc412$var$max;
function $6983314ea78cc412$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("5oxpw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ed91c5101d92ca4$var$min;
function $3ed91c5101d92ca4$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("l37BJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f52fc783328d31e1$var$quickselect;

var $cZZyC = parcelRequire("cZZyC");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $f52fc783328d31e1$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $cZZyC.ascendingDefined : (0, $cZZyC.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $f52fc783328d31e1$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $f52fc783328d31e1$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $f52fc783328d31e1$var$swap(array, left, right);
        while(i < j){
            $f52fc783328d31e1$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $f52fc783328d31e1$var$swap(array, left, j);
        else ++j, $f52fc783328d31e1$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $f52fc783328d31e1$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("6h57H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49184df91bb832ea$var$thresholdScott;

var $49184df91bb832ea$var$_count = $49184df91bb832ea$var$_interopRequireDefault((parcelRequire("jRmQq")));

var $49184df91bb832ea$var$_deviation = $49184df91bb832ea$var$_interopRequireDefault((parcelRequire("e0UhK")));
function $49184df91bb832ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49184df91bb832ea$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $49184df91bb832ea$var$_count.default)(values)) / (3.49 * (0, $49184df91bb832ea$var$_deviation.default)(values)));
}

});

parcelRegister("dpxdx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c376075ebb6a51b$var$maxIndex;
function $9c376075ebb6a51b$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("gd94P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bcd4e6b596f612b9$var$mean;
function $bcd4e6b596f612b9$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("b3KGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $80d42fd1adcb0cb1$var$median;

var $80d42fd1adcb0cb1$var$_quantile = $80d42fd1adcb0cb1$var$_interopRequireDefault((parcelRequire("hSQ1l")));
function $80d42fd1adcb0cb1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80d42fd1adcb0cb1$var$median(values, valueof) {
    return (0, $80d42fd1adcb0cb1$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("3wDu6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2912fd0b93b9b84d$var$merge;
function* $2912fd0b93b9b84d$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $2912fd0b93b9b84d$var$merge(arrays) {
    return Array.from($2912fd0b93b9b84d$var$flatten(arrays));
}

});

parcelRegister("32tGX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $236897329b327d67$var$minIndex;
function $236897329b327d67$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("gnR5I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bed7fa1effd47853$var$mode;

var $6CV6g = parcelRequire("6CV6g");
function $bed7fa1effd47853$var$mode(values, valueof) {
    const counts = new $6CV6g.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("fPkBn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b85b998e40179317$var$pairs;
module.exports.pair = $b85b998e40179317$var$pair;
function $b85b998e40179317$var$pairs(values, pairof = $b85b998e40179317$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $b85b998e40179317$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("8b7pK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f451a1eaa8c7ebc$var$range;
function $5f451a1eaa8c7ebc$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("ejl42", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6b32df1bcbda344$var$rank;

var $a6b32df1bcbda344$var$_ascending = $a6b32df1bcbda344$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $cZZyC = parcelRequire("cZZyC");
function $a6b32df1bcbda344$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a6b32df1bcbda344$var$rank(values, valueof = $a6b32df1bcbda344$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $a6b32df1bcbda344$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $a6b32df1bcbda344$var$_ascending.default ? (i, j)=>(0, $cZZyC.ascendingDefined)(V[i], V[j]) : (0, $cZZyC.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("lw8Kx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $040ae4a396c0cf5b$var$least;

var $040ae4a396c0cf5b$var$_ascending = $040ae4a396c0cf5b$var$_interopRequireDefault((parcelRequire("2WR5G")));
function $040ae4a396c0cf5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $040ae4a396c0cf5b$var$least(values, compare = $040ae4a396c0cf5b$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $040ae4a396c0cf5b$var$_ascending.default)(value, minValue) < 0 : (0, $040ae4a396c0cf5b$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("7mLIh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55cf9952c2173637$var$leastIndex;

var $55cf9952c2173637$var$_ascending = $55cf9952c2173637$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $55cf9952c2173637$var$_minIndex = $55cf9952c2173637$var$_interopRequireDefault((parcelRequire("32tGX")));
function $55cf9952c2173637$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $55cf9952c2173637$var$leastIndex(values, compare = $55cf9952c2173637$var$_ascending.default) {
    if (compare.length === 1) return (0, $55cf9952c2173637$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("5NlUE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $438286c048d80d03$var$greatest;

var $438286c048d80d03$var$_ascending = $438286c048d80d03$var$_interopRequireDefault((parcelRequire("2WR5G")));
function $438286c048d80d03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $438286c048d80d03$var$greatest(values, compare = $438286c048d80d03$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $438286c048d80d03$var$_ascending.default)(value, maxValue) > 0 : (0, $438286c048d80d03$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("eUrJc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adabcdda5af24ac5$var$greatestIndex;

var $adabcdda5af24ac5$var$_ascending = $adabcdda5af24ac5$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $adabcdda5af24ac5$var$_maxIndex = $adabcdda5af24ac5$var$_interopRequireDefault((parcelRequire("dpxdx")));
function $adabcdda5af24ac5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $adabcdda5af24ac5$var$greatestIndex(values, compare = $adabcdda5af24ac5$var$_ascending.default) {
    if (compare.length === 1) return (0, $adabcdda5af24ac5$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("kbw85", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eb1dc1f02c8ad832$var$scan;

var $eb1dc1f02c8ad832$var$_leastIndex = $eb1dc1f02c8ad832$var$_interopRequireDefault((parcelRequire("7mLIh")));
function $eb1dc1f02c8ad832$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $eb1dc1f02c8ad832$var$scan(values, compare) {
    const index = (0, $eb1dc1f02c8ad832$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("33B7C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $239e728f66a8bf68$var$shuffler;
var $239e728f66a8bf68$var$_default = $239e728f66a8bf68$var$shuffler(Math.random);
module.exports.default = $239e728f66a8bf68$var$_default;
function $239e728f66a8bf68$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("i2FN5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d228d4b031310de7$var$sum;
function $d228d4b031310de7$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("evd6D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8ee208bc7507fd2$var$transpose;

var $a8ee208bc7507fd2$var$_min = $a8ee208bc7507fd2$var$_interopRequireDefault((parcelRequire("5oxpw")));
function $a8ee208bc7507fd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a8ee208bc7507fd2$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $a8ee208bc7507fd2$var$_min.default)(matrix, $a8ee208bc7507fd2$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $a8ee208bc7507fd2$var$length(d) {
    return d.length;
}

});

parcelRegister("jWis9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e841bf789ed6f191$var$zip;

var $e841bf789ed6f191$var$_transpose = $e841bf789ed6f191$var$_interopRequireDefault((parcelRequire("evd6D")));
function $e841bf789ed6f191$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e841bf789ed6f191$var$zip() {
    return (0, $e841bf789ed6f191$var$_transpose.default)(arguments);
}

});

parcelRegister("joCtP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e1ee1b91ef9c0b44$var$every;
function $e1ee1b91ef9c0b44$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("kDNkv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f06db70a69d79f22$var$some;
function $f06db70a69d79f22$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("h8ZUA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7b33569b75866b6$var$filter;
function $c7b33569b75866b6$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("6LTkM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ee20e169d055268$var$map;
function $4ee20e169d055268$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("lIMEs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd03723cc5057acb$var$reduce;
function $fd03723cc5057acb$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("hkpgI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9d7e7bd491e47db$var$reverse;
function $c9d7e7bd491e47db$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("2pqEM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c1298095047dfa5$var$difference;

var $6CV6g = parcelRequire("6CV6g");
function $1c1298095047dfa5$var$difference(values, ...others) {
    values = new $6CV6g.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("h2zcH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c67dee54f7105787$var$disjoint;

var $6CV6g = parcelRequire("6CV6g");
function $c67dee54f7105787$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $6CV6g.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("aAVLd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7b6a123d63b5deee$var$intersection;

var $6CV6g = parcelRequire("6CV6g");
function $7b6a123d63b5deee$var$intersection(values, ...others) {
    values = new $6CV6g.InternSet(values);
    others = others.map($7b6a123d63b5deee$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $7b6a123d63b5deee$var$set(values) {
    return values instanceof $6CV6g.InternSet ? values : new $6CV6g.InternSet(values);
}

});

parcelRegister("11x46", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0bef8879c93c737c$var$subset;

var $0bef8879c93c737c$var$_superset = $0bef8879c93c737c$var$_interopRequireDefault((parcelRequire("l2doT")));
function $0bef8879c93c737c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0bef8879c93c737c$var$subset(values, other) {
    return (0, $0bef8879c93c737c$var$_superset.default)(other, values);
}

});
parcelRegister("l2doT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5042def8ce91e86$var$superset;
function $f5042def8ce91e86$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $f5042def8ce91e86$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $f5042def8ce91e86$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $f5042def8ce91e86$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("gsNLm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bfc5dcb6a76b44e3$var$union;

var $6CV6g = parcelRequire("6CV6g");
function $bfc5dcb6a76b44e3$var$union(...others) {
    const set = new $6CV6g.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("ezRKk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $a9ce0670c1272f4f$var$initInterpolator;
module.exports.initRange = $a9ce0670c1272f4f$var$initRange;
function $a9ce0670c1272f4f$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $a9ce0670c1272f4f$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("1gB5A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0ec40e30bf0f5c00$var$ordinal;
module.exports.implicit = void 0;

var $dfXar = parcelRequire("dfXar");

var $ezRKk = parcelRequire("ezRKk");
const $0ec40e30bf0f5c00$var$implicit = Symbol("implicit");
module.exports.implicit = $0ec40e30bf0f5c00$var$implicit;
function $0ec40e30bf0f5c00$var$ordinal() {
    var index = new $dfXar.InternMap(), domain = [], range = [], unknown = $0ec40e30bf0f5c00$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $0ec40e30bf0f5c00$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $dfXar.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $0ec40e30bf0f5c00$var$ordinal(domain, range).unknown(unknown);
    };
    $ezRKk.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("j15Sh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd82aadac38a35b1$var$identity;

var $8cBoe = parcelRequire("8cBoe");

var $dd82aadac38a35b1$var$_number = $dd82aadac38a35b1$var$_interopRequireDefault((parcelRequire("9pEAW")));
function $dd82aadac38a35b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dd82aadac38a35b1$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $dd82aadac38a35b1$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $dd82aadac38a35b1$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $dd82aadac38a35b1$var$_number.default) : [
        0,
        1
    ];
    return (0, $8cBoe.linearish)(scale);
}

});
parcelRegister("8cBoe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f8c728aee153f97$var$linear;
module.exports.linearish = $5f8c728aee153f97$var$linearish;

var $dfXar = parcelRequire("dfXar");

var $5f8c728aee153f97$var$_continuous = $5f8c728aee153f97$var$_interopRequireWildcard((parcelRequire("kcPbm")));

var $ezRKk = parcelRequire("ezRKk");

var $5f8c728aee153f97$var$_tickFormat = $5f8c728aee153f97$var$_interopRequireDefault((parcelRequire("lIlUJ")));
function $5f8c728aee153f97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f8c728aee153f97$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5f8c728aee153f97$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5f8c728aee153f97$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5f8c728aee153f97$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5f8c728aee153f97$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $dfXar.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $5f8c728aee153f97$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $dfXar.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $5f8c728aee153f97$var$linear() {
    var scale = (0, $5f8c728aee153f97$var$_continuous.default)();
    scale.copy = function() {
        return (0, $5f8c728aee153f97$var$_continuous.copy)(scale, $5f8c728aee153f97$var$linear());
    };
    $ezRKk.initRange.apply(scale, arguments);
    return $5f8c728aee153f97$var$linearish(scale);
}

});
parcelRegister("kcPbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $eb5ca1580ede39e5$var$copy;
module.exports.default = $eb5ca1580ede39e5$var$continuous;
module.exports.identity = $eb5ca1580ede39e5$var$identity;
module.exports.transformer = $eb5ca1580ede39e5$var$transformer;

var $dfXar = parcelRequire("dfXar");

var $84oZu = parcelRequire("84oZu");

var $eb5ca1580ede39e5$var$_constant = $eb5ca1580ede39e5$var$_interopRequireDefault((parcelRequire("eq00u")));

var $eb5ca1580ede39e5$var$_number = $eb5ca1580ede39e5$var$_interopRequireDefault((parcelRequire("9pEAW")));
function $eb5ca1580ede39e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $eb5ca1580ede39e5$var$unit = [
    0,
    1
];
function $eb5ca1580ede39e5$var$identity(x) {
    return x;
}
function $eb5ca1580ede39e5$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $eb5ca1580ede39e5$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $eb5ca1580ede39e5$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $eb5ca1580ede39e5$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $eb5ca1580ede39e5$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $eb5ca1580ede39e5$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $eb5ca1580ede39e5$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $eb5ca1580ede39e5$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $dfXar.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $eb5ca1580ede39e5$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $eb5ca1580ede39e5$var$transformer() {
    var domain = $eb5ca1580ede39e5$var$unit, range = $eb5ca1580ede39e5$var$unit, interpolate = $84oZu.interpolate, transform, untransform, unknown, clamp = $eb5ca1580ede39e5$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $eb5ca1580ede39e5$var$identity) clamp = $eb5ca1580ede39e5$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $eb5ca1580ede39e5$var$polymap : $eb5ca1580ede39e5$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $84oZu.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $eb5ca1580ede39e5$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $84oZu.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $eb5ca1580ede39e5$var$identity, rescale()) : clamp !== $eb5ca1580ede39e5$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $eb5ca1580ede39e5$var$continuous() {
    return $eb5ca1580ede39e5$var$transformer()($eb5ca1580ede39e5$var$identity, $eb5ca1580ede39e5$var$identity);
}

});
parcelRegister("84oZu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $f9YjU.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $f9YjU.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_quantize.default;
    }
});

var $5e0215138d0a55b8$var$_value = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("bqAXw")));

var $5e0215138d0a55b8$var$_array = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("kQcG1")));

var $5e0215138d0a55b8$var$_basis = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("a1vOh")));

var $5e0215138d0a55b8$var$_basisClosed = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("3OWQH")));

var $5e0215138d0a55b8$var$_date = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("GQCzZ")));

var $5e0215138d0a55b8$var$_discrete = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("eP0kF")));

var $5e0215138d0a55b8$var$_hue = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("lLzpp")));

var $5e0215138d0a55b8$var$_number = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("9n4Qi")));

var $5e0215138d0a55b8$var$_numberArray = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("cws9j")));

var $5e0215138d0a55b8$var$_object = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("2xR4B")));

var $5e0215138d0a55b8$var$_round = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("9mzi1")));

var $5e0215138d0a55b8$var$_string = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("56Roz")));

var $f9YjU = parcelRequire("f9YjU");

var $5e0215138d0a55b8$var$_zoom = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("j7cx5")));

var $5e0215138d0a55b8$var$_rgb = $5e0215138d0a55b8$var$_interopRequireWildcard((parcelRequire("fczzB")));

var $5e0215138d0a55b8$var$_hsl = $5e0215138d0a55b8$var$_interopRequireWildcard((parcelRequire("bfWaM")));

var $5e0215138d0a55b8$var$_lab = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("dS0ed")));

var $5e0215138d0a55b8$var$_hcl = $5e0215138d0a55b8$var$_interopRequireWildcard((parcelRequire("i3ui9")));

var $5e0215138d0a55b8$var$_cubehelix = $5e0215138d0a55b8$var$_interopRequireWildcard((parcelRequire("ichIC")));

var $5e0215138d0a55b8$var$_piecewise = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("fPqKp")));

var $5e0215138d0a55b8$var$_quantize = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("lxEcn")));
function $5e0215138d0a55b8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5e0215138d0a55b8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5e0215138d0a55b8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5e0215138d0a55b8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5e0215138d0a55b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("bqAXw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $851ecab306118005$var$_default;

var $eyM6K = parcelRequire("eyM6K");

var $851ecab306118005$var$_rgb = $851ecab306118005$var$_interopRequireDefault((parcelRequire("fczzB")));

var $kQcG1 = parcelRequire("kQcG1");

var $851ecab306118005$var$_date = $851ecab306118005$var$_interopRequireDefault((parcelRequire("GQCzZ")));

var $851ecab306118005$var$_number = $851ecab306118005$var$_interopRequireDefault((parcelRequire("9n4Qi")));

var $851ecab306118005$var$_object = $851ecab306118005$var$_interopRequireDefault((parcelRequire("2xR4B")));

var $851ecab306118005$var$_string = $851ecab306118005$var$_interopRequireDefault((parcelRequire("56Roz")));

var $851ecab306118005$var$_constant = $851ecab306118005$var$_interopRequireDefault((parcelRequire("8s9ZJ")));

var $851ecab306118005$var$_numberArray = $851ecab306118005$var$_interopRequireWildcard((parcelRequire("cws9j")));
function $851ecab306118005$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($851ecab306118005$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $851ecab306118005$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $851ecab306118005$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $851ecab306118005$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $851ecab306118005$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $851ecab306118005$var$_constant.default)(b) : (t === "number" ? $851ecab306118005$var$_number.default : t === "string" ? (c = (0, $eyM6K.color)(b)) ? (b = c, $851ecab306118005$var$_rgb.default) : $851ecab306118005$var$_string.default : b instanceof $eyM6K.color ? $851ecab306118005$var$_rgb.default : b instanceof Date ? $851ecab306118005$var$_date.default : (0, $851ecab306118005$var$_numberArray.isNumberArray)(b) ? $851ecab306118005$var$_numberArray.default : Array.isArray(b) ? $kQcG1.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $851ecab306118005$var$_object.default : $851ecab306118005$var$_number.default)(a, b);
}

});
parcelRegister("eyM6K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_color.rgb;
    }
});

var $a9998ee6ec2d57cf$var$_color = $a9998ee6ec2d57cf$var$_interopRequireWildcard((parcelRequire("eZZi2")));

var $a9998ee6ec2d57cf$var$_lab = $a9998ee6ec2d57cf$var$_interopRequireWildcard((parcelRequire("epdzq")));

var $a9998ee6ec2d57cf$var$_cubehelix = $a9998ee6ec2d57cf$var$_interopRequireDefault((parcelRequire("k8o4k")));
function $a9998ee6ec2d57cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a9998ee6ec2d57cf$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a9998ee6ec2d57cf$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a9998ee6ec2d57cf$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a9998ee6ec2d57cf$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("eZZi2", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("h2Uz9")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("h2Uz9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c68e80655f3c9e6c$var$_default;
module.exports.extend = $c68e80655f3c9e6c$var$extend;
function $c68e80655f3c9e6c$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $c68e80655f3c9e6c$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("epdzq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $a7cded475dce49e7$var$Hcl;
module.exports.Lab = $a7cded475dce49e7$var$Lab;
module.exports.default = $a7cded475dce49e7$var$lab;
module.exports.gray = $a7cded475dce49e7$var$gray;
module.exports.hcl = $a7cded475dce49e7$var$hcl;
module.exports.lch = $a7cded475dce49e7$var$lch;

var $a7cded475dce49e7$var$_define = $a7cded475dce49e7$var$_interopRequireWildcard((parcelRequire("h2Uz9")));

var $eZZi2 = parcelRequire("eZZi2");

var $65fvp = parcelRequire("65fvp");
function $a7cded475dce49e7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a7cded475dce49e7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a7cded475dce49e7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a7cded475dce49e7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $a7cded475dce49e7$var$K = 18, $a7cded475dce49e7$var$Xn = 0.96422, $a7cded475dce49e7$var$Yn = 1, $a7cded475dce49e7$var$Zn = 0.82521, $a7cded475dce49e7$var$t0 = 4 / 29, $a7cded475dce49e7$var$t1 = 6 / 29, $a7cded475dce49e7$var$t2 = 3 * $a7cded475dce49e7$var$t1 * $a7cded475dce49e7$var$t1, $a7cded475dce49e7$var$t3 = $a7cded475dce49e7$var$t1 * $a7cded475dce49e7$var$t1 * $a7cded475dce49e7$var$t1;
function $a7cded475dce49e7$var$labConvert(o) {
    if (o instanceof $a7cded475dce49e7$var$Lab) return new $a7cded475dce49e7$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $a7cded475dce49e7$var$Hcl) return $a7cded475dce49e7$var$hcl2lab(o);
    if (!(o instanceof $eZZi2.Rgb)) o = (0, $eZZi2.rgbConvert)(o);
    var r = $a7cded475dce49e7$var$rgb2lrgb(o.r), g = $a7cded475dce49e7$var$rgb2lrgb(o.g), b = $a7cded475dce49e7$var$rgb2lrgb(o.b), y = $a7cded475dce49e7$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $a7cded475dce49e7$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $a7cded475dce49e7$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $a7cded475dce49e7$var$Xn);
        z = $a7cded475dce49e7$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $a7cded475dce49e7$var$Zn);
    }
    return new $a7cded475dce49e7$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $a7cded475dce49e7$var$gray(l, opacity) {
    return new $a7cded475dce49e7$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $a7cded475dce49e7$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $a7cded475dce49e7$var$labConvert(l) : new $a7cded475dce49e7$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $a7cded475dce49e7$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $a7cded475dce49e7$var$_define.default)($a7cded475dce49e7$var$Lab, $a7cded475dce49e7$var$lab, (0, $a7cded475dce49e7$var$_define.extend)($eZZi2.Color, {
    brighter (k) {
        return new $a7cded475dce49e7$var$Lab(this.l + $a7cded475dce49e7$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $a7cded475dce49e7$var$Lab(this.l - $a7cded475dce49e7$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $a7cded475dce49e7$var$Xn * $a7cded475dce49e7$var$lab2xyz(x);
        y = $a7cded475dce49e7$var$Yn * $a7cded475dce49e7$var$lab2xyz(y);
        z = $a7cded475dce49e7$var$Zn * $a7cded475dce49e7$var$lab2xyz(z);
        return new $eZZi2.Rgb($a7cded475dce49e7$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $a7cded475dce49e7$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $a7cded475dce49e7$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $a7cded475dce49e7$var$xyz2lab(t) {
    return t > $a7cded475dce49e7$var$t3 ? Math.pow(t, 1 / 3) : t / $a7cded475dce49e7$var$t2 + $a7cded475dce49e7$var$t0;
}
function $a7cded475dce49e7$var$lab2xyz(t) {
    return t > $a7cded475dce49e7$var$t1 ? t * t * t : $a7cded475dce49e7$var$t2 * (t - $a7cded475dce49e7$var$t0);
}
function $a7cded475dce49e7$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $a7cded475dce49e7$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $a7cded475dce49e7$var$hclConvert(o) {
    if (o instanceof $a7cded475dce49e7$var$Hcl) return new $a7cded475dce49e7$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $a7cded475dce49e7$var$Lab)) o = $a7cded475dce49e7$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $a7cded475dce49e7$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $65fvp.degrees;
    return new $a7cded475dce49e7$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $a7cded475dce49e7$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $a7cded475dce49e7$var$hclConvert(l) : new $a7cded475dce49e7$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $a7cded475dce49e7$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $a7cded475dce49e7$var$hclConvert(h) : new $a7cded475dce49e7$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $a7cded475dce49e7$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $a7cded475dce49e7$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $a7cded475dce49e7$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $65fvp.radians;
    return new $a7cded475dce49e7$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $a7cded475dce49e7$var$_define.default)($a7cded475dce49e7$var$Hcl, $a7cded475dce49e7$var$hcl, (0, $a7cded475dce49e7$var$_define.extend)($eZZi2.Color, {
    brighter (k) {
        return new $a7cded475dce49e7$var$Hcl(this.h, this.c, this.l + $a7cded475dce49e7$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $a7cded475dce49e7$var$Hcl(this.h, this.c, this.l - $a7cded475dce49e7$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $a7cded475dce49e7$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("65fvp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $46df3cc99a843bd6$var$radians = Math.PI / 180;
module.exports.radians = $46df3cc99a843bd6$var$radians;
const $46df3cc99a843bd6$var$degrees = 180 / Math.PI;
module.exports.degrees = $46df3cc99a843bd6$var$degrees;

});


parcelRegister("k8o4k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $ea8739913c38feb3$var$Cubehelix;
module.exports.default = $ea8739913c38feb3$var$cubehelix;

var $ea8739913c38feb3$var$_define = $ea8739913c38feb3$var$_interopRequireWildcard((parcelRequire("h2Uz9")));

var $eZZi2 = parcelRequire("eZZi2");

var $65fvp = parcelRequire("65fvp");
function $ea8739913c38feb3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ea8739913c38feb3$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ea8739913c38feb3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ea8739913c38feb3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $ea8739913c38feb3$var$A = -0.14861, $ea8739913c38feb3$var$B = 1.78277, $ea8739913c38feb3$var$C = -0.29227, $ea8739913c38feb3$var$D = -0.90649, $ea8739913c38feb3$var$E = 1.97294, $ea8739913c38feb3$var$ED = $ea8739913c38feb3$var$E * $ea8739913c38feb3$var$D, $ea8739913c38feb3$var$EB = $ea8739913c38feb3$var$E * $ea8739913c38feb3$var$B, $ea8739913c38feb3$var$BC_DA = $ea8739913c38feb3$var$B * $ea8739913c38feb3$var$C - $ea8739913c38feb3$var$D * $ea8739913c38feb3$var$A;
function $ea8739913c38feb3$var$cubehelixConvert(o) {
    if (o instanceof $ea8739913c38feb3$var$Cubehelix) return new $ea8739913c38feb3$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $eZZi2.Rgb)) o = (0, $eZZi2.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($ea8739913c38feb3$var$BC_DA * b + $ea8739913c38feb3$var$ED * r - $ea8739913c38feb3$var$EB * g) / ($ea8739913c38feb3$var$BC_DA + $ea8739913c38feb3$var$ED - $ea8739913c38feb3$var$EB), bl = b - l, k = ($ea8739913c38feb3$var$E * (g - l) - $ea8739913c38feb3$var$C * bl) / $ea8739913c38feb3$var$D, s = Math.sqrt(k * k + bl * bl) / ($ea8739913c38feb3$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $65fvp.degrees - 120 : NaN;
    return new $ea8739913c38feb3$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $ea8739913c38feb3$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $ea8739913c38feb3$var$cubehelixConvert(h) : new $ea8739913c38feb3$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $ea8739913c38feb3$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $ea8739913c38feb3$var$_define.default)($ea8739913c38feb3$var$Cubehelix, $ea8739913c38feb3$var$cubehelix, (0, $ea8739913c38feb3$var$_define.extend)($eZZi2.Color, {
    brighter (k) {
        k = k == null ? $eZZi2.brighter : Math.pow($eZZi2.brighter, k);
        return new $ea8739913c38feb3$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $eZZi2.darker : Math.pow($eZZi2.darker, k);
        return new $ea8739913c38feb3$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $65fvp.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $eZZi2.Rgb(255 * (l + a * ($ea8739913c38feb3$var$A * cosh + $ea8739913c38feb3$var$B * sinh)), 255 * (l + a * ($ea8739913c38feb3$var$C * cosh + $ea8739913c38feb3$var$D * sinh)), 255 * (l + a * ($ea8739913c38feb3$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("fczzB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $eyM6K = parcelRequire("eyM6K");

var $b1139220491ac4fe$var$_basis = $b1139220491ac4fe$var$_interopRequireDefault((parcelRequire("a1vOh")));

var $b1139220491ac4fe$var$_basisClosed = $b1139220491ac4fe$var$_interopRequireDefault((parcelRequire("3OWQH")));

var $b1139220491ac4fe$var$_color = $b1139220491ac4fe$var$_interopRequireWildcard((parcelRequire("hE9q1")));
function $b1139220491ac4fe$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b1139220491ac4fe$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b1139220491ac4fe$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b1139220491ac4fe$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b1139220491ac4fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b1139220491ac4fe$var$_default = function rgbGamma(y) {
    var color = (0, $b1139220491ac4fe$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $eyM6K.rgb)(start)).r, (end = (0, $eyM6K.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $b1139220491ac4fe$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $b1139220491ac4fe$var$_default;
function $b1139220491ac4fe$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $eyM6K.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $b1139220491ac4fe$var$rgbBasis = $b1139220491ac4fe$var$rgbSpline($b1139220491ac4fe$var$_basis.default);
module.exports.rgbBasis = $b1139220491ac4fe$var$rgbBasis;
var $b1139220491ac4fe$var$rgbBasisClosed = $b1139220491ac4fe$var$rgbSpline($b1139220491ac4fe$var$_basisClosed.default);
module.exports.rgbBasisClosed = $b1139220491ac4fe$var$rgbBasisClosed;

});
parcelRegister("a1vOh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $74c2ac2be00c25df$var$basis;
module.exports.default = $74c2ac2be00c25df$var$_default;
function $74c2ac2be00c25df$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $74c2ac2be00c25df$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $74c2ac2be00c25df$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("3OWQH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c83b0c4ee7a74b9$var$_default;

var $a1vOh = parcelRequire("a1vOh");
function $2c83b0c4ee7a74b9$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $a1vOh.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("hE9q1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd8d7a72f256afc3$var$nogamma;
module.exports.gamma = $cd8d7a72f256afc3$var$gamma;
module.exports.hue = $cd8d7a72f256afc3$var$hue;

var $cd8d7a72f256afc3$var$_constant = $cd8d7a72f256afc3$var$_interopRequireDefault((parcelRequire("8s9ZJ")));
function $cd8d7a72f256afc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cd8d7a72f256afc3$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $cd8d7a72f256afc3$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $cd8d7a72f256afc3$var$hue(a, b) {
    var d = b - a;
    return d ? $cd8d7a72f256afc3$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $cd8d7a72f256afc3$var$_constant.default)(isNaN(a) ? b : a);
}
function $cd8d7a72f256afc3$var$gamma(y) {
    return (y = +y) === 1 ? $cd8d7a72f256afc3$var$nogamma : function(a, b) {
        return b - a ? $cd8d7a72f256afc3$var$exponential(a, b, y) : (0, $cd8d7a72f256afc3$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $cd8d7a72f256afc3$var$nogamma(a, b) {
    var d = b - a;
    return d ? $cd8d7a72f256afc3$var$linear(a, d) : (0, $cd8d7a72f256afc3$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("8s9ZJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $6278b0f88be90622$var$_default = (x)=>()=>x;
module.exports.default = $6278b0f88be90622$var$_default;

});



parcelRegister("kQcG1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2c27f55a6e67554$var$_default;
module.exports.genericArray = $f2c27f55a6e67554$var$genericArray;

var $f2c27f55a6e67554$var$_value = $f2c27f55a6e67554$var$_interopRequireDefault((parcelRequire("bqAXw")));

var $f2c27f55a6e67554$var$_numberArray = $f2c27f55a6e67554$var$_interopRequireWildcard((parcelRequire("cws9j")));
function $f2c27f55a6e67554$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f2c27f55a6e67554$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f2c27f55a6e67554$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f2c27f55a6e67554$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f2c27f55a6e67554$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f2c27f55a6e67554$var$_default(a, b) {
    return ((0, $f2c27f55a6e67554$var$_numberArray.isNumberArray)(b) ? $f2c27f55a6e67554$var$_numberArray.default : $f2c27f55a6e67554$var$genericArray)(a, b);
}
function $f2c27f55a6e67554$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $f2c27f55a6e67554$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("cws9j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $91de4f0a4dd67afc$var$_default;
module.exports.isNumberArray = $91de4f0a4dd67afc$var$isNumberArray;
function $91de4f0a4dd67afc$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $91de4f0a4dd67afc$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("GQCzZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $080cbdd7ac6e0c59$var$_default;
function $080cbdd7ac6e0c59$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("9n4Qi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d2a04a545812b28$var$_default;
function $6d2a04a545812b28$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("2xR4B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1da7d510c8b9150b$var$_default;

var $1da7d510c8b9150b$var$_value = $1da7d510c8b9150b$var$_interopRequireDefault((parcelRequire("bqAXw")));
function $1da7d510c8b9150b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1da7d510c8b9150b$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $1da7d510c8b9150b$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("56Roz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b86ee7ff8efed04$var$_default;

var $3b86ee7ff8efed04$var$_number = $3b86ee7ff8efed04$var$_interopRequireDefault((parcelRequire("9n4Qi")));
function $3b86ee7ff8efed04$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3b86ee7ff8efed04$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $3b86ee7ff8efed04$var$reB = new RegExp($3b86ee7ff8efed04$var$reA.source, "g");
function $3b86ee7ff8efed04$var$zero(b) {
    return function() {
        return b;
    };
}
function $3b86ee7ff8efed04$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $3b86ee7ff8efed04$var$_default(a, b) {
    var bi = $3b86ee7ff8efed04$var$reA.lastIndex = $3b86ee7ff8efed04$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $3b86ee7ff8efed04$var$reA.exec(a)) && (bm = $3b86ee7ff8efed04$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $3b86ee7ff8efed04$var$_number.default)(am, bm)
            });
        }
        bi = $3b86ee7ff8efed04$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $3b86ee7ff8efed04$var$one(q[0].x) : $3b86ee7ff8efed04$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("eP0kF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aca6161d8bd83d34$var$_default;
function $aca6161d8bd83d34$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("lLzpp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd897435e6af771b$var$_default;

var $hE9q1 = parcelRequire("hE9q1");
function $fd897435e6af771b$var$_default(a, b) {
    var i = (0, $hE9q1.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("9mzi1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d118aef1893f91c$var$_default;
function $6d118aef1893f91c$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("f9YjU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $b0967c93565b9772$var$_number = $b0967c93565b9772$var$_interopRequireDefault((parcelRequire("9n4Qi")));

var $jx2Ik = parcelRequire("jx2Ik");
function $b0967c93565b9772$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b0967c93565b9772$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $b0967c93565b9772$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $b0967c93565b9772$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $b0967c93565b9772$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $b0967c93565b9772$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $b0967c93565b9772$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $b0967c93565b9772$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $b0967c93565b9772$var$interpolateTransformCss = $b0967c93565b9772$var$interpolateTransform($jx2Ik.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $b0967c93565b9772$var$interpolateTransformCss;
var $b0967c93565b9772$var$interpolateTransformSvg = $b0967c93565b9772$var$interpolateTransform($jx2Ik.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $b0967c93565b9772$var$interpolateTransformSvg;

});
parcelRegister("jx2Ik", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $e383345a236f382d$var$parseCss;
module.exports.parseSvg = $e383345a236f382d$var$parseSvg;

var $e383345a236f382d$var$_decompose = $e383345a236f382d$var$_interopRequireWildcard((parcelRequire("31XW4")));
function $e383345a236f382d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e383345a236f382d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e383345a236f382d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e383345a236f382d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $e383345a236f382d$var$svgNode;
/* eslint-disable no-undef */ function $e383345a236f382d$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $e383345a236f382d$var$_decompose.identity : (0, $e383345a236f382d$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $e383345a236f382d$var$parseSvg(value) {
    if (value == null) return $e383345a236f382d$var$_decompose.identity;
    if (!$e383345a236f382d$var$svgNode) $e383345a236f382d$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $e383345a236f382d$var$svgNode.setAttribute("transform", value);
    if (!(value = $e383345a236f382d$var$svgNode.transform.baseVal.consolidate())) return $e383345a236f382d$var$_decompose.identity;
    value = value.matrix;
    return (0, $e383345a236f382d$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("31XW4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $234ff50cd36ed304$var$_default;
module.exports.identity = void 0;
var $234ff50cd36ed304$var$degrees = 180 / Math.PI;
var $234ff50cd36ed304$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $234ff50cd36ed304$var$identity;
function $234ff50cd36ed304$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $234ff50cd36ed304$var$degrees,
        skewX: Math.atan(skewX) * $234ff50cd36ed304$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("j7cx5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dea86482284d55a5$var$epsilon2 = 1e-12;
function $dea86482284d55a5$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $dea86482284d55a5$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $dea86482284d55a5$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $dea86482284d55a5$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $dea86482284d55a5$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $dea86482284d55a5$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $dea86482284d55a5$var$tanh(rho * s + r0) - $dea86482284d55a5$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $dea86482284d55a5$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $dea86482284d55a5$var$_default;

});

parcelRegister("bfWaM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $eyM6K = parcelRequire("eyM6K");

var $831e3853f95e624c$var$_color = $831e3853f95e624c$var$_interopRequireWildcard((parcelRequire("hE9q1")));
function $831e3853f95e624c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($831e3853f95e624c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $831e3853f95e624c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $831e3853f95e624c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $831e3853f95e624c$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $eyM6K.hsl)(start)).h, (end = (0, $eyM6K.hsl)(end)).h), s = (0, $831e3853f95e624c$var$_color.default)(start.s, end.s), l = (0, $831e3853f95e624c$var$_color.default)(start.l, end.l), opacity = (0, $831e3853f95e624c$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $831e3853f95e624c$var$_default = $831e3853f95e624c$var$hsl($831e3853f95e624c$var$_color.hue);
module.exports.default = $831e3853f95e624c$var$_default;
var $831e3853f95e624c$var$hslLong = $831e3853f95e624c$var$hsl($831e3853f95e624c$var$_color.default);
module.exports.hslLong = $831e3853f95e624c$var$hslLong;

});

parcelRegister("dS0ed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a1907ed219b19dbe$var$lab;

var $eyM6K = parcelRequire("eyM6K");

var $a1907ed219b19dbe$var$_color = $a1907ed219b19dbe$var$_interopRequireDefault((parcelRequire("hE9q1")));
function $a1907ed219b19dbe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a1907ed219b19dbe$var$lab(start, end) {
    var l = (0, $a1907ed219b19dbe$var$_color.default)((start = (0, $eyM6K.lab)(start)).l, (end = (0, $eyM6K.lab)(end)).l), a = (0, $a1907ed219b19dbe$var$_color.default)(start.a, end.a), b = (0, $a1907ed219b19dbe$var$_color.default)(start.b, end.b), opacity = (0, $a1907ed219b19dbe$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("i3ui9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $eyM6K = parcelRequire("eyM6K");

var $d2500124005000b1$var$_color = $d2500124005000b1$var$_interopRequireWildcard((parcelRequire("hE9q1")));
function $d2500124005000b1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d2500124005000b1$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d2500124005000b1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d2500124005000b1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d2500124005000b1$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $eyM6K.hcl)(start)).h, (end = (0, $eyM6K.hcl)(end)).h), c = (0, $d2500124005000b1$var$_color.default)(start.c, end.c), l = (0, $d2500124005000b1$var$_color.default)(start.l, end.l), opacity = (0, $d2500124005000b1$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $d2500124005000b1$var$_default = $d2500124005000b1$var$hcl($d2500124005000b1$var$_color.hue);
module.exports.default = $d2500124005000b1$var$_default;
var $d2500124005000b1$var$hclLong = $d2500124005000b1$var$hcl($d2500124005000b1$var$_color.default);
module.exports.hclLong = $d2500124005000b1$var$hclLong;

});

parcelRegister("ichIC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $eyM6K = parcelRequire("eyM6K");

var $d3f7178c47a6553b$var$_color = $d3f7178c47a6553b$var$_interopRequireWildcard((parcelRequire("hE9q1")));
function $d3f7178c47a6553b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d3f7178c47a6553b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d3f7178c47a6553b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d3f7178c47a6553b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d3f7178c47a6553b$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $eyM6K.cubehelix)(start)).h, (end = (0, $eyM6K.cubehelix)(end)).h), s = (0, $d3f7178c47a6553b$var$_color.default)(start.s, end.s), l = (0, $d3f7178c47a6553b$var$_color.default)(start.l, end.l), opacity = (0, $d3f7178c47a6553b$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $d3f7178c47a6553b$var$_default = $d3f7178c47a6553b$var$cubehelix($d3f7178c47a6553b$var$_color.hue);
module.exports.default = $d3f7178c47a6553b$var$_default;
var $d3f7178c47a6553b$var$cubehelixLong = $d3f7178c47a6553b$var$cubehelix($d3f7178c47a6553b$var$_color.default);
module.exports.cubehelixLong = $d3f7178c47a6553b$var$cubehelixLong;

});

parcelRegister("fPqKp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b8605ded540cf407$var$piecewise;

var $b8605ded540cf407$var$_value = $b8605ded540cf407$var$_interopRequireDefault((parcelRequire("bqAXw")));
function $b8605ded540cf407$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b8605ded540cf407$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $b8605ded540cf407$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("lxEcn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $faebdca1a21258f6$var$_default;
function $faebdca1a21258f6$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("eq00u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7f37fc22b6a3430$var$constants;
function $a7f37fc22b6a3430$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("9pEAW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6da5f02991bd4350$var$number;
function $6da5f02991bd4350$var$number(x) {
    return +x;
}

});


parcelRegister("lIlUJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fceeb4b385ade6d6$var$tickFormat;

var $dfXar = parcelRequire("dfXar");

var $7uMWs = parcelRequire("7uMWs");
function $fceeb4b385ade6d6$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $dfXar.tickStep)(start, stop, count), precision;
    specifier = (0, $7uMWs.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $7uMWs.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $7uMWs.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $7uMWs.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $7uMWs.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $7uMWs.format)(specifier);
}

});
parcelRegister("7uMWs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_precisionRound.default;
    }
});

var $57514c9906feacb9$var$_defaultLocale = $57514c9906feacb9$var$_interopRequireWildcard((parcelRequire("f4gnY")));

var $57514c9906feacb9$var$_locale = $57514c9906feacb9$var$_interopRequireDefault((parcelRequire("basO1")));

var $57514c9906feacb9$var$_formatSpecifier = $57514c9906feacb9$var$_interopRequireWildcard((parcelRequire("4V7rf")));

var $57514c9906feacb9$var$_precisionFixed = $57514c9906feacb9$var$_interopRequireDefault((parcelRequire("l9uU9")));

var $57514c9906feacb9$var$_precisionPrefix = $57514c9906feacb9$var$_interopRequireDefault((parcelRequire("alJCX")));

var $57514c9906feacb9$var$_precisionRound = $57514c9906feacb9$var$_interopRequireDefault((parcelRequire("5Q4CM")));
function $57514c9906feacb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $57514c9906feacb9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($57514c9906feacb9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $57514c9906feacb9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $57514c9906feacb9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("f4gnY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af83f09335af1d37$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $af83f09335af1d37$var$_locale = $af83f09335af1d37$var$_interopRequireDefault((parcelRequire("basO1")));
function $af83f09335af1d37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $af83f09335af1d37$var$locale;
var $af83f09335af1d37$var$format;
module.exports.format = $af83f09335af1d37$var$format;
var $af83f09335af1d37$var$formatPrefix;
module.exports.formatPrefix = $af83f09335af1d37$var$formatPrefix;
$af83f09335af1d37$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $af83f09335af1d37$var$defaultLocale(definition) {
    $af83f09335af1d37$var$locale = (0, $af83f09335af1d37$var$_locale.default)(definition);
    module.exports.format = $af83f09335af1d37$var$format = $af83f09335af1d37$var$locale.format;
    module.exports.formatPrefix = $af83f09335af1d37$var$formatPrefix = $af83f09335af1d37$var$locale.formatPrefix;
    return $af83f09335af1d37$var$locale;
}

});
parcelRegister("basO1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8216f91b54cfbe15$var$_default;

var $8216f91b54cfbe15$var$_exponent = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("1Ql80")));

var $8216f91b54cfbe15$var$_formatGroup = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("izmDk")));

var $8216f91b54cfbe15$var$_formatNumerals = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("gjmM7")));

var $8216f91b54cfbe15$var$_formatSpecifier = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("4V7rf")));

var $8216f91b54cfbe15$var$_formatTrim = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("2dMwj")));

var $8216f91b54cfbe15$var$_formatTypes = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("jhi0g")));

var $fc1ax = parcelRequire("fc1ax");

var $8216f91b54cfbe15$var$_identity = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("8aR4t")));
function $8216f91b54cfbe15$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8216f91b54cfbe15$var$map = Array.prototype.map, $8216f91b54cfbe15$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $8216f91b54cfbe15$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $8216f91b54cfbe15$var$_identity.default : (0, $8216f91b54cfbe15$var$_formatGroup.default)($8216f91b54cfbe15$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $8216f91b54cfbe15$var$_identity.default : (0, $8216f91b54cfbe15$var$_formatNumerals.default)($8216f91b54cfbe15$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $8216f91b54cfbe15$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$8216f91b54cfbe15$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $8216f91b54cfbe15$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $8216f91b54cfbe15$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $8216f91b54cfbe15$var$prefixes[8 + $fc1ax.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $8216f91b54cfbe15$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $8216f91b54cfbe15$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $8216f91b54cfbe15$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("1Ql80", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $157b0960229b1f1a$var$_default;

var $3sOC5 = parcelRequire("3sOC5");
function $157b0960229b1f1a$var$_default(x) {
    return x = (0, $3sOC5.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("3sOC5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $285b3f5f938e3df5$var$_default;
module.exports.formatDecimalParts = $285b3f5f938e3df5$var$formatDecimalParts;
function $285b3f5f938e3df5$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $285b3f5f938e3df5$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("izmDk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d84d0d68ca9f5790$var$_default;
function $d84d0d68ca9f5790$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("gjmM7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be00165b46e31dc8$var$_default;
function $be00165b46e31dc8$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("4V7rf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $395241695799c319$var$FormatSpecifier;
module.exports.default = $395241695799c319$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $395241695799c319$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $395241695799c319$var$formatSpecifier(specifier) {
    if (!(match = $395241695799c319$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $395241695799c319$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$395241695799c319$var$formatSpecifier.prototype = $395241695799c319$var$FormatSpecifier.prototype; // instanceof
function $395241695799c319$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$395241695799c319$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("2dMwj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19e26ec3d81dc191$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $19e26ec3d81dc191$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("jhi0g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e08d91e6758090a0$var$_formatDecimal = $e08d91e6758090a0$var$_interopRequireDefault((parcelRequire("3sOC5")));

var $e08d91e6758090a0$var$_formatPrefixAuto = $e08d91e6758090a0$var$_interopRequireDefault((parcelRequire("fc1ax")));

var $e08d91e6758090a0$var$_formatRounded = $e08d91e6758090a0$var$_interopRequireDefault((parcelRequire("3eltF")));
function $e08d91e6758090a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e08d91e6758090a0$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $e08d91e6758090a0$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $e08d91e6758090a0$var$_formatRounded.default)(x * 100, p),
    "r": $e08d91e6758090a0$var$_formatRounded.default,
    "s": $e08d91e6758090a0$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $e08d91e6758090a0$var$_default;

});
parcelRegister("fc1ax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b0f8e2294dd2f03f$var$_default;
module.exports.prefixExponent = void 0;

var $3sOC5 = parcelRequire("3sOC5");
var $b0f8e2294dd2f03f$var$prefixExponent;
module.exports.prefixExponent = $b0f8e2294dd2f03f$var$prefixExponent;
function $b0f8e2294dd2f03f$var$_default(x, p) {
    var d = (0, $3sOC5.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $b0f8e2294dd2f03f$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $3sOC5.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("3eltF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25a356e97a1d9ed6$var$_default;

var $3sOC5 = parcelRequire("3sOC5");
function $25a356e97a1d9ed6$var$_default(x, p) {
    var d = (0, $3sOC5.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("8aR4t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f386cbdb64a70ea$var$_default;
function $5f386cbdb64a70ea$var$_default(x) {
    return x;
}

});



parcelRegister("l9uU9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f662693e8de88ced$var$_default;

var $f662693e8de88ced$var$_exponent = $f662693e8de88ced$var$_interopRequireDefault((parcelRequire("1Ql80")));
function $f662693e8de88ced$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f662693e8de88ced$var$_default(step) {
    return Math.max(0, -(0, $f662693e8de88ced$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("alJCX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $788f422f57b10027$var$_default;

var $788f422f57b10027$var$_exponent = $788f422f57b10027$var$_interopRequireDefault((parcelRequire("1Ql80")));
function $788f422f57b10027$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $788f422f57b10027$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $788f422f57b10027$var$_exponent.default)(value) / 3))) * 3 - (0, $788f422f57b10027$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("5Q4CM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44056569c9e9982f$var$_default;

var $44056569c9e9982f$var$_exponent = $44056569c9e9982f$var$_interopRequireDefault((parcelRequire("1Ql80")));
function $44056569c9e9982f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $44056569c9e9982f$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $44056569c9e9982f$var$_exponent.default)(max) - (0, $44056569c9e9982f$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("cw7m0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $91ce2d8a0eb84c4f$var$log;
module.exports.loggish = $91ce2d8a0eb84c4f$var$loggish;

var $dfXar = parcelRequire("dfXar");

var $7uMWs = parcelRequire("7uMWs");

var $91ce2d8a0eb84c4f$var$_nice = $91ce2d8a0eb84c4f$var$_interopRequireDefault((parcelRequire("etVnX")));

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");
function $91ce2d8a0eb84c4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $91ce2d8a0eb84c4f$var$transformLog(x) {
    return Math.log(x);
}
function $91ce2d8a0eb84c4f$var$transformExp(x) {
    return Math.exp(x);
}
function $91ce2d8a0eb84c4f$var$transformLogn(x) {
    return -Math.log(-x);
}
function $91ce2d8a0eb84c4f$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $91ce2d8a0eb84c4f$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $91ce2d8a0eb84c4f$var$powp(base) {
    return base === 10 ? $91ce2d8a0eb84c4f$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $91ce2d8a0eb84c4f$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $91ce2d8a0eb84c4f$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $91ce2d8a0eb84c4f$var$loggish(transform) {
    const scale = transform($91ce2d8a0eb84c4f$var$transformLog, $91ce2d8a0eb84c4f$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $91ce2d8a0eb84c4f$var$logp(base), pows = $91ce2d8a0eb84c4f$var$powp(base);
        if (domain()[0] < 0) {
            logs = $91ce2d8a0eb84c4f$var$reflect(logs), pows = $91ce2d8a0eb84c4f$var$reflect(pows);
            transform($91ce2d8a0eb84c4f$var$transformLogn, $91ce2d8a0eb84c4f$var$transformExpn);
        } else transform($91ce2d8a0eb84c4f$var$transformLog, $91ce2d8a0eb84c4f$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $dfXar.ticks)(u, v, n);
        } else z = (0, $dfXar.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $7uMWs.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $7uMWs.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $91ce2d8a0eb84c4f$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $91ce2d8a0eb84c4f$var$log() {
    const scale = $91ce2d8a0eb84c4f$var$loggish((0, $kcPbm.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $kcPbm.copy)(scale, $91ce2d8a0eb84c4f$var$log()).base(scale.base());
    $ezRKk.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("etVnX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8b049abb6dce171$var$nice;
function $a8b049abb6dce171$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("3DXgb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a72fb69a5cbf18d$var$symlog;
module.exports.symlogish = $2a72fb69a5cbf18d$var$symlogish;

var $8cBoe = parcelRequire("8cBoe");

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");
function $2a72fb69a5cbf18d$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $2a72fb69a5cbf18d$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $2a72fb69a5cbf18d$var$symlogish(transform) {
    var c = 1, scale = transform($2a72fb69a5cbf18d$var$transformSymlog(c), $2a72fb69a5cbf18d$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($2a72fb69a5cbf18d$var$transformSymlog(c = +_), $2a72fb69a5cbf18d$var$transformSymexp(c)) : c;
    };
    return (0, $8cBoe.linearish)(scale);
}
function $2a72fb69a5cbf18d$var$symlog() {
    var scale = $2a72fb69a5cbf18d$var$symlogish((0, $kcPbm.transformer)());
    scale.copy = function() {
        return (0, $kcPbm.copy)(scale, $2a72fb69a5cbf18d$var$symlog()).constant(scale.constant());
    };
    return $ezRKk.initRange.apply(scale, arguments);
}

});

parcelRegister("6kjWv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49b414858ebc7381$var$pow;
module.exports.powish = $49b414858ebc7381$var$powish;
module.exports.sqrt = $49b414858ebc7381$var$sqrt;

var $8cBoe = parcelRequire("8cBoe");

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");
function $49b414858ebc7381$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $49b414858ebc7381$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $49b414858ebc7381$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $49b414858ebc7381$var$powish(transform) {
    var scale = transform($kcPbm.identity, $kcPbm.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($kcPbm.identity, $kcPbm.identity) : exponent === 0.5 ? transform($49b414858ebc7381$var$transformSqrt, $49b414858ebc7381$var$transformSquare) : transform($49b414858ebc7381$var$transformPow(exponent), $49b414858ebc7381$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $8cBoe.linearish)(scale);
}
function $49b414858ebc7381$var$pow() {
    var scale = $49b414858ebc7381$var$powish((0, $kcPbm.transformer)());
    scale.copy = function() {
        return (0, $kcPbm.copy)(scale, $49b414858ebc7381$var$pow()).exponent(scale.exponent());
    };
    $ezRKk.initRange.apply(scale, arguments);
    return scale;
}
function $49b414858ebc7381$var$sqrt() {
    return $49b414858ebc7381$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("kwNoN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef1d1d63bf1479b2$var$radial;

var $ef1d1d63bf1479b2$var$_continuous = $ef1d1d63bf1479b2$var$_interopRequireDefault((parcelRequire("kcPbm")));

var $ezRKk = parcelRequire("ezRKk");

var $8cBoe = parcelRequire("8cBoe");

var $ef1d1d63bf1479b2$var$_number = $ef1d1d63bf1479b2$var$_interopRequireDefault((parcelRequire("9pEAW")));
function $ef1d1d63bf1479b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef1d1d63bf1479b2$var$square(x) {
    return Math.sign(x) * x * x;
}
function $ef1d1d63bf1479b2$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $ef1d1d63bf1479b2$var$radial() {
    var squared = (0, $ef1d1d63bf1479b2$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $ef1d1d63bf1479b2$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($ef1d1d63bf1479b2$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $ef1d1d63bf1479b2$var$_number.default)).map($ef1d1d63bf1479b2$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $ef1d1d63bf1479b2$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $ezRKk.initRange.apply(scale, arguments);
    return (0, $8cBoe.linearish)(scale);
}

});

parcelRegister("kEBaY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f094617a4f64d8ba$var$quantile;

var $dfXar = parcelRequire("dfXar");

var $ezRKk = parcelRequire("ezRKk");
function $f094617a4f64d8ba$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $dfXar.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $dfXar.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($dfXar.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $f094617a4f64d8ba$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $ezRKk.initRange.apply(scale, arguments);
}

});

parcelRegister("5prmo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f0482b6ea5d0b8f$var$quantize;

var $dfXar = parcelRequire("dfXar");

var $8cBoe = parcelRequire("8cBoe");

var $ezRKk = parcelRequire("ezRKk");
function $3f0482b6ea5d0b8f$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $dfXar.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $3f0482b6ea5d0b8f$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $ezRKk.initRange.apply((0, $8cBoe.linearish)(scale), arguments);
}

});

parcelRegister("81sXE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d74e1d056465429$var$threshold;

var $dfXar = parcelRequire("dfXar");

var $ezRKk = parcelRequire("ezRKk");
function $5d74e1d056465429$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $dfXar.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $5d74e1d056465429$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $ezRKk.initRange.apply(scale, arguments);
}

});

parcelRegister("3lv9c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $26fb7e7cfa923bda$var$calendar;
module.exports.default = $26fb7e7cfa923bda$var$time;

var $2iBJo = parcelRequire("2iBJo");

var $allvJ = parcelRequire("allvJ");

var $26fb7e7cfa923bda$var$_continuous = $26fb7e7cfa923bda$var$_interopRequireWildcard((parcelRequire("kcPbm")));

var $ezRKk = parcelRequire("ezRKk");

var $26fb7e7cfa923bda$var$_nice = $26fb7e7cfa923bda$var$_interopRequireDefault((parcelRequire("etVnX")));
function $26fb7e7cfa923bda$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $26fb7e7cfa923bda$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($26fb7e7cfa923bda$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $26fb7e7cfa923bda$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $26fb7e7cfa923bda$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $26fb7e7cfa923bda$var$date(t) {
    return new Date(t);
}
function $26fb7e7cfa923bda$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $26fb7e7cfa923bda$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $26fb7e7cfa923bda$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $26fb7e7cfa923bda$var$number)) : domain().map($26fb7e7cfa923bda$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $26fb7e7cfa923bda$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $26fb7e7cfa923bda$var$_continuous.copy)(scale, $26fb7e7cfa923bda$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $26fb7e7cfa923bda$var$time() {
    return $ezRKk.initRange.apply($26fb7e7cfa923bda$var$calendar($2iBJo.timeTicks, $2iBJo.timeTickInterval, $2iBJo.timeYear, $2iBJo.timeMonth, $2iBJo.timeWeek, $2iBJo.timeDay, $2iBJo.timeHour, $2iBJo.timeMinute, $2iBJo.timeSecond, $allvJ.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("2iBJo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $9wwjs.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $9wwjs.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $9wwjs.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $9wwjs.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $9wwjs.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $9wwjs.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $9wwjs.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $9wwjs.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $9wwjs.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $9wwjs.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $fi2S9.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $fi2S9.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $9wwjs.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $9wwjs.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $9wwjs.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $9wwjs.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $9wwjs.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $9wwjs.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $fi2S9.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $fi2S9.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcYear.utcYears;
    }
});

var $1aca87d4f197032e$var$_interval = $1aca87d4f197032e$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $1aca87d4f197032e$var$_millisecond = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("joIgc")));

var $1aca87d4f197032e$var$_second = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("emUZs")));

var $1aca87d4f197032e$var$_minute = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("bWQ0C")));

var $1aca87d4f197032e$var$_hour = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("la0bP")));

var $1aca87d4f197032e$var$_day = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("8Qo8R")));

var $9wwjs = parcelRequire("9wwjs");

var $1aca87d4f197032e$var$_month = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("eQlmO")));

var $1aca87d4f197032e$var$_year = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("bCw6g")));

var $1aca87d4f197032e$var$_utcMinute = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("56CHD")));

var $1aca87d4f197032e$var$_utcHour = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("4Id0V")));

var $1aca87d4f197032e$var$_utcDay = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("coaP9")));

var $gYiWY = parcelRequire("gYiWY");

var $1aca87d4f197032e$var$_utcMonth = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("15kWX")));

var $1aca87d4f197032e$var$_utcYear = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("bRXUB")));

var $fi2S9 = parcelRequire("fi2S9");
function $1aca87d4f197032e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1aca87d4f197032e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1aca87d4f197032e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1aca87d4f197032e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1aca87d4f197032e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("9mYsL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d2511cf3662afe1$var$newInterval;
var $6d2511cf3662afe1$var$t0 = new Date(), $6d2511cf3662afe1$var$t1 = new Date();
function $6d2511cf3662afe1$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $6d2511cf3662afe1$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $6d2511cf3662afe1$var$t0.setTime(+start), $6d2511cf3662afe1$var$t1.setTime(+end);
            floori($6d2511cf3662afe1$var$t0), floori($6d2511cf3662afe1$var$t1);
            return Math.floor(count($6d2511cf3662afe1$var$t0, $6d2511cf3662afe1$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("joIgc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $e1f2975b854fe23b$var$_interval = $e1f2975b854fe23b$var$_interopRequireDefault((parcelRequire("9mYsL")));
function $e1f2975b854fe23b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e1f2975b854fe23b$var$millisecond = (0, $e1f2975b854fe23b$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$e1f2975b854fe23b$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $e1f2975b854fe23b$var$millisecond;
    return (0, $e1f2975b854fe23b$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $e1f2975b854fe23b$var$_default = $e1f2975b854fe23b$var$millisecond;
module.exports.default = $e1f2975b854fe23b$var$_default;
var $e1f2975b854fe23b$var$milliseconds = $e1f2975b854fe23b$var$millisecond.range;
module.exports.milliseconds = $e1f2975b854fe23b$var$milliseconds;

});

parcelRegister("emUZs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $a75f53d9ffa9fbfb$var$_interval = $a75f53d9ffa9fbfb$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $a75f53d9ffa9fbfb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a75f53d9ffa9fbfb$var$second = (0, $a75f53d9ffa9fbfb$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $ffS6a.durationSecond);
}, function(start, end) {
    return (end - start) / $ffS6a.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $a75f53d9ffa9fbfb$var$_default = $a75f53d9ffa9fbfb$var$second;
module.exports.default = $a75f53d9ffa9fbfb$var$_default;
var $a75f53d9ffa9fbfb$var$seconds = $a75f53d9ffa9fbfb$var$second.range;
module.exports.seconds = $a75f53d9ffa9fbfb$var$seconds;

});
parcelRegister("ffS6a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $b1b2388a57633b6c$var$durationSecond = 1000;
module.exports.durationSecond = $b1b2388a57633b6c$var$durationSecond;
const $b1b2388a57633b6c$var$durationMinute = $b1b2388a57633b6c$var$durationSecond * 60;
module.exports.durationMinute = $b1b2388a57633b6c$var$durationMinute;
const $b1b2388a57633b6c$var$durationHour = $b1b2388a57633b6c$var$durationMinute * 60;
module.exports.durationHour = $b1b2388a57633b6c$var$durationHour;
const $b1b2388a57633b6c$var$durationDay = $b1b2388a57633b6c$var$durationHour * 24;
module.exports.durationDay = $b1b2388a57633b6c$var$durationDay;
const $b1b2388a57633b6c$var$durationWeek = $b1b2388a57633b6c$var$durationDay * 7;
module.exports.durationWeek = $b1b2388a57633b6c$var$durationWeek;
const $b1b2388a57633b6c$var$durationMonth = $b1b2388a57633b6c$var$durationDay * 30;
module.exports.durationMonth = $b1b2388a57633b6c$var$durationMonth;
const $b1b2388a57633b6c$var$durationYear = $b1b2388a57633b6c$var$durationDay * 365;
module.exports.durationYear = $b1b2388a57633b6c$var$durationYear;

});


parcelRegister("bWQ0C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $8b2d7466a451a47f$var$_interval = $8b2d7466a451a47f$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $8b2d7466a451a47f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8b2d7466a451a47f$var$minute = (0, $8b2d7466a451a47f$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $ffS6a.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $ffS6a.durationMinute);
}, function(start, end) {
    return (end - start) / $ffS6a.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $8b2d7466a451a47f$var$_default = $8b2d7466a451a47f$var$minute;
module.exports.default = $8b2d7466a451a47f$var$_default;
var $8b2d7466a451a47f$var$minutes = $8b2d7466a451a47f$var$minute.range;
module.exports.minutes = $8b2d7466a451a47f$var$minutes;

});

parcelRegister("la0bP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $f67aadcffd65d77a$var$_interval = $f67aadcffd65d77a$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $f67aadcffd65d77a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f67aadcffd65d77a$var$hour = (0, $f67aadcffd65d77a$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $ffS6a.durationSecond - date.getMinutes() * $ffS6a.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $ffS6a.durationHour);
}, function(start, end) {
    return (end - start) / $ffS6a.durationHour;
}, function(date) {
    return date.getHours();
});
var $f67aadcffd65d77a$var$_default = $f67aadcffd65d77a$var$hour;
module.exports.default = $f67aadcffd65d77a$var$_default;
var $f67aadcffd65d77a$var$hours = $f67aadcffd65d77a$var$hour.range;
module.exports.hours = $f67aadcffd65d77a$var$hours;

});

parcelRegister("8Qo8R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $6705e829935a7cb9$var$_interval = $6705e829935a7cb9$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $6705e829935a7cb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6705e829935a7cb9$var$day = (0, $6705e829935a7cb9$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $ffS6a.durationMinute) / $ffS6a.durationDay, (date)=>date.getDate() - 1);
var $6705e829935a7cb9$var$_default = $6705e829935a7cb9$var$day;
module.exports.default = $6705e829935a7cb9$var$_default;
var $6705e829935a7cb9$var$days = $6705e829935a7cb9$var$day.range;
module.exports.days = $6705e829935a7cb9$var$days;

});

parcelRegister("9wwjs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $6ef02adb24568350$var$_interval = $6ef02adb24568350$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $6ef02adb24568350$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6ef02adb24568350$var$weekday(i) {
    return (0, $6ef02adb24568350$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $ffS6a.durationMinute) / $ffS6a.durationWeek;
    });
}
var $6ef02adb24568350$var$sunday = $6ef02adb24568350$var$weekday(0);
module.exports.sunday = $6ef02adb24568350$var$sunday;
var $6ef02adb24568350$var$monday = $6ef02adb24568350$var$weekday(1);
module.exports.monday = $6ef02adb24568350$var$monday;
var $6ef02adb24568350$var$tuesday = $6ef02adb24568350$var$weekday(2);
module.exports.tuesday = $6ef02adb24568350$var$tuesday;
var $6ef02adb24568350$var$wednesday = $6ef02adb24568350$var$weekday(3);
module.exports.wednesday = $6ef02adb24568350$var$wednesday;
var $6ef02adb24568350$var$thursday = $6ef02adb24568350$var$weekday(4);
module.exports.thursday = $6ef02adb24568350$var$thursday;
var $6ef02adb24568350$var$friday = $6ef02adb24568350$var$weekday(5);
module.exports.friday = $6ef02adb24568350$var$friday;
var $6ef02adb24568350$var$saturday = $6ef02adb24568350$var$weekday(6);
module.exports.saturday = $6ef02adb24568350$var$saturday;
var $6ef02adb24568350$var$sundays = $6ef02adb24568350$var$sunday.range;
module.exports.sundays = $6ef02adb24568350$var$sundays;
var $6ef02adb24568350$var$mondays = $6ef02adb24568350$var$monday.range;
module.exports.mondays = $6ef02adb24568350$var$mondays;
var $6ef02adb24568350$var$tuesdays = $6ef02adb24568350$var$tuesday.range;
module.exports.tuesdays = $6ef02adb24568350$var$tuesdays;
var $6ef02adb24568350$var$wednesdays = $6ef02adb24568350$var$wednesday.range;
module.exports.wednesdays = $6ef02adb24568350$var$wednesdays;
var $6ef02adb24568350$var$thursdays = $6ef02adb24568350$var$thursday.range;
module.exports.thursdays = $6ef02adb24568350$var$thursdays;
var $6ef02adb24568350$var$fridays = $6ef02adb24568350$var$friday.range;
module.exports.fridays = $6ef02adb24568350$var$fridays;
var $6ef02adb24568350$var$saturdays = $6ef02adb24568350$var$saturday.range;
module.exports.saturdays = $6ef02adb24568350$var$saturdays;

});

parcelRegister("eQlmO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $ace67f0a1f8c565a$var$_interval = $ace67f0a1f8c565a$var$_interopRequireDefault((parcelRequire("9mYsL")));
function $ace67f0a1f8c565a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ace67f0a1f8c565a$var$month = (0, $ace67f0a1f8c565a$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $ace67f0a1f8c565a$var$_default = $ace67f0a1f8c565a$var$month;
module.exports.default = $ace67f0a1f8c565a$var$_default;
var $ace67f0a1f8c565a$var$months = $ace67f0a1f8c565a$var$month.range;
module.exports.months = $ace67f0a1f8c565a$var$months;

});

parcelRegister("bCw6g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $875c24b45131705a$var$_interval = $875c24b45131705a$var$_interopRequireDefault((parcelRequire("9mYsL")));
function $875c24b45131705a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $875c24b45131705a$var$year = (0, $875c24b45131705a$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$875c24b45131705a$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $875c24b45131705a$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $875c24b45131705a$var$_default = $875c24b45131705a$var$year;
module.exports.default = $875c24b45131705a$var$_default;
var $875c24b45131705a$var$years = $875c24b45131705a$var$year.range;
module.exports.years = $875c24b45131705a$var$years;

});

parcelRegister("56CHD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $3b7b88d507c18b58$var$_interval = $3b7b88d507c18b58$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $3b7b88d507c18b58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3b7b88d507c18b58$var$utcMinute = (0, $3b7b88d507c18b58$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $ffS6a.durationMinute);
}, function(start, end) {
    return (end - start) / $ffS6a.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $3b7b88d507c18b58$var$_default = $3b7b88d507c18b58$var$utcMinute;
module.exports.default = $3b7b88d507c18b58$var$_default;
var $3b7b88d507c18b58$var$utcMinutes = $3b7b88d507c18b58$var$utcMinute.range;
module.exports.utcMinutes = $3b7b88d507c18b58$var$utcMinutes;

});

parcelRegister("4Id0V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $36e55dcbc0be1199$var$_interval = $36e55dcbc0be1199$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $36e55dcbc0be1199$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $36e55dcbc0be1199$var$utcHour = (0, $36e55dcbc0be1199$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $ffS6a.durationHour);
}, function(start, end) {
    return (end - start) / $ffS6a.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $36e55dcbc0be1199$var$_default = $36e55dcbc0be1199$var$utcHour;
module.exports.default = $36e55dcbc0be1199$var$_default;
var $36e55dcbc0be1199$var$utcHours = $36e55dcbc0be1199$var$utcHour.range;
module.exports.utcHours = $36e55dcbc0be1199$var$utcHours;

});

parcelRegister("coaP9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $90501f5dc5e67a5a$var$_interval = $90501f5dc5e67a5a$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $90501f5dc5e67a5a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $90501f5dc5e67a5a$var$utcDay = (0, $90501f5dc5e67a5a$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $ffS6a.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $90501f5dc5e67a5a$var$_default = $90501f5dc5e67a5a$var$utcDay;
module.exports.default = $90501f5dc5e67a5a$var$_default;
var $90501f5dc5e67a5a$var$utcDays = $90501f5dc5e67a5a$var$utcDay.range;
module.exports.utcDays = $90501f5dc5e67a5a$var$utcDays;

});

parcelRegister("gYiWY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $c5b0f30bdebda553$var$_interval = $c5b0f30bdebda553$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $c5b0f30bdebda553$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c5b0f30bdebda553$var$utcWeekday(i) {
    return (0, $c5b0f30bdebda553$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $ffS6a.durationWeek;
    });
}
var $c5b0f30bdebda553$var$utcSunday = $c5b0f30bdebda553$var$utcWeekday(0);
module.exports.utcSunday = $c5b0f30bdebda553$var$utcSunday;
var $c5b0f30bdebda553$var$utcMonday = $c5b0f30bdebda553$var$utcWeekday(1);
module.exports.utcMonday = $c5b0f30bdebda553$var$utcMonday;
var $c5b0f30bdebda553$var$utcTuesday = $c5b0f30bdebda553$var$utcWeekday(2);
module.exports.utcTuesday = $c5b0f30bdebda553$var$utcTuesday;
var $c5b0f30bdebda553$var$utcWednesday = $c5b0f30bdebda553$var$utcWeekday(3);
module.exports.utcWednesday = $c5b0f30bdebda553$var$utcWednesday;
var $c5b0f30bdebda553$var$utcThursday = $c5b0f30bdebda553$var$utcWeekday(4);
module.exports.utcThursday = $c5b0f30bdebda553$var$utcThursday;
var $c5b0f30bdebda553$var$utcFriday = $c5b0f30bdebda553$var$utcWeekday(5);
module.exports.utcFriday = $c5b0f30bdebda553$var$utcFriday;
var $c5b0f30bdebda553$var$utcSaturday = $c5b0f30bdebda553$var$utcWeekday(6);
module.exports.utcSaturday = $c5b0f30bdebda553$var$utcSaturday;
var $c5b0f30bdebda553$var$utcSundays = $c5b0f30bdebda553$var$utcSunday.range;
module.exports.utcSundays = $c5b0f30bdebda553$var$utcSundays;
var $c5b0f30bdebda553$var$utcMondays = $c5b0f30bdebda553$var$utcMonday.range;
module.exports.utcMondays = $c5b0f30bdebda553$var$utcMondays;
var $c5b0f30bdebda553$var$utcTuesdays = $c5b0f30bdebda553$var$utcTuesday.range;
module.exports.utcTuesdays = $c5b0f30bdebda553$var$utcTuesdays;
var $c5b0f30bdebda553$var$utcWednesdays = $c5b0f30bdebda553$var$utcWednesday.range;
module.exports.utcWednesdays = $c5b0f30bdebda553$var$utcWednesdays;
var $c5b0f30bdebda553$var$utcThursdays = $c5b0f30bdebda553$var$utcThursday.range;
module.exports.utcThursdays = $c5b0f30bdebda553$var$utcThursdays;
var $c5b0f30bdebda553$var$utcFridays = $c5b0f30bdebda553$var$utcFriday.range;
module.exports.utcFridays = $c5b0f30bdebda553$var$utcFridays;
var $c5b0f30bdebda553$var$utcSaturdays = $c5b0f30bdebda553$var$utcSaturday.range;
module.exports.utcSaturdays = $c5b0f30bdebda553$var$utcSaturdays;

});

parcelRegister("15kWX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $0ca6824cb1dfe8de$var$_interval = $0ca6824cb1dfe8de$var$_interopRequireDefault((parcelRequire("9mYsL")));
function $0ca6824cb1dfe8de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0ca6824cb1dfe8de$var$utcMonth = (0, $0ca6824cb1dfe8de$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $0ca6824cb1dfe8de$var$_default = $0ca6824cb1dfe8de$var$utcMonth;
module.exports.default = $0ca6824cb1dfe8de$var$_default;
var $0ca6824cb1dfe8de$var$utcMonths = $0ca6824cb1dfe8de$var$utcMonth.range;
module.exports.utcMonths = $0ca6824cb1dfe8de$var$utcMonths;

});

parcelRegister("bRXUB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $8a431e3bea1d160c$var$_interval = $8a431e3bea1d160c$var$_interopRequireDefault((parcelRequire("9mYsL")));
function $8a431e3bea1d160c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8a431e3bea1d160c$var$utcYear = (0, $8a431e3bea1d160c$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$8a431e3bea1d160c$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $8a431e3bea1d160c$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $8a431e3bea1d160c$var$_default = $8a431e3bea1d160c$var$utcYear;
module.exports.default = $8a431e3bea1d160c$var$_default;
var $8a431e3bea1d160c$var$utcYears = $8a431e3bea1d160c$var$utcYear.range;
module.exports.utcYears = $8a431e3bea1d160c$var$utcYears;

});

parcelRegister("fi2S9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $dfXar = parcelRequire("dfXar");

var $ffS6a = parcelRequire("ffS6a");

var $b21ac3da0cc713d1$var$_millisecond = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("joIgc")));

var $b21ac3da0cc713d1$var$_second = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("emUZs")));

var $b21ac3da0cc713d1$var$_minute = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("bWQ0C")));

var $b21ac3da0cc713d1$var$_hour = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("la0bP")));

var $b21ac3da0cc713d1$var$_day = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("8Qo8R")));

var $9wwjs = parcelRequire("9wwjs");

var $b21ac3da0cc713d1$var$_month = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("eQlmO")));

var $b21ac3da0cc713d1$var$_year = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("bCw6g")));

var $b21ac3da0cc713d1$var$_utcMinute = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("56CHD")));

var $b21ac3da0cc713d1$var$_utcHour = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("4Id0V")));

var $b21ac3da0cc713d1$var$_utcDay = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("coaP9")));

var $gYiWY = parcelRequire("gYiWY");

var $b21ac3da0cc713d1$var$_utcMonth = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("15kWX")));

var $b21ac3da0cc713d1$var$_utcYear = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("bRXUB")));
function $b21ac3da0cc713d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b21ac3da0cc713d1$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $b21ac3da0cc713d1$var$_second.default,
            1,
            $ffS6a.durationSecond
        ],
        [
            $b21ac3da0cc713d1$var$_second.default,
            5,
            5 * $ffS6a.durationSecond
        ],
        [
            $b21ac3da0cc713d1$var$_second.default,
            15,
            15 * $ffS6a.durationSecond
        ],
        [
            $b21ac3da0cc713d1$var$_second.default,
            30,
            30 * $ffS6a.durationSecond
        ],
        [
            minute,
            1,
            $ffS6a.durationMinute
        ],
        [
            minute,
            5,
            5 * $ffS6a.durationMinute
        ],
        [
            minute,
            15,
            15 * $ffS6a.durationMinute
        ],
        [
            minute,
            30,
            30 * $ffS6a.durationMinute
        ],
        [
            hour,
            1,
            $ffS6a.durationHour
        ],
        [
            hour,
            3,
            3 * $ffS6a.durationHour
        ],
        [
            hour,
            6,
            6 * $ffS6a.durationHour
        ],
        [
            hour,
            12,
            12 * $ffS6a.durationHour
        ],
        [
            day,
            1,
            $ffS6a.durationDay
        ],
        [
            day,
            2,
            2 * $ffS6a.durationDay
        ],
        [
            week,
            1,
            $ffS6a.durationWeek
        ],
        [
            month,
            1,
            $ffS6a.durationMonth
        ],
        [
            month,
            3,
            3 * $ffS6a.durationMonth
        ],
        [
            year,
            1,
            $ffS6a.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $dfXar.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $dfXar.tickStep)(start / $ffS6a.durationYear, stop / $ffS6a.durationYear, count));
        if (i === 0) return $b21ac3da0cc713d1$var$_millisecond.default.every(Math.max((0, $dfXar.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$b21ac3da0cc713d1$var$utcTicks, $b21ac3da0cc713d1$var$utcTickInterval] = $b21ac3da0cc713d1$var$ticker($b21ac3da0cc713d1$var$_utcYear.default, $b21ac3da0cc713d1$var$_utcMonth.default, $gYiWY.utcSunday, $b21ac3da0cc713d1$var$_utcDay.default, $b21ac3da0cc713d1$var$_utcHour.default, $b21ac3da0cc713d1$var$_utcMinute.default);
module.exports.utcTickInterval = $b21ac3da0cc713d1$var$utcTickInterval;
module.exports.utcTicks = $b21ac3da0cc713d1$var$utcTicks;
const [$b21ac3da0cc713d1$var$timeTicks, $b21ac3da0cc713d1$var$timeTickInterval] = $b21ac3da0cc713d1$var$ticker($b21ac3da0cc713d1$var$_year.default, $b21ac3da0cc713d1$var$_month.default, $9wwjs.sunday, $b21ac3da0cc713d1$var$_day.default, $b21ac3da0cc713d1$var$_hour.default, $b21ac3da0cc713d1$var$_minute.default);
module.exports.timeTickInterval = $b21ac3da0cc713d1$var$timeTickInterval;
module.exports.timeTicks = $b21ac3da0cc713d1$var$timeTicks;

});


parcelRegister("allvJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_defaultLocale.utcParse;
    }
});

var $787c8d25ff9222f8$var$_defaultLocale = $787c8d25ff9222f8$var$_interopRequireWildcard((parcelRequire("h4Kh2")));

var $787c8d25ff9222f8$var$_locale = $787c8d25ff9222f8$var$_interopRequireDefault((parcelRequire("4tJEG")));

var $787c8d25ff9222f8$var$_isoFormat = $787c8d25ff9222f8$var$_interopRequireDefault((parcelRequire("im63r")));

var $787c8d25ff9222f8$var$_isoParse = $787c8d25ff9222f8$var$_interopRequireDefault((parcelRequire("1sar7")));
function $787c8d25ff9222f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $787c8d25ff9222f8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($787c8d25ff9222f8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $787c8d25ff9222f8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $787c8d25ff9222f8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("h4Kh2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c6e6b464710df3ee$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $c6e6b464710df3ee$var$_locale = $c6e6b464710df3ee$var$_interopRequireDefault((parcelRequire("4tJEG")));
function $c6e6b464710df3ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c6e6b464710df3ee$var$locale;
var $c6e6b464710df3ee$var$timeFormat;
module.exports.timeFormat = $c6e6b464710df3ee$var$timeFormat;
var $c6e6b464710df3ee$var$timeParse;
module.exports.timeParse = $c6e6b464710df3ee$var$timeParse;
var $c6e6b464710df3ee$var$utcFormat;
module.exports.utcFormat = $c6e6b464710df3ee$var$utcFormat;
var $c6e6b464710df3ee$var$utcParse;
module.exports.utcParse = $c6e6b464710df3ee$var$utcParse;
$c6e6b464710df3ee$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $c6e6b464710df3ee$var$defaultLocale(definition) {
    $c6e6b464710df3ee$var$locale = (0, $c6e6b464710df3ee$var$_locale.default)(definition);
    module.exports.timeFormat = $c6e6b464710df3ee$var$timeFormat = $c6e6b464710df3ee$var$locale.format;
    module.exports.timeParse = $c6e6b464710df3ee$var$timeParse = $c6e6b464710df3ee$var$locale.parse;
    module.exports.utcFormat = $c6e6b464710df3ee$var$utcFormat = $c6e6b464710df3ee$var$locale.utcFormat;
    module.exports.utcParse = $c6e6b464710df3ee$var$utcParse = $c6e6b464710df3ee$var$locale.utcParse;
    return $c6e6b464710df3ee$var$locale;
}

});
parcelRegister("4tJEG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $342d490293d3c52e$var$formatLocale;

var $2iBJo = parcelRequire("2iBJo");
function $342d490293d3c52e$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $342d490293d3c52e$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $342d490293d3c52e$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $342d490293d3c52e$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $342d490293d3c52e$var$formatRe(locale_periods), periodLookup = $342d490293d3c52e$var$formatLookup(locale_periods), weekdayRe = $342d490293d3c52e$var$formatRe(locale_weekdays), weekdayLookup = $342d490293d3c52e$var$formatLookup(locale_weekdays), shortWeekdayRe = $342d490293d3c52e$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $342d490293d3c52e$var$formatLookup(locale_shortWeekdays), monthRe = $342d490293d3c52e$var$formatRe(locale_months), monthLookup = $342d490293d3c52e$var$formatLookup(locale_months), shortMonthRe = $342d490293d3c52e$var$formatRe(locale_shortMonths), shortMonthLookup = $342d490293d3c52e$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $342d490293d3c52e$var$formatDayOfMonth,
        "e": $342d490293d3c52e$var$formatDayOfMonth,
        "f": $342d490293d3c52e$var$formatMicroseconds,
        "g": $342d490293d3c52e$var$formatYearISO,
        "G": $342d490293d3c52e$var$formatFullYearISO,
        "H": $342d490293d3c52e$var$formatHour24,
        "I": $342d490293d3c52e$var$formatHour12,
        "j": $342d490293d3c52e$var$formatDayOfYear,
        "L": $342d490293d3c52e$var$formatMilliseconds,
        "m": $342d490293d3c52e$var$formatMonthNumber,
        "M": $342d490293d3c52e$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $342d490293d3c52e$var$formatUnixTimestamp,
        "s": $342d490293d3c52e$var$formatUnixTimestampSeconds,
        "S": $342d490293d3c52e$var$formatSeconds,
        "u": $342d490293d3c52e$var$formatWeekdayNumberMonday,
        "U": $342d490293d3c52e$var$formatWeekNumberSunday,
        "V": $342d490293d3c52e$var$formatWeekNumberISO,
        "w": $342d490293d3c52e$var$formatWeekdayNumberSunday,
        "W": $342d490293d3c52e$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $342d490293d3c52e$var$formatYear,
        "Y": $342d490293d3c52e$var$formatFullYear,
        "Z": $342d490293d3c52e$var$formatZone,
        "%": $342d490293d3c52e$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $342d490293d3c52e$var$formatUTCDayOfMonth,
        "e": $342d490293d3c52e$var$formatUTCDayOfMonth,
        "f": $342d490293d3c52e$var$formatUTCMicroseconds,
        "g": $342d490293d3c52e$var$formatUTCYearISO,
        "G": $342d490293d3c52e$var$formatUTCFullYearISO,
        "H": $342d490293d3c52e$var$formatUTCHour24,
        "I": $342d490293d3c52e$var$formatUTCHour12,
        "j": $342d490293d3c52e$var$formatUTCDayOfYear,
        "L": $342d490293d3c52e$var$formatUTCMilliseconds,
        "m": $342d490293d3c52e$var$formatUTCMonthNumber,
        "M": $342d490293d3c52e$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $342d490293d3c52e$var$formatUnixTimestamp,
        "s": $342d490293d3c52e$var$formatUnixTimestampSeconds,
        "S": $342d490293d3c52e$var$formatUTCSeconds,
        "u": $342d490293d3c52e$var$formatUTCWeekdayNumberMonday,
        "U": $342d490293d3c52e$var$formatUTCWeekNumberSunday,
        "V": $342d490293d3c52e$var$formatUTCWeekNumberISO,
        "w": $342d490293d3c52e$var$formatUTCWeekdayNumberSunday,
        "W": $342d490293d3c52e$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $342d490293d3c52e$var$formatUTCYear,
        "Y": $342d490293d3c52e$var$formatUTCFullYear,
        "Z": $342d490293d3c52e$var$formatUTCZone,
        "%": $342d490293d3c52e$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $342d490293d3c52e$var$parseDayOfMonth,
        "e": $342d490293d3c52e$var$parseDayOfMonth,
        "f": $342d490293d3c52e$var$parseMicroseconds,
        "g": $342d490293d3c52e$var$parseYear,
        "G": $342d490293d3c52e$var$parseFullYear,
        "H": $342d490293d3c52e$var$parseHour24,
        "I": $342d490293d3c52e$var$parseHour24,
        "j": $342d490293d3c52e$var$parseDayOfYear,
        "L": $342d490293d3c52e$var$parseMilliseconds,
        "m": $342d490293d3c52e$var$parseMonthNumber,
        "M": $342d490293d3c52e$var$parseMinutes,
        "p": parsePeriod,
        "q": $342d490293d3c52e$var$parseQuarter,
        "Q": $342d490293d3c52e$var$parseUnixTimestamp,
        "s": $342d490293d3c52e$var$parseUnixTimestampSeconds,
        "S": $342d490293d3c52e$var$parseSeconds,
        "u": $342d490293d3c52e$var$parseWeekdayNumberMonday,
        "U": $342d490293d3c52e$var$parseWeekNumberSunday,
        "V": $342d490293d3c52e$var$parseWeekNumberISO,
        "w": $342d490293d3c52e$var$parseWeekdayNumberSunday,
        "W": $342d490293d3c52e$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $342d490293d3c52e$var$parseYear,
        "Y": $342d490293d3c52e$var$parseFullYear,
        "Z": $342d490293d3c52e$var$parseZone,
        "%": $342d490293d3c52e$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $342d490293d3c52e$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $342d490293d3c52e$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $342d490293d3c52e$var$utcDate($342d490293d3c52e$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $2iBJo.utcMonday.ceil(week) : (0, $2iBJo.utcMonday)(week);
                    week = $2iBJo.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $342d490293d3c52e$var$localDate($342d490293d3c52e$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $2iBJo.timeMonday.ceil(week) : (0, $2iBJo.timeMonday)(week);
                    week = $2iBJo.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $342d490293d3c52e$var$utcDate($342d490293d3c52e$var$newDate(d.y, 0, 1)).getUTCDay() : $342d490293d3c52e$var$localDate($342d490293d3c52e$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $342d490293d3c52e$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $342d490293d3c52e$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $342d490293d3c52e$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $342d490293d3c52e$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $342d490293d3c52e$var$numberRe = /^\s*\d+/, // note: ignores next directive
$342d490293d3c52e$var$percentRe = /^%/, $342d490293d3c52e$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $342d490293d3c52e$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $342d490293d3c52e$var$requote(s) {
    return s.replace($342d490293d3c52e$var$requoteRe, "\\$&");
}
function $342d490293d3c52e$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($342d490293d3c52e$var$requote).join("|") + ")", "i");
}
function $342d490293d3c52e$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $342d490293d3c52e$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseWeekNumberSunday(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseWeekNumberISO(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseWeekNumberMonday(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseFullYear(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseYear(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseQuarter(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseMonthNumber(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseDayOfMonth(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseDayOfYear(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseHour24(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseMinutes(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseSeconds(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseMilliseconds(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseMicroseconds(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseLiteralPercent(d, string, i) {
    var n = $342d490293d3c52e$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $342d490293d3c52e$var$parseUnixTimestamp(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$formatDayOfMonth(d, p) {
    return $342d490293d3c52e$var$pad(d.getDate(), p, 2);
}
function $342d490293d3c52e$var$formatHour24(d, p) {
    return $342d490293d3c52e$var$pad(d.getHours(), p, 2);
}
function $342d490293d3c52e$var$formatHour12(d, p) {
    return $342d490293d3c52e$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $342d490293d3c52e$var$formatDayOfYear(d, p) {
    return $342d490293d3c52e$var$pad(1 + $2iBJo.timeDay.count((0, $2iBJo.timeYear)(d), d), p, 3);
}
function $342d490293d3c52e$var$formatMilliseconds(d, p) {
    return $342d490293d3c52e$var$pad(d.getMilliseconds(), p, 3);
}
function $342d490293d3c52e$var$formatMicroseconds(d, p) {
    return $342d490293d3c52e$var$formatMilliseconds(d, p) + "000";
}
function $342d490293d3c52e$var$formatMonthNumber(d, p) {
    return $342d490293d3c52e$var$pad(d.getMonth() + 1, p, 2);
}
function $342d490293d3c52e$var$formatMinutes(d, p) {
    return $342d490293d3c52e$var$pad(d.getMinutes(), p, 2);
}
function $342d490293d3c52e$var$formatSeconds(d, p) {
    return $342d490293d3c52e$var$pad(d.getSeconds(), p, 2);
}
function $342d490293d3c52e$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $342d490293d3c52e$var$formatWeekNumberSunday(d, p) {
    return $342d490293d3c52e$var$pad($2iBJo.timeSunday.count((0, $2iBJo.timeYear)(d) - 1, d), p, 2);
}
function $342d490293d3c52e$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $2iBJo.timeThursday)(d) : $2iBJo.timeThursday.ceil(d);
}
function $342d490293d3c52e$var$formatWeekNumberISO(d, p) {
    d = $342d490293d3c52e$var$dISO(d);
    return $342d490293d3c52e$var$pad($2iBJo.timeThursday.count((0, $2iBJo.timeYear)(d), d) + ((0, $2iBJo.timeYear)(d).getDay() === 4), p, 2);
}
function $342d490293d3c52e$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $342d490293d3c52e$var$formatWeekNumberMonday(d, p) {
    return $342d490293d3c52e$var$pad($2iBJo.timeMonday.count((0, $2iBJo.timeYear)(d) - 1, d), p, 2);
}
function $342d490293d3c52e$var$formatYear(d, p) {
    return $342d490293d3c52e$var$pad(d.getFullYear() % 100, p, 2);
}
function $342d490293d3c52e$var$formatYearISO(d, p) {
    d = $342d490293d3c52e$var$dISO(d);
    return $342d490293d3c52e$var$pad(d.getFullYear() % 100, p, 2);
}
function $342d490293d3c52e$var$formatFullYear(d, p) {
    return $342d490293d3c52e$var$pad(d.getFullYear() % 10000, p, 4);
}
function $342d490293d3c52e$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $2iBJo.timeThursday)(d) : $2iBJo.timeThursday.ceil(d);
    return $342d490293d3c52e$var$pad(d.getFullYear() % 10000, p, 4);
}
function $342d490293d3c52e$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $342d490293d3c52e$var$pad(z / 60 | 0, "0", 2) + $342d490293d3c52e$var$pad(z % 60, "0", 2);
}
function $342d490293d3c52e$var$formatUTCDayOfMonth(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCDate(), p, 2);
}
function $342d490293d3c52e$var$formatUTCHour24(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCHours(), p, 2);
}
function $342d490293d3c52e$var$formatUTCHour12(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $342d490293d3c52e$var$formatUTCDayOfYear(d, p) {
    return $342d490293d3c52e$var$pad(1 + $2iBJo.utcDay.count((0, $2iBJo.utcYear)(d), d), p, 3);
}
function $342d490293d3c52e$var$formatUTCMilliseconds(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $342d490293d3c52e$var$formatUTCMicroseconds(d, p) {
    return $342d490293d3c52e$var$formatUTCMilliseconds(d, p) + "000";
}
function $342d490293d3c52e$var$formatUTCMonthNumber(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $342d490293d3c52e$var$formatUTCMinutes(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCMinutes(), p, 2);
}
function $342d490293d3c52e$var$formatUTCSeconds(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCSeconds(), p, 2);
}
function $342d490293d3c52e$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $342d490293d3c52e$var$formatUTCWeekNumberSunday(d, p) {
    return $342d490293d3c52e$var$pad($2iBJo.utcSunday.count((0, $2iBJo.utcYear)(d) - 1, d), p, 2);
}
function $342d490293d3c52e$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $2iBJo.utcThursday)(d) : $2iBJo.utcThursday.ceil(d);
}
function $342d490293d3c52e$var$formatUTCWeekNumberISO(d, p) {
    d = $342d490293d3c52e$var$UTCdISO(d);
    return $342d490293d3c52e$var$pad($2iBJo.utcThursday.count((0, $2iBJo.utcYear)(d), d) + ((0, $2iBJo.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $342d490293d3c52e$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $342d490293d3c52e$var$formatUTCWeekNumberMonday(d, p) {
    return $342d490293d3c52e$var$pad($2iBJo.utcMonday.count((0, $2iBJo.utcYear)(d) - 1, d), p, 2);
}
function $342d490293d3c52e$var$formatUTCYear(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $342d490293d3c52e$var$formatUTCYearISO(d, p) {
    d = $342d490293d3c52e$var$UTCdISO(d);
    return $342d490293d3c52e$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $342d490293d3c52e$var$formatUTCFullYear(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $342d490293d3c52e$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $2iBJo.utcThursday)(d) : $2iBJo.utcThursday.ceil(d);
    return $342d490293d3c52e$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $342d490293d3c52e$var$formatUTCZone() {
    return "+0000";
}
function $342d490293d3c52e$var$formatLiteralPercent() {
    return "%";
}
function $342d490293d3c52e$var$formatUnixTimestamp(d) {
    return +d;
}
function $342d490293d3c52e$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("im63r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $h4Kh2 = parcelRequire("h4Kh2");
var $d5cefa6251d20328$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $d5cefa6251d20328$var$isoSpecifier;
function $d5cefa6251d20328$var$formatIsoNative(date) {
    return date.toISOString();
}
var $d5cefa6251d20328$var$formatIso = Date.prototype.toISOString ? $d5cefa6251d20328$var$formatIsoNative : (0, $h4Kh2.utcFormat)($d5cefa6251d20328$var$isoSpecifier);
var $d5cefa6251d20328$var$_default = $d5cefa6251d20328$var$formatIso;
module.exports.default = $d5cefa6251d20328$var$_default;

});

parcelRegister("1sar7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $im63r = parcelRequire("im63r");

var $h4Kh2 = parcelRequire("h4Kh2");
function $10f080706394d1f7$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $10f080706394d1f7$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $10f080706394d1f7$var$parseIsoNative : (0, $h4Kh2.utcParse)($im63r.isoSpecifier);
var $10f080706394d1f7$var$_default = $10f080706394d1f7$var$parseIso;
module.exports.default = $10f080706394d1f7$var$_default;

});



parcelRegister("k0gY2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e900f8151d80ea00$var$utcTime;

var $2iBJo = parcelRequire("2iBJo");

var $allvJ = parcelRequire("allvJ");

var $3lv9c = parcelRequire("3lv9c");

var $ezRKk = parcelRequire("ezRKk");
function $e900f8151d80ea00$var$utcTime() {
    return $ezRKk.initRange.apply((0, $3lv9c.calendar)($2iBJo.utcTicks, $2iBJo.utcTickInterval, $2iBJo.utcYear, $2iBJo.utcMonth, $2iBJo.utcWeek, $2iBJo.utcDay, $2iBJo.utcHour, $2iBJo.utcMinute, $2iBJo.utcSecond, $allvJ.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("bo5gu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $84a6051f316b5ae4$var$copy;
module.exports.default = $84a6051f316b5ae4$var$sequential;
module.exports.sequentialLog = $84a6051f316b5ae4$var$sequentialLog;
module.exports.sequentialPow = $84a6051f316b5ae4$var$sequentialPow;
module.exports.sequentialSqrt = $84a6051f316b5ae4$var$sequentialSqrt;
module.exports.sequentialSymlog = $84a6051f316b5ae4$var$sequentialSymlog;

var $84oZu = parcelRequire("84oZu");

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");

var $8cBoe = parcelRequire("8cBoe");

var $cw7m0 = parcelRequire("cw7m0");

var $3DXgb = parcelRequire("3DXgb");

var $6kjWv = parcelRequire("6kjWv");
function $84a6051f316b5ae4$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $kcPbm.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($84oZu.interpolate);
    scale.rangeRound = range($84oZu.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $84a6051f316b5ae4$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $84a6051f316b5ae4$var$sequential() {
    var scale = (0, $8cBoe.linearish)($84a6051f316b5ae4$var$transformer()($kcPbm.identity));
    scale.copy = function() {
        return $84a6051f316b5ae4$var$copy(scale, $84a6051f316b5ae4$var$sequential());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $84a6051f316b5ae4$var$sequentialLog() {
    var scale = (0, $cw7m0.loggish)($84a6051f316b5ae4$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $84a6051f316b5ae4$var$copy(scale, $84a6051f316b5ae4$var$sequentialLog()).base(scale.base());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $84a6051f316b5ae4$var$sequentialSymlog() {
    var scale = (0, $3DXgb.symlogish)($84a6051f316b5ae4$var$transformer());
    scale.copy = function() {
        return $84a6051f316b5ae4$var$copy(scale, $84a6051f316b5ae4$var$sequentialSymlog()).constant(scale.constant());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $84a6051f316b5ae4$var$sequentialPow() {
    var scale = (0, $6kjWv.powish)($84a6051f316b5ae4$var$transformer());
    scale.copy = function() {
        return $84a6051f316b5ae4$var$copy(scale, $84a6051f316b5ae4$var$sequentialPow()).exponent(scale.exponent());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $84a6051f316b5ae4$var$sequentialSqrt() {
    return $84a6051f316b5ae4$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("5yyjd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $40babdc73d4c4272$var$sequentialQuantile;

var $dfXar = parcelRequire("dfXar");

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");
function $40babdc73d4c4272$var$sequentialQuantile() {
    var domain = [], interpolator = $kcPbm.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $dfXar.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($dfXar.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $dfXar.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $40babdc73d4c4272$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("8db3Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5fa81e918fa865b9$var$diverging;
module.exports.divergingLog = $5fa81e918fa865b9$var$divergingLog;
module.exports.divergingPow = $5fa81e918fa865b9$var$divergingPow;
module.exports.divergingSqrt = $5fa81e918fa865b9$var$divergingSqrt;
module.exports.divergingSymlog = $5fa81e918fa865b9$var$divergingSymlog;

var $84oZu = parcelRequire("84oZu");

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");

var $8cBoe = parcelRequire("8cBoe");

var $cw7m0 = parcelRequire("cw7m0");

var $bo5gu = parcelRequire("bo5gu");

var $3DXgb = parcelRequire("3DXgb");

var $6kjWv = parcelRequire("6kjWv");
function $5fa81e918fa865b9$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $kcPbm.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $84oZu.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($84oZu.interpolate);
    scale.rangeRound = range($84oZu.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $5fa81e918fa865b9$var$diverging() {
    var scale = (0, $8cBoe.linearish)($5fa81e918fa865b9$var$transformer()($kcPbm.identity));
    scale.copy = function() {
        return (0, $bo5gu.copy)(scale, $5fa81e918fa865b9$var$diverging());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $5fa81e918fa865b9$var$divergingLog() {
    var scale = (0, $cw7m0.loggish)($5fa81e918fa865b9$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $bo5gu.copy)(scale, $5fa81e918fa865b9$var$divergingLog()).base(scale.base());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $5fa81e918fa865b9$var$divergingSymlog() {
    var scale = (0, $3DXgb.symlogish)($5fa81e918fa865b9$var$transformer());
    scale.copy = function() {
        return (0, $bo5gu.copy)(scale, $5fa81e918fa865b9$var$divergingSymlog()).constant(scale.constant());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $5fa81e918fa865b9$var$divergingPow() {
    var scale = (0, $6kjWv.powish)($5fa81e918fa865b9$var$transformer());
    scale.copy = function() {
        return (0, $bo5gu.copy)(scale, $5fa81e918fa865b9$var$divergingPow()).exponent(scale.exponent());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $5fa81e918fa865b9$var$divergingSqrt() {
    return $5fa81e918fa865b9$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("jR8B9", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("c7qvc"));

});
parcelRegister("c7qvc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $7pWof.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $7pWof.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $eg4Yo.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $eg4Yo.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $1a7us.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $1a7us.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $1a7us.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $1a7us.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_symbol.symbolsStroke;
    }
});

var $8d2ab249534730b9$var$_arc = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("hb8pW")));

var $8d2ab249534730b9$var$_area = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("2mXKD")));

var $8d2ab249534730b9$var$_line = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("aPa75")));

var $8d2ab249534730b9$var$_pie = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("fMagQ")));

var $8d2ab249534730b9$var$_areaRadial = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("62Jmo")));

var $8d2ab249534730b9$var$_lineRadial = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("gWd5A")));

var $8d2ab249534730b9$var$_pointRadial = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("i3JLJ")));

var $1a7us = parcelRequire("1a7us");

var $8d2ab249534730b9$var$_symbol = $8d2ab249534730b9$var$_interopRequireWildcard((parcelRequire("erM6A")));

var $8d2ab249534730b9$var$_asterisk = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("kGig7")));

var $8d2ab249534730b9$var$_circle = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("aoOCn")));

var $8d2ab249534730b9$var$_cross = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("inanL")));

var $8d2ab249534730b9$var$_diamond = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("brlrK")));

var $8d2ab249534730b9$var$_diamond2 = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("uApSn")));

var $8d2ab249534730b9$var$_plus = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("lqFon")));

var $8d2ab249534730b9$var$_square = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("lgQfD")));

var $8d2ab249534730b9$var$_square2 = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("hazlA")));

var $8d2ab249534730b9$var$_star = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("5Q2TJ")));

var $8d2ab249534730b9$var$_triangle = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("5KhNy")));

var $8d2ab249534730b9$var$_triangle2 = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("1SPqJ")));

var $8d2ab249534730b9$var$_wye = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("2Qn8y")));

var $8d2ab249534730b9$var$_x = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("lbWiU")));

var $8d2ab249534730b9$var$_basisClosed = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("3Rs2W")));

var $8d2ab249534730b9$var$_basisOpen = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("6nSQ2")));

var $8d2ab249534730b9$var$_basis = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("5Qhl2")));

var $7pWof = parcelRequire("7pWof");

var $8d2ab249534730b9$var$_bundle = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("3Z7fr")));

var $8d2ab249534730b9$var$_cardinalClosed = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("2as13")));

var $8d2ab249534730b9$var$_cardinalOpen = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("jxpZF")));

var $8d2ab249534730b9$var$_cardinal = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("8eKmz")));

var $8d2ab249534730b9$var$_catmullRomClosed = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("jbHfS")));

var $8d2ab249534730b9$var$_catmullRomOpen = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("keMhD")));

var $8d2ab249534730b9$var$_catmullRom = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("lCdlx")));

var $8d2ab249534730b9$var$_linearClosed = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("aQUVY")));

var $8d2ab249534730b9$var$_linear = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("d5sso")));

var $eg4Yo = parcelRequire("eg4Yo");

var $8d2ab249534730b9$var$_natural = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("er2IE")));

var $8d2ab249534730b9$var$_step = $8d2ab249534730b9$var$_interopRequireWildcard((parcelRequire("dvzIZ")));

var $8d2ab249534730b9$var$_stack = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("31wXu")));

var $8d2ab249534730b9$var$_expand = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("jmoE1")));

var $8d2ab249534730b9$var$_diverging = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("f0DEq")));

var $8d2ab249534730b9$var$_none = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("3ECyH")));

var $8d2ab249534730b9$var$_silhouette = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("9owud")));

var $8d2ab249534730b9$var$_wiggle = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("kJmkn")));

var $8d2ab249534730b9$var$_appearance = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("cMxJq")));

var $8d2ab249534730b9$var$_ascending = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("7OIkp")));

var $8d2ab249534730b9$var$_descending = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("bl2N4")));

var $8d2ab249534730b9$var$_insideOut = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("ino5x")));

var $8d2ab249534730b9$var$_none2 = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("3MXBI")));

var $8d2ab249534730b9$var$_reverse = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("nTFR3")));
function $8d2ab249534730b9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8d2ab249534730b9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8d2ab249534730b9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8d2ab249534730b9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8d2ab249534730b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("hb8pW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c819fe4b3989a3f7$var$_default;

var $e1EIs = parcelRequire("e1EIs");

var $c819fe4b3989a3f7$var$_constant = $c819fe4b3989a3f7$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $6SVxd = parcelRequire("6SVxd");
function $c819fe4b3989a3f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c819fe4b3989a3f7$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $c819fe4b3989a3f7$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $c819fe4b3989a3f7$var$arcStartAngle(d) {
    return d.startAngle;
}
function $c819fe4b3989a3f7$var$arcEndAngle(d) {
    return d.endAngle;
}
function $c819fe4b3989a3f7$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $c819fe4b3989a3f7$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $6SVxd.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $c819fe4b3989a3f7$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $6SVxd.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $6SVxd.sqrt)((0, $6SVxd.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $c819fe4b3989a3f7$var$_default() {
    var innerRadius = $c819fe4b3989a3f7$var$arcInnerRadius, outerRadius = $c819fe4b3989a3f7$var$arcOuterRadius, cornerRadius = (0, $c819fe4b3989a3f7$var$_constant.default)(0), padRadius = null, startAngle = $c819fe4b3989a3f7$var$arcStartAngle, endAngle = $c819fe4b3989a3f7$var$arcEndAngle, padAngle = $c819fe4b3989a3f7$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $6SVxd.halfPi, a1 = endAngle.apply(this, arguments) - $6SVxd.halfPi, da = (0, $6SVxd.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $e1EIs.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $6SVxd.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $6SVxd.tau - $6SVxd.epsilon) {
            context.moveTo(r1 * (0, $6SVxd.cos)(a0), r1 * (0, $6SVxd.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $6SVxd.epsilon) {
                context.moveTo(r0 * (0, $6SVxd.cos)(a1), r0 * (0, $6SVxd.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $6SVxd.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $6SVxd.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $6SVxd.min)((0, $6SVxd.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $6SVxd.epsilon) {
                var p0 = (0, $6SVxd.asin)(rp / r0 * (0, $6SVxd.sin)(ap)), p1 = (0, $6SVxd.asin)(rp / r1 * (0, $6SVxd.sin)(ap));
                if ((da0 -= p0 * 2) > $6SVxd.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $6SVxd.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $6SVxd.cos)(a01), y01 = r1 * (0, $6SVxd.sin)(a01), x10 = r0 * (0, $6SVxd.cos)(a10), y10 = r0 * (0, $6SVxd.sin)(a10); // Apply rounded corners?
            if (rc > $6SVxd.epsilon) {
                var x11 = r1 * (0, $6SVxd.cos)(a11), y11 = r1 * (0, $6SVxd.sin)(a11), x00 = r0 * (0, $6SVxd.cos)(a00), y00 = r0 * (0, $6SVxd.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $6SVxd.pi && (oc = $c819fe4b3989a3f7$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $6SVxd.sin)((0, $6SVxd.acos)((ax * bx + ay * by) / ((0, $6SVxd.sqrt)(ax * ax + ay * ay) * (0, $6SVxd.sqrt)(bx * bx + by * by))) / 2), lc = (0, $6SVxd.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $6SVxd.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $6SVxd.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $6SVxd.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $6SVxd.epsilon) {
                t0 = $c819fe4b3989a3f7$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $c819fe4b3989a3f7$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $6SVxd.atan2)(t0.y01, t0.x01), (0, $6SVxd.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $6SVxd.atan2)(t0.y01, t0.x01), (0, $6SVxd.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $6SVxd.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $6SVxd.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $6SVxd.atan2)(t1.y11, t1.x11), (0, $6SVxd.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $6SVxd.epsilon) || !(da0 > $6SVxd.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $6SVxd.epsilon) {
                t0 = $c819fe4b3989a3f7$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $c819fe4b3989a3f7$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $6SVxd.atan2)(t0.y01, t0.x01), (0, $6SVxd.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $6SVxd.atan2)(t0.y01, t0.x01), (0, $6SVxd.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $6SVxd.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $6SVxd.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $6SVxd.atan2)(t1.y11, t1.x11), (0, $6SVxd.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $6SVxd.pi / 2;
        return [
            (0, $6SVxd.cos)(a) * r,
            (0, $6SVxd.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("e1EIs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $a360be0c9ee1c708$var$_path.default;
    }
});

var $a360be0c9ee1c708$var$_path = $a360be0c9ee1c708$var$_interopRequireDefault((parcelRequire("a0aX6")));
function $a360be0c9ee1c708$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("a0aX6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $7482665b9d11f335$var$pi = Math.PI, $7482665b9d11f335$var$tau = 2 * $7482665b9d11f335$var$pi, $7482665b9d11f335$var$epsilon = 1e-6, $7482665b9d11f335$var$tauEpsilon = $7482665b9d11f335$var$tau - $7482665b9d11f335$var$epsilon;
function $7482665b9d11f335$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $7482665b9d11f335$var$path() {
    return new $7482665b9d11f335$var$Path();
}
$7482665b9d11f335$var$Path.prototype = $7482665b9d11f335$var$path.prototype = {
    constructor: $7482665b9d11f335$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $7482665b9d11f335$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $7482665b9d11f335$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($7482665b9d11f335$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $7482665b9d11f335$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $7482665b9d11f335$var$epsilon || Math.abs(this._y1 - y0) > $7482665b9d11f335$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $7482665b9d11f335$var$tau + $7482665b9d11f335$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $7482665b9d11f335$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $7482665b9d11f335$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $7482665b9d11f335$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $7482665b9d11f335$var$_default = $7482665b9d11f335$var$path;
module.exports.default = $7482665b9d11f335$var$_default;

});


parcelRegister("aMcNX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7d8851d01781858f$var$_default;
function $7d8851d01781858f$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("6SVxd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $50346a708aec5d4c$var$acos;
module.exports.asin = $50346a708aec5d4c$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $50346a708aec5d4c$var$abs = Math.abs;
module.exports.abs = $50346a708aec5d4c$var$abs;
const $50346a708aec5d4c$var$atan2 = Math.atan2;
module.exports.atan2 = $50346a708aec5d4c$var$atan2;
const $50346a708aec5d4c$var$cos = Math.cos;
module.exports.cos = $50346a708aec5d4c$var$cos;
const $50346a708aec5d4c$var$max = Math.max;
module.exports.max = $50346a708aec5d4c$var$max;
const $50346a708aec5d4c$var$min = Math.min;
module.exports.min = $50346a708aec5d4c$var$min;
const $50346a708aec5d4c$var$sin = Math.sin;
module.exports.sin = $50346a708aec5d4c$var$sin;
const $50346a708aec5d4c$var$sqrt = Math.sqrt;
module.exports.sqrt = $50346a708aec5d4c$var$sqrt;
const $50346a708aec5d4c$var$epsilon = 1e-12;
module.exports.epsilon = $50346a708aec5d4c$var$epsilon;
const $50346a708aec5d4c$var$pi = Math.PI;
module.exports.pi = $50346a708aec5d4c$var$pi;
const $50346a708aec5d4c$var$halfPi = $50346a708aec5d4c$var$pi / 2;
module.exports.halfPi = $50346a708aec5d4c$var$halfPi;
const $50346a708aec5d4c$var$tau = 2 * $50346a708aec5d4c$var$pi;
module.exports.tau = $50346a708aec5d4c$var$tau;
function $50346a708aec5d4c$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $50346a708aec5d4c$var$pi : Math.acos(x);
}
function $50346a708aec5d4c$var$asin(x) {
    return x >= 1 ? $50346a708aec5d4c$var$halfPi : x <= -1 ? -$50346a708aec5d4c$var$halfPi : Math.asin(x);
}

});


parcelRegister("2mXKD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b9bfc3223355168$var$_default;

var $e1EIs = parcelRequire("e1EIs");

var $1b9bfc3223355168$var$_array = $1b9bfc3223355168$var$_interopRequireDefault((parcelRequire("6svIw")));

var $1b9bfc3223355168$var$_constant = $1b9bfc3223355168$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $1b9bfc3223355168$var$_linear = $1b9bfc3223355168$var$_interopRequireDefault((parcelRequire("d5sso")));

var $1b9bfc3223355168$var$_line = $1b9bfc3223355168$var$_interopRequireDefault((parcelRequire("aPa75")));

var $j6qtD = parcelRequire("j6qtD");
function $1b9bfc3223355168$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1b9bfc3223355168$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $1b9bfc3223355168$var$_constant.default)(true), context = null, curve = $1b9bfc3223355168$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $j6qtD.x : (0, $1b9bfc3223355168$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $1b9bfc3223355168$var$_constant.default)(0) : (0, $1b9bfc3223355168$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $j6qtD.y : (0, $1b9bfc3223355168$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $1b9bfc3223355168$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $e1EIs.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $1b9bfc3223355168$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("6svIw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b3df5f65b06abb7$var$_default;
module.exports.slice = void 0;
var $4b3df5f65b06abb7$var$slice = Array.prototype.slice;
module.exports.slice = $4b3df5f65b06abb7$var$slice;
function $4b3df5f65b06abb7$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("d5sso", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9871d0eed2325e7c$var$_default;
function $9871d0eed2325e7c$var$Linear(context) {
    this._context = context;
}
$9871d0eed2325e7c$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $9871d0eed2325e7c$var$_default(context) {
    return new $9871d0eed2325e7c$var$Linear(context);
}

});

parcelRegister("aPa75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e16831311f98076$var$_default;

var $e1EIs = parcelRequire("e1EIs");

var $7e16831311f98076$var$_array = $7e16831311f98076$var$_interopRequireDefault((parcelRequire("6svIw")));

var $7e16831311f98076$var$_constant = $7e16831311f98076$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $7e16831311f98076$var$_linear = $7e16831311f98076$var$_interopRequireDefault((parcelRequire("d5sso")));

var $j6qtD = parcelRequire("j6qtD");
function $7e16831311f98076$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e16831311f98076$var$_default(x, y) {
    var defined = (0, $7e16831311f98076$var$_constant.default)(true), context = null, curve = $7e16831311f98076$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $j6qtD.x : (0, $7e16831311f98076$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $j6qtD.y : (0, $7e16831311f98076$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $7e16831311f98076$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $e1EIs.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $7e16831311f98076$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $7e16831311f98076$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $7e16831311f98076$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("j6qtD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $de831da31114a4ea$var$x;
module.exports.y = $de831da31114a4ea$var$y;
function $de831da31114a4ea$var$x(p) {
    return p[0];
}
function $de831da31114a4ea$var$y(p) {
    return p[1];
}

});



parcelRegister("fMagQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7c34e4493eeeabc$var$_default;

var $b7c34e4493eeeabc$var$_array = $b7c34e4493eeeabc$var$_interopRequireDefault((parcelRequire("6svIw")));

var $b7c34e4493eeeabc$var$_constant = $b7c34e4493eeeabc$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $b7c34e4493eeeabc$var$_descending = $b7c34e4493eeeabc$var$_interopRequireDefault((parcelRequire("9PbYZ")));

var $b7c34e4493eeeabc$var$_identity = $b7c34e4493eeeabc$var$_interopRequireDefault((parcelRequire("6DLHe")));

var $6SVxd = parcelRequire("6SVxd");
function $b7c34e4493eeeabc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b7c34e4493eeeabc$var$_default() {
    var value = $b7c34e4493eeeabc$var$_identity.default, sortValues = $b7c34e4493eeeabc$var$_descending.default, sort = null, startAngle = (0, $b7c34e4493eeeabc$var$_constant.default)(0), endAngle = (0, $b7c34e4493eeeabc$var$_constant.default)($6SVxd.tau), padAngle = (0, $b7c34e4493eeeabc$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $b7c34e4493eeeabc$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($6SVxd.tau, Math.max(-$6SVxd.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $b7c34e4493eeeabc$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $b7c34e4493eeeabc$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $b7c34e4493eeeabc$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $b7c34e4493eeeabc$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("9PbYZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72722bfa77121463$var$_default;
function $72722bfa77121463$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("6DLHe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d5b620f12ffdaf0$var$_default;
function $4d5b620f12ffdaf0$var$_default(d) {
    return d;
}

});


parcelRegister("62Jmo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $46661d933a646095$var$_default;

var $46661d933a646095$var$_radial = $46661d933a646095$var$_interopRequireWildcard((parcelRequire("cxTQC")));

var $46661d933a646095$var$_area = $46661d933a646095$var$_interopRequireDefault((parcelRequire("2mXKD")));

var $gWd5A = parcelRequire("gWd5A");
function $46661d933a646095$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $46661d933a646095$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($46661d933a646095$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $46661d933a646095$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $46661d933a646095$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $46661d933a646095$var$_default() {
    var a = (0, $46661d933a646095$var$_area.default)().curve($46661d933a646095$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $gWd5A.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $gWd5A.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $gWd5A.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $gWd5A.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $46661d933a646095$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("cxTQC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $9223e34472d5d74a$var$curveRadial;

var $9223e34472d5d74a$var$_linear = $9223e34472d5d74a$var$_interopRequireDefault((parcelRequire("d5sso")));
function $9223e34472d5d74a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9223e34472d5d74a$var$curveRadialLinear = $9223e34472d5d74a$var$curveRadial($9223e34472d5d74a$var$_linear.default);
module.exports.curveRadialLinear = $9223e34472d5d74a$var$curveRadialLinear;
function $9223e34472d5d74a$var$Radial(curve) {
    this._curve = curve;
}
$9223e34472d5d74a$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $9223e34472d5d74a$var$curveRadial(curve) {
    function radial(context) {
        return new $9223e34472d5d74a$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("gWd5A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c54c375a12146d14$var$_default;
module.exports.lineRadial = $c54c375a12146d14$var$lineRadial;

var $c54c375a12146d14$var$_radial = $c54c375a12146d14$var$_interopRequireWildcard((parcelRequire("cxTQC")));

var $c54c375a12146d14$var$_line = $c54c375a12146d14$var$_interopRequireDefault((parcelRequire("aPa75")));
function $c54c375a12146d14$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c54c375a12146d14$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c54c375a12146d14$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c54c375a12146d14$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c54c375a12146d14$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c54c375a12146d14$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $c54c375a12146d14$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $c54c375a12146d14$var$_default() {
    return $c54c375a12146d14$var$lineRadial((0, $c54c375a12146d14$var$_line.default)().curve($c54c375a12146d14$var$_radial.curveRadialLinear));
}

});


parcelRegister("i3JLJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d25c02916fab152d$var$_default;
function $d25c02916fab152d$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("1a7us", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $0d8c8904acfd0d6a$var$link;
module.exports.linkHorizontal = $0d8c8904acfd0d6a$var$linkHorizontal;
module.exports.linkRadial = $0d8c8904acfd0d6a$var$linkRadial;
module.exports.linkVertical = $0d8c8904acfd0d6a$var$linkVertical;

var $e1EIs = parcelRequire("e1EIs");

var $6svIw = parcelRequire("6svIw");

var $0d8c8904acfd0d6a$var$_constant = $0d8c8904acfd0d6a$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $7pWof = parcelRequire("7pWof");

var $j6qtD = parcelRequire("j6qtD");
function $0d8c8904acfd0d6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0d8c8904acfd0d6a$var$linkSource(d) {
    return d.source;
}
function $0d8c8904acfd0d6a$var$linkTarget(d) {
    return d.target;
}
function $0d8c8904acfd0d6a$var$link(curve) {
    let source = $0d8c8904acfd0d6a$var$linkSource;
    let target = $0d8c8904acfd0d6a$var$linkTarget;
    let x = $j6qtD.x;
    let y = $j6qtD.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $6svIw.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $e1EIs.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $0d8c8904acfd0d6a$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $0d8c8904acfd0d6a$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $0d8c8904acfd0d6a$var$linkHorizontal() {
    return $0d8c8904acfd0d6a$var$link($7pWof.bumpX);
}
function $0d8c8904acfd0d6a$var$linkVertical() {
    return $0d8c8904acfd0d6a$var$link($7pWof.bumpY);
}
function $0d8c8904acfd0d6a$var$linkRadial() {
    const l = $0d8c8904acfd0d6a$var$link($7pWof.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("7pWof", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $5668293e7000ce9d$var$bumpRadial;
module.exports.bumpX = $5668293e7000ce9d$var$bumpX;
module.exports.bumpY = $5668293e7000ce9d$var$bumpY;

var $5668293e7000ce9d$var$_pointRadial = $5668293e7000ce9d$var$_interopRequireDefault((parcelRequire("i3JLJ")));
function $5668293e7000ce9d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $5668293e7000ce9d$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $5668293e7000ce9d$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $5668293e7000ce9d$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $5668293e7000ce9d$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $5668293e7000ce9d$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $5668293e7000ce9d$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $5668293e7000ce9d$var$bumpX(context) {
    return new $5668293e7000ce9d$var$Bump(context, true);
}
function $5668293e7000ce9d$var$bumpY(context) {
    return new $5668293e7000ce9d$var$Bump(context, false);
}
function $5668293e7000ce9d$var$bumpRadial(context) {
    return new $5668293e7000ce9d$var$BumpRadial(context);
}

});


parcelRegister("erM6A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a848e700ac23b717$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $e1EIs = parcelRequire("e1EIs");

var $a848e700ac23b717$var$_constant = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $a848e700ac23b717$var$_asterisk = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("kGig7")));

var $a848e700ac23b717$var$_circle = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("aoOCn")));

var $a848e700ac23b717$var$_cross = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("inanL")));

var $a848e700ac23b717$var$_diamond = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("brlrK")));

var $a848e700ac23b717$var$_diamond2 = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("uApSn")));

var $a848e700ac23b717$var$_plus = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("lqFon")));

var $a848e700ac23b717$var$_square = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("lgQfD")));

var $a848e700ac23b717$var$_square2 = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("hazlA")));

var $a848e700ac23b717$var$_star = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("5Q2TJ")));

var $a848e700ac23b717$var$_triangle = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("5KhNy")));

var $a848e700ac23b717$var$_triangle2 = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("1SPqJ")));

var $a848e700ac23b717$var$_wye = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("2Qn8y")));

var $a848e700ac23b717$var$_x = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("lbWiU")));
function $a848e700ac23b717$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $a848e700ac23b717$var$symbolsFill = [
    $a848e700ac23b717$var$_circle.default,
    $a848e700ac23b717$var$_cross.default,
    $a848e700ac23b717$var$_diamond.default,
    $a848e700ac23b717$var$_square.default,
    $a848e700ac23b717$var$_star.default,
    $a848e700ac23b717$var$_triangle.default,
    $a848e700ac23b717$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $a848e700ac23b717$var$symbolsFill;
const $a848e700ac23b717$var$symbolsStroke = [
    $a848e700ac23b717$var$_circle.default,
    $a848e700ac23b717$var$_plus.default,
    $a848e700ac23b717$var$_x.default,
    $a848e700ac23b717$var$_triangle2.default,
    $a848e700ac23b717$var$_asterisk.default,
    $a848e700ac23b717$var$_square2.default,
    $a848e700ac23b717$var$_diamond2.default
];
module.exports.symbolsStroke = $a848e700ac23b717$var$symbolsStroke;
function $a848e700ac23b717$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $a848e700ac23b717$var$_constant.default)(type || $a848e700ac23b717$var$_circle.default);
    size = typeof size === "function" ? size : (0, $a848e700ac23b717$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $e1EIs.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $a848e700ac23b717$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $a848e700ac23b717$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("kGig7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $f0e5e4b9cf05227e$var$sqrt3 = (0, $6SVxd.sqrt)(3);
var $f0e5e4b9cf05227e$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size + (0, $6SVxd.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $f0e5e4b9cf05227e$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $f0e5e4b9cf05227e$var$_default;

});

parcelRegister("aoOCn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $792368f3690fafa3$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size / $6SVxd.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $6SVxd.tau);
    }
};
module.exports.default = $792368f3690fafa3$var$_default;

});

parcelRegister("inanL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $d6026db0f1f69073$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $d6026db0f1f69073$var$_default;

});

parcelRegister("brlrK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $8542da2adf472f40$var$tan30 = (0, $6SVxd.sqrt)(1 / 3);
const $8542da2adf472f40$var$tan30_2 = $8542da2adf472f40$var$tan30 * 2;
var $8542da2adf472f40$var$_default = {
    draw (context, size) {
        const y = (0, $6SVxd.sqrt)(size / $8542da2adf472f40$var$tan30_2);
        const x = y * $8542da2adf472f40$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $8542da2adf472f40$var$_default;

});

parcelRegister("uApSn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $05bf0cfc8875f816$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $05bf0cfc8875f816$var$_default;

});

parcelRegister("lqFon", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $f99c224eb9831c89$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size - (0, $6SVxd.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $f99c224eb9831c89$var$_default;

});

parcelRegister("lgQfD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $f7c39f9aaff8637d$var$_default = {
    draw (context, size) {
        const w = (0, $6SVxd.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $f7c39f9aaff8637d$var$_default;

});

parcelRegister("hazlA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $c7feca11638fe8ed$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $c7feca11638fe8ed$var$_default;

});

parcelRegister("5Q2TJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $44040e8b5fb88313$var$ka = 0.89081309152928522810;
const $44040e8b5fb88313$var$kr = (0, $6SVxd.sin)($6SVxd.pi / 10) / (0, $6SVxd.sin)(7 * $6SVxd.pi / 10);
const $44040e8b5fb88313$var$kx = (0, $6SVxd.sin)($6SVxd.tau / 10) * $44040e8b5fb88313$var$kr;
const $44040e8b5fb88313$var$ky = -(0, $6SVxd.cos)($6SVxd.tau / 10) * $44040e8b5fb88313$var$kr;
var $44040e8b5fb88313$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size * $44040e8b5fb88313$var$ka);
        const x = $44040e8b5fb88313$var$kx * r;
        const y = $44040e8b5fb88313$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $6SVxd.tau * i / 5;
            const c = (0, $6SVxd.cos)(a);
            const s = (0, $6SVxd.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $44040e8b5fb88313$var$_default;

});

parcelRegister("5KhNy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $42ef0dff45ed70d1$var$sqrt3 = (0, $6SVxd.sqrt)(3);
var $42ef0dff45ed70d1$var$_default = {
    draw (context, size) {
        const y = -(0, $6SVxd.sqrt)(size / ($42ef0dff45ed70d1$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$42ef0dff45ed70d1$var$sqrt3 * y, -y);
        context.lineTo($42ef0dff45ed70d1$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $42ef0dff45ed70d1$var$_default;

});

parcelRegister("1SPqJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $15f2ba8f76592b22$var$sqrt3 = (0, $6SVxd.sqrt)(3);
var $15f2ba8f76592b22$var$_default = {
    draw (context, size) {
        const s = (0, $6SVxd.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $15f2ba8f76592b22$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $15f2ba8f76592b22$var$_default;

});

parcelRegister("2Qn8y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $212262a3cf40a3de$var$c = -0.5;
const $212262a3cf40a3de$var$s = (0, $6SVxd.sqrt)(3) / 2;
const $212262a3cf40a3de$var$k = 1 / (0, $6SVxd.sqrt)(12);
const $212262a3cf40a3de$var$a = ($212262a3cf40a3de$var$k / 2 + 1) * 3;
var $212262a3cf40a3de$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size / $212262a3cf40a3de$var$a);
        const x0 = r / 2, y0 = r * $212262a3cf40a3de$var$k;
        const x1 = x0, y1 = r * $212262a3cf40a3de$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($212262a3cf40a3de$var$c * x0 - $212262a3cf40a3de$var$s * y0, $212262a3cf40a3de$var$s * x0 + $212262a3cf40a3de$var$c * y0);
        context.lineTo($212262a3cf40a3de$var$c * x1 - $212262a3cf40a3de$var$s * y1, $212262a3cf40a3de$var$s * x1 + $212262a3cf40a3de$var$c * y1);
        context.lineTo($212262a3cf40a3de$var$c * x2 - $212262a3cf40a3de$var$s * y2, $212262a3cf40a3de$var$s * x2 + $212262a3cf40a3de$var$c * y2);
        context.lineTo($212262a3cf40a3de$var$c * x0 + $212262a3cf40a3de$var$s * y0, $212262a3cf40a3de$var$c * y0 - $212262a3cf40a3de$var$s * x0);
        context.lineTo($212262a3cf40a3de$var$c * x1 + $212262a3cf40a3de$var$s * y1, $212262a3cf40a3de$var$c * y1 - $212262a3cf40a3de$var$s * x1);
        context.lineTo($212262a3cf40a3de$var$c * x2 + $212262a3cf40a3de$var$s * y2, $212262a3cf40a3de$var$c * y2 - $212262a3cf40a3de$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $212262a3cf40a3de$var$_default;

});

parcelRegister("lbWiU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $f6d7da02fb1195bd$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size - (0, $6SVxd.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $f6d7da02fb1195bd$var$_default;

});


parcelRegister("3Rs2W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2cfc13c3e6f008f4$var$_default;

var $2cfc13c3e6f008f4$var$_noop = $2cfc13c3e6f008f4$var$_interopRequireDefault((parcelRequire("DwreA")));

var $5Qhl2 = parcelRequire("5Qhl2");
function $2cfc13c3e6f008f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2cfc13c3e6f008f4$var$BasisClosed(context) {
    this._context = context;
}
$2cfc13c3e6f008f4$var$BasisClosed.prototype = {
    areaStart: $2cfc13c3e6f008f4$var$_noop.default,
    areaEnd: $2cfc13c3e6f008f4$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $5Qhl2.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $2cfc13c3e6f008f4$var$_default(context) {
    return new $2cfc13c3e6f008f4$var$BasisClosed(context);
}

});
parcelRegister("DwreA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $076cce322a7018d3$var$_default;
function $076cce322a7018d3$var$_default() {}

});

parcelRegister("5Qhl2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $440f421e1a553982$var$Basis;
module.exports.default = $440f421e1a553982$var$_default;
module.exports.point = $440f421e1a553982$var$point;
function $440f421e1a553982$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $440f421e1a553982$var$Basis(context) {
    this._context = context;
}
$440f421e1a553982$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $440f421e1a553982$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $440f421e1a553982$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $440f421e1a553982$var$_default(context) {
    return new $440f421e1a553982$var$Basis(context);
}

});


parcelRegister("6nSQ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a5f6dcc082043c8$var$_default;

var $5Qhl2 = parcelRequire("5Qhl2");
function $4a5f6dcc082043c8$var$BasisOpen(context) {
    this._context = context;
}
$4a5f6dcc082043c8$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $5Qhl2.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $4a5f6dcc082043c8$var$_default(context) {
    return new $4a5f6dcc082043c8$var$BasisOpen(context);
}

});

parcelRegister("3Z7fr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5Qhl2 = parcelRequire("5Qhl2");
function $2e6cb0e614239711$var$Bundle(context, beta) {
    this._basis = new $5Qhl2.Basis(context);
    this._beta = beta;
}
$2e6cb0e614239711$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $2e6cb0e614239711$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $5Qhl2.Basis(context) : new $2e6cb0e614239711$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $2e6cb0e614239711$var$_default;

});

parcelRegister("2as13", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $19423f507cbf8f17$var$CardinalClosed;
module.exports.default = void 0;

var $19423f507cbf8f17$var$_noop = $19423f507cbf8f17$var$_interopRequireDefault((parcelRequire("DwreA")));

var $8eKmz = parcelRequire("8eKmz");
function $19423f507cbf8f17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $19423f507cbf8f17$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$19423f507cbf8f17$var$CardinalClosed.prototype = {
    areaStart: $19423f507cbf8f17$var$_noop.default,
    areaEnd: $19423f507cbf8f17$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $8eKmz.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $19423f507cbf8f17$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $19423f507cbf8f17$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $19423f507cbf8f17$var$_default;

});
parcelRegister("8eKmz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $5ff3984554cabbc0$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $5ff3984554cabbc0$var$point;
function $5ff3984554cabbc0$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $5ff3984554cabbc0$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$5ff3984554cabbc0$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $5ff3984554cabbc0$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $5ff3984554cabbc0$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $5ff3984554cabbc0$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $5ff3984554cabbc0$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $5ff3984554cabbc0$var$_default;

});


parcelRegister("jxpZF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $e3954333b381aa52$var$CardinalOpen;
module.exports.default = void 0;

var $8eKmz = parcelRequire("8eKmz");
function $e3954333b381aa52$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$e3954333b381aa52$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $8eKmz.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $e3954333b381aa52$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $e3954333b381aa52$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $e3954333b381aa52$var$_default;

});

parcelRegister("jbHfS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2as13 = parcelRequire("2as13");

var $df8098fa74193398$var$_noop = $df8098fa74193398$var$_interopRequireDefault((parcelRequire("DwreA")));

var $lCdlx = parcelRequire("lCdlx");
function $df8098fa74193398$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $df8098fa74193398$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$df8098fa74193398$var$CatmullRomClosed.prototype = {
    areaStart: $df8098fa74193398$var$_noop.default,
    areaEnd: $df8098fa74193398$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $lCdlx.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $df8098fa74193398$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $df8098fa74193398$var$CatmullRomClosed(context, alpha) : new $2as13.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $df8098fa74193398$var$_default;

});
parcelRegister("lCdlx", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $6SVxd = parcelRequire("6SVxd");

var $8eKmz = parcelRequire("8eKmz");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $6SVxd.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $6SVxd.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $8eKmz.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("keMhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jxpZF = parcelRequire("jxpZF");

var $lCdlx = parcelRequire("lCdlx");
function $ebba9186e3b304d2$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$ebba9186e3b304d2$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $lCdlx.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $ebba9186e3b304d2$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $ebba9186e3b304d2$var$CatmullRomOpen(context, alpha) : new $jxpZF.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $ebba9186e3b304d2$var$_default;

});

parcelRegister("aQUVY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e6aeca2018ea8c4$var$_default;

var $7e6aeca2018ea8c4$var$_noop = $7e6aeca2018ea8c4$var$_interopRequireDefault((parcelRequire("DwreA")));
function $7e6aeca2018ea8c4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e6aeca2018ea8c4$var$LinearClosed(context) {
    this._context = context;
}
$7e6aeca2018ea8c4$var$LinearClosed.prototype = {
    areaStart: $7e6aeca2018ea8c4$var$_noop.default,
    areaEnd: $7e6aeca2018ea8c4$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $7e6aeca2018ea8c4$var$_default(context) {
    return new $7e6aeca2018ea8c4$var$LinearClosed(context);
}

});

parcelRegister("eg4Yo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $a6166ad6ab1a0825$var$monotoneX;
module.exports.monotoneY = $a6166ad6ab1a0825$var$monotoneY;
function $a6166ad6ab1a0825$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $a6166ad6ab1a0825$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($a6166ad6ab1a0825$var$sign(s0) + $a6166ad6ab1a0825$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $a6166ad6ab1a0825$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $a6166ad6ab1a0825$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $a6166ad6ab1a0825$var$MonotoneX(context) {
    this._context = context;
}
$a6166ad6ab1a0825$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $a6166ad6ab1a0825$var$point(this, this._t0, $a6166ad6ab1a0825$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $a6166ad6ab1a0825$var$point(this, $a6166ad6ab1a0825$var$slope2(this, t1 = $a6166ad6ab1a0825$var$slope3(this, x, y)), t1);
                break;
            default:
                $a6166ad6ab1a0825$var$point(this, this._t0, t1 = $a6166ad6ab1a0825$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $a6166ad6ab1a0825$var$MonotoneY(context) {
    this._context = new $a6166ad6ab1a0825$var$ReflectContext(context);
}
($a6166ad6ab1a0825$var$MonotoneY.prototype = Object.create($a6166ad6ab1a0825$var$MonotoneX.prototype)).point = function(x, y) {
    $a6166ad6ab1a0825$var$MonotoneX.prototype.point.call(this, y, x);
};
function $a6166ad6ab1a0825$var$ReflectContext(context) {
    this._context = context;
}
$a6166ad6ab1a0825$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $a6166ad6ab1a0825$var$monotoneX(context) {
    return new $a6166ad6ab1a0825$var$MonotoneX(context);
}
function $a6166ad6ab1a0825$var$monotoneY(context) {
    return new $a6166ad6ab1a0825$var$MonotoneY(context);
}

});

parcelRegister("er2IE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a825b245f4ed65b6$var$_default;
function $a825b245f4ed65b6$var$Natural(context) {
    this._context = context;
}
$a825b245f4ed65b6$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $a825b245f4ed65b6$var$controlPoints(x), py = $a825b245f4ed65b6$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $a825b245f4ed65b6$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $a825b245f4ed65b6$var$_default(context) {
    return new $a825b245f4ed65b6$var$Natural(context);
}

});

parcelRegister("dvzIZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d59e1c8c88d35c8$var$_default;
module.exports.stepAfter = $9d59e1c8c88d35c8$var$stepAfter;
module.exports.stepBefore = $9d59e1c8c88d35c8$var$stepBefore;
function $9d59e1c8c88d35c8$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$9d59e1c8c88d35c8$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $9d59e1c8c88d35c8$var$_default(context) {
    return new $9d59e1c8c88d35c8$var$Step(context, 0.5);
}
function $9d59e1c8c88d35c8$var$stepBefore(context) {
    return new $9d59e1c8c88d35c8$var$Step(context, 0);
}
function $9d59e1c8c88d35c8$var$stepAfter(context) {
    return new $9d59e1c8c88d35c8$var$Step(context, 1);
}

});

parcelRegister("31wXu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $233b07f21af819cd$var$_default;

var $233b07f21af819cd$var$_array = $233b07f21af819cd$var$_interopRequireDefault((parcelRequire("6svIw")));

var $233b07f21af819cd$var$_constant = $233b07f21af819cd$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $233b07f21af819cd$var$_none = $233b07f21af819cd$var$_interopRequireDefault((parcelRequire("3ECyH")));

var $233b07f21af819cd$var$_none2 = $233b07f21af819cd$var$_interopRequireDefault((parcelRequire("3MXBI")));
function $233b07f21af819cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $233b07f21af819cd$var$stackValue(d, key) {
    return d[key];
}
function $233b07f21af819cd$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $233b07f21af819cd$var$_default() {
    var keys = (0, $233b07f21af819cd$var$_constant.default)([]), order = $233b07f21af819cd$var$_none2.default, offset = $233b07f21af819cd$var$_none.default, value = $233b07f21af819cd$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $233b07f21af819cd$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $233b07f21af819cd$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $233b07f21af819cd$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $233b07f21af819cd$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $233b07f21af819cd$var$_none2.default : typeof _ === "function" ? _ : (0, $233b07f21af819cd$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $233b07f21af819cd$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("3ECyH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a93047a4f3e4882$var$_default;
function $2a93047a4f3e4882$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("3MXBI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c241795eda08ad1$var$_default;
function $2c241795eda08ad1$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("jmoE1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e183304388747979$var$_default;

var $e183304388747979$var$_none = $e183304388747979$var$_interopRequireDefault((parcelRequire("3ECyH")));
function $e183304388747979$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e183304388747979$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $e183304388747979$var$_none.default)(series, order);
}

});

parcelRegister("f0DEq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aed59cf73c40a83a$var$_default;
function $aed59cf73c40a83a$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("9owud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d6f8e094a80c42b$var$_default;

var $6d6f8e094a80c42b$var$_none = $6d6f8e094a80c42b$var$_interopRequireDefault((parcelRequire("3ECyH")));
function $6d6f8e094a80c42b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6d6f8e094a80c42b$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $6d6f8e094a80c42b$var$_none.default)(series, order);
}

});

parcelRegister("kJmkn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f179546c90cfd5b8$var$_default;

var $f179546c90cfd5b8$var$_none = $f179546c90cfd5b8$var$_interopRequireDefault((parcelRequire("3ECyH")));
function $f179546c90cfd5b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f179546c90cfd5b8$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $f179546c90cfd5b8$var$_none.default)(series, order);
}

});

parcelRegister("cMxJq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94e422235dd9ade6$var$_default;

var $94e422235dd9ade6$var$_none = $94e422235dd9ade6$var$_interopRequireDefault((parcelRequire("3MXBI")));
function $94e422235dd9ade6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94e422235dd9ade6$var$_default(series) {
    var peaks = series.map($94e422235dd9ade6$var$peak);
    return (0, $94e422235dd9ade6$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $94e422235dd9ade6$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("7OIkp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b0f968ea3bfef64$var$_default;
module.exports.sum = $5b0f968ea3bfef64$var$sum;

var $5b0f968ea3bfef64$var$_none = $5b0f968ea3bfef64$var$_interopRequireDefault((parcelRequire("3MXBI")));
function $5b0f968ea3bfef64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5b0f968ea3bfef64$var$_default(series) {
    var sums = series.map($5b0f968ea3bfef64$var$sum);
    return (0, $5b0f968ea3bfef64$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $5b0f968ea3bfef64$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("bl2N4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8413d1ffb7520f5d$var$_default;

var $8413d1ffb7520f5d$var$_ascending = $8413d1ffb7520f5d$var$_interopRequireDefault((parcelRequire("7OIkp")));
function $8413d1ffb7520f5d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8413d1ffb7520f5d$var$_default(series) {
    return (0, $8413d1ffb7520f5d$var$_ascending.default)(series).reverse();
}

});

parcelRegister("ino5x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d60d0f7084dc1115$var$_default;

var $d60d0f7084dc1115$var$_appearance = $d60d0f7084dc1115$var$_interopRequireDefault((parcelRequire("cMxJq")));

var $7OIkp = parcelRequire("7OIkp");
function $d60d0f7084dc1115$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d60d0f7084dc1115$var$_default(series) {
    var n = series.length, i, j, sums = series.map($7OIkp.sum), order = (0, $d60d0f7084dc1115$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("nTFR3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $047d55cf2e68263f$var$_default;

var $047d55cf2e68263f$var$_none = $047d55cf2e68263f$var$_interopRequireDefault((parcelRequire("3MXBI")));
function $047d55cf2e68263f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $047d55cf2e68263f$var$_default(series) {
    return (0, $047d55cf2e68263f$var$_none.default)(series).reverse();
}

});



parcelRegister("eFJGi", function(module, exports) {

var $2jpDk = parcelRequire("2jpDk");

var $1GoSn = parcelRequire("1GoSn");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $2jpDk.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1GoSn;
module.exports = isBuffer;

});
parcelRegister("2jpDk", function(module, exports) {

var $korbf = parcelRequire("korbf");
/** Detect free variable `self`. */ var $1af13d63009a4839$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1af13d63009a4839$var$root = $korbf || $1af13d63009a4839$var$freeSelf || Function('return this')();
module.exports = $1af13d63009a4839$var$root;

});
parcelRegister("korbf", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $ed8b21fcd2e725e3$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $ed8b21fcd2e725e3$var$freeGlobal;

});


parcelRegister("1GoSn", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $139d02900740a52b$var$stubFalse() {
    return false;
}
module.exports = $139d02900740a52b$var$stubFalse;

});


parcelRegister("1cz3N", function(module, exports) {

var $korbf = parcelRequire("korbf");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $korbf.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("9HWmz", function(module, exports) {
parcelRequire("9k0OT");

module.exports = (parcelRequire("aunq5")).Object.assign;

});
parcelRegister("9k0OT", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $g45SR = parcelRequire("g45SR");

$g45SR($g45SR.S + $g45SR.F, 'Object', {
    assign: (parcelRequire("4LVma"))
});

});
parcelRegister("g45SR", function(module, exports) {

var $pnVph = parcelRequire("pnVph");

var $aunq5 = parcelRequire("aunq5");

var $bMm8u = parcelRequire("bMm8u");

var $9szbs = parcelRequire("9szbs");

var $779TT = parcelRequire("779TT");
var $bb21957dbdff3874$var$PROTOTYPE = 'prototype';
var $bb21957dbdff3874$var$$export = function(type, name, source) {
    var IS_FORCED = type & $bb21957dbdff3874$var$$export.F;
    var IS_GLOBAL = type & $bb21957dbdff3874$var$$export.G;
    var IS_STATIC = type & $bb21957dbdff3874$var$$export.S;
    var IS_PROTO = type & $bb21957dbdff3874$var$$export.P;
    var IS_BIND = type & $bb21957dbdff3874$var$$export.B;
    var IS_WRAP = type & $bb21957dbdff3874$var$$export.W;
    var exports = IS_GLOBAL ? $aunq5 : $aunq5[name] || ($aunq5[name] = {});
    var expProto = exports[$bb21957dbdff3874$var$PROTOTYPE];
    var target = IS_GLOBAL ? $pnVph : IS_STATIC ? $pnVph[name] : ($pnVph[name] || {})[$bb21957dbdff3874$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $779TT(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $bMm8u(out, $pnVph) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$bb21957dbdff3874$var$PROTOTYPE] = C[$bb21957dbdff3874$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $bMm8u(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $bb21957dbdff3874$var$$export.R && expProto && !expProto[key]) $9szbs(expProto, key, out);
        }
    }
};
// type bitmap
$bb21957dbdff3874$var$$export.F = 1; // forced
$bb21957dbdff3874$var$$export.G = 2; // global
$bb21957dbdff3874$var$$export.S = 4; // static
$bb21957dbdff3874$var$$export.P = 8; // proto
$bb21957dbdff3874$var$$export.B = 16; // bind
$bb21957dbdff3874$var$$export.W = 32; // wrap
$bb21957dbdff3874$var$$export.U = 64; // safe
$bb21957dbdff3874$var$$export.R = 128; // real proto method for `library`
module.exports = $bb21957dbdff3874$var$$export;

});
parcelRegister("pnVph", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $04c4e4e76a6edd9f$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $04c4e4e76a6edd9f$var$global; // eslint-disable-line no-undef

});

parcelRegister("aunq5", function(module, exports) {
var $7a2edf6687c7bf3d$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $7a2edf6687c7bf3d$var$core; // eslint-disable-line no-undef

});

parcelRegister("bMm8u", function(module, exports) {
// optional / simple context binding

var $lRhcY = parcelRequire("lRhcY");
module.exports = function(fn, that, length) {
    $lRhcY(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("lRhcY", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("9szbs", function(module, exports) {

var $fxtrV = parcelRequire("fxtrV");

var $Gbehr = parcelRequire("Gbehr");

module.exports = (parcelRequire("iUvfY")) ? function(object, key, value) {
    return $fxtrV.f(object, key, $Gbehr(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("fxtrV", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $b500c822271951d0$export$2d1720544b23b823; }, function (v) { return $b500c822271951d0$export$2d1720544b23b823 = v; });
var $b500c822271951d0$export$2d1720544b23b823;

var $gWOKW = parcelRequire("gWOKW");

var $3EiA3 = parcelRequire("3EiA3");

var $jfS6J = parcelRequire("jfS6J");
var $b500c822271951d0$var$dP = Object.defineProperty;

$b500c822271951d0$export$2d1720544b23b823 = (parcelRequire("iUvfY")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $gWOKW(O);
    P = $jfS6J(P, true);
    $gWOKW(Attributes);
    if ($3EiA3) try {
        return $b500c822271951d0$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("gWOKW", function(module, exports) {

var $c8vg0 = parcelRequire("c8vg0");
module.exports = function(it) {
    if (!$c8vg0(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("c8vg0", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("3EiA3", function(module, exports) {



module.exports = !(parcelRequire("iUvfY")) && !(parcelRequire("k9mjq"))(function() {
    return Object.defineProperty((parcelRequire("5ZV8G"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("iUvfY", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("k9mjq"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("k9mjq", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("5ZV8G", function(module, exports) {

var $c8vg0 = parcelRequire("c8vg0");

var $pnVph = parcelRequire("pnVph");
var $45def8dd436ab5ed$require$document = $pnVph.document;
// typeof document.createElement is 'object' in old IE
var $45def8dd436ab5ed$var$is = $c8vg0($45def8dd436ab5ed$require$document) && $c8vg0($45def8dd436ab5ed$require$document.createElement);
module.exports = function(it) {
    return $45def8dd436ab5ed$var$is ? $45def8dd436ab5ed$require$document.createElement(it) : {};
};

});


parcelRegister("jfS6J", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $c8vg0 = parcelRequire("c8vg0");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$c8vg0(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$c8vg0(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$c8vg0(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$c8vg0(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("Gbehr", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("779TT", function(module, exports) {
var $52e0dde1fa7b30e4$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $52e0dde1fa7b30e4$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("4LVma", function(module, exports) {
'use strict';

var $iUvfY = parcelRequire("iUvfY");

var $fmsEx = parcelRequire("fmsEx");

var $i3Fjk = parcelRequire("i3Fjk");

var $fbjf9 = parcelRequire("fbjf9");

var $f7AII = parcelRequire("f7AII");

var $awHHr = parcelRequire("awHHr");
var $37980b09787ef0c9$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$37980b09787ef0c9$var$$assign || (parcelRequire("k9mjq"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $37980b09787ef0c9$var$$assign({}, A)[S] != 7 || Object.keys($37980b09787ef0c9$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $f7AII(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $i3Fjk.f;
    var isEnum = $fbjf9.f;
    while(aLen > index){
        var S = $awHHr(arguments[index++]);
        var keys = getSymbols ? $fmsEx(S).concat(getSymbols(S)) : $fmsEx(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$iUvfY || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $37980b09787ef0c9$var$$assign;

});
parcelRegister("fmsEx", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $g7Rv3 = parcelRequire("g7Rv3");

var $eeRfl = parcelRequire("eeRfl");
module.exports = Object.keys || function keys(O) {
    return $g7Rv3(O, $eeRfl);
};

});
parcelRegister("g7Rv3", function(module, exports) {

var $779TT = parcelRequire("779TT");

var $bSzJU = parcelRequire("bSzJU");

var $bbd6ccc00206b77b$var$arrayIndexOf = (parcelRequire("gHQQ2"))(false);

var $bbd6ccc00206b77b$var$IE_PROTO = (parcelRequire("GgEeA"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $bSzJU(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $bbd6ccc00206b77b$var$IE_PROTO) $779TT(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($779TT(O, key = names[i++])) ~$bbd6ccc00206b77b$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("bSzJU", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $awHHr = parcelRequire("awHHr");

var $2GiKc = parcelRequire("2GiKc");
module.exports = function(it) {
    return $awHHr($2GiKc(it));
};

});
parcelRegister("awHHr", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $cONIx = parcelRequire("cONIx");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $cONIx(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("cONIx", function(module, exports) {
var $9550b8609f427639$var$toString = {}.toString;
module.exports = function(it) {
    return $9550b8609f427639$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("2GiKc", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("gHQQ2", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $bSzJU = parcelRequire("bSzJU");

var $42VcX = parcelRequire("42VcX");

var $btJ4J = parcelRequire("btJ4J");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $bSzJU($this);
        var length = $42VcX(O.length);
        var index = $btJ4J(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("42VcX", function(module, exports) {
// 7.1.15 ToLength

var $le8Xc = parcelRequire("le8Xc");
var $2f23b9a1f4477c52$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $2f23b9a1f4477c52$var$min($le8Xc(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("le8Xc", function(module, exports) {
// 7.1.4 ToInteger
var $f741d9d2c398843c$var$ceil = Math.ceil;
var $f741d9d2c398843c$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $f741d9d2c398843c$var$floor : $f741d9d2c398843c$var$ceil)(it);
};

});


parcelRegister("btJ4J", function(module, exports) {

var $le8Xc = parcelRequire("le8Xc");
var $85b55e281721d3ab$var$max = Math.max;
var $85b55e281721d3ab$var$min = Math.min;
module.exports = function(index, length) {
    index = $le8Xc(index);
    return index < 0 ? $85b55e281721d3ab$var$max(index + length, 0) : $85b55e281721d3ab$var$min(index, length);
};

});


parcelRegister("GgEeA", function(module, exports) {

var $07f0d64acd5a0c70$var$shared = (parcelRequire("cjBmO"))('keys');

var $59Ov2 = parcelRequire("59Ov2");
module.exports = function(key) {
    return $07f0d64acd5a0c70$var$shared[key] || ($07f0d64acd5a0c70$var$shared[key] = $59Ov2(key));
};

});
parcelRegister("cjBmO", function(module, exports) {

var $aunq5 = parcelRequire("aunq5");

var $pnVph = parcelRequire("pnVph");
var $8f743ea8506f6d26$var$SHARED = '__core-js_shared__';
var $8f743ea8506f6d26$var$store = $pnVph[$8f743ea8506f6d26$var$SHARED] || ($pnVph[$8f743ea8506f6d26$var$SHARED] = {});

(module.exports = function(key, value) {
    return $8f743ea8506f6d26$var$store[key] || ($8f743ea8506f6d26$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $aunq5.version,
    mode: (parcelRequire("9q93S")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("9q93S", function(module, exports) {
module.exports = true;

});


parcelRegister("59Ov2", function(module, exports) {
var $3c14f72a489241a1$var$id = 0;
var $3c14f72a489241a1$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$3c14f72a489241a1$var$id + $3c14f72a489241a1$var$px).toString(36));
};

});



parcelRegister("eeRfl", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});


parcelRegister("i3Fjk", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $d2588d4145d20b3f$export$2d1720544b23b823; }, function (v) { return $d2588d4145d20b3f$export$2d1720544b23b823 = v; });
var $d2588d4145d20b3f$export$2d1720544b23b823;
$d2588d4145d20b3f$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("fbjf9", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $b0d6cf6dc7525790$export$2d1720544b23b823; }, function (v) { return $b0d6cf6dc7525790$export$2d1720544b23b823 = v; });
var $b0d6cf6dc7525790$export$2d1720544b23b823;
$b0d6cf6dc7525790$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("f7AII", function(module, exports) {
// 7.1.13 ToObject(argument)

var $2GiKc = parcelRequire("2GiKc");
module.exports = function(it) {
    return Object($2GiKc(it));
};

});




parcelRegister("7kC0X", function(module, exports) {
parcelRequire("cnRix");

module.exports = (parcelRequire("aunq5")).Object.getPrototypeOf;

});
parcelRegister("cnRix", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $f7AII = parcelRequire("f7AII");

var $iQWEJ = parcelRequire("iQWEJ");

(parcelRequire("7lufS"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $iQWEJ($f7AII(it));
    };
});

});
parcelRegister("iQWEJ", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $779TT = parcelRequire("779TT");

var $f7AII = parcelRequire("f7AII");

var $db9a95279c2b66e7$var$IE_PROTO = (parcelRequire("GgEeA"))('IE_PROTO');
var $db9a95279c2b66e7$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $f7AII(O);
    if ($779TT(O, $db9a95279c2b66e7$var$IE_PROTO)) return O[$db9a95279c2b66e7$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $db9a95279c2b66e7$var$ObjectProto : null;
};

});

parcelRegister("7lufS", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $g45SR = parcelRequire("g45SR");

var $aunq5 = parcelRequire("aunq5");

var $k9mjq = parcelRequire("k9mjq");
module.exports = function(KEY, exec) {
    var fn = ($aunq5.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $g45SR($g45SR.S + $g45SR.F * $k9mjq(function() {
        fn(1);
    }), 'Object', exp);
};

});



parcelRegister("kRrED", function(module, exports) {
parcelRequire("kd4bk");

var $aunq5 = parcelRequire("aunq5");
var $f2fe357f25d7c4c7$require$$Object = $aunq5.Object;
module.exports = function defineProperty(it, key, desc) {
    return $f2fe357f25d7c4c7$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("kd4bk", function(module, exports) {

var $g45SR = parcelRequire("g45SR");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$g45SR($g45SR.S + $g45SR.F * !(parcelRequire("iUvfY")), 'Object', {
    defineProperty: (parcelRequire("fxtrV")).f
});

});


parcelRegister("5nWeK", function(module, exports) {
parcelRequire("4WGOw");
parcelRequire("6Lpnt");

module.exports = (parcelRequire("7ClSO")).f('iterator');

});
parcelRegister("4WGOw", function(module, exports) {
'use strict';

var $399dca20849743a1$var$$at = (parcelRequire("4MEQN"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("fOaE1"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $399dca20849743a1$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("4MEQN", function(module, exports) {

var $le8Xc = parcelRequire("le8Xc");

var $2GiKc = parcelRequire("2GiKc");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($2GiKc(that));
        var i = $le8Xc(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("fOaE1", function(module, exports) {
'use strict';

var $9q93S = parcelRequire("9q93S");

var $g45SR = parcelRequire("g45SR");

var $eM6v4 = parcelRequire("eM6v4");

var $9szbs = parcelRequire("9szbs");

var $G17rB = parcelRequire("G17rB");

var $aR3DP = parcelRequire("aR3DP");

var $fkjfL = parcelRequire("fkjfL");

var $iQWEJ = parcelRequire("iQWEJ");

var $b823c84978a89247$var$ITERATOR = (parcelRequire("fydF3"))('iterator');
var $b823c84978a89247$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $b823c84978a89247$var$FF_ITERATOR = '@@iterator';
var $b823c84978a89247$var$KEYS = 'keys';
var $b823c84978a89247$var$VALUES = 'values';
var $b823c84978a89247$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $aR3DP(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$b823c84978a89247$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $b823c84978a89247$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $b823c84978a89247$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $b823c84978a89247$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$b823c84978a89247$var$ITERATOR] || proto[$b823c84978a89247$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $iQWEJ($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $fkjfL(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$9q93S && typeof IteratorPrototype[$b823c84978a89247$var$ITERATOR] != 'function') $9szbs(IteratorPrototype, $b823c84978a89247$var$ITERATOR, $b823c84978a89247$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $b823c84978a89247$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$9q93S || FORCED) && ($b823c84978a89247$var$BUGGY || VALUES_BUG || !proto[$b823c84978a89247$var$ITERATOR])) $9szbs(proto, $b823c84978a89247$var$ITERATOR, $default);
    // Plug for library
    $G17rB[NAME] = $default;
    $G17rB[TAG] = $b823c84978a89247$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($b823c84978a89247$var$VALUES),
            keys: IS_SET ? $default : getMethod($b823c84978a89247$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $eM6v4(proto, key, methods[key]);
        } else $g45SR($g45SR.P + $g45SR.F * ($b823c84978a89247$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("eM6v4", function(module, exports) {

module.exports = (parcelRequire("9szbs"));

});

parcelRegister("G17rB", function(module, exports) {
module.exports = {};

});

parcelRegister("aR3DP", function(module, exports) {
'use strict';

var $ey75m = parcelRequire("ey75m");

var $Gbehr = parcelRequire("Gbehr");

var $fkjfL = parcelRequire("fkjfL");
var $7e71adbe8ce110e0$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("9szbs"))($7e71adbe8ce110e0$var$IteratorPrototype, (parcelRequire("fydF3"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $ey75m($7e71adbe8ce110e0$var$IteratorPrototype, {
        next: $Gbehr(1, next)
    });
    $fkjfL(Constructor, NAME + ' Iterator');
};

});
parcelRegister("ey75m", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $gWOKW = parcelRequire("gWOKW");

var $1xk0l = parcelRequire("1xk0l");

var $eeRfl = parcelRequire("eeRfl");

var $a979bcaa26f38a68$var$IE_PROTO = (parcelRequire("GgEeA"))('IE_PROTO');
var $a979bcaa26f38a68$var$Empty = function() {};
var $a979bcaa26f38a68$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $a979bcaa26f38a68$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("5ZV8G"))('iframe');
    var i = $eeRfl.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("gu9tw")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $a979bcaa26f38a68$var$createDict = iframeDocument.F;
    while(i--)delete $a979bcaa26f38a68$var$createDict[$a979bcaa26f38a68$var$PROTOTYPE][$eeRfl[i]];
    return $a979bcaa26f38a68$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $a979bcaa26f38a68$var$Empty[$a979bcaa26f38a68$var$PROTOTYPE] = $gWOKW(O);
        result = new $a979bcaa26f38a68$var$Empty();
        $a979bcaa26f38a68$var$Empty[$a979bcaa26f38a68$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$a979bcaa26f38a68$var$IE_PROTO] = O;
    } else result = $a979bcaa26f38a68$var$createDict();
    return Properties === undefined ? result : $1xk0l(result, Properties);
};

});
parcelRegister("1xk0l", function(module, exports) {

var $fxtrV = parcelRequire("fxtrV");

var $gWOKW = parcelRequire("gWOKW");

var $fmsEx = parcelRequire("fmsEx");

module.exports = (parcelRequire("iUvfY")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $gWOKW(O);
    var keys = $fmsEx(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$fxtrV.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("gu9tw", function(module, exports) {

var $pnVph = parcelRequire("pnVph");
var $c006cc3eded20735$require$document = $pnVph.document;
module.exports = $c006cc3eded20735$require$document && $c006cc3eded20735$require$document.documentElement;

});


parcelRegister("fkjfL", function(module, exports) {

var $fxtrV = parcelRequire("fxtrV");
var $b287a896fa454b10$require$def = $fxtrV.f;

var $779TT = parcelRequire("779TT");

var $b287a896fa454b10$var$TAG = (parcelRequire("fydF3"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$779TT(it = stat ? it : it.prototype, $b287a896fa454b10$var$TAG)) $b287a896fa454b10$require$def(it, $b287a896fa454b10$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("fydF3", function(module, exports) {

var $b524a0d2e0457ac4$var$store = (parcelRequire("cjBmO"))('wks');

var $59Ov2 = parcelRequire("59Ov2");

var $pnVph = parcelRequire("pnVph");
var $b524a0d2e0457ac4$require$Symbol = $pnVph.Symbol;
var $b524a0d2e0457ac4$var$USE_SYMBOL = typeof $b524a0d2e0457ac4$require$Symbol == 'function';
var $b524a0d2e0457ac4$var$$exports = module.exports = function(name) {
    return $b524a0d2e0457ac4$var$store[name] || ($b524a0d2e0457ac4$var$store[name] = $b524a0d2e0457ac4$var$USE_SYMBOL && $b524a0d2e0457ac4$require$Symbol[name] || ($b524a0d2e0457ac4$var$USE_SYMBOL ? $b524a0d2e0457ac4$require$Symbol : $59Ov2)('Symbol.' + name));
};
$b524a0d2e0457ac4$var$$exports.store = $b524a0d2e0457ac4$var$store;

});





parcelRegister("6Lpnt", function(module, exports) {
parcelRequire("9KY9L");

var $pnVph = parcelRequire("pnVph");

var $9szbs = parcelRequire("9szbs");

var $G17rB = parcelRequire("G17rB");

var $4ecad155a8c488ba$var$TO_STRING_TAG = (parcelRequire("fydF3"))('toStringTag');
var $4ecad155a8c488ba$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $4ecad155a8c488ba$var$i = 0; $4ecad155a8c488ba$var$i < $4ecad155a8c488ba$var$DOMIterables.length; $4ecad155a8c488ba$var$i++){
    var $4ecad155a8c488ba$var$NAME = $4ecad155a8c488ba$var$DOMIterables[$4ecad155a8c488ba$var$i];
    var $4ecad155a8c488ba$var$Collection = $pnVph[$4ecad155a8c488ba$var$NAME];
    var $4ecad155a8c488ba$var$proto = $4ecad155a8c488ba$var$Collection && $4ecad155a8c488ba$var$Collection.prototype;
    if ($4ecad155a8c488ba$var$proto && !$4ecad155a8c488ba$var$proto[$4ecad155a8c488ba$var$TO_STRING_TAG]) $9szbs($4ecad155a8c488ba$var$proto, $4ecad155a8c488ba$var$TO_STRING_TAG, $4ecad155a8c488ba$var$NAME);
    $G17rB[$4ecad155a8c488ba$var$NAME] = $G17rB.Array;
}

});
parcelRegister("9KY9L", function(module, exports) {
'use strict';

var $eqjq0 = parcelRequire("eqjq0");

var $jlYOp = parcelRequire("jlYOp");

var $G17rB = parcelRequire("G17rB");

var $bSzJU = parcelRequire("bSzJU");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("fOaE1"))(Array, 'Array', function(iterated, kind) {
    this._t = $bSzJU(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $jlYOp(1);
    }
    if (kind == 'keys') return $jlYOp(0, index);
    if (kind == 'values') return $jlYOp(0, O[index]);
    return $jlYOp(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$G17rB.Arguments = $G17rB.Array;
$eqjq0('keys');
$eqjq0('values');
$eqjq0('entries');

});
parcelRegister("eqjq0", function(module, exports) {
module.exports = function() {};

});

parcelRegister("jlYOp", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("7ClSO", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $58bd0e8a021ddf36$export$2d1720544b23b823; }, function (v) { return $58bd0e8a021ddf36$export$2d1720544b23b823 = v; });
var $58bd0e8a021ddf36$export$2d1720544b23b823;

$58bd0e8a021ddf36$export$2d1720544b23b823 = (parcelRequire("fydF3"));

});


parcelRegister("awRwR", function(module, exports) {
parcelRequire("cZq1X");
parcelRequire("aghnC");
parcelRequire("6owPI");
parcelRequire("grJtS");

module.exports = (parcelRequire("aunq5")).Symbol;

});
parcelRegister("cZq1X", function(module, exports) {
'use strict';

var $pnVph = parcelRequire("pnVph");

var $779TT = parcelRequire("779TT");

var $iUvfY = parcelRequire("iUvfY");

var $g45SR = parcelRequire("g45SR");

var $eM6v4 = parcelRequire("eM6v4");

var $32bVO = parcelRequire("32bVO");
var $974f5fb1f22faffb$require$META = $32bVO.KEY;

var $k9mjq = parcelRequire("k9mjq");

var $cjBmO = parcelRequire("cjBmO");

var $fkjfL = parcelRequire("fkjfL");

var $59Ov2 = parcelRequire("59Ov2");

var $fydF3 = parcelRequire("fydF3");

var $7ClSO = parcelRequire("7ClSO");

var $1BYu8 = parcelRequire("1BYu8");

var $d1OTP = parcelRequire("d1OTP");

var $ky93M = parcelRequire("ky93M");

var $gWOKW = parcelRequire("gWOKW");

var $c8vg0 = parcelRequire("c8vg0");

var $f7AII = parcelRequire("f7AII");

var $bSzJU = parcelRequire("bSzJU");

var $jfS6J = parcelRequire("jfS6J");

var $Gbehr = parcelRequire("Gbehr");

var $ey75m = parcelRequire("ey75m");

var $4YQr4 = parcelRequire("4YQr4");

var $b6FJh = parcelRequire("b6FJh");

var $i3Fjk = parcelRequire("i3Fjk");

var $fxtrV = parcelRequire("fxtrV");

var $fmsEx = parcelRequire("fmsEx");
var $974f5fb1f22faffb$var$gOPD = $b6FJh.f;
var $974f5fb1f22faffb$var$dP = $fxtrV.f;
var $974f5fb1f22faffb$var$gOPN = $4YQr4.f;
var $974f5fb1f22faffb$var$$Symbol = $pnVph.Symbol;
var $974f5fb1f22faffb$var$$JSON = $pnVph.JSON;
var $974f5fb1f22faffb$var$_stringify = $974f5fb1f22faffb$var$$JSON && $974f5fb1f22faffb$var$$JSON.stringify;
var $974f5fb1f22faffb$var$PROTOTYPE = 'prototype';
var $974f5fb1f22faffb$var$HIDDEN = $fydF3('_hidden');
var $974f5fb1f22faffb$var$TO_PRIMITIVE = $fydF3('toPrimitive');
var $974f5fb1f22faffb$var$isEnum = {}.propertyIsEnumerable;
var $974f5fb1f22faffb$var$SymbolRegistry = $cjBmO('symbol-registry');
var $974f5fb1f22faffb$var$AllSymbols = $cjBmO('symbols');
var $974f5fb1f22faffb$var$OPSymbols = $cjBmO('op-symbols');
var $974f5fb1f22faffb$var$ObjectProto = Object[$974f5fb1f22faffb$var$PROTOTYPE];
var $974f5fb1f22faffb$var$USE_NATIVE = typeof $974f5fb1f22faffb$var$$Symbol == 'function' && !!$i3Fjk.f;
var $974f5fb1f22faffb$var$QObject = $pnVph.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $974f5fb1f22faffb$var$setter = !$974f5fb1f22faffb$var$QObject || !$974f5fb1f22faffb$var$QObject[$974f5fb1f22faffb$var$PROTOTYPE] || !$974f5fb1f22faffb$var$QObject[$974f5fb1f22faffb$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $974f5fb1f22faffb$var$setSymbolDesc = $iUvfY && $k9mjq(function() {
    return $ey75m($974f5fb1f22faffb$var$dP({}, 'a', {
        get: function() {
            return $974f5fb1f22faffb$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $974f5fb1f22faffb$var$gOPD($974f5fb1f22faffb$var$ObjectProto, key);
    if (protoDesc) delete $974f5fb1f22faffb$var$ObjectProto[key];
    $974f5fb1f22faffb$var$dP(it, key, D);
    if (protoDesc && it !== $974f5fb1f22faffb$var$ObjectProto) $974f5fb1f22faffb$var$dP($974f5fb1f22faffb$var$ObjectProto, key, protoDesc);
} : $974f5fb1f22faffb$var$dP;
var $974f5fb1f22faffb$var$wrap = function(tag) {
    var sym = $974f5fb1f22faffb$var$AllSymbols[tag] = $ey75m($974f5fb1f22faffb$var$$Symbol[$974f5fb1f22faffb$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $974f5fb1f22faffb$var$isSymbol = $974f5fb1f22faffb$var$USE_NATIVE && typeof $974f5fb1f22faffb$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $974f5fb1f22faffb$var$$Symbol;
};
var $974f5fb1f22faffb$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $974f5fb1f22faffb$var$ObjectProto) $974f5fb1f22faffb$var$$defineProperty($974f5fb1f22faffb$var$OPSymbols, key, D);
    $gWOKW(it);
    key = $jfS6J(key, true);
    $gWOKW(D);
    if ($779TT($974f5fb1f22faffb$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$779TT(it, $974f5fb1f22faffb$var$HIDDEN)) $974f5fb1f22faffb$var$dP(it, $974f5fb1f22faffb$var$HIDDEN, $Gbehr(1, {}));
            it[$974f5fb1f22faffb$var$HIDDEN][key] = true;
        } else {
            if ($779TT(it, $974f5fb1f22faffb$var$HIDDEN) && it[$974f5fb1f22faffb$var$HIDDEN][key]) it[$974f5fb1f22faffb$var$HIDDEN][key] = false;
            D = $ey75m(D, {
                enumerable: $Gbehr(0, false)
            });
        }
        return $974f5fb1f22faffb$var$setSymbolDesc(it, key, D);
    }
    return $974f5fb1f22faffb$var$dP(it, key, D);
};
var $974f5fb1f22faffb$var$$defineProperties = function defineProperties(it, P) {
    $gWOKW(it);
    var keys = $d1OTP(P = $bSzJU(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$974f5fb1f22faffb$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $974f5fb1f22faffb$var$$create = function create(it, P) {
    return P === undefined ? $ey75m(it) : $974f5fb1f22faffb$var$$defineProperties($ey75m(it), P);
};
var $974f5fb1f22faffb$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $974f5fb1f22faffb$var$isEnum.call(this, key = $jfS6J(key, true));
    if (this === $974f5fb1f22faffb$var$ObjectProto && $779TT($974f5fb1f22faffb$var$AllSymbols, key) && !$779TT($974f5fb1f22faffb$var$OPSymbols, key)) return false;
    return E || !$779TT(this, key) || !$779TT($974f5fb1f22faffb$var$AllSymbols, key) || $779TT(this, $974f5fb1f22faffb$var$HIDDEN) && this[$974f5fb1f22faffb$var$HIDDEN][key] ? E : true;
};
var $974f5fb1f22faffb$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $bSzJU(it);
    key = $jfS6J(key, true);
    if (it === $974f5fb1f22faffb$var$ObjectProto && $779TT($974f5fb1f22faffb$var$AllSymbols, key) && !$779TT($974f5fb1f22faffb$var$OPSymbols, key)) return;
    var D = $974f5fb1f22faffb$var$gOPD(it, key);
    if (D && $779TT($974f5fb1f22faffb$var$AllSymbols, key) && !($779TT(it, $974f5fb1f22faffb$var$HIDDEN) && it[$974f5fb1f22faffb$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $974f5fb1f22faffb$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $974f5fb1f22faffb$var$gOPN($bSzJU(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$779TT($974f5fb1f22faffb$var$AllSymbols, key = names[i++]) && key != $974f5fb1f22faffb$var$HIDDEN && key != $974f5fb1f22faffb$require$META) result.push(key);
    return result;
};
var $974f5fb1f22faffb$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $974f5fb1f22faffb$var$ObjectProto;
    var names = $974f5fb1f22faffb$var$gOPN(IS_OP ? $974f5fb1f22faffb$var$OPSymbols : $bSzJU(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($779TT($974f5fb1f22faffb$var$AllSymbols, key = names[i++]) && (IS_OP ? $779TT($974f5fb1f22faffb$var$ObjectProto, key) : true)) result.push($974f5fb1f22faffb$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$974f5fb1f22faffb$var$USE_NATIVE) {
    $974f5fb1f22faffb$var$$Symbol = function Symbol() {
        if (this instanceof $974f5fb1f22faffb$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $59Ov2(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $974f5fb1f22faffb$var$ObjectProto) $set.call($974f5fb1f22faffb$var$OPSymbols, value);
            if ($779TT(this, $974f5fb1f22faffb$var$HIDDEN) && $779TT(this[$974f5fb1f22faffb$var$HIDDEN], tag)) this[$974f5fb1f22faffb$var$HIDDEN][tag] = false;
            $974f5fb1f22faffb$var$setSymbolDesc(this, tag, $Gbehr(1, value));
        };
        if ($iUvfY && $974f5fb1f22faffb$var$setter) $974f5fb1f22faffb$var$setSymbolDesc($974f5fb1f22faffb$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $974f5fb1f22faffb$var$wrap(tag);
    };
    $eM6v4($974f5fb1f22faffb$var$$Symbol[$974f5fb1f22faffb$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $b6FJh.f = $974f5fb1f22faffb$var$$getOwnPropertyDescriptor;
    $fxtrV.f = $974f5fb1f22faffb$var$$defineProperty;
    (parcelRequire("79buJ")).f = $4YQr4.f = $974f5fb1f22faffb$var$$getOwnPropertyNames;
    (parcelRequire("fbjf9")).f = $974f5fb1f22faffb$var$$propertyIsEnumerable;
    $i3Fjk.f = $974f5fb1f22faffb$var$$getOwnPropertySymbols;
    if ($iUvfY && !(parcelRequire("9q93S"))) $eM6v4($974f5fb1f22faffb$var$ObjectProto, 'propertyIsEnumerable', $974f5fb1f22faffb$var$$propertyIsEnumerable, true);
    $7ClSO.f = function(name) {
        return $974f5fb1f22faffb$var$wrap($fydF3(name));
    };
}
$g45SR($g45SR.G + $g45SR.W + $g45SR.F * !$974f5fb1f22faffb$var$USE_NATIVE, {
    Symbol: $974f5fb1f22faffb$var$$Symbol
});
for(var $974f5fb1f22faffb$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $974f5fb1f22faffb$var$j = 0; $974f5fb1f22faffb$var$es6Symbols.length > $974f5fb1f22faffb$var$j;)$fydF3($974f5fb1f22faffb$var$es6Symbols[$974f5fb1f22faffb$var$j++]);
for(var $974f5fb1f22faffb$var$wellKnownSymbols = $fmsEx($fydF3.store), $974f5fb1f22faffb$var$k = 0; $974f5fb1f22faffb$var$wellKnownSymbols.length > $974f5fb1f22faffb$var$k;)$1BYu8($974f5fb1f22faffb$var$wellKnownSymbols[$974f5fb1f22faffb$var$k++]);
$g45SR($g45SR.S + $g45SR.F * !$974f5fb1f22faffb$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $779TT($974f5fb1f22faffb$var$SymbolRegistry, key += '') ? $974f5fb1f22faffb$var$SymbolRegistry[key] : $974f5fb1f22faffb$var$SymbolRegistry[key] = $974f5fb1f22faffb$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$974f5fb1f22faffb$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $974f5fb1f22faffb$var$SymbolRegistry)if ($974f5fb1f22faffb$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $974f5fb1f22faffb$var$setter = true;
    },
    useSimple: function() {
        $974f5fb1f22faffb$var$setter = false;
    }
});
$g45SR($g45SR.S + $g45SR.F * !$974f5fb1f22faffb$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $974f5fb1f22faffb$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $974f5fb1f22faffb$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $974f5fb1f22faffb$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $974f5fb1f22faffb$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $974f5fb1f22faffb$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $974f5fb1f22faffb$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $974f5fb1f22faffb$var$FAILS_ON_PRIMITIVES = $k9mjq(function() {
    $i3Fjk.f(1);
});
$g45SR($g45SR.S + $g45SR.F * $974f5fb1f22faffb$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $i3Fjk.f($f7AII(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$974f5fb1f22faffb$var$$JSON && $g45SR($g45SR.S + $g45SR.F * (!$974f5fb1f22faffb$var$USE_NATIVE || $k9mjq(function() {
    var S = $974f5fb1f22faffb$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $974f5fb1f22faffb$var$_stringify([
        S
    ]) != '[null]' || $974f5fb1f22faffb$var$_stringify({
        a: S
    }) != '{}' || $974f5fb1f22faffb$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$c8vg0(replacer) && it === undefined || $974f5fb1f22faffb$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$ky93M(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$974f5fb1f22faffb$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $974f5fb1f22faffb$var$_stringify.apply($974f5fb1f22faffb$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$974f5fb1f22faffb$var$$Symbol[$974f5fb1f22faffb$var$PROTOTYPE][$974f5fb1f22faffb$var$TO_PRIMITIVE] || (parcelRequire("9szbs"))($974f5fb1f22faffb$var$$Symbol[$974f5fb1f22faffb$var$PROTOTYPE], $974f5fb1f22faffb$var$TO_PRIMITIVE, $974f5fb1f22faffb$var$$Symbol[$974f5fb1f22faffb$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$fkjfL($974f5fb1f22faffb$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$fkjfL(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$fkjfL($pnVph.JSON, 'JSON', true);

});
parcelRegister("32bVO", function(module, exports) {

var $235ad05d31a21508$var$META = (parcelRequire("59Ov2"))('meta');

var $c8vg0 = parcelRequire("c8vg0");

var $779TT = parcelRequire("779TT");

var $fxtrV = parcelRequire("fxtrV");
var $235ad05d31a21508$require$setDesc = $fxtrV.f;
var $235ad05d31a21508$var$id = 0;
var $235ad05d31a21508$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $235ad05d31a21508$var$FREEZE = !(parcelRequire("k9mjq"))(function() {
    return $235ad05d31a21508$var$isExtensible(Object.preventExtensions({}));
});
var $235ad05d31a21508$var$setMeta = function(it) {
    $235ad05d31a21508$require$setDesc(it, $235ad05d31a21508$var$META, {
        value: {
            i: 'O' + ++$235ad05d31a21508$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $235ad05d31a21508$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$c8vg0(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$779TT(it, $235ad05d31a21508$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$235ad05d31a21508$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $235ad05d31a21508$var$setMeta(it);
    // return object ID
    }
    return it[$235ad05d31a21508$var$META].i;
};
var $235ad05d31a21508$var$getWeak = function(it, create) {
    if (!$779TT(it, $235ad05d31a21508$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$235ad05d31a21508$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $235ad05d31a21508$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$235ad05d31a21508$var$META].w;
};
// add metadata on freeze-family methods calling
var $235ad05d31a21508$var$onFreeze = function(it) {
    if ($235ad05d31a21508$var$FREEZE && $235ad05d31a21508$var$meta.NEED && $235ad05d31a21508$var$isExtensible(it) && !$779TT(it, $235ad05d31a21508$var$META)) $235ad05d31a21508$var$setMeta(it);
    return it;
};
var $235ad05d31a21508$var$meta = module.exports = {
    KEY: $235ad05d31a21508$var$META,
    NEED: false,
    fastKey: $235ad05d31a21508$var$fastKey,
    getWeak: $235ad05d31a21508$var$getWeak,
    onFreeze: $235ad05d31a21508$var$onFreeze
};

});

parcelRegister("1BYu8", function(module, exports) {

var $pnVph = parcelRequire("pnVph");

var $aunq5 = parcelRequire("aunq5");

var $9q93S = parcelRequire("9q93S");

var $7ClSO = parcelRequire("7ClSO");

var $fxtrV = parcelRequire("fxtrV");
var $12c82a3a21e87666$require$defineProperty = $fxtrV.f;
module.exports = function(name) {
    var $Symbol = $aunq5.Symbol || ($aunq5.Symbol = $9q93S ? {} : $pnVph.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $12c82a3a21e87666$require$defineProperty($Symbol, name, {
        value: $7ClSO.f(name)
    });
};

});

parcelRegister("d1OTP", function(module, exports) {
// all enumerable object keys, includes symbols

var $fmsEx = parcelRequire("fmsEx");

var $i3Fjk = parcelRequire("i3Fjk");

var $fbjf9 = parcelRequire("fbjf9");
module.exports = function(it) {
    var result = $fmsEx(it);
    var getSymbols = $i3Fjk.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $fbjf9.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});

parcelRegister("ky93M", function(module, exports) {
// 7.2.2 IsArray(argument)

var $cONIx = parcelRequire("cONIx");
module.exports = Array.isArray || function isArray(arg) {
    return $cONIx(arg) == 'Array';
};

});

parcelRegister("4YQr4", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $3a0570aae603589a$export$2d1720544b23b823; }, function (v) { return $3a0570aae603589a$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $3a0570aae603589a$export$2d1720544b23b823;

var $bSzJU = parcelRequire("bSzJU");

var $79buJ = parcelRequire("79buJ");
var $3a0570aae603589a$require$gOPN = $79buJ.f;
var $3a0570aae603589a$var$toString = {}.toString;
var $3a0570aae603589a$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $3a0570aae603589a$var$getWindowNames = function(it) {
    try {
        return $3a0570aae603589a$require$gOPN(it);
    } catch (e) {
        return $3a0570aae603589a$var$windowNames.slice();
    }
};
$3a0570aae603589a$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $3a0570aae603589a$var$windowNames && $3a0570aae603589a$var$toString.call(it) == '[object Window]' ? $3a0570aae603589a$var$getWindowNames(it) : $3a0570aae603589a$require$gOPN($bSzJU(it));
};

});
parcelRegister("79buJ", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $53424a41b87ed3aa$export$2d1720544b23b823; }, function (v) { return $53424a41b87ed3aa$export$2d1720544b23b823 = v; });
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $53424a41b87ed3aa$export$2d1720544b23b823;

var $g7Rv3 = parcelRequire("g7Rv3");

var $53424a41b87ed3aa$var$hiddenKeys = (parcelRequire("eeRfl")).concat('length', 'prototype');
$53424a41b87ed3aa$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $g7Rv3(O, $53424a41b87ed3aa$var$hiddenKeys);
};

});


parcelRegister("b6FJh", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $81609fd4f300f6f5$export$2d1720544b23b823; }, function (v) { return $81609fd4f300f6f5$export$2d1720544b23b823 = v; });
var $81609fd4f300f6f5$export$2d1720544b23b823;

var $fbjf9 = parcelRequire("fbjf9");

var $Gbehr = parcelRequire("Gbehr");

var $bSzJU = parcelRequire("bSzJU");

var $jfS6J = parcelRequire("jfS6J");

var $779TT = parcelRequire("779TT");

var $3EiA3 = parcelRequire("3EiA3");
var $81609fd4f300f6f5$var$gOPD = Object.getOwnPropertyDescriptor;

$81609fd4f300f6f5$export$2d1720544b23b823 = (parcelRequire("iUvfY")) ? $81609fd4f300f6f5$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $bSzJU(O);
    P = $jfS6J(P, true);
    if ($3EiA3) try {
        return $81609fd4f300f6f5$var$gOPD(O, P);
    } catch (e) {}
    if ($779TT(O, P)) return $Gbehr(!$fbjf9.f.call(O, P), O[P]);
};

});


parcelRegister("aghnC", function(module, exports) {

});

parcelRegister("6owPI", function(module, exports) {

(parcelRequire("1BYu8"))('asyncIterator');

});

parcelRegister("grJtS", function(module, exports) {

(parcelRequire("1BYu8"))('observable');

});


parcelRegister("elpuD", function(module, exports) {
parcelRequire("h4Ncr");

module.exports = (parcelRequire("aunq5")).Object.setPrototypeOf;

});
parcelRegister("h4Ncr", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $g45SR = parcelRequire("g45SR");

$g45SR($g45SR.S, 'Object', {
    setPrototypeOf: (parcelRequire("jEtjD")).set
});

});
parcelRegister("jEtjD", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $c8vg0 = parcelRequire("c8vg0");

var $gWOKW = parcelRequire("gWOKW");
var $e4e87e3fa1b0cb0a$var$check = function(O, proto) {
    $gWOKW(O);
    if (!$c8vg0(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("bMm8u"))(Function.call, (parcelRequire("b6FJh")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $e4e87e3fa1b0cb0a$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $e4e87e3fa1b0cb0a$var$check
};

});



parcelRegister("iWNxk", function(module, exports) {
parcelRequire("ewWHt");

var $aunq5 = parcelRequire("aunq5");
var $dcb411b02d87e671$require$$Object = $aunq5.Object;
module.exports = function create(P, D) {
    return $dcb411b02d87e671$require$$Object.create(P, D);
};

});
parcelRegister("ewWHt", function(module, exports) {

var $g45SR = parcelRequire("g45SR");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$g45SR($g45SR.S, 'Object', {
    create: (parcelRequire("ey75m"))
});

});


parcelRegister("2DQiR", function(module, exports) {
typeof navigator !== "undefined" && function(global, factory) {
    module.exports = factory();
}(this, function() {
    'use strict';
    var svgNS = 'http://www.w3.org/2000/svg';
    var locationHref = '';
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case 'int16':
                case 'uint8c':
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === 'float32') return new Float32Array(len);
            if (type === 'int16') return new Int16Array(len);
            if (type === 'uint8c') return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$6(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$6 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$6(obj);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = '';
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            'abs',
            'acos',
            'acosh',
            'asin',
            'asinh',
            'atan',
            'atanh',
            'atan2',
            'ceil',
            'cbrt',
            'expm1',
            'clz32',
            'cos',
            'cosh',
            'exp',
            'floor',
            'fround',
            'hypot',
            'imul',
            'log',
            'log1p',
            'log2',
            'log10',
            'max',
            'min',
            'pow',
            'random',
            'round',
            'sign',
            'sin',
            'sinh',
            'sqrt',
            'tan',
            'tanh',
            'trunc',
            'E',
            'LN10',
            'LN2',
            'LOG10E',
            'LOG2E',
            'PI',
            'SQRT1_2',
            'SQRT2'
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$6(val);
        if (tOfVal === 'object' && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = 'absolute';
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = 'block';
        element.style.transformOrigin = '0 0';
        element.style.webkitTransformOrigin = '0 0';
        element.style.backfaceVisibility = 'visible';
        element.style.webkitBackfaceVisibility = 'visible';
        element.style.transformStyle = 'preserve-3d';
        element.style.webkitTransformStyle = 'preserve-3d';
        element.style.mozTransformStyle = 'preserve-3d';
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = 'renderFrameError';
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = 'configError';
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + '__lottie_element_' + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? '0' + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return '#' + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$5(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$5 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$5(obj);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    'var _workerSelf = self; self.onmessage = ',
                    fn.toString()
                ], {
                    type: 'text/javascript'
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ('ks' in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === 'sh') {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === 'gr') completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split('.') : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: 'no'
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: 'tr'
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === 'number') pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === 'number') pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === 'number') pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === 'gr') iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === 'sh') {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === 'gr') completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader('content-type');
                            if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) return xhr.response;
                            if (xhr.response && _typeof$5(xhr.response) === 'object') return xhr.response;
                            if (xhr.response && typeof xhr.response === 'string') return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = 'json';
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), fullPath + '/' + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === 'loadAnimation') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                    else if (e.data.type === 'complete') {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: 'success'
                        });
                    } else if (e.data.type === 'loadData') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === 'success') process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = 'processId_' + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadAnimation',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadData',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'complete',
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(0,0,0,0)';
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = '';
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : '';
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS('image');
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag('img');
            img.crossOrigin = 'anonymous';
            img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === 'seq') {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || '';
        }
        function setAssetsPath(path) {
            this.assetsPath = path || '';
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === 'svg') {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = '';
            this.path = '';
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split('\r\n');
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(':');
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return 'canvas';
         // Returns any renderer that is registered
        for(var key in renderers){
            if (renderers[key]) return key;
        }
        return '';
    }
    function _typeof$4(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$4 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$4(obj);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = '';
        this.path = '';
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = '';
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = 'svg';
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = 'autoplay' in params ? params.autoplay : true;
        this.name = params.name ? params.name : '';
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf('\\') !== -1) this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger('data_failed');
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$4(animationData) !== 'object') animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
        params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
        var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
        if (loop === 'false') params.loop = false;
        else if (loop === 'true') params.loop = true;
        else if (loop !== '') params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
        params.autoplay = autoplay !== 'false';
        params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
        var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
        if (prerender === 'false') params.prerender = false;
        if (!params.path) this.trigger('destroy');
        else this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger('data_ready');
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger('data_failed');
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger('loaded_images');
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger('config_ready');
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger('DOMLoaded');
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === 'number' ? width : undefined;
        var _height = typeof height === 'number' ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger('enterFrame');
        this.renderFrame();
        this.trigger('drawnFrame');
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger('_play');
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger('_active');
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger('_pause');
            this._idle = true;
            this.trigger('_idle');
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger('loopComplete');
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger('loopComplete');
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger('complete');
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger('segmentStart');
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$4(arr[0]) === 'object') {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger('destroy');
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = '';
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {}
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case 'enterFrame':
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case 'drawnFrame':
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case 'loopComplete':
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === 'enterFrame' && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === 'loopComplete' && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === 'complete' && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === 'segmentStart' && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === 'destroy' && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener('destroy', removeElement);
            animItem.addEventListener('_active', addPlayingCount);
            animItem.addEventListener('_idle', subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute('data-bm-type', renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = 'svg';
                var body = document.getElementsByTagName('body')[0];
                body.innerText = '';
                var div = createTag('div');
                div.style.width = '100%';
                div.style.height = '100%';
                div.setAttribute('data-bm-type', renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize; // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === 'function';
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample; // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray('float32', getDefaultCurveSegments()),
                lengths: createTypedArray('float32', getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray('float32', 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0; //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1; //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1; //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === 'multidimensional') newValue = createTypedArray('float32', this.pv.length);
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i + 1];
            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                if (keyData.h) keyData = nextKeyData;
                iterationIndex = 0;
                break;
            }
            if (nextKeyData.t - offsetTime > frameNum) {
                iterationIndex = i;
                break;
            }
            if (i < len - 1) i += 1;
            else {
                iterationIndex = 0;
                flag = false;
            }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
            if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
            var bezierData = keyframeMetadata.bezierData;
            if (frameNum >= nextKeyTime || frameNum < keyTime) {
                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
                 // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                else {
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                var distanceInLine = bezierData.segmentLength * perc;
                var segmentPerc;
                var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength += bezierData.points[j].partialLength;
                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        break;
                    }
                    if (j < jLen - 1) j += 1;
                    else flag = false;
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastKeyframeIndex = i;
            }
        } else {
            var outX;
            var outY;
            var inX;
            var inY;
            var keyValue;
            len = keyData.s.length;
            endValue = nextKeyData.s || keyData.e;
            if (this.sh && keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                    newValue[0] = endValue[0];
                    newValue[1] = endValue[1];
                    newValue[2] = endValue[2];
                } else if (frameNum <= keyTime) {
                    newValue[0] = keyData.s[0];
                    newValue[1] = keyData.s[1];
                    newValue[2] = keyData.s[2];
                } else {
                    var quatStart = createQuaternion(keyData.s);
                    var quatEnd = createQuaternion(endValue);
                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                }
            } else for(i = 0; i < len; i += 1){
                if (keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) perc = 1;
                    else if (frameNum < keyTime) perc = 0;
                    else {
                        if (keyData.o.x.constructor === Array) {
                            if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                            if (!keyframeMetadata.__fnct[i]) {
                                outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyframeMetadata.__fnct[i] = fnc;
                            } else fnc = keyframeMetadata.__fnct[i];
                        } else if (!keyframeMetadata.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                            fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyData.keyframeMetadata = fnc;
                        } else fnc = keyframeMetadata.__fnct;
                        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    }
                }
                endValue = nextKeyData.s || keyData.e;
                keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                if (this.propType === 'multidimensional') newValue[i] = keyValue;
                else newValue = keyValue;
            }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
    } // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a, b, t) {
        var out = [];
        var ax = a[0];
        var ay = a[1];
        var az = a[2];
        var aw = a[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if (1.0 - cosom > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
    }
    function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x = s1 * s2 * c3 + c1 * c2 * s3;
        var y = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [
            x,
            y,
            z,
            w
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
            if (this._caching.lastFrame >= frameNum) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult = this.interpolateValue(frameNum, this._caching);
            this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function setVValue(val) {
        var multipliedValue;
        if (this.propType === 'unidimensional') {
            multipliedValue = val * this.mult;
            if (mathAbs(this.v - multipliedValue) > 0.00001) {
                this.v = multipliedValue;
                this._mdf = true;
            }
        } else {
            var i = 0;
            var len = this.v.length;
            while(i < len){
                multipliedValue = val[i] * this.mult;
                if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                    this.v[i] = multipliedValue;
                    this._mdf = true;
                }
                i += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.mult = mult || 1;
        this.data = data;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        this.mult = mult || 1;
        this.data = data;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data.k.length;
        this.v = createTypedArray('float32', len);
        this.pv = createTypedArray('float32', len);
        this.vel = createTypedArray('float32', len);
        for(i = 0; i < len; i += 1){
            this.v[i] = data.k[i] * this.mult;
            this.pv[i] = data.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        var i;
        var len = data.k.length;
        var s;
        var e;
        var to;
        var ti;
        for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
            s = data.k[i].s;
            e = data.k[i + 1].s;
            to = data.k[i].to;
            ti = data.k[i].ti;
            if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
            if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data;
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data.k[0].s.length;
        this.v = createTypedArray('float32', arrLen);
        this.pv = createTypedArray('float32', arrLen);
        for(i = 0; i < arrLen; i += 1){
            this.v[i] = initFrame;
            this.pv[i] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray('float32', arrLen)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp(elem, data, type, mult, container) {
            if (data.sid) data = elem.globalData.slotManager.getProp(data);
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === 'number') p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray('float32', 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case 'v':
                arr = this.v;
                break;
            case 'i':
                arr = this.i;
                break;
            case 'o':
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, 'v', pos, replace);
        this.setXYAt(oX, oY, 'o', pos, replace);
        this.setXYAt(iX, iY, 'i', pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2; // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function multiply(matrix) {
            var matrixProps = matrix.props;
            return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray('float32', 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + ',' + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = 'matrix3d(';
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ')' : ',';
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.multiply = multiply;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray('float32', 16);
            this.reset();
        };
    }();
    function _typeof$3(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$3 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$3(obj);
    }
    var lottie = {};
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === 'string') switch(value){
            case 'high':
                setDefaultCurveSegments(200);
                break;
            default:
            case 'medium':
                setDefaultCurveSegments(50);
                break;
            case 'low':
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== 'undefined';
    }
    function installPlugin(type, plugin) {
        if (type === 'expressions') setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case 'propertyFactory':
                return PropertyFactory;
            case 'shapePropertyFactory':
                return ShapePropertyFactory;
            case 'matrix':
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = '5.12.2';
    function checkReady() {
        if (document.readyState === 'complete') {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split('&');
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = '';
    if (standalone) {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ''
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === 'object' && true) && !(typeof define === 'function' && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
        shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
        shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], 'o', pos);
        shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], 'v', pos);
        shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = 'transform';
            this.data = data;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === 'gr') this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === 'gr') this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: 'gr'
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: 'Transform',
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: 'tr'
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies; /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c; // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a); // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a); // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        } // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0]; // Bevel
        if (lineJoin === 3) return p0; // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0; // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        } // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
        var fWeight = 'normal';
        var fStyle = 'normal';
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case 'italic':
                    fStyle = 'italic';
                    break;
                case 'bold':
                    fWeight = '700';
                    break;
                case 'black':
                    fWeight = '900';
                    break;
                case 'medium':
                    fWeight = '500';
                    break;
                case 'regular':
                case 'normal':
                    fWeight = '400';
                    break;
                case 'light':
                case 'thin':
                    fWeight = '200';
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = []; // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = [
            'd83cdffb',
            'd83cdffc',
            'd83cdffd',
            'd83cdffe',
            'd83cdfff'
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(',');
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(',');
        }
        function setUpNode(font, family) {
            var parentNode = createTag('span'); // Node is invisible to screen readers.
            parentNode.setAttribute('aria-hidden', true);
            parentNode.style.fontFamily = family;
            var node = createTag('span'); // Characters that vary significantly among different fonts
            node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen
            parentNode.style.position = 'absolute';
            parentNode.style.left = '-10000px';
            parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = '300px'; // Reset any font properties
            parentNode.style.fontVariant = 'normal';
            parentNode.style.fontStyle = 'normal';
            parentNode.style.fontWeight = 'normal';
            parentNode.style.letterSpacing = '0';
            parentNode.appendChild(node);
            document.body.appendChild(parentNode); // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ', ' + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? 'svg' : 'canvas';
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === 'svg') {
                var tHelper = createNS('text');
                tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute('font-family', fontData.fFamily);
                tHelper.setAttribute('font-style', fontProps.style);
                tHelper.setAttribute('font-weight', fontProps.weight);
                tHelper.textContent = '1';
                if (fontData.fClass) {
                    tHelper.style.fontFamily = 'inherit';
                    tHelper.setAttribute('class', fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
                tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === 'svg') {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag('style');
                        s.setAttribute('f-forigin', fontArr[i].fOrigin);
                        s.setAttribute('f-origin', fontArr[i].origin);
                        s.setAttribute('f-family', fontArr[i].fFamily);
                        s.type = 'text/css';
                        s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag('link');
                        l.setAttribute('f-forigin', fontArr[i].fOrigin);
                        l.setAttribute('f-origin', fontArr[i].origin);
                        l.type = 'text/css';
                        l.rel = 'stylesheet';
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag('link');
                        sc.setAttribute('f-forigin', fontArr[i].fOrigin);
                        sc.setAttribute('f-origin', fontArr[i].origin);
                        sc.setAttribute('rel', 'stylesheet');
                        sc.setAttribute('href', fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index = _char2;
            if (!fontData.cache[index]) {
                var tHelper = fontData.helper;
                if (_char2 === ' ') {
                    var doubleSize = tHelper.measureText('|' + _char2 + '|');
                    var singleSize = tHelper.measureText('||');
                    fontData.cache[index] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint(string) {
            var codePoint = 0;
            var first = string.charCodeAt(0);
            if (first >= 0xD800 && first <= 0xDBFF) {
                var second = string.charCodeAt(1);
                if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
            return codePoint;
        } // Skin tone modifiers
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
            return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        } // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector(charCode) {
            return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        } // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode(string) {
            var codePoint = getCodePoint(string);
            if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
            return false;
        } // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji(string) {
            return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        } // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag(text, index) {
            var codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
            var count = 0;
            index += 2;
            while(count < 5){
                codePoint = getCodePoint(text.substr(index, 2));
                if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
                count += 1;
                index += 2;
            }
            return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function SlotManager(animationData) {
        this.animationData = animationData;
    }
    SlotManager.prototype.getProp = function(data) {
        if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
        return data;
    };
    function slotFactory(animationData) {
        return new SlotManager(animationData);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: 'source-over',
            1: 'multiply',
            2: 'screen',
            3: 'overlay',
            4: 'darken',
            5: 'lighten',
            6: 'color-dodge',
            7: 'color-burn',
            8: 'hard-light',
            9: 'soft-light',
            10: 'difference',
            11: 'exclusion',
            12: 'hue',
            13: 'saturation',
            14: 'color',
            15: 'luminosity'
        };
        return function(mode) {
            return blendModeEnums[mode] || '';
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces('layer');
            var EffectsExpressionInterface = expressionsInterfaces('effects');
            var ShapeExpressionInterface = expressionsInterfaces('shape');
            var TextExpressionInterface = expressionsInterfaces('text');
            var CompExpressionInterface = expressionsInterfaces('comp');
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style['mix-blend-mode'] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces('footage');
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error('You\'re using a 3d camera. Try the html renderer.');
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1){
            if (this.elements[i].data.ind === ind) return this.elements[i];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === 'number') element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: 'transformEFfect'
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            var mat = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat,
                localMat: mat,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
                }
            }
            if (this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform() {
            if (this.localTransforms) {
                var i = 0;
                var len = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                    if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat);
                    for(i = 1; i < len; i += 1){
                        var lmat = this.localTransforms[i].matrix;
                        localMat.multiply(lmat);
                    }
                    localMat.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp = this.finalTransform.localOpacity;
                    for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms() {
            if (this.renderableEffectsManager) {
                var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i = 0;
                    var len = transformEffects.length;
                    for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = '';
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = 'clipPath';
        var maskRef = 'clip-path';
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = 'mask';
                maskRef = 'mask';
            }
            if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
                rect = createNS('rect');
                rect.setAttribute('fill', '#ffffff');
                rect.setAttribute('width', this.element.comp.data.w || 0);
                rect.setAttribute('height', this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS('path');
            if (properties[i].mode === 'n') {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ''
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
                path.setAttribute('clip-rule', 'nonzero');
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = 'mask';
                    maskRef = 'mask';
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS('filter');
                    expansor.setAttribute('id', filterID);
                    feMorph = createNS('feMorphology');
                    feMorph.setAttribute('operator', 'erode');
                    feMorph.setAttribute('in', 'SourceGraphic');
                    feMorph.setAttribute('radius', '0');
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
                } else {
                    feMorph = null;
                    x = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: '',
                    lastOperator: '',
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === 'i') {
                    jLen = currentMasks.length;
                    var g = createNS('g');
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS('mask');
                    mask.setAttribute('mask-type', 'alpha');
                    mask.setAttribute('id', layerId + '_' + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: '',
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute('id', layerId);
            this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== 'n') {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== 'erode') {
                            this.storedData[i].lastOperator = 'erode';
                            this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
                        }
                        feMorph.setAttribute('radius', -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== 'dilate') {
                            this.storedData[i].lastOperator = 'dilate';
                            this.storedData[i].elem.setAttribute('filter', null);
                        }
                        this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = 'M0,0 ';
        path += ' h' + this.globalData.compSize.w;
        path += ' v' + this.globalData.compSize.h;
        path += ' h-' + this.globalData.compSize.w;
        path += ' v-' + this.globalData.compSize.h + ' ';
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = '';
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute('d', pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS('filter');
            fil.setAttribute('id', filId);
            if (skipCoordinates !== true) {
                fil.setAttribute('filterUnits', 'objectBoundingBox');
                fil.setAttribute('x', '0%');
                fil.setAttribute('y', '0%');
                fil.setAttribute('width', '100%');
                fil.setAttribute('height', '100%');
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS('feColorMatrix');
            feColorMatrix.setAttribute('type', 'matrix');
            feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
            feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
        return ob;
    }();
    var registeredEffects$1 = {};
    var idPrefix = 'filter_result_';
    function SVGEffects(elem) {
        var i;
        var source = 'SourceGraphic';
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects$1[type]) {
                var Effect = registeredEffects$1[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects$1[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect$1(id, effect, countsAsEffect) {
        registeredEffects$1[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS('g');
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS('g');
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg = createNS('g');
                gg.setAttribute('id', this.layerId);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                this.globalData.defs.appendChild(gg);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS('clipPath');
                var pt = createNS('path');
                pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
                var clipId = createElementID();
                cp.setAttribute('id', clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS('g');
                    cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + '_' + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS('mask');
                    masker.setAttribute('id', id);
                    masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute('mask-type', 'luminance');
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS('mask');
                    maskGroup.setAttribute('id', id);
                    maskGroup.setAttribute('mask-type', 'alpha');
                    var maskGrouper = createNS('g');
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId); /// /
                    var feCTr = createNS('feComponentTransfer');
                    feCTr.setAttribute('in', 'SourceGraphic');
                    fil.appendChild(feCTr);
                    var feFunc = createNS('feFuncA');
                    feFunc.setAttribute('type', 'table');
                    feFunc.setAttribute('tableValues', '1.0 0.0');
                    feCTr.appendChild(feFunc); /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS('rect');
                    alphaRect.setAttribute('width', this.comp.data.w);
                    alphaRect.setAttribute('height', this.comp.data.h);
                    alphaRect.setAttribute('x', '0');
                    alphaRect.setAttribute('y', '0');
                    alphaRect.setAttribute('fill', '#ffffff');
                    alphaRect.setAttribute('opacity', '0');
                    maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute('mask-type', 'luminance');
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = 'none';
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = 'block';
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS('image');
        this.innerElem.setAttribute('width', this.assetData.w + 'px');
        this.innerElem.setAttribute('height', this.assetData.h + 'px');
        this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: 'butt',
        2: 'round',
        3: 'square'
    };
    var lineJoinEnum = {
        1: 'miter',
        2: 'round',
        3: 'bevel'
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = '';
        this.sh = shape;
        this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = '';
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS('path');
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = '';
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = '';
        this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray('float32', 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === 'svg') this.dashStr = '';
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== 'o') {
                if (this.renderer === 'svg') this.dashStr += ' ' + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray('uint8c', data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray('float32', cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
        gfill.setAttribute('id', gradientId);
        gfill.setAttribute('spreadMethod', 'pad');
        gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS('stop');
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS('mask');
            var maskElement = createNS('path');
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute('id', maskId);
            var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
            opFill.setAttribute('id', opacityId);
            opFill.setAttribute('spreadMethod', 'pad');
            opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS('stop');
                stop.setAttribute('stop-color', 'rgb(255,255,255)');
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
            if (data.ty === 'gs') {
                maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
                maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute('stroke-miterlimit', data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS('g');
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return '';
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += 'z';
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case 'fl':
                    return renderFill;
                case 'gf':
                    return renderGradient;
                case 'gs':
                    return renderGradientStroke;
                case 'st':
                    return renderStroke;
                case 'sh':
                case 'el':
                case 'rc':
                case 'sr':
                    return renderPath;
                case 'tr':
                    return renderContentTransform;
                case 'no':
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            mat.multiply(itemData.transformers[k].mProps.v);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = '';
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? 'x1' : 'cx';
                var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute('offset', cValues[i * 4] + '%');
                    stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute('offset', oValues[i * 2] + '%');
                    stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute('x2', pt2[0]);
                    gfill.setAttribute('y2', pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('x2', pt2[0]);
                        itemData.of.setAttribute('y2', pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute('r', rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute('r', rad);
                }
                if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute('fx', x);
                    gfill.setAttribute('fy', y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('fx', x);
                        itemData.of.setAttribute('fy', y);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
                styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === 'st') elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === 'fl') elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === 'gf' || data.ty === 'gs') {
            var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
            }
        } else if (data.ty === 'no') elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === 'st' || data.ty === 'gs') {
            pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
            pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute('fill-opacity', '0');
            if (data.lj === 1) pathElement.setAttribute('stroke-miterlimit', data.ml);
        }
        if (data.r === 2) pathElement.setAttribute('fill-rule', 'evenodd');
        if (data.ln) pathElement.setAttribute('id', data.ln);
        if (data.cl) pathElement.setAttribute('class', data.cl);
        if (data.bm) pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute('id', data.ln);
        if (data.cl) elementData.gr.setAttribute('class', data.cl);
        if (data.bm) elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (!this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = false;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = '';
        this.v = '';
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: '',
            fStyle: '',
            fWeight: '',
            fc: '',
            j: '',
            justifyOffset: '',
            l: [],
            lh: 0,
            lineWidths: [],
            ls: '',
            of: '',
            s: '',
            sc: '',
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = '';
        while(i < len){
            shouldCombine = shouldCombineNext;
            shouldCombineNext = false;
            charCode = text.charCodeAt(i);
            currentChars = text.charAt(i);
            if (FontManager.isCombinedCharacter(charCode)) shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
                else {
                    secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                        if (FontManager.isModifier(charCode, secondCharCode)) {
                            currentChars = text.substr(i, 2);
                            shouldCombine = true;
                        } else if (FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                        else currentChars = text.substr(i, 2);
                    }
                }
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isVariationSelector(charCode)) shouldCombine = true;
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                shouldCombine = true;
                shouldCombineNext = true;
            }
            if (shouldCombine) {
                charactersArray[charactersArray.length - 1] += currentChars;
                shouldCombine = false;
            } else charactersArray.push(currentChars);
            i += currentChars.length;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === ' ') lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = '';
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
             //
            if (currentChar === ' ') uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || val === ' ' || i === len - 1) {
                    if (val === '' || val === ' ') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || i === len - 1) {
                    if (val === '') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ('e' in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && 'm' in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = '';
        var letterP = this.defaultPropsArray;
        var letterO; //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        } //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = '';
                letterFc = '';
                letterSw = '';
                letterO = '';
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0); // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
                if (documentData.fillColorAnim && documentData.fc) letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === 'html') letterM = matrixHelper.toCSS();
                else if (renderType === 'svg') letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = '';
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = 'svg';
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS('text');
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = '';
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = '';
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
        else this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
        if (documentData.sc) {
            this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
            this.layerElement.setAttribute('stroke-width', documentData.sw);
        }
        this.layerElement.setAttribute('font-size', documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute('class', fontData.fClass);
        else {
            this.layerElement.setAttribute('font-family', fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute('font-style', fStyle);
            this.layerElement.setAttribute('font-weight', fWeight);
        }
        this.layerElement.setAttribute('aria-label', documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = '';
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = 'start';
            switch(documentData.j){
                case 1:
                    justify = 'end';
                    break;
                case 2:
                    justify = 'middle';
                    break;
                default:
                    justify = 'start';
                    break;
            }
            tElement.setAttribute('text-anchor', justify);
            tElement.setAttribute('letter-spacing', trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS('tspan');
                tSpan.textContent = textContent[i];
                tSpan.setAttribute('x', 0);
                tSpan.setAttribute('y', yPos);
                tSpan.style.display = 'inherit';
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute('stroke-linecap', 'butt');
                        tSpan.setAttribute('stroke-linejoin', 'round');
                        tSpan.setAttribute('stroke-miterlimit', '4');
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS('g');
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = 'inherit';
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement; // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
                } else {
                    if (singleShape) tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                } //
            }
            if (singleShape && tSpan) tSpan.setAttribute('d', shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = 'none';
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute('transform', renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute('opacity', renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute('stroke-width', renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute('stroke', renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute('fill', renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute('width', this.data.sw);
        rect.setAttribute('height', this.data.sh);
        rect.setAttribute('fill', this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute('width', animData.w);
            this.svgElement.setAttribute('height', animData.h);
            this.svgElement.style.width = '100%';
            this.svgElement.style.height = '100%';
            this.svgElement.style.transform = 'translate3d(0,0,0)';
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute('width', this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute('height', this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute('class', this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute('id', this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
        this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS('clipPath');
        var rect = createNS('rect');
        rect.setAttribute('width', animData.w);
        rect.setAttribute('height', animData.h);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', 0);
        var maskId = createElementID();
        maskElement.setAttribute('id', maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = 'none';
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = 'block';
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS('svg');
        var ariaLabel = '';
        if (config && config.title) {
            var titleElement = createNS('title');
            var titleId = createElementID();
            titleElement.setAttribute('id', titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS('desc');
            var descId = createElementID();
            descElement.setAttribute('id', descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += ' ' + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute('aria-labelledby', ariaLabel);
        var defs = createNS('defs');
        this.svgElement.appendChild(defs);
        var maskElement = createNS('g');
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || '',
            id: config && config.id || '',
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '100%',
                height: config && config.filterSize && config.filterSize.height || '100%',
                x: config && config.filterSize && config.filterSize.x || '0%',
                y: config && config.filterSize && config.filterSize.y || '0%'
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = 'svg';
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence(transforms) {
            var i;
            var len = transforms.length;
            var key = '_';
            for(i = 0; i < len; i += 1)key += transforms[i].transform.key + '_';
            var sequence = this.sequences[key];
            if (!sequence) {
                sequence = {
                    transforms: [].concat(transforms),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key] = sequence;
                this.sequenceList.push(sequence);
            }
            return sequence;
        },
        processSequence: function processSequence(sequence, isFirstFrame) {
            var i = 0;
            var len = sequence.transforms.length;
            var _mdf = isFirstFrame;
            while(i < len && !isFirstFrame){
                if (sequence.transforms[i].transform.mProps._mdf) {
                    _mdf = true;
                    break;
                }
                i += 1;
            }
            if (_mdf) {
                sequence.finalTransform.reset();
                for(i = len - 1; i >= 0; i -= 1)sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
            }
            sequence._mdf = _mdf;
        },
        processSequences: function processSequences(isFirstFrame) {
            var i;
            var len = this.sequenceList.length;
            for(i = 0; i < len; i += 1)this.processSequence(this.sequenceList[i], isFirstFrame);
        },
        getNewKey: function getNewKey() {
            this.transform_key_count += 1;
            return '_' + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader() {
        var id = '__lottie_element_luma_buffer';
        var lumaBuffer = null;
        var lumaBufferCtx = null;
        var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter() {
            var _svg = createNS('svg');
            var fil = createNS('filter');
            var matrix = createNS('feColorMatrix');
            fil.setAttribute('id', id);
            matrix.setAttribute('type', 'matrix');
            matrix.setAttribute('color-interpolation-filters', 'sRGB');
            matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
            fil.appendChild(matrix);
            _svg.appendChild(fil);
            _svg.setAttribute('id', id + '_svg');
            if (featureSupport.svgLumaHidden) _svg.style.display = 'none';
            return _svg;
        }
        function loadLuma() {
            if (!lumaBuffer) {
                svg = createLumaSvgFilter();
                document.body.appendChild(svg);
                lumaBuffer = createTag('canvas');
                lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx.filter = 'url(#' + id + ')';
                lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
                lumaBufferCtx.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma(canvas) {
            if (!lumaBuffer) loadLuma();
            lumaBuffer.width = canvas.width;
            lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx.filter = 'url(#' + id + ')';
            return lumaBuffer;
        }
        return {
            load: loadLuma,
            get: getLuma
        };
    };
    function createCanvas(width, height) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width, height);
        var canvas = createTag('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem) {
        var i;
        var len = elem.data.ef ? elem.data.ef.length : 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    CVEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect(id, effect) {
        registeredEffects[id] = {
            effect: effect
        };
    }
    function CVMaskElement(data, element) {
        this.data = data;
        this.element = element;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i;
        var len = this.masksProperties.length;
        var hasMasks = false;
        for(i = 0; i < len; i += 1){
            if (this.masksProperties[i].mode !== 'n') hasMasks = true;
            this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
        }
        this.hasMasks = hasMasks;
        if (hasMasks) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform = this.element.finalTransform.mat;
        var ctx = this.element.canvasContext;
        var i;
        var len = this.masksProperties.length;
        var pt;
        var pts;
        var data;
        ctx.beginPath();
        for(i = 0; i < len; i += 1)if (this.masksProperties[i].mode !== 'n') {
            if (this.masksProperties[i].inv) {
                ctx.moveTo(0, 0);
                ctx.lineTo(this.element.globalData.compSize.w, 0);
                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx.lineTo(0, this.element.globalData.compSize.h);
                ctx.lineTo(0, 0);
            }
            data = this.viewData[i].v;
            pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
            ctx.moveTo(pt[0], pt[1]);
            var j;
            var jLen = data._length;
            for(j = 1; j < jLen; j += 1){
                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
            }
            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: 'source-in',
        2: 'source-out',
        3: 'source-in',
        4: 'source-out'
    };
    CVBaseElement.prototype = {
        createElements: function createElements() {},
        initRendererElement: function initRendererElement() {},
        createContainerElements: function createContainerElements() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext = this.globalData.canvasContext;
                var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas);
                var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas2);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent() {},
        setBlendMode: function setBlendMode() {
            var globalData = this.globalData;
            if (globalData.blendMode !== this.data.bm) {
                globalData.blendMode = this.data.bm;
                var blendModeValue = getBlendMode(this.data.bm);
                globalData.canvasContext.globalCompositeOperation = blendModeValue;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas(canvasContext) {
            canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[0];
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx);
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform); // We draw the mask
                var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
                mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx = lumaBuffer.getContext('2d');
                    lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = 'destination-over';
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = 'source-over';
            }
        },
        renderFrame: function renderFrame(forceRender) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element, data, styles, transformsManager) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
        var i;
        var len = styles.length;
        var styledShape;
        for(i = 0; i < len; i += 1)if (!styles[i].closed) {
            styledShape = {
                transforms: transformsManager.addTransformSequence(styles[i].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape);
            styles[i].elements.push(styledShape);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data, globalData, comp) {
        this.shapes = [];
        this.shapesData = data.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data, transforms) {
        var styleElem = {
            data: data,
            type: data.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms),
            transforms: [],
            elements: [],
            closed: data.hd === true
        };
        var elementData = {};
        if (data.ty === 'fl' || data.ty === 'st') {
            elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
            if (!elementData.c.k) styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
        } else if (data.ty === 'gf' || data.ty === 'gs') {
            elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
            elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
            elementData.h = PropertyFactory.getProp(this, data.h || {
                k: 0
            }, 0, 0.01, this);
            elementData.a = PropertyFactory.getProp(this, data.a || {
                k: 0
            }, 0, degToRads, this);
            elementData.g = new GradientProperty(this, data.g, this);
        }
        elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
        if (data.ty === 'st' || data.ty === 'gs') {
            styleElem.lc = lineCapEnum[data.lc || 2];
            styleElem.lj = lineJoinEnum[data.lj || 2];
            if (data.lj == 1) // eslint-disable-line eqeqeq
            styleElem.ml = data.ml;
            elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
            if (!elementData.w.k) styleElem.wi = elementData.w.v;
            if (data.d) {
                var d = new DashProperty(this, data.d, 'canvas', this);
                elementData.d = d;
                if (!elementData.d.k) {
                    styleElem.da = elementData.d.dashArray;
                    styleElem["do"] = elementData.d.dashoffset[0];
                }
            }
        } else styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
        this.stylesList.push(styleElem);
        elementData.style = styleElem;
        return elementData;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData = {
            it: [],
            prevViewData: []
        };
        return elementData;
    };
    CVShapeElement.prototype.createTransformElement = function(data) {
        var elementData = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
            }
        };
        return elementData;
    };
    CVShapeElement.prototype.createShapeElement = function(data) {
        var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        return elementData;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform) {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.push(transform);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles) {
        var i;
        var len = styles.length;
        for(i = 0; i < len; i += 1)styles[i].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, shouldRender, transforms) {
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var processedPos;
        var modifier;
        var currentTransform;
        var ownTransforms = [].concat(transforms);
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._shouldRender = shouldRender;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
                else itemsData[i].style.closed = false;
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) {
                    currentTransform = this.createTransformElement(arr[i]);
                    itemsData[i] = currentTransform;
                }
                ownTransforms.push(itemsData[i]);
                this.addTransformToStyleList(itemsData[i]);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    shouldRender = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles);
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
        if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
            groupTransform.opacity = parentTransform.opacity;
            groupTransform.opacity *= groupTransform.op.v;
            groupTransform._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i;
        var len = this.stylesList.length;
        var j;
        var jLen;
        var k;
        var kLen;
        var elems;
        var nodes;
        var renderer = this.globalData.renderer;
        var ctx = this.globalData.canvasContext;
        var type;
        var currentStyle;
        for(i = 0; i < len; i += 1){
            currentStyle = this.stylesList[i];
            type = currentStyle.type; // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer.save();
                elems = currentStyle.elements;
                if (type === 'st' || type === 'gs') {
                    renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
                    renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;
                    renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;
                    renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;
                    renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
                } else renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
                renderer.ctxOpacity(currentStyle.coOp);
                if (type !== 'st' && type !== 'gs') ctx.beginPath();
                renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
                jLen = elems.length;
                for(j = 0; j < jLen; j += 1){
                    if (type === 'st' || type === 'gs') {
                        ctx.beginPath();
                        if (currentStyle.da) {
                            ctx.setLineDash(currentStyle.da);
                            ctx.lineDashOffset = currentStyle["do"];
                        }
                    }
                    nodes = elems[j].trNodes;
                    kLen = nodes.length;
                    for(k = 0; k < kLen; k += 1){
                        if (nodes[k].t === 'm') ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
                        else if (nodes[k].t === 'c') ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
                        else ctx.closePath();
                    }
                    if (type === 'st' || type === 'gs') {
                        // ctx.stroke();
                        renderer.ctxStroke();
                        if (currentStyle.da) ctx.setLineDash(this.dashResetter);
                    }
                }
                if (type !== 'st' && type !== 'gs') // ctx.fill(currentStyle.r);
                this.globalData.renderer.ctxFill(currentStyle.r);
                renderer.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform, items, data, isMain) {
        var i;
        var len = items.length - 1;
        var groupTransform;
        groupTransform = parentTransform;
        for(i = len; i >= 0; i -= 1){
            if (items[i].ty === 'tr') {
                groupTransform = data[i].transform;
                this.renderShapeTransform(parentTransform, groupTransform);
            } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') this.renderPath(items[i], data[i]);
            else if (items[i].ty === 'fl') this.renderFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'st') this.renderStroke(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gf' || items[i].ty === 'gs') this.renderGradientFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gr') this.renderShape(groupTransform, items[i].it, data[i].it);
            else items[i].ty;
        }
        if (isMain) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape, shape) {
        if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
            var shapeNodes = styledShape.trNodes;
            var paths = shape.paths;
            var i;
            var len;
            var j;
            var jLen = paths._length;
            shapeNodes.length = 0;
            var groupTransformMat = styledShape.transforms.finalTransform;
            for(j = 0; j < jLen; j += 1){
                var pathNodes = paths.shapes[j];
                if (pathNodes && pathNodes.v) {
                    len = pathNodes._length;
                    for(i = 1; i < len; i += 1){
                        if (i === 1) shapeNodes.push({
                            t: 'm',
                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
                        });
                    }
                    if (len === 1) shapeNodes.push({
                        t: 'm',
                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    if (pathNodes.c && len) {
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
                        });
                        shapeNodes.push({
                            t: 'z'
                        });
                    }
                }
            }
            styledShape.trNodes = shapeNodes;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData, itemData) {
        if (pathData.hd !== true && pathData._shouldRender) {
            var i;
            var len = itemData.styledShapes.length;
            for(i = 0; i < len; i += 1)this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var grd;
        if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
            var ctx = this.globalData.canvasContext;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (styleData.t === 1) grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
            else {
                var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                var percent = itemData.h.v;
                if (percent >= 1) percent = 0.99;
                else if (percent <= -1) percent = -0.99;
                var dist = rad * percent;
                var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
            }
            var i;
            var len = styleData.g.p;
            var cValues = itemData.g.c;
            var opacity = 1;
            for(i = 0; i < len; i += 1){
                if (itemData.g._hasOpacity && itemData.g._collapsable) opacity = itemData.g.o[i * 2 + 1];
                grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
            }
            styleElem.grd = grd;
        }
        styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || this._isFirstFrame)) {
            styleElem.da = d.dashArray;
            styleElem["do"] = d.dashoffset[0];
        }
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
        if (itemData.w._mdf || this._isFirstFrame) styleElem.wi = itemData.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = 'canvas';
        this.values = {
            fill: 'rgba(0,0,0,0)',
            stroke: 'rgba(0,0,0,0)',
            sWidth: 0,
            fValue: ''
        };
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
    CVTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var hasFill = false;
        if (documentData.fc) {
            hasFill = true;
            this.values.fill = this.buildColor(documentData.fc);
        } else this.values.fill = 'rgba(0,0,0,0)';
        this.fill = hasFill;
        var hasStroke = false;
        if (documentData.sc) {
            hasStroke = true;
            this.values.stroke = this.buildColor(documentData.sc);
            this.values.sWidth = documentData.sw;
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        var i;
        var len;
        var letters = documentData.l;
        var matrixHelper = this.mHelper;
        this.stroke = hasStroke;
        this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
        len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;
        var charData;
        var shapeData;
        var k;
        var kLen;
        var shapes;
        var j;
        var jLen;
        var pathNodes;
        var commands;
        var pathArr;
        var singleShape = this.data.singleShape;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            shapeData = charData && charData.data || {};
            matrixHelper.reset();
            if (singleShape && letters[i].n) {
                xPos = -trackingOffset;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                firstLine = false;
            }
            shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
            jLen = shapes.length;
            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
            if (singleShape) this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
            commands = createSizedArray(jLen - 1);
            var commandsCounter = 0;
            for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k = 1; k < kLen; k += 1){
                    if (k === 1) pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                commands[commandsCounter] = pathArr;
                commandsCounter += 1;
            }
            if (singleShape) {
                xPos += letters[i].l;
                xPos += trackingOffset;
            }
            if (this.textSpans[cnt]) this.textSpans[cnt].elem = commands;
            else this.textSpans[cnt] = {
                elem: commands
            };
            cnt += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx = this.canvasContext;
        ctx.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';
        this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';
        this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i;
        var len;
        var j;
        var jLen;
        var k;
        var kLen;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var lastFill = null;
        var lastStroke = null;
        var lastStrokeW = null;
        var commands;
        var pathArr;
        var renderer = this.globalData.renderer;
        for(i = 0; i < len; i += 1)if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            if (renderedLetter) {
                renderer.save();
                renderer.ctxTransform(renderedLetter.p);
                renderer.ctxOpacity(renderedLetter.o);
            }
            if (this.fill) {
                if (renderedLetter && renderedLetter.fc) {
                    if (lastFill !== renderedLetter.fc) {
                        renderer.ctxFillStyle(renderedLetter.fc);
                        lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
                    }
                } else if (lastFill !== this.values.fill) {
                    lastFill = this.values.fill;
                    renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxFill(); // this.globalData.canvasContext.fill();
            /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter && renderedLetter.sw) {
                    if (lastStrokeW !== renderedLetter.sw) {
                        lastStrokeW = renderedLetter.sw;
                        renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
                    }
                } else if (lastStrokeW !== this.values.sWidth) {
                    lastStrokeW = this.values.sWidth;
                    renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
                }
                if (renderedLetter && renderedLetter.sc) {
                    if (lastStroke !== renderedLetter.sc) {
                        lastStroke = renderedLetter.sc;
                        renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
                    }
                } else if (lastStroke !== this.values.stroke) {
                    lastStroke = this.values.stroke;
                    renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
            /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.img = globalData.imageLoader.getAsset(this.assetData);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas = createTag('canvas');
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext('2d');
            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w / this.assetData.h;
            var widthCrop;
            var heightCrop;
            var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
                heightCrop = imgH;
                widthCrop = heightCrop * canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop / canvasRel;
            }
            ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        // var ctx = this.canvasContext;
        this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
    };
    function CanvasRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data) {
        return new CVShapeElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data) {
        return new CVTextElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data) {
        return new CVImageElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data) {
        return new CVSolidElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props) {
        if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) return;
        this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op) {
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    };
    CanvasRendererBase.prototype.ctxFillStyle = function(value) {
        this.canvasContext.fillStyle = value;
    };
    CanvasRendererBase.prototype.ctxStrokeStyle = function(value) {
        this.canvasContext.strokeStyle = value;
    };
    CanvasRendererBase.prototype.ctxLineWidth = function(value) {
        this.canvasContext.lineWidth = value;
    };
    CanvasRendererBase.prototype.ctxLineCap = function(value) {
        this.canvasContext.lineCap = value;
    };
    CanvasRendererBase.prototype.ctxLineJoin = function(value) {
        this.canvasContext.lineJoin = value;
    };
    CanvasRendererBase.prototype.ctxMiterLimit = function(value) {
        this.canvasContext.miterLimit = value;
    };
    CanvasRendererBase.prototype.ctxFill = function(rule) {
        this.canvasContext.fill(rule);
    };
    CanvasRendererBase.prototype.ctxFillRect = function(x, y, w, h) {
        this.canvasContext.fillRect(x, y, w, h);
    };
    CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag) this.globalData.blendMode = 'source-over';
        this.contextData.restore(actionFlag);
    };
    CanvasRendererBase.prototype.configAnimation = function(animData) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag('canvas');
            var containerStyle = this.animationItem.container.style;
            containerStyle.width = '100%';
            containerStyle.height = '100%';
            var origin = '0px 0px 0px';
            containerStyle.transformOrigin = origin;
            containerStyle.mozTransformOrigin = origin;
            containerStyle.webkitTransformOrigin = origin;
            containerStyle['-webkit-transform'] = origin;
            containerStyle.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext('2d');
            if (this.renderConfig.className) this.animationItem.container.setAttribute('class', this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute('id', this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext);
        this.data = animData;
        this.layers = animData.layers;
        this.transformCanvas = {
            w: animData.w,
            h: animData.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width, height) {
        this.reset();
        var elementWidth;
        var elementHeight;
        if (width) {
            elementWidth = width;
            elementHeight = height;
            this.canvasContext.canvas.width = elementWidth;
            this.canvasContext.canvas.height = elementHeight;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth = this.animationItem.wrapper.offsetWidth;
                elementHeight = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth = this.canvasContext.canvas.width;
                elementHeight = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
        }
        var elementRel;
        var animationRel;
        if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
            var par = this.renderConfig.preserveAspectRatio.split(' ');
            var fillType = par[1] || 'meet';
            var pos = par[0] || 'xMidYMid';
            var xPos = pos.substr(0, 4);
            var yPos = pos.substr(4);
            elementRel = elementWidth / elementHeight;
            animationRel = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
                this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === 'none') {
            this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num, forceRender) {
        if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) return;
        this.renderedFrame = num;
        this.globalData.frameNum = num - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
        this.globalData.projectInterface.currentFrame = num; // console.log('--------');
        // console.log('NEW: ',num);
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        var element = this.createItem(this.layers[pos], this, this.globalData);
        elements[pos] = element;
        element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = 'none';
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = 'block';
    };
    function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray('float32', 16);
        this.fillStyle = '';
        this.strokeStyle = '';
        this.lineWidth = '';
        this.lineCap = '';
        this.lineJoin = '';
        this.miterLimit = '';
        this.id = Math.random();
    }
    function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i;
        var len = 15;
        for(i = 0; i < len; i += 1){
            var canvasContext = new CanvasContext();
            this.stack[i] = canvasContext;
        }
        this._length = len;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1; //
        this.currentFillStyle = '';
        this.appliedFillStyle = ''; //
        this.currentStrokeStyle = '';
        this.appliedStrokeStyle = ''; //
        this.currentLineWidth = '';
        this.appliedLineWidth = ''; //
        this.currentLineCap = '';
        this.appliedLineCap = ''; //
        this.currentLineJoin = '';
        this.appliedLineJoin = ''; //
        this.appliedMiterLimit = '';
        this.currentMiterLimit = '';
    }
    CVContextData.prototype.duplicate = function() {
        var newLength = this._length * 2;
        var i = 0;
        for(i = this._length; i < newLength; i += 1)this.stack[i] = new CanvasContext();
        this._length = newLength;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
    };
    CVContextData.prototype.restore = function(forceRestore) {
        this.cArrPos -= 1;
        var currentContext = this.stack[this.cArrPos];
        var transform = currentContext.transform;
        var i;
        var arr = this.cTr.props;
        for(i = 0; i < 16; i += 1)arr[i] = transform[i];
        if (forceRestore) {
            this.nativeContext.restore();
            var prevStack = this.stack[this.cArrPos + 1];
            this.appliedFillStyle = prevStack.fillStyle;
            this.appliedStrokeStyle = prevStack.strokeStyle;
            this.appliedLineWidth = prevStack.lineWidth;
            this.appliedLineCap = prevStack.lineCap;
            this.appliedLineJoin = prevStack.lineJoin;
            this.appliedMiterLimit = prevStack.miterLimit;
        }
        this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
        if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
            this.nativeContext.globalAlpha = currentContext.opacity;
            this.currentOpacity = currentContext.opacity;
        }
        this.currentFillStyle = currentContext.fillStyle;
        this.currentStrokeStyle = currentContext.strokeStyle;
        this.currentLineWidth = currentContext.lineWidth;
        this.currentLineCap = currentContext.lineCap;
        this.currentLineJoin = currentContext.lineJoin;
        this.currentMiterLimit = currentContext.miterLimit;
    };
    CVContextData.prototype.save = function(saveOnNativeFlag) {
        if (saveOnNativeFlag) this.nativeContext.save();
        var props = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var currentStack = this.stack[this.cArrPos];
        var i;
        for(i = 0; i < 16; i += 1)currentStack.transform[i] = props[i];
        this.cArrPos += 1;
        var newStack = this.stack[this.cArrPos];
        newStack.opacity = currentStack.opacity;
        newStack.fillStyle = currentStack.fillStyle;
        newStack.strokeStyle = currentStack.strokeStyle;
        newStack.lineWidth = currentStack.lineWidth;
        newStack.lineCap = currentStack.lineCap;
        newStack.lineJoin = currentStack.lineJoin;
        newStack.miterLimit = currentStack.miterLimit;
    };
    CVContextData.prototype.setOpacity = function(value) {
        this.stack[this.cArrPos].opacity = value;
    };
    CVContextData.prototype.setContext = function(value) {
        this.nativeContext = value;
    };
    CVContextData.prototype.fillStyle = function(value) {
        if (this.stack[this.cArrPos].fillStyle !== value) {
            this.currentFillStyle = value;
            this.stack[this.cArrPos].fillStyle = value;
        }
    };
    CVContextData.prototype.strokeStyle = function(value) {
        if (this.stack[this.cArrPos].strokeStyle !== value) {
            this.currentStrokeStyle = value;
            this.stack[this.cArrPos].strokeStyle = value;
        }
    };
    CVContextData.prototype.lineWidth = function(value) {
        if (this.stack[this.cArrPos].lineWidth !== value) {
            this.currentLineWidth = value;
            this.stack[this.cArrPos].lineWidth = value;
        }
    };
    CVContextData.prototype.lineCap = function(value) {
        if (this.stack[this.cArrPos].lineCap !== value) {
            this.currentLineCap = value;
            this.stack[this.cArrPos].lineCap = value;
        }
    };
    CVContextData.prototype.lineJoin = function(value) {
        if (this.stack[this.cArrPos].lineJoin !== value) {
            this.currentLineJoin = value;
            this.stack[this.cArrPos].lineJoin = value;
        }
    };
    CVContextData.prototype.miterLimit = function(value) {
        if (this.stack[this.cArrPos].miterLimit !== value) {
            this.currentMiterLimit = value;
            this.stack[this.cArrPos].miterLimit = value;
        }
    };
    CVContextData.prototype.transform = function(props) {
        this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms
        var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform
        currentTransform.cloneFromProps(this.transformMat.props);
        var trProps = currentTransform.props; // Applying the new transform to the canvas
        this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
    };
    CVContextData.prototype.opacity = function(op) {
        var currentOpacity = this.stack[this.cArrPos].opacity;
        currentOpacity *= op < 0 ? 0 : op;
        if (this.stack[this.cArrPos].opacity !== currentOpacity) {
            if (this.currentOpacity !== op) {
                this.nativeContext.globalAlpha = op;
                this.currentOpacity = op;
            }
            this.stack[this.cArrPos].opacity = currentOpacity;
        }
    };
    CVContextData.prototype.fill = function(rule) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule);
    };
    CVContextData.prototype.fillRect = function(x, y, w, h) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x, y, w, h);
    };
    CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
            this.appliedStrokeStyle = this.currentStrokeStyle;
            this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
            this.appliedLineWidth = this.currentLineWidth;
            this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
            this.appliedLineCap = this.currentLineCap;
            this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
            this.appliedLineJoin = this.currentLineJoin;
            this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
            this.appliedMiterLimit = this.currentMiterLimit;
            this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
    };
    function CVCompElement(data, globalData, comp) {
        this.completeLayers = false;
        this.layers = data.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx = this.canvasContext;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.data.w, 0);
        ctx.lineTo(this.data.w, this.data.h);
        ctx.lineTo(0, this.data.h);
        ctx.lineTo(0, 0);
        ctx.clip();
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i]) this.elements[i].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function CanvasRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.renderConfig = {
            clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
            context: config && config.context || null,
            progressiveLoad: config && config.progressiveLoad || false,
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            className: config && config.className || '',
            id: config && config.id || '',
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.renderConfig.dpr = config && config.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = 'canvas';
        if (this.renderConfig.clearCanvas) {
            this.ctxTransform = this.contextData.transform.bind(this.contextData);
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
            this.ctxFill = this.contextData.fill.bind(this.contextData);
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
            this.ctxStroke = this.contextData.stroke.bind(this.contextData);
            this.save = this.contextData.save.bind(this.contextData);
        }
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode() {},
        initRendererElement: function initRendererElement() {
            this.baseElement = createTag(this.data.tg || 'div');
            if (this.data.hasMask) {
                this.svgElement = createNS('svg');
                this.layerElement = createNS('g');
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue = this.finalTransform.mat.toCSS();
                transformedElementStyle.transform = matrixValue;
                transformedElementStyle.webkitTransform = matrixValue;
            }
            if (this.finalTransform._opMdf) transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects() {},
        setMatte: function setMatte() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect;
        if (this.data.hasMask) {
            rect = createNS('rect');
            rect.setAttribute('width', this.data.sw);
            rect.setAttribute('height', this.data.sh);
            rect.setAttribute('fill', this.data.sc);
            this.svgElement.setAttribute('width', this.data.sw);
            this.svgElement.setAttribute('height', this.data.sh);
        } else {
            rect = createTag('div');
            rect.style.width = this.data.sw + 'px';
            rect.style.height = this.data.sh + 'px';
            rect.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect);
    };
    function HShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS('g');
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont = this.svgElement;
        } else {
            cont = createNS('svg');
            var size = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont.setAttribute('width', size.w);
            cont.setAttribute('height', size.h);
            cont.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
        var i;
        var len = transformers.length;
        for(i = 0; i < len; i += 1)point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
        return point;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
        var shape = item.sh.v;
        var transformers = item.transformers;
        var i;
        var len = shape._length;
        var vPoint;
        var oPoint;
        var nextIPoint;
        var nextVPoint;
        if (len <= 1) return;
        for(i = 0; i < len - 1; i += 1){
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
        if (shape.c) {
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
        this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
        var bounds = this.shapeBoundingBox;
        boundingBox.x = bmMin(bounds.left, boundingBox.x);
        boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
        boundingBox.y = bmMin(bounds.top, boundingBox.y);
        boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
        var bounds = [
            [
                p0[0],
                p3[0]
            ],
            [
                p0[1],
                p3[1]
            ]
        ];
        for(var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i){
            // eslint-disable-line no-plusplus
            b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            c = 3 * p1[i] - 3 * p0[i];
            b |= 0; // eslint-disable-line no-bitwise
            a |= 0; // eslint-disable-line no-bitwise
            c |= 0; // eslint-disable-line no-bitwise
            if (a === 0 && b === 0) ;
            else if (a === 0) {
                t = -c / b;
                if (t > 0 && t < 1) bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
            } else {
                b2ac = b * b - 4 * c * a;
                if (b2ac >= 0) {
                    t1 = (-b + bmSqrt(b2ac)) / (2 * a);
                    if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
                    t2 = (-b - bmSqrt(b2ac)) / (2 * a);
                    if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
    };
    HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
        return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
        var i;
        var len = itemsData.length;
        for(i = 0; i < len; i += 1){
            if (itemsData[i] && itemsData[i].sh) this.calculateShapeBoundingBox(itemsData[i], boundingBox);
            else if (itemsData[i] && itemsData[i].it) this.calculateBoundingBox(itemsData[i].it, boundingBox);
            else if (itemsData[i] && itemsData[i].style && itemsData[i].w) this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty, boundingBox) {
        var width = 0;
        if (widthProperty.keyframes) {
            for(var i = 0; i < widthProperty.keyframes.length; i += 1){
                var kfw = widthProperty.keyframes[i].s;
                if (kfw > width) width = kfw;
            }
            width *= widthProperty.mult;
        } else width = widthProperty.v * widthProperty.mult;
        boundingBox.x -= width;
        boundingBox.xMax += width;
        boundingBox.y -= width;
        boundingBox.yMax += width;
    };
    HShapeElement.prototype.currentBoxContains = function(box) {
        return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox = this.tempBoundingBox;
            var max = 999999;
            tempBoundingBox.x = max;
            tempBoundingBox.xMax = -max;
            tempBoundingBox.y = max;
            tempBoundingBox.yMax = -max;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox);
            tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
            tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox)) return;
            var changed = false;
            if (this.currentBBox.w !== tempBoundingBox.width) {
                this.currentBBox.w = tempBoundingBox.width;
                this.shapeCont.setAttribute('width', tempBoundingBox.width);
                changed = true;
            }
            if (this.currentBBox.h !== tempBoundingBox.height) {
                this.currentBBox.h = tempBoundingBox.height;
                this.shapeCont.setAttribute('height', tempBoundingBox.height);
                changed = true;
            }
            if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
                this.currentBBox.w = tempBoundingBox.width;
                this.currentBBox.h = tempBoundingBox.height;
                this.currentBBox.x = tempBoundingBox.x;
                this.currentBBox.y = tempBoundingBox.y;
                this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                var shapeStyle = this.shapeCont.style;
                var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                shapeStyle.transform = shapeTransform;
                shapeStyle.webkitTransform = shapeTransform;
            }
        }
    };
    function HTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = 'svg';
        this.isMasked = false;
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = 'svg';
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute('width', this.compW);
            this.svgElement.setAttribute('height', this.compH);
            var g = createNS('g');
            this.maskedElement.appendChild(g);
            this.innerElem = g;
        } else {
            this.renderType = 'html';
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var innerElemStyle = this.innerElem.style;
        var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
        innerElemStyle.fill = textColor;
        innerElemStyle.color = textColor;
        if (documentData.sc) {
            innerElemStyle.stroke = this.buildColor(documentData.sc);
            innerElemStyle.strokeWidth = documentData.sw + 'px';
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle.fontSize = documentData.finalSize + 'px';
            innerElemStyle.lineHeight = documentData.finalSize + 'px';
            if (fontData.fClass) this.innerElem.className = fontData.fClass;
            else {
                innerElemStyle.fontFamily = fontData.fFamily;
                var fWeight = documentData.fWeight;
                var fStyle = documentData.fStyle;
                innerElemStyle.fontStyle = fStyle;
                innerElemStyle.fontWeight = fWeight;
            }
        }
        var i;
        var len;
        var letters = documentData.l;
        len = letters.length;
        var tSpan;
        var tParent;
        var tCont;
        var matrixHelper = this.mHelper;
        var shapes;
        var shapeStr = '';
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt]) {
                    tSpan = createNS('path');
                    tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
                    tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
                    tSpan.setAttribute('stroke-miterlimit', '4');
                } else tSpan = this.textPaths[cnt];
                if (!this.isMasked) {
                    if (this.textSpans[cnt]) {
                        tParent = this.textSpans[cnt];
                        tCont = tParent.children[0];
                    } else {
                        tParent = createTag('div');
                        tParent.style.lineHeight = 0;
                        tCont = createNS('svg');
                        tCont.appendChild(tSpan);
                        styleDiv(tParent);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt]) {
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = createTag('span');
                    styleDiv(tParent);
                    tSpan = createTag('span');
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
             // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                var shapeData;
                if (charData) shapeData = charData.data;
                else shapeData = null;
                matrixHelper.reset();
                if (shapeData && shapeData.shapes && shapeData.shapes.length) {
                    shapes = shapeData.shapes[0].it;
                    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
                    shapeStr = this.createPathShape(matrixHelper, shapes);
                    tSpan.setAttribute('d', shapeStr);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent);
                    if (shapeData && shapeData.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont);
                        var boundingBox = tCont.getBBox();
                        tCont.setAttribute('width', boundingBox.width + 2);
                        tCont.setAttribute('height', boundingBox.height + 2);
                        tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
                        var tContStyle = tCont.style;
                        var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
                        tContStyle.transform = tContTranslation;
                        tContStyle.webkitTransform = tContTranslation;
                        letters[i].yOffset = boundingBox.y - 1;
                    } else {
                        tCont.setAttribute('width', 1);
                        tCont.setAttribute('height', 1);
                    }
                    tParent.appendChild(tCont);
                } else this.innerElem.appendChild(tSpan);
            } else {
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent); //
                    var tStyle = tSpan.style;
                    var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
                    tStyle.transform = tSpanTranslation;
                    tStyle.webkitTransform = tSpanTranslation;
                } else this.innerElem.appendChild(tSpan);
            } //
            if (!this.isMasked) this.textSpans[cnt] = tParent;
            else this.textSpans[cnt] = tSpan;
            this.textSpans[cnt].style.display = 'block';
            this.textPaths[cnt] = tSpan;
            cnt += 1;
        }
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = 'none';
            cnt += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
                svgStyle = this.svgElement.style;
                var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
                svgStyle.transform = translation;
                svgStyle.webkitTransform = translation;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i;
        var len;
        var count = 0;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var textPath;
        for(i = 0; i < len; i += 1)if (letters[i].n) count += 1;
        else {
            textSpan = this.textSpans[i];
            textPath = this.textPaths[i];
            renderedLetter = renderedLetters[count];
            count += 1;
            if (renderedLetter._mdf.m) {
                if (!this.isMasked) {
                    textSpan.style.webkitTransform = renderedLetter.m;
                    textSpan.style.transform = renderedLetter.m;
                } else textSpan.setAttribute('transform', renderedLetter.m);
            } /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan.style.opacity = renderedLetter.o;
            if (renderedLetter.sw && renderedLetter._mdf.sw) textPath.setAttribute('stroke-width', renderedLetter.sw);
            if (renderedLetter.sc && renderedLetter._mdf.sc) textPath.setAttribute('stroke', renderedLetter.sc);
            if (renderedLetter.fc && renderedLetter._mdf.fc) {
                textPath.setAttribute('fill', renderedLetter.fc);
                textPath.style.color = renderedLetter.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox.width) {
                this.currentBBox.w = boundingBox.width;
                this.svgElement.setAttribute('width', boundingBox.width);
            }
            if (this.currentBBox.h !== boundingBox.height) {
                this.currentBBox.h = boundingBox.height;
                this.svgElement.setAttribute('height', boundingBox.height);
            }
            var margin = 1;
            if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
                this.currentBBox.w = boundingBox.width + margin * 2;
                this.currentBBox.h = boundingBox.height + margin * 2;
                this.currentBBox.x = boundingBox.x - margin;
                this.currentBBox.y = boundingBox.y - margin;
                this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                svgStyle = this.svgElement.style;
                var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                svgStyle.transform = svgTransform;
                svgStyle.webkitTransform = svgTransform;
            }
        }
    };
    function HCameraElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initHierarchy();
        var getProp = PropertyFactory.getProp;
        this.pe = getProp(this, data.pe, 0, 0, this);
        if (data.ks.p.s) {
            this.px = getProp(this, data.ks.p.x, 1, 0, this);
            this.py = getProp(this, data.ks.p.y, 1, 0, this);
            this.pz = getProp(this, data.ks.p.z, 1, 0, this);
        } else this.p = getProp(this, data.ks.p, 1, 0, this);
        if (data.ks.a) this.a = getProp(this, data.ks.a, 1, 0, this);
        if (data.ks.or.k.length && data.ks.or.k[0].to) {
            var i;
            var len = data.ks.or.k.length;
            for(i = 0; i < len; i += 1){
                data.ks.or.k[i].to = null;
                data.ks.or.k[i].ti = null;
            }
        }
        this.or = getProp(this, data.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
        this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
        this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i;
        var len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;
        for(i = 0; i < len; i += 1){
            // [perspectiveElem,container]
            comp = this.comp.threeDElements[i];
            if (comp.type === '3d') {
                perspectiveStyle = comp.perspectiveElem.style;
                containerStyle = comp.container.style;
                var perspective = this.pe.v + 'px';
                var origin = '0px 0px 0px';
                var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
                perspectiveStyle.perspective = perspective;
                perspectiveStyle.webkitPerspective = perspective;
                containerStyle.transformOrigin = origin;
                containerStyle.mozTransformOrigin = origin;
                containerStyle.webkitTransformOrigin = origin;
                perspectiveStyle.transform = matrix;
                perspectiveStyle.webkitTransform = matrix;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf = this._isFirstFrame;
        var i;
        var len;
        if (this.hierarchy) {
            len = this.hierarchy.length;
            for(i = 0; i < len; i += 1)_mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
        }
        if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len = this.hierarchy.length - 1;
                for(i = len; i >= 0; i -= 1){
                    var mTransf = this.hierarchy[i].finalTransform.mProp;
                    this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
                    this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
                    this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
                    this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
                    this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector;
                if (this.p) diffVector = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir = [
                    diffVector[0] / mag,
                    diffVector[1] / mag,
                    diffVector[2] / mag
                ];
                var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
                var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
                var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
                this.mat.rotateY(mRotationY).rotateX(-mRotationX);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
                len = this.comp.threeDElements.length;
                var comp;
                var perspectiveStyle;
                var containerStyle;
                for(i = 0; i < len; i += 1){
                    comp = this.comp.threeDElements[i];
                    if (comp.type === '3d') {
                        if (hasMatrixChanged) {
                            var matValue = this.mat.toCSS();
                            containerStyle = comp.container.style;
                            containerStyle.transform = matValue;
                            containerStyle.webkitTransform = matValue;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle = comp.perspectiveElem.style;
                            perspectiveStyle.perspective = this.pe.v + 'px';
                            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        var img = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS('image');
            this.imageElem.setAttribute('width', this.assetData.w + 'px');
            this.imageElem.setAttribute('height', this.assetData.h + 'px');
            this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute('width', this.assetData.w);
            this.baseElement.setAttribute('height', this.assetData.h);
        } else this.layerElement.appendChild(img);
        img.crossOrigin = 'anonymous';
        img.src = assetPath;
        if (this.data.ln) this.baseElement.setAttribute('id', this.data.ln);
    };
    function HybridRendererBase(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newDOMElement = element.getBaseElement();
        if (!newDOMElement) return;
        var layer = this.layers[pos];
        if (!layer.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement, pos);
            else {
                var i = 0;
                var nextDOMElement;
                var nextLayer;
                var tmpDOMElement;
                while(i < pos){
                    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
                        nextLayer = this.elements[i];
                        tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
                        nextDOMElement = tmpDOMElement || nextDOMElement;
                    }
                    i += 1;
                }
                if (nextDOMElement) {
                    if (!layer.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement, nextDOMElement);
                } else if (!layer.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement);
            }
        } else this.addTo3dContainer(newDOMElement, pos);
    };
    HybridRendererBase.prototype.createShape = function(data) {
        if (!this.supports3d) return new SVGShapeElement(data, this.globalData, this);
        return new HShapeElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data) {
        if (!this.supports3d) return new SVGTextLottieElement(data, this.globalData, this);
        return new HTextElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data) {
        this.camera = new HCameraElement(data, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data) {
        if (!this.supports3d) return new IImageElement(data, this.globalData, this);
        return new HImageElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data) {
        if (!this.supports3d) return new ISolidElement(data, this.globalData, this);
        return new HSolidElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) return this.threeDElements[i].perspectiveElem;
            i += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos, type) {
        var perspectiveElem = createTag('div');
        var style;
        var containerStyle;
        styleDiv(perspectiveElem);
        var container = createTag('div');
        styleDiv(container);
        if (type === '3d') {
            style = perspectiveElem.style;
            style.width = this.globalData.compSize.w + 'px';
            style.height = this.globalData.compSize.h + 'px';
            var center = '50% 50%';
            style.webkitTransformOrigin = center;
            style.mozTransformOrigin = center;
            style.transformOrigin = center;
            containerStyle = container.style;
            var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
            containerStyle.transform = matrix;
            containerStyle.webkitTransform = matrix;
        }
        perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData = {
            container: container,
            perspectiveElem: perspectiveElem,
            startPos: pos,
            endPos: pos,
            type: type
        };
        this.threeDElements.push(threeDContainerData);
        return threeDContainerData;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i;
        var len = this.layers.length;
        var lastThreeDContainerData;
        var currentContainer = '';
        for(i = 0; i < len; i += 1)if (this.layers[i].ddd && this.layers[i].ty !== 3) {
            if (currentContainer !== '3d') {
                currentContainer = '3d';
                lastThreeDContainerData = this.createThreeDContainer(i, '3d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        } else {
            if (currentContainer !== '2d') {
                currentContainer = '2d';
                lastThreeDContainerData = this.createThreeDContainer(i, '2d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        }
        len = this.threeDElements.length;
        for(i = len - 1; i >= 0; i -= 1)this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem, pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (pos <= this.threeDElements[i].endPos) {
                var j = this.threeDElements[i].startPos;
                var nextElement;
                while(j < pos){
                    if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
                    j += 1;
                }
                if (nextElement) this.threeDElements[i].container.insertBefore(elem, nextElement);
                else this.threeDElements[i].container.appendChild(elem);
                break;
            }
            i += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData) {
        var resizerElem = createTag('div');
        var wrapper = this.animationItem.wrapper;
        var style = resizerElem.style;
        style.width = animData.w + 'px';
        style.height = animData.h + 'px';
        this.resizerElem = resizerElem;
        styleDiv(resizerElem);
        style.transformStyle = 'flat';
        style.mozTransformStyle = 'flat';
        style.webkitTransformStyle = 'flat';
        if (this.renderConfig.className) resizerElem.setAttribute('class', this.renderConfig.className);
        wrapper.appendChild(resizerElem);
        style.overflow = 'hidden';
        var svg = createNS('svg');
        svg.setAttribute('width', '1');
        svg.setAttribute('height', '1');
        styleDiv(svg);
        this.resizerElem.appendChild(svg);
        var defs = createNS('defs');
        svg.appendChild(defs);
        this.data = animData; // Mask animation
        this.setupGlobalData(animData, svg);
        this.globalData.defs = defs;
        this.layers = animData.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth = this.animationItem.wrapper.offsetWidth;
        var elementHeight = this.animationItem.wrapper.offsetHeight;
        var elementRel = elementWidth / elementHeight;
        var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx;
        var sy;
        var tx;
        var ty;
        if (animationRel > elementRel) {
            sx = elementWidth / this.globalData.compSize.w;
            sy = elementWidth / this.globalData.compSize.w;
            tx = 0;
            ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
        } else {
            sx = elementHeight / this.globalData.compSize.h;
            sy = elementHeight / this.globalData.compSize.h;
            tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
            ty = 0;
        }
        var style = this.resizerElem.style;
        style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
        style.transform = style.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = 'none';
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = 'block';
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth = this.globalData.compSize.w;
            var cHeight = this.globalData.compSize.h;
            var i;
            var len = this.threeDElements.length;
            for(i = 0; i < len; i += 1){
                var style = this.threeDElements[i].perspectiveElem.style;
                style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
                style.perspective = style.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        var floatingContainer = createTag('div');
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    function HCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = !data.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute('width', this.data.w);
            this.svgElement.setAttribute('height', this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem, pos) {
        var j = 0;
        var nextElement;
        while(j < pos){
            if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
            j += 1;
        }
        if (nextElement) this.layerElement.insertBefore(elem, nextElement);
        else this.layerElement.appendChild(elem);
    };
    HCompElement.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    function HybridRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            },
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp) {
            function _thisLayerFunction(name) {
                var i = 0;
                var len = comp.layers.length;
                while(i < len){
                    if (comp.layers[i].nm === name || comp.layers[i].ind === name) return comp.elements[i].layerInterface;
                    i += 1;
                }
                return null; // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction, '_name', {
                value: comp.data.nm
            });
            _thisLayerFunction.layer = _thisLayerFunction;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
            _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
            _thisLayerFunction.displayStartTime = 0;
            _thisLayerFunction.numLayers = comp.layers.length;
            return _thisLayerFunction;
        };
    }();
    function _typeof$2(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$2 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$2(obj);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool, math) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global = this, width = 256, // each RC4 output is 0 <= x < 256
        chunks = 6, // at least six RC4 outputs for each double
        digits = 52, // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom(seed, options, callback) {
            var key = [];
            options = options === true ? {
                entropy: true
            } : options || {}; // Flatten the seed string or build one from local entropy if needed.
            var shortseed = mixkey(flatten(options.entropy ? [
                seed,
                tostring(pool)
            ] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.
            var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng = function prng() {
                var n = arc4.g(chunks), // Start with a numerator n < 2 ^ 48
                d = startdenom, //   and denominator d = 2 ^ 48.
                x = 0; //   and no 'extra last byte'.
                while(n < significance){
                    // Fill up all significant digits by
                    n = (n + x) * width; //   shifting numerator and
                    d *= width; //   denominator and generating a
                    x = arc4.g(1); //   new least-significant-byte.
                }
                while(n >= overflow){
                    // To avoid rounding up, before adding
                    n /= 2; //   last byte, shift everything
                    d /= 2; //   right using integer math until
                    x >>>= 1; //   we have exactly the desired bits.
                }
                return (n + x) / d; // Form the number within [0, 1).
            };
            prng.int32 = function() {
                return arc4.g(4) | 0;
            };
            prng.quick = function() {
                return arc4.g(4) / 0x100000000;
            };
            prng["double"] = prng; // Mix the randomness into accumulated entropy.
            mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.
            return (options.pass || callback || function(prng, seed, is_math_call, state) {
                if (state) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state.S) copy(state, arc4);
                     // Only provide the .state method if requested via options.state.
                    prng.state = function() {
                        return copy(arc4, {});
                    };
                } // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call) {
                    math[rngname] = prng;
                    return seed;
                } else return prng;
            })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
        }
        math['seed' + rngname] = seedrandom; //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC4(key) {
            var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = []; // The empty key [] is treated as [0].
            if (!keylen) key = [
                keylen++
            ];
             // Set up S using the standard key scheduling algorithm.
            while(i < width)s[i] = i++;
            for(i = 0; i < width; i++){
                s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
                s[j] = t;
            } // The "g" method returns the next (count) outputs as one number.
            me.g = function(count) {
                // Using instance members instead of closure state nearly doubles speed.
                var t, r = 0, i = me.i, j = me.j, s = me.S;
                while(count--){
                    t = s[i = mask & i + 1];
                    r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
                }
                me.i = i;
                me.j = j;
                return r; // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        } //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy(f, t) {
            t.i = f.i;
            t.j = f.j;
            t.S = f.S.slice();
            return t;
        } //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten(obj, depth) {
            var result = [], typ = _typeof$2(obj), prop;
            if (depth && typ == 'object') {
                for(prop in obj)try {
                    result.push(flatten(obj[prop], depth - 1));
                } catch (e) {}
            }
            return result.length ? result : typ == 'string' ? obj : obj + '\0';
        } //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey(seed, key) {
            var stringseed = seed + '', smear, j = 0;
            while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
            return tostring(key);
        } //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed() {
            try {
                if (nodecrypto) return tostring(nodecrypto.randomBytes(width));
                var out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
                return tostring(out);
            } catch (e) {
                var browser = global.navigator, plugins = browser && browser.plugins;
                return [
                    +new Date(),
                    global,
                    plugins,
                    global.screen,
                    tostring(pool)
                ];
            }
        } //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring(a) {
            return String.fromCharCode.apply(0, a);
        } //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey(math.random(), pool); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath) {
        seedRandom([], BMMath);
    }
    var propTypes = {
        SHAPE: 'shape'
    };
    function _typeof$1(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$1 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$1(obj);
    }
    var ExpressionManager = function() {
        'use strict';
        var ob = {};
        var Math1 = BMMath;
        var window1 = null;
        var document1 = null;
        var XMLHttpRequest1 = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr) {
            return arr.constructor === Array || arr.constructor === Float32Array;
        }
        function isNumerable(tOfV, v) {
            return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
        }
        function $bm_neg(a) {
            var tOfA = _typeof$1(a);
            if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') return -a;
            if ($bm_isInstanceOfArray(a)) {
                var i;
                var lenA = a.length;
                var retArr = [];
                for(i = 0; i < lenA; i += 1)retArr[i] = -a[i];
                return retArr;
            }
            if (a.propType) return a.v;
            return -a;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
        function sum(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') return a + b;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] += b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a + b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] + b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        var add = sum;
        function sub(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
                if (tOfA === 'string') a = parseInt(a, 10);
                if (tOfB === 'string') b = parseInt(b, 10);
                return a - b;
            }
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] -= b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a - b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] - b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        function mul(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a * b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] * b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a * b[i];
                return arr;
            }
            return 0;
        }
        function div(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a / b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] / b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a / b[i];
                return arr;
            }
            return 0;
        }
        function mod(a, b) {
            if (typeof a === 'string') a = parseInt(a, 10);
            if (typeof b === 'string') b = parseInt(b, 10);
            return a % b;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num, min, max) {
            if (min > max) {
                var mm = max;
                max = min;
                min = mm;
            }
            return Math1.min(Math1.max(num, min), max);
        }
        function radiansToDegrees(val) {
            return val / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val) {
            return val * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr1, arr2) {
            if (typeof arr1 === 'number' || arr1 instanceof Number) {
                arr2 = arr2 || 0;
                return Math1.abs(arr1 - arr2);
            }
            if (!arr2) arr2 = helperLengthArray;
            var i;
            var len = Math1.min(arr1.length, arr2.length);
            var addedLength = 0;
            for(i = 0; i < len; i += 1)addedLength += Math1.pow(arr2[i] - arr1[i], 2);
            return Math1.sqrt(addedLength);
        }
        function normalize(vec) {
            return div(vec, length(vec));
        }
        function rgbToHsl(val) {
            var r = val[0];
            var g = val[1];
            var b = val[2];
            var max = Math1.max(r, g, b);
            var min = Math1.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            if (max === min) {
                h = 0; // achromatic
                s = 0; // achromatic
            } else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                    default:
                        break;
                }
                h /= 6;
            }
            return [
                h,
                s,
                l,
                val[3]
            ];
        }
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        function hslToRgb(val) {
            var h = val[0];
            var s = val[1];
            var l = val[2];
            var r;
            var g;
            var b;
            if (s === 0) {
                r = l; // achromatic
                b = l; // achromatic
                g = l; // achromatic
            } else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return [
                r,
                g,
                b,
                val[3]
            ];
        }
        function linear(t, tMin, tMax, value1, value2) {
            if (value1 === undefined || value2 === undefined) {
                value1 = tMin;
                value2 = tMax;
                tMin = 0;
                tMax = 1;
            }
            if (tMax < tMin) {
                var _tMin = tMax;
                tMax = tMin;
                tMin = _tMin;
            }
            if (t <= tMin) return value1;
            if (t >= tMax) return value2;
            var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
            if (!value1.length) return value1 + (value2 - value1) * perc;
            var i;
            var len = value1.length;
            var arr = createTypedArray('float32', len);
            for(i = 0; i < len; i += 1)arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
            return arr;
        }
        function random(min, max) {
            if (max === undefined) {
                if (min === undefined) {
                    min = 0;
                    max = 1;
                } else {
                    max = min;
                    min = undefined;
                }
            }
            if (max.length) {
                var i;
                var len = max.length;
                if (!min) min = createTypedArray('float32', len);
                var arr = createTypedArray('float32', len);
                var rnd = BMMath.random();
                for(i = 0; i < len; i += 1)arr[i] = min[i] + rnd * (max[i] - min[i]);
                return arr;
            }
            if (min === undefined) min = 0;
            var rndm = BMMath.random();
            return min + rndm * (max - min);
        }
        function createPath(points, inTangents, outTangents, closed) {
            var i;
            var len = points.length;
            var path = shapePool.newElement();
            path.setPathData(!!closed, len);
            var arrPlaceholder = [
                0,
                0
            ];
            var inVertexPoint;
            var outVertexPoint;
            for(i = 0; i < len; i += 1){
                inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
                outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
                path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
            }
            return path;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value) {
                return _value;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf('random') !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, 'value', {
                get: function get() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle(freq, amp) {
                var iWiggle;
                var j;
                var lenWiggle = this.pv.length ? this.pv.length : 1;
                var addedAmps = createTypedArray('float32', lenWiggle);
                freq = 5;
                var iterations = Math1.floor(time * freq);
                iWiggle = 0;
                j = 0;
                while(iWiggle < iterations){
                    // var rnd = BMMath.random();
                    for(j = 0; j < lenWiggle; j += 1)addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
                    iWiggle += 1;
                } // var rnd2 = BMMath.random();
                var periods = time * freq;
                var perc = periods - Math1.floor(periods);
                var arr = createTypedArray('float32', lenWiggle);
                if (lenWiggle > 1) {
                    for(j = 0; j < lenWiggle; j += 1)arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    return arr;
                }
                return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type, duration) {
                return loopIn(type, duration, true);
            }
            function loopOutDuration(type, duration) {
                return loopOut(type, duration, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem1, elem2) {
                var fVec = [
                    elem2[0] - elem1[0],
                    elem2[1] - elem1[1],
                    elem2[2] - elem1[2]
                ];
                var pitch = Math1.atan2(fVec[0], Math1.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
                var yaw = -Math1.atan2(fVec[1], fVec[2]) / degToRads;
                return [
                    yaw,
                    pitch,
                    0
                ];
            }
            function easeOut(t, tMin, tMax, val1, val2) {
                return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
            }
            function easeIn(t, tMin, tMax, val1, val2) {
                return applyEase(easeInBez, t, tMin, tMax, val1, val2);
            }
            function ease(t, tMin, tMax, val1, val2) {
                return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
            }
            function applyEase(fn, t, tMin, tMax, val1, val2) {
                if (val1 === undefined) {
                    val1 = tMin;
                    val2 = tMax;
                } else t = (t - tMin) / (tMax - tMin);
                if (t > 1) t = 1;
                else if (t < 0) t = 0;
                var mult = fn(t);
                if ($bm_isInstanceOfArray(val1)) {
                    var iKey;
                    var lenKey = val1.length;
                    var arr = createTypedArray('float32', lenKey);
                    for(iKey = 0; iKey < lenKey; iKey += 1)arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
                    return arr;
                }
                return (val2 - val1) * mult + val1;
            }
            function nearestKey(time) {
                var iKey;
                var lenKey = data.k.length;
                var index;
                var keyTime;
                if (!data.k.length || typeof data.k[0] === 'number') {
                    index = 0;
                    keyTime = 0;
                } else {
                    index = -1;
                    time *= elem.comp.globalData.frameRate;
                    if (time < data.k[0].t) {
                        index = 1;
                        keyTime = data.k[0].t;
                    } else {
                        for(iKey = 0; iKey < lenKey - 1; iKey += 1){
                            if (time === data.k[iKey].t) {
                                index = iKey + 1;
                                keyTime = data.k[iKey].t;
                                break;
                            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                                    index = iKey + 2;
                                    keyTime = data.k[iKey + 1].t;
                                } else {
                                    index = iKey + 1;
                                    keyTime = data.k[iKey].t;
                                }
                                break;
                            }
                        }
                        if (index === -1) {
                            index = iKey + 1;
                            keyTime = data.k[iKey].t;
                        }
                    }
                }
                var obKey = {};
                obKey.index = index;
                obKey.time = keyTime / elem.comp.globalData.frameRate;
                return obKey;
            }
            function key(ind) {
                var obKey;
                var iKey;
                var lenKey;
                if (!data.k.length || typeof data.k[0] === 'number') throw new Error('The property has no keyframe at index ' + ind);
                ind -= 1;
                obKey = {
                    time: data.k[ind].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
                lenKey = arr.length;
                for(iKey = 0; iKey < lenKey; iKey += 1){
                    obKey[iKey] = arr[iKey];
                    obKey.value[iKey] = arr[iKey];
                }
                return obKey;
            }
            function framesToTime(fr, fps) {
                if (!fps) fps = elem.comp.globalData.frameRate;
                return fr / fps;
            }
            function timeToFrames(t, fps) {
                if (!t && t !== 0) t = time;
                if (!fps) fps = elem.comp.globalData.frameRate;
                return t * fps;
            }
            function seedRandom(seed) {
                BMMath.seedrandom(randSeed + seed);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substring(init);
                    return value.substring(init, end);
                }
                return '';
            }
            function substr(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substr(init);
                    return value.substr(init, end);
                }
                return '';
            }
            function posterizeTime(framesPerSecond) {
                time = framesPerSecond === 0 ? 0 : Math1.floor(time * framesPerSecond) / framesPerSecond;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math1.floor(Math1.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value) {
                // globalData.pushExpression();
                value = _value;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') return value;
                if (this.propType === 'textSelector') {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface('ADBE Transform Group');
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer('ADBE Root Vectors Group');
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            } // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window1,
            document1,
            XMLHttpRequest1,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob = {};
        ob.initExpressions = initExpressions;
        ob.resetFrame = ExpressionManager.resetFrame;
        function initExpressions(animation) {
            var stackCount = 0;
            var registers = [];
            function pushExpression() {
                stackCount += 1;
            }
            function popExpression() {
                stackCount -= 1;
                if (stackCount === 0) releaseInstances();
            }
            function registerExpressionProperty(expression) {
                if (registers.indexOf(expression) === -1) registers.push(expression);
            }
            function releaseInstances() {
                var i;
                var len = registers.length;
                for(i = 0; i < len; i += 1)registers[i].release();
                registers.length = 0;
            }
            animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
            animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
            animation.renderer.globalData.pushExpression = pushExpression;
            animation.renderer.globalData.popExpression = popExpression;
            animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
        }
        return ob;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface(mask, data) {
            this._mask = mask;
            this._data = data;
        }
        Object.defineProperty(MaskInterface.prototype, 'maskPath', {
            get: function get() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
            get: function get() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager = function MaskManager(maskManager) {
            var _masksInterfaces = createSizedArray(maskManager.viewData.length);
            var i;
            var len = maskManager.viewData.length;
            for(i = 0; i < len; i += 1)_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
            var maskFunction = function maskFunction(name) {
                i = 0;
                while(i < len){
                    if (maskManager.masksProperties[i].nm === name) return _masksInterfaces[i];
                    i += 1;
                }
                return null;
            };
            return maskFunction;
        };
        return MaskManager;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty(expressionValue, property, type) {
            Object.defineProperty(expressionValue, 'velocity', {
                get: function get() {
                    return property.getVelocityAtTime(property.comp.currentFrame);
                }
            });
            expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
            expressionValue.key = function(pos) {
                if (!expressionValue.numKeys) return 0;
                var value = '';
                if ('s' in property.keyframes[pos - 1]) value = property.keyframes[pos - 1].s;
                else if ('e' in property.keyframes[pos - 2]) value = property.keyframes[pos - 2].e;
                else value = property.keyframes[pos - 2].s;
                var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
                valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
                valueProp.value = type === 'unidimensional' ? value[0] : value;
                return valueProp;
            };
            expressionValue.valueAtTime = property.getValueAtTime;
            expressionValue.speedAtTime = property.getSpeedAtTime;
            expressionValue.velocityAtTime = property.getVelocityAtTime;
            expressionValue.propertyGroup = property.propertyGroup;
        }
        function UnidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultUnidimensionalValue;
            var mult = 1 / property.mult;
            var val = property.pv * mult;
            var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
            expressionValue.value = val;
            completeProperty(expressionValue, property, 'unidimensional');
            return function() {
                if (property.k) property.getValue();
                val = property.v * mult;
                if (expressionValue.value !== val) {
                    expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
                    expressionValue.value = val;
                    completeProperty(expressionValue, property, 'unidimensional');
                }
                return expressionValue;
            };
        }
        function MultidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultMultidimensionalValue;
            var mult = 1 / property.mult;
            var len = property.data && property.data.l || property.pv.length;
            var expressionValue = createTypedArray('float32', len);
            var arrValue = createTypedArray('float32', len);
            expressionValue.value = arrValue;
            completeProperty(expressionValue, property, 'multidimensional');
            return function() {
                if (property.k) property.getValue();
                for(var i = 0; i < len; i += 1){
                    arrValue[i] = property.v[i] * mult;
                    expressionValue[i] = arrValue[i];
                }
                return expressionValue;
            };
        } // TODO: try to avoid using this getter
        function defaultGetter() {
            return defaultUnidimensionalValue;
        }
        return function(property) {
            if (!property) return defaultGetter;
            if (property.propType === 'unidimensional') return UnidimensionalPropertyInterface(property);
            return MultidimensionalPropertyInterface(property);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform) {
            function _thisFunction(name) {
                switch(name){
                    case 'scale':
                    case 'Scale':
                    case 'ADBE Scale':
                    case 6:
                        return _thisFunction.scale;
                    case 'rotation':
                    case 'Rotation':
                    case 'ADBE Rotation':
                    case 'ADBE Rotate Z':
                    case 10:
                        return _thisFunction.rotation;
                    case 'ADBE Rotate X':
                        return _thisFunction.xRotation;
                    case 'ADBE Rotate Y':
                        return _thisFunction.yRotation;
                    case 'position':
                    case 'Position':
                    case 'ADBE Position':
                    case 2:
                        return _thisFunction.position;
                    case 'ADBE Position_0':
                        return _thisFunction.xPosition;
                    case 'ADBE Position_1':
                        return _thisFunction.yPosition;
                    case 'ADBE Position_2':
                        return _thisFunction.zPosition;
                    case 'anchorPoint':
                    case 'AnchorPoint':
                    case 'Anchor Point':
                    case 'ADBE AnchorPoint':
                    case 1:
                        return _thisFunction.anchorPoint;
                    case 'opacity':
                    case 'Opacity':
                    case 11:
                        return _thisFunction.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction, 'rotation', {
                get: ExpressionPropertyInterface(transform.r || transform.rz)
            });
            Object.defineProperty(_thisFunction, 'zRotation', {
                get: ExpressionPropertyInterface(transform.rz || transform.r)
            });
            Object.defineProperty(_thisFunction, 'xRotation', {
                get: ExpressionPropertyInterface(transform.rx)
            });
            Object.defineProperty(_thisFunction, 'yRotation', {
                get: ExpressionPropertyInterface(transform.ry)
            });
            Object.defineProperty(_thisFunction, 'scale', {
                get: ExpressionPropertyInterface(transform.s)
            });
            var _px;
            var _py;
            var _pz;
            var _transformFactory;
            if (transform.p) _transformFactory = ExpressionPropertyInterface(transform.p);
            else {
                _px = ExpressionPropertyInterface(transform.px);
                _py = ExpressionPropertyInterface(transform.py);
                if (transform.pz) _pz = ExpressionPropertyInterface(transform.pz);
            }
            Object.defineProperty(_thisFunction, 'position', {
                get: function get() {
                    if (transform.p) return _transformFactory();
                    return [
                        _px(),
                        _py(),
                        _pz ? _pz() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction, 'xPosition', {
                get: ExpressionPropertyInterface(transform.px)
            });
            Object.defineProperty(_thisFunction, 'yPosition', {
                get: ExpressionPropertyInterface(transform.py)
            });
            Object.defineProperty(_thisFunction, 'zPosition', {
                get: ExpressionPropertyInterface(transform.pz)
            });
            Object.defineProperty(_thisFunction, 'anchorPoint', {
                get: ExpressionPropertyInterface(transform.a)
            });
            Object.defineProperty(_thisFunction, 'opacity', {
                get: ExpressionPropertyInterface(transform.o)
            });
            Object.defineProperty(_thisFunction, 'skew', {
                get: ExpressionPropertyInterface(transform.sk)
            });
            Object.defineProperty(_thisFunction, 'skewAxis', {
                get: ExpressionPropertyInterface(transform.sa)
            });
            Object.defineProperty(_thisFunction, 'orientation', {
                get: ExpressionPropertyInterface(transform.or)
            });
            return _thisFunction;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix(time) {
            var toWorldMat = new Matrix();
            if (time !== undefined) {
                var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
                propMatrix.clone(toWorldMat);
            } else {
                var transformMat = this._elem.finalTransform.mProp;
                transformMat.applyToMatrix(toWorldMat);
            }
            return toWorldMat;
        }
        function toWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.applyPoint(toWorldMat, arr);
        }
        function toWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.applyPoint(toWorldMat, arr);
        }
        function fromWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.invertPoint(toWorldMat, arr);
        }
        function fromWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.invertPoint(toWorldMat, arr);
        }
        function applyPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
        }
        function invertPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.inversePoint(arr);
        }
        function fromComp(arr) {
            var toWorldMat = new Matrix();
            toWorldMat.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
                return toWorldMat.inversePoint(arr);
            }
            return toWorldMat.inversePoint(arr);
        }
        function sampleImage() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem) {
            var transformInterface;
            function _registerMaskInterface(maskManager) {
                _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
            }
            function _registerEffectsInterface(effects) {
                _thisLayerFunction.effect = effects;
            }
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Root Vectors Group':
                    case 'Contents':
                    case 2:
                        return _thisLayerFunction.shapeInterface;
                    case 1:
                    case 6:
                    case 'Transform':
                    case 'transform':
                    case 'ADBE Transform Group':
                        return transformInterface;
                    case 4:
                    case 'ADBE Effect Parade':
                    case 'effects':
                    case 'Effects':
                        return _thisLayerFunction.effect;
                    case 'ADBE Text Properties':
                        return _thisLayerFunction.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction.getMatrix = getMatrix;
            _thisLayerFunction.invertPoint = invertPoint;
            _thisLayerFunction.applyPoint = applyPoint;
            _thisLayerFunction.toWorld = toWorld;
            _thisLayerFunction.toWorldVec = toWorldVec;
            _thisLayerFunction.fromWorld = fromWorld;
            _thisLayerFunction.fromWorldVec = fromWorldVec;
            _thisLayerFunction.toComp = toWorld;
            _thisLayerFunction.fromComp = fromComp;
            _thisLayerFunction.sampleImage = sampleImage;
            _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
            _thisLayerFunction._elem = elem;
            transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
            var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
            Object.defineProperties(_thisLayerFunction, {
                hasParent: {
                    get: function get() {
                        return elem.hierarchy.length;
                    }
                },
                parent: {
                    get: function get() {
                        return elem.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface, 'rotation'),
                scale: getDescriptor(transformInterface, 'scale'),
                position: getDescriptor(transformInterface, 'position'),
                opacity: getDescriptor(transformInterface, 'opacity'),
                anchorPoint: anchorPointDescriptor,
                anchor_point: anchorPointDescriptor,
                transform: {
                    get: function get() {
                        return transformInterface;
                    }
                },
                active: {
                    get: function get() {
                        return elem.isInRange;
                    }
                }
            });
            _thisLayerFunction.startTime = elem.data.st;
            _thisLayerFunction.index = elem.data.ind;
            _thisLayerFunction.source = elem.data.refId;
            _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
            _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
            _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
            _thisLayerFunction._name = elem.data.nm;
            _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
            _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
            return _thisLayerFunction;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction, parentPropertyGroup) {
            return function(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return parentPropertyGroup(val - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName, propertyGroup) {
            var interfaceFunction = {
                _name: propertyName
            };
            function _propertyGroup(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return propertyGroup(val - 1);
            }
            return _propertyGroup;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob = {
            createEffectsInterface: createEffectsInterface
        };
        function createEffectsInterface(elem, propertyGroup) {
            if (elem.effectsManager) {
                var effectElements = [];
                var effectsData = elem.data.ef;
                var i;
                var len = elem.effectsManager.effectElements.length;
                for(i = 0; i < len; i += 1)effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
                var effects = elem.data.ef || [];
                var groupInterface = function groupInterface(name) {
                    i = 0;
                    len = effects.length;
                    while(i < len){
                        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) return effectElements[i];
                        i += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface, 'numProperties', {
                    get: function get() {
                        return effects.length;
                    }
                });
                return groupInterface;
            }
            return null;
        }
        function createGroupInterface(data, elements, propertyGroup, elem) {
            function groupInterface(name) {
                var effects = data.ef;
                var i = 0;
                var len = effects.length;
                while(i < len){
                    if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
                        if (effects[i].ty === 5) return effectElements[i];
                        return effectElements[i]();
                    }
                    i += 1;
                }
                throw new Error();
            }
            var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
            var effectElements = [];
            var i;
            var len = data.ef.length;
            for(i = 0; i < len; i += 1)if (data.ef[i].ty === 5) effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
            else effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
            if (data.mn === 'ADBE Color Control') Object.defineProperty(groupInterface, 'color', {
                get: function get() {
                    return effectElements[0]();
                }
            });
            Object.defineProperties(groupInterface, {
                numProperties: {
                    get: function get() {
                        return data.np;
                    }
                },
                _name: {
                    value: data.nm
                },
                propertyGroup: {
                    value: _propertyGroup
                }
            });
            groupInterface.enabled = data.en !== 0;
            groupInterface.active = groupInterface.enabled;
            return groupInterface;
        }
        function createValueInterface(element, type, elem, propertyGroup) {
            var expressionProperty = ExpressionPropertyInterface(element.p);
            function interfaceFunction() {
                if (type === 10) return elem.comp.compInterface(element.p.v);
                return expressionProperty();
            }
            if (element.p.setGroupProperty) element.p.setGroupProperty(PropertyInterface('', propertyGroup));
            return interfaceFunction;
        }
        return ob;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory(shape, view, propertyGroup) {
            var prop = view.sh;
            function interfaceFunction(val) {
                if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) return interfaceFunction.path;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                path: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                shape: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                _name: {
                    value: shape.nm
                },
                ix: {
                    value: shape.ix
                },
                propertyIndex: {
                    value: shape.ix
                },
                mn: {
                    value: shape.mn
                },
                propertyGroup: {
                    value: propertyGroup
                }
            });
            return interfaceFunction;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements(shapes, view, propertyGroup) {
            var arr = [];
            var i;
            var len = shapes ? shapes.length : 0;
            for(i = 0; i < len; i += 1){
                if (shapes[i].ty === 'gr') arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'fl') arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'st') arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tm') arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tr') ;
                else if (shapes[i].ty === 'el') arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sr') arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sh') arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rc') arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rd') arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rp') arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'gf') arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
            }
            return arr;
        }
        function contentsInterfaceFactory(shape, view, propertyGroup) {
            var interfaces;
            var interfaceFunction = function _interfaceFunction(value) {
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) return interfaces[i];
                    i += 1;
                }
                if (typeof value === 'number') return interfaces[value - 1];
                return null;
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
            interfaceFunction.numProperties = interfaces.length;
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.transform = transformInterface;
            interfaceFunction.propertyIndex = shape.cix;
            interfaceFunction._name = shape.nm;
            return interfaceFunction;
        }
        function groupInterfaceFactory(shape, view, propertyGroup) {
            var interfaceFunction = function _interfaceFunction(value) {
                switch(value){
                    case 'ADBE Vectors Group':
                    case 'Contents':
                    case 2:
                        return interfaceFunction.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction.transform;
                }
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, '_name', {
                get: function get() {
                    return shape.nm;
                }
            }); // interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function fillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function gradientFillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Start Point' || val === 'start point') return interfaceFunction.startPoint;
                if (val === 'End Point' || val === 'end point') return interfaceFunction.endPoint;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                startPoint: {
                    get: ExpressionPropertyInterface(view.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                type: {
                    get: function get() {
                        return 'a';
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function defaultInterfaceFactory() {
            function interfaceFunction() {
                return null;
            }
            return interfaceFunction;
        }
        function strokeInterfaceFactory(shape, view, propertyGroup) {
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: ExpressionPropertyInterface(view.d.dataProps[i].p)
                });
            }
            var i;
            var len = shape.d ? shape.d.length : 0;
            var dashOb = {};
            for(i = 0; i < len; i += 1){
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                if (val === 'Stroke Width' || val === 'stroke width') return interfaceFunction.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view.w)
                },
                dash: {
                    get: function get() {
                        return dashOb;
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
            return interfaceFunction;
        }
        function trimInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === shape.e.ix || val === 'End' || val === 'end') return interfaceFunction.end;
                if (val === shape.s.ix) return interfaceFunction.start;
                if (val === shape.o.ix) return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.propertyGroup = propertyGroup;
            Object.defineProperties(interfaceFunction, {
                start: {
                    get: ExpressionPropertyInterface(view.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function transformInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.a.ix === value || value === 'Anchor Point') return interfaceFunction.anchorPoint;
                if (shape.o.ix === value || value === 'Opacity') return interfaceFunction.opacity;
                if (shape.p.ix === value || value === 'Position') return interfaceFunction.position;
                if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') return interfaceFunction.rotation;
                if (shape.s.ix === value || value === 'Scale') return interfaceFunction.scale;
                if (shape.sk && shape.sk.ix === value || value === 'Skew') return interfaceFunction.skew;
                if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') return interfaceFunction.skewAxis;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
            view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
            view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (view.transform.mProps.sk) {
                view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
                view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
            }
            view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                opacity: {
                    get: ExpressionPropertyInterface(view.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sa)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.ty = 'tr';
            interfaceFunction.mn = shape.mn;
            interfaceFunction.propertyGroup = propertyGroup;
            return interfaceFunction;
        }
        function ellipseInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.s.ix === value) return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function starInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.rotation;
                if (shape.pt.ix === value) return interfaceFunction.points;
                if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') return interfaceFunction.outerRadius;
                if (shape.os.ix === value) return interfaceFunction.outerRoundness;
                if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) return interfaceFunction.innerRadius;
                if (shape.is && shape.is.ix === value) return interfaceFunction.innerRoundness;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
            prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
            prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (shape.ir) {
                prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
                prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
            }
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop.is)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function rectInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.roundness;
                if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function roundedInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.r.ix === value || value === 'Round Corners 1') return interfaceFunction.radius;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                radius: {
                    get: ExpressionPropertyInterface(prop.rd)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function repeaterInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.c.ix === value || value === 'Copies') return interfaceFunction.copies;
                if (shape.o.ix === value || value === 'Offset') return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
            prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                copies: {
                    get: ExpressionPropertyInterface(prop.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        return function(shapes, view, propertyGroup) {
            var interfaces;
            function _interfaceFunction(value) {
                if (typeof value === 'number') {
                    value = value === undefined ? 1 : value;
                    if (value === 0) return propertyGroup;
                    return interfaces[value - 1];
                }
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value) return interfaces[i];
                    i += 1;
                }
                return null;
            }
            function parentGroupWrapper() {
                return propertyGroup;
            }
            _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
            interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
            _interfaceFunction.numProperties = interfaces.length;
            _interfaceFunction._name = 'Contents';
            return _interfaceFunction;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem) {
            var _sourceText;
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Text Document':
                        return _thisLayerFunction.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction, 'sourceText', {
                get: function get() {
                    elem.textProperty.getValue();
                    var stringValue = elem.textProperty.currentData.t;
                    if (!_sourceText || stringValue !== _sourceText.value) {
                        _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText, 'style', {
                            get: function get() {
                                return {
                                    fillColor: elem.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText;
                }
            });
            return _thisLayerFunction;
        };
    }();
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof1(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof1(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
            var currentPropertyName = '';
            var currentProperty = elem.getFootageData();
            function init() {
                currentPropertyName = '';
                currentProperty = elem.getFootageData();
                return searchProperty;
            }
            function searchProperty(value) {
                if (currentProperty[value]) {
                    currentPropertyName = value;
                    currentProperty = currentProperty[value];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                var propertyNameIndex = value.indexOf(currentPropertyName);
                if (propertyNameIndex !== -1) {
                    var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
                    currentProperty = currentProperty[index];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                return '';
            }
            return init;
        };
        var dataInterfaceFactory = function dataInterfaceFactory(elem) {
            function interfaceFunction(value) {
                if (value === 'Outline') return interfaceFunction.outlineInterface();
                return null;
            }
            interfaceFunction._name = 'Outline';
            interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
            return interfaceFunction;
        };
        return function(elem) {
            function _interfaceFunction(value) {
                if (value === 'Data') return _interfaceFunction.dataInterface;
                return null;
            }
            _interfaceFunction._name = 'Data';
            _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
            return _interfaceFunction;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type) {
        return interfaces[type] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions(elem, data, prop) {
            if (data.x) {
                prop.k = true;
                prop.x = true;
                prop.initiateExpression = ExpressionManager.initiateExpression;
                prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
            }
        }
        function getValueAtTime(frameNum) {
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime(frameNum) {
            var delta = -0.01;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var speed = 0;
            if (v1.length) {
                var i;
                for(i = 0; i < v1.length; i += 1)speed += Math.pow(v2[i] - v1[i], 2);
                speed = Math.sqrt(speed) * 100;
            } else speed = 0;
            return speed;
        }
        function getVelocityAtTime(frameNum) {
            if (this.vel !== undefined) return this.vel;
            var delta = -0.001; // frameNum += this.elem.data.st;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var velocity;
            if (v1.length) {
                velocity = createTypedArray('float32', v1.length);
                var i;
                for(i = 0; i < v1.length; i += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i]) / delta;
            } else velocity = (v2 - v1) / delta;
            return velocity;
        }
        function getStaticValueAtTime() {
            return this.pv;
        }
        function setGroupProperty(propertyGroup) {
            this.propertyGroup = propertyGroup;
        }
        return {
            searchExpressions: searchExpressions,
            getSpeedAtTime: getSpeedAtTime,
            getVelocityAtTime: getVelocityAtTime,
            getValueAtTime: getValueAtTime,
            getStaticValueAtTime: getStaticValueAtTime,
            setGroupProperty: setGroupProperty
        };
    }();
    function addPropertyDecorator() {
        function loopOut(type, duration, durationFlag) {
            if (!this.k || !this.keyframes) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if (currentFrame <= lastKeyFrame) return this.pv;
            var cycleDuration;
            var firstKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
                else cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
                firstKeyFrame = lastKeyFrame - cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (iterations % 2 !== 0) return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = (endV[i] - initV[i]) * repeats + current[i];
                    return ret;
                }
                return (endV - initV) * repeats + current;
            } else if (type === 'continue') {
                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(lastValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret;
                }
                return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
            }
            return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn(type, duration, durationFlag) {
            if (!this.k) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if (currentFrame >= firstKeyFrame) return this.pv;
            var cycleDuration;
            var lastKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                lastKeyFrame = keyframes[duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
                else cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
                lastKeyFrame = firstKeyFrame + cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
                if (iterations % 2 === 0) return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
                    return ret;
                }
                return current - (endV - initV) * repeats;
            } else if (type === 'continue') {
                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(firstValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
                    return ret;
                }
                return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
            }
            return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth(width, samples) {
            if (!this.k) return this.pv;
            width = (width || 0.4) * 0.5;
            samples = Math.floor(samples || 5);
            if (samples <= 1) return this.pv;
            var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame = currentTime - width;
            var endFrame = currentTime + width;
            var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
            var i = 0;
            var j = 0;
            var value;
            if (this.pv.length) value = createTypedArray('float32', this.pv.length);
            else value = 0;
            var sampleValue;
            while(i < samples){
                sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
                if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] += sampleValue[j];
                else value += sampleValue;
                i += 1;
            }
            if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] /= samples;
            else value /= samples;
            return value;
        }
        function getTransformValueAtTime(time) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
             /// /
            var matrix = this._transformCachingAtTime.v;
            matrix.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor = this.a.getValueAtTime(time);
                matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale = this.s.getValueAtTime(time);
                matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew = this.sk.getValueAtTime(time);
                var skewAxis = this.sa.getValueAtTime(time);
                matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation = this.r.getValueAtTime(time);
                matrix.rotate(-rotation * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ = this.rz.getValueAtTime(time);
                var rotationY = this.ry.getValueAtTime(time);
                var rotationX = this.rx.getValueAtTime(time);
                var orientation = this.or.getValueAtTime(time);
                matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX = this.px.getValueAtTime(time);
                var positionY = this.py.getValueAtTime(time);
                if (this.data.p.z) {
                    var positionZ = this.pz.getValueAtTime(time);
                    matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
                } else matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
            } else {
                var position = this.p.getValueAtTime(time);
                matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
            }
            return matrix; /// /
        }
        function getTransformStaticValueAtTime() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
            var prop = getTransformProperty(elem, data, container);
            if (prop.dynamicProperties.length) prop.getValueAtTime = getTransformValueAtTime.bind(prop);
            else prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop;
        };
        var propertyGetProp = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem, data, type, mult, container) {
            var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop.kf) prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
            else prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            prop.loopOut = loopOut;
            prop.loopIn = loopIn;
            prop.smooth = smooth;
            prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
            prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
            prop.numKeys = data.a === 1 ? data.k.length : 0;
            prop.propertyIndex = data.ix;
            var value = 0;
            if (type !== 0) value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
            prop._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value
            };
            expressionHelpers.searchExpressions(elem, data, prop);
            if (prop.k) container.addDynamicProperty(prop);
            return prop;
        };
        function getShapeValueAtTime(frameNum) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum;
                this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions() {}
        ShapeExpressions.prototype = {
            vertices: function vertices(prop, time) {
                if (this.k) this.getValue();
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                var i;
                var len = shapePath._length;
                var vertices = shapePath[prop];
                var points = shapePath.v;
                var arr = createSizedArray(len);
                for(i = 0; i < len; i += 1)if (prop === 'i' || prop === 'o') arr[i] = [
                    vertices[i][0] - points[i][0],
                    vertices[i][1] - points[i][1]
                ];
                else arr[i] = [
                    vertices[i][0],
                    vertices[i][1]
                ];
                return arr;
            },
            points: function points(time) {
                return this.vertices('v', time);
            },
            inTangents: function inTangents(time) {
                return this.vertices('i', time);
            },
            outTangents: function outTangents(time) {
                return this.vertices('o', time);
            },
            isClosed: function isClosed() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath(perc, time) {
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath);
                var segmentsLength = this._segmentsLength;
                var lengths = segmentsLength.lengths;
                var lengthPos = segmentsLength.totalLength * perc;
                var i = 0;
                var len = lengths.length;
                var accumulatedLength = 0;
                var pt;
                while(i < len){
                    if (accumulatedLength + lengths[i].addedLength > lengthPos) {
                        var initIndex = i;
                        var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
                        var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
                        pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
                        break;
                    } else accumulatedLength += lengths[i].addedLength;
                    i += 1;
                }
                if (!pt) pt = shapePath.c ? [
                    shapePath.v[0][0],
                    shapePath.v[0][1]
                ] : [
                    shapePath.v[shapePath._length - 1][0],
                    shapePath.v[shapePath._length - 1][1]
                ];
                return pt;
            },
            vectorOnPath: function vectorOnPath(perc, time, vectorType) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc == 1) // eslint-disable-line eqeqeq
                perc = this.v.c;
                else if (perc == 0) // eslint-disable-line eqeqeq
                perc = 0.999;
                var pt1 = this.pointOnPath(perc, time);
                var pt2 = this.pointOnPath(perc + 0.001, time);
                var xLength = pt2[0] - pt1[0];
                var yLength = pt2[1] - pt1[1];
                var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
                if (magnitude === 0) return [
                    0,
                    0
                ];
                var unitVector = vectorType === 'tangent' ? [
                    xLength / magnitude,
                    yLength / magnitude
                ] : [
                    -yLength / magnitude,
                    xLength / magnitude
                ];
                return unitVector;
            },
            tangentOnPath: function tangentOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'tangent');
            },
            normalOnPath: function normalOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'normal');
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions
        ], ShapePropertyConstructorFunction);
        extendPrototype([
            ShapeExpressions
        ], KeyframedShapePropertyConstructorFunction);
        KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
        KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem, data, type, arr, trims) {
            var prop = propertyGetShapeProp(elem, data, type, arr, trims);
            prop.propertyIndex = data.ix;
            prop.lock = false;
            if (type === 3) expressionHelpers.searchExpressions(elem, data.pt, prop);
            else if (type === 4) expressionHelpers.searchExpressions(elem, data.ks, prop);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue, text) {
            var newValue = this.calculateExpression(text);
            if (currentValue.t !== newValue) {
                var newData = {};
                this.copyData(newData, currentValue);
                newData.t = newValue.toString();
                newData.__complete = false;
                return newData;
            }
            return currentValue;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed = this.searchKeyframes();
            var hasExpressions = this.searchExpressions();
            this.kf = isKeyframed || hasExpressions;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode(resultId, ins) {
            var feMerge = createNS('feMerge');
            feMerge.setAttribute('result', resultId);
            var feMergeNode;
            var i;
            for(i = 0; i < ins.length; i += 1){
                feMergeNode = createNS('feMergeNode');
                feMergeNode.setAttribute('in', ins[i]);
                feMerge.appendChild(feMergeNode);
                feMerge.appendChild(feMergeNode);
            }
            return feMerge;
        }
    };
    var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';
    function SVGTintFilter(filter, filterManager, elem, id, source) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
        this.linearFilter = feColorMatrix;
        feColorMatrix.setAttribute('result', id + '_tint_1');
        filter.appendChild(feColorMatrix);
        feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id + '_tint_2');
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
        var feMerge = this.createMergeNode(id, [
            source,
            id + '_tint_1',
            id + '_tint_2'
        ]);
        filter.appendChild(feMerge);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var colorBlack = this.filterManager.effectElements[0].p.v;
            var colorWhite = this.filterManager.effectElements[1].p.v;
            var opacity = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
            this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
        }
    };
    function SVGFillFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id);
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color = this.filterManager.effectElements[2].p.v;
            var opacity = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
        }
    };
    function SVGStrokeEffect(fil, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.elem = elem;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path;
        var groupPath;
        var i;
        var len;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len = this.elem.maskManager.masksProperties.length;
            i = 0;
        } else {
            i = this.filterManager.effectElements[0].p.v - 1;
            len = i + 1;
        }
        groupPath = createNS('g');
        groupPath.setAttribute('fill', 'none');
        groupPath.setAttribute('stroke-linecap', 'round');
        groupPath.setAttribute('stroke-dashoffset', 1);
        for(i; i < len; i += 1){
            path = createNS('path');
            groupPath.appendChild(path);
            this.paths.push({
                p: path,
                m: i
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask = createNS('mask');
            var id = createElementID();
            mask.setAttribute('id', id);
            mask.setAttribute('mask-type', 'alpha');
            mask.appendChild(groupPath);
            this.elem.globalData.defs.appendChild(mask);
            var g = createNS('g');
            g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
            while(elemChildren[0])g.appendChild(elemChildren[0]);
            this.elem.layerElement.appendChild(g);
            this.masker = mask;
            groupPath.setAttribute('stroke', '#fff');
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren.length)this.elem.layerElement.removeChild(elemChildren[0]);
            }
            this.elem.layerElement.appendChild(groupPath);
            this.elem.layerElement.removeAttribute('mask');
            groupPath.setAttribute('stroke', '#fff');
        }
        this.initialized = true;
        this.pathMasker = groupPath;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender) {
        if (!this.initialized) this.initialize();
        var i;
        var len = this.paths.length;
        var mask;
        var path;
        for(i = 0; i < len; i += 1)if (this.paths[i].m !== -1) {
            mask = this.elem.maskManager.viewData[this.paths[i].m];
            path = this.paths[i].p;
            if (forceRender || this.filterManager._mdf || mask.prop._mdf) path.setAttribute('d', mask.lastPath);
            if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
                var dasharrayValue;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l = path.getTotalLength();
                    dasharrayValue = '0 0 0 ' + l * s + ' ';
                    var lineLength = l * (e - s);
                    var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units = Math.floor(lineLength / segment);
                    var j;
                    for(j = 0; j < units; j += 1)dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
                    dasharrayValue += '0 ' + l * 10 + ' 0 0';
                } else dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path.setAttribute('stroke-dasharray', dasharrayValue);
            }
        }
        if (forceRender || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
        if (forceRender || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender || this.filterManager.effectElements[3].p._mdf) {
                var color = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
            }
        }
    };
    function SVGTritoneFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
        filter.appendChild(feColorMatrix);
        var feComponentTransfer = createNS('feComponentTransfer');
        feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
        feComponentTransfer.setAttribute('result', id);
        this.matrixFilter = feComponentTransfer;
        var feFuncR = createNS('feFuncR');
        feFuncR.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncR);
        this.feFuncR = feFuncR;
        var feFuncG = createNS('feFuncG');
        feFuncG.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncG);
        this.feFuncG = feFuncG;
        var feFuncB = createNS('feFuncB');
        feFuncB.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncB);
        this.feFuncB = feFuncB;
        filter.appendChild(feComponentTransfer);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color1 = this.filterManager.effectElements[0].p.v;
            var color2 = this.filterManager.effectElements[1].p.v;
            var color3 = this.filterManager.effectElements[2].p.v;
            var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
            var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
            var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
            this.feFuncR.setAttribute('tableValues', tableR);
            this.feFuncG.setAttribute('tableValues', tableG);
            this.feFuncB.setAttribute('tableValues', tableB);
        }
    };
    function SVGProLevelsFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var effectElements = this.filterManager.effectElements;
        var feComponentTransfer = createNS('feComponentTransfer'); // Red
        if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
         // Green
        if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
         // Blue
        if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
         // Alpha
        if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
         // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            filter.appendChild(feComponentTransfer);
        }
        if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
            feComponentTransfer = createNS('feComponentTransfer');
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            feComponentTransfer.setAttribute('result', id);
            filter.appendChild(feComponentTransfer);
            this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
            this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
            this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
        var feFunc = createNS(type);
        feFunc.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFunc);
        return feFunc;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
        var cnt = 0;
        var segments = 256;
        var perc;
        var min = Math.min(inputBlack, inputWhite);
        var max = Math.max(inputBlack, inputWhite);
        var table = Array.call(null, {
            length: segments
        });
        var colorValue;
        var pos = 0;
        var outputDelta = outputWhite - outputBlack;
        var inputDelta = inputWhite - inputBlack;
        while(cnt <= 256){
            perc = cnt / 256;
            if (perc <= min) colorValue = inputDelta < 0 ? outputWhite : outputBlack;
            else if (perc >= max) colorValue = inputDelta < 0 ? outputBlack : outputWhite;
            else colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
            table[pos] = colorValue;
            pos += 1;
            cnt += 256 / (segments - 1);
        }
        return table.join(' ');
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var val;
            var effectElements = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
                val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
                this.feFuncRComposed.setAttribute('tableValues', val);
                this.feFuncGComposed.setAttribute('tableValues', val);
                this.feFuncBComposed.setAttribute('tableValues', val);
            }
            if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
                val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
                this.feFuncR.setAttribute('tableValues', val);
            }
            if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
                val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
                this.feFuncG.setAttribute('tableValues', val);
            }
            if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
                val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
                this.feFuncB.setAttribute('tableValues', val);
            }
            if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
                val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
                this.feFuncA.setAttribute('tableValues', val);
            }
        }
    };
    function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
        var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
        var filterSize = filterManager.data.fs || globalFilterSize;
        filter.setAttribute('x', filterSize.x || globalFilterSize.x);
        filter.setAttribute('y', filterSize.y || globalFilterSize.y);
        filter.setAttribute('width', filterSize.width || globalFilterSize.width);
        filter.setAttribute('height', filterSize.height || globalFilterSize.height);
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('in', 'SourceAlpha');
        feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
        feGaussianBlur.setAttribute('stdDeviation', '0');
        this.feGaussianBlur = feGaussianBlur;
        filter.appendChild(feGaussianBlur);
        var feOffset = createNS('feOffset');
        feOffset.setAttribute('dx', '25');
        feOffset.setAttribute('dy', '0');
        feOffset.setAttribute('in', id + '_drop_shadow_1');
        feOffset.setAttribute('result', id + '_drop_shadow_2');
        this.feOffset = feOffset;
        filter.appendChild(feOffset);
        var feFlood = createNS('feFlood');
        feFlood.setAttribute('flood-color', '#00ff00');
        feFlood.setAttribute('flood-opacity', '1');
        feFlood.setAttribute('result', id + '_drop_shadow_3');
        this.feFlood = feFlood;
        filter.appendChild(feFlood);
        var feComposite = createNS('feComposite');
        feComposite.setAttribute('in', id + '_drop_shadow_3');
        feComposite.setAttribute('in2', id + '_drop_shadow_2');
        feComposite.setAttribute('operator', 'in');
        feComposite.setAttribute('result', id + '_drop_shadow_4');
        filter.appendChild(feComposite);
        var feMerge = this.createMergeNode(id, [
            id + '_drop_shadow_4',
            source
        ]);
        filter.appendChild(feMerge); //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            if (forceRender || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
            if (forceRender || this.filterManager.effectElements[0].p._mdf) {
                var col = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
            }
            if (forceRender || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
            if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance = this.filterManager.effectElements[3].p.v;
                var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x = distance * Math.cos(angle);
                var y = distance * Math.sin(angle);
                this.feOffset.setAttribute('dx', x);
                this.feOffset.setAttribute('dy', y);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.filterElem = filterElem;
        this.elem = elem;
        elem.matteElement = createNS('g');
        elem.matteElement.appendChild(elem.layerElement);
        elem.matteElement.appendChild(elem.transformedElement);
        elem.baseElement = elem.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask) {
        var i = 0;
        var len = _svgMatteSymbols.length;
        while(i < len){
            if (_svgMatteSymbols[i] === mask) return _svgMatteSymbols[i];
            i += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
        var parentNode = mask.layerElement.parentNode;
        if (!parentNode) return;
        var children = parentNode.children;
        var i = 0;
        var len = children.length;
        while(i < len){
            if (children[i] === mask.layerElement) break;
            i += 1;
        }
        var nextChild;
        if (i <= len - 2) nextChild = children[i + 1];
        var useElem = createNS('use');
        useElem.setAttribute('href', '#' + symbolId);
        if (nextChild) parentNode.insertBefore(useElem, nextChild);
        else parentNode.appendChild(useElem);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
        if (!this.findSymbol(mask)) {
            var symbolId = createElementID();
            var masker = createNS('mask');
            masker.setAttribute('id', mask.layerId);
            masker.setAttribute('mask-type', 'alpha');
            _svgMatteSymbols.push(mask);
            var defs = elem.globalData.defs;
            defs.appendChild(masker);
            var symbol = createNS('symbol');
            symbol.setAttribute('id', symbolId);
            this.replaceInParent(mask, symbolId);
            symbol.appendChild(mask.layerElement);
            defs.appendChild(symbol);
            var useElem = createNS('use');
            useElem.setAttribute('href', '#' + symbolId);
            masker.appendChild(useElem);
            mask.data.hd = false;
            mask.show();
        }
        elem.setMatte(mask.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind = this.filterManager.effectElements[0].p.v;
        var elements = this.elem.comp.elements;
        var i = 0;
        var len = elements.length;
        while(i < len){
            if (elements[i] && elements[i].data.ind === ind) this.setElementAsMask(this.elem, elements[i]);
            i += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter.setAttribute('x', '-100%');
        filter.setAttribute('y', '-100%');
        filter.setAttribute('width', '300%');
        filter.setAttribute('height', '300%');
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('result', id);
        filter.appendChild(feGaussianBlur);
        this.feGaussianBlur = feGaussianBlur;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma = 0.3;
            var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions = this.filterManager.effectElements[1].p.v;
            var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
            var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager) {
        this.effectsManager = effectsManager;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame || this.effectsManager._mdf) {
            var effectElements = this.effectsManager.effectElements;
            var anchor = effectElements[0].p.v;
            var position = effectElements[1].p.v;
            var isUniformScale = effectElements[2].p.v === 1;
            var scaleHeight = effectElements[3].p.v;
            var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
            var skew = effectElements[5].p.v;
            var skewAxis = effectElements[6].p.v;
            var rotation = effectElements[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
            this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
            this.matrix.rotate(-rotation * degToRads);
            this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
            this.matrix.translate(position[0], position[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements[8].p.v) {
                this.opacity = effectElements[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_, filterManager) {
        this.init(filterManager);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager) {
        this.init(effectsManager);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    registerRenderer('canvas', CanvasRenderer);
    registerRenderer('html', HybridRenderer);
    registerRenderer('svg', SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier('tm', TrimModifier);
    ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
    ShapeModifiers.registerModifier('rp', RepeaterModifier);
    ShapeModifiers.registerModifier('rd', RoundCornersModifier);
    ShapeModifiers.registerModifier('zz', ZigZagModifier);
    ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize(); // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});

parcelRegister("4kfzs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $32651bbfef366712$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $32651bbfef366712$export$2e2bcd8739ae039; });
function $32651bbfef366712$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $32651bbfef366712$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $32651bbfef366712$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $32651bbfef366712$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $32651bbfef366712$export$2e2bcd8739ae039 = $32651bbfef366712$export$4f5d2d50c9deca37;

});

parcelRegister("4wvvx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $34b2976058f700f7$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $34b2976058f700f7$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $34b2976058f700f7$var$getPrefix;
const $34b2976058f700f7$var$prefixes = [
    'Moz',
    'Webkit',
    'O',
    'ms'
];
function $34b2976058f700f7$var$getPrefix() /*: string*/ {
    var _window$document;
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === 'undefined') return '';
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
    if (!style) return '';
    if (prop in style) return '';
    for(let i = 0; i < $34b2976058f700f7$var$prefixes.length; i++){
        if ($34b2976058f700f7$var$browserPrefixToKey(prop, $34b2976058f700f7$var$prefixes[i]) in style) return $34b2976058f700f7$var$prefixes[i];
    }
    return '';
}
function $34b2976058f700f7$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "".concat(prefix).concat($34b2976058f700f7$var$kebabToTitleCase(prop)) : prop;
}
function $34b2976058f700f7$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $34b2976058f700f7$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = '';
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $34b2976058f700f7$var$_default = module.exports.default = $34b2976058f700f7$var$getPrefix();

});

parcelRegister("eBJyY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa27dd4a3e5c865e$var$React = $aa27dd4a3e5c865e$var$_interopRequireWildcard((parcelRequire("8nGP5")));

var $aa27dd4a3e5c865e$var$_propTypes = $aa27dd4a3e5c865e$var$_interopRequireDefault((parcelRequire("ebCsu")));

var $aa27dd4a3e5c865e$var$_reactDom = $aa27dd4a3e5c865e$var$_interopRequireDefault((parcelRequire("fCKK7")));

var $9aSVH = parcelRequire("9aSVH");

var $fbPNc = parcelRequire("fbPNc");

var $7i6sP = parcelRequire("7i6sP");

var $aa27dd4a3e5c865e$var$_log = $aa27dd4a3e5c865e$var$_interopRequireDefault((parcelRequire("iI5jz")));
function $aa27dd4a3e5c865e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aa27dd4a3e5c865e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($aa27dd4a3e5c865e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $aa27dd4a3e5c865e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $aa27dd4a3e5c865e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $aa27dd4a3e5c865e$var$_defineProperty(obj, key, value) {
    key = $aa27dd4a3e5c865e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aa27dd4a3e5c865e$var$_toPropertyKey(arg) {
    var key = $aa27dd4a3e5c865e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $aa27dd4a3e5c865e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $aa27dd4a3e5c865e$var$eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
// Default to mouse events.
let $aa27dd4a3e5c865e$var$dragEventFor = $aa27dd4a3e5c865e$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $aa27dd4a3e5c865e$var$DraggableCore extends $aa27dd4a3e5c865e$var$React.Component /*:: <DraggableCoreProps>*/  {
    constructor(){
        super(...arguments);
        $aa27dd4a3e5c865e$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $aa27dd4a3e5c865e$var$_defineProperty(this, "lastX", NaN);
        $aa27dd4a3e5c865e$var$_defineProperty(this, "lastY", NaN);
        $aa27dd4a3e5c865e$var$_defineProperty(this, "touchIdentifier", null);
        $aa27dd4a3e5c865e$var$_defineProperty(this, "mounted", false);
        $aa27dd4a3e5c865e$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error('<DraggableCore> not mounted on DragStart!');
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $9aSVH.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $9aSVH.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === 'touchstart') e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $9aSVH.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $fbPNc.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $fbPNc.createCoreData)(this, x, y);
            (0, $aa27dd4a3e5c865e$var$_log.default)('DraggableCore: handleDragStart: %j', coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $aa27dd4a3e5c865e$var$_log.default)('calling', this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $9aSVH.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $9aSVH.addEvent)(ownerDocument, $aa27dd4a3e5c865e$var$dragEventFor.move, this.handleDrag);
            (0, $9aSVH.addEvent)(ownerDocument, $aa27dd4a3e5c865e$var$dragEventFor.stop, this.handleDragStop);
        });
        $aa27dd4a3e5c865e$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $fbPNc.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $fbPNc.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $fbPNc.createCoreData)(this, x, y);
            (0, $aa27dd4a3e5c865e$var$_log.default)('DraggableCore: handleDrag: %j', coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent('mouseup'));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent('MouseEvents');
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $aa27dd4a3e5c865e$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $fbPNc.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $fbPNc.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $fbPNc.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $9aSVH.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $aa27dd4a3e5c865e$var$_log.default)('DraggableCore: handleDragStop: %j', coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $aa27dd4a3e5c865e$var$_log.default)('DraggableCore: Removing handlers');
                (0, $9aSVH.removeEvent)(thisNode.ownerDocument, $aa27dd4a3e5c865e$var$dragEventFor.move, this.handleDrag);
                (0, $9aSVH.removeEvent)(thisNode.ownerDocument, $aa27dd4a3e5c865e$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $aa27dd4a3e5c865e$var$_defineProperty(this, "onMouseDown", (e)=>{
            $aa27dd4a3e5c865e$var$dragEventFor = $aa27dd4a3e5c865e$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $aa27dd4a3e5c865e$var$_defineProperty(this, "onMouseUp", (e)=>{
            $aa27dd4a3e5c865e$var$dragEventFor = $aa27dd4a3e5c865e$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $aa27dd4a3e5c865e$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $aa27dd4a3e5c865e$var$dragEventFor = $aa27dd4a3e5c865e$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $aa27dd4a3e5c865e$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $aa27dd4a3e5c865e$var$dragEventFor = $aa27dd4a3e5c865e$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $9aSVH.addEvent)(thisNode, $aa27dd4a3e5c865e$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $9aSVH.removeEvent)(ownerDocument, $aa27dd4a3e5c865e$var$eventsFor.mouse.move, this.handleDrag);
            (0, $9aSVH.removeEvent)(ownerDocument, $aa27dd4a3e5c865e$var$eventsFor.touch.move, this.handleDrag);
            (0, $9aSVH.removeEvent)(ownerDocument, $aa27dd4a3e5c865e$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $9aSVH.removeEvent)(ownerDocument, $aa27dd4a3e5c865e$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $9aSVH.removeEvent)(thisNode, $aa27dd4a3e5c865e$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $9aSVH.removeUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props, _this$props2;
        return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : $aa27dd4a3e5c865e$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $aa27dd4a3e5c865e$var$React.cloneElement($aa27dd4a3e5c865e$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
}
module.exports.default = $aa27dd4a3e5c865e$var$DraggableCore;
$aa27dd4a3e5c865e$var$_defineProperty($aa27dd4a3e5c865e$var$DraggableCore, "displayName", 'DraggableCore');
$aa27dd4a3e5c865e$var$_defineProperty($aa27dd4a3e5c865e$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $aa27dd4a3e5c865e$var$_propTypes.default.bool,
    children: $aa27dd4a3e5c865e$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $aa27dd4a3e5c865e$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $aa27dd4a3e5c865e$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $aa27dd4a3e5c865e$var$_propTypes.default.arrayOf($aa27dd4a3e5c865e$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $aa27dd4a3e5c865e$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $aa27dd4a3e5c865e$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $aa27dd4a3e5c865e$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $aa27dd4a3e5c865e$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $aa27dd4a3e5c865e$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $aa27dd4a3e5c865e$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $aa27dd4a3e5c865e$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $aa27dd4a3e5c865e$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $7i6sP.dontSetMe,
    style: $7i6sP.dontSetMe,
    transform: $7i6sP.dontSetMe
});
$aa27dd4a3e5c865e$var$_defineProperty($aa27dd4a3e5c865e$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("9aSVH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $6adfa816cc691178$var$addClassName;
module.exports.addEvent = $6adfa816cc691178$var$addEvent;
module.exports.addUserSelectStyles = $6adfa816cc691178$var$addUserSelectStyles;
module.exports.createCSSTransform = $6adfa816cc691178$var$createCSSTransform;
module.exports.createSVGTransform = $6adfa816cc691178$var$createSVGTransform;
module.exports.getTouch = $6adfa816cc691178$var$getTouch;
module.exports.getTouchIdentifier = $6adfa816cc691178$var$getTouchIdentifier;
module.exports.getTranslation = $6adfa816cc691178$var$getTranslation;
module.exports.innerHeight = $6adfa816cc691178$var$innerHeight;
module.exports.innerWidth = $6adfa816cc691178$var$innerWidth;
module.exports.matchesSelector = $6adfa816cc691178$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $6adfa816cc691178$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $6adfa816cc691178$var$offsetXYFromParent;
module.exports.outerHeight = $6adfa816cc691178$var$outerHeight;
module.exports.outerWidth = $6adfa816cc691178$var$outerWidth;
module.exports.removeClassName = $6adfa816cc691178$var$removeClassName;
module.exports.removeEvent = $6adfa816cc691178$var$removeEvent;
module.exports.removeUserSelectStyles = $6adfa816cc691178$var$removeUserSelectStyles;

var $7i6sP = parcelRequire("7i6sP");

var $6adfa816cc691178$var$_getPrefix = $6adfa816cc691178$var$_interopRequireWildcard((parcelRequire("4wvvx")));
function $6adfa816cc691178$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6adfa816cc691178$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6adfa816cc691178$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6adfa816cc691178$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $6adfa816cc691178$var$matchesSelectorFunc = '';
function $6adfa816cc691178$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$6adfa816cc691178$var$matchesSelectorFunc) $6adfa816cc691178$var$matchesSelectorFunc = (0, $7i6sP.findInArray)([
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $7i6sP.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $7i6sP.isFunction)(el[$6adfa816cc691178$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$6adfa816cc691178$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $6adfa816cc691178$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($6adfa816cc691178$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $6adfa816cc691178$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
}
function $6adfa816cc691178$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
}
function $6adfa816cc691178$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $7i6sP.int)(computedStyle.borderTopWidth);
    height += (0, $7i6sP.int)(computedStyle.borderBottomWidth);
    return height;
}
function $6adfa816cc691178$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $7i6sP.int)(computedStyle.borderLeftWidth);
    width += (0, $7i6sP.int)(computedStyle.borderRightWidth);
    return width;
}
function $6adfa816cc691178$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $7i6sP.int)(computedStyle.paddingTop);
    height -= (0, $7i6sP.int)(computedStyle.paddingBottom);
    return height;
}
function $6adfa816cc691178$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $7i6sP.int)(computedStyle.paddingLeft);
    width -= (0, $7i6sP.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $6adfa816cc691178$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $6adfa816cc691178$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $6adfa816cc691178$var$getTranslation(controlPos, positionOffset, 'px');
    return {
        [(0, $6adfa816cc691178$var$_getPrefix.browserPrefixToKey)('transform', $6adfa816cc691178$var$_getPrefix.default)]: translation
    };
}
function $6adfa816cc691178$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $6adfa816cc691178$var$getTranslation(controlPos, positionOffset, '');
    return translation;
}
function $6adfa816cc691178$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        const defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
        const defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $6adfa816cc691178$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $7i6sP.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $7i6sP.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $6adfa816cc691178$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $6adfa816cc691178$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) $6adfa816cc691178$var$addClassName(doc.body, 'react-draggable-transparent-selection');
}
function $6adfa816cc691178$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $6adfa816cc691178$var$removeClassName(doc.body, 'react-draggable-transparent-selection');
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $6adfa816cc691178$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $6adfa816cc691178$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
}

});
parcelRegister("7i6sP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $54ef3a71b0f9cde4$var$dontSetMe;
module.exports.findInArray = $54ef3a71b0f9cde4$var$findInArray;
module.exports.int = $54ef3a71b0f9cde4$var$int;
module.exports.isFunction = $54ef3a71b0f9cde4$var$isFunction;
module.exports.isNum = $54ef3a71b0f9cde4$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $54ef3a71b0f9cde4$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $54ef3a71b0f9cde4$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function $54ef3a71b0f9cde4$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === 'number' && !isNaN(num);
}
function $54ef3a71b0f9cde4$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $54ef3a71b0f9cde4$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});


parcelRegister("fbPNc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $b0f00f03a45cf533$var$canDragX;
module.exports.canDragY = $b0f00f03a45cf533$var$canDragY;
module.exports.createCoreData = $b0f00f03a45cf533$var$createCoreData;
module.exports.createDraggableData = $b0f00f03a45cf533$var$createDraggableData;
module.exports.getBoundPosition = $b0f00f03a45cf533$var$getBoundPosition;
module.exports.getControlPosition = $b0f00f03a45cf533$var$getControlPosition;
module.exports.snapToGrid = $b0f00f03a45cf533$var$snapToGrid;

var $7i6sP = parcelRequire("7i6sP");

var $9aSVH = parcelRequire("9aSVH");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $b0f00f03a45cf533$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === 'string' ? bounds : $b0f00f03a45cf533$var$cloneBounds(bounds);
    const node = $b0f00f03a45cf533$var$findDOMNode(draggable);
    if (typeof bounds === 'string') {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === 'parent') boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $7i6sP.int)(boundNodeStyle.paddingLeft) + (0, $7i6sP.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $7i6sP.int)(boundNodeStyle.paddingTop) + (0, $7i6sP.int)(nodeStyle.marginTop),
            right: (0, $9aSVH.innerWidth)(boundNodeEl) - (0, $9aSVH.outerWidth)(node) - node.offsetLeft + (0, $7i6sP.int)(boundNodeStyle.paddingRight) - (0, $7i6sP.int)(nodeStyle.marginRight),
            bottom: (0, $9aSVH.innerHeight)(boundNodeEl) - (0, $9aSVH.outerHeight)(node) - node.offsetTop + (0, $7i6sP.int)(boundNodeStyle.paddingBottom) - (0, $7i6sP.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $7i6sP.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $7i6sP.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $7i6sP.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $7i6sP.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $b0f00f03a45cf533$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $b0f00f03a45cf533$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function $b0f00f03a45cf533$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}
// Get {x, y} positions from event.
function $b0f00f03a45cf533$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === 'number' ? (0, $9aSVH.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
    const node = $b0f00f03a45cf533$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $9aSVH.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $b0f00f03a45cf533$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $7i6sP.isNum)(draggable.lastX);
    const node = $b0f00f03a45cf533$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $b0f00f03a45cf533$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $b0f00f03a45cf533$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $b0f00f03a45cf533$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error('<DraggableCore>: Unmounted during event!');
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("iI5jz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d9f0756950235782$var$log;
/*eslint no-console:0*/ function $d9f0756950235782$var$log() {}

});


parcelRegister("4kwnA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3272258f0af3cbc3$export$2e2bcd8739ae039; });

var $u6I0t = parcelRequire("u6I0t");
// eslint-disable-next-line no-undef
var $3272258f0af3cbc3$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $3272258f0af3cbc3$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $u6I0t.default)(function(prop) {
    return $3272258f0af3cbc3$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("u6I0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a801ae819a91bc$export$2e2bcd8739ae039; });
function $05a801ae819a91bc$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("4TUCe", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3v6Pw.createSvgIcon;
    }
});

var $3v6Pw = parcelRequire("3v6Pw");

});
parcelRegister("3v6Pw", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $28c990a026c7c5e6$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "capitalize", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_capitalize.default;
    }
});
Object.defineProperty(module.exports, "createChainedFunction", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_createChainedFunction.default;
    }
});
Object.defineProperty(module.exports, "createSvgIcon", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_createSvgIcon.default;
    }
});
Object.defineProperty(module.exports, "debounce", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_debounce.default;
    }
});
Object.defineProperty(module.exports, "deprecatedPropType", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_deprecatedPropType.default;
    }
});
Object.defineProperty(module.exports, "isMuiElement", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_isMuiElement.default;
    }
});
Object.defineProperty(module.exports, "mergeSlotProps", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_mergeSlotProps.default;
    }
});
Object.defineProperty(module.exports, "ownerDocument", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_ownerDocument.default;
    }
});
Object.defineProperty(module.exports, "ownerWindow", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_ownerWindow.default;
    }
});
Object.defineProperty(module.exports, "requirePropFactory", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_requirePropFactory.default;
    }
});
Object.defineProperty(module.exports, "setRef", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_setRef.default;
    }
});
module.exports.unstable_ClassNameGenerator = void 0;
Object.defineProperty(module.exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_memoTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_useEnhancedEffect", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_useEnhancedEffect.default;
    }
});
Object.defineProperty(module.exports, "unstable_useId", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_useId.default;
    }
});
Object.defineProperty(module.exports, "unsupportedProp", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_unsupportedProp.default;
    }
});
Object.defineProperty(module.exports, "useControlled", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_useControlled.default;
    }
});
Object.defineProperty(module.exports, "useEventCallback", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_useEventCallback.default;
    }
});
Object.defineProperty(module.exports, "useForkRef", {
    enumerable: true,
    get: function() {
        return $28c990a026c7c5e6$var$_useForkRef.default;
    }
});

var $8zvjb = parcelRequire("8zvjb");

var $28c990a026c7c5e6$var$_capitalize = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("gVVIq")));

var $28c990a026c7c5e6$var$_createChainedFunction = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("1kabw")));

var $28c990a026c7c5e6$var$_createSvgIcon = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("ehak1")));

var $28c990a026c7c5e6$var$_debounce = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("b7tDG")));

var $28c990a026c7c5e6$var$_deprecatedPropType = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("87PEQ")));

var $28c990a026c7c5e6$var$_isMuiElement = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("chsEC")));

var $28c990a026c7c5e6$var$_memoTheme = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("kTCCA")));

var $28c990a026c7c5e6$var$_ownerDocument = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("5ar2w")));

var $28c990a026c7c5e6$var$_ownerWindow = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("8V6h9")));

var $28c990a026c7c5e6$var$_requirePropFactory = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("hsSgH")));

var $28c990a026c7c5e6$var$_setRef = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("9O4Pm")));

var $28c990a026c7c5e6$var$_useEnhancedEffect = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("4oMQY")));

var $28c990a026c7c5e6$var$_useId = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("edkAa")));

var $28c990a026c7c5e6$var$_unsupportedProp = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("9d2MU")));

var $28c990a026c7c5e6$var$_useControlled = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("8WqeI")));

var $28c990a026c7c5e6$var$_useEventCallback = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("6hPuj")));

var $28c990a026c7c5e6$var$_useForkRef = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("iZq8x")));

var $28c990a026c7c5e6$var$_mergeSlotProps = $28c990a026c7c5e6$require$_interopRequireDefault((parcelRequire("bkauv")));
// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const $28c990a026c7c5e6$var$unstable_ClassNameGenerator = module.exports.unstable_ClassNameGenerator = {
    configure: (generator)=>{
        $8zvjb.default.configure(generator);
    }
};

});
parcelRegister("1yHiF", function(module, exports) {
function $122a8dedaa9a5728$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $122a8dedaa9a5728$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8zvjb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63d9e0d62239238e$export$2e2bcd8739ae039; });
const $63d9e0d62239238e$var$defaultGenerator = (componentName)=>componentName;
const $63d9e0d62239238e$var$createClassNameGenerator = ()=>{
    let generate = $63d9e0d62239238e$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $63d9e0d62239238e$var$defaultGenerator;
        }
    };
};
const $63d9e0d62239238e$var$ClassNameGenerator = $63d9e0d62239238e$var$createClassNameGenerator();
var $63d9e0d62239238e$export$2e2bcd8739ae039 = $63d9e0d62239238e$var$ClassNameGenerator;

});

parcelRegister("gVVIq", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c53ebd4c618c3e7d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c53ebd4c618c3e7d$var$_capitalize = $c53ebd4c618c3e7d$require$_interopRequireDefault((parcelRequire("eUhyY")));
var $c53ebd4c618c3e7d$var$_default = module.exports.default = $c53ebd4c618c3e7d$var$_capitalize.default;

});
parcelRegister("eUhyY", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ada3eb5738fd4a73$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ada3eb5738fd4a73$var$_capitalize.default;
    }
});

var $ada3eb5738fd4a73$var$_capitalize = $ada3eb5738fd4a73$require$_interopRequireDefault((parcelRequire("hakLf")));

});
parcelRegister("hakLf", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c7f3798835790372$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7f3798835790372$var$capitalize;

var $c7f3798835790372$var$_formatMuiErrorMessage = $c7f3798835790372$require$_interopRequireDefault((parcelRequire("cCZAW")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $c7f3798835790372$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, $c7f3798835790372$var$_formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("cCZAW", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9318d01ab38ece29$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9318d01ab38ece29$var$_formatMuiErrorMessage.default;
    }
});

var $9318d01ab38ece29$var$_formatMuiErrorMessage = $9318d01ab38ece29$require$_interopRequireDefault((parcelRequire("crgVA")));

});
parcelRegister("crgVA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90e5232a222589c1$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $90e5232a222589c1$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});





parcelRegister("1kabw", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $0f6f8f2dc9943706$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f6f8f2dc9943706$var$_createChainedFunction = $0f6f8f2dc9943706$require$_interopRequireDefault((parcelRequire("d4blJ")));
var $0f6f8f2dc9943706$var$_default = module.exports.default = $0f6f8f2dc9943706$var$_createChainedFunction.default;

});
parcelRegister("d4blJ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $983473e129da36ee$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $983473e129da36ee$var$_createChainedFunction.default;
    }
});

var $983473e129da36ee$var$_createChainedFunction = $983473e129da36ee$require$_interopRequireDefault((parcelRequire("eS7HI")));

});
parcelRegister("eS7HI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad3c15b2a71f6c1a$var$createChainedFunction;
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $ad3c15b2a71f6c1a$var$createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});



parcelRegister("ehak1", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $a64aa8eebcd3858c$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $a64aa8eebcd3858c$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a64aa8eebcd3858c$var$createSvgIcon;

var $a64aa8eebcd3858c$var$React = $a64aa8eebcd3858c$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $a64aa8eebcd3858c$var$_SvgIcon = $a64aa8eebcd3858c$require$_interopRequireDefault((parcelRequire("f4BEv")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * Private module reserved for @mui packages.
 */ function $a64aa8eebcd3858c$var$createSvgIcon(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $kSbwP.jsx)($a64aa8eebcd3858c$var$_SvgIcon.default, {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = $a64aa8eebcd3858c$var$_SvgIcon.default.muiName;
    return /*#__PURE__*/ $a64aa8eebcd3858c$var$React.memo(/*#__PURE__*/ $a64aa8eebcd3858c$var$React.forwardRef(Component));
}

});
parcelRegister("1RopH", function(module, exports) {

var $1XeFJ = parcelRequire("1XeFJ");
var $15adadaf01189225$var$_typeof = $1XeFJ.default;
function $15adadaf01189225$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($15adadaf01189225$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $15adadaf01189225$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $15adadaf01189225$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $15adadaf01189225$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
module.exports = $15adadaf01189225$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1XeFJ", function(module, exports) {
function $16c6aeb54381cada$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $16c6aeb54381cada$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $16c6aeb54381cada$var$_typeof(o);
}
module.exports = $16c6aeb54381cada$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("f4BEv", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $af946fb808850830$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $af946fb808850830$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $af946fb808850830$var$_exportNames = {
    svgIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $af946fb808850830$var$_SvgIcon.default;
    }
});
Object.defineProperty(module.exports, "svgIconClasses", {
    enumerable: true,
    get: function() {
        return $af946fb808850830$var$_svgIconClasses.default;
    }
});

var $af946fb808850830$var$_SvgIcon = $af946fb808850830$require$_interopRequireDefault((parcelRequire("9U1dW")));

var $af946fb808850830$var$_svgIconClasses = $af946fb808850830$require$_interopRequireWildcard((parcelRequire("eQgWl")));
Object.keys($af946fb808850830$var$_svgIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($af946fb808850830$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $af946fb808850830$var$_svgIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $af946fb808850830$var$_svgIconClasses[key];
        }
    });
});

});
parcelRegister("9U1dW", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $735a4b0d150de7f9$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $735a4b0d150de7f9$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $735a4b0d150de7f9$var$React = $735a4b0d150de7f9$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $735a4b0d150de7f9$var$_propTypes = $735a4b0d150de7f9$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $735a4b0d150de7f9$var$_clsx = $735a4b0d150de7f9$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $735a4b0d150de7f9$var$_composeClasses = $735a4b0d150de7f9$require$_interopRequireDefault((parcelRequire("4F19u")));

var $735a4b0d150de7f9$var$_capitalize = $735a4b0d150de7f9$require$_interopRequireDefault((parcelRequire("gVVIq")));

var $bvcHB = parcelRequire("bvcHB");

var $735a4b0d150de7f9$var$_memoTheme = $735a4b0d150de7f9$require$_interopRequireDefault((parcelRequire("kTCCA")));

var $eFtkv = parcelRequire("eFtkv");

var $eQgWl = parcelRequire("eQgWl");

var $kSbwP = parcelRequire("kSbwP");
const $735a4b0d150de7f9$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $735a4b0d150de7f9$var$_capitalize.default)(color)}`,
            `fontSize${(0, $735a4b0d150de7f9$var$_capitalize.default)(fontSize)}`
        ]
    };
    return (0, $735a4b0d150de7f9$var$_composeClasses.default)(slots, $eQgWl.getSvgIconUtilityClass, classes);
};
const $735a4b0d150de7f9$var$SvgIconRoot = (0, $bvcHB.styled)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $735a4b0d150de7f9$var$_capitalize.default)(ownerState.color)}`],
            styles[`fontSize${(0, $735a4b0d150de7f9$var$_capitalize.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $735a4b0d150de7f9$var$_memoTheme.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $735a4b0d150de7f9$var$SvgIcon = /*#__PURE__*/ $735a4b0d150de7f9$var$React.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $eFtkv.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $735a4b0d150de7f9$var$React.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $735a4b0d150de7f9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $kSbwP.jsxs)($735a4b0d150de7f9$var$SvgIconRoot, {
        as: component,
        className: (0, $735a4b0d150de7f9$var$_clsx.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $kSbwP.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$735a4b0d150de7f9$var$SvgIcon.muiName = 'SvgIcon';
var $735a4b0d150de7f9$var$_default = module.exports.default = $735a4b0d150de7f9$var$SvgIcon;

});
parcelRegister("4F19u", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $364be2897847355f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $364be2897847355f$var$_composeClasses.default;
    }
});

var $364be2897847355f$var$_composeClasses = $364be2897847355f$require$_interopRequireDefault((parcelRequire("cgXH7")));

});
parcelRegister("cgXH7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8ef548c22cdb6b96$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $8ef548c22cdb6b96$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});


parcelRegister("bvcHB", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $85fc71588cc361f7$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $85fc71588cc361f7$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $bj8tp.css;
    }
});
module.exports.globalCss = $85fc71588cc361f7$var$globalCss;
module.exports.internal_createExtendSxProp = $85fc71588cc361f7$var$internal_createExtendSxProp;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $bj8tp.keyframes;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $85fc71588cc361f7$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $85fc71588cc361f7$var$_useTheme.default;
    }
});

var $85fc71588cc361f7$var$React = $85fc71588cc361f7$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $jNnBr = parcelRequire("jNnBr");

var $85fc71588cc361f7$var$_useTheme = $85fc71588cc361f7$require$_interopRequireDefault((parcelRequire("kYavH")));

var $85fc71588cc361f7$var$_GlobalStyles = $85fc71588cc361f7$require$_interopRequireDefault((parcelRequire("jiDuP")));

var $kSbwP = parcelRequire("kSbwP");

var $bj8tp = parcelRequire("bj8tp");

var $85fc71588cc361f7$var$_styled = $85fc71588cc361f7$require$_interopRequireDefault((parcelRequire("dq4m7")));
function $85fc71588cc361f7$var$globalCss(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $kSbwP.jsx)($85fc71588cc361f7$var$_GlobalStyles.default, {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $85fc71588cc361f7$var$internal_createExtendSxProp() {
    return $jNnBr.extendSxProp;
}

});
parcelRegister("jNnBr", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $e694e6fb4caa797b$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $e694e6fb4caa797b$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e694e6fb4caa797b$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return $e694e6fb4caa797b$var$_extendSxProp.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $e694e6fb4caa797b$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $e694e6fb4caa797b$var$_defaultSxConfig.default;
    }
});

var $e694e6fb4caa797b$var$_styleFunctionSx = $e694e6fb4caa797b$require$_interopRequireWildcard((parcelRequire("4I0wy")));

var $e694e6fb4caa797b$var$_extendSxProp = $e694e6fb4caa797b$require$_interopRequireDefault((parcelRequire("hoRpU")));

var $e694e6fb4caa797b$var$_defaultSxConfig = $e694e6fb4caa797b$require$_interopRequireDefault((parcelRequire("3pSKT")));

});
parcelRegister("4I0wy", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $36dbad911e9ea849$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createStyleFunctionSx = $36dbad911e9ea849$var$unstable_createStyleFunctionSx;

var $36dbad911e9ea849$var$_capitalize = $36dbad911e9ea849$require$_interopRequireDefault((parcelRequire("eUhyY")));

var $36dbad911e9ea849$var$_merge = $36dbad911e9ea849$require$_interopRequireDefault((parcelRequire("1gEAC")));

var $aicXM = parcelRequire("aicXM");

var $kFz1f = parcelRequire("kFz1f");

var $9w6E6 = parcelRequire("9w6E6");

var $36dbad911e9ea849$var$_defaultSxConfig = $36dbad911e9ea849$require$_interopRequireDefault((parcelRequire("3pSKT")));
function $36dbad911e9ea849$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $36dbad911e9ea849$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $36dbad911e9ea849$var$unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $aicXM.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $aicXM.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $aicXM.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $36dbad911e9ea849$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $kFz1f.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? $36dbad911e9ea849$var$_defaultSxConfig.default;
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $kFz1f.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $36dbad911e9ea849$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $36dbad911e9ea849$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $kFz1f.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($36dbad911e9ea849$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $36dbad911e9ea849$var$_merge.default)(css, breakpointsValues);
                        }
                    } else css = (0, $36dbad911e9ea849$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $9w6E6.sortContainerQueries)(theme, (0, $kFz1f.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $36dbad911e9ea849$var$styleFunctionSx = $36dbad911e9ea849$var$unstable_createStyleFunctionSx();
$36dbad911e9ea849$var$styleFunctionSx.filterProps = [
    'sx'
];
var $36dbad911e9ea849$var$_default = module.exports.default = $36dbad911e9ea849$var$styleFunctionSx;

});
parcelRegister("1gEAC", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $0ec6c5519999dcf0$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0ec6c5519999dcf0$var$_merge.default;
    }
});

var $0ec6c5519999dcf0$var$_merge = $0ec6c5519999dcf0$require$_interopRequireDefault((parcelRequire("7HXlX")));

});
parcelRegister("7HXlX", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $59ca96ddeb190632$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $59ca96ddeb190632$var$_deepmerge = $59ca96ddeb190632$require$_interopRequireDefault((parcelRequire("cfKeZ")));
function $59ca96ddeb190632$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $59ca96ddeb190632$var$_deepmerge.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $59ca96ddeb190632$var$_default = module.exports.default = $59ca96ddeb190632$var$merge;

});
parcelRegister("cfKeZ", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $8ebac136a5bb41e3$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8ebac136a5bb41e3$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8ebac136a5bb41e3$var$_deepmerge.default;
    }
});

var $8ebac136a5bb41e3$var$_deepmerge = $8ebac136a5bb41e3$require$_interopRequireWildcard((parcelRequire("kSvzm")));
Object.keys($8ebac136a5bb41e3$var$_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($8ebac136a5bb41e3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8ebac136a5bb41e3$var$_deepmerge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8ebac136a5bb41e3$var$_deepmerge[key];
        }
    });
});

});
parcelRegister("kSvzm", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $f33156d31a79402a$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f33156d31a79402a$var$deepmerge;
module.exports.isPlainObject = $f33156d31a79402a$var$isPlainObject;

var $f33156d31a79402a$var$React = $f33156d31a79402a$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $4G43L = parcelRequire("4G43L");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $f33156d31a79402a$var$isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $f33156d31a79402a$var$deepClone(source) {
    if (/*#__PURE__*/ $f33156d31a79402a$var$React.isValidElement(source) || (0, $4G43L.isValidElementType)(source) || !$f33156d31a79402a$var$isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $f33156d31a79402a$var$deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function $f33156d31a79402a$var$deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($f33156d31a79402a$var$isPlainObject(target) && $f33156d31a79402a$var$isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $f33156d31a79402a$var$React.isValidElement(source[key]) || (0, $4G43L.isValidElementType)(source[key])) output[key] = source[key];
        else if ($f33156d31a79402a$var$isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $f33156d31a79402a$var$isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $f33156d31a79402a$var$deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = $f33156d31a79402a$var$isPlainObject(source[key]) ? $f33156d31a79402a$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("4G43L", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iHnq9"));

});
parcelRegister("iHnq9", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $d9ce690c28ea75f0$export$a7c73072b1a182ae; }, function (v) { return $d9ce690c28ea75f0$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d9ce690c28ea75f0$export$9f27bc3417b4524d; }, function (v) { return $d9ce690c28ea75f0$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d9ce690c28ea75f0$export$db77ccec0bb4ccac; }, function (v) { return $d9ce690c28ea75f0$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d9ce690c28ea75f0$export$8392c0c9d3dcbd35; }, function (v) { return $d9ce690c28ea75f0$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d9ce690c28ea75f0$export$ffb0004e005737fa; }, function (v) { return $d9ce690c28ea75f0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d9ce690c28ea75f0$export$b624eff549462981; }, function (v) { return $d9ce690c28ea75f0$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d9ce690c28ea75f0$export$7897aa7841a5380c; }, function (v) { return $d9ce690c28ea75f0$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d9ce690c28ea75f0$export$602eac185826482c; }, function (v) { return $d9ce690c28ea75f0$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d9ce690c28ea75f0$export$e2c29f18771995cb; }, function (v) { return $d9ce690c28ea75f0$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d9ce690c28ea75f0$export$5f8d39834fd61797; }, function (v) { return $d9ce690c28ea75f0$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d9ce690c28ea75f0$export$74bf444e3cd11ea5; }, function (v) { return $d9ce690c28ea75f0$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $d9ce690c28ea75f0$export$998bcd577473dd93; }, function (v) { return $d9ce690c28ea75f0$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d9ce690c28ea75f0$export$b706b080d889d2c9; }, function (v) { return $d9ce690c28ea75f0$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d9ce690c28ea75f0$export$5be5a87408f70ddc; }, function (v) { return $d9ce690c28ea75f0$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d9ce690c28ea75f0$export$45a5e7f76e0caa8d; }, function (v) { return $d9ce690c28ea75f0$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d9ce690c28ea75f0$export$455c2e768291efa6; }, function (v) { return $d9ce690c28ea75f0$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d9ce690c28ea75f0$export$9522e17588c12572; }, function (v) { return $d9ce690c28ea75f0$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d9ce690c28ea75f0$export$2110ac352bb060b9; }, function (v) { return $d9ce690c28ea75f0$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d9ce690c28ea75f0$export$56885ab8b9c456ab; }, function (v) { return $d9ce690c28ea75f0$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d9ce690c28ea75f0$export$d927fcb6adf8f9de; }, function (v) { return $d9ce690c28ea75f0$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d9ce690c28ea75f0$export$b82d16f27459e05a; }, function (v) { return $d9ce690c28ea75f0$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d9ce690c28ea75f0$export$522c17b4f5e123e8; }, function (v) { return $d9ce690c28ea75f0$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d9ce690c28ea75f0$export$1aabd8a0274ecfd6; }, function (v) { return $d9ce690c28ea75f0$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $d9ce690c28ea75f0$export$3d6c20d97e46b957; }, function (v) { return $d9ce690c28ea75f0$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d9ce690c28ea75f0$export$9b621391a187a31a; }, function (v) { return $d9ce690c28ea75f0$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d9ce690c28ea75f0$export$f5bbd400c2f4426f; }, function (v) { return $d9ce690c28ea75f0$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9ce690c28ea75f0$export$a7c73072b1a182ae;
var $d9ce690c28ea75f0$export$9f27bc3417b4524d;
var $d9ce690c28ea75f0$export$db77ccec0bb4ccac;
var $d9ce690c28ea75f0$export$8392c0c9d3dcbd35;
var $d9ce690c28ea75f0$export$ffb0004e005737fa;
var $d9ce690c28ea75f0$export$b624eff549462981;
var $d9ce690c28ea75f0$export$7897aa7841a5380c;
var $d9ce690c28ea75f0$export$602eac185826482c;
var $d9ce690c28ea75f0$export$e2c29f18771995cb;
var $d9ce690c28ea75f0$export$5f8d39834fd61797;
var $d9ce690c28ea75f0$export$74bf444e3cd11ea5;
var $d9ce690c28ea75f0$export$998bcd577473dd93;
var $d9ce690c28ea75f0$export$b706b080d889d2c9;
var $d9ce690c28ea75f0$export$5be5a87408f70ddc;
var $d9ce690c28ea75f0$export$45a5e7f76e0caa8d;
var $d9ce690c28ea75f0$export$455c2e768291efa6;
var $d9ce690c28ea75f0$export$9522e17588c12572;
var $d9ce690c28ea75f0$export$2110ac352bb060b9;
var $d9ce690c28ea75f0$export$56885ab8b9c456ab;
var $d9ce690c28ea75f0$export$d927fcb6adf8f9de;
var $d9ce690c28ea75f0$export$b82d16f27459e05a;
var $d9ce690c28ea75f0$export$522c17b4f5e123e8;
var $d9ce690c28ea75f0$export$1aabd8a0274ecfd6;
var $d9ce690c28ea75f0$export$3d6c20d97e46b957;
var $d9ce690c28ea75f0$export$9b621391a187a31a;
var $d9ce690c28ea75f0$export$f5bbd400c2f4426f;
"use strict";
var $d9ce690c28ea75f0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d9ce690c28ea75f0$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $d9ce690c28ea75f0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $d9ce690c28ea75f0$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $d9ce690c28ea75f0$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $d9ce690c28ea75f0$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $d9ce690c28ea75f0$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $d9ce690c28ea75f0$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $d9ce690c28ea75f0$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $d9ce690c28ea75f0$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $d9ce690c28ea75f0$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $d9ce690c28ea75f0$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $d9ce690c28ea75f0$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $d9ce690c28ea75f0$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $d9ce690c28ea75f0$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $d9ce690c28ea75f0$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $d9ce690c28ea75f0$var$REACT_FRAGMENT_TYPE:
                    case $d9ce690c28ea75f0$var$REACT_PROFILER_TYPE:
                    case $d9ce690c28ea75f0$var$REACT_STRICT_MODE_TYPE:
                    case $d9ce690c28ea75f0$var$REACT_SUSPENSE_TYPE:
                    case $d9ce690c28ea75f0$var$REACT_SUSPENSE_LIST_TYPE:
                    case $d9ce690c28ea75f0$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $d9ce690c28ea75f0$var$REACT_CONTEXT_TYPE:
                            case $d9ce690c28ea75f0$var$REACT_FORWARD_REF_TYPE:
                            case $d9ce690c28ea75f0$var$REACT_LAZY_TYPE:
                            case $d9ce690c28ea75f0$var$REACT_MEMO_TYPE:
                                return object;
                            case $d9ce690c28ea75f0$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $d9ce690c28ea75f0$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$d9ce690c28ea75f0$export$a7c73072b1a182ae = $d9ce690c28ea75f0$var$REACT_CONSUMER_TYPE;
$d9ce690c28ea75f0$export$9f27bc3417b4524d = $d9ce690c28ea75f0$var$REACT_CONTEXT_TYPE;
$d9ce690c28ea75f0$export$db77ccec0bb4ccac = $d9ce690c28ea75f0$var$REACT_ELEMENT_TYPE;
$d9ce690c28ea75f0$export$8392c0c9d3dcbd35 = $d9ce690c28ea75f0$var$REACT_FORWARD_REF_TYPE;
$d9ce690c28ea75f0$export$ffb0004e005737fa = $d9ce690c28ea75f0$var$REACT_FRAGMENT_TYPE;
$d9ce690c28ea75f0$export$b624eff549462981 = $d9ce690c28ea75f0$var$REACT_LAZY_TYPE;
$d9ce690c28ea75f0$export$7897aa7841a5380c = $d9ce690c28ea75f0$var$REACT_MEMO_TYPE;
$d9ce690c28ea75f0$export$602eac185826482c = $d9ce690c28ea75f0$var$REACT_PORTAL_TYPE;
$d9ce690c28ea75f0$export$e2c29f18771995cb = $d9ce690c28ea75f0$var$REACT_PROFILER_TYPE;
$d9ce690c28ea75f0$export$5f8d39834fd61797 = $d9ce690c28ea75f0$var$REACT_STRICT_MODE_TYPE;
$d9ce690c28ea75f0$export$74bf444e3cd11ea5 = $d9ce690c28ea75f0$var$REACT_SUSPENSE_TYPE;
$d9ce690c28ea75f0$export$998bcd577473dd93 = $d9ce690c28ea75f0$var$REACT_SUSPENSE_LIST_TYPE;
$d9ce690c28ea75f0$export$b706b080d889d2c9 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_CONSUMER_TYPE;
};
$d9ce690c28ea75f0$export$5be5a87408f70ddc = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_CONTEXT_TYPE;
};
$d9ce690c28ea75f0$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $d9ce690c28ea75f0$var$REACT_ELEMENT_TYPE;
};
$d9ce690c28ea75f0$export$455c2e768291efa6 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_FORWARD_REF_TYPE;
};
$d9ce690c28ea75f0$export$9522e17588c12572 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_FRAGMENT_TYPE;
};
$d9ce690c28ea75f0$export$2110ac352bb060b9 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_LAZY_TYPE;
};
$d9ce690c28ea75f0$export$56885ab8b9c456ab = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_MEMO_TYPE;
};
$d9ce690c28ea75f0$export$d927fcb6adf8f9de = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_PORTAL_TYPE;
};
$d9ce690c28ea75f0$export$b82d16f27459e05a = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_PROFILER_TYPE;
};
$d9ce690c28ea75f0$export$522c17b4f5e123e8 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_STRICT_MODE_TYPE;
};
$d9ce690c28ea75f0$export$1aabd8a0274ecfd6 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_SUSPENSE_TYPE;
};
$d9ce690c28ea75f0$export$3d6c20d97e46b957 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_SUSPENSE_LIST_TYPE;
};
$d9ce690c28ea75f0$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $d9ce690c28ea75f0$var$REACT_FRAGMENT_TYPE || type === $d9ce690c28ea75f0$var$REACT_PROFILER_TYPE || type === $d9ce690c28ea75f0$var$REACT_STRICT_MODE_TYPE || type === $d9ce690c28ea75f0$var$REACT_SUSPENSE_TYPE || type === $d9ce690c28ea75f0$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $d9ce690c28ea75f0$var$REACT_LAZY_TYPE || type.$$typeof === $d9ce690c28ea75f0$var$REACT_MEMO_TYPE || type.$$typeof === $d9ce690c28ea75f0$var$REACT_CONTEXT_TYPE || type.$$typeof === $d9ce690c28ea75f0$var$REACT_CONSUMER_TYPE || type.$$typeof === $d9ce690c28ea75f0$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $d9ce690c28ea75f0$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$d9ce690c28ea75f0$export$f5bbd400c2f4426f = $d9ce690c28ea75f0$var$typeOf;

});






parcelRegister("aicXM", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $77e5a409e44dcf04$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $77e5a409e44dcf04$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $77e5a409e44dcf04$var$_style.default;
    }
});

var $77e5a409e44dcf04$var$_style = $77e5a409e44dcf04$require$_interopRequireWildcard((parcelRequire("amhzg")));
Object.keys($77e5a409e44dcf04$var$_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($77e5a409e44dcf04$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $77e5a409e44dcf04$var$_style[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $77e5a409e44dcf04$var$_style[key];
        }
    });
});

});
parcelRegister("amhzg", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $78a9961200072a9a$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPath = $78a9961200072a9a$var$getPath;
module.exports.getStyleValue = $78a9961200072a9a$var$getStyleValue;

var $78a9961200072a9a$var$_capitalize = $78a9961200072a9a$require$_interopRequireDefault((parcelRequire("eUhyY")));

var $78a9961200072a9a$var$_responsivePropType = $78a9961200072a9a$require$_interopRequireDefault((parcelRequire("l9eYP")));

var $kFz1f = parcelRequire("kFz1f");
function $78a9961200072a9a$var$getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $78a9961200072a9a$var$getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $78a9961200072a9a$var$getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $78a9961200072a9a$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $78a9961200072a9a$var$getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $78a9961200072a9a$var$getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $78a9961200072a9a$var$getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $78a9961200072a9a$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $kFz1f.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $78a9961200072a9a$var$_default = module.exports.default = $78a9961200072a9a$var$style;

});
parcelRegister("l9eYP", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f6560efde6fc5879$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f6560efde6fc5879$var$_responsivePropType.default;
    }
});

var $f6560efde6fc5879$var$_responsivePropType = $f6560efde6fc5879$require$_interopRequireDefault((parcelRequire("lJebz")));

});
parcelRegister("lJebz", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $fd18cde4c88e9534$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd18cde4c88e9534$var$_propTypes = $fd18cde4c88e9534$require$_interopRequireDefault((parcelRequire("ebCsu")));
const $fd18cde4c88e9534$var$responsivePropType = {};
var $fd18cde4c88e9534$var$_default = module.exports.default = $fd18cde4c88e9534$var$responsivePropType;

});


parcelRegister("kFz1f", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $f0c2cd13b6b18423$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f0c2cd13b6b18423$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f0c2cd13b6b18423$var$_breakpoints.default;
    }
});

var $f0c2cd13b6b18423$var$_breakpoints = $f0c2cd13b6b18423$require$_interopRequireWildcard((parcelRequire("43aIU")));
Object.keys($f0c2cd13b6b18423$var$_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f0c2cd13b6b18423$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f0c2cd13b6b18423$var$_breakpoints[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f0c2cd13b6b18423$var$_breakpoints[key];
        }
    });
});

});
parcelRegister("43aIU", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $2f2fc2a579dcdb69$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeBreakpointsBase = $2f2fc2a579dcdb69$var$computeBreakpointsBase;
module.exports.createEmptyBreakpointObject = $2f2fc2a579dcdb69$var$createEmptyBreakpointObject;
module.exports.default = void 0;
module.exports.handleBreakpoints = $2f2fc2a579dcdb69$var$handleBreakpoints;
module.exports.mergeBreakpointsInOrder = $2f2fc2a579dcdb69$var$mergeBreakpointsInOrder;
module.exports.removeUnusedBreakpoints = $2f2fc2a579dcdb69$var$removeUnusedBreakpoints;
module.exports.resolveBreakpointValues = $2f2fc2a579dcdb69$var$resolveBreakpointValues;
module.exports.values = void 0;

var $2f2fc2a579dcdb69$var$_propTypes = $2f2fc2a579dcdb69$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $2f2fc2a579dcdb69$var$_deepmerge = $2f2fc2a579dcdb69$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $2f2fc2a579dcdb69$var$_merge = $2f2fc2a579dcdb69$require$_interopRequireDefault((parcelRequire("1gEAC")));

var $9w6E6 = parcelRequire("9w6E6");
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const $2f2fc2a579dcdb69$var$values = module.exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2f2fc2a579dcdb69$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$2f2fc2a579dcdb69$var$values[key]}px)`
};
const $2f2fc2a579dcdb69$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $2f2fc2a579dcdb69$var$values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $2f2fc2a579dcdb69$var$handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2f2fc2a579dcdb69$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $2f2fc2a579dcdb69$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $9w6E6.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $9w6E6.getContainerQuery)(theme.containerQueries ? theme : $2f2fc2a579dcdb69$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $2f2fc2a579dcdb69$var$values).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2f2fc2a579dcdb69$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2f2fc2a579dcdb69$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $2f2fc2a579dcdb69$var$_merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2f2fc2a579dcdb69$var$createEmptyBreakpointObject(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2f2fc2a579dcdb69$var$removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2f2fc2a579dcdb69$var$mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2f2fc2a579dcdb69$var$createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $2f2fc2a579dcdb69$var$_deepmerge.default)(prev, next), {});
    return $2f2fc2a579dcdb69$var$removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function $2f2fc2a579dcdb69$var$computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2f2fc2a579dcdb69$var$resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2f2fc2a579dcdb69$var$computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2f2fc2a579dcdb69$var$_default = module.exports.default = $2f2fc2a579dcdb69$var$breakpoints;

});
parcelRegister("9w6E6", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $01c9beffd30ecb13$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $01c9beffd30ecb13$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return $01c9beffd30ecb13$var$_cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(module.exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return $01c9beffd30ecb13$var$_cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(module.exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return $01c9beffd30ecb13$var$_cssContainerQueries.sortContainerQueries;
    }
});

var $01c9beffd30ecb13$var$_cssContainerQueries = $01c9beffd30ecb13$require$_interopRequireWildcard((parcelRequire("gdApB")));

});
parcelRegister("gdApB", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $bcea1ae0868c1871$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bcea1ae0868c1871$var$cssContainerQueries;
module.exports.getContainerQuery = $bcea1ae0868c1871$var$getContainerQuery;
module.exports.isCqShorthand = $bcea1ae0868c1871$var$isCqShorthand;
module.exports.sortContainerQueries = $bcea1ae0868c1871$var$sortContainerQueries;

var $bcea1ae0868c1871$var$_formatMuiErrorMessage = $bcea1ae0868c1871$require$_interopRequireDefault((parcelRequire("cCZAW")));
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 eventhough 40rem > 300px
 */ function $bcea1ae0868c1871$var$sortContainerQueries(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $bcea1ae0868c1871$var$isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $bcea1ae0868c1871$var$getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $bcea1ae0868c1871$var$cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});






parcelRegister("3pSKT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6QfFh = parcelRequire("6QfFh");

var $3rcHQ = parcelRequire("3rcHQ");

var $4zH5S = parcelRequire("4zH5S");

var $9xWWR = parcelRequire("9xWWR");

var $gKFto = parcelRequire("gKFto");
const $27ce2e2ea69ee2e6$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: $3rcHQ.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: $3rcHQ.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: $3rcHQ.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: $3rcHQ.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: $3rcHQ.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: $3rcHQ.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: $3rcHQ.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: $9xWWR.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: $9xWWR.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: $9xWWR.paletteTransform
    },
    // spacing
    p: {
        style: $6QfFh.padding
    },
    pt: {
        style: $6QfFh.padding
    },
    pr: {
        style: $6QfFh.padding
    },
    pb: {
        style: $6QfFh.padding
    },
    pl: {
        style: $6QfFh.padding
    },
    px: {
        style: $6QfFh.padding
    },
    py: {
        style: $6QfFh.padding
    },
    padding: {
        style: $6QfFh.padding
    },
    paddingTop: {
        style: $6QfFh.padding
    },
    paddingRight: {
        style: $6QfFh.padding
    },
    paddingBottom: {
        style: $6QfFh.padding
    },
    paddingLeft: {
        style: $6QfFh.padding
    },
    paddingX: {
        style: $6QfFh.padding
    },
    paddingY: {
        style: $6QfFh.padding
    },
    paddingInline: {
        style: $6QfFh.padding
    },
    paddingInlineStart: {
        style: $6QfFh.padding
    },
    paddingInlineEnd: {
        style: $6QfFh.padding
    },
    paddingBlock: {
        style: $6QfFh.padding
    },
    paddingBlockStart: {
        style: $6QfFh.padding
    },
    paddingBlockEnd: {
        style: $6QfFh.padding
    },
    m: {
        style: $6QfFh.margin
    },
    mt: {
        style: $6QfFh.margin
    },
    mr: {
        style: $6QfFh.margin
    },
    mb: {
        style: $6QfFh.margin
    },
    ml: {
        style: $6QfFh.margin
    },
    mx: {
        style: $6QfFh.margin
    },
    my: {
        style: $6QfFh.margin
    },
    margin: {
        style: $6QfFh.margin
    },
    marginTop: {
        style: $6QfFh.margin
    },
    marginRight: {
        style: $6QfFh.margin
    },
    marginBottom: {
        style: $6QfFh.margin
    },
    marginLeft: {
        style: $6QfFh.margin
    },
    marginX: {
        style: $6QfFh.margin
    },
    marginY: {
        style: $6QfFh.margin
    },
    marginInline: {
        style: $6QfFh.margin
    },
    marginInlineStart: {
        style: $6QfFh.margin
    },
    marginInlineEnd: {
        style: $6QfFh.margin
    },
    marginBlock: {
        style: $6QfFh.margin
    },
    marginBlockStart: {
        style: $6QfFh.margin
    },
    marginBlockEnd: {
        style: $6QfFh.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: $4zH5S.gap
    },
    rowGap: {
        style: $4zH5S.rowGap
    },
    columnGap: {
        style: $4zH5S.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: $gKFto.sizingTransform
    },
    maxWidth: {
        style: $gKFto.maxWidth
    },
    minWidth: {
        transform: $gKFto.sizingTransform
    },
    height: {
        transform: $gKFto.sizingTransform
    },
    maxHeight: {
        transform: $gKFto.sizingTransform
    },
    minHeight: {
        transform: $gKFto.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $27ce2e2ea69ee2e6$var$_default = module.exports.default = $27ce2e2ea69ee2e6$var$defaultSxConfig;

});
parcelRegister("6QfFh", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $4fb3c020f72468c2$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4fb3c020f72468c2$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4fb3c020f72468c2$var$_spacing.default;
    }
});

var $4fb3c020f72468c2$var$_spacing = $4fb3c020f72468c2$require$_interopRequireWildcard((parcelRequire("e0bQM")));
Object.keys($4fb3c020f72468c2$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4fb3c020f72468c2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4fb3c020f72468c2$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4fb3c020f72468c2$var$_spacing[key];
        }
    });
});

});
parcelRegister("e0bQM", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $a31a42011344f865$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnarySpacing = $a31a42011344f865$var$createUnarySpacing;
module.exports.createUnaryUnit = $a31a42011344f865$var$createUnaryUnit;
module.exports.default = void 0;
module.exports.getStyleFromPropValue = $a31a42011344f865$var$getStyleFromPropValue;
module.exports.getValue = $a31a42011344f865$var$getValue;
module.exports.margin = $a31a42011344f865$var$margin;
module.exports.marginKeys = void 0;
module.exports.padding = $a31a42011344f865$var$padding;
module.exports.paddingKeys = void 0;

var $a31a42011344f865$var$_responsivePropType = $a31a42011344f865$require$_interopRequireDefault((parcelRequire("l9eYP")));

var $kFz1f = parcelRequire("kFz1f");

var $aicXM = parcelRequire("aicXM");

var $a31a42011344f865$var$_merge = $a31a42011344f865$require$_interopRequireDefault((parcelRequire("1gEAC")));

var $a31a42011344f865$var$_memoize = $a31a42011344f865$require$_interopRequireDefault((parcelRequire("eG4SW")));
const $a31a42011344f865$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $a31a42011344f865$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $a31a42011344f865$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $a31a42011344f865$var$getCssProperties = (0, $a31a42011344f865$var$_memoize.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($a31a42011344f865$var$aliases[prop]) prop = $a31a42011344f865$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $a31a42011344f865$var$properties[a];
    const direction = $a31a42011344f865$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $a31a42011344f865$var$marginKeys = module.exports.marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $a31a42011344f865$var$paddingKeys = module.exports.paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $a31a42011344f865$var$spacingKeys = [
    ...$a31a42011344f865$var$marginKeys,
    ...$a31a42011344f865$var$paddingKeys
];
function $a31a42011344f865$var$createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $aicXM.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $a31a42011344f865$var$createUnarySpacing(theme) {
    return $a31a42011344f865$var$createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function $a31a42011344f865$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $a31a42011344f865$var$getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $a31a42011344f865$var$getValue(transformer, propValue);
            return acc;
        }, {});
}
function $a31a42011344f865$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $a31a42011344f865$var$getCssProperties(prop);
    const styleFromPropValue = $a31a42011344f865$var$getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $kFz1f.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $a31a42011344f865$var$style(props, keys) {
    const transformer = $a31a42011344f865$var$createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>$a31a42011344f865$var$resolveCssProperty(props, keys, prop, transformer)).reduce($a31a42011344f865$var$_merge.default, {});
}
function $a31a42011344f865$var$margin(props) {
    return $a31a42011344f865$var$style(props, $a31a42011344f865$var$marginKeys);
}
$a31a42011344f865$var$margin.propTypes = {};
$a31a42011344f865$var$margin.filterProps = $a31a42011344f865$var$marginKeys;
function $a31a42011344f865$var$padding(props) {
    return $a31a42011344f865$var$style(props, $a31a42011344f865$var$paddingKeys);
}
$a31a42011344f865$var$padding.propTypes = {};
$a31a42011344f865$var$padding.filterProps = $a31a42011344f865$var$paddingKeys;
function $a31a42011344f865$var$spacing(props) {
    return $a31a42011344f865$var$style(props, $a31a42011344f865$var$spacingKeys);
}
$a31a42011344f865$var$spacing.propTypes = {};
$a31a42011344f865$var$spacing.filterProps = $a31a42011344f865$var$spacingKeys;
var $a31a42011344f865$var$_default = module.exports.default = $a31a42011344f865$var$spacing;

});
parcelRegister("eG4SW", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $aaf8c6ffb3020474$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $aaf8c6ffb3020474$var$_memoize.default;
    }
});

var $aaf8c6ffb3020474$var$_memoize = $aaf8c6ffb3020474$require$_interopRequireDefault((parcelRequire("lBitx")));

});
parcelRegister("lBitx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb9b628109650446$var$memoize;
function $fb9b628109650446$var$memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});




parcelRegister("3rcHQ", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $280dbfe25cd39646$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $280dbfe25cd39646$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $280dbfe25cd39646$var$_borders.default;
    }
});

var $280dbfe25cd39646$var$_borders = $280dbfe25cd39646$require$_interopRequireWildcard((parcelRequire("kQfi1")));
Object.keys($280dbfe25cd39646$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($280dbfe25cd39646$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $280dbfe25cd39646$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $280dbfe25cd39646$var$_borders[key];
        }
    });
});

});
parcelRegister("kQfi1", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f2c486366957a7ea$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.borderTopColor = module.exports.borderTop = module.exports.borderRightColor = module.exports.borderRight = module.exports.borderRadius = module.exports.borderLeftColor = module.exports.borderLeft = module.exports.borderColor = module.exports.borderBottomColor = module.exports.borderBottom = module.exports.border = void 0;
module.exports.borderTransform = $f2c486366957a7ea$var$borderTransform;
module.exports.outlineColor = module.exports.outline = module.exports.default = void 0;

var $f2c486366957a7ea$var$_responsivePropType = $f2c486366957a7ea$require$_interopRequireDefault((parcelRequire("l9eYP")));

var $f2c486366957a7ea$var$_style = $f2c486366957a7ea$require$_interopRequireDefault((parcelRequire("aicXM")));

var $f2c486366957a7ea$var$_compose = $f2c486366957a7ea$require$_interopRequireDefault((parcelRequire("lgAsJ")));

var $6QfFh = parcelRequire("6QfFh");

var $kFz1f = parcelRequire("kFz1f");
function $f2c486366957a7ea$var$borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $f2c486366957a7ea$var$createBorderStyle(prop, transform) {
    return (0, $f2c486366957a7ea$var$_style.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $f2c486366957a7ea$var$border = module.exports.border = $f2c486366957a7ea$var$createBorderStyle('border', $f2c486366957a7ea$var$borderTransform);
const $f2c486366957a7ea$var$borderTop = module.exports.borderTop = $f2c486366957a7ea$var$createBorderStyle('borderTop', $f2c486366957a7ea$var$borderTransform);
const $f2c486366957a7ea$var$borderRight = module.exports.borderRight = $f2c486366957a7ea$var$createBorderStyle('borderRight', $f2c486366957a7ea$var$borderTransform);
const $f2c486366957a7ea$var$borderBottom = module.exports.borderBottom = $f2c486366957a7ea$var$createBorderStyle('borderBottom', $f2c486366957a7ea$var$borderTransform);
const $f2c486366957a7ea$var$borderLeft = module.exports.borderLeft = $f2c486366957a7ea$var$createBorderStyle('borderLeft', $f2c486366957a7ea$var$borderTransform);
const $f2c486366957a7ea$var$borderColor = module.exports.borderColor = $f2c486366957a7ea$var$createBorderStyle('borderColor');
const $f2c486366957a7ea$var$borderTopColor = module.exports.borderTopColor = $f2c486366957a7ea$var$createBorderStyle('borderTopColor');
const $f2c486366957a7ea$var$borderRightColor = module.exports.borderRightColor = $f2c486366957a7ea$var$createBorderStyle('borderRightColor');
const $f2c486366957a7ea$var$borderBottomColor = module.exports.borderBottomColor = $f2c486366957a7ea$var$createBorderStyle('borderBottomColor');
const $f2c486366957a7ea$var$borderLeftColor = module.exports.borderLeftColor = $f2c486366957a7ea$var$createBorderStyle('borderLeftColor');
const $f2c486366957a7ea$var$outline = module.exports.outline = $f2c486366957a7ea$var$createBorderStyle('outline', $f2c486366957a7ea$var$borderTransform);
const $f2c486366957a7ea$var$outlineColor = module.exports.outlineColor = $f2c486366957a7ea$var$createBorderStyle('outlineColor');
// false positive
// eslint-disable-next-line react/function-component-definition
const $f2c486366957a7ea$var$borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $6QfFh.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $6QfFh.getValue)(transformer, propValue)
            });
        return (0, $kFz1f.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
module.exports.borderRadius = $f2c486366957a7ea$var$borderRadius;
$f2c486366957a7ea$var$borderRadius.propTypes = {};
$f2c486366957a7ea$var$borderRadius.filterProps = [
    'borderRadius'
];
const $f2c486366957a7ea$var$borders = (0, $f2c486366957a7ea$var$_compose.default)($f2c486366957a7ea$var$border, $f2c486366957a7ea$var$borderTop, $f2c486366957a7ea$var$borderRight, $f2c486366957a7ea$var$borderBottom, $f2c486366957a7ea$var$borderLeft, $f2c486366957a7ea$var$borderColor, $f2c486366957a7ea$var$borderTopColor, $f2c486366957a7ea$var$borderRightColor, $f2c486366957a7ea$var$borderBottomColor, $f2c486366957a7ea$var$borderLeftColor, $f2c486366957a7ea$var$borderRadius, $f2c486366957a7ea$var$outline, $f2c486366957a7ea$var$outlineColor);
var $f2c486366957a7ea$var$_default = module.exports.default = $f2c486366957a7ea$var$borders;

});
parcelRegister("lgAsJ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f7b76048b667ed99$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f7b76048b667ed99$var$_compose.default;
    }
});

var $f7b76048b667ed99$var$_compose = $f7b76048b667ed99$require$_interopRequireDefault((parcelRequire("7OpmN")));

});
parcelRegister("7OpmN", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $5b00e1396a0bc5a1$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b00e1396a0bc5a1$var$_merge = $5b00e1396a0bc5a1$require$_interopRequireDefault((parcelRequire("1gEAC")));
function $5b00e1396a0bc5a1$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $5b00e1396a0bc5a1$var$_merge.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $5b00e1396a0bc5a1$var$_default = module.exports.default = $5b00e1396a0bc5a1$var$compose;

});




parcelRegister("4zH5S", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $354bdbd1d1e058ae$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $354bdbd1d1e058ae$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $354bdbd1d1e058ae$var$_cssGrid.default;
    }
});

var $354bdbd1d1e058ae$var$_cssGrid = $354bdbd1d1e058ae$require$_interopRequireWildcard((parcelRequire("71l4w")));
Object.keys($354bdbd1d1e058ae$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($354bdbd1d1e058ae$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $354bdbd1d1e058ae$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $354bdbd1d1e058ae$var$_cssGrid[key];
        }
    });
});

});
parcelRegister("71l4w", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $51c8f8db37c2fd98$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rowGap = module.exports.gridTemplateRows = module.exports.gridTemplateColumns = module.exports.gridTemplateAreas = module.exports.gridRow = module.exports.gridColumn = module.exports.gridAutoRows = module.exports.gridAutoFlow = module.exports.gridAutoColumns = module.exports.gridArea = module.exports.gap = module.exports.default = module.exports.columnGap = void 0;

var $51c8f8db37c2fd98$var$_style = $51c8f8db37c2fd98$require$_interopRequireDefault((parcelRequire("aicXM")));

var $51c8f8db37c2fd98$var$_compose = $51c8f8db37c2fd98$require$_interopRequireDefault((parcelRequire("lgAsJ")));

var $6QfFh = parcelRequire("6QfFh");

var $kFz1f = parcelRequire("kFz1f");

var $51c8f8db37c2fd98$var$_responsivePropType = $51c8f8db37c2fd98$require$_interopRequireDefault((parcelRequire("l9eYP")));
// false positive
// eslint-disable-next-line react/function-component-definition
const $51c8f8db37c2fd98$var$gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $6QfFh.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $6QfFh.getValue)(transformer, propValue)
            });
        return (0, $kFz1f.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
module.exports.gap = $51c8f8db37c2fd98$var$gap;
$51c8f8db37c2fd98$var$gap.propTypes = {};
$51c8f8db37c2fd98$var$gap.filterProps = [
    'gap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $51c8f8db37c2fd98$var$columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $6QfFh.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $6QfFh.getValue)(transformer, propValue)
            });
        return (0, $kFz1f.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
module.exports.columnGap = $51c8f8db37c2fd98$var$columnGap;
$51c8f8db37c2fd98$var$columnGap.propTypes = {};
$51c8f8db37c2fd98$var$columnGap.filterProps = [
    'columnGap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $51c8f8db37c2fd98$var$rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $6QfFh.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $6QfFh.getValue)(transformer, propValue)
            });
        return (0, $kFz1f.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
module.exports.rowGap = $51c8f8db37c2fd98$var$rowGap;
$51c8f8db37c2fd98$var$rowGap.propTypes = {};
$51c8f8db37c2fd98$var$rowGap.filterProps = [
    'rowGap'
];
const $51c8f8db37c2fd98$var$gridColumn = module.exports.gridColumn = (0, $51c8f8db37c2fd98$var$_style.default)({
    prop: 'gridColumn'
});
const $51c8f8db37c2fd98$var$gridRow = module.exports.gridRow = (0, $51c8f8db37c2fd98$var$_style.default)({
    prop: 'gridRow'
});
const $51c8f8db37c2fd98$var$gridAutoFlow = module.exports.gridAutoFlow = (0, $51c8f8db37c2fd98$var$_style.default)({
    prop: 'gridAutoFlow'
});
const $51c8f8db37c2fd98$var$gridAutoColumns = module.exports.gridAutoColumns = (0, $51c8f8db37c2fd98$var$_style.default)({
    prop: 'gridAutoColumns'
});
const $51c8f8db37c2fd98$var$gridAutoRows = module.exports.gridAutoRows = (0, $51c8f8db37c2fd98$var$_style.default)({
    prop: 'gridAutoRows'
});
const $51c8f8db37c2fd98$var$gridTemplateColumns = module.exports.gridTemplateColumns = (0, $51c8f8db37c2fd98$var$_style.default)({
    prop: 'gridTemplateColumns'
});
const $51c8f8db37c2fd98$var$gridTemplateRows = module.exports.gridTemplateRows = (0, $51c8f8db37c2fd98$var$_style.default)({
    prop: 'gridTemplateRows'
});
const $51c8f8db37c2fd98$var$gridTemplateAreas = module.exports.gridTemplateAreas = (0, $51c8f8db37c2fd98$var$_style.default)({
    prop: 'gridTemplateAreas'
});
const $51c8f8db37c2fd98$var$gridArea = module.exports.gridArea = (0, $51c8f8db37c2fd98$var$_style.default)({
    prop: 'gridArea'
});
const $51c8f8db37c2fd98$var$grid = (0, $51c8f8db37c2fd98$var$_compose.default)($51c8f8db37c2fd98$var$gap, $51c8f8db37c2fd98$var$columnGap, $51c8f8db37c2fd98$var$rowGap, $51c8f8db37c2fd98$var$gridColumn, $51c8f8db37c2fd98$var$gridRow, $51c8f8db37c2fd98$var$gridAutoFlow, $51c8f8db37c2fd98$var$gridAutoColumns, $51c8f8db37c2fd98$var$gridAutoRows, $51c8f8db37c2fd98$var$gridTemplateColumns, $51c8f8db37c2fd98$var$gridTemplateRows, $51c8f8db37c2fd98$var$gridTemplateAreas, $51c8f8db37c2fd98$var$gridArea);
var $51c8f8db37c2fd98$var$_default = module.exports.default = $51c8f8db37c2fd98$var$grid;

});


parcelRegister("9xWWR", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $6f34ec0726a1ca8a$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6f34ec0726a1ca8a$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6f34ec0726a1ca8a$var$_palette.default;
    }
});

var $6f34ec0726a1ca8a$var$_palette = $6f34ec0726a1ca8a$require$_interopRequireWildcard((parcelRequire("iSmaf")));
Object.keys($6f34ec0726a1ca8a$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6f34ec0726a1ca8a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6f34ec0726a1ca8a$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6f34ec0726a1ca8a$var$_palette[key];
        }
    });
});

});
parcelRegister("iSmaf", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $dbde76873afe2e31$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.color = module.exports.bgcolor = module.exports.backgroundColor = void 0;
module.exports.paletteTransform = $dbde76873afe2e31$var$paletteTransform;

var $dbde76873afe2e31$var$_style = $dbde76873afe2e31$require$_interopRequireDefault((parcelRequire("aicXM")));

var $dbde76873afe2e31$var$_compose = $dbde76873afe2e31$require$_interopRequireDefault((parcelRequire("lgAsJ")));
function $dbde76873afe2e31$var$paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $dbde76873afe2e31$var$color = module.exports.color = (0, $dbde76873afe2e31$var$_style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $dbde76873afe2e31$var$paletteTransform
});
const $dbde76873afe2e31$var$bgcolor = module.exports.bgcolor = (0, $dbde76873afe2e31$var$_style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $dbde76873afe2e31$var$paletteTransform
});
const $dbde76873afe2e31$var$backgroundColor = module.exports.backgroundColor = (0, $dbde76873afe2e31$var$_style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $dbde76873afe2e31$var$paletteTransform
});
const $dbde76873afe2e31$var$palette = (0, $dbde76873afe2e31$var$_compose.default)($dbde76873afe2e31$var$color, $dbde76873afe2e31$var$bgcolor, $dbde76873afe2e31$var$backgroundColor);
var $dbde76873afe2e31$var$_default = module.exports.default = $dbde76873afe2e31$var$palette;

});


parcelRegister("gKFto", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $c3211ce3eab471d3$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c3211ce3eab471d3$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c3211ce3eab471d3$var$_sizing.default;
    }
});

var $c3211ce3eab471d3$var$_sizing = $c3211ce3eab471d3$require$_interopRequireWildcard((parcelRequire("9J3yB")));
Object.keys($c3211ce3eab471d3$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c3211ce3eab471d3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c3211ce3eab471d3$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c3211ce3eab471d3$var$_sizing[key];
        }
    });
});

});
parcelRegister("9J3yB", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $714b1364e3467a48$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sizeWidth = module.exports.sizeHeight = module.exports.minWidth = module.exports.minHeight = module.exports.maxWidth = module.exports.maxHeight = module.exports.height = module.exports.default = module.exports.boxSizing = void 0;
module.exports.sizingTransform = $714b1364e3467a48$var$sizingTransform;
module.exports.width = void 0;

var $714b1364e3467a48$var$_style = $714b1364e3467a48$require$_interopRequireDefault((parcelRequire("aicXM")));

var $714b1364e3467a48$var$_compose = $714b1364e3467a48$require$_interopRequireDefault((parcelRequire("lgAsJ")));

var $kFz1f = parcelRequire("kFz1f");
function $714b1364e3467a48$var$sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $714b1364e3467a48$var$width = module.exports.width = (0, $714b1364e3467a48$var$_style.default)({
    prop: 'width',
    transform: $714b1364e3467a48$var$sizingTransform
});
const $714b1364e3467a48$var$maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $kFz1f.values[propValue];
            if (!breakpoint) return {
                maxWidth: $714b1364e3467a48$var$sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $kFz1f.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
module.exports.maxWidth = $714b1364e3467a48$var$maxWidth;
$714b1364e3467a48$var$maxWidth.filterProps = [
    'maxWidth'
];
const $714b1364e3467a48$var$minWidth = module.exports.minWidth = (0, $714b1364e3467a48$var$_style.default)({
    prop: 'minWidth',
    transform: $714b1364e3467a48$var$sizingTransform
});
const $714b1364e3467a48$var$height = module.exports.height = (0, $714b1364e3467a48$var$_style.default)({
    prop: 'height',
    transform: $714b1364e3467a48$var$sizingTransform
});
const $714b1364e3467a48$var$maxHeight = module.exports.maxHeight = (0, $714b1364e3467a48$var$_style.default)({
    prop: 'maxHeight',
    transform: $714b1364e3467a48$var$sizingTransform
});
const $714b1364e3467a48$var$minHeight = module.exports.minHeight = (0, $714b1364e3467a48$var$_style.default)({
    prop: 'minHeight',
    transform: $714b1364e3467a48$var$sizingTransform
});
const $714b1364e3467a48$var$sizeWidth = module.exports.sizeWidth = (0, $714b1364e3467a48$var$_style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $714b1364e3467a48$var$sizingTransform
});
const $714b1364e3467a48$var$sizeHeight = module.exports.sizeHeight = (0, $714b1364e3467a48$var$_style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $714b1364e3467a48$var$sizingTransform
});
const $714b1364e3467a48$var$boxSizing = module.exports.boxSizing = (0, $714b1364e3467a48$var$_style.default)({
    prop: 'boxSizing'
});
const $714b1364e3467a48$var$sizing = (0, $714b1364e3467a48$var$_compose.default)($714b1364e3467a48$var$width, $714b1364e3467a48$var$maxWidth, $714b1364e3467a48$var$minWidth, $714b1364e3467a48$var$height, $714b1364e3467a48$var$maxHeight, $714b1364e3467a48$var$minHeight, $714b1364e3467a48$var$boxSizing);
var $714b1364e3467a48$var$_default = module.exports.default = $714b1364e3467a48$var$sizing;

});




parcelRegister("hoRpU", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $caae1d0fd3f18184$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $caae1d0fd3f18184$var$extendSxProp;

var $cfKeZ = parcelRequire("cfKeZ");

var $caae1d0fd3f18184$var$_defaultSxConfig = $caae1d0fd3f18184$require$_interopRequireDefault((parcelRequire("3pSKT")));
const $caae1d0fd3f18184$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? $caae1d0fd3f18184$var$_defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $caae1d0fd3f18184$var$extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $caae1d0fd3f18184$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $cfKeZ.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("kYavH", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $f441905be2dc74b2$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $f441905be2dc74b2$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f441905be2dc74b2$var$useTheme;

var $f441905be2dc74b2$var$React = $f441905be2dc74b2$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $hk9Pq = parcelRequire("hk9Pq");

var $f441905be2dc74b2$var$_defaultTheme = $f441905be2dc74b2$require$_interopRequireDefault((parcelRequire("kbn1c")));

var $f441905be2dc74b2$var$_identifier = $f441905be2dc74b2$require$_interopRequireDefault((parcelRequire("Ho9ot")));
function $f441905be2dc74b2$var$useTheme() {
    const theme = (0, $hk9Pq.default)($f441905be2dc74b2$var$_defaultTheme.default);
    return theme[$f441905be2dc74b2$var$_identifier.default] || theme;
}

});
parcelRegister("hk9Pq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9cbed9f9eee53dc$export$2e2bcd8739ae039; });

var $Elngy = parcelRequire("Elngy");

var $34cvB = parcelRequire("34cvB");
'use client';
const $c9cbed9f9eee53dc$export$35e57303dbd8a66 = (0, $Elngy.default)();
function $c9cbed9f9eee53dc$var$useTheme(defaultTheme = $c9cbed9f9eee53dc$export$35e57303dbd8a66) {
    return (0, $34cvB.default)(defaultTheme);
}
var $c9cbed9f9eee53dc$export$2e2bcd8739ae039 = $c9cbed9f9eee53dc$var$useTheme;

});
parcelRegister("Elngy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $079451063867d010$export$2e2bcd8739ae039; });

var $cfKeZ = parcelRequire("cfKeZ");

var $hBOoG = parcelRequire("hBOoG");

var $icuUB = parcelRequire("icuUB");

var $70Mj2 = parcelRequire("70Mj2");

var $dMm7J = parcelRequire("dMm7J");

var $jxonz = parcelRequire("jxonz");

var $jakrK = parcelRequire("jakrK");

var $ekTgt = parcelRequire("ekTgt");
function $079451063867d010$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $hBOoG.default)(breakpointsInput);
    const spacing = (0, $dMm7J.default)(spacingInput);
    let muiTheme = (0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $70Mj2.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $icuUB.default)(muiTheme);
    muiTheme.applyStyles = (0, $ekTgt.default);
    muiTheme = args.reduce((acc, argument)=>(0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $jakrK.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $jxonz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $079451063867d010$export$2e2bcd8739ae039 = $079451063867d010$var$createTheme;

});
parcelRegister("hBOoG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd1cfc2c25d64373$export$2e2bcd8739ae039; });
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $cd1cfc2c25d64373$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $cd1cfc2c25d64373$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $cd1cfc2c25d64373$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $cd1cfc2c25d64373$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("icuUB", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", function () { return $d4015375427777f6$export$456f6c1142f990db; });
$parcel$export(module.exports, "isCqShorthand", function () { return $d4015375427777f6$export$77c7c3e357f440e7; });
$parcel$export(module.exports, "getContainerQuery", function () { return $d4015375427777f6$export$10a9745dfa00d15; });
$parcel$export(module.exports, "default", function () { return $d4015375427777f6$export$2e2bcd8739ae039; });

function $d4015375427777f6$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $d4015375427777f6$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $d4015375427777f6$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $d4015375427777f6$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});

parcelRegister("70Mj2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51ae011349bd05b3$export$2e2bcd8739ae039; });
const $51ae011349bd05b3$var$shape = {
    borderRadius: 4
};
var $51ae011349bd05b3$export$2e2bcd8739ae039 = $51ae011349bd05b3$var$shape;

});

parcelRegister("dMm7J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a080eb569c8a872e$export$2e2bcd8739ae039; });

var $WqQl4 = parcelRequire("WqQl4");
function $a080eb569c8a872e$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $WqQl4.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("WqQl4", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $0afa3d63b9f0e231$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $0afa3d63b9f0e231$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $0afa3d63b9f0e231$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $0afa3d63b9f0e231$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $0afa3d63b9f0e231$export$6f98e8eaf0be1996; });


var $6m0u5 = parcelRequire("6m0u5");

var $ieTF2 = parcelRequire("ieTF2");

var $joYgc = parcelRequire("joYgc");

var $aNPoV = parcelRequire("aNPoV");
const $0afa3d63b9f0e231$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $0afa3d63b9f0e231$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $0afa3d63b9f0e231$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $0afa3d63b9f0e231$var$getCssProperties = (0, $aNPoV.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($0afa3d63b9f0e231$var$aliases[prop]) prop = $0afa3d63b9f0e231$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $0afa3d63b9f0e231$var$properties[a];
    const direction = $0afa3d63b9f0e231$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $0afa3d63b9f0e231$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $0afa3d63b9f0e231$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $0afa3d63b9f0e231$var$spacingKeys = [
    ...$0afa3d63b9f0e231$export$aab52a0dde05ad8a,
    ...$0afa3d63b9f0e231$export$f8397d44f03ab6ad
];
function $0afa3d63b9f0e231$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $ieTF2.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $0afa3d63b9f0e231$export$1def6f833384e3d1(theme) {
    return $0afa3d63b9f0e231$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $0afa3d63b9f0e231$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $0afa3d63b9f0e231$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $0afa3d63b9f0e231$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $0afa3d63b9f0e231$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $0afa3d63b9f0e231$var$getCssProperties(prop);
    const styleFromPropValue = $0afa3d63b9f0e231$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $6m0u5.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $0afa3d63b9f0e231$var$style(props, keys) {
    const transformer = $0afa3d63b9f0e231$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$0afa3d63b9f0e231$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $joYgc.default), {});
}
function $0afa3d63b9f0e231$export$7ede87f9b603dd3c(props) {
    return $0afa3d63b9f0e231$var$style(props, $0afa3d63b9f0e231$export$aab52a0dde05ad8a);
}
$0afa3d63b9f0e231$export$7ede87f9b603dd3c.propTypes = {};
$0afa3d63b9f0e231$export$7ede87f9b603dd3c.filterProps = $0afa3d63b9f0e231$export$aab52a0dde05ad8a;
function $0afa3d63b9f0e231$export$6f98e8eaf0be1996(props) {
    return $0afa3d63b9f0e231$var$style(props, $0afa3d63b9f0e231$export$f8397d44f03ab6ad);
}
$0afa3d63b9f0e231$export$6f98e8eaf0be1996.propTypes = {};
$0afa3d63b9f0e231$export$6f98e8eaf0be1996.filterProps = $0afa3d63b9f0e231$export$f8397d44f03ab6ad;
function $0afa3d63b9f0e231$var$spacing(props) {
    return $0afa3d63b9f0e231$var$style(props, $0afa3d63b9f0e231$var$spacingKeys);
}
$0afa3d63b9f0e231$var$spacing.propTypes = {};
$0afa3d63b9f0e231$var$spacing.filterProps = $0afa3d63b9f0e231$var$spacingKeys;
var $0afa3d63b9f0e231$export$2e2bcd8739ae039 = $0afa3d63b9f0e231$var$spacing;

});
parcelRegister("6m0u5", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $4a052c56d38724a9$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $4a052c56d38724a9$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $4a052c56d38724a9$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $4a052c56d38724a9$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $4a052c56d38724a9$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $4a052c56d38724a9$export$980e6a259d807490; });


var $cfKeZ = parcelRequire("cfKeZ");

var $joYgc = parcelRequire("joYgc");

var $icuUB = parcelRequire("icuUB");
const $4a052c56d38724a9$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $4a052c56d38724a9$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$4a052c56d38724a9$export$68c286be0e7e55b7[key]}px)`
};
const $4a052c56d38724a9$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $4a052c56d38724a9$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $4a052c56d38724a9$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $4a052c56d38724a9$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $4a052c56d38724a9$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $icuUB.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $icuUB.getContainerQuery)(theme.containerQueries ? theme : $4a052c56d38724a9$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $4a052c56d38724a9$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $4a052c56d38724a9$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $4a052c56d38724a9$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $joYgc.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $4a052c56d38724a9$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $4a052c56d38724a9$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $4a052c56d38724a9$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $4a052c56d38724a9$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(prev, next), {});
    return $4a052c56d38724a9$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $4a052c56d38724a9$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $4a052c56d38724a9$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $4a052c56d38724a9$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $4a052c56d38724a9$export$2e2bcd8739ae039 = $4a052c56d38724a9$var$breakpoints;

});
parcelRegister("joYgc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1ff00a34b33a248$export$2e2bcd8739ae039; });

var $cfKeZ = parcelRequire("cfKeZ");
function $e1ff00a34b33a248$var$merge(acc, item) {
    if (!item) return acc;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $e1ff00a34b33a248$export$2e2bcd8739ae039 = $e1ff00a34b33a248$var$merge;

});


parcelRegister("ieTF2", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $036d3cbd9d86f173$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $036d3cbd9d86f173$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $036d3cbd9d86f173$export$2e2bcd8739ae039; });

var $eUhyY = parcelRequire("eUhyY");


var $6m0u5 = parcelRequire("6m0u5");
function $036d3cbd9d86f173$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $036d3cbd9d86f173$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $036d3cbd9d86f173$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $036d3cbd9d86f173$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $036d3cbd9d86f173$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $036d3cbd9d86f173$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $036d3cbd9d86f173$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($eUhyY)))(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $6m0u5.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $036d3cbd9d86f173$export$2e2bcd8739ae039 = $036d3cbd9d86f173$var$style;

});

parcelRegister("aNPoV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7dd65a26dd0d8e12$export$2e2bcd8739ae039; });
function $7dd65a26dd0d8e12$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("jxonz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3940296ca149810$export$2e2bcd8739ae039; });

var $eUhyY = parcelRequire("eUhyY");

var $joYgc = parcelRequire("joYgc");

var $ieTF2 = parcelRequire("ieTF2");

var $6m0u5 = parcelRequire("6m0u5");

var $icuUB = parcelRequire("icuUB");

var $jakrK = parcelRequire("jakrK");
function $e3940296ca149810$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $e3940296ca149810$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $e3940296ca149810$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $ieTF2.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $ieTF2.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $ieTF2.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($eUhyY)))(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $6m0u5.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $jakrK.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $6m0u5.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $e3940296ca149810$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $joYgc.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $6m0u5.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($e3940296ca149810$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $joYgc.default)(css, breakpointsValues);
                        }
                    } else css = (0, $joYgc.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $icuUB.sortContainerQueries)(theme, (0, $6m0u5.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $e3940296ca149810$var$styleFunctionSx = $e3940296ca149810$export$7d53d8bf2911e013();
$e3940296ca149810$var$styleFunctionSx.filterProps = [
    'sx'
];
var $e3940296ca149810$export$2e2bcd8739ae039 = $e3940296ca149810$var$styleFunctionSx;

});
parcelRegister("jakrK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df3ecfbd2bc6a574$export$2e2bcd8739ae039; });

var $WqQl4 = parcelRequire("WqQl4");

var $6vK4J = parcelRequire("6vK4J");

var $iTdVG = parcelRequire("iTdVG");

var $gQO29 = parcelRequire("gQO29");

var $aBcBO = parcelRequire("aBcBO");
const $df3ecfbd2bc6a574$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $6vK4J.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $6vK4J.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $6vK4J.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $6vK4J.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $6vK4J.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $6vK4J.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $6vK4J.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $gQO29.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $gQO29.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $gQO29.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $WqQl4.padding)
    },
    pt: {
        style: (0, $WqQl4.padding)
    },
    pr: {
        style: (0, $WqQl4.padding)
    },
    pb: {
        style: (0, $WqQl4.padding)
    },
    pl: {
        style: (0, $WqQl4.padding)
    },
    px: {
        style: (0, $WqQl4.padding)
    },
    py: {
        style: (0, $WqQl4.padding)
    },
    padding: {
        style: (0, $WqQl4.padding)
    },
    paddingTop: {
        style: (0, $WqQl4.padding)
    },
    paddingRight: {
        style: (0, $WqQl4.padding)
    },
    paddingBottom: {
        style: (0, $WqQl4.padding)
    },
    paddingLeft: {
        style: (0, $WqQl4.padding)
    },
    paddingX: {
        style: (0, $WqQl4.padding)
    },
    paddingY: {
        style: (0, $WqQl4.padding)
    },
    paddingInline: {
        style: (0, $WqQl4.padding)
    },
    paddingInlineStart: {
        style: (0, $WqQl4.padding)
    },
    paddingInlineEnd: {
        style: (0, $WqQl4.padding)
    },
    paddingBlock: {
        style: (0, $WqQl4.padding)
    },
    paddingBlockStart: {
        style: (0, $WqQl4.padding)
    },
    paddingBlockEnd: {
        style: (0, $WqQl4.padding)
    },
    m: {
        style: (0, $WqQl4.margin)
    },
    mt: {
        style: (0, $WqQl4.margin)
    },
    mr: {
        style: (0, $WqQl4.margin)
    },
    mb: {
        style: (0, $WqQl4.margin)
    },
    ml: {
        style: (0, $WqQl4.margin)
    },
    mx: {
        style: (0, $WqQl4.margin)
    },
    my: {
        style: (0, $WqQl4.margin)
    },
    margin: {
        style: (0, $WqQl4.margin)
    },
    marginTop: {
        style: (0, $WqQl4.margin)
    },
    marginRight: {
        style: (0, $WqQl4.margin)
    },
    marginBottom: {
        style: (0, $WqQl4.margin)
    },
    marginLeft: {
        style: (0, $WqQl4.margin)
    },
    marginX: {
        style: (0, $WqQl4.margin)
    },
    marginY: {
        style: (0, $WqQl4.margin)
    },
    marginInline: {
        style: (0, $WqQl4.margin)
    },
    marginInlineStart: {
        style: (0, $WqQl4.margin)
    },
    marginInlineEnd: {
        style: (0, $WqQl4.margin)
    },
    marginBlock: {
        style: (0, $WqQl4.margin)
    },
    marginBlockStart: {
        style: (0, $WqQl4.margin)
    },
    marginBlockEnd: {
        style: (0, $WqQl4.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $iTdVG.gap)
    },
    rowGap: {
        style: (0, $iTdVG.rowGap)
    },
    columnGap: {
        style: (0, $iTdVG.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $aBcBO.sizingTransform)
    },
    maxWidth: {
        style: (0, $aBcBO.maxWidth)
    },
    minWidth: {
        transform: (0, $aBcBO.sizingTransform)
    },
    height: {
        transform: (0, $aBcBO.sizingTransform)
    },
    maxHeight: {
        transform: (0, $aBcBO.sizingTransform)
    },
    minHeight: {
        transform: (0, $aBcBO.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $df3ecfbd2bc6a574$export$2e2bcd8739ae039 = $df3ecfbd2bc6a574$var$defaultSxConfig;

});
parcelRegister("6vK4J", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $4bd960f290024d40$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $4bd960f290024d40$export$7a57f79000377ca2; });


var $ieTF2 = parcelRequire("ieTF2");

var $k2Znp = parcelRequire("k2Znp");

var $WqQl4 = parcelRequire("WqQl4");

var $6m0u5 = parcelRequire("6m0u5");
function $4bd960f290024d40$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $4bd960f290024d40$var$createBorderStyle(prop, transform) {
    return (0, $ieTF2.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $4bd960f290024d40$export$1edee58a52776cd9 = $4bd960f290024d40$var$createBorderStyle('border', $4bd960f290024d40$export$34e2febe53ae29cc);
const $4bd960f290024d40$export$f9a7b6bd24892946 = $4bd960f290024d40$var$createBorderStyle('borderTop', $4bd960f290024d40$export$34e2febe53ae29cc);
const $4bd960f290024d40$export$5abca33e6be905d2 = $4bd960f290024d40$var$createBorderStyle('borderRight', $4bd960f290024d40$export$34e2febe53ae29cc);
const $4bd960f290024d40$export$e2ce9f12a980a822 = $4bd960f290024d40$var$createBorderStyle('borderBottom', $4bd960f290024d40$export$34e2febe53ae29cc);
const $4bd960f290024d40$export$47658cca1a909427 = $4bd960f290024d40$var$createBorderStyle('borderLeft', $4bd960f290024d40$export$34e2febe53ae29cc);
const $4bd960f290024d40$export$e7fb0694ba2404fc = $4bd960f290024d40$var$createBorderStyle('borderColor');
const $4bd960f290024d40$export$126a92c968acdb85 = $4bd960f290024d40$var$createBorderStyle('borderTopColor');
const $4bd960f290024d40$export$85cc51cb8fbb8c0e = $4bd960f290024d40$var$createBorderStyle('borderRightColor');
const $4bd960f290024d40$export$340b0327727f6d1a = $4bd960f290024d40$var$createBorderStyle('borderBottomColor');
const $4bd960f290024d40$export$60beef91a985b4bf = $4bd960f290024d40$var$createBorderStyle('borderLeftColor');
const $4bd960f290024d40$export$f9258c55612cbed7 = $4bd960f290024d40$var$createBorderStyle('outline', $4bd960f290024d40$export$34e2febe53ae29cc);
const $4bd960f290024d40$export$621fe586efeb64b9 = $4bd960f290024d40$var$createBorderStyle('outlineColor');
const $4bd960f290024d40$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $WqQl4.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $WqQl4.getValue)(transformer, propValue)
            });
        return (0, $6m0u5.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$4bd960f290024d40$export$7a57f79000377ca2.propTypes = {};
$4bd960f290024d40$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $4bd960f290024d40$var$borders = (0, $k2Znp.default)($4bd960f290024d40$export$1edee58a52776cd9, $4bd960f290024d40$export$f9a7b6bd24892946, $4bd960f290024d40$export$5abca33e6be905d2, $4bd960f290024d40$export$e2ce9f12a980a822, $4bd960f290024d40$export$47658cca1a909427, $4bd960f290024d40$export$e7fb0694ba2404fc, $4bd960f290024d40$export$126a92c968acdb85, $4bd960f290024d40$export$85cc51cb8fbb8c0e, $4bd960f290024d40$export$340b0327727f6d1a, $4bd960f290024d40$export$60beef91a985b4bf, $4bd960f290024d40$export$7a57f79000377ca2, $4bd960f290024d40$export$f9258c55612cbed7, $4bd960f290024d40$export$621fe586efeb64b9);
var $4bd960f290024d40$export$2e2bcd8739ae039 = $4bd960f290024d40$var$borders;

});
parcelRegister("k2Znp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9839aaa789910ec$export$2e2bcd8739ae039; });

var $joYgc = parcelRequire("joYgc");
function $e9839aaa789910ec$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $joYgc.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $e9839aaa789910ec$export$2e2bcd8739ae039 = $e9839aaa789910ec$var$compose;

});


parcelRegister("iTdVG", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $dc082b23665ce302$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $dc082b23665ce302$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $dc082b23665ce302$export$8a833ffa5f5dbeda; });

var $ieTF2 = parcelRequire("ieTF2");

var $k2Znp = parcelRequire("k2Znp");

var $WqQl4 = parcelRequire("WqQl4");

var $6m0u5 = parcelRequire("6m0u5");

const $dc082b23665ce302$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $WqQl4.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $WqQl4.getValue)(transformer, propValue)
            });
        return (0, $6m0u5.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$dc082b23665ce302$export$5df9adcb0db95e1e.propTypes = {};
$dc082b23665ce302$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $dc082b23665ce302$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $WqQl4.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $WqQl4.getValue)(transformer, propValue)
            });
        return (0, $6m0u5.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$dc082b23665ce302$export$ec60d70ff941a580.propTypes = {};
$dc082b23665ce302$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $dc082b23665ce302$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $WqQl4.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $WqQl4.getValue)(transformer, propValue)
            });
        return (0, $6m0u5.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$dc082b23665ce302$export$8a833ffa5f5dbeda.propTypes = {};
$dc082b23665ce302$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $dc082b23665ce302$export$baf44164ca3a34e8 = (0, $ieTF2.default)({
    prop: 'gridColumn'
});
const $dc082b23665ce302$export$8f7213a1cd01e832 = (0, $ieTF2.default)({
    prop: 'gridRow'
});
const $dc082b23665ce302$export$b0e0abbc49ba668 = (0, $ieTF2.default)({
    prop: 'gridAutoFlow'
});
const $dc082b23665ce302$export$bcd8b929d4b4142 = (0, $ieTF2.default)({
    prop: 'gridAutoColumns'
});
const $dc082b23665ce302$export$e5039a674e14c828 = (0, $ieTF2.default)({
    prop: 'gridAutoRows'
});
const $dc082b23665ce302$export$42bd9088661ffb03 = (0, $ieTF2.default)({
    prop: 'gridTemplateColumns'
});
const $dc082b23665ce302$export$920682ae05b999bc = (0, $ieTF2.default)({
    prop: 'gridTemplateRows'
});
const $dc082b23665ce302$export$1b88fbdd482fd33a = (0, $ieTF2.default)({
    prop: 'gridTemplateAreas'
});
const $dc082b23665ce302$export$bdb486e40d52d26f = (0, $ieTF2.default)({
    prop: 'gridArea'
});
const $dc082b23665ce302$var$grid = (0, $k2Znp.default)($dc082b23665ce302$export$5df9adcb0db95e1e, $dc082b23665ce302$export$ec60d70ff941a580, $dc082b23665ce302$export$8a833ffa5f5dbeda, $dc082b23665ce302$export$baf44164ca3a34e8, $dc082b23665ce302$export$8f7213a1cd01e832, $dc082b23665ce302$export$b0e0abbc49ba668, $dc082b23665ce302$export$bcd8b929d4b4142, $dc082b23665ce302$export$e5039a674e14c828, $dc082b23665ce302$export$42bd9088661ffb03, $dc082b23665ce302$export$920682ae05b999bc, $dc082b23665ce302$export$1b88fbdd482fd33a, $dc082b23665ce302$export$bdb486e40d52d26f);
var $dc082b23665ce302$export$2e2bcd8739ae039 = $dc082b23665ce302$var$grid;

});

parcelRegister("gQO29", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $c44850587766837c$export$dbaffd4420ea0ac6; });

var $ieTF2 = parcelRequire("ieTF2");

var $k2Znp = parcelRequire("k2Znp");
function $c44850587766837c$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $c44850587766837c$export$35e9368ef982300f = (0, $ieTF2.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $c44850587766837c$export$dbaffd4420ea0ac6
});
const $c44850587766837c$export$2506f56c10355b33 = (0, $ieTF2.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $c44850587766837c$export$dbaffd4420ea0ac6
});
const $c44850587766837c$export$8c5a050822fd698c = (0, $ieTF2.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $c44850587766837c$export$dbaffd4420ea0ac6
});
const $c44850587766837c$var$palette = (0, $k2Znp.default)($c44850587766837c$export$35e9368ef982300f, $c44850587766837c$export$2506f56c10355b33, $c44850587766837c$export$8c5a050822fd698c);
var $c44850587766837c$export$2e2bcd8739ae039 = $c44850587766837c$var$palette;

});

parcelRegister("aBcBO", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $7b7723f84cd9b8ff$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $7b7723f84cd9b8ff$export$488fda99655ff65a; });

var $ieTF2 = parcelRequire("ieTF2");

var $k2Znp = parcelRequire("k2Znp");

var $6m0u5 = parcelRequire("6m0u5");
function $7b7723f84cd9b8ff$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $7b7723f84cd9b8ff$export$7e3df82ee760448c = (0, $ieTF2.default)({
    prop: 'width',
    transform: $7b7723f84cd9b8ff$export$8afece71750ec241
});
const $7b7723f84cd9b8ff$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $6m0u5.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $7b7723f84cd9b8ff$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $6m0u5.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$7b7723f84cd9b8ff$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $7b7723f84cd9b8ff$export$ee148fbbe8357dd2 = (0, $ieTF2.default)({
    prop: 'minWidth',
    transform: $7b7723f84cd9b8ff$export$8afece71750ec241
});
const $7b7723f84cd9b8ff$export$ac607276a8fe9f0a = (0, $ieTF2.default)({
    prop: 'height',
    transform: $7b7723f84cd9b8ff$export$8afece71750ec241
});
const $7b7723f84cd9b8ff$export$dc0d8bd0b94f8570 = (0, $ieTF2.default)({
    prop: 'maxHeight',
    transform: $7b7723f84cd9b8ff$export$8afece71750ec241
});
const $7b7723f84cd9b8ff$export$a43cf604e12f3b17 = (0, $ieTF2.default)({
    prop: 'minHeight',
    transform: $7b7723f84cd9b8ff$export$8afece71750ec241
});
const $7b7723f84cd9b8ff$export$ffed9f14fb65e276 = (0, $ieTF2.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $7b7723f84cd9b8ff$export$8afece71750ec241
});
const $7b7723f84cd9b8ff$export$905076ed6620e671 = (0, $ieTF2.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $7b7723f84cd9b8ff$export$8afece71750ec241
});
const $7b7723f84cd9b8ff$export$6ccc93f785106a58 = (0, $ieTF2.default)({
    prop: 'boxSizing'
});
const $7b7723f84cd9b8ff$var$sizing = (0, $k2Znp.default)($7b7723f84cd9b8ff$export$7e3df82ee760448c, $7b7723f84cd9b8ff$export$488fda99655ff65a, $7b7723f84cd9b8ff$export$ee148fbbe8357dd2, $7b7723f84cd9b8ff$export$ac607276a8fe9f0a, $7b7723f84cd9b8ff$export$dc0d8bd0b94f8570, $7b7723f84cd9b8ff$export$a43cf604e12f3b17, $7b7723f84cd9b8ff$export$6ccc93f785106a58);
var $7b7723f84cd9b8ff$export$2e2bcd8739ae039 = $7b7723f84cd9b8ff$var$sizing;

});



parcelRegister("ekTgt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6fdcd5c4501f343$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $a6fdcd5c4501f343$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("34cvB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23bb72cef0562a91$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");
parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");
'use client';
function $23bb72cef0562a91$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $23bb72cef0562a91$var$useTheme(defaultTheme = null) {
    const contextTheme = $8nGP5.useContext((0, $jspCa.T));
    return !contextTheme || $23bb72cef0562a91$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $23bb72cef0562a91$export$2e2bcd8739ae039 = $23bb72cef0562a91$var$useTheme;

});
parcelRegister("bj8tp", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $83b80aaa9bbccc8e$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $83b80aaa9bbccc8e$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $83b80aaa9bbccc8e$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("jspCa")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("jspCa")).w; });

var $jspCa = parcelRequire("jspCa");

var $8nGP5 = parcelRequire("8nGP5");

var $7x006 = parcelRequire("7x006");

var $dgnOT = parcelRequire("dgnOT");

var $iBxqj = parcelRequire("iBxqj");
parcelRequire("6tfZw");
parcelRequire("8tsi7");
parcelRequire("eIxVf");

parcelRequire("cSUBB");
var $83b80aaa9bbccc8e$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $83b80aaa9bbccc8e$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $jspCa.h).call(props, 'css')) // $FlowFixMe
    return $8nGP5.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $jspCa.E);
    createElementArgArray[1] = (0, $jspCa.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $8nGP5.createElement.apply(null, createElementArgArray);
};
var $83b80aaa9bbccc8e$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $83b80aaa9bbccc8e$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $jspCa.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $iBxqj.serializeStyles)([
        styles
    ], undefined, $8nGP5.useContext((0, $jspCa.T)));
    if (!(0, $jspCa.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8nGP5.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8nGP5.useRef();
    (0, $dgnOT.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $dgnOT.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $7x006.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $83b80aaa9bbccc8e$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $iBxqj.serializeStyles)(args);
}
var $83b80aaa9bbccc8e$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $83b80aaa9bbccc8e$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $83b80aaa9bbccc8e$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $83b80aaa9bbccc8e$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $7x006.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $83b80aaa9bbccc8e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $dgnOT.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $7x006.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $83b80aaa9bbccc8e$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $jspCa.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $iBxqj.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $7x006.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $83b80aaa9bbccc8e$var$merge(cache.registered, css, $83b80aaa9bbccc8e$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8nGP5.useContext((0, $jspCa.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement($83b80aaa9bbccc8e$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $83b80aaa9bbccc8e$var$isBrowser, $83b80aaa9bbccc8e$var$isTestEnv, $83b80aaa9bbccc8e$var$globalContext, $83b80aaa9bbccc8e$var$globalKey;

});
parcelRegister("jspCa", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $e2a48059f7c5542d$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $e2a48059f7c5542d$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $e2a48059f7c5542d$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $e2a48059f7c5542d$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $e2a48059f7c5542d$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $e2a48059f7c5542d$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $e2a48059f7c5542d$export$a9c23c6ac3fc3eca; });

var $8nGP5 = parcelRequire("8nGP5");

var $6tfZw = parcelRequire("6tfZw");

var $1TGTA = parcelRequire("1TGTA");

var $eIxVf = parcelRequire("eIxVf");

var $glGaj = parcelRequire("glGaj");

var $7x006 = parcelRequire("7x006");

var $iBxqj = parcelRequire("iBxqj");

var $dgnOT = parcelRequire("dgnOT");
var $e2a48059f7c5542d$export$23f2a1d2818174ef = true;
var $e2a48059f7c5542d$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $e2a48059f7c5542d$var$EmotionCacheContext = /* #__PURE__ */ $8nGP5.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $6tfZw.default)({
    key: 'css'
}) : null);
var $e2a48059f7c5542d$export$e7094788287c5e9b = $e2a48059f7c5542d$var$EmotionCacheContext.Provider;
var $e2a48059f7c5542d$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8nGP5.useContext)($e2a48059f7c5542d$var$EmotionCacheContext);
};
var $e2a48059f7c5542d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8nGP5.useContext)($e2a48059f7c5542d$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$e2a48059f7c5542d$export$23f2a1d2818174ef) $e2a48059f7c5542d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8nGP5.useContext)($e2a48059f7c5542d$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $6tfZw.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $8nGP5.createElement($e2a48059f7c5542d$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $e2a48059f7c5542d$export$971d5caa766a69d7 = /* #__PURE__ */ $8nGP5.createContext({});
var $e2a48059f7c5542d$export$3b14a55fb2447963 = function useTheme() {
    return $8nGP5.useContext($e2a48059f7c5542d$export$971d5caa766a69d7);
};
var $e2a48059f7c5542d$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $1TGTA.default)({}, outerTheme, theme);
};
var $e2a48059f7c5542d$var$createCacheWithTheme = /* #__PURE__ */ (0, $eIxVf.default)(function(outerTheme) {
    return (0, $eIxVf.default)(function(theme) {
        return $e2a48059f7c5542d$var$getTheme(outerTheme, theme);
    });
});
var $e2a48059f7c5542d$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $8nGP5.useContext($e2a48059f7c5542d$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $e2a48059f7c5542d$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8nGP5.createElement($e2a48059f7c5542d$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $e2a48059f7c5542d$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $8nGP5.useContext($e2a48059f7c5542d$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8nGP5.createElement(Component, (0, $1TGTA.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $8nGP5.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $glGaj.default)(WithTheme, Component);
}
var $e2a48059f7c5542d$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $e2a48059f7c5542d$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $e2a48059f7c5542d$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $e2a48059f7c5542d$var$getLastPart(match[1]);
    return undefined;
};
var $e2a48059f7c5542d$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $e2a48059f7c5542d$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $e2a48059f7c5542d$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $e2a48059f7c5542d$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($e2a48059f7c5542d$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $e2a48059f7c5542d$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $e2a48059f7c5542d$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $e2a48059f7c5542d$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $e2a48059f7c5542d$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($e2a48059f7c5542d$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$e2a48059f7c5542d$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $e2a48059f7c5542d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7x006.registerStyles)(cache, serialized, isStringTag);
    (0, $dgnOT.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7x006.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $e2a48059f7c5542d$var$Emotion = /* #__PURE__ */ $e2a48059f7c5542d$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$e2a48059f7c5542d$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $7x006.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $iBxqj.serializeStyles)(registeredStyles, undefined, $8nGP5.useContext($e2a48059f7c5542d$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($e2a48059f7c5542d$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $e2a48059f7c5542d$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement($e2a48059f7c5542d$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8nGP5.createElement(WrappedComponent, newProps));
});
var $e2a48059f7c5542d$export$a9c23c6ac3fc3eca = $e2a48059f7c5542d$var$Emotion;

});
parcelRegister("6tfZw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b61db10e92cce84$export$2e2bcd8739ae039; });

var $77sbF = parcelRequire("77sbF");

var $jtx5G = parcelRequire("jtx5G");

var $gbY0o = parcelRequire("gbY0o");

var $u6I0t = parcelRequire("u6I0t");
var $4b61db10e92cce84$var$isBrowser = typeof document !== 'undefined';
var $4b61db10e92cce84$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $jtx5G.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $jtx5G.token)(character)) break;
        (0, $jtx5G.next)();
    }
    return (0, $jtx5G.slice)(begin, (0, $jtx5G.position));
};
var $4b61db10e92cce84$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $jtx5G.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $jtx5G.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $4b61db10e92cce84$var$identifierWithPointTracking((0, $jtx5G.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $jtx5G.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $jtx5G.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $jtx5G.from)(character);
    }
    while (character = (0, $jtx5G.next)());
    return parsed;
};
var $4b61db10e92cce84$var$getRules = function getRules(value, points) {
    return (0, $jtx5G.dealloc)($4b61db10e92cce84$var$toRules((0, $jtx5G.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $4b61db10e92cce84$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $4b61db10e92cce84$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$4b61db10e92cce84$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $4b61db10e92cce84$var$fixedElements.set(element, true);
    var points = [];
    var rules = $4b61db10e92cce84$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $4b61db10e92cce84$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $4b61db10e92cce84$var$prefix(value, length) {
    switch((0, $jtx5G.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $jtx5G.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $jtx5G.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MOZ) + value + (0, $jtx5G.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + value + value;
        // order
        case 6165:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.replace)(value, /(\w+).+(:[^]+)/, (0, $jtx5G.WEBKIT) + 'box-$1$2' + (0, $jtx5G.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + 'flex-item-' + (0, $jtx5G.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + 'flex-line-pack' + (0, $jtx5G.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $jtx5G.WEBKIT) + 'box-' + (0, $jtx5G.replace)(value, '-grow', '') + (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $jtx5G.WEBKIT) + (0, $jtx5G.replace)(value, /([^-])(transform)/g, '$1' + (0, $jtx5G.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $jtx5G.replace)((0, $jtx5G.replace)((0, $jtx5G.replace)(value, /(zoom-|grab)/, (0, $jtx5G.WEBKIT) + '$1'), /(image-set)/, (0, $jtx5G.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jtx5G.replace)(value, /(image-set\([^]*)/, (0, $jtx5G.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $jtx5G.replace)((0, $jtx5G.replace)(value, /(.+:)(flex-)?(.*)/, (0, $jtx5G.WEBKIT) + 'box-pack:$3' + (0, $jtx5G.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $jtx5G.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jtx5G.replace)(value, /(.+)-inline(.+)/, (0, $jtx5G.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jtx5G.strlen)(value) - 1 - length > 6) switch((0, $jtx5G.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jtx5G.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jtx5G.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $jtx5G.WEBKIT) + '$2-$3' + '$1' + (0, $jtx5G.MOZ) + ((0, $jtx5G.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jtx5G.indexof)(value, 'stretch') ? $4b61db10e92cce84$var$prefix((0, $jtx5G.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $jtx5G.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $jtx5G.charat)(value, (0, $jtx5G.strlen)(value) - 3 - (~(0, $jtx5G.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $jtx5G.replace)(value, ':', ':' + (0, $jtx5G.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $jtx5G.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $jtx5G.WEBKIT) + ((0, $jtx5G.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $jtx5G.WEBKIT) + '$2$3' + '$1' + (0, $jtx5G.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $jtx5G.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + value + value;
    }
    return value;
}
var $4b61db10e92cce84$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $jtx5G.DECLARATION:
                element["return"] = $4b61db10e92cce84$var$prefix(element.value, element.length);
                break;
            case 0, $jtx5G.KEYFRAMES:
                return (0, $jtx5G.serialize)([
                    (0, $jtx5G.copy)(element, {
                        value: (0, $jtx5G.replace)(element.value, '@', '@' + (0, $jtx5G.WEBKIT))
                    })
                ], callback);
            case 0, $jtx5G.RULESET:
                if (element.length) return (0, $jtx5G.combine)(element.props, function(value) {
                    switch((0, $jtx5G.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $jtx5G.serialize)([
                                (0, $jtx5G.copy)(element, {
                                    props: [
                                        (0, $jtx5G.replace)(value, /:(read-\w+)/, ':' + (0, $jtx5G.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $jtx5G.serialize)([
                                (0, $jtx5G.copy)(element, {
                                    props: [
                                        (0, $jtx5G.replace)(value, /:(plac\w+)/, ':' + (0, $jtx5G.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $jtx5G.copy)(element, {
                                    props: [
                                        (0, $jtx5G.replace)(value, /:(plac\w+)/, ':' + (0, $jtx5G.MOZ) + '$1')
                                    ]
                                }),
                                (0, $jtx5G.copy)(element, {
                                    props: [
                                        (0, $jtx5G.replace)(value, /:(plac\w+)/, (0, $jtx5G.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $4b61db10e92cce84$var$getServerStylisCache = $4b61db10e92cce84$var$isBrowser ? undefined : (0, $gbY0o.default)(function() {
    return (0, $u6I0t.default)(function() {
        return {};
    });
});
var $4b61db10e92cce84$var$defaultStylisPlugins = [
    $4b61db10e92cce84$var$prefixer
];
var $4b61db10e92cce84$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($4b61db10e92cce84$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $4b61db10e92cce84$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($4b61db10e92cce84$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $4b61db10e92cce84$var$compat,
        $4b61db10e92cce84$var$removeLabel
    ];
    if (!$4b61db10e92cce84$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $jtx5G.stringify),
            (0, $jtx5G.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $jtx5G.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $jtx5G.serialize)((0, $jtx5G.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $jtx5G.stringify)
        ];
        var _serializer = (0, $jtx5G.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $jtx5G.serialize)((0, $jtx5G.compile)(styles), _serializer);
        };
        var serverStylisCache = $4b61db10e92cce84$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $77sbF.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("77sbF", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $52ef0d398243f671$export$9d753cd7ae895cce; });
var $52ef0d398243f671$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $52ef0d398243f671$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $52ef0d398243f671$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $52ef0d398243f671$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$52ef0d398243f671$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($52ef0d398243f671$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $52ef0d398243f671$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("jtx5G", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $eea1162845e87fb8$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $eea1162845e87fb8$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $eea1162845e87fb8$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $eea1162845e87fb8$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $eea1162845e87fb8$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $eea1162845e87fb8$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $eea1162845e87fb8$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $eea1162845e87fb8$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $eea1162845e87fb8$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $eea1162845e87fb8$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $eea1162845e87fb8$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $eea1162845e87fb8$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $eea1162845e87fb8$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $eea1162845e87fb8$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $eea1162845e87fb8$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $eea1162845e87fb8$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $eea1162845e87fb8$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $eea1162845e87fb8$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $eea1162845e87fb8$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $eea1162845e87fb8$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $eea1162845e87fb8$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $eea1162845e87fb8$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $eea1162845e87fb8$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $eea1162845e87fb8$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $eea1162845e87fb8$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $eea1162845e87fb8$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $eea1162845e87fb8$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $eea1162845e87fb8$export$38bcb760f1d4871c; });
var $eea1162845e87fb8$export$71ad59f2e432cfe8 = "-ms-";
var $eea1162845e87fb8$export$2c0f367103c8d01c = "-moz-";
var $eea1162845e87fb8$export$39dfd62a25e0fe93 = "-webkit-";
var $eea1162845e87fb8$export$a29989082612d0d9 = "comm";
var $eea1162845e87fb8$export$aa3a2e812ca8570d = "rule";
var $eea1162845e87fb8$export$527d108ccf083c2b = "decl";
var $eea1162845e87fb8$export$d3d35020fa5b54f0 = "@page";
var $eea1162845e87fb8$export$500415a86c544f73 = "@media";
var $eea1162845e87fb8$export$a763edbf796b780a = "@import";
var $eea1162845e87fb8$export$2790aeb8b4e5c826 = "@charset";
var $eea1162845e87fb8$export$1cc683e23b84b133 = "@viewport";
var $eea1162845e87fb8$export$9447a5efea57e862 = "@supports";
var $eea1162845e87fb8$export$ef011b4e114b1fba = "@document";
var $eea1162845e87fb8$export$6aad947bda0f3f46 = "@namespace";
var $eea1162845e87fb8$export$b44a8529a35fcb60 = "@keyframes";
var $eea1162845e87fb8$export$2c16de31893252e6 = "@font-face";
var $eea1162845e87fb8$export$3d846dd52e150c6f = "@counter-style";
var $eea1162845e87fb8$export$22314bfbb57653fe = "@font-feature-values";
var $eea1162845e87fb8$export$d773506282b3cfe6 = "@layer";
var $eea1162845e87fb8$export$2335f513bbd82c6d = Math.abs;
var $eea1162845e87fb8$export$6788812c4e6611e6 = String.fromCharCode;
var $eea1162845e87fb8$export$e6e34fd1f2686227 = Object.assign;
function $eea1162845e87fb8$export$d6af199866bfb566(e, r) {
    return $eea1162845e87fb8$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $eea1162845e87fb8$export$a9db5e087081082d(e, 0)) << 2 ^ $eea1162845e87fb8$export$a9db5e087081082d(e, 1)) << 2 ^ $eea1162845e87fb8$export$a9db5e087081082d(e, 2)) << 2 ^ $eea1162845e87fb8$export$a9db5e087081082d(e, 3) : 0;
}
function $eea1162845e87fb8$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $eea1162845e87fb8$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $eea1162845e87fb8$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $eea1162845e87fb8$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $eea1162845e87fb8$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $eea1162845e87fb8$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $eea1162845e87fb8$export$36776f635604f274(e) {
    return e.length;
}
function $eea1162845e87fb8$export$f9084667e487ed46(e) {
    return e.length;
}
function $eea1162845e87fb8$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $eea1162845e87fb8$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $eea1162845e87fb8$export$53f1d5ea8de3d7c = 1;
var $eea1162845e87fb8$export$4e0c71f277ca26b3 = 1;
var $eea1162845e87fb8$export$f24224f1c91d8156 = 0;
var $eea1162845e87fb8$export$5880b8b5730aff45 = 0;
var $eea1162845e87fb8$export$c0306caf338ac095 = 0;
var $eea1162845e87fb8$export$30a86d91af8ff6e6 = "";
function $eea1162845e87fb8$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $eea1162845e87fb8$export$53f1d5ea8de3d7c,
        column: $eea1162845e87fb8$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $eea1162845e87fb8$export$784d13d8ee351f07(e, r) {
    return $eea1162845e87fb8$export$e6e34fd1f2686227($eea1162845e87fb8$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $eea1162845e87fb8$export$eba6f6f03b0a92e7() {
    return $eea1162845e87fb8$export$c0306caf338ac095;
}
function $eea1162845e87fb8$export$232faf9add678146() {
    $eea1162845e87fb8$export$c0306caf338ac095 = $eea1162845e87fb8$export$5880b8b5730aff45 > 0 ? $eea1162845e87fb8$export$a9db5e087081082d($eea1162845e87fb8$export$30a86d91af8ff6e6, --$eea1162845e87fb8$export$5880b8b5730aff45) : 0;
    if ($eea1162845e87fb8$export$4e0c71f277ca26b3--, $eea1162845e87fb8$export$c0306caf338ac095 === 10) $eea1162845e87fb8$export$4e0c71f277ca26b3 = 1, $eea1162845e87fb8$export$53f1d5ea8de3d7c--;
    return $eea1162845e87fb8$export$c0306caf338ac095;
}
function $eea1162845e87fb8$export$48cfd1e771a65c4f() {
    $eea1162845e87fb8$export$c0306caf338ac095 = $eea1162845e87fb8$export$5880b8b5730aff45 < $eea1162845e87fb8$export$f24224f1c91d8156 ? $eea1162845e87fb8$export$a9db5e087081082d($eea1162845e87fb8$export$30a86d91af8ff6e6, $eea1162845e87fb8$export$5880b8b5730aff45++) : 0;
    if ($eea1162845e87fb8$export$4e0c71f277ca26b3++, $eea1162845e87fb8$export$c0306caf338ac095 === 10) $eea1162845e87fb8$export$4e0c71f277ca26b3 = 1, $eea1162845e87fb8$export$53f1d5ea8de3d7c++;
    return $eea1162845e87fb8$export$c0306caf338ac095;
}
function $eea1162845e87fb8$export$4d3fb11e950abb9e() {
    return $eea1162845e87fb8$export$a9db5e087081082d($eea1162845e87fb8$export$30a86d91af8ff6e6, $eea1162845e87fb8$export$5880b8b5730aff45);
}
function $eea1162845e87fb8$export$e88cb2efb12ae807() {
    return $eea1162845e87fb8$export$5880b8b5730aff45;
}
function $eea1162845e87fb8$export$58adb3bec8346d0f(e, r) {
    return $eea1162845e87fb8$export$2f35ab04d2335697($eea1162845e87fb8$export$30a86d91af8ff6e6, e, r);
}
function $eea1162845e87fb8$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $eea1162845e87fb8$export$2de70f21292aac9e(e) {
    return $eea1162845e87fb8$export$53f1d5ea8de3d7c = $eea1162845e87fb8$export$4e0c71f277ca26b3 = 1, $eea1162845e87fb8$export$f24224f1c91d8156 = $eea1162845e87fb8$export$36776f635604f274($eea1162845e87fb8$export$30a86d91af8ff6e6 = e), $eea1162845e87fb8$export$5880b8b5730aff45 = 0, [];
}
function $eea1162845e87fb8$export$45918ac1574455b1(e) {
    return $eea1162845e87fb8$export$30a86d91af8ff6e6 = "", e;
}
function $eea1162845e87fb8$export$410ac95b9ec204b8(e) {
    return $eea1162845e87fb8$export$87c2784dc9fc4ab($eea1162845e87fb8$export$58adb3bec8346d0f($eea1162845e87fb8$export$5880b8b5730aff45 - 1, $eea1162845e87fb8$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $eea1162845e87fb8$export$660b2ee2d4fb4eff(e) {
    return $eea1162845e87fb8$export$45918ac1574455b1($eea1162845e87fb8$export$5f8c09e3ae6f64e1($eea1162845e87fb8$export$2de70f21292aac9e(e)));
}
function $eea1162845e87fb8$export$7af1228ff777d175(e) {
    while($eea1162845e87fb8$export$c0306caf338ac095 = $eea1162845e87fb8$export$4d3fb11e950abb9e())if ($eea1162845e87fb8$export$c0306caf338ac095 < 33) $eea1162845e87fb8$export$48cfd1e771a65c4f();
    else break;
    return $eea1162845e87fb8$export$9e1725a4cfeada27(e) > 2 || $eea1162845e87fb8$export$9e1725a4cfeada27($eea1162845e87fb8$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $eea1162845e87fb8$export$5f8c09e3ae6f64e1(e) {
    while($eea1162845e87fb8$export$48cfd1e771a65c4f())switch($eea1162845e87fb8$export$9e1725a4cfeada27($eea1162845e87fb8$export$c0306caf338ac095)){
        case 0:
            $eea1162845e87fb8$export$10d8903dec122b9d($eea1162845e87fb8$export$c2ab62c7bf24634($eea1162845e87fb8$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $eea1162845e87fb8$export$10d8903dec122b9d($eea1162845e87fb8$export$410ac95b9ec204b8($eea1162845e87fb8$export$c0306caf338ac095), e);
            break;
        default:
            $eea1162845e87fb8$export$10d8903dec122b9d($eea1162845e87fb8$export$6788812c4e6611e6($eea1162845e87fb8$export$c0306caf338ac095), e);
    }
    return e;
}
function $eea1162845e87fb8$export$955ba06d119e085e(e, r) {
    while(--r && $eea1162845e87fb8$export$48cfd1e771a65c4f())if ($eea1162845e87fb8$export$c0306caf338ac095 < 48 || $eea1162845e87fb8$export$c0306caf338ac095 > 102 || $eea1162845e87fb8$export$c0306caf338ac095 > 57 && $eea1162845e87fb8$export$c0306caf338ac095 < 65 || $eea1162845e87fb8$export$c0306caf338ac095 > 70 && $eea1162845e87fb8$export$c0306caf338ac095 < 97) break;
    return $eea1162845e87fb8$export$58adb3bec8346d0f(e, $eea1162845e87fb8$export$e88cb2efb12ae807() + (r < 6 && $eea1162845e87fb8$export$4d3fb11e950abb9e() == 32 && $eea1162845e87fb8$export$48cfd1e771a65c4f() == 32));
}
function $eea1162845e87fb8$export$c889f2fcc19dbf12(e) {
    while($eea1162845e87fb8$export$48cfd1e771a65c4f())switch($eea1162845e87fb8$export$c0306caf338ac095){
        case e:
            return $eea1162845e87fb8$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $eea1162845e87fb8$export$c889f2fcc19dbf12($eea1162845e87fb8$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $eea1162845e87fb8$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $eea1162845e87fb8$export$48cfd1e771a65c4f();
            break;
    }
    return $eea1162845e87fb8$export$5880b8b5730aff45;
}
function $eea1162845e87fb8$export$4254d4e2b3745c4c(e, r) {
    while($eea1162845e87fb8$export$48cfd1e771a65c4f())if (e + $eea1162845e87fb8$export$c0306caf338ac095 === 57) break;
    else if (e + $eea1162845e87fb8$export$c0306caf338ac095 === 84 && $eea1162845e87fb8$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $eea1162845e87fb8$export$58adb3bec8346d0f(r, $eea1162845e87fb8$export$5880b8b5730aff45 - 1) + "*" + $eea1162845e87fb8$export$6788812c4e6611e6(e === 47 ? e : $eea1162845e87fb8$export$48cfd1e771a65c4f());
}
function $eea1162845e87fb8$export$c2ab62c7bf24634(e) {
    while(!$eea1162845e87fb8$export$9e1725a4cfeada27($eea1162845e87fb8$export$4d3fb11e950abb9e()))$eea1162845e87fb8$export$48cfd1e771a65c4f();
    return $eea1162845e87fb8$export$58adb3bec8346d0f(e, $eea1162845e87fb8$export$5880b8b5730aff45);
}
function $eea1162845e87fb8$export$ef7acd7185315e22(e) {
    return $eea1162845e87fb8$export$45918ac1574455b1($eea1162845e87fb8$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $eea1162845e87fb8$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $eea1162845e87fb8$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $eea1162845e87fb8$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $eea1162845e87fb8$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($eea1162845e87fb8$export$f8e21b1e77979a08(j += $eea1162845e87fb8$export$77ad94ebf1c2b9ed($eea1162845e87fb8$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $eea1162845e87fb8$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $eea1162845e87fb8$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $eea1162845e87fb8$export$955ba06d119e085e($eea1162845e87fb8$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($eea1162845e87fb8$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $eea1162845e87fb8$export$10d8903dec122b9d($eea1162845e87fb8$export$4a34f930e789283c($eea1162845e87fb8$export$4254d4e2b3745c4c($eea1162845e87fb8$export$48cfd1e771a65c4f(), $eea1162845e87fb8$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $eea1162845e87fb8$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $eea1162845e87fb8$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $eea1162845e87fb8$export$36776f635604f274(j) - l) $eea1162845e87fb8$export$10d8903dec122b9d(p > 32 ? $eea1162845e87fb8$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $eea1162845e87fb8$export$f8483753829ec8f3($eea1162845e87fb8$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $eea1162845e87fb8$export$10d8903dec122b9d(y = $eea1162845e87fb8$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $eea1162845e87fb8$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $eea1162845e87fb8$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $eea1162845e87fb8$export$98e6a39c04603d36(e, y, y, n && $eea1162845e87fb8$export$10d8903dec122b9d($eea1162845e87fb8$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $eea1162845e87fb8$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $eea1162845e87fb8$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $eea1162845e87fb8$export$232faf9add678146() == 125) continue;
            }
            switch(j += $eea1162845e87fb8$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($eea1162845e87fb8$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($eea1162845e87fb8$export$4d3fb11e950abb9e() === 45) j += $eea1162845e87fb8$export$410ac95b9ec204b8($eea1162845e87fb8$export$48cfd1e771a65c4f());
                    v = $eea1162845e87fb8$export$4d3fb11e950abb9e(), o = l = $eea1162845e87fb8$export$36776f635604f274(g = j += $eea1162845e87fb8$export$c2ab62c7bf24634($eea1162845e87fb8$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $eea1162845e87fb8$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $eea1162845e87fb8$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $eea1162845e87fb8$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $eea1162845e87fb8$export$2f35ab04d2335697(e, v + 1, v = $eea1162845e87fb8$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $eea1162845e87fb8$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $eea1162845e87fb8$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $eea1162845e87fb8$export$35059013cd4a06db(e, r, a, s === 0 ? $eea1162845e87fb8$export$aa3a2e812ca8570d : i, f, o, l);
}
function $eea1162845e87fb8$export$4a34f930e789283c(e, r, a) {
    return $eea1162845e87fb8$export$35059013cd4a06db(e, r, a, $eea1162845e87fb8$export$a29989082612d0d9, $eea1162845e87fb8$export$6788812c4e6611e6($eea1162845e87fb8$export$eba6f6f03b0a92e7()), $eea1162845e87fb8$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $eea1162845e87fb8$export$f8483753829ec8f3(e, r, a, n) {
    return $eea1162845e87fb8$export$35059013cd4a06db(e, r, a, $eea1162845e87fb8$export$527d108ccf083c2b, $eea1162845e87fb8$export$2f35ab04d2335697(e, 0, n), $eea1162845e87fb8$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $eea1162845e87fb8$export$82e9f45cca5ba907(n, c, s) {
    switch($eea1162845e87fb8$export$d6af199866bfb566(n, c)){
        case 5103:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $eea1162845e87fb8$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$2c0f367103c8d01c + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($eea1162845e87fb8$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "box-$1$2" + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "flex-item-" + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$eea1162845e87fb8$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $eea1162845e87fb8$export$71ad59f2e432cfe8 + "grid-row-" + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "flex-line-pack" + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + "box-" + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "-grow", "") + $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed($eea1162845e87fb8$export$77ad94ebf1c2b9ed($eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed($eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "box-pack:$3" + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$eea1162845e87fb8$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $eea1162845e87fb8$export$71ad59f2e432cfe8 + "grid-column-align" + $eea1162845e87fb8$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $eea1162845e87fb8$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$eea1162845e87fb8$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$eea1162845e87fb8$export$f8e21b1e77979a08(s, "span") ? $eea1162845e87fb8$export$4659b591c19bdf3d(s, /\d+/) : +$eea1162845e87fb8$export$4659b591c19bdf3d(s, /\d+/) - +$eea1162845e87fb8$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $eea1162845e87fb8$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed($eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($eea1162845e87fb8$export$36776f635604f274(n) - 1 - c > 6) switch($eea1162845e87fb8$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($eea1162845e87fb8$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $eea1162845e87fb8$export$2c0f367103c8d01c + ($eea1162845e87fb8$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$eea1162845e87fb8$export$f8e21b1e77979a08(n, "stretch") ? $eea1162845e87fb8$export$82e9f45cca5ba907($eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $eea1162845e87fb8$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $eea1162845e87fb8$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($eea1162845e87fb8$export$a9db5e087081082d(n, c + 6) === 121) return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, ":", ":" + $eea1162845e87fb8$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($eea1162845e87fb8$export$a9db5e087081082d(n, $eea1162845e87fb8$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $eea1162845e87fb8$export$39dfd62a25e0fe93 + ($eea1162845e87fb8$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, ":", ":" + $eea1162845e87fb8$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $eea1162845e87fb8$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $eea1162845e87fb8$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $eea1162845e87fb8$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $eea1162845e87fb8$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $eea1162845e87fb8$export$a763edbf796b780a:
        case $eea1162845e87fb8$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $eea1162845e87fb8$export$a29989082612d0d9:
            return "";
        case $eea1162845e87fb8$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $eea1162845e87fb8$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $eea1162845e87fb8$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $eea1162845e87fb8$export$36776f635604f274(a = $eea1162845e87fb8$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $eea1162845e87fb8$export$5a7767152ae0305f(e) {
    var r = $eea1162845e87fb8$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $eea1162845e87fb8$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $eea1162845e87fb8$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $eea1162845e87fb8$export$527d108ccf083c2b:
                n.return = $eea1162845e87fb8$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $eea1162845e87fb8$export$b44a8529a35fcb60:
                return $eea1162845e87fb8$export$dfdc1655ccc5b9cb([
                    $eea1162845e87fb8$export$784d13d8ee351f07(n, {
                        value: $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $eea1162845e87fb8$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $eea1162845e87fb8$export$aa3a2e812ca8570d:
                if (n.length) return $eea1162845e87fb8$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($eea1162845e87fb8$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $eea1162845e87fb8$export$dfdc1655ccc5b9cb([
                                $eea1162845e87fb8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $eea1162845e87fb8$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $eea1162845e87fb8$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $eea1162845e87fb8$export$dfdc1655ccc5b9cb([
                                $eea1162845e87fb8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $eea1162845e87fb8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $eea1162845e87fb8$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $eea1162845e87fb8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $eea1162845e87fb8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $eea1162845e87fb8$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $eea1162845e87fb8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $eea1162845e87fb8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $eea1162845e87fb8$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $eea1162845e87fb8$export$76a88f7de6507443(e) {
    switch(e.type){
        case $eea1162845e87fb8$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $eea1162845e87fb8$export$1be1fc439b849fdf($eea1162845e87fb8$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($eea1162845e87fb8$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $eea1162845e87fb8$export$2f35ab04d2335697(r, 1, $eea1162845e87fb8$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $eea1162845e87fb8$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $eea1162845e87fb8$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $eea1162845e87fb8$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("gbY0o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc9c38393dd6748a$export$2e2bcd8739ae039; });
var $bc9c38393dd6748a$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("1TGTA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $161c33aa9edc3225$export$2e2bcd8739ae039; });
function $161c33aa9edc3225$export$2e2bcd8739ae039() {
    return $161c33aa9edc3225$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $161c33aa9edc3225$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("eIxVf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab6f7d074592e389$export$2e2bcd8739ae039; });
var $ab6f7d074592e389$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("glGaj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be6f50a8bcbd3d42$export$2e2bcd8739ae039; });

var $cSUBB = parcelRequire("cSUBB");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $be6f50a8bcbd3d42$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cSUBB)))(targetComponent, sourceComponent);
};

});
parcelRegister("cSUBB", function(module, exports) {
'use strict';

var $8xxle = parcelRequire("8xxle");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $96166fd72a1567f8$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $96166fd72a1567f8$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $96166fd72a1567f8$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $96166fd72a1567f8$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $96166fd72a1567f8$var$TYPE_STATICS = {};
$96166fd72a1567f8$var$TYPE_STATICS[$8xxle.ForwardRef] = $96166fd72a1567f8$var$FORWARD_REF_STATICS;
$96166fd72a1567f8$var$TYPE_STATICS[$8xxle.Memo] = $96166fd72a1567f8$var$MEMO_STATICS;
function $96166fd72a1567f8$var$getStatics(component) {
    // React v16.11 and below
    if ($8xxle.isMemo(component)) return $96166fd72a1567f8$var$MEMO_STATICS;
     // React v16.12 and above
    return $96166fd72a1567f8$var$TYPE_STATICS[component['$$typeof']] || $96166fd72a1567f8$var$REACT_STATICS;
}
var $96166fd72a1567f8$var$defineProperty = Object.defineProperty;
var $96166fd72a1567f8$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $96166fd72a1567f8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $96166fd72a1567f8$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $96166fd72a1567f8$var$getPrototypeOf = Object.getPrototypeOf;
var $96166fd72a1567f8$var$objectPrototype = Object.prototype;
function $96166fd72a1567f8$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($96166fd72a1567f8$var$objectPrototype) {
            var inheritedComponent = $96166fd72a1567f8$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $96166fd72a1567f8$var$objectPrototype) $96166fd72a1567f8$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $96166fd72a1567f8$var$getOwnPropertyNames(sourceComponent);
        if ($96166fd72a1567f8$var$getOwnPropertySymbols) keys = keys.concat($96166fd72a1567f8$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $96166fd72a1567f8$var$getStatics(targetComponent);
        var sourceStatics = $96166fd72a1567f8$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$96166fd72a1567f8$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $96166fd72a1567f8$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $96166fd72a1567f8$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $96166fd72a1567f8$var$hoistNonReactStatics;

});
parcelRegister("8xxle", function(module, exports) {
'use strict';

module.exports = (parcelRequire("36bfA"));

});
parcelRegister("36bfA", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $241aa8c06e4e7e71$export$2b8d127b894957b9; }, function (v) { return $241aa8c06e4e7e71$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $241aa8c06e4e7e71$export$cea3a54a6425200c; }, function (v) { return $241aa8c06e4e7e71$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $241aa8c06e4e7e71$export$a7c73072b1a182ae; }, function (v) { return $241aa8c06e4e7e71$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $241aa8c06e4e7e71$export$9f27bc3417b4524d; }, function (v) { return $241aa8c06e4e7e71$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $241aa8c06e4e7e71$export$db77ccec0bb4ccac; }, function (v) { return $241aa8c06e4e7e71$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $241aa8c06e4e7e71$export$8392c0c9d3dcbd35; }, function (v) { return $241aa8c06e4e7e71$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $241aa8c06e4e7e71$export$ffb0004e005737fa; }, function (v) { return $241aa8c06e4e7e71$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $241aa8c06e4e7e71$export$b624eff549462981; }, function (v) { return $241aa8c06e4e7e71$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $241aa8c06e4e7e71$export$7897aa7841a5380c; }, function (v) { return $241aa8c06e4e7e71$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $241aa8c06e4e7e71$export$602eac185826482c; }, function (v) { return $241aa8c06e4e7e71$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $241aa8c06e4e7e71$export$e2c29f18771995cb; }, function (v) { return $241aa8c06e4e7e71$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $241aa8c06e4e7e71$export$5f8d39834fd61797; }, function (v) { return $241aa8c06e4e7e71$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $241aa8c06e4e7e71$export$74bf444e3cd11ea5; }, function (v) { return $241aa8c06e4e7e71$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $241aa8c06e4e7e71$export$92387174baf9b227; }, function (v) { return $241aa8c06e4e7e71$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $241aa8c06e4e7e71$export$ec112efeb987d9c6; }, function (v) { return $241aa8c06e4e7e71$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $241aa8c06e4e7e71$export$b706b080d889d2c9; }, function (v) { return $241aa8c06e4e7e71$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $241aa8c06e4e7e71$export$5be5a87408f70ddc; }, function (v) { return $241aa8c06e4e7e71$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $241aa8c06e4e7e71$export$45a5e7f76e0caa8d; }, function (v) { return $241aa8c06e4e7e71$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $241aa8c06e4e7e71$export$455c2e768291efa6; }, function (v) { return $241aa8c06e4e7e71$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $241aa8c06e4e7e71$export$9522e17588c12572; }, function (v) { return $241aa8c06e4e7e71$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $241aa8c06e4e7e71$export$2110ac352bb060b9; }, function (v) { return $241aa8c06e4e7e71$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $241aa8c06e4e7e71$export$56885ab8b9c456ab; }, function (v) { return $241aa8c06e4e7e71$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $241aa8c06e4e7e71$export$d927fcb6adf8f9de; }, function (v) { return $241aa8c06e4e7e71$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $241aa8c06e4e7e71$export$b82d16f27459e05a; }, function (v) { return $241aa8c06e4e7e71$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $241aa8c06e4e7e71$export$522c17b4f5e123e8; }, function (v) { return $241aa8c06e4e7e71$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $241aa8c06e4e7e71$export$1aabd8a0274ecfd6; }, function (v) { return $241aa8c06e4e7e71$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $241aa8c06e4e7e71$export$9b621391a187a31a; }, function (v) { return $241aa8c06e4e7e71$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $241aa8c06e4e7e71$export$f5bbd400c2f4426f; }, function (v) { return $241aa8c06e4e7e71$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $241aa8c06e4e7e71$export$2b8d127b894957b9;
var $241aa8c06e4e7e71$export$cea3a54a6425200c;
var $241aa8c06e4e7e71$export$a7c73072b1a182ae;
var $241aa8c06e4e7e71$export$9f27bc3417b4524d;
var $241aa8c06e4e7e71$export$db77ccec0bb4ccac;
var $241aa8c06e4e7e71$export$8392c0c9d3dcbd35;
var $241aa8c06e4e7e71$export$ffb0004e005737fa;
var $241aa8c06e4e7e71$export$b624eff549462981;
var $241aa8c06e4e7e71$export$7897aa7841a5380c;
var $241aa8c06e4e7e71$export$602eac185826482c;
var $241aa8c06e4e7e71$export$e2c29f18771995cb;
var $241aa8c06e4e7e71$export$5f8d39834fd61797;
var $241aa8c06e4e7e71$export$74bf444e3cd11ea5;
var $241aa8c06e4e7e71$export$92387174baf9b227;
var $241aa8c06e4e7e71$export$ec112efeb987d9c6;
var $241aa8c06e4e7e71$export$b706b080d889d2c9;
var $241aa8c06e4e7e71$export$5be5a87408f70ddc;
var $241aa8c06e4e7e71$export$45a5e7f76e0caa8d;
var $241aa8c06e4e7e71$export$455c2e768291efa6;
var $241aa8c06e4e7e71$export$9522e17588c12572;
var $241aa8c06e4e7e71$export$2110ac352bb060b9;
var $241aa8c06e4e7e71$export$56885ab8b9c456ab;
var $241aa8c06e4e7e71$export$d927fcb6adf8f9de;
var $241aa8c06e4e7e71$export$b82d16f27459e05a;
var $241aa8c06e4e7e71$export$522c17b4f5e123e8;
var $241aa8c06e4e7e71$export$1aabd8a0274ecfd6;
var $241aa8c06e4e7e71$export$9b621391a187a31a;
var $241aa8c06e4e7e71$export$f5bbd400c2f4426f;
'use strict';
var $241aa8c06e4e7e71$var$b = "function" === typeof Symbol && Symbol.for, $241aa8c06e4e7e71$var$c = $241aa8c06e4e7e71$var$b ? Symbol.for("react.element") : 60103, $241aa8c06e4e7e71$var$d = $241aa8c06e4e7e71$var$b ? Symbol.for("react.portal") : 60106, $241aa8c06e4e7e71$var$e = $241aa8c06e4e7e71$var$b ? Symbol.for("react.fragment") : 60107, $241aa8c06e4e7e71$var$f = $241aa8c06e4e7e71$var$b ? Symbol.for("react.strict_mode") : 60108, $241aa8c06e4e7e71$var$g = $241aa8c06e4e7e71$var$b ? Symbol.for("react.profiler") : 60114, $241aa8c06e4e7e71$var$h = $241aa8c06e4e7e71$var$b ? Symbol.for("react.provider") : 60109, $241aa8c06e4e7e71$var$k = $241aa8c06e4e7e71$var$b ? Symbol.for("react.context") : 60110, $241aa8c06e4e7e71$var$l = $241aa8c06e4e7e71$var$b ? Symbol.for("react.async_mode") : 60111, $241aa8c06e4e7e71$var$m = $241aa8c06e4e7e71$var$b ? Symbol.for("react.concurrent_mode") : 60111, $241aa8c06e4e7e71$var$n = $241aa8c06e4e7e71$var$b ? Symbol.for("react.forward_ref") : 60112, $241aa8c06e4e7e71$var$p = $241aa8c06e4e7e71$var$b ? Symbol.for("react.suspense") : 60113, $241aa8c06e4e7e71$var$q = $241aa8c06e4e7e71$var$b ? Symbol.for("react.suspense_list") : 60120, $241aa8c06e4e7e71$var$r = $241aa8c06e4e7e71$var$b ? Symbol.for("react.memo") : 60115, $241aa8c06e4e7e71$var$t = $241aa8c06e4e7e71$var$b ? Symbol.for("react.lazy") : 60116, $241aa8c06e4e7e71$var$v = $241aa8c06e4e7e71$var$b ? Symbol.for("react.block") : 60121, $241aa8c06e4e7e71$var$w = $241aa8c06e4e7e71$var$b ? Symbol.for("react.fundamental") : 60117, $241aa8c06e4e7e71$var$x = $241aa8c06e4e7e71$var$b ? Symbol.for("react.responder") : 60118, $241aa8c06e4e7e71$var$y = $241aa8c06e4e7e71$var$b ? Symbol.for("react.scope") : 60119;
function $241aa8c06e4e7e71$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $241aa8c06e4e7e71$var$c:
                switch(a = a.type, a){
                    case $241aa8c06e4e7e71$var$l:
                    case $241aa8c06e4e7e71$var$m:
                    case $241aa8c06e4e7e71$var$e:
                    case $241aa8c06e4e7e71$var$g:
                    case $241aa8c06e4e7e71$var$f:
                    case $241aa8c06e4e7e71$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $241aa8c06e4e7e71$var$k:
                            case $241aa8c06e4e7e71$var$n:
                            case $241aa8c06e4e7e71$var$t:
                            case $241aa8c06e4e7e71$var$r:
                            case $241aa8c06e4e7e71$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $241aa8c06e4e7e71$var$d:
                return u;
        }
    }
}
function $241aa8c06e4e7e71$var$A(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$m;
}
$241aa8c06e4e7e71$export$2b8d127b894957b9 = $241aa8c06e4e7e71$var$l;
$241aa8c06e4e7e71$export$cea3a54a6425200c = $241aa8c06e4e7e71$var$m;
$241aa8c06e4e7e71$export$a7c73072b1a182ae = $241aa8c06e4e7e71$var$k;
$241aa8c06e4e7e71$export$9f27bc3417b4524d = $241aa8c06e4e7e71$var$h;
$241aa8c06e4e7e71$export$db77ccec0bb4ccac = $241aa8c06e4e7e71$var$c;
$241aa8c06e4e7e71$export$8392c0c9d3dcbd35 = $241aa8c06e4e7e71$var$n;
$241aa8c06e4e7e71$export$ffb0004e005737fa = $241aa8c06e4e7e71$var$e;
$241aa8c06e4e7e71$export$b624eff549462981 = $241aa8c06e4e7e71$var$t;
$241aa8c06e4e7e71$export$7897aa7841a5380c = $241aa8c06e4e7e71$var$r;
$241aa8c06e4e7e71$export$602eac185826482c = $241aa8c06e4e7e71$var$d;
$241aa8c06e4e7e71$export$e2c29f18771995cb = $241aa8c06e4e7e71$var$g;
$241aa8c06e4e7e71$export$5f8d39834fd61797 = $241aa8c06e4e7e71$var$f;
$241aa8c06e4e7e71$export$74bf444e3cd11ea5 = $241aa8c06e4e7e71$var$p;
$241aa8c06e4e7e71$export$92387174baf9b227 = function(a) {
    return $241aa8c06e4e7e71$var$A(a) || $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$l;
};
$241aa8c06e4e7e71$export$ec112efeb987d9c6 = $241aa8c06e4e7e71$var$A;
$241aa8c06e4e7e71$export$b706b080d889d2c9 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$k;
};
$241aa8c06e4e7e71$export$5be5a87408f70ddc = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$h;
};
$241aa8c06e4e7e71$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $241aa8c06e4e7e71$var$c;
};
$241aa8c06e4e7e71$export$455c2e768291efa6 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$n;
};
$241aa8c06e4e7e71$export$9522e17588c12572 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$e;
};
$241aa8c06e4e7e71$export$2110ac352bb060b9 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$t;
};
$241aa8c06e4e7e71$export$56885ab8b9c456ab = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$r;
};
$241aa8c06e4e7e71$export$d927fcb6adf8f9de = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$d;
};
$241aa8c06e4e7e71$export$b82d16f27459e05a = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$g;
};
$241aa8c06e4e7e71$export$522c17b4f5e123e8 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$f;
};
$241aa8c06e4e7e71$export$1aabd8a0274ecfd6 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$p;
};
$241aa8c06e4e7e71$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $241aa8c06e4e7e71$var$e || a === $241aa8c06e4e7e71$var$m || a === $241aa8c06e4e7e71$var$g || a === $241aa8c06e4e7e71$var$f || a === $241aa8c06e4e7e71$var$p || a === $241aa8c06e4e7e71$var$q || "object" === typeof a && null !== a && (a.$$typeof === $241aa8c06e4e7e71$var$t || a.$$typeof === $241aa8c06e4e7e71$var$r || a.$$typeof === $241aa8c06e4e7e71$var$h || a.$$typeof === $241aa8c06e4e7e71$var$k || a.$$typeof === $241aa8c06e4e7e71$var$n || a.$$typeof === $241aa8c06e4e7e71$var$w || a.$$typeof === $241aa8c06e4e7e71$var$x || a.$$typeof === $241aa8c06e4e7e71$var$y || a.$$typeof === $241aa8c06e4e7e71$var$v);
};
$241aa8c06e4e7e71$export$f5bbd400c2f4426f = $241aa8c06e4e7e71$var$z;

});




parcelRegister("7x006", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $57bb9d9a345e3a49$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $57bb9d9a345e3a49$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $57bb9d9a345e3a49$export$6f077d94b33a01aa; });
var $57bb9d9a345e3a49$var$isBrowser = typeof document !== 'undefined';
function $57bb9d9a345e3a49$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $57bb9d9a345e3a49$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $57bb9d9a345e3a49$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $57bb9d9a345e3a49$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $57bb9d9a345e3a49$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$57bb9d9a345e3a49$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$57bb9d9a345e3a49$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("iBxqj", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $d8b59be3fd10785e$export$6321afa313b251b5; });

var $1av6J = parcelRequire("1av6J");

var $kZVpK = parcelRequire("kZVpK");

var $u6I0t = parcelRequire("u6I0t");
var $d8b59be3fd10785e$var$isDevelopment = false;
var $d8b59be3fd10785e$var$hyphenateRegex = /[A-Z]|^ms/g;
var $d8b59be3fd10785e$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $d8b59be3fd10785e$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $d8b59be3fd10785e$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $d8b59be3fd10785e$var$processStyleName = /* #__PURE__ */ (0, $u6I0t.default)(function(styleName) {
    return $d8b59be3fd10785e$var$isCustomProperty(styleName) ? styleName : styleName.replace($d8b59be3fd10785e$var$hyphenateRegex, '-$&').toLowerCase();
});
var $d8b59be3fd10785e$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($d8b59be3fd10785e$var$animationRegex, function(match, p1, p2) {
                $d8b59be3fd10785e$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $d8b59be3fd10785e$var$cursor
                };
                return p1;
            });
    }
    if ((0, $kZVpK.default)[key] !== 1 && !$d8b59be3fd10785e$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $d8b59be3fd10785e$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $d8b59be3fd10785e$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $d8b59be3fd10785e$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $d8b59be3fd10785e$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $d8b59be3fd10785e$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $d8b59be3fd10785e$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $d8b59be3fd10785e$var$cursor;
                var result = interpolation(mergedProps);
                $d8b59be3fd10785e$var$cursor = previousCursor;
                return $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $d8b59be3fd10785e$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($d8b59be3fd10785e$var$isProcessableValue(asString)) string += $d8b59be3fd10785e$var$processStyleName(key) + ":" + $d8b59be3fd10785e$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $d8b59be3fd10785e$var$isDevelopment) throw new Error($d8b59be3fd10785e$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($d8b59be3fd10785e$var$isProcessableValue(value[_i])) string += $d8b59be3fd10785e$var$processStyleName(key) + ":" + $d8b59be3fd10785e$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $d8b59be3fd10785e$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $d8b59be3fd10785e$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $d8b59be3fd10785e$var$cursor;
function $d8b59be3fd10785e$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $d8b59be3fd10785e$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $d8b59be3fd10785e$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $d8b59be3fd10785e$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1av6J.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $d8b59be3fd10785e$var$cursor
    };
}

});
parcelRegister("1av6J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d9edae8851266c4$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0d9edae8851266c4$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("kZVpK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4960a7312a76ce2$export$2e2bcd8739ae039; });
var $f4960a7312a76ce2$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("dgnOT", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $9a7f3f1cc52e2219$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $9a7f3f1cc52e2219$export$811a713a7276cb9d; });

var $8nGP5 = parcelRequire("8nGP5");
var $9a7f3f1cc52e2219$var$isBrowser = typeof document !== 'undefined';
var $9a7f3f1cc52e2219$var$syncFallback = function syncFallback(create) {
    return create();
};
var $9a7f3f1cc52e2219$var$useInsertionEffect = $8nGP5.useInsertionEffect ? $8nGP5.useInsertionEffect : false;
var $9a7f3f1cc52e2219$export$db21c7ffa21794e7 = !$9a7f3f1cc52e2219$var$isBrowser ? $9a7f3f1cc52e2219$var$syncFallback : $9a7f3f1cc52e2219$var$useInsertionEffect || $9a7f3f1cc52e2219$var$syncFallback;
var $9a7f3f1cc52e2219$export$811a713a7276cb9d = $9a7f3f1cc52e2219$var$useInsertionEffect || $8nGP5.useLayoutEffect;

});





parcelRegister("kbn1c", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $eb16b0b5db4dfe04$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb16b0b5db4dfe04$var$_createTheme = $eb16b0b5db4dfe04$require$_interopRequireDefault((parcelRequire("dQ1bf")));
const $eb16b0b5db4dfe04$var$defaultTheme = (0, $eb16b0b5db4dfe04$var$_createTheme.default)();
var $eb16b0b5db4dfe04$var$_default = module.exports.default = $eb16b0b5db4dfe04$var$defaultTheme;

});
parcelRegister("dQ1bf", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $a1310c19af5a697e$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a1310c19af5a697e$var$createTheme;

var $a1310c19af5a697e$var$_createPalette = $a1310c19af5a697e$require$_interopRequireDefault((parcelRequire("enVL6")));

var $a1310c19af5a697e$var$_createThemeWithVars = $a1310c19af5a697e$require$_interopRequireDefault((parcelRequire("bODXu")));

var $a1310c19af5a697e$var$_createThemeNoVars = $a1310c19af5a697e$require$_interopRequireDefault((parcelRequire("b2AEc")));
// eslint-disable-next-line consistent-return
function $a1310c19af5a697e$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $a1310c19af5a697e$var$_createPalette.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $a1310c19af5a697e$var$createTheme(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $a1310c19af5a697e$var$_createThemeNoVars.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $a1310c19af5a697e$var$_createThemeNoVars.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $a1310c19af5a697e$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $a1310c19af5a697e$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $a1310c19af5a697e$var$_createThemeWithVars.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("enVL6", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $a7900457bef4b4bd$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dark = void 0;
module.exports.default = $a7900457bef4b4bd$var$createPalette;
module.exports.light = void 0;

var $a7900457bef4b4bd$var$_formatMuiErrorMessage = $a7900457bef4b4bd$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $a7900457bef4b4bd$var$_deepmerge = $a7900457bef4b4bd$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $gLbll = parcelRequire("gLbll");

var $a7900457bef4b4bd$var$_common = $a7900457bef4b4bd$require$_interopRequireDefault((parcelRequire("GE4tR")));

var $a7900457bef4b4bd$var$_grey = $a7900457bef4b4bd$require$_interopRequireDefault((parcelRequire("6TRHq")));

var $a7900457bef4b4bd$var$_purple = $a7900457bef4b4bd$require$_interopRequireDefault((parcelRequire("eteoK")));

var $a7900457bef4b4bd$var$_red = $a7900457bef4b4bd$require$_interopRequireDefault((parcelRequire("ho0K1")));

var $a7900457bef4b4bd$var$_orange = $a7900457bef4b4bd$require$_interopRequireDefault((parcelRequire("8katy")));

var $a7900457bef4b4bd$var$_blue = $a7900457bef4b4bd$require$_interopRequireDefault((parcelRequire("9o3H2")));

var $a7900457bef4b4bd$var$_lightBlue = $a7900457bef4b4bd$require$_interopRequireDefault((parcelRequire("aTyXZ")));

var $a7900457bef4b4bd$var$_green = $a7900457bef4b4bd$require$_interopRequireDefault((parcelRequire("dAAoM")));
function $a7900457bef4b4bd$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: $a7900457bef4b4bd$var$_common.default.white,
            default: $a7900457bef4b4bd$var$_common.default.white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $a7900457bef4b4bd$var$light = module.exports.light = $a7900457bef4b4bd$var$getLight();
function $a7900457bef4b4bd$var$getDark() {
    return {
        text: {
            primary: $a7900457bef4b4bd$var$_common.default.white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: $a7900457bef4b4bd$var$_common.default.white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $a7900457bef4b4bd$var$dark = module.exports.dark = $a7900457bef4b4bd$var$getDark();
function $a7900457bef4b4bd$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $gLbll.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $gLbll.darken)(intent.main, tonalOffsetDark);
    }
}
function $a7900457bef4b4bd$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: $a7900457bef4b4bd$var$_blue.default[200],
        light: $a7900457bef4b4bd$var$_blue.default[50],
        dark: $a7900457bef4b4bd$var$_blue.default[400]
    };
    return {
        main: $a7900457bef4b4bd$var$_blue.default[700],
        light: $a7900457bef4b4bd$var$_blue.default[400],
        dark: $a7900457bef4b4bd$var$_blue.default[800]
    };
}
function $a7900457bef4b4bd$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: $a7900457bef4b4bd$var$_purple.default[200],
        light: $a7900457bef4b4bd$var$_purple.default[50],
        dark: $a7900457bef4b4bd$var$_purple.default[400]
    };
    return {
        main: $a7900457bef4b4bd$var$_purple.default[500],
        light: $a7900457bef4b4bd$var$_purple.default[300],
        dark: $a7900457bef4b4bd$var$_purple.default[700]
    };
}
function $a7900457bef4b4bd$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: $a7900457bef4b4bd$var$_red.default[500],
        light: $a7900457bef4b4bd$var$_red.default[300],
        dark: $a7900457bef4b4bd$var$_red.default[700]
    };
    return {
        main: $a7900457bef4b4bd$var$_red.default[700],
        light: $a7900457bef4b4bd$var$_red.default[400],
        dark: $a7900457bef4b4bd$var$_red.default[800]
    };
}
function $a7900457bef4b4bd$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: $a7900457bef4b4bd$var$_lightBlue.default[400],
        light: $a7900457bef4b4bd$var$_lightBlue.default[300],
        dark: $a7900457bef4b4bd$var$_lightBlue.default[700]
    };
    return {
        main: $a7900457bef4b4bd$var$_lightBlue.default[700],
        light: $a7900457bef4b4bd$var$_lightBlue.default[500],
        dark: $a7900457bef4b4bd$var$_lightBlue.default[900]
    };
}
function $a7900457bef4b4bd$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: $a7900457bef4b4bd$var$_green.default[400],
        light: $a7900457bef4b4bd$var$_green.default[300],
        dark: $a7900457bef4b4bd$var$_green.default[700]
    };
    return {
        main: $a7900457bef4b4bd$var$_green.default[800],
        light: $a7900457bef4b4bd$var$_green.default[500],
        dark: $a7900457bef4b4bd$var$_green.default[900]
    };
}
function $a7900457bef4b4bd$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: $a7900457bef4b4bd$var$_orange.default[400],
        light: $a7900457bef4b4bd$var$_orange.default[300],
        dark: $a7900457bef4b4bd$var$_orange.default[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: $a7900457bef4b4bd$var$_orange.default[500],
        dark: $a7900457bef4b4bd$var$_orange.default[900]
    };
}
function $a7900457bef4b4bd$var$createPalette(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $a7900457bef4b4bd$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $a7900457bef4b4bd$var$getDefaultSecondary(mode);
    const error = palette.error || $a7900457bef4b4bd$var$getDefaultError(mode);
    const info = palette.info || $a7900457bef4b4bd$var$getDefaultInfo(mode);
    const success = palette.success || $a7900457bef4b4bd$var$getDefaultSuccess(mode);
    const warning = palette.warning || $a7900457bef4b4bd$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $gLbll.getContrastRatio)(background, $a7900457bef4b4bd$var$dark.text.primary) >= contrastThreshold ? $a7900457bef4b4bd$var$dark.text.primary : $a7900457bef4b4bd$var$light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $a7900457bef4b4bd$var$_formatMuiErrorMessage.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $a7900457bef4b4bd$var$_formatMuiErrorMessage.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $a7900457bef4b4bd$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $a7900457bef4b4bd$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $a7900457bef4b4bd$var$getLight();
    else if (mode === 'dark') modeHydrated = $a7900457bef4b4bd$var$getDark();
    const paletteOutput = (0, $a7900457bef4b4bd$var$_deepmerge.default)({
        // A collection of common colors.
        common: {
            ...$a7900457bef4b4bd$var$_common.default
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        // The grey colors.
        grey: $a7900457bef4b4bd$var$_grey.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("gLbll", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kX6uF = parcelRequire("kX6uF");
Object.keys($kX6uF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kX6uF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kX6uF[key];
        }
    });
});

});
parcelRegister("kX6uF", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f40e5ad79d2c754e$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $f40e5ad79d2c754e$var$alpha;
module.exports.blend = $f40e5ad79d2c754e$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $f40e5ad79d2c754e$var$darken;
module.exports.decomposeColor = $f40e5ad79d2c754e$var$decomposeColor;
module.exports.emphasize = $f40e5ad79d2c754e$var$emphasize;
module.exports.getContrastRatio = $f40e5ad79d2c754e$var$getContrastRatio;
module.exports.getLuminance = $f40e5ad79d2c754e$var$getLuminance;
module.exports.hexToRgb = $f40e5ad79d2c754e$var$hexToRgb;
module.exports.hslToRgb = $f40e5ad79d2c754e$var$hslToRgb;
module.exports.lighten = $f40e5ad79d2c754e$var$lighten;
module.exports.private_safeAlpha = $f40e5ad79d2c754e$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $f40e5ad79d2c754e$var$private_safeDarken;
module.exports.private_safeEmphasize = $f40e5ad79d2c754e$var$private_safeEmphasize;
module.exports.private_safeLighten = $f40e5ad79d2c754e$var$private_safeLighten;
module.exports.recomposeColor = $f40e5ad79d2c754e$var$recomposeColor;
module.exports.rgbToHex = $f40e5ad79d2c754e$var$rgbToHex;

var $f40e5ad79d2c754e$var$_formatMuiErrorMessage = $f40e5ad79d2c754e$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $f40e5ad79d2c754e$var$_clamp = $f40e5ad79d2c754e$require$_interopRequireDefault((parcelRequire("hxVqe")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f40e5ad79d2c754e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $f40e5ad79d2c754e$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $f40e5ad79d2c754e$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $f40e5ad79d2c754e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $f40e5ad79d2c754e$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $f40e5ad79d2c754e$var$decomposeColor($f40e5ad79d2c754e$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $f40e5ad79d2c754e$var$_formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $f40e5ad79d2c754e$var$_formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $f40e5ad79d2c754e$var$colorChannel = (color)=>{
    const decomposedColor = $f40e5ad79d2c754e$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $f40e5ad79d2c754e$var$colorChannel;
const $f40e5ad79d2c754e$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $f40e5ad79d2c754e$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $f40e5ad79d2c754e$var$private_safeColorChannel;
function $f40e5ad79d2c754e$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $f40e5ad79d2c754e$var$rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $f40e5ad79d2c754e$var$decomposeColor(color);
    return `#${values.map((n, i)=>$f40e5ad79d2c754e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $f40e5ad79d2c754e$var$hslToRgb(color) {
    color = $f40e5ad79d2c754e$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $f40e5ad79d2c754e$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $f40e5ad79d2c754e$var$getLuminance(color) {
    color = $f40e5ad79d2c754e$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $f40e5ad79d2c754e$var$decomposeColor($f40e5ad79d2c754e$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $f40e5ad79d2c754e$var$getContrastRatio(foreground, background) {
    const lumA = $f40e5ad79d2c754e$var$getLuminance(foreground);
    const lumB = $f40e5ad79d2c754e$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f40e5ad79d2c754e$var$alpha(color, value) {
    color = $f40e5ad79d2c754e$var$decomposeColor(color);
    value = $f40e5ad79d2c754e$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f40e5ad79d2c754e$var$recomposeColor(color);
}
function $f40e5ad79d2c754e$var$private_safeAlpha(color, value, warning) {
    try {
        return $f40e5ad79d2c754e$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f40e5ad79d2c754e$var$darken(color, coefficient) {
    color = $f40e5ad79d2c754e$var$decomposeColor(color);
    coefficient = $f40e5ad79d2c754e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f40e5ad79d2c754e$var$recomposeColor(color);
}
function $f40e5ad79d2c754e$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $f40e5ad79d2c754e$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f40e5ad79d2c754e$var$lighten(color, coefficient) {
    color = $f40e5ad79d2c754e$var$decomposeColor(color);
    coefficient = $f40e5ad79d2c754e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f40e5ad79d2c754e$var$recomposeColor(color);
}
function $f40e5ad79d2c754e$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $f40e5ad79d2c754e$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f40e5ad79d2c754e$var$emphasize(color, coefficient = 0.15) {
    return $f40e5ad79d2c754e$var$getLuminance(color) > 0.5 ? $f40e5ad79d2c754e$var$darken(color, coefficient) : $f40e5ad79d2c754e$var$lighten(color, coefficient);
}
function $f40e5ad79d2c754e$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $f40e5ad79d2c754e$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $f40e5ad79d2c754e$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $f40e5ad79d2c754e$var$decomposeColor(background);
    const overlayColor = $f40e5ad79d2c754e$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $f40e5ad79d2c754e$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("hxVqe", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $cc620f927411b1c2$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cc620f927411b1c2$var$_clamp.default;
    }
});

var $cc620f927411b1c2$var$_clamp = $cc620f927411b1c2$require$_interopRequireDefault((parcelRequire("bGq95")));

});
parcelRegister("bGq95", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $0231ef103b8af312$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0231ef103b8af312$var$_default = module.exports.default = $0231ef103b8af312$var$clamp;

});




parcelRegister("GE4tR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $080301ad6ee0e843$var$common = {
    black: '#000',
    white: '#fff'
};
var $080301ad6ee0e843$var$_default = module.exports.default = $080301ad6ee0e843$var$common;

});

parcelRegister("6TRHq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $506188bcaf04c3e3$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $506188bcaf04c3e3$var$_default = module.exports.default = $506188bcaf04c3e3$var$grey;

});

parcelRegister("eteoK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $a88ef14f2623dea2$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $a88ef14f2623dea2$var$_default = module.exports.default = $a88ef14f2623dea2$var$purple;

});

parcelRegister("ho0K1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $ca8540c1ffa57556$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $ca8540c1ffa57556$var$_default = module.exports.default = $ca8540c1ffa57556$var$red;

});

parcelRegister("8katy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $60f8513a0b8035ae$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $60f8513a0b8035ae$var$_default = module.exports.default = $60f8513a0b8035ae$var$orange;

});

parcelRegister("9o3H2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $6d5938565b1ed349$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $6d5938565b1ed349$var$_default = module.exports.default = $6d5938565b1ed349$var$blue;

});

parcelRegister("aTyXZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $7eea2a158c7696cd$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $7eea2a158c7696cd$var$_default = module.exports.default = $7eea2a158c7696cd$var$lightBlue;

});

parcelRegister("dAAoM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $9e4adf2beef03d0c$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $9e4adf2beef03d0c$var$_default = module.exports.default = $9e4adf2beef03d0c$var$green;

});


parcelRegister("bODXu", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $89a35c28427bf9d8$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $89a35c28427bf9d8$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetCssVar = void 0;
module.exports.default = $89a35c28427bf9d8$var$createThemeWithVars;

var $89a35c28427bf9d8$var$_formatMuiErrorMessage = $89a35c28427bf9d8$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $89a35c28427bf9d8$var$_deepmerge = $89a35c28427bf9d8$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $dMm7J = parcelRequire("dMm7J");
var $kfZ7E = parcelRequire("kfZ7E");

var $6QfFh = parcelRequire("6QfFh");

var $58o68 = parcelRequire("58o68");

var $89a35c28427bf9d8$var$_styleFunctionSx = $89a35c28427bf9d8$require$_interopRequireWildcard((parcelRequire("jNnBr")));

var $gLbll = parcelRequire("gLbll");

var $89a35c28427bf9d8$var$_createThemeNoVars = $89a35c28427bf9d8$require$_interopRequireDefault((parcelRequire("b2AEc")));

var $89a35c28427bf9d8$var$_createColorScheme = $89a35c28427bf9d8$require$_interopRequireWildcard((parcelRequire("4DQJV")));

var $89a35c28427bf9d8$var$_shouldSkipGeneratingVar = $89a35c28427bf9d8$require$_interopRequireDefault((parcelRequire("024TL")));

var $89a35c28427bf9d8$var$_createGetSelector = $89a35c28427bf9d8$require$_interopRequireDefault((parcelRequire("1U48P")));

var $72y10 = parcelRequire("72y10");
function $89a35c28427bf9d8$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $89a35c28427bf9d8$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $89a35c28427bf9d8$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $gLbll.hslToRgb)(color);
}
function $89a35c28427bf9d8$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $gLbll.private_safeColorChannel)($89a35c28427bf9d8$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $89a35c28427bf9d8$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $89a35c28427bf9d8$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $89a35c28427bf9d8$var$createGetCssVar = (cssVarPrefix = 'mui')=>(0, $kfZ7E.default)(cssVarPrefix);
module.exports.createGetCssVar = $89a35c28427bf9d8$var$createGetCssVar;
function $89a35c28427bf9d8$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $89a35c28427bf9d8$var$_createColorScheme.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $89a35c28427bf9d8$var$_createThemeNoVars.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $89a35c28427bf9d8$var$_createColorScheme.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $89a35c28427bf9d8$var$_createColorScheme.getOverlays)(mode)
    };
    return muiTheme;
}
/**
 * A default `createThemeWithVars` comes with a single color scheme, either `light` or `dark` based on the `defaultColorScheme`.
 * This is better suited for apps that only need a single color scheme.
 *
 * To enable built-in `light` and `dark` color schemes, either:
 * 1. provide a `colorSchemeSelector` to define how the color schemes will change.
 * 2. provide `colorSchemes.dark` will set `colorSchemeSelector: 'media'` by default.
 */ function $89a35c28427bf9d8$var$createThemeWithVars(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = $89a35c28427bf9d8$var$_shouldSkipGeneratingVar.default, colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $89a35c28427bf9d8$var$createGetCssVar(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $89a35c28427bf9d8$var$_formatMuiErrorMessage.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $89a35c28427bf9d8$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $89a35c28427bf9d8$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $89a35c28427bf9d8$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $58o68.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $89a35c28427bf9d8$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $89a35c28427bf9d8$var$setColor(palette.common, 'background', '#fff');
            $89a35c28427bf9d8$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $89a35c28427bf9d8$var$setColor(palette.common, 'background', '#000');
            $89a35c28427bf9d8$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $89a35c28427bf9d8$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'errorColor', (0, $gLbll.private_safeDarken)(palette.error.light, 0.6));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'infoColor', (0, $gLbll.private_safeDarken)(palette.info.light, 0.6));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'successColor', (0, $gLbll.private_safeDarken)(palette.success.light, 0.6));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'warningColor', (0, $gLbll.private_safeDarken)(palette.warning.light, 0.6));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'errorFilledColor', $89a35c28427bf9d8$var$silent(()=>palette.getContrastText(palette.error.main)));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'infoFilledColor', $89a35c28427bf9d8$var$silent(()=>palette.getContrastText(palette.info.main)));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'successFilledColor', $89a35c28427bf9d8$var$silent(()=>palette.getContrastText(palette.success.main)));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'warningFilledColor', $89a35c28427bf9d8$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'errorStandardBg', (0, $gLbll.private_safeLighten)(palette.error.light, 0.9));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'infoStandardBg', (0, $gLbll.private_safeLighten)(palette.info.light, 0.9));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'successStandardBg', (0, $gLbll.private_safeLighten)(palette.success.light, 0.9));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'warningStandardBg', (0, $gLbll.private_safeLighten)(palette.warning.light, 0.9));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $89a35c28427bf9d8$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $89a35c28427bf9d8$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $89a35c28427bf9d8$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $89a35c28427bf9d8$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $89a35c28427bf9d8$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $89a35c28427bf9d8$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $89a35c28427bf9d8$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $89a35c28427bf9d8$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $89a35c28427bf9d8$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $89a35c28427bf9d8$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'primaryBg', (0, $gLbll.private_safeLighten)(palette.primary.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $gLbll.private_safeLighten)(palette.secondary.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'errorBg', (0, $gLbll.private_safeLighten)(palette.error.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'infoBg', (0, $gLbll.private_safeLighten)(palette.info.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'successBg', (0, $gLbll.private_safeLighten)(palette.success.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'warningBg', (0, $gLbll.private_safeLighten)(palette.warning.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'primaryTrack', (0, $gLbll.private_safeLighten)(palette.primary.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'secondaryTrack', (0, $gLbll.private_safeLighten)(palette.secondary.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'errorTrack', (0, $gLbll.private_safeLighten)(palette.error.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'infoTrack', (0, $gLbll.private_safeLighten)(palette.info.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'successTrack', (0, $gLbll.private_safeLighten)(palette.success.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'warningTrack', (0, $gLbll.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $gLbll.private_safeEmphasize)(palette.background.default, 0.8);
            $89a35c28427bf9d8$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $89a35c28427bf9d8$var$setColor(palette.SnackbarContent, 'color', $89a35c28427bf9d8$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $89a35c28427bf9d8$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $gLbll.private_safeEmphasize)(palette.background.paper, 0.15));
            $89a35c28427bf9d8$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $89a35c28427bf9d8$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $gLbll.private_safeLighten)(palette.primary.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $gLbll.private_safeLighten)(palette.secondary.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'errorDisabledColor', (0, $gLbll.private_safeLighten)(palette.error.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'infoDisabledColor', (0, $gLbll.private_safeLighten)(palette.info.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'successDisabledColor', (0, $gLbll.private_safeLighten)(palette.success.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'warningDisabledColor', (0, $gLbll.private_safeLighten)(palette.warning.main, 0.62));
            $89a35c28427bf9d8$var$setColor(palette.TableCell, 'border', (0, $gLbll.private_safeLighten)((0, $gLbll.private_safeAlpha)(palette.divider, 1), 0.88));
            $89a35c28427bf9d8$var$setColor(palette.Tooltip, 'bg', (0, $gLbll.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'errorColor', (0, $gLbll.private_safeLighten)(palette.error.light, 0.6));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'infoColor', (0, $gLbll.private_safeLighten)(palette.info.light, 0.6));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'successColor', (0, $gLbll.private_safeLighten)(palette.success.light, 0.6));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'warningColor', (0, $gLbll.private_safeLighten)(palette.warning.light, 0.6));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'errorFilledColor', $89a35c28427bf9d8$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'infoFilledColor', $89a35c28427bf9d8$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'successFilledColor', $89a35c28427bf9d8$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'warningFilledColor', $89a35c28427bf9d8$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'errorStandardBg', (0, $gLbll.private_safeDarken)(palette.error.light, 0.9));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'infoStandardBg', (0, $gLbll.private_safeDarken)(palette.info.light, 0.9));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'successStandardBg', (0, $gLbll.private_safeDarken)(palette.success.light, 0.9));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'warningStandardBg', (0, $gLbll.private_safeDarken)(palette.warning.light, 0.9));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $89a35c28427bf9d8$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $89a35c28427bf9d8$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $89a35c28427bf9d8$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $89a35c28427bf9d8$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $89a35c28427bf9d8$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $89a35c28427bf9d8$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $89a35c28427bf9d8$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $89a35c28427bf9d8$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $89a35c28427bf9d8$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $89a35c28427bf9d8$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $89a35c28427bf9d8$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $89a35c28427bf9d8$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $89a35c28427bf9d8$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'primaryBg', (0, $gLbll.private_safeDarken)(palette.primary.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $gLbll.private_safeDarken)(palette.secondary.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'errorBg', (0, $gLbll.private_safeDarken)(palette.error.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'infoBg', (0, $gLbll.private_safeDarken)(palette.info.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'successBg', (0, $gLbll.private_safeDarken)(palette.success.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.LinearProgress, 'warningBg', (0, $gLbll.private_safeDarken)(palette.warning.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'primaryTrack', (0, $gLbll.private_safeDarken)(palette.primary.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'secondaryTrack', (0, $gLbll.private_safeDarken)(palette.secondary.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'errorTrack', (0, $gLbll.private_safeDarken)(palette.error.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'infoTrack', (0, $gLbll.private_safeDarken)(palette.info.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'successTrack', (0, $gLbll.private_safeDarken)(palette.success.main, 0.5));
            $89a35c28427bf9d8$var$setColor(palette.Slider, 'warningTrack', (0, $gLbll.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $gLbll.private_safeEmphasize)(palette.background.default, 0.98);
            $89a35c28427bf9d8$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $89a35c28427bf9d8$var$setColor(palette.SnackbarContent, 'color', $89a35c28427bf9d8$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $89a35c28427bf9d8$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $gLbll.private_safeEmphasize)(palette.background.paper, 0.15));
            $89a35c28427bf9d8$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $89a35c28427bf9d8$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $gLbll.private_safeDarken)(palette.primary.main, 0.55));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $gLbll.private_safeDarken)(palette.secondary.main, 0.55));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'errorDisabledColor', (0, $gLbll.private_safeDarken)(palette.error.main, 0.55));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'infoDisabledColor', (0, $gLbll.private_safeDarken)(palette.info.main, 0.55));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'successDisabledColor', (0, $gLbll.private_safeDarken)(palette.success.main, 0.55));
            $89a35c28427bf9d8$var$setColor(palette.Switch, 'warningDisabledColor', (0, $gLbll.private_safeDarken)(palette.warning.main, 0.55));
            $89a35c28427bf9d8$var$setColor(palette.TableCell, 'border', (0, $gLbll.private_safeDarken)((0, $gLbll.private_safeAlpha)(palette.divider, 1), 0.68));
            $89a35c28427bf9d8$var$setColor(palette.Tooltip, 'bg', (0, $gLbll.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $89a35c28427bf9d8$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $89a35c28427bf9d8$var$setColorChannel(palette.background, 'paper');
        $89a35c28427bf9d8$var$setColorChannel(palette.common, 'background');
        $89a35c28427bf9d8$var$setColorChannel(palette.common, 'onBackground');
        $89a35c28427bf9d8$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $89a35c28427bf9d8$var$setColor(palette[color], 'mainChannel', (0, $gLbll.private_safeColorChannel)($89a35c28427bf9d8$var$toRgb(colors.main)));
                if (colors.light) $89a35c28427bf9d8$var$setColor(palette[color], 'lightChannel', (0, $gLbll.private_safeColorChannel)($89a35c28427bf9d8$var$toRgb(colors.light)));
                if (colors.dark) $89a35c28427bf9d8$var$setColor(palette[color], 'darkChannel', (0, $gLbll.private_safeColorChannel)($89a35c28427bf9d8$var$toRgb(colors.dark)));
                if (colors.contrastText) $89a35c28427bf9d8$var$setColor(palette[color], 'contrastTextChannel', (0, $gLbll.private_safeColorChannel)($89a35c28427bf9d8$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $89a35c28427bf9d8$var$setColorChannel(palette[color], 'primary');
                    $89a35c28427bf9d8$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $89a35c28427bf9d8$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $89a35c28427bf9d8$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $89a35c28427bf9d8$var$_deepmerge.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $89a35c28427bf9d8$var$_createGetSelector.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $58o68.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $dMm7J.default)(input.spacing, (0, $6QfFh.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $58o68.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...$89a35c28427bf9d8$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $89a35c28427bf9d8$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = $72y10.stringifyTheme; // for Pigment CSS integration
    return theme;
}

});
parcelRegister("kfZ7E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebf49f022192c593$export$2e2bcd8739ae039; });
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $ebf49f022192c593$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("58o68", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $3bd06478533281c3$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $3bd06478533281c3$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty(module.exports, "createGetColorSchemeSelector", {
    enumerable: true,
    get: function() {
        return $d5H1x.createGetColorSchemeSelector;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3bd06478533281c3$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty(module.exports, "prepareCssVars", {
    enumerable: true,
    get: function() {
        return $3bd06478533281c3$var$_prepareCssVars.default;
    }
});
Object.defineProperty(module.exports, "prepareTypographyVars", {
    enumerable: true,
    get: function() {
        return $3bd06478533281c3$var$_prepareTypographyVars.default;
    }
});

var $3bd06478533281c3$var$_createCssVarsProvider = $3bd06478533281c3$require$_interopRequireDefault((parcelRequire("9lnsl")));

var $3bd06478533281c3$var$_prepareCssVars = $3bd06478533281c3$require$_interopRequireDefault((parcelRequire("kfqh9")));

var $3bd06478533281c3$var$_prepareTypographyVars = $3bd06478533281c3$require$_interopRequireDefault((parcelRequire("9cWKT")));

var $3bd06478533281c3$var$_createCssVarsTheme = $3bd06478533281c3$require$_interopRequireDefault((parcelRequire("46HwO")));

var $d5H1x = parcelRequire("d5H1x");

});
parcelRegister("9lnsl", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $6cd8452611d3d42e$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $6cd8452611d3d42e$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISABLE_CSS_TRANSITION = void 0;
module.exports.default = $6cd8452611d3d42e$var$createCssVarsProvider;

var $6cd8452611d3d42e$var$React = $6cd8452611d3d42e$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $6cd8452611d3d42e$var$_propTypes = $6cd8452611d3d42e$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $hR4TP = parcelRequire("hR4TP");

var $1aEuo = parcelRequire("1aEuo");

var $6cd8452611d3d42e$var$_useEnhancedEffect = $6cd8452611d3d42e$require$_interopRequireDefault((parcelRequire("jMi8t")));

var $6cd8452611d3d42e$var$_ThemeProvider = $6cd8452611d3d42e$require$_interopRequireDefault((parcelRequire("ay9ex")));

var $6cd8452611d3d42e$var$_InitColorSchemeScript = $6cd8452611d3d42e$require$_interopRequireWildcard((parcelRequire("i7hfB")));

var $6cd8452611d3d42e$var$_useCurrentColorScheme = $6cd8452611d3d42e$require$_interopRequireDefault((parcelRequire("fZpmZ")));

var $kSbwP = parcelRequire("kSbwP");
const $6cd8452611d3d42e$var$DISABLE_CSS_TRANSITION = module.exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $6cd8452611d3d42e$var$createCssVarsProvider(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = $6cd8452611d3d42e$var$_InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = $6cd8452611d3d42e$var$_InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $6cd8452611d3d42e$var$React.createContext(undefined);
    const useColorScheme = ()=>$6cd8452611d3d42e$var$React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $6cd8452611d3d42e$var$React.useRef(false);
        const upperTheme = (0, $1aEuo.default)();
        const ctx = $6cd8452611d3d42e$var$React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $6cd8452611d3d42e$var$React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $6cd8452611d3d42e$var$React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $6cd8452611d3d42e$var$_useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $6cd8452611d3d42e$var$React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $6cd8452611d3d42e$var$_useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $6cd8452611d3d42e$var$React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($6cd8452611d3d42e$var$DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $6cd8452611d3d42e$var$React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $6cd8452611d3d42e$var$React.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $kSbwP.jsxs)($6cd8452611d3d42e$var$React.Fragment, {
            children: [
                /*#__PURE__*/ (0, $kSbwP.jsx)($6cd8452611d3d42e$var$_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $kSbwP.jsx)($hR4TP.default, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $kSbwP.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $6cd8452611d3d42e$var$_InitColorSchemeScript.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("hR4TP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cffb2fd4a4377a01$export$2e2bcd8739ae039; });
parcelRequire("8nGP5");


var $bj8tp = parcelRequire("bj8tp");

var $kSbwP = parcelRequire("kSbwP");
'use client';
function $cffb2fd4a4377a01$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $cffb2fd4a4377a01$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($cffb2fd4a4377a01$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $bj8tp.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("kSbwP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6IstV"));

});


parcelRegister("1aEuo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0da621ea7d39803e$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");

var $iCGFJ = parcelRequire("iCGFJ");
function $0da621ea7d39803e$export$2e2bcd8739ae039() {
    const theme = $8nGP5.useContext((0, $iCGFJ.default));
    return theme;
}

});
parcelRegister("iCGFJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8ece061c76505b2$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");
'use client';
const $d8ece061c76505b2$var$ThemeContext = /*#__PURE__*/ $8nGP5.createContext(null);
var $d8ece061c76505b2$export$2e2bcd8739ae039 = $d8ece061c76505b2$var$ThemeContext;

});


parcelRegister("jMi8t", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $e66091611cd09938$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e66091611cd09938$var$_useEnhancedEffect.default;
    }
});

var $e66091611cd09938$var$_useEnhancedEffect = $e66091611cd09938$require$_interopRequireDefault((parcelRequire("7pL5n")));

});
parcelRegister("7pL5n", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $565f6470f9c3e151$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $565f6470f9c3e151$var$React = $565f6470f9c3e151$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $565f6470f9c3e151$var$useEnhancedEffect = typeof window !== 'undefined' ? $565f6470f9c3e151$var$React.useLayoutEffect : $565f6470f9c3e151$var$React.useEffect;
var $565f6470f9c3e151$var$_default = module.exports.default = $565f6470f9c3e151$var$useEnhancedEffect;

});


parcelRegister("ay9ex", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $7ae43deffc894b79$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7ae43deffc894b79$var$_ThemeProvider.default;
    }
});

var $7ae43deffc894b79$var$_ThemeProvider = $7ae43deffc894b79$require$_interopRequireDefault((parcelRequire("iHuLj")));

});
parcelRegister("iHuLj", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $d9d41ad70da39aa2$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $d9d41ad70da39aa2$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9d41ad70da39aa2$var$React = $d9d41ad70da39aa2$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $d9d41ad70da39aa2$var$_propTypes = $d9d41ad70da39aa2$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $7WGAH = parcelRequire("7WGAH");
var $1aEuo = parcelRequire("1aEuo");

var $d9d41ad70da39aa2$var$_exactProp = $d9d41ad70da39aa2$require$_interopRequireDefault((parcelRequire("fhWSG")));
parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");

var $d9d41ad70da39aa2$var$_useThemeWithoutDefault = $d9d41ad70da39aa2$require$_interopRequireDefault((parcelRequire("aabYF")));

var $d9d41ad70da39aa2$var$_RtlProvider = $d9d41ad70da39aa2$require$_interopRequireDefault((parcelRequire("KFXJz")));

var $d9d41ad70da39aa2$var$_DefaultPropsProvider = $d9d41ad70da39aa2$require$_interopRequireDefault((parcelRequire("dIKpX")));

var $kSbwP = parcelRequire("kSbwP");
const $d9d41ad70da39aa2$var$EMPTY_THEME = {};
function $d9d41ad70da39aa2$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $d9d41ad70da39aa2$var$React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $d9d41ad70da39aa2$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $d9d41ad70da39aa2$var$_useThemeWithoutDefault.default)($d9d41ad70da39aa2$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $1aEuo.default)() || $d9d41ad70da39aa2$var$EMPTY_THEME;
    const engineTheme = $d9d41ad70da39aa2$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $d9d41ad70da39aa2$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    return /*#__PURE__*/ (0, $kSbwP.jsx)($7WGAH.default, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)($jspCa.T.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)($d9d41ad70da39aa2$var$_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)($d9d41ad70da39aa2$var$_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $d9d41ad70da39aa2$var$_default = module.exports.default = $d9d41ad70da39aa2$var$ThemeProvider;

});
parcelRegister("7WGAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c8efcdcf61962f4$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");



var $iCGFJ = parcelRequire("iCGFJ");

var $1aEuo = parcelRequire("1aEuo");

var $gldWy = parcelRequire("gldWy");

var $kSbwP = parcelRequire("kSbwP");
function $5c8efcdcf61962f4$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $5c8efcdcf61962f4$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $1aEuo.default)();
    const theme = $8nGP5.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $5c8efcdcf61962f4$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $gldWy.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $iCGFJ.default).Provider, {
        value: theme,
        children: children
    });
}
var $5c8efcdcf61962f4$export$2e2bcd8739ae039 = $5c8efcdcf61962f4$var$ThemeProvider;

});
parcelRegister("gldWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be596c67f0e4c29f$export$2e2bcd8739ae039; });
const $be596c67f0e4c29f$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $be596c67f0e4c29f$export$2e2bcd8739ae039 = $be596c67f0e4c29f$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("fhWSG", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b2161e1b3b547a75$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b2161e1b3b547a75$var$_exactProp.default;
    }
});

var $b2161e1b3b547a75$var$_exactProp = $b2161e1b3b547a75$require$_interopRequireDefault((parcelRequire("lX7yX")));

});
parcelRegister("lX7yX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffb4f97ec2835fce$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $ffb4f97ec2835fce$var$specialProperty = 'exact-prop: \u200b';
function $ffb4f97ec2835fce$var$exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

});


parcelRegister("aabYF", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $76642109a6872554$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $76642109a6872554$var$_useThemeWithoutDefault.default;
    }
});

var $76642109a6872554$var$_useThemeWithoutDefault = $76642109a6872554$require$_interopRequireDefault((parcelRequire("6NUgl")));

});
parcelRegister("6NUgl", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $4f42f647ef31fff2$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f42f647ef31fff2$var$React = $4f42f647ef31fff2$require$_interopRequireWildcard((parcelRequire("8nGP5")));
parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");
function $4f42f647ef31fff2$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $4f42f647ef31fff2$var$useTheme(defaultTheme = null) {
    const contextTheme = $4f42f647ef31fff2$var$React.useContext($jspCa.T);
    return !contextTheme || $4f42f647ef31fff2$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $4f42f647ef31fff2$var$_default = module.exports.default = $4f42f647ef31fff2$var$useTheme;

});


parcelRegister("KFXJz", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $08c4d8dc980c944a$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $08c4d8dc980c944a$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRtl = module.exports.default = void 0;

var $08c4d8dc980c944a$var$React = $08c4d8dc980c944a$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $08c4d8dc980c944a$var$_propTypes = $08c4d8dc980c944a$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $kSbwP = parcelRequire("kSbwP");
const $08c4d8dc980c944a$var$RtlContext = /*#__PURE__*/ $08c4d8dc980c944a$var$React.createContext();
function $08c4d8dc980c944a$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($08c4d8dc980c944a$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $08c4d8dc980c944a$var$useRtl = ()=>{
    const value = $08c4d8dc980c944a$var$React.useContext($08c4d8dc980c944a$var$RtlContext);
    return value ?? false;
};
module.exports.useRtl = $08c4d8dc980c944a$var$useRtl;
var $08c4d8dc980c944a$var$_default = module.exports.default = $08c4d8dc980c944a$var$RtlProvider;

});

parcelRegister("dIKpX", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $9fd363fd91ab1350$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9fd363fd91ab1350$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $9fd363fd91ab1350$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $9fd363fd91ab1350$var$_DefaultPropsProvider = $9fd363fd91ab1350$require$_interopRequireWildcard((parcelRequire("50hgQ")));

});
parcelRegister("50hgQ", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $3a4a596eb53a52d7$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $3a4a596eb53a52d7$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $3a4a596eb53a52d7$var$useDefaultProps;

var $3a4a596eb53a52d7$var$React = $3a4a596eb53a52d7$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $3a4a596eb53a52d7$var$_propTypes = $3a4a596eb53a52d7$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $3a4a596eb53a52d7$var$_resolveProps = $3a4a596eb53a52d7$require$_interopRequireDefault((parcelRequire("9Blzt")));

var $kSbwP = parcelRequire("kSbwP");
const $3a4a596eb53a52d7$var$PropsContext = /*#__PURE__*/ $3a4a596eb53a52d7$var$React.createContext(undefined);
function $3a4a596eb53a52d7$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($3a4a596eb53a52d7$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $3a4a596eb53a52d7$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $3a4a596eb53a52d7$var$_resolveProps.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $3a4a596eb53a52d7$var$_resolveProps.default)(config, props);
    return props;
}
function $3a4a596eb53a52d7$var$useDefaultProps({ props: props, name: name }) {
    const ctx = $3a4a596eb53a52d7$var$React.useContext($3a4a596eb53a52d7$var$PropsContext);
    return $3a4a596eb53a52d7$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $3a4a596eb53a52d7$var$_default = module.exports.default = $3a4a596eb53a52d7$var$DefaultPropsProvider;

});
parcelRegister("9Blzt", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $6fd84d5c756a0a30$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6fd84d5c756a0a30$var$_resolveProps.default;
    }
});

var $6fd84d5c756a0a30$var$_resolveProps = $6fd84d5c756a0a30$require$_interopRequireDefault((parcelRequire("314yM")));

});
parcelRegister("314yM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2325009c3d139361$var$resolveProps;
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $2325009c3d139361$var$resolveProps(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $2325009c3d139361$var$resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});






parcelRegister("i7hfB", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $d306430c1b6a84af$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_ATTRIBUTE = void 0;
module.exports.default = $d306430c1b6a84af$var$InitColorSchemeScript;

var $d306430c1b6a84af$var$React = $d306430c1b6a84af$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * Split this component for RSC import
 */ const $d306430c1b6a84af$var$DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const $d306430c1b6a84af$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const $d306430c1b6a84af$var$DEFAULT_ATTRIBUTE = module.exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
function $d306430c1b6a84af$var$InitColorSchemeScript(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $d306430c1b6a84af$var$DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $d306430c1b6a84af$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = $d306430c1b6a84af$var$DEFAULT_ATTRIBUTE, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $kSbwP.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("fZpmZ", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $ba403b6a916f19ef$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $ba403b6a916f19ef$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba403b6a916f19ef$var$useCurrentColorScheme;
module.exports.getColorScheme = $ba403b6a916f19ef$var$getColorScheme;
module.exports.getSystemMode = $ba403b6a916f19ef$var$getSystemMode;

var $ba403b6a916f19ef$var$React = $ba403b6a916f19ef$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $i7hfB = parcelRequire("i7hfB");

var $ba403b6a916f19ef$var$_localStorageManager = $ba403b6a916f19ef$require$_interopRequireDefault((parcelRequire("gutZz")));
function $ba403b6a916f19ef$var$noop() {}
function $ba403b6a916f19ef$var$getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $ba403b6a916f19ef$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $ba403b6a916f19ef$var$getColorScheme(state) {
    return $ba403b6a916f19ef$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $ba403b6a916f19ef$var$useCurrentColorScheme(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = $i7hfB.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $i7hfB.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = $ba403b6a916f19ef$var$_localStorageManager.default, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $ba403b6a916f19ef$var$React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $ba403b6a916f19ef$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $ba403b6a916f19ef$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $ba403b6a916f19ef$var$React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $ba403b6a916f19ef$var$getSystemMode(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $ba403b6a916f19ef$var$React.useState(noSsr || !isMultiSchemes);
    $ba403b6a916f19ef$var$React.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $ba403b6a916f19ef$var$getColorScheme(state);
    const setMode = $ba403b6a916f19ef$var$React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $ba403b6a916f19ef$var$getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $ba403b6a916f19ef$var$React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $ba403b6a916f19ef$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $ba403b6a916f19ef$var$React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $ba403b6a916f19ef$var$React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $ba403b6a916f19ef$var$React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $ba403b6a916f19ef$var$React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $ba403b6a916f19ef$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $ba403b6a916f19ef$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $ba403b6a916f19ef$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("gutZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $031923f9bf951514$var$noop() {}
const $031923f9bf951514$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $031923f9bf951514$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $031923f9bf951514$var$_default = module.exports.default = $031923f9bf951514$var$localStorageManager;

});



parcelRegister("kfqh9", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ebd99729686f35a0$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebd99729686f35a0$var$_deepmerge = $ebd99729686f35a0$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $ebd99729686f35a0$var$_cssVarsParser = $ebd99729686f35a0$require$_interopRequireDefault((parcelRequire("7EKNo")));
function $ebd99729686f35a0$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $ebd99729686f35a0$var$_cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $ebd99729686f35a0$var$_cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, $ebd99729686f35a0$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $ebd99729686f35a0$var$_cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, $ebd99729686f35a0$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $ebd99729686f35a0$var$_deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $ebd99729686f35a0$var$_default = module.exports.default = $ebd99729686f35a0$var$prepareCssVars;

});
parcelRegister("7EKNo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignNestedKeys = void 0;
module.exports.default = $59309176252380b0$var$cssVarsParser;
module.exports.walkObjectDeep = void 0;
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $59309176252380b0$var$assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ module.exports.assignNestedKeys = $59309176252380b0$var$assignNestedKeys;
const $59309176252380b0$var$walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
module.exports.walkObjectDeep = $59309176252380b0$var$walkObjectDeep;
const $59309176252380b0$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function $59309176252380b0$var$cssVarsParser(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $59309176252380b0$var$walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $59309176252380b0$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $59309176252380b0$var$assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                $59309176252380b0$var$assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("9cWKT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b42cf9dfc4d84c3$var$prepareTypographyVars;
function $6b42cf9dfc4d84c3$var$prepareTypographyVars(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("46HwO", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $2fd97cc0a0529686$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fd97cc0a0529686$var$_prepareCssVars = $2fd97cc0a0529686$require$_interopRequireDefault((parcelRequire("kfqh9")));

var $d5H1x = parcelRequire("d5H1x");

var $i7hfB = parcelRequire("i7hfB");
function $2fd97cc0a0529686$var$createCssVarsTheme({ colorSchemeSelector: colorSchemeSelector = `[${$i7hfB.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, $2fd97cc0a0529686$var$_prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector: colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, $d5H1x.createGetColorSchemeSelector)(colorSchemeSelector);
    return output;
}
var $2fd97cc0a0529686$var$_default = module.exports.default = $2fd97cc0a0529686$var$createCssVarsTheme;

});
parcelRegister("d5H1x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetColorSchemeSelector = $987d1d9e01bdfb37$var$createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function $987d1d9e01bdfb37$var$createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});



parcelRegister("b2AEc", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $809c4efec5342420$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $809c4efec5342420$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $809c4efec5342420$var$_formatMuiErrorMessage = $809c4efec5342420$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $809c4efec5342420$var$_deepmerge = $809c4efec5342420$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $809c4efec5342420$var$_styleFunctionSx = $809c4efec5342420$require$_interopRequireWildcard((parcelRequire("jNnBr")));

var $809c4efec5342420$var$_createTheme = $809c4efec5342420$require$_interopRequireDefault((parcelRequire("l5tdw")));

var $809c4efec5342420$var$_generateUtilityClass = $809c4efec5342420$require$_interopRequireDefault((parcelRequire("4E9MM")));

var $809c4efec5342420$var$_createMixins = $809c4efec5342420$require$_interopRequireDefault((parcelRequire("2p16W")));

var $809c4efec5342420$var$_createPalette = $809c4efec5342420$require$_interopRequireDefault((parcelRequire("enVL6")));

var $809c4efec5342420$var$_createTypography = $809c4efec5342420$require$_interopRequireDefault((parcelRequire("64QfU")));

var $809c4efec5342420$var$_shadows = $809c4efec5342420$require$_interopRequireDefault((parcelRequire("iapvj")));

var $809c4efec5342420$var$_createTransitions = $809c4efec5342420$require$_interopRequireDefault((parcelRequire("3R9Iy")));

var $809c4efec5342420$var$_zIndex = $809c4efec5342420$require$_interopRequireDefault((parcelRequire("iGFiw")));

var $72y10 = parcelRequire("72y10");
function $809c4efec5342420$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $809c4efec5342420$var$_formatMuiErrorMessage.default)(20));
    const palette = (0, $809c4efec5342420$var$_createPalette.default)(paletteInput);
    const systemTheme = (0, $809c4efec5342420$var$_createTheme.default)(options);
    let muiTheme = (0, $809c4efec5342420$var$_deepmerge.default)(systemTheme, {
        mixins: (0, $809c4efec5342420$var$_createMixins.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: $809c4efec5342420$var$_shadows.default.slice(),
        typography: (0, $809c4efec5342420$var$_createTypography.default)(palette, typographyInput),
        transitions: (0, $809c4efec5342420$var$_createTransitions.default)(transitionsInput),
        zIndex: {
            ...$809c4efec5342420$var$_zIndex.default
        }
    });
    muiTheme = (0, $809c4efec5342420$var$_deepmerge.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $809c4efec5342420$var$_deepmerge.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...$809c4efec5342420$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $809c4efec5342420$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = $72y10.stringifyTheme; // for Pigment CSS integration
    return muiTheme;
}
var $809c4efec5342420$var$_default = module.exports.default = $809c4efec5342420$var$createThemeNoVars;

});
parcelRegister("l5tdw", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f5a0ba86a2fa3412$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f5a0ba86a2fa3412$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $f5a0ba86a2fa3412$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return $f5a0ba86a2fa3412$var$_applyStyles.default;
    }
});

var $f5a0ba86a2fa3412$var$_createTheme = $f5a0ba86a2fa3412$require$_interopRequireDefault((parcelRequire("8cCXP")));

var $f5a0ba86a2fa3412$var$_createBreakpoints = $f5a0ba86a2fa3412$require$_interopRequireDefault((parcelRequire("crgFF")));

var $f5a0ba86a2fa3412$var$_applyStyles = $f5a0ba86a2fa3412$require$_interopRequireDefault((parcelRequire("fzmUS")));

});
parcelRegister("8cCXP", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $5f8dab230236cc80$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f8dab230236cc80$var$_deepmerge = $5f8dab230236cc80$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $5f8dab230236cc80$var$_createBreakpoints = $5f8dab230236cc80$require$_interopRequireDefault((parcelRequire("crgFF")));

var $5f8dab230236cc80$var$_cssContainerQueries = $5f8dab230236cc80$require$_interopRequireDefault((parcelRequire("9w6E6")));

var $5f8dab230236cc80$var$_shape = $5f8dab230236cc80$require$_interopRequireDefault((parcelRequire("gJ6Vm")));

var $5f8dab230236cc80$var$_createSpacing = $5f8dab230236cc80$require$_interopRequireDefault((parcelRequire("3x7VK")));

var $5f8dab230236cc80$var$_styleFunctionSx = $5f8dab230236cc80$require$_interopRequireDefault((parcelRequire("4I0wy")));

var $5f8dab230236cc80$var$_defaultSxConfig = $5f8dab230236cc80$require$_interopRequireDefault((parcelRequire("3pSKT")));

var $5f8dab230236cc80$var$_applyStyles = $5f8dab230236cc80$require$_interopRequireDefault((parcelRequire("fzmUS")));
function $5f8dab230236cc80$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $5f8dab230236cc80$var$_createBreakpoints.default)(breakpointsInput);
    const spacing = (0, $5f8dab230236cc80$var$_createSpacing.default)(spacingInput);
    let muiTheme = (0, $5f8dab230236cc80$var$_deepmerge.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...$5f8dab230236cc80$var$_shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $5f8dab230236cc80$var$_cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = $5f8dab230236cc80$var$_applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, $5f8dab230236cc80$var$_deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...$5f8dab230236cc80$var$_defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $5f8dab230236cc80$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $5f8dab230236cc80$var$_default = module.exports.default = $5f8dab230236cc80$var$createTheme;

});
parcelRegister("crgFF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakpointKeys = void 0;
module.exports.default = $90e4f0268bae9454$var$createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $90e4f0268bae9454$var$breakpointKeys = module.exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $90e4f0268bae9454$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function $90e4f0268bae9454$var$createBreakpoints(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $90e4f0268bae9454$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("gJ6Vm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $c2d6384bb671060d$var$shape = {
    borderRadius: 4
};
var $c2d6384bb671060d$var$_default = module.exports.default = $c2d6384bb671060d$var$shape;

});

parcelRegister("3x7VK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $292a9af4902835cf$var$createSpacing;

var $6QfFh = parcelRequire("6QfFh");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function $292a9af4902835cf$var$createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $6QfFh.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("fzmUS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b55be6a08aa0b9b6$var$applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $b55be6a08aa0b9b6$var$applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("4E9MM", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $36227d17408af430$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $36227d17408af430$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $36227d17408af430$var$_generateUtilityClass.default;
    }
});

var $36227d17408af430$var$_generateUtilityClass = $36227d17408af430$require$_interopRequireWildcard((parcelRequire("6c8aZ")));
Object.keys($36227d17408af430$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($36227d17408af430$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $36227d17408af430$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $36227d17408af430$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("6c8aZ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $482a34b147e5bb23$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $482a34b147e5bb23$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $482a34b147e5bb23$var$isGlobalState;

var $482a34b147e5bb23$var$_ClassNameGenerator = $482a34b147e5bb23$require$_interopRequireDefault((parcelRequire("hKcHZ")));
const $482a34b147e5bb23$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $482a34b147e5bb23$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $482a34b147e5bb23$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$482a34b147e5bb23$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $482a34b147e5bb23$var$isGlobalState(slot) {
    return $482a34b147e5bb23$var$globalStateClasses[slot] !== undefined;
}

});
parcelRegister("hKcHZ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ceb09736d060ee4f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ceb09736d060ee4f$var$_ClassNameGenerator.default;
    }
});

var $ceb09736d060ee4f$var$_ClassNameGenerator = $ceb09736d060ee4f$require$_interopRequireDefault((parcelRequire("1KCob")));

});
parcelRegister("1KCob", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $1467dd9872fc2db2$var$defaultGenerator = (componentName)=>componentName;
const $1467dd9872fc2db2$var$createClassNameGenerator = ()=>{
    let generate = $1467dd9872fc2db2$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $1467dd9872fc2db2$var$defaultGenerator;
        }
    };
};
const $1467dd9872fc2db2$var$ClassNameGenerator = $1467dd9872fc2db2$var$createClassNameGenerator();
var $1467dd9872fc2db2$var$_default = module.exports.default = $1467dd9872fc2db2$var$ClassNameGenerator;

});




parcelRegister("2p16W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1bfec72c04490361$var$createMixins;
function $1bfec72c04490361$var$createMixins(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("64QfU", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $46cba6ad9186b800$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $46cba6ad9186b800$var$createTypography;

var $46cba6ad9186b800$var$_deepmerge = $46cba6ad9186b800$require$_interopRequireDefault((parcelRequire("cfKeZ")));
function $46cba6ad9186b800$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $46cba6ad9186b800$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $46cba6ad9186b800$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */ function $46cba6ad9186b800$var$createTypography(palette, typography) {
    const { fontFamily: fontFamily = $46cba6ad9186b800$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $46cba6ad9186b800$var$defaultFontFamily ? {
                letterSpacing: `${$46cba6ad9186b800$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $46cba6ad9186b800$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $46cba6ad9186b800$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $46cba6ad9186b800$var$_deepmerge.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("iapvj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $d39cf1b6cc086bab$var$shadowKeyUmbraOpacity = 0.2;
const $d39cf1b6cc086bab$var$shadowKeyPenumbraOpacity = 0.14;
const $d39cf1b6cc086bab$var$shadowAmbientShadowOpacity = 0.12;
function $d39cf1b6cc086bab$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$d39cf1b6cc086bab$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$d39cf1b6cc086bab$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$d39cf1b6cc086bab$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $d39cf1b6cc086bab$var$shadows = [
    'none',
    $d39cf1b6cc086bab$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $d39cf1b6cc086bab$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $d39cf1b6cc086bab$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $d39cf1b6cc086bab$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $d39cf1b6cc086bab$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $d39cf1b6cc086bab$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $d39cf1b6cc086bab$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $d39cf1b6cc086bab$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $d39cf1b6cc086bab$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $d39cf1b6cc086bab$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $d39cf1b6cc086bab$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $d39cf1b6cc086bab$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $d39cf1b6cc086bab$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $d39cf1b6cc086bab$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $d39cf1b6cc086bab$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $d39cf1b6cc086bab$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $d39cf1b6cc086bab$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $d39cf1b6cc086bab$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $d39cf1b6cc086bab$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $d39cf1b6cc086bab$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $d39cf1b6cc086bab$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $d39cf1b6cc086bab$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $d39cf1b6cc086bab$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $d39cf1b6cc086bab$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $d39cf1b6cc086bab$var$_default = module.exports.default = $d39cf1b6cc086bab$var$shadows;

});

parcelRegister("3R9Iy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ceddc0a327bf7b6$var$createTransitions;
module.exports.easing = module.exports.duration = void 0;
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $2ceddc0a327bf7b6$var$easing = module.exports.easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const $2ceddc0a327bf7b6$var$duration = module.exports.duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $2ceddc0a327bf7b6$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $2ceddc0a327bf7b6$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $2ceddc0a327bf7b6$var$createTransitions(inputTransitions) {
    const mergedEasing = {
        ...$2ceddc0a327bf7b6$var$easing,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$2ceddc0a327bf7b6$var$duration,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $2ceddc0a327bf7b6$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $2ceddc0a327bf7b6$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $2ceddc0a327bf7b6$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("iGFiw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $d9ac2f16ea5b3317$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $d9ac2f16ea5b3317$var$_default = module.exports.default = $d9ac2f16ea5b3317$var$zIndex;

});

parcelRegister("72y10", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringifyTheme = $52031b0ade48a0e1$var$stringifyTheme;

var $cfKeZ = parcelRequire("cfKeZ");
/* eslint-disable import/prefer-default-export */ function $52031b0ade48a0e1$var$isSerializable(val) {
    return (0, $cfKeZ.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
/**
 * `baseTheme` usually comes from `createTheme()` or `extendTheme()`.
 *
 * This function is intended to be used with zero-runtime CSS-in-JS like Pigment CSS
 * For example, in a Next.js project:
 *
 * ```js
 * // next.config.js
 * const { extendTheme } = require('@mui/material/styles');
 *
 * const theme = extendTheme();
 * // `.toRuntimeSource` is Pigment CSS specific to create a theme that is available at runtime.
 * theme.toRuntimeSource = stringifyTheme;
 *
 * module.exports = withPigment({
 *  theme,
 * });
 * ```
 */ function $52031b0ade48a0e1$var$stringifyTheme(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$52031b0ade48a0e1$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $cfKeZ.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("4DQJV", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $3613b6f704525878$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3613b6f704525878$var$createColorScheme;
module.exports.getOpacity = $3613b6f704525878$var$getOpacity;
module.exports.getOverlays = $3613b6f704525878$var$getOverlays;

var $3613b6f704525878$var$_createPalette = $3613b6f704525878$require$_interopRequireDefault((parcelRequire("enVL6")));

var $3613b6f704525878$var$_getOverlayAlpha = $3613b6f704525878$require$_interopRequireDefault((parcelRequire("7cuWF")));
const $3613b6f704525878$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $3613b6f704525878$var$_getOverlayAlpha.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $3613b6f704525878$var$getOpacity(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $3613b6f704525878$var$getOverlays(mode) {
    return mode === 'dark' ? $3613b6f704525878$var$defaultDarkOverlays : [];
}
function $3613b6f704525878$var$createColorScheme(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $3613b6f704525878$var$_createPalette.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$3613b6f704525878$var$getOpacity(palette.mode),
            ...opacity
        },
        overlays: overlays || $3613b6f704525878$var$getOverlays(palette.mode),
        ...rest
    };
}

});
parcelRegister("7cuWF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $53e1a87446bea030$var$getOverlayAlpha;
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $53e1a87446bea030$var$getOverlayAlpha(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("024TL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0063fcc176eb842a$var$shouldSkipGeneratingVar;
function $0063fcc176eb842a$var$shouldSkipGeneratingVar(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("1U48P", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $162e3bc84c635612$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $162e3bc84c635612$var$_excludeVariablesFromRoot = $162e3bc84c635612$require$_interopRequireDefault((parcelRequire("902eJ")));
var $162e3bc84c635612$var$_default = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $162e3bc84c635612$var$_excludeVariablesFromRoot.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };
module.exports.default = $162e3bc84c635612$var$_default;

});
parcelRegister("902eJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $68d5d94a37b0fece$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $68d5d94a37b0fece$var$_default = module.exports.default = $68d5d94a37b0fece$var$excludeVariablesFromRoot;

});





parcelRegister("Ho9ot", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $0826c00e508fddb7$var$_default = module.exports.default = '$$material';

});


parcelRegister("jiDuP", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $e0ce55e4ed6e72ae$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e0ce55e4ed6e72ae$var$_GlobalStyles.default;
    }
});

var $e0ce55e4ed6e72ae$var$_GlobalStyles = $e0ce55e4ed6e72ae$require$_interopRequireDefault((parcelRequire("jAnj4")));

});
parcelRegister("jAnj4", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $e42375529404b52b$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $e42375529404b52b$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e42375529404b52b$var$React = $e42375529404b52b$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $e42375529404b52b$var$_propTypes = $e42375529404b52b$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $fUKUp = parcelRequire("fUKUp");

var $e42375529404b52b$var$_defaultTheme = $e42375529404b52b$require$_interopRequireDefault((parcelRequire("kbn1c")));

var $e42375529404b52b$var$_identifier = $e42375529404b52b$require$_interopRequireDefault((parcelRequire("Ho9ot")));

var $kSbwP = parcelRequire("kSbwP");
function $e42375529404b52b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($fUKUp.default, {
        ...props,
        defaultTheme: $e42375529404b52b$var$_defaultTheme.default,
        themeId: $e42375529404b52b$var$_identifier.default
    });
}
var $e42375529404b52b$var$_default = module.exports.default = $e42375529404b52b$var$GlobalStyles;

});
parcelRegister("fUKUp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9607916df1c2c49$export$2e2bcd8739ae039; });
parcelRequire("8nGP5");


var $hR4TP = parcelRequire("hR4TP");

var $hk9Pq = parcelRequire("hk9Pq");

var $kSbwP = parcelRequire("kSbwP");
'use client';
function $b9607916df1c2c49$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $hk9Pq.default)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $hR4TP.default), {
        styles: globalStyles
    });
}
var $b9607916df1c2c49$export$2e2bcd8739ae039 = $b9607916df1c2c49$var$GlobalStyles;

});



parcelRegister("dq4m7", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $9c51150400781925$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
Object.defineProperty(module.exports, "rootShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $9c51150400781925$var$_rootShouldForwardProp.default;
    }
});
Object.defineProperty(module.exports, "slotShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $9c51150400781925$var$_slotShouldForwardProp.default;
    }
});

var $9c51150400781925$var$_createStyled = $9c51150400781925$require$_interopRequireDefault((parcelRequire("8GVXe")));

var $9c51150400781925$var$_defaultTheme = $9c51150400781925$require$_interopRequireDefault((parcelRequire("kbn1c")));

var $9c51150400781925$var$_identifier = $9c51150400781925$require$_interopRequireDefault((parcelRequire("Ho9ot")));

var $9c51150400781925$var$_rootShouldForwardProp = $9c51150400781925$require$_interopRequireDefault((parcelRequire("75rPq")));

var $9c51150400781925$var$_slotShouldForwardProp = $9c51150400781925$require$_interopRequireDefault((parcelRequire("azr6N")));
const $9c51150400781925$var$styled = (0, $9c51150400781925$var$_createStyled.default)({
    themeId: $9c51150400781925$var$_identifier.default,
    defaultTheme: $9c51150400781925$var$_defaultTheme.default,
    rootShouldForwardProp: $9c51150400781925$var$_rootShouldForwardProp.default
});
var $9c51150400781925$var$_default = module.exports.default = $9c51150400781925$var$styled;

});
parcelRegister("8GVXe", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $653f3386b4412af5$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $653f3386b4412af5$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $653f3386b4412af5$var$_createStyled.default;
    }
});

var $653f3386b4412af5$var$_createStyled = $653f3386b4412af5$require$_interopRequireWildcard((parcelRequire("d9Axn")));
Object.keys($653f3386b4412af5$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($653f3386b4412af5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $653f3386b4412af5$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $653f3386b4412af5$var$_createStyled[key];
        }
    });
});

});
parcelRegister("d9Axn", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $993875298d8eaadf$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $993875298d8eaadf$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $993875298d8eaadf$var$createStyled;
module.exports.shouldForwardProp = $993875298d8eaadf$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $993875298d8eaadf$var$_styledEngine = $993875298d8eaadf$require$_interopRequireWildcard((parcelRequire("8gY7h")));

var $cfKeZ = parcelRequire("cfKeZ");

var $993875298d8eaadf$var$_capitalize = $993875298d8eaadf$require$_interopRequireDefault((parcelRequire("eUhyY")));

var $993875298d8eaadf$var$_getDisplayName = $993875298d8eaadf$require$_interopRequireDefault((parcelRequire("2iJqU")));

var $993875298d8eaadf$var$_createTheme = $993875298d8eaadf$require$_interopRequireDefault((parcelRequire("l5tdw")));

var $993875298d8eaadf$var$_styleFunctionSx = $993875298d8eaadf$require$_interopRequireDefault((parcelRequire("jNnBr")));

var $993875298d8eaadf$var$_preprocessStyles = $993875298d8eaadf$require$_interopRequireDefault((parcelRequire("eyIwP")));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const $993875298d8eaadf$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $993875298d8eaadf$var$_createTheme.default)();
// Update /system/styled/#api in case if this changes
function $993875298d8eaadf$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $993875298d8eaadf$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $993875298d8eaadf$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $993875298d8eaadf$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $993875298d8eaadf$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$993875298d8eaadf$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $993875298d8eaadf$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $993875298d8eaadf$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $993875298d8eaadf$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $993875298d8eaadf$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $993875298d8eaadf$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $993875298d8eaadf$var$shouldForwardProp } = input;
    function styleAttachTheme(props) {
        $993875298d8eaadf$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $993875298d8eaadf$var$_styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== $993875298d8eaadf$var$_styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $993875298d8eaadf$var$defaultOverridesResolver($993875298d8eaadf$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $993875298d8eaadf$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($993875298d8eaadf$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $993875298d8eaadf$var$_styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $993875298d8eaadf$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === 'function' && style.__emotion_real !== style) return function styleFunctionProcessor(props) {
                return $993875298d8eaadf$var$processStyle(props, style);
            };
            if ((0, $cfKeZ.isPlainObject)(style)) {
                const serialized = (0, $993875298d8eaadf$var$_preprocessStyles.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $993875298d8eaadf$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $993875298d8eaadf$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $993875298d8eaadf$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push($993875298d8eaadf$var$_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $993875298d8eaadf$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $993875298d8eaadf$var$_capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, $993875298d8eaadf$var$_getDisplayName.default)(tag)})`;
}
function $993875298d8eaadf$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $993875298d8eaadf$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $993875298d8eaadf$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $993875298d8eaadf$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("8gY7h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $605e733a2e2c93a7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_mutateStyles", function () { return $605e733a2e2c93a7$export$592c7226e4cb0171; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $605e733a2e2c93a7$export$13a2d3ef13012b32; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("jspCa")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("bj8tp")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("bj8tp")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("gbhcr")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("hR4TP")).default; });
/**
 * @mui/styled-engine v7.0.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5Nojk = parcelRequire("5Nojk");

var $iBxqj = parcelRequire("iBxqj");

var $bj8tp = parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");

var $gbhcr = parcelRequire("gbhcr");

var $hR4TP = parcelRequire("hR4TP");
'use client';
function $605e733a2e2c93a7$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5Nojk.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $605e733a2e2c93a7$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $605e733a2e2c93a7$var$wrapper = [];
function $605e733a2e2c93a7$export$13a2d3ef13012b32(styles) {
    $605e733a2e2c93a7$var$wrapper[0] = styles;
    return (0, $iBxqj.serializeStyles)($605e733a2e2c93a7$var$wrapper);
}

});
parcelRegister("5Nojk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $438462fab9e54a99$export$2e2bcd8739ae039; });

var $iqQta = parcelRequire("iqQta");
parcelRequire("8tsi7");
parcelRequire("8nGP5");
parcelRequire("4kwnA");

parcelRequire("7x006");
parcelRequire("iBxqj");
parcelRequire("dgnOT");
var $438462fab9e54a99$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $438462fab9e54a99$export$2e2bcd8739ae039 = (0, $iqQta.default).bind();
$438462fab9e54a99$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $438462fab9e54a99$export$2e2bcd8739ae039[tagName] = $438462fab9e54a99$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("iqQta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6b35b0f053397da$export$2e2bcd8739ae039; });

var $1TGTA = parcelRequire("1TGTA");

var $8nGP5 = parcelRequire("8nGP5");

var $4kwnA = parcelRequire("4kwnA");
parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");

var $7x006 = parcelRequire("7x006");

var $iBxqj = parcelRequire("iBxqj");

var $dgnOT = parcelRequire("dgnOT");
var $d6b35b0f053397da$var$testOmitPropsOnStringTag = (0, $4kwnA.default);
var $d6b35b0f053397da$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $d6b35b0f053397da$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $d6b35b0f053397da$var$testOmitPropsOnStringTag : $d6b35b0f053397da$var$testOmitPropsOnComponent;
};
var $d6b35b0f053397da$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $d6b35b0f053397da$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $d6b35b0f053397da$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7x006.registerStyles)(cache, serialized, isStringTag);
    (0, $dgnOT.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7x006.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $d6b35b0f053397da$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $d6b35b0f053397da$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $d6b35b0f053397da$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $jspCa.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8nGP5.useContext((0, $jspCa.T));
            }
            if (typeof props.className === 'string') className = (0, $7x006.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $iBxqj.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $d6b35b0f053397da$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement($d6b35b0f053397da$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $8nGP5.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $1TGTA.default)({}, options, nextOptions, {
                shouldForwardProp: $d6b35b0f053397da$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});


parcelRegister("gbhcr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc7b03ee2fd8b4d3$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");


var $jspCa = parcelRequire("jspCa");

var $6tfZw = parcelRequire("6tfZw");

var $77sbF = parcelRequire("77sbF");

var $kSbwP = parcelRequire("kSbwP");
'use client';
const $bc7b03ee2fd8b4d3$var$cacheMap = new Map();
const $bc7b03ee2fd8b4d3$export$5a3f4e255fc47e86 = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $bc7b03ee2fd8b4d3$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $6tfZw.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $bc7b03ee2fd8b4d3$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $bc7b03ee2fd8b4d3$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$bc7b03ee2fd8b4d3$var$insertionPoint) {
        $bc7b03ee2fd8b4d3$var$insertionPoint = document.createElement('meta');
        $bc7b03ee2fd8b4d3$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $bc7b03ee2fd8b4d3$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($bc7b03ee2fd8b4d3$var$insertionPoint);
    }
}
function $bc7b03ee2fd8b4d3$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends (0, $77sbF.StyleSheet) {
            insert(rule, options) {
                if ($bc7b03ee2fd8b4d3$export$5a3f4e255fc47e86.insert) return $bc7b03ee2fd8b4d3$export$5a3f4e255fc47e86.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $bc7b03ee2fd8b4d3$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $bc7b03ee2fd8b4d3$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $bc7b03ee2fd8b4d3$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.startsWith('@layer')) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $bc7b03ee2fd8b4d3$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $8nGP5.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if ($bc7b03ee2fd8b4d3$var$cacheMap.has(cacheKey)) return $bc7b03ee2fd8b4d3$var$cacheMap.get(cacheKey);
        const fresh = $bc7b03ee2fd8b4d3$var$getCache(injectFirst, enableCssLayer);
        $bc7b03ee2fd8b4d3$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $kSbwP.jsx)((0, $jspCa.C), {
        value: cache,
        children: children
    }) : children;
}

});


parcelRegister("2iJqU", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $1ad081476776c35f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1ad081476776c35f$var$_getDisplayName.default;
    }
});

var $1ad081476776c35f$var$_getDisplayName = $1ad081476776c35f$require$_interopRequireDefault((parcelRequire("hfpaJ")));

});
parcelRegister("hfpaJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c8e75d0a6d624484$var$getDisplayName;

var $4G43L = parcelRequire("4G43L");
function $c8e75d0a6d624484$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $c8e75d0a6d624484$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $c8e75d0a6d624484$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function $c8e75d0a6d624484$var$getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $c8e75d0a6d624484$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $4G43L.ForwardRef:
            return $c8e75d0a6d624484$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case $4G43L.Memo:
            return $c8e75d0a6d624484$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("eyIwP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a996c81c450e8c67$var$preprocessStyles;

var $8gY7h = parcelRequire("8gY7h");
function $a996c81c450e8c67$var$preprocessStyles(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $8gY7h.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $8gY7h.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("75rPq", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $528e962df5a73844$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $528e962df5a73844$var$_slotShouldForwardProp = $528e962df5a73844$require$_interopRequireDefault((parcelRequire("azr6N")));
const $528e962df5a73844$var$rootShouldForwardProp = (prop)=>(0, $528e962df5a73844$var$_slotShouldForwardProp.default)(prop) && prop !== 'classes';
var $528e962df5a73844$var$_default = module.exports.default = $528e962df5a73844$var$rootShouldForwardProp;

});
parcelRegister("azr6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// copied from @mui/system/createStyled
function $7b22337a45010f77$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $7b22337a45010f77$var$_default = module.exports.default = $7b22337a45010f77$var$slotShouldForwardProp;

});




parcelRegister("kTCCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jjdRO = parcelRequire("jjdRO");
const $f366e7193ff2ae7d$var$memoTheme = $jjdRO.default;
var $f366e7193ff2ae7d$var$_default = module.exports.default = $f366e7193ff2ae7d$var$memoTheme;

});
parcelRegister("jjdRO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0ea8c54cd0be10b$export$2e2bcd8739ae039; });

var $7EwlR = parcelRequire("7EwlR");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $e0ea8c54cd0be10b$var$arg = {
    theme: undefined
};
function $e0ea8c54cd0be10b$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $e0ea8c54cd0be10b$var$arg.theme = props.theme;
            value = (0, $7EwlR.default)(styleFn($e0ea8c54cd0be10b$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});
parcelRegister("7EwlR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59255d2cc88b8d66$export$2e2bcd8739ae039; });

var $8gY7h = parcelRequire("8gY7h");
function $59255d2cc88b8d66$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $8gY7h.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $8gY7h.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("eFtkv", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $aadba55263e9017c$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $aadba55263e9017c$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $aadba55263e9017c$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $aadba55263e9017c$var$_DefaultPropsProvider = $aadba55263e9017c$require$_interopRequireWildcard((parcelRequire("hhctI")));

});
parcelRegister("hhctI", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $c93db41c84743df2$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $c93db41c84743df2$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $c93db41c84743df2$var$useDefaultProps;

var $c93db41c84743df2$var$React = $c93db41c84743df2$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $c93db41c84743df2$var$_propTypes = $c93db41c84743df2$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $c93db41c84743df2$var$_DefaultPropsProvider = $c93db41c84743df2$require$_interopRequireWildcard((parcelRequire("dIKpX")));

var $kSbwP = parcelRequire("kSbwP");
function $c93db41c84743df2$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($c93db41c84743df2$var$_DefaultPropsProvider.default, {
        ...props
    });
}
var $c93db41c84743df2$var$_default = module.exports.default = $c93db41c84743df2$var$DefaultPropsProvider;
function $c93db41c84743df2$var$useDefaultProps(params) {
    return (0, $c93db41c84743df2$var$_DefaultPropsProvider.useDefaultProps)(params);
}

});


parcelRegister("eQgWl", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ace30ff9c36bec5b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSvgIconUtilityClass = $ace30ff9c36bec5b$var$getSvgIconUtilityClass;

var $ace30ff9c36bec5b$var$_generateUtilityClasses = $ace30ff9c36bec5b$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $ace30ff9c36bec5b$var$_generateUtilityClass = $ace30ff9c36bec5b$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $ace30ff9c36bec5b$var$getSvgIconUtilityClass(slot) {
    return (0, $ace30ff9c36bec5b$var$_generateUtilityClass.default)('MuiSvgIcon', slot);
}
const $ace30ff9c36bec5b$var$svgIconClasses = (0, $ace30ff9c36bec5b$var$_generateUtilityClasses.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $ace30ff9c36bec5b$var$_default = module.exports.default = $ace30ff9c36bec5b$var$svgIconClasses;

});
parcelRegister("4bI4C", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $30ca608ebce0b338$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $30ca608ebce0b338$var$_generateUtilityClasses.default;
    }
});

var $30ca608ebce0b338$var$_generateUtilityClasses = $30ca608ebce0b338$require$_interopRequireDefault((parcelRequire("gg7F3")));

});
parcelRegister("gg7F3", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $bd6415536cd8695d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd6415536cd8695d$var$generateUtilityClasses;

var $bd6415536cd8695d$var$_generateUtilityClass = $bd6415536cd8695d$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $bd6415536cd8695d$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $bd6415536cd8695d$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});






parcelRegister("b7tDG", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $818756de317a3913$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $818756de317a3913$var$_debounce = $818756de317a3913$require$_interopRequireDefault((parcelRequire("4aHRm")));
var $818756de317a3913$var$_default = module.exports.default = $818756de317a3913$var$_debounce.default;

});
parcelRegister("4aHRm", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $309a1e383c48f3af$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $309a1e383c48f3af$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $309a1e383c48f3af$var$_debounce.default;
    }
});

var $309a1e383c48f3af$var$_debounce = $309a1e383c48f3af$require$_interopRequireWildcard((parcelRequire("eeeqA")));
Object.keys($309a1e383c48f3af$var$_debounce).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($309a1e383c48f3af$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $309a1e383c48f3af$var$_debounce[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $309a1e383c48f3af$var$_debounce[key];
        }
    });
});

});
parcelRegister("eeeqA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a5bd90887596d7d8$var$debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $a5bd90887596d7d8$var$debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});



parcelRegister("87PEQ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $5ea70c5c24f877a8$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ea70c5c24f877a8$var$_deprecatedPropType = $5ea70c5c24f877a8$require$_interopRequireDefault((parcelRequire("jhuth")));
var $5ea70c5c24f877a8$var$_default = module.exports.default = $5ea70c5c24f877a8$var$_deprecatedPropType.default;

});
parcelRegister("jhuth", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $e0973dd0957be1be$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e0973dd0957be1be$var$_deprecatedPropType.default;
    }
});

var $e0973dd0957be1be$var$_deprecatedPropType = $e0973dd0957be1be$require$_interopRequireDefault((parcelRequire("lqC9i")));

});
parcelRegister("lqC9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9999e3e42d339a1$var$deprecatedPropType;
function $f9999e3e42d339a1$var$deprecatedPropType(validator, reason) {
    var props, propName, componentName, location, propFullName;
    return ()=>null;
}

});



parcelRegister("chsEC", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $8f0d4cafdfed5d85$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f0d4cafdfed5d85$var$_isMuiElement = $8f0d4cafdfed5d85$require$_interopRequireDefault((parcelRequire("dhro8")));
var $8f0d4cafdfed5d85$var$_default = module.exports.default = $8f0d4cafdfed5d85$var$_isMuiElement.default;

});
parcelRegister("dhro8", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9ab21ba1fd93b567$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9ab21ba1fd93b567$var$_isMuiElement.default;
    }
});

var $9ab21ba1fd93b567$var$_isMuiElement = $9ab21ba1fd93b567$require$_interopRequireDefault((parcelRequire("8Vjlg")));

});
parcelRegister("8Vjlg", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $67f2a684794b2bf6$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67f2a684794b2bf6$var$isMuiElement;

var $67f2a684794b2bf6$var$React = $67f2a684794b2bf6$require$_interopRequireWildcard((parcelRequire("8nGP5")));
function $67f2a684794b2bf6$var$isMuiElement(element, muiNames) {
    return /*#__PURE__*/ $67f2a684794b2bf6$var$React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});



parcelRegister("5ar2w", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $3c32dc746d66972c$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c32dc746d66972c$var$_ownerDocument = $3c32dc746d66972c$require$_interopRequireDefault((parcelRequire("cZzr8")));
var $3c32dc746d66972c$var$_default = module.exports.default = $3c32dc746d66972c$var$_ownerDocument.default;

});
parcelRegister("cZzr8", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9756ab89623dca63$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9756ab89623dca63$var$_ownerDocument.default;
    }
});

var $9756ab89623dca63$var$_ownerDocument = $9756ab89623dca63$require$_interopRequireDefault((parcelRequire("eVbdR")));

});
parcelRegister("eVbdR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adcf1821f6c6bd31$var$ownerDocument;
function $adcf1821f6c6bd31$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("8V6h9", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $67e883d5fbd88d95$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67e883d5fbd88d95$var$_ownerWindow = $67e883d5fbd88d95$require$_interopRequireDefault((parcelRequire("dJ518")));
var $67e883d5fbd88d95$var$_default = module.exports.default = $67e883d5fbd88d95$var$_ownerWindow.default;

});
parcelRegister("dJ518", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9fe35eabc2bed473$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9fe35eabc2bed473$var$_ownerWindow.default;
    }
});

var $9fe35eabc2bed473$var$_ownerWindow = $9fe35eabc2bed473$require$_interopRequireDefault((parcelRequire("2SfzQ")));

});
parcelRegister("2SfzQ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $217cb5335251aabf$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $217cb5335251aabf$var$ownerWindow;

var $217cb5335251aabf$var$_ownerDocument = $217cb5335251aabf$require$_interopRequireDefault((parcelRequire("cZzr8")));
function $217cb5335251aabf$var$ownerWindow(node) {
    const doc = (0, $217cb5335251aabf$var$_ownerDocument.default)(node);
    return doc.defaultView || window;
}

});



parcelRegister("hsSgH", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $cb6f25be6a1c73f3$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb6f25be6a1c73f3$var$_requirePropFactory = $cb6f25be6a1c73f3$require$_interopRequireDefault((parcelRequire("hKd8N")));
var $cb6f25be6a1c73f3$var$_default = module.exports.default = $cb6f25be6a1c73f3$var$_requirePropFactory.default;

});
parcelRegister("hKd8N", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ceb0ed089c4b7843$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ceb0ed089c4b7843$var$_requirePropFactory.default;
    }
});

var $ceb0ed089c4b7843$var$_requirePropFactory = $ceb0ed089c4b7843$require$_interopRequireDefault((parcelRequire("eUqFj")));

});
parcelRegister("eUqFj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adaaface2eaf896d$var$requirePropFactory;
function $adaaface2eaf896d$var$requirePropFactory(componentNameInError, Component) {
    return ()=>null;
}

});



parcelRegister("9O4Pm", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $723c8731f536bc81$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $723c8731f536bc81$var$_setRef = $723c8731f536bc81$require$_interopRequireDefault((parcelRequire("7W32S")));
var $723c8731f536bc81$var$_default = module.exports.default = $723c8731f536bc81$var$_setRef.default;

});
parcelRegister("7W32S", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $5c704fec5afb7364$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5c704fec5afb7364$var$_setRef.default;
    }
});

var $5c704fec5afb7364$var$_setRef = $5c704fec5afb7364$require$_interopRequireDefault((parcelRequire("2BH8w")));

});
parcelRegister("2BH8w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e607f7c9ff280be$var$setRef;
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $1e607f7c9ff280be$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});



parcelRegister("4oMQY", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $333f4c9c20720e38$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $333f4c9c20720e38$var$_useEnhancedEffect = $333f4c9c20720e38$require$_interopRequireDefault((parcelRequire("jMi8t")));
var $333f4c9c20720e38$var$_default = module.exports.default = $333f4c9c20720e38$var$_useEnhancedEffect.default;

});

parcelRegister("edkAa", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $a5923ed401f9f23b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5923ed401f9f23b$var$_useId = $a5923ed401f9f23b$require$_interopRequireDefault((parcelRequire("BEaqK")));
var $a5923ed401f9f23b$var$_default = module.exports.default = $a5923ed401f9f23b$var$_useId.default;

});
parcelRegister("BEaqK", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $07129d310f60d476$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $07129d310f60d476$var$_useId.default;
    }
});

var $07129d310f60d476$var$_useId = $07129d310f60d476$require$_interopRequireDefault((parcelRequire("jERCH")));

});
parcelRegister("jERCH", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $e4fb592ff0088479$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4fb592ff0088479$var$useId;

var $e4fb592ff0088479$var$React = $e4fb592ff0088479$require$_interopRequireWildcard((parcelRequire("8nGP5")));
let $e4fb592ff0088479$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $e4fb592ff0088479$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $e4fb592ff0088479$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $e4fb592ff0088479$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $e4fb592ff0088479$var$globalId += 1;
            setDefaultId(`mui-${$e4fb592ff0088479$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $e4fb592ff0088479$var$safeReact = {
    ...$e4fb592ff0088479$var$React
};
const $e4fb592ff0088479$var$maybeReactUseId = $e4fb592ff0088479$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $e4fb592ff0088479$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($e4fb592ff0088479$var$maybeReactUseId !== undefined) {
        const reactId = $e4fb592ff0088479$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $e4fb592ff0088479$var$useGlobalId(idOverride);
}

});



parcelRegister("9d2MU", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $6b477d8b05d91033$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b477d8b05d91033$var$_unsupportedProp = $6b477d8b05d91033$require$_interopRequireDefault((parcelRequire("lalIu")));
var $6b477d8b05d91033$var$_default = module.exports.default = $6b477d8b05d91033$var$_unsupportedProp.default;

});
parcelRegister("lalIu", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f68b6094e20a5e42$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f68b6094e20a5e42$var$_unsupportedProp.default;
    }
});

var $f68b6094e20a5e42$var$_unsupportedProp = $f68b6094e20a5e42$require$_interopRequireDefault((parcelRequire("jAmtF")));

});
parcelRegister("jAmtF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e422d0adf9677a6e$var$unsupportedProp;
function $e422d0adf9677a6e$var$unsupportedProp(props, propName, componentName, location, propFullName) {
    return null;
}

});



parcelRegister("8WqeI", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $68281785fe89b153$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68281785fe89b153$var$_useControlled = $68281785fe89b153$require$_interopRequireDefault((parcelRequire("fvGy1")));
var $68281785fe89b153$var$_default = module.exports.default = $68281785fe89b153$var$_useControlled.default;

});
parcelRegister("fvGy1", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b4aac15733addaa3$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b4aac15733addaa3$var$_useControlled.default;
    }
});

var $b4aac15733addaa3$var$_useControlled = $b4aac15733addaa3$require$_interopRequireDefault((parcelRequire("bWnqg")));

});
parcelRegister("bWnqg", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $8b1747bfa7d60961$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b1747bfa7d60961$var$useControlled;

var $8b1747bfa7d60961$var$React = $8b1747bfa7d60961$require$_interopRequireWildcard((parcelRequire("8nGP5")));
function $8b1747bfa7d60961$var$useControlled({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $8b1747bfa7d60961$var$React.useRef(controlled !== undefined);
    const [valueState, setValue] = $8b1747bfa7d60961$var$React.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $8b1747bfa7d60961$var$React.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});



parcelRegister("6hPuj", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $493c45087f81ad6e$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $493c45087f81ad6e$var$_useEventCallback = $493c45087f81ad6e$require$_interopRequireDefault((parcelRequire("5xdHV")));
var $493c45087f81ad6e$var$_default = module.exports.default = $493c45087f81ad6e$var$_useEventCallback.default;

});
parcelRegister("5xdHV", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $407aaad440b680e2$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $407aaad440b680e2$var$_useEventCallback.default;
    }
});

var $407aaad440b680e2$var$_useEventCallback = $407aaad440b680e2$require$_interopRequireDefault((parcelRequire("f8Zxa")));

});
parcelRegister("f8Zxa", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $b06755b7f180a780$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $b06755b7f180a780$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b06755b7f180a780$var$React = $b06755b7f180a780$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $b06755b7f180a780$var$_useEnhancedEffect = $b06755b7f180a780$require$_interopRequireDefault((parcelRequire("jMi8t")));
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $b06755b7f180a780$var$useEventCallback(fn) {
    const ref = $b06755b7f180a780$var$React.useRef(fn);
    (0, $b06755b7f180a780$var$_useEnhancedEffect.default)(()=>{
        ref.current = fn;
    });
    return $b06755b7f180a780$var$React.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $b06755b7f180a780$var$_default = module.exports.default = $b06755b7f180a780$var$useEventCallback;

});



parcelRegister("iZq8x", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $dd3232b9e7598f08$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd3232b9e7598f08$var$_useForkRef = $dd3232b9e7598f08$require$_interopRequireDefault((parcelRequire("7uWLa")));
var $dd3232b9e7598f08$var$_default = module.exports.default = $dd3232b9e7598f08$var$_useForkRef.default;

});
parcelRegister("7uWLa", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $5758ea304694dedd$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5758ea304694dedd$var$_useForkRef.default;
    }
});

var $5758ea304694dedd$var$_useForkRef = $5758ea304694dedd$require$_interopRequireDefault((parcelRequire("j7Q3z")));

});
parcelRegister("j7Q3z", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $dec70d1bd561b224$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dec70d1bd561b224$var$useForkRef;

var $dec70d1bd561b224$var$React = $dec70d1bd561b224$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * Merges refs into a single memoized callback ref or `null`.
 *
 * ```tsx
 * const rootRef = React.useRef<Instance>(null);
 * const refFork = useForkRef(rootRef, props.ref);
 *
 * return (
 *   <Root {...props} ref={refFork} />
 * );
 * ```
 *
 * @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
 * @returns {React.RefCallback<Instance> | null} The new ref callback.
 */ function $dec70d1bd561b224$var$useForkRef(...refs) {
    const cleanupRef = $dec70d1bd561b224$var$React.useRef(undefined);
    const refEffect = $dec70d1bd561b224$var$React.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $dec70d1bd561b224$var$React.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});



parcelRegister("bkauv", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $83e9b3498bb71c39$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $83e9b3498bb71c39$var$mergeSlotProps;

var $83e9b3498bb71c39$var$_clsx = $83e9b3498bb71c39$require$_interopRequireDefault((parcelRequire("ajIhI")));
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $83e9b3498bb71c39$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $83e9b3498bb71c39$var$mergeSlotProps(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($83e9b3498bb71c39$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $83e9b3498bb71c39$var$_clsx.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $83e9b3498bb71c39$var$_clsx.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});



parcelRegister("e4lJB", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $a3e24c6c8e984729$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a3e24c6c8e984729$var$_refType.default;
    }
});

var $a3e24c6c8e984729$var$_refType = $a3e24c6c8e984729$require$_interopRequireDefault((parcelRequire("h22aM")));

});
parcelRegister("h22aM", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c6644f156dd99f9d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6644f156dd99f9d$var$_propTypes = $c6644f156dd99f9d$require$_interopRequireDefault((parcelRequire("ebCsu")));
const $c6644f156dd99f9d$var$refType = $c6644f156dd99f9d$var$_propTypes.default.oneOfType([
    $c6644f156dd99f9d$var$_propTypes.default.func,
    $c6644f156dd99f9d$var$_propTypes.default.object
]);
var $c6644f156dd99f9d$var$_default = module.exports.default = $c6644f156dd99f9d$var$refType;

});


parcelRegister("5kQCz", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $3e27a373f2ea0a29$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3e27a373f2ea0a29$var$_elementTypeAcceptingRef.default;
    }
});

var $3e27a373f2ea0a29$var$_elementTypeAcceptingRef = $3e27a373f2ea0a29$require$_interopRequireDefault((parcelRequire("aAbx9")));

});
parcelRegister("aAbx9", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $7b463683f69119c7$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b463683f69119c7$var$_propTypes = $7b463683f69119c7$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $7b463683f69119c7$var$_chainPropTypes = $7b463683f69119c7$require$_interopRequireDefault((parcelRequire("3wrUq")));
function $7b463683f69119c7$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $7b463683f69119c7$var$elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !$7b463683f69119c7$var$isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
var $7b463683f69119c7$var$_default = module.exports.default = (0, $7b463683f69119c7$var$_chainPropTypes.default)($7b463683f69119c7$var$_propTypes.default.elementType, $7b463683f69119c7$var$elementTypeAcceptingRef);

});
parcelRegister("3wrUq", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $290a0271bb4a82c4$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $290a0271bb4a82c4$var$_chainPropTypes.default;
    }
});

var $290a0271bb4a82c4$var$_chainPropTypes = $290a0271bb4a82c4$require$_interopRequireDefault((parcelRequire("xH48M")));

});
parcelRegister("xH48M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06547d2651b0686f$var$chainPropTypes;
function $06547d2651b0686f$var$chainPropTypes(propType1, propType2) {
    return ()=>null;
}

});




parcelRegister("jLOre", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $e649881af75aa788$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e649881af75aa788$var$_isFocusVisible.default;
    }
});

var $e649881af75aa788$var$_isFocusVisible = $e649881af75aa788$require$_interopRequireDefault((parcelRequire("jZAvu")));

});
parcelRegister("jZAvu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8e008581ed2c035$var$isFocusVisible;
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $e8e008581ed2c035$var$isFocusVisible(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});


parcelRegister("3MjpJ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $2c04ea08bc684ff8$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2c04ea08bc684ff8$var$_useLazyRef.default;
    }
});

var $2c04ea08bc684ff8$var$_useLazyRef = $2c04ea08bc684ff8$require$_interopRequireDefault((parcelRequire("587f9")));

});
parcelRegister("587f9", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $3bc351786e03e696$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3bc351786e03e696$var$useLazyRef;

var $3bc351786e03e696$var$React = $3bc351786e03e696$require$_interopRequireWildcard((parcelRequire("8nGP5")));
const $3bc351786e03e696$var$UNINITIALIZED = {};
/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */ function $3bc351786e03e696$var$useLazyRef(init, initArg) {
    const ref = $3bc351786e03e696$var$React.useRef($3bc351786e03e696$var$UNINITIALIZED);
    if (ref.current === $3bc351786e03e696$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});


parcelRegister("kuuLw", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $eeae79608977ec34$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Timeout", {
    enumerable: true,
    get: function() {
        return $eeae79608977ec34$var$_useTimeout.Timeout;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $eeae79608977ec34$var$_useTimeout.default;
    }
});

var $eeae79608977ec34$var$_useTimeout = $eeae79608977ec34$require$_interopRequireWildcard((parcelRequire("iDHdc")));

});
parcelRegister("iDHdc", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $d91d638341eb78f3$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
module.exports.default = $d91d638341eb78f3$var$useTimeout;

var $d91d638341eb78f3$var$_useLazyRef = $d91d638341eb78f3$require$_interopRequireDefault((parcelRequire("587f9")));

var $d91d638341eb78f3$var$_useOnMount = $d91d638341eb78f3$require$_interopRequireDefault((parcelRequire("coHAx")));
class $d91d638341eb78f3$var$Timeout {
    static create() {
        return new $d91d638341eb78f3$var$Timeout();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
module.exports.Timeout = $d91d638341eb78f3$var$Timeout;
function $d91d638341eb78f3$var$useTimeout() {
    const timeout = (0, $d91d638341eb78f3$var$_useLazyRef.default)($d91d638341eb78f3$var$Timeout.create).current;
    (0, $d91d638341eb78f3$var$_useOnMount.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("coHAx", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $906989a3cb2f6219$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $906989a3cb2f6219$var$useOnMount;

var $906989a3cb2f6219$var$React = $906989a3cb2f6219$require$_interopRequireWildcard((parcelRequire("8nGP5")));
const $906989a3cb2f6219$var$EMPTY = [];
/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */ function $906989a3cb2f6219$var$useOnMount(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $906989a3cb2f6219$var$React.useEffect(fn, $906989a3cb2f6219$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});



parcelRegister("37mRE", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $2453c2ecdb25cf91$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $2453c2ecdb25cf91$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2453c2ecdb25cf91$var$_exportNames = {
    circularProgressClasses: true
};
Object.defineProperty(module.exports, "circularProgressClasses", {
    enumerable: true,
    get: function() {
        return $2453c2ecdb25cf91$var$_circularProgressClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2453c2ecdb25cf91$var$_CircularProgress.default;
    }
});

var $2453c2ecdb25cf91$var$_CircularProgress = $2453c2ecdb25cf91$require$_interopRequireDefault((parcelRequire("3UWAv")));

var $2453c2ecdb25cf91$var$_circularProgressClasses = $2453c2ecdb25cf91$require$_interopRequireWildcard((parcelRequire("1usZs")));
Object.keys($2453c2ecdb25cf91$var$_circularProgressClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2453c2ecdb25cf91$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2453c2ecdb25cf91$var$_circularProgressClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2453c2ecdb25cf91$var$_circularProgressClasses[key];
        }
    });
});

});
parcelRegister("3UWAv", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $2da40c63ac95d18e$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $2da40c63ac95d18e$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2da40c63ac95d18e$var$React = $2da40c63ac95d18e$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $2da40c63ac95d18e$var$_propTypes = $2da40c63ac95d18e$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $2da40c63ac95d18e$var$_clsx = $2da40c63ac95d18e$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $2da40c63ac95d18e$var$_chainPropTypes = $2da40c63ac95d18e$require$_interopRequireDefault((parcelRequire("3wrUq")));

var $2da40c63ac95d18e$var$_composeClasses = $2da40c63ac95d18e$require$_interopRequireDefault((parcelRequire("4F19u")));

var $bvcHB = parcelRequire("bvcHB");

var $2da40c63ac95d18e$var$_memoTheme = $2da40c63ac95d18e$require$_interopRequireDefault((parcelRequire("kTCCA")));

var $eFtkv = parcelRequire("eFtkv");

var $2da40c63ac95d18e$var$_capitalize = $2da40c63ac95d18e$require$_interopRequireDefault((parcelRequire("gVVIq")));

var $2da40c63ac95d18e$var$_createSimplePaletteValueFilter = $2da40c63ac95d18e$require$_interopRequireDefault((parcelRequire("bJNLl")));

var $1usZs = parcelRequire("1usZs");

var $kSbwP = parcelRequire("kSbwP");
const $2da40c63ac95d18e$var$SIZE = 44;
const $2da40c63ac95d18e$var$circularRotateKeyframe = (0, $bvcHB.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $2da40c63ac95d18e$var$circularDashKeyframe = (0, $bvcHB.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $2da40c63ac95d18e$var$rotateAnimation = typeof $2da40c63ac95d18e$var$circularRotateKeyframe !== 'string' ? (0, $bvcHB.css)`
        animation: ${$2da40c63ac95d18e$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $2da40c63ac95d18e$var$dashAnimation = typeof $2da40c63ac95d18e$var$circularDashKeyframe !== 'string' ? (0, $bvcHB.css)`
        animation: ${$2da40c63ac95d18e$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $2da40c63ac95d18e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $2da40c63ac95d18e$var$_capitalize.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $2da40c63ac95d18e$var$_capitalize.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $2da40c63ac95d18e$var$_composeClasses.default)(slots, $1usZs.getCircularProgressUtilityClass, classes);
};
const $2da40c63ac95d18e$var$CircularProgressRoot = (0, $bvcHB.styled)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $2da40c63ac95d18e$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $2da40c63ac95d18e$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $2da40c63ac95d18e$var$rotateAnimation || {
                    animation: `${$2da40c63ac95d18e$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $2da40c63ac95d18e$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $2da40c63ac95d18e$var$CircularProgressSVG = (0, $bvcHB.styled)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $2da40c63ac95d18e$var$CircularProgressCircle = (0, $bvcHB.styled)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $2da40c63ac95d18e$var$_capitalize.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $2da40c63ac95d18e$var$_memoTheme.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $2da40c63ac95d18e$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$2da40c63ac95d18e$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $2da40c63ac95d18e$var$CircularProgress = /*#__PURE__*/ $2da40c63ac95d18e$var$React.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $eFtkv.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $2da40c63ac95d18e$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($2da40c63ac95d18e$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $kSbwP.jsx)($2da40c63ac95d18e$var$CircularProgressRoot, {
        className: (0, $2da40c63ac95d18e$var$_clsx.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)($2da40c63ac95d18e$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$2da40c63ac95d18e$var$SIZE / 2} ${$2da40c63ac95d18e$var$SIZE / 2} ${$2da40c63ac95d18e$var$SIZE} ${$2da40c63ac95d18e$var$SIZE}`,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)($2da40c63ac95d18e$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $2da40c63ac95d18e$var$SIZE,
                cy: $2da40c63ac95d18e$var$SIZE,
                r: ($2da40c63ac95d18e$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $2da40c63ac95d18e$var$_default = module.exports.default = $2da40c63ac95d18e$var$CircularProgress;

});
parcelRegister("bJNLl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $88ba7f7d10eb8184$var$createSimplePaletteValueFilter;
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $88ba7f7d10eb8184$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $88ba7f7d10eb8184$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$88ba7f7d10eb8184$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
/**
 * Creates a filter function used to filter simple palette color options.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns ([, value]: [any, PaletteColorOptions]) => boolean
 */ function $88ba7f7d10eb8184$var$createSimplePaletteValueFilter(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $88ba7f7d10eb8184$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("1usZs", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $115f14a4ae3b2884$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCircularProgressUtilityClass = $115f14a4ae3b2884$var$getCircularProgressUtilityClass;

var $115f14a4ae3b2884$var$_generateUtilityClasses = $115f14a4ae3b2884$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $115f14a4ae3b2884$var$_generateUtilityClass = $115f14a4ae3b2884$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $115f14a4ae3b2884$var$getCircularProgressUtilityClass(slot) {
    return (0, $115f14a4ae3b2884$var$_generateUtilityClass.default)('MuiCircularProgress', slot);
}
const $115f14a4ae3b2884$var$circularProgressClasses = (0, $115f14a4ae3b2884$var$_generateUtilityClasses.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $115f14a4ae3b2884$var$_default = module.exports.default = $115f14a4ae3b2884$var$circularProgressClasses;

});



parcelRegister("fwOL7", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4e137dd62fad75f$var$adaptV4Theme;

var $hBOoG = parcelRequire("hBOoG");
var $dMm7J = parcelRequire("dMm7J");
function $b4e137dd62fad75f$var$adaptV4Theme(inputTheme) {
    const { defaultProps: defaultProps = {}, mixins: mixins = {}, overrides: overrides = {}, palette: palette = {}, props: props = {}, styleOverrides: styleOverrides = {}, ...other } = inputTheme;
    const theme = {
        ...other,
        components: {}
    };
    // default props
    Object.keys(defaultProps).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = (0, $dMm7J.default)(inputTheme.spacing);
    // theme.mixins.gutters
    const breakpoints = (0, $hBOoG.default)(inputTheme.breakpoints || {});
    const spacing = theme.spacing;
    theme.mixins = {
        gutters: (styles = {})=>{
            return {
                paddingLeft: spacing(2),
                paddingRight: spacing(2),
                ...styles,
                [breakpoints.up('sm')]: {
                    paddingLeft: spacing(3),
                    paddingRight: spacing(3),
                    ...styles[breakpoints.up('sm')]
                }
            };
        },
        ...mixins
    };
    const { type: typeInput, mode: modeInput, ...paletteRest } = palette;
    const finalMode = modeInput || typeInput || 'light';
    theme.palette = {
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode,
        ...paletteRest
    };
    return theme;
}

});

parcelRegister("hYdxP", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $d1528bf51b3124f3$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d1528bf51b3124f3$var$createMuiStrictModeTheme;

var $d1528bf51b3124f3$var$_deepmerge = $d1528bf51b3124f3$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $d1528bf51b3124f3$var$_createTheme = $d1528bf51b3124f3$require$_interopRequireDefault((parcelRequire("dQ1bf")));
function $d1528bf51b3124f3$var$createMuiStrictModeTheme(options, ...args) {
    return (0, $d1528bf51b3124f3$var$_createTheme.default)((0, $d1528bf51b3124f3$var$_deepmerge.default)({
        unstable_strictMode: true
    }, options), ...args);
}

});

parcelRegister("2STuI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $219babf7b753a3a6$var$createStyles;
let $219babf7b753a3a6$var$warnedOnce = false;
// To remove in v6
function $219babf7b753a3a6$var$createStyles(styles) {
    if (!$219babf7b753a3a6$var$warnedOnce) {
        console.warn([
            'MUI: createStyles from @mui/material/styles is deprecated.',
            'Please use @mui/styles/createStyles'
        ].join('\n'));
        $219babf7b753a3a6$var$warnedOnce = true;
    }
    return styles;
}

});

parcelRegister("hzWsq", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ccc30cfdccfb4578$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccc30cfdccfb4578$var$responsiveFontSizes;

var $ccc30cfdccfb4578$var$_formatMuiErrorMessage = $ccc30cfdccfb4578$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $eRNf4 = parcelRequire("eRNf4");
function $ccc30cfdccfb4578$var$responsiveFontSizes(themeInput, options = {}) {
    const { breakpoints: breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign: disableAlign = false, factor: factor = 2, variants: variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = {
        ...themeInput
    };
    theme.typography = {
        ...theme.typography
    };
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, $eRNf4.convertLength)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight: lineHeight } = style;
        if (!(0, $eRNf4.isUnitless)(lineHeight) && !disableAlign) throw new Error((0, $ccc30cfdccfb4578$var$_formatMuiErrorMessage.default)(6));
        if (!(0, $eRNf4.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, $eRNf4.alignProperty)({
                size: value,
                grid: (0, $eRNf4.fontGrid)({
                    pixels: 4,
                    lineHeight: lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        typography[variant] = {
            ...style,
            ...(0, $eRNf4.responsiveProperty)({
                cssProperty: 'fontSize',
                min: minFontSize,
                max: maxFontSize,
                unit: 'rem',
                breakpoints: breakpointValues,
                transform: transform
            })
        };
    });
    return theme;
}

});
parcelRegister("eRNf4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alignProperty = $ad2c365ac29fd7bf$var$alignProperty;
module.exports.convertLength = $ad2c365ac29fd7bf$var$convertLength;
module.exports.fontGrid = $ad2c365ac29fd7bf$var$fontGrid;
module.exports.getUnit = $ad2c365ac29fd7bf$var$getUnit;
module.exports.isUnitless = $ad2c365ac29fd7bf$var$isUnitless;
module.exports.responsiveProperty = $ad2c365ac29fd7bf$var$responsiveProperty;
module.exports.toUnitless = $ad2c365ac29fd7bf$var$toUnitless;
function $ad2c365ac29fd7bf$var$isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function $ad2c365ac29fd7bf$var$getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
// Emulate the sass function "unitless"
function $ad2c365ac29fd7bf$var$toUnitless(length) {
    return parseFloat(length);
}
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function $ad2c365ac29fd7bf$var$convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $ad2c365ac29fd7bf$var$getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $ad2c365ac29fd7bf$var$toUnitless(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $ad2c365ac29fd7bf$var$toUnitless(length) * $ad2c365ac29fd7bf$var$toUnitless(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $ad2c365ac29fd7bf$var$toUnitless(length) * $ad2c365ac29fd7bf$var$toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $ad2c365ac29fd7bf$var$toUnitless(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $ad2c365ac29fd7bf$var$toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $ad2c365ac29fd7bf$var$alignProperty({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function $ad2c365ac29fd7bf$var$fontGrid({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ function $ad2c365ac29fd7bf$var$responsiveProperty({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});


parcelRegister("6HsQe", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $4e0d2187c54d7201$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e0d2187c54d7201$var$useThemeProps;

var $4e0d2187c54d7201$var$_useThemeProps = $4e0d2187c54d7201$require$_interopRequireDefault((parcelRequire("kzOvA")));

var $4e0d2187c54d7201$var$_defaultTheme = $4e0d2187c54d7201$require$_interopRequireDefault((parcelRequire("kbn1c")));

var $4e0d2187c54d7201$var$_identifier = $4e0d2187c54d7201$require$_interopRequireDefault((parcelRequire("Ho9ot")));
function $4e0d2187c54d7201$var$useThemeProps({ props: props, name: name }) {
    return (0, $4e0d2187c54d7201$var$_useThemeProps.default)({
        props: props,
        name: name,
        defaultTheme: $4e0d2187c54d7201$var$_defaultTheme.default,
        themeId: $4e0d2187c54d7201$var$_identifier.default
    });
}

});
parcelRegister("kzOvA", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $efae4177044d9740$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $efae4177044d9740$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $efae4177044d9740$var$_getThemeProps.default;
    }
});

var $efae4177044d9740$var$_useThemeProps = $efae4177044d9740$require$_interopRequireDefault((parcelRequire("mcQHB")));

var $efae4177044d9740$var$_getThemeProps = $efae4177044d9740$require$_interopRequireDefault((parcelRequire("iqQx8")));

});
parcelRegister("mcQHB", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $042c05bd4d747ae2$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $042c05bd4d747ae2$var$useThemeProps;

var $042c05bd4d747ae2$var$_getThemeProps = $042c05bd4d747ae2$require$_interopRequireDefault((parcelRequire("iqQx8")));

var $042c05bd4d747ae2$var$_useTheme = $042c05bd4d747ae2$require$_interopRequireDefault((parcelRequire("1yBPg")));
function $042c05bd4d747ae2$var$useThemeProps({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $042c05bd4d747ae2$var$_useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $042c05bd4d747ae2$var$_getThemeProps.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("iqQx8", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $d6b367c524ec139b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6b367c524ec139b$var$getThemeProps;

var $d6b367c524ec139b$var$_resolveProps = $d6b367c524ec139b$require$_interopRequireDefault((parcelRequire("9Blzt")));
function $d6b367c524ec139b$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $d6b367c524ec139b$var$_resolveProps.default)(theme.components[name].defaultProps, props);
}

});

parcelRegister("1yBPg", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $12264eda80e05564$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $12264eda80e05564$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $12264eda80e05564$var$_useTheme.default;
    }
});

var $12264eda80e05564$var$_useTheme = $12264eda80e05564$require$_interopRequireWildcard((parcelRequire("7Rov2")));
Object.keys($12264eda80e05564$var$_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($12264eda80e05564$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $12264eda80e05564$var$_useTheme[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $12264eda80e05564$var$_useTheme[key];
        }
    });
});

});
parcelRegister("7Rov2", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $5b907cc36c8106ec$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.systemDefaultTheme = module.exports.default = void 0;

var $5b907cc36c8106ec$var$_createTheme = $5b907cc36c8106ec$require$_interopRequireDefault((parcelRequire("l5tdw")));

var $5b907cc36c8106ec$var$_useThemeWithoutDefault = $5b907cc36c8106ec$require$_interopRequireDefault((parcelRequire("aabYF")));
const $5b907cc36c8106ec$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $5b907cc36c8106ec$var$_createTheme.default)();
function $5b907cc36c8106ec$var$useTheme(defaultTheme = $5b907cc36c8106ec$var$systemDefaultTheme) {
    return (0, $5b907cc36c8106ec$var$_useThemeWithoutDefault.default)(defaultTheme);
}
var $5b907cc36c8106ec$var$_default = module.exports.default = $5b907cc36c8106ec$var$useTheme;

});





parcelRegister("5LlAU", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $432217bc170ace15$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $432217bc170ace15$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $432217bc170ace15$var$ThemeProvider;

var $432217bc170ace15$var$React = $432217bc170ace15$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $432217bc170ace15$var$_ThemeProviderNoVars = $432217bc170ace15$require$_interopRequireDefault((parcelRequire("3BAfh")));

var $bgduR = parcelRequire("bgduR");

var $432217bc170ace15$var$_identifier = $432217bc170ace15$require$_interopRequireDefault((parcelRequire("Ho9ot")));

var $kSbwP = parcelRequire("kSbwP");
function $432217bc170ace15$var$ThemeProvider({ theme: theme, ...props }) {
    if (typeof theme === 'function') return /*#__PURE__*/ (0, $kSbwP.jsx)($432217bc170ace15$var$_ThemeProviderNoVars.default, {
        theme: theme,
        ...props
    });
    const muiTheme = $432217bc170ace15$var$_identifier.default in theme ? theme[$432217bc170ace15$var$_identifier.default] : theme;
    if (!('colorSchemes' in muiTheme)) {
        if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
        // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
        return /*#__PURE__*/ (0, $kSbwP.jsx)($432217bc170ace15$var$_ThemeProviderNoVars.default, {
            theme: {
                ...theme,
                vars: null
            },
            ...props
        });
        return /*#__PURE__*/ (0, $kSbwP.jsx)($432217bc170ace15$var$_ThemeProviderNoVars.default, {
            theme: theme,
            ...props
        });
    }
    return /*#__PURE__*/ (0, $kSbwP.jsx)($bgduR.CssVarsProvider, {
        theme: theme,
        ...props
    });
}

});
parcelRegister("3BAfh", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $2a00f1634669355d$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $2a00f1634669355d$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a00f1634669355d$var$ThemeProviderNoVars;

var $2a00f1634669355d$var$React = $2a00f1634669355d$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $7i3Am = parcelRequire("7i3Am");

var $2a00f1634669355d$var$_identifier = $2a00f1634669355d$require$_interopRequireDefault((parcelRequire("Ho9ot")));

var $kSbwP = parcelRequire("kSbwP");
function $2a00f1634669355d$var$ThemeProviderNoVars({ theme: themeInput, ...props }) {
    const scopedTheme = $2a00f1634669355d$var$_identifier.default in themeInput ? themeInput[$2a00f1634669355d$var$_identifier.default] : undefined;
    return /*#__PURE__*/ (0, $kSbwP.jsx)($7i3Am.default, {
        ...props,
        themeId: scopedTheme ? $2a00f1634669355d$var$_identifier.default : undefined,
        theme: scopedTheme || themeInput
    });
}

});
parcelRegister("7i3Am", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54ecfed4f95ef4d7$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");


var $7WGAH = parcelRequire("7WGAH");
var $1aEuo = parcelRequire("1aEuo");

parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");

var $34cvB = parcelRequire("34cvB");

var $1k1dq = parcelRequire("1k1dq");

var $h2Hxn = parcelRequire("h2Hxn");

var $kSbwP = parcelRequire("kSbwP");
'use client';
const $54ecfed4f95ef4d7$var$EMPTY_THEME = {};
function $54ecfed4f95ef4d7$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $8nGP5.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $54ecfed4f95ef4d7$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $34cvB.default)($54ecfed4f95ef4d7$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $1aEuo.default)() || $54ecfed4f95ef4d7$var$EMPTY_THEME;
    const engineTheme = $54ecfed4f95ef4d7$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $54ecfed4f95ef4d7$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $7WGAH.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $jspCa.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $1k1dq.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $h2Hxn.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $54ecfed4f95ef4d7$export$2e2bcd8739ae039 = $54ecfed4f95ef4d7$var$ThemeProvider;

});
parcelRegister("1k1dq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f689a1961a5f1f7$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
'use client';
const $0f689a1961a5f1f7$var$RtlContext = /*#__PURE__*/ $8nGP5.createContext();
function $0f689a1961a5f1f7$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($0f689a1961a5f1f7$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $0f689a1961a5f1f7$export$b2dd014b6c321cb = ()=>{
    const value = $8nGP5.useContext($0f689a1961a5f1f7$var$RtlContext);
    return value ?? false;
};
var $0f689a1961a5f1f7$export$2e2bcd8739ae039 = $0f689a1961a5f1f7$var$RtlProvider;

});

parcelRegister("h2Hxn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c684652bf5734a8b$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");


var $9Blzt = parcelRequire("9Blzt");

var $kSbwP = parcelRequire("kSbwP");
'use client';
const $c684652bf5734a8b$var$PropsContext = /*#__PURE__*/ $8nGP5.createContext(undefined);
function $c684652bf5734a8b$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($c684652bf5734a8b$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $c684652bf5734a8b$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Blzt)))(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Blzt)))(config, props);
    return props;
}
function $c684652bf5734a8b$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $8nGP5.useContext($c684652bf5734a8b$var$PropsContext);
    return $c684652bf5734a8b$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $c684652bf5734a8b$export$2e2bcd8739ae039 = $c684652bf5734a8b$var$DefaultPropsProvider;

});



parcelRegister("bgduR", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $832ba87c1921e610$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $832ba87c1921e610$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CssVarsProvider = void 0;
module.exports.Experimental_CssVarsProvider = $832ba87c1921e610$var$Experimental_CssVarsProvider;
module.exports.useColorScheme = module.exports.getInitColorSchemeScript = void 0;

var $832ba87c1921e610$var$React = $832ba87c1921e610$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $832ba87c1921e610$var$_styleFunctionSx = $832ba87c1921e610$require$_interopRequireDefault((parcelRequire("jNnBr")));

var $2cdCc = parcelRequire("2cdCc");

var $832ba87c1921e610$var$_createTheme = $832ba87c1921e610$require$_interopRequireDefault((parcelRequire("dQ1bf")));

var $832ba87c1921e610$var$_createTypography = $832ba87c1921e610$require$_interopRequireDefault((parcelRequire("64QfU")));

var $832ba87c1921e610$var$_identifier = $832ba87c1921e610$require$_interopRequireDefault((parcelRequire("Ho9ot")));

var $6ghYk = parcelRequire("6ghYk");

var $kSbwP = parcelRequire("kSbwP");
const { CssVarsProvider: $832ba87c1921e610$var$InternalCssVarsProvider, useColorScheme: $832ba87c1921e610$var$useColorScheme, getInitColorSchemeScript: $832ba87c1921e610$var$deprecatedGetInitColorSchemeScript } = (0, $2cdCc.default)({
    themeId: $832ba87c1921e610$var$_identifier.default,
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $832ba87c1921e610$var$_createTheme.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: $6ghYk.defaultConfig.colorSchemeStorageKey,
    modeStorageKey: $6ghYk.defaultConfig.modeStorageKey,
    defaultColorScheme: {
        light: $6ghYk.defaultConfig.defaultLightColorScheme,
        dark: $6ghYk.defaultConfig.defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $832ba87c1921e610$var$_createTypography.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $832ba87c1921e610$var$_styleFunctionSx.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
module.exports.useColorScheme = $832ba87c1921e610$var$useColorScheme;
let $832ba87c1921e610$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $832ba87c1921e610$var$Experimental_CssVarsProvider(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($832ba87c1921e610$var$InternalCssVarsProvider, {
        ...props
    });
}
let $832ba87c1921e610$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $832ba87c1921e610$var$getInitColorSchemeScript = (params)=>{
    if (!$832ba87c1921e610$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $832ba87c1921e610$var$warnedInitScriptOnce = true;
    }
    return $832ba87c1921e610$var$deprecatedGetInitColorSchemeScript(params);
};
/**
 * TODO: remove this export in v7
 * @deprecated
 * The `CssVarsProvider` component has been deprecated and ported into `ThemeProvider`.
 *
 * You should use `ThemeProvider` and `createTheme()` instead:
 *
 * ```diff
 * - import { CssVarsProvider, extendTheme } from '@mui/material/styles';
 * + import { ThemeProvider, createTheme } from '@mui/material/styles';
 *
 * - const theme = extendTheme();
 * + const theme = createTheme({
 * +   cssVariables: true,
 * +   colorSchemes: { light: true, dark: true },
 * + });
 *
 * - <CssVarsProvider theme={theme}>
 * + <ThemeProvider theme={theme}>
 * ```
 *
 * To see the full documentation, check out https://mui.com/material-ui/customization/css-theme-variables/usage/.
 */ module.exports.getInitColorSchemeScript = $832ba87c1921e610$var$getInitColorSchemeScript;
const $832ba87c1921e610$var$CssVarsProvider = module.exports.CssVarsProvider = $832ba87c1921e610$var$InternalCssVarsProvider;

});
parcelRegister("2cdCc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19974373b8f7a062$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");


var $hR4TP = parcelRequire("hR4TP");

var $1aEuo = parcelRequire("1aEuo");

var $jMi8t = parcelRequire("jMi8t");

var $7i3Am = parcelRequire("7i3Am");

var $kcF1X = parcelRequire("kcF1X");

var $a2jCD = parcelRequire("a2jCD");

var $kSbwP = parcelRequire("kSbwP");
'use client';
const $19974373b8f7a062$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $19974373b8f7a062$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $kcF1X.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $kcF1X.DEFAULT_COLOR_SCHEME_STORAGE_KEY), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $8nGP5.createContext(undefined);
    const useColorScheme = ()=>$8nGP5.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $8nGP5.useRef(false);
        const upperTheme = (0, $1aEuo.default)();
        const ctx = $8nGP5.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $8nGP5.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $8nGP5.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $a2jCD.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $8nGP5.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, (/*@__PURE__*/$parcel$interopDefault($jMi8t)))(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $8nGP5.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($19974373b8f7a062$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $8nGP5.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $8nGP5.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $kSbwP.jsxs)($8nGP5.Fragment, {
            children: [
                /*#__PURE__*/ (0, $kSbwP.jsx)((0, $7i3Am.default), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $kSbwP.jsx)((0, $hR4TP.default), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $kSbwP.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $kcF1X.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("kcF1X", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MODE_STORAGE_KEY", function () { return $eb54c17209003124$export$ff0fa3047d11164c; });
$parcel$export(module.exports, "DEFAULT_COLOR_SCHEME_STORAGE_KEY", function () { return $eb54c17209003124$export$665054ea9d94dab9; });
$parcel$export(module.exports, "default", function () { return $eb54c17209003124$export$2e2bcd8739ae039; });
/**
 * Split this component for RSC import
 */ parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");
const $eb54c17209003124$export$ff0fa3047d11164c = 'mode';
const $eb54c17209003124$export$665054ea9d94dab9 = 'color-scheme';
const $eb54c17209003124$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $eb54c17209003124$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $eb54c17209003124$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $eb54c17209003124$export$665054ea9d94dab9, attribute: initialAttribute = $eb54c17209003124$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $kSbwP.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("a2jCD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e94fd16854f0cb$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");

var $kcF1X = parcelRequire("kcF1X");

var $jxujW = parcelRequire("jxujW");
'use client';
function $74e94fd16854f0cb$var$noop() {}
function $74e94fd16854f0cb$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $74e94fd16854f0cb$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $74e94fd16854f0cb$export$3caa7590cc1987bd(state) {
    return $74e94fd16854f0cb$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $74e94fd16854f0cb$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $kcF1X.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: colorSchemeStorageKey = (0, $kcF1X.DEFAULT_COLOR_SCHEME_STORAGE_KEY), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $jxujW.default), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $8nGP5.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $8nGP5.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $8nGP5.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $8nGP5.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $74e94fd16854f0cb$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $8nGP5.useState(noSsr || !isMultiSchemes);
    $8nGP5.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $74e94fd16854f0cb$export$3caa7590cc1987bd(state);
    const setMode = $8nGP5.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $74e94fd16854f0cb$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $8nGP5.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $74e94fd16854f0cb$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $8nGP5.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $8nGP5.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $8nGP5.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $8nGP5.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $74e94fd16854f0cb$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $74e94fd16854f0cb$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $74e94fd16854f0cb$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("jxujW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3989e6fe61205e2$export$2e2bcd8739ae039; });
function $e3989e6fe61205e2$var$noop() {}
const $e3989e6fe61205e2$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $e3989e6fe61205e2$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $e3989e6fe61205e2$export$2e2bcd8739ae039 = $e3989e6fe61205e2$var$localStorageManager;

});



parcelRegister("6ghYk", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $48f22d8e6c00f8e0$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $48f22d8e6c00f8e0$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultConfig = module.exports.default = void 0;

var $48f22d8e6c00f8e0$var$React = $48f22d8e6c00f8e0$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $48f22d8e6c00f8e0$var$_InitColorSchemeScript = $48f22d8e6c00f8e0$require$_interopRequireDefault((parcelRequire("fs46H")));

var $kSbwP = parcelRequire("kSbwP");
const $48f22d8e6c00f8e0$var$defaultConfig = module.exports.defaultConfig = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
var $48f22d8e6c00f8e0$var$InitColorSchemeScript = module.exports.default = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($48f22d8e6c00f8e0$var$_InitColorSchemeScript.default, {
        ...$48f22d8e6c00f8e0$var$defaultConfig,
        ...props
    });
};

});
parcelRegister("fs46H", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b3fca817a616c6aa$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b3fca817a616c6aa$var$_InitColorSchemeScript.default;
    }
});

var $b3fca817a616c6aa$var$_InitColorSchemeScript = $b3fca817a616c6aa$require$_interopRequireDefault((parcelRequire("i7hfB")));

});




parcelRegister("lZ3Sv", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $042153d503bbb037$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $042153d503bbb037$var$makeStyles;

var $042153d503bbb037$var$_formatMuiErrorMessage = $042153d503bbb037$require$_interopRequireDefault((parcelRequire("cCZAW")));
function $042153d503bbb037$var$makeStyles() {
    throw new Error((0, $042153d503bbb037$var$_formatMuiErrorMessage.default)(14));
}

});

parcelRegister("2my3N", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $1b880e856d7c1ec9$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b880e856d7c1ec9$var$withStyles;

var $1b880e856d7c1ec9$var$_formatMuiErrorMessage = $1b880e856d7c1ec9$require$_interopRequireDefault((parcelRequire("cCZAW")));
function $1b880e856d7c1ec9$var$withStyles() {
    throw new Error((0, $1b880e856d7c1ec9$var$_formatMuiErrorMessage.default)(15));
}

});

parcelRegister("dWI9K", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $a272f1a36af5143a$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a272f1a36af5143a$var$withTheme;

var $a272f1a36af5143a$var$_formatMuiErrorMessage = $a272f1a36af5143a$require$_interopRequireDefault((parcelRequire("cCZAW")));
function $a272f1a36af5143a$var$withTheme() {
    throw new Error((0, $a272f1a36af5143a$var$_formatMuiErrorMessage.default)(16));
}

});

parcelRegister("hqQxy", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $cb0d9ec391fd795b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cb0d9ec391fd795b$var$deprecatedExtendTheme;

var $cb0d9ec391fd795b$var$_createThemeWithVars = $cb0d9ec391fd795b$require$_interopRequireDefault((parcelRequire("bODXu")));
let $cb0d9ec391fd795b$var$warnedOnce = false;
function $cb0d9ec391fd795b$var$deprecatedExtendTheme(...args) {
    if (!$cb0d9ec391fd795b$var$warnedOnce) {
        console.warn([
            'MUI: The `experimental_extendTheme` has been stabilized.',
            '',
            "You should use `import { extendTheme } from '@mui/material/styles'`"
        ].join('\n'));
        $cb0d9ec391fd795b$var$warnedOnce = true;
    }
    return (0, $cb0d9ec391fd795b$var$_createThemeWithVars.default)(...args);
}

});

parcelRegister("64RUw", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $46ccef591bd7dd37$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $46ccef591bd7dd37$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $46ccef591bd7dd37$var$_exportNames = {
    collapseClasses: true
};
Object.defineProperty(module.exports, "collapseClasses", {
    enumerable: true,
    get: function() {
        return $46ccef591bd7dd37$var$_collapseClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $46ccef591bd7dd37$var$_Collapse.default;
    }
});

var $46ccef591bd7dd37$var$_Collapse = $46ccef591bd7dd37$require$_interopRequireDefault((parcelRequire("j6fJr")));

var $46ccef591bd7dd37$var$_collapseClasses = $46ccef591bd7dd37$require$_interopRequireWildcard((parcelRequire("i9AfU")));
Object.keys($46ccef591bd7dd37$var$_collapseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($46ccef591bd7dd37$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $46ccef591bd7dd37$var$_collapseClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $46ccef591bd7dd37$var$_collapseClasses[key];
        }
    });
});

});
parcelRegister("j6fJr", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $de7ac7e213fa2144$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $de7ac7e213fa2144$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de7ac7e213fa2144$var$React = $de7ac7e213fa2144$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $de7ac7e213fa2144$var$_clsx = $de7ac7e213fa2144$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $de7ac7e213fa2144$var$_propTypes = $de7ac7e213fa2144$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $4paKp = parcelRequire("4paKp");

var $de7ac7e213fa2144$var$_useTimeout = $de7ac7e213fa2144$require$_interopRequireDefault((parcelRequire("kuuLw")));

var $de7ac7e213fa2144$var$_elementTypeAcceptingRef = $de7ac7e213fa2144$require$_interopRequireDefault((parcelRequire("5kQCz")));

var $de7ac7e213fa2144$var$_composeClasses = $de7ac7e213fa2144$require$_interopRequireDefault((parcelRequire("4F19u")));

var $bvcHB = parcelRequire("bvcHB");

var $de7ac7e213fa2144$var$_memoTheme = $de7ac7e213fa2144$require$_interopRequireDefault((parcelRequire("kTCCA")));

var $eFtkv = parcelRequire("eFtkv");

var $3R9Iy = parcelRequire("3R9Iy");

var $iIang = parcelRequire("iIang");

var $3v6Pw = parcelRequire("3v6Pw");

var $i9AfU = parcelRequire("i9AfU");

var $kSbwP = parcelRequire("kSbwP");
const $de7ac7e213fa2144$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $de7ac7e213fa2144$var$_composeClasses.default)(slots, $i9AfU.getCollapseUtilityClass, classes);
};
const $de7ac7e213fa2144$var$CollapseRoot = (0, $bvcHB.styled)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $de7ac7e213fa2144$var$_memoTheme.default)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $de7ac7e213fa2144$var$CollapseWrapper = (0, $bvcHB.styled)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $de7ac7e213fa2144$var$CollapseWrapperInner = (0, $bvcHB.styled)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $de7ac7e213fa2144$var$Collapse = /*#__PURE__*/ $de7ac7e213fa2144$var$React.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $eFtkv.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = $3R9Iy.duration.standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = $4paKp.default, ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $de7ac7e213fa2144$var$useUtilityClasses(ownerState);
    const theme = (0, $bvcHB.useTheme)();
    const timer = (0, $de7ac7e213fa2144$var$_useTimeout.default)();
    const wrapperRef = $de7ac7e213fa2144$var$React.useRef(null);
    const autoTransitionDuration = $de7ac7e213fa2144$var$React.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $de7ac7e213fa2144$var$React.useRef(null);
    const handleRef = (0, $3v6Pw.useForkRef)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $iIang.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $iIang.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $kSbwP.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>/*#__PURE__*/ (0, $kSbwP.jsx)($de7ac7e213fa2144$var$CollapseRoot, {
                as: component,
                className: (0, $de7ac7e213fa2144$var$_clsx.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: {
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                    ...style
                },
                ref: handleRef,
                ownerState: {
                    ...ownerState,
                    state: state
                },
                ...restChildProps,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)($de7ac7e213fa2144$var$CollapseWrapper, {
                    ownerState: {
                        ...ownerState,
                        state: state
                    },
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $kSbwP.jsx)($de7ac7e213fa2144$var$CollapseWrapperInner, {
                        ownerState: {
                            ...ownerState,
                            state: state
                        },
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            })
    });
});
if ($de7ac7e213fa2144$var$Collapse) $de7ac7e213fa2144$var$Collapse.muiSupportAuto = true;
var $de7ac7e213fa2144$var$_default = module.exports.default = $de7ac7e213fa2144$var$Collapse;

});
parcelRegister("4paKp", function(module, exports) {

$parcel$export(module.exports, "ENTERING", function () { return $3351d5706602a3c5$export$df38205c966be359; });
$parcel$export(module.exports, "ENTERED", function () { return $3351d5706602a3c5$export$78e9e6e3e014d60a; });
$parcel$export(module.exports, "default", function () { return $3351d5706602a3c5$export$2e2bcd8739ae039; });

var $8D9Xw = parcelRequire("8D9Xw");

var $79bU5 = parcelRequire("79bU5");


var $8nGP5 = parcelRequire("8nGP5");

var $fCKK7 = parcelRequire("fCKK7");

var $jvgKe = parcelRequire("jvgKe");


var $41ytQ = parcelRequire("41ytQ");

var $e1rWq = parcelRequire("e1rWq");
var $3351d5706602a3c5$export$bb38bb9a1161268 = 'unmounted';
var $3351d5706602a3c5$export$84cbff306f539230 = 'exited';
var $3351d5706602a3c5$export$df38205c966be359 = 'entering';
var $3351d5706602a3c5$export$78e9e6e3e014d60a = 'entered';
var $3351d5706602a3c5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3351d5706602a3c5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $79bU5.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3351d5706602a3c5$export$84cbff306f539230;
                _this.appearStatus = $3351d5706602a3c5$export$df38205c966be359;
            } else initialStatus = $3351d5706602a3c5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3351d5706602a3c5$export$bb38bb9a1161268;
        else initialStatus = $3351d5706602a3c5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3351d5706602a3c5$export$bb38bb9a1161268) return {
            status: $3351d5706602a3c5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3351d5706602a3c5$export$df38205c966be359 && status !== $3351d5706602a3c5$export$78e9e6e3e014d60a) nextStatus = $3351d5706602a3c5$export$df38205c966be359;
            } else if (status === $3351d5706602a3c5$export$df38205c966be359 || status === $3351d5706602a3c5$export$78e9e6e3e014d60a) nextStatus = $3351d5706602a3c5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3351d5706602a3c5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $e1rWq.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3351d5706602a3c5$export$84cbff306f539230) this.setState({
            status: $3351d5706602a3c5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $jvgKe.default).disabled) {
            this.safeSetState({
                status: $3351d5706602a3c5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3351d5706602a3c5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3351d5706602a3c5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $jvgKe.default).disabled) {
            this.safeSetState({
                status: $3351d5706602a3c5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3351d5706602a3c5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3351d5706602a3c5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3351d5706602a3c5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $8D9Xw.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $41ytQ.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$3351d5706602a3c5$var$Transition.contextType = (0, $41ytQ.default);
$3351d5706602a3c5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3351d5706602a3c5$var$noop() {}
$3351d5706602a3c5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3351d5706602a3c5$var$noop,
    onEntering: $3351d5706602a3c5$var$noop,
    onEntered: $3351d5706602a3c5$var$noop,
    onExit: $3351d5706602a3c5$var$noop,
    onExiting: $3351d5706602a3c5$var$noop,
    onExited: $3351d5706602a3c5$var$noop
};
$3351d5706602a3c5$var$Transition.UNMOUNTED = $3351d5706602a3c5$export$bb38bb9a1161268;
$3351d5706602a3c5$var$Transition.EXITED = $3351d5706602a3c5$export$84cbff306f539230;
$3351d5706602a3c5$var$Transition.ENTERING = $3351d5706602a3c5$export$df38205c966be359;
$3351d5706602a3c5$var$Transition.ENTERED = $3351d5706602a3c5$export$78e9e6e3e014d60a;
$3351d5706602a3c5$var$Transition.EXITING = $3351d5706602a3c5$export$4aacc83d4d59139f;
var $3351d5706602a3c5$export$2e2bcd8739ae039 = $3351d5706602a3c5$var$Transition;

});
parcelRegister("8D9Xw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6489b0e3346855d0$export$2e2bcd8739ae039; });
function $6489b0e3346855d0$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("79bU5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53429b78f989eb39$export$2e2bcd8739ae039; });

var $4xcoB = parcelRequire("4xcoB");
function $53429b78f989eb39$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $4xcoB.default)(t, o);
}

});
parcelRegister("4xcoB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d3dc0b25481873$export$2e2bcd8739ae039; });
function $34d3dc0b25481873$export$2e2bcd8739ae039(t, e) {
    return $34d3dc0b25481873$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $34d3dc0b25481873$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("jvgKe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e32de6b6b7ccf4a6$export$2e2bcd8739ae039; });
var $e32de6b6b7ccf4a6$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("41ytQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ee2008271b8a5e9$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");
var $2ee2008271b8a5e9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createContext(null);

});

parcelRegister("e1rWq", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $a356d5410b88876f$export$7d26bbb1236dafd6; });
var $a356d5410b88876f$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("iIang", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTransitionProps = $d9f46227eaa44a03$var$getTransitionProps;
module.exports.reflow = void 0;
const $d9f46227eaa44a03$var$reflow = (node)=>node.scrollTop;
module.exports.reflow = $d9f46227eaa44a03$var$reflow;
function $d9f46227eaa44a03$var$getTransitionProps(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

});

parcelRegister("i9AfU", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $d37530e06edb4600$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCollapseUtilityClass = $d37530e06edb4600$var$getCollapseUtilityClass;

var $d37530e06edb4600$var$_generateUtilityClasses = $d37530e06edb4600$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $d37530e06edb4600$var$_generateUtilityClass = $d37530e06edb4600$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $d37530e06edb4600$var$getCollapseUtilityClass(slot) {
    return (0, $d37530e06edb4600$var$_generateUtilityClass.default)('MuiCollapse', slot);
}
const $d37530e06edb4600$var$collapseClasses = (0, $d37530e06edb4600$var$_generateUtilityClasses.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $d37530e06edb4600$var$_default = module.exports.default = $d37530e06edb4600$var$collapseClasses;

});



parcelRegister("7qdWX", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $5675c8456f989d23$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $5675c8456f989d23$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5675c8456f989d23$var$_exportNames = {
    checkboxClasses: true
};
Object.defineProperty(module.exports, "checkboxClasses", {
    enumerable: true,
    get: function() {
        return $5675c8456f989d23$var$_checkboxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5675c8456f989d23$var$_Checkbox.default;
    }
});

var $5675c8456f989d23$var$_Checkbox = $5675c8456f989d23$require$_interopRequireDefault((parcelRequire("7JRp6")));

var $5675c8456f989d23$var$_checkboxClasses = $5675c8456f989d23$require$_interopRequireWildcard((parcelRequire("732qP")));
Object.keys($5675c8456f989d23$var$_checkboxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5675c8456f989d23$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5675c8456f989d23$var$_checkboxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5675c8456f989d23$var$_checkboxClasses[key];
        }
    });
});

});
parcelRegister("7JRp6", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $5a26294befa814e8$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $5a26294befa814e8$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a26294befa814e8$var$React = $5a26294befa814e8$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $5a26294befa814e8$var$_propTypes = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $5a26294befa814e8$var$_clsx = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $5a26294befa814e8$var$_composeClasses = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("4F19u")));

var $gLbll = parcelRequire("gLbll");

var $5a26294befa814e8$var$_SwitchBase = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("ezTiz")));

var $5a26294befa814e8$var$_CheckBoxOutlineBlank = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("4UDK4")));

var $5a26294befa814e8$var$_CheckBox = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("7F4Up")));

var $5a26294befa814e8$var$_IndeterminateCheckBox = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("kUM2d")));

var $5a26294befa814e8$var$_capitalize = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("gVVIq")));

var $5a26294befa814e8$var$_rootShouldForwardProp = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("75rPq")));

var $5a26294befa814e8$var$_checkboxClasses = $5a26294befa814e8$require$_interopRequireWildcard((parcelRequire("732qP")));

var $bvcHB = parcelRequire("bvcHB");

var $5a26294befa814e8$var$_memoTheme = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("kTCCA")));

var $5a26294befa814e8$var$_createSimplePaletteValueFilter = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("bJNLl")));

var $eFtkv = parcelRequire("eFtkv");

var $3v6Pw = parcelRequire("3v6Pw");

var $5a26294befa814e8$var$_useSlot = $5a26294befa814e8$require$_interopRequireDefault((parcelRequire("iwCeP")));

var $kSbwP = parcelRequire("kSbwP");
const $5a26294befa814e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $5a26294befa814e8$var$_capitalize.default)(color)}`,
            `size${(0, $5a26294befa814e8$var$_capitalize.default)(size)}`
        ]
    };
    const composedClasses = (0, $5a26294befa814e8$var$_composeClasses.default)(slots, $5a26294befa814e8$var$_checkboxClasses.getCheckboxUtilityClass, classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $5a26294befa814e8$var$CheckboxRoot = (0, $bvcHB.styled)($5a26294befa814e8$var$_SwitchBase.default, {
    shouldForwardProp: (prop)=>(0, $5a26294befa814e8$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $5a26294befa814e8$var$_capitalize.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $5a26294befa814e8$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $5a26294befa814e8$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $gLbll.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $5a26294befa814e8$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $gLbll.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $5a26294befa814e8$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$5a26294befa814e8$var$_checkboxClasses.default.checked}, &.${$5a26294befa814e8$var$_checkboxClasses.default.indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${$5a26294befa814e8$var$_checkboxClasses.default.disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $5a26294befa814e8$var$defaultCheckedIcon = /*#__PURE__*/ (0, $kSbwP.jsx)($5a26294befa814e8$var$_CheckBox.default, {});
const $5a26294befa814e8$var$defaultIcon = /*#__PURE__*/ (0, $kSbwP.jsx)($5a26294befa814e8$var$_CheckBoxOutlineBlank.default, {});
const $5a26294befa814e8$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $kSbwP.jsx)($5a26294befa814e8$var$_IndeterminateCheckBox.default, {});
const $5a26294befa814e8$var$Checkbox = /*#__PURE__*/ $5a26294befa814e8$var$React.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $eFtkv.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $5a26294befa814e8$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $5a26294befa814e8$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $5a26294befa814e8$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $5a26294befa814e8$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $5a26294befa814e8$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $5a26294befa814e8$var$CheckboxRoot,
        className: (0, $5a26294befa814e8$var$_clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $5a26294befa814e8$var$React.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $5a26294befa814e8$var$React.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $3v6Pw.mergeSlotProps)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $5a26294befa814e8$var$_default = module.exports.default = $5a26294befa814e8$var$Checkbox;

});
parcelRegister("ezTiz", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $a9cf3ab041e72dac$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $a9cf3ab041e72dac$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9cf3ab041e72dac$var$React = $a9cf3ab041e72dac$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $a9cf3ab041e72dac$var$_propTypes = $a9cf3ab041e72dac$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $a9cf3ab041e72dac$var$_refType = $a9cf3ab041e72dac$require$_interopRequireDefault((parcelRequire("e4lJB")));

var $a9cf3ab041e72dac$var$_composeClasses = $a9cf3ab041e72dac$require$_interopRequireDefault((parcelRequire("4F19u")));

var $a9cf3ab041e72dac$var$_capitalize = $a9cf3ab041e72dac$require$_interopRequireDefault((parcelRequire("gVVIq")));

var $a9cf3ab041e72dac$var$_rootShouldForwardProp = $a9cf3ab041e72dac$require$_interopRequireDefault((parcelRequire("75rPq")));

var $bvcHB = parcelRequire("bvcHB");

var $a9cf3ab041e72dac$var$_useControlled = $a9cf3ab041e72dac$require$_interopRequireDefault((parcelRequire("8WqeI")));

var $a9cf3ab041e72dac$var$_useFormControl = $a9cf3ab041e72dac$require$_interopRequireDefault((parcelRequire("bC7JU")));

var $a9cf3ab041e72dac$var$_ButtonBase = $a9cf3ab041e72dac$require$_interopRequireDefault((parcelRequire("5GVYm")));

var $2farV = parcelRequire("2farV");

var $a9cf3ab041e72dac$var$_useSlot = $a9cf3ab041e72dac$require$_interopRequireDefault((parcelRequire("iwCeP")));

var $kSbwP = parcelRequire("kSbwP");
const $a9cf3ab041e72dac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $a9cf3ab041e72dac$var$_capitalize.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $a9cf3ab041e72dac$var$_composeClasses.default)(slots, $2farV.getSwitchBaseUtilityClass, classes);
};
const $a9cf3ab041e72dac$var$SwitchBaseRoot = (0, $bvcHB.styled)($a9cf3ab041e72dac$var$_ButtonBase.default)({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $a9cf3ab041e72dac$var$SwitchBaseInput = (0, $bvcHB.styled)('input', {
    shouldForwardProp: $a9cf3ab041e72dac$var$_rootShouldForwardProp.default
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $a9cf3ab041e72dac$var$SwitchBase = /*#__PURE__*/ $a9cf3ab041e72dac$var$React.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $a9cf3ab041e72dac$var$_useControlled.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $a9cf3ab041e72dac$var$_useFormControl.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $a9cf3ab041e72dac$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $a9cf3ab041e72dac$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $a9cf3ab041e72dac$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $a9cf3ab041e72dac$var$_useSlot.default)('input', {
        ref: inputRef,
        elementType: $a9cf3ab041e72dac$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $kSbwP.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $kSbwP.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $a9cf3ab041e72dac$var$_default = module.exports.default = $a9cf3ab041e72dac$var$SwitchBase;

});
parcelRegister("bC7JU", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $87493f32b963fcf4$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $87493f32b963fcf4$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $87493f32b963fcf4$var$useFormControl;

var $87493f32b963fcf4$var$React = $87493f32b963fcf4$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $87493f32b963fcf4$var$_FormControlContext = $87493f32b963fcf4$require$_interopRequireDefault((parcelRequire("3rSUS")));
function $87493f32b963fcf4$var$useFormControl() {
    return $87493f32b963fcf4$var$React.useContext($87493f32b963fcf4$var$_FormControlContext.default);
}

});
parcelRegister("3rSUS", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $282e7dfb80625ef8$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $282e7dfb80625ef8$var$React = $282e7dfb80625ef8$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * @ignore - internal component.
 */ const $282e7dfb80625ef8$var$FormControlContext = /*#__PURE__*/ $282e7dfb80625ef8$var$React.createContext(undefined);
var $282e7dfb80625ef8$var$_default = module.exports.default = $282e7dfb80625ef8$var$FormControlContext;

});


parcelRegister("5GVYm", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $424dd8299abaeab3$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $424dd8299abaeab3$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $424dd8299abaeab3$var$_exportNames = {
    buttonBaseClasses: true,
    touchRippleClasses: true
};
Object.defineProperty(module.exports, "buttonBaseClasses", {
    enumerable: true,
    get: function() {
        return $424dd8299abaeab3$var$_buttonBaseClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $424dd8299abaeab3$var$_ButtonBase.default;
    }
});
Object.defineProperty(module.exports, "touchRippleClasses", {
    enumerable: true,
    get: function() {
        return $424dd8299abaeab3$var$_touchRippleClasses.default;
    }
});

var $424dd8299abaeab3$var$_ButtonBase = $424dd8299abaeab3$require$_interopRequireDefault((parcelRequire("5PM5z")));

var $424dd8299abaeab3$var$_buttonBaseClasses = $424dd8299abaeab3$require$_interopRequireWildcard((parcelRequire("dD1O7")));
Object.keys($424dd8299abaeab3$var$_buttonBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($424dd8299abaeab3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $424dd8299abaeab3$var$_buttonBaseClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $424dd8299abaeab3$var$_buttonBaseClasses[key];
        }
    });
});

var $424dd8299abaeab3$var$_touchRippleClasses = $424dd8299abaeab3$require$_interopRequireWildcard((parcelRequire("9SKWn")));
Object.keys($424dd8299abaeab3$var$_touchRippleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($424dd8299abaeab3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $424dd8299abaeab3$var$_touchRippleClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $424dd8299abaeab3$var$_touchRippleClasses[key];
        }
    });
});

});
parcelRegister("5PM5z", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $43f7049f75db134f$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $43f7049f75db134f$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.ButtonBaseRoot = void 0;

var $43f7049f75db134f$var$React = $43f7049f75db134f$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $43f7049f75db134f$var$_propTypes = $43f7049f75db134f$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $43f7049f75db134f$var$_clsx = $43f7049f75db134f$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $43f7049f75db134f$var$_refType = $43f7049f75db134f$require$_interopRequireDefault((parcelRequire("e4lJB")));

var $43f7049f75db134f$var$_elementTypeAcceptingRef = $43f7049f75db134f$require$_interopRequireDefault((parcelRequire("5kQCz")));

var $43f7049f75db134f$var$_composeClasses = $43f7049f75db134f$require$_interopRequireDefault((parcelRequire("4F19u")));

var $43f7049f75db134f$var$_isFocusVisible = $43f7049f75db134f$require$_interopRequireDefault((parcelRequire("jLOre")));

var $bvcHB = parcelRequire("bvcHB");

var $eFtkv = parcelRequire("eFtkv");

var $43f7049f75db134f$var$_useForkRef = $43f7049f75db134f$require$_interopRequireDefault((parcelRequire("iZq8x")));

var $43f7049f75db134f$var$_useEventCallback = $43f7049f75db134f$require$_interopRequireDefault((parcelRequire("6hPuj")));

var $43f7049f75db134f$var$_useLazyRipple = $43f7049f75db134f$require$_interopRequireDefault((parcelRequire("JBL16")));

var $43f7049f75db134f$var$_TouchRipple = $43f7049f75db134f$require$_interopRequireDefault((parcelRequire("eV0Lb")));

var $43f7049f75db134f$var$_buttonBaseClasses = $43f7049f75db134f$require$_interopRequireWildcard((parcelRequire("dD1O7")));

var $kSbwP = parcelRequire("kSbwP");
const $43f7049f75db134f$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $43f7049f75db134f$var$_composeClasses.default)(slots, $43f7049f75db134f$var$_buttonBaseClasses.getButtonBaseUtilityClass, classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $43f7049f75db134f$var$ButtonBaseRoot = module.exports.ButtonBaseRoot = (0, $bvcHB.styled)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${$43f7049f75db134f$var$_buttonBaseClasses.default.disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $43f7049f75db134f$var$ButtonBase = /*#__PURE__*/ $43f7049f75db134f$var$React.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $eFtkv.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $43f7049f75db134f$var$React.useRef(null);
    const ripple = (0, $43f7049f75db134f$var$_useLazyRipple.default)();
    const handleRippleRef = (0, $43f7049f75db134f$var$_useForkRef.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $43f7049f75db134f$var$React.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $43f7049f75db134f$var$React.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $43f7049f75db134f$var$React.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $43f7049f75db134f$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $43f7049f75db134f$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $43f7049f75db134f$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $43f7049f75db134f$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $43f7049f75db134f$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $43f7049f75db134f$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $43f7049f75db134f$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $43f7049f75db134f$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $43f7049f75db134f$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $43f7049f75db134f$var$_isFocusVisible.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $43f7049f75db134f$var$_useEventCallback.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $43f7049f75db134f$var$_isFocusVisible.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $43f7049f75db134f$var$_useEventCallback.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $43f7049f75db134f$var$_useEventCallback.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $43f7049f75db134f$var$_useForkRef.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $43f7049f75db134f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $kSbwP.jsxs)($43f7049f75db134f$var$ButtonBaseRoot, {
        as: ComponentProp,
        className: (0, $43f7049f75db134f$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $kSbwP.jsx)($43f7049f75db134f$var$_TouchRipple.default, {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $43f7049f75db134f$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $43f7049f75db134f$var$_useEventCallback.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $43f7049f75db134f$var$_default = module.exports.default = $43f7049f75db134f$var$ButtonBase;

});
parcelRegister("JBL16", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $08917de76814e7ba$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $08917de76814e7ba$var$_useLazyRipple.default;
    }
});

var $08917de76814e7ba$var$_useLazyRipple = $08917de76814e7ba$require$_interopRequireDefault((parcelRequire("ga75c")));

});
parcelRegister("ga75c", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $bc431302761b5da3$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $bc431302761b5da3$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LazyRipple = void 0;
module.exports.default = $bc431302761b5da3$var$useLazyRipple;

var $bc431302761b5da3$var$React = $bc431302761b5da3$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $bc431302761b5da3$var$_useLazyRef = $bc431302761b5da3$require$_interopRequireDefault((parcelRequire("3MjpJ")));
/**
 * Lazy initialization container for the Ripple instance. This improves
 * performance by delaying mounting the ripple until it's needed.
 */ class $bc431302761b5da3$var$LazyRipple {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $bc431302761b5da3$var$LazyRipple();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $bc431302761b5da3$var$_useLazyRef.default)($bc431302761b5da3$var$LazyRipple.create).current;
        const [shouldMount, setShouldMount] = $bc431302761b5da3$var$React.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $bc431302761b5da3$var$React.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $bc431302761b5da3$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
module.exports.LazyRipple = $bc431302761b5da3$var$LazyRipple;
function $bc431302761b5da3$var$useLazyRipple() {
    return $bc431302761b5da3$var$LazyRipple.use();
}
function $bc431302761b5da3$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});


parcelRegister("eV0Lb", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $adc6fa79cd77578a$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $adc6fa79cd77578a$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.TouchRippleRoot = module.exports.TouchRippleRipple = module.exports.DELAY_RIPPLE = void 0;

var $adc6fa79cd77578a$var$React = $adc6fa79cd77578a$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $adc6fa79cd77578a$var$_propTypes = $adc6fa79cd77578a$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $b7Gxh = parcelRequire("b7Gxh");

var $adc6fa79cd77578a$var$_clsx = $adc6fa79cd77578a$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $adc6fa79cd77578a$var$_useTimeout = $adc6fa79cd77578a$require$_interopRequireDefault((parcelRequire("kuuLw")));

var $bvcHB = parcelRequire("bvcHB");

var $eFtkv = parcelRequire("eFtkv");

var $adc6fa79cd77578a$var$_Ripple = $adc6fa79cd77578a$require$_interopRequireDefault((parcelRequire("7KwRU")));

var $adc6fa79cd77578a$var$_touchRippleClasses = $adc6fa79cd77578a$require$_interopRequireDefault((parcelRequire("9SKWn")));

var $kSbwP = parcelRequire("kSbwP");
const $adc6fa79cd77578a$var$DURATION = 550;
const $adc6fa79cd77578a$var$DELAY_RIPPLE = module.exports.DELAY_RIPPLE = 80;
const $adc6fa79cd77578a$var$enterKeyframe = (0, $bvcHB.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $adc6fa79cd77578a$var$exitKeyframe = (0, $bvcHB.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $adc6fa79cd77578a$var$pulsateKeyframe = (0, $bvcHB.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $adc6fa79cd77578a$var$TouchRippleRoot = module.exports.TouchRippleRoot = (0, $bvcHB.styled)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const $adc6fa79cd77578a$var$TouchRippleRipple = module.exports.TouchRippleRipple = (0, $bvcHB.styled)($adc6fa79cd77578a$var$_Ripple.default, {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${$adc6fa79cd77578a$var$_touchRippleClasses.default.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$adc6fa79cd77578a$var$enterKeyframe};
    animation-duration: ${$adc6fa79cd77578a$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${$adc6fa79cd77578a$var$_touchRippleClasses.default.ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${$adc6fa79cd77578a$var$_touchRippleClasses.default.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${$adc6fa79cd77578a$var$_touchRippleClasses.default.childLeaving} {
    opacity: 0;
    animation-name: ${$adc6fa79cd77578a$var$exitKeyframe};
    animation-duration: ${$adc6fa79cd77578a$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${$adc6fa79cd77578a$var$_touchRippleClasses.default.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$adc6fa79cd77578a$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $adc6fa79cd77578a$var$TouchRipple = /*#__PURE__*/ $adc6fa79cd77578a$var$React.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $eFtkv.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $adc6fa79cd77578a$var$React.useState([]);
    const nextKey = $adc6fa79cd77578a$var$React.useRef(0);
    const rippleCallback = $adc6fa79cd77578a$var$React.useRef(null);
    $adc6fa79cd77578a$var$React.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $adc6fa79cd77578a$var$React.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $adc6fa79cd77578a$var$_useTimeout.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $adc6fa79cd77578a$var$React.useRef(null);
    const container = $adc6fa79cd77578a$var$React.useRef(null);
    const startCommit = $adc6fa79cd77578a$var$React.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $kSbwP.jsx)($adc6fa79cd77578a$var$TouchRippleRipple, {
                    classes: {
                        ripple: (0, $adc6fa79cd77578a$var$_clsx.default)(classes.ripple, $adc6fa79cd77578a$var$_touchRippleClasses.default.ripple),
                        rippleVisible: (0, $adc6fa79cd77578a$var$_clsx.default)(classes.rippleVisible, $adc6fa79cd77578a$var$_touchRippleClasses.default.rippleVisible),
                        ripplePulsate: (0, $adc6fa79cd77578a$var$_clsx.default)(classes.ripplePulsate, $adc6fa79cd77578a$var$_touchRippleClasses.default.ripplePulsate),
                        child: (0, $adc6fa79cd77578a$var$_clsx.default)(classes.child, $adc6fa79cd77578a$var$_touchRippleClasses.default.child),
                        childLeaving: (0, $adc6fa79cd77578a$var$_clsx.default)(classes.childLeaving, $adc6fa79cd77578a$var$_touchRippleClasses.default.childLeaving),
                        childPulsate: (0, $adc6fa79cd77578a$var$_clsx.default)(classes.childPulsate, $adc6fa79cd77578a$var$_touchRippleClasses.default.childPulsate)
                    },
                    timeout: $adc6fa79cd77578a$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $adc6fa79cd77578a$var$React.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($adc6fa79cd77578a$var$DELAY_RIPPLE, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $adc6fa79cd77578a$var$React.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $adc6fa79cd77578a$var$React.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $adc6fa79cd77578a$var$React.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($adc6fa79cd77578a$var$TouchRippleRoot, {
        className: (0, $adc6fa79cd77578a$var$_clsx.default)($adc6fa79cd77578a$var$_touchRippleClasses.default.root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)($b7Gxh.default, {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $adc6fa79cd77578a$var$_default = module.exports.default = $adc6fa79cd77578a$var$TouchRipple;

});
parcelRegister("b7Gxh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $819157dd7c621c38$export$2e2bcd8739ae039; });

var $8D9Xw = parcelRequire("8D9Xw");

var $1TGTA = parcelRequire("1TGTA");

var $l5AdR = parcelRequire("l5AdR");

var $79bU5 = parcelRequire("79bU5");


var $8nGP5 = parcelRequire("8nGP5");

var $41ytQ = parcelRequire("41ytQ");

var $jovsd = parcelRequire("jovsd");
var $819157dd7c621c38$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $819157dd7c621c38$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $819157dd7c621c38$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $79bU5.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $l5AdR.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $jovsd.getInitialChildMapping)(nextProps, handleExited) : (0, $jovsd.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $jovsd.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $1TGTA.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $8D9Xw.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $819157dd7c621c38$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $41ytQ.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $41ytQ.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$819157dd7c621c38$var$TransitionGroup.propTypes = {};
$819157dd7c621c38$var$TransitionGroup.defaultProps = $819157dd7c621c38$var$defaultProps;
var $819157dd7c621c38$export$2e2bcd8739ae039 = $819157dd7c621c38$var$TransitionGroup;

});
parcelRegister("l5AdR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5a629a998bf01e6$export$2e2bcd8739ae039; });
function $f5a629a998bf01e6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("jovsd", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $e1e8a85036f16937$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $e1e8a85036f16937$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $e1e8a85036f16937$export$36fd1af28d383ec0; });

var $8nGP5 = parcelRequire("8nGP5");
function $e1e8a85036f16937$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $8nGP5.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $8nGP5.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $e1e8a85036f16937$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $e1e8a85036f16937$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $e1e8a85036f16937$export$fa71e2345c31d7a2(props, onExited) {
    return $e1e8a85036f16937$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $8nGP5.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $e1e8a85036f16937$var$getProp(child, 'appear', props),
            enter: $e1e8a85036f16937$var$getProp(child, 'enter', props),
            exit: $e1e8a85036f16937$var$getProp(child, 'exit', props)
        });
    });
}
function $e1e8a85036f16937$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $e1e8a85036f16937$export$bbc8a025727ea824(nextProps.children);
    var children = $e1e8a85036f16937$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $8nGP5.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $8nGP5.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $8nGP5.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $e1e8a85036f16937$var$getProp(child, 'exit', nextProps),
            enter: $e1e8a85036f16937$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $8nGP5.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $8nGP5.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $8nGP5.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $e1e8a85036f16937$var$getProp(child, 'exit', nextProps),
            enter: $e1e8a85036f16937$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("7KwRU", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $5a46534808463da0$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $5a46534808463da0$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a46534808463da0$var$React = $5a46534808463da0$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $5a46534808463da0$var$_propTypes = $5a46534808463da0$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $5a46534808463da0$var$_clsx = $5a46534808463da0$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ function $5a46534808463da0$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $5a46534808463da0$var$React.useState(false);
    const rippleClassName = (0, $5a46534808463da0$var$_clsx.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $5a46534808463da0$var$_clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $5a46534808463da0$var$React.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)("span", {
            className: childClassName
        })
    });
}
var $5a46534808463da0$var$_default = module.exports.default = $5a46534808463da0$var$Ripple;

});

parcelRegister("9SKWn", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $731d919ee4d8accb$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTouchRippleUtilityClass = $731d919ee4d8accb$var$getTouchRippleUtilityClass;

var $731d919ee4d8accb$var$_generateUtilityClasses = $731d919ee4d8accb$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $731d919ee4d8accb$var$_generateUtilityClass = $731d919ee4d8accb$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $731d919ee4d8accb$var$getTouchRippleUtilityClass(slot) {
    return (0, $731d919ee4d8accb$var$_generateUtilityClass.default)('MuiTouchRipple', slot);
}
const $731d919ee4d8accb$var$touchRippleClasses = (0, $731d919ee4d8accb$var$_generateUtilityClasses.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $731d919ee4d8accb$var$_default = module.exports.default = $731d919ee4d8accb$var$touchRippleClasses;

});


parcelRegister("dD1O7", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9ec051c6add16d52$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getButtonBaseUtilityClass = $9ec051c6add16d52$var$getButtonBaseUtilityClass;

var $9ec051c6add16d52$var$_generateUtilityClasses = $9ec051c6add16d52$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $9ec051c6add16d52$var$_generateUtilityClass = $9ec051c6add16d52$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $9ec051c6add16d52$var$getButtonBaseUtilityClass(slot) {
    return (0, $9ec051c6add16d52$var$_generateUtilityClass.default)('MuiButtonBase', slot);
}
const $9ec051c6add16d52$var$buttonBaseClasses = (0, $9ec051c6add16d52$var$_generateUtilityClasses.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $9ec051c6add16d52$var$_default = module.exports.default = $9ec051c6add16d52$var$buttonBaseClasses;

});



parcelRegister("2farV", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $1a251689615bc6c4$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSwitchBaseUtilityClass = $1a251689615bc6c4$var$getSwitchBaseUtilityClass;

var $1a251689615bc6c4$var$_generateUtilityClasses = $1a251689615bc6c4$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $1a251689615bc6c4$var$_generateUtilityClass = $1a251689615bc6c4$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $1a251689615bc6c4$var$getSwitchBaseUtilityClass(slot) {
    return (0, $1a251689615bc6c4$var$_generateUtilityClass.default)('PrivateSwitchBase', slot);
}
const $1a251689615bc6c4$var$switchBaseClasses = (0, $1a251689615bc6c4$var$_generateUtilityClasses.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $1a251689615bc6c4$var$_default = module.exports.default = $1a251689615bc6c4$var$switchBaseClasses;

});

parcelRegister("iwCeP", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $d7c8e06f2b02a4d6$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d7c8e06f2b02a4d6$var$useSlot;

var $d7c8e06f2b02a4d6$var$_useForkRef = $d7c8e06f2b02a4d6$require$_interopRequireDefault((parcelRequire("7uWLa")));

var $d7c8e06f2b02a4d6$var$_appendOwnerState = $d7c8e06f2b02a4d6$require$_interopRequireDefault((parcelRequire("1UjvS")));

var $d7c8e06f2b02a4d6$var$_resolveComponentProps = $d7c8e06f2b02a4d6$require$_interopRequireDefault((parcelRequire("iselN")));

var $d7c8e06f2b02a4d6$var$_mergeSlotProps = $d7c8e06f2b02a4d6$require$_interopRequireDefault((parcelRequire("43DfG")));
/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */ function $d7c8e06f2b02a4d6$var$useSlot(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $d7c8e06f2b02a4d6$var$_resolveComponentProps.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $d7c8e06f2b02a4d6$var$_mergeSlotProps.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $d7c8e06f2b02a4d6$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $d7c8e06f2b02a4d6$var$_appendOwnerState.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});
parcelRegister("1UjvS", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $163a284c3f5d55a5$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $163a284c3f5d55a5$var$_appendOwnerState.default;
    }
});

var $163a284c3f5d55a5$var$_appendOwnerState = $163a284c3f5d55a5$require$_interopRequireDefault((parcelRequire("3B0Xs")));

});
parcelRegister("3B0Xs", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $29e5920e3cf1be8d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29e5920e3cf1be8d$var$_isHostComponent = $29e5920e3cf1be8d$require$_interopRequireDefault((parcelRequire("3c7cF")));
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $29e5920e3cf1be8d$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $29e5920e3cf1be8d$var$_isHostComponent.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $29e5920e3cf1be8d$var$_default = module.exports.default = $29e5920e3cf1be8d$var$appendOwnerState;

});
parcelRegister("3c7cF", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $25381481a59a6d62$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $25381481a59a6d62$var$_isHostComponent.default;
    }
});

var $25381481a59a6d62$var$_isHostComponent = $25381481a59a6d62$require$_interopRequireDefault((parcelRequire("aZi4K")));

});
parcelRegister("aZi4K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7ffd9f576736edcf$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7ffd9f576736edcf$var$_default = module.exports.default = $7ffd9f576736edcf$var$isHostComponent;

});




parcelRegister("iselN", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $d6f5f9398014fd74$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d6f5f9398014fd74$var$_resolveComponentProps.default;
    }
});

var $d6f5f9398014fd74$var$_resolveComponentProps = $d6f5f9398014fd74$require$_interopRequireDefault((parcelRequire("gxVIh")));

});
parcelRegister("gxVIh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $c0bc7f11c44e42cd$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $c0bc7f11c44e42cd$var$_default = module.exports.default = $c0bc7f11c44e42cd$var$resolveComponentProps;

});


parcelRegister("43DfG", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $2f45e3d9fa07f54e$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2f45e3d9fa07f54e$var$_mergeSlotProps.default;
    }
});

var $2f45e3d9fa07f54e$var$_mergeSlotProps = $2f45e3d9fa07f54e$require$_interopRequireDefault((parcelRequire("lnM7e")));

});
parcelRegister("lnM7e", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f91111b6d20a7b45$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f91111b6d20a7b45$var$_clsx = $f91111b6d20a7b45$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $f91111b6d20a7b45$var$_extractEventHandlers = $f91111b6d20a7b45$require$_interopRequireDefault((parcelRequire("9ds9N")));

var $f91111b6d20a7b45$var$_omitEventHandlers = $f91111b6d20a7b45$require$_interopRequireDefault((parcelRequire("4RRML")));
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $f91111b6d20a7b45$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $f91111b6d20a7b45$var$_clsx.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f91111b6d20a7b45$var$_extractEventHandlers.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $f91111b6d20a7b45$var$_omitEventHandlers.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $f91111b6d20a7b45$var$_omitEventHandlers.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $f91111b6d20a7b45$var$_clsx.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $f91111b6d20a7b45$var$_default = module.exports.default = $f91111b6d20a7b45$var$mergeSlotProps;

});
parcelRegister("9ds9N", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $6b5b2b583a762705$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6b5b2b583a762705$var$_extractEventHandlers.default;
    }
});

var $6b5b2b583a762705$var$_extractEventHandlers = $6b5b2b583a762705$require$_interopRequireDefault((parcelRequire("iTrGK")));

});
parcelRegister("iTrGK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $dc12d768c76d3df9$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $dc12d768c76d3df9$var$_default = module.exports.default = $dc12d768c76d3df9$var$extractEventHandlers;

});


parcelRegister("4RRML", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $38b5d55d2d06e1f4$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $38b5d55d2d06e1f4$var$_omitEventHandlers.default;
    }
});

var $38b5d55d2d06e1f4$var$_omitEventHandlers = $38b5d55d2d06e1f4$require$_interopRequireDefault((parcelRequire("264pz")));

});
parcelRegister("264pz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $186f904e6bde06ca$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $186f904e6bde06ca$var$_default = module.exports.default = $186f904e6bde06ca$var$omitEventHandlers;

});






parcelRegister("4UDK4", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $393b384f817d6523$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $393b384f817d6523$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $393b384f817d6523$var$React = $393b384f817d6523$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $393b384f817d6523$var$_createSvgIcon = $393b384f817d6523$require$_interopRequireDefault((parcelRequire("ehak1")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ var $393b384f817d6523$var$_default = module.exports.default = (0, $393b384f817d6523$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("7F4Up", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $59402b84e4a1c660$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $59402b84e4a1c660$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $59402b84e4a1c660$var$React = $59402b84e4a1c660$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $59402b84e4a1c660$var$_createSvgIcon = $59402b84e4a1c660$require$_interopRequireDefault((parcelRequire("ehak1")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ var $59402b84e4a1c660$var$_default = module.exports.default = (0, $59402b84e4a1c660$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("kUM2d", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $f39e4c4905d7c4fa$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $f39e4c4905d7c4fa$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f39e4c4905d7c4fa$var$React = $f39e4c4905d7c4fa$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $f39e4c4905d7c4fa$var$_createSvgIcon = $f39e4c4905d7c4fa$require$_interopRequireDefault((parcelRequire("ehak1")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ var $f39e4c4905d7c4fa$var$_default = module.exports.default = (0, $f39e4c4905d7c4fa$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});

parcelRegister("732qP", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $521ab31e4b940223$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCheckboxUtilityClass = $521ab31e4b940223$var$getCheckboxUtilityClass;

var $521ab31e4b940223$var$_generateUtilityClasses = $521ab31e4b940223$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $521ab31e4b940223$var$_generateUtilityClass = $521ab31e4b940223$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $521ab31e4b940223$var$getCheckboxUtilityClass(slot) {
    return (0, $521ab31e4b940223$var$_generateUtilityClass.default)('MuiCheckbox', slot);
}
const $521ab31e4b940223$var$checkboxClasses = (0, $521ab31e4b940223$var$_generateUtilityClasses.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $521ab31e4b940223$var$_default = module.exports.default = $521ab31e4b940223$var$checkboxClasses;

});



parcelRegister("k3QMn", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $e9ad0755039c3a1c$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e9ad0755039c3a1c$var$_useSlotProps.default;
    }
});

var $e9ad0755039c3a1c$var$_useSlotProps = $e9ad0755039c3a1c$require$_interopRequireDefault((parcelRequire("9cQXs")));

});
parcelRegister("9cQXs", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $6b3e506ce459d8ac$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b3e506ce459d8ac$var$_useForkRef = $6b3e506ce459d8ac$require$_interopRequireDefault((parcelRequire("7uWLa")));

var $6b3e506ce459d8ac$var$_appendOwnerState = $6b3e506ce459d8ac$require$_interopRequireDefault((parcelRequire("1UjvS")));

var $6b3e506ce459d8ac$var$_mergeSlotProps = $6b3e506ce459d8ac$require$_interopRequireDefault((parcelRequire("43DfG")));

var $6b3e506ce459d8ac$var$_resolveComponentProps = $6b3e506ce459d8ac$require$_interopRequireDefault((parcelRequire("iselN")));
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $6b3e506ce459d8ac$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $6b3e506ce459d8ac$var$_resolveComponentProps.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $6b3e506ce459d8ac$var$_mergeSlotProps.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $6b3e506ce459d8ac$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $6b3e506ce459d8ac$var$_appendOwnerState.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $6b3e506ce459d8ac$var$_default = module.exports.default = $6b3e506ce459d8ac$var$useSlotProps;

});


parcelRegister("htUof", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $cba0e2ff011e01c1$export$bf730a2d8bf68b42; }, function (v) { return $cba0e2ff011e01c1$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cba0e2ff011e01c1$export$bf730a2d8bf68b42;
"use strict";

var $8nGP5 = parcelRequire("8nGP5");
function $cba0e2ff011e01c1$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $cba0e2ff011e01c1$var$objectIs = "function" === typeof Object.is ? Object.is : $cba0e2ff011e01c1$var$is, $cba0e2ff011e01c1$var$useSyncExternalStore = $8nGP5.useSyncExternalStore, $cba0e2ff011e01c1$var$useRef = $8nGP5.useRef, $cba0e2ff011e01c1$var$useEffect = $8nGP5.useEffect, $cba0e2ff011e01c1$var$useMemo = $8nGP5.useMemo, $cba0e2ff011e01c1$var$useDebugValue = $8nGP5.useDebugValue;
$cba0e2ff011e01c1$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $cba0e2ff011e01c1$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $cba0e2ff011e01c1$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($cba0e2ff011e01c1$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $cba0e2ff011e01c1$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $cba0e2ff011e01c1$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $cba0e2ff011e01c1$var$useDebugValue(value);
    return value;
};

});

parcelRegister("jn4Is", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $e1a3d2d2d1adab91$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $e1a3d2d2d1adab91$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e1a3d2d2d1adab91$var$_exportNames = {
    alertClasses: true
};
Object.defineProperty(module.exports, "alertClasses", {
    enumerable: true,
    get: function() {
        return $e1a3d2d2d1adab91$var$_alertClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e1a3d2d2d1adab91$var$_Alert.default;
    }
});

var $e1a3d2d2d1adab91$var$_Alert = $e1a3d2d2d1adab91$require$_interopRequireDefault((parcelRequire("kWZ5b")));

var $e1a3d2d2d1adab91$var$_alertClasses = $e1a3d2d2d1adab91$require$_interopRequireWildcard((parcelRequire("j1TEr")));
Object.keys($e1a3d2d2d1adab91$var$_alertClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e1a3d2d2d1adab91$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e1a3d2d2d1adab91$var$_alertClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e1a3d2d2d1adab91$var$_alertClasses[key];
        }
    });
});

});
parcelRegister("kWZ5b", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $f4089b2ae31f25c7$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $f4089b2ae31f25c7$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4089b2ae31f25c7$var$React = $f4089b2ae31f25c7$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $f4089b2ae31f25c7$var$_propTypes = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $f4089b2ae31f25c7$var$_clsx = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $f4089b2ae31f25c7$var$_composeClasses = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("4F19u")));

var $gLbll = parcelRequire("gLbll");

var $bvcHB = parcelRequire("bvcHB");

var $f4089b2ae31f25c7$var$_memoTheme = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("kTCCA")));

var $eFtkv = parcelRequire("eFtkv");

var $f4089b2ae31f25c7$var$_useSlot = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("iwCeP")));

var $f4089b2ae31f25c7$var$_capitalize = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("gVVIq")));

var $f4089b2ae31f25c7$var$_createSimplePaletteValueFilter = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("bJNLl")));

var $f4089b2ae31f25c7$var$_Paper = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("H8TAs")));

var $f4089b2ae31f25c7$var$_alertClasses = $f4089b2ae31f25c7$require$_interopRequireWildcard((parcelRequire("j1TEr")));

var $f4089b2ae31f25c7$var$_IconButton = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("dpiol")));

var $f4089b2ae31f25c7$var$_SuccessOutlined = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("8LtJG")));

var $f4089b2ae31f25c7$var$_ReportProblemOutlined = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("1GPm8")));

var $f4089b2ae31f25c7$var$_ErrorOutline = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("4HSxj")));

var $f4089b2ae31f25c7$var$_InfoOutlined = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("hiOXa")));

var $f4089b2ae31f25c7$var$_Close = $f4089b2ae31f25c7$require$_interopRequireDefault((parcelRequire("3sz1C")));

var $kSbwP = parcelRequire("kSbwP");
const $f4089b2ae31f25c7$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $f4089b2ae31f25c7$var$_capitalize.default)(color || severity)}`,
            `${variant}${(0, $f4089b2ae31f25c7$var$_capitalize.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $f4089b2ae31f25c7$var$_composeClasses.default)(slots, $f4089b2ae31f25c7$var$_alertClasses.getAlertUtilityClass, classes);
};
const $f4089b2ae31f25c7$var$AlertRoot = (0, $bvcHB.styled)($f4089b2ae31f25c7$var$_Paper.default, {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $f4089b2ae31f25c7$var$_capitalize.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $f4089b2ae31f25c7$var$_memoTheme.default)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? $gLbll.darken : $gLbll.lighten;
    const getBackgroundColor = theme.palette.mode === 'light' ? $gLbll.lighten : $gLbll.darken;
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $f4089b2ae31f25c7$var$_createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${$f4089b2ae31f25c7$var$_alertClasses.default.icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $f4089b2ae31f25c7$var$_createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${$f4089b2ae31f25c7$var$_alertClasses.default.icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $f4089b2ae31f25c7$var$_createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $f4089b2ae31f25c7$var$AlertIcon = (0, $bvcHB.styled)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $f4089b2ae31f25c7$var$AlertMessage = (0, $bvcHB.styled)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $f4089b2ae31f25c7$var$AlertAction = (0, $bvcHB.styled)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $f4089b2ae31f25c7$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $kSbwP.jsx)($f4089b2ae31f25c7$var$_SuccessOutlined.default, {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $kSbwP.jsx)($f4089b2ae31f25c7$var$_ReportProblemOutlined.default, {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $kSbwP.jsx)($f4089b2ae31f25c7$var$_ErrorOutline.default, {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $kSbwP.jsx)($f4089b2ae31f25c7$var$_InfoOutlined.default, {
        fontSize: "inherit"
    })
};
const $f4089b2ae31f25c7$var$Alert = /*#__PURE__*/ $f4089b2ae31f25c7$var$React.forwardRef(function Alert(inProps, ref) {
    const props = (0, $eFtkv.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $f4089b2ae31f25c7$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $f4089b2ae31f25c7$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $f4089b2ae31f25c7$var$_useSlot.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $f4089b2ae31f25c7$var$_clsx.default)(classes.root, className),
        elementType: $f4089b2ae31f25c7$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $f4089b2ae31f25c7$var$_useSlot.default)('icon', {
        className: classes.icon,
        elementType: $f4089b2ae31f25c7$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $f4089b2ae31f25c7$var$_useSlot.default)('message', {
        className: classes.message,
        elementType: $f4089b2ae31f25c7$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $f4089b2ae31f25c7$var$_useSlot.default)('action', {
        className: classes.action,
        elementType: $f4089b2ae31f25c7$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $f4089b2ae31f25c7$var$_useSlot.default)('closeButton', {
        elementType: $f4089b2ae31f25c7$var$_IconButton.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $f4089b2ae31f25c7$var$_useSlot.default)('closeIcon', {
        elementType: $f4089b2ae31f25c7$var$_Close.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $kSbwP.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $kSbwP.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || $f4089b2ae31f25c7$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $kSbwP.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $kSbwP.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $kSbwP.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $kSbwP.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $f4089b2ae31f25c7$var$_default = module.exports.default = $f4089b2ae31f25c7$var$Alert;

});
parcelRegister("H8TAs", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $081aeabda44a57ee$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $081aeabda44a57ee$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $081aeabda44a57ee$var$_exportNames = {
    paperClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $081aeabda44a57ee$var$_Paper.default;
    }
});
Object.defineProperty(module.exports, "paperClasses", {
    enumerable: true,
    get: function() {
        return $081aeabda44a57ee$var$_paperClasses.default;
    }
});

var $081aeabda44a57ee$var$_Paper = $081aeabda44a57ee$require$_interopRequireDefault((parcelRequire("c00fi")));

var $081aeabda44a57ee$var$_paperClasses = $081aeabda44a57ee$require$_interopRequireWildcard((parcelRequire("b8dZ0")));
Object.keys($081aeabda44a57ee$var$_paperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($081aeabda44a57ee$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $081aeabda44a57ee$var$_paperClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $081aeabda44a57ee$var$_paperClasses[key];
        }
    });
});

});
parcelRegister("c00fi", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $8bc5acefb53f6f6d$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $8bc5acefb53f6f6d$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bc5acefb53f6f6d$var$React = $8bc5acefb53f6f6d$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $8bc5acefb53f6f6d$var$_propTypes = $8bc5acefb53f6f6d$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $8bc5acefb53f6f6d$var$_clsx = $8bc5acefb53f6f6d$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $8bc5acefb53f6f6d$var$_integerPropType = $8bc5acefb53f6f6d$require$_interopRequireDefault((parcelRequire("hIi4V")));

var $8bc5acefb53f6f6d$var$_chainPropTypes = $8bc5acefb53f6f6d$require$_interopRequireDefault((parcelRequire("3wrUq")));

var $8bc5acefb53f6f6d$var$_composeClasses = $8bc5acefb53f6f6d$require$_interopRequireDefault((parcelRequire("4F19u")));

var $gLbll = parcelRequire("gLbll");

var $bvcHB = parcelRequire("bvcHB");

var $8bc5acefb53f6f6d$var$_memoTheme = $8bc5acefb53f6f6d$require$_interopRequireDefault((parcelRequire("kTCCA")));

var $eFtkv = parcelRequire("eFtkv");

var $8bc5acefb53f6f6d$var$_getOverlayAlpha = $8bc5acefb53f6f6d$require$_interopRequireDefault((parcelRequire("7cuWF")));

var $b8dZ0 = parcelRequire("b8dZ0");

var $kSbwP = parcelRequire("kSbwP");
const $8bc5acefb53f6f6d$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $8bc5acefb53f6f6d$var$_composeClasses.default)(slots, $b8dZ0.getPaperUtilityClass, classes);
};
const $8bc5acefb53f6f6d$var$PaperRoot = (0, $bvcHB.styled)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $8bc5acefb53f6f6d$var$_memoTheme.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $8bc5acefb53f6f6d$var$Paper = /*#__PURE__*/ $8bc5acefb53f6f6d$var$React.forwardRef(function Paper(inProps, ref) {
    const props = (0, $eFtkv.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $bvcHB.useTheme)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $8bc5acefb53f6f6d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($8bc5acefb53f6f6d$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $8bc5acefb53f6f6d$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $gLbll.alpha)('#fff', (0, $8bc5acefb53f6f6d$var$_getOverlayAlpha.default)(elevation))}, ${(0, $gLbll.alpha)('#fff', (0, $8bc5acefb53f6f6d$var$_getOverlayAlpha.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $8bc5acefb53f6f6d$var$_default = module.exports.default = $8bc5acefb53f6f6d$var$Paper;

});
parcelRegister("hIi4V", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $ce5491b583a5ff8c$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ce5491b583a5ff8c$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ce5491b583a5ff8c$var$_integerPropType.default;
    }
});

var $ce5491b583a5ff8c$var$_integerPropType = $ce5491b583a5ff8c$require$_interopRequireWildcard((parcelRequire("hZJmQ")));
Object.keys($ce5491b583a5ff8c$var$_integerPropType).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ce5491b583a5ff8c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ce5491b583a5ff8c$var$_integerPropType[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ce5491b583a5ff8c$var$_integerPropType[key];
        }
    });
});

});
parcelRegister("hZJmQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTypeByValue = $d19b5337aa37206f$var$getTypeByValue;
function $d19b5337aa37206f$var$getTypeByValue(value) {
    const valueType = typeof value;
    switch(valueType){
        case 'number':
            if (Number.isNaN(value)) return 'NaN';
            if (!Number.isFinite(value)) return 'Infinity';
            if (value !== Math.floor(value)) return 'float';
            return 'number';
        case 'object':
            if (value === null) return 'null';
            return value.constructor.name;
        default:
            return valueType;
    }
}
function $d19b5337aa37206f$var$requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !Number.isInteger(propValue)) {
        const propType = $d19b5337aa37206f$var$getTypeByValue(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function $d19b5337aa37206f$var$validator(props, propName, ...other) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return $d19b5337aa37206f$var$requiredInteger(props, propName, ...other);
}
function $d19b5337aa37206f$var$validatorNoop() {
    return null;
}
$d19b5337aa37206f$var$validator.isRequired = $d19b5337aa37206f$var$requiredInteger;
$d19b5337aa37206f$var$validatorNoop.isRequired = $d19b5337aa37206f$var$validatorNoop;
var $d19b5337aa37206f$var$_default = module.exports.default = $d19b5337aa37206f$var$validatorNoop;

});


parcelRegister("b8dZ0", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $81ab49ca5666a200$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPaperUtilityClass = $81ab49ca5666a200$var$getPaperUtilityClass;

var $81ab49ca5666a200$var$_generateUtilityClasses = $81ab49ca5666a200$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $81ab49ca5666a200$var$_generateUtilityClass = $81ab49ca5666a200$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $81ab49ca5666a200$var$getPaperUtilityClass(slot) {
    return (0, $81ab49ca5666a200$var$_generateUtilityClass.default)('MuiPaper', slot);
}
const $81ab49ca5666a200$var$paperClasses = (0, $81ab49ca5666a200$var$_generateUtilityClasses.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $81ab49ca5666a200$var$_default = module.exports.default = $81ab49ca5666a200$var$paperClasses;

});



parcelRegister("j1TEr", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $dda9477ea4200fb6$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAlertUtilityClass = $dda9477ea4200fb6$var$getAlertUtilityClass;

var $dda9477ea4200fb6$var$_generateUtilityClasses = $dda9477ea4200fb6$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $dda9477ea4200fb6$var$_generateUtilityClass = $dda9477ea4200fb6$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $dda9477ea4200fb6$var$getAlertUtilityClass(slot) {
    return (0, $dda9477ea4200fb6$var$_generateUtilityClass.default)('MuiAlert', slot);
}
const $dda9477ea4200fb6$var$alertClasses = (0, $dda9477ea4200fb6$var$_generateUtilityClasses.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $dda9477ea4200fb6$var$_default = module.exports.default = $dda9477ea4200fb6$var$alertClasses;

});

parcelRegister("dpiol", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $9c2be0587fd39924$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $9c2be0587fd39924$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9c2be0587fd39924$var$_exportNames = {
    iconButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9c2be0587fd39924$var$_IconButton.default;
    }
});
Object.defineProperty(module.exports, "iconButtonClasses", {
    enumerable: true,
    get: function() {
        return $9c2be0587fd39924$var$_iconButtonClasses.default;
    }
});

var $9c2be0587fd39924$var$_IconButton = $9c2be0587fd39924$require$_interopRequireDefault((parcelRequire("8mbqy")));

var $9c2be0587fd39924$var$_iconButtonClasses = $9c2be0587fd39924$require$_interopRequireWildcard((parcelRequire("cXJOV")));
Object.keys($9c2be0587fd39924$var$_iconButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9c2be0587fd39924$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9c2be0587fd39924$var$_iconButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9c2be0587fd39924$var$_iconButtonClasses[key];
        }
    });
});

});
parcelRegister("8mbqy", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $61593e072c75bb2c$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $61593e072c75bb2c$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61593e072c75bb2c$var$React = $61593e072c75bb2c$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $61593e072c75bb2c$var$_propTypes = $61593e072c75bb2c$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $61593e072c75bb2c$var$_clsx = $61593e072c75bb2c$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $61593e072c75bb2c$var$_chainPropTypes = $61593e072c75bb2c$require$_interopRequireDefault((parcelRequire("3wrUq")));

var $61593e072c75bb2c$var$_composeClasses = $61593e072c75bb2c$require$_interopRequireDefault((parcelRequire("4F19u")));

var $gLbll = parcelRequire("gLbll");

var $3v6Pw = parcelRequire("3v6Pw");

var $bvcHB = parcelRequire("bvcHB");

var $61593e072c75bb2c$var$_memoTheme = $61593e072c75bb2c$require$_interopRequireDefault((parcelRequire("kTCCA")));

var $61593e072c75bb2c$var$_createSimplePaletteValueFilter = $61593e072c75bb2c$require$_interopRequireDefault((parcelRequire("bJNLl")));

var $eFtkv = parcelRequire("eFtkv");

var $61593e072c75bb2c$var$_ButtonBase = $61593e072c75bb2c$require$_interopRequireDefault((parcelRequire("5GVYm")));

var $61593e072c75bb2c$var$_CircularProgress = $61593e072c75bb2c$require$_interopRequireDefault((parcelRequire("37mRE")));

var $61593e072c75bb2c$var$_capitalize = $61593e072c75bb2c$require$_interopRequireDefault((parcelRequire("gVVIq")));

var $61593e072c75bb2c$var$_iconButtonClasses = $61593e072c75bb2c$require$_interopRequireWildcard((parcelRequire("cXJOV")));

var $kSbwP = parcelRequire("kSbwP");
const $61593e072c75bb2c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $61593e072c75bb2c$var$_capitalize.default)(color)}`,
            edge && `edge${(0, $61593e072c75bb2c$var$_capitalize.default)(edge)}`,
            `size${(0, $61593e072c75bb2c$var$_capitalize.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $61593e072c75bb2c$var$_composeClasses.default)(slots, $61593e072c75bb2c$var$_iconButtonClasses.getIconButtonUtilityClass, classes);
};
const $61593e072c75bb2c$var$IconButtonRoot = (0, $bvcHB.styled)($61593e072c75bb2c$var$_ButtonBase.default, {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $61593e072c75bb2c$var$_capitalize.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $61593e072c75bb2c$var$_capitalize.default)(ownerState.edge)}`],
            styles[`size${(0, $61593e072c75bb2c$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, $61593e072c75bb2c$var$_memoTheme.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $gLbll.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $61593e072c75bb2c$var$_memoTheme.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $61593e072c75bb2c$var$_createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $61593e072c75bb2c$var$_createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $gLbll.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${$61593e072c75bb2c$var$_iconButtonClasses.default.disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${$61593e072c75bb2c$var$_iconButtonClasses.default.loading}`]: {
            color: 'transparent'
        }
    })));
const $61593e072c75bb2c$var$IconButtonLoadingIndicator = (0, $bvcHB.styled)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $61593e072c75bb2c$var$IconButton = /*#__PURE__*/ $61593e072c75bb2c$var$React.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $eFtkv.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $3v6Pw.unstable_useId)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $kSbwP.jsx)($61593e072c75bb2c$var$_CircularProgress.default, {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $61593e072c75bb2c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $kSbwP.jsxs)($61593e072c75bb2c$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $61593e072c75bb2c$var$_clsx.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $kSbwP.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $kSbwP.jsx)($61593e072c75bb2c$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $61593e072c75bb2c$var$_default = module.exports.default = $61593e072c75bb2c$var$IconButton;

});
parcelRegister("cXJOV", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $96fe89ae6b23dbec$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getIconButtonUtilityClass = $96fe89ae6b23dbec$var$getIconButtonUtilityClass;

var $96fe89ae6b23dbec$var$_generateUtilityClasses = $96fe89ae6b23dbec$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $96fe89ae6b23dbec$var$_generateUtilityClass = $96fe89ae6b23dbec$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $96fe89ae6b23dbec$var$getIconButtonUtilityClass(slot) {
    return (0, $96fe89ae6b23dbec$var$_generateUtilityClass.default)('MuiIconButton', slot);
}
const $96fe89ae6b23dbec$var$iconButtonClasses = (0, $96fe89ae6b23dbec$var$_generateUtilityClasses.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $96fe89ae6b23dbec$var$_default = module.exports.default = $96fe89ae6b23dbec$var$iconButtonClasses;

});



parcelRegister("8LtJG", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $6619c76ed6de3385$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $6619c76ed6de3385$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6619c76ed6de3385$var$React = $6619c76ed6de3385$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $6619c76ed6de3385$var$_createSvgIcon = $6619c76ed6de3385$require$_interopRequireDefault((parcelRequire("ehak1")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ var $6619c76ed6de3385$var$_default = module.exports.default = (0, $6619c76ed6de3385$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

});

parcelRegister("1GPm8", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $13b18cf1925d06ed$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $13b18cf1925d06ed$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13b18cf1925d06ed$var$React = $13b18cf1925d06ed$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $13b18cf1925d06ed$var$_createSvgIcon = $13b18cf1925d06ed$require$_interopRequireDefault((parcelRequire("ehak1")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ var $13b18cf1925d06ed$var$_default = module.exports.default = (0, $13b18cf1925d06ed$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

});

parcelRegister("4HSxj", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $36d57b54212d9c3f$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $36d57b54212d9c3f$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36d57b54212d9c3f$var$React = $36d57b54212d9c3f$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $36d57b54212d9c3f$var$_createSvgIcon = $36d57b54212d9c3f$require$_interopRequireDefault((parcelRequire("ehak1")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ var $36d57b54212d9c3f$var$_default = module.exports.default = (0, $36d57b54212d9c3f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

});

parcelRegister("hiOXa", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $c98ba45c916bc219$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $c98ba45c916bc219$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c98ba45c916bc219$var$React = $c98ba45c916bc219$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $c98ba45c916bc219$var$_createSvgIcon = $c98ba45c916bc219$require$_interopRequireDefault((parcelRequire("ehak1")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ var $c98ba45c916bc219$var$_default = module.exports.default = (0, $c98ba45c916bc219$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

});

parcelRegister("3sz1C", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $284f27dd27964242$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $284f27dd27964242$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $284f27dd27964242$var$React = $284f27dd27964242$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $284f27dd27964242$var$_createSvgIcon = $284f27dd27964242$require$_interopRequireDefault((parcelRequire("ehak1")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */ var $284f27dd27964242$var$_default = module.exports.default = (0, $284f27dd27964242$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});



parcelRegister("by9f1", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $868a09d3c443ea90$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $868a09d3c443ea90$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $868a09d3c443ea90$var$_exportNames = {
    typographyClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $868a09d3c443ea90$var$_Typography.default;
    }
});
Object.defineProperty(module.exports, "typographyClasses", {
    enumerable: true,
    get: function() {
        return $868a09d3c443ea90$var$_typographyClasses.default;
    }
});

var $868a09d3c443ea90$var$_Typography = $868a09d3c443ea90$require$_interopRequireDefault((parcelRequire("eU0kL")));

var $868a09d3c443ea90$var$_typographyClasses = $868a09d3c443ea90$require$_interopRequireWildcard((parcelRequire("dAen8")));
Object.keys($868a09d3c443ea90$var$_typographyClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($868a09d3c443ea90$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $868a09d3c443ea90$var$_typographyClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $868a09d3c443ea90$var$_typographyClasses[key];
        }
    });
});

});
parcelRegister("eU0kL", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $ad968df37b7841a6$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $ad968df37b7841a6$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.TypographyRoot = void 0;

var $ad968df37b7841a6$var$React = $ad968df37b7841a6$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $ad968df37b7841a6$var$_propTypes = $ad968df37b7841a6$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $ad968df37b7841a6$var$_clsx = $ad968df37b7841a6$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $ad968df37b7841a6$var$_composeClasses = $ad968df37b7841a6$require$_interopRequireDefault((parcelRequire("4F19u")));

var $bvcHB = parcelRequire("bvcHB");

var $ad968df37b7841a6$var$_memoTheme = $ad968df37b7841a6$require$_interopRequireDefault((parcelRequire("kTCCA")));

var $eFtkv = parcelRequire("eFtkv");

var $ad968df37b7841a6$var$_capitalize = $ad968df37b7841a6$require$_interopRequireDefault((parcelRequire("gVVIq")));

var $ad968df37b7841a6$var$_createSimplePaletteValueFilter = $ad968df37b7841a6$require$_interopRequireDefault((parcelRequire("bJNLl")));

var $dAen8 = parcelRequire("dAen8");

var $kSbwP = parcelRequire("kSbwP");
const $ad968df37b7841a6$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $ad968df37b7841a6$var$extendSxProp = (0, $bvcHB.internal_createExtendSxProp)();
const $ad968df37b7841a6$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $ad968df37b7841a6$var$_capitalize.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $ad968df37b7841a6$var$_composeClasses.default)(slots, $dAen8.getTypographyUtilityClass, classes);
};
const $ad968df37b7841a6$var$TypographyRoot = module.exports.TypographyRoot = (0, $bvcHB.styled)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $ad968df37b7841a6$var$_capitalize.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $ad968df37b7841a6$var$_memoTheme.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $ad968df37b7841a6$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $ad968df37b7841a6$var$_capitalize.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $ad968df37b7841a6$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $ad968df37b7841a6$var$Typography = /*#__PURE__*/ $ad968df37b7841a6$var$React.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $eFtkv.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$ad968df37b7841a6$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $ad968df37b7841a6$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $ad968df37b7841a6$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $ad968df37b7841a6$var$defaultVariantMapping[variant]) || 'span';
    const classes = $ad968df37b7841a6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($ad968df37b7841a6$var$TypographyRoot, {
        as: Component,
        ref: ref,
        className: (0, $ad968df37b7841a6$var$_clsx.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $ad968df37b7841a6$var$_default = module.exports.default = $ad968df37b7841a6$var$Typography;

});
parcelRegister("dAen8", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9e39c92d73a5fc42$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTypographyUtilityClass = $9e39c92d73a5fc42$var$getTypographyUtilityClass;

var $9e39c92d73a5fc42$var$_generateUtilityClasses = $9e39c92d73a5fc42$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $9e39c92d73a5fc42$var$_generateUtilityClass = $9e39c92d73a5fc42$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $9e39c92d73a5fc42$var$getTypographyUtilityClass(slot) {
    return (0, $9e39c92d73a5fc42$var$_generateUtilityClass.default)('MuiTypography', slot);
}
const $9e39c92d73a5fc42$var$typographyClasses = (0, $9e39c92d73a5fc42$var$_generateUtilityClasses.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $9e39c92d73a5fc42$var$_default = module.exports.default = $9e39c92d73a5fc42$var$typographyClasses;

});



var $d448fdab65d58853$exports = {};

(parcelRequire("ebB0J")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"ej7d9\",\"index.5390efc4.js\",\"A4M98\",\"logo-1752058808881-blue.e8a70c5a.svg\",\"c6KuT\",\"bird_logo.4a767494.png\",\"9PF1W\",\"new_logo.d9372fce.png\",\"lgEa1\",\"modal.ebd08c8d.png\",\"7kLiz\",\"hand-edit-icon.0cb414cb.svg\",\"bDhEv\",\"concentration.b319fb3b.png\",\"jXhar\",\"ebitda_performance.2268d70b.png\",\"gNDcM\",\"fcf_profile.36dff1fa.png\",\"ik67M\",\"market_size_and_performance.92da13ac.png\",\"7kGkR\",\"other.e3eaa9be.png\",\"dcrTg\",\"overview.1c4cc915.png\",\"aDbQE\",\"revenue_performance.db5c8439.png\",\"kFESX\",\"concentration.7d597663.svg\",\"da3Qr\",\"ebitda_performance.d2e303be.svg\",\"g073H\",\"fcf_profile.4ba5e38a.svg\",\"lKkC8\",\"market_size_and_performance.fd9c2e5e.svg\",\"9jVWK\",\"other.80576dc7.svg\",\"5fFqa\",\"overview.a1b80899.svg\",\"eNLYq\",\"revenue_performance.82890e81.svg\",\"9uQZU\",\"industry_icon.30d7df5b.svg\",\"bZYkh\",\"we_like.0a7707e9.svg\",\"iUGZL\",\"key_risks.daa734dd.svg\",\"aVVPK\",\"due_diligence.ad039bf5.svg\",\"6BHBM\",\"dragIcon.481a3c08.svg\",\"6CWZy\",\"chatgpt.2e7eab8d.svg\",\"5s7Jn\",\"sparkle.c93894f3.svg\",\"UJ8DQ\",\"task-checkmark.2563595b.svg\",\"fXrsI\",\"task-circle.45172d54.svg\",\"kW3uK\",\"task-locked.25b44aaa.svg\",\"92wfQ\",\"task-paused.9c823c90.svg\",\"iZthi\",\"task-working.b9e6de61.svg\",\"6KzTD\",\"back2.7df4d33c.svg\",\"cYxqS\",\"checkmark.2563595b.svg\",\"7j9Ne\",\"circle.45172d54.svg\",\"khWTK\",\"paused.9c823c90.svg\",\"eqtIO\",\"working.b9e6de61.svg\"]"));


var $kSbwP = parcelRequire("kSbwP");
var $de9addb89ca41b61$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $de9addb89ca41b61$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $de9addb89ca41b61$var$InstrumentedPromise$1)) throw new TypeError('Cannot call a class as a function');
    var promise = new $de9addb89ca41b61$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $de9addb89ca41b61$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $de9addb89ca41b61$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $de9addb89ca41b61$var$InstrumentedPromise$1.prototype;
    return promise;
};
$de9addb89ca41b61$var$InstrumentedPromise$1.__proto__ = $de9addb89ca41b61$var$OriginalPromise;
$de9addb89ca41b61$var$InstrumentedPromise$1.prototype.__proto__ = $de9addb89ca41b61$var$OriginalPromise.prototype;
$de9addb89ca41b61$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $de9addb89ca41b61$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $de9addb89ca41b61$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent('Event');
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent('unhandledrejection', false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $de9addb89ca41b61$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === 'undefined';
}
function $de9addb89ca41b61$export$cea1c58a6db52bca() {
    Promise = $de9addb89ca41b61$var$InstrumentedPromise$1;
}
function $de9addb89ca41b61$export$dfb5619354ba860() {
    if ($de9addb89ca41b61$export$baf72085f5fb4df()) $de9addb89ca41b61$export$cea1c58a6db52bca();
}
var $de9addb89ca41b61$export$2e2bcd8739ae039 = $de9addb89ca41b61$var$InstrumentedPromise$1;



var $T5IcR = parcelRequire("T5IcR");
var $d87212bfbb9d55bf$export$882461b6382ed46c;
var $d87212bfbb9d55bf$export$757ceba2d55c277e;
'use strict';

var $fCKK7 = parcelRequire("fCKK7");
var $d87212bfbb9d55bf$var$i;
$d87212bfbb9d55bf$export$882461b6382ed46c = $fCKK7.createRoot;
$d87212bfbb9d55bf$export$757ceba2d55c277e = $fCKK7.hydrateRoot;


var $66fd588cfa718c83$exports = {};
$66fd588cfa718c83$exports = JSON.parse("{\"overview\":{\"sectionName\":\"Overview\",\"section_worth\":0,\"rules\":[{\"field\":\"industry\",\"check\":\"none\"},{\"field\":\"industrySubType\",\"check\":\"none\"},{\"field\":\"company_ceo\",\"check\":\"none\"},{\"field\":\"year_founded\",\"check\":\"none\"},{\"field\":\"last_full_fiscal_year_reported\",\"check\":\"none\"}]},\"revenue_performance\":{\"sectionName\":\"Revenue Performance\",\"section_worth\":25,\"rules\":[{\"field\":\"revenue_latest\",\"check\":\"none\"},{\"field\":\"organic_cagr_N_years\",\"check\":\"range\",\"dataPick\":\"biggest_key_with_value\",\"range\":[-0.01,0.1]},{\"field\":\"projected_organic_cagr_N_years\",\"check\":\"range\",\"dataPick\":\"biggest_key_with_value\",\"range\":[-0.01,0.1]},{\"field\":\"projected_organic_cagr_N_years_minus_tam_growth\",\"check\":\"range\",\"range\":[-0.05,0.05]},{\"field\":\"gross_retention\",\"check\":\"range\",\"range\":[0,0.98]},{\"field\":\"net_retention\",\"check\":\"range\",\"range\":[0,120]},{\"field\":\"recurring_revenue_summary\",\"check\":\"boolean\"}]},\"ebitda_performance\":{\"sectionName\":\"Margins & Profitability\",\"section_worth\":25,\"rules\":[{\"field\":\"extended_selected_ebitda\",\"check\":\"none\"},{\"field\":\"adj_ebitda\",\"check\":\"greater_than\",\"threshold\":20,\"range\":[10,30]},{\"field\":\"adj_ebitda_margin\",\"check\":\"range\",\"range\":[0,0.25]},{\"field\":\"gross_profit_margin\",\"check\":\"range\",\"range\":[0.4,0.8]},{\"field\":\"adj_ebitda_margin_trend\",\"check\":\"range\",\"range\":[-0.1,0.1]},{\"field\":\"ebitda_magnatitude_adjustment\",\"check\":\"range\",\"inverse_score\":true,\"range\":[0.05,0.5]}]},\"market_size_and_performance\":{\"sectionName\":\"Market Size and Performance\",\"section_worth\":25,\"rules\":[{\"field\":\"total_addressable_market\",\"check\":\"range\",\"range\":[0,5]},{\"field\":\"historical_market_growth\",\"check\":\"range\",\"range\":[0,10]},{\"field\":\"projected_market_growth\",\"check\":\"range\",\"range\":[0,10]}]},\"fcf_profile\":{\"sectionName\":\"FCF Profile\",\"section_worth\":25,\"rules\":[{\"field\":\"nwc_as_percent_of_revenue\",\"check\":\"range\",\"range\":[-0.1,0.3],\"inverse_score\":true},{\"field\":\"free_cash_flow_conversion\",\"check\":\"range\",\"range\":[0.25,0.95]},{\"field\":\"total_capex_by_rev\",\"check\":\"range\",\"range\":[0.01,0.3],\"inverse_score\":true}]},\"concentration\":{\"sectionName\":\"Concentration\",\"section_worth\":25,\"rules\":[]},\"other\":{\"sectionName\":\"Other\",\"section_worth\":25,\"rules\":[]}}");


var $5825dfeb0ec6f258$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($5825dfeb0ec6f258$export$7debb50ef11d5e0b || ($5825dfeb0ec6f258$export$7debb50ef11d5e0b = {}));
var $5825dfeb0ec6f258$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($5825dfeb0ec6f258$export$4aa2142c225fd5c7 || ($5825dfeb0ec6f258$export$4aa2142c225fd5c7 = {}));
const $5825dfeb0ec6f258$export$5716da67bfaa244d = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $5825dfeb0ec6f258$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined;
        case "string":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $5825dfeb0ec6f258$export$5716da67bfaa244d.nan : $5825dfeb0ec6f258$export$5716da67bfaa244d.number;
        case "boolean":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.boolean;
        case "function":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.function;
        case "bigint":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $5825dfeb0ec6f258$export$5716da67bfaa244d.array;
            if (data === null) return $5825dfeb0ec6f258$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $5825dfeb0ec6f258$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $5825dfeb0ec6f258$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $5825dfeb0ec6f258$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $5825dfeb0ec6f258$export$5716da67bfaa244d.date;
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.object;
        default:
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.unknown;
    }
};
const $5825dfeb0ec6f258$export$5ba560653e4a1035 = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $5825dfeb0ec6f258$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $5825dfeb0ec6f258$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $5825dfeb0ec6f258$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $5825dfeb0ec6f258$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$5825dfeb0ec6f258$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $5825dfeb0ec6f258$export$f98dac4b251ab333(issues);
    return error;
};
const $5825dfeb0ec6f258$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $5825dfeb0ec6f258$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$5825dfeb0ec6f258$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$5825dfeb0ec6f258$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$5825dfeb0ec6f258$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $5825dfeb0ec6f258$var$overrideErrorMap = $5825dfeb0ec6f258$export$341b0b6e0a6f5099;
function $5825dfeb0ec6f258$export$1097a8289cfd22d7(map) {
    $5825dfeb0ec6f258$var$overrideErrorMap = map;
}
function $5825dfeb0ec6f258$export$32f27c719778d4c4() {
    return $5825dfeb0ec6f258$var$overrideErrorMap;
}
const $5825dfeb0ec6f258$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $5825dfeb0ec6f258$export$1526d2e05f74572 = [];
function $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $5825dfeb0ec6f258$export$32f27c719778d4c4();
    const issue = $5825dfeb0ec6f258$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $5825dfeb0ec6f258$export$341b0b6e0a6f5099 ? undefined : $5825dfeb0ec6f258$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $5825dfeb0ec6f258$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $5825dfeb0ec6f258$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $5825dfeb0ec6f258$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $5825dfeb0ec6f258$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $5825dfeb0ec6f258$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $5825dfeb0ec6f258$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $5825dfeb0ec6f258$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $5825dfeb0ec6f258$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5825dfeb0ec6f258$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $5825dfeb0ec6f258$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($5825dfeb0ec6f258$var$errorUtil || ($5825dfeb0ec6f258$var$errorUtil = {}));
var $5825dfeb0ec6f258$var$_ZodEnum_cache, $5825dfeb0ec6f258$var$_ZodNativeEnum_cache;
class $5825dfeb0ec6f258$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $5825dfeb0ec6f258$var$handleResult = (ctx, result)=>{
    if ($5825dfeb0ec6f258$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $5825dfeb0ec6f258$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $5825dfeb0ec6f258$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $5825dfeb0ec6f258$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($5825dfeb0ec6f258$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $5825dfeb0ec6f258$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return $5825dfeb0ec6f258$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>$5825dfeb0ec6f258$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($5825dfeb0ec6f258$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $5825dfeb0ec6f258$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $5825dfeb0ec6f258$export$a60af00cc0ce2582({
            schema: this,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $5825dfeb0ec6f258$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $5825dfeb0ec6f258$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $5825dfeb0ec6f258$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $5825dfeb0ec6f258$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $5825dfeb0ec6f258$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $5825dfeb0ec6f258$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $5825dfeb0ec6f258$export$a60af00cc0ce2582({
            ...$5825dfeb0ec6f258$var$processCreateParams(this._def),
            schema: this,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $5825dfeb0ec6f258$export$bb19b37874861e7e({
            ...$5825dfeb0ec6f258$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $5825dfeb0ec6f258$export$66b0c798a395271f({
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$5825dfeb0ec6f258$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $5825dfeb0ec6f258$export$75a44ec6249ac76b({
            ...$5825dfeb0ec6f258$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $5825dfeb0ec6f258$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $5825dfeb0ec6f258$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $5825dfeb0ec6f258$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $5825dfeb0ec6f258$var$cuid2Regex = /^[0-9a-z]+$/;
const $5825dfeb0ec6f258$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $5825dfeb0ec6f258$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $5825dfeb0ec6f258$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $5825dfeb0ec6f258$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $5825dfeb0ec6f258$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $5825dfeb0ec6f258$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $5825dfeb0ec6f258$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $5825dfeb0ec6f258$var$emojiRegex;
// faster, simpler, safer
const $5825dfeb0ec6f258$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $5825dfeb0ec6f258$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $5825dfeb0ec6f258$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $5825dfeb0ec6f258$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $5825dfeb0ec6f258$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $5825dfeb0ec6f258$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $5825dfeb0ec6f258$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $5825dfeb0ec6f258$var$dateRegex = new RegExp(`^${$5825dfeb0ec6f258$var$dateRegexSource}$`);
function $5825dfeb0ec6f258$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $5825dfeb0ec6f258$var$timeRegex(args) {
    return new RegExp(`^${$5825dfeb0ec6f258$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $5825dfeb0ec6f258$export$a4b563879add27a(args) {
    let regex = `${$5825dfeb0ec6f258$var$dateRegexSource}T${$5825dfeb0ec6f258$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $5825dfeb0ec6f258$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $5825dfeb0ec6f258$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $5825dfeb0ec6f258$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $5825dfeb0ec6f258$var$isValidJWT(jwt, alg) {
    if (!$5825dfeb0ec6f258$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if (!decoded.typ || !decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch (_a) {
        return false;
    }
}
function $5825dfeb0ec6f258$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $5825dfeb0ec6f258$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $5825dfeb0ec6f258$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $5825dfeb0ec6f258$export$1230eb29b8d3b502 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const status = new $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$5825dfeb0ec6f258$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$5825dfeb0ec6f258$var$emojiRegex) $5825dfeb0ec6f258$var$emojiRegex = new RegExp($5825dfeb0ec6f258$var$_emojiRegex, "u");
                if (!$5825dfeb0ec6f258$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$5825dfeb0ec6f258$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$5825dfeb0ec6f258$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$5825dfeb0ec6f258$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$5825dfeb0ec6f258$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$5825dfeb0ec6f258$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $5825dfeb0ec6f258$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $5825dfeb0ec6f258$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $5825dfeb0ec6f258$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$5825dfeb0ec6f258$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$5825dfeb0ec6f258$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$5825dfeb0ec6f258$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "jwt",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$5825dfeb0ec6f258$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "cidr",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$5825dfeb0ec6f258$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$5825dfeb0ec6f258$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "base64url",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $5825dfeb0ec6f258$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, $5825dfeb0ec6f258$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $5825dfeb0ec6f258$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $5825dfeb0ec6f258$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $5825dfeb0ec6f258$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$5825dfeb0ec6f258$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $5825dfeb0ec6f258$export$1230eb29b8d3b502({
        checks: [],
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $5825dfeb0ec6f258$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $5825dfeb0ec6f258$export$5b070a55c0c43e09 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$5825dfeb0ec6f258$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($5825dfeb0ec6f258$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $5825dfeb0ec6f258$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $5825dfeb0ec6f258$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $5825dfeb0ec6f258$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$5825dfeb0ec6f258$export$5b070a55c0c43e09.create = (params)=>{
    return new $5825dfeb0ec6f258$export$5b070a55c0c43e09({
        checks: [],
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$67d741fd70ff98f4 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch (_a) {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
            code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
            expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.bigint,
            received: ctx.parsedType
        });
        return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $5825dfeb0ec6f258$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $5825dfeb0ec6f258$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$5825dfeb0ec6f258$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $5825dfeb0ec6f258$export$67d741fd70ff98f4({
        checks: [],
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$723d146f80596191 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$723d146f80596191.create = (params)=>{
    return new $5825dfeb0ec6f258$export$723d146f80596191({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$e974be33bdc55521 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_date
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const status = new $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $5825dfeb0ec6f258$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$5825dfeb0ec6f258$export$e974be33bdc55521.create = (params)=>{
    return new $5825dfeb0ec6f258$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodDate,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$bcc3b40f6b638044 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$bcc3b40f6b638044.create = (params)=>{
    return new $5825dfeb0ec6f258$export$bcc3b40f6b638044({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodSymbol,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$4e780e961c30340d extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$4e780e961c30340d.create = (params)=>{
    return new $5825dfeb0ec6f258$export$4e780e961c30340d({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodUndefined,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$a96281f914484f2d extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$a96281f914484f2d.create = (params)=>{
    return new $5825dfeb0ec6f258$export$a96281f914484f2d({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNull,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$b9d1edb536b4e4eb extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $5825dfeb0ec6f258$export$b9d1edb536b4e4eb({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodAny,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$ef3b1bb1630977ae extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$ef3b1bb1630977ae.create = (params)=>{
    return new $5825dfeb0ec6f258$export$ef3b1bb1630977ae({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodUnknown,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$1e576a20c3ce9fb5 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
            code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
            expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
    }
}
$5825dfeb0ec6f258$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $5825dfeb0ec6f258$export$1e576a20c3ce9fb5({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNever,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$7d39f5df85f21031 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$7d39f5df85f21031.create = (params)=>{
    return new $5825dfeb0ec6f258$export$7d39f5df85f21031({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodVoid,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$7acfc3e64785411 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.array) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big : $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $5825dfeb0ec6f258$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $5825dfeb0ec6f258$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $5825dfeb0ec6f258$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$5825dfeb0ec6f258$export$7acfc3e64785411.create = (schema, params)=>{
    return new $5825dfeb0ec6f258$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodArray,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
function $5825dfeb0ec6f258$var$deepPartialify(schema) {
    if (schema instanceof $5825dfeb0ec6f258$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $5825dfeb0ec6f258$export$aa56fec1e9d629b8.create($5825dfeb0ec6f258$var$deepPartialify(fieldSchema));
        }
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $5825dfeb0ec6f258$export$7acfc3e64785411) return new $5825dfeb0ec6f258$export$7acfc3e64785411({
        ...schema._def,
        type: $5825dfeb0ec6f258$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $5825dfeb0ec6f258$export$aa56fec1e9d629b8) return $5825dfeb0ec6f258$export$aa56fec1e9d629b8.create($5825dfeb0ec6f258$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $5825dfeb0ec6f258$export$aaac0b8b429cef5) return $5825dfeb0ec6f258$export$aaac0b8b429cef5.create($5825dfeb0ec6f258$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $5825dfeb0ec6f258$export$e2a18bb771d8e6a3) return $5825dfeb0ec6f258$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$5825dfeb0ec6f258$var$deepPartialify(item)));
    else return schema;
}
class $5825dfeb0ec6f258$export$736315c5b55efbad extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $5825dfeb0ec6f258$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $5825dfeb0ec6f258$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $5825dfeb0ec6f258$var$errorUtil.errToObj;
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $5825dfeb0ec6f258$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $5825dfeb0ec6f258$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $5825dfeb0ec6f258$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $5825dfeb0ec6f258$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $5825dfeb0ec6f258$var$createZodEnum($5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$5825dfeb0ec6f258$export$736315c5b55efbad.create = (shape, params)=>{
    return new $5825dfeb0ec6f258$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $5825dfeb0ec6f258$export$1e576a20c3ce9fb5.create(),
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodObject,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
$5825dfeb0ec6f258$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $5825dfeb0ec6f258$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $5825dfeb0ec6f258$export$1e576a20c3ce9fb5.create(),
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodObject,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
$5825dfeb0ec6f258$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $5825dfeb0ec6f258$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $5825dfeb0ec6f258$export$1e576a20c3ce9fb5.create(),
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodObject,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$a8b236cb5070a311 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $5825dfeb0ec6f258$export$f98dac4b251ab333(result.ctx.common.issues));
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $5825dfeb0ec6f258$export$f98dac4b251ab333(issues));
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$5825dfeb0ec6f258$export$a8b236cb5070a311.create = (types, params)=>{
    return new $5825dfeb0ec6f258$export$a8b236cb5070a311({
        options: types,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodUnion,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $5825dfeb0ec6f258$var$getDiscriminator = (type)=>{
    if (type instanceof $5825dfeb0ec6f258$export$378d0cfce37406e6) return $5825dfeb0ec6f258$var$getDiscriminator(type.schema);
    else if (type instanceof $5825dfeb0ec6f258$export$a60af00cc0ce2582) return $5825dfeb0ec6f258$var$getDiscriminator(type.innerType());
    else if (type instanceof $5825dfeb0ec6f258$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $5825dfeb0ec6f258$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $5825dfeb0ec6f258$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $5825dfeb0ec6f258$export$bb19b37874861e7e) return $5825dfeb0ec6f258$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $5825dfeb0ec6f258$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $5825dfeb0ec6f258$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $5825dfeb0ec6f258$export$aa56fec1e9d629b8) return [
        undefined,
        ...$5825dfeb0ec6f258$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $5825dfeb0ec6f258$export$aaac0b8b429cef5) return [
        null,
        ...$5825dfeb0ec6f258$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $5825dfeb0ec6f258$export$66b0c798a395271f) return $5825dfeb0ec6f258$var$getDiscriminator(type.unwrap());
    else if (type instanceof $5825dfeb0ec6f258$export$5d1f7ef05c4e493a) return $5825dfeb0ec6f258$var$getDiscriminator(type.unwrap());
    else if (type instanceof $5825dfeb0ec6f258$export$75a44ec6249ac76b) return $5825dfeb0ec6f258$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $5825dfeb0ec6f258$export$5ef2424805ac76a3 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.object) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $5825dfeb0ec6f258$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $5825dfeb0ec6f258$export$5ef2424805ac76a3({
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$5825dfeb0ec6f258$var$processCreateParams(params)
        });
    }
}
function $5825dfeb0ec6f258$var$mergeValues(a, b) {
    const aType = $5825dfeb0ec6f258$export$3e9057828ebd5c7a(a);
    const bType = $5825dfeb0ec6f258$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $5825dfeb0ec6f258$export$5716da67bfaa244d.object && bType === $5825dfeb0ec6f258$export$5716da67bfaa244d.object) {
        const bKeys = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $5825dfeb0ec6f258$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $5825dfeb0ec6f258$export$5716da67bfaa244d.array && bType === $5825dfeb0ec6f258$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $5825dfeb0ec6f258$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $5825dfeb0ec6f258$export$5716da67bfaa244d.date && bType === $5825dfeb0ec6f258$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $5825dfeb0ec6f258$export$c02deaf0bb5203d4 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($5825dfeb0ec6f258$export$afa861e3c5730743(parsedLeft) || $5825dfeb0ec6f258$export$afa861e3c5730743(parsedRight)) return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            const merged = $5825dfeb0ec6f258$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            }
            if ($5825dfeb0ec6f258$export$910b6cdd390341b3(parsedLeft) || $5825dfeb0ec6f258$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$5825dfeb0ec6f258$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $5825dfeb0ec6f258$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodIntersection,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$e2a18bb771d8e6a3 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.array) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $5825dfeb0ec6f258$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$5825dfeb0ec6f258$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $5825dfeb0ec6f258$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$a2acc09968cb4b7f extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.object) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $5825dfeb0ec6f258$export$19342e026b58ebb7) return new $5825dfeb0ec6f258$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodRecord,
            ...$5825dfeb0ec6f258$var$processCreateParams(third)
        });
        return new $5825dfeb0ec6f258$export$a2acc09968cb4b7f({
            keyType: $5825dfeb0ec6f258$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodRecord,
            ...$5825dfeb0ec6f258$var$processCreateParams(second)
        });
    }
}
class $5825dfeb0ec6f258$export$163b6a2b712d9542 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.map) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$5825dfeb0ec6f258$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $5825dfeb0ec6f258$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodMap,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$977057706f816712 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.set) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $5825dfeb0ec6f258$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $5825dfeb0ec6f258$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$5825dfeb0ec6f258$export$977057706f816712.create = (valueType, params)=>{
    return new $5825dfeb0ec6f258$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodSet,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$d4602ba55673f53c extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.function) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $5825dfeb0ec6f258$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $5825dfeb0ec6f258$export$32f27c719778d4c4(),
                    $5825dfeb0ec6f258$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $5825dfeb0ec6f258$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $5825dfeb0ec6f258$export$32f27c719778d4c4(),
                    $5825dfeb0ec6f258$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $5825dfeb0ec6f258$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $5825dfeb0ec6f258$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $5825dfeb0ec6f258$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $5825dfeb0ec6f258$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $5825dfeb0ec6f258$export$d4602ba55673f53c({
            ...this._def,
            args: $5825dfeb0ec6f258$export$e2a18bb771d8e6a3.create(items).rest($5825dfeb0ec6f258$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $5825dfeb0ec6f258$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $5825dfeb0ec6f258$export$d4602ba55673f53c({
            args: args ? args : $5825dfeb0ec6f258$export$e2a18bb771d8e6a3.create([]).rest($5825dfeb0ec6f258$export$ef3b1bb1630977ae.create()),
            returns: returns || $5825dfeb0ec6f258$export$ef3b1bb1630977ae.create(),
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodFunction,
            ...$5825dfeb0ec6f258$var$processCreateParams(params)
        });
    }
}
class $5825dfeb0ec6f258$export$378d0cfce37406e6 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$5825dfeb0ec6f258$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $5825dfeb0ec6f258$export$378d0cfce37406e6({
        getter: getter,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodLazy,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$7e44096782a165d3 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$5825dfeb0ec6f258$export$7e44096782a165d3.create = (value, params)=>{
    return new $5825dfeb0ec6f258$export$7e44096782a165d3({
        value: value,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodLiteral,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
function $5825dfeb0ec6f258$var$createZodEnum(values, params) {
    return new $5825dfeb0ec6f258$export$d325d1f0e1c20179({
        values: values,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodEnum,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
}
class $5825dfeb0ec6f258$export$d325d1f0e1c20179 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $5825dfeb0ec6f258$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                expected: $5825dfeb0ec6f258$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (!$5825dfeb0ec6f258$var$__classPrivateFieldGet(this, $5825dfeb0ec6f258$var$_ZodEnum_cache, "f")) $5825dfeb0ec6f258$var$__classPrivateFieldSet(this, $5825dfeb0ec6f258$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$5825dfeb0ec6f258$var$__classPrivateFieldGet(this, $5825dfeb0ec6f258$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $5825dfeb0ec6f258$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $5825dfeb0ec6f258$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$5825dfeb0ec6f258$var$_ZodEnum_cache = new WeakMap();
$5825dfeb0ec6f258$export$d325d1f0e1c20179.create = $5825dfeb0ec6f258$var$createZodEnum;
class $5825dfeb0ec6f258$export$370b2e8d6d6f5c56 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $5825dfeb0ec6f258$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.string && ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.number) {
            const expectedValues = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                expected: $5825dfeb0ec6f258$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (!$5825dfeb0ec6f258$var$__classPrivateFieldGet(this, $5825dfeb0ec6f258$var$_ZodNativeEnum_cache, "f")) $5825dfeb0ec6f258$var$__classPrivateFieldSet(this, $5825dfeb0ec6f258$var$_ZodNativeEnum_cache, new Set($5825dfeb0ec6f258$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$5825dfeb0ec6f258$var$__classPrivateFieldGet(this, $5825dfeb0ec6f258$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$5825dfeb0ec6f258$var$_ZodNativeEnum_cache = new WeakMap();
$5825dfeb0ec6f258$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $5825dfeb0ec6f258$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNativeEnum,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$3f196b0127d6e50a extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $5825dfeb0ec6f258$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$5825dfeb0ec6f258$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $5825dfeb0ec6f258$export$3f196b0127d6e50a({
        type: schema,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodPromise,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$a60af00cc0ce2582 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $5825dfeb0ec6f258$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $5825dfeb0ec6f258$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $5825dfeb0ec6f258$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $5825dfeb0ec6f258$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $5825dfeb0ec6f258$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$5825dfeb0ec6f258$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$5825dfeb0ec6f258$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$5825dfeb0ec6f258$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $5825dfeb0ec6f258$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
$5825dfeb0ec6f258$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $5825dfeb0ec6f258$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodEffects,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$aa56fec1e9d629b8 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined) return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$5825dfeb0ec6f258$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $5825dfeb0ec6f258$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodOptional,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$aaac0b8b429cef5 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $5825dfeb0ec6f258$export$5716da67bfaa244d.null) return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$5825dfeb0ec6f258$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $5825dfeb0ec6f258$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNullable,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$bb19b37874861e7e extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$5825dfeb0ec6f258$export$bb19b37874861e7e.create = (type, params)=>{
    return new $5825dfeb0ec6f258$export$bb19b37874861e7e({
        innerType: type,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$75a44ec6249ac76b extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($5825dfeb0ec6f258$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $5825dfeb0ec6f258$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $5825dfeb0ec6f258$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$5825dfeb0ec6f258$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $5825dfeb0ec6f258$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$26ccfa0145e8511f extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$5825dfeb0ec6f258$export$26ccfa0145e8511f.create = (params)=>{
    return new $5825dfeb0ec6f258$export$26ccfa0145e8511f({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNaN,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
const $5825dfeb0ec6f258$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $5825dfeb0ec6f258$export$66b0c798a395271f extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $5825dfeb0ec6f258$export$a3c3ef8a0e95c6da extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $5825dfeb0ec6f258$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $5825dfeb0ec6f258$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $5825dfeb0ec6f258$export$5d1f7ef05c4e493a extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($5825dfeb0ec6f258$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $5825dfeb0ec6f258$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$5825dfeb0ec6f258$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $5825dfeb0ec6f258$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodReadonly,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $5825dfeb0ec6f258$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $5825dfeb0ec6f258$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $5825dfeb0ec6f258$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            var _a, _b;
            if (!r) {
                const params = $5825dfeb0ec6f258$var$cleanParams(_params, data);
                const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $5825dfeb0ec6f258$var$cleanParams(_params, data);
            const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $5825dfeb0ec6f258$export$b9d1edb536b4e4eb.create();
}
const $5825dfeb0ec6f258$export$1ee8ee30835eab8b = {
    object: $5825dfeb0ec6f258$export$736315c5b55efbad.lazycreate
};
var $5825dfeb0ec6f258$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($5825dfeb0ec6f258$export$558106ce543bd011 || ($5825dfeb0ec6f258$export$558106ce543bd011 = {}));
const $5825dfeb0ec6f258$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$5825dfeb0ec6f258$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $5825dfeb0ec6f258$export$22b082955e083ec3 = $5825dfeb0ec6f258$export$1230eb29b8d3b502.create;
const $5825dfeb0ec6f258$export$98e628dec113755e = $5825dfeb0ec6f258$export$5b070a55c0c43e09.create;
const $5825dfeb0ec6f258$export$9e06de0973666692 = $5825dfeb0ec6f258$export$26ccfa0145e8511f.create;
const $5825dfeb0ec6f258$export$a0f65b52274bcc00 = $5825dfeb0ec6f258$export$67d741fd70ff98f4.create;
const $5825dfeb0ec6f258$export$4a21f16c33752377 = $5825dfeb0ec6f258$export$723d146f80596191.create;
const $5825dfeb0ec6f258$export$324d90190a8b822a = $5825dfeb0ec6f258$export$e974be33bdc55521.create;
const $5825dfeb0ec6f258$export$8f701197936bc2a6 = $5825dfeb0ec6f258$export$bcc3b40f6b638044.create;
const $5825dfeb0ec6f258$export$1db45310990710a5 = $5825dfeb0ec6f258$export$4e780e961c30340d.create;
const $5825dfeb0ec6f258$export$7b1b591b262c240 = $5825dfeb0ec6f258$export$a96281f914484f2d.create;
const $5825dfeb0ec6f258$export$4154a199d7d90455 = $5825dfeb0ec6f258$export$b9d1edb536b4e4eb.create;
const $5825dfeb0ec6f258$export$19282c40b967aec6 = $5825dfeb0ec6f258$export$ef3b1bb1630977ae.create;
const $5825dfeb0ec6f258$export$b3e22bcfd64c1022 = $5825dfeb0ec6f258$export$1e576a20c3ce9fb5.create;
const $5825dfeb0ec6f258$export$490e536ee7389aeb = $5825dfeb0ec6f258$export$7d39f5df85f21031.create;
const $5825dfeb0ec6f258$export$2f23118c22fb2630 = $5825dfeb0ec6f258$export$7acfc3e64785411.create;
const $5825dfeb0ec6f258$export$be5493f9613cbbe = $5825dfeb0ec6f258$export$736315c5b55efbad.create;
const $5825dfeb0ec6f258$export$8fb0df5f40d0b477 = $5825dfeb0ec6f258$export$736315c5b55efbad.strictCreate;
const $5825dfeb0ec6f258$export$971dd5b0dfd021b6 = $5825dfeb0ec6f258$export$a8b236cb5070a311.create;
const $5825dfeb0ec6f258$export$4b888e40c4ee26dd = $5825dfeb0ec6f258$export$5ef2424805ac76a3.create;
const $5825dfeb0ec6f258$export$bc86dfbf7795668c = $5825dfeb0ec6f258$export$c02deaf0bb5203d4.create;
const $5825dfeb0ec6f258$export$65e3907585753458 = $5825dfeb0ec6f258$export$e2a18bb771d8e6a3.create;
const $5825dfeb0ec6f258$export$e5185e241753e543 = $5825dfeb0ec6f258$export$a2acc09968cb4b7f.create;
const $5825dfeb0ec6f258$export$871de8747c9eaa88 = $5825dfeb0ec6f258$export$163b6a2b712d9542.create;
const $5825dfeb0ec6f258$export$adaa4cf7ef1b65be = $5825dfeb0ec6f258$export$977057706f816712.create;
const $5825dfeb0ec6f258$export$44e51c8aac7c2deb = $5825dfeb0ec6f258$export$d4602ba55673f53c.create;
const $5825dfeb0ec6f258$export$488013bae63b21da = $5825dfeb0ec6f258$export$378d0cfce37406e6.create;
const $5825dfeb0ec6f258$export$c8ec6e1ec9fefcb0 = $5825dfeb0ec6f258$export$7e44096782a165d3.create;
const $5825dfeb0ec6f258$export$78a99c8d44d72635 = $5825dfeb0ec6f258$export$d325d1f0e1c20179.create;
const $5825dfeb0ec6f258$export$6fe7eca19ebe5199 = $5825dfeb0ec6f258$export$370b2e8d6d6f5c56.create;
const $5825dfeb0ec6f258$export$c957ef27a0ebfd4 = $5825dfeb0ec6f258$export$3f196b0127d6e50a.create;
const $5825dfeb0ec6f258$export$dc573d8a6576cdb3 = $5825dfeb0ec6f258$export$a60af00cc0ce2582.create;
const $5825dfeb0ec6f258$export$516e28dec6a4b6d4 = $5825dfeb0ec6f258$export$aa56fec1e9d629b8.create;
const $5825dfeb0ec6f258$export$133fc36489ac9add = $5825dfeb0ec6f258$export$aaac0b8b429cef5.create;
const $5825dfeb0ec6f258$export$fc37fe19dfda43ee = $5825dfeb0ec6f258$export$a60af00cc0ce2582.createWithPreprocess;
const $5825dfeb0ec6f258$export$43f28b24e1eb8181 = $5825dfeb0ec6f258$export$a3c3ef8a0e95c6da.create;
const $5825dfeb0ec6f258$export$3b3d07727c5b702c = ()=>$5825dfeb0ec6f258$export$22b082955e083ec3().optional();
const $5825dfeb0ec6f258$export$eb150471a61fced6 = ()=>$5825dfeb0ec6f258$export$98e628dec113755e().optional();
const $5825dfeb0ec6f258$export$269251733cdcbbf1 = ()=>$5825dfeb0ec6f258$export$4a21f16c33752377().optional();
const $5825dfeb0ec6f258$export$8c14e57e778d3873 = {
    string: (arg)=>$5825dfeb0ec6f258$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$5825dfeb0ec6f258$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$5825dfeb0ec6f258$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$5825dfeb0ec6f258$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$5825dfeb0ec6f258$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $5825dfeb0ec6f258$export$96c94437c95d7862 = $5825dfeb0ec6f258$export$9a105a556e65c2c0;
var $5825dfeb0ec6f258$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $5825dfeb0ec6f258$export$341b0b6e0a6f5099,
    setErrorMap: $5825dfeb0ec6f258$export$1097a8289cfd22d7,
    getErrorMap: $5825dfeb0ec6f258$export$32f27c719778d4c4,
    makeIssue: $5825dfeb0ec6f258$export$244a85fde9c419ed,
    EMPTY_PATH: $5825dfeb0ec6f258$export$1526d2e05f74572,
    addIssueToContext: $5825dfeb0ec6f258$export$db7caee60e5d514d,
    ParseStatus: $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f,
    INVALID: $5825dfeb0ec6f258$export$9a105a556e65c2c0,
    DIRTY: $5825dfeb0ec6f258$export$325a211da9693fcf,
    OK: $5825dfeb0ec6f258$export$c6813a8d51f77eaf,
    isAborted: $5825dfeb0ec6f258$export$afa861e3c5730743,
    isDirty: $5825dfeb0ec6f258$export$910b6cdd390341b3,
    isValid: $5825dfeb0ec6f258$export$1ea939691cdc45b8,
    isAsync: $5825dfeb0ec6f258$export$aefee5ebe1dcfd9e,
    get util () {
        return $5825dfeb0ec6f258$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $5825dfeb0ec6f258$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $5825dfeb0ec6f258$export$5716da67bfaa244d,
    getParsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a,
    ZodType: $5825dfeb0ec6f258$export$19342e026b58ebb7,
    datetimeRegex: $5825dfeb0ec6f258$export$a4b563879add27a,
    ZodString: $5825dfeb0ec6f258$export$1230eb29b8d3b502,
    ZodNumber: $5825dfeb0ec6f258$export$5b070a55c0c43e09,
    ZodBigInt: $5825dfeb0ec6f258$export$67d741fd70ff98f4,
    ZodBoolean: $5825dfeb0ec6f258$export$723d146f80596191,
    ZodDate: $5825dfeb0ec6f258$export$e974be33bdc55521,
    ZodSymbol: $5825dfeb0ec6f258$export$bcc3b40f6b638044,
    ZodUndefined: $5825dfeb0ec6f258$export$4e780e961c30340d,
    ZodNull: $5825dfeb0ec6f258$export$a96281f914484f2d,
    ZodAny: $5825dfeb0ec6f258$export$b9d1edb536b4e4eb,
    ZodUnknown: $5825dfeb0ec6f258$export$ef3b1bb1630977ae,
    ZodNever: $5825dfeb0ec6f258$export$1e576a20c3ce9fb5,
    ZodVoid: $5825dfeb0ec6f258$export$7d39f5df85f21031,
    ZodArray: $5825dfeb0ec6f258$export$7acfc3e64785411,
    ZodObject: $5825dfeb0ec6f258$export$736315c5b55efbad,
    ZodUnion: $5825dfeb0ec6f258$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $5825dfeb0ec6f258$export$5ef2424805ac76a3,
    ZodIntersection: $5825dfeb0ec6f258$export$c02deaf0bb5203d4,
    ZodTuple: $5825dfeb0ec6f258$export$e2a18bb771d8e6a3,
    ZodRecord: $5825dfeb0ec6f258$export$a2acc09968cb4b7f,
    ZodMap: $5825dfeb0ec6f258$export$163b6a2b712d9542,
    ZodSet: $5825dfeb0ec6f258$export$977057706f816712,
    ZodFunction: $5825dfeb0ec6f258$export$d4602ba55673f53c,
    ZodLazy: $5825dfeb0ec6f258$export$378d0cfce37406e6,
    ZodLiteral: $5825dfeb0ec6f258$export$7e44096782a165d3,
    ZodEnum: $5825dfeb0ec6f258$export$d325d1f0e1c20179,
    ZodNativeEnum: $5825dfeb0ec6f258$export$370b2e8d6d6f5c56,
    ZodPromise: $5825dfeb0ec6f258$export$3f196b0127d6e50a,
    ZodEffects: $5825dfeb0ec6f258$export$a60af00cc0ce2582,
    ZodTransformer: $5825dfeb0ec6f258$export$a60af00cc0ce2582,
    ZodOptional: $5825dfeb0ec6f258$export$aa56fec1e9d629b8,
    ZodNullable: $5825dfeb0ec6f258$export$aaac0b8b429cef5,
    ZodDefault: $5825dfeb0ec6f258$export$bb19b37874861e7e,
    ZodCatch: $5825dfeb0ec6f258$export$75a44ec6249ac76b,
    ZodNaN: $5825dfeb0ec6f258$export$26ccfa0145e8511f,
    BRAND: $5825dfeb0ec6f258$export$cf2deea74cde46b4,
    ZodBranded: $5825dfeb0ec6f258$export$66b0c798a395271f,
    ZodPipeline: $5825dfeb0ec6f258$export$a3c3ef8a0e95c6da,
    ZodReadonly: $5825dfeb0ec6f258$export$5d1f7ef05c4e493a,
    custom: $5825dfeb0ec6f258$export$4c00f665f0d4b443,
    Schema: $5825dfeb0ec6f258$export$19342e026b58ebb7,
    ZodSchema: $5825dfeb0ec6f258$export$19342e026b58ebb7,
    late: $5825dfeb0ec6f258$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $5825dfeb0ec6f258$export$558106ce543bd011;
    },
    coerce: $5825dfeb0ec6f258$export$8c14e57e778d3873,
    any: $5825dfeb0ec6f258$export$4154a199d7d90455,
    array: $5825dfeb0ec6f258$export$2f23118c22fb2630,
    bigint: $5825dfeb0ec6f258$export$a0f65b52274bcc00,
    boolean: $5825dfeb0ec6f258$export$4a21f16c33752377,
    date: $5825dfeb0ec6f258$export$324d90190a8b822a,
    discriminatedUnion: $5825dfeb0ec6f258$export$4b888e40c4ee26dd,
    effect: $5825dfeb0ec6f258$export$dc573d8a6576cdb3,
    'enum': $5825dfeb0ec6f258$export$78a99c8d44d72635,
    'function': $5825dfeb0ec6f258$export$44e51c8aac7c2deb,
    'instanceof': $5825dfeb0ec6f258$export$3d916e7c22dbd8b5,
    intersection: $5825dfeb0ec6f258$export$bc86dfbf7795668c,
    lazy: $5825dfeb0ec6f258$export$488013bae63b21da,
    literal: $5825dfeb0ec6f258$export$c8ec6e1ec9fefcb0,
    map: $5825dfeb0ec6f258$export$871de8747c9eaa88,
    nan: $5825dfeb0ec6f258$export$9e06de0973666692,
    nativeEnum: $5825dfeb0ec6f258$export$6fe7eca19ebe5199,
    never: $5825dfeb0ec6f258$export$b3e22bcfd64c1022,
    'null': $5825dfeb0ec6f258$export$7b1b591b262c240,
    nullable: $5825dfeb0ec6f258$export$133fc36489ac9add,
    number: $5825dfeb0ec6f258$export$98e628dec113755e,
    object: $5825dfeb0ec6f258$export$be5493f9613cbbe,
    oboolean: $5825dfeb0ec6f258$export$269251733cdcbbf1,
    onumber: $5825dfeb0ec6f258$export$eb150471a61fced6,
    optional: $5825dfeb0ec6f258$export$516e28dec6a4b6d4,
    ostring: $5825dfeb0ec6f258$export$3b3d07727c5b702c,
    pipeline: $5825dfeb0ec6f258$export$43f28b24e1eb8181,
    preprocess: $5825dfeb0ec6f258$export$fc37fe19dfda43ee,
    promise: $5825dfeb0ec6f258$export$c957ef27a0ebfd4,
    record: $5825dfeb0ec6f258$export$e5185e241753e543,
    set: $5825dfeb0ec6f258$export$adaa4cf7ef1b65be,
    strictObject: $5825dfeb0ec6f258$export$8fb0df5f40d0b477,
    string: $5825dfeb0ec6f258$export$22b082955e083ec3,
    symbol: $5825dfeb0ec6f258$export$8f701197936bc2a6,
    transformer: $5825dfeb0ec6f258$export$dc573d8a6576cdb3,
    tuple: $5825dfeb0ec6f258$export$65e3907585753458,
    'undefined': $5825dfeb0ec6f258$export$1db45310990710a5,
    union: $5825dfeb0ec6f258$export$971dd5b0dfd021b6,
    unknown: $5825dfeb0ec6f258$export$19282c40b967aec6,
    'void': $5825dfeb0ec6f258$export$490e536ee7389aeb,
    NEVER: $5825dfeb0ec6f258$export$96c94437c95d7862,
    ZodIssueCode: $5825dfeb0ec6f258$export$5ba560653e4a1035,
    quotelessJson: $5825dfeb0ec6f258$export$913eddeaf297cfea,
    ZodError: $5825dfeb0ec6f258$export$f98dac4b251ab333
});



var $fgQ0V = parcelRequire("fgQ0V");

var $T5IcR = parcelRequire("T5IcR");
var $9b879bbdd76f7296$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9b879bbdd76f7296$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9b879bbdd76f7296$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9b879bbdd76f7296$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
const $9b879bbdd76f7296$var$RuleSchema = (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).object({
    field: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).string(),
    check: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).enum([
        'greater_than',
        'range',
        'boolean',
        'none'
    ]),
    range: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).tuple([
        (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).number(),
        (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).number()
    ]).optional(),
    points: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).number().default(1),
    dataPick: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).enum([
        'biggest_key_with_value'
    ]).optional(),
    threshold: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).number().optional(),
    threshold_display: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).string().optional(),
    inverse_score: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).boolean().default(false),
    sectionId: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).string().optional(),
    disabled: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).boolean().default(false),
    debugger: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).boolean().default(false)
}).refine((data)=>{
    if (data.check === 'range' && !data.range) return false;
    if (data.check === 'greater_than' && (data.threshold === undefined || data.range === undefined)) return false;
    if (data.check !== 'range' && data.inverse_score) return false;
    return true;
});
const $9b879bbdd76f7296$var$SectionSchema = (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).object({
    sectionName: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).string(),
    section_worth: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).number(),
    rules: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).array($9b879bbdd76f7296$var$RuleSchema)
});
class $9b879bbdd76f7296$export$3a327ec912fc46d0 {
    constructor(sectionId){
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sectionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "section_worth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const scoreRules = $9b879bbdd76f7296$export$5bbef306d29b8236().rules;
        this.sectionId = sectionId;
        this.section_worth = scoreRules[sectionId].section_worth;
        this.name = scoreRules[sectionId].sectionName;
        this.fields = $9b879bbdd76f7296$export$39c49a915ff7ed37.get_section_fields(sectionId);
    }
}
//type SectionTypes = "revenue_performance" | "ebitda_performance";
const $9b879bbdd76f7296$var$SectionTypeEnum = (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).enum([
    'overview',
    'revenue_performance',
    'ebitda_performance',
    'market_size_and_performance',
    'fcf_profile',
    'concentration',
    'other'
]);
const $9b879bbdd76f7296$var$SectionsSchema = (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).record($9b879bbdd76f7296$var$SectionSchema).refine((data)=>{
    return Object.keys(data).every((key)=>$9b879bbdd76f7296$var$SectionTypeEnum.options.includes(key));
});
const $9b879bbdd76f7296$var$scoreRulesCopy = $9b879bbdd76f7296$var$SectionsSchema.parse((0, (/*@__PURE__*/$parcel$interopDefault($66fd588cfa718c83$exports))));
class $9b879bbdd76f7296$export$39c49a915ff7ed37 {
    constructor(dataAccess, doLog = false){
        Object.defineProperty(this, "dataAccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: dataAccess
        });
        Object.defineProperty(this, "doLog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: doLog
        });
    }
    get_rule_weight(section, rule) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        const rulesUsed = scoreRules[section].rules.filter((rule)=>this.is_rule_used_for_scoring(rule)).length;
        return rule.points / rulesUsed;
    }
    get_datapick_key_for_rule(rule) {
        if (rule.dataPick === 'biggest_key_with_value') {
            const fieldValue = this.dataAccess.get_extended_value_float(rule.field);
            var keys = Object.keys(fieldValue).sort().reverse();
            if (keys.length == 0) return null;
            for(var i = 0; i < keys.length; i++){
                var keyIndex = keys[i];
                var value = fieldValue[keyIndex];
                if (value != 'N/A' && value != null) return keyIndex;
            }
        } else return null;
    }
    get_extended_float_for_scoring(score) {
        var fieldValue = this.dataAccess.get_extended_value_float(score.field);
        if (score.dataPick) {
            const keyIndex = this.get_datapick_key_for_rule(score);
            if (keyIndex == null) return 'N/A';
            return fieldValue[keyIndex];
        } else return fieldValue;
    }
    do_rule_score(score, clamp_to_01 = true) {
        if (score.debugger) debugger;
        const p = score.points;
        var fieldValue = this.get_extended_float_for_scoring(score);
        var ret = 0;
        switch(score.check){
            case 'greater_than':
                ret = fieldValue > score.threshold ? p : 0;
                this.log(`Scoring -> (${score.field}) greater_than (${score.threshold}): ${fieldValue}: ${ret}/${p}`);
                break;
            case 'range':
                const [low, high] = score.range;
                var norm = (fieldValue - low) / (high - low);
                if (clamp_to_01) norm = Math.min(1, Math.max(0, norm));
                if (score.inverse_score === true) {
                    this.log(`*** Inverse Scoring (${score.field}): ${norm} to: ${1 - norm} ***`);
                    norm = 1 - norm;
                }
                ret = p * norm;
                this.log(`Scoring -> (${score.field}) range[${low}, ${high}] (Value: ${fieldValue.toFixed(2)}, Norm: ${norm.toFixed(2)}): ${ret}/${p}`);
                break;
            case 'boolean':
                ret = fieldValue ? p : 0;
                this.log(`Scoring -> (${score.field}) boolean: ${fieldValue}: ${ret}/${p}`);
                break;
            default:
                this.log('Scoring-> Unknown check type: ' + score.check);
                ret = 0;
                break;
        }
        if (isNaN(ret)) {
            this.log('Scoring-> Error calculating score for ' + score.field);
            ret = 0;
        }
        return ret;
    }
    log(msg) {
        if (!this.doLog) return;
        console.log(msg);
    }
    static get_section_name(section) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        return scoreRules[section].sectionName;
    }
    static get_section_fields(section) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        return scoreRules[section].rules.map((rule)=>rule.field);
    }
    is_rule_excluded_for_client(rule) {
        if (rule.disabled) return true;
        return false;
    }
    is_rule_used_for_scoring(scoreRule) {
        if (scoreRule.check === 'none' || scoreRule.disabled) return false;
        if (this.is_rule_excluded_for_client(scoreRule)) {
            this.log('Scoring-> Skipping: ' + scoreRule.field + ' due to client exclusion');
            return false;
        }
        var value = this.get_extended_float_for_scoring(scoreRule);
        if (value == 'N/A' || isNaN(value)) {
            this.log('Scoring-> Skipping: ' + scoreRule.field + ' due to N/A or NaN');
            return false;
        }
        return true;
    }
    static get_score_rule_by_fieldname(section, fieldName) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        const sectionData = scoreRules[section];
        return sectionData.rules.find((rule)=>rule.field === fieldName);
    }
    is_section_used_for_scoring_by_id(section) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        return this.is_section_used_for_scoring(scoreRules[section]);
    }
    is_section_used_for_scoring(section) {
        var isUsed = false;
        for (const rule of section.rules)if (this.is_rule_used_for_scoring(rule)) {
            isUsed = true;
            break;
        }
        return isUsed;
    }
    calcSectionPercentileById(sectionId) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        const section = scoreRules[sectionId];
        return this.calcSectionPercentile(section);
    }
    calcSectionPercentile(section) {
        var maxPointsAvailable = 0;
        var totalPoints = 0;
        section.rules.forEach((rule)=>{
            if (this.is_rule_used_for_scoring(rule)) {
                maxPointsAvailable += rule.points;
                totalPoints += this.do_rule_score(rule);
            }
        });
        this.log(`Scoring-> ${section.sectionName} Section: ${totalPoints.toFixed(2)}/${maxPointsAvailable.toFixed(2)}`);
        const percentile = totalPoints / maxPointsAvailable;
        this.log(`Scoring-> ${section.sectionName} Section Percentile: ${percentile.toFixed(2)}`);
        return percentile;
    }
    get_max_points_based_on_sections_used() {
        var maxPoints = 0;
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        for(var id in scoreRules)if (this.is_section_used_for_scoring_by_id(id)) maxPoints += scoreRules[id].section_worth;
        return maxPoints;
    }
    calcScorePercentile() {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        var maxAvailableSectionPoints = 0;
        var totalPointsScored = 0;
        this.log('START SCORE CALCULATION');
        for(var id in scoreRules){
            const section = scoreRules[id];
            if (this.is_section_used_for_scoring(section)) {
                maxAvailableSectionPoints += section.section_worth;
                const percentileScoreSection = this.calcSectionPercentile(section);
                this.log(`Section ${section.sectionName} scored ${percentileScoreSection}`);
                totalPointsScored += percentileScoreSection * section.section_worth;
            }
        }
        this.log('END SCORE CALCULATION');
        if (maxAvailableSectionPoints == 0) {
            this.log('Scoring-> No sections to score');
            return null;
        }
        var finalScore = totalPointsScored / maxAvailableSectionPoints;
        return finalScore;
    }
}
let $9b879bbdd76f7296$var$ScoreRulesStore = (()=>{
    var _a, _ScoreRulesStore_SCORE_FIELDS_GROUPS_accessor_storage, _ScoreRulesStore_COMPARE_FIELDS_GROUPS_accessor_storage;
    let _SCORE_FIELDS_GROUPS_decorators;
    let _SCORE_FIELDS_GROUPS_initializers = [];
    let _SCORE_FIELDS_GROUPS_extraInitializers = [];
    let _COMPARE_FIELDS_GROUPS_decorators;
    let _COMPARE_FIELDS_GROUPS_initializers = [];
    let _COMPARE_FIELDS_GROUPS_extraInitializers = [];
    return _a = class ScoreRulesStore {
        constructor(outputLog = false){
            Object.defineProperty(this, "outputLog", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: outputLog
            });
            Object.defineProperty(this, "rules", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: null
            });
            Object.defineProperty(this, "overviewGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "revenueGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ebitdaGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "marketGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "fcfGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "customerConcentration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "other", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _ScoreRulesStore_SCORE_FIELDS_GROUPS_accessor_storage.set(this, $9b879bbdd76f7296$var$__runInitializers(this, _SCORE_FIELDS_GROUPS_initializers, []));
            _ScoreRulesStore_COMPARE_FIELDS_GROUPS_accessor_storage.set(this, ($9b879bbdd76f7296$var$__runInitializers(this, _SCORE_FIELDS_GROUPS_extraInitializers), $9b879bbdd76f7296$var$__runInitializers(this, _COMPARE_FIELDS_GROUPS_initializers, [])));
            $9b879bbdd76f7296$var$__runInitializers(this, _COMPARE_FIELDS_GROUPS_extraInitializers);
            this.outputLog = outputLog;
        }
        init() {
            this.rules = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep($9b879bbdd76f7296$var$scoreRulesCopy);
            for(var sectionId in this.rules){
                const section = $9b879bbdd76f7296$var$scoreRulesCopy[sectionId];
                section.rules.forEach((rule)=>{
                    rule.sectionId = sectionId;
                });
            }
            this.setupGroups();
        }
        setupGroups() {
            this.overviewGroup = new $9b879bbdd76f7296$export$3a327ec912fc46d0('overview');
            this.revenueGroup = new $9b879bbdd76f7296$export$3a327ec912fc46d0('revenue_performance');
            this.ebitdaGroup = new $9b879bbdd76f7296$export$3a327ec912fc46d0('ebitda_performance');
            this.marketGroup = new $9b879bbdd76f7296$export$3a327ec912fc46d0('market_size_and_performance');
            this.fcfGroup = new $9b879bbdd76f7296$export$3a327ec912fc46d0('fcf_profile');
            this.customerConcentration = new $9b879bbdd76f7296$export$3a327ec912fc46d0('concentration');
            this.other = new $9b879bbdd76f7296$export$3a327ec912fc46d0('other');
            this.SCORE_FIELDS_GROUPS = [
                this.revenueGroup,
                this.ebitdaGroup,
                this.marketGroup,
                this.fcfGroup
            ];
            this.COMPARE_FIELDS_GROUPS = [
                this.overviewGroup,
                this.revenueGroup,
                this.ebitdaGroup,
                this.marketGroup,
                this.fcfGroup
            ];
        }
        get_local_rule(sectonId, fieldName) {
            return this.rules[sectonId].rules.find((rule)=>rule.field === fieldName);
        }
        update_rules(data) {
            this.rules = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep($9b879bbdd76f7296$var$scoreRulesCopy);
            for(var sectionId in data){
                const section = data[sectionId];
                const pick = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).pick(section, [
                    'sectionName',
                    'section_worth'
                ]);
                Object.assign(this.rules[sectionId], pick);
                if (section.rules) for (var ruleUpdates of section.rules){
                    var localRule = this.get_local_rule(sectionId, ruleUpdates.field);
                    if (localRule) Object.assign(localRule, ruleUpdates);
                }
            }
            this.setupGroups();
        }
        get SCORE_FIELDS_GROUPS() {
            return $9b879bbdd76f7296$var$__classPrivateFieldGet(this, _ScoreRulesStore_SCORE_FIELDS_GROUPS_accessor_storage, "f");
        }
        set SCORE_FIELDS_GROUPS(value) {
            $9b879bbdd76f7296$var$__classPrivateFieldSet(this, _ScoreRulesStore_SCORE_FIELDS_GROUPS_accessor_storage, value, "f");
        }
        get COMPARE_FIELDS_GROUPS() {
            return $9b879bbdd76f7296$var$__classPrivateFieldGet(this, _ScoreRulesStore_COMPARE_FIELDS_GROUPS_accessor_storage, "f");
        }
        set COMPARE_FIELDS_GROUPS(value) {
            $9b879bbdd76f7296$var$__classPrivateFieldSet(this, _ScoreRulesStore_COMPARE_FIELDS_GROUPS_accessor_storage, value, "f");
        }
    }, _ScoreRulesStore_SCORE_FIELDS_GROUPS_accessor_storage = new WeakMap(), _ScoreRulesStore_COMPARE_FIELDS_GROUPS_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _SCORE_FIELDS_GROUPS_decorators = [
            (0, $T5IcR.observable)
        ];
        _COMPARE_FIELDS_GROUPS_decorators = [
            (0, $T5IcR.observable)
        ];
        $9b879bbdd76f7296$var$__esDecorate(_a, null, _SCORE_FIELDS_GROUPS_decorators, {
            kind: "accessor",
            name: "SCORE_FIELDS_GROUPS",
            static: false,
            private: false,
            access: {
                has: (obj)=>"SCORE_FIELDS_GROUPS" in obj,
                get: (obj)=>obj.SCORE_FIELDS_GROUPS,
                set: (obj, value)=>{
                    obj.SCORE_FIELDS_GROUPS = value;
                }
            },
            metadata: _metadata
        }, _SCORE_FIELDS_GROUPS_initializers, _SCORE_FIELDS_GROUPS_extraInitializers);
        $9b879bbdd76f7296$var$__esDecorate(_a, null, _COMPARE_FIELDS_GROUPS_decorators, {
            kind: "accessor",
            name: "COMPARE_FIELDS_GROUPS",
            static: false,
            private: false,
            access: {
                has: (obj)=>"COMPARE_FIELDS_GROUPS" in obj,
                get: (obj)=>obj.COMPARE_FIELDS_GROUPS,
                set: (obj, value)=>{
                    obj.COMPARE_FIELDS_GROUPS = value;
                }
            },
            metadata: _metadata
        }, _COMPARE_FIELDS_GROUPS_initializers, _COMPARE_FIELDS_GROUPS_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $9b879bbdd76f7296$var$scoringDataStore = new $9b879bbdd76f7296$var$ScoreRulesStore();
const $9b879bbdd76f7296$export$5bbef306d29b8236 = ()=>{
    return $9b879bbdd76f7296$var$scoringDataStore;
};
const $9b879bbdd76f7296$export$f65e0b130162f295 = ()=>{
    return $9b879bbdd76f7296$var$scoringDataStore.rules;
};
$9b879bbdd76f7296$var$scoringDataStore.init();


var $3d71a0e5fc49a3ca$exports = {};
/*global window, global*/ 
var $eqWSa = parcelRequire("eqWSa");

var $gpaur = parcelRequire("gpaur");
function $3d71a0e5fc49a3ca$var$now() {
    return new Date().getTime();
}
var $3d71a0e5fc49a3ca$var$slice = Array.prototype.slice;
var $3d71a0e5fc49a3ca$var$console;
var $3d71a0e5fc49a3ca$var$times = {};
if (typeof $parcel$global !== "undefined" && $parcel$global.console) $3d71a0e5fc49a3ca$var$console = $parcel$global.console;
else if (typeof window !== "undefined" && window.console) $3d71a0e5fc49a3ca$var$console = window.console;
else $3d71a0e5fc49a3ca$var$console = {};
var $3d71a0e5fc49a3ca$var$functions = [
    [
        $3d71a0e5fc49a3ca$var$log,
        "log"
    ],
    [
        $3d71a0e5fc49a3ca$var$info,
        "info"
    ],
    [
        $3d71a0e5fc49a3ca$var$warn,
        "warn"
    ],
    [
        $3d71a0e5fc49a3ca$var$error,
        "error"
    ],
    [
        $3d71a0e5fc49a3ca$var$time,
        "time"
    ],
    [
        $3d71a0e5fc49a3ca$var$timeEnd,
        "timeEnd"
    ],
    [
        $3d71a0e5fc49a3ca$var$trace,
        "trace"
    ],
    [
        $3d71a0e5fc49a3ca$var$dir,
        "dir"
    ],
    [
        $3d71a0e5fc49a3ca$var$consoleAssert,
        "assert"
    ]
];
for(var $3d71a0e5fc49a3ca$var$i = 0; $3d71a0e5fc49a3ca$var$i < $3d71a0e5fc49a3ca$var$functions.length; $3d71a0e5fc49a3ca$var$i++){
    var $3d71a0e5fc49a3ca$var$tuple = $3d71a0e5fc49a3ca$var$functions[$3d71a0e5fc49a3ca$var$i];
    var $3d71a0e5fc49a3ca$var$f = $3d71a0e5fc49a3ca$var$tuple[0];
    var $3d71a0e5fc49a3ca$var$name = $3d71a0e5fc49a3ca$var$tuple[1];
    if (!$3d71a0e5fc49a3ca$var$console[$3d71a0e5fc49a3ca$var$name]) $3d71a0e5fc49a3ca$var$console[$3d71a0e5fc49a3ca$var$name] = $3d71a0e5fc49a3ca$var$f;
}
$3d71a0e5fc49a3ca$exports = $3d71a0e5fc49a3ca$var$console;
function $3d71a0e5fc49a3ca$var$log() {}
function $3d71a0e5fc49a3ca$var$info() {
    $3d71a0e5fc49a3ca$var$console.log.apply($3d71a0e5fc49a3ca$var$console, arguments);
}
function $3d71a0e5fc49a3ca$var$warn() {
    $3d71a0e5fc49a3ca$var$console.log.apply($3d71a0e5fc49a3ca$var$console, arguments);
}
function $3d71a0e5fc49a3ca$var$error() {
    $3d71a0e5fc49a3ca$var$console.warn.apply($3d71a0e5fc49a3ca$var$console, arguments);
}
function $3d71a0e5fc49a3ca$var$time(label) {
    $3d71a0e5fc49a3ca$var$times[label] = $3d71a0e5fc49a3ca$var$now();
}
function $3d71a0e5fc49a3ca$var$timeEnd(label) {
    var time = $3d71a0e5fc49a3ca$var$times[label];
    if (!time) throw new Error("No such label: " + label);
    delete $3d71a0e5fc49a3ca$var$times[label];
    var duration = $3d71a0e5fc49a3ca$var$now() - time;
    $3d71a0e5fc49a3ca$var$console.log(label + ": " + duration + "ms");
}
function $3d71a0e5fc49a3ca$var$trace() {
    var err = new Error();
    err.name = "Trace";
    err.message = $eqWSa.format.apply(null, arguments);
    $3d71a0e5fc49a3ca$var$console.error(err.stack);
}
function $3d71a0e5fc49a3ca$var$dir(object) {
    $3d71a0e5fc49a3ca$var$console.log($eqWSa.inspect(object) + "\n");
}
function $3d71a0e5fc49a3ca$var$consoleAssert(expression) {
    if (!expression) {
        var arr = $3d71a0e5fc49a3ca$var$slice.call(arguments, 1);
        $gpaur.ok(false, $eqWSa.format.apply(null, arr));
    }
}


var $685ea9875b44937b$exports = {};
var $557b93ccd0374a02$exports = {};
$557b93ccd0374a02$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyAsnokt7beqnidxzHpDU1yc3GFrzmq9yy0\",\"authDomain\":\"flightline-madison-prod.firebaseapp.com\",\"databaseURL\":\"https://flightline-madison-prod-default-rtdb.firebaseio.com\",\"projectId\":\"flightline-madison-prod\",\"storageBucket\":\"flightline-madison-prod.firebasestorage.app\",\"messagingSenderId\":\"161215752472\",\"appId\":\"1:161215752472:web:0057d401a28dfa95ad566d\"},\"clientName\":\"25madison\",\"pdfViewerKey\":\"384fff5edfe5436e8177480ebd9667f0\",\"domains\":[\"25madison.flightlinedata.com\"]}");


var $b3cd63a4764f976b$exports = {};
$b3cd63a4764f976b$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyAMX7TbxOh2n2puTqQqpppeSHRf43n9W8w\",\"authDomain\":\"flightline-alon-deveopment.firebaseapp.com\",\"projectId\":\"flightline-alon-deveopment\",\"storageBucket\":\"flightline-alon-deveopment.firebasestorage.app\",\"messagingSenderId\":\"169542687669\",\"appId\":\"1:169542687669:web:f5bdc378919df9c09d57fc\"},\"clientName\":\"Alon Environment\",\"pdfViewerKey\":\"d4b849d50ed5483c8bf51f2b390223c6\",\"domains\":[\"testing-flightline.web.app\"]}");


var $38bc86d03fb49fee$exports = {};
$38bc86d03fb49fee$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyBQCCIPH1ZmKj_p_VlVG4DD5Y2lmyBByvs\",\"authDomain\":\"flightline-demo.firebaseapp.com\",\"projectId\":\"flightline-demo\",\"storageBucket\":\"flightline-demo.firebasestorage.app\",\"messagingSenderId\":\"377745278229\",\"appId\":\"1:377745278229:web:6a4256d4458f250513151c\"},\"clientName\":\"Demo Environment\",\"pdfViewerKey\":\"2ce4cb9a26e04ebd93556687712fe3db\",\"domains\":[\"flightline-demo.web.app\"],\"flowise_url\":\"https://flowise-demo.flightlinedata.com\",\"flowise_api_key\":\"N_ZfQfqWZ4c5v94WG5der6R4I81JHeTEvb-b_jIppvc\"}");


var $9c04cf844efabfe9$exports = {};
$9c04cf844efabfe9$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyClqKYOePpwnqVYRGVvETNZPbmTwljZMCk\",\"authDomain\":\"flightline-demo-3.firebaseapp.com\",\"databaseURL\":\"https://flightline-demo-3-default-rtdb.firebaseio.com\",\"projectId\":\"flightline-demo-3\",\"storageBucket\":\"flightline-demo-3.firebasestorage.app\",\"messagingSenderId\":\"376653444896\",\"appId\":\"1:376653444896:web:4b5654bad3f2205ecec945\"},\"clientName\":\"Berwind\",\"pdfViewerKey\":\"433bd4f70313453aacd60124900e6c20\",\"domains\":[\"berwind.flightlinedata.com\"]}");


var $c84686120c01498e$exports = {};
$c84686120c01498e$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyC8tivPreytHdsXxrppU-fnlH2fpmb8Pio\",\"authDomain\":\"flightline-demo-dev.firebaseapp.com\",\"databaseURL\":\"https://flightline-demo-dev-default-rtdb.firebaseio.com\",\"projectId\":\"flightline-demo-dev\",\"storageBucket\":\"flightline-demo-dev.firebasestorage.app\",\"messagingSenderId\":\"321215760873\",\"appId\":\"1:321215760873:web:0785adbdf7b1f9eb85e378\"},\"clientName\":\"Demo\",\"pdfViewerKey\":\"b6e99a26b87f41d8b9b559f10c557346\",\"domains\":[\"flightline-demo-dev.web.app\"]}");


var $33b70b8fe3d0fa23$exports = {};
$33b70b8fe3d0fa23$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyAG_1nlPDL1utbsxzUPZgncxCtY45SW5Ww\",\"authDomain\":\"flightline-harvest-prod.firebaseapp.com\",\"databaseURL\":\"https://flightline-harvest-prod-default-rtdb.firebaseio.com\",\"projectId\":\"flightline-harvest-prod\",\"storageBucket\":\"flightline-harvest-prod.firebasestorage.app\",\"messagingSenderId\":\"12613364577\",\"appId\":\"1:12613364577:web:a309dd555dc824f5cdb320\"},\"clientName\":\"Harvest\",\"pdfViewerKey\":\"dfc1f220ecc745298858395864414c6a\",\"domains\":[\"harvest.flightlinedata.com\"]}");


var $00130a4904f2fceb$exports = {};
$00130a4904f2fceb$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyBlIM4LtpCaonZkHKar-QGAh1oaHAgKgEI\",\"authDomain\":\"flightline-odyssey-1823e.firebaseapp.com\",\"databaseURL\":\"https://flightline-odyssey-1823e-default-rtdb.firebaseio.com\",\"projectId\":\"flightline-odyssey-1823e\",\"storageBucket\":\"flightline-odyssey-1823e.firebasestorage.app\",\"messagingSenderId\":\"638860155\",\"appId\":\"1:638860155:web:18c31de9ef7a84fcc6dbde\"},\"clientName\":\"Odyssey\",\"pdfViewerKey\":\"bb557ef832fa4844b1b6dd30edf887da\",\"domains\":[\"flightline-odyssey-1823e.web.app\",\"odyssey.flightlinedata.com\"]}");


var $da840342761613d6$exports = {};
$da840342761613d6$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyBu9txqgbNStiV1QmGZtBawywuUdP2KHHM\",\"authDomain\":\"flowise-test-30c33.firebaseapp.com\",\"databaseURL\":\"https://flowise-test-30c33-default-rtdb.firebaseio.com\",\"projectId\":\"flowise-test-30c33\",\"storageBucket\":\"flowise-test-30c33.firebasestorage.app\",\"messagingSenderId\":\"91380858542\",\"appId\":\"1:91380858542:web:6a9cf5fabd6e551718773f\"},\"clientName\":\"Flowise Test Env Environment\",\"pdfViewerKey\":\"71b71910e00f4cb485d49d628413168b\",\"domains\":[\"flowise-test-30c33.web.app\"],\"flowise_url\":\"https://flowise-test.flightlinedata.com\",\"flowise_api_key\":\"PhkgUfG2bBlOGgp7mmuXjQgQvBnXWGZSGTkBbwFRnDE\"}");


var $4d2c22d24cb4b027$exports = {};
$4d2c22d24cb4b027$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyAH49TGtYOjC2IA3L2QwP6BzTpUxkIdczg\",\"authDomain\":\"testing-flightline.firebaseapp.com\",\"projectId\":\"testing-flightline\",\"storageBucket\":\"testing-flightline.firebasestorage.app\",\"messagingSenderId\":\"601730080387\",\"appId\":\"1:601730080387:web:fb19d4cf586d164560c5b6\"},\"clientName\":\"Testing Environment\",\"pdfViewerKey\":\"d4b849d50ed5483c8bf51f2b390223c6\",\"domains\":[\"testing-flightline.web.app\"]}");


$685ea9875b44937b$exports = {
    "25madison": $557b93ccd0374a02$exports,
    "alon": $b3cd63a4764f976b$exports,
    "demo": $38bc86d03fb49fee$exports,
    "demo_3": $9c04cf844efabfe9$exports,
    "dev": $c84686120c01498e$exports,
    "harvest": $33b70b8fe3d0fa23$exports,
    "odyssey": $00130a4904f2fceb$exports,
    "test-env": $da840342761613d6$exports,
    "testing": $4d2c22d24cb4b027$exports
};


class $3d79bba9fc178656$var$ConfigStore {
    constructor(){
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = this.getConfigByHostname();
        (0, $3d71a0e5fc49a3ca$exports.assert)(this.config, 'Config not found');
    }
    getConfig() {
        return this.getConfigByHostname();
    }
    getConfigByHostname() {
        const host = window.location.hostname;
        for(const key in $685ea9875b44937b$exports){
            const config = $685ea9875b44937b$exports[key];
            const domains = config.domains;
            if (config.domains.includes(host)) {
                console.log('Using config hostname: ', host);
                return config;
            }
        }
        return null;
    }
}
const $3d79bba9fc178656$var$configStore = new $3d79bba9fc178656$var$ConfigStore();
const $3d79bba9fc178656$export$b3611e87cd5ba6ce = ()=>{
    return $3d79bba9fc178656$var$configStore.config;
};
var $3d79bba9fc178656$export$2e2bcd8739ae039 = $3d79bba9fc178656$var$configStore;


// This is a magic string replaced by rollup
const $ef9854b1b1bbf4cf$export$31499a9cd224b78c = "9.14.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $4546c9f85d024500$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $69b66c77e999bb3b$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $69b66c77e999bb3b$export$c8bfa33e4e8ae492((0, $4546c9f85d024500$export$f1a6cdb1459e81d1));
    return 0, $4546c9f85d024500$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $69b66c77e999bb3b$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c] = __SENTRY__[0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $69b66c77e999bb3b$export$7e223ec222791509(name, creator, obj = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c] = __SENTRY__[0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



// eslint-disable-next-line @typescript-eslint/unbound-method
const $04327917d6f3444a$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$e6127cc7fe7395c3(wat) {
    switch($04327917d6f3444a$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $04327917d6f3444a$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$var$isBuiltin(wat, className) {
    return $04327917d6f3444a$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$9f9636d330b71954(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$ef9e2056653f0c8e(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$12e869b2a583f783(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$844ec244b1367d54(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$c3825b437cbdea5c(wat) {
    return wat === null || $04327917d6f3444a$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$53b83ca8eaab0383(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $04327917d6f3444a$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $04327917d6f3444a$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$49841c62b9eff15(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $04327917d6f3444a$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$bc2894c7158efbac(wat) {
    return $04327917d6f3444a$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $04327917d6f3444a$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $04327917d6f3444a$export$49034edbe6b62415(request, Request);
}



const $d2c922fb99362c48$var$WINDOW = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
const $d2c922fb99362c48$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d2c922fb99362c48$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d2c922fb99362c48$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d2c922fb99362c48$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d2c922fb99362c48$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($d2c922fb99362c48$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $04327917d6f3444a$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $d2c922fb99362c48$export$1cfafeee2987818b() {
    try {
        return $d2c922fb99362c48$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $d2c922fb99362c48$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$d2c922fb99362c48$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $32dbb9c779accb6e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






/** Prefix for logging strings */ const $50107229405f0b55$var$PREFIX = 'Sentry Logger ';
const $50107229405f0b55$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $50107229405f0b55$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $50107229405f0b55$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $4546c9f85d024500$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($50107229405f0b55$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $50107229405f0b55$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $50107229405f0b55$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $32dbb9c779accb6e$export$16a28057038b10ef) $50107229405f0b55$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $50107229405f0b55$export$cda52e2a8927a2ca(()=>{
                (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).console[name](`${$50107229405f0b55$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $50107229405f0b55$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $50107229405f0b55$export$af88d00dbe7f521 = (0, $69b66c77e999bb3b$export$7e223ec222791509)('logger', $50107229405f0b55$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $404b08ff2be9997a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $404b08ff2be9997a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $404b08ff2be9997a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $04327917d6f3444a$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $404b08ff2be9997a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $04327917d6f3444a$export$844ec244b1367d54)(value)) return false;
    if ((0, $04327917d6f3444a$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $04327917d6f3444a$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $404b08ff2be9997a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$404b08ff2be9997a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $331e7a423c1d6bab$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $331e7a423c1d6bab$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $331e7a423c1d6bab$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $331e7a423c1d6bab$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $331e7a423c1d6bab$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $331e7a423c1d6bab$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $331e7a423c1d6bab$export$62ff257738bf57f5(value) {
    if ((0, $04327917d6f3444a$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$331e7a423c1d6bab$var$getOwnProperties(value)
    };
    else if ((0, $04327917d6f3444a$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $331e7a423c1d6bab$var$serializeEventTarget(value.target),
            currentTarget: $331e7a423c1d6bab$var$serializeEventTarget(value.currentTarget),
            ...$331e7a423c1d6bab$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $04327917d6f3444a$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $331e7a423c1d6bab$var$serializeEventTarget(target) {
    try {
        return (0, $04327917d6f3444a$export$45a5e7f76e0caa8d)(target) ? (0, $d2c922fb99362c48$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $331e7a423c1d6bab$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $331e7a423c1d6bab$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($331e7a423c1d6bab$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $404b08ff2be9997a$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $404b08ff2be9997a$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $331e7a423c1d6bab$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $331e7a423c1d6bab$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $331e7a423c1d6bab$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($331e7a423c1d6bab$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($331e7a423c1d6bab$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $331e7a423c1d6bab$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $331e7a423c1d6bab$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $331e7a423c1d6bab$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $04327917d6f3444a$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $832931c5253c6f61$var$getCrypto() {
    const gbl = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $832931c5253c6f61$export$19f53698e68b2496(crypto = $832931c5253c6f61$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $832931c5253c6f61$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $832931c5253c6f61$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $832931c5253c6f61$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $832931c5253c6f61$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $832931c5253c6f61$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $832931c5253c6f61$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $832931c5253c6f61$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $832931c5253c6f61$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $832931c5253c6f61$export$d364f2020ab30578(input) {
    const match = input.match($832931c5253c6f61$var$SEMVER_REGEXP) || [];
    const major = $832931c5253c6f61$var$_parseInt(match[1]);
    const minor = $832931c5253c6f61$var$_parseInt(match[2]);
    const patch = $832931c5253c6f61$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $832931c5253c6f61$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $404b08ff2be9997a$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $404b08ff2be9997a$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $404b08ff2be9997a$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $832931c5253c6f61$export$6de4ffac6a2f1098(exception) {
    if ($832931c5253c6f61$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $832931c5253c6f61$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $b99b0aced21a41e0$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $b99b0aced21a41e0$export$7740643b9eeaf0c4() {
    return Date.now() / $b99b0aced21a41e0$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $b99b0aced21a41e0$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $b99b0aced21a41e0$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $b99b0aced21a41e0$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $b99b0aced21a41e0$export$ee52dced521e3e18 = $b99b0aced21a41e0$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $b99b0aced21a41e0$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $b99b0aced21a41e0$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $b99b0aced21a41e0$export$baf075a948ffc0bf() {
    if (!$b99b0aced21a41e0$var$cachedTimeOrigin) $b99b0aced21a41e0$var$cachedTimeOrigin = $b99b0aced21a41e0$var$getBrowserTimeOrigin();
    return $b99b0aced21a41e0$var$cachedTimeOrigin[0];
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $933b7638f999d30c$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $b99b0aced21a41e0$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $832931c5253c6f61$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$933b7638f999d30c$var$sessionToJSON(session)
    };
    if (context) $933b7638f999d30c$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $933b7638f999d30c$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $b99b0aced21a41e0$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $832931c5253c6f61$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $933b7638f999d30c$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $933b7638f999d30c$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $933b7638f999d30c$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}






/**
 * Generate a random, valid trace ID.
 */ function $a4fae29ec8bb25f7$export$dc6d7ea554bcce10() {
    return (0, $832931c5253c6f61$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $a4fae29ec8bb25f7$export$295213bc4d0c54ad() {
    return (0, $832931c5253c6f61$export$19f53698e68b2496)().substring(16);
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $e0d3e5565e99f13e$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $e0d3e5565e99f13e$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $3384f12a46e56483$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $3384f12a46e56483$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(scope, $3384f12a46e56483$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$3384f12a46e56483$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $3384f12a46e56483$export$91f063ebb8eff307(scope) {
    return scope[$3384f12a46e56483$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $2043822b84732d98$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $2043822b84732d98$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $a4fae29ec8bb25f7$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $2043822b84732d98$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $3384f12a46e56483$export$3f25fa50c18e20ca)(newScope, (0, $3384f12a46e56483$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $933b7638f999d30c$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $2043822b84732d98$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $04327917d6f3444a$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $3384f12a46e56483$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $a4fae29ec8bb25f7$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $2043822b84732d98$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $b99b0aced21a41e0$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $404b08ff2be9997a$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $3384f12a46e56483$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $e0d3e5565e99f13e$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $832931c5253c6f61$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $832931c5253c6f61$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $832931c5253c6f61$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $4913dbcbce765e31$export$6f1b9191db9c4d5() {
    return (0, $69b66c77e999bb3b$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $2043822b84732d98$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $4913dbcbce765e31$export$de9862929b76bf57() {
    return (0, $69b66c77e999bb3b$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $2043822b84732d98$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $8efce4d24d3cc76f$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $2043822b84732d98$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $2043822b84732d98$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $04327917d6f3444a$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $8efce4d24d3cc76f$var$getAsyncContextStack() {
    const registry = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const sentry = (0, $69b66c77e999bb3b$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $8efce4d24d3cc76f$export$d36ec451f120cfba((0, $4913dbcbce765e31$export$6f1b9191db9c4d5)(), (0, $4913dbcbce765e31$export$de9862929b76bf57)());
}
function $8efce4d24d3cc76f$var$withScope(callback) {
    return $8efce4d24d3cc76f$var$getAsyncContextStack().withScope(callback);
}
function $8efce4d24d3cc76f$var$withSetScope(scope, callback) {
    const stack = $8efce4d24d3cc76f$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $8efce4d24d3cc76f$var$withIsolationScope(callback) {
    return $8efce4d24d3cc76f$var$getAsyncContextStack().withScope(()=>{
        return callback($8efce4d24d3cc76f$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $8efce4d24d3cc76f$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $8efce4d24d3cc76f$var$withIsolationScope,
        withScope: $8efce4d24d3cc76f$var$withScope,
        withSetScope: $8efce4d24d3cc76f$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $8efce4d24d3cc76f$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$8efce4d24d3cc76f$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$8efce4d24d3cc76f$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $4df7c5181b9904cb$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const sentry = (0, $69b66c77e999bb3b$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $4df7c5181b9904cb$export$f639b0c2752203be(carrier) {
    const sentry = (0, $69b66c77e999bb3b$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $8efce4d24d3cc76f$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $7579005d8c799ca0$export$c7be4b0125a10cba() {
    const carrier = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const acs = (0, $4df7c5181b9904cb$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $7579005d8c799ca0$export$68f3af03034c9e90() {
    const carrier = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const acs = (0, $4df7c5181b9904cb$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $7579005d8c799ca0$export$aa55d5ab8e05984f() {
    return (0, $69b66c77e999bb3b$export$7e223ec222791509)('globalScope', ()=>new (0, $2043822b84732d98$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $7579005d8c799ca0$export$ec58d9285c204497(...rest) {
    const carrier = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const acs = (0, $4df7c5181b9904cb$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $7579005d8c799ca0$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const acs = (0, $4df7c5181b9904cb$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $7579005d8c799ca0$export$6bb76d6eba7e258c() {
    return $7579005d8c799ca0$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $7579005d8c799ca0$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $a4fae29ec8bb25f7$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $f24718adf40977d4$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;








const $09c0eeb1390de562$export$849dbeeeda01ae98 = 'production';







/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $88d6af982193bd0a$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($88d6af982193bd0a$var$States || ($88d6af982193bd0a$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $88d6af982193bd0a$export$1fda8aa4d135f8aa(value) {
    return new $88d6af982193bd0a$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $88d6af982193bd0a$export$78e43115b553f358(reason) {
    return new $88d6af982193bd0a$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $88d6af982193bd0a$export$6f292d4960313241 {
    constructor(executor){
        this._state = $88d6af982193bd0a$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $88d6af982193bd0a$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $88d6af982193bd0a$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $88d6af982193bd0a$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $88d6af982193bd0a$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $88d6af982193bd0a$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $88d6af982193bd0a$var$States.PENDING) return;
            if ((0, $04327917d6f3444a$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($88d6af982193bd0a$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($88d6af982193bd0a$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $2b9febab9489909b$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $88d6af982193bd0a$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $f24718adf40977d4$export$16a28057038b10ef) && processor.id && result === null && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $04327917d6f3444a$export$f5b060c2914b97c8)(result)) result.then((final)=>$2b9febab9489909b$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $2b9febab9489909b$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $91867b645e9a946a$var$parsedStackResults;
let $91867b645e9a946a$var$lastKeysCount;
let $91867b645e9a946a$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $91867b645e9a946a$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($91867b645e9a946a$var$cachedFilenameDebugIds && debugIdKeys.length === $91867b645e9a946a$var$lastKeysCount) return $91867b645e9a946a$var$cachedFilenameDebugIds;
    $91867b645e9a946a$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $91867b645e9a946a$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$91867b645e9a946a$var$parsedStackResults) $91867b645e9a946a$var$parsedStackResults = {};
        const result = $91867b645e9a946a$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $91867b645e9a946a$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $91867b645e9a946a$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $91867b645e9a946a$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $91867b645e9a946a$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}





const $6eb7fa2c12e5f94a$var$STACKTRACE_FRAME_LIMIT = 50;
const $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $6eb7fa2c12e5f94a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $6eb7fa2c12e5f94a$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $6eb7fa2c12e5f94a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $6eb7fa2c12e5f94a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($6eb7fa2c12e5f94a$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $6eb7fa2c12e5f94a$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $6eb7fa2c12e5f94a$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $6eb7fa2c12e5f94a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $6eb7fa2c12e5f94a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $6eb7fa2c12e5f94a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($6eb7fa2c12e5f94a$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($6eb7fa2c12e5f94a$var$STRIP_FRAME_REGEXP.test($6eb7fa2c12e5f94a$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($6eb7fa2c12e5f94a$var$STRIP_FRAME_REGEXP.test($6eb7fa2c12e5f94a$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $6eb7fa2c12e5f94a$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $6eb7fa2c12e5f94a$var$getLastStackFrame(localStack).filename,
            function: frame.function || $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac
        }));
}
function $6eb7fa2c12e5f94a$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $6eb7fa2c12e5f94a$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $6eb7fa2c12e5f94a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $6eb7fa2c12e5f94a$var$defaultFunctionName;
        return fn.name || $6eb7fa2c12e5f94a$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $6eb7fa2c12e5f94a$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $6eb7fa2c12e5f94a$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81e4dea968b0d498$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $81e4dea968b0d498$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $81e4dea968b0d498$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $81e4dea968b0d498$export$a3295358bff77e(object, depth);
    if ($81e4dea968b0d498$var$jsonSize(normalized) > maxSize) return $81e4dea968b0d498$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $81e4dea968b0d498$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $81e4dea968b0d498$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $81e4dea968b0d498$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $81e4dea968b0d498$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $331e7a423c1d6bab$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $81e4dea968b0d498$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $81e4dea968b0d498$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $04327917d6f3444a$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $04327917d6f3444a$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $81e4dea968b0d498$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $81e4dea968b0d498$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $81e4dea968b0d498$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81e4dea968b0d498$var$jsonSize(value) {
    return $81e4dea968b0d498$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $81e4dea968b0d498$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $81e4dea968b0d498$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}






/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $a0fd9313f4cb718b$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $a0fd9313f4cb718b$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $a0fd9313f4cb718b$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $a0fd9313f4cb718b$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $a0fd9313f4cb718b$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $a0fd9313f4cb718b$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $a0fd9313f4cb718b$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $a0fd9313f4cb718b$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $a0fd9313f4cb718b$export$1efec95406bbe327 = 'sentry.profile_id';
const $a0fd9313f4cb718b$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $a0fd9313f4cb718b$export$b016f89ac1066ec = 'cache.hit';
const $a0fd9313f4cb718b$export$3110e4c3f4386399 = 'cache.key';
const $a0fd9313f4cb718b$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $a0fd9313f4cb718b$export$be7a251980e7e946 = 'http.request.method';
const $a0fd9313f4cb718b$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $a0fd9313f4cb718b$export$ff77b5fd5b2d627b = 'sentry.link.type';





const $8d4d84fb2953dc92$export$6e69537d67fa20f = 'sentry-';
const $8d4d84fb2953dc92$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $8d4d84fb2953dc92$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $8d4d84fb2953dc92$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $8d4d84fb2953dc92$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($8d4d84fb2953dc92$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($8d4d84fb2953dc92$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $8d4d84fb2953dc92$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$8d4d84fb2953dc92$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $8d4d84fb2953dc92$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $8d4d84fb2953dc92$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $04327917d6f3444a$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $8d4d84fb2953dc92$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $8d4d84fb2953dc92$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $8d4d84fb2953dc92$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $8d4d84fb2953dc92$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $8d4d84fb2953dc92$export$bdd844ddb2def819) {
            (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}




// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $3ce0cc58f6f6cba3$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $3ce0cc58f6f6cba3$export$5008da00b1b6dee6 = $3ce0cc58f6f6cba3$export$1f70765132c3c225;






const $c739fbebe9c4fc83$export$136e25984ba4a383 = 0;
const $c739fbebe9c4fc83$export$58f7963109c806fc = 1;
const $c739fbebe9c4fc83$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $c739fbebe9c4fc83$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $c739fbebe9c4fc83$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $c739fbebe9c4fc83$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $c739fbebe9c4fc83$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $c739fbebe9c4fc83$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}



const $c41596970e41417f$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $c41596970e41417f$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $c41596970e41417f$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(span, $c41596970e41417f$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(span, $c41596970e41417f$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $c41596970e41417f$export$c08fbc656a245d03(span) {
    return {
        scope: span[$c41596970e41417f$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$c41596970e41417f$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}






/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $cc2433bfd1c42bff$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}




// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $805e225f1c20308d$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $805e225f1c20308d$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($805e225f1c20308d$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $805e225f1c20308d$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $805e225f1c20308d$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $8d4d84fb2953dc92$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $a4fae29ec8bb25f7$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $805e225f1c20308d$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $805e225f1c20308d$export$f35d907436da45cf(traceId = (0, $a4fae29ec8bb25f7$export$dc6d7ea554bcce10)(), spanId = (0, $a4fae29ec8bb25f7$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $805e225f1c20308d$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $cc2433bfd1c42bff$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $cc2433bfd1c42bff$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}



// These are aligned with OpenTelemetry trace flags
const $8001bfb4d6603905$export$208d5b368507fb8b = 0x0;
const $8001bfb4d6603905$export$eb571cd9b5d98de8 = 0x1;
let $8001bfb4d6603905$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $8001bfb4d6603905$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $8001bfb4d6603905$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $8001bfb4d6603905$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $8001bfb4d6603905$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $c41596970e41417f$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $a4fae29ec8bb25f7$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $8001bfb4d6603905$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $8001bfb4d6603905$export$5caecac1caaf3a71(span);
    return (0, $805e225f1c20308d$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $8001bfb4d6603905$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $8001bfb4d6603905$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $8001bfb4d6603905$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $8001bfb4d6603905$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $8001bfb4d6603905$var$ensureTimestampInSeconds(input.getTime());
    return (0, $b99b0aced21a41e0$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $8001bfb4d6603905$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $8001bfb4d6603905$export$92d8c23565496537(span) {
    if ($8001bfb4d6603905$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($8001bfb4d6603905$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $8001bfb4d6603905$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $8001bfb4d6603905$export$3f7581298f56c6d7(endTime) || undefined,
            status: $8001bfb4d6603905$export$e238a77ea3a8cd66(status),
            op: attributes[0, $a0fd9313f4cb718b$export$1a413bd9a88fdb09],
            origin: attributes[0, $a0fd9313f4cb718b$export$cca8dd30f57f805e],
            links: $8001bfb4d6603905$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $8001bfb4d6603905$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $8001bfb4d6603905$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $8001bfb4d6603905$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $8001bfb4d6603905$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $8001bfb4d6603905$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $c739fbebe9c4fc83$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $c739fbebe9c4fc83$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $8001bfb4d6603905$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $8001bfb4d6603905$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $8001bfb4d6603905$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$8001bfb4d6603905$var$ROOT_SPAN_FIELD] || span;
    (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(childSpan, $8001bfb4d6603905$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD]) span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(span, $8001bfb4d6603905$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $8001bfb4d6603905$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD]) span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $8001bfb4d6603905$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($8001bfb4d6603905$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD] ? Array.from(span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $8001bfb4d6603905$export$c4c6a79b1260ca1b(span) {
    return span[$8001bfb4d6603905$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $8001bfb4d6603905$export$1be426a8e585c83e() {
    const carrier = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const acs = (0, $4df7c5181b9904cb$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $3384f12a46e56483$export$91f063ebb8eff307)((0, $7579005d8c799ca0$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $8001bfb4d6603905$export$d11691ff45a3e535() {
    if (!$8001bfb4d6603905$var$hasShownSpanDropWarning) {
        (0, $50107229405f0b55$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $8001bfb4d6603905$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $8001bfb4d6603905$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $a0fd9313f4cb718b$export$d7a7d984b0791405)]: 'custom',
        [(0, $a0fd9313f4cb718b$export$165ce9a229f6f050)]: name
    });
}



/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $e872f90a02880534$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $e872f90a02880534$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(spanWithMaybeDsc, $e872f90a02880534$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $e872f90a02880534$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $09c0eeb1390de562$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $e872f90a02880534$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $e872f90a02880534$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $e872f90a02880534$export$a117f995597e25df(span) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $8001bfb4d6603905$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $8001bfb4d6603905$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $a0fd9313f4cb718b$export$ccfe0a40627cc34b];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$e872f90a02880534$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $8d4d84fb2953dc92$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $e872f90a02880534$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $a0fd9313f4cb718b$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $3ce0cc58f6f6cba3$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $8001bfb4d6603905$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $c41596970e41417f$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $e872f90a02880534$export$95cf936fdacaff7b(span) {
    const dsc = $e872f90a02880534$export$a117f995597e25df(span);
    return (0, $8d4d84fb2953dc92$export$56766feef403f365)(dsc);
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $8bb3e72af3599b65$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $8bb3e72af3599b65$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $8bb3e72af3599b65$var$applySpanToEvent(event, span);
    $8bb3e72af3599b65$var$applyFingerprintToEvent(event, fingerprint);
    $8bb3e72af3599b65$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $8bb3e72af3599b65$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $8bb3e72af3599b65$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $8bb3e72af3599b65$export$b1a120a2871faa46(data, 'extra', extra);
    $8bb3e72af3599b65$export$b1a120a2871faa46(data, 'tags', tags);
    $8bb3e72af3599b65$export$b1a120a2871faa46(data, 'user', user);
    $8bb3e72af3599b65$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $e0d3e5565e99f13e$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $8bb3e72af3599b65$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $e0d3e5565e99f13e$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $8bb3e72af3599b65$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $8bb3e72af3599b65$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $8bb3e72af3599b65$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $8bb3e72af3599b65$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $8001bfb4d6603905$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $e872f90a02880534$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $8001bfb4d6603905$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $8001bfb4d6603905$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $8bb3e72af3599b65$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $84bc2afffc49348f$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $832931c5253c6f61$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $b99b0aced21a41e0$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $84bc2afffc49348f$export$d7e04067a6fbc882(prepared, options);
    $84bc2afffc49348f$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $84bc2afffc49348f$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $84bc2afffc49348f$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $7579005d8c799ca0$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $8bb3e72af3599b65$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $8bb3e72af3599b65$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $8bb3e72af3599b65$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $2b9febab9489909b$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $84bc2afffc49348f$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $84bc2afffc49348f$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $84bc2afffc49348f$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $09c0eeb1390de562$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $404b08ff2be9997a$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $84bc2afffc49348f$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $91867b645e9a946a$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $84bc2afffc49348f$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $84bc2afffc49348f$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $84bc2afffc49348f$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $81e4dea968b0d498$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $81e4dea968b0d498$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $81e4dea968b0d498$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $81e4dea968b0d498$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $81e4dea968b0d498$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $81e4dea968b0d498$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $81e4dea968b0d498$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $84bc2afffc49348f$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $2043822b84732d98$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $84bc2afffc49348f$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($84bc2afffc49348f$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($84bc2afffc49348f$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $84bc2afffc49348f$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $2043822b84732d98$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $84bc2afffc49348f$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $84bc2afffc49348f$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$84bc2afffc49348f$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $d0ea6cfcc1ddd989$export$f5282963edea4a68(exception, hint) {
    return (0, $7579005d8c799ca0$export$c7be4b0125a10cba)().captureException(exception, (0, $84bc2afffc49348f$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $d0ea6cfcc1ddd989$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $7579005d8c799ca0$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $d0ea6cfcc1ddd989$export$1462b974fdcf6ba2(event, hint) {
    return (0, $7579005d8c799ca0$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $d0ea6cfcc1ddd989$export$2f04de43fe27971a(name, context) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $d0ea6cfcc1ddd989$export$bb4922da0dd51b92(extras) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $d0ea6cfcc1ddd989$export$8e8e7789d42ed61d(key, extra) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $d0ea6cfcc1ddd989$export$74a8fb34822092e6(tags) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $d0ea6cfcc1ddd989$export$a37d07ee78eb4569(key, value) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $d0ea6cfcc1ddd989$export$8b6bb3dd62a01be2(user) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $d0ea6cfcc1ddd989$export$5d4e9fd7fac8e617() {
    return (0, $7579005d8c799ca0$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $d0ea6cfcc1ddd989$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)();
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    if (!client) (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $832931c5253c6f61$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $d0ea6cfcc1ddd989$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $d0ea6cfcc1ddd989$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $b99b0aced21a41e0$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $d0ea6cfcc1ddd989$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $7579005d8c799ca0$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $04327917d6f3444a$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $d0ea6cfcc1ddd989$export$4909b86c8034bf73(timeout) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $d0ea6cfcc1ddd989$export$8360e631d277ea4d(timeout) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $d0ea6cfcc1ddd989$export$3f95c6f800b78024() {
    return !!(0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $d0ea6cfcc1ddd989$export$3b029eb57ac4d562() {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $d0ea6cfcc1ddd989$export$9aac0b9f77928fbf(callback) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $d0ea6cfcc1ddd989$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $7579005d8c799ca0$export$68f3af03034c9e90)();
    const currentScope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $933b7638f999d30c$export$14a186326edbb264)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $933b7638f999d30c$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $d0ea6cfcc1ddd989$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $d0ea6cfcc1ddd989$export$17a5be43989a0bc1() {
    const isolationScope = (0, $7579005d8c799ca0$export$68f3af03034c9e90)();
    const currentScope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $933b7638f999d30c$export$56521d9ba90f62ee)(session);
    $d0ea6cfcc1ddd989$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $d0ea6cfcc1ddd989$var$_sendSessionUpdate() {
    const isolationScope = (0, $7579005d8c799ca0$export$68f3af03034c9e90)();
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $d0ea6cfcc1ddd989$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $d0ea6cfcc1ddd989$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $d0ea6cfcc1ddd989$var$_sendSessionUpdate();
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $djlMn = parcelRequire("djlMn");
const $474ae12482b554c6$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $474ae12482b554c6$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $474ae12482b554c6$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $474ae12482b554c6$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $474ae12482b554c6$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $474ae12482b554c6$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $474ae12482b554c6$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $474ae12482b554c6$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($474ae12482b554c6$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $474ae12482b554c6$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $474ae12482b554c6$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $474ae12482b554c6$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $474ae12482b554c6$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $474ae12482b554c6$var$stringToByteArray$1(str);
    return $474ae12482b554c6$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $474ae12482b554c6$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $474ae12482b554c6$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $474ae12482b554c6$export$c62426fdd000a97e = function(str) {
    try {
        return $474ae12482b554c6$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $474ae12482b554c6$export$6c40052bed430212(value) {
    return $474ae12482b554c6$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $474ae12482b554c6$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$474ae12482b554c6$var$isValidKey(prop)) continue;
        target[prop] = $474ae12482b554c6$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $474ae12482b554c6$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $474ae12482b554c6$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $474ae12482b554c6$var$getDefaultsFromGlobal = ()=>$474ae12482b554c6$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $474ae12482b554c6$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $djlMn === 'undefined' || typeof $djlMn.env === 'undefined') return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $474ae12482b554c6$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $474ae12482b554c6$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $474ae12482b554c6$export$212bb2fc580a90a8 = ()=>{
    try {
        return $474ae12482b554c6$var$getDefaultsFromGlobal() || $474ae12482b554c6$var$getDefaultsFromEnvVariable() || $474ae12482b554c6$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $474ae12482b554c6$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $474ae12482b554c6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $474ae12482b554c6$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $474ae12482b554c6$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $474ae12482b554c6$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $474ae12482b554c6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $474ae12482b554c6$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $474ae12482b554c6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $474ae12482b554c6$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $474ae12482b554c6$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $474ae12482b554c6$export$4b5284a3025a455(JSON.stringify(header)),
        $474ae12482b554c6$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $474ae12482b554c6$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $474ae12482b554c6$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($474ae12482b554c6$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $474ae12482b554c6$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $474ae12482b554c6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $474ae12482b554c6$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $474ae12482b554c6$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $474ae12482b554c6$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $474ae12482b554c6$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $474ae12482b554c6$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $474ae12482b554c6$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $474ae12482b554c6$export$f2f6a8999f8ebd30() {
    return $474ae12482b554c6$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $474ae12482b554c6$export$7e7b1a9668aaed8() {
    const ua = $474ae12482b554c6$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $474ae12482b554c6$export$202944b2d2824246() {
    return $474ae12482b554c6$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $474ae12482b554c6$export$5d1d834fbbf8bab7() {
    return $474ae12482b554c6$export$588c7fdda06fbb0a.NODE_CLIENT === true || $474ae12482b554c6$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $474ae12482b554c6$export$95df08bae54cb4df() {
    return !$474ae12482b554c6$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $474ae12482b554c6$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $474ae12482b554c6$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $474ae12482b554c6$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $474ae12482b554c6$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $474ae12482b554c6$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $474ae12482b554c6$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $474ae12482b554c6$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $474ae12482b554c6$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $474ae12482b554c6$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $474ae12482b554c6$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $474ae12482b554c6$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $474ae12482b554c6$var$replaceTemplate(template, data) {
    return template.replace($474ae12482b554c6$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $474ae12482b554c6$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $474ae12482b554c6$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $474ae12482b554c6$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $474ae12482b554c6$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $474ae12482b554c6$export$c5a53ce6a17cf18d($474ae12482b554c6$export$c62426fdd000a97e(parts[0]) || '');
        claims = $474ae12482b554c6$export$c5a53ce6a17cf18d($474ae12482b554c6$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $474ae12482b554c6$export$5f870fcca7ae6a88 = function(token) {
    const claims = $474ae12482b554c6$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $474ae12482b554c6$export$701c661ec91095f2 = function(token) {
    const claims = $474ae12482b554c6$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $474ae12482b554c6$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $474ae12482b554c6$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $474ae12482b554c6$export$fc970ed23da99565 = function(token) {
    const claims = $474ae12482b554c6$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $474ae12482b554c6$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $474ae12482b554c6$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $474ae12482b554c6$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $474ae12482b554c6$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $474ae12482b554c6$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($474ae12482b554c6$var$isObject(aProp) && $474ae12482b554c6$var$isObject(bProp)) {
            if (!$474ae12482b554c6$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $474ae12482b554c6$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $474ae12482b554c6$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $474ae12482b554c6$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $474ae12482b554c6$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $474ae12482b554c6$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $474ae12482b554c6$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $474ae12482b554c6$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $474ae12482b554c6$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $474ae12482b554c6$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $474ae12482b554c6$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($474ae12482b554c6$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $474ae12482b554c6$var$noop;
        if (observer.error === undefined) observer.error = $474ae12482b554c6$var$noop;
        if (observer.complete === undefined) observer.complete = $474ae12482b554c6$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $474ae12482b554c6$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $474ae12482b554c6$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $474ae12482b554c6$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $474ae12482b554c6$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $474ae12482b554c6$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $474ae12482b554c6$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($474ae12482b554c6$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $474ae12482b554c6$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($474ae12482b554c6$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $474ae12482b554c6$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($474ae12482b554c6$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $474ae12482b554c6$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $474ae12482b554c6$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $474ae12482b554c6$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $474ae12482b554c6$export$abe4376e1bf796d6 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $474ae12482b554c6$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $474ae12482b554c6$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $474ae12482b554c6$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $474ae12482b554c6$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $474ae12482b554c6$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $474ae12482b554c6$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $474ae12482b554c6$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $474ae12482b554c6$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($474ae12482b554c6$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $474ae12482b554c6$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $474ae12482b554c6$var$indicator(i);
}
function $474ae12482b554c6$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $474ae12482b554c6$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $51d4719ad519d4e6$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $51d4719ad519d4e6$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($51d4719ad519d4e6$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $51d4719ad519d4e6$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $51d4719ad519d4e6$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $51d4719ad519d4e6$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $51d4719ad519d4e6$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $51d4719ad519d4e6$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $6cbcb85fb6f607fa$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $6cbcb85fb6f607fa$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($6cbcb85fb6f607fa$export$243e62d78d3b544d || ($6cbcb85fb6f607fa$export$243e62d78d3b544d = {}));
const $6cbcb85fb6f607fa$var$levelStringToEnum = {
    'debug': $6cbcb85fb6f607fa$export$243e62d78d3b544d.DEBUG,
    'verbose': $6cbcb85fb6f607fa$export$243e62d78d3b544d.VERBOSE,
    'info': $6cbcb85fb6f607fa$export$243e62d78d3b544d.INFO,
    'warn': $6cbcb85fb6f607fa$export$243e62d78d3b544d.WARN,
    'error': $6cbcb85fb6f607fa$export$243e62d78d3b544d.ERROR,
    'silent': $6cbcb85fb6f607fa$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $6cbcb85fb6f607fa$var$defaultLogLevel = $6cbcb85fb6f607fa$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $6cbcb85fb6f607fa$var$ConsoleMethod = {
    [$6cbcb85fb6f607fa$export$243e62d78d3b544d.DEBUG]: 'log',
    [$6cbcb85fb6f607fa$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$6cbcb85fb6f607fa$export$243e62d78d3b544d.INFO]: 'info',
    [$6cbcb85fb6f607fa$export$243e62d78d3b544d.WARN]: 'warn',
    [$6cbcb85fb6f607fa$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $6cbcb85fb6f607fa$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $6cbcb85fb6f607fa$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $6cbcb85fb6f607fa$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $6cbcb85fb6f607fa$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $6cbcb85fb6f607fa$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $6cbcb85fb6f607fa$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $6cbcb85fb6f607fa$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $6cbcb85fb6f607fa$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $6cbcb85fb6f607fa$export$c622e99c0ce7b1c9(level) {
    $6cbcb85fb6f607fa$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $6cbcb85fb6f607fa$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $6cbcb85fb6f607fa$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $6cbcb85fb6f607fa$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $6cbcb85fb6f607fa$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $d1e222ab0dd68be4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $d1e222ab0dd68be4$var$idbProxyableTypes;
let $d1e222ab0dd68be4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $d1e222ab0dd68be4$var$getIdbProxyableTypes() {
    return $d1e222ab0dd68be4$var$idbProxyableTypes || ($d1e222ab0dd68be4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $d1e222ab0dd68be4$var$getCursorAdvanceMethods() {
    return $d1e222ab0dd68be4$var$cursorAdvanceMethods || ($d1e222ab0dd68be4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $d1e222ab0dd68be4$var$cursorRequestMap = new WeakMap();
const $d1e222ab0dd68be4$var$transactionDoneMap = new WeakMap();
const $d1e222ab0dd68be4$var$transactionStoreNamesMap = new WeakMap();
const $d1e222ab0dd68be4$var$transformCache = new WeakMap();
const $d1e222ab0dd68be4$export$407448d2b89b1813 = new WeakMap();
function $d1e222ab0dd68be4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($d1e222ab0dd68be4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $d1e222ab0dd68be4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $d1e222ab0dd68be4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $d1e222ab0dd68be4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($d1e222ab0dd68be4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $d1e222ab0dd68be4$var$transactionDoneMap.set(tx, done);
}
let $d1e222ab0dd68be4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $d1e222ab0dd68be4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $d1e222ab0dd68be4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $d1e222ab0dd68be4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $d1e222ab0dd68be4$export$43caf9889c228507(callback) {
    $d1e222ab0dd68be4$var$idbProxyTraps = callback($d1e222ab0dd68be4$var$idbProxyTraps);
}
function $d1e222ab0dd68be4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($d1e222ab0dd68be4$export$3b14a55fb2447963(this), storeNames, ...args);
        $d1e222ab0dd68be4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $d1e222ab0dd68be4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($d1e222ab0dd68be4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($d1e222ab0dd68be4$export$3b14a55fb2447963(this), args);
        return $d1e222ab0dd68be4$export$efccba1c4a2ef57b($d1e222ab0dd68be4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $d1e222ab0dd68be4$export$efccba1c4a2ef57b(func.apply($d1e222ab0dd68be4$export$3b14a55fb2447963(this), args));
    };
}
function $d1e222ab0dd68be4$var$transformCachableValue(value) {
    if (typeof value === 'function') return $d1e222ab0dd68be4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $d1e222ab0dd68be4$var$cacheDonePromiseForTransaction(value);
    if ($d1e222ab0dd68be4$export$23f2a1d2818174ef(value, $d1e222ab0dd68be4$var$getIdbProxyableTypes())) return new Proxy(value, $d1e222ab0dd68be4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $d1e222ab0dd68be4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $d1e222ab0dd68be4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($d1e222ab0dd68be4$var$transformCache.has(value)) return $d1e222ab0dd68be4$var$transformCache.get(value);
    const newValue = $d1e222ab0dd68be4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $d1e222ab0dd68be4$var$transformCache.set(value, newValue);
        $d1e222ab0dd68be4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $d1e222ab0dd68be4$export$3b14a55fb2447963 = (value)=>$d1e222ab0dd68be4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $a2c995df3f0fbbe6$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $d1e222ab0dd68be4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $d1e222ab0dd68be4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $d1e222ab0dd68be4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $a2c995df3f0fbbe6$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $d1e222ab0dd68be4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $a2c995df3f0fbbe6$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $a2c995df3f0fbbe6$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $a2c995df3f0fbbe6$var$cachedMethods = new Map();
function $a2c995df3f0fbbe6$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($a2c995df3f0fbbe6$var$cachedMethods.get(prop)) return $a2c995df3f0fbbe6$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $a2c995df3f0fbbe6$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $a2c995df3f0fbbe6$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $a2c995df3f0fbbe6$var$cachedMethods.set(prop, method);
    return method;
}
(0, $d1e222ab0dd68be4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$a2c995df3f0fbbe6$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$a2c995df3f0fbbe6$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20ed53392b3edc61$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($20ed53392b3edc61$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $20ed53392b3edc61$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $20ed53392b3edc61$var$name$q = "@firebase/app";
const $20ed53392b3edc61$var$version$1 = "0.10.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20ed53392b3edc61$var$logger = new (0, $6cbcb85fb6f607fa$export$efa9a398d6368992)('@firebase/app');
const $20ed53392b3edc61$var$name$p = "@firebase/app-compat";
const $20ed53392b3edc61$var$name$o = "@firebase/analytics-compat";
const $20ed53392b3edc61$var$name$n = "@firebase/analytics";
const $20ed53392b3edc61$var$name$m = "@firebase/app-check-compat";
const $20ed53392b3edc61$var$name$l = "@firebase/app-check";
const $20ed53392b3edc61$var$name$k = "@firebase/auth";
const $20ed53392b3edc61$var$name$j = "@firebase/auth-compat";
const $20ed53392b3edc61$var$name$i = "@firebase/database";
const $20ed53392b3edc61$var$name$h = "@firebase/data-connect";
const $20ed53392b3edc61$var$name$g = "@firebase/database-compat";
const $20ed53392b3edc61$var$name$f = "@firebase/functions";
const $20ed53392b3edc61$var$name$e = "@firebase/functions-compat";
const $20ed53392b3edc61$var$name$d = "@firebase/installations";
const $20ed53392b3edc61$var$name$c = "@firebase/installations-compat";
const $20ed53392b3edc61$var$name$b = "@firebase/messaging";
const $20ed53392b3edc61$var$name$a = "@firebase/messaging-compat";
const $20ed53392b3edc61$var$name$9 = "@firebase/performance";
const $20ed53392b3edc61$var$name$8 = "@firebase/performance-compat";
const $20ed53392b3edc61$var$name$7 = "@firebase/remote-config";
const $20ed53392b3edc61$var$name$6 = "@firebase/remote-config-compat";
const $20ed53392b3edc61$var$name$5 = "@firebase/storage";
const $20ed53392b3edc61$var$name$4 = "@firebase/storage-compat";
const $20ed53392b3edc61$var$name$3 = "@firebase/firestore";
const $20ed53392b3edc61$var$name$2 = "@firebase/vertexai-preview";
const $20ed53392b3edc61$var$name$1 = "@firebase/firestore-compat";
const $20ed53392b3edc61$var$name = "firebase";
const $20ed53392b3edc61$var$version = "10.14.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $20ed53392b3edc61$export$9f30fa0c10967f7f = '[DEFAULT]';
const $20ed53392b3edc61$var$PLATFORM_LOG_STRING = {
    [$20ed53392b3edc61$var$name$q]: 'fire-core',
    [$20ed53392b3edc61$var$name$p]: 'fire-core-compat',
    [$20ed53392b3edc61$var$name$n]: 'fire-analytics',
    [$20ed53392b3edc61$var$name$o]: 'fire-analytics-compat',
    [$20ed53392b3edc61$var$name$l]: 'fire-app-check',
    [$20ed53392b3edc61$var$name$m]: 'fire-app-check-compat',
    [$20ed53392b3edc61$var$name$k]: 'fire-auth',
    [$20ed53392b3edc61$var$name$j]: 'fire-auth-compat',
    [$20ed53392b3edc61$var$name$i]: 'fire-rtdb',
    [$20ed53392b3edc61$var$name$h]: 'fire-data-connect',
    [$20ed53392b3edc61$var$name$g]: 'fire-rtdb-compat',
    [$20ed53392b3edc61$var$name$f]: 'fire-fn',
    [$20ed53392b3edc61$var$name$e]: 'fire-fn-compat',
    [$20ed53392b3edc61$var$name$d]: 'fire-iid',
    [$20ed53392b3edc61$var$name$c]: 'fire-iid-compat',
    [$20ed53392b3edc61$var$name$b]: 'fire-fcm',
    [$20ed53392b3edc61$var$name$a]: 'fire-fcm-compat',
    [$20ed53392b3edc61$var$name$9]: 'fire-perf',
    [$20ed53392b3edc61$var$name$8]: 'fire-perf-compat',
    [$20ed53392b3edc61$var$name$7]: 'fire-rc',
    [$20ed53392b3edc61$var$name$6]: 'fire-rc-compat',
    [$20ed53392b3edc61$var$name$5]: 'fire-gcs',
    [$20ed53392b3edc61$var$name$4]: 'fire-gcs-compat',
    [$20ed53392b3edc61$var$name$3]: 'fire-fst',
    [$20ed53392b3edc61$var$name$1]: 'fire-fst-compat',
    [$20ed53392b3edc61$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$20ed53392b3edc61$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $20ed53392b3edc61$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $20ed53392b3edc61$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $20ed53392b3edc61$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $20ed53392b3edc61$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $20ed53392b3edc61$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $20ed53392b3edc61$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $20ed53392b3edc61$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($20ed53392b3edc61$export$9566bce3835c0f28.has(componentName)) {
        $20ed53392b3edc61$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $20ed53392b3edc61$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $20ed53392b3edc61$export$b4e3c36c855b14b5.values())$20ed53392b3edc61$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $20ed53392b3edc61$export$fb03ad8d3d5c5f76.values())$20ed53392b3edc61$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $20ed53392b3edc61$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $20ed53392b3edc61$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $20ed53392b3edc61$export$9f30fa0c10967f7f) {
    $20ed53392b3edc61$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $20ed53392b3edc61$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $20ed53392b3edc61$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $20ed53392b3edc61$export$3685d89b9c3cdfaf() {
    $20ed53392b3edc61$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20ed53392b3edc61$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $20ed53392b3edc61$var$ERROR_FACTORY = new (0, $474ae12482b554c6$export$3fa6e1b18a3b2d40)('app', 'Firebase', $20ed53392b3edc61$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20ed53392b3edc61$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $20ed53392b3edc61$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20ed53392b3edc61$var$FirebaseServerAppImpl extends $20ed53392b3edc61$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $20ed53392b3edc61$export$d29d5299a7137abc($20ed53392b3edc61$var$name$q, $20ed53392b3edc61$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $20ed53392b3edc61$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $20ed53392b3edc61$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $20ed53392b3edc61$export$31499a9cd224b78c = $20ed53392b3edc61$var$version;
function $20ed53392b3edc61$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $20ed53392b3edc61$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $20ed53392b3edc61$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $474ae12482b554c6$export$3dfb6827a9f89756)());
    if (!options) throw $20ed53392b3edc61$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $20ed53392b3edc61$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $474ae12482b554c6$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $474ae12482b554c6$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $20ed53392b3edc61$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $51d4719ad519d4e6$export$436a80eea5d5c0c5)(name);
    for (const component of $20ed53392b3edc61$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $20ed53392b3edc61$var$FirebaseAppImpl(options, config, container);
    $20ed53392b3edc61$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $20ed53392b3edc61$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $474ae12482b554c6$export$4e09c449d6c407f7)() && !(0, $474ae12482b554c6$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $20ed53392b3edc61$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($20ed53392b3edc61$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $20ed53392b3edc61$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $20ed53392b3edc61$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $51d4719ad519d4e6$export$436a80eea5d5c0c5)(nameString);
    for (const component of $20ed53392b3edc61$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $20ed53392b3edc61$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $20ed53392b3edc61$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $20ed53392b3edc61$export$f9962582c9e66d99(name = $20ed53392b3edc61$export$9f30fa0c10967f7f) {
    const app = $20ed53392b3edc61$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $20ed53392b3edc61$export$9f30fa0c10967f7f && (0, $474ae12482b554c6$export$3dfb6827a9f89756)()) return $20ed53392b3edc61$export$c55cfd413944906d();
    if (!app) throw $20ed53392b3edc61$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $20ed53392b3edc61$export$68ddedf7d44b3bdf() {
    return Array.from($20ed53392b3edc61$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $20ed53392b3edc61$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($20ed53392b3edc61$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $20ed53392b3edc61$export$b4e3c36c855b14b5.delete(name);
    } else if ($20ed53392b3edc61$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $20ed53392b3edc61$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $20ed53392b3edc61$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $20ed53392b3edc61$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $20ed53392b3edc61$var$logger.warn(warning.join(' '));
        return;
    }
    $20ed53392b3edc61$export$c930050e7bb63965(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $20ed53392b3edc61$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $20ed53392b3edc61$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $6cbcb85fb6f607fa$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $20ed53392b3edc61$export$c622e99c0ce7b1c9(logLevel) {
    (0, $6cbcb85fb6f607fa$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20ed53392b3edc61$var$DB_NAME = 'firebase-heartbeat-database';
const $20ed53392b3edc61$var$DB_VERSION = 1;
const $20ed53392b3edc61$var$STORE_NAME = 'firebase-heartbeat-store';
let $20ed53392b3edc61$var$dbPromise = null;
function $20ed53392b3edc61$var$getDbPromise() {
    if (!$20ed53392b3edc61$var$dbPromise) $20ed53392b3edc61$var$dbPromise = (0, $a2c995df3f0fbbe6$export$ca0ed41b1a2af7e)($20ed53392b3edc61$var$DB_NAME, $20ed53392b3edc61$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($20ed53392b3edc61$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $20ed53392b3edc61$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $20ed53392b3edc61$var$dbPromise;
}
async function $20ed53392b3edc61$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $20ed53392b3edc61$var$getDbPromise();
        const tx = db.transaction($20ed53392b3edc61$var$STORE_NAME);
        const result = await tx.objectStore($20ed53392b3edc61$var$STORE_NAME).get($20ed53392b3edc61$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $474ae12482b554c6$export$dd24e9cd51226c56)) $20ed53392b3edc61$var$logger.warn(e.message);
        else {
            const idbGetError = $20ed53392b3edc61$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $20ed53392b3edc61$var$logger.warn(idbGetError.message);
        }
    }
}
async function $20ed53392b3edc61$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $20ed53392b3edc61$var$getDbPromise();
        const tx = db.transaction($20ed53392b3edc61$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($20ed53392b3edc61$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $20ed53392b3edc61$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $474ae12482b554c6$export$dd24e9cd51226c56)) $20ed53392b3edc61$var$logger.warn(e.message);
        else {
            const idbGetError = $20ed53392b3edc61$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $20ed53392b3edc61$var$logger.warn(idbGetError.message);
        }
    }
}
function $20ed53392b3edc61$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20ed53392b3edc61$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $20ed53392b3edc61$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $20ed53392b3edc61$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $20ed53392b3edc61$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $20ed53392b3edc61$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({
                date: date,
                agent: agent
            });
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
                const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                const now = Date.now();
                return now - hbTimestamp <= $20ed53392b3edc61$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
            });
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $20ed53392b3edc61$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $20ed53392b3edc61$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $20ed53392b3edc61$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $474ae12482b554c6$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $20ed53392b3edc61$var$logger.warn(e);
            return '';
        }
    }
}
function $20ed53392b3edc61$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $20ed53392b3edc61$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $20ed53392b3edc61$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($20ed53392b3edc61$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($20ed53392b3edc61$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $20ed53392b3edc61$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $474ae12482b554c6$export$3865db50535c2055)()) return false;
        else return (0, $474ae12482b554c6$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $20ed53392b3edc61$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $20ed53392b3edc61$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $20ed53392b3edc61$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $20ed53392b3edc61$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $474ae12482b554c6$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $20ed53392b3edc61$var$registerCoreComponents(variant) {
    $20ed53392b3edc61$export$c930050e7bb63965(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('platform-logger', (container)=>new $20ed53392b3edc61$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $20ed53392b3edc61$export$c930050e7bb63965(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('heartbeat', (container)=>new $20ed53392b3edc61$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $20ed53392b3edc61$export$d29d5299a7137abc($20ed53392b3edc61$var$name$q, $20ed53392b3edc61$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $20ed53392b3edc61$export$d29d5299a7137abc($20ed53392b3edc61$var$name$q, $20ed53392b3edc61$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $20ed53392b3edc61$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $20ed53392b3edc61$var$registerCoreComponents('');


var $de96275166ad8d09$var$name = "firebase";
var $de96275166ad8d09$var$version = "10.14.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $20ed53392b3edc61$export$d29d5299a7137abc)($de96275166ad8d09$var$name, $de96275166ad8d09$var$version, 'app');





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $7c9d35c24923c1be$var$extendStatics = function(d, b) {
    $7c9d35c24923c1be$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $7c9d35c24923c1be$var$extendStatics(d, b);
};
function $7c9d35c24923c1be$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $7c9d35c24923c1be$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7c9d35c24923c1be$export$18ce0697a983be9b = function() {
    $7c9d35c24923c1be$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7c9d35c24923c1be$export$18ce0697a983be9b.apply(this, arguments);
};
function $7c9d35c24923c1be$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7c9d35c24923c1be$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7c9d35c24923c1be$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7c9d35c24923c1be$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $7c9d35c24923c1be$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $7c9d35c24923c1be$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $7c9d35c24923c1be$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $7c9d35c24923c1be$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7c9d35c24923c1be$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7c9d35c24923c1be$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $7c9d35c24923c1be$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $7c9d35c24923c1be$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $7c9d35c24923c1be$export$45d3717a4c69092e(o, m, p);
}
function $7c9d35c24923c1be$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7c9d35c24923c1be$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7c9d35c24923c1be$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7c9d35c24923c1be$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7c9d35c24923c1be$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7c9d35c24923c1be$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $7c9d35c24923c1be$export$10c90e4f7922046c(v) {
    return this instanceof $7c9d35c24923c1be$export$10c90e4f7922046c ? (this.v = v, this) : new $7c9d35c24923c1be$export$10c90e4f7922046c(v);
}
function $7c9d35c24923c1be$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7c9d35c24923c1be$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7c9d35c24923c1be$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7c9d35c24923c1be$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $7c9d35c24923c1be$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7c9d35c24923c1be$export$19a8beecd37a4c45 === "function" ? $7c9d35c24923c1be$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7c9d35c24923c1be$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $7c9d35c24923c1be$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $7c9d35c24923c1be$var$ownKeys = function(o) {
    $7c9d35c24923c1be$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $7c9d35c24923c1be$var$ownKeys(o);
};
function $7c9d35c24923c1be$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $7c9d35c24923c1be$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $7c9d35c24923c1be$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $7c9d35c24923c1be$var$__setModuleDefault(result, mod);
    return result;
}
function $7c9d35c24923c1be$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7c9d35c24923c1be$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $7c9d35c24923c1be$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $7c9d35c24923c1be$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $7c9d35c24923c1be$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $7c9d35c24923c1be$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $7c9d35c24923c1be$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $7c9d35c24923c1be$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $7c9d35c24923c1be$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $7c9d35c24923c1be$export$2e2bcd8739ae039 = {
    __extends: $7c9d35c24923c1be$export$a8ba968b8961cb8a,
    __assign: $7c9d35c24923c1be$export$18ce0697a983be9b,
    __rest: $7c9d35c24923c1be$export$3c9a16f847548506,
    __decorate: $7c9d35c24923c1be$export$29e00dfd3077644b,
    __param: $7c9d35c24923c1be$export$d5ad3fd78186038f,
    __esDecorate: $7c9d35c24923c1be$export$3a84e1ae4e97e9b0,
    __runInitializers: $7c9d35c24923c1be$export$d831c04e792af3d,
    __propKey: $7c9d35c24923c1be$export$6a2a36740a146cb8,
    __setFunctionName: $7c9d35c24923c1be$export$d1a06452d3489bc7,
    __metadata: $7c9d35c24923c1be$export$f1db080c865becb9,
    __awaiter: $7c9d35c24923c1be$export$1050f835b63b671e,
    __generator: $7c9d35c24923c1be$export$67ebef60e6f28a6,
    __createBinding: $7c9d35c24923c1be$export$45d3717a4c69092e,
    __exportStar: $7c9d35c24923c1be$export$f33643c0debef087,
    __values: $7c9d35c24923c1be$export$19a8beecd37a4c45,
    __read: $7c9d35c24923c1be$export$8d051b38c9118094,
    __spread: $7c9d35c24923c1be$export$afc72e2116322959,
    __spreadArrays: $7c9d35c24923c1be$export$6388937ca91ccae8,
    __spreadArray: $7c9d35c24923c1be$export$1216008129fb82ed,
    __await: $7c9d35c24923c1be$export$10c90e4f7922046c,
    __asyncGenerator: $7c9d35c24923c1be$export$e427f37a30a4de9b,
    __asyncDelegator: $7c9d35c24923c1be$export$bbd80228419bb833,
    __asyncValues: $7c9d35c24923c1be$export$e3b29a3d6162315f,
    __makeTemplateObject: $7c9d35c24923c1be$export$4fb47efe1390b86f,
    __importStar: $7c9d35c24923c1be$export$c21735bcef00d192,
    __importDefault: $7c9d35c24923c1be$export$da59b14a69baef04,
    __classPrivateFieldGet: $7c9d35c24923c1be$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $7c9d35c24923c1be$export$d40a35129aaff81f,
    __classPrivateFieldIn: $7c9d35c24923c1be$export$81fdc39f203e4e04,
    __addDisposableResource: $7c9d35c24923c1be$export$88ac25d8e944e405,
    __disposeResources: $7c9d35c24923c1be$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $7c9d35c24923c1be$export$889dfb5d17574b0b
};



/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $402d0a489f4b5d89$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $402d0a489f4b5d89$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $402d0a489f4b5d89$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $402d0a489f4b5d89$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $402d0a489f4b5d89$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.'
    };
}
function $402d0a489f4b5d89$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $402d0a489f4b5d89$export$2329c99376c9d0a4 = $402d0a489f4b5d89$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $402d0a489f4b5d89$export$7f8ddf7c7c20b3cd = $402d0a489f4b5d89$var$_prodErrorMap;
const $402d0a489f4b5d89$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $474ae12482b554c6$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $402d0a489f4b5d89$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $402d0a489f4b5d89$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$logClient = new (0, $6cbcb85fb6f607fa$export$efa9a398d6368992)('@firebase/auth');
function $402d0a489f4b5d89$var$_logWarn(msg, ...args) {
    if ($402d0a489f4b5d89$var$logClient.logLevel <= (0, $6cbcb85fb6f607fa$export$243e62d78d3b544d).WARN) $402d0a489f4b5d89$var$logClient.warn(`Auth (${(0, $20ed53392b3edc61$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $402d0a489f4b5d89$var$_logError(msg, ...args) {
    if ($402d0a489f4b5d89$var$logClient.logLevel <= (0, $6cbcb85fb6f607fa$export$243e62d78d3b544d).ERROR) $402d0a489f4b5d89$var$logClient.error(`Auth (${(0, $20ed53392b3edc61$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $402d0a489f4b5d89$var$createErrorInternal(authOrCode, ...rest);
}
function $402d0a489f4b5d89$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $402d0a489f4b5d89$var$createErrorInternal(authOrCode, ...rest);
}
function $402d0a489f4b5d89$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $402d0a489f4b5d89$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $474ae12482b554c6$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $402d0a489f4b5d89$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $402d0a489f4b5d89$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $402d0a489f4b5d89$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $402d0a489f4b5d89$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $402d0a489f4b5d89$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $402d0a489f4b5d89$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $402d0a489f4b5d89$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $402d0a489f4b5d89$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $402d0a489f4b5d89$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $402d0a489f4b5d89$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $402d0a489f4b5d89$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$_getCurrentUrl() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || '';
}
function $402d0a489f4b5d89$var$_isHttpOrHttps() {
    return $402d0a489f4b5d89$var$_getCurrentScheme() === 'http:' || $402d0a489f4b5d89$var$_getCurrentScheme() === 'https:';
}
function $402d0a489f4b5d89$var$_getCurrentScheme() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $402d0a489f4b5d89$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($402d0a489f4b5d89$var$_isHttpOrHttps() || (0, $474ae12482b554c6$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $402d0a489f4b5d89$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $402d0a489f4b5d89$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $402d0a489f4b5d89$export$1fbe638ecf81657e(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $474ae12482b554c6$export$872f8323f01d7ae0)() || (0, $474ae12482b554c6$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$402d0a489f4b5d89$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$_emulatorUrl(config, path) {
    $402d0a489f4b5d89$export$1fbe638ecf81657e(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $402d0a489f4b5d89$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $402d0a489f4b5d89$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $402d0a489f4b5d89$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $402d0a489f4b5d89$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$DEFAULT_API_TIMEOUT_MS = new $402d0a489f4b5d89$var$Delay(30000, 60000);
function $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $402d0a489f4b5d89$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $402d0a489f4b5d89$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $474ae12482b554c6$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = Object.assign({
            method: method,
            headers: headers
        }, body);
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $474ae12482b554c6$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = 'no-referrer';
        return $402d0a489f4b5d89$export$2ed0fc6709e59212.fetch()($402d0a489f4b5d89$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $402d0a489f4b5d89$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $402d0a489f4b5d89$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $402d0a489f4b5d89$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $402d0a489f4b5d89$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $402d0a489f4b5d89$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $402d0a489f4b5d89$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $402d0a489f4b5d89$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $402d0a489f4b5d89$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $474ae12482b554c6$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $402d0a489f4b5d89$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $402d0a489f4b5d89$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $402d0a489f4b5d89$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $402d0a489f4b5d89$var$_emulatorUrl(auth.config, base);
}
function $402d0a489f4b5d89$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $402d0a489f4b5d89$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($402d0a489f4b5d89$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $402d0a489f4b5d89$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $402d0a489f4b5d89$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $402d0a489f4b5d89$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $402d0a489f4b5d89$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $402d0a489f4b5d89$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $402d0a489f4b5d89$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$getRecaptchaParams(auth) {
    return (await $402d0a489f4b5d89$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $402d0a489f4b5d89$var$getRecaptchaConfig(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$deleteAccount(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $402d0a489f4b5d89$var$deleteLinkedAccounts(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $402d0a489f4b5d89$var$getAccountInfo(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $402d0a489f4b5d89$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $402d0a489f4b5d89$var$_parseToken(token);
    $402d0a489f4b5d89$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $402d0a489f4b5d89$var$utcTimestampToDateString($402d0a489f4b5d89$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $402d0a489f4b5d89$var$utcTimestampToDateString($402d0a489f4b5d89$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $402d0a489f4b5d89$var$utcTimestampToDateString($402d0a489f4b5d89$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function $402d0a489f4b5d89$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $402d0a489f4b5d89$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $402d0a489f4b5d89$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $474ae12482b554c6$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $402d0a489f4b5d89$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $402d0a489f4b5d89$var$_logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $402d0a489f4b5d89$var$_tokenExpiresIn(token) {
    const parsedToken = $402d0a489f4b5d89$var$_parseToken(token);
    $402d0a489f4b5d89$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $474ae12482b554c6$export$dd24e9cd51226c56) && $402d0a489f4b5d89$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $402d0a489f4b5d89$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $402d0a489f4b5d89$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $402d0a489f4b5d89$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $402d0a489f4b5d89$var$_logoutIfInvalidated(user, $402d0a489f4b5d89$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $402d0a489f4b5d89$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $402d0a489f4b5d89$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $402d0a489f4b5d89$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $402d0a489f4b5d89$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$d24c54395ce0c509(user) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    await $402d0a489f4b5d89$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $402d0a489f4b5d89$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $402d0a489f4b5d89$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $7c9d35c24923c1be$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$requestStsToken(auth, refreshToken) {
    const response = await $402d0a489f4b5d89$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $474ae12482b554c6$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $402d0a489f4b5d89$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        return $402d0a489f4b5d89$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $402d0a489f4b5d89$var$revokeToken(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $402d0a489f4b5d89$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $402d0a489f4b5d89$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $402d0a489f4b5d89$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $402d0a489f4b5d89$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $402d0a489f4b5d89$var$StsTokenManager();
        if (refreshToken) {
            $402d0a489f4b5d89$export$890c4ad488842ce7(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $402d0a489f4b5d89$export$890c4ad488842ce7(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $402d0a489f4b5d89$export$890c4ad488842ce7(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $402d0a489f4b5d89$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $402d0a489f4b5d89$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$assertStringOrUndefined(assertion, appName) {
    $402d0a489f4b5d89$export$890c4ad488842ce7(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $402d0a489f4b5d89$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $7c9d35c24923c1be$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $402d0a489f4b5d89$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $402d0a489f4b5d89$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $402d0a489f4b5d89$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $402d0a489f4b5d89$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $402d0a489f4b5d89$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $402d0a489f4b5d89$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $402d0a489f4b5d89$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $402d0a489f4b5d89$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $402d0a489f4b5d89$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $402d0a489f4b5d89$var$_logoutIfInvalidated(this, $402d0a489f4b5d89$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $402d0a489f4b5d89$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $402d0a489f4b5d89$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $402d0a489f4b5d89$var$assertStringOrUndefined(displayName, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(email, auth.name);
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $402d0a489f4b5d89$var$assertStringOrUndefined(phoneNumber, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(photoURL, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(tenantId, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(createdAt, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $402d0a489f4b5d89$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $402d0a489f4b5d89$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $402d0a489f4b5d89$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $402d0a489f4b5d89$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $402d0a489f4b5d89$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $402d0a489f4b5d89$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $402d0a489f4b5d89$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $402d0a489f4b5d89$export$23ebac1979863676({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $402d0a489f4b5d89$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$instanceCache = new Map();
function $402d0a489f4b5d89$export$158acd800e1ef08b(cls) {
    $402d0a489f4b5d89$export$1fbe638ecf81657e(cls instanceof Function, 'Expected a class definition');
    let instance = $402d0a489f4b5d89$var$instanceCache.get(cls);
    if (instance) {
        $402d0a489f4b5d89$export$1fbe638ecf81657e(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $402d0a489f4b5d89$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$402d0a489f4b5d89$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $402d0a489f4b5d89$export$3a6d5c9ae78a2c08 = $402d0a489f4b5d89$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $402d0a489f4b5d89$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $402d0a489f4b5d89$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $402d0a489f4b5d89$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $402d0a489f4b5d89$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $402d0a489f4b5d89$var$PersistenceUserManager($402d0a489f4b5d89$export$158acd800e1ef08b($402d0a489f4b5d89$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $402d0a489f4b5d89$export$158acd800e1ef08b($402d0a489f4b5d89$export$3a6d5c9ae78a2c08);
        const key = $402d0a489f4b5d89$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $402d0a489f4b5d89$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $402d0a489f4b5d89$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $402d0a489f4b5d89$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $402d0a489f4b5d89$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($402d0a489f4b5d89$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($402d0a489f4b5d89$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($402d0a489f4b5d89$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($402d0a489f4b5d89$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($402d0a489f4b5d89$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $402d0a489f4b5d89$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($402d0a489f4b5d89$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $402d0a489f4b5d89$var$_isFirefox(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $402d0a489f4b5d89$var$_isSafari(userAgent = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $402d0a489f4b5d89$var$_isChromeIOS(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $402d0a489f4b5d89$var$_isIEMobile(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $402d0a489f4b5d89$export$92108d983e8ee699(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $402d0a489f4b5d89$var$_isBlackBerry(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $402d0a489f4b5d89$var$_isWebOS(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $402d0a489f4b5d89$export$d66dc83d8cfc8dd(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $402d0a489f4b5d89$export$91c6e00c14e7e6fd(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $402d0a489f4b5d89$var$_isIOSStandalone(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    var _a;
    return $402d0a489f4b5d89$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $402d0a489f4b5d89$var$_isIE10() {
    return (0, $474ae12482b554c6$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $402d0a489f4b5d89$var$_isMobileBrowser(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $402d0a489f4b5d89$export$d66dc83d8cfc8dd(ua) || $402d0a489f4b5d89$export$92108d983e8ee699(ua) || $402d0a489f4b5d89$var$_isWebOS(ua) || $402d0a489f4b5d89$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $402d0a489f4b5d89$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $402d0a489f4b5d89$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $402d0a489f4b5d89$var$_getBrowserName((0, $474ae12482b554c6$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$402d0a489f4b5d89$var$_getBrowserName((0, $474ae12482b554c6$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $20ed53392b3edc61$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $402d0a489f4b5d89$var$_getPasswordPolicy(auth, request = {}) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $402d0a489f4b5d89$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $402d0a489f4b5d89$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $402d0a489f4b5d89$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $402d0a489f4b5d89$var$Subscription(this);
        this.idTokenSubscription = new $402d0a489f4b5d89$var$Subscription(this);
        this.beforeStateQueue = new $402d0a489f4b5d89$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $402d0a489f4b5d89$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $402d0a489f4b5d89$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $402d0a489f4b5d89$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $402d0a489f4b5d89$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $402d0a489f4b5d89$export$23ebac1979863676._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $402d0a489f4b5d89$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $402d0a489f4b5d89$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $402d0a489f4b5d89$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(this.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $402d0a489f4b5d89$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $402d0a489f4b5d89$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(this.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(this.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($402d0a489f4b5d89$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $402d0a489f4b5d89$var$_getPasswordPolicy(this);
        const passwordPolicy = new $402d0a489f4b5d89$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $474ae12482b554c6$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $402d0a489f4b5d89$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $402d0a489f4b5d89$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $402d0a489f4b5d89$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $402d0a489f4b5d89$var$PersistenceUserManager.create(this, [
                $402d0a489f4b5d89$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $402d0a489f4b5d89$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $402d0a489f4b5d89$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $402d0a489f4b5d89$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $402d0a489f4b5d89$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $474ae12482b554c6$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $402d0a489f4b5d89$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $402d0a489f4b5d89$var$_setExternalJSProvider(p) {
    $402d0a489f4b5d89$var$externalJSProvider = p;
}
function $402d0a489f4b5d89$var$_loadJS(url) {
    return $402d0a489f4b5d89$var$externalJSProvider.loadJS(url);
}
function $402d0a489f4b5d89$var$_recaptchaV2ScriptUrl() {
    return $402d0a489f4b5d89$var$externalJSProvider.recaptchaV2Script;
}
function $402d0a489f4b5d89$var$_recaptchaEnterpriseScriptUrl() {
    return $402d0a489f4b5d89$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $402d0a489f4b5d89$var$_gapiScriptUrl() {
    return $402d0a489f4b5d89$var$externalJSProvider.gapiScript;
}
function $402d0a489f4b5d89$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $402d0a489f4b5d89$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $402d0a489f4b5d89$var$FAKE_TOKEN = 'NO_RECAPTCHA';
class $402d0a489f4b5d89$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $402d0a489f4b5d89$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $402d0a489f4b5d89$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $402d0a489f4b5d89$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $402d0a489f4b5d89$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($402d0a489f4b5d89$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($402d0a489f4b5d89$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $402d0a489f4b5d89$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $402d0a489f4b5d89$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $402d0a489f4b5d89$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $402d0a489f4b5d89$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $402d0a489f4b5d89$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $402d0a489f4b5d89$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    var _a;
    if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const requestWithRecaptcha = await $402d0a489f4b5d89$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
        return actionMethod(authInstance, requestWithRecaptcha);
    } else return actionMethod(authInstance, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
            const requestWithRecaptcha = await $402d0a489f4b5d89$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
}
async function $402d0a489f4b5d89$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const response = await $402d0a489f4b5d89$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $402d0a489f4b5d89$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const verifier = new $402d0a489f4b5d89$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $402d0a489f4b5d89$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $20ed53392b3edc61$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $474ae12482b554c6$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $402d0a489f4b5d89$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($402d0a489f4b5d89$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $402d0a489f4b5d89$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    $402d0a489f4b5d89$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $402d0a489f4b5d89$var$extractProtocol(url);
    const { host: host, port: port } = $402d0a489f4b5d89$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $402d0a489f4b5d89$var$emitEmulatorWarning();
}
function $402d0a489f4b5d89$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $402d0a489f4b5d89$var$extractHostAndPort(url) {
    const protocol = $402d0a489f4b5d89$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $402d0a489f4b5d89$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $402d0a489f4b5d89$var$parsePort(port)
        };
    }
}
function $402d0a489f4b5d89$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $402d0a489f4b5d89$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $402d0a489f4b5d89$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $402d0a489f4b5d89$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $402d0a489f4b5d89$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $402d0a489f4b5d89$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $402d0a489f4b5d89$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$resetPassword(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$updateEmailPassword(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $402d0a489f4b5d89$var$linkEmailPassword(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $402d0a489f4b5d89$var$applyActionCode$1(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$signInWithPassword(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$sendOobCode(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$sendEmailVerification$1(auth, request) {
    return $402d0a489f4b5d89$var$sendOobCode(auth, request);
}
async function $402d0a489f4b5d89$var$sendPasswordResetEmail$1(auth, request) {
    return $402d0a489f4b5d89$var$sendOobCode(auth, request);
}
async function $402d0a489f4b5d89$var$sendSignInLinkToEmail$1(auth, request) {
    return $402d0a489f4b5d89$var$sendOobCode(auth, request);
}
async function $402d0a489f4b5d89$var$verifyAndChangeEmail(auth, request) {
    return $402d0a489f4b5d89$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$signInWithEmailLink$1(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$signInWithEmailLinkForLinking(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $402d0a489f4b5d89$export$3a1a48c8f6ef640e extends $402d0a489f4b5d89$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $402d0a489f4b5d89$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $402d0a489f4b5d89$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $402d0a489f4b5d89$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $402d0a489f4b5d89$var$signInWithPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $402d0a489f4b5d89$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $402d0a489f4b5d89$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $402d0a489f4b5d89$var$linkEmailPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $402d0a489f4b5d89$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$signInWithIdp(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $402d0a489f4b5d89$export$a07804094c3ecf2d extends $402d0a489f4b5d89$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $402d0a489f4b5d89$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $402d0a489f4b5d89$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $7c9d35c24923c1be$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $402d0a489f4b5d89$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $402d0a489f4b5d89$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $474ae12482b554c6$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$sendPhoneVerificationCode(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$signInWithPhoneNumber$1(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $402d0a489f4b5d89$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $402d0a489f4b5d89$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $402d0a489f4b5d89$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: 'REAUTH'
    });
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, apiRequest), $402d0a489f4b5d89$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $402d0a489f4b5d89$export$3722cfe417b6ed86 extends $402d0a489f4b5d89$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $402d0a489f4b5d89$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $402d0a489f4b5d89$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $402d0a489f4b5d89$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $402d0a489f4b5d89$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $402d0a489f4b5d89$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $402d0a489f4b5d89$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $402d0a489f4b5d89$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $402d0a489f4b5d89$var$parseDeepLink(url) {
    const link = (0, $474ae12482b554c6$export$c1271ca4c8a70741)((0, $474ae12482b554c6$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $474ae12482b554c6$export$c1271ca4c8a70741)((0, $474ae12482b554c6$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $474ae12482b554c6$export$c1271ca4c8a70741)((0, $474ae12482b554c6$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $474ae12482b554c6$export$c1271ca4c8a70741)((0, $474ae12482b554c6$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $402d0a489f4b5d89$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $474ae12482b554c6$export$c1271ca4c8a70741)((0, $474ae12482b554c6$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $402d0a489f4b5d89$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $402d0a489f4b5d89$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $402d0a489f4b5d89$var$parseDeepLink(link);
        try {
            return new $402d0a489f4b5d89$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $402d0a489f4b5d89$export$3b513254972cfc9c(link) {
    return $402d0a489f4b5d89$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $402d0a489f4b5d89$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $402d0a489f4b5d89$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $402d0a489f4b5d89$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $402d0a489f4b5d89$export$f38c853ae54ed474.parseLink(emailLink);
        $402d0a489f4b5d89$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $402d0a489f4b5d89$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $402d0a489f4b5d89$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $402d0a489f4b5d89$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $402d0a489f4b5d89$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $402d0a489f4b5d89$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $402d0a489f4b5d89$var$BaseOAuthProvider extends $402d0a489f4b5d89$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $402d0a489f4b5d89$export$dc98b0b04f4c7758 extends $402d0a489f4b5d89$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $402d0a489f4b5d89$export$890c4ad488842ce7('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $402d0a489f4b5d89$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $402d0a489f4b5d89$export$71cec2538cb2c617 extends $402d0a489f4b5d89$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams({
            providerId: $402d0a489f4b5d89$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $402d0a489f4b5d89$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $402d0a489f4b5d89$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $402d0a489f4b5d89$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $402d0a489f4b5d89$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $402d0a489f4b5d89$export$78acf4525d8a74c4 extends $402d0a489f4b5d89$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams({
            providerId: $402d0a489f4b5d89$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $402d0a489f4b5d89$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $402d0a489f4b5d89$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $402d0a489f4b5d89$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $402d0a489f4b5d89$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $402d0a489f4b5d89$export$8743009a87fcb00f extends $402d0a489f4b5d89$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams({
            providerId: $402d0a489f4b5d89$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $402d0a489f4b5d89$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $402d0a489f4b5d89$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $402d0a489f4b5d89$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $402d0a489f4b5d89$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $402d0a489f4b5d89$export$f96d196f7728bb5 extends $402d0a489f4b5d89$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $402d0a489f4b5d89$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $402d0a489f4b5d89$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $402d0a489f4b5d89$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $402d0a489f4b5d89$export$71511d61b312f219 extends $402d0a489f4b5d89$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $402d0a489f4b5d89$export$890c4ad488842ce7(providerId.startsWith($402d0a489f4b5d89$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $402d0a489f4b5d89$export$f96d196f7728bb5.fromJSON(json);
        $402d0a489f4b5d89$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $402d0a489f4b5d89$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $402d0a489f4b5d89$export$3d8c2f653ac9d0b9 extends $402d0a489f4b5d89$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams({
            providerId: $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$signUp(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $402d0a489f4b5d89$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $402d0a489f4b5d89$var$providerIdForResponse(idTokenResponse);
        const userCred = new $402d0a489f4b5d89$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $402d0a489f4b5d89$var$providerIdForResponse(response);
        return new $402d0a489f4b5d89$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $402d0a489f4b5d89$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$34aec0b863436764(auth) {
    var _a;
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $402d0a489f4b5d89$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $402d0a489f4b5d89$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $402d0a489f4b5d89$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$MultiFactorError extends (0, $474ae12482b554c6$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $402d0a489f4b5d89$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $402d0a489f4b5d89$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $402d0a489f4b5d89$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $402d0a489f4b5d89$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $402d0a489f4b5d89$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    await $402d0a489f4b5d89$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $402d0a489f4b5d89$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $402d0a489f4b5d89$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $402d0a489f4b5d89$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $402d0a489f4b5d89$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $402d0a489f4b5d89$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $402d0a489f4b5d89$var$_assertLinkedStatus(expected, user, provider) {
    await $402d0a489f4b5d89$var$_reloadWithoutSaving(user);
    const providerIds = $402d0a489f4b5d89$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $402d0a489f4b5d89$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $402d0a489f4b5d89$var$_logoutIfInvalidated(user, $402d0a489f4b5d89$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $402d0a489f4b5d89$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $402d0a489f4b5d89$var$_parseToken(response.idToken);
        $402d0a489f4b5d89$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $402d0a489f4b5d89$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $402d0a489f4b5d89$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $402d0a489f4b5d89$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $402d0a489f4b5d89$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$3c2fa207a37baaea(auth, credential) {
    return $402d0a489f4b5d89$var$_signInWithCredential($402d0a489f4b5d89$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    await $402d0a489f4b5d89$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $402d0a489f4b5d89$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$6559d589eb85fbb6(user, credential) {
    return $402d0a489f4b5d89$var$_reauthenticate((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$signInWithCustomToken$1(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$efca4cbe5dd06740(auth, customToken) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const response = await $402d0a489f4b5d89$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $402d0a489f4b5d89$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $402d0a489f4b5d89$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $402d0a489f4b5d89$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $402d0a489f4b5d89$var$PhoneMultiFactorInfoImpl extends $402d0a489f4b5d89$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $402d0a489f4b5d89$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $402d0a489f4b5d89$var$TotpMultiFactorInfoImpl extends $402d0a489f4b5d89$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $402d0a489f4b5d89$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $402d0a489f4b5d89$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $402d0a489f4b5d89$var$recachePasswordPolicy(auth) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $402d0a489f4b5d89$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $402d0a489f4b5d89$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $402d0a489f4b5d89$var$sendPasswordResetEmail$1);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $402d0a489f4b5d89$var$resetPassword((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $402d0a489f4b5d89$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$a93c5207d687da10(auth, oobCode) {
    await $402d0a489f4b5d89$var$applyActionCode$1((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth);
    const response = await $402d0a489f4b5d89$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $402d0a489f4b5d89$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $402d0a489f4b5d89$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $402d0a489f4b5d89$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $402d0a489f4b5d89$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $402d0a489f4b5d89$var$MultiFactorInfoImpl._fromServerResponse($402d0a489f4b5d89$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $402d0a489f4b5d89$export$c3950d9923825c02((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$7910e0436ed8d1de(auth, email, password) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $402d0a489f4b5d89$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $402d0a489f4b5d89$var$signUp);
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $402d0a489f4b5d89$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $402d0a489f4b5d89$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $402d0a489f4b5d89$export$555508cbc6add439(auth, email, password) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $402d0a489f4b5d89$export$3c2fa207a37baaea((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth), $402d0a489f4b5d89$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $402d0a489f4b5d89$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $402d0a489f4b5d89$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $402d0a489f4b5d89$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $402d0a489f4b5d89$var$sendSignInLinkToEmail$1);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $402d0a489f4b5d89$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $402d0a489f4b5d89$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$f787f51d84a910ad(auth, email, emailLink) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth);
    const credential = $402d0a489f4b5d89$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $402d0a489f4b5d89$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $402d0a489f4b5d89$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $402d0a489f4b5d89$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$createAuthUri(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $402d0a489f4b5d89$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $402d0a489f4b5d89$var$_isHttpOrHttps() ? $402d0a489f4b5d89$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $402d0a489f4b5d89$var$createAuthUri((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $402d0a489f4b5d89$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $402d0a489f4b5d89$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $402d0a489f4b5d89$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $402d0a489f4b5d89$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$updateProfile$1(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $402d0a489f4b5d89$var$_logoutIfInvalidated(userInternal, $402d0a489f4b5d89$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $402d0a489f4b5d89$export$ab83b03e4111b1d0(user, newEmail) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $402d0a489f4b5d89$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $402d0a489f4b5d89$export$1a82df3d29112e01(user, newPassword) {
    return $402d0a489f4b5d89$var$updateEmailOrPassword((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $402d0a489f4b5d89$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $402d0a489f4b5d89$var$_logoutIfInvalidated(user, $402d0a489f4b5d89$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $402d0a489f4b5d89$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $402d0a489f4b5d89$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $402d0a489f4b5d89$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $402d0a489f4b5d89$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $402d0a489f4b5d89$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $402d0a489f4b5d89$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $402d0a489f4b5d89$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $402d0a489f4b5d89$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $402d0a489f4b5d89$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $402d0a489f4b5d89$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $402d0a489f4b5d89$var$FederatedAdditionalUserInfoWithUsername extends $402d0a489f4b5d89$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $402d0a489f4b5d89$var$FacebookAdditionalUserInfo extends $402d0a489f4b5d89$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $402d0a489f4b5d89$var$GithubAdditionalUserInfo extends $402d0a489f4b5d89$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $402d0a489f4b5d89$var$GoogleAdditionalUserInfo extends $402d0a489f4b5d89$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $402d0a489f4b5d89$var$TwitterAdditionalUserInfo extends $402d0a489f4b5d89$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $402d0a489f4b5d89$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $402d0a489f4b5d89$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $402d0a489f4b5d89$export$9e5f44173e64f162(auth, persistence) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $402d0a489f4b5d89$export$625550452a3fa3ec(auth) {
    return $402d0a489f4b5d89$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$90a7f3efeed30595(auth, password) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $402d0a489f4b5d89$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $402d0a489f4b5d89$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $402d0a489f4b5d89$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $402d0a489f4b5d89$export$df995fae86a55f06(auth) {
    (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $402d0a489f4b5d89$export$ef35774e6d314e91(auth, user) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $402d0a489f4b5d89$export$e7094788287c5e9b(auth) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $402d0a489f4b5d89$export$96f57966bedc81b4(auth, token) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$a9c23c6ac3fc3eca(user) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $402d0a489f4b5d89$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $402d0a489f4b5d89$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $402d0a489f4b5d89$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $402d0a489f4b5d89$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $402d0a489f4b5d89$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$402d0a489f4b5d89$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $402d0a489f4b5d89$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $402d0a489f4b5d89$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $402d0a489f4b5d89$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $402d0a489f4b5d89$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $402d0a489f4b5d89$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $402d0a489f4b5d89$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $402d0a489f4b5d89$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $402d0a489f4b5d89$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $402d0a489f4b5d89$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$startEnrollPhoneMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$finalizeEnrollPhoneMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$startEnrollTotpMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$finalizeEnrollTotpMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$withdrawMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
class $402d0a489f4b5d89$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$402d0a489f4b5d89$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $402d0a489f4b5d89$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $402d0a489f4b5d89$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $402d0a489f4b5d89$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $402d0a489f4b5d89$var$_logoutIfInvalidated(this.user, $402d0a489f4b5d89$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $402d0a489f4b5d89$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $402d0a489f4b5d89$export$493d36ec626b6698(user) {
    const userModular = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    if (!$402d0a489f4b5d89$var$multiFactorUserCache.has(userModular)) $402d0a489f4b5d89$var$multiFactorUserCache.set(userModular, $402d0a489f4b5d89$var$MultiFactorUserImpl._fromUser(userModular));
    return $402d0a489f4b5d89$var$multiFactorUserCache.get(userModular);
}
const $402d0a489f4b5d89$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $402d0a489f4b5d89$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($402d0a489f4b5d89$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($402d0a489f4b5d89$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $402d0a489f4b5d89$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $402d0a489f4b5d89$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $402d0a489f4b5d89$var$BrowserLocalPersistence extends $402d0a489f4b5d89$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $402d0a489f4b5d89$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($402d0a489f4b5d89$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $402d0a489f4b5d89$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $402d0a489f4b5d89$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$402d0a489f4b5d89$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $402d0a489f4b5d89$export$8b22cf2602fb60ce = $402d0a489f4b5d89$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$BrowserSessionPersistence extends $402d0a489f4b5d89$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$402d0a489f4b5d89$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $402d0a489f4b5d89$export$407448d2b89b1813 = $402d0a489f4b5d89$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $402d0a489f4b5d89$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $402d0a489f4b5d89$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $402d0a489f4b5d89$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $402d0a489f4b5d89$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$402d0a489f4b5d89$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$export$faec65b429be379(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $402d0a489f4b5d89$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $402d0a489f4b5d89$export$faec65b429be379('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $402d0a489f4b5d89$var$_window() {
    return window;
}
function $402d0a489f4b5d89$var$_setWindowLocation(url) {
    $402d0a489f4b5d89$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$_isWorker() {
    return typeof $402d0a489f4b5d89$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $402d0a489f4b5d89$var$_window()['importScripts'] === 'function';
}
async function $402d0a489f4b5d89$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $402d0a489f4b5d89$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $402d0a489f4b5d89$var$_getWorkerGlobalScope() {
    return $402d0a489f4b5d89$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$DB_NAME = 'firebaseLocalStorageDb';
const $402d0a489f4b5d89$var$DB_VERSION = 1;
const $402d0a489f4b5d89$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $402d0a489f4b5d89$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $402d0a489f4b5d89$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $402d0a489f4b5d89$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $402d0a489f4b5d89$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($402d0a489f4b5d89$var$DB_OBJECTSTORE_NAME);
}
function $402d0a489f4b5d89$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($402d0a489f4b5d89$var$DB_NAME);
    return new $402d0a489f4b5d89$var$DBPromise(request).toPromise();
}
function $402d0a489f4b5d89$var$_openDatabase() {
    const request = indexedDB.open($402d0a489f4b5d89$var$DB_NAME, $402d0a489f4b5d89$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($402d0a489f4b5d89$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $402d0a489f4b5d89$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($402d0a489f4b5d89$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $402d0a489f4b5d89$var$_deleteDatabase();
                resolve(await $402d0a489f4b5d89$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $402d0a489f4b5d89$var$_putObject(db, key, value) {
    const request = $402d0a489f4b5d89$var$getObjectStore(db, true).put({
        [$402d0a489f4b5d89$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $402d0a489f4b5d89$var$DBPromise(request).toPromise();
}
async function $402d0a489f4b5d89$var$getObject(db, key) {
    const request = $402d0a489f4b5d89$var$getObjectStore(db, false).get(key);
    const data = await new $402d0a489f4b5d89$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $402d0a489f4b5d89$var$_deleteObject(db, key) {
    const request = $402d0a489f4b5d89$var$getObjectStore(db, true).delete(key);
    return new $402d0a489f4b5d89$var$DBPromise(request).toPromise();
}
const $402d0a489f4b5d89$var$_POLLING_INTERVAL_MS = 800;
const $402d0a489f4b5d89$var$_TRANSACTION_RETRY_COUNT = 3;
class $402d0a489f4b5d89$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $402d0a489f4b5d89$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $402d0a489f4b5d89$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $402d0a489f4b5d89$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $402d0a489f4b5d89$var$Receiver._getInstance($402d0a489f4b5d89$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $402d0a489f4b5d89$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $402d0a489f4b5d89$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $402d0a489f4b5d89$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $402d0a489f4b5d89$var$_openDatabase();
            await $402d0a489f4b5d89$var$_putObject(db, $402d0a489f4b5d89$var$STORAGE_AVAILABLE_KEY, '1');
            await $402d0a489f4b5d89$var$_deleteObject(db, $402d0a489f4b5d89$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$402d0a489f4b5d89$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$402d0a489f4b5d89$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$402d0a489f4b5d89$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $402d0a489f4b5d89$var$getObjectStore(db, false).getAll();
            return new $402d0a489f4b5d89$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $402d0a489f4b5d89$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$402d0a489f4b5d89$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $402d0a489f4b5d89$export$23f2a1d2818174ef = $402d0a489f4b5d89$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$startSignInPhoneMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$finalizeSignInPhoneMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$finalizeSignInTotpMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$_SOLVE_TIME_MS = 500;
const $402d0a489f4b5d89$var$_EXPIRATION_TIME_MS = 60000;
const $402d0a489f4b5d89$var$_WIDGET_ID_START = 1000000000000;
class $402d0a489f4b5d89$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $402d0a489f4b5d89$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $402d0a489f4b5d89$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $402d0a489f4b5d89$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $402d0a489f4b5d89$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $402d0a489f4b5d89$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return '';
    }
}
class $402d0a489f4b5d89$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $402d0a489f4b5d89$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $402d0a489f4b5d89$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $402d0a489f4b5d89$var$_EXPIRATION_TIME_MS);
        }, $402d0a489f4b5d89$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $402d0a489f4b5d89$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $402d0a489f4b5d89$var$_JSLOAD_CALLBACK = $402d0a489f4b5d89$var$_generateCallbackName('rcb');
const $402d0a489f4b5d89$var$NETWORK_TIMEOUT_DELAY = new $402d0a489f4b5d89$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $402d0a489f4b5d89$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $402d0a489f4b5d89$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = '') {
        $402d0a489f4b5d89$export$890c4ad488842ce7($402d0a489f4b5d89$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $402d0a489f4b5d89$var$isV2($402d0a489f4b5d89$var$_window().grecaptcha)) return Promise.resolve($402d0a489f4b5d89$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $402d0a489f4b5d89$var$_window().setTimeout(()=>{
                reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $402d0a489f4b5d89$var$NETWORK_TIMEOUT_DELAY.get());
            $402d0a489f4b5d89$var$_window()[$402d0a489f4b5d89$var$_JSLOAD_CALLBACK] = ()=>{
                $402d0a489f4b5d89$var$_window().clearTimeout(networkTimeout);
                delete $402d0a489f4b5d89$var$_window()[$402d0a489f4b5d89$var$_JSLOAD_CALLBACK];
                const recaptcha = $402d0a489f4b5d89$var$_window().grecaptcha;
                if (!recaptcha || !$402d0a489f4b5d89$var$isV2(recaptcha)) {
                    reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$402d0a489f4b5d89$var$_recaptchaV2ScriptUrl()}?${(0, $474ae12482b554c6$export$ac4103b836844853)({
                onload: $402d0a489f4b5d89$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $402d0a489f4b5d89$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $402d0a489f4b5d89$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $402d0a489f4b5d89$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $402d0a489f4b5d89$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $402d0a489f4b5d89$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $402d0a489f4b5d89$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $402d0a489f4b5d89$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $402d0a489f4b5d89$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $402d0a489f4b5d89$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $402d0a489f4b5d89$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $402d0a489f4b5d89$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $402d0a489f4b5d89$var$MockReCaptchaLoaderImpl() : new $402d0a489f4b5d89$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $402d0a489f4b5d89$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $402d0a489f4b5d89$export$890c4ad488842ce7($402d0a489f4b5d89$var$_isHttpOrHttps() && !$402d0a489f4b5d89$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $402d0a489f4b5d89$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $402d0a489f4b5d89$var$getRecaptchaParams(this.auth);
        $402d0a489f4b5d89$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $402d0a489f4b5d89$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $402d0a489f4b5d89$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const verificationId = await $402d0a489f4b5d89$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(appVerifier));
    return new $402d0a489f4b5d89$var$ConfirmationResultImpl(verificationId, (cred)=>$402d0a489f4b5d89$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    await $402d0a489f4b5d89$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $402d0a489f4b5d89$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(appVerifier));
    return new $402d0a489f4b5d89$var$ConfirmationResultImpl(verificationId, (cred)=>$402d0a489f4b5d89$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $402d0a489f4b5d89$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(appVerifier));
    return new $402d0a489f4b5d89$var$ConfirmationResultImpl(verificationId, (cred)=>$402d0a489f4b5d89$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $402d0a489f4b5d89$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof recaptchaToken === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(verifier.type === $402d0a489f4b5d89$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $402d0a489f4b5d89$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $402d0a489f4b5d89$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $402d0a489f4b5d89$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $402d0a489f4b5d89$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $402d0a489f4b5d89$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $402d0a489f4b5d89$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $402d0a489f4b5d89$var$_link$1(userInternal, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $402d0a489f4b5d89$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $402d0a489f4b5d89$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $402d0a489f4b5d89$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $402d0a489f4b5d89$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $402d0a489f4b5d89$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $402d0a489f4b5d89$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $402d0a489f4b5d89$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $402d0a489f4b5d89$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $402d0a489f4b5d89$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $402d0a489f4b5d89$export$158acd800e1ef08b(resolverOverride);
    $402d0a489f4b5d89$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$IdpCredential extends $402d0a489f4b5d89$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $402d0a489f4b5d89$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $402d0a489f4b5d89$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $402d0a489f4b5d89$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $402d0a489f4b5d89$var$_signIn(params) {
    return $402d0a489f4b5d89$var$_signInWithCredential(params.auth, new $402d0a489f4b5d89$var$IdpCredential(params), params.bypassAuthState);
}
function $402d0a489f4b5d89$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $402d0a489f4b5d89$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $402d0a489f4b5d89$var$_reauthenticate(user, new $402d0a489f4b5d89$var$IdpCredential(params), params.bypassAuthState);
}
async function $402d0a489f4b5d89$var$_link(params) {
    const { auth: auth, user: user } = params;
    $402d0a489f4b5d89$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $402d0a489f4b5d89$var$_link$1(user, new $402d0a489f4b5d89$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $402d0a489f4b5d89$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $402d0a489f4b5d89$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $402d0a489f4b5d89$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $402d0a489f4b5d89$var$_reauth;
            default:
                $402d0a489f4b5d89$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $402d0a489f4b5d89$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $402d0a489f4b5d89$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $402d0a489f4b5d89$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$db3b6bfb95261072(auth, provider, resolver) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    $402d0a489f4b5d89$var$_assertInstanceOf(auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(authInternal, resolver);
    const action = new $402d0a489f4b5d89$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($402d0a489f4b5d89$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $402d0a489f4b5d89$var$_assertInstanceOf(userInternal.auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $402d0a489f4b5d89$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    $402d0a489f4b5d89$var$_assertInstanceOf(userInternal.auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $402d0a489f4b5d89$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $402d0a489f4b5d89$var$PopupOperation extends $402d0a489f4b5d89$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($402d0a489f4b5d89$var$PopupOperation.currentPopupAction) $402d0a489f4b5d89$var$PopupOperation.currentPopupAction.cancel();
        $402d0a489f4b5d89$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $402d0a489f4b5d89$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $402d0a489f4b5d89$export$1fbe638ecf81657e(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $402d0a489f4b5d89$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($402d0a489f4b5d89$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($402d0a489f4b5d89$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $402d0a489f4b5d89$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($402d0a489f4b5d89$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $402d0a489f4b5d89$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$402d0a489f4b5d89$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $402d0a489f4b5d89$var$redirectOutcomeMap = new Map();
class $402d0a489f4b5d89$var$RedirectAction extends $402d0a489f4b5d89$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $402d0a489f4b5d89$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $402d0a489f4b5d89$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $402d0a489f4b5d89$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $402d0a489f4b5d89$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $402d0a489f4b5d89$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $402d0a489f4b5d89$var$pendingRedirectKey(auth);
    const persistence = $402d0a489f4b5d89$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $402d0a489f4b5d89$var$_setPendingRedirectStatus(resolver, auth) {
    return $402d0a489f4b5d89$var$resolverPersistence(resolver)._set($402d0a489f4b5d89$var$pendingRedirectKey(auth), 'true');
}
function $402d0a489f4b5d89$export$b9a6b53f9be3734() {
    $402d0a489f4b5d89$var$redirectOutcomeMap.clear();
}
function $402d0a489f4b5d89$export$a33b77bbdbb8366c(auth, result) {
    $402d0a489f4b5d89$var$redirectOutcomeMap.set(auth._key(), result);
}
function $402d0a489f4b5d89$var$resolverPersistence(resolver) {
    return $402d0a489f4b5d89$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $402d0a489f4b5d89$var$pendingRedirectKey(auth) {
    return $402d0a489f4b5d89$export$cf2f7c5792f80b46($402d0a489f4b5d89$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $402d0a489f4b5d89$export$2d1720544b23b823(auth, provider, resolver) {
    return $402d0a489f4b5d89$var$_signInWithRedirect(auth, provider, resolver);
}
async function $402d0a489f4b5d89$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    $402d0a489f4b5d89$var$_assertInstanceOf(auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(authInternal, resolver);
    await $402d0a489f4b5d89$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $402d0a489f4b5d89$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $402d0a489f4b5d89$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $402d0a489f4b5d89$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    $402d0a489f4b5d89$var$_assertInstanceOf(userInternal.auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(userInternal.auth, resolver);
    await $402d0a489f4b5d89$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $402d0a489f4b5d89$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $402d0a489f4b5d89$export$39b482c5e57630a8(user, provider, resolver) {
    return $402d0a489f4b5d89$var$_linkWithRedirect(user, provider, resolver);
}
async function $402d0a489f4b5d89$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    $402d0a489f4b5d89$var$_assertInstanceOf(userInternal.auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(userInternal.auth, resolver);
    await $402d0a489f4b5d89$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $402d0a489f4b5d89$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $402d0a489f4b5d89$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$35e795649ee09318(auth, resolver) {
    await $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $402d0a489f4b5d89$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $402d0a489f4b5d89$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const resolver = $402d0a489f4b5d89$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $402d0a489f4b5d89$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $402d0a489f4b5d89$var$prepareUserForRedirect(user) {
    const eventId = $402d0a489f4b5d89$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $402d0a489f4b5d89$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $402d0a489f4b5d89$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$402d0a489f4b5d89$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$402d0a489f4b5d89$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($402d0a489f4b5d89$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $402d0a489f4b5d89$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($402d0a489f4b5d89$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($402d0a489f4b5d89$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $402d0a489f4b5d89$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $402d0a489f4b5d89$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $402d0a489f4b5d89$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $402d0a489f4b5d89$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$export$3d12bd131bb975d1(auth, request = {}) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $402d0a489f4b5d89$var$HTTP_REGEX = /^https?/;
async function $402d0a489f4b5d89$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $402d0a489f4b5d89$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($402d0a489f4b5d89$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $402d0a489f4b5d89$var$matchDomain(expected) {
    const currentUrl = $402d0a489f4b5d89$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$402d0a489f4b5d89$var$HTTP_REGEX.test(protocol)) return false;
    if ($402d0a489f4b5d89$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$NETWORK_TIMEOUT = new $402d0a489f4b5d89$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $402d0a489f4b5d89$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $402d0a489f4b5d89$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $402d0a489f4b5d89$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $402d0a489f4b5d89$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $402d0a489f4b5d89$var$resetUnloadedGapiModules();
                    reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $402d0a489f4b5d89$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $402d0a489f4b5d89$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $402d0a489f4b5d89$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $402d0a489f4b5d89$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $402d0a489f4b5d89$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $402d0a489f4b5d89$var$_loadJS(`${$402d0a489f4b5d89$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $402d0a489f4b5d89$var$cachedGApiLoader = null;
        throw error;
    });
}
let $402d0a489f4b5d89$var$cachedGApiLoader = null;
function $402d0a489f4b5d89$var$_loadGapi(auth) {
    $402d0a489f4b5d89$var$cachedGApiLoader = $402d0a489f4b5d89$var$cachedGApiLoader || $402d0a489f4b5d89$var$loadGapi(auth);
    return $402d0a489f4b5d89$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$PING_TIMEOUT = new $402d0a489f4b5d89$var$Delay(5000, 15000);
const $402d0a489f4b5d89$var$IFRAME_PATH = '__/auth/iframe';
const $402d0a489f4b5d89$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $402d0a489f4b5d89$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $402d0a489f4b5d89$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $402d0a489f4b5d89$var$getIframeUrl(auth) {
    const config = auth.config;
    $402d0a489f4b5d89$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $402d0a489f4b5d89$var$_emulatorUrl(config, $402d0a489f4b5d89$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$402d0a489f4b5d89$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $20ed53392b3edc61$export$31499a9cd224b78c)
    };
    const eid = $402d0a489f4b5d89$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $474ae12482b554c6$export$ac4103b836844853)(params).slice(1)}`;
}
async function $402d0a489f4b5d89$var$_openIframe(auth) {
    const context = await $402d0a489f4b5d89$var$_loadGapi(auth);
    const gapi1 = $402d0a489f4b5d89$var$_window().gapi;
    $402d0a489f4b5d89$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $402d0a489f4b5d89$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $402d0a489f4b5d89$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $402d0a489f4b5d89$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $402d0a489f4b5d89$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $402d0a489f4b5d89$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $402d0a489f4b5d89$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $402d0a489f4b5d89$var$DEFAULT_WIDTH = 500;
const $402d0a489f4b5d89$var$DEFAULT_HEIGHT = 600;
const $402d0a489f4b5d89$var$TARGET_BLANK = '_blank';
const $402d0a489f4b5d89$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $402d0a489f4b5d89$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $402d0a489f4b5d89$var$_open(auth, url, name, width = $402d0a489f4b5d89$var$DEFAULT_WIDTH, height = $402d0a489f4b5d89$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, $402d0a489f4b5d89$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $402d0a489f4b5d89$var$_isChromeIOS(ua) ? $402d0a489f4b5d89$var$TARGET_BLANK : name;
    if ($402d0a489f4b5d89$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $402d0a489f4b5d89$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($402d0a489f4b5d89$var$_isIOSStandalone(ua) && target !== '_self') {
        $402d0a489f4b5d89$var$openAsNewWindowIOS(url || '', target);
        return new $402d0a489f4b5d89$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $402d0a489f4b5d89$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $402d0a489f4b5d89$export$c03999cb2f36933f(newWin);
}
function $402d0a489f4b5d89$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $402d0a489f4b5d89$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $402d0a489f4b5d89$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $402d0a489f4b5d89$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $402d0a489f4b5d89$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $402d0a489f4b5d89$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $20ed53392b3edc61$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $402d0a489f4b5d89$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $474ae12482b554c6$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $402d0a489f4b5d89$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$402d0a489f4b5d89$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$402d0a489f4b5d89$var$getHandlerBase(auth)}?${(0, $474ae12482b554c6$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $402d0a489f4b5d89$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$402d0a489f4b5d89$var$WIDGET_PATH}`;
    return $402d0a489f4b5d89$var$_emulatorUrl(config, $402d0a489f4b5d89$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $402d0a489f4b5d89$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $402d0a489f4b5d89$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $402d0a489f4b5d89$export$407448d2b89b1813;
        this._completeRedirectFn = $402d0a489f4b5d89$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $402d0a489f4b5d89$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $402d0a489f4b5d89$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = await $402d0a489f4b5d89$export$28f7fcd39efa255(auth, provider, authType, $402d0a489f4b5d89$var$_getCurrentUrl(), eventId);
        return $402d0a489f4b5d89$var$_open(auth, url, $402d0a489f4b5d89$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $402d0a489f4b5d89$export$28f7fcd39efa255(auth, provider, authType, $402d0a489f4b5d89$var$_getCurrentUrl(), eventId);
        $402d0a489f4b5d89$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $402d0a489f4b5d89$export$1fbe638ecf81657e(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $402d0a489f4b5d89$var$_openIframe(auth);
        const manager = new $402d0a489f4b5d89$export$24baa2b76016ce0e(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $402d0a489f4b5d89$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($402d0a489f4b5d89$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $402d0a489f4b5d89$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$402d0a489f4b5d89$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $402d0a489f4b5d89$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $402d0a489f4b5d89$var$_isMobileBrowser() || $402d0a489f4b5d89$var$_isSafari() || $402d0a489f4b5d89$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $402d0a489f4b5d89$export$342063e11d6c3cad = $402d0a489f4b5d89$var$BrowserPopupRedirectResolver;
class $402d0a489f4b5d89$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $402d0a489f4b5d89$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $402d0a489f4b5d89$var$PhoneMultiFactorAssertionImpl extends $402d0a489f4b5d89$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $402d0a489f4b5d89$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $402d0a489f4b5d89$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $402d0a489f4b5d89$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $402d0a489f4b5d89$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $402d0a489f4b5d89$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $402d0a489f4b5d89$export$953cecd6e717a553.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $402d0a489f4b5d89$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $402d0a489f4b5d89$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $402d0a489f4b5d89$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $402d0a489f4b5d89$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $402d0a489f4b5d89$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $402d0a489f4b5d89$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $402d0a489f4b5d89$var$TotpMultiFactorAssertionImpl extends $402d0a489f4b5d89$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $402d0a489f4b5d89$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $402d0a489f4b5d89$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $402d0a489f4b5d89$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $402d0a489f4b5d89$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $402d0a489f4b5d89$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $402d0a489f4b5d89$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($402d0a489f4b5d89$var$_isEmptyString(accountName) || $402d0a489f4b5d89$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($402d0a489f4b5d89$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || 'unknownuser';
            if ($402d0a489f4b5d89$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $402d0a489f4b5d89$var$_isEmptyString(input) {
    return typeof input === 'undefined' || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $402d0a489f4b5d89$var$name = "@firebase/auth";
var $402d0a489f4b5d89$var$version = "1.7.9";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $402d0a489f4b5d89$var$registerAuth(clientPlatform) {
    (0, $20ed53392b3edc61$export$c930050e7bb63965)(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $402d0a489f4b5d89$export$890c4ad488842ce7(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $402d0a489f4b5d89$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $402d0a489f4b5d89$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $402d0a489f4b5d89$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $20ed53392b3edc61$export$c930050e7bb63965)(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $402d0a489f4b5d89$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $402d0a489f4b5d89$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($402d0a489f4b5d89$var$name, $402d0a489f4b5d89$var$version, $402d0a489f4b5d89$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($402d0a489f4b5d89$var$name, $402d0a489f4b5d89$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $402d0a489f4b5d89$var$authIdTokenMaxAge = (0, $474ae12482b554c6$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $402d0a489f4b5d89$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $402d0a489f4b5d89$var$lastPostedIdToken = null;
const $402d0a489f4b5d89$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $402d0a489f4b5d89$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($402d0a489f4b5d89$var$lastPostedIdToken === idToken) return;
        $402d0a489f4b5d89$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $402d0a489f4b5d89$export$ae1af26003f05816(app = (0, $20ed53392b3edc61$export$f9962582c9e66d99)()) {
    const provider = (0, $20ed53392b3edc61$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $402d0a489f4b5d89$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $402d0a489f4b5d89$export$342063e11d6c3cad,
        persistence: [
            $402d0a489f4b5d89$export$23f2a1d2818174ef,
            $402d0a489f4b5d89$export$8b22cf2602fb60ce,
            $402d0a489f4b5d89$export$407448d2b89b1813
        ]
    });
    const authTokenSyncPath = (0, $474ae12482b554c6$export$5539a1a3afe87d6)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $402d0a489f4b5d89$var$mintCookieFactory(authTokenSyncUrl.toString());
            $402d0a489f4b5d89$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $402d0a489f4b5d89$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $474ae12482b554c6$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $402d0a489f4b5d89$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $402d0a489f4b5d89$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$402d0a489f4b5d89$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $402d0a489f4b5d89$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $402d0a489f4b5d89$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$402d0a489f4b5d89$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );
















var $djlMn = parcelRequire("djlMn");
const $e0be213f695400f3$var$name = "@firebase/database";
const $e0be213f695400f3$var$version = "1.0.8";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $e0be213f695400f3$var$SDK_VERSION = '';
/**
 * SDK_VERSION should be set before any database instance is created
 * @internal
 */ function $e0be213f695400f3$export$c9fb972242fcb3c4(version) {
    $e0be213f695400f3$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ class $e0be213f695400f3$var$DOMStorageWrapper {
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ constructor(domStorage_){
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ set(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $474ae12482b554c6$export$fac44ee5b035f737)(value));
    }
    /**
     * @returns The value that was stored under this key, or null
     */ get(key) {
        const storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $474ae12482b554c6$export$c5a53ce6a17cf18d)(storedVal);
    }
    remove(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    }
    prefixedName_(name) {
        return this.prefix_ + name;
    }
    toString() {
        return this.domStorage_.toString();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ class $e0be213f695400f3$var$MemoryStorage {
    constructor(){
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    set(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    }
    get(key) {
        if ((0, $474ae12482b554c6$export$2344b14b097df817)(this.cache_, key)) return this.cache_[key];
        return null;
    }
    remove(key) {
        delete this.cache_[key];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ const $e0be213f695400f3$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' && typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            const domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new $e0be213f695400f3$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $e0be213f695400f3$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ const $e0be213f695400f3$var$PersistentStorage = $e0be213f695400f3$var$createStoragefor('localStorage');
/** A storage object that only lasts one session */ const $e0be213f695400f3$var$SessionStorage = $e0be213f695400f3$var$createStoragefor('sessionStorage');
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$logClient = new (0, $6cbcb85fb6f607fa$export$efa9a398d6368992)('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ const $e0be213f695400f3$var$LUIDGenerator = function() {
    let id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ const $e0be213f695400f3$var$sha1 = function(str) {
    const utf8Bytes = (0, $474ae12482b554c6$export$655666783217a925)(str);
    const sha1 = new (0, $474ae12482b554c6$export$c85d589bf4e25fef)();
    sha1.update(utf8Bytes);
    const sha1Bytes = sha1.digest();
    return (0, $474ae12482b554c6$export$b3b2de96497acc47).encodeByteArray(sha1Bytes);
};
const $e0be213f695400f3$var$buildLogMessage_ = function(...varArgs) {
    let message = '';
    for(let i = 0; i < varArgs.length; i++){
        const arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === 'number') message += $e0be213f695400f3$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === 'object') message += (0, $474ae12482b554c6$export$fac44ee5b035f737)(arg);
        else message += arg;
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ let $e0be213f695400f3$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ let $e0be213f695400f3$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ const $e0be213f695400f3$var$enableLogging$1 = function(logger_, persistent) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $e0be213f695400f3$var$logClient.logLevel = (0, $6cbcb85fb6f607fa$export$243e62d78d3b544d).VERBOSE;
        $e0be213f695400f3$var$logger = $e0be213f695400f3$var$logClient.log.bind($e0be213f695400f3$var$logClient);
        if (persistent) $e0be213f695400f3$var$SessionStorage.set('logging_enabled', true);
    } else if (typeof logger_ === 'function') $e0be213f695400f3$var$logger = logger_;
    else {
        $e0be213f695400f3$var$logger = null;
        $e0be213f695400f3$var$SessionStorage.remove('logging_enabled');
    }
};
const $e0be213f695400f3$var$log = function(...varArgs) {
    if ($e0be213f695400f3$var$firstLog_ === true) {
        $e0be213f695400f3$var$firstLog_ = false;
        if ($e0be213f695400f3$var$logger === null && $e0be213f695400f3$var$SessionStorage.get('logging_enabled') === true) $e0be213f695400f3$var$enableLogging$1(true);
    }
    if ($e0be213f695400f3$var$logger) {
        const message = $e0be213f695400f3$var$buildLogMessage_.apply(null, varArgs);
        $e0be213f695400f3$var$logger(message);
    }
};
const $e0be213f695400f3$var$logWrapper = function(prefix) {
    return function(...varArgs) {
        $e0be213f695400f3$var$log(prefix, ...varArgs);
    };
};
const $e0be213f695400f3$var$error = function(...varArgs) {
    const message = 'FIREBASE INTERNAL ERROR: ' + $e0be213f695400f3$var$buildLogMessage_(...varArgs);
    $e0be213f695400f3$var$logClient.error(message);
};
const $e0be213f695400f3$var$fatal = function(...varArgs) {
    const message = `FIREBASE FATAL ERROR: ${$e0be213f695400f3$var$buildLogMessage_(...varArgs)}`;
    $e0be213f695400f3$var$logClient.error(message);
    throw new Error(message);
};
const $e0be213f695400f3$var$warn = function(...varArgs) {
    const message = 'FIREBASE WARNING: ' + $e0be213f695400f3$var$buildLogMessage_(...varArgs);
    $e0be213f695400f3$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ const $e0be213f695400f3$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('https:') !== -1) $e0be213f695400f3$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ const $e0be213f695400f3$var$isInvalidJSONNumber = function(data) {
    return typeof data === 'number' && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
const $e0be213f695400f3$var$executeWhenDOMReady = function(fn) {
    if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)() || document.readyState === 'complete') fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        let called = false;
        const wrappedFn = function() {
            if (!document.body) {
                setTimeout(wrappedFn, Math.floor(10));
                return;
            }
            if (!called) {
                called = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent('onreadystatechange', ()=>{
                if (document.readyState === 'complete') wrappedFn();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent('onload', wrappedFn);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ const $e0be213f695400f3$var$MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ const $e0be213f695400f3$var$MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 */ const $e0be213f695400f3$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $e0be213f695400f3$var$MIN_NAME || b === $e0be213f695400f3$var$MAX_NAME) return -1;
    else if (b === $e0be213f695400f3$var$MIN_NAME || a === $e0be213f695400f3$var$MAX_NAME) return 1;
    else {
        const aAsInt = $e0be213f695400f3$var$tryParseInt(a), bAsInt = $e0be213f695400f3$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ const $e0be213f695400f3$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
const $e0be213f695400f3$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error('Missing required key (' + key + ') in object: ' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(obj));
};
const $e0be213f695400f3$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== 'object' || obj === null) return (0, $474ae12482b554c6$export$fac44ee5b035f737)(obj);
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for(const k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    let key = '{';
    for(let i = 0; i < keys.length; i++){
        if (i !== 0) key += ',';
        key += (0, $474ae12482b554c6$export$fac44ee5b035f737)(keys[i]);
        key += ':';
        key += $e0be213f695400f3$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ const $e0be213f695400f3$var$splitStringBySize = function(str, segsize) {
    const len = str.length;
    if (len <= segsize) return [
        str
    ];
    const dataSegs = [];
    for(let c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $e0be213f695400f3$var$each(obj, fn) {
    for(const key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ const $e0be213f695400f3$var$doubleToIEEE754String = function(v) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(!$e0be213f695400f3$var$isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    const ebits = 11, fbits = 52;
    const bias = (1 << ebits - 1) - 1;
    let s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    const bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    const str = bits.join('');
    // Return the data as a hex string. --MJL
    let hexByteString = '';
    for(i = 0; i < 64; i += 8){
        let hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ const $e0be213f695400f3$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === 'object' && window['chrome'] && window['chrome']['extension'] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ const $e0be213f695400f3$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a JavaScript Error
 */ function $e0be213f695400f3$var$errorForServerCode(code, query) {
    let reason = 'Unknown Error';
    if (code === 'too_big') reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === 'permission_denied') reason = "Client doesn't have permission to access the desired data.";
    else if (code === 'unavailable') reason = 'The service is unavailable';
    const error = new Error(code + ' at ' + query._path.toString() + ': ' + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ const $e0be213f695400f3$var$INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ const $e0be213f695400f3$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in keys, the maximum possible 32-bit integer.
 */ const $e0be213f695400f3$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ const $e0be213f695400f3$var$tryParseInt = function(str) {
    if ($e0be213f695400f3$var$INTEGER_REGEXP_.test(str)) {
        const intVal = Number(str);
        if (intVal >= $e0be213f695400f3$var$INTEGER_32_MIN && intVal <= $e0be213f695400f3$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ const $e0be213f695400f3$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(()=>{
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            const stack = e.stack || '';
            $e0be213f695400f3$var$warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ const $e0be213f695400f3$var$beingCrawled = function() {
    const userAgent = typeof window === 'object' && window['navigator'] && window['navigator']['userAgent'] || '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ const $e0be213f695400f3$var$setTimeoutNonBlocking = function(fn, time) {
    const timeout = setTimeout(fn, time);
    // Note: at the time of this comment, unrefTimer is under the unstable set of APIs. Run with --unstable to enable the API.
    if (typeof timeout === 'number' && // @ts-ignore Is only defined in Deno environments.
    typeof Deno !== 'undefined' && // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno['unrefTimer']) // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno.unrefTimer(timeout);
    else if (typeof timeout === 'object' && timeout['unref']) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout['unref']();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ class $e0be213f695400f3$var$AppCheckTokenProvider {
    constructor(appName_, appCheckProvider){
        this.appName_ = appName_;
        this.appCheckProvider = appCheckProvider;
        this.appCheck = appCheckProvider === null || appCheckProvider === void 0 ? void 0 : appCheckProvider.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck);
    }
    getToken(forceRefresh) {
        if (!this.appCheck) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.appCheck) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    }
    addTokenChangeListener(listener) {
        var _a;
        (_a = this.appCheckProvider) === null || _a === void 0 || _a.get().then((appCheck)=>appCheck.addTokenListener(listener));
    }
    notifyForInvalidToken() {
        $e0be213f695400f3$var$warn(`Provided AppCheck credentials for the app named "${this.appName_}" ` + 'are invalid. This usually indicates your app was not initialized correctly.');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ class $e0be213f695400f3$var$FirebaseAuthTokenProvider {
    constructor(appName_, firebaseOptions_, authProvider_){
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit((auth)=>this.auth_ = auth);
    }
    getToken(forceRefresh) {
        if (!this.auth_) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.auth_) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch((error)=>{
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                $e0be213f695400f3$var$log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            } else return Promise.reject(error);
        });
    }
    addTokenChangeListener(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then((auth)=>auth.addAuthTokenListener(listener));
    }
    removeTokenChangeListener(listener) {
        this.authProvider_.get().then((auth)=>auth.removeAuthTokenListener(listener));
    }
    notifyForInvalidToken() {
        let errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + 'initialized correctly. ';
        if ('credential' in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ('serviceAccount' in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $e0be213f695400f3$var$warn(errorMessage);
    }
}
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ class $e0be213f695400f3$var$EmulatorTokenProvider {
    constructor(accessToken){
        this.accessToken = accessToken;
    }
    getToken(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    }
    addTokenChangeListener(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    }
    removeTokenChangeListener(listener) {}
    notifyForInvalidToken() {}
}
/** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ $e0be213f695400f3$var$EmulatorTokenProvider.OWNER = 'owner';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$PROTOCOL_VERSION = '5';
const $e0be213f695400f3$var$VERSION_PARAM = 'v';
const $e0be213f695400f3$var$TRANSPORT_SESSION_PARAM = 's';
const $e0be213f695400f3$var$REFERER_PARAM = 'r';
const $e0be213f695400f3$var$FORGE_REF = 'f';
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
const $e0be213f695400f3$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
const $e0be213f695400f3$var$LAST_SESSION_PARAM = 'ls';
const $e0be213f695400f3$var$APPLICATION_ID_PARAM = 'p';
const $e0be213f695400f3$var$APP_CHECK_TOKEN_PARAM = 'ac';
const $e0be213f695400f3$var$WEBSOCKET = 'websocket';
const $e0be213f695400f3$var$LONG_POLLING = 'long_polling';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ class $e0be213f695400f3$var$RepoInfo {
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ constructor(host, secure, namespace, webSocketOnly, nodeAdmin = false, persistenceKey = '', includeNamespaceInQueryParams = false, isUsingEmulator = false){
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.isUsingEmulator = isUsingEmulator;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf('.') + 1);
        this.internalHost = $e0be213f695400f3$var$PersistentStorage.get('host:' + host) || this._host;
    }
    isCacheableHost() {
        return this.internalHost.substr(0, 2) === 's-';
    }
    isCustomHost() {
        return this._domain !== 'firebaseio.com' && this._domain !== 'firebaseio-demo.com';
    }
    get host() {
        return this._host;
    }
    set host(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $e0be213f695400f3$var$PersistentStorage.set('host:' + this._host, this.internalHost);
        }
    }
    toString() {
        let str = this.toURLString();
        if (this.persistenceKey) str += '<' + this.persistenceKey + '>';
        return str;
    }
    toURLString() {
        const protocol = this.secure ? 'https://' : 'http://';
        const query = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : '';
        return `${protocol}${this.host}/${query}`;
    }
}
function $e0be213f695400f3$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $e0be213f695400f3$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(typeof type === 'string', 'typeof type must == string');
    (0, $474ae12482b554c6$export$a7a9523472993e97)(typeof params === 'object', 'typeof params must == object');
    let connURL;
    if (type === $e0be213f695400f3$var$WEBSOCKET) connURL = (repoInfo.secure ? 'wss://' : 'ws://') + repoInfo.internalHost + '/.ws?';
    else if (type === $e0be213f695400f3$var$LONG_POLLING) connURL = (repoInfo.secure ? 'https://' : 'http://') + repoInfo.internalHost + '/.lp?';
    else throw new Error('Unknown connection type: ' + type);
    if ($e0be213f695400f3$var$repoInfoNeedsQueryParam(repoInfo)) params['ns'] = repoInfo.namespace;
    const pairs = [];
    $e0be213f695400f3$var$each(params, (key, value)=>{
        pairs.push(key + '=' + value);
    });
    return connURL + pairs.join('&');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ class $e0be213f695400f3$var$StatsCollection {
    constructor(){
        this.counters_ = {};
    }
    incrementCounter(name, amount = 1) {
        if (!(0, $474ae12482b554c6$export$2344b14b097df817)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    }
    get() {
        return (0, $474ae12482b554c6$export$6c40052bed430212)(this.counters_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$collections = {};
const $e0be213f695400f3$var$reporters = {};
function $e0be213f695400f3$var$statsManagerGetCollection(repoInfo) {
    const hashString = repoInfo.toString();
    if (!$e0be213f695400f3$var$collections[hashString]) $e0be213f695400f3$var$collections[hashString] = new $e0be213f695400f3$var$StatsCollection();
    return $e0be213f695400f3$var$collections[hashString];
}
function $e0be213f695400f3$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    const hashString = repoInfo.toString();
    if (!$e0be213f695400f3$var$reporters[hashString]) $e0be213f695400f3$var$reporters[hashString] = creatorFunction();
    return $e0be213f695400f3$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ class $e0be213f695400f3$var$PacketReceiver {
    /**
     * @param onMessage_
     */ constructor(onMessage_){
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    closeAfter(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    }
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ handleResponse(requestNum, data) {
        this.pendingResponses[requestNum] = data;
        while(this.pendingResponses[this.currentResponseNum]){
            const toProcess = this.pendingResponses[this.currentResponseNum];
            delete this.pendingResponses[this.currentResponseNum];
            for(let i = 0; i < toProcess.length; ++i)if (toProcess[i]) $e0be213f695400f3$var$exceptionGuard(()=>{
                this.onMessage_(toProcess[i]);
            });
            if (this.currentResponseNum === this.closeAfterResponse) {
                if (this.onClose) {
                    this.onClose();
                    this.onClose = null;
                }
                break;
            }
            this.currentResponseNum++;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_START_PARAM = 'start';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_ID_PARAM = 'id';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_PW_PARAM = 'pw';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_DATA_PARAM = 'd';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
const $e0be213f695400f3$var$MAX_URL_DATA_SIZE = 1870;
const $e0be213f695400f3$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
const $e0be213f695400f3$var$MAX_PAYLOAD_SIZE = $e0be213f695400f3$var$MAX_URL_DATA_SIZE - $e0be213f695400f3$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ const $e0be213f695400f3$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ const $e0be213f695400f3$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ class $e0be213f695400f3$var$BrowserPollConnection {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $e0be213f695400f3$var$logWrapper(connId);
        this.stats_ = $e0be213f695400f3$var$statsManagerGetCollection(repoInfo);
        this.urlFn = (params)=>{
            // Always add the token if we have one.
            if (this.appCheckToken) params[$e0be213f695400f3$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            return $e0be213f695400f3$var$repoInfoConnectionURL(repoInfo, $e0be213f695400f3$var$LONG_POLLING, params);
        };
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $e0be213f695400f3$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(()=>{
            this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            this.onClosed_();
            this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($e0be213f695400f3$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $e0be213f695400f3$var$executeWhenDOMReady(()=>{
            if (this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            this.scriptTagHolder = new $e0be213f695400f3$var$FirebaseIFrameScriptHolder((...args)=>{
                const [command, arg1, arg2, arg3, arg4] = args;
                this.incrementIncomingBytes_(args);
                if (!this.scriptTagHolder) return; // we closed the connection.
                if (this.connectTimeoutTimer_) {
                    clearTimeout(this.connectTimeoutTimer_);
                    this.connectTimeoutTimer_ = null;
                }
                this.everConnected_ = true;
                if (command === $e0be213f695400f3$var$FIREBASE_LONGPOLL_START_PARAM) {
                    this.id = arg1;
                    this.password = arg2;
                } else if (command === $e0be213f695400f3$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        this.myPacketOrderer.closeAfter(arg1, ()=>{
                            this.onClosed_();
                        });
                    } else this.onClosed_();
                } else throw new Error('Unrecognized command received: ' + command);
            }, (...args)=>{
                const [pN, data] = args;
                this.incrementIncomingBytes_(args);
                this.myPacketOrderer.handleResponse(pN, data);
            }, ()=>{
                this.onClosed_();
            }, this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            const urlParams = {};
            urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$e0be213f695400f3$var$VERSION_PARAM] = $e0be213f695400f3$var$PROTOCOL_VERSION;
            if (this.transportSessionId) urlParams[$e0be213f695400f3$var$TRANSPORT_SESSION_PARAM] = this.transportSessionId;
            if (this.lastSessionId) urlParams[$e0be213f695400f3$var$LAST_SESSION_PARAM] = this.lastSessionId;
            if (this.applicationId) urlParams[$e0be213f695400f3$var$APPLICATION_ID_PARAM] = this.applicationId;
            if (this.appCheckToken) urlParams[$e0be213f695400f3$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            if (typeof location !== 'undefined' && location.hostname && $e0be213f695400f3$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$e0be213f695400f3$var$REFERER_PARAM] = $e0be213f695400f3$var$FORGE_REF;
            const connectURL = this.urlFn(urlParams);
            this.log_('Connecting via long-poll to ' + connectURL);
            this.scriptTagHolder.addTag(connectURL, ()=>{
            /* do nothing */ });
        });
    }
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ start() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    }
    /**
     * Forces long polling to be considered as a potential transport
     */ static forceAllow() {
        $e0be213f695400f3$var$BrowserPollConnection.forceAllow_ = true;
    }
    /**
     * Forces longpolling to not be considered as a potential transport
     */ static forceDisallow() {
        $e0be213f695400f3$var$BrowserPollConnection.forceDisallow_ = true;
    }
    // Static method, use string literal so it can be accessed in a generic way
    static isAvailable() {
        if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) return false;
        else if ($e0be213f695400f3$var$BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !$e0be213f695400f3$var$BrowserPollConnection.forceDisallow_ && typeof document !== 'undefined' && document.createElement != null && !$e0be213f695400f3$var$isChromeExtensionContentScript() && !$e0be213f695400f3$var$isWindowsStoreApp();
    }
    /**
     * No-op for polling
     */ markConnectionHealthy() {}
    /**
     * Stops polling and cleans up the iframe
     */ shutdown_() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    }
    /**
     * Triggered when this transport is closed
     */ onClosed_() {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    }
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ close() {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    }
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ send(data) {
        const dataStr = (0, $474ae12482b554c6$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        const base64data = (0, $474ae12482b554c6$export$e510a73ee562749)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $e0be213f695400f3$var$splitStringBySize(base64data, $e0be213f695400f3$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(let i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    }
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ addDisconnectPingFrame(id, pw) {
        if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) return;
        this.myDisconnFrame = document.createElement('iframe');
        const urlParams = {};
        urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    }
    /**
     * Used to track the bytes received by this client
     */ incrementIncomingBytes_(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        const bytesReceived = (0, $474ae12482b554c6$export$fac44ee5b035f737)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    }
}
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ class $e0be213f695400f3$var$FirebaseIFrameScriptHolder {
    /**
     * @param commandCB - The callback to be called when control commands are received from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ constructor(commandCB, onMessageCB, onDisconnect, urlFn){
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $e0be213f695400f3$var$LUIDGenerator();
            window[$e0be213f695400f3$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$e0be213f695400f3$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = $e0be213f695400f3$var$FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            let script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === 'javascript:') {
                const currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            const iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $e0be213f695400f3$var$log('frame writing exception');
                if (e.stack) $e0be213f695400f3$var$log(e.stack);
                $e0be213f695400f3$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ static createIFrame_() {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                const a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $e0be213f695400f3$var$log('No IE domain setting required');
            } catch (e) {
                const domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    }
    /**
     * Cancel all outstanding queries and remove the frame.
     */ close() {
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting textContent seems to be the safest way to do this.
            this.myIFrame.doc.body.textContent = '';
            setTimeout(()=>{
                if (this.myIFrame !== null) {
                    document.body.removeChild(this.myIFrame);
                    this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        const onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    }
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ startLongPoll(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    }
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ newRequest_() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            const urlParams = {};
            urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            let theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            let curDataString = '';
            let i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                const nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $e0be213f695400f3$var$SEG_HEADER_SIZE + curDataString.length <= $e0be213f695400f3$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    const theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + '&' + $e0be213f695400f3$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + '=' + theSeg.seg + '&' + $e0be213f695400f3$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + '=' + theSeg.ts + '&' + $e0be213f695400f3$var$FIREBASE_LONGPOLL_DATA_PARAM + i + '=' + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    }
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ enqueueSegment(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    }
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ addLongPollTag_(url, serial) {
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        const doNewRequest = ()=>{
            this.outstandingRequests.delete(serial);
            this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        const keepaliveTimeout = setTimeout(doNewRequest, Math.floor($e0be213f695400f3$var$KEEPALIVE_REQUEST_INTERVAL));
        const readyStateCB = ()=>{
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    }
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ addTag(url, loadCB) {
        if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(()=>{
            try {
                // if we're already closed, don't add this poll
                if (!this.sendNewPolls) return;
                const newScript = this.myIFrame.doc.createElement('script');
                newScript.type = 'text/javascript';
                newScript.async = true;
                newScript.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript.onload = newScript.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const rstate = newScript.readyState;
                    if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript.onload = newScript.onreadystatechange = null;
                        if (newScript.parentNode) newScript.parentNode.removeChild(newScript);
                        loadCB();
                    }
                };
                newScript.onerror = ()=>{
                    $e0be213f695400f3$var$log('Long-poll script failed to load: ' + url);
                    this.sendNewPolls = false;
                    this.close();
                };
                this.myIFrame.doc.body.appendChild(newScript);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
const $e0be213f695400f3$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
let $e0be213f695400f3$var$WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') $e0be213f695400f3$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== 'undefined') $e0be213f695400f3$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ class $e0be213f695400f3$var$WebSocketConnection {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $e0be213f695400f3$var$logWrapper(this.connId);
        this.stats_ = $e0be213f695400f3$var$statsManagerGetCollection(repoInfo);
        this.connURL = $e0be213f695400f3$var$WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ static connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId) {
        const urlParams = {};
        urlParams[$e0be213f695400f3$var$VERSION_PARAM] = $e0be213f695400f3$var$PROTOCOL_VERSION;
        if (!(0, $474ae12482b554c6$export$5d1d834fbbf8bab7)() && typeof location !== 'undefined' && location.hostname && $e0be213f695400f3$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$e0be213f695400f3$var$REFERER_PARAM] = $e0be213f695400f3$var$FORGE_REF;
        if (transportSessionId) urlParams[$e0be213f695400f3$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$e0be213f695400f3$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$e0be213f695400f3$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        if (applicationId) urlParams[$e0be213f695400f3$var$APPLICATION_ID_PARAM] = applicationId;
        return $e0be213f695400f3$var$repoInfoConnectionURL(repoInfo, $e0be213f695400f3$var$WEBSOCKET, urlParams);
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $e0be213f695400f3$var$PersistentStorage.set('previous_websocket_failure', true);
        try {
            let options;
            if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) {
                const device = this.nodeAdmin ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                options = {
                    headers: {
                        'User-Agent': `Firebase/${$e0be213f695400f3$var$PROTOCOL_VERSION}/${$e0be213f695400f3$var$SDK_VERSION}/${$djlMn.platform}/${device}`,
                        'X-Firebase-GMPID': this.applicationId || ''
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers['Authorization'] = `Bearer ${this.authToken}`;
                if (this.appCheckToken) options.headers['X-Firebase-AppCheck'] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                const env = {};
                const proxy = this.connURL.indexOf('wss://') === 0 ? env['HTTPS_PROXY'] || env['https_proxy'] : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) options['proxy'] = {
                    origin: proxy
                };
            }
            this.mySock = new $e0be213f695400f3$var$WebSocketImpl(this.connURL, [], options);
        } catch (e) {
            this.log_('Error instantiating WebSocket.');
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = ()=>{
            this.log_('Websocket connected.');
            this.everConnected_ = true;
        };
        this.mySock.onclose = ()=>{
            this.log_('Websocket connection was disconnected.');
            this.mySock = null;
            this.onClosed_();
        };
        this.mySock.onmessage = (m)=>{
            this.handleIncomingFrame(m);
        };
        this.mySock.onerror = (e)=>{
            this.log_('WebSocket error.  Closing connection.');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
        };
    }
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ start() {}
    static forceDisallow() {
        $e0be213f695400f3$var$WebSocketConnection.forceDisallow_ = true;
    }
    static isAvailable() {
        let isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            const oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            const oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $e0be213f695400f3$var$WebSocketImpl !== null && !$e0be213f695400f3$var$WebSocketConnection.forceDisallow_;
    }
    /**
     * Returns true if we previously failed to connect with this transport.
     */ static previouslyFailed() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $e0be213f695400f3$var$PersistentStorage.isInMemoryStorage || $e0be213f695400f3$var$PersistentStorage.get('previous_websocket_failure') === true;
    }
    markConnectionHealthy() {
        $e0be213f695400f3$var$PersistentStorage.remove('previous_websocket_failure');
    }
    appendFrame_(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            const fullMess = this.frames.join('');
            this.frames = null;
            const jsonMess = (0, $474ae12482b554c6$export$c5a53ce6a17cf18d)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    }
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ handleNewFrameCount_(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    }
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ extractFrameCount_(data) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            const frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    }
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ handleIncomingFrame(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        const data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            const remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    }
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ send(data) {
        this.resetKeepAlive();
        const dataStr = (0, $474ae12482b554c6$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $e0be213f695400f3$var$splitStringBySize(dataStr, $e0be213f695400f3$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(let i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    }
    shutdown_() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    }
    onClosed_() {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    }
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ close() {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    }
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ resetKeepAlive() {
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(()=>{
            //If there has been no websocket activity for a while, send a no-op
            if (this.mySock) this.sendString_('0');
            this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($e0be213f695400f3$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    }
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ sendString_(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    }
}
/**
 * Number of response before we consider the connection "healthy."
 */ $e0be213f695400f3$var$WebSocketConnection.responsesRequiredToBeHealthy = 2;
/**
 * Time to wait for the connection te become healthy before giving up.
 */ $e0be213f695400f3$var$WebSocketConnection.healthyTimeout = 30000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ class $e0be213f695400f3$var$TransportManager {
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ constructor(repoInfo){
        this.initTransports_(repoInfo);
    }
    static get ALL_TRANSPORTS() {
        return [
            $e0be213f695400f3$var$BrowserPollConnection,
            $e0be213f695400f3$var$WebSocketConnection
        ];
    }
    /**
     * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
     * TransportManager has already set up transports_
     */ static get IS_TRANSPORT_INITIALIZED() {
        return this.globalTransportInitialized_;
    }
    initTransports_(repoInfo) {
        const isWebSocketsAvailable = $e0be213f695400f3$var$WebSocketConnection && $e0be213f695400f3$var$WebSocketConnection['isAvailable']();
        let isSkipPollConnection = isWebSocketsAvailable && !$e0be213f695400f3$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $e0be213f695400f3$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $e0be213f695400f3$var$WebSocketConnection
        ];
        else {
            const transports = this.transports_ = [];
            for (const transport of $e0be213f695400f3$var$TransportManager.ALL_TRANSPORTS)if (transport && transport['isAvailable']()) transports.push(transport);
            $e0be213f695400f3$var$TransportManager.globalTransportInitialized_ = true;
        }
    }
    /**
     * @returns The constructor for the initial transport to use
     */ initialTransport() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error('No transports available');
    }
    /**
     * @returns The constructor for the next transport, or null
     */ upgradeTransport() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    }
}
// Keeps track of whether the TransportManager has already chosen a transport to use
$e0be213f695400f3$var$TransportManager.globalTransportInitialized_ = false;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
const $e0be213f695400f3$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
const $e0be213f695400f3$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
const $e0be213f695400f3$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
const $e0be213f695400f3$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
const $e0be213f695400f3$var$MESSAGE_TYPE = 't';
const $e0be213f695400f3$var$MESSAGE_DATA = 'd';
const $e0be213f695400f3$var$CONTROL_SHUTDOWN = 's';
const $e0be213f695400f3$var$CONTROL_RESET = 'r';
const $e0be213f695400f3$var$CONTROL_ERROR = 'e';
const $e0be213f695400f3$var$CONTROL_PONG = 'o';
const $e0be213f695400f3$var$SWITCH_ACK = 'a';
const $e0be213f695400f3$var$END_TRANSMISSION = 'n';
const $e0be213f695400f3$var$PING = 'p';
const $e0be213f695400f3$var$SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ class $e0be213f695400f3$var$Connection {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ constructor(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId){
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* RealtimeState.CONNECTING */ ;
        this.log_ = $e0be213f695400f3$var$logWrapper('c:' + this.id + ':');
        this.transportManager_ = new $e0be213f695400f3$var$TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     */ start_() {
        const conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessageReceived = this.connReceiver_(this.conn_);
        const onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(()=>{
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            this.conn_ && this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        const healthyTimeoutMS = conn['healthyTimeout'] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $e0be213f695400f3$var$setTimeoutNonBlocking(()=>{
            this.healthyTimeout_ = null;
            if (!this.isHealthy_) {
                if (this.conn_ && this.conn_.bytesReceived > $e0be213f695400f3$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    this.log_('Connection exceeded healthy timeout but has received ' + this.conn_.bytesReceived + ' bytes.  Marking connection healthy.');
                    this.isHealthy_ = true;
                    this.conn_.markConnectionHealthy();
                } else if (this.conn_ && this.conn_.bytesSent > $e0be213f695400f3$var$BYTES_SENT_HEALTHY_OVERRIDE) this.log_('Connection exceeded healthy timeout but has sent ' + this.conn_.bytesSent + ' bytes.  Leaving connection alive.');
                else {
                    this.log_('Closing unhealthy connection after timeout.');
                    this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    }
    nextTransportId_() {
        return 'c:' + this.id + ':' + this.connectionCount++;
    }
    disconnReceiver_(conn) {
        return (everConnected)=>{
            if (conn === this.conn_) this.onConnectionLost_(everConnected);
            else if (conn === this.secondaryConn_) {
                this.log_('Secondary connection lost.');
                this.onSecondaryConnectionLost_();
            } else this.log_('closing an old connection');
        };
    }
    connReceiver_(conn) {
        return (message)=>{
            if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
                if (conn === this.rx_) this.onPrimaryMessageReceived_(message);
                else if (conn === this.secondaryConn_) this.onSecondaryMessageReceived_(message);
                else this.log_('message on old connection');
            }
        };
    }
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ sendRequest(dataMsg) {
        // wrap in a data message envelope and send it on
        const msg = {
            t: 'd',
            d: dataMsg
        };
        this.sendData_(msg);
    }
    tryCleanupConnection() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    }
    onSecondaryControl_(controlData) {
        if ($e0be213f695400f3$var$MESSAGE_TYPE in controlData) {
            const cmd = controlData[$e0be213f695400f3$var$MESSAGE_TYPE];
            if (cmd === $e0be213f695400f3$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $e0be213f695400f3$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $e0be213f695400f3$var$CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    }
    onSecondaryMessageReceived_(parsedData) {
        const layer = $e0be213f695400f3$var$requireKey('t', parsedData);
        const data = $e0be213f695400f3$var$requireKey('d', parsedData);
        if (layer === 'c') this.onSecondaryControl_(data);
        else if (layer === 'd') // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error('Unknown protocol layer: ' + layer);
    }
    upgradeIfSecondaryHealthy_() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({
                t: 'c',
                d: {
                    t: $e0be213f695400f3$var$PING,
                    d: {}
                }
            });
        }
    }
    proceedWithUpgrade_() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({
            t: 'c',
            d: {
                t: $e0be213f695400f3$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({
            t: 'c',
            d: {
                t: $e0be213f695400f3$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    }
    onPrimaryMessageReceived_(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        const layer = $e0be213f695400f3$var$requireKey('t', parsedData);
        const data = $e0be213f695400f3$var$requireKey('d', parsedData);
        if (layer === 'c') this.onControl_(data);
        else if (layer === 'd') this.onDataMessage_(data);
    }
    onDataMessage_(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    }
    onPrimaryResponse_() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    }
    onControl_(controlData) {
        const cmd = $e0be213f695400f3$var$requireKey($e0be213f695400f3$var$MESSAGE_TYPE, controlData);
        if ($e0be213f695400f3$var$MESSAGE_DATA in controlData) {
            const payload = controlData[$e0be213f695400f3$var$MESSAGE_DATA];
            if (cmd === $e0be213f695400f3$var$SERVER_HELLO) {
                const handshakePayload = Object.assign({}, payload);
                if (this.repoInfo_.isUsingEmulator) // Upon connecting, the emulator will pass the hostname that it's aware of, but we prefer the user's set hostname via `connectDatabaseEmulator` over what the emulator passes.
                handshakePayload.h = this.repoInfo_.host;
                this.onHandshake_(handshakePayload);
            } else if (cmd === $e0be213f695400f3$var$END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for(let i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $e0be213f695400f3$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $e0be213f695400f3$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $e0be213f695400f3$var$CONTROL_ERROR) $e0be213f695400f3$var$error('Server Error: ' + payload);
            else if (cmd === $e0be213f695400f3$var$CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $e0be213f695400f3$var$error('Unknown control packet command: ' + cmd);
        }
    }
    /**
     * @param handshake - The handshake data returned from the server
     */ onHandshake_(handshake) {
        const timestamp = handshake.ts;
        const version = handshake.v;
        const host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($e0be213f695400f3$var$PROTOCOL_VERSION !== version) $e0be213f695400f3$var$warn('Protocol version mismatch detected');
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    }
    tryStartUpgrade_() {
        const conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    }
    startUpgrade_(conn) {
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessage = this.connReceiver_(this.secondaryConn_);
        const onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $e0be213f695400f3$var$setTimeoutNonBlocking(()=>{
            if (this.secondaryConn_) {
                this.log_('Timed out trying to upgrade.');
                this.secondaryConn_.close();
            }
        }, Math.floor($e0be213f695400f3$var$UPGRADE_TIMEOUT));
    }
    onReset_(host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    }
    onConnectionEstablished_(conn, timestamp) {
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* RealtimeState.CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        } else $e0be213f695400f3$var$setTimeoutNonBlocking(()=>{
            this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($e0be213f695400f3$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
    sendPingOnPrimaryIfNecessary_() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* RealtimeState.CONNECTED */ ) {
            this.log_('sending ping on primary.');
            this.sendData_({
                t: 'c',
                d: {
                    t: $e0be213f695400f3$var$PING,
                    d: {}
                }
            });
        }
    }
    onSecondaryConnectionLost_() {
        const conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    }
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ onConnectionLost_(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $e0be213f695400f3$var$PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.log_('Realtime connection lost.');
        this.close();
    }
    onConnectionShutdown_(reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    }
    sendData_(data) {
        if (this.state_ !== 1 /* RealtimeState.CONNECTED */ ) throw 'Connection is not connected';
        else this.tx_.send(data);
    }
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ close() {
        if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* RealtimeState.DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    }
    closeConnections_() {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ class $e0be213f695400f3$var$ServerActions {
    put(pathString, data, onComplete, hash) {}
    merge(pathString, data, onComplete, hash) {}
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ refreshAuthToken(token) {}
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ refreshAppCheckToken(token) {}
    onDisconnectPut(pathString, data, onComplete) {}
    onDisconnectMerge(pathString, data, onComplete) {}
    onDisconnectCancel(pathString, onComplete) {}
    reportStats(stats) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ class $e0be213f695400f3$var$EventEmitter {
    constructor(allowedEvents_){
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $474ae12482b554c6$export$a7a9523472993e97)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     */ trigger(eventType, ...varArgs) {
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            const listeners = [
                ...this.listeners_[eventType]
            ];
            for(let i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    }
    on(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        const eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    }
    off(eventType, callback, context) {
        this.validateEventType_(eventType);
        const listeners = this.listeners_[eventType] || [];
        for(let i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    }
    validateEventType_(eventType) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.allowedEvents_.find((et)=>{
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ class $e0be213f695400f3$var$OnlineMonitor extends $e0be213f695400f3$var$EventEmitter {
    constructor(){
        super([
            'online'
        ]);
        this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined' && !(0, $474ae12482b554c6$export$872f8323f01d7ae0)()) {
            window.addEventListener('online', ()=>{
                if (!this.online_) {
                    this.online_ = true;
                    this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', ()=>{
                if (this.online_) {
                    this.online_ = false;
                    this.trigger('online', false);
                }
            }, false);
        }
    }
    static getInstance() {
        return new $e0be213f695400f3$var$OnlineMonitor();
    }
    getInitialEvent(eventType) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(eventType === 'online', 'Unknown event type: ' + eventType);
        return [
            this.online_
        ];
    }
    currentlyOnline() {
        return this.online_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ const $e0be213f695400f3$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ const $e0be213f695400f3$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ class $e0be213f695400f3$var$Path {
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ constructor(pathOrString, pieceNum){
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            let copyTo = 0;
            for(let i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    toString() {
        let pathString = '';
        for(let i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== '') pathString += '/' + this.pieces_[i];
        return pathString || '/';
    }
}
function $e0be213f695400f3$var$newEmptyPath() {
    return new $e0be213f695400f3$var$Path('');
}
function $e0be213f695400f3$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $e0be213f695400f3$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $e0be213f695400f3$var$pathPopFront(path) {
    let pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $e0be213f695400f3$var$Path(path.pieces_, pieceNum);
}
function $e0be213f695400f3$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $e0be213f695400f3$var$pathToUrlEncodedString(path) {
    let pathString = '';
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== '') pathString += '/' + encodeURIComponent(String(path.pieces_[i]));
    return pathString || '/';
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $e0be213f695400f3$var$pathSlice(path, begin = 0) {
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $e0be213f695400f3$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $e0be213f695400f3$var$Path(pieces, 0);
}
function $e0be213f695400f3$var$pathChild(path, childPathObj) {
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $e0be213f695400f3$var$Path) for(let i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        const childPieces = childPathObj.split('/');
        for(let i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $e0be213f695400f3$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $e0be213f695400f3$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $e0be213f695400f3$var$newRelativePath(outerPath, innerPath) {
    const outer = $e0be213f695400f3$var$pathGetFront(outerPath), inner = $e0be213f695400f3$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $e0be213f695400f3$var$newRelativePath($e0be213f695400f3$var$pathPopFront(outerPath), $e0be213f695400f3$var$pathPopFront(innerPath));
    else throw new Error('INTERNAL ERROR: innerPath (' + innerPath + ') is not within ' + 'outerPath (' + outerPath + ')');
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $e0be213f695400f3$var$pathCompare(left, right) {
    const leftKeys = $e0be213f695400f3$var$pathSlice(left, 0);
    const rightKeys = $e0be213f695400f3$var$pathSlice(right, 0);
    for(let i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        const cmp = $e0be213f695400f3$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $e0be213f695400f3$var$pathEquals(path, other) {
    if ($e0be213f695400f3$var$pathGetLength(path) !== $e0be213f695400f3$var$pathGetLength(other)) return false;
    for(let i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent of (or the same as) other
 */ function $e0be213f695400f3$var$pathContains(path, other) {
    let i = path.pieceNum_;
    let j = other.pieceNum_;
    if ($e0be213f695400f3$var$pathGetLength(path) > $e0be213f695400f3$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ class $e0be213f695400f3$var$ValidationPath {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ constructor(path, errorPrefix_){
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $e0be213f695400f3$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(let i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $474ae12482b554c6$export$9536dc0a75b20bf9)(this.parts_[i]);
        $e0be213f695400f3$var$validationPathCheckValid(this);
    }
}
function $e0be213f695400f3$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $474ae12482b554c6$export$9536dc0a75b20bf9)(child);
    $e0be213f695400f3$var$validationPathCheckValid(validationPath);
}
function $e0be213f695400f3$var$validationPathPop(validationPath) {
    const last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $474ae12482b554c6$export$9536dc0a75b20bf9)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $e0be213f695400f3$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $e0be213f695400f3$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + 'has a key path longer than ' + $e0be213f695400f3$var$MAX_PATH_LENGTH_BYTES + ' bytes (' + validationPath.byteLength_ + ').');
    if (validationPath.parts_.length > $e0be213f695400f3$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + 'path specified exceeds the maximum depth that can be written (' + $e0be213f695400f3$var$MAX_PATH_DEPTH + ') or object contains a cycle ' + $e0be213f695400f3$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $e0be213f695400f3$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return '';
    return "in property '" + validationPath.parts_.join('.') + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$VisibilityMonitor extends $e0be213f695400f3$var$EventEmitter {
    constructor(){
        super([
            'visible'
        ]);
        let hidden;
        let visibilityChange;
        if (typeof document !== 'undefined' && typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            } else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            } else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            } else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, ()=>{
            const visible = !document[hidden];
            if (visible !== this.visible_) {
                this.visible_ = visible;
                this.trigger('visible', visible);
            }
        }, false);
    }
    static getInstance() {
        return new $e0be213f695400f3$var$VisibilityMonitor();
    }
    getInitialEvent(eventType) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [
            this.visible_
        ];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$RECONNECT_MIN_DELAY = 1000;
const $e0be213f695400f3$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
const $e0be213f695400f3$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
const $e0be213f695400f3$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
const $e0be213f695400f3$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
const $e0be213f695400f3$var$SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
const $e0be213f695400f3$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ class $e0be213f695400f3$var$PersistentConnection extends $e0be213f695400f3$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_){
        super();
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onDataUpdate_ = onDataUpdate_;
        this.onConnectStatus_ = onConnectStatus_;
        this.onServerInfoUpdate_ = onServerInfoUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        this.id = $e0be213f695400f3$var$PersistentConnection.nextPersistentConnectionId_++;
        this.log_ = $e0be213f695400f3$var$logWrapper('p:' + this.id + ':');
        this.interruptReasons_ = {};
        this.listens = new Map();
        this.outstandingPuts_ = [];
        this.outstandingGets_ = [];
        this.outstandingPutCount_ = 0;
        this.outstandingGetCount_ = 0;
        this.onDisconnectRequestQueue_ = [];
        this.connected_ = false;
        this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MIN_DELAY;
        this.maxReconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MAX_DELAY_DEFAULT;
        this.securityDebugCallback_ = null;
        this.lastSessionId = null;
        this.establishConnectionTimer_ = null;
        this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        this.requestCBHash_ = {};
        this.requestNumber_ = 0;
        this.realtime_ = null;
        this.authToken_ = null;
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = false;
        this.invalidAuthTokenCount_ = 0;
        this.invalidAppCheckTokenCount_ = 0;
        this.firstConnection_ = true;
        this.lastConnectionAttemptTime_ = null;
        this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        $e0be213f695400f3$var$VisibilityMonitor.getInstance().on('visible', this.onVisible_, this);
        if (repoInfo_.host.indexOf('fblocal') === -1) $e0be213f695400f3$var$OnlineMonitor.getInstance().on('online', this.onOnline_, this);
    }
    sendRequest(action, body, onResponse) {
        const curReqNum = ++this.requestNumber_;
        const msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $474ae12482b554c6$export$fac44ee5b035f737)(msg));
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    }
    get(query) {
        this.initConnection_();
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        const request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        const outstandingGet = {
            action: 'g',
            request: request,
            onComplete: (message)=>{
                const payload = message['d'];
                if (message['s'] === 'ok') deferred.resolve(payload);
                else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        const index = this.outstandingGets_.length - 1;
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    }
    listen(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        const queryId = query._queryIdentifier;
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $474ae12482b554c6$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'listen() called for non-default but complete query');
        (0, $474ae12482b554c6$export$a7a9523472993e97)(!this.listens.get(pathString).has(queryId), `listen() called twice for same path/queryId.`);
        const listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    }
    sendGet_(index) {
        const get = this.outstandingGets_[index];
        this.sendRequest('g', get.request, (message)=>{
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    }
    sendListen_(listenSpec) {
        const query = listenSpec.query;
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query._queryObject;
            req['t'] = listenSpec.tag;
        }
        req[/*hash*/ 'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, (message)=>{
            const payload = message[/*data*/ 'd'];
            const status = message[/*status*/ 's'];
            // print warnings in any case...
            $e0be213f695400f3$var$PersistentConnection.warnOnListenWarnings_(payload, query);
            const currentListenSpec = this.listens.get(pathString) && this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                this.log_('listen response', message);
                if (status !== 'ok') this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    }
    static warnOnListenWarnings_(payload, query) {
        if (payload && typeof payload === 'object' && (0, $474ae12482b554c6$export$2344b14b097df817)(payload, 'w')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const warnings = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                const indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                const indexPath = query._path.toString();
                $e0be213f695400f3$var$warn(`Using an unspecified index. Your data will be downloaded and ` + `filtered on the client. Consider adding ${indexSpec} at ` + `${indexPath} to your security rules for better performance.`);
            }
        }
    }
    refreshAuthToken(token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest('unauth', {}, ()=>{});
        this.reduceReconnectDelayIfAdminCredential_(token);
    }
    reduceReconnectDelayIfAdminCredential_(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        const isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $474ae12482b554c6$export$fc970ed23da99565)(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    }
    refreshAppCheckToken(token) {
        this.appCheckToken_ = token;
        this.log_('App check token refreshed');
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest('unappeck', {}, ()=>{});
    }
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ tryAuth() {
        if (this.connected_ && this.authToken_) {
            const token = this.authToken_;
            const authMethod = (0, $474ae12482b554c6$export$9565ca3d387f8aa0)(token) ? 'auth' : 'gauth';
            const requestData = {
                cred: token
            };
            if (this.authOverride_ === null) requestData['noauth'] = true;
            else if (typeof this.authOverride_ === 'object') requestData['authvar'] = this.authOverride_;
            this.sendRequest(authMethod, requestData, (res)=>{
                const status = res[/*status*/ 's'];
                const data = res[/*data*/ 'd'] || 'error';
                if (this.authToken_ === token) {
                    if (status === 'ok') this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    this.onAuthRevoked_(status, data);
                }
            });
        }
    }
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ tryAppCheck() {
        if (this.connected_ && this.appCheckToken_) this.sendRequest('appcheck', {
            'token': this.appCheckToken_
        }, (res)=>{
            const status = res[/*status*/ 's'];
            const data = res[/*data*/ 'd'] || 'error';
            if (status === 'ok') this.invalidAppCheckTokenCount_ = 0;
            else this.onAppCheckRevoked_(status, data);
        });
    }
    /**
     * @inheritDoc
     */ unlisten(query, tag) {
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'unlisten() called for non-default but complete query');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    }
    sendUnlisten_(pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    }
    onDisconnectPut(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('o', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'o',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectMerge(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('om', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'om',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectCancel(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('oc', pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'oc',
            data: null,
            onComplete: onComplete
        });
    }
    sendOnDisconnect_(action, pathString, data, onComplete) {
        const request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, (response)=>{
            if (onComplete) setTimeout(()=>{
                onComplete(response[/*status*/ 's'], response[/* data */ 'd']);
            }, Math.floor(0));
        });
    }
    put(pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    }
    merge(pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    }
    putInternal(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        const request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ 'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        const index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_('Buffering put: ' + pathString);
    }
    sendPut_(index) {
        const action = this.outstandingPuts_[index].action;
        const request = this.outstandingPuts_[index].request;
        const onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, (message)=>{
            this.log_(action + ' response', message);
            delete this.outstandingPuts_[index];
            this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ 's'], message[/* data */ 'd']);
        });
    }
    reportStats(stats) {
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            const request = {
                c: stats
            };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, (result)=>{
                const status = result[/*status*/ 's'];
                if (status !== 'ok') {
                    const errorReason = result[/* data */ 'd'];
                    this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    }
    onDataMessage_(message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(message));
            const reqNum = message['r'];
            const onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ 'b']);
            }
        } else if ('error' in message) throw 'A server-side error has occurred: ' + message['error'];
        else if ('a' in message) // a and b are action and body, respectively
        this.onDataPush_(message['a'], message['b']);
    }
    onDataPush_(action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge*/ false, body['t']);
        else if (action === 'm') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge=*/ true, body['t']);
        else if (action === 'c') this.onListenRevoked_(body[/*path*/ 'p'], body[/*query*/ 'q']);
        else if (action === 'ac') this.onAuthRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'apc') this.onAppCheckRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'sd') this.onSecurityDebugPacket_(body);
        else $e0be213f695400f3$var$error('Unrecognized action received from server: ' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(action) + '\nAre you using the latest client?');
    }
    onReady_(timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    }
    scheduleConnect_(timeout) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(()=>{
            this.establishConnectionTimer_ = null;
            this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    }
    initConnection_() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    }
    onVisible_(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    }
    onOnline_(online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) this.realtime_.close();
        }
    }
    onRealtimeDisconnect_() {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                const timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $e0be213f695400f3$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            const timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            let reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $e0be213f695400f3$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    }
    async establishConnection_() {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            const onDataMessage = this.onDataMessage_.bind(this);
            const onReady = this.onReady_.bind(this);
            const onDisconnect = this.onRealtimeDisconnect_.bind(this);
            const connId = this.id + ':' + $e0be213f695400f3$var$PersistentConnection.nextConnectionId_++;
            const lastSessionId = this.lastSessionId;
            let canceled = false;
            let connection = null;
            const closeFn = function() {
                if (connection) connection.close();
                else {
                    canceled = true;
                    onDisconnect();
                }
            };
            const sendRequestFn = function(msg) {
                (0, $474ae12482b554c6$export$a7a9523472993e97)(connection, "sendRequest call when we're not connected not allowed.");
                connection.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn,
                sendRequest: sendRequestFn
            };
            const forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            try {
                // First fetch auth and app check token, and establish connection after
                // fetching the token was successful
                const [authToken, appCheckToken] = await Promise.all([
                    this.authTokenProvider_.getToken(forceRefresh),
                    this.appCheckTokenProvider_.getToken(forceRefresh)
                ]);
                if (!canceled) {
                    $e0be213f695400f3$var$log('getToken() completed. Creating connection.');
                    this.authToken_ = authToken && authToken.accessToken;
                    this.appCheckToken_ = appCheckToken && appCheckToken.token;
                    connection = new $e0be213f695400f3$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect, /* onKill= */ (reason)=>{
                        $e0be213f695400f3$var$warn(reason + ' (' + this.repoInfo_.toString() + ')');
                        this.interrupt($e0be213f695400f3$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId);
                } else $e0be213f695400f3$var$log('getToken() completed but was canceled');
            } catch (error) {
                this.log_('Failed to get token: ' + error);
                if (!canceled) {
                    if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $e0be213f695400f3$var$warn(error);
                    closeFn();
                }
            }
        }
    }
    interrupt(reason) {
        $e0be213f695400f3$var$log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    }
    resume(reason) {
        $e0be213f695400f3$var$log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if ((0, $474ae12482b554c6$export$dd1bc94b04021eeb)(this.interruptReasons_)) {
            this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    }
    handleTimestamp_(timestamp) {
        const delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    }
    cancelSentTransactions_() {
        for(let i = 0; i < this.outstandingPuts_.length; i++){
            const put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete) put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    }
    onListenRevoked_(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        let queryId;
        if (!query) queryId = 'default';
        else queryId = query.map((q)=>$e0be213f695400f3$var$ObjectToUniqueKey(q)).join('$');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete('permission_denied');
    }
    removeListen_(pathString, queryId) {
        const normalizedPathString = new $e0be213f695400f3$var$Path(pathString).toString(); // normalize path.
        let listen;
        if (this.listens.has(normalizedPathString)) {
            const map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    }
    onAuthRevoked_(statusCode, explanation) {
        $e0be213f695400f3$var$log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $e0be213f695400f3$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    }
    onAppCheckRevoked_(statusCode, explanation) {
        $e0be213f695400f3$var$log('App check token revoked: ' + statusCode + '/' + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $e0be213f695400f3$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    }
    onSecurityDebugPacket_(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ('msg' in body) console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
    }
    restoreState_() {
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        for (const queries of this.listens.values())for (const listenSpec of queries.values())this.sendListen_(listenSpec);
        for(let i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            const request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(let i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    }
    /**
     * Sends client stats for first connection
     */ sendConnectStats_() {
        const stats = {};
        let clientName = 'js';
        if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) {
            if (this.repoInfo_.nodeAdmin) clientName = 'admin_node';
            else clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + $e0be213f695400f3$var$SDK_VERSION.replace(/\./g, '-')] = 1;
        if ((0, $474ae12482b554c6$export$872f8323f01d7ae0)()) stats['framework.cordova'] = 1;
        else if ((0, $474ae12482b554c6$export$f7a1e23e542d38e3)()) stats['framework.reactnative'] = 1;
        this.reportStats(stats);
    }
    shouldReconnect_() {
        const online = $e0be213f695400f3$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $474ae12482b554c6$export$dd1bc94b04021eeb)(this.interruptReasons_) && online;
    }
}
$e0be213f695400f3$var$PersistentConnection.nextPersistentConnectionId_ = 0;
/**
 * Counter for number of connections created. Mainly used for tagging in the logs
 */ $e0be213f695400f3$var$PersistentConnection.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$NamedNode {
    constructor(name, node){
        this.name = name;
        this.node = node;
    }
    static Wrap(name, node) {
        return new $e0be213f695400f3$var$NamedNode(name, node);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$Index {
    /**
     * @returns A standalone comparison function for
     * this index
     */ getCompare() {
        return this.compare.bind(this);
    }
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ indexedValueChanged(oldNode, newNode) {
        const oldWrapped = new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MIN_NAME, oldNode);
        const newWrapped = new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    }
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $e0be213f695400f3$var$NamedNode.MIN;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$__EMPTY_NODE;
class $e0be213f695400f3$var$KeyIndex extends $e0be213f695400f3$var$Index {
    static get __EMPTY_NODE() {
        return $e0be213f695400f3$var$__EMPTY_NODE;
    }
    static set __EMPTY_NODE(val) {
        $e0be213f695400f3$var$__EMPTY_NODE = val;
    }
    compare(a, b) {
        return $e0be213f695400f3$var$nameCompare(a.name, b.name);
    }
    isDefinedOn(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $474ae12482b554c6$export$a39cad550e7ab28a)('KeyIndex.isDefinedOn not expected to be called.');
    }
    indexedValueChanged(oldNode, newNode) {
        return false; // The key for a node never changes.
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $e0be213f695400f3$var$NamedNode.MIN;
    }
    maxPost() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MAX_NAME, $e0be213f695400f3$var$__EMPTY_NODE);
    }
    makePost(indexValue, name) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $e0be213f695400f3$var$NamedNode(indexValue, $e0be213f695400f3$var$__EMPTY_NODE);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.key';
    }
}
const $e0be213f695400f3$var$KEY_INDEX = new $e0be213f695400f3$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ class $e0be213f695400f3$var$SortedMapIterator {
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ constructor(node, startKey, comparator, isReverse_, resultGenerator_ = null){
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        let cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    getNext() {
        if (this.nodeStack_.length === 0) return null;
        let node = this.nodeStack_.pop();
        let result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    }
    hasNext() {
        return this.nodeStack_.length > 0;
    }
    peek() {
        if (this.nodeStack_.length === 0) return null;
        const node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    }
}
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ class $e0be213f695400f3$var$LLRBNode {
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ constructor(key, value, color, left, right){
        this.key = key;
        this.value = value;
        this.color = color != null ? color : $e0be213f695400f3$var$LLRBNode.RED;
        this.left = left != null ? left : $e0be213f695400f3$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $e0be213f695400f3$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return new $e0be213f695400f3$var$LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return this.left.count() + 1 + this.right.count();
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return false;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    }
    /**
     * @returns The minimum node in the tree.
     */ min_() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    }
    /**
     * @returns The maximum key in the tree.
     */ minKey() {
        return this.min_().key;
    }
    /**
     * @returns The maximum key in the tree.
     */ maxKey() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    }
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ insert(key, value, comparator) {
        let n = this;
        const cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    }
    /**
     * @returns New tree, with the minimum key removed.
     */ removeMin_() {
        if (this.left.isEmpty()) return $e0be213f695400f3$var$SortedMap.EMPTY_NODE;
        let n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    }
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ remove(key, comparator) {
        let n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $e0be213f695400f3$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    }
    /**
     * @returns Whether this is a RED node.
     */ isRed_() {
        return this.color;
    }
    /**
     * @returns New tree after performing any needed rotations.
     */ fixUp_() {
        let n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    }
    /**
     * @returns New tree, after moveRedLeft.
     */ moveRedLeft_() {
        let n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after moveRedRight.
     */ moveRedRight_() {
        let n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after rotateLeft.
     */ rotateLeft_() {
        const nl = this.copy(null, null, $e0be213f695400f3$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    }
    /**
     * @returns New tree, after rotateRight.
     */ rotateRight_() {
        const nr = this.copy(null, null, $e0be213f695400f3$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    }
    /**
     * @returns Newt ree, after colorFlip.
     */ colorFlip_() {
        const left = this.left.copy(null, null, !this.left.color, null, null);
        const right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    }
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ checkMaxDepth_() {
        const blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    }
    check_() {
        if (this.isRed_() && this.left.isRed_()) throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        if (this.right.isRed_()) throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        const blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error('Black depths differ');
        else return blackDepth + (this.isRed_() ? 0 : 1);
    }
}
$e0be213f695400f3$var$LLRBNode.RED = true;
$e0be213f695400f3$var$LLRBNode.BLACK = false;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ class $e0be213f695400f3$var$LLRBEmptyNode {
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return this;
    }
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ insert(key, value, comparator) {
        return new $e0be213f695400f3$var$LLRBNode(key, value, null);
    }
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ remove(key, comparator) {
        return this;
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return 0;
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return true;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ inorderTraversal(action) {
        return false;
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    check_() {
        return 0;
    }
    /**
     * @returns Whether this node is red.
     */ isRed_() {
        return false;
    }
}
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ class $e0be213f695400f3$var$SortedMap {
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ constructor(comparator_, root_ = $e0be213f695400f3$var$SortedMap.EMPTY_NODE){
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ insert(key, value) {
        return new $e0be213f695400f3$var$SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $e0be213f695400f3$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ remove(key) {
        return new $e0be213f695400f3$var$SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $e0be213f695400f3$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ get(key) {
        let cmp;
        let node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    }
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ getPredecessorKey(key) {
        let cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    }
    /**
     * @returns True if the map is empty.
     */ isEmpty() {
        return this.root_.isEmpty();
    }
    /**
     * @returns The total number of nodes in the map.
     */ count() {
        return this.root_.count();
    }
    /**
     * @returns The minimum key in the map.
     */ minKey() {
        return this.root_.minKey();
    }
    /**
     * @returns The maximum key in the map.
     */ maxKey() {
        return this.root_.maxKey();
    }
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.root_.inorderTraversal(action);
    }
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ reverseTraversal(action) {
        return this.root_.reverseTraversal(action);
    }
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ getIterator(resultGenerator) {
        return new $e0be213f695400f3$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    }
    getIteratorFrom(key, resultGenerator) {
        return new $e0be213f695400f3$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    }
    getReverseIteratorFrom(key, resultGenerator) {
        return new $e0be213f695400f3$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    }
    getReverseIterator(resultGenerator) {
        return new $e0be213f695400f3$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    }
}
/**
 * Always use the same empty node, to reduce memory.
 */ $e0be213f695400f3$var$SortedMap.EMPTY_NODE = new $e0be213f695400f3$var$LLRBEmptyNode();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$NAME_ONLY_COMPARATOR(left, right) {
    return $e0be213f695400f3$var$nameCompare(left.name, right.name);
}
function $e0be213f695400f3$var$NAME_COMPARATOR(left, right) {
    return $e0be213f695400f3$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$MAX_NODE$2;
function $e0be213f695400f3$var$setMaxNode$1(val) {
    $e0be213f695400f3$var$MAX_NODE$2 = val;
}
const $e0be213f695400f3$var$priorityHashText = function(priority) {
    if (typeof priority === 'number') return 'number:' + $e0be213f695400f3$var$doubleToIEEE754String(priority);
    else return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ const $e0be213f695400f3$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        const val = priorityNode.val();
        (0, $474ae12482b554c6$export$a7a9523472993e97)(typeof val === 'string' || typeof val === 'number' || typeof val === 'object' && (0, $474ae12482b554c6$export$2344b14b097df817)(val, '.sv'), 'Priority must be a string or number.');
    } else (0, $474ae12482b554c6$export$a7a9523472993e97)(priorityNode === $e0be213f695400f3$var$MAX_NODE$2 || priorityNode.isEmpty(), 'priority of unexpected type.');
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $474ae12482b554c6$export$a7a9523472993e97)(priorityNode === $e0be213f695400f3$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ class $e0be213f695400f3$var$LeafNode {
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ constructor(value_, priorityNode_ = $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE){
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $e0be213f695400f3$var$validatePriorityNode(this.priorityNode_);
    }
    static set __childrenNodeConstructor(val) {
        $e0be213f695400f3$var$__childrenNodeConstructor = val;
    }
    static get __childrenNodeConstructor() {
        return $e0be213f695400f3$var$__childrenNodeConstructor;
    }
    /** @inheritDoc */ isLeafNode() {
        return true;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        return new $e0be213f695400f3$var$LeafNode(this.value_, newPriorityNode);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.priorityNode_;
        else return $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    /** @inheritDoc */ getChild(path) {
        if ($e0be213f695400f3$var$pathIsEmpty(path)) return this;
        else if ($e0be213f695400f3$var$pathGetFront(path) === '.priority') return this.priorityNode_;
        else return $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    hasChild() {
        return false;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode) {
        return null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== '.priority') return this;
        else return $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $e0be213f695400f3$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== '.priority') return this;
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(front !== '.priority' || $e0be213f695400f3$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($e0be213f695400f3$var$pathPopFront(path), newChildNode));
        }
    }
    /** @inheritDoc */ isEmpty() {
        return false;
    }
    /** @inheritDoc */ numChildren() {
        return 0;
    }
    /** @inheritDoc */ forEachChild(index, action) {
        return false;
    }
    val(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            '.value': this.getValue(),
            '.priority': this.getPriority().val()
        };
        else return this.getValue();
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.priorityNode_.isEmpty()) toHash += 'priority:' + $e0be213f695400f3$var$priorityHashText(this.priorityNode_.val()) + ':';
            const type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') toHash += $e0be213f695400f3$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $e0be213f695400f3$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ getValue() {
        return this.value_;
    }
    compareTo(other) {
        if (other === $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    }
    /**
     * Comparison specifically for two leaf nodes
     */ compareToLeafNode_(otherLeaf) {
        const otherLeafType = typeof otherLeaf.value_;
        const thisLeafType = typeof this.value_;
        const otherIndex = $e0be213f695400f3$var$LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        const thisIndex = $e0be213f695400f3$var$LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    }
    withIndex() {
        return this;
    }
    isIndexed() {
        return true;
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            const otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    }
}
/**
 * The sort order for comparing leaf nodes of different types. If two leaf nodes have
 * the same type, the comparison falls back to their value
 */ $e0be213f695400f3$var$LeafNode.VALUE_TYPE_ORDER = [
    'object',
    'boolean',
    'number',
    'string'
];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$nodeFromJSON$1;
let $e0be213f695400f3$var$MAX_NODE$1;
function $e0be213f695400f3$var$setNodeFromJSON(val) {
    $e0be213f695400f3$var$nodeFromJSON$1 = val;
}
function $e0be213f695400f3$var$setMaxNode(val) {
    $e0be213f695400f3$var$MAX_NODE$1 = val;
}
class $e0be213f695400f3$var$PriorityIndex extends $e0be213f695400f3$var$Index {
    compare(a, b) {
        const aPriority = a.node.getPriority();
        const bPriority = b.node.getPriority();
        const indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $e0be213f695400f3$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return !node.getPriority().isEmpty();
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $e0be213f695400f3$var$NamedNode.MIN;
    }
    maxPost() {
        return new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MAX_NAME, new $e0be213f695400f3$var$LeafNode('[PRIORITY-POST]', $e0be213f695400f3$var$MAX_NODE$1));
    }
    makePost(indexValue, name) {
        const priorityNode = $e0be213f695400f3$var$nodeFromJSON$1(indexValue);
        return new $e0be213f695400f3$var$NamedNode(name, new $e0be213f695400f3$var$LeafNode('[PRIORITY-POST]', priorityNode));
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.priority';
    }
}
const $e0be213f695400f3$var$PRIORITY_INDEX = new $e0be213f695400f3$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$LOG_2 = Math.log(2);
class $e0be213f695400f3$var$Base12Num {
    constructor(length){
        const logBase2 = (num)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            parseInt(Math.log(num) / $e0be213f695400f3$var$LOG_2, 10);
        const bitMask = (bits)=>parseInt(Array(bits + 1).join('1'), 2);
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        const mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    nextBitIsOne() {
        //noinspection JSBitwiseOperatorUsage
        const result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    }
}
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ const $e0be213f695400f3$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    const buildBalancedTree = function(low, high) {
        const length = high - low;
        let namedNode;
        let key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $e0be213f695400f3$var$LLRBNode(key, namedNode.node, $e0be213f695400f3$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const middle = parseInt(length / 2, 10) + low;
            const left = buildBalancedTree(low, middle);
            const right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $e0be213f695400f3$var$LLRBNode(key, namedNode.node, $e0be213f695400f3$var$LLRBNode.BLACK, left, right);
        }
    };
    const buildFrom12Array = function(base12) {
        let node = null;
        let root = null;
        let index = childList.length;
        const buildPennant = function(chunkSize, color) {
            const low = index - chunkSize;
            const high = index;
            index -= chunkSize;
            const childTree = buildBalancedTree(low + 1, high);
            const namedNode = childList[low];
            const key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $e0be213f695400f3$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        const attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(let i = 0; i < base12.count; ++i){
            const isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            const chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $e0be213f695400f3$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $e0be213f695400f3$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $e0be213f695400f3$var$LLRBNode.RED);
            }
        }
        return root;
    };
    const base12 = new $e0be213f695400f3$var$Base12Num(childList.length);
    const root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $e0be213f695400f3$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$_defaultIndexMap;
const $e0be213f695400f3$var$fallbackObject = {};
class $e0be213f695400f3$var$IndexMap {
    constructor(indexes_, indexSet_){
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    /**
     * The default IndexMap for nodes without a priority
     */ static get Default() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$fallbackObject && $e0be213f695400f3$var$PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
        $e0be213f695400f3$var$_defaultIndexMap = $e0be213f695400f3$var$_defaultIndexMap || new $e0be213f695400f3$var$IndexMap({
            '.priority': $e0be213f695400f3$var$fallbackObject
        }, {
            '.priority': $e0be213f695400f3$var$PRIORITY_INDEX
        });
        return $e0be213f695400f3$var$_defaultIndexMap;
    }
    get(indexKey) {
        const sortedMap = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error('No index defined for ' + indexKey);
        if (sortedMap instanceof $e0be213f695400f3$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    }
    hasIndex(indexDefinition) {
        return (0, $474ae12482b554c6$export$2344b14b097df817)(this.indexSet_, indexDefinition.toString());
    }
    addIndex(indexDefinition, existingChildren) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(indexDefinition !== $e0be213f695400f3$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        const childList = [];
        let sawIndexedValue = false;
        const iter = existingChildren.getIterator($e0be213f695400f3$var$NamedNode.Wrap);
        let next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        let newIndex;
        if (sawIndexedValue) newIndex = $e0be213f695400f3$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $e0be213f695400f3$var$fallbackObject;
        const indexName = indexDefinition.toString();
        const newIndexSet = Object.assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        const newIndexes = Object.assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new $e0be213f695400f3$var$IndexMap(newIndexes, newIndexSet);
    }
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ addToIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $474ae12482b554c6$export$871de8747c9eaa88)(this.indexes_, (indexedChildren, indexName)=>{
            const index = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(this.indexSet_, indexName);
            (0, $474ae12482b554c6$export$a7a9523472993e97)(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === $e0be213f695400f3$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    const childList = [];
                    const iter = existingChildren.getIterator($e0be213f695400f3$var$NamedNode.Wrap);
                    let next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $e0be213f695400f3$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $e0be213f695400f3$var$fallbackObject;
            } else {
                const existingSnap = existingChildren.get(namedNode.name);
                let newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $e0be213f695400f3$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new $e0be213f695400f3$var$IndexMap(newIndexes, this.indexSet_);
    }
    /**
     * Create a new IndexMap instance with the given value removed
     */ removeFromIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $474ae12482b554c6$export$871de8747c9eaa88)(this.indexes_, (indexedChildren)=>{
            if (indexedChildren === $e0be213f695400f3$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                const existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $e0be213f695400f3$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new $e0be213f695400f3$var$IndexMap(newIndexes, this.indexSet_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
let $e0be213f695400f3$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ class $e0be213f695400f3$var$ChildrenNode {
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ constructor(children_, priorityNode_, indexMap_){
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $e0be213f695400f3$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $474ae12482b554c6$export$a7a9523472993e97)(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
    }
    static get EMPTY_NODE() {
        return $e0be213f695400f3$var$EMPTY_NODE || ($e0be213f695400f3$var$EMPTY_NODE = new $e0be213f695400f3$var$ChildrenNode(new $e0be213f695400f3$var$SortedMap($e0be213f695400f3$var$NAME_COMPARATOR), null, $e0be213f695400f3$var$IndexMap.Default));
    }
    /** @inheritDoc */ isLeafNode() {
        return false;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_ || $e0be213f695400f3$var$EMPTY_NODE;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new $e0be213f695400f3$var$ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.getPriority();
        else {
            const child = this.children_.get(childName);
            return child === null ? $e0be213f695400f3$var$EMPTY_NODE : child;
        }
    }
    /** @inheritDoc */ getChild(path) {
        const front = $e0be213f695400f3$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($e0be213f695400f3$var$pathPopFront(path));
    }
    /** @inheritDoc */ hasChild(childName) {
        return this.children_.get(childName) !== null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else {
            const namedNode = new $e0be213f695400f3$var$NamedNode(childName, newChildNode);
            let newChildren, newIndexMap;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            const newPriority = newChildren.isEmpty() ? $e0be213f695400f3$var$EMPTY_NODE : this.priorityNode_;
            return new $e0be213f695400f3$var$ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $e0be213f695400f3$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$pathGetFront(path) !== '.priority' || $e0be213f695400f3$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            const newImmediateChild = this.getImmediateChild(front).updateChild($e0be213f695400f3$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    }
    /** @inheritDoc */ isEmpty() {
        return this.children_.isEmpty();
    }
    /** @inheritDoc */ numChildren() {
        return this.children_.count();
    }
    /** @inheritDoc */ val(exportFormat) {
        if (this.isEmpty()) return null;
        const obj = {};
        let numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && $e0be213f695400f3$var$ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            const array = [];
            // eslint-disable-next-line guard-for-in
            for(const key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj['.priority'] = this.getPriority().val();
            return obj;
        }
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.getPriority().isEmpty()) toHash += 'priority:' + $e0be213f695400f3$var$priorityHashText(this.getPriority().val()) + ':';
            this.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
                const childHash = childNode.hash();
                if (childHash !== '') toHash += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash === '' ? '' : $e0be213f695400f3$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode, index) {
        const idx = this.resolveIndex_(index);
        if (idx) {
            const predecessor = idx.getPredecessorKey(new $e0be213f695400f3$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    }
    getFirstChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    }
    getFirstChild(indexDefinition) {
        const minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $e0be213f695400f3$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    }
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ getLastChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    }
    getLastChild(indexDefinition) {
        const maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $e0be213f695400f3$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    }
    forEachChild(index, action) {
        const idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal((wrappedNode)=>{
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    }
    getIterator(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    }
    getIteratorFrom(startPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, (key)=>key);
        else {
            const iterator = this.children_.getIteratorFrom(startPost.name, $e0be213f695400f3$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    getReverseIterator(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    }
    getReverseIteratorFrom(endPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, (key)=>{
            return key;
        });
        else {
            const iterator = this.children_.getReverseIteratorFrom(endPost.name, $e0be213f695400f3$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    compareTo(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $e0be213f695400f3$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    }
    withIndex(indexDefinition) {
        if (indexDefinition === $e0be213f695400f3$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            const newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new $e0be213f695400f3$var$ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    }
    isIndexed(index) {
        return index === $e0be213f695400f3$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            const otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                const thisIter = this.getIterator($e0be213f695400f3$var$PRIORITY_INDEX);
                const otherIter = otherChildrenNode.getIterator($e0be213f695400f3$var$PRIORITY_INDEX);
                let thisCurrent = thisIter.getNext();
                let otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    }
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ resolveIndex_(indexDefinition) {
        if (indexDefinition === $e0be213f695400f3$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    }
}
$e0be213f695400f3$var$ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class $e0be213f695400f3$var$MaxNode extends $e0be213f695400f3$var$ChildrenNode {
    constructor(){
        super(new $e0be213f695400f3$var$SortedMap($e0be213f695400f3$var$NAME_COMPARATOR), $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE, $e0be213f695400f3$var$IndexMap.Default);
    }
    compareTo(other) {
        if (other === this) return 0;
        else return 1;
    }
    equals(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    }
    getPriority() {
        return this;
    }
    getImmediateChild(childName) {
        return $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
    }
    isEmpty() {
        return false;
    }
}
/**
 * Marker that will sort higher than any other snapshot.
 */ const $e0be213f695400f3$var$MAX_NODE = new $e0be213f695400f3$var$MaxNode();
Object.defineProperties($e0be213f695400f3$var$NamedNode, {
    MIN: {
        value: new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MIN_NAME, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MAX_NAME, $e0be213f695400f3$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $e0be213f695400f3$var$KeyIndex.__EMPTY_NODE = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
$e0be213f695400f3$var$LeafNode.__childrenNodeConstructor = $e0be213f695400f3$var$ChildrenNode;
$e0be213f695400f3$var$setMaxNode$1($e0be213f695400f3$var$MAX_NODE);
$e0be213f695400f3$var$setMaxNode($e0be213f695400f3$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $e0be213f695400f3$var$nodeFromJSON(json, priority = null) {
    if (json === null) return $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === 'object' && '.priority' in json) priority = json['.priority'];
    (0, $474ae12482b554c6$export$a7a9523472993e97)(priority === null || typeof priority === 'string' || typeof priority === 'number' || typeof priority === 'object' && '.sv' in priority, 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) json = json['.value'];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        const jsonLeaf = json;
        return new $e0be213f695400f3$var$LeafNode(jsonLeaf, $e0be213f695400f3$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $e0be213f695400f3$var$USE_HINZE) {
        const children = [];
        let childrenHavePriority = false;
        const hinzeJsonObj = json;
        $e0be213f695400f3$var$each(hinzeJsonObj, (key, child)=>{
            if (key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                const childNode = $e0be213f695400f3$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority = childrenHavePriority || !childNode.getPriority().isEmpty();
                    children.push(new $e0be213f695400f3$var$NamedNode(key, childNode));
                }
            }
        });
        if (children.length === 0) return $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        const childSet = $e0be213f695400f3$var$buildChildSet(children, $e0be213f695400f3$var$NAME_ONLY_COMPARATOR, (namedNode)=>namedNode.name, $e0be213f695400f3$var$NAME_COMPARATOR);
        if (childrenHavePriority) {
            const sortedChildSet = $e0be213f695400f3$var$buildChildSet(children, $e0be213f695400f3$var$PRIORITY_INDEX.getCompare());
            return new $e0be213f695400f3$var$ChildrenNode(childSet, $e0be213f695400f3$var$nodeFromJSON(priority), new $e0be213f695400f3$var$IndexMap({
                '.priority': sortedChildSet
            }, {
                '.priority': $e0be213f695400f3$var$PRIORITY_INDEX
            }));
        } else return new $e0be213f695400f3$var$ChildrenNode(childSet, $e0be213f695400f3$var$nodeFromJSON(priority), $e0be213f695400f3$var$IndexMap.Default);
    } else {
        let node = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        $e0be213f695400f3$var$each(json, (key, childData)=>{
            if ((0, $474ae12482b554c6$export$2344b14b097df817)(json, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    const childNode = $e0be213f695400f3$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node = node.updateImmediateChild(key, childNode);
                }
            }
        });
        return node.updatePriority($e0be213f695400f3$var$nodeFromJSON(priority));
    }
}
$e0be213f695400f3$var$setNodeFromJSON($e0be213f695400f3$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$PathIndex extends $e0be213f695400f3$var$Index {
    constructor(indexPath_){
        super();
        this.indexPath_ = indexPath_;
        (0, $474ae12482b554c6$export$a7a9523472993e97)(!$e0be213f695400f3$var$pathIsEmpty(indexPath_) && $e0be213f695400f3$var$pathGetFront(indexPath_) !== '.priority', "Can't create PathIndex with empty path or .priority key");
    }
    extractChild(snap) {
        return snap.getChild(this.indexPath_);
    }
    isDefinedOn(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    }
    compare(a, b) {
        const aChild = this.extractChild(a.node);
        const bChild = this.extractChild(b.node);
        const indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $e0be213f695400f3$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    makePost(indexValue, name) {
        const valueNode = $e0be213f695400f3$var$nodeFromJSON(indexValue);
        const node = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $e0be213f695400f3$var$NamedNode(name, node);
    }
    maxPost() {
        const node = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $e0be213f695400f3$var$MAX_NODE);
        return new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MAX_NAME, node);
    }
    toString() {
        return $e0be213f695400f3$var$pathSlice(this.indexPath_, 0).join('/');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$ValueIndex extends $e0be213f695400f3$var$Index {
    compare(a, b) {
        const indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $e0be213f695400f3$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return true;
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.equals(newNode);
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $e0be213f695400f3$var$NamedNode.MIN;
    }
    maxPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $e0be213f695400f3$var$NamedNode.MAX;
    }
    makePost(indexValue, name) {
        const valueNode = $e0be213f695400f3$var$nodeFromJSON(indexValue);
        return new $e0be213f695400f3$var$NamedNode(name, valueNode);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.value';
    }
}
const $e0be213f695400f3$var$VALUE_INDEX = new $e0be213f695400f3$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$changeValue(snapshotNode) {
    return {
        type: "value" /* ChangeType.VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $e0be213f695400f3$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* ChangeType.CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $e0be213f695400f3$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* ChangeType.CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $e0be213f695400f3$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* ChangeType.CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $e0be213f695400f3$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* ChangeType.CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ class $e0be213f695400f3$var$IndexedFilter {
    constructor(index_){
        this.index_ = index_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        const oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildRemoved(key, oldChild));
                else (0, $474ae12482b554c6$export$a7a9523472993e97)(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
                if (oldSnap.hasChild(key)) {
                    const oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    }
    updatePriority(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    }
    filtersNodes() {
        return false;
    }
    getIndexedFilter() {
        return this;
    }
    getIndex() {
        return this.index_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ class $e0be213f695400f3$var$RangedFilter {
    constructor(params){
        this.indexedFilter_ = new $e0be213f695400f3$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = $e0be213f695400f3$var$RangedFilter.getStartPost_(params);
        this.endPost_ = $e0be213f695400f3$var$RangedFilter.getEndPost_(params);
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    getStartPost() {
        return this.startPost_;
    }
    getEndPost() {
        return this.endPost_;
    }
    matches(node) {
        const isWithinStart = this.startIsInclusive_ ? this.index_.compare(this.getStartPost(), node) <= 0 : this.index_.compare(this.getStartPost(), node) < 0;
        const isWithinEnd = this.endIsInclusive_ ? this.index_.compare(node, this.getEndPost()) <= 0 : this.index_.compare(node, this.getEndPost()) < 0;
        return isWithinStart && isWithinEnd;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $e0be213f695400f3$var$NamedNode(key, newChild))) newChild = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        let filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
        const self = this;
        newSnap.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
            if (!self.matches(new $e0be213f695400f3$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.indexedFilter_;
    }
    getIndex() {
        return this.index_;
    }
    static getStartPost_(params) {
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    }
    static getEndPost_(params) {
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ class $e0be213f695400f3$var$LimitedFilter {
    constructor(params){
        this.withinDirectionalStart = (node)=>this.reverse_ ? this.withinEndPost(node) : this.withinStartPost(node);
        this.withinDirectionalEnd = (node)=>this.reverse_ ? this.withinStartPost(node) : this.withinEndPost(node);
        this.withinStartPost = (node)=>{
            const compareRes = this.index_.compare(this.rangedFilter_.getStartPost(), node);
            return this.startIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.withinEndPost = (node)=>{
            const compareRes = this.index_.compare(node, this.rangedFilter_.getEndPost());
            return this.endIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.rangedFilter_ = new $e0be213f695400f3$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $e0be213f695400f3$var$NamedNode(key, newChild))) newChild = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        let filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            let iterator;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            let count = 0;
            while(iterator.hasNext() && count < this.limit_){
                const next = iterator.getNext();
                if (!this.withinDirectionalStart(next)) continue;
                else if (!this.withinDirectionalEnd(next)) break;
                else {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                }
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
            let iterator;
            if (this.reverse_) iterator = filtered.getReverseIterator(this.index_);
            else iterator = filtered.getIterator(this.index_);
            let count = 0;
            while(iterator.hasNext()){
                const next = iterator.getNext();
                const inRange = count < this.limit_ && this.withinDirectionalStart(next) && this.withinDirectionalEnd(next);
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.rangedFilter_.getIndexedFilter();
    }
    getIndex() {
        return this.index_;
    }
    fullLimitUpdateChild_(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        let cmp;
        if (this.reverse_) {
            const indexCmp = this.index_.getCompare();
            cmp = (a, b)=>indexCmp(b, a);
        } else cmp = this.index_.getCompare();
        const oldEventCache = snap;
        (0, $474ae12482b554c6$export$a7a9523472993e97)(oldEventCache.numChildren() === this.limit_, '');
        const newChildNamedNode = new $e0be213f695400f3$var$NamedNode(childKey, childSnap);
        const windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        const inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            const oldChildSnap = oldEventCache.getImmediateChild(childKey);
            let nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            const compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            const remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildRemoved(childKey, oldChildSnap));
                const newEventCache = oldEventCache.updateImmediateChild(childKey, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
                const nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 *
 * @internal
 */ class $e0be213f695400f3$export$7ba287e361c94330 {
    constructor(){
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false; // can only be true if startSet_ is true
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false; // can only be true if endSet_ is true
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = $e0be213f695400f3$var$PRIORITY_INDEX;
    }
    hasStart() {
        return this.startSet_;
    }
    /**
     * @returns True if it would return from left.
     */ isViewFromLeft() {
        if (this.viewFrom_ === '') // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    }
    /**
     * Only valid to call if hasStart() returns true
     */ getIndexStartValue() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    }
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ getIndexStartName() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) return this.indexStartName_;
        else return $e0be213f695400f3$var$MIN_NAME;
    }
    hasEnd() {
        return this.endSet_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     */ getIndexEndValue() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ getIndexEndName() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) return this.indexEndName_;
        else return $e0be213f695400f3$var$MAX_NAME;
    }
    hasLimit() {
        return this.limitSet_;
    }
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ hasAnchoredLimit() {
        return this.limitSet_ && this.viewFrom_ !== '';
    }
    /**
     * Only valid to call if hasLimit() returns true
     */ getLimit() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    }
    getIndex() {
        return this.index_;
    }
    loadsAllData() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    }
    isDefault() {
        return this.loadsAllData() && this.index_ === $e0be213f695400f3$var$PRIORITY_INDEX;
    }
    copy() {
        const copy = new $e0be213f695400f3$export$7ba287e361c94330();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.startAfterSet_ = this.startAfterSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.endBeforeSet_ = this.endBeforeSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    }
}
function $e0be213f695400f3$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $e0be213f695400f3$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $e0be213f695400f3$var$LimitedFilter(queryParams);
    else return new $e0be213f695400f3$var$RangedFilter(queryParams);
}
function $e0be213f695400f3$var$queryParamsLimitToFirst(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    return newParams;
}
function $e0be213f695400f3$var$queryParamsLimitToLast(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $e0be213f695400f3$var$queryParamsStartAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = '';
    }
    return newParams;
}
function $e0be213f695400f3$var$queryParamsStartAfter(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $e0be213f695400f3$var$KEY_INDEX || !!key) params = $e0be213f695400f3$var$queryParamsStartAt(queryParams, indexValue, key);
    else params = $e0be213f695400f3$var$queryParamsStartAt(queryParams, indexValue, $e0be213f695400f3$var$MAX_NAME);
    params.startAfterSet_ = true;
    return params;
}
function $e0be213f695400f3$var$queryParamsEndAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = '';
    }
    return newParams;
}
function $e0be213f695400f3$var$queryParamsEndBefore(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $e0be213f695400f3$var$KEY_INDEX || !!key) params = $e0be213f695400f3$var$queryParamsEndAt(queryParams, indexValue, key);
    else params = $e0be213f695400f3$var$queryParamsEndAt(queryParams, indexValue, $e0be213f695400f3$var$MIN_NAME);
    params.endBeforeSet_ = true;
    return params;
}
function $e0be213f695400f3$var$queryParamsOrderBy(queryParams, index) {
    const newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $e0be213f695400f3$var$queryParamsToRestQueryStringParameters(queryParams) {
    const qs = {};
    if (queryParams.isDefault()) return qs;
    let orderBy;
    if (queryParams.index_ === $e0be213f695400f3$var$PRIORITY_INDEX) orderBy = "$priority" /* REST_QUERY_CONSTANTS.PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $e0be213f695400f3$var$VALUE_INDEX) orderBy = "$value" /* REST_QUERY_CONSTANTS.VALUE_INDEX */ ;
    else if (queryParams.index_ === $e0be213f695400f3$var$KEY_INDEX) orderBy = "$key" /* REST_QUERY_CONSTANTS.KEY_INDEX */ ;
    else {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(queryParams.index_ instanceof $e0be213f695400f3$var$PathIndex, 'Unrecognized index type!');
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* REST_QUERY_CONSTANTS.ORDER_BY */ ] = (0, $474ae12482b554c6$export$fac44ee5b035f737)(orderBy);
    if (queryParams.startSet_) {
        const startParam = queryParams.startAfterSet_ ? "startAfter" /* REST_QUERY_CONSTANTS.START_AFTER */  : "startAt" /* REST_QUERY_CONSTANTS.START_AT */ ;
        qs[startParam] = (0, $474ae12482b554c6$export$fac44ee5b035f737)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs[startParam] += ',' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        const endParam = queryParams.endBeforeSet_ ? "endBefore" /* REST_QUERY_CONSTANTS.END_BEFORE */  : "endAt" /* REST_QUERY_CONSTANTS.END_AT */ ;
        qs[endParam] = (0, $474ae12482b554c6$export$fac44ee5b035f737)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs[endParam] += ',' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* REST_QUERY_CONSTANTS.LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* REST_QUERY_CONSTANTS.LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $e0be213f695400f3$var$queryParamsGetQueryObject(queryParams) {
    const obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME */ ] = queryParams.indexStartName_;
        obj["sin" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_IS_INCLUSIVE */ ] = !queryParams.startAfterSet_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME */ ] = queryParams.indexEndName_;
        obj["ein" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_IS_INCLUSIVE */ ] = !queryParams.endBeforeSet_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* WIRE_PROTOCOL_CONSTANTS.LIMIT */ ] = queryParams.limit_;
        let viewFrom = queryParams.viewFrom_;
        if (viewFrom === '') {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $e0be213f695400f3$var$PRIORITY_INDEX) obj["i" /* WIRE_PROTOCOL_CONSTANTS.INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ class $e0be213f695400f3$var$ReadonlyRestClient extends $e0be213f695400f3$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_){
        super();
        this.repoInfo_ = repoInfo_;
        this.onDataUpdate_ = onDataUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ this.log_ = $e0be213f695400f3$var$logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ this.listens_ = {};
    }
    reportStats(stats) {
        throw new Error('Method not implemented.');
    }
    static getListenId_(query, tag) {
        if (tag !== undefined) return 'tag$' + tag;
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    }
    /** @inheritDoc */ listen(query, currentHashFn, tag, onComplete) {
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        const listenId = $e0be213f695400f3$var$ReadonlyRestClient.getListenId_(query, tag);
        const thisListen = {};
        this.listens_[listenId] = thisListen;
        const queryStringParameters = $e0be213f695400f3$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $474ae12482b554c6$export$e51ae4db7b428f67)(this.listens_, listenId) === thisListen) {
                let status;
                if (!error) status = 'ok';
                else if (error === 401) status = 'permission_denied';
                else status = 'rest_error:' + error;
                onComplete(status, null);
            }
        });
    }
    /** @inheritDoc */ unlisten(query, tag) {
        const listenId = $e0be213f695400f3$var$ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    }
    get(query) {
        const queryStringParameters = $e0be213f695400f3$var$queryParamsToRestQueryStringParameters(query._queryParams);
        const pathString = query._path.toString();
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    }
    /** @inheritDoc */ refreshAuthToken(token) {
    // no-op since we just always call getToken.
    }
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ restRequest_(pathString, queryStringParameters = {}, callback) {
        queryStringParameters['format'] = 'export';
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(([authToken, appCheckToken])=>{
            if (authToken && authToken.accessToken) queryStringParameters['auth'] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters['ac'] = appCheckToken.token;
            const url = (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host + pathString + '?' + 'ns=' + this.repoInfo_.namespace + (0, $474ae12482b554c6$export$ac4103b836844853)(queryStringParameters);
            this.log_('Sending REST request for ' + url);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = ()=>{
                if (callback && xhr.readyState === 4) {
                    this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    let res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $474ae12482b554c6$export$c5a53ce6a17cf18d)(xhr.responseText);
                        } catch (e) {
                            $e0be213f695400f3$var$warn('Failed to parse JSON response for ' + url + ': ' + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $e0be213f695400f3$var$warn('Got unsuccessful REST response for ' + url + ' Status: ' + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ class $e0be213f695400f3$var$SnapshotHolder {
    constructor(){
        this.rootNode_ = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
    }
    getNode(path) {
        return this.rootNode_.getChild(path);
    }
    updateSnapshot(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $e0be213f695400f3$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($e0be213f695400f3$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        const childKey = $e0be213f695400f3$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $e0be213f695400f3$var$newSparseSnapshotTree());
        const child = sparseSnapshotTree.children.get(childKey);
        path = $e0be213f695400f3$var$pathPopFront(path);
        $e0be213f695400f3$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $e0be213f695400f3$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($e0be213f695400f3$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                const value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, tree)=>{
                    $e0be213f695400f3$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $e0be213f695400f3$var$Path(key), tree);
                });
                return $e0be213f695400f3$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            const childKey = $e0be213f695400f3$var$pathGetFront(path);
            path = $e0be213f695400f3$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                const safeToRemove = $e0be213f695400f3$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $e0be213f695400f3$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $e0be213f695400f3$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, (key, tree)=>{
        const path = new $e0be213f695400f3$var$Path(prefixPath.toString() + '/' + key);
        $e0be213f695400f3$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $e0be213f695400f3$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach((tree, key)=>{
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ class $e0be213f695400f3$var$StatsListener {
    constructor(collection_){
        this.collection_ = collection_;
        this.last_ = null;
    }
    get() {
        const newStats = this.collection_.get();
        const delta = Object.assign({}, newStats);
        if (this.last_) $e0be213f695400f3$var$each(this.last_, (stat, value)=>{
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
const $e0be213f695400f3$var$FIRST_STATS_MIN_TIME = 10000;
const $e0be213f695400f3$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
const $e0be213f695400f3$var$REPORT_STATS_INTERVAL = 300000;
class $e0be213f695400f3$var$StatsReporter {
    constructor(collection, server_){
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $e0be213f695400f3$var$StatsListener(collection);
        const timeout = $e0be213f695400f3$var$FIRST_STATS_MIN_TIME + ($e0be213f695400f3$var$FIRST_STATS_MAX_TIME - $e0be213f695400f3$var$FIRST_STATS_MIN_TIME) * Math.random();
        $e0be213f695400f3$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    reportStats_() {
        const stats = this.statsListener_.get();
        const reportedStats = {};
        let haveStatsToReport = false;
        $e0be213f695400f3$var$each(stats, (stat, value)=>{
            if (value > 0 && (0, $474ae12482b554c6$export$2344b14b097df817)(this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $e0be213f695400f3$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $e0be213f695400f3$var$REPORT_STATS_INTERVAL));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $e0be213f695400f3$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($e0be213f695400f3$var$OperationType || ($e0be213f695400f3$var$OperationType = {}));
function $e0be213f695400f3$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $e0be213f695400f3$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $e0be213f695400f3$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$AckUserWrite {
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ constructor(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert){
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $e0be213f695400f3$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $e0be213f695400f3$var$newOperationSourceUser();
    }
    operationForChild(childName) {
        if (!$e0be213f695400f3$var$pathIsEmpty(this.path)) {
            (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$pathGetFront(this.path) === childName, 'operationForChild called for unrelated child.');
            return new $e0be213f695400f3$var$AckUserWrite($e0be213f695400f3$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            const childTree = this.affectedTree.subtree(new $e0be213f695400f3$var$Path(childName));
            return new $e0be213f695400f3$var$AckUserWrite($e0be213f695400f3$var$newEmptyPath(), childTree, this.revert);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$ListenComplete {
    constructor(source, path){
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $e0be213f695400f3$var$OperationType.LISTEN_COMPLETE;
    }
    operationForChild(childName) {
        if ($e0be213f695400f3$var$pathIsEmpty(this.path)) return new $e0be213f695400f3$var$ListenComplete(this.source, $e0be213f695400f3$var$newEmptyPath());
        else return new $e0be213f695400f3$var$ListenComplete(this.source, $e0be213f695400f3$var$pathPopFront(this.path));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$Overwrite {
    constructor(source, path, snap){
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $e0be213f695400f3$var$OperationType.OVERWRITE;
    }
    operationForChild(childName) {
        if ($e0be213f695400f3$var$pathIsEmpty(this.path)) return new $e0be213f695400f3$var$Overwrite(this.source, $e0be213f695400f3$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new $e0be213f695400f3$var$Overwrite(this.source, $e0be213f695400f3$var$pathPopFront(this.path), this.snap);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$Merge {
    constructor(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children){
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $e0be213f695400f3$var$OperationType.MERGE;
    }
    operationForChild(childName) {
        if ($e0be213f695400f3$var$pathIsEmpty(this.path)) {
            const childTree = this.children.subtree(new $e0be213f695400f3$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $e0be213f695400f3$var$Overwrite(this.source, $e0be213f695400f3$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new $e0be213f695400f3$var$Merge(this.source, $e0be213f695400f3$var$newEmptyPath(), childTree);
        } else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new $e0be213f695400f3$var$Merge(this.source, $e0be213f695400f3$var$pathPopFront(this.path), this.children);
        }
    }
    toString() {
        return 'Operation(' + this.path + ': ' + this.source.toString() + ' merge: ' + this.children.toString() + ')';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ class $e0be213f695400f3$var$CacheNode {
    constructor(node_, fullyInitialized_, filtered_){
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ isFullyInitialized() {
        return this.fullyInitialized_;
    }
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ isFiltered() {
        return this.filtered_;
    }
    isCompleteForPath(path) {
        if ($e0be213f695400f3$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        const childKey = $e0be213f695400f3$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    }
    isCompleteForChild(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    }
    getNode() {
        return this.node_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ class $e0be213f695400f3$var$EventGenerator {
    constructor(query_){
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
}
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $e0be213f695400f3$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    const events = [];
    const moves = [];
    changes.forEach((change)=>{
        if (change.type === "child_changed" /* ChangeType.CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($e0be213f695400f3$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* ChangeType.CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* ChangeType.CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* ChangeType.CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* ChangeType.CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* ChangeType.VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    const filteredChanges = changes.filter((change)=>change.type === eventType);
    filteredChanges.sort((a, b)=>$e0be213f695400f3$var$eventGeneratorCompareChanges(eventGenerator, a, b));
    filteredChanges.forEach((change)=>{
        const materializedChange = $e0be213f695400f3$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach((registration)=>{
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $e0be213f695400f3$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === 'value' || change.type === 'child_removed') return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $e0be213f695400f3$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $474ae12482b554c6$export$a39cad550e7ab28a)('Should only compare child_ events.');
    const aWrapped = new $e0be213f695400f3$var$NamedNode(a.childName, a.snapshotNode);
    const bWrapped = new $e0be213f695400f3$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $e0be213f695400f3$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $e0be213f695400f3$var$newViewCache(new $e0be213f695400f3$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $e0be213f695400f3$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $e0be213f695400f3$var$newViewCache(viewCache.eventCache, new $e0be213f695400f3$var$CacheNode(serverSnap, complete, filtered));
}
function $e0be213f695400f3$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ const $e0be213f695400f3$var$EmptyChildren = ()=>{
    if (!$e0be213f695400f3$var$emptyChildrenSingleton) $e0be213f695400f3$var$emptyChildrenSingleton = new $e0be213f695400f3$var$SortedMap($e0be213f695400f3$var$stringCompare);
    return $e0be213f695400f3$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ class $e0be213f695400f3$var$ImmutableTree {
    constructor(value, children = $e0be213f695400f3$var$EmptyChildren()){
        this.value = value;
        this.children = children;
    }
    static fromObject(obj) {
        let tree = new $e0be213f695400f3$var$ImmutableTree(null);
        $e0be213f695400f3$var$each(obj, (childPath, childSnap)=>{
            tree = tree.set(new $e0be213f695400f3$var$Path(childPath), childSnap);
        });
        return tree;
    }
    /**
     * True if the value is empty and there are no children
     */ isEmpty() {
        return this.value === null && this.children.isEmpty();
    }
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ findRootMostMatchingPathAndValue(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $e0be213f695400f3$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) return null;
            else {
                const front = $e0be213f695400f3$var$pathGetFront(relativePath);
                const child = this.children.get(front);
                if (child !== null) {
                    const childExistingPathAndValue = child.findRootMostMatchingPathAndValue($e0be213f695400f3$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        const fullPath = $e0be213f695400f3$var$pathChild(new $e0be213f695400f3$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    }
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ findRootMostValueAndPath(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, ()=>true);
    }
    /**
     * @returns The subtree at the given path
     */ subtree(relativePath) {
        if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) return this;
        else {
            const front = $e0be213f695400f3$var$pathGetFront(relativePath);
            const childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($e0be213f695400f3$var$pathPopFront(relativePath));
            else return new $e0be213f695400f3$var$ImmutableTree(null);
        }
    }
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ set(relativePath, toSet) {
        if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) return new $e0be213f695400f3$var$ImmutableTree(toSet, this.children);
        else {
            const front = $e0be213f695400f3$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $e0be213f695400f3$var$ImmutableTree(null);
            const newChild = child.set($e0be213f695400f3$var$pathPopFront(relativePath), toSet);
            const newChildren = this.children.insert(front, newChild);
            return new $e0be213f695400f3$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ remove(relativePath) {
        if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new $e0be213f695400f3$var$ImmutableTree(null);
            else return new $e0be213f695400f3$var$ImmutableTree(null, this.children);
        } else {
            const front = $e0be213f695400f3$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) {
                const newChild = child.remove($e0be213f695400f3$var$pathPopFront(relativePath));
                let newChildren;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new $e0be213f695400f3$var$ImmutableTree(null);
                else return new $e0be213f695400f3$var$ImmutableTree(this.value, newChildren);
            } else return this;
        }
    }
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ get(relativePath) {
        if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) return this.value;
        else {
            const front = $e0be213f695400f3$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) return child.get($e0be213f695400f3$var$pathPopFront(relativePath));
            else return null;
        }
    }
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ setTree(relativePath, newTree) {
        if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) return newTree;
        else {
            const front = $e0be213f695400f3$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $e0be213f695400f3$var$ImmutableTree(null);
            const newChild = child.setTree($e0be213f695400f3$var$pathPopFront(relativePath), newTree);
            let newChildren;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new $e0be213f695400f3$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ fold(fn) {
        return this.fold_($e0be213f695400f3$var$newEmptyPath(), fn);
    }
    /**
     * Recursive helper for public-facing fold() method
     */ fold_(pathSoFar, fn) {
        const accum = {};
        this.children.inorderTraversal((childKey, childTree)=>{
            accum[childKey] = childTree.fold_($e0be213f695400f3$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    }
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ findOnPath(path, f) {
        return this.findOnPath_(path, $e0be213f695400f3$var$newEmptyPath(), f);
    }
    findOnPath_(pathToFollow, pathSoFar, f) {
        const result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($e0be213f695400f3$var$pathIsEmpty(pathToFollow)) return null;
            else {
                const front = $e0be213f695400f3$var$pathGetFront(pathToFollow);
                const nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($e0be213f695400f3$var$pathPopFront(pathToFollow), $e0be213f695400f3$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    }
    foreachOnPath(path, f) {
        return this.foreachOnPath_(path, $e0be213f695400f3$var$newEmptyPath(), f);
    }
    foreachOnPath_(pathToFollow, currentRelativePath, f) {
        if ($e0be213f695400f3$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            const front = $e0be213f695400f3$var$pathGetFront(pathToFollow);
            const nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($e0be213f695400f3$var$pathPopFront(pathToFollow), $e0be213f695400f3$var$pathChild(currentRelativePath, front), f);
            else return new $e0be213f695400f3$var$ImmutableTree(null);
        }
    }
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ foreach(f) {
        this.foreach_($e0be213f695400f3$var$newEmptyPath(), f);
    }
    foreach_(currentRelativePath, f) {
        this.children.inorderTraversal((childName, childTree)=>{
            childTree.foreach_($e0be213f695400f3$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    }
    foreachChild(f) {
        this.children.inorderTraversal((childName, childTree)=>{
            if (childTree.value) f(childName, childTree.value);
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ class $e0be213f695400f3$var$CompoundWrite {
    constructor(writeTree_){
        this.writeTree_ = writeTree_;
    }
    static empty() {
        return new $e0be213f695400f3$var$CompoundWrite(new $e0be213f695400f3$var$ImmutableTree(null));
    }
}
function $e0be213f695400f3$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($e0be213f695400f3$var$pathIsEmpty(path)) return new $e0be213f695400f3$var$CompoundWrite(new $e0be213f695400f3$var$ImmutableTree(node));
    else {
        const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            const rootMostPath = rootmost.path;
            let value = rootmost.value;
            const relativePath = $e0be213f695400f3$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $e0be213f695400f3$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            const subtree = new $e0be213f695400f3$var$ImmutableTree(node);
            const newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $e0be213f695400f3$var$CompoundWrite(newWriteTree);
        }
    }
}
function $e0be213f695400f3$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    let newWrite = compoundWrite;
    $e0be213f695400f3$var$each(updates, (childKey, node)=>{
        newWrite = $e0be213f695400f3$var$compoundWriteAddWrite(newWrite, $e0be213f695400f3$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $e0be213f695400f3$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($e0be213f695400f3$var$pathIsEmpty(path)) return $e0be213f695400f3$var$CompoundWrite.empty();
    else {
        const newWriteTree = compoundWrite.writeTree_.setTree(path, new $e0be213f695400f3$var$ImmutableTree(null));
        return new $e0be213f695400f3$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $e0be213f695400f3$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $e0be213f695400f3$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $e0be213f695400f3$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($e0be213f695400f3$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $e0be213f695400f3$var$compoundWriteGetCompleteChildren(compoundWrite) {
    const children = [];
    const node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (childName, childNode)=>{
            children.push(new $e0be213f695400f3$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal((childName, childTree)=>{
        if (childTree.value != null) children.push(new $e0be213f695400f3$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $e0be213f695400f3$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($e0be213f695400f3$var$pathIsEmpty(path)) return compoundWrite;
    else {
        const shadowingNode = $e0be213f695400f3$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $e0be213f695400f3$var$CompoundWrite(new $e0be213f695400f3$var$ImmutableTree(shadowingNode));
        else return new $e0be213f695400f3$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $e0be213f695400f3$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $e0be213f695400f3$var$compoundWriteApply(compoundWrite, node) {
    return $e0be213f695400f3$var$applySubtreeWrite($e0be213f695400f3$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $e0be213f695400f3$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        let priorityWrite = null;
        writeTree.children.inorderTraversal((childKey, childTree)=>{
            if (childKey === '.priority') {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $474ae12482b554c6$export$a7a9523472993e97)(childTree.value !== null, 'Priority writes must always be leaf nodes');
                priorityWrite = childTree.value;
            } else node = $e0be213f695400f3$var$applySubtreeWrite($e0be213f695400f3$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite !== null) node = node.updateChild($e0be213f695400f3$var$pathChild(relativePath, '.priority'), priorityWrite);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $e0be213f695400f3$var$writeTreeChildWrites(writeTree, path) {
    return $e0be213f695400f3$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $e0be213f695400f3$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older write on top of newer ones');
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $e0be213f695400f3$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $e0be213f695400f3$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older merge on top of newer ones');
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $e0be213f695400f3$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $e0be213f695400f3$var$writeTreeGetWrite(writeTree, writeId) {
    for(let i = 0; i < writeTree.allWrites.length; i++){
        const record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $e0be213f695400f3$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    const idx = writeTree.allWrites.findIndex((s)=>{
        return s.writeId === writeId;
    });
    (0, $474ae12482b554c6$export$a7a9523472993e97)(idx >= 0, 'removeWrite called with nonexistent writeId.');
    const writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    let removedWriteWasVisible = writeToRemove.visible;
    let removedWriteOverlapsWithOtherWrites = false;
    let i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        const currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $e0be213f695400f3$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($e0be213f695400f3$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $e0be213f695400f3$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $e0be213f695400f3$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            const children = writeToRemove.children;
            $e0be213f695400f3$var$each(children, (childName)=>{
                writeTree.visibleWrites = $e0be213f695400f3$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $e0be213f695400f3$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $e0be213f695400f3$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $e0be213f695400f3$var$pathContains(writeRecord.path, path);
    else {
        for(const childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $e0be213f695400f3$var$pathContains($e0be213f695400f3$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $e0be213f695400f3$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $e0be213f695400f3$var$writeTreeLayerTree_(writeTree.allWrites, $e0be213f695400f3$var$writeTreeDefaultFilter_, $e0be213f695400f3$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $e0be213f695400f3$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $e0be213f695400f3$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    let compoundWrite = $e0be213f695400f3$var$CompoundWrite.empty();
    for(let i = 0; i < writes.length; ++i){
        const write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            const writePath = write.path;
            let relativePath;
            if (write.snap) {
                if ($e0be213f695400f3$var$pathContains(treeRoot, writePath)) {
                    relativePath = $e0be213f695400f3$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $e0be213f695400f3$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($e0be213f695400f3$var$pathContains(writePath, treeRoot)) {
                    relativePath = $e0be213f695400f3$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $e0be213f695400f3$var$compoundWriteAddWrite(compoundWrite, $e0be213f695400f3$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($e0be213f695400f3$var$pathContains(treeRoot, writePath)) {
                    relativePath = $e0be213f695400f3$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $e0be213f695400f3$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($e0be213f695400f3$var$pathContains(writePath, treeRoot)) {
                    relativePath = $e0be213f695400f3$var$newRelativePath(writePath, treeRoot);
                    if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) compoundWrite = $e0be213f695400f3$var$compoundWriteAddWrites(compoundWrite, $e0be213f695400f3$var$newEmptyPath(), write.children);
                    else {
                        const child = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(write.children, $e0be213f695400f3$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            const deepNode = child.getChild($e0be213f695400f3$var$pathPopFront(relativePath));
                            compoundWrite = $e0be213f695400f3$var$compoundWriteAddWrite(compoundWrite, $e0be213f695400f3$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $474ae12482b554c6$export$a39cad550e7ab28a)('WriteRecord should have .snap or .children');
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $e0be213f695400f3$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        const shadowingNode = $e0be213f695400f3$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            const subMerge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($e0be213f695400f3$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$e0be213f695400f3$var$compoundWriteHasCompleteWrite(subMerge, $e0be213f695400f3$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                const layeredCache = completeServerCache || $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
                return $e0be213f695400f3$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        const merge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $e0be213f695400f3$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$e0be213f695400f3$var$compoundWriteHasCompleteWrite(merge, $e0be213f695400f3$var$newEmptyPath())) return null;
            else {
                const filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($e0be213f695400f3$var$pathContains(write.path, treePath) || $e0be213f695400f3$var$pathContains(treePath, write.path));
                };
                const mergeAtPath = $e0be213f695400f3$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                const layeredCache = completeServerCache || $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
                return $e0be213f695400f3$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $e0be213f695400f3$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    let completeChildren = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
    const topLevelSet = $e0be213f695400f3$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (childName, childSnap)=>{
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        const merge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (childName, childNode)=>{
            const node = $e0be213f695400f3$var$compoundWriteApply($e0be213f695400f3$var$compoundWriteChildCompoundWrite(merge, new $e0be213f695400f3$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $e0be213f695400f3$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        const merge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $e0be213f695400f3$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $e0be213f695400f3$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
    const path = $e0be213f695400f3$var$pathChild(treePath, childPath);
    if ($e0be213f695400f3$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        const childMerge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($e0be213f695400f3$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $e0be213f695400f3$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $e0be213f695400f3$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    const path = $e0be213f695400f3$var$pathChild(treePath, childKey);
    const shadowingNode = $e0be213f695400f3$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            const childMerge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $e0be213f695400f3$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $e0be213f695400f3$var$writeTreeShadowingWrite(writeTree, path) {
    return $e0be213f695400f3$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $e0be213f695400f3$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    let toIterate;
    const merge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    const shadowingNode = $e0be213f695400f3$var$compoundWriteGetCompleteNode(merge, $e0be213f695400f3$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $e0be213f695400f3$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        const nodes = [];
        const cmp = index.getCompare();
        const iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        let next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $e0be213f695400f3$var$newWriteTree() {
    return {
        visibleWrites: $e0be213f695400f3$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $e0be213f695400f3$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $e0be213f695400f3$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $e0be213f695400f3$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $e0be213f695400f3$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $e0be213f695400f3$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $e0be213f695400f3$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $e0be213f695400f3$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $e0be213f695400f3$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $e0be213f695400f3$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $e0be213f695400f3$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $e0be213f695400f3$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $e0be213f695400f3$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $e0be213f695400f3$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $e0be213f695400f3$var$writeTreeRefChild(writeTreeRef, childName) {
    return $e0be213f695400f3$var$newWriteTreeRef($e0be213f695400f3$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $e0be213f695400f3$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$ChildChangeAccumulator {
    constructor(){
        this.changeMap = new Map();
    }
    trackChildChange(change) {
        const type = change.type;
        const childKey = change.childName;
        (0, $474ae12482b554c6$export$a7a9523472993e97)(type === "child_added" /* ChangeType.CHILD_ADDED */  || type === "child_changed" /* ChangeType.CHILD_CHANGED */  || type === "child_removed" /* ChangeType.CHILD_REMOVED */ , 'Only child changes supported for tracking');
        (0, $474ae12482b554c6$export$a7a9523472993e97)(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        const oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            const oldType = oldChange.type;
            if (type === "child_added" /* ChangeType.CHILD_ADDED */  && oldType === "child_removed" /* ChangeType.CHILD_REMOVED */ ) this.changeMap.set(childKey, $e0be213f695400f3$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $e0be213f695400f3$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.set(childKey, $e0be213f695400f3$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $e0be213f695400f3$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $474ae12482b554c6$export$a39cad550e7ab28a)('Illegal combination of changes: ' + change + ' occurred after ' + oldChange);
        } else this.changeMap.set(childKey, change);
    }
    getChanges() {
        return Array.from(this.changeMap.values());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $e0be213f695400f3$var$NoCompleteChildSource_ {
    getCompleteChild(childKey) {
        return null;
    }
    getChildAfterChild(index, child, reverse) {
        return null;
    }
}
/**
 * Singleton instance.
 */ const $e0be213f695400f3$var$NO_COMPLETE_CHILD_SOURCE = new $e0be213f695400f3$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ class $e0be213f695400f3$var$WriteTreeCompleteChildSource {
    constructor(writes_, viewCache_, optCompleteServerCache_ = null){
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    getCompleteChild(childKey) {
        const node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            const serverNode = this.optCompleteServerCache_ != null ? new $e0be213f695400f3$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $e0be213f695400f3$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    }
    getChildAfterChild(index, child, reverse) {
        const completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        const nodes = $e0be213f695400f3$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $e0be213f695400f3$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Event snap not indexed');
    (0, $474ae12482b554c6$export$a7a9523472993e97)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Server snap not indexed');
}
function $e0be213f695400f3$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    const accumulator = new $e0be213f695400f3$var$ChildChangeAccumulator();
    let newViewCache, filterServerNode;
    if (operation.type === $e0be213f695400f3$var$OperationType.OVERWRITE) {
        const overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $e0be213f695400f3$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(overwrite.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$e0be213f695400f3$var$pathIsEmpty(overwrite.path);
            newViewCache = $e0be213f695400f3$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $e0be213f695400f3$var$OperationType.MERGE) {
        const merge = operation;
        if (merge.source.fromUser) newViewCache = $e0be213f695400f3$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(merge.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $e0be213f695400f3$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $e0be213f695400f3$var$OperationType.ACK_USER_WRITE) {
        const ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $e0be213f695400f3$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $e0be213f695400f3$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $e0be213f695400f3$var$OperationType.LISTEN_COMPLETE) newViewCache = $e0be213f695400f3$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $474ae12482b554c6$export$a39cad550e7ab28a)('Unknown operation type: ' + operation.type);
    const changes = accumulator.getChanges();
    $e0be213f695400f3$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $e0be213f695400f3$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    const eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        const isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        const oldCompleteSnap = $e0be213f695400f3$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($e0be213f695400f3$var$changeValue($e0be213f695400f3$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $e0be213f695400f3$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    const oldEventSnap = viewCache.eventCache;
    if ($e0be213f695400f3$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        let newEventCache, serverNode;
        if ($e0be213f695400f3$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $474ae12482b554c6$export$a7a9523472993e97)(viewCache.serverCache.isFullyInitialized(), 'If change path is empty, we must have complete server data');
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                const serverCache = $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(viewCache);
                const completeChildren = serverCache instanceof $e0be213f695400f3$var$ChildrenNode ? serverCache : $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
                const completeEventChildren = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                const completeNode = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventCache(writesCache, $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            const childKey = $e0be213f695400f3$var$pathGetFront(changePath);
            if (childKey === '.priority') {
                (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                const oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                const updatedPriority = $e0be213f695400f3$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                const childChangePath = $e0be213f695400f3$var$pathPopFront(changePath);
                // update child
                let newEventChild;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    const eventChildUpdate = $e0be213f695400f3$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $e0be213f695400f3$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $e0be213f695400f3$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $e0be213f695400f3$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $e0be213f695400f3$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    const oldServerSnap = oldViewCache.serverCache;
    let newServerCache;
    const serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($e0be213f695400f3$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        const newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        const childKey = $e0be213f695400f3$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $e0be213f695400f3$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        const childChangePath = $e0be213f695400f3$var$pathPopFront(changePath);
        const childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        const newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === '.priority') newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $e0be213f695400f3$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    const newViewCache = $e0be213f695400f3$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $e0be213f695400f3$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    const source = new $e0be213f695400f3$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $e0be213f695400f3$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $e0be213f695400f3$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    const oldEventSnap = oldViewCache.eventCache;
    let newViewCache, newEventCache;
    const source = new $e0be213f695400f3$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($e0be213f695400f3$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $e0be213f695400f3$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        const childKey = $e0be213f695400f3$var$pathGetFront(changePath);
        if (childKey === '.priority') {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $e0be213f695400f3$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            const childChangePath = $e0be213f695400f3$var$pathPopFront(changePath);
            const oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            let newChild;
            if ($e0be213f695400f3$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                const childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($e0be213f695400f3$var$pathGetBack(childChangePath) === '.priority' && childNode.getChild($e0be213f695400f3$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                const newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $e0be213f695400f3$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $e0be213f695400f3$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $e0be213f695400f3$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $e0be213f695400f3$var$pathChild(path, relativePath);
        if ($e0be213f695400f3$var$viewProcessorCacheHasChild(viewCache, $e0be213f695400f3$var$pathGetFront(writePath))) curViewCache = $e0be213f695400f3$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $e0be213f695400f3$var$pathChild(path, relativePath);
        if (!$e0be213f695400f3$var$viewProcessorCacheHasChild(viewCache, $e0be213f695400f3$var$pathGetFront(writePath))) curViewCache = $e0be213f695400f3$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $e0be213f695400f3$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach((relativePath, childNode)=>{
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $e0be213f695400f3$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    let viewMergeTree;
    if ($e0be213f695400f3$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $e0be213f695400f3$var$ImmutableTree(null).setTree(path, changedChildren);
    const serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal((childKey, childTree)=>{
        if (serverNode.hasChild(childKey)) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $e0be213f695400f3$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $e0be213f695400f3$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $e0be213f695400f3$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal((childKey, childMergeTree)=>{
        const isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === null;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $e0be213f695400f3$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $e0be213f695400f3$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $e0be213f695400f3$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $e0be213f695400f3$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($e0be213f695400f3$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    const filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    const serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($e0be213f695400f3$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $e0be213f695400f3$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($e0be213f695400f3$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            let changedChildren = new $e0be213f695400f3$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($e0be213f695400f3$var$KEY_INDEX, (name, node)=>{
                changedChildren = changedChildren.set(new $e0be213f695400f3$var$Path(name), node);
            });
            return $e0be213f695400f3$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        let changedChildren = new $e0be213f695400f3$var$ImmutableTree(null);
        affectedTree.foreach((mergePath, value)=>{
            const serverCachePath = $e0be213f695400f3$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren = changedChildren.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $e0be213f695400f3$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $e0be213f695400f3$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    const oldServerNode = viewCache.serverCache;
    const newViewCache = $e0be213f695400f3$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $e0be213f695400f3$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $e0be213f695400f3$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $e0be213f695400f3$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $e0be213f695400f3$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    let complete;
    if ($e0be213f695400f3$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        const source = new $e0be213f695400f3$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        const oldEventCache = viewCache.eventCache.getNode();
        let newEventCache;
        if ($e0be213f695400f3$var$pathIsEmpty(path) || $e0be213f695400f3$var$pathGetFront(path) === '.priority') {
            let newNode;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventCache(writesCache, $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                const serverChildren = viewCache.serverCache.getNode();
                (0, $474ae12482b554c6$export$a7a9523472993e97)(serverChildren instanceof $e0be213f695400f3$var$ChildrenNode, 'serverChildren would be complete if leaf node');
                newNode = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            const childKey = $e0be213f695400f3$var$pathGetFront(path);
            let newChild = $e0be213f695400f3$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $e0be213f695400f3$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE, $e0be213f695400f3$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventCache(writesCache, $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $e0be213f695400f3$var$writeTreeRefShadowingWrite(writesCache, $e0be213f695400f3$var$newEmptyPath()) != null;
        return $e0be213f695400f3$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ class $e0be213f695400f3$var$View {
    constructor(query_, initialViewCache){
        this.query_ = query_;
        this.eventRegistrations_ = [];
        const params = this.query_._queryParams;
        const indexFilter = new $e0be213f695400f3$var$IndexedFilter(params.getIndex());
        const filter = $e0be213f695400f3$var$queryParamsGetNodeFilter(params);
        this.processor_ = $e0be213f695400f3$var$newViewProcessor(filter);
        const initialServerCache = initialViewCache.serverCache;
        const initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        const serverSnap = indexFilter.updateFullNode($e0be213f695400f3$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        const eventSnap = filter.updateFullNode($e0be213f695400f3$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        const newServerCache = new $e0be213f695400f3$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        const newEventCache = new $e0be213f695400f3$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $e0be213f695400f3$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $e0be213f695400f3$var$EventGenerator(this.query_);
    }
    get query() {
        return this.query_;
    }
}
function $e0be213f695400f3$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $e0be213f695400f3$var$viewGetCompleteNode(view) {
    return $e0be213f695400f3$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $e0be213f695400f3$var$viewGetCompleteServerCache(view, path) {
    const cache = $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$e0be213f695400f3$var$pathIsEmpty(path) && !cache.getImmediateChild($e0be213f695400f3$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $e0be213f695400f3$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $e0be213f695400f3$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $e0be213f695400f3$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    const cancelEvents = [];
    if (cancelError) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(eventRegistration == null, 'A cancel should cancel all event registrations.');
        const path = view.query._path;
        view.eventRegistrations_.forEach((registration)=>{
            const maybeEvent = registration.createCancelEvent(cancelError, path);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        let remaining = [];
        for(let i = 0; i < view.eventRegistrations_.length; ++i){
            const existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $e0be213f695400f3$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $e0be213f695400f3$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$viewCacheGetCompleteServerSnap(view.viewCache_), 'We should always have a full cache before handling merges');
        (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$viewCacheGetCompleteEventSnap(view.viewCache_), 'Missing event cache, even though we have a server cache');
    }
    const oldViewCache = view.viewCache_;
    const result = $e0be213f695400f3$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $e0be213f695400f3$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $474ae12482b554c6$export$a7a9523472993e97)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), 'Once a server snap is complete, it should never go back');
    view.viewCache_ = result.viewCache;
    return $e0be213f695400f3$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $e0be213f695400f3$var$viewGetInitialEvents(view, registration) {
    const eventSnap = view.viewCache_.eventCache;
    const initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        const eventNode = eventSnap.getNode();
        eventNode.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
            initialChanges.push($e0be213f695400f3$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($e0be213f695400f3$var$changeValue(eventSnap.getNode()));
    return $e0be213f695400f3$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $e0be213f695400f3$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    const registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $e0be213f695400f3$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ class $e0be213f695400f3$var$SyncPoint {
    constructor(){
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
}
function $e0be213f695400f3$var$syncPointSetReferenceConstructor(val) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(!$e0be213f695400f3$var$referenceConstructor$1, '__referenceConstructor has already been defined');
    $e0be213f695400f3$var$referenceConstructor$1 = val;
}
function $e0be213f695400f3$var$syncPointGetReferenceConstructor() {
    (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$referenceConstructor$1, 'Reference.ts has not been loaded');
    return $e0be213f695400f3$var$referenceConstructor$1;
}
function $e0be213f695400f3$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $e0be213f695400f3$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    const queryId = operation.source.queryId;
    if (queryId !== null) {
        const view = syncPoint.views.get(queryId);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(view != null, 'SyncTree gave us an op for an invalid query.');
        return $e0be213f695400f3$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        let events = [];
        for (const view of syncPoint.views.values())events = events.concat($e0be213f695400f3$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    const queryId = query._queryIdentifier;
    const view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        let eventCache = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        let eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $e0be213f695400f3$var$ChildrenNode) {
            eventCache = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        const viewCache = $e0be213f695400f3$var$newViewCache(new $e0be213f695400f3$var$CacheNode(eventCache, eventCacheComplete, false), new $e0be213f695400f3$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $e0be213f695400f3$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    const view = $e0be213f695400f3$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $e0be213f695400f3$var$viewAddEventRegistration(view, eventRegistration);
    return $e0be213f695400f3$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $e0be213f695400f3$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    const queryId = query._queryIdentifier;
    const removed = [];
    let cancelEvents = [];
    const hadCompleteView = $e0be213f695400f3$var$syncPointHasCompleteView(syncPoint);
    if (queryId === 'default') // When you do ref.off(...), we search all views for the registration to remove.
    for (const [viewQueryId, view] of syncPoint.views.entries()){
        cancelEvents = cancelEvents.concat($e0be213f695400f3$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
        if ($e0be213f695400f3$var$viewIsEmpty(view)) {
            syncPoint.views.delete(viewQueryId);
            // We'll deal with complete views later.
            if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
        }
    }
    else {
        // remove the callback from the specific view.
        const view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($e0be213f695400f3$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($e0be213f695400f3$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$e0be213f695400f3$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($e0be213f695400f3$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $e0be213f695400f3$var$syncPointGetQueryViews(syncPoint) {
    const result = [];
    for (const view of syncPoint.views.values())if (!view.query._queryParams.loadsAllData()) result.push(view);
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, path) {
    let serverCache = null;
    for (const view of syncPoint.views.values())serverCache = serverCache || $e0be213f695400f3$var$viewGetCompleteServerCache(view, path);
    return serverCache;
}
function $e0be213f695400f3$var$syncPointViewForQuery(syncPoint, query) {
    const params = query._queryParams;
    if (params.loadsAllData()) return $e0be213f695400f3$var$syncPointGetCompleteView(syncPoint);
    else {
        const queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $e0be213f695400f3$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $e0be213f695400f3$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $e0be213f695400f3$var$syncPointHasCompleteView(syncPoint) {
    return $e0be213f695400f3$var$syncPointGetCompleteView(syncPoint) != null;
}
function $e0be213f695400f3$var$syncPointGetCompleteView(syncPoint) {
    for (const view of syncPoint.views.values()){
        if (view.query._queryParams.loadsAllData()) return view;
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$referenceConstructor;
function $e0be213f695400f3$var$syncTreeSetReferenceConstructor(val) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(!$e0be213f695400f3$var$referenceConstructor, '__referenceConstructor has already been defined');
    $e0be213f695400f3$var$referenceConstructor = val;
}
function $e0be213f695400f3$var$syncTreeGetReferenceConstructor() {
    (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$referenceConstructor, 'Reference.ts has not been loaded');
    return $e0be213f695400f3$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ let $e0be213f695400f3$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ class $e0be213f695400f3$var$SyncTree {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ constructor(listenProvider_){
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $e0be213f695400f3$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $e0be213f695400f3$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
}
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $e0be213f695400f3$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$Overwrite($e0be213f695400f3$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $e0be213f695400f3$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    const changeTree = $e0be213f695400f3$var$ImmutableTree.fromObject(changedChildren);
    return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$Merge($e0be213f695400f3$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeAckUserWrite(syncTree, writeId, revert = false) {
    const write = $e0be213f695400f3$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    const needToReevaluate = $e0be213f695400f3$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        let affectedTree = new $e0be213f695400f3$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree = affectedTree.set($e0be213f695400f3$var$newEmptyPath(), true);
        else $e0be213f695400f3$var$each(write.children, (pathString)=>{
            affectedTree = affectedTree.set(new $e0be213f695400f3$var$Path(pathString), true);
        });
        return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$AckUserWrite(write.path, affectedTree, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$Overwrite($e0be213f695400f3$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    const changeTree = $e0be213f695400f3$var$ImmutableTree.fromObject(changedChildren);
    return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$Merge($e0be213f695400f3$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyListenComplete(syncTree, path) {
    return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$ListenComplete($e0be213f695400f3$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    const queryKey = $e0be213f695400f3$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $e0be213f695400f3$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $e0be213f695400f3$var$newRelativePath(queryPath, path);
        const op = new $e0be213f695400f3$var$ListenComplete($e0be213f695400f3$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $e0be213f695400f3$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @param skipListenerDedup - When performing a `get()`, we don't add any new listeners, so no
 *  deduping needs to take place. This flag allows toggling of that behavior
 * @returns Cancel events, if cancelError was provided.
 */ function $e0be213f695400f3$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError, skipListenerDedup = false) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    const path = query._path;
    const maybeSyncPoint = syncTree.syncPointTree_.get(path);
    let cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === 'default' || $e0be213f695400f3$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        const removedAndEvents = $e0be213f695400f3$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($e0be213f695400f3$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        const removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        if (!skipListenerDedup) {
            /**
             * We may have just removed one of many listeners and can short-circuit this whole process
             * We may also not have removed a default listener, in which case all of the descendant listeners should already be
             * properly set up.
             */ // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            const removingDefault = -1 !== removed.findIndex((query)=>{
                return query._queryParams.loadsAllData();
            });
            const covered = syncTree.syncPointTree_.findOnPath(path, (relativePath, parentSyncPoint)=>$e0be213f695400f3$var$syncPointHasCompleteView(parentSyncPoint));
            if (removingDefault && !covered) {
                const subtree = syncTree.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    const newViews = $e0be213f695400f3$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for(let i = 0; i < newViews.length; ++i){
                        const view = newViews[i], newQuery = view.query;
                        const listener = $e0be213f695400f3$var$syncTreeCreateListenerForView_(syncTree, view);
                        syncTree.listenProvider_.startListening($e0be213f695400f3$var$syncTreeQueryForListening_(newQuery), $e0be213f695400f3$var$syncTreeTagForQuery(syncTree, newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            // Otherwise there's nothing below us, so nothing we need to start listening on
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    const defaultTag = null;
                    syncTree.listenProvider_.stopListening($e0be213f695400f3$var$syncTreeQueryForListening_(query), defaultTag);
                } else removed.forEach((queryToRemove)=>{
                    const tagToRemove = syncTree.queryToTagMap.get($e0be213f695400f3$var$syncTreeMakeQueryKey_(queryToRemove));
                    syncTree.listenProvider_.stopListening($e0be213f695400f3$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
                });
            }
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $e0be213f695400f3$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    const queryKey = $e0be213f695400f3$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        const r = $e0be213f695400f3$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $e0be213f695400f3$var$newRelativePath(queryPath, path);
        const op = new $e0be213f695400f3$var$Overwrite($e0be213f695400f3$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $e0be213f695400f3$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    const queryKey = $e0be213f695400f3$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $e0be213f695400f3$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $e0be213f695400f3$var$newRelativePath(queryPath, path);
        const changeTree = $e0be213f695400f3$var$ImmutableTree.fromObject(changedChildren);
        const op = new $e0be213f695400f3$var$Merge($e0be213f695400f3$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $e0be213f695400f3$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration, skipSetupListener = false) {
    const path = query._path;
    let serverCache = null;
    let foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $e0be213f695400f3$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $e0be213f695400f3$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $e0be213f695400f3$var$syncPointHasCompleteView(sp);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $e0be213f695400f3$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $e0be213f695400f3$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, $e0be213f695400f3$var$newEmptyPath());
    }
    let serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        const subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild((childName, childSyncPoint)=>{
            const completeCache = $e0be213f695400f3$var$syncPointGetCompleteServerCache(childSyncPoint, $e0be213f695400f3$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    const viewAlreadyExists = $e0be213f695400f3$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        const queryKey = $e0be213f695400f3$var$syncTreeMakeQueryKey_(query);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(!syncTree.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
        const tag = $e0be213f695400f3$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    const writesCache = $e0be213f695400f3$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    let events = $e0be213f695400f3$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView && !skipSetupListener) {
        const view = $e0be213f695400f3$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($e0be213f695400f3$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $e0be213f695400f3$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    const includeHiddenSets = true;
    const writeTree = syncTree.pendingWriteTree_;
    const serverCache = syncTree.syncPointTree_.findOnPath(path, (pathSoFar, syncPoint)=>{
        const relativePath = $e0be213f695400f3$var$newRelativePath(pathSoFar, path);
        const serverCache = $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $e0be213f695400f3$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $e0be213f695400f3$var$syncTreeGetServerValue(syncTree, query) {
    const path = query._path;
    let serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $e0be213f695400f3$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $e0be213f695400f3$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $e0be213f695400f3$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, $e0be213f695400f3$var$newEmptyPath());
    const serverCacheComplete = serverCache != null;
    const serverCacheNode = serverCacheComplete ? new $e0be213f695400f3$var$CacheNode(serverCache, true, false) : null;
    const writesCache = $e0be213f695400f3$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    const view = $e0be213f695400f3$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $e0be213f695400f3$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $e0be213f695400f3$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $e0be213f695400f3$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $e0be213f695400f3$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $e0be213f695400f3$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($e0be213f695400f3$var$pathIsEmpty(operation.path)) return $e0be213f695400f3$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        const syncPoint = syncPointTree.get($e0be213f695400f3$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, $e0be213f695400f3$var$newEmptyPath());
        let events = [];
        const childName = $e0be213f695400f3$var$pathGetFront(operation.path);
        const childOperation = operation.operationForChild(childName);
        const childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            const childWritesCache = $e0be213f695400f3$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($e0be213f695400f3$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($e0be213f695400f3$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $e0be213f695400f3$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    const syncPoint = syncPointTree.get($e0be213f695400f3$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, $e0be213f695400f3$var$newEmptyPath());
    let events = [];
    syncPointTree.children.inorderTraversal((childName, childTree)=>{
        const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        const childWritesCache = $e0be213f695400f3$var$writeTreeRefChild(writesCache, childName);
        const childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($e0be213f695400f3$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($e0be213f695400f3$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $e0be213f695400f3$var$syncTreeCreateListenerForView_(syncTree, view) {
    const query = view.query;
    const tag = $e0be213f695400f3$var$syncTreeTagForQuery(syncTree, query);
    return {
        hashFn: ()=>{
            const cache = $e0be213f695400f3$var$viewGetServerCache(view) || $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: (status)=>{
            if (status === 'ok') {
                if (tag) return $e0be213f695400f3$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $e0be213f695400f3$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                const error = $e0be213f695400f3$var$errorForServerCode(status, query);
                return $e0be213f695400f3$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $e0be213f695400f3$var$syncTreeTagForQuery(syncTree, query) {
    const queryKey = $e0be213f695400f3$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $e0be213f695400f3$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + '$' + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $e0be213f695400f3$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $e0be213f695400f3$var$syncTreeParseQueryKey_(queryKey) {
    const splitIndex = queryKey.indexOf('$');
    (0, $474ae12482b554c6$export$a7a9523472993e97)(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $e0be213f695400f3$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $e0be213f695400f3$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    const syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $474ae12482b554c6$export$a7a9523472993e97)(syncPoint, "Missing sync point for query tag that we're tracking");
    const writesCache = $e0be213f695400f3$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $e0be213f695400f3$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $e0be213f695400f3$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
        if (maybeChildSyncPoint && $e0be213f695400f3$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            const completeView = $e0be213f695400f3$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            let views = [];
            if (maybeChildSyncPoint) views = $e0be213f695400f3$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $e0be213f695400f3$var$each(childMap, (_key, childViews)=>{
                views = views.concat(childViews);
            });
            return views;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $e0be213f695400f3$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($e0be213f695400f3$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $e0be213f695400f3$var$syncTreeRemoveTags_(syncTree, queries) {
    for(let j = 0; j < queries.length; ++j){
        const removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            const removedQueryKey = $e0be213f695400f3$var$syncTreeMakeQueryKey_(removedQuery);
            const removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $e0be213f695400f3$var$syncTreeGetNextQueryTag_() {
    return $e0be213f695400f3$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $e0be213f695400f3$var$syncTreeSetupListener_(syncTree, query, view) {
    const path = query._path;
    const tag = $e0be213f695400f3$var$syncTreeTagForQuery(syncTree, query);
    const listener = $e0be213f695400f3$var$syncTreeCreateListenerForView_(syncTree, view);
    const events = syncTree.listenProvider_.startListening($e0be213f695400f3$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    const subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $474ae12482b554c6$export$a7a9523472993e97)(!$e0be213f695400f3$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        const queriesToStop = subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
            if (!$e0be213f695400f3$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $e0be213f695400f3$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $e0be213f695400f3$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                let queries = [];
                if (maybeChildSyncPoint) queries = queries.concat($e0be213f695400f3$var$syncPointGetQueryViews(maybeChildSyncPoint).map((view)=>view.query));
                $e0be213f695400f3$var$each(childMap, (_key, childQueries)=>{
                    queries = queries.concat(childQueries);
                });
                return queries;
            }
        });
        for(let i = 0; i < queriesToStop.length; ++i){
            const queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($e0be213f695400f3$var$syncTreeQueryForListening_(queryToStop), $e0be213f695400f3$var$syncTreeTagForQuery(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$ExistingValueProvider {
    constructor(node_){
        this.node_ = node_;
    }
    getImmediateChild(childName) {
        const child = this.node_.getImmediateChild(childName);
        return new $e0be213f695400f3$var$ExistingValueProvider(child);
    }
    node() {
        return this.node_;
    }
}
class $e0be213f695400f3$var$DeferredValueProvider {
    constructor(syncTree, path){
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    getImmediateChild(childName) {
        const childPath = $e0be213f695400f3$var$pathChild(this.path_, childName);
        return new $e0be213f695400f3$var$DeferredValueProvider(this.syncTree_, childPath);
    }
    node() {
        return $e0be213f695400f3$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    }
}
/**
 * Generate placeholders for deferred values.
 */ const $e0be213f695400f3$var$generateWithValues = function(values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ const $e0be213f695400f3$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== 'object') return value;
    (0, $474ae12482b554c6$export$a7a9523472993e97)('.sv' in value, 'Unexpected leaf node or priority contents');
    if (typeof value['.sv'] === 'string') return $e0be213f695400f3$var$resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
    else if (typeof value['.sv'] === 'object') return $e0be213f695400f3$var$resolveComplexDeferredValue(value['.sv'], existingVal);
    else (0, $474ae12482b554c6$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
};
const $e0be213f695400f3$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case 'timestamp':
            return serverValues['timestamp'];
        default:
            (0, $474ae12482b554c6$export$a7a9523472993e97)(false, 'Unexpected server value: ' + op);
    }
};
const $e0be213f695400f3$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty('increment')) (0, $474ae12482b554c6$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
    const delta = op['increment'];
    if (typeof delta !== 'number') (0, $474ae12482b554c6$export$a7a9523472993e97)(false, 'Unexpected increment value: ' + delta);
    const existingNode = existing.node();
    (0, $474ae12482b554c6$export$a7a9523472993e97)(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    const leaf = existingNode;
    const existingVal = leaf.getValue();
    if (typeof existingVal !== 'number') return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ const $e0be213f695400f3$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $e0be213f695400f3$var$resolveDeferredValue(node, new $e0be213f695400f3$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ const $e0be213f695400f3$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $e0be213f695400f3$var$resolveDeferredValue(node, new $e0be213f695400f3$var$ExistingValueProvider(existing), serverValues);
};
function $e0be213f695400f3$var$resolveDeferredValue(node, existingVal, serverValues) {
    const rawPri = node.getPriority().val();
    const priority = $e0be213f695400f3$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
    let newNode;
    if (node.isLeafNode()) {
        const leafNode = node;
        const value = $e0be213f695400f3$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $e0be213f695400f3$var$LeafNode(value, $e0be213f695400f3$var$nodeFromJSON(priority));
        else return node;
    } else {
        const childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $e0be213f695400f3$var$LeafNode(priority));
        childrenNode.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (childName, childNode)=>{
            const newChildNode = $e0be213f695400f3$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ class $e0be213f695400f3$var$Tree {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ constructor(name = '', parent = null, node = {
        children: {},
        childCount: 0
    }){
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
}
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $e0be213f695400f3$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    let path = pathObj instanceof $e0be213f695400f3$var$Path ? pathObj : new $e0be213f695400f3$var$Path(pathObj);
    let child = tree, next = $e0be213f695400f3$var$pathGetFront(path);
    while(next !== null){
        const childNode = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $e0be213f695400f3$var$Tree(next, child, childNode);
        path = $e0be213f695400f3$var$pathPopFront(path);
        next = $e0be213f695400f3$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $e0be213f695400f3$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $e0be213f695400f3$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $e0be213f695400f3$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $e0be213f695400f3$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whether the tree is empty (no value or children).
 */ function $e0be213f695400f3$var$treeIsEmpty(tree) {
    return $e0be213f695400f3$var$treeGetValue(tree) === undefined && !$e0be213f695400f3$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $e0be213f695400f3$var$treeForEachChild(tree, action) {
    $e0be213f695400f3$var$each(tree.node.children, (child, childTree)=>{
        action(new $e0be213f695400f3$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $e0be213f695400f3$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $e0be213f695400f3$var$treeForEachChild(tree, (child)=>{
        $e0be213f695400f3$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $e0be213f695400f3$var$treeForEachAncestor(tree, action, includeSelf) {
    let node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $e0be213f695400f3$var$treeGetPath(tree) {
    return new $e0be213f695400f3$var$Path(tree.parent === null ? tree.name : $e0be213f695400f3$var$treeGetPath(tree.parent) + '/' + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $e0be213f695400f3$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $e0be213f695400f3$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $e0be213f695400f3$var$treeUpdateChild(tree, childName, child) {
    const childEmpty = $e0be213f695400f3$var$treeIsEmpty(child);
    const childExists = (0, $474ae12482b554c6$export$2344b14b097df817)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $e0be213f695400f3$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $e0be213f695400f3$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ const $e0be213f695400f3$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ const $e0be213f695400f3$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ const $e0be213f695400f3$var$MAX_LEAF_SIZE_ = 10485760;
const $e0be213f695400f3$var$isValidKey = function(key) {
    return typeof key === 'string' && key.length !== 0 && !$e0be213f695400f3$var$INVALID_KEY_REGEX_.test(key);
};
const $e0be213f695400f3$var$isValidPathString = function(pathString) {
    return typeof pathString === 'string' && pathString.length !== 0 && !$e0be213f695400f3$var$INVALID_PATH_REGEX_.test(pathString);
};
const $e0be213f695400f3$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    return $e0be213f695400f3$var$isValidPathString(pathString);
};
const $e0be213f695400f3$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === 'string' || typeof priority === 'number' && !$e0be213f695400f3$var$isInvalidJSONNumber(priority) || priority && typeof priority === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $474ae12482b554c6$export$2344b14b097df817)(priority, '.sv');
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ const $e0be213f695400f3$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $e0be213f695400f3$var$validateFirebaseData((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, 'value'), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ const $e0be213f695400f3$var$validateFirebaseData = function(errorPrefix, data, path_) {
    const path = path_ instanceof $e0be213f695400f3$var$Path ? new $e0be213f695400f3$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + 'contains undefined ' + $e0be213f695400f3$var$validationPathToErrorString(path));
    if (typeof data === 'function') throw new Error(errorPrefix + 'contains a function ' + $e0be213f695400f3$var$validationPathToErrorString(path) + ' with contents = ' + data.toString());
    if ($e0be213f695400f3$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + $e0be213f695400f3$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' && data.length > $e0be213f695400f3$var$MAX_LEAF_SIZE_ / 3 && (0, $474ae12482b554c6$export$9536dc0a75b20bf9)(data) > $e0be213f695400f3$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + 'contains a string greater than ' + $e0be213f695400f3$var$MAX_LEAF_SIZE_ + ' utf8 bytes ' + $e0be213f695400f3$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        let hasDotValue = false;
        let hasActualChild = false;
        $e0be213f695400f3$var$each(data, (key, value)=>{
            if (key === '.value') hasDotValue = true;
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild = true;
                if (!$e0be213f695400f3$var$isValidKey(key)) throw new Error(errorPrefix + ' contains an invalid key (' + key + ') ' + $e0be213f695400f3$var$validationPathToErrorString(path) + '.  Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $e0be213f695400f3$var$validationPathPush(path, key);
            $e0be213f695400f3$var$validateFirebaseData(errorPrefix, value, path);
            $e0be213f695400f3$var$validationPathPop(path);
        });
        if (hasDotValue && hasActualChild) throw new Error(errorPrefix + ' contains ".value" child ' + $e0be213f695400f3$var$validationPathToErrorString(path) + ' in addition to actual children.');
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ const $e0be213f695400f3$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    let i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        const keys = $e0be213f695400f3$var$pathSlice(curPath);
        for(let j = 0; j < keys.length; j++){
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!$e0be213f695400f3$var$isValidKey(keys[j])) throw new Error(errorPrefix + 'contains an invalid key (' + keys[j] + ') in path ' + curPath.toString() + '. Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($e0be213f695400f3$var$pathCompare);
    let prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $e0be213f695400f3$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + 'contains a path ' + prevPath.toString() + ' that is ancestor of another path ' + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ const $e0be213f695400f3$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    const errorPrefix$1 = (0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, 'values');
    if (!(data && typeof data === 'object') || Array.isArray(data)) throw new Error(errorPrefix$1 + ' must be an object containing the children to replace.');
    const mergePaths = [];
    $e0be213f695400f3$var$each(data, (key, value)=>{
        const curPath = new $e0be213f695400f3$var$Path(key);
        $e0be213f695400f3$var$validateFirebaseData(errorPrefix$1, value, $e0be213f695400f3$var$pathChild(path, curPath));
        if ($e0be213f695400f3$var$pathGetBack(curPath) === '.priority') {
            if (!$e0be213f695400f3$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + 'Firebase priority (a string, finite number, server value, or null).');
        }
        mergePaths.push(curPath);
    });
    $e0be213f695400f3$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
const $e0be213f695400f3$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($e0be213f695400f3$var$isInvalidJSONNumber(priority)) throw new Error((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, 'priority') + 'is ' + priority.toString() + ', but must be a valid Firebase priority (a string, finite number, ' + 'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!$e0be213f695400f3$var$isValidPriority(priority)) throw new Error((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, 'priority') + 'must be a valid Firebase priority ' + '(a string, finite number, server value, or null).');
};
const $e0be213f695400f3$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$e0be213f695400f3$var$isValidKey(key)) throw new Error((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
/**
 * @internal
 */ const $e0be213f695400f3$export$8637b026ace8abb1 = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$e0be213f695400f3$var$isValidPathString(pathString)) throw new Error((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
const $e0be213f695400f3$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    $e0be213f695400f3$export$8637b026ace8abb1(fnName, argumentName, pathString, optional);
};
/**
 * @internal
 */ const $e0be213f695400f3$export$8d83036122ae444e = function(fnName, path) {
    if ($e0be213f695400f3$var$pathGetFront(path) === '.info') throw new Error(fnName + " failed = Can't modify data under /.info/");
};
const $e0be213f695400f3$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    const pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') || parsedUrl.repoInfo.host.length === 0 || !$e0be213f695400f3$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(':')[0] !== 'localhost' || pathString.length !== 0 && !$e0be213f695400f3$var$isValidRootPathString(pathString)) throw new Error((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, 'url') + 'must be a valid firebase URL and ' + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ class $e0be213f695400f3$var$EventQueue {
    constructor(){
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
}
/**
 * @param eventDataList - The new events to queue.
 */ function $e0be213f695400f3$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    let currList = null;
    for(let i = 0; i < eventDataList.length; i++){
        const data = eventDataList[i];
        const path = data.getPath();
        if (currList !== null && !$e0be213f695400f3$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $e0be213f695400f3$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $e0be213f695400f3$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $e0be213f695400f3$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$e0be213f695400f3$var$pathEquals(eventPath, path));
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $e0be213f695400f3$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $e0be213f695400f3$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$e0be213f695400f3$var$pathContains(eventPath, changedPath) || $e0be213f695400f3$var$pathContains(changedPath, eventPath));
}
function $e0be213f695400f3$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    let sentAll = true;
    for(let i = 0; i < eventQueue.eventLists_.length; i++){
        const eventList = eventQueue.eventLists_[i];
        if (eventList) {
            const eventPath = eventList.path;
            if (predicate(eventPath)) {
                $e0be213f695400f3$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $e0be213f695400f3$var$eventListRaise(eventList) {
    for(let i = 0; i < eventList.events.length; i++){
        const eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            const eventFn = eventData.getEventRunner();
            if ($e0be213f695400f3$var$logger) $e0be213f695400f3$var$log('event: ' + eventData.toString());
            $e0be213f695400f3$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$INTERRUPT_REASON = 'repo_interrupt';
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ const $e0be213f695400f3$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ class $e0be213f695400f3$var$Repo {
    constructor(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_){
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $e0be213f695400f3$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $e0be213f695400f3$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $e0be213f695400f3$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ toString() {
        return (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host;
    }
}
function $e0be213f695400f3$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $e0be213f695400f3$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $e0be213f695400f3$var$beingCrawled()) {
        repo.server_ = new $e0be213f695400f3$var$ReadonlyRestClient(repo.repoInfo_, (pathString, data, isMerge, tag)=>{
            $e0be213f695400f3$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(()=>$e0be213f695400f3$var$repoOnConnectStatus(repo, /* connectStatus= */ true), 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== 'undefined' && authOverride !== null) {
            if (typeof authOverride !== 'object') throw new Error('Only objects are supported for option databaseAuthVariableOverride');
            try {
                (0, $474ae12482b554c6$export$fac44ee5b035f737)(authOverride);
            } catch (e) {
                throw new Error('Invalid authOverride provided: ' + e);
            }
        }
        repo.persistentConnection_ = new $e0be213f695400f3$var$PersistentConnection(repo.repoInfo_, appId, (pathString, data, isMerge, tag)=>{
            $e0be213f695400f3$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, (connectStatus)=>{
            $e0be213f695400f3$var$repoOnConnectStatus(repo, connectStatus);
        }, (updates)=>{
            $e0be213f695400f3$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener((token)=>{
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener((result)=>{
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $e0be213f695400f3$var$statsManagerGetOrCreateReporter(repo.repoInfo_, ()=>new $e0be213f695400f3$var$StatsReporter(repo.stats_, repo.server_));
    // Used for .info.
    repo.infoData_ = new $e0be213f695400f3$var$SnapshotHolder();
    repo.infoSyncTree_ = new $e0be213f695400f3$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            let infoEvents = [];
            const node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $e0be213f695400f3$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(()=>{
                    onComplete('ok');
                }, 0);
            }
            return infoEvents;
        },
        stopListening: ()=>{}
    });
    $e0be213f695400f3$var$repoUpdateInfo(repo, 'connected', false);
    repo.serverSyncTree_ = new $e0be213f695400f3$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            repo.server_.listen(query, currentHashFn, tag, (status, data)=>{
                const events = onComplete(status, data);
                $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: (query, tag)=>{
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $e0be213f695400f3$var$repoServerTime(repo) {
    const offsetNode = repo.infoData_.getNode(new $e0be213f695400f3$var$Path('.info/serverTimeOffset'));
    const offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $e0be213f695400f3$var$repoGenerateServerValues(repo) {
    return $e0be213f695400f3$var$generateWithValues({
        timestamp: $e0be213f695400f3$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $e0be213f695400f3$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    const path = new $e0be213f695400f3$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    let events = [];
    if (tag) {
        if (isMerge) {
            const taggedChildren = (0, $474ae12482b554c6$export$871de8747c9eaa88)(data, (raw)=>$e0be213f695400f3$var$nodeFromJSON(raw));
            events = $e0be213f695400f3$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            const taggedSnap = $e0be213f695400f3$var$nodeFromJSON(data);
            events = $e0be213f695400f3$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        const changedChildren = (0, $474ae12482b554c6$export$871de8747c9eaa88)(data, (raw)=>$e0be213f695400f3$var$nodeFromJSON(raw));
        events = $e0be213f695400f3$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        const snap = $e0be213f695400f3$var$nodeFromJSON(data);
        events = $e0be213f695400f3$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    let affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $e0be213f695400f3$var$repoRerunTransactions(repo, path);
    $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
function $e0be213f695400f3$var$repoOnConnectStatus(repo, connectStatus) {
    $e0be213f695400f3$var$repoUpdateInfo(repo, 'connected', connectStatus);
    if (connectStatus === false) $e0be213f695400f3$var$repoRunOnDisconnectEvents(repo);
}
function $e0be213f695400f3$var$repoOnServerInfoUpdate(repo, updates) {
    $e0be213f695400f3$var$each(updates, (key, value)=>{
        $e0be213f695400f3$var$repoUpdateInfo(repo, key, value);
    });
}
function $e0be213f695400f3$var$repoUpdateInfo(repo, pathString, value) {
    const path = new $e0be213f695400f3$var$Path('/.info/' + pathString);
    const newNode = $e0be213f695400f3$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    const events = $e0be213f695400f3$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $e0be213f695400f3$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will wait until the
 *  repo has established a connection and then request the value for `query`.
 * If the client is not able to retrieve the query result for another reason,
 * it reports an error.
 *
 * @param query - The query to surface a value for.
 */ function $e0be213f695400f3$var$repoGetValue(repo, query, eventRegistration) {
    // Only active queries are cached. There is no persisted cache.
    const cached = $e0be213f695400f3$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then((payload)=>{
        const node = $e0be213f695400f3$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        /**
         * Below we simulate the actions of an `onlyOnce` `onValue()` event where:
         * Add an event registration,
         * Update data at the path,
         * Raise any events,
         * Cleanup the SyncTree
         */ $e0be213f695400f3$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration, true);
        let events;
        if (query._queryParams.loadsAllData()) events = $e0be213f695400f3$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        else {
            const tag = $e0be213f695400f3$var$syncTreeTagForQuery(repo.serverSyncTree_, query);
            events = $e0be213f695400f3$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, query._path, node, tag);
        }
        /*
         * We need to raise events in the scenario where `get()` is called at a parent path, and
         * while the `get()` is pending, `onValue` is called at a child location. While get() is waiting
         * for the data, `onValue` will register a new event. Then, get() will come back, and update the syncTree
         * and its corresponding serverCache, including the child location where `onValue` is called. Then,
         * `onValue` will receive the event from the server, but look at the syncTree and see that the data received
         * from the server is already at the SyncPoint, and so the `onValue` callback will never get fired.
         * Calling `eventQueueRaiseEventsForChangedPath()` is the correct way to propagate the events and
         * ensure the corresponding child events will get fired.
         */ $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
        $e0be213f695400f3$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration, null, true);
        return node;
    }, (err)=>{
        $e0be213f695400f3$var$repoLog(repo, 'get for query ' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(query) + ' failed: ' + err);
        return Promise.reject(new Error(err));
    });
}
function $e0be213f695400f3$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $e0be213f695400f3$var$repoLog(repo, 'set', {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    const serverValues = $e0be213f695400f3$var$repoGenerateServerValues(repo);
    const newNodeUnresolved = $e0be213f695400f3$var$nodeFromJSON(newVal, newPriority);
    const existing = $e0be213f695400f3$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    const newNode = $e0be213f695400f3$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    const writeId = $e0be213f695400f3$var$repoGetNextWriteId(repo);
    const events = $e0be213f695400f3$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $e0be213f695400f3$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), (status, errorReason)=>{
        const success = status === 'ok';
        if (!success) $e0be213f695400f3$var$warn('set at ' + path + ' failed: ' + status);
        const clearEvents = $e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    const affectedPath = $e0be213f695400f3$var$repoAbortTransactions(repo, path);
    $e0be213f695400f3$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $e0be213f695400f3$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $e0be213f695400f3$var$repoLog(repo, 'update', {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    let empty = true;
    const serverValues = $e0be213f695400f3$var$repoGenerateServerValues(repo);
    const changedChildren = {};
    $e0be213f695400f3$var$each(childrenToMerge, (changedKey, changedValue)=>{
        empty = false;
        changedChildren[changedKey] = $e0be213f695400f3$var$resolveDeferredValueTree($e0be213f695400f3$var$pathChild(path, changedKey), $e0be213f695400f3$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        const writeId = $e0be213f695400f3$var$repoGetNextWriteId(repo);
        const events = $e0be213f695400f3$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId);
        $e0be213f695400f3$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, (status, errorReason)=>{
            const success = status === 'ok';
            if (!success) $e0be213f695400f3$var$warn('update at ' + path + ' failed: ' + status);
            const clearEvents = $e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
            const affectedPath = clearEvents.length > 0 ? $e0be213f695400f3$var$repoRerunTransactions(repo, path) : path;
            $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $e0be213f695400f3$var$each(childrenToMerge, (changedPath)=>{
            const affectedPath = $e0be213f695400f3$var$repoAbortTransactions(repo, $e0be213f695400f3$var$pathChild(path, changedPath));
            $e0be213f695400f3$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $e0be213f695400f3$var$log("update() called with empty data.  Don't do anything.");
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $e0be213f695400f3$var$repoRunOnDisconnectEvents(repo) {
    $e0be213f695400f3$var$repoLog(repo, 'onDisconnectEvents');
    const serverValues = $e0be213f695400f3$var$repoGenerateServerValues(repo);
    const resolvedOnDisconnectTree = $e0be213f695400f3$var$newSparseSnapshotTree();
    $e0be213f695400f3$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $e0be213f695400f3$var$newEmptyPath(), (path, node)=>{
        const resolved = $e0be213f695400f3$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $e0be213f695400f3$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    let events = [];
    $e0be213f695400f3$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $e0be213f695400f3$var$newEmptyPath(), (path, snap)=>{
        events = events.concat($e0be213f695400f3$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        const affectedPath = $e0be213f695400f3$var$repoAbortTransactions(repo, path);
        $e0be213f695400f3$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $e0be213f695400f3$var$newSparseSnapshotTree();
    $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $e0be213f695400f3$var$newEmptyPath(), events);
}
function $e0be213f695400f3$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), (status, errorReason)=>{
        if (status === 'ok') $e0be213f695400f3$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $e0be213f695400f3$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    const newNode = $e0be213f695400f3$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $e0be213f695400f3$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $e0be213f695400f3$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    const newNode = $e0be213f695400f3$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $e0be213f695400f3$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $e0be213f695400f3$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $474ae12482b554c6$export$dd1bc94b04021eeb)(childrenToMerge)) {
        $e0be213f695400f3$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, (status, errorReason)=>{
        if (status === 'ok') $e0be213f695400f3$var$each(childrenToMerge, (childName, childNode)=>{
            const newChildNode = $e0be213f695400f3$var$nodeFromJSON(childNode);
            $e0be213f695400f3$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $e0be213f695400f3$var$pathChild(path, childName), newChildNode);
        });
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $e0be213f695400f3$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    let events;
    if ($e0be213f695400f3$var$pathGetFront(query._path) === '.info') events = $e0be213f695400f3$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $e0be213f695400f3$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $e0be213f695400f3$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $e0be213f695400f3$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    let events;
    if ($e0be213f695400f3$var$pathGetFront(query._path) === '.info') events = $e0be213f695400f3$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $e0be213f695400f3$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $e0be213f695400f3$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $e0be213f695400f3$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($e0be213f695400f3$var$INTERRUPT_REASON);
}
function $e0be213f695400f3$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($e0be213f695400f3$var$INTERRUPT_REASON);
}
function $e0be213f695400f3$var$repoLog(repo, ...varArgs) {
    let prefix = '';
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ':';
    $e0be213f695400f3$var$log(prefix, ...varArgs);
}
function $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $e0be213f695400f3$var$exceptionGuard(()=>{
        if (status === 'ok') callback(null);
        else {
            const code = (status || 'error').toUpperCase();
            let message = code;
            if (errorReason) message += ': ' + errorReason;
            const error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $e0be213f695400f3$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $e0be213f695400f3$var$repoLog(repo, 'transaction on ' + path);
    // Initialize transaction.
    const transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $e0be213f695400f3$var$LUIDGenerator(),
        applyLocally: // Whether to raise local events for this transaction.
        applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        unwatcher: // Function to call to clean up our .on() listener.
        unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    const currentState = $e0be213f695400f3$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    const newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $e0be213f695400f3$var$validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* TransactionStatus.RUN */ ;
        const queueNode = $e0be213f695400f3$var$treeSubTree(repo.transactionQueueTree_, path);
        const nodeQueue = $e0be213f695400f3$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $e0be213f695400f3$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        let priorityForNode;
        if (typeof newVal === 'object' && newVal !== null && (0, $474ae12482b554c6$export$2344b14b097df817)(newVal, '.priority')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(newVal, '.priority');
            (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            const currentNode = $e0be213f695400f3$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        const serverValues = $e0be213f695400f3$var$repoGenerateServerValues(repo);
        const newNodeUnresolved = $e0be213f695400f3$var$nodeFromJSON(newVal, priorityForNode);
        const newNode = $e0be213f695400f3$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $e0be213f695400f3$var$repoGetNextWriteId(repo);
        const events = $e0be213f695400f3$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $e0be213f695400f3$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $e0be213f695400f3$var$repoGetLatestState(repo, path, excludeSets) {
    return $e0be213f695400f3$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $e0be213f695400f3$var$repoSendReadyTransactions(repo, node = repo.transactionQueueTree_) {
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $e0be213f695400f3$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($e0be213f695400f3$var$treeGetValue(node)) {
        const queue = $e0be213f695400f3$var$repoBuildTransactionQueue(repo, node);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(queue.length > 0, 'Sending zero length transaction queue');
        const allRun = queue.every((transaction)=>transaction.status === 0 /* TransactionStatus.RUN */ );
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $e0be213f695400f3$var$repoSendTransactionQueue(repo, $e0be213f695400f3$var$treeGetPath(node), queue);
    } else if ($e0be213f695400f3$var$treeHasChildren(node)) $e0be213f695400f3$var$treeForEachChild(node, (childNode)=>{
        $e0be213f695400f3$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $e0be213f695400f3$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    const setsToIgnore = queue.map((txn)=>{
        return txn.currentWriteId;
    });
    const latestState = $e0be213f695400f3$var$repoGetLatestState(repo, path, setsToIgnore);
    let snapToSend = latestState;
    const latestHash = latestState.hash();
    for(let i = 0; i < queue.length; i++){
        const txn = queue[i];
        (0, $474ae12482b554c6$export$a7a9523472993e97)(txn.status === 0 /* TransactionStatus.RUN */ , 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = 1 /* TransactionStatus.SENT */ ;
        txn.retryCount++;
        const relativePath = $e0be213f695400f3$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    const dataToSend = snapToSend.val(true);
    const pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, (status)=>{
        $e0be213f695400f3$var$repoLog(repo, 'transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        let events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            const callbacks = [];
            for(let i = 0; i < queue.length; i++){
                queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
                events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(()=>queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved));
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            $e0be213f695400f3$var$repoPruneCompletedTransactionsBelowNode(repo, $e0be213f695400f3$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $e0be213f695400f3$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(let i = 0; i < callbacks.length; i++)$e0be213f695400f3$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for(let i = 0; i < queue.length; i++)if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                else queue[i].status = 0 /* TransactionStatus.RUN */ ;
            } else {
                $e0be213f695400f3$var$warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for(let i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $e0be213f695400f3$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $e0be213f695400f3$var$repoRerunTransactions(repo, changedPath) {
    const rootMostTransactionNode = $e0be213f695400f3$var$repoGetAncestorTransactionNode(repo, changedPath);
    const path = $e0be213f695400f3$var$treeGetPath(rootMostTransactionNode);
    const queue = $e0be213f695400f3$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $e0be213f695400f3$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $e0be213f695400f3$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    const callbacks = [];
    let events = [];
    // Ignore all of the sets we're going to re-run.
    const txnsToRerun = queue.filter((q)=>{
        return q.status === 0 /* TransactionStatus.RUN */ ;
    });
    const setsToIgnore = txnsToRerun.map((q)=>{
        return q.currentWriteId;
    });
    for(let i = 0; i < queue.length; i++){
        const transaction = queue[i];
        const relativePath = $e0be213f695400f3$var$newRelativePath(path, transaction.path);
        let abortTransaction = false, abortReason;
        (0, $474ae12482b554c6$export$a7a9523472993e97)(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === 4 /* TransactionStatus.NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* TransactionStatus.RUN */ ) {
            if (transaction.retryCount >= $e0be213f695400f3$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                const currentNode = $e0be213f695400f3$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                const newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $e0be213f695400f3$var$validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    let newDataNode = $e0be213f695400f3$var$nodeFromJSON(newData);
                    const hasExplicitPriority = typeof newData === 'object' && newData != null && (0, $474ae12482b554c6$export$2344b14b097df817)(newData, '.priority');
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    const oldWriteId = transaction.currentWriteId;
                    const serverValues = $e0be213f695400f3$var$repoGenerateServerValues(repo);
                    const newNodeResolved = $e0be213f695400f3$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $e0be213f695400f3$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($e0be213f695400f3$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') callbacks.push(()=>queue[i].onComplete(null, false, queue[i].currentInputSnapshot));
                else callbacks.push(()=>queue[i].onComplete(new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    $e0be213f695400f3$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(let i = 0; i < callbacks.length; i++)$e0be213f695400f3$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $e0be213f695400f3$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $e0be213f695400f3$var$repoGetAncestorTransactionNode(repo, path) {
    let front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    let transactionNode = repo.transactionQueueTree_;
    front = $e0be213f695400f3$var$pathGetFront(path);
    while(front !== null && $e0be213f695400f3$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $e0be213f695400f3$var$treeSubTree(transactionNode, front);
        path = $e0be213f695400f3$var$pathPopFront(path);
        front = $e0be213f695400f3$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $e0be213f695400f3$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    const transactionQueue = [];
    $e0be213f695400f3$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort((a, b)=>a.order - b.order);
    return transactionQueue;
}
function $e0be213f695400f3$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    const nodeQueue = $e0be213f695400f3$var$treeGetValue(node);
    if (nodeQueue) for(let i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $e0be213f695400f3$var$treeForEachChild(node, (child)=>{
        $e0be213f695400f3$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $e0be213f695400f3$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    const queue = $e0be213f695400f3$var$treeGetValue(node);
    if (queue) {
        let to = 0;
        for(let from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* TransactionStatus.COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $e0be213f695400f3$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $e0be213f695400f3$var$treeForEachChild(node, (childNode)=>{
        $e0be213f695400f3$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $e0be213f695400f3$var$repoAbortTransactions(repo, path) {
    const affectedPath = $e0be213f695400f3$var$treeGetPath($e0be213f695400f3$var$repoGetAncestorTransactionNode(repo, path));
    const transactionNode = $e0be213f695400f3$var$treeSubTree(repo.transactionQueueTree_, path);
    $e0be213f695400f3$var$treeForEachAncestor(transactionNode, (node)=>{
        $e0be213f695400f3$var$repoAbortTransactionsOnNode(repo, node);
    });
    $e0be213f695400f3$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $e0be213f695400f3$var$treeForEachDescendant(transactionNode, (node)=>{
        $e0be213f695400f3$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $e0be213f695400f3$var$repoAbortTransactionsOnNode(repo, node) {
    const queue = $e0be213f695400f3$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        const callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        let events = [];
        let lastSent = -1;
        for(let i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* TransactionStatus.SENT */ ) {
                (0, $474ae12482b554c6$export$a7a9523472993e97)(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = 'set';
            } else {
                (0, $474ae12482b554c6$export$a7a9523472993e97)(queue[i].status === 0 /* TransactionStatus.RUN */ , 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $e0be213f695400f3$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $e0be213f695400f3$var$treeGetPath(node), events);
        for(let i = 0; i < callbacks.length; i++)$e0be213f695400f3$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$decodePath(pathString) {
    let pathStringDecoded = '';
    const pieces = pathString.split('/');
    for(let i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        let piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, ' '));
        } catch (e) {}
        pathStringDecoded += '/' + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $e0be213f695400f3$var$decodeQuery(queryString) {
    const results = {};
    if (queryString.charAt(0) === '?') queryString = queryString.substring(1);
    for (const segment of queryString.split('&')){
        if (segment.length === 0) continue;
        const kv = segment.split('=');
        if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        else $e0be213f695400f3$var$warn(`Invalid query segment '${segment}' in query '${queryString}'`);
    }
    return results;
}
const $e0be213f695400f3$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    const parsedUrl = $e0be213f695400f3$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === 'firebase.com') $e0be213f695400f3$var$fatal(parsedUrl.host + ' is no longer supported. ' + 'Please use <YOUR FIREBASE>.firebaseio.com instead');
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === 'undefined') && parsedUrl.domain !== 'localhost') $e0be213f695400f3$var$fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    if (!parsedUrl.secure) $e0be213f695400f3$var$warnIfPageIsSecure();
    const webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new $e0be213f695400f3$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, nodeAdmin, /*persistenceKey=*/ '', /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $e0be213f695400f3$var$Path(parsedUrl.pathString)
    };
};
const $e0be213f695400f3$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    let host = '', domain = '', subdomain = '', pathString = '', namespace = '';
    // Always default to SSL, unless otherwise specified.
    let secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        let colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        let slashInd = dataURL.indexOf('/');
        if (slashInd === -1) slashInd = dataURL.length;
        let questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $e0be213f695400f3$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        const queryParams = $e0be213f695400f3$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        const hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === 'localhost') domain = 'localhost';
        else if (hostWithoutPort.split('.').length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            const dotInd = host.indexOf('.');
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ('ns' in queryParams) namespace = queryParams['ns'];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
const $e0be213f695400f3$var$PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ const $e0be213f695400f3$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    let lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    const lastRandChars = [];
    return function(now) {
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        let i;
        const timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $e0be213f695400f3$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $474ae12482b554c6$export$a7a9523472993e97)(now === 0, 'Cannot push at time == 0');
        let id = timeStampChars.join('');
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $e0be213f695400f3$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ class $e0be213f695400f3$var$DataEvent {
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ constructor(eventType, eventRegistration, snapshot, prevName){
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    getPath() {
        const ref = this.snapshot.ref;
        if (this.eventType === 'value') return ref._path;
        else return ref.parent._path;
    }
    getEventType() {
        return this.eventType;
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.getPath().toString() + ':' + this.eventType + ':' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(this.snapshot.exportVal());
    }
}
class $e0be213f695400f3$var$CancelEvent {
    constructor(eventRegistration, error, path){
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    getPath() {
        return this.path;
    }
    getEventType() {
        return 'cancel';
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.path.toString() + ':cancel';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ class $e0be213f695400f3$var$CallbackContext {
    constructor(snapshotCallback, cancelCallback){
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
    onValue(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    }
    onCancel(error) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.hasCancelCallback, 'Raising a cancel event on a listener with no cancel callback');
        return this.cancelCallback.call(null, error);
    }
    get hasCancelCallback() {
        return !!this.cancelCallback;
    }
    matches(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ class $e0be213f695400f3$export$95b7818b4ee6c2af {
    /** @hideconstructor */ constructor(_repo, _path){
        this._repo = _repo;
        this._path = _path;
    }
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ cancel() {
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        $e0be213f695400f3$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ remove() {
        $e0be213f695400f3$export$8d83036122ae444e('OnDisconnect.remove', this._path);
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        $e0be213f695400f3$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ set(value) {
        $e0be213f695400f3$export$8d83036122ae444e('OnDisconnect.set', this._path);
        $e0be213f695400f3$var$validateFirebaseDataArg('OnDisconnect.set', value, this._path, false);
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        $e0be213f695400f3$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ setWithPriority(value, priority) {
        $e0be213f695400f3$export$8d83036122ae444e('OnDisconnect.setWithPriority', this._path);
        $e0be213f695400f3$var$validateFirebaseDataArg('OnDisconnect.setWithPriority', value, this._path, false);
        $e0be213f695400f3$var$validatePriority('OnDisconnect.setWithPriority', priority, false);
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        $e0be213f695400f3$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ update(values) {
        $e0be213f695400f3$export$8d83036122ae444e('OnDisconnect.update', this._path);
        $e0be213f695400f3$var$validateFirebaseMergeDataArg('OnDisconnect.update', values, this._path, false);
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        $e0be213f695400f3$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $e0be213f695400f3$export$e79c8d837d2220a8 {
    /**
     * @hideconstructor
     */ constructor(_repo, _path, _queryParams, _orderByCalled){
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
    get key() {
        if ($e0be213f695400f3$var$pathIsEmpty(this._path)) return null;
        else return $e0be213f695400f3$var$pathGetBack(this._path);
    }
    get ref() {
        return new $e0be213f695400f3$export$35c3a5e7c9d1033c(this._repo, this._path);
    }
    get _queryIdentifier() {
        const obj = $e0be213f695400f3$var$queryParamsGetQueryObject(this._queryParams);
        const id = $e0be213f695400f3$var$ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    }
    /**
     * An object representation of the query parameters used by this Query.
     */ get _queryObject() {
        return $e0be213f695400f3$var$queryParamsGetQueryObject(this._queryParams);
    }
    isEqual(other) {
        other = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof $e0be213f695400f3$export$e79c8d837d2220a8)) return false;
        const sameRepo = this._repo === other._repo;
        const samePath = $e0be213f695400f3$var$pathEquals(this._path, other._path);
        const sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return this._repo.toString() + $e0be213f695400f3$var$pathToUrlEncodedString(this._path);
    }
}
/**
 * Validates that no other order by call has been made
 */ function $e0be213f695400f3$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $e0be213f695400f3$var$validateQueryEndpoints(params) {
    let startNode = null;
    let endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $e0be213f695400f3$var$KEY_INDEX) {
        const tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        const wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            if (startName !== $e0be213f695400f3$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== 'string') throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            if (endName !== $e0be213f695400f3$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== 'string') throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $e0be213f695400f3$var$PRIORITY_INDEX) {
        if (startNode != null && !$e0be213f695400f3$var$isValidPriority(startNode) || endNode != null && !$e0be213f695400f3$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(params.getIndex() instanceof $e0be213f695400f3$var$PathIndex || params.getIndex() === $e0be213f695400f3$var$VALUE_INDEX, 'unknown index type.');
        if (startNode != null && typeof startNode === 'object' || endNode != null && typeof endNode === 'object') throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $e0be213f695400f3$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ class $e0be213f695400f3$export$35c3a5e7c9d1033c extends $e0be213f695400f3$export$e79c8d837d2220a8 {
    /** @hideconstructor */ constructor(repo, path){
        super(repo, path, new $e0be213f695400f3$export$7ba287e361c94330(), false);
    }
    get parent() {
        const parentPath = $e0be213f695400f3$var$pathParent(this._path);
        return parentPath === null ? null : new $e0be213f695400f3$export$35c3a5e7c9d1033c(this._repo, parentPath);
    }
    get root() {
        let ref = this;
        while(ref.parent !== null)ref = ref.parent;
        return ref;
    }
}
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ class $e0be213f695400f3$export$80b98bcbc246c942 {
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ constructor(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index){
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
    /**
     * Gets the priority value of the data in this `DataSnapshot`.
     *
     * Applications need not use priority but can order collections by
     * ordinary properties (see
     * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
     * ).
     */ get priority() {
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this._node.getPriority().val();
    }
    /**
     * The key (last part of the path) of the location of this `DataSnapshot`.
     *
     * The last token in a Database location is considered its key. For example,
     * "ada" is the key for the /users/ada/ node. Accessing the key on any
     * `DataSnapshot` will return the key for the location that generated it.
     * However, accessing the key on the root URL of a Database will return
     * `null`.
     */ get key() {
        return this.ref.key;
    }
    /** Returns the number of child properties of this `DataSnapshot`. */ get size() {
        return this._node.numChildren();
    }
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ child(path) {
        const childPath = new $e0be213f695400f3$var$Path(path);
        const childRef = $e0be213f695400f3$export$f9574b70e1d95d9d(this.ref, path);
        return new $e0be213f695400f3$export$80b98bcbc246c942(this._node.getChild(childPath), childRef, $e0be213f695400f3$var$PRIORITY_INDEX);
    }
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ exists() {
        return !this._node.isEmpty();
    }
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportVal() {
        return this._node.val(true);
    }
    /**
     * Enumerates the top-level children in the `IteratedDataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ forEach(action) {
        if (this._node.isLeafNode()) return false;
        const childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, (key, node)=>{
            return action(new $e0be213f695400f3$export$80b98bcbc246c942(node, $e0be213f695400f3$export$f9574b70e1d95d9d(this.ref, key), $e0be213f695400f3$var$PRIORITY_INDEX));
        });
    }
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ hasChild(path) {
        const childPath = new $e0be213f695400f3$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    }
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ hasChildren() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    }
    /**
     * Returns a JSON-serializable representation of this object.
     */ toJSON() {
        return this.exportVal();
    }
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    val() {
        return this._node.val();
    }
}
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $e0be213f695400f3$export$eff4d24c3ff7876e(db, path) {
    db = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('ref');
    return path !== undefined ? $e0be213f695400f3$export$f9574b70e1d95d9d(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $e0be213f695400f3$export$291fc3c05735451(db, url) {
    db = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('refFromURL');
    const parsedURL = $e0be213f695400f3$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $e0be213f695400f3$var$validateUrl('refFromURL', parsedURL);
    const repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $e0be213f695400f3$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + ' but expected ' + db._repo.repoInfo_.host + ')');
    return $e0be213f695400f3$export$eff4d24c3ff7876e(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $e0be213f695400f3$export$f9574b70e1d95d9d(parent, path) {
    parent = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(parent);
    if ($e0be213f695400f3$var$pathGetFront(parent._path) === null) $e0be213f695400f3$var$validateRootPathString('child', 'path', path, false);
    else $e0be213f695400f3$export$8637b026ace8abb1('child', 'path', path, false);
    return new $e0be213f695400f3$export$35c3a5e7c9d1033c(parent._repo, $e0be213f695400f3$var$pathChild(parent._path, path));
}
/**
 * Returns an `OnDisconnect` object - see
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information on how to use it.
 *
 * @param ref - The reference to add OnDisconnect triggers for.
 */ function $e0be213f695400f3$export$b61bdcd0bdb4f86a(ref) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return new $e0be213f695400f3$export$95b7818b4ee6c2af(ref._repo, ref._path);
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}.
 * See {@link https://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}.
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $e0be213f695400f3$export$4cbf152802aa238(parent, value) {
    parent = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(parent);
    $e0be213f695400f3$export$8d83036122ae444e('push', parent._path);
    $e0be213f695400f3$var$validateFirebaseDataArg('push', value, parent._path, true);
    const now = $e0be213f695400f3$var$repoServerTime(parent._repo);
    const name = $e0be213f695400f3$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    const thenablePushRef = $e0be213f695400f3$export$f9574b70e1d95d9d(parent, name);
    const pushRef = $e0be213f695400f3$export$f9574b70e1d95d9d(parent, name);
    let promise;
    if (value != null) promise = $e0be213f695400f3$export$adaa4cf7ef1b65be(pushRef, value).then(()=>pushRef);
    else promise = Promise.resolve(pushRef);
    thenablePushRef.then = promise.then.bind(promise);
    thenablePushRef.catch = promise.then.bind(promise, undefined);
    return thenablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $e0be213f695400f3$export$cd7f480d6b8286c3(ref) {
    $e0be213f695400f3$export$8d83036122ae444e('remove', ref._path);
    return $e0be213f695400f3$export$adaa4cf7ef1b65be(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $e0be213f695400f3$export$adaa4cf7ef1b65be(ref, value) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    $e0be213f695400f3$export$8d83036122ae444e('set', ref._path);
    $e0be213f695400f3$var$validateFirebaseDataArg('set', value, ref._path, false);
    const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
    $e0be213f695400f3$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $e0be213f695400f3$export$313bf5dbe7a1196e(ref, priority) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    $e0be213f695400f3$export$8d83036122ae444e('setPriority', ref._path);
    $e0be213f695400f3$var$validatePriority('setPriority', priority, false);
    const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
    $e0be213f695400f3$var$repoSetWithPriority(ref._repo, $e0be213f695400f3$var$pathChild(ref._path, '.priority'), priority, null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $e0be213f695400f3$export$1fa5d5bf488088f3(ref, value, priority) {
    $e0be213f695400f3$export$8d83036122ae444e('setWithPriority', ref._path);
    $e0be213f695400f3$var$validateFirebaseDataArg('setWithPriority', value, ref._path, false);
    $e0be213f695400f3$var$validatePriority('setWithPriority', priority, false);
    if (ref.key === '.length' || ref.key === '.keys') throw 'setWithPriority failed: ' + ref.key + ' is a read-only object.';
    const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
    $e0be213f695400f3$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $e0be213f695400f3$export$722fbec263ad908a(ref, values) {
    $e0be213f695400f3$var$validateFirebaseMergeDataArg('update', values, ref._path, false);
    const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
    $e0be213f695400f3$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A `Promise` which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $e0be213f695400f3$export$3988ae62b71be9a3(query) {
    query = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(query);
    const callbackContext = new $e0be213f695400f3$var$CallbackContext(()=>{});
    const container = new $e0be213f695400f3$var$ValueEventRegistration(callbackContext);
    return $e0be213f695400f3$var$repoGetValue(query._repo, query, container).then((node)=>{
        return new $e0be213f695400f3$export$80b98bcbc246c942(node, new $e0be213f695400f3$export$35c3a5e7c9d1033c(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ class $e0be213f695400f3$var$ValueEventRegistration {
    constructor(callbackContext){
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        return eventType === 'value';
    }
    createEvent(change, query) {
        const index = query._queryParams.getIndex();
        return new $e0be213f695400f3$var$DataEvent('value', this, new $e0be213f695400f3$export$80b98bcbc246c942(change.snapshotNode, new $e0be213f695400f3$export$35c3a5e7c9d1033c(query._repo, query._path), index));
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, null);
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $e0be213f695400f3$var$CancelEvent(this, error, path);
        else return null;
    }
    matches(other) {
        if (!(other instanceof $e0be213f695400f3$var$ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    }
    hasAnyCallback() {
        return this.callbackContext !== null;
    }
}
/**
 * Represents the registration of a child_x event.
 */ class $e0be213f695400f3$var$ChildEventRegistration {
    constructor(eventType, callbackContext){
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        let eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck = eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return this.eventType === eventToCheck;
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $e0be213f695400f3$var$CancelEvent(this, error, path);
        else return null;
    }
    createEvent(change, query) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(change.childName != null, 'Child events should have a childName.');
        const childRef = $e0be213f695400f3$export$f9574b70e1d95d9d(new $e0be213f695400f3$export$35c3a5e7c9d1033c(query._repo, query._path), change.childName);
        const index = query._queryParams.getIndex();
        return new $e0be213f695400f3$var$DataEvent(change.type, this, new $e0be213f695400f3$export$80b98bcbc246c942(change.snapshotNode, childRef, index), change.prevName);
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
    }
    matches(other) {
        if (other instanceof $e0be213f695400f3$var$ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    }
    hasAnyCallback() {
        return !!this.callbackContext;
    }
}
function $e0be213f695400f3$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    let cancelCallback;
    if (typeof cancelCallbackOrListenOptions === 'object') {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === 'function') cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        const userCallback = callback;
        const onceCallback = (dataSnapshot, previousChildName)=>{
            $e0be213f695400f3$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    const callbackContext = new $e0be213f695400f3$var$CallbackContext(callback, cancelCallback || undefined);
    const container = eventType === 'value' ? new $e0be213f695400f3$var$ValueEventRegistration(callbackContext) : new $e0be213f695400f3$var$ChildEventRegistration(eventType, callbackContext);
    $e0be213f695400f3$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return ()=>$e0be213f695400f3$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
function $e0be213f695400f3$export$ad30f661f41f4d90(query, callback, cancelCallbackOrListenOptions, options) {
    return $e0be213f695400f3$var$addEventListener(query, 'value', callback, cancelCallbackOrListenOptions, options);
}
function $e0be213f695400f3$export$fdc3e67b2775c753(query, callback, cancelCallbackOrListenOptions, options) {
    return $e0be213f695400f3$var$addEventListener(query, 'child_added', callback, cancelCallbackOrListenOptions, options);
}
function $e0be213f695400f3$export$a3fdf31223dcb03(query, callback, cancelCallbackOrListenOptions, options) {
    return $e0be213f695400f3$var$addEventListener(query, 'child_changed', callback, cancelCallbackOrListenOptions, options);
}
function $e0be213f695400f3$export$1b001b15904d2a7f(query, callback, cancelCallbackOrListenOptions, options) {
    return $e0be213f695400f3$var$addEventListener(query, 'child_moved', callback, cancelCallbackOrListenOptions, options);
}
function $e0be213f695400f3$export$8362b530316d1aba(query, callback, cancelCallbackOrListenOptions, options) {
    return $e0be213f695400f3$var$addEventListener(query, 'child_removed', callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with the corresponding `on*()` (`onValue`, `onChildAdded`) listener.
 * Note: This is not the recommended way to remove a listener. Instead, please use the returned callback function from
 * the respective `on*` callbacks.
 *
 * Detach a callback previously attached with `on*()`. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $e0be213f695400f3$export$8c8705df4a2dcec9(query, eventType, callback) {
    let container = null;
    const expCallback = callback ? new $e0be213f695400f3$var$CallbackContext(callback) : null;
    if (eventType === 'value') container = new $e0be213f695400f3$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $e0be213f695400f3$var$ChildEventRegistration(eventType, expCallback);
    $e0be213f695400f3$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $e0be213f695400f3$export$b0e86f2c7431df4e {
}
class $e0be213f695400f3$var$QueryEndAtConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endAt';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateFirebaseDataArg('endAt', this._value, query._path, true);
        const newParams = $e0be213f695400f3$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $e0be213f695400f3$var$validateLimit(newParams);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $e0be213f695400f3$export$28ec54a8428bdb3f(value, key) {
    $e0be213f695400f3$var$validateKey('endAt', 'key', key, true);
    return new $e0be213f695400f3$var$QueryEndAtConstraint(value, key);
}
class $e0be213f695400f3$var$QueryEndBeforeConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endBefore';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateFirebaseDataArg('endBefore', this._value, query._path, false);
        const newParams = $e0be213f695400f3$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $e0be213f695400f3$var$validateLimit(newParams);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value less than or equal
 * to the specified value and a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $e0be213f695400f3$export$57203950645b8b11(value, key) {
    $e0be213f695400f3$var$validateKey('endBefore', 'key', key, true);
    return new $e0be213f695400f3$var$QueryEndBeforeConstraint(value, key);
}
class $e0be213f695400f3$var$QueryStartAtConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAt';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateFirebaseDataArg('startAt', this._value, query._path, true);
        const newParams = $e0be213f695400f3$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $e0be213f695400f3$var$validateLimit(newParams);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $e0be213f695400f3$export$859941c5fc8eba6b(value = null, key) {
    $e0be213f695400f3$var$validateKey('startAt', 'key', key, true);
    return new $e0be213f695400f3$var$QueryStartAtConstraint(value, key);
}
class $e0be213f695400f3$var$QueryStartAfterConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAfter';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateFirebaseDataArg('startAfter', this._value, query._path, false);
        const newParams = $e0be213f695400f3$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $e0be213f695400f3$var$validateLimit(newParams);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $e0be213f695400f3$export$dd8dee5f7b804673(value, key) {
    $e0be213f695400f3$var$validateKey('startAfter', 'key', key, true);
    return new $e0be213f695400f3$var$QueryStartAfterConstraint(value, key);
}
class $e0be213f695400f3$var$QueryLimitToFirstConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToFirst';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, $e0be213f695400f3$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $e0be213f695400f3$export$9d02e839f813b99d(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToFirst: First argument must be a positive integer.');
    return new $e0be213f695400f3$var$QueryLimitToFirstConstraint(limit);
}
class $e0be213f695400f3$var$QueryLimitToLastConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToLast';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, $e0be213f695400f3$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $e0be213f695400f3$export$f823b3589f69d3b8(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToLast: First argument must be a positive integer.');
    return new $e0be213f695400f3$var$QueryLimitToLastConstraint(limit);
}
class $e0be213f695400f3$var$QueryOrderByChildConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_path){
        super();
        this._path = _path;
        this.type = 'orderByChild';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateNoPreviousOrderByCall(query, 'orderByChild');
        const parsedPath = new $e0be213f695400f3$var$Path(this._path);
        if ($e0be213f695400f3$var$pathIsEmpty(parsedPath)) throw new Error('orderByChild: cannot pass in empty path. Use orderByValue() instead.');
        const index = new $e0be213f695400f3$var$PathIndex(parsedPath);
        const newParams = $e0be213f695400f3$var$queryParamsOrderBy(query._queryParams, index);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $e0be213f695400f3$export$5162bd9025f8e144(path) {
    if (path === '$key') throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === '$priority') throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === '$value') throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $e0be213f695400f3$export$8637b026ace8abb1('orderByChild', 'path', path, false);
    return new $e0be213f695400f3$var$QueryOrderByChildConstraint(path);
}
class $e0be213f695400f3$var$QueryOrderByKeyConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByKey';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateNoPreviousOrderByCall(query, 'orderByKey');
        const newParams = $e0be213f695400f3$var$queryParamsOrderBy(query._queryParams, $e0be213f695400f3$var$KEY_INDEX);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $e0be213f695400f3$export$d5ab8b3bbd8afbf8() {
    return new $e0be213f695400f3$var$QueryOrderByKeyConstraint();
}
class $e0be213f695400f3$var$QueryOrderByPriorityConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByPriority';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateNoPreviousOrderByCall(query, 'orderByPriority');
        const newParams = $e0be213f695400f3$var$queryParamsOrderBy(query._queryParams, $e0be213f695400f3$var$PRIORITY_INDEX);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $e0be213f695400f3$export$19e8ae5500cf2e55() {
    return new $e0be213f695400f3$var$QueryOrderByPriorityConstraint();
}
class $e0be213f695400f3$var$QueryOrderByValueConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByValue';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateNoPreviousOrderByCall(query, 'orderByValue');
        const newParams = $e0be213f695400f3$var$queryParamsOrderBy(query._queryParams, $e0be213f695400f3$var$VALUE_INDEX);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $e0be213f695400f3$export$7f2f62793c39d0c0() {
    return new $e0be213f695400f3$var$QueryOrderByValueConstraint();
}
class $e0be213f695400f3$var$QueryEqualToValueConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'equalTo';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateFirebaseDataArg('equalTo', this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $e0be213f695400f3$var$QueryEndAtConstraint(this._value, this._key)._apply(new $e0be213f695400f3$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    }
}
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $e0be213f695400f3$export$bdcdec1f91f16dff(value, key) {
    $e0be213f695400f3$var$validateKey('equalTo', 'key', key, true);
    return new $e0be213f695400f3$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $e0be213f695400f3$export$2fa187e846a241c4(query1, ...queryConstraints) {
    let queryImpl = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(query1);
    for (const constraint of queryConstraints)queryImpl = constraint._apply(queryImpl);
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $e0be213f695400f3$var$syncPointSetReferenceConstructor($e0be213f695400f3$export$35c3a5e7c9d1033c);
$e0be213f695400f3$var$syncTreeSetReferenceConstructor($e0be213f695400f3$export$35c3a5e7c9d1033c);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase Node.js Admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ const $e0be213f695400f3$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
/**
 * Creates and caches `Repo` instances.
 */ const $e0be213f695400f3$var$repos = {};
/**
 * If true, any new `Repo` will be created to use `ReadonlyRestClient` (for testing purposes).
 */ let $e0be213f695400f3$var$useRestClient = false;
/**
 * Update an existing `Repo` in place to point to a new host/port.
 */ function $e0be213f695400f3$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider) {
    repo.repoInfo_ = new $e0be213f695400f3$var$RepoInfo(`${host}:${port}`, /* secure= */ false, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams, /*isUsingEmulator=*/ true);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $e0be213f695400f3$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin) {
    let dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $e0be213f695400f3$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $e0be213f695400f3$var$log('Using default host for project ', app.options.projectId);
        dbUrl = `${app.options.projectId}-default-rtdb.firebaseio.com`;
    }
    let parsedUrl = $e0be213f695400f3$var$parseRepoInfo(dbUrl, nodeAdmin);
    let repoInfo = parsedUrl.repoInfo;
    let isEmulator;
    let dbEmulatorHost = undefined;
    if (typeof $djlMn !== 'undefined' && $djlMn.env) dbEmulatorHost = $djlMn.env[$e0be213f695400f3$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR];
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = `http://${dbEmulatorHost}?ns=${repoInfo.namespace}`;
        parsedUrl = $e0be213f695400f3$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    const authTokenProvider = nodeAdmin && isEmulator ? new $e0be213f695400f3$var$EmulatorTokenProvider($e0be213f695400f3$var$EmulatorTokenProvider.OWNER) : new $e0be213f695400f3$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $e0be213f695400f3$var$validateUrl('Invalid Firebase Database URL', parsedUrl);
    if (!$e0be213f695400f3$var$pathIsEmpty(parsedUrl.path)) $e0be213f695400f3$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    const repo = $e0be213f695400f3$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $e0be213f695400f3$var$AppCheckTokenProvider(app.name, appCheckProvider));
    return new $e0be213f695400f3$export$6feb5ea51a7b0b47(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $e0be213f695400f3$var$repoManagerDeleteRepo(repo, appName) {
    const appRepos = $e0be213f695400f3$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $e0be213f695400f3$var$fatal(`Database ${appName}(${repo.repoInfo_}) has already been deleted.`);
    $e0be213f695400f3$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $e0be213f695400f3$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    let appRepos = $e0be213f695400f3$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $e0be213f695400f3$var$repos[app.name] = appRepos;
    }
    let repo = appRepos[repoInfo.toURLString()];
    if (repo) $e0be213f695400f3$var$fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
    repo = new $e0be213f695400f3$var$Repo(repoInfo, $e0be213f695400f3$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $e0be213f695400f3$var$repoManagerForceRestClient(forceRestClient) {
    $e0be213f695400f3$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ class $e0be213f695400f3$export$6feb5ea51a7b0b47 {
    /** @hideconstructor */ constructor(_repoInternal, /** The {@link @firebase/app#FirebaseApp} associated with this Realtime Database instance. */ app){
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a `Database` instance. */ this['type'] = 'database';
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
    get _repo() {
        if (!this._instanceStarted) {
            $e0be213f695400f3$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options['databaseAuthVariableOverride']);
            this._instanceStarted = true;
        }
        return this._repoInternal;
    }
    get _root() {
        if (!this._rootInternal) this._rootInternal = new $e0be213f695400f3$export$35c3a5e7c9d1033c(this._repo, $e0be213f695400f3$var$newEmptyPath());
        return this._rootInternal;
    }
    _delete() {
        if (this._rootInternal !== null) {
            $e0be213f695400f3$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    }
    _checkNotDeleted(apiName) {
        if (this._rootInternal === null) $e0be213f695400f3$var$fatal('Cannot call ' + apiName + ' on a deleted database.');
    }
}
function $e0be213f695400f3$var$checkTransportInit() {
    if ($e0be213f695400f3$var$TransportManager.IS_TRANSPORT_INITIALIZED) $e0be213f695400f3$var$warn('Transport has already been initialized. Please call this function before calling ref or setting up a listener');
}
/**
 * Force the use of websockets instead of longPolling.
 */ function $e0be213f695400f3$export$752b38c15a5377b6() {
    $e0be213f695400f3$var$checkTransportInit();
    $e0be213f695400f3$var$BrowserPollConnection.forceDisallow();
}
/**
 * Force the use of longPolling instead of websockets. This will be ignored if websocket protocol is used in databaseURL.
 */ function $e0be213f695400f3$export$387cff57f2608869() {
    $e0be213f695400f3$var$checkTransportInit();
    $e0be213f695400f3$var$WebSocketConnection.forceDisallow();
    $e0be213f695400f3$var$BrowserPollConnection.forceAllow();
}
/**
 * Returns the instance of the Realtime Database SDK that is associated with the provided
 * {@link @firebase/app#FirebaseApp}. Initializes a new instance with default settings if
 * no instance exists or if the existing instance uses a custom database URL.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned Realtime
 * Database instance is associated with.
 * @param url - The URL of the Realtime Database instance to connect to. If not
 * provided, the SDK connects to the default instance of the Firebase App.
 * @returns The `Database` instance of the provided app.
 */ function $e0be213f695400f3$export$d0dd861204d0bf72(app = (0, $20ed53392b3edc61$export$f9962582c9e66d99)(), url) {
    const db = (0, $20ed53392b3edc61$export$fa0d6da0f5838f50)(app, 'database').getImmediate({
        identifier: url
    });
    if (!db._instanceStarted) {
        const emulator = (0, $474ae12482b554c6$export$a3febcf1f14a3a0c)('database');
        if (emulator) $e0be213f695400f3$export$87f3cfc4a2e3958d(db, ...emulator);
    }
    return db;
}
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $e0be213f695400f3$export$87f3cfc4a2e3958d(db, host, port, options = {}) {
    db = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('useEmulator');
    if (db._instanceStarted) $e0be213f695400f3$var$fatal('Cannot call useEmulator() after instance has already been initialized.');
    const repo = db._repoInternal;
    let tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $e0be213f695400f3$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $e0be213f695400f3$var$EmulatorTokenProvider($e0be213f695400f3$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        const token = typeof options.mockUserToken === 'string' ? options.mockUserToken : (0, $474ae12482b554c6$export$367bf224123348f1)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $e0be213f695400f3$var$EmulatorTokenProvider(token);
    }
    // Modify the repo to apply emulator settings
    $e0be213f695400f3$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $e0be213f695400f3$export$bee838355d017f0a(db) {
    db = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOffline');
    $e0be213f695400f3$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $e0be213f695400f3$export$e0eecaabee32dd(db) {
    db = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOnline');
    $e0be213f695400f3$var$repoResume(db._repo);
}
function $e0be213f695400f3$export$4e1d237eb9e560af(logger, persistent) {
    $e0be213f695400f3$var$enableLogging$1(logger, persistent);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$registerDatabase(variant) {
    $e0be213f695400f3$export$c9fb972242fcb3c4((0, $20ed53392b3edc61$export$31499a9cd224b78c));
    (0, $20ed53392b3edc61$export$c930050e7bb63965)(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('database', (container, { instanceIdentifier: url })=>{
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider('auth-internal');
        const appCheckProvider = container.getProvider('app-check-internal');
        return $e0be213f695400f3$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($e0be213f695400f3$var$name, $e0be213f695400f3$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($e0be213f695400f3$var$name, $e0be213f695400f3$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$SERVER_TIMESTAMP = {
    '.sv': 'timestamp'
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $e0be213f695400f3$export$3ff8e7e00c3264b7() {
    return $e0be213f695400f3$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $e0be213f695400f3$export$a2647aa13413c947(delta) {
    return {
        '.sv': {
            'increment': delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of {@link runTransaction}.
 */ class $e0be213f695400f3$export$7a6f238067628c6b {
    /** @hideconstructor */ constructor(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    /** Returns a JSON-serializable representation of this object. */ toJSON() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `runTransaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `runTransaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A `Promise` that can optionally be used instead of the `onComplete`
 * callback to handle success and failure.
 */ function $e0be213f695400f3$export$3c54e006bf9c93b7(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    var _a;
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    $e0be213f695400f3$export$8d83036122ae444e('Reference.transaction', ref._path);
    if (ref.key === '.length' || ref.key === '.keys') throw 'Reference.transaction failed: ' + ref.key + ' is a read-only object.';
    const applyLocally = (_a = options === null || options === void 0 ? void 0 : options.applyLocally) !== null && _a !== void 0 ? _a : true;
    const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
    const promiseComplete = (error, committed, node)=>{
        let dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $e0be213f695400f3$export$80b98bcbc246c942(node, new $e0be213f695400f3$export$35c3a5e7c9d1033c(ref._repo, ref._path), $e0be213f695400f3$var$PRIORITY_INDEX);
            deferred.resolve(new $e0be213f695400f3$export$7a6f238067628c6b(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    const unwatcher = $e0be213f695400f3$export$ad30f661f41f4d90(ref, ()=>{});
    $e0be213f695400f3$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $e0be213f695400f3$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$e0be213f695400f3$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest('q', {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$e0be213f695400f3$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest('echo', {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
$e0be213f695400f3$var$Connection;
/**
 * @internal
 */ const $e0be213f695400f3$export$3f9782a4529ff160 = function(newHash) {
    const oldPut = $e0be213f695400f3$var$PersistentConnection.prototype.put;
    $e0be213f695400f3$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $e0be213f695400f3$var$PersistentConnection.prototype.put = oldPut;
    };
};
$e0be213f695400f3$var$RepoInfo;
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 * @internal
 */ const $e0be213f695400f3$export$868c9f20a76f0839 = function(forceRestClient) {
    $e0be213f695400f3$var$repoManagerForceRestClient(forceRestClient);
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 * @internal
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAppCheckImpl - custom app check implementation
 * @param customAuthImpl - custom auth implementation
 */ function $e0be213f695400f3$export$8efb8ed30f837963({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, customAppCheckImpl: customAppCheckImpl, nodeAdmin: nodeAdmin = false }) {
    $e0be213f695400f3$export$c9fb972242fcb3c4(version);
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const componentContainer = new (0, $51d4719ad519d4e6$export$436a80eea5d5c0c5)('database-standalone');
    const authProvider = new (0, $51d4719ad519d4e6$export$2881499e37b75b9a)('auth-internal', componentContainer);
    let appCheckProvider;
    if (customAppCheckImpl) {
        appCheckProvider = new (0, $51d4719ad519d4e6$export$2881499e37b75b9a)('app-check-internal', componentContainer);
        appCheckProvider.setComponent(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('app-check-internal', ()=>customAppCheckImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    }
    authProvider.setComponent(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('auth-internal', ()=>customAuthImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    return $e0be213f695400f3$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin);
}
/**
 * Firebase Realtime Database
 *
 * @packageDocumentation
 */ $e0be213f695400f3$var$registerDatabase();





var $kSbwP = parcelRequire("kSbwP");
var $46a03b660b5bd4f2$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, $46a03b660b5bd4f2$exports) {
        classNames.default = classNames;
        $46a03b660b5bd4f2$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $T5IcR = parcelRequire("T5IcR");

var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");

var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");
if (!(0, $8nGP5.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $T5IcR.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");



var $fCKK7 = parcelRequire("fCKK7");


var $fCKK7 = parcelRequire("fCKK7");

var $T5IcR = parcelRequire("T5IcR");
function $04e1e07904e764d2$export$fb2daceae6f5097a(callback) {
    callback();
}
function $04e1e07904e764d2$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $04e1e07904e764d2$export$fb2daceae6f5097a;
    (0, $T5IcR.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $04e1e07904e764d2$export$13ce1459b9a04b51 = function() {
    return true;
};


var $3e59fecb0d88b31d$var$deprecatedMessages = [];
function $3e59fecb0d88b31d$export$be38475be17599d(msg) {
    if (!$3e59fecb0d88b31d$var$deprecatedMessages.includes(msg)) {
        $3e59fecb0d88b31d$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");

var $T5IcR = parcelRequire("T5IcR");
function $a5424f759636f4e4$export$ef795f1f307682c7(v) {
    return (0, $T5IcR.getDependencyTree)(v);
}


var $7868f6b5814ed075$var$globalIsUsingStaticRendering = false;
function $7868f6b5814ed075$export$5d52eaa7c0f24c9e(enable) {
    $7868f6b5814ed075$var$globalIsUsingStaticRendering = enable;
}
function $7868f6b5814ed075$export$55979271896d643e() {
    return $7868f6b5814ed075$var$globalIsUsingStaticRendering;
}


var $96c77d0362f1be72$export$e901ba0ffe10ba41 = 10000;
var $96c77d0362f1be72$export$1ae22ce5a82f26b6 = 10000;
var $96c77d0362f1be72$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $96c77d0362f1be72$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $96c77d0362f1be72$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $96c77d0362f1be72$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $96c77d0362f1be72$export$b7a00d372cedeedd;


var $83cd963e7e5a898f$export$10e8a12fbfd8583c = new (0, $96c77d0362f1be72$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $3c02d2fff4e333b2$exports = {};
'use strict';

$3c02d2fff4e333b2$exports = (parcelRequire("8wQss"));


function $4a5b43e92da5ca85$var$createReaction(adm) {
    adm.reaction = new (0, $T5IcR.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $4a5b43e92da5ca85$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $7868f6b5814ed075$export$55979271896d643e)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $83cd963e7e5a898f$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $4a5b43e92da5ca85$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $4a5b43e92da5ca85$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $83cd963e7e5a898f$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useDebugValue(adm.reaction, (0, $a5424f759636f4e4$export$ef795f1f307682c7));
    (0, $3c02d2fff4e333b2$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $8nGP5 = parcelRequire("8nGP5");


var $63b20c62c820efaa$var$_a, $63b20c62c820efaa$var$_b;
var $63b20c62c820efaa$var$warnObserverOptionsDeprecated = true;
var $63b20c62c820efaa$var$warnLegacyContextTypes = true;
var $63b20c62c820efaa$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $63b20c62c820efaa$var$isFunctionNameConfigurable = ($63b20c62c820efaa$var$_b = ($63b20c62c820efaa$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $63b20c62c820efaa$var$_a === void 0 ? void 0 : $63b20c62c820efaa$var$_a.configurable) !== null && $63b20c62c820efaa$var$_b !== void 0 ? $63b20c62c820efaa$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $63b20c62c820efaa$var$ReactForwardRefSymbol = $63b20c62c820efaa$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $8nGP5.forwardRef) === "function" && (0, $8nGP5.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $63b20c62c820efaa$var$ReactMemoSymbol = $63b20c62c820efaa$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $8nGP5.memo) === "function" && (0, $8nGP5.memo)(function(props) {
    return null;
})["$$typeof"];
function $63b20c62c820efaa$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($63b20c62c820efaa$var$ReactMemoSymbol && baseComponent["$$typeof"] === $63b20c62c820efaa$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $7868f6b5814ed075$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($63b20c62c820efaa$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $63b20c62c820efaa$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $4a5b43e92da5ca85$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($63b20c62c820efaa$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $8nGP5.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $8nGP5.memo)(observerComponent);
    $63b20c62c820efaa$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $63b20c62c820efaa$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $63b20c62c820efaa$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$63b20c62c820efaa$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $9c6adcb1334d9dc7$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $4a5b43e92da5ca85$export$b9c7ecd090a87b14)(component);
}
$9c6adcb1334d9dc7$export$c1cbdee04e18ea8b.displayName = "Observer";
function $9c6adcb1334d9dc7$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");
function $36369ea20a684a84$export$aa207039f277c5f(initializer, annotations) {
    return (0, $8nGP5.useState)(function() {
        return (0, $T5IcR.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");



var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");
function $b74889755f24c165$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $8nGP5.useState)(function() {
        return (0, $T5IcR.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $T5IcR.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $67aa88ac6b7f2881$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $b74889755f24c165$export$e0ded3646391939c)(current);
    return (0, $8nGP5.useState)(function() {
        return (0, $T5IcR.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $d620cb0f6f4ed8a5$var$_a;
(0, $04e1e07904e764d2$export$294943bbc3c74f4f)((0, $fCKK7.unstable_batchedUpdates));
var $d620cb0f6f4ed8a5$export$469d51fb8d268227 = ($d620cb0f6f4ed8a5$var$_a = (0, $83cd963e7e5a898f$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $d620cb0f6f4ed8a5$var$_a !== void 0 ? $d620cb0f6f4ed8a5$var$_a : function() {};
function $d620cb0f6f4ed8a5$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $4a5b43e92da5ca85$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $d620cb0f6f4ed8a5$export$7613124ee4202834(enable) {
    (0, $7868f6b5814ed075$export$5d52eaa7c0f24c9e)(enable);
}


function $f2729dedef021789$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($f2729dedef021789$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$f2729dedef021789$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $f2729dedef021789$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $f2729dedef021789$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $f2729dedef021789$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$f2729dedef021789$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $f2729dedef021789$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $f2729dedef021789$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $f2729dedef021789$var$getMixins(target, methodName) {
    var mixins = target[$f2729dedef021789$var$mobxMixins] = target[$f2729dedef021789$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $f2729dedef021789$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $f2729dedef021789$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $f2729dedef021789$var$wrapper.call.apply($f2729dedef021789$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $f2729dedef021789$var$patch(target, methodName, mixinMethod) {
    var mixins = $f2729dedef021789$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$f2729dedef021789$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $f2729dedef021789$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $f2729dedef021789$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $f2729dedef021789$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$f2729dedef021789$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $f2729dedef021789$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $f2729dedef021789$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $f2729dedef021789$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $f2729dedef021789$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $f2729dedef021789$var$observablePropDescriptors;
function $f2729dedef021789$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$f2729dedef021789$var$administrationSymbol]) != null ? _component$administra : component[$f2729dedef021789$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $f2729dedef021789$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $f2729dedef021789$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$f2729dedef021789$var$isMobXReactObserverSymbol]) {
        var displayName = $f2729dedef021789$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$f2729dedef021789$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $8nGP5.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $f2729dedef021789$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $f2729dedef021789$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $f2729dedef021789$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $7868f6b5814ed075$export$55979271896d643e)() ? originalRender : $f2729dedef021789$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        var _displayName2;
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $f2729dedef021789$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $83cd963e7e5a898f$export$10e8a12fbfd8583c).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $f2729dedef021789$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $7868f6b5814ed075$export$55979271896d643e)()) return;
        var admin = $f2729dedef021789$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $f2729dedef021789$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $f2729dedef021789$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $f2729dedef021789$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $f2729dedef021789$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $83cd963e7e5a898f$export$10e8a12fbfd8583c).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $T5IcR._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $f2729dedef021789$var$createReaction(admin) {
    return new (0, $T5IcR.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $f2729dedef021789$var$observerSCU(nextProps, nextState) {
    if ((0, $7868f6b5814ed075$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$f2729dedef021789$var$shallowEqual(this.props, nextProps);
}
function $f2729dedef021789$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $f2729dedef021789$var$getAdministration(this);
            var derivation = (0, $T5IcR._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error("[mobx-react] Cannot read \"" + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $f2729dedef021789$var$getAdministration(this)[key] = value;
        }
    };
}
function $f2729dedef021789$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $8nGP5.Component), component) || Object.prototype.isPrototypeOf.call((0, $8nGP5.PureComponent), component)) // Class component
    return $f2729dedef021789$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $63b20c62c820efaa$export$b6ae1bc530f4c149)(component);
}
function $f2729dedef021789$var$_extends() {
    return $f2729dedef021789$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f2729dedef021789$var$_extends.apply(null, arguments);
}
function $f2729dedef021789$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $f2729dedef021789$var$_excluded = [
    "children"
];
var $f2729dedef021789$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createContext({});
function $f2729dedef021789$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $f2729dedef021789$var$_objectWithoutPropertiesLoose(props, $f2729dedef021789$var$_excluded);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useContext($f2729dedef021789$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useRef($f2729dedef021789$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($f2729dedef021789$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$f2729dedef021789$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $f2729dedef021789$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef(function(props, ref) {
        var newProps = $f2729dedef021789$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useContext($f2729dedef021789$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $f2729dedef021789$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $f2729dedef021789$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $f2729dedef021789$var$getInjectName(component, injectNames);
    return Injector;
}
function $f2729dedef021789$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $f2729dedef021789$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $f2729dedef021789$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $f2729dedef021789$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $f2729dedef021789$var$createStoreInjector($f2729dedef021789$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $f2729dedef021789$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).version.split(".")[0]);
var $f2729dedef021789$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $f2729dedef021789$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $f2729dedef021789$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $f2729dedef021789$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$f2729dedef021789$var$protoStoreKey] || [], this[$f2729dedef021789$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $f2729dedef021789$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $f2729dedef021789$export$4e749cb731da87a9(target, fn);
    });
    if (!$f2729dedef021789$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($f2729dedef021789$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $f2729dedef021789$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$f2729dedef021789$var$protoStoreKey] || !!target[$f2729dedef021789$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$f2729dedef021789$var$protoStoreKey] || (target[$f2729dedef021789$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$f2729dedef021789$var$instStoreKey] || (target[$f2729dedef021789$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $f2729dedef021789$var$patch(target, "componentWillUnmount", $f2729dedef021789$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $f2729dedef021789$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $T5IcR.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $f2729dedef021789$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $f2729dedef021789$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($f2729dedef021789$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $f2729dedef021789$var$getPreciseType(propValue) {
    var propType = $f2729dedef021789$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $f2729dedef021789$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $f2729dedef021789$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $T5IcR.untracked)(function() {
            if (allowNativeType) {
                if ($f2729dedef021789$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $T5IcR.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $T5IcR.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $T5IcR.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $f2729dedef021789$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $f2729dedef021789$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $f2729dedef021789$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $T5IcR.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $f2729dedef021789$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $f2729dedef021789$var$observableArray = /*#__PURE__*/ $f2729dedef021789$var$createObservableTypeCheckerCreator(false, "Array");
var $f2729dedef021789$var$observableArrayOf = /*#__PURE__*/ $f2729dedef021789$var$createObservableArrayOfTypeChecker.bind(null, false);
var $f2729dedef021789$var$observableMap = /*#__PURE__*/ $f2729dedef021789$var$createObservableTypeCheckerCreator(false, "Map");
var $f2729dedef021789$var$observableObject = /*#__PURE__*/ $f2729dedef021789$var$createObservableTypeCheckerCreator(false, "Object");
var $f2729dedef021789$var$arrayOrObservableArray = /*#__PURE__*/ $f2729dedef021789$var$createObservableTypeCheckerCreator(true, "Array");
var $f2729dedef021789$var$arrayOrObservableArrayOf = /*#__PURE__*/ $f2729dedef021789$var$createObservableArrayOfTypeChecker.bind(null, true);
var $f2729dedef021789$var$objectOrObservableObject = /*#__PURE__*/ $f2729dedef021789$var$createObservableTypeCheckerCreator(true, "Object");
var $f2729dedef021789$export$e0c95a451cd220b7 = {
    observableArray: $f2729dedef021789$var$observableArray,
    observableArrayOf: $f2729dedef021789$var$observableArrayOf,
    observableMap: $f2729dedef021789$var$observableMap,
    observableObject: $f2729dedef021789$var$observableObject,
    arrayOrObservableArray: $f2729dedef021789$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $f2729dedef021789$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $f2729dedef021789$var$objectOrObservableObject
};
if (!(0, $8nGP5.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $T5IcR.observable)) throw new Error("mobx-react requires mobx to be available");



var $8nGP5 = parcelRequire("8nGP5");
// Components

var $8tsi7 = parcelRequire("8tsi7");

var $8nGP5 = parcelRequire("8nGP5");

var $8tsi7 = parcelRequire("8tsi7");
var $95134dd252a1c141$exports = {};
var $84e62c9181c3ad9d$exports = {};

var $1XeFJ = parcelRequire("1XeFJ");
var $84e62c9181c3ad9d$var$_typeof = $1XeFJ.default;
var $e9fef0b183b3ed16$exports = {};

var $1XeFJ = parcelRequire("1XeFJ");
var $e9fef0b183b3ed16$var$_typeof = $1XeFJ.default;
function $e9fef0b183b3ed16$var$toPrimitive(t, r) {
    if ("object" != $e9fef0b183b3ed16$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e9fef0b183b3ed16$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$e9fef0b183b3ed16$exports = $e9fef0b183b3ed16$var$toPrimitive, $e9fef0b183b3ed16$exports.__esModule = true, $e9fef0b183b3ed16$exports["default"] = $e9fef0b183b3ed16$exports;


function $84e62c9181c3ad9d$var$toPropertyKey(t) {
    var i = $e9fef0b183b3ed16$exports(t, "string");
    return "symbol" == $84e62c9181c3ad9d$var$_typeof(i) ? i : i + "";
}
$84e62c9181c3ad9d$exports = $84e62c9181c3ad9d$var$toPropertyKey, $84e62c9181c3ad9d$exports.__esModule = true, $84e62c9181c3ad9d$exports["default"] = $84e62c9181c3ad9d$exports;


function $95134dd252a1c141$var$_defineProperty(e, r, t) {
    return (r = $84e62c9181c3ad9d$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$95134dd252a1c141$exports = $95134dd252a1c141$var$_defineProperty, $95134dd252a1c141$exports.__esModule = true, $95134dd252a1c141$exports["default"] = $95134dd252a1c141$exports;


var $087fe1b2c8dfed8f$exports = {};

var $68UY6 = parcelRequire("68UY6");
function $087fe1b2c8dfed8f$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $68UY6(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$087fe1b2c8dfed8f$exports = $087fe1b2c8dfed8f$var$_objectWithoutProperties, $087fe1b2c8dfed8f$exports.__esModule = true, $087fe1b2c8dfed8f$exports["default"] = $087fe1b2c8dfed8f$exports;


var $6fe20d3196595522$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $6fe20d3196595522$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $6fe20d3196595522$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $6fe20d3196595522$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $6fe20d3196595522$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $6fe20d3196595522$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6fe20d3196595522$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6fe20d3196595522$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6fe20d3196595522$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $6fe20d3196595522$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $6fe20d3196595522$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $6fe20d3196595522$var$root = $6fe20d3196595522$var$freeGlobal || $6fe20d3196595522$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $6fe20d3196595522$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6fe20d3196595522$var$objectToString = $6fe20d3196595522$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6fe20d3196595522$var$nativeMax = Math.max, $6fe20d3196595522$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6fe20d3196595522$var$now = function() {
    return $6fe20d3196595522$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $6fe20d3196595522$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($6fe20d3196595522$var$FUNC_ERROR_TEXT);
    wait = $6fe20d3196595522$var$toNumber(wait) || 0;
    if ($6fe20d3196595522$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $6fe20d3196595522$var$nativeMax($6fe20d3196595522$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $6fe20d3196595522$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $6fe20d3196595522$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($6fe20d3196595522$var$now());
    }
    function debounced() {
        var time = $6fe20d3196595522$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6fe20d3196595522$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6fe20d3196595522$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6fe20d3196595522$var$isSymbol(value) {
    return typeof value == 'symbol' || $6fe20d3196595522$var$isObjectLike(value) && $6fe20d3196595522$var$objectToString.call(value) == $6fe20d3196595522$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6fe20d3196595522$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6fe20d3196595522$var$isSymbol(value)) return $6fe20d3196595522$var$NAN;
    if ($6fe20d3196595522$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $6fe20d3196595522$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($6fe20d3196595522$var$reTrim, '');
    var isBinary = $6fe20d3196595522$var$reIsBinary.test(value);
    return isBinary || $6fe20d3196595522$var$reIsOctal.test(value) ? $6fe20d3196595522$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6fe20d3196595522$var$reIsBadHex.test(value) ? $6fe20d3196595522$var$NAN : +value;
}
$6fe20d3196595522$exports = $6fe20d3196595522$var$debounce;



var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
function $178a7eb43675e020$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $8nGP5.useReducer)((state)=>!state, false);
    return dispatch;
}



var $8nGP5 = parcelRequire("8nGP5");
function $2d88d745050e62ad$export$2e2bcd8739ae039(value) {
    const ref = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}




var $ebCsu = parcelRequire("ebCsu");
var $6c473702788b87ec$export$54df5a921294d7ab = [
    'justify',
    'left',
    'right'
];
var $6c473702788b87ec$export$365087e449b345ed = 'label';
var $6c473702788b87ec$export$57732b6846a8df7c = [
    'lg',
    'sm'
];


var $250d2e1099d426ec$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $250d2e1099d426ec$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$250d2e1099d426ec$exports = $250d2e1099d426ec$var$invariant;



function $da50cc31c0eb58b8$export$2e2bcd8739ae039(labelKey) {
    return typeof labelKey === 'string' ? labelKey : (0, $6c473702788b87ec$export$365087e449b345ed);
}


/**
 * Check if an object has the given property in a type-safe way.
 */ function $b99951bb5143ac83$export$2e2bcd8739ae039(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}


var $a3d838f9b379d079$var$idCounter = 0;
function $a3d838f9b379d079$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $a3d838f9b379d079$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $a3d838f9b379d079$export$8793edee2d425525() {}
function $a3d838f9b379d079$export$357523c63a2253b9(obj, keys) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {};
    keys.forEach(function(key) {
        result[key] = obj[key];
    });
    return result;
}
function $a3d838f9b379d079$export$8b15d37bc3f197d4(prefix) {
    $a3d838f9b379d079$var$idCounter += 1;
    return (prefix == null ? '' : String(prefix)) + $a3d838f9b379d079$var$idCounter;
}


/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */ function $ebf6e7a66fd060c3$var$getOptionLabel(option, labelKey) {
    // Handle internally created options first.
    if (!(0, $a3d838f9b379d079$export$844ec244b1367d54)(option) && ((0, $b99951bb5143ac83$export$2e2bcd8739ae039)(option, 'paginationOption') || (0, $b99951bb5143ac83$export$2e2bcd8739ae039)(option, 'customOption'))) return option[(0, $da50cc31c0eb58b8$export$2e2bcd8739ae039)(labelKey)];
    var optionLabel;
    if ((0, $a3d838f9b379d079$export$f6e2535fb5126e54)(labelKey)) optionLabel = labelKey(option);
    else if ((0, $a3d838f9b379d079$export$844ec244b1367d54)(option)) optionLabel = option;
    else // `option` is an object and `labelKey` is a string.
    optionLabel = option[labelKey];
    !(0, $a3d838f9b379d079$export$844ec244b1367d54)(optionLabel) && (0, (/*@__PURE__*/$parcel$interopDefault($250d2e1099d426ec$exports)))(false);
    return optionLabel;
}
var $ebf6e7a66fd060c3$export$2e2bcd8739ae039 = $ebf6e7a66fd060c3$var$getOptionLabel;



function $7d5137151550c1bc$var$addCustomOption(results, props) {
    var allowNew = props.allowNew, labelKey = props.labelKey, text = props.text;
    if (!allowNew || !text.trim()) return false;
    // If the consumer has provided a callback, use that to determine whether or
    // not to add the custom option.
    if ((0, $a3d838f9b379d079$export$f6e2535fb5126e54)(allowNew)) return allowNew(results, props);
    // By default, don't add the custom option if there is an exact text match
    // with an existing option.
    return !results.some(function(o) {
        return (0, $ebf6e7a66fd060c3$export$2e2bcd8739ae039)(o, labelKey) === text;
    });
}
var $7d5137151550c1bc$export$2e2bcd8739ae039 = $7d5137151550c1bc$var$addCustomOption;


var $60aa457c0b214a25$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$60aa457c0b214a25$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



function $65c8a734025a1eb8$export$2e2bcd8739ae039(option, key) {
    if ((0, $a3d838f9b379d079$export$844ec244b1367d54)(option)) return undefined;
    return option[key];
}



// prettier-ignore
var $1410a28c84b417d5$var$map = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'OE',
        letters: "\x8C\u0152"
    },
    {
        base: 'oe',
        letters: "\x9C\u0153"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
].reduce(function(acc, _ref) {
    var base = _ref.base, letters = _ref.letters;
    letters.split('').forEach(function(letter) {
        acc[letter] = base;
    });
    return acc;
}, {});
// Combining marks
var $1410a28c84b417d5$var$latin = "\u0300-\u036F";
var $1410a28c84b417d5$var$japanese = "\u3099\u309A";
function $1410a28c84b417d5$export$2e2bcd8739ae039(str) {
    return str.normalize('NFD')// Remove combining diacritics
    .replace(new RegExp("[".concat($1410a28c84b417d5$var$latin).concat($1410a28c84b417d5$var$japanese, "]"), 'g'), '')/* eslint-disable-next-line no-control-regex */ .replace(/[^\u0000-\u007E]/g, function(a) {
        return $1410a28c84b417d5$var$map[a] || a;
    });
}


var $ced47db6f467fbae$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ced47db6f467fbae$var$__DEV__ = false;
var $ced47db6f467fbae$var$warning = function() {};
if ($ced47db6f467fbae$var$__DEV__) {
    var $ced47db6f467fbae$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ced47db6f467fbae$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ced47db6f467fbae$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ced47db6f467fbae$exports = $ced47db6f467fbae$var$warning;


var $7984d358c14bcc13$var$warned = {};
function $7984d358c14bcc13$export$2e2bcd8739ae039(falseToWarn, message) {
    // Only issue deprecation warnings once.
    if (!falseToWarn && message.indexOf('deprecated') !== -1) {
        if ($7984d358c14bcc13$var$warned[message]) return;
        $7984d358c14bcc13$var$warned[message] = true;
    }
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    (0, (/*@__PURE__*/$parcel$interopDefault($ced47db6f467fbae$exports))).apply(void 0, [
        falseToWarn,
        "[react-bootstrap-typeahead] ".concat(message)
    ].concat(args));
}
function $7984d358c14bcc13$export$60eef1277fe463e4() {
    $7984d358c14bcc13$var$warned = {};
}


function $71833fbe0ef759ba$var$isMatch(input, string, props) {
    var searchStr = input;
    var str = string;
    if (!props.caseSensitive) {
        searchStr = searchStr.toLowerCase();
        str = str.toLowerCase();
    }
    if (props.ignoreDiacritics) {
        searchStr = (0, $1410a28c84b417d5$export$2e2bcd8739ae039)(searchStr);
        str = (0, $1410a28c84b417d5$export$2e2bcd8739ae039)(str);
    }
    return str.indexOf(searchStr) !== -1;
}
function $71833fbe0ef759ba$export$2e2bcd8739ae039(option, props) {
    var filterBy = props.filterBy, labelKey = props.labelKey, multiple = props.multiple, selected = props.selected, text = props.text;
    // Don't show selected options in the menu for the multi-select case.
    if (multiple && selected.some(function(o) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($60aa457c0b214a25$exports)))(o, option);
    })) return false;
    if ((0, $a3d838f9b379d079$export$f6e2535fb5126e54)(labelKey)) return $71833fbe0ef759ba$var$isMatch(text, labelKey(option), props);
    var fields = filterBy.slice();
    if ((0, $a3d838f9b379d079$export$844ec244b1367d54)(labelKey)) // Add the `labelKey` field to the list of fields if it isn't already there.
    {
        if (fields.indexOf(labelKey) === -1) fields.unshift(labelKey);
    }
    if ((0, $a3d838f9b379d079$export$844ec244b1367d54)(option)) {
        (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');
        return $71833fbe0ef759ba$var$isMatch(text, option, props);
    }
    return fields.some(function(field) {
        var value = (0, $65c8a734025a1eb8$export$2e2bcd8739ae039)(option, field);
        if (!(0, $a3d838f9b379d079$export$844ec244b1367d54)(value)) {
            (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(false, "Fields passed to `filterBy` should have string values. Value will be converted to a string; results may be unexpected.");
            value = String(value);
        }
        return $71833fbe0ef759ba$var$isMatch(text, value, props);
    });
}


/**
 * Check if an input type is selectable, based on WHATWG spec.
 *
 * See:
 *  - https://stackoverflow.com/questions/21177489/selectionstart-selectionend-on-input-type-number-no-longer-allowed-in-chrome/24175357
 *  - https://html.spec.whatwg.org/multipage/input.html#do-not-apply
 */ function $209c555ea6334353$export$2e2bcd8739ae039(inputNode) {
    return inputNode.selectionStart != null;
}


function $e27c6e850cb98467$export$2e2bcd8739ae039(e, selectHint) {
    var shouldSelectHint = false;
    if (e.key === 'ArrowRight') // For selectable input types ("text", "search"), only select the hint if
    // it's at the end of the input value. For non-selectable types ("email",
    // "number"), always select the hint.
    shouldSelectHint = (0, $209c555ea6334353$export$2e2bcd8739ae039)(e.currentTarget) ? e.currentTarget.selectionStart === e.currentTarget.value.length : true;
    if (e.key === 'Tab') {
        // Prevent input from blurring on TAB.
        e.preventDefault();
        shouldSelectHint = true;
    }
    return selectHint ? selectHint(shouldSelectHint, e) : shouldSelectHint;
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0152309507841af0$export$2e2bcd8739ae039(Component) {
    return Component.displayName || Component.name || 'Component';
}




var $143ebf005b87c2cf$var$CASE_INSENSITIVE = 'i';
var $143ebf005b87c2cf$var$COMBINING_MARKS = /[\u0300-\u036F]/;
function $143ebf005b87c2cf$export$691f87e685a5fa78(str) {
    !(typeof str === 'string') && (0, (/*@__PURE__*/$parcel$interopDefault($250d2e1099d426ec$exports)))(false);
    // Escape characters with special meaning either inside or outside character
    // sets. Use a simple backslash escape when it’s always valid, and a \unnnn
    // escape when the simpler form would be disallowed by Unicode patterns’
    // stricter grammar.
    return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
function $143ebf005b87c2cf$export$2e2bcd8739ae039(subject, str) {
    var search = new RegExp($143ebf005b87c2cf$export$691f87e685a5fa78((0, $1410a28c84b417d5$export$2e2bcd8739ae039)(str)), $143ebf005b87c2cf$var$CASE_INSENSITIVE);
    var matches = search.exec((0, $1410a28c84b417d5$export$2e2bcd8739ae039)(subject));
    if (!matches) return null;
    var start = matches.index;
    var matchLength = matches[0].length;
    // Account for combining marks, which changes the indices.
    if ($143ebf005b87c2cf$var$COMBINING_MARKS.test(subject)) {
        // Starting at the beginning of the subject string, check for the number of
        // combining marks and increment the start index whenever one is found.
        for(var ii = 0; ii <= start; ii++)if ($143ebf005b87c2cf$var$COMBINING_MARKS.test(subject[ii])) start += 1;
        // Similarly, increment the length of the match string if it contains a
        // combining mark.
        for(var _ii = start; _ii <= start + matchLength; _ii++)if ($143ebf005b87c2cf$var$COMBINING_MARKS.test(subject[_ii])) matchLength += 1;
    }
    return {
        end: start + matchLength,
        start: start
    };
}





function $41f2e5951eb4ef0f$var$getHintText(_ref) {
    var activeIndex = _ref.activeIndex, initialItem = _ref.initialItem, isFocused = _ref.isFocused, isMenuShown = _ref.isMenuShown, labelKey = _ref.labelKey, multiple = _ref.multiple, selected = _ref.selected, text = _ref.text;
    // Don't display a hint under the following conditions:
    if (// No text entered.
    !text || // The input is not focused.
    !isFocused || // The menu is hidden.
    !isMenuShown || // No item in the menu.
    !initialItem || // The initial item is a custom option.
    !(0, $a3d838f9b379d079$export$844ec244b1367d54)(initialItem) && (0, $b99951bb5143ac83$export$2e2bcd8739ae039)(initialItem, 'customOption') || // The initial item is disabled
    !(0, $a3d838f9b379d079$export$844ec244b1367d54)(initialItem) && initialItem.disabled || // One of the menu items is active.
    activeIndex > -1 || // There's already a selection in single-select mode.
    !!selected.length && !multiple) return '';
    var initialItemStr = (0, $ebf6e7a66fd060c3$export$2e2bcd8739ae039)(initialItem, labelKey);
    var bounds = (0, $143ebf005b87c2cf$export$2e2bcd8739ae039)(initialItemStr.toLowerCase(), text.toLowerCase());
    if (!(bounds && bounds.start === 0)) return '';
    // Text matching is case- and accent-insensitive, so to display the hint
    // correctly, splice the input string with the hint string.
    return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}
var $41f2e5951eb4ef0f$export$2e2bcd8739ae039 = $41f2e5951eb4ef0f$var$getHintText;





function $86ef4837c81eb2fa$export$2e2bcd8739ae039() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var position = arguments.length > 1 ? arguments[1] : undefined;
    return "".concat(id, "-item-").concat(position);
}



var $e9b352b009bf69a4$var$_excluded = [
    "activeIndex",
    "id",
    "isFocused",
    "isMenuShown",
    "multiple",
    "onClick",
    "onFocus",
    "placeholder"
];
function $e9b352b009bf69a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e9b352b009bf69a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e9b352b009bf69a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e9b352b009bf69a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e9b352b009bf69a4$var$getInputProps = function getInputProps(_ref) {
    var activeIndex = _ref.activeIndex, id = _ref.id, isFocused = _ref.isFocused, isMenuShown = _ref.isMenuShown, multiple = _ref.multiple, onClick = _ref.onClick, onFocus = _ref.onFocus, placeholder = _ref.placeholder, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $e9b352b009bf69a4$var$_excluded);
    return function() {
        var _cx;
        var inputProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var className = (0, $b99951bb5143ac83$export$2e2bcd8739ae039)(inputProps, 'className') ? String(inputProps.className) : undefined;
        return $e9b352b009bf69a4$var$_objectSpread($e9b352b009bf69a4$var$_objectSpread($e9b352b009bf69a4$var$_objectSpread($e9b352b009bf69a4$var$_objectSpread({
            // These props can be overridden by values in `inputProps`.
            autoComplete: 'off',
            placeholder: placeholder,
            type: 'text'
        }, inputProps), props), {}, {
            'aria-activedescendant': activeIndex >= 0 ? (0, $86ef4837c81eb2fa$export$2e2bcd8739ae039)(id, activeIndex) : undefined,
            'aria-autocomplete': 'both',
            'aria-expanded': isMenuShown,
            'aria-haspopup': 'listbox',
            'aria-multiselectable': multiple || undefined,
            'aria-owns': isMenuShown ? id : undefined,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))((_cx = {}, (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(_cx, className || '', !multiple), (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(_cx, "focus", isFocused), _cx))
        }, multiple && {
            inputClassName: className
        }), {}, {
            onClick: onClick,
            onFocus: onFocus,
            role: 'combobox'
        });
    };
};
var $e9b352b009bf69a4$export$2e2bcd8739ae039 = $e9b352b009bf69a4$var$getInputProps;



function $240dbffda9d073ae$var$getInputText(props) {
    var activeItem = props.activeItem, labelKey = props.labelKey, multiple = props.multiple, selected = props.selected, text = props.text;
    if (activeItem) // Display the input value if the pagination item is active.
    return (0, $ebf6e7a66fd060c3$export$2e2bcd8739ae039)(activeItem, labelKey);
    if (!multiple && selected.length && selected[0]) return (0, $ebf6e7a66fd060c3$export$2e2bcd8739ae039)(selected[0], labelKey);
    return text;
}
var $240dbffda9d073ae$export$2e2bcd8739ae039 = $240dbffda9d073ae$var$getInputText;



function $f560059fa629c976$var$getIsOnlyResult(props) {
    var allowNew = props.allowNew, highlightOnlyResult = props.highlightOnlyResult, results = props.results;
    if (!highlightOnlyResult || allowNew) return false;
    return results.length === 1 && !(0, $65c8a734025a1eb8$export$2e2bcd8739ae039)(results[0], 'disabled');
}
var $f560059fa629c976$export$2e2bcd8739ae039 = $f560059fa629c976$var$getIsOnlyResult;







/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */ function $abd821bf9eb98a98$var$getTruncatedOptions(options, maxResults) {
    if (!maxResults || maxResults >= options.length) return options;
    return options.slice(0, maxResults);
}
var $abd821bf9eb98a98$export$2e2bcd8739ae039 = $abd821bf9eb98a98$var$getTruncatedOptions;



function $06978a837a109142$export$30acd1b3e7561a3(index, items) {
    var option = items[index];
    return !!option && !!(0, $65c8a734025a1eb8$export$2e2bcd8739ae039)(option, 'disabled');
}
function $06978a837a109142$export$3b2e82793fda938f(currentIndex, key, items) {
    var newIndex = currentIndex;
    while($06978a837a109142$export$30acd1b3e7561a3(newIndex, items))newIndex += key === 'ArrowUp' ? -1 : 1;
    return newIndex;
}
function $06978a837a109142$export$2e2bcd8739ae039(currentIndex, key, items) {
    var newIndex = currentIndex;
    // Increment or decrement index based on user keystroke.
    newIndex += key === 'ArrowUp' ? -1 : 1;
    // Skip over any disabled options.
    newIndex = $06978a837a109142$export$3b2e82793fda938f(newIndex, key, items);
    // If we've reached the end, go back to the beginning or vice-versa.
    if (newIndex === items.length) newIndex = -1;
    else if (newIndex === -2) {
        newIndex = items.length - 1;
        // Skip over any disabled options.
        newIndex = $06978a837a109142$export$3b2e82793fda938f(newIndex, key, items);
    }
    return newIndex;
}




function $dec4832be24b105d$export$2e2bcd8739ae039(_ref) {
    var open = _ref.open, minLength = _ref.minLength, showMenu = _ref.showMenu, text = _ref.text;
    // If menu visibility is controlled via props, that value takes precedence.
    if (open || open === false) return open;
    if (text.length < minLength) return false;
    return showMenu;
}



/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */ function $ad92d9f34ff3c43b$export$2e2bcd8739ae039(e) {
    e.preventDefault();
}





function $60191fc4983e8db4$export$650961c52e438122(size) {
    return size === 'lg';
}
function $60191fc4983e8db4$export$93100e6f8d8c0365(size) {
    return size === 'sm';
}


var $32a5c1e6fca9687b$var$_excluded = [
    "className",
    "isInvalid",
    "isValid",
    "size"
];
function $32a5c1e6fca9687b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32a5c1e6fca9687b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32a5c1e6fca9687b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32a5c1e6fca9687b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $32a5c1e6fca9687b$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, isInvalid = _ref.isInvalid, isValid = _ref.isValid, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $32a5c1e6fca9687b$var$_excluded);
    return $32a5c1e6fca9687b$var$_objectSpread($32a5c1e6fca9687b$var$_objectSpread({}, props), {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('form-control', 'rbt-input', {
            'form-control-lg': (0, $60191fc4983e8db4$export$650961c52e438122)(size),
            'form-control-sm': (0, $60191fc4983e8db4$export$93100e6f8d8c0365)(size),
            'is-invalid': isInvalid,
            'is-valid': isValid
        }, className)
    });
}





function $7c99b32e52379cfa$export$2e2bcd8739ae039(prevSelected, selected) {
    var uncontrolledToControlled = !prevSelected && selected;
    var controlledToUncontrolled = prevSelected && !selected;
    var from, to, precedent;
    if (uncontrolledToControlled) {
        from = 'uncontrolled';
        to = 'controlled';
        precedent = 'an';
    } else {
        from = 'controlled';
        to = 'uncontrolled';
        precedent = 'a';
    }
    var message = "You are changing ".concat(precedent, " ").concat(from, " typeahead to be ").concat(to, ". ") + "Input elements should not switch from ".concat(from, " to ").concat(to, " (or vice versa). ") + 'Decide between using a controlled or uncontrolled element for the ' + 'lifetime of the component.';
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(!(uncontrolledToControlled || controlledToUncontrolled), message);
}





var $1040560fbf61b9ca$var$INPUT_PROPS_BLACKLIST = [
    {
        alt: 'onBlur',
        prop: 'onBlur'
    },
    {
        alt: 'onInputChange',
        prop: 'onChange'
    },
    {
        alt: 'onFocus',
        prop: 'onFocus'
    },
    {
        alt: 'onKeyDown',
        prop: 'onKeyDown'
    }
];
var $1040560fbf61b9ca$export$9ae6167e9ee9e6d0 = (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOf((0, $6c473702788b87ec$export$57732b6846a8df7c));
function $1040560fbf61b9ca$export$1c8c72d28a0627d2(validator, callback) {
    return function(props, propName, componentName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).checkPropTypes((0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))({}, propName, validator), props, 'prop', componentName);
        (0, $a3d838f9b379d079$export$f6e2535fb5126e54)(callback) && callback(props, propName, componentName);
    };
}
function $1040560fbf61b9ca$export$8a831d0ae116fbcd(props) {
    var caseSensitive = props.caseSensitive, filterBy = props.filterBy;
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(!caseSensitive || typeof filterBy !== 'function', 'Your `filterBy` function will override the `caseSensitive` prop.');
}
function $1040560fbf61b9ca$export$cdd73fc4100a6ef4(validator, reason) {
    return function(props, propName, componentName) {
        if (props[propName] != null) (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(false, "The `".concat(propName, "` prop is deprecated. ").concat(reason));
        return (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).checkPropTypes((0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))({}, propName, validator), props, 'prop', componentName);
    };
}
function $1040560fbf61b9ca$export$5534cbfe725ae92a(props) {
    var defaultInputValue = props.defaultInputValue, defaultSelected = props.defaultSelected, multiple = props.multiple, selected = props.selected;
    var name = defaultSelected.length ? 'defaultSelected' : 'selected';
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), "`defaultInputValue` will be overridden by the value from `".concat(name, "`."));
}
function $1040560fbf61b9ca$export$79f4757fa6baab77(props) {
    var defaultSelected = props.defaultSelected, multiple = props.multiple;
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(multiple || defaultSelected.length <= 1, "You are passing multiple options to the `defaultSelected` prop of a Typeahead in single-select mode. The selections will be truncated to a single selection.");
}
function $1040560fbf61b9ca$export$f8e54140ea7ea3a8(_ref) {
    var allowNew = _ref.allowNew, highlightOnlyResult = _ref.highlightOnlyResult;
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(!(highlightOnlyResult && allowNew), '`highlightOnlyResult` will not work with `allowNew`.');
}
function $1040560fbf61b9ca$export$9b9aee2bc2e2973d(props) {
    var filterBy = props.filterBy, ignoreDiacritics = props.ignoreDiacritics;
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(ignoreDiacritics || typeof filterBy !== 'function', 'Your `filterBy` function will override the `ignoreDiacritics` prop.');
}
function $1040560fbf61b9ca$export$82c0eddbd071e45f(_ref2) {
    var inputProps = _ref2.inputProps;
    if (!(inputProps && Object.prototype.toString.call(inputProps) === '[object Object]')) return;
    // Blacklisted properties.
    $1040560fbf61b9ca$var$INPUT_PROPS_BLACKLIST.forEach(function(_ref3) {
        var alt = _ref3.alt, prop = _ref3.prop;
        var msg = alt ? " Use the top-level `".concat(alt, "` prop instead.") : null;
        (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(!inputProps[prop], "The `".concat(prop, "` property of `inputProps` will be ignored.").concat(msg));
    });
}
function $1040560fbf61b9ca$export$50bb8c440cf2a42c(props, propName, componentName) {
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(props[propName] != null, "The prop `".concat(propName, "` is required to make `").concat(componentName, "` ") + 'accessible for users of assistive technologies such as screen readers.');
}
function $1040560fbf61b9ca$export$8ae4524d34467ed5(_ref4) {
    var allowNew = _ref4.allowNew, labelKey = _ref4.labelKey;
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(!((0, $a3d838f9b379d079$export$f6e2535fb5126e54)(labelKey) && allowNew), '`labelKey` must be a string when `allowNew={true}`.');
}
var $1040560fbf61b9ca$export$7de5fae3688fa523 = (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
]);
function $1040560fbf61b9ca$export$1f1343c4475956f4(_ref5) {
    var multiple = _ref5.multiple, onChange = _ref5.onChange, selected = _ref5.selected;
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(multiple || !selected || selected.length <= 1, "You are passing multiple options to the `selected` prop of a Typeahead in single-select mode. This may lead to unexpected behaviors or errors.");
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(!selected || selected && (0, $a3d838f9b379d079$export$f6e2535fb5126e54)(onChange), "You provided a `selected` prop without an `onChange` handler. If you want the typeahead to be uncontrolled, use `defaultSelected`. Otherwise, set `onChange`.");
}



var $96080b5534c0b718$var$_excluded = [
    "allowNew",
    "delay",
    "emptyLabel",
    "isLoading",
    "minLength",
    "onInputChange",
    "onSearch",
    "options",
    "promptText",
    "searchText",
    "useCache"
];
function $96080b5534c0b718$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $96080b5534c0b718$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $96080b5534c0b718$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $96080b5534c0b718$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $96080b5534c0b718$var$propTypes = {
    /**
   * Delay, in milliseconds, before performing search.
   */ delay: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    /**
   * Whether or not a request is currently pending. Necessary for the
   * container to know when new results are available.
   */ isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool.isRequired,
    /**
   * Number of input characters that must be entered before showing results.
   */ minLength: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    /**
   * Callback to perform when the search is executed.
   */ onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func.isRequired,
    /**
   * Options to be passed to the typeahead. Will typically be the query
   * results, but can also be initial default options.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, $1040560fbf61b9ca$export$7de5fae3688fa523)),
    /**
   * Message displayed in the menu when there is no user input.
   */ promptText: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
    /**
   * Message displayed in the menu while the request is pending.
   */ searchText: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
    /**
   * Whether or not the component should cache query results.
   */ useCache: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool
};
function $96080b5534c0b718$export$cdf1dc76b55502e3(props) {
    var allowNew = props.allowNew, _props$delay = props.delay, delay = _props$delay === void 0 ? 200 : _props$delay, emptyLabel = props.emptyLabel, isLoading = props.isLoading, _props$minLength = props.minLength, minLength = _props$minLength === void 0 ? 2 : _props$minLength, onInputChange = props.onInputChange, onSearch = props.onSearch, _props$options = props.options, options = _props$options === void 0 ? [] : _props$options, _props$promptText = props.promptText, promptText = _props$promptText === void 0 ? 'Type to search...' : _props$promptText, _props$searchText = props.searchText, searchText = _props$searchText === void 0 ? 'Searching...' : _props$searchText, _props$useCache = props.useCache, useCache = _props$useCache === void 0 ? true : _props$useCache, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(props, $96080b5534c0b718$var$_excluded);
    var cacheRef = (0, $8nGP5.useRef)({});
    var handleSearchDebouncedRef = (0, $8nGP5.useRef)(null);
    var queryRef = (0, $8nGP5.useRef)(props.defaultInputValue || '');
    var forceUpdate = (0, $178a7eb43675e020$export$2e2bcd8739ae039)();
    var prevProps = (0, $2d88d745050e62ad$export$2e2bcd8739ae039)(props);
    var handleSearch = (0, $8nGP5.useCallback)(function(query) {
        queryRef.current = query;
        if (!query || minLength && query.length < minLength) return;
        // Use cached results, if applicable.
        if (useCache && cacheRef.current[query]) {
            // Re-render the component with the cached results.
            forceUpdate();
            return;
        }
        // Perform the search.
        onSearch(query);
    }, [
        forceUpdate,
        minLength,
        onSearch,
        useCache
    ]);
    // Set the debounced search function.
    (0, $8nGP5.useEffect)(function() {
        handleSearchDebouncedRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($6fe20d3196595522$exports)))(handleSearch, delay);
        return function() {
            handleSearchDebouncedRef.current && handleSearchDebouncedRef.current.cancel();
        };
    }, [
        delay,
        handleSearch
    ]);
    (0, $8nGP5.useEffect)(function() {
        // Ensure that we've gone from a loading to a completed state. Otherwise
        // an empty response could get cached if the component updates during the
        // request (eg: if the parent re-renders for some reason).
        if (!isLoading && prevProps && prevProps.isLoading && useCache) cacheRef.current[queryRef.current] = options;
    });
    var getEmptyLabel = function getEmptyLabel() {
        if (!queryRef.current.length) return promptText;
        if (isLoading) return searchText;
        return emptyLabel;
    };
    var handleInputChange = (0, $8nGP5.useCallback)(function(query, e) {
        onInputChange && onInputChange(query, e);
        handleSearchDebouncedRef.current && handleSearchDebouncedRef.current(query);
    }, [
        onInputChange
    ]);
    var cachedQuery = cacheRef.current[queryRef.current];
    return $96080b5534c0b718$var$_objectSpread($96080b5534c0b718$var$_objectSpread({}, otherProps), {}, {
        // Disable custom selections during a search if `allowNew` isn't a function.
        allowNew: (0, $a3d838f9b379d079$export$f6e2535fb5126e54)(allowNew) ? allowNew : allowNew && !isLoading,
        emptyLabel: getEmptyLabel(),
        isLoading: isLoading,
        minLength: minLength,
        onInputChange: handleInputChange,
        options: useCache && cachedQuery ? cachedQuery : options
    });
}
function $96080b5534c0b718$export$3523553ee0bc32a8(Component) {
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(false, "Warning: `withAsync` is deprecated and will be removed in the next major version. Use `useAsync` instead.");
    var AsyncTypeahead = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, $96080b5534c0b718$export$cdf1dc76b55502e3(props), {
            ref: ref
        }));
    });
    AsyncTypeahead.displayName = "withAsync(".concat((0, $0152309507841af0$export$2e2bcd8739ae039)(Component), ")");
    // @ts-ignore
    AsyncTypeahead.propTypes = $96080b5534c0b718$var$propTypes;
    return AsyncTypeahead;
}


var $face66a2b537e00d$exports = {};
function $face66a2b537e00d$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$face66a2b537e00d$exports = $face66a2b537e00d$var$_classCallCheck, $face66a2b537e00d$exports.__esModule = true, $face66a2b537e00d$exports["default"] = $face66a2b537e00d$exports;


var $2bd15c24945ea86e$exports = {};

function $2bd15c24945ea86e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $84e62c9181c3ad9d$exports(o.key), o);
    }
}
function $2bd15c24945ea86e$var$_createClass(e, r, t) {
    return r && $2bd15c24945ea86e$var$_defineProperties(e.prototype, r), t && $2bd15c24945ea86e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$2bd15c24945ea86e$exports = $2bd15c24945ea86e$var$_createClass, $2bd15c24945ea86e$exports.__esModule = true, $2bd15c24945ea86e$exports["default"] = $2bd15c24945ea86e$exports;


var $91b09f50e96287f6$exports = {};
function $91b09f50e96287f6$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$91b09f50e96287f6$exports = $91b09f50e96287f6$var$_assertThisInitialized, $91b09f50e96287f6$exports.__esModule = true, $91b09f50e96287f6$exports["default"] = $91b09f50e96287f6$exports;


var $0e1045ebe29aee70$exports = {};
var $01054b8d8aa533aa$exports = {};
function $01054b8d8aa533aa$var$_setPrototypeOf(t, e) {
    return $01054b8d8aa533aa$exports = $01054b8d8aa533aa$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $01054b8d8aa533aa$exports.__esModule = true, $01054b8d8aa533aa$exports["default"] = $01054b8d8aa533aa$exports, $01054b8d8aa533aa$var$_setPrototypeOf(t, e);
}
$01054b8d8aa533aa$exports = $01054b8d8aa533aa$var$_setPrototypeOf, $01054b8d8aa533aa$exports.__esModule = true, $01054b8d8aa533aa$exports["default"] = $01054b8d8aa533aa$exports;


function $0e1045ebe29aee70$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $01054b8d8aa533aa$exports(t, e);
}
$0e1045ebe29aee70$exports = $0e1045ebe29aee70$var$_inherits, $0e1045ebe29aee70$exports.__esModule = true, $0e1045ebe29aee70$exports["default"] = $0e1045ebe29aee70$exports;


var $2443e6812aa08435$exports = {};

var $1XeFJ = parcelRequire("1XeFJ");
var $2443e6812aa08435$var$_typeof = $1XeFJ.default;

function $2443e6812aa08435$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $2443e6812aa08435$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $91b09f50e96287f6$exports(t);
}
$2443e6812aa08435$exports = $2443e6812aa08435$var$_possibleConstructorReturn, $2443e6812aa08435$exports.__esModule = true, $2443e6812aa08435$exports["default"] = $2443e6812aa08435$exports;


var $c922f707fc099e1f$exports = {};
function $c922f707fc099e1f$var$_getPrototypeOf(t) {
    return $c922f707fc099e1f$exports = $c922f707fc099e1f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $c922f707fc099e1f$exports.__esModule = true, $c922f707fc099e1f$exports["default"] = $c922f707fc099e1f$exports, $c922f707fc099e1f$var$_getPrototypeOf(t);
}
$c922f707fc099e1f$exports = $c922f707fc099e1f$var$_getPrototypeOf, $c922f707fc099e1f$exports.__esModule = true, $c922f707fc099e1f$exports["default"] = $c922f707fc099e1f$exports;




var $8tsi7 = parcelRequire("8tsi7");


var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");

var $8tsi7 = parcelRequire("8tsi7");










var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $6254293de2d4ae9c$export$2fba198b5b2e37fa = {
    activeIndex: -1,
    hintText: '',
    id: '',
    initialItem: null,
    inputNode: null,
    isOnlyResult: false,
    onActiveItemChange: (0, $a3d838f9b379d079$export$8793edee2d425525),
    onAdd: (0, $a3d838f9b379d079$export$8793edee2d425525),
    onInitialItemChange: (0, $a3d838f9b379d079$export$8793edee2d425525),
    onMenuItemClick: (0, $a3d838f9b379d079$export$8793edee2d425525),
    setItem: (0, $a3d838f9b379d079$export$8793edee2d425525)
};
var $6254293de2d4ae9c$export$b86a312c9066f850 = /*#__PURE__*/ (0, $8nGP5.createContext)($6254293de2d4ae9c$export$2fba198b5b2e37fa);
var $6254293de2d4ae9c$export$20418b9b18662c6c = function useTypeaheadContext() {
    return (0, $8nGP5.useContext)($6254293de2d4ae9c$export$b86a312c9066f850);
};



function $ae313b405c37e897$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ae313b405c37e897$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ae313b405c37e897$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ae313b405c37e897$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ae313b405c37e897$var$inputPropKeys = [
    'activeIndex',
    'disabled',
    'id',
    'inputRef',
    'isFocused',
    'isMenuShown',
    'multiple',
    'onBlur',
    'onChange',
    'onClick',
    'onFocus',
    'onKeyDown',
    'placeholder'
];
var $ae313b405c37e897$var$propKeys = [
    'activeIndex',
    'hideMenu',
    'isMenuShown',
    'labelKey',
    'onClear',
    'onHide',
    'onRemove',
    'results',
    'selected',
    'text',
    'toggleMenu'
];
var $ae313b405c37e897$var$contextKeys = [
    'activeIndex',
    'id',
    'initialItem',
    'inputNode',
    'onActiveItemChange',
    'onAdd',
    'onInitialItemChange',
    'onMenuItemClick',
    'setItem'
];
var $ae313b405c37e897$var$TypeaheadManager = function TypeaheadManager(props) {
    var allowNew = props.allowNew, children = props.children, initialItem = props.initialItem, isMenuShown = props.isMenuShown, onAdd = props.onAdd, onInitialItemChange = props.onInitialItemChange, onKeyDown = props.onKeyDown, onMenuToggle = props.onMenuToggle, results = props.results, selectHint = props.selectHint;
    var hintText = (0, $41f2e5951eb4ef0f$export$2e2bcd8739ae039)(props);
    (0, $8nGP5.useEffect)(function() {
        // Clear the initial item when there are no results.
        if (!(allowNew || results.length)) onInitialItemChange();
    });
    var isInitialRender = (0, $8nGP5.useRef)(true);
    (0, $8nGP5.useEffect)(function() {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        onMenuToggle(isMenuShown);
    }, [
        isMenuShown,
        onMenuToggle
    ]);
    var handleKeyDown = function handleKeyDown(e) {
        onKeyDown(e);
        if (!initialItem) return;
        var addOnlyResult = e.key === 'Enter' && (0, $f560059fa629c976$export$2e2bcd8739ae039)(props);
        var shouldSelectHint = hintText && (0, $e27c6e850cb98467$export$2e2bcd8739ae039)(e, selectHint);
        if (addOnlyResult || shouldSelectHint) onAdd(initialItem);
    };
    var childProps = $ae313b405c37e897$var$_objectSpread($ae313b405c37e897$var$_objectSpread({}, (0, $a3d838f9b379d079$export$357523c63a2253b9)(props, $ae313b405c37e897$var$propKeys)), {}, {
        getInputProps: (0, $e9b352b009bf69a4$export$2e2bcd8739ae039)($ae313b405c37e897$var$_objectSpread($ae313b405c37e897$var$_objectSpread({}, (0, $a3d838f9b379d079$export$357523c63a2253b9)(props, $ae313b405c37e897$var$inputPropKeys)), {}, {
            onKeyDown: handleKeyDown,
            value: (0, $240dbffda9d073ae$export$2e2bcd8739ae039)(props)
        }))
    });
    var contextValue = $ae313b405c37e897$var$_objectSpread($ae313b405c37e897$var$_objectSpread({}, (0, $a3d838f9b379d079$export$357523c63a2253b9)(props, $ae313b405c37e897$var$contextKeys)), {}, {
        hintText: hintText,
        isOnlyResult: (0, $f560059fa629c976$export$2e2bcd8739ae039)(props)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $6254293de2d4ae9c$export$b86a312c9066f850).Provider, {
        value: contextValue
    }, (0, $a3d838f9b379d079$export$f6e2535fb5126e54)(children) ? children(childProps) : children);
};
var $ae313b405c37e897$export$2e2bcd8739ae039 = $ae313b405c37e897$var$TypeaheadManager;




function $ed38d1144f5ad269$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed38d1144f5ad269$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed38d1144f5ad269$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed38d1144f5ad269$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ed38d1144f5ad269$export$53ac33307b5acee9(props) {
    var defaultInputValue = props.defaultInputValue, defaultOpen = props.defaultOpen, defaultSelected = props.defaultSelected, maxResults = props.maxResults, multiple = props.multiple;
    var selected = props.selected ? props.selected.slice() : defaultSelected.slice();
    var text = defaultInputValue;
    if (!multiple && selected.length) {
        // Set the text if an initial selection is passed in.
        text = (0, $ebf6e7a66fd060c3$export$2e2bcd8739ae039)(selected[0], props.labelKey);
        if (selected.length > 1) // Limit to 1 selection in single-select mode.
        selected = selected.slice(0, 1);
    }
    return {
        activeIndex: -1,
        activeItem: undefined,
        initialItem: undefined,
        isFocused: false,
        selected: selected,
        showMenu: defaultOpen,
        shownResults: maxResults,
        text: text
    };
}
function $ed38d1144f5ad269$export$df98f41f85652e52(state, props) {
    return $ed38d1144f5ad269$var$_objectSpread($ed38d1144f5ad269$var$_objectSpread({}, $ed38d1144f5ad269$export$53ac33307b5acee9(props)), {}, {
        isFocused: state.isFocused,
        selected: [],
        text: ''
    });
}
function $ed38d1144f5ad269$export$81b416d1310f34c8(state) {
    return $ed38d1144f5ad269$var$_objectSpread($ed38d1144f5ad269$var$_objectSpread({}, state), {}, {
        isFocused: true,
        showMenu: true
    });
}
function $ed38d1144f5ad269$export$cdf0b0ed532145ff(state, props) {
    var _getInitialState = $ed38d1144f5ad269$export$53ac33307b5acee9(props), activeIndex = _getInitialState.activeIndex, activeItem = _getInitialState.activeItem, initialItem = _getInitialState.initialItem, shownResults = _getInitialState.shownResults;
    return $ed38d1144f5ad269$var$_objectSpread($ed38d1144f5ad269$var$_objectSpread({}, state), {}, {
        activeIndex: activeIndex,
        activeItem: activeItem,
        initialItem: initialItem,
        showMenu: false,
        shownResults: shownResults
    });
}
function $ed38d1144f5ad269$export$ac262bcf0e49db26(state, props) {
    return state.showMenu ? $ed38d1144f5ad269$export$cdf0b0ed532145ff(state, props) : $ed38d1144f5ad269$var$_objectSpread($ed38d1144f5ad269$var$_objectSpread({}, state), {}, {
        showMenu: true
    });
}





var $fa544beb6a77dc66$var$_excluded = [
    "onChange"
];
function $fa544beb6a77dc66$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa544beb6a77dc66$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa544beb6a77dc66$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa544beb6a77dc66$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fa544beb6a77dc66$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fa544beb6a77dc66$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($c922f707fc099e1f$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($c922f707fc099e1f$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($2443e6812aa08435$exports)))(this, result);
    };
}
function $fa544beb6a77dc66$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $fa544beb6a77dc66$var$propTypes = {
    /**
   * Allows the creation of new selections on the fly. Note that any new items
   * will be added to the list of selections, but not the list of original
   * options unless handled as such by `Typeahead`'s parent.
   *
   * If a function is specified, it will be used to determine whether a custom
   * option should be included. The return value should be true or false.
   */ allowNew: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    ]),
    /**
   * Autofocus the input when the component initially mounts.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Whether or not filtering should be case-sensitive.
   */ caseSensitive: (0, $1040560fbf61b9ca$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool, (0, $1040560fbf61b9ca$export$8a831d0ae116fbcd)),
    /**
   * The initial value displayed in the text input.
   */ defaultInputValue: (0, $1040560fbf61b9ca$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string, (0, $1040560fbf61b9ca$export$5534cbfe725ae92a)),
    /**
   * Whether or not the menu is displayed upon initial render.
   */ defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Specify any pre-selected options. Use only if you want the component to
   * be uncontrolled.
   */ defaultSelected: (0, $1040560fbf61b9ca$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, $1040560fbf61b9ca$export$7de5fae3688fa523)), (0, $1040560fbf61b9ca$export$79f4757fa6baab77)),
    /**
   * Either an array of fields in `option` to search, or a custom filtering
   * callback.
   */ filterBy: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string.isRequired),
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    ]),
    /**
   * Highlights the menu item if there is only one result and allows selecting
   * that item by hitting enter. Does not work with `allowNew`.
   */ highlightOnlyResult: (0, $1040560fbf61b9ca$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool, (0, $1040560fbf61b9ca$export$f8e54140ea7ea3a8)),
    /**
   * An html id attribute, required for assistive technologies such as screen
   * readers.
   */ id: (0, $1040560fbf61b9ca$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
    ]), (0, $1040560fbf61b9ca$export$50bb8c440cf2a42c)),
    /**
   * Whether the filter should ignore accents and other diacritical marks.
   */ ignoreDiacritics: (0, $1040560fbf61b9ca$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool, (0, $1040560fbf61b9ca$export$9b9aee2bc2e2973d)),
    /**
   * Specify the option key to use for display or a function returning the
   * display string. By default, the selector will use the `label` key.
   */ labelKey: (0, $1040560fbf61b9ca$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    ]), (0, $1040560fbf61b9ca$export$8ae4524d34467ed5)),
    /**
   * Maximum number of results to display by default. Mostly done for
   * performance reasons so as not to render too many DOM nodes in the case of
   * large data sets.
   */ maxResults: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    /**
   * Number of input characters that must be entered before showing results.
   */ minLength: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    /**
   * Whether or not multiple selections are allowed.
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Invoked when the input is blurred. Receives an event.
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked whenever items are added or removed. Receives an array of the
   * selected options.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked when the input is focused. Receives an event.
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked when the input value changes. Receives the string value of the
   * input.
   */ onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked when a key is pressed. Receives an event.
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked when menu visibility changes.
   */ onMenuToggle: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked when the pagination menu item is clicked. Receives an event.
   */ onPaginate: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Whether or not the menu should be displayed. `undefined` allows the
   * component to control visibility, while `true` and `false` show and hide
   * the menu, respectively.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Full set of options, including pre-selected options. Must either be an
   * array of objects (recommended) or strings.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, $1040560fbf61b9ca$export$7de5fae3688fa523)).isRequired,
    /**
   * Give user the ability to display additional results if the number of
   * results exceeds `maxResults`.
   */ paginate: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * The selected option(s) displayed in the input. Use this prop if you want
   * to control the component via its parent.
   */ selected: (0, $1040560fbf61b9ca$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, $1040560fbf61b9ca$export$7de5fae3688fa523)), (0, $1040560fbf61b9ca$export$1f1343c4475956f4))
};
var $fa544beb6a77dc66$var$defaultProps = {
    allowNew: false,
    autoFocus: false,
    caseSensitive: false,
    defaultInputValue: '',
    defaultOpen: false,
    defaultSelected: [],
    filterBy: [],
    highlightOnlyResult: false,
    ignoreDiacritics: true,
    labelKey: (0, $6c473702788b87ec$export$365087e449b345ed),
    maxResults: 100,
    minLength: 0,
    multiple: false,
    onBlur: (0, $a3d838f9b379d079$export$8793edee2d425525),
    onFocus: (0, $a3d838f9b379d079$export$8793edee2d425525),
    onInputChange: (0, $a3d838f9b379d079$export$8793edee2d425525),
    onKeyDown: (0, $a3d838f9b379d079$export$8793edee2d425525),
    onMenuToggle: (0, $a3d838f9b379d079$export$8793edee2d425525),
    onPaginate: (0, $a3d838f9b379d079$export$8793edee2d425525),
    paginate: true
};
/**
 * Manually trigger the input's change event.
 * https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js/46012210#46012210
 */ function $fa544beb6a77dc66$var$triggerInputChange(input, value) {
    var inputValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    inputValue && inputValue.set && inputValue.set.call(input, value);
    var e = new Event('input', {
        bubbles: true
    });
    input.dispatchEvent(e);
}
var $fa544beb6a77dc66$var$Typeahead = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($0e1045ebe29aee70$exports)))(Typeahead, _React$Component);
    var _super = $fa544beb6a77dc66$var$_createSuper(Typeahead);
    function Typeahead() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($face66a2b537e00d$exports)))(this, Typeahead);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "state", (0, $ed38d1144f5ad269$export$53ac33307b5acee9)(_this.props));
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "inputNode", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "isMenuShown", false);
        // Keeps track of actual items displayed in the menu, after sorting,
        // truncating, grouping, etc.
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "items", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "blur", function() {
            _this.inputNode && _this.inputNode.blur();
            _this.hideMenu();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "clear", function() {
            _this.setState((0, $ed38d1144f5ad269$export$df98f41f85652e52));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "focus", function() {
            _this.inputNode && _this.inputNode.focus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "getInput", function() {
            return _this.inputNode;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "inputRef", function(inputNode) {
            _this.inputNode = inputNode;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "setItem", function(item, position) {
            _this.items[position] = item;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "hideMenu", function() {
            _this.setState((0, $ed38d1144f5ad269$export$cdf0b0ed532145ff));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "toggleMenu", function() {
            _this.setState((0, $ed38d1144f5ad269$export$ac262bcf0e49db26));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleActiveIndexChange", function(activeIndex) {
            _this.setState(function(state) {
                return {
                    activeIndex: activeIndex,
                    activeItem: activeIndex >= 0 ? state.activeItem : undefined
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleActiveItemChange", function(activeItem) {
            // Don't update the active item if it hasn't changed.
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($60aa457c0b214a25$exports)))(activeItem, _this.state.activeItem)) _this.setState({
                activeItem: activeItem
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleBlur", function(e) {
            e.persist();
            _this.setState({
                isFocused: false
            }, function() {
                return _this.props.onBlur(e);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleChange", function(selected) {
            _this.props.onChange && _this.props.onChange(selected);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleClear", function() {
            _this.inputNode && $fa544beb6a77dc66$var$triggerInputChange(_this.inputNode, '');
            _this.setState((0, $ed38d1144f5ad269$export$df98f41f85652e52), function() {
                // Change handler is automatically triggered for single selections but
                // not multi-selections.
                if (_this.props.multiple) _this._handleChange([]);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleClick", function(e) {
            var _this$props$inputProp;
            e.persist();
            var onClick = (_this$props$inputProp = _this.props.inputProps) === null || _this$props$inputProp === void 0 ? void 0 : _this$props$inputProp.onClick;
            _this.setState((0, $ed38d1144f5ad269$export$81b416d1310f34c8), function() {
                return (0, $a3d838f9b379d079$export$f6e2535fb5126e54)(onClick) && onClick(e);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleFocus", function(e) {
            e.persist();
            _this.setState((0, $ed38d1144f5ad269$export$81b416d1310f34c8), function() {
                return _this.props.onFocus(e);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleInitialItemChange", function(initialItem) {
            // Don't update the initial item if it hasn't changed.
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($60aa457c0b214a25$exports)))(initialItem, _this.state.initialItem)) _this.setState({
                initialItem: initialItem
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleInputChange", function(e) {
            e.persist();
            var text = e.currentTarget.value;
            var _this$props = _this.props, multiple = _this$props.multiple, onInputChange = _this$props.onInputChange;
            // Clear selections when the input value changes in single-select mode.
            var shouldClearSelections = _this.state.selected.length && !multiple;
            _this.setState(function(state, props) {
                var _getInitialState = (0, $ed38d1144f5ad269$export$53ac33307b5acee9)(props), activeIndex = _getInitialState.activeIndex, activeItem = _getInitialState.activeItem, shownResults = _getInitialState.shownResults;
                return {
                    activeIndex: activeIndex,
                    activeItem: activeItem,
                    selected: shouldClearSelections ? [] : state.selected,
                    showMenu: true,
                    shownResults: shownResults,
                    text: text
                };
            }, function() {
                onInputChange(text, e);
                shouldClearSelections && _this._handleChange([]);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleKeyDown", function(e) {
            var activeItem = _this.state.activeItem;
            // Skip most actions when the menu is hidden.
            if (!_this.isMenuShown) {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') _this.setState({
                    showMenu: true
                });
                _this.props.onKeyDown(e);
                return;
            }
            switch(e.key){
                case 'ArrowUp':
                case 'ArrowDown':
                    // Prevent input cursor from going to the beginning when pressing up.
                    e.preventDefault();
                    _this._handleActiveIndexChange((0, $06978a837a109142$export$2e2bcd8739ae039)(_this.state.activeIndex, e.key, _this.items));
                    break;
                case 'Enter':
                    // Prevent form submission while menu is open.
                    e.preventDefault();
                    activeItem && _this._handleMenuItemSelect(activeItem, e);
                    break;
                case 'Escape':
                case 'Tab':
                    // ESC simply hides the menu. TAB will blur the input and move focus to
                    // the next item; hide the menu so it doesn't gain focus.
                    _this.hideMenu();
                    break;
                default:
                    break;
            }
            _this.props.onKeyDown(e);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleMenuItemSelect", function(option, e) {
            if ((0, $65c8a734025a1eb8$export$2e2bcd8739ae039)(option, 'paginationOption')) _this._handlePaginate(e);
            else _this._handleSelectionAdd(option);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handlePaginate", function(e) {
            e.persist();
            _this.setState(function(state, props) {
                return {
                    shownResults: state.shownResults + props.maxResults
                };
            }, function() {
                return _this.props.onPaginate(e, _this.state.shownResults);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleSelectionAdd", function(option) {
            var _this$props2 = _this.props, multiple = _this$props2.multiple, labelKey = _this$props2.labelKey;
            var selected;
            var selection = option;
            var text;
            // Add a unique id to the custom selection. Avoid doing this in `render` so
            // the id doesn't increment every time.
            if (!(0, $a3d838f9b379d079$export$844ec244b1367d54)(selection) && selection.customOption) selection = $fa544beb6a77dc66$var$_objectSpread($fa544beb6a77dc66$var$_objectSpread({}, selection), {}, {
                id: (0, $a3d838f9b379d079$export$8b15d37bc3f197d4)('new-id-')
            });
            if (multiple) {
                // If multiple selections are allowed, add the new selection to the
                // existing selections.
                selected = _this.state.selected.concat(selection);
                text = '';
            } else {
                // If only a single selection is allowed, replace the existing selection
                // with the new one.
                selected = [
                    selection
                ];
                text = (0, $ebf6e7a66fd060c3$export$2e2bcd8739ae039)(selection, labelKey);
            }
            _this.setState(function(state, props) {
                return $fa544beb6a77dc66$var$_objectSpread($fa544beb6a77dc66$var$_objectSpread({}, (0, $ed38d1144f5ad269$export$cdf0b0ed532145ff)(state, props)), {}, {
                    initialItem: selection,
                    selected: selected,
                    text: text
                });
            }, function() {
                return _this._handleChange(selected);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleSelectionRemove", function(selection) {
            var selected = _this.state.selected.filter(function(option) {
                return !(0, (/*@__PURE__*/$parcel$interopDefault($60aa457c0b214a25$exports)))(option, selection);
            });
            // Make sure the input stays focused after the item is removed.
            _this.focus();
            _this.setState(function(state, props) {
                return $fa544beb6a77dc66$var$_objectSpread($fa544beb6a77dc66$var$_objectSpread({}, (0, $ed38d1144f5ad269$export$cdf0b0ed532145ff)(state, props)), {}, {
                    selected: selected
                });
            }, function() {
                return _this._handleChange(selected);
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2bd15c24945ea86e$exports)))(Typeahead, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.autoFocus && this.focus();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props3 = this.props, labelKey = _this$props3.labelKey, multiple = _this$props3.multiple, selected = _this$props3.selected;
                (0, $7c99b32e52379cfa$export$2e2bcd8739ae039)(selected, prevProps.selected);
                // Sync selections in state with those in props.
                if (selected && !(0, (/*@__PURE__*/$parcel$interopDefault($60aa457c0b214a25$exports)))(selected, prevState.selected)) {
                    this.setState({
                        selected: selected
                    });
                    if (!multiple) this.setState({
                        text: selected.length ? (0, $ebf6e7a66fd060c3$export$2e2bcd8739ae039)(selected[0], labelKey) : ''
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, onChange = _this$props4.onChange, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_this$props4, $fa544beb6a77dc66$var$_excluded);
                var mergedPropsAndState = $fa544beb6a77dc66$var$_objectSpread($fa544beb6a77dc66$var$_objectSpread({}, props), this.state);
                var filterBy = mergedPropsAndState.filterBy, labelKey = mergedPropsAndState.labelKey, options = mergedPropsAndState.options, paginate = mergedPropsAndState.paginate, shownResults = mergedPropsAndState.shownResults, text = mergedPropsAndState.text;
                this.isMenuShown = (0, $dec4832be24b105d$export$2e2bcd8739ae039)(mergedPropsAndState);
                this.items = []; // Reset items on re-render.
                var results = [];
                if (this.isMenuShown) {
                    var cb = (0, $a3d838f9b379d079$export$f6e2535fb5126e54)(filterBy) ? filterBy : (0, $71833fbe0ef759ba$export$2e2bcd8739ae039);
                    results = options.filter(function(option) {
                        return cb(option, mergedPropsAndState);
                    });
                    // This must come before results are truncated.
                    var shouldPaginate = paginate && results.length > shownResults;
                    // Truncate results if necessary.
                    results = (0, $abd821bf9eb98a98$export$2e2bcd8739ae039)(results, shownResults);
                    // Add the custom option if necessary.
                    if ((0, $7d5137151550c1bc$export$2e2bcd8739ae039)(results, mergedPropsAndState)) results.push((0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))({
                        customOption: true
                    }, (0, $da50cc31c0eb58b8$export$2e2bcd8739ae039)(labelKey), text));
                    // Add the pagination item if necessary.
                    if (shouldPaginate) {
                        var _results$push2;
                        results.push((_results$push2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(_results$push2, (0, $da50cc31c0eb58b8$export$2e2bcd8739ae039)(labelKey), ''), (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(_results$push2, "paginationOption", true), _results$push2));
                    }
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ae313b405c37e897$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, mergedPropsAndState, {
                    hideMenu: this.hideMenu,
                    inputNode: this.inputNode,
                    inputRef: this.inputRef,
                    isMenuShown: this.isMenuShown,
                    onActiveItemChange: this._handleActiveItemChange,
                    onAdd: this._handleSelectionAdd,
                    onBlur: this._handleBlur,
                    onChange: this._handleInputChange,
                    onClear: this._handleClear,
                    onClick: this._handleClick,
                    onFocus: this._handleFocus,
                    onHide: this.hideMenu,
                    onInitialItemChange: this._handleInitialItemChange,
                    onKeyDown: this._handleKeyDown,
                    onMenuItemClick: this._handleMenuItemSelect,
                    onRemove: this._handleSelectionRemove,
                    results: results,
                    setItem: this.setItem,
                    toggleMenu: this.toggleMenu
                }));
            }
        }
    ]);
    return Typeahead;
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))($fa544beb6a77dc66$var$Typeahead, "propTypes", $fa544beb6a77dc66$var$propTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))($fa544beb6a77dc66$var$Typeahead, "defaultProps", $fa544beb6a77dc66$var$defaultProps);
var $fa544beb6a77dc66$export$2e2bcd8739ae039 = $fa544beb6a77dc66$var$Typeahead;



var $8tsi7 = parcelRequire("8tsi7");



var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");


var $653b17d7694cd265$var$_excluded = [
    "className",
    "label",
    "onClick",
    "onKeyDown",
    "size"
];
var $653b17d7694cd265$var$propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    size: (0, $1040560fbf61b9ca$export$9ae6167e9ee9e6d0)
};
/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */ var $653b17d7694cd265$var$ClearButton = function ClearButton(_ref) {
    var className = _ref.className, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Clear' : _ref$label, _onClick = _ref.onClick, _onKeyDown = _ref.onKeyDown, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $653b17d7694cd265$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('close', 'btn-close', 'rbt-close', {
            'rbt-close-lg': (0, $60191fc4983e8db4$export$650961c52e438122)(size),
            'rbt-close-sm': (0, $60191fc4983e8db4$export$93100e6f8d8c0365)(size)
        }, className),
        onClick: function onClick(e) {
            e.stopPropagation();
            _onClick && _onClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            // Prevent browser from navigating back.
            if (e.key === 'Backspace') e.preventDefault();
            _onKeyDown && _onKeyDown(e);
        },
        type: "button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
        "aria-hidden": "true",
        className: "rbt-close-content"
    }, "\xD7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
        className: "sr-only visually-hidden"
    }, label));
};
$653b17d7694cd265$var$ClearButton.propTypes = $653b17d7694cd265$var$propTypes;
var $653b17d7694cd265$export$2e2bcd8739ae039 = $653b17d7694cd265$var$ClearButton;





var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");
var $341beb83c8e86e5e$var$propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
};
var $341beb83c8e86e5e$var$Loader = function Loader(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loading...' : _ref$label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "rbt-loader spinner-border spinner-border-sm",
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
        className: "sr-only visually-hidden"
    }, label));
};
$341beb83c8e86e5e$var$Loader.propTypes = $341beb83c8e86e5e$var$propTypes;
var $341beb83c8e86e5e$export$2e2bcd8739ae039 = $341beb83c8e86e5e$var$Loader;






var $ebCsu = parcelRequire("ebCsu");
var $a74fbf0c8354a097$exports = {};
var $f0b3d55530c9f11c$exports = {};
function $f0b3d55530c9f11c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$f0b3d55530c9f11c$exports = $f0b3d55530c9f11c$var$_arrayWithHoles, $f0b3d55530c9f11c$exports.__esModule = true, $f0b3d55530c9f11c$exports["default"] = $f0b3d55530c9f11c$exports;


var $9a8c171e66b36989$exports = {};
function $9a8c171e66b36989$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$9a8c171e66b36989$exports = $9a8c171e66b36989$var$_iterableToArrayLimit, $9a8c171e66b36989$exports.__esModule = true, $9a8c171e66b36989$exports["default"] = $9a8c171e66b36989$exports;


var $47e6fce6f3313410$exports = {};
var $7e7cf0ecf06c2d08$exports = {};
function $7e7cf0ecf06c2d08$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$7e7cf0ecf06c2d08$exports = $7e7cf0ecf06c2d08$var$_arrayLikeToArray, $7e7cf0ecf06c2d08$exports.__esModule = true, $7e7cf0ecf06c2d08$exports["default"] = $7e7cf0ecf06c2d08$exports;


function $47e6fce6f3313410$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7e7cf0ecf06c2d08$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7e7cf0ecf06c2d08$exports(r, a) : void 0;
    }
}
$47e6fce6f3313410$exports = $47e6fce6f3313410$var$_unsupportedIterableToArray, $47e6fce6f3313410$exports.__esModule = true, $47e6fce6f3313410$exports["default"] = $47e6fce6f3313410$exports;


var $a8af1fc8a581bdd4$exports = {};
function $a8af1fc8a581bdd4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$a8af1fc8a581bdd4$exports = $a8af1fc8a581bdd4$var$_nonIterableRest, $a8af1fc8a581bdd4$exports.__esModule = true, $a8af1fc8a581bdd4$exports["default"] = $a8af1fc8a581bdd4$exports;


function $a74fbf0c8354a097$var$_slicedToArray(r, e) {
    return $f0b3d55530c9f11c$exports(r) || $9a8c171e66b36989$exports(r, e) || $47e6fce6f3313410$exports(r, e) || $a8af1fc8a581bdd4$exports();
}
$a74fbf0c8354a097$exports = $a74fbf0c8354a097$var$_slicedToArray, $a74fbf0c8354a097$exports.__esModule = true, $a74fbf0c8354a097$exports["default"] = $a74fbf0c8354a097$exports;


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $96ee0238679183f5$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $96ee0238679183f5$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $96ee0238679183f5$export$803cd8101b6c182b = /*#__PURE__*/ $96ee0238679183f5$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $96ee0238679183f5$export$27b07d8a310ed8b5[0], side + "-" + $96ee0238679183f5$export$27b07d8a310ed8b5[1]), []);
const $96ee0238679183f5$export$96ec731ed4dcb222 = Math.min;
const $96ee0238679183f5$export$8960430cfd85939f = Math.max;
const $96ee0238679183f5$export$2077e0241d6afd3c = Math.round;
const $96ee0238679183f5$export$a3fe094919f356fd = Math.floor;
const $96ee0238679183f5$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $96ee0238679183f5$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $96ee0238679183f5$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $96ee0238679183f5$export$7d15b64cf5a3a4c4(start, value, end) {
    return $96ee0238679183f5$export$8960430cfd85939f(start, $96ee0238679183f5$export$96ec731ed4dcb222(value, end));
}
function $96ee0238679183f5$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $96ee0238679183f5$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $96ee0238679183f5$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $96ee0238679183f5$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $96ee0238679183f5$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $96ee0238679183f5$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($96ee0238679183f5$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $96ee0238679183f5$export$2b57e0052a6d6d4c(placement) {
    return $96ee0238679183f5$export$8a000a963141ac32($96ee0238679183f5$export$f28e8f882010718a(placement));
}
function $96ee0238679183f5$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $96ee0238679183f5$export$f0989780f32bfcda(placement);
    const alignmentAxis = $96ee0238679183f5$export$2b57e0052a6d6d4c(placement);
    const length = $96ee0238679183f5$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $96ee0238679183f5$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $96ee0238679183f5$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $96ee0238679183f5$export$496432a3699e50b1(placement) {
    const oppositePlacement = $96ee0238679183f5$export$9c5e28bad23365fa(placement);
    return [
        $96ee0238679183f5$export$2b182c584985588b(placement),
        oppositePlacement,
        $96ee0238679183f5$export$2b182c584985588b(oppositePlacement)
    ];
}
function $96ee0238679183f5$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$96ee0238679183f5$var$oppositeAlignmentMap[alignment]);
}
function $96ee0238679183f5$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $96ee0238679183f5$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $96ee0238679183f5$export$f0989780f32bfcda(placement);
    let list = $96ee0238679183f5$var$getSideList($96ee0238679183f5$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($96ee0238679183f5$export$2b182c584985588b));
    }
    return list;
}
function $96ee0238679183f5$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$96ee0238679183f5$var$oppositeSideMap[side]);
}
function $96ee0238679183f5$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $96ee0238679183f5$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $96ee0238679183f5$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $96ee0238679183f5$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $477f7879101cfdb4$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $96ee0238679183f5$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $96ee0238679183f5$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $96ee0238679183f5$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $477f7879101cfdb4$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $477f7879101cfdb4$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $477f7879101cfdb4$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $477f7879101cfdb4$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $96ee0238679183f5$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $96ee0238679183f5$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $96ee0238679183f5$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $477f7879101cfdb4$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $96ee0238679183f5$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $96ee0238679183f5$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $96ee0238679183f5$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $96ee0238679183f5$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $96ee0238679183f5$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $477f7879101cfdb4$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $96ee0238679183f5$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $96ee0238679183f5$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $96ee0238679183f5$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $96ee0238679183f5$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $477f7879101cfdb4$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $96ee0238679183f5$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $96ee0238679183f5$export$803cd8101b6c182b) ? $477f7879101cfdb4$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $96ee0238679183f5$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $96ee0238679183f5$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $96ee0238679183f5$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $96ee0238679183f5$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $477f7879101cfdb4$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $96ee0238679183f5$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $96ee0238679183f5$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $96ee0238679183f5$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $96ee0238679183f5$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $477f7879101cfdb4$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $477f7879101cfdb4$var$isAnySideFullyClipped(overflow) {
    return (0, $96ee0238679183f5$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $477f7879101cfdb4$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $477f7879101cfdb4$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $477f7879101cfdb4$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $477f7879101cfdb4$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $477f7879101cfdb4$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $477f7879101cfdb4$var$getBoundingRect(rects) {
    const minX = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $96ee0238679183f5$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $96ee0238679183f5$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $477f7879101cfdb4$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $96ee0238679183f5$export$ee05aea0aeecbad4)($477f7879101cfdb4$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $477f7879101cfdb4$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $477f7879101cfdb4$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $96ee0238679183f5$export$ee05aea0aeecbad4)($477f7879101cfdb4$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $96ee0238679183f5$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $96ee0238679183f5$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $96ee0238679183f5$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $477f7879101cfdb4$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $96ee0238679183f5$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $96ee0238679183f5$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $477f7879101cfdb4$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $477f7879101cfdb4$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $477f7879101cfdb4$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)((0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $96ee0238679183f5$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $96ee0238679183f5$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $96ee0238679183f5$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $477f7879101cfdb4$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $96ee0238679183f5$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $477f7879101cfdb4$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $96ee0238679183f5$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $1dc0cfe62243c1a1$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $1dc0cfe62243c1a1$export$651544f548703224(node) {
    if ($1dc0cfe62243c1a1$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $1dc0cfe62243c1a1$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $1dc0cfe62243c1a1$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($1dc0cfe62243c1a1$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $1dc0cfe62243c1a1$export$8ee0fc9ee280b4ee(value) {
    if (!$1dc0cfe62243c1a1$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $1dc0cfe62243c1a1$export$38b2d434cce3ea22(value).Node;
}
function $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d(value) {
    if (!$1dc0cfe62243c1a1$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $1dc0cfe62243c1a1$export$38b2d434cce3ea22(value).Element;
}
function $1dc0cfe62243c1a1$export$1b3bfaa9684536aa(value) {
    if (!$1dc0cfe62243c1a1$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $1dc0cfe62243c1a1$export$38b2d434cce3ea22(value).HTMLElement;
}
function $1dc0cfe62243c1a1$export$af51f0f06c0f328a(value) {
    if (!$1dc0cfe62243c1a1$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $1dc0cfe62243c1a1$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $1dc0cfe62243c1a1$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $1dc0cfe62243c1a1$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $1dc0cfe62243c1a1$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($1dc0cfe62243c1a1$export$651544f548703224(element));
}
function $1dc0cfe62243c1a1$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $1dc0cfe62243c1a1$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $1dc0cfe62243c1a1$export$78551043582a6a98();
    const css = $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d(elementOrCss) ? $1dc0cfe62243c1a1$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $1dc0cfe62243c1a1$export$940d8225183e1404(element) {
    let currentNode = $1dc0cfe62243c1a1$export$4e12058fc4d51d56(element);
    while($1dc0cfe62243c1a1$export$1b3bfaa9684536aa(currentNode) && !$1dc0cfe62243c1a1$export$d1162fb0b6d4cd51(currentNode)){
        if ($1dc0cfe62243c1a1$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($1dc0cfe62243c1a1$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $1dc0cfe62243c1a1$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $1dc0cfe62243c1a1$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $1dc0cfe62243c1a1$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($1dc0cfe62243c1a1$export$651544f548703224(node));
}
function $1dc0cfe62243c1a1$export$3735103072e4a80(element) {
    return $1dc0cfe62243c1a1$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $1dc0cfe62243c1a1$export$dc8fc79fa2800137(element) {
    if ($1dc0cfe62243c1a1$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $1dc0cfe62243c1a1$export$4e12058fc4d51d56(node) {
    if ($1dc0cfe62243c1a1$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $1dc0cfe62243c1a1$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $1dc0cfe62243c1a1$export$e495491855dc5418(node);
    return $1dc0cfe62243c1a1$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $1dc0cfe62243c1a1$export$7cd01a57c8ca906c(node) {
    const parentNode = $1dc0cfe62243c1a1$export$4e12058fc4d51d56(node);
    if ($1dc0cfe62243c1a1$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($1dc0cfe62243c1a1$export$1b3bfaa9684536aa(parentNode) && $1dc0cfe62243c1a1$export$989e911fa9af580a(parentNode)) return parentNode;
    return $1dc0cfe62243c1a1$export$7cd01a57c8ca906c(parentNode);
}
function $1dc0cfe62243c1a1$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $1dc0cfe62243c1a1$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $1dc0cfe62243c1a1$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $1dc0cfe62243c1a1$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $1dc0cfe62243c1a1$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $1dc0cfe62243c1a1$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $1dc0cfe62243c1a1$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $1dc0cfe62243c1a1$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $322acf408b6b8401$var$getCssDimensions(element) {
    const css = (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $96ee0238679183f5$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $96ee0238679183f5$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $322acf408b6b8401$var$unwrapElement(element) {
    return !(0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $322acf408b6b8401$var$getScale(element) {
    const domElement = $322acf408b6b8401$var$unwrapElement(element);
    if (!(0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(domElement)) return (0, $96ee0238679183f5$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $322acf408b6b8401$var$getCssDimensions(domElement);
    let x = ($ ? (0, $96ee0238679183f5$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $96ee0238679183f5$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $322acf408b6b8401$var$noOffsets = /*#__PURE__*/ (0, $96ee0238679183f5$export$a397704b5e280835)(0);
function $322acf408b6b8401$var$getVisualOffsets(element) {
    const win = (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(element);
    if (!(0, $1dc0cfe62243c1a1$export$78551043582a6a98)() || !win.visualViewport) return $322acf408b6b8401$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $322acf408b6b8401$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $322acf408b6b8401$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $322acf408b6b8401$var$unwrapElement(element);
    let scale = (0, $96ee0238679183f5$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(offsetParent)) scale = $322acf408b6b8401$var$getScale(offsetParent);
        } else scale = $322acf408b6b8401$var$getScale(element);
    }
    const visualOffsets = $322acf408b6b8401$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $322acf408b6b8401$var$getVisualOffsets(domElement) : (0, $96ee0238679183f5$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $1dc0cfe62243c1a1$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $322acf408b6b8401$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $1dc0cfe62243c1a1$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $96ee0238679183f5$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $322acf408b6b8401$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $1dc0cfe62243c1a1$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $322acf408b6b8401$var$getBoundingClientRect((0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $322acf408b6b8401$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $322acf408b6b8401$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $322acf408b6b8401$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $1dc0cfe62243c1a1$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $1dc0cfe62243c1a1$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $96ee0238679183f5$export$a397704b5e280835)(1);
    const offsets = (0, $96ee0238679183f5$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1dc0cfe62243c1a1$export$651544f548703224)(offsetParent) !== 'body' || (0, $1dc0cfe62243c1a1$export$989e911fa9af580a)(documentElement)) scroll = (0, $1dc0cfe62243c1a1$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $322acf408b6b8401$var$getBoundingClientRect(offsetParent);
            scale = $322acf408b6b8401$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $322acf408b6b8401$var$getHTMLOffset(documentElement, scroll, true) : (0, $96ee0238679183f5$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $322acf408b6b8401$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $322acf408b6b8401$var$getDocumentRect(element) {
    const html = (0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element);
    const scroll = (0, $1dc0cfe62243c1a1$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $96ee0238679183f5$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $96ee0238679183f5$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $322acf408b6b8401$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1dc0cfe62243c1a1$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $96ee0238679183f5$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $322acf408b6b8401$var$getViewportRect(element, strategy) {
    const win = (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(element);
    const html = (0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1dc0cfe62243c1a1$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $322acf408b6b8401$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $322acf408b6b8401$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(element) ? $322acf408b6b8401$var$getScale(element) : (0, $96ee0238679183f5$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $322acf408b6b8401$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $322acf408b6b8401$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $322acf408b6b8401$var$getDocumentRect((0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element));
    else if ((0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $322acf408b6b8401$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $322acf408b6b8401$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $96ee0238679183f5$export$ee05aea0aeecbad4)(rect);
}
function $322acf408b6b8401$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1dc0cfe62243c1a1$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(parentNode) || (0, $1dc0cfe62243c1a1$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(parentNode).position === 'fixed' || $322acf408b6b8401$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $322acf408b6b8401$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1dc0cfe62243c1a1$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(el) && (0, $1dc0cfe62243c1a1$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $1dc0cfe62243c1a1$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(currentNode) && !(0, $1dc0cfe62243c1a1$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $1dc0cfe62243c1a1$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $1dc0cfe62243c1a1$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $322acf408b6b8401$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1dc0cfe62243c1a1$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $322acf408b6b8401$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $1dc0cfe62243c1a1$export$89e651af02346cd4)(element) ? [] : $322acf408b6b8401$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $322acf408b6b8401$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $96ee0238679183f5$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $96ee0238679183f5$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $322acf408b6b8401$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $322acf408b6b8401$var$getDimensions(element) {
    const { width: width, height: height } = $322acf408b6b8401$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $322acf408b6b8401$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $1dc0cfe62243c1a1$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $322acf408b6b8401$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $96ee0238679183f5$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1dc0cfe62243c1a1$export$651544f548703224)(offsetParent) !== 'body' || (0, $1dc0cfe62243c1a1$export$989e911fa9af580a)(documentElement)) scroll = (0, $1dc0cfe62243c1a1$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $322acf408b6b8401$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $322acf408b6b8401$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $322acf408b6b8401$var$getHTMLOffset(documentElement, scroll) : (0, $96ee0238679183f5$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $322acf408b6b8401$var$isStaticPositioned(element) {
    return (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(element).position === 'static';
}
function $322acf408b6b8401$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(element) || (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $322acf408b6b8401$var$getOffsetParent(element, polyfill) {
    const win = (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(element);
    if ((0, $1dc0cfe62243c1a1$export$89e651af02346cd4)(element)) return win;
    if (!(0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $1dc0cfe62243c1a1$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $1dc0cfe62243c1a1$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$322acf408b6b8401$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $1dc0cfe62243c1a1$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $322acf408b6b8401$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1dc0cfe62243c1a1$export$71535ffaa902797f)(offsetParent) && $322acf408b6b8401$var$isStaticPositioned(offsetParent))offsetParent = $322acf408b6b8401$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $1dc0cfe62243c1a1$export$d1162fb0b6d4cd51)(offsetParent) && $322acf408b6b8401$var$isStaticPositioned(offsetParent) && !(0, $1dc0cfe62243c1a1$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $1dc0cfe62243c1a1$export$940d8225183e1404)(element) || win;
}
const $322acf408b6b8401$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $322acf408b6b8401$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $322acf408b6b8401$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $322acf408b6b8401$var$isRTL(element) {
    return (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(element).direction === 'rtl';
}
const $322acf408b6b8401$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $322acf408b6b8401$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1dc0cfe62243c1a1$export$e495491855dc5418,
    getClippingRect: $322acf408b6b8401$var$getClippingRect,
    getOffsetParent: $322acf408b6b8401$var$getOffsetParent,
    getElementRects: $322acf408b6b8401$var$getElementRects,
    getClientRects: $322acf408b6b8401$var$getClientRects,
    getDimensions: $322acf408b6b8401$var$getDimensions,
    getScale: $322acf408b6b8401$var$getScale,
    isElement: $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d,
    isRTL: $322acf408b6b8401$var$isRTL
};
function $322acf408b6b8401$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $322acf408b6b8401$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $96ee0238679183f5$export$a3fe094919f356fd)(top);
        const insetRight = (0, $96ee0238679183f5$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $96ee0238679183f5$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $96ee0238679183f5$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $96ee0238679183f5$export$8960430cfd85939f)(0, (0, $96ee0238679183f5$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$322acf408b6b8401$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $322acf408b6b8401$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $322acf408b6b8401$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1dc0cfe62243c1a1$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $1dc0cfe62243c1a1$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $322acf408b6b8401$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $322acf408b6b8401$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $322acf408b6b8401$var$getBoundingClientRect(reference);
        if (prevRefRect && !$322acf408b6b8401$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $322acf408b6b8401$export$37b6bde19b108ecc = (0, $477f7879101cfdb4$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $322acf408b6b8401$export$cc800923e997bb8 = (0, $477f7879101cfdb4$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $322acf408b6b8401$export$91fb6ecbd551914 = (0, $477f7879101cfdb4$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $322acf408b6b8401$export$fba63a578e423eb = (0, $477f7879101cfdb4$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $322acf408b6b8401$export$8a83211c878a3f1f = (0, $477f7879101cfdb4$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $322acf408b6b8401$export$346677f925de839c = (0, $477f7879101cfdb4$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $322acf408b6b8401$export$fe8985bb6374093c = (0, $477f7879101cfdb4$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $322acf408b6b8401$export$f2120bbfa5450bd2 = (0, $477f7879101cfdb4$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $322acf408b6b8401$export$18c8ad048e32c7d5 = (0, $477f7879101cfdb4$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $322acf408b6b8401$export$7bf07e38f3dc4b69 = (0, $477f7879101cfdb4$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $322acf408b6b8401$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $322acf408b6b8401$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $477f7879101cfdb4$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $8nGP5 = parcelRequire("8nGP5");

var $fCKK7 = parcelRequire("fCKK7");
var $6bc90079d7900558$var$index = typeof document !== 'undefined' ? (0, $8nGP5.useLayoutEffect) : (0, $8nGP5.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $6bc90079d7900558$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$6bc90079d7900558$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$6bc90079d7900558$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $6bc90079d7900558$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $6bc90079d7900558$var$roundByDPR(element, value) {
    const dpr = $6bc90079d7900558$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $6bc90079d7900558$var$useLatestRef(value) {
    const ref = $8nGP5.useRef(value);
    $6bc90079d7900558$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $6bc90079d7900558$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $8nGP5.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $8nGP5.useState(middleware);
    if (!$6bc90079d7900558$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $8nGP5.useState(null);
    const [_floating, _setFloating] = $8nGP5.useState(null);
    const setReference = $8nGP5.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $8nGP5.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $8nGP5.useRef(null);
    const floatingRef = $8nGP5.useRef(null);
    const dataRef = $8nGP5.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $6bc90079d7900558$var$useLatestRef(whileElementsMounted);
    const platformRef = $6bc90079d7900558$var$useLatestRef(platform);
    const openRef = $6bc90079d7900558$var$useLatestRef(open);
    const update = $8nGP5.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $322acf408b6b8401$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$6bc90079d7900558$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $fCKK7.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $6bc90079d7900558$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $8nGP5.useRef(false);
    $6bc90079d7900558$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $6bc90079d7900558$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $8nGP5.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $8nGP5.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $8nGP5.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $6bc90079d7900558$var$roundByDPR(elements.floating, data.x);
        const y = $6bc90079d7900558$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$6bc90079d7900558$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $8nGP5.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $6bc90079d7900558$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $322acf408b6b8401$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $322acf408b6b8401$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $6bc90079d7900558$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $6bc90079d7900558$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $6bc90079d7900558$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $6bc90079d7900558$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $6bc90079d7900558$export$346677f925de839c = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $6bc90079d7900558$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $6bc90079d7900558$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $6bc90079d7900558$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $6bc90079d7900558$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$6bc90079d7900558$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });



var $8nGP5 = parcelRequire("8nGP5");
function $a2d5fbefb787669b$export$e2eb4c264cf71a83(props) {
    var middleware = [];
    if (props.flip) middleware.push((0, $6bc90079d7900558$export$8a83211c878a3f1f)());
    if (props.align !== 'right' && props.align !== 'left') middleware.push((0, $6bc90079d7900558$export$346677f925de839c)({
        apply: function apply(_ref) {
            var rects = _ref.rects, elements = _ref.elements;
            Object.assign(elements.floating.style, {
                width: "".concat(rects.reference.width, "px")
            });
        }
    }));
    return middleware;
}
function $a2d5fbefb787669b$export$a9fe23cfa43a7b55(props) {
    var x = props.align === 'right' ? 'end' : 'start';
    var y = props.dropup ? 'top' : 'bottom';
    return "".concat(y, "-").concat(x);
}
function $a2d5fbefb787669b$export$ea8f71083e90600f(referenceElement, options) {
    var _useState = (0, $8nGP5.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($a74fbf0c8354a097$exports)))(_useState, 2), floatingElement = _useState2[0], attachRef = _useState2[1];
    var _useFloating = (0, $6bc90079d7900558$export$4e02a5c1d08bac65)({
        elements: {
            floating: floatingElement,
            reference: referenceElement
        },
        middleware: $a2d5fbefb787669b$export$e2eb4c264cf71a83(options),
        placement: $a2d5fbefb787669b$export$a9fe23cfa43a7b55(options),
        strategy: options.positionFixed ? 'fixed' : 'absolute',
        whileElementsMounted: (0, $322acf408b6b8401$export$deee3a793edee05f)
    }), floatingStyles = _useFloating.floatingStyles;
    return {
        innerRef: attachRef,
        style: floatingStyles
    };
}
var $a2d5fbefb787669b$export$2e2bcd8739ae039 = $a2d5fbefb787669b$export$ea8f71083e90600f;




var $cc2c27f6ba3b26bb$var$_excluded = [
    "referenceElement",
    "isMenuShown"
];
// `Element` is not defined during server-side rendering, so shim it here.
/* istanbul ignore next */ var $cc2c27f6ba3b26bb$var$SafeElement = typeof Element === 'undefined' ? (0, $a3d838f9b379d079$export$8793edee2d425525) : Element;
var $cc2c27f6ba3b26bb$var$propTypes = {
    /**
   * Specify menu alignment. The default value is `justify`, which makes the
   * menu as wide as the input and truncates long values. Specifying `left`
   * or `right` will align the menu to that side and the width will be
   * determined by the length of menu item values.
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOf((0, $6c473702788b87ec$export$54df5a921294d7ab)),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func.isRequired,
    /**
   * Specify whether the menu should appear above the input.
   */ dropup: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Whether or not to automatically adjust the position of the menu when it
   * reaches the viewport boundaries.
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    isMenuShown: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    positionFixed: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    // @ts-ignore
    referenceElement: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).instanceOf($cc2c27f6ba3b26bb$var$SafeElement)
};
var $cc2c27f6ba3b26bb$var$Overlay = function Overlay(_ref) {
    var referenceElement = _ref.referenceElement, isMenuShown = _ref.isMenuShown, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $cc2c27f6ba3b26bb$var$_excluded);
    var overlayProps = (0, $a2d5fbefb787669b$export$2e2bcd8739ae039)(referenceElement, props);
    if (!isMenuShown) return null;
    return props.children(overlayProps);
};
$cc2c27f6ba3b26bb$var$Overlay.propTypes = $cc2c27f6ba3b26bb$var$propTypes;
var $cc2c27f6ba3b26bb$export$2e2bcd8739ae039 = $cc2c27f6ba3b26bb$var$Overlay;







var $8nGP5 = parcelRequire("8nGP5");
/* eslint-disable no-return-assign */ var $53e6d5b016eb161e$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $39288ac6dc5c98da$export$63fefd044b2bc624 = false;
var $39288ac6dc5c98da$export$a614c6b395900f69 = false;
try {
    var $39288ac6dc5c98da$var$options = {
        get passive () {
            return $39288ac6dc5c98da$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $39288ac6dc5c98da$export$a614c6b395900f69 = $39288ac6dc5c98da$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $53e6d5b016eb161e$export$2e2bcd8739ae039) {
        window.addEventListener('test', $39288ac6dc5c98da$var$options, $39288ac6dc5c98da$var$options);
        window.removeEventListener('test', $39288ac6dc5c98da$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $39288ac6dc5c98da$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$39288ac6dc5c98da$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$39288ac6dc5c98da$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $39288ac6dc5c98da$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $39288ac6dc5c98da$export$2e2bcd8739ae039 = $39288ac6dc5c98da$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $bf50d51abf54f84c$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $bf50d51abf54f84c$export$2e2bcd8739ae039 = $bf50d51abf54f84c$var$removeEventListener;


function $c19f71e61aa90e5d$var$listen(node, eventName, handler, options) {
    (0, $39288ac6dc5c98da$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $bf50d51abf54f84c$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $c19f71e61aa90e5d$export$2e2bcd8739ae039 = $c19f71e61aa90e5d$var$listen;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $0ddd9f7131150c10$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $9e2b25d42636a35a$var$useCommittedRef(value) {
    const ref = (0, $8nGP5.useRef)(value);
    (0, $8nGP5.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $9e2b25d42636a35a$export$2e2bcd8739ae039 = $9e2b25d42636a35a$var$useCommittedRef;


function $000fcb6676031dc3$export$2e2bcd8739ae039(fn) {
    const ref = (0, $9e2b25d42636a35a$export$2e2bcd8739ae039)(fn);
    return (0, $8nGP5.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $321b0569c1d3b241$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $8nGP5 = parcelRequire("8nGP5");


const $8b486869c221a144$var$noop = ()=>{};
function $8b486869c221a144$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $8b486869c221a144$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $8b486869c221a144$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $8b486869c221a144$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $8b486869c221a144$var$useClickOutside(ref, onClickOutside = $8b486869c221a144$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $8nGP5.useRef)(false);
    const waitingForTrigger = (0, $8nGP5.useRef)(false);
    const handleMouseCapture = (0, $8nGP5.useCallback)((e)=>{
        const currentTarget = $8b486869c221a144$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($ced47db6f467fbae$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $8b486869c221a144$var$isModifiedEvent(e) || !$8b486869c221a144$var$isLeftClickEvent(e) || !!(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $8b486869c221a144$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $321b0569c1d3b241$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $8nGP5.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)($8b486869c221a144$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($8b486869c221a144$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, $8b486869c221a144$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(el, 'mousemove', $8b486869c221a144$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $8b486869c221a144$export$2e2bcd8739ae039 = $8b486869c221a144$var$useClickOutside;



var $8nGP5 = parcelRequire("8nGP5");
function $408b7150cc48713e$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $408b7150cc48713e$export$13e065f3a74cfe36() {
    const parts = $8nGP5.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $408b7150cc48713e$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $408b7150cc48713e$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}


const $6b8ae382063dfa98$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $6b8ae382063dfa98$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $6b8ae382063dfa98$var$noop;
    (0, $8b486869c221a144$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        if ((0, $408b7150cc48713e$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $8nGP5.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)((0, $8b486869c221a144$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $6b8ae382063dfa98$export$2e2bcd8739ae039 = $6b8ae382063dfa98$var$useRootClose;


function $027eb5d21bfedcb2$var$useRootClose(onRootClose, options) {
    var ref = (0, $8nGP5.useRef)(null);
    (0, $6b8ae382063dfa98$export$2e2bcd8739ae039)(ref, onRootClose, options);
    return ref;
}
var $027eb5d21bfedcb2$export$2e2bcd8739ae039 = $027eb5d21bfedcb2$var$useRootClose;


var $778ccc1ba4c8691f$var$_excluded = [
    "children",
    "onRootClose"
];
function $778ccc1ba4c8691f$var$RootClose(_ref) {
    var children = _ref.children, onRootClose = _ref.onRootClose, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $778ccc1ba4c8691f$var$_excluded);
    var rootRef = (0, $027eb5d21bfedcb2$export$2e2bcd8739ae039)(onRootClose, props);
    return children(rootRef);
}
var $778ccc1ba4c8691f$export$2e2bcd8739ae039 = $778ccc1ba4c8691f$var$RootClose;







var $8tsi7 = parcelRequire("8tsi7");



var $8nGP5 = parcelRequire("8nGP5");


var $8tsi7 = parcelRequire("8tsi7");




var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");



var $250779de198125ff$var$_excluded = [
    "onBlur",
    "onClick",
    "onFocus",
    "onRemove",
    "option"
];
function $250779de198125ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $250779de198125ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $250779de198125ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $250779de198125ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $250779de198125ff$var$propTypes = {
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    onRemove: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    option: (0, $1040560fbf61b9ca$export$7de5fae3688fa523).isRequired
};
function $250779de198125ff$export$31dcd79391e423fe(_ref) {
    var onBlur = _ref.onBlur, onClick = _ref.onClick, onFocus = _ref.onFocus, onRemove = _ref.onRemove, option = _ref.option, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $250779de198125ff$var$_excluded);
    var _useState = (0, $8nGP5.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($a74fbf0c8354a097$exports)))(_useState, 2), active = _useState2[0], setActive = _useState2[1];
    var handleBlur = function handleBlur(e) {
        setActive(false);
        onBlur && onBlur(e);
    };
    var handleClick = function handleClick(e) {
        setActive(true);
        onClick && onClick(e);
    };
    var handleFocus = function handleFocus(e) {
        setActive(true);
        onFocus && onFocus(e);
    };
    var handleRemove = function handleRemove() {
        onRemove && onRemove(option);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Backspace' && active) {
            // Prevent browser from going back.
            e.preventDefault();
            handleRemove();
        }
    };
    var attachRef = (0, $027eb5d21bfedcb2$export$2e2bcd8739ae039)(handleBlur, $250779de198125ff$var$_objectSpread($250779de198125ff$var$_objectSpread({}, props), {}, {
        disabled: !active
    }));
    return {
        active: active,
        onBlur: handleBlur,
        onClick: handleClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onRemove: (0, $a3d838f9b379d079$export$f6e2535fb5126e54)(onRemove) ? handleRemove : undefined,
        ref: attachRef
    };
}
function $250779de198125ff$export$f6f0dceccdb6a70d(Component) {
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(false, "Warning: `withToken` is deprecated and will be removed in the next major version. Use `useToken` instead.");
    var displayName = "withToken(".concat((0, $0152309507841af0$export$2e2bcd8739ae039)(Component), ")");
    var WrappedToken = function WrappedToken(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, $250779de198125ff$export$31dcd79391e423fe(props)));
    };
    WrappedToken.displayName = displayName;
    WrappedToken.propTypes = $250779de198125ff$var$propTypes;
    return WrappedToken;
}



var $79da02d3ffda5fec$var$_excluded = [
    "active",
    "children",
    "className",
    "onRemove",
    "tabIndex"
], $79da02d3ffda5fec$var$_excluded2 = [
    "children",
    "option",
    "readOnly"
], $79da02d3ffda5fec$var$_excluded3 = [
    "ref"
];
function $79da02d3ffda5fec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $79da02d3ffda5fec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $79da02d3ffda5fec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $79da02d3ffda5fec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $79da02d3ffda5fec$var$InteractiveToken = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(_ref, ref) {
    var active = _ref.active, children = _ref.children, className = _ref.className, onRemove = _ref.onRemove, tabIndex = _ref.tabIndex, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $79da02d3ffda5fec$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-token', 'rbt-token-removeable', {
            'rbt-token-active': !!active
        }, className),
        ref: ref,
        tabIndex: tabIndex || 0
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $653b17d7694cd265$export$2e2bcd8739ae039), {
        className: "rbt-token-remove-button",
        label: "Remove",
        onClick: onRemove,
        tabIndex: -1
    }));
});
var $79da02d3ffda5fec$var$StaticToken = function StaticToken(_ref2) {
    var children = _ref2.children, className = _ref2.className, disabled = _ref2.disabled, href = _ref2.href;
    var classnames = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-token', {
        'rbt-token-disabled': disabled
    }, className);
    if (href && !disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("a", {
        className: classnames,
        href: href
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: classnames
    }, children);
};
/**
 * Individual token component, generally displayed within the
 * `TypeaheadInputMulti` component, but can also be rendered on its own.
 */ var $79da02d3ffda5fec$var$Token = function Token(_ref3) {
    var children = _ref3.children, option = _ref3.option, readOnly = _ref3.readOnly, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref3, $79da02d3ffda5fec$var$_excluded2);
    var _useToken = (0, $250779de198125ff$export$31dcd79391e423fe)($79da02d3ffda5fec$var$_objectSpread($79da02d3ffda5fec$var$_objectSpread({}, props), {}, {
        option: option
    })), ref = _useToken.ref, tokenProps = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_useToken, $79da02d3ffda5fec$var$_excluded3);
    var child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "rbt-token-label"
    }, children);
    return !props.disabled && !readOnly && (0, $a3d838f9b379d079$export$f6e2535fb5126e54)(tokenProps.onRemove) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($79da02d3ffda5fec$var$InteractiveToken, (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, tokenProps, {
        ref: ref
    }), child) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($79da02d3ffda5fec$var$StaticToken, props, child);
};
var $79da02d3ffda5fec$export$2e2bcd8739ae039 = $79da02d3ffda5fec$var$Token;



var $8tsi7 = parcelRequire("8tsi7");



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

// IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.
function $22ad69d003d86797$var$interpolateStyle(styles, attr) {
    var subattr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    // Title-case the sub-attribute.
    if (subattr) /* eslint-disable-next-line no-param-reassign */ subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
    return [
        'Top',
        'Right',
        'Bottom',
        'Left'
    ].map(function(dir) {
        return styles["".concat(attr).concat(dir).concat(subattr)];
    }).join(' ');
}
function $22ad69d003d86797$var$copyStyles(inputNode, hintNode) {
    var inputStyle = window.getComputedStyle(inputNode);
    /* eslint-disable no-param-reassign */ hintNode.style.borderStyle = $22ad69d003d86797$var$interpolateStyle(inputStyle, 'border', 'style');
    hintNode.style.borderWidth = $22ad69d003d86797$var$interpolateStyle(inputStyle, 'border', 'width');
    hintNode.style.fontSize = inputStyle.fontSize;
    hintNode.style.fontWeight = inputStyle.fontWeight;
    hintNode.style.height = inputStyle.height;
    hintNode.style.lineHeight = inputStyle.lineHeight;
    hintNode.style.margin = $22ad69d003d86797$var$interpolateStyle(inputStyle, 'margin');
    hintNode.style.padding = $22ad69d003d86797$var$interpolateStyle(inputStyle, 'padding');
/* eslint-enable no-param-reassign */ }
var $22ad69d003d86797$export$efccc994a079cdc8 = function useHint() {
    var _useTypeaheadContext = (0, $6254293de2d4ae9c$export$20418b9b18662c6c)(), hintText = _useTypeaheadContext.hintText, inputNode = _useTypeaheadContext.inputNode;
    var hintRef = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(function() {
        // Scroll hint input when the text input is scrolling.
        var handleInputScroll = function handleInputScroll() {
            if (hintRef.current && inputNode) hintRef.current.scrollLeft = inputNode.scrollLeft;
        };
        inputNode === null || inputNode === void 0 || inputNode.addEventListener('scroll', handleInputScroll);
        return function() {
            inputNode === null || inputNode === void 0 || inputNode.removeEventListener('scroll', handleInputScroll);
        };
    }, [
        inputNode
    ]);
    (0, $8nGP5.useEffect)(function() {
        if (inputNode && hintRef.current) $22ad69d003d86797$var$copyStyles(inputNode, hintRef.current);
    });
    return {
        hintRef: hintRef,
        hintText: hintText
    };
};
var $22ad69d003d86797$var$Hint = function Hint(_ref) {
    var children = _ref.children, className = _ref.className;
    var _useHint = $22ad69d003d86797$export$efccc994a079cdc8(), hintRef = _useHint.hintRef, hintText = _useHint.hintText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: className,
        style: {
            display: 'flex',
            flex: 1,
            height: '100%',
            position: 'relative'
        }
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("input", {
        "aria-hidden": true,
        className: "rbt-input-hint",
        ref: hintRef,
        readOnly: true,
        style: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            boxShadow: 'none',
            color: 'rgba(0, 0, 0, 0.54)',
            left: 0,
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            width: '100%'
        },
        tabIndex: -1,
        value: hintText
    }));
};
var $22ad69d003d86797$export$2e2bcd8739ae039 = $22ad69d003d86797$var$Hint;





var $8tsi7 = parcelRequire("8tsi7");


var $8nGP5 = parcelRequire("8nGP5");
var $bd4f1186d97c0c01$var$Input = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-input-main', props.className),
        ref: ref
    }));
});
var $bd4f1186d97c0c01$export$2e2bcd8739ae039 = $bd4f1186d97c0c01$var$Input;





var $2b75c7df982c0599$var$_excluded = [
    "children",
    "className",
    "inputClassName",
    "inputRef",
    "referenceElementRef",
    "selected"
];
function $2b75c7df982c0599$var$TypeaheadInputMulti(props) {
    var wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useRef(null);
    var inputElem = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useRef(null);
    var _propsWithBsClassName = (0, $32a5c1e6fca9687b$export$2e2bcd8739ae039)(props), children = _propsWithBsClassName.children, className = _propsWithBsClassName.className, inputClassName = _propsWithBsClassName.inputClassName, inputRef = _propsWithBsClassName.inputRef, referenceElementRef = _propsWithBsClassName.referenceElementRef, selected = _propsWithBsClassName.selected, rest = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_propsWithBsClassName, $2b75c7df982c0599$var$_excluded);
    function getInputRef(input) {
        inputElem.current = input;
        props.inputRef(input);
    }
    /**
   * Forward click or focus events on the container element to the input.
   */ function handleContainerClickOrFocus(e) {
        // Don't focus the input if it's disabled.
        if (props.disabled) {
            e.currentTarget.blur();
            return;
        }
        var inputNode = inputElem.current;
        if (!inputNode || // Ignore if the clicked element is a child of the container, ie: a token
        // or the input itself.
        e.currentTarget.contains(e.target) && e.currentTarget !== e.target) return;
        if ((0, $209c555ea6334353$export$2e2bcd8739ae039)(inputNode)) // Move cursor to the end if the user clicks outside the actual input.
        inputNode.selectionStart = inputNode.value.length;
        inputNode.focus();
    }
    function handleKeyDown(e) {
        if (e.key === 'Backspace' && selected.length && !props.value) {
            var _wrapperRef$current;
            // Prevent browser from going back.
            e.preventDefault();
            // If the input is selected and there is no text, focus the last
            // token when the user hits backspace.
            var wrapperChildren = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.children;
            if (wrapperChildren !== null && wrapperChildren !== void 0 && wrapperChildren.length) {
                var lastToken = wrapperChildren[wrapperChildren.length - 2];
                lastToken === null || lastToken === void 0 || lastToken.focus();
            }
        }
        props.onKeyDown && props.onKeyDown(e);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-input-multi', {
            disabled: props.disabled
        }, className),
        onClick: handleContainerClickOrFocus,
        onFocus: handleContainerClickOrFocus,
        ref: referenceElementRef,
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "rbt-input-wrapper",
        ref: wrapperRef
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $22ad69d003d86797$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $bd4f1186d97c0c01$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, rest, {
        className: inputClassName,
        onKeyDown: handleKeyDown,
        ref: getInputRef,
        style: {
            backgroundColor: 'transparent',
            border: 0,
            boxShadow: 'none',
            cursor: 'inherit',
            outline: 'none',
            padding: 0,
            width: '100%',
            zIndex: 1
        }
    })))));
}
var $2b75c7df982c0599$export$2e2bcd8739ae039 = $2b75c7df982c0599$var$TypeaheadInputMulti;





var $8tsi7 = parcelRequire("8tsi7");


var $8nGP5 = parcelRequire("8nGP5");



var $51ca32ea2d560d5b$var$_excluded = [
    "inputRef",
    "referenceElementRef"
];
var $51ca32ea2d560d5b$var$TypeaheadInputSingle = function TypeaheadInputSingle(_ref) {
    var inputRef = _ref.inputRef, referenceElementRef = _ref.referenceElementRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $51ca32ea2d560d5b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $22ad69d003d86797$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $bd4f1186d97c0c01$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, (0, $32a5c1e6fca9687b$export$2e2bcd8739ae039)(props), {
        ref: function ref(node) {
            inputRef(node);
            referenceElementRef(node);
        }
    })));
};
var $51ca32ea2d560d5b$export$2e2bcd8739ae039 = $51ca32ea2d560d5b$var$TypeaheadInputSingle;





var $8tsi7 = parcelRequire("8tsi7");


var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");

var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");

var $116510c3d59e0b2a$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string.isRequired,
    highlightClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    search: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string.isRequired
};
/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */ var $116510c3d59e0b2a$var$Highlighter = function Highlighter(_ref) {
    var children = _ref.children, _ref$highlightClassNa = _ref.highlightClassName, highlightClassName = _ref$highlightClassNa === void 0 ? 'rbt-highlight-text' : _ref$highlightClassNa, search = _ref.search;
    if (!search || !children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, null, children);
    var matchCount = 0;
    var remaining = children;
    var highlighterChildren = [];
    while(remaining){
        var bounds = (0, $143ebf005b87c2cf$export$2e2bcd8739ae039)(remaining, search);
        // No match anywhere in the remaining string, stop.
        if (!bounds) {
            highlighterChildren.push(remaining);
            break;
        }
        // Capture the string that leads up to a match.
        var nonMatch = remaining.slice(0, bounds.start);
        if (nonMatch) highlighterChildren.push(nonMatch);
        // Capture the matching string.
        var match = remaining.slice(bounds.start, bounds.end);
        highlighterChildren.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("mark", {
            className: highlightClassName,
            key: matchCount
        }, match));
        matchCount += 1;
        // And if there's anything left over, continue the loop.
        remaining = remaining.slice(bounds.end);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, null, highlighterChildren);
};
$116510c3d59e0b2a$var$Highlighter.propTypes = $116510c3d59e0b2a$var$propTypes;
var $116510c3d59e0b2a$export$2e2bcd8739ae039 = $116510c3d59e0b2a$var$Highlighter;







var $8tsi7 = parcelRequire("8tsi7");


var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");

var $8tsi7 = parcelRequire("8tsi7");



var $8nGP5 = parcelRequire("8nGP5");

var $8tsi7 = parcelRequire("8tsi7");



var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");
const $103c83a501eb320c$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $103c83a501eb320c$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $103c83a501eb320c$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $103c83a501eb320c$var$e(o.overflowY, n) || $103c83a501eb320c$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $103c83a501eb320c$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $103c83a501eb320c$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $103c83a501eb320c$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$103c83a501eb320c$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $103c83a501eb320c$var$t(W) && p(W);){
        if (W = $103c83a501eb320c$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $103c83a501eb320c$var$n(W) && !$103c83a501eb320c$var$n(document.documentElement) || null != W && $103c83a501eb320c$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !$103c83a501eb320c$var$n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $103c83a501eb320c$var$o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $103c83a501eb320c$var$o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? $103c83a501eb320c$var$o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : $103c83a501eb320c$var$o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};


const $e403ef96e408edf5$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $e403ef96e408edf5$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $103c83a501eb320c$export$3b12cb22b12b954b)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $103c83a501eb320c$export$3b12cb22b12b954b)(e, $e403ef96e408edf5$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}





var $70432833ac6706af$var$_excluded = [
    "label",
    "onClick",
    "option",
    "position"
];
function $70432833ac6706af$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70432833ac6706af$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70432833ac6706af$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70432833ac6706af$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $70432833ac6706af$var$propTypes = {
    option: (0, $1040560fbf61b9ca$export$7de5fae3688fa523).isRequired,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number
};
function $70432833ac6706af$export$9842ce616dcc8723(_ref) {
    var label = _ref.label, onClick = _ref.onClick, option = _ref.option, position = _ref.position, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $70432833ac6706af$var$_excluded);
    var _useTypeaheadContext = (0, $6254293de2d4ae9c$export$20418b9b18662c6c)(), activeIndex = _useTypeaheadContext.activeIndex, id = _useTypeaheadContext.id, isOnlyResult = _useTypeaheadContext.isOnlyResult, onActiveItemChange = _useTypeaheadContext.onActiveItemChange, onInitialItemChange = _useTypeaheadContext.onInitialItemChange, onMenuItemClick = _useTypeaheadContext.onMenuItemClick, setItem = _useTypeaheadContext.setItem;
    var itemRef = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(function() {
        if (position === 0) onInitialItemChange(option);
    });
    (0, $8nGP5.useEffect)(function() {
        if (position === activeIndex) {
            onActiveItemChange(option);
            // Automatically scroll the menu as the user keys through it.
            var node = itemRef.current;
            node && (0, $e403ef96e408edf5$export$2e2bcd8739ae039)(node, {
                boundary: node.parentNode,
                scrollMode: 'if-needed'
            });
        }
    }, [
        activeIndex,
        onActiveItemChange,
        option,
        position
    ]);
    var handleClick = (0, $8nGP5.useCallback)(function(e) {
        onMenuItemClick(option, e);
        onClick && onClick(e);
    }, [
        onClick,
        onMenuItemClick,
        option
    ]);
    var active = isOnlyResult || activeIndex === position;
    // Update the item's position in the item stack.
    setItem(option, position);
    return $70432833ac6706af$var$_objectSpread($70432833ac6706af$var$_objectSpread({}, props), {}, {
        active: active,
        'aria-label': label,
        'aria-selected': active,
        id: (0, $86ef4837c81eb2fa$export$2e2bcd8739ae039)(id, position),
        onClick: handleClick,
        onMouseDown: (0, $ad92d9f34ff3c43b$export$2e2bcd8739ae039),
        ref: itemRef,
        role: 'option'
    });
}
function $70432833ac6706af$export$a3a500069effb440(Component) {
    (0, $7984d358c14bcc13$export$2e2bcd8739ae039)(false, "Warning: `withItem` is deprecated and will be removed in the next major version. Use `useItem` instead.");
    var WrappedMenuItem = function WrappedMenuItem(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, $70432833ac6706af$export$9842ce616dcc8723(props)));
    };
    WrappedMenuItem.displayName = "withItem(".concat((0, $0152309507841af0$export$2e2bcd8739ae039)(Component), ")");
    WrappedMenuItem.propTypes = $70432833ac6706af$var$propTypes;
    return WrappedMenuItem;
}


var $0e525f254146d1c8$var$_excluded = [
    "active",
    "children",
    "className",
    "disabled",
    "onClick"
];
var $0e525f254146d1c8$export$2ddca9041350239b = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(_ref, ref) {
    var active = _ref.active, children = _ref.children, className = _ref.className, disabled = _ref.disabled, _onClick = _ref.onClick, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $0e525f254146d1c8$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("a", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('dropdown-item', {
            active: active,
            disabled: disabled
        }, className),
        href: props.href || '#',
        onClick: function onClick(e) {
            e.preventDefault();
            !disabled && _onClick && _onClick(e);
        },
        ref: ref
    }), children);
});
function $0e525f254146d1c8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($0e525f254146d1c8$export$2ddca9041350239b, (0, $70432833ac6706af$export$9842ce616dcc8723)(props));
}






var $6dc2979d3137cf1b$var$_excluded = [
    "emptyLabel",
    "innerRef",
    "maxHeight",
    "style"
];
function $6dc2979d3137cf1b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6dc2979d3137cf1b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6dc2979d3137cf1b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6dc2979d3137cf1b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6dc2979d3137cf1b$var$MenuDivider = function MenuDivider() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "dropdown-divider",
        role: "separator"
    });
};
var $6dc2979d3137cf1b$var$MenuHeader = function MenuHeader(props) {
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        className: "dropdown-header",
        role: "heading"
    })));
};
var $6dc2979d3137cf1b$var$propTypes = {
    'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    /**
   * Message to display in the menu if there are no valid results.
   */ emptyLabel: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
    /**
   * Needed for accessibility.
   */ id: (0, $1040560fbf61b9ca$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
    ]), (0, $1040560fbf61b9ca$export$50bb8c440cf2a42c)),
    /**
   * Maximum height of the dropdown menu.
   */ maxHeight: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
};
/**
 * Menu component that handles empty state when passed a set of results.
 */ var $6dc2979d3137cf1b$var$Menu = function Menu(_ref) {
    var _ref$emptyLabel = _ref.emptyLabel, emptyLabel = _ref$emptyLabel === void 0 ? 'No matches found.' : _ref$emptyLabel, innerRef = _ref.innerRef, _ref$maxHeight = _ref.maxHeight, maxHeight = _ref$maxHeight === void 0 ? '300px' : _ref$maxHeight, style = _ref.style, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $6dc2979d3137cf1b$var$_excluded);
    var children = (0, $8nGP5.Children).count(props.children) === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $0e525f254146d1c8$export$2ddca9041350239b), {
        disabled: true,
        role: "option"
    }, emptyLabel) : props.children;
    return /*#__PURE__*/ /* eslint-disable jsx-a11y/interactive-supports-focus */ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        "aria-label": props['aria-label'] || 'menu-options',
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-menu', 'dropdown-menu', 'show', props.className),
        onMouseDown: // Prevent input from blurring when clicking on the menu scrollbar.
        (0, $ad92d9f34ff3c43b$export$2e2bcd8739ae039),
        ref: innerRef,
        role: "listbox",
        style: $6dc2979d3137cf1b$var$_objectSpread($6dc2979d3137cf1b$var$_objectSpread({}, style), {}, {
            display: 'block',
            maxHeight: maxHeight,
            overflow: 'auto'
        })
    }), children);
};
$6dc2979d3137cf1b$var$Menu.propTypes = $6dc2979d3137cf1b$var$propTypes;
$6dc2979d3137cf1b$var$Menu.Divider = $6dc2979d3137cf1b$var$MenuDivider;
$6dc2979d3137cf1b$var$Menu.Header = $6dc2979d3137cf1b$var$MenuHeader;
var $6dc2979d3137cf1b$export$2e2bcd8739ae039 = $6dc2979d3137cf1b$var$Menu;






var $f4b164aff63005ce$var$_excluded = [
    "labelKey",
    "newSelectionPrefix",
    "options",
    "paginationText",
    "renderMenuItemChildren",
    "text"
];
var $f4b164aff63005ce$var$propTypes = {
    /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */ newSelectionPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
    /**
   * Prompt displayed when large data sets are paginated.
   */ paginationText: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
    /**
   * Provides a hook for customized rendering of menu item contents.
   */ renderMenuItemChildren: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
};
function $f4b164aff63005ce$var$renderMenuItemChildrenFn(option, props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $116510c3d59e0b2a$export$2e2bcd8739ae039), {
        search: props.text
    }, (0, $ebf6e7a66fd060c3$export$2e2bcd8739ae039)(option, props.labelKey));
}
var $f4b164aff63005ce$var$TypeaheadMenu = function TypeaheadMenu(props) {
    var labelKey = props.labelKey, _props$newSelectionPr = props.newSelectionPrefix, newSelectionPrefix = _props$newSelectionPr === void 0 ? 'New selection: ' : _props$newSelectionPr, options = props.options, _props$paginationText = props.paginationText, paginationText = _props$paginationText === void 0 ? 'Display additional results...' : _props$paginationText, _props$renderMenuItem = props.renderMenuItemChildren, renderMenuItemChildren = _props$renderMenuItem === void 0 ? $f4b164aff63005ce$var$renderMenuItemChildrenFn : _props$renderMenuItem, text = props.text, menuProps = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(props, $f4b164aff63005ce$var$_excluded);
    var renderMenuItem = function renderMenuItem(option, position) {
        var label = (0, $ebf6e7a66fd060c3$export$2e2bcd8739ae039)(option, labelKey);
        var menuItemProps = {
            disabled: !!(0, $65c8a734025a1eb8$export$2e2bcd8739ae039)(option, 'disabled'),
            label: label,
            option: option,
            position: position
        };
        if ((0, $65c8a734025a1eb8$export$2e2bcd8739ae039)(option, 'customOption')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $0e525f254146d1c8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, menuItemProps, {
            className: "rbt-menu-custom-option",
            key: position,
            label: label
        }), newSelectionPrefix, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $116510c3d59e0b2a$export$2e2bcd8739ae039), {
            search: text
        }, label));
        if ((0, $65c8a734025a1eb8$export$2e2bcd8739ae039)(option, 'paginationOption')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, {
            key: "pagination-option-divider"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $6dc2979d3137cf1b$export$2e2bcd8739ae039).Divider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $0e525f254146d1c8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, menuItemProps, {
            className: "rbt-menu-pagination-option",
            label: // TODO: Fix how (aria-)labels are passed to `MenuItem`.
            // `paginationText` can be a ReactNode.
            (0, $a3d838f9b379d079$export$844ec244b1367d54)(paginationText) ? paginationText : ''
        }), paginationText));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $0e525f254146d1c8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, menuItemProps, {
            key: position
        }), renderMenuItemChildren(option, props, position));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $6dc2979d3137cf1b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, menuProps, {
        key: // Force a re-render if the text changes to ensure that menu
        // positioning updates correctly.
        text
    }), options.map(renderMenuItem));
};
$f4b164aff63005ce$var$TypeaheadMenu.propTypes = $f4b164aff63005ce$var$propTypes;
var $f4b164aff63005ce$export$2e2bcd8739ae039 = $f4b164aff63005ce$var$TypeaheadMenu;






function $987409511f795a07$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $987409511f795a07$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $987409511f795a07$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $987409511f795a07$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $987409511f795a07$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $987409511f795a07$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($c922f707fc099e1f$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($c922f707fc099e1f$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($2443e6812aa08435$exports)))(this, result);
    };
}
function $987409511f795a07$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $987409511f795a07$var$propTypes = {
    /**
   * Displays a button to clear the input when there are selections.
   */ clearButton: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Props to be applied directly to the input. `onBlur`, `onChange`,
   * `onFocus`, and `onKeyDown` are ignored.
   */ inputProps: (0, $1040560fbf61b9ca$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object, (0, $1040560fbf61b9ca$export$82c0eddbd071e45f)),
    /**
   * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
   */ isInvalid: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Indicate whether an asynchronous data fetch is happening.
   */ isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
   */ isValid: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Callback for custom input rendering.
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Callback for custom menu rendering.
   */ renderMenu: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Callback for custom menu rendering.
   */ renderToken: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Specifies the size of the input.
   */ size: (0, $1040560fbf61b9ca$export$9ae6167e9ee9e6d0)
};
var $987409511f795a07$var$defaultProps = {
    isLoading: false
};
var $987409511f795a07$var$defaultRenderMenu = function defaultRenderMenu(results, menuProps, props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $f4b164aff63005ce$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, menuProps, {
        labelKey: props.labelKey,
        options: results,
        text: props.text
    }));
};
var $987409511f795a07$var$defaultRenderToken = function defaultRenderToken(option, props, idx) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $79da02d3ffda5fec$export$2e2bcd8739ae039), {
        disabled: props.disabled,
        key: idx,
        onRemove: props.onRemove,
        option: option,
        tabIndex: props.tabIndex
    }, (0, $ebf6e7a66fd060c3$export$2e2bcd8739ae039)(option, props.labelKey));
};
var $987409511f795a07$var$overlayPropKeys = [
    'align',
    'dropup',
    'flip',
    'positionFixed'
];
function $987409511f795a07$var$getOverlayProps(props) {
    return (0, $a3d838f9b379d079$export$357523c63a2253b9)(props, $987409511f795a07$var$overlayPropKeys);
}
var $987409511f795a07$var$TypeaheadComponent = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($0e1045ebe29aee70$exports)))(TypeaheadComponent, _React$Component);
    var _super = $987409511f795a07$var$_createSuper(TypeaheadComponent);
    function TypeaheadComponent() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($face66a2b537e00d$exports)))(this, TypeaheadComponent);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_referenceElement", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "referenceElementRef", function(referenceElement) {
            _this._referenceElement = referenceElement;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_renderInput", function(inputProps, props) {
            var _this$props = _this.props, isInvalid = _this$props.isInvalid, isValid = _this$props.isValid, multiple = _this$props.multiple, renderInput = _this$props.renderInput, renderToken = _this$props.renderToken, size = _this$props.size;
            if ((0, $a3d838f9b379d079$export$f6e2535fb5126e54)(renderInput)) return renderInput(inputProps, props);
            var commonProps = $987409511f795a07$var$_objectSpread($987409511f795a07$var$_objectSpread({}, inputProps), {}, {
                isInvalid: isInvalid,
                isValid: isValid,
                size: size
            });
            if (!multiple) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $51ca32ea2d560d5b$export$2e2bcd8739ae039), commonProps);
            var labelKey = props.labelKey, onRemove = props.onRemove, selected = props.selected;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2b75c7df982c0599$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, commonProps, {
                placeholder: selected.length ? '' : inputProps.placeholder,
                selected: selected
            }), selected.map(function(option, idx) {
                return (renderToken || $987409511f795a07$var$defaultRenderToken)(option, $987409511f795a07$var$_objectSpread($987409511f795a07$var$_objectSpread({}, commonProps), {}, {
                    labelKey: labelKey,
                    onRemove: onRemove
                }), idx);
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_renderMenu", function(results, menuProps, props) {
            var _this$props2 = _this.props, emptyLabel = _this$props2.emptyLabel, id = _this$props2.id, maxHeight = _this$props2.maxHeight, newSelectionPrefix = _this$props2.newSelectionPrefix, paginationText = _this$props2.paginationText, renderMenu = _this$props2.renderMenu, renderMenuItemChildren = _this$props2.renderMenuItemChildren;
            return (renderMenu || $987409511f795a07$var$defaultRenderMenu)(results, $987409511f795a07$var$_objectSpread($987409511f795a07$var$_objectSpread({}, menuProps), {}, {
                emptyLabel: emptyLabel,
                id: id,
                maxHeight: maxHeight,
                newSelectionPrefix: newSelectionPrefix,
                paginationText: paginationText,
                renderMenuItemChildren: renderMenuItemChildren
            }), props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_renderAux", function(_ref) {
            var onClear = _ref.onClear, selected = _ref.selected;
            var _this$props3 = _this.props, clearButton = _this$props3.clearButton, disabled = _this$props3.disabled, isLoading = _this$props3.isLoading, size = _this$props3.size;
            var content;
            if (isLoading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $341beb83c8e86e5e$export$2e2bcd8739ae039), null);
            else if (clearButton && !disabled && selected.length) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $653b17d7694cd265$export$2e2bcd8739ae039), {
                onClick: onClear,
                onMouseDown: (0, $ad92d9f34ff3c43b$export$2e2bcd8739ae039),
                size: size
            });
            return content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-aux', {
                    'rbt-aux-lg': (0, $60191fc4983e8db4$export$650961c52e438122)(size)
                })
            }, content) : null;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2bd15c24945ea86e$exports)))(TypeaheadComponent, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, instanceRef = _this$props4.instanceRef, open = _this$props4.open, options = _this$props4.options, style = _this$props4.style;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $fa544beb6a77dc66$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, this.props, {
                    options: options,
                    ref: instanceRef
                }), function(props) {
                    var hideMenu = props.hideMenu, isMenuShown = props.isMenuShown, results = props.results;
                    var auxContent = _this2._renderAux(props);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $778ccc1ba4c8691f$export$2e2bcd8739ae039), {
                        disabled: open || !isMenuShown,
                        onRootClose: hideMenu
                    }, function(ref) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt', {
                                'has-aux': !!auxContent,
                                'is-invalid': _this2.props.isInvalid,
                                'is-valid': _this2.props.isValid
                            }, className),
                            ref: ref,
                            style: $987409511f795a07$var$_objectSpread($987409511f795a07$var$_objectSpread({}, style), {}, {
                                outline: 'none',
                                position: 'relative'
                            }),
                            tabIndex: -1
                        }, _this2._renderInput($987409511f795a07$var$_objectSpread($987409511f795a07$var$_objectSpread({}, props.getInputProps(_this2.props.inputProps)), {}, {
                            referenceElementRef: _this2.referenceElementRef
                        }), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $cc2c27f6ba3b26bb$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, $987409511f795a07$var$getOverlayProps(_this2.props), {
                            isMenuShown: isMenuShown,
                            referenceElement: _this2._referenceElement
                        }), function(menuProps) {
                            return _this2._renderMenu(results, menuProps, props);
                        }), auxContent, (0, $a3d838f9b379d079$export$f6e2535fb5126e54)(children) ? children(props) : children);
                    });
                });
            }
        }
    ]);
    return TypeaheadComponent;
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))($987409511f795a07$var$TypeaheadComponent, "propTypes", $987409511f795a07$var$propTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))($987409511f795a07$var$TypeaheadComponent, "defaultProps", $987409511f795a07$var$defaultProps);
var $987409511f795a07$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($987409511f795a07$var$TypeaheadComponent, (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        instanceRef: ref
    }));
});




var $fab7a275448645ce$var$AsyncTypeahead = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $987409511f795a07$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, (0, $96080b5534c0b718$export$cdf1dc76b55502e3)(props), {
        ref: ref
    }));
});
var $fab7a275448645ce$export$2e2bcd8739ae039 = $fab7a275448645ce$var$AsyncTypeahead;

























var $11cc9488d14d0545$export$37c8efd0a1d7c4c5;
var $11cc9488d14d0545$export$d90250155de6d7e7;
$11cc9488d14d0545$export$37c8efd0a1d7c4c5 = `vhWYdq_industrySearch`;
$11cc9488d14d0545$export$d90250155de6d7e7 = `vhWYdq_selected`;



var $9640fc307de8e8aa$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9640fc307de8e8aa$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9640fc307de8e8aa$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9640fc307de8e8aa$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $9640fc307de8e8aa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $9640fc307de8e8aa$var$braileSpacing = "\u2800  ";
const $9640fc307de8e8aa$var$SEPERATOR = '::';
let $9640fc307de8e8aa$export$22c8bd8fd228c58a = (()=>{
    var _a, _TaggingStore_taggedIds_accessor_storage;
    let _taggedIds_decorators;
    let _taggedIds_initializers = [];
    let _taggedIds_extraInitializers = [];
    return _a = class TaggingStore {
        get taggedIds() {
            return $9640fc307de8e8aa$var$__classPrivateFieldGet(this, _TaggingStore_taggedIds_accessor_storage, "f");
        }
        set taggedIds(value) {
            $9640fc307de8e8aa$var$__classPrivateFieldSet(this, _TaggingStore_taggedIds_accessor_storage, value, "f");
        }
        constructor(){
            _TaggingStore_taggedIds_accessor_storage.set(this, $9640fc307de8e8aa$var$__runInitializers(this, _taggedIds_initializers, []));
            $9640fc307de8e8aa$var$__runInitializers(this, _taggedIds_extraInitializers);
        }
    }, _TaggingStore_taggedIds_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _taggedIds_decorators = [
            (0, $T5IcR.observable)
        ];
        $9640fc307de8e8aa$var$__esDecorate(_a, null, _taggedIds_decorators, {
            kind: "accessor",
            name: "taggedIds",
            static: false,
            private: false,
            access: {
                has: (obj)=>"taggedIds" in obj,
                get: (obj)=>obj.taggedIds,
                set: (obj, value)=>{
                    obj.taggedIds = value;
                }
            },
            metadata: _metadata
        }, _taggedIds_initializers, _taggedIds_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $9640fc307de8e8aa$export$e5ac8460294ca616 = 'ALL';
const $9640fc307de8e8aa$export$b3f69e2b6baaff4f = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    var _a;
    const allowSelectAll = (_a = props.allowSelectAll) !== null && _a !== void 0 ? _a : false;
    function groupBy(list, keyGetter) {
        const map = {};
        list.forEach((item)=>{
            const key = keyGetter(item);
            if (!map.hasOwnProperty(key)) map[key] = [];
            map[key].push(item);
        });
        return map;
    }
    const { tagStore: tagStore } = props;
    const updateSelectionIndustry = (selected)=>{
        var updated = [];
        selected.forEach((selection)=>{
            if (!updated.find((item)=>item.value == selection.value)) updated.push({
                value: selection.value
            });
        });
        //setMultiSelectionsIndustry(updated);
        tagStore.taggedIds = updated;
    };
    function filterBy(option, ticker) {
        return option.value.toLowerCase().indexOf(ticker.text.toLowerCase()) > -1;
    }
    var typeahead_props = {};
    typeahead_props['renderMenu'] = (results, _a, state)=>{
        var { newSelectionPrefix: newSelectionPrefix, paginationText: paginationText, renderMenuItemChildren: renderMenuItemChildren } = _a, menuProps = $9640fc307de8e8aa$var$__rest(_a, [
            "newSelectionPrefix",
            "paginationText",
            "renderMenuItemChildren"
        ]);
        let index = 0;
        const list = groupBy(results, (a)=>a.industry);
        const items = Object.keys(list).sort().map((region)=>{
            var subitems = list[region];
            var header = (0, $kSbwP.jsx)((0, $6dc2979d3137cf1b$export$2e2bcd8739ae039).Header, {
                children: region
            });
            if (subitems[0].value == region) //kind of hackish
            header = null;
            return (0, $kSbwP.jsxs)((0, $8nGP5.Fragment), {
                children: [
                    index !== 0 && (0, $kSbwP.jsx)((0, $6dc2979d3137cf1b$export$2e2bcd8739ae039).Divider, {}),
                    header,
                    subitems.map((i)=>{
                        var isSelected = tagStore.taggedIds.find((a)=>a.value == i.value);
                        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
                            [$11cc9488d14d0545$export$d90250155de6d7e7]: isSelected
                        });
                        const braileCount = i.value.split($9640fc307de8e8aa$var$SEPERATOR).length - 1;
                        const braile = $9640fc307de8e8aa$var$braileSpacing.repeat(braileCount);
                        const label = `${braile}${i.label}`;
                        const item = //<a aria-label="Consumer/Retail" aria-selected="false" id="industry-search-item-0" role="option" class="dropdown-item" href="#">Consumer/Retail</a>
                        (0, $kSbwP.jsx)((0, $0e525f254146d1c8$export$2e2bcd8739ae039), {
                            option: i,
                            position: index,
                            className: cls,
                            children: (0, $kSbwP.jsx)((0, $116510c3d59e0b2a$export$2e2bcd8739ae039), {
                                search: state.text,
                                children: label
                            })
                        }, index);
                        index += 1;
                        return item;
                    })
                ]
            }, region);
        });
        return (0, $kSbwP.jsx)((0, $6dc2979d3137cf1b$export$2e2bcd8739ae039), Object.assign({}, menuProps, {
            children: items
        }));
    };
    var options = [];
    if (allowSelectAll) options.push({
        label: $9640fc307de8e8aa$export$e5ac8460294ca616,
        value: $9640fc307de8e8aa$export$e5ac8460294ca616,
        industry: $9640fc307de8e8aa$export$e5ac8460294ca616
    });
    const industry = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)().industryTypes;
    industry.forEach((industry)=>{
        var name = industry.name;
        options.push({
            label: name,
            value: name,
            industry: name
        });
        industry.subtypes.forEach((sub_industry)=>{
            options.push({
                label: sub_industry.name,
                value: `${name}${$9640fc307de8e8aa$var$SEPERATOR}${sub_industry.name}`,
                industry: name
            });
        });
    });
    const selected = tagStore.taggedIds.map((item)=>{
        const parts = item.value.split($9640fc307de8e8aa$var$SEPERATOR);
        const label = parts[parts.length - 1];
        return {
            label: label,
            value: item.value,
            industry: parts[0]
        };
    });
    return (0, $kSbwP.jsx)((0, $987409511f795a07$export$2e2bcd8739ae039), Object.assign({}, typeahead_props, {
        id: "industry-search",
        className: $11cc9488d14d0545$export$37c8efd0a1d7c4c5,
        filterBy: filterBy,
        options: options,
        placeholder: "Filter by Industry",
        onChange: updateSelectionIndustry,
        selected: selected,
        multiple: true
    }));
});



//Get yearly value
//get Value
//default values
//Sources
// Break FieldsSchema into sub-structs based on categories
const $809f7f123ac5d4fa$export$90649b5dc12c94b1 = {
    net_revenue_per_year: {
        t: '$',
        yearly: true,
        field: 'revenue'
    },
    top_10_customers_revenue_percentage: {
        t: '%',
        yearly: true,
        field: 'percentage_of_revenue'
    },
    top_1_customers_revenue_percentage: {
        t: '%',
        yearly: true,
        field: 'percentage_of_revenue'
    },
    acquisition_ebitda_per_year: {
        t: '$',
        yearly: true,
        field: 'acquisition_ebitda'
    },
    acquisition_revenue_per_year: {
        t: '$',
        yearly: true,
        field: 'acquisition_revenue'
    },
    gross_profit_per_year: {
        t: '$',
        yearly: true,
        field: 'gross_profit'
    },
    fixed_asset_acquisitions_revenue_per_year: {
        t: '$',
        yearly: true,
        field: 'acquisition_rev'
    },
    recurring_revenue_percent_per_year: {
        t: '$',
        yearly: true,
        field: 'recurring_revenue_percent'
    },
    gross_retention_lost_only_per_year: {
        t: '$',
        yearly: true,
        field: 'gross_retention_lost_only'
    },
    net_retention_yearly: {
        t: '$',
        yearly: true,
        field: 'net_retention_percent'
    }
};
const $809f7f123ac5d4fa$export$3b47d575189433bc = {
    ebitda_per_year: {
        t: '$',
        yearly: true,
        field: 'ebitda'
    },
    adjusted_ebitda_per_year: {
        t: '$',
        yearly: true,
        field: 'adjusted_ebitda'
    }
};
const $809f7f123ac5d4fa$export$239fac331b09df39 = {
    capitalized_software_override: {
        t: '$',
        yearly: true,
        field: 'capitalized_software_override'
    },
    capitalized_software: {
        display: 'Capitalized Software',
        t: '$',
        yearly: true,
        field: 'capitalized_software'
    },
    capitalized_application_development: {
        display: 'Capitalized Application Development',
        t: '$',
        yearly: true,
        field: 'capitalized_application_development'
    },
    capitalized_rnd: {
        display: 'Capitalized R&D',
        t: '$',
        yearly: true,
        field: 'capitalized_rnd'
    }
};
const $809f7f123ac5d4fa$export$1fdd607427d5a745 = {
    capex_per_year: {
        t: '$',
        yearly: true,
        field: 'capex'
    },
    maintenance_capex_per_year: {
        t: '$',
        yearly: true,
        field: 'maintenance_capex'
    },
    growth_capex_per_year: {
        t: '$',
        yearly: true,
        field: 'growth_capex'
    },
    total_current_assets_yearly: {
        t: '$',
        yearly: true,
        field: 'total_current_assets'
    },
    total_current_liabilities_yearly: {
        t: '$',
        yearly: true,
        field: 'total_current_liabilities'
    },
    historical_market_size: {
        t: '%',
        yearly: true,
        field: 'historic_market_size'
    },
    projected_market_size: {
        t: '%',
        yearly: true,
        field: 'projected_market_size'
    },
    list_years_actualized_revenue: {
        t: 'array'
    },
    list_years_projected_revenue: {
        t: 'array'
    },
    recurring_revenue_summary: {
        t: 'bool'
    },
    company_name: {
        t: 'str'
    },
    company_overview: {
        t: 'str'
    },
    company_main_market: {
        t: 'str'
    },
    company_ceo: {
        t: 'str'
    },
    hq_location: {
        t: 'str'
    },
    year_founded: {
        t: 'year'
    },
    industry: {
        t: 'str'
    },
    industrySubType: {
        t: 'str'
    },
    subscription_revenue: {
        t: 'bool'
    },
    recurring_revenue_stream: {
        t: 'bool'
    },
    contractual_revenue: {
        t: 'bool'
    },
    total_addressable_market: {
        t: '$'
    },
    market_share: {
        t: '%'
    },
    historical_market_growth: {
        t: '%'
    },
    projected_market_growth: {
        t: '%'
    },
    last_full_fiscal_year_reported: {
        t: 'int'
    }
};
const $809f7f123ac5d4fa$export$be4faee424ea3a71 = Object.assign(Object.assign(Object.assign(Object.assign({}, $809f7f123ac5d4fa$export$90649b5dc12c94b1), $809f7f123ac5d4fa$export$3b47d575189433bc), $809f7f123ac5d4fa$export$239fac331b09df39), $809f7f123ac5d4fa$export$1fdd607427d5a745);
const $809f7f123ac5d4fa$export$3266a7a951967395 = {
    extended_selected_ebitda: {
        t: 'str',
        display: 'EBITDA Used for Comparison'
    },
    organic_cagr_N_years: {
        t: '%',
        display: 'Year(s) Historical Organic Revenue CAGR',
        dynDisplayPrefix: '$DATA_PICK_KEY-'
    },
    organic_cagr_4_years: {
        t: '%',
        display: '4-Year Historical Organic Revenue CAGR'
    },
    organic_cagr_3_years: {
        t: '%',
        display: '3-Year Historical Organic Revenue CAGR'
    },
    projected_organic_cagr_N_years: {
        t: '%',
        display: 'Year(s) Projected Organic Revenue CAGR',
        dynDisplayPrefix: '$DATA_PICK_KEY-'
    },
    projected_organic_cagr_3_years: {
        t: '%',
        display: '3-Year Projected Organic Revenue CAGR'
    },
    projected_organic_cagr_4_years: {
        t: '%',
        display: '4-Year Projected Organic Revenue CAGR'
    },
    projected_organic_cagr_N_years_minus_tam_growth: {
        t: '%',
        display: 'Relative Growth Rate (Company Growth less Market Growth)'
    },
    adj_ebitda_margin: {
        t: '%',
        display: 'Adjusted EBITDA Margin',
        dynDisplay: '%SELECTED_EBITDA% Margin'
    },
    adj_ebitda_margin_trend: {
        t: '%',
        display: 'Adjusted Ebitda Margin versus Two Years Ago',
        dynDisplay: '%SELECTED_EBITDA% Margin versus Two Years Ago'
    },
    adj_ebitda: {
        t: '$',
        display: 'Adjusted Ebitda',
        dynDisplay: '%SELECTED_EBITDA%'
    },
    gross_retention: {
        t: '%',
        display: 'Gross Retention Rate'
    },
    net_retention: {
        t: '%',
        display: 'Net Retention Rate',
        scale: 100
    },
    ebitda_magnatitude_adjustment: {
        t: '%',
        display: '% of Adjusted EBITDA from Adjustments'
    },
    fcf_conversion_ebitda: {
        t: '%',
        display: ''
    },
    nwc_as_percent_of_revenue: {
        t: '%',
        display: 'New Working Capital, as a % of Revenue'
    },
    free_cash_flow_conversion: {
        t: '%',
        display: 'Free Cash Flow Conversion'
    },
    total_capex_by_rev: {
        t: '%',
        display: 'CapEx, as a % of Revenue'
    },
    total_addressable_market: {
        t: '$',
        display: 'Total Addressable Market Size'
    },
    historical_market_growth: {
        t: '%',
        display: 'Historical Market Growth Rate',
        scale: 100
    },
    projected_market_growth: {
        t: '%',
        display: 'Projected Market Growth Rate',
        scale: 100
    },
    recurring_revenue_summary: {
        t: 'bool',
        display: 'Contractual Revenue'
    },
    gross_profit_margin: {
        t: '%',
        display: 'Gross Profit Margin'
    },
    gross_profit: {
        t: '$',
        display: 'Gross Profit'
    },
    industry: {
        t: 'str',
        display: 'Industry'
    },
    industrySubType: {
        t: 'str',
        display: 'Sub-Industry'
    },
    company_ceo: {
        t: 'str',
        display: 'CEO'
    },
    hq_location: {
        t: 'str',
        display: 'HQ Location'
    },
    year_founded: {
        t: 'str',
        display: 'Founded'
    },
    last_full_fiscal_year_reported: {
        t: 'str',
        display: 'Actuals As Of'
    },
    revenue_latest: {
        t: '$',
        display: 'Revenue'
    }
};


const $7fbd760f3c05e83d$export$c47d79b712795940 = (s)=>{
    try {
        if (!s) return 0;
        if (s == 'N/A') return 0;
        return parseInt(s.toString().match(/(-)?\d+[\.,\d+]*/)[0].replace(',', ''));
    } catch (e) {
        return 0;
    }
};
const $7fbd760f3c05e83d$export$c0080068ec287465 = (s)=>{
    try {
        if (!s) return 0;
        if (s == 'N/A') return 0;
        return parseFloat(s.toString().match(/(-)?\d+[\.,\d+]*/)[0].replace(',', ''));
    } catch (e) {
        return 0;
    }
};
const $7fbd760f3c05e83d$export$4ba1d6600e2a2892 = (s)=>{
    try {
        if (!s) return false;
        if (s == 'N/A') return false;
        return !isNaN(parseFloat(s.match(/\d+[\.,\d+]*/)[0]));
    } catch (e) {
        return false;
    }
};
const $7fbd760f3c05e83d$export$357fc28f6427af8b = (s)=>{
    try {
        if (!s) return false;
        if (s == 'N/A') return false;
        return !isNaN(parseInt(s.toString().match(/\d+[\.,\d+]*/)[0]));
    } catch (e) {
        return false;
    }
};
function $7fbd760f3c05e83d$var$isString(s) {
    return typeof s === 'string' || s instanceof String;
}
const $7fbd760f3c05e83d$var$EMPTY_RETURN = '-';
const $7fbd760f3c05e83d$export$48d3f001ea9fddb0 = (s, sizeConversion = 'auto')=>{
    function formatNumberCommas(num) {
        return num.toFixed(1).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    if (!s || s == 'N/A' || s == 'NaN') return $7fbd760f3c05e83d$var$EMPTY_RETURN;
    if ($7fbd760f3c05e83d$var$isString(s)) {
        var str = s;
        if (str == '' || str == 'N/A' || str == 'NaN') return $7fbd760f3c05e83d$var$EMPTY_RETURN;
        if ($7fbd760f3c05e83d$export$4ba1d6600e2a2892(str)) {
            var num = $7fbd760f3c05e83d$export$c0080068ec287465(str);
            var absNum = Math.abs(num);
            var letterToAdd = '';
            //Values expected in MILLIONS
            if (sizeConversion === 'auto') {
                if (absNum != 0) {
                    if (absNum > 1000) {
                        letterToAdd = 'B';
                        num = num / 1000;
                    } else if (absNum < 1) {
                        num = num * 1000;
                        letterToAdd = 'K';
                    }
                }
            }
            var numDisplay = formatNumberCommas(Math.abs(num)) + letterToAdd;
            if (num >= 0) return '$' + numDisplay;
            else return '-$' + numDisplay;
        } else return $7fbd760f3c05e83d$var$EMPTY_RETURN;
    } else return $7fbd760f3c05e83d$var$EMPTY_RETURN;
};
const $7fbd760f3c05e83d$export$e440a706af0c0216 = (s, multiplyBy = 100)=>{
    if (!s) return $7fbd760f3c05e83d$var$EMPTY_RETURN;
    if ($7fbd760f3c05e83d$var$isString(s)) {
        var str = s;
        if (str == '' || str == 'N/A') return $7fbd760f3c05e83d$var$EMPTY_RETURN;
        if ($7fbd760f3c05e83d$export$4ba1d6600e2a2892(str)) {
            var num = $7fbd760f3c05e83d$export$c0080068ec287465(str);
            var r = (num * multiplyBy).toFixed(1) + '%';
            return r;
        } else return $7fbd760f3c05e83d$var$EMPTY_RETURN;
    } else return $7fbd760f3c05e83d$var$EMPTY_RETURN;
};
const $7fbd760f3c05e83d$export$5e10dcd5066a208c = (url)=>{
    if (!url) return url;
    return url.split('?')[0];
};


var $e0f2436fd88d0d31$exports = {};
/**
 * marked v15.0.9 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory($e0f2436fd88d0d31$exports);
})($e0f2436fd88d0d31$exports, function(exports1) {
    'use strict';
    /**
     * Gets the original marked default options.
     */ function _getDefaults() {
        return {
            async: false,
            breaks: false,
            extensions: null,
            gfm: true,
            hooks: null,
            pedantic: false,
            renderer: null,
            silent: false,
            tokenizer: null,
            walkTokens: null
        };
    }
    exports1.defaults = _getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    const noopTest = {
        exec: ()=>null
    };
    function edit(regex, opt = '') {
        let source = typeof regex === 'string' ? regex : regex.source;
        const obj = {
            replace: (name, val)=>{
                let valSource = typeof val === 'string' ? val : val.source;
                valSource = valSource.replace(other.caret, '$1');
                source = source.replace(name, valSource);
                return obj;
            },
            getRegex: ()=>{
                return new RegExp(source, opt);
            }
        };
        return obj;
    }
    const other = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceTabs: /^\t+/,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] /,
        listReplaceTask: /^\[[ xX]\] +/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (bull)=>new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`),
        hrRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
        htmlBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, 'i')
    };
    /**
     * Block-Level Grammar
     */ const newline = /^(?:[ \t]*(?:\n|$))+/;
    const blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
    const fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
    const hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
    const heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
    const bullet = /(?:[*+-]|\d{1,9}[.)])/;
    const lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
    const lheading = edit(lheadingCore).replace(/bull/g, bullet) // lists can interrupt
    .replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
    .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
    .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
    .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
    .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
    .replace(/\|table/g, '') // table not in commonmark
    .getRegex();
    const lheadingGfm = edit(lheadingCore).replace(/bull/g, bullet) // lists can interrupt
    .replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
    .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
    .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
    .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
    .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
    .replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/) // table can interrupt
    .getRegex();
    const _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
    const blockText = /^[^\n]+/;
    const _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    const def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace('label', _blockLabel).replace('title', /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
    const list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
    const _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    const _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
    const html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", 'i').replace('comment', _comment).replace('tag', _tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    const paragraph = edit(_paragraph).replace('hr', hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
    .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', _tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    const blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace('paragraph', paragraph).getRegex();
    /**
     * Normal Block Grammar
     */ const blockNormal = {
        blockquote: blockquote,
        code: blockCode,
        def: def,
        fences: fences,
        heading: heading,
        hr: hr,
        html: html,
        lheading: lheading,
        list: list,
        newline: newline,
        paragraph: paragraph,
        table: noopTest,
        text: blockText
    };
    /**
     * GFM Block Grammar
     */ const gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)") // Cells
    .replace('hr', hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('blockquote', ' {0,3}>').replace('code', '(?: {4}| {0,3}\t)[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', _tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    const blockGfm = {
        ...blockNormal,
        lheading: lheadingGfm,
        table: gfmTable,
        paragraph: edit(_paragraph).replace('hr', hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
        .replace('table', gfmTable) // interrupt paragraphs with table
        .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
        .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', _tag) // pars can be interrupted by type (6) html blocks
        .getRegex()
    };
    /**
     * Pedantic grammar (original John Gruber's loose markdown specification)
     */ const blockPedantic = {
        ...blockNormal,
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace('comment', _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(_paragraph).replace('hr', hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', lheading).replace('|table', '').replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').replace('|tag', '').getRegex()
    };
    /**
     * Inline-Level Grammar
     */ const escape$1 = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
    const inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
    const br = /^( {2,}|\\)\n(?!\s*$)/;
    const inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
    // list of unicode punctuation marks, plus any missing characters from CommonMark spec
    const _punctuation = /[\p{P}\p{S}]/u;
    const _punctuationOrSpace = /[\s\p{P}\p{S}]/u;
    const _notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
    const punctuation = edit(/^((?![*_])punctSpace)/, 'u').replace(/punctSpace/g, _punctuationOrSpace).getRegex();
    // GFM allows ~ inside strong and em for strikethrough
    const _punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
    const _punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
    const _notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
    // sequences em should skip over [title](link), `code`, <html>
    const blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
    const emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
    const emStrongLDelim = edit(emStrongLDelimCore, 'u').replace(/punct/g, _punctuation).getRegex();
    const emStrongLDelimGfm = edit(emStrongLDelimCore, 'u').replace(/punct/g, _punctuationGfmStrongEm).getRegex();
    const emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)"; // (6) a***a can be either Left or Right Delimiter
    const emStrongRDelimAst = edit(emStrongRDelimAstCore, 'gu').replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
    const emStrongRDelimAstGfm = edit(emStrongRDelimAstCore, 'gu').replace(/notPunctSpace/g, _notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, _punctuationOrSpaceGfmStrongEm).replace(/punct/g, _punctuationGfmStrongEm).getRegex();
    // (6) Not allowed for _
    const emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", 'gu') // (5) #___# can be either Left or Right Delimiter
    .replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
    const anyPunctuation = edit(/\\(punct)/, 'gu').replace(/punct/g, _punctuation).getRegex();
    const autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace('scheme', /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace('email', /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
    const _inlineComment = edit(_comment).replace('(?:-->|$)', '-->').getRegex();
    const tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>") // CDATA section
    .replace('comment', _inlineComment).replace('attribute', /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
    const _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    const link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace('label', _inlineLabel).replace('href', /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace('title', /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
    const reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace('label', _inlineLabel).replace('ref', _blockLabel).getRegex();
    const nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace('ref', _blockLabel).getRegex();
    const reflinkSearch = edit('reflink|nolink(?!\\()', 'g').replace('reflink', reflink).replace('nolink', nolink).getRegex();
    /**
     * Normal Inline Grammar
     */ const inlineNormal = {
        _backpedal: noopTest,
        anyPunctuation: anyPunctuation,
        autolink: autolink,
        blockSkip: blockSkip,
        br: br,
        code: inlineCode,
        del: noopTest,
        emStrongLDelim: emStrongLDelim,
        emStrongRDelimAst: emStrongRDelimAst,
        emStrongRDelimUnd: emStrongRDelimUnd,
        escape: escape$1,
        link: link,
        nolink: nolink,
        punctuation: punctuation,
        reflink: reflink,
        reflinkSearch: reflinkSearch,
        tag: tag,
        text: inlineText,
        url: noopTest
    };
    /**
     * Pedantic Inline Grammar
     */ const inlinePedantic = {
        ...inlineNormal,
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', _inlineLabel).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', _inlineLabel).getRegex()
    };
    /**
     * GFM Inline Grammar
     */ const inlineGfm = {
        ...inlineNormal,
        emStrongRDelimAst: emStrongRDelimAstGfm,
        emStrongLDelim: emStrongLDelimGfm,
        url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, 'i').replace('email', /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    };
    /**
     * GFM + Line Breaks Inline Grammar
     */ const inlineBreaks = {
        ...inlineGfm,
        br: edit(br).replace('{2,}', '*').getRegex(),
        text: edit(inlineGfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
    };
    /**
     * exports
     */ const block = {
        normal: blockNormal,
        gfm: blockGfm,
        pedantic: blockPedantic
    };
    const inline = {
        normal: inlineNormal,
        gfm: inlineGfm,
        breaks: inlineBreaks,
        pedantic: inlinePedantic
    };
    /**
     * Helpers
     */ const escapeReplacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    const getEscapeReplacement = (ch)=>escapeReplacements[ch];
    function escape(html, encode) {
        if (encode) {
            if (other.escapeTest.test(html)) return html.replace(other.escapeReplace, getEscapeReplacement);
        } else {
            if (other.escapeTestNoEncode.test(html)) return html.replace(other.escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    function cleanUrl(href) {
        try {
            href = encodeURI(href).replace(other.percentDecode, '%');
        } catch  {
            return null;
        }
        return href;
    }
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        const row = tableRow.replace(other.findPipe, (match, offset, str)=>{
            let escaped = false;
            let curr = offset;
            while(--curr >= 0 && str[curr] === '\\')escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return '|';
            else // add space before unescaped |
            return ' |';
        }), cells = row.split(other.splitPipe);
        let i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells.at(-1)?.trim()) cells.pop();
        if (count) {
            if (cells.length > count) cells.splice(count);
            else while(cells.length < count)cells.push('');
        }
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(other.slashPipe, '|');
        return cells;
    }
    /**
     * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
     * /c*$/ is vulnerable to REDOS.
     *
     * @param str
     * @param c
     * @param invert Remove suffix of non-c chars instead. Default falsey.
     */ function rtrim(str, c, invert) {
        const l = str.length;
        if (l === 0) return '';
        // Length of suffix matching the invert condition.
        let suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            const currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && true) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        let level = 0;
        for(let i = 0; i < str.length; i++){
            if (str[i] === '\\') i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        if (level > 0) return -2;
        return -1;
    }
    function outputLink(cap, link, raw, lexer, rules) {
        const href = link.href;
        const title = link.title || null;
        const text = cap[1].replace(rules.other.outputLinkReplace, '$1');
        if (cap[0].charAt(0) !== '!') {
            lexer.state.inLink = true;
            const token = {
                type: 'link',
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: 'image',
            raw: raw,
            href: href,
            title: title,
            text: text
        };
    }
    function indentCodeCompensation(raw, text, rules) {
        const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
        if (matchIndentToCode === null) return text;
        const indentToCode = matchIndentToCode[1];
        return text.split('\n').map((node)=>{
            const matchIndentInNode = node.match(rules.other.beginningSpace);
            if (matchIndentInNode === null) return node;
            const [indentInNode] = matchIndentInNode;
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join('\n');
    }
    /**
     * Tokenizer
     */ class _Tokenizer {
        options;
        rules;
        lexer;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(src) {
            const cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: 'space',
                raw: cap[0]
            };
        }
        code(src) {
            const cap = this.rules.block.code.exec(src);
            if (cap) {
                const text = cap[0].replace(this.rules.other.codeRemoveIndent, '');
                return {
                    type: 'code',
                    raw: cap[0],
                    codeBlockStyle: 'indented',
                    text: !this.options.pedantic ? rtrim(text, '\n') : text
                };
            }
        }
        fences(src) {
            const cap = this.rules.block.fences.exec(src);
            if (cap) {
                const raw = cap[0];
                const text = indentCodeCompensation(raw, cap[3] || '', this.rules);
                return {
                    type: 'code',
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, '$1') : cap[2],
                    text: text
                };
            }
        }
        heading(src) {
            const cap = this.rules.block.heading.exec(src);
            if (cap) {
                let text = cap[2].trim();
                // remove trailing #s
                if (this.rules.other.endingHash.test(text)) {
                    const trimmed = rtrim(text, '#');
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        hr(src) {
            const cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: 'hr',
                raw: rtrim(cap[0], '\n')
            };
        }
        blockquote(src) {
            const cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                let lines = rtrim(cap[0], '\n').split('\n');
                let raw = '';
                let text = '';
                const tokens = [];
                while(lines.length > 0){
                    let inBlockquote = false;
                    const currentLines = [];
                    let i;
                    for(i = 0; i < lines.length; i++){
                        // get lines up to a continuation
                        if (this.rules.other.blockquoteStart.test(lines[i])) {
                            currentLines.push(lines[i]);
                            inBlockquote = true;
                        } else if (!inBlockquote) currentLines.push(lines[i]);
                        else break;
                    }
                    lines = lines.slice(i);
                    const currentRaw = currentLines.join('\n');
                    const currentText = currentRaw// precede setext continuation with 4 spaces so it isn't a setext
                    .replace(this.rules.other.blockquoteSetextReplace, '\n    $1').replace(this.rules.other.blockquoteSetextReplace2, '');
                    raw = raw ? `${raw}\n${currentRaw}` : currentRaw;
                    text = text ? `${text}\n${currentText}` : currentText;
                    // parse blockquote lines as top level tokens
                    // merge paragraphs if this is a continuation
                    const top = this.lexer.state.top;
                    this.lexer.state.top = true;
                    this.lexer.blockTokens(currentText, tokens, true);
                    this.lexer.state.top = top;
                    // if there is no continuation then we are done
                    if (lines.length === 0) break;
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === 'code') break;
                    else if (lastToken?.type === 'blockquote') {
                        // include continuation in nested blockquote
                        const oldToken = lastToken;
                        const newText = oldToken.raw + '\n' + lines.join('\n');
                        const newToken = this.blockquote(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                        break;
                    } else if (lastToken?.type === 'list') {
                        // include continuation in nested list
                        const oldToken = lastToken;
                        const newText = oldToken.raw + '\n' + lines.join('\n');
                        const newToken = this.list(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                        lines = newText.substring(tokens.at(-1).raw.length).split('\n');
                        continue;
                    }
                }
                return {
                    type: 'blockquote',
                    raw: raw,
                    tokens: tokens,
                    text: text
                };
            }
        }
        list(src) {
            let cap = this.rules.block.list.exec(src);
            if (cap) {
                let bull = cap[1].trim();
                const isordered = bull.length > 1;
                const list = {
                    type: 'list',
                    raw: '',
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : '',
                    loose: false,
                    items: []
                };
                bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                if (this.options.pedantic) bull = isordered ? bull : '[*+-]';
                // Get next list item
                const itemRegex = this.rules.other.listItemRegex(bull);
                let endsWithBlankLine = false;
                // Check if current bullet point can start a new List Item
                while(src){
                    let endEarly = false;
                    let raw = '';
                    let itemContents = '';
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    let line = cap[2].split('\n', 1)[0].replace(this.rules.other.listReplaceTabs, (t)=>' '.repeat(3 * t.length));
                    let nextLine = src.split('\n', 1)[0];
                    let blankLine = !line.trim();
                    let indent = 0;
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimStart();
                    } else if (blankLine) indent = cap[1].length + 1;
                    else {
                        indent = cap[2].search(this.rules.other.nonSpaceChar); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                        raw += nextLine + '\n';
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                        const hrRegex = this.rules.other.hrRegex(indent);
                        const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                        const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                        const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                        // Check if following lines should be included in List Item
                        while(src){
                            const rawLine = src.split('\n', 1)[0];
                            let nextLineWithoutTabs;
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) {
                                nextLine = nextLine.replace(this.rules.other.listReplaceNesting, '  ');
                                nextLineWithoutTabs = nextLine;
                            } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, '    ');
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of html block
                            if (htmlBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(nextLine)) break;
                            if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += '\n' + nextLineWithoutTabs.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.replace(this.rules.other.tabCharGlobal, '    ').search(this.rules.other.nonSpaceChar) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += '\n' + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) blankLine = true;
                            raw += rawLine + '\n';
                            src = src.substring(rawLine.length + 1);
                            line = nextLineWithoutTabs.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                    }
                    let istask = null;
                    let ischecked;
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = this.rules.other.listIsTask.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== '[ ] ';
                            itemContents = itemContents.replace(this.rules.other.listReplaceTask, '');
                        }
                    }
                    list.items.push({
                        type: 'list_item',
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents,
                        tokens: []
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                const lastItem = list.items.at(-1);
                if (lastItem) {
                    lastItem.raw = lastItem.raw.trimEnd();
                    lastItem.text = lastItem.text.trimEnd();
                } else // not a list since there were no items
                return;
                list.raw = list.raw.trimEnd();
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(let i = 0; i < list.items.length; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        const spacers = list.items[i].tokens.filter((t)=>t.type === 'space');
                        const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>this.rules.other.anyLine.test(t.raw));
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
                return list;
            }
        }
        html(src) {
            const cap = this.rules.block.html.exec(src);
            if (cap) {
                const token = {
                    type: 'html',
                    block: true,
                    raw: cap[0],
                    pre: cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style',
                    text: cap[0]
                };
                return token;
            }
        }
        def(src) {
            const cap = this.rules.block.def.exec(src);
            if (cap) {
                const tag = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, ' ');
                const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, '$1').replace(this.rules.inline.anyPunctuation, '$1') : '';
                const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, '$1') : cap[3];
                return {
                    type: 'def',
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        }
        table(src) {
            const cap = this.rules.block.table.exec(src);
            if (!cap) return;
            if (!this.rules.other.tableDelimiter.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
            return;
            const headers = splitCells(cap[1]);
            const aligns = cap[2].replace(this.rules.other.tableAlignChars, '').split('|');
            const rows = cap[3]?.trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, '').split('\n') : [];
            const item = {
                type: 'table',
                raw: cap[0],
                header: [],
                align: [],
                rows: []
            };
            if (headers.length !== aligns.length) // header and align columns must be equal, rows can be different.
            return;
            for (const align of aligns){
                if (this.rules.other.tableAlignRight.test(align)) item.align.push('right');
                else if (this.rules.other.tableAlignCenter.test(align)) item.align.push('center');
                else if (this.rules.other.tableAlignLeft.test(align)) item.align.push('left');
                else item.align.push(null);
            }
            for(let i = 0; i < headers.length; i++)item.header.push({
                text: headers[i],
                tokens: this.lexer.inline(headers[i]),
                header: true,
                align: item.align[i]
            });
            for (const row of rows)item.rows.push(splitCells(row, item.header.length).map((cell, i)=>{
                return {
                    text: cell,
                    tokens: this.lexer.inline(cell),
                    header: false,
                    align: item.align[i]
                };
            }));
            return item;
        }
        lheading(src) {
            const cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: 'heading',
                raw: cap[0],
                depth: cap[2].charAt(0) === '=' ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        }
        paragraph(src) {
            const cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                const text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: 'paragraph',
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        text(src) {
            const cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: 'text',
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        }
        escape(src) {
            const cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: 'escape',
                raw: cap[0],
                text: cap[1]
            };
        }
        tag(src) {
            const cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: 'html',
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    block: false,
                    text: cap[0]
                };
            }
        }
        link(src) {
            const cap = this.rules.inline.link.exec(src);
            if (cap) {
                const trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    const lastParenIndex = findClosingBracket(cap[2], '()');
                    if (lastParenIndex === -2) // more open parens than closed
                    return;
                    if (lastParenIndex > -1) {
                        const start = cap[0].indexOf('!') === 0 ? 5 : 4;
                        const linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = '';
                    }
                }
                let href = cap[2];
                let title = '';
                if (this.options.pedantic) {
                    // split pedantic href and title
                    const link = this.rules.other.pedanticHrefTitle.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : '';
                href = href.trim();
                if (this.rules.other.startAngleBracket.test(href)) {
                    if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline.anyPunctuation, '$1') : href,
                    title: title ? title.replace(this.rules.inline.anyPunctuation, '$1') : title
                }, cap[0], this.lexer, this.rules);
            }
        }
        reflink(src, links) {
            let cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, ' ');
                const link = links[linkString.toLowerCase()];
                if (!link) {
                    const text = cap[0].charAt(0);
                    return {
                        type: 'text',
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer, this.rules);
            }
        }
        emStrong(src, maskedSrc, prevChar = '') {
            let match = this.rules.inline.emStrongLDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
            const nextChar = match[1] || match[2] || '';
            if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
                const lLength = [
                    ...match[0]
                ].length - 1;
                let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                const endReg = match[0][0] === '*' ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = [
                        ...rDelim
                    ].length;
                    if (match[3] || match[4]) {
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    // char length can be >1 for unicode characters;
                    const lastCharLength = [
                        ...match[0]
                    ][0].length;
                    const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        const text = raw.slice(1, -1);
                        return {
                            type: 'em',
                            raw: raw,
                            text: text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    const text = raw.slice(2, -2);
                    return {
                        type: 'strong',
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        }
        codespan(src) {
            const cap = this.rules.inline.code.exec(src);
            if (cap) {
                let text = cap[2].replace(this.rules.other.newLineCharGlobal, ' ');
                const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
                const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                return {
                    type: 'codespan',
                    raw: cap[0],
                    text: text
                };
            }
        }
        br(src) {
            const cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: 'br',
                raw: cap[0]
            };
        }
        del(src) {
            const cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: 'del',
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        }
        autolink(src) {
            const cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                let text, href;
                if (cap[2] === '@') {
                    text = cap[1];
                    href = 'mailto:' + text;
                } else {
                    text = cap[1];
                    href = text;
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        url(src) {
            let cap;
            if (cap = this.rules.inline.url.exec(src)) {
                let text, href;
                if (cap[2] === '@') {
                    text = cap[0];
                    href = 'mailto:' + text;
                } else {
                    // do extended autolink path validation
                    let prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? '';
                    }while (prevCapZero !== cap[0]);
                    text = cap[0];
                    if (cap[1] === 'www.') href = 'http://' + cap[0];
                    else href = cap[0];
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        inlineText(src) {
            const cap = this.rules.inline.text.exec(src);
            if (cap) {
                const escaped = this.lexer.state.inRawBlock;
                return {
                    type: 'text',
                    raw: cap[0],
                    text: cap[0],
                    escaped: escaped
                };
            }
        }
    }
    /**
     * Block Lexer
     */ class _Lexer {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(options){
            // TokenList cannot be created in one go
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            const rules = {
                other: other,
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
         * Expose Rules
         */ static get rules() {
            return {
                block: block,
                inline: inline
            };
        }
        /**
         * Static Lex Method
         */ static lex(src, options) {
            const lexer = new _Lexer(options);
            return lexer.lex(src);
        }
        /**
         * Static Lex Inline Method
         */ static lexInline(src, options) {
            const lexer = new _Lexer(options);
            return lexer.inlineTokens(src);
        }
        /**
         * Preprocessing
         */ lex(src) {
            src = src.replace(other.carriageReturn, '\n');
            this.blockTokens(src, this.tokens);
            for(let i = 0; i < this.inlineQueue.length; i++){
                const next = this.inlineQueue[i];
                this.inlineTokens(next.src, next.tokens);
            }
            this.inlineQueue = [];
            return this.tokens;
        }
        blockTokens(src, tokens = [], lastParagraphClipped = false) {
            if (this.options.pedantic) src = src.replace(other.tabCharGlobal, '    ').replace(other.spaceLine, '');
            while(src){
                let token;
                if (this.options.extensions?.block?.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (token.raw.length === 1 && lastToken !== undefined) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unnecessary paragraph tags
                    lastToken.raw += '\n';
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken?.type === 'paragraph' || lastToken?.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === 'paragraph' || lastToken?.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.raw;
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                let cutSrc = src;
                if (this.options.extensions?.startBlock) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startBlock.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    const lastToken = tokens.at(-1);
                    if (lastParagraphClipped && lastToken?.type === 'paragraph') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        }
        inline(src, tokens = []) {
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        }
        /**
         * Lexing/Compiling
         */ inlineTokens(src, tokens = []) {
            // String with links masked to avoid interference with em and strong
            let maskedSrc = src;
            let match = null;
            // Mask out reflinks
            if (this.tokens.links) {
                const links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out escaped characters
            while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            let keepPrevChar = false;
            let prevChar = '';
            while(src){
                if (!keepPrevChar) prevChar = '';
                keepPrevChar = false;
                let token;
                // extensions
                if (this.options.extensions?.inline?.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (token.type === 'text' && lastToken?.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                let cutSrc = src;
                if (this.options.extensions?.startInline) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startInline.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (token = this.tokenizer.inlineText(cutSrc)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== '_') prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        }
    }
    /**
     * Renderer
     */ class _Renderer {
        options;
        parser;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(token) {
            return '';
        }
        code({ text: text, lang: lang, escaped: escaped }) {
            const langString = (lang || '').match(other.notSpaceStart)?.[0];
            const code = text.replace(other.endingNewline, '') + '\n';
            if (!langString) return '<pre><code>' + (escaped ? code : escape(code, true)) + '</code></pre>\n';
            return '<pre><code class="language-' + escape(langString) + '">' + (escaped ? code : escape(code, true)) + '</code></pre>\n';
        }
        blockquote({ tokens: tokens }) {
            const body = this.parser.parse(tokens);
            return `<blockquote>\n${body}</blockquote>\n`;
        }
        html({ text: text }) {
            return text;
        }
        heading({ tokens: tokens, depth: depth }) {
            return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>\n`;
        }
        hr(token) {
            return '<hr>\n';
        }
        list(token) {
            const ordered = token.ordered;
            const start = token.start;
            let body = '';
            for(let j = 0; j < token.items.length; j++){
                const item = token.items[j];
                body += this.listitem(item);
            }
            const type = ordered ? 'ol' : 'ul';
            const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : '';
            return '<' + type + startAttr + '>\n' + body + '</' + type + '>\n';
        }
        listitem(item) {
            let itemBody = '';
            if (item.task) {
                const checkbox = this.checkbox({
                    checked: !!item.checked
                });
                if (item.loose) {
                    if (item.tokens[0]?.type === 'paragraph') {
                        item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                            item.tokens[0].tokens[0].text = checkbox + ' ' + escape(item.tokens[0].tokens[0].text);
                            item.tokens[0].tokens[0].escaped = true;
                        }
                    } else item.tokens.unshift({
                        type: 'text',
                        raw: checkbox + ' ',
                        text: checkbox + ' ',
                        escaped: true
                    });
                } else itemBody += checkbox + ' ';
            }
            itemBody += this.parser.parse(item.tokens, !!item.loose);
            return `<li>${itemBody}</li>\n`;
        }
        checkbox({ checked: checked }) {
            return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox">';
        }
        paragraph({ tokens: tokens }) {
            return `<p>${this.parser.parseInline(tokens)}</p>\n`;
        }
        table(token) {
            let header = '';
            // header
            let cell = '';
            for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
            header += this.tablerow({
                text: cell
            });
            let body = '';
            for(let j = 0; j < token.rows.length; j++){
                const row = token.rows[j];
                cell = '';
                for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
                body += this.tablerow({
                    text: cell
                });
            }
            if (body) body = `<tbody>${body}</tbody>`;
            return "<table>\n<thead>\n" + header + '</thead>\n' + body + '</table>\n';
        }
        tablerow({ text: text }) {
            return `<tr>\n${text}</tr>\n`;
        }
        tablecell(token) {
            const content = this.parser.parseInline(token.tokens);
            const type = token.header ? 'th' : 'td';
            const tag = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
            return tag + content + `</${type}>\n`;
        }
        /**
         * span level renderer
         */ strong({ tokens: tokens }) {
            return `<strong>${this.parser.parseInline(tokens)}</strong>`;
        }
        em({ tokens: tokens }) {
            return `<em>${this.parser.parseInline(tokens)}</em>`;
        }
        codespan({ text: text }) {
            return `<code>${escape(text, true)}</code>`;
        }
        br(token) {
            return '<br>';
        }
        del({ tokens: tokens }) {
            return `<del>${this.parser.parseInline(tokens)}</del>`;
        }
        link({ href: href, title: title, tokens: tokens }) {
            const text = this.parser.parseInline(tokens);
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = '<a href="' + href + '"';
            if (title) out += ' title="' + escape(title) + '"';
            out += '>' + text + '</a>';
            return out;
        }
        image({ href: href, title: title, text: text }) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return escape(text);
            href = cleanHref;
            let out = `<img src="${href}" alt="${text}"`;
            if (title) out += ` title="${escape(title)}"`;
            out += '>';
            return out;
        }
        text(token) {
            return 'tokens' in token && token.tokens ? this.parser.parseInline(token.tokens) : 'escaped' in token && token.escaped ? token.text : escape(token.text);
        }
    }
    /**
     * TextRenderer
     * returns only the textual part of the token
     */ class _TextRenderer {
        // no need for block level renderers
        strong({ text: text }) {
            return text;
        }
        em({ text: text }) {
            return text;
        }
        codespan({ text: text }) {
            return text;
        }
        del({ text: text }) {
            return text;
        }
        html({ text: text }) {
            return text;
        }
        text({ text: text }) {
            return text;
        }
        link({ text: text }) {
            return '' + text;
        }
        image({ text: text }) {
            return '' + text;
        }
        br() {
            return '';
        }
    }
    /**
     * Parsing & Compiling
     */ class _Parser {
        options;
        renderer;
        textRenderer;
        constructor(options){
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new _Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.renderer.parser = this;
            this.textRenderer = new _TextRenderer();
        }
        /**
         * Static Parse Method
         */ static parse(tokens, options) {
            const parser = new _Parser(options);
            return parser.parse(tokens);
        }
        /**
         * Static Parse Inline Method
         */ static parseInline(tokens, options) {
            const parser = new _Parser(options);
            return parser.parseInline(tokens);
        }
        /**
         * Parse Loop
         */ parse(tokens, top = true) {
            let out = '';
            for(let i = 0; i < tokens.length; i++){
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions?.renderers?.[anyToken.type]) {
                    const genericToken = anyToken;
                    const ret = this.options.extensions.renderers[genericToken.type].call({
                        parser: this
                    }, genericToken);
                    if (ret !== false || ![
                        'space',
                        'hr',
                        'heading',
                        'code',
                        'table',
                        'blockquote',
                        'list',
                        'html',
                        'paragraph',
                        'text'
                    ].includes(genericToken.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                const token = anyToken;
                switch(token.type){
                    case 'space':
                        out += this.renderer.space(token);
                        continue;
                    case 'hr':
                        out += this.renderer.hr(token);
                        continue;
                    case 'heading':
                        out += this.renderer.heading(token);
                        continue;
                    case 'code':
                        out += this.renderer.code(token);
                        continue;
                    case 'table':
                        out += this.renderer.table(token);
                        continue;
                    case 'blockquote':
                        out += this.renderer.blockquote(token);
                        continue;
                    case 'list':
                        out += this.renderer.list(token);
                        continue;
                    case 'html':
                        out += this.renderer.html(token);
                        continue;
                    case 'paragraph':
                        out += this.renderer.paragraph(token);
                        continue;
                    case 'text':
                        {
                            let textToken = token;
                            let body = this.renderer.text(textToken);
                            while(i + 1 < tokens.length && tokens[i + 1].type === 'text'){
                                textToken = tokens[++i];
                                body += '\n' + this.renderer.text(textToken);
                            }
                            if (top) out += this.renderer.paragraph({
                                type: 'paragraph',
                                raw: body,
                                text: body,
                                tokens: [
                                    {
                                        type: 'text',
                                        raw: body,
                                        text: body,
                                        escaped: true
                                    }
                                ]
                            });
                            else out += body;
                            continue;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return '';
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
        /**
         * Parse Inline Tokens
         */ parseInline(tokens, renderer = this.renderer) {
            let out = '';
            for(let i = 0; i < tokens.length; i++){
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions?.renderers?.[anyToken.type]) {
                    const ret = this.options.extensions.renderers[anyToken.type].call({
                        parser: this
                    }, anyToken);
                    if (ret !== false || ![
                        'escape',
                        'html',
                        'link',
                        'image',
                        'strong',
                        'em',
                        'codespan',
                        'br',
                        'del',
                        'text'
                    ].includes(anyToken.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                const token = anyToken;
                switch(token.type){
                    case 'escape':
                        out += renderer.text(token);
                        break;
                    case 'html':
                        out += renderer.html(token);
                        break;
                    case 'link':
                        out += renderer.link(token);
                        break;
                    case 'image':
                        out += renderer.image(token);
                        break;
                    case 'strong':
                        out += renderer.strong(token);
                        break;
                    case 'em':
                        out += renderer.em(token);
                        break;
                    case 'codespan':
                        out += renderer.codespan(token);
                        break;
                    case 'br':
                        out += renderer.br(token);
                        break;
                    case 'del':
                        out += renderer.del(token);
                        break;
                    case 'text':
                        out += renderer.text(token);
                        break;
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return '';
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
    }
    class _Hooks {
        options;
        block;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        static passThroughHooks = new Set([
            'preprocess',
            'postprocess',
            'processAllTokens'
        ]);
        /**
         * Process markdown before marked
         */ preprocess(markdown) {
            return markdown;
        }
        /**
         * Process HTML after marked is finished
         */ postprocess(html) {
            return html;
        }
        /**
         * Process all tokens before walk tokens
         */ processAllTokens(tokens) {
            return tokens;
        }
        /**
         * Provide function to tokenize markdown
         */ provideLexer() {
            return this.block ? _Lexer.lex : _Lexer.lexInline;
        }
        /**
         * Provide function to parse tokens
         */ provideParser() {
            return this.block ? _Parser.parse : _Parser.parseInline;
        }
    }
    class Marked {
        defaults = _getDefaults();
        options = this.setOptions;
        parse = this.parseMarkdown(true);
        parseInline = this.parseMarkdown(false);
        Parser = _Parser;
        Renderer = _Renderer;
        TextRenderer = _TextRenderer;
        Lexer = _Lexer;
        Tokenizer = _Tokenizer;
        Hooks = _Hooks;
        constructor(...args){
            this.use(...args);
        }
        /**
         * Run callback for every token
         */ walkTokens(tokens, callback) {
            let values = [];
            for (const token of tokens){
                values = values.concat(callback.call(this, token));
                switch(token.type){
                    case 'table':
                        {
                            const tableToken = token;
                            for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                            for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                            break;
                        }
                    case 'list':
                        {
                            const listToken = token;
                            values = values.concat(this.walkTokens(listToken.items, callback));
                            break;
                        }
                    default:
                        {
                            const genericToken = token;
                            if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                                const tokens = genericToken[childTokens].flat(Infinity);
                                values = values.concat(this.walkTokens(tokens, callback));
                            });
                            else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                        }
                }
            }
            return values;
        }
        use(...args) {
            const extensions = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            args.forEach((pack)=>{
                // copy options to new object
                const opts = {
                    ...pack
                };
                // set async to true if it was set to true before
                opts.async = this.defaults.async || opts.async || false;
                // ==-- Parse "addon" extensions --== //
                if (pack.extensions) {
                    pack.extensions.forEach((ext)=>{
                        if (!ext.name) throw new Error('extension name required');
                        if ('renderer' in ext) {
                            const prevRenderer = extensions.renderers[ext.name];
                            if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                            extensions.renderers[ext.name] = function(...args) {
                                let ret = ext.renderer.apply(this, args);
                                if (ret === false) ret = prevRenderer.apply(this, args);
                                return ret;
                            };
                            else extensions.renderers[ext.name] = ext.renderer;
                        }
                        if ('tokenizer' in ext) {
                            if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') throw new Error("extension level must be 'block' or 'inline'");
                            const extLevel = extensions[ext.level];
                            if (extLevel) extLevel.unshift(ext.tokenizer);
                            else extensions[ext.level] = [
                                ext.tokenizer
                            ];
                            if (ext.start) {
                                if (ext.level === 'block') {
                                    if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                    else extensions.startBlock = [
                                        ext.start
                                    ];
                                } else if (ext.level === 'inline') {
                                    if (extensions.startInline) extensions.startInline.push(ext.start);
                                    else extensions.startInline = [
                                        ext.start
                                    ];
                                }
                            }
                        }
                        if ('childTokens' in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                    });
                    opts.extensions = extensions;
                }
                // ==-- Parse "overwrite" extensions --== //
                if (pack.renderer) {
                    const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                    for(const prop in pack.renderer){
                        if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                        if ([
                            'options',
                            'parser'
                        ].includes(prop)) continue;
                        const rendererProp = prop;
                        const rendererFunc = pack.renderer[rendererProp];
                        const prevRenderer = renderer[rendererProp];
                        // Replace renderer with func to run extension, but fall back if false
                        renderer[rendererProp] = (...args)=>{
                            let ret = rendererFunc.apply(renderer, args);
                            if (ret === false) ret = prevRenderer.apply(renderer, args);
                            return ret || '';
                        };
                    }
                    opts.renderer = renderer;
                }
                if (pack.tokenizer) {
                    const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                    for(const prop in pack.tokenizer){
                        if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                        if ([
                            'options',
                            'rules',
                            'lexer'
                        ].includes(prop)) continue;
                        const tokenizerProp = prop;
                        const tokenizerFunc = pack.tokenizer[tokenizerProp];
                        const prevTokenizer = tokenizer[tokenizerProp];
                        // Replace tokenizer with func to run extension, but fall back if false
                        // @ts-expect-error cannot type tokenizer function dynamically
                        tokenizer[tokenizerProp] = (...args)=>{
                            let ret = tokenizerFunc.apply(tokenizer, args);
                            if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                            return ret;
                        };
                    }
                    opts.tokenizer = tokenizer;
                }
                // ==-- Parse Hooks extensions --== //
                if (pack.hooks) {
                    const hooks = this.defaults.hooks || new _Hooks();
                    for(const prop in pack.hooks){
                        if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                        if ([
                            'options',
                            'block'
                        ].includes(prop)) continue;
                        const hooksProp = prop;
                        const hooksFunc = pack.hooks[hooksProp];
                        const prevHook = hooks[hooksProp];
                        if (_Hooks.passThroughHooks.has(prop)) // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (arg)=>{
                            if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                                return prevHook.call(hooks, ret);
                            });
                            const ret = hooksFunc.call(hooks, arg);
                            return prevHook.call(hooks, ret);
                        };
                        else // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (...args)=>{
                            let ret = hooksFunc.apply(hooks, args);
                            if (ret === false) ret = prevHook.apply(hooks, args);
                            return ret;
                        };
                    }
                    opts.hooks = hooks;
                }
                // ==-- Parse WalkTokens extensions --== //
                if (pack.walkTokens) {
                    const walkTokens = this.defaults.walkTokens;
                    const packWalktokens = pack.walkTokens;
                    opts.walkTokens = function(token) {
                        let values = [];
                        values.push(packWalktokens.call(this, token));
                        if (walkTokens) values = values.concat(walkTokens.call(this, token));
                        return values;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...opts
                };
            });
            return this;
        }
        setOptions(opt) {
            this.defaults = {
                ...this.defaults,
                ...opt
            };
            return this;
        }
        lexer(src, options) {
            return _Lexer.lex(src, options ?? this.defaults);
        }
        parser(tokens, options) {
            return _Parser.parse(tokens, options ?? this.defaults);
        }
        parseMarkdown(blockType) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const parse = (src, options)=>{
                const origOpt = {
                    ...options
                };
                const opt = {
                    ...this.defaults,
                    ...origOpt
                };
                const throwError = this.onError(!!opt.silent, !!opt.async);
                // throw error if an extension set async to true but parse was called with async: false
                if (this.defaults.async === true && origOpt.async === false) return throwError(new Error('marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise.'));
                // throw error in case of non string input
                if (typeof src === 'undefined' || src === null) return throwError(new Error('marked(): input parameter is undefined or null'));
                if (typeof src !== 'string') return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
                if (opt.hooks) {
                    opt.hooks.options = opt;
                    opt.hooks.block = blockType;
                }
                const lexer = opt.hooks ? opt.hooks.provideLexer() : blockType ? _Lexer.lex : _Lexer.lexInline;
                const parser = opt.hooks ? opt.hooks.provideParser() : blockType ? _Parser.parse : _Parser.parseInline;
                if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    let tokens = lexer(src, opt);
                    if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                    if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                    let html = parser(tokens, opt);
                    if (opt.hooks) html = opt.hooks.postprocess(html);
                    return html;
                } catch (e) {
                    return throwError(e);
                }
            };
            return parse;
        }
        onError(silent, async) {
            return (e)=>{
                e.message += '\nPlease report this to https://github.com/markedjs/marked.';
                if (silent) {
                    const msg = '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
                    if (async) return Promise.resolve(msg);
                    return msg;
                }
                if (async) return Promise.reject(e);
                throw e;
            };
        }
    }
    const markedInstance = new Marked();
    function marked(src, opt) {
        return markedInstance.parse(src, opt);
    }
    /**
     * Sets the default options.
     *
     * @param options Hash of options
     */ marked.options = marked.setOptions = function(options) {
        markedInstance.setOptions(options);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Gets the original marked default options.
     */ marked.getDefaults = _getDefaults;
    marked.defaults = exports1.defaults;
    /**
     * Use Extension
     */ marked.use = function(...args) {
        markedInstance.use(...args);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Run callback for every token
     */ marked.walkTokens = function(tokens, callback) {
        return markedInstance.walkTokens(tokens, callback);
    };
    /**
     * Compiles markdown to HTML without enclosing `p` tag.
     *
     * @param src String of markdown source to be compiled
     * @param options Hash of options
     * @return String of compiled HTML
     */ marked.parseInline = markedInstance.parseInline;
    /**
     * Expose
     */ marked.Parser = _Parser;
    marked.parser = _Parser.parse;
    marked.Renderer = _Renderer;
    marked.TextRenderer = _TextRenderer;
    marked.Lexer = _Lexer;
    marked.lexer = _Lexer.lex;
    marked.Tokenizer = _Tokenizer;
    marked.Hooks = _Hooks;
    marked.parse = marked;
    const options = marked.options;
    const setOptions = marked.setOptions;
    const use = marked.use;
    const walkTokens = marked.walkTokens;
    const parseInline = marked.parseInline;
    const parse = marked;
    const parser = _Parser.parse;
    const lexer = _Lexer.lex;
    exports1.Hooks = _Hooks;
    exports1.Lexer = _Lexer;
    exports1.Marked = Marked;
    exports1.Parser = _Parser;
    exports1.Renderer = _Renderer;
    exports1.TextRenderer = _TextRenderer;
    exports1.Tokenizer = _Tokenizer;
    exports1.getDefaults = _getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});


var $4a6c6cd3ba57d1fc$exports = {};
/*! @license DOMPurify 3.2.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.5/LICENSE */ (function(global, factory) {
    $4a6c6cd3ba57d1fc$exports = factory();
})($4a6c6cd3ba57d1fc$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.2.5';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === 'value' ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


const $d8669940f261b2b4$export$c69afbbecb48616d = (input)=>{
    var ret = input.toString().match(/[0-9]+/g);
    if (ret == null) return [];
    return ret.map((x)=>parseInt(x));
};
const $d8669940f261b2b4$export$f31d32bd04711717 = (markdown)=>{
    if (!markdown) return 'ERROR: No message content';
    const rawHtmlWithDefault = (0, $e0f2436fd88d0d31$exports.marked).parse(markdown);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4a6c6cd3ba57d1fc$exports))).sanitize(rawHtmlWithDefault);
};



var $fgQ0V = parcelRequire("fgQ0V");


var $gpaur = parcelRequire("gpaur");
class $2934a4a4389d65dc$export$d9b13a70c820f8b9 {
    constructor(reportOriginal, overrides, reportId){
        Object.defineProperty(this, "overrides", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: overrides
        });
        Object.defineProperty(this, "reportId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: reportId
        });
        Object.defineProperty(this, "report", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_scoreCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.report = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep(reportOriginal);
        if (!this.report) return null;
        var over_rides = overrides;
        for(var fieldName in over_rides){
            const value = over_rides[fieldName];
            //typeof a == 'object' && Array.isArray(a)\
            //Connect to field type in schmea to know sub field
            const fieldsSchema = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71);
            if (typeof value == 'object') {
                if (!Array.isArray(value)) {
                    var set = value;
                    if (!Array.isArray(this.report[fieldName])) this.report[fieldName] = [];
                    const keys = Object.keys(set);
                    keys.forEach((year)=>{
                        const yearValue = set[year];
                        // if (fieldName.indexOf(".") > 0) {
                        //     const { section, field } = this.getSectionFieldFromSource(fieldName);
                        //     const fieldsSchema = DATA_SECTIONS[section];
                        // }
                        if (!fieldsSchema.hasOwnProperty(fieldName)) {
                            console.log(`Field ${fieldName} not found in schema`);
                            return;
                        }
                        // assert(
                        //     fieldsSchema.hasOwnProperty(fieldName),
                        //     `Field ${fieldName} not found in schema`
                        // );
                        const subFieldName = fieldsSchema[fieldName].field;
                        const e = this.report[fieldName].find((arrYear)=>{
                            return parseInt(arrYear.year) == parseInt(year);
                        });
                        const entry = {
                            year: parseInt(year),
                            [subFieldName]: yearValue
                        };
                        if (!e) this.report[fieldName].push(entry);
                        else e[subFieldName] = yearValue;
                    });
                }
            } else {
                const fieldMeta = fieldsSchema[fieldName];
                if (fieldMeta && fieldMeta.t == 'array') {
                    var unpack = value.split(',');
                    var toInt = unpack.map((v)=>(0, $7fbd760f3c05e83d$export$c47d79b712795940)(v));
                    this.report[fieldName] = toInt;
                } else this.report[fieldName] = value;
            }
        }
    }
    isValueEditedByRowCol(row, col) {
        const schema = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71);
        const edits = this.overrides;
        const fieldName = row.field.source;
        // if (fieldName.indexOf(".") > 0) {
        //     const parts = fieldName.split(".");
        //     var sectionName = parts[0] as DataSectionKey;
        //     var subField = parts[1] as DataFieldsKey<DataSectionKey>;
        //     const sectionDefinition = DATA_SECTIONS[sectionName];
        //     const field = sectionDefinition[subField];
        //     const editKey = `${sectionName}.${subField}`;
        //     if (field.yearly) {
        //         if (!edits.hasOwnProperty(editKey)) {
        //             return false;
        //         }
        //         if (!edits[editKey].hasOwnProperty(col.column.source.toString())) {
        //             return false;
        //         }
        //         return true;
        //     } else {
        //         return edits && edits.hasOwnProperty(editKey);
        //     }
        // }
        const f = schema[row.field.source];
        if (f.yearly) {
            if (!edits.hasOwnProperty(row.field.source)) return false;
            if (!edits[row.field.source].hasOwnProperty(col.column.source.toString())) return false;
            return true;
        } else //value
        return edits && edits.hasOwnProperty(row.field.source);
    }
    isValueEditedAtAll(fieldName) {
        const edits = this.overrides;
        return edits && edits.hasOwnProperty(fieldName);
    }
    get report_has_pdf() {
        return this.value('pdf') !== 'N/A';
    }
    get activeReport() {
        return this.report;
    }
    get company_acquisitions() {
        const v = this.value('company_acquisitions');
        if (v == 'N/A') return null;
        return v;
    }
    get top_customers() {
        const v = this.value('top_customers');
        if (v == 'N/A') return null;
        //Sometimes AI returns duplicates for a year, so we need to clean it up
        const customers = v.slice(0, 10).map((customer)=>{
            const cleanedRevenue = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V)))(customer.revenue || []).groupBy('year').map((group)=>(0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).maxBy(group, 'revenue')).value();
            return Object.assign(Object.assign({}, customer), {
                revenue: cleanedRevenue
            });
        });
        return customers;
    }
    get revenueByTopCustomers() {
        const v = this.value('top_10_customers_revenue_percentage');
        if (v == 'N/A') return null;
        return v;
    }
    get selectedEbitdaType() {
        var availEbitda = [];
        for (const ebitdaType of $2934a4a4389d65dc$export$d9b13a70c820f8b9.EBITDA_TYPES)if (this.report[ebitdaType]) availEbitda.push(ebitdaType);
        if (availEbitda.length == 0) return 'ebitda_per_year';
        const getTotal = (key)=>{
            return this.report[key].length;
        };
        const options = availEbitda.slice(0, 2);
        if (options.length > 1) {
            const totalBest = getTotal(options[0]);
            const totalSecond = getTotal(options[1]);
            if (totalBest >= totalSecond - 2) //Still pick #1 if its only 2 less than #2
            return options[0];
            else return options[1];
        } else return options[0];
    }
    value(fieldName) {
        let data = this.report;
        if (!data) return 'N/A';
        if (data.hasOwnProperty(fieldName)) {
            var field = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName];
            var val = data[fieldName];
            if (field && field.t == 'bool') {
                if (typeof val === 'string') return val === 'true' ? true : false;
            }
            return data[fieldName];
        }
        return 'N/A';
    }
    actualYear() {
        var _a, _b;
        try {
            const actualizedYears = (_a = this.report['list_years_actualized_revenue']) !== null && _a !== void 0 ? _a : [];
            if (actualizedYears.length == 0) ((_b = this.report['net_revenue_per_year']) !== null && _b !== void 0 ? _b : []).forEach((item)=>{
                actualizedYears.push(parseInt(item.year));
            });
            return Math.max(...actualizedYears);
        } catch (_c) {
            return -1;
        }
    }
    valueByYearDivideByRevenue(fieldName, year, yearOffset = 0) {
        let data = this.report;
        if (!data) return 'N/A';
        try {
            const fieldValue = this.valueByYear(fieldName, year, yearOffset);
            const revenue = this.valueByYear('net_revenue_per_year', year, yearOffset);
            return fieldValue / revenue;
        } catch (_a) {
            return 'N/A';
        }
    }
    getIsYearActualized(year) {
        var _a;
        const actualizedYears = (_a = this.value('list_years_actualized_revenue')) !== null && _a !== void 0 ? _a : [];
        const minActualizedYear = Math.min(...actualizedYears);
        const isActualized = actualizedYears.includes(year) || year <= minActualizedYear;
        return isActualized;
    }
    getReportYearRange() {
        var minYear = -1;
        var maxYear = -1;
        const fields = [
            'net_revenue_per_year',
            'ebitda_per_year'
        ];
        var data = this.activeReport;
        fields.forEach((field)=>{
            const list = data[field];
            if (!list || Array.isArray(list) === false) return;
            const years = list.map((item)=>parseInt(item.year));
            const min = Math.min(...years);
            const max = Math.max(...years);
            if (minYear == -1 || min < minYear) minYear = min;
            if (maxYear == -1 || max > maxYear) maxYear = max;
        });
        return {
            from: minYear,
            to: maxYear
        };
    }
    valueByYear(fieldName, year, yearOffset = 0) {
        // if (fieldName.indexOf(".") > 0) {
        //     const { section, field } = this.getSectionFieldFromSource(fieldName);
        //     return this.valueBySection({ section, field, year: year + yearOffset });
        // }
        let data = this.report;
        if (!data) return 'N/A';
        const fieldInfo = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName];
        (0, (/*@__PURE__*/$parcel$interopDefault($gpaur)))(fieldInfo, `Field ${fieldName} not found in schema`);
        (0, (/*@__PURE__*/$parcel$interopDefault($gpaur)))(fieldInfo.hasOwnProperty('field'), `Field ${fieldName} does not have 'field' property`);
        const valueField = fieldInfo['field'];
        const yearSource = year + yearOffset;
        const dataRow = data[fieldName];
        if (!dataRow || !Array.isArray(dataRow)) return 'N/A';
        const r = dataRow.find((d)=>parseInt(d.year) === yearSource);
        if (r == undefined) return 'N/A';
        if (r.hasOwnProperty(valueField)) return r[valueField];
        else return 'N/A';
    }
    // BY SECTION CODE TO USE SOMETIME
    // getSectionFieldFromSource(fieldName: string) {
    //     const parts = fieldName.split('.');
    //     assert(parts.length == 2, `Invalid field name ${fieldName}`);
    //     const section = parts[0] as DataSectionKey;
    //     const field = parts[1] as DataFieldsKey<DataSectionKey>;
    //     return { section, field };
    // }
    // schemaBySection(request: SectionFieldRequest): FieldInfo {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     return sectionDefinition[request.field];
    // }
    // labelBySection(request: SectionFieldRequest) {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     const field = sectionDefinition[request.field];
    //     return field.display;
    // }
    // sourcesBySection(request: SectionFieldRequest): number[] {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     const data = this.report[request.section];
    //     if (!data) {
    //         return [];
    //     }
    //     const field = sectionDefinition[request.field];
    //     const sourcesField = request.field + '_sources';
    //     const sourcesValue = data[sourcesField];
    //     var sources = [];
    //     if (sourcesValue) {
    //         sources = get_numbers(sourcesValue.toString());
    //     }
    //     return sources;
    // }
    // valueBySection(request: SectionValueByYearRequest) {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     const data = this.report[request.section];
    //     const field = sectionDefinition[request.field];
    //     const ret = (val) => {
    //         return val;
    //     }
    //     const retNA = () => {
    //         return "N/A";
    //     }
    //     if (!data) {
    //         return retNA();
    //     }
    //     if (field.yearly && !request.year) {
    //         console.log(`Field ${request.field} is yearly, but year is not provided`);
    //         return retNA();
    //     }
    //     if (field.yearly) {
    //         const year = request.year;
    //         const fieldList = data[request.field];
    //         if (!fieldList) {
    //             return retNA();
    //         }
    //         const yearData = fieldList.find((d: any) => parseInt(d.year) === year);
    //         if (yearData) {
    //             const val = yearData[request.field]; //always same key
    //             if (val == undefined) {
    //                 return retNA();
    //             }
    //             return ret(val);
    //         }
    //     } else {
    //         const fieldValue = data[request.field];
    //         if (fieldValue == undefined) {
    //             return retNA();
    //         }
    //         return ret(fieldValue);
    //     }
    // }
    organicCagr(howManYears) {
        try {
            const q = this;
            const lastYear = q.actualYear();
            const current = q.valueByYear('net_revenue_per_year', lastYear);
            const before = q.valueByYear('net_revenue_per_year', lastYear, -howManYears);
            if (current == 'N/A' || before == 'N/A') return 'N/A';
            return Math.pow(current / before, 1 / howManYears) - 1;
        } catch (_a) {
            return 'N/A';
        }
    }
    ebitdaMargin(year) {
        const ebitda = this.valueByYear('ebitda_per_year', year);
        const revenue = this.valueByYear('net_revenue_per_year', year);
        if (ebitda === 'N/A' || revenue === 'N/A') return 'N/A';
        return ebitda / revenue;
    }
    selectedEbitda(year) {
        const selectedEbitdaType = this.selectedEbitdaType;
        return this.valueByYear(selectedEbitdaType, year);
    }
    selectedEbitdaMargin(year) {
        const ebidtaType = this.selectedEbitdaType;
        const ebitda = this.selectedEbitda(year);
        const revenue = this.valueByYear('net_revenue_per_year', year);
        if (ebitda === 'N/A' || revenue === 'N/A') return 'N/A';
        return ebitda / revenue;
    }
    //Merge the two
    projectedCagr(howManYears) {
        try {
            const q = this;
            const lastYear = q.actualYear();
            const current = q.valueByYear('net_revenue_per_year', lastYear);
            const projected = q.valueByYear('net_revenue_per_year', lastYear, howManYears);
            if (current == 'N/A' || projected == 'N/A') return 'N/A';
            return Math.pow(projected / current, 1 / howManYears) - 1;
        } catch (e) {
            return 'N/A';
        }
    }
    fcf_conversion_ebitda(year) {
        const ebitda = this.valueByYear('adjusted_ebitda_per_year', year);
        const fcf = this.free_cash_flow(year);
        if (ebitda === 'N/A' || fcf === 'N/A') return 'N/A';
        return fcf / ebitda;
    }
    free_cash_flow(year) {
        const ebitda = this.valueByYear('adjusted_ebitda_per_year', year);
        const maintenanceCapex = this.valueByYear('maintenance_capex_per_year', year);
        if (ebitda === 'N/A' || maintenanceCapex === 'N/A') return 'N/A';
        return ebitda - maintenanceCapex;
    }
    formatExtendedValueDisplay(input) {
        var _a;
        var display = input;
        const matches = display.match(/%[A-Z0-9_]+%/g) || [];
        const stripped = matches.map((m)=>m.slice(1, -1));
        for (const match of stripped)switch(match){
            case 'SELECTED_EBITDA':
                const selected = this.selectedEbitdaType;
                const schemaLookupName = (_a = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[selected]['display']) !== null && _a !== void 0 ? _a : 'Adjusted EBITDA';
                display = display.replace(`%${match}%`, schemaLookupName);
                break;
        }
        return display;
    }
    get_extended_value_float(fieldName) {
        var val = this.get_extended_value_float_internal(fieldName);
        if ((0, $fgQ0V.isString)(val)) {
            val = val.replace('%', '');
            val = val.replace('$', '');
        }
        //Hack
        if (fieldName == 'recurring_revenue_summary' || fieldName == 'organic_cagr_N_years' || fieldName == 'projected_organic_cagr_N_years' || fieldName == 'extended_selected_ebitda') return val;
        if (fieldName == 'total_addressable_market' && val) return (0, $7fbd760f3c05e83d$export$c0080068ec287465)(val);
        if (val === 'N/A' || isNaN(val) || val === '' || val === 'NaN') return 'N/A';
        return (0, $7fbd760f3c05e83d$export$c0080068ec287465)(val);
    }
    get_extended_value_float_internal(fieldName) {
        var _a;
        switch(fieldName){
            case 'extended_selected_ebitda':
                const selected = this.selectedEbitdaType;
                const schemaLookupName = (_a = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[selected]['display']) !== null && _a !== void 0 ? _a : 'Adjusted EBITDA';
                return schemaLookupName;
            case 'organic_cagr_N_years':
                var ret = {};
                for(var years = 5; years >= 3; years--)ret[years] = this.organicCagr(years);
                return ret;
            case 'projected_organic_cagr_N_years':
                var ret = {};
                for(var years = 5; years >= 3; years--)ret[years] = this.projectedCagr(years);
                return ret;
            case 'organic_cagr_4_years':
                return this.organicCagr(4);
            case 'organic_cagr_3_years':
                return this.organicCagr(3);
            case 'projected_organic_cagr_3_years':
                return this.projectedCagr(3);
            case 'projected_organic_cagr_4_years':
                return this.projectedCagr(4);
            case 'projected_organic_cagr_N_years_minus_tam_growth':
                var projected = null;
                for(var years = 5; years >= 3; years--){
                    projected = this.projectedCagr(years);
                    if (projected !== 'N/A') break;
                }
                var market_growth = this.value('projected_market_growth');
                if (projected === 'N/A' || market_growth === 'N/A') return 'N/A';
                //Market growth is 1-100, not 0-1
                return projected - (0, $7fbd760f3c05e83d$export$c0080068ec287465)(market_growth) / 100.0;
            case 'adj_ebitda_margin':
                return this.selectedEbitdaMargin(this.actualYear());
            case 'adj_ebitda_margin_trend':
                const ebitdaNow = this.selectedEbitdaMargin(this.actualYear());
                const ebitda2YearsAgo = this.selectedEbitdaMargin(this.actualYear() - 2);
                if (ebitdaNow === 'N/A' || ebitda2YearsAgo === 'N/A') return 'N/A';
                return ebitdaNow - ebitda2YearsAgo;
            case 'adj_ebitda':
                return this.selectedEbitda(this.actualYear());
            case 'gross_retention':
                const gross = this.valueByYear('gross_retention_lost_only_per_year', this.actualYear());
                if (gross === 'N/A') return 'N/A';
                return gross / 100;
            case 'net_retention':
                return this.valueByYear('net_retention_yearly', this.actualYear());
            case 'revenue_latest':
                return this.valueByYear('net_revenue_per_year', this.actualYear());
            case 'ebitda_magnatitude_adjustment':
                const ebitda = this.valueByYear('ebitda_per_year', this.actualYear());
                const adj_ebitda = this.selectedEbitda(this.actualYear());
                return (adj_ebitda - ebitda) / adj_ebitda;
            case 'fcf_conversion_ebitda':
                return this.fcf_conversion_ebitda(this.actualYear());
            case 'nwc_as_percent_of_revenue':
                const currentAssets = this.valueByYear('total_current_assets_yearly', this.actualYear());
                const currentLiabilities = this.valueByYear('total_current_liabilities_yearly', this.actualYear());
                const revenue = this.valueByYear('net_revenue_per_year', this.actualYear());
                if (currentAssets === 'N/A' || currentLiabilities === 'N/A' || revenue === 'N/A') return 'N/A';
                return (currentAssets - currentLiabilities) / revenue;
            case 'free_cash_flow_conversion':
                const adjustedEbitda = this.valueByYear('adjusted_ebitda_per_year', this.actualYear());
                const fcf = this.free_cash_flow(this.actualYear());
                if (adjustedEbitda === 'N/A' || fcf === 'N/A') return 'N/A';
                return fcf / adjustedEbitda;
            case 'total_capex_by_rev':
                const capex = this.valueByYear('capex_per_year', this.actualYear());
                const revenueCapex = this.valueByYear('net_revenue_per_year', this.actualYear());
                if (capex === 'N/A' || revenueCapex === 'N/A') return 'N/A';
                return capex / revenueCapex;
            case 'gross_profit_margin':
                const grossProfit = this.valueByYear('gross_profit_per_year', this.actualYear());
                const revenueGross = this.valueByYear('net_revenue_per_year', this.actualYear());
                if (grossProfit === 'N/A' || revenueGross === 'N/A') return 'N/A';
                return grossProfit / revenueGross;
            case 'gross_profit':
                return this.valueByYear('gross_profit_per_year', this.actualYear());
            case 'total_addressable_market':
            case 'historical_market_growth':
            case 'projected_market_growth':
            case 'recurring_revenue_summary':
                return this.value(fieldName);
            default:
                return null;
        }
    }
    scoreBySection(sectionName) {
        const scoreUtil = new (0, $9b879bbdd76f7296$export$39c49a915ff7ed37)(this);
        if (scoreUtil.is_section_used_for_scoring_by_id(sectionName)) return scoreUtil.calcSectionPercentileById(sectionName);
        else return null;
    }
    score() {
        if (this._scoreCache != null) return this._scoreCache;
        const scoreUtil = new (0, $9b879bbdd76f7296$export$39c49a915ff7ed37)(this);
        const score = scoreUtil.calcScorePercentile();
        if (score == null) this._scoreCache = -1;
        else this._scoreCache = Math.round(score * 100);
        return this._scoreCache;
    }
    sourcesByField(fieldName, fieldDisplay) {
        // if (fieldName && fieldName.indexOf(".") > 0) {
        //     const parts = fieldName.split(".");
        //     var sectionName = parts[0];
        //     var fieldName = parts[1];
        //     return this.sourcesBySection({ section: sectionName as any, field: fieldName as any });
        // }
        let fields = [
            fieldName
        ];
        if (fieldDisplay == "\u2060Capitalized Development Costs") {
            if (this.value('capitalized_software_override_page_source') != 'N/A') fields = [
                'capitalized_software_override'
            ];
            else fields = [
                'capitalized_software',
                'capitalized_application_development',
                'capitalized_rnd'
            ];
        }
        const conv_source_to_num_array = (sourcesValue)=>{
            var pages = (0, $d8669940f261b2b4$export$c69afbbecb48616d)(sourcesValue.toString());
            return pages;
        };
        var sources = [];
        fields.forEach((fieldEntry)=>{
            let val = this.value(fieldEntry + '_page_source');
            if ((0, $fgQ0V.isArray)(val)) {
                val = val.map((v)=>{
                    var nums = (0, $d8669940f261b2b4$export$c69afbbecb48616d)(v);
                    if (nums.length > 0) return nums[0];
                    else return -1;
                });
                val = val.filter((v)=>v != -1);
                val = val.join(',');
            }
            sources = sources.concat(conv_source_to_num_array(val));
        });
        return sources;
    }
    anyValue(fieldName) {
        var _a;
        const field = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName];
        if ((_a = field['yearly']) !== null && _a !== void 0 ? _a : false) {
            const data = this.report[fieldName];
            if (!data) return false;
            return Object.keys(data).length > 0;
        } else return this.report.hasOwnProperty(fieldName);
    }
    sources(field, column) {
        let l = this.sourcesByField(field.source, field.display);
        l = l.sort((a, b)=>a - b);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).uniq(l);
    }
    get pdfViewUrl() {
        return this.value('pdfViewUrl');
    }
    get companyName() {
        return this.value('company_name');
    }
}
//Order of selected ebitda top is most 'adjusted'
Object.defineProperty($2934a4a4389d65dc$export$d9b13a70c820f8b9, "EBITDA_TYPES", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [
        'adjusted_ebitda_per_year',
        'ebitda_per_year'
    ]
});



var $fgQ0V = parcelRequire("fgQ0V");

var $T5IcR = parcelRequire("T5IcR");

var $fX8pL = parcelRequire("fX8pL");

var $8nGP5 = parcelRequire("8nGP5");


var $8df13b3de5b3c0c6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $8df13b3de5b3c0c6$export$79c5294a8f16ac4d {
    constructor(reportId){
        Object.defineProperty(this, "reportId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: reportId
        });
        Object.defineProperty(this, "query", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    init(query) {
        return $8df13b3de5b3c0c6$var$__awaiter(this, void 0, void 0, function*() {
            this.query = query;
        });
    }
    sendMessage(question) {
        return $8df13b3de5b3c0c6$var$__awaiter(this, void 0, void 0, function*() {
            const query = this.query;
            const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            storeUI.chatWaitingForResponse = true;
            try {
                fb.chatbot_add_message(this.reportId, question, true);
                storeUI.chatWaitingForResponse = false;
            } catch (e) {
                storeUI.chatWaitingForResponse = false;
            }
        });
    }
}
Object.defineProperty($8df13b3de5b3c0c6$export$79c5294a8f16ac4d, "accessTokenAPI", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: null
}); //This can be static


var $80541c05916033ee$exports = {};
$80541c05916033ee$exports = JSON.parse("[{\"name\":\"Consumer/Retail\",\"id\":1,\"subtypes\":[{\"name\":\"Apparel\",\"id\":1},{\"name\":\"Beauty and Personal Care Products\",\"id\":2},{\"name\":\"Convenience Stores\",\"id\":3},{\"name\":\"Food and Beverage\",\"id\":4},{\"name\":\"Department Stores\",\"id\":5},{\"name\":\"Pet Food and Services\",\"id\":6},{\"name\":\"Restaurants\",\"id\":7},{\"name\":\"Specialty and Hardline Retailers\",\"id\":8},{\"name\":\"Supermarkets\",\"id\":9},{\"name\":\"Other Consumer/Retail\",\"id\":10}]},{\"name\":\"Financial Institutions\",\"id\":2,\"subtypes\":[{\"name\":\"Banks\",\"id\":11},{\"name\":\"Insurance Companies\",\"id\":12},{\"name\":\"Asset Management Firms\",\"id\":13},{\"name\":\"Financial Technology Companies\",\"id\":14},{\"name\":\"Specialty Finance Institutions\",\"id\":15},{\"name\":\"Other Financial Institutions\",\"id\":16}]},{\"name\":\"Healthcare\",\"id\":3,\"subtypes\":[{\"name\":\"Biotechnology\",\"id\":17},{\"name\":\"Diagnostics/Life Sciences\",\"id\":18},{\"name\":\"Healthcare Information Technology\",\"id\":19},{\"name\":\"Healthcare Services\",\"id\":20},{\"name\":\"Medical Devices\",\"id\":21},{\"name\":\"Pharmaceuticals\",\"id\":22},{\"name\":\"Other Healthcare\",\"id\":23}]},{\"name\":\"Industrials\",\"id\":4,\"subtypes\":[{\"name\":\"Aerospace and Defense\",\"id\":24},{\"name\":\"Automotive\",\"id\":25},{\"name\":\"Building and Construction\",\"id\":26},{\"name\":\"Business Services\",\"id\":27},{\"name\":\"Capital Goods\",\"id\":28},{\"name\":\"Diversified Industrials\",\"id\":29},{\"name\":\"Industrial Technology\",\"id\":30},{\"name\":\"Paper\",\"id\":31},{\"name\":\"Forest Products And Packaging\",\"id\":32},{\"name\":\"Transportation And Logistics\",\"id\":33},{\"name\":\"Other Industrials\",\"id\":34}]},{\"name\":\"Natural Resources\",\"id\":5,\"subtypes\":[{\"name\":\"Energy\",\"id\":35},{\"name\":\"Power\",\"id\":36},{\"name\":\"Infrastructure\",\"id\":37},{\"name\":\"Chemicals\",\"id\":38},{\"name\":\"Metals and Mining\",\"id\":39},{\"name\":\"Other Natural Resources\",\"id\":40}]},{\"name\":\"Public Sector and Infrastructure\",\"id\":6,\"subtypes\":[{\"name\":\"State and Local Governments\",\"id\":41},{\"name\":\"Not-For-Profit Healthcare Systems\",\"id\":42},{\"name\":\"Higher Education Institutions\",\"id\":43},{\"name\":\"Public Power Utilities\",\"id\":44},{\"name\":\"Surface Transportation and Mass Transit Agencies\",\"id\":45},{\"name\":\"Airports and Seaports\",\"id\":46},{\"name\":\"Sports Franchises\",\"id\":47},{\"name\":\"Other Public Sector and Infrastructure\",\"id\":48}]},{\"name\":\"Real Estate\",\"id\":7,\"subtypes\":[{\"name\":\"Real Estate Investment Trusts (REITs)\",\"id\":49},{\"name\":\"Hotels and Resorts\",\"id\":50},{\"name\":\"Retailers and Public Sector Entities\",\"id\":51},{\"name\":\"Retail Properties\",\"id\":52},{\"name\":\"Golf Courses\",\"id\":53},{\"name\":\"Shopping Centers\",\"id\":54},{\"name\":\"Office Buildings\",\"id\":55},{\"name\":\"Industrial Properties\",\"id\":56},{\"name\":\"Multifamily Properties\",\"id\":57},{\"name\":\"Development Projects\",\"id\":58},{\"name\":\"Other Real Estate\",\"id\":59}]},{\"name\":\"Technology, Media, and Telecommunications\",\"id\":8,\"subtypes\":[{\"name\":\"Software\",\"id\":60},{\"name\":\"Internet\",\"id\":61},{\"name\":\"Semiconductors\",\"id\":62},{\"name\":\"Hardware\",\"id\":63},{\"name\":\"Communications Technology\",\"id\":64},{\"name\":\"Information Services\",\"id\":65},{\"name\":\"Education Technology\",\"id\":66},{\"name\":\"Media\",\"id\":67},{\"name\":\"Telecom\",\"id\":68},{\"name\":\"Gaming Companies\",\"id\":69},{\"name\":\"Other Technology, Media, and Telecommunications\",\"id\":70}]},{\"name\":\"Business Services\",\"id\":9,\"subtypes\":[{\"name\":\"Property Maintenance Services\",\"id\":71}]}]");


var $8f024b03d9af7c67$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $8f024b03d9af7c67$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $8f024b03d9af7c67$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8f024b03d9af7c67$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $8f024b03d9af7c67$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
function $8f024b03d9af7c67$var$isString(s) {
    return typeof s === 'string' || s instanceof String;
}
class $8f024b03d9af7c67$var$TaskStateQuery {
    constructor(taskState, taskVarsExistTable, taskDef){
        Object.defineProperty(this, "taskState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: taskState
        });
        Object.defineProperty(this, "taskVarsExistTable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: taskVarsExistTable
        });
        Object.defineProperty(this, "taskDef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: taskDef
        });
    }
    get isComplete() {
        if (this.taskState == null || this.taskState.state_vars == null) return false;
        return this.taskState.state_vars['IS_COMPLETE'] == '1';
    }
    get activeStep() {
        var _a;
        if (this.taskState == null || this.taskState.state_vars == null) return 0;
        if (this.isComplete) return this.taskDef.inner_steps_names.length;
        return parseInt((_a = this.taskState.state_vars['ACTIVE_STEP']) !== null && _a !== void 0 ? _a : '0');
    }
    get isLocked() {
        if (!this.taskDef) return true;
        if (!this.taskDef.prerequisite_variable) return false;
        for (const varObj of this.taskDef.prerequisite_variable){
            if (!this.taskVarsExistTable) return true;
            if (this.taskVarsExistTable[varObj.name] !== true) return true;
        }
        return false;
    }
    get status() {
        if (this.taskState == null) return 'not_set';
        return this.taskState.status;
    }
}
class $8f024b03d9af7c67$var$ReportTaskState {
    constructor(flowTaskState, flowTaskVarsExistTable){
        Object.defineProperty(this, "flowTaskState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: flowTaskState
        });
        Object.defineProperty(this, "flowTaskVarsExistTable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: flowTaskVarsExistTable
        });
        if (!this.flowTaskState) this.flowTaskState = {};
        if (!this.flowTaskVarsExistTable) this.flowTaskVarsExistTable = {};
    }
    getTaskQuery(taskId) {
        var _a;
        const taskDef = $8f024b03d9af7c67$export$c2ad39067c031726().get_task_definition(taskId);
        return new $8f024b03d9af7c67$var$TaskStateQuery((_a = this.flowTaskState[taskId]) !== null && _a !== void 0 ? _a : null, this.flowTaskVarsExistTable, taskDef);
    }
}
let $8f024b03d9af7c67$var$Store = (()=>{
    var _a, _Store_selectedReportId_accessor_storage, _Store_selectedTaskId_accessor_storage, _Store_reportDataDB_accessor_storage, _Store_flowTaskVarsExistTable_accessor_storage, _Store_flowTaskState_accessor_storage, _Store_knowledgeFilesDB_accessor_storage, _Store_showAdminConsoleFromKeyboardShortcut_accessor_storage, _Store_reportDataOverridesDB_accessor_storage, _Store_reportsDataAccessCache_accessor_storage, _Store_users_accessor_storage, _Store_userId_accessor_storage, _Store_jobs_accessor_storage, _Store_systemStatus_accessor_storage, _Store_activeJob_accessor_storage, _Store_areSettingsLoaded_accessor_storage, _Store_areOveridesLoaded_accessor_storage, _Store_areScoreRulesLoaded_accessor_storage, _Store_areKnowledgeFilesLoaded_accessor_storage, _Store_areTaskDefinitionsLoaded_accessor_storage, _Store_allProjectFiles_accessor_storage, _Store_firmInfo_accessor_storage, _Store_reportDefinitions_accessor_storage, _Store_isChatLoaded_accessor_storage, _Store_chatData_accessor_storage, _Store_ragDB_accessor_storage, _Store_isRagDbLoaded_accessor_storage, _Store_lastReportLoaded_accessor_storage, _Store_allUserComparables_accessor_storage;
    let _instanceExtraInitializers = [];
    let _selectedReportId_decorators;
    let _selectedReportId_initializers = [];
    let _selectedReportId_extraInitializers = [];
    let _selectedTaskId_decorators;
    let _selectedTaskId_initializers = [];
    let _selectedTaskId_extraInitializers = [];
    let _reportDataDB_decorators;
    let _reportDataDB_initializers = [];
    let _reportDataDB_extraInitializers = [];
    let _flowTaskVarsExistTable_decorators;
    let _flowTaskVarsExistTable_initializers = [];
    let _flowTaskVarsExistTable_extraInitializers = [];
    let _flowTaskState_decorators;
    let _flowTaskState_initializers = [];
    let _flowTaskState_extraInitializers = [];
    let _get_activeReportTasksState_decorators;
    let _knowledgeFilesDB_decorators;
    let _knowledgeFilesDB_initializers = [];
    let _knowledgeFilesDB_extraInitializers = [];
    let _get_isAdmin_decorators;
    let _showAdminConsoleFromKeyboardShortcut_decorators;
    let _showAdminConsoleFromKeyboardShortcut_initializers = [];
    let _showAdminConsoleFromKeyboardShortcut_extraInitializers = [];
    let _get_showAdminConsole_decorators;
    let _reportDataOverridesDB_decorators;
    let _reportDataOverridesDB_initializers = [];
    let _reportDataOverridesDB_extraInitializers = [];
    let _reportsDataAccessCache_decorators;
    let _reportsDataAccessCache_initializers = [];
    let _reportsDataAccessCache_extraInitializers = [];
    let _users_decorators;
    let _users_initializers = [];
    let _users_extraInitializers = [];
    let _userId_decorators;
    let _userId_initializers = [];
    let _userId_extraInitializers = [];
    let _jobs_decorators;
    let _jobs_initializers = [];
    let _jobs_extraInitializers = [];
    let _systemStatus_decorators;
    let _systemStatus_initializers = [];
    let _systemStatus_extraInitializers = [];
    let _activeJob_decorators;
    let _activeJob_initializers = [];
    let _activeJob_extraInitializers = [];
    let _areSettingsLoaded_decorators;
    let _areSettingsLoaded_initializers = [];
    let _areSettingsLoaded_extraInitializers = [];
    let _areOveridesLoaded_decorators;
    let _areOveridesLoaded_initializers = [];
    let _areOveridesLoaded_extraInitializers = [];
    let _areScoreRulesLoaded_decorators;
    let _areScoreRulesLoaded_initializers = [];
    let _areScoreRulesLoaded_extraInitializers = [];
    let _areKnowledgeFilesLoaded_decorators;
    let _areKnowledgeFilesLoaded_initializers = [];
    let _areKnowledgeFilesLoaded_extraInitializers = [];
    let _areTaskDefinitionsLoaded_decorators;
    let _areTaskDefinitionsLoaded_initializers = [];
    let _areTaskDefinitionsLoaded_extraInitializers = [];
    let _allProjectFiles_decorators;
    let _allProjectFiles_initializers = [];
    let _allProjectFiles_extraInitializers = [];
    let _firmInfo_decorators;
    let _firmInfo_initializers = [];
    let _firmInfo_extraInitializers = [];
    let _reportDefinitions_decorators;
    let _reportDefinitions_initializers = [];
    let _reportDefinitions_extraInitializers = [];
    let _isChatLoaded_decorators;
    let _isChatLoaded_initializers = [];
    let _isChatLoaded_extraInitializers = [];
    let _chatData_decorators;
    let _chatData_initializers = [];
    let _chatData_extraInitializers = [];
    let _ragDB_decorators;
    let _ragDB_initializers = [];
    let _ragDB_extraInitializers = [];
    let _isRagDbLoaded_decorators;
    let _isRagDbLoaded_initializers = [];
    let _isRagDbLoaded_extraInitializers = [];
    let _lastReportLoaded_decorators;
    let _lastReportLoaded_initializers = [];
    let _lastReportLoaded_extraInitializers = [];
    let _allUserComparables_decorators;
    let _allUserComparables_initializers = [];
    let _allUserComparables_extraInitializers = [];
    let _get_userComparables_decorators;
    let _get_hasMaxComparables_decorators;
    let _initializeUserComparables_decorators;
    let _get_activeReportOriginal_decorators;
    let _get_isLoaded_decorators;
    let _get_projectKnowledgeFiles_decorators;
    let _get_projectFiles_decorators;
    let _get_reportChatHistory_decorators;
    let _get_reportChatCitationsHistory_decorators;
    let _get_reportOverride_decorators;
    let _get_query_decorators;
    let _get_report_flowise_decorators;
    let _get_ragAPI_decorators;
    let _get_company_name_decorators;
    let _get_ticker_decorators;
    let _get_reportCreationDate_decorators;
    let _get_errorMessageTicker_decorators;
    let _get_reportFiscalYear_decorators;
    let _get_companyOverview_decorators;
    return _a = class Store {
        constructor(){
            _Store_selectedReportId_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _instanceExtraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _selectedReportId_initializers, '')));
            _Store_selectedTaskId_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _selectedReportId_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _selectedTaskId_initializers, '')));
            _Store_reportDataDB_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _selectedTaskId_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _reportDataDB_initializers, null)));
            _Store_flowTaskVarsExistTable_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _reportDataDB_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _flowTaskVarsExistTable_initializers, {})));
            _Store_flowTaskState_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _flowTaskVarsExistTable_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _flowTaskState_initializers, {})));
            _Store_knowledgeFilesDB_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _flowTaskState_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _knowledgeFilesDB_initializers, void 0)));
            _Store_showAdminConsoleFromKeyboardShortcut_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _knowledgeFilesDB_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _showAdminConsoleFromKeyboardShortcut_initializers, this.isDev)));
            _Store_reportDataOverridesDB_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _showAdminConsoleFromKeyboardShortcut_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _reportDataOverridesDB_initializers, {})));
            _Store_reportsDataAccessCache_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _reportDataOverridesDB_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _reportsDataAccessCache_initializers, {})));
            _Store_users_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _reportsDataAccessCache_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _users_initializers, {})));
            _Store_userId_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _users_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _userId_initializers, void 0)));
            _Store_jobs_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _userId_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _jobs_initializers, {})));
            _Store_systemStatus_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _jobs_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _systemStatus_initializers, {})));
            _Store_activeJob_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _systemStatus_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _activeJob_initializers, null)));
            _Store_areSettingsLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _activeJob_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _areSettingsLoaded_initializers, false)));
            _Store_areOveridesLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _areSettingsLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _areOveridesLoaded_initializers, false)));
            _Store_areScoreRulesLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _areOveridesLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _areScoreRulesLoaded_initializers, false)));
            _Store_areKnowledgeFilesLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _areScoreRulesLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _areKnowledgeFilesLoaded_initializers, false)));
            _Store_areTaskDefinitionsLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _areKnowledgeFilesLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _areTaskDefinitionsLoaded_initializers, false)));
            _Store_allProjectFiles_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _areTaskDefinitionsLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _allProjectFiles_initializers, {})));
            _Store_firmInfo_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _allProjectFiles_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _firmInfo_initializers, {})));
            _Store_reportDefinitions_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _firmInfo_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _reportDefinitions_initializers, {})));
            _Store_isChatLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _reportDefinitions_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isChatLoaded_initializers, false)));
            _Store_chatData_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isChatLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _chatData_initializers, {})));
            _Store_ragDB_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _chatData_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _ragDB_initializers, {})));
            _Store_isRagDbLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _ragDB_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isRagDbLoaded_initializers, false)));
            _Store_lastReportLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isRagDbLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _lastReportLoaded_initializers, '')));
            _Store_allUserComparables_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _lastReportLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _allUserComparables_initializers, {})));
            $8f024b03d9af7c67$var$__runInitializers(this, _allUserComparables_extraInitializers);
        }
        logout() {
            this.userId = null;
        }
        get selectedReportId() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_selectedReportId_accessor_storage, "f");
        }
        set selectedReportId(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_selectedReportId_accessor_storage, value, "f");
        }
        get selectedTaskId() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_selectedTaskId_accessor_storage, "f");
        }
        set selectedTaskId(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_selectedTaskId_accessor_storage, value, "f");
        }
        get reportDataDB() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_reportDataDB_accessor_storage, "f");
        }
        set reportDataDB(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_reportDataDB_accessor_storage, value, "f");
        }
        get flowTaskVarsExistTable() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_flowTaskVarsExistTable_accessor_storage, "f");
        }
        set flowTaskVarsExistTable(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_flowTaskVarsExistTable_accessor_storage, value, "f");
        }
        get flowTaskState() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_flowTaskState_accessor_storage, "f");
        }
        set flowTaskState(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_flowTaskState_accessor_storage, value, "f");
        }
        get activeReportTasksState() {
            var _b, _c;
            return new $8f024b03d9af7c67$var$ReportTaskState((_b = this.flowTaskState[this.selectedReportId]) !== null && _b !== void 0 ? _b : null, (_c = this.flowTaskVarsExistTable[this.selectedReportId]) !== null && _c !== void 0 ? _c : null);
        }
        get knowledgeFilesDB() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_knowledgeFilesDB_accessor_storage, "f");
        }
        set knowledgeFilesDB(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_knowledgeFilesDB_accessor_storage, value, "f");
        }
        get isDev() {
            return false;
        }
        get isAdmin() {
            var _b, _c;
            if (this.isDev) return true;
            if (!this.users) return false;
            return (_c = (_b = this.users[this.userId]) === null || _b === void 0 ? void 0 : _b.isAdmin) !== null && _c !== void 0 ? _c : false;
        }
        get showAdminConsoleFromKeyboardShortcut() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_showAdminConsoleFromKeyboardShortcut_accessor_storage, "f");
        }
        set showAdminConsoleFromKeyboardShortcut(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_showAdminConsoleFromKeyboardShortcut_accessor_storage, value, "f");
        }
        get showAdminConsole() {
            if (!this.isAdmin) return false;
            return this.showAdminConsoleFromKeyboardShortcut;
        }
        get reportDataOverridesDB() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_reportDataOverridesDB_accessor_storage, "f");
        }
        set reportDataOverridesDB(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_reportDataOverridesDB_accessor_storage, value, "f");
        }
        get reportsDataAccessCache() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_reportsDataAccessCache_accessor_storage, "f");
        }
        set reportsDataAccessCache(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_reportsDataAccessCache_accessor_storage, value, "f");
        }
        get users() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_users_accessor_storage, "f");
        }
        set users(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_users_accessor_storage, value, "f");
        }
        get userId() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_userId_accessor_storage, "f");
        }
        set userId(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_userId_accessor_storage, value, "f");
        }
        get jobs() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_jobs_accessor_storage, "f");
        }
        set jobs(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_jobs_accessor_storage, value, "f");
        }
        get systemStatus() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_systemStatus_accessor_storage, "f");
        }
        set systemStatus(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_systemStatus_accessor_storage, value, "f");
        }
        get activeJob() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_activeJob_accessor_storage, "f");
        }
        set activeJob(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_activeJob_accessor_storage, value, "f");
        }
        get areSettingsLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_areSettingsLoaded_accessor_storage, "f");
        }
        set areSettingsLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_areSettingsLoaded_accessor_storage, value, "f");
        }
        get areOveridesLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_areOveridesLoaded_accessor_storage, "f");
        }
        set areOveridesLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_areOveridesLoaded_accessor_storage, value, "f");
        }
        get areScoreRulesLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_areScoreRulesLoaded_accessor_storage, "f");
        }
        set areScoreRulesLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_areScoreRulesLoaded_accessor_storage, value, "f");
        }
        get areKnowledgeFilesLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_areKnowledgeFilesLoaded_accessor_storage, "f");
        }
        set areKnowledgeFilesLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_areKnowledgeFilesLoaded_accessor_storage, value, "f");
        }
        get areTaskDefinitionsLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_areTaskDefinitionsLoaded_accessor_storage, "f");
        }
        set areTaskDefinitionsLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_areTaskDefinitionsLoaded_accessor_storage, value, "f");
        }
        get allProjectFiles() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_allProjectFiles_accessor_storage, "f");
        }
        set allProjectFiles(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_allProjectFiles_accessor_storage, value, "f");
        }
        get firmInfo() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_firmInfo_accessor_storage, "f");
        }
        set firmInfo(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_firmInfo_accessor_storage, value, "f");
        }
        get reportDefinitions() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_reportDefinitions_accessor_storage, "f");
        }
        set reportDefinitions(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_reportDefinitions_accessor_storage, value, "f");
        }
        get isChatLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_isChatLoaded_accessor_storage, "f");
        }
        set isChatLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_isChatLoaded_accessor_storage, value, "f");
        }
        get chatData() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_chatData_accessor_storage, "f");
        }
        set chatData(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_chatData_accessor_storage, value, "f");
        }
        get ragDB() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_ragDB_accessor_storage, "f");
        }
        set ragDB(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_ragDB_accessor_storage, value, "f");
        }
        get isRagDbLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_isRagDbLoaded_accessor_storage, "f");
        }
        set isRagDbLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_isRagDbLoaded_accessor_storage, value, "f");
        }
        get lastReportLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_lastReportLoaded_accessor_storage, "f");
        }
        set lastReportLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_lastReportLoaded_accessor_storage, value, "f");
        }
        get allUserComparables() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_allUserComparables_accessor_storage, "f");
        }
        set allUserComparables(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_allUserComparables_accessor_storage, value, "f");
        }
        get userComparables() {
            if (!this.selectedReportId) return Array(2).fill(null);
            const dealData = this.allUserComparables[this.selectedReportId];
            if (!(dealData === null || dealData === void 0 ? void 0 : dealData.comparables)) return Array(2).fill(null);
            const comparables = [
                ...dealData.comparables
            ];
            while(comparables.length < 2)comparables.push(null);
            return comparables.slice(0, 2).map((val)=>val !== null && val !== void 0 ? val : null);
        }
        get hasMaxComparables() {
            return this.userComparables.filter((dealId)=>dealId !== null).length >= 2;
        }
        initializeUserComparables(dealId, comparables) {
            if (!dealId) {
                console.warn('Cannot initialize comparables: missing dealId');
                return;
            }
            // Initialize with default comparables locally without saving to Firebase
            this.allUserComparables[dealId] = {
                comparables: comparables.map((val)=>val !== null && val !== void 0 ? val : null),
                lastUpdated: Date.now()
            };
        }
        saveUserComparables(dealId, comparables) {
            return $8f024b03d9af7c67$var$__awaiter(this, void 0, void 0, function*() {
                if (!dealId || !this.userId) {
                    console.warn('Cannot save comparables: missing dealId or userId');
                    return;
                }
                // Ensure we always have exactly 2 slots with null for empty positions
                const normalizedComparables = comparables.slice(0, 2).map((val)=>val !== null && val !== void 0 ? val : null);
                while(normalizedComparables.length < 2)normalizedComparables.push(null);
                try {
                    const firebase = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                    yield firebase.saveUserComparables(this.userId, dealId, normalizedComparables);
                } catch (error) {
                    console.error('Error saving user comparables:', error);
                }
            });
        }
        get activeReportOriginal() {
            const ticker = this.selectedReportId;
            if (!this.reportDataDB) return null;
            if (this.reportDataDB.hasOwnProperty(ticker)) {
                if (this.reportDataDB[ticker].status == 'processing') return null;
                return (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep(this.reportDataDB[ticker]);
            }
            return null;
        }
        get isLoaded() {
            return this.reportDataDB != null && this.areOveridesLoaded && this.areScoreRulesLoaded && this.areSettingsLoaded && this.areKnowledgeFilesLoaded && this.areTaskDefinitionsLoaded;
        }
        get projectKnowledgeFiles() {
            const industry = this.query.value('industry');
            const sub_industry = this.query.value('industrySubType');
            const ret = {};
            for(var key in this.knowledgeFilesDB){
                const file = this.knowledgeFilesDB[key];
                if (file.tags) {
                    const tags = file.tags.map((tag)=>tag.value);
                    if (tags.indexOf((0, $9640fc307de8e8aa$export$e5ac8460294ca616)) !== -1) {
                        ret[key] = file;
                        continue;
                    }
                    for(var i = 0; i < tags.length; i++)if (!tags[i].includes('::')) {
                        const industryType = tags[i];
                        if (industryType === industry) ret[key] = file;
                    } else {
                        const industrySubType = tags[i].split('::')[1];
                        if (industrySubType === sub_industry) ret[key] = file;
                    }
                }
            }
            return ret;
        }
        get projectFiles() {
            var _b;
            return (_b = this.allProjectFiles[this.selectedReportId]) !== null && _b !== void 0 ? _b : {
                files: {}
            };
        }
        get reportChatHistory() {
            var _b;
            return (_b = this.chatData[this.selectedReportId]) !== null && _b !== void 0 ? _b : {
                intro: {
                    isMe: false,
                    message: 'Hello! How can I help you today?',
                    date: new Date(),
                    processed: true
                }
            };
        }
        get reportChatCitationsHistory() {
            var _b, _c, _d, _e, _f, _g, _h;
            const citationsTable = {};
            const messages = (_b = this.chatData[this.selectedReportId]) !== null && _b !== void 0 ? _b : [];
            for(const msgId in messages){
                const msg = messages[msgId];
                const raw = msg.raw;
                const citations = (_e = (_d = (_c = msg === null || msg === void 0 ? void 0 : msg.raw) === null || _c === void 0 ? void 0 : _c.metadata) === null || _d === void 0 ? void 0 : _d.citations) !== null && _e !== void 0 ? _e : [];
                for (const citationEntry of citations){
                    const id = citationEntry.id;
                    var text = (_f = citationEntry.payload) === null || _f === void 0 ? void 0 : _f.text;
                    if (!text) text = citationEntry.text;
                    // if (!text) {
                    //     text = citationEntry?.payload?.summary;
                    // }
                    if (!text) {
                        var chunks = (_h = (_g = citationEntry === null || citationEntry === void 0 ? void 0 : citationEntry.payload) === null || _g === void 0 ? void 0 : _g.chunks) !== null && _h !== void 0 ? _h : [];
                        if (chunks.length > 0) text = chunks[0].text;
                    }
                    if (text) citationsTable[id] = text;
                }
            }
            return citationsTable;
        }
        get reportOverride() {
            const ticker = this.selectedReportId;
            var over_rides = {};
            if (this.reportDataOverridesDB && this.reportDataOverridesDB.hasOwnProperty(ticker)) over_rides = this.reportDataOverridesDB[ticker];
            return over_rides;
        }
        // @computed get selectedReportRun(): any {
        //     if (!this.reportRuns || !this.selectedReportId) {
        //         return null;
        //     }
        //     return this.reportRuns[this.selectedReportId] ?? null;
        // }
        get query() {
            if (!this.activeReportOriginal) return null;
            if (!this.areOveridesLoaded || !this.isRagDbLoaded || !this.isChatLoaded) return null;
            return new (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)(this.activeReportOriginal, this.reportOverride, this.selectedReportId);
        }
        get report_flowise() {
            if (!this.query) return null;
            const ret = this.query.value('flowise');
            if (ret == 'N/A') return null;
            return ret;
        }
        get ragAPI() {
            if (!this.activeReportOriginal) return null;
            return new (0, $8df13b3de5b3c0c6$export$79c5294a8f16ac4d)(this.selectedReportId);
        }
        resetDataAccessCache() {
            this.reportsDataAccessCache = {};
        }
        createDataAccess(reportId) {
            if (this.reportsDataAccessCache[reportId]) return this.reportsDataAccessCache[reportId];
            //console.log('Creating data access for: ', reportId);
            const deal = this.reportDataDB[reportId]; //Fix over rides ?
            if (!deal || deal['status'] != 'completed') {
                console.log('No data found for: ', reportId);
                return null;
            }
            const override = this.reportDataOverridesDB[reportId];
            this.reportsDataAccessCache[reportId] = new (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)(deal, override, reportId);
            return this.reportsDataAccessCache[reportId];
        }
        get company_name() {
            var _b;
            return (_b = this.query) === null || _b === void 0 ? void 0 : _b.value('company_name');
        }
        get ticker() {
            var _b;
            return (_b = this.query) === null || _b === void 0 ? void 0 : _b.value('ticker');
        }
        get reportCreationDate() {
            var _b, _c;
            if (!((_b = this.query) === null || _b === void 0 ? void 0 : _b.value('created'))) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($fX8pL))).unix((_c = this.query) === null || _c === void 0 ? void 0 : _c.value('created')).format('YYYY-MM-D');
        }
        get errorMessageTicker() {
            var _b, _c;
            if (!((_b = this.query) === null || _b === void 0 ? void 0 : _b.value('error'))) return null;
            return (_c = this.query) === null || _c === void 0 ? void 0 : _c.value('error');
        }
        get reportFiscalYear() {
            var _b, _c;
            if (!((_b = this.query) === null || _b === void 0 ? void 0 : _b.value('report_fiscal_year'))) return null;
            return (_c = this.query) === null || _c === void 0 ? void 0 : _c.value('report_fiscal_year');
        }
        get companyOverview() {
            var _b;
            return (_b = this.query) === null || _b === void 0 ? void 0 : _b.value('company_overview');
        }
    }, _Store_selectedReportId_accessor_storage = new WeakMap(), _Store_selectedTaskId_accessor_storage = new WeakMap(), _Store_reportDataDB_accessor_storage = new WeakMap(), _Store_flowTaskVarsExistTable_accessor_storage = new WeakMap(), _Store_flowTaskState_accessor_storage = new WeakMap(), _Store_knowledgeFilesDB_accessor_storage = new WeakMap(), _Store_showAdminConsoleFromKeyboardShortcut_accessor_storage = new WeakMap(), _Store_reportDataOverridesDB_accessor_storage = new WeakMap(), _Store_reportsDataAccessCache_accessor_storage = new WeakMap(), _Store_users_accessor_storage = new WeakMap(), _Store_userId_accessor_storage = new WeakMap(), _Store_jobs_accessor_storage = new WeakMap(), _Store_systemStatus_accessor_storage = new WeakMap(), _Store_activeJob_accessor_storage = new WeakMap(), _Store_areSettingsLoaded_accessor_storage = new WeakMap(), _Store_areOveridesLoaded_accessor_storage = new WeakMap(), _Store_areScoreRulesLoaded_accessor_storage = new WeakMap(), _Store_areKnowledgeFilesLoaded_accessor_storage = new WeakMap(), _Store_areTaskDefinitionsLoaded_accessor_storage = new WeakMap(), _Store_allProjectFiles_accessor_storage = new WeakMap(), _Store_firmInfo_accessor_storage = new WeakMap(), _Store_reportDefinitions_accessor_storage = new WeakMap(), _Store_isChatLoaded_accessor_storage = new WeakMap(), _Store_chatData_accessor_storage = new WeakMap(), _Store_ragDB_accessor_storage = new WeakMap(), _Store_isRagDbLoaded_accessor_storage = new WeakMap(), _Store_lastReportLoaded_accessor_storage = new WeakMap(), _Store_allUserComparables_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _selectedReportId_decorators = [
            (0, $T5IcR.observable)
        ];
        _selectedTaskId_decorators = [
            (0, $T5IcR.observable)
        ];
        _reportDataDB_decorators = [
            (0, $T5IcR.observable)
        ];
        _flowTaskVarsExistTable_decorators = [
            (0, $T5IcR.observable)
        ];
        _flowTaskState_decorators = [
            (0, $T5IcR.observable)
        ];
        _get_activeReportTasksState_decorators = [
            (0, $T5IcR.computed)
        ];
        _knowledgeFilesDB_decorators = [
            (0, $T5IcR.observable)
        ];
        _get_isAdmin_decorators = [
            (0, $T5IcR.computed)
        ];
        _showAdminConsoleFromKeyboardShortcut_decorators = [
            (0, $T5IcR.observable)
        ];
        _get_showAdminConsole_decorators = [
            (0, $T5IcR.computed)
        ];
        _reportDataOverridesDB_decorators = [
            (0, $T5IcR.observable)
        ];
        _reportsDataAccessCache_decorators = [
            (0, $T5IcR.observable)
        ];
        _users_decorators = [
            (0, $T5IcR.observable)
        ];
        _userId_decorators = [
            (0, $T5IcR.observable)
        ];
        _jobs_decorators = [
            (0, $T5IcR.observable)
        ];
        _systemStatus_decorators = [
            (0, $T5IcR.observable)
        ];
        _activeJob_decorators = [
            (0, $T5IcR.observable)
        ];
        _areSettingsLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _areOveridesLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _areScoreRulesLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _areKnowledgeFilesLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _areTaskDefinitionsLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _allProjectFiles_decorators = [
            (0, $T5IcR.observable)
        ];
        _firmInfo_decorators = [
            (0, $T5IcR.observable)
        ];
        _reportDefinitions_decorators = [
            (0, $T5IcR.observable)
        ];
        _isChatLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _chatData_decorators = [
            (0, $T5IcR.observable)
        ];
        _ragDB_decorators = [
            (0, $T5IcR.observable)
        ];
        _isRagDbLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _lastReportLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _allUserComparables_decorators = [
            (0, $T5IcR.observable)
        ];
        _get_userComparables_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_hasMaxComparables_decorators = [
            (0, $T5IcR.computed)
        ];
        _initializeUserComparables_decorators = [
            (0, $T5IcR.action)
        ];
        _get_activeReportOriginal_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_isLoaded_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_projectKnowledgeFiles_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_projectFiles_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_reportChatHistory_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_reportChatCitationsHistory_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_reportOverride_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_query_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_report_flowise_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_ragAPI_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_company_name_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_ticker_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_reportCreationDate_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_errorMessageTicker_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_reportFiscalYear_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_companyOverview_decorators = [
            (0, $T5IcR.computed)
        ];
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _selectedReportId_decorators, {
            kind: "accessor",
            name: "selectedReportId",
            static: false,
            private: false,
            access: {
                has: (obj)=>"selectedReportId" in obj,
                get: (obj)=>obj.selectedReportId,
                set: (obj, value)=>{
                    obj.selectedReportId = value;
                }
            },
            metadata: _metadata
        }, _selectedReportId_initializers, _selectedReportId_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _selectedTaskId_decorators, {
            kind: "accessor",
            name: "selectedTaskId",
            static: false,
            private: false,
            access: {
                has: (obj)=>"selectedTaskId" in obj,
                get: (obj)=>obj.selectedTaskId,
                set: (obj, value)=>{
                    obj.selectedTaskId = value;
                }
            },
            metadata: _metadata
        }, _selectedTaskId_initializers, _selectedTaskId_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _reportDataDB_decorators, {
            kind: "accessor",
            name: "reportDataDB",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportDataDB" in obj,
                get: (obj)=>obj.reportDataDB,
                set: (obj, value)=>{
                    obj.reportDataDB = value;
                }
            },
            metadata: _metadata
        }, _reportDataDB_initializers, _reportDataDB_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _flowTaskVarsExistTable_decorators, {
            kind: "accessor",
            name: "flowTaskVarsExistTable",
            static: false,
            private: false,
            access: {
                has: (obj)=>"flowTaskVarsExistTable" in obj,
                get: (obj)=>obj.flowTaskVarsExistTable,
                set: (obj, value)=>{
                    obj.flowTaskVarsExistTable = value;
                }
            },
            metadata: _metadata
        }, _flowTaskVarsExistTable_initializers, _flowTaskVarsExistTable_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _flowTaskState_decorators, {
            kind: "accessor",
            name: "flowTaskState",
            static: false,
            private: false,
            access: {
                has: (obj)=>"flowTaskState" in obj,
                get: (obj)=>obj.flowTaskState,
                set: (obj, value)=>{
                    obj.flowTaskState = value;
                }
            },
            metadata: _metadata
        }, _flowTaskState_initializers, _flowTaskState_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_activeReportTasksState_decorators, {
            kind: "getter",
            name: "activeReportTasksState",
            static: false,
            private: false,
            access: {
                has: (obj)=>"activeReportTasksState" in obj,
                get: (obj)=>obj.activeReportTasksState
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _knowledgeFilesDB_decorators, {
            kind: "accessor",
            name: "knowledgeFilesDB",
            static: false,
            private: false,
            access: {
                has: (obj)=>"knowledgeFilesDB" in obj,
                get: (obj)=>obj.knowledgeFilesDB,
                set: (obj, value)=>{
                    obj.knowledgeFilesDB = value;
                }
            },
            metadata: _metadata
        }, _knowledgeFilesDB_initializers, _knowledgeFilesDB_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_isAdmin_decorators, {
            kind: "getter",
            name: "isAdmin",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isAdmin" in obj,
                get: (obj)=>obj.isAdmin
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _showAdminConsoleFromKeyboardShortcut_decorators, {
            kind: "accessor",
            name: "showAdminConsoleFromKeyboardShortcut",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showAdminConsoleFromKeyboardShortcut" in obj,
                get: (obj)=>obj.showAdminConsoleFromKeyboardShortcut,
                set: (obj, value)=>{
                    obj.showAdminConsoleFromKeyboardShortcut = value;
                }
            },
            metadata: _metadata
        }, _showAdminConsoleFromKeyboardShortcut_initializers, _showAdminConsoleFromKeyboardShortcut_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_showAdminConsole_decorators, {
            kind: "getter",
            name: "showAdminConsole",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showAdminConsole" in obj,
                get: (obj)=>obj.showAdminConsole
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _reportDataOverridesDB_decorators, {
            kind: "accessor",
            name: "reportDataOverridesDB",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportDataOverridesDB" in obj,
                get: (obj)=>obj.reportDataOverridesDB,
                set: (obj, value)=>{
                    obj.reportDataOverridesDB = value;
                }
            },
            metadata: _metadata
        }, _reportDataOverridesDB_initializers, _reportDataOverridesDB_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _reportsDataAccessCache_decorators, {
            kind: "accessor",
            name: "reportsDataAccessCache",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportsDataAccessCache" in obj,
                get: (obj)=>obj.reportsDataAccessCache,
                set: (obj, value)=>{
                    obj.reportsDataAccessCache = value;
                }
            },
            metadata: _metadata
        }, _reportsDataAccessCache_initializers, _reportsDataAccessCache_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _users_decorators, {
            kind: "accessor",
            name: "users",
            static: false,
            private: false,
            access: {
                has: (obj)=>"users" in obj,
                get: (obj)=>obj.users,
                set: (obj, value)=>{
                    obj.users = value;
                }
            },
            metadata: _metadata
        }, _users_initializers, _users_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _userId_decorators, {
            kind: "accessor",
            name: "userId",
            static: false,
            private: false,
            access: {
                has: (obj)=>"userId" in obj,
                get: (obj)=>obj.userId,
                set: (obj, value)=>{
                    obj.userId = value;
                }
            },
            metadata: _metadata
        }, _userId_initializers, _userId_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _jobs_decorators, {
            kind: "accessor",
            name: "jobs",
            static: false,
            private: false,
            access: {
                has: (obj)=>"jobs" in obj,
                get: (obj)=>obj.jobs,
                set: (obj, value)=>{
                    obj.jobs = value;
                }
            },
            metadata: _metadata
        }, _jobs_initializers, _jobs_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _systemStatus_decorators, {
            kind: "accessor",
            name: "systemStatus",
            static: false,
            private: false,
            access: {
                has: (obj)=>"systemStatus" in obj,
                get: (obj)=>obj.systemStatus,
                set: (obj, value)=>{
                    obj.systemStatus = value;
                }
            },
            metadata: _metadata
        }, _systemStatus_initializers, _systemStatus_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _activeJob_decorators, {
            kind: "accessor",
            name: "activeJob",
            static: false,
            private: false,
            access: {
                has: (obj)=>"activeJob" in obj,
                get: (obj)=>obj.activeJob,
                set: (obj, value)=>{
                    obj.activeJob = value;
                }
            },
            metadata: _metadata
        }, _activeJob_initializers, _activeJob_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _areSettingsLoaded_decorators, {
            kind: "accessor",
            name: "areSettingsLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"areSettingsLoaded" in obj,
                get: (obj)=>obj.areSettingsLoaded,
                set: (obj, value)=>{
                    obj.areSettingsLoaded = value;
                }
            },
            metadata: _metadata
        }, _areSettingsLoaded_initializers, _areSettingsLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _areOveridesLoaded_decorators, {
            kind: "accessor",
            name: "areOveridesLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"areOveridesLoaded" in obj,
                get: (obj)=>obj.areOveridesLoaded,
                set: (obj, value)=>{
                    obj.areOveridesLoaded = value;
                }
            },
            metadata: _metadata
        }, _areOveridesLoaded_initializers, _areOveridesLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _areScoreRulesLoaded_decorators, {
            kind: "accessor",
            name: "areScoreRulesLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"areScoreRulesLoaded" in obj,
                get: (obj)=>obj.areScoreRulesLoaded,
                set: (obj, value)=>{
                    obj.areScoreRulesLoaded = value;
                }
            },
            metadata: _metadata
        }, _areScoreRulesLoaded_initializers, _areScoreRulesLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _areKnowledgeFilesLoaded_decorators, {
            kind: "accessor",
            name: "areKnowledgeFilesLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"areKnowledgeFilesLoaded" in obj,
                get: (obj)=>obj.areKnowledgeFilesLoaded,
                set: (obj, value)=>{
                    obj.areKnowledgeFilesLoaded = value;
                }
            },
            metadata: _metadata
        }, _areKnowledgeFilesLoaded_initializers, _areKnowledgeFilesLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _areTaskDefinitionsLoaded_decorators, {
            kind: "accessor",
            name: "areTaskDefinitionsLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"areTaskDefinitionsLoaded" in obj,
                get: (obj)=>obj.areTaskDefinitionsLoaded,
                set: (obj, value)=>{
                    obj.areTaskDefinitionsLoaded = value;
                }
            },
            metadata: _metadata
        }, _areTaskDefinitionsLoaded_initializers, _areTaskDefinitionsLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _allProjectFiles_decorators, {
            kind: "accessor",
            name: "allProjectFiles",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allProjectFiles" in obj,
                get: (obj)=>obj.allProjectFiles,
                set: (obj, value)=>{
                    obj.allProjectFiles = value;
                }
            },
            metadata: _metadata
        }, _allProjectFiles_initializers, _allProjectFiles_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _firmInfo_decorators, {
            kind: "accessor",
            name: "firmInfo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"firmInfo" in obj,
                get: (obj)=>obj.firmInfo,
                set: (obj, value)=>{
                    obj.firmInfo = value;
                }
            },
            metadata: _metadata
        }, _firmInfo_initializers, _firmInfo_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _reportDefinitions_decorators, {
            kind: "accessor",
            name: "reportDefinitions",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportDefinitions" in obj,
                get: (obj)=>obj.reportDefinitions,
                set: (obj, value)=>{
                    obj.reportDefinitions = value;
                }
            },
            metadata: _metadata
        }, _reportDefinitions_initializers, _reportDefinitions_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isChatLoaded_decorators, {
            kind: "accessor",
            name: "isChatLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isChatLoaded" in obj,
                get: (obj)=>obj.isChatLoaded,
                set: (obj, value)=>{
                    obj.isChatLoaded = value;
                }
            },
            metadata: _metadata
        }, _isChatLoaded_initializers, _isChatLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _chatData_decorators, {
            kind: "accessor",
            name: "chatData",
            static: false,
            private: false,
            access: {
                has: (obj)=>"chatData" in obj,
                get: (obj)=>obj.chatData,
                set: (obj, value)=>{
                    obj.chatData = value;
                }
            },
            metadata: _metadata
        }, _chatData_initializers, _chatData_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _ragDB_decorators, {
            kind: "accessor",
            name: "ragDB",
            static: false,
            private: false,
            access: {
                has: (obj)=>"ragDB" in obj,
                get: (obj)=>obj.ragDB,
                set: (obj, value)=>{
                    obj.ragDB = value;
                }
            },
            metadata: _metadata
        }, _ragDB_initializers, _ragDB_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isRagDbLoaded_decorators, {
            kind: "accessor",
            name: "isRagDbLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isRagDbLoaded" in obj,
                get: (obj)=>obj.isRagDbLoaded,
                set: (obj, value)=>{
                    obj.isRagDbLoaded = value;
                }
            },
            metadata: _metadata
        }, _isRagDbLoaded_initializers, _isRagDbLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _lastReportLoaded_decorators, {
            kind: "accessor",
            name: "lastReportLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"lastReportLoaded" in obj,
                get: (obj)=>obj.lastReportLoaded,
                set: (obj, value)=>{
                    obj.lastReportLoaded = value;
                }
            },
            metadata: _metadata
        }, _lastReportLoaded_initializers, _lastReportLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _allUserComparables_decorators, {
            kind: "accessor",
            name: "allUserComparables",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allUserComparables" in obj,
                get: (obj)=>obj.allUserComparables,
                set: (obj, value)=>{
                    obj.allUserComparables = value;
                }
            },
            metadata: _metadata
        }, _allUserComparables_initializers, _allUserComparables_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_userComparables_decorators, {
            kind: "getter",
            name: "userComparables",
            static: false,
            private: false,
            access: {
                has: (obj)=>"userComparables" in obj,
                get: (obj)=>obj.userComparables
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_hasMaxComparables_decorators, {
            kind: "getter",
            name: "hasMaxComparables",
            static: false,
            private: false,
            access: {
                has: (obj)=>"hasMaxComparables" in obj,
                get: (obj)=>obj.hasMaxComparables
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _initializeUserComparables_decorators, {
            kind: "method",
            name: "initializeUserComparables",
            static: false,
            private: false,
            access: {
                has: (obj)=>"initializeUserComparables" in obj,
                get: (obj)=>obj.initializeUserComparables
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_activeReportOriginal_decorators, {
            kind: "getter",
            name: "activeReportOriginal",
            static: false,
            private: false,
            access: {
                has: (obj)=>"activeReportOriginal" in obj,
                get: (obj)=>obj.activeReportOriginal
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_isLoaded_decorators, {
            kind: "getter",
            name: "isLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isLoaded" in obj,
                get: (obj)=>obj.isLoaded
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_projectKnowledgeFiles_decorators, {
            kind: "getter",
            name: "projectKnowledgeFiles",
            static: false,
            private: false,
            access: {
                has: (obj)=>"projectKnowledgeFiles" in obj,
                get: (obj)=>obj.projectKnowledgeFiles
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_projectFiles_decorators, {
            kind: "getter",
            name: "projectFiles",
            static: false,
            private: false,
            access: {
                has: (obj)=>"projectFiles" in obj,
                get: (obj)=>obj.projectFiles
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_reportChatHistory_decorators, {
            kind: "getter",
            name: "reportChatHistory",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportChatHistory" in obj,
                get: (obj)=>obj.reportChatHistory
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_reportChatCitationsHistory_decorators, {
            kind: "getter",
            name: "reportChatCitationsHistory",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportChatCitationsHistory" in obj,
                get: (obj)=>obj.reportChatCitationsHistory
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_reportOverride_decorators, {
            kind: "getter",
            name: "reportOverride",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportOverride" in obj,
                get: (obj)=>obj.reportOverride
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_query_decorators, {
            kind: "getter",
            name: "query",
            static: false,
            private: false,
            access: {
                has: (obj)=>"query" in obj,
                get: (obj)=>obj.query
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_report_flowise_decorators, {
            kind: "getter",
            name: "report_flowise",
            static: false,
            private: false,
            access: {
                has: (obj)=>"report_flowise" in obj,
                get: (obj)=>obj.report_flowise
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_ragAPI_decorators, {
            kind: "getter",
            name: "ragAPI",
            static: false,
            private: false,
            access: {
                has: (obj)=>"ragAPI" in obj,
                get: (obj)=>obj.ragAPI
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_company_name_decorators, {
            kind: "getter",
            name: "company_name",
            static: false,
            private: false,
            access: {
                has: (obj)=>"company_name" in obj,
                get: (obj)=>obj.company_name
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_ticker_decorators, {
            kind: "getter",
            name: "ticker",
            static: false,
            private: false,
            access: {
                has: (obj)=>"ticker" in obj,
                get: (obj)=>obj.ticker
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_reportCreationDate_decorators, {
            kind: "getter",
            name: "reportCreationDate",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportCreationDate" in obj,
                get: (obj)=>obj.reportCreationDate
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_errorMessageTicker_decorators, {
            kind: "getter",
            name: "errorMessageTicker",
            static: false,
            private: false,
            access: {
                has: (obj)=>"errorMessageTicker" in obj,
                get: (obj)=>obj.errorMessageTicker
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_reportFiscalYear_decorators, {
            kind: "getter",
            name: "reportFiscalYear",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportFiscalYear" in obj,
                get: (obj)=>obj.reportFiscalYear
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_companyOverview_decorators, {
            kind: "getter",
            name: "companyOverview",
            static: false,
            private: false,
            access: {
                has: (obj)=>"companyOverview" in obj,
                get: (obj)=>obj.companyOverview
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $8f024b03d9af7c67$export$74848b9d4d66d1d3;
(function(UIDealDetailsTabs) {
    UIDealDetailsTabs["DASHBOARD"] = "DASHBOARD";
    UIDealDetailsTabs["FLOWISE_CHAT"] = "COMPETITORS";
    UIDealDetailsTabs["DETAILS"] = "DETAILS";
    UIDealDetailsTabs["COMPARE"] = "COMPARE";
    UIDealDetailsTabs["SCORE_BREAKDOWN"] = "SUMMARY";
    UIDealDetailsTabs["CHAT"] = "CHAT";
    UIDealDetailsTabs["FLOWISE"] = "FLOWISE";
    UIDealDetailsTabs["TASK_CHAT"] = "TASK_CHAT";
    UIDealDetailsTabs["TASK_CHAT_1"] = "TASK_CHAT_1";
    UIDealDetailsTabs["TASK_CHAT_2"] = "TASK_CHAT_2";
    UIDealDetailsTabs["WORKSTREAMS"] = "WORKSTREAMS";
    UIDealDetailsTabs["OUTPUTS"] = "OUTPUTS";
})($8f024b03d9af7c67$export$74848b9d4d66d1d3 || ($8f024b03d9af7c67$export$74848b9d4d66d1d3 = {}));
let $8f024b03d9af7c67$export$5a825fdb72e99846 = (()=>{
    var _a, _StoreUI_detailsViewYearsToShow_accessor_storage, _StoreUI_pdfRequest_accessor_storage, _StoreUI_disableLoading_accessor_storage, _StoreUI_forceLoading_accessor_storage, _StoreUI_scrolling_accessor_storage, _StoreUI_currentSplitRatioDetailView_accessor_storage, _StoreUI_modal_accessor_storage, _StoreUI_dealPageNameSearch_accessor_storage, _StoreUI_dealPageIndustrySearch_accessor_storage, _StoreUI_dealPageScoreSearch_accessor_storage, _StoreUI_dealPageSortOrder_accessor_storage, _StoreUI_pageTitle_accessor_storage, _StoreUI_dealViewTab_accessor_storage, _StoreUI_chatWaitingForResponse_accessor_storage, _StoreUI_isKeyControlKeyDown_accessor_storage, _StoreUI_isKeyTabDown_accessor_storage, _StoreUI_isKeyShiftKeyDown_accessor_storage, _StoreUI_isKeyEscapeDown_accessor_storage, _StoreUI_showEditedUnderlines_accessor_storage;
    let _detailsViewYearsToShow_decorators;
    let _detailsViewYearsToShow_initializers = [];
    let _detailsViewYearsToShow_extraInitializers = [];
    let _pdfRequest_decorators;
    let _pdfRequest_initializers = [];
    let _pdfRequest_extraInitializers = [];
    let _disableLoading_decorators;
    let _disableLoading_initializers = [];
    let _disableLoading_extraInitializers = [];
    let _forceLoading_decorators;
    let _forceLoading_initializers = [];
    let _forceLoading_extraInitializers = [];
    let _scrolling_decorators;
    let _scrolling_initializers = [];
    let _scrolling_extraInitializers = [];
    let _currentSplitRatioDetailView_decorators;
    let _currentSplitRatioDetailView_initializers = [];
    let _currentSplitRatioDetailView_extraInitializers = [];
    let _modal_decorators;
    let _modal_initializers = [];
    let _modal_extraInitializers = [];
    let _dealPageNameSearch_decorators;
    let _dealPageNameSearch_initializers = [];
    let _dealPageNameSearch_extraInitializers = [];
    let _dealPageIndustrySearch_decorators;
    let _dealPageIndustrySearch_initializers = [];
    let _dealPageIndustrySearch_extraInitializers = [];
    let _dealPageScoreSearch_decorators;
    let _dealPageScoreSearch_initializers = [];
    let _dealPageScoreSearch_extraInitializers = [];
    let _dealPageSortOrder_decorators;
    let _dealPageSortOrder_initializers = [];
    let _dealPageSortOrder_extraInitializers = [];
    let _pageTitle_decorators;
    let _pageTitle_initializers = [];
    let _pageTitle_extraInitializers = [];
    let _dealViewTab_decorators;
    let _dealViewTab_initializers = [];
    let _dealViewTab_extraInitializers = [];
    let _chatWaitingForResponse_decorators;
    let _chatWaitingForResponse_initializers = [];
    let _chatWaitingForResponse_extraInitializers = [];
    let _isKeyControlKeyDown_decorators;
    let _isKeyControlKeyDown_initializers = [];
    let _isKeyControlKeyDown_extraInitializers = [];
    let _isKeyTabDown_decorators;
    let _isKeyTabDown_initializers = [];
    let _isKeyTabDown_extraInitializers = [];
    let _isKeyShiftKeyDown_decorators;
    let _isKeyShiftKeyDown_initializers = [];
    let _isKeyShiftKeyDown_extraInitializers = [];
    let _isKeyEscapeDown_decorators;
    let _isKeyEscapeDown_initializers = [];
    let _isKeyEscapeDown_extraInitializers = [];
    let _showEditedUnderlines_decorators;
    let _showEditedUnderlines_initializers = [];
    let _showEditedUnderlines_extraInitializers = [];
    return _a = class StoreUI {
        get isDev() {
            return false;
        }
        resetViewerRequests() {
            this.pdfRequest = {
                page: -1,
                highlightTexts: []
            };
        }
        resetDealView() {
            this.dealViewTab = $8f024b03d9af7c67$export$74848b9d4d66d1d3.DASHBOARD;
            if (this.isDev) this.dealViewTab = $8f024b03d9af7c67$export$74848b9d4d66d1d3.WORKSTREAMS;
            this.resetViewerRequests();
        }
        resetHome() {
            this.dealPageNameSearch = '';
            this.dealPageIndustrySearch = [];
            this.dealPageScoreSearch = [];
            this.dealPageSortOrder = 'newest';
        }
        onKeyUpReset() {
            this.isKeyControlKeyDown = false;
            this.scrolling = 'NONE';
            this.isKeyTabDown = false;
            this.isKeyShiftKeyDown = false;
            this.isKeyEscapeDown = false;
        }
        requestPdfImagePage(page) {
            this.resetViewerRequests();
            setTimeout(()=>{
                this.pdfRequest = {
                    page: page,
                    highlightTexts: []
                };
            }, 10);
        }
        constructor(){
            _StoreUI_detailsViewYearsToShow_accessor_storage.set(this, $8f024b03d9af7c67$var$__runInitializers(this, _detailsViewYearsToShow_initializers, 3));
            _StoreUI_pdfRequest_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _detailsViewYearsToShow_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _pdfRequest_initializers, void 0)));
            _StoreUI_disableLoading_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _pdfRequest_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _disableLoading_initializers, false)));
            _StoreUI_forceLoading_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _disableLoading_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _forceLoading_initializers, false)));
            _StoreUI_scrolling_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _forceLoading_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _scrolling_initializers, 'NONE')));
            _StoreUI_currentSplitRatioDetailView_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _scrolling_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _currentSplitRatioDetailView_initializers, 50)));
            _StoreUI_modal_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _currentSplitRatioDetailView_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _modal_initializers, null)));
            _StoreUI_dealPageNameSearch_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _modal_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _dealPageNameSearch_initializers, '')));
            _StoreUI_dealPageIndustrySearch_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _dealPageNameSearch_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _dealPageIndustrySearch_initializers, [])));
            _StoreUI_dealPageScoreSearch_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _dealPageIndustrySearch_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _dealPageScoreSearch_initializers, [])));
            _StoreUI_dealPageSortOrder_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _dealPageScoreSearch_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _dealPageSortOrder_initializers, 'newest')));
            _StoreUI_pageTitle_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _dealPageSortOrder_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _pageTitle_initializers, '')));
            _StoreUI_dealViewTab_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _pageTitle_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _dealViewTab_initializers, void 0)));
            _StoreUI_chatWaitingForResponse_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _dealViewTab_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _chatWaitingForResponse_initializers, false)));
            _StoreUI_isKeyControlKeyDown_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _chatWaitingForResponse_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isKeyControlKeyDown_initializers, false)));
            _StoreUI_isKeyTabDown_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isKeyControlKeyDown_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isKeyTabDown_initializers, false)));
            _StoreUI_isKeyShiftKeyDown_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isKeyTabDown_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isKeyShiftKeyDown_initializers, false)));
            _StoreUI_isKeyEscapeDown_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isKeyShiftKeyDown_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isKeyEscapeDown_initializers, false)));
            _StoreUI_showEditedUnderlines_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isKeyEscapeDown_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _showEditedUnderlines_initializers, false)));
            $8f024b03d9af7c67$var$__runInitializers(this, _showEditedUnderlines_extraInitializers);
            this.resetDealView();
        }
        get detailsViewYearsToShow() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_detailsViewYearsToShow_accessor_storage, "f");
        }
        set detailsViewYearsToShow(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_detailsViewYearsToShow_accessor_storage, value, "f");
        }
        get pdfRequest() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_pdfRequest_accessor_storage, "f");
        }
        set pdfRequest(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_pdfRequest_accessor_storage, value, "f");
        }
        get disableLoading() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_disableLoading_accessor_storage, "f");
        }
        set disableLoading(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_disableLoading_accessor_storage, value, "f");
        }
        get forceLoading() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_forceLoading_accessor_storage, "f");
        }
        set forceLoading(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_forceLoading_accessor_storage, value, "f");
        }
        get scrolling() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_scrolling_accessor_storage, "f");
        }
        set scrolling(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_scrolling_accessor_storage, value, "f");
        }
        get currentSplitRatioDetailView() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_currentSplitRatioDetailView_accessor_storage, "f");
        }
        set currentSplitRatioDetailView(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_currentSplitRatioDetailView_accessor_storage, value, "f");
        }
        get modal() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_modal_accessor_storage, "f");
        }
        set modal(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_modal_accessor_storage, value, "f");
        }
        get dealPageNameSearch() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_dealPageNameSearch_accessor_storage, "f");
        }
        set dealPageNameSearch(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_dealPageNameSearch_accessor_storage, value, "f");
        }
        get dealPageIndustrySearch() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_dealPageIndustrySearch_accessor_storage, "f");
        }
        set dealPageIndustrySearch(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_dealPageIndustrySearch_accessor_storage, value, "f");
        }
        get dealPageScoreSearch() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_dealPageScoreSearch_accessor_storage, "f");
        }
        set dealPageScoreSearch(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_dealPageScoreSearch_accessor_storage, value, "f");
        }
        get dealPageSortOrder() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_dealPageSortOrder_accessor_storage, "f");
        }
        set dealPageSortOrder(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_dealPageSortOrder_accessor_storage, value, "f");
        }
        get pageTitle() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_pageTitle_accessor_storage, "f");
        }
        set pageTitle(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_pageTitle_accessor_storage, value, "f");
        }
        get dealViewTab() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_dealViewTab_accessor_storage, "f");
        }
        set dealViewTab(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_dealViewTab_accessor_storage, value, "f");
        }
        get chatWaitingForResponse() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_chatWaitingForResponse_accessor_storage, "f");
        }
        set chatWaitingForResponse(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_chatWaitingForResponse_accessor_storage, value, "f");
        }
        get isKeyControlKeyDown() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_isKeyControlKeyDown_accessor_storage, "f");
        }
        set isKeyControlKeyDown(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_isKeyControlKeyDown_accessor_storage, value, "f");
        }
        get isKeyTabDown() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_isKeyTabDown_accessor_storage, "f");
        }
        set isKeyTabDown(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_isKeyTabDown_accessor_storage, value, "f");
        }
        get isKeyShiftKeyDown() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_isKeyShiftKeyDown_accessor_storage, "f");
        }
        set isKeyShiftKeyDown(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_isKeyShiftKeyDown_accessor_storage, value, "f");
        }
        get isKeyEscapeDown() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_isKeyEscapeDown_accessor_storage, "f");
        }
        set isKeyEscapeDown(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_isKeyEscapeDown_accessor_storage, value, "f");
        }
        get showEditedUnderlines() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_showEditedUnderlines_accessor_storage, "f");
        }
        set showEditedUnderlines(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_showEditedUnderlines_accessor_storage, value, "f");
        }
    }, _StoreUI_detailsViewYearsToShow_accessor_storage = new WeakMap(), _StoreUI_pdfRequest_accessor_storage = new WeakMap(), _StoreUI_disableLoading_accessor_storage = new WeakMap(), _StoreUI_forceLoading_accessor_storage = new WeakMap(), _StoreUI_scrolling_accessor_storage = new WeakMap(), _StoreUI_currentSplitRatioDetailView_accessor_storage = new WeakMap(), _StoreUI_modal_accessor_storage = new WeakMap(), _StoreUI_dealPageNameSearch_accessor_storage = new WeakMap(), _StoreUI_dealPageIndustrySearch_accessor_storage = new WeakMap(), _StoreUI_dealPageScoreSearch_accessor_storage = new WeakMap(), _StoreUI_dealPageSortOrder_accessor_storage = new WeakMap(), _StoreUI_pageTitle_accessor_storage = new WeakMap(), _StoreUI_dealViewTab_accessor_storage = new WeakMap(), _StoreUI_chatWaitingForResponse_accessor_storage = new WeakMap(), _StoreUI_isKeyControlKeyDown_accessor_storage = new WeakMap(), _StoreUI_isKeyTabDown_accessor_storage = new WeakMap(), _StoreUI_isKeyShiftKeyDown_accessor_storage = new WeakMap(), _StoreUI_isKeyEscapeDown_accessor_storage = new WeakMap(), _StoreUI_showEditedUnderlines_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _detailsViewYearsToShow_decorators = [
            (0, $T5IcR.observable)
        ];
        _pdfRequest_decorators = [
            (0, $T5IcR.observable)
        ];
        _disableLoading_decorators = [
            (0, $T5IcR.observable)
        ];
        _forceLoading_decorators = [
            (0, $T5IcR.observable)
        ];
        _scrolling_decorators = [
            (0, $T5IcR.observable)
        ];
        _currentSplitRatioDetailView_decorators = [
            (0, $T5IcR.observable)
        ];
        _modal_decorators = [
            (0, $T5IcR.observable)
        ];
        _dealPageNameSearch_decorators = [
            (0, $T5IcR.observable)
        ];
        _dealPageIndustrySearch_decorators = [
            (0, $T5IcR.observable)
        ];
        _dealPageScoreSearch_decorators = [
            (0, $T5IcR.observable)
        ];
        _dealPageSortOrder_decorators = [
            (0, $T5IcR.observable)
        ];
        _pageTitle_decorators = [
            (0, $T5IcR.observable)
        ];
        _dealViewTab_decorators = [
            (0, $T5IcR.observable)
        ];
        _chatWaitingForResponse_decorators = [
            (0, $T5IcR.observable)
        ];
        _isKeyControlKeyDown_decorators = [
            (0, $T5IcR.observable)
        ];
        _isKeyTabDown_decorators = [
            (0, $T5IcR.observable)
        ];
        _isKeyShiftKeyDown_decorators = [
            (0, $T5IcR.observable)
        ];
        _isKeyEscapeDown_decorators = [
            (0, $T5IcR.observable)
        ];
        _showEditedUnderlines_decorators = [
            (0, $T5IcR.observable)
        ];
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _detailsViewYearsToShow_decorators, {
            kind: "accessor",
            name: "detailsViewYearsToShow",
            static: false,
            private: false,
            access: {
                has: (obj)=>"detailsViewYearsToShow" in obj,
                get: (obj)=>obj.detailsViewYearsToShow,
                set: (obj, value)=>{
                    obj.detailsViewYearsToShow = value;
                }
            },
            metadata: _metadata
        }, _detailsViewYearsToShow_initializers, _detailsViewYearsToShow_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _pdfRequest_decorators, {
            kind: "accessor",
            name: "pdfRequest",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pdfRequest" in obj,
                get: (obj)=>obj.pdfRequest,
                set: (obj, value)=>{
                    obj.pdfRequest = value;
                }
            },
            metadata: _metadata
        }, _pdfRequest_initializers, _pdfRequest_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _disableLoading_decorators, {
            kind: "accessor",
            name: "disableLoading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"disableLoading" in obj,
                get: (obj)=>obj.disableLoading,
                set: (obj, value)=>{
                    obj.disableLoading = value;
                }
            },
            metadata: _metadata
        }, _disableLoading_initializers, _disableLoading_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _forceLoading_decorators, {
            kind: "accessor",
            name: "forceLoading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"forceLoading" in obj,
                get: (obj)=>obj.forceLoading,
                set: (obj, value)=>{
                    obj.forceLoading = value;
                }
            },
            metadata: _metadata
        }, _forceLoading_initializers, _forceLoading_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _scrolling_decorators, {
            kind: "accessor",
            name: "scrolling",
            static: false,
            private: false,
            access: {
                has: (obj)=>"scrolling" in obj,
                get: (obj)=>obj.scrolling,
                set: (obj, value)=>{
                    obj.scrolling = value;
                }
            },
            metadata: _metadata
        }, _scrolling_initializers, _scrolling_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _currentSplitRatioDetailView_decorators, {
            kind: "accessor",
            name: "currentSplitRatioDetailView",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentSplitRatioDetailView" in obj,
                get: (obj)=>obj.currentSplitRatioDetailView,
                set: (obj, value)=>{
                    obj.currentSplitRatioDetailView = value;
                }
            },
            metadata: _metadata
        }, _currentSplitRatioDetailView_initializers, _currentSplitRatioDetailView_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _modal_decorators, {
            kind: "accessor",
            name: "modal",
            static: false,
            private: false,
            access: {
                has: (obj)=>"modal" in obj,
                get: (obj)=>obj.modal,
                set: (obj, value)=>{
                    obj.modal = value;
                }
            },
            metadata: _metadata
        }, _modal_initializers, _modal_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _dealPageNameSearch_decorators, {
            kind: "accessor",
            name: "dealPageNameSearch",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealPageNameSearch" in obj,
                get: (obj)=>obj.dealPageNameSearch,
                set: (obj, value)=>{
                    obj.dealPageNameSearch = value;
                }
            },
            metadata: _metadata
        }, _dealPageNameSearch_initializers, _dealPageNameSearch_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _dealPageIndustrySearch_decorators, {
            kind: "accessor",
            name: "dealPageIndustrySearch",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealPageIndustrySearch" in obj,
                get: (obj)=>obj.dealPageIndustrySearch,
                set: (obj, value)=>{
                    obj.dealPageIndustrySearch = value;
                }
            },
            metadata: _metadata
        }, _dealPageIndustrySearch_initializers, _dealPageIndustrySearch_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _dealPageScoreSearch_decorators, {
            kind: "accessor",
            name: "dealPageScoreSearch",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealPageScoreSearch" in obj,
                get: (obj)=>obj.dealPageScoreSearch,
                set: (obj, value)=>{
                    obj.dealPageScoreSearch = value;
                }
            },
            metadata: _metadata
        }, _dealPageScoreSearch_initializers, _dealPageScoreSearch_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _dealPageSortOrder_decorators, {
            kind: "accessor",
            name: "dealPageSortOrder",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealPageSortOrder" in obj,
                get: (obj)=>obj.dealPageSortOrder,
                set: (obj, value)=>{
                    obj.dealPageSortOrder = value;
                }
            },
            metadata: _metadata
        }, _dealPageSortOrder_initializers, _dealPageSortOrder_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _pageTitle_decorators, {
            kind: "accessor",
            name: "pageTitle",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageTitle" in obj,
                get: (obj)=>obj.pageTitle,
                set: (obj, value)=>{
                    obj.pageTitle = value;
                }
            },
            metadata: _metadata
        }, _pageTitle_initializers, _pageTitle_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _dealViewTab_decorators, {
            kind: "accessor",
            name: "dealViewTab",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealViewTab" in obj,
                get: (obj)=>obj.dealViewTab,
                set: (obj, value)=>{
                    obj.dealViewTab = value;
                }
            },
            metadata: _metadata
        }, _dealViewTab_initializers, _dealViewTab_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _chatWaitingForResponse_decorators, {
            kind: "accessor",
            name: "chatWaitingForResponse",
            static: false,
            private: false,
            access: {
                has: (obj)=>"chatWaitingForResponse" in obj,
                get: (obj)=>obj.chatWaitingForResponse,
                set: (obj, value)=>{
                    obj.chatWaitingForResponse = value;
                }
            },
            metadata: _metadata
        }, _chatWaitingForResponse_initializers, _chatWaitingForResponse_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isKeyControlKeyDown_decorators, {
            kind: "accessor",
            name: "isKeyControlKeyDown",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isKeyControlKeyDown" in obj,
                get: (obj)=>obj.isKeyControlKeyDown,
                set: (obj, value)=>{
                    obj.isKeyControlKeyDown = value;
                }
            },
            metadata: _metadata
        }, _isKeyControlKeyDown_initializers, _isKeyControlKeyDown_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isKeyTabDown_decorators, {
            kind: "accessor",
            name: "isKeyTabDown",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isKeyTabDown" in obj,
                get: (obj)=>obj.isKeyTabDown,
                set: (obj, value)=>{
                    obj.isKeyTabDown = value;
                }
            },
            metadata: _metadata
        }, _isKeyTabDown_initializers, _isKeyTabDown_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isKeyShiftKeyDown_decorators, {
            kind: "accessor",
            name: "isKeyShiftKeyDown",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isKeyShiftKeyDown" in obj,
                get: (obj)=>obj.isKeyShiftKeyDown,
                set: (obj, value)=>{
                    obj.isKeyShiftKeyDown = value;
                }
            },
            metadata: _metadata
        }, _isKeyShiftKeyDown_initializers, _isKeyShiftKeyDown_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isKeyEscapeDown_decorators, {
            kind: "accessor",
            name: "isKeyEscapeDown",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isKeyEscapeDown" in obj,
                get: (obj)=>obj.isKeyEscapeDown,
                set: (obj, value)=>{
                    obj.isKeyEscapeDown = value;
                }
            },
            metadata: _metadata
        }, _isKeyEscapeDown_initializers, _isKeyEscapeDown_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _showEditedUnderlines_decorators, {
            kind: "accessor",
            name: "showEditedUnderlines",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showEditedUnderlines" in obj,
                get: (obj)=>obj.showEditedUnderlines,
                set: (obj, value)=>{
                    obj.showEditedUnderlines = value;
                }
            },
            metadata: _metadata
        }, _showEditedUnderlines_initializers, _showEditedUnderlines_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $8f024b03d9af7c67$export$d2d3ee67e04f6bd9 = (pageTitle)=>{
    (0, $8nGP5.useEffect)(()=>{
        $8f024b03d9af7c67$var$storeUI.pageTitle = pageTitle;
    }, [
        pageTitle
    ]);
};
let $8f024b03d9af7c67$var$ClientSettingsStore = (()=>{
    var _a, _ClientSettingsStore_settings_accessor_storage;
    let _instanceExtraInitializers = [];
    let _settings_decorators;
    let _settings_initializers = [];
    let _settings_extraInitializers = [];
    let _get_filterCompaniesForDemo_decorators;
    let _get_isMaintenanceOn_decorators;
    let _get_isDemoFilterOn_decorators;
    let _get_onlyAdminsAddReports_decorators;
    let _get_showBetaFeatures_decorators;
    let _get_showAggregateScores_decorators;
    let _get_showSubIndustryInHeader_decorators;
    let _get_enableSourcing_decorators;
    let _get_showWorkstreams_decorators;
    let _get_showPotentialCustomers_decorators;
    let _get_showOutputsTab_decorators;
    let _get_industryTypes_decorators;
    return _a = class ClientSettingsStore {
        set(data) {
            this.settings = data;
        }
        get settings() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _ClientSettingsStore_settings_accessor_storage, "f");
        }
        set settings(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _ClientSettingsStore_settings_accessor_storage, value, "f");
        }
        get filterCompaniesForDemo() {
            var _b, _c;
            return (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.filterCompaniesForDemo) !== null && _c !== void 0 ? _c : {};
        }
        get isMaintenanceOn() {
            var _b, _c;
            return (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.isMaintenanceOn) !== null && _c !== void 0 ? _c : false;
        }
        get isDemoFilterOn() {
            var _b, _c;
            return (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.isDemoFilterOn) !== null && _c !== void 0 ? _c : false;
        }
        get onlyAdminsAddReports() {
            var _b, _c, _d;
            return (_d = (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.onOff) === null || _c === void 0 ? void 0 : _c.onlyAdminsAddReports) !== null && _d !== void 0 ? _d : false;
        }
        get showBetaFeatures() {
            var _b, _c, _d;
            return (_d = (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.onOff) === null || _c === void 0 ? void 0 : _c.showBetaFeatures) !== null && _d !== void 0 ? _d : false;
        }
        get showAggregateScores() {
            var _b, _c, _d;
            return (_d = (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.onOff) === null || _c === void 0 ? void 0 : _c.showAggregateScores) !== null && _d !== void 0 ? _d : true;
        }
        get showSubIndustryInHeader() {
            var _b, _c, _d;
            return (_d = (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.onOff) === null || _c === void 0 ? void 0 : _c.showSubIndustryInHeader) !== null && _d !== void 0 ? _d : true;
        }
        get enableSourcing() {
            var _b, _c, _d;
            return (_d = (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.onOff) === null || _c === void 0 ? void 0 : _c.enableSourcing) !== null && _d !== void 0 ? _d : true;
        }
        get showWorkstreams() {
            var _b, _c, _d;
            return (_d = (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.onOff) === null || _c === void 0 ? void 0 : _c.showWorkstreams) !== null && _d !== void 0 ? _d : false;
        }
        get showPotentialCustomers() {
            var _b, _c, _d;
            return (_d = (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.onOff) === null || _c === void 0 ? void 0 : _c.showPotentialCustomers) !== null && _d !== void 0 ? _d : true;
        }
        get showOutputsTab() {
            var _b, _c, _d;
            return (_d = (_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.onOff) === null || _c === void 0 ? void 0 : _c.showOutputsTab) !== null && _d !== void 0 ? _d : true;
        }
        get industryTypes() {
            var _b, _c;
            if (!((_b = this.settings) === null || _b === void 0 ? void 0 : _b.industry_types_override)) return 0, (/*@__PURE__*/$parcel$interopDefault($80541c05916033ee$exports));
            return (_c = this.settings) === null || _c === void 0 ? void 0 : _c.industry_types_override;
        }
        constructor(){
            _ClientSettingsStore_settings_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _instanceExtraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _settings_initializers, null)));
            $8f024b03d9af7c67$var$__runInitializers(this, _settings_extraInitializers);
        }
    }, _ClientSettingsStore_settings_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _settings_decorators = [
            (0, $T5IcR.observable)
        ];
        _get_filterCompaniesForDemo_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_isMaintenanceOn_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_isDemoFilterOn_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_onlyAdminsAddReports_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_showBetaFeatures_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_showAggregateScores_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_showSubIndustryInHeader_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_enableSourcing_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_showWorkstreams_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_showPotentialCustomers_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_showOutputsTab_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_industryTypes_decorators = [
            (0, $T5IcR.computed)
        ];
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _settings_decorators, {
            kind: "accessor",
            name: "settings",
            static: false,
            private: false,
            access: {
                has: (obj)=>"settings" in obj,
                get: (obj)=>obj.settings,
                set: (obj, value)=>{
                    obj.settings = value;
                }
            },
            metadata: _metadata
        }, _settings_initializers, _settings_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_filterCompaniesForDemo_decorators, {
            kind: "getter",
            name: "filterCompaniesForDemo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filterCompaniesForDemo" in obj,
                get: (obj)=>obj.filterCompaniesForDemo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_isMaintenanceOn_decorators, {
            kind: "getter",
            name: "isMaintenanceOn",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isMaintenanceOn" in obj,
                get: (obj)=>obj.isMaintenanceOn
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_isDemoFilterOn_decorators, {
            kind: "getter",
            name: "isDemoFilterOn",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isDemoFilterOn" in obj,
                get: (obj)=>obj.isDemoFilterOn
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_onlyAdminsAddReports_decorators, {
            kind: "getter",
            name: "onlyAdminsAddReports",
            static: false,
            private: false,
            access: {
                has: (obj)=>"onlyAdminsAddReports" in obj,
                get: (obj)=>obj.onlyAdminsAddReports
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_showBetaFeatures_decorators, {
            kind: "getter",
            name: "showBetaFeatures",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showBetaFeatures" in obj,
                get: (obj)=>obj.showBetaFeatures
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_showAggregateScores_decorators, {
            kind: "getter",
            name: "showAggregateScores",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showAggregateScores" in obj,
                get: (obj)=>obj.showAggregateScores
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_showSubIndustryInHeader_decorators, {
            kind: "getter",
            name: "showSubIndustryInHeader",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showSubIndustryInHeader" in obj,
                get: (obj)=>obj.showSubIndustryInHeader
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_enableSourcing_decorators, {
            kind: "getter",
            name: "enableSourcing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"enableSourcing" in obj,
                get: (obj)=>obj.enableSourcing
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_showWorkstreams_decorators, {
            kind: "getter",
            name: "showWorkstreams",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showWorkstreams" in obj,
                get: (obj)=>obj.showWorkstreams
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_showPotentialCustomers_decorators, {
            kind: "getter",
            name: "showPotentialCustomers",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showPotentialCustomers" in obj,
                get: (obj)=>obj.showPotentialCustomers
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_showOutputsTab_decorators, {
            kind: "getter",
            name: "showOutputsTab",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showOutputsTab" in obj,
                get: (obj)=>obj.showOutputsTab
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_industryTypes_decorators, {
            kind: "getter",
            name: "industryTypes",
            static: false,
            private: false,
            access: {
                has: (obj)=>"industryTypes" in obj,
                get: (obj)=>obj.industryTypes
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
let $8f024b03d9af7c67$var$TasksStore = (()=>{
    var _a, _TasksStore_tasksDefinitions_accessor_storage;
    let _tasksDefinitions_decorators;
    let _tasksDefinitions_initializers = [];
    let _tasksDefinitions_extraInitializers = [];
    return _a = class TasksStore {
        get tasksDefinitions() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _TasksStore_tasksDefinitions_accessor_storage, "f");
        }
        set tasksDefinitions(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _TasksStore_tasksDefinitions_accessor_storage, value, "f");
        }
        get_task_definition(task_id) {
            return this.tasksDefinitions[task_id];
        }
        constructor(){
            _TasksStore_tasksDefinitions_accessor_storage.set(this, $8f024b03d9af7c67$var$__runInitializers(this, _tasksDefinitions_initializers, {}));
            $8f024b03d9af7c67$var$__runInitializers(this, _tasksDefinitions_extraInitializers);
        }
    }, _TasksStore_tasksDefinitions_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _tasksDefinitions_decorators = [
            (0, $T5IcR.observable)
        ];
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _tasksDefinitions_decorators, {
            kind: "accessor",
            name: "tasksDefinitions",
            static: false,
            private: false,
            access: {
                has: (obj)=>"tasksDefinitions" in obj,
                get: (obj)=>obj.tasksDefinitions,
                set: (obj, value)=>{
                    obj.tasksDefinitions = value;
                }
            },
            metadata: _metadata
        }, _tasksDefinitions_initializers, _tasksDefinitions_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $8f024b03d9af7c67$var$store = new $8f024b03d9af7c67$var$Store();
const $8f024b03d9af7c67$var$storeUI = new $8f024b03d9af7c67$export$5a825fdb72e99846();
const $8f024b03d9af7c67$var$tasksStore = new $8f024b03d9af7c67$var$TasksStore();
const $8f024b03d9af7c67$var$clientSettingStore = new $8f024b03d9af7c67$var$ClientSettingsStore();
const $8f024b03d9af7c67$export$6ccbb43953eebf8 = ()=>$8f024b03d9af7c67$var$store;
const $8f024b03d9af7c67$export$d842a17955610ca9 = ()=>$8f024b03d9af7c67$var$storeUI;
const $8f024b03d9af7c67$export$30eb9424ed49720f = ()=>$8f024b03d9af7c67$var$clientSettingStore;
const $8f024b03d9af7c67$export$c2ad39067c031726 = ()=>$8f024b03d9af7c67$var$tasksStore;



var $b2432f43c421c848$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $b2432f43c421c848$var$PATH_DB_SERVICE_FILES = '/Service_Files';
const $b2432f43c421c848$var$PATH_DB_KNOWLEDGE_FILES = '/Knowledge_Files';
const $b2432f43c421c848$var$PATH_DB_JOBS = '/jobs';
const $b2432f43c421c848$var$PATH_CIM_RESULTS = '/cim_results';
const $b2432f43c421c848$var$PATH_REPORT_RUNS = '/report_runs/insight_report_with_cim';
const $b2432f43c421c848$var$PATH_CIM_RESULTS_OVERRIDES = '/cim_results_overrides';
const $b2432f43c421c848$var$PATH_SETTINGS = '/settings';
const $b2432f43c421c848$var$PATH_SCORE_OVERRIDE = '/score_override';
//RAG
const $b2432f43c421c848$var$PATH_RAG = '/Service_RAG';
const $b2432f43c421c848$var$PATH_CHAT = '/Service_Chat';
//Flow Tasks
const $b2432f43c421c848$var$PATH_FLOWTASK_JOBS = '/flowtasks/jobs';
const $b2432f43c421c848$var$PATH_FLOWTASK_ACTIVE_JOB = '/flowtasks/active_job';
const $b2432f43c421c848$var$PATH_FLOWTASK_TASK_STATE = '/flowtasks/task_state';
const $b2432f43c421c848$var$PATH_FLOWTASK_VARS_EXIST_TABLE = '/flowtasks/vars_exist_table';
const $b2432f43c421c848$var$PATH_RAG_REMOTE_ACTION = 'Service_RAG_RemoteAction';
const $b2432f43c421c848$var$PATH_ACTIVE_JOB = '/activeJob';
const $b2432f43c421c848$var$PATH_USERS = '/users';
const $b2432f43c421c848$var$PATH_FIRM_INFO = '/firm_info';
const $b2432f43c421c848$var$PATH_REPORT_DEFINITIONS = '/report_definition';
const $b2432f43c421c848$var$PATH_DB_TASK_DEFINITIONS = '/flowtasks/defs';
function $b2432f43c421c848$export$ce5cbb93a219e469(name) {
    const validChars = new Set('-_()ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
    return [
        ...name
    ].filter((c)=>validChars.has(c)).join('');
}
function $b2432f43c421c848$var$dbBuildProjectFilePath(reportId, fileName) {
    const noExt = fileName.replace(/\.[^/.]+$/, '');
    const entryName = $b2432f43c421c848$export$ce5cbb93a219e469(noExt).replace('_unlocked', '');
    return `${$b2432f43c421c848$var$PATH_DB_SERVICE_FILES}/${reportId}/files/${entryName}`;
}
function $b2432f43c421c848$export$5a1443b88cb7b0d4(fileStoragePath) {
    const noExt = fileStoragePath.replace(/\.[^/.]+$/, '');
    var path = noExt.replace('knowledge_', ''); //Only at start of string
    return $b2432f43c421c848$export$ce5cbb93a219e469(path.replaceAll('/', '__'));
}
function $b2432f43c421c848$export$7dd9cfe78b77dd41(fileStoragePath) {
    const entryName = $b2432f43c421c848$export$5a1443b88cb7b0d4(fileStoragePath);
    return `${$b2432f43c421c848$var$PATH_DB_KNOWLEDGE_FILES}/${entryName}`;
}
class $b2432f43c421c848$var$FirebaseAdapater {
    constructor(){
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "db", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "authInitialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "navigationCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    getConfig() {
        return (0, $3d79bba9fc178656$export$b3611e87cd5ba6ce)().firebase;
    }
    setNavigationCallback(callback) {
        this.navigationCallback = callback;
    }
    navigateToPath(path) {
        if (this.navigationCallback) this.navigationCallback(path);
        else // Fallback to location.href if no navigation callback is set
        location.href = path;
    }
    init() {
        const firebaseConfig = this.getConfig();
        console.log('Initializing Firebase');
        console.log(firebaseConfig);
        console.log('Is Developer: ', (0, $8f024b03d9af7c67$export$d842a17955610ca9)().isDev);
        this.app = (0, $20ed53392b3edc61$export$c55cfd413944906d)(firebaseConfig);
        this.db = (0, $e0be213f695400f3$export$d0dd861204d0bf72)(this.app);
        var auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)(this.app);
        (0, $402d0a489f4b5d89$export$4a5767248b18ef41)(auth, (user)=>{
            this.authInitialized = true;
            if (user) {
                console.log('Logged in!');
                this.userId = user.uid;
                this.user = user;
                const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                store.userId = user.uid;
                $d0ea6cfcc1ddd989$export$8b6bb3dd62a01be2({
                    id: user.uid,
                    username: user.email,
                    email: user.email
                });
                //TODO: Clean this up a bit
                this.store_audit_entry('APP_LOAD');
                var r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_CIM_RESULTS);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.resetDataAccessCache();
                    store.reportDataDB = val || {};
                });
                var r_flowtask_states = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_FLOWTASK_TASK_STATE);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_flowtask_states, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.flowTaskState = val || {};
                });
                var r_flowtask_vars_exist_table = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_FLOWTASK_VARS_EXIST_TABLE);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_flowtask_vars_exist_table, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.flowTaskVarsExistTable = val || {};
                });
                var r_knowledgeFiles = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_DB_KNOWLEDGE_FILES);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_knowledgeFiles, (data)=>{
                    const val = data.val();
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    for(var fileEntryKey in val)val[fileEntryKey].saveKey = fileEntryKey;
                    store.knowledgeFilesDB = val || {};
                    store.areKnowledgeFilesLoaded = true;
                });
                var r_task_definitions = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_DB_TASK_DEFINITIONS);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_task_definitions, (data)=>{
                    const val = data.val();
                    const taskStore = (0, $8f024b03d9af7c67$export$c2ad39067c031726)();
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    for(var fileEntryKey in val)val[fileEntryKey].saveKey = fileEntryKey;
                    taskStore.tasksDefinitions = val || {};
                    store.areTaskDefinitionsLoaded = true;
                });
                var r_overrides = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_CIM_RESULTS_OVERRIDES);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_overrides, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.resetDataAccessCache();
                    store.reportDataOverridesDB = val || {};
                    store.areOveridesLoaded = true;
                });
                var r_firminfo = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_FIRM_INFO);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_firminfo, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.firmInfo = val || {};
                });
                var r_report_defs = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_REPORT_DEFINITIONS);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_report_defs, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.reportDefinitions = val || {};
                });
                var r_project_files = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_DB_SERVICE_FILES);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_project_files, (data)=>{
                    const val = data.val();
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    for(var reportId in val){
                        const files = val[reportId].files;
                        if (files) for(var key in files)files[key].saveKey = key;
                    }
                    store.allProjectFiles = val || {};
                });
                var r_rag = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_RAG);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_rag, (data)=>{
                    var val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    // for (var key in val) {
                    //     val[key]['originalDocId'] = key;
                    // }
                    store.ragDB = val || {};
                    store.isRagDbLoaded = true;
                });
                var r_settings = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_SETTINGS);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_settings, (data)=>{
                    const val = data.val();
                    const clientStore = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.areSettingsLoaded = true;
                    clientStore.settings = val || {};
                });
                var r_scoreoverride = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_SCORE_OVERRIDE);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_scoreoverride, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const ruleStore = (0, $9b879bbdd76f7296$export$5bbef306d29b8236)();
                    ruleStore.update_rules(val || {});
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.areScoreRulesLoaded = true;
                });
                var r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_DB_JOBS);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r, (data)=>{
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.jobs = data.val();
                });
                var r_task_activejob = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_FLOWTASK_ACTIVE_JOB);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_task_activejob, (data)=>{
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.taskActiveJob = data.val();
                });
                $b2432f43c421c848$var$PATH_FLOWTASK_JOBS;
                var chatsRef = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_CHAT);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(chatsRef, (data)=>{
                    var _a;
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.chatData = (_a = data.val()) !== null && _a !== void 0 ? _a : {};
                    store.isChatLoaded = true;
                });
                var activeJobs = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_ACTIVE_JOB);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(activeJobs, (data)=>{
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.activeJob = data.val();
                });
                var users = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_USERS);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(users, (data)=>{
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.users = data.val();
                });
                // Setup user comparables listener
                const userComparablesRef = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `user_compare/${this.userId}`);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(userComparablesRef, (data)=>{
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.allUserComparables = data.val() || {};
                });
            // var onlineStatus = ref(this.db, '/system_status');
            // onValue(onlineStatus, data => {
            //     store.systemStatus = data.val();
            // });
            } else if (location.href.indexOf('login') < 0) {
                // Add small retry mechanism for auth state changes after deploys
                let retryCount = 0;
                const maxRetries = 3;
                const retryDelay = 1000; // 1 second
                const attemptRedirect = ()=>{
                    retryCount++;
                    if (this.authInitialized || retryCount >= maxRetries) this.navigateToPath('/login');
                    else setTimeout(attemptRedirect, retryDelay);
                };
                attemptRedirect();
            }
        });
    }
    deleteReport(reportId) {
        this.store_audit_entry('DELETE_DEAL', {
            reportId: reportId
        });
        var r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `${$b2432f43c421c848$var$PATH_CIM_RESULTS}/${reportId}`);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
    }
    store_override(reportId, overidePath, value) {
        const path = `${$b2432f43c421c848$var$PATH_CIM_RESULTS_OVERRIDES}/${reportId}/${overidePath}`;
        const switchDot = path.replace('.', '___');
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, switchDot);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, value);
        const request_redo_summary = `${$b2432f43c421c848$var$PATH_DB_SERVICE_FILES}/${reportId}/should_redo_summary`;
        const r2 = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, request_redo_summary);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r2, true);
        this.triggerScanRagFiles();
        this.store_audit_entry('EDIT_FIELD', {
            reportId: reportId,
            field: overidePath,
            value: value
        });
        // Update reference data snapshot if this deal has reference data
        this.update_reference_snapshot_if_exists(reportId);
    }
    remove_override(reportId, overidePath) {
        const path = `${$b2432f43c421c848$var$PATH_CIM_RESULTS_OVERRIDES}/${reportId}/${overidePath}`;
        const switchDot = path.replace('.', '___');
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, switchDot);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
        this.store_audit_entry('EDIT_FIELD', {
            reportId: reportId,
            field: overidePath,
            value: 'DELETED'
        });
        // Update reference data snapshot if this deal has reference data
        this.update_reference_snapshot_if_exists(reportId);
    }
    update_reference_snapshot_if_exists(dealId) {
        return $b2432f43c421c848$var$__awaiter(this, void 0, void 0, function*() {
            try {
                // Check if this deal has reference data
                const referenceRef = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `cim_results_reference/${dealId}`);
                const referenceSnapshot = yield (0, $e0be213f695400f3$export$3988ae62b71be9a3)(referenceRef);
                if (!referenceSnapshot.exists()) // No reference data for this deal, nothing to update
                return;
                const referenceData = referenceSnapshot.val();
                if (!referenceData.data || typeof referenceData.data !== 'object') {
                    console.warn('Reference data exists but has unexpected format');
                    return;
                }
                console.log(`Updating reference snapshot for deal ${dealId} due to override change`);
                // Get the current store
                const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                // Get current deal data with updated overrides
                const currentDealData = store.reportDataDB[dealId];
                const overrides = store.reportDataOverridesDB[dealId] || {};
                if (!currentDealData) {
                    console.warn(`No deal data found for dealId: ${dealId}`);
                    return;
                }
                // Create DataAccessUtils to get the current values with overrides
                const dataAccess = new (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)(currentDealData, overrides, dealId);
                // Update only the fields that are in the reference data
                const updatedSnapshot = {};
                const referenceFields = Object.keys(referenceData.data);
                referenceFields.forEach((fieldName)=>{
                    try {
                        // Get the current value with overrides applied
                        const fieldValue = dataAccess.value(fieldName);
                        updatedSnapshot[fieldName] = fieldValue;
                    } catch (error) {
                        console.warn(`Could not get updated value for field ${fieldName}:`, error);
                        // Keep the old value if we can't get the new one
                        updatedSnapshot[fieldName] = referenceData.data[fieldName];
                    }
                });
                // Update the reference data with new snapshot
                const updatedReferenceData = Object.assign(Object.assign({}, referenceData), {
                    data: updatedSnapshot,
                    metadata: Object.assign(Object.assign({}, referenceData.metadata), {
                        last_modified: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)(),
                        auto_updated_due_to_override: true
                    })
                });
                // Save the updated reference data
                yield (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(referenceRef, updatedReferenceData);
                console.log(`Successfully updated reference snapshot for deal ${dealId}`);
            } catch (error) {
                console.error(`Error updating reference snapshot for deal ${dealId}:`, error);
            }
        });
    }
    store_audit_entry(type, extraData = {}) {
        if (!this.userId) {
            setTimeout(()=>{
                this.store_audit_entry(type, extraData);
            }, 1000);
            return;
        }
        const userId = this.userId;
        const userEmail = this.user.email;
        const path = `audit_log`;
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
        (0, $e0be213f695400f3$export$4cbf152802aa238)(r, {
            type: type,
            userId: userId,
            userEmail: userEmail,
            extraData: extraData,
            date: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)()
        });
    }
    addDummyProjectFile(reportId, fileName) {
        const path = $b2432f43c421c848$var$dbBuildProjectFilePath(reportId, fileName);
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
        (0, $e0be213f695400f3$export$722fbec263ad908a)(r, {
            filename: fileName
        });
    }
    deleteKnowledgeFileDbEntry(fileStoragePath) {
        const path = $b2432f43c421c848$export$7dd9cfe78b77dd41(fileStoragePath);
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
    }
    setKnowledgeFileTags(fileStoragePath, tags) {
        const path = $b2432f43c421c848$export$7dd9cfe78b77dd41(fileStoragePath);
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
        (0, $e0be213f695400f3$export$722fbec263ad908a)(r, {
            tags: tags
        });
    }
    deleteProjectFile(reportId, filename) {
        const path = $b2432f43c421c848$var$dbBuildProjectFilePath(reportId, filename);
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
    }
    triggerScanRagFiles() {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_RAG_REMOTE_ACTION);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, {
            action: 'import',
            started: false,
            timestamp: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)()
        });
    }
    triggerKnowledgeFilesImport() {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_RAG_REMOTE_ACTION);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, {
            action: 'import_knowledge',
            started: false
        });
    }
    clearJobQueue() {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, '/jobs');
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
    }
    setJobStatus(jobId, status) {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `${$b2432f43c421c848$var$PATH_DB_JOBS}/${jobId}`);
        (0, $e0be213f695400f3$export$722fbec263ad908a)(r, {
            status: status
        });
    }
    add_research_job(researchName, companyName, industry, website, reportId = '', debugSpecificSteps = null, runPostProcessing = true, createNewReport = true) {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_DB_JOBS);
        const data = {
            fileName: researchName,
            user: (0, $402d0a489f4b5d89$export$ae1af26003f05816)().currentUser.email,
            userId: (0, $402d0a489f4b5d89$export$ae1af26003f05816)().currentUser.uid,
            priority: 0,
            status: 'pending',
            jobType: 'process_research',
            createdAt: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)(),
            companyName: companyName,
            industry: industry,
            website: website,
            debug: {
                specificSteps: debugSpecificSteps,
                reportId: reportId,
                runPostProcessing: runPostProcessing,
                createNewReport: createNewReport
            }
        };
        (0, $e0be213f695400f3$export$4cbf152802aa238)(r, data);
    }
    save_flowise_variable(reportId, varName, value) {
        const path = `flowise_vars/${reportId}/${varName}`;
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, value);
    }
    get_all_flowise_vars(reportId) {
        return $b2432f43c421c848$var$__awaiter(this, void 0, void 0, function*() {
            const path = `flowise_vars/${reportId}`;
            const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
            return (yield (0, $e0be213f695400f3$export$3988ae62b71be9a3)(r)).val() || {};
        });
    }
    add_job(fileName, password, originalJobId, clearCache, priority) {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_DB_JOBS);
        const data = {
            fileName: fileName,
            user: (0, $402d0a489f4b5d89$export$ae1af26003f05816)().currentUser.email,
            userId: (0, $402d0a489f4b5d89$export$ae1af26003f05816)().currentUser.uid,
            priority: priority || 0,
            status: 'pending',
            jobType: 'process_cim',
            createdAt: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)()
        };
        if (password) data['pdfPassword'] = password;
        if (originalJobId) data['originalJobId'] = originalJobId;
        if (clearCache) data['clearCache'] = true;
        (0, $e0be213f695400f3$export$4cbf152802aa238)(r, data);
    }
    chatbot_add_message(reportId, message, isMe) {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `${$b2432f43c421c848$var$PATH_CHAT}/${reportId}`);
        (0, $e0be213f695400f3$export$4cbf152802aa238)(r, {
            message: message,
            isMe: isMe,
            processed: false,
            date: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)()
        });
    }
    flowtask_state_set_queued(reportId, taskId, last_message_for_ui) {
        const path = `${$b2432f43c421c848$var$PATH_FLOWTASK_TASK_STATE}/${reportId}/${taskId}`;
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
        (0, $e0be213f695400f3$export$722fbec263ad908a)(r, {
            last_message_for_ui: last_message_for_ui,
            status: 'queued',
            updatedAt: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)(),
            updatedBy: 'frontend'
        });
    }
    flowtask_add_prompt_job(reportId, taskId, message) {
        if (message.content == null || message.content.trim() == '') message.content = '-';
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `${$b2432f43c421c848$var$PATH_FLOWTASK_JOBS}/`);
        (0, $e0be213f695400f3$export$4cbf152802aa238)(r, {
            reportId: reportId,
            taskId: taskId,
            message: message,
            status: 'queued',
            type: 'prompt',
            createdAt: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)()
        });
        this.flowtask_state_set_queued(reportId, taskId, message);
    }
    flowtask_add_clear_job(reportId, taskId) {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `${$b2432f43c421c848$var$PATH_FLOWTASK_JOBS}/`);
        (0, $e0be213f695400f3$export$4cbf152802aa238)(r, {
            reportId: reportId,
            taskId: taskId,
            status: 'queued',
            type: 'clear',
            createdAt: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)()
        });
        this.flowtask_state_set_queued(reportId, taskId, {
            content: 'Clearing task state...'
        });
    }
    clear_chat(reportId) {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `${$b2432f43c421c848$var$PATH_CHAT}/${reportId}`);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
        const r2 = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `R2R_Company_To_Conversation_Id/${reportId}`);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r2, null);
    }
    save_reference_data(dealId, selectedFields) {
        // Get fields that should be saved as reference
        const fieldsToSave = Object.keys(selectedFields).filter((field)=>selectedFields[field]);
        if (fieldsToSave.length === 0) {
            console.log('No fields selected to save');
            return {
                success: false,
                message: 'No fields selected to save'
            };
        }
        try {
            console.log(`Saving ${fieldsToSave.length} fields as reference data for deal: ${dealId}`);
            // Get the current store
            const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
            // Get current deal data with overrides
            const currentDealData = store.reportDataDB[dealId];
            const overrides = store.reportDataOverridesDB[dealId] || {};
            if (!currentDealData) {
                console.error('No deal data found for dealId:', dealId);
                return {
                    success: false,
                    message: 'No deal data found for this deal'
                };
            }
            // Create DataAccessUtils to get the current values
            const dataAccess = new (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)(currentDealData, overrides, dealId);
            // Create snapshot of actual data values for selected fields
            const dataSnapshot = {};
            fieldsToSave.forEach((fieldName)=>{
                try {
                    // Get the current value using DataAccessUtils
                    const fieldValue = dataAccess.value(fieldName);
                    dataSnapshot[fieldName] = fieldValue;
                } catch (error) {
                    console.warn(`Could not get value for field ${fieldName}:`, error);
                    dataSnapshot[fieldName] = null;
                }
            });
            // Save snapshot structure with actual data values
            const referenceData = {
                data: dataSnapshot,
                metadata: {
                    saved_at: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)(),
                    saved_by: this.userId,
                    saved_by_email: this.user.email,
                    backend_version: 'unknown',
                    last_modified: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)(),
                    field_count: fieldsToSave.length
                }
            };
            // Save to Firebase
            const path = `cim_results_reference/${dealId}`;
            const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
            (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, referenceData);
            // Log audit entry
            this.store_audit_entry('SAVE_REFERENCE_DATA', {
                dealId: dealId,
                fieldCount: fieldsToSave.length,
                fields: fieldsToSave
            });
            // Return success message for UI feedback
            return {
                success: true,
                message: `Saved ${fieldsToSave.length} fields as reference data for testing.`
            };
        } catch (error) {
            console.error('Error saving reference data:', error);
            return {
                success: false,
                message: `Error saving reference data: ${error.message}`
            };
        }
    }
    has_reference_data(dealId) {
        return $b2432f43c421c848$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            try {
                const referenceRef = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `cim_results_reference/${dealId}`);
                const snapshot = yield (0, $e0be213f695400f3$export$3988ae62b71be9a3)(referenceRef);
                return snapshot.exists() && ((_a = snapshot.val()) === null || _a === void 0 ? void 0 : _a.data);
            } catch (error) {
                console.error(`Error checking reference data for deal ${dealId}:`, error);
                return false;
            }
        });
    }
    get_existing_reference_data(dealId) {
        return new Promise((resolve, reject)=>{
            if (!dealId) {
                console.log('No dealId provided to get_existing_reference_data');
                resolve(null);
                return;
            }
            console.log(`Getting reference data for deal: ${dealId}`);
            const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `cim_results_reference/${dealId}`);
            (0, $e0be213f695400f3$export$3988ae62b71be9a3)(r).then((snapshot)=>{
                if (snapshot.exists()) {
                    console.log('Found existing reference data');
                    const data = snapshot.val();
                    // Check if we have the data snapshot structure
                    if (data.data && typeof data.data === 'object') {
                        // Transform the data object into field selections for the UI
                        const fieldSelections = {};
                        Object.keys(data.data).forEach((fieldName)=>{
                            fieldSelections[fieldName] = true;
                        });
                        // Return the properly formatted object for SelectionStore
                        resolve({
                            data: fieldSelections,
                            metadata: data.metadata || {}
                        });
                    } else {
                        console.warn('Reference data exists but has unexpected format:', data);
                        resolve({
                            data: {},
                            metadata: data.metadata || {}
                        });
                    }
                } else {
                    console.log('No existing reference data found');
                    resolve(null);
                }
            }).catch((error)=>{
                console.error('Error getting reference data:', error);
                reject(error);
            });
        });
    }
    saveUserComparables(userId, dealId, comparables) {
        return $b2432f43c421c848$var$__awaiter(this, void 0, void 0, function*() {
            if (!userId || !dealId) {
                console.warn('Cannot save comparables: missing dealId or userId');
                return false;
            }
            try {
                const comparablesRef = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `user_compare/${userId}/${dealId}`);
                yield (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(comparablesRef, {
                    comparables: comparables,
                    lastUpdated: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)()
                });
                return true;
            } catch (error) {
                console.error('Error saving user comparables:', error);
                return false;
            }
        });
    }
}
const $b2432f43c421c848$var$mFirebaseService = new $b2432f43c421c848$var$FirebaseAdapater();
function $b2432f43c421c848$export$7a667d08ed65fa47() {
    return $b2432f43c421c848$var$mFirebaseService;
}



var $kSbwP = parcelRequire("kSbwP");

var $kSbwP = parcelRequire("kSbwP");



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");
"use client";
function $8f0b3b9abdff19ee$var$Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
$8f0b3b9abdff19ee$var$Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var $8f0b3b9abdff19ee$var$L = (t)=>typeof t == "number" && !isNaN(t), $8f0b3b9abdff19ee$var$N = (t)=>typeof t == "string", $8f0b3b9abdff19ee$var$P = (t)=>typeof t == "function", $8f0b3b9abdff19ee$var$mt = (t)=>$8f0b3b9abdff19ee$var$N(t) || $8f0b3b9abdff19ee$var$L(t), $8f0b3b9abdff19ee$var$B = (t)=>$8f0b3b9abdff19ee$var$N(t) || $8f0b3b9abdff19ee$var$P(t) ? t : null, $8f0b3b9abdff19ee$var$pt = (t, o)=>t === !1 || $8f0b3b9abdff19ee$var$L(t) && t > 0 ? t : o, $8f0b3b9abdff19ee$var$z = (t)=>(0, $8nGP5.isValidElement)(t) || $8f0b3b9abdff19ee$var$N(t) || $8f0b3b9abdff19ee$var$P(t) || $8f0b3b9abdff19ee$var$L(t);
function $8f0b3b9abdff19ee$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $8f0b3b9abdff19ee$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, $8nGP5.useRef)(0);
        return (0, $8nGP5.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, $8nGP5.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? $8f0b3b9abdff19ee$export$184cca501f1aed7f(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, null, a);
    };
}
function $8f0b3b9abdff19ee$var$J(t, o) {
    return {
        content: $8f0b3b9abdff19ee$var$tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $8f0b3b9abdff19ee$var$tt(t, o, e = !1) {
    return (0, $8nGP5.isValidElement)(t) && !$8f0b3b9abdff19ee$var$N(t.type) ? (0, $8nGP5.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $8f0b3b9abdff19ee$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $8f0b3b9abdff19ee$var$yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $8f0b3b9abdff19ee$var$gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, $ajIhI.default)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $8f0b3b9abdff19ee$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $ajIhI.default)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var $8f0b3b9abdff19ee$var$Xt = 1, $8f0b3b9abdff19ee$var$at = ()=>`${$8f0b3b9abdff19ee$var$Xt++}`;
function $8f0b3b9abdff19ee$var$_t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($8f0b3b9abdff19ee$var$J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([D, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $8f0b3b9abdff19ee$var$B(n.className || d.toastClassName),
                progressClassName: $8f0b3b9abdff19ee$var$B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : $8f0b3b9abdff19ee$var$pt(n.autoClose, d.autoClose),
                closeToast (D) {
                    c.get(u).removalReason = D, E(u);
                },
                deleteToast () {
                    let D = c.get(u);
                    if (D != null) {
                        if (e($8f0b3b9abdff19ee$var$J(D, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || $8f0b3b9abdff19ee$var$z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $8f0b3b9abdff19ee$var$z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : $8f0b3b9abdff19ee$var$L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var $8f0b3b9abdff19ee$var$I = new Map, $8f0b3b9abdff19ee$var$F = [], $8f0b3b9abdff19ee$var$st = new Set, $8f0b3b9abdff19ee$var$Vt = (t)=>$8f0b3b9abdff19ee$var$st.forEach((o)=>o(t)), $8f0b3b9abdff19ee$var$bt = ()=>$8f0b3b9abdff19ee$var$I.size > 0;
function $8f0b3b9abdff19ee$var$Qt() {
    $8f0b3b9abdff19ee$var$F.forEach((t)=>$8f0b3b9abdff19ee$var$nt(t.content, t.options)), $8f0b3b9abdff19ee$var$F = [];
}
var $8f0b3b9abdff19ee$var$vt = (t, { containerId: o })=>{
    var e;
    return (e = $8f0b3b9abdff19ee$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $8f0b3b9abdff19ee$var$X(t, o) {
    var r;
    if (o) return !!((r = $8f0b3b9abdff19ee$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $8f0b3b9abdff19ee$var$I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function $8f0b3b9abdff19ee$var$ht(t) {
    if (!$8f0b3b9abdff19ee$var$bt()) {
        $8f0b3b9abdff19ee$var$F = $8f0b3b9abdff19ee$var$F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $8f0b3b9abdff19ee$var$mt(t)) $8f0b3b9abdff19ee$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $8f0b3b9abdff19ee$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $8f0b3b9abdff19ee$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $8f0b3b9abdff19ee$var$Ct = (t = {})=>{
    $8f0b3b9abdff19ee$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $8f0b3b9abdff19ee$var$nt(t, o) {
    $8f0b3b9abdff19ee$var$z(t) && ($8f0b3b9abdff19ee$var$bt() || $8f0b3b9abdff19ee$var$F.push({
        content: t,
        options: o
    }), $8f0b3b9abdff19ee$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $8f0b3b9abdff19ee$var$xt(t) {
    var o;
    (o = $8f0b3b9abdff19ee$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $8f0b3b9abdff19ee$var$rt(t, o) {
    $8f0b3b9abdff19ee$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $8f0b3b9abdff19ee$var$Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $8f0b3b9abdff19ee$var$_t(o, t, $8f0b3b9abdff19ee$var$Vt);
            $8f0b3b9abdff19ee$var$I.set(o, r);
            let s = r.observe(e);
            return $8f0b3b9abdff19ee$var$Qt(), ()=>{
                s(), $8f0b3b9abdff19ee$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $8f0b3b9abdff19ee$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $8f0b3b9abdff19ee$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $8f0b3b9abdff19ee$var$Pt(t) {
    return $8f0b3b9abdff19ee$var$st.add(t), ()=>{
        $8f0b3b9abdff19ee$var$st.delete(t);
    };
}
function $8f0b3b9abdff19ee$var$Wt(t) {
    return t && ($8f0b3b9abdff19ee$var$N(t.toastId) || $8f0b3b9abdff19ee$var$L(t.toastId)) ? t.toastId : $8f0b3b9abdff19ee$var$at();
}
function $8f0b3b9abdff19ee$var$U(t, o) {
    return $8f0b3b9abdff19ee$var$nt(t, o), o.toastId;
}
function $8f0b3b9abdff19ee$var$V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $8f0b3b9abdff19ee$var$Wt(o)
    };
}
function $8f0b3b9abdff19ee$var$Q(t) {
    return (o, e)=>$8f0b3b9abdff19ee$var$U(o, $8f0b3b9abdff19ee$var$V(t, e));
}
function $8f0b3b9abdff19ee$export$b410431fab84fa58(t, o) {
    return $8f0b3b9abdff19ee$var$U(t, $8f0b3b9abdff19ee$var$V("default", o));
}
$8f0b3b9abdff19ee$export$b410431fab84fa58.loading = (t, o)=>$8f0b3b9abdff19ee$var$U(t, $8f0b3b9abdff19ee$var$V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $8f0b3b9abdff19ee$var$Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = $8f0b3b9abdff19ee$var$N(o) ? $8f0b3b9abdff19ee$export$b410431fab84fa58.loading(o, s) : $8f0b3b9abdff19ee$export$b410431fab84fa58.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            $8f0b3b9abdff19ee$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = $8f0b3b9abdff19ee$var$N(g) ? {
            render: g
        } : g;
        return l ? $8f0b3b9abdff19ee$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $8f0b3b9abdff19ee$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $8f0b3b9abdff19ee$var$P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
$8f0b3b9abdff19ee$export$b410431fab84fa58.promise = $8f0b3b9abdff19ee$var$Gt;
$8f0b3b9abdff19ee$export$b410431fab84fa58.success = $8f0b3b9abdff19ee$var$Q("success");
$8f0b3b9abdff19ee$export$b410431fab84fa58.info = $8f0b3b9abdff19ee$var$Q("info");
$8f0b3b9abdff19ee$export$b410431fab84fa58.error = $8f0b3b9abdff19ee$var$Q("error");
$8f0b3b9abdff19ee$export$b410431fab84fa58.warning = $8f0b3b9abdff19ee$var$Q("warning");
$8f0b3b9abdff19ee$export$b410431fab84fa58.warn = $8f0b3b9abdff19ee$export$b410431fab84fa58.warning;
$8f0b3b9abdff19ee$export$b410431fab84fa58.dark = (t, o)=>$8f0b3b9abdff19ee$var$U(t, $8f0b3b9abdff19ee$var$V("default", {
        theme: "dark",
        ...o
    }));
function $8f0b3b9abdff19ee$var$qt(t) {
    $8f0b3b9abdff19ee$var$ht(t);
}
$8f0b3b9abdff19ee$export$b410431fab84fa58.dismiss = $8f0b3b9abdff19ee$var$qt;
$8f0b3b9abdff19ee$export$b410431fab84fa58.clearWaitingQueue = $8f0b3b9abdff19ee$var$Ct;
$8f0b3b9abdff19ee$export$b410431fab84fa58.isActive = $8f0b3b9abdff19ee$var$X;
$8f0b3b9abdff19ee$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $8f0b3b9abdff19ee$var$vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $8f0b3b9abdff19ee$var$at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, $8f0b3b9abdff19ee$var$U(a, l);
    }
};
$8f0b3b9abdff19ee$export$b410431fab84fa58.done = (t)=>{
    $8f0b3b9abdff19ee$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$8f0b3b9abdff19ee$export$b410431fab84fa58.onChange = $8f0b3b9abdff19ee$var$Pt;
$8f0b3b9abdff19ee$export$b410431fab84fa58.play = (t)=>$8f0b3b9abdff19ee$var$rt(!0, t);
$8f0b3b9abdff19ee$export$b410431fab84fa58.pause = (t)=>$8f0b3b9abdff19ee$var$rt(!1, t);
function $8f0b3b9abdff19ee$var$It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $8nGP5.useRef)($8f0b3b9abdff19ee$var$Et(t)).current;
    r(t);
    let s = (a = (0, $8nGP5.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $8f0b3b9abdff19ee$var$X,
        count: s == null ? void 0 : s.length
    };
}
function $8f0b3b9abdff19ee$var$At(t) {
    let [o, e] = (0, $8nGP5.useState)(!1), [r, s] = (0, $8nGP5.useState)(!1), l = (0, $8nGP5.useRef)(null), a = (0, $8nGP5.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $8f0b3b9abdff19ee$var$xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $8nGP5.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $8f0b3b9abdff19ee$var$Ot = typeof window != "undefined" ? (0, $8nGP5.useLayoutEffect) : (0, $8nGP5.useEffect);
var $8f0b3b9abdff19ee$var$G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $8f0b3b9abdff19ee$var$ao(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($8f0b3b9abdff19ee$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $8f0b3b9abdff19ee$var$so(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($8f0b3b9abdff19ee$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $8f0b3b9abdff19ee$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($8f0b3b9abdff19ee$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $8f0b3b9abdff19ee$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($8f0b3b9abdff19ee$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $8f0b3b9abdff19ee$var$io() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $8f0b3b9abdff19ee$export$4f13f83fd8bb1dac = {
    info: $8f0b3b9abdff19ee$var$so,
    warning: $8f0b3b9abdff19ee$var$ao,
    success: $8f0b3b9abdff19ee$var$no,
    error: $8f0b3b9abdff19ee$var$ro,
    spinner: $8f0b3b9abdff19ee$var$io
}, $8f0b3b9abdff19ee$var$lo = (t)=>t in $8f0b3b9abdff19ee$export$4f13f83fd8bb1dac;
function $8f0b3b9abdff19ee$var$Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($8f0b3b9abdff19ee$var$P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, $8nGP5.isValidElement)(r) ? s = (0, $8nGP5.cloneElement)(r, l) : e ? s = $8f0b3b9abdff19ee$export$4f13f83fd8bb1dac.spinner() : $8f0b3b9abdff19ee$var$lo(o) && (s = $8f0b3b9abdff19ee$export$4f13f83fd8bb1dac[o](l))), s;
}
var $8f0b3b9abdff19ee$var$wt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = $8f0b3b9abdff19ee$var$At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, D = (0, $ajIhI.default)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = $8f0b3b9abdff19ee$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: D
    }) : (0, $ajIhI.default)(D, E), ft = $8f0b3b9abdff19ee$var$Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || ($8f0b3b9abdff19ee$var$P(a) ? H = a(j) : (0, $8nGP5.isValidElement)(a) ? H = (0, $8nGP5.cloneElement)(a, j) : H = $8f0b3b9abdff19ee$var$yt(j)), (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: (0, $ajIhI.default)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), $8f0b3b9abdff19ee$var$tt(d, t, !o), H, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($8f0b3b9abdff19ee$var$gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var $8f0b3b9abdff19ee$var$K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $8f0b3b9abdff19ee$export$d20e79fdc3899e95 = $8f0b3b9abdff19ee$export$3ff7dc44d332d222($8f0b3b9abdff19ee$var$K("bounce", !0)), $8f0b3b9abdff19ee$export$d8dc01b5c85a37b9 = $8f0b3b9abdff19ee$export$3ff7dc44d332d222($8f0b3b9abdff19ee$var$K("slide", !0)), $8f0b3b9abdff19ee$export$65cfd44a2050f99 = $8f0b3b9abdff19ee$export$3ff7dc44d332d222($8f0b3b9abdff19ee$var$K("zoom")), $8f0b3b9abdff19ee$export$4d2fae537bd90431 = $8f0b3b9abdff19ee$export$3ff7dc44d332d222($8f0b3b9abdff19ee$var$K("flip"));
var $8f0b3b9abdff19ee$var$_o = {
    position: "top-right",
    transition: $8f0b3b9abdff19ee$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $8f0b3b9abdff19ee$export$f2815235e76a62b9(t) {
    let o = {
        ...$8f0b3b9abdff19ee$var$_o,
        ...t
    }, e = t.stacked, [r, s] = (0, $8nGP5.useState)(!0), l = (0, $8nGP5.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = $8f0b3b9abdff19ee$var$It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, $ajIhI.default)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $8f0b3b9abdff19ee$var$P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, $ajIhI.default)(p, $8f0b3b9abdff19ee$var$B(T));
    }
    function E() {
        e && (s(!0), $8f0b3b9abdff19ee$export$b410431fab84fa58.play());
    }
    return $8f0b3b9abdff19ee$var$Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $8nGP5.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), $8f0b3b9abdff19ee$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), $8f0b3b9abdff19ee$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), $8f0b3b9abdff19ee$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($8f0b3b9abdff19ee$var$wt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}


const $96c137ca70850e28$export$7a45779be0c29756 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const activeJobToaster = (0, $8nGP5.useRef)(null);
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    (0, $8nGP5.useEffect)(()=>{
        if (store.activeJob && store.activeJob.status == 'processing') {
            if (activeJobToaster.current == null) activeJobToaster.current = (0, $8f0b3b9abdff19ee$export$b410431fab84fa58).info(`Analysis \r\n ${store.activeJob.task}`, {
                progress: 0,
                autoClose: false,
                closeButton: false
            });
            const progress = Math.min(store.activeJob.progress || 0, 0.99);
            (0, $8f0b3b9abdff19ee$export$b410431fab84fa58).update(activeJobToaster.current, {
                render: (0, $kSbwP.jsxs)("span", {
                    style: {
                        marginLeft: 'auto'
                    },
                    children: [
                        store.activeJob.task,
                        ' ',
                        (0, $kSbwP.jsxs)("b", {
                            children: [
                                (progress * 100).toFixed(0),
                                "%"
                            ]
                        })
                    ]
                }),
                progress: progress
            });
        } else if (activeJobToaster.current) {
            (0, $8f0b3b9abdff19ee$export$b410431fab84fa58).dismiss(activeJobToaster.current);
            activeJobToaster.current = null;
        }
    }, [
        store.activeJob
    ]);
    (0, $8nGP5.useEffect)(()=>{
        if (!store.taskActiveJob) return;
        if (store.taskActiveJob.status != 'in_progress') return;
        if (activeJobToaster.current) {
            (0, $8f0b3b9abdff19ee$export$b410431fab84fa58).dismiss(activeJobToaster.current);
            activeJobToaster.current = null;
        }
        const taskDef = (0, $8f024b03d9af7c67$export$c2ad39067c031726)().get_task_definition(store.taskActiveJob.taskId);
        activeJobToaster.current = (0, $8f0b3b9abdff19ee$export$b410431fab84fa58).info(`${taskDef.name} Started`, {
            progress: 0,
            autoClose: 5000,
            closeButton: true,
            transition: (0, $8f0b3b9abdff19ee$export$d8dc01b5c85a37b9)
        });
    }, [
        store.taskActiveJob
    ]);
    return null;
});



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");
var $4c7b1825f8a16f64$exports = {};
var $22b8ec638f42dca7$exports = {};
var $d932e958496f67e8$exports = {};

var $2jpDk = parcelRequire("2jpDk");
/** Built-in value references. */ var $d932e958496f67e8$var$Symbol = $2jpDk.Symbol;
$d932e958496f67e8$exports = $d932e958496f67e8$var$Symbol;


var $711d9afa20a40c30$exports = {};

/** Used for built-in method references. */ var $711d9afa20a40c30$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $711d9afa20a40c30$var$hasOwnProperty = $711d9afa20a40c30$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $711d9afa20a40c30$var$nativeObjectToString = $711d9afa20a40c30$var$objectProto.toString;
/** Built-in value references. */ var $711d9afa20a40c30$var$symToStringTag = $d932e958496f67e8$exports ? $d932e958496f67e8$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $711d9afa20a40c30$var$getRawTag(value) {
    var isOwn = $711d9afa20a40c30$var$hasOwnProperty.call(value, $711d9afa20a40c30$var$symToStringTag), tag = value[$711d9afa20a40c30$var$symToStringTag];
    try {
        value[$711d9afa20a40c30$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $711d9afa20a40c30$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$711d9afa20a40c30$var$symToStringTag] = tag;
        else delete value[$711d9afa20a40c30$var$symToStringTag];
    }
    return result;
}
$711d9afa20a40c30$exports = $711d9afa20a40c30$var$getRawTag;


var $31dce5817c35017e$exports = {};
/** Used for built-in method references. */ var $31dce5817c35017e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $31dce5817c35017e$var$nativeObjectToString = $31dce5817c35017e$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $31dce5817c35017e$var$objectToString(value) {
    return $31dce5817c35017e$var$nativeObjectToString.call(value);
}
$31dce5817c35017e$exports = $31dce5817c35017e$var$objectToString;


/** `Object#toString` result references. */ var $22b8ec638f42dca7$var$nullTag = '[object Null]', $22b8ec638f42dca7$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $22b8ec638f42dca7$var$symToStringTag = $d932e958496f67e8$exports ? $d932e958496f67e8$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $22b8ec638f42dca7$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $22b8ec638f42dca7$var$undefinedTag : $22b8ec638f42dca7$var$nullTag;
    return $22b8ec638f42dca7$var$symToStringTag && $22b8ec638f42dca7$var$symToStringTag in Object(value) ? $711d9afa20a40c30$exports(value) : $31dce5817c35017e$exports(value);
}
$22b8ec638f42dca7$exports = $22b8ec638f42dca7$var$baseGetTag;


var $4679825e1cdd07bc$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4679825e1cdd07bc$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$4679825e1cdd07bc$exports = $4679825e1cdd07bc$var$isObject;


/** `Object#toString` result references. */ var $4c7b1825f8a16f64$var$asyncTag = '[object AsyncFunction]', $4c7b1825f8a16f64$var$funcTag = '[object Function]', $4c7b1825f8a16f64$var$genTag = '[object GeneratorFunction]', $4c7b1825f8a16f64$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $4c7b1825f8a16f64$var$isFunction(value) {
    if (!$4679825e1cdd07bc$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $22b8ec638f42dca7$exports(value);
    return tag == $4c7b1825f8a16f64$var$funcTag || tag == $4c7b1825f8a16f64$var$genTag || tag == $4c7b1825f8a16f64$var$asyncTag || tag == $4c7b1825f8a16f64$var$proxyTag;
}
$4c7b1825f8a16f64$exports = $4c7b1825f8a16f64$var$isFunction;


/* eslint no-console: 0 */ var $7371dc891b6c1818$var$isDev = false;
var $7371dc891b6c1818$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($7371dc891b6c1818$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


var $187d420db4e9f7fe$exports = {};

var $46116793eaa02c32$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $46116793eaa02c32$var$isArray = Array.isArray;
$46116793eaa02c32$exports = $46116793eaa02c32$var$isArray;


var $9405d96f7f034703$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9405d96f7f034703$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$9405d96f7f034703$exports = $9405d96f7f034703$var$isObjectLike;


/** `Object#toString` result references. */ var $187d420db4e9f7fe$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $187d420db4e9f7fe$var$isString(value) {
    return typeof value == 'string' || !$46116793eaa02c32$exports(value) && $9405d96f7f034703$exports(value) && $22b8ec638f42dca7$exports(value) == $187d420db4e9f7fe$var$stringTag;
}
$187d420db4e9f7fe$exports = $187d420db4e9f7fe$var$isString;


var $5fa94942c48bac63$exports = {};
var $5bcb1a33d8b181b4$exports = {};


/** `Object#toString` result references. */ var $5bcb1a33d8b181b4$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $5bcb1a33d8b181b4$var$isNumber(value) {
    return typeof value == 'number' || $9405d96f7f034703$exports(value) && $22b8ec638f42dca7$exports(value) == $5bcb1a33d8b181b4$var$numberTag;
}
$5bcb1a33d8b181b4$exports = $5bcb1a33d8b181b4$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $5fa94942c48bac63$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $5bcb1a33d8b181b4$exports(value) && value != +value;
}
$5fa94942c48bac63$exports = $5fa94942c48bac63$var$isNaN;


var $cb1822b0eadf52f8$exports = {};
var $1378bbdee3372fdb$exports = {};
var $c3e51feb30e3ace0$exports = {};

var $6b74c0782c00dd69$exports = {};

var $8fab81ce33077160$exports = {};


/** `Object#toString` result references. */ var $8fab81ce33077160$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $8fab81ce33077160$var$isSymbol(value) {
    return typeof value == 'symbol' || $9405d96f7f034703$exports(value) && $22b8ec638f42dca7$exports(value) == $8fab81ce33077160$var$symbolTag;
}
$8fab81ce33077160$exports = $8fab81ce33077160$var$isSymbol;


/** Used to match property names within property paths. */ var $6b74c0782c00dd69$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $6b74c0782c00dd69$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $6b74c0782c00dd69$var$isKey(value, object) {
    if ($46116793eaa02c32$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $8fab81ce33077160$exports(value)) return true;
    return $6b74c0782c00dd69$var$reIsPlainProp.test(value) || !$6b74c0782c00dd69$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$6b74c0782c00dd69$exports = $6b74c0782c00dd69$var$isKey;


var $9d65ec3c6b614ffd$exports = {};
var $e0bc53e005c763a4$exports = {};
var $c273302ab84aa29a$exports = {};
var $d4e6758f087be491$exports = {};
var $e8d7f6bb0d6ba14b$exports = {};
var $43ccfad3c27b8c09$exports = {};
var $d0716826acc0b84b$exports = {};
var $d518273df11762cd$exports = {};
var $7f56803878bcc7da$exports = {};
var $05341c6db84a2b16$exports = {};

var $17080069c0442cfb$exports = {};
var $c2de6c6f88aa051a$exports = {};

var $2jpDk = parcelRequire("2jpDk");
/** Used to detect overreaching core-js shims. */ var $c2de6c6f88aa051a$var$coreJsData = $2jpDk["__core-js_shared__"];
$c2de6c6f88aa051a$exports = $c2de6c6f88aa051a$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $17080069c0442cfb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($c2de6c6f88aa051a$exports && $c2de6c6f88aa051a$exports.keys && $c2de6c6f88aa051a$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $17080069c0442cfb$var$isMasked(func) {
    return !!$17080069c0442cfb$var$maskSrcKey && $17080069c0442cfb$var$maskSrcKey in func;
}
$17080069c0442cfb$exports = $17080069c0442cfb$var$isMasked;



var $c926545e85a233a2$exports = {};
/** Used for built-in method references. */ var $c926545e85a233a2$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $c926545e85a233a2$var$funcToString = $c926545e85a233a2$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $c926545e85a233a2$var$toSource(func) {
    if (func != null) {
        try {
            return $c926545e85a233a2$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$c926545e85a233a2$exports = $c926545e85a233a2$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $05341c6db84a2b16$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $05341c6db84a2b16$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $05341c6db84a2b16$var$funcProto = Function.prototype, $05341c6db84a2b16$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $05341c6db84a2b16$var$funcToString = $05341c6db84a2b16$var$funcProto.toString;
/** Used to check objects for own properties. */ var $05341c6db84a2b16$var$hasOwnProperty = $05341c6db84a2b16$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $05341c6db84a2b16$var$reIsNative = RegExp('^' + $05341c6db84a2b16$var$funcToString.call($05341c6db84a2b16$var$hasOwnProperty).replace($05341c6db84a2b16$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $05341c6db84a2b16$var$baseIsNative(value) {
    if (!$4679825e1cdd07bc$exports(value) || $17080069c0442cfb$exports(value)) return false;
    var pattern = $4c7b1825f8a16f64$exports(value) ? $05341c6db84a2b16$var$reIsNative : $05341c6db84a2b16$var$reIsHostCtor;
    return pattern.test($c926545e85a233a2$exports(value));
}
$05341c6db84a2b16$exports = $05341c6db84a2b16$var$baseIsNative;


var $9dad768a39cb1f08$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $9dad768a39cb1f08$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$9dad768a39cb1f08$exports = $9dad768a39cb1f08$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7f56803878bcc7da$var$getNative(object, key) {
    var value = $9dad768a39cb1f08$exports(object, key);
    return $05341c6db84a2b16$exports(value) ? value : undefined;
}
$7f56803878bcc7da$exports = $7f56803878bcc7da$var$getNative;


/* Built-in method references that are verified to be native. */ var $d518273df11762cd$var$nativeCreate = $7f56803878bcc7da$exports(Object, 'create');
$d518273df11762cd$exports = $d518273df11762cd$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $d0716826acc0b84b$var$hashClear() {
    this.__data__ = $d518273df11762cd$exports ? $d518273df11762cd$exports(null) : {};
    this.size = 0;
}
$d0716826acc0b84b$exports = $d0716826acc0b84b$var$hashClear;


var $08b793673aa88d6c$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $08b793673aa88d6c$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$08b793673aa88d6c$exports = $08b793673aa88d6c$var$hashDelete;


var $6160f2c3d9bd32b2$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $6160f2c3d9bd32b2$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $6160f2c3d9bd32b2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6160f2c3d9bd32b2$var$hasOwnProperty = $6160f2c3d9bd32b2$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6160f2c3d9bd32b2$var$hashGet(key) {
    var data = this.__data__;
    if ($d518273df11762cd$exports) {
        var result = data[key];
        return result === $6160f2c3d9bd32b2$var$HASH_UNDEFINED ? undefined : result;
    }
    return $6160f2c3d9bd32b2$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$6160f2c3d9bd32b2$exports = $6160f2c3d9bd32b2$var$hashGet;


var $e803f96216f1da01$exports = {};

/** Used for built-in method references. */ var $e803f96216f1da01$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e803f96216f1da01$var$hasOwnProperty = $e803f96216f1da01$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e803f96216f1da01$var$hashHas(key) {
    var data = this.__data__;
    return $d518273df11762cd$exports ? data[key] !== undefined : $e803f96216f1da01$var$hasOwnProperty.call(data, key);
}
$e803f96216f1da01$exports = $e803f96216f1da01$var$hashHas;


var $9be87881822841c9$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $9be87881822841c9$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $9be87881822841c9$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $d518273df11762cd$exports && value === undefined ? $9be87881822841c9$var$HASH_UNDEFINED : value;
    return this;
}
$9be87881822841c9$exports = $9be87881822841c9$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $43ccfad3c27b8c09$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$43ccfad3c27b8c09$var$Hash.prototype.clear = $d0716826acc0b84b$exports;
$43ccfad3c27b8c09$var$Hash.prototype['delete'] = $08b793673aa88d6c$exports;
$43ccfad3c27b8c09$var$Hash.prototype.get = $6160f2c3d9bd32b2$exports;
$43ccfad3c27b8c09$var$Hash.prototype.has = $e803f96216f1da01$exports;
$43ccfad3c27b8c09$var$Hash.prototype.set = $9be87881822841c9$exports;
$43ccfad3c27b8c09$exports = $43ccfad3c27b8c09$var$Hash;


var $7f2c7dd9742642e0$exports = {};
var $6fa627bcecd5990f$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $6fa627bcecd5990f$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$6fa627bcecd5990f$exports = $6fa627bcecd5990f$var$listCacheClear;


var $8beda91139d9f496$exports = {};
var $db5286ddcd601607$exports = {};
var $59abe4f1dde57d22$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $59abe4f1dde57d22$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$59abe4f1dde57d22$exports = $59abe4f1dde57d22$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $db5286ddcd601607$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($59abe4f1dde57d22$exports(array[length][0], key)) return length;
    }
    return -1;
}
$db5286ddcd601607$exports = $db5286ddcd601607$var$assocIndexOf;


/** Used for built-in method references. */ var $8beda91139d9f496$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $8beda91139d9f496$var$splice = $8beda91139d9f496$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8beda91139d9f496$var$listCacheDelete(key) {
    var data = this.__data__, index = $db5286ddcd601607$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $8beda91139d9f496$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$8beda91139d9f496$exports = $8beda91139d9f496$var$listCacheDelete;


var $088f70052d566114$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $088f70052d566114$var$listCacheGet(key) {
    var data = this.__data__, index = $db5286ddcd601607$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$088f70052d566114$exports = $088f70052d566114$var$listCacheGet;


var $f36f76e6af54e920$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f36f76e6af54e920$var$listCacheHas(key) {
    return $db5286ddcd601607$exports(this.__data__, key) > -1;
}
$f36f76e6af54e920$exports = $f36f76e6af54e920$var$listCacheHas;


var $03912848439cf58e$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $03912848439cf58e$var$listCacheSet(key, value) {
    var data = this.__data__, index = $db5286ddcd601607$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$03912848439cf58e$exports = $03912848439cf58e$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7f2c7dd9742642e0$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$7f2c7dd9742642e0$var$ListCache.prototype.clear = $6fa627bcecd5990f$exports;
$7f2c7dd9742642e0$var$ListCache.prototype['delete'] = $8beda91139d9f496$exports;
$7f2c7dd9742642e0$var$ListCache.prototype.get = $088f70052d566114$exports;
$7f2c7dd9742642e0$var$ListCache.prototype.has = $f36f76e6af54e920$exports;
$7f2c7dd9742642e0$var$ListCache.prototype.set = $03912848439cf58e$exports;
$7f2c7dd9742642e0$exports = $7f2c7dd9742642e0$var$ListCache;


var $1ac484c0eeaed10e$exports = {};


var $2jpDk = parcelRequire("2jpDk");
/* Built-in method references that are verified to be native. */ var $1ac484c0eeaed10e$var$Map = $7f56803878bcc7da$exports($2jpDk, 'Map');
$1ac484c0eeaed10e$exports = $1ac484c0eeaed10e$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $e8d7f6bb0d6ba14b$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $43ccfad3c27b8c09$exports,
        'map': new ($1ac484c0eeaed10e$exports || $7f2c7dd9742642e0$exports),
        'string': new $43ccfad3c27b8c09$exports
    };
}
$e8d7f6bb0d6ba14b$exports = $e8d7f6bb0d6ba14b$var$mapCacheClear;


var $4fdb5da172003e14$exports = {};
var $eb8cd57dcb58d4c9$exports = {};
var $d9e8d4659e1cdef6$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $d9e8d4659e1cdef6$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$d9e8d4659e1cdef6$exports = $d9e8d4659e1cdef6$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $eb8cd57dcb58d4c9$var$getMapData(map, key) {
    var data = map.__data__;
    return $d9e8d4659e1cdef6$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$eb8cd57dcb58d4c9$exports = $eb8cd57dcb58d4c9$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4fdb5da172003e14$var$mapCacheDelete(key) {
    var result = $eb8cd57dcb58d4c9$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$4fdb5da172003e14$exports = $4fdb5da172003e14$var$mapCacheDelete;


var $dc6af98db77117e4$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dc6af98db77117e4$var$mapCacheGet(key) {
    return $eb8cd57dcb58d4c9$exports(this, key).get(key);
}
$dc6af98db77117e4$exports = $dc6af98db77117e4$var$mapCacheGet;


var $6650c8b92c02e0d6$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6650c8b92c02e0d6$var$mapCacheHas(key) {
    return $eb8cd57dcb58d4c9$exports(this, key).has(key);
}
$6650c8b92c02e0d6$exports = $6650c8b92c02e0d6$var$mapCacheHas;


var $c42519bfc0806ebf$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c42519bfc0806ebf$var$mapCacheSet(key, value) {
    var data = $eb8cd57dcb58d4c9$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$c42519bfc0806ebf$exports = $c42519bfc0806ebf$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d4e6758f087be491$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$d4e6758f087be491$var$MapCache.prototype.clear = $e8d7f6bb0d6ba14b$exports;
$d4e6758f087be491$var$MapCache.prototype['delete'] = $4fdb5da172003e14$exports;
$d4e6758f087be491$var$MapCache.prototype.get = $dc6af98db77117e4$exports;
$d4e6758f087be491$var$MapCache.prototype.has = $6650c8b92c02e0d6$exports;
$d4e6758f087be491$var$MapCache.prototype.set = $c42519bfc0806ebf$exports;
$d4e6758f087be491$exports = $d4e6758f087be491$var$MapCache;


/** Error message constants. */ var $c273302ab84aa29a$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c273302ab84aa29a$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($c273302ab84aa29a$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($c273302ab84aa29a$var$memoize.Cache || $d4e6758f087be491$exports);
    return memoized;
}
// Expose `MapCache`.
$c273302ab84aa29a$var$memoize.Cache = $d4e6758f087be491$exports;
$c273302ab84aa29a$exports = $c273302ab84aa29a$var$memoize;


/** Used as the maximum memoize cache size. */ var $e0bc53e005c763a4$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $e0bc53e005c763a4$var$memoizeCapped(func) {
    var result = $c273302ab84aa29a$exports(func, function(key) {
        if (cache.size === $e0bc53e005c763a4$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$e0bc53e005c763a4$exports = $e0bc53e005c763a4$var$memoizeCapped;


/** Used to match property names within property paths. */ var $9d65ec3c6b614ffd$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $9d65ec3c6b614ffd$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $9d65ec3c6b614ffd$var$stringToPath = $e0bc53e005c763a4$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($9d65ec3c6b614ffd$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($9d65ec3c6b614ffd$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$9d65ec3c6b614ffd$exports = $9d65ec3c6b614ffd$var$stringToPath;


var $2854456ba4e51b7a$exports = {};
var $f98b1794ede2b410$exports = {};

var $9fd738eaa74f3638$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $9fd738eaa74f3638$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$9fd738eaa74f3638$exports = $9fd738eaa74f3638$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f98b1794ede2b410$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f98b1794ede2b410$var$symbolProto = $d932e958496f67e8$exports ? $d932e958496f67e8$exports.prototype : undefined, $f98b1794ede2b410$var$symbolToString = $f98b1794ede2b410$var$symbolProto ? $f98b1794ede2b410$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f98b1794ede2b410$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($46116793eaa02c32$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $9fd738eaa74f3638$exports(value, $f98b1794ede2b410$var$baseToString) + '';
    if ($8fab81ce33077160$exports(value)) return $f98b1794ede2b410$var$symbolToString ? $f98b1794ede2b410$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f98b1794ede2b410$var$INFINITY ? '-0' : result;
}
$f98b1794ede2b410$exports = $f98b1794ede2b410$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $2854456ba4e51b7a$var$toString(value) {
    return value == null ? '' : $f98b1794ede2b410$exports(value);
}
$2854456ba4e51b7a$exports = $2854456ba4e51b7a$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $c3e51feb30e3ace0$var$castPath(value, object) {
    if ($46116793eaa02c32$exports(value)) return value;
    return $6b74c0782c00dd69$exports(value, object) ? [
        value
    ] : $9d65ec3c6b614ffd$exports($2854456ba4e51b7a$exports(value));
}
$c3e51feb30e3ace0$exports = $c3e51feb30e3ace0$var$castPath;


var $696bce860a809156$exports = {};

/** Used as references for various `Number` constants. */ var $696bce860a809156$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $696bce860a809156$var$toKey(value) {
    if (typeof value == 'string' || $8fab81ce33077160$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$696bce860a809156$var$INFINITY ? '-0' : result;
}
$696bce860a809156$exports = $696bce860a809156$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $1378bbdee3372fdb$var$baseGet(object, path) {
    path = $c3e51feb30e3ace0$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$696bce860a809156$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$1378bbdee3372fdb$exports = $1378bbdee3372fdb$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $cb1822b0eadf52f8$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $1378bbdee3372fdb$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$cb1822b0eadf52f8$exports = $cb1822b0eadf52f8$var$get;



var $3d08f6c3b4eab1e3$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $3d08f6c3b4eab1e3$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $3d08f6c3b4eab1e3$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5bcb1a33d8b181b4$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(value);
};
var $3d08f6c3b4eab1e3$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $3d08f6c3b4eab1e3$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(value);
};
var $3d08f6c3b4eab1e3$var$idCounter = 0;
var $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$3d08f6c3b4eab1e3$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $3d08f6c3b4eab1e3$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$3d08f6c3b4eab1e3$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(percent)) return defaultValue;
    var value;
    if ($3d08f6c3b4eab1e3$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $3d08f6c3b4eab1e3$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $3d08f6c3b4eab1e3$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $3d08f6c3b4eab1e3$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($3d08f6c3b4eab1e3$export$7e4aa119212bc614(numberA) && $3d08f6c3b4eab1e3$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $3d08f6c3b4eab1e3$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $3d08f6c3b4eab1e3$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $3d08f6c3b4eab1e3$export$6ab1df3197f7c641 = function compareValues(a, b) {
    if ($3d08f6c3b4eab1e3$export$7e4aa119212bc614(a) && $3d08f6c3b4eab1e3$export$7e4aa119212bc614(b)) return a - b;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(a) && (0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(b)) return a.localeCompare(b);
    if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
    return String(a).localeCompare(String(b));
};



var $19a6b838e2f2c525$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $19a6b838e2f2c525$var$isNil(value) {
    return value == null;
}
$19a6b838e2f2c525$exports = $19a6b838e2f2c525$var$isNil;






var $8nGP5 = parcelRequire("8nGP5");
var $a21b66e3b05a06f0$exports = {};
'use strict';

$a21b66e3b05a06f0$exports = (parcelRequire("gdOjy"));



function $0e7c207b469fdda3$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $8nGP5 = parcelRequire("8nGP5");

function $f1d44a0cc6cff721$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f1d44a0cc6cff721$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f1d44a0cc6cff721$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $f1d44a0cc6cff721$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $f1d44a0cc6cff721$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $f1d44a0cc6cff721$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $f1d44a0cc6cff721$export$2b22758266a6fa48 = {
    svg: $f1d44a0cc6cff721$var$SVGContainerPropKeys,
    polygon: $f1d44a0cc6cff721$var$PolyElementKeys,
    polyline: $f1d44a0cc6cff721$var$PolyElementKeys
};
var $f1d44a0cc6cff721$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $f1d44a0cc6cff721$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($f1d44a0cc6cff721$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $f1d44a0cc6cff721$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $f1d44a0cc6cff721$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(props) || $f1d44a0cc6cff721$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($f1d44a0cc6cff721$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $f1d44a0cc6cff721$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $8b99c43c69c5c37b$var$_excluded = [
    "children"
], $8b99c43c69c5c37b$var$_excluded2 = [
    "children"
];
function $8b99c43c69c5c37b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8b99c43c69c5c37b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8b99c43c69c5c37b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8b99c43c69c5c37b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8b99c43c69c5c37b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8b99c43c69c5c37b$var$_typeof(o);
}
var $8b99c43c69c5c37b$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart',
    contextmenu: 'onContextMenu',
    dblclick: 'onDoubleClick'
};
var $8b99c43c69c5c37b$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $8b99c43c69c5c37b$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $8b99c43c69c5c37b$export$59a4d7d024cf1025 = [
    'none'
];
var $8b99c43c69c5c37b$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $8b99c43c69c5c37b$var$lastChildren = null;
var $8b99c43c69c5c37b$var$lastResult = null;
var $8b99c43c69c5c37b$export$45b10814cc054894 = function toArray(children) {
    if (children === $8b99c43c69c5c37b$var$lastChildren && Array.isArray($8b99c43c69c5c37b$var$lastResult)) return $8b99c43c69c5c37b$var$lastResult;
    var result = [];
    (0, $8nGP5.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(child)) return;
        if ((0, $a21b66e3b05a06f0$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $8b99c43c69c5c37b$var$lastResult = result;
    $8b99c43c69c5c37b$var$lastChildren = children;
    return result;
};
function $8b99c43c69c5c37b$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $8b99c43c69c5c37b$export$be63e0664592e141(t);
    });
    else types = [
        $8b99c43c69c5c37b$export$be63e0664592e141(type)
    ];
    $8b99c43c69c5c37b$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $8b99c43c69c5c37b$export$64c61536a2b72e0f(children, type) {
    var result = $8b99c43c69c5c37b$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $8b99c43c69c5c37b$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $8b99c43c69c5c37b$export$be63e0664592e141(t);
    });
    else types = [
        $8b99c43c69c5c37b$export$be63e0664592e141(type)
    ];
    $8b99c43c69c5c37b$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $8b99c43c69c5c37b$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $8b99c43c69c5c37b$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $8b99c43c69c5c37b$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(child.type) && $8b99c43c69c5c37b$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $8b99c43c69c5c37b$export$392f6c9701718a4e = function hasClipDot(dot) {
    return dot && $8b99c43c69c5c37b$var$_typeof(dot) === 'object' && 'clipDot' in dot;
};
var $8b99c43c69c5c37b$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $f1d44a0cc6cff721$export$2b22758266a6fa48) === null || (0, $f1d44a0cc6cff721$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $f1d44a0cc6cff721$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return key.startsWith('data-') || !(0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $f1d44a0cc6cff721$export$190f430946f96110).includes(key)) || includeEvents && (0, $f1d44a0cc6cff721$export$f30789245f2c4d11).includes(key);
};
var $8b99c43c69c5c37b$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $8b99c43c69c5c37b$export$45b10814cc054894(children).forEach(function(entry) {
        if ($8b99c43c69c5c37b$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $8b99c43c69c5c37b$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($8b99c43c69c5c37b$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $8b99c43c69c5c37b$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $8nGP5.Children).count(nextChildren);
    if (count !== (0, $8nGP5.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $8b99c43c69c5c37b$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$8b99c43c69c5c37b$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $8b99c43c69c5c37b$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $8b99c43c69c5c37b$var$_objectWithoutProperties(_ref, $8b99c43c69c5c37b$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $8b99c43c69c5c37b$var$_objectWithoutProperties(_ref2, $8b99c43c69c5c37b$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $0e7c207b469fdda3$export$d36bdfa510afb180)(nextProps, prevProps) && $8b99c43c69c5c37b$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $0e7c207b469fdda3$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $8b99c43c69c5c37b$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $8b99c43c69c5c37b$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($8b99c43c69c5c37b$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $8b99c43c69c5c37b$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $8b99c43c69c5c37b$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $8b99c43c69c5c37b$var$REACT_BROWSER_EVENT_MAP[type]) return $8b99c43c69c5c37b$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $8b99c43c69c5c37b$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $8b99c43c69c5c37b$export$45b10814cc054894(children).indexOf(child);
};


var $5389c27663bb3a0e$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$5389c27663bb3a0e$exports = (parcelRequire("1xE3P"));


var $4efdaf596664c2fb$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$4efdaf596664c2fb$exports = (parcelRequire("jR8B9"));


var $16a263dc7ad650d9$exports = {};
var $a5f8c8545678430c$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $a5f8c8545678430c$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$8fab81ce33077160$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$a5f8c8545678430c$exports = $a5f8c8545678430c$var$baseExtremum;


var $697c572969d07084$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $697c572969d07084$var$baseGt(value, other) {
    return value > other;
}
$697c572969d07084$exports = $697c572969d07084$var$baseGt;


var $5cab5b412769001e$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $5cab5b412769001e$var$identity(value) {
    return value;
}
$5cab5b412769001e$exports = $5cab5b412769001e$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $16a263dc7ad650d9$var$max(array) {
    return array && array.length ? $a5f8c8545678430c$exports(array, $5cab5b412769001e$exports, $697c572969d07084$exports) : undefined;
}
$16a263dc7ad650d9$exports = $16a263dc7ad650d9$var$max;


var $68f8d6cfd642a3d7$exports = {};

var $82ee23cbf0c7be99$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $82ee23cbf0c7be99$var$baseLt(value, other) {
    return value < other;
}
$82ee23cbf0c7be99$exports = $82ee23cbf0c7be99$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $68f8d6cfd642a3d7$var$min(array) {
    return array && array.length ? $a5f8c8545678430c$exports(array, $5cab5b412769001e$exports, $82ee23cbf0c7be99$exports) : undefined;
}
$68f8d6cfd642a3d7$exports = $68f8d6cfd642a3d7$var$min;






var $ce626f03865ef5d1$exports = {};
var $dcd699742a532aa9$exports = {};
var $93eb1ba0371cd30c$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $93eb1ba0371cd30c$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$93eb1ba0371cd30c$exports = $93eb1ba0371cd30c$var$arrayPush;


var $1db7dd8c21ff64f4$exports = {};

var $831a7343de17c81b$exports = {};
var $00ae986c6dc32c3a$exports = {};


/** `Object#toString` result references. */ var $00ae986c6dc32c3a$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $00ae986c6dc32c3a$var$baseIsArguments(value) {
    return $9405d96f7f034703$exports(value) && $22b8ec638f42dca7$exports(value) == $00ae986c6dc32c3a$var$argsTag;
}
$00ae986c6dc32c3a$exports = $00ae986c6dc32c3a$var$baseIsArguments;



/** Used for built-in method references. */ var $831a7343de17c81b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $831a7343de17c81b$var$hasOwnProperty = $831a7343de17c81b$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $831a7343de17c81b$var$propertyIsEnumerable = $831a7343de17c81b$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $831a7343de17c81b$var$isArguments = $00ae986c6dc32c3a$exports(function() {
    return arguments;
}()) ? $00ae986c6dc32c3a$exports : function(value) {
    return $9405d96f7f034703$exports(value) && $831a7343de17c81b$var$hasOwnProperty.call(value, 'callee') && !$831a7343de17c81b$var$propertyIsEnumerable.call(value, 'callee');
};
$831a7343de17c81b$exports = $831a7343de17c81b$var$isArguments;



/** Built-in value references. */ var $1db7dd8c21ff64f4$var$spreadableSymbol = $d932e958496f67e8$exports ? $d932e958496f67e8$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $1db7dd8c21ff64f4$var$isFlattenable(value) {
    return $46116793eaa02c32$exports(value) || $831a7343de17c81b$exports(value) || !!($1db7dd8c21ff64f4$var$spreadableSymbol && value && value[$1db7dd8c21ff64f4$var$spreadableSymbol]);
}
$1db7dd8c21ff64f4$exports = $1db7dd8c21ff64f4$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $dcd699742a532aa9$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $1db7dd8c21ff64f4$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $dcd699742a532aa9$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $93eb1ba0371cd30c$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$dcd699742a532aa9$exports = $dcd699742a532aa9$var$baseFlatten;


var $19c32bf6b9804e62$exports = {};

var $6aa52744a9ab51b8$exports = {};
var $7391754aeef62814$exports = {};
var $b05f87b265eaa1b9$exports = {};
var $7cbdce1218977e91$exports = {};

var $38b3a72f4503a8d5$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $38b3a72f4503a8d5$var$stackClear() {
    this.__data__ = new $7f2c7dd9742642e0$exports;
    this.size = 0;
}
$38b3a72f4503a8d5$exports = $38b3a72f4503a8d5$var$stackClear;


var $999145c3bcdba4dc$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $999145c3bcdba4dc$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$999145c3bcdba4dc$exports = $999145c3bcdba4dc$var$stackDelete;


var $3f716e9ece3a4a7e$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3f716e9ece3a4a7e$var$stackGet(key) {
    return this.__data__.get(key);
}
$3f716e9ece3a4a7e$exports = $3f716e9ece3a4a7e$var$stackGet;


var $0a9325c0fff3448a$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0a9325c0fff3448a$var$stackHas(key) {
    return this.__data__.has(key);
}
$0a9325c0fff3448a$exports = $0a9325c0fff3448a$var$stackHas;


var $ffa18809d5034c03$exports = {};



/** Used as the size to enable large array optimizations. */ var $ffa18809d5034c03$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $ffa18809d5034c03$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $7f2c7dd9742642e0$exports) {
        var pairs = data.__data__;
        if (!$1ac484c0eeaed10e$exports || pairs.length < $ffa18809d5034c03$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $d4e6758f087be491$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$ffa18809d5034c03$exports = $ffa18809d5034c03$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7cbdce1218977e91$var$Stack(entries) {
    var data = this.__data__ = new $7f2c7dd9742642e0$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$7cbdce1218977e91$var$Stack.prototype.clear = $38b3a72f4503a8d5$exports;
$7cbdce1218977e91$var$Stack.prototype['delete'] = $999145c3bcdba4dc$exports;
$7cbdce1218977e91$var$Stack.prototype.get = $3f716e9ece3a4a7e$exports;
$7cbdce1218977e91$var$Stack.prototype.has = $0a9325c0fff3448a$exports;
$7cbdce1218977e91$var$Stack.prototype.set = $ffa18809d5034c03$exports;
$7cbdce1218977e91$exports = $7cbdce1218977e91$var$Stack;


var $319a4f523286b934$exports = {};
var $e4e3f2df1701baeb$exports = {};

var $1ce4e306faa356cb$exports = {};
var $d2c49809ad6e170e$exports = {};

var $dce0bf715e67581f$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dce0bf715e67581f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dce0bf715e67581f$var$setCacheAdd(value) {
    this.__data__.set(value, $dce0bf715e67581f$var$HASH_UNDEFINED);
    return this;
}
$dce0bf715e67581f$exports = $dce0bf715e67581f$var$setCacheAdd;


var $f0fae38dced8c043$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $f0fae38dced8c043$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$f0fae38dced8c043$exports = $f0fae38dced8c043$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $d2c49809ad6e170e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $d4e6758f087be491$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$d2c49809ad6e170e$var$SetCache.prototype.add = $d2c49809ad6e170e$var$SetCache.prototype.push = $dce0bf715e67581f$exports;
$d2c49809ad6e170e$var$SetCache.prototype.has = $f0fae38dced8c043$exports;
$d2c49809ad6e170e$exports = $d2c49809ad6e170e$var$SetCache;


var $63744a28e8fd4c84$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $63744a28e8fd4c84$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$63744a28e8fd4c84$exports = $63744a28e8fd4c84$var$arraySome;


var $e5e703715ca3ea7c$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e5e703715ca3ea7c$var$cacheHas(cache, key) {
    return cache.has(key);
}
$e5e703715ca3ea7c$exports = $e5e703715ca3ea7c$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1ce4e306faa356cb$var$COMPARE_PARTIAL_FLAG = 1, $1ce4e306faa356cb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1ce4e306faa356cb$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1ce4e306faa356cb$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1ce4e306faa356cb$var$COMPARE_UNORDERED_FLAG ? new $d2c49809ad6e170e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$63744a28e8fd4c84$exports(other, function(othValue, othIndex) {
                if (!$e5e703715ca3ea7c$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$1ce4e306faa356cb$exports = $1ce4e306faa356cb$var$equalArrays;


var $d4e9211b344c9a7a$exports = {};

var $09f8dc425a8b200b$exports = {};

var $2jpDk = parcelRequire("2jpDk");
/** Built-in value references. */ var $09f8dc425a8b200b$var$Uint8Array = $2jpDk.Uint8Array;
$09f8dc425a8b200b$exports = $09f8dc425a8b200b$var$Uint8Array;




var $02e2a23514891b9e$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $02e2a23514891b9e$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$02e2a23514891b9e$exports = $02e2a23514891b9e$var$mapToArray;


var $1360f177952adc80$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $1360f177952adc80$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$1360f177952adc80$exports = $1360f177952adc80$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $d4e9211b344c9a7a$var$COMPARE_PARTIAL_FLAG = 1, $d4e9211b344c9a7a$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $d4e9211b344c9a7a$var$boolTag = '[object Boolean]', $d4e9211b344c9a7a$var$dateTag = '[object Date]', $d4e9211b344c9a7a$var$errorTag = '[object Error]', $d4e9211b344c9a7a$var$mapTag = '[object Map]', $d4e9211b344c9a7a$var$numberTag = '[object Number]', $d4e9211b344c9a7a$var$regexpTag = '[object RegExp]', $d4e9211b344c9a7a$var$setTag = '[object Set]', $d4e9211b344c9a7a$var$stringTag = '[object String]', $d4e9211b344c9a7a$var$symbolTag = '[object Symbol]';
var $d4e9211b344c9a7a$var$arrayBufferTag = '[object ArrayBuffer]', $d4e9211b344c9a7a$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $d4e9211b344c9a7a$var$symbolProto = $d932e958496f67e8$exports ? $d932e958496f67e8$exports.prototype : undefined, $d4e9211b344c9a7a$var$symbolValueOf = $d4e9211b344c9a7a$var$symbolProto ? $d4e9211b344c9a7a$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d4e9211b344c9a7a$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $d4e9211b344c9a7a$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $d4e9211b344c9a7a$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $09f8dc425a8b200b$exports(object), new $09f8dc425a8b200b$exports(other))) return false;
            return true;
        case $d4e9211b344c9a7a$var$boolTag:
        case $d4e9211b344c9a7a$var$dateTag:
        case $d4e9211b344c9a7a$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $59abe4f1dde57d22$exports(+object, +other);
        case $d4e9211b344c9a7a$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $d4e9211b344c9a7a$var$regexpTag:
        case $d4e9211b344c9a7a$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $d4e9211b344c9a7a$var$mapTag:
            var convert = $02e2a23514891b9e$exports;
        case $d4e9211b344c9a7a$var$setTag:
            var isPartial = bitmask & $d4e9211b344c9a7a$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1360f177952adc80$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $d4e9211b344c9a7a$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1ce4e306faa356cb$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $d4e9211b344c9a7a$var$symbolTag:
            if ($d4e9211b344c9a7a$var$symbolValueOf) return $d4e9211b344c9a7a$var$symbolValueOf.call(object) == $d4e9211b344c9a7a$var$symbolValueOf.call(other);
    }
    return false;
}
$d4e9211b344c9a7a$exports = $d4e9211b344c9a7a$var$equalByTag;


var $2224c020433640a0$exports = {};
var $8d7541fd0e463dc6$exports = {};
var $c63543f5c9e1db85$exports = {};


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c63543f5c9e1db85$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $46116793eaa02c32$exports(object) ? result : $93eb1ba0371cd30c$exports(result, symbolsFunc(object));
}
$c63543f5c9e1db85$exports = $c63543f5c9e1db85$var$baseGetAllKeys;


var $2e702b29c03226bb$exports = {};
var $03b49cc04a9e0bf9$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $03b49cc04a9e0bf9$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$03b49cc04a9e0bf9$exports = $03b49cc04a9e0bf9$var$arrayFilter;


var $f5556dcf7a4bbfe6$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $f5556dcf7a4bbfe6$var$stubArray() {
    return [];
}
$f5556dcf7a4bbfe6$exports = $f5556dcf7a4bbfe6$var$stubArray;


/** Used for built-in method references. */ var $2e702b29c03226bb$var$objectProto = Object.prototype;
/** Built-in value references. */ var $2e702b29c03226bb$var$propertyIsEnumerable = $2e702b29c03226bb$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2e702b29c03226bb$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $2e702b29c03226bb$var$getSymbols = !$2e702b29c03226bb$var$nativeGetSymbols ? $f5556dcf7a4bbfe6$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $03b49cc04a9e0bf9$exports($2e702b29c03226bb$var$nativeGetSymbols(object), function(symbol) {
        return $2e702b29c03226bb$var$propertyIsEnumerable.call(object, symbol);
    });
};
$2e702b29c03226bb$exports = $2e702b29c03226bb$var$getSymbols;


var $2e84fcf9f20ac983$exports = {};
var $82c78902af9d196b$exports = {};
var $5a1e00bc5b141560$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $5a1e00bc5b141560$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$5a1e00bc5b141560$exports = $5a1e00bc5b141560$var$baseTimes;





var $eFJGi = parcelRequire("eFJGi");
var $ea7b709b198a2835$exports = {};
/** Used as references for various `Number` constants. */ var $ea7b709b198a2835$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ea7b709b198a2835$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ea7b709b198a2835$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ea7b709b198a2835$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ea7b709b198a2835$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$ea7b709b198a2835$exports = $ea7b709b198a2835$var$isIndex;


var $d92395e90f0b7eed$exports = {};
var $c6b3bec86156229a$exports = {};

var $5b55e27769eb229f$exports = {};
/** Used as references for various `Number` constants. */ var $5b55e27769eb229f$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $5b55e27769eb229f$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $5b55e27769eb229f$var$MAX_SAFE_INTEGER;
}
$5b55e27769eb229f$exports = $5b55e27769eb229f$var$isLength;



/** `Object#toString` result references. */ var $c6b3bec86156229a$var$argsTag = '[object Arguments]', $c6b3bec86156229a$var$arrayTag = '[object Array]', $c6b3bec86156229a$var$boolTag = '[object Boolean]', $c6b3bec86156229a$var$dateTag = '[object Date]', $c6b3bec86156229a$var$errorTag = '[object Error]', $c6b3bec86156229a$var$funcTag = '[object Function]', $c6b3bec86156229a$var$mapTag = '[object Map]', $c6b3bec86156229a$var$numberTag = '[object Number]', $c6b3bec86156229a$var$objectTag = '[object Object]', $c6b3bec86156229a$var$regexpTag = '[object RegExp]', $c6b3bec86156229a$var$setTag = '[object Set]', $c6b3bec86156229a$var$stringTag = '[object String]', $c6b3bec86156229a$var$weakMapTag = '[object WeakMap]';
var $c6b3bec86156229a$var$arrayBufferTag = '[object ArrayBuffer]', $c6b3bec86156229a$var$dataViewTag = '[object DataView]', $c6b3bec86156229a$var$float32Tag = '[object Float32Array]', $c6b3bec86156229a$var$float64Tag = '[object Float64Array]', $c6b3bec86156229a$var$int8Tag = '[object Int8Array]', $c6b3bec86156229a$var$int16Tag = '[object Int16Array]', $c6b3bec86156229a$var$int32Tag = '[object Int32Array]', $c6b3bec86156229a$var$uint8Tag = '[object Uint8Array]', $c6b3bec86156229a$var$uint8ClampedTag = '[object Uint8ClampedArray]', $c6b3bec86156229a$var$uint16Tag = '[object Uint16Array]', $c6b3bec86156229a$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $c6b3bec86156229a$var$typedArrayTags = {};
$c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$float32Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$float64Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$int8Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$int16Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$int32Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$uint8Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$uint8ClampedTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$uint16Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$uint32Tag] = true;
$c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$argsTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$arrayTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$arrayBufferTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$boolTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$dataViewTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$dateTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$errorTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$funcTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$mapTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$numberTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$objectTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$regexpTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$setTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$stringTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $c6b3bec86156229a$var$baseIsTypedArray(value) {
    return $9405d96f7f034703$exports(value) && $5b55e27769eb229f$exports(value.length) && !!$c6b3bec86156229a$var$typedArrayTags[$22b8ec638f42dca7$exports(value)];
}
$c6b3bec86156229a$exports = $c6b3bec86156229a$var$baseIsTypedArray;


var $6c87d2ec7a5b64db$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $6c87d2ec7a5b64db$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$6c87d2ec7a5b64db$exports = $6c87d2ec7a5b64db$var$baseUnary;



var $1cz3N = parcelRequire("1cz3N");
/* Node.js helper references. */ var $d92395e90f0b7eed$var$nodeIsTypedArray = $1cz3N && $1cz3N.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $d92395e90f0b7eed$var$isTypedArray = $d92395e90f0b7eed$var$nodeIsTypedArray ? $6c87d2ec7a5b64db$exports($d92395e90f0b7eed$var$nodeIsTypedArray) : $c6b3bec86156229a$exports;
$d92395e90f0b7eed$exports = $d92395e90f0b7eed$var$isTypedArray;


/** Used for built-in method references. */ var $82c78902af9d196b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $82c78902af9d196b$var$hasOwnProperty = $82c78902af9d196b$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $82c78902af9d196b$var$arrayLikeKeys(value, inherited) {
    var isArr = $46116793eaa02c32$exports(value), isArg = !isArr && $831a7343de17c81b$exports(value), isBuff = !isArr && !isArg && $eFJGi(value), isType = !isArr && !isArg && !isBuff && $d92395e90f0b7eed$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $5a1e00bc5b141560$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $82c78902af9d196b$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $ea7b709b198a2835$exports(key, length)))) result.push(key);
    return result;
}
$82c78902af9d196b$exports = $82c78902af9d196b$var$arrayLikeKeys;


var $70343d667ca5cf12$exports = {};
var $ede3dc0e3cba8cac$exports = {};
/** Used for built-in method references. */ var $ede3dc0e3cba8cac$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $ede3dc0e3cba8cac$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $ede3dc0e3cba8cac$var$objectProto;
    return value === proto;
}
$ede3dc0e3cba8cac$exports = $ede3dc0e3cba8cac$var$isPrototype;


var $64b4ff58317e9ed8$exports = {};
var $e5cfd6ab9c22776f$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e5cfd6ab9c22776f$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$e5cfd6ab9c22776f$exports = $e5cfd6ab9c22776f$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $64b4ff58317e9ed8$var$nativeKeys = $e5cfd6ab9c22776f$exports(Object.keys, Object);
$64b4ff58317e9ed8$exports = $64b4ff58317e9ed8$var$nativeKeys;


/** Used for built-in method references. */ var $70343d667ca5cf12$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $70343d667ca5cf12$var$hasOwnProperty = $70343d667ca5cf12$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $70343d667ca5cf12$var$baseKeys(object) {
    if (!$ede3dc0e3cba8cac$exports(object)) return $64b4ff58317e9ed8$exports(object);
    var result = [];
    for(var key in Object(object))if ($70343d667ca5cf12$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$70343d667ca5cf12$exports = $70343d667ca5cf12$var$baseKeys;


var $70a87f3bd796a6cd$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $70a87f3bd796a6cd$var$isArrayLike(value) {
    return value != null && $5b55e27769eb229f$exports(value.length) && !$4c7b1825f8a16f64$exports(value);
}
$70a87f3bd796a6cd$exports = $70a87f3bd796a6cd$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $2e84fcf9f20ac983$var$keys(object) {
    return $70a87f3bd796a6cd$exports(object) ? $82c78902af9d196b$exports(object) : $70343d667ca5cf12$exports(object);
}
$2e84fcf9f20ac983$exports = $2e84fcf9f20ac983$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8d7541fd0e463dc6$var$getAllKeys(object) {
    return $c63543f5c9e1db85$exports(object, $2e84fcf9f20ac983$exports, $2e702b29c03226bb$exports);
}
$8d7541fd0e463dc6$exports = $8d7541fd0e463dc6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $2224c020433640a0$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $2224c020433640a0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2224c020433640a0$var$hasOwnProperty = $2224c020433640a0$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2224c020433640a0$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $2224c020433640a0$var$COMPARE_PARTIAL_FLAG, objProps = $8d7541fd0e463dc6$exports(object), objLength = objProps.length, othProps = $8d7541fd0e463dc6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $2224c020433640a0$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$2224c020433640a0$exports = $2224c020433640a0$var$equalObjects;


var $397ffb1740602045$exports = {};
var $3a8fec3239256c13$exports = {};


var $2jpDk = parcelRequire("2jpDk");
/* Built-in method references that are verified to be native. */ var $3a8fec3239256c13$var$DataView = $7f56803878bcc7da$exports($2jpDk, 'DataView');
$3a8fec3239256c13$exports = $3a8fec3239256c13$var$DataView;



var $ba1a06f8a2e0f960$exports = {};


var $2jpDk = parcelRequire("2jpDk");
/* Built-in method references that are verified to be native. */ var $ba1a06f8a2e0f960$var$Promise = $7f56803878bcc7da$exports($2jpDk, 'Promise');
$ba1a06f8a2e0f960$exports = $ba1a06f8a2e0f960$var$Promise;


var $4c1a03e269fbabc9$exports = {};


var $2jpDk = parcelRequire("2jpDk");
/* Built-in method references that are verified to be native. */ var $4c1a03e269fbabc9$var$Set = $7f56803878bcc7da$exports($2jpDk, 'Set');
$4c1a03e269fbabc9$exports = $4c1a03e269fbabc9$var$Set;


var $8b7614145d10ca77$exports = {};


var $2jpDk = parcelRequire("2jpDk");
/* Built-in method references that are verified to be native. */ var $8b7614145d10ca77$var$WeakMap = $7f56803878bcc7da$exports($2jpDk, 'WeakMap');
$8b7614145d10ca77$exports = $8b7614145d10ca77$var$WeakMap;




/** `Object#toString` result references. */ var $397ffb1740602045$var$mapTag = '[object Map]', $397ffb1740602045$var$objectTag = '[object Object]', $397ffb1740602045$var$promiseTag = '[object Promise]', $397ffb1740602045$var$setTag = '[object Set]', $397ffb1740602045$var$weakMapTag = '[object WeakMap]';
var $397ffb1740602045$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $397ffb1740602045$var$dataViewCtorString = $c926545e85a233a2$exports($3a8fec3239256c13$exports), $397ffb1740602045$var$mapCtorString = $c926545e85a233a2$exports($1ac484c0eeaed10e$exports), $397ffb1740602045$var$promiseCtorString = $c926545e85a233a2$exports($ba1a06f8a2e0f960$exports), $397ffb1740602045$var$setCtorString = $c926545e85a233a2$exports($4c1a03e269fbabc9$exports), $397ffb1740602045$var$weakMapCtorString = $c926545e85a233a2$exports($8b7614145d10ca77$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $397ffb1740602045$var$getTag = $22b8ec638f42dca7$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($3a8fec3239256c13$exports && $397ffb1740602045$var$getTag(new $3a8fec3239256c13$exports(new ArrayBuffer(1))) != $397ffb1740602045$var$dataViewTag || $1ac484c0eeaed10e$exports && $397ffb1740602045$var$getTag(new $1ac484c0eeaed10e$exports) != $397ffb1740602045$var$mapTag || $ba1a06f8a2e0f960$exports && $397ffb1740602045$var$getTag($ba1a06f8a2e0f960$exports.resolve()) != $397ffb1740602045$var$promiseTag || $4c1a03e269fbabc9$exports && $397ffb1740602045$var$getTag(new $4c1a03e269fbabc9$exports) != $397ffb1740602045$var$setTag || $8b7614145d10ca77$exports && $397ffb1740602045$var$getTag(new $8b7614145d10ca77$exports) != $397ffb1740602045$var$weakMapTag) $397ffb1740602045$var$getTag = function(value) {
    var result = $22b8ec638f42dca7$exports(value), Ctor = result == $397ffb1740602045$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $c926545e85a233a2$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $397ffb1740602045$var$dataViewCtorString:
            return $397ffb1740602045$var$dataViewTag;
        case $397ffb1740602045$var$mapCtorString:
            return $397ffb1740602045$var$mapTag;
        case $397ffb1740602045$var$promiseCtorString:
            return $397ffb1740602045$var$promiseTag;
        case $397ffb1740602045$var$setCtorString:
            return $397ffb1740602045$var$setTag;
        case $397ffb1740602045$var$weakMapCtorString:
            return $397ffb1740602045$var$weakMapTag;
    }
    return result;
};
$397ffb1740602045$exports = $397ffb1740602045$var$getTag;




var $eFJGi = parcelRequire("eFJGi");

/** Used to compose bitmasks for value comparisons. */ var $e4e3f2df1701baeb$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $e4e3f2df1701baeb$var$argsTag = '[object Arguments]', $e4e3f2df1701baeb$var$arrayTag = '[object Array]', $e4e3f2df1701baeb$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $e4e3f2df1701baeb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e4e3f2df1701baeb$var$hasOwnProperty = $e4e3f2df1701baeb$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e4e3f2df1701baeb$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $46116793eaa02c32$exports(object), othIsArr = $46116793eaa02c32$exports(other), objTag = objIsArr ? $e4e3f2df1701baeb$var$arrayTag : $397ffb1740602045$exports(object), othTag = othIsArr ? $e4e3f2df1701baeb$var$arrayTag : $397ffb1740602045$exports(other);
    objTag = objTag == $e4e3f2df1701baeb$var$argsTag ? $e4e3f2df1701baeb$var$objectTag : objTag;
    othTag = othTag == $e4e3f2df1701baeb$var$argsTag ? $e4e3f2df1701baeb$var$objectTag : othTag;
    var objIsObj = objTag == $e4e3f2df1701baeb$var$objectTag, othIsObj = othTag == $e4e3f2df1701baeb$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $eFJGi(object)) {
        if (!$eFJGi(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $7cbdce1218977e91$exports);
        return objIsArr || $d92395e90f0b7eed$exports(object) ? $1ce4e306faa356cb$exports(object, other, bitmask, customizer, equalFunc, stack) : $d4e9211b344c9a7a$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $e4e3f2df1701baeb$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $e4e3f2df1701baeb$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $e4e3f2df1701baeb$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $7cbdce1218977e91$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $7cbdce1218977e91$exports);
    return $2224c020433640a0$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$e4e3f2df1701baeb$exports = $e4e3f2df1701baeb$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $319a4f523286b934$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$9405d96f7f034703$exports(value) && !$9405d96f7f034703$exports(other)) return value !== value && other !== other;
    return $e4e3f2df1701baeb$exports(value, other, bitmask, customizer, $319a4f523286b934$var$baseIsEqual, stack);
}
$319a4f523286b934$exports = $319a4f523286b934$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $b05f87b265eaa1b9$var$COMPARE_PARTIAL_FLAG = 1, $b05f87b265eaa1b9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $b05f87b265eaa1b9$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $7cbdce1218977e91$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $319a4f523286b934$exports(srcValue, objValue, $b05f87b265eaa1b9$var$COMPARE_PARTIAL_FLAG | $b05f87b265eaa1b9$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$b05f87b265eaa1b9$exports = $b05f87b265eaa1b9$var$baseIsMatch;


var $e974065d649a8bdc$exports = {};
var $4cdcaa293be7a027$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $4cdcaa293be7a027$var$isStrictComparable(value) {
    return value === value && !$4679825e1cdd07bc$exports(value);
}
$4cdcaa293be7a027$exports = $4cdcaa293be7a027$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $e974065d649a8bdc$var$getMatchData(object) {
    var result = $2e84fcf9f20ac983$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $4cdcaa293be7a027$exports(value)
        ];
    }
    return result;
}
$e974065d649a8bdc$exports = $e974065d649a8bdc$var$getMatchData;


var $bfd06d716f20e505$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $bfd06d716f20e505$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$bfd06d716f20e505$exports = $bfd06d716f20e505$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $7391754aeef62814$var$baseMatches(source) {
    var matchData = $e974065d649a8bdc$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $bfd06d716f20e505$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $b05f87b265eaa1b9$exports(object, source, matchData);
    };
}
$7391754aeef62814$exports = $7391754aeef62814$var$baseMatches;


var $506ddeba8a5cf470$exports = {};


var $eb43c4c7d5c912d2$exports = {};
var $ed3d94793c08c9a8$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ed3d94793c08c9a8$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$ed3d94793c08c9a8$exports = $ed3d94793c08c9a8$var$baseHasIn;


var $55cbad4ee8bb0cfb$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $55cbad4ee8bb0cfb$var$hasPath(object, path, hasFunc) {
    path = $c3e51feb30e3ace0$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $696bce860a809156$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $5b55e27769eb229f$exports(length) && $ea7b709b198a2835$exports(key, length) && ($46116793eaa02c32$exports(object) || $831a7343de17c81b$exports(object));
}
$55cbad4ee8bb0cfb$exports = $55cbad4ee8bb0cfb$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $eb43c4c7d5c912d2$var$hasIn(object, path) {
    return object != null && $55cbad4ee8bb0cfb$exports(object, path, $ed3d94793c08c9a8$exports);
}
$eb43c4c7d5c912d2$exports = $eb43c4c7d5c912d2$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $506ddeba8a5cf470$var$COMPARE_PARTIAL_FLAG = 1, $506ddeba8a5cf470$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $506ddeba8a5cf470$var$baseMatchesProperty(path, srcValue) {
    if ($6b74c0782c00dd69$exports(path) && $4cdcaa293be7a027$exports(srcValue)) return $bfd06d716f20e505$exports($696bce860a809156$exports(path), srcValue);
    return function(object) {
        var objValue = $cb1822b0eadf52f8$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $eb43c4c7d5c912d2$exports(object, path) : $319a4f523286b934$exports(srcValue, objValue, $506ddeba8a5cf470$var$COMPARE_PARTIAL_FLAG | $506ddeba8a5cf470$var$COMPARE_UNORDERED_FLAG);
    };
}
$506ddeba8a5cf470$exports = $506ddeba8a5cf470$var$baseMatchesProperty;




var $166d88ea8445df76$exports = {};
var $4ee6ae10e8830287$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4ee6ae10e8830287$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$4ee6ae10e8830287$exports = $4ee6ae10e8830287$var$baseProperty;


var $871249e1c0a017db$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $871249e1c0a017db$var$basePropertyDeep(path) {
    return function(object) {
        return $1378bbdee3372fdb$exports(object, path);
    };
}
$871249e1c0a017db$exports = $871249e1c0a017db$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $166d88ea8445df76$var$property(path) {
    return $6b74c0782c00dd69$exports(path) ? $4ee6ae10e8830287$exports($696bce860a809156$exports(path)) : $871249e1c0a017db$exports(path);
}
$166d88ea8445df76$exports = $166d88ea8445df76$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $6aa52744a9ab51b8$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $5cab5b412769001e$exports;
    if (typeof value == 'object') return $46116793eaa02c32$exports(value) ? $506ddeba8a5cf470$exports(value[0], value[1]) : $7391754aeef62814$exports(value);
    return $166d88ea8445df76$exports(value);
}
$6aa52744a9ab51b8$exports = $6aa52744a9ab51b8$var$baseIteratee;


var $bd274b9519243073$exports = {};
var $f1008ccff5feed7a$exports = {};
var $34c69bd8a346e2bb$exports = {};
var $e517e993f90f8988$exports = {};
var $d9fabc146d8d5ada$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d9fabc146d8d5ada$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$d9fabc146d8d5ada$exports = $d9fabc146d8d5ada$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $e517e993f90f8988$var$baseFor = $d9fabc146d8d5ada$exports();
$e517e993f90f8988$exports = $e517e993f90f8988$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34c69bd8a346e2bb$var$baseForOwn(object, iteratee) {
    return object && $e517e993f90f8988$exports(object, iteratee, $2e84fcf9f20ac983$exports);
}
$34c69bd8a346e2bb$exports = $34c69bd8a346e2bb$var$baseForOwn;


var $d5d90ceb4314d0a2$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d5d90ceb4314d0a2$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$70a87f3bd796a6cd$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$d5d90ceb4314d0a2$exports = $d5d90ceb4314d0a2$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $f1008ccff5feed7a$var$baseEach = $d5d90ceb4314d0a2$exports($34c69bd8a346e2bb$exports);
$f1008ccff5feed7a$exports = $f1008ccff5feed7a$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $bd274b9519243073$var$baseMap(collection, iteratee) {
    var index = -1, result = $70a87f3bd796a6cd$exports(collection) ? Array(collection.length) : [];
    $f1008ccff5feed7a$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$bd274b9519243073$exports = $bd274b9519243073$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $19c32bf6b9804e62$var$map(collection, iteratee) {
    var func = $46116793eaa02c32$exports(collection) ? $9fd738eaa74f3638$exports : $bd274b9519243073$exports;
    return func(collection, $6aa52744a9ab51b8$exports(iteratee, 3));
}
$19c32bf6b9804e62$exports = $19c32bf6b9804e62$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $ce626f03865ef5d1$var$flatMap(collection, iteratee) {
    return $dcd699742a532aa9$exports($19c32bf6b9804e62$exports(collection, iteratee), 1);
}
$ce626f03865ef5d1$exports = $ce626f03865ef5d1$var$flatMap;



var $dba9b32de817c336$exports = {};
var $4ee66e75fa6423f9$exports = {};
var $52811d56a7e00a58$exports = {};
var $191e618a80d2ac3e$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $191e618a80d2ac3e$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$191e618a80d2ac3e$exports = $191e618a80d2ac3e$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $52811d56a7e00a58$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $191e618a80d2ac3e$exports(array, start, end);
}
$52811d56a7e00a58$exports = $52811d56a7e00a58$var$castSlice;


var $08c6de7647e49cf0$exports = {};
/** Used to compose unicode character classes. */ var $08c6de7647e49cf0$var$rsAstralRange = '\\ud800-\\udfff', $08c6de7647e49cf0$var$rsComboMarksRange = '\\u0300-\\u036f', $08c6de7647e49cf0$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $08c6de7647e49cf0$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $08c6de7647e49cf0$var$rsComboRange = $08c6de7647e49cf0$var$rsComboMarksRange + $08c6de7647e49cf0$var$reComboHalfMarksRange + $08c6de7647e49cf0$var$rsComboSymbolsRange, $08c6de7647e49cf0$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $08c6de7647e49cf0$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $08c6de7647e49cf0$var$reHasUnicode = RegExp('[' + $08c6de7647e49cf0$var$rsZWJ + $08c6de7647e49cf0$var$rsAstralRange + $08c6de7647e49cf0$var$rsComboRange + $08c6de7647e49cf0$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $08c6de7647e49cf0$var$hasUnicode(string) {
    return $08c6de7647e49cf0$var$reHasUnicode.test(string);
}
$08c6de7647e49cf0$exports = $08c6de7647e49cf0$var$hasUnicode;


var $e44dd93306bd922d$exports = {};
var $7be5b911880c1538$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7be5b911880c1538$var$asciiToArray(string) {
    return string.split('');
}
$7be5b911880c1538$exports = $7be5b911880c1538$var$asciiToArray;



var $993c3276db17f461$exports = {};
/** Used to compose unicode character classes. */ var $993c3276db17f461$var$rsAstralRange = '\\ud800-\\udfff', $993c3276db17f461$var$rsComboMarksRange = '\\u0300-\\u036f', $993c3276db17f461$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $993c3276db17f461$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $993c3276db17f461$var$rsComboRange = $993c3276db17f461$var$rsComboMarksRange + $993c3276db17f461$var$reComboHalfMarksRange + $993c3276db17f461$var$rsComboSymbolsRange, $993c3276db17f461$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $993c3276db17f461$var$rsAstral = '[' + $993c3276db17f461$var$rsAstralRange + ']', $993c3276db17f461$var$rsCombo = '[' + $993c3276db17f461$var$rsComboRange + ']', $993c3276db17f461$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $993c3276db17f461$var$rsModifier = '(?:' + $993c3276db17f461$var$rsCombo + '|' + $993c3276db17f461$var$rsFitz + ')', $993c3276db17f461$var$rsNonAstral = '[^' + $993c3276db17f461$var$rsAstralRange + ']', $993c3276db17f461$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $993c3276db17f461$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $993c3276db17f461$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $993c3276db17f461$var$reOptMod = $993c3276db17f461$var$rsModifier + '?', $993c3276db17f461$var$rsOptVar = '[' + $993c3276db17f461$var$rsVarRange + ']?', $993c3276db17f461$var$rsOptJoin = '(?:' + $993c3276db17f461$var$rsZWJ + '(?:' + [
    $993c3276db17f461$var$rsNonAstral,
    $993c3276db17f461$var$rsRegional,
    $993c3276db17f461$var$rsSurrPair
].join('|') + ')' + $993c3276db17f461$var$rsOptVar + $993c3276db17f461$var$reOptMod + ')*', $993c3276db17f461$var$rsSeq = $993c3276db17f461$var$rsOptVar + $993c3276db17f461$var$reOptMod + $993c3276db17f461$var$rsOptJoin, $993c3276db17f461$var$rsSymbol = '(?:' + [
    $993c3276db17f461$var$rsNonAstral + $993c3276db17f461$var$rsCombo + '?',
    $993c3276db17f461$var$rsCombo,
    $993c3276db17f461$var$rsRegional,
    $993c3276db17f461$var$rsSurrPair,
    $993c3276db17f461$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $993c3276db17f461$var$reUnicode = RegExp($993c3276db17f461$var$rsFitz + '(?=' + $993c3276db17f461$var$rsFitz + ')|' + $993c3276db17f461$var$rsSymbol + $993c3276db17f461$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $993c3276db17f461$var$unicodeToArray(string) {
    return string.match($993c3276db17f461$var$reUnicode) || [];
}
$993c3276db17f461$exports = $993c3276db17f461$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $e44dd93306bd922d$var$stringToArray(string) {
    return $08c6de7647e49cf0$exports(string) ? $993c3276db17f461$exports(string) : $7be5b911880c1538$exports(string);
}
$e44dd93306bd922d$exports = $e44dd93306bd922d$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $4ee66e75fa6423f9$var$createCaseFirst(methodName) {
    return function(string) {
        string = $2854456ba4e51b7a$exports(string);
        var strSymbols = $08c6de7647e49cf0$exports(string) ? $e44dd93306bd922d$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $52811d56a7e00a58$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$4ee66e75fa6423f9$exports = $4ee66e75fa6423f9$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $dba9b32de817c336$var$upperFirst = $4ee66e75fa6423f9$exports('toUpperCase');
$dba9b32de817c336$exports = $dba9b32de817c336$var$upperFirst;


var $5443d49d3d139f56$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $5443d49d3d139f56$var$isEqual(value, other) {
    return $319a4f523286b934$exports(value, other);
}
$5443d49d3d139f56$exports = $5443d49d3d139f56$var$isEqual;


var $0082dfda2c4d7cdc$exports = {};

var $abf6d9273e7929f9$exports = {};




var $3af2638337ba382f$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $3af2638337ba382f$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$3af2638337ba382f$exports = $3af2638337ba382f$var$baseSortBy;



var $602519c54e4e091b$exports = {};
var $0251941a81a84b5d$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $0251941a81a84b5d$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $8fab81ce33077160$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $8fab81ce33077160$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$0251941a81a84b5d$exports = $0251941a81a84b5d$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $602519c54e4e091b$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $0251941a81a84b5d$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$602519c54e4e091b$exports = $602519c54e4e091b$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $abf6d9273e7929f9$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $9fd738eaa74f3638$exports(iteratees, function(iteratee) {
        if ($46116793eaa02c32$exports(iteratee)) return function(value) {
            return $1378bbdee3372fdb$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $5cab5b412769001e$exports
    ];
    var index = -1;
    iteratees = $9fd738eaa74f3638$exports(iteratees, $6c87d2ec7a5b64db$exports($6aa52744a9ab51b8$exports));
    var result = $bd274b9519243073$exports(collection, function(value, key, collection) {
        var criteria = $9fd738eaa74f3638$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $3af2638337ba382f$exports(result, function(object, other) {
        return $602519c54e4e091b$exports(object, other, orders);
    });
}
$abf6d9273e7929f9$exports = $abf6d9273e7929f9$var$baseOrderBy;


var $61c73e9686c610a8$exports = {};

var $c82c120815c1c8ae$exports = {};
var $658c040200873e47$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $658c040200873e47$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$658c040200873e47$exports = $658c040200873e47$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $c82c120815c1c8ae$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $c82c120815c1c8ae$var$overRest(func, start, transform) {
    start = $c82c120815c1c8ae$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $c82c120815c1c8ae$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $658c040200873e47$exports(func, this, otherArgs);
    };
}
$c82c120815c1c8ae$exports = $c82c120815c1c8ae$var$overRest;


var $21a1f32b1e81f677$exports = {};
var $9a46bbf5bbe44fa4$exports = {};
var $2c613fe635aa8c20$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $2c613fe635aa8c20$var$constant(value) {
    return function() {
        return value;
    };
}
$2c613fe635aa8c20$exports = $2c613fe635aa8c20$var$constant;


var $aa9927229ed34ba4$exports = {};

var $aa9927229ed34ba4$var$defineProperty = function() {
    try {
        var func = $7f56803878bcc7da$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$aa9927229ed34ba4$exports = $aa9927229ed34ba4$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $9a46bbf5bbe44fa4$var$baseSetToString = !$aa9927229ed34ba4$exports ? $5cab5b412769001e$exports : function(func, string) {
    return $aa9927229ed34ba4$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $2c613fe635aa8c20$exports(string),
        'writable': true
    });
};
$9a46bbf5bbe44fa4$exports = $9a46bbf5bbe44fa4$var$baseSetToString;


var $9c556a97cef624ca$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $9c556a97cef624ca$var$HOT_COUNT = 800, $9c556a97cef624ca$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9c556a97cef624ca$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $9c556a97cef624ca$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $9c556a97cef624ca$var$nativeNow(), remaining = $9c556a97cef624ca$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $9c556a97cef624ca$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$9c556a97cef624ca$exports = $9c556a97cef624ca$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $21a1f32b1e81f677$var$setToString = $9c556a97cef624ca$exports($9a46bbf5bbe44fa4$exports);
$21a1f32b1e81f677$exports = $21a1f32b1e81f677$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $61c73e9686c610a8$var$baseRest(func, start) {
    return $21a1f32b1e81f677$exports($c82c120815c1c8ae$exports(func, start, $5cab5b412769001e$exports), func + '');
}
$61c73e9686c610a8$exports = $61c73e9686c610a8$var$baseRest;


var $b4e75ea659f79f53$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $b4e75ea659f79f53$var$isIterateeCall(value, index, object) {
    if (!$4679825e1cdd07bc$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $70a87f3bd796a6cd$exports(object) && $ea7b709b198a2835$exports(index, object.length) : type == 'string' && index in object) return $59abe4f1dde57d22$exports(object[index], value);
    return false;
}
$b4e75ea659f79f53$exports = $b4e75ea659f79f53$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $0082dfda2c4d7cdc$var$sortBy = $61c73e9686c610a8$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $b4e75ea659f79f53$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $b4e75ea659f79f53$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $abf6d9273e7929f9$exports(collection, $dcd699742a532aa9$exports(iteratees, 1), []);
});
$0082dfda2c4d7cdc$exports = $0082dfda2c4d7cdc$var$sortBy;


var $bce74eef350a6fa0$exports = {};
(function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $bce74eef350a6fa0$exports) $bce74eef350a6fa0$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($bce74eef350a6fa0$exports);


function $a06b64c01280796f$var$_toConsumableArray(arr) {
    return $a06b64c01280796f$var$_arrayWithoutHoles(arr) || $a06b64c01280796f$var$_iterableToArray(arr) || $a06b64c01280796f$var$_unsupportedIterableToArray(arr) || $a06b64c01280796f$var$_nonIterableSpread();
}
function $a06b64c01280796f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a06b64c01280796f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a06b64c01280796f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a06b64c01280796f$var$_arrayLikeToArray(o, minLen);
}
function $a06b64c01280796f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $a06b64c01280796f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a06b64c01280796f$var$_arrayLikeToArray(arr);
}
function $a06b64c01280796f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $a06b64c01280796f$var$identity = function identity(i) {
    return i;
};
var $a06b64c01280796f$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $a06b64c01280796f$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $a06b64c01280796f$export$ca73b6d700d0505;
};
var $a06b64c01280796f$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $a06b64c01280796f$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $a06b64c01280796f$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $a06b64c01280796f$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $a06b64c01280796f$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $a06b64c01280796f$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $a06b64c01280796f$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $a06b64c01280796f$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $a06b64c01280796f$export$c3095a23b368d1f2 = function curry(fn) {
    return $a06b64c01280796f$var$curryN(fn.length, fn);
};
var $a06b64c01280796f$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $a06b64c01280796f$export$871de8747c9eaa88 = $a06b64c01280796f$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $a06b64c01280796f$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $a06b64c01280796f$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $a06b64c01280796f$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $a06b64c01280796f$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $112b038b80f65489$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $112b038b80f65489$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $112b038b80f65489$var$interpolateNumber = (0, $a06b64c01280796f$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $112b038b80f65489$var$uninterpolateNumber = (0, $a06b64c01280796f$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $112b038b80f65489$var$uninterpolateTruncation = (0, $a06b64c01280796f$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $112b038b80f65489$export$2e2bcd8739ae039 = {
    rangeStep: $112b038b80f65489$var$rangeStep,
    getDigitCount: $112b038b80f65489$var$getDigitCount,
    interpolateNumber: $112b038b80f65489$var$interpolateNumber,
    uninterpolateNumber: $112b038b80f65489$var$uninterpolateNumber,
    uninterpolateTruncation: $112b038b80f65489$var$uninterpolateTruncation
};


function $c8245f9d62e1c71a$var$_toConsumableArray(arr) {
    return $c8245f9d62e1c71a$var$_arrayWithoutHoles(arr) || $c8245f9d62e1c71a$var$_iterableToArray(arr) || $c8245f9d62e1c71a$var$_unsupportedIterableToArray(arr) || $c8245f9d62e1c71a$var$_nonIterableSpread();
}
function $c8245f9d62e1c71a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c8245f9d62e1c71a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c8245f9d62e1c71a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c8245f9d62e1c71a$var$_arrayLikeToArray(arr);
}
function $c8245f9d62e1c71a$var$_slicedToArray(arr, i) {
    return $c8245f9d62e1c71a$var$_arrayWithHoles(arr) || $c8245f9d62e1c71a$var$_iterableToArrayLimit(arr, i) || $c8245f9d62e1c71a$var$_unsupportedIterableToArray(arr, i) || $c8245f9d62e1c71a$var$_nonIterableRest();
}
function $c8245f9d62e1c71a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c8245f9d62e1c71a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c8245f9d62e1c71a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c8245f9d62e1c71a$var$_arrayLikeToArray(o, minLen);
}
function $c8245f9d62e1c71a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c8245f9d62e1c71a$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c8245f9d62e1c71a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $c8245f9d62e1c71a$var$getValidInterval(_ref) {
    var _ref2 = $c8245f9d62e1c71a$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $c8245f9d62e1c71a$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0);
    var digitCount = (0, $112b038b80f65489$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $c8245f9d62e1c71a$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(10).pow((0, $112b038b80f65489$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $a06b64c01280796f$export$f672e0b6f7222cd7)((0, $a06b64c01280796f$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $a06b64c01280796f$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $c8245f9d62e1c71a$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $c8245f9d62e1c71a$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $c8245f9d62e1c71a$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $c8245f9d62e1c71a$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $c8245f9d62e1c71a$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $c8245f9d62e1c71a$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $c8245f9d62e1c71a$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($c8245f9d62e1c71a$var$_toConsumableArray((0, $a06b64c01280796f$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($c8245f9d62e1c71a$var$_toConsumableArray((0, $a06b64c01280796f$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $a06b64c01280796f$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $c8245f9d62e1c71a$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $c8245f9d62e1c71a$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $112b038b80f65489$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $a06b64c01280796f$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $c8245f9d62e1c71a$var$getTickValuesFn(_ref5) {
    var _ref6 = $c8245f9d62e1c71a$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $c8245f9d62e1c71a$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $c8245f9d62e1c71a$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $c8245f9d62e1c71a$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $c8245f9d62e1c71a$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $a06b64c01280796f$export$f672e0b6f7222cd7)((0, $a06b64c01280796f$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(n).mul(step)).toNumber();
    }), (0, $a06b64c01280796f$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $a06b64c01280796f$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $c8245f9d62e1c71a$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $c8245f9d62e1c71a$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $c8245f9d62e1c71a$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $c8245f9d62e1c71a$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $c8245f9d62e1c71a$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($c8245f9d62e1c71a$var$_toConsumableArray((0, $112b038b80f65489$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $a06b64c01280796f$export$66c1ae025e96b4bc)(values) : values;
}
var $c8245f9d62e1c71a$export$b84e75ccbfe6a612 = (0, $a06b64c01280796f$export$fc10aeed3a532e2a)($c8245f9d62e1c71a$var$getNiceTickValuesFn);
var $c8245f9d62e1c71a$export$4cc7a216492b1f53 = (0, $a06b64c01280796f$export$fc10aeed3a532e2a)($c8245f9d62e1c71a$var$getTickValuesFn);
var $c8245f9d62e1c71a$export$e9d28da780436e98 = (0, $a06b64c01280796f$export$fc10aeed3a532e2a)($c8245f9d62e1c71a$var$getTickValuesFixedDomainFn);





var $8nGP5 = parcelRequire("8nGP5");
var $0c84d2c5e90079cb$var$isProduction = true;
var $0c84d2c5e90079cb$var$prefix = 'Invariant failed';
function $0c84d2c5e90079cb$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($0c84d2c5e90079cb$var$isProduction) throw new Error($0c84d2c5e90079cb$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($0c84d2c5e90079cb$var$prefix, ": ").concat(provided) : $0c84d2c5e90079cb$var$prefix;
    throw new Error(value);
}



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");

var $9147c7844befd856$var$_excluded = [
    "children",
    "className"
];
function $9147c7844befd856$var$_extends() {
    $9147c7844befd856$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9147c7844befd856$var$_extends.apply(this, arguments);
}
function $9147c7844befd856$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9147c7844befd856$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9147c7844befd856$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9147c7844befd856$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $9147c7844befd856$var$_objectWithoutProperties(props, $9147c7844befd856$var$_excluded);
    var layerClass = (0, $ajIhI.default)('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", $9147c7844befd856$var$_extends({
        className: layerClass
    }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $d0e02a4abf979d13$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $d0e02a4abf979d13$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d0e02a4abf979d13$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d0e02a4abf979d13$var$_typeof(o);
}
function $d0e02a4abf979d13$var$_extends() {
    $d0e02a4abf979d13$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d0e02a4abf979d13$var$_extends.apply(this, arguments);
}
function $d0e02a4abf979d13$var$_slicedToArray(arr, i) {
    return $d0e02a4abf979d13$var$_arrayWithHoles(arr) || $d0e02a4abf979d13$var$_iterableToArrayLimit(arr, i) || $d0e02a4abf979d13$var$_unsupportedIterableToArray(arr, i) || $d0e02a4abf979d13$var$_nonIterableRest();
}
function $d0e02a4abf979d13$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d0e02a4abf979d13$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d0e02a4abf979d13$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d0e02a4abf979d13$var$_arrayLikeToArray(o, minLen);
}
function $d0e02a4abf979d13$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d0e02a4abf979d13$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d0e02a4abf979d13$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d0e02a4abf979d13$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d0e02a4abf979d13$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d0e02a4abf979d13$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d0e02a4abf979d13$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d0e02a4abf979d13$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d0e02a4abf979d13$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d0e02a4abf979d13$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d0e02a4abf979d13$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d0e02a4abf979d13$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d0e02a4abf979d13$var$_callSuper(t, o, e) {
    return o = $d0e02a4abf979d13$var$_getPrototypeOf(o), $d0e02a4abf979d13$var$_possibleConstructorReturn(t, $d0e02a4abf979d13$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $d0e02a4abf979d13$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $d0e02a4abf979d13$var$_possibleConstructorReturn(self, call) {
    if (call && ($d0e02a4abf979d13$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d0e02a4abf979d13$var$_assertThisInitialized(self);
}
function $d0e02a4abf979d13$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d0e02a4abf979d13$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d0e02a4abf979d13$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d0e02a4abf979d13$var$_getPrototypeOf(o) {
    $d0e02a4abf979d13$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d0e02a4abf979d13$var$_getPrototypeOf(o);
}
function $d0e02a4abf979d13$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d0e02a4abf979d13$var$_setPrototypeOf(subClass, superClass);
}
function $d0e02a4abf979d13$var$_setPrototypeOf(o, p) {
    $d0e02a4abf979d13$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d0e02a4abf979d13$var$_setPrototypeOf(o, p);
}
function $d0e02a4abf979d13$var$_defineProperty(obj, key, value) {
    key = $d0e02a4abf979d13$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d0e02a4abf979d13$var$_toPropertyKey(t) {
    var i = $d0e02a4abf979d13$var$_toPrimitive(t, "string");
    return "symbol" == $d0e02a4abf979d13$var$_typeof(i) ? i : i + "";
}
function $d0e02a4abf979d13$var$_toPrimitive(t, r) {
    if ("object" != $d0e02a4abf979d13$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d0e02a4abf979d13$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d0e02a4abf979d13$export$4f4d7676bdf949e5 = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        $d0e02a4abf979d13$var$_classCallCheck(this, ErrorBar);
        return $d0e02a4abf979d13$var$_callSuper(this, ErrorBar, arguments);
    }
    $d0e02a4abf979d13$var$_inherits(ErrorBar, _React$Component);
    return $d0e02a4abf979d13$var$_createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = $d0e02a4abf979d13$var$_objectWithoutProperties(_this$props, $d0e02a4abf979d13$var$_excluded);
                var svgProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, false);
                !!(this.props.direction === 'x' && xAxis.type !== 'number') && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = $d0e02a4abf979d13$var$_slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === 'vertical') {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === 'horizontal') {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $d0e02a4abf979d13$var$_extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", $d0e02a4abf979d13$var$_extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$d0e02a4abf979d13$var$_defineProperty($d0e02a4abf979d13$export$4f4d7676bdf949e5, "defaultProps", {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
});
$d0e02a4abf979d13$var$_defineProperty($d0e02a4abf979d13$export$4f4d7676bdf949e5, "displayName", 'ErrorBar');





var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");


var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");

var $ed0c2f2ddc9d58cd$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $ed0c2f2ddc9d58cd$var$_extends() {
    $ed0c2f2ddc9d58cd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed0c2f2ddc9d58cd$var$_extends.apply(this, arguments);
}
function $ed0c2f2ddc9d58cd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ed0c2f2ddc9d58cd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ed0c2f2ddc9d58cd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ed0c2f2ddc9d58cd$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $ed0c2f2ddc9d58cd$var$_objectWithoutProperties(props, $ed0c2f2ddc9d58cd$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $ajIhI.default)('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("svg", $ed0c2f2ddc9d58cd$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("desc", null, desc), children);
}



var $8nGP5 = parcelRequire("8nGP5");



var $ajIhI = parcelRequire("ajIhI");

function $1a06a1b516e783f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1a06a1b516e783f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1a06a1b516e783f8$var$_typeof(o);
}
var $1a06a1b516e783f8$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $1a06a1b516e783f8$var$_extends() {
    $1a06a1b516e783f8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a06a1b516e783f8$var$_extends.apply(this, arguments);
}
function $1a06a1b516e783f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a06a1b516e783f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a06a1b516e783f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1a06a1b516e783f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a06a1b516e783f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1a06a1b516e783f8$var$_defineProperty(obj, key, value) {
    key = $1a06a1b516e783f8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1a06a1b516e783f8$var$_toPropertyKey(t) {
    var i = $1a06a1b516e783f8$var$_toPrimitive(t, "string");
    return "symbol" == $1a06a1b516e783f8$var$_typeof(i) ? i : i + "";
}
function $1a06a1b516e783f8$var$_toPrimitive(t, r) {
    if ("object" != $1a06a1b516e783f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1a06a1b516e783f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1a06a1b516e783f8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1a06a1b516e783f8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1a06a1b516e783f8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1a06a1b516e783f8$var$symbolFactories = {
    symbolCircle: (0, $4efdaf596664c2fb$exports.symbolCircle),
    symbolCross: (0, $4efdaf596664c2fb$exports.symbolCross),
    symbolDiamond: (0, $4efdaf596664c2fb$exports.symbolDiamond),
    symbolSquare: (0, $4efdaf596664c2fb$exports.symbolSquare),
    symbolStar: (0, $4efdaf596664c2fb$exports.symbolStar),
    symbolTriangle: (0, $4efdaf596664c2fb$exports.symbolTriangle),
    symbolWye: (0, $4efdaf596664c2fb$exports.symbolWye)
};
var $1a06a1b516e783f8$var$RADIAN = Math.PI / 180;
var $1a06a1b516e783f8$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($dba9b32de817c336$exports)))(type));
    return $1a06a1b516e783f8$var$symbolFactories[name] || (0, $4efdaf596664c2fb$exports.symbolCircle);
};
var $1a06a1b516e783f8$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $1a06a1b516e783f8$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $1a06a1b516e783f8$var$registerSymbol = function registerSymbol(key, factory) {
    $1a06a1b516e783f8$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($dba9b32de817c336$exports)))(key))] = factory;
};
var $1a06a1b516e783f8$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = $1a06a1b516e783f8$var$_objectWithoutProperties(_ref, $1a06a1b516e783f8$var$_excluded);
    var props = $1a06a1b516e783f8$var$_objectSpread($1a06a1b516e783f8$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $1a06a1b516e783f8$var$getSymbolFactory(type);
        var symbol = (0, $4efdaf596664c2fb$exports.symbol)().type(symbolFactory).size($1a06a1b516e783f8$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $1a06a1b516e783f8$var$_extends({}, filteredProps, {
        className: (0, $ajIhI.default)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$1a06a1b516e783f8$export$fa456266707bf4e4.registerSymbol = $1a06a1b516e783f8$var$registerSymbol;



function $9367d502c40c9dd9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9367d502c40c9dd9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9367d502c40c9dd9$var$_typeof(o);
}
function $9367d502c40c9dd9$var$_extends() {
    $9367d502c40c9dd9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9367d502c40c9dd9$var$_extends.apply(this, arguments);
}
function $9367d502c40c9dd9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9367d502c40c9dd9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9367d502c40c9dd9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9367d502c40c9dd9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9367d502c40c9dd9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9367d502c40c9dd9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9367d502c40c9dd9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9367d502c40c9dd9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9367d502c40c9dd9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9367d502c40c9dd9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9367d502c40c9dd9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9367d502c40c9dd9$var$_callSuper(t, o, e) {
    return o = $9367d502c40c9dd9$var$_getPrototypeOf(o), $9367d502c40c9dd9$var$_possibleConstructorReturn(t, $9367d502c40c9dd9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $9367d502c40c9dd9$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $9367d502c40c9dd9$var$_possibleConstructorReturn(self, call) {
    if (call && ($9367d502c40c9dd9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9367d502c40c9dd9$var$_assertThisInitialized(self);
}
function $9367d502c40c9dd9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9367d502c40c9dd9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9367d502c40c9dd9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9367d502c40c9dd9$var$_getPrototypeOf(o) {
    $9367d502c40c9dd9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9367d502c40c9dd9$var$_getPrototypeOf(o);
}
function $9367d502c40c9dd9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9367d502c40c9dd9$var$_setPrototypeOf(subClass, superClass);
}
function $9367d502c40c9dd9$var$_setPrototypeOf(o, p) {
    $9367d502c40c9dd9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9367d502c40c9dd9$var$_setPrototypeOf(o, p);
}
function $9367d502c40c9dd9$var$_defineProperty(obj, key, value) {
    key = $9367d502c40c9dd9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9367d502c40c9dd9$var$_toPropertyKey(t) {
    var i = $9367d502c40c9dd9$var$_toPrimitive(t, "string");
    return "symbol" == $9367d502c40c9dd9$var$_typeof(i) ? i : i + "";
}
function $9367d502c40c9dd9$var$_toPrimitive(t, r) {
    if ("object" != $9367d502c40c9dd9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9367d502c40c9dd9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9367d502c40c9dd9$var$SIZE = 32;
var $9367d502c40c9dd9$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        $9367d502c40c9dd9$var$_classCallCheck(this, DefaultLegendContent);
        return $9367d502c40c9dd9$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $9367d502c40c9dd9$var$_inherits(DefaultLegendContent, _PureComponent);
    return $9367d502c40c9dd9$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $9367d502c40c9dd9$var$SIZE / 2;
                var sixthSize = $9367d502c40c9dd9$var$SIZE / 6;
                var thirdSize = $9367d502c40c9dd9$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $9367d502c40c9dd9$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($9367d502c40c9dd9$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($9367d502c40c9dd9$var$SIZE / 8, "h").concat($9367d502c40c9dd9$var$SIZE, "v").concat($9367d502c40c9dd9$var$SIZE * 3 / 4, "h").concat(-$9367d502c40c9dd9$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(data.legendIcon)) {
                    var iconProps = $9367d502c40c9dd9$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1a06a1b516e783f8$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $9367d502c40c9dd9$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $9367d502c40c9dd9$var$SIZE,
                    height: $9367d502c40c9dd9$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $ajIhI.default)($9367d502c40c9dd9$var$_defineProperty($9367d502c40c9dd9$var$_defineProperty({
                        'recharts-legend-item': true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(entry.value) ? entry.value : null;
                    (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("li", $9367d502c40c9dd9$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $f1d44a0cc6cff721$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ed0c2f2ddc9d58cd$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$9367d502c40c9dd9$var$_defineProperty($9367d502c40c9dd9$export$99f8d96ed0cededa, "displayName", 'Legend');
$9367d502c40c9dd9$var$_defineProperty($9367d502c40c9dd9$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



var $40ad740a6014714b$exports = {};

var $a06e18c8dbcabb91$exports = {};

var $3bc11f46233f5100$exports = {};
var $9b098515d7eeae5d$exports = {};
var $ecf86b262255e231$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ecf86b262255e231$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$ecf86b262255e231$exports = $ecf86b262255e231$var$baseFindIndex;


var $f70a71a1b152b764$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $f70a71a1b152b764$var$baseIsNaN(value) {
    return value !== value;
}
$f70a71a1b152b764$exports = $f70a71a1b152b764$var$baseIsNaN;


var $70917896206e833e$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $70917896206e833e$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$70917896206e833e$exports = $70917896206e833e$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $9b098515d7eeae5d$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $70917896206e833e$exports(array, value, fromIndex) : $ecf86b262255e231$exports(array, $f70a71a1b152b764$exports, fromIndex);
}
$9b098515d7eeae5d$exports = $9b098515d7eeae5d$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $3bc11f46233f5100$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $9b098515d7eeae5d$exports(array, value, 0) > -1;
}
$3bc11f46233f5100$exports = $3bc11f46233f5100$var$arrayIncludes;


var $557571bb1a129035$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $557571bb1a129035$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$557571bb1a129035$exports = $557571bb1a129035$var$arrayIncludesWith;



var $0e7b9f08e7c4736f$exports = {};

var $77935f72c4f64c88$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $77935f72c4f64c88$var$noop() {
// No operation performed.
}
$77935f72c4f64c88$exports = $77935f72c4f64c88$var$noop;



/** Used as references for various `Number` constants. */ var $0e7b9f08e7c4736f$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $0e7b9f08e7c4736f$var$createSet = !($4c1a03e269fbabc9$exports && 1 / $1360f177952adc80$exports(new $4c1a03e269fbabc9$exports([
    ,
    -0
]))[1] == $0e7b9f08e7c4736f$var$INFINITY) ? $77935f72c4f64c88$exports : function(values) {
    return new $4c1a03e269fbabc9$exports(values);
};
$0e7b9f08e7c4736f$exports = $0e7b9f08e7c4736f$var$createSet;



/** Used as the size to enable large array optimizations. */ var $a06e18c8dbcabb91$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $a06e18c8dbcabb91$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $3bc11f46233f5100$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $557571bb1a129035$exports;
    } else if (length >= $a06e18c8dbcabb91$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $0e7b9f08e7c4736f$exports(array);
        if (set) return $1360f177952adc80$exports(set);
        isCommon = false;
        includes = $e5e703715ca3ea7c$exports;
        seen = new $d2c49809ad6e170e$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$a06e18c8dbcabb91$exports = $a06e18c8dbcabb91$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $40ad740a6014714b$var$uniqBy(array, iteratee) {
    return array && array.length ? $a06e18c8dbcabb91$exports(array, $6aa52744a9ab51b8$exports(iteratee, 2)) : [];
}
$40ad740a6014714b$exports = $40ad740a6014714b$var$uniqBy;



function $45b995e155031399$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($40ad740a6014714b$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($40ad740a6014714b$exports)))(payload, option);
    return payload;
}


function $06340f5273236c74$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $06340f5273236c74$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $06340f5273236c74$var$_typeof(o);
}
var $06340f5273236c74$var$_excluded = [
    "ref"
];
function $06340f5273236c74$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $06340f5273236c74$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $06340f5273236c74$var$ownKeys(Object(t), !0).forEach(function(r) {
            $06340f5273236c74$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $06340f5273236c74$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $06340f5273236c74$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $06340f5273236c74$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $06340f5273236c74$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $06340f5273236c74$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $06340f5273236c74$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $06340f5273236c74$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $06340f5273236c74$var$_callSuper(t, o, e) {
    return o = $06340f5273236c74$var$_getPrototypeOf(o), $06340f5273236c74$var$_possibleConstructorReturn(t, $06340f5273236c74$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $06340f5273236c74$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $06340f5273236c74$var$_possibleConstructorReturn(self, call) {
    if (call && ($06340f5273236c74$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $06340f5273236c74$var$_assertThisInitialized(self);
}
function $06340f5273236c74$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $06340f5273236c74$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($06340f5273236c74$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $06340f5273236c74$var$_getPrototypeOf(o) {
    $06340f5273236c74$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $06340f5273236c74$var$_getPrototypeOf(o);
}
function $06340f5273236c74$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $06340f5273236c74$var$_setPrototypeOf(subClass, superClass);
}
function $06340f5273236c74$var$_setPrototypeOf(o, p) {
    $06340f5273236c74$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $06340f5273236c74$var$_setPrototypeOf(o, p);
}
function $06340f5273236c74$var$_defineProperty(obj, key, value) {
    key = $06340f5273236c74$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $06340f5273236c74$var$_toPropertyKey(t) {
    var i = $06340f5273236c74$var$_toPrimitive(t, "string");
    return "symbol" == $06340f5273236c74$var$_typeof(i) ? i : i + "";
}
function $06340f5273236c74$var$_toPrimitive(t, r) {
    if ("object" != $06340f5273236c74$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $06340f5273236c74$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $06340f5273236c74$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $06340f5273236c74$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $06340f5273236c74$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $06340f5273236c74$var$defaultUniqBy(entry) {
    return entry.value;
}
function $06340f5273236c74$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(content, props);
    var ref = props.ref, otherProps = $06340f5273236c74$var$_objectWithoutProperties(props, $06340f5273236c74$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9367d502c40c9dd9$export$99f8d96ed0cededa), otherProps);
}
var $06340f5273236c74$var$EPS = 1;
var $06340f5273236c74$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        $06340f5273236c74$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $06340f5273236c74$var$_callSuper(this, Legend, [].concat(args));
        $06340f5273236c74$var$_defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $06340f5273236c74$var$_inherits(Legend, _PureComponent);
    return $06340f5273236c74$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $06340f5273236c74$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $06340f5273236c74$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $06340f5273236c74$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $06340f5273236c74$var$_objectSpread($06340f5273236c74$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $06340f5273236c74$var$_objectSpread($06340f5273236c74$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $06340f5273236c74$var$renderContent(content, $06340f5273236c74$var$_objectSpread($06340f5273236c74$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $45b995e155031399$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $06340f5273236c74$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = $06340f5273236c74$var$_objectSpread($06340f5273236c74$var$_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === 'vertical' && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$06340f5273236c74$var$_defineProperty($06340f5273236c74$export$ed247974535929c7, "displayName", 'Legend');
$06340f5273236c74$var$_defineProperty($06340f5273236c74$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});




function $3c595a89abddaa2c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3c595a89abddaa2c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3c595a89abddaa2c$var$_typeof(o);
}
function $3c595a89abddaa2c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c595a89abddaa2c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c595a89abddaa2c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3c595a89abddaa2c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c595a89abddaa2c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3c595a89abddaa2c$var$_defineProperty(obj, key, value) {
    key = $3c595a89abddaa2c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3c595a89abddaa2c$var$_toPropertyKey(t) {
    var i = $3c595a89abddaa2c$var$_toPrimitive(t, "string");
    return "symbol" == $3c595a89abddaa2c$var$_typeof(i) ? i : i + "";
}
function $3c595a89abddaa2c$var$_toPrimitive(t, r) {
    if ("object" != $3c595a89abddaa2c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3c595a89abddaa2c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3c595a89abddaa2c$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $06340f5273236c74$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendDefaultProps = (0, $06340f5273236c74$export$ed247974535929c7).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? $3c595a89abddaa2c$var$_objectSpread($3c595a89abddaa2c$var$_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? $3c595a89abddaa2c$var$_objectSpread($3c595a89abddaa2c$var$_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || 'square',
            color: (0, $cc31aced37ecb634$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return $3c595a89abddaa2c$var$_objectSpread($3c595a89abddaa2c$var$_objectSpread($3c595a89abddaa2c$var$_objectSpread({}, legendProps), (0, $06340f5273236c74$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $cc31aced37ecb634$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cc31aced37ecb634$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cc31aced37ecb634$var$_typeof(o);
}
function $cc31aced37ecb634$var$_toConsumableArray(arr) {
    return $cc31aced37ecb634$var$_arrayWithoutHoles(arr) || $cc31aced37ecb634$var$_iterableToArray(arr) || $cc31aced37ecb634$var$_unsupportedIterableToArray(arr) || $cc31aced37ecb634$var$_nonIterableSpread();
}
function $cc31aced37ecb634$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cc31aced37ecb634$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cc31aced37ecb634$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cc31aced37ecb634$var$_arrayLikeToArray(o, minLen);
}
function $cc31aced37ecb634$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cc31aced37ecb634$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cc31aced37ecb634$var$_arrayLikeToArray(arr);
}
function $cc31aced37ecb634$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cc31aced37ecb634$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc31aced37ecb634$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc31aced37ecb634$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cc31aced37ecb634$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc31aced37ecb634$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cc31aced37ecb634$var$_defineProperty(obj, key, value) {
    key = $cc31aced37ecb634$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cc31aced37ecb634$var$_toPropertyKey(t) {
    var i = $cc31aced37ecb634$var$_toPrimitive(t, "string");
    return "symbol" == $cc31aced37ecb634$var$_typeof(i) ? i : i + "";
}
function $cc31aced37ecb634$var$_toPrimitive(t, r) {
    if ("object" != $cc31aced37ecb634$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cc31aced37ecb634$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cc31aced37ecb634$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(dataKey)) return defaultValue;
    if ((0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $cc31aced37ecb634$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($ce626f03865ef5d1$exports)))(data, function(entry) {
        return $cc31aced37ecb634$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($68f8d6cfd642a3d7$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $cc31aced37ecb634$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(cur - before) !== (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(after - cur) === (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $cc31aced37ecb634$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $cc31aced37ecb634$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $8b99c43c69c5c37b$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(barSize) ? undefined : (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $cc31aced37ecb634$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($cc31aced37ecb634$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($cc31aced37ecb634$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $cc31aced37ecb634$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $3c595a89abddaa2c$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(offset[align])) return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, offset), {}, $cc31aced37ecb634$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(offset[verticalAlign])) return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, offset), {}, $cc31aced37ecb634$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $cc31aced37ecb634$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $cc31aced37ecb634$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $d0e02a4abf979d13$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $cc31aced37ecb634$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $cc31aced37ecb634$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($68f8d6cfd642a3d7$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $cc31aced37ecb634$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $cc31aced37ecb634$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $cc31aced37ecb634$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $cc31aced37ecb634$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $cc31aced37ecb634$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $cc31aced37ecb634$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $cc31aced37ecb634$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $cc31aced37ecb634$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $cc31aced37ecb634$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $cc31aced37ecb634$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $cc31aced37ecb634$var$handlerWeakMap = new WeakMap();
var $cc31aced37ecb634$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!$cc31aced37ecb634$var$handlerWeakMap.has(defaultHandler)) $cc31aced37ecb634$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $cc31aced37ecb634$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $cc31aced37ecb634$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $5389c27663bb3a0e$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $5389c27663bb3a0e$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $5389c27663bb3a0e$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $5389c27663bb3a0e$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $5389c27663bb3a0e$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($dba9b32de817c336$exports)))(scale));
        return {
            scale: ($5389c27663bb3a0e$exports[name] || $5389c27663bb3a0e$exports.scalePoint)(),
            realScaleType: $5389c27663bb3a0e$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $5389c27663bb3a0e$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $cc31aced37ecb634$var$EPS = 1e-4;
var $cc31aced37ecb634$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $cc31aced37ecb634$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $cc31aced37ecb634$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $cc31aced37ecb634$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $cc31aced37ecb634$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(domain[0]) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $cc31aced37ecb634$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $cc31aced37ecb634$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $cc31aced37ecb634$var$STACK_OFFSET_MAP = {
    sign: $cc31aced37ecb634$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $4efdaf596664c2fb$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $4efdaf596664c2fb$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $4efdaf596664c2fb$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $4efdaf596664c2fb$exports.stackOffsetWiggle),
    positive: $cc31aced37ecb634$export$9f2c6ead70935022
};
var $cc31aced37ecb634$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $cc31aced37ecb634$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $4efdaf596664c2fb$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$cc31aced37ecb634$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $4efdaf596664c2fb$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $cc31aced37ecb634$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, result), {}, $cc31aced37ecb634$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, res), {}, $cc31aced37ecb634$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $cc31aced37ecb634$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, result), {}, $cc31aced37ecb634$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $cc31aced37ecb634$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $c8245f9d62e1c71a$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($68f8d6cfd642a3d7$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $c8245f9d62e1c71a$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $cc31aced37ecb634$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $3d08f6c3b4eab1e3$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $cc31aced37ecb634$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(value) ? axis.scale(value) : null;
}
var $cc31aced37ecb634$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $cc31aced37ecb634$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $cc31aced37ecb634$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $cc31aced37ecb634$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $cc31aced37ecb634$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($68f8d6cfd642a3d7$exports)))(entry.concat([
                result[0]
            ]).filter((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(entry.concat([
                result[1]
            ]).filter((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $cc31aced37ecb634$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $cc31aced37ecb634$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $cc31aced37ecb634$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cc31aced37ecb634$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cc31aced37ecb634$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($cc31aced37ecb634$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$cc31aced37ecb634$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($cc31aced37ecb634$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$cc31aced37ecb634$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $cc31aced37ecb634$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($0082dfda2c4d7cdc$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $cc31aced37ecb634$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $cc31aced37ecb634$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $cc31aced37ecb634$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $cc31aced37ecb634$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};




var $863769adbc4b0799$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $863769adbc4b0799$export$98f03c5d19621d70 = {
    isSsr: $863769adbc4b0799$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $863769adbc4b0799$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $863769adbc4b0799$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $863769adbc4b0799$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};


function $afcbff65789b5460$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $afcbff65789b5460$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $afcbff65789b5460$var$_typeof(o);
}
function $afcbff65789b5460$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $afcbff65789b5460$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $afcbff65789b5460$var$ownKeys(Object(t), !0).forEach(function(r) {
            $afcbff65789b5460$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $afcbff65789b5460$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $afcbff65789b5460$var$_defineProperty(obj, key, value) {
    key = $afcbff65789b5460$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $afcbff65789b5460$var$_toPropertyKey(t) {
    var i = $afcbff65789b5460$var$_toPrimitive(t, "string");
    return "symbol" == $afcbff65789b5460$var$_typeof(i) ? i : i + "";
}
function $afcbff65789b5460$var$_toPrimitive(t, r) {
    if ("object" != $afcbff65789b5460$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $afcbff65789b5460$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $afcbff65789b5460$var$_toConsumableArray(arr) {
    return $afcbff65789b5460$var$_arrayWithoutHoles(arr) || $afcbff65789b5460$var$_iterableToArray(arr) || $afcbff65789b5460$var$_unsupportedIterableToArray(arr) || $afcbff65789b5460$var$_nonIterableSpread();
}
function $afcbff65789b5460$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $afcbff65789b5460$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $afcbff65789b5460$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $afcbff65789b5460$var$_arrayLikeToArray(o, minLen);
}
function $afcbff65789b5460$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $afcbff65789b5460$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $afcbff65789b5460$var$_arrayLikeToArray(arr);
}
function $afcbff65789b5460$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $afcbff65789b5460$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $afcbff65789b5460$var$MAX_CACHE_NUM = 2000;
var $afcbff65789b5460$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $afcbff65789b5460$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $afcbff65789b5460$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $afcbff65789b5460$var$autoCompleteStyle(name, value) {
    if ($afcbff65789b5460$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $afcbff65789b5460$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($afcbff65789b5460$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($afcbff65789b5460$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $afcbff65789b5460$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($afcbff65789b5460$var$camelToMiddleLine(s), ":").concat($afcbff65789b5460$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function $afcbff65789b5460$var$removeInvalidKeys(obj) {
    var copyObj = $afcbff65789b5460$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $afcbff65789b5460$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $afcbff65789b5460$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($afcbff65789b5460$var$stringCache.widthCache[cacheKey]) return $afcbff65789b5460$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($afcbff65789b5460$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $afcbff65789b5460$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $afcbff65789b5460$var$_objectSpread($afcbff65789b5460$var$_objectSpread({}, $afcbff65789b5460$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $afcbff65789b5460$var$stringCache.widthCache[cacheKey] = result;
        if (++$afcbff65789b5460$var$stringCache.cacheCount > $afcbff65789b5460$var$MAX_CACHE_NUM) {
            $afcbff65789b5460$var$stringCache.cacheCount = 0;
            $afcbff65789b5460$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $afcbff65789b5460$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};



var $55b7e71ec6654a57$exports = {};
var $2d2644df4cbe6c5b$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $2d2644df4cbe6c5b$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $aa9927229ed34ba4$exports) $aa9927229ed34ba4$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$2d2644df4cbe6c5b$exports = $2d2644df4cbe6c5b$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $55b7e71ec6654a57$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $6aa52744a9ab51b8$exports(iteratee, 3);
    $34c69bd8a346e2bb$exports(object, function(value, key, object) {
        $2d2644df4cbe6c5b$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$55b7e71ec6654a57$exports = $55b7e71ec6654a57$var$mapValues;


var $0a6c56731a98b599$exports = {};
var $59519f3b0613cc71$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $59519f3b0613cc71$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$59519f3b0613cc71$exports = $59519f3b0613cc71$var$arrayEvery;


var $d0ae2edd8b705e48$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $d0ae2edd8b705e48$var$baseEvery(collection, predicate) {
    var result = true;
    $f1008ccff5feed7a$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$d0ae2edd8b705e48$exports = $d0ae2edd8b705e48$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $0a6c56731a98b599$var$every(collection, predicate, guard) {
    var func = $46116793eaa02c32$exports(collection) ? $59519f3b0613cc71$exports : $d0ae2edd8b705e48$exports;
    if (guard && $b4e75ea659f79f53$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $6aa52744a9ab51b8$exports(predicate, 3));
}
$0a6c56731a98b599$exports = $0a6c56731a98b599$var$every;






var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");

var $8nGP5 = parcelRequire("8nGP5");

var $ebCsu = parcelRequire("ebCsu");
var $a22fa58636ba4c67$exports = {};
(function(global, factory) {
    factory($a22fa58636ba4c67$exports);
})($a22fa58636ba4c67$exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    var PREACT_VNODE = '__v';
    var PREACT_OWNER = '__o';
    var REACT_OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.entries();
        var aResult;
        var bResult;
        var index = 0;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                var aEntry = aResult.value;
                var bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ var areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var ERROR_TAG = '[object Error]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var URL_TAG = '[object URL]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areErrorsEqual = _a.areErrorsEqual, areFunctionsEqual = _a.areFunctionsEqual, areMapsEqual = _a.areMapsEqual, areNumbersEqual = _a.areNumbersEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual, areUrlsEqual = _a.areUrlsEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            var type = typeof a;
            if (type !== typeof b) return false;
            if (type !== 'object') {
                if (type === 'number') return areNumbersEqual(a, b, state);
                if (type === 'function') return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $5b6780dd94df09db$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $5b6780dd94df09db$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $5b6780dd94df09db$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $337e3951d7a8edb0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $337e3951d7a8edb0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $337e3951d7a8edb0$var$_typeof(o);
}
function $337e3951d7a8edb0$var$_toArray(arr) {
    return $337e3951d7a8edb0$var$_arrayWithHoles(arr) || $337e3951d7a8edb0$var$_iterableToArray(arr) || $337e3951d7a8edb0$var$_unsupportedIterableToArray(arr) || $337e3951d7a8edb0$var$_nonIterableRest();
}
function $337e3951d7a8edb0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $337e3951d7a8edb0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $337e3951d7a8edb0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $337e3951d7a8edb0$var$_arrayLikeToArray(o, minLen);
}
function $337e3951d7a8edb0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $337e3951d7a8edb0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $337e3951d7a8edb0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $337e3951d7a8edb0$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $337e3951d7a8edb0$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $5b6780dd94df09db$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $5b6780dd94df09db$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($337e3951d7a8edb0$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $ad14d613dac655bd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ad14d613dac655bd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ad14d613dac655bd$var$_typeof(o);
}
function $ad14d613dac655bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad14d613dac655bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad14d613dac655bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ad14d613dac655bd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad14d613dac655bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ad14d613dac655bd$var$_defineProperty(obj, key, value) {
    key = $ad14d613dac655bd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ad14d613dac655bd$var$_toPropertyKey(arg) {
    var key = $ad14d613dac655bd$var$_toPrimitive(arg, "string");
    return $ad14d613dac655bd$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ad14d613dac655bd$var$_toPrimitive(input, hint) {
    if ($ad14d613dac655bd$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ad14d613dac655bd$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $ad14d613dac655bd$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $ad14d613dac655bd$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $ad14d613dac655bd$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $ad14d613dac655bd$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $ad14d613dac655bd$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $ad14d613dac655bd$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $ad14d613dac655bd$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $ad14d613dac655bd$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $ad14d613dac655bd$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $ad14d613dac655bd$var$_objectSpread($ad14d613dac655bd$var$_objectSpread({}, res), {}, $ad14d613dac655bd$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $ad14d613dac655bd$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($ad14d613dac655bd$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $ad14d613dac655bd$var$isDev = false;
var $ad14d613dac655bd$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($ad14d613dac655bd$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $ec6c311f8a939cc0$var$_slicedToArray(arr, i) {
    return $ec6c311f8a939cc0$var$_arrayWithHoles(arr) || $ec6c311f8a939cc0$var$_iterableToArrayLimit(arr, i) || $ec6c311f8a939cc0$var$_unsupportedIterableToArray(arr, i) || $ec6c311f8a939cc0$var$_nonIterableRest();
}
function $ec6c311f8a939cc0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ec6c311f8a939cc0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ec6c311f8a939cc0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ec6c311f8a939cc0$var$_toConsumableArray(arr) {
    return $ec6c311f8a939cc0$var$_arrayWithoutHoles(arr) || $ec6c311f8a939cc0$var$_iterableToArray(arr) || $ec6c311f8a939cc0$var$_unsupportedIterableToArray(arr) || $ec6c311f8a939cc0$var$_nonIterableSpread();
}
function $ec6c311f8a939cc0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ec6c311f8a939cc0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ec6c311f8a939cc0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ec6c311f8a939cc0$var$_arrayLikeToArray(o, minLen);
}
function $ec6c311f8a939cc0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ec6c311f8a939cc0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ec6c311f8a939cc0$var$_arrayLikeToArray(arr);
}
function $ec6c311f8a939cc0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ec6c311f8a939cc0$var$ACCURACY = 1e-4;
var $ec6c311f8a939cc0$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $ec6c311f8a939cc0$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $ec6c311f8a939cc0$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $ec6c311f8a939cc0$var$cubicBezierFactor(c1, c2);
        return $ec6c311f8a939cc0$var$multyTime(params, t);
    };
};
var $ec6c311f8a939cc0$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $ec6c311f8a939cc0$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($ec6c311f8a939cc0$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $ec6c311f8a939cc0$var$multyTime(newParams, t);
    };
};
var $ec6c311f8a939cc0$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $ec6c311f8a939cc0$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $ad14d613dac655bd$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $ad14d613dac655bd$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $ec6c311f8a939cc0$var$cubicBezier(x1, x2);
    var curveY = $ec6c311f8a939cc0$var$cubicBezier(y1, y2);
    var derCurveX = $ec6c311f8a939cc0$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $ec6c311f8a939cc0$var$ACCURACY || derVal < $ec6c311f8a939cc0$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $ec6c311f8a939cc0$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $ec6c311f8a939cc0$var$ACCURACY && Math.abs(newV) < $ec6c311f8a939cc0$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $ec6c311f8a939cc0$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $ec6c311f8a939cc0$export$56c51296f72f0592(easing);
        case 'spring':
            return $ec6c311f8a939cc0$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $ec6c311f8a939cc0$export$56c51296f72f0592(easing);
            (0, $ad14d613dac655bd$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $ad14d613dac655bd$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $f61fc44e6cd0dd12$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f61fc44e6cd0dd12$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f61fc44e6cd0dd12$var$_typeof(o);
}
function $f61fc44e6cd0dd12$var$_toConsumableArray(arr) {
    return $f61fc44e6cd0dd12$var$_arrayWithoutHoles(arr) || $f61fc44e6cd0dd12$var$_iterableToArray(arr) || $f61fc44e6cd0dd12$var$_unsupportedIterableToArray(arr) || $f61fc44e6cd0dd12$var$_nonIterableSpread();
}
function $f61fc44e6cd0dd12$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f61fc44e6cd0dd12$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f61fc44e6cd0dd12$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f61fc44e6cd0dd12$var$_arrayLikeToArray(arr);
}
function $f61fc44e6cd0dd12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f61fc44e6cd0dd12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f61fc44e6cd0dd12$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f61fc44e6cd0dd12$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f61fc44e6cd0dd12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f61fc44e6cd0dd12$var$_defineProperty(obj, key, value) {
    key = $f61fc44e6cd0dd12$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f61fc44e6cd0dd12$var$_toPropertyKey(arg) {
    var key = $f61fc44e6cd0dd12$var$_toPrimitive(arg, "string");
    return $f61fc44e6cd0dd12$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f61fc44e6cd0dd12$var$_toPrimitive(input, hint) {
    if ($f61fc44e6cd0dd12$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f61fc44e6cd0dd12$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f61fc44e6cd0dd12$var$_slicedToArray(arr, i) {
    return $f61fc44e6cd0dd12$var$_arrayWithHoles(arr) || $f61fc44e6cd0dd12$var$_iterableToArrayLimit(arr, i) || $f61fc44e6cd0dd12$var$_unsupportedIterableToArray(arr, i) || $f61fc44e6cd0dd12$var$_nonIterableRest();
}
function $f61fc44e6cd0dd12$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f61fc44e6cd0dd12$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f61fc44e6cd0dd12$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f61fc44e6cd0dd12$var$_arrayLikeToArray(o, minLen);
}
function $f61fc44e6cd0dd12$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f61fc44e6cd0dd12$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f61fc44e6cd0dd12$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $f61fc44e6cd0dd12$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $f61fc44e6cd0dd12$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $f61fc44e6cd0dd12$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $ad14d613dac655bd$export$d6051a0f7a227332)(function(key, val) {
        if ($f61fc44e6cd0dd12$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $f61fc44e6cd0dd12$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $f61fc44e6cd0dd12$var$_objectSpread($f61fc44e6cd0dd12$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $ad14d613dac655bd$export$d6051a0f7a227332)(function(key, val) {
        if ($f61fc44e6cd0dd12$var$needContinue(val)) return $f61fc44e6cd0dd12$var$_objectSpread($f61fc44e6cd0dd12$var$_objectSpread({}, val), {}, {
            velocity: $f61fc44e6cd0dd12$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $f61fc44e6cd0dd12$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$f61fc44e6cd0dd12$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $ad14d613dac655bd$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $f61fc44e6cd0dd12$var$_objectSpread($f61fc44e6cd0dd12$var$_objectSpread({}, res), {}, $f61fc44e6cd0dd12$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $f61fc44e6cd0dd12$var$_objectSpread($f61fc44e6cd0dd12$var$_objectSpread({}, res), {}, $f61fc44e6cd0dd12$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $ad14d613dac655bd$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($f61fc44e6cd0dd12$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $f61fc44e6cd0dd12$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($f61fc44e6cd0dd12$var$_objectSpread($f61fc44e6cd0dd12$var$_objectSpread($f61fc44e6cd0dd12$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $ad14d613dac655bd$export$d6051a0f7a227332)(function(key, val) {
            return $f61fc44e6cd0dd12$var$alpha.apply(void 0, $f61fc44e6cd0dd12$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($f61fc44e6cd0dd12$var$_objectSpread($f61fc44e6cd0dd12$var$_objectSpread($f61fc44e6cd0dd12$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $ad14d613dac655bd$export$d6051a0f7a227332)(function(key, val) {
                return $f61fc44e6cd0dd12$var$alpha.apply(void 0, $f61fc44e6cd0dd12$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($f61fc44e6cd0dd12$var$_objectSpread($f61fc44e6cd0dd12$var$_objectSpread($f61fc44e6cd0dd12$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $fe388b12b6d97ad5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fe388b12b6d97ad5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fe388b12b6d97ad5$var$_typeof(o);
}
var $fe388b12b6d97ad5$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $fe388b12b6d97ad5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fe388b12b6d97ad5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fe388b12b6d97ad5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fe388b12b6d97ad5$var$_toConsumableArray(arr) {
    return $fe388b12b6d97ad5$var$_arrayWithoutHoles(arr) || $fe388b12b6d97ad5$var$_iterableToArray(arr) || $fe388b12b6d97ad5$var$_unsupportedIterableToArray(arr) || $fe388b12b6d97ad5$var$_nonIterableSpread();
}
function $fe388b12b6d97ad5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fe388b12b6d97ad5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fe388b12b6d97ad5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fe388b12b6d97ad5$var$_arrayLikeToArray(o, minLen);
}
function $fe388b12b6d97ad5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $fe388b12b6d97ad5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $fe388b12b6d97ad5$var$_arrayLikeToArray(arr);
}
function $fe388b12b6d97ad5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fe388b12b6d97ad5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe388b12b6d97ad5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe388b12b6d97ad5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fe388b12b6d97ad5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe388b12b6d97ad5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fe388b12b6d97ad5$var$_defineProperty(obj, key, value) {
    key = $fe388b12b6d97ad5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fe388b12b6d97ad5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fe388b12b6d97ad5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $fe388b12b6d97ad5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $fe388b12b6d97ad5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe388b12b6d97ad5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe388b12b6d97ad5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fe388b12b6d97ad5$var$_toPropertyKey(arg) {
    var key = $fe388b12b6d97ad5$var$_toPrimitive(arg, "string");
    return $fe388b12b6d97ad5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $fe388b12b6d97ad5$var$_toPrimitive(input, hint) {
    if ($fe388b12b6d97ad5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($fe388b12b6d97ad5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $fe388b12b6d97ad5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $fe388b12b6d97ad5$var$_setPrototypeOf(subClass, superClass);
}
function $fe388b12b6d97ad5$var$_setPrototypeOf(o, p) {
    $fe388b12b6d97ad5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fe388b12b6d97ad5$var$_setPrototypeOf(o, p);
}
function $fe388b12b6d97ad5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fe388b12b6d97ad5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $fe388b12b6d97ad5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $fe388b12b6d97ad5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fe388b12b6d97ad5$var$_possibleConstructorReturn(this, result);
    };
}
function $fe388b12b6d97ad5$var$_possibleConstructorReturn(self, call) {
    if (call && ($fe388b12b6d97ad5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $fe388b12b6d97ad5$var$_assertThisInitialized(self);
}
function $fe388b12b6d97ad5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fe388b12b6d97ad5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fe388b12b6d97ad5$var$_getPrototypeOf(o) {
    $fe388b12b6d97ad5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fe388b12b6d97ad5$var$_getPrototypeOf(o);
}
var $fe388b12b6d97ad5$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $fe388b12b6d97ad5$var$_inherits(Animate, _PureComponent);
    var _super = $fe388b12b6d97ad5$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $fe388b12b6d97ad5$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($fe388b12b6d97ad5$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($fe388b12b6d97ad5$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $fe388b12b6d97ad5$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $fe388b12b6d97ad5$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $fe388b12b6d97ad5$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $fe388b12b6d97ad5$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $fe388b12b6d97ad5$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $a22fa58636ba4c67$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $fe388b12b6d97ad5$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($fe388b12b6d97ad5$var$_objectSpread($fe388b12b6d97ad5$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $f61fc44e6cd0dd12$export$2e2bcd8739ae039)(from, to, (0, $ec6c311f8a939cc0$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($fe388b12b6d97ad5$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $ad14d613dac655bd$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $fe388b12b6d97ad5$var$_objectSpread($fe388b12b6d97ad5$var$_objectSpread($fe388b12b6d97ad5$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($fe388b12b6d97ad5$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $ad14d613dac655bd$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($fe388b12b6d97ad5$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $337e3951d7a8edb0$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $fe388b12b6d97ad5$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $ad14d613dac655bd$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $fe388b12b6d97ad5$var$_objectSpread($fe388b12b6d97ad5$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $fe388b12b6d97ad5$var$_objectWithoutProperties(_this$props4, $fe388b12b6d97ad5$var$_excluded);
                var count = (0, $8nGP5.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $8nGP5.cloneElement)(container, $fe388b12b6d97ad5$var$_objectSpread($fe388b12b6d97ad5$var$_objectSpread({}, others), {}, {
                        style: $fe388b12b6d97ad5$var$_objectSpread($fe388b12b6d97ad5$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $8nGP5.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", null, (0, $8nGP5.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $8nGP5.PureComponent));
$fe388b12b6d97ad5$var$Animate.displayName = 'Animate';
$fe388b12b6d97ad5$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$fe388b12b6d97ad5$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
};
var $fe388b12b6d97ad5$export$2e2bcd8739ae039 = $fe388b12b6d97ad5$var$Animate;




var $32fd8300d9e7a1d4$export$2e2bcd8739ae039 = (0, $fe388b12b6d97ad5$export$2e2bcd8739ae039);






/**
 * @fileOverview Cross
 */ var $94307f62a0d95f57$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$94307f62a0d95f57$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $8nGP5 = parcelRequire("8nGP5");



var $ef7c13d61ecebd89$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $ef7c13d61ecebd89$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$ef7c13d61ecebd89$exports = $ef7c13d61ecebd89$var$last;



var $8nGP5 = parcelRequire("8nGP5");




var $ajIhI = parcelRequire("ajIhI");

var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");




function $0c5a8338a63fb7e5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0c5a8338a63fb7e5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0c5a8338a63fb7e5$var$_typeof(o);
}
function $0c5a8338a63fb7e5$var$_slicedToArray(arr, i) {
    return $0c5a8338a63fb7e5$var$_arrayWithHoles(arr) || $0c5a8338a63fb7e5$var$_iterableToArrayLimit(arr, i) || $0c5a8338a63fb7e5$var$_unsupportedIterableToArray(arr, i) || $0c5a8338a63fb7e5$var$_nonIterableRest();
}
function $0c5a8338a63fb7e5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0c5a8338a63fb7e5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0c5a8338a63fb7e5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0c5a8338a63fb7e5$var$_arrayLikeToArray(o, minLen);
}
function $0c5a8338a63fb7e5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0c5a8338a63fb7e5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0c5a8338a63fb7e5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0c5a8338a63fb7e5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0c5a8338a63fb7e5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0c5a8338a63fb7e5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0c5a8338a63fb7e5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0c5a8338a63fb7e5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0c5a8338a63fb7e5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0c5a8338a63fb7e5$var$_toPropertyKey(t) {
    var i = $0c5a8338a63fb7e5$var$_toPrimitive(t, "string");
    return "symbol" == $0c5a8338a63fb7e5$var$_typeof(i) ? i : i + "";
}
function $0c5a8338a63fb7e5$var$_toPrimitive(t, r) {
    if ("object" != $0c5a8338a63fb7e5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0c5a8338a63fb7e5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0c5a8338a63fb7e5$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $0c5a8338a63fb7e5$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $0c5a8338a63fb7e5$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $0c5a8338a63fb7e5$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $0c5a8338a63fb7e5$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $0c5a8338a63fb7e5$var$FIXED_CSS_LENGTH_UNITS = Object.keys($0c5a8338a63fb7e5$var$CONVERSION_RATES);
var $0c5a8338a63fb7e5$var$STR_NAN = 'NaN';
function $0c5a8338a63fb7e5$var$convertToPx(value, unit) {
    return value * $0c5a8338a63fb7e5$var$CONVERSION_RATES[unit];
}
var $0c5a8338a63fb7e5$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $0c5a8338a63fb7e5$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !$0c5a8338a63fb7e5$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($0c5a8338a63fb7e5$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $0c5a8338a63fb7e5$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    return $0c5a8338a63fb7e5$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $0c5a8338a63fb7e5$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $0c5a8338a63fb7e5$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
}();
function $0c5a8338a63fb7e5$var$calculateArithmetic(expr) {
    if (expr.includes($0c5a8338a63fb7e5$var$STR_NAN)) return $0c5a8338a63fb7e5$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $0c5a8338a63fb7e5$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $0c5a8338a63fb7e5$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $0c5a8338a63fb7e5$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $0c5a8338a63fb7e5$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $0c5a8338a63fb7e5$var$STR_NAN;
        newExpr = newExpr.replace($0c5a8338a63fb7e5$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $0c5a8338a63fb7e5$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $0c5a8338a63fb7e5$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $0c5a8338a63fb7e5$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $0c5a8338a63fb7e5$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $0c5a8338a63fb7e5$var$STR_NAN;
        newExpr = newExpr.replace($0c5a8338a63fb7e5$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $0c5a8338a63fb7e5$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $0c5a8338a63fb7e5$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = $0c5a8338a63fb7e5$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $0c5a8338a63fb7e5$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($0c5a8338a63fb7e5$var$PARENTHESES_REGEX, $0c5a8338a63fb7e5$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $0c5a8338a63fb7e5$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $0c5a8338a63fb7e5$var$calculateParentheses(newExpr);
    newExpr = $0c5a8338a63fb7e5$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $0c5a8338a63fb7e5$export$c891f73c9c6d00c9(expression) {
    try {
        return $0c5a8338a63fb7e5$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $0c5a8338a63fb7e5$var$STR_NAN;
    }
}
function $0c5a8338a63fb7e5$export$254eac204f89fd7d(expression) {
    var result = $0c5a8338a63fb7e5$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $0c5a8338a63fb7e5$var$STR_NAN) // notify the user
    return '';
    return result;
}


var $844463820b79d851$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $844463820b79d851$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $844463820b79d851$var$_extends() {
    $844463820b79d851$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $844463820b79d851$var$_extends.apply(this, arguments);
}
function $844463820b79d851$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $844463820b79d851$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $844463820b79d851$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $844463820b79d851$var$_slicedToArray(arr, i) {
    return $844463820b79d851$var$_arrayWithHoles(arr) || $844463820b79d851$var$_iterableToArrayLimit(arr, i) || $844463820b79d851$var$_unsupportedIterableToArray(arr, i) || $844463820b79d851$var$_nonIterableRest();
}
function $844463820b79d851$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $844463820b79d851$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $844463820b79d851$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $844463820b79d851$var$_arrayLikeToArray(o, minLen);
}
function $844463820b79d851$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $844463820b79d851$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $844463820b79d851$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $844463820b79d851$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $844463820b79d851$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($844463820b79d851$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $afcbff65789b5460$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $afcbff65789b5460$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $844463820b79d851$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $844463820b79d851$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $844463820b79d851$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $844463820b79d851$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $844463820b79d851$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(children) ? children.toString().split($844463820b79d851$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $844463820b79d851$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $844463820b79d851$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $844463820b79d851$var$getWordsWithoutCalculate(children);
        return $844463820b79d851$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $844463820b79d851$var$getWordsWithoutCalculate(children);
};
var $844463820b79d851$var$DEFAULT_FILL = '#808080';
var $844463820b79d851$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $844463820b79d851$var$DEFAULT_FILL : _ref5$fill, props = $844463820b79d851$var$_objectWithoutProperties(_ref5, $844463820b79d851$var$_excluded);
    var wordsByLines = (0, $8nGP5.useMemo)(function() {
        return $844463820b79d851$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $844463820b79d851$var$_objectWithoutProperties(props, $844463820b79d851$var$_excluded2);
    if (!(0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(propsX) || !(0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $0c5a8338a63fb7e5$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $0c5a8338a63fb7e5$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $0c5a8338a63fb7e5$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("text", $844463820b79d851$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $ajIhI.default)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $844463820b79d851$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};






var $8nGP5 = parcelRequire("8nGP5");



function $e229728826610b73$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e229728826610b73$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e229728826610b73$var$_typeof(o);
}
function $e229728826610b73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e229728826610b73$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e229728826610b73$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e229728826610b73$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e229728826610b73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e229728826610b73$var$_defineProperty(obj, key, value) {
    key = $e229728826610b73$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e229728826610b73$var$_toPropertyKey(t) {
    var i = $e229728826610b73$var$_toPrimitive(t, "string");
    return "symbol" == $e229728826610b73$var$_typeof(i) ? i : i + "";
}
function $e229728826610b73$var$_toPrimitive(t, r) {
    if ("object" != $e229728826610b73$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e229728826610b73$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e229728826610b73$var$_slicedToArray(arr, i) {
    return $e229728826610b73$var$_arrayWithHoles(arr) || $e229728826610b73$var$_iterableToArrayLimit(arr, i) || $e229728826610b73$var$_unsupportedIterableToArray(arr, i) || $e229728826610b73$var$_nonIterableRest();
}
function $e229728826610b73$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e229728826610b73$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e229728826610b73$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e229728826610b73$var$_arrayLikeToArray(o, minLen);
}
function $e229728826610b73$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e229728826610b73$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e229728826610b73$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $e229728826610b73$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $e229728826610b73$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $e229728826610b73$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $e229728826610b73$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$e229728826610b73$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$e229728826610b73$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $e229728826610b73$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $e229728826610b73$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $e229728826610b73$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $e229728826610b73$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $cc31aced37ecb634$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $cc31aced37ecb634$export$9d80152e23bae434)(scale);
        var ticks = (0, $cc31aced37ecb634$export$ac086aaa4358d590)(scale, $e229728826610b73$var$_objectSpread($e229728826610b73$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $e229728826610b73$var$_objectSpread($e229728826610b73$var$_objectSpread($e229728826610b73$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $e229728826610b73$var$_objectSpread($e229728826610b73$var$_objectSpread({}, result), {}, $e229728826610b73$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $e229728826610b73$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $e229728826610b73$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $e229728826610b73$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $e229728826610b73$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $e229728826610b73$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $e229728826610b73$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $e229728826610b73$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $e229728826610b73$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $e229728826610b73$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $e229728826610b73$var$_objectSpread($e229728826610b73$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $e229728826610b73$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $e229728826610b73$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $8nGP5.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(tick) && typeof tick !== 'boolean' ? tick.className : '';
};


function $91b8fcd34b00a8a9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $91b8fcd34b00a8a9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $91b8fcd34b00a8a9$var$_typeof(o);
}
var $91b8fcd34b00a8a9$var$_excluded = [
    "offset"
];
function $91b8fcd34b00a8a9$var$_toConsumableArray(arr) {
    return $91b8fcd34b00a8a9$var$_arrayWithoutHoles(arr) || $91b8fcd34b00a8a9$var$_iterableToArray(arr) || $91b8fcd34b00a8a9$var$_unsupportedIterableToArray(arr) || $91b8fcd34b00a8a9$var$_nonIterableSpread();
}
function $91b8fcd34b00a8a9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $91b8fcd34b00a8a9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $91b8fcd34b00a8a9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $91b8fcd34b00a8a9$var$_arrayLikeToArray(o, minLen);
}
function $91b8fcd34b00a8a9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $91b8fcd34b00a8a9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $91b8fcd34b00a8a9$var$_arrayLikeToArray(arr);
}
function $91b8fcd34b00a8a9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $91b8fcd34b00a8a9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $91b8fcd34b00a8a9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $91b8fcd34b00a8a9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $91b8fcd34b00a8a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91b8fcd34b00a8a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91b8fcd34b00a8a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $91b8fcd34b00a8a9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91b8fcd34b00a8a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $91b8fcd34b00a8a9$var$_defineProperty(obj, key, value) {
    key = $91b8fcd34b00a8a9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $91b8fcd34b00a8a9$var$_toPropertyKey(t) {
    var i = $91b8fcd34b00a8a9$var$_toPrimitive(t, "string");
    return "symbol" == $91b8fcd34b00a8a9$var$_typeof(i) ? i : i + "";
}
function $91b8fcd34b00a8a9$var$_toPrimitive(t, r) {
    if ("object" != $91b8fcd34b00a8a9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $91b8fcd34b00a8a9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $91b8fcd34b00a8a9$var$_extends() {
    $91b8fcd34b00a8a9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $91b8fcd34b00a8a9$var$_extends.apply(this, arguments);
}
var $91b8fcd34b00a8a9$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(formatter)) return formatter(label);
    return label;
};
var $91b8fcd34b00a8a9$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $91b8fcd34b00a8a9$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $91b8fcd34b00a8a9$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(labelProps.id) ? (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("text", $91b8fcd34b00a8a9$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $ajIhI.default)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $91b8fcd34b00a8a9$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $91b8fcd34b00a8a9$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $91b8fcd34b00a8a9$var$_objectSpread($91b8fcd34b00a8a9$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $91b8fcd34b00a8a9$var$_objectSpread($91b8fcd34b00a8a9$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $91b8fcd34b00a8a9$var$_objectSpread($91b8fcd34b00a8a9$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $91b8fcd34b00a8a9$var$_objectSpread($91b8fcd34b00a8a9$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(position) && ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(position.x) || (0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(position.x)) && ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(position.y) || (0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(position.y))) return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $91b8fcd34b00a8a9$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(viewBox.cx);
};
function $91b8fcd34b00a8a9$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $91b8fcd34b00a8a9$var$_objectWithoutProperties(_ref4, $91b8fcd34b00a8a9$var$_excluded);
    var props = $91b8fcd34b00a8a9$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(children) && !/*#__PURE__*/ (0, $8nGP5.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(content)) return /*#__PURE__*/ (0, $8nGP5.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(content)) {
        label = /*#__PURE__*/ (0, $8nGP5.createElement)(content, props);
        if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(label)) return label;
    } else label = $91b8fcd34b00a8a9$var$getLabel(props);
    var isPolarLabel = $91b8fcd34b00a8a9$var$isPolar(viewBox);
    var attrs = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $91b8fcd34b00a8a9$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $91b8fcd34b00a8a9$var$getAttrsOfPolarLabel(props) : $91b8fcd34b00a8a9$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $844463820b79d851$export$5f1af8db9871e1d6), $91b8fcd34b00a8a9$var$_extends({
        className: (0, $ajIhI.default)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$91b8fcd34b00a8a9$export$b04be29aa201d4f5.displayName = 'Label';
var $91b8fcd34b00a8a9$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(height)) {
        if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(x) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(top) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(x) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(cx) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $91b8fcd34b00a8a9$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($91b8fcd34b00a8a9$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($91b8fcd34b00a8a9$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(label)) {
        if (label.type === $91b8fcd34b00a8a9$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $8nGP5.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($91b8fcd34b00a8a9$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($91b8fcd34b00a8a9$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($91b8fcd34b00a8a9$export$b04be29aa201d4f5, $91b8fcd34b00a8a9$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $91b8fcd34b00a8a9$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $91b8fcd34b00a8a9$var$parseViewBox(parentProps);
    var explicitChildren = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $8nGP5.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $91b8fcd34b00a8a9$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($91b8fcd34b00a8a9$var$_toConsumableArray(explicitChildren));
};
$91b8fcd34b00a8a9$export$b04be29aa201d4f5.parseViewBox = $91b8fcd34b00a8a9$var$parseViewBox;
$91b8fcd34b00a8a9$export$b04be29aa201d4f5.renderCallByParent = $91b8fcd34b00a8a9$var$renderCallByParent;





function $e476a06be597057a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e476a06be597057a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e476a06be597057a$var$_typeof(o);
}
var $e476a06be597057a$var$_excluded = [
    "valueAccessor"
], $e476a06be597057a$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $e476a06be597057a$var$_toConsumableArray(arr) {
    return $e476a06be597057a$var$_arrayWithoutHoles(arr) || $e476a06be597057a$var$_iterableToArray(arr) || $e476a06be597057a$var$_unsupportedIterableToArray(arr) || $e476a06be597057a$var$_nonIterableSpread();
}
function $e476a06be597057a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e476a06be597057a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e476a06be597057a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e476a06be597057a$var$_arrayLikeToArray(o, minLen);
}
function $e476a06be597057a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e476a06be597057a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e476a06be597057a$var$_arrayLikeToArray(arr);
}
function $e476a06be597057a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e476a06be597057a$var$_extends() {
    $e476a06be597057a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e476a06be597057a$var$_extends.apply(this, arguments);
}
function $e476a06be597057a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e476a06be597057a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e476a06be597057a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e476a06be597057a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e476a06be597057a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e476a06be597057a$var$_defineProperty(obj, key, value) {
    key = $e476a06be597057a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e476a06be597057a$var$_toPropertyKey(t) {
    var i = $e476a06be597057a$var$_toPrimitive(t, "string");
    return "symbol" == $e476a06be597057a$var$_typeof(i) ? i : i + "";
}
function $e476a06be597057a$var$_toPrimitive(t, r) {
    if ("object" != $e476a06be597057a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e476a06be597057a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e476a06be597057a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e476a06be597057a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e476a06be597057a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e476a06be597057a$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($ef7c13d61ecebd89$exports)))(entry.value) : entry.value;
};
function $e476a06be597057a$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $e476a06be597057a$var$defaultAccessor : _ref$valueAccessor, restProps = $e476a06be597057a$var$_objectWithoutProperties(_ref, $e476a06be597057a$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $e476a06be597057a$var$_objectWithoutProperties(restProps, $e476a06be597057a$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5), $e476a06be597057a$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(clockWise) ? entry : $e476a06be597057a$var$_objectSpread($e476a06be597057a$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$e476a06be597057a$export$835fcf23ab7bf88.displayName = 'LabelList';
function $e476a06be597057a$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($e476a06be597057a$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($e476a06be597057a$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($e476a06be597057a$export$835fcf23ab7bf88, $e476a06be597057a$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $e476a06be597057a$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, $e476a06be597057a$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $8nGP5.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $e476a06be597057a$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($e476a06be597057a$var$_toConsumableArray(explicitChildren));
}
$e476a06be597057a$export$835fcf23ab7bf88.renderCallByParent = $e476a06be597057a$var$renderCallByParent;








var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");

var $bce4a89e1bec64eb$exports = {};

var $4415e39530ad0572$exports = {};

/** Built-in value references. */ var $4415e39530ad0572$var$getPrototype = $e5cfd6ab9c22776f$exports(Object.getPrototypeOf, Object);
$4415e39530ad0572$exports = $4415e39530ad0572$var$getPrototype;



/** `Object#toString` result references. */ var $bce4a89e1bec64eb$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $bce4a89e1bec64eb$var$funcProto = Function.prototype, $bce4a89e1bec64eb$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $bce4a89e1bec64eb$var$funcToString = $bce4a89e1bec64eb$var$funcProto.toString;
/** Used to check objects for own properties. */ var $bce4a89e1bec64eb$var$hasOwnProperty = $bce4a89e1bec64eb$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $bce4a89e1bec64eb$var$objectCtorString = $bce4a89e1bec64eb$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $bce4a89e1bec64eb$var$isPlainObject(value) {
    if (!$9405d96f7f034703$exports(value) || $22b8ec638f42dca7$exports(value) != $bce4a89e1bec64eb$var$objectTag) return false;
    var proto = $4415e39530ad0572$exports(value);
    if (proto === null) return true;
    var Ctor = $bce4a89e1bec64eb$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $bce4a89e1bec64eb$var$funcToString.call(Ctor) == $bce4a89e1bec64eb$var$objectCtorString;
}
$bce4a89e1bec64eb$exports = $bce4a89e1bec64eb$var$isPlainObject;


var $8e0c6c162d0a6ac4$exports = {};


/** `Object#toString` result references. */ var $8e0c6c162d0a6ac4$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $8e0c6c162d0a6ac4$var$isBoolean(value) {
    return value === true || value === false || $9405d96f7f034703$exports(value) && $22b8ec638f42dca7$exports(value) == $8e0c6c162d0a6ac4$var$boolTag;
}
$8e0c6c162d0a6ac4$exports = $8e0c6c162d0a6ac4$var$isBoolean;




var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");


function $2a40e10cde5ed370$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2a40e10cde5ed370$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2a40e10cde5ed370$var$_typeof(o);
}
function $2a40e10cde5ed370$var$_extends() {
    $2a40e10cde5ed370$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a40e10cde5ed370$var$_extends.apply(this, arguments);
}
function $2a40e10cde5ed370$var$_slicedToArray(arr, i) {
    return $2a40e10cde5ed370$var$_arrayWithHoles(arr) || $2a40e10cde5ed370$var$_iterableToArrayLimit(arr, i) || $2a40e10cde5ed370$var$_unsupportedIterableToArray(arr, i) || $2a40e10cde5ed370$var$_nonIterableRest();
}
function $2a40e10cde5ed370$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a40e10cde5ed370$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2a40e10cde5ed370$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2a40e10cde5ed370$var$_arrayLikeToArray(o, minLen);
}
function $2a40e10cde5ed370$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2a40e10cde5ed370$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2a40e10cde5ed370$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2a40e10cde5ed370$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a40e10cde5ed370$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a40e10cde5ed370$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2a40e10cde5ed370$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a40e10cde5ed370$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a40e10cde5ed370$var$_defineProperty(obj, key, value) {
    key = $2a40e10cde5ed370$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a40e10cde5ed370$var$_toPropertyKey(t) {
    var i = $2a40e10cde5ed370$var$_toPrimitive(t, "string");
    return "symbol" == $2a40e10cde5ed370$var$_typeof(i) ? i : i + "";
}
function $2a40e10cde5ed370$var$_toPrimitive(t, r) {
    if ("object" != $2a40e10cde5ed370$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2a40e10cde5ed370$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2a40e10cde5ed370$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $2a40e10cde5ed370$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $2a40e10cde5ed370$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $2a40e10cde5ed370$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $2a40e10cde5ed370$var$_objectSpread($2a40e10cde5ed370$var$_objectSpread({}, $2a40e10cde5ed370$var$defaultProps), rectangleProps);
    var pathRef = (0, $8nGP5.useRef)();
    var _useState = (0, $8nGP5.useState)(-1), _useState2 = $2a40e10cde5ed370$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $8nGP5.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $ajIhI.default)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $2a40e10cde5ed370$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $2a40e10cde5ed370$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $32fd8300d9e7a1d4$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $32fd8300d9e7a1d4$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $2a40e10cde5ed370$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $2a40e10cde5ed370$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");


function $ad71aaf4920156c8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ad71aaf4920156c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ad71aaf4920156c8$var$_typeof(o);
}
function $ad71aaf4920156c8$var$_extends() {
    $ad71aaf4920156c8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ad71aaf4920156c8$var$_extends.apply(this, arguments);
}
function $ad71aaf4920156c8$var$_slicedToArray(arr, i) {
    return $ad71aaf4920156c8$var$_arrayWithHoles(arr) || $ad71aaf4920156c8$var$_iterableToArrayLimit(arr, i) || $ad71aaf4920156c8$var$_unsupportedIterableToArray(arr, i) || $ad71aaf4920156c8$var$_nonIterableRest();
}
function $ad71aaf4920156c8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ad71aaf4920156c8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ad71aaf4920156c8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ad71aaf4920156c8$var$_arrayLikeToArray(o, minLen);
}
function $ad71aaf4920156c8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ad71aaf4920156c8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ad71aaf4920156c8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ad71aaf4920156c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad71aaf4920156c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad71aaf4920156c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ad71aaf4920156c8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad71aaf4920156c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ad71aaf4920156c8$var$_defineProperty(obj, key, value) {
    key = $ad71aaf4920156c8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ad71aaf4920156c8$var$_toPropertyKey(t) {
    var i = $ad71aaf4920156c8$var$_toPrimitive(t, "string");
    return "symbol" == $ad71aaf4920156c8$var$_typeof(i) ? i : i + "";
}
function $ad71aaf4920156c8$var$_toPrimitive(t, r) {
    if ("object" != $ad71aaf4920156c8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ad71aaf4920156c8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ad71aaf4920156c8$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $ad71aaf4920156c8$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $ad71aaf4920156c8$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $ad71aaf4920156c8$var$_objectSpread($ad71aaf4920156c8$var$_objectSpread({}, $ad71aaf4920156c8$var$defaultProps), props);
    var pathRef = (0, $8nGP5.useRef)();
    var _useState = (0, $8nGP5.useState)(-1), _useState2 = $ad71aaf4920156c8$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $8nGP5.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $ajIhI.default)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $ad71aaf4920156c8$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $ad71aaf4920156c8$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $32fd8300d9e7a1d4$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $32fd8300d9e7a1d4$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $ad71aaf4920156c8$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $ad71aaf4920156c8$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");



function $ac8f8e6d22dec697$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ac8f8e6d22dec697$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ac8f8e6d22dec697$var$_typeof(o);
}
function $ac8f8e6d22dec697$var$_extends() {
    $ac8f8e6d22dec697$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ac8f8e6d22dec697$var$_extends.apply(this, arguments);
}
function $ac8f8e6d22dec697$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ac8f8e6d22dec697$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ac8f8e6d22dec697$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ac8f8e6d22dec697$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ac8f8e6d22dec697$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ac8f8e6d22dec697$var$_defineProperty(obj, key, value) {
    key = $ac8f8e6d22dec697$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ac8f8e6d22dec697$var$_toPropertyKey(t) {
    var i = $ac8f8e6d22dec697$var$_toPrimitive(t, "string");
    return "symbol" == $ac8f8e6d22dec697$var$_typeof(i) ? i : i + "";
}
function $ac8f8e6d22dec697$var$_toPrimitive(t, r) {
    if ("object" != $ac8f8e6d22dec697$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ac8f8e6d22dec697$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ac8f8e6d22dec697$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $ac8f8e6d22dec697$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $e229728826610b73$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $e229728826610b73$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $ac8f8e6d22dec697$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $ac8f8e6d22dec697$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $ac8f8e6d22dec697$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $ac8f8e6d22dec697$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $ac8f8e6d22dec697$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $ac8f8e6d22dec697$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $ac8f8e6d22dec697$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $ac8f8e6d22dec697$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $ac8f8e6d22dec697$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $ac8f8e6d22dec697$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $ac8f8e6d22dec697$var$_objectSpread($ac8f8e6d22dec697$var$_objectSpread({}, $ac8f8e6d22dec697$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $ajIhI.default)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $ac8f8e6d22dec697$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $ac8f8e6d22dec697$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $ac8f8e6d22dec697$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $2be7c72ce33b6679$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $2be7c72ce33b6679$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2be7c72ce33b6679$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2be7c72ce33b6679$var$_typeof(o);
}
function $2be7c72ce33b6679$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2be7c72ce33b6679$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2be7c72ce33b6679$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2be7c72ce33b6679$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2be7c72ce33b6679$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2be7c72ce33b6679$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2be7c72ce33b6679$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2be7c72ce33b6679$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2be7c72ce33b6679$var$_defineProperty(obj, key, value) {
    key = $2be7c72ce33b6679$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2be7c72ce33b6679$var$_toPropertyKey(t) {
    var i = $2be7c72ce33b6679$var$_toPrimitive(t, "string");
    return "symbol" == $2be7c72ce33b6679$var$_typeof(i) ? i : i + "";
}
function $2be7c72ce33b6679$var$_toPrimitive(t, r) {
    if ("object" != $2be7c72ce33b6679$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2be7c72ce33b6679$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $2be7c72ce33b6679$var$defaultPropTransformer(option, props) {
    return $2be7c72ce33b6679$var$_objectSpread($2be7c72ce33b6679$var$_objectSpread({}, props), option);
}
function $2be7c72ce33b6679$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $2be7c72ce33b6679$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2a40e10cde5ed370$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ad71aaf4920156c8$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ac8f8e6d22dec697$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($2be7c72ce33b6679$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1a06a1b516e783f8$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $2be7c72ce33b6679$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(option)) return option.props;
    return option;
}
function $2be7c72ce33b6679$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $2be7c72ce33b6679$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = $2be7c72ce33b6679$var$_objectWithoutProperties(_ref2, $2be7c72ce33b6679$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(option)) shape = /*#__PURE__*/ (0, $8nGP5.cloneElement)(option, $2be7c72ce33b6679$var$_objectSpread($2be7c72ce33b6679$var$_objectSpread({}, props), $2be7c72ce33b6679$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($bce4a89e1bec64eb$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($8e0c6c162d0a6ac4$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($2be7c72ce33b6679$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($2be7c72ce33b6679$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $2be7c72ce33b6679$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function $2be7c72ce33b6679$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function $2be7c72ce33b6679$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function $2be7c72ce33b6679$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $2be7c72ce33b6679$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $2be7c72ce33b6679$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $2be7c72ce33b6679$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($2be7c72ce33b6679$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $2be7c72ce33b6679$export$7c9a98b3f068686f;
    else if ($2be7c72ce33b6679$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $2be7c72ce33b6679$export$b356b51e8337a02f;
    else if ($2be7c72ce33b6679$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $2be7c72ce33b6679$export$559c3a78b4889350;
    return comparison;
}
function $2be7c72ce33b6679$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($2be7c72ce33b6679$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if ($2be7c72ce33b6679$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if ($2be7c72ce33b6679$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function $2be7c72ce33b6679$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($2be7c72ce33b6679$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($2be7c72ce33b6679$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($2be7c72ce33b6679$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $2be7c72ce33b6679$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $2be7c72ce33b6679$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $2be7c72ce33b6679$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $2be7c72ce33b6679$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}


var $9ea489eb6e8299b9$var$_excluded = [
    "x",
    "y"
];
function $9ea489eb6e8299b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9ea489eb6e8299b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9ea489eb6e8299b9$var$_typeof(o);
}
function $9ea489eb6e8299b9$var$_extends() {
    $9ea489eb6e8299b9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9ea489eb6e8299b9$var$_extends.apply(this, arguments);
}
function $9ea489eb6e8299b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ea489eb6e8299b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ea489eb6e8299b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9ea489eb6e8299b9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ea489eb6e8299b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9ea489eb6e8299b9$var$_defineProperty(obj, key, value) {
    key = $9ea489eb6e8299b9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ea489eb6e8299b9$var$_toPropertyKey(t) {
    var i = $9ea489eb6e8299b9$var$_toPrimitive(t, "string");
    return "symbol" == $9ea489eb6e8299b9$var$_typeof(i) ? i : i + "";
}
function $9ea489eb6e8299b9$var$_toPrimitive(t, r) {
    if ("object" != $9ea489eb6e8299b9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9ea489eb6e8299b9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9ea489eb6e8299b9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9ea489eb6e8299b9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9ea489eb6e8299b9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $9ea489eb6e8299b9$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $9ea489eb6e8299b9$var$_objectWithoutProperties(_ref, $9ea489eb6e8299b9$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $9ea489eb6e8299b9$var$_objectSpread($9ea489eb6e8299b9$var$_objectSpread($9ea489eb6e8299b9$var$_objectSpread($9ea489eb6e8299b9$var$_objectSpread($9ea489eb6e8299b9$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $9ea489eb6e8299b9$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2be7c72ce33b6679$export$6428a7f2611ef1fa), $9ea489eb6e8299b9$var$_extends({
        shapeType: "rectangle",
        propTransformer: $9ea489eb6e8299b9$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $9ea489eb6e8299b9$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === 'number') return minPointSize;
        var isValueNumber = typeof value === 'number';
        if (isValueNumber) return minPointSize(value, index);
        !isValueNumber && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
        return defaultValue;
    };
};


var $6f50d8c16ef9d517$var$_excluded = [
    "value",
    "background"
];
var $6f50d8c16ef9d517$var$_Bar;
function $6f50d8c16ef9d517$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6f50d8c16ef9d517$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6f50d8c16ef9d517$var$_typeof(o);
}
function $6f50d8c16ef9d517$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6f50d8c16ef9d517$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6f50d8c16ef9d517$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6f50d8c16ef9d517$var$_extends() {
    $6f50d8c16ef9d517$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6f50d8c16ef9d517$var$_extends.apply(this, arguments);
}
function $6f50d8c16ef9d517$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f50d8c16ef9d517$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f50d8c16ef9d517$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6f50d8c16ef9d517$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f50d8c16ef9d517$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6f50d8c16ef9d517$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6f50d8c16ef9d517$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6f50d8c16ef9d517$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6f50d8c16ef9d517$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6f50d8c16ef9d517$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6f50d8c16ef9d517$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6f50d8c16ef9d517$var$_callSuper(t, o, e) {
    return o = $6f50d8c16ef9d517$var$_getPrototypeOf(o), $6f50d8c16ef9d517$var$_possibleConstructorReturn(t, $6f50d8c16ef9d517$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $6f50d8c16ef9d517$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $6f50d8c16ef9d517$var$_possibleConstructorReturn(self, call) {
    if (call && ($6f50d8c16ef9d517$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6f50d8c16ef9d517$var$_assertThisInitialized(self);
}
function $6f50d8c16ef9d517$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6f50d8c16ef9d517$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6f50d8c16ef9d517$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6f50d8c16ef9d517$var$_getPrototypeOf(o) {
    $6f50d8c16ef9d517$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6f50d8c16ef9d517$var$_getPrototypeOf(o);
}
function $6f50d8c16ef9d517$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6f50d8c16ef9d517$var$_setPrototypeOf(subClass, superClass);
}
function $6f50d8c16ef9d517$var$_setPrototypeOf(o, p) {
    $6f50d8c16ef9d517$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6f50d8c16ef9d517$var$_setPrototypeOf(o, p);
}
function $6f50d8c16ef9d517$var$_defineProperty(obj, key, value) {
    key = $6f50d8c16ef9d517$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6f50d8c16ef9d517$var$_toPropertyKey(t) {
    var i = $6f50d8c16ef9d517$var$_toPrimitive(t, "string");
    return "symbol" == $6f50d8c16ef9d517$var$_typeof(i) ? i : i + "";
}
function $6f50d8c16ef9d517$var$_toPrimitive(t, r) {
    if ("object" != $6f50d8c16ef9d517$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6f50d8c16ef9d517$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6f50d8c16ef9d517$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        $6f50d8c16ef9d517$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6f50d8c16ef9d517$var$_callSuper(this, Bar, [].concat(args));
        $6f50d8c16ef9d517$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $6f50d8c16ef9d517$var$_defineProperty(_this, "id", (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts-bar-'));
        $6f50d8c16ef9d517$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $6f50d8c16ef9d517$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $6f50d8c16ef9d517$var$_inherits(Bar, _PureComponent);
    return $6f50d8c16ef9d517$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $6f50d8c16ef9d517$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $f1d44a0cc6cff721$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // https://github.com/recharts/recharts/issues/5415
                        // eslint-disable-next-line react/no-array-index-key
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9ea489eb6e8299b9$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $32fd8300d9e7a1d4$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $6f50d8c16ef9d517$var$_objectWithoutProperties(entry, $6f50d8c16ef9d517$var$_excluded);
                    if (!background) return null;
                    var props = $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $f1d44a0cc6cff721$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9ea489eb6e8299b9$export$f19074a6842f9217), $6f50d8c16ef9d517$var$_extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $d0e02a4abf979d13$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $cc31aced37ecb634$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $ajIhI.default)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $e476a06be597057a$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$6f50d8c16ef9d517$var$_Bar = $6f50d8c16ef9d517$export$bbc6c6369b38e3d1;
$6f50d8c16ef9d517$var$_defineProperty($6f50d8c16ef9d517$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$6f50d8c16ef9d517$var$_defineProperty($6f50d8c16ef9d517$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: false,
    isAnimationActive: !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $6f50d8c16ef9d517$var$_defineProperty($6f50d8c16ef9d517$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $cc31aced37ecb634$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $cc31aced37ecb634$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $94307f62a0d95f57$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $cc31aced37ecb634$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $9ea489eb6e8299b9$export$c20d73790de171f0)(minPointSizeProp, $6f50d8c16ef9d517$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $cc31aced37ecb634$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $cc31aced37ecb634$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $cc31aced37ecb634$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $6f50d8c16ef9d517$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $b57066fd5661be22$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b57066fd5661be22$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b57066fd5661be22$var$_typeof(o);
}
function $b57066fd5661be22$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b57066fd5661be22$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b57066fd5661be22$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b57066fd5661be22$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b57066fd5661be22$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b57066fd5661be22$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b57066fd5661be22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b57066fd5661be22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b57066fd5661be22$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b57066fd5661be22$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b57066fd5661be22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b57066fd5661be22$var$_defineProperty(obj, key, value) {
    key = $b57066fd5661be22$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b57066fd5661be22$var$_toPropertyKey(t) {
    var i = $b57066fd5661be22$var$_toPrimitive(t, "string");
    return "symbol" == $b57066fd5661be22$var$_typeof(i) ? i : i + "";
}
function $b57066fd5661be22$var$_toPrimitive(t, r) {
    if ("object" != $b57066fd5661be22$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b57066fd5661be22$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b57066fd5661be22$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort((0, $3d08f6c3b4eab1e3$export$6ab1df3197f7c641));
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
                if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === 'no-gap') {
                    var gap = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $cc31aced37ecb634$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $cc31aced37ecb634$export$9d80152e23bae434)(scale);
        var ticks = (0, $cc31aced37ecb634$export$ac086aaa4358d590)(scale, $b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $cc31aced37ecb634$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread({}, result), {}, $b57066fd5661be22$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $b57066fd5661be22$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $b57066fd5661be22$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $b57066fd5661be22$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $b57066fd5661be22$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $b57066fd5661be22$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return $b57066fd5661be22$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
$b57066fd5661be22$var$_defineProperty($b57066fd5661be22$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $b57066fd5661be22$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread({}, res), {}, $b57066fd5661be22$var$_defineProperty({}, key, $b57066fd5661be22$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($55b7e71ec6654a57$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($0a6c56731a98b599$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $b57066fd5661be22$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $b57066fd5661be22$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $b57066fd5661be22$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $67d4444155ff8f94$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $d8628af70720a1fc$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $b57066fd5661be22$export$3ee78d51cffc2b68)(size, angle);
}
function $d8628af70720a1fc$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $d8628af70720a1fc$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $d8628af70720a1fc$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $67d4444155ff8f94$export$41514b9f058a6886)(ticks, interval + 1);
}




function $a8fa9b9160b1bf17$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $67d4444155ff8f94$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $d8628af70720a1fc$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $dfb3031f2e0bc9fa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dfb3031f2e0bc9fa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dfb3031f2e0bc9fa$var$_typeof(o);
}
function $dfb3031f2e0bc9fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dfb3031f2e0bc9fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dfb3031f2e0bc9fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dfb3031f2e0bc9fa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dfb3031f2e0bc9fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dfb3031f2e0bc9fa$var$_defineProperty(obj, key, value) {
    key = $dfb3031f2e0bc9fa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dfb3031f2e0bc9fa$var$_toPropertyKey(t) {
    var i = $dfb3031f2e0bc9fa$var$_toPrimitive(t, "string");
    return "symbol" == $dfb3031f2e0bc9fa$var$_typeof(i) ? i : i + "";
}
function $dfb3031f2e0bc9fa$var$_toPrimitive(t, r) {
    if ("object" != $dfb3031f2e0bc9fa$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dfb3031f2e0bc9fa$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dfb3031f2e0bc9fa$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $d8628af70720a1fc$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $dfb3031f2e0bc9fa$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $d8628af70720a1fc$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $d8628af70720a1fc$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $dfb3031f2e0bc9fa$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(interval) || (0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr) return (0, $d8628af70720a1fc$export$beeebbe3ff1b306b)(ticks, typeof interval === 'number' && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $afcbff65789b5460$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $d8628af70720a1fc$export$a1966f4ad955c82b)((0, $afcbff65789b5460$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $afcbff65789b5460$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $d8628af70720a1fc$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $a8fa9b9160b1bf17$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $dfb3031f2e0bc9fa$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $dfb3031f2e0bc9fa$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}



var $8nGP5 = parcelRequire("8nGP5");



var $ajIhI = parcelRequire("ajIhI");








var $040ce345c37febc7$var$_excluded = [
    "viewBox"
], $040ce345c37febc7$var$_excluded2 = [
    "viewBox"
], $040ce345c37febc7$var$_excluded3 = [
    "ticks"
];
function $040ce345c37febc7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $040ce345c37febc7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $040ce345c37febc7$var$_typeof(o);
}
function $040ce345c37febc7$var$_extends() {
    $040ce345c37febc7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040ce345c37febc7$var$_extends.apply(this, arguments);
}
function $040ce345c37febc7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $040ce345c37febc7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $040ce345c37febc7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $040ce345c37febc7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $040ce345c37febc7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $040ce345c37febc7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $040ce345c37febc7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $040ce345c37febc7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $040ce345c37febc7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $040ce345c37febc7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $040ce345c37febc7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $040ce345c37febc7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $040ce345c37febc7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $040ce345c37febc7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $040ce345c37febc7$var$_callSuper(t, o, e) {
    return o = $040ce345c37febc7$var$_getPrototypeOf(o), $040ce345c37febc7$var$_possibleConstructorReturn(t, $040ce345c37febc7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $040ce345c37febc7$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $040ce345c37febc7$var$_possibleConstructorReturn(self, call) {
    if (call && ($040ce345c37febc7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $040ce345c37febc7$var$_assertThisInitialized(self);
}
function $040ce345c37febc7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $040ce345c37febc7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($040ce345c37febc7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $040ce345c37febc7$var$_getPrototypeOf(o) {
    $040ce345c37febc7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $040ce345c37febc7$var$_getPrototypeOf(o);
}
function $040ce345c37febc7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $040ce345c37febc7$var$_setPrototypeOf(subClass, superClass);
}
function $040ce345c37febc7$var$_setPrototypeOf(o, p) {
    $040ce345c37febc7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $040ce345c37febc7$var$_setPrototypeOf(o, p);
}
function $040ce345c37febc7$var$_defineProperty(obj, key, value) {
    key = $040ce345c37febc7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $040ce345c37febc7$var$_toPropertyKey(t) {
    var i = $040ce345c37febc7$var$_toPrimitive(t, "string");
    return "symbol" == $040ce345c37febc7$var$_typeof(i) ? i : i + "";
}
function $040ce345c37febc7$var$_toPrimitive(t, r) {
    if ("object" != $040ce345c37febc7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $040ce345c37febc7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $040ce345c37febc7$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        $040ce345c37febc7$var$_classCallCheck(this, CartesianAxis);
        _this = $040ce345c37febc7$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $040ce345c37febc7$var$_inherits(CartesianAxis, _Component);
    return $040ce345c37febc7$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $040ce345c37febc7$var$_objectWithoutProperties(_ref, $040ce345c37febc7$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $040ce345c37febc7$var$_objectWithoutProperties(_this$props, $040ce345c37febc7$var$_excluded2);
                return !(0, $0e7c207b469fdda3$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $0e7c207b469fdda3$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $0e7c207b469fdda3$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false)), (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", $040ce345c37febc7$var$_extends({}, props, {
                    className: (0, $ajIhI.default)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $dfb3031f2e0bc9fa$export$3d27d42b1034de5c)($040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $040ce345c37febc7$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $f1d44a0cc6cff721$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", $040ce345c37febc7$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $ajIhI.default)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $040ce345c37febc7$var$_objectWithoutProperties(_this$props8, $040ce345c37febc7$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: (0, $ajIhI.default)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $844463820b79d851$export$5f1af8db9871e1d6), $040ce345c37febc7$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $8nGP5.Component));
$040ce345c37febc7$var$_defineProperty($040ce345c37febc7$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$040ce345c37febc7$var$_defineProperty($040ce345c37febc7$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});



var $8nGP5 = parcelRequire("8nGP5");

var $5b6ee6816960e591$exports = {};
var $85281606f309b748$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $85281606f309b748$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$70a87f3bd796a6cd$exports(collection)) {
            var iteratee = $6aa52744a9ab51b8$exports(predicate, 3);
            collection = $2e84fcf9f20ac983$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$85281606f309b748$exports = $85281606f309b748$var$createFind;


var $b940e20407e750fe$exports = {};


var $2ce32a6911170559$exports = {};
var $72c8651a1f6abbcd$exports = {};
var $47f0826a017aad43$exports = {};
var $94149fd2e115b066$exports = {};
var $3dff5e0e5d51c756$exports = {};
/** Used to match a single whitespace character. */ var $3dff5e0e5d51c756$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $3dff5e0e5d51c756$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $3dff5e0e5d51c756$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$3dff5e0e5d51c756$exports = $3dff5e0e5d51c756$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $94149fd2e115b066$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $94149fd2e115b066$var$baseTrim(string) {
    return string ? string.slice(0, $3dff5e0e5d51c756$exports(string) + 1).replace($94149fd2e115b066$var$reTrimStart, '') : string;
}
$94149fd2e115b066$exports = $94149fd2e115b066$var$baseTrim;




/** Used as references for various `Number` constants. */ var $47f0826a017aad43$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $47f0826a017aad43$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $47f0826a017aad43$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $47f0826a017aad43$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $47f0826a017aad43$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $47f0826a017aad43$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($8fab81ce33077160$exports(value)) return $47f0826a017aad43$var$NAN;
    if ($4679825e1cdd07bc$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $4679825e1cdd07bc$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $94149fd2e115b066$exports(value);
    var isBinary = $47f0826a017aad43$var$reIsBinary.test(value);
    return isBinary || $47f0826a017aad43$var$reIsOctal.test(value) ? $47f0826a017aad43$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $47f0826a017aad43$var$reIsBadHex.test(value) ? $47f0826a017aad43$var$NAN : +value;
}
$47f0826a017aad43$exports = $47f0826a017aad43$var$toNumber;


/** Used as references for various `Number` constants. */ var $72c8651a1f6abbcd$var$INFINITY = 1 / 0, $72c8651a1f6abbcd$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $72c8651a1f6abbcd$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $47f0826a017aad43$exports(value);
    if (value === $72c8651a1f6abbcd$var$INFINITY || value === -$72c8651a1f6abbcd$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $72c8651a1f6abbcd$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$72c8651a1f6abbcd$exports = $72c8651a1f6abbcd$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $2ce32a6911170559$var$toInteger(value) {
    var result = $72c8651a1f6abbcd$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$2ce32a6911170559$exports = $2ce32a6911170559$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $b940e20407e750fe$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b940e20407e750fe$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $2ce32a6911170559$exports(fromIndex);
    if (index < 0) index = $b940e20407e750fe$var$nativeMax(length + index, 0);
    return $ecf86b262255e231$exports(array, $6aa52744a9ab51b8$exports(predicate, 3), index);
}
$b940e20407e750fe$exports = $b940e20407e750fe$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $5b6ee6816960e591$var$find = $85281606f309b748$exports($b940e20407e750fe$exports);
$5b6ee6816960e591$exports = $5b6ee6816960e591$var$find;




var $de77b8275d271892$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($c273302ab84aa29a$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});



function $c06c4bb7dffe0deb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c06c4bb7dffe0deb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c06c4bb7dffe0deb$var$_typeof(o);
}
var $c06c4bb7dffe0deb$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $8nGP5.createContext)(undefined);
var $c06c4bb7dffe0deb$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $8nGP5.createContext)(undefined);
var $c06c4bb7dffe0deb$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $8nGP5.createContext)(undefined);
var $c06c4bb7dffe0deb$export$482c85f2026f212e = /*#__PURE__*/ (0, $8nGP5.createContext)({});
var $c06c4bb7dffe0deb$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $8nGP5.createContext)(undefined);
var $c06c4bb7dffe0deb$export$b18854f928720bc8 = /*#__PURE__*/ (0, $8nGP5.createContext)(0);
var $c06c4bb7dffe0deb$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $8nGP5.createContext)(0);
var $c06c4bb7dffe0deb$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $de77b8275d271892$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $c06c4bb7dffe0deb$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$e42cfe3f3988c70f);
};
function $c06c4bb7dffe0deb$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var $c06c4bb7dffe0deb$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
    return xAxis;
};
var $c06c4bb7dffe0deb$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$92c2a2c8239475bf);
    return (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(xAxisMap);
};
var $c06c4bb7dffe0deb$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$40ceabe61e17c4dc);
    return (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(yAxisMap);
};
var $c06c4bb7dffe0deb$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($5b6ee6816960e591$exports)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($0a6c56731a98b599$exports)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(yAxisMap);
};
var $c06c4bb7dffe0deb$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
    return yAxis;
};
var $c06c4bb7dffe0deb$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$29b7735f8b5653b2);
    return viewBox;
};
var $c06c4bb7dffe0deb$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$482c85f2026f212e);
};
var $c06c4bb7dffe0deb$export$8854f7ece606854b = function useChartWidth() {
    return (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$3c3f0c9338cf7530);
};
var $c06c4bb7dffe0deb$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$b18854f928720bc8);
};


var $836f11cfcda8d642$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $836f11cfcda8d642$var$_excluded2 = [
    "offset"
];
function $836f11cfcda8d642$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $836f11cfcda8d642$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $836f11cfcda8d642$var$_typeof(o);
}
function $836f11cfcda8d642$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $836f11cfcda8d642$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $836f11cfcda8d642$var$ownKeys(Object(t), !0).forEach(function(r) {
            $836f11cfcda8d642$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $836f11cfcda8d642$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $836f11cfcda8d642$var$_defineProperty(obj, key, value) {
    key = $836f11cfcda8d642$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $836f11cfcda8d642$var$_toPropertyKey(t) {
    var i = $836f11cfcda8d642$var$_toPrimitive(t, "string");
    return "symbol" == $836f11cfcda8d642$var$_typeof(i) ? i : i + "";
}
function $836f11cfcda8d642$var$_toPrimitive(t, r) {
    if ("object" != $836f11cfcda8d642$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $836f11cfcda8d642$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $836f11cfcda8d642$var$_extends() {
    $836f11cfcda8d642$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $836f11cfcda8d642$var$_extends.apply(this, arguments);
}
function $836f11cfcda8d642$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $836f11cfcda8d642$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $836f11cfcda8d642$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $836f11cfcda8d642$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $836f11cfcda8d642$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $836f11cfcda8d642$var$_objectWithoutProperties(props, $836f11cfcda8d642$var$_excluded);
        var _filterProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $836f11cfcda8d642$var$_objectWithoutProperties(_filterProps, $836f11cfcda8d642$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", $836f11cfcda8d642$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $836f11cfcda8d642$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $836f11cfcda8d642$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $836f11cfcda8d642$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $836f11cfcda8d642$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $836f11cfcda8d642$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $836f11cfcda8d642$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $836f11cfcda8d642$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $cc31aced37ecb634$export$846dc5ac5fecff74)((0, $dfb3031f2e0bc9fa$export$3d27d42b1034de5c)($836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, (0, $040ce345c37febc7$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $836f11cfcda8d642$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $cc31aced37ecb634$export$846dc5ac5fecff74)((0, $dfb3031f2e0bc9fa$export$3d27d42b1034de5c)($836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, (0, $040ce345c37febc7$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $836f11cfcda8d642$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $836f11cfcda8d642$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $c06c4bb7dffe0deb$export$8854f7ece606854b)();
    var chartHeight = (0, $c06c4bb7dffe0deb$export$369ae257969c6f9f)();
    var offset = (0, $c06c4bb7dffe0deb$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $836f11cfcda8d642$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $836f11cfcda8d642$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $836f11cfcda8d642$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $836f11cfcda8d642$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $836f11cfcda8d642$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $836f11cfcda8d642$var$defaultProps.verticalFill,
        x: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $c06c4bb7dffe0deb$export$1d855c2865750a72)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $c06c4bb7dffe0deb$export$631ee617f1052e16)();
    if (!(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(x) || x !== +x || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $836f11cfcda8d642$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $836f11cfcda8d642$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($836f11cfcda8d642$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($836f11cfcda8d642$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($836f11cfcda8d642$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($836f11cfcda8d642$var$HorizontalGridLines, $836f11cfcda8d642$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($836f11cfcda8d642$var$VerticalGridLines, $836f11cfcda8d642$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($836f11cfcda8d642$var$HorizontalStripes, $836f11cfcda8d642$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($836f11cfcda8d642$var$VerticalStripes, $836f11cfcda8d642$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$836f11cfcda8d642$export$6440e27b9f186856.displayName = 'CartesianGrid';


var $8nGP5 = parcelRequire("8nGP5");





var $ajIhI = parcelRequire("ajIhI");

var $8nGP5 = parcelRequire("8nGP5");




var $ajIhI = parcelRequire("ajIhI");



function $1371972ac018f8f3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1371972ac018f8f3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1371972ac018f8f3$var$_typeof(o);
}
function $1371972ac018f8f3$var$_extends() {
    $1371972ac018f8f3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1371972ac018f8f3$var$_extends.apply(this, arguments);
}
function $1371972ac018f8f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1371972ac018f8f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1371972ac018f8f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1371972ac018f8f3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1371972ac018f8f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1371972ac018f8f3$var$_defineProperty(obj, key, value) {
    key = $1371972ac018f8f3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1371972ac018f8f3$var$_toPropertyKey(t) {
    var i = $1371972ac018f8f3$var$_toPrimitive(t, "string");
    return "symbol" == $1371972ac018f8f3$var$_typeof(i) ? i : i + "";
}
function $1371972ac018f8f3$var$_toPrimitive(t, r) {
    if ("object" != $1371972ac018f8f3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1371972ac018f8f3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1371972ac018f8f3$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $4efdaf596664c2fb$exports.curveBasisClosed),
    curveBasisOpen: (0, $4efdaf596664c2fb$exports.curveBasisOpen),
    curveBasis: (0, $4efdaf596664c2fb$exports.curveBasis),
    curveBumpX: (0, $4efdaf596664c2fb$exports.curveBumpX),
    curveBumpY: (0, $4efdaf596664c2fb$exports.curveBumpY),
    curveLinearClosed: (0, $4efdaf596664c2fb$exports.curveLinearClosed),
    curveLinear: (0, $4efdaf596664c2fb$exports.curveLinear),
    curveMonotoneX: (0, $4efdaf596664c2fb$exports.curveMonotoneX),
    curveMonotoneY: (0, $4efdaf596664c2fb$exports.curveMonotoneY),
    curveNatural: (0, $4efdaf596664c2fb$exports.curveNatural),
    curveStep: (0, $4efdaf596664c2fb$exports.curveStep),
    curveStepAfter: (0, $4efdaf596664c2fb$exports.curveStepAfter),
    curveStepBefore: (0, $4efdaf596664c2fb$exports.curveStepBefore)
};
var $1371972ac018f8f3$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $1371972ac018f8f3$var$getX = function getX(p) {
    return p.x;
};
var $1371972ac018f8f3$var$getY = function getY(p) {
    return p.y;
};
var $1371972ac018f8f3$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($dba9b32de817c336$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $1371972ac018f8f3$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $1371972ac018f8f3$var$CURVE_FACTORIES[name] || (0, $4efdaf596664c2fb$exports.curveLinear);
};
var $1371972ac018f8f3$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $1371972ac018f8f3$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $1371972ac018f8f3$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $1371972ac018f8f3$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $1371972ac018f8f3$var$_objectSpread($1371972ac018f8f3$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $4efdaf596664c2fb$exports.area)().y($1371972ac018f8f3$var$getY).x1($1371972ac018f8f3$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $4efdaf596664c2fb$exports.area)().x($1371972ac018f8f3$var$getX).y1($1371972ac018f8f3$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($1371972ac018f8f3$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $4efdaf596664c2fb$exports.area)().y($1371972ac018f8f3$var$getY).x1($1371972ac018f8f3$var$getX).x0(baseLine);
    else if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $4efdaf596664c2fb$exports.area)().x($1371972ac018f8f3$var$getX).y1($1371972ac018f8f3$var$getY).y0(baseLine);
    else lineFunction = (0, $4efdaf596664c2fb$exports.line)().x($1371972ac018f8f3$var$getX).y($1371972ac018f8f3$var$getY);
    lineFunction.defined($1371972ac018f8f3$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $1371972ac018f8f3$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $1371972ac018f8f3$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $1371972ac018f8f3$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, false), (0, $f1d44a0cc6cff721$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $ajIhI.default)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");


function $5c4d5cf43eecf2f0$var$_extends() {
    $5c4d5cf43eecf2f0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5c4d5cf43eecf2f0$var$_extends.apply(this, arguments);
}
var $5c4d5cf43eecf2f0$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $ajIhI.default)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("circle", $5c4d5cf43eecf2f0$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, false), (0, $f1d44a0cc6cff721$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};









var $a0158cc2cd24124f$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
], $a0158cc2cd24124f$var$_excluded2 = [
    "key"
];
function $a0158cc2cd24124f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a0158cc2cd24124f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a0158cc2cd24124f$var$_typeof(o);
}
function $a0158cc2cd24124f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a0158cc2cd24124f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a0158cc2cd24124f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a0158cc2cd24124f$var$_extends() {
    $a0158cc2cd24124f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0158cc2cd24124f$var$_extends.apply(this, arguments);
}
function $a0158cc2cd24124f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0158cc2cd24124f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0158cc2cd24124f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a0158cc2cd24124f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0158cc2cd24124f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a0158cc2cd24124f$var$_toConsumableArray(arr) {
    return $a0158cc2cd24124f$var$_arrayWithoutHoles(arr) || $a0158cc2cd24124f$var$_iterableToArray(arr) || $a0158cc2cd24124f$var$_unsupportedIterableToArray(arr) || $a0158cc2cd24124f$var$_nonIterableSpread();
}
function $a0158cc2cd24124f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a0158cc2cd24124f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a0158cc2cd24124f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a0158cc2cd24124f$var$_arrayLikeToArray(o, minLen);
}
function $a0158cc2cd24124f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a0158cc2cd24124f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a0158cc2cd24124f$var$_arrayLikeToArray(arr);
}
function $a0158cc2cd24124f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a0158cc2cd24124f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a0158cc2cd24124f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a0158cc2cd24124f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a0158cc2cd24124f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a0158cc2cd24124f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a0158cc2cd24124f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a0158cc2cd24124f$var$_callSuper(t, o, e) {
    return o = $a0158cc2cd24124f$var$_getPrototypeOf(o), $a0158cc2cd24124f$var$_possibleConstructorReturn(t, $a0158cc2cd24124f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $a0158cc2cd24124f$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $a0158cc2cd24124f$var$_possibleConstructorReturn(self, call) {
    if (call && ($a0158cc2cd24124f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a0158cc2cd24124f$var$_assertThisInitialized(self);
}
function $a0158cc2cd24124f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a0158cc2cd24124f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a0158cc2cd24124f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a0158cc2cd24124f$var$_getPrototypeOf(o) {
    $a0158cc2cd24124f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a0158cc2cd24124f$var$_getPrototypeOf(o);
}
function $a0158cc2cd24124f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a0158cc2cd24124f$var$_setPrototypeOf(subClass, superClass);
}
function $a0158cc2cd24124f$var$_setPrototypeOf(o, p) {
    $a0158cc2cd24124f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a0158cc2cd24124f$var$_setPrototypeOf(o, p);
}
function $a0158cc2cd24124f$var$_defineProperty(obj, key, value) {
    key = $a0158cc2cd24124f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a0158cc2cd24124f$var$_toPropertyKey(t) {
    var i = $a0158cc2cd24124f$var$_toPrimitive(t, "string");
    return "symbol" == $a0158cc2cd24124f$var$_typeof(i) ? i : i + "";
}
function $a0158cc2cd24124f$var$_toPrimitive(t, r) {
    if ("object" != $a0158cc2cd24124f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a0158cc2cd24124f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a0158cc2cd24124f$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    function Line() {
        var _this;
        $a0158cc2cd24124f$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $a0158cc2cd24124f$var$_callSuper(this, Line, [].concat(args));
        $a0158cc2cd24124f$var$_defineProperty(_this, "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $a0158cc2cd24124f$var$_defineProperty(_this, "generateSimpleStrokeDasharray", function(totalLength, length) {
            return "".concat(length, "px ").concat(totalLength - length, "px");
        });
        $a0158cc2cd24124f$var$_defineProperty(_this, "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            // if lineLength is 0 return the default when no strokeDasharray is provided
            if (!lineLength) return _this.generateSimpleStrokeDasharray(totalLength, length);
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($a0158cc2cd24124f$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($a0158cc2cd24124f$var$_toConsumableArray(Line.repeat(lines, count)), $a0158cc2cd24124f$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(', ');
        });
        $a0158cc2cd24124f$var$_defineProperty(_this, "id", (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts-line-'));
        $a0158cc2cd24124f$var$_defineProperty(_this, "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $a0158cc2cd24124f$var$_defineProperty(_this, "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $a0158cc2cd24124f$var$_defineProperty(_this, "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $a0158cc2cd24124f$var$_inherits(Line, _PureComponent);
    return $a0158cc2cd24124f$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                if (totalLength !== this.state.totalLength) this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $d0e02a4abf979d13$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $cc31aced37ecb634$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(item, {
                        key: "bar-".concat(item.props.dataKey),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        value: entry.value,
                        dataKey: dataKey,
                        payload: entry.payload,
                        points: points
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $a0158cc2cd24124f$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $a0158cc2cd24124f$var$_objectWithoutProperties(_this$props3, $a0158cc2cd24124f$var$_excluded);
                var curveProps = $a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: 'none',
                    className: 'recharts-line-curve',
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1371972ac018f8f3$export$b0e83c3ef8d2db1), $a0158cc2cd24124f$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $32fd8300d9e7a1d4$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $ajIhI.default)('recharts-line', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $8b99c43c69c5c37b$export$392f6c9701718a4e)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $e476a06be597057a$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($a0158cc2cd24124f$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($a0158cc2cd24124f$var$_toConsumableArray(result), $a0158cc2cd24124f$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) dotItem = option(props);
                else {
                    var key = props.key, dotProps = $a0158cc2cd24124f$var$_objectWithoutProperties(props, $a0158cc2cd24124f$var$_excluded2);
                    var className = (0, $ajIhI.default)('recharts-line-dot', typeof option !== 'boolean' ? option.className : '');
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $5c4d5cf43eecf2f0$export$d046b3c4a416f60d), $a0158cc2cd24124f$var$_extends({
                        key: key
                    }, dotProps, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$a0158cc2cd24124f$var$_defineProperty($a0158cc2cd24124f$export$17d680238e50603e, "displayName", 'Line');
$a0158cc2cd24124f$var$_defineProperty($a0158cc2cd24124f$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    fill: '#fff',
    points: [],
    isAnimationActive: !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $a0158cc2cd24124f$var$_defineProperty($a0158cc2cd24124f$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === 'horizontal') return {
            x: (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $a0158cc2cd24124f$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Line Chart
 */ 
var $8nGP5 = parcelRequire("8nGP5");


var $1b98d377f77cff70$exports = {};
var $fccba66310ac2d90$exports = {};
var $609b44c1ee046c31$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $609b44c1ee046c31$var$nativeCeil = Math.ceil, $609b44c1ee046c31$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $609b44c1ee046c31$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $609b44c1ee046c31$var$nativeMax($609b44c1ee046c31$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$609b44c1ee046c31$exports = $609b44c1ee046c31$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $fccba66310ac2d90$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $b4e75ea659f79f53$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $72c8651a1f6abbcd$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $72c8651a1f6abbcd$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $72c8651a1f6abbcd$exports(step);
        return $609b44c1ee046c31$exports(start, end, step, fromRight);
    };
}
$fccba66310ac2d90$exports = $fccba66310ac2d90$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $1b98d377f77cff70$var$range = $fccba66310ac2d90$exports();
$1b98d377f77cff70$exports = $1b98d377f77cff70$var$range;




var $a090addee6f26581$exports = {};
var $483de91136f09fd5$exports = {};

var $000c4c084007e7b6$exports = {};

var $2jpDk = parcelRequire("2jpDk");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $000c4c084007e7b6$var$now = function() {
    return $2jpDk.Date.now();
};
$000c4c084007e7b6$exports = $000c4c084007e7b6$var$now;



/** Error message constants. */ var $483de91136f09fd5$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $483de91136f09fd5$var$nativeMax = Math.max, $483de91136f09fd5$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $483de91136f09fd5$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($483de91136f09fd5$var$FUNC_ERROR_TEXT);
    wait = $47f0826a017aad43$exports(wait) || 0;
    if ($4679825e1cdd07bc$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $483de91136f09fd5$var$nativeMax($47f0826a017aad43$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $483de91136f09fd5$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $000c4c084007e7b6$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($000c4c084007e7b6$exports());
    }
    function debounced() {
        var time = $000c4c084007e7b6$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$483de91136f09fd5$exports = $483de91136f09fd5$var$debounce;



/** Error message constants. */ var $a090addee6f26581$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $a090addee6f26581$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($a090addee6f26581$var$FUNC_ERROR_TEXT);
    if ($4679825e1cdd07bc$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $483de91136f09fd5$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$a090addee6f26581$exports = $a090addee6f26581$var$throttle;



var $ajIhI = parcelRequire("ajIhI");




var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");



var $ajIhI = parcelRequire("ajIhI");

function $36951101fab10caa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $36951101fab10caa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $36951101fab10caa$var$_typeof(o);
}
function $36951101fab10caa$var$_extends() {
    $36951101fab10caa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36951101fab10caa$var$_extends.apply(this, arguments);
}
function $36951101fab10caa$var$_slicedToArray(arr, i) {
    return $36951101fab10caa$var$_arrayWithHoles(arr) || $36951101fab10caa$var$_iterableToArrayLimit(arr, i) || $36951101fab10caa$var$_unsupportedIterableToArray(arr, i) || $36951101fab10caa$var$_nonIterableRest();
}
function $36951101fab10caa$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $36951101fab10caa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $36951101fab10caa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $36951101fab10caa$var$_arrayLikeToArray(o, minLen);
}
function $36951101fab10caa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $36951101fab10caa$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $36951101fab10caa$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $36951101fab10caa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $36951101fab10caa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $36951101fab10caa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $36951101fab10caa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $36951101fab10caa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $36951101fab10caa$var$_defineProperty(obj, key, value) {
    key = $36951101fab10caa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $36951101fab10caa$var$_toPropertyKey(t) {
    var i = $36951101fab10caa$var$_toPrimitive(t, "string");
    return "symbol" == $36951101fab10caa$var$_typeof(i) ? i : i + "";
}
function $36951101fab10caa$var$_toPrimitive(t, r) {
    if ("object" != $36951101fab10caa$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $36951101fab10caa$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $36951101fab10caa$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(value[0]) && (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $36951101fab10caa$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($0082dfda2c4d7cdc$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $36951101fab10caa$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $36951101fab10caa$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $36951101fab10caa$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $36951101fab10caa$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $36951101fab10caa$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $ajIhI.default)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $ajIhI.default)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", $36951101fab10caa$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");

function $0e36cf037831a0be$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0e36cf037831a0be$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0e36cf037831a0be$var$_typeof(o);
}
function $0e36cf037831a0be$var$_defineProperty(obj, key, value) {
    key = $0e36cf037831a0be$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0e36cf037831a0be$var$_toPropertyKey(t) {
    var i = $0e36cf037831a0be$var$_toPrimitive(t, "string");
    return "symbol" == $0e36cf037831a0be$var$_typeof(i) ? i : i + "";
}
function $0e36cf037831a0be$var$_toPrimitive(t, r) {
    if ("object" != $0e36cf037831a0be$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0e36cf037831a0be$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0e36cf037831a0be$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $0e36cf037831a0be$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $0e36cf037831a0be$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $ajIhI.default)($0e36cf037831a0be$var$CSS_CLASS_PREFIX, $0e36cf037831a0be$var$_defineProperty($0e36cf037831a0be$var$_defineProperty($0e36cf037831a0be$var$_defineProperty($0e36cf037831a0be$var$_defineProperty({}, "".concat($0e36cf037831a0be$var$CSS_CLASS_PREFIX, "-right"), (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(translateX) && coordinate && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), "".concat($0e36cf037831a0be$var$CSS_CLASS_PREFIX, "-left"), (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(translateX) && coordinate && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), "".concat($0e36cf037831a0be$var$CSS_CLASS_PREFIX, "-bottom"), (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(translateY) && coordinate && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), "".concat($0e36cf037831a0be$var$CSS_CLASS_PREFIX, "-top"), (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(translateY) && coordinate && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y));
}
function $0e36cf037831a0be$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $0e36cf037831a0be$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $0e36cf037831a0be$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $0e36cf037831a0be$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $0e36cf037831a0be$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $0e36cf037831a0be$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $0e36cf037831a0be$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $0e36cf037831a0be$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $6380d2f9caef22b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6380d2f9caef22b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6380d2f9caef22b9$var$_typeof(o);
}
function $6380d2f9caef22b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6380d2f9caef22b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6380d2f9caef22b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6380d2f9caef22b9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6380d2f9caef22b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6380d2f9caef22b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6380d2f9caef22b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6380d2f9caef22b9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6380d2f9caef22b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6380d2f9caef22b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6380d2f9caef22b9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6380d2f9caef22b9$var$_callSuper(t, o, e) {
    return o = $6380d2f9caef22b9$var$_getPrototypeOf(o), $6380d2f9caef22b9$var$_possibleConstructorReturn(t, $6380d2f9caef22b9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $6380d2f9caef22b9$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $6380d2f9caef22b9$var$_possibleConstructorReturn(self, call) {
    if (call && ($6380d2f9caef22b9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6380d2f9caef22b9$var$_assertThisInitialized(self);
}
function $6380d2f9caef22b9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6380d2f9caef22b9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6380d2f9caef22b9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6380d2f9caef22b9$var$_getPrototypeOf(o) {
    $6380d2f9caef22b9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6380d2f9caef22b9$var$_getPrototypeOf(o);
}
function $6380d2f9caef22b9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6380d2f9caef22b9$var$_setPrototypeOf(subClass, superClass);
}
function $6380d2f9caef22b9$var$_setPrototypeOf(o, p) {
    $6380d2f9caef22b9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6380d2f9caef22b9$var$_setPrototypeOf(o, p);
}
function $6380d2f9caef22b9$var$_defineProperty(obj, key, value) {
    key = $6380d2f9caef22b9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6380d2f9caef22b9$var$_toPropertyKey(t) {
    var i = $6380d2f9caef22b9$var$_toPrimitive(t, "string");
    return "symbol" == $6380d2f9caef22b9$var$_typeof(i) ? i : i + "";
}
function $6380d2f9caef22b9$var$_toPrimitive(t, r) {
    if ("object" != $6380d2f9caef22b9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6380d2f9caef22b9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6380d2f9caef22b9$var$EPSILON = 1;
var $6380d2f9caef22b9$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        $6380d2f9caef22b9$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6380d2f9caef22b9$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $6380d2f9caef22b9$var$_defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $6380d2f9caef22b9$var$_defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $6380d2f9caef22b9$var$_inherits(TooltipBoundingBox, _PureComponent);
    return $6380d2f9caef22b9$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $6380d2f9caef22b9$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $6380d2f9caef22b9$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $0e36cf037831a0be$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $6380d2f9caef22b9$var$_objectSpread($6380d2f9caef22b9$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, $8nGP5.PureComponent));




function $c1ee5960bb8c7c28$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c1ee5960bb8c7c28$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c1ee5960bb8c7c28$var$_typeof(o);
}
function $c1ee5960bb8c7c28$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c1ee5960bb8c7c28$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c1ee5960bb8c7c28$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c1ee5960bb8c7c28$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c1ee5960bb8c7c28$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c1ee5960bb8c7c28$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c1ee5960bb8c7c28$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c1ee5960bb8c7c28$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c1ee5960bb8c7c28$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c1ee5960bb8c7c28$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c1ee5960bb8c7c28$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c1ee5960bb8c7c28$var$_callSuper(t, o, e) {
    return o = $c1ee5960bb8c7c28$var$_getPrototypeOf(o), $c1ee5960bb8c7c28$var$_possibleConstructorReturn(t, $c1ee5960bb8c7c28$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c1ee5960bb8c7c28$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c1ee5960bb8c7c28$var$_possibleConstructorReturn(self, call) {
    if (call && ($c1ee5960bb8c7c28$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c1ee5960bb8c7c28$var$_assertThisInitialized(self);
}
function $c1ee5960bb8c7c28$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c1ee5960bb8c7c28$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c1ee5960bb8c7c28$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c1ee5960bb8c7c28$var$_getPrototypeOf(o) {
    $c1ee5960bb8c7c28$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c1ee5960bb8c7c28$var$_getPrototypeOf(o);
}
function $c1ee5960bb8c7c28$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c1ee5960bb8c7c28$var$_setPrototypeOf(subClass, superClass);
}
function $c1ee5960bb8c7c28$var$_setPrototypeOf(o, p) {
    $c1ee5960bb8c7c28$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c1ee5960bb8c7c28$var$_setPrototypeOf(o, p);
}
function $c1ee5960bb8c7c28$var$_defineProperty(obj, key, value) {
    key = $c1ee5960bb8c7c28$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c1ee5960bb8c7c28$var$_toPropertyKey(t) {
    var i = $c1ee5960bb8c7c28$var$_toPrimitive(t, "string");
    return "symbol" == $c1ee5960bb8c7c28$var$_typeof(i) ? i : i + "";
}
function $c1ee5960bb8c7c28$var$_toPrimitive(t, r) {
    if ("object" != $c1ee5960bb8c7c28$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c1ee5960bb8c7c28$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c1ee5960bb8c7c28$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $c1ee5960bb8c7c28$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $36951101fab10caa$export$6fe33945eebf9ac8), props);
}
var $c1ee5960bb8c7c28$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        $c1ee5960bb8c7c28$var$_classCallCheck(this, Tooltip);
        return $c1ee5960bb8c7c28$var$_callSuper(this, Tooltip, arguments);
    }
    $c1ee5960bb8c7c28$var$_inherits(Tooltip, _PureComponent);
    return $c1ee5960bb8c7c28$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $45b995e155031399$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $c1ee5960bb8c7c28$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $6380d2f9caef22b9$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $c1ee5960bb8c7c28$var$renderContent(content, $c1ee5960bb8c7c28$var$_objectSpread($c1ee5960bb8c7c28$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$c1ee5960bb8c7c28$var$_defineProperty($c1ee5960bb8c7c28$export$28c660c63b792dea, "displayName", 'Tooltip');
$c1ee5960bb8c7c28$var$_defineProperty($c1ee5960bb8c7c28$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});







var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");







function $2de67ced7c3f1e5b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2de67ced7c3f1e5b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2de67ced7c3f1e5b$var$_typeof(o);
}
function $2de67ced7c3f1e5b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2de67ced7c3f1e5b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2de67ced7c3f1e5b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2de67ced7c3f1e5b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2de67ced7c3f1e5b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2de67ced7c3f1e5b$var$_defineProperty(obj, key, value) {
    key = $2de67ced7c3f1e5b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2de67ced7c3f1e5b$var$_toPropertyKey(t) {
    var i = $2de67ced7c3f1e5b$var$_toPrimitive(t, "string");
    return "symbol" == $2de67ced7c3f1e5b$var$_typeof(i) ? i : i + "";
}
function $2de67ced7c3f1e5b$var$_toPrimitive(t, r) {
    if ("object" != $2de67ced7c3f1e5b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2de67ced7c3f1e5b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2de67ced7c3f1e5b$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $2de67ced7c3f1e5b$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $2de67ced7c3f1e5b$var$PREFIX_LIST.reduce(function(res, entry) {
        return $2de67ced7c3f1e5b$var$_objectSpread($2de67ced7c3f1e5b$var$_objectSpread({}, res), {}, $2de67ced7c3f1e5b$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $099f4aa5be8152a1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $099f4aa5be8152a1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $099f4aa5be8152a1$var$_typeof(o);
}
function $099f4aa5be8152a1$var$_extends() {
    $099f4aa5be8152a1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $099f4aa5be8152a1$var$_extends.apply(this, arguments);
}
function $099f4aa5be8152a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $099f4aa5be8152a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $099f4aa5be8152a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $099f4aa5be8152a1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $099f4aa5be8152a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $099f4aa5be8152a1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $099f4aa5be8152a1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $099f4aa5be8152a1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $099f4aa5be8152a1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $099f4aa5be8152a1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $099f4aa5be8152a1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $099f4aa5be8152a1$var$_callSuper(t, o, e) {
    return o = $099f4aa5be8152a1$var$_getPrototypeOf(o), $099f4aa5be8152a1$var$_possibleConstructorReturn(t, $099f4aa5be8152a1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $099f4aa5be8152a1$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $099f4aa5be8152a1$var$_possibleConstructorReturn(self, call) {
    if (call && ($099f4aa5be8152a1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $099f4aa5be8152a1$var$_assertThisInitialized(self);
}
function $099f4aa5be8152a1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $099f4aa5be8152a1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($099f4aa5be8152a1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $099f4aa5be8152a1$var$_getPrototypeOf(o) {
    $099f4aa5be8152a1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $099f4aa5be8152a1$var$_getPrototypeOf(o);
}
function $099f4aa5be8152a1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $099f4aa5be8152a1$var$_setPrototypeOf(subClass, superClass);
}
function $099f4aa5be8152a1$var$_setPrototypeOf(o, p) {
    $099f4aa5be8152a1$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $099f4aa5be8152a1$var$_setPrototypeOf(o, p);
}
function $099f4aa5be8152a1$var$_defineProperty(obj, key, value) {
    key = $099f4aa5be8152a1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $099f4aa5be8152a1$var$_toPropertyKey(t) {
    var i = $099f4aa5be8152a1$var$_toPrimitive(t, "string");
    return "symbol" == $099f4aa5be8152a1$var$_typeof(i) ? i : i + "";
}
function $099f4aa5be8152a1$var$_toPrimitive(t, r) {
    if ("object" != $099f4aa5be8152a1$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $099f4aa5be8152a1$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $099f4aa5be8152a1$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $5389c27663bb3a0e$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($1b98d377f77cff70$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $099f4aa5be8152a1$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $099f4aa5be8152a1$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        $099f4aa5be8152a1$var$_classCallCheck(this, Brush);
        _this = $099f4aa5be8152a1$var$_callSuper(this, Brush, [
            props
        ]);
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = $099f4aa5be8152a1$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
            endX: _this.handleTravellerDragStart.bind(_this, 'endX')
        };
        _this.state = {};
        return _this;
    }
    $099f4aa5be8152a1$var$_inherits(Brush, _PureComponent);
    return $099f4aa5be8152a1$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $099f4aa5be8152a1$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($099f4aa5be8152a1$var$_defineProperty($099f4aa5be8152a1$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState($099f4aa5be8152a1$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $8nGP5.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $099f4aa5be8152a1$var$_objectSpread($099f4aa5be8152a1$var$_objectSpread({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $844463820b79d851$export$5f1af8db9871e1d6), $099f4aa5be8152a1$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $844463820b79d851$export$5f1af8db9871e1d6), $099f4aa5be8152a1$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(x) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(y) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $ajIhI.default)('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.count(children) === 1;
                var style = (0, $2de67ced7c3f1e5b$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $099f4aa5be8152a1$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $099f4aa5be8152a1$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$099f4aa5be8152a1$var$_defineProperty($099f4aa5be8152a1$export$59bc2e3533b384a0, "displayName", 'Brush');
$099f4aa5be8152a1$var$_defineProperty($099f4aa5be8152a1$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");




var $f3c1c1fa4db1e67b$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};





function $b32d0da43da8e062$var$_extends() {
    $b32d0da43da8e062$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b32d0da43da8e062$var$_extends.apply(this, arguments);
}
function $b32d0da43da8e062$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b32d0da43da8e062$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b32d0da43da8e062$var$_typeof(o);
}
function $b32d0da43da8e062$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b32d0da43da8e062$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b32d0da43da8e062$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b32d0da43da8e062$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b32d0da43da8e062$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b32d0da43da8e062$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b32d0da43da8e062$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b32d0da43da8e062$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b32d0da43da8e062$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b32d0da43da8e062$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b32d0da43da8e062$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b32d0da43da8e062$var$_callSuper(t, o, e) {
    return o = $b32d0da43da8e062$var$_getPrototypeOf(o), $b32d0da43da8e062$var$_possibleConstructorReturn(t, $b32d0da43da8e062$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $b32d0da43da8e062$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $b32d0da43da8e062$var$_possibleConstructorReturn(self, call) {
    if (call && ($b32d0da43da8e062$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b32d0da43da8e062$var$_assertThisInitialized(self);
}
function $b32d0da43da8e062$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b32d0da43da8e062$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b32d0da43da8e062$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $b32d0da43da8e062$var$_getPrototypeOf(o) {
    $b32d0da43da8e062$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b32d0da43da8e062$var$_getPrototypeOf(o);
}
function $b32d0da43da8e062$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b32d0da43da8e062$var$_setPrototypeOf(subClass, superClass);
}
function $b32d0da43da8e062$var$_setPrototypeOf(o, p) {
    $b32d0da43da8e062$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b32d0da43da8e062$var$_setPrototypeOf(o, p);
}
function $b32d0da43da8e062$var$_defineProperty(obj, key, value) {
    key = $b32d0da43da8e062$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b32d0da43da8e062$var$_toPropertyKey(t) {
    var i = $b32d0da43da8e062$var$_toPrimitive(t, "string");
    return "symbol" == $b32d0da43da8e062$var$_typeof(i) ? i : i + "";
}
function $b32d0da43da8e062$var$_toPrimitive(t, r) {
    if ("object" != $b32d0da43da8e062$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b32d0da43da8e062$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b32d0da43da8e062$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $b57066fd5661be22$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
var $b32d0da43da8e062$export$aa7f0b0106bff39 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        $b32d0da43da8e062$var$_classCallCheck(this, ReferenceDot);
        return $b32d0da43da8e062$var$_callSuper(this, ReferenceDot, arguments);
    }
    $b32d0da43da8e062$var$_inherits(ReferenceDot, _React$Component);
    return $b32d0da43da8e062$var$_createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(x);
                var isY = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(y);
                (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = $b32d0da43da8e062$var$getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = $b32d0da43da8e062$var$_objectSpread($b32d0da43da8e062$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: (0, $ajIhI.default)('recharts-reference-dot', className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$b32d0da43da8e062$var$_defineProperty($b32d0da43da8e062$export$aa7f0b0106bff39, "displayName", 'ReferenceDot');
$b32d0da43da8e062$var$_defineProperty($b32d0da43da8e062$export$aa7f0b0106bff39, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
});
$b32d0da43da8e062$var$_defineProperty($b32d0da43da8e062$export$aa7f0b0106bff39, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $5c4d5cf43eecf2f0$export$d046b3c4a416f60d), $b32d0da43da8e062$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});



var $8nGP5 = parcelRequire("8nGP5");

var $1c0fb2bbf2ed516e$exports = {};


var $def60b97c914d75a$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $def60b97c914d75a$var$baseSome(collection, predicate) {
    var result;
    $f1008ccff5feed7a$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$def60b97c914d75a$exports = $def60b97c914d75a$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $1c0fb2bbf2ed516e$var$some(collection, predicate, guard) {
    var func = $46116793eaa02c32$exports(collection) ? $63744a28e8fd4c84$exports : $def60b97c914d75a$exports;
    if (guard && $b4e75ea659f79f53$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $6aa52744a9ab51b8$exports(predicate, 3));
}
$1c0fb2bbf2ed516e$exports = $1c0fb2bbf2ed516e$var$some;



var $ajIhI = parcelRequire("ajIhI");








function $17044d3a00ece147$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $17044d3a00ece147$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $17044d3a00ece147$var$_typeof(o);
}
function $17044d3a00ece147$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $17044d3a00ece147$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $17044d3a00ece147$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $17044d3a00ece147$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $17044d3a00ece147$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $17044d3a00ece147$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $17044d3a00ece147$var$_callSuper(t, o, e) {
    return o = $17044d3a00ece147$var$_getPrototypeOf(o), $17044d3a00ece147$var$_possibleConstructorReturn(t, $17044d3a00ece147$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $17044d3a00ece147$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $17044d3a00ece147$var$_possibleConstructorReturn(self, call) {
    if (call && ($17044d3a00ece147$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $17044d3a00ece147$var$_assertThisInitialized(self);
}
function $17044d3a00ece147$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $17044d3a00ece147$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($17044d3a00ece147$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $17044d3a00ece147$var$_getPrototypeOf(o) {
    $17044d3a00ece147$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $17044d3a00ece147$var$_getPrototypeOf(o);
}
function $17044d3a00ece147$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $17044d3a00ece147$var$_setPrototypeOf(subClass, superClass);
}
function $17044d3a00ece147$var$_setPrototypeOf(o, p) {
    $17044d3a00ece147$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $17044d3a00ece147$var$_setPrototypeOf(o, p);
}
function $17044d3a00ece147$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $17044d3a00ece147$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $17044d3a00ece147$var$ownKeys(Object(t), !0).forEach(function(r) {
            $17044d3a00ece147$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $17044d3a00ece147$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $17044d3a00ece147$var$_defineProperty(obj, key, value) {
    key = $17044d3a00ece147$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $17044d3a00ece147$var$_toPropertyKey(t) {
    var i = $17044d3a00ece147$var$_toPrimitive(t, "string");
    return "symbol" == $17044d3a00ece147$var$_typeof(i) ? i : i + "";
}
function $17044d3a00ece147$var$_toPrimitive(t, r) {
    if ("object" != $17044d3a00ece147$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $17044d3a00ece147$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $17044d3a00ece147$var$_slicedToArray(arr, i) {
    return $17044d3a00ece147$var$_arrayWithHoles(arr) || $17044d3a00ece147$var$_iterableToArrayLimit(arr, i) || $17044d3a00ece147$var$_unsupportedIterableToArray(arr, i) || $17044d3a00ece147$var$_nonIterableRest();
}
function $17044d3a00ece147$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $17044d3a00ece147$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $17044d3a00ece147$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $17044d3a00ece147$var$_arrayLikeToArray(o, minLen);
}
function $17044d3a00ece147$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $17044d3a00ece147$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $17044d3a00ece147$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $17044d3a00ece147$var$_extends() {
    $17044d3a00ece147$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17044d3a00ece147$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $17044d3a00ece147$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", $17044d3a00ece147$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $17044d3a00ece147$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($1c0fb2bbf2ed516e$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $17044d3a00ece147$var$ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $c06c4bb7dffe0deb$export$71e825c43eae6ca6)();
    var xAxis = (0, $c06c4bb7dffe0deb$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $c06c4bb7dffe0deb$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $c06c4bb7dffe0deb$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $b57066fd5661be22$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(fixedX);
    var isY = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $17044d3a00ece147$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $17044d3a00ece147$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $17044d3a00ece147$var$_objectSpread($17044d3a00ece147$var$_objectSpread({
        clipPath: clipPath
    }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
        className: (0, $ajIhI.default)('recharts-reference-line', className)
    }, $17044d3a00ece147$var$renderLine(shape, lineProps), (0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).renderCallByParent(props, (0, $b57066fd5661be22$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var $17044d3a00ece147$export$b2f28e248e7838eb = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        $17044d3a00ece147$var$_classCallCheck(this, ReferenceLine);
        return $17044d3a00ece147$var$_callSuper(this, ReferenceLine, arguments);
    }
    $17044d3a00ece147$var$_inherits(ReferenceLine, _React$Component);
    return $17044d3a00ece147$var$_createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($17044d3a00ece147$var$ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$17044d3a00ece147$var$_defineProperty($17044d3a00ece147$export$b2f28e248e7838eb, "displayName", 'ReferenceLine');
$17044d3a00ece147$var$_defineProperty($17044d3a00ece147$export$b2f28e248e7838eb, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
});



var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");








function $fc15d13e0e07ae7f$var$_extends() {
    $fc15d13e0e07ae7f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc15d13e0e07ae7f$var$_extends.apply(this, arguments);
}
function $fc15d13e0e07ae7f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fc15d13e0e07ae7f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fc15d13e0e07ae7f$var$_typeof(o);
}
function $fc15d13e0e07ae7f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc15d13e0e07ae7f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc15d13e0e07ae7f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fc15d13e0e07ae7f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc15d13e0e07ae7f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fc15d13e0e07ae7f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fc15d13e0e07ae7f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $fc15d13e0e07ae7f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $fc15d13e0e07ae7f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fc15d13e0e07ae7f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fc15d13e0e07ae7f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fc15d13e0e07ae7f$var$_callSuper(t, o, e) {
    return o = $fc15d13e0e07ae7f$var$_getPrototypeOf(o), $fc15d13e0e07ae7f$var$_possibleConstructorReturn(t, $fc15d13e0e07ae7f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $fc15d13e0e07ae7f$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $fc15d13e0e07ae7f$var$_possibleConstructorReturn(self, call) {
    if (call && ($fc15d13e0e07ae7f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $fc15d13e0e07ae7f$var$_assertThisInitialized(self);
}
function $fc15d13e0e07ae7f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fc15d13e0e07ae7f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fc15d13e0e07ae7f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $fc15d13e0e07ae7f$var$_getPrototypeOf(o) {
    $fc15d13e0e07ae7f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fc15d13e0e07ae7f$var$_getPrototypeOf(o);
}
function $fc15d13e0e07ae7f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $fc15d13e0e07ae7f$var$_setPrototypeOf(subClass, superClass);
}
function $fc15d13e0e07ae7f$var$_setPrototypeOf(o, p) {
    $fc15d13e0e07ae7f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fc15d13e0e07ae7f$var$_setPrototypeOf(o, p);
}
function $fc15d13e0e07ae7f$var$_defineProperty(obj, key, value) {
    key = $fc15d13e0e07ae7f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fc15d13e0e07ae7f$var$_toPropertyKey(t) {
    var i = $fc15d13e0e07ae7f$var$_toPrimitive(t, "string");
    return "symbol" == $fc15d13e0e07ae7f$var$_typeof(i) ? i : i + "";
}
function $fc15d13e0e07ae7f$var$_toPrimitive(t, r) {
    if ("object" != $fc15d13e0e07ae7f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fc15d13e0e07ae7f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fc15d13e0e07ae7f$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $b57066fd5661be22$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $b57066fd5661be22$export$c7964a5b9439ae62)(p1, p2);
};
var $fc15d13e0e07ae7f$export$b4ec4f050ce240b9 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        $fc15d13e0e07ae7f$var$_classCallCheck(this, ReferenceArea);
        return $fc15d13e0e07ae7f$var$_callSuper(this, ReferenceArea, arguments);
    }
    $fc15d13e0e07ae7f$var$_inherits(ReferenceArea, _React$Component);
    return $fc15d13e0e07ae7f$var$_createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(x1);
                var hasX2 = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(x2);
                var hasY1 = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(y1);
                var hasY2 = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = $fc15d13e0e07ae7f$var$getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: (0, $ajIhI.default)('recharts-reference-area', className)
                }, ReferenceArea.renderRect(shape, $fc15d13e0e07ae7f$var$_objectSpread($fc15d13e0e07ae7f$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, true)), rect)), (0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$fc15d13e0e07ae7f$var$_defineProperty($fc15d13e0e07ae7f$export$b4ec4f050ce240b9, "displayName", 'ReferenceArea');
$fc15d13e0e07ae7f$var$_defineProperty($fc15d13e0e07ae7f$export$b4ec4f050ce240b9, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
});
$fc15d13e0e07ae7f$var$_defineProperty($fc15d13e0e07ae7f$export$b4ec4f050ce240b9, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2a40e10cde5ed370$export$4617fb02663045ef), $fc15d13e0e07ae7f$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});





function $aae848d13cf3ba2c$var$_toConsumableArray(arr) {
    return $aae848d13cf3ba2c$var$_arrayWithoutHoles(arr) || $aae848d13cf3ba2c$var$_iterableToArray(arr) || $aae848d13cf3ba2c$var$_unsupportedIterableToArray(arr) || $aae848d13cf3ba2c$var$_nonIterableSpread();
}
function $aae848d13cf3ba2c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aae848d13cf3ba2c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aae848d13cf3ba2c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aae848d13cf3ba2c$var$_arrayLikeToArray(o, minLen);
}
function $aae848d13cf3ba2c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aae848d13cf3ba2c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aae848d13cf3ba2c$var$_arrayLikeToArray(arr);
}
function $aae848d13cf3ba2c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $aae848d13cf3ba2c$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $17044d3a00ece147$export$b2f28e248e7838eb));
    var dots = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $b32d0da43da8e062$export$aa7f0b0106bff39));
    var elements = [].concat($aae848d13cf3ba2c$var$_toConsumableArray(lines), $aae848d13cf3ba2c$var$_toConsumableArray(dots));
    var areas = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $fc15d13e0e07ae7f$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(el.props[key1]) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $f52b8f1d950ef826$exports = {};
'use strict';
var $f52b8f1d950ef826$var$has = Object.prototype.hasOwnProperty, $f52b8f1d950ef826$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $f52b8f1d950ef826$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $f52b8f1d950ef826$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $f52b8f1d950ef826$var$Events().__proto__) $f52b8f1d950ef826$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $f52b8f1d950ef826$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $f52b8f1d950ef826$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $f52b8f1d950ef826$var$EE(fn, context || emitter, once), evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $f52b8f1d950ef826$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $f52b8f1d950ef826$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $f52b8f1d950ef826$var$EventEmitter() {
    this._events = new $f52b8f1d950ef826$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($f52b8f1d950ef826$var$has.call(events, name)) names.push($f52b8f1d950ef826$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $f52b8f1d950ef826$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $f52b8f1d950ef826$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $f52b8f1d950ef826$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $f52b8f1d950ef826$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $f52b8f1d950ef826$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event;
        if (this._events[evt]) $f52b8f1d950ef826$var$clearEvent(this, evt);
    } else {
        this._events = new $f52b8f1d950ef826$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$f52b8f1d950ef826$var$EventEmitter.prototype.off = $f52b8f1d950ef826$var$EventEmitter.prototype.removeListener;
$f52b8f1d950ef826$var$EventEmitter.prototype.addListener = $f52b8f1d950ef826$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$f52b8f1d950ef826$var$EventEmitter.prefixed = $f52b8f1d950ef826$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$f52b8f1d950ef826$var$EventEmitter.EventEmitter = $f52b8f1d950ef826$var$EventEmitter;
$f52b8f1d950ef826$exports = $f52b8f1d950ef826$var$EventEmitter;


var $7a03261827aeb66f$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($f52b8f1d950ef826$exports)))();
var $7a03261827aeb66f$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $46f047ba3a8a0f0e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $46f047ba3a8a0f0e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $46f047ba3a8a0f0e$var$_typeof(o);
}
function $46f047ba3a8a0f0e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $46f047ba3a8a0f0e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $46f047ba3a8a0f0e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $46f047ba3a8a0f0e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $46f047ba3a8a0f0e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $46f047ba3a8a0f0e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $46f047ba3a8a0f0e$var$_defineProperty(obj, key, value) {
    key = $46f047ba3a8a0f0e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $46f047ba3a8a0f0e$var$_toPropertyKey(t) {
    var i = $46f047ba3a8a0f0e$var$_toPrimitive(t, "string");
    return "symbol" == $46f047ba3a8a0f0e$var$_typeof(i) ? i : i + "";
}
function $46f047ba3a8a0f0e$var$_toPrimitive(t, r) {
    if ("object" != $46f047ba3a8a0f0e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $46f047ba3a8a0f0e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $46f047ba3a8a0f0e$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $46f047ba3a8a0f0e$var$_classCallCheck(this, AccessibilityManager);
        $46f047ba3a8a0f0e$var$_defineProperty(this, "activeIndex", 0);
        $46f047ba3a8a0f0e$var$_defineProperty(this, "coordinateList", []);
        $46f047ba3a8a0f0e$var$_defineProperty(this, "layout", 'horizontal');
    }
    return $46f047ba3a8a0f0e$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();



function $0ded3ded59a9813b$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(domainStart) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");


var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");


function $d02fe2384966c7b3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d02fe2384966c7b3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d02fe2384966c7b3$var$_typeof(o);
}
var $d02fe2384966c7b3$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $d02fe2384966c7b3$var$_extends() {
    $d02fe2384966c7b3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d02fe2384966c7b3$var$_extends.apply(this, arguments);
}
function $d02fe2384966c7b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d02fe2384966c7b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d02fe2384966c7b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d02fe2384966c7b3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d02fe2384966c7b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d02fe2384966c7b3$var$_defineProperty(obj, key, value) {
    key = $d02fe2384966c7b3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d02fe2384966c7b3$var$_toPropertyKey(t) {
    var i = $d02fe2384966c7b3$var$_toPrimitive(t, "string");
    return "symbol" == $d02fe2384966c7b3$var$_typeof(i) ? i : i + "";
}
function $d02fe2384966c7b3$var$_toPrimitive(t, r) {
    if ("object" != $d02fe2384966c7b3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d02fe2384966c7b3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d02fe2384966c7b3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d02fe2384966c7b3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d02fe2384966c7b3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d02fe2384966c7b3$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $d02fe2384966c7b3$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $d02fe2384966c7b3$var$_objectWithoutProperties(_ref, $d02fe2384966c7b3$var$_excluded);
    var props = $d02fe2384966c7b3$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(x) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(y) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(height) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(top) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $d02fe2384966c7b3$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true), {
        className: (0, $ajIhI.default)('recharts-cross', className),
        d: $d02fe2384966c7b3$var$getPath(x, y, width, height, top, left)
    }));
};


function $c18e35bf49155ee1$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $80b0b4a67fb2d33d$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $9823ac6159474f98$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $80b0b4a67fb2d33d$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $f3674fa56c89941b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f3674fa56c89941b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f3674fa56c89941b$var$_typeof(o);
}
function $f3674fa56c89941b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f3674fa56c89941b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f3674fa56c89941b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f3674fa56c89941b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f3674fa56c89941b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f3674fa56c89941b$var$_defineProperty(obj, key, value) {
    key = $f3674fa56c89941b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f3674fa56c89941b$var$_toPropertyKey(t) {
    var i = $f3674fa56c89941b$var$_toPrimitive(t, "string");
    return "symbol" == $f3674fa56c89941b$var$_typeof(i) ? i : i + "";
}
function $f3674fa56c89941b$var$_toPrimitive(t, r) {
    if ("object" != $f3674fa56c89941b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f3674fa56c89941b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f3674fa56c89941b$export$b6a79797ad180576(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, $1371972ac018f8f3$export$b0e83c3ef8d2db1);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $d02fe2384966c7b3$export$3c877bb842c36952);
    } else if (chartName === 'BarChart') {
        restProps = (0, $c18e35bf49155ee1$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $2a40e10cde5ed370$export$4617fb02663045ef);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, $80b0b4a67fb2d33d$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $ac8f8e6d22dec697$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $9823ac6159474f98$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $1371972ac018f8f3$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $f3674fa56c89941b$var$_objectSpread($f3674fa56c89941b$var$_objectSpread($f3674fa56c89941b$var$_objectSpread($f3674fa56c89941b$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $ajIhI.default)('recharts-tooltip-cursor', elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, $8nGP5.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, $8nGP5.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, $8nGP5.createElement)(cursorComp, cursorProps);
}



var $3cb8ecafb87115bc$var$_excluded = [
    "item"
], $3cb8ecafb87115bc$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $3cb8ecafb87115bc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3cb8ecafb87115bc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3cb8ecafb87115bc$var$_typeof(o);
}
function $3cb8ecafb87115bc$var$_extends() {
    $3cb8ecafb87115bc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3cb8ecafb87115bc$var$_extends.apply(this, arguments);
}
function $3cb8ecafb87115bc$var$_slicedToArray(arr, i) {
    return $3cb8ecafb87115bc$var$_arrayWithHoles(arr) || $3cb8ecafb87115bc$var$_iterableToArrayLimit(arr, i) || $3cb8ecafb87115bc$var$_unsupportedIterableToArray(arr, i) || $3cb8ecafb87115bc$var$_nonIterableRest();
}
function $3cb8ecafb87115bc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3cb8ecafb87115bc$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3cb8ecafb87115bc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3cb8ecafb87115bc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3cb8ecafb87115bc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3cb8ecafb87115bc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3cb8ecafb87115bc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3cb8ecafb87115bc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3cb8ecafb87115bc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3cb8ecafb87115bc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3cb8ecafb87115bc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3cb8ecafb87115bc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3cb8ecafb87115bc$var$_callSuper(t, o, e) {
    return o = $3cb8ecafb87115bc$var$_getPrototypeOf(o), $3cb8ecafb87115bc$var$_possibleConstructorReturn(t, $3cb8ecafb87115bc$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $3cb8ecafb87115bc$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $3cb8ecafb87115bc$var$_possibleConstructorReturn(self, call) {
    if (call && ($3cb8ecafb87115bc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3cb8ecafb87115bc$var$_assertThisInitialized(self);
}
function $3cb8ecafb87115bc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3cb8ecafb87115bc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3cb8ecafb87115bc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3cb8ecafb87115bc$var$_getPrototypeOf(o) {
    $3cb8ecafb87115bc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3cb8ecafb87115bc$var$_getPrototypeOf(o);
}
function $3cb8ecafb87115bc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3cb8ecafb87115bc$var$_setPrototypeOf(subClass, superClass);
}
function $3cb8ecafb87115bc$var$_setPrototypeOf(o, p) {
    $3cb8ecafb87115bc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3cb8ecafb87115bc$var$_setPrototypeOf(o, p);
}
function $3cb8ecafb87115bc$var$_toConsumableArray(arr) {
    return $3cb8ecafb87115bc$var$_arrayWithoutHoles(arr) || $3cb8ecafb87115bc$var$_iterableToArray(arr) || $3cb8ecafb87115bc$var$_unsupportedIterableToArray(arr) || $3cb8ecafb87115bc$var$_nonIterableSpread();
}
function $3cb8ecafb87115bc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3cb8ecafb87115bc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3cb8ecafb87115bc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3cb8ecafb87115bc$var$_arrayLikeToArray(o, minLen);
}
function $3cb8ecafb87115bc$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3cb8ecafb87115bc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3cb8ecafb87115bc$var$_arrayLikeToArray(arr);
}
function $3cb8ecafb87115bc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3cb8ecafb87115bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cb8ecafb87115bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cb8ecafb87115bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3cb8ecafb87115bc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cb8ecafb87115bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3cb8ecafb87115bc$var$_defineProperty(obj, key, value) {
    key = $3cb8ecafb87115bc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3cb8ecafb87115bc$var$_toPropertyKey(t) {
    var i = $3cb8ecafb87115bc$var$_toPrimitive(t, "string");
    return "symbol" == $3cb8ecafb87115bc$var$_typeof(i) ? i : i + "";
}
function $3cb8ecafb87115bc$var$_toPrimitive(t, r) {
    if ("object" != $3cb8ecafb87115bc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3cb8ecafb87115bc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3cb8ecafb87115bc$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $3cb8ecafb87115bc$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var $3cb8ecafb87115bc$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $3cb8ecafb87115bc$var$renderAsIs(element) {
    return element;
}
var $3cb8ecafb87115bc$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $3cb8ecafb87115bc$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, rangeObj), (0, $e229728826610b73$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, rangeObj), (0, $e229728826610b73$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $3cb8ecafb87115bc$var$originCoordinate;
};
var $3cb8ecafb87115bc$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($3cb8ecafb87115bc$var$_toConsumableArray(result), $3cb8ecafb87115bc$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(dataStartIndex) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $3cb8ecafb87115bc$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $3cb8ecafb87115bc$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $3cb8ecafb87115bc$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $3d08f6c3b4eab1e3$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($3cb8ecafb87115bc$var$_toConsumableArray(result), [
            (0, $cc31aced37ecb634$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $3cb8ecafb87115bc$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $3cb8ecafb87115bc$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $cc31aced37ecb634$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $3cb8ecafb87115bc$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $3cb8ecafb87115bc$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $3cb8ecafb87115bc$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $cc31aced37ecb634$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $3cb8ecafb87115bc$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $0ded3ded59a9813b$export$33279f645a5831b7)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, $cc31aced37ecb634$export$a0bc8660980558a0)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $cc31aced37ecb634$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $3cb8ecafb87115bc$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $cc31aced37ecb634$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $3d08f6c3b4eab1e3$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($1b98d377f77cff70$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $cc31aced37ecb634$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($3cb8ecafb87115bc$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $cc31aced37ecb634$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entry) ? finalDomain : [].concat($3cb8ecafb87115bc$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $cc31aced37ecb634$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $cc31aced37ecb634$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($1b98d377f77cff70$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $cc31aced37ecb634$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $cc31aced37ecb634$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = 'hide' in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $aae848d13cf3ba2c$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $cc31aced37ecb634$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty({}, axisId, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $3cb8ecafb87115bc$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $3cb8ecafb87115bc$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $cc31aced37ecb634$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = $3cb8ecafb87115bc$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($1b98d377f77cff70$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $cc31aced37ecb634$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $aae848d13cf3ba2c$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $cc31aced37ecb634$export$a0bc8660980558a0)(originalDomain, (0, $cc31aced37ecb634$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $aae848d13cf3ba2c$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty({}, axisId, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))($3cb8ecafb87115bc$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $3cb8ecafb87115bc$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $3cb8ecafb87115bc$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $3cb8ecafb87115bc$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $3cb8ecafb87115bc$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($0082dfda2c4d7cdc$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $cc31aced37ecb634$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $3cb8ecafb87115bc$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $099f4aa5be8152a1$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $3cb8ecafb87115bc$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $8b99c43c69c5c37b$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $3cb8ecafb87115bc$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $3cb8ecafb87115bc$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $099f4aa5be8152a1$export$59bc2e3533b384a0));
    var legendItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $06340f5273236c74$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $099f4aa5be8152a1$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $cc31aced37ecb634$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $3cb8ecafb87115bc$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === 'xAxis') return axisObj[axisName].width;
    if (axisName === 'yAxis') return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $3cb8ecafb87115bc$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $3cb8ecafb87115bc$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $3cb8ecafb87115bc$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $3cb8ecafb87115bc$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty($3cb8ecafb87115bc$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $cc31aced37ecb634$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $8b99c43c69c5c37b$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $cc31aced37ecb634$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $cc31aced37ecb634$export$570d306bee26c748)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $3cb8ecafb87115bc$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $cc31aced37ecb634$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $cc31aced37ecb634$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, pos), {}, {
                        position: $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, composedFn($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $3cb8ecafb87115bc$var$_defineProperty($3cb8ecafb87115bc$var$_defineProperty($3cb8ecafb87115bc$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $8b99c43c69c5c37b$export$857ca101f741953)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $8b99c43c69c5c37b$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $3cb8ecafb87115bc$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $cc31aced37ecb634$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty({}, name, $3cb8ecafb87115bc$var$getAxisMap(props, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $3cb8ecafb87115bc$var$calculateOffset($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $3cb8ecafb87115bc$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $3cb8ecafb87115bc$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $3cb8ecafb87115bc$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $3cb8ecafb87115bc$var$_defineProperty(_this, "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            $3cb8ecafb87115bc$var$_defineProperty(_this, "accessibilityManager", new (0, $46f047ba3a8a0f0e$export$a2c2de1efa8671eb)());
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($3cb8ecafb87115bc$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $3cb8ecafb87115bc$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, $8b99c43c69c5c37b$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleDoubleClick", function(e) {
                var onDoubleClick = _this.props.onDoubleClick;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onDoubleClick)) {
                    var _nextState5 = _this.getMouseInfo(e);
                    onDoubleClick(_nextState5, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleContextMenu", function(e) {
                var onContextMenu = _this.props.onContextMenu;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onContextMenu)) {
                    var _nextState6 = _this.getMouseInfo(e);
                    onContextMenu(_nextState6, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $7a03261827aeb66f$export$9bcdfe5f29bb33).emit((0, $7a03261827aeb66f$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($3cb8ecafb87115bc$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $3cb8ecafb87115bc$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $3cb8ecafb87115bc$var$originCoordinate;
                    _this.setState($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $f3674fa56c89941b$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $ajIhI.default)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $3c595a89abddaa2c$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $3cb8ecafb87115bc$var$_objectWithoutProperties(props, $3cb8ecafb87115bc$var$_excluded);
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(item, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(tooltipItem, {
                    viewBox: $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $cc31aced37ecb634$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $cc31aced37ecb634$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(activeDot, false)), (0, $f1d44a0cc6cff721$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $cc31aced37ecb634$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $cc31aced37ecb634$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $cc31aced37ecb634$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $3d08f6c3b4eab1e3$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $3d08f6c3b4eab1e3$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($3cb8ecafb87115bc$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $8nGP5.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: $3cb8ecafb87115bc$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $3cb8ecafb87115bc$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $3cb8ecafb87115bc$var$renderAsIs
                },
                YAxis: {
                    handler: $3cb8ecafb87115bc$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($a090addee6f26581$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $3cb8ecafb87115bc$var$_inherits(CategoricalChartWrapper, _Component);
        return $3cb8ecafb87115bc$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $3cb8ecafb87115bc$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $8b99c43c69c5c37b$export$acdc716e08572f94)([
                        (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(prevProps.children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea))
                    ], [
                        (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(this.props.children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(this.props.children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $afcbff65789b5460$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    var toolTipData = $3cb8ecafb87115bc$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        }, toolTipData);
                    }
                    if (toolTipData) return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $e229728826610b73$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onDoubleClick: this.handleDoubleClick,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onContextMenu: this.handleContextMenu
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $f1d44a0cc6cff721$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $7a03261827aeb66f$export$9bcdfe5f29bb33).on((0, $7a03261827aeb66f$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $7a03261827aeb66f$export$9bcdfe5f29bb33).removeListener((0, $7a03261827aeb66f$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $8b99c43c69c5c37b$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $3cb8ecafb87115bc$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, res), {}, $3cb8ecafb87115bc$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $3cb8ecafb87115bc$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, res), {}, $3cb8ecafb87115bc$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, $8b99c43c69c5c37b$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $2a40e10cde5ed370$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $e229728826610b73$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $2be7c72ce33b6679$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $2be7c72ce33b6679$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $2be7c72ce33b6679$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $2be7c72ce33b6679$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $2be7c72ce33b6679$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, $8b99c43c69c5c37b$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $3cb8ecafb87115bc$var$_objectWithoutProperties(_this$props6, $3cb8ecafb87115bc$var$_excluded2);
                    var attrs = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $c06c4bb7dffe0deb$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ed0c2f2ddc9d58cd$export$7b92b459e668cb21), $3cb8ecafb87115bc$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $8b99c43c69c5c37b$export$a98d6da55570cb82)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $c06c4bb7dffe0deb$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", $3cb8ecafb87115bc$var$_extends({
                        className: (0, $ajIhI.default)('recharts-wrapper', className),
                        style: $3cb8ecafb87115bc$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ed0c2f2ddc9d58cd$export$7b92b459e668cb21), $3cb8ecafb87115bc$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $3cb8ecafb87115bc$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $8b99c43c69c5c37b$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, $8nGP5.Component));
    $3cb8ecafb87115bc$var$_defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    $3cb8ecafb87115bc$var$_defineProperty(CategoricalChartWrapper, "defaultProps", $3cb8ecafb87115bc$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps));
    $3cb8ecafb87115bc$var$_defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $3cb8ecafb87115bc$export$e5182fb58612e577(nextProps);
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $0e7c207b469fdda3$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $3cb8ecafb87115bc$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, $3cb8ecafb87115bc$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($3cb8ecafb87115bc$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $8b99c43c69c5c37b$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $099f4aa5be8152a1$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    $3cb8ecafb87115bc$var$_defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(option)) dot = /*#__PURE__*/ (0, $8nGP5.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $5c4d5cf43eecf2f0$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(CategoricalChartWrapper, $3cb8ecafb87115bc$var$_extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};




var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");



function $f4dd95f529f72065$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f4dd95f529f72065$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f4dd95f529f72065$var$_typeof(o);
}
function $f4dd95f529f72065$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f4dd95f529f72065$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f4dd95f529f72065$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f4dd95f529f72065$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f4dd95f529f72065$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f4dd95f529f72065$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f4dd95f529f72065$var$_callSuper(t, o, e) {
    return o = $f4dd95f529f72065$var$_getPrototypeOf(o), $f4dd95f529f72065$var$_possibleConstructorReturn(t, $f4dd95f529f72065$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f4dd95f529f72065$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f4dd95f529f72065$var$_possibleConstructorReturn(self, call) {
    if (call && ($f4dd95f529f72065$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f4dd95f529f72065$var$_assertThisInitialized(self);
}
function $f4dd95f529f72065$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f4dd95f529f72065$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f4dd95f529f72065$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f4dd95f529f72065$var$_getPrototypeOf(o) {
    $f4dd95f529f72065$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f4dd95f529f72065$var$_getPrototypeOf(o);
}
function $f4dd95f529f72065$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f4dd95f529f72065$var$_setPrototypeOf(subClass, superClass);
}
function $f4dd95f529f72065$var$_setPrototypeOf(o, p) {
    $f4dd95f529f72065$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f4dd95f529f72065$var$_setPrototypeOf(o, p);
}
function $f4dd95f529f72065$var$_defineProperty(obj, key, value) {
    key = $f4dd95f529f72065$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f4dd95f529f72065$var$_toPropertyKey(t) {
    var i = $f4dd95f529f72065$var$_toPrimitive(t, "string");
    return "symbol" == $f4dd95f529f72065$var$_typeof(i) ? i : i + "";
}
function $f4dd95f529f72065$var$_toPrimitive(t, r) {
    if ("object" != $f4dd95f529f72065$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f4dd95f529f72065$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f4dd95f529f72065$var$_extends() {
    $f4dd95f529f72065$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f4dd95f529f72065$var$_extends.apply(this, arguments);
}
/** Define of XAxis props */ function $f4dd95f529f72065$var$XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $c06c4bb7dffe0deb$export$8854f7ece606854b)();
    var height = (0, $c06c4bb7dffe0deb$export$369ae257969c6f9f)();
    var axisOptions = (0, $c06c4bb7dffe0deb$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $040ce345c37febc7$export$bdd99f2cdf352bae), $f4dd95f529f72065$var$_extends({}, axisOptions, {
        className: (0, $ajIhI.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(axis, true);
        }
    })));
}
var $f4dd95f529f72065$export$ea77231de273b52d = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        $f4dd95f529f72065$var$_classCallCheck(this, XAxis);
        return $f4dd95f529f72065$var$_callSuper(this, XAxis, arguments);
    }
    $f4dd95f529f72065$var$_inherits(XAxis, _React$Component);
    return $f4dd95f529f72065$var$_createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($f4dd95f529f72065$var$XAxisImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$f4dd95f529f72065$var$_defineProperty($f4dd95f529f72065$export$ea77231de273b52d, "displayName", 'XAxis');
$f4dd95f529f72065$var$_defineProperty($f4dd95f529f72065$export$ea77231de273b52d, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
});



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");



function $0a6c1adc00c46590$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0a6c1adc00c46590$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0a6c1adc00c46590$var$_typeof(o);
}
function $0a6c1adc00c46590$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0a6c1adc00c46590$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0a6c1adc00c46590$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0a6c1adc00c46590$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0a6c1adc00c46590$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0a6c1adc00c46590$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0a6c1adc00c46590$var$_callSuper(t, o, e) {
    return o = $0a6c1adc00c46590$var$_getPrototypeOf(o), $0a6c1adc00c46590$var$_possibleConstructorReturn(t, $0a6c1adc00c46590$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $0a6c1adc00c46590$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $0a6c1adc00c46590$var$_possibleConstructorReturn(self, call) {
    if (call && ($0a6c1adc00c46590$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0a6c1adc00c46590$var$_assertThisInitialized(self);
}
function $0a6c1adc00c46590$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0a6c1adc00c46590$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0a6c1adc00c46590$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0a6c1adc00c46590$var$_getPrototypeOf(o) {
    $0a6c1adc00c46590$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0a6c1adc00c46590$var$_getPrototypeOf(o);
}
function $0a6c1adc00c46590$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0a6c1adc00c46590$var$_setPrototypeOf(subClass, superClass);
}
function $0a6c1adc00c46590$var$_setPrototypeOf(o, p) {
    $0a6c1adc00c46590$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0a6c1adc00c46590$var$_setPrototypeOf(o, p);
}
function $0a6c1adc00c46590$var$_defineProperty(obj, key, value) {
    key = $0a6c1adc00c46590$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0a6c1adc00c46590$var$_toPropertyKey(t) {
    var i = $0a6c1adc00c46590$var$_toPrimitive(t, "string");
    return "symbol" == $0a6c1adc00c46590$var$_typeof(i) ? i : i + "";
}
function $0a6c1adc00c46590$var$_toPrimitive(t, r) {
    if ("object" != $0a6c1adc00c46590$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0a6c1adc00c46590$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0a6c1adc00c46590$var$_extends() {
    $0a6c1adc00c46590$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0a6c1adc00c46590$var$_extends.apply(this, arguments);
}
var $0a6c1adc00c46590$var$YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $c06c4bb7dffe0deb$export$8854f7ece606854b)();
    var height = (0, $c06c4bb7dffe0deb$export$369ae257969c6f9f)();
    var axisOptions = (0, $c06c4bb7dffe0deb$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $040ce345c37febc7$export$bdd99f2cdf352bae), $0a6c1adc00c46590$var$_extends({}, axisOptions, {
        className: (0, $ajIhI.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
var $0a6c1adc00c46590$export$f96c4024c52de8f4 = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        $0a6c1adc00c46590$var$_classCallCheck(this, YAxis);
        return $0a6c1adc00c46590$var$_callSuper(this, YAxis, arguments);
    }
    $0a6c1adc00c46590$var$_inherits(YAxis, _React$Component);
    return $0a6c1adc00c46590$var$_createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($0a6c1adc00c46590$var$YAxisImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$0a6c1adc00c46590$var$_defineProperty($0a6c1adc00c46590$export$f96c4024c52de8f4, "displayName", 'YAxis');
$0a6c1adc00c46590$var$_defineProperty($0a6c1adc00c46590$export$f96c4024c52de8f4, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
});



var $3db935e47dd15f70$export$54d0e8420ac838ac = (0, $3cb8ecafb87115bc$export$77871aede60e6838)({
    chartName: 'LineChart',
    GraphicalChild: (0, $a0158cc2cd24124f$export$17d680238e50603e),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $f4dd95f529f72065$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $0a6c1adc00c46590$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $b57066fd5661be22$export$ece7de1383db5ac)
});


var $ajIhI = parcelRequire("ajIhI");

var $8nGP5 = parcelRequire("8nGP5");




function $65a9db7fe004392a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $65a9db7fe004392a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $65a9db7fe004392a$var$_typeof(o);
}
function $65a9db7fe004392a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65a9db7fe004392a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65a9db7fe004392a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $65a9db7fe004392a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65a9db7fe004392a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $65a9db7fe004392a$var$_defineProperty(obj, key, value) {
    key = $65a9db7fe004392a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $65a9db7fe004392a$var$_toPropertyKey(t) {
    var i = $65a9db7fe004392a$var$_toPrimitive(t, "string");
    return "symbol" == $65a9db7fe004392a$var$_typeof(i) ? i : i + "";
}
function $65a9db7fe004392a$var$_toPrimitive(t, r) {
    if ("object" != $65a9db7fe004392a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $65a9db7fe004392a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $65a9db7fe004392a$var$_slicedToArray(arr, i) {
    return $65a9db7fe004392a$var$_arrayWithHoles(arr) || $65a9db7fe004392a$var$_iterableToArrayLimit(arr, i) || $65a9db7fe004392a$var$_unsupportedIterableToArray(arr, i) || $65a9db7fe004392a$var$_nonIterableRest();
}
function $65a9db7fe004392a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $65a9db7fe004392a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $65a9db7fe004392a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $65a9db7fe004392a$var$_arrayLikeToArray(o, minLen);
}
function $65a9db7fe004392a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $65a9db7fe004392a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $65a9db7fe004392a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $65a9db7fe004392a$export$e60a4704009a0009 = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $8nGP5.useRef)(null);
    var onResizeRef = (0, $8nGP5.useRef)();
    onResizeRef.current = onResize;
    (0, $8nGP5.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, 'current', {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, $8nGP5.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $65a9db7fe004392a$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $8nGP5.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $8nGP5.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($a090addee6f26581$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $8nGP5.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)((0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(width) || (0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $8b99c43c69c5c37b$export$be63e0664592e141)(children.type).endsWith('Chart');
        return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(child)) return /*#__PURE__*/ (0, $8nGP5.cloneElement)(child, $65a9db7fe004392a$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $65a9db7fe004392a$var$_objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $ajIhI.default)('recharts-responsive-container', className),
        style: $65a9db7fe004392a$var$_objectSpread($65a9db7fe004392a$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});



var $fX8pL = parcelRequire("fX8pL");
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8nGP5 = parcelRequire("8nGP5");

var $fCKK7 = parcelRequire("fCKK7");
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $f4bbcf51f4268bcb$var$_extends() {
    $f4bbcf51f4268bcb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f4bbcf51f4268bcb$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $f4bbcf51f4268bcb$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($f4bbcf51f4268bcb$export$e19cd5f9376f8cee || ($f4bbcf51f4268bcb$export$e19cd5f9376f8cee = {}));
const $f4bbcf51f4268bcb$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $f4bbcf51f4268bcb$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $f4bbcf51f4268bcb$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $f4bbcf51f4268bcb$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $f4bbcf51f4268bcb$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $f4bbcf51f4268bcb$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $f4bbcf51f4268bcb$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $f4bbcf51f4268bcb$export$fe53371bee54353d(to);
    }
    return $f4bbcf51f4268bcb$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $f4bbcf51f4268bcb$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $f4bbcf51f4268bcb$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f4bbcf51f4268bcb$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f4bbcf51f4268bcb$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $f4bbcf51f4268bcb$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f4bbcf51f4268bcb$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f4bbcf51f4268bcb$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $f4bbcf51f4268bcb$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $f4bbcf51f4268bcb$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $f4bbcf51f4268bcb$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $f4bbcf51f4268bcb$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f4bbcf51f4268bcb$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $f4bbcf51f4268bcb$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f4bbcf51f4268bcb$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($f4bbcf51f4268bcb$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push;
        let location = $f4bbcf51f4268bcb$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f4bbcf51f4268bcb$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace;
        let location = $f4bbcf51f4268bcb$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f4bbcf51f4268bcb$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $f4bbcf51f4268bcb$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($f4bbcf51f4268bcb$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($f4bbcf51f4268bcb$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $f4bbcf51f4268bcb$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($f4bbcf51f4268bcb$var$ResultType || ($f4bbcf51f4268bcb$var$ResultType = {}));
const $f4bbcf51f4268bcb$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f4bbcf51f4268bcb$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($f4bbcf51f4268bcb$var$isIndexRoute(route)) {
            let indexRoute = $f4bbcf51f4268bcb$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $f4bbcf51f4268bcb$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $f4bbcf51f4268bcb$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $f4bbcf51f4268bcb$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $f4bbcf51f4268bcb$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f4bbcf51f4268bcb$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $f4bbcf51f4268bcb$var$flattenRoutes(routes);
    $f4bbcf51f4268bcb$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $f4bbcf51f4268bcb$export$30d21fd6d7295f52(pathname);
        matches = $f4bbcf51f4268bcb$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $f4bbcf51f4268bcb$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $f4bbcf51f4268bcb$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f4bbcf51f4268bcb$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $f4bbcf51f4268bcb$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f4bbcf51f4268bcb$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $f4bbcf51f4268bcb$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $f4bbcf51f4268bcb$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f4bbcf51f4268bcb$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f4bbcf51f4268bcb$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $f4bbcf51f4268bcb$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $f4bbcf51f4268bcb$var$paramRe = /^:[\w-]+$/;
const $f4bbcf51f4268bcb$var$dynamicSegmentValue = 3;
const $f4bbcf51f4268bcb$var$indexRouteValue = 2;
const $f4bbcf51f4268bcb$var$emptySegmentValue = 1;
const $f4bbcf51f4268bcb$var$staticSegmentValue = 10;
const $f4bbcf51f4268bcb$var$splatPenalty = -2;
const $f4bbcf51f4268bcb$var$isSplat = (s)=>s === "*";
function $f4bbcf51f4268bcb$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f4bbcf51f4268bcb$var$isSplat)) initialScore += $f4bbcf51f4268bcb$var$splatPenalty;
    if (index) initialScore += $f4bbcf51f4268bcb$var$indexRouteValue;
    return segments.filter((s)=>!$f4bbcf51f4268bcb$var$isSplat(s)).reduce((score, segment)=>score + ($f4bbcf51f4268bcb$var$paramRe.test(segment) ? $f4bbcf51f4268bcb$var$dynamicSegmentValue : segment === "" ? $f4bbcf51f4268bcb$var$emptySegmentValue : $f4bbcf51f4268bcb$var$staticSegmentValue), initialScore);
}
function $f4bbcf51f4268bcb$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $f4bbcf51f4268bcb$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $f4bbcf51f4268bcb$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $f4bbcf51f4268bcb$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f4bbcf51f4268bcb$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f4bbcf51f4268bcb$export$a5c6d149b50c1d86($f4bbcf51f4268bcb$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f4bbcf51f4268bcb$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $f4bbcf51f4268bcb$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f4bbcf51f4268bcb$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $f4bbcf51f4268bcb$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $f4bbcf51f4268bcb$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f4bbcf51f4268bcb$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $f4bbcf51f4268bcb$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $f4bbcf51f4268bcb$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $f4bbcf51f4268bcb$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $f4bbcf51f4268bcb$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $f4bbcf51f4268bcb$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $f4bbcf51f4268bcb$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $f4bbcf51f4268bcb$var$normalizeSearch(search),
        hash: $f4bbcf51f4268bcb$var$normalizeHash(hash)
    };
}
function $f4bbcf51f4268bcb$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f4bbcf51f4268bcb$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $f4bbcf51f4268bcb$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $f4bbcf51f4268bcb$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $f4bbcf51f4268bcb$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $f4bbcf51f4268bcb$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(toArg);
    else {
        to = $f4bbcf51f4268bcb$var$_extends({}, toArg);
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $f4bbcf51f4268bcb$var$getInvalidPathError("?", "pathname", "search", to));
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $f4bbcf51f4268bcb$var$getInvalidPathError("#", "pathname", "hash", to));
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $f4bbcf51f4268bcb$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f4bbcf51f4268bcb$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $f4bbcf51f4268bcb$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $f4bbcf51f4268bcb$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $f4bbcf51f4268bcb$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $f4bbcf51f4268bcb$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $f4bbcf51f4268bcb$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $f4bbcf51f4268bcb$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $f4bbcf51f4268bcb$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $f4bbcf51f4268bcb$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $f4bbcf51f4268bcb$export$4051a07651545597(data, init) {
    return new $f4bbcf51f4268bcb$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $f4bbcf51f4268bcb$export$42a99a7a4bc0e76a extends Error {
}
class $f4bbcf51f4268bcb$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $f4bbcf51f4268bcb$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $f4bbcf51f4268bcb$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $f4bbcf51f4268bcb$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $f4bbcf51f4268bcb$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $f4bbcf51f4268bcb$var$unwrapTrackedPromise(value) {
    if (!$f4bbcf51f4268bcb$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $f4bbcf51f4268bcb$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $f4bbcf51f4268bcb$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f4bbcf51f4268bcb$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $f4bbcf51f4268bcb$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f4bbcf51f4268bcb$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $f4bbcf51f4268bcb$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f4bbcf51f4268bcb$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $f4bbcf51f4268bcb$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $f4bbcf51f4268bcb$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $f4bbcf51f4268bcb$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $f4bbcf51f4268bcb$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $f4bbcf51f4268bcb$var$validMutationMethods = new Set($f4bbcf51f4268bcb$var$validMutationMethodsArr);
const $f4bbcf51f4268bcb$var$validRequestMethodsArr = [
    "get",
    ...$f4bbcf51f4268bcb$var$validMutationMethodsArr
];
const $f4bbcf51f4268bcb$var$validRequestMethods = new Set($f4bbcf51f4268bcb$var$validRequestMethodsArr);
const $f4bbcf51f4268bcb$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $f4bbcf51f4268bcb$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $f4bbcf51f4268bcb$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f4bbcf51f4268bcb$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f4bbcf51f4268bcb$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $f4bbcf51f4268bcb$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $f4bbcf51f4268bcb$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $f4bbcf51f4268bcb$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $f4bbcf51f4268bcb$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $f4bbcf51f4268bcb$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f4bbcf51f4268bcb$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $f4bbcf51f4268bcb$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $f4bbcf51f4268bcb$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f4bbcf51f4268bcb$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f4bbcf51f4268bcb$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$f4bbcf51f4268bcb$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$f4bbcf51f4268bcb$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $f4bbcf51f4268bcb$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $f4bbcf51f4268bcb$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f4bbcf51f4268bcb$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $f4bbcf51f4268bcb$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$f4bbcf51f4268bcb$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $f4bbcf51f4268bcb$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f4bbcf51f4268bcb$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $f4bbcf51f4268bcb$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f4bbcf51f4268bcb$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f4bbcf51f4268bcb$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($f4bbcf51f4268bcb$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $f4bbcf51f4268bcb$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $f4bbcf51f4268bcb$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $f4bbcf51f4268bcb$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $f4bbcf51f4268bcb$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $f4bbcf51f4268bcb$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $f4bbcf51f4268bcb$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f4bbcf51f4268bcb$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $f4bbcf51f4268bcb$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $f4bbcf51f4268bcb$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f4bbcf51f4268bcb$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $f4bbcf51f4268bcb$var$findNearestBoundary(matches).route.id,
            {
                type: $f4bbcf51f4268bcb$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $f4bbcf51f4268bcb$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($f4bbcf51f4268bcb$var$isErrorResult(result) && $f4bbcf51f4268bcb$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $f4bbcf51f4268bcb$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $f4bbcf51f4268bcb$var$_extends({
            matches: updatedMatches || matches
        }, $f4bbcf51f4268bcb$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $f4bbcf51f4268bcb$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $f4bbcf51f4268bcb$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $f4bbcf51f4268bcb$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $f4bbcf51f4268bcb$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $f4bbcf51f4268bcb$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $f4bbcf51f4268bcb$var$ResultType.error,
            error: $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f4bbcf51f4268bcb$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $f4bbcf51f4268bcb$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) throw $f4bbcf51f4268bcb$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($f4bbcf51f4268bcb$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f4bbcf51f4268bcb$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $f4bbcf51f4268bcb$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $f4bbcf51f4268bcb$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($f4bbcf51f4268bcb$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $f4bbcf51f4268bcb$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $f4bbcf51f4268bcb$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $f4bbcf51f4268bcb$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $f4bbcf51f4268bcb$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $f4bbcf51f4268bcb$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $f4bbcf51f4268bcb$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f4bbcf51f4268bcb$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $f4bbcf51f4268bcb$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $f4bbcf51f4268bcb$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $f4bbcf51f4268bcb$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $f4bbcf51f4268bcb$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $f4bbcf51f4268bcb$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $f4bbcf51f4268bcb$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $f4bbcf51f4268bcb$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f4bbcf51f4268bcb$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f4bbcf51f4268bcb$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $f4bbcf51f4268bcb$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($f4bbcf51f4268bcb$var$isRedirectResult(actionResult) || $f4bbcf51f4268bcb$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $f4bbcf51f4268bcb$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($f4bbcf51f4268bcb$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $f4bbcf51f4268bcb$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $f4bbcf51f4268bcb$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($f4bbcf51f4268bcb$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($f4bbcf51f4268bcb$var$isDeferredResult(actionResult)) throw $f4bbcf51f4268bcb$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $f4bbcf51f4268bcb$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $f4bbcf51f4268bcb$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $f4bbcf51f4268bcb$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $f4bbcf51f4268bcb$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $f4bbcf51f4268bcb$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $f4bbcf51f4268bcb$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f4bbcf51f4268bcb$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $f4bbcf51f4268bcb$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $f4bbcf51f4268bcb$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f4bbcf51f4268bcb$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $f4bbcf51f4268bcb$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) result = await $f4bbcf51f4268bcb$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $f4bbcf51f4268bcb$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($f4bbcf51f4268bcb$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $f4bbcf51f4268bcb$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($f4bbcf51f4268bcb$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!$f4bbcf51f4268bcb$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $f4bbcf51f4268bcb$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $f4bbcf51f4268bcb$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $f4bbcf51f4268bcb$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($f4bbcf51f4268bcb$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $f4bbcf51f4268bcb$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace : $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $f4bbcf51f4268bcb$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($f4bbcf51f4268bcb$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $f4bbcf51f4268bcb$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $f4bbcf51f4268bcb$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $f4bbcf51f4268bcb$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $f4bbcf51f4268bcb$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $f4bbcf51f4268bcb$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($f4bbcf51f4268bcb$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $f4bbcf51f4268bcb$var$ResultType.redirect,
                response: $f4bbcf51f4268bcb$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $f4bbcf51f4268bcb$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $f4bbcf51f4268bcb$var$ResultType.error,
                    error: $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $f4bbcf51f4268bcb$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $f4bbcf51f4268bcb$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $f4bbcf51f4268bcb$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $f4bbcf51f4268bcb$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $f4bbcf51f4268bcb$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f4bbcf51f4268bcb$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f4bbcf51f4268bcb$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $f4bbcf51f4268bcb$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $f4bbcf51f4268bcb$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $f4bbcf51f4268bcb$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$f4bbcf51f4268bcb$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $f4bbcf51f4268bcb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $f4bbcf51f4268bcb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $f4bbcf51f4268bcb$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $f4bbcf51f4268bcb$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $f4bbcf51f4268bcb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $f4bbcf51f4268bcb$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $f4bbcf51f4268bcb$export$4d0306f8f6a4585b = Symbol("deferred");
function $f4bbcf51f4268bcb$export$3336b097a6fbc59a(routes, opts) {
    $f4bbcf51f4268bcb$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f4bbcf51f4268bcb$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $f4bbcf51f4268bcb$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f4bbcf51f4268bcb$var$createLocation("", $f4bbcf51f4268bcb$export$fe53371bee54353d(url), null, "default");
        let matches = $f4bbcf51f4268bcb$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f4bbcf51f4268bcb$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f4bbcf51f4268bcb$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f4bbcf51f4268bcb$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($f4bbcf51f4268bcb$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $f4bbcf51f4268bcb$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f4bbcf51f4268bcb$var$createLocation("", $f4bbcf51f4268bcb$export$fe53371bee54353d(url), null, "default");
        let matches = $f4bbcf51f4268bcb$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f4bbcf51f4268bcb$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f4bbcf51f4268bcb$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f4bbcf51f4268bcb$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($f4bbcf51f4268bcb$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$f4bbcf51f4268bcb$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f4bbcf51f4268bcb$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $f4bbcf51f4268bcb$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $f4bbcf51f4268bcb$var$isResponse(result) ? result : $f4bbcf51f4268bcb$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($f4bbcf51f4268bcb$var$isDataStrategyResult(e) && $f4bbcf51f4268bcb$var$isResponse(e.result)) {
                if (e.type === $f4bbcf51f4268bcb$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($f4bbcf51f4268bcb$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f4bbcf51f4268bcb$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $f4bbcf51f4268bcb$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($f4bbcf51f4268bcb$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) {
            let error = $f4bbcf51f4268bcb$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f4bbcf51f4268bcb$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($f4bbcf51f4268bcb$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($f4bbcf51f4268bcb$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f4bbcf51f4268bcb$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $f4bbcf51f4268bcb$var$_extends({}, context, {
                statusCode: $f4bbcf51f4268bcb$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $f4bbcf51f4268bcb$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $f4bbcf51f4268bcb$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $f4bbcf51f4268bcb$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? $f4bbcf51f4268bcb$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $f4bbcf51f4268bcb$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $f4bbcf51f4268bcb$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $f4bbcf51f4268bcb$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $f4bbcf51f4268bcb$var$callDataStrategyImpl(dataStrategy || $f4bbcf51f4268bcb$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($f4bbcf51f4268bcb$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $f4bbcf51f4268bcb$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($f4bbcf51f4268bcb$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $f4bbcf51f4268bcb$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $f4bbcf51f4268bcb$export$fec11da027c70692(routes, context, error) {
    let newContext = $f4bbcf51f4268bcb$var$_extends({}, context, {
        statusCode: $f4bbcf51f4268bcb$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $f4bbcf51f4268bcb$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $f4bbcf51f4268bcb$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $f4bbcf51f4268bcb$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $f4bbcf51f4268bcb$export$cae722b0cc860f13(to ? to : ".", $f4bbcf51f4268bcb$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $f4bbcf51f4268bcb$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $f4bbcf51f4268bcb$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f4bbcf51f4268bcb$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $f4bbcf51f4268bcb$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $f4bbcf51f4268bcb$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$f4bbcf51f4268bcb$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f4bbcf51f4268bcb$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f4bbcf51f4268bcb$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $f4bbcf51f4268bcb$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$f4bbcf51f4268bcb$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$f4bbcf51f4268bcb$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $f4bbcf51f4268bcb$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f4bbcf51f4268bcb$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f4bbcf51f4268bcb$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f4bbcf51f4268bcb$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f4bbcf51f4268bcb$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($f4bbcf51f4268bcb$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $f4bbcf51f4268bcb$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $f4bbcf51f4268bcb$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $f4bbcf51f4268bcb$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $f4bbcf51f4268bcb$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $f4bbcf51f4268bcb$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $f4bbcf51f4268bcb$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $f4bbcf51f4268bcb$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($f4bbcf51f4268bcb$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $f4bbcf51f4268bcb$var$shouldRevalidateLoader(match, $f4bbcf51f4268bcb$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $f4bbcf51f4268bcb$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $f4bbcf51f4268bcb$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $f4bbcf51f4268bcb$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $f4bbcf51f4268bcb$var$shouldRevalidateLoader(fetcherMatch, $f4bbcf51f4268bcb$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $f4bbcf51f4268bcb$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $f4bbcf51f4268bcb$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $f4bbcf51f4268bcb$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $f4bbcf51f4268bcb$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $f4bbcf51f4268bcb$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$f4bbcf51f4268bcb$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $f4bbcf51f4268bcb$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$f4bbcf51f4268bcb$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $f4bbcf51f4268bcb$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $f4bbcf51f4268bcb$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $f4bbcf51f4268bcb$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$f4bbcf51f4268bcb$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $f4bbcf51f4268bcb$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $f4bbcf51f4268bcb$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $f4bbcf51f4268bcb$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $f4bbcf51f4268bcb$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $f4bbcf51f4268bcb$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $f4bbcf51f4268bcb$var$ResultType.data,
                result: undefined
            });
        };
        return $f4bbcf51f4268bcb$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $f4bbcf51f4268bcb$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $f4bbcf51f4268bcb$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $f4bbcf51f4268bcb$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($f4bbcf51f4268bcb$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $f4bbcf51f4268bcb$var$ResultType.error,
                error: e
            };
        }
        if (type === $f4bbcf51f4268bcb$var$ResultType.error) return {
            type: $f4bbcf51f4268bcb$var$ResultType.error,
            error: new $f4bbcf51f4268bcb$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $f4bbcf51f4268bcb$var$ResultType.error) {
        if ($f4bbcf51f4268bcb$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $f4bbcf51f4268bcb$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $f4bbcf51f4268bcb$var$ResultType.error,
                error: new $f4bbcf51f4268bcb$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $f4bbcf51f4268bcb$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.error,
            error: result,
            statusCode: $f4bbcf51f4268bcb$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($f4bbcf51f4268bcb$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($f4bbcf51f4268bcb$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $f4bbcf51f4268bcb$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $f4bbcf51f4268bcb$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $f4bbcf51f4268bcb$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$f4bbcf51f4268bcb$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $f4bbcf51f4268bcb$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $f4bbcf51f4268bcb$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($f4bbcf51f4268bcb$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $f4bbcf51f4268bcb$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $f4bbcf51f4268bcb$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f4bbcf51f4268bcb$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f4bbcf51f4268bcb$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $f4bbcf51f4268bcb$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f4bbcf51f4268bcb$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f4bbcf51f4268bcb$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f4bbcf51f4268bcb$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!$f4bbcf51f4268bcb$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f4bbcf51f4268bcb$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $f4bbcf51f4268bcb$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $f4bbcf51f4268bcb$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f4bbcf51f4268bcb$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $f4bbcf51f4268bcb$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($f4bbcf51f4268bcb$var$isErrorResult(result)) {
            let boundaryMatch = $f4bbcf51f4268bcb$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $f4bbcf51f4268bcb$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($f4bbcf51f4268bcb$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $f4bbcf51f4268bcb$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f4bbcf51f4268bcb$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $f4bbcf51f4268bcb$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $f4bbcf51f4268bcb$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $f4bbcf51f4268bcb$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f4bbcf51f4268bcb$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f4bbcf51f4268bcb$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $f4bbcf51f4268bcb$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $f4bbcf51f4268bcb$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($f4bbcf51f4268bcb$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $f4bbcf51f4268bcb$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(path) : path;
    return $f4bbcf51f4268bcb$export$fe53371bee54353d($f4bbcf51f4268bcb$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $f4bbcf51f4268bcb$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $f4bbcf51f4268bcb$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $f4bbcf51f4268bcb$var$ResultType.data || result.type === $f4bbcf51f4268bcb$var$ResultType.error);
}
function $f4bbcf51f4268bcb$var$isRedirectDataStrategyResultResult(result) {
    return $f4bbcf51f4268bcb$var$isResponse(result.result) && $f4bbcf51f4268bcb$var$redirectStatusCodes.has(result.result.status);
}
function $f4bbcf51f4268bcb$var$isDeferredResult(result) {
    return result.type === $f4bbcf51f4268bcb$var$ResultType.deferred;
}
function $f4bbcf51f4268bcb$var$isErrorResult(result) {
    return result.type === $f4bbcf51f4268bcb$var$ResultType.error;
}
function $f4bbcf51f4268bcb$var$isRedirectResult(result) {
    return (result && result.type) === $f4bbcf51f4268bcb$var$ResultType.redirect;
}
function $f4bbcf51f4268bcb$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $f4bbcf51f4268bcb$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $f4bbcf51f4268bcb$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f4bbcf51f4268bcb$var$isRedirectResponse(result) {
    if (!$f4bbcf51f4268bcb$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $f4bbcf51f4268bcb$var$isValidMethod(method) {
    return $f4bbcf51f4268bcb$var$validRequestMethods.has(method.toLowerCase());
}
function $f4bbcf51f4268bcb$var$isMutationMethod(method) {
    return $f4bbcf51f4268bcb$var$validMutationMethods.has(method.toLowerCase());
}
async function $f4bbcf51f4268bcb$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$f4bbcf51f4268bcb$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($f4bbcf51f4268bcb$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $f4bbcf51f4268bcb$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $f4bbcf51f4268bcb$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $f4bbcf51f4268bcb$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $f4bbcf51f4268bcb$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $f4bbcf51f4268bcb$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $f4bbcf51f4268bcb$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $f4bbcf51f4268bcb$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f4bbcf51f4268bcb$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $f4bbcf51f4268bcb$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f4bbcf51f4268bcb$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $f4bbcf51f4268bcb$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $f4bbcf51f4268bcb$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $f4bbcf51f4268bcb$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $f4bbcf51f4268bcb$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $f4bbcf51f4268bcb$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $f4bbcf51f4268bcb$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($f4bbcf51f4268bcb$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $f4bbcf51f4268bcb$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($f4bbcf51f4268bcb$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $f4bbcf51f4268bcb$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8nGP5 = parcelRequire("8nGP5");

function $48e5d1fb97c993cc$var$_extends() {
    $48e5d1fb97c993cc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48e5d1fb97c993cc$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $48e5d1fb97c993cc$export$3add0d5dce533e2e = /*#__PURE__*/ $8nGP5.createContext(null);
const $48e5d1fb97c993cc$export$145dfa71566a64dc = /*#__PURE__*/ $8nGP5.createContext(null);
const $48e5d1fb97c993cc$var$AwaitContext = /*#__PURE__*/ $8nGP5.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $48e5d1fb97c993cc$export$26749e8557646306 = /*#__PURE__*/ $8nGP5.createContext(null);
const $48e5d1fb97c993cc$export$c7914228fb69b0f5 = /*#__PURE__*/ $8nGP5.createContext(null);
const $48e5d1fb97c993cc$export$9072aa6dd1f93057 = /*#__PURE__*/ $8nGP5.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $48e5d1fb97c993cc$var$RouteErrorContext = /*#__PURE__*/ $8nGP5.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $48e5d1fb97c993cc$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $48e5d1fb97c993cc$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f4bbcf51f4268bcb$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $48e5d1fb97c993cc$export$9c954a9d03d32f4a() {
    return $8nGP5.useContext($48e5d1fb97c993cc$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $48e5d1fb97c993cc$export$45d76561a5302f2b() {
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return $8nGP5.useContext($48e5d1fb97c993cc$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $48e5d1fb97c993cc$export$1b3f31771c5d07c() {
    return $8nGP5.useContext($48e5d1fb97c993cc$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $48e5d1fb97c993cc$export$6c330e8992e8a295(pattern) {
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $48e5d1fb97c993cc$export$45d76561a5302f2b();
    return $8nGP5.useMemo(()=>(0, $f4bbcf51f4268bcb$export$81336c211d5ff295)(pattern, (0, $f4bbcf51f4268bcb$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $48e5d1fb97c993cc$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $48e5d1fb97c993cc$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8nGP5.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $48e5d1fb97c993cc$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $48e5d1fb97c993cc$var$useNavigateStable() : $48e5d1fb97c993cc$var$useNavigateUnstable();
}
function $48e5d1fb97c993cc$var$useNavigateUnstable() {
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8nGP5.useContext($48e5d1fb97c993cc$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306);
    let { matches: matches } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $48e5d1fb97c993cc$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f4bbcf51f4268bcb$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8nGP5.useRef(false);
    $48e5d1fb97c993cc$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8nGP5.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $f4bbcf51f4268bcb$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f4bbcf51f4268bcb$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $48e5d1fb97c993cc$var$OutletContext = /*#__PURE__*/ $8nGP5.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $48e5d1fb97c993cc$export$4138103a3ae699cc() {
    return $8nGP5.useContext($48e5d1fb97c993cc$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $48e5d1fb97c993cc$export$a3be3530d8e40d0b(context) {
    let outlet = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $48e5d1fb97c993cc$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $48e5d1fb97c993cc$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306);
    let { matches: matches } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $48e5d1fb97c993cc$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f4bbcf51f4268bcb$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8nGP5.useMemo(()=>(0, $f4bbcf51f4268bcb$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $48e5d1fb97c993cc$export$5d3fca4a98652595(routes, locationArg) {
    return $48e5d1fb97c993cc$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $48e5d1fb97c993cc$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306);
    let { matches: parentMatches } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $48e5d1fb97c993cc$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $f4bbcf51f4268bcb$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $f4bbcf51f4268bcb$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $48e5d1fb97c993cc$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $f4bbcf51f4268bcb$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $f4bbcf51f4268bcb$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $48e5d1fb97c993cc$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $f4bbcf51f4268bcb$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $48e5d1fb97c993cc$var$DefaultErrorComponent() {
    let error = $48e5d1fb97c993cc$export$ed527bf60f6e05f2();
    let message = (0, $f4bbcf51f4268bcb$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8nGP5.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8nGP5.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $48e5d1fb97c993cc$var$defaultErrorElement = /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$DefaultErrorComponent, null);
class $48e5d1fb97c993cc$var$RenderErrorBoundary extends $8nGP5.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $48e5d1fb97c993cc$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8nGP5.useContext($48e5d1fb97c993cc$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $48e5d1fb97c993cc$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $48e5d1fb97c993cc$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $48e5d1fb97c993cc$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8nGP5.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $48e5d1fb97c993cc$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($48e5d1fb97c993cc$var$DataRouterHook || {});
var $48e5d1fb97c993cc$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($48e5d1fb97c993cc$var$DataRouterStateHook || {});
function $48e5d1fb97c993cc$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $48e5d1fb97c993cc$var$useDataRouterContext(hookName) {
    let ctx = $8nGP5.useContext($48e5d1fb97c993cc$export$3add0d5dce533e2e);
    !ctx && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return ctx;
}
function $48e5d1fb97c993cc$var$useDataRouterState(hookName) {
    let state = $8nGP5.useContext($48e5d1fb97c993cc$export$145dfa71566a64dc);
    !state && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return state;
}
function $48e5d1fb97c993cc$var$useRouteContext(hookName) {
    let route = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    !route && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $48e5d1fb97c993cc$var$useCurrentRouteId(hookName) {
    let route = $48e5d1fb97c993cc$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $48e5d1fb97c993cc$export$5fc8298006ad9e58() {
    return $48e5d1fb97c993cc$var$useCurrentRouteId($48e5d1fb97c993cc$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $48e5d1fb97c993cc$export$d0fd4b7106de2769() {
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $48e5d1fb97c993cc$export$600dc272ed516c15() {
    let dataRouterContext = $48e5d1fb97c993cc$var$useDataRouterContext($48e5d1fb97c993cc$var$DataRouterHook.UseRevalidator);
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseRevalidator);
    return $8nGP5.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $48e5d1fb97c993cc$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseMatches);
    return $8nGP5.useMemo(()=>matches.map((m)=>(0, $f4bbcf51f4268bcb$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $48e5d1fb97c993cc$export$1448a5050d252c4d() {
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseLoaderData);
    let routeId = $48e5d1fb97c993cc$var$useCurrentRouteId($48e5d1fb97c993cc$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $48e5d1fb97c993cc$export$fd5d37484eab868d(routeId) {
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $48e5d1fb97c993cc$export$fdc00f3f26066d5e() {
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseActionData);
    let routeId = $48e5d1fb97c993cc$var$useCurrentRouteId($48e5d1fb97c993cc$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $48e5d1fb97c993cc$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8nGP5.useContext($48e5d1fb97c993cc$var$RouteErrorContext);
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseRouteError);
    let routeId = $48e5d1fb97c993cc$var$useCurrentRouteId($48e5d1fb97c993cc$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $48e5d1fb97c993cc$export$78a72ddb39bdd145() {
    let value = $8nGP5.useContext($48e5d1fb97c993cc$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $48e5d1fb97c993cc$export$17f53340677d5831() {
    let value = $8nGP5.useContext($48e5d1fb97c993cc$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $48e5d1fb97c993cc$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $48e5d1fb97c993cc$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $48e5d1fb97c993cc$var$useDataRouterContext($48e5d1fb97c993cc$var$DataRouterHook.UseBlocker);
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8nGP5.useState("");
    let blockerFunction = $8nGP5.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $48e5d1fb97c993cc$var$_extends({}, currentLocation, {
                pathname: (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $48e5d1fb97c993cc$var$_extends({}, nextLocation, {
                pathname: (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8nGP5.useEffect(()=>{
        let key = String(++$48e5d1fb97c993cc$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8nGP5.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $f4bbcf51f4268bcb$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $48e5d1fb97c993cc$var$useNavigateStable() {
    let { router: router } = $48e5d1fb97c993cc$var$useDataRouterContext($48e5d1fb97c993cc$var$DataRouterHook.UseNavigateStable);
    let id = $48e5d1fb97c993cc$var$useCurrentRouteId($48e5d1fb97c993cc$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8nGP5.useRef(false);
    $48e5d1fb97c993cc$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8nGP5.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $48e5d1fb97c993cc$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $48e5d1fb97c993cc$var$alreadyWarned$1 = {};
function $48e5d1fb97c993cc$var$warningOnce(key, cond, message) {
    if (!cond && !$48e5d1fb97c993cc$var$alreadyWarned$1[key]) $48e5d1fb97c993cc$var$alreadyWarned$1[key] = true;
}
const $48e5d1fb97c993cc$var$alreadyWarned = {};
function $48e5d1fb97c993cc$var$warnOnce(key, message) {}
const $48e5d1fb97c993cc$var$logDeprecation = (flag, msg, link)=>$48e5d1fb97c993cc$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $48e5d1fb97c993cc$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $48e5d1fb97c993cc$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $48e5d1fb97c993cc$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $48e5d1fb97c993cc$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $48e5d1fb97c993cc$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $48e5d1fb97c993cc$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $48e5d1fb97c993cc$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $48e5d1fb97c993cc$var$START_TRANSITION = "startTransition";
const $48e5d1fb97c993cc$var$startTransitionImpl = $8nGP5[$48e5d1fb97c993cc$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $48e5d1fb97c993cc$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8nGP5.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8nGP5.useCallback((newState)=>{
        if (v7_startTransition && $48e5d1fb97c993cc$var$startTransitionImpl) $48e5d1fb97c993cc$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8nGP5.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8nGP5.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8nGP5.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8nGP5.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8nGP5.useEffect(()=>$48e5d1fb97c993cc$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $48e5d1fb97c993cc$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $48e5d1fb97c993cc$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $48e5d1fb97c993cc$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8nGP5.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f4bbcf51f4268bcb$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8nGP5.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8nGP5.useCallback((newState)=>{
        v7_startTransition && $48e5d1fb97c993cc$var$startTransitionImpl ? $48e5d1fb97c993cc$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8nGP5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8nGP5.useEffect(()=>$48e5d1fb97c993cc$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $48e5d1fb97c993cc$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306);
    let { matches: matches } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $48e5d1fb97c993cc$export$45d76561a5302f2b();
    let navigate = $48e5d1fb97c993cc$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $f4bbcf51f4268bcb$export$cae722b0cc860f13)(to, (0, $f4bbcf51f4268bcb$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8nGP5.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $48e5d1fb97c993cc$export$910ae8079b2c2852(props) {
    return $48e5d1fb97c993cc$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $48e5d1fb97c993cc$export$e7b0ac011bb776c6(_props) {
    (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $48e5d1fb97c993cc$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $f4bbcf51f4268bcb$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8nGP5.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $48e5d1fb97c993cc$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $f4bbcf51f4268bcb$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8nGP5.useMemo(()=>{
        let trailingPathname = (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $48e5d1fb97c993cc$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $48e5d1fb97c993cc$export$5d3fca4a98652595($48e5d1fb97c993cc$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $48e5d1fb97c993cc$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$ResolveAwait, null, children));
}
var $48e5d1fb97c993cc$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($48e5d1fb97c993cc$var$AwaitRenderStatus || {});
const $48e5d1fb97c993cc$var$neverSettledPromise = new Promise(()=>{});
class $48e5d1fb97c993cc$var$AwaitErrorBoundary extends $8nGP5.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $48e5d1fb97c993cc$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $48e5d1fb97c993cc$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $48e5d1fb97c993cc$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $48e5d1fb97c993cc$var$AwaitRenderStatus.error : "_data" in promise ? $48e5d1fb97c993cc$var$AwaitRenderStatus.success : $48e5d1fb97c993cc$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $48e5d1fb97c993cc$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $48e5d1fb97c993cc$var$AwaitRenderStatus.error && promise._error instanceof (0, $f4bbcf51f4268bcb$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $48e5d1fb97c993cc$var$neverSettledPromise;
        if (status === $48e5d1fb97c993cc$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $48e5d1fb97c993cc$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $48e5d1fb97c993cc$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $48e5d1fb97c993cc$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $48e5d1fb97c993cc$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $48e5d1fb97c993cc$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8nGP5.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8nGP5.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8nGP5.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $48e5d1fb97c993cc$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $48e5d1fb97c993cc$export$e7b0ac011bb776c6) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $48e5d1fb97c993cc$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $48e5d1fb97c993cc$export$daf73786167a7f72(matches) {
    return $48e5d1fb97c993cc$var$_renderMatches(matches);
}
function $48e5d1fb97c993cc$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8nGP5.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8nGP5.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8nGP5.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $48e5d1fb97c993cc$export$f30f7e456d254e83(routes, opts) {
    return (0, $f4bbcf51f4268bcb$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $48e5d1fb97c993cc$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f4bbcf51f4268bcb$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $48e5d1fb97c993cc$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $fd869777ac1b5d3c$var$_extends() {
    $fd869777ac1b5d3c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fd869777ac1b5d3c$var$_extends.apply(this, arguments);
}
function $fd869777ac1b5d3c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $fd869777ac1b5d3c$var$defaultMethod = "get";
const $fd869777ac1b5d3c$var$defaultEncType = "application/x-www-form-urlencoded";
function $fd869777ac1b5d3c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fd869777ac1b5d3c$var$isButtonElement(object) {
    return $fd869777ac1b5d3c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fd869777ac1b5d3c$var$isFormElement(object) {
    return $fd869777ac1b5d3c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fd869777ac1b5d3c$var$isInputElement(object) {
    return $fd869777ac1b5d3c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fd869777ac1b5d3c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fd869777ac1b5d3c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fd869777ac1b5d3c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $fd869777ac1b5d3c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fd869777ac1b5d3c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $fd869777ac1b5d3c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $fd869777ac1b5d3c$var$_formDataSupportsSubmitter = null;
function $fd869777ac1b5d3c$var$isFormDataSubmitterSupported() {
    if ($fd869777ac1b5d3c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fd869777ac1b5d3c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fd869777ac1b5d3c$var$_formDataSupportsSubmitter = true;
    }
    return $fd869777ac1b5d3c$var$_formDataSupportsSubmitter;
}
const $fd869777ac1b5d3c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fd869777ac1b5d3c$var$getFormEncType(encType) {
    if (encType != null && !$fd869777ac1b5d3c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $fd869777ac1b5d3c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($fd869777ac1b5d3c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $fd869777ac1b5d3c$var$defaultMethod;
        encType = $fd869777ac1b5d3c$var$getFormEncType(target.getAttribute("enctype")) || $fd869777ac1b5d3c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fd869777ac1b5d3c$var$isButtonElement(target) || $fd869777ac1b5d3c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fd869777ac1b5d3c$var$defaultMethod;
        encType = $fd869777ac1b5d3c$var$getFormEncType(target.getAttribute("formenctype")) || $fd869777ac1b5d3c$var$getFormEncType(form.getAttribute("enctype")) || $fd869777ac1b5d3c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$fd869777ac1b5d3c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fd869777ac1b5d3c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $fd869777ac1b5d3c$var$defaultMethod;
        action = null;
        encType = $fd869777ac1b5d3c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $fd869777ac1b5d3c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $fd869777ac1b5d3c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $fd869777ac1b5d3c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $fd869777ac1b5d3c$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $fd869777ac1b5d3c$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $fd869777ac1b5d3c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $f4bbcf51f4268bcb$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fd869777ac1b5d3c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f4bbcf51f4268bcb$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fd869777ac1b5d3c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $48e5d1fb97c993cc$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fd869777ac1b5d3c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $f4bbcf51f4268bcb$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fd869777ac1b5d3c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f4bbcf51f4268bcb$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fd869777ac1b5d3c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $48e5d1fb97c993cc$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fd869777ac1b5d3c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $fd869777ac1b5d3c$var$_extends({}, state, {
        errors: $fd869777ac1b5d3c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $fd869777ac1b5d3c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $f4bbcf51f4268bcb$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $fd869777ac1b5d3c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8nGP5.createContext({
    isTransitioning: false
});
const $fd869777ac1b5d3c$export$148fd98d095596d4 = /*#__PURE__*/ $8nGP5.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $fd869777ac1b5d3c$var$START_TRANSITION = "startTransition";
const $fd869777ac1b5d3c$var$startTransitionImpl = $8nGP5[$fd869777ac1b5d3c$var$START_TRANSITION];
const $fd869777ac1b5d3c$var$FLUSH_SYNC = "flushSync";
const $fd869777ac1b5d3c$var$flushSyncImpl = $fCKK7[$fd869777ac1b5d3c$var$FLUSH_SYNC];
const $fd869777ac1b5d3c$var$USE_ID = "useId";
const $fd869777ac1b5d3c$var$useIdImpl = $8nGP5[$fd869777ac1b5d3c$var$USE_ID];
function $fd869777ac1b5d3c$var$startTransitionSafe(cb) {
    if ($fd869777ac1b5d3c$var$startTransitionImpl) $fd869777ac1b5d3c$var$startTransitionImpl(cb);
    else cb();
}
function $fd869777ac1b5d3c$var$flushSyncSafe(cb) {
    if ($fd869777ac1b5d3c$var$flushSyncImpl) $fd869777ac1b5d3c$var$flushSyncImpl(cb);
    else cb();
}
class $fd869777ac1b5d3c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $fd869777ac1b5d3c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8nGP5.useState(router.state);
    let [pendingState, setPendingState] = $8nGP5.useState();
    let [vtContext, setVtContext] = $8nGP5.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8nGP5.useState();
    let [transition, setTransition] = $8nGP5.useState();
    let [interruption, setInterruption] = $8nGP5.useState();
    let fetcherData = $8nGP5.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8nGP5.useCallback((cb)=>{
        if (v7_startTransition) $fd869777ac1b5d3c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8nGP5.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $fd869777ac1b5d3c$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $fd869777ac1b5d3c$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $fd869777ac1b5d3c$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $fd869777ac1b5d3c$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $fd869777ac1b5d3c$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8nGP5.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8nGP5.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fd869777ac1b5d3c$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8nGP5.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8nGP5.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8nGP5.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8nGP5.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8nGP5.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8nGP5.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8nGP5.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8nGP5.useEffect(()=>(0, $48e5d1fb97c993cc$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8nGP5.createElement($fd869777ac1b5d3c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8nGP5.createElement($fd869777ac1b5d3c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8nGP5.createElement($fd869777ac1b5d3c$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $fd869777ac1b5d3c$var$MemoizedDataRoutes = /*#__PURE__*/ $8nGP5.memo($fd869777ac1b5d3c$var$DataRoutes);
function $fd869777ac1b5d3c$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $48e5d1fb97c993cc$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $fd869777ac1b5d3c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8nGP5.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f4bbcf51f4268bcb$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8nGP5.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8nGP5.useCallback((newState)=>{
        v7_startTransition && $fd869777ac1b5d3c$var$startTransitionImpl ? $fd869777ac1b5d3c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8nGP5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8nGP5.useEffect(()=>(0, $48e5d1fb97c993cc$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $fd869777ac1b5d3c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8nGP5.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f4bbcf51f4268bcb$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8nGP5.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8nGP5.useCallback((newState)=>{
        v7_startTransition && $fd869777ac1b5d3c$var$startTransitionImpl ? $fd869777ac1b5d3c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8nGP5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8nGP5.useEffect(()=>(0, $48e5d1fb97c993cc$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $fd869777ac1b5d3c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8nGP5.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8nGP5.useCallback((newState)=>{
        v7_startTransition && $fd869777ac1b5d3c$var$startTransitionImpl ? $fd869777ac1b5d3c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8nGP5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8nGP5.useEffect(()=>(0, $48e5d1fb97c993cc$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $fd869777ac1b5d3c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $fd869777ac1b5d3c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $fd869777ac1b5d3c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8nGP5.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $fd869777ac1b5d3c$var$_objectWithoutPropertiesLoose(_ref7, $fd869777ac1b5d3c$var$_excluded);
    let { basename: basename } = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $fd869777ac1b5d3c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($fd869777ac1b5d3c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $48e5d1fb97c993cc$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $fd869777ac1b5d3c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8nGP5.createElement("a", $fd869777ac1b5d3c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $fd869777ac1b5d3c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8nGP5.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $fd869777ac1b5d3c$var$_objectWithoutPropertiesLoose(_ref8, $fd869777ac1b5d3c$var$_excluded2);
    let path = (0, $48e5d1fb97c993cc$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    let routerState = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fd869777ac1b5d3c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8nGP5.createElement($fd869777ac1b5d3c$export$a6c7ac8248d6e38a, $fd869777ac1b5d3c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $fd869777ac1b5d3c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8nGP5.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $fd869777ac1b5d3c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $fd869777ac1b5d3c$var$_objectWithoutPropertiesLoose(_ref9, $fd869777ac1b5d3c$var$_excluded3);
    let submit = $fd869777ac1b5d3c$export$47c85c6e3a081d3();
    let formAction = $fd869777ac1b5d3c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8nGP5.createElement("form", $fd869777ac1b5d3c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $fd869777ac1b5d3c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $fd869777ac1b5d3c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $fd869777ac1b5d3c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($fd869777ac1b5d3c$var$DataRouterHook || ($fd869777ac1b5d3c$var$DataRouterHook = {}));
var $fd869777ac1b5d3c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($fd869777ac1b5d3c$var$DataRouterStateHook || ($fd869777ac1b5d3c$var$DataRouterStateHook = {}));
// Internal hooks
function $fd869777ac1b5d3c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $fd869777ac1b5d3c$var$useDataRouterContext(hookName) {
    let ctx = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$3add0d5dce533e2e));
    !ctx && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return ctx;
}
function $fd869777ac1b5d3c$var$useDataRouterState(hookName) {
    let state = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$145dfa71566a64dc));
    !state && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $fd869777ac1b5d3c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $48e5d1fb97c993cc$export$9770f232ac06a008)();
    let location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    let path = (0, $48e5d1fb97c993cc$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8nGP5.useCallback((event)=>{
        if ($fd869777ac1b5d3c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $f4bbcf51f4268bcb$export$fe53371bee54353d)(location) === (0, $f4bbcf51f4268bcb$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $fd869777ac1b5d3c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8nGP5.useRef($fd869777ac1b5d3c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8nGP5.useRef(false);
    let location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    let searchParams = $8nGP5.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fd869777ac1b5d3c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $48e5d1fb97c993cc$export$9770f232ac06a008)();
    let setSearchParams = $8nGP5.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $fd869777ac1b5d3c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $fd869777ac1b5d3c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $fd869777ac1b5d3c$var$fetcherId = 0;
let $fd869777ac1b5d3c$var$getUniqueFetcherId = ()=>"__" + String(++$fd869777ac1b5d3c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $fd869777ac1b5d3c$export$47c85c6e3a081d3() {
    let { router: router } = $fd869777ac1b5d3c$var$useDataRouterContext($fd869777ac1b5d3c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$26749e8557646306));
    let currentRouteId = (0, $48e5d1fb97c993cc$export$5fc8298006ad9e58)();
    return $8nGP5.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fd869777ac1b5d3c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $fd869777ac1b5d3c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $fd869777ac1b5d3c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $fd869777ac1b5d3c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$26749e8557646306));
    let routeContext = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$9072aa6dd1f93057));
    !routeContext && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $fd869777ac1b5d3c$var$_extends({}, (0, $48e5d1fb97c993cc$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f4bbcf51f4268bcb$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $f4bbcf51f4268bcb$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $fd869777ac1b5d3c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $fd869777ac1b5d3c$var$useDataRouterContext($fd869777ac1b5d3c$var$DataRouterHook.UseFetcher);
    let state = $fd869777ac1b5d3c$var$useDataRouterState($fd869777ac1b5d3c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8nGP5.useContext($fd869777ac1b5d3c$export$148fd98d095596d4);
    let route = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    !route && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $fd869777ac1b5d3c$var$useIdImpl ? $fd869777ac1b5d3c$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8nGP5.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($fd869777ac1b5d3c$var$getUniqueFetcherId());
    // Registration/cleanup
    $8nGP5.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8nGP5.useCallback((href, opts)=>{
        !routeId && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $fd869777ac1b5d3c$export$47c85c6e3a081d3();
    let submit = $8nGP5.useCallback((target, opts)=>{
        submitImpl(target, $fd869777ac1b5d3c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8nGP5.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8nGP5.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8nGP5.createElement($fd869777ac1b5d3c$export$a7fed597f4b8afd8, $fd869777ac1b5d3c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $f4bbcf51f4268bcb$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8nGP5.useMemo(()=>$fd869777ac1b5d3c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $fd869777ac1b5d3c$export$fa996778a3a31087() {
    let state = $fd869777ac1b5d3c$var$useDataRouterState($fd869777ac1b5d3c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $fd869777ac1b5d3c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $fd869777ac1b5d3c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $fd869777ac1b5d3c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $fd869777ac1b5d3c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $fd869777ac1b5d3c$var$useDataRouterContext($fd869777ac1b5d3c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $fd869777ac1b5d3c$var$useDataRouterState($fd869777ac1b5d3c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$26749e8557646306));
    let location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    let matches = (0, $48e5d1fb97c993cc$export$2378eb7f5ff86053)();
    let navigation = (0, $48e5d1fb97c993cc$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8nGP5.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $fd869777ac1b5d3c$var$usePageHide($8nGP5.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $fd869777ac1b5d3c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fd869777ac1b5d3c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fd869777ac1b5d3c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8nGP5.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $fd869777ac1b5d3c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fd869777ac1b5d3c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8nGP5.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($fd869777ac1b5d3c$var$_extends({}, location, {
                    pathname: (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($fd869777ac1b5d3c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8nGP5.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fd869777ac1b5d3c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8nGP5.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fd869777ac1b5d3c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8nGP5.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $fd869777ac1b5d3c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $48e5d1fb97c993cc$export$b273b3273281a049)(when);
    $8nGP5.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8nGP5.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $fd869777ac1b5d3c$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8nGP5.useContext($fd869777ac1b5d3c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let { basename: basename } = $fd869777ac1b5d3c$var$useDataRouterContext($fd869777ac1b5d3c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $48e5d1fb97c993cc$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $f4bbcf51f4268bcb$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $f4bbcf51f4268bcb$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");
const $ec9fcdd42cb47dac$var$_excluded = [
    "as",
    "disabled"
];
function $ec9fcdd42cb47dac$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ec9fcdd42cb47dac$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $ec9fcdd42cb47dac$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $ec9fcdd42cb47dac$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $ec9fcdd42cb47dac$var$Button = /*#__PURE__*/ $8nGP5.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $ec9fcdd42cb47dac$var$_objectWithoutPropertiesLoose(_ref, $ec9fcdd42cb47dac$var$_excluded);
    const [buttonProps, { tagName: Component }] = $ec9fcdd42cb47dac$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$ec9fcdd42cb47dac$var$Button.displayName = 'Button';
var $ec9fcdd42cb47dac$export$2e2bcd8739ae039 = $ec9fcdd42cb47dac$var$Button;



var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");
"use client";
const $58df59260255f5cd$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $58df59260255f5cd$export$ff817e17bad2e091 = 'xs';
const $58df59260255f5cd$var$ThemeContext = /*#__PURE__*/ $8nGP5.createContext({
    prefixes: {},
    breakpoints: $58df59260255f5cd$export$666ad80b5007f835,
    minBreakpoint: $58df59260255f5cd$export$ff817e17bad2e091
});
const { Consumer: $58df59260255f5cd$export$b631efc24e9d5e2f, Provider: $58df59260255f5cd$var$Provider } = $58df59260255f5cd$var$ThemeContext;
function $58df59260255f5cd$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $58df59260255f5cd$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $58df59260255f5cd$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $8nGP5.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($58df59260255f5cd$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $58df59260255f5cd$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $8nGP5.useContext)($58df59260255f5cd$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $58df59260255f5cd$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $8nGP5.useContext)($58df59260255f5cd$var$ThemeContext);
    return breakpoints;
}
function $58df59260255f5cd$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $8nGP5.useContext)($58df59260255f5cd$var$ThemeContext);
    return minBreakpoint;
}
function $58df59260255f5cd$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $8nGP5.useContext)($58df59260255f5cd$var$ThemeContext);
    return dir === 'rtl';
}
function $58df59260255f5cd$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $8nGP5.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $58df59260255f5cd$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $58df59260255f5cd$export$2e2bcd8739ae039 = $58df59260255f5cd$var$ThemeProvider;



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $e3fe232d2b1bc057$var$Button = /*#__PURE__*/ $8nGP5.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $ec9fcdd42cb47dac$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$e3fe232d2b1bc057$var$Button.displayName = 'Button';
var $e3fe232d2b1bc057$export$2e2bcd8739ae039 = $e3fe232d2b1bc057$var$Button;



var $T5IcR = parcelRequire("T5IcR");



var $f6922ed004a61ab7$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $f6922ed004a61ab7$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $f6922ed004a61ab7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f6922ed004a61ab7$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f6922ed004a61ab7$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $f6922ed004a61ab7$export$2fc8123783cbf45e = (()=>{
    var _a, _BacktestingStore_backtestingData_accessor_storage, _BacktestingStore_loading_accessor_storage, _BacktestingStore_error_accessor_storage;
    let _instanceExtraInitializers = [];
    let _backtestingData_decorators;
    let _backtestingData_initializers = [];
    let _backtestingData_extraInitializers = [];
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _error_decorators;
    let _error_initializers = [];
    let _error_extraInitializers = [];
    let _fetchData_decorators;
    let _get_processedData_decorators;
    return _a = class BacktestingStore {
        get backtestingData() {
            return $f6922ed004a61ab7$var$__classPrivateFieldGet(this, _BacktestingStore_backtestingData_accessor_storage, "f");
        }
        set backtestingData(value) {
            $f6922ed004a61ab7$var$__classPrivateFieldSet(this, _BacktestingStore_backtestingData_accessor_storage, value, "f");
        }
        get loading() {
            return $f6922ed004a61ab7$var$__classPrivateFieldGet(this, _BacktestingStore_loading_accessor_storage, "f");
        }
        set loading(value) {
            $f6922ed004a61ab7$var$__classPrivateFieldSet(this, _BacktestingStore_loading_accessor_storage, value, "f");
        }
        get error() {
            return $f6922ed004a61ab7$var$__classPrivateFieldGet(this, _BacktestingStore_error_accessor_storage, "f");
        }
        set error(value) {
            $f6922ed004a61ab7$var$__classPrivateFieldSet(this, _BacktestingStore_error_accessor_storage, value, "f");
        }
        constructor(){
            _BacktestingStore_backtestingData_accessor_storage.set(this, ($f6922ed004a61ab7$var$__runInitializers(this, _instanceExtraInitializers), $f6922ed004a61ab7$var$__runInitializers(this, _backtestingData_initializers, null)));
            _BacktestingStore_loading_accessor_storage.set(this, ($f6922ed004a61ab7$var$__runInitializers(this, _backtestingData_extraInitializers), $f6922ed004a61ab7$var$__runInitializers(this, _loading_initializers, true)));
            _BacktestingStore_error_accessor_storage.set(this, ($f6922ed004a61ab7$var$__runInitializers(this, _loading_extraInitializers), $f6922ed004a61ab7$var$__runInitializers(this, _error_initializers, null)));
            $f6922ed004a61ab7$var$__runInitializers(this, _error_extraInitializers);
            (0, $T5IcR.makeObservable)(this);
        }
        getFieldDisplayName(fieldName) {
            // Try to get display name from FieldsSchema
            if (fieldName in (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)) {
                const schema = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName];
                // Check if schema has a display property in any of its properties
                if ('yearly' in schema && schema.yearly) return fieldName.replace(/_per_year$/, '').split('_').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
            }
            // Handle special cases
            const specialCases = {
                'top_1_customers_revenue_percentage': 'Top 1 Customers Revenue %',
                'top_10_customers_revenue_percentage': 'Top 10 Customers Revenue %',
                'company_name': 'Company Name',
                'company_ceo': 'Company CEO',
                'hq_location': 'HQ Location',
                'year_founded': 'Year Founded',
                'capitalized_software_override': 'Capitalized Development Costs',
                'maintenance_capex_per_year': 'Maintenance CapEx',
                'net_revenue_per_year': 'Revenue',
                'gross_profit_per_year': 'Gross Profit',
                'ebitda_per_year': 'EBITDA',
                'adjusted_ebitda_per_year': 'Adj. EBITDA',
                'gross_retention_lost_only_per_year': 'Gross Retention (Lost Only)',
                'net_retention_yearly': 'Net Retention',
                'total_current_assets_yearly': 'Current Assets',
                'total_current_liabilities_yearly': 'Current Liabilities',
                'capex_per_year': 'Capex'
            };
            return specialCases[fieldName] || fieldName.split('_').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        }
        fetchData() {
            return $f6922ed004a61ab7$var$__awaiter(this, void 0, void 0, function*() {
                try {
                    this.loading = true;
                    this.error = null;
                    const firebase = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                    const backTestRef = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(firebase.db, 'backtest_results');
                    const data = yield (0, $e0be213f695400f3$export$3988ae62b71be9a3)(backTestRef);
                    if (data.exists()) (0, $T5IcR.runInAction)(()=>{
                        this.backtestingData = data.val();
                    });
                    else (0, $T5IcR.runInAction)(()=>{
                        this.backtestingData = {};
                    });
                } catch (err) {
                    console.error('Error fetching backtesting data:', err);
                    (0, $T5IcR.runInAction)(()=>{
                        this.error = 'Failed to load backtesting data';
                    });
                } finally{
                    (0, $T5IcR.runInAction)(()=>{
                        this.loading = false;
                    });
                }
            });
        }
        get processedData() {
            if (!this.backtestingData) return null;
            // Collect all tests
            const allTests = [];
            Object.entries(this.backtestingData).forEach(([dealId, dealTests])=>{
                Object.values(dealTests).forEach((test)=>{
                    allTests.push(test);
                });
            });
            // Group tests by version
            const versionMap = new Map();
            allTests.forEach((test)=>{
                const version = test.metadata.backend_version || 'unknown';
                if (!versionMap.has(version)) versionMap.set(version, []);
                versionMap.get(version).push(test);
            });
            // Process each version
            const versions = Array.from(versionMap.entries()).map(([version, tests])=>{
                // Get unique deals and fields for this version
                const deals = Array.from(new Set(tests.map((t)=>t.source_of_truth_deal_id)));
                const fields = Array.from(new Set(tests.flatMap((t)=>Object.keys(t.results))));
                // Calculate field accuracies
                const fieldAccuracies = {};
                fields.forEach((field)=>{
                    const fieldResults = tests.filter((t)=>field in t.results);
                    const matches = fieldResults.filter((t)=>t.results[field].is_match).length;
                    // Collect results per deal
                    const dealResults = {};
                    fieldResults.forEach((test)=>{
                        dealResults[test.source_of_truth_deal_id] = {
                            is_match: test.results[field].is_match,
                            source_of_truth_value: test.results[field].source_of_truth_value,
                            test_run_value: test.results[field].test_run_value,
                            timestamp: test.metadata.timestamp
                        };
                    });
                    fieldAccuracies[field] = {
                        accuracy: matches / fieldResults.length,
                        total: fieldResults.length,
                        matches: matches,
                        dealResults: dealResults
                    };
                });
                // Calculate overall accuracy
                const overallAccuracy = tests.reduce((sum, test)=>sum + test.metadata.overall_accuracy, 0) / tests.length;
                // Get the most recent test timestamp for this version
                const latestTest = tests.reduce((latest, test)=>{
                    const testTime = new Date(test.metadata.timestamp).getTime();
                    return !latest || testTime > new Date(latest.metadata.timestamp).getTime() ? test : latest;
                }, tests[0]);
                return {
                    version: version,
                    deals: deals,
                    fields: fields,
                    tests: tests,
                    fieldAccuracies: fieldAccuracies,
                    overallAccuracy: overallAccuracy,
                    metadata: {
                        timestamp: latestTest.metadata.timestamp,
                        run_at: latestTest.metadata.run_at,
                        executed_by: latestTest.metadata.executed_by,
                        backend_version: latestTest.metadata.backend_version
                    }
                };
            });
            // Sort versions by timestamp
            versions.sort((a, b)=>{
                const aTime = new Date(a.metadata.timestamp).getTime();
                const bTime = new Date(b.metadata.timestamp).getTime();
                return aTime - bTime;
            });
            // Get all unique fields that have ever been tested
            const allFields = Array.from(new Set(versions.flatMap((v)=>v.fields))).sort();
            // Create version comparison data
            const fieldComparisons = allFields.map((field)=>{
                const displayName = this.getFieldDisplayName(field);
                const versionResults = {};
                versions.forEach((v)=>{
                    if (field in v.fieldAccuracies) {
                        const accuracy = v.fieldAccuracies[field];
                        versionResults[v.version] = {
                            accuracy: accuracy.accuracy,
                            total: accuracy.total,
                            matches: accuracy.matches
                        };
                    } else versionResults[v.version] = null;
                });
                return {
                    field: field,
                    displayName: displayName,
                    versionResults: versionResults
                };
            });
            // Sort fields alphabetically by display name
            fieldComparisons.sort((a, b)=>a.displayName.localeCompare(b.displayName));
            return {
                versions: versions,
                fieldComparisons: fieldComparisons,
                allFields: allFields
            };
        }
    }, _BacktestingStore_backtestingData_accessor_storage = new WeakMap(), _BacktestingStore_loading_accessor_storage = new WeakMap(), _BacktestingStore_error_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _backtestingData_decorators = [
            (0, $T5IcR.observable)
        ];
        _loading_decorators = [
            (0, $T5IcR.observable)
        ];
        _error_decorators = [
            (0, $T5IcR.observable)
        ];
        _fetchData_decorators = [
            (0, $T5IcR.action)
        ];
        _get_processedData_decorators = [
            (0, $T5IcR.computed)
        ];
        $f6922ed004a61ab7$var$__esDecorate(_a, null, _backtestingData_decorators, {
            kind: "accessor",
            name: "backtestingData",
            static: false,
            private: false,
            access: {
                has: (obj)=>"backtestingData" in obj,
                get: (obj)=>obj.backtestingData,
                set: (obj, value)=>{
                    obj.backtestingData = value;
                }
            },
            metadata: _metadata
        }, _backtestingData_initializers, _backtestingData_extraInitializers);
        $f6922ed004a61ab7$var$__esDecorate(_a, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loading" in obj,
                get: (obj)=>obj.loading,
                set: (obj, value)=>{
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _loading_extraInitializers);
        $f6922ed004a61ab7$var$__esDecorate(_a, null, _error_decorators, {
            kind: "accessor",
            name: "error",
            static: false,
            private: false,
            access: {
                has: (obj)=>"error" in obj,
                get: (obj)=>obj.error,
                set: (obj, value)=>{
                    obj.error = value;
                }
            },
            metadata: _metadata
        }, _error_initializers, _error_extraInitializers);
        $f6922ed004a61ab7$var$__esDecorate(_a, null, _fetchData_decorators, {
            kind: "method",
            name: "fetchData",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fetchData" in obj,
                get: (obj)=>obj.fetchData
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $f6922ed004a61ab7$var$__esDecorate(_a, null, _get_processedData_decorators, {
            kind: "getter",
            name: "processedData",
            static: false,
            private: false,
            access: {
                has: (obj)=>"processedData" in obj,
                get: (obj)=>obj.processedData
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
// Create a singleton instance
const $f6922ed004a61ab7$var$backtestingStore = new $f6922ed004a61ab7$export$2fc8123783cbf45e();
const $f6922ed004a61ab7$export$1ebdec035ffac9bd = ()=>$f6922ed004a61ab7$var$backtestingStore;


var $00163985929c6b54$export$f843afa9e9b53052;
var $00163985929c6b54$export$40a9eeef55665a40;
var $00163985929c6b54$export$b8972b998723d602;
var $00163985929c6b54$export$13925b5cf10ba292;
var $00163985929c6b54$export$93b7586d956c930e;
var $00163985929c6b54$export$9bfd64464b8f45a7;
var $00163985929c6b54$export$38e42c68cf43b5d4;
var $00163985929c6b54$export$15c60d712917cee6;
var $00163985929c6b54$export$a7db06668cad9adb;
var $00163985929c6b54$export$34e0f9847d4c02dd;
var $00163985929c6b54$export$252465da46a2ae40;
var $00163985929c6b54$export$2b53d53e423cdab9;
var $00163985929c6b54$export$1d6a9118937ed7d;
var $00163985929c6b54$export$58da63f03165c2f9;
var $00163985929c6b54$export$84221cc388bca1;
var $00163985929c6b54$export$4c52ea7d4acf259a;
var $00163985929c6b54$export$705a5d0f317c1086;
var $00163985929c6b54$export$27fe35c112973b92;
var $00163985929c6b54$export$7cb505ef3217a5c4;
var $00163985929c6b54$export$649ecc744817b5c7;
var $00163985929c6b54$export$e81601c80b4e876e;
var $00163985929c6b54$export$7ba6177e240eac98;
var $00163985929c6b54$export$60744eb6487238a3;
var $00163985929c6b54$export$ea6d0c2efb25a89e;
var $00163985929c6b54$export$6e7e37eb8f7adace;
var $00163985929c6b54$export$12bd7e6396252f7c;
var $00163985929c6b54$export$75b421b9855b6bb5;
var $00163985929c6b54$export$156474db97972001;
var $00163985929c6b54$export$82462a21aead86ed;
var $00163985929c6b54$export$d9ce03847cc286f2;
var $00163985929c6b54$export$4f512692da3ee37d;
var $00163985929c6b54$export$f2d5245d66b09437;
var $00163985929c6b54$export$d978fa30aeff199f;
var $00163985929c6b54$export$a6d1b741b95d60e7;
var $00163985929c6b54$export$d57d50d329e176cd;
var $00163985929c6b54$export$fb313acfb15c9d4d;
var $00163985929c6b54$export$682bb571521324b7;
var $00163985929c6b54$export$dbe047964f50b6ff;
var $00163985929c6b54$export$e8fc12ede0ba29ac;
var $00163985929c6b54$export$34667176fbb427b0;
var $00163985929c6b54$export$96e4b36520c26a2c;
var $00163985929c6b54$export$add244bda2f9423c;
var $00163985929c6b54$export$3099d0daead893d3;
var $00163985929c6b54$export$475ea8af95eb4516;
var $00163985929c6b54$export$8d6d009d1f06226e;
var $00163985929c6b54$export$fb184b623420d9be;
var $00163985929c6b54$export$c96745152eb2740f;
var $00163985929c6b54$export$480fff2e0766c90e;
var $00163985929c6b54$export$f765a644dcb18b0;
var $00163985929c6b54$export$611af70312ccd4a0;
var $00163985929c6b54$export$9842c0fef17e1195;
var $00163985929c6b54$export$f04863362ae346da;
var $00163985929c6b54$export$6a5bec5ac36fa0ed;
var $00163985929c6b54$export$e2ae4e7e6c2355ac;
var $00163985929c6b54$export$944650aba5c1de21;
var $00163985929c6b54$export$c728ab0932043065;
var $00163985929c6b54$export$4f081f07c0fd24b0;
var $00163985929c6b54$export$b7fd59eeefab32d8;
var $00163985929c6b54$export$b6059b24dea06560;
var $00163985929c6b54$export$87e8fb11df40e8cf;
var $00163985929c6b54$export$9d15b7319b395d1;
var $00163985929c6b54$export$f340828b36f985db;
var $00163985929c6b54$export$3059dccea22603ea;
var $00163985929c6b54$export$f9614e80fcc8ccac;
var $00163985929c6b54$export$e67ef840c66287bf;
var $00163985929c6b54$export$a5f98448b9315739;
var $00163985929c6b54$export$57c9d70002d6d2e4;
var $00163985929c6b54$export$fac5cddadc0272;
var $00163985929c6b54$export$b49b7e6b62273467;
var $00163985929c6b54$export$8206f45866bddfd9;
var $00163985929c6b54$export$22a2e6f02c6c081f;
var $00163985929c6b54$export$fa8f8c077625f0c0;
var $00163985929c6b54$export$60d5655c6babb2a0;
var $00163985929c6b54$export$ae78d338ad66ff90;
$00163985929c6b54$export$f843afa9e9b53052 = "panelImage_8c4922";
$00163985929c6b54$export$40a9eeef55665a40 = "defaultPadding_8c4922";
$00163985929c6b54$export$b8972b998723d602 = "shadow_8c4922";
$00163985929c6b54$export$13925b5cf10ba292 = "small-shadow_8c4922";
$00163985929c6b54$export$93b7586d956c930e = "dropShadow_8c4922";
$00163985929c6b54$export$9bfd64464b8f45a7 = "pageContainer_8c4922";
$00163985929c6b54$export$38e42c68cf43b5d4 = "header_8c4922";
$00163985929c6b54$export$15c60d712917cee6 = "headerTitle_8c4922";
$00163985929c6b54$export$a7db06668cad9adb = "content_8c4922";
$00163985929c6b54$export$34e0f9847d4c02dd = "container_8c4922";
$00163985929c6b54$export$252465da46a2ae40 = "emptyState_8c4922";
$00163985929c6b54$export$2b53d53e423cdab9 = "chartContainer_8c4922";
$00163985929c6b54$export$1d6a9118937ed7d = "versionStats_8c4922";
$00163985929c6b54$export$58da63f03165c2f9 = "statsGrid_8c4922";
$00163985929c6b54$export$84221cc388bca1 = "versionStat_8c4922";
$00163985929c6b54$export$4c52ea7d4acf259a = "versionHeader_8c4922";
$00163985929c6b54$export$705a5d0f317c1086 = "versionDate_8c4922";
$00163985929c6b54$export$27fe35c112973b92 = "statsContent_8c4922";
$00163985929c6b54$export$7cb505ef3217a5c4 = "high_8c4922";
$00163985929c6b54$export$649ecc744817b5c7 = "medium_8c4922";
$00163985929c6b54$export$e81601c80b4e876e = "low_8c4922";
$00163985929c6b54$export$7ba6177e240eac98 = "versionConnector_8c4922";
$00163985929c6b54$export$60744eb6487238a3 = "connectorTitle_8c4922";
$00163985929c6b54$export$ea6d0c2efb25a89e = "commonFields_8c4922";
$00163985929c6b54$export$6e7e37eb8f7adace = "newFields_8c4922";
$00163985929c6b54$export$12bd7e6396252f7c = "removedFields_8c4922";
$00163985929c6b54$export$75b421b9855b6bb5 = "comparisonPercent_8c4922";
$00163985929c6b54$export$156474db97972001 = "fieldAccuracy_8c4922";
$00163985929c6b54$export$82462a21aead86ed = "filters_8c4922";
$00163985929c6b54$export$d9ce03847cc286f2 = "filterContainer_8c4922";
$00163985929c6b54$export$4f512692da3ee37d = "filterInput_8c4922";
$00163985929c6b54$export$f2d5245d66b09437 = "tableContainer_8c4922";
$00163985929c6b54$export$d978fa30aeff199f = "comparisonTable_8c4922";
$00163985929c6b54$export$a6d1b741b95d60e7 = "fieldNameHeader_8c4922";
$00163985929c6b54$export$d57d50d329e176cd = "fieldName_8c4922";
$00163985929c6b54$export$fb313acfb15c9d4d = "versionLabel_8c4922";
$00163985929c6b54$export$682bb571521324b7 = "accuracyCell_8c4922";
$00163985929c6b54$export$dbe047964f50b6ff = "accuracyValue_8c4922";
$00163985929c6b54$export$e8fc12ede0ba29ac = "matchCount_8c4922";
$00163985929c6b54$export$34667176fbb427b0 = "notTested_8c4922";
$00163985929c6b54$export$96e4b36520c26a2c = "modal_8c4922";
$00163985929c6b54$export$add244bda2f9423c = "modalContent_8c4922";
$00163985929c6b54$export$3099d0daead893d3 = "modalHeader_8c4922";
$00163985929c6b54$export$475ea8af95eb4516 = "modalBody_8c4922";
$00163985929c6b54$export$8d6d009d1f06226e = "backButton_8c4922";
$00163985929c6b54$export$fb184b623420d9be = "title_8c4922";
$00163985929c6b54$export$c96745152eb2740f = "subtitle_8c4922";
$00163985929c6b54$export$480fff2e0766c90e = "statsContainer_8c4922";
$00163985929c6b54$export$f765a644dcb18b0 = "statCard_8c4922";
$00163985929c6b54$export$611af70312ccd4a0 = "statValue_8c4922";
$00163985929c6b54$export$9842c0fef17e1195 = "statLabel_8c4922";
$00163985929c6b54$export$f04863362ae346da = "resultTable_8c4922";
$00163985929c6b54$export$6a5bec5ac36fa0ed = "compareTable_8c4922";
$00163985929c6b54$export$e2ae4e7e6c2355ac = "valueCell_8c4922";
$00163985929c6b54$export$944650aba5c1de21 = "matchSuccess_8c4922";
$00163985929c6b54$export$c728ab0932043065 = "matchError_8c4922";
$00163985929c6b54$export$4f081f07c0fd24b0 = "modalTitle_8c4922";
$00163985929c6b54$export$b7fd59eeefab32d8 = "modalLabel_8c4922";
$00163985929c6b54$export$b6059b24dea06560 = "modalPre_8c4922";
$00163985929c6b54$export$87e8fb11df40e8cf = "compareTableHeader_8c4922";
$00163985929c6b54$export$9d15b7319b395d1 = "compareTableCell_8c4922";
$00163985929c6b54$export$f340828b36f985db = "compareTableMatch_8c4922";
$00163985929c6b54$export$3059dccea22603ea = "compareTableMismatch_8c4922";
$00163985929c6b54$export$f9614e80fcc8ccac = "compareValue_8c4922";
$00163985929c6b54$export$e67ef840c66287bf = "modalDialog_8c4922";
$00163985929c6b54$export$a5f98448b9315739 = "dashboard_8c4922";
$00163985929c6b54$export$57c9d70002d6d2e4 = "fieldVersionInfo_8c4922";
$00163985929c6b54$export$fac5cddadc0272 = "sampleCount_8c4922";
$00163985929c6b54$export$b49b7e6b62273467 = "comparisonMatrix_8c4922";
$00163985929c6b54$export$8206f45866bddfd9 = "matrixHeader_8c4922";
$00163985929c6b54$export$22a2e6f02c6c081f = "matrixRow_8c4922";
$00163985929c6b54$export$fa8f8c077625f0c0 = "matrixCell_8c4922";
$00163985929c6b54$export$60d5655c6babb2a0 = "clickable_8c4922";
$00163985929c6b54$export$ae78d338ad66ff90 = "scaleInOut_8c4922";



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");
const $a5cfab634e3a04d6$export$f51f4c4ede09e011 = (props)=>{
    const ref = (0, $8nGP5.useRef)();
    const id = props.id || '';
    const fillCell = props.fillCell || false;
    const direction = props.direction || 'row';
    const justify = props.justify || 'start';
    const wrap = props.wrap || 'nowrap';
    const alignItems = props.alignItems || 'stretch';
    const className = props.className || '';
    const inline = props.inline || false;
    const flexType = inline ? 'd-inline-flex' : 'd-flex';
    const classes = `${flexType} flex-${direction} justify-content-${justify} flex-${wrap} align-items-${alignItems} ${className} ${fillCell ? 'h-100 w-100' : ''}`;
    return (0, $kSbwP.jsx)("div", {
        id: id,
        className: classes,
        style: props.style,
        onClick: ()=>{
            if (props.onClick) props.onClick();
        },
        children: props.children
    });
};



const $1ac83566e6b5504b$export$ce7cfd4f28e6833 = (postfix)=>{
    return (data)=>{
        return (0, $7fbd760f3c05e83d$export$48d3f001ea9fddb0)(data.toString()) + postfix;
    };
};
const $1ac83566e6b5504b$export$40333d0facc9092d = (data)=>{
    if (!data && data !== 0) data = '';
    return (0, $7fbd760f3c05e83d$export$48d3f001ea9fddb0)(data.toString());
};
const $1ac83566e6b5504b$export$32e6b1ae352e94d6 = (data)=>{
    if (!data && data !== 0) data = '';
    return (0, $7fbd760f3c05e83d$export$e440a706af0c0216)(data.toString());
};
const $1ac83566e6b5504b$export$23be700726d3a499 = (data)=>{
    if (!data && data !== 0) data = '';
    return (0, $7fbd760f3c05e83d$export$e440a706af0c0216)(data.toString(), 1);
};
const $1ac83566e6b5504b$export$91991769c57c29a = (data)=>{
    if (!data) data = '';
    return data.toString();
};
const $1ac83566e6b5504b$export$8c8c9051f21dcdc2 = (data)=>{
    return data;
};


const $613bef4b407d3331$export$5be27499c82e15a7 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const navigate = (0, $48e5d1fb97c993cc$export$9770f232ac06a008)();
    const store = (0, $f6922ed004a61ab7$export$1ebdec035ffac9bd)();
    const [selectedDeal, setSelectedDeal] = (0, $8nGP5.useState)(null);
    const [fieldFilter, setFieldFilter] = (0, $8nGP5.useState)('');
    const [sortOrder, setSortOrder] = (0, $8nGP5.useState)('desc');
    const [selectedCell, setSelectedCell] = (0, $8nGP5.useState)(null);
    const [showResultModal, setShowResultModal] = (0, $8nGP5.useState)(false);
    const chartContainerRef = (0, $8nGP5.useRef)(null);
    // Fetch backtesting data from Firebase
    (0, $8nGP5.useEffect)(()=>{
        store.fetchData();
    }, []);
    // Go back to main app
    const goBack = ()=>{
        navigate('/');
    };
    // Render loading state
    if (store.loading) return (0, $kSbwP.jsxs)("div", {
        className: $00163985929c6b54$export$9bfd64464b8f45a7,
        children: [
            (0, $kSbwP.jsxs)("div", {
                className: $00163985929c6b54$export$38e42c68cf43b5d4,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: $00163985929c6b54$export$15c60d712917cee6,
                        children: "Backtesting Dashboard"
                    }),
                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        variant: "outline-light",
                        onClick: goBack,
                        children: "Back to App"
                    })
                ]
            }),
            (0, $kSbwP.jsx)("div", {
                className: $00163985929c6b54$export$a7db06668cad9adb,
                children: (0, $kSbwP.jsx)("div", {
                    className: $00163985929c6b54$export$252465da46a2ae40,
                    children: "Loading backtesting data..."
                })
            })
        ]
    });
    // Render error state
    if (store.error) return (0, $kSbwP.jsxs)("div", {
        className: $00163985929c6b54$export$9bfd64464b8f45a7,
        children: [
            (0, $kSbwP.jsxs)("div", {
                className: $00163985929c6b54$export$38e42c68cf43b5d4,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: $00163985929c6b54$export$15c60d712917cee6,
                        children: "Backtesting Dashboard"
                    }),
                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        variant: "outline-light",
                        onClick: goBack,
                        children: "Back to App"
                    })
                ]
            }),
            (0, $kSbwP.jsx)("div", {
                className: $00163985929c6b54$export$a7db06668cad9adb,
                children: (0, $kSbwP.jsxs)("div", {
                    className: $00163985929c6b54$export$252465da46a2ae40,
                    children: [
                        "Error: ",
                        store.error
                    ]
                })
            })
        ]
    });
    // Render empty state
    if (!store.processedData || store.processedData.versions.length === 0) return (0, $kSbwP.jsxs)("div", {
        className: $00163985929c6b54$export$9bfd64464b8f45a7,
        children: [
            (0, $kSbwP.jsxs)("div", {
                className: $00163985929c6b54$export$38e42c68cf43b5d4,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: $00163985929c6b54$export$15c60d712917cee6,
                        children: "Backtesting Dashboard"
                    }),
                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        variant: "outline-light",
                        onClick: goBack,
                        children: "Back to App"
                    })
                ]
            }),
            (0, $kSbwP.jsx)("div", {
                className: $00163985929c6b54$export$a7db06668cad9adb,
                children: (0, $kSbwP.jsx)("div", {
                    className: $00163985929c6b54$export$252465da46a2ae40,
                    children: "No backtesting data available. Run backtests to see results here."
                })
            })
        ]
    });
    const data = store.processedData;
    const handleCellClick = (field, displayName, version)=>{
        const versionData = data.versions.find((v)=>v.version === version);
        if (!versionData) return;
        const fieldData = versionData.fieldAccuracies[field];
        if (!fieldData) return;
        const dealResults = Object.entries(fieldData.dealResults).map(([dealId, result])=>Object.assign({
                dealId: dealId
            }, result));
        setSelectedCell({
            field: field,
            displayName: displayName,
            version: version,
            dealResults: dealResults
        });
        setShowResultModal(true);
    };
    const getAccuracyClass = (accuracy)=>{
        if (accuracy >= 0.8) return $00163985929c6b54$export$7cb505ef3217a5c4;
        if (accuracy >= 0.6) return $00163985929c6b54$export$649ecc744817b5c7;
        return $00163985929c6b54$export$e81601c80b4e876e;
    };
    const getAccuracyDescription = (accuracy)=>{
        if (accuracy >= 0.8) return 'High accuracy - Very reliable extraction';
        if (accuracy >= 0.6) return 'Medium accuracy - Generally reliable extraction';
        return 'Low accuracy - Needs improvement';
    };
    // Sort versions by timestamp from metadata
    const sortedVersions = [
        ...data.versions
    ].sort((a, b)=>{
        var _a, _b;
        const aTime = new Date(((_a = a.metadata) === null || _a === void 0 ? void 0 : _a.timestamp) || 0).getTime();
        const bTime = new Date(((_b = b.metadata) === null || _b === void 0 ? void 0 : _b.timestamp) || 0).getTime();
        return sortOrder === 'asc' ? aTime - bTime : bTime - aTime;
    });
    // Filter and process field comparisons
    const processFieldComparisons = ()=>{
        let comparisons = [
            ...data.fieldComparisons
        ];
        // Filter by search term if any
        if (fieldFilter) comparisons = comparisons.filter((comp)=>comp.displayName.toLowerCase().includes(fieldFilter.toLowerCase()));
        // Filter by selected deal if applicable
        if (selectedDeal) comparisons = comparisons.map((comp)=>Object.assign(Object.assign({}, comp), {
                versionResults: Object.fromEntries(Object.entries(comp.versionResults).map(([version, results])=>{
                    var _a;
                    if (!results) return [
                        version,
                        null
                    ];
                    const versionData = data.versions.find((v)=>v.version === version);
                    const dealResult = (_a = versionData === null || versionData === void 0 ? void 0 : versionData.fieldAccuracies[comp.field]) === null || _a === void 0 ? void 0 : _a.dealResults[selectedDeal];
                    return [
                        version,
                        dealResult ? {
                            accuracy: dealResult.is_match ? 1 : 0,
                            total: 1,
                            matches: dealResult.is_match ? 1 : 0
                        } : null
                    ];
                }))
            }));
        return comparisons;
    };
    const formatDate = (timestamp)=>{
        if (!timestamp) return 'N/A';
        const date = new Date(timestamp);
        return `${date.toLocaleString()} UTC`;
    };
    const renderResultsModal = ()=>{
        if (!showResultModal || !selectedCell) return null;
        const { field: field, displayName: displayName, version: version, dealResults: dealResults } = selectedCell;
        return (0, $kSbwP.jsx)("div", {
            className: $00163985929c6b54$export$96e4b36520c26a2c,
            children: (0, $kSbwP.jsxs)("div", {
                className: $00163985929c6b54$export$add244bda2f9423c,
                children: [
                    (0, $kSbwP.jsxs)("div", {
                        className: $00163985929c6b54$export$3099d0daead893d3,
                        children: [
                            (0, $kSbwP.jsxs)("h2", {
                                children: [
                                    displayName,
                                    " - Version ",
                                    version
                                ]
                            }),
                            (0, $kSbwP.jsx)("button", {
                                onClick: ()=>setShowResultModal(false),
                                children: "\u00D7"
                            })
                        ]
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $00163985929c6b54$export$475ea8af95eb4516,
                        children: (0, $kSbwP.jsx)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '2rem'
                            },
                            children: dealResults.filter((result)=>!selectedDeal || result.dealId === selectedDeal).map((result)=>{
                                const sourceValue = result.source_of_truth_value;
                                const testValue = result.test_run_value;
                                const isTabularData = Array.isArray(sourceValue) && sourceValue.length > 0 && typeof sourceValue[0] === 'object';
                                return (0, $kSbwP.jsxs)("div", {
                                    children: [
                                        (0, $kSbwP.jsxs)("div", {
                                            style: {
                                                padding: '1rem',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '4px',
                                                marginBottom: '1rem',
                                                display: 'flex',
                                                gap: '2rem'
                                            },
                                            children: [
                                                (0, $kSbwP.jsxs)("div", {
                                                    children: [
                                                        (0, $kSbwP.jsx)("span", {
                                                            style: {
                                                                color: '#6c757d',
                                                                fontSize: '0.9rem'
                                                            },
                                                            children: "Deal ID"
                                                        }),
                                                        (0, $kSbwP.jsx)("div", {
                                                            style: {
                                                                fontWeight: 'bold',
                                                                color: '#243a5c',
                                                                marginTop: '0.25rem'
                                                            },
                                                            children: result.dealId
                                                        })
                                                    ]
                                                }),
                                                (0, $kSbwP.jsxs)("div", {
                                                    children: [
                                                        (0, $kSbwP.jsx)("span", {
                                                            style: {
                                                                color: '#6c757d',
                                                                fontSize: '0.9rem'
                                                            },
                                                            children: "Test Date"
                                                        }),
                                                        (0, $kSbwP.jsxs)("div", {
                                                            style: {
                                                                fontWeight: 'bold',
                                                                color: '#243a5c',
                                                                marginTop: '0.25rem'
                                                            },
                                                            children: [
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($fX8pL)))(result.timestamp).format('MMM DD, YYYY HH:mm:ss'),
                                                                " UTC"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        (0, $kSbwP.jsxs)("table", {
                                            className: $00163985929c6b54$export$6a5bec5ac36fa0ed,
                                            children: [
                                                (0, $kSbwP.jsxs)("thead", {
                                                    children: [
                                                        (0, $kSbwP.jsxs)("tr", {
                                                            children: [
                                                                (0, $kSbwP.jsx)("th", {
                                                                    className: $00163985929c6b54$export$87e8fb11df40e8cf,
                                                                    style: {
                                                                        width: '10%'
                                                                    },
                                                                    children: "Match"
                                                                }),
                                                                (0, $kSbwP.jsx)("th", {
                                                                    className: $00163985929c6b54$export$87e8fb11df40e8cf,
                                                                    style: {
                                                                        width: '45%'
                                                                    },
                                                                    colSpan: isTabularData ? sourceValue[0] ? Object.keys(sourceValue[0]).length : 2 : 2,
                                                                    children: "Source of Truth"
                                                                }),
                                                                (0, $kSbwP.jsx)("th", {
                                                                    className: $00163985929c6b54$export$87e8fb11df40e8cf,
                                                                    style: {
                                                                        width: '45%'
                                                                    },
                                                                    colSpan: isTabularData ? sourceValue[0] ? Object.keys(sourceValue[0]).length : 2 : 2,
                                                                    children: "Test Run"
                                                                })
                                                            ]
                                                        }),
                                                        isTabularData && (0, $kSbwP.jsxs)("tr", {
                                                            children: [
                                                                (0, $kSbwP.jsx)("th", {}),
                                                                Object.keys(sourceValue[0]).map((key)=>(0, $kSbwP.jsx)("th", {
                                                                        className: $00163985929c6b54$export$87e8fb11df40e8cf,
                                                                        children: key
                                                                    }, `source-${key}`)),
                                                                Object.keys(sourceValue[0]).map((key)=>(0, $kSbwP.jsx)("th", {
                                                                        className: $00163985929c6b54$export$87e8fb11df40e8cf,
                                                                        children: key
                                                                    }, `test-${key}`))
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                (0, $kSbwP.jsx)("tbody", {
                                                    children: isTabularData ? (()=>{
                                                        const allYears = new Set([
                                                            ...sourceValue.map((item)=>item.year),
                                                            ...Array.isArray(testValue) ? testValue.map((item)=>item.year) : []
                                                        ]);
                                                        return Array.from(allYears).map((year)=>{
                                                            const sourceRow = sourceValue.find((item)=>item.year === year) || {};
                                                            const testRow = Array.isArray(testValue) ? testValue.find((item)=>item.year === year) || {} : {};
                                                            const rowMatches = Object.keys(sourceRow).every((key)=>String(sourceRow[key]) === String(testRow[key]));
                                                            return (0, $kSbwP.jsxs)("tr", {
                                                                children: [
                                                                    (0, $kSbwP.jsx)("td", {
                                                                        className: $00163985929c6b54$export$9d15b7319b395d1,
                                                                        style: {
                                                                            textAlign: 'center',
                                                                            fontWeight: 'bold',
                                                                            color: rowMatches ? '#0c8a20' : '#d62b2b'
                                                                        },
                                                                        children: rowMatches ? "\u2713" : "\u2717"
                                                                    }),
                                                                    Object.keys(sourceValue[0]).map((key)=>(0, $kSbwP.jsx)("td", {
                                                                            className: $00163985929c6b54$export$9d15b7319b395d1,
                                                                            style: {
                                                                                color: rowMatches ? '#0c8a20' : '#d62b2b'
                                                                            },
                                                                            children: sourceRow[key] || 'NaN'
                                                                        }, `source-${key}`)),
                                                                    Object.keys(sourceValue[0]).map((key)=>(0, $kSbwP.jsx)("td", {
                                                                            className: $00163985929c6b54$export$9d15b7319b395d1,
                                                                            style: {
                                                                                color: rowMatches ? '#0c8a20' : '#d62b2b'
                                                                            },
                                                                            children: testRow[key] || 'NaN'
                                                                        }, `test-${key}`))
                                                                ]
                                                            }, year);
                                                        });
                                                    })() : (0, $kSbwP.jsxs)("tr", {
                                                        children: [
                                                            (0, $kSbwP.jsx)("td", {
                                                                className: $00163985929c6b54$export$9d15b7319b395d1,
                                                                style: {
                                                                    textAlign: 'center',
                                                                    fontWeight: 'bold',
                                                                    color: result.is_match ? '#0c8a20' : '#d62b2b'
                                                                },
                                                                children: result.is_match ? "\u2713" : "\u2717"
                                                            }),
                                                            (0, $kSbwP.jsx)("td", {
                                                                className: `${$00163985929c6b54$export$9d15b7319b395d1} ${$00163985929c6b54$export$f9614e80fcc8ccac}`,
                                                                colSpan: 2,
                                                                style: {
                                                                    color: result.is_match ? '#0c8a20' : '#d62b2b'
                                                                },
                                                                children: result.source_of_truth_value
                                                            }),
                                                            (0, $kSbwP.jsx)("td", {
                                                                className: `${$00163985929c6b54$export$9d15b7319b395d1} ${$00163985929c6b54$export$f9614e80fcc8ccac}`,
                                                                colSpan: 2,
                                                                style: {
                                                                    color: result.is_match ? '#0c8a20' : '#d62b2b'
                                                                },
                                                                children: result.test_run_value
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, result.dealId);
                            })
                        })
                    })
                ]
            })
        });
    };
    const renderAccuracyChart = ()=>{
        const chartData = sortedVersions.map((version)=>{
            var _a;
            return {
                version: version.version,
                accuracy: version.overallAccuracy * 100,
                timestamp: (_a = version.metadata) === null || _a === void 0 ? void 0 : _a.timestamp
            };
        });
        return (0, $kSbwP.jsxs)("div", {
            className: $00163985929c6b54$export$2b53d53e423cdab9,
            ref: chartContainerRef,
            children: [
                (0, $kSbwP.jsxs)("div", {
                    style: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '1rem'
                    },
                    children: [
                        (0, $kSbwP.jsx)("h3", {
                            children: "Version Accuracy History"
                        }),
                        (0, $kSbwP.jsxs)("select", {
                            value: sortOrder,
                            onChange: (e)=>setSortOrder(e.target.value),
                            className: $00163985929c6b54$export$4f512692da3ee37d,
                            style: {
                                width: 'auto'
                            },
                            children: [
                                (0, $kSbwP.jsx)("option", {
                                    value: "desc",
                                    children: "Most Recent First"
                                }),
                                (0, $kSbwP.jsx)("option", {
                                    value: "asc",
                                    children: "Oldest First"
                                })
                            ]
                        })
                    ]
                }),
                (0, $kSbwP.jsx)("div", {
                    style: {
                        width: '100%',
                        height: '300px'
                    },
                    children: (0, $kSbwP.jsx)((0, $65a9db7fe004392a$export$e60a4704009a0009), {
                        children: (0, $kSbwP.jsxs)((0, $3db935e47dd15f70$export$54d0e8420ac838ac), {
                            data: chartData,
                            children: [
                                (0, $kSbwP.jsx)((0, $836f11cfcda8d642$export$6440e27b9f186856), {
                                    strokeDasharray: "3 3"
                                }),
                                (0, $kSbwP.jsx)((0, $f4dd95f529f72065$export$ea77231de273b52d), {
                                    dataKey: "version",
                                    angle: -45,
                                    textAnchor: "end",
                                    height: 60,
                                    interval: 0,
                                    tick: {
                                        fontSize: 12,
                                        width: 100
                                    }
                                }),
                                (0, $kSbwP.jsx)((0, $0a6c1adc00c46590$export$f96c4024c52de8f4), {
                                    domain: [
                                        0,
                                        100
                                    ]
                                }),
                                (0, $kSbwP.jsx)((0, $c1ee5960bb8c7c28$export$28c660c63b792dea), {
                                    formatter: (value)=>[
                                            `${value.toFixed(1)}%`,
                                            'Accuracy %'
                                        ],
                                    labelFormatter: (label)=>{
                                        const version = chartData.find((d)=>d.version === label);
                                        return `Version: ${label}\nDate: ${formatDate(version === null || version === void 0 ? void 0 : version.timestamp)}`;
                                    },
                                    separator: ": ",
                                    contentStyle: {
                                        whiteSpace: 'pre-line'
                                    }
                                }),
                                (0, $kSbwP.jsx)((0, $06340f5273236c74$export$ed247974535929c7), {}),
                                (0, $kSbwP.jsx)((0, $a0158cc2cd24124f$export$17d680238e50603e), {
                                    type: "monotone",
                                    dataKey: "accuracy",
                                    name: "Accuracy %",
                                    stroke: "#243a5c",
                                    strokeWidth: 2,
                                    dot: {
                                        r: 4
                                    },
                                    activeDot: {
                                        r: 6
                                    }
                                })
                            ]
                        })
                    })
                })
            ]
        });
    };
    const renderVersionStats = ()=>{
        return (0, $kSbwP.jsxs)("div", {
            className: $00163985929c6b54$export$1d6a9118937ed7d,
            children: [
                (0, $kSbwP.jsxs)("div", {
                    style: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '1rem'
                    },
                    children: [
                        (0, $kSbwP.jsx)("h3", {
                            children: "Version Statistics"
                        }),
                        (0, $kSbwP.jsxs)("select", {
                            value: sortOrder,
                            onChange: (e)=>setSortOrder(e.target.value),
                            className: $00163985929c6b54$export$4f512692da3ee37d,
                            style: {
                                width: 'auto'
                            },
                            children: [
                                (0, $kSbwP.jsx)("option", {
                                    value: "desc",
                                    children: "Most Recent First"
                                }),
                                (0, $kSbwP.jsx)("option", {
                                    value: "asc",
                                    children: "Oldest First"
                                })
                            ]
                        })
                    ]
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $00163985929c6b54$export$58da63f03165c2f9,
                    children: sortedVersions.map((version, index)=>{
                        var _a, _b;
                        const nextVersion = index < sortedVersions.length - 1 ? sortedVersions[index + 1] : null;
                        return (0, $kSbwP.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, {
                            children: [
                                (0, $kSbwP.jsxs)("div", {
                                    className: $00163985929c6b54$export$84221cc388bca1,
                                    children: [
                                        (0, $kSbwP.jsxs)("div", {
                                            className: $00163985929c6b54$export$4c52ea7d4acf259a,
                                            children: [
                                                (0, $kSbwP.jsx)("h4", {
                                                    title: version.version,
                                                    children: version.version
                                                }),
                                                (0, $kSbwP.jsx)("span", {
                                                    className: $00163985929c6b54$export$705a5d0f317c1086,
                                                    title: `Test executed on ${formatDate((_a = version.metadata) === null || _a === void 0 ? void 0 : _a.timestamp)}`,
                                                    children: formatDate((_b = version.metadata) === null || _b === void 0 ? void 0 : _b.timestamp)
                                                })
                                            ]
                                        }),
                                        (0, $kSbwP.jsxs)("div", {
                                            className: $00163985929c6b54$export$27fe35c112973b92,
                                            children: [
                                                (0, $kSbwP.jsxs)("p", {
                                                    children: [
                                                        (0, $kSbwP.jsx)("span", {
                                                            children: "Deals Tested"
                                                        }),
                                                        (0, $kSbwP.jsx)("span", {
                                                            title: `${version.deals.length} deals were processed in this test run`,
                                                            children: version.deals.length
                                                        })
                                                    ]
                                                }),
                                                (0, $kSbwP.jsxs)("p", {
                                                    children: [
                                                        (0, $kSbwP.jsx)("span", {
                                                            children: "Fields Tested"
                                                        }),
                                                        (0, $kSbwP.jsx)("span", {
                                                            title: `${version.fields.length} unique fields were extracted and compared`,
                                                            children: version.fields.length
                                                        })
                                                    ]
                                                }),
                                                (0, $kSbwP.jsxs)("p", {
                                                    children: [
                                                        (0, $kSbwP.jsx)("span", {
                                                            children: "Overall Accuracy"
                                                        }),
                                                        (0, $kSbwP.jsx)("span", {
                                                            className: getAccuracyClass(version.overallAccuracy),
                                                            title: getAccuracyDescription(version.overallAccuracy),
                                                            children: (0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)(version.overallAccuracy)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                nextVersion && (0, $kSbwP.jsxs)("div", {
                                    className: $00163985929c6b54$export$7ba6177e240eac98,
                                    title: `Comparing ${version.version} with ${nextVersion.version}`,
                                    children: [
                                        (0, $kSbwP.jsx)("div", {
                                            className: $00163985929c6b54$export$60744eb6487238a3,
                                            children: "Field Comparison"
                                        }),
                                        (()=>{
                                            const commonFields = version.fields.filter((field)=>nextVersion.fields.includes(field));
                                            const newFields = nextVersion.fields.filter((field)=>!version.fields.includes(field));
                                            const removedFields = version.fields.filter((field)=>!nextVersion.fields.includes(field));
                                            const comparisonPercent = commonFields.length / Math.max(version.fields.length, nextVersion.fields.length) * 100;
                                            return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
                                                children: [
                                                    (0, $kSbwP.jsxs)("div", {
                                                        className: $00163985929c6b54$export$ea6d0c2efb25a89e,
                                                        title: `${commonFields.length} fields are present in both versions`,
                                                        children: [
                                                            commonFields.length,
                                                            " Common Fields"
                                                        ]
                                                    }),
                                                    newFields.length > 0 && (0, $kSbwP.jsxs)("div", {
                                                        className: $00163985929c6b54$export$6e7e37eb8f7adace,
                                                        title: `${newFields.length} new fields added in ${nextVersion.version}`,
                                                        children: [
                                                            "+",
                                                            newFields.length,
                                                            " New Fields"
                                                        ]
                                                    }),
                                                    removedFields.length > 0 && (0, $kSbwP.jsxs)("div", {
                                                        className: $00163985929c6b54$export$12bd7e6396252f7c,
                                                        title: `${removedFields.length} fields removed in ${nextVersion.version}`,
                                                        children: [
                                                            "-",
                                                            removedFields.length,
                                                            " Removed Fields"
                                                        ]
                                                    }),
                                                    (0, $kSbwP.jsxs)("div", {
                                                        className: $00163985929c6b54$export$75b421b9855b6bb5,
                                                        title: "Percentage of fields that can be directly compared between versions",
                                                        children: [
                                                            comparisonPercent.toFixed(0),
                                                            "% Comparable"
                                                        ]
                                                    })
                                                ]
                                            });
                                        })()
                                    ]
                                })
                            ]
                        }, version.version);
                    })
                })
            ]
        });
    };
    const renderFieldAccuracyComparison = ()=>{
        const fieldComparisons = processFieldComparisons();
        return (0, $kSbwP.jsxs)("div", {
            className: $00163985929c6b54$export$156474db97972001,
            children: [
                (0, $kSbwP.jsxs)("div", {
                    style: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '1rem'
                    },
                    children: [
                        (0, $kSbwP.jsx)("h3", {
                            children: "Field Accuracy Comparison"
                        }),
                        (0, $kSbwP.jsxs)("select", {
                            value: sortOrder,
                            onChange: (e)=>setSortOrder(e.target.value),
                            className: $00163985929c6b54$export$4f512692da3ee37d,
                            style: {
                                width: 'auto'
                            },
                            children: [
                                (0, $kSbwP.jsx)("option", {
                                    value: "desc",
                                    children: "Most Recent First"
                                }),
                                (0, $kSbwP.jsx)("option", {
                                    value: "asc",
                                    children: "Oldest First"
                                })
                            ]
                        })
                    ]
                }),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "row",
                    className: $00163985929c6b54$export$82462a21aead86ed,
                    children: [
                        (0, $kSbwP.jsx)("div", {
                            className: $00163985929c6b54$export$d9ce03847cc286f2,
                            children: (0, $kSbwP.jsx)("input", {
                                type: "text",
                                className: $00163985929c6b54$export$4f512692da3ee37d,
                                value: fieldFilter,
                                onChange: (e)=>setFieldFilter(e.target.value),
                                placeholder: "Filter by field name"
                            })
                        }),
                        (0, $kSbwP.jsx)("div", {
                            className: $00163985929c6b54$export$d9ce03847cc286f2,
                            children: (0, $kSbwP.jsxs)("select", {
                                value: selectedDeal || '',
                                onChange: (e)=>setSelectedDeal(e.target.value || null),
                                className: $00163985929c6b54$export$4f512692da3ee37d,
                                children: [
                                    (0, $kSbwP.jsx)("option", {
                                        value: "",
                                        children: "Filter by Deal"
                                    }),
                                    Array.from(new Set(data.versions.flatMap((v)=>v.deals))).map((deal)=>(0, $kSbwP.jsx)("option", {
                                            value: deal,
                                            children: deal
                                        }, deal))
                                ]
                            })
                        })
                    ]
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $00163985929c6b54$export$f2d5245d66b09437,
                    children: (0, $kSbwP.jsxs)("table", {
                        className: $00163985929c6b54$export$d978fa30aeff199f,
                        children: [
                            (0, $kSbwP.jsx)("thead", {
                                children: (0, $kSbwP.jsxs)("tr", {
                                    children: [
                                        (0, $kSbwP.jsx)("th", {
                                            className: $00163985929c6b54$export$a6d1b741b95d60e7,
                                            children: "Field"
                                        }),
                                        sortedVersions.map((version)=>{
                                            var _a;
                                            return (0, $kSbwP.jsxs)("th", {
                                                className: $00163985929c6b54$export$4c52ea7d4acf259a,
                                                children: [
                                                    (0, $kSbwP.jsx)("div", {
                                                        className: $00163985929c6b54$export$fb313acfb15c9d4d,
                                                        title: version.version,
                                                        children: version.version
                                                    }),
                                                    (0, $kSbwP.jsx)("div", {
                                                        className: $00163985929c6b54$export$705a5d0f317c1086,
                                                        children: formatDate((_a = version.metadata) === null || _a === void 0 ? void 0 : _a.timestamp)
                                                    })
                                                ]
                                            }, version.version);
                                        })
                                    ]
                                })
                            }),
                            (0, $kSbwP.jsx)("tbody", {
                                children: fieldComparisons.map((comparison)=>(0, $kSbwP.jsxs)("tr", {
                                        children: [
                                            (0, $kSbwP.jsx)("td", {
                                                className: $00163985929c6b54$export$d57d50d329e176cd,
                                                title: comparison.displayName,
                                                children: comparison.displayName
                                            }),
                                            sortedVersions.map((version)=>{
                                                const result = comparison.versionResults[version.version];
                                                if (!result) return (0, $kSbwP.jsx)("td", {
                                                    className: $00163985929c6b54$export$34667176fbb427b0,
                                                    children: "-"
                                                }, version.version);
                                                return (0, $kSbwP.jsxs)("td", {
                                                    className: $00163985929c6b54$export$682bb571521324b7,
                                                    onClick: ()=>handleCellClick(comparison.field, comparison.displayName, version.version),
                                                    children: [
                                                        (0, $kSbwP.jsx)("div", {
                                                            className: `${$00163985929c6b54$export$dbe047964f50b6ff} ${getAccuracyClass(result.accuracy)}`,
                                                            children: (0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)(result.accuracy)
                                                        }),
                                                        (0, $kSbwP.jsxs)("div", {
                                                            className: $00163985929c6b54$export$e8fc12ede0ba29ac,
                                                            children: [
                                                                "(",
                                                                result.matches,
                                                                "/",
                                                                result.total,
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                }, version.version);
                                            })
                                        ]
                                    }, comparison.field))
                            })
                        ]
                    })
                })
            ]
        });
    };
    return (0, $kSbwP.jsxs)("div", {
        className: $00163985929c6b54$export$9bfd64464b8f45a7,
        children: [
            (0, $kSbwP.jsxs)("div", {
                className: $00163985929c6b54$export$38e42c68cf43b5d4,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: $00163985929c6b54$export$15c60d712917cee6,
                        children: "Backtesting Dashboard"
                    }),
                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        variant: "outline-light",
                        onClick: goBack,
                        children: "Back to App"
                    })
                ]
            }),
            (0, $kSbwP.jsx)("div", {
                className: $00163985929c6b54$export$a7db06668cad9adb,
                children: (0, $kSbwP.jsxs)("div", {
                    className: $00163985929c6b54$export$34e0f9847d4c02dd,
                    children: [
                        renderAccuracyChart(),
                        renderVersionStats(),
                        renderFieldAccuracyComparison()
                    ]
                })
            }),
            renderResultsModal()
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");
var $11d64bfbeec2556f$exports = {};
$11d64bfbeec2556f$exports = new URL("logo-1752058808881-blue.e8a70c5a.svg", import.meta.url).toString();


var $dd745a44a0bc8be6$exports = {};
$dd745a44a0bc8be6$exports = new URL("bird_logo.4a767494.png", import.meta.url).toString();


const $bc783706f3494468$export$e6ff31bff12b7ff4 = (props)=>{
    const width = props.width || 160;
    return (0, $kSbwP.jsx)("img", {
        style: {
            cursor: 'pointer',
            objectFit: 'contain'
        },
        className: props.className,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($11d64bfbeec2556f$exports))),
        width: width,
        onClick: ()=>{
            if (props.onClick) props.onClick();
        }
    });
};
const $bc783706f3494468$export$7707107edd1bbb83 = ()=>{
    return (0, $kSbwP.jsx)("img", {
        style: {
            objectFit: 'contain'
        },
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dd745a44a0bc8be6$exports))),
        width: 50
    });
};



var $kSbwP = parcelRequire("kSbwP");

// src/index.ts
// src/hooks/useChain.ts
// src/index.ts
var $d67fa8c2937648db$var$updateQueue = $d67fa8c2937648db$var$makeQueue();
var $d67fa8c2937648db$export$27f233d61a9e2fa4 = (fn)=>$d67fa8c2937648db$var$schedule(fn, $d67fa8c2937648db$var$updateQueue);
var $d67fa8c2937648db$var$writeQueue = $d67fa8c2937648db$var$makeQueue();
$d67fa8c2937648db$export$27f233d61a9e2fa4.write = (fn)=>$d67fa8c2937648db$var$schedule(fn, $d67fa8c2937648db$var$writeQueue);
var $d67fa8c2937648db$var$onStartQueue = $d67fa8c2937648db$var$makeQueue();
$d67fa8c2937648db$export$27f233d61a9e2fa4.onStart = (fn)=>$d67fa8c2937648db$var$schedule(fn, $d67fa8c2937648db$var$onStartQueue);
var $d67fa8c2937648db$var$onFrameQueue = $d67fa8c2937648db$var$makeQueue();
$d67fa8c2937648db$export$27f233d61a9e2fa4.onFrame = (fn)=>$d67fa8c2937648db$var$schedule(fn, $d67fa8c2937648db$var$onFrameQueue);
var $d67fa8c2937648db$var$onFinishQueue = $d67fa8c2937648db$var$makeQueue();
$d67fa8c2937648db$export$27f233d61a9e2fa4.onFinish = (fn)=>$d67fa8c2937648db$var$schedule(fn, $d67fa8c2937648db$var$onFinishQueue);
var $d67fa8c2937648db$var$timeouts = [];
$d67fa8c2937648db$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $d67fa8c2937648db$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $d67fa8c2937648db$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $d67fa8c2937648db$var$timeouts.splice(i, 1);
        $d67fa8c2937648db$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $d67fa8c2937648db$var$timeouts.splice($d67fa8c2937648db$var$findTimeout(time), 0, timeout);
    $d67fa8c2937648db$var$pendingCount += 1;
    $d67fa8c2937648db$var$start();
    return timeout;
};
var $d67fa8c2937648db$var$findTimeout = (time)=>~(~$d67fa8c2937648db$var$timeouts.findIndex((t)=>t.time > time) || ~$d67fa8c2937648db$var$timeouts.length);
$d67fa8c2937648db$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $d67fa8c2937648db$var$onStartQueue.delete(fn);
    $d67fa8c2937648db$var$onFrameQueue.delete(fn);
    $d67fa8c2937648db$var$onFinishQueue.delete(fn);
    $d67fa8c2937648db$var$updateQueue.delete(fn);
    $d67fa8c2937648db$var$writeQueue.delete(fn);
};
$d67fa8c2937648db$export$27f233d61a9e2fa4.sync = (fn)=>{
    $d67fa8c2937648db$var$sync = true;
    $d67fa8c2937648db$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $d67fa8c2937648db$var$sync = false;
};
$d67fa8c2937648db$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $d67fa8c2937648db$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $d67fa8c2937648db$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $d67fa8c2937648db$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$d67fa8c2937648db$export$27f233d61a9e2fa4.use = (impl)=>$d67fa8c2937648db$var$nativeRaf = impl;
$d67fa8c2937648db$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$d67fa8c2937648db$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$d67fa8c2937648db$export$27f233d61a9e2fa4.catch = console.error;
$d67fa8c2937648db$export$27f233d61a9e2fa4.frameLoop = "always";
$d67fa8c2937648db$export$27f233d61a9e2fa4.advance = ()=>{
    if ($d67fa8c2937648db$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $d67fa8c2937648db$var$update();
};
var $d67fa8c2937648db$var$ts = -1;
var $d67fa8c2937648db$var$pendingCount = 0;
var $d67fa8c2937648db$var$sync = false;
function $d67fa8c2937648db$var$schedule(fn, queue) {
    if ($d67fa8c2937648db$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $d67fa8c2937648db$var$start();
    }
}
function $d67fa8c2937648db$var$start() {
    if ($d67fa8c2937648db$var$ts < 0) {
        $d67fa8c2937648db$var$ts = 0;
        if ($d67fa8c2937648db$export$27f233d61a9e2fa4.frameLoop !== "demand") $d67fa8c2937648db$var$nativeRaf($d67fa8c2937648db$var$loop);
    }
}
function $d67fa8c2937648db$var$stop() {
    $d67fa8c2937648db$var$ts = -1;
}
function $d67fa8c2937648db$var$loop() {
    if (~$d67fa8c2937648db$var$ts) {
        $d67fa8c2937648db$var$nativeRaf($d67fa8c2937648db$var$loop);
        $d67fa8c2937648db$export$27f233d61a9e2fa4.batchedUpdates($d67fa8c2937648db$var$update);
    }
}
function $d67fa8c2937648db$var$update() {
    const prevTs = $d67fa8c2937648db$var$ts;
    $d67fa8c2937648db$var$ts = $d67fa8c2937648db$export$27f233d61a9e2fa4.now();
    const count = $d67fa8c2937648db$var$findTimeout($d67fa8c2937648db$var$ts);
    if (count) {
        $d67fa8c2937648db$var$eachSafely($d67fa8c2937648db$var$timeouts.splice(0, count), (t)=>t.handler());
        $d67fa8c2937648db$var$pendingCount -= count;
    }
    if (!$d67fa8c2937648db$var$pendingCount) {
        $d67fa8c2937648db$var$stop();
        return;
    }
    $d67fa8c2937648db$var$onStartQueue.flush();
    $d67fa8c2937648db$var$updateQueue.flush(prevTs ? Math.min(64, $d67fa8c2937648db$var$ts - prevTs) : 16.667);
    $d67fa8c2937648db$var$onFrameQueue.flush();
    $d67fa8c2937648db$var$writeQueue.flush();
    $d67fa8c2937648db$var$onFinishQueue.flush();
}
function $d67fa8c2937648db$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $d67fa8c2937648db$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $d67fa8c2937648db$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $d67fa8c2937648db$var$pendingCount -= current.size;
                $d67fa8c2937648db$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $d67fa8c2937648db$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $d67fa8c2937648db$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $d67fa8c2937648db$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $d67fa8c2937648db$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $d67fa8c2937648db$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $d67fa8c2937648db$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $d67fa8c2937648db$var$ts = -1;
        $d67fa8c2937648db$var$timeouts = [];
        $d67fa8c2937648db$var$onStartQueue = $d67fa8c2937648db$var$makeQueue();
        $d67fa8c2937648db$var$updateQueue = $d67fa8c2937648db$var$makeQueue();
        $d67fa8c2937648db$var$onFrameQueue = $d67fa8c2937648db$var$makeQueue();
        $d67fa8c2937648db$var$writeQueue = $d67fa8c2937648db$var$makeQueue();
        $d67fa8c2937648db$var$onFinishQueue = $d67fa8c2937648db$var$makeQueue();
        $d67fa8c2937648db$var$pendingCount = 0;
    }
};



var $8nGP5 = parcelRequire("8nGP5");
var $fda335f6a9b8d095$var$__defProp = Object.defineProperty;
var $fda335f6a9b8d095$var$__export = (target, all)=>{
    for(var name in all)$fda335f6a9b8d095$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $fda335f6a9b8d095$export$cceeabf822b64fc0 = {};
$fda335f6a9b8d095$var$__export($fda335f6a9b8d095$export$cceeabf822b64fc0, {
    assign: ()=>$fda335f6a9b8d095$var$assign,
    colors: ()=>$fda335f6a9b8d095$var$colors,
    createStringInterpolator: ()=>$fda335f6a9b8d095$var$createStringInterpolator,
    skipAnimation: ()=>$fda335f6a9b8d095$var$skipAnimation,
    to: ()=>$fda335f6a9b8d095$var$to,
    willAdvance: ()=>$fda335f6a9b8d095$var$willAdvance
});
// src/helpers.ts
function $fda335f6a9b8d095$export$8793edee2d425525() {}
var $fda335f6a9b8d095$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $fda335f6a9b8d095$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $fda335f6a9b8d095$export$248d38f6296296c5(a, b) {
    if ($fda335f6a9b8d095$export$226b3eccf92c9ed9.arr(a)) {
        if (!$fda335f6a9b8d095$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $fda335f6a9b8d095$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $fda335f6a9b8d095$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($fda335f6a9b8d095$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $fda335f6a9b8d095$export$45b10814cc054894 = (a)=>$fda335f6a9b8d095$export$226b3eccf92c9ed9.und(a) ? [] : $fda335f6a9b8d095$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $fda335f6a9b8d095$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $fda335f6a9b8d095$export$79b2f7037acddd43(items, iterator);
    }
}
var $fda335f6a9b8d095$export$7ba486852759e806 = (queue, ...args)=>$fda335f6a9b8d095$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $fda335f6a9b8d095$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $fda335f6a9b8d095$var$createStringInterpolator;
var $fda335f6a9b8d095$var$to;
var $fda335f6a9b8d095$var$colors = null;
var $fda335f6a9b8d095$var$skipAnimation = false;
var $fda335f6a9b8d095$var$willAdvance = $fda335f6a9b8d095$export$8793edee2d425525;
var $fda335f6a9b8d095$var$assign = (globals)=>{
    if (globals.to) $fda335f6a9b8d095$var$to = globals.to;
    if (globals.now) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== void 0) $fda335f6a9b8d095$var$colors = globals.colors;
    if (globals.skipAnimation != null) $fda335f6a9b8d095$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $fda335f6a9b8d095$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $fda335f6a9b8d095$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $fda335f6a9b8d095$var$startQueue = /* @__PURE__ */ new Set();
var $fda335f6a9b8d095$var$currentFrame = [];
var $fda335f6a9b8d095$var$prevFrame = [];
var $fda335f6a9b8d095$var$priority = 0;
var $fda335f6a9b8d095$export$a57f5080a3bcc90a = {
    get idle () {
        return !$fda335f6a9b8d095$var$startQueue.size && !$fda335f6a9b8d095$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($fda335f6a9b8d095$var$priority > animation.priority) {
            $fda335f6a9b8d095$var$startQueue.add(animation);
            (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).onStart($fda335f6a9b8d095$var$flushStartQueue);
        } else {
            $fda335f6a9b8d095$var$startSafely(animation);
            (0, $d67fa8c2937648db$export$27f233d61a9e2fa4)($fda335f6a9b8d095$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $fda335f6a9b8d095$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($fda335f6a9b8d095$var$priority) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).onFrame(()=>$fda335f6a9b8d095$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $fda335f6a9b8d095$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $fda335f6a9b8d095$var$currentFrame.splice(prevIndex, 1);
                $fda335f6a9b8d095$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $fda335f6a9b8d095$var$currentFrame = [];
        $fda335f6a9b8d095$var$startQueue.clear();
    }
};
function $fda335f6a9b8d095$var$flushStartQueue() {
    $fda335f6a9b8d095$var$startQueue.forEach($fda335f6a9b8d095$var$startSafely);
    $fda335f6a9b8d095$var$startQueue.clear();
    (0, $d67fa8c2937648db$export$27f233d61a9e2fa4)($fda335f6a9b8d095$var$advance);
}
function $fda335f6a9b8d095$var$startSafely(animation) {
    if (!$fda335f6a9b8d095$var$currentFrame.includes(animation)) $fda335f6a9b8d095$var$startUnsafely(animation);
}
function $fda335f6a9b8d095$var$startUnsafely(animation) {
    $fda335f6a9b8d095$var$currentFrame.splice($fda335f6a9b8d095$var$findIndex($fda335f6a9b8d095$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $fda335f6a9b8d095$var$advance(dt) {
    const nextFrame = $fda335f6a9b8d095$var$prevFrame;
    for(let i = 0; i < $fda335f6a9b8d095$var$currentFrame.length; i++){
        const animation = $fda335f6a9b8d095$var$currentFrame[i];
        $fda335f6a9b8d095$var$priority = animation.priority;
        if (!animation.idle) {
            $fda335f6a9b8d095$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $fda335f6a9b8d095$var$priority = 0;
    $fda335f6a9b8d095$var$prevFrame = $fda335f6a9b8d095$var$currentFrame;
    $fda335f6a9b8d095$var$prevFrame.length = 0;
    $fda335f6a9b8d095$var$currentFrame = nextFrame;
    return $fda335f6a9b8d095$var$currentFrame.length > 0;
}
function $fda335f6a9b8d095$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $fda335f6a9b8d095$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $fda335f6a9b8d095$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $fda335f6a9b8d095$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $fda335f6a9b8d095$var$PERCENTAGE = $fda335f6a9b8d095$var$NUMBER + "%";
function $fda335f6a9b8d095$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $fda335f6a9b8d095$export$8972dc0e6ad9238f = new RegExp("rgb" + $fda335f6a9b8d095$var$call($fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$NUMBER));
var $fda335f6a9b8d095$export$4e46ac54fc82cf3b = new RegExp("rgba" + $fda335f6a9b8d095$var$call($fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$NUMBER));
var $fda335f6a9b8d095$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $fda335f6a9b8d095$var$call($fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$PERCENTAGE, $fda335f6a9b8d095$var$PERCENTAGE));
var $fda335f6a9b8d095$export$810b04175080204c = new RegExp("hsla" + $fda335f6a9b8d095$var$call($fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$PERCENTAGE, $fda335f6a9b8d095$var$PERCENTAGE, $fda335f6a9b8d095$var$NUMBER));
var $fda335f6a9b8d095$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $fda335f6a9b8d095$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $fda335f6a9b8d095$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $fda335f6a9b8d095$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $fda335f6a9b8d095$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $fda335f6a9b8d095$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($fda335f6a9b8d095$var$colors && $fda335f6a9b8d095$var$colors[color] !== void 0) return $fda335f6a9b8d095$var$colors[color];
    if (match = $fda335f6a9b8d095$export$8972dc0e6ad9238f.exec(color)) return ($fda335f6a9b8d095$var$parse255(match[1]) << 24 | // r
    $fda335f6a9b8d095$var$parse255(match[2]) << 16 | // g
    $fda335f6a9b8d095$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $fda335f6a9b8d095$export$4e46ac54fc82cf3b.exec(color)) return ($fda335f6a9b8d095$var$parse255(match[1]) << 24 | // r
    $fda335f6a9b8d095$var$parse255(match[2]) << 16 | // g
    $fda335f6a9b8d095$var$parse255(match[3]) << 8 | // b
    $fda335f6a9b8d095$var$parse1(match[4])) >>> // a
    0;
    if (match = $fda335f6a9b8d095$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $fda335f6a9b8d095$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $fda335f6a9b8d095$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $fda335f6a9b8d095$export$8f4a7c0bb78e6ea8.exec(color)) return ($fda335f6a9b8d095$var$hslToRgb($fda335f6a9b8d095$var$parse360(match[1]), // h
    $fda335f6a9b8d095$var$parsePercentage(match[2]), // s
    $fda335f6a9b8d095$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $fda335f6a9b8d095$export$810b04175080204c.exec(color)) return ($fda335f6a9b8d095$var$hslToRgb($fda335f6a9b8d095$var$parse360(match[1]), // h
    $fda335f6a9b8d095$var$parsePercentage(match[2]), // s
    $fda335f6a9b8d095$var$parsePercentage(match[3])) | $fda335f6a9b8d095$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $fda335f6a9b8d095$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fda335f6a9b8d095$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $fda335f6a9b8d095$var$hue2rgb(p, q, h + 1 / 3);
    const g = $fda335f6a9b8d095$var$hue2rgb(p, q, h);
    const b = $fda335f6a9b8d095$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $fda335f6a9b8d095$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $fda335f6a9b8d095$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $fda335f6a9b8d095$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $fda335f6a9b8d095$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $fda335f6a9b8d095$export$61db176b839af1f(input) {
    let int32Color = $fda335f6a9b8d095$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $fda335f6a9b8d095$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($fda335f6a9b8d095$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($fda335f6a9b8d095$export$226b3eccf92c9ed9.arr(range)) return $fda335f6a9b8d095$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($fda335f6a9b8d095$export$226b3eccf92c9ed9.str(range.output[0])) return $fda335f6a9b8d095$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $fda335f6a9b8d095$var$findRange(input, inputRange);
        return $fda335f6a9b8d095$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $fda335f6a9b8d095$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $fda335f6a9b8d095$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $fda335f6a9b8d095$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $fda335f6a9b8d095$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $fda335f6a9b8d095$var$c1 = 1.70158;
var $fda335f6a9b8d095$var$c2 = $fda335f6a9b8d095$var$c1 * 1.525;
var $fda335f6a9b8d095$var$c3 = $fda335f6a9b8d095$var$c1 + 1;
var $fda335f6a9b8d095$var$c4 = 2 * Math.PI / 3;
var $fda335f6a9b8d095$var$c5 = 2 * Math.PI / 4.5;
var $fda335f6a9b8d095$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $fda335f6a9b8d095$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$fda335f6a9b8d095$var$c3 * x * x * x - $fda335f6a9b8d095$var$c1 * x * x,
    easeOutBack: (x)=>1 + $fda335f6a9b8d095$var$c3 * Math.pow(x - 1, 3) + $fda335f6a9b8d095$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($fda335f6a9b8d095$var$c2 + 1) * 2 * x - $fda335f6a9b8d095$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($fda335f6a9b8d095$var$c2 + 1) * (x * 2 - 2) + $fda335f6a9b8d095$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $fda335f6a9b8d095$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $fda335f6a9b8d095$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $fda335f6a9b8d095$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $fda335f6a9b8d095$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $fda335f6a9b8d095$var$bounceOut(1 - x),
    easeOutBounce: $fda335f6a9b8d095$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $fda335f6a9b8d095$var$bounceOut(1 - 2 * x)) / 2 : (1 + $fda335f6a9b8d095$var$bounceOut(2 * x - 1)) / 2,
    steps: $fda335f6a9b8d095$var$steps
};
// src/fluids.ts
var $fda335f6a9b8d095$var$$get = Symbol.for("FluidValue.get");
var $fda335f6a9b8d095$var$$observers = Symbol.for("FluidValue.observers");
var $fda335f6a9b8d095$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$fda335f6a9b8d095$var$$get]);
var $fda335f6a9b8d095$export$e37b7520edd66839 = (arg)=>arg && arg[$fda335f6a9b8d095$var$$get] ? arg[$fda335f6a9b8d095$var$$get]() : arg;
var $fda335f6a9b8d095$export$133f54e9f7cf1796 = (target)=>target[$fda335f6a9b8d095$var$$observers] || null;
function $fda335f6a9b8d095$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $fda335f6a9b8d095$export$31752c40a5fab62a(target, event) {
    const observers = target[$fda335f6a9b8d095$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $fda335f6a9b8d095$export$8cbca1207adce0c0(observer2, event);
    });
}
var $fda335f6a9b8d095$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $fda335f6a9b8d095$export$a3b4618659637aa3(this, get);
    }
};
$fda335f6a9b8d095$var$$get, $fda335f6a9b8d095$var$$observers;
var $fda335f6a9b8d095$export$a3b4618659637aa3 = (target, get)=>$fda335f6a9b8d095$var$setHidden(target, $fda335f6a9b8d095$var$$get, get);
function $fda335f6a9b8d095$export$72d604e3f8d000a5(target, observer2) {
    if (target[$fda335f6a9b8d095$var$$get]) {
        let observers = target[$fda335f6a9b8d095$var$$observers];
        if (!observers) $fda335f6a9b8d095$var$setHidden(target, $fda335f6a9b8d095$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $fda335f6a9b8d095$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$fda335f6a9b8d095$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$fda335f6a9b8d095$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $fda335f6a9b8d095$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $fda335f6a9b8d095$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $fda335f6a9b8d095$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $fda335f6a9b8d095$var$unitRegex = new RegExp(`(${$fda335f6a9b8d095$var$numberRegex.source})(%|[a-z]+)`, "i");
var $fda335f6a9b8d095$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $fda335f6a9b8d095$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $fda335f6a9b8d095$var$variableToRgba = (input)=>{
    const [token, fallback] = $fda335f6a9b8d095$var$parseCSSVariable(input);
    if (!token || $fda335f6a9b8d095$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $fda335f6a9b8d095$var$cssVariableRegex.test(fallback)) return $fda335f6a9b8d095$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $fda335f6a9b8d095$var$parseCSSVariable = (current)=>{
    const match = $fda335f6a9b8d095$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $fda335f6a9b8d095$var$namedColorRegex;
var $fda335f6a9b8d095$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $fda335f6a9b8d095$export$4759a013d387347a = (config)=>{
    if (!$fda335f6a9b8d095$var$namedColorRegex) $fda335f6a9b8d095$var$namedColorRegex = $fda335f6a9b8d095$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($fda335f6a9b8d095$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $fda335f6a9b8d095$export$e37b7520edd66839(value).replace($fda335f6a9b8d095$var$cssVariableRegex, $fda335f6a9b8d095$var$variableToRgba).replace($fda335f6a9b8d095$var$colorRegex, $fda335f6a9b8d095$export$61db176b839af1f).replace($fda335f6a9b8d095$var$namedColorRegex, $fda335f6a9b8d095$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($fda335f6a9b8d095$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$fda335f6a9b8d095$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$fda335f6a9b8d095$var$unitRegex.test(output[0]) && output.find((value)=>$fda335f6a9b8d095$var$unitRegex.test(value))?.replace($fda335f6a9b8d095$var$numberRegex, "");
        let i = 0;
        return output[0].replace($fda335f6a9b8d095$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($fda335f6a9b8d095$var$rgbaRegex, $fda335f6a9b8d095$var$rgbaRound);
    };
};
// src/deprecations.ts
var $fda335f6a9b8d095$export$82e9f45cca5ba907 = "react-spring: ";
var $fda335f6a9b8d095$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$fda335f6a9b8d095$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $fda335f6a9b8d095$var$warnInterpolate = $fda335f6a9b8d095$export$d2de3aaeafa91619(console.warn);
function $fda335f6a9b8d095$export$2abfcde8ae218ba8() {
    $fda335f6a9b8d095$var$warnInterpolate(`${$fda335f6a9b8d095$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $fda335f6a9b8d095$var$warnDirectCall = $fda335f6a9b8d095$export$d2de3aaeafa91619(console.warn);
function $fda335f6a9b8d095$export$d99d974913ad3b12() {
    $fda335f6a9b8d095$var$warnDirectCall(`${$fda335f6a9b8d095$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $fda335f6a9b8d095$export$75bed621f62abfa9(value) {
    return $fda335f6a9b8d095$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$fda335f6a9b8d095$export$48d7c418edadb60c() && $fda335f6a9b8d095$var$cssVariableRegex.test(value) || value in ($fda335f6a9b8d095$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $fda335f6a9b8d095$var$observer;
var $fda335f6a9b8d095$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $fda335f6a9b8d095$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $fda335f6a9b8d095$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $fda335f6a9b8d095$var$resizeElement(handler, target) {
    if (!$fda335f6a9b8d095$var$observer) {
        if (typeof ResizeObserver !== "undefined") $fda335f6a9b8d095$var$observer = new ResizeObserver($fda335f6a9b8d095$var$handleObservation);
    }
    let elementHandlers = $fda335f6a9b8d095$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $fda335f6a9b8d095$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($fda335f6a9b8d095$var$observer) $fda335f6a9b8d095$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $fda335f6a9b8d095$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $fda335f6a9b8d095$var$observer) $fda335f6a9b8d095$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $fda335f6a9b8d095$var$listeners = /* @__PURE__ */ new Set();
var $fda335f6a9b8d095$var$cleanupWindowResizeHandler;
var $fda335f6a9b8d095$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $fda335f6a9b8d095$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $fda335f6a9b8d095$var$resizeWindow = (callback)=>{
    $fda335f6a9b8d095$var$listeners.add(callback);
    if (!$fda335f6a9b8d095$var$cleanupWindowResizeHandler) $fda335f6a9b8d095$var$cleanupWindowResizeHandler = $fda335f6a9b8d095$var$createResizeHandler();
    return ()=>{
        $fda335f6a9b8d095$var$listeners.delete(callback);
        if (!$fda335f6a9b8d095$var$listeners.size && $fda335f6a9b8d095$var$cleanupWindowResizeHandler) {
            $fda335f6a9b8d095$var$cleanupWindowResizeHandler();
            $fda335f6a9b8d095$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $fda335f6a9b8d095$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $fda335f6a9b8d095$var$resizeWindow(callback);
    else return $fda335f6a9b8d095$var$resizeElement(callback, container);
};
// src/progress.ts
var $fda335f6a9b8d095$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $fda335f6a9b8d095$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $fda335f6a9b8d095$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $fda335f6a9b8d095$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $fda335f6a9b8d095$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $fda335f6a9b8d095$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $fda335f6a9b8d095$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $fda335f6a9b8d095$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $fda335f6a9b8d095$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $fda335f6a9b8d095$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $fda335f6a9b8d095$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $fda335f6a9b8d095$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $fda335f6a9b8d095$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$fda335f6a9b8d095$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $fda335f6a9b8d095$var$scrollListeners.set(container, listener);
        const target = $fda335f6a9b8d095$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $fda335f6a9b8d095$var$resizeListeners.set(container, $fda335f6a9b8d095$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $fda335f6a9b8d095$var$scrollListeners.get(container);
    (0, $d67fa8c2937648db$export$27f233d61a9e2fa4)(animateScroll);
    return ()=>{
        (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).cancel(animateScroll);
        const containerHandlers2 = $fda335f6a9b8d095$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $fda335f6a9b8d095$var$scrollListeners.get(container);
        $fda335f6a9b8d095$var$scrollListeners.delete(container);
        if (listener) {
            $fda335f6a9b8d095$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $fda335f6a9b8d095$var$resizeListeners.get(container)?.();
        }
    };
};
function $fda335f6a9b8d095$export$fe4300aa8eebea86(init) {
    const ref = (0, $8nGP5.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $fda335f6a9b8d095$export$700979bc83e7db82 = $fda335f6a9b8d095$export$48d7c418edadb60c() ? (0, $8nGP5.useEffect) : (0, $8nGP5.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $fda335f6a9b8d095$var$useIsMounted = ()=>{
    const isMounted = (0, $8nGP5.useRef)(false);
    $fda335f6a9b8d095$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $fda335f6a9b8d095$export$91db9bc4f8ac944a() {
    const update = (0, $8nGP5.useState)()[1];
    const isMounted = $fda335f6a9b8d095$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $fda335f6a9b8d095$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $8nGP5.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $8nGP5.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $fda335f6a9b8d095$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $8nGP5.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $fda335f6a9b8d095$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $fda335f6a9b8d095$export$392544347a18b6ea = (effect)=>(0, $8nGP5.useEffect)(effect, $fda335f6a9b8d095$var$emptyDeps);
var $fda335f6a9b8d095$var$emptyDeps = [];
function $fda335f6a9b8d095$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $8nGP5.useRef)();
    (0, $8nGP5.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $fda335f6a9b8d095$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $8nGP5.useState)(null);
    $fda335f6a9b8d095$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $fda335f6a9b8d095$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $8nGP5 = parcelRequire("8nGP5");
// src/Animated.ts


var $8nGP5 = parcelRequire("8nGP5");
var $b08e4134053d0fe9$var$$node = Symbol.for("Animated:node");
var $b08e4134053d0fe9$export$3df5e165e801a70f = (value)=>!!value && value[$b08e4134053d0fe9$var$$node] === value;
var $b08e4134053d0fe9$export$6b63995194a3a9e4 = (owner)=>owner && owner[$b08e4134053d0fe9$var$$node];
var $b08e4134053d0fe9$export$b553cb5b22b81b04 = (owner, node)=>(0, $fda335f6a9b8d095$export$5c74248ea0e35446)(owner, $b08e4134053d0fe9$var$$node, node);
var $b08e4134053d0fe9$export$ccab2b64c5d440 = (owner)=>owner && owner[$b08e4134053d0fe9$var$$node] && owner[$b08e4134053d0fe9$var$$node].getPayload();
var $b08e4134053d0fe9$export$31627395a3b18e54 = class {
    constructor(){
        $b08e4134053d0fe9$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $b08e4134053d0fe9$export$cb1e8f3c05d37ad5 = class extends $b08e4134053d0fe9$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $b08e4134053d0fe9$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93 = class extends $b08e4134053d0fe9$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $fda335f6a9b8d095$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $fda335f6a9b8d095$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $b08e4134053d0fe9$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $b08e4134053d0fe9$export$f1b0b9e366a6e2d4 = class extends $b08e4134053d0fe9$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($b08e4134053d0fe9$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($b08e4134053d0fe9$var$TreeContext.dependencies && (0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(source)) $b08e4134053d0fe9$var$TreeContext.dependencies.add(source);
        const payload = $b08e4134053d0fe9$export$ccab2b64c5d440(source);
        if (payload) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $b08e4134053d0fe9$export$ede394683406942d = class extends $b08e4134053d0fe9$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $b08e4134053d0fe9$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($b08e4134053d0fe9$var$makeAnimated));
        return true;
    }
};
function $b08e4134053d0fe9$var$makeAnimated(value) {
    const nodeType = (0, $fda335f6a9b8d095$export$75bed621f62abfa9)(value) ? $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93 : $b08e4134053d0fe9$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $b08e4134053d0fe9$export$e6b77ddbe47b132e(value) {
    const parentNode = $b08e4134053d0fe9$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(value) ? $b08e4134053d0fe9$export$ede394683406942d : (0, $fda335f6a9b8d095$export$75bed621f62abfa9)(value) ? $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93 : $b08e4134053d0fe9$export$cb1e8f3c05d37ad5;
}
var $b08e4134053d0fe9$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $8nGP5.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $8nGP5.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $8nGP5.useCallback)((value)=>{
            instanceRef.current = $b08e4134053d0fe9$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $b08e4134053d0fe9$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $fda335f6a9b8d095$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $b08e4134053d0fe9$var$PropsObserver(callback, deps);
        const observerRef = (0, $8nGP5.useRef)();
        (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(deps, (dep)=>(0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $fda335f6a9b8d095$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $8nGP5.useEffect)(callback, []);
        (0, $fda335f6a9b8d095$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $fda335f6a9b8d095$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $8nGP5.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $b08e4134053d0fe9$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $b08e4134053d0fe9$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $b08e4134053d0fe9$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $b08e4134053d0fe9$export$f1b0b9e366a6e2d4(props);
    $b08e4134053d0fe9$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $b08e4134053d0fe9$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $b08e4134053d0fe9$var$cacheKey = Symbol.for("AnimatedComponent");
var $b08e4134053d0fe9$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $b08e4134053d0fe9$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $b08e4134053d0fe9$var$getDisplayName(Component) || "Anonymous";
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $b08e4134053d0fe9$var$withAnimated(Component, hostConfig));
        else Component = Component[$b08e4134053d0fe9$var$cacheKey] || (Component[$b08e4134053d0fe9$var$cacheKey] = $b08e4134053d0fe9$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(components)) key = $b08e4134053d0fe9$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $b08e4134053d0fe9$var$getDisplayName = (arg)=>(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $5498e6d7807daeb5$export$b24b633b1364b94b = class {
};


function $21cbb88cff39ec52$var$callProp(value, ...args) {
    return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $21cbb88cff39ec52$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $fda335f6a9b8d095$export$45b10814cc054894)(value).includes(key)));
var $21cbb88cff39ec52$var$resolveProp = (prop, key)=>(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $21cbb88cff39ec52$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $21cbb88cff39ec52$var$noopTransform = (value)=>value;
var $21cbb88cff39ec52$var$getDefaultProps = (props, transform = $21cbb88cff39ec52$var$noopTransform)=>{
    let keys = $21cbb88cff39ec52$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $21cbb88cff39ec52$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $21cbb88cff39ec52$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $21cbb88cff39ec52$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$21cbb88cff39ec52$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $21cbb88cff39ec52$export$b971039a739bf227(props) {
    const to2 = $21cbb88cff39ec52$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $21cbb88cff39ec52$var$computeGoal(value) {
    value = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(value);
    return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(value) ? value.map($21cbb88cff39ec52$var$computeGoal) : (0, $fda335f6a9b8d095$export$75bed621f62abfa9)(value) ? (0, $fda335f6a9b8d095$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $21cbb88cff39ec52$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $21cbb88cff39ec52$var$isAsyncTo(to2) {
    return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(to2) || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(to2) && (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $21cbb88cff39ec52$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $21cbb88cff39ec52$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $21cbb88cff39ec52$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $21cbb88cff39ec52$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $fda335f6a9b8d095$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $21cbb88cff39ec52$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $21cbb88cff39ec52$var$defaults = {
    ...$21cbb88cff39ec52$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $fda335f6a9b8d095$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $21cbb88cff39ec52$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $21cbb88cff39ec52$var$defaults);
    }
};
function $21cbb88cff39ec52$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $21cbb88cff39ec52$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $21cbb88cff39ec52$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $21cbb88cff39ec52$var$defaults)if (config2[key] == null) config2[key] = $21cbb88cff39ec52$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $21cbb88cff39ec52$var$sanitizeConfig(config2, props) {
    if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.tension) || !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.damping) || !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $21cbb88cff39ec52$var$emptyArray = [];
var $21cbb88cff39ec52$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $21cbb88cff39ec52$var$emptyArray;
        this.toValues = null;
        this.fromValues = $21cbb88cff39ec52$var$emptyArray;
        this.config = new $21cbb88cff39ec52$var$AnimationConfig();
        this.immediate = false;
    }
};
function $21cbb88cff39ec52$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $21cbb88cff39ec52$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $21cbb88cff39ec52$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $21cbb88cff39ec52$var$matchProp(pause, key);
            delay = $21cbb88cff39ec52$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $fda335f6a9b8d095$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $21cbb88cff39ec52$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $21cbb88cff39ec52$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $21cbb88cff39ec52$var$getNoopResult(target.get()) : $21cbb88cff39ec52$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $21cbb88cff39ec52$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $21cbb88cff39ec52$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $21cbb88cff39ec52$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $21cbb88cff39ec52$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $21cbb88cff39ec52$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $21cbb88cff39ec52$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $21cbb88cff39ec52$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $21cbb88cff39ec52$export$d362d093fa99dc7();
            const skipAnimationSignal = new $21cbb88cff39ec52$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $fda335f6a9b8d095$export$cceeabf822b64fc0).skipAnimation) {
                    $21cbb88cff39ec52$var$stopAsync(state);
                    skipAnimationSignal.result = $21cbb88cff39ec52$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $fda335f6a9b8d095$export$cceeabf822b64fc0).skipAnimation) {
            $21cbb88cff39ec52$var$stopAsync(state);
            return $21cbb88cff39ec52$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $21cbb88cff39ec52$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $21cbb88cff39ec52$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $21cbb88cff39ec52$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(onRest)) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $21cbb88cff39ec52$var$stopAsync(state, cancelId) {
    (0, $fda335f6a9b8d095$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $21cbb88cff39ec52$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $21cbb88cff39ec52$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $21cbb88cff39ec52$var$isFrameValue = (value)=>value instanceof $21cbb88cff39ec52$export$8229896f80e2495e;
var $21cbb88cff39ec52$var$nextId = 1;
var $21cbb88cff39ec52$export$8229896f80e2495e = class extends (0, $fda335f6a9b8d095$export$aff8e1ac1a016a2) {
    constructor(){
        super(...arguments);
        this.id = $21cbb88cff39ec52$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $fda335f6a9b8d095$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $fda335f6a9b8d095$export$2abfcde8ae218ba8)();
        return (0, $fda335f6a9b8d095$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $fda335f6a9b8d095$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $fda335f6a9b8d095$export$a57f5080a3bcc90a).sort(this);
        (0, $fda335f6a9b8d095$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $21cbb88cff39ec52$var$$P = Symbol.for("SpringPhase");
var $21cbb88cff39ec52$var$HAS_ANIMATED = 1;
var $21cbb88cff39ec52$var$IS_ANIMATING = 2;
var $21cbb88cff39ec52$var$IS_PAUSED = 4;
var $21cbb88cff39ec52$var$hasAnimated = (target)=>(target[$21cbb88cff39ec52$var$$P] & $21cbb88cff39ec52$var$HAS_ANIMATED) > 0;
var $21cbb88cff39ec52$var$isAnimating = (target)=>(target[$21cbb88cff39ec52$var$$P] & $21cbb88cff39ec52$var$IS_ANIMATING) > 0;
var $21cbb88cff39ec52$var$isPaused = (target)=>(target[$21cbb88cff39ec52$var$$P] & $21cbb88cff39ec52$var$IS_PAUSED) > 0;
var $21cbb88cff39ec52$var$setActiveBit = (target, active)=>active ? target[$21cbb88cff39ec52$var$$P] |= $21cbb88cff39ec52$var$IS_ANIMATING | $21cbb88cff39ec52$var$HAS_ANIMATED : target[$21cbb88cff39ec52$var$$P] &= ~$21cbb88cff39ec52$var$IS_ANIMATING;
var $21cbb88cff39ec52$var$setPausedBit = (target, paused)=>paused ? target[$21cbb88cff39ec52$var$$P] |= $21cbb88cff39ec52$var$IS_PAUSED : target[$21cbb88cff39ec52$var$$P] &= ~$21cbb88cff39ec52$var$IS_PAUSED;
// src/SpringValue.ts
var $21cbb88cff39ec52$export$5854d13427d5a954 = class extends $21cbb88cff39ec52$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $21cbb88cff39ec52$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(arg1) || !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($21cbb88cff39ec52$var$isAnimating(this) || this._state.asyncTo) || $21cbb88cff39ec52$var$isPaused(this);
    }
    get goal() {
        return (0, $fda335f6a9b8d095$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $b08e4134053d0fe9$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $21cbb88cff39ec52$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $21cbb88cff39ec52$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $21cbb88cff39ec52$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $b08e4134053d0fe9$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $fda335f6a9b8d095$export$45b10814cc054894)((0, $fda335f6a9b8d095$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($21cbb88cff39ec52$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$21cbb88cff39ec52$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $21cbb88cff39ec52$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $21cbb88cff39ec52$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$21cbb88cff39ec52$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(from);
            if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $21cbb88cff39ec52$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $21cbb88cff39ec52$var$resolveProp(value, key) : value));
        $21cbb88cff39ec52$var$mergeActiveFn(this, props, "onProps");
        $21cbb88cff39ec52$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $21cbb88cff39ec52$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$21cbb88cff39ec52$var$isPaused(this)) {
                        $21cbb88cff39ec52$var$setPausedBit(this, true);
                        (0, $fda335f6a9b8d095$export$7ba486852759e806)(state.pauseQueue);
                        $21cbb88cff39ec52$var$sendEvent(this, "onPause", $21cbb88cff39ec52$var$getFinishedResult(this, $21cbb88cff39ec52$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($21cbb88cff39ec52$var$isPaused(this)) {
                        $21cbb88cff39ec52$var$setPausedBit(this, false);
                        if ($21cbb88cff39ec52$var$isAnimating(this)) this._resume();
                        (0, $fda335f6a9b8d095$export$7ba486852759e806)(state.resumeQueue);
                        $21cbb88cff39ec52$var$sendEvent(this, "onResume", $21cbb88cff39ec52$var$getFinishedResult(this, $21cbb88cff39ec52$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $21cbb88cff39ec52$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($21cbb88cff39ec52$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($21cbb88cff39ec52$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $fda335f6a9b8d095$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $fda335f6a9b8d095$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $21cbb88cff39ec52$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $21cbb88cff39ec52$var$mergeConfig(config2, $21cbb88cff39ec52$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $21cbb88cff39ec52$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
        if (!node || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(to2)) return resolve($21cbb88cff39ec52$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(from) && $21cbb88cff39ec52$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $21cbb88cff39ec52$var$computeGoal(to2);
        const isAnimatable = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(goal) || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(goal) || (0, $fda335f6a9b8d095$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $21cbb88cff39ec52$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $b08e4134053d0fe9$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$21cbb88cff39ec52$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $fda335f6a9b8d095$export$248d38f6296296c5)($21cbb88cff39ec52$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $fda335f6a9b8d095$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $fda335f6a9b8d095$export$248d38f6296296c5)(config2.decay, decay) || !(0, $fda335f6a9b8d095$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $21cbb88cff39ec52$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $fda335f6a9b8d095$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $fda335f6a9b8d095$export$79b2f7037acddd43)($21cbb88cff39ec52$var$ACTIVE_EVENTS, (type)=>$21cbb88cff39ec52$var$mergeActiveFn(this, props, type));
                const result = $21cbb88cff39ec52$var$getFinishedResult(this, $21cbb88cff39ec52$var$checkFinished(this, prevTo));
                (0, $fda335f6a9b8d095$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $21cbb88cff39ec52$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($21cbb88cff39ec52$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($21cbb88cff39ec52$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($21cbb88cff39ec52$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $fda335f6a9b8d095$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $fda335f6a9b8d095$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(to2)) {
            (0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(to2, this);
            if ($21cbb88cff39ec52$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(to2)) (0, $fda335f6a9b8d095$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(arg);
        if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $fda335f6a9b8d095$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $b08e4134053d0fe9$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $b08e4134053d0fe9$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $21cbb88cff39ec52$var$sendEvent(this, "onStart", $21cbb88cff39ec52$var$getFinishedResult(this, $21cbb88cff39ec52$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $21cbb88cff39ec52$var$callProp(this.animation.onChange, value, this);
        }
        $21cbb88cff39ec52$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this).reset((0, $fda335f6a9b8d095$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$21cbb88cff39ec52$var$isAnimating(this)) {
            $21cbb88cff39ec52$var$setActiveBit(this, true);
            if (!$21cbb88cff39ec52$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $fda335f6a9b8d095$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $fda335f6a9b8d095$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($21cbb88cff39ec52$var$isAnimating(this)) {
            $21cbb88cff39ec52$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $fda335f6a9b8d095$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $21cbb88cff39ec52$var$getCancelledResult(this.get()) : $21cbb88cff39ec52$var$getFinishedResult(this.get(), $21cbb88cff39ec52$var$checkFinished(this, goal ?? anim.to));
            (0, $fda335f6a9b8d095$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $21cbb88cff39ec52$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $21cbb88cff39ec52$var$checkFinished(target, to2) {
    const goal = $21cbb88cff39ec52$var$computeGoal(to2);
    const value = $21cbb88cff39ec52$var$computeGoal(target.get());
    return (0, $fda335f6a9b8d095$export$248d38f6296296c5)(value, goal);
}
function $21cbb88cff39ec52$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $21cbb88cff39ec52$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $21cbb88cff39ec52$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $21cbb88cff39ec52$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $21cbb88cff39ec52$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $21cbb88cff39ec52$var$createUpdate(props) {
    const { to: to2, from: from } = props = $21cbb88cff39ec52$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(to2)) $21cbb88cff39ec52$var$findDefined(to2, keys);
    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(from)) $21cbb88cff39ec52$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $21cbb88cff39ec52$var$declareUpdate(props) {
    const update2 = $21cbb88cff39ec52$var$createUpdate(props);
    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $21cbb88cff39ec52$var$getDefaultProps(update2);
    return update2;
}
function $21cbb88cff39ec52$var$findDefined(values, keys) {
    (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $21cbb88cff39ec52$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $21cbb88cff39ec52$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $21cbb88cff39ec52$var$getDefaultProp(props, type) ? $21cbb88cff39ec52$var$resolveProp(props[type], target.key) : void 0;
}
function $21cbb88cff39ec52$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $21cbb88cff39ec52$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $21cbb88cff39ec52$var$nextId2 = 1;
var $21cbb88cff39ec52$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $21cbb88cff39ec52$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($21cbb88cff39ec52$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $fda335f6a9b8d095$export$45b10814cc054894)(props).map($21cbb88cff39ec52$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $21cbb88cff39ec52$var$prepareKeys(this, queue);
        return $21cbb88cff39ec52$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $21cbb88cff39ec52$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $fda335f6a9b8d095$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $fda335f6a9b8d095$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $fda335f6a9b8d095$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
function $21cbb88cff39ec52$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$21cbb88cff39ec52$var$flushUpdate(ctrl, props))).then((results)=>$21cbb88cff39ec52$var$getCombinedResult(ctrl, results));
}
async function $21cbb88cff39ec52$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(to2) || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $fda335f6a9b8d095$export$79b2f7037acddd43)($21cbb88cff39ec52$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $fda335f6a9b8d095$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $21cbb88cff39ec52$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($21cbb88cff39ec52$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $fda335f6a9b8d095$export$8793edee2d425525),
            resume: (0, $fda335f6a9b8d095$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $21cbb88cff39ec52$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($21cbb88cff39ec52$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($21cbb88cff39ec52$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $21cbb88cff39ec52$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $21cbb88cff39ec52$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $21cbb88cff39ec52$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $21cbb88cff39ec52$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $21cbb88cff39ec52$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $21cbb88cff39ec52$var$createUpdate(props2);
        if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $21cbb88cff39ec52$var$prepareSprings(springs, props2, (key)=>{
            return $21cbb88cff39ec52$var$createSpring(key);
        });
    });
    $21cbb88cff39ec52$var$setSprings(ctrl, springs);
    return springs;
}
function $21cbb88cff39ec52$var$setSprings(ctrl, springs) {
    (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $21cbb88cff39ec52$var$createSpring(key, observer) {
    const spring = new $21cbb88cff39ec52$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $21cbb88cff39ec52$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $21cbb88cff39ec52$var$prepareKeys(ctrl, queue) {
    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(queue, (props)=>{
        $21cbb88cff39ec52$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $21cbb88cff39ec52$var$createSpring(key, ctrl);
        });
    });
}
var $21cbb88cff39ec52$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $8nGP5.useContext)($21cbb88cff39ec52$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $fda335f6a9b8d095$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $21cbb88cff39ec52$var$ctx;
    return /* @__PURE__ */ $8nGP5.createElement(Provider, {
        value: props
    }, children);
};
var $21cbb88cff39ec52$var$ctx = $21cbb88cff39ec52$var$makeContext($21cbb88cff39ec52$export$f12a216ec50d2cf1, {});
$21cbb88cff39ec52$export$f12a216ec50d2cf1.Provider = $21cbb88cff39ec52$var$ctx.Provider;
$21cbb88cff39ec52$export$f12a216ec50d2cf1.Consumer = $21cbb88cff39ec52$var$ctx.Consumer;
function $21cbb88cff39ec52$var$makeContext(target, init) {
    Object.assign(target, $8nGP5.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $21cbb88cff39ec52$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $fda335f6a9b8d095$export$d99d974913ad3b12)();
        const results = [];
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $21cbb88cff39ec52$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $8nGP5.useMemo)(()=>propsFn || arguments.length == 3 ? $21cbb88cff39ec52$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $8nGP5.useRef)(0);
    const forceUpdate = (0, $fda335f6a9b8d095$export$91db9bc4f8ac944a)();
    const state = (0, $8nGP5.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $21cbb88cff39ec52$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $21cbb88cff39ec52$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $21cbb88cff39ec52$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($21cbb88cff39ec52$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $8nGP5.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $fda335f6a9b8d095$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $8nGP5.useMemo)(()=>{
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $21cbb88cff39ec52$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $8nGP5.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $21cbb88cff39ec52$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $21cbb88cff39ec52$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$21cbb88cff39ec52$var$getSprings(ctrl, updates[i]));
    const context = (0, $8nGP5.useContext)($21cbb88cff39ec52$export$f12a216ec50d2cf1);
    const prevContext = (0, $fda335f6a9b8d095$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $21cbb88cff39ec52$var$hasProps(context);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $21cbb88cff39ec52$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $fda335f6a9b8d095$export$392544347a18b6ea)(()=>()=>{
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $21cbb88cff39ec52$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $21cbb88cff39ec52$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $21cbb88cff39ec52$var$initSpringRef = ()=>$21cbb88cff39ec52$export$2471ae76e2946684();
var $21cbb88cff39ec52$export$564bff9c23cad2ca = ()=>(0, $8nGP5.useState)($21cbb88cff39ec52$var$initSpringRef)[0];
var $21cbb88cff39ec52$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $fda335f6a9b8d095$export$fe4300aa8eebea86)(()=>new $21cbb88cff39ec52$export$5854d13427d5a954(initial, props));
    (0, $fda335f6a9b8d095$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $21cbb88cff39ec52$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $21cbb88cff39ec52$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $21cbb88cff39ec52$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $21cbb88cff39ec52$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $8nGP5.useMemo)(()=>propsFn || arguments.length == 3 ? $21cbb88cff39ec52$export$2471ae76e2946684() : void 0, []);
    const items = (0, $fda335f6a9b8d095$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $8nGP5.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $fda335f6a9b8d095$export$392544347a18b6ea)(()=>{
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $21cbb88cff39ec52$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $21cbb88cff39ec52$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>(0, $fda335f6a9b8d095$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $21cbb88cff39ec52$var$detachRefs(ctrl, ref);
            $21cbb88cff39ec52$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $21cbb88cff39ec52$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $fda335f6a9b8d095$export$91db9bc4f8ac944a)();
    const defaultProps = $21cbb88cff39ec52$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $8nGP5.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $8nGP5.useRef)(false);
    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $21cbb88cff39ec52$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $21cbb88cff39ec52$var$callProp(to2, t.item, i);
        to2 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(to2) ? $21cbb88cff39ec52$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $21cbb88cff39ec52$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $21cbb88cff39ec52$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $21cbb88cff39ec52$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $21cbb88cff39ec52$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $21cbb88cff39ec52$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $8nGP5.useContext)($21cbb88cff39ec52$export$f12a216ec50d2cf1);
    const prevContext = (0, $fda335f6a9b8d095$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $21cbb88cff39ec52$var$hasProps(context);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $21cbb88cff39ec52$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $8nGP5.createElement($8nGP5.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $8nGP5.createElement(elem.type, {
                ...elem.props,
                key: (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).str(t.key) || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $21cbb88cff39ec52$var$nextKey = 1;
function $21cbb88cff39ec52$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $21cbb88cff39ec52$var$nextKey++;
        });
    }
    return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(keys) ? items : (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $fda335f6a9b8d095$export$45b10814cc054894)(keys);
}
var $21cbb88cff39ec52$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $21cbb88cff39ec52$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $fda335f6a9b8d095$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $21cbb88cff39ec52$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $21cbb88cff39ec52$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $fda335f6a9b8d095$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $21cbb88cff39ec52$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $21cbb88cff39ec52$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $8nGP5.useState)(false);
    const ref = (0, $8nGP5.useRef)();
    const propsFn = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $21cbb88cff39ec52$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $21cbb88cff39ec52$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $21cbb88cff39ec52$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($21cbb88cff39ec52$export$c4af9125706c4d30(props));
}
function $21cbb88cff39ec52$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $21cbb88cff39ec52$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $21cbb88cff39ec52$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $21cbb88cff39ec52$export$7b286972b8d8ccbf(items, props)(children);
}
var $21cbb88cff39ec52$export$b0cc4f9860136880 = class extends $21cbb88cff39ec52$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $fda335f6a9b8d095$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $b08e4134053d0fe9$export$e6b77ddbe47b132e)(value);
        (0, $b08e4134053d0fe9$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $fda335f6a9b8d095$export$248d38f6296296c5)(value, oldValue)) {
            (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $21cbb88cff39ec52$var$checkIdle(this._active)) $21cbb88cff39ec52$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $fda335f6a9b8d095$export$e37b7520edd66839)) : (0, $fda335f6a9b8d095$export$45b10814cc054894)((0, $fda335f6a9b8d095$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$21cbb88cff39ec52$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $b08e4134053d0fe9$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $fda335f6a9b8d095$export$cceeabf822b64fc0).skipAnimation) {
                (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $21cbb88cff39ec52$var$becomeIdle(this);
            } else (0, $fda335f6a9b8d095$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(source)) (0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(source, this);
            if ($21cbb88cff39ec52$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(source)) (0, $fda335f6a9b8d095$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $21cbb88cff39ec52$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $fda335f6a9b8d095$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($21cbb88cff39ec52$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $21cbb88cff39ec52$var$isIdle(source) {
    return source.idle !== false;
}
function $21cbb88cff39ec52$var$checkIdle(active) {
    return !active.size || Array.from(active).every($21cbb88cff39ec52$var$isIdle);
}
function $21cbb88cff39ec52$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $b08e4134053d0fe9$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $fda335f6a9b8d095$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $21cbb88cff39ec52$export$2c618a4308a30424 = (source, ...args)=>new $21cbb88cff39ec52$export$b0cc4f9860136880(source, args);
var $21cbb88cff39ec52$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $fda335f6a9b8d095$export$2abfcde8ae218ba8)(), new $21cbb88cff39ec52$export$b0cc4f9860136880(source, args));
(0, $fda335f6a9b8d095$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $fda335f6a9b8d095$export$4759a013d387347a,
    to: (source, args)=>new $21cbb88cff39ec52$export$b0cc4f9860136880(source, args)
});
var $21cbb88cff39ec52$export$722fbec263ad908a = (0, $fda335f6a9b8d095$export$a57f5080a3bcc90a).advance;



var $fCKK7 = parcelRequire("fCKK7");


// src/applyAnimatedValues.ts
var $6084490f368b0396$var$isCustomPropRE = /^--/;
function $6084490f368b0396$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$6084490f368b0396$var$isCustomPropRE.test(name) && !($6084490f368b0396$var$isUnitlessNumber.hasOwnProperty(name) && $6084490f368b0396$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $6084490f368b0396$var$attributeCache = {};
function $6084490f368b0396$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $6084490f368b0396$var$attributeCache[name] || ($6084490f368b0396$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $6084490f368b0396$var$dangerousStyleValue(name, style[name]);
        if ($6084490f368b0396$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $6084490f368b0396$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $6084490f368b0396$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $6084490f368b0396$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$6084490f368b0396$var$isUnitlessNumber = Object.keys($6084490f368b0396$var$isUnitlessNumber).reduce((acc, prop)=>{
    $6084490f368b0396$var$prefixes.forEach((prefix)=>acc[$6084490f368b0396$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $6084490f368b0396$var$isUnitlessNumber);
var $6084490f368b0396$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $6084490f368b0396$var$pxTransforms = /^(translate)/;
var $6084490f368b0396$var$degTransforms = /^(rotate|skew)/;
var $6084490f368b0396$var$addUnit = (value, unit)=>(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $6084490f368b0396$var$isValueIdentity = (value, id)=>(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$6084490f368b0396$var$isValueIdentity(v, id)) : (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $6084490f368b0396$var$AnimatedStyle = class extends (0, $b08e4134053d0fe9$export$f1b0b9e366a6e2d4) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$6084490f368b0396$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $6084490f368b0396$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($6084490f368b0396$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $6084490f368b0396$var$pxTransforms.test(key) ? "px" : $6084490f368b0396$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $fda335f6a9b8d095$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$6084490f368b0396$var$addUnit(deg, unit)})`,
                        $6084490f368b0396$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$6084490f368b0396$var$addUnit(v, unit)).join(",")})`,
                        $6084490f368b0396$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $6084490f368b0396$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $6084490f368b0396$var$FluidTransform = class extends (0, $fda335f6a9b8d095$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $fda335f6a9b8d095$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $fda335f6a9b8d095$export$79b2f7037acddd43)(input, (value)=>(0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(value) && (0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $fda335f6a9b8d095$export$79b2f7037acddd43)(input, (value)=>(0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(value) && (0, $fda335f6a9b8d095$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $fda335f6a9b8d095$export$31752c40a5fab62a)(this, event);
    }
};
// src/primitives.ts
var $6084490f368b0396$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $fda335f6a9b8d095$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $fCKK7.unstable_batchedUpdates),
    createStringInterpolator: $fda335f6a9b8d095$export$4759a013d387347a,
    colors: $fda335f6a9b8d095$export$8f45430ccf837300
});
var $6084490f368b0396$var$host = (0, $b08e4134053d0fe9$export$4ee5c78f6dcbcef)($6084490f368b0396$var$primitives, {
    applyAnimatedValues: $6084490f368b0396$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $6084490f368b0396$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $6084490f368b0396$export$407448d2b89b1813 = $6084490f368b0396$var$host.animated;




var $8nGP5 = parcelRequire("8nGP5");
var $4c21b0df46793000$exports = {};
'use strict';
Object.defineProperty($4c21b0df46793000$exports, "__esModule", {
    value: true
});
var $b19883bf6c50b518$exports = {};

$parcel$defineInteropFlag($b19883bf6c50b518$exports);

$parcel$export($b19883bf6c50b518$exports, "__esModule", function () { return $b19883bf6c50b518$export$1e511d4a378977f5; }, function (v) { return $b19883bf6c50b518$export$1e511d4a378977f5 = v; });
$parcel$export($b19883bf6c50b518$exports, "default", function () { return $b19883bf6c50b518$export$2e2bcd8739ae039; }, function (v) { return $b19883bf6c50b518$export$2e2bcd8739ae039 = v; });
var $b19883bf6c50b518$export$1e511d4a378977f5;
var $b19883bf6c50b518$export$2e2bcd8739ae039;
"use strict";
$b19883bf6c50b518$export$1e511d4a378977f5 = true;
var $0107668699af6117$exports = {};

$0107668699af6117$exports = {
    "default": (parcelRequire("9HWmz")),
    __esModule: true
};


var $b19883bf6c50b518$var$_assign2 = $b19883bf6c50b518$var$_interopRequireDefault($0107668699af6117$exports);
function $b19883bf6c50b518$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$b19883bf6c50b518$export$2e2bcd8739ae039 = $b19883bf6c50b518$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};


var $4c21b0df46793000$var$_extends3 = $4c21b0df46793000$var$_interopRequireDefault($b19883bf6c50b518$exports);
var $d1803123caaf0bdf$exports = {};

$d1803123caaf0bdf$exports = {
    "default": (parcelRequire("7kC0X")),
    __esModule: true
};


var $4c21b0df46793000$var$_getPrototypeOf2 = $4c21b0df46793000$var$_interopRequireDefault($d1803123caaf0bdf$exports);
var $8fbe2cbc4e7ce8ca$exports = {};

$parcel$defineInteropFlag($8fbe2cbc4e7ce8ca$exports);

$parcel$export($8fbe2cbc4e7ce8ca$exports, "__esModule", function () { return $8fbe2cbc4e7ce8ca$export$1e511d4a378977f5; }, function (v) { return $8fbe2cbc4e7ce8ca$export$1e511d4a378977f5 = v; });
$parcel$export($8fbe2cbc4e7ce8ca$exports, "default", function () { return $8fbe2cbc4e7ce8ca$export$2e2bcd8739ae039; }, function (v) { return $8fbe2cbc4e7ce8ca$export$2e2bcd8739ae039 = v; });
var $8fbe2cbc4e7ce8ca$export$1e511d4a378977f5;
var $8fbe2cbc4e7ce8ca$export$2e2bcd8739ae039;
"use strict";
$8fbe2cbc4e7ce8ca$export$1e511d4a378977f5 = true;
$8fbe2cbc4e7ce8ca$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};


var $4c21b0df46793000$var$_classCallCheck3 = $4c21b0df46793000$var$_interopRequireDefault($8fbe2cbc4e7ce8ca$exports);
var $0b67a7dd7b08a285$exports = {};

$parcel$defineInteropFlag($0b67a7dd7b08a285$exports);

$parcel$export($0b67a7dd7b08a285$exports, "__esModule", function () { return $0b67a7dd7b08a285$export$1e511d4a378977f5; }, function (v) { return $0b67a7dd7b08a285$export$1e511d4a378977f5 = v; });
$parcel$export($0b67a7dd7b08a285$exports, "default", function () { return $0b67a7dd7b08a285$export$2e2bcd8739ae039; }, function (v) { return $0b67a7dd7b08a285$export$2e2bcd8739ae039 = v; });
var $0b67a7dd7b08a285$export$1e511d4a378977f5;
var $0b67a7dd7b08a285$export$2e2bcd8739ae039;
"use strict";
$0b67a7dd7b08a285$export$1e511d4a378977f5 = true;
var $ca42b4fdaa8cc95e$exports = {};

$ca42b4fdaa8cc95e$exports = {
    "default": (parcelRequire("kRrED")),
    __esModule: true
};


var $0b67a7dd7b08a285$var$_defineProperty2 = $0b67a7dd7b08a285$var$_interopRequireDefault($ca42b4fdaa8cc95e$exports);
function $0b67a7dd7b08a285$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$0b67a7dd7b08a285$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $0b67a7dd7b08a285$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();


var $4c21b0df46793000$var$_createClass3 = $4c21b0df46793000$var$_interopRequireDefault($0b67a7dd7b08a285$exports);
var $f44505b454109184$exports = {};

$parcel$defineInteropFlag($f44505b454109184$exports);

$parcel$export($f44505b454109184$exports, "__esModule", function () { return $f44505b454109184$export$1e511d4a378977f5; }, function (v) { return $f44505b454109184$export$1e511d4a378977f5 = v; });
$parcel$export($f44505b454109184$exports, "default", function () { return $f44505b454109184$export$2e2bcd8739ae039; }, function (v) { return $f44505b454109184$export$2e2bcd8739ae039 = v; });
var $f44505b454109184$export$1e511d4a378977f5;
var $f44505b454109184$export$2e2bcd8739ae039;
"use strict";
$f44505b454109184$export$1e511d4a378977f5 = true;
var $9e3b7384f5c31771$exports = {};

$parcel$defineInteropFlag($9e3b7384f5c31771$exports);

$parcel$export($9e3b7384f5c31771$exports, "__esModule", function () { return $9e3b7384f5c31771$export$1e511d4a378977f5; }, function (v) { return $9e3b7384f5c31771$export$1e511d4a378977f5 = v; });
$parcel$export($9e3b7384f5c31771$exports, "default", function () { return $9e3b7384f5c31771$export$2e2bcd8739ae039; }, function (v) { return $9e3b7384f5c31771$export$2e2bcd8739ae039 = v; });
var $9e3b7384f5c31771$export$1e511d4a378977f5;
var $9e3b7384f5c31771$export$2e2bcd8739ae039;
"use strict";
$9e3b7384f5c31771$export$1e511d4a378977f5 = true;
var $458c58f186e9b17f$exports = {};

$458c58f186e9b17f$exports = {
    "default": (parcelRequire("5nWeK")),
    __esModule: true
};


var $9e3b7384f5c31771$var$_iterator2 = $9e3b7384f5c31771$var$_interopRequireDefault($458c58f186e9b17f$exports);
var $68dfa0da1d64505a$exports = {};

$68dfa0da1d64505a$exports = {
    "default": (parcelRequire("awRwR")),
    __esModule: true
};


var $9e3b7384f5c31771$var$_symbol2 = $9e3b7384f5c31771$var$_interopRequireDefault($68dfa0da1d64505a$exports);
var $9e3b7384f5c31771$var$_typeof = typeof $9e3b7384f5c31771$var$_symbol2.default === "function" && typeof $9e3b7384f5c31771$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $9e3b7384f5c31771$var$_symbol2.default === "function" && obj.constructor === $9e3b7384f5c31771$var$_symbol2.default && obj !== $9e3b7384f5c31771$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $9e3b7384f5c31771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$9e3b7384f5c31771$export$2e2bcd8739ae039 = typeof $9e3b7384f5c31771$var$_symbol2.default === "function" && $9e3b7384f5c31771$var$_typeof($9e3b7384f5c31771$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $9e3b7384f5c31771$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $9e3b7384f5c31771$var$_symbol2.default === "function" && obj.constructor === $9e3b7384f5c31771$var$_symbol2.default && obj !== $9e3b7384f5c31771$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $9e3b7384f5c31771$var$_typeof(obj);
};


var $f44505b454109184$var$_typeof3 = $f44505b454109184$var$_interopRequireDefault($9e3b7384f5c31771$exports);
function $f44505b454109184$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$f44505b454109184$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $f44505b454109184$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};


var $4c21b0df46793000$var$_possibleConstructorReturn3 = $4c21b0df46793000$var$_interopRequireDefault($f44505b454109184$exports);
var $c62b3f33f191c239$exports = {};

$parcel$defineInteropFlag($c62b3f33f191c239$exports);

$parcel$export($c62b3f33f191c239$exports, "__esModule", function () { return $c62b3f33f191c239$export$1e511d4a378977f5; }, function (v) { return $c62b3f33f191c239$export$1e511d4a378977f5 = v; });
$parcel$export($c62b3f33f191c239$exports, "default", function () { return $c62b3f33f191c239$export$2e2bcd8739ae039; }, function (v) { return $c62b3f33f191c239$export$2e2bcd8739ae039 = v; });
var $c62b3f33f191c239$export$1e511d4a378977f5;
var $c62b3f33f191c239$export$2e2bcd8739ae039;
"use strict";
$c62b3f33f191c239$export$1e511d4a378977f5 = true;
var $41bfbf96173944bd$exports = {};

$41bfbf96173944bd$exports = {
    "default": (parcelRequire("elpuD")),
    __esModule: true
};


var $c62b3f33f191c239$var$_setPrototypeOf2 = $c62b3f33f191c239$var$_interopRequireDefault($41bfbf96173944bd$exports);
var $8aaf46f087fe6360$exports = {};

$8aaf46f087fe6360$exports = {
    "default": (parcelRequire("iWNxk")),
    __esModule: true
};


var $c62b3f33f191c239$var$_create2 = $c62b3f33f191c239$var$_interopRequireDefault($8aaf46f087fe6360$exports);

var $c62b3f33f191c239$var$_typeof3 = $c62b3f33f191c239$var$_interopRequireDefault($9e3b7384f5c31771$exports);
function $c62b3f33f191c239$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$c62b3f33f191c239$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $c62b3f33f191c239$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $c62b3f33f191c239$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c62b3f33f191c239$var$_setPrototypeOf2.default ? (0, $c62b3f33f191c239$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};


var $4c21b0df46793000$var$_inherits3 = $4c21b0df46793000$var$_interopRequireDefault($c62b3f33f191c239$exports);

var $8nGP5 = parcelRequire("8nGP5");
var $4c21b0df46793000$var$_react2 = $4c21b0df46793000$var$_interopRequireDefault($8nGP5);

var $ebCsu = parcelRequire("ebCsu");
var $4c21b0df46793000$var$_propTypes2 = $4c21b0df46793000$var$_interopRequireDefault($ebCsu);

var $2DQiR = parcelRequire("2DQiR");
var $4c21b0df46793000$var$_lottieWeb2 = $4c21b0df46793000$var$_interopRequireDefault($2DQiR);
function $4c21b0df46793000$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4c21b0df46793000$var$Lottie = function(_React$Component) {
    (0, $4c21b0df46793000$var$_inherits3.default)(Lottie, _React$Component);
    function Lottie() {
        var _ref;
        var _temp, _this, _ret;
        (0, $4c21b0df46793000$var$_classCallCheck3.default)(this, Lottie);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $4c21b0df46793000$var$_possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, $4c21b0df46793000$var$_getPrototypeOf2.default)(Lottie)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.handleClickToPause = function() {
            // The pause() method is for handling pausing by passing a prop isPaused
            // This method is for handling the ability to pause by clicking on the animation
            if (_this.anim.isPaused) _this.anim.play();
            else _this.anim.pause();
        }, _temp), (0, $4c21b0df46793000$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $4c21b0df46793000$var$_createClass3.default)(Lottie, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props, options = _props.options, eventListeners = _props.eventListeners;
                var loop = options.loop, autoplay = options.autoplay, animationData = options.animationData, rendererSettings = options.rendererSettings, segments = options.segments;
                this.options = {
                    container: this.el,
                    renderer: 'svg',
                    loop: loop !== false,
                    autoplay: autoplay !== false,
                    segments: segments !== false,
                    animationData: animationData,
                    rendererSettings: rendererSettings
                };
                this.options = (0, $4c21b0df46793000$var$_extends3.default)({}, this.options, options);
                this.anim = $4c21b0df46793000$var$_lottieWeb2.default.loadAnimation(this.options);
                this.registerEvents(eventListeners);
                this.setSpeed();
            }
        },
        {
            key: 'componentWillUpdate',
            value: function componentWillUpdate(nextProps /* , nextState */ ) {
                /* Recreate the animation handle if the data is changed */ if (this.options.animationData !== nextProps.options.animationData) {
                    this.deRegisterEvents(this.props.eventListeners);
                    this.destroy();
                    this.options = (0, $4c21b0df46793000$var$_extends3.default)({}, this.options, nextProps.options);
                    this.anim = $4c21b0df46793000$var$_lottieWeb2.default.loadAnimation(this.options);
                    this.registerEvents(nextProps.eventListeners);
                }
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                if (this.props.isStopped) this.stop();
                else if (this.props.segments) this.playSegments();
                else this.play();
                this.pause();
                this.setSpeed();
                this.setDirection();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.deRegisterEvents(this.props.eventListeners);
                this.destroy();
                this.options.animationData = null;
                this.anim = null;
            }
        },
        {
            key: 'setSpeed',
            value: function setSpeed() {
                this.anim.setSpeed(this.props.speed);
            }
        },
        {
            key: 'setDirection',
            value: function setDirection() {
                this.anim.setDirection(this.props.direction);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.anim.play();
            }
        },
        {
            key: 'playSegments',
            value: function playSegments() {
                this.anim.playSegments(this.props.segments);
            }
        },
        {
            key: 'stop',
            value: function stop() {
                this.anim.stop();
            }
        },
        {
            key: 'pause',
            value: function pause() {
                if (this.props.isPaused && !this.anim.isPaused) this.anim.pause();
                else if (!this.props.isPaused && this.anim.isPaused) this.anim.pause();
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                this.anim.destroy();
            }
        },
        {
            key: 'registerEvents',
            value: function registerEvents(eventListeners) {
                var _this2 = this;
                eventListeners.forEach(function(eventListener) {
                    _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: 'deRegisterEvents',
            value: function deRegisterEvents(eventListeners) {
                var _this3 = this;
                eventListeners.forEach(function(eventListener) {
                    _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, width = _props2.width, height = _props2.height, ariaRole = _props2.ariaRole, ariaLabel = _props2.ariaLabel, isClickToPauseDisabled = _props2.isClickToPauseDisabled, title = _props2.title;
                var getSize = function getSize(initial) {
                    var size = void 0;
                    if (typeof initial === 'number') size = initial + 'px';
                    else size = initial || '100%';
                    return size;
                };
                var lottieStyles = (0, $4c21b0df46793000$var$_extends3.default)({
                    width: getSize(width),
                    height: getSize(height),
                    overflow: 'hidden',
                    margin: '0 auto',
                    outline: 'none'
                }, this.props.style);
                var onClickHandler = isClickToPauseDisabled ? function() {
                    return null;
                } : this.handleClickToPause;
                return(// Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                $4c21b0df46793000$var$_react2.default.createElement('div', {
                    ref: function ref(c) {
                        _this4.el = c;
                    },
                    style: lottieStyles,
                    onClick: onClickHandler,
                    title: title,
                    role: ariaRole,
                    'aria-label': ariaLabel,
                    tabIndex: '0'
                }));
            }
        }
    ]);
    return Lottie;
}($4c21b0df46793000$var$_react2.default.Component);
$4c21b0df46793000$exports.default = $4c21b0df46793000$var$Lottie;
$4c21b0df46793000$var$Lottie.propTypes = {
    eventListeners: $4c21b0df46793000$var$_propTypes2.default.arrayOf($4c21b0df46793000$var$_propTypes2.default.object),
    options: $4c21b0df46793000$var$_propTypes2.default.object.isRequired,
    height: $4c21b0df46793000$var$_propTypes2.default.oneOfType([
        $4c21b0df46793000$var$_propTypes2.default.string,
        $4c21b0df46793000$var$_propTypes2.default.number
    ]),
    width: $4c21b0df46793000$var$_propTypes2.default.oneOfType([
        $4c21b0df46793000$var$_propTypes2.default.string,
        $4c21b0df46793000$var$_propTypes2.default.number
    ]),
    isStopped: $4c21b0df46793000$var$_propTypes2.default.bool,
    isPaused: $4c21b0df46793000$var$_propTypes2.default.bool,
    speed: $4c21b0df46793000$var$_propTypes2.default.number,
    segments: $4c21b0df46793000$var$_propTypes2.default.arrayOf($4c21b0df46793000$var$_propTypes2.default.number),
    direction: $4c21b0df46793000$var$_propTypes2.default.number,
    ariaRole: $4c21b0df46793000$var$_propTypes2.default.string,
    ariaLabel: $4c21b0df46793000$var$_propTypes2.default.string,
    isClickToPauseDisabled: $4c21b0df46793000$var$_propTypes2.default.bool,
    title: $4c21b0df46793000$var$_propTypes2.default.string,
    style: $4c21b0df46793000$var$_propTypes2.default.object
};
$4c21b0df46793000$var$Lottie.defaultProps = {
    eventListeners: [],
    isStopped: false,
    isPaused: false,
    speed: 1,
    ariaRole: 'button',
    ariaLabel: 'animation',
    isClickToPauseDisabled: false,
    title: ''
};




var $1e22e536e4ef8476$exports = {};
$1e22e536e4ef8476$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":696,\"op\":762,\"w\":600,\"h\":600,\"nm\":\"Final\",\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ind\":3,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[200,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":20,\"op\":1520,\"st\":20},{\"ind\":4,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[250,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":30,\"op\":1530,\"st\":30},{\"ind\":5,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":40,\"op\":1540,\"st\":40},{\"ind\":6,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[350,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":50,\"op\":1550,\"st\":50},{\"ind\":7,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[400,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":60,\"op\":1560,\"st\":60},{\"ind\":8,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[450,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":70,\"op\":1570,\"st\":70},{\"ind\":9,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[500,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":80,\"op\":1580,\"st\":80}]},{\"id\":\"comp_1\",\"layers\":[{\"ind\":1,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":632,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":645,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":657,\"s\":[30]},{\"t\":680,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,415,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1.298]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,0.845]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.057]},\"t\":632,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.645]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0.143]},\"t\":645,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":657,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":699,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":714,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":726,\"s\":[100,100,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0},{\"ind\":2,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":680,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":697,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":710,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":722,\"s\":[30]},{\"t\":745,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,171,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":634,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":647,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":659,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":697,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":710,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":722,\"s\":[55,55,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":-65,\"op\":1435,\"st\":-65}]},{\"id\":\"comp_2\",\"layers\":[{\"ind\":1,\"ty\":4,\"nm\":\"Round 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-74,-14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[129,129,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[60,60]},\"p\":{\"a\":0,\"k\":[0,0]},\"nm\":\"Ellipse Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.831,0.851,0.878,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-74,-14]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\"}],\"ip\":0,\"op\":1500,\"st\":0}]}],\"layers\":[{\"ind\":2,\"ty\":0,\"nm\":\"sequance\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[248,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0}],\"markers\":[]}");


const $7cf10799ed69235a$export$669f6ea7d267feaf = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const [showLoading, setShowLoading] = (0, $8nGP5.useState)(true);
    const targetAlpha = (store.isLoaded || uiStore.disableLoading) && !uiStore.forceLoading ? 0 : 1;
    const props = (0, $21cbb88cff39ec52$export$c4af9125706c4d30)({
        from: {
            opacity: 1
        },
        to: {
            opacity: targetAlpha
        },
        delay: targetAlpha === 1 ? 0 : 1000,
        onChange: (val)=>{
            if (val.value['opacity'] == 0) setShowLoading(false);
        }
    });
    // Reset showLoading when we need to show loading again
    if (targetAlpha === 1 && !showLoading) setShowLoading(true);
    if (!showLoading) return null;
    const defaultOptions = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($1e22e536e4ef8476$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return (0, $kSbwP.jsx)((0, $6084490f368b0396$export$407448d2b89b1813).div, {
        style: Object.assign({
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: 80000
        }, props),
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            justify: "start",
            alignItems: "center",
            style: {
                backgroundColor: 'white',
                pointerEvents: 'none'
            },
            direction: "column",
            className: "fade-in",
            children: [
                (0, $kSbwP.jsx)("div", {
                    style: {
                        color: '#243A5C',
                        fontSize: '60px',
                        fontFamily: 'LustTextMedium',
                        marginTop: '200px',
                        zIndex: 100,
                        position: 'relative',
                        top: '50px',
                        animationDelay: '0.2s'
                    },
                    className: "fade-in",
                    children: (0, $kSbwP.jsx)((0, $bc783706f3494468$export$e6ff31bff12b7ff4), {
                        width: 300
                    })
                }),
                (0, $kSbwP.jsx)("div", {
                    className: "fade-in",
                    style: {
                        animationDelay: '0.45s'
                    },
                    children: (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
                        options: defaultOptions,
                        height: 400,
                        width: 400
                    })
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");
parcelRequire("8nGP5");


var $T5IcR = parcelRequire("T5IcR");




var $ffb64b99b5e6ea0e$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ffb64b99b5e6ea0e$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ffb64b99b5e6ea0e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ffb64b99b5e6ea0e$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ffb64b99b5e6ea0e$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
// Helper function to check if a field is yearly
function $ffb64b99b5e6ea0e$var$isYearlyField(fieldKey) {
    // Type guard to ensure the field has the yearly property
    return 'yearly' in (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldKey] && (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldKey]['yearly'] === true;
}
let $ffb64b99b5e6ea0e$export$4cdb0f51af2f8879 = (()=>{
    var _a, _SelectionStore_isSelectionModeActive_accessor_storage, _SelectionStore_selectedFields_accessor_storage, _SelectionStore_existingDataFound_accessor_storage, _SelectionStore_existingReferenceFields_accessor_storage;
    let _instanceExtraInitializers = [];
    let _isSelectionModeActive_decorators;
    let _isSelectionModeActive_initializers = [];
    let _isSelectionModeActive_extraInitializers = [];
    let _selectedFields_decorators;
    let _selectedFields_initializers = [];
    let _selectedFields_extraInitializers = [];
    let _existingDataFound_decorators;
    let _existingDataFound_initializers = [];
    let _existingDataFound_extraInitializers = [];
    let _existingReferenceFields_decorators;
    let _existingReferenceFields_initializers = [];
    let _existingReferenceFields_extraInitializers = [];
    let _get_selectionCount_decorators;
    let _toggleSelection_decorators;
    let _activateSelectionMode_decorators;
    let _selectAll_decorators;
    let _saveSelected_decorators;
    let _exitSelectionMode_decorators;
    let _isFieldSelected_decorators;
    return _a = class SelectionStore {
        get isSelectionModeActive() {
            return $ffb64b99b5e6ea0e$var$__classPrivateFieldGet(this, _SelectionStore_isSelectionModeActive_accessor_storage, "f");
        }
        set isSelectionModeActive(value) {
            $ffb64b99b5e6ea0e$var$__classPrivateFieldSet(this, _SelectionStore_isSelectionModeActive_accessor_storage, value, "f");
        }
        get selectedFields() {
            return $ffb64b99b5e6ea0e$var$__classPrivateFieldGet(this, _SelectionStore_selectedFields_accessor_storage, "f");
        }
        set selectedFields(value) {
            $ffb64b99b5e6ea0e$var$__classPrivateFieldSet(this, _SelectionStore_selectedFields_accessor_storage, value, "f");
        }
        get existingDataFound() {
            return $ffb64b99b5e6ea0e$var$__classPrivateFieldGet(this, _SelectionStore_existingDataFound_accessor_storage, "f");
        }
        set existingDataFound(value) {
            $ffb64b99b5e6ea0e$var$__classPrivateFieldSet(this, _SelectionStore_existingDataFound_accessor_storage, value, "f");
        }
        get existingReferenceFields() {
            return $ffb64b99b5e6ea0e$var$__classPrivateFieldGet(this, _SelectionStore_existingReferenceFields_accessor_storage, "f");
        }
        set existingReferenceFields(value) {
            $ffb64b99b5e6ea0e$var$__classPrivateFieldSet(this, _SelectionStore_existingReferenceFields_accessor_storage, value, "f");
        }
        constructor(){
            _SelectionStore_isSelectionModeActive_accessor_storage.set(this, ($ffb64b99b5e6ea0e$var$__runInitializers(this, _instanceExtraInitializers), $ffb64b99b5e6ea0e$var$__runInitializers(this, _isSelectionModeActive_initializers, false)));
            _SelectionStore_selectedFields_accessor_storage.set(this, ($ffb64b99b5e6ea0e$var$__runInitializers(this, _isSelectionModeActive_extraInitializers), $ffb64b99b5e6ea0e$var$__runInitializers(this, _selectedFields_initializers, {})));
            _SelectionStore_existingDataFound_accessor_storage.set(this, ($ffb64b99b5e6ea0e$var$__runInitializers(this, _selectedFields_extraInitializers), $ffb64b99b5e6ea0e$var$__runInitializers(this, _existingDataFound_initializers, false)));
            _SelectionStore_existingReferenceFields_accessor_storage.set(this, ($ffb64b99b5e6ea0e$var$__runInitializers(this, _existingDataFound_extraInitializers), $ffb64b99b5e6ea0e$var$__runInitializers(this, _existingReferenceFields_initializers, {})));
            $ffb64b99b5e6ea0e$var$__runInitializers(this, _existingReferenceFields_extraInitializers);
            (0, $T5IcR.makeObservable)(this);
        }
        get selectionCount() {
            return Object.values(this.selectedFields).filter(Boolean).length;
        }
        toggleSelection(fieldName) {
            if (!this.isSelectionModeActive || !fieldName) {
                console.warn(`Toggle selection failed: isSelectionModeActive=${this.isSelectionModeActive}, fieldName=${fieldName}`);
                return;
            }
            console.log(`Toggle selection for ${fieldName}: current=${this.selectedFields[fieldName]}`);
            // Create new object to guarantee that MobX detects the change
            const newSelectedFields = Object.assign({}, this.selectedFields);
            // Toggle the field in the new object
            newSelectedFields[fieldName] = !newSelectedFields[fieldName];
            // Replace the entire object instead of modifying in place
            this.selectedFields = newSelectedFields;
            console.log(`After toggle - field ${fieldName}: new value=${this.selectedFields[fieldName]}`);
            console.log(`Total selected fields: ${this.selectionCount}`);
        }
        activateSelectionMode() {
            return $ffb64b99b5e6ea0e$var$__awaiter(this, void 0, void 0, function*() {
                const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                const dealId = store.selectedReportId;
                if (!dealId) return;
                // Clear previous selections
                this.selectedFields = {};
                try {
                    // Use get() instead of onValue for one-time data retrieval
                    const existingData = yield (0, $b2432f43c421c848$export$7a667d08ed65fa47)().get_existing_reference_data(dealId);
                    if (existingData && existingData.data) {
                        // Mark that we found existing data
                        this.existingDataFound = true;
                        // existingData.data is already an object in format {fieldName: true}
                        this.existingReferenceFields = existingData.data;
                        // Use the existing fields object directly
                        this.selectedFields = Object.assign({}, existingData.data);
                        console.log('Pre-selected fields:', this.selectedFields);
                    } else {
                        this.existingDataFound = false;
                        this.existingReferenceFields = {};
                    }
                    // Activate selection mode
                    this.isSelectionModeActive = true;
                } catch (error) {
                    console.error('Error loading existing reference data:', error);
                }
            });
        }
        selectAll() {
            const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
            const dealId = store.selectedReportId;
            if (!dealId || !store.reportDataDB[dealId]) {
                console.warn('No active deal data available');
                return;
            }
            // Get all available fields from the current deal data
            const currentDealData = store.reportDataDB[dealId];
            const overrides = store.reportDataOverridesDB[dealId] || {};
            // Create DataAccessUtils to access the deal data
            const dataAccess = new (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)(currentDealData, overrides, dealId);
            // Get all fields from FieldsSchema that have data in the current deal
            const allSchemaFields = Object.keys((0, $809f7f123ac5d4fa$export$be4faee424ea3a71));
            const availableFields = new Set();
            // Use DataAccessUtils to check for available fields
            allSchemaFields.forEach((fieldKey)=>{
                // Use DataAccessUtils.value() method to properly access and validate fields
                const fieldValue = dataAccess.value(fieldKey);
                // Only add fields that have valid data (not 'N/A')
                if (fieldValue !== 'N/A' && fieldValue !== undefined && fieldValue !== null) availableFields.add(fieldKey);
                // For yearly data fields, check if they have data using valueByYear
                if ($ffb64b99b5e6ea0e$var$isYearlyField(fieldKey)) try {
                    const currentYear = dataAccess.actualYear();
                    const yearlyValue = dataAccess.valueByYear(fieldKey, currentYear);
                    if (yearlyValue !== 'N/A' && yearlyValue !== undefined && yearlyValue !== null) availableFields.add(fieldKey);
                } catch (e) {
                // Field might not support valueByYear, skip it
                }
            });
            console.log(`Found ${availableFields.size} available fields to select`);
            // Create an object with all fields set to true
            const allSelected = Object.assign({}, this.selectedFields);
            // Add all available fields
            availableFields.forEach((fieldName)=>{
                allSelected[fieldName] = true;
            });
            this.selectedFields = allSelected;
        }
        saveSelected() {
            return $ffb64b99b5e6ea0e$var$__awaiter(this, void 0, void 0, function*() {
                const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                const dealId = store.selectedReportId;
                if (!dealId) {
                    console.error('No dealId available for saving reference data');
                    return;
                }
                try {
                    // Filter to get only selected fields
                    const fieldsToSave = Object.assign({}, this.selectedFields);
                    if (this.selectionCount === 0) {
                        console.warn('No fields selected for saving');
                        return;
                    }
                    // Save to Firebase
                    yield (0, $b2432f43c421c848$export$7a667d08ed65fa47)().save_reference_data(dealId, fieldsToSave);
                    // Exit selection mode
                    this.exitSelectionMode();
                } catch (error) {
                    console.error('Error in saveSelected:', error);
                }
            });
        }
        exitSelectionMode() {
            this.isSelectionModeActive = false;
            this.selectedFields = {};
            this.existingDataFound = false;
            this.existingReferenceFields = {};
        }
        isFieldSelected(fieldName) {
            return this.selectedFields[fieldName] === true;
        }
    }, _SelectionStore_isSelectionModeActive_accessor_storage = new WeakMap(), _SelectionStore_selectedFields_accessor_storage = new WeakMap(), _SelectionStore_existingDataFound_accessor_storage = new WeakMap(), _SelectionStore_existingReferenceFields_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _isSelectionModeActive_decorators = [
            (0, $T5IcR.observable)
        ];
        _selectedFields_decorators = [
            (0, $T5IcR.observable)
        ];
        _existingDataFound_decorators = [
            (0, $T5IcR.observable)
        ];
        _existingReferenceFields_decorators = [
            (0, $T5IcR.observable)
        ];
        _get_selectionCount_decorators = [
            (0, $T5IcR.computed)
        ];
        _toggleSelection_decorators = [
            (0, $T5IcR.action)
        ];
        _activateSelectionMode_decorators = [
            (0, $T5IcR.action)
        ];
        _selectAll_decorators = [
            (0, $T5IcR.action)
        ];
        _saveSelected_decorators = [
            (0, $T5IcR.action)
        ];
        _exitSelectionMode_decorators = [
            (0, $T5IcR.action)
        ];
        _isFieldSelected_decorators = [
            (0, $T5IcR.action)
        ];
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _isSelectionModeActive_decorators, {
            kind: "accessor",
            name: "isSelectionModeActive",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isSelectionModeActive" in obj,
                get: (obj)=>obj.isSelectionModeActive,
                set: (obj, value)=>{
                    obj.isSelectionModeActive = value;
                }
            },
            metadata: _metadata
        }, _isSelectionModeActive_initializers, _isSelectionModeActive_extraInitializers);
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _selectedFields_decorators, {
            kind: "accessor",
            name: "selectedFields",
            static: false,
            private: false,
            access: {
                has: (obj)=>"selectedFields" in obj,
                get: (obj)=>obj.selectedFields,
                set: (obj, value)=>{
                    obj.selectedFields = value;
                }
            },
            metadata: _metadata
        }, _selectedFields_initializers, _selectedFields_extraInitializers);
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _existingDataFound_decorators, {
            kind: "accessor",
            name: "existingDataFound",
            static: false,
            private: false,
            access: {
                has: (obj)=>"existingDataFound" in obj,
                get: (obj)=>obj.existingDataFound,
                set: (obj, value)=>{
                    obj.existingDataFound = value;
                }
            },
            metadata: _metadata
        }, _existingDataFound_initializers, _existingDataFound_extraInitializers);
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _existingReferenceFields_decorators, {
            kind: "accessor",
            name: "existingReferenceFields",
            static: false,
            private: false,
            access: {
                has: (obj)=>"existingReferenceFields" in obj,
                get: (obj)=>obj.existingReferenceFields,
                set: (obj, value)=>{
                    obj.existingReferenceFields = value;
                }
            },
            metadata: _metadata
        }, _existingReferenceFields_initializers, _existingReferenceFields_extraInitializers);
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _get_selectionCount_decorators, {
            kind: "getter",
            name: "selectionCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"selectionCount" in obj,
                get: (obj)=>obj.selectionCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _toggleSelection_decorators, {
            kind: "method",
            name: "toggleSelection",
            static: false,
            private: false,
            access: {
                has: (obj)=>"toggleSelection" in obj,
                get: (obj)=>obj.toggleSelection
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _activateSelectionMode_decorators, {
            kind: "method",
            name: "activateSelectionMode",
            static: false,
            private: false,
            access: {
                has: (obj)=>"activateSelectionMode" in obj,
                get: (obj)=>obj.activateSelectionMode
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _selectAll_decorators, {
            kind: "method",
            name: "selectAll",
            static: false,
            private: false,
            access: {
                has: (obj)=>"selectAll" in obj,
                get: (obj)=>obj.selectAll
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _saveSelected_decorators, {
            kind: "method",
            name: "saveSelected",
            static: false,
            private: false,
            access: {
                has: (obj)=>"saveSelected" in obj,
                get: (obj)=>obj.saveSelected
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _exitSelectionMode_decorators, {
            kind: "method",
            name: "exitSelectionMode",
            static: false,
            private: false,
            access: {
                has: (obj)=>"exitSelectionMode" in obj,
                get: (obj)=>obj.exitSelectionMode
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $ffb64b99b5e6ea0e$var$__esDecorate(_a, null, _isFieldSelected_decorators, {
            kind: "method",
            name: "isFieldSelected",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isFieldSelected" in obj,
                get: (obj)=>obj.isFieldSelected
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
// Create a singleton instance
const $ffb64b99b5e6ea0e$var$selectionStore = new $ffb64b99b5e6ea0e$export$4cdb0f51af2f8879();
const $ffb64b99b5e6ea0e$export$4b4c417a6113a34c = ()=>$ffb64b99b5e6ea0e$var$selectionStore;



const $92cbda2f3abbf0b8$export$980520e7688d5821 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const selectionStore = (0, $ffb64b99b5e6ea0e$export$4b4c417a6113a34c)();
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        style: {
            position: 'fixed',
            right: '20px',
            bottom: '20px',
            padding: '16px',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
            zIndex: 10000,
            minWidth: '240px',
            gap: '12px'
        },
        children: [
            (0, $kSbwP.jsx)("div", {
                style: {
                    fontSize: '16px',
                    fontWeight: 600,
                    color: '#333333',
                    marginBottom: '8px',
                    borderBottom: '1px solid #e0e0e0',
                    paddingBottom: '8px'
                },
                children: "Reference Data Selection"
            }),
            selectionStore.existingDataFound && (0, $kSbwP.jsx)("div", {
                style: {
                    fontSize: '12px',
                    color: '#2e7d32',
                    marginBottom: '4px'
                },
                children: "Existing reference data found"
            }),
            (0, $kSbwP.jsxs)("div", {
                style: {
                    fontSize: '14px',
                    color: '#333333',
                    marginBottom: '8px'
                },
                children: [
                    selectionStore.selectionCount,
                    " fields selected"
                ]
            }),
            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                justify: "between",
                style: {
                    gap: '8px'
                },
                children: [
                    (0, $kSbwP.jsx)("button", {
                        onClick: ()=>selectionStore.selectAll(),
                        style: {
                            padding: '8px 12px',
                            borderRadius: '4px',
                            border: 'none',
                            cursor: 'pointer',
                            fontWeight: 500,
                            backgroundColor: '#F9FAFB',
                            color: '#333333'
                        },
                        children: "Select All"
                    }),
                    (0, $kSbwP.jsx)("button", {
                        onClick: ()=>selectionStore.exitSelectionMode(),
                        style: {
                            padding: '8px 12px',
                            borderRadius: '4px',
                            border: 'none',
                            cursor: 'pointer',
                            fontWeight: 500,
                            backgroundColor: '#F9FAFB',
                            color: '#333333'
                        },
                        children: "Cancel"
                    }),
                    (0, $kSbwP.jsx)("button", {
                        onClick: ()=>selectionStore.saveSelected(),
                        style: {
                            padding: '8px 12px',
                            borderRadius: '4px',
                            border: 'none',
                            cursor: 'pointer',
                            fontWeight: 500,
                            backgroundColor: '#1976d2',
                            color: '#ffffff'
                        },
                        children: "Save Selected"
                    })
                ]
            })
        ]
    });
});







var $8nGP5 = parcelRequire("8nGP5");




var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");




var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");




class $02fdab2e48ca7872$export$28a0d76af7a168a {
    constructor(nav){
        Object.defineProperty(this, "nav", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: nav
        });
    }
    openLink(url) {
        const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        if (ui.isKeyControlKeyDown) window.open(url, '_blank');
        else this.nav(url);
    }
    toReport(tickerId) {
        this.openLink(`/${tickerId}`);
    }
    back() {
        this.nav(-1);
    }
    home() {
        this.openLink('/');
    }
    knowledgeBase() {
        this.openLink('/knowledge');
    }
    navigateTo(path) {
        this.openLink(path);
    }
}
function $02fdab2e48ca7872$export$726c44d912e0140f() {
    const nav = (0, $48e5d1fb97c993cc$export$9770f232ac06a008)();
    return new $02fdab2e48ca7872$export$28a0d76af7a168a(nav);
}



var $87d9bcd99e124788$export$e8c9778bf415dd08;
var $87d9bcd99e124788$export$3dc9c18d68dcbf9a;
var $87d9bcd99e124788$export$becc9140d0e846f8;
var $87d9bcd99e124788$export$fb184b623420d9be;
$87d9bcd99e124788$export$e8c9778bf415dd08 = `vb520q_divider`;
$87d9bcd99e124788$export$3dc9c18d68dcbf9a = `vb520q_filenameText`;
$87d9bcd99e124788$export$becc9140d0e846f8 = `vb520q_thumb`;
$87d9bcd99e124788$export$fb184b623420d9be = `vb520q_title`;


var $8879a5b024ca9d42$exports = {};
$8879a5b024ca9d42$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":696,\"op\":762,\"w\":600,\"h\":600,\"nm\":\"Final\",\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ind\":3,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[200,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":20,\"op\":1520,\"st\":20},{\"ind\":4,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[250,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":30,\"op\":1530,\"st\":30},{\"ind\":5,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":40,\"op\":1540,\"st\":40},{\"ind\":6,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[350,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":50,\"op\":1550,\"st\":50},{\"ind\":7,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[400,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":60,\"op\":1560,\"st\":60},{\"ind\":8,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[450,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":70,\"op\":1570,\"st\":70},{\"ind\":9,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[500,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":80,\"op\":1580,\"st\":80}]},{\"id\":\"comp_1\",\"layers\":[{\"ind\":1,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":632,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":645,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":657,\"s\":[30]},{\"t\":680,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,415,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1.298]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,0.845]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.057]},\"t\":632,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.645]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0.143]},\"t\":645,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":657,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":699,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":714,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":726,\"s\":[100,100,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0},{\"ind\":2,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":680,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":697,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":710,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":722,\"s\":[30]},{\"t\":745,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,171,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":634,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":647,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":659,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":697,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":710,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":722,\"s\":[55,55,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":-65,\"op\":1435,\"st\":-65}]},{\"id\":\"comp_2\",\"layers\":[{\"ind\":1,\"ty\":4,\"nm\":\"Round 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-74,-14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[129,129,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[60,60]},\"p\":{\"a\":0,\"k\":[0,0]},\"nm\":\"Ellipse Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.831,0.851,0.878,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-74,-14]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\"}],\"ip\":0,\"op\":1500,\"st\":0}]}],\"layers\":[{\"ind\":2,\"ty\":0,\"nm\":\"sequance\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[248,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0}],\"markers\":[]}");



const $a3827455c2ec81f0$export$7750bf75c5a3c423 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    var _a, _b, _c, _d;
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const defaultOptionsLottie = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($8879a5b024ca9d42$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    const jobs = store.jobs;
    if (((_a = store.activeJob) === null || _a === void 0 ? void 0 : _a.jobId) == p.jobId) return (0, $kSbwP.jsx)("div", {
        className: $87d9bcd99e124788$export$becc9140d0e846f8,
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            justify: "between",
            alignItems: "center",
            direction: "column",
            fillCell: true,
            style: {
                padding: '10px 0px'
            },
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $87d9bcd99e124788$export$3dc9c18d68dcbf9a,
                    children: (_b = store.activeJob) === null || _b === void 0 ? void 0 : _b.fileName
                }),
                (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
                    options: defaultOptionsLottie,
                    height: 300,
                    width: 300
                })
            ]
        })
    });
    else {
        const queueString = 'In Queue';
        return (0, $kSbwP.jsx)("div", {
            className: $87d9bcd99e124788$export$becc9140d0e846f8,
            children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                justify: "between",
                alignItems: "center",
                direction: "column",
                fillCell: true,
                style: {
                    padding: '10px 0px'
                },
                children: [
                    (0, $kSbwP.jsxs)("div", {
                        className: $87d9bcd99e124788$export$fb184b623420d9be,
                        children: [
                            queueString,
                            ' ',
                            ((_c = store.jobs[p.jobId]) === null || _c === void 0 ? void 0 : _c.pdfPassword) !== undefined && (0, $kSbwP.jsx)("i", {
                                className: "bi bi-asterisk",
                                style: {
                                    fontSize: 25
                                }
                            })
                        ]
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $87d9bcd99e124788$export$3dc9c18d68dcbf9a,
                        children: (_d = store.jobs[p.jobId]) === null || _d === void 0 ? void 0 : _d.fileName
                    })
                ]
            })
        });
    }
});


var $def1233c7c6126ed$export$34e0f9847d4c02dd;
$def1233c7c6126ed$export$34e0f9847d4c02dd = `zbMiIq_container`;



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

const $3e7d8e12b3f432b0$export$4ec57c364807b0e9 = (page, fn)=>{
    const location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    (0, $8nGP5.useEffect)(()=>{
        if (location.pathname == '/' && page == 'DB_PAGE') fn();
        else if (location.pathname == '/login' && page == 'LOGIN_PAGE') fn();
        else //DEAL_VIEW
        fn();
    }, [
        location
    ]);
};





var $fgQ0V = parcelRequire("fgQ0V");


var $8nGP5 = parcelRequire("8nGP5");



var $3e1bb84537f03bf0$export$d0cd57123140c470;
var $3e1bb84537f03bf0$export$40a9eeef55665a40;
var $3e1bb84537f03bf0$export$e8c9778bf415dd08;
var $3e1bb84537f03bf0$export$93b7586d956c930e;
var $3e1bb84537f03bf0$export$b7f029de53087ca2;
var $3e1bb84537f03bf0$export$38e42c68cf43b5d4;
var $3e1bb84537f03bf0$export$37c8efd0a1d7c4c5;
var $3e1bb84537f03bf0$export$35b074988b073474;
var $3e1bb84537f03bf0$export$f843afa9e9b53052;
var $3e1bb84537f03bf0$export$69181d24bfc61261;
var $3e1bb84537f03bf0$export$337b552c20a93b34;
var $3e1bb84537f03bf0$export$ae78d338ad66ff90;
var $3e1bb84537f03bf0$export$a72e403537378b74;
var $3e1bb84537f03bf0$export$d76128d007d19019;
var $3e1bb84537f03bf0$export$f2ea4ab276c3e3fa;
var $3e1bb84537f03bf0$export$8687ffcdea58e000;
var $3e1bb84537f03bf0$export$33fcfcc28f93a08d;
var $3e1bb84537f03bf0$export$d90250155de6d7e7;
var $3e1bb84537f03bf0$export$b8972b998723d602;
var $3e1bb84537f03bf0$export$13925b5cf10ba292;
var $3e1bb84537f03bf0$export$d174ec83970e3502;
var $3e1bb84537f03bf0$export$8427e1cdd60dbd47;
$3e1bb84537f03bf0$export$d0cd57123140c470 = `JH1BnG_dealCount`;
$3e1bb84537f03bf0$export$40a9eeef55665a40 = `JH1BnG_defaultPadding`;
$3e1bb84537f03bf0$export$e8c9778bf415dd08 = `JH1BnG_divider`;
$3e1bb84537f03bf0$export$93b7586d956c930e = `JH1BnG_dropShadow`;
$3e1bb84537f03bf0$export$b7f029de53087ca2 = `JH1BnG_dropdownIcon`;
$3e1bb84537f03bf0$export$38e42c68cf43b5d4 = `JH1BnG_header`;
$3e1bb84537f03bf0$export$37c8efd0a1d7c4c5 = `JH1BnG_industrySearch`;
$3e1bb84537f03bf0$export$35b074988b073474 = `JH1BnG_leftGroup`;
$3e1bb84537f03bf0$export$f843afa9e9b53052 = `JH1BnG_panelImage`;
$3e1bb84537f03bf0$export$69181d24bfc61261 = `JH1BnG_resetButton`;
$3e1bb84537f03bf0$export$337b552c20a93b34 = `JH1BnG_rightGroup`;
$3e1bb84537f03bf0$export$ae78d338ad66ff90 = `JH1BnG_scaleInOut`;
$3e1bb84537f03bf0$export$a72e403537378b74 = `JH1BnG_scoreSearch`;
$3e1bb84537f03bf0$export$d76128d007d19019 = `JH1BnG_search`;
$3e1bb84537f03bf0$export$f2ea4ab276c3e3fa = `JH1BnG_searchBar`;
$3e1bb84537f03bf0$export$8687ffcdea58e000 = `JH1BnG_searchIcon`;
$3e1bb84537f03bf0$export$33fcfcc28f93a08d = `JH1BnG_searchWrapper`;
$3e1bb84537f03bf0$export$d90250155de6d7e7 = `JH1BnG_selected`;
$3e1bb84537f03bf0$export$b8972b998723d602 = `JH1BnG_shadow`;
$3e1bb84537f03bf0$export$13925b5cf10ba292 = `JH1BnG_small-shadow`;
$3e1bb84537f03bf0$export$d174ec83970e3502 = `JH1BnG_sortSelect`;
$3e1bb84537f03bf0$export$8427e1cdd60dbd47 = `JH1BnG_sortWrapper`;


var $959d475eae63db88$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $959d475eae63db88$export$552e6df88a6b2171 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    (0, $8f024b03d9af7c67$export$d2d3ee67e04f6bd9)('Deal Database');
    const [multiSelectionsIndustry, setMultiSelectionsIndustry] = (0, $8nGP5.useState)([]);
    const [scoreSelection, setScoreSelection] = (0, $8nGP5.useState)([]);
    const [textSearch, setTextSearch] = (0, $8nGP5.useState)(ui.dealPageNameSearch);
    const [sortSelection, setSortSelection] = (0, $8nGP5.useState)([
        {
            label: ui.dealPageSortOrder === 'newest' ? 'Newest first' : 'Oldest first',
            value: ui.dealPageSortOrder
        }
    ]);
    const setTextSearchDebounce = (0, $fgQ0V.debounce)((text)=>{
        ui.dealPageNameSearch = text;
    }, 300);
    (0, $3e7d8e12b3f432b0$export$4ec57c364807b0e9)('DB_PAGE', ()=>{
        const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        ui.resetHome();
        resetFilters();
    });
    const resetFilters = ()=>{
        setMultiSelectionsIndustry([]);
        setScoreSelection([]);
        setTextSearch('');
        setSortSelection([
            {
                label: 'Newest first',
                value: 'newest'
            }
        ]);
        ui.dealPageNameSearch = '';
        ui.dealPageIndustrySearch = [];
        ui.dealPageScoreSearch = [];
        ui.dealPageSortOrder = 'newest';
    };
    const updateScoreSeletion = (selected)=>{
        setScoreSelection(selected);
    };
    const updateSelectionIndustry = (selected)=>{
        var updated = [];
        selected.slice(0, 3).forEach((selection)=>{
            if (!updated.find((item)=>item.value == selection.value)) updated.push({
                label: selection.label,
                value: selection.value
            });
        });
        setMultiSelectionsIndustry(updated);
    };
    const updateSortSelection = (selected)=>{
        var _a;
        if (selected && selected.length > 0) {
            setSortSelection(selected);
            ui.dealPageSortOrder = ((_a = selected[0]) === null || _a === void 0 ? void 0 : _a.value) || 'newest';
        }
    };
    (0, $8nGP5.useEffect)(()=>{
        const filter = [];
        multiSelectionsIndustry.forEach((selection)=>{
            const [type, value] = selection.value.split(':');
            filter.push({
                type: type == 'CAT' ? 'category' : 'sub_category',
                value: value
            });
        });
        ui.dealPageIndustrySearch = filter;
        ui.dealPageScoreSearch = scoreSelection.map((selection)=>selection.value);
    }, [
        multiSelectionsIndustry,
        scoreSelection
    ]);
    // Calculate filtered deals count
    const getFilteredDealsCount = ()=>{
        if (!store.isLoaded) return 0;
        const dealKeys = Object.keys(store.reportDataDB);
        const filtered = dealKeys.filter((deal)=>{
            const e = store.reportDataDB[deal];
            if (e.status != 'completed') return false;
            const filter_settings = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)().filterCompaniesForDemo;
            if ((0, $8f024b03d9af7c67$export$30eb9424ed49720f)().isDemoFilterOn && filter_settings != null) {
                if (filter_settings[deal] !== true) return false;
            }
            const dataAccess = store.createDataAccess(deal);
            const companyName = dataAccess.companyName;
            const matchCompanyName = companyName.toLowerCase().includes(ui.dealPageNameSearch.toLowerCase()) || ui.dealPageNameSearch == '';
            const filter = ui.dealPageIndustrySearch;
            const industry = dataAccess.value('industry');
            const sub_industry = dataAccess.value('industrySubType');
            let matchIndustry = false;
            if (filter.length == 0) matchIndustry = true;
            else filter.forEach((filterItem)=>{
                if (filterItem.type == 'category') {
                    if (filterItem.value == industry) matchIndustry = true;
                } else if (filterItem.type == 'sub_category') {
                    if (filterItem.value == sub_industry) matchIndustry = true;
                }
            });
            // Score filtering
            let matchScore = true;
            if (scoreSelection.length > 0 && !scoreSelection.find((s)=>s.value === 'All')) {
                const score = dataAccess.value('cim_score');
                const scoreValue = parseInt((score === null || score === void 0 ? void 0 : score.toString()) || '0');
                matchScore = scoreSelection.some((selection)=>{
                    if (selection.value === 'Strong') return scoreValue > 85;
                    if (selection.value === 'Medium') return scoreValue > 55 && scoreValue <= 85;
                    if (selection.value === 'Weak') return scoreValue <= 55;
                    return false;
                });
            }
            return matchCompanyName && matchIndustry && matchScore;
        });
        return filtered.length;
    };
    if (!store.isLoaded) return null;
    function filterBy(option, ticker) {
        return option.label.toLowerCase().indexOf(ticker.text.toLowerCase()) > -1;
    }
    function filterByReturnAll(option, ticker) {
        return true;
    }
    const braileSpacing = "\u2800  ";
    var options_score = [
        {
            label: 'All',
            value: 'All'
        },
        {
            label: 'Strong',
            value: 'Strong'
        },
        {
            label: 'Medium',
            value: 'Medium'
        },
        {
            label: 'Weak',
            value: 'Weak'
        }
    ];
    var options_sort = [
        {
            label: 'Newest first',
            value: 'newest'
        },
        {
            label: 'Oldest first',
            value: 'oldest'
        }
    ];
    var options = [];
    const industry = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)().industryTypes;
    industry.forEach((industry)=>{
        var name = industry.name;
        options.push({
            label: name,
            value: 'CAT:' + name,
            industry: name,
            type: 'category'
        });
        industry.subtypes.forEach((sub_industry)=>{
            options.push({
                label: braileSpacing + sub_industry.name,
                value: 'SUB:' + sub_industry.name,
                industry: name,
                type: 'subcategory'
            });
        });
    });
    function groupBy(list, keyGetter) {
        const map = {};
        list.forEach((item)=>{
            const key = keyGetter(item);
            if (!map.hasOwnProperty(key)) map[key] = [];
            map[key].push(item);
        });
        return map;
    }
    var typeahead_props = {};
    typeahead_props['renderMenu'] = (results, _a, state)=>{
        var { newSelectionPrefix: newSelectionPrefix, paginationText: paginationText, renderMenuItemChildren: renderMenuItemChildren } = _a, menuProps = $959d475eae63db88$var$__rest(_a, [
            "newSelectionPrefix",
            "paginationText",
            "renderMenuItemChildren"
        ]);
        let index = 0;
        const list = groupBy(results, (a)=>a.industry);
        const items = Object.keys(list).sort().map((region)=>{
            var subitems = list[region];
            var header = (0, $kSbwP.jsx)((0, $6dc2979d3137cf1b$export$2e2bcd8739ae039).Header, {
                children: region
            });
            if (subitems[0].label == region) header = null;
            return (0, $kSbwP.jsxs)((0, $8nGP5.Fragment), {
                children: [
                    index !== 0 && (0, $kSbwP.jsx)((0, $6dc2979d3137cf1b$export$2e2bcd8739ae039).Divider, {}),
                    header,
                    subitems.map((i)=>{
                        var isSelected = multiSelectionsIndustry.find((a)=>a.value == i.value);
                        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
                            [$3e1bb84537f03bf0$export$d90250155de6d7e7]: isSelected
                        });
                        const item = (0, $kSbwP.jsx)((0, $0e525f254146d1c8$export$2e2bcd8739ae039), {
                            option: i,
                            position: index,
                            className: cls,
                            children: (0, $kSbwP.jsx)((0, $116510c3d59e0b2a$export$2e2bcd8739ae039), {
                                search: state.text,
                                children: i.label
                            })
                        }, index);
                        index += 1;
                        return item;
                    })
                ]
            }, region);
        });
        return (0, $kSbwP.jsx)((0, $6dc2979d3137cf1b$export$2e2bcd8739ae039), Object.assign({}, menuProps, {
            children: items
        }));
    };
    const filteredDealsCount = getFilteredDealsCount();
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        className: $3e1bb84537f03bf0$export$38e42c68cf43b5d4,
        justify: "start",
        children: [
            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "row",
                className: $3e1bb84537f03bf0$export$f2ea4ab276c3e3fa,
                children: [
                    (0, $kSbwP.jsxs)("div", {
                        className: $3e1bb84537f03bf0$export$35b074988b073474,
                        children: [
                            (0, $kSbwP.jsxs)("div", {
                                className: $3e1bb84537f03bf0$export$33fcfcc28f93a08d,
                                children: [
                                    (0, $kSbwP.jsx)("input", {
                                        type: "text",
                                        className: $3e1bb84537f03bf0$export$d76128d007d19019,
                                        value: textSearch,
                                        onInput: (e)=>{
                                            setTextSearch(e.currentTarget.value);
                                            setTextSearchDebounce(e.currentTarget.value);
                                        },
                                        placeholder: "Search"
                                    }),
                                    (0, $kSbwP.jsx)("i", {
                                        className: `bi bi-search ${$3e1bb84537f03bf0$export$8687ffcdea58e000}`
                                    })
                                ]
                            }),
                            (0, $kSbwP.jsx)("div", {
                                className: $3e1bb84537f03bf0$export$e8c9778bf415dd08
                            }),
                            (0, $kSbwP.jsxs)("div", {
                                className: $3e1bb84537f03bf0$export$37c8efd0a1d7c4c5,
                                children: [
                                    (0, $kSbwP.jsx)((0, $987409511f795a07$export$2e2bcd8739ae039), Object.assign({}, typeahead_props, {
                                        id: "industry-search",
                                        className: $3e1bb84537f03bf0$export$37c8efd0a1d7c4c5,
                                        filterBy: filterBy,
                                        options: options,
                                        placeholder: "Select industry",
                                        onChange: updateSelectionIndustry,
                                        selected: multiSelectionsIndustry,
                                        multiple: true
                                    })),
                                    (0, $kSbwP.jsx)("i", {
                                        className: `bi bi-chevron-down ${$3e1bb84537f03bf0$export$b7f029de53087ca2}`
                                    })
                                ]
                            }),
                            (0, $kSbwP.jsxs)("div", {
                                className: $3e1bb84537f03bf0$export$a72e403537378b74,
                                children: [
                                    (0, $kSbwP.jsx)((0, $987409511f795a07$export$2e2bcd8739ae039), {
                                        id: "score-search",
                                        filterBy: filterByReturnAll,
                                        className: $3e1bb84537f03bf0$export$a72e403537378b74,
                                        options: options_score,
                                        placeholder: "Deal scores: 0-100",
                                        onChange: updateScoreSeletion,
                                        selected: scoreSelection
                                    }),
                                    (0, $kSbwP.jsx)("i", {
                                        className: `bi bi-chevron-down ${$3e1bb84537f03bf0$export$b7f029de53087ca2}`
                                    })
                                ]
                            }),
                            (0, $kSbwP.jsx)("button", {
                                className: $3e1bb84537f03bf0$export$69181d24bfc61261,
                                onClick: resetFilters,
                                children: "Reset filters"
                            })
                        ]
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $3e1bb84537f03bf0$export$337b552c20a93b34,
                        children: (0, $kSbwP.jsxs)("div", {
                            className: $3e1bb84537f03bf0$export$8427e1cdd60dbd47,
                            children: [
                                (0, $kSbwP.jsx)((0, $987409511f795a07$export$2e2bcd8739ae039), {
                                    id: "sort-select",
                                    filterBy: filterByReturnAll,
                                    className: $3e1bb84537f03bf0$export$d174ec83970e3502,
                                    options: options_sort,
                                    placeholder: "Newest first",
                                    onChange: updateSortSelection,
                                    selected: sortSelection
                                }),
                                (0, $kSbwP.jsx)("i", {
                                    className: `bi bi-chevron-down ${$3e1bb84537f03bf0$export$b7f029de53087ca2}`
                                })
                            ]
                        })
                    })
                ]
            }),
            (0, $kSbwP.jsxs)("div", {
                className: $3e1bb84537f03bf0$export$d0cd57123140c470,
                children: [
                    filteredDealsCount,
                    " deals shown"
                ]
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");

var $kSbwP = parcelRequire("kSbwP");


var $6843beb2b4fdf546$export$1ca1ec8b29a4ce27;
var $6843beb2b4fdf546$export$b1e2ee34456f92d3;
var $6843beb2b4fdf546$export$6b75a9690b36aa74;
var $6843beb2b4fdf546$export$6f093cfa640b7166;
$6843beb2b4fdf546$export$1ca1ec8b29a4ce27 = `KZ9tcG_icon`;
$6843beb2b4fdf546$export$b1e2ee34456f92d3 = `KZ9tcG_numberScore`;
$6843beb2b4fdf546$export$6b75a9690b36aa74 = `KZ9tcG_scoreBox`;
$6843beb2b4fdf546$export$6f093cfa640b7166 = `KZ9tcG_text`;



const $33ac36ca38f3f8d0$export$5fb755babf77fa30 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    var icon = 'bi bi-check';
    var text = 'Strong';
    var color = '#00A171';
    var showScore = true;
    if (p.score == null) debugger;
    var score = parseInt(p.score.toString());
    //temp hack
    //score = 90;
    //temp hack
    var scoreDisplay = score.toString();
    if (score > 85) ;
    else if (p.score == -1) {
        icon = 'bi bi-dash';
        text = 'No Data';
        color = '#6C757D';
        scoreDisplay = '--';
    } else if (score > 55) {
        //Medium
        icon = 'bi bi-dash';
        text = 'Med';
        color = '#FF9F00';
    } else {
        icon = 'bi bi-x';
        text = 'Weak';
        color = '#DD2222';
    }
    // Check if we should show dots instead of score
    const shouldShowDots = p.score == -1 || isNaN(score);
    const finalScoreDisplay = shouldShowDots ? '...' : scoreDisplay;
    var iconCls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('bi', icon, $6843beb2b4fdf546$export$1ca1ec8b29a4ce27);
    //scoreDisplay = 'TBD'
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        className: $6843beb2b4fdf546$export$6b75a9690b36aa74 + ' ' + p.className,
        style: {
            backgroundColor: color
        },
        justify: "between",
        alignItems: "center",
        children: [
            (0, $kSbwP.jsx)("i", {
                className: iconCls
            }),
            (0, $kSbwP.jsx)("div", {
                className: $6843beb2b4fdf546$export$6f093cfa640b7166,
                children: text
            }),
            (0, $kSbwP.jsx)("div", {
                className: $6843beb2b4fdf546$export$b1e2ee34456f92d3,
                style: {
                    color: color
                },
                children: finalScoreDisplay
            })
        ]
    });
//<div>{p.score}</div>;
});







var $1a071b47cc920250$export$e8c9778bf415dd08;
var $1a071b47cc920250$export$9cc28892e1853afe;
var $1a071b47cc920250$export$e7b177dbdcaed6bd;
var $1a071b47cc920250$export$3a3c5c2f733d37e3;
var $1a071b47cc920250$export$d9696ccac9d85db1;
var $1a071b47cc920250$export$8b09bce1e89c2f21;
var $1a071b47cc920250$export$7a2e7b3d8095518a;
var $1a071b47cc920250$export$d049a13fc4149044;
var $1a071b47cc920250$export$f3cbcc6ad82435d7;
var $1a071b47cc920250$export$e55b6242cf16bbb8;
var $1a071b47cc920250$export$becc9140d0e846f8;
var $1a071b47cc920250$export$fb184b623420d9be;
$1a071b47cc920250$export$e8c9778bf415dd08 = `_4we_0W_divider`;
$1a071b47cc920250$export$9cc28892e1853afe = `_4we_0W_fieldContainer`;
$1a071b47cc920250$export$e7b177dbdcaed6bd = `_4we_0W_fieldTitle`;
$1a071b47cc920250$export$3a3c5c2f733d37e3 = `_4we_0W_fieldValue`;
$1a071b47cc920250$export$d9696ccac9d85db1 = `_4we_0W_imageThumbLoading`;
$1a071b47cc920250$export$8b09bce1e89c2f21 = `_4we_0W_imageThumbnail`;
$1a071b47cc920250$export$7a2e7b3d8095518a = `_4we_0W_imageThumbnailContainer`;
$1a071b47cc920250$export$d049a13fc4149044 = `_4we_0W_industry`;
$1a071b47cc920250$export$f3cbcc6ad82435d7 = `_4we_0W_overview`;
$1a071b47cc920250$export$e55b6242cf16bbb8 = `_4we_0W_score`;
$1a071b47cc920250$export$becc9140d0e846f8 = `_4we_0W_thumb`;
$1a071b47cc920250$export$fb184b623420d9be = `_4we_0W_title`;



var $8nGP5 = parcelRequire("8nGP5");

var $63ebe9e92d041dc9$exports = {};
$63ebe9e92d041dc9$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":696,\"op\":762,\"w\":600,\"h\":600,\"nm\":\"Final\",\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ind\":3,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[200,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":20,\"op\":1520,\"st\":20},{\"ind\":4,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[250,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":30,\"op\":1530,\"st\":30},{\"ind\":5,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":40,\"op\":1540,\"st\":40},{\"ind\":6,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[350,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":50,\"op\":1550,\"st\":50},{\"ind\":7,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[400,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":60,\"op\":1560,\"st\":60},{\"ind\":8,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[450,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":70,\"op\":1570,\"st\":70},{\"ind\":9,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[500,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":80,\"op\":1580,\"st\":80}]},{\"id\":\"comp_1\",\"layers\":[{\"ind\":1,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":632,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":645,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":657,\"s\":[30]},{\"t\":680,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,415,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1.298]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,0.845]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.057]},\"t\":632,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.645]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0.143]},\"t\":645,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":657,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":699,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":714,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":726,\"s\":[100,100,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0},{\"ind\":2,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":680,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":697,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":710,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":722,\"s\":[30]},{\"t\":745,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,171,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":634,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":647,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":659,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":697,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":710,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":722,\"s\":[55,55,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":-65,\"op\":1435,\"st\":-65}]},{\"id\":\"comp_2\",\"layers\":[{\"ind\":1,\"ty\":4,\"nm\":\"Round 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-74,-14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[129,129,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[60,60]},\"p\":{\"a\":0,\"k\":[0,0]},\"nm\":\"Ellipse Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.831,0.851,0.878,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-74,-14]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\"}],\"ip\":0,\"op\":1500,\"st\":0}]}],\"layers\":[{\"ind\":2,\"ty\":0,\"nm\":\"sequance\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[248,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0}],\"markers\":[]}");


const $9e54bdf16921cff4$export$fe8b4069b38236f9 = ()=>{
    return (0, $kSbwP.jsx)("div", {
        className: $1a071b47cc920250$export$becc9140d0e846f8,
        style: {
            visibility: 'hidden'
        }
    });
};
const $9e54bdf16921cff4$export$ec96aade4c78ed16 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const clientStore = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const [isImgLoaded, setIsImgLoaded] = (0, $8nGP5.useState)(0);
    const defaultOptionsLottie = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($63ebe9e92d041dc9$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    const query = store.createDataAccess(p.name);
    const companyName = query.companyName;
    const year = query.actualYear();
    const rev = query.valueByYear('net_revenue_per_year', year);
    const ebitda = query.selectedEbitda(year);
    const companyDesc = query.value('company_overview_short');
    const industry = query.value('industry');
    const sub_industry = query.value('industrySubType');
    const thumb = query.value('thumb');
    const metaFields = [
        {
            label: 'Revenue ($M)',
            value: (0, $7fbd760f3c05e83d$export$48d3f001ea9fddb0)(rev.toString())
        },
        {
            label: 'Adj. EBITDA ($M)',
            value: (0, $7fbd760f3c05e83d$export$48d3f001ea9fddb0)(ebitda.toString())
        },
        {
            label: 'CEO',
            value: query.value('company_ceo')
        },
        {
            label: 'Founded',
            value: query.value('year_founded')
        }
    ];
    const industry_display = industry + (clientStore.showSubIndustryInHeader ? ` - ${sub_industry}` : '');
    return (0, $kSbwP.jsx)("div", {
        className: $1a071b47cc920250$export$becc9140d0e846f8,
        onClick: ()=>{
            navUtils.toReport(p.name);
        },
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $1a071b47cc920250$export$fb184b623420d9be,
                    children: companyName
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $1a071b47cc920250$export$d049a13fc4149044,
                    children: industry_display
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $1a071b47cc920250$export$e8c9778bf415dd08
                }),
                clientStore.showAggregateScores && (0, $kSbwP.jsx)((0, $33ac36ca38f3f8d0$export$5fb755babf77fa30), {
                    score: query.score(),
                    className: $1a071b47cc920250$export$e55b6242cf16bbb8
                }),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    justify: "between",
                    children: [
                        (0, $kSbwP.jsx)("div", {
                            className: $1a071b47cc920250$export$f3cbcc6ad82435d7,
                            children: companyDesc
                        }),
                        (0, $kSbwP.jsxs)("div", {
                            className: $1a071b47cc920250$export$7a2e7b3d8095518a,
                            children: [
                                isImgLoaded == 0 && (0, $kSbwP.jsx)("div", {
                                    className: $1a071b47cc920250$export$d9696ccac9d85db1,
                                    children: (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
                                        options: defaultOptionsLottie,
                                        height: 150,
                                        width: 200
                                    })
                                }),
                                (0, $kSbwP.jsx)("img", {
                                    src: thumb,
                                    className: $1a071b47cc920250$export$8b09bce1e89c2f21,
                                    style: {
                                        opacity: isImgLoaded
                                    },
                                    onLoad: ()=>setIsImgLoaded(1)
                                })
                            ]
                        })
                    ]
                }),
                (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    style: {
                        position: 'absolute',
                        bottom: '30px',
                        width: '100%',
                        padding: '0 20px 0 0px',
                        maxHeight: '50px'
                    },
                    justify: "between",
                    children: metaFields.map((field, index)=>{
                        return (0, $kSbwP.jsxs)("div", {
                            className: $1a071b47cc920250$export$9cc28892e1853afe,
                            children: [
                                (0, $kSbwP.jsx)("div", {
                                    className: $1a071b47cc920250$export$e7b177dbdcaed6bd,
                                    children: field.label
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    className: $1a071b47cc920250$export$3a3c5c2f733d37e3,
                                    children: field.value
                                })
                            ]
                        }, field.label);
                    })
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");

var $f103a063e33ca209$export$34e0f9847d4c02dd;
var $f103a063e33ca209$export$acf4eaf431084f78;
var $f103a063e33ca209$export$a8ecead220dd38a6;
var $f103a063e33ca209$export$8687ffcdea58e000;
var $f103a063e33ca209$export$fb184b623420d9be;
$f103a063e33ca209$export$34e0f9847d4c02dd = `Fn-vjq_container`;
$f103a063e33ca209$export$acf4eaf431084f78 = `Fn-vjq_iconContainer`;
$f103a063e33ca209$export$a8ecead220dd38a6 = `Fn-vjq_message`;
$f103a063e33ca209$export$8687ffcdea58e000 = `Fn-vjq_searchIcon`;
$f103a063e33ca209$export$fb184b623420d9be = `Fn-vjq_title`;


const $14155747c992a779$export$c9765147a8dd7e5d = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    return (0, $kSbwP.jsxs)("div", {
        className: $f103a063e33ca209$export$34e0f9847d4c02dd,
        children: [
            (0, $kSbwP.jsx)("div", {
                className: $f103a063e33ca209$export$acf4eaf431084f78,
                children: (0, $kSbwP.jsx)("i", {
                    className: `bi bi-search ${$f103a063e33ca209$export$8687ffcdea58e000}`
                })
            }),
            (0, $kSbwP.jsx)("div", {
                className: $f103a063e33ca209$export$fb184b623420d9be,
                children: "No Results Found"
            }),
            (0, $kSbwP.jsx)("div", {
                className: $f103a063e33ca209$export$a8ecead220dd38a6,
                children: "Your search is too narrow. Try adjusting the filters or search parameters."
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");




var $71285a979481ea35$export$b7e3ae3d7c15e42e;
var $71285a979481ea35$export$becc9140d0e846f8;
var $71285a979481ea35$export$fb184b623420d9be;
var $71285a979481ea35$export$c6e11f163cc2dc47;
var $71285a979481ea35$export$eccddd504975e05d;
var $71285a979481ea35$export$743fdfb094991ec6;
$71285a979481ea35$export$b7e3ae3d7c15e42e = `_9ntroq_input`;
$71285a979481ea35$export$becc9140d0e846f8 = `_9ntroq_thumb`;
$71285a979481ea35$export$fb184b623420d9be = `_9ntroq_title`;
$71285a979481ea35$export$c6e11f163cc2dc47 = `_9ntroq_trashIcon`;
$71285a979481ea35$export$eccddd504975e05d = `_9ntroq_unlock`;
$71285a979481ea35$export$743fdfb094991ec6 = `_9ntroq_unlockIcon`;



var $8nGP5 = parcelRequire("8nGP5");



var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");

var $ebCsu = parcelRequire("ebCsu");

var $kSbwP = parcelRequire("kSbwP");
const $bc9387ca5ea26558$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).elementType
};
const $bc9387ca5ea26558$var$Feedback = /*#__PURE__*/ $8nGP5.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$bc9387ca5ea26558$var$Feedback.displayName = 'Feedback';
$bc9387ca5ea26558$var$Feedback.propTypes = $bc9387ca5ea26558$var$propTypes;
var $bc9387ca5ea26558$export$2e2bcd8739ae039 = $bc9387ca5ea26558$var$Feedback;




var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
"use client";
// TODO
const $e89449ff687fa1de$var$FormContext = /*#__PURE__*/ $8nGP5.createContext({});
var $e89449ff687fa1de$export$2e2bcd8739ae039 = $e89449ff687fa1de$var$FormContext;




var $kSbwP = parcelRequire("kSbwP");
"use client";
const $f4db4795cc64fa87$var$FormCheckInput = /*#__PURE__*/ $8nGP5.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $e89449ff687fa1de$export$2e2bcd8739ae039));
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$f4db4795cc64fa87$var$FormCheckInput.displayName = 'FormCheckInput';
var $f4db4795cc64fa87$export$2e2bcd8739ae039 = $f4db4795cc64fa87$var$FormCheckInput;




var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $15dcfa89131833bf$var$FormCheckLabel = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $e89449ff687fa1de$export$2e2bcd8739ae039));
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $kSbwP.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix)
    });
});
$15dcfa89131833bf$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $15dcfa89131833bf$export$2e2bcd8739ae039 = $15dcfa89131833bf$var$FormCheckLabel;





var $8nGP5 = parcelRequire("8nGP5");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $53f1ebcf35f12b2a$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $8nGP5.Children.map(children, (child)=>/*#__PURE__*/ $8nGP5.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $53f1ebcf35f12b2a$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $8nGP5.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $8nGP5.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $53f1ebcf35f12b2a$export$500fd6099226ffae(children, type) {
    return $8nGP5.Children.toArray(children).some((child)=>/*#__PURE__*/ $8nGP5.isValidElement(child) && child.type === type);
}



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $a117487a7494adb3$var$FormCheck = /*#__PURE__*/ $8nGP5.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $e89449ff687fa1de$export$2e2bcd8739ae039));
    const innerFormContext = (0, $8nGP5.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $53f1ebcf35f12b2a$export$500fd6099226ffae)(children, (0, $15dcfa89131833bf$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $kSbwP.jsx)((0, $f4db4795cc64fa87$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $e89449ff687fa1de$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $kSbwP.jsx)((0, $15dcfa89131833bf$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $kSbwP.jsx)((0, $bc9387ca5ea26558$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$a117487a7494adb3$var$FormCheck.displayName = 'FormCheck';
var $a117487a7494adb3$export$2e2bcd8739ae039 = Object.assign($a117487a7494adb3$var$FormCheck, {
    Input: (0, $f4db4795cc64fa87$export$2e2bcd8739ae039),
    Label: (0, $15dcfa89131833bf$export$2e2bcd8739ae039)
});




var $8nGP5 = parcelRequire("8nGP5");





var $kSbwP = parcelRequire("kSbwP");
"use client";
const $d77f2d38da70d86f$var$FormControl = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $e89449ff687fa1de$export$2e2bcd8739ae039));
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$d77f2d38da70d86f$var$FormControl.displayName = 'FormControl';
var $d77f2d38da70d86f$export$2e2bcd8739ae039 = Object.assign($d77f2d38da70d86f$var$FormControl, {
    Feedback: $bc9387ca5ea26558$export$2e2bcd8739ae039
});



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $3558c385b1dedbf8$var$FormFloating = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$3558c385b1dedbf8$var$FormFloating.displayName = 'FormFloating';
var $3558c385b1dedbf8$export$2e2bcd8739ae039 = $3558c385b1dedbf8$var$FormFloating;



var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
const $5e4fe7230df0a2a2$var$FormGroup = /*#__PURE__*/ $8nGP5.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $8nGP5.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $e89449ff687fa1de$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$5e4fe7230df0a2a2$var$FormGroup.displayName = 'FormGroup';
var $5e4fe7230df0a2a2$export$2e2bcd8739ae039 = $5e4fe7230df0a2a2$var$FormGroup;




var $8nGP5 = parcelRequire("8nGP5");



var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
"use client";
function $3122a95e939cfe17$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $58df59260255f5cd$export$8970c8db816a5863)();
    const minBreakpoint = (0, $58df59260255f5cd$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $3122a95e939cfe17$var$Col = /*#__PURE__*/ $8nGP5.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $3122a95e939cfe17$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, !spans.length && bsPrefix)
    });
});
$3122a95e939cfe17$var$Col.displayName = 'Col';
var $3122a95e939cfe17$export$2e2bcd8739ae039 = $3122a95e939cfe17$var$Col;





var $kSbwP = parcelRequire("kSbwP");
"use client";
const $8d0906f46b886d5d$var$FormLabel = /*#__PURE__*/ $8nGP5.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $e89449ff687fa1de$export$2e2bcd8739ae039));
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $3122a95e939cfe17$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$8d0906f46b886d5d$var$FormLabel.displayName = 'FormLabel';
var $8d0906f46b886d5d$export$2e2bcd8739ae039 = $8d0906f46b886d5d$var$FormLabel;




var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $89828b6da7a4c682$var$FormRange = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $e89449ff687fa1de$export$2e2bcd8739ae039));
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $kSbwP.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$89828b6da7a4c682$var$FormRange.displayName = 'FormRange';
var $89828b6da7a4c682$export$2e2bcd8739ae039 = $89828b6da7a4c682$var$FormRange;




var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $c1b07a5103616b39$var$FormSelect = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $e89449ff687fa1de$export$2e2bcd8739ae039));
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $kSbwP.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$c1b07a5103616b39$var$FormSelect.displayName = 'FormSelect';
var $c1b07a5103616b39$export$2e2bcd8739ae039 = $c1b07a5103616b39$var$FormSelect;




var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
"use client";
const $427b06f9f9e452b1$var$FormText = /*#__PURE__*/ $8nGP5.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$427b06f9f9e452b1$var$FormText.displayName = 'FormText';
var $427b06f9f9e452b1$export$2e2bcd8739ae039 = $427b06f9f9e452b1$var$FormText;



var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
const $c5c11c0f1565ca8f$var$Switch = /*#__PURE__*/ $8nGP5.forwardRef((props, ref)=>/*#__PURE__*/ (0, $kSbwP.jsx)((0, $a117487a7494adb3$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$c5c11c0f1565ca8f$var$Switch.displayName = 'Switch';
var $c5c11c0f1565ca8f$export$2e2bcd8739ae039 = Object.assign($c5c11c0f1565ca8f$var$Switch, {
    Input: (0, $a117487a7494adb3$export$2e2bcd8739ae039).Input,
    Label: (0, $a117487a7494adb3$export$2e2bcd8739ae039).Label
});




var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $3ec65164fed4e5bd$var$FloatingLabel = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $kSbwP.jsxs)((0, $5e4fe7230df0a2a2$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $kSbwP.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$3ec65164fed4e5bd$var$FloatingLabel.displayName = 'FloatingLabel';
var $3ec65164fed4e5bd$export$2e2bcd8739ae039 = $3ec65164fed4e5bd$var$FloatingLabel;



var $kSbwP = parcelRequire("kSbwP");
const $ca5560d48e2c2703$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).elementType
};
const $ca5560d48e2c2703$var$Form = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, validated && 'was-validated')
    }));
$ca5560d48e2c2703$var$Form.displayName = 'Form';
$ca5560d48e2c2703$var$Form.propTypes = $ca5560d48e2c2703$var$propTypes;
var $ca5560d48e2c2703$export$2e2bcd8739ae039 = Object.assign($ca5560d48e2c2703$var$Form, {
    Group: (0, $5e4fe7230df0a2a2$export$2e2bcd8739ae039),
    Control: (0, $d77f2d38da70d86f$export$2e2bcd8739ae039),
    Floating: (0, $3558c385b1dedbf8$export$2e2bcd8739ae039),
    Check: (0, $a117487a7494adb3$export$2e2bcd8739ae039),
    Switch: $c5c11c0f1565ca8f$export$2e2bcd8739ae039,
    Label: (0, $8d0906f46b886d5d$export$2e2bcd8739ae039),
    Text: (0, $427b06f9f9e452b1$export$2e2bcd8739ae039),
    Range: (0, $89828b6da7a4c682$export$2e2bcd8739ae039),
    Select: (0, $c1b07a5103616b39$export$2e2bcd8739ae039),
    FloatingLabel: $3ec65164fed4e5bd$export$2e2bcd8739ae039
});



var $8nGP5 = parcelRequire("8nGP5");



var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $0bb8eb2689c12e18$var$context = /*#__PURE__*/ $8nGP5.createContext(null);
$0bb8eb2689c12e18$var$context.displayName = 'InputGroupContext';
var $0bb8eb2689c12e18$export$2e2bcd8739ae039 = $0bb8eb2689c12e18$var$context;



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $9cf96e17a2503ae3$var$InputGroupText = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$9cf96e17a2503ae3$var$InputGroupText.displayName = 'InputGroupText';
var $9cf96e17a2503ae3$export$2e2bcd8739ae039 = $9cf96e17a2503ae3$var$InputGroupText;



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $211c12844a90c093$var$InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, $kSbwP.jsx)((0, $9cf96e17a2503ae3$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $f4db4795cc64fa87$export$2e2bcd8739ae039), {
            type: "checkbox",
            ...props
        })
    });
const $211c12844a90c093$var$InputGroupRadio = (props)=>/*#__PURE__*/ (0, $kSbwP.jsx)((0, $9cf96e17a2503ae3$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $f4db4795cc64fa87$export$2e2bcd8739ae039), {
            type: "radio",
            ...props
        })
    });
const $211c12844a90c093$var$InputGroup = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, size: size, hasValidation: hasValidation, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, $8nGP5.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $0bb8eb2689c12e18$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        })
    });
});
$211c12844a90c093$var$InputGroup.displayName = 'InputGroup';
var $211c12844a90c093$export$2e2bcd8739ae039 = Object.assign($211c12844a90c093$var$InputGroup, {
    Text: (0, $9cf96e17a2503ae3$export$2e2bcd8739ae039),
    Radio: $211c12844a90c093$var$InputGroupRadio,
    Checkbox: $211c12844a90c093$var$InputGroupCheckbox
});


const $5f2582552430e6bc$export$57d7964eb05a4d4e = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const pdfPasswordRef = (0, $8nGP5.useRef)(null);
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const deal = store.reportDataDB[p.jobId];
    if (!deal) return null;
    return (0, $kSbwP.jsx)("div", {
        className: $71285a979481ea35$export$becc9140d0e846f8,
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            justify: "between",
            alignItems: "center",
            direction: "column",
            fillCell: true,
            style: {
                padding: '10px 0px'
            },
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $71285a979481ea35$export$fb184b623420d9be,
                    children: deal.errorText
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $71285a979481ea35$export$fb184b623420d9be,
                    style: {
                        fontSize: '30px'
                    },
                    children: deal === null || deal === void 0 ? void 0 : deal.pdf
                }),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    fillCell: true,
                    style: {
                        maxHeight: '40px',
                        padding: '0px 10px'
                    },
                    children: [
                        (0, $kSbwP.jsxs)((0, $211c12844a90c093$export$2e2bcd8739ae039), {
                            children: [
                                (0, $kSbwP.jsx)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039).Control, {
                                    className: $71285a979481ea35$export$b7e3ae3d7c15e42e,
                                    placeholder: "PDF Unlock password?",
                                    "aria-label": "PDF Unlock password?",
                                    ref: pdfPasswordRef
                                }),
                                (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                    className: $71285a979481ea35$export$eccddd504975e05d,
                                    onClick: ()=>{
                                        var _a;
                                        const pass = pdfPasswordRef.current.value;
                                        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                                        const pdf = (_a = store.reportDataDB[p.jobId]) === null || _a === void 0 ? void 0 : _a.pdf;
                                        fb.add_job(pdf, pass, p.jobId);
                                    },
                                    children: (0, $kSbwP.jsx)("i", {
                                        className: 'bi bi-unlock ' + $71285a979481ea35$export$743fdfb094991ec6
                                    })
                                })
                            ]
                        }),
                        (0, $kSbwP.jsx)("i", {
                            className: 'bi bi-trash ' + $71285a979481ea35$export$c6e11f163cc2dc47,
                            onClick: ()=>{
                                const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                                const yesNo = confirm('Are you sure you want to delete this report?');
                                if (yesNo) fb.deleteReport(p.jobId);
                            }
                        })
                    ]
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");
const $e6c16966fa3d22d4$export$f2b96e571871cea1 = (scrollRef, uiStore, scrollSpeed = 100)=>{
    const scrollInterval = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(()=>{
        const clearTimer = ()=>{
            if (scrollInterval.current) {
                clearInterval(scrollInterval.current);
                scrollInterval.current = null;
            }
        };
        clearTimer();
        if (scrollRef) {
            if (uiStore.scrolling == 'UP') scrollInterval.current = setInterval(()=>{
                if (scrollRef) scrollRef.scrollBy(0, -scrollSpeed);
            }, 50);
            else if (uiStore.scrolling == 'DOWN') scrollInterval.current = setInterval(()=>{
                if (scrollRef) scrollRef.scrollBy(0, scrollSpeed);
            }, 50);
            return ()=>{
                clearTimer();
            };
        }
    }, [
        scrollRef,
        uiStore.scrolling
    ]);
};




var $8nGP5 = parcelRequire("8nGP5");

var $fCKK7 = parcelRequire("fCKK7");
function $cc4347c94e2e0bfc$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    function memoizedFunction() {
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    }
    memoizedFunction.updateDeps = (newDeps)=>{
        deps = newDeps;
    };
    return memoizedFunction;
}
function $cc4347c94e2e0bfc$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $cc4347c94e2e0bfc$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $cc4347c94e2e0bfc$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};


const $4d01f19e09510362$export$76974b428a49f15b = (index)=>index;
const $4d01f19e09510362$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $4d01f19e09510362$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const run = ()=>{
            const entry = entries[0];
            if (entry == null ? void 0 : entry.borderBoxSize) {
                const box = entry.borderBoxSize[0];
                if (box) {
                    handler({
                        width: box.inlineSize,
                        height: box.blockSize
                    });
                    return;
                }
            }
            handler(element.getBoundingClientRect());
        };
        instance.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $4d01f19e09510362$var$addEventListenerOptions = {
    passive: true
};
const $4d01f19e09510362$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $4d01f19e09510362$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $4d01f19e09510362$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $4d01f19e09510362$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = instance.options.useScrollendEvent && $4d01f19e09510362$var$supportsScrollend ? ()=>void 0 : (0, $cc4347c94e2e0bfc$export$61fc7d43ac8f84b0)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $4d01f19e09510362$var$addEventListenerOptions);
    const registerScrollendEvent = instance.options.useScrollendEvent && $4d01f19e09510362$var$supportsScrollend;
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $4d01f19e09510362$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
    };
};
const $4d01f19e09510362$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = instance.options.useScrollendEvent && $4d01f19e09510362$var$supportsScrollend ? ()=>void 0 : (0, $cc4347c94e2e0bfc$export$61fc7d43ac8f84b0)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $4d01f19e09510362$var$addEventListenerOptions);
    const registerScrollendEvent = instance.options.useScrollendEvent && $4d01f19e09510362$var$supportsScrollend;
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $4d01f19e09510362$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
    };
};
const $4d01f19e09510362$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $4d01f19e09510362$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $4d01f19e09510362$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $4d01f19e09510362$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        const run = ()=>{
                            this._measureElement(entry.target, entry);
                        };
                        this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $4d01f19e09510362$export$76974b428a49f15b,
                rangeExtractor: $4d01f19e09510362$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $4d01f19e09510362$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                useScrollendEvent: false,
                useAnimationFrameWithResizeObserver: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset(),
                this.options.lanes
            ], (measurements, outerSize, scrollOffset, lanes)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $4d01f19e09510362$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset,
                lanes: lanes
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualIndexes = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>{
            let startIndex = null;
            let endIndex = null;
            const range = this.calculateRange();
            if (range) {
                startIndex = range.startIndex;
                endIndex = range.endIndex;
            }
            this.maybeNotify.updateDeps([
                this.isScrolling,
                startIndex,
                endIndex
            ]);
            return [
                this.options.rangeExtractor,
                this.options.overscan,
                this.options.count,
                startIndex,
                endIndex
            ];
        }, (rangeExtractor, overscan, count, startIndex, endIndex)=>{
            return startIndex === null || endIndex === null ? [] : rangeExtractor({
                startIndex: startIndex,
                endIndex: endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>[
                this.getVirtualIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $cc4347c94e2e0bfc$export$9a1adf421b69c6a)(measurements[$4d01f19e09510362$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $cc4347c94e2e0bfc$export$9a1adf421b69c6a)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align, itemSize = 0)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") align = toOffset >= scrollOffset + size ? "end" : "start";
            if (align === "center") toOffset += (itemSize - size) / 2;
            else if (align === "end") toOffset -= size;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align, item.size),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $cc4347c94e2e0bfc$export$9a1adf421b69c6a)(this.getOffsetForIndex(index, align));
                    if (!(0, $cc4347c94e2e0bfc$export$8a4f1dcc58a69dbd)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else if (this.options.lanes === 1) end = ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0;
            else {
                const endByLane = Array(this.options.lanes).fill(null);
                let endIndex = measurements.length - 1;
                while(endIndex >= 0 && endByLane.some((val)=>val === null)){
                    const item = measurements[endIndex];
                    if (endByLane[item.lane] === null) endByLane[item.lane] = item.end;
                    endIndex--;
                }
                end = Math.max(...endByLane.filter((val)=>val !== null));
            }
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $4d01f19e09510362$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $4d01f19e09510362$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset, lanes: lanes }) {
    const lastIndex = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    if (measurements.length <= lanes) return {
        startIndex: 0,
        endIndex: lastIndex
    };
    let startIndex = $4d01f19e09510362$var$findNearestBinarySearch(0, lastIndex, getOffset, scrollOffset);
    let endIndex = startIndex;
    if (lanes === 1) while(endIndex < lastIndex && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    else if (lanes > 1) {
        const endPerLane = Array(lanes).fill(0);
        while(endIndex < lastIndex && endPerLane.some((pos)=>pos < scrollOffset + outerSize)){
            const item = measurements[endIndex];
            endPerLane[item.lane] = item.end;
            endIndex++;
        }
        const startPerLane = Array(lanes).fill(scrollOffset + outerSize);
        while(startIndex >= 0 && startPerLane.some((pos)=>pos >= scrollOffset)){
            const item = measurements[startIndex];
            startPerLane[item.lane] = item.start;
            startIndex--;
        }
        startIndex = Math.max(0, startIndex - startIndex % lanes);
        endIndex = Math.min(lastIndex, endIndex + (lanes - 1 - endIndex % lanes));
    }
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}


const $a3a2f7bad3119899$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $8nGP5.useLayoutEffect : $8nGP5.useEffect;
function $a3a2f7bad3119899$var$useVirtualizerBase(options) {
    const rerender = $8nGP5.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $fCKK7.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $8nGP5.useState(()=>new (0, $4d01f19e09510362$export$89be5a243e59c4b2)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $a3a2f7bad3119899$var$useIsomorphicLayoutEffect(()=>{
        return instance._didMount();
    }, []);
    $a3a2f7bad3119899$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $a3a2f7bad3119899$export$dd6d526d88b5a137(options) {
    return $a3a2f7bad3119899$var$useVirtualizerBase({
        observeElementRect: $4d01f19e09510362$export$5a50ff2cde8c3802,
        observeElementOffset: $4d01f19e09510362$export$fbc040aee017375a,
        scrollToFn: (0, $4d01f19e09510362$export$1cdb988e5ab69fe7),
        ...options
    });
}
function $a3a2f7bad3119899$export$645722dcac657cb9(options) {
    return $a3a2f7bad3119899$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $4d01f19e09510362$export$e911b82c7a99311),
        observeElementOffset: (0, $4d01f19e09510362$export$518998f8c5d09287),
        scrollToFn: (0, $4d01f19e09510362$export$2162c5b3eeedd27),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}




var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
function $7e7ca35815405df8$var$g(n, t) {
    let o;
    return (...i)=>{
        window.clearTimeout(o), o = window.setTimeout(()=>n(...i), t);
    };
}
function $7e7ca35815405df8$export$2e2bcd8739ae039({ debounce: n, scroll: t, polyfill: o, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const a = o || (typeof window == "undefined" ? class {
    } : window.ResizeObserver);
    if (!a) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [c, h] = (0, $8nGP5.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), e = (0, $8nGP5.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: c,
        orientationHandler: null
    }), d = n ? typeof n == "number" ? n : n.scroll : null, f = n ? typeof n == "number" ? n : n.resize : null, w = (0, $8nGP5.useRef)(!1);
    (0, $8nGP5.useEffect)(()=>(w.current = !0, ()=>void (w.current = !1)));
    const [z, m, s] = (0, $8nGP5.useMemo)(()=>{
        const r = ()=>{
            if (!e.current.element) return;
            const { left: y, top: C, width: H, height: O, bottom: S, right: x, x: B, y: R } = e.current.element.getBoundingClientRect(), l = {
                left: y,
                top: C,
                width: H,
                height: O,
                bottom: S,
                right: x,
                x: B,
                y: R
            };
            e.current.element instanceof HTMLElement && i && (l.height = e.current.element.offsetHeight, l.width = e.current.element.offsetWidth), Object.freeze(l), w.current && !$7e7ca35815405df8$var$D(e.current.lastBounds, l) && h(e.current.lastBounds = l);
        };
        return [
            r,
            f ? $7e7ca35815405df8$var$g(r, f) : r,
            d ? $7e7ca35815405df8$var$g(r, d) : r
        ];
    }, [
        h,
        i,
        d,
        f
    ]);
    function v() {
        e.current.scrollContainers && (e.current.scrollContainers.forEach((r)=>r.removeEventListener("scroll", s, !0)), e.current.scrollContainers = null), e.current.resizeObserver && (e.current.resizeObserver.disconnect(), e.current.resizeObserver = null), e.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e.current.orientationHandler));
    }
    function b() {
        e.current.element && (e.current.resizeObserver = new a(s), e.current.resizeObserver.observe(e.current.element), t && e.current.scrollContainers && e.current.scrollContainers.forEach((r)=>r.addEventListener("scroll", s, {
                capture: !0,
                passive: !0
            })), e.current.orientationHandler = ()=>{
            s();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e.current.orientationHandler));
    }
    const L = (r)=>{
        !r || r === e.current.element || (v(), e.current.element = r, e.current.scrollContainers = $7e7ca35815405df8$var$E(r), b());
    };
    return $7e7ca35815405df8$var$X(s, !!t), $7e7ca35815405df8$var$W(m), (0, $8nGP5.useEffect)(()=>{
        v(), b();
    }, [
        t,
        s,
        m
    ]), (0, $8nGP5.useEffect)(()=>v, []), [
        L,
        c,
        z
    ];
}
function $7e7ca35815405df8$var$W(n) {
    (0, $8nGP5.useEffect)(()=>{
        const t = n;
        return window.addEventListener("resize", t), ()=>void window.removeEventListener("resize", t);
    }, [
        n
    ]);
}
function $7e7ca35815405df8$var$X(n, t) {
    (0, $8nGP5.useEffect)(()=>{
        if (t) {
            const o = n;
            return window.addEventListener("scroll", o, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", o, !0);
        }
    }, [
        n,
        t
    ]);
}
function $7e7ca35815405df8$var$E(n) {
    const t = [];
    if (!n || n === document.body) return t;
    const { overflow: o, overflowX: i, overflowY: a } = window.getComputedStyle(n);
    return [
        o,
        i,
        a
    ].some((c)=>c === "auto" || c === "scroll") && t.push(n), [
        ...t,
        ...$7e7ca35815405df8$var$E(n.parentElement)
    ];
}
const $7e7ca35815405df8$var$k = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $7e7ca35815405df8$var$D = (n, t)=>$7e7ca35815405df8$var$k.every((o)=>n[o] === t[o]);




const $9a6a933c7ac9e24c$export$1eab25c49fe72a2f = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    const thumbMinSize = 660;
    const parentRef = (0, $8nGP5.useRef)(null);
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const [resizeRef, bounds] = (0, $7e7ca35815405df8$export$2e2bcd8739ae039)();
    const [elementsPerLine, setElementsPerLine] = (0, $8nGP5.useState)(3);
    const deals = [
        ...props.deals
    ];
    const [totalRows, setTotalRows] = (0, $8nGP5.useState)(props.deals.length / elementsPerLine); //Good guess
    const rowVirtualizer = (0, $a3a2f7bad3119899$export$dd6d526d88b5a137)({
        count: totalRows,
        getScrollElement: ()=>parentRef.current,
        estimateSize: (i)=>415,
        overscan: 2
    });
    (0, $e6c16966fa3d22d4$export$f2b96e571871cea1)(parentRef.current, uiStore);
    const totalRowsNeeded = Math.ceil(deals.length / elementsPerLine);
    if (totalRows !== totalRowsNeeded) setTotalRows(totalRowsNeeded);
    if (bounds.width > 0) {
        const expectedElemsPerLine = Math.max(Math.floor(bounds.width / thumbMinSize), 1);
        if (expectedElemsPerLine !== elementsPerLine) setElementsPerLine(expectedElemsPerLine);
    }
    const fillLine = deals.length % elementsPerLine;
    if (elementsPerLine > 1) for(let i = 0; i < elementsPerLine - fillLine; i++)deals.push((0, $kSbwP.jsx)((0, $9e54bdf16921cff4$export$fe8b4069b38236f9), {}, 'empty_' + i.toString()));
    return (0, $kSbwP.jsxs)("div", {
        style: {
            height: 'calc(100vh - 250px)',
            width: 'calc(100% + 20px)'
        },
        children: [
            (0, $kSbwP.jsx)("div", {
                ref: resizeRef,
                style: {
                    width: '100%',
                    height: '1px',
                    position: 'absolute'
                }
            }),
            (0, $kSbwP.jsx)("div", {
                ref: parentRef,
                style: {
                    height: `100%`,
                    width: `100%`,
                    overflow: 'auto',
                    scrollbarColor: ' #eaecf0',
                    scrollbarWidth: 'thin'
                },
                children: (0, $kSbwP.jsx)("div", {
                    style: {
                        height: `${rowVirtualizer.getTotalSize()}px`,
                        width: '100%',
                        position: 'relative'
                    },
                    children: rowVirtualizer.getVirtualItems().map((virtualRow)=>{
                        const dealsElements = [];
                        for(var i = 0; i < elementsPerLine; i++)dealsElements.push(deals[virtualRow.index * elementsPerLine + i]);
                        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            style: {
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: `400px`,
                                transform: `translateY(${virtualRow.start}px)`
                            },
                            children: dealsElements
                        }, virtualRow.index);
                    })
                })
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");





var $91b022b4e06cdbab$export$e8c9778bf415dd08;
var $91b022b4e06cdbab$export$9cc28892e1853afe;
var $91b022b4e06cdbab$export$e7b177dbdcaed6bd;
var $91b022b4e06cdbab$export$3a3c5c2f733d37e3;
var $91b022b4e06cdbab$export$d9696ccac9d85db1;
var $91b022b4e06cdbab$export$8b09bce1e89c2f21;
var $91b022b4e06cdbab$export$7a2e7b3d8095518a;
var $91b022b4e06cdbab$export$d049a13fc4149044;
var $91b022b4e06cdbab$export$f3cbcc6ad82435d7;
var $91b022b4e06cdbab$export$e55b6242cf16bbb8;
var $91b022b4e06cdbab$export$becc9140d0e846f8;
var $91b022b4e06cdbab$export$fb184b623420d9be;
$91b022b4e06cdbab$export$e8c9778bf415dd08 = `xIVmwW_divider`;
$91b022b4e06cdbab$export$9cc28892e1853afe = `xIVmwW_fieldContainer`;
$91b022b4e06cdbab$export$e7b177dbdcaed6bd = `xIVmwW_fieldTitle`;
$91b022b4e06cdbab$export$3a3c5c2f733d37e3 = `xIVmwW_fieldValue`;
$91b022b4e06cdbab$export$d9696ccac9d85db1 = `xIVmwW_imageThumbLoading`;
$91b022b4e06cdbab$export$8b09bce1e89c2f21 = `xIVmwW_imageThumbnail`;
$91b022b4e06cdbab$export$7a2e7b3d8095518a = `xIVmwW_imageThumbnailContainer`;
$91b022b4e06cdbab$export$d049a13fc4149044 = `xIVmwW_industry`;
$91b022b4e06cdbab$export$f3cbcc6ad82435d7 = `xIVmwW_overview`;
$91b022b4e06cdbab$export$e55b6242cf16bbb8 = `xIVmwW_score`;
$91b022b4e06cdbab$export$becc9140d0e846f8 = `xIVmwW_thumb`;
$91b022b4e06cdbab$export$fb184b623420d9be = `xIVmwW_title`;


const $5207baf8189a67e9$export$469999bd78b57976 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const clientStore = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const query = store.createDataAccess(p.name);
    const companyName = query.companyName;
    const year = query.actualYear();
    const website = (0, $7fbd760f3c05e83d$export$5e10dcd5066a208c)(query.value('website'));
    const ebitda = query.selectedEbitda(year);
    const companyDesc = query.value('company_overview_short');
    const industry = query.value('industry');
    const sub_industry = query.value('industrySubType');
    const metaFields = [
        {
            label: 'Website',
            value: website,
            isUrl: true
        },
        {
            label: 'CEO',
            value: query.value('company_ceo')
        },
        {
            label: 'Founded',
            value: query.value('year_founded')
        }
    ];
    const industry_display = industry + (clientStore.showSubIndustryInHeader ? ` - ${sub_industry}` : '');
    return (0, $kSbwP.jsx)("div", {
        className: $91b022b4e06cdbab$export$becc9140d0e846f8,
        onClick: ()=>{
            navUtils.toReport(p.name);
        },
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $91b022b4e06cdbab$export$fb184b623420d9be,
                    children: companyName
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $91b022b4e06cdbab$export$d049a13fc4149044,
                    children: industry_display
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $91b022b4e06cdbab$export$e8c9778bf415dd08
                }),
                (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    justify: "between",
                    children: (0, $kSbwP.jsx)("div", {
                        className: $91b022b4e06cdbab$export$f3cbcc6ad82435d7,
                        children: companyDesc
                    })
                }),
                (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    style: {
                        position: 'absolute',
                        bottom: '30px',
                        width: '100%',
                        padding: '0 20px 0 0px',
                        maxHeight: '50px'
                    },
                    justify: "between",
                    children: metaFields.map((field, index)=>{
                        return (0, $kSbwP.jsxs)("div", {
                            className: $91b022b4e06cdbab$export$9cc28892e1853afe,
                            children: [
                                (0, $kSbwP.jsx)("div", {
                                    className: $91b022b4e06cdbab$export$e7b177dbdcaed6bd,
                                    children: field.label
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    className: $91b022b4e06cdbab$export$3a3c5c2f733d37e3,
                                    children: field.isUrl && field.value && (field.value.toLowerCase().startsWith('http') || field.value.toLowerCase().startsWith('www')) ? (0, $kSbwP.jsx)("a", {
                                        href: field.value,
                                        target: "_blank",
                                        style: {
                                            zIndex: 100000,
                                            color: '#243a5c'
                                        },
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                        },
                                        children: field.value
                                    }) : field.value
                                })
                            ]
                        }, field.label);
                    })
                })
            ]
        })
    });
});


const $a283eceebd9e41ec$export$632b367007f30628 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    (0, $8nGP5.useEffect)(()=>{
        uiStore.dealPageIndustrySearch = [];
        uiStore.dealPageNameSearch = '';
    }, []);
    var dealKeys = Object.keys(store.reportDataDB);
    const filter_settings = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)().filterCompaniesForDemo;
    if ((0, $8f024b03d9af7c67$export$30eb9424ed49720f)().isDemoFilterOn && filter_settings != null) {
        if (Object.keys(filter_settings).length > 0) dealKeys = dealKeys.filter((dealId)=>filter_settings[dealId] === true);
    }
    //Show completed reports
    var filtered = dealKeys.filter((deal)=>{
        var e = store.reportDataDB[deal];
        var status = e.status;
        if (status != 'completed') return false;
        var dataAccess = store.createDataAccess(deal);
        const companyName = dataAccess.companyName;
        const matchCompanyName = companyName.toLowerCase().includes(uiStore.dealPageNameSearch.toLowerCase()) || uiStore.dealPageNameSearch == '';
        const filter = uiStore.dealPageIndustrySearch;
        var industry = dataAccess.value('industry');
        var sub_industry = dataAccess.value('industrySubType');
        var matchIndustry = false;
        if (filter.length == 0) matchIndustry = true;
        else filter.forEach((filterItem)=>{
            if (filterItem.type == 'category') {
                if (filterItem.value == industry) matchIndustry = true;
            } else if (filterItem.type == 'sub_category') {
                if (filterItem.value == sub_industry) matchIndustry = true;
            }
        });
        const filterScore = uiStore.dealPageScoreSearch;
        var matchScore = true;
        if (filterScore.length > 0) {
            var type = filterScore[0];
            const score = dataAccess.score();
            if (type == 'All') matchScore = true;
            else if (type == 'Strong') matchScore = score > 85;
            else if (type == 'Medium') matchScore = score > 60 && score <= 85;
            else if (type == 'Weak') matchScore = score <= 60;
        }
        return matchCompanyName && matchIndustry && matchScore;
    });
    //sort by creation than name
    filtered = filtered.sort((a, b)=>{
        const ep1 = store.reportDataDB[a].report_creation_epoch || 0;
        const ep2 = store.reportDataDB[b].report_creation_epoch || 0;
        if (ep1 === ep2) {
            const aName = store.reportDataDB[a].company_name;
            const bName = store.reportDataDB[b].company_name;
            return aName.localeCompare(bName);
        } else {
            // Apply sort order based on UI selection
            if (uiStore.dealPageSortOrder === 'oldest') return ep1 - ep2; // Oldest first
            else return ep2 - ep1; // Newest first (default)
        }
    });
    //Add pending jobs to view
    const pendingJobs = [];
    if (uiStore.dealPageNameSearch.length == 0) for(const key in store.jobs){
        var e = store.jobs[key];
        if (e.status == 'pending') pendingJobs.push(key);
    }
    const queuedFilesInJobs = [];
    for(var jobId in store.jobs){
        var job = store.jobs[jobId];
        if (job.status == 'pending') queuedFilesInJobs.push(job.fileName.toLowerCase());
    }
    var activeJob = store.activeJob;
    if (store.activeJob) {
        const job = store.activeJob;
        if (job.status == 'processing') {
            const fileName = activeJob.fileName.toLowerCase();
            queuedFilesInJobs.push(fileName);
        }
    }
    const pdfLocked = [];
    //Switch to sorting the view by the final IDs
    for(const key in store.reportDataDB){
        var e = store.reportDataDB[key];
        var file = e['pdf'];
        if (e.status == 'failed' && e['error'] == 'pdf_password' && !queuedFilesInJobs.includes(file.toLowerCase())) pdfLocked.push(key);
    }
    if (pendingJobs.length > 0) pendingJobs.forEach((jobId, index)=>{
        if (!filtered.includes(jobId)) {
            if (index < 4) filtered.unshift(jobId);
            else filtered.push(jobId);
        }
    });
    if (pdfLocked.length > 0) pdfLocked.forEach((jobId)=>{
        if (!filtered.includes(jobId)) filtered.unshift(jobId);
    });
    if (store.activeJob && store.activeJob.status === 'processing' && !filtered.includes(store.activeJob.jobId)) {
        const jobs = store.jobs;
        for(const key in jobs);
        filtered.unshift(store.activeJob.jobId);
    }
    let deals = filtered.map((deal)=>{
        if (pdfLocked.includes(deal) && !pendingJobs.includes(deal)) return (0, $kSbwP.jsx)((0, $5f2582552430e6bc$export$57d7964eb05a4d4e), {
            jobId: deal
        }, deal);
        else if (store.activeJob && store.activeJob.status === 'processing' && deal === store.activeJob.jobId || pendingJobs.includes(deal)) return (0, $kSbwP.jsx)((0, $a3827455c2ec81f0$export$7750bf75c5a3c423), {
            jobId: deal
        }, deal);
        const dataAccess = store.createDataAccess(deal);
        const hasPdf = dataAccess.report_has_pdf;
        if (hasPdf) return (0, $kSbwP.jsx)((0, $9e54bdf16921cff4$export$ec96aade4c78ed16), {
            name: deal
        }, deal);
        else return (0, $kSbwP.jsx)((0, $5207baf8189a67e9$export$469999bd78b57976), {
            name: deal
        }, deal);
    });
    // Check if we should show "No Results Found"
    const hasActiveFilters = uiStore.dealPageNameSearch.length > 0 || uiStore.dealPageIndustrySearch.length > 0 || uiStore.dealPageScoreSearch.length > 0;
    const shouldShowNoResults = hasActiveFilters && filtered.length === 0 && pendingJobs.length === 0 && pdfLocked.length === 0 && (!store.activeJob || store.activeJob.status !== 'processing');
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            className: $def1233c7c6126ed$export$34e0f9847d4c02dd,
            justify: "start",
            children: [
                (0, $kSbwP.jsx)((0, $959d475eae63db88$export$552e6df88a6b2171), {}),
                shouldShowNoResults ? (0, $kSbwP.jsx)((0, $14155747c992a779$export$c9765147a8dd7e5d), {}) : (0, $kSbwP.jsx)((0, $9a6a933c7ac9e24c$export$1eab25c49fe72a2f), {
                    deals: deals
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");









var $kSbwP = parcelRequire("kSbwP");



var $kSbwP = parcelRequire("kSbwP");




var $8nGP5 = parcelRequire("8nGP5");




/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $9540cd6ba7792ada$var$DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ const $9540cd6ba7792ada$var$CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $9540cd6ba7792ada$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $9540cd6ba7792ada$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $9540cd6ba7792ada$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $9540cd6ba7792ada$export$697502632950e9d3 extends (0, $474ae12482b554c6$export$dd24e9cd51226c56) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($9540cd6ba7792ada$var$prependCode(code), `Firebase Storage: ${message} (${$9540cd6ba7792ada$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $9540cd6ba7792ada$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $9540cd6ba7792ada$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $9540cd6ba7792ada$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($9540cd6ba7792ada$export$54592d666d6ce114 || ($9540cd6ba7792ada$export$54592d666d6ce114 = {}));
function $9540cd6ba7792ada$var$prependCode(code) {
    return 'storage/' + code;
}
function $9540cd6ba7792ada$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNKNOWN, message);
}
function $9540cd6ba7792ada$var$objectNotFound(path) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $9540cd6ba7792ada$var$quotaExceeded(bucket) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function $9540cd6ba7792ada$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $9540cd6ba7792ada$var$unauthorizedApp() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNAUTHORIZED_APP, 'This app does not have permission to access Firebase Storage on this project.');
}
function $9540cd6ba7792ada$var$unauthorized(path) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $9540cd6ba7792ada$var$retryLimitExceeded() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function $9540cd6ba7792ada$var$canceled() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.CANCELED, 'User canceled the upload/download.');
}
function $9540cd6ba7792ada$var$invalidUrl(url) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $9540cd6ba7792ada$var$invalidDefaultBucket(bucket) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $9540cd6ba7792ada$var$noDefaultBucket() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $9540cd6ba7792ada$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $9540cd6ba7792ada$var$cannotSliceBlob() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function $9540cd6ba7792ada$var$serverFileWrongSize() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function $9540cd6ba7792ada$var$noDownloadURL() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function $9540cd6ba7792ada$var$missingPolyFill(polyFill) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $9540cd6ba7792ada$export$8f74d9881d1936fd(message) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $9540cd6ba7792ada$var$appDeleted() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $9540cd6ba7792ada$export$61f54cdc36500ad(name) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $9540cd6ba7792ada$var$invalidFormat(format, message) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $9540cd6ba7792ada$var$internalError(message) {
    throw new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $9540cd6ba7792ada$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $9540cd6ba7792ada$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $9540cd6ba7792ada$export$adb98fff6714334(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw $9540cd6ba7792ada$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = '(/(.*))?$';
        const gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = 'v[A-Za-z0-9_]+';
        const firebaseStorageHost = host.replace(/[.]/g, '\\.');
        const firebaseStoragePath = '(/([^?#]*).*)?$';
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, 'i');
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $9540cd6ba7792ada$var$DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
        const cloudStoragePath = '([^?#]*)';
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, 'i');
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new $9540cd6ba7792ada$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $9540cd6ba7792ada$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $9540cd6ba7792ada$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $9540cd6ba7792ada$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $9540cd6ba7792ada$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9540cd6ba7792ada$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $9540cd6ba7792ada$var$isFunction(p) {
    return typeof p === 'function';
}
function $9540cd6ba7792ada$var$isNonArrayObject(p) {
    return typeof p === 'object' && !Array.isArray(p);
}
function $9540cd6ba7792ada$var$isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function $9540cd6ba7792ada$var$isNativeBlob(p) {
    return $9540cd6ba7792ada$var$isNativeBlobDefined() && p instanceof Blob;
}
function $9540cd6ba7792ada$var$isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
function $9540cd6ba7792ada$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $9540cd6ba7792ada$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $9540cd6ba7792ada$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9540cd6ba7792ada$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $9540cd6ba7792ada$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = '?';
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * Error codes for requests made by the XhrIo wrapper.
 */ var $9540cd6ba7792ada$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($9540cd6ba7792ada$var$ErrorCode || ($9540cd6ba7792ada$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $9540cd6ba7792ada$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $9540cd6ba7792ada$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $9540cd6ba7792ada$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $9540cd6ba7792ada$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $9540cd6ba7792ada$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $9540cd6ba7792ada$var$ErrorCode.ABORT;
                    backoffCallback(false, new $9540cd6ba7792ada$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $9540cd6ba7792ada$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($9540cd6ba7792ada$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $9540cd6ba7792ada$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $9540cd6ba7792ada$var$appDeleted() : $9540cd6ba7792ada$var$canceled();
                    reject(err);
                } else {
                    const err = $9540cd6ba7792ada$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $9540cd6ba7792ada$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $9540cd6ba7792ada$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $9540cd6ba7792ada$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $9540cd6ba7792ada$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $9540cd6ba7792ada$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function $9540cd6ba7792ada$var$addVersionHeader_(headers, firebaseVersion) {
    headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : 'AppManager');
}
function $9540cd6ba7792ada$var$addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
function $9540cd6ba7792ada$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers['X-Firebase-AppCheck'] = appCheckToken;
}
function $9540cd6ba7792ada$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true) {
    const queryPart = $9540cd6ba7792ada$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $9540cd6ba7792ada$var$addGmpidHeader_(headers, appId);
    $9540cd6ba7792ada$var$addAuthHeader_(headers, authToken);
    $9540cd6ba7792ada$var$addVersionHeader_(headers, firebaseVersion);
    $9540cd6ba7792ada$var$addAppCheckHeader_(headers, appCheckToken);
    return new $9540cd6ba7792ada$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9540cd6ba7792ada$var$getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $9540cd6ba7792ada$var$getBlob$1(...args) {
    const BlobBuilder1 = $9540cd6ba7792ada$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($9540cd6ba7792ada$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $9540cd6ba7792ada$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $9540cd6ba7792ada$var$decodeBase64(encoded) {
    if (typeof atob === 'undefined') throw $9540cd6ba7792ada$var$missingPolyFill('base-64');
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $9540cd6ba7792ada$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: 'raw',
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: 'base64',
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: 'base64url',
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: 'data_url'
};
class $9540cd6ba7792ada$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $9540cd6ba7792ada$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.RAW:
            return new $9540cd6ba7792ada$var$StringData($9540cd6ba7792ada$var$utf8Bytes_(stringData));
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.BASE64:
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.BASE64URL:
            return new $9540cd6ba7792ada$var$StringData($9540cd6ba7792ada$var$base64Bytes_(format, stringData));
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.DATA_URL:
            return new $9540cd6ba7792ada$var$StringData($9540cd6ba7792ada$var$dataURLBytes_(stringData), $9540cd6ba7792ada$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $9540cd6ba7792ada$var$unknown();
}
function $9540cd6ba7792ada$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $9540cd6ba7792ada$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $9540cd6ba7792ada$var$invalidFormat($9540cd6ba7792ada$export$f22e7fe56db8ae03.DATA_URL, 'Malformed data URL.');
    }
    return $9540cd6ba7792ada$var$utf8Bytes_(decoded);
}
function $9540cd6ba7792ada$var$base64Bytes_(format, value) {
    switch(format){
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf('-') !== -1;
                const hasUnder = value.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? '-' : '_';
                    throw $9540cd6ba7792ada$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf('+') !== -1;
                const hasSlash = value.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? '+' : '/';
                    throw $9540cd6ba7792ada$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    let bytes;
    try {
        bytes = $9540cd6ba7792ada$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes('polyfill')) throw e;
        throw $9540cd6ba7792ada$var$invalidFormat(format, 'Invalid character found');
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $9540cd6ba7792ada$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $9540cd6ba7792ada$var$invalidFormat($9540cd6ba7792ada$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $9540cd6ba7792ada$var$endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
}
function $9540cd6ba7792ada$var$dataURLBytes_(dataUrl) {
    const parts = new $9540cd6ba7792ada$var$DataURLParts(dataUrl);
    if (parts.base64) return $9540cd6ba7792ada$var$base64Bytes_($9540cd6ba7792ada$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $9540cd6ba7792ada$var$percentEncodedBytes_(parts.rest);
}
function $9540cd6ba7792ada$var$dataURLContentType_(dataUrl) {
    const parts = new $9540cd6ba7792ada$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $9540cd6ba7792ada$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $9540cd6ba7792ada$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = '';
        if ($9540cd6ba7792ada$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($9540cd6ba7792ada$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $9540cd6ba7792ada$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $9540cd6ba7792ada$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $9540cd6ba7792ada$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($9540cd6ba7792ada$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $9540cd6ba7792ada$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $9540cd6ba7792ada$export$8deea8629ff0b8a7($9540cd6ba7792ada$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($9540cd6ba7792ada$var$isString(val)) return $9540cd6ba7792ada$export$d80b9b5a2ccdd3e0($9540cd6ba7792ada$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $9540cd6ba7792ada$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $9540cd6ba7792ada$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($9540cd6ba7792ada$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $9540cd6ba7792ada$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf('/');
    if (index === -1) return '';
    const newPath = path.slice(0, index);
    return newPath;
}
function $9540cd6ba7792ada$var$child(path, childPath) {
    const canonicalChildPath = childPath.split('/').filter((component)=>component.length > 0).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $9540cd6ba7792ada$var$lastComponent(path) {
    const index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9540cd6ba7792ada$var$noXform_(metadata, value) {
    return value;
}
class $9540cd6ba7792ada$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $9540cd6ba7792ada$var$noXform_;
    }
}
let $9540cd6ba7792ada$var$mappings_ = null;
function $9540cd6ba7792ada$var$xformPath(fullPath) {
    if (!$9540cd6ba7792ada$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $9540cd6ba7792ada$var$lastComponent(fullPath);
}
function $9540cd6ba7792ada$var$getMappings() {
    if ($9540cd6ba7792ada$var$mappings_) return $9540cd6ba7792ada$var$mappings_;
    const mappings = [];
    mappings.push(new $9540cd6ba7792ada$var$Mapping('bucket'));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('generation'));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('metageneration'));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return $9540cd6ba7792ada$var$xformPath(fullPath);
    }
    const nameMapping = new $9540cd6ba7792ada$var$Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $9540cd6ba7792ada$var$Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $9540cd6ba7792ada$var$Mapping('timeCreated'));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('updated'));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('md5Hash', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('cacheControl', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('contentDisposition', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('contentEncoding', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('contentLanguage', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('contentType', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('metadata', 'customMetadata', true));
    $9540cd6ba7792ada$var$mappings_ = mappings;
    return $9540cd6ba7792ada$var$mappings_;
}
function $9540cd6ba7792ada$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const loc = new $9540cd6ba7792ada$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function $9540cd6ba7792ada$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata['type'] = 'file';
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $9540cd6ba7792ada$var$addRef(metadata, service);
    return metadata;
}
function $9540cd6ba7792ada$var$fromResourceString(service, resourceString, mappings) {
    const obj = $9540cd6ba7792ada$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $9540cd6ba7792ada$var$fromResource(service, resource, mappings);
}
function $9540cd6ba7792ada$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $9540cd6ba7792ada$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$9540cd6ba7792ada$var$isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(',');
    const urls = tokensList.map((token)=>{
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        const base = $9540cd6ba7792ada$var$makeUrl(urlPart, host, protocol);
        const queryString = $9540cd6ba7792ada$var$makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $9540cd6ba7792ada$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9540cd6ba7792ada$var$PREFIXES_KEY = 'prefixes';
const $9540cd6ba7792ada$var$ITEMS_KEY = 'items';
function $9540cd6ba7792ada$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[$9540cd6ba7792ada$var$PREFIXES_KEY]) for (const path of resource[$9540cd6ba7792ada$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, '');
        const reference = service._makeStorageReference(new $9540cd6ba7792ada$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$9540cd6ba7792ada$var$ITEMS_KEY]) for (const item of resource[$9540cd6ba7792ada$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $9540cd6ba7792ada$export$adb98fff6714334(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function $9540cd6ba7792ada$var$fromResponseString(service, bucket, resourceString) {
    const obj = $9540cd6ba7792ada$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $9540cd6ba7792ada$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $9540cd6ba7792ada$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $9540cd6ba7792ada$var$handlerCheck(cndn) {
    if (!cndn) throw $9540cd6ba7792ada$var$unknown();
}
function $9540cd6ba7792ada$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $9540cd6ba7792ada$var$fromResourceString(service, text, mappings);
        $9540cd6ba7792ada$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $9540cd6ba7792ada$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $9540cd6ba7792ada$var$fromResponseString(service, bucket, text);
        $9540cd6ba7792ada$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $9540cd6ba7792ada$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $9540cd6ba7792ada$var$fromResourceString(service, text, mappings);
        $9540cd6ba7792ada$var$handlerCheck(metadata !== null);
        return $9540cd6ba7792ada$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $9540cd6ba7792ada$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes('Firebase App Check token is invalid')) newErr = $9540cd6ba7792ada$var$unauthorizedApp();
            else newErr = $9540cd6ba7792ada$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $9540cd6ba7792ada$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $9540cd6ba7792ada$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $9540cd6ba7792ada$var$objectErrorHandler(location) {
    const shared = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $9540cd6ba7792ada$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $9540cd6ba7792ada$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, $9540cd6ba7792ada$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $9540cd6ba7792ada$var$objectErrorHandler(location);
    return requestInfo;
}
function $9540cd6ba7792ada$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter && delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, $9540cd6ba7792ada$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    return requestInfo;
}
function $9540cd6ba7792ada$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol) + '?alt=media';
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $9540cd6ba7792ada$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers['Range'] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $9540cd6ba7792ada$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, $9540cd6ba7792ada$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $9540cd6ba7792ada$var$objectErrorHandler(location);
    return requestInfo;
}
function $9540cd6ba7792ada$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'PATCH';
    const body = $9540cd6ba7792ada$var$toResourceString(metadata, mappings);
    const headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, $9540cd6ba7792ada$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $9540cd6ba7792ada$var$objectErrorHandler(location);
    return requestInfo;
}
function $9540cd6ba7792ada$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'DELETE';
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $9540cd6ba7792ada$var$objectErrorHandler(location);
    return requestInfo;
}
function $9540cd6ba7792ada$var$determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function $9540cd6ba7792ada$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = $9540cd6ba7792ada$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $9540cd6ba7792ada$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        let str = '';
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    const metadata_ = $9540cd6ba7792ada$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $9540cd6ba7792ada$var$toResourceString(metadata_, mappings);
    const preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    const postBlobPart = '\r\n--' + boundary + '--';
    const body = $9540cd6ba7792ada$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $9540cd6ba7792ada$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_['fullPath']
    };
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, $9540cd6ba7792ada$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $9540cd6ba7792ada$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $9540cd6ba7792ada$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        $9540cd6ba7792ada$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        'active'
    ];
    $9540cd6ba7792ada$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $9540cd6ba7792ada$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $9540cd6ba7792ada$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload['fullPath']
    };
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': `${blob.size()}`,
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    const body = $9540cd6ba7792ada$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $9540cd6ba7792ada$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            $9540cd6ba7792ada$var$handlerCheck(false);
        }
        $9540cd6ba7792ada$var$handlerCheck($9540cd6ba7792ada$var$isString(url));
        return url;
    }
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $9540cd6ba7792ada$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        const status = $9540cd6ba7792ada$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            $9540cd6ba7792ada$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $9540cd6ba7792ada$var$handlerCheck(false);
        const size = Number(sizeString);
        $9540cd6ba7792ada$var$handlerCheck(!isNaN(size));
        return new $9540cd6ba7792ada$var$ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $9540cd6ba7792ada$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $9540cd6ba7792ada$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $9540cd6ba7792ada$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $9540cd6ba7792ada$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = '';
    if (bytesToUpload === 0) uploadCommand = 'finalize';
    else if (bytesLeft === bytesToUpload) uploadCommand = 'upload, finalize';
    else uploadCommand = 'upload';
    const headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $9540cd6ba7792ada$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $9540cd6ba7792ada$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === 'final') metadata = $9540cd6ba7792ada$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $9540cd6ba7792ada$var$ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $9540cd6ba7792ada$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: 'state_changed'
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $9540cd6ba7792ada$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function $9540cd6ba7792ada$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9540cd6ba7792ada$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $9540cd6ba7792ada$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error !== null && error !== void 0 ? error : undefined;
            this.complete = complete !== null && complete !== void 0 ? complete : undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $9540cd6ba7792ada$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $9540cd6ba7792ada$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $9540cd6ba7792ada$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $9540cd6ba7792ada$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener('abort', ()=>{
                this.errorCode_ = $9540cd6ba7792ada$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener('error', ()=>{
                this.errorCode_ = $9540cd6ba7792ada$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener('load', ()=>{
                resolve();
            });
        });
    }
    send(url, method, body, headers) {
        if (this.sent_) throw $9540cd6ba7792ada$var$internalError('cannot .send() more than once');
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $9540cd6ba7792ada$var$internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $9540cd6ba7792ada$var$internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $9540cd6ba7792ada$var$internalError('cannot .getResponse() before sending');
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $9540cd6ba7792ada$var$internalError('cannot .getErrorText() before sending');
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener('progress', listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener('progress', listener);
    }
}
class $9540cd6ba7792ada$var$XhrTextConnection extends $9540cd6ba7792ada$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'text';
    }
}
function $9540cd6ba7792ada$var$newTextConnection() {
    return $9540cd6ba7792ada$var$textFactoryOverride ? $9540cd6ba7792ada$var$textFactoryOverride() : new $9540cd6ba7792ada$var$XhrTextConnection();
}
class $9540cd6ba7792ada$var$XhrBytesConnection extends $9540cd6ba7792ada$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'arraybuffer';
    }
}
function $9540cd6ba7792ada$var$newBytesConnection() {
    return new $9540cd6ba7792ada$var$XhrBytesConnection();
}
class $9540cd6ba7792ada$var$XhrBlobConnection extends $9540cd6ba7792ada$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'blob';
    }
}
function $9540cd6ba7792ada$var$newBlobConnection() {
    return new $9540cd6ba7792ada$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $9540cd6ba7792ada$export$86a2a9b92406a048 {
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $9540cd6ba7792ada$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($9540cd6ba7792ada$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($9540cd6ba7792ada$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $9540cd6ba7792ada$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $9540cd6ba7792ada$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($9540cd6ba7792ada$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $9540cd6ba7792ada$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $9540cd6ba7792ada$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $9540cd6ba7792ada$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $9540cd6ba7792ada$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $9540cd6ba7792ada$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $9540cd6ba7792ada$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $9540cd6ba7792ada$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $9540cd6ba7792ada$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $9540cd6ba7792ada$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $9540cd6ba7792ada$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $9540cd6ba7792ada$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $9540cd6ba7792ada$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $9540cd6ba7792ada$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $9540cd6ba7792ada$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $9540cd6ba7792ada$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $9540cd6ba7792ada$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($9540cd6ba7792ada$var$taskStateFromInternalTaskState(this._state)){
                case $9540cd6ba7792ada$export$9dc4203728a9a7c9.SUCCESS:
                    $9540cd6ba7792ada$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $9540cd6ba7792ada$export$9dc4203728a9a7c9.CANCELED:
                case $9540cd6ba7792ada$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $9540cd6ba7792ada$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $9540cd6ba7792ada$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $9540cd6ba7792ada$export$9dc4203728a9a7c9.RUNNING:
            case $9540cd6ba7792ada$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $9540cd6ba7792ada$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $9540cd6ba7792ada$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $9540cd6ba7792ada$var$async(observer.complete.bind(observer))();
                break;
            case $9540cd6ba7792ada$export$9dc4203728a9a7c9.CANCELED:
            case $9540cd6ba7792ada$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $9540cd6ba7792ada$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $9540cd6ba7792ada$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $9540cd6ba7792ada$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $9540cd6ba7792ada$export$adb98fff6714334) this._location = location;
        else this._location = $9540cd6ba7792ada$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
    _newRef(service, location) {
        return new $9540cd6ba7792ada$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $9540cd6ba7792ada$export$adb98fff6714334(this._location.bucket, '');
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $9540cd6ba7792ada$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $9540cd6ba7792ada$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $9540cd6ba7792ada$export$adb98fff6714334(this._location.bucket, newPath);
        return new $9540cd6ba7792ada$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === '') throw $9540cd6ba7792ada$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $9540cd6ba7792ada$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBytes');
    const requestInfo = $9540cd6ba7792ada$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $9540cd6ba7792ada$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBlob');
    const requestInfo = $9540cd6ba7792ada$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $9540cd6ba7792ada$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytes');
    const requestInfo = $9540cd6ba7792ada$var$multipartUpload(ref.storage, ref._location, $9540cd6ba7792ada$var$getMappings(), new $9540cd6ba7792ada$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $9540cd6ba7792ada$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytesResumable');
    return new $9540cd6ba7792ada$export$86a2a9b92406a048(ref, new $9540cd6ba7792ada$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $9540cd6ba7792ada$var$uploadString$1(ref, value, format = $9540cd6ba7792ada$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot('uploadString');
    const data = $9540cd6ba7792ada$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = Object.assign({}, metadata);
    if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
    return $9540cd6ba7792ada$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $9540cd6ba7792ada$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $9540cd6ba7792ada$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $9540cd6ba7792ada$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $9540cd6ba7792ada$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $9540cd6ba7792ada$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $9540cd6ba7792ada$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === 'number') $9540cd6ba7792ada$var$validateNumber('options.maxResults', /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $9540cd6ba7792ada$var$list$2(ref.storage, ref._location, /*delimiter= */ '/', op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $9540cd6ba7792ada$var$getMetadata$1(ref) {
    ref._throwIfRoot('getMetadata');
    const requestInfo = $9540cd6ba7792ada$var$getMetadata$2(ref.storage, ref._location, $9540cd6ba7792ada$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $9540cd6ba7792ada$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot('updateMetadata');
    const requestInfo = $9540cd6ba7792ada$var$updateMetadata$2(ref.storage, ref._location, metadata, $9540cd6ba7792ada$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $9540cd6ba7792ada$var$getDownloadURL$1(ref) {
    ref._throwIfRoot('getDownloadURL');
    const requestInfo = $9540cd6ba7792ada$var$getDownloadUrl(ref.storage, ref._location, $9540cd6ba7792ada$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection).then((url)=>{
        if (url === null) throw $9540cd6ba7792ada$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $9540cd6ba7792ada$var$deleteObject$1(ref) {
    ref._throwIfRoot('deleteObject');
    const requestInfo = $9540cd6ba7792ada$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $9540cd6ba7792ada$var$_getChild$1(ref, childPath) {
    const newPath = $9540cd6ba7792ada$var$child(ref._location.path, childPath);
    const location = new $9540cd6ba7792ada$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $9540cd6ba7792ada$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9540cd6ba7792ada$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $9540cd6ba7792ada$var$refFromURL(service, url) {
    return new $9540cd6ba7792ada$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $9540cd6ba7792ada$var$refFromPath(ref, path) {
    if (ref instanceof $9540cd6ba7792ada$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $9540cd6ba7792ada$var$noDefaultBucket();
        const reference = new $9540cd6ba7792ada$var$Reference(service, service._bucket);
        if (path != null) return $9540cd6ba7792ada$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $9540cd6ba7792ada$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $9540cd6ba7792ada$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $9540cd6ba7792ada$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $9540cd6ba7792ada$var$FirebaseStorageImpl) return $9540cd6ba7792ada$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $9540cd6ba7792ada$export$8f74d9881d1936fd('To use ref(service, url), the first argument must be a Storage instance.');
    } else return $9540cd6ba7792ada$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $9540cd6ba7792ada$var$extractBucket(host, config) {
    const bucketString = config === null || config === void 0 ? void 0 : config[$9540cd6ba7792ada$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $9540cd6ba7792ada$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $9540cd6ba7792ada$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    storage._protocol = 'http';
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === 'string' ? mockUserToken : (0, $474ae12482b554c6$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $9540cd6ba7792ada$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $9540cd6ba7792ada$var$DEFAULT_HOST;
        this._protocol = 'https';
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $9540cd6ba7792ada$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $9540cd6ba7792ada$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $9540cd6ba7792ada$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $9540cd6ba7792ada$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $9540cd6ba7792ada$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $9540cd6ba7792ada$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $9540cd6ba7792ada$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $9540cd6ba7792ada$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $9540cd6ba7792ada$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $9540cd6ba7792ada$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $9540cd6ba7792ada$var$FailRequest($9540cd6ba7792ada$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $9540cd6ba7792ada$var$name = "@firebase/storage";
const $9540cd6ba7792ada$var$version = "0.13.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $9540cd6ba7792ada$var$STORAGE_TYPE = 'storage';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $9540cd6ba7792ada$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $9540cd6ba7792ada$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $9540cd6ba7792ada$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $9540cd6ba7792ada$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $9540cd6ba7792ada$export$8548546c0aa631e6(ref) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $9540cd6ba7792ada$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $9540cd6ba7792ada$export$8837f4fc672e936d(ref, options) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $9540cd6ba7792ada$export$6a265a7d315dec03(ref) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $9540cd6ba7792ada$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $9540cd6ba7792ada$export$39c5ed4ec960eade(ref) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$deleteObject$1(ref);
}
function $9540cd6ba7792ada$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(serviceOrRef);
    return $9540cd6ba7792ada$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $9540cd6ba7792ada$export$9acd24c0fce96a85(ref, childPath) {
    return $9540cd6ba7792ada$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $9540cd6ba7792ada$export$fbd9b57a66480737(app = (0, $20ed53392b3edc61$export$f9962582c9e66d99)(), bucketUrl) {
    app = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $20ed53392b3edc61$export$fa0d6da0f5838f50)(app, $9540cd6ba7792ada$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $474ae12482b554c6$export$a3febcf1f14a3a0c)('storage');
    if (emulator) $9540cd6ba7792ada$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $9540cd6ba7792ada$export$9850e656f954b889(storage, host, port, options = {}) {
    $9540cd6ba7792ada$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $9540cd6ba7792ada$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $9540cd6ba7792ada$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error('getStream() is only supported by NodeJS builds');
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $9540cd6ba7792ada$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider('app').getImmediate();
    const authProvider = container.getProvider('auth-internal');
    const appCheckProvider = container.getProvider('app-check-internal');
    return new $9540cd6ba7792ada$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $20ed53392b3edc61$export$31499a9cd224b78c));
}
function $9540cd6ba7792ada$var$registerStorage() {
    (0, $20ed53392b3edc61$export$c930050e7bb63965)(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)($9540cd6ba7792ada$var$STORAGE_TYPE, $9540cd6ba7792ada$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($9540cd6ba7792ada$var$name, $9540cd6ba7792ada$var$version, '');
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($9540cd6ba7792ada$var$name, $9540cd6ba7792ada$var$version, 'esm2017');
}
$9540cd6ba7792ada$var$registerStorage();






var $fa12c9399a1a76ec$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fa12c9399a1a76ec$var$PLACEHOLDER_FILE = '.placeholder';
const $fa12c9399a1a76ec$var$STORAGE_PATH_REPORTS = 'gs://' + (0, $b2432f43c421c848$export$7a667d08ed65fa47)().getConfig().storageBucket + '/pdfs';
const $fa12c9399a1a76ec$var$STORAGE_PATH_RAG = 'gs://' + (0, $b2432f43c421c848$export$7a667d08ed65fa47)().getConfig().storageBucket + '/rag';
const $fa12c9399a1a76ec$export$54784bc20f80fcff = 'gs://' + (0, $b2432f43c421c848$export$7a667d08ed65fa47)().getConfig().storageBucket + '/knowledge';
class $fa12c9399a1a76ec$var$StorageAdapater {
    check_if_report_exists(fileName) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            const docRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, `${$fa12c9399a1a76ec$var$STORAGE_PATH_REPORTS}/${fileName}`);
            try {
                yield (0, $9540cd6ba7792ada$export$c8bf645a0c2a7d9f)(docRef);
                return true;
            } catch (error) {
                return false;
            }
        });
    }
    getListFolderContent(path) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            const rootDir = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, path);
            const getFolder = (dirRef)=>$fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        const listResult = yield (0, $9540cd6ba7792ada$export$6a265a7d315dec03)(dirRef);
                        const files = listResult.items.map((item)=>({
                                fileName: item.name,
                                path: item.fullPath
                            }));
                        const filesNoPlaceholder = files.filter((file)=>file.fileName !== $fa12c9399a1a76ec$var$PLACEHOLDER_FILE);
                        const folders = yield Promise.all(listResult.prefixes.map((folderRef)=>$fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
                                return yield getFolder(folderRef); // folderRef is already a StorageReference
                            })));
                        return {
                            path: dirRef.fullPath,
                            name: dirRef.name,
                            files: filesNoPlaceholder,
                            folders: folders
                        };
                    } catch (error) {
                        console.error('Error listing folder contents:', error);
                        return {
                            path: dirRef.fullPath,
                            name: dirRef.name,
                            files: [],
                            folders: []
                        };
                    }
                });
            return yield getFolder(rootDir);
        });
    }
    buildStorageFolderPath(storageTarget, fileName) {
        switch(storageTarget.type){
            case 'cim':
                return `${$fa12c9399a1a76ec$var$STORAGE_PATH_REPORTS}/${fileName}`;
            case 'rag':
                return `${$fa12c9399a1a76ec$var$STORAGE_PATH_RAG}/${storageTarget.reportId}/${fileName}`;
            case 'knowledge_base':
                if (!storageTarget.folder) return `${$fa12c9399a1a76ec$export$54784bc20f80fcff}/${fileName}`;
                return `${$fa12c9399a1a76ec$export$54784bc20f80fcff}/${storageTarget.folder}/${fileName}`;
            default:
                throw new Error('Invalid storage target type');
        }
    }
    uploadFileToStorage(storageTarget, file, onProgress) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            const userId = fb.userId;
            const userEmail = fb.user.email;
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            //const filePath = `${STORAGE_PATH_RAG}/${dealId}/${file.name}`;
            const filePath = this.buildStorageFolderPath(storageTarget, file.name);
            const storageRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, filePath);
            const upload_task = (0, $9540cd6ba7792ada$export$3895d39eb7ac9b25)(storageRef, file);
            upload_task.on('state_changed', (snapshot)=>{
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                const progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                if (onProgress) onProgress(progress);
            }, (error)=>{
                return null;
            }, ()=>{});
            const metadata = {
                customMetadata: {
                    userId: userId,
                    userEmail: userEmail
                }
            };
            var snapshot = yield upload_task;
            yield (0, $9540cd6ba7792ada$export$f64791b2d30456a0)(storageRef, metadata);
            fb.triggerScanRagFiles();
            return filePath;
        });
    }
    deleteFileFromStorage(storageTarget, fileName) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            const filePath = this.buildStorageFolderPath(storageTarget, fileName);
            const storageRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, filePath);
            try {
                yield (0, $9540cd6ba7792ada$export$39c5ed4ec960eade)(storageRef);
            } catch (error) {
                return false;
            }
            return true;
        });
    }
    createFolder(storageTarget, newFolder) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const path = this.buildStorageFolderPath(storageTarget, newFolder);
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            const folderRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, path + '/' + $fa12c9399a1a76ec$var$PLACEHOLDER_FILE);
            const emptyFile = new Blob([]); // Empty file
            try {
                yield (0, $9540cd6ba7792ada$export$ac40f56b52f99dd1)(folderRef, emptyFile);
                return true;
            } catch (error) {
                console.error('Error creating folder:', error);
                return false;
            }
        });
    }
    deleteKnowledgeFile(storagePath) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            (0, $3d71a0e5fc49a3ca$exports.assert)(storagePath.startsWith('knowledge/'), 'Invalid path for knowledge file deletion');
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            const fileRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, storagePath);
            try {
                yield (0, $9540cd6ba7792ada$export$39c5ed4ec960eade)(fileRef);
                return true;
            } catch (error) {
                console.error('Error deleting file:', error);
                return false;
            }
        });
    }
    deleteFolder(storageTarget) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            const path = this.buildStorageFolderPath(storageTarget, '');
            const folderRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, path);
            const deleteFolderRec = (dirRef)=>$fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        const listResult = yield (0, $9540cd6ba7792ada$export$6a265a7d315dec03)(dirRef);
                        yield Promise.all(listResult.prefixes.map((folderRef)=>$fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
                                return yield deleteFolderRec(folderRef); // folderRef is already a StorageReference
                            })));
                        for (var item of listResult.items){
                            item = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, item.fullPath);
                            yield (0, $9540cd6ba7792ada$export$39c5ed4ec960eade)(item).catch((error)=>{
                                console.error('Error deleting file:', error);
                            });
                        }
                    } catch (error) {
                        console.error(`Error deleting folder: ${dirRef.fullPath} ${error}`);
                    }
                });
            try {
                yield deleteFolderRec(folderRef);
                return true;
            } catch (error) {
                console.error('Error deleting folder:', error);
                return false;
            }
        });
    }
    uploadReportPdf(file, onProgress) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            const userId = fb.userId;
            const userEmail = fb.user.email;
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            const storageRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, `${$fa12c9399a1a76ec$var$STORAGE_PATH_REPORTS}/${file.name}`);
            const upload_task = (0, $9540cd6ba7792ada$export$3895d39eb7ac9b25)(storageRef, file);
            upload_task.on('state_changed', (snapshot)=>{
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                const progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                if (onProgress) onProgress(progress);
            }, (error)=>{
                return false;
            }, ()=>{});
            const metadata = {
                customMetadata: {
                    userId: userId,
                    userEmail: userEmail
                }
            };
            var snapshot = yield upload_task;
            yield (0, $9540cd6ba7792ada$export$f64791b2d30456a0)(storageRef, metadata);
            return true;
        });
    }
}
const $fa12c9399a1a76ec$var$mStorageService = new $fa12c9399a1a76ec$var$StorageAdapater();
function $fa12c9399a1a76ec$export$39e0a5bed87a3667() {
    return $fa12c9399a1a76ec$var$mStorageService;
}




var $1bc40f4eb65039a9$export$40a9eeef55665a40;
var $1bc40f4eb65039a9$export$93b7586d956c930e;
var $1bc40f4eb65039a9$export$f843afa9e9b53052;
var $1bc40f4eb65039a9$export$ae78d338ad66ff90;
var $1bc40f4eb65039a9$export$b8972b998723d602;
var $1bc40f4eb65039a9$export$13925b5cf10ba292;
var $1bc40f4eb65039a9$export$2778853eeaa53fa7;
$1bc40f4eb65039a9$export$40a9eeef55665a40 = `tEP1QG_defaultPadding`;
$1bc40f4eb65039a9$export$93b7586d956c930e = `tEP1QG_dropShadow`;
$1bc40f4eb65039a9$export$f843afa9e9b53052 = `tEP1QG_panelImage`;
$1bc40f4eb65039a9$export$ae78d338ad66ff90 = `tEP1QG_scaleInOut`;
$1bc40f4eb65039a9$export$ae78d338ad66ff90;
$1bc40f4eb65039a9$export$b8972b998723d602 = `tEP1QG_shadow`;
$1bc40f4eb65039a9$export$13925b5cf10ba292 = `tEP1QG_small-shadow`;
$1bc40f4eb65039a9$export$2778853eeaa53fa7 = `tEP1QG_taskPageDropZone`;



var $d39d5626a2a26fe7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ee62ca6949990202$export$2e2bcd8739ae039 = $ee62ca6949990202$var$extend;
/*
  var obj = {a: 3, b: 5};
  extend(obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 4, b: 5, c: 8}

  var obj = {a: 3, b: 5};
  extend({}, obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 3, b: 5}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4]}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(true, obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3]}

  extend({a: 4, b: 5}); // {a: 4, b: 5}
  extend({a: 4, b: 5}, 3); {a: 4, b: 5}
  extend({a: 4, b: 5}, true); {a: 4, b: 5}
  extend('hello', {a: 4, b: 5}); // throws
  extend(3, {a: 4, b: 5}); // throws
*/ function $ee62ca6949990202$var$extend() {
    var args = [].slice.call(arguments);
    var deep = false;
    if (typeof args[0] == 'boolean') deep = args.shift();
    var result = args[0];
    if ($ee62ca6949990202$var$isUnextendable(result)) throw new Error('extendee must be an object');
    var extenders = args.slice(1);
    var len = extenders.length;
    for(var i = 0; i < len; i++){
        var extender = extenders[i];
        for(var key in extender)if (Object.prototype.hasOwnProperty.call(extender, key)) {
            var value = extender[key];
            if (deep && $ee62ca6949990202$var$isCloneable(value)) {
                var base = Array.isArray(value) ? [] : {};
                result[key] = $ee62ca6949990202$var$extend(true, Object.prototype.hasOwnProperty.call(result, key) && !$ee62ca6949990202$var$isUnextendable(result[key]) ? result[key] : base, value);
            } else result[key] = value;
        }
    }
    return result;
}
function $ee62ca6949990202$var$isCloneable(obj) {
    return Array.isArray(obj) || ({}).toString.call(obj) == '[object Object]';
}
function $ee62ca6949990202$var$isUnextendable(val) {
    return !val || typeof val != 'object' && typeof val != 'function';
}


function $540cd3dd02161f28$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
class $540cd3dd02161f28$var$$4040acfd8584338d$export$2e2bcd8739ae039 {
    // Add an event listener for given event
    on(event, fn) {
        this._callbacks = this._callbacks || {};
        // Create namespace for this event
        if (!this._callbacks[event]) this._callbacks[event] = [];
        this._callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        this._callbacks = this._callbacks || {};
        let callbacks = this._callbacks[event];
        if (callbacks) for (let callback of callbacks)callback.apply(this, args);
        // trigger a corresponding DOM event
        if (this.element) this.element.dispatchEvent(this.makeEvent("dropzone:" + event, {
            args: args
        }));
        return this;
    }
    makeEvent(eventName, detail) {
        let params = {
            bubbles: true,
            cancelable: true,
            detail: detail
        };
        if (typeof window.CustomEvent === "function") return new CustomEvent(eventName, params);
        else {
            // IE 11 support
            // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(eventName, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
    }
    // Remove event listener for given event. If fn is not provided, all event
    // listeners for that event will be removed. If neither is provided, all
    // event listeners will be removed.
    off(event, fn) {
        if (!this._callbacks || arguments.length === 0) {
            this._callbacks = {};
            return this;
        }
        // specific event
        let callbacks = this._callbacks[event];
        if (!callbacks) return this;
        // remove all handlers
        if (arguments.length === 1) {
            delete this._callbacks[event];
            return this;
        }
        // remove specific handler
        for(let i = 0; i < callbacks.length; i++){
            let callback = callbacks[i];
            if (callback === fn) {
                callbacks.splice(i, 1);
                break;
            }
        }
        return this;
    }
}
var $540cd3dd02161f28$var$$fd6031f88dce2e32$exports = {};
$540cd3dd02161f28$var$$fd6031f88dce2e32$exports = "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail=\"\"></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size=\"\"></span></div>\n    <div class=\"dz-filename\"><span data-dz-name=\"\"></span></div>\n  </div>\n  <div class=\"dz-progress\">\n    <span class=\"dz-upload\" data-dz-uploadprogress=\"\"></span>\n  </div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage=\"\"></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54\" height=\"54\" viewBox=\"0 0 54 54\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M10.2071 29.7929L14.2929 25.7071C14.6834 25.3166 15.3166 25.3166 15.7071 25.7071L21.2929 31.2929C21.6834 31.6834 22.3166 31.6834 22.7071 31.2929L38.2929 15.7071C38.6834 15.3166 39.3166 15.3166 39.7071 15.7071L43.7929 19.7929C44.1834 20.1834 44.1834 20.8166 43.7929 21.2071L22.7071 42.2929C22.3166 42.6834 21.6834 42.6834 21.2929 42.2929L10.2071 31.2071C9.81658 30.8166 9.81658 30.1834 10.2071 29.7929Z\"></path>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54\" height=\"54\" viewBox=\"0 0 54 54\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M26.2929 20.2929L19.2071 13.2071C18.8166 12.8166 18.1834 12.8166 17.7929 13.2071L13.2071 17.7929C12.8166 18.1834 12.8166 18.8166 13.2071 19.2071L20.2929 26.2929C20.6834 26.6834 20.6834 27.3166 20.2929 27.7071L13.2071 34.7929C12.8166 35.1834 12.8166 35.8166 13.2071 36.2071L17.7929 40.7929C18.1834 41.1834 18.8166 41.1834 19.2071 40.7929L26.2929 33.7071C26.6834 33.3166 27.3166 33.3166 27.7071 33.7071L34.7929 40.7929C35.1834 41.1834 35.8166 41.1834 36.2071 40.7929L40.7929 36.2071C41.1834 35.8166 41.1834 35.1834 40.7929 34.7929L33.7071 27.7071C33.3166 27.3166 33.3166 26.6834 33.7071 26.2929L40.7929 19.2071C41.1834 18.8166 41.1834 18.1834 40.7929 17.7929L36.2071 13.2071C35.8166 12.8166 35.1834 12.8166 34.7929 13.2071L27.7071 20.2929C27.3166 20.6834 26.6834 20.6834 26.2929 20.2929Z\"></path>\n    </svg>\n  </div>\n</div>\n";
let $540cd3dd02161f28$var$$4ca367182776f80b$var$defaultOptions = {
    /**
   * Has to be specified on elements other than form (or when the form doesn't
   * have an `action` attribute).
   *
   * You can also provide a function that will be called with `files` and
   * `dataBlocks`  and must return the url as string.
   */ url: null,
    /**
   * Can be changed to `"put"` if necessary. You can also provide a function
   * that will be called with `files` and must return the method (since `v3.12.0`).
   */ method: "post",
    /**
   * Will be set on the XHRequest.
   */ withCredentials: false,
    /**
   * The timeout for the XHR requests in milliseconds (since `v4.4.0`).
   * If set to null or 0, no timeout is going to be set.
   */ timeout: null,
    /**
   * How many file uploads to process in parallel (See the
   * Enqueuing file uploads documentation section for more info)
   */ parallelUploads: 2,
    /**
   * Whether to send multiple files in one request. If
   * this it set to true, then the fallback file input element will
   * have the `multiple` attribute as well. This option will
   * also trigger additional events (like `processingmultiple`). See the events
   * documentation section for more information.
   */ uploadMultiple: false,
    /**
   * Whether you want files to be uploaded in chunks to your server. This can't be
   * used in combination with `uploadMultiple`.
   *
   * See [chunksUploaded](#config-chunksUploaded) for the callback to finalise an upload.
   */ chunking: false,
    /**
   * If `chunking` is enabled, this defines whether **every** file should be chunked,
   * even if the file size is below chunkSize. This means, that the additional chunk
   * form data will be submitted and the `chunksUploaded` callback will be invoked.
   */ forceChunking: false,
    /**
   * If `chunking` is `true`, then this defines the chunk size in bytes.
   */ chunkSize: 2097152,
    /**
   * If `true`, the individual chunks of a file are being uploaded simultaneously.
   */ parallelChunkUploads: false,
    /**
   * Whether a chunk should be retried if it fails.
   */ retryChunks: false,
    /**
   * If `retryChunks` is true, how many times should it be retried.
   */ retryChunksLimit: 3,
    /**
   * The maximum filesize (in MiB) that is allowed to be uploaded.
   */ maxFilesize: 256,
    /**
   * The name of the file param that gets transferred.
   * **NOTE**: If you have the option  `uploadMultiple` set to `true`, then
   * Dropzone will append `[]` to the name.
   */ paramName: "file",
    /**
   * Whether thumbnails for images should be generated
   */ createImageThumbnails: true,
    /**
   * In MB. When the filename exceeds this limit, the thumbnail will not be generated.
   */ maxThumbnailFilesize: 10,
    /**
   * If `null`, the ratio of the image will be used to calculate it.
   */ thumbnailWidth: 120,
    /**
   * The same as `thumbnailWidth`. If both are null, images will not be resized.
   */ thumbnailHeight: 120,
    /**
   * How the images should be scaled down in case both, `thumbnailWidth` and `thumbnailHeight` are provided.
   * Can be either `contain` or `crop`.
   */ thumbnailMethod: "crop",
    /**
   * If set, images will be resized to these dimensions before being **uploaded**.
   * If only one, `resizeWidth` **or** `resizeHeight` is provided, the original aspect
   * ratio of the file will be preserved.
   *
   * The `options.transformFile` function uses these options, so if the `transformFile` function
   * is overridden, these options don't do anything.
   */ resizeWidth: null,
    /**
   * See `resizeWidth`.
   */ resizeHeight: null,
    /**
   * The mime type of the resized image (before it gets uploaded to the server).
   * If `null` the original mime type will be used. To force jpeg, for example, use `image/jpeg`.
   * See `resizeWidth` for more information.
   */ resizeMimeType: null,
    /**
   * The quality of the resized images. See `resizeWidth`.
   */ resizeQuality: 0.8,
    /**
   * How the images should be scaled down in case both, `resizeWidth` and `resizeHeight` are provided.
   * Can be either `contain` or `crop`.
   */ resizeMethod: "contain",
    /**
   * The base that is used to calculate the **displayed** filesize. You can
   * change this to 1024 if you would rather display kibibytes, mebibytes,
   * etc... 1024 is technically incorrect, because `1024 bytes` are `1 kibibyte`
   * not `1 kilobyte`. You can change this to `1024` if you don't care about
   * validity.
   */ filesizeBase: 1000,
    /**
   * If not `null` defines how many files this Dropzone handles. If it exceeds,
   * the event `maxfilesexceeded` will be called. The dropzone element gets the
   * class `dz-max-files-reached` accordingly so you can provide visual
   * feedback.
   */ maxFiles: null,
    /**
   * An optional object to send additional headers to the server. Eg:
   * `{ "My-Awesome-Header": "header value" }`
   */ headers: null,
    /**
   * Should the default headers be set or not?
   * Accept: application/json <- for requesting json response
   * Cache-Control: no-cache <- Request shouldnt be cached
   * X-Requested-With: XMLHttpRequest <- We sent the request via XMLHttpRequest
   */ defaultHeaders: true,
    /**
   * If `true`, the dropzone element itself will be clickable, if `false`
   * nothing will be clickable.
   *
   * You can also pass an HTML element, a CSS selector (for multiple elements)
   * or an array of those. In that case, all of those elements will trigger an
   * upload when clicked.
   */ clickable: true,
    /**
   * Whether hidden files in directories should be ignored.
   */ ignoreHiddenFiles: true,
    /**
   * The default implementation of `accept` checks the file's mime type or
   * extension against this list. This is a comma separated list of mime
   * types or file extensions.
   *
   * Eg.: `image/*,application/pdf,.psd`
   *
   * If the Dropzone is `clickable` this option will also be used as
   * [`accept`](https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept)
   * parameter on the hidden file input as well.
   */ acceptedFiles: null,
    /**
   * **Deprecated!**
   * Use acceptedFiles instead.
   */ acceptedMimeTypes: null,
    /**
   * If false, files will be added to the queue but the queue will not be
   * processed automatically.
   * This can be useful if you need some additional user input before sending
   * files (or if you want want all files sent at once).
   * If you're ready to send the file simply call `myDropzone.processQueue()`.
   *
   * See the [enqueuing file uploads](#enqueuing-file-uploads) documentation
   * section for more information.
   */ autoProcessQueue: true,
    /**
   * If false, files added to the dropzone will not be queued by default.
   * You'll have to call `enqueueFile(file)` manually.
   */ autoQueue: true,
    /**
   * If `true`, this will add a link to every file preview to remove or cancel (if
   * already uploading) the file. The `dictCancelUpload`, `dictCancelUploadConfirmation`
   * and `dictRemoveFile` options are used for the wording.
   */ addRemoveLinks: false,
    /**
   * Defines where to display the file previews – if `null` the
   * Dropzone element itself is used. Can be a plain `HTMLElement` or a CSS
   * selector. The element should have the `dropzone-previews` class so
   * the previews are displayed properly.
   */ previewsContainer: null,
    /**
   * Set this to `true` if you don't want previews to be shown.
   */ disablePreviews: false,
    /**
   * This is the element the hidden input field (which is used when clicking on the
   * dropzone to trigger file selection) will be appended to. This might
   * be important in case you use frameworks to switch the content of your page.
   *
   * Can be a selector string, or an element directly.
   */ hiddenInputContainer: "body",
    /**
   * If null, no capture type will be specified
   * If camera, mobile devices will skip the file selection and choose camera
   * If microphone, mobile devices will skip the file selection and choose the microphone
   * If camcorder, mobile devices will skip the file selection and choose the camera in video mode
   * On apple devices multiple must be set to false.  AcceptedFiles may need to
   * be set to an appropriate mime type (e.g. "image/*", "audio/*", or "video/*").
   */ capture: null,
    /**
   * **Deprecated**. Use `renameFile` instead.
   */ renameFilename: null,
    /**
   * A function that is invoked before the file is uploaded to the server and renames the file.
   * This function gets the `File` as argument and can use the `file.name`. The actual name of the
   * file that gets used during the upload can be accessed through `file.upload.filename`.
   */ renameFile: null,
    /**
   * If `true` the fallback will be forced. This is very useful to test your server
   * implementations first and make sure that everything works as
   * expected without dropzone if you experience problems, and to test
   * how your fallbacks will look.
   */ forceFallback: false,
    /**
   * The text used before any files are dropped.
   */ dictDefaultMessage: "Drop files here to upload",
    /**
   * The text that replaces the default message text it the browser is not supported.
   */ dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
    /**
   * The text that will be added before the fallback form.
   * If you provide a  fallback element yourself, or if this option is `null` this will
   * be ignored.
   */ dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
    /**
   * If the filesize is too big.
   * `{{filesize}}` and `{{maxFilesize}}` will be replaced with the respective configuration values.
   */ dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    /**
   * If the file doesn't match the file type.
   */ dictInvalidFileType: "You can't upload files of this type.",
    /**
   * If the server response was invalid.
   * `{{statusCode}}` will be replaced with the servers status code.
   */ dictResponseError: "Server responded with {{statusCode}} code.",
    /**
   * If `addRemoveLinks` is true, the text to be used for the cancel upload link.
   */ dictCancelUpload: "Cancel upload",
    /**
   * The text that is displayed if an upload was manually canceled
   */ dictUploadCanceled: "Upload canceled.",
    /**
   * If `addRemoveLinks` is true, the text to be used for confirmation when cancelling upload.
   */ dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    /**
   * If `addRemoveLinks` is true, the text to be used to remove a file.
   */ dictRemoveFile: "Remove file",
    /**
   * If this is not null, then the user will be prompted before removing a file.
   */ dictRemoveFileConfirmation: null,
    /**
   * Displayed if `maxFiles` is st and exceeded.
   * The string `{{maxFiles}}` will be replaced by the configuration value.
   */ dictMaxFilesExceeded: "You can not upload any more files.",
    /**
   * Allows you to translate the different units. Starting with `tb` for terabytes and going down to
   * `b` for bytes.
   */ dictFileSizeUnits: {
        tb: "TB",
        gb: "GB",
        mb: "MB",
        kb: "KB",
        b: "b"
    },
    /**
   * Called when dropzone initialized
   * You can add event listeners here
   */ init () {},
    /**
   * Can be an **object** of additional parameters to transfer to the server, **or** a `Function`
   * that gets invoked with the `files`, `xhr` and, if it's a chunked upload, `chunk` arguments. In case
   * of a function, this needs to return a map.
   *
   * The default implementation does nothing for normal uploads, but adds relevant information for
   * chunked uploads.
   *
   * This is the same as adding hidden input fields in the form element.
   */ params (files, xhr, chunk) {
        if (chunk) return {
            dzuuid: chunk.file.upload.uuid,
            dzchunkindex: chunk.index,
            dztotalfilesize: chunk.file.size,
            dzchunksize: this.options.chunkSize,
            dztotalchunkcount: chunk.file.upload.totalChunkCount,
            dzchunkbyteoffset: chunk.index * this.options.chunkSize
        };
    },
    /**
   * A function that gets a [file](https://developer.mozilla.org/en-US/docs/DOM/File)
   * and a `done` function as parameters.
   *
   * If the done function is invoked without arguments, the file is "accepted" and will
   * be processed. If you pass an error message, the file is rejected, and the error
   * message will be displayed.
   * This function will not be called if the file is too big or doesn't match the mime types.
   */ accept (file, done) {
        return done();
    },
    /**
   * The callback that will be invoked when all chunks have been uploaded for a file.
   * It gets the file for which the chunks have been uploaded as the first parameter,
   * and the `done` function as second. `done()` needs to be invoked when everything
   * needed to finish the upload process is done.
   */ chunksUploaded: function(file, done) {
        done();
    },
    /**
   * Sends the file as binary blob in body instead of form data.
   * If this is set, the `params` option will be ignored.
   * It's an error to set this to `true` along with `uploadMultiple` since
   * multiple files cannot be in a single binary body.
   */ binaryBody: false,
    /**
   * Gets called when the browser is not supported.
   * The default implementation shows the fallback input field and adds
   * a text.
   */ fallback () {
        // This code should pass in IE7... :(
        let messageElement;
        this.element.className = `${this.element.className} dz-browser-not-supported`;
        for (let child of this.element.getElementsByTagName("div"))if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message"; // Removes the 'dz-default' class
            break;
        }
        if (!messageElement) {
            messageElement = $540cd3dd02161f28$export$2e2bcd8739ae039.createElement('<div class="dz-message"><span></span></div>');
            this.element.appendChild(messageElement);
        }
        let span = messageElement.getElementsByTagName("span")[0];
        if (span) {
            if (span.textContent != null) span.textContent = this.options.dictFallbackMessage;
            else if (span.innerText != null) span.innerText = this.options.dictFallbackMessage;
        }
        return this.element.appendChild(this.getFallbackForm());
    },
    /**
   * Gets called to calculate the thumbnail dimensions.
   *
   * It gets `file`, `width` and `height` (both may be `null`) as parameters and must return an object containing:
   *
   *  - `srcWidth` & `srcHeight` (required)
   *  - `trgWidth` & `trgHeight` (required)
   *  - `srcX` & `srcY` (optional, default `0`)
   *  - `trgX` & `trgY` (optional, default `0`)
   *
   * Those values are going to be used by `ctx.drawImage()`.
   */ resize (file, width, height, resizeMethod) {
        let info = {
            srcX: 0,
            srcY: 0,
            srcWidth: file.width,
            srcHeight: file.height
        };
        let srcRatio = file.width / file.height;
        // Automatically calculate dimensions if not specified
        if (width == null && height == null) {
            width = info.srcWidth;
            height = info.srcHeight;
        } else if (width == null) width = height * srcRatio;
        else if (height == null) height = width / srcRatio;
        // Make sure images aren't upscaled
        width = Math.min(width, info.srcWidth);
        height = Math.min(height, info.srcHeight);
        let trgRatio = width / height;
        if (info.srcWidth > width || info.srcHeight > height) {
            // Image is bigger and needs rescaling
            if (resizeMethod === "crop") {
                if (srcRatio > trgRatio) {
                    info.srcHeight = file.height;
                    info.srcWidth = info.srcHeight * trgRatio;
                } else {
                    info.srcWidth = file.width;
                    info.srcHeight = info.srcWidth / trgRatio;
                }
            } else if (resizeMethod === "contain") {
                // Method 'contain'
                if (srcRatio > trgRatio) height = width / srcRatio;
                else width = height * srcRatio;
            } else throw new Error(`Unknown resizeMethod '${resizeMethod}'`);
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        info.trgWidth = width;
        info.trgHeight = height;
        return info;
    },
    /**
   * Can be used to transform the file (for example, resize an image if necessary).
   *
   * The default implementation uses `resizeWidth` and `resizeHeight` (if provided) and resizes
   * images according to those dimensions.
   *
   * Gets the `file` as the first parameter, and a `done()` function as the second, that needs
   * to be invoked with the file when the transformation is done.
   */ transformFile (file, done) {
        if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) return this.resizeImage(file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
        else return done(file);
    },
    /**
   * A string that contains the template used for each dropped
   * file. Change it to fulfill your needs but make sure to properly
   * provide all elements.
   *
   * If you want to use an actual HTML element instead of providing a String
   * as a config option, you could create a div with the id `tpl`,
   * put the template inside it and provide the element like this:
   *
   *     document
   *       .querySelector('#tpl')
   *       .innerHTML
   *
   */ previewTemplate: /*@__PURE__*/ $540cd3dd02161f28$var$$parcel$interopDefault($540cd3dd02161f28$var$$fd6031f88dce2e32$exports),
    /*
   Those functions register themselves to the events on init and handle all
   the user interface specific stuff. Overwriting them won't break the upload
   but can break the way it's displayed.
   You can overwrite them if you don't like the default behavior. If you just
   want to add an additional event handler, register it on the dropzone object
   and don't overwrite those options.
   */ // Those are self explanatory and simply concern the DragnDrop.
    drop (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragstart (e) {},
    dragend (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragenter (e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragover (e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragleave (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    paste (e) {},
    // Called whenever there are no files left in the dropzone anymore, and the
    // dropzone should be displayed as if in the initial state.
    reset () {
        return this.element.classList.remove("dz-started");
    },
    // Called when a file is added to the queue
    // Receives `file`
    addedfile (file) {
        if (this.element === this.previewsContainer) this.element.classList.add("dz-started");
        if (this.previewsContainer && !this.options.disablePreviews) {
            file.previewElement = $540cd3dd02161f28$export$2e2bcd8739ae039.createElement(this.options.previewTemplate.trim());
            file.previewTemplate = file.previewElement; // Backwards compatibility
            this.previewsContainer.appendChild(file.previewElement);
            for (var node of file.previewElement.querySelectorAll("[data-dz-name]"))node.textContent = file.name;
            for (node of file.previewElement.querySelectorAll("[data-dz-size]"))node.innerHTML = this.filesize(file.size);
            if (this.options.addRemoveLinks) {
                file._removeLink = $540cd3dd02161f28$export$2e2bcd8739ae039.createElement(`<a class="dz-remove" href="javascript:undefined;" data-dz-remove>${this.options.dictRemoveFile}</a>`);
                file.previewElement.appendChild(file._removeLink);
            }
            let removeFileEvent = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                if (file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING) return $540cd3dd02161f28$export$2e2bcd8739ae039.confirm(this.options.dictCancelUploadConfirmation, ()=>this.removeFile(file));
                else {
                    if (this.options.dictRemoveFileConfirmation) return $540cd3dd02161f28$export$2e2bcd8739ae039.confirm(this.options.dictRemoveFileConfirmation, ()=>this.removeFile(file));
                    else return this.removeFile(file);
                }
            };
            for (let removeLink of file.previewElement.querySelectorAll("[data-dz-remove]"))removeLink.addEventListener("click", removeFileEvent);
        }
    },
    // Called whenever a file is removed.
    removedfile (file) {
        if (file.previewElement != null && file.previewElement.parentNode != null) file.previewElement.parentNode.removeChild(file.previewElement);
        return this._updateMaxFilesReachedClass();
    },
    // Called when a thumbnail has been generated
    // Receives `file` and `dataUrl`
    thumbnail (file, dataUrl) {
        if (file.previewElement) {
            file.previewElement.classList.remove("dz-file-preview");
            for (let thumbnailElement of file.previewElement.querySelectorAll("[data-dz-thumbnail]")){
                thumbnailElement.alt = file.name;
                thumbnailElement.src = dataUrl;
            }
            return setTimeout(()=>file.previewElement.classList.add("dz-image-preview"), 1);
        }
    },
    // Called whenever an error occurs
    // Receives `file` and `message`
    error (file, message) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-error");
            if (typeof message !== "string" && message.error) message = message.error;
            for (let node of file.previewElement.querySelectorAll("[data-dz-errormessage]"))node.textContent = message;
        }
    },
    errormultiple () {},
    // Called when a file gets processed. Since there is a cue, not all added
    // files are processed immediately.
    // Receives `file`
    processing (file) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-processing");
            if (file._removeLink) return file._removeLink.innerHTML = this.options.dictCancelUpload;
        }
    },
    processingmultiple () {},
    // Called whenever the upload progress gets updated.
    // Receives `file`, `progress` (percentage 0-100) and `bytesSent`.
    // To get the total number of bytes of the file, use `file.size`
    uploadprogress (file, progress, bytesSent) {
        if (file.previewElement) for (let node of file.previewElement.querySelectorAll("[data-dz-uploadprogress]"))node.nodeName === "PROGRESS" ? node.value = progress : node.style.width = `${progress}%`;
    },
    // Called whenever the total upload progress gets updated.
    // Called with totalUploadProgress (0-100), totalBytes and totalBytesSent
    totaluploadprogress () {},
    // Called just before the file is sent. Gets the `xhr` object as second
    // parameter, so you can modify it (for example to add a CSRF token) and a
    // `formData` object to add additional information.
    sending () {},
    sendingmultiple () {},
    // When the complete upload is finished and successful
    // Receives `file`
    success (file) {
        if (file.previewElement) return file.previewElement.classList.add("dz-success");
    },
    successmultiple () {},
    // When the upload is canceled.
    canceled (file) {
        return this.emit("error", file, this.options.dictUploadCanceled);
    },
    canceledmultiple () {},
    // When the upload is finished, either with success or an error.
    // Receives `file`
    complete (file) {
        if (file._removeLink) file._removeLink.innerHTML = this.options.dictRemoveFile;
        if (file.previewElement) return file.previewElement.classList.add("dz-complete");
    },
    completemultiple () {},
    maxfilesexceeded () {},
    maxfilesreached () {},
    queuecomplete () {},
    addedfiles () {}
};
var $540cd3dd02161f28$var$$4ca367182776f80b$export$2e2bcd8739ae039 = $540cd3dd02161f28$var$$4ca367182776f80b$var$defaultOptions;
class $540cd3dd02161f28$export$2e2bcd8739ae039 extends $540cd3dd02161f28$var$$4040acfd8584338d$export$2e2bcd8739ae039 {
    static initClass() {
        // Exposing the emitter class, mainly for tests
        this.prototype.Emitter = $540cd3dd02161f28$var$$4040acfd8584338d$export$2e2bcd8739ae039;
        /*
     This is a list of all available events you can register on a dropzone object.

     You can register an event handler like this:

     dropzone.on("dragEnter", function() { });

     */ this.prototype.events = [
            "drop",
            "dragstart",
            "dragend",
            "dragenter",
            "dragover",
            "dragleave",
            "addedfile",
            "addedfiles",
            "removedfile",
            "thumbnail",
            "error",
            "errormultiple",
            "processing",
            "processingmultiple",
            "uploadprogress",
            "totaluploadprogress",
            "sending",
            "sendingmultiple",
            "success",
            "successmultiple",
            "canceled",
            "canceledmultiple",
            "complete",
            "completemultiple",
            "reset",
            "maxfilesexceeded",
            "maxfilesreached",
            "queuecomplete"
        ];
        this.prototype._thumbnailQueue = [];
        this.prototype._processingThumbnail = false;
    }
    // Returns all files that have been accepted
    getAcceptedFiles() {
        return this.files.filter((file)=>file.accepted).map((file)=>file);
    }
    // Returns all files that have been rejected
    // Not sure when that's going to be useful, but added for completeness.
    getRejectedFiles() {
        return this.files.filter((file)=>!file.accepted).map((file)=>file);
    }
    getFilesWithStatus(status) {
        return this.files.filter((file)=>file.status === status).map((file)=>file);
    }
    // Returns all files that are in the queue
    getQueuedFiles() {
        return this.getFilesWithStatus($540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED);
    }
    getUploadingFiles() {
        return this.getFilesWithStatus($540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING);
    }
    getAddedFiles() {
        return this.getFilesWithStatus($540cd3dd02161f28$export$2e2bcd8739ae039.ADDED);
    }
    // Files that are either queued or uploading
    getActiveFiles() {
        return this.files.filter((file)=>file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING || file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED).map((file)=>file);
    }
    // The function that gets called when Dropzone is initialized. You
    // can (and should) setup event listeners inside this function.
    init() {
        // In case it isn't set already
        if (this.element.tagName === "form") this.element.setAttribute("enctype", "multipart/form-data");
        if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) this.element.appendChild($540cd3dd02161f28$export$2e2bcd8739ae039.createElement(`<div class="dz-default dz-message"><button class="dz-button" type="button">${this.options.dictDefaultMessage}</button></div>`));
        if (this.clickableElements.length) {
            let setupHiddenFileInput = ()=>{
                if (this.hiddenFileInput) this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
                this.hiddenFileInput = document.createElement("input");
                this.hiddenFileInput.setAttribute("type", "file");
                if (this.options.maxFiles === null || this.options.maxFiles > 1) this.hiddenFileInput.setAttribute("multiple", "multiple");
                this.hiddenFileInput.className = "dz-hidden-input";
                if (this.options.acceptedFiles !== null) this.hiddenFileInput.setAttribute("accept", this.options.acceptedFiles);
                if (this.options.capture !== null) this.hiddenFileInput.setAttribute("capture", this.options.capture);
                // Making sure that no one can "tab" into this field.
                this.hiddenFileInput.setAttribute("tabindex", "-1");
                // Not setting `display="none"` because some browsers don't accept clicks
                // on elements that aren't displayed.
                this.hiddenFileInput.style.visibility = "hidden";
                this.hiddenFileInput.style.position = "absolute";
                this.hiddenFileInput.style.top = "0";
                this.hiddenFileInput.style.left = "0";
                this.hiddenFileInput.style.height = "0";
                this.hiddenFileInput.style.width = "0";
                $540cd3dd02161f28$export$2e2bcd8739ae039.getElement(this.options.hiddenInputContainer, "hiddenInputContainer").appendChild(this.hiddenFileInput);
                this.hiddenFileInput.addEventListener("change", ()=>{
                    let { files: files } = this.hiddenFileInput;
                    if (files.length) for (let file of files)this.addFile(file);
                    this.emit("addedfiles", files);
                    setupHiddenFileInput();
                });
            };
            setupHiddenFileInput();
        }
        this.URL = window.URL !== null ? window.URL : window.webkitURL;
        // Setup all event listeners on the Dropzone object itself.
        // They're not in @setupEventListeners() because they shouldn't be removed
        // again when the dropzone gets disabled.
        for (let eventName of this.events)this.on(eventName, this.options[eventName]);
        this.on("uploadprogress", ()=>this.updateTotalUploadProgress());
        this.on("removedfile", ()=>this.updateTotalUploadProgress());
        this.on("canceled", (file)=>this.emit("complete", file));
        // Emit a `queuecomplete` event if all files finished uploading.
        this.on("complete", (file)=>{
            if (this.getAddedFiles().length === 0 && this.getUploadingFiles().length === 0 && this.getQueuedFiles().length === 0) return setTimeout(()=>this.emit("queuecomplete"), 0);
        });
        const containsFiles = function(e) {
            if (e.dataTransfer.types) // IE, we need to iterate like this instead of
            // using e.dataTransfer.types.some()
            for(var i = 0; i < e.dataTransfer.types.length; i++){
                if (e.dataTransfer.types[i] === "Files") return true;
            }
            return false;
        };
        let noPropagation = function(e) {
            // If there are no files, we don't want to stop
            // propagation so we don't interfere with other
            // drag and drop behaviour.
            if (!containsFiles(e)) return;
            e.stopPropagation();
            if (e.preventDefault) return e.preventDefault();
            else return e.returnValue = false;
        };
        // Create the listeners
        this.listeners = [
            {
                element: this.element,
                events: {
                    dragstart: (e)=>{
                        return this.emit("dragstart", e);
                    },
                    dragenter: (e)=>{
                        noPropagation(e);
                        return this.emit("dragenter", e);
                    },
                    dragover: (e)=>{
                        // Makes it possible to drag files from chrome's download bar
                        // http://stackoverflow.com/questions/19526430/drag-and-drop-file-uploads-from-chrome-downloads-bar
                        // Try is required to prevent bug in Internet Explorer 11 (SCRIPT65535 exception)
                        let efct;
                        try {
                            efct = e.dataTransfer.effectAllowed;
                        } catch (error) {}
                        e.dataTransfer.dropEffect = "move" === efct || "linkMove" === efct ? "move" : "copy";
                        noPropagation(e);
                        return this.emit("dragover", e);
                    },
                    dragleave: (e)=>{
                        return this.emit("dragleave", e);
                    },
                    drop: (e)=>{
                        noPropagation(e);
                        return this.drop(e);
                    },
                    dragend: (e)=>{
                        return this.emit("dragend", e);
                    }
                }
            }
        ];
        this.clickableElements.forEach((clickableElement)=>{
            return this.listeners.push({
                element: clickableElement,
                events: {
                    click: (evt)=>{
                        // Only the actual dropzone or the message element should trigger file selection
                        if (clickableElement !== this.element || evt.target === this.element || $540cd3dd02161f28$export$2e2bcd8739ae039.elementInside(evt.target, this.element.querySelector(".dz-message"))) this.hiddenFileInput.click(); // Forward the click
                        return true;
                    }
                }
            });
        });
        this.enable();
        return this.options.init.call(this);
    }
    // Not fully tested yet
    destroy() {
        this.disable();
        this.removeAllFiles(true);
        if (this.hiddenFileInput != null ? this.hiddenFileInput.parentNode : undefined) {
            this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
            this.hiddenFileInput = null;
        }
        delete this.element.dropzone;
        return $540cd3dd02161f28$export$2e2bcd8739ae039.instances.splice($540cd3dd02161f28$export$2e2bcd8739ae039.instances.indexOf(this), 1);
    }
    updateTotalUploadProgress() {
        let totalUploadProgress;
        let totalBytesSent = 0;
        let totalBytes = 0;
        let activeFiles = this.getActiveFiles();
        if (activeFiles.length) {
            for (let file of this.getActiveFiles()){
                totalBytesSent += file.upload.bytesSent;
                totalBytes += file.upload.total;
            }
            totalUploadProgress = 100 * totalBytesSent / totalBytes;
        } else totalUploadProgress = 100;
        return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    }
    // @options.paramName can be a function taking one parameter rather than a string.
    // A parameter name for a file is obtained simply by calling this with an index number.
    _getParamName(n) {
        if (typeof this.options.paramName === "function") return this.options.paramName(n);
        else return `${this.options.paramName}${this.options.uploadMultiple ? `[${n}]` : ""}`;
    }
    // If @options.renameFile is a function,
    // the function will be used to rename the file.name before appending it to the formData
    _renameFile(file) {
        if (typeof this.options.renameFile !== "function") return file.name;
        return this.options.renameFile(file);
    }
    // Returns a form that can be used as fallback if the browser does not support DragnDrop
    //
    // If the dropzone is already a form, only the input field and button are returned. Otherwise a complete form element is provided.
    // This code has to pass in IE7 :(
    getFallbackForm() {
        let existingFallback, form;
        if (existingFallback = this.getExistingFallback()) return existingFallback;
        let fieldsString = '<div class="dz-fallback">';
        if (this.options.dictFallbackText) fieldsString += `<p>${this.options.dictFallbackText}</p>`;
        fieldsString += `<input type="file" name="${this._getParamName(0)}" ${this.options.uploadMultiple ? 'multiple="multiple"' : undefined} /><input type="submit" value="Upload!"></div>`;
        let fields = $540cd3dd02161f28$export$2e2bcd8739ae039.createElement(fieldsString);
        if (this.element.tagName !== "FORM") {
            form = $540cd3dd02161f28$export$2e2bcd8739ae039.createElement(`<form action="${this.options.url}" enctype="multipart/form-data" method="${this.options.method}"></form>`);
            form.appendChild(fields);
        } else {
            // Make sure that the enctype and method attributes are set properly
            this.element.setAttribute("enctype", "multipart/form-data");
            this.element.setAttribute("method", this.options.method);
        }
        return form != null ? form : fields;
    }
    // Returns the fallback elements if they exist already
    //
    // This code has to pass in IE7 :(
    getExistingFallback() {
        let getFallback = function(elements) {
            for (let el of elements){
                if (/(^| )fallback($| )/.test(el.className)) return el;
            }
        };
        for (let tagName of [
            "div",
            "form"
        ]){
            var fallback;
            if (fallback = getFallback(this.element.getElementsByTagName(tagName))) return fallback;
        }
    }
    // Activates all listeners stored in @listeners
    setupEventListeners() {
        return this.listeners.map((elementListeners)=>(()=>{
                let result = [];
                for(let event in elementListeners.events){
                    let listener = elementListeners.events[event];
                    result.push(elementListeners.element.addEventListener(event, listener, false));
                }
                return result;
            })());
    }
    // Deactivates all listeners stored in @listeners
    removeEventListeners() {
        return this.listeners.map((elementListeners)=>(()=>{
                let result = [];
                for(let event in elementListeners.events){
                    let listener = elementListeners.events[event];
                    result.push(elementListeners.element.removeEventListener(event, listener, false));
                }
                return result;
            })());
    }
    // Removes all event listeners and cancels all files in the queue or being processed.
    disable() {
        this.clickableElements.forEach((element)=>element.classList.remove("dz-clickable"));
        this.removeEventListeners();
        this.disabled = true;
        return this.files.map((file)=>this.cancelUpload(file));
    }
    enable() {
        delete this.disabled;
        this.clickableElements.forEach((element)=>element.classList.add("dz-clickable"));
        return this.setupEventListeners();
    }
    // Returns a nicely formatted filesize
    filesize(size) {
        let selectedSize = 0;
        let selectedUnit = "b";
        if (size > 0) {
            let units = [
                "tb",
                "gb",
                "mb",
                "kb",
                "b"
            ];
            for(let i = 0; i < units.length; i++){
                let unit = units[i];
                let cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
                if (size >= cutoff) {
                    selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
                    selectedUnit = unit;
                    break;
                }
            }
            selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
        }
        return `<strong>${selectedSize}</strong> ${this.options.dictFileSizeUnits[selectedUnit]}`;
    }
    // Adds or removes the `dz-max-files-reached` class from the form.
    _updateMaxFilesReachedClass() {
        if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
            if (this.getAcceptedFiles().length === this.options.maxFiles) this.emit("maxfilesreached", this.files);
            return this.element.classList.add("dz-max-files-reached");
        } else return this.element.classList.remove("dz-max-files-reached");
    }
    drop(e) {
        if (!e.dataTransfer) return;
        this.emit("drop", e);
        // Convert the FileList to an Array
        // This is necessary for IE11
        let files = [];
        for(let i = 0; i < e.dataTransfer.files.length; i++)files[i] = e.dataTransfer.files[i];
        // Even if it's a folder, files.length will contain the folders.
        if (files.length) {
            let { items: items } = e.dataTransfer;
            if (items && items.length && items[0].webkitGetAsEntry != null) this._addFilesFromItems(items);
            else this.handleFiles(files);
        }
        this.emit("addedfiles", files);
    }
    paste(e) {
        if ($540cd3dd02161f28$var$$3ed269f2f0fb224b$var$__guard__(e != null ? e.clipboardData : undefined, (x)=>x.items) == null) return;
        this.emit("paste", e);
        let { items: items } = e.clipboardData;
        if (items.length) return this._addFilesFromItems(items);
    }
    handleFiles(files) {
        for (let file of files)this.addFile(file);
    }
    // When a folder is dropped (or files are pasted), items must be handled
    // instead of files.
    _addFilesFromItems(items) {
        return (()=>{
            let result = [];
            for (let item of items){
                var entry;
                if (item.webkitGetAsEntry != null && (entry = item.webkitGetAsEntry())) {
                    if (entry.isFile) result.push(this.addFile(item.getAsFile()));
                    else if (entry.isDirectory) result.push(this._addFilesFromDirectory(entry, entry.name));
                    else result.push(undefined);
                } else if (item.getAsFile != null) {
                    if (item.kind == null || item.kind === "file") result.push(this.addFile(item.getAsFile()));
                    else result.push(undefined);
                } else result.push(undefined);
            }
            return result;
        })();
    }
    // Goes through the directory, and adds each file it finds recursively
    _addFilesFromDirectory(directory, path) {
        let dirReader = directory.createReader();
        let errorHandler = (error)=>$540cd3dd02161f28$var$$3ed269f2f0fb224b$var$__guardMethod__(console, "log", (o)=>o.log(error));
        var readEntries = ()=>{
            return dirReader.readEntries((entries)=>{
                if (entries.length > 0) {
                    for (let entry of entries){
                        if (entry.isFile) entry.file((file)=>{
                            if (this.options.ignoreHiddenFiles && file.name.substring(0, 1) === ".") return;
                            file.fullPath = `${path}/${file.name}`;
                            return this.addFile(file);
                        });
                        else if (entry.isDirectory) this._addFilesFromDirectory(entry, `${path}/${entry.name}`);
                    }
                    // Recursively call readEntries() again, since browser only handle
                    // the first 100 entries.
                    // See: https://developer.mozilla.org/en-US/docs/Web/API/DirectoryReader#readEntries
                    readEntries();
                }
                return null;
            }, errorHandler);
        };
        return readEntries();
    }
    // If `done()` is called without argument the file is accepted
    // If you call it with an error message, the file is rejected
    // (This allows for asynchronous validation)
    //
    // This function checks the filesize, and if the file.type passes the
    // `acceptedFiles` check.
    accept(file, done) {
        if (this.options.maxFilesize && file.size > this.options.maxFilesize * 1048576) done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
        else if (!$540cd3dd02161f28$export$2e2bcd8739ae039.isValidFile(file, this.options.acceptedFiles)) done(this.options.dictInvalidFileType);
        else if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
            done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
            this.emit("maxfilesexceeded", file);
        } else this.options.accept.call(this, file, done);
    }
    addFile(file) {
        file.upload = {
            uuid: $540cd3dd02161f28$export$2e2bcd8739ae039.uuidv4(),
            progress: 0,
            // Setting the total upload size to file.size for the beginning
            // It's actual different than the size to be transmitted.
            total: file.size,
            bytesSent: 0,
            filename: this._renameFile(file)
        };
        this.files.push(file);
        file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.ADDED;
        this.emit("addedfile", file);
        this._enqueueThumbnail(file);
        this.accept(file, (error)=>{
            if (error) {
                file.accepted = false;
                this._errorProcessing([
                    file
                ], error); // Will set the file.status
            } else {
                file.accepted = true;
                if (this.options.autoQueue) this.enqueueFile(file);
            // Will set .accepted = true
            }
            this._updateMaxFilesReachedClass();
        });
    }
    // Wrapper for enqueueFile
    enqueueFiles(files) {
        for (let file of files)this.enqueueFile(file);
        return null;
    }
    enqueueFile(file) {
        if (file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.ADDED && file.accepted === true) {
            file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED;
            if (this.options.autoProcessQueue) return setTimeout(()=>this.processQueue(), 0); // Deferring the call
        } else throw new Error("This file can't be queued because it has already been processed or was rejected.");
    }
    _enqueueThumbnail(file) {
        if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1048576) {
            this._thumbnailQueue.push(file);
            return setTimeout(()=>this._processThumbnailQueue(), 0); // Deferring the call
        }
    }
    _processThumbnailQueue() {
        if (this._processingThumbnail || this._thumbnailQueue.length === 0) return;
        this._processingThumbnail = true;
        let file = this._thumbnailQueue.shift();
        return this.createThumbnail(file, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, true, (dataUrl)=>{
            this.emit("thumbnail", file, dataUrl);
            this._processingThumbnail = false;
            return this._processThumbnailQueue();
        });
    }
    // Can be called by the user to remove a file
    removeFile(file) {
        if (file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING) this.cancelUpload(file);
        this.files = $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$without(this.files, file);
        this.emit("removedfile", file);
        if (this.files.length === 0) return this.emit("reset");
    }
    // Removes all files that aren't currently processed from the list
    removeAllFiles(cancelIfNecessary) {
        // Create a copy of files since removeFile() changes the @files array.
        if (cancelIfNecessary == null) cancelIfNecessary = false;
        for (let file of this.files.slice())if (file.status !== $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING || cancelIfNecessary) this.removeFile(file);
        return null;
    }
    // Resizes an image before it gets sent to the server. This function is the default behavior of
    // `options.transformFile` if `resizeWidth` or `resizeHeight` are set. The callback is invoked with
    // the resized blob.
    resizeImage(file, width, height, resizeMethod, callback) {
        return this.createThumbnail(file, width, height, resizeMethod, true, (dataUrl, canvas)=>{
            if (canvas == null) return callback(file);
            else {
                let { resizeMimeType: resizeMimeType } = this.options;
                if (resizeMimeType == null) resizeMimeType = file.type;
                let resizedDataURL = canvas.toDataURL(resizeMimeType, this.options.resizeQuality);
                if (resizeMimeType === "image/jpeg" || resizeMimeType === "image/jpg") resizedDataURL = $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$ExifRestore.restore(file.dataURL, resizedDataURL);
                return callback($540cd3dd02161f28$export$2e2bcd8739ae039.dataURItoBlob(resizedDataURL));
            }
        });
    }
    createThumbnail(file, width, height, resizeMethod, fixOrientation, callback) {
        let fileReader = new FileReader();
        fileReader.onload = ()=>{
            file.dataURL = fileReader.result;
            // Don't bother creating a thumbnail for SVG images since they're vector
            if (file.type === "image/svg+xml") {
                if (callback != null) callback(fileReader.result);
                return;
            }
            this.createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback);
        };
        fileReader.readAsDataURL(file);
    }
    // `mockFile` needs to have these attributes:
    //
    //     { name: 'name', size: 12345, imageUrl: '' }
    //
    // `callback` will be invoked when the image has been downloaded and displayed.
    // `crossOrigin` will be added to the `img` tag when accessing the file.
    displayExistingFile(mockFile, imageUrl, callback, crossOrigin, resizeThumbnail = true) {
        this.emit("addedfile", mockFile);
        this.emit("complete", mockFile);
        if (!resizeThumbnail) {
            this.emit("thumbnail", mockFile, imageUrl);
            if (callback) callback();
        } else {
            let onDone = (thumbnail)=>{
                this.emit("thumbnail", mockFile, thumbnail);
                if (callback) callback();
            };
            mockFile.dataURL = imageUrl;
            this.createThumbnailFromUrl(mockFile, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, this.options.fixOrientation, onDone, crossOrigin);
        }
    }
    createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback, crossOrigin) {
        // Not using `new Image` here because of a bug in latest Chrome versions.
        // See https://github.com/enyo/dropzone/pull/226
        let img = document.createElement("img");
        if (crossOrigin) img.crossOrigin = crossOrigin;
        // fixOrientation is not needed anymore with browsers handling imageOrientation
        fixOrientation = getComputedStyle(document.body)["imageOrientation"] == "from-image" ? false : fixOrientation;
        img.onload = ()=>{
            let loadExif = (callback)=>callback(1);
            if (typeof EXIF !== "undefined" && EXIF !== null && fixOrientation) loadExif = (callback)=>EXIF.getData(img, function() {
                    return callback(EXIF.getTag(this, "Orientation"));
                });
            return loadExif((orientation)=>{
                file.width = img.width;
                file.height = img.height;
                let resizeInfo = this.options.resize.call(this, file, width, height, resizeMethod);
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext("2d");
                canvas.width = resizeInfo.trgWidth;
                canvas.height = resizeInfo.trgHeight;
                if (orientation > 4) {
                    canvas.width = resizeInfo.trgHeight;
                    canvas.height = resizeInfo.trgWidth;
                }
                switch(orientation){
                    case 2:
                        // horizontal flip
                        ctx.translate(canvas.width, 0);
                        ctx.scale(-1, 1);
                        break;
                    case 3:
                        // 180° rotate left
                        ctx.translate(canvas.width, canvas.height);
                        ctx.rotate(Math.PI);
                        break;
                    case 4:
                        // vertical flip
                        ctx.translate(0, canvas.height);
                        ctx.scale(1, -1);
                        break;
                    case 5:
                        // vertical flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.scale(1, -1);
                        break;
                    case 6:
                        // 90° rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(0, -canvas.width);
                        break;
                    case 7:
                        // horizontal flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(canvas.height, -canvas.width);
                        ctx.scale(-1, 1);
                        break;
                    case 8:
                        // 90° rotate left
                        ctx.rotate(-0.5 * Math.PI);
                        ctx.translate(-canvas.height, 0);
                        break;
                }
                // This is a bugfix for iOS' scaling bug.
                $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$drawImageIOSFix(ctx, img, resizeInfo.srcX != null ? resizeInfo.srcX : 0, resizeInfo.srcY != null ? resizeInfo.srcY : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, resizeInfo.trgX != null ? resizeInfo.trgX : 0, resizeInfo.trgY != null ? resizeInfo.trgY : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
                let thumbnail = canvas.toDataURL("image/png");
                if (callback != null) return callback(thumbnail, canvas);
            });
        };
        if (callback != null) img.onerror = callback;
        return img.src = file.dataURL;
    }
    // Goes through the queue and processes files if there aren't too many already.
    processQueue() {
        let { parallelUploads: parallelUploads } = this.options;
        let processingLength = this.getUploadingFiles().length;
        let i = processingLength;
        // There are already at least as many files uploading than should be
        if (processingLength >= parallelUploads) return;
        let queuedFiles = this.getQueuedFiles();
        if (!(queuedFiles.length > 0)) return;
        if (this.options.uploadMultiple) return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
        else while(i < parallelUploads){
            if (!queuedFiles.length) return;
            // Nothing left to process
            this.processFile(queuedFiles.shift());
            i++;
        }
    }
    // Wrapper for `processFiles`
    processFile(file) {
        return this.processFiles([
            file
        ]);
    }
    // Loads the file, then calls finishedLoading()
    processFiles(files) {
        for (let file of files){
            file.processing = true; // Backwards compatibility
            file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING;
            this.emit("processing", file);
        }
        if (this.options.uploadMultiple) this.emit("processingmultiple", files);
        return this.uploadFiles(files);
    }
    _getFilesWithXhr(xhr) {
        let files;
        return files = this.files.filter((file)=>file.xhr === xhr).map((file)=>file);
    }
    // Cancels the file upload and sets the status to CANCELED
    // **if** the file is actually being uploaded.
    // If it's still in the queue, the file is being removed from it and the status
    // set to CANCELED.
    cancelUpload(file) {
        if (file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING) {
            let groupedFiles = this._getFilesWithXhr(file.xhr);
            for (let groupedFile of groupedFiles)groupedFile.status = $540cd3dd02161f28$export$2e2bcd8739ae039.CANCELED;
            if (typeof file.xhr !== "undefined") file.xhr.abort();
            for (let groupedFile1 of groupedFiles)this.emit("canceled", groupedFile1);
            if (this.options.uploadMultiple) this.emit("canceledmultiple", groupedFiles);
        } else if (file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.ADDED || file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED) {
            file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.CANCELED;
            this.emit("canceled", file);
            if (this.options.uploadMultiple) this.emit("canceledmultiple", [
                file
            ]);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    resolveOption(option, ...args) {
        if (typeof option === "function") return option.apply(this, args);
        return option;
    }
    uploadFile(file) {
        return this.uploadFiles([
            file
        ]);
    }
    uploadFiles(files) {
        this._transformFiles(files, (transformedFiles)=>{
            if (this.options.chunking) {
                // Chunking is not allowed to be used with `uploadMultiple` so we know
                // that there is only __one__file.
                let transformedFile = transformedFiles[0];
                files[0].upload.chunked = this.options.chunking && (this.options.forceChunking || transformedFile.size > this.options.chunkSize);
                files[0].upload.totalChunkCount = Math.ceil(transformedFile.size / this.options.chunkSize);
            }
            if (files[0].upload.chunked) {
                // This file should be sent in chunks!
                // If the chunking option is set, we **know** that there can only be **one** file, since
                // uploadMultiple is not allowed with this option.
                let file = files[0];
                let transformedFile = transformedFiles[0];
                let startedChunkCount = 0;
                file.upload.chunks = [];
                let handleNextChunk = ()=>{
                    let chunkIndex = 0;
                    // Find the next item in file.upload.chunks that is not defined yet.
                    while(file.upload.chunks[chunkIndex] !== undefined)chunkIndex++;
                    // This means, that all chunks have already been started.
                    if (chunkIndex >= file.upload.totalChunkCount) return;
                    startedChunkCount++;
                    let start = chunkIndex * this.options.chunkSize;
                    let end = Math.min(start + this.options.chunkSize, transformedFile.size);
                    let dataBlock = {
                        name: this._getParamName(0),
                        data: transformedFile.webkitSlice ? transformedFile.webkitSlice(start, end) : transformedFile.slice(start, end),
                        filename: file.upload.filename,
                        chunkIndex: chunkIndex
                    };
                    file.upload.chunks[chunkIndex] = {
                        file: file,
                        index: chunkIndex,
                        dataBlock: dataBlock,
                        status: $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING,
                        progress: 0,
                        retries: 0
                    };
                    this._uploadData(files, [
                        dataBlock
                    ]);
                };
                file.upload.finishedChunkUpload = (chunk, response)=>{
                    let allFinished = true;
                    chunk.status = $540cd3dd02161f28$export$2e2bcd8739ae039.SUCCESS;
                    // Clear the data from the chunk
                    chunk.dataBlock = null;
                    chunk.response = chunk.xhr.responseText;
                    chunk.responseHeaders = chunk.xhr.getAllResponseHeaders();
                    // Leaving this reference to xhr will cause memory leaks.
                    chunk.xhr = null;
                    for(let i = 0; i < file.upload.totalChunkCount; i++){
                        if (file.upload.chunks[i] === undefined) return handleNextChunk();
                        if (file.upload.chunks[i].status !== $540cd3dd02161f28$export$2e2bcd8739ae039.SUCCESS) allFinished = false;
                    }
                    if (allFinished) this.options.chunksUploaded(file, ()=>{
                        this._finished(files, response, null);
                    });
                };
                if (this.options.parallelChunkUploads) for(let i = 0; i < file.upload.totalChunkCount; i++)handleNextChunk();
                else handleNextChunk();
            } else {
                let dataBlocks = [];
                for(let i = 0; i < files.length; i++)dataBlocks[i] = {
                    name: this._getParamName(i),
                    data: transformedFiles[i],
                    filename: files[i].upload.filename
                };
                this._uploadData(files, dataBlocks);
            }
        });
    }
    /// Returns the right chunk for given file and xhr
    _getChunk(file, xhr) {
        for(let i = 0; i < file.upload.totalChunkCount; i++){
            if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].xhr === xhr) return file.upload.chunks[i];
        }
    }
    // This function actually uploads the file(s) to the server.
    //
    //  If dataBlocks contains the actual data to upload (meaning, that this could
    // either be transformed files, or individual chunks for chunked upload) then
    // they will be used for the actual data to upload.
    _uploadData(files, dataBlocks) {
        let xhr = new XMLHttpRequest();
        // Put the xhr object in the file objects to be able to reference it later.
        for (let file of files)file.xhr = xhr;
        if (files[0].upload.chunked) // later, and found with _getChunk.
        files[0].upload.chunks[dataBlocks[0].chunkIndex].xhr = xhr;
        let method = this.resolveOption(this.options.method, files, dataBlocks);
        let url = this.resolveOption(this.options.url, files, dataBlocks);
        xhr.open(method, url, true);
        // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
        let timeout = this.resolveOption(this.options.timeout, files);
        if (timeout) xhr.timeout = this.resolveOption(this.options.timeout, files);
        // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
        xhr.withCredentials = !!this.options.withCredentials;
        xhr.onload = (e)=>{
            this._finishedUploading(files, xhr, e);
        };
        xhr.ontimeout = ()=>{
            this._handleUploadError(files, xhr, `Request timedout after ${this.options.timeout / 1000} seconds`);
        };
        xhr.onerror = ()=>{
            this._handleUploadError(files, xhr);
        };
        // Some browsers do not have the .upload property
        let progressObj = xhr.upload != null ? xhr.upload : xhr;
        progressObj.onprogress = (e)=>this._updateFilesUploadProgress(files, xhr, e);
        let headers = this.options.defaultHeaders ? {
            Accept: "application/json",
            "Cache-Control": "no-cache",
            "X-Requested-With": "XMLHttpRequest"
        } : {};
        if (this.options.binaryBody) headers["Content-Type"] = files[0].type;
        if (this.options.headers) (0, $ee62ca6949990202$export$2e2bcd8739ae039)(headers, this.options.headers);
        for(let headerName in headers){
            let headerValue = headers[headerName];
            if (headerValue) xhr.setRequestHeader(headerName, headerValue);
        }
        if (this.options.binaryBody) {
            // Since the file is going to be sent as binary body, it doesn't make
            // any sense to generate `FormData` for it.
            for (let file of files)this.emit("sending", file, xhr);
            if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr);
            this.submitRequest(xhr, null, files);
        } else {
            let formData = new FormData();
            // Adding all @options parameters
            if (this.options.params) {
                let additionalParams = this.options.params;
                if (typeof additionalParams === "function") additionalParams = additionalParams.call(this, files, xhr, files[0].upload.chunked ? this._getChunk(files[0], xhr) : null);
                for(let key in additionalParams){
                    let value = additionalParams[key];
                    if (Array.isArray(value)) // so lets iterate over it to attach each value
                    // individually.
                    for(let i = 0; i < value.length; i++)formData.append(key, value[i]);
                    else formData.append(key, value);
                }
            }
            // Let the user add additional data if necessary
            for (let file of files)this.emit("sending", file, xhr, formData);
            if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr, formData);
            this._addFormElementData(formData);
            // Finally add the files
            // Has to be last because some servers (eg: S3) expect the file to be the last parameter
            for(let i = 0; i < dataBlocks.length; i++){
                let dataBlock = dataBlocks[i];
                formData.append(dataBlock.name, dataBlock.data, dataBlock.filename);
            }
            this.submitRequest(xhr, formData, files);
        }
    }
    // Transforms all files with this.options.transformFile and invokes done with the transformed files when done.
    _transformFiles(files, done) {
        let transformedFiles = [];
        // Clumsy way of handling asynchronous calls, until I get to add a proper Future library.
        let doneCounter = 0;
        for(let i = 0; i < files.length; i++)this.options.transformFile.call(this, files[i], (transformedFile)=>{
            transformedFiles[i] = transformedFile;
            if (++doneCounter === files.length) done(transformedFiles);
        });
    }
    // Takes care of adding other input elements of the form to the AJAX request
    _addFormElementData(formData) {
        // Take care of other input elements
        if (this.element.tagName === "FORM") for (let input of this.element.querySelectorAll("input, textarea, select, button")){
            let inputName = input.getAttribute("name");
            let inputType = input.getAttribute("type");
            if (inputType) inputType = inputType.toLowerCase();
            // If the input doesn't have a name, we can't use it.
            if (typeof inputName === "undefined" || inputName === null) continue;
            if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
                // Possibly multiple values
                for (let option of input.options)if (option.selected) formData.append(inputName, option.value);
            } else if (!inputType || inputType !== "checkbox" && inputType !== "radio" || input.checked) formData.append(inputName, input.value);
        }
    }
    // Invoked when there is new progress information about given files.
    // If e is not provided, it is assumed that the upload is finished.
    _updateFilesUploadProgress(files, xhr, e) {
        if (!files[0].upload.chunked) for (let file of files){
            if (file.upload.total && file.upload.bytesSent && file.upload.bytesSent == file.upload.total) continue;
            if (e) {
                file.upload.progress = 100 * e.loaded / e.total;
                file.upload.total = e.total;
                file.upload.bytesSent = e.loaded;
            } else {
                // No event, so we're at 100%
                file.upload.progress = 100;
                file.upload.bytesSent = file.upload.total;
            }
            this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
        }
        else {
            // Handle chunked file uploads
            // Chunked upload is not compatible with uploading multiple files in one
            // request, so we know there's only one file.
            let file = files[0];
            // Since this is a chunked upload, we need to update the appropriate chunk
            // progress.
            let chunk = this._getChunk(file, xhr);
            if (e) {
                chunk.progress = 100 * e.loaded / e.total;
                chunk.total = e.total;
                chunk.bytesSent = e.loaded;
            } else {
                // No event, so we're at 100%
                chunk.progress = 100;
                chunk.bytesSent = chunk.total;
            }
            // Now tally the *file* upload progress from its individual chunks
            file.upload.progress = 0;
            file.upload.total = 0;
            file.upload.bytesSent = 0;
            for(let i = 0; i < file.upload.totalChunkCount; i++)if (file.upload.chunks[i] && typeof file.upload.chunks[i].progress !== "undefined") {
                file.upload.progress += file.upload.chunks[i].progress;
                file.upload.total += file.upload.chunks[i].total;
                file.upload.bytesSent += file.upload.chunks[i].bytesSent;
            }
            // Since the process is a percentage, we need to divide by the amount of
            // chunks we've used.
            file.upload.progress = file.upload.progress / file.upload.totalChunkCount;
            this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
        }
    }
    _finishedUploading(files, xhr, e) {
        let response;
        if (files[0].status === $540cd3dd02161f28$export$2e2bcd8739ae039.CANCELED) return;
        if (xhr.readyState !== 4) return;
        if (xhr.responseType !== "arraybuffer" && xhr.responseType !== "blob") {
            response = xhr.responseText;
            if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) try {
                response = JSON.parse(response);
            } catch (error) {
                e = error;
                response = "Invalid JSON response from server.";
            }
        }
        this._updateFilesUploadProgress(files, xhr);
        if (!(200 <= xhr.status && xhr.status < 300)) this._handleUploadError(files, xhr, response);
        else if (files[0].upload.chunked) files[0].upload.finishedChunkUpload(this._getChunk(files[0], xhr), response);
        else this._finished(files, response, e);
    }
    _handleUploadError(files, xhr, response) {
        if (files[0].status === $540cd3dd02161f28$export$2e2bcd8739ae039.CANCELED) return;
        if (files[0].upload.chunked && this.options.retryChunks) {
            let chunk = this._getChunk(files[0], xhr);
            if (chunk.retries++ < this.options.retryChunksLimit) {
                this._uploadData(files, [
                    chunk.dataBlock
                ]);
                return;
            } else console.warn("Retried this chunk too often. Giving up.");
        }
        this._errorProcessing(files, response || this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr);
    }
    submitRequest(xhr, formData, files) {
        if (xhr.readyState != 1) {
            console.warn("Cannot send this request because the XMLHttpRequest.readyState is not OPENED.");
            return;
        }
        if (this.options.binaryBody) {
            if (files[0].upload.chunked) {
                const chunk = this._getChunk(files[0], xhr);
                xhr.send(chunk.dataBlock.data);
            } else xhr.send(files[0]);
        } else xhr.send(formData);
    }
    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.
    _finished(files, responseText, e) {
        for (let file of files){
            file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.SUCCESS;
            this.emit("success", file, responseText, e);
            this.emit("complete", file);
        }
        if (this.options.uploadMultiple) {
            this.emit("successmultiple", files, responseText, e);
            this.emit("completemultiple", files);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.
    _errorProcessing(files, message, xhr) {
        for (let file of files){
            file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.ERROR;
            this.emit("error", file, message, xhr);
            this.emit("complete", file);
        }
        if (this.options.uploadMultiple) {
            this.emit("errormultiple", files, message, xhr);
            this.emit("completemultiple", files);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    static uuidv4() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            let r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
            return v.toString(16);
        });
    }
    constructor(el, options){
        super();
        let fallback, left;
        this.element = el;
        this.clickableElements = [];
        this.listeners = [];
        this.files = []; // All files
        if (typeof this.element === "string") this.element = document.querySelector(this.element);
        // Not checking if instance of HTMLElement or Element since IE9 is extremely weird.
        if (!this.element || this.element.nodeType == null) throw new Error("Invalid dropzone element.");
        if (this.element.dropzone) throw new Error("Dropzone already attached.");
        // Now add this dropzone to the instances.
        $540cd3dd02161f28$export$2e2bcd8739ae039.instances.push(this);
        // Put the dropzone inside the element itself.
        this.element.dropzone = this;
        let elementOptions = (left = $540cd3dd02161f28$export$2e2bcd8739ae039.optionsForElement(this.element)) != null ? left : {};
        this.options = (0, $ee62ca6949990202$export$2e2bcd8739ae039)(true, {}, $540cd3dd02161f28$var$$4ca367182776f80b$export$2e2bcd8739ae039, elementOptions, options != null ? options : {});
        this.options.previewTemplate = this.options.previewTemplate.replace(/\n*/g, "");
        // If the browser failed, just call the fallback and leave
        if (this.options.forceFallback || !$540cd3dd02161f28$export$2e2bcd8739ae039.isBrowserSupported()) return this.options.fallback.call(this);
        // @options.url = @element.getAttribute "action" unless @options.url?
        if (this.options.url == null) this.options.url = this.element.getAttribute("action");
        if (!this.options.url) throw new Error("No URL provided.");
        if (this.options.acceptedFiles && this.options.acceptedMimeTypes) throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
        if (this.options.uploadMultiple && this.options.chunking) throw new Error("You cannot set both: uploadMultiple and chunking.");
        if (this.options.binaryBody && this.options.uploadMultiple) throw new Error("You cannot set both: binaryBody and uploadMultiple.");
        // Backwards compatibility
        if (this.options.acceptedMimeTypes) {
            this.options.acceptedFiles = this.options.acceptedMimeTypes;
            delete this.options.acceptedMimeTypes;
        }
        // Backwards compatibility
        if (this.options.renameFilename != null) this.options.renameFile = (file)=>this.options.renameFilename.call(this, file.name, file);
        if (typeof this.options.method === "string") this.options.method = this.options.method.toUpperCase();
        if ((fallback = this.getExistingFallback()) && fallback.parentNode) fallback.parentNode.removeChild(fallback);
        // Display previews in the previewsContainer element or the Dropzone element unless explicitly set to false
        if (this.options.previewsContainer !== false) {
            if (this.options.previewsContainer) this.previewsContainer = $540cd3dd02161f28$export$2e2bcd8739ae039.getElement(this.options.previewsContainer, "previewsContainer");
            else this.previewsContainer = this.element;
        }
        if (this.options.clickable) {
            if (this.options.clickable === true) this.clickableElements = [
                this.element
            ];
            else this.clickableElements = $540cd3dd02161f28$export$2e2bcd8739ae039.getElements(this.options.clickable, "clickable");
        }
        this.init();
    }
}
$540cd3dd02161f28$export$2e2bcd8739ae039.initClass();
// This is a map of options for your different dropzones. Add configurations
// to this object for your different dropzone elemens.
//
// Example:
//
//     Dropzone.options.myDropzoneElementId = { maxFilesize: 1 };
//
// And in html:
//
//     <form action="/upload" id="my-dropzone-element-id" class="dropzone"></form>
$540cd3dd02161f28$export$2e2bcd8739ae039.options = {};
// Returns the options for an element or undefined if none available.
$540cd3dd02161f28$export$2e2bcd8739ae039.optionsForElement = function(element) {
    // Get the `Dropzone.options.elementId` for this element if it exists
    if (element.getAttribute("id")) return $540cd3dd02161f28$export$2e2bcd8739ae039.options[$540cd3dd02161f28$var$$3ed269f2f0fb224b$var$camelize(element.getAttribute("id"))];
    else return undefined;
};
// Holds a list of all dropzone instances
$540cd3dd02161f28$export$2e2bcd8739ae039.instances = [];
// Returns the dropzone for given element if any
$540cd3dd02161f28$export$2e2bcd8739ae039.forElement = function(element) {
    if (typeof element === "string") element = document.querySelector(element);
    if ((element != null ? element.dropzone : undefined) == null) throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    return element.dropzone;
};
// Looks for all .dropzone elements and creates a dropzone for them
$540cd3dd02161f28$export$2e2bcd8739ae039.discover = function() {
    let dropzones;
    if (document.querySelectorAll) dropzones = document.querySelectorAll(".dropzone");
    else {
        dropzones = [];
        // IE :(
        let checkElements = (elements)=>(()=>{
                let result = [];
                for (let el of elements)if (/(^| )dropzone($| )/.test(el.className)) result.push(dropzones.push(el));
                else result.push(undefined);
                return result;
            })();
        checkElements(document.getElementsByTagName("div"));
        checkElements(document.getElementsByTagName("form"));
    }
    return (()=>{
        let result = [];
        for (let dropzone of dropzones)if ($540cd3dd02161f28$export$2e2bcd8739ae039.optionsForElement(dropzone) !== false) result.push(new $540cd3dd02161f28$export$2e2bcd8739ae039(dropzone));
        else result.push(undefined);
        return result;
    })();
};
// Some browsers support drag and drog functionality, but not correctly.
//
// So I created a blocklist of userAgents. Yes, yes. Browser sniffing, I know.
// But what to do when browsers *theoretically* support an API, but crash
// when using it.
//
// This is a list of regular expressions tested against navigator.userAgent
//
// ** It should only be used on browser that *do* support the API, but
// incorrectly **
$540cd3dd02161f28$export$2e2bcd8739ae039.blockedBrowsers = [
    // The mac os and windows phone version of opera 12 seems to have a problem with the File drag'n'drop API.
    /opera.*(Macintosh|Windows Phone).*version\/12/i
];
// Checks if the browser is supported
$540cd3dd02161f28$export$2e2bcd8739ae039.isBrowserSupported = function() {
    let capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
        if (!("classList" in document.createElement("a"))) capableBrowser = false;
        else {
            if ($540cd3dd02161f28$export$2e2bcd8739ae039.blacklistedBrowsers !== undefined) // configuration.
            $540cd3dd02161f28$export$2e2bcd8739ae039.blockedBrowsers = $540cd3dd02161f28$export$2e2bcd8739ae039.blacklistedBrowsers;
            // The browser supports the API, but may be blocked.
            for (let regex of $540cd3dd02161f28$export$2e2bcd8739ae039.blockedBrowsers)if (regex.test(navigator.userAgent)) {
                capableBrowser = false;
                continue;
            }
        }
    } else capableBrowser = false;
    return capableBrowser;
};
$540cd3dd02161f28$export$2e2bcd8739ae039.dataURItoBlob = function(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    let byteString = atob(dataURI.split(",")[1]);
    // separate out the mime component
    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to an ArrayBuffer
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for(let i = 0, end = byteString.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--)ia[i] = byteString.charCodeAt(i);
    // write the ArrayBuffer to a blob
    return new Blob([
        ab
    ], {
        type: mimeString
    });
};
// Returns an array without the rejected item
const $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$without = (list, rejectedItem)=>list.filter((item)=>item !== rejectedItem).map((item)=>item);
// abc-def_ghi -> abcDefGhi
const $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$camelize = (str)=>str.replace(/[\-_](\w)/g, (match)=>match.charAt(1).toUpperCase());
// Creates an element from string
$540cd3dd02161f28$export$2e2bcd8739ae039.createElement = function(string) {
    let div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
};
// Tests if given element is inside (or simply is) the container
$540cd3dd02161f28$export$2e2bcd8739ae039.elementInside = function(element, container) {
    if (element === container) return true;
    // Coffeescript doesn't support do/while loops
    while(element = element.parentNode){
        if (element === container) return true;
    }
    return false;
};
$540cd3dd02161f28$export$2e2bcd8739ae039.getElement = function(el, name) {
    let element;
    if (typeof el === "string") element = document.querySelector(el);
    else if (el.nodeType != null) element = el;
    if (element == null) throw new Error(`Invalid \`${name}\` option provided. Please provide a CSS selector or a plain HTML element.`);
    return element;
};
$540cd3dd02161f28$export$2e2bcd8739ae039.getElements = function(els, name) {
    let el, elements;
    if (els instanceof Array) {
        elements = [];
        try {
            for (el of els)elements.push(this.getElement(el, name));
        } catch (e) {
            elements = null;
        }
    } else if (typeof els === "string") {
        elements = [];
        for (el of document.querySelectorAll(els))elements.push(el);
    } else if (els.nodeType != null) elements = [
        els
    ];
    if (elements == null || !elements.length) throw new Error(`Invalid \`${name}\` option provided. Please provide a CSS selector, a plain HTML element or a list of those.`);
    return elements;
};
// Asks the user the question and calls accepted or rejected accordingly
//
// The default implementation just uses `window.confirm` and then calls the
// appropriate callback.
$540cd3dd02161f28$export$2e2bcd8739ae039.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) return accepted();
    else if (rejected != null) return rejected();
};
// Validates the mime type like this:
//
// https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept
$540cd3dd02161f28$export$2e2bcd8739ae039.isValidFile = function(file, acceptedFiles) {
    if (!acceptedFiles) return true;
    // If there are no accepted mime types, it's OK
    acceptedFiles = acceptedFiles.split(",");
    let mimeType = file.type;
    let baseMimeType = mimeType.replace(/\/.*$/, "");
    for (let validType of acceptedFiles){
        validType = validType.trim();
        if (validType.charAt(0) === ".") {
            if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) return true;
        } else if (/\/\*$/.test(validType)) {
            // This is something like a image/* mime type
            if (baseMimeType === validType.replace(/\/.*$/, "")) return true;
        } else {
            if (mimeType === validType) return true;
        }
    }
    return false;
};
// Augment jQuery
if (typeof jQuery !== "undefined" && jQuery !== null) jQuery.fn.dropzone = function(options) {
    return this.each(function() {
        return new $540cd3dd02161f28$export$2e2bcd8739ae039(this, options);
    });
};
// Dropzone file status codes
$540cd3dd02161f28$export$2e2bcd8739ae039.ADDED = "added";
$540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED = "queued";
// For backwards compatibility. Now, if a file is accepted, it's either queued
// or uploading.
$540cd3dd02161f28$export$2e2bcd8739ae039.ACCEPTED = $540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED;
$540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING = "uploading";
$540cd3dd02161f28$export$2e2bcd8739ae039.PROCESSING = $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING; // alias
$540cd3dd02161f28$export$2e2bcd8739ae039.CANCELED = "canceled";
$540cd3dd02161f28$export$2e2bcd8739ae039.ERROR = "error";
$540cd3dd02161f28$export$2e2bcd8739ae039.SUCCESS = "success";
/*

 Bugfix for iOS 6 and 7
 Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
 based on the work of https://github.com/stomita/ios-imagefile-megapixel

 */ // Detecting vertical squash in loaded image.
// Fixes a bug which squash image vertically while drawing into canvas for some images.
// This is a bug in iOS6 devices. This function from https://github.com/stomita/ios-imagefile-megapixel
let $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$detectVerticalSquash = function(img) {
    let iw = img.naturalWidth;
    let ih = img.naturalHeight;
    let canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    let { data: data } = ctx.getImageData(1, 0, 1, ih);
    // search image edge pixel position in case it is squashed vertically.
    let sy = 0;
    let ey = ih;
    let py = ih;
    while(py > sy){
        let alpha = data[(py - 1) * 4 + 3];
        if (alpha === 0) ey = py;
        else sy = py;
        py = ey + sy >> 1;
    }
    let ratio = py / ih;
    if (ratio === 0) return 1;
    else return ratio;
};
// A replacement for context.drawImage
// (args are for source and destination).
var $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    let vertSquashRatio = $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
};
// Based on MinifyJpeg
// Source: http://www.perry.cz/files/ExifRestorer.js
// http://elicon.blog57.fc2.com/blog-entry-206.html
class $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$ExifRestore {
    static initClass() {
        this.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    }
    static encode64(input) {
        let output = "";
        let chr1 = undefined;
        let chr2 = undefined;
        let chr3 = "";
        let enc1 = undefined;
        let enc2 = undefined;
        let enc3 = undefined;
        let enc4 = "";
        let i = 0;
        while(true){
            chr1 = input[i++];
            chr2 = input[i++];
            chr3 = input[i++];
            enc1 = chr1 >> 2;
            enc2 = (chr1 & 3) << 4 | chr2 >> 4;
            enc3 = (chr2 & 15) << 2 | chr3 >> 6;
            enc4 = chr3 & 63;
            if (isNaN(chr2)) enc3 = enc4 = 64;
            else if (isNaN(chr3)) enc4 = 64;
            output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
            if (!(i < input.length)) break;
        }
        return output;
    }
    static restore(origFileBase64, resizedFileBase64) {
        if (!origFileBase64.match("data:image/jpeg;base64,")) return resizedFileBase64;
        let rawImage = this.decode64(origFileBase64.replace("data:image/jpeg;base64,", ""));
        let segments = this.slice2Segments(rawImage);
        let image = this.exifManipulation(resizedFileBase64, segments);
        return `data:image/jpeg;base64,${this.encode64(image)}`;
    }
    static exifManipulation(resizedFileBase64, segments) {
        let exifArray = this.getExifArray(segments);
        let newImageArray = this.insertExif(resizedFileBase64, exifArray);
        let aBuffer = new Uint8Array(newImageArray);
        return aBuffer;
    }
    static getExifArray(segments) {
        let seg = undefined;
        let x = 0;
        while(x < segments.length){
            seg = segments[x];
            if (seg[0] === 255 & seg[1] === 225) return seg;
            x++;
        }
        return [];
    }
    static insertExif(resizedFileBase64, exifArray) {
        let imageData = resizedFileBase64.replace("data:image/jpeg;base64,", "");
        let buf = this.decode64(imageData);
        let separatePoint = buf.indexOf(255, 3);
        let mae = buf.slice(0, separatePoint);
        let ato = buf.slice(separatePoint);
        let array = mae;
        array = array.concat(exifArray);
        array = array.concat(ato);
        return array;
    }
    static slice2Segments(rawImageArray) {
        let head = 0;
        let segments = [];
        while(true){
            var length;
            if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) break;
            if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) head += 2;
            else {
                length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3];
                let endPoint = head + length + 2;
                let seg = rawImageArray.slice(head, endPoint);
                segments.push(seg);
                head = endPoint;
            }
            if (head > rawImageArray.length) break;
        }
        return segments;
    }
    static decode64(input) {
        let output = "";
        let chr1 = undefined;
        let chr2 = undefined;
        let chr3 = "";
        let enc1 = undefined;
        let enc2 = undefined;
        let enc3 = undefined;
        let enc4 = "";
        let i = 0;
        let buf = [];
        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        let base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(input)) console.warn("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding.");
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while(true){
            enc1 = this.KEY_STR.indexOf(input.charAt(i++));
            enc2 = this.KEY_STR.indexOf(input.charAt(i++));
            enc3 = this.KEY_STR.indexOf(input.charAt(i++));
            enc4 = this.KEY_STR.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            buf.push(chr1);
            if (enc3 !== 64) buf.push(chr2);
            if (enc4 !== 64) buf.push(chr3);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
            if (!(i < input.length)) break;
        }
        return buf;
    }
}
$540cd3dd02161f28$var$$3ed269f2f0fb224b$var$ExifRestore.initClass();
/*
 * contentloaded.js
 *
 * Author: Diego Perini (diego.perini at gmail.com)
 * Summary: cross-browser wrapper for DOMContentLoaded
 * Updated: 20101020
 * License: MIT
 * Version: 1.2
 *
 * URL:
 * http://javascript.nwbox.com/ContentLoaded/
 * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
 */ // @win window reference
// @fn function reference
let $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$contentLoaded = function(win, fn) {
    let done = false;
    let top = true;
    let doc = win.document;
    let root = doc.documentElement;
    let add = doc.addEventListener ? "addEventListener" : "attachEvent";
    let rem = doc.addEventListener ? "removeEventListener" : "detachEvent";
    let pre = doc.addEventListener ? "" : "on";
    var init = function(e) {
        if (e.type === "readystatechange" && doc.readyState !== "complete") return;
        (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
        if (!done && (done = true)) return fn.call(win, e.type || e);
    };
    var poll = function() {
        try {
            root.doScroll("left");
        } catch (e) {
            setTimeout(poll, 50);
            return;
        }
        return init("poll");
    };
    if (doc.readyState !== "complete") {
        if (doc.createEventObject && root.doScroll) {
            try {
                top = !win.frameElement;
            } catch (error) {}
            if (top) poll();
        }
        doc[add](pre + "DOMContentLoaded", init, false);
        doc[add](pre + "readystatechange", init, false);
        return win[add](pre + "load", init, false);
    }
};
function $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$__guard__(value, transform) {
    return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}
function $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$__guardMethod__(obj, methodName, transform) {
    if (typeof obj !== "undefined" && obj !== null && typeof obj[methodName] === "function") return transform(obj, methodName);
    else return undefined;
}


var $d39d5626a2a26fe7$require$Dropzone = $540cd3dd02161f28$export$2e2bcd8739ae039;
const $d39d5626a2a26fe7$export$6b45509f74bc6382 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    const dropzoneRef = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(()=>{
        let myDropzone = new $d39d5626a2a26fe7$require$Dropzone(dropzoneRef.current, {
            dictDefaultMessage: '',
            maxFilesize: 20,
            url: '/',
            addRemoveLinks: false,
            method: 'put',
            chunking: true,
            forceChunking: true,
            autoQueue: false,
            autoProcessQueue: false,
            disablePreviews: true
        });
        myDropzone.on('addedfile', function(file) {
            return $d39d5626a2a26fe7$var$__awaiter(this, void 0, void 0, function*() {
                const storage = (0, $fa12c9399a1a76ec$export$39e0a5bed87a3667)();
                const name = file.name;
                if (!name.toLowerCase().endsWith('.pdf')) {
                    (0, $8f0b3b9abdff19ee$export$b410431fab84fa58).error('Please upload a PDF file');
                    myDropzone.removeFile(file);
                    return;
                }
                const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                const fileExists = false;
                if (!fileExists) {
                    const message = props.toasterMessage.replace('%name%', name);
                    var toasterId = (0, $8f0b3b9abdff19ee$export$b410431fab84fa58).info(message, {
                        progress: 0,
                        autoClose: false
                    });
                    //alert('Uploading file');
                    const success = yield storage.uploadFileToStorage(props.storageTarget, file, (progress)=>{
                        //file.upload.progress = progress;
                        (0, $8f0b3b9abdff19ee$export$b410431fab84fa58).update(toasterId, {
                            progress: progress / 100
                        });
                    });
                    if (success) {
                        //alert('Upload done!');
                        if (props.onUpload) props.onUpload(name);
                        (0, $8f0b3b9abdff19ee$export$b410431fab84fa58).done(toasterId);
                    } else (0, $8f0b3b9abdff19ee$export$b410431fab84fa58).info('Trouble uploading the file..');
                }
            });
        });
        return ()=>{
            while(myDropzone.files.length > 0)myDropzone.removeFile(myDropzone.files[0]);
            myDropzone.destroy();
        };
    }, [
        dropzoneRef,
        props
    ]);
    const clsToUse = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($1bc40f4eb65039a9$export$2778853eeaa53fa7, props.className);
    return(//Click is handled by drop-zone
    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
        ref: dropzoneRef,
        className: clsToUse,
        variant: "light",
        children: props.display
    }));
});


var $3c05c8c560a8b6b4$export$40a9eeef55665a40;
var $3c05c8c560a8b6b4$export$93b7586d956c930e;
var $3c05c8c560a8b6b4$export$e4f6ce96d55d099a;
var $3c05c8c560a8b6b4$export$f843afa9e9b53052;
var $3c05c8c560a8b6b4$export$3304639b795b6ae;
var $3c05c8c560a8b6b4$export$ae78d338ad66ff90;
var $3c05c8c560a8b6b4$export$b8972b998723d602;
var $3c05c8c560a8b6b4$export$13925b5cf10ba292;
$3c05c8c560a8b6b4$export$40a9eeef55665a40 = `YUBJYq_defaultPadding`;
$3c05c8c560a8b6b4$export$93b7586d956c930e = `YUBJYq_dropShadow`;
$3c05c8c560a8b6b4$export$e4f6ce96d55d099a = `YUBJYq_newDealButton`;
$3c05c8c560a8b6b4$export$f843afa9e9b53052 = `YUBJYq_panelImage`;
$3c05c8c560a8b6b4$export$3304639b795b6ae = `YUBJYq_plusIcon`;
$3c05c8c560a8b6b4$export$ae78d338ad66ff90 = `YUBJYq_scaleInOut`;
$3c05c8c560a8b6b4$export$b8972b998723d602 = `YUBJYq_shadow`;
$3c05c8c560a8b6b4$export$13925b5cf10ba292 = `YUBJYq_small-shadow`;


const $cb260e4106feb219$export$3dd2d6bc8d332dfb = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    return (0, $kSbwP.jsx)((0, $d39d5626a2a26fe7$export$6b45509f74bc6382), {
        display: (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
            children: [
                (0, $kSbwP.jsx)("i", {
                    className: `bi bi-plus-lg ${$3c05c8c560a8b6b4$export$3304639b795b6ae}`
                }),
                "New Deal"
            ]
        }),
        storageTarget: {
            type: 'cim'
        },
        toasterMessage: "Uploading Deal: %name%",
        className: $3c05c8c560a8b6b4$export$e4f6ce96d55d099a,
        onUpload: (fileName)=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            fb.store_audit_entry('UPLOAD_CIM', {
                fileName: fileName
            });
            fb.add_job(fileName);
        }
    });
});


var $705b9354ee184fb4$export$dac02eec6ee70897;
var $705b9354ee184fb4$export$34e0f9847d4c02dd;
var $705b9354ee184fb4$export$ee3e77a244f87ca2;
var $705b9354ee184fb4$export$40a9eeef55665a40;
var $705b9354ee184fb4$export$93b7586d956c930e;
var $705b9354ee184fb4$export$faed4863136ce212;
var $705b9354ee184fb4$export$e4f6ce96d55d099a;
var $705b9354ee184fb4$export$f843afa9e9b53052;
var $705b9354ee184fb4$export$3304639b795b6ae;
var $705b9354ee184fb4$export$ae78d338ad66ff90;
var $705b9354ee184fb4$export$155b316d1d1ff341;
var $705b9354ee184fb4$export$b8972b998723d602;
var $705b9354ee184fb4$export$13925b5cf10ba292;
var $705b9354ee184fb4$export$fb184b623420d9be;
$705b9354ee184fb4$export$dac02eec6ee70897 = `_sVDwa_clientName`;
$705b9354ee184fb4$export$34e0f9847d4c02dd = `_sVDwa_container`;
$705b9354ee184fb4$export$ee3e77a244f87ca2 = `_sVDwa_dealDatabaseButton`;
$705b9354ee184fb4$export$40a9eeef55665a40 = `_sVDwa_defaultPadding`;
$705b9354ee184fb4$export$93b7586d956c930e = `_sVDwa_dropShadow`;
$705b9354ee184fb4$export$faed4863136ce212 = `_sVDwa_headerRow`;
$705b9354ee184fb4$export$e4f6ce96d55d099a = `_sVDwa_newDealButton`;
$705b9354ee184fb4$export$f843afa9e9b53052 = `_sVDwa_panelImage`;
$705b9354ee184fb4$export$3304639b795b6ae = `_sVDwa_plusIcon`;
$705b9354ee184fb4$export$ae78d338ad66ff90 = `_sVDwa_scaleInOut`;
$705b9354ee184fb4$export$155b316d1d1ff341 = `_sVDwa_scorePosition`;
$705b9354ee184fb4$export$b8972b998723d602 = `_sVDwa_shadow`;
$705b9354ee184fb4$export$13925b5cf10ba292 = `_sVDwa_small-shadow`;
$705b9354ee184fb4$export$fb184b623420d9be = `_sVDwa_title`;




var $kSbwP = parcelRequire("kSbwP");


var $96bdaab448b7fce9$export$40a9eeef55665a40;
var $96bdaab448b7fce9$export$93b7586d956c930e;
var $96bdaab448b7fce9$export$424e99fc53fcd713;
var $96bdaab448b7fce9$export$f843afa9e9b53052;
var $96bdaab448b7fce9$export$3304639b795b6ae;
var $96bdaab448b7fce9$export$ae78d338ad66ff90;
var $96bdaab448b7fce9$export$b8972b998723d602;
var $96bdaab448b7fce9$export$13925b5cf10ba292;
$96bdaab448b7fce9$export$40a9eeef55665a40 = `djkRzW_defaultPadding`;
$96bdaab448b7fce9$export$93b7586d956c930e = `djkRzW_dropShadow`;
$96bdaab448b7fce9$export$424e99fc53fcd713 = `djkRzW_exportButton`;
$96bdaab448b7fce9$export$f843afa9e9b53052 = `djkRzW_panelImage`;
$96bdaab448b7fce9$export$3304639b795b6ae = `djkRzW_plusIcon`;
$96bdaab448b7fce9$export$ae78d338ad66ff90 = `djkRzW_scaleInOut`;
$96bdaab448b7fce9$export$b8972b998723d602 = `djkRzW_shadow`;
$96bdaab448b7fce9$export$13925b5cf10ba292 = `djkRzW_small-shadow`;


var $eec13e6b5a0b94b3$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $eec13e6b5a0b94b3$exports = factory();
})($eec13e6b5a0b94b3$exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = 'AAAAAAAAAAAAEA4AGBkAAFAaAAACAAAAAAAIABAAGAAwADgACAAQAAgAEAAIABAACAAQAAgAEAAIABAACAAQAAgAEAAIABAAQABIAEQATAAIABAACAAQAAgAEAAIABAAVABcAAgAEAAIABAACAAQAGAAaABwAHgAgACIAI4AlgAIABAAmwCjAKgAsAC2AL4AvQDFAMoA0gBPAVYBWgEIAAgACACMANoAYgFkAWwBdAF8AX0BhQGNAZUBlgGeAaMBlQGWAasBswF8AbsBwwF0AcsBYwHTAQgA2wG/AOMBdAF8AekB8QF0AfkB+wHiAHQBfAEIAAMC5gQIAAsCEgIIAAgAFgIeAggAIgIpAggAMQI5AkACygEIAAgASAJQAlgCYAIIAAgACAAKBQoFCgUTBRMFGQUrBSsFCAAIAAgACAAIAAgACAAIAAgACABdAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABoAmgCrwGvAQgAbgJ2AggAHgEIAAgACADnAXsCCAAIAAgAgwIIAAgACAAIAAgACACKAggAkQKZAggAPADJAAgAoQKkAqwCsgK6AsICCADJAggA0AIIAAgACAAIANYC3gIIAAgACAAIAAgACABAAOYCCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAkASoB+QIEAAgACAA8AEMCCABCBQgACABJBVAFCAAIAAgACAAIAAgACAAIAAgACABTBVoFCAAIAFoFCABfBWUFCAAIAAgACAAIAAgAbQUIAAgACAAIAAgACABzBXsFfQWFBYoFigWKBZEFigWKBYoFmAWfBaYFrgWxBbkFCAAIAAgACAAIAAgACAAIAAgACAAIAMEFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAMgFCADQBQgACAAIAAgACAAIAAgACAAIAAgACAAIAO4CCAAIAAgAiQAIAAgACABAAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAD0AggACAD8AggACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIANYFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAMDvwAIAAgAJAIIAAgACAAIAAgACAAIAAgACwMTAwgACAB9BOsEGwMjAwgAKwMyAwsFYgE3A/MEPwMIAEUDTQNRAwgAWQOsAGEDCAAIAAgACAAIAAgACABpAzQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFIQUoBSwFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABtAwgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABMAEwACAAIAAgACAAIABgACAAIAAgACAC/AAgACAAyAQgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACAAIAAwAAgACAAIAAgACAAIAAgACAAIAAAARABIAAgACAAIABQASAAIAAgAIABwAEAAjgCIABsAqAC2AL0AigDQAtwC+IJIQqVAZUBWQqVAZUBlQGVAZUBlQGrC5UBlQGVAZUBlQGVAZUBlQGVAXsKlQGVAbAK6wsrDGUMpQzlDJUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAfAKAAuZA64AtwCJALoC6ADwAAgAuACgA/oEpgO6AqsD+AAIAAgAswMIAAgACAAIAIkAuwP5AfsBwwPLAwgACAAIAAgACADRA9kDCAAIAOED6QMIAAgACAAIAAgACADuA/YDCAAIAP4DyQAIAAgABgQIAAgAXQAOBAgACAAIAAgACAAIABMECAAIAAgACAAIAAgACAD8AAQBCAAIAAgAGgQiBCoECAExBAgAEAEIAAgACAAIAAgACAAIAAgACAAIAAgACAA4BAgACABABEYECAAIAAgATAQYAQgAVAQIAAgACAAIAAgACAAIAAgACAAIAFoECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAOQEIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAB+BAcACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAEABhgSMBAgACAAIAAgAlAQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAwAEAAQABAADAAMAAwADAAQABAAEAAQABAAEAAQABHATAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAdQMIAAgACAAIAAgACAAIAMkACAAIAAgAfQMIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACFA4kDCAAIAAgACAAIAOcBCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAIcDCAAIAAgACAAIAAgACAAIAAgACAAIAJEDCAAIAAgACADFAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABgBAgAZgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAbAQCBXIECAAIAHkECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABAAJwEQACjBKoEsgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAC6BMIECAAIAAgACAAIAAgACABmBAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAxwQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAGYECAAIAAgAzgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBd0FXwUIAOIF6gXxBYoF3gT5BQAGCAaKBYoFigWKBYoFigWKBYoFigWKBYoFigXWBIoFigWKBYoFigWKBYoFigWKBYsFEAaKBYoFigWKBYoFigWKBRQGCACKBYoFigWKBQgACAAIANEECAAIABgGigUgBggAJgYIAC4GMwaKBYoF0wQ3Bj4GigWKBYoFigWKBYoFigWKBYoFigWKBYoFigUIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWLBf///////wQABAAEAAQABAAEAAQABAAEAAQAAwAEAAQAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAQADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUAAAAFAAUAAAAFAAUAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAQAAAAUABQAFAAUABQAFAAAAAAAFAAUAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAFAAUAAQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAAABwAHAAcAAAAHAAcABwAFAAEAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAcABwAFAAUAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAAAAQABAAAAAAAAAAAAAAAFAAUABQAFAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAHAAcAAAAHAAcAAAAAAAUABQAHAAUAAQAHAAEABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwABAAUABQAFAAUAAAAAAAAAAAAAAAEAAQABAAEAAQABAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABQANAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAABQAHAAUABQAFAAAAAAAAAAcABQAFAAUABQAFAAQABAAEAAQABAAEAAQABAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUAAAAFAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAUAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAcABwAFAAcABwAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUABwAHAAUABQAFAAUAAAAAAAcABwAAAAAABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAAAAAAAAAAABQAFAAAAAAAFAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAFAAUABQAFAAUAAAAFAAUABwAAAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABwAFAAUABQAFAAAAAAAHAAcAAAAAAAcABwAFAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAAAAAAAAAHAAcABwAAAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAUABQAFAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAHAAcABQAHAAcAAAAFAAcABwAAAAcABwAFAAUAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAFAAcABwAFAAUABQAAAAUAAAAHAAcABwAHAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAHAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUAAAAFAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAUAAAAFAAUAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABwAFAAUABQAFAAUABQAAAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABQAFAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAFAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAHAAUABQAFAAUABQAFAAUABwAHAAcABwAHAAcABwAHAAUABwAHAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABwAHAAcABwAFAAUABwAHAAcAAAAAAAAAAAAHAAcABQAHAAcABwAHAAcABwAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAUABQAFAAUABQAFAAUAAAAFAAAABQAAAAAABQAFAAUABQAFAAUABQAFAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAUABQAFAAUABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABwAFAAcABwAHAAcABwAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAUABQAFAAUABwAHAAUABQAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABQAFAAcABwAHAAUABwAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAcABQAFAAUABQAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAAAAAABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAAAAAAAAAFAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAUABQAHAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAFAAUABQAFAAcABwAFAAUABwAHAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAcABwAFAAUABwAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABQAAAAAABQAFAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAcABwAAAAAAAAAAAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAcABwAFAAcABwAAAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAFAAUABQAAAAUABQAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABwAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAHAAcABQAHAAUABQAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAAABwAHAAAAAAAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAFAAUABwAFAAcABwAFAAcABQAFAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAAAAAABwAHAAcABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAFAAcABwAFAAUABQAFAAUABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAUABQAFAAcABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABQAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAAAAAAFAAUABwAHAAcABwAFAAAAAAAAAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAHAAUABQAFAAUABQAFAAUABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAABQAAAAUABQAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAHAAcAAAAFAAUAAAAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABQAFAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAABQAFAAUABQAFAAUABQAAAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAFAAUABQAFAAUADgAOAA4ADgAOAA4ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAMAAwADAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAAAAAAAAAAAAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAAAAAAAAAAAAsADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwACwAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAADgAOAA4AAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAAAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4AAAAOAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAAAAAAAAAAAA4AAAAOAAAAAAAAAAAADgAOAA4AAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAA=';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


var $e621d79c37897443$exports = {};
/*! pdfmake v0.2.20, @license MIT, @link http://pdfmake.org */ (function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    $e621d79c37897443$exports = factory();
})(typeof self !== 'undefined' ? self : $e621d79c37897443$exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 464: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var IS_PURE = __webpack_require__(63432);
                var store = __webpack_require__(55480);
                (module1.exports = function(key, value) {
                    return store[key] || (store[key] = value !== undefined ? value : {});
                })('versions', []).push({
                    version: '3.19.0',
                    mode: IS_PURE ? 'pure' : 'global',
                    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
                });
            /***/ },
            /***/ 520: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var getBuiltIn = __webpack_require__(38486);
                module1.exports = getBuiltIn('document', 'documentElement');
            /***/ },
            /***/ 664: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var userAgent = __webpack_require__(40715);
                module1.exports = /web0s(?!.*chrome)/i.test(userAgent);
            /***/ },
            /***/ 1083: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(71768);
            /***/ },
            /***/ 1239: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352));
                })(void 0, function(CryptoJS) {
                    /** @preserve
  (c) 2012 by Cédric Mesnil. All rights reserved.
  	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
  	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
  	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */ (function(Math1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var Hasher = C_lib.Hasher;
                        var C_algo = C.algo;
                        // Constants table
                        var _zl = WordArray.create([
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14,
                            15,
                            7,
                            4,
                            13,
                            1,
                            10,
                            6,
                            15,
                            3,
                            12,
                            0,
                            9,
                            5,
                            2,
                            14,
                            11,
                            8,
                            3,
                            10,
                            14,
                            4,
                            9,
                            15,
                            8,
                            1,
                            2,
                            7,
                            0,
                            6,
                            13,
                            11,
                            5,
                            12,
                            1,
                            9,
                            11,
                            10,
                            0,
                            8,
                            12,
                            4,
                            13,
                            3,
                            7,
                            15,
                            14,
                            5,
                            6,
                            2,
                            4,
                            0,
                            5,
                            9,
                            7,
                            12,
                            2,
                            10,
                            14,
                            1,
                            3,
                            8,
                            11,
                            6,
                            15,
                            13
                        ]);
                        var _zr = WordArray.create([
                            5,
                            14,
                            7,
                            0,
                            9,
                            2,
                            11,
                            4,
                            13,
                            6,
                            15,
                            8,
                            1,
                            10,
                            3,
                            12,
                            6,
                            11,
                            3,
                            7,
                            0,
                            13,
                            5,
                            10,
                            14,
                            15,
                            8,
                            12,
                            4,
                            9,
                            1,
                            2,
                            15,
                            5,
                            1,
                            3,
                            7,
                            14,
                            6,
                            9,
                            11,
                            8,
                            12,
                            2,
                            10,
                            0,
                            4,
                            13,
                            8,
                            6,
                            4,
                            1,
                            3,
                            11,
                            15,
                            0,
                            5,
                            12,
                            2,
                            13,
                            9,
                            7,
                            10,
                            14,
                            12,
                            15,
                            10,
                            4,
                            1,
                            5,
                            8,
                            7,
                            6,
                            2,
                            13,
                            14,
                            0,
                            3,
                            9,
                            11
                        ]);
                        var _sl = WordArray.create([
                            11,
                            14,
                            15,
                            12,
                            5,
                            8,
                            7,
                            9,
                            11,
                            13,
                            14,
                            15,
                            6,
                            7,
                            9,
                            8,
                            7,
                            6,
                            8,
                            13,
                            11,
                            9,
                            7,
                            15,
                            7,
                            12,
                            15,
                            9,
                            11,
                            7,
                            13,
                            12,
                            11,
                            13,
                            6,
                            7,
                            14,
                            9,
                            13,
                            15,
                            14,
                            8,
                            13,
                            6,
                            5,
                            12,
                            7,
                            5,
                            11,
                            12,
                            14,
                            15,
                            14,
                            15,
                            9,
                            8,
                            9,
                            14,
                            5,
                            6,
                            8,
                            6,
                            5,
                            12,
                            9,
                            15,
                            5,
                            11,
                            6,
                            8,
                            13,
                            12,
                            5,
                            12,
                            13,
                            14,
                            11,
                            8,
                            5,
                            6
                        ]);
                        var _sr = WordArray.create([
                            8,
                            9,
                            9,
                            11,
                            13,
                            15,
                            15,
                            5,
                            7,
                            7,
                            8,
                            11,
                            14,
                            14,
                            12,
                            6,
                            9,
                            13,
                            15,
                            7,
                            12,
                            8,
                            9,
                            11,
                            7,
                            7,
                            12,
                            7,
                            6,
                            15,
                            13,
                            11,
                            9,
                            7,
                            15,
                            11,
                            8,
                            6,
                            6,
                            14,
                            12,
                            13,
                            5,
                            14,
                            13,
                            13,
                            7,
                            5,
                            15,
                            5,
                            8,
                            11,
                            14,
                            14,
                            6,
                            14,
                            6,
                            9,
                            12,
                            9,
                            12,
                            5,
                            15,
                            8,
                            8,
                            5,
                            12,
                            9,
                            12,
                            5,
                            14,
                            6,
                            8,
                            13,
                            6,
                            5,
                            15,
                            13,
                            11,
                            11
                        ]);
                        var _hl = WordArray.create([
                            0x00000000,
                            0x5A827999,
                            0x6ED9EBA1,
                            0x8F1BBCDC,
                            0xA953FD4E
                        ]);
                        var _hr = WordArray.create([
                            0x50A28BE6,
                            0x5C4DD124,
                            0x6D703EF3,
                            0x7A6D76E9,
                            0x00000000
                        ]);
                        /**
     * RIPEMD160 hash algorithm.
     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
                            _doReset: function _doReset() {
                                this._hash = WordArray.create([
                                    0x67452301,
                                    0xEFCDAB89,
                                    0x98BADCFE,
                                    0x10325476,
                                    0xC3D2E1F0
                                ]);
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Swap endian
                                for(var i = 0; i < 16; i++){
                                    // Shortcuts
                                    var offset_i = offset + i;
                                    var M_offset_i = M[offset_i];
                                    // Swap
                                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                                }
                                // Shortcut
                                var H = this._hash.words;
                                var hl = _hl.words;
                                var hr = _hr.words;
                                var zl = _zl.words;
                                var zr = _zr.words;
                                var sl = _sl.words;
                                var sr = _sr.words;
                                // Working variables
                                var al, bl, cl, dl, el;
                                var ar, br, cr, dr, er;
                                ar = al = H[0];
                                br = bl = H[1];
                                cr = cl = H[2];
                                dr = dl = H[3];
                                er = el = H[4];
                                // Computation
                                var t;
                                for(var i = 0; i < 80; i += 1){
                                    t = al + M[offset + zl[i]] | 0;
                                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                                    else // if (i<80) {
                                    t += f5(bl, cl, dl) + hl[4];
                                    t = t | 0;
                                    t = rotl(t, sl[i]);
                                    t = t + el | 0;
                                    al = el;
                                    el = dl;
                                    dl = rotl(cl, 10);
                                    cl = bl;
                                    bl = t;
                                    t = ar + M[offset + zr[i]] | 0;
                                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                                    else // if (i<80) {
                                    t += f1(br, cr, dr) + hr[4];
                                    t = t | 0;
                                    t = rotl(t, sr[i]);
                                    t = t + er | 0;
                                    ar = er;
                                    er = dr;
                                    dr = rotl(cr, 10);
                                    cr = br;
                                    br = t;
                                }
                                // Intermediate hash value
                                t = H[1] + cl + dr | 0;
                                H[1] = H[2] + dl + er | 0;
                                H[2] = H[3] + el + ar | 0;
                                H[3] = H[4] + al + br | 0;
                                H[4] = H[0] + bl + cr | 0;
                                H[0] = t;
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                                data.sigBytes = (dataWords.length + 1) * 4;
                                // Hash final blocks
                                this._process();
                                // Shortcuts
                                var hash = this._hash;
                                var H = hash.words;
                                // Swap endian
                                for(var i = 0; i < 5; i++){
                                    // Shortcut
                                    var H_i = H[i];
                                    // Swap
                                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                                }
                                // Return final computed hash
                                return hash;
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                clone._hash = this._hash.clone();
                                return clone;
                            }
                        });
                        function f1(x, y, z) {
                            return x ^ y ^ z;
                        }
                        function f2(x, y, z) {
                            return x & y | ~x & z;
                        }
                        function f3(x, y, z) {
                            return (x | ~y) ^ z;
                        }
                        function f4(x, y, z) {
                            return x & z | y & ~z;
                        }
                        function f5(x, y, z) {
                            return x ^ (y | ~z);
                        }
                        function rotl(x, n) {
                            return x << n | x >>> 32 - n;
                        }
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.RIPEMD160('message');
     *     var hash = CryptoJS.RIPEMD160(wordArray);
     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
                    })(Math);
                    return CryptoJS.RIPEMD160;
                });
            /***/ },
            /***/ 1593: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var call = __webpack_require__(2834);
                var uncurryThis = __webpack_require__(38347);
                var requireObjectCoercible = __webpack_require__(83943);
                var isCallable = __webpack_require__(94578);
                var isRegExp = __webpack_require__(28831);
                var toString = __webpack_require__(25096);
                var getMethod = __webpack_require__(51839);
                var regExpFlags = __webpack_require__(21182);
                var getSubstitution = __webpack_require__(29519);
                var wellKnownSymbol = __webpack_require__(38688);
                var IS_PURE = __webpack_require__(63432);
                var REPLACE = wellKnownSymbol('replace');
                var RegExpPrototype = RegExp.prototype;
                var TypeError1 = global.TypeError;
                var getFlags = uncurryThis(regExpFlags);
                var indexOf = uncurryThis(''.indexOf);
                var replace = uncurryThis(''.replace);
                var stringSlice = uncurryThis(''.slice);
                var max = Math.max;
                var stringIndexOf = function(string, searchValue, fromIndex) {
                    if (fromIndex > string.length) return -1;
                    if (searchValue === '') return fromIndex;
                    return indexOf(string, searchValue, fromIndex);
                };
                // `String.prototype.replaceAll` method
                // https://tc39.es/ecma262/#sec-string.prototype.replaceall
                $({
                    target: 'String',
                    proto: true
                }, {
                    replaceAll: function replaceAll(searchValue, replaceValue) {
                        var O = requireObjectCoercible(this);
                        var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
                        var position = 0;
                        var endOfLastMatch = 0;
                        var result = '';
                        if (searchValue != null) {
                            IS_REG_EXP = isRegExp(searchValue);
                            if (IS_REG_EXP) {
                                flags = toString(requireObjectCoercible('flags' in RegExpPrototype ? searchValue.flags : getFlags(searchValue)));
                                if (!~indexOf(flags, 'g')) throw TypeError1('`.replaceAll` does not allow non-global regexes');
                            }
                            replacer = getMethod(searchValue, REPLACE);
                            if (replacer) return call(replacer, searchValue, O, replaceValue);
                            else if (IS_PURE && IS_REG_EXP) return replace(toString(O), searchValue, replaceValue);
                        }
                        string = toString(O);
                        searchString = toString(searchValue);
                        functionalReplace = isCallable(replaceValue);
                        if (!functionalReplace) replaceValue = toString(replaceValue);
                        searchLength = searchString.length;
                        advanceBy = max(1, searchLength);
                        position = stringIndexOf(string, searchString, 0);
                        while(position !== -1){
                            replacement = functionalReplace ? toString(replaceValue(searchString, position, string)) : getSubstitution(searchString, string, position, [], undefined, replaceValue);
                            result += stringSlice(string, endOfLastMatch, position) + replacement;
                            endOfLastMatch = position + searchLength;
                            position = stringIndexOf(string, searchString, position + advanceBy);
                        }
                        if (endOfLastMatch < string.length) result += stringSlice(string, endOfLastMatch);
                        return result;
                    }
                });
            /***/ },
            /***/ 2256: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(94845);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var C_enc = C.enc;
                        /**
     * UTF-16 BE encoding strategy.
     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
                            /**
       * Converts a word array to a UTF-16 BE string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-16 BE string.
       *
       * @static
       *
       * @example
       *
       *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                // Convert
                                var utf16Chars = [];
                                for(var i = 0; i < sigBytes; i += 2){
                                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                                    utf16Chars.push(String.fromCharCode(codePoint));
                                }
                                return utf16Chars.join('');
                            },
                            /**
       * Converts a UTF-16 BE string to a word array.
       *
       * @param {string} utf16Str The UTF-16 BE string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
       */ parse: function parse(utf16Str) {
                                // Shortcut
                                var utf16StrLength = utf16Str.length;
                                // Convert
                                var words = [];
                                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                                return WordArray.create(words, utf16StrLength * 2);
                            }
                        };
                        /**
     * UTF-16 LE encoding strategy.
     */ C_enc.Utf16LE = {
                            /**
       * Converts a word array to a UTF-16 LE string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-16 LE string.
       *
       * @static
       *
       * @example
       *
       *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                // Convert
                                var utf16Chars = [];
                                for(var i = 0; i < sigBytes; i += 2){
                                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                                    utf16Chars.push(String.fromCharCode(codePoint));
                                }
                                return utf16Chars.join('');
                            },
                            /**
       * Converts a UTF-16 LE string to a word array.
       *
       * @param {string} utf16Str The UTF-16 LE string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
       */ parse: function parse(utf16Str) {
                                // Shortcut
                                var utf16StrLength = utf16Str.length;
                                // Convert
                                var words = [];
                                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                                return WordArray.create(words, utf16StrLength * 2);
                            }
                        };
                        function swapEndian(word) {
                            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
                        }
                    })();
                    return CryptoJS.enc.Utf16;
                });
            /***/ },
            /***/ 2269: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                var utils = __webpack_require__(72519);
                var adler32 = __webpack_require__(46911);
                var crc32 = __webpack_require__(99049);
                var inflate_fast = __webpack_require__(96395);
                var inflate_table = __webpack_require__(92920);
                var CODES = 0;
                var LENS = 1;
                var DISTS = 2;
                /* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
                //var Z_PARTIAL_FLUSH = 1;
                //var Z_SYNC_FLUSH    = 2;
                //var Z_FULL_FLUSH    = 3;
                var Z_FINISH = 4;
                var Z_BLOCK = 5;
                var Z_TREES = 6;
                /* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
                var Z_STREAM_END = 1;
                var Z_NEED_DICT = 2;
                //var Z_ERRNO         = -1;
                var Z_STREAM_ERROR = -2;
                var Z_DATA_ERROR = -3;
                var Z_MEM_ERROR = -4;
                var Z_BUF_ERROR = -5;
                //var Z_VERSION_ERROR = -6;
                /* The deflate compression method */ var Z_DEFLATED = 8;
                /* STATES ====================================================================*/ /* ===========================================================================*/ var HEAD = 1; /* i: waiting for magic header */ 
                var FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
                var TIME = 3; /* i: waiting for modification time (gzip) */ 
                var OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
                var EXLEN = 5; /* i: waiting for extra length (gzip) */ 
                var EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
                var NAME = 7; /* i: waiting for end of file name (gzip) */ 
                var COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
                var HCRC = 9; /* i: waiting for header crc (gzip) */ 
                var DICTID = 10; /* i: waiting for dictionary check value */ 
                var DICT = 11; /* waiting for inflateSetDictionary() call */ 
                var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
                var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
                var STORED = 14; /* i: waiting for stored size (length and complement) */ 
                var COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
                var COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
                var TABLE = 17; /* i: waiting for dynamic block table lengths */ 
                var LENLENS = 18; /* i: waiting for code length code lengths */ 
                var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
                var LEN_ = 20; /* i: same as LEN below, but only first time in */ 
                var LEN = 21; /* i: waiting for length/lit/eob code */ 
                var LENEXT = 22; /* i: waiting for length extra bits */ 
                var DIST = 23; /* i: waiting for distance code */ 
                var DISTEXT = 24; /* i: waiting for distance extra bits */ 
                var MATCH = 25; /* o: waiting for output space to copy string */ 
                var LIT = 26; /* o: waiting for output space to write literal */ 
                var CHECK = 27; /* i: waiting for 32-bit check value */ 
                var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
                var DONE = 29; /* finished check, done -- remain here until reset */ 
                var BAD = 30; /* got a data error -- remain here until reset */ 
                var MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
                var SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
                /* ===========================================================================*/ var ENOUGH_LENS = 852;
                var ENOUGH_DISTS = 592;
                //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
                var MAX_WBITS = 15;
                /* 32K LZ77 window */ var DEF_WBITS = MAX_WBITS;
                function zswap32(q) {
                    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
                }
                function InflateState() {
                    this.mode = 0; /* current inflate mode */ 
                    this.last = false; /* true if processing last block */ 
                    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
                    this.havedict = false; /* true if dictionary provided */ 
                    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
                    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
                    this.check = 0; /* protected copy of check value */ 
                    this.total = 0; /* protected copy of output count */ 
                    // TODO: may be {}
                    this.head = null; /* where to save gzip header information */ 
                    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
                    this.wsize = 0; /* window size or zero if not using window */ 
                    this.whave = 0; /* valid bytes in the window */ 
                    this.wnext = 0; /* window write index */ 
                    this.window = null; /* allocated sliding window, if needed */ 
                    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
                    this.bits = 0; /* number of bits in "in" */ 
                    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
                    this.offset = 0; /* distance back to copy string from */ 
                    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
                    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
                    this.distcode = null; /* starting table for distance codes */ 
                    this.lenbits = 0; /* index bits for lencode */ 
                    this.distbits = 0; /* index bits for distcode */ 
                    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
                    this.nlen = 0; /* number of length code lengths */ 
                    this.ndist = 0; /* number of distance code lengths */ 
                    this.have = 0; /* number of code lengths in lens[] */ 
                    this.next = null; /* next available space in codes[] */ 
                    this.lens = new utils.Buf16(320); /* temporary storage for code lengths */ 
                    this.work = new utils.Buf16(288); /* work area for code table building */ 
                    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
                    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
                    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
                    this.sane = 0; /* if false, allow invalid distance too far */ 
                    this.back = 0; /* bits back of last unprocessed length/lit */ 
                    this.was = 0; /* initial length of match */ 
                }
                function inflateResetKeep(strm) {
                    var state;
                    if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    strm.total_in = strm.total_out = state.total = 0;
                    strm.msg = ''; /*Z_NULL*/ 
                    if (state.wrap) strm.adler = state.wrap & 1;
                    state.mode = HEAD;
                    state.last = 0;
                    state.havedict = 0;
                    state.dmax = 32768;
                    state.head = null /*Z_NULL*/ ;
                    state.hold = 0;
                    state.bits = 0;
                    //state.lencode = state.distcode = state.next = state.codes;
                    state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
                    state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
                    state.sane = 1;
                    state.back = -1;
                    //Tracev((stderr, "inflate: reset\n"));
                    return Z_OK;
                }
                function inflateReset(strm) {
                    var state;
                    if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    state.wsize = 0;
                    state.whave = 0;
                    state.wnext = 0;
                    return inflateResetKeep(strm);
                }
                function inflateReset2(strm, windowBits) {
                    var wrap;
                    var state;
                    /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
                        wrap = 0;
                        windowBits = -windowBits;
                    } else {
                        wrap = (windowBits >> 4) + 1;
                        if (windowBits < 48) windowBits &= 15;
                    }
                    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
                    if (state.window !== null && state.wbits !== windowBits) state.window = null;
                    /* update state and reset the rest of it */ state.wrap = wrap;
                    state.wbits = windowBits;
                    return inflateReset(strm);
                }
                function inflateInit2(strm, windowBits) {
                    var ret;
                    var state;
                    if (!strm) return Z_STREAM_ERROR;
                    //strm.msg = Z_NULL;                 /* in case we return an error */
                    state = new InflateState();
                    //if (state === Z_NULL) return Z_MEM_ERROR;
                    //Tracev((stderr, "inflate: allocated\n"));
                    strm.state = state;
                    state.window = null /*Z_NULL*/ ;
                    ret = inflateReset2(strm, windowBits);
                    if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
                    return ret;
                }
                function inflateInit(strm) {
                    return inflateInit2(strm, DEF_WBITS);
                }
                /*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var virgin = true;
                var lenfix, distfix; // We have no pointers in JS, so keep tables separate
                function fixedtables(state) {
                    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
                        var sym;
                        lenfix = new utils.Buf32(512);
                        distfix = new utils.Buf32(32);
                        /* literal/length table */ sym = 0;
                        while(sym < 144)state.lens[sym++] = 8;
                        while(sym < 256)state.lens[sym++] = 9;
                        while(sym < 280)state.lens[sym++] = 7;
                        while(sym < 288)state.lens[sym++] = 8;
                        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
                            bits: 9
                        });
                        /* distance table */ sym = 0;
                        while(sym < 32)state.lens[sym++] = 5;
                        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
                            bits: 5
                        });
                        /* do this just once */ virgin = false;
                    }
                    state.lencode = lenfix;
                    state.lenbits = 9;
                    state.distcode = distfix;
                    state.distbits = 5;
                }
                /*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function updatewindow(strm, src, end, copy) {
                    var dist;
                    var state = strm.state;
                    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
                        state.wsize = 1 << state.wbits;
                        state.wnext = 0;
                        state.whave = 0;
                        state.window = new utils.Buf8(state.wsize);
                    }
                    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
                        utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
                        state.wnext = 0;
                        state.whave = state.wsize;
                    } else {
                        dist = state.wsize - state.wnext;
                        if (dist > copy) dist = copy;
                        //zmemcpy(state->window + state->wnext, end - copy, dist);
                        utils.arraySet(state.window, src, end - copy, dist, state.wnext);
                        copy -= dist;
                        if (copy) {
                            //zmemcpy(state->window, end - copy, copy);
                            utils.arraySet(state.window, src, end - copy, copy, 0);
                            state.wnext = copy;
                            state.whave = state.wsize;
                        } else {
                            state.wnext += dist;
                            if (state.wnext === state.wsize) state.wnext = 0;
                            if (state.whave < state.wsize) state.whave += dist;
                        }
                    }
                    return 0;
                }
                function inflate(strm, flush) {
                    var state;
                    var input, output; // input/output buffers
                    var next; /* next input INDEX */ 
                    var put; /* next output INDEX */ 
                    var have, left; /* available input and output */ 
                    var hold; /* bit buffer */ 
                    var bits; /* bits in bit buffer */ 
                    var _in, _out; /* save starting available input and output */ 
                    var copy; /* number of stored or match bytes to copy */ 
                    var from; /* where to copy match bytes from */ 
                    var from_source;
                    var here = 0; /* current decoding table entry */ 
                    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
                    //var last;                   /* parent table entry */
                    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
                    var len; /* length to copy for repeats, bits to drop */ 
                    var ret; /* return code */ 
                    var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */ 
                    var opts;
                    var n; // temporary var for NEED_BITS
                    var order = /* permutation of code lengths */ [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
                    state = strm.state;
                    if (state.mode === TYPE) state.mode = TYPEDO;
                     /* skip check */ 
                    //--- LOAD() ---
                    put = strm.next_out;
                    output = strm.output;
                    left = strm.avail_out;
                    next = strm.next_in;
                    input = strm.input;
                    have = strm.avail_in;
                    hold = state.hold;
                    bits = state.bits;
                    //---
                    _in = have;
                    _out = left;
                    ret = Z_OK;
                    inf_leave: for(;;)switch(state.mode){
                        case HEAD:
                            if (state.wrap === 0) {
                                state.mode = TYPEDO;
                                break;
                            }
                            //=== NEEDBITS(16);
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.wrap & 2 && hold === 0x8b1f) {
                                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32(state.check, hbuf, 2, 0);
                                //===//
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                                //===//
                                state.mode = FLAGS;
                                break;
                            }
                            state.flags = 0; /* expect zlib header */ 
                            if (state.head) state.head.done = false;
                            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                                strm.msg = 'incorrect header check';
                                state.mode = BAD;
                                break;
                            }
                            if ((hold & 0x0f) !== Z_DEFLATED) {
                                strm.msg = 'unknown compression method';
                                state.mode = BAD;
                                break;
                            }
                            //--- DROPBITS(4) ---//
                            hold >>>= 4;
                            bits -= 4;
                            //---//
                            len = (hold & 0x0f) + 8;
                            if (state.wbits === 0) state.wbits = len;
                            else if (len > state.wbits) {
                                strm.msg = 'invalid window size';
                                state.mode = BAD;
                                break;
                            }
                            state.dmax = 1 << len;
                            //Tracev((stderr, "inflate:   zlib header ok\n"));
                            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
                            state.mode = hold & 0x200 ? DICTID : TYPE;
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            break;
                        case FLAGS:
                            //=== NEEDBITS(16); */
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.flags = hold;
                            if ((state.flags & 0xff) !== Z_DEFLATED) {
                                strm.msg = 'unknown compression method';
                                state.mode = BAD;
                                break;
                            }
                            if (state.flags & 0xe000) {
                                strm.msg = 'unknown header flags set';
                                state.mode = BAD;
                                break;
                            }
                            if (state.head) state.head.text = hold >> 8 & 1;
                            if (state.flags & 0x0200) {
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32(state.check, hbuf, 2, 0);
                            //===//
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = TIME;
                        /* falls through */ case TIME:
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.head) state.head.time = hold;
                            if (state.flags & 0x0200) {
                                //=== CRC4(state.check, hold)
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                hbuf[2] = hold >>> 16 & 0xff;
                                hbuf[3] = hold >>> 24 & 0xff;
                                state.check = crc32(state.check, hbuf, 4, 0);
                            //===
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = OS;
                        /* falls through */ case OS:
                            //=== NEEDBITS(16); */
                            while(bits < 16){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if (state.head) {
                                state.head.xflags = hold & 0xff;
                                state.head.os = hold >> 8;
                            }
                            if (state.flags & 0x0200) {
                                //=== CRC2(state.check, hold);
                                hbuf[0] = hold & 0xff;
                                hbuf[1] = hold >>> 8 & 0xff;
                                state.check = crc32(state.check, hbuf, 2, 0);
                            //===//
                            }
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = EXLEN;
                        /* falls through */ case EXLEN:
                            if (state.flags & 0x0400) {
                                //=== NEEDBITS(16); */
                                while(bits < 16){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.length = hold;
                                if (state.head) state.head.extra_len = hold;
                                if (state.flags & 0x0200) {
                                    //=== CRC2(state.check, hold);
                                    hbuf[0] = hold & 0xff;
                                    hbuf[1] = hold >>> 8 & 0xff;
                                    state.check = crc32(state.check, hbuf, 2, 0);
                                //===//
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
                            state.mode = EXTRA;
                        /* falls through */ case EXTRA:
                            if (state.flags & 0x0400) {
                                copy = state.length;
                                if (copy > have) copy = have;
                                if (copy) {
                                    if (state.head) {
                                        len = state.head.extra_len - state.length;
                                        if (!state.head.extra) // Use untyped array for more convenient processing later
                                        state.head.extra = new Array(state.head.extra_len);
                                        utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                                        // - no need for additional size check
                                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                                    //zmemcpy(state.head.extra + len, next,
                                    //        len + copy > state.head.extra_max ?
                                    //        state.head.extra_max - len : copy);
                                    }
                                    if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                                    have -= copy;
                                    next += copy;
                                    state.length -= copy;
                                }
                                if (state.length) break inf_leave;
                            }
                            state.length = 0;
                            state.mode = NAME;
                        /* falls through */ case NAME:
                            if (state.flags & 0x0800) {
                                if (have === 0) break inf_leave;
                                copy = 0;
                                do {
                                    // TODO: 2 or 1 bytes?
                                    len = input[next + copy++];
                                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                                }while (len && copy < have);
                                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                                have -= copy;
                                next += copy;
                                if (len) break inf_leave;
                            } else if (state.head) state.head.name = null;
                            state.length = 0;
                            state.mode = COMMENT;
                        /* falls through */ case COMMENT:
                            if (state.flags & 0x1000) {
                                if (have === 0) break inf_leave;
                                copy = 0;
                                do {
                                    len = input[next + copy++];
                                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                                }while (len && copy < have);
                                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                                have -= copy;
                                next += copy;
                                if (len) break inf_leave;
                            } else if (state.head) state.head.comment = null;
                            state.mode = HCRC;
                        /* falls through */ case HCRC:
                            if (state.flags & 0x0200) {
                                //=== NEEDBITS(16); */
                                while(bits < 16){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                if (hold !== (state.check & 0xffff)) {
                                    strm.msg = 'header crc mismatch';
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            }
                            if (state.head) {
                                state.head.hcrc = state.flags >> 9 & 1;
                                state.head.done = true;
                            }
                            strm.adler = state.check = 0;
                            state.mode = TYPE;
                            break;
                        case DICTID:
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            strm.adler = state.check = zswap32(hold);
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = DICT;
                        /* falls through */ case DICT:
                            if (state.havedict === 0) {
                                //--- RESTORE() ---
                                strm.next_out = put;
                                strm.avail_out = left;
                                strm.next_in = next;
                                strm.avail_in = have;
                                state.hold = hold;
                                state.bits = bits;
                                //---
                                return Z_NEED_DICT;
                            }
                            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
                            state.mode = TYPE;
                        /* falls through */ case TYPE:
                            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
                        /* falls through */ case TYPEDO:
                            if (state.last) {
                                //--- BYTEBITS() ---//
                                hold >>>= bits & 7;
                                bits -= bits & 7;
                                //---//
                                state.mode = CHECK;
                                break;
                            }
                            //=== NEEDBITS(3); */
                            while(bits < 3){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.last = hold & 0x01 /*BITS(1)*/ ;
                            //--- DROPBITS(1) ---//
                            hold >>>= 1;
                            bits -= 1;
                            //---//
                            switch(hold & 0x03){
                                case 0:
                                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = STORED;
                                    break;
                                case 1:
                                    /* fixed block */ fixedtables(state);
                                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = LEN_; /* decode codes */ 
                                    if (flush === Z_TREES) {
                                        //--- DROPBITS(2) ---//
                                        hold >>>= 2;
                                        bits -= 2;
                                        break inf_leave;
                                    }
                                    break;
                                case 2:
                                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                                    //        state.last ? " (last)" : ""));
                                    state.mode = TABLE;
                                    break;
                                case 3:
                                    strm.msg = 'invalid block type';
                                    state.mode = BAD;
                            }
                            //--- DROPBITS(2) ---//
                            hold >>>= 2;
                            bits -= 2;
                            break;
                        case STORED:
                            //--- BYTEBITS() ---// /* go to byte boundary */
                            hold >>>= bits & 7;
                            bits -= bits & 7;
                            //---//
                            //=== NEEDBITS(32); */
                            while(bits < 32){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                                strm.msg = 'invalid stored block lengths';
                                state.mode = BAD;
                                break;
                            }
                            state.length = hold & 0xffff;
                            //Tracev((stderr, "inflate:       stored length %u\n",
                            //        state.length));
                            //=== INITBITS();
                            hold = 0;
                            bits = 0;
                            //===//
                            state.mode = COPY_;
                            if (flush === Z_TREES) break inf_leave;
                        /* falls through */ case COPY_:
                            state.mode = COPY;
                        /* falls through */ case COPY:
                            copy = state.length;
                            if (copy) {
                                if (copy > have) copy = have;
                                if (copy > left) copy = left;
                                if (copy === 0) break inf_leave;
                                //--- zmemcpy(put, next, copy); ---
                                utils.arraySet(output, input, next, copy, put);
                                //---//
                                have -= copy;
                                next += copy;
                                left -= copy;
                                put += copy;
                                state.length -= copy;
                                break;
                            }
                            //Tracev((stderr, "inflate:       stored end\n"));
                            state.mode = TYPE;
                            break;
                        case TABLE:
                            //=== NEEDBITS(14); */
                            while(bits < 14){
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            }
                            //===//
                            state.nlen = (hold & 0x1f) + 257;
                            //--- DROPBITS(5) ---//
                            hold >>>= 5;
                            bits -= 5;
                            //---//
                            state.ndist = (hold & 0x1f) + 1;
                            //--- DROPBITS(5) ---//
                            hold >>>= 5;
                            bits -= 5;
                            //---//
                            state.ncode = (hold & 0x0f) + 4;
                            //--- DROPBITS(4) ---//
                            hold >>>= 4;
                            bits -= 4;
                            //---//
                            //#ifndef PKZIP_BUG_WORKAROUND
                            if (state.nlen > 286 || state.ndist > 30) {
                                strm.msg = 'too many length or distance symbols';
                                state.mode = BAD;
                                break;
                            }
                            //#endif
                            //Tracev((stderr, "inflate:       table sizes ok\n"));
                            state.have = 0;
                            state.mode = LENLENS;
                        /* falls through */ case LENLENS:
                            while(state.have < state.ncode){
                                //=== NEEDBITS(3);
                                while(bits < 3){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                                //--- DROPBITS(3) ---//
                                hold >>>= 3;
                                bits -= 3;
                            //---//
                            }
                            while(state.have < 19)state.lens[order[state.have++]] = 0;
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            //state.next = state.codes;
                            //state.lencode = state.next;
                            // Switch to use dynamic table
                            state.lencode = state.lendyn;
                            state.lenbits = 7;
                            opts = {
                                bits: state.lenbits
                            };
                            ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
                            state.lenbits = opts.bits;
                            if (ret) {
                                strm.msg = 'invalid code lengths set';
                                state.mode = BAD;
                                break;
                            }
                            //Tracev((stderr, "inflate:       code lengths ok\n"));
                            state.have = 0;
                            state.mode = CODELENS;
                        /* falls through */ case CODELENS:
                            while(state.have < state.nlen + state.ndist){
                                for(;;){
                                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                if (here_val < 16) {
                                    //--- DROPBITS(here.bits) ---//
                                    hold >>>= here_bits;
                                    bits -= here_bits;
                                    //---//
                                    state.lens[state.have++] = here_val;
                                } else {
                                    if (here_val === 16) {
                                        //=== NEEDBITS(here.bits + 2);
                                        n = here_bits + 2;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        if (state.have === 0) {
                                            strm.msg = 'invalid bit length repeat';
                                            state.mode = BAD;
                                            break;
                                        }
                                        len = state.lens[state.have - 1];
                                        copy = 3 + (hold & 0x03); //BITS(2);
                                        //--- DROPBITS(2) ---//
                                        hold >>>= 2;
                                        bits -= 2;
                                    //---//
                                    } else if (here_val === 17) {
                                        //=== NEEDBITS(here.bits + 3);
                                        n = here_bits + 3;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        len = 0;
                                        copy = 3 + (hold & 0x07); //BITS(3);
                                        //--- DROPBITS(3) ---//
                                        hold >>>= 3;
                                        bits -= 3;
                                    //---//
                                    } else {
                                        //=== NEEDBITS(here.bits + 7);
                                        n = here_bits + 7;
                                        while(bits < n){
                                            if (have === 0) break inf_leave;
                                            have--;
                                            hold += input[next++] << bits;
                                            bits += 8;
                                        }
                                        //===//
                                        //--- DROPBITS(here.bits) ---//
                                        hold >>>= here_bits;
                                        bits -= here_bits;
                                        //---//
                                        len = 0;
                                        copy = 11 + (hold & 0x7f); //BITS(7);
                                        //--- DROPBITS(7) ---//
                                        hold >>>= 7;
                                        bits -= 7;
                                    //---//
                                    }
                                    if (state.have + copy > state.nlen + state.ndist) {
                                        strm.msg = 'invalid bit length repeat';
                                        state.mode = BAD;
                                        break;
                                    }
                                    while(copy--)state.lens[state.have++] = len;
                                }
                            }
                            /* handle error breaks in while */ if (state.mode === BAD) break;
                            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                                strm.msg = 'invalid code -- missing end-of-block';
                                state.mode = BAD;
                                break;
                            }
                            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
                            opts = {
                                bits: state.lenbits
                            };
                            ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            // state.next_index = opts.table_index;
                            state.lenbits = opts.bits;
                            // state.lencode = state.next;
                            if (ret) {
                                strm.msg = 'invalid literal/lengths set';
                                state.mode = BAD;
                                break;
                            }
                            state.distbits = 6;
                            //state.distcode.copy(state.codes);
                            // Switch to use dynamic table
                            state.distcode = state.distdyn;
                            opts = {
                                bits: state.distbits
                            };
                            ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
                            // We have separate tables & no pointers. 2 commented lines below not needed.
                            // state.next_index = opts.table_index;
                            state.distbits = opts.bits;
                            // state.distcode = state.next;
                            if (ret) {
                                strm.msg = 'invalid distances set';
                                state.mode = BAD;
                                break;
                            }
                            //Tracev((stderr, 'inflate:       codes ok\n'));
                            state.mode = LEN_;
                            if (flush === Z_TREES) break inf_leave;
                        /* falls through */ case LEN_:
                            state.mode = LEN;
                        /* falls through */ case LEN:
                            if (have >= 6 && left >= 258) {
                                //--- RESTORE() ---
                                strm.next_out = put;
                                strm.avail_out = left;
                                strm.next_in = next;
                                strm.avail_in = have;
                                state.hold = hold;
                                state.bits = bits;
                                //---
                                inflate_fast(strm, _out);
                                //--- LOAD() ---
                                put = strm.next_out;
                                output = strm.output;
                                left = strm.avail_out;
                                next = strm.next_in;
                                input = strm.input;
                                have = strm.avail_in;
                                hold = state.hold;
                                bits = state.bits;
                                //---
                                if (state.mode === TYPE) state.back = -1;
                                break;
                            }
                            state.back = 0;
                            for(;;){
                                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            if (here_op && (here_op & 0xf0) === 0) {
                                last_bits = here_bits;
                                last_op = here_op;
                                last_val = here_val;
                                for(;;){
                                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (last_bits + here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                //--- DROPBITS(last.bits) ---//
                                hold >>>= last_bits;
                                bits -= last_bits;
                                //---//
                                state.back += last_bits;
                            }
                            //--- DROPBITS(here.bits) ---//
                            hold >>>= here_bits;
                            bits -= here_bits;
                            //---//
                            state.back += here_bits;
                            state.length = here_val;
                            if (here_op === 0) {
                                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                                //        "inflate:         literal '%c'\n" :
                                //        "inflate:         literal 0x%02x\n", here.val));
                                state.mode = LIT;
                                break;
                            }
                            if (here_op & 32) {
                                //Tracevv((stderr, "inflate:         end of block\n"));
                                state.back = -1;
                                state.mode = TYPE;
                                break;
                            }
                            if (here_op & 64) {
                                strm.msg = 'invalid literal/length code';
                                state.mode = BAD;
                                break;
                            }
                            state.extra = here_op & 15;
                            state.mode = LENEXT;
                        /* falls through */ case LENEXT:
                            if (state.extra) {
                                //=== NEEDBITS(state.extra);
                                n = state.extra;
                                while(bits < n){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                                //--- DROPBITS(state.extra) ---//
                                hold >>>= state.extra;
                                bits -= state.extra;
                                //---//
                                state.back += state.extra;
                            }
                            //Tracevv((stderr, "inflate:         length %u\n", state.length));
                            state.was = state.length;
                            state.mode = DIST;
                        /* falls through */ case DIST:
                            for(;;){
                                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                                here_bits = here >>> 24;
                                here_op = here >>> 16 & 0xff;
                                here_val = here & 0xffff;
                                if (here_bits <= bits) break;
                                //--- PULLBYTE() ---//
                                if (have === 0) break inf_leave;
                                have--;
                                hold += input[next++] << bits;
                                bits += 8;
                            //---//
                            }
                            if ((here_op & 0xf0) === 0) {
                                last_bits = here_bits;
                                last_op = here_op;
                                last_val = here_val;
                                for(;;){
                                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                                    here_bits = here >>> 24;
                                    here_op = here >>> 16 & 0xff;
                                    here_val = here & 0xffff;
                                    if (last_bits + here_bits <= bits) break;
                                    //--- PULLBYTE() ---//
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                //---//
                                }
                                //--- DROPBITS(last.bits) ---//
                                hold >>>= last_bits;
                                bits -= last_bits;
                                //---//
                                state.back += last_bits;
                            }
                            //--- DROPBITS(here.bits) ---//
                            hold >>>= here_bits;
                            bits -= here_bits;
                            //---//
                            state.back += here_bits;
                            if (here_op & 64) {
                                strm.msg = 'invalid distance code';
                                state.mode = BAD;
                                break;
                            }
                            state.offset = here_val;
                            state.extra = here_op & 15;
                            state.mode = DISTEXT;
                        /* falls through */ case DISTEXT:
                            if (state.extra) {
                                //=== NEEDBITS(state.extra);
                                n = state.extra;
                                while(bits < n){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                                //--- DROPBITS(state.extra) ---//
                                hold >>>= state.extra;
                                bits -= state.extra;
                                //---//
                                state.back += state.extra;
                            }
                            //#ifdef INFLATE_STRICT
                            if (state.offset > state.dmax) {
                                strm.msg = 'invalid distance too far back';
                                state.mode = BAD;
                                break;
                            }
                            //#endif
                            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
                            state.mode = MATCH;
                        /* falls through */ case MATCH:
                            if (left === 0) break inf_leave;
                            copy = _out - left;
                            if (state.offset > copy) {
                                copy = state.offset - copy;
                                if (copy > state.whave) {
                                    if (state.sane) {
                                        strm.msg = 'invalid distance too far back';
                                        state.mode = BAD;
                                        break;
                                    }
                                }
                                if (copy > state.wnext) {
                                    copy -= state.wnext;
                                    from = state.wsize - copy;
                                } else from = state.wnext - copy;
                                if (copy > state.length) copy = state.length;
                                from_source = state.window;
                            } else {
                                from_source = output;
                                from = put - state.offset;
                                copy = state.length;
                            }
                            if (copy > left) copy = left;
                            left -= copy;
                            state.length -= copy;
                            do output[put++] = from_source[from++];
                            while (--copy);
                            if (state.length === 0) state.mode = LEN;
                            break;
                        case LIT:
                            if (left === 0) break inf_leave;
                            output[put++] = state.length;
                            left--;
                            state.mode = LEN;
                            break;
                        case CHECK:
                            if (state.wrap) {
                                //=== NEEDBITS(32);
                                while(bits < 32){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    // Use '|' instead of '+' to make sure that result is signed
                                    hold |= input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                _out -= left;
                                strm.total_out += _out;
                                state.total += _out;
                                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                                _out = left;
                                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                                    strm.msg = 'incorrect data check';
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            //Tracev((stderr, "inflate:   check matches trailer\n"));
                            }
                            state.mode = LENGTH;
                        /* falls through */ case LENGTH:
                            if (state.wrap && state.flags) {
                                //=== NEEDBITS(32);
                                while(bits < 32){
                                    if (have === 0) break inf_leave;
                                    have--;
                                    hold += input[next++] << bits;
                                    bits += 8;
                                }
                                //===//
                                if (hold !== (state.total & 0xffffffff)) {
                                    strm.msg = 'incorrect length check';
                                    state.mode = BAD;
                                    break;
                                }
                                //=== INITBITS();
                                hold = 0;
                                bits = 0;
                            //===//
                            //Tracev((stderr, "inflate:   length matches trailer\n"));
                            }
                            state.mode = DONE;
                        /* falls through */ case DONE:
                            ret = Z_STREAM_END;
                            break inf_leave;
                        case BAD:
                            ret = Z_DATA_ERROR;
                            break inf_leave;
                        case MEM:
                            return Z_MEM_ERROR;
                        case SYNC:
                        /* falls through */ default:
                            return Z_STREAM_ERROR;
                    }
                    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
                    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
                    strm.next_out = put;
                    strm.avail_out = left;
                    strm.next_in = next;
                    strm.avail_in = have;
                    state.hold = hold;
                    state.bits = bits;
                    //---
                    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
                        if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
                            state.mode = MEM;
                            return Z_MEM_ERROR;
                        }
                    }
                    _in -= strm.avail_in;
                    _out -= strm.avail_out;
                    strm.total_in += _in;
                    strm.total_out += _out;
                    state.total += _out;
                    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
                    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
                    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
                    return ret;
                }
                function inflateEnd(strm) {
                    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return Z_STREAM_ERROR;
                    var state = strm.state;
                    if (state.window) state.window = null;
                    strm.state = null;
                    return Z_OK;
                }
                function inflateGetHeader(strm, head) {
                    var state;
                    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
                    state = strm.state;
                    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
                    /* save header structure */ state.head = head;
                    head.done = false;
                    return Z_OK;
                }
                function inflateSetDictionary(strm, dictionary) {
                    var dictLength = dictionary.length;
                    var state;
                    var dictid;
                    var ret;
                    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return Z_STREAM_ERROR;
                    state = strm.state;
                    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
                    /* check for correct dictionary identifier */ if (state.mode === DICT) {
                        dictid = 1; /* adler32(0, null, 0)*/ 
                        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32(dictid, dictionary, dictLength, 0);
                        if (dictid !== state.check) return Z_DATA_ERROR;
                    }
                    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
                    if (ret) {
                        state.mode = MEM;
                        return Z_MEM_ERROR;
                    }
                    state.havedict = 1;
                    // Tracev((stderr, "inflate:   dictionary set\n"));
                    return Z_OK;
                }
                exports.inflateReset = inflateReset;
                exports.inflateReset2 = inflateReset2;
                exports.inflateResetKeep = inflateResetKeep;
                exports.inflateInit = inflateInit;
                exports.inflateInit2 = inflateInit2;
                exports.inflate = inflate;
                exports.inflateEnd = inflateEnd;
                exports.inflateGetHeader = inflateGetHeader;
                exports.inflateSetDictionary = inflateSetDictionary;
                exports.inflateInfo = 'pako inflate (from Nodeca project)';
            /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ /***/ },
            /***/ 2318: /***/ function(module1) {
                "use strict";
                function TraversalTracker() {
                    this.events = {};
                }
                TraversalTracker.prototype.startTracking = function(event, callback) {
                    var callbacks = this.events[event] || (this.events[event] = []);
                    if (callbacks.indexOf(callback) < 0) callbacks.push(callback);
                };
                TraversalTracker.prototype.stopTracking = function(event, callback) {
                    var callbacks = this.events[event];
                    if (!callbacks) return;
                    var index = callbacks.indexOf(callback);
                    if (index >= 0) callbacks.splice(index, 1);
                };
                TraversalTracker.prototype.emit = function(event) {
                    var args = Array.prototype.slice.call(arguments, 1);
                    var callbacks = this.events[event];
                    if (!callbacks) return;
                    callbacks.forEach(function(callback) {
                        callback.apply(this, args);
                    });
                };
                TraversalTracker.prototype.auto = function(event, callback, innerFunction) {
                    this.startTracking(event, callback);
                    innerFunction();
                    this.stopTracking(event, callback);
                };
                module1.exports = TraversalTracker;
            /***/ },
            /***/ 2416: /***/ function(module1) {
                // IE8- don't enum bug keys
                module1.exports = [
                    'constructor',
                    'hasOwnProperty',
                    'isPrototypeOf',
                    'propertyIsEnumerable',
                    'toLocaleString',
                    'toString',
                    'valueOf'
                ];
            /***/ },
            /***/ 2644: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var call = __webpack_require__(2834);
                var isObject = __webpack_require__(24517);
                var isSymbol = __webpack_require__(46290);
                var getMethod = __webpack_require__(51839);
                var ordinaryToPrimitive = __webpack_require__(39629);
                var wellKnownSymbol = __webpack_require__(38688);
                var TypeError1 = global.TypeError;
                var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
                // `ToPrimitive` abstract operation
                // https://tc39.es/ecma262/#sec-toprimitive
                module1.exports = function(input, pref) {
                    if (!isObject(input) || isSymbol(input)) return input;
                    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
                    var result;
                    if (exoticToPrim) {
                        if (pref === undefined) pref = 'default';
                        result = call(exoticToPrim, input, pref);
                        if (!isObject(result) || isSymbol(result)) return result;
                        throw TypeError1("Can't convert object to primitive value");
                    }
                    if (pref === undefined) pref = 'number';
                    return ordinaryToPrimitive(input, pref);
                };
            /***/ },
            /***/ 2675: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var hasOwn = __webpack_require__(20340);
                var ownKeys = __webpack_require__(21594);
                var getOwnPropertyDescriptorModule = __webpack_require__(72062);
                var definePropertyModule = __webpack_require__(95892);
                module1.exports = function(target, source) {
                    var keys = ownKeys(source);
                    var defineProperty = definePropertyModule.f;
                    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                    }
                };
            /***/ },
            /***/ 2834: /***/ function(module1) {
                var call = Function.prototype.call;
                module1.exports = call.bind ? call.bind(call) : function() {
                    return call.apply(call, arguments);
                };
            /***/ },
            /***/ 2857: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $forEach = __webpack_require__(91102).forEach;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.forEach` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
                exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */ ) {
                    $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 2868: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isPrototypeOf = __webpack_require__(70176);
                var TypeError1 = global.TypeError;
                module1.exports = function(it, Prototype) {
                    if (isPrototypeOf(Prototype, it)) return it;
                    throw TypeError1('Incorrect invocation');
                };
            /***/ },
            /***/ 2876: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var isIntegralNumber = __webpack_require__(17506);
                // `Number.isInteger` method
                // https://tc39.es/ecma262/#sec-number.isinteger
                $({
                    target: 'Number',
                    stat: true
                }, {
                    isInteger: isIntegralNumber
                });
            /***/ },
            /***/ 3131: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(98828);
                // `Float32Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor('Float32', function(init) {
                    return function Float32Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 3157: /***/ function(module1) {
                module1.exports = typeof window == 'object';
            /***/ },
            /***/ 3483: /***/ function(module1) {
                var TINF_OK = 0;
                var TINF_DATA_ERROR = -3;
                function Tree() {
                    this.table = new Uint16Array(16); /* table of code length counts */ 
                    this.trans = new Uint16Array(288); /* code -> symbol translation table */ 
                }
                function Data(source, dest) {
                    this.source = source;
                    this.sourceIndex = 0;
                    this.tag = 0;
                    this.bitcount = 0;
                    this.dest = dest;
                    this.destLen = 0;
                    this.ltree = new Tree(); /* dynamic length/symbol tree */ 
                    this.dtree = new Tree(); /* dynamic distance tree */ 
                }
                /* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var sltree = new Tree();
                var sdtree = new Tree();
                /* extra bits and base tables for length codes */ var length_bits = new Uint8Array(30);
                var length_base = new Uint16Array(30);
                /* extra bits and base tables for distance codes */ var dist_bits = new Uint8Array(30);
                var dist_base = new Uint16Array(30);
                /* special ordering of code length codes */ var clcidx = new Uint8Array([
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ]);
                /* used by tinf_decode_trees, avoids allocations every call */ var code_tree = new Tree();
                var lengths = new Uint8Array(320);
                /* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function tinf_build_bits_base(bits, base, delta, first) {
                    var i, sum;
                    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
                    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
                    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
                        base[i] = sum;
                        sum += 1 << bits[i];
                    }
                }
                /* build the fixed huffman trees */ function tinf_build_fixed_trees(lt, dt) {
                    var i;
                    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
                    lt.table[7] = 24;
                    lt.table[8] = 152;
                    lt.table[9] = 112;
                    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
                    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
                    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
                    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
                    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
                    dt.table[5] = 32;
                    for(i = 0; i < 32; ++i)dt.trans[i] = i;
                }
                /* given an array of code lengths, build a tree */ var offs = new Uint16Array(16);
                function tinf_build_tree(t, lengths, off, num) {
                    var i, sum;
                    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
                    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
                    t.table[0] = 0;
                    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
                        offs[i] = sum;
                        sum += t.table[i];
                    }
                    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
                }
                /* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function tinf_getbit(d) {
                    /* check if tag is empty */ if (!d.bitcount--) {
                        /* load next tag */ d.tag = d.source[d.sourceIndex++];
                        d.bitcount = 7;
                    }
                    /* shift bit out of tag */ var bit = d.tag & 1;
                    d.tag >>>= 1;
                    return bit;
                }
                /* read a num bit value from a stream and add base */ function tinf_read_bits(d, num, base) {
                    if (!num) return base;
                    while(d.bitcount < 24){
                        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
                        d.bitcount += 8;
                    }
                    var val = d.tag & 0xffff >>> 16 - num;
                    d.tag >>>= num;
                    d.bitcount -= num;
                    return val + base;
                }
                /* given a data stream and a tree, decode a symbol */ function tinf_decode_symbol(d, t) {
                    while(d.bitcount < 24){
                        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
                        d.bitcount += 8;
                    }
                    var sum = 0, cur = 0, len = 0;
                    var tag = d.tag;
                    /* get more bits while code value is above sum */ do {
                        cur = 2 * cur + (tag & 1);
                        tag >>>= 1;
                        ++len;
                        sum += t.table[len];
                        cur -= t.table[len];
                    }while (cur >= 0);
                    d.tag = tag;
                    d.bitcount -= len;
                    return t.trans[sum + cur];
                }
                /* given a data stream, decode dynamic trees from it */ function tinf_decode_trees(d, lt, dt) {
                    var hlit, hdist, hclen;
                    var i, num, length;
                    /* get 5 bits HLIT (257-286) */ hlit = tinf_read_bits(d, 5, 257);
                    /* get 5 bits HDIST (1-32) */ hdist = tinf_read_bits(d, 5, 1);
                    /* get 4 bits HCLEN (4-19) */ hclen = tinf_read_bits(d, 4, 4);
                    for(i = 0; i < 19; ++i)lengths[i] = 0;
                    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
                        /* get 3 bits code length (0-7) */ var clen = tinf_read_bits(d, 3, 0);
                        lengths[clcidx[i]] = clen;
                    }
                    /* build code length tree */ tinf_build_tree(code_tree, lengths, 0, 19);
                    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
                        var sym = tinf_decode_symbol(d, code_tree);
                        switch(sym){
                            case 16:
                                /* copy previous code length 3-6 times (read 2 bits) */ var prev = lengths[num - 1];
                                for(length = tinf_read_bits(d, 2, 3); length; --length)lengths[num++] = prev;
                                break;
                            case 17:
                                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = tinf_read_bits(d, 3, 3); length; --length)lengths[num++] = 0;
                                break;
                            case 18:
                                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = tinf_read_bits(d, 7, 11); length; --length)lengths[num++] = 0;
                                break;
                            default:
                                /* values 0-15 represent the actual code lengths */ lengths[num++] = sym;
                                break;
                        }
                    }
                    /* build dynamic trees */ tinf_build_tree(lt, lengths, 0, hlit);
                    tinf_build_tree(dt, lengths, hlit, hdist);
                }
                /* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function tinf_inflate_block_data(d, lt, dt) {
                    while(true){
                        var sym = tinf_decode_symbol(d, lt);
                        /* check for end of block */ if (sym === 256) return TINF_OK;
                        if (sym < 256) d.dest[d.destLen++] = sym;
                        else {
                            var length, dist, offs;
                            var i;
                            sym -= 257;
                            /* possibly get more bits from length code */ length = tinf_read_bits(d, length_bits[sym], length_base[sym]);
                            dist = tinf_decode_symbol(d, dt);
                            /* possibly get more bits from distance code */ offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);
                            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
                        }
                    }
                }
                /* inflate an uncompressed block of data */ function tinf_inflate_uncompressed_block(d) {
                    var length, invlength;
                    var i;
                    /* unread from bitbuffer */ while(d.bitcount > 8){
                        d.sourceIndex--;
                        d.bitcount -= 8;
                    }
                    /* get length */ length = d.source[d.sourceIndex + 1];
                    length = 256 * length + d.source[d.sourceIndex];
                    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
                    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
                    /* check length */ if (length !== (~invlength & 0x0000ffff)) return TINF_DATA_ERROR;
                    d.sourceIndex += 4;
                    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
                    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
                    return TINF_OK;
                }
                /* inflate stream from source to dest */ function tinf_uncompress(source, dest) {
                    var d = new Data(source, dest);
                    var bfinal, btype, res;
                    do {
                        /* read final block flag */ bfinal = tinf_getbit(d);
                        /* read block type (2 bits) */ btype = tinf_read_bits(d, 2, 0);
                        /* decompress block */ switch(btype){
                            case 0:
                                /* decompress uncompressed block */ res = tinf_inflate_uncompressed_block(d);
                                break;
                            case 1:
                                /* decompress block with fixed huffman trees */ res = tinf_inflate_block_data(d, sltree, sdtree);
                                break;
                            case 2:
                                /* decompress block with dynamic huffman trees */ tinf_decode_trees(d, d.ltree, d.dtree);
                                res = tinf_inflate_block_data(d, d.ltree, d.dtree);
                                break;
                            default:
                                res = TINF_DATA_ERROR;
                        }
                        if (res !== TINF_OK) throw new Error('Data error');
                    }while (!bfinal);
                    if (d.destLen < d.dest.length) {
                        if (typeof d.dest.slice === 'function') return d.dest.slice(0, d.destLen);
                        else return d.dest.subarray(0, d.destLen);
                    }
                    return d.dest;
                }
                /* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ tinf_build_fixed_trees(sltree, sdtree);
                /* build extra bits and base tables */ tinf_build_bits_base(length_bits, length_base, 4, 3);
                tinf_build_bits_base(dist_bits, dist_base, 2, 1);
                /* fix a special case */ length_bits[28] = 0;
                length_base[28] = 258;
                module1.exports = tinf_uncompress;
            /***/ },
            /***/ 3534: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var getPolyfill = __webpack_require__(89636);
                var define = __webpack_require__(77802);
                module1.exports = function shimObjectIs() {
                    var polyfill = getPolyfill();
                    define(Object, {
                        is: polyfill
                    }, {
                        is: function testObjectIs() {
                            return Object.is !== polyfill;
                        }
                    });
                    return polyfill;
                };
            /***/ },
            /***/ 3746: /***/ function(module1) {
                "use strict";
                var fnToStr = Function.prototype.toString;
                var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
                var badArrayLike;
                var isCallableMarker;
                if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
                    badArrayLike = Object.defineProperty({}, 'length', {
                        get: function() {
                            throw isCallableMarker;
                        }
                    });
                    isCallableMarker = {};
                    // eslint-disable-next-line no-throw-literal
                    reflectApply(function() {
                        throw 42;
                    }, null, badArrayLike);
                } catch (_) {
                    if (_ !== isCallableMarker) reflectApply = null;
                }
                else reflectApply = null;
                var constructorRegex = /^\s*class\b/;
                var isES6ClassFn = function isES6ClassFunction(value) {
                    try {
                        var fnStr = fnToStr.call(value);
                        return constructorRegex.test(fnStr);
                    } catch (e) {
                        return false; // not a function
                    }
                };
                var tryFunctionObject = function tryFunctionToStr(value) {
                    try {
                        if (isES6ClassFn(value)) return false;
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                };
                var toStr = Object.prototype.toString;
                var objectClass = '[object Object]';
                var fnClass = '[object Function]';
                var genClass = '[object GeneratorFunction]';
                var ddaClass = '[object HTMLAllCollection]'; // IE 11
                var ddaClass2 = '[object HTML document.all class]';
                var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
                var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
                var isIE68 = !(0 in [
                    , 
                ]); // eslint-disable-line no-sparse-arrays, comma-spacing
                var isDDA = function isDocumentDotAll() {
                    return false;
                };
                if (typeof document === 'object') {
                    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
                    var all = document.all;
                    if (toStr.call(all) === toStr.call(document.all)) isDDA = function isDocumentDotAll(value) {
                        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
                        if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
                            var str = toStr.call(value);
                            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 // opera 12.16
                             || str === objectClass // IE 6-8
                            ) && value('') == null; // eslint-disable-line eqeqeq
                        } catch (e) {}
                        return false;
                    };
                }
                module1.exports = reflectApply ? function isCallable(value) {
                    if (isDDA(value)) return true;
                    if (!value) return false;
                    if (typeof value !== 'function' && typeof value !== 'object') return false;
                    try {
                        reflectApply(value, null, badArrayLike);
                    } catch (e) {
                        if (e !== isCallableMarker) return false;
                    }
                    return !isES6ClassFn(value) && tryFunctionObject(value);
                } : function isCallable(value) {
                    if (isDDA(value)) return true;
                    if (!value) return false;
                    if (typeof value !== 'function' && typeof value !== 'object') return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    if (isES6ClassFn(value)) return false;
                    var strClass = toStr.call(value);
                    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
                    return tryFunctionObject(value);
                };
            /***/ },
            /***/ 3774: /***/ function(module1) {
                "use strict";
                /** @type {import('./max')} */ module1.exports = Math.max;
            /***/ },
            /***/ 3809: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var userAgent = __webpack_require__(40715);
                var firefox = userAgent.match(/firefox\/(\d+)/i);
                module1.exports = !!firefox && +firefox[1];
            /***/ },
            /***/ 3840: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* eslint-disable no-proto -- safe */ var uncurryThis = __webpack_require__(38347);
                var anObject = __webpack_require__(34984);
                var aPossiblePrototype = __webpack_require__(58659);
                // `Object.setPrototypeOf` method
                // https://tc39.es/ecma262/#sec-object.setprototypeof
                // Works with __proto__ only. Old v8 can't work with null proto objects.
                // eslint-disable-next-line es/no-object-setprototypeof -- safe
                module1.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
                    var CORRECT_SETTER = false;
                    var test = {};
                    var setter;
                    try {
                        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                        setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
                        setter(test, []);
                        CORRECT_SETTER = test instanceof Array;
                    } catch (error) {}
                    return function setPrototypeOf(O, proto) {
                        anObject(O);
                        aPossiblePrototype(proto);
                        if (CORRECT_SETTER) setter(O, proto);
                        else O.__proto__ = proto;
                        return O;
                    };
                }() : undefined);
            /***/ },
            /***/ 3858: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $some = __webpack_require__(91102).some;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.some` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
                exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */ ) {
                    return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 4420: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(39081);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Base = C_lib.Base;
                        var C_enc = C.enc;
                        var Utf8 = C_enc.Utf8;
                        var C_algo = C.algo;
                        /**
     * HMAC algorithm.
     */ var HMAC = C_algo.HMAC = Base.extend({
                            /**
       * Initializes a newly created HMAC.
       *
       * @param {Hasher} hasher The hash algorithm to use.
       * @param {WordArray|string} key The secret key.
       *
       * @example
       *
       *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
       */ init: function init(hasher, key) {
                                // Init hasher
                                hasher = this._hasher = new hasher.init();
                                // Convert string to WordArray, else assume WordArray already
                                if (typeof key == 'string') key = Utf8.parse(key);
                                // Shortcuts
                                var hasherBlockSize = hasher.blockSize;
                                var hasherBlockSizeBytes = hasherBlockSize * 4;
                                // Allow arbitrary length keys
                                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                                // Clamp excess bits
                                key.clamp();
                                // Clone key for inner and outer pads
                                var oKey = this._oKey = key.clone();
                                var iKey = this._iKey = key.clone();
                                // Shortcuts
                                var oKeyWords = oKey.words;
                                var iKeyWords = iKey.words;
                                // XOR keys with pad constants
                                for(var i = 0; i < hasherBlockSize; i++){
                                    oKeyWords[i] ^= 0x5c5c5c5c;
                                    iKeyWords[i] ^= 0x36363636;
                                }
                                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                                // Set initial values
                                this.reset();
                            },
                            /**
       * Resets this HMAC to its initial state.
       *
       * @example
       *
       *     hmacHasher.reset();
       */ reset: function reset() {
                                // Shortcut
                                var hasher = this._hasher;
                                // Reset
                                hasher.reset();
                                hasher.update(this._iKey);
                            },
                            /**
       * Updates this HMAC with a message.
       *
       * @param {WordArray|string} messageUpdate The message to append.
       *
       * @return {HMAC} This HMAC instance.
       *
       * @example
       *
       *     hmacHasher.update('message');
       *     hmacHasher.update(wordArray);
       */ update: function update(messageUpdate) {
                                this._hasher.update(messageUpdate);
                                // Chainable
                                return this;
                            },
                            /**
       * Finalizes the HMAC computation.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} messageUpdate (Optional) A final message update.
       *
       * @return {WordArray} The HMAC.
       *
       * @example
       *
       *     var hmac = hmacHasher.finalize();
       *     var hmac = hmacHasher.finalize('message');
       *     var hmac = hmacHasher.finalize(wordArray);
       */ finalize: function finalize(messageUpdate) {
                                // Shortcut
                                var hasher = this._hasher;
                                // Compute HMAC
                                var innerHash = hasher.finalize(messageUpdate);
                                hasher.reset();
                                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                                return hmac;
                            }
                        });
                    })();
                });
            /***/ },
            /***/ 4660: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $reduce = __webpack_require__(32843).left;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.reduce` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
                exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */ ) {
                    var length = arguments.length;
                    return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 5049: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var implementation = __webpack_require__(12719);
                module1.exports = Function.prototype.bind || implementation;
            /***/ },
            /***/ 5155: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                module1.exports = global.Promise;
            /***/ },
            /***/ 5303: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var CI_BRK, CP_BRK, DI_BRK, IN_BRK, PR_BRK;
                exports.DI_BRK = DI_BRK = 0; // Direct break opportunity
                exports.IN_BRK = IN_BRK = 1; // Indirect break opportunity
                exports.CI_BRK = CI_BRK = 2; // Indirect break opportunity for combining marks
                exports.CP_BRK = CP_BRK = 3; // Prohibited break for combining marks
                exports.PR_BRK = PR_BRK = 4; // Prohibited break
                // Based on example pair table from https://www.unicode.org/reports/tr14/tr14-37.html#Table2
                // - ZWJ special processing for LB8a of Revision 41
                // - CB manually added as per Rule LB20
                // - CL, CP, NS, SY, IS, PR, PO, HY, BA, B2 and RI manually adjusted as per LB22 of Revision 45
                exports.pairTable = [
                    //OP   , CL    , CP    , QU    , GL    , NS    , EX    , SY    , IS    , PR    , PO    , NU    , AL    , HL    , ID    , IN    , HY    , BA    , BB    , B2    , ZW    , CM    , WJ    , H2    , H3    , JL    , JV    , JT    , RI    , EB    , EM    , ZWJ   , CB
                    [
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        CP_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK
                    ],
                    // OP
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // CL
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // CP
                    [
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK
                    ],
                    // QU
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK
                    ],
                    // GL
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // NS
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // EX
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // SY
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // IS
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // PR
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // PO
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // NU
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // AL
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // HL
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // ID
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // IN
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // HY
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // BA
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // BB
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // B2
                    [
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK
                    ],
                    // ZW
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // CM
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK
                    ],
                    // WJ
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // H2
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // H3
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // JL
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // JV
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // JT
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // RI
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // EB
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // EM
                    [
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        IN_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ],
                    // ZWJ
                    [
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        IN_BRK,
                        IN_BRK,
                        DI_BRK,
                        PR_BRK,
                        PR_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        PR_BRK,
                        CI_BRK,
                        PR_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        DI_BRK,
                        IN_BRK,
                        DI_BRK
                    ] // CB
                ];
            /***/ },
            /***/ 5417: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var UnicodeTrie = __webpack_require__(59006);
                var base64 = __webpack_require__(32504);
                var _require = __webpack_require__(84490), BK = _require.BK, CR = _require.CR, LF = _require.LF, NL = _require.NL, SG = _require.SG, WJ = _require.WJ, SP = _require.SP, ZWJ = _require.ZWJ, BA = _require.BA, HY = _require.HY, NS = _require.NS, AI = _require.AI, AL = _require.AL, CJ = _require.CJ, HL = _require.HL, RI = _require.RI, SA = _require.SA, XX = _require.XX;
                var _require2 = __webpack_require__(5303), DI_BRK = _require2.DI_BRK, IN_BRK = _require2.IN_BRK, CI_BRK = _require2.CI_BRK, CP_BRK = _require2.CP_BRK, PR_BRK = _require2.PR_BRK, pairTable = _require2.pairTable;
                var data = base64.toByteArray("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");
                var classTrie = new UnicodeTrie(data);
                var mapClass = function mapClass(c) {
                    switch(c){
                        case AI:
                            return AL;
                        case SA:
                        case SG:
                        case XX:
                            return AL;
                        case CJ:
                            return NS;
                        default:
                            return c;
                    }
                };
                var mapFirst = function mapFirst(c) {
                    switch(c){
                        case LF:
                        case NL:
                            return BK;
                        case SP:
                            return WJ;
                        default:
                            return c;
                    }
                };
                var Break = function Break(position, required) {
                    if (required === void 0) required = false;
                    this.position = position;
                    this.required = required;
                };
                var LineBreaker = /*#__PURE__*/ function() {
                    function LineBreaker(string) {
                        this.string = string;
                        this.pos = 0;
                        this.lastPos = 0;
                        this.curClass = null;
                        this.nextClass = null;
                        this.LB8a = false;
                        this.LB21a = false;
                        this.LB30a = 0;
                    }
                    var _proto = LineBreaker.prototype;
                    _proto.nextCodePoint = function nextCodePoint() {
                        var code = this.string.charCodeAt(this.pos++);
                        var next = this.string.charCodeAt(this.pos);
                        // If a surrogate pair
                        if (0xd800 <= code && code <= 0xdbff && 0xdc00 <= next && next <= 0xdfff) {
                            this.pos++;
                            return (code - 0xd800) * 0x400 + (next - 0xdc00) + 0x10000;
                        }
                        return code;
                    };
                    _proto.nextCharClass = function nextCharClass() {
                        return mapClass(classTrie.get(this.nextCodePoint()));
                    };
                    _proto.getSimpleBreak = function getSimpleBreak() {
                        // handle classes not handled by the pair table
                        switch(this.nextClass){
                            case SP:
                                return false;
                            case BK:
                            case LF:
                            case NL:
                                this.curClass = BK;
                                return false;
                            case CR:
                                this.curClass = CR;
                                return false;
                        }
                        return null;
                    };
                    _proto.getPairTableBreak = function getPairTableBreak(lastClass) {
                        // if not handled already, use the pair table
                        var shouldBreak = false;
                        switch(pairTable[this.curClass][this.nextClass]){
                            case DI_BRK:
                                // Direct break
                                shouldBreak = true;
                                break;
                            case IN_BRK:
                                // possible indirect break
                                shouldBreak = lastClass === SP;
                                break;
                            case CI_BRK:
                                shouldBreak = lastClass === SP;
                                if (!shouldBreak) {
                                    shouldBreak = false;
                                    return shouldBreak;
                                }
                                break;
                            case CP_BRK:
                                // prohibited for combining marks
                                if (lastClass !== SP) return shouldBreak;
                                break;
                            case PR_BRK:
                                break;
                        }
                        if (this.LB8a) shouldBreak = false;
                        // Rule LB21a
                        if (this.LB21a && (this.curClass === HY || this.curClass === BA)) {
                            shouldBreak = false;
                            this.LB21a = false;
                        } else this.LB21a = this.curClass === HL;
                        // Rule LB30a
                        if (this.curClass === RI) {
                            this.LB30a++;
                            if (this.LB30a == 2 && this.nextClass === RI) {
                                shouldBreak = true;
                                this.LB30a = 0;
                            }
                        } else this.LB30a = 0;
                        this.curClass = this.nextClass;
                        return shouldBreak;
                    };
                    _proto.nextBreak = function nextBreak() {
                        // get the first char if we're at the beginning of the string
                        if (this.curClass == null) {
                            var firstClass = this.nextCharClass();
                            this.curClass = mapFirst(firstClass);
                            this.nextClass = firstClass;
                            this.LB8a = firstClass === ZWJ;
                            this.LB30a = 0;
                        }
                        while(this.pos < this.string.length){
                            this.lastPos = this.pos;
                            var lastClass = this.nextClass;
                            this.nextClass = this.nextCharClass();
                            // explicit newline
                            if (this.curClass === BK || this.curClass === CR && this.nextClass !== LF) {
                                this.curClass = mapFirst(mapClass(this.nextClass));
                                return new Break(this.lastPos, true);
                            }
                            var shouldBreak = this.getSimpleBreak();
                            if (shouldBreak === null) shouldBreak = this.getPairTableBreak(lastClass);
                            // Rule LB8a
                            this.LB8a = this.nextClass === ZWJ;
                            if (shouldBreak) return new Break(this.lastPos);
                        }
                        if (this.lastPos < this.string.length) {
                            this.lastPos = this.string.length;
                            return new Break(this.string.length);
                        }
                        return null;
                    };
                    return LineBreaker;
                }();
                module1.exports = LineBreaker;
            /***/ },
            /***/ 5557: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var SVGtoPDF = __webpack_require__(64781);
                module1.exports = SVGtoPDF;
            /***/ },
            /***/ 5597: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var defineWellKnownSymbol = __webpack_require__(46042);
                // `Symbol.toPrimitive` well-known symbol
                // https://tc39.es/ecma262/#sec-symbol.toprimitive
                defineWellKnownSymbol('toPrimitive');
            /***/ },
            /***/ 5844: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(47044);
                var isCallable = __webpack_require__(94578);
                var create = __webpack_require__(10819);
                var getPrototypeOf = __webpack_require__(69548);
                var redefine = __webpack_require__(13711);
                var wellKnownSymbol = __webpack_require__(38688);
                var IS_PURE = __webpack_require__(63432);
                var ITERATOR = wellKnownSymbol('iterator');
                var BUGGY_SAFARI_ITERATORS = false;
                // `%IteratorPrototype%` object
                // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
                var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
                /* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
                    arrayIterator = [].keys();
                    // Safari 8 has buggy iterators w/o `next`
                    if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
                    else {
                        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
                        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
                    }
                }
                var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function() {
                    var test = {};
                    // FF44- legacy iterators case
                    return IteratorPrototype[ITERATOR].call(test) !== test;
                });
                if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
                else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
                // `%IteratorPrototype%[@@iterator]()` method
                // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
                if (!isCallable(IteratorPrototype[ITERATOR])) redefine(IteratorPrototype, ITERATOR, function() {
                    return this;
                });
                module1.exports = {
                    IteratorPrototype: IteratorPrototype,
                    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
                };
            /***/ },
            /***/ 6422: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = __webpack_require__(2834);
                var fixRegExpWellKnownSymbolLogic = __webpack_require__(11813);
                var anObject = __webpack_require__(34984);
                var toLength = __webpack_require__(23417);
                var toString = __webpack_require__(25096);
                var requireObjectCoercible = __webpack_require__(83943);
                var getMethod = __webpack_require__(51839);
                var advanceStringIndex = __webpack_require__(36352);
                var regExpExec = __webpack_require__(66723);
                // @@match logic
                fixRegExpWellKnownSymbolLogic('match', function(MATCH, nativeMatch, maybeCallNative) {
                    return [
                        // `String.prototype.match` method
                        // https://tc39.es/ecma262/#sec-string.prototype.match
                        function match(regexp) {
                            var O = requireObjectCoercible(this);
                            var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
                            return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
                        },
                        // `RegExp.prototype[@@match]` method
                        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
                        function(string) {
                            var rx = anObject(this);
                            var S = toString(string);
                            var res = maybeCallNative(nativeMatch, rx, S);
                            if (res.done) return res.value;
                            if (!rx.global) return regExpExec(rx, S);
                            var fullUnicode = rx.unicode;
                            rx.lastIndex = 0;
                            var A = [];
                            var n = 0;
                            var result;
                            while((result = regExpExec(rx, S)) !== null){
                                var matchStr = toString(result[0]);
                                A[n] = matchStr;
                                if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                                n++;
                            }
                            return n === 0 ? null : A;
                        }
                    ];
                });
            /***/ },
            /***/ 6564: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(20731);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    /**
   * Output Feedback block mode.
   */ CryptoJS.mode.OFB = function() {
                        var OFB = CryptoJS.lib.BlockCipherMode.extend();
                        var Encryptor = OFB.Encryptor = OFB.extend({
                            processBlock: function processBlock(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                var iv = this._iv;
                                var keystream = this._keystream;
                                // Generate keystream
                                if (iv) {
                                    keystream = this._keystream = iv.slice(0);
                                    // Remove IV for subsequent blocks
                                    this._iv = undefined;
                                }
                                cipher.encryptBlock(keystream, 0);
                                // Encrypt
                                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                            }
                        });
                        OFB.Decryptor = Encryptor;
                        return OFB;
                    }();
                    return CryptoJS.mode.OFB;
                });
            /***/ },
            /***/ 6611: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var internalObjectKeys = __webpack_require__(64429);
                var enumBugKeys = __webpack_require__(2416);
                var hiddenKeys = enumBugKeys.concat('length', 'prototype');
                // `Object.getOwnPropertyNames` method
                // https://tc39.es/ecma262/#sec-object.getownpropertynames
                // eslint-disable-next-line es/no-object-getownpropertynames -- safe
                exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                    return internalObjectKeys(O, hiddenKeys);
                };
            /***/ },
            /***/ 6616: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var apply = __webpack_require__(58448);
                var bind = __webpack_require__(25567);
                var isCallable = __webpack_require__(94578);
                var hasOwn = __webpack_require__(20340);
                var fails = __webpack_require__(47044);
                var html = __webpack_require__(520);
                var arraySlice = __webpack_require__(73163);
                var createElement = __webpack_require__(12072);
                var IS_IOS = __webpack_require__(17716);
                var IS_NODE = __webpack_require__(95053);
                var set = global.setImmediate;
                var clear = global.clearImmediate;
                var process = global.process;
                var Dispatch = global.Dispatch;
                var Function1 = global.Function;
                var MessageChannel = global.MessageChannel;
                var String1 = global.String;
                var counter = 0;
                var queue = {};
                var ONREADYSTATECHANGE = 'onreadystatechange';
                var location1, defer, channel, port;
                try {
                    // Deno throws a ReferenceError on `location` access without `--location` flag
                    location1 = global.location;
                } catch (error) {}
                var run = function(id) {
                    if (hasOwn(queue, id)) {
                        var fn = queue[id];
                        delete queue[id];
                        fn();
                    }
                };
                var runner = function(id) {
                    return function() {
                        run(id);
                    };
                };
                var listener = function(event) {
                    run(event.data);
                };
                var post = function(id) {
                    // old engines have not location.origin
                    global.postMessage(String1(id), location1.protocol + '//' + location1.host);
                };
                // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
                if (!set || !clear) {
                    set = function setImmediate(fn) {
                        var args = arraySlice(arguments, 1);
                        queue[++counter] = function() {
                            apply(isCallable(fn) ? fn : Function1(fn), undefined, args);
                        };
                        defer(counter);
                        return counter;
                    };
                    clear = function clearImmediate(id) {
                        delete queue[id];
                    };
                    // Node.js 0.8-
                    if (IS_NODE) defer = function(id) {
                        process.nextTick(runner(id));
                    };
                    else if (Dispatch && Dispatch.now) defer = function(id) {
                        Dispatch.now(runner(id));
                    };
                    else if (MessageChannel && !IS_IOS) {
                        channel = new MessageChannel();
                        port = channel.port2;
                        channel.port1.onmessage = listener;
                        defer = bind(port.postMessage, port);
                    // Browsers with postMessage, skip WebWorkers
                    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
                    } else if (global.addEventListener && isCallable(global.postMessage) && !global.importScripts && location1 && location1.protocol !== 'file:' && !fails(post)) {
                        defer = post;
                        global.addEventListener('message', listener, false);
                    // IE8-
                    } else if (ONREADYSTATECHANGE in createElement('script')) defer = function(id) {
                        html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function() {
                            html.removeChild(this);
                            run(id);
                        };
                    };
                    else defer = function(id) {
                        setTimeout(runner(id), 0);
                    };
                }
                module1.exports = {
                    set: set,
                    clear: clear
                };
            /***/ },
            /***/ 6729: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(9964);
                var Buffer = __webpack_require__(14598).Buffer;
                var Transform = __webpack_require__(9760).Transform;
                var binding = __webpack_require__(72908);
                var util = __webpack_require__(7187);
                var assert = __webpack_require__(80182).ok;
                var kMaxLength = __webpack_require__(14598).kMaxLength;
                var kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + kMaxLength.toString(16) + ' bytes';
                // zlib doesn't provide these, so kludge them in following the same
                // const naming scheme zlib uses.
                binding.Z_MIN_WINDOWBITS = 8;
                binding.Z_MAX_WINDOWBITS = 15;
                binding.Z_DEFAULT_WINDOWBITS = 15;
                // fewer than 64 bytes per chunk is stupid.
                // technically it could work with as few as 8, but even 64 bytes
                // is absurdly low.  Usually a MB or more is best.
                binding.Z_MIN_CHUNK = 64;
                binding.Z_MAX_CHUNK = Infinity;
                binding.Z_DEFAULT_CHUNK = 16384;
                binding.Z_MIN_MEMLEVEL = 1;
                binding.Z_MAX_MEMLEVEL = 9;
                binding.Z_DEFAULT_MEMLEVEL = 8;
                binding.Z_MIN_LEVEL = -1;
                binding.Z_MAX_LEVEL = 9;
                binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
                // expose all the zlib constants
                var bkeys = Object.keys(binding);
                for(var bk = 0; bk < bkeys.length; bk++){
                    var bkey = bkeys[bk];
                    if (bkey.match(/^Z/)) Object.defineProperty(exports, bkey, {
                        enumerable: true,
                        value: binding[bkey],
                        writable: false
                    });
                }
                // translation table for return codes.
                var codes = {
                    Z_OK: binding.Z_OK,
                    Z_STREAM_END: binding.Z_STREAM_END,
                    Z_NEED_DICT: binding.Z_NEED_DICT,
                    Z_ERRNO: binding.Z_ERRNO,
                    Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
                    Z_DATA_ERROR: binding.Z_DATA_ERROR,
                    Z_MEM_ERROR: binding.Z_MEM_ERROR,
                    Z_BUF_ERROR: binding.Z_BUF_ERROR,
                    Z_VERSION_ERROR: binding.Z_VERSION_ERROR
                };
                var ckeys = Object.keys(codes);
                for(var ck = 0; ck < ckeys.length; ck++){
                    var ckey = ckeys[ck];
                    codes[codes[ckey]] = ckey;
                }
                Object.defineProperty(exports, "codes", {
                    enumerable: true,
                    value: Object.freeze(codes),
                    writable: false
                });
                exports.Deflate = Deflate;
                exports.Inflate = Inflate;
                exports.Gzip = Gzip;
                exports.Gunzip = Gunzip;
                exports.DeflateRaw = DeflateRaw;
                exports.InflateRaw = InflateRaw;
                exports.Unzip = Unzip;
                exports.createDeflate = function(o) {
                    return new Deflate(o);
                };
                exports.createInflate = function(o) {
                    return new Inflate(o);
                };
                exports.createDeflateRaw = function(o) {
                    return new DeflateRaw(o);
                };
                exports.createInflateRaw = function(o) {
                    return new InflateRaw(o);
                };
                exports.createGzip = function(o) {
                    return new Gzip(o);
                };
                exports.createGunzip = function(o) {
                    return new Gunzip(o);
                };
                exports.createUnzip = function(o) {
                    return new Unzip(o);
                };
                // Convenience methods.
                // compress/decompress a string or buffer in one step.
                exports.deflate = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Deflate(opts), buffer, callback);
                };
                exports.deflateSync = function(buffer, opts) {
                    return zlibBufferSync(new Deflate(opts), buffer);
                };
                exports.gzip = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Gzip(opts), buffer, callback);
                };
                exports.gzipSync = function(buffer, opts) {
                    return zlibBufferSync(new Gzip(opts), buffer);
                };
                exports.deflateRaw = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new DeflateRaw(opts), buffer, callback);
                };
                exports.deflateRawSync = function(buffer, opts) {
                    return zlibBufferSync(new DeflateRaw(opts), buffer);
                };
                exports.unzip = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Unzip(opts), buffer, callback);
                };
                exports.unzipSync = function(buffer, opts) {
                    return zlibBufferSync(new Unzip(opts), buffer);
                };
                exports.inflate = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Inflate(opts), buffer, callback);
                };
                exports.inflateSync = function(buffer, opts) {
                    return zlibBufferSync(new Inflate(opts), buffer);
                };
                exports.gunzip = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new Gunzip(opts), buffer, callback);
                };
                exports.gunzipSync = function(buffer, opts) {
                    return zlibBufferSync(new Gunzip(opts), buffer);
                };
                exports.inflateRaw = function(buffer, opts, callback) {
                    if (typeof opts === 'function') {
                        callback = opts;
                        opts = {};
                    }
                    return zlibBuffer(new InflateRaw(opts), buffer, callback);
                };
                exports.inflateRawSync = function(buffer, opts) {
                    return zlibBufferSync(new InflateRaw(opts), buffer);
                };
                function zlibBuffer(engine, buffer, callback) {
                    var buffers = [];
                    var nread = 0;
                    engine.on('error', onError);
                    engine.on('end', onEnd);
                    engine.end(buffer);
                    flow();
                    function flow() {
                        var chunk;
                        while(null !== (chunk = engine.read())){
                            buffers.push(chunk);
                            nread += chunk.length;
                        }
                        engine.once('readable', flow);
                    }
                    function onError(err) {
                        engine.removeListener('end', onEnd);
                        engine.removeListener('readable', flow);
                        callback(err);
                    }
                    function onEnd() {
                        var buf;
                        var err = null;
                        if (nread >= kMaxLength) err = new RangeError(kRangeErrorMessage);
                        else buf = Buffer.concat(buffers, nread);
                        buffers = [];
                        engine.close();
                        callback(err, buf);
                    }
                }
                function zlibBufferSync(engine, buffer) {
                    if (typeof buffer === 'string') buffer = Buffer.from(buffer);
                    if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');
                    var flushFlag = engine._finishFlushFlag;
                    return engine._processChunk(buffer, flushFlag);
                }
                // generic zlib
                // minimal 2-byte header
                function Deflate(opts) {
                    if (!(this instanceof Deflate)) return new Deflate(opts);
                    Zlib.call(this, opts, binding.DEFLATE);
                }
                function Inflate(opts) {
                    if (!(this instanceof Inflate)) return new Inflate(opts);
                    Zlib.call(this, opts, binding.INFLATE);
                }
                // gzip - bigger header, same deflate compression
                function Gzip(opts) {
                    if (!(this instanceof Gzip)) return new Gzip(opts);
                    Zlib.call(this, opts, binding.GZIP);
                }
                function Gunzip(opts) {
                    if (!(this instanceof Gunzip)) return new Gunzip(opts);
                    Zlib.call(this, opts, binding.GUNZIP);
                }
                // raw - no header
                function DeflateRaw(opts) {
                    if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
                    Zlib.call(this, opts, binding.DEFLATERAW);
                }
                function InflateRaw(opts) {
                    if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
                    Zlib.call(this, opts, binding.INFLATERAW);
                }
                // auto-detect header.
                function Unzip(opts) {
                    if (!(this instanceof Unzip)) return new Unzip(opts);
                    Zlib.call(this, opts, binding.UNZIP);
                }
                function isValidFlushFlag(flag) {
                    return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
                }
                // the Zlib class they all inherit from
                // This thing manages the queue of requests, and returns
                // true or false if there is anything in the queue when
                // you call the .write() method.
                function Zlib(opts, mode) {
                    var _this = this;
                    this._opts = opts = opts || {};
                    this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
                    Transform.call(this, opts);
                    if (opts.flush && !isValidFlushFlag(opts.flush)) throw new Error('Invalid flush flag: ' + opts.flush);
                    if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) throw new Error('Invalid flush flag: ' + opts.finishFlush);
                    this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
                    this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;
                    if (opts.chunkSize) {
                        if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) throw new Error('Invalid chunk size: ' + opts.chunkSize);
                    }
                    if (opts.windowBits) {
                        if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) throw new Error('Invalid windowBits: ' + opts.windowBits);
                    }
                    if (opts.level) {
                        if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) throw new Error('Invalid compression level: ' + opts.level);
                    }
                    if (opts.memLevel) {
                        if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) throw new Error('Invalid memLevel: ' + opts.memLevel);
                    }
                    if (opts.strategy) {
                        if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) throw new Error('Invalid strategy: ' + opts.strategy);
                    }
                    if (opts.dictionary) {
                        if (!Buffer.isBuffer(opts.dictionary)) throw new Error('Invalid dictionary: it should be a Buffer instance');
                    }
                    this._handle = new binding.Zlib(mode);
                    var self1 = this;
                    this._hadError = false;
                    this._handle.onerror = function(message, errno) {
                        // there is no way to cleanly recover.
                        // continuing only obscures problems.
                        _close(self1);
                        self1._hadError = true;
                        var error = new Error(message);
                        error.errno = errno;
                        error.code = exports.codes[errno];
                        self1.emit('error', error);
                    };
                    var level = exports.Z_DEFAULT_COMPRESSION;
                    if (typeof opts.level === 'number') level = opts.level;
                    var strategy = exports.Z_DEFAULT_STRATEGY;
                    if (typeof opts.strategy === 'number') strategy = opts.strategy;
                    this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
                    this._buffer = Buffer.allocUnsafe(this._chunkSize);
                    this._offset = 0;
                    this._level = level;
                    this._strategy = strategy;
                    this.once('end', this.close);
                    Object.defineProperty(this, '_closed', {
                        get: function() {
                            return !_this._handle;
                        },
                        configurable: true,
                        enumerable: true
                    });
                }
                util.inherits(Zlib, Transform);
                Zlib.prototype.params = function(level, strategy, callback) {
                    if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) throw new RangeError('Invalid compression level: ' + level);
                    if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) throw new TypeError('Invalid strategy: ' + strategy);
                    if (this._level !== level || this._strategy !== strategy) {
                        var self1 = this;
                        this.flush(binding.Z_SYNC_FLUSH, function() {
                            assert(self1._handle, 'zlib binding closed');
                            self1._handle.params(level, strategy);
                            if (!self1._hadError) {
                                self1._level = level;
                                self1._strategy = strategy;
                                if (callback) callback();
                            }
                        });
                    } else process.nextTick(callback);
                };
                Zlib.prototype.reset = function() {
                    assert(this._handle, 'zlib binding closed');
                    return this._handle.reset();
                };
                // This is the _flush function called by the transform class,
                // internally, when the last chunk has been written.
                Zlib.prototype._flush = function(callback) {
                    this._transform(Buffer.alloc(0), '', callback);
                };
                Zlib.prototype.flush = function(kind, callback) {
                    var _this2 = this;
                    var ws = this._writableState;
                    if (typeof kind === 'function' || kind === undefined && !callback) {
                        callback = kind;
                        kind = binding.Z_FULL_FLUSH;
                    }
                    if (ws.ended) {
                        if (callback) process.nextTick(callback);
                    } else if (ws.ending) {
                        if (callback) this.once('end', callback);
                    } else if (ws.needDrain) {
                        if (callback) this.once('drain', function() {
                            return _this2.flush(kind, callback);
                        });
                    } else {
                        this._flushFlag = kind;
                        this.write(Buffer.alloc(0), '', callback);
                    }
                };
                Zlib.prototype.close = function(callback) {
                    _close(this, callback);
                    process.nextTick(emitCloseNT, this);
                };
                function _close(engine, callback) {
                    if (callback) process.nextTick(callback);
                    // Caller may invoke .close after a zlib error (which will null _handle).
                    if (!engine._handle) return;
                    engine._handle.close();
                    engine._handle = null;
                }
                function emitCloseNT(self1) {
                    self1.emit('close');
                }
                Zlib.prototype._transform = function(chunk, encoding, cb) {
                    var flushFlag;
                    var ws = this._writableState;
                    var ending = ws.ending || ws.ended;
                    var last = ending && (!chunk || ws.length === chunk.length);
                    if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));
                    if (!this._handle) return cb(new Error('zlib binding closed'));
                    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
                    // (or whatever flag was provided using opts.finishFlush).
                    // If it's explicitly flushing at some other time, then we use
                    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
                    // goodness.
                    if (last) flushFlag = this._finishFlushFlag;
                    else {
                        flushFlag = this._flushFlag;
                        // once we've flushed the last of the queue, stop flushing and
                        // go back to the normal behavior.
                        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
                    }
                    this._processChunk(chunk, flushFlag, cb);
                };
                Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
                    var availInBefore = chunk && chunk.length;
                    var availOutBefore = this._chunkSize - this._offset;
                    var inOff = 0;
                    var self1 = this;
                    var async = typeof cb === 'function';
                    if (!async) {
                        var buffers = [];
                        var nread = 0;
                        var error;
                        this.on('error', function(er) {
                            error = er;
                        });
                        assert(this._handle, 'zlib binding closed');
                        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
                        while (!this._hadError && callback(res[0], res[1]));
                        if (this._hadError) throw error;
                        if (nread >= kMaxLength) {
                            _close(this);
                            throw new RangeError(kRangeErrorMessage);
                        }
                        var buf = Buffer.concat(buffers, nread);
                        _close(this);
                        return buf;
                    }
                    assert(this._handle, 'zlib binding closed');
                    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
                    req.buffer = chunk;
                    req.callback = callback;
                    function callback(availInAfter, availOutAfter) {
                        // When the callback is used in an async write, the callback's
                        // context is the `req` object that was created. The req object
                        // is === this._handle, and that's why it's important to null
                        // out the values after they are done being used. `this._handle`
                        // can stay in memory longer than the callback and buffer are needed.
                        if (this) {
                            this.buffer = null;
                            this.callback = null;
                        }
                        if (self1._hadError) return;
                        var have = availOutBefore - availOutAfter;
                        assert(have >= 0, 'have should not go down');
                        if (have > 0) {
                            var out = self1._buffer.slice(self1._offset, self1._offset + have);
                            self1._offset += have;
                            // serve some output to the consumer.
                            if (async) self1.push(out);
                            else {
                                buffers.push(out);
                                nread += out.length;
                            }
                        }
                        // exhausted the output buffer, or used all the input create a new one.
                        if (availOutAfter === 0 || self1._offset >= self1._chunkSize) {
                            availOutBefore = self1._chunkSize;
                            self1._offset = 0;
                            self1._buffer = Buffer.allocUnsafe(self1._chunkSize);
                        }
                        if (availOutAfter === 0) {
                            // Not actually done.  Need to reprocess.
                            // Also, update the availInBefore to the availInAfter value,
                            // so that if we have to hit it a third (fourth, etc.) time,
                            // it'll have the correct byte counts.
                            inOff += availInBefore - availInAfter;
                            availInBefore = availInAfter;
                            if (!async) return true;
                            var newReq = self1._handle.write(flushFlag, chunk, inOff, availInBefore, self1._buffer, self1._offset, self1._chunkSize);
                            newReq.callback = callback; // this same function
                            newReq.buffer = chunk;
                            return;
                        }
                        if (!async) return false;
                        // finished with the chunk.
                        cb();
                    }
                };
                util.inherits(Deflate, Zlib);
                util.inherits(Inflate, Zlib);
                util.inherits(Gzip, Zlib);
                util.inherits(Gunzip, Zlib);
                util.inherits(DeflateRaw, Zlib);
                util.inherits(InflateRaw, Zlib);
                util.inherits(Unzip, Zlib);
            /***/ },
            /***/ 6819: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(66947), __webpack_require__(68319), __webpack_require__(82747), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var StreamCipher = C_lib.StreamCipher;
                        var C_algo = C.algo;
                        // Reusable objects
                        var S = [];
                        var C_ = [];
                        var G = [];
                        /**
     * Rabbit stream cipher algorithm
     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
                            _doReset: function _doReset() {
                                // Shortcuts
                                var K = this._key.words;
                                var iv = this.cfg.iv;
                                // Swap endian
                                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                                // Generate initial state values
                                var X = this._X = [
                                    K[0],
                                    K[3] << 16 | K[2] >>> 16,
                                    K[1],
                                    K[0] << 16 | K[3] >>> 16,
                                    K[2],
                                    K[1] << 16 | K[0] >>> 16,
                                    K[3],
                                    K[2] << 16 | K[1] >>> 16
                                ];
                                // Generate initial counter values
                                var C = this._C = [
                                    K[2] << 16 | K[2] >>> 16,
                                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                                    K[3] << 16 | K[3] >>> 16,
                                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                                    K[0] << 16 | K[0] >>> 16,
                                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                                    K[1] << 16 | K[1] >>> 16,
                                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                                ];
                                // Carry bit
                                this._b = 0;
                                // Iterate the system four times
                                for(var i = 0; i < 4; i++)nextState.call(this);
                                // Modify the counters
                                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                                // IV setup
                                if (iv) {
                                    // Shortcuts
                                    var IV = iv.words;
                                    var IV_0 = IV[0];
                                    var IV_1 = IV[1];
                                    // Generate four subvectors
                                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                                    // Modify counter values
                                    C[0] ^= i0;
                                    C[1] ^= i1;
                                    C[2] ^= i2;
                                    C[3] ^= i3;
                                    C[4] ^= i0;
                                    C[5] ^= i1;
                                    C[6] ^= i2;
                                    C[7] ^= i3;
                                    // Iterate the system four times
                                    for(var i = 0; i < 4; i++)nextState.call(this);
                                }
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcut
                                var X = this._X;
                                // Iterate the system
                                nextState.call(this);
                                // Generate four keystream words
                                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                                for(var i = 0; i < 4; i++){
                                    // Swap endian
                                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                                    // Encrypt
                                    M[offset + i] ^= S[i];
                                }
                            },
                            blockSize: 4,
                            ivSize: 2
                        });
                        function nextState() {
                            // Shortcuts
                            var X = this._X;
                            var C = this._C;
                            // Save old counter values
                            for(var i = 0; i < 8; i++)C_[i] = C[i];
                            // Calculate new counter values
                            C[0] = C[0] + 0x4d34d34d + this._b | 0;
                            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
                            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
                            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
                            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
                            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
                            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
                            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
                            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
                            // Calculate the g-values
                            for(var i = 0; i < 8; i++){
                                var gx = X[i] + C[i];
                                // Construct high and low argument for squaring
                                var ga = gx & 0xffff;
                                var gb = gx >>> 16;
                                // Calculate high and low result of squaring
                                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                                // High XOR low
                                G[i] = gh ^ gl;
                            }
                            // Calculate new state values
                            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
                            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
                            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
                            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
                            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
                            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
                            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
                            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
                        }
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
                    })();
                    return CryptoJS.Rabbit;
                });
            /***/ },
            /***/ 7043: /***/ function(__unused_webpack_module, exports) {
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/ var CONTEXT_LSB6 = 0;
                var CONTEXT_MSB6 = 1;
                var CONTEXT_UTF8 = 2;
                var CONTEXT_SIGNED = 3;
                /* Common context lookup table for all context modes. */ exports.lookup = new Uint8Array([
                    /* CONTEXT_UTF8, last byte. */ /* ASCII range. */ 0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4,
                    4,
                    0,
                    0,
                    4,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8,
                    12,
                    16,
                    12,
                    12,
                    20,
                    12,
                    16,
                    24,
                    28,
                    12,
                    12,
                    32,
                    12,
                    36,
                    12,
                    44,
                    44,
                    44,
                    44,
                    44,
                    44,
                    44,
                    44,
                    44,
                    44,
                    32,
                    32,
                    24,
                    40,
                    28,
                    12,
                    12,
                    48,
                    52,
                    52,
                    52,
                    48,
                    52,
                    52,
                    52,
                    48,
                    52,
                    52,
                    52,
                    52,
                    52,
                    48,
                    52,
                    52,
                    52,
                    52,
                    52,
                    48,
                    52,
                    52,
                    52,
                    52,
                    52,
                    24,
                    12,
                    28,
                    12,
                    12,
                    12,
                    56,
                    60,
                    60,
                    60,
                    56,
                    60,
                    60,
                    60,
                    56,
                    60,
                    60,
                    60,
                    60,
                    60,
                    56,
                    60,
                    60,
                    60,
                    60,
                    60,
                    56,
                    60,
                    60,
                    60,
                    60,
                    60,
                    24,
                    12,
                    28,
                    12,
                    0,
                    /* UTF8 continuation byte range. */ 0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    /* UTF8 lead byte range. */ 2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    2,
                    3,
                    /* CONTEXT_UTF8 second last byte. */ /* ASCII range. */ 0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    1,
                    1,
                    1,
                    1,
                    0,
                    /* UTF8 continuation byte range. */ 0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    /* UTF8 lead byte range. */ 0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    /* CONTEXT_SIGNED, second last byte. */ 0,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    5,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    6,
                    7,
                    /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */ 0,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    8,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    24,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    40,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    48,
                    56,
                    /* CONTEXT_LSB6, last byte. */ 0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53,
                    54,
                    55,
                    56,
                    57,
                    58,
                    59,
                    60,
                    61,
                    62,
                    63,
                    /* CONTEXT_MSB6, last byte. */ 0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    6,
                    6,
                    6,
                    6,
                    7,
                    7,
                    7,
                    7,
                    8,
                    8,
                    8,
                    8,
                    9,
                    9,
                    9,
                    9,
                    10,
                    10,
                    10,
                    10,
                    11,
                    11,
                    11,
                    11,
                    12,
                    12,
                    12,
                    12,
                    13,
                    13,
                    13,
                    13,
                    14,
                    14,
                    14,
                    14,
                    15,
                    15,
                    15,
                    15,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    22,
                    22,
                    22,
                    22,
                    23,
                    23,
                    23,
                    23,
                    24,
                    24,
                    24,
                    24,
                    25,
                    25,
                    25,
                    25,
                    26,
                    26,
                    26,
                    26,
                    27,
                    27,
                    27,
                    27,
                    28,
                    28,
                    28,
                    28,
                    29,
                    29,
                    29,
                    29,
                    30,
                    30,
                    30,
                    30,
                    31,
                    31,
                    31,
                    31,
                    32,
                    32,
                    32,
                    32,
                    33,
                    33,
                    33,
                    33,
                    34,
                    34,
                    34,
                    34,
                    35,
                    35,
                    35,
                    35,
                    36,
                    36,
                    36,
                    36,
                    37,
                    37,
                    37,
                    37,
                    38,
                    38,
                    38,
                    38,
                    39,
                    39,
                    39,
                    39,
                    40,
                    40,
                    40,
                    40,
                    41,
                    41,
                    41,
                    41,
                    42,
                    42,
                    42,
                    42,
                    43,
                    43,
                    43,
                    43,
                    44,
                    44,
                    44,
                    44,
                    45,
                    45,
                    45,
                    45,
                    46,
                    46,
                    46,
                    46,
                    47,
                    47,
                    47,
                    47,
                    48,
                    48,
                    48,
                    48,
                    49,
                    49,
                    49,
                    49,
                    50,
                    50,
                    50,
                    50,
                    51,
                    51,
                    51,
                    51,
                    52,
                    52,
                    52,
                    52,
                    53,
                    53,
                    53,
                    53,
                    54,
                    54,
                    54,
                    54,
                    55,
                    55,
                    55,
                    55,
                    56,
                    56,
                    56,
                    56,
                    57,
                    57,
                    57,
                    57,
                    58,
                    58,
                    58,
                    58,
                    59,
                    59,
                    59,
                    59,
                    60,
                    60,
                    60,
                    60,
                    61,
                    61,
                    61,
                    61,
                    62,
                    62,
                    62,
                    62,
                    63,
                    63,
                    63,
                    63,
                    /* CONTEXT_{M,L}SB6, second last byte, */ 0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]);
                exports.lookupOffsets = new Uint16Array([
                    /* CONTEXT_LSB6 */ 1024,
                    1536,
                    /* CONTEXT_MSB6 */ 1280,
                    1536,
                    /* CONTEXT_UTF8 */ 0,
                    256,
                    /* CONTEXT_SIGNED */ 768,
                    512
                ]);
            /***/ },
            /***/ 7051: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var callBind = __webpack_require__(26601);
                var define = __webpack_require__(77802);
                var implementation = __webpack_require__(82621);
                var getPolyfill = __webpack_require__(61320);
                var shim = __webpack_require__(35074);
                var polyfill = callBind(getPolyfill(), Number);
                /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ define(polyfill, {
                    getPolyfill: getPolyfill,
                    implementation: implementation,
                    shim: shim
                });
                module1.exports = polyfill;
            /***/ },
            /***/ 7081: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(15567);
                var hasOwn = __webpack_require__(20340);
                var FunctionPrototype = Function.prototype;
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
                var EXISTS = hasOwn(FunctionPrototype, 'name');
                // additional protection from minified / mangled / dropped function names
                var PROPER = EXISTS && (function something() {}).name === 'something';
                var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
                module1.exports = {
                    EXISTS: EXISTS,
                    PROPER: PROPER,
                    CONFIGURABLE: CONFIGURABLE
                };
            /***/ },
            /***/ 7187: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                /* provided dependency */ var process = __webpack_require__(9964);
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
                    var keys = Object.keys(obj);
                    var descriptors = {};
                    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
                    return descriptors;
                };
                var formatRegExp = /%[sdj%]/g;
                exports.format = function(f) {
                    if (!isString(f)) {
                        var objects = [];
                        for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
                        return objects.join(' ');
                    }
                    var i = 1;
                    var args = arguments;
                    var len = args.length;
                    var str = String(f).replace(formatRegExp, function(x) {
                        if (x === '%%') return '%';
                        if (i >= len) return x;
                        switch(x){
                            case '%s':
                                return String(args[i++]);
                            case '%d':
                                return Number(args[i++]);
                            case '%j':
                                try {
                                    return JSON.stringify(args[i++]);
                                } catch (_) {
                                    return '[Circular]';
                                }
                            default:
                                return x;
                        }
                    });
                    for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += ' ' + x;
                    else str += ' ' + inspect(x);
                    return str;
                };
                // Mark that a method should not be used.
                // Returns a modified function which warns once by default.
                // If --no-deprecation is set, then it is a no-op.
                exports.deprecate = function(fn, msg) {
                    if (typeof process !== 'undefined' && process.noDeprecation === true) return fn;
                    // Allow for deprecating things in the process of starting up.
                    if (typeof process === 'undefined') return function() {
                        return exports.deprecate(fn, msg).apply(this, arguments);
                    };
                    var warned = false;
                    function deprecated() {
                        if (!warned) {
                            if (process.throwDeprecation) throw new Error(msg);
                            else if (process.traceDeprecation) console.trace(msg);
                            else console.error(msg);
                            warned = true;
                        }
                        return fn.apply(this, arguments);
                    }
                    return deprecated;
                };
                var debugs = {};
                var debugEnvRegex = /^$/;
                if (process.env.NODE_DEBUG) {
                    var debugEnv = process.env.NODE_DEBUG;
                    debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&').replace(/\*/g, '.*').replace(/,/g, '$|^').toUpperCase();
                    debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
                }
                exports.debuglog = function(set) {
                    set = set.toUpperCase();
                    if (!debugs[set]) {
                        if (debugEnvRegex.test(set)) {
                            var pid = process.pid;
                            debugs[set] = function() {
                                var msg = exports.format.apply(exports, arguments);
                                console.error('%s %d: %s', set, pid, msg);
                            };
                        } else debugs[set] = function() {};
                    }
                    return debugs[set];
                };
                /**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
                    // default options
                    var ctx = {
                        seen: [],
                        stylize: stylizeNoColor
                    };
                    // legacy...
                    if (arguments.length >= 3) ctx.depth = arguments[2];
                    if (arguments.length >= 4) ctx.colors = arguments[3];
                    if (isBoolean(opts)) // legacy...
                    ctx.showHidden = opts;
                    else if (opts) // got an "options" object
                    exports._extend(ctx, opts);
                    // set default options
                    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
                    if (isUndefined(ctx.depth)) ctx.depth = 2;
                    if (isUndefined(ctx.colors)) ctx.colors = false;
                    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
                    if (ctx.colors) ctx.stylize = stylizeWithColor;
                    return formatValue(ctx, obj, ctx.depth);
                }
                exports.inspect = inspect;
                // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
                inspect.colors = {
                    'bold': [
                        1,
                        22
                    ],
                    'italic': [
                        3,
                        23
                    ],
                    'underline': [
                        4,
                        24
                    ],
                    'inverse': [
                        7,
                        27
                    ],
                    'white': [
                        37,
                        39
                    ],
                    'grey': [
                        90,
                        39
                    ],
                    'black': [
                        30,
                        39
                    ],
                    'blue': [
                        34,
                        39
                    ],
                    'cyan': [
                        36,
                        39
                    ],
                    'green': [
                        32,
                        39
                    ],
                    'magenta': [
                        35,
                        39
                    ],
                    'red': [
                        31,
                        39
                    ],
                    'yellow': [
                        33,
                        39
                    ]
                };
                // Don't use 'blue' not visible on cmd.exe
                inspect.styles = {
                    'special': 'cyan',
                    'number': 'yellow',
                    'boolean': 'yellow',
                    'undefined': 'grey',
                    'null': 'bold',
                    'string': 'green',
                    'date': 'magenta',
                    // "name": intentionally not styling
                    'regexp': 'red'
                };
                function stylizeWithColor(str, styleType) {
                    var style = inspect.styles[styleType];
                    if (style) return '\u001b[' + inspect.colors[style][0] + 'm' + str + '\u001b[' + inspect.colors[style][1] + 'm';
                    else return str;
                }
                function stylizeNoColor(str, styleType) {
                    return str;
                }
                function arrayToHash(array) {
                    var hash = {};
                    array.forEach(function(val, idx) {
                        hash[val] = true;
                    });
                    return hash;
                }
                function formatValue(ctx, value, recurseTimes) {
                    // Provide a hook for user-specified inspect functions.
                    // Check that value is an object with an inspect function on it
                    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
                    value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
                    !(value.constructor && value.constructor.prototype === value)) {
                        var ret = value.inspect(recurseTimes, ctx);
                        if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
                        return ret;
                    }
                    // Primitive types cannot have properties
                    var primitive = formatPrimitive(ctx, value);
                    if (primitive) return primitive;
                    // Look up the keys of the object.
                    var keys = Object.keys(value);
                    var visibleKeys = arrayToHash(keys);
                    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
                    // IE doesn't make error fields non-enumerable
                    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
                    if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return formatError(value);
                    // Some type of object without properties can be shortcutted.
                    if (keys.length === 0) {
                        if (isFunction(value)) {
                            var name = value.name ? ': ' + value.name : '';
                            return ctx.stylize('[Function' + name + ']', 'special');
                        }
                        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
                        if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
                        if (isError(value)) return formatError(value);
                    }
                    var base = '', array = false, braces = [
                        '{',
                        '}'
                    ];
                    // Make Array say that they are Array
                    if (isArray(value)) {
                        array = true;
                        braces = [
                            '[',
                            ']'
                        ];
                    }
                    // Make functions say that they are functions
                    if (isFunction(value)) {
                        var n = value.name ? ': ' + value.name : '';
                        base = ' [Function' + n + ']';
                    }
                    // Make RegExps say that they are RegExps
                    if (isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
                    // Make dates with properties first say the date
                    if (isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
                    // Make error with message first say the error
                    if (isError(value)) base = ' ' + formatError(value);
                    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
                    if (recurseTimes < 0) {
                        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
                        else return ctx.stylize('[Object]', 'special');
                    }
                    ctx.seen.push(value);
                    var output;
                    if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
                    else output = keys.map(function(key) {
                        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
                    });
                    ctx.seen.pop();
                    return reduceToSingleString(output, base, braces);
                }
                function formatPrimitive(ctx, value) {
                    if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
                    if (isString(value)) {
                        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
                        return ctx.stylize(simple, 'string');
                    }
                    if (isNumber(value)) return ctx.stylize('' + value, 'number');
                    if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
                    // For some reason typeof null is "object", so special case here.
                    if (isNull(value)) return ctx.stylize('null', 'null');
                }
                function formatError(value) {
                    return '[' + Error.prototype.toString.call(value) + ']';
                }
                function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
                    var output = [];
                    for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
                    else output.push('');
                    keys.forEach(function(key) {
                        if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
                    });
                    return output;
                }
                function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
                    var name, str, desc;
                    desc = Object.getOwnPropertyDescriptor(value, key) || {
                        value: value[key]
                    };
                    if (desc.get) {
                        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
                        else str = ctx.stylize('[Getter]', 'special');
                    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
                    if (!hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
                    if (!str) {
                        if (ctx.seen.indexOf(desc.value) < 0) {
                            if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
                            else str = formatValue(ctx, desc.value, recurseTimes - 1);
                            if (str.indexOf('\n') > -1) {
                                if (array) str = str.split('\n').map(function(line) {
                                    return '  ' + line;
                                }).join('\n').slice(2);
                                else str = '\n' + str.split('\n').map(function(line) {
                                    return '   ' + line;
                                }).join('\n');
                            }
                        } else str = ctx.stylize('[Circular]', 'special');
                    }
                    if (isUndefined(name)) {
                        if (array && key.match(/^\d+$/)) return str;
                        name = JSON.stringify('' + key);
                        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                            name = name.slice(1, -1);
                            name = ctx.stylize(name, 'name');
                        } else {
                            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                            name = ctx.stylize(name, 'string');
                        }
                    }
                    return name + ': ' + str;
                }
                function reduceToSingleString(output, base, braces) {
                    var numLinesEst = 0;
                    var length = output.reduce(function(prev, cur) {
                        numLinesEst++;
                        if (cur.indexOf('\n') >= 0) numLinesEst++;
                        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
                    }, 0);
                    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
                    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
                }
                // NOTE: These type checking functions intentionally don't use `instanceof`
                // because it is fragile and can be easily faked with `Object.create()`.
                exports.types = __webpack_require__(29490);
                function isArray(ar) {
                    return Array.isArray(ar);
                }
                exports.isArray = isArray;
                function isBoolean(arg) {
                    return typeof arg === 'boolean';
                }
                exports.isBoolean = isBoolean;
                function isNull(arg) {
                    return arg === null;
                }
                exports.isNull = isNull;
                function isNullOrUndefined(arg) {
                    return arg == null;
                }
                exports.isNullOrUndefined = isNullOrUndefined;
                function isNumber(arg) {
                    return typeof arg === 'number';
                }
                exports.isNumber = isNumber;
                function isString(arg) {
                    return typeof arg === 'string';
                }
                exports.isString = isString;
                function isSymbol(arg) {
                    return typeof arg === 'symbol';
                }
                exports.isSymbol = isSymbol;
                function isUndefined(arg) {
                    return arg === void 0;
                }
                exports.isUndefined = isUndefined;
                function isRegExp(re) {
                    return isObject(re) && objectToString(re) === '[object RegExp]';
                }
                exports.isRegExp = isRegExp;
                exports.types.isRegExp = isRegExp;
                function isObject(arg) {
                    return typeof arg === 'object' && arg !== null;
                }
                exports.isObject = isObject;
                function isDate(d) {
                    return isObject(d) && objectToString(d) === '[object Date]';
                }
                exports.isDate = isDate;
                exports.types.isDate = isDate;
                function isError(e) {
                    return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
                }
                exports.isError = isError;
                exports.types.isNativeError = isError;
                function isFunction(arg) {
                    return typeof arg === 'function';
                }
                exports.isFunction = isFunction;
                function isPrimitive(arg) {
                    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
                    typeof arg === 'undefined';
                }
                exports.isPrimitive = isPrimitive;
                exports.isBuffer = __webpack_require__(41201);
                function objectToString(o) {
                    return Object.prototype.toString.call(o);
                }
                function pad(n) {
                    return n < 10 ? '0' + n.toString(10) : n.toString(10);
                }
                var months = [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                ];
                // 26 Feb 16:19:34
                function timestamp() {
                    var d = new Date();
                    var time = [
                        pad(d.getHours()),
                        pad(d.getMinutes()),
                        pad(d.getSeconds())
                    ].join(':');
                    return [
                        d.getDate(),
                        months[d.getMonth()],
                        time
                    ].join(' ');
                }
                // log is just a thin wrapper to console.log that prepends a timestamp
                exports.log = function() {
                    console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
                };
                /**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ exports.inherits = __webpack_require__(89784);
                exports._extend = function(origin, add) {
                    // Don't do anything if add isn't an object
                    if (!add || !isObject(add)) return origin;
                    var keys = Object.keys(add);
                    var i = keys.length;
                    while(i--)origin[keys[i]] = add[keys[i]];
                    return origin;
                };
                function hasOwnProperty(obj, prop) {
                    return Object.prototype.hasOwnProperty.call(obj, prop);
                }
                var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
                exports.promisify = function promisify(original) {
                    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
                    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
                        var fn = original[kCustomPromisifiedSymbol];
                        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                            value: fn,
                            enumerable: false,
                            writable: false,
                            configurable: true
                        });
                        return fn;
                    }
                    function fn() {
                        var promiseResolve, promiseReject;
                        var promise = new Promise(function(resolve, reject) {
                            promiseResolve = resolve;
                            promiseReject = reject;
                        });
                        var args = [];
                        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
                        args.push(function(err, value) {
                            if (err) promiseReject(err);
                            else promiseResolve(value);
                        });
                        try {
                            original.apply(this, args);
                        } catch (err) {
                            promiseReject(err);
                        }
                        return promise;
                    }
                    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
                    if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                        value: fn,
                        enumerable: false,
                        writable: false,
                        configurable: true
                    });
                    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
                };
                exports.promisify.custom = kCustomPromisifiedSymbol;
                function callbackifyOnRejected(reason, cb) {
                    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
                    // Because `null` is a special error value in callbacks which means "no error
                    // occurred", we error-wrap so the callback consumer can distinguish between
                    // "the promise rejected with null" or "the promise fulfilled with undefined".
                    if (!reason) {
                        var newReason = new Error('Promise was rejected with a falsy value');
                        newReason.reason = reason;
                        reason = newReason;
                    }
                    return cb(reason);
                }
                function callbackify(original) {
                    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
                    // We DO NOT return the promise as it gives the user a false sense that
                    // the promise is actually somehow related to the callback's execution
                    // and that the callback throwing will reject the promise.
                    function callbackified() {
                        var args = [];
                        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
                        var maybeCb = args.pop();
                        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
                        var self1 = this;
                        var cb = function() {
                            return maybeCb.apply(self1, arguments);
                        };
                        // In true node style we process the callback on `nextTick` with all the
                        // implications (stack, `uncaughtException`, `async_hooks`)
                        original.apply(this, args).then(function(ret) {
                            process.nextTick(cb.bind(null, null, ret));
                        }, function(rej) {
                            process.nextTick(callbackifyOnRejected.bind(null, rej, cb));
                        });
                    }
                    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
                    Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
                    return callbackified;
                }
                exports.callbackify = callbackify;
            /***/ },
            /***/ 7283: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(15567);
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var isForced = __webpack_require__(39599);
                var redefine = __webpack_require__(13711);
                var hasOwn = __webpack_require__(20340);
                var inheritIfRequired = __webpack_require__(51868);
                var isPrototypeOf = __webpack_require__(70176);
                var isSymbol = __webpack_require__(46290);
                var toPrimitive = __webpack_require__(2644);
                var fails = __webpack_require__(47044);
                var getOwnPropertyNames = __webpack_require__(6611).f;
                var getOwnPropertyDescriptor = __webpack_require__(72062).f;
                var defineProperty = __webpack_require__(95892).f;
                var thisNumberValue = __webpack_require__(16679);
                var trim = __webpack_require__(29841).trim;
                var NUMBER = 'Number';
                var NativeNumber = global[NUMBER];
                var NumberPrototype = NativeNumber.prototype;
                var TypeError1 = global.TypeError;
                var arraySlice = uncurryThis(''.slice);
                var charCodeAt = uncurryThis(''.charCodeAt);
                // `ToNumeric` abstract operation
                // https://tc39.es/ecma262/#sec-tonumeric
                var toNumeric = function(value) {
                    var primValue = toPrimitive(value, 'number');
                    return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
                };
                // `ToNumber` abstract operation
                // https://tc39.es/ecma262/#sec-tonumber
                var toNumber = function(argument) {
                    var it = toPrimitive(argument, 'number');
                    var first, third, radix, maxCode, digits, length, index, code;
                    if (isSymbol(it)) throw TypeError1('Cannot convert a Symbol value to a number');
                    if (typeof it == 'string' && it.length > 2) {
                        it = trim(it);
                        first = charCodeAt(it, 0);
                        if (first === 43 || first === 45) {
                            third = charCodeAt(it, 2);
                            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
                        } else if (first === 48) {
                            switch(charCodeAt(it, 1)){
                                case 66:
                                case 98:
                                    radix = 2;
                                    maxCode = 49;
                                    break; // fast equal of /^0b[01]+$/i
                                case 79:
                                case 111:
                                    radix = 8;
                                    maxCode = 55;
                                    break; // fast equal of /^0o[0-7]+$/i
                                default:
                                    return +it;
                            }
                            digits = arraySlice(it, 2);
                            length = digits.length;
                            for(index = 0; index < length; index++){
                                code = charCodeAt(digits, index);
                                // parseInt parses a string to a first unavailable symbol
                                // but ToNumber should return NaN if a string contains unavailable symbols
                                if (code < 48 || code > maxCode) return NaN;
                            }
                            return parseInt(digits, radix);
                        }
                    }
                    return +it;
                };
                // `Number` constructor
                // https://tc39.es/ecma262/#sec-number-constructor
                if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
                    var NumberWrapper = function Number1(value) {
                        var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
                        var dummy = this;
                        // check on 1..constructor(foo) case
                        return isPrototypeOf(NumberPrototype, dummy) && fails(function() {
                            thisNumberValue(dummy);
                        }) ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
                    };
                    for(var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : // ES3:
                    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(','), j = 0, key; keys.length > j; j++)if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
                    NumberWrapper.prototype = NumberPrototype;
                    NumberPrototype.constructor = NumberWrapper;
                    redefine(global, NUMBER, NumberWrapper);
                }
            /***/ },
            /***/ 7421: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                var defineProperty = Object.defineProperty;
                module1.exports = function(key, value) {
                    try {
                        defineProperty(global, key, {
                            value: value,
                            configurable: true,
                            writable: true
                        });
                    } catch (error) {
                        global[key] = value;
                    }
                    return value;
                };
            /***/ },
            /***/ 7452: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(47044);
                // check the existence of a method, lowercase
                // of a tag and escaping quotes in arguments
                module1.exports = function(METHOD_NAME) {
                    return fails(function() {
                        var test = ''[METHOD_NAME]('"');
                        return test !== test.toLowerCase() || test.split('"').length > 3;
                    });
                };
            /***/ },
            /***/ 7514: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var fails = __webpack_require__(47044);
                var classof = __webpack_require__(93975);
                var Object1 = global.Object;
                var split = uncurryThis(''.split);
                // fallback for non-array-like ES3 and non-enumerable old V8 strings
                module1.exports = fails(function() {
                    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
                    // eslint-disable-next-line no-prototype-builtins -- safe
                    return !Object1('z').propertyIsEnumerable(0);
                }) ? function(it) {
                    return classof(it) == 'String' ? split(it, '') : Object1(it);
                } : Object1;
            /***/ },
            /***/ 7585: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var hasOwn = __webpack_require__(20340);
                var redefine = __webpack_require__(13711);
                var dateToPrimitive = __webpack_require__(53087);
                var wellKnownSymbol = __webpack_require__(38688);
                var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
                var DatePrototype = Date.prototype;
                // `Date.prototype[@@toPrimitive]` method
                // https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
                if (!hasOwn(DatePrototype, TO_PRIMITIVE)) redefine(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
            /***/ },
            /***/ 7785: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Internet Explorer polyfills
                if (typeof window !== 'undefined' && !window.Promise) __webpack_require__(98168);
                __webpack_require__(83043);
                var fetchUrl = function(url, headers) {
                    return new Promise(function(resolve, reject) {
                        var xhr = new XMLHttpRequest();
                        xhr.open('GET', url, true);
                        for(var headerName in headers)xhr.setRequestHeader(headerName, headers[headerName]);
                        xhr.responseType = 'arraybuffer';
                        xhr.onreadystatechange = function() {
                            if (xhr.readyState !== 4) return;
                            var ok = xhr.status >= 200 && xhr.status < 300;
                            if (!ok) setTimeout(function() {
                                reject(new TypeError('Failed to fetch (url: "' + url + '")'));
                            }, 0);
                        };
                        xhr.onload = function() {
                            var ok = xhr.status >= 200 && xhr.status < 300;
                            if (ok) resolve(xhr.response);
                        };
                        xhr.onerror = function() {
                            setTimeout(function() {
                                reject(new TypeError('Network request failed (url: "' + url + '")'));
                            }, 0);
                        };
                        xhr.ontimeout = function() {
                            setTimeout(function() {
                                reject(new TypeError('Network request failed (url: "' + url + '")'));
                            }, 0);
                        };
                        xhr.send();
                    });
                };
                function URLBrowserResolver(fs) {
                    this.fs = fs;
                    this.resolving = {};
                }
                URLBrowserResolver.prototype.resolve = function(url, headers) {
                    if (!this.resolving[url]) {
                        var _this = this;
                        this.resolving[url] = new Promise(function(resolve, reject) {
                            if (url.toLowerCase().indexOf('https://') === 0 || url.toLowerCase().indexOf('http://') === 0) {
                                if (_this.fs.existsSync(url)) // url was downloaded earlier
                                resolve();
                                else fetchUrl(url, headers).then(function(buffer) {
                                    _this.fs.writeFileSync(url, buffer);
                                    resolve();
                                }, function(result) {
                                    reject(result);
                                });
                            } else // cannot be resolved
                            resolve();
                        });
                    }
                    return this.resolving[url];
                };
                URLBrowserResolver.prototype.resolved = function() {
                    var _this = this;
                    return new Promise(function(resolve, reject) {
                        Promise.all(Object.values(_this.resolving)).then(function() {
                            resolve();
                        }, function(result) {
                            reject(result);
                        });
                    });
                };
                module1.exports = URLBrowserResolver;
            /***/ },
            /***/ 7844: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var implementation = __webpack_require__(83089);
                var supportsDescriptors = __webpack_require__(77802).supportsDescriptors;
                var $gOPD = Object.getOwnPropertyDescriptor;
                module1.exports = function getPolyfill() {
                    if (supportsDescriptors && /a/mig.flags === 'gim') {
                        var descriptor = $gOPD(RegExp.prototype, 'flags');
                        if (descriptor && typeof descriptor.get === 'function' && 'dotAll' in RegExp.prototype && 'hasIndices' in RegExp.prototype) {
                            /* eslint getter-return: 0 */ var calls = '';
                            var o = {};
                            Object.defineProperty(o, 'hasIndices', {
                                get: function() {
                                    calls += 'd';
                                }
                            });
                            Object.defineProperty(o, 'sticky', {
                                get: function() {
                                    calls += 'y';
                                }
                            });
                            descriptor.get.call(o);
                            if (calls === 'dy') return descriptor.get;
                        }
                    }
                    return implementation;
                };
            /***/ },
            /***/ 7851: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var apply = __webpack_require__(58448);
                var call = __webpack_require__(2834);
                var uncurryThis = __webpack_require__(38347);
                var fixRegExpWellKnownSymbolLogic = __webpack_require__(11813);
                var isRegExp = __webpack_require__(28831);
                var anObject = __webpack_require__(34984);
                var requireObjectCoercible = __webpack_require__(83943);
                var speciesConstructor = __webpack_require__(27754);
                var advanceStringIndex = __webpack_require__(36352);
                var toLength = __webpack_require__(23417);
                var toString = __webpack_require__(25096);
                var getMethod = __webpack_require__(51839);
                var arraySlice = __webpack_require__(73163);
                var callRegExpExec = __webpack_require__(66723);
                var regexpExec = __webpack_require__(49820);
                var stickyHelpers = __webpack_require__(74846);
                var fails = __webpack_require__(47044);
                var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
                var MAX_UINT32 = 0xFFFFFFFF;
                var min = Math.min;
                var $push = [].push;
                var exec = uncurryThis(/./.exec);
                var push = uncurryThis($push);
                var stringSlice = uncurryThis(''.slice);
                // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
                // Weex JS has frozen built-in prototypes, so use try / catch wrapper
                var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
                    // eslint-disable-next-line regexp/no-empty-group -- required for testing
                    var re = /(?:)/;
                    var originalExec = re.exec;
                    re.exec = function() {
                        return originalExec.apply(this, arguments);
                    };
                    var result = 'ab'.split(re);
                    return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
                });
                // @@split logic
                fixRegExpWellKnownSymbolLogic('split', function(SPLIT, nativeSplit, maybeCallNative) {
                    var internalSplit;
                    if ('abbc'.split(/(b)*/)[1] == 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
                    'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
                    '.'.split(/()()/).length > 1 || ''.split(/.?/).length) // based on es5-shim implementation, need to rework it
                    internalSplit = function(separator, limit) {
                        var string = toString(requireObjectCoercible(this));
                        var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
                        if (lim === 0) return [];
                        if (separator === undefined) return [
                            string
                        ];
                        // If `separator` is not a regex, use native split
                        if (!isRegExp(separator)) return call(nativeSplit, string, separator, lim);
                        var output = [];
                        var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
                        var lastLastIndex = 0;
                        // Make `global` and avoid `lastIndex` issues by working with a copy
                        var separatorCopy = new RegExp(separator.source, flags + 'g');
                        var match, lastIndex, lastLength;
                        while(match = call(regexpExec, separatorCopy, string)){
                            lastIndex = separatorCopy.lastIndex;
                            if (lastIndex > lastLastIndex) {
                                push(output, stringSlice(string, lastLastIndex, match.index));
                                if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
                                lastLength = match[0].length;
                                lastLastIndex = lastIndex;
                                if (output.length >= lim) break;
                            }
                            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
                        }
                        if (lastLastIndex === string.length) {
                            if (lastLength || !exec(separatorCopy, '')) push(output, '');
                        } else push(output, stringSlice(string, lastLastIndex));
                        return output.length > lim ? arraySlice(output, 0, lim) : output;
                    };
                    else if ('0'.split(undefined, 0).length) internalSplit = function(separator, limit) {
                        return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
                    };
                    else internalSplit = nativeSplit;
                    return [
                        // `String.prototype.split` method
                        // https://tc39.es/ecma262/#sec-string.prototype.split
                        function split(separator, limit) {
                            var O = requireObjectCoercible(this);
                            var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
                            return splitter ? call(splitter, separator, O, limit) : call(internalSplit, toString(O), separator, limit);
                        },
                        // `RegExp.prototype[@@split]` method
                        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
                        //
                        // NOTE: This cannot be properly polyfilled in engines that don't support
                        // the 'y' flag.
                        function(string, limit) {
                            var rx = anObject(this);
                            var S = toString(string);
                            var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
                            if (res.done) return res.value;
                            var C = speciesConstructor(rx, RegExp);
                            var unicodeMatching = rx.unicode;
                            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y ? 'g' : 'y');
                            // ^(? + rx + ) is needed, in combination with some S slicing, to
                            // simulate the 'y' flag.
                            var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
                            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
                            if (lim === 0) return [];
                            if (S.length === 0) return callRegExpExec(splitter, S) === null ? [
                                S
                            ] : [];
                            var p = 0;
                            var q = 0;
                            var A = [];
                            while(q < S.length){
                                splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
                                var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
                                var e;
                                if (z === null || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = advanceStringIndex(S, q, unicodeMatching);
                                else {
                                    push(A, stringSlice(S, p, q));
                                    if (A.length === lim) return A;
                                    for(var i = 1; i <= z.length - 1; i++){
                                        push(A, z[i]);
                                        if (A.length === lim) return A;
                                    }
                                    q = p = e;
                                }
                            }
                            push(A, stringSlice(S, p));
                            return A;
                        }
                    ];
                }, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
            /***/ },
            /***/ 8807: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* eslint-disable es/no-object-getownpropertynames -- safe */ var classof = __webpack_require__(93975);
                var toIndexedObject = __webpack_require__(98086);
                var $getOwnPropertyNames = __webpack_require__(6611).f;
                var arraySlice = __webpack_require__(73163);
                var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                var getWindowNames = function(it) {
                    try {
                        return $getOwnPropertyNames(it);
                    } catch (error) {
                        return arraySlice(windowNames);
                    }
                };
                // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
                module1.exports.f = function getOwnPropertyNames(it) {
                    return windowNames && classof(it) == 'Window' ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
                };
            /***/ },
            /***/ 8953: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var arrayBufferModule = __webpack_require__(83124);
                var setSpecies = __webpack_require__(51334);
                var ARRAY_BUFFER = 'ArrayBuffer';
                var ArrayBuffer1 = arrayBufferModule[ARRAY_BUFFER];
                var NativeArrayBuffer = global[ARRAY_BUFFER];
                // `ArrayBuffer` constructor
                // https://tc39.es/ecma262/#sec-arraybuffer-constructor
                $({
                    global: true,
                    forced: NativeArrayBuffer !== ArrayBuffer1
                }, {
                    ArrayBuffer: ArrayBuffer1
                });
                setSpecies(ARRAY_BUFFER);
            /***/ },
            /***/ 9240: /***/ function(module1) {
                "use strict";
                module1.exports = /*#__PURE__*/ JSON.parse('{"ifd":{"8298":"Copyright","8769":"ExifIFDPointer","8822":"ExposureProgram","8824":"SpectralSensitivity","8825":"GPSInfoIFDPointer","8827":"PhotographicSensitivity","8828":"OECF","8830":"SensitivityType","8831":"StandardOutputSensitivity","8832":"RecommendedExposureIndex","8833":"ISOSpeed","8834":"ISOSpeedLatitudeyyy","8835":"ISOSpeedLatitudezzz","9000":"ExifVersion","9003":"DateTimeOriginal","9004":"DateTimeDigitized","9101":"ComponentsConfiguration","9102":"CompressedBitsPerPixel","9201":"ShutterSpeedValue","9202":"ApertureValue","9203":"BrightnessValue","9204":"ExposureBiasValue","9205":"MaxApertureValue","9206":"SubjectDistance","9207":"MeteringMode","9208":"LightSource","9209":"Flash","9214":"SubjectArea","9286":"UserComment","9290":"SubSecTime","9291":"SubSecTimeOriginal","9292":"SubSecTimeDigitized","010e":"ImageDescription","010f":"Make","011a":"XResolution","011b":"YResolution","011c":"PlanarConfiguration","012d":"TransferFunction","013b":"Artist","013e":"WhitePoint","013f":"PrimaryChromaticities","0100":"ImageWidth","0101":"ImageHeight","0102":"BitsPerSample","0103":"Compression","0106":"PhotometricInterpretation","0110":"Model","0111":"StripOffsets","0112":"Orientation","0115":"SamplesPerPixel","0116":"RowsPerStrip","0117":"StripByteCounts","0128":"ResolutionUnit","0131":"Software","0132":"DateTime","0201":"JPEGInterchangeFormat","0202":"JPEGInterchangeFormatLength","0211":"YCbCrCoefficients","0212":"YCbCrSubSampling","0213":"YCbCrPositioning","0214":"ReferenceBlackWhite","829a":"ExposureTime","829d":"FNumber","920a":"FocalLength","927c":"MakerNote","a000":"FlashpixVersion","a001":"ColorSpace","a002":"PixelXDimension","a003":"PixelYDimension","a004":"RelatedSoundFile","a005":"InteroperabilityIFDPointer","a20b":"FlashEnergy","a20c":"SpatialFrequencyResponse","a20e":"FocalPlaneXResolution","a20f":"FocalPlaneYResolution","a40a":"Sharpness","a40b":"DeviceSettingDescription","a40c":"SubjectDistanceRange","a210":"FocalPlaneResolutionUnit","a214":"SubjectLocation","a215":"ExposureIndex","a217":"SensingMethod","a300":"FileSource","a301":"SceneType","a302":"CFAPattern","a401":"CustomRendered","a402":"ExposureMode","a403":"WhiteBalance","a404":"DigitalZoomRatio","a405":"FocalLengthIn35mmFilm","a406":"SceneCaptureType","a407":"GainControl","a408":"Contrast","a409":"Saturation","a420":"ImageUniqueID","a430":"CameraOwnerName","a431":"BodySerialNumber","a432":"LensSpecification","a433":"LensMake","a434":"LensModel","a435":"LensSerialNumber","a500":"Gamma"},"gps":{"0000":"GPSVersionID","0001":"GPSLatitudeRef","0002":"GPSLatitude","0003":"GPSLongitudeRef","0004":"GPSLongitude","0005":"GPSAltitudeRef","0006":"GPSAltitude","0007":"GPSTimeStamp","0008":"GPSSatellites","0009":"GPSStatus","000a":"GPSMeasureMode","000b":"GPSDOP","000c":"GPSSpeedRef","000d":"GPSSpeed","000e":"GPSTrackRef","000f":"GPSTrack","0010":"GPSImgDirectionRef","0011":"GPSImgDirection","0012":"GPSMapDatum","0013":"GPSDestLatitudeRef","0014":"GPSDestLatitude","0015":"GPSDestLongitudeRef","0016":"GPSDestLongitude","0017":"GPSDestBearingRef","0018":"GPSDestBearing","0019":"GPSDestDistanceRef","001a":"GPSDestDistance","001b":"GPSProcessingMethod","001c":"GPSAreaInformation","001d":"GPSDateStamp","001e":"GPSDifferential","001f":"GPSHPositioningError"}}');
            /***/ },
            /***/ 9324: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var utils = __webpack_require__(18128);
                var Pointer = /*#__PURE__*/ function() {
                    function Pointer(offsetType, type, options) {
                        if (options === void 0) options = {};
                        this.offsetType = offsetType;
                        this.type = type;
                        this.options = options;
                        if (this.type === 'void') this.type = null;
                        if (this.options.type == null) this.options.type = 'local';
                        if (this.options.allowNull == null) this.options.allowNull = true;
                        if (this.options.nullValue == null) this.options.nullValue = 0;
                        if (this.options.lazy == null) this.options.lazy = false;
                        if (this.options.relativeTo) {
                            if (typeof this.options.relativeTo !== 'function') throw new Error('relativeTo option must be a function');
                            this.relativeToGetter = options.relativeTo;
                        }
                    }
                    var _proto = Pointer.prototype;
                    _proto.decode = function decode(stream, ctx) {
                        var _this = this;
                        var offset = this.offsetType.decode(stream, ctx);
                        // handle NULL pointers
                        if (offset === this.options.nullValue && this.options.allowNull) return null;
                        var relative;
                        switch(this.options.type){
                            case 'local':
                                relative = ctx._startOffset;
                                break;
                            case 'immediate':
                                relative = stream.pos - this.offsetType.size();
                                break;
                            case 'parent':
                                relative = ctx.parent._startOffset;
                                break;
                            default:
                                var c = ctx;
                                while(c.parent)c = c.parent;
                                relative = c._startOffset || 0;
                        }
                        if (this.options.relativeTo) relative += this.relativeToGetter(ctx);
                        var ptr = offset + relative;
                        if (this.type != null) {
                            var val = null;
                            var decodeValue = function decodeValue() {
                                if (val != null) return val;
                                var pos = stream.pos;
                                stream.pos = ptr;
                                val = _this.type.decode(stream, ctx);
                                stream.pos = pos;
                                return val;
                            };
                            // If this is a lazy pointer, define a getter to decode only when needed.
                            // This obviously only works when the pointer is contained by a Struct.
                            if (this.options.lazy) return new utils.PropertyDescriptor({
                                get: decodeValue
                            });
                            return decodeValue();
                        } else return ptr;
                    };
                    _proto.size = function size(val, ctx) {
                        var parent = ctx;
                        switch(this.options.type){
                            case 'local':
                            case 'immediate':
                                break;
                            case 'parent':
                                ctx = ctx.parent;
                                break;
                            default:
                                // global
                                while(ctx.parent)ctx = ctx.parent;
                        }
                        var type = this.type;
                        if (type == null) {
                            if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
                            var _val = val;
                            type = _val.type;
                            val = val.value;
                        }
                        if (val && ctx) ctx.pointerSize += type.size(val, parent);
                        return this.offsetType.size();
                    };
                    _proto.encode = function encode(stream, val, ctx) {
                        var relative;
                        var parent = ctx;
                        if (val == null) {
                            this.offsetType.encode(stream, this.options.nullValue);
                            return;
                        }
                        switch(this.options.type){
                            case 'local':
                                relative = ctx.startOffset;
                                break;
                            case 'immediate':
                                relative = stream.pos + this.offsetType.size(val, parent);
                                break;
                            case 'parent':
                                ctx = ctx.parent;
                                relative = ctx.startOffset;
                                break;
                            default:
                                // global
                                relative = 0;
                                while(ctx.parent)ctx = ctx.parent;
                        }
                        if (this.options.relativeTo) relative += this.relativeToGetter(parent.val);
                        this.offsetType.encode(stream, ctx.pointerOffset - relative);
                        var type = this.type;
                        if (type == null) {
                            if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
                            var _val2 = val;
                            type = _val2.type;
                            val = val.value;
                        }
                        ctx.pointers.push({
                            type: type,
                            val: val,
                            parent: parent
                        });
                        return ctx.pointerOffset += type.size(val, parent);
                    };
                    return Pointer;
                }(); // A pointer whose type is determined at decode time
                var VoidPointer = function VoidPointer(type, value) {
                    this.type = type;
                    this.value = value;
                };
                exports.Pointer = Pointer;
                exports.VoidPointer = VoidPointer;
            /***/ },
            /***/ 9567: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = __webpack_require__(46887);
                module1.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';
            /***/ },
            /***/ 9649: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var defineProperty = __webpack_require__(95892).f;
                var create = __webpack_require__(10819);
                var redefineAll = __webpack_require__(15341);
                var bind = __webpack_require__(25567);
                var anInstance = __webpack_require__(2868);
                var iterate = __webpack_require__(80383);
                var defineIterator = __webpack_require__(97001);
                var setSpecies = __webpack_require__(51334);
                var DESCRIPTORS = __webpack_require__(15567);
                var fastKey = __webpack_require__(62148).fastKey;
                var InternalStateModule = __webpack_require__(70172);
                var setInternalState = InternalStateModule.set;
                var internalStateGetterFor = InternalStateModule.getterFor;
                module1.exports = {
                    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
                        var Constructor = wrapper(function(that, iterable) {
                            anInstance(that, Prototype);
                            setInternalState(that, {
                                type: CONSTRUCTOR_NAME,
                                index: create(null),
                                first: undefined,
                                last: undefined,
                                size: 0
                            });
                            if (!DESCRIPTORS) that.size = 0;
                            if (iterable != undefined) iterate(iterable, that[ADDER], {
                                that: that,
                                AS_ENTRIES: IS_MAP
                            });
                        });
                        var Prototype = Constructor.prototype;
                        var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
                        var define = function(that, key, value) {
                            var state = getInternalState(that);
                            var entry = getEntry(that, key);
                            var previous, index;
                            // change existing entry
                            if (entry) entry.value = value;
                            else {
                                state.last = entry = {
                                    index: index = fastKey(key, true),
                                    key: key,
                                    value: value,
                                    previous: previous = state.last,
                                    next: undefined,
                                    removed: false
                                };
                                if (!state.first) state.first = entry;
                                if (previous) previous.next = entry;
                                if (DESCRIPTORS) state.size++;
                                else that.size++;
                                // add to index
                                if (index !== 'F') state.index[index] = entry;
                            }
                            return that;
                        };
                        var getEntry = function(that, key) {
                            var state = getInternalState(that);
                            // fast case
                            var index = fastKey(key);
                            var entry;
                            if (index !== 'F') return state.index[index];
                            // frozen object case
                            for(entry = state.first; entry; entry = entry.next){
                                if (entry.key == key) return entry;
                            }
                        };
                        redefineAll(Prototype, {
                            // `{ Map, Set }.prototype.clear()` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.clear
                            // https://tc39.es/ecma262/#sec-set.prototype.clear
                            clear: function clear() {
                                var that = this;
                                var state = getInternalState(that);
                                var data = state.index;
                                var entry = state.first;
                                while(entry){
                                    entry.removed = true;
                                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                                    delete data[entry.index];
                                    entry = entry.next;
                                }
                                state.first = state.last = undefined;
                                if (DESCRIPTORS) state.size = 0;
                                else that.size = 0;
                            },
                            // `{ Map, Set }.prototype.delete(key)` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.delete
                            // https://tc39.es/ecma262/#sec-set.prototype.delete
                            'delete': function(key) {
                                var that = this;
                                var state = getInternalState(that);
                                var entry = getEntry(that, key);
                                if (entry) {
                                    var next = entry.next;
                                    var prev = entry.previous;
                                    delete state.index[entry.index];
                                    entry.removed = true;
                                    if (prev) prev.next = next;
                                    if (next) next.previous = prev;
                                    if (state.first == entry) state.first = next;
                                    if (state.last == entry) state.last = prev;
                                    if (DESCRIPTORS) state.size--;
                                    else that.size--;
                                }
                                return !!entry;
                            },
                            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.foreach
                            // https://tc39.es/ecma262/#sec-set.prototype.foreach
                            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                                var state = getInternalState(this);
                                var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                                var entry;
                                while(entry = entry ? entry.next : state.first){
                                    boundFunction(entry.value, entry.key, this);
                                    // revert to the last existing entry
                                    while(entry && entry.removed)entry = entry.previous;
                                }
                            },
                            // `{ Map, Set}.prototype.has(key)` methods
                            // https://tc39.es/ecma262/#sec-map.prototype.has
                            // https://tc39.es/ecma262/#sec-set.prototype.has
                            has: function has(key) {
                                return !!getEntry(this, key);
                            }
                        });
                        redefineAll(Prototype, IS_MAP ? {
                            // `Map.prototype.get(key)` method
                            // https://tc39.es/ecma262/#sec-map.prototype.get
                            get: function get(key) {
                                var entry = getEntry(this, key);
                                return entry && entry.value;
                            },
                            // `Map.prototype.set(key, value)` method
                            // https://tc39.es/ecma262/#sec-map.prototype.set
                            set: function set(key, value) {
                                return define(this, key === 0 ? 0 : key, value);
                            }
                        } : {
                            // `Set.prototype.add(value)` method
                            // https://tc39.es/ecma262/#sec-set.prototype.add
                            add: function add(value) {
                                return define(this, value = value === 0 ? 0 : value, value);
                            }
                        });
                        if (DESCRIPTORS) defineProperty(Prototype, 'size', {
                            get: function() {
                                return getInternalState(this).size;
                            }
                        });
                        return Constructor;
                    },
                    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
                        var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
                        var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
                        var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
                        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
                        // https://tc39.es/ecma262/#sec-map.prototype.entries
                        // https://tc39.es/ecma262/#sec-map.prototype.keys
                        // https://tc39.es/ecma262/#sec-map.prototype.values
                        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
                        // https://tc39.es/ecma262/#sec-set.prototype.entries
                        // https://tc39.es/ecma262/#sec-set.prototype.keys
                        // https://tc39.es/ecma262/#sec-set.prototype.values
                        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
                        defineIterator(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
                            setInternalState(this, {
                                type: ITERATOR_NAME,
                                target: iterated,
                                state: getInternalCollectionState(iterated),
                                kind: kind,
                                last: undefined
                            });
                        }, function() {
                            var state = getInternalIteratorState(this);
                            var kind = state.kind;
                            var entry = state.last;
                            // revert to the last existing entry
                            while(entry && entry.removed)entry = entry.previous;
                            // get next entry
                            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                                // or finish the iteration
                                state.target = undefined;
                                return {
                                    value: undefined,
                                    done: true
                                };
                            }
                            // return step by kind
                            if (kind == 'keys') return {
                                value: entry.key,
                                done: false
                            };
                            if (kind == 'values') return {
                                value: entry.value,
                                done: false
                            };
                            return {
                                value: [
                                    entry.key,
                                    entry.value
                                ],
                                done: false
                            };
                        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
                        // `{ Map, Set }.prototype[@@species]` accessors
                        // https://tc39.es/ecma262/#sec-get-map-@@species
                        // https://tc39.es/ecma262/#sec-get-set-@@species
                        setSpecies(CONSTRUCTOR_NAME);
                    }
                };
            /***/ },
            /***/ 9760: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                module1.exports = Stream;
                var EE = __webpack_require__(64785).EventEmitter;
                var inherits = __webpack_require__(89784);
                inherits(Stream, EE);
                Stream.Readable = __webpack_require__(88261);
                Stream.Writable = __webpack_require__(29781);
                Stream.Duplex = __webpack_require__(14903);
                Stream.Transform = __webpack_require__(48569);
                Stream.PassThrough = __webpack_require__(17723);
                Stream.finished = __webpack_require__(12167);
                Stream.pipeline = __webpack_require__(43765);
                // Backwards-compat with node 0.4.x
                Stream.Stream = Stream;
                // old-style streams.  Note that the pipe method (the only relevant
                // part of this class) is overridden in the Readable class.
                function Stream() {
                    EE.call(this);
                }
                Stream.prototype.pipe = function(dest, options) {
                    var source = this;
                    function ondata(chunk) {
                        if (dest.writable) {
                            if (false === dest.write(chunk) && source.pause) source.pause();
                        }
                    }
                    source.on('data', ondata);
                    function ondrain() {
                        if (source.readable && source.resume) source.resume();
                    }
                    dest.on('drain', ondrain);
                    // If the 'end' option is not supplied, dest.end() will be called when
                    // source gets the 'end' or 'close' events.  Only dest.end() once.
                    if (!dest._isStdio && (!options || options.end !== false)) {
                        source.on('end', onend);
                        source.on('close', onclose);
                    }
                    var didOnEnd = false;
                    function onend() {
                        if (didOnEnd) return;
                        didOnEnd = true;
                        dest.end();
                    }
                    function onclose() {
                        if (didOnEnd) return;
                        didOnEnd = true;
                        if (typeof dest.destroy === 'function') dest.destroy();
                    }
                    // don't leave dangling pipes when there are errors.
                    function onerror(er) {
                        cleanup();
                        if (EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
                    }
                    source.on('error', onerror);
                    dest.on('error', onerror);
                    // remove all the event listeners that were added.
                    function cleanup() {
                        source.removeListener('data', ondata);
                        dest.removeListener('drain', ondrain);
                        source.removeListener('end', onend);
                        source.removeListener('close', onclose);
                        source.removeListener('error', onerror);
                        dest.removeListener('error', onerror);
                        source.removeListener('end', cleanup);
                        source.removeListener('close', cleanup);
                        dest.removeListener('close', cleanup);
                    }
                    source.on('end', cleanup);
                    source.on('close', cleanup);
                    dest.on('close', cleanup);
                    dest.emit('pipe', source);
                    // Allow for unix-like usage: A.pipe(B).pipe(C)
                    return dest;
                };
            /***/ },
            /***/ 9964: /***/ function(module1) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error('setTimeout has not been defined');
                }
                function defaultClearTimeout() {
                    throw new Error('clearTimeout has not been defined');
                }
                (function() {
                    try {
                        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = 'browser';
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ''; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error('process.binding is not supported');
                };
                process.cwd = function() {
                    return '/';
                };
                process.chdir = function(dir) {
                    throw new Error('process.chdir is not supported');
                };
                process.umask = function() {
                    return 0;
                };
            /***/ },
            /***/ 10078: /***/ function(module1) {
                "use strict";
                /** @type {import('./functionCall')} */ module1.exports = Function.prototype.call;
            /***/ },
            /***/ 10196: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(15567);
                var definePropertyModule = __webpack_require__(95892);
                var anObject = __webpack_require__(34984);
                var toIndexedObject = __webpack_require__(98086);
                var objectKeys = __webpack_require__(84675);
                // `Object.defineProperties` method
                // https://tc39.es/ecma262/#sec-object.defineproperties
                // eslint-disable-next-line es/no-object-defineproperties -- safe
                module1.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
                    anObject(O);
                    var props = toIndexedObject(Properties);
                    var keys = objectKeys(Properties);
                    var length = keys.length;
                    var index = 0;
                    var key;
                    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
                    return O;
                };
            /***/ },
            /***/ 10447: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var isCallable = __webpack_require__(94578);
                var store = __webpack_require__(55480);
                var functionToString = uncurryThis(Function.toString);
                // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
                if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
                    return functionToString(it);
                };
                module1.exports = store.inspectSource;
            /***/ },
            /***/ 10713: /***/ function(module1) {
                "use strict";
                /** @type {import('./isNaN')} */ module1.exports = Number.isNaN || function isNaN1(a) {
                    return a !== a;
                };
            /***/ },
            /***/ 10740: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                __webpack_require__(65292);
                __webpack_require__(73844);
                __webpack_require__(69330);
                __webpack_require__(5597);
                __webpack_require__(7585);
                __webpack_require__(39081);
                __webpack_require__(41584);
                __webpack_require__(11765);
                __webpack_require__(81755);
                __webpack_require__(94845);
                __webpack_require__(80055);
                __webpack_require__(20731);
                __webpack_require__(45337);
                __webpack_require__(23913);
                __webpack_require__(8953);
                __webpack_require__(24863);
                __webpack_require__(18828);
                __webpack_require__(7283);
                __webpack_require__(58549);
                __webpack_require__(18756);
                __webpack_require__(75174);
                __webpack_require__(57444);
                __webpack_require__(37309);
                __webpack_require__(14032);
                __webpack_require__(68067);
                __webpack_require__(61726);
                __webpack_require__(74516);
                __webpack_require__(57114);
                __webpack_require__(76014);
                __webpack_require__(65578);
                __webpack_require__(58281);
                __webpack_require__(6422);
                __webpack_require__(28264);
                __webpack_require__(72095);
                __webpack_require__(75626);
                __webpack_require__(47969);
                __webpack_require__(73663);
                __webpack_require__(29883);
                __webpack_require__(35471);
                __webpack_require__(21012);
                __webpack_require__(88997);
                __webpack_require__(97464);
                __webpack_require__(2857);
                __webpack_require__(94715);
                __webpack_require__(13624);
                __webpack_require__(91132);
                __webpack_require__(62514);
                __webpack_require__(24597);
                __webpack_require__(88042);
                __webpack_require__(4660);
                __webpack_require__(92451);
                __webpack_require__(44206);
                __webpack_require__(66288);
                __webpack_require__(13250);
                __webpack_require__(3858);
                __webpack_require__(84538);
                __webpack_require__(64793);
                __webpack_require__(74202);
                __webpack_require__(52529);
                __webpack_require__(42437);
                __webpack_require__(94712);
                var _;
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == typeof i ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != typeof t || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                function _inheritsLoose(t, o) {
                    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
                }
                function _setPrototypeOf(t, e) {
                    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                        return t.__proto__ = e, t;
                    }, _setPrototypeOf(t, e);
                }
                function _createForOfIteratorHelperLoose(r, e) {
                    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                    if (t) return (t = t.call(r)).next.bind(t);
                    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
                        t && (r = t);
                        var o = 0;
                        return function() {
                            return o >= r.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: r[o++]
                            };
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(r, a) {
                    if (r) {
                        if ("string" == typeof r) return _arrayLikeToArray(r, a);
                        var t = ({}).toString.call(r).slice(8, -1);
                        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
                    }
                }
                function _arrayLikeToArray(r, a) {
                    (null == a || a > r.length) && (a = r.length);
                    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
                    return n;
                }
                function _interopDefault(ex) {
                    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
                }
                var r = _interopDefault(__webpack_require__(62420));
                var utils = __webpack_require__(18128);
                var isEqual = _interopDefault(__webpack_require__(45728));
                var unicode = _interopDefault(__webpack_require__(24766));
                var UnicodeTrie = _interopDefault(__webpack_require__(59006));
                var StateMachine = _interopDefault(__webpack_require__(18645));
                var cloneDeep = _interopDefault(__webpack_require__(41613));
                var inflate = _interopDefault(__webpack_require__(3483));
                var brotli = _interopDefault(__webpack_require__(34460));
                var fs = __webpack_require__(48181);
                var fontkit = {};
                fontkit.logErrors = false;
                var formats = [];
                fontkit.registerFormat = function(format) {
                    formats.push(format);
                };
                fontkit.openSync = function(filename, postscriptName) {
                    var buffer = fs.readFileSync(filename);
                    return fontkit.create(buffer, postscriptName);
                };
                fontkit.open = function(filename, postscriptName, callback) {
                    if (typeof postscriptName === 'function') {
                        callback = postscriptName;
                        postscriptName = null;
                    }
                    fs.readFile(filename, function(err, buffer) {
                        if (err) return callback(err);
                        try {
                            var font = fontkit.create(buffer, postscriptName);
                        } catch (e) {
                            return callback(e);
                        }
                        return callback(null, font);
                    });
                    return;
                };
                fontkit.create = function(buffer, postscriptName) {
                    for(var i = 0; i < formats.length; i++){
                        var format = formats[i];
                        if (format.probe(buffer)) {
                            var font = new format(new r.DecodeStream(buffer));
                            if (postscriptName) return font.getFont(postscriptName);
                            return font;
                        }
                    }
                    throw new Error('Unknown font format');
                };
                fontkit.defaultLanguage = 'en';
                fontkit.setDefaultLanguage = function(lang) {
                    if (lang === void 0) lang = 'en';
                    fontkit.defaultLanguage = lang;
                };
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
                    var desc = {};
                    Object.keys(descriptor).forEach(function(key) {
                        desc[key] = descriptor[key];
                    });
                    desc.enumerable = !!desc.enumerable;
                    desc.configurable = !!desc.configurable;
                    if ('value' in desc || desc.initializer) desc.writable = true;
                    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
                        return decorator(target, property, desc) || desc;
                    }, desc);
                    if (context && desc.initializer !== void 0) {
                        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
                        desc.initializer = undefined;
                    }
                    if (desc.initializer === void 0) {
                        Object.defineProperty(target, property, desc);
                        desc = null;
                    }
                    return desc;
                }
                /**
 * This decorator caches the results of a getter or method such that
 * the results are lazily computed once, and then cached.
 * @private
 */ function cache(target, key, descriptor) {
                    if (descriptor.get) {
                        var get = descriptor.get;
                        descriptor.get = function() {
                            var value = get.call(this);
                            Object.defineProperty(this, key, {
                                value: value
                            });
                            return value;
                        };
                    } else if (typeof descriptor.value === 'function') {
                        var fn = descriptor.value;
                        return {
                            get: function get() {
                                var cache = new Map();
                                function memoized() {
                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                    var key = args.length > 0 ? args[0] : 'value';
                                    if (cache.has(key)) return cache.get(key);
                                    var result = fn.apply(this, args);
                                    cache.set(key, result);
                                    return result;
                                }
                                Object.defineProperty(this, key, {
                                    value: memoized
                                });
                                return memoized;
                            }
                        };
                    }
                }
                var SubHeader = new r.Struct({
                    firstCode: r.uint16,
                    entryCount: r.uint16,
                    idDelta: r.int16,
                    idRangeOffset: r.uint16
                });
                var CmapGroup = new r.Struct({
                    startCharCode: r.uint32,
                    endCharCode: r.uint32,
                    glyphID: r.uint32
                });
                var UnicodeValueRange = new r.Struct({
                    startUnicodeValue: r.uint24,
                    additionalCount: r.uint8
                });
                var UVSMapping = new r.Struct({
                    unicodeValue: r.uint24,
                    glyphID: r.uint16
                });
                var DefaultUVS = new r.Array(UnicodeValueRange, r.uint32);
                var NonDefaultUVS = new r.Array(UVSMapping, r.uint32);
                var VarSelectorRecord = new r.Struct({
                    varSelector: r.uint24,
                    defaultUVS: new r.Pointer(r.uint32, DefaultUVS, {
                        type: 'parent'
                    }),
                    nonDefaultUVS: new r.Pointer(r.uint32, NonDefaultUVS, {
                        type: 'parent'
                    })
                });
                var CmapSubtable = new r.VersionedStruct(r.uint16, {
                    0: {
                        // Byte encoding
                        length: r.uint16,
                        // Total table length in bytes (set to 262 for format 0)
                        language: r.uint16,
                        // Language code for this encoding subtable, or zero if language-independent
                        codeMap: new r.LazyArray(r.uint8, 256)
                    },
                    2: {
                        // High-byte mapping (CJK)
                        length: r.uint16,
                        language: r.uint16,
                        subHeaderKeys: new r.Array(r.uint16, 256),
                        subHeaderCount: function subHeaderCount(t) {
                            return Math.max.apply(Math, t.subHeaderKeys);
                        },
                        subHeaders: new r.LazyArray(SubHeader, 'subHeaderCount'),
                        glyphIndexArray: new r.LazyArray(r.uint16, 'subHeaderCount')
                    },
                    4: {
                        // Segment mapping to delta values
                        length: r.uint16,
                        // Total table length in bytes
                        language: r.uint16,
                        // Language code
                        segCountX2: r.uint16,
                        segCount: function segCount(t) {
                            return t.segCountX2 >> 1;
                        },
                        searchRange: r.uint16,
                        entrySelector: r.uint16,
                        rangeShift: r.uint16,
                        endCode: new r.LazyArray(r.uint16, 'segCount'),
                        reservedPad: new r.Reserved(r.uint16),
                        // This value should be zero
                        startCode: new r.LazyArray(r.uint16, 'segCount'),
                        idDelta: new r.LazyArray(r.int16, 'segCount'),
                        idRangeOffset: new r.LazyArray(r.uint16, 'segCount'),
                        glyphIndexArray: new r.LazyArray(r.uint16, function(t) {
                            return (t.length - t._currentOffset) / 2;
                        })
                    },
                    6: {
                        // Trimmed table
                        length: r.uint16,
                        language: r.uint16,
                        firstCode: r.uint16,
                        entryCount: r.uint16,
                        glyphIndices: new r.LazyArray(r.uint16, 'entryCount')
                    },
                    8: {
                        // mixed 16-bit and 32-bit coverage
                        reserved: new r.Reserved(r.uint16),
                        length: r.uint32,
                        language: r.uint16,
                        is32: new r.LazyArray(r.uint8, 8192),
                        nGroups: r.uint32,
                        groups: new r.LazyArray(CmapGroup, 'nGroups')
                    },
                    10: {
                        // Trimmed Array
                        reserved: new r.Reserved(r.uint16),
                        length: r.uint32,
                        language: r.uint32,
                        firstCode: r.uint32,
                        entryCount: r.uint32,
                        glyphIndices: new r.LazyArray(r.uint16, 'numChars')
                    },
                    12: {
                        // Segmented coverage
                        reserved: new r.Reserved(r.uint16),
                        length: r.uint32,
                        language: r.uint32,
                        nGroups: r.uint32,
                        groups: new r.LazyArray(CmapGroup, 'nGroups')
                    },
                    13: {
                        // Many-to-one range mappings (same as 12 except for group.startGlyphID)
                        reserved: new r.Reserved(r.uint16),
                        length: r.uint32,
                        language: r.uint32,
                        nGroups: r.uint32,
                        groups: new r.LazyArray(CmapGroup, 'nGroups')
                    },
                    14: {
                        // Unicode Variation Sequences
                        length: r.uint32,
                        numRecords: r.uint32,
                        varSelectors: new r.LazyArray(VarSelectorRecord, 'numRecords')
                    }
                });
                var CmapEntry = new r.Struct({
                    platformID: r.uint16,
                    // Platform identifier
                    encodingID: r.uint16,
                    // Platform-specific encoding identifier
                    table: new r.Pointer(r.uint32, CmapSubtable, {
                        type: 'parent',
                        lazy: true
                    })
                }); // character to glyph mapping
                var cmap = new r.Struct({
                    version: r.uint16,
                    numSubtables: r.uint16,
                    tables: new r.Array(CmapEntry, 'numSubtables')
                });
                var head = new r.Struct({
                    version: r.int32,
                    // 0x00010000 (version 1.0)
                    revision: r.int32,
                    // set by font manufacturer
                    checkSumAdjustment: r.uint32,
                    magicNumber: r.uint32,
                    // set to 0x5F0F3CF5
                    flags: r.uint16,
                    unitsPerEm: r.uint16,
                    // range from 64 to 16384
                    created: new r.Array(r.int32, 2),
                    modified: new r.Array(r.int32, 2),
                    xMin: r.int16,
                    // for all glyph bounding boxes
                    yMin: r.int16,
                    // for all glyph bounding boxes
                    xMax: r.int16,
                    // for all glyph bounding boxes
                    yMax: r.int16,
                    // for all glyph bounding boxes
                    macStyle: new r.Bitfield(r.uint16, [
                        'bold',
                        'italic',
                        'underline',
                        'outline',
                        'shadow',
                        'condensed',
                        'extended'
                    ]),
                    lowestRecPPEM: r.uint16,
                    // smallest readable size in pixels
                    fontDirectionHint: r.int16,
                    indexToLocFormat: r.int16,
                    // 0 for short offsets, 1 for long
                    glyphDataFormat: r.int16 // 0 for current format
                });
                var hhea = new r.Struct({
                    version: r.int32,
                    ascent: r.int16,
                    // Distance from baseline of highest ascender
                    descent: r.int16,
                    // Distance from baseline of lowest descender
                    lineGap: r.int16,
                    // Typographic line gap
                    advanceWidthMax: r.uint16,
                    // Maximum advance width value in 'hmtx' table
                    minLeftSideBearing: r.int16,
                    // Maximum advance width value in 'hmtx' table
                    minRightSideBearing: r.int16,
                    // Minimum right sidebearing value
                    xMaxExtent: r.int16,
                    caretSlopeRise: r.int16,
                    // Used to calculate the slope of the cursor (rise/run); 1 for vertical
                    caretSlopeRun: r.int16,
                    // 0 for vertical
                    caretOffset: r.int16,
                    // Set to 0 for non-slanted fonts
                    reserved: new r.Reserved(r.int16, 4),
                    metricDataFormat: r.int16,
                    // 0 for current format
                    numberOfMetrics: r.uint16 // Number of advance widths in 'hmtx' table
                });
                var HmtxEntry = new r.Struct({
                    advance: r.uint16,
                    bearing: r.int16
                });
                var hmtx = new r.Struct({
                    metrics: new r.LazyArray(HmtxEntry, function(t) {
                        return t.parent.hhea.numberOfMetrics;
                    }),
                    bearings: new r.LazyArray(r.int16, function(t) {
                        return t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics;
                    })
                });
                var maxp = new r.Struct({
                    version: r.int32,
                    numGlyphs: r.uint16,
                    // The number of glyphs in the font
                    maxPoints: r.uint16,
                    // Maximum points in a non-composite glyph
                    maxContours: r.uint16,
                    // Maximum contours in a non-composite glyph
                    maxComponentPoints: r.uint16,
                    // Maximum points in a composite glyph
                    maxComponentContours: r.uint16,
                    // Maximum contours in a composite glyph
                    maxZones: r.uint16,
                    // 1 if instructions do not use the twilight zone, 2 otherwise
                    maxTwilightPoints: r.uint16,
                    // Maximum points used in Z0
                    maxStorage: r.uint16,
                    // Number of Storage Area locations
                    maxFunctionDefs: r.uint16,
                    // Number of FDEFs
                    maxInstructionDefs: r.uint16,
                    // Number of IDEFs
                    maxStackElements: r.uint16,
                    // Maximum stack depth
                    maxSizeOfInstructions: r.uint16,
                    // Maximum byte count for glyph instructions
                    maxComponentElements: r.uint16,
                    // Maximum number of components referenced at “top level” for any composite glyph
                    maxComponentDepth: r.uint16 // Maximum levels of recursion; 1 for simple components
                });
                /**
 * Gets an encoding name from platform, encoding, and language ids.
 * Returned encoding names can be used in iconv-lite to decode text.
 */ function getEncoding(platformID, encodingID, languageID) {
                    if (languageID === void 0) languageID = 0;
                    if (platformID === 1 && MAC_LANGUAGE_ENCODINGS[languageID]) return MAC_LANGUAGE_ENCODINGS[languageID];
                    return ENCODINGS[platformID][encodingID];
                } // Map of platform ids to encoding ids.
                var ENCODINGS = [
                    // unicode
                    [
                        'utf16be',
                        'utf16be',
                        'utf16be',
                        'utf16be',
                        'utf16be',
                        'utf16be'
                    ],
                    // macintosh
                    // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
                    // 0	Roman                 17	Malayalam
                    // 1	Japanese	            18	Sinhalese
                    // 2	Traditional Chinese	  19	Burmese
                    // 3	Korean	              20	Khmer
                    // 4	Arabic	              21	Thai
                    // 5	Hebrew	              22	Laotian
                    // 6	Greek	                23	Georgian
                    // 7	Russian	              24	Armenian
                    // 8	RSymbol	              25	Simplified Chinese
                    // 9	Devanagari	          26	Tibetan
                    // 10	Gurmukhi	            27	Mongolian
                    // 11	Gujarati	            28	Geez
                    // 12	Oriya	                29	Slavic
                    // 13	Bengali	              30	Vietnamese
                    // 14	Tamil	                31	Sindhi
                    // 15	Telugu	              32	(Uninterpreted)
                    // 16	Kannada
                    [
                        'macroman',
                        'shift-jis',
                        'big5',
                        'euc-kr',
                        'iso-8859-6',
                        'iso-8859-8',
                        'macgreek',
                        'maccyrillic',
                        'symbol',
                        'Devanagari',
                        'Gurmukhi',
                        'Gujarati',
                        'Oriya',
                        'Bengali',
                        'Tamil',
                        'Telugu',
                        'Kannada',
                        'Malayalam',
                        'Sinhalese',
                        'Burmese',
                        'Khmer',
                        'macthai',
                        'Laotian',
                        'Georgian',
                        'Armenian',
                        'gb-2312-80',
                        'Tibetan',
                        'Mongolian',
                        'Geez',
                        'maccenteuro',
                        'Vietnamese',
                        'Sindhi'
                    ],
                    // ISO (deprecated)
                    [
                        'ascii'
                    ],
                    // windows
                    // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
                    [
                        'symbol',
                        'utf16be',
                        'shift-jis',
                        'gb18030',
                        'big5',
                        'wansung',
                        'johab',
                        null,
                        null,
                        null,
                        'utf16be'
                    ]
                ]; // Overrides for Mac scripts by language id.
                // See http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
                var MAC_LANGUAGE_ENCODINGS = {
                    15: 'maciceland',
                    17: 'macturkish',
                    18: 'maccroatian',
                    24: 'maccenteuro',
                    25: 'maccenteuro',
                    26: 'maccenteuro',
                    27: 'maccenteuro',
                    28: 'maccenteuro',
                    30: 'maciceland',
                    37: 'macromania',
                    38: 'maccenteuro',
                    39: 'maccenteuro',
                    40: 'maccenteuro',
                    143: 'macinuit',
                    // Unsupported by iconv-lite
                    146: 'macgaelic' // Unsupported by iconv-lite
                }; // Map of platform ids to BCP-47 language codes.
                var LANGUAGES = [
                    // unicode
                    [],
                    {
                        // macintosh
                        0: 'en',
                        30: 'fo',
                        60: 'ks',
                        90: 'rw',
                        1: 'fr',
                        31: 'fa',
                        61: 'ku',
                        91: 'rn',
                        2: 'de',
                        32: 'ru',
                        62: 'sd',
                        92: 'ny',
                        3: 'it',
                        33: 'zh',
                        63: 'bo',
                        93: 'mg',
                        4: 'nl',
                        34: 'nl-BE',
                        64: 'ne',
                        94: 'eo',
                        5: 'sv',
                        35: 'ga',
                        65: 'sa',
                        128: 'cy',
                        6: 'es',
                        36: 'sq',
                        66: 'mr',
                        129: 'eu',
                        7: 'da',
                        37: 'ro',
                        67: 'bn',
                        130: 'ca',
                        8: 'pt',
                        38: 'cz',
                        68: 'as',
                        131: 'la',
                        9: 'no',
                        39: 'sk',
                        69: 'gu',
                        132: 'qu',
                        10: 'he',
                        40: 'si',
                        70: 'pa',
                        133: 'gn',
                        11: 'ja',
                        41: 'yi',
                        71: 'or',
                        134: 'ay',
                        12: 'ar',
                        42: 'sr',
                        72: 'ml',
                        135: 'tt',
                        13: 'fi',
                        43: 'mk',
                        73: 'kn',
                        136: 'ug',
                        14: 'el',
                        44: 'bg',
                        74: 'ta',
                        137: 'dz',
                        15: 'is',
                        45: 'uk',
                        75: 'te',
                        138: 'jv',
                        16: 'mt',
                        46: 'be',
                        76: 'si',
                        139: 'su',
                        17: 'tr',
                        47: 'uz',
                        77: 'my',
                        140: 'gl',
                        18: 'hr',
                        48: 'kk',
                        78: 'km',
                        141: 'af',
                        19: 'zh-Hant',
                        49: 'az-Cyrl',
                        79: 'lo',
                        142: 'br',
                        20: 'ur',
                        50: 'az-Arab',
                        80: 'vi',
                        143: 'iu',
                        21: 'hi',
                        51: 'hy',
                        81: 'id',
                        144: 'gd',
                        22: 'th',
                        52: 'ka',
                        82: 'tl',
                        145: 'gv',
                        23: 'ko',
                        53: 'mo',
                        83: 'ms',
                        146: 'ga',
                        24: 'lt',
                        54: 'ky',
                        84: 'ms-Arab',
                        147: 'to',
                        25: 'pl',
                        55: 'tg',
                        85: 'am',
                        148: 'el-polyton',
                        26: 'hu',
                        56: 'tk',
                        86: 'ti',
                        149: 'kl',
                        27: 'es',
                        57: 'mn-CN',
                        87: 'om',
                        150: 'az',
                        28: 'lv',
                        58: 'mn',
                        88: 'so',
                        151: 'nn',
                        29: 'se',
                        59: 'ps',
                        89: 'sw'
                    },
                    // ISO (deprecated)
                    [],
                    {
                        // windows                                        
                        0x0436: 'af',
                        0x4009: 'en-IN',
                        0x0487: 'rw',
                        0x0432: 'tn',
                        0x041C: 'sq',
                        0x1809: 'en-IE',
                        0x0441: 'sw',
                        0x045B: 'si',
                        0x0484: 'gsw',
                        0x2009: 'en-JM',
                        0x0457: 'kok',
                        0x041B: 'sk',
                        0x045E: 'am',
                        0x4409: 'en-MY',
                        0x0412: 'ko',
                        0x0424: 'sl',
                        0x1401: 'ar-DZ',
                        0x1409: 'en-NZ',
                        0x0440: 'ky',
                        0x2C0A: 'es-AR',
                        0x3C01: 'ar-BH',
                        0x3409: 'en-PH',
                        0x0454: 'lo',
                        0x400A: 'es-BO',
                        0x0C01: 'ar',
                        0x4809: 'en-SG',
                        0x0426: 'lv',
                        0x340A: 'es-CL',
                        0x0801: 'ar-IQ',
                        0x1C09: 'en-ZA',
                        0x0427: 'lt',
                        0x240A: 'es-CO',
                        0x2C01: 'ar-JO',
                        0x2C09: 'en-TT',
                        0x082E: 'dsb',
                        0x140A: 'es-CR',
                        0x3401: 'ar-KW',
                        0x0809: 'en-GB',
                        0x046E: 'lb',
                        0x1C0A: 'es-DO',
                        0x3001: 'ar-LB',
                        0x0409: 'en',
                        0x042F: 'mk',
                        0x300A: 'es-EC',
                        0x1001: 'ar-LY',
                        0x3009: 'en-ZW',
                        0x083E: 'ms-BN',
                        0x440A: 'es-SV',
                        0x1801: 'ary',
                        0x0425: 'et',
                        0x043E: 'ms',
                        0x100A: 'es-GT',
                        0x2001: 'ar-OM',
                        0x0438: 'fo',
                        0x044C: 'ml',
                        0x480A: 'es-HN',
                        0x4001: 'ar-QA',
                        0x0464: 'fil',
                        0x043A: 'mt',
                        0x080A: 'es-MX',
                        0x0401: 'ar-SA',
                        0x040B: 'fi',
                        0x0481: 'mi',
                        0x4C0A: 'es-NI',
                        0x2801: 'ar-SY',
                        0x080C: 'fr-BE',
                        0x047A: 'arn',
                        0x180A: 'es-PA',
                        0x1C01: 'aeb',
                        0x0C0C: 'fr-CA',
                        0x044E: 'mr',
                        0x3C0A: 'es-PY',
                        0x3801: 'ar-AE',
                        0x040C: 'fr',
                        0x047C: 'moh',
                        0x280A: 'es-PE',
                        0x2401: 'ar-YE',
                        0x140C: 'fr-LU',
                        0x0450: 'mn',
                        0x500A: 'es-PR',
                        0x042B: 'hy',
                        0x180C: 'fr-MC',
                        0x0850: 'mn-CN',
                        0x0C0A: 'es',
                        0x044D: 'as',
                        0x100C: 'fr-CH',
                        0x0461: 'ne',
                        0x040A: 'es',
                        0x082C: 'az-Cyrl',
                        0x0462: 'fy',
                        0x0414: 'nb',
                        0x540A: 'es-US',
                        0x042C: 'az',
                        0x0456: 'gl',
                        0x0814: 'nn',
                        0x380A: 'es-UY',
                        0x046D: 'ba',
                        0x0437: 'ka',
                        0x0482: 'oc',
                        0x200A: 'es-VE',
                        0x042D: 'eu',
                        0x0C07: 'de-AT',
                        0x0448: 'or',
                        0x081D: 'sv-FI',
                        0x0423: 'be',
                        0x0407: 'de',
                        0x0463: 'ps',
                        0x041D: 'sv',
                        0x0845: 'bn',
                        0x1407: 'de-LI',
                        0x0415: 'pl',
                        0x045A: 'syr',
                        0x0445: 'bn-IN',
                        0x1007: 'de-LU',
                        0x0416: 'pt',
                        0x0428: 'tg',
                        0x201A: 'bs-Cyrl',
                        0x0807: 'de-CH',
                        0x0816: 'pt-PT',
                        0x085F: 'tzm',
                        0x141A: 'bs',
                        0x0408: 'el',
                        0x0446: 'pa',
                        0x0449: 'ta',
                        0x047E: 'br',
                        0x046F: 'kl',
                        0x046B: 'qu-BO',
                        0x0444: 'tt',
                        0x0402: 'bg',
                        0x0447: 'gu',
                        0x086B: 'qu-EC',
                        0x044A: 'te',
                        0x0403: 'ca',
                        0x0468: 'ha',
                        0x0C6B: 'qu',
                        0x041E: 'th',
                        0x0C04: 'zh-HK',
                        0x040D: 'he',
                        0x0418: 'ro',
                        0x0451: 'bo',
                        0x1404: 'zh-MO',
                        0x0439: 'hi',
                        0x0417: 'rm',
                        0x041F: 'tr',
                        0x0804: 'zh',
                        0x040E: 'hu',
                        0x0419: 'ru',
                        0x0442: 'tk',
                        0x1004: 'zh-SG',
                        0x040F: 'is',
                        0x243B: 'smn',
                        0x0480: 'ug',
                        0x0404: 'zh-TW',
                        0x0470: 'ig',
                        0x103B: 'smj-NO',
                        0x0422: 'uk',
                        0x0483: 'co',
                        0x0421: 'id',
                        0x143B: 'smj',
                        0x042E: 'hsb',
                        0x041A: 'hr',
                        0x045D: 'iu',
                        0x0C3B: 'se-FI',
                        0x0420: 'ur',
                        0x101A: 'hr-BA',
                        0x085D: 'iu-Latn',
                        0x043B: 'se',
                        0x0843: 'uz-Cyrl',
                        0x0405: 'cs',
                        0x083C: 'ga',
                        0x083B: 'se-SE',
                        0x0443: 'uz',
                        0x0406: 'da',
                        0x0434: 'xh',
                        0x203B: 'sms',
                        0x042A: 'vi',
                        0x048C: 'prs',
                        0x0435: 'zu',
                        0x183B: 'sma-NO',
                        0x0452: 'cy',
                        0x0465: 'dv',
                        0x0410: 'it',
                        0x1C3B: 'sms',
                        0x0488: 'wo',
                        0x0813: 'nl-BE',
                        0x0810: 'it-CH',
                        0x044F: 'sa',
                        0x0485: 'sah',
                        0x0413: 'nl',
                        0x0411: 'ja',
                        0x1C1A: 'sr-Cyrl-BA',
                        0x0478: 'ii',
                        0x0C09: 'en-AU',
                        0x044B: 'kn',
                        0x0C1A: 'sr',
                        0x046A: 'yo',
                        0x2809: 'en-BZ',
                        0x043F: 'kk',
                        0x181A: 'sr-Latn-BA',
                        0x1009: 'en-CA',
                        0x0453: 'km',
                        0x081A: 'sr-Latn',
                        0x2409: 'en-029',
                        0x0486: 'quc',
                        0x046C: 'nso'
                    }
                ];
                var NameRecord = new r.Struct({
                    platformID: r.uint16,
                    encodingID: r.uint16,
                    languageID: r.uint16,
                    nameID: r.uint16,
                    length: r.uint16,
                    string: new r.Pointer(r.uint16, new r.String('length', function(t) {
                        return getEncoding(t.platformID, t.encodingID, t.languageID);
                    }), {
                        type: 'parent',
                        relativeTo: function relativeTo(ctx) {
                            return ctx.parent.stringOffset;
                        },
                        allowNull: false
                    })
                });
                var LangTagRecord = new r.Struct({
                    length: r.uint16,
                    tag: new r.Pointer(r.uint16, new r.String('length', 'utf16be'), {
                        type: 'parent',
                        relativeTo: function relativeTo(ctx) {
                            return ctx.stringOffset;
                        }
                    })
                });
                var NameTable = new r.VersionedStruct(r.uint16, {
                    0: {
                        count: r.uint16,
                        stringOffset: r.uint16,
                        records: new r.Array(NameRecord, 'count')
                    },
                    1: {
                        count: r.uint16,
                        stringOffset: r.uint16,
                        records: new r.Array(NameRecord, 'count'),
                        langTagCount: r.uint16,
                        langTags: new r.Array(LangTagRecord, 'langTagCount')
                    }
                });
                var NAMES = [
                    'copyright',
                    'fontFamily',
                    'fontSubfamily',
                    'uniqueSubfamily',
                    'fullName',
                    'version',
                    'postscriptName',
                    // Note: A font may have only one PostScript name and that name must be ASCII.
                    'trademark',
                    'manufacturer',
                    'designer',
                    'description',
                    'vendorURL',
                    'designerURL',
                    'license',
                    'licenseURL',
                    null,
                    // reserved
                    'preferredFamily',
                    'preferredSubfamily',
                    'compatibleFull',
                    'sampleText',
                    'postscriptCIDFontName',
                    'wwsFamilyName',
                    'wwsSubfamilyName'
                ];
                NameTable.process = function(stream) {
                    var records = {};
                    for(var _iterator = _createForOfIteratorHelperLoose(this.records), _step; !(_step = _iterator()).done;){
                        var record = _step.value;
                        // find out what language this is for
                        var language = LANGUAGES[record.platformID][record.languageID];
                        if (language == null && this.langTags != null && record.languageID >= 0x8000) language = this.langTags[record.languageID - 0x8000].tag;
                        if (language == null) language = record.platformID + '-' + record.languageID;
                         // if the nameID is >= 256, it is a font feature record (AAT)
                        var key = record.nameID >= 256 ? 'fontFeatures' : NAMES[record.nameID] || record.nameID;
                        if (records[key] == null) records[key] = {};
                        var obj = records[key];
                        if (record.nameID >= 256) obj = obj[record.nameID] || (obj[record.nameID] = {});
                        if (typeof record.string === 'string' || typeof obj[language] !== 'string') obj[language] = record.string;
                    }
                    this.records = records;
                };
                NameTable.preEncode = function() {
                    if (Array.isArray(this.records)) return;
                    this.version = 0;
                    var records = [];
                    for(var key in this.records){
                        var val = this.records[key];
                        if (key === 'fontFeatures') continue;
                        records.push({
                            platformID: 3,
                            encodingID: 1,
                            languageID: 0x409,
                            nameID: NAMES.indexOf(key),
                            length: Buffer.byteLength(val.en, 'utf16le'),
                            string: val.en
                        });
                        if (key === 'postscriptName') records.push({
                            platformID: 1,
                            encodingID: 0,
                            languageID: 0,
                            nameID: NAMES.indexOf(key),
                            length: val.en.length,
                            string: val.en
                        });
                    }
                    this.records = records;
                    this.count = records.length;
                    this.stringOffset = NameTable.size(this, null, false);
                };
                var OS2 = new r.VersionedStruct(r.uint16, {
                    header: {
                        xAvgCharWidth: r.int16,
                        // average weighted advance width of lower case letters and space
                        usWeightClass: r.uint16,
                        // visual weight of stroke in glyphs
                        usWidthClass: r.uint16,
                        // relative change from the normal aspect ratio (width to height ratio)
                        fsType: new r.Bitfield(r.uint16, [
                            // Indicates font embedding licensing rights
                            null,
                            'noEmbedding',
                            'viewOnly',
                            'editable',
                            null,
                            null,
                            null,
                            null,
                            'noSubsetting',
                            'bitmapOnly'
                        ]),
                        ySubscriptXSize: r.int16,
                        // recommended horizontal size in pixels for subscripts
                        ySubscriptYSize: r.int16,
                        // recommended vertical size in pixels for subscripts
                        ySubscriptXOffset: r.int16,
                        // recommended horizontal offset for subscripts
                        ySubscriptYOffset: r.int16,
                        // recommended vertical offset form the baseline for subscripts
                        ySuperscriptXSize: r.int16,
                        // recommended horizontal size in pixels for superscripts
                        ySuperscriptYSize: r.int16,
                        // recommended vertical size in pixels for superscripts
                        ySuperscriptXOffset: r.int16,
                        // recommended horizontal offset for superscripts
                        ySuperscriptYOffset: r.int16,
                        // recommended vertical offset from the baseline for superscripts
                        yStrikeoutSize: r.int16,
                        // width of the strikeout stroke
                        yStrikeoutPosition: r.int16,
                        // position of the strikeout stroke relative to the baseline
                        sFamilyClass: r.int16,
                        // classification of font-family design
                        panose: new r.Array(r.uint8, 10),
                        // describe the visual characteristics of a given typeface
                        ulCharRange: new r.Array(r.uint32, 4),
                        vendorID: new r.String(4),
                        // four character identifier for the font vendor
                        fsSelection: new r.Bitfield(r.uint16, [
                            // bit field containing information about the font
                            'italic',
                            'underscore',
                            'negative',
                            'outlined',
                            'strikeout',
                            'bold',
                            'regular',
                            'useTypoMetrics',
                            'wws',
                            'oblique'
                        ]),
                        usFirstCharIndex: r.uint16,
                        // The minimum Unicode index in this font
                        usLastCharIndex: r.uint16 // The maximum Unicode index in this font
                    },
                    // The Apple version of this table ends here, but the Microsoft one continues on...
                    0: {},
                    1: {
                        typoAscender: r.int16,
                        typoDescender: r.int16,
                        typoLineGap: r.int16,
                        winAscent: r.uint16,
                        winDescent: r.uint16,
                        codePageRange: new r.Array(r.uint32, 2)
                    },
                    2: {
                        // these should be common with version 1 somehow
                        typoAscender: r.int16,
                        typoDescender: r.int16,
                        typoLineGap: r.int16,
                        winAscent: r.uint16,
                        winDescent: r.uint16,
                        codePageRange: new r.Array(r.uint32, 2),
                        xHeight: r.int16,
                        capHeight: r.int16,
                        defaultChar: r.uint16,
                        breakChar: r.uint16,
                        maxContent: r.uint16
                    },
                    5: {
                        typoAscender: r.int16,
                        typoDescender: r.int16,
                        typoLineGap: r.int16,
                        winAscent: r.uint16,
                        winDescent: r.uint16,
                        codePageRange: new r.Array(r.uint32, 2),
                        xHeight: r.int16,
                        capHeight: r.int16,
                        defaultChar: r.uint16,
                        breakChar: r.uint16,
                        maxContent: r.uint16,
                        usLowerOpticalPointSize: r.uint16,
                        usUpperOpticalPointSize: r.uint16
                    }
                });
                var versions = OS2.versions;
                versions[3] = versions[4] = versions[2];
                var post = new r.VersionedStruct(r.fixed32, {
                    header: {
                        // these fields exist at the top of all versions
                        italicAngle: r.fixed32,
                        // Italic angle in counter-clockwise degrees from the vertical.
                        underlinePosition: r.int16,
                        // Suggested distance of the top of the underline from the baseline
                        underlineThickness: r.int16,
                        // Suggested values for the underline thickness
                        isFixedPitch: r.uint32,
                        // Whether the font is monospaced
                        minMemType42: r.uint32,
                        // Minimum memory usage when a TrueType font is downloaded as a Type 42 font
                        maxMemType42: r.uint32,
                        // Maximum memory usage when a TrueType font is downloaded as a Type 42 font
                        minMemType1: r.uint32,
                        // Minimum memory usage when a TrueType font is downloaded as a Type 1 font
                        maxMemType1: r.uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
                    },
                    1: {},
                    // version 1 has no additional fields
                    2: {
                        numberOfGlyphs: r.uint16,
                        glyphNameIndex: new r.Array(r.uint16, 'numberOfGlyphs'),
                        names: new r.Array(new r.String(r.uint8))
                    },
                    2.5: {
                        numberOfGlyphs: r.uint16,
                        offsets: new r.Array(r.uint8, 'numberOfGlyphs')
                    },
                    3: {},
                    // version 3 has no additional fields
                    4: {
                        map: new r.Array(r.uint32, function(t) {
                            return t.parent.maxp.numGlyphs;
                        })
                    }
                });
                var cvt = new r.Struct({
                    controlValues: new r.Array(r.int16)
                });
                // These instructions are known as the font program. The main use of this table
                // is for the definition of functions that are used in many different glyph programs.
                var fpgm = new r.Struct({
                    instructions: new r.Array(r.uint8)
                });
                var loca = new r.VersionedStruct('head.indexToLocFormat', {
                    0: {
                        offsets: new r.Array(r.uint16)
                    },
                    1: {
                        offsets: new r.Array(r.uint32)
                    }
                });
                loca.process = function() {
                    if (this.version === 0) for(var i = 0; i < this.offsets.length; i++)this.offsets[i] <<= 1;
                };
                loca.preEncode = function() {
                    if (this.version === 0) for(var i = 0; i < this.offsets.length; i++)this.offsets[i] >>>= 1;
                };
                var prep = new r.Struct({
                    controlValueProgram: new r.Array(r.uint8)
                });
                var glyf = new r.Array(new r.Buffer());
                var CFFIndex = /*#__PURE__*/ function() {
                    function CFFIndex(type) {
                        this.type = type;
                    }
                    var _proto = CFFIndex.prototype;
                    _proto.getCFFVersion = function getCFFVersion(ctx) {
                        while(ctx && !ctx.hdrSize)ctx = ctx.parent;
                        return ctx ? ctx.version : -1;
                    };
                    _proto.decode = function decode(stream, parent) {
                        var version = this.getCFFVersion(parent);
                        var count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
                        if (count === 0) return [];
                        var offSize = stream.readUInt8();
                        var offsetType;
                        if (offSize === 1) offsetType = r.uint8;
                        else if (offSize === 2) offsetType = r.uint16;
                        else if (offSize === 3) offsetType = r.uint24;
                        else if (offSize === 4) offsetType = r.uint32;
                        else throw new Error("Bad offset size in CFFIndex: ".concat(offSize, " ").concat(stream.pos));
                        var ret = [];
                        var startPos = stream.pos + (count + 1) * offSize - 1;
                        var start = offsetType.decode(stream);
                        for(var i = 0; i < count; i++){
                            var end = offsetType.decode(stream);
                            if (this.type != null) {
                                var pos = stream.pos;
                                stream.pos = startPos + start;
                                parent.length = end - start;
                                ret.push(this.type.decode(stream, parent));
                                stream.pos = pos;
                            } else ret.push({
                                offset: startPos + start,
                                length: end - start
                            });
                            start = end;
                        }
                        stream.pos = startPos + start;
                        return ret;
                    };
                    _proto.size = function size(arr, parent) {
                        var size = 2;
                        if (arr.length === 0) return size;
                        var type = this.type || new r.Buffer(); // find maximum offset to detminine offset type
                        var offset = 1;
                        for(var i = 0; i < arr.length; i++){
                            var item = arr[i];
                            offset += type.size(item, parent);
                        }
                        var offsetType;
                        if (offset <= 0xff) offsetType = r.uint8;
                        else if (offset <= 0xffff) offsetType = r.uint16;
                        else if (offset <= 0xffffff) offsetType = r.uint24;
                        else if (offset <= 0xffffffff) offsetType = r.uint32;
                        else throw new Error("Bad offset in CFFIndex");
                        size += 1 + offsetType.size() * (arr.length + 1);
                        size += offset - 1;
                        return size;
                    };
                    _proto.encode = function encode(stream, arr, parent) {
                        stream.writeUInt16BE(arr.length);
                        if (arr.length === 0) return;
                        var type = this.type || new r.Buffer(); // find maximum offset to detminine offset type
                        var sizes = [];
                        var offset = 1;
                        for(var _iterator2 = _createForOfIteratorHelperLoose(arr), _step2; !(_step2 = _iterator2()).done;){
                            var item = _step2.value;
                            var s = type.size(item, parent);
                            sizes.push(s);
                            offset += s;
                        }
                        var offsetType;
                        if (offset <= 0xff) offsetType = r.uint8;
                        else if (offset <= 0xffff) offsetType = r.uint16;
                        else if (offset <= 0xffffff) offsetType = r.uint24;
                        else if (offset <= 0xffffffff) offsetType = r.uint32;
                        else throw new Error("Bad offset in CFFIndex");
                         // write offset size
                        stream.writeUInt8(offsetType.size()); // write elements
                        offset = 1;
                        offsetType.encode(stream, offset);
                        for(var _i0 = 0, _sizes = sizes; _i0 < _sizes.length; _i0++){
                            var size = _sizes[_i0];
                            offset += size;
                            offsetType.encode(stream, offset);
                        }
                        for(var _iterator3 = _createForOfIteratorHelperLoose(arr), _step3; !(_step3 = _iterator3()).done;){
                            var _item = _step3.value;
                            type.encode(stream, _item, parent);
                        }
                        return;
                    };
                    return CFFIndex;
                }();
                var FLOAT_EOF = 0xf;
                var FLOAT_LOOKUP = [
                    '0',
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '.',
                    'E',
                    'E-',
                    null,
                    '-'
                ];
                var FLOAT_ENCODE_LOOKUP = {
                    '.': 10,
                    'E': 11,
                    'E-': 12,
                    '-': 14
                };
                var CFFOperand = /*#__PURE__*/ function() {
                    function CFFOperand() {}
                    CFFOperand.decode = function decode(stream, value) {
                        if (32 <= value && value <= 246) return value - 139;
                        if (247 <= value && value <= 250) return (value - 247) * 256 + stream.readUInt8() + 108;
                        if (251 <= value && value <= 254) return -(value - 251) * 256 - stream.readUInt8() - 108;
                        if (value === 28) return stream.readInt16BE();
                        if (value === 29) return stream.readInt32BE();
                        if (value === 30) {
                            var str = '';
                            while(true){
                                var b = stream.readUInt8();
                                var n1 = b >> 4;
                                if (n1 === FLOAT_EOF) break;
                                str += FLOAT_LOOKUP[n1];
                                var n2 = b & 15;
                                if (n2 === FLOAT_EOF) break;
                                str += FLOAT_LOOKUP[n2];
                            }
                            return parseFloat(str);
                        }
                        return null;
                    };
                    CFFOperand.size = function size(value) {
                        // if the value needs to be forced to the largest size (32 bit)
                        // e.g. for unknown pointers, set to 32768
                        if (value.forceLarge) value = 32768;
                        if ((value | 0) !== value) {
                            // floating point
                            var str = '' + value;
                            return 1 + Math.ceil((str.length + 1) / 2);
                        } else if (-107 <= value && value <= 107) return 1;
                        else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) return 2;
                        else if (-32768 <= value && value <= 32767) return 3;
                        else return 5;
                    };
                    CFFOperand.encode = function encode(stream, value) {
                        // if the value needs to be forced to the largest size (32 bit)
                        // e.g. for unknown pointers, save the old value and set to 32768
                        var val = Number(value);
                        if (value.forceLarge) {
                            stream.writeUInt8(29);
                            return stream.writeInt32BE(val);
                        } else if ((val | 0) !== val) {
                            // floating point
                            stream.writeUInt8(30);
                            var str = '' + val;
                            for(var i = 0; i < str.length; i += 2){
                                var c1 = str[i];
                                var n1 = FLOAT_ENCODE_LOOKUP[c1] || +c1;
                                if (i === str.length - 1) var n2 = FLOAT_EOF;
                                else {
                                    var c2 = str[i + 1];
                                    var n2 = FLOAT_ENCODE_LOOKUP[c2] || +c2;
                                }
                                stream.writeUInt8(n1 << 4 | n2 & 15);
                            }
                            if (n2 !== FLOAT_EOF) return stream.writeUInt8(FLOAT_EOF << 4);
                        } else if (-107 <= val && val <= 107) return stream.writeUInt8(val + 139);
                        else if (108 <= val && val <= 1131) {
                            val -= 108;
                            stream.writeUInt8((val >> 8) + 247);
                            return stream.writeUInt8(val & 0xff);
                        } else if (-1131 <= val && val <= -108) {
                            val = -val - 108;
                            stream.writeUInt8((val >> 8) + 251);
                            return stream.writeUInt8(val & 0xff);
                        } else if (-32768 <= val && val <= 32767) {
                            stream.writeUInt8(28);
                            return stream.writeInt16BE(val);
                        } else {
                            stream.writeUInt8(29);
                            return stream.writeInt32BE(val);
                        }
                    };
                    return CFFOperand;
                }();
                var CFFDict = /*#__PURE__*/ function() {
                    function CFFDict(ops) {
                        if (ops === void 0) ops = [];
                        this.ops = ops;
                        this.fields = {};
                        for(var _iterator4 = _createForOfIteratorHelperLoose(ops), _step4; !(_step4 = _iterator4()).done;){
                            var field = _step4.value;
                            var key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
                            this.fields[key] = field;
                        }
                    }
                    var _proto2 = CFFDict.prototype;
                    _proto2.decodeOperands = function decodeOperands(type, stream, ret, operands) {
                        var _this = this;
                        if (Array.isArray(type)) return operands.map(function(op, i) {
                            return _this.decodeOperands(type[i], stream, ret, [
                                op
                            ]);
                        });
                        else if (type.decode != null) return type.decode(stream, ret, operands);
                        else switch(type){
                            case 'number':
                            case 'offset':
                            case 'sid':
                                return operands[0];
                            case 'boolean':
                                return !!operands[0];
                            default:
                                return operands;
                        }
                    };
                    _proto2.encodeOperands = function encodeOperands(type, stream, ctx, operands) {
                        var _this2 = this;
                        if (Array.isArray(type)) return operands.map(function(op, i) {
                            return _this2.encodeOperands(type[i], stream, ctx, op)[0];
                        });
                        else if (type.encode != null) return type.encode(stream, operands, ctx);
                        else if (typeof operands === 'number') return [
                            operands
                        ];
                        else if (typeof operands === 'boolean') return [
                            +operands
                        ];
                        else if (Array.isArray(operands)) return operands;
                        else return [
                            operands
                        ];
                    };
                    _proto2.decode = function decode(stream, parent) {
                        var end = stream.pos + parent.length;
                        var ret = {};
                        var operands = []; // define hidden properties
                        Object.defineProperties(ret, {
                            parent: {
                                value: parent
                            },
                            _startOffset: {
                                value: stream.pos
                            }
                        }); // fill in defaults
                        for(var key in this.fields){
                            var field = this.fields[key];
                            ret[field[1]] = field[3];
                        }
                        while(stream.pos < end){
                            var b = stream.readUInt8();
                            if (b < 28) {
                                if (b === 12) b = b << 8 | stream.readUInt8();
                                var _field = this.fields[b];
                                if (!_field) throw new Error("Unknown operator ".concat(b));
                                var val = this.decodeOperands(_field[2], stream, ret, operands);
                                if (val != null) {
                                    if (val instanceof utils.PropertyDescriptor) Object.defineProperty(ret, _field[1], val);
                                    else ret[_field[1]] = val;
                                }
                                operands = [];
                            } else operands.push(CFFOperand.decode(stream, b));
                        }
                        return ret;
                    };
                    _proto2.size = function size(dict, parent, includePointers) {
                        if (includePointers === void 0) includePointers = true;
                        var ctx = {
                            parent: parent,
                            val: dict,
                            pointerSize: 0,
                            startOffset: parent.startOffset || 0
                        };
                        var len = 0;
                        for(var k in this.fields){
                            var field = this.fields[k];
                            var val = dict[field[1]];
                            if (val == null || isEqual(val, field[3])) continue;
                            var operands = this.encodeOperands(field[2], null, ctx, val);
                            for(var _iterator5 = _createForOfIteratorHelperLoose(operands), _step5; !(_step5 = _iterator5()).done;){
                                var op = _step5.value;
                                len += CFFOperand.size(op);
                            }
                            var key = Array.isArray(field[0]) ? field[0] : [
                                field[0]
                            ];
                            len += key.length;
                        }
                        if (includePointers) len += ctx.pointerSize;
                        return len;
                    };
                    _proto2.encode = function encode(stream, dict, parent) {
                        var ctx = {
                            pointers: [],
                            startOffset: stream.pos,
                            parent: parent,
                            val: dict,
                            pointerSize: 0
                        };
                        ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
                        for(var _iterator6 = _createForOfIteratorHelperLoose(this.ops), _step6; !(_step6 = _iterator6()).done;){
                            var field = _step6.value;
                            var val = dict[field[1]];
                            if (val == null || isEqual(val, field[3])) continue;
                            var operands = this.encodeOperands(field[2], stream, ctx, val);
                            for(var _iterator7 = _createForOfIteratorHelperLoose(operands), _step7; !(_step7 = _iterator7()).done;){
                                var op = _step7.value;
                                CFFOperand.encode(stream, op);
                            }
                            var key = Array.isArray(field[0]) ? field[0] : [
                                field[0]
                            ];
                            for(var _iterator8 = _createForOfIteratorHelperLoose(key), _step8; !(_step8 = _iterator8()).done;){
                                var _op = _step8.value;
                                stream.writeUInt8(_op);
                            }
                        }
                        var i = 0;
                        while(i < ctx.pointers.length){
                            var ptr = ctx.pointers[i++];
                            ptr.type.encode(stream, ptr.val, ptr.parent);
                        }
                        return;
                    };
                    return CFFDict;
                }();
                var CFFPointer = /*#__PURE__*/ function(_r$Pointer) {
                    function CFFPointer(type, options) {
                        if (options === void 0) options = {};
                        if (options.type == null) options.type = 'global';
                        return _r$Pointer.call(this, null, type, options) || this;
                    }
                    _inheritsLoose(CFFPointer, _r$Pointer);
                    var _proto3 = CFFPointer.prototype;
                    _proto3.decode = function decode(stream, parent, operands) {
                        this.offsetType = {
                            decode: function decode() {
                                return operands[0];
                            }
                        };
                        return _r$Pointer.prototype.decode.call(this, stream, parent, operands);
                    };
                    _proto3.encode = function encode(stream, value, ctx) {
                        if (!stream) {
                            // compute the size (so ctx.pointerSize is correct)
                            this.offsetType = {
                                size: function size() {
                                    return 0;
                                }
                            };
                            this.size(value, ctx);
                            return [
                                new Ptr(0)
                            ];
                        }
                        var ptr = null;
                        this.offsetType = {
                            encode: function encode(stream, val) {
                                return ptr = val;
                            }
                        };
                        _r$Pointer.prototype.encode.call(this, stream, value, ctx);
                        return [
                            new Ptr(ptr)
                        ];
                    };
                    return CFFPointer;
                }(r.Pointer);
                var Ptr = /*#__PURE__*/ function() {
                    function Ptr(val) {
                        this.val = val;
                        this.forceLarge = true;
                    }
                    var _proto4 = Ptr.prototype;
                    _proto4.valueOf = function valueOf() {
                        return this.val;
                    };
                    return Ptr;
                }();
                var CFFBlendOp = /*#__PURE__*/ function() {
                    function CFFBlendOp() {}
                    CFFBlendOp.decode = function decode(stream, parent, operands) {
                        var numBlends = operands.pop(); // TODO: actually blend. For now just consume the deltas
                        // since we don't use any of the values anyway.
                        while(operands.length > numBlends)operands.pop();
                    };
                    return CFFBlendOp;
                }();
                var CFFPrivateDict = new CFFDict([
                    // key       name                    type                                          default
                    [
                        6,
                        'BlueValues',
                        'delta',
                        null
                    ],
                    [
                        7,
                        'OtherBlues',
                        'delta',
                        null
                    ],
                    [
                        8,
                        'FamilyBlues',
                        'delta',
                        null
                    ],
                    [
                        9,
                        'FamilyOtherBlues',
                        'delta',
                        null
                    ],
                    [
                        [
                            12,
                            9
                        ],
                        'BlueScale',
                        'number',
                        0.039625
                    ],
                    [
                        [
                            12,
                            10
                        ],
                        'BlueShift',
                        'number',
                        7
                    ],
                    [
                        [
                            12,
                            11
                        ],
                        'BlueFuzz',
                        'number',
                        1
                    ],
                    [
                        10,
                        'StdHW',
                        'number',
                        null
                    ],
                    [
                        11,
                        'StdVW',
                        'number',
                        null
                    ],
                    [
                        [
                            12,
                            12
                        ],
                        'StemSnapH',
                        'delta',
                        null
                    ],
                    [
                        [
                            12,
                            13
                        ],
                        'StemSnapV',
                        'delta',
                        null
                    ],
                    [
                        [
                            12,
                            14
                        ],
                        'ForceBold',
                        'boolean',
                        false
                    ],
                    [
                        [
                            12,
                            17
                        ],
                        'LanguageGroup',
                        'number',
                        0
                    ],
                    [
                        [
                            12,
                            18
                        ],
                        'ExpansionFactor',
                        'number',
                        0.06
                    ],
                    [
                        [
                            12,
                            19
                        ],
                        'initialRandomSeed',
                        'number',
                        0
                    ],
                    [
                        20,
                        'defaultWidthX',
                        'number',
                        0
                    ],
                    [
                        21,
                        'nominalWidthX',
                        'number',
                        0
                    ],
                    [
                        22,
                        'vsindex',
                        'number',
                        0
                    ],
                    [
                        23,
                        'blend',
                        CFFBlendOp,
                        null
                    ],
                    [
                        19,
                        'Subrs',
                        new CFFPointer(new CFFIndex(), {
                            type: 'local'
                        }),
                        null
                    ]
                ]);
                // Automatically generated from Appendix A of the CFF specification; do
                // not edit. Length should be 391.
                var standardStrings = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall",
                    "001.000",
                    "001.001",
                    "001.002",
                    "001.003",
                    "Black",
                    "Bold",
                    "Book",
                    "Light",
                    "Medium",
                    "Regular",
                    "Roman",
                    "Semibold"
                ];
                var StandardEncoding = [
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    'space',
                    'exclam',
                    'quotedbl',
                    'numbersign',
                    'dollar',
                    'percent',
                    'ampersand',
                    'quoteright',
                    'parenleft',
                    'parenright',
                    'asterisk',
                    'plus',
                    'comma',
                    'hyphen',
                    'period',
                    'slash',
                    'zero',
                    'one',
                    'two',
                    'three',
                    'four',
                    'five',
                    'six',
                    'seven',
                    'eight',
                    'nine',
                    'colon',
                    'semicolon',
                    'less',
                    'equal',
                    'greater',
                    'question',
                    'at',
                    'A',
                    'B',
                    'C',
                    'D',
                    'E',
                    'F',
                    'G',
                    'H',
                    'I',
                    'J',
                    'K',
                    'L',
                    'M',
                    'N',
                    'O',
                    'P',
                    'Q',
                    'R',
                    'S',
                    'T',
                    'U',
                    'V',
                    'W',
                    'X',
                    'Y',
                    'Z',
                    'bracketleft',
                    'backslash',
                    'bracketright',
                    'asciicircum',
                    'underscore',
                    'quoteleft',
                    'a',
                    'b',
                    'c',
                    'd',
                    'e',
                    'f',
                    'g',
                    'h',
                    'i',
                    'j',
                    'k',
                    'l',
                    'm',
                    'n',
                    'o',
                    'p',
                    'q',
                    'r',
                    's',
                    't',
                    'u',
                    'v',
                    'w',
                    'x',
                    'y',
                    'z',
                    'braceleft',
                    'bar',
                    'braceright',
                    'asciitilde',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    'exclamdown',
                    'cent',
                    'sterling',
                    'fraction',
                    'yen',
                    'florin',
                    'section',
                    'currency',
                    'quotesingle',
                    'quotedblleft',
                    'guillemotleft',
                    'guilsinglleft',
                    'guilsinglright',
                    'fi',
                    'fl',
                    '',
                    'endash',
                    'dagger',
                    'daggerdbl',
                    'periodcentered',
                    '',
                    'paragraph',
                    'bullet',
                    'quotesinglbase',
                    'quotedblbase',
                    'quotedblright',
                    'guillemotright',
                    'ellipsis',
                    'perthousand',
                    '',
                    'questiondown',
                    '',
                    'grave',
                    'acute',
                    'circumflex',
                    'tilde',
                    'macron',
                    'breve',
                    'dotaccent',
                    'dieresis',
                    '',
                    'ring',
                    'cedilla',
                    '',
                    'hungarumlaut',
                    'ogonek',
                    'caron',
                    'emdash',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    'AE',
                    '',
                    'ordfeminine',
                    '',
                    '',
                    '',
                    '',
                    'Lslash',
                    'Oslash',
                    'OE',
                    'ordmasculine',
                    '',
                    '',
                    '',
                    '',
                    '',
                    'ae',
                    '',
                    '',
                    '',
                    'dotlessi',
                    '',
                    '',
                    'lslash',
                    'oslash',
                    'oe',
                    'germandbls'
                ];
                var ExpertEncoding = [
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    'space',
                    'exclamsmall',
                    'Hungarumlautsmall',
                    '',
                    'dollaroldstyle',
                    'dollarsuperior',
                    'ampersandsmall',
                    'Acutesmall',
                    'parenleftsuperior',
                    'parenrightsuperior',
                    'twodotenleader',
                    'onedotenleader',
                    'comma',
                    'hyphen',
                    'period',
                    'fraction',
                    'zerooldstyle',
                    'oneoldstyle',
                    'twooldstyle',
                    'threeoldstyle',
                    'fouroldstyle',
                    'fiveoldstyle',
                    'sixoldstyle',
                    'sevenoldstyle',
                    'eightoldstyle',
                    'nineoldstyle',
                    'colon',
                    'semicolon',
                    'commasuperior',
                    'threequartersemdash',
                    'periodsuperior',
                    'questionsmall',
                    '',
                    'asuperior',
                    'bsuperior',
                    'centsuperior',
                    'dsuperior',
                    'esuperior',
                    '',
                    '',
                    'isuperior',
                    '',
                    '',
                    'lsuperior',
                    'msuperior',
                    'nsuperior',
                    'osuperior',
                    '',
                    '',
                    'rsuperior',
                    'ssuperior',
                    'tsuperior',
                    '',
                    'ff',
                    'fi',
                    'fl',
                    'ffi',
                    'ffl',
                    'parenleftinferior',
                    '',
                    'parenrightinferior',
                    'Circumflexsmall',
                    'hyphensuperior',
                    'Gravesmall',
                    'Asmall',
                    'Bsmall',
                    'Csmall',
                    'Dsmall',
                    'Esmall',
                    'Fsmall',
                    'Gsmall',
                    'Hsmall',
                    'Ismall',
                    'Jsmall',
                    'Ksmall',
                    'Lsmall',
                    'Msmall',
                    'Nsmall',
                    'Osmall',
                    'Psmall',
                    'Qsmall',
                    'Rsmall',
                    'Ssmall',
                    'Tsmall',
                    'Usmall',
                    'Vsmall',
                    'Wsmall',
                    'Xsmall',
                    'Ysmall',
                    'Zsmall',
                    'colonmonetary',
                    'onefitted',
                    'rupiah',
                    'Tildesmall',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    'exclamdownsmall',
                    'centoldstyle',
                    'Lslashsmall',
                    '',
                    '',
                    'Scaronsmall',
                    'Zcaronsmall',
                    'Dieresissmall',
                    'Brevesmall',
                    'Caronsmall',
                    '',
                    'Dotaccentsmall',
                    '',
                    '',
                    'Macronsmall',
                    '',
                    '',
                    'figuredash',
                    'hypheninferior',
                    '',
                    '',
                    'Ogoneksmall',
                    'Ringsmall',
                    'Cedillasmall',
                    '',
                    '',
                    '',
                    'onequarter',
                    'onehalf',
                    'threequarters',
                    'questiondownsmall',
                    'oneeighth',
                    'threeeighths',
                    'fiveeighths',
                    'seveneighths',
                    'onethird',
                    'twothirds',
                    '',
                    '',
                    'zerosuperior',
                    'onesuperior',
                    'twosuperior',
                    'threesuperior',
                    'foursuperior',
                    'fivesuperior',
                    'sixsuperior',
                    'sevensuperior',
                    'eightsuperior',
                    'ninesuperior',
                    'zeroinferior',
                    'oneinferior',
                    'twoinferior',
                    'threeinferior',
                    'fourinferior',
                    'fiveinferior',
                    'sixinferior',
                    'seveninferior',
                    'eightinferior',
                    'nineinferior',
                    'centinferior',
                    'dollarinferior',
                    'periodinferior',
                    'commainferior',
                    'Agravesmall',
                    'Aacutesmall',
                    'Acircumflexsmall',
                    'Atildesmall',
                    'Adieresissmall',
                    'Aringsmall',
                    'AEsmall',
                    'Ccedillasmall',
                    'Egravesmall',
                    'Eacutesmall',
                    'Ecircumflexsmall',
                    'Edieresissmall',
                    'Igravesmall',
                    'Iacutesmall',
                    'Icircumflexsmall',
                    'Idieresissmall',
                    'Ethsmall',
                    'Ntildesmall',
                    'Ogravesmall',
                    'Oacutesmall',
                    'Ocircumflexsmall',
                    'Otildesmall',
                    'Odieresissmall',
                    'OEsmall',
                    'Oslashsmall',
                    'Ugravesmall',
                    'Uacutesmall',
                    'Ucircumflexsmall',
                    'Udieresissmall',
                    'Yacutesmall',
                    'Thornsmall',
                    'Ydieresissmall'
                ];
                var ISOAdobeCharset = [
                    '.notdef',
                    'space',
                    'exclam',
                    'quotedbl',
                    'numbersign',
                    'dollar',
                    'percent',
                    'ampersand',
                    'quoteright',
                    'parenleft',
                    'parenright',
                    'asterisk',
                    'plus',
                    'comma',
                    'hyphen',
                    'period',
                    'slash',
                    'zero',
                    'one',
                    'two',
                    'three',
                    'four',
                    'five',
                    'six',
                    'seven',
                    'eight',
                    'nine',
                    'colon',
                    'semicolon',
                    'less',
                    'equal',
                    'greater',
                    'question',
                    'at',
                    'A',
                    'B',
                    'C',
                    'D',
                    'E',
                    'F',
                    'G',
                    'H',
                    'I',
                    'J',
                    'K',
                    'L',
                    'M',
                    'N',
                    'O',
                    'P',
                    'Q',
                    'R',
                    'S',
                    'T',
                    'U',
                    'V',
                    'W',
                    'X',
                    'Y',
                    'Z',
                    'bracketleft',
                    'backslash',
                    'bracketright',
                    'asciicircum',
                    'underscore',
                    'quoteleft',
                    'a',
                    'b',
                    'c',
                    'd',
                    'e',
                    'f',
                    'g',
                    'h',
                    'i',
                    'j',
                    'k',
                    'l',
                    'm',
                    'n',
                    'o',
                    'p',
                    'q',
                    'r',
                    's',
                    't',
                    'u',
                    'v',
                    'w',
                    'x',
                    'y',
                    'z',
                    'braceleft',
                    'bar',
                    'braceright',
                    'asciitilde',
                    'exclamdown',
                    'cent',
                    'sterling',
                    'fraction',
                    'yen',
                    'florin',
                    'section',
                    'currency',
                    'quotesingle',
                    'quotedblleft',
                    'guillemotleft',
                    'guilsinglleft',
                    'guilsinglright',
                    'fi',
                    'fl',
                    'endash',
                    'dagger',
                    'daggerdbl',
                    'periodcentered',
                    'paragraph',
                    'bullet',
                    'quotesinglbase',
                    'quotedblbase',
                    'quotedblright',
                    'guillemotright',
                    'ellipsis',
                    'perthousand',
                    'questiondown',
                    'grave',
                    'acute',
                    'circumflex',
                    'tilde',
                    'macron',
                    'breve',
                    'dotaccent',
                    'dieresis',
                    'ring',
                    'cedilla',
                    'hungarumlaut',
                    'ogonek',
                    'caron',
                    'emdash',
                    'AE',
                    'ordfeminine',
                    'Lslash',
                    'Oslash',
                    'OE',
                    'ordmasculine',
                    'ae',
                    'dotlessi',
                    'lslash',
                    'oslash',
                    'oe',
                    'germandbls',
                    'onesuperior',
                    'logicalnot',
                    'mu',
                    'trademark',
                    'Eth',
                    'onehalf',
                    'plusminus',
                    'Thorn',
                    'onequarter',
                    'divide',
                    'brokenbar',
                    'degree',
                    'thorn',
                    'threequarters',
                    'twosuperior',
                    'registered',
                    'minus',
                    'eth',
                    'multiply',
                    'threesuperior',
                    'copyright',
                    'Aacute',
                    'Acircumflex',
                    'Adieresis',
                    'Agrave',
                    'Aring',
                    'Atilde',
                    'Ccedilla',
                    'Eacute',
                    'Ecircumflex',
                    'Edieresis',
                    'Egrave',
                    'Iacute',
                    'Icircumflex',
                    'Idieresis',
                    'Igrave',
                    'Ntilde',
                    'Oacute',
                    'Ocircumflex',
                    'Odieresis',
                    'Ograve',
                    'Otilde',
                    'Scaron',
                    'Uacute',
                    'Ucircumflex',
                    'Udieresis',
                    'Ugrave',
                    'Yacute',
                    'Ydieresis',
                    'Zcaron',
                    'aacute',
                    'acircumflex',
                    'adieresis',
                    'agrave',
                    'aring',
                    'atilde',
                    'ccedilla',
                    'eacute',
                    'ecircumflex',
                    'edieresis',
                    'egrave',
                    'iacute',
                    'icircumflex',
                    'idieresis',
                    'igrave',
                    'ntilde',
                    'oacute',
                    'ocircumflex',
                    'odieresis',
                    'ograve',
                    'otilde',
                    'scaron',
                    'uacute',
                    'ucircumflex',
                    'udieresis',
                    'ugrave',
                    'yacute',
                    'ydieresis',
                    'zcaron'
                ];
                var ExpertCharset = [
                    '.notdef',
                    'space',
                    'exclamsmall',
                    'Hungarumlautsmall',
                    'dollaroldstyle',
                    'dollarsuperior',
                    'ampersandsmall',
                    'Acutesmall',
                    'parenleftsuperior',
                    'parenrightsuperior',
                    'twodotenleader',
                    'onedotenleader',
                    'comma',
                    'hyphen',
                    'period',
                    'fraction',
                    'zerooldstyle',
                    'oneoldstyle',
                    'twooldstyle',
                    'threeoldstyle',
                    'fouroldstyle',
                    'fiveoldstyle',
                    'sixoldstyle',
                    'sevenoldstyle',
                    'eightoldstyle',
                    'nineoldstyle',
                    'colon',
                    'semicolon',
                    'commasuperior',
                    'threequartersemdash',
                    'periodsuperior',
                    'questionsmall',
                    'asuperior',
                    'bsuperior',
                    'centsuperior',
                    'dsuperior',
                    'esuperior',
                    'isuperior',
                    'lsuperior',
                    'msuperior',
                    'nsuperior',
                    'osuperior',
                    'rsuperior',
                    'ssuperior',
                    'tsuperior',
                    'ff',
                    'fi',
                    'fl',
                    'ffi',
                    'ffl',
                    'parenleftinferior',
                    'parenrightinferior',
                    'Circumflexsmall',
                    'hyphensuperior',
                    'Gravesmall',
                    'Asmall',
                    'Bsmall',
                    'Csmall',
                    'Dsmall',
                    'Esmall',
                    'Fsmall',
                    'Gsmall',
                    'Hsmall',
                    'Ismall',
                    'Jsmall',
                    'Ksmall',
                    'Lsmall',
                    'Msmall',
                    'Nsmall',
                    'Osmall',
                    'Psmall',
                    'Qsmall',
                    'Rsmall',
                    'Ssmall',
                    'Tsmall',
                    'Usmall',
                    'Vsmall',
                    'Wsmall',
                    'Xsmall',
                    'Ysmall',
                    'Zsmall',
                    'colonmonetary',
                    'onefitted',
                    'rupiah',
                    'Tildesmall',
                    'exclamdownsmall',
                    'centoldstyle',
                    'Lslashsmall',
                    'Scaronsmall',
                    'Zcaronsmall',
                    'Dieresissmall',
                    'Brevesmall',
                    'Caronsmall',
                    'Dotaccentsmall',
                    'Macronsmall',
                    'figuredash',
                    'hypheninferior',
                    'Ogoneksmall',
                    'Ringsmall',
                    'Cedillasmall',
                    'onequarter',
                    'onehalf',
                    'threequarters',
                    'questiondownsmall',
                    'oneeighth',
                    'threeeighths',
                    'fiveeighths',
                    'seveneighths',
                    'onethird',
                    'twothirds',
                    'zerosuperior',
                    'onesuperior',
                    'twosuperior',
                    'threesuperior',
                    'foursuperior',
                    'fivesuperior',
                    'sixsuperior',
                    'sevensuperior',
                    'eightsuperior',
                    'ninesuperior',
                    'zeroinferior',
                    'oneinferior',
                    'twoinferior',
                    'threeinferior',
                    'fourinferior',
                    'fiveinferior',
                    'sixinferior',
                    'seveninferior',
                    'eightinferior',
                    'nineinferior',
                    'centinferior',
                    'dollarinferior',
                    'periodinferior',
                    'commainferior',
                    'Agravesmall',
                    'Aacutesmall',
                    'Acircumflexsmall',
                    'Atildesmall',
                    'Adieresissmall',
                    'Aringsmall',
                    'AEsmall',
                    'Ccedillasmall',
                    'Egravesmall',
                    'Eacutesmall',
                    'Ecircumflexsmall',
                    'Edieresissmall',
                    'Igravesmall',
                    'Iacutesmall',
                    'Icircumflexsmall',
                    'Idieresissmall',
                    'Ethsmall',
                    'Ntildesmall',
                    'Ogravesmall',
                    'Oacutesmall',
                    'Ocircumflexsmall',
                    'Otildesmall',
                    'Odieresissmall',
                    'OEsmall',
                    'Oslashsmall',
                    'Ugravesmall',
                    'Uacutesmall',
                    'Ucircumflexsmall',
                    'Udieresissmall',
                    'Yacutesmall',
                    'Thornsmall',
                    'Ydieresissmall'
                ];
                var ExpertSubsetCharset = [
                    '.notdef',
                    'space',
                    'dollaroldstyle',
                    'dollarsuperior',
                    'parenleftsuperior',
                    'parenrightsuperior',
                    'twodotenleader',
                    'onedotenleader',
                    'comma',
                    'hyphen',
                    'period',
                    'fraction',
                    'zerooldstyle',
                    'oneoldstyle',
                    'twooldstyle',
                    'threeoldstyle',
                    'fouroldstyle',
                    'fiveoldstyle',
                    'sixoldstyle',
                    'sevenoldstyle',
                    'eightoldstyle',
                    'nineoldstyle',
                    'colon',
                    'semicolon',
                    'commasuperior',
                    'threequartersemdash',
                    'periodsuperior',
                    'asuperior',
                    'bsuperior',
                    'centsuperior',
                    'dsuperior',
                    'esuperior',
                    'isuperior',
                    'lsuperior',
                    'msuperior',
                    'nsuperior',
                    'osuperior',
                    'rsuperior',
                    'ssuperior',
                    'tsuperior',
                    'ff',
                    'fi',
                    'fl',
                    'ffi',
                    'ffl',
                    'parenleftinferior',
                    'parenrightinferior',
                    'hyphensuperior',
                    'colonmonetary',
                    'onefitted',
                    'rupiah',
                    'centoldstyle',
                    'figuredash',
                    'hypheninferior',
                    'onequarter',
                    'onehalf',
                    'threequarters',
                    'oneeighth',
                    'threeeighths',
                    'fiveeighths',
                    'seveneighths',
                    'onethird',
                    'twothirds',
                    'zerosuperior',
                    'onesuperior',
                    'twosuperior',
                    'threesuperior',
                    'foursuperior',
                    'fivesuperior',
                    'sixsuperior',
                    'sevensuperior',
                    'eightsuperior',
                    'ninesuperior',
                    'zeroinferior',
                    'oneinferior',
                    'twoinferior',
                    'threeinferior',
                    'fourinferior',
                    'fiveinferior',
                    'sixinferior',
                    'seveninferior',
                    'eightinferior',
                    'nineinferior',
                    'centinferior',
                    'dollarinferior',
                    'periodinferior',
                    'commainferior'
                ];
                // Scripts and Languages #
                //########################
                var LangSysTable = new r.Struct({
                    reserved: new r.Reserved(r.uint16),
                    reqFeatureIndex: r.uint16,
                    featureCount: r.uint16,
                    featureIndexes: new r.Array(r.uint16, 'featureCount')
                });
                var LangSysRecord = new r.Struct({
                    tag: new r.String(4),
                    langSys: new r.Pointer(r.uint16, LangSysTable, {
                        type: 'parent'
                    })
                });
                var Script = new r.Struct({
                    defaultLangSys: new r.Pointer(r.uint16, LangSysTable),
                    count: r.uint16,
                    langSysRecords: new r.Array(LangSysRecord, 'count')
                });
                var ScriptRecord = new r.Struct({
                    tag: new r.String(4),
                    script: new r.Pointer(r.uint16, Script, {
                        type: 'parent'
                    })
                });
                var ScriptList = new r.Array(ScriptRecord, r.uint16); //#######################
                // Features and Lookups #
                //#######################
                var Feature = new r.Struct({
                    featureParams: r.uint16,
                    // pointer
                    lookupCount: r.uint16,
                    lookupListIndexes: new r.Array(r.uint16, 'lookupCount')
                });
                var FeatureRecord = new r.Struct({
                    tag: new r.String(4),
                    feature: new r.Pointer(r.uint16, Feature, {
                        type: 'parent'
                    })
                });
                var FeatureList = new r.Array(FeatureRecord, r.uint16);
                var LookupFlags = new r.Struct({
                    markAttachmentType: r.uint8,
                    flags: new r.Bitfield(r.uint8, [
                        'rightToLeft',
                        'ignoreBaseGlyphs',
                        'ignoreLigatures',
                        'ignoreMarks',
                        'useMarkFilteringSet'
                    ])
                });
                function LookupList(SubTable) {
                    var Lookup = new r.Struct({
                        lookupType: r.uint16,
                        flags: LookupFlags,
                        subTableCount: r.uint16,
                        subTables: new r.Array(new r.Pointer(r.uint16, SubTable), 'subTableCount'),
                        markFilteringSet: new r.Optional(r.uint16, function(t) {
                            return t.flags.flags.useMarkFilteringSet;
                        })
                    });
                    return new r.LazyArray(new r.Pointer(r.uint16, Lookup), r.uint16);
                } //#################
                // Coverage Table #
                //#################
                var RangeRecord = new r.Struct({
                    start: r.uint16,
                    end: r.uint16,
                    startCoverageIndex: r.uint16
                });
                var Coverage = new r.VersionedStruct(r.uint16, {
                    1: {
                        glyphCount: r.uint16,
                        glyphs: new r.Array(r.uint16, 'glyphCount')
                    },
                    2: {
                        rangeCount: r.uint16,
                        rangeRecords: new r.Array(RangeRecord, 'rangeCount')
                    }
                }); //#########################
                // Class Definition Table #
                //#########################
                var ClassRangeRecord = new r.Struct({
                    start: r.uint16,
                    end: r.uint16,
                    class: r.uint16
                });
                var ClassDef = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Class array
                        startGlyph: r.uint16,
                        glyphCount: r.uint16,
                        classValueArray: new r.Array(r.uint16, 'glyphCount')
                    },
                    2: {
                        // Class ranges
                        classRangeCount: r.uint16,
                        classRangeRecord: new r.Array(ClassRangeRecord, 'classRangeCount')
                    }
                }); //###############
                // Device Table #
                //###############
                var Device = new r.Struct({
                    a: r.uint16,
                    // startSize for hinting Device, outerIndex for VariationIndex
                    b: r.uint16,
                    // endSize for Device, innerIndex for VariationIndex
                    deltaFormat: r.uint16
                }); //#############################################
                // Contextual Substitution/Positioning Tables #
                //#############################################
                var LookupRecord = new r.Struct({
                    sequenceIndex: r.uint16,
                    lookupListIndex: r.uint16
                });
                var Rule = new r.Struct({
                    glyphCount: r.uint16,
                    lookupCount: r.uint16,
                    input: new r.Array(r.uint16, function(t) {
                        return t.glyphCount - 1;
                    }),
                    lookupRecords: new r.Array(LookupRecord, 'lookupCount')
                });
                var RuleSet = new r.Array(new r.Pointer(r.uint16, Rule), r.uint16);
                var ClassRule = new r.Struct({
                    glyphCount: r.uint16,
                    lookupCount: r.uint16,
                    classes: new r.Array(r.uint16, function(t) {
                        return t.glyphCount - 1;
                    }),
                    lookupRecords: new r.Array(LookupRecord, 'lookupCount')
                });
                var ClassSet = new r.Array(new r.Pointer(r.uint16, ClassRule), r.uint16);
                var Context = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Simple context
                        coverage: new r.Pointer(r.uint16, Coverage),
                        ruleSetCount: r.uint16,
                        ruleSets: new r.Array(new r.Pointer(r.uint16, RuleSet), 'ruleSetCount')
                    },
                    2: {
                        // Class-based context
                        coverage: new r.Pointer(r.uint16, Coverage),
                        classDef: new r.Pointer(r.uint16, ClassDef),
                        classSetCnt: r.uint16,
                        classSet: new r.Array(new r.Pointer(r.uint16, ClassSet), 'classSetCnt')
                    },
                    3: {
                        glyphCount: r.uint16,
                        lookupCount: r.uint16,
                        coverages: new r.Array(new r.Pointer(r.uint16, Coverage), 'glyphCount'),
                        lookupRecords: new r.Array(LookupRecord, 'lookupCount')
                    }
                }); //######################################################
                // Chaining Contextual Substitution/Positioning Tables #
                //######################################################
                var ChainRule = new r.Struct({
                    backtrackGlyphCount: r.uint16,
                    backtrack: new r.Array(r.uint16, 'backtrackGlyphCount'),
                    inputGlyphCount: r.uint16,
                    input: new r.Array(r.uint16, function(t) {
                        return t.inputGlyphCount - 1;
                    }),
                    lookaheadGlyphCount: r.uint16,
                    lookahead: new r.Array(r.uint16, 'lookaheadGlyphCount'),
                    lookupCount: r.uint16,
                    lookupRecords: new r.Array(LookupRecord, 'lookupCount')
                });
                var ChainRuleSet = new r.Array(new r.Pointer(r.uint16, ChainRule), r.uint16);
                var ChainingContext = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Simple context glyph substitution
                        coverage: new r.Pointer(r.uint16, Coverage),
                        chainCount: r.uint16,
                        chainRuleSets: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount')
                    },
                    2: {
                        // Class-based chaining context
                        coverage: new r.Pointer(r.uint16, Coverage),
                        backtrackClassDef: new r.Pointer(r.uint16, ClassDef),
                        inputClassDef: new r.Pointer(r.uint16, ClassDef),
                        lookaheadClassDef: new r.Pointer(r.uint16, ClassDef),
                        chainCount: r.uint16,
                        chainClassSet: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount')
                    },
                    3: {
                        // Coverage-based chaining context
                        backtrackGlyphCount: r.uint16,
                        backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
                        inputGlyphCount: r.uint16,
                        inputCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'inputGlyphCount'),
                        lookaheadGlyphCount: r.uint16,
                        lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
                        lookupCount: r.uint16,
                        lookupRecords: new r.Array(LookupRecord, 'lookupCount')
                    }
                });
                /*******************
 * Variation Store *
 *******************/ var F2DOT14 = new r.Fixed(16, 'BE', 14);
                var RegionAxisCoordinates = new r.Struct({
                    startCoord: F2DOT14,
                    peakCoord: F2DOT14,
                    endCoord: F2DOT14
                });
                var VariationRegionList = new r.Struct({
                    axisCount: r.uint16,
                    regionCount: r.uint16,
                    variationRegions: new r.Array(new r.Array(RegionAxisCoordinates, 'axisCount'), 'regionCount')
                });
                var DeltaSet = new r.Struct({
                    shortDeltas: new r.Array(r.int16, function(t) {
                        return t.parent.shortDeltaCount;
                    }),
                    regionDeltas: new r.Array(r.int8, function(t) {
                        return t.parent.regionIndexCount - t.parent.shortDeltaCount;
                    }),
                    deltas: function deltas(t) {
                        return t.shortDeltas.concat(t.regionDeltas);
                    }
                });
                var ItemVariationData = new r.Struct({
                    itemCount: r.uint16,
                    shortDeltaCount: r.uint16,
                    regionIndexCount: r.uint16,
                    regionIndexes: new r.Array(r.uint16, 'regionIndexCount'),
                    deltaSets: new r.Array(DeltaSet, 'itemCount')
                });
                var ItemVariationStore = new r.Struct({
                    format: r.uint16,
                    variationRegionList: new r.Pointer(r.uint32, VariationRegionList),
                    variationDataCount: r.uint16,
                    itemVariationData: new r.Array(new r.Pointer(r.uint32, ItemVariationData), 'variationDataCount')
                });
                /**********************
 * Feature Variations *
 **********************/ var ConditionTable = new r.VersionedStruct(r.uint16, {
                    1: (_ = {
                        axisIndex: r.uint16
                    }, _["axisIndex"] = r.uint16, _.filterRangeMinValue = F2DOT14, _.filterRangeMaxValue = F2DOT14, _)
                });
                var ConditionSet = new r.Struct({
                    conditionCount: r.uint16,
                    conditionTable: new r.Array(new r.Pointer(r.uint32, ConditionTable), 'conditionCount')
                });
                var FeatureTableSubstitutionRecord = new r.Struct({
                    featureIndex: r.uint16,
                    alternateFeatureTable: new r.Pointer(r.uint32, Feature, {
                        type: 'parent'
                    })
                });
                var FeatureTableSubstitution = new r.Struct({
                    version: r.fixed32,
                    substitutionCount: r.uint16,
                    substitutions: new r.Array(FeatureTableSubstitutionRecord, 'substitutionCount')
                });
                var FeatureVariationRecord = new r.Struct({
                    conditionSet: new r.Pointer(r.uint32, ConditionSet, {
                        type: 'parent'
                    }),
                    featureTableSubstitution: new r.Pointer(r.uint32, FeatureTableSubstitution, {
                        type: 'parent'
                    })
                });
                var FeatureVariations = new r.Struct({
                    majorVersion: r.uint16,
                    minorVersion: r.uint16,
                    featureVariationRecordCount: r.uint32,
                    featureVariationRecords: new r.Array(FeatureVariationRecord, 'featureVariationRecordCount')
                });
                // otherwise delegates to the provided type.
                var PredefinedOp = /*#__PURE__*/ function() {
                    function PredefinedOp(predefinedOps, type) {
                        this.predefinedOps = predefinedOps;
                        this.type = type;
                    }
                    var _proto5 = PredefinedOp.prototype;
                    _proto5.decode = function decode(stream, parent, operands) {
                        if (this.predefinedOps[operands[0]]) return this.predefinedOps[operands[0]];
                        return this.type.decode(stream, parent, operands);
                    };
                    _proto5.size = function size(value, ctx) {
                        return this.type.size(value, ctx);
                    };
                    _proto5.encode = function encode(stream, value, ctx) {
                        var index = this.predefinedOps.indexOf(value);
                        if (index !== -1) return index;
                        return this.type.encode(stream, value, ctx);
                    };
                    return PredefinedOp;
                }();
                var CFFEncodingVersion = /*#__PURE__*/ function(_r$Number) {
                    function CFFEncodingVersion() {
                        return _r$Number.call(this, 'UInt8') || this;
                    }
                    _inheritsLoose(CFFEncodingVersion, _r$Number);
                    var _proto6 = CFFEncodingVersion.prototype;
                    _proto6.decode = function decode(stream) {
                        return r.uint8.decode(stream) & 0x7f;
                    };
                    return CFFEncodingVersion;
                }(r.Number);
                var Range1 = new r.Struct({
                    first: r.uint16,
                    nLeft: r.uint8
                });
                var Range2 = new r.Struct({
                    first: r.uint16,
                    nLeft: r.uint16
                });
                var CFFCustomEncoding = new r.VersionedStruct(new CFFEncodingVersion(), {
                    0: {
                        nCodes: r.uint8,
                        codes: new r.Array(r.uint8, 'nCodes')
                    },
                    1: {
                        nRanges: r.uint8,
                        ranges: new r.Array(Range1, 'nRanges')
                    } // TODO: supplement?
                });
                var CFFEncoding = new PredefinedOp([
                    StandardEncoding,
                    ExpertEncoding
                ], new CFFPointer(CFFCustomEncoding, {
                    lazy: true
                })); // Decodes an array of ranges until the total
                // length is equal to the provided length.
                var RangeArray = /*#__PURE__*/ function(_r$Array) {
                    function RangeArray() {
                        return _r$Array.apply(this, arguments) || this;
                    }
                    _inheritsLoose(RangeArray, _r$Array);
                    var _proto7 = RangeArray.prototype;
                    _proto7.decode = function decode(stream, parent) {
                        var length = utils.resolveLength(this.length, stream, parent);
                        var count = 0;
                        var res = [];
                        while(count < length){
                            var range = this.type.decode(stream, parent);
                            range.offset = count;
                            count += range.nLeft + 1;
                            res.push(range);
                        }
                        return res;
                    };
                    return RangeArray;
                }(r.Array);
                var CFFCustomCharset = new r.VersionedStruct(r.uint8, {
                    0: {
                        glyphs: new r.Array(r.uint16, function(t) {
                            return t.parent.CharStrings.length - 1;
                        })
                    },
                    1: {
                        ranges: new RangeArray(Range1, function(t) {
                            return t.parent.CharStrings.length - 1;
                        })
                    },
                    2: {
                        ranges: new RangeArray(Range2, function(t) {
                            return t.parent.CharStrings.length - 1;
                        })
                    }
                });
                var CFFCharset = new PredefinedOp([
                    ISOAdobeCharset,
                    ExpertCharset,
                    ExpertSubsetCharset
                ], new CFFPointer(CFFCustomCharset, {
                    lazy: true
                }));
                var FDRange3 = new r.Struct({
                    first: r.uint16,
                    fd: r.uint8
                });
                var FDRange4 = new r.Struct({
                    first: r.uint32,
                    fd: r.uint16
                });
                var FDSelect = new r.VersionedStruct(r.uint8, {
                    0: {
                        fds: new r.Array(r.uint8, function(t) {
                            return t.parent.CharStrings.length;
                        })
                    },
                    3: {
                        nRanges: r.uint16,
                        ranges: new r.Array(FDRange3, 'nRanges'),
                        sentinel: r.uint16
                    },
                    4: {
                        nRanges: r.uint32,
                        ranges: new r.Array(FDRange4, 'nRanges'),
                        sentinel: r.uint32
                    }
                });
                var ptr = new CFFPointer(CFFPrivateDict);
                var CFFPrivateOp = /*#__PURE__*/ function() {
                    function CFFPrivateOp() {}
                    var _proto8 = CFFPrivateOp.prototype;
                    _proto8.decode = function decode(stream, parent, operands) {
                        parent.length = operands[0];
                        return ptr.decode(stream, parent, [
                            operands[1]
                        ]);
                    };
                    _proto8.size = function size(dict, ctx) {
                        return [
                            CFFPrivateDict.size(dict, ctx, false),
                            ptr.size(dict, ctx)[0]
                        ];
                    };
                    _proto8.encode = function encode(stream, dict, ctx) {
                        return [
                            CFFPrivateDict.size(dict, ctx, false),
                            ptr.encode(stream, dict, ctx)[0]
                        ];
                    };
                    return CFFPrivateOp;
                }();
                var FontDict = new CFFDict([
                    // key       name                   type(s)                                 default
                    [
                        18,
                        'Private',
                        new CFFPrivateOp(),
                        null
                    ],
                    [
                        [
                            12,
                            38
                        ],
                        'FontName',
                        'sid',
                        null
                    ],
                    [
                        [
                            12,
                            7
                        ],
                        'FontMatrix',
                        'array',
                        [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]
                    ],
                    [
                        [
                            12,
                            5
                        ],
                        'PaintType',
                        'number',
                        0
                    ]
                ]);
                var CFFTopDict = new CFFDict([
                    // key       name                   type(s)                                 default
                    [
                        [
                            12,
                            30
                        ],
                        'ROS',
                        [
                            'sid',
                            'sid',
                            'number'
                        ],
                        null
                    ],
                    [
                        0,
                        'version',
                        'sid',
                        null
                    ],
                    [
                        1,
                        'Notice',
                        'sid',
                        null
                    ],
                    [
                        [
                            12,
                            0
                        ],
                        'Copyright',
                        'sid',
                        null
                    ],
                    [
                        2,
                        'FullName',
                        'sid',
                        null
                    ],
                    [
                        3,
                        'FamilyName',
                        'sid',
                        null
                    ],
                    [
                        4,
                        'Weight',
                        'sid',
                        null
                    ],
                    [
                        [
                            12,
                            1
                        ],
                        'isFixedPitch',
                        'boolean',
                        false
                    ],
                    [
                        [
                            12,
                            2
                        ],
                        'ItalicAngle',
                        'number',
                        0
                    ],
                    [
                        [
                            12,
                            3
                        ],
                        'UnderlinePosition',
                        'number',
                        -100
                    ],
                    [
                        [
                            12,
                            4
                        ],
                        'UnderlineThickness',
                        'number',
                        50
                    ],
                    [
                        [
                            12,
                            5
                        ],
                        'PaintType',
                        'number',
                        0
                    ],
                    [
                        [
                            12,
                            6
                        ],
                        'CharstringType',
                        'number',
                        2
                    ],
                    [
                        [
                            12,
                            7
                        ],
                        'FontMatrix',
                        'array',
                        [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]
                    ],
                    [
                        13,
                        'UniqueID',
                        'number',
                        null
                    ],
                    [
                        5,
                        'FontBBox',
                        'array',
                        [
                            0,
                            0,
                            0,
                            0
                        ]
                    ],
                    [
                        [
                            12,
                            8
                        ],
                        'StrokeWidth',
                        'number',
                        0
                    ],
                    [
                        14,
                        'XUID',
                        'array',
                        null
                    ],
                    [
                        15,
                        'charset',
                        CFFCharset,
                        ISOAdobeCharset
                    ],
                    [
                        16,
                        'Encoding',
                        CFFEncoding,
                        StandardEncoding
                    ],
                    [
                        17,
                        'CharStrings',
                        new CFFPointer(new CFFIndex()),
                        null
                    ],
                    [
                        18,
                        'Private',
                        new CFFPrivateOp(),
                        null
                    ],
                    [
                        [
                            12,
                            20
                        ],
                        'SyntheticBase',
                        'number',
                        null
                    ],
                    [
                        [
                            12,
                            21
                        ],
                        'PostScript',
                        'sid',
                        null
                    ],
                    [
                        [
                            12,
                            22
                        ],
                        'BaseFontName',
                        'sid',
                        null
                    ],
                    [
                        [
                            12,
                            23
                        ],
                        'BaseFontBlend',
                        'delta',
                        null
                    ],
                    // CID font specific
                    [
                        [
                            12,
                            31
                        ],
                        'CIDFontVersion',
                        'number',
                        0
                    ],
                    [
                        [
                            12,
                            32
                        ],
                        'CIDFontRevision',
                        'number',
                        0
                    ],
                    [
                        [
                            12,
                            33
                        ],
                        'CIDFontType',
                        'number',
                        0
                    ],
                    [
                        [
                            12,
                            34
                        ],
                        'CIDCount',
                        'number',
                        8720
                    ],
                    [
                        [
                            12,
                            35
                        ],
                        'UIDBase',
                        'number',
                        null
                    ],
                    [
                        [
                            12,
                            37
                        ],
                        'FDSelect',
                        new CFFPointer(FDSelect),
                        null
                    ],
                    [
                        [
                            12,
                            36
                        ],
                        'FDArray',
                        new CFFPointer(new CFFIndex(FontDict)),
                        null
                    ],
                    [
                        [
                            12,
                            38
                        ],
                        'FontName',
                        'sid',
                        null
                    ]
                ]);
                var VariationStore = new r.Struct({
                    length: r.uint16,
                    itemVariationStore: ItemVariationStore
                });
                var CFF2TopDict = new CFFDict([
                    [
                        [
                            12,
                            7
                        ],
                        'FontMatrix',
                        'array',
                        [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]
                    ],
                    [
                        17,
                        'CharStrings',
                        new CFFPointer(new CFFIndex()),
                        null
                    ],
                    [
                        [
                            12,
                            37
                        ],
                        'FDSelect',
                        new CFFPointer(FDSelect),
                        null
                    ],
                    [
                        [
                            12,
                            36
                        ],
                        'FDArray',
                        new CFFPointer(new CFFIndex(FontDict)),
                        null
                    ],
                    [
                        24,
                        'vstore',
                        new CFFPointer(VariationStore),
                        null
                    ],
                    [
                        25,
                        'maxstack',
                        'number',
                        193
                    ]
                ]);
                var CFFTop = new r.VersionedStruct(r.fixed16, {
                    1: {
                        hdrSize: r.uint8,
                        offSize: r.uint8,
                        nameIndex: new CFFIndex(new r.String('length')),
                        topDictIndex: new CFFIndex(CFFTopDict),
                        stringIndex: new CFFIndex(new r.String('length')),
                        globalSubrIndex: new CFFIndex()
                    },
                    2: {
                        hdrSize: r.uint8,
                        length: r.uint16,
                        topDict: CFF2TopDict,
                        globalSubrIndex: new CFFIndex()
                    }
                });
                var CFFFont = /*#__PURE__*/ function() {
                    function CFFFont(stream) {
                        this.stream = stream;
                        this.decode();
                    }
                    CFFFont.decode = function decode(stream) {
                        return new CFFFont(stream);
                    };
                    var _proto9 = CFFFont.prototype;
                    _proto9.decode = function decode() {
                        var start = this.stream.pos;
                        var top = CFFTop.decode(this.stream);
                        for(var key in top){
                            var val = top[key];
                            this[key] = val;
                        }
                        if (this.version < 2) {
                            if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
                            this.topDict = this.topDictIndex[0];
                        }
                        this.isCIDFont = this.topDict.ROS != null;
                        return this;
                    };
                    _proto9.string = function string(sid) {
                        if (this.version >= 2) return null;
                        if (sid < standardStrings.length) return standardStrings[sid];
                        return this.stringIndex[sid - standardStrings.length];
                    };
                    _proto9.getCharString = function getCharString(glyph) {
                        this.stream.pos = this.topDict.CharStrings[glyph].offset;
                        return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
                    };
                    _proto9.getGlyphName = function getGlyphName(gid) {
                        // CFF2 glyph names are in the post table.
                        if (this.version >= 2) return null;
                         // CID-keyed fonts don't have glyph names
                        if (this.isCIDFont) return null;
                        var charset = this.topDict.charset;
                        if (Array.isArray(charset)) return charset[gid];
                        if (gid === 0) return '.notdef';
                        gid -= 1;
                        switch(charset.version){
                            case 0:
                                return this.string(charset.glyphs[gid]);
                            case 1:
                            case 2:
                                for(var i = 0; i < charset.ranges.length; i++){
                                    var range = charset.ranges[i];
                                    if (range.offset <= gid && gid <= range.offset + range.nLeft) return this.string(range.first + (gid - range.offset));
                                }
                                break;
                        }
                        return null;
                    };
                    _proto9.fdForGlyph = function fdForGlyph(gid) {
                        if (!this.topDict.FDSelect) return null;
                        switch(this.topDict.FDSelect.version){
                            case 0:
                                return this.topDict.FDSelect.fds[gid];
                            case 3:
                            case 4:
                                var ranges = this.topDict.FDSelect.ranges;
                                var low = 0;
                                var high = ranges.length - 1;
                                while(low <= high){
                                    var mid = low + high >> 1;
                                    if (gid < ranges[mid].first) high = mid - 1;
                                    else if (mid < high && gid >= ranges[mid + 1].first) low = mid + 1;
                                    else return ranges[mid].fd;
                                }
                            default:
                                throw new Error("Unknown FDSelect version: ".concat(this.topDict.FDSelect.version));
                        }
                    };
                    _proto9.privateDictForGlyph = function privateDictForGlyph(gid) {
                        if (this.topDict.FDSelect) {
                            var fd = this.fdForGlyph(gid);
                            if (this.topDict.FDArray[fd]) return this.topDict.FDArray[fd].Private;
                            return null;
                        }
                        if (this.version < 2) return this.topDict.Private;
                        return this.topDict.FDArray[0].Private;
                    };
                    return _createClass(CFFFont, [
                        {
                            key: "postscriptName",
                            get: function get() {
                                if (this.version < 2) return this.nameIndex[0];
                                return null;
                            }
                        },
                        {
                            key: "fullName",
                            get: function get() {
                                return this.string(this.topDict.FullName);
                            }
                        },
                        {
                            key: "familyName",
                            get: function get() {
                                return this.string(this.topDict.FamilyName);
                            }
                        }
                    ]);
                }();
                var VerticalOrigin = new r.Struct({
                    glyphIndex: r.uint16,
                    vertOriginY: r.int16
                });
                var VORG = new r.Struct({
                    majorVersion: r.uint16,
                    minorVersion: r.uint16,
                    defaultVertOriginY: r.int16,
                    numVertOriginYMetrics: r.uint16,
                    metrics: new r.Array(VerticalOrigin, 'numVertOriginYMetrics')
                });
                var BigMetrics = new r.Struct({
                    height: r.uint8,
                    width: r.uint8,
                    horiBearingX: r.int8,
                    horiBearingY: r.int8,
                    horiAdvance: r.uint8,
                    vertBearingX: r.int8,
                    vertBearingY: r.int8,
                    vertAdvance: r.uint8
                });
                var SmallMetrics = new r.Struct({
                    height: r.uint8,
                    width: r.uint8,
                    bearingX: r.int8,
                    bearingY: r.int8,
                    advance: r.uint8
                });
                var EBDTComponent = new r.Struct({
                    glyph: r.uint16,
                    xOffset: r.int8,
                    yOffset: r.int8
                });
                var ByteAligned = function ByteAligned() {};
                var BitAligned = function BitAligned() {};
                var glyph = new r.VersionedStruct('version', {
                    1: {
                        metrics: SmallMetrics,
                        data: ByteAligned
                    },
                    2: {
                        metrics: SmallMetrics,
                        data: BitAligned
                    },
                    // format 3 is deprecated
                    // format 4 is not supported by Microsoft
                    5: {
                        data: BitAligned
                    },
                    6: {
                        metrics: BigMetrics,
                        data: ByteAligned
                    },
                    7: {
                        metrics: BigMetrics,
                        data: BitAligned
                    },
                    8: {
                        metrics: SmallMetrics,
                        pad: new r.Reserved(r.uint8),
                        numComponents: r.uint16,
                        components: new r.Array(EBDTComponent, 'numComponents')
                    },
                    9: {
                        metrics: BigMetrics,
                        pad: new r.Reserved(r.uint8),
                        numComponents: r.uint16,
                        components: new r.Array(EBDTComponent, 'numComponents')
                    },
                    17: {
                        metrics: SmallMetrics,
                        dataLen: r.uint32,
                        data: new r.Buffer('dataLen')
                    },
                    18: {
                        metrics: BigMetrics,
                        dataLen: r.uint32,
                        data: new r.Buffer('dataLen')
                    },
                    19: {
                        dataLen: r.uint32,
                        data: new r.Buffer('dataLen')
                    }
                });
                var SBitLineMetrics = new r.Struct({
                    ascender: r.int8,
                    descender: r.int8,
                    widthMax: r.uint8,
                    caretSlopeNumerator: r.int8,
                    caretSlopeDenominator: r.int8,
                    caretOffset: r.int8,
                    minOriginSB: r.int8,
                    minAdvanceSB: r.int8,
                    maxBeforeBL: r.int8,
                    minAfterBL: r.int8,
                    pad: new r.Reserved(r.int8, 2)
                });
                var CodeOffsetPair = new r.Struct({
                    glyphCode: r.uint16,
                    offset: r.uint16
                });
                var IndexSubtable = new r.VersionedStruct(r.uint16, {
                    header: {
                        imageFormat: r.uint16,
                        imageDataOffset: r.uint32
                    },
                    1: {
                        offsetArray: new r.Array(r.uint32, function(t) {
                            return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
                        })
                    },
                    2: {
                        imageSize: r.uint32,
                        bigMetrics: BigMetrics
                    },
                    3: {
                        offsetArray: new r.Array(r.uint16, function(t) {
                            return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
                        })
                    },
                    4: {
                        numGlyphs: r.uint32,
                        glyphArray: new r.Array(CodeOffsetPair, function(t) {
                            return t.numGlyphs + 1;
                        })
                    },
                    5: {
                        imageSize: r.uint32,
                        bigMetrics: BigMetrics,
                        numGlyphs: r.uint32,
                        glyphCodeArray: new r.Array(r.uint16, 'numGlyphs')
                    }
                });
                var IndexSubtableArray = new r.Struct({
                    firstGlyphIndex: r.uint16,
                    lastGlyphIndex: r.uint16,
                    subtable: new r.Pointer(r.uint32, IndexSubtable)
                });
                var BitmapSizeTable = new r.Struct({
                    indexSubTableArray: new r.Pointer(r.uint32, new r.Array(IndexSubtableArray, 1), {
                        type: 'parent'
                    }),
                    indexTablesSize: r.uint32,
                    numberOfIndexSubTables: r.uint32,
                    colorRef: r.uint32,
                    hori: SBitLineMetrics,
                    vert: SBitLineMetrics,
                    startGlyphIndex: r.uint16,
                    endGlyphIndex: r.uint16,
                    ppemX: r.uint8,
                    ppemY: r.uint8,
                    bitDepth: r.uint8,
                    flags: new r.Bitfield(r.uint8, [
                        'horizontal',
                        'vertical'
                    ])
                });
                var EBLC = new r.Struct({
                    version: r.uint32,
                    // 0x00020000
                    numSizes: r.uint32,
                    sizes: new r.Array(BitmapSizeTable, 'numSizes')
                });
                var ImageTable = new r.Struct({
                    ppem: r.uint16,
                    resolution: r.uint16,
                    imageOffsets: new r.Array(new r.Pointer(r.uint32, 'void'), function(t) {
                        return t.parent.parent.maxp.numGlyphs + 1;
                    })
                }); // This is the Apple sbix table, used by the "Apple Color Emoji" font.
                // It includes several image tables with images for each bitmap glyph
                // of several different sizes.
                var sbix = new r.Struct({
                    version: r.uint16,
                    flags: new r.Bitfield(r.uint16, [
                        'renderOutlines'
                    ]),
                    numImgTables: r.uint32,
                    imageTables: new r.Array(new r.Pointer(r.uint32, ImageTable), 'numImgTables')
                });
                var LayerRecord = new r.Struct({
                    gid: r.uint16,
                    // Glyph ID of layer glyph (must be in z-order from bottom to top).
                    paletteIndex: r.uint16 // Index value to use in the appropriate palette. This value must
                }); // be less than numPaletteEntries in the CPAL table, except for
                // the special case noted below. Each palette entry is 16 bits.
                // A palette index of 0xFFFF is a special case indicating that
                // the text foreground color should be used.
                var BaseGlyphRecord = new r.Struct({
                    gid: r.uint16,
                    // Glyph ID of reference glyph. This glyph is for reference only
                    // and is not rendered for color.
                    firstLayerIndex: r.uint16,
                    // Index (from beginning of the Layer Records) to the layer record.
                    // There will be numLayers consecutive entries for this base glyph.
                    numLayers: r.uint16
                });
                var COLR = new r.Struct({
                    version: r.uint16,
                    numBaseGlyphRecords: r.uint16,
                    baseGlyphRecord: new r.Pointer(r.uint32, new r.Array(BaseGlyphRecord, 'numBaseGlyphRecords')),
                    layerRecords: new r.Pointer(r.uint32, new r.Array(LayerRecord, 'numLayerRecords'), {
                        lazy: true
                    }),
                    numLayerRecords: r.uint16
                });
                var ColorRecord = new r.Struct({
                    blue: r.uint8,
                    green: r.uint8,
                    red: r.uint8,
                    alpha: r.uint8
                });
                var CPAL = new r.VersionedStruct(r.uint16, {
                    header: {
                        numPaletteEntries: r.uint16,
                        numPalettes: r.uint16,
                        numColorRecords: r.uint16,
                        colorRecords: new r.Pointer(r.uint32, new r.Array(ColorRecord, 'numColorRecords')),
                        colorRecordIndices: new r.Array(r.uint16, 'numPalettes')
                    },
                    0: {},
                    1: {
                        offsetPaletteTypeArray: new r.Pointer(r.uint32, new r.Array(r.uint32, 'numPalettes')),
                        offsetPaletteLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPalettes')),
                        offsetPaletteEntryLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPaletteEntries'))
                    }
                });
                var BaseCoord = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Design units only
                        coordinate: r.int16 // X or Y value, in design units
                    },
                    2: {
                        // Design units plus contour point
                        coordinate: r.int16,
                        // X or Y value, in design units
                        referenceGlyph: r.uint16,
                        // GlyphID of control glyph
                        baseCoordPoint: r.uint16 // Index of contour point on the referenceGlyph
                    },
                    3: {
                        // Design units plus Device table
                        coordinate: r.int16,
                        // X or Y value, in design units
                        deviceTable: new r.Pointer(r.uint16, Device) // Device table for X or Y value
                    }
                });
                var BaseValues = new r.Struct({
                    defaultIndex: r.uint16,
                    // Index of default baseline for this script-same index in the BaseTagList
                    baseCoordCount: r.uint16,
                    baseCoords: new r.Array(new r.Pointer(r.uint16, BaseCoord), 'baseCoordCount')
                });
                var FeatMinMaxRecord = new r.Struct({
                    tag: new r.String(4),
                    // 4-byte feature identification tag-must match FeatureTag in FeatureList
                    minCoord: new r.Pointer(r.uint16, BaseCoord, {
                        type: 'parent'
                    }),
                    // May be NULL
                    maxCoord: new r.Pointer(r.uint16, BaseCoord, {
                        type: 'parent'
                    }) // May be NULL
                });
                var MinMax = new r.Struct({
                    minCoord: new r.Pointer(r.uint16, BaseCoord),
                    // May be NULL
                    maxCoord: new r.Pointer(r.uint16, BaseCoord),
                    // May be NULL
                    featMinMaxCount: r.uint16,
                    // May be 0
                    featMinMaxRecords: new r.Array(FeatMinMaxRecord, 'featMinMaxCount') // In alphabetical order
                });
                var BaseLangSysRecord = new r.Struct({
                    tag: new r.String(4),
                    // 4-byte language system identification tag
                    minMax: new r.Pointer(r.uint16, MinMax, {
                        type: 'parent'
                    })
                });
                var BaseScript = new r.Struct({
                    baseValues: new r.Pointer(r.uint16, BaseValues),
                    // May be NULL
                    defaultMinMax: new r.Pointer(r.uint16, MinMax),
                    // May be NULL
                    baseLangSysCount: r.uint16,
                    // May be 0
                    baseLangSysRecords: new r.Array(BaseLangSysRecord, 'baseLangSysCount') // in alphabetical order by BaseLangSysTag
                });
                var BaseScriptRecord = new r.Struct({
                    tag: new r.String(4),
                    // 4-byte script identification tag
                    script: new r.Pointer(r.uint16, BaseScript, {
                        type: 'parent'
                    })
                });
                var BaseScriptList = new r.Array(BaseScriptRecord, r.uint16); // Array of 4-byte baseline identification tags-must be in alphabetical order
                var BaseTagList = new r.Array(new r.String(4), r.uint16);
                var Axis = new r.Struct({
                    baseTagList: new r.Pointer(r.uint16, BaseTagList),
                    // May be NULL
                    baseScriptList: new r.Pointer(r.uint16, BaseScriptList)
                });
                var BASE = new r.VersionedStruct(r.uint32, {
                    header: {
                        horizAxis: new r.Pointer(r.uint16, Axis),
                        // May be NULL
                        vertAxis: new r.Pointer(r.uint16, Axis) // May be NULL
                    },
                    0x00010000: {},
                    0x00010001: {
                        itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
                    }
                });
                var AttachPoint = new r.Array(r.uint16, r.uint16);
                var AttachList = new r.Struct({
                    coverage: new r.Pointer(r.uint16, Coverage),
                    glyphCount: r.uint16,
                    attachPoints: new r.Array(new r.Pointer(r.uint16, AttachPoint), 'glyphCount')
                });
                var CaretValue = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Design units only
                        coordinate: r.int16
                    },
                    2: {
                        // Contour point
                        caretValuePoint: r.uint16
                    },
                    3: {
                        // Design units plus Device table
                        coordinate: r.int16,
                        deviceTable: new r.Pointer(r.uint16, Device)
                    }
                });
                var LigGlyph = new r.Array(new r.Pointer(r.uint16, CaretValue), r.uint16);
                var LigCaretList = new r.Struct({
                    coverage: new r.Pointer(r.uint16, Coverage),
                    ligGlyphCount: r.uint16,
                    ligGlyphs: new r.Array(new r.Pointer(r.uint16, LigGlyph), 'ligGlyphCount')
                });
                var MarkGlyphSetsDef = new r.Struct({
                    markSetTableFormat: r.uint16,
                    markSetCount: r.uint16,
                    coverage: new r.Array(new r.Pointer(r.uint32, Coverage), 'markSetCount')
                });
                var GDEF = new r.VersionedStruct(r.uint32, {
                    header: {
                        glyphClassDef: new r.Pointer(r.uint16, ClassDef),
                        attachList: new r.Pointer(r.uint16, AttachList),
                        ligCaretList: new r.Pointer(r.uint16, LigCaretList),
                        markAttachClassDef: new r.Pointer(r.uint16, ClassDef)
                    },
                    0x00010000: {},
                    0x00010002: {
                        markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef)
                    },
                    0x00010003: {
                        markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef),
                        itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
                    }
                });
                var ValueFormat = new r.Bitfield(r.uint16, [
                    'xPlacement',
                    'yPlacement',
                    'xAdvance',
                    'yAdvance',
                    'xPlaDevice',
                    'yPlaDevice',
                    'xAdvDevice',
                    'yAdvDevice'
                ]);
                var types = {
                    xPlacement: r.int16,
                    yPlacement: r.int16,
                    xAdvance: r.int16,
                    yAdvance: r.int16,
                    xPlaDevice: new r.Pointer(r.uint16, Device, {
                        type: 'global',
                        relativeTo: function relativeTo(ctx) {
                            return ctx.rel;
                        }
                    }),
                    yPlaDevice: new r.Pointer(r.uint16, Device, {
                        type: 'global',
                        relativeTo: function relativeTo(ctx) {
                            return ctx.rel;
                        }
                    }),
                    xAdvDevice: new r.Pointer(r.uint16, Device, {
                        type: 'global',
                        relativeTo: function relativeTo(ctx) {
                            return ctx.rel;
                        }
                    }),
                    yAdvDevice: new r.Pointer(r.uint16, Device, {
                        type: 'global',
                        relativeTo: function relativeTo(ctx) {
                            return ctx.rel;
                        }
                    })
                };
                var ValueRecord = /*#__PURE__*/ function() {
                    function ValueRecord(key) {
                        if (key === void 0) key = 'valueFormat';
                        this.key = key;
                    }
                    var _proto0 = ValueRecord.prototype;
                    _proto0.buildStruct = function buildStruct(parent) {
                        var struct = parent;
                        while(!struct[this.key] && struct.parent)struct = struct.parent;
                        if (!struct[this.key]) return;
                        var fields = {};
                        fields.rel = function() {
                            return struct._startOffset;
                        };
                        var format = struct[this.key];
                        for(var key in format)if (format[key]) fields[key] = types[key];
                        return new r.Struct(fields);
                    };
                    _proto0.size = function size(val, ctx) {
                        return this.buildStruct(ctx).size(val, ctx);
                    };
                    _proto0.decode = function decode(stream, parent) {
                        var res = this.buildStruct(parent).decode(stream, parent);
                        delete res.rel;
                        return res;
                    };
                    return ValueRecord;
                }();
                var PairValueRecord = new r.Struct({
                    secondGlyph: r.uint16,
                    value1: new ValueRecord('valueFormat1'),
                    value2: new ValueRecord('valueFormat2')
                });
                var PairSet = new r.Array(PairValueRecord, r.uint16);
                var Class2Record = new r.Struct({
                    value1: new ValueRecord('valueFormat1'),
                    value2: new ValueRecord('valueFormat2')
                });
                var Anchor = new r.VersionedStruct(r.uint16, {
                    1: {
                        // Design units only
                        xCoordinate: r.int16,
                        yCoordinate: r.int16
                    },
                    2: {
                        // Design units plus contour point
                        xCoordinate: r.int16,
                        yCoordinate: r.int16,
                        anchorPoint: r.uint16
                    },
                    3: {
                        // Design units plus Device tables
                        xCoordinate: r.int16,
                        yCoordinate: r.int16,
                        xDeviceTable: new r.Pointer(r.uint16, Device),
                        yDeviceTable: new r.Pointer(r.uint16, Device)
                    }
                });
                var EntryExitRecord = new r.Struct({
                    entryAnchor: new r.Pointer(r.uint16, Anchor, {
                        type: 'parent'
                    }),
                    exitAnchor: new r.Pointer(r.uint16, Anchor, {
                        type: 'parent'
                    })
                });
                var MarkRecord = new r.Struct({
                    class: r.uint16,
                    markAnchor: new r.Pointer(r.uint16, Anchor, {
                        type: 'parent'
                    })
                });
                var MarkArray = new r.Array(MarkRecord, r.uint16);
                var BaseRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function(t) {
                    return t.parent.classCount;
                });
                var BaseArray = new r.Array(BaseRecord, r.uint16);
                var ComponentRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function(t) {
                    return t.parent.parent.classCount;
                });
                var LigatureAttach = new r.Array(ComponentRecord, r.uint16);
                var LigatureArray = new r.Array(new r.Pointer(r.uint16, LigatureAttach), r.uint16);
                var GPOSLookup = new r.VersionedStruct('lookupType', {
                    1: new r.VersionedStruct(r.uint16, {
                        // Single Adjustment
                        1: {
                            // Single positioning value
                            coverage: new r.Pointer(r.uint16, Coverage),
                            valueFormat: ValueFormat,
                            value: new ValueRecord()
                        },
                        2: {
                            coverage: new r.Pointer(r.uint16, Coverage),
                            valueFormat: ValueFormat,
                            valueCount: r.uint16,
                            values: new r.LazyArray(new ValueRecord(), 'valueCount')
                        }
                    }),
                    2: new r.VersionedStruct(r.uint16, {
                        // Pair Adjustment Positioning
                        1: {
                            // Adjustments for glyph pairs
                            coverage: new r.Pointer(r.uint16, Coverage),
                            valueFormat1: ValueFormat,
                            valueFormat2: ValueFormat,
                            pairSetCount: r.uint16,
                            pairSets: new r.LazyArray(new r.Pointer(r.uint16, PairSet), 'pairSetCount')
                        },
                        2: {
                            // Class pair adjustment
                            coverage: new r.Pointer(r.uint16, Coverage),
                            valueFormat1: ValueFormat,
                            valueFormat2: ValueFormat,
                            classDef1: new r.Pointer(r.uint16, ClassDef),
                            classDef2: new r.Pointer(r.uint16, ClassDef),
                            class1Count: r.uint16,
                            class2Count: r.uint16,
                            classRecords: new r.LazyArray(new r.LazyArray(Class2Record, 'class2Count'), 'class1Count')
                        }
                    }),
                    3: {
                        // Cursive Attachment Positioning
                        format: r.uint16,
                        coverage: new r.Pointer(r.uint16, Coverage),
                        entryExitCount: r.uint16,
                        entryExitRecords: new r.Array(EntryExitRecord, 'entryExitCount')
                    },
                    4: {
                        // MarkToBase Attachment Positioning
                        format: r.uint16,
                        markCoverage: new r.Pointer(r.uint16, Coverage),
                        baseCoverage: new r.Pointer(r.uint16, Coverage),
                        classCount: r.uint16,
                        markArray: new r.Pointer(r.uint16, MarkArray),
                        baseArray: new r.Pointer(r.uint16, BaseArray)
                    },
                    5: {
                        // MarkToLigature Attachment Positioning
                        format: r.uint16,
                        markCoverage: new r.Pointer(r.uint16, Coverage),
                        ligatureCoverage: new r.Pointer(r.uint16, Coverage),
                        classCount: r.uint16,
                        markArray: new r.Pointer(r.uint16, MarkArray),
                        ligatureArray: new r.Pointer(r.uint16, LigatureArray)
                    },
                    6: {
                        // MarkToMark Attachment Positioning
                        format: r.uint16,
                        mark1Coverage: new r.Pointer(r.uint16, Coverage),
                        mark2Coverage: new r.Pointer(r.uint16, Coverage),
                        classCount: r.uint16,
                        mark1Array: new r.Pointer(r.uint16, MarkArray),
                        mark2Array: new r.Pointer(r.uint16, BaseArray)
                    },
                    7: Context,
                    // Contextual positioning
                    8: ChainingContext,
                    // Chaining contextual positioning
                    9: {
                        // Extension Positioning
                        posFormat: r.uint16,
                        lookupType: r.uint16,
                        // cannot also be 9
                        extension: new r.Pointer(r.uint32, GPOSLookup)
                    }
                }); // Fix circular reference
                GPOSLookup.versions[9].extension.type = GPOSLookup;
                var GPOS = new r.VersionedStruct(r.uint32, {
                    header: {
                        scriptList: new r.Pointer(r.uint16, ScriptList),
                        featureList: new r.Pointer(r.uint16, FeatureList),
                        lookupList: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
                    },
                    0x00010000: {},
                    0x00010001: {
                        featureVariations: new r.Pointer(r.uint32, FeatureVariations)
                    }
                }); // export GPOSLookup for JSTF table
                var Sequence = new r.Array(r.uint16, r.uint16);
                var AlternateSet = Sequence;
                var Ligature = new r.Struct({
                    glyph: r.uint16,
                    compCount: r.uint16,
                    components: new r.Array(r.uint16, function(t) {
                        return t.compCount - 1;
                    })
                });
                var LigatureSet = new r.Array(new r.Pointer(r.uint16, Ligature), r.uint16);
                var GSUBLookup = new r.VersionedStruct('lookupType', {
                    1: new r.VersionedStruct(r.uint16, {
                        // Single Substitution
                        1: {
                            coverage: new r.Pointer(r.uint16, Coverage),
                            deltaGlyphID: r.int16
                        },
                        2: {
                            coverage: new r.Pointer(r.uint16, Coverage),
                            glyphCount: r.uint16,
                            substitute: new r.LazyArray(r.uint16, 'glyphCount')
                        }
                    }),
                    2: {
                        // Multiple Substitution
                        substFormat: r.uint16,
                        coverage: new r.Pointer(r.uint16, Coverage),
                        count: r.uint16,
                        sequences: new r.LazyArray(new r.Pointer(r.uint16, Sequence), 'count')
                    },
                    3: {
                        // Alternate Substitution
                        substFormat: r.uint16,
                        coverage: new r.Pointer(r.uint16, Coverage),
                        count: r.uint16,
                        alternateSet: new r.LazyArray(new r.Pointer(r.uint16, AlternateSet), 'count')
                    },
                    4: {
                        // Ligature Substitution
                        substFormat: r.uint16,
                        coverage: new r.Pointer(r.uint16, Coverage),
                        count: r.uint16,
                        ligatureSets: new r.LazyArray(new r.Pointer(r.uint16, LigatureSet), 'count')
                    },
                    5: Context,
                    // Contextual Substitution
                    6: ChainingContext,
                    // Chaining Contextual Substitution
                    7: {
                        // Extension Substitution
                        substFormat: r.uint16,
                        lookupType: r.uint16,
                        // cannot also be 7
                        extension: new r.Pointer(r.uint32, GSUBLookup)
                    },
                    8: {
                        // Reverse Chaining Contextual Single Substitution
                        substFormat: r.uint16,
                        coverage: new r.Pointer(r.uint16, Coverage),
                        backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
                        lookaheadGlyphCount: r.uint16,
                        lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
                        glyphCount: r.uint16,
                        substitutes: new r.Array(r.uint16, 'glyphCount')
                    }
                }); // Fix circular reference
                GSUBLookup.versions[7].extension.type = GSUBLookup;
                var GSUB = new r.VersionedStruct(r.uint32, {
                    header: {
                        scriptList: new r.Pointer(r.uint16, ScriptList),
                        featureList: new r.Pointer(r.uint16, FeatureList),
                        lookupList: new r.Pointer(r.uint16, new LookupList(GSUBLookup))
                    },
                    0x00010000: {},
                    0x00010001: {
                        featureVariations: new r.Pointer(r.uint32, FeatureVariations)
                    }
                });
                var JstfGSUBModList = new r.Array(r.uint16, r.uint16);
                var JstfPriority = new r.Struct({
                    shrinkageEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                    shrinkageDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                    shrinkageEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                    shrinkageDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                    shrinkageJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup)),
                    extensionEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                    extensionDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                    extensionEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                    extensionDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                    extensionJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
                });
                var JstfLangSys = new r.Array(new r.Pointer(r.uint16, JstfPriority), r.uint16);
                var JstfLangSysRecord = new r.Struct({
                    tag: new r.String(4),
                    jstfLangSys: new r.Pointer(r.uint16, JstfLangSys)
                });
                var JstfScript = new r.Struct({
                    extenderGlyphs: new r.Pointer(r.uint16, new r.Array(r.uint16, r.uint16)),
                    // array of glyphs to extend line length
                    defaultLangSys: new r.Pointer(r.uint16, JstfLangSys),
                    langSysCount: r.uint16,
                    langSysRecords: new r.Array(JstfLangSysRecord, 'langSysCount')
                });
                var JstfScriptRecord = new r.Struct({
                    tag: new r.String(4),
                    script: new r.Pointer(r.uint16, JstfScript, {
                        type: 'parent'
                    })
                });
                var JSTF = new r.Struct({
                    version: r.uint32,
                    // should be 0x00010000
                    scriptCount: r.uint16,
                    scriptList: new r.Array(JstfScriptRecord, 'scriptCount')
                });
                var VariableSizeNumber = /*#__PURE__*/ function() {
                    function VariableSizeNumber(size) {
                        this._size = size;
                    }
                    var _proto1 = VariableSizeNumber.prototype;
                    _proto1.decode = function decode(stream, parent) {
                        switch(this.size(0, parent)){
                            case 1:
                                return stream.readUInt8();
                            case 2:
                                return stream.readUInt16BE();
                            case 3:
                                return stream.readUInt24BE();
                            case 4:
                                return stream.readUInt32BE();
                        }
                    };
                    _proto1.size = function size(val, parent) {
                        return utils.resolveLength(this._size, null, parent);
                    };
                    return VariableSizeNumber;
                }();
                var MapDataEntry = new r.Struct({
                    entry: new VariableSizeNumber(function(t) {
                        return ((t.parent.entryFormat & 0x0030) >> 4) + 1;
                    }),
                    outerIndex: function outerIndex(t) {
                        return t.entry >> (t.parent.entryFormat & 0x000F) + 1;
                    },
                    innerIndex: function innerIndex(t) {
                        return t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1;
                    }
                });
                var DeltaSetIndexMap = new r.Struct({
                    entryFormat: r.uint16,
                    mapCount: r.uint16,
                    mapData: new r.Array(MapDataEntry, 'mapCount')
                });
                var HVAR = new r.Struct({
                    majorVersion: r.uint16,
                    minorVersion: r.uint16,
                    itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore),
                    advanceWidthMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
                    LSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
                    RSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap)
                });
                var Signature = new r.Struct({
                    format: r.uint32,
                    length: r.uint32,
                    offset: r.uint32
                });
                var SignatureBlock = new r.Struct({
                    reserved: new r.Reserved(r.uint16, 2),
                    cbSignature: r.uint32,
                    // Length (in bytes) of the PKCS#7 packet in pbSignature
                    signature: new r.Buffer('cbSignature')
                });
                var DSIG = new r.Struct({
                    ulVersion: r.uint32,
                    // Version number of the DSIG table (0x00000001)
                    usNumSigs: r.uint16,
                    // Number of signatures in the table
                    usFlag: r.uint16,
                    // Permission flags
                    signatures: new r.Array(Signature, 'usNumSigs'),
                    signatureBlocks: new r.Array(SignatureBlock, 'usNumSigs')
                });
                var GaspRange = new r.Struct({
                    rangeMaxPPEM: r.uint16,
                    // Upper limit of range, in ppem
                    rangeGaspBehavior: new r.Bitfield(r.uint16, [
                        // Flags describing desired rasterizer behavior
                        'grayscale',
                        'gridfit',
                        'symmetricSmoothing',
                        'symmetricGridfit' // only in version 1, for ClearType
                    ])
                });
                var gasp = new r.Struct({
                    version: r.uint16,
                    // set to 0
                    numRanges: r.uint16,
                    gaspRanges: new r.Array(GaspRange, 'numRanges') // Sorted by ppem
                });
                var DeviceRecord = new r.Struct({
                    pixelSize: r.uint8,
                    maximumWidth: r.uint8,
                    widths: new r.Array(r.uint8, function(t) {
                        return t.parent.parent.maxp.numGlyphs;
                    })
                }); // The Horizontal Device Metrics table stores integer advance widths scaled to particular pixel sizes
                var hdmx = new r.Struct({
                    version: r.uint16,
                    numRecords: r.int16,
                    sizeDeviceRecord: r.int32,
                    records: new r.Array(DeviceRecord, 'numRecords')
                });
                var KernPair = new r.Struct({
                    left: r.uint16,
                    right: r.uint16,
                    value: r.int16
                });
                var ClassTable = new r.Struct({
                    firstGlyph: r.uint16,
                    nGlyphs: r.uint16,
                    offsets: new r.Array(r.uint16, 'nGlyphs'),
                    max: function max(t) {
                        return t.offsets.length && Math.max.apply(Math, t.offsets);
                    }
                });
                var Kern2Array = new r.Struct({
                    off: function off(t) {
                        return t._startOffset - t.parent.parent._startOffset;
                    },
                    len: function len(t) {
                        return ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2);
                    },
                    values: new r.LazyArray(r.int16, 'len')
                });
                var KernSubtable = new r.VersionedStruct('format', {
                    0: {
                        nPairs: r.uint16,
                        searchRange: r.uint16,
                        entrySelector: r.uint16,
                        rangeShift: r.uint16,
                        pairs: new r.Array(KernPair, 'nPairs')
                    },
                    2: {
                        rowWidth: r.uint16,
                        leftTable: new r.Pointer(r.uint16, ClassTable, {
                            type: 'parent'
                        }),
                        rightTable: new r.Pointer(r.uint16, ClassTable, {
                            type: 'parent'
                        }),
                        array: new r.Pointer(r.uint16, Kern2Array, {
                            type: 'parent'
                        })
                    },
                    3: {
                        glyphCount: r.uint16,
                        kernValueCount: r.uint8,
                        leftClassCount: r.uint8,
                        rightClassCount: r.uint8,
                        flags: r.uint8,
                        kernValue: new r.Array(r.int16, 'kernValueCount'),
                        leftClass: new r.Array(r.uint8, 'glyphCount'),
                        rightClass: new r.Array(r.uint8, 'glyphCount'),
                        kernIndex: new r.Array(r.uint8, function(t) {
                            return t.leftClassCount * t.rightClassCount;
                        })
                    }
                });
                var KernTable = new r.VersionedStruct('version', {
                    0: {
                        // Microsoft uses this format
                        subVersion: r.uint16,
                        // Microsoft has an extra sub-table version number
                        length: r.uint16,
                        // Length of the subtable, in bytes
                        format: r.uint8,
                        // Format of subtable
                        coverage: new r.Bitfield(r.uint8, [
                            'horizontal',
                            // 1 if table has horizontal data, 0 if vertical
                            'minimum',
                            // If set to 1, the table has minimum values. If set to 0, the table has kerning values.
                            'crossStream',
                            // If set to 1, kerning is perpendicular to the flow of the text
                            'override' // If set to 1 the value in this table replaces the accumulated value
                        ]),
                        subtable: KernSubtable,
                        padding: new r.Reserved(r.uint8, function(t) {
                            return t.length - t._currentOffset;
                        })
                    },
                    1: {
                        // Apple uses this format
                        length: r.uint32,
                        coverage: new r.Bitfield(r.uint8, [
                            null,
                            null,
                            null,
                            null,
                            null,
                            'variation',
                            // Set if table has variation kerning values
                            'crossStream',
                            // Set if table has cross-stream kerning values
                            'vertical' // Set if table has vertical kerning values
                        ]),
                        format: r.uint8,
                        tupleIndex: r.uint16,
                        subtable: KernSubtable,
                        padding: new r.Reserved(r.uint8, function(t) {
                            return t.length - t._currentOffset;
                        })
                    }
                });
                var kern = new r.VersionedStruct(r.uint16, {
                    0: {
                        // Microsoft Version
                        nTables: r.uint16,
                        tables: new r.Array(KernTable, 'nTables')
                    },
                    1: {
                        // Apple Version
                        reserved: new r.Reserved(r.uint16),
                        // the other half of the version number
                        nTables: r.uint32,
                        tables: new r.Array(KernTable, 'nTables')
                    }
                });
                // Records the ppem for each glyph at which the scaling becomes linear again,
                // despite instructions effecting the advance width
                var LTSH = new r.Struct({
                    version: r.uint16,
                    numGlyphs: r.uint16,
                    yPels: new r.Array(r.uint8, 'numGlyphs')
                });
                // NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
                var PCLT = new r.Struct({
                    version: r.uint16,
                    fontNumber: r.uint32,
                    pitch: r.uint16,
                    xHeight: r.uint16,
                    style: r.uint16,
                    typeFamily: r.uint16,
                    capHeight: r.uint16,
                    symbolSet: r.uint16,
                    typeface: new r.String(16),
                    characterComplement: new r.String(8),
                    fileName: new r.String(6),
                    strokeWeight: new r.String(1),
                    widthType: new r.String(1),
                    serifStyle: r.uint8,
                    reserved: new r.Reserved(r.uint8)
                });
                // sizes. This is needed in order to match font metrics on Windows.
                var Ratio = new r.Struct({
                    bCharSet: r.uint8,
                    // Character set
                    xRatio: r.uint8,
                    // Value to use for x-Ratio
                    yStartRatio: r.uint8,
                    // Starting y-Ratio value
                    yEndRatio: r.uint8 // Ending y-Ratio value
                });
                var vTable = new r.Struct({
                    yPelHeight: r.uint16,
                    // yPelHeight to which values apply
                    yMax: r.int16,
                    // Maximum value (in pels) for this yPelHeight
                    yMin: r.int16 // Minimum value (in pels) for this yPelHeight
                });
                var VdmxGroup = new r.Struct({
                    recs: r.uint16,
                    // Number of height records in this group
                    startsz: r.uint8,
                    // Starting yPelHeight
                    endsz: r.uint8,
                    // Ending yPelHeight
                    entries: new r.Array(vTable, 'recs') // The VDMX records
                });
                var VDMX = new r.Struct({
                    version: r.uint16,
                    // Version number (0 or 1)
                    numRecs: r.uint16,
                    // Number of VDMX groups present
                    numRatios: r.uint16,
                    // Number of aspect ratio groupings
                    ratioRanges: new r.Array(Ratio, 'numRatios'),
                    // Ratio ranges
                    offsets: new r.Array(r.uint16, 'numRatios'),
                    // Offset to the VDMX group for this ratio range
                    groups: new r.Array(VdmxGroup, 'numRecs') // The actual VDMX groupings
                });
                var vhea = new r.Struct({
                    version: r.uint16,
                    // Version number of the Vertical Header Table
                    ascent: r.int16,
                    // The vertical typographic ascender for this font
                    descent: r.int16,
                    // The vertical typographic descender for this font
                    lineGap: r.int16,
                    // The vertical typographic line gap for this font
                    advanceHeightMax: r.int16,
                    // The maximum advance height measurement found in the font
                    minTopSideBearing: r.int16,
                    // The minimum top side bearing measurement found in the font
                    minBottomSideBearing: r.int16,
                    // The minimum bottom side bearing measurement found in the font
                    yMaxExtent: r.int16,
                    caretSlopeRise: r.int16,
                    // Caret slope (rise/run)
                    caretSlopeRun: r.int16,
                    caretOffset: r.int16,
                    // Set value equal to 0 for nonslanted fonts
                    reserved: new r.Reserved(r.int16, 4),
                    metricDataFormat: r.int16,
                    // Set to 0
                    numberOfMetrics: r.uint16 // Number of advance heights in the Vertical Metrics table
                });
                var VmtxEntry = new r.Struct({
                    advance: r.uint16,
                    // The advance height of the glyph
                    bearing: r.int16 // The top sidebearing of the glyph
                }); // Vertical Metrics Table
                var vmtx = new r.Struct({
                    metrics: new r.LazyArray(VmtxEntry, function(t) {
                        return t.parent.vhea.numberOfMetrics;
                    }),
                    bearings: new r.LazyArray(r.int16, function(t) {
                        return t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics;
                    })
                });
                var shortFrac = new r.Fixed(16, 'BE', 14);
                var Correspondence = new r.Struct({
                    fromCoord: shortFrac,
                    toCoord: shortFrac
                });
                var Segment = new r.Struct({
                    pairCount: r.uint16,
                    correspondence: new r.Array(Correspondence, 'pairCount')
                });
                var avar = new r.Struct({
                    version: r.fixed32,
                    axisCount: r.uint32,
                    segment: new r.Array(Segment, 'axisCount')
                });
                var UnboundedArrayAccessor = /*#__PURE__*/ function() {
                    function UnboundedArrayAccessor(type, stream, parent) {
                        this.type = type;
                        this.stream = stream;
                        this.parent = parent;
                        this.base = this.stream.pos;
                        this._items = [];
                    }
                    var _proto10 = UnboundedArrayAccessor.prototype;
                    _proto10.getItem = function getItem(index) {
                        if (this._items[index] == null) {
                            var pos = this.stream.pos;
                            this.stream.pos = this.base + this.type.size(null, this.parent) * index;
                            this._items[index] = this.type.decode(this.stream, this.parent);
                            this.stream.pos = pos;
                        }
                        return this._items[index];
                    };
                    _proto10.inspect = function inspect() {
                        return "[UnboundedArray ".concat(this.type.constructor.name, "]");
                    };
                    return UnboundedArrayAccessor;
                }();
                var UnboundedArray = /*#__PURE__*/ function(_r$Array2) {
                    function UnboundedArray(type) {
                        return _r$Array2.call(this, type, 0) || this;
                    }
                    _inheritsLoose(UnboundedArray, _r$Array2);
                    var _proto11 = UnboundedArray.prototype;
                    _proto11.decode = function decode(stream, parent) {
                        return new UnboundedArrayAccessor(this.type, stream, parent);
                    };
                    return UnboundedArray;
                }(r.Array);
                var LookupTable = function LookupTable(ValueType) {
                    if (ValueType === void 0) ValueType = r.uint16;
                    // Helper class that makes internal structures invisible to pointers
                    var Shadow = /*#__PURE__*/ function() {
                        function Shadow(type) {
                            this.type = type;
                        }
                        var _proto12 = Shadow.prototype;
                        _proto12.decode = function decode(stream, ctx) {
                            ctx = ctx.parent.parent;
                            return this.type.decode(stream, ctx);
                        };
                        _proto12.size = function size(val, ctx) {
                            ctx = ctx.parent.parent;
                            return this.type.size(val, ctx);
                        };
                        _proto12.encode = function encode(stream, val, ctx) {
                            ctx = ctx.parent.parent;
                            return this.type.encode(stream, val, ctx);
                        };
                        return Shadow;
                    }();
                    ValueType = new Shadow(ValueType);
                    var BinarySearchHeader = new r.Struct({
                        unitSize: r.uint16,
                        nUnits: r.uint16,
                        searchRange: r.uint16,
                        entrySelector: r.uint16,
                        rangeShift: r.uint16
                    });
                    var LookupSegmentSingle = new r.Struct({
                        lastGlyph: r.uint16,
                        firstGlyph: r.uint16,
                        value: ValueType
                    });
                    var LookupSegmentArray = new r.Struct({
                        lastGlyph: r.uint16,
                        firstGlyph: r.uint16,
                        values: new r.Pointer(r.uint16, new r.Array(ValueType, function(t) {
                            return t.lastGlyph - t.firstGlyph + 1;
                        }), {
                            type: 'parent'
                        })
                    });
                    var LookupSingle = new r.Struct({
                        glyph: r.uint16,
                        value: ValueType
                    });
                    return new r.VersionedStruct(r.uint16, {
                        0: {
                            values: new UnboundedArray(ValueType) // length == number of glyphs maybe?
                        },
                        2: {
                            binarySearchHeader: BinarySearchHeader,
                            segments: new r.Array(LookupSegmentSingle, function(t) {
                                return t.binarySearchHeader.nUnits;
                            })
                        },
                        4: {
                            binarySearchHeader: BinarySearchHeader,
                            segments: new r.Array(LookupSegmentArray, function(t) {
                                return t.binarySearchHeader.nUnits;
                            })
                        },
                        6: {
                            binarySearchHeader: BinarySearchHeader,
                            segments: new r.Array(LookupSingle, function(t) {
                                return t.binarySearchHeader.nUnits;
                            })
                        },
                        8: {
                            firstGlyph: r.uint16,
                            count: r.uint16,
                            values: new r.Array(ValueType, 'count')
                        }
                    });
                };
                function StateTable(entryData, lookupType) {
                    if (entryData === void 0) entryData = {};
                    if (lookupType === void 0) lookupType = r.uint16;
                    var entry = Object.assign({
                        newState: r.uint16,
                        flags: r.uint16
                    }, entryData);
                    var Entry = new r.Struct(entry);
                    var StateArray = new UnboundedArray(new r.Array(r.uint16, function(t) {
                        return t.nClasses;
                    }));
                    var StateHeader = new r.Struct({
                        nClasses: r.uint32,
                        classTable: new r.Pointer(r.uint32, new LookupTable(lookupType)),
                        stateArray: new r.Pointer(r.uint32, StateArray),
                        entryTable: new r.Pointer(r.uint32, new UnboundedArray(Entry))
                    });
                    return StateHeader;
                } // This is the old version of the StateTable structure
                function StateTable1(entryData, lookupType) {
                    if (entryData === void 0) entryData = {};
                    if (lookupType === void 0) lookupType = r.uint16;
                    var ClassLookupTable = new r.Struct({
                        version: function version() {
                            return 8;
                        },
                        // simulate LookupTable
                        firstGlyph: r.uint16,
                        values: new r.Array(r.uint8, r.uint16)
                    });
                    var entry = Object.assign({
                        newStateOffset: r.uint16,
                        // convert offset to stateArray index
                        newState: function newState(t) {
                            return (t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses;
                        },
                        flags: r.uint16
                    }, entryData);
                    var Entry = new r.Struct(entry);
                    var StateArray = new UnboundedArray(new r.Array(r.uint8, function(t) {
                        return t.nClasses;
                    }));
                    var StateHeader1 = new r.Struct({
                        nClasses: r.uint16,
                        classTable: new r.Pointer(r.uint16, ClassLookupTable),
                        stateArray: new r.Pointer(r.uint16, StateArray),
                        entryTable: new r.Pointer(r.uint16, new UnboundedArray(Entry))
                    });
                    return StateHeader1;
                }
                var BslnSubtable = new r.VersionedStruct('format', {
                    0: {
                        // Distance-based, no mapping
                        deltas: new r.Array(r.int16, 32)
                    },
                    1: {
                        // Distance-based, with mapping
                        deltas: new r.Array(r.int16, 32),
                        mappingData: new LookupTable(r.uint16)
                    },
                    2: {
                        // Control point-based, no mapping
                        standardGlyph: r.uint16,
                        controlPoints: new r.Array(r.uint16, 32)
                    },
                    3: {
                        // Control point-based, with mapping
                        standardGlyph: r.uint16,
                        controlPoints: new r.Array(r.uint16, 32),
                        mappingData: new LookupTable(r.uint16)
                    }
                });
                var bsln = new r.Struct({
                    version: r.fixed32,
                    format: r.uint16,
                    defaultBaseline: r.uint16,
                    subtable: BslnSubtable
                });
                var Setting = new r.Struct({
                    setting: r.uint16,
                    nameIndex: r.int16,
                    name: function name(t) {
                        return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex];
                    }
                });
                var FeatureName = new r.Struct({
                    feature: r.uint16,
                    nSettings: r.uint16,
                    settingTable: new r.Pointer(r.uint32, new r.Array(Setting, 'nSettings'), {
                        type: 'parent'
                    }),
                    featureFlags: new r.Bitfield(r.uint8, [
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        'hasDefault',
                        'exclusive'
                    ]),
                    defaultSetting: r.uint8,
                    nameIndex: r.int16,
                    name: function name(t) {
                        return t.parent.parent.name.records.fontFeatures[t.nameIndex];
                    }
                });
                var feat = new r.Struct({
                    version: r.fixed32,
                    featureNameCount: r.uint16,
                    reserved1: new r.Reserved(r.uint16),
                    reserved2: new r.Reserved(r.uint32),
                    featureNames: new r.Array(FeatureName, 'featureNameCount')
                });
                var Axis$1 = new r.Struct({
                    axisTag: new r.String(4),
                    minValue: r.fixed32,
                    defaultValue: r.fixed32,
                    maxValue: r.fixed32,
                    flags: r.uint16,
                    nameID: r.uint16,
                    name: function name(t) {
                        return t.parent.parent.name.records.fontFeatures[t.nameID];
                    }
                });
                var Instance = new r.Struct({
                    nameID: r.uint16,
                    name: function name(t) {
                        return t.parent.parent.name.records.fontFeatures[t.nameID];
                    },
                    flags: r.uint16,
                    coord: new r.Array(r.fixed32, function(t) {
                        return t.parent.axisCount;
                    }),
                    postscriptNameID: new r.Optional(r.uint16, function(t) {
                        return t.parent.instanceSize - t._currentOffset > 0;
                    })
                });
                var fvar = new r.Struct({
                    version: r.fixed32,
                    offsetToData: r.uint16,
                    countSizePairs: r.uint16,
                    axisCount: r.uint16,
                    axisSize: r.uint16,
                    instanceCount: r.uint16,
                    instanceSize: r.uint16,
                    axis: new r.Array(Axis$1, 'axisCount'),
                    instance: new r.Array(Instance, 'instanceCount')
                });
                var shortFrac$1 = new r.Fixed(16, 'BE', 14);
                var Offset = /*#__PURE__*/ function() {
                    function Offset() {}
                    Offset.decode = function decode(stream, parent) {
                        // In short format, offsets are multiplied by 2.
                        // This doesn't seem to be documented by Apple, but it
                        // is implemented this way in Freetype.
                        return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
                    };
                    return Offset;
                }();
                var gvar = new r.Struct({
                    version: r.uint16,
                    reserved: new r.Reserved(r.uint16),
                    axisCount: r.uint16,
                    globalCoordCount: r.uint16,
                    globalCoords: new r.Pointer(r.uint32, new r.Array(new r.Array(shortFrac$1, 'axisCount'), 'globalCoordCount')),
                    glyphCount: r.uint16,
                    flags: r.uint16,
                    offsetToData: r.uint32,
                    offsets: new r.Array(new r.Pointer(Offset, 'void', {
                        relativeTo: function relativeTo(ctx) {
                            return ctx.offsetToData;
                        },
                        allowNull: false
                    }), function(t) {
                        return t.glyphCount + 1;
                    })
                });
                var ClassTable$1 = new r.Struct({
                    length: r.uint16,
                    coverage: r.uint16,
                    subFeatureFlags: r.uint32,
                    stateTable: new StateTable1()
                });
                var WidthDeltaRecord = new r.Struct({
                    justClass: r.uint32,
                    beforeGrowLimit: r.fixed32,
                    beforeShrinkLimit: r.fixed32,
                    afterGrowLimit: r.fixed32,
                    afterShrinkLimit: r.fixed32,
                    growFlags: r.uint16,
                    shrinkFlags: r.uint16
                });
                var WidthDeltaCluster = new r.Array(WidthDeltaRecord, r.uint32);
                var ActionData = new r.VersionedStruct('actionType', {
                    0: {
                        // Decomposition action
                        lowerLimit: r.fixed32,
                        upperLimit: r.fixed32,
                        order: r.uint16,
                        glyphs: new r.Array(r.uint16, r.uint16)
                    },
                    1: {
                        // Unconditional add glyph action
                        addGlyph: r.uint16
                    },
                    2: {
                        // Conditional add glyph action
                        substThreshold: r.fixed32,
                        addGlyph: r.uint16,
                        substGlyph: r.uint16
                    },
                    3: {},
                    // Stretch glyph action (no data, not supported by CoreText)
                    4: {
                        // Ductile glyph action (not supported by CoreText)
                        variationAxis: r.uint32,
                        minimumLimit: r.fixed32,
                        noStretchValue: r.fixed32,
                        maximumLimit: r.fixed32
                    },
                    5: {
                        // Repeated add glyph action
                        flags: r.uint16,
                        glyph: r.uint16
                    }
                });
                var Action = new r.Struct({
                    actionClass: r.uint16,
                    actionType: r.uint16,
                    actionLength: r.uint32,
                    actionData: ActionData,
                    padding: new r.Reserved(r.uint8, function(t) {
                        return t.actionLength - t._currentOffset;
                    })
                });
                var PostcompensationAction = new r.Array(Action, r.uint32);
                var PostCompensationTable = new r.Struct({
                    lookupTable: new LookupTable(new r.Pointer(r.uint16, PostcompensationAction))
                });
                var JustificationTable = new r.Struct({
                    classTable: new r.Pointer(r.uint16, ClassTable$1, {
                        type: 'parent'
                    }),
                    wdcOffset: r.uint16,
                    postCompensationTable: new r.Pointer(r.uint16, PostCompensationTable, {
                        type: 'parent'
                    }),
                    widthDeltaClusters: new LookupTable(new r.Pointer(r.uint16, WidthDeltaCluster, {
                        type: 'parent',
                        relativeTo: function relativeTo(ctx) {
                            return ctx.wdcOffset;
                        }
                    }))
                });
                var just = new r.Struct({
                    version: r.uint32,
                    format: r.uint16,
                    horizontal: new r.Pointer(r.uint16, JustificationTable),
                    vertical: new r.Pointer(r.uint16, JustificationTable)
                });
                var LigatureData = {
                    action: r.uint16
                };
                var ContextualData = {
                    markIndex: r.uint16,
                    currentIndex: r.uint16
                };
                var InsertionData = {
                    currentInsertIndex: r.uint16,
                    markedInsertIndex: r.uint16
                };
                var SubstitutionTable = new r.Struct({
                    items: new UnboundedArray(new r.Pointer(r.uint32, new LookupTable()))
                });
                var SubtableData = new r.VersionedStruct('type', {
                    0: {
                        // Indic Rearrangement Subtable
                        stateTable: new StateTable()
                    },
                    1: {
                        // Contextual Glyph Substitution Subtable
                        stateTable: new StateTable(ContextualData),
                        substitutionTable: new r.Pointer(r.uint32, SubstitutionTable)
                    },
                    2: {
                        // Ligature subtable
                        stateTable: new StateTable(LigatureData),
                        ligatureActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint32)),
                        components: new r.Pointer(r.uint32, new UnboundedArray(r.uint16)),
                        ligatureList: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
                    },
                    4: {
                        // Non-contextual Glyph Substitution Subtable
                        lookupTable: new LookupTable()
                    },
                    5: {
                        // Glyph Insertion Subtable
                        stateTable: new StateTable(InsertionData),
                        insertionActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
                    }
                });
                var Subtable = new r.Struct({
                    length: r.uint32,
                    coverage: r.uint24,
                    type: r.uint8,
                    subFeatureFlags: r.uint32,
                    table: SubtableData,
                    padding: new r.Reserved(r.uint8, function(t) {
                        return t.length - t._currentOffset;
                    })
                });
                var FeatureEntry = new r.Struct({
                    featureType: r.uint16,
                    featureSetting: r.uint16,
                    enableFlags: r.uint32,
                    disableFlags: r.uint32
                });
                var MorxChain = new r.Struct({
                    defaultFlags: r.uint32,
                    chainLength: r.uint32,
                    nFeatureEntries: r.uint32,
                    nSubtables: r.uint32,
                    features: new r.Array(FeatureEntry, 'nFeatureEntries'),
                    subtables: new r.Array(Subtable, 'nSubtables')
                });
                var morx = new r.Struct({
                    version: r.uint16,
                    unused: new r.Reserved(r.uint16),
                    nChains: r.uint32,
                    chains: new r.Array(MorxChain, 'nChains')
                });
                var OpticalBounds = new r.Struct({
                    left: r.int16,
                    top: r.int16,
                    right: r.int16,
                    bottom: r.int16
                });
                var opbd = new r.Struct({
                    version: r.fixed32,
                    format: r.uint16,
                    lookupTable: new LookupTable(OpticalBounds)
                });
                var tables = {};
                tables.cmap = cmap;
                tables.head = head;
                tables.hhea = hhea;
                tables.hmtx = hmtx;
                tables.maxp = maxp;
                tables.name = NameTable;
                tables['OS/2'] = OS2;
                tables.post = post; // TrueType Outlines
                tables.fpgm = fpgm;
                tables.loca = loca;
                tables.prep = prep;
                tables['cvt '] = cvt;
                tables.glyf = glyf; // PostScript Outlines
                tables['CFF '] = CFFFont;
                tables['CFF2'] = CFFFont;
                tables.VORG = VORG; // Bitmap Glyphs
                tables.EBLC = EBLC;
                tables.CBLC = tables.EBLC;
                tables.sbix = sbix;
                tables.COLR = COLR;
                tables.CPAL = CPAL; // Advanced OpenType Tables
                tables.BASE = BASE;
                tables.GDEF = GDEF;
                tables.GPOS = GPOS;
                tables.GSUB = GSUB;
                tables.JSTF = JSTF; // OpenType variations tables
                tables.HVAR = HVAR; // Other OpenType Tables
                tables.DSIG = DSIG;
                tables.gasp = gasp;
                tables.hdmx = hdmx;
                tables.kern = kern;
                tables.LTSH = LTSH;
                tables.PCLT = PCLT;
                tables.VDMX = VDMX;
                tables.vhea = vhea;
                tables.vmtx = vmtx; // Apple Advanced Typography Tables
                tables.avar = avar;
                tables.bsln = bsln;
                tables.feat = feat;
                tables.fvar = fvar;
                tables.gvar = gvar;
                tables.just = just;
                tables.morx = morx;
                tables.opbd = opbd;
                var TableEntry = new r.Struct({
                    tag: new r.String(4),
                    checkSum: r.uint32,
                    offset: new r.Pointer(r.uint32, 'void', {
                        type: 'global'
                    }),
                    length: r.uint32
                });
                var Directory = new r.Struct({
                    tag: new r.String(4),
                    numTables: r.uint16,
                    searchRange: r.uint16,
                    entrySelector: r.uint16,
                    rangeShift: r.uint16,
                    tables: new r.Array(TableEntry, 'numTables')
                });
                Directory.process = function() {
                    var tables = {};
                    for(var _iterator9 = _createForOfIteratorHelperLoose(this.tables), _step9; !(_step9 = _iterator9()).done;){
                        var table = _step9.value;
                        tables[table.tag] = table;
                    }
                    this.tables = tables;
                };
                Directory.preEncode = function(stream) {
                    var tables$1 = [];
                    for(var tag in this.tables){
                        var table = this.tables[tag];
                        if (table) tables$1.push({
                            tag: tag,
                            checkSum: 0,
                            offset: new r.VoidPointer(tables[tag], table),
                            length: tables[tag].size(table)
                        });
                    }
                    this.tag = 'true';
                    this.numTables = tables$1.length;
                    this.tables = tables$1;
                    var maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
                    var maxPowerOf2 = Math.pow(2, maxExponentFor2);
                    this.searchRange = maxPowerOf2 * 16;
                    this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
                    this.rangeShift = this.numTables * 16 - this.searchRange;
                };
                function binarySearch(arr, cmp) {
                    var min = 0;
                    var max = arr.length - 1;
                    while(min <= max){
                        var mid = min + max >> 1;
                        var res = cmp(arr[mid]);
                        if (res < 0) max = mid - 1;
                        else if (res > 0) min = mid + 1;
                        else return mid;
                    }
                    return -1;
                }
                function range(index, end) {
                    var range = [];
                    while(index < end)range.push(index++);
                    return range;
                }
                var _class;
                try {
                    var iconv = __webpack_require__(54171);
                } catch (err) {}
                var CmapProcessor = (_class = /*#__PURE__*/ function() {
                    function CmapProcessor(cmapTable) {
                        // Attempt to find a Unicode cmap first
                        this.encoding = null;
                        this.cmap = this.findSubtable(cmapTable, [
                            // 32-bit subtables
                            [
                                3,
                                10
                            ],
                            [
                                0,
                                6
                            ],
                            [
                                0,
                                4
                            ],
                            // 16-bit subtables
                            [
                                3,
                                1
                            ],
                            [
                                0,
                                3
                            ],
                            [
                                0,
                                2
                            ],
                            [
                                0,
                                1
                            ],
                            [
                                0,
                                0
                            ]
                        ]); // If not unicode cmap was found, and iconv-lite is installed,
                        // take the first table with a supported encoding.
                        if (!this.cmap && iconv) for(var _iterator0 = _createForOfIteratorHelperLoose(cmapTable.tables), _step0; !(_step0 = _iterator0()).done;){
                            var cmap = _step0.value;
                            var encoding = getEncoding(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
                            if (iconv.encodingExists(encoding)) {
                                this.cmap = cmap.table;
                                this.encoding = encoding;
                            }
                        }
                        if (!this.cmap) throw new Error("Could not find a supported cmap table");
                        this.uvs = this.findSubtable(cmapTable, [
                            [
                                0,
                                5
                            ]
                        ]);
                        if (this.uvs && this.uvs.version !== 14) this.uvs = null;
                    }
                    var _proto13 = CmapProcessor.prototype;
                    _proto13.findSubtable = function findSubtable(cmapTable, pairs) {
                        for(var _iterator1 = _createForOfIteratorHelperLoose(pairs), _step1; !(_step1 = _iterator1()).done;){
                            var _step1$value = _step1.value, platformID = _step1$value[0], encodingID = _step1$value[1];
                            for(var _iterator10 = _createForOfIteratorHelperLoose(cmapTable.tables), _step10; !(_step10 = _iterator10()).done;){
                                var cmap = _step10.value;
                                if (cmap.platformID === platformID && cmap.encodingID === encodingID) return cmap.table;
                            }
                        }
                        return null;
                    };
                    _proto13.lookup = function lookup(codepoint, variationSelector) {
                        // If there is no Unicode cmap in this font, we need to re-encode
                        // the codepoint in the encoding that the cmap supports.
                        if (this.encoding) {
                            var buf = iconv.encode(String.fromCodePoint(codepoint), this.encoding);
                            codepoint = 0;
                            for(var i = 0; i < buf.length; i++)codepoint = codepoint << 8 | buf[i];
                             // Otherwise, try to get a Unicode variation selector for this codepoint if one is provided.
                        } else if (variationSelector) {
                            var gid = this.getVariationSelector(codepoint, variationSelector);
                            if (gid) return gid;
                        }
                        var cmap = this.cmap;
                        switch(cmap.version){
                            case 0:
                                return cmap.codeMap.get(codepoint) || 0;
                            case 4:
                                var min = 0;
                                var max = cmap.segCount - 1;
                                while(min <= max){
                                    var mid = min + max >> 1;
                                    if (codepoint < cmap.startCode.get(mid)) max = mid - 1;
                                    else if (codepoint > cmap.endCode.get(mid)) min = mid + 1;
                                    else {
                                        var rangeOffset = cmap.idRangeOffset.get(mid);
                                        var _gid = void 0;
                                        if (rangeOffset === 0) _gid = codepoint + cmap.idDelta.get(mid);
                                        else {
                                            var index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                                            _gid = cmap.glyphIndexArray.get(index) || 0;
                                            if (_gid !== 0) _gid += cmap.idDelta.get(mid);
                                        }
                                        return _gid & 0xffff;
                                    }
                                }
                                return 0;
                            case 8:
                                throw new Error('TODO: cmap format 8');
                            case 6:
                            case 10:
                                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
                            case 12:
                            case 13:
                                var _min = 0;
                                var _max = cmap.nGroups - 1;
                                while(_min <= _max){
                                    var _mid = _min + _max >> 1;
                                    var group = cmap.groups.get(_mid);
                                    if (codepoint < group.startCharCode) _max = _mid - 1;
                                    else if (codepoint > group.endCharCode) _min = _mid + 1;
                                    else {
                                        if (cmap.version === 12) return group.glyphID + (codepoint - group.startCharCode);
                                        else return group.glyphID;
                                    }
                                }
                                return 0;
                            case 14:
                                throw new Error('TODO: cmap format 14');
                            default:
                                throw new Error("Unknown cmap format ".concat(cmap.version));
                        }
                    };
                    _proto13.getVariationSelector = function getVariationSelector(codepoint, variationSelector) {
                        if (!this.uvs) return 0;
                        var selectors = this.uvs.varSelectors.toArray();
                        var i = binarySearch(selectors, function(x) {
                            return variationSelector - x.varSelector;
                        });
                        var sel = selectors[i];
                        if (i !== -1 && sel.defaultUVS) i = binarySearch(sel.defaultUVS, function(x) {
                            return codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? 1 : 0;
                        });
                        if (i !== -1 && sel.nonDefaultUVS) {
                            i = binarySearch(sel.nonDefaultUVS, function(x) {
                                return codepoint - x.unicodeValue;
                            });
                            if (i !== -1) return sel.nonDefaultUVS[i].glyphID;
                        }
                        return 0;
                    };
                    _proto13.getCharacterSet = function getCharacterSet() {
                        var cmap = this.cmap;
                        switch(cmap.version){
                            case 0:
                                return range(0, cmap.codeMap.length);
                            case 4:
                                var res = [];
                                var endCodes = cmap.endCode.toArray();
                                for(var i = 0; i < endCodes.length; i++){
                                    var tail = endCodes[i] + 1;
                                    var start = cmap.startCode.get(i);
                                    res.push.apply(res, range(start, tail));
                                }
                                return res;
                            case 8:
                                throw new Error('TODO: cmap format 8');
                            case 6:
                            case 10:
                                return range(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
                            case 12:
                            case 13:
                                var _res = [];
                                for(var _iterator11 = _createForOfIteratorHelperLoose(cmap.groups.toArray()), _step11; !(_step11 = _iterator11()).done;){
                                    var group = _step11.value;
                                    _res.push.apply(_res, range(group.startCharCode, group.endCharCode + 1));
                                }
                                return _res;
                            case 14:
                                throw new Error('TODO: cmap format 14');
                            default:
                                throw new Error("Unknown cmap format ".concat(cmap.version));
                        }
                    };
                    _proto13.codePointsForGlyph = function codePointsForGlyph(gid) {
                        var cmap = this.cmap;
                        switch(cmap.version){
                            case 0:
                                var res = [];
                                for(var i = 0; i < 256; i++)if (cmap.codeMap.get(i) === gid) res.push(i);
                                return res;
                            case 4:
                                var _res2 = [];
                                for(var _i = 0; _i < cmap.segCount; _i++){
                                    var end = cmap.endCode.get(_i);
                                    var start = cmap.startCode.get(_i);
                                    var rangeOffset = cmap.idRangeOffset.get(_i);
                                    var delta = cmap.idDelta.get(_i);
                                    for(var c = start; c <= end; c++){
                                        var g = 0;
                                        if (rangeOffset === 0) g = c + delta;
                                        else {
                                            var index = rangeOffset / 2 + (c - start) - (cmap.segCount - _i);
                                            g = cmap.glyphIndexArray.get(index) || 0;
                                            if (g !== 0) g += delta;
                                        }
                                        if (g === gid) _res2.push(c);
                                    }
                                }
                                return _res2;
                            case 12:
                                var _res3 = [];
                                for(var _iterator12 = _createForOfIteratorHelperLoose(cmap.groups.toArray()), _step12; !(_step12 = _iterator12()).done;){
                                    var group = _step12.value;
                                    if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) _res3.push(group.startCharCode + (gid - group.glyphID));
                                }
                                return _res3;
                            case 13:
                                var _res4 = [];
                                for(var _iterator13 = _createForOfIteratorHelperLoose(cmap.groups.toArray()), _step13; !(_step13 = _iterator13()).done;){
                                    var _group = _step13.value;
                                    if (gid === _group.glyphID) _res4.push.apply(_res4, range(_group.startCharCode, _group.endCharCode + 1));
                                }
                                return _res4;
                            default:
                                throw new Error("Unknown cmap format ".concat(cmap.version));
                        }
                    };
                    return CmapProcessor;
                }(), _applyDecoratedDescriptor(_class.prototype, "getCharacterSet", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class.prototype, "getCharacterSet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "codePointsForGlyph", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class.prototype, "codePointsForGlyph"), _class.prototype), _class);
                var KernProcessor = /*#__PURE__*/ function() {
                    function KernProcessor(font) {
                        this.kern = font.kern;
                    }
                    var _proto14 = KernProcessor.prototype;
                    _proto14.process = function process(glyphs, positions) {
                        for(var glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++){
                            var left = glyphs[glyphIndex].id;
                            var right = glyphs[glyphIndex + 1].id;
                            positions[glyphIndex].xAdvance += this.getKerning(left, right);
                        }
                    };
                    _proto14.getKerning = function getKerning(left, right) {
                        var res = 0;
                        for(var _iterator14 = _createForOfIteratorHelperLoose(this.kern.tables), _step14; !(_step14 = _iterator14()).done;){
                            var table = _step14.value;
                            if (table.coverage.crossStream) continue;
                            switch(table.version){
                                case 0:
                                    if (!table.coverage.horizontal) continue;
                                    break;
                                case 1:
                                    if (table.coverage.vertical || table.coverage.variation) continue;
                                    break;
                                default:
                                    throw new Error("Unsupported kerning table version ".concat(table.version));
                            }
                            var val = 0;
                            var s = table.subtable;
                            switch(table.format){
                                case 0:
                                    var pairIdx = binarySearch(s.pairs, function(pair) {
                                        return left - pair.left || right - pair.right;
                                    });
                                    if (pairIdx >= 0) val = s.pairs[pairIdx].value;
                                    break;
                                case 2:
                                    var leftOffset = 0, rightOffset = 0;
                                    if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                                    else leftOffset = s.array.off;
                                    if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                                    var index = (leftOffset + rightOffset - s.array.off) / 2;
                                    val = s.array.values.get(index);
                                    break;
                                case 3:
                                    if (left >= s.glyphCount || right >= s.glyphCount) return 0;
                                    val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                                    break;
                                default:
                                    throw new Error("Unsupported kerning sub-table format ".concat(table.format));
                            } // Microsoft supports the override flag, which resets the result
                            // Otherwise, the sum of the results from all subtables is returned
                            if (table.coverage.override) res = val;
                            else res += val;
                        }
                        return res;
                    };
                    return KernProcessor;
                }();
                /**
 * This class is used when GPOS does not define 'mark' or 'mkmk' features
 * for positioning marks relative to base glyphs. It uses the unicode
 * combining class property to position marks.
 *
 * Based on code from Harfbuzz, thanks!
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-fallback.cc
 */ var UnicodeLayoutEngine = /*#__PURE__*/ function() {
                    function UnicodeLayoutEngine(font) {
                        this.font = font;
                    }
                    var _proto15 = UnicodeLayoutEngine.prototype;
                    _proto15.positionGlyphs = function positionGlyphs(glyphs, positions) {
                        // find each base + mark cluster, and position the marks relative to the base
                        var clusterStart = 0;
                        var clusterEnd = 0;
                        for(var index = 0; index < glyphs.length; index++){
                            var glyph = glyphs[index];
                            if (glyph.isMark) // TODO: handle ligatures
                            clusterEnd = index;
                            else {
                                if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                                clusterStart = clusterEnd = index;
                            }
                        }
                        if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                        return positions;
                    };
                    _proto15.positionCluster = function positionCluster(glyphs, positions, clusterStart, clusterEnd) {
                        var base = glyphs[clusterStart];
                        var baseBox = base.cbox.copy(); // adjust bounding box for ligature glyphs
                        if (base.codePoints.length > 1) // LTR. TODO: RTL support.
                        baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
                        var xOffset = -positions[clusterStart].xAdvance;
                        var yOffset = 0;
                        var yGap = this.font.unitsPerEm / 16; // position each of the mark glyphs relative to the base glyph
                        for(var index = clusterStart + 1; index <= clusterEnd; index++){
                            var mark = glyphs[index];
                            var markBox = mark.cbox;
                            var position = positions[index];
                            var combiningClass = this.getCombiningClass(mark.codePoints[0]);
                            if (combiningClass !== 'Not_Reordered') {
                                position.xOffset = position.yOffset = 0; // x positioning
                                switch(combiningClass){
                                    case 'Double_Above':
                                    case 'Double_Below':
                                        // LTR. TODO: RTL support.
                                        position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                                        break;
                                    case 'Attached_Below_Left':
                                    case 'Below_Left':
                                    case 'Above_Left':
                                        // left align
                                        position.xOffset += baseBox.minX - markBox.minX;
                                        break;
                                    case 'Attached_Above_Right':
                                    case 'Below_Right':
                                    case 'Above_Right':
                                        // right align
                                        position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                                        break;
                                    default:
                                        // Attached_Below, Attached_Above, Below, Above, other
                                        // center align
                                        position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                                } // y positioning
                                switch(combiningClass){
                                    case 'Double_Below':
                                    case 'Below_Left':
                                    case 'Below':
                                    case 'Below_Right':
                                    case 'Attached_Below_Left':
                                    case 'Attached_Below':
                                        // add a small gap between the glyphs if they are not attached
                                        if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') baseBox.minY += yGap;
                                        position.yOffset = -baseBox.minY - markBox.maxY;
                                        baseBox.minY += markBox.height;
                                        break;
                                    case 'Double_Above':
                                    case 'Above_Left':
                                    case 'Above':
                                    case 'Above_Right':
                                    case 'Attached_Above':
                                    case 'Attached_Above_Right':
                                        // add a small gap between the glyphs if they are not attached
                                        if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') baseBox.maxY += yGap;
                                        position.yOffset = baseBox.maxY - markBox.minY;
                                        baseBox.maxY += markBox.height;
                                        break;
                                }
                                position.xAdvance = position.yAdvance = 0;
                                position.xOffset += xOffset;
                                position.yOffset += yOffset;
                            } else {
                                xOffset -= position.xAdvance;
                                yOffset -= position.yAdvance;
                            }
                        }
                        return;
                    };
                    _proto15.getCombiningClass = function getCombiningClass(codePoint) {
                        var combiningClass = unicode.getCombiningClass(codePoint); // Thai / Lao need some per-character work
                        if ((codePoint & -256) === 0x0e00) {
                            if (combiningClass === 'Not_Reordered') switch(codePoint){
                                case 0x0e31:
                                case 0x0e34:
                                case 0x0e35:
                                case 0x0e36:
                                case 0x0e37:
                                case 0x0e47:
                                case 0x0e4c:
                                case 0x0e3d:
                                case 0x0e4e:
                                    return 'Above_Right';
                                case 0x0eb1:
                                case 0x0eb4:
                                case 0x0eb5:
                                case 0x0eb6:
                                case 0x0eb7:
                                case 0x0ebb:
                                case 0x0ecc:
                                case 0x0ecd:
                                    return 'Above';
                                case 0x0ebc:
                                    return 'Below';
                            }
                            else if (codePoint === 0x0e3a) // virama
                            return 'Below_Right';
                        }
                        switch(combiningClass){
                            // Hebrew
                            case 'CCC10':
                            case 'CCC11':
                            case 'CCC12':
                            case 'CCC13':
                            case 'CCC14':
                            case 'CCC15':
                            case 'CCC16':
                            case 'CCC17':
                            case 'CCC18':
                            case 'CCC20':
                            case 'CCC22':
                                // meteg
                                return 'Below';
                            case 'CCC23':
                                // rafe
                                return 'Attached_Above';
                            case 'CCC24':
                                // shin dot
                                return 'Above_Right';
                            case 'CCC25':
                            case 'CCC19':
                                // holam
                                return 'Above_Left';
                            case 'CCC26':
                                // point varika
                                return 'Above';
                            case 'CCC21':
                                break;
                            // Arabic and Syriac
                            case 'CCC27':
                            case 'CCC28':
                            case 'CCC30':
                            case 'CCC31':
                            case 'CCC33':
                            case 'CCC34':
                            case 'CCC35':
                            case 'CCC36':
                                // superscript alaph
                                return 'Above';
                            case 'CCC29':
                            case 'CCC32':
                                // kasra
                                return 'Below';
                            // Thai
                            case 'CCC103':
                                // sara u / sara uu
                                return 'Below_Right';
                            case 'CCC107':
                                // mai
                                return 'Above_Right';
                            // Lao
                            case 'CCC118':
                                // sign u / sign uu
                                return 'Below';
                            case 'CCC122':
                                // mai
                                return 'Above';
                            // Tibetan
                            case 'CCC129':
                            case 'CCC132':
                                // sign u
                                return 'Below';
                            case 'CCC130':
                                // sign i
                                return 'Above';
                        }
                        return combiningClass;
                    };
                    return UnicodeLayoutEngine;
                }();
                /**
 * Represents a glyph bounding box
 */ var BBox = /*#__PURE__*/ function() {
                    function BBox(minX, minY, maxX, maxY) {
                        if (minX === void 0) minX = Infinity;
                        if (minY === void 0) minY = Infinity;
                        if (maxX === void 0) maxX = -Infinity;
                        if (maxY === void 0) maxY = -Infinity;
                        /**
     * The minimum X position in the bounding box
     * @type {number}
     */ this.minX = minX;
                        /**
     * The minimum Y position in the bounding box
     * @type {number}
     */ this.minY = minY;
                        /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */ this.maxX = maxX;
                        /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */ this.maxY = maxY;
                    }
                    /**
   * The width of the bounding box
   * @type {number}
   */ var _proto16 = BBox.prototype;
                    _proto16.addPoint = function addPoint(x, y) {
                        if (Math.abs(x) !== Infinity) {
                            if (x < this.minX) this.minX = x;
                            if (x > this.maxX) this.maxX = x;
                        }
                        if (Math.abs(y) !== Infinity) {
                            if (y < this.minY) this.minY = y;
                            if (y > this.maxY) this.maxY = y;
                        }
                    };
                    _proto16.copy = function copy() {
                        return new BBox(this.minX, this.minY, this.maxX, this.maxY);
                    };
                    return _createClass(BBox, [
                        {
                            key: "width",
                            get: function get() {
                                return this.maxX - this.minX;
                            }
                        },
                        {
                            key: "height",
                            get: function get() {
                                return this.maxY - this.minY;
                            }
                        }
                    ]);
                }(); // Data from http://www.microsoft.com/typography/otspec/scripttags.htm
                // and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
                var UNICODE_SCRIPTS = {
                    Caucasian_Albanian: 'aghb',
                    Arabic: 'arab',
                    Imperial_Aramaic: 'armi',
                    Armenian: 'armn',
                    Avestan: 'avst',
                    Balinese: 'bali',
                    Bamum: 'bamu',
                    Bassa_Vah: 'bass',
                    Batak: 'batk',
                    Bengali: [
                        'bng2',
                        'beng'
                    ],
                    Bopomofo: 'bopo',
                    Brahmi: 'brah',
                    Braille: 'brai',
                    Buginese: 'bugi',
                    Buhid: 'buhd',
                    Chakma: 'cakm',
                    Canadian_Aboriginal: 'cans',
                    Carian: 'cari',
                    Cham: 'cham',
                    Cherokee: 'cher',
                    Coptic: 'copt',
                    Cypriot: 'cprt',
                    Cyrillic: 'cyrl',
                    Devanagari: [
                        'dev2',
                        'deva'
                    ],
                    Deseret: 'dsrt',
                    Duployan: 'dupl',
                    Egyptian_Hieroglyphs: 'egyp',
                    Elbasan: 'elba',
                    Ethiopic: 'ethi',
                    Georgian: 'geor',
                    Glagolitic: 'glag',
                    Gothic: 'goth',
                    Grantha: 'gran',
                    Greek: 'grek',
                    Gujarati: [
                        'gjr2',
                        'gujr'
                    ],
                    Gurmukhi: [
                        'gur2',
                        'guru'
                    ],
                    Hangul: 'hang',
                    Han: 'hani',
                    Hanunoo: 'hano',
                    Hebrew: 'hebr',
                    Hiragana: 'hira',
                    Pahawh_Hmong: 'hmng',
                    Katakana_Or_Hiragana: 'hrkt',
                    Old_Italic: 'ital',
                    Javanese: 'java',
                    Kayah_Li: 'kali',
                    Katakana: 'kana',
                    Kharoshthi: 'khar',
                    Khmer: 'khmr',
                    Khojki: 'khoj',
                    Kannada: [
                        'knd2',
                        'knda'
                    ],
                    Kaithi: 'kthi',
                    Tai_Tham: 'lana',
                    Lao: 'lao ',
                    Latin: 'latn',
                    Lepcha: 'lepc',
                    Limbu: 'limb',
                    Linear_A: 'lina',
                    Linear_B: 'linb',
                    Lisu: 'lisu',
                    Lycian: 'lyci',
                    Lydian: 'lydi',
                    Mahajani: 'mahj',
                    Mandaic: 'mand',
                    Manichaean: 'mani',
                    Mende_Kikakui: 'mend',
                    Meroitic_Cursive: 'merc',
                    Meroitic_Hieroglyphs: 'mero',
                    Malayalam: [
                        'mlm2',
                        'mlym'
                    ],
                    Modi: 'modi',
                    Mongolian: 'mong',
                    Mro: 'mroo',
                    Meetei_Mayek: 'mtei',
                    Myanmar: [
                        'mym2',
                        'mymr'
                    ],
                    Old_North_Arabian: 'narb',
                    Nabataean: 'nbat',
                    Nko: 'nko ',
                    Ogham: 'ogam',
                    Ol_Chiki: 'olck',
                    Old_Turkic: 'orkh',
                    Oriya: [
                        'ory2',
                        'orya'
                    ],
                    Osmanya: 'osma',
                    Palmyrene: 'palm',
                    Pau_Cin_Hau: 'pauc',
                    Old_Permic: 'perm',
                    Phags_Pa: 'phag',
                    Inscriptional_Pahlavi: 'phli',
                    Psalter_Pahlavi: 'phlp',
                    Phoenician: 'phnx',
                    Miao: 'plrd',
                    Inscriptional_Parthian: 'prti',
                    Rejang: 'rjng',
                    Runic: 'runr',
                    Samaritan: 'samr',
                    Old_South_Arabian: 'sarb',
                    Saurashtra: 'saur',
                    Shavian: 'shaw',
                    Sharada: 'shrd',
                    Siddham: 'sidd',
                    Khudawadi: 'sind',
                    Sinhala: 'sinh',
                    Sora_Sompeng: 'sora',
                    Sundanese: 'sund',
                    Syloti_Nagri: 'sylo',
                    Syriac: 'syrc',
                    Tagbanwa: 'tagb',
                    Takri: 'takr',
                    Tai_Le: 'tale',
                    New_Tai_Lue: 'talu',
                    Tamil: [
                        'tml2',
                        'taml'
                    ],
                    Tai_Viet: 'tavt',
                    Telugu: [
                        'tel2',
                        'telu'
                    ],
                    Tifinagh: 'tfng',
                    Tagalog: 'tglg',
                    Thaana: 'thaa',
                    Thai: 'thai',
                    Tibetan: 'tibt',
                    Tirhuta: 'tirh',
                    Ugaritic: 'ugar',
                    Vai: 'vai ',
                    Warang_Citi: 'wara',
                    Old_Persian: 'xpeo',
                    Cuneiform: 'xsux',
                    Yi: 'yi  ',
                    Inherited: 'zinh',
                    Common: 'zyyy',
                    Unknown: 'zzzz'
                };
                var OPENTYPE_SCRIPTS = {};
                for(var script in UNICODE_SCRIPTS){
                    var tag = UNICODE_SCRIPTS[script];
                    if (Array.isArray(tag)) for(var _iterator15 = _createForOfIteratorHelperLoose(tag), _step15; !(_step15 = _iterator15()).done;){
                        var t = _step15.value;
                        OPENTYPE_SCRIPTS[t] = script;
                    }
                    else OPENTYPE_SCRIPTS[tag] = script;
                }
                function fromOpenType(tag) {
                    return OPENTYPE_SCRIPTS[tag];
                }
                function forString(string) {
                    var len = string.length;
                    var idx = 0;
                    while(idx < len){
                        var code = string.charCodeAt(idx++); // Check if this is a high surrogate
                        if (0xd800 <= code && code <= 0xdbff && idx < len) {
                            var next = string.charCodeAt(idx); // Check if this is a low surrogate
                            if (0xdc00 <= next && next <= 0xdfff) {
                                idx++;
                                code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
                            }
                        }
                        var _script = unicode.getScript(code);
                        if (_script !== 'Common' && _script !== 'Inherited' && _script !== 'Unknown') return UNICODE_SCRIPTS[_script];
                    }
                    return UNICODE_SCRIPTS.Unknown;
                }
                function forCodePoints(codePoints) {
                    for(var i = 0; i < codePoints.length; i++){
                        var codePoint = codePoints[i];
                        var _script2 = unicode.getScript(codePoint);
                        if (_script2 !== 'Common' && _script2 !== 'Inherited' && _script2 !== 'Unknown') return UNICODE_SCRIPTS[_script2];
                    }
                    return UNICODE_SCRIPTS.Unknown;
                } // The scripts in this map are written from right to left
                var RTL = {
                    arab: true,
                    // Arabic
                    hebr: true,
                    // Hebrew
                    syrc: true,
                    // Syriac
                    thaa: true,
                    // Thaana
                    cprt: true,
                    // Cypriot Syllabary
                    khar: true,
                    // Kharosthi
                    phnx: true,
                    // Phoenician
                    'nko ': true,
                    // N'Ko
                    lydi: true,
                    // Lydian
                    avst: true,
                    // Avestan
                    armi: true,
                    // Imperial Aramaic
                    phli: true,
                    // Inscriptional Pahlavi
                    prti: true,
                    // Inscriptional Parthian
                    sarb: true,
                    // Old South Arabian
                    orkh: true,
                    // Old Turkic, Orkhon Runic
                    samr: true,
                    // Samaritan
                    mand: true,
                    // Mandaic, Mandaean
                    merc: true,
                    // Meroitic Cursive
                    mero: true,
                    // Meroitic Hieroglyphs
                    // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
                    mani: true,
                    // Manichaean
                    mend: true,
                    // Mende Kikakui
                    nbat: true,
                    // Nabataean
                    narb: true,
                    // Old North Arabian
                    palm: true,
                    // Palmyrene
                    phlp: true // Psalter Pahlavi
                };
                function direction(script) {
                    if (RTL[script]) return 'rtl';
                    return 'ltr';
                }
                /**
 * Represents a run of Glyph and GlyphPosition objects.
 * Returned by the font layout method.
 */ var GlyphRun = /*#__PURE__*/ function() {
                    function GlyphRun(glyphs, features, script, language, direction$1) {
                        /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */ this.glyphs = glyphs;
                        /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */ this.positions = null;
                        /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */ this.script = script;
                        /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */ this.language = language || null;
                        /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */ this.direction = direction$1 || direction(script);
                        /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */ this.features = {}; // Convert features to an object
                        if (Array.isArray(features)) for(var _iterator16 = _createForOfIteratorHelperLoose(features), _step16; !(_step16 = _iterator16()).done;){
                            var tag = _step16.value;
                            this.features[tag] = true;
                        }
                        else if (typeof features === 'object') this.features = features;
                    }
                    /**
   * The total advance width of the run.
   * @type {number}
   */ return _createClass(GlyphRun, [
                        {
                            key: "advanceWidth",
                            get: function get() {
                                var width = 0;
                                for(var _iterator17 = _createForOfIteratorHelperLoose(this.positions), _step17; !(_step17 = _iterator17()).done;){
                                    var position = _step17.value;
                                    width += position.xAdvance;
                                }
                                return width;
                            }
                        },
                        {
                            key: "advanceHeight",
                            get: function get() {
                                var height = 0;
                                for(var _iterator18 = _createForOfIteratorHelperLoose(this.positions), _step18; !(_step18 = _iterator18()).done;){
                                    var position = _step18.value;
                                    height += position.yAdvance;
                                }
                                return height;
                            }
                        },
                        {
                            key: "bbox",
                            get: function get() {
                                var bbox = new BBox();
                                var x = 0;
                                var y = 0;
                                for(var index = 0; index < this.glyphs.length; index++){
                                    var glyph = this.glyphs[index];
                                    var p = this.positions[index];
                                    var b = glyph.bbox;
                                    bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
                                    bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
                                    x += p.xAdvance;
                                    y += p.yAdvance;
                                }
                                return bbox;
                            }
                        }
                    ]);
                }();
                /**
 * Represents positioning information for a glyph in a GlyphRun.
 */ var GlyphPosition = function GlyphPosition(xAdvance, yAdvance, xOffset, yOffset) {
                    if (xAdvance === void 0) xAdvance = 0;
                    if (yAdvance === void 0) yAdvance = 0;
                    if (xOffset === void 0) xOffset = 0;
                    if (yOffset === void 0) yOffset = 0;
                    /**
   * The amount to move the virtual pen in the X direction after rendering this glyph.
   * @type {number}
   */ this.xAdvance = xAdvance;
                    /**
   * The amount to move the virtual pen in the Y direction after rendering this glyph.
   * @type {number}
   */ this.yAdvance = yAdvance;
                    /**
   * The offset from the pen position in the X direction at which to render this glyph.
   * @type {number}
   */ this.xOffset = xOffset;
                    /**
   * The offset from the pen position in the Y direction at which to render this glyph.
   * @type {number}
   */ this.yOffset = yOffset;
                }; // see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
                // and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
                var features = {
                    allTypographicFeatures: {
                        code: 0,
                        exclusive: false,
                        allTypeFeatures: 0
                    },
                    ligatures: {
                        code: 1,
                        exclusive: false,
                        requiredLigatures: 0,
                        commonLigatures: 2,
                        rareLigatures: 4,
                        // logos: 6
                        rebusPictures: 8,
                        diphthongLigatures: 10,
                        squaredLigatures: 12,
                        abbrevSquaredLigatures: 14,
                        symbolLigatures: 16,
                        contextualLigatures: 18,
                        historicalLigatures: 20
                    },
                    cursiveConnection: {
                        code: 2,
                        exclusive: true,
                        unconnected: 0,
                        partiallyConnected: 1,
                        cursive: 2
                    },
                    letterCase: {
                        code: 3,
                        exclusive: true
                    },
                    // upperAndLowerCase: 0          # deprecated
                    // allCaps: 1                    # deprecated
                    // allLowerCase: 2               # deprecated
                    // smallCaps: 3                  # deprecated
                    // initialCaps: 4                # deprecated
                    // initialCapsAndSmallCaps: 5    # deprecated
                    verticalSubstitution: {
                        code: 4,
                        exclusive: false,
                        substituteVerticalForms: 0
                    },
                    linguisticRearrangement: {
                        code: 5,
                        exclusive: false,
                        linguisticRearrangement: 0
                    },
                    numberSpacing: {
                        code: 6,
                        exclusive: true,
                        monospacedNumbers: 0,
                        proportionalNumbers: 1,
                        thirdWidthNumbers: 2,
                        quarterWidthNumbers: 3
                    },
                    smartSwash: {
                        code: 8,
                        exclusive: false,
                        wordInitialSwashes: 0,
                        wordFinalSwashes: 2,
                        // lineInitialSwashes: 4
                        // lineFinalSwashes: 6
                        nonFinalSwashes: 8
                    },
                    diacritics: {
                        code: 9,
                        exclusive: true,
                        showDiacritics: 0,
                        hideDiacritics: 1,
                        decomposeDiacritics: 2
                    },
                    verticalPosition: {
                        code: 10,
                        exclusive: true,
                        normalPosition: 0,
                        superiors: 1,
                        inferiors: 2,
                        ordinals: 3,
                        scientificInferiors: 4
                    },
                    fractions: {
                        code: 11,
                        exclusive: true,
                        noFractions: 0,
                        verticalFractions: 1,
                        diagonalFractions: 2
                    },
                    overlappingCharacters: {
                        code: 13,
                        exclusive: false,
                        preventOverlap: 0
                    },
                    typographicExtras: {
                        code: 14,
                        exclusive: false,
                        // hyphensToEmDash: 0
                        // hyphenToEnDash: 2
                        slashedZero: 4
                    },
                    // formInterrobang: 6
                    // smartQuotes: 8
                    // periodsToEllipsis: 10
                    mathematicalExtras: {
                        code: 15,
                        exclusive: false,
                        // hyphenToMinus: 0
                        // asteristoMultiply: 2
                        // slashToDivide: 4
                        // inequalityLigatures: 6
                        // exponents: 8
                        mathematicalGreek: 10
                    },
                    ornamentSets: {
                        code: 16,
                        exclusive: true,
                        noOrnaments: 0,
                        dingbats: 1,
                        piCharacters: 2,
                        fleurons: 3,
                        decorativeBorders: 4,
                        internationalSymbols: 5,
                        mathSymbols: 6
                    },
                    characterAlternatives: {
                        code: 17,
                        exclusive: true,
                        noAlternates: 0
                    },
                    // user defined options
                    designComplexity: {
                        code: 18,
                        exclusive: true,
                        designLevel1: 0,
                        designLevel2: 1,
                        designLevel3: 2,
                        designLevel4: 3,
                        designLevel5: 4
                    },
                    styleOptions: {
                        code: 19,
                        exclusive: true,
                        noStyleOptions: 0,
                        displayText: 1,
                        engravedText: 2,
                        illuminatedCaps: 3,
                        titlingCaps: 4,
                        tallCaps: 5
                    },
                    characterShape: {
                        code: 20,
                        exclusive: true,
                        traditionalCharacters: 0,
                        simplifiedCharacters: 1,
                        JIS1978Characters: 2,
                        JIS1983Characters: 3,
                        JIS1990Characters: 4,
                        traditionalAltOne: 5,
                        traditionalAltTwo: 6,
                        traditionalAltThree: 7,
                        traditionalAltFour: 8,
                        traditionalAltFive: 9,
                        expertCharacters: 10,
                        JIS2004Characters: 11,
                        hojoCharacters: 12,
                        NLCCharacters: 13,
                        traditionalNamesCharacters: 14
                    },
                    numberCase: {
                        code: 21,
                        exclusive: true,
                        lowerCaseNumbers: 0,
                        upperCaseNumbers: 1
                    },
                    textSpacing: {
                        code: 22,
                        exclusive: true,
                        proportionalText: 0,
                        monospacedText: 1,
                        halfWidthText: 2,
                        thirdWidthText: 3,
                        quarterWidthText: 4,
                        altProportionalText: 5,
                        altHalfWidthText: 6
                    },
                    transliteration: {
                        code: 23,
                        exclusive: true,
                        noTransliteration: 0
                    },
                    // hanjaToHangul: 1
                    // hiraganaToKatakana: 2
                    // katakanaToHiragana: 3
                    // kanaToRomanization: 4
                    // romanizationToHiragana: 5
                    // romanizationToKatakana: 6
                    // hanjaToHangulAltOne: 7
                    // hanjaToHangulAltTwo: 8
                    // hanjaToHangulAltThree: 9
                    annotation: {
                        code: 24,
                        exclusive: true,
                        noAnnotation: 0,
                        boxAnnotation: 1,
                        roundedBoxAnnotation: 2,
                        circleAnnotation: 3,
                        invertedCircleAnnotation: 4,
                        parenthesisAnnotation: 5,
                        periodAnnotation: 6,
                        romanNumeralAnnotation: 7,
                        diamondAnnotation: 8,
                        invertedBoxAnnotation: 9,
                        invertedRoundedBoxAnnotation: 10
                    },
                    kanaSpacing: {
                        code: 25,
                        exclusive: true,
                        fullWidthKana: 0,
                        proportionalKana: 1
                    },
                    ideographicSpacing: {
                        code: 26,
                        exclusive: true,
                        fullWidthIdeographs: 0,
                        proportionalIdeographs: 1,
                        halfWidthIdeographs: 2
                    },
                    unicodeDecomposition: {
                        code: 27,
                        exclusive: false,
                        canonicalComposition: 0,
                        compatibilityComposition: 2,
                        transcodingComposition: 4
                    },
                    rubyKana: {
                        code: 28,
                        exclusive: false,
                        // noRubyKana: 0     # deprecated - use rubyKanaOff instead
                        // rubyKana: 1     # deprecated - use rubyKanaOn instead
                        rubyKana: 2
                    },
                    CJKSymbolAlternatives: {
                        code: 29,
                        exclusive: true,
                        noCJKSymbolAlternatives: 0,
                        CJKSymbolAltOne: 1,
                        CJKSymbolAltTwo: 2,
                        CJKSymbolAltThree: 3,
                        CJKSymbolAltFour: 4,
                        CJKSymbolAltFive: 5
                    },
                    ideographicAlternatives: {
                        code: 30,
                        exclusive: true,
                        noIdeographicAlternatives: 0,
                        ideographicAltOne: 1,
                        ideographicAltTwo: 2,
                        ideographicAltThree: 3,
                        ideographicAltFour: 4,
                        ideographicAltFive: 5
                    },
                    CJKVerticalRomanPlacement: {
                        code: 31,
                        exclusive: true,
                        CJKVerticalRomanCentered: 0,
                        CJKVerticalRomanHBaseline: 1
                    },
                    italicCJKRoman: {
                        code: 32,
                        exclusive: false,
                        // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
                        // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
                        CJKItalicRoman: 2
                    },
                    caseSensitiveLayout: {
                        code: 33,
                        exclusive: false,
                        caseSensitiveLayout: 0,
                        caseSensitiveSpacing: 2
                    },
                    alternateKana: {
                        code: 34,
                        exclusive: false,
                        alternateHorizKana: 0,
                        alternateVertKana: 2
                    },
                    stylisticAlternatives: {
                        code: 35,
                        exclusive: false,
                        noStylisticAlternates: 0,
                        stylisticAltOne: 2,
                        stylisticAltTwo: 4,
                        stylisticAltThree: 6,
                        stylisticAltFour: 8,
                        stylisticAltFive: 10,
                        stylisticAltSix: 12,
                        stylisticAltSeven: 14,
                        stylisticAltEight: 16,
                        stylisticAltNine: 18,
                        stylisticAltTen: 20,
                        stylisticAltEleven: 22,
                        stylisticAltTwelve: 24,
                        stylisticAltThirteen: 26,
                        stylisticAltFourteen: 28,
                        stylisticAltFifteen: 30,
                        stylisticAltSixteen: 32,
                        stylisticAltSeventeen: 34,
                        stylisticAltEighteen: 36,
                        stylisticAltNineteen: 38,
                        stylisticAltTwenty: 40
                    },
                    contextualAlternates: {
                        code: 36,
                        exclusive: false,
                        contextualAlternates: 0,
                        swashAlternates: 2,
                        contextualSwashAlternates: 4
                    },
                    lowerCase: {
                        code: 37,
                        exclusive: true,
                        defaultLowerCase: 0,
                        lowerCaseSmallCaps: 1,
                        lowerCasePetiteCaps: 2
                    },
                    upperCase: {
                        code: 38,
                        exclusive: true,
                        defaultUpperCase: 0,
                        upperCaseSmallCaps: 1,
                        upperCasePetiteCaps: 2
                    },
                    languageTag: {
                        // indices into ltag table
                        code: 39,
                        exclusive: true
                    },
                    CJKRomanSpacing: {
                        code: 103,
                        exclusive: true,
                        halfWidthCJKRoman: 0,
                        proportionalCJKRoman: 1,
                        defaultCJKRoman: 2,
                        fullWidthCJKRoman: 3
                    }
                };
                var feature = function feature(name, selector) {
                    return [
                        features[name].code,
                        features[name][selector]
                    ];
                };
                var OTMapping = {
                    rlig: feature('ligatures', 'requiredLigatures'),
                    clig: feature('ligatures', 'contextualLigatures'),
                    dlig: feature('ligatures', 'rareLigatures'),
                    hlig: feature('ligatures', 'historicalLigatures'),
                    liga: feature('ligatures', 'commonLigatures'),
                    hist: feature('ligatures', 'historicalLigatures'),
                    // ??
                    smcp: feature('lowerCase', 'lowerCaseSmallCaps'),
                    pcap: feature('lowerCase', 'lowerCasePetiteCaps'),
                    frac: feature('fractions', 'diagonalFractions'),
                    dnom: feature('fractions', 'diagonalFractions'),
                    // ??
                    numr: feature('fractions', 'diagonalFractions'),
                    // ??
                    afrc: feature('fractions', 'verticalFractions'),
                    // aalt
                    // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
                    // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
                    // unic, vatu, vhal, vjmo, vpal, vrt2
                    // dist -> trak table?
                    // kern, vkrn -> kern table
                    // lfbd + opbd + rtbd -> opbd table?
                    // mark, mkmk -> acnt table?
                    // locl -> languageTag + ltag table
                    case: feature('caseSensitiveLayout', 'caseSensitiveLayout'),
                    // also caseSensitiveSpacing
                    ccmp: feature('unicodeDecomposition', 'canonicalComposition'),
                    // compatibilityComposition?
                    cpct: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
                    // guess..., probably not given below
                    valt: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
                    swsh: feature('contextualAlternates', 'swashAlternates'),
                    cswh: feature('contextualAlternates', 'contextualSwashAlternates'),
                    curs: feature('cursiveConnection', 'cursive'),
                    // ??
                    c2pc: feature('upperCase', 'upperCasePetiteCaps'),
                    c2sc: feature('upperCase', 'upperCaseSmallCaps'),
                    init: feature('smartSwash', 'wordInitialSwashes'),
                    // ??
                    fin2: feature('smartSwash', 'wordFinalSwashes'),
                    // ??
                    medi: feature('smartSwash', 'nonFinalSwashes'),
                    // ??
                    med2: feature('smartSwash', 'nonFinalSwashes'),
                    // ??
                    fin3: feature('smartSwash', 'wordFinalSwashes'),
                    // ??
                    fina: feature('smartSwash', 'wordFinalSwashes'),
                    // ??
                    pkna: feature('kanaSpacing', 'proportionalKana'),
                    half: feature('textSpacing', 'halfWidthText'),
                    // also HalfWidthCJKRoman, HalfWidthIdeographs?
                    halt: feature('textSpacing', 'altHalfWidthText'),
                    hkna: feature('alternateKana', 'alternateHorizKana'),
                    vkna: feature('alternateKana', 'alternateVertKana'),
                    // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
                    ital: feature('italicCJKRoman', 'CJKItalicRoman'),
                    lnum: feature('numberCase', 'upperCaseNumbers'),
                    onum: feature('numberCase', 'lowerCaseNumbers'),
                    mgrk: feature('mathematicalExtras', 'mathematicalGreek'),
                    // nalt: not enough info. what type of annotation?
                    // ornm: ditto, which ornament style?
                    calt: feature('contextualAlternates', 'contextualAlternates'),
                    // or more?
                    vrt2: feature('verticalSubstitution', 'substituteVerticalForms'),
                    // oh... below?
                    vert: feature('verticalSubstitution', 'substituteVerticalForms'),
                    tnum: feature('numberSpacing', 'monospacedNumbers'),
                    pnum: feature('numberSpacing', 'proportionalNumbers'),
                    sups: feature('verticalPosition', 'superiors'),
                    subs: feature('verticalPosition', 'inferiors'),
                    ordn: feature('verticalPosition', 'ordinals'),
                    pwid: feature('textSpacing', 'proportionalText'),
                    hwid: feature('textSpacing', 'halfWidthText'),
                    qwid: feature('textSpacing', 'quarterWidthText'),
                    // also QuarterWidthNumbers?
                    twid: feature('textSpacing', 'thirdWidthText'),
                    // also ThirdWidthNumbers?
                    fwid: feature('textSpacing', 'proportionalText'),
                    //??
                    palt: feature('textSpacing', 'altProportionalText'),
                    trad: feature('characterShape', 'traditionalCharacters'),
                    smpl: feature('characterShape', 'simplifiedCharacters'),
                    jp78: feature('characterShape', 'JIS1978Characters'),
                    jp83: feature('characterShape', 'JIS1983Characters'),
                    jp90: feature('characterShape', 'JIS1990Characters'),
                    jp04: feature('characterShape', 'JIS2004Characters'),
                    expt: feature('characterShape', 'expertCharacters'),
                    hojo: feature('characterShape', 'hojoCharacters'),
                    nlck: feature('characterShape', 'NLCCharacters'),
                    tnam: feature('characterShape', 'traditionalNamesCharacters'),
                    ruby: feature('rubyKana', 'rubyKana'),
                    titl: feature('styleOptions', 'titlingCaps'),
                    zero: feature('typographicExtras', 'slashedZero'),
                    ss01: feature('stylisticAlternatives', 'stylisticAltOne'),
                    ss02: feature('stylisticAlternatives', 'stylisticAltTwo'),
                    ss03: feature('stylisticAlternatives', 'stylisticAltThree'),
                    ss04: feature('stylisticAlternatives', 'stylisticAltFour'),
                    ss05: feature('stylisticAlternatives', 'stylisticAltFive'),
                    ss06: feature('stylisticAlternatives', 'stylisticAltSix'),
                    ss07: feature('stylisticAlternatives', 'stylisticAltSeven'),
                    ss08: feature('stylisticAlternatives', 'stylisticAltEight'),
                    ss09: feature('stylisticAlternatives', 'stylisticAltNine'),
                    ss10: feature('stylisticAlternatives', 'stylisticAltTen'),
                    ss11: feature('stylisticAlternatives', 'stylisticAltEleven'),
                    ss12: feature('stylisticAlternatives', 'stylisticAltTwelve'),
                    ss13: feature('stylisticAlternatives', 'stylisticAltThirteen'),
                    ss14: feature('stylisticAlternatives', 'stylisticAltFourteen'),
                    ss15: feature('stylisticAlternatives', 'stylisticAltFifteen'),
                    ss16: feature('stylisticAlternatives', 'stylisticAltSixteen'),
                    ss17: feature('stylisticAlternatives', 'stylisticAltSeventeen'),
                    ss18: feature('stylisticAlternatives', 'stylisticAltEighteen'),
                    ss19: feature('stylisticAlternatives', 'stylisticAltNineteen'),
                    ss20: feature('stylisticAlternatives', 'stylisticAltTwenty')
                }; // salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
                // Add cv01-cv99 features
                for(var i = 1; i <= 99; i++)OTMapping["cv".concat("00".concat(i).slice(-2))] = [
                    features.characterAlternatives.code,
                    i
                ];
                 // create inverse mapping
                var AATMapping = {};
                for(var ot in OTMapping){
                    var aat = OTMapping[ot];
                    if (AATMapping[aat[0]] == null) AATMapping[aat[0]] = {};
                    AATMapping[aat[0]][aat[1]] = ot;
                } // Maps an array of OpenType features to AAT features
                // in the form of {featureType:{featureSetting:true}}
                function mapOTToAAT(features) {
                    var res = {};
                    for(var k in features){
                        var r = void 0;
                        if (r = OTMapping[k]) {
                            if (res[r[0]] == null) res[r[0]] = {};
                            res[r[0]][r[1]] = features[k];
                        }
                    }
                    return res;
                } // Maps strings in a [featureType, featureSetting]
                // to their equivalent number codes
                function mapFeatureStrings(f) {
                    var type = f[0], setting = f[1];
                    if (isNaN(type)) var typeCode = features[type] && features[type].code;
                    else var typeCode = type;
                    if (isNaN(setting)) var settingCode = features[type] && features[type][setting];
                    else var settingCode = setting;
                    return [
                        typeCode,
                        settingCode
                    ];
                } // Maps AAT features to an array of OpenType features
                // Supports both arrays in the form of [[featureType, featureSetting]]
                // and objects in the form of {featureType:{featureSetting:true}}
                // featureTypes and featureSettings can be either strings or number codes
                function mapAATToOT(features) {
                    var res = {};
                    if (Array.isArray(features)) for(var k = 0; k < features.length; k++){
                        var r = void 0;
                        var f = mapFeatureStrings(features[k]);
                        if (r = AATMapping[f[0]] && AATMapping[f[0]][f[1]]) res[r] = true;
                    }
                    else if (typeof features === 'object') for(var type in features){
                        var _feature = features[type];
                        for(var setting in _feature){
                            var _r = void 0;
                            var _f = mapFeatureStrings([
                                type,
                                setting
                            ]);
                            if (_feature[setting] && (_r = AATMapping[_f[0]] && AATMapping[_f[0]][_f[1]])) res[_r] = true;
                        }
                    }
                    return Object.keys(res);
                }
                var _class$1;
                var AATLookupTable = (_class$1 = /*#__PURE__*/ function() {
                    function AATLookupTable(table) {
                        this.table = table;
                    }
                    var _proto17 = AATLookupTable.prototype;
                    _proto17.lookup = function lookup(glyph) {
                        switch(this.table.version){
                            case 0:
                                // simple array format
                                return this.table.values.getItem(glyph);
                            case 2:
                            case 4:
                                var min = 0;
                                var max = this.table.binarySearchHeader.nUnits - 1;
                                while(min <= max){
                                    var mid = min + max >> 1;
                                    var seg = this.table.segments[mid]; // special end of search value
                                    if (seg.firstGlyph === 0xffff) return null;
                                    if (glyph < seg.firstGlyph) max = mid - 1;
                                    else if (glyph > seg.lastGlyph) min = mid + 1;
                                    else {
                                        if (this.table.version === 2) return seg.value;
                                        else return seg.values[glyph - seg.firstGlyph];
                                    }
                                }
                                return null;
                            case 6:
                                // lookup single
                                var _min = 0;
                                var _max = this.table.binarySearchHeader.nUnits - 1;
                                while(_min <= _max){
                                    var mid = _min + _max >> 1;
                                    var seg = this.table.segments[mid]; // special end of search value
                                    if (seg.glyph === 0xffff) return null;
                                    if (glyph < seg.glyph) _max = mid - 1;
                                    else if (glyph > seg.glyph) _min = mid + 1;
                                    else return seg.value;
                                }
                                return null;
                            case 8:
                                // lookup trimmed
                                return this.table.values[glyph - this.table.firstGlyph];
                            default:
                                throw new Error("Unknown lookup table format: ".concat(this.table.version));
                        }
                    };
                    _proto17.glyphsForValue = function glyphsForValue(classValue) {
                        var res = [];
                        switch(this.table.version){
                            case 2:
                            case 4:
                                for(var _iterator19 = _createForOfIteratorHelperLoose(this.table.segments), _step19; !(_step19 = _iterator19()).done;){
                                    var segment = _step19.value;
                                    if (this.table.version === 2 && segment.value === classValue) res.push.apply(res, range(segment.firstGlyph, segment.lastGlyph + 1));
                                    else {
                                        for(var index = 0; index < segment.values.length; index++)if (segment.values[index] === classValue) res.push(segment.firstGlyph + index);
                                    }
                                }
                                break;
                            case 6:
                                // lookup single
                                for(var _iterator20 = _createForOfIteratorHelperLoose(this.table.segments), _step20; !(_step20 = _iterator20()).done;){
                                    var _segment = _step20.value;
                                    if (_segment.value === classValue) res.push(_segment.glyph);
                                }
                                break;
                            case 8:
                                // lookup trimmed
                                for(var i = 0; i < this.table.values.length; i++)if (this.table.values[i] === classValue) res.push(this.table.firstGlyph + i);
                                break;
                            default:
                                throw new Error("Unknown lookup table format: ".concat(this.table.version));
                        }
                        return res;
                    };
                    return AATLookupTable;
                }(), _applyDecoratedDescriptor(_class$1.prototype, "glyphsForValue", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$1.prototype, "glyphsForValue"), _class$1.prototype), _class$1);
                var START_OF_TEXT_STATE = 0;
                var END_OF_TEXT_CLASS = 0;
                var OUT_OF_BOUNDS_CLASS = 1;
                var DELETED_GLYPH_CLASS = 2;
                var DONT_ADVANCE = 0x4000;
                var AATStateMachine = /*#__PURE__*/ function() {
                    function AATStateMachine(stateTable) {
                        this.stateTable = stateTable;
                        this.lookupTable = new AATLookupTable(stateTable.classTable);
                    }
                    var _proto18 = AATStateMachine.prototype;
                    _proto18.process = function process(glyphs, reverse, processEntry) {
                        var currentState = START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
                        var index = reverse ? glyphs.length - 1 : 0;
                        var dir = reverse ? -1 : 1;
                        while(dir === 1 && index <= glyphs.length || dir === -1 && index >= -1){
                            var glyph = null;
                            var classCode = OUT_OF_BOUNDS_CLASS;
                            var shouldAdvance = true;
                            if (index === glyphs.length || index === -1) classCode = END_OF_TEXT_CLASS;
                            else {
                                glyph = glyphs[index];
                                if (glyph.id === 0xffff) // deleted glyph
                                classCode = DELETED_GLYPH_CLASS;
                                else {
                                    classCode = this.lookupTable.lookup(glyph.id);
                                    if (classCode == null) classCode = OUT_OF_BOUNDS_CLASS;
                                }
                            }
                            var row = this.stateTable.stateArray.getItem(currentState);
                            var entryIndex = row[classCode];
                            var entry = this.stateTable.entryTable.getItem(entryIndex);
                            if (classCode !== END_OF_TEXT_CLASS && classCode !== DELETED_GLYPH_CLASS) {
                                processEntry(glyph, entry, index);
                                shouldAdvance = !(entry.flags & DONT_ADVANCE);
                            }
                            currentState = entry.newState;
                            if (shouldAdvance) index += dir;
                        }
                        return glyphs;
                    } /**
   * Performs a depth-first traversal of the glyph strings
   * represented by the state machine.
   */ ;
                    _proto18.traverse = function traverse(opts, state, visited) {
                        if (state === void 0) state = 0;
                        if (visited === void 0) visited = new Set();
                        if (visited.has(state)) return;
                        visited.add(state);
                        var _this$stateTable = this.stateTable, nClasses = _this$stateTable.nClasses, stateArray = _this$stateTable.stateArray, entryTable = _this$stateTable.entryTable;
                        var row = stateArray.getItem(state); // Skip predefined classes
                        for(var classCode = 4; classCode < nClasses; classCode++){
                            var entryIndex = row[classCode];
                            var entry = entryTable.getItem(entryIndex); // Try all glyphs in the class
                            for(var _iterator21 = _createForOfIteratorHelperLoose(this.lookupTable.glyphsForValue(classCode)), _step21; !(_step21 = _iterator21()).done;){
                                var glyph = _step21.value;
                                if (opts.enter) opts.enter(glyph, entry);
                                if (entry.newState !== 0) this.traverse(opts, entry.newState, visited);
                                if (opts.exit) opts.exit(glyph, entry);
                            }
                        }
                    };
                    return AATStateMachine;
                }();
                var _class$2;
                var MARK_FIRST = 0x8000;
                var MARK_LAST = 0x2000;
                var VERB = 0x000F; // contextual substitution and glyph insertion flag
                var SET_MARK = 0x8000; // ligature entry flags
                var SET_COMPONENT = 0x8000;
                var PERFORM_ACTION = 0x2000; // ligature action masks
                var LAST_MASK = 0x80000000;
                var STORE_MASK = 0x40000000;
                var OFFSET_MASK = 0x3FFFFFFF;
                var REVERSE_DIRECTION = 0x400000;
                var CURRENT_INSERT_BEFORE = 0x0800;
                var MARKED_INSERT_BEFORE = 0x0400;
                var CURRENT_INSERT_COUNT = 0x03E0;
                var MARKED_INSERT_COUNT = 0x001F;
                var AATMorxProcessor = (_class$2 = /*#__PURE__*/ function() {
                    function AATMorxProcessor(font) {
                        this.processIndicRearragement = this.processIndicRearragement.bind(this);
                        this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
                        this.processLigature = this.processLigature.bind(this);
                        this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
                        this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
                        this.font = font;
                        this.morx = font.morx;
                        this.inputCache = null;
                    } // Processes an array of glyphs and applies the specified features
                    // Features should be in the form of {featureType:{featureSetting:boolean}}
                    var _proto19 = AATMorxProcessor.prototype;
                    _proto19.process = function process(glyphs, features) {
                        if (features === void 0) features = {};
                        for(var _iterator22 = _createForOfIteratorHelperLoose(this.morx.chains), _step22; !(_step22 = _iterator22()).done;){
                            var chain = _step22.value;
                            var flags = chain.defaultFlags; // enable/disable the requested features
                            for(var _iterator23 = _createForOfIteratorHelperLoose(chain.features), _step23; !(_step23 = _iterator23()).done;){
                                var feature = _step23.value;
                                var f = void 0;
                                if (f = features[feature.featureType]) {
                                    if (f[feature.featureSetting]) {
                                        flags &= feature.disableFlags;
                                        flags |= feature.enableFlags;
                                    } else if (f[feature.featureSetting] === false) {
                                        flags |= ~feature.disableFlags;
                                        flags &= ~feature.enableFlags;
                                    }
                                }
                            }
                            for(var _iterator24 = _createForOfIteratorHelperLoose(chain.subtables), _step24; !(_step24 = _iterator24()).done;){
                                var subtable = _step24.value;
                                if (subtable.subFeatureFlags & flags) this.processSubtable(subtable, glyphs);
                            }
                        } // remove deleted glyphs
                        var index = glyphs.length - 1;
                        while(index >= 0){
                            if (glyphs[index].id === 0xffff) glyphs.splice(index, 1);
                            index--;
                        }
                        return glyphs;
                    };
                    _proto19.processSubtable = function processSubtable(subtable, glyphs) {
                        this.subtable = subtable;
                        this.glyphs = glyphs;
                        if (this.subtable.type === 4) {
                            this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
                            return;
                        }
                        this.ligatureStack = [];
                        this.markedGlyph = null;
                        this.firstGlyph = null;
                        this.lastGlyph = null;
                        this.markedIndex = null;
                        var stateMachine = this.getStateMachine(subtable);
                        var process = this.getProcessor();
                        var reverse = !!(this.subtable.coverage & REVERSE_DIRECTION);
                        return stateMachine.process(this.glyphs, reverse, process);
                    };
                    _proto19.getStateMachine = function getStateMachine(subtable) {
                        return new AATStateMachine(subtable.table.stateTable);
                    };
                    _proto19.getProcessor = function getProcessor() {
                        switch(this.subtable.type){
                            case 0:
                                return this.processIndicRearragement;
                            case 1:
                                return this.processContextualSubstitution;
                            case 2:
                                return this.processLigature;
                            case 4:
                                return this.processNoncontextualSubstitutions;
                            case 5:
                                return this.processGlyphInsertion;
                            default:
                                throw new Error("Invalid morx subtable type: ".concat(this.subtable.type));
                        }
                    };
                    _proto19.processIndicRearragement = function processIndicRearragement(glyph, entry, index) {
                        if (entry.flags & MARK_FIRST) this.firstGlyph = index;
                        if (entry.flags & MARK_LAST) this.lastGlyph = index;
                        reorderGlyphs(this.glyphs, entry.flags & VERB, this.firstGlyph, this.lastGlyph);
                    };
                    _proto19.processContextualSubstitution = function processContextualSubstitution(glyph, entry, index) {
                        var subsitutions = this.subtable.table.substitutionTable.items;
                        if (entry.markIndex !== 0xffff) {
                            var lookup = subsitutions.getItem(entry.markIndex);
                            var lookupTable = new AATLookupTable(lookup);
                            glyph = this.glyphs[this.markedGlyph];
                            var gid = lookupTable.lookup(glyph.id);
                            if (gid) this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
                        }
                        if (entry.currentIndex !== 0xffff) {
                            var _lookup = subsitutions.getItem(entry.currentIndex);
                            var _lookupTable = new AATLookupTable(_lookup);
                            glyph = this.glyphs[index];
                            var gid = _lookupTable.lookup(glyph.id);
                            if (gid) this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
                        }
                        if (entry.flags & SET_MARK) this.markedGlyph = index;
                    };
                    _proto19.processLigature = function processLigature(glyph, entry, index) {
                        if (entry.flags & SET_COMPONENT) this.ligatureStack.push(index);
                        if (entry.flags & PERFORM_ACTION) {
                            var _this$ligatureStack;
                            var actions = this.subtable.table.ligatureActions;
                            var components = this.subtable.table.components;
                            var ligatureList = this.subtable.table.ligatureList;
                            var actionIndex = entry.action;
                            var last = false;
                            var ligatureIndex = 0;
                            var codePoints = [];
                            var ligatureGlyphs = [];
                            while(!last){
                                var _codePoints;
                                var componentGlyph = this.ligatureStack.pop();
                                (_codePoints = codePoints).unshift.apply(_codePoints, this.glyphs[componentGlyph].codePoints);
                                var action = actions.getItem(actionIndex++);
                                last = !!(action & LAST_MASK);
                                var store = !!(action & STORE_MASK);
                                var offset = (action & OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
                                offset += this.glyphs[componentGlyph].id;
                                var component = components.getItem(offset);
                                ligatureIndex += component;
                                if (last || store) {
                                    var ligatureEntry = ligatureList.getItem(ligatureIndex);
                                    this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                                    ligatureGlyphs.push(componentGlyph);
                                    ligatureIndex = 0;
                                    codePoints = [];
                                } else this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
                            } // Put ligature glyph indexes back on the stack
                            (_this$ligatureStack = this.ligatureStack).push.apply(_this$ligatureStack, ligatureGlyphs);
                        }
                    };
                    _proto19.processNoncontextualSubstitutions = function processNoncontextualSubstitutions(subtable, glyphs, index) {
                        var lookupTable = new AATLookupTable(subtable.table.lookupTable);
                        for(index = 0; index < glyphs.length; index++){
                            var glyph = glyphs[index];
                            if (glyph.id !== 0xffff) {
                                var gid = lookupTable.lookup(glyph.id);
                                if (gid) // 0 means do nothing
                                glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
                            }
                        }
                    };
                    _proto19._insertGlyphs = function _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
                        var _this$glyphs;
                        var insertions = [];
                        while(count--){
                            var gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
                            insertions.push(this.font.getGlyph(gid));
                        }
                        if (!isBefore) glyphIndex++;
                        (_this$glyphs = this.glyphs).splice.apply(_this$glyphs, [
                            glyphIndex,
                            0
                        ].concat(insertions));
                    };
                    _proto19.processGlyphInsertion = function processGlyphInsertion(glyph, entry, index) {
                        if (entry.flags & SET_MARK) this.markedIndex = index;
                        if (entry.markedInsertIndex !== 0xffff) {
                            var count = (entry.flags & MARKED_INSERT_COUNT) >>> 5;
                            var isBefore = !!(entry.flags & MARKED_INSERT_BEFORE);
                            this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
                        }
                        if (entry.currentInsertIndex !== 0xffff) {
                            var _count = (entry.flags & CURRENT_INSERT_COUNT) >>> 5;
                            var _isBefore = !!(entry.flags & CURRENT_INSERT_BEFORE);
                            this._insertGlyphs(index, entry.currentInsertIndex, _count, _isBefore);
                        }
                    };
                    _proto19.getSupportedFeatures = function getSupportedFeatures() {
                        var features = [];
                        for(var _iterator25 = _createForOfIteratorHelperLoose(this.morx.chains), _step25; !(_step25 = _iterator25()).done;){
                            var chain = _step25.value;
                            for(var _iterator26 = _createForOfIteratorHelperLoose(chain.features), _step26; !(_step26 = _iterator26()).done;){
                                var feature = _step26.value;
                                features.push([
                                    feature.featureType,
                                    feature.featureSetting
                                ]);
                            }
                        }
                        return features;
                    };
                    _proto19.generateInputs = function generateInputs(gid) {
                        if (!this.inputCache) this.generateInputCache();
                        return this.inputCache[gid] || [];
                    };
                    _proto19.generateInputCache = function generateInputCache() {
                        this.inputCache = {};
                        for(var _iterator27 = _createForOfIteratorHelperLoose(this.morx.chains), _step27; !(_step27 = _iterator27()).done;){
                            var chain = _step27.value;
                            var flags = chain.defaultFlags;
                            for(var _iterator28 = _createForOfIteratorHelperLoose(chain.subtables), _step28; !(_step28 = _iterator28()).done;){
                                var subtable = _step28.value;
                                if (subtable.subFeatureFlags & flags) this.generateInputsForSubtable(subtable);
                            }
                        }
                    };
                    _proto19.generateInputsForSubtable = function generateInputsForSubtable(subtable) {
                        var _this3 = this;
                        // Currently, only supporting ligature subtables.
                        if (subtable.type !== 2) return;
                        var reverse = !!(subtable.coverage & REVERSE_DIRECTION);
                        if (reverse) throw new Error('Reverse subtable, not supported.');
                        this.subtable = subtable;
                        this.ligatureStack = [];
                        var stateMachine = this.getStateMachine(subtable);
                        var process = this.getProcessor();
                        var input = [];
                        var stack = [];
                        this.glyphs = [];
                        stateMachine.traverse({
                            enter: function enter(glyph, entry) {
                                var glyphs = _this3.glyphs;
                                stack.push({
                                    glyphs: glyphs.slice(),
                                    ligatureStack: _this3.ligatureStack.slice()
                                }); // Add glyph to input and glyphs to process.
                                var g = _this3.font.getGlyph(glyph);
                                input.push(g);
                                glyphs.push(input[input.length - 1]); // Process ligature substitution
                                process(glyphs[glyphs.length - 1], entry, glyphs.length - 1); // Add input to result if only one matching (non-deleted) glyph remains.
                                var count = 0;
                                var found = 0;
                                for(var i = 0; i < glyphs.length && count <= 1; i++)if (glyphs[i].id !== 0xffff) {
                                    count++;
                                    found = glyphs[i].id;
                                }
                                if (count === 1) {
                                    var result = input.map(function(g) {
                                        return g.id;
                                    });
                                    var _cache = _this3.inputCache[found];
                                    if (_cache) _cache.push(result);
                                    else _this3.inputCache[found] = [
                                        result
                                    ];
                                }
                            },
                            exit: function exit() {
                                var _stack$pop = stack.pop();
                                _this3.glyphs = _stack$pop.glyphs;
                                _this3.ligatureStack = _stack$pop.ligatureStack;
                                input.pop();
                            }
                        });
                    };
                    return AATMorxProcessor;
                }(), _applyDecoratedDescriptor(_class$2.prototype, "getStateMachine", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$2.prototype, "getStateMachine"), _class$2.prototype), _class$2);
                // reverse the glyphs inside those ranges if specified
                // ranges are in [offset, length] format
                function swap(glyphs, rangeA, rangeB, reverseA, reverseB) {
                    if (reverseA === void 0) reverseA = false;
                    if (reverseB === void 0) reverseB = false;
                    var end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
                    if (reverseB) end.reverse();
                    var start = glyphs.splice.apply(glyphs, [
                        rangeA[0],
                        rangeA[1]
                    ].concat(end));
                    if (reverseA) start.reverse();
                    glyphs.splice.apply(glyphs, [
                        rangeB[0] - (rangeA[1] - 1),
                        0
                    ].concat(start));
                    return glyphs;
                }
                function reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
                    switch(verb){
                        case 0:
                            // no change
                            return glyphs;
                        case 1:
                            // Ax => xA
                            return swap(glyphs, [
                                firstGlyph,
                                1
                            ], [
                                lastGlyph,
                                0
                            ]);
                        case 2:
                            // xD => Dx
                            return swap(glyphs, [
                                firstGlyph,
                                0
                            ], [
                                lastGlyph,
                                1
                            ]);
                        case 3:
                            // AxD => DxA
                            return swap(glyphs, [
                                firstGlyph,
                                1
                            ], [
                                lastGlyph,
                                1
                            ]);
                        case 4:
                            // ABx => xAB
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                0
                            ]);
                        case 5:
                            // ABx => xBA
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                0
                            ], true, false);
                        case 6:
                            // xCD => CDx
                            return swap(glyphs, [
                                firstGlyph,
                                0
                            ], [
                                lastGlyph,
                                2
                            ]);
                        case 7:
                            // xCD => DCx
                            return swap(glyphs, [
                                firstGlyph,
                                0
                            ], [
                                lastGlyph,
                                2
                            ], false, true);
                        case 8:
                            // AxCD => CDxA
                            return swap(glyphs, [
                                firstGlyph,
                                1
                            ], [
                                lastGlyph,
                                2
                            ]);
                        case 9:
                            // AxCD => DCxA
                            return swap(glyphs, [
                                firstGlyph,
                                1
                            ], [
                                lastGlyph,
                                2
                            ], false, true);
                        case 10:
                            // ABxD => DxAB
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                1
                            ]);
                        case 11:
                            // ABxD => DxBA
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                1
                            ], true, false);
                        case 12:
                            // ABxCD => CDxAB
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                2
                            ]);
                        case 13:
                            // ABxCD => CDxBA
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                2
                            ], true, false);
                        case 14:
                            // ABxCD => DCxAB
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                2
                            ], false, true);
                        case 15:
                            // ABxCD => DCxBA
                            return swap(glyphs, [
                                firstGlyph,
                                2
                            ], [
                                lastGlyph,
                                2
                            ], true, true);
                        default:
                            throw new Error("Unknown verb: ".concat(verb));
                    }
                }
                var AATLayoutEngine = /*#__PURE__*/ function() {
                    function AATLayoutEngine(font) {
                        this.font = font;
                        this.morxProcessor = new AATMorxProcessor(font);
                        this.fallbackPosition = false;
                    }
                    var _proto20 = AATLayoutEngine.prototype;
                    _proto20.substitute = function substitute(glyphRun) {
                        // AAT expects the glyphs to be in visual order prior to morx processing,
                        // so reverse the glyphs if the script is right-to-left.
                        if (glyphRun.direction === 'rtl') glyphRun.glyphs.reverse();
                        this.morxProcessor.process(glyphRun.glyphs, mapOTToAAT(glyphRun.features));
                    };
                    _proto20.getAvailableFeatures = function getAvailableFeatures(script, language) {
                        return mapAATToOT(this.morxProcessor.getSupportedFeatures());
                    };
                    _proto20.stringsForGlyph = function stringsForGlyph(gid) {
                        var glyphStrings = this.morxProcessor.generateInputs(gid);
                        var result = new Set();
                        for(var _iterator29 = _createForOfIteratorHelperLoose(glyphStrings), _step29; !(_step29 = _iterator29()).done;){
                            var glyphs = _step29.value;
                            this._addStrings(glyphs, 0, result, '');
                        }
                        return result;
                    };
                    _proto20._addStrings = function _addStrings(glyphs, index, strings, string) {
                        var codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
                        for(var _iterator30 = _createForOfIteratorHelperLoose(codePoints), _step30; !(_step30 = _iterator30()).done;){
                            var codePoint = _step30.value;
                            var s = string + String.fromCodePoint(codePoint);
                            if (index < glyphs.length - 1) this._addStrings(glyphs, index + 1, strings, s);
                            else strings.add(s);
                        }
                    };
                    return AATLayoutEngine;
                }();
                /**
 * ShapingPlans are used by the OpenType shapers to store which
 * features should by applied, and in what order to apply them.
 * The features are applied in groups called stages. A feature
 * can be applied globally to all glyphs, or locally to only
 * specific glyphs.
 *
 * @private
 */ var ShapingPlan = /*#__PURE__*/ function() {
                    function ShapingPlan(font, script, direction) {
                        this.font = font;
                        this.script = script;
                        this.direction = direction;
                        this.stages = [];
                        this.globalFeatures = {};
                        this.allFeatures = {};
                    }
                    /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */ var _proto21 = ShapingPlan.prototype;
                    _proto21._addFeatures = function _addFeatures(features, global) {
                        var stageIndex = this.stages.length - 1;
                        var stage = this.stages[stageIndex];
                        for(var _iterator31 = _createForOfIteratorHelperLoose(features), _step31; !(_step31 = _iterator31()).done;){
                            var feature = _step31.value;
                            if (this.allFeatures[feature] == null) {
                                stage.push(feature);
                                this.allFeatures[feature] = stageIndex;
                                if (global) this.globalFeatures[feature] = true;
                            }
                        }
                    } /**
   * Add features to the last stage
   */ ;
                    _proto21.add = function add(arg, global) {
                        if (global === void 0) global = true;
                        if (this.stages.length === 0) this.stages.push([]);
                        if (typeof arg === 'string') arg = [
                            arg
                        ];
                        if (Array.isArray(arg)) this._addFeatures(arg, global);
                        else if (typeof arg === 'object') {
                            this._addFeatures(arg.global || [], true);
                            this._addFeatures(arg.local || [], false);
                        } else throw new Error("Unsupported argument to ShapingPlan#add");
                    } /**
   * Add a new stage
   */ ;
                    _proto21.addStage = function addStage(arg, global) {
                        if (typeof arg === 'function') this.stages.push(arg, []);
                        else {
                            this.stages.push([]);
                            this.add(arg, global);
                        }
                    };
                    _proto21.setFeatureOverrides = function setFeatureOverrides(features) {
                        if (Array.isArray(features)) this.add(features);
                        else if (typeof features === 'object') for(var tag in features){
                            if (features[tag]) this.add(tag);
                            else if (this.allFeatures[tag] != null) {
                                var stage = this.stages[this.allFeatures[tag]];
                                stage.splice(stage.indexOf(tag), 1);
                                delete this.allFeatures[tag];
                                delete this.globalFeatures[tag];
                            }
                        }
                    } /**
   * Assigns the global features to the given glyphs
   */ ;
                    _proto21.assignGlobalFeatures = function assignGlobalFeatures(glyphs) {
                        for(var _iterator32 = _createForOfIteratorHelperLoose(glyphs), _step32; !(_step32 = _iterator32()).done;){
                            var glyph = _step32.value;
                            for(var feature in this.globalFeatures)glyph.features[feature] = true;
                        }
                    } /**
   * Executes the planned stages using the given OTProcessor
   */ ;
                    _proto21.process = function process(processor, glyphs, positions) {
                        for(var _iterator33 = _createForOfIteratorHelperLoose(this.stages), _step33; !(_step33 = _iterator33()).done;){
                            var stage = _step33.value;
                            if (typeof stage === 'function') {
                                if (!positions) stage(this.font, glyphs, this);
                            } else if (stage.length > 0) processor.applyFeatures(stage, glyphs, positions);
                        }
                    };
                    return ShapingPlan;
                }();
                var VARIATION_FEATURES = [
                    'rvrn'
                ];
                var COMMON_FEATURES = [
                    'ccmp',
                    'locl',
                    'rlig',
                    'mark',
                    'mkmk'
                ];
                var FRACTIONAL_FEATURES = [
                    'frac',
                    'numr',
                    'dnom'
                ];
                var HORIZONTAL_FEATURES = [
                    'calt',
                    'clig',
                    'liga',
                    'rclt',
                    'curs',
                    'kern'
                ];
                var DIRECTIONAL_FEATURES = {
                    ltr: [
                        'ltra',
                        'ltrm'
                    ],
                    rtl: [
                        'rtla',
                        'rtlm'
                    ]
                };
                var DefaultShaper = /*#__PURE__*/ function() {
                    function DefaultShaper() {}
                    DefaultShaper.plan = function plan(_plan, glyphs, features) {
                        // Plan the features we want to apply
                        this.planPreprocessing(_plan);
                        this.planFeatures(_plan);
                        this.planPostprocessing(_plan, features); // Assign the global features to all the glyphs
                        _plan.assignGlobalFeatures(glyphs); // Assign local features to glyphs
                        this.assignFeatures(_plan, glyphs);
                    };
                    DefaultShaper.planPreprocessing = function planPreprocessing(plan) {
                        plan.add({
                            global: [].concat(VARIATION_FEATURES, DIRECTIONAL_FEATURES[plan.direction]),
                            local: FRACTIONAL_FEATURES
                        });
                    };
                    DefaultShaper.planFeatures = function planFeatures(plan) {};
                    DefaultShaper.planPostprocessing = function planPostprocessing(plan, userFeatures) {
                        plan.add([].concat(COMMON_FEATURES, HORIZONTAL_FEATURES));
                        plan.setFeatureOverrides(userFeatures);
                    };
                    DefaultShaper.assignFeatures = function assignFeatures(plan, glyphs) {
                        // Enable contextual fractions
                        for(var i = 0; i < glyphs.length; i++){
                            var glyph = glyphs[i];
                            if (glyph.codePoints[0] === 0x2044) {
                                // fraction slash
                                var start = i;
                                var end = i + 1; // Apply numerator
                                while(start > 0 && unicode.isDigit(glyphs[start - 1].codePoints[0])){
                                    glyphs[start - 1].features.numr = true;
                                    glyphs[start - 1].features.frac = true;
                                    start--;
                                } // Apply denominator
                                while(end < glyphs.length && unicode.isDigit(glyphs[end].codePoints[0])){
                                    glyphs[end].features.dnom = true;
                                    glyphs[end].features.frac = true;
                                    end++;
                                } // Apply fraction slash
                                glyph.features.frac = true;
                                i = end - 1;
                            }
                        }
                    };
                    return DefaultShaper;
                }();
                _defineProperty(DefaultShaper, "zeroMarkWidths", 'AFTER_GPOS');
                var trie = new UnicodeTrie(Buffer("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ==", "base64"));
                var FEATURES = [
                    'isol',
                    'fina',
                    'fin2',
                    'fin3',
                    'medi',
                    'med2',
                    'init'
                ];
                var ShapingClasses = {
                    Non_Joining: 0,
                    Left_Joining: 1,
                    Right_Joining: 2,
                    Dual_Joining: 3,
                    Join_Causing: 3,
                    ALAPH: 4,
                    'DALATH RISH': 5,
                    Transparent: 6
                };
                var ISOL = 'isol';
                var FINA = 'fina';
                var FIN2 = 'fin2';
                var FIN3 = 'fin3';
                var MEDI = 'medi';
                var MED2 = 'med2';
                var INIT = 'init';
                var NONE = null; // Each entry is [prevAction, curAction, nextState]
                var STATE_TABLE = [
                    //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
                    // State 0: prev was U,  not willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            ISOL,
                            1
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            ISOL,
                            1
                        ],
                        [
                            NONE,
                            ISOL,
                            6
                        ]
                    ],
                    // State 1: prev was R or ISOL/ALAPH,  not willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            ISOL,
                            1
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            FIN2,
                            5
                        ],
                        [
                            NONE,
                            ISOL,
                            6
                        ]
                    ],
                    // State 2: prev was D/L in ISOL form,  willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            INIT,
                            FINA,
                            1
                        ],
                        [
                            INIT,
                            FINA,
                            3
                        ],
                        [
                            INIT,
                            FINA,
                            4
                        ],
                        [
                            INIT,
                            FINA,
                            6
                        ]
                    ],
                    // State 3: prev was D in FINA form,  willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            MEDI,
                            FINA,
                            1
                        ],
                        [
                            MEDI,
                            FINA,
                            3
                        ],
                        [
                            MEDI,
                            FINA,
                            4
                        ],
                        [
                            MEDI,
                            FINA,
                            6
                        ]
                    ],
                    // State 4: prev was FINA ALAPH,  not willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            MED2,
                            ISOL,
                            1
                        ],
                        [
                            MED2,
                            ISOL,
                            2
                        ],
                        [
                            MED2,
                            FIN2,
                            5
                        ],
                        [
                            MED2,
                            ISOL,
                            6
                        ]
                    ],
                    // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            ISOL,
                            ISOL,
                            1
                        ],
                        [
                            ISOL,
                            ISOL,
                            2
                        ],
                        [
                            ISOL,
                            FIN2,
                            5
                        ],
                        [
                            ISOL,
                            ISOL,
                            6
                        ]
                    ],
                    // State 6: prev was DALATH/RISH,  not willing to join.
                    [
                        [
                            NONE,
                            NONE,
                            0
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            ISOL,
                            1
                        ],
                        [
                            NONE,
                            ISOL,
                            2
                        ],
                        [
                            NONE,
                            FIN3,
                            5
                        ],
                        [
                            NONE,
                            ISOL,
                            6
                        ]
                    ]
                ];
                /**
 * This is a shaper for Arabic, and other cursive scripts.
 * It uses data from ArabicShaping.txt in the Unicode database,
 * compiled to a UnicodeTrie by generate-data.coffee.
 *
 * The shaping state machine was ported from Harfbuzz.
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-arabic.cc
 */ var ArabicShaper = /*#__PURE__*/ function(_DefaultShaper) {
                    function ArabicShaper() {
                        return _DefaultShaper.apply(this, arguments) || this;
                    }
                    _inheritsLoose(ArabicShaper, _DefaultShaper);
                    ArabicShaper.planFeatures = function planFeatures(plan) {
                        plan.add([
                            'ccmp',
                            'locl'
                        ]);
                        for(var i = 0; i < FEATURES.length; i++){
                            var feature = FEATURES[i];
                            plan.addStage(feature, false);
                        }
                        plan.addStage('mset');
                    };
                    ArabicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
                        _DefaultShaper.assignFeatures.call(this, plan, glyphs);
                        var prev = -1;
                        var state = 0;
                        var actions = []; // Apply the state machine to map glyphs to features
                        for(var i = 0; i < glyphs.length; i++){
                            var curAction = void 0, prevAction = void 0;
                            var glyph = glyphs[i];
                            var type = getShapingClass(glyph.codePoints[0]);
                            if (type === ShapingClasses.Transparent) {
                                actions[i] = NONE;
                                continue;
                            }
                            var _STATE_TABLE$state$ty = STATE_TABLE[state][type];
                            prevAction = _STATE_TABLE$state$ty[0];
                            curAction = _STATE_TABLE$state$ty[1];
                            state = _STATE_TABLE$state$ty[2];
                            if (prevAction !== NONE && prev !== -1) actions[prev] = prevAction;
                            actions[i] = curAction;
                            prev = i;
                        } // Apply the chosen features to their respective glyphs
                        for(var index = 0; index < glyphs.length; index++){
                            var feature = void 0;
                            var glyph = glyphs[index];
                            if (feature = actions[index]) glyph.features[feature] = true;
                        }
                    };
                    return ArabicShaper;
                }(DefaultShaper);
                function getShapingClass(codePoint) {
                    var res = trie.get(codePoint);
                    if (res) return res - 1;
                    var category = unicode.getCategory(codePoint);
                    if (category === 'Mn' || category === 'Me' || category === 'Cf') return ShapingClasses.Transparent;
                    return ShapingClasses.Non_Joining;
                }
                var GlyphIterator = /*#__PURE__*/ function() {
                    function GlyphIterator(glyphs, options) {
                        this.glyphs = glyphs;
                        this.reset(options);
                    }
                    var _proto22 = GlyphIterator.prototype;
                    _proto22.reset = function reset(options, index) {
                        if (options === void 0) options = {};
                        if (index === void 0) index = 0;
                        this.options = options;
                        this.flags = options.flags || {};
                        this.markAttachmentType = options.markAttachmentType || 0;
                        this.index = index;
                    };
                    _proto22.shouldIgnore = function shouldIgnore(glyph) {
                        return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
                    };
                    _proto22.move = function move(dir) {
                        this.index += dir;
                        while(0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]))this.index += dir;
                        if (0 > this.index || this.index >= this.glyphs.length) return null;
                        return this.glyphs[this.index];
                    };
                    _proto22.next = function next() {
                        return this.move(1);
                    };
                    _proto22.prev = function prev() {
                        return this.move(-1);
                    };
                    _proto22.peek = function peek(count) {
                        if (count === void 0) count = 1;
                        var idx = this.index;
                        var res = this.increment(count);
                        this.index = idx;
                        return res;
                    };
                    _proto22.peekIndex = function peekIndex(count) {
                        if (count === void 0) count = 1;
                        var idx = this.index;
                        this.increment(count);
                        var res = this.index;
                        this.index = idx;
                        return res;
                    };
                    _proto22.increment = function increment(count) {
                        if (count === void 0) count = 1;
                        var dir = count < 0 ? -1 : 1;
                        count = Math.abs(count);
                        while(count--)this.move(dir);
                        return this.glyphs[this.index];
                    };
                    return _createClass(GlyphIterator, [
                        {
                            key: "cur",
                            get: function get() {
                                return this.glyphs[this.index] || null;
                            }
                        }
                    ]);
                }();
                var DEFAULT_SCRIPTS = [
                    'DFLT',
                    'dflt',
                    'latn'
                ];
                var OTProcessor = /*#__PURE__*/ function() {
                    function OTProcessor(font, table) {
                        this.font = font;
                        this.table = table;
                        this.script = null;
                        this.scriptTag = null;
                        this.language = null;
                        this.languageTag = null;
                        this.features = {};
                        this.lookups = {}; // Setup variation substitutions
                        this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1; // initialize to default script + language
                        this.selectScript(); // current context (set by applyFeatures)
                        this.glyphs = [];
                        this.positions = []; // only used by GPOS
                        this.ligatureID = 1;
                        this.currentFeature = null;
                    }
                    var _proto23 = OTProcessor.prototype;
                    _proto23.findScript = function findScript(script) {
                        if (this.table.scriptList == null) return null;
                        if (!Array.isArray(script)) script = [
                            script
                        ];
                        for(var _iterator34 = _createForOfIteratorHelperLoose(script), _step34; !(_step34 = _iterator34()).done;){
                            var s = _step34.value;
                            for(var _iterator35 = _createForOfIteratorHelperLoose(this.table.scriptList), _step35; !(_step35 = _iterator35()).done;){
                                var entry = _step35.value;
                                if (entry.tag === s) return entry;
                            }
                        }
                        return null;
                    };
                    _proto23.selectScript = function selectScript(script, language, direction$1) {
                        var changed = false;
                        var entry;
                        if (!this.script || script !== this.scriptTag) {
                            entry = this.findScript(script);
                            if (!entry) entry = this.findScript(DEFAULT_SCRIPTS);
                            if (!entry) return this.scriptTag;
                            this.scriptTag = entry.tag;
                            this.script = entry.script;
                            this.language = null;
                            this.languageTag = null;
                            changed = true;
                        }
                        if (!direction$1 || direction$1 !== this.direction) this.direction = direction$1 || direction(script);
                        if (language && language.length < 4) language += ' '.repeat(4 - language.length);
                        if (!language || language !== this.languageTag) {
                            this.language = null;
                            for(var _iterator36 = _createForOfIteratorHelperLoose(this.script.langSysRecords), _step36; !(_step36 = _iterator36()).done;){
                                var lang = _step36.value;
                                if (lang.tag === language) {
                                    this.language = lang.langSys;
                                    this.languageTag = lang.tag;
                                    break;
                                }
                            }
                            if (!this.language) {
                                this.language = this.script.defaultLangSys;
                                this.languageTag = null;
                            }
                            changed = true;
                        } // Build a feature lookup table
                        if (changed) {
                            this.features = {};
                            if (this.language) for(var _iterator37 = _createForOfIteratorHelperLoose(this.language.featureIndexes), _step37; !(_step37 = _iterator37()).done;){
                                var featureIndex = _step37.value;
                                var record = this.table.featureList[featureIndex];
                                var substituteFeature = this.substituteFeatureForVariations(featureIndex);
                                this.features[record.tag] = substituteFeature || record.feature;
                            }
                        }
                        return this.scriptTag;
                    };
                    _proto23.lookupsForFeatures = function lookupsForFeatures(userFeatures, exclude) {
                        if (userFeatures === void 0) userFeatures = [];
                        var lookups = [];
                        for(var _iterator38 = _createForOfIteratorHelperLoose(userFeatures), _step38; !(_step38 = _iterator38()).done;){
                            var tag = _step38.value;
                            var feature = this.features[tag];
                            if (!feature) continue;
                            for(var _iterator39 = _createForOfIteratorHelperLoose(feature.lookupListIndexes), _step39; !(_step39 = _iterator39()).done;){
                                var lookupIndex = _step39.value;
                                if (exclude && exclude.indexOf(lookupIndex) !== -1) continue;
                                lookups.push({
                                    feature: tag,
                                    index: lookupIndex,
                                    lookup: this.table.lookupList.get(lookupIndex)
                                });
                            }
                        }
                        lookups.sort(function(a, b) {
                            return a.index - b.index;
                        });
                        return lookups;
                    };
                    _proto23.substituteFeatureForVariations = function substituteFeatureForVariations(featureIndex) {
                        if (this.variationsIndex === -1) return null;
                        var record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
                        var substitutions = record.featureTableSubstitution.substitutions;
                        for(var _iterator40 = _createForOfIteratorHelperLoose(substitutions), _step40; !(_step40 = _iterator40()).done;){
                            var substitution = _step40.value;
                            if (substitution.featureIndex === featureIndex) return substitution.alternateFeatureTable;
                        }
                        return null;
                    };
                    _proto23.findVariationsIndex = function findVariationsIndex(coords) {
                        var variations = this.table.featureVariations;
                        if (!variations) return -1;
                        var records = variations.featureVariationRecords;
                        for(var i = 0; i < records.length; i++){
                            var conditions = records[i].conditionSet.conditionTable;
                            if (this.variationConditionsMatch(conditions, coords)) return i;
                        }
                        return -1;
                    };
                    _proto23.variationConditionsMatch = function variationConditionsMatch(conditions, coords) {
                        return conditions.every(function(condition) {
                            var coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
                            return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
                        });
                    };
                    _proto23.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
                        var lookups = this.lookupsForFeatures(userFeatures);
                        this.applyLookups(lookups, glyphs, advances);
                    };
                    _proto23.applyLookups = function applyLookups(lookups, glyphs, positions) {
                        this.glyphs = glyphs;
                        this.positions = positions;
                        this.glyphIterator = new GlyphIterator(glyphs);
                        for(var _iterator41 = _createForOfIteratorHelperLoose(lookups), _step41; !(_step41 = _iterator41()).done;){
                            var _step41$value = _step41.value, feature = _step41$value.feature, lookup = _step41$value.lookup;
                            this.currentFeature = feature;
                            this.glyphIterator.reset(lookup.flags);
                            while(this.glyphIterator.index < glyphs.length){
                                if (!(feature in this.glyphIterator.cur.features)) {
                                    this.glyphIterator.next();
                                    continue;
                                }
                                for(var _iterator42 = _createForOfIteratorHelperLoose(lookup.subTables), _step42; !(_step42 = _iterator42()).done;){
                                    var table = _step42.value;
                                    var res = this.applyLookup(lookup.lookupType, table);
                                    if (res) break;
                                }
                                this.glyphIterator.next();
                            }
                        }
                    };
                    _proto23.applyLookup = function applyLookup(lookup, table) {
                        throw new Error("applyLookup must be implemented by subclasses");
                    };
                    _proto23.applyLookupList = function applyLookupList(lookupRecords) {
                        var options = this.glyphIterator.options;
                        var glyphIndex = this.glyphIterator.index;
                        for(var _iterator43 = _createForOfIteratorHelperLoose(lookupRecords), _step43; !(_step43 = _iterator43()).done;){
                            var lookupRecord = _step43.value;
                            // Reset flags and find glyph index for this lookup record
                            this.glyphIterator.reset(options, glyphIndex);
                            this.glyphIterator.increment(lookupRecord.sequenceIndex); // Get the lookup and setup flags for subtables
                            var lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
                            this.glyphIterator.reset(lookup.flags, this.glyphIterator.index); // Apply lookup subtables until one matches
                            for(var _iterator44 = _createForOfIteratorHelperLoose(lookup.subTables), _step44; !(_step44 = _iterator44()).done;){
                                var table = _step44.value;
                                if (this.applyLookup(lookup.lookupType, table)) break;
                            }
                        }
                        this.glyphIterator.reset(options, glyphIndex);
                        return true;
                    };
                    _proto23.coverageIndex = function coverageIndex(coverage, glyph) {
                        if (glyph == null) glyph = this.glyphIterator.cur.id;
                        switch(coverage.version){
                            case 1:
                                return coverage.glyphs.indexOf(glyph);
                            case 2:
                                for(var _iterator45 = _createForOfIteratorHelperLoose(coverage.rangeRecords), _step45; !(_step45 = _iterator45()).done;){
                                    var range = _step45.value;
                                    if (range.start <= glyph && glyph <= range.end) return range.startCoverageIndex + glyph - range.start;
                                }
                                break;
                        }
                        return -1;
                    };
                    _proto23.match = function match(sequenceIndex, sequence, fn, matched) {
                        var pos = this.glyphIterator.index;
                        var glyph = this.glyphIterator.increment(sequenceIndex);
                        var idx = 0;
                        while(idx < sequence.length && glyph && fn(sequence[idx], glyph)){
                            if (matched) matched.push(this.glyphIterator.index);
                            idx++;
                            glyph = this.glyphIterator.next();
                        }
                        this.glyphIterator.index = pos;
                        if (idx < sequence.length) return false;
                        return matched || true;
                    };
                    _proto23.sequenceMatches = function sequenceMatches(sequenceIndex, sequence) {
                        return this.match(sequenceIndex, sequence, function(component, glyph) {
                            return component === glyph.id;
                        });
                    };
                    _proto23.sequenceMatchIndices = function sequenceMatchIndices(sequenceIndex, sequence) {
                        var _this4 = this;
                        return this.match(sequenceIndex, sequence, function(component, glyph) {
                            // If the current feature doesn't apply to this glyph,
                            if (!(_this4.currentFeature in glyph.features)) return false;
                            return component === glyph.id;
                        }, []);
                    };
                    _proto23.coverageSequenceMatches = function coverageSequenceMatches(sequenceIndex, sequence) {
                        var _this5 = this;
                        return this.match(sequenceIndex, sequence, function(coverage, glyph) {
                            return _this5.coverageIndex(coverage, glyph.id) >= 0;
                        });
                    };
                    _proto23.getClassID = function getClassID(glyph, classDef) {
                        switch(classDef.version){
                            case 1:
                                // Class array
                                var i = glyph - classDef.startGlyph;
                                if (i >= 0 && i < classDef.classValueArray.length) return classDef.classValueArray[i];
                                break;
                            case 2:
                                for(var _iterator46 = _createForOfIteratorHelperLoose(classDef.classRangeRecord), _step46; !(_step46 = _iterator46()).done;){
                                    var range = _step46.value;
                                    if (range.start <= glyph && glyph <= range.end) return range.class;
                                }
                                break;
                        }
                        return 0;
                    };
                    _proto23.classSequenceMatches = function classSequenceMatches(sequenceIndex, sequence, classDef) {
                        var _this6 = this;
                        return this.match(sequenceIndex, sequence, function(classID, glyph) {
                            return classID === _this6.getClassID(glyph.id, classDef);
                        });
                    };
                    _proto23.applyContext = function applyContext(table) {
                        switch(table.version){
                            case 1:
                                var index = this.coverageIndex(table.coverage);
                                if (index === -1) return false;
                                var set = table.ruleSets[index];
                                for(var _iterator47 = _createForOfIteratorHelperLoose(set), _step47; !(_step47 = _iterator47()).done;){
                                    var rule = _step47.value;
                                    if (this.sequenceMatches(1, rule.input)) return this.applyLookupList(rule.lookupRecords);
                                }
                                break;
                            case 2:
                                if (this.coverageIndex(table.coverage) === -1) return false;
                                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
                                if (index === -1) return false;
                                set = table.classSet[index];
                                for(var _iterator48 = _createForOfIteratorHelperLoose(set), _step48; !(_step48 = _iterator48()).done;){
                                    var _rule = _step48.value;
                                    if (this.classSequenceMatches(1, _rule.classes, table.classDef)) return this.applyLookupList(_rule.lookupRecords);
                                }
                                break;
                            case 3:
                                if (this.coverageSequenceMatches(0, table.coverages)) return this.applyLookupList(table.lookupRecords);
                                break;
                        }
                        return false;
                    };
                    _proto23.applyChainingContext = function applyChainingContext(table) {
                        switch(table.version){
                            case 1:
                                var index = this.coverageIndex(table.coverage);
                                if (index === -1) return false;
                                var set = table.chainRuleSets[index];
                                for(var _iterator49 = _createForOfIteratorHelperLoose(set), _step49; !(_step49 = _iterator49()).done;){
                                    var rule = _step49.value;
                                    if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) return this.applyLookupList(rule.lookupRecords);
                                }
                                break;
                            case 2:
                                if (this.coverageIndex(table.coverage) === -1) return false;
                                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                                var rules = table.chainClassSet[index];
                                if (!rules) return false;
                                for(var _iterator50 = _createForOfIteratorHelperLoose(rules), _step50; !(_step50 = _iterator50()).done;){
                                    var _rule2 = _step50.value;
                                    if (this.classSequenceMatches(-_rule2.backtrack.length, _rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, _rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + _rule2.input.length, _rule2.lookahead, table.lookaheadClassDef)) return this.applyLookupList(_rule2.lookupRecords);
                                }
                                break;
                            case 3:
                                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) return this.applyLookupList(table.lookupRecords);
                                break;
                        }
                        return false;
                    };
                    return OTProcessor;
                }();
                var GlyphInfo = /*#__PURE__*/ function() {
                    function GlyphInfo(font, id, codePoints, features) {
                        if (codePoints === void 0) codePoints = [];
                        this._font = font;
                        this.codePoints = codePoints;
                        this.id = id;
                        this.features = {};
                        if (Array.isArray(features)) for(var i = 0; i < features.length; i++){
                            var feature = features[i];
                            this.features[feature] = true;
                        }
                        else if (typeof features === 'object') Object.assign(this.features, features);
                        this.ligatureID = null;
                        this.ligatureComponent = null;
                        this.isLigated = false;
                        this.cursiveAttachment = null;
                        this.markAttachment = null;
                        this.shaperInfo = null;
                        this.substituted = false;
                        this.isMultiplied = false;
                    }
                    var _proto24 = GlyphInfo.prototype;
                    _proto24.copy = function copy() {
                        return new GlyphInfo(this._font, this.id, this.codePoints, this.features);
                    };
                    return _createClass(GlyphInfo, [
                        {
                            key: "id",
                            get: function get() {
                                return this._id;
                            },
                            set: function set(id) {
                                this._id = id;
                                this.substituted = true;
                                var GDEF = this._font.GDEF;
                                if (GDEF && GDEF.glyphClassDef) {
                                    // TODO: clean this up
                                    var classID = OTProcessor.prototype.getClassID(id, GDEF.glyphClassDef);
                                    this.isBase = classID === 1;
                                    this.isLigature = classID === 2;
                                    this.isMark = classID === 3;
                                    this.markAttachmentType = GDEF.markAttachClassDef ? OTProcessor.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
                                } else {
                                    this.isMark = this.codePoints.length > 0 && this.codePoints.every(unicode.isMark);
                                    this.isBase = !this.isMark;
                                    this.isLigature = this.codePoints.length > 1;
                                    this.markAttachmentType = 0;
                                }
                            }
                        }
                    ]);
                }();
                /**
 * This is a shaper for the Hangul script, used by the Korean language.
 * It does the following:
 *   - decompose if unsupported by the font:
 *     <LV>   -> <L,V>
 *     <LVT>  -> <L,V,T>
 *     <LV,T> -> <L,V,T>
 *
 *   - compose if supported by the font:
 *     <L,V>   -> <LV>
 *     <L,V,T> -> <LVT>
 *     <LV,T>  -> <LVT>
 *
 *   - reorder tone marks (S is any valid syllable):
 *     <S, M> -> <M, S>
 *
 *   - apply ljmo, vjmo, and tjmo OpenType features to decomposed Jamo sequences.
 *
 * This logic is based on the following documents:
 *   - http://www.microsoft.com/typography/OpenTypeDev/hangul/intro.htm
 *   - http://ktug.org/~nomos/harfbuzz-hangul/hangulshaper.pdf
 */ var HangulShaper = /*#__PURE__*/ function(_DefaultShaper2) {
                    function HangulShaper() {
                        return _DefaultShaper2.apply(this, arguments) || this;
                    }
                    _inheritsLoose(HangulShaper, _DefaultShaper2);
                    HangulShaper.planFeatures = function planFeatures(plan) {
                        plan.add([
                            'ljmo',
                            'vjmo',
                            'tjmo'
                        ], false);
                    };
                    HangulShaper.assignFeatures = function assignFeatures(plan, glyphs) {
                        var state = 0;
                        var i = 0;
                        while(i < glyphs.length){
                            var action = void 0;
                            var glyph = glyphs[i];
                            var code = glyph.codePoints[0];
                            var type = getType(code);
                            var _STATE_TABLE$1$state$ = STATE_TABLE$1[state][type];
                            action = _STATE_TABLE$1$state$[0];
                            state = _STATE_TABLE$1$state$[1];
                            switch(action){
                                case DECOMPOSE:
                                    // Decompose the composed syllable if it is not supported by the font.
                                    if (!plan.font.hasGlyphForCodePoint(code)) i = decompose(glyphs, i, plan.font);
                                    break;
                                case COMPOSE:
                                    // Found a decomposed syllable. Try to compose if supported by the font.
                                    i = compose(glyphs, i, plan.font);
                                    break;
                                case TONE_MARK:
                                    // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
                                    reorderToneMark(glyphs, i, plan.font);
                                    break;
                                case INVALID:
                                    // Tone mark has no valid syllable to attach to, so insert a dotted circle
                                    i = insertDottedCircle(glyphs, i, plan.font);
                                    break;
                            }
                            i++;
                        }
                    };
                    return HangulShaper;
                }(DefaultShaper);
                _defineProperty(HangulShaper, "zeroMarkWidths", 'NONE');
                var HANGUL_BASE = 0xac00;
                var HANGUL_END = 0xd7a4;
                var HANGUL_COUNT = HANGUL_END - HANGUL_BASE + 1;
                var L_BASE = 0x1100; // lead
                var V_BASE = 0x1161; // vowel
                var T_BASE = 0x11a7; // trail
                var L_COUNT = 19;
                var V_COUNT = 21;
                var T_COUNT = 28;
                var L_END = L_BASE + L_COUNT - 1;
                var V_END = V_BASE + V_COUNT - 1;
                var T_END = T_BASE + T_COUNT - 1;
                var DOTTED_CIRCLE = 0x25cc;
                var isL = function isL(code) {
                    return 0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
                };
                var isV = function isV(code) {
                    return 0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
                };
                var isT = function isT(code) {
                    return 0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
                };
                var isTone = function isTone(code) {
                    return 0x302e <= code && code <= 0x302f;
                };
                var isLVT = function isLVT(code) {
                    return HANGUL_BASE <= code && code <= HANGUL_END;
                };
                var isLV = function isLV(code) {
                    return code - HANGUL_BASE < HANGUL_COUNT && (code - HANGUL_BASE) % T_COUNT === 0;
                };
                var isCombiningL = function isCombiningL(code) {
                    return L_BASE <= code && code <= L_END;
                };
                var isCombiningV = function isCombiningV(code) {
                    return V_BASE <= code && code <= V_END;
                };
                var isCombiningT = function isCombiningT(code) {
                    return 1 <= code && code <= T_END;
                }; // Character categories
                var X = 0; // Other character
                var L = 1; // Leading consonant
                var V = 2; // Medial vowel
                var T = 3; // Trailing consonant
                var LV = 4; // Composed <LV> syllable
                var LVT = 5; // Composed <LVT> syllable
                var M = 6; // Tone mark
                // This function classifies a character using the above categories.
                function getType(code) {
                    if (isL(code)) return L;
                    if (isV(code)) return V;
                    if (isT(code)) return T;
                    if (isLV(code)) return LV;
                    if (isLVT(code)) return LVT;
                    if (isTone(code)) return M;
                    return X;
                } // State machine actions
                var NO_ACTION = 0;
                var DECOMPOSE = 1;
                var COMPOSE = 2;
                var TONE_MARK = 4;
                var INVALID = 5; // Build a state machine that accepts valid syllables, and applies actions along the way.
                // The logic this is implementing is documented at the top of the file.
                var STATE_TABLE$1 = [
                    //       X                 L                 V                T                  LV                LVT               M
                    // State 0: start state
                    [
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            1
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            DECOMPOSE,
                            2
                        ],
                        [
                            DECOMPOSE,
                            3
                        ],
                        [
                            INVALID,
                            0
                        ]
                    ],
                    // State 1: <L>
                    [
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            1
                        ],
                        [
                            COMPOSE,
                            2
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            DECOMPOSE,
                            2
                        ],
                        [
                            DECOMPOSE,
                            3
                        ],
                        [
                            INVALID,
                            0
                        ]
                    ],
                    // State 2: <L,V> or <LV>
                    [
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            1
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            COMPOSE,
                            3
                        ],
                        [
                            DECOMPOSE,
                            2
                        ],
                        [
                            DECOMPOSE,
                            3
                        ],
                        [
                            TONE_MARK,
                            0
                        ]
                    ],
                    // State 3: <L,V,T> or <LVT>
                    [
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            1
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            NO_ACTION,
                            0
                        ],
                        [
                            DECOMPOSE,
                            2
                        ],
                        [
                            DECOMPOSE,
                            3
                        ],
                        [
                            TONE_MARK,
                            0
                        ]
                    ]
                ];
                function getGlyph(font, code, features) {
                    return new GlyphInfo(font, font.glyphForCodePoint(code).id, [
                        code
                    ], features);
                }
                function decompose(glyphs, i, font) {
                    var glyph = glyphs[i];
                    var code = glyph.codePoints[0];
                    var s = code - HANGUL_BASE;
                    var t = T_BASE + s % T_COUNT;
                    s = s / T_COUNT | 0;
                    var l = L_BASE + s / V_COUNT | 0;
                    var v = V_BASE + s % V_COUNT; // Don't decompose if all of the components are not available
                    if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== T_BASE && !font.hasGlyphForCodePoint(t)) return i;
                     // Replace the current glyph with decomposed L, V, and T glyphs,
                    // and apply the proper OpenType features to each component.
                    var ljmo = getGlyph(font, l, glyph.features);
                    ljmo.features.ljmo = true;
                    var vjmo = getGlyph(font, v, glyph.features);
                    vjmo.features.vjmo = true;
                    var insert = [
                        ljmo,
                        vjmo
                    ];
                    if (t > T_BASE) {
                        var tjmo = getGlyph(font, t, glyph.features);
                        tjmo.features.tjmo = true;
                        insert.push(tjmo);
                    }
                    glyphs.splice.apply(glyphs, [
                        i,
                        1
                    ].concat(insert));
                    return i + insert.length - 1;
                }
                function compose(glyphs, i, font) {
                    var glyph = glyphs[i];
                    var code = glyphs[i].codePoints[0];
                    var type = getType(code);
                    var prev = glyphs[i - 1].codePoints[0];
                    var prevType = getType(prev); // Figure out what type of syllable we're dealing with
                    var lv, ljmo, vjmo, tjmo;
                    if (prevType === LV && type === T) {
                        // <LV,T>
                        lv = prev;
                        tjmo = glyph;
                    } else {
                        if (type === V) {
                            // <L,V>
                            ljmo = glyphs[i - 1];
                            vjmo = glyph;
                        } else {
                            // <L,V,T>
                            ljmo = glyphs[i - 2];
                            vjmo = glyphs[i - 1];
                            tjmo = glyph;
                        }
                        var l = ljmo.codePoints[0];
                        var v = vjmo.codePoints[0]; // Make sure L and V are combining characters
                        if (isCombiningL(l) && isCombiningV(v)) lv = HANGUL_BASE + ((l - L_BASE) * V_COUNT + (v - V_BASE)) * T_COUNT;
                    }
                    var t = tjmo && tjmo.codePoints[0] || T_BASE;
                    if (lv != null && (t === T_BASE || isCombiningT(t))) {
                        var s = lv + (t - T_BASE); // Replace with a composed glyph if supported by the font,
                        // otherwise apply the proper OpenType features to each component.
                        if (font.hasGlyphForCodePoint(s)) {
                            var del = prevType === V ? 3 : 2;
                            glyphs.splice(i - del + 1, del, getGlyph(font, s, glyph.features));
                            return i - del + 1;
                        }
                    } // Didn't compose (either a non-combining component or unsupported by font).
                    if (ljmo) ljmo.features.ljmo = true;
                    if (vjmo) vjmo.features.vjmo = true;
                    if (tjmo) tjmo.features.tjmo = true;
                    if (prevType === LV) {
                        // Sequence was originally <L,V>, which got combined earlier.
                        // Either the T was non-combining, or the LVT glyph wasn't supported.
                        // Decompose the glyph again and apply OT features.
                        decompose(glyphs, i - 1, font);
                        return i + 1;
                    }
                    return i;
                }
                function getLength(code) {
                    switch(getType(code)){
                        case LV:
                        case LVT:
                            return 1;
                        case V:
                            return 2;
                        case T:
                            return 3;
                    }
                }
                function reorderToneMark(glyphs, i, font) {
                    var glyph = glyphs[i];
                    var code = glyphs[i].codePoints[0]; // Move tone mark to the beginning of the previous syllable, unless it is zero width
                    if (font.glyphForCodePoint(code).advanceWidth === 0) return;
                    var prev = glyphs[i - 1].codePoints[0];
                    var len = getLength(prev);
                    glyphs.splice(i, 1);
                    return glyphs.splice(i - len, 0, glyph);
                }
                function insertDottedCircle(glyphs, i, font) {
                    var glyph = glyphs[i];
                    var code = glyphs[i].codePoints[0];
                    if (font.hasGlyphForCodePoint(DOTTED_CIRCLE)) {
                        var dottedCircle = getGlyph(font, DOTTED_CIRCLE, glyph.features); // If the tone mark is zero width, insert the dotted circle before, otherwise after
                        var idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
                        glyphs.splice(idx, 0, dottedCircle);
                        i++;
                    }
                    return i;
                }
                var stateTable = [
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        0,
                        10,
                        11,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17
                    ],
                    [
                        0,
                        0,
                        0,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        25,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        35,
                        36,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        38,
                        5,
                        7,
                        7,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        13,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        39,
                        0,
                        0,
                        0,
                        40,
                        41,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        39,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        12,
                        43,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        45,
                        46,
                        47,
                        48,
                        49,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        50,
                        0,
                        0,
                        51,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        52,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        53,
                        54,
                        55,
                        56,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        60,
                        61,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        4,
                        5,
                        7,
                        7,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        13,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        63,
                        64,
                        0,
                        0,
                        40,
                        41,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        63,
                        0,
                        0
                    ],
                    [
                        0,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        0,
                        10,
                        11,
                        11,
                        12,
                        13,
                        0,
                        2,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        18,
                        65,
                        20,
                        21,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        25,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        69,
                        0,
                        70,
                        70,
                        0,
                        71,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        73,
                        19,
                        74,
                        74,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        0,
                        0,
                        76,
                        77,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        79,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        25,
                        79,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        18,
                        19,
                        20,
                        74,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        25,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        81,
                        82,
                        83,
                        84,
                        85,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        86,
                        0,
                        0,
                        87,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        88,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        18,
                        19,
                        74,
                        74,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        89,
                        90,
                        0,
                        0,
                        76,
                        77,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        89,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        94,
                        29,
                        95,
                        31,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        36,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        96,
                        0,
                        0,
                        0,
                        97,
                        98,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        96,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        100,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        35,
                        100,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        100,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        100,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        102,
                        103,
                        104,
                        105,
                        106,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        107,
                        0,
                        0,
                        108,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        109,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        28,
                        29,
                        95,
                        31,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        36,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        110,
                        111,
                        0,
                        0,
                        97,
                        98,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        110,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        5,
                        7,
                        7,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        13,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        115,
                        116,
                        117,
                        118,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        119,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        39,
                        0,
                        122,
                        0,
                        123,
                        123,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        39,
                        0,
                        0
                    ],
                    [
                        0,
                        124,
                        64,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        124,
                        0,
                        0
                    ],
                    [
                        0,
                        39,
                        0,
                        0,
                        0,
                        121,
                        125,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        39,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        126,
                        126,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        46,
                        47,
                        48,
                        49,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        47,
                        47,
                        49,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        127,
                        127,
                        49,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        128,
                        127,
                        127,
                        49,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        129,
                        130,
                        131,
                        132,
                        133,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        50,
                        0,
                        0,
                        0,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        134,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        135,
                        54,
                        56,
                        56,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        61,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        136,
                        0,
                        0,
                        0,
                        137,
                        138,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        136,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        140,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        60,
                        140,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        140,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        140,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        142,
                        143,
                        144,
                        145,
                        146,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        147,
                        0,
                        0,
                        148,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        149,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        53,
                        54,
                        56,
                        56,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        61,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        150,
                        151,
                        0,
                        0,
                        137,
                        138,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        150,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        155,
                        116,
                        156,
                        157,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        158,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        3,
                        4,
                        5,
                        159,
                        160,
                        8,
                        161,
                        0,
                        162,
                        0,
                        11,
                        12,
                        163,
                        0,
                        75,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        40,
                        164,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        165,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        165,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        124,
                        64,
                        0,
                        0,
                        40,
                        164,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        124,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        70,
                        70,
                        0,
                        71,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        71,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        166,
                        0,
                        0,
                        167,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        168,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        19,
                        74,
                        74,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        26,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        79,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        79,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        169,
                        170,
                        171,
                        172,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        173,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        176,
                        0,
                        177,
                        177,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        178,
                        90,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        178,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        0,
                        0,
                        175,
                        179,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        180,
                        180,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        82,
                        83,
                        84,
                        85,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        83,
                        83,
                        85,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        181,
                        181,
                        85,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        182,
                        181,
                        181,
                        85,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        183,
                        184,
                        185,
                        186,
                        187,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        86,
                        0,
                        0,
                        0,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        188,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        189,
                        170,
                        190,
                        191,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        192,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        76,
                        193,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        194,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        194,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        178,
                        90,
                        0,
                        0,
                        76,
                        193,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        178,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        29,
                        95,
                        31,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        36,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        100,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        100,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        195,
                        196,
                        197,
                        198,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        199,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        96,
                        0,
                        202,
                        0,
                        203,
                        203,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        96,
                        0,
                        0
                    ],
                    [
                        0,
                        204,
                        111,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        204,
                        0,
                        0
                    ],
                    [
                        0,
                        96,
                        0,
                        0,
                        0,
                        201,
                        205,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        96,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        206,
                        206,
                        32,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        103,
                        104,
                        105,
                        106,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        104,
                        104,
                        106,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        207,
                        207,
                        106,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        208,
                        207,
                        207,
                        106,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        209,
                        210,
                        211,
                        212,
                        213,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        107,
                        0,
                        0,
                        0,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        214,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        215,
                        196,
                        216,
                        217,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        218,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        97,
                        219,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        220,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        220,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        204,
                        111,
                        0,
                        0,
                        97,
                        219,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        204,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        221,
                        116,
                        222,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        223,
                        0,
                        0,
                        0,
                        40,
                        224,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        223,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        119,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        115,
                        116,
                        117,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        119,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        115,
                        116,
                        222,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        226,
                        64,
                        0,
                        0,
                        40,
                        224,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        226,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        39,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        39,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        227,
                        0,
                        228,
                        229,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        230,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        39,
                        0,
                        122,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        39,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        231,
                        231,
                        49,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        232,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        130,
                        131,
                        132,
                        133,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        131,
                        131,
                        133,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        233,
                        233,
                        133,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        234,
                        233,
                        233,
                        133,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        235,
                        236,
                        237,
                        238,
                        239,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        54,
                        56,
                        56,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        61,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        240,
                        241,
                        242,
                        243,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        244,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        136,
                        0,
                        247,
                        0,
                        248,
                        248,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        136,
                        0,
                        0
                    ],
                    [
                        0,
                        249,
                        151,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        249,
                        0,
                        0
                    ],
                    [
                        0,
                        136,
                        0,
                        0,
                        0,
                        246,
                        250,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        136,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        251,
                        251,
                        57,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        143,
                        144,
                        145,
                        146,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        144,
                        144,
                        146,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        252,
                        252,
                        146,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        253,
                        252,
                        252,
                        146,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        254,
                        255,
                        256,
                        257,
                        258,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        147,
                        0,
                        0,
                        0,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        259,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        260,
                        241,
                        261,
                        262,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        263,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        137,
                        264,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        265,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        265,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        249,
                        151,
                        0,
                        0,
                        137,
                        264,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        249,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        221,
                        116,
                        222,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        158,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        155,
                        116,
                        156,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        158,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        155,
                        116,
                        222,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        43,
                        266,
                        266,
                        8,
                        161,
                        0,
                        24,
                        0,
                        0,
                        12,
                        267,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        176,
                        43,
                        268,
                        268,
                        269,
                        161,
                        0,
                        24,
                        0,
                        0,
                        0,
                        267,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        270,
                        0,
                        0,
                        271,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        272,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        273,
                        274,
                        0,
                        0,
                        40,
                        41,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        273,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        40,
                        0,
                        123,
                        123,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        121,
                        275,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        166,
                        0,
                        0,
                        0,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        276,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        277,
                        170,
                        278,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        279,
                        0,
                        0,
                        0,
                        76,
                        280,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        279,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        281,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        173,
                        281,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        169,
                        170,
                        171,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        173,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        169,
                        170,
                        278,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        282,
                        90,
                        0,
                        0,
                        76,
                        280,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        282,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        283,
                        0,
                        284,
                        285,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        286,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        75,
                        0,
                        176,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        75,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        287,
                        287,
                        85,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        288,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        184,
                        185,
                        186,
                        187,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        185,
                        185,
                        187,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        289,
                        289,
                        187,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        290,
                        289,
                        289,
                        187,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        291,
                        292,
                        293,
                        294,
                        295,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        277,
                        170,
                        278,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        281,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        192,
                        281,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        189,
                        170,
                        190,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        192,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        189,
                        170,
                        278,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        76,
                        0,
                        177,
                        177,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        175,
                        296,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        297,
                        196,
                        298,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        299,
                        0,
                        0,
                        0,
                        97,
                        300,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        299,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        301,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        199,
                        301,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        195,
                        196,
                        197,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        199,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        195,
                        196,
                        298,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        302,
                        111,
                        0,
                        0,
                        97,
                        300,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        302,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        96,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        96,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        303,
                        0,
                        304,
                        305,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        306,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        96,
                        0,
                        202,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        96,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        32,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        307,
                        307,
                        106,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        308,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        210,
                        211,
                        212,
                        213,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        211,
                        211,
                        213,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        309,
                        309,
                        213,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        310,
                        309,
                        309,
                        213,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        311,
                        312,
                        313,
                        314,
                        315,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        297,
                        196,
                        298,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        301,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        218,
                        301,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        215,
                        196,
                        216,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        218,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        215,
                        196,
                        298,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        97,
                        0,
                        203,
                        203,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        201,
                        316,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        116,
                        222,
                        222,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        317,
                        318,
                        319,
                        320,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        321,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        223,
                        0,
                        323,
                        0,
                        123,
                        123,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        223,
                        0,
                        0
                    ],
                    [
                        0,
                        223,
                        0,
                        0,
                        0,
                        121,
                        324,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        223,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        325,
                        318,
                        326,
                        327,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        328,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        64,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        9,
                        0,
                        0,
                        0,
                        0,
                        230,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        227,
                        0,
                        228,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        230,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        227,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        49,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        329,
                        329,
                        133,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        330,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        236,
                        237,
                        238,
                        239,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        237,
                        237,
                        239,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        331,
                        331,
                        239,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        332,
                        331,
                        331,
                        239,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        333,
                        40,
                        121,
                        334,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        335,
                        241,
                        336,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        337,
                        0,
                        0,
                        0,
                        137,
                        338,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        337,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        339,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        244,
                        339,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        240,
                        241,
                        242,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        244,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        240,
                        241,
                        336,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        340,
                        151,
                        0,
                        0,
                        137,
                        338,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        340,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        136,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        136,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        341,
                        0,
                        342,
                        343,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        344,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        136,
                        0,
                        247,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        136,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        57,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        345,
                        345,
                        146,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        346,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        255,
                        256,
                        257,
                        258,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        256,
                        256,
                        258,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        347,
                        347,
                        258,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        348,
                        347,
                        347,
                        258,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        349,
                        350,
                        351,
                        352,
                        353,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        335,
                        241,
                        336,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        339,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        263,
                        339,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        260,
                        241,
                        261,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        263,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        260,
                        241,
                        336,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        137,
                        0,
                        248,
                        248,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        246,
                        354,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        126,
                        126,
                        8,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        355,
                        90,
                        0,
                        0,
                        121,
                        125,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        355,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        356,
                        356,
                        269,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        357,
                        358,
                        359,
                        360,
                        361,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        270,
                        0,
                        0,
                        0,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        363,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        364,
                        116,
                        365,
                        366,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        367,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        368,
                        368,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        40,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        170,
                        278,
                        278,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        174,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        281,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        281,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        369,
                        370,
                        371,
                        372,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        373,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        279,
                        0,
                        375,
                        0,
                        177,
                        177,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        279,
                        0,
                        0
                    ],
                    [
                        0,
                        279,
                        0,
                        0,
                        0,
                        175,
                        376,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        279,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        377,
                        370,
                        378,
                        379,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        380,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        90,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        286,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        283,
                        0,
                        284,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        286,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        283,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        85,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        82,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        381,
                        381,
                        187,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        382,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        292,
                        293,
                        294,
                        295,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        293,
                        293,
                        295,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        383,
                        383,
                        295,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        384,
                        383,
                        383,
                        295,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        385,
                        76,
                        175,
                        386,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        76,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        196,
                        298,
                        298,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        200,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        301,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        301,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        387,
                        388,
                        389,
                        390,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        391,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        299,
                        0,
                        393,
                        0,
                        203,
                        203,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        299,
                        0,
                        0
                    ],
                    [
                        0,
                        299,
                        0,
                        0,
                        0,
                        201,
                        394,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        299,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        395,
                        388,
                        396,
                        397,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        398,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        111,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        33,
                        0,
                        0,
                        0,
                        0,
                        306,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        303,
                        0,
                        304,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        306,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        303,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        106,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        103,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        399,
                        399,
                        213,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        400,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        312,
                        313,
                        314,
                        315,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        313,
                        313,
                        315,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        401,
                        401,
                        315,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        402,
                        401,
                        401,
                        315,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        403,
                        97,
                        201,
                        404,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        97,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        405,
                        318,
                        406,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        407,
                        0,
                        0,
                        0,
                        40,
                        408,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        407,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        409,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        321,
                        409,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        317,
                        318,
                        319,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        321,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        317,
                        318,
                        406,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        410,
                        64,
                        0,
                        0,
                        40,
                        408,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        410,
                        0,
                        0
                    ],
                    [
                        0,
                        223,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        223,
                        0,
                        0
                    ],
                    [
                        0,
                        223,
                        0,
                        323,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        223,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        405,
                        318,
                        406,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        409,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        328,
                        409,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        325,
                        318,
                        326,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        328,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        325,
                        318,
                        406,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        133,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        130,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        411,
                        411,
                        239,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        412,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        40,
                        121,
                        334,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        413,
                        0,
                        0,
                        0,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        241,
                        336,
                        336,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        245,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        339,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        339,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        414,
                        415,
                        416,
                        417,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        418,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        337,
                        0,
                        420,
                        0,
                        248,
                        248,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        337,
                        0,
                        0
                    ],
                    [
                        0,
                        337,
                        0,
                        0,
                        0,
                        246,
                        421,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        337,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        422,
                        415,
                        423,
                        424,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        425,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        151,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        58,
                        0,
                        0,
                        0,
                        0,
                        344,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        341,
                        0,
                        342,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        344,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        341,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        146,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        143,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        426,
                        426,
                        258,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        427,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        350,
                        351,
                        352,
                        353,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        351,
                        351,
                        353,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        428,
                        428,
                        353,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        429,
                        428,
                        428,
                        353,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        430,
                        137,
                        246,
                        431,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        137,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        432,
                        116,
                        433,
                        434,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        435,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        180,
                        180,
                        269,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        358,
                        359,
                        360,
                        361,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        359,
                        359,
                        361,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        436,
                        436,
                        361,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        437,
                        436,
                        436,
                        361,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        438,
                        439,
                        440,
                        441,
                        442,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        443,
                        274,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        443,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        444,
                        116,
                        445,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        161,
                        0,
                        0,
                        0,
                        0,
                        367,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        364,
                        116,
                        365,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        367,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        364,
                        116,
                        445,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        446,
                        370,
                        447,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        448,
                        0,
                        0,
                        0,
                        76,
                        449,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        448,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        450,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        373,
                        450,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        369,
                        370,
                        371,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        373,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        369,
                        370,
                        447,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        451,
                        90,
                        0,
                        0,
                        76,
                        449,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        451,
                        0,
                        0
                    ],
                    [
                        0,
                        279,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        279,
                        0,
                        0
                    ],
                    [
                        0,
                        279,
                        0,
                        375,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        279,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        446,
                        370,
                        447,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        450,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        380,
                        450,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        377,
                        370,
                        378,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        380,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        377,
                        370,
                        447,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        187,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        184,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        452,
                        452,
                        295,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        453,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        76,
                        175,
                        386,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        454,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        455,
                        388,
                        456,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        457,
                        0,
                        0,
                        0,
                        97,
                        458,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        457,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        459,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        391,
                        459,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        387,
                        388,
                        389,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        391,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        387,
                        388,
                        456,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        460,
                        111,
                        0,
                        0,
                        97,
                        458,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        460,
                        0,
                        0
                    ],
                    [
                        0,
                        299,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        299,
                        0,
                        0
                    ],
                    [
                        0,
                        299,
                        0,
                        393,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        299,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        455,
                        388,
                        456,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        459,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        398,
                        459,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        395,
                        388,
                        396,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        398,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        395,
                        388,
                        456,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        213,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        210,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        461,
                        461,
                        315,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        462,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        97,
                        201,
                        404,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        463,
                        0,
                        0,
                        0,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        318,
                        406,
                        406,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        322,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        409,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        409,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        464,
                        465,
                        466,
                        467,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        468,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        407,
                        0,
                        470,
                        0,
                        123,
                        123,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        407,
                        0,
                        0
                    ],
                    [
                        0,
                        407,
                        0,
                        0,
                        0,
                        121,
                        471,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        407,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        472,
                        465,
                        473,
                        474,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        475,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        239,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        236,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        476,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        477,
                        415,
                        478,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        479,
                        0,
                        0,
                        0,
                        137,
                        480,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        479,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        481,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        418,
                        481,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        414,
                        415,
                        416,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        418,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        414,
                        415,
                        478,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        482,
                        151,
                        0,
                        0,
                        137,
                        480,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        482,
                        0,
                        0
                    ],
                    [
                        0,
                        337,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        337,
                        0,
                        0
                    ],
                    [
                        0,
                        337,
                        0,
                        420,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        337,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        477,
                        415,
                        478,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        481,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        425,
                        481,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        422,
                        415,
                        423,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        425,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        422,
                        415,
                        478,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        258,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        255,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        483,
                        483,
                        353,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        484,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        137,
                        246,
                        431,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        485,
                        0,
                        0,
                        0,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        444,
                        116,
                        445,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        161,
                        0,
                        0,
                        0,
                        0,
                        435,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        432,
                        116,
                        433,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        435,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        432,
                        116,
                        445,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        486,
                        486,
                        361,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        487,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        439,
                        440,
                        441,
                        442,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        440,
                        440,
                        442,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        488,
                        488,
                        442,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        489,
                        488,
                        488,
                        442,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        490,
                        491,
                        492,
                        493,
                        494,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        495,
                        0,
                        496,
                        497,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        498,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        116,
                        445,
                        445,
                        8,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        120,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        225,
                        44,
                        44,
                        8,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        225,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        370,
                        447,
                        447,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        374,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        450,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        450,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        499,
                        500,
                        501,
                        502,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        503,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        448,
                        0,
                        505,
                        0,
                        177,
                        177,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        448,
                        0,
                        0
                    ],
                    [
                        0,
                        448,
                        0,
                        0,
                        0,
                        175,
                        506,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        448,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        507,
                        500,
                        508,
                        509,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        510,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        295,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        292,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        511,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        388,
                        456,
                        456,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        392,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        459,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        459,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        512,
                        513,
                        514,
                        515,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        516,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        457,
                        0,
                        518,
                        0,
                        203,
                        203,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        457,
                        0,
                        0
                    ],
                    [
                        0,
                        457,
                        0,
                        0,
                        0,
                        201,
                        519,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        457,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        520,
                        513,
                        521,
                        522,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        523,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        315,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        312,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        524,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        525,
                        465,
                        526,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        527,
                        0,
                        0,
                        0,
                        40,
                        528,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        527,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        529,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        468,
                        529,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        464,
                        465,
                        466,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        468,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        464,
                        465,
                        526,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        530,
                        64,
                        0,
                        0,
                        40,
                        528,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        530,
                        0,
                        0
                    ],
                    [
                        0,
                        407,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        407,
                        0,
                        0
                    ],
                    [
                        0,
                        407,
                        0,
                        470,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        407,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        525,
                        465,
                        526,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        529,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        475,
                        529,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        472,
                        465,
                        473,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        475,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        472,
                        465,
                        526,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        40,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        415,
                        478,
                        478,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        419,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        481,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        481,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        531,
                        532,
                        533,
                        534,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        535,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        479,
                        0,
                        537,
                        0,
                        248,
                        248,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        479,
                        0,
                        0
                    ],
                    [
                        0,
                        479,
                        0,
                        0,
                        0,
                        246,
                        538,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        479,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        539,
                        532,
                        540,
                        541,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        542,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        353,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        350,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        543,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        361,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        358,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        544,
                        544,
                        442,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        545,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        491,
                        492,
                        493,
                        494,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        492,
                        492,
                        494,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        546,
                        546,
                        494,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        547,
                        546,
                        546,
                        494,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        548,
                        549,
                        368,
                        550,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        274,
                        0,
                        368,
                        368,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        161,
                        0,
                        0,
                        0,
                        0,
                        498,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        495,
                        0,
                        496,
                        368,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        498,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        495,
                        0,
                        368,
                        368,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        551,
                        500,
                        552,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        553,
                        0,
                        0,
                        0,
                        76,
                        554,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        553,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        555,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        503,
                        555,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        499,
                        500,
                        501,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        503,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        499,
                        500,
                        552,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        556,
                        90,
                        0,
                        0,
                        76,
                        554,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        556,
                        0,
                        0
                    ],
                    [
                        0,
                        448,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        448,
                        0,
                        0
                    ],
                    [
                        0,
                        448,
                        0,
                        505,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        448,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        551,
                        500,
                        552,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        555,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        510,
                        555,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        507,
                        500,
                        508,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        510,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        507,
                        500,
                        552,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        76,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        557,
                        513,
                        558,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        559,
                        0,
                        0,
                        0,
                        97,
                        560,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        559,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        561,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        516,
                        561,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        512,
                        513,
                        514,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        516,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        512,
                        513,
                        558,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        562,
                        111,
                        0,
                        0,
                        97,
                        560,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        562,
                        0,
                        0
                    ],
                    [
                        0,
                        457,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        457,
                        0,
                        0
                    ],
                    [
                        0,
                        457,
                        0,
                        518,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        457,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        557,
                        513,
                        558,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        561,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        523,
                        561,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        520,
                        513,
                        521,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        523,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        520,
                        513,
                        558,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        97,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        465,
                        526,
                        526,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        469,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        529,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        0,
                        529,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        563,
                        66,
                        564,
                        565,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        566,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        527,
                        0,
                        567,
                        0,
                        123,
                        123,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        527,
                        0,
                        0
                    ],
                    [
                        0,
                        527,
                        0,
                        0,
                        0,
                        121,
                        568,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        527,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        569,
                        66,
                        570,
                        571,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        572,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        573,
                        532,
                        574,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        575,
                        0,
                        0,
                        0,
                        137,
                        576,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        575,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        577,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        535,
                        577,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        531,
                        532,
                        533,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        535,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        531,
                        532,
                        574,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        578,
                        151,
                        0,
                        0,
                        137,
                        576,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        578,
                        0,
                        0
                    ],
                    [
                        0,
                        479,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        479,
                        0,
                        0
                    ],
                    [
                        0,
                        479,
                        0,
                        537,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        479,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        573,
                        532,
                        574,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        577,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        542,
                        577,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        539,
                        532,
                        540,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        542,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        539,
                        532,
                        574,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        137,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        442,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        439,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        579,
                        579,
                        494,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        580,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        549,
                        368,
                        550,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        368,
                        368,
                        0,
                        161,
                        0,
                        162,
                        0,
                        0,
                        0,
                        362,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        581,
                        0,
                        0,
                        0,
                        161,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        500,
                        552,
                        552,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        504,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        555,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        555,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        582,
                        91,
                        583,
                        584,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        585,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        553,
                        0,
                        586,
                        0,
                        177,
                        177,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        553,
                        0,
                        0
                    ],
                    [
                        0,
                        553,
                        0,
                        0,
                        0,
                        175,
                        587,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        553,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        588,
                        91,
                        589,
                        590,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        591,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        513,
                        558,
                        558,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        517,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        561,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        0,
                        561,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        592,
                        112,
                        593,
                        594,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        595,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        559,
                        0,
                        596,
                        0,
                        203,
                        203,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        559,
                        0,
                        0
                    ],
                    [
                        0,
                        559,
                        0,
                        0,
                        0,
                        201,
                        597,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        559,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        598,
                        112,
                        599,
                        600,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        601,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        602,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        165,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        566,
                        165,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        563,
                        66,
                        564,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        566,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        563,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        527,
                        0,
                        0,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        527,
                        0,
                        0
                    ],
                    [
                        0,
                        527,
                        0,
                        567,
                        0,
                        121,
                        121,
                        0,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        42,
                        0,
                        527,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        602,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        165,
                        44,
                        44,
                        8,
                        9,
                        0,
                        0,
                        0,
                        0,
                        572,
                        165,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        569,
                        66,
                        570,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        572,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        569,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        532,
                        574,
                        574,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        536,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        577,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        0,
                        577,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        603,
                        152,
                        604,
                        605,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        606,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        575,
                        0,
                        607,
                        0,
                        248,
                        248,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        575,
                        0,
                        0
                    ],
                    [
                        0,
                        575,
                        0,
                        0,
                        0,
                        246,
                        608,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        575,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        609,
                        152,
                        610,
                        611,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        612,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        494,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        491,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        613,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        614,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        194,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        585,
                        194,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        582,
                        91,
                        583,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        585,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        582,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        553,
                        0,
                        0,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        553,
                        0,
                        0
                    ],
                    [
                        0,
                        553,
                        0,
                        586,
                        0,
                        175,
                        175,
                        0,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        78,
                        0,
                        553,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        614,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        194,
                        80,
                        80,
                        22,
                        23,
                        0,
                        0,
                        0,
                        0,
                        591,
                        194,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        588,
                        91,
                        589,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        591,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        588,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        615,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        220,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        595,
                        220,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        592,
                        112,
                        593,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        595,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        592,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        559,
                        0,
                        0,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        559,
                        0,
                        0
                    ],
                    [
                        0,
                        559,
                        0,
                        596,
                        0,
                        201,
                        201,
                        0,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        99,
                        0,
                        559,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        615,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        220,
                        101,
                        101,
                        32,
                        33,
                        0,
                        0,
                        0,
                        0,
                        601,
                        220,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        598,
                        112,
                        599,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        601,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        598,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        66,
                        67,
                        67,
                        8,
                        9,
                        0,
                        10,
                        0,
                        0,
                        0,
                        68,
                        0,
                        0,
                        16,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        616,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        265,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        606,
                        265,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        603,
                        152,
                        604,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        606,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        603,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        575,
                        0,
                        0,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        575,
                        0,
                        0
                    ],
                    [
                        0,
                        575,
                        0,
                        607,
                        0,
                        246,
                        246,
                        0,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        139,
                        0,
                        575,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        616,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        265,
                        141,
                        141,
                        57,
                        58,
                        0,
                        0,
                        0,
                        0,
                        612,
                        265,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        609,
                        152,
                        610,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        612,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        609,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        62,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        549,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        91,
                        92,
                        92,
                        22,
                        23,
                        0,
                        24,
                        0,
                        0,
                        0,
                        93,
                        0,
                        0,
                        27,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        112,
                        113,
                        113,
                        32,
                        33,
                        0,
                        34,
                        0,
                        0,
                        0,
                        114,
                        0,
                        0,
                        37,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        152,
                        153,
                        153,
                        57,
                        58,
                        0,
                        59,
                        0,
                        0,
                        0,
                        154,
                        0,
                        0,
                        62,
                        0
                    ]
                ];
                var accepting = [
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    true,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    false,
                    false,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true
                ];
                var tags = [
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [
                        "consonant_syllable",
                        "broken_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "standalone_cluster"
                    ],
                    [
                        "standalone_cluster"
                    ],
                    [],
                    [
                        "consonant_syllable"
                    ],
                    [
                        "vowel_syllable"
                    ],
                    [
                        "standalone_cluster"
                    ]
                ];
                var indicMachine = {
                    stateTable: stateTable,
                    accepting: accepting,
                    tags: tags
                };
                var categories = [
                    "O",
                    "IND",
                    "S",
                    "GB",
                    "B",
                    "FM",
                    "CGJ",
                    "VMAbv",
                    "VMPst",
                    "VAbv",
                    "VPst",
                    "CMBlw",
                    "VPre",
                    "VBlw",
                    "H",
                    "VMBlw",
                    "CMAbv",
                    "MBlw",
                    "CS",
                    "R",
                    "SUB",
                    "MPst",
                    "MPre",
                    "FAbv",
                    "FPst",
                    "FBlw",
                    "null",
                    "SMAbv",
                    "SMBlw",
                    "VMPre",
                    "ZWNJ",
                    "ZWJ",
                    "WJ",
                    "M",
                    "VS",
                    "N",
                    "HN",
                    "MAbv"
                ];
                var decompositions = {
                    "2507": [
                        2503,
                        2494
                    ],
                    "2508": [
                        2503,
                        2519
                    ],
                    "2888": [
                        2887,
                        2902
                    ],
                    "2891": [
                        2887,
                        2878
                    ],
                    "2892": [
                        2887,
                        2903
                    ],
                    "3018": [
                        3014,
                        3006
                    ],
                    "3019": [
                        3015,
                        3006
                    ],
                    "3020": [
                        3014,
                        3031
                    ],
                    "3144": [
                        3142,
                        3158
                    ],
                    "3264": [
                        3263,
                        3285
                    ],
                    "3271": [
                        3270,
                        3285
                    ],
                    "3272": [
                        3270,
                        3286
                    ],
                    "3274": [
                        3270,
                        3266
                    ],
                    "3275": [
                        3270,
                        3266,
                        3285
                    ],
                    "3402": [
                        3398,
                        3390
                    ],
                    "3403": [
                        3399,
                        3390
                    ],
                    "3404": [
                        3398,
                        3415
                    ],
                    "3546": [
                        3545,
                        3530
                    ],
                    "3548": [
                        3545,
                        3535
                    ],
                    "3549": [
                        3545,
                        3535,
                        3530
                    ],
                    "3550": [
                        3545,
                        3551
                    ],
                    "3635": [
                        3661,
                        3634
                    ],
                    "3763": [
                        3789,
                        3762
                    ],
                    "3955": [
                        3953,
                        3954
                    ],
                    "3957": [
                        3953,
                        3956
                    ],
                    "3958": [
                        4018,
                        3968
                    ],
                    "3959": [
                        4018,
                        3953,
                        3968
                    ],
                    "3960": [
                        4019,
                        3968
                    ],
                    "3961": [
                        4019,
                        3953,
                        3968
                    ],
                    "3969": [
                        3953,
                        3968
                    ],
                    "6971": [
                        6970,
                        6965
                    ],
                    "6973": [
                        6972,
                        6965
                    ],
                    "6976": [
                        6974,
                        6965
                    ],
                    "6977": [
                        6975,
                        6965
                    ],
                    "6979": [
                        6978,
                        6965
                    ],
                    "69934": [
                        69937,
                        69927
                    ],
                    "69935": [
                        69938,
                        69927
                    ],
                    "70475": [
                        70471,
                        70462
                    ],
                    "70476": [
                        70471,
                        70487
                    ],
                    "70843": [
                        70841,
                        70842
                    ],
                    "70844": [
                        70841,
                        70832
                    ],
                    "70846": [
                        70841,
                        70845
                    ],
                    "71098": [
                        71096,
                        71087
                    ],
                    "71099": [
                        71097,
                        71087
                    ]
                };
                var stateTable$1 = [
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        2,
                        2,
                        3,
                        4,
                        4,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        0,
                        17,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        2,
                        0,
                        0,
                        24,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        26,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        27,
                        28,
                        0,
                        0,
                        0,
                        0,
                        0,
                        27,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        39,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        0,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        0,
                        0,
                        12,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        0,
                        9,
                        0,
                        0,
                        0,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        0,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        0,
                        11,
                        12,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        0,
                        9,
                        0,
                        0,
                        12,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        18,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        0,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        0,
                        11,
                        12,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        11,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        4,
                        4,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        48,
                        11,
                        12,
                        13,
                        14,
                        48,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        49,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        0,
                        11,
                        12,
                        0,
                        14,
                        0,
                        16,
                        0,
                        0,
                        0,
                        11,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        21,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        21,
                        22,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        14,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        50,
                        0,
                        51,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        0,
                        11,
                        12,
                        0,
                        14,
                        0,
                        16,
                        0,
                        0,
                        0,
                        11,
                        0,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        27,
                        28,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        28,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        0,
                        31,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        0,
                        0,
                        36,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        0,
                        33,
                        0,
                        0,
                        0,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        0,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        0,
                        35,
                        36,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        0,
                        33,
                        0,
                        0,
                        36,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        41,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        0,
                        31,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        0,
                        35,
                        36,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        35,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        52,
                        35,
                        36,
                        37,
                        38,
                        52,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        53,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        0,
                        35,
                        36,
                        0,
                        38,
                        0,
                        40,
                        0,
                        0,
                        0,
                        35,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        44,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        44,
                        45,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        38,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        0,
                        35,
                        36,
                        0,
                        38,
                        0,
                        40,
                        0,
                        0,
                        0,
                        35,
                        0,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        48,
                        11,
                        12,
                        13,
                        14,
                        0,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        5,
                        0,
                        6,
                        7,
                        8,
                        9,
                        48,
                        11,
                        12,
                        13,
                        14,
                        48,
                        16,
                        0,
                        0,
                        18,
                        11,
                        19,
                        20,
                        21,
                        22,
                        0,
                        0,
                        0,
                        23,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        25
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        51,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        54,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        52,
                        35,
                        36,
                        37,
                        38,
                        0,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        29,
                        0,
                        30,
                        31,
                        32,
                        33,
                        52,
                        35,
                        36,
                        37,
                        38,
                        52,
                        40,
                        0,
                        0,
                        41,
                        35,
                        42,
                        43,
                        44,
                        45,
                        0,
                        0,
                        0,
                        46,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        47
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        50,
                        0,
                        51,
                        0
                    ]
                ];
                var accepting$1 = [
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    false,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true,
                    true
                ];
                var tags$1 = [
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "independent_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "numeral_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "independent_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "symbol_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "virama_terminated_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "broken_cluster"
                    ],
                    [
                        "numeral_cluster"
                    ],
                    [
                        "number_joiner_terminated_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "standard_cluster"
                    ],
                    [
                        "numeral_cluster"
                    ]
                ];
                var useData = {
                    categories: categories,
                    decompositions: decompositions,
                    stateTable: stateTable$1,
                    accepting: accepting$1,
                    tags: tags$1
                };
                // Cateories used in the OpenType spec:
                // https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx
                var CATEGORIES = {
                    X: 1,
                    C: 2,
                    V: 4,
                    N: 8,
                    H: 16,
                    ZWNJ: 32,
                    ZWJ: 64,
                    M: 128,
                    SM: 256,
                    VD: 512,
                    A: 1024,
                    Placeholder: 2048,
                    Dotted_Circle: 4096,
                    RS: 8192,
                    // Register Shifter, used in Khmer OT spec.
                    Coeng: 16384,
                    // Khmer-style Virama.
                    Repha: 32768,
                    // Atomically-encoded logical or visual repha.
                    Ra: 65536,
                    CM: 131072,
                    // Consonant-Medial.
                    Symbol: 262144 // Avagraha, etc that take marks (SM,A,VD).
                }; // Visual positions in a syllable from left to right.
                var POSITIONS = {
                    Start: 1,
                    Ra_To_Become_Reph: 2,
                    Pre_M: 4,
                    Pre_C: 8,
                    Base_C: 16,
                    After_Main: 32,
                    Above_C: 64,
                    Before_Sub: 128,
                    Below_C: 256,
                    After_Sub: 512,
                    Before_Post: 1024,
                    Post_C: 2048,
                    After_Post: 4096,
                    Final_C: 8192,
                    SMVD: 16384,
                    End: 32768
                };
                var CONSONANT_FLAGS = CATEGORIES.C | CATEGORIES.Ra | CATEGORIES.CM | CATEGORIES.V | CATEGORIES.Placeholder | CATEGORIES.Dotted_Circle;
                var JOINER_FLAGS = CATEGORIES.ZWJ | CATEGORIES.ZWNJ;
                var HALANT_OR_COENG_FLAGS = CATEGORIES.H | CATEGORIES.Coeng;
                var INDIC_CONFIGS = {
                    Default: {
                        hasOldSpec: false,
                        virama: 0,
                        basePos: 'Last',
                        rephPos: POSITIONS.Before_Post,
                        rephMode: 'Implicit',
                        blwfMode: 'Pre_And_Post'
                    },
                    Devanagari: {
                        hasOldSpec: true,
                        virama: 0x094D,
                        basePos: 'Last',
                        rephPos: POSITIONS.Before_Post,
                        rephMode: 'Implicit',
                        blwfMode: 'Pre_And_Post'
                    },
                    Bengali: {
                        hasOldSpec: true,
                        virama: 0x09CD,
                        basePos: 'Last',
                        rephPos: POSITIONS.After_Sub,
                        rephMode: 'Implicit',
                        blwfMode: 'Pre_And_Post'
                    },
                    Gurmukhi: {
                        hasOldSpec: true,
                        virama: 0x0A4D,
                        basePos: 'Last',
                        rephPos: POSITIONS.Before_Sub,
                        rephMode: 'Implicit',
                        blwfMode: 'Pre_And_Post'
                    },
                    Gujarati: {
                        hasOldSpec: true,
                        virama: 0x0ACD,
                        basePos: 'Last',
                        rephPos: POSITIONS.Before_Post,
                        rephMode: 'Implicit',
                        blwfMode: 'Pre_And_Post'
                    },
                    Oriya: {
                        hasOldSpec: true,
                        virama: 0x0B4D,
                        basePos: 'Last',
                        rephPos: POSITIONS.After_Main,
                        rephMode: 'Implicit',
                        blwfMode: 'Pre_And_Post'
                    },
                    Tamil: {
                        hasOldSpec: true,
                        virama: 0x0BCD,
                        basePos: 'Last',
                        rephPos: POSITIONS.After_Post,
                        rephMode: 'Implicit',
                        blwfMode: 'Pre_And_Post'
                    },
                    Telugu: {
                        hasOldSpec: true,
                        virama: 0x0C4D,
                        basePos: 'Last',
                        rephPos: POSITIONS.After_Post,
                        rephMode: 'Explicit',
                        blwfMode: 'Post_Only'
                    },
                    Kannada: {
                        hasOldSpec: true,
                        virama: 0x0CCD,
                        basePos: 'Last',
                        rephPos: POSITIONS.After_Post,
                        rephMode: 'Implicit',
                        blwfMode: 'Post_Only'
                    },
                    Malayalam: {
                        hasOldSpec: true,
                        virama: 0x0D4D,
                        basePos: 'Last',
                        rephPos: POSITIONS.After_Main,
                        rephMode: 'Log_Repha',
                        blwfMode: 'Pre_And_Post'
                    },
                    // Handled by UniversalShaper
                    // Sinhala: {
                    //   hasOldSpec: false,
                    //   virama: 0x0DCA,
                    //   basePos: 'Last_Sinhala',
                    //   rephPos: POSITIONS.After_Main,
                    //   rephMode: 'Explicit',
                    //   blwfMode: 'Pre_And_Post'
                    // },
                    Khmer: {
                        hasOldSpec: false,
                        virama: 0x17D2,
                        basePos: 'First',
                        rephPos: POSITIONS.Ra_To_Become_Reph,
                        rephMode: 'Vis_Repha',
                        blwfMode: 'Pre_And_Post'
                    }
                }; // Additional decompositions that aren't in Unicode
                var INDIC_DECOMPOSITIONS = {
                    // Khmer
                    0x17BE: [
                        0x17C1,
                        0x17BE
                    ],
                    0x17BF: [
                        0x17C1,
                        0x17BF
                    ],
                    0x17C0: [
                        0x17C1,
                        0x17C0
                    ],
                    0x17C4: [
                        0x17C1,
                        0x17C4
                    ],
                    0x17C5: [
                        0x17C1,
                        0x17C5
                    ]
                };
                var decompositions$1 = useData.decompositions;
                var trie$1 = new UnicodeTrie(Buffer("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", "base64"));
                var stateMachine = new StateMachine(indicMachine);
                /**
 * The IndicShaper supports indic scripts e.g. Devanagari, Kannada, etc.
 * Based on code from Harfbuzz: https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-indic.cc
 */ var IndicShaper = /*#__PURE__*/ function(_DefaultShaper3) {
                    function IndicShaper() {
                        return _DefaultShaper3.apply(this, arguments) || this;
                    }
                    _inheritsLoose(IndicShaper, _DefaultShaper3);
                    IndicShaper.planFeatures = function planFeatures(plan) {
                        plan.addStage(setupSyllables);
                        plan.addStage([
                            'locl',
                            'ccmp'
                        ]);
                        plan.addStage(initialReordering);
                        plan.addStage('nukt');
                        plan.addStage('akhn');
                        plan.addStage('rphf', false);
                        plan.addStage('rkrf');
                        plan.addStage('pref', false);
                        plan.addStage('blwf', false);
                        plan.addStage('abvf', false);
                        plan.addStage('half', false);
                        plan.addStage('pstf', false);
                        plan.addStage('vatu');
                        plan.addStage('cjct');
                        plan.addStage('cfar', false);
                        plan.addStage(finalReordering);
                        plan.addStage({
                            local: [
                                'init'
                            ],
                            global: [
                                'pres',
                                'abvs',
                                'blws',
                                'psts',
                                'haln',
                                'dist',
                                'abvm',
                                'blwm',
                                'calt',
                                'clig'
                            ]
                        }); // Setup the indic config for the selected script
                        plan.unicodeScript = fromOpenType(plan.script);
                        plan.indicConfig = INDIC_CONFIGS[plan.unicodeScript] || INDIC_CONFIGS.Default;
                        plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2'; // TODO: turn off kern (Khmer) and liga features.
                    };
                    IndicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
                        var _loop = function _loop(i) {
                            var codepoint = glyphs[i].codePoints[0];
                            var d = INDIC_DECOMPOSITIONS[codepoint] || decompositions$1[codepoint];
                            if (d) {
                                var decomposed = d.map(function(c) {
                                    var g = plan.font.glyphForCodePoint(c);
                                    return new GlyphInfo(plan.font, g.id, [
                                        c
                                    ], glyphs[i].features);
                                });
                                glyphs.splice.apply(glyphs, [
                                    i,
                                    1
                                ].concat(decomposed));
                            }
                        };
                        // Decompose split matras
                        // TODO: do this in a more general unicode normalizer
                        for(var i = glyphs.length - 1; i >= 0; i--)_loop(i);
                    };
                    return IndicShaper;
                }(DefaultShaper);
                _defineProperty(IndicShaper, "zeroMarkWidths", 'NONE');
                function indicCategory(glyph) {
                    return trie$1.get(glyph.codePoints[0]) >> 8;
                }
                function indicPosition(glyph) {
                    return 1 << (trie$1.get(glyph.codePoints[0]) & 0xff);
                }
                var IndicInfo = function IndicInfo(category, position, syllableType, syllable) {
                    this.category = category;
                    this.position = position;
                    this.syllableType = syllableType;
                    this.syllable = syllable;
                };
                function setupSyllables(font, glyphs) {
                    var syllable = 0;
                    var last = 0;
                    for(var _iterator51 = _createForOfIteratorHelperLoose(stateMachine.match(glyphs.map(indicCategory))), _step51; !(_step51 = _iterator51()).done;){
                        var _step51$value = _step51.value, start = _step51$value[0], end = _step51$value[1], tags = _step51$value[2];
                        if (start > last) {
                            ++syllable;
                            for(var i = last; i < start; i++)glyphs[i].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
                        }
                        ++syllable; // Create shaper info
                        for(var _i = start; _i <= end; _i++)glyphs[_i].shaperInfo = new IndicInfo(1 << indicCategory(glyphs[_i]), indicPosition(glyphs[_i]), tags[0], syllable);
                        last = end + 1;
                    }
                    if (last < glyphs.length) {
                        ++syllable;
                        for(var _i2 = last; _i2 < glyphs.length; _i2++)glyphs[_i2].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
                    }
                }
                function isConsonant(glyph) {
                    return glyph.shaperInfo.category & CONSONANT_FLAGS;
                }
                function isJoiner(glyph) {
                    return glyph.shaperInfo.category & JOINER_FLAGS;
                }
                function isHalantOrCoeng(glyph) {
                    return glyph.shaperInfo.category & HALANT_OR_COENG_FLAGS;
                }
                function wouldSubstitute(glyphs, feature) {
                    for(var _iterator52 = _createForOfIteratorHelperLoose(glyphs), _step52; !(_step52 = _iterator52()).done;){
                        var _glyph$features;
                        var glyph = _step52.value;
                        glyph.features = (_glyph$features = {}, _glyph$features[feature] = true, _glyph$features);
                    }
                    var GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
                    GSUB.applyFeatures([
                        feature
                    ], glyphs);
                    return glyphs.length === 1;
                }
                function consonantPosition(font, consonant, virama) {
                    var glyphs = [
                        virama,
                        consonant,
                        virama
                    ];
                    if (wouldSubstitute(glyphs.slice(0, 2), 'blwf') || wouldSubstitute(glyphs.slice(1, 3), 'blwf')) return POSITIONS.Below_C;
                    else if (wouldSubstitute(glyphs.slice(0, 2), 'pstf') || wouldSubstitute(glyphs.slice(1, 3), 'pstf')) return POSITIONS.Post_C;
                    else if (wouldSubstitute(glyphs.slice(0, 2), 'pref') || wouldSubstitute(glyphs.slice(1, 3), 'pref')) return POSITIONS.Post_C;
                    return POSITIONS.Base_C;
                }
                function initialReordering(font, glyphs, plan) {
                    var indicConfig = plan.indicConfig;
                    var features = font._layoutEngine.engine.GSUBProcessor.features;
                    var dottedCircle = font.glyphForCodePoint(0x25cc).id;
                    var virama = font.glyphForCodePoint(indicConfig.virama).id;
                    if (virama) {
                        var info = new GlyphInfo(font, virama, [
                            indicConfig.virama
                        ]);
                        for(var i = 0; i < glyphs.length; i++)if (glyphs[i].shaperInfo.position === POSITIONS.Base_C) glyphs[i].shaperInfo.position = consonantPosition(font, glyphs[i].copy(), info);
                    }
                    for(var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)){
                        var _glyphs$start$shaperI = glyphs[start].shaperInfo, category = _glyphs$start$shaperI.category, syllableType = _glyphs$start$shaperI.syllableType;
                        if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') continue;
                        if (syllableType === 'broken_cluster' && dottedCircle) {
                            var g = new GlyphInfo(font, dottedCircle, [
                                0x25cc
                            ]);
                            g.shaperInfo = new IndicInfo(1 << indicCategory(g), indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable); // Insert after possible Repha.
                            var _i3 = start;
                            while(_i3 < end && glyphs[_i3].shaperInfo.category === CATEGORIES.Repha)_i3++;
                            glyphs.splice(_i3++, 0, g);
                            end++;
                        } // 1. Find base consonant:
                        //
                        // The shaping engine finds the base consonant of the syllable, using the
                        // following algorithm: starting from the end of the syllable, move backwards
                        // until a consonant is found that does not have a below-base or post-base
                        // form (post-base forms have to follow below-base forms), or that is not a
                        // pre-base reordering Ra, or arrive at the first consonant. The consonant
                        // stopped at will be the base.
                        var base = end;
                        var limit = start;
                        var hasReph = false; // If the syllable starts with Ra + Halant (in a script that has Reph)
                        // and has more than one consonant, Ra is excluded from candidates for
                        // base consonants.
                        if (indicConfig.rephPos !== POSITIONS.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
                            // See if it matches the 'rphf' feature.
                            var _g = [
                                glyphs[start].copy(),
                                glyphs[start + 1].copy(),
                                glyphs[start + 2].copy()
                            ];
                            if (wouldSubstitute(_g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && wouldSubstitute(_g, 'rphf')) {
                                limit += 2;
                                while(limit < end && isJoiner(glyphs[limit]))limit++;
                                base = start;
                                hasReph = true;
                            }
                        } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === CATEGORIES.Repha) {
                            limit++;
                            while(limit < end && isJoiner(glyphs[limit]))limit++;
                            base = start;
                            hasReph = true;
                        }
                        switch(indicConfig.basePos){
                            case 'Last':
                                // starting from the end of the syllable, move backwards
                                var _i4 = end;
                                var seenBelow = false;
                                do {
                                    var _info = glyphs[--_i4].shaperInfo; // until a consonant is found
                                    if (isConsonant(glyphs[_i4])) {
                                        // that does not have a below-base or post-base form
                                        // (post-base forms have to follow below-base forms),
                                        if (_info.position !== POSITIONS.Below_C && (_info.position !== POSITIONS.Post_C || seenBelow)) {
                                            base = _i4;
                                            break;
                                        } // or that is not a pre-base reordering Ra,
                                        //
                                        // IMPLEMENTATION NOTES:
                                        //
                                        // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
                                        // by the logic above already.
                                        //
                                        // or arrive at the first consonant. The consonant stopped at will
                                        // be the base.
                                        if (_info.position === POSITIONS.Below_C) seenBelow = true;
                                        base = _i4;
                                    } else if (start < _i4 && _info.category === CATEGORIES.ZWJ && glyphs[_i4 - 1].shaperInfo.category === CATEGORIES.H) break;
                                }while (_i4 > limit);
                                break;
                            case 'First':
                                // The first consonant is always the base.
                                base = start; // Mark all subsequent consonants as below.
                                for(var _i5 = base + 1; _i5 < end; _i5++)if (isConsonant(glyphs[_i5])) glyphs[_i5].shaperInfo.position = POSITIONS.Below_C;
                        } // If the syllable starts with Ra + Halant (in a script that has Reph)
                        // and has more than one consonant, Ra is excluded from candidates for
                        // base consonants.
                        //
                        //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
                        if (hasReph && base === start && limit - base <= 2) hasReph = false;
                         // 2. Decompose and reorder Matras:
                        //
                        // Each matra and any syllable modifier sign in the cluster are moved to the
                        // appropriate position relative to the consonant(s) in the cluster. The
                        // shaping engine decomposes two- or three-part matras into their constituent
                        // parts before any repositioning. Matra characters are classified by which
                        // consonant in a conjunct they have affinity for and are reordered to the
                        // following positions:
                        //
                        //   o Before first half form in the syllable
                        //   o After subjoined consonants
                        //   o After post-form consonant
                        //   o After main consonant (for above marks)
                        //
                        // IMPLEMENTATION NOTES:
                        //
                        // The normalize() routine has already decomposed matras for us, so we don't
                        // need to worry about that.
                        // 3.  Reorder marks to canonical order:
                        //
                        // Adjacent nukta and halant or nukta and vedic sign are always repositioned
                        // if necessary, so that the nukta is first.
                        //
                        // IMPLEMENTATION NOTES:
                        //
                        // We don't need to do this: the normalize() routine already did this for us.
                        // Reorder characters
                        for(var _i6 = start; _i6 < base; _i6++){
                            var _info2 = glyphs[_i6].shaperInfo;
                            _info2.position = Math.min(POSITIONS.Pre_C, _info2.position);
                        }
                        if (base < end) glyphs[base].shaperInfo.position = POSITIONS.Base_C;
                         // Mark final consonants.  A final consonant is one appearing after a matra,
                        // like in Khmer.
                        for(var _i7 = base + 1; _i7 < end; _i7++)if (glyphs[_i7].shaperInfo.category === CATEGORIES.M) {
                            for(var j = _i7 + 1; j < end; j++)if (isConsonant(glyphs[j])) {
                                glyphs[j].shaperInfo.position = POSITIONS.Final_C;
                                break;
                            }
                            break;
                        }
                         // Handle beginning Ra
                        if (hasReph) glyphs[start].shaperInfo.position = POSITIONS.Ra_To_Become_Reph;
                         // For old-style Indic script tags, move the first post-base Halant after
                        // last consonant.
                        //
                        // Reports suggest that in some scripts Uniscribe does this only if there
                        // is *not* a Halant after last consonant already (eg. Kannada), while it
                        // does it unconditionally in other scripts (eg. Malayalam).  We don't
                        // currently know about other scripts, so we single out Malayalam for now.
                        //
                        // Kannada test case:
                        // U+0C9A,U+0CCD,U+0C9A,U+0CCD
                        // With some versions of Lohit Kannada.
                        // https://bugs.freedesktop.org/show_bug.cgi?id=59118
                        //
                        // Malayalam test case:
                        // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
                        // With lohit-ttf-20121122/Lohit-Malayalam.ttf
                        if (plan.isOldSpec) {
                            var disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';
                            for(var _i8 = base + 1; _i8 < end; _i8++)if (glyphs[_i8].shaperInfo.category === CATEGORIES.H) {
                                var _j = void 0;
                                for(_j = end - 1; _j > _i8; _j--){
                                    if (isConsonant(glyphs[_j]) || disallowDoubleHalants && glyphs[_j].shaperInfo.category === CATEGORIES.H) break;
                                }
                                if (glyphs[_j].shaperInfo.category !== CATEGORIES.H && _j > _i8) {
                                    // Move Halant to after last consonant.
                                    var t = glyphs[_i8];
                                    glyphs.splice.apply(glyphs, [
                                        _i8,
                                        0
                                    ].concat(glyphs.splice(_i8 + 1, _j - _i8)));
                                    glyphs[_j] = t;
                                }
                                break;
                            }
                        } // Attach misc marks to previous char to move with them.
                        var lastPos = POSITIONS.Start;
                        for(var _i9 = start; _i9 < end; _i9++){
                            var _info3 = glyphs[_i9].shaperInfo;
                            if (_info3.category & (JOINER_FLAGS | CATEGORIES.N | CATEGORIES.RS | CATEGORIES.CM | HALANT_OR_COENG_FLAGS & _info3.category)) {
                                _info3.position = lastPos;
                                if (_info3.category === CATEGORIES.H && _info3.position === POSITIONS.Pre_M) {
                                    // Uniscribe doesn't move the Halant with Left Matra.
                                    // TEST: U+092B,U+093F,U+094DE
                                    // We follow.  This is important for the Sinhala
                                    // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
                                    // where U+0DD9 is a left matra and U+0DCA is the virama.
                                    // We don't want to move the virama with the left matra.
                                    // TEST: U+0D9A,U+0DDA
                                    for(var _j2 = _i9; _j2 > start; _j2--)if (glyphs[_j2 - 1].shaperInfo.position !== POSITIONS.Pre_M) {
                                        _info3.position = glyphs[_j2 - 1].shaperInfo.position;
                                        break;
                                    }
                                }
                            } else if (_info3.position !== POSITIONS.SMVD) lastPos = _info3.position;
                        } // For post-base consonants let them own anything before them
                        // since the last consonant or matra.
                        var last = base;
                        for(var _i10 = base + 1; _i10 < end; _i10++){
                            if (isConsonant(glyphs[_i10])) {
                                for(var _j3 = last + 1; _j3 < _i10; _j3++)if (glyphs[_j3].shaperInfo.position < POSITIONS.SMVD) glyphs[_j3].shaperInfo.position = glyphs[_i10].shaperInfo.position;
                                last = _i10;
                            } else if (glyphs[_i10].shaperInfo.category === CATEGORIES.M) last = _i10;
                        }
                        var arr = glyphs.slice(start, end);
                        arr.sort(function(a, b) {
                            return a.shaperInfo.position - b.shaperInfo.position;
                        });
                        glyphs.splice.apply(glyphs, [
                            start,
                            arr.length
                        ].concat(arr)); // Find base again
                        for(var _i11 = start; _i11 < end; _i11++)if (glyphs[_i11].shaperInfo.position === POSITIONS.Base_C) {
                            base = _i11;
                            break;
                        }
                         // Setup features now
                        // Reph
                        for(var _i12 = start; _i12 < end && glyphs[_i12].shaperInfo.position === POSITIONS.Ra_To_Become_Reph; _i12++)glyphs[_i12].features.rphf = true;
                         // Pre-base
                        var blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';
                        for(var _i13 = start; _i13 < base; _i13++){
                            glyphs[_i13].features.half = true;
                            if (blwf) glyphs[_i13].features.blwf = true;
                        } // Post-base
                        for(var _i14 = base + 1; _i14 < end; _i14++){
                            glyphs[_i14].features.abvf = true;
                            glyphs[_i14].features.pstf = true;
                            glyphs[_i14].features.blwf = true;
                        }
                        if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
                            // Old-spec eye-lash Ra needs special handling.  From the
                            // spec:
                            //
                            // "The feature 'below-base form' is applied to consonants
                            // having below-base forms and following the base consonant.
                            // The exception is vattu, which may appear below half forms
                            // as well as below the base glyph. The feature 'below-base
                            // form' will be applied to all such occurrences of Ra as well."
                            //
                            // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
                            // with Sanskrit 2003 font.
                            //
                            // However, note that Ra,Halant,ZWJ is the correct way to
                            // request eyelash form of Ra, so we wouldbn't inhibit it
                            // in that sequence.
                            //
                            // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
                            for(var _i15 = start; _i15 + 1 < base; _i15++)if (glyphs[_i15].shaperInfo.category === CATEGORIES.Ra && glyphs[_i15 + 1].shaperInfo.category === CATEGORIES.H && (_i15 + 1 === base || glyphs[_i15 + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
                                glyphs[_i15].features.blwf = true;
                                glyphs[_i15 + 1].features.blwf = true;
                            }
                        }
                        var prefLen = 2;
                        if (features.pref && base + prefLen < end) // Find a Halant,Ra sequence and mark it for pre-base reordering processing.
                        for(var _i16 = base + 1; _i16 + prefLen - 1 < end; _i16++){
                            var _g2 = [
                                glyphs[_i16].copy(),
                                glyphs[_i16 + 1].copy()
                            ];
                            if (wouldSubstitute(_g2, 'pref')) {
                                for(var _j4 = 0; _j4 < prefLen; _j4++)glyphs[_i16++].features.pref = true;
                                 // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
                                // Read the feature spec.
                                // This allows distinguishing the following cases with MS Khmer fonts:
                                // U+1784,U+17D2,U+179A,U+17D2,U+1782
                                // U+1784,U+17D2,U+1782,U+17D2,U+179A
                                if (features.cfar) for(; _i16 < end; _i16++)glyphs[_i16].features.cfar = true;
                                break;
                            }
                        }
                         // Apply ZWJ/ZWNJ effects
                        for(var _i17 = start + 1; _i17 < end; _i17++)if (isJoiner(glyphs[_i17])) {
                            var nonJoiner = glyphs[_i17].shaperInfo.category === CATEGORIES.ZWNJ;
                            var _j5 = _i17;
                            do {
                                _j5--; // ZWJ/ZWNJ should disable CJCT.  They do that by simply
                                // being there, since we don't skip them for the CJCT
                                // feature (ie. F_MANUAL_ZWJ)
                                // A ZWNJ disables HALF.
                                if (nonJoiner) delete glyphs[_j5].features.half;
                            }while (_j5 > start && !isConsonant(glyphs[_j5]));
                        }
                    }
                }
                function finalReordering(font, glyphs, plan) {
                    var indicConfig = plan.indicConfig;
                    var features = font._layoutEngine.engine.GSUBProcessor.features;
                    for(var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)){
                        // 4. Final reordering:
                        //
                        // After the localized forms and basic shaping forms GSUB features have been
                        // applied (see below), the shaping engine performs some final glyph
                        // reordering before applying all the remaining font features to the entire
                        // cluster.
                        var tryPref = !!features.pref; // Find base again
                        var base = start;
                        for(; base < end; base++)if (glyphs[base].shaperInfo.position >= POSITIONS.Base_C) {
                            if (tryPref && base + 1 < end) {
                                for(var i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                                    if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                                        // Ok, this was a 'pref' candidate but didn't form any.
                                        // Base is around here...
                                        base = i;
                                        while(base < end && isHalantOrCoeng(glyphs[base]))base++;
                                        glyphs[base].shaperInfo.position = POSITIONS.BASE_C;
                                        tryPref = false;
                                    }
                                    break;
                                }
                            } // For Malayalam, skip over unformed below- (but NOT post-) forms.
                            if (plan.unicodeScript === 'Malayalam') for(var _i18 = base + 1; _i18 < end; _i18++){
                                while(_i18 < end && isJoiner(glyphs[_i18]))_i18++;
                                if (_i18 === end || !isHalantOrCoeng(glyphs[_i18])) break;
                                _i18++; // Skip halant.
                                while(_i18 < end && isJoiner(glyphs[_i18]))_i18++;
                                if (_i18 < end && isConsonant(glyphs[_i18]) && glyphs[_i18].shaperInfo.position === POSITIONS.Below_C) {
                                    base = _i18;
                                    glyphs[base].shaperInfo.position = POSITIONS.Base_C;
                                }
                            }
                            if (start < base && glyphs[base].shaperInfo.position > POSITIONS.Base_C) base--;
                            break;
                        }
                        if (base === end && start < base && glyphs[base - 1].shaperInfo.category === CATEGORIES.ZWJ) base--;
                        if (base < end) while(start < base && glyphs[base].shaperInfo.category & (CATEGORIES.N | HALANT_OR_COENG_FLAGS))base--;
                         // o Reorder matras:
                        //
                        // If a pre-base matra character had been reordered before applying basic
                        // features, the glyph can be moved closer to the main consonant based on
                        // whether half-forms had been formed. Actual position for the matra is
                        // defined as “after last standalone halant glyph, after initial matra
                        // position and before the main consonant”. If ZWJ or ZWNJ follow this
                        // halant, position is moved after it.
                        //
                        if (start + 1 < end && start < base) {
                            // Otherwise there can't be any pre-base matra characters.
                            // If we lost track of base, alas, position before last thingy.
                            var newPos = base === end ? base - 2 : base - 1; // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                            // We want to position matra after them.
                            if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                                while(newPos > start && !(glyphs[newPos].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS)))newPos--;
                                 // If we found no Halant we are done.
                                // Otherwise only proceed if the Halant does
                                // not belong to the Matra itself!
                                if (isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) // If ZWJ or ZWNJ follow this halant, position is moved after it.
                                {
                                    if (newPos + 1 < end && isJoiner(glyphs[newPos + 1])) newPos++;
                                } else newPos = start; // No move.
                            }
                            if (start < newPos && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
                                // Now go see if there's actually any matras...
                                for(var _i19 = newPos; _i19 > start; _i19--)if (glyphs[_i19 - 1].shaperInfo.position === POSITIONS.Pre_M) {
                                    var oldPos = _i19 - 1;
                                    if (oldPos < base && base <= newPos) // Shouldn't actually happen.
                                    base--;
                                    var tmp = glyphs[oldPos];
                                    glyphs.splice.apply(glyphs, [
                                        oldPos,
                                        0
                                    ].concat(glyphs.splice(oldPos + 1, newPos - oldPos)));
                                    glyphs[newPos] = tmp;
                                    newPos--;
                                }
                            }
                        } // o Reorder reph:
                        //
                        // Reph’s original position is always at the beginning of the syllable,
                        // (i.e. it is not reordered at the character reordering stage). However,
                        // it will be reordered according to the basic-forms shaping results.
                        // Possible positions for reph, depending on the script, are; after main,
                        // before post-base consonant forms, and after post-base consonant forms.
                        // Two cases:
                        //
                        // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
                        //   we should only move it if the sequence ligated to the repha form.
                        //
                        // - If repha is encoded separately and in the logical position, we should only
                        //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
                        //   to make it work without the reordering.
                        if (start + 1 < end && glyphs[start].shaperInfo.position === POSITIONS.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === CATEGORIES.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
                            var newRephPos = void 0;
                            var rephPos = indicConfig.rephPos;
                            var found = false; // 1. If reph should be positioned after post-base consonant forms,
                            //    proceed to step 5.
                            if (rephPos !== POSITIONS.After_Post) {
                                //  2. If the reph repositioning class is not after post-base: target
                                //     position is after the first explicit halant glyph between the
                                //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
                                //     are following this halant, position is moved after it. If such
                                //     position is found, this is the target position. Otherwise,
                                //     proceed to the next step.
                                //
                                //     Note: in old-implementation fonts, where classifications were
                                //     fixed in shaping engine, there was no case where reph position
                                //     will be found on this step.
                                newRephPos = start + 1;
                                while(newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                                if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
                                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                                    if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                                    found = true;
                                } // 3. If reph should be repositioned after the main consonant: find the
                                //    first consonant not ligated with main, or find the first
                                //    consonant that is not a potential pre-base reordering Ra.
                                if (!found && rephPos === POSITIONS.After_Main) {
                                    newRephPos = base;
                                    while(newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= POSITIONS.After_Main)newRephPos++;
                                    found = newRephPos < end;
                                } // 4. If reph should be positioned before post-base consonant, find
                                //    first post-base classified consonant not ligated with main. If no
                                //    consonant is found, the target position should be before the
                                //    first matra, syllable modifier sign or vedic sign.
                                //
                                // This is our take on what step 4 is trying to say (and failing, BADLY).
                                if (!found && rephPos === POSITIONS.After_Sub) {
                                    newRephPos = base;
                                    while(newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & (POSITIONS.Post_C | POSITIONS.After_Post | POSITIONS.SMVD)))newRephPos++;
                                    found = newRephPos < end;
                                }
                            } //  5. If no consonant is found in steps 3 or 4, move reph to a position
                            //     immediately before the first post-base matra, syllable modifier
                            //     sign or vedic sign that has a reordering class after the intended
                            //     reph position. For example, if the reordering position for reph
                            //     is post-main, it will skip above-base matras that also have a
                            //     post-main position.
                            if (!found) {
                                // Copied from step 2.
                                newRephPos = start + 1;
                                while(newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                                if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
                                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                                    if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                                    found = true;
                                }
                            } // 6. Otherwise, reorder reph to the end of the syllable.
                            if (!found) {
                                newRephPos = end - 1;
                                while(newRephPos > start && glyphs[newRephPos].shaperInfo.position === POSITIONS.SMVD)newRephPos--;
                                 // If the Reph is to be ending up after a Matra,Halant sequence,
                                // position it before that Halant so it can interact with the Matra.
                                // However, if it's a plain Consonant,Halant we shouldn't do that.
                                // Uniscribe doesn't do this.
                                // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
                                if (isHalantOrCoeng(glyphs[newRephPos])) {
                                    for(var _i20 = base + 1; _i20 < newRephPos; _i20++)if (glyphs[_i20].shaperInfo.category === CATEGORIES.M) newRephPos--;
                                }
                            }
                            var reph = glyphs[start];
                            glyphs.splice.apply(glyphs, [
                                start,
                                0
                            ].concat(glyphs.splice(start + 1, newRephPos - start)));
                            glyphs[newRephPos] = reph;
                            if (start < base && base <= newRephPos) base--;
                        } // o Reorder pre-base reordering consonants:
                        //
                        // If a pre-base reordering consonant is found, reorder it according to
                        // the following rules:
                        if (tryPref && base + 1 < end) {
                            for(var _i21 = base + 1; _i21 < end; _i21++)if (glyphs[_i21].features.pref) {
                                // 1. Only reorder a glyph produced by substitution during application
                                //    of the <pref> feature. (Note that a font may shape a Ra consonant with
                                //    the feature generally but block it in certain contexts.)
                                // Note: We just check that something got substituted.  We don't check that
                                // the <pref> feature actually did it...
                                //
                                // Reorder pref only if it ligated.
                                if (glyphs[_i21].isLigated && !glyphs[_i21].isMultiplied) {
                                    // 2. Try to find a target position the same way as for pre-base matra.
                                    //    If it is found, reorder pre-base consonant glyph.
                                    //
                                    // 3. If position is not found, reorder immediately before main
                                    //    consonant.
                                    var _newPos = base; // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                                    // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                                    // We want to position matra after them.
                                    if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                                        while(_newPos > start && !(glyphs[_newPos - 1].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS)))_newPos--;
                                         // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
                                        // split matra, it should be reordered to *before* the left part of such matra.
                                        if (_newPos > start && glyphs[_newPos - 1].shaperInfo.category === CATEGORIES.M) {
                                            var _oldPos2 = _i21;
                                            for(var j = base + 1; j < _oldPos2; j++)if (glyphs[j].shaperInfo.category === CATEGORIES.M) {
                                                _newPos--;
                                                break;
                                            }
                                        }
                                    }
                                    if (_newPos > start && isHalantOrCoeng(glyphs[_newPos - 1])) // -> If ZWJ or ZWNJ follow this halant, position is moved after it.
                                    {
                                        if (_newPos < end && isJoiner(glyphs[_newPos])) _newPos++;
                                    }
                                    var _oldPos = _i21;
                                    var _tmp = glyphs[_oldPos];
                                    glyphs.splice.apply(glyphs, [
                                        _newPos + 1,
                                        0
                                    ].concat(glyphs.splice(_newPos, _oldPos - _newPos)));
                                    glyphs[_newPos] = _tmp;
                                    if (_newPos <= base && base < _oldPos) base++;
                                }
                                break;
                            }
                        } // Apply 'init' to the Left Matra if it's a word start.
                        if (glyphs[start].shaperInfo.position === POSITIONS.Pre_M && (!start || !/Cf|Mn/.test(unicode.getCategory(glyphs[start - 1].codePoints[0])))) glyphs[start].features.init = true;
                    }
                }
                function nextSyllable(glyphs, start) {
                    if (start >= glyphs.length) return start;
                    var syllable = glyphs[start].shaperInfo.syllable;
                    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
                    return start;
                }
                var categories$1 = useData.categories, decompositions$2 = useData.decompositions;
                var trie$2 = new UnicodeTrie(Buffer("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", "base64"));
                var stateMachine$1 = new StateMachine(useData);
                /**
 * This shaper is an implementation of the Universal Shaping Engine, which
 * uses Unicode data to shape a number of scripts without a dedicated shaping engine.
 * See https://www.microsoft.com/typography/OpenTypeDev/USE/intro.htm.
 */ var UniversalShaper = /*#__PURE__*/ function(_DefaultShaper4) {
                    function UniversalShaper() {
                        return _DefaultShaper4.apply(this, arguments) || this;
                    }
                    _inheritsLoose(UniversalShaper, _DefaultShaper4);
                    UniversalShaper.planFeatures = function planFeatures(plan) {
                        plan.addStage(setupSyllables$1); // Default glyph pre-processing group
                        plan.addStage([
                            'locl',
                            'ccmp',
                            'nukt',
                            'akhn'
                        ]); // Reordering group
                        plan.addStage(clearSubstitutionFlags);
                        plan.addStage([
                            'rphf'
                        ], false);
                        plan.addStage(recordRphf);
                        plan.addStage(clearSubstitutionFlags);
                        plan.addStage([
                            'pref'
                        ]);
                        plan.addStage(recordPref); // Orthographic unit shaping group
                        plan.addStage([
                            'rkrf',
                            'abvf',
                            'blwf',
                            'half',
                            'pstf',
                            'vatu',
                            'cjct'
                        ]);
                        plan.addStage(reorder); // Topographical features
                        // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
                        // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
                        // Standard topographic presentation and positional feature application
                        plan.addStage([
                            'abvs',
                            'blws',
                            'pres',
                            'psts',
                            'dist',
                            'abvm',
                            'blwm'
                        ]);
                    };
                    UniversalShaper.assignFeatures = function assignFeatures(plan, glyphs) {
                        var _loop = function _loop(i) {
                            var codepoint = glyphs[i].codePoints[0];
                            if (decompositions$2[codepoint]) {
                                var decomposed = decompositions$2[codepoint].map(function(c) {
                                    var g = plan.font.glyphForCodePoint(c);
                                    return new GlyphInfo(plan.font, g.id, [
                                        c
                                    ], glyphs[i].features);
                                });
                                glyphs.splice.apply(glyphs, [
                                    i,
                                    1
                                ].concat(decomposed));
                            }
                        };
                        // Decompose split vowels
                        // TODO: do this in a more general unicode normalizer
                        for(var i = glyphs.length - 1; i >= 0; i--)_loop(i);
                    };
                    return UniversalShaper;
                }(DefaultShaper);
                _defineProperty(UniversalShaper, "zeroMarkWidths", 'BEFORE_GPOS');
                function useCategory(glyph) {
                    return trie$2.get(glyph.codePoints[0]);
                }
                var USEInfo = function USEInfo(category, syllableType, syllable) {
                    this.category = category;
                    this.syllableType = syllableType;
                    this.syllable = syllable;
                };
                function setupSyllables$1(font, glyphs) {
                    var syllable = 0;
                    for(var _iterator53 = _createForOfIteratorHelperLoose(stateMachine$1.match(glyphs.map(useCategory))), _step53; !(_step53 = _iterator53()).done;){
                        var _step53$value = _step53.value, start = _step53$value[0], end = _step53$value[1], tags = _step53$value[2];
                        ++syllable; // Create shaper info
                        for(var i = start; i <= end; i++)glyphs[i].shaperInfo = new USEInfo(categories$1[useCategory(glyphs[i])], tags[0], syllable);
                         // Assign rphf feature
                        var limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);
                        for(var _i = start; _i < start + limit; _i++)glyphs[_i].features.rphf = true;
                    }
                }
                function clearSubstitutionFlags(font, glyphs) {
                    for(var _iterator54 = _createForOfIteratorHelperLoose(glyphs), _step54; !(_step54 = _iterator54()).done;){
                        var glyph = _step54.value;
                        glyph.substituted = false;
                    }
                }
                function recordRphf(font, glyphs) {
                    for(var _iterator55 = _createForOfIteratorHelperLoose(glyphs), _step55; !(_step55 = _iterator55()).done;){
                        var glyph = _step55.value;
                        if (glyph.substituted && glyph.features.rphf) // Mark a substituted repha.
                        glyph.shaperInfo.category = 'R';
                    }
                }
                function recordPref(font, glyphs) {
                    for(var _iterator56 = _createForOfIteratorHelperLoose(glyphs), _step56; !(_step56 = _iterator56()).done;){
                        var glyph = _step56.value;
                        if (glyph.substituted) // Mark a substituted pref as VPre, as they behave the same way.
                        glyph.shaperInfo.category = 'VPre';
                    }
                }
                function reorder(font, glyphs) {
                    var dottedCircle = font.glyphForCodePoint(0x25cc).id;
                    for(var start = 0, end = nextSyllable$1(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable$1(glyphs, start)){
                        var i = void 0, j = void 0;
                        var info = glyphs[start].shaperInfo;
                        var type = info.syllableType; // Only a few syllable types need reordering.
                        if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') continue;
                         // Insert a dotted circle glyph in broken clusters.
                        if (type === 'broken_cluster' && dottedCircle) {
                            var g = new GlyphInfo(font, dottedCircle, [
                                0x25cc
                            ]);
                            g.shaperInfo = info; // Insert after possible Repha.
                            for(i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++);
                            glyphs.splice(++i, 0, g);
                            end++;
                        } // Move things forward.
                        if (info.category === 'R' && end - start > 1) // Got a repha. Reorder it to after first base, before first halant.
                        for(i = start + 1; i < end; i++){
                            info = glyphs[i].shaperInfo;
                            if (isBase(info) || isHalant(glyphs[i])) {
                                // If we hit a halant, move before it; otherwise it's a base: move to it's
                                // place, and shift things in between backward.
                                if (isHalant(glyphs[i])) i--;
                                glyphs.splice.apply(glyphs, [
                                    start,
                                    0
                                ].concat(glyphs.splice(start + 1, i - start), [
                                    glyphs[i]
                                ]));
                                break;
                            }
                        }
                         // Move things back.
                        for(i = start, j = end; i < end; i++){
                            info = glyphs[i].shaperInfo;
                            if (isBase(info) || isHalant(glyphs[i])) // If we hit a halant, move after it; otherwise it's a base: move to it's
                            // place, and shift things in between backward.
                            j = isHalant(glyphs[i]) ? i + 1 : i;
                            else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) glyphs.splice.apply(glyphs, [
                                j,
                                1,
                                glyphs[i]
                            ].concat(glyphs.splice(j, i - j)));
                        }
                    }
                }
                function nextSyllable$1(glyphs, start) {
                    if (start >= glyphs.length) return start;
                    var syllable = glyphs[start].shaperInfo.syllable;
                    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
                    return start;
                }
                function isHalant(glyph) {
                    return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
                }
                function isBase(info) {
                    return info.category === 'B' || info.category === 'GB';
                }
                var SHAPERS = {
                    arab: ArabicShaper,
                    // Arabic
                    mong: ArabicShaper,
                    // Mongolian
                    syrc: ArabicShaper,
                    // Syriac
                    'nko ': ArabicShaper,
                    // N'Ko
                    phag: ArabicShaper,
                    // Phags Pa
                    mand: ArabicShaper,
                    // Mandaic
                    mani: ArabicShaper,
                    // Manichaean
                    phlp: ArabicShaper,
                    // Psalter Pahlavi
                    hang: HangulShaper,
                    // Hangul
                    bng2: IndicShaper,
                    // Bengali
                    beng: IndicShaper,
                    // Bengali
                    dev2: IndicShaper,
                    // Devanagari
                    deva: IndicShaper,
                    // Devanagari
                    gjr2: IndicShaper,
                    // Gujarati
                    gujr: IndicShaper,
                    // Gujarati
                    guru: IndicShaper,
                    // Gurmukhi
                    gur2: IndicShaper,
                    // Gurmukhi
                    knda: IndicShaper,
                    // Kannada
                    knd2: IndicShaper,
                    // Kannada
                    mlm2: IndicShaper,
                    // Malayalam
                    mlym: IndicShaper,
                    // Malayalam
                    ory2: IndicShaper,
                    // Oriya
                    orya: IndicShaper,
                    // Oriya
                    taml: IndicShaper,
                    // Tamil
                    tml2: IndicShaper,
                    // Tamil
                    telu: IndicShaper,
                    // Telugu
                    tel2: IndicShaper,
                    // Telugu
                    khmr: IndicShaper,
                    // Khmer
                    bali: UniversalShaper,
                    // Balinese
                    batk: UniversalShaper,
                    // Batak
                    brah: UniversalShaper,
                    // Brahmi
                    bugi: UniversalShaper,
                    // Buginese
                    buhd: UniversalShaper,
                    // Buhid
                    cakm: UniversalShaper,
                    // Chakma
                    cham: UniversalShaper,
                    // Cham
                    dupl: UniversalShaper,
                    // Duployan
                    egyp: UniversalShaper,
                    // Egyptian Hieroglyphs
                    gran: UniversalShaper,
                    // Grantha
                    hano: UniversalShaper,
                    // Hanunoo
                    java: UniversalShaper,
                    // Javanese
                    kthi: UniversalShaper,
                    // Kaithi
                    kali: UniversalShaper,
                    // Kayah Li
                    khar: UniversalShaper,
                    // Kharoshthi
                    khoj: UniversalShaper,
                    // Khojki
                    sind: UniversalShaper,
                    // Khudawadi
                    lepc: UniversalShaper,
                    // Lepcha
                    limb: UniversalShaper,
                    // Limbu
                    mahj: UniversalShaper,
                    // Mahajani
                    // mand: UniversalShaper, // Mandaic
                    // mani: UniversalShaper, // Manichaean
                    mtei: UniversalShaper,
                    // Meitei Mayek
                    modi: UniversalShaper,
                    // Modi
                    // mong: UniversalShaper, // Mongolian
                    // 'nko ': UniversalShaper, // N’Ko
                    hmng: UniversalShaper,
                    // Pahawh Hmong
                    // phag: UniversalShaper, // Phags-pa
                    // phlp: UniversalShaper, // Psalter Pahlavi
                    rjng: UniversalShaper,
                    // Rejang
                    saur: UniversalShaper,
                    // Saurashtra
                    shrd: UniversalShaper,
                    // Sharada
                    sidd: UniversalShaper,
                    // Siddham
                    sinh: UniversalShaper,
                    // Sinhala
                    sund: UniversalShaper,
                    // Sundanese
                    sylo: UniversalShaper,
                    // Syloti Nagri
                    tglg: UniversalShaper,
                    // Tagalog
                    tagb: UniversalShaper,
                    // Tagbanwa
                    tale: UniversalShaper,
                    // Tai Le
                    lana: UniversalShaper,
                    // Tai Tham
                    tavt: UniversalShaper,
                    // Tai Viet
                    takr: UniversalShaper,
                    // Takri
                    tibt: UniversalShaper,
                    // Tibetan
                    tfng: UniversalShaper,
                    // Tifinagh
                    tirh: UniversalShaper,
                    // Tirhuta
                    latn: DefaultShaper,
                    // Latin
                    DFLT: DefaultShaper // Default
                };
                function choose(script) {
                    if (!Array.isArray(script)) script = [
                        script
                    ];
                    for(var _iterator57 = _createForOfIteratorHelperLoose(script), _step57; !(_step57 = _iterator57()).done;){
                        var s = _step57.value;
                        var shaper = SHAPERS[s];
                        if (shaper) return shaper;
                    }
                    return DefaultShaper;
                }
                var GSUBProcessor = /*#__PURE__*/ function(_OTProcessor) {
                    function GSUBProcessor() {
                        return _OTProcessor.apply(this, arguments) || this;
                    }
                    _inheritsLoose(GSUBProcessor, _OTProcessor);
                    var _proto25 = GSUBProcessor.prototype;
                    _proto25.applyLookup = function applyLookup(lookupType, table) {
                        var _this7 = this;
                        switch(lookupType){
                            case 1:
                                // Single Substitution
                                var index = this.coverageIndex(table.coverage);
                                if (index === -1) return false;
                                var glyph = this.glyphIterator.cur;
                                switch(table.version){
                                    case 1:
                                        glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
                                        break;
                                    case 2:
                                        glyph.id = table.substitute.get(index);
                                        break;
                                }
                                return true;
                            case 2:
                                // Multiple Substitution
                                var _index = this.coverageIndex(table.coverage);
                                if (_index !== -1) {
                                    var _this$glyphs2;
                                    var sequence = table.sequences.get(_index);
                                    if (sequence.length === 0) {
                                        // If the sequence length is zero, delete the glyph.
                                        // The OpenType spec disallows this, but seems like Harfbuzz and Uniscribe allow it.
                                        this.glyphs.splice(this.glyphIterator.index, 1);
                                        return true;
                                    }
                                    this.glyphIterator.cur.id = sequence[0];
                                    this.glyphIterator.cur.ligatureComponent = 0;
                                    var features = this.glyphIterator.cur.features;
                                    var curGlyph = this.glyphIterator.cur;
                                    var replacement = sequence.slice(1).map(function(gid, i) {
                                        var glyph = new GlyphInfo(_this7.font, gid, undefined, features);
                                        glyph.shaperInfo = curGlyph.shaperInfo;
                                        glyph.isLigated = curGlyph.isLigated;
                                        glyph.ligatureComponent = i + 1;
                                        glyph.substituted = true;
                                        glyph.isMultiplied = true;
                                        return glyph;
                                    });
                                    (_this$glyphs2 = this.glyphs).splice.apply(_this$glyphs2, [
                                        this.glyphIterator.index + 1,
                                        0
                                    ].concat(replacement));
                                    return true;
                                }
                                return false;
                            case 3:
                                // Alternate Substitution
                                var _index2 = this.coverageIndex(table.coverage);
                                if (_index2 !== -1) {
                                    var USER_INDEX = 0; // TODO
                                    this.glyphIterator.cur.id = table.alternateSet.get(_index2)[USER_INDEX];
                                    return true;
                                }
                                return false;
                            case 4:
                                // Ligature Substitution
                                var _index3 = this.coverageIndex(table.coverage);
                                if (_index3 === -1) return false;
                                for(var _iterator58 = _createForOfIteratorHelperLoose(table.ligatureSets.get(_index3)), _step58; !(_step58 = _iterator58()).done;){
                                    var ligature = _step58.value;
                                    var matched = this.sequenceMatchIndices(1, ligature.components);
                                    if (!matched) continue;
                                    var _curGlyph = this.glyphIterator.cur; // Concatenate all of the characters the new ligature will represent
                                    var characters = _curGlyph.codePoints.slice();
                                    for(var _iterator59 = _createForOfIteratorHelperLoose(matched), _step59; !(_step59 = _iterator59()).done;){
                                        var _characters;
                                        var _index4 = _step59.value;
                                        (_characters = characters).push.apply(_characters, this.glyphs[_index4].codePoints);
                                    } // Create the replacement ligature glyph
                                    var ligatureGlyph = new GlyphInfo(this.font, ligature.glyph, characters, _curGlyph.features);
                                    ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
                                    ligatureGlyph.isLigated = true;
                                    ligatureGlyph.substituted = true; // From Harfbuzz:
                                    // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
                                    //   the ligature to keep its old ligature id.  This will allow it to attach to
                                    //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
                                    //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
                                    //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
                                    //   later, we don't want them to lose their ligature id/component, otherwise
                                    //   GPOS will fail to correctly position the mark ligature on top of the
                                    //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
                                    //
                                    // - If a ligature is formed of components that some of which are also ligatures
                                    //   themselves, and those ligature components had marks attached to *their*
                                    //   components, we have to attach the marks to the new ligature component
                                    //   positions!  Now *that*'s tricky!  And these marks may be following the
                                    //   last component of the whole sequence, so we should loop forward looking
                                    //   for them and update them.
                                    //
                                    //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
                                    //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
                                    //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
                                    //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
                                    //   the new ligature with a component value of 2.
                                    //
                                    //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
                                    var isMarkLigature = _curGlyph.isMark;
                                    for(var i = 0; i < matched.length && isMarkLigature; i++)isMarkLigature = this.glyphs[matched[i]].isMark;
                                    ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                                    var lastLigID = _curGlyph.ligatureID;
                                    var lastNumComps = _curGlyph.codePoints.length;
                                    var curComps = lastNumComps;
                                    var idx = this.glyphIterator.index + 1; // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
                                    // This allows GPOS to attach marks to the correct ligature components.
                                    for(var _iterator60 = _createForOfIteratorHelperLoose(matched), _step60; !(_step60 = _iterator60()).done;){
                                        var matchIndex = _step60.value;
                                        // Don't assign new ligature components for mark ligatures (see above)
                                        if (isMarkLigature) idx = matchIndex;
                                        else while(idx < matchIndex){
                                            var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                                            this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                                            this.glyphs[idx].ligatureComponent = ligatureComponent;
                                            idx++;
                                        }
                                        lastLigID = this.glyphs[idx].ligatureID;
                                        lastNumComps = this.glyphs[idx].codePoints.length;
                                        curComps += lastNumComps;
                                        idx++; // skip base glyph
                                    } // Adjust ligature components for any marks following
                                    if (lastLigID && !isMarkLigature) for(var _i = idx; _i < this.glyphs.length; _i++){
                                        if (this.glyphs[_i].ligatureID === lastLigID) {
                                            var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[_i].ligatureComponent || 1, lastNumComps);
                                            this.glyphs[_i].ligatureComponent = ligatureComponent;
                                        } else break;
                                    }
                                     // Delete the matched glyphs, and replace the current glyph with the ligature glyph
                                    for(var _i2 = matched.length - 1; _i2 >= 0; _i2--)this.glyphs.splice(matched[_i2], 1);
                                    this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                                    return true;
                                }
                                return false;
                            case 5:
                                // Contextual Substitution
                                return this.applyContext(table);
                            case 6:
                                // Chaining Contextual Substitution
                                return this.applyChainingContext(table);
                            case 7:
                                // Extension Substitution
                                return this.applyLookup(table.lookupType, table.extension);
                            default:
                                throw new Error("GSUB lookupType ".concat(lookupType, " is not supported"));
                        }
                    };
                    return GSUBProcessor;
                }(OTProcessor);
                var GPOSProcessor = /*#__PURE__*/ function(_OTProcessor2) {
                    function GPOSProcessor() {
                        return _OTProcessor2.apply(this, arguments) || this;
                    }
                    _inheritsLoose(GPOSProcessor, _OTProcessor2);
                    var _proto26 = GPOSProcessor.prototype;
                    _proto26.applyPositionValue = function applyPositionValue(sequenceIndex, value) {
                        var position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
                        if (value.xAdvance != null) position.xAdvance += value.xAdvance;
                        if (value.yAdvance != null) position.yAdvance += value.yAdvance;
                        if (value.xPlacement != null) position.xOffset += value.xPlacement;
                        if (value.yPlacement != null) position.yOffset += value.yPlacement;
                         // Adjustments for font variations
                        var variationProcessor = this.font._variationProcessor;
                        var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
                        if (variationProcessor && variationStore) {
                            if (value.xPlaDevice) position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
                            if (value.yPlaDevice) position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
                            if (value.xAdvDevice) position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
                            if (value.yAdvDevice) position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
                        } // TODO: device tables
                    };
                    _proto26.applyLookup = function applyLookup(lookupType, table) {
                        switch(lookupType){
                            case 1:
                                // Single positioning value
                                var index = this.coverageIndex(table.coverage);
                                if (index === -1) return false;
                                switch(table.version){
                                    case 1:
                                        this.applyPositionValue(0, table.value);
                                        break;
                                    case 2:
                                        this.applyPositionValue(0, table.values.get(index));
                                        break;
                                }
                                return true;
                            case 2:
                                // Pair Adjustment Positioning
                                var nextGlyph = this.glyphIterator.peek();
                                if (!nextGlyph) return false;
                                var _index = this.coverageIndex(table.coverage);
                                if (_index === -1) return false;
                                switch(table.version){
                                    case 1:
                                        // Adjustments for glyph pairs
                                        var set = table.pairSets.get(_index);
                                        for(var _iterator61 = _createForOfIteratorHelperLoose(set), _step61; !(_step61 = _iterator61()).done;){
                                            var _pair = _step61.value;
                                            if (_pair.secondGlyph === nextGlyph.id) {
                                                this.applyPositionValue(0, _pair.value1);
                                                this.applyPositionValue(1, _pair.value2);
                                                return true;
                                            }
                                        }
                                        return false;
                                    case 2:
                                        // Class pair adjustment
                                        var class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                                        var class2 = this.getClassID(nextGlyph.id, table.classDef2);
                                        if (class1 === -1 || class2 === -1) return false;
                                        var pair = table.classRecords.get(class1).get(class2);
                                        this.applyPositionValue(0, pair.value1);
                                        this.applyPositionValue(1, pair.value2);
                                        return true;
                                }
                            case 3:
                                // Cursive Attachment Positioning
                                var nextIndex = this.glyphIterator.peekIndex();
                                var _nextGlyph = this.glyphs[nextIndex];
                                if (!_nextGlyph) return false;
                                var curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
                                if (!curRecord || !curRecord.exitAnchor) return false;
                                var nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, _nextGlyph.id)];
                                if (!nextRecord || !nextRecord.entryAnchor) return false;
                                var entry = this.getAnchor(nextRecord.entryAnchor);
                                var exit = this.getAnchor(curRecord.exitAnchor);
                                var cur = this.positions[this.glyphIterator.index];
                                var next = this.positions[nextIndex];
                                switch(this.direction){
                                    case 'ltr':
                                        cur.xAdvance = exit.x + cur.xOffset;
                                        var d = entry.x + next.xOffset;
                                        next.xAdvance -= d;
                                        next.xOffset -= d;
                                        break;
                                    case 'rtl':
                                        d = exit.x + cur.xOffset;
                                        cur.xAdvance -= d;
                                        cur.xOffset -= d;
                                        next.xAdvance = entry.x + next.xOffset;
                                        break;
                                }
                                if (this.glyphIterator.flags.rightToLeft) {
                                    this.glyphIterator.cur.cursiveAttachment = nextIndex;
                                    cur.yOffset = entry.y - exit.y;
                                } else {
                                    _nextGlyph.cursiveAttachment = this.glyphIterator.index;
                                    cur.yOffset = exit.y - entry.y;
                                }
                                return true;
                            case 4:
                                // Mark to base positioning
                                var markIndex = this.coverageIndex(table.markCoverage);
                                if (markIndex === -1) return false;
                                 // search backward for a base glyph
                                var baseGlyphIndex = this.glyphIterator.index;
                                while(--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0));
                                if (baseGlyphIndex < 0) return false;
                                var baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
                                if (baseIndex === -1) return false;
                                var markRecord = table.markArray[markIndex];
                                var baseAnchor = table.baseArray[baseIndex][markRecord.class];
                                this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                                return true;
                            case 5:
                                // Mark to ligature positioning
                                var _markIndex = this.coverageIndex(table.markCoverage);
                                if (_markIndex === -1) return false;
                                 // search backward for a base glyph
                                var _baseGlyphIndex = this.glyphIterator.index;
                                while(--_baseGlyphIndex >= 0 && this.glyphs[_baseGlyphIndex].isMark);
                                if (_baseGlyphIndex < 0) return false;
                                var ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[_baseGlyphIndex].id);
                                if (ligIndex === -1) return false;
                                var ligAttach = table.ligatureArray[ligIndex];
                                var markGlyph = this.glyphIterator.cur;
                                var ligGlyph = this.glyphs[_baseGlyphIndex];
                                var compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                                var _markRecord = table.markArray[_markIndex];
                                var _baseAnchor = ligAttach[compIndex][_markRecord.class];
                                this.applyAnchor(_markRecord, _baseAnchor, _baseGlyphIndex);
                                return true;
                            case 6:
                                // Mark to mark positioning
                                var mark1Index = this.coverageIndex(table.mark1Coverage);
                                if (mark1Index === -1) return false;
                                 // get the previous mark to attach to
                                var prevIndex = this.glyphIterator.peekIndex(-1);
                                var prev = this.glyphs[prevIndex];
                                if (!prev || !prev.isMark) return false;
                                var _cur = this.glyphIterator.cur; // The following logic was borrowed from Harfbuzz
                                var good = false;
                                if (_cur.ligatureID === prev.ligatureID) {
                                    if (!_cur.ligatureID) // Marks belonging to the same base
                                    good = true;
                                    else if (_cur.ligatureComponent === prev.ligatureComponent) // Marks belonging to the same ligature component
                                    good = true;
                                } else // If ligature ids don't match, it may be the case that one of the marks
                                // itself is a ligature, in which case match.
                                if (_cur.ligatureID && !_cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) good = true;
                                if (!good) return false;
                                var mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
                                if (mark2Index === -1) return false;
                                var _markRecord2 = table.mark1Array[mark1Index];
                                var _baseAnchor2 = table.mark2Array[mark2Index][_markRecord2.class];
                                this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
                                return true;
                            case 7:
                                // Contextual positioning
                                return this.applyContext(table);
                            case 8:
                                // Chaining contextual positioning
                                return this.applyChainingContext(table);
                            case 9:
                                // Extension positioning
                                return this.applyLookup(table.lookupType, table.extension);
                            default:
                                throw new Error("Unsupported GPOS table: ".concat(lookupType));
                        }
                    };
                    _proto26.applyAnchor = function applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
                        var baseCoords = this.getAnchor(baseAnchor);
                        var markCoords = this.getAnchor(markRecord.markAnchor);
                        var basePos = this.positions[baseGlyphIndex];
                        var markPos = this.positions[this.glyphIterator.index];
                        markPos.xOffset = baseCoords.x - markCoords.x;
                        markPos.yOffset = baseCoords.y - markCoords.y;
                        this.glyphIterator.cur.markAttachment = baseGlyphIndex;
                    };
                    _proto26.getAnchor = function getAnchor(anchor) {
                        // TODO: contour point, device tables
                        var x = anchor.xCoordinate;
                        var y = anchor.yCoordinate; // Adjustments for font variations
                        var variationProcessor = this.font._variationProcessor;
                        var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
                        if (variationProcessor && variationStore) {
                            if (anchor.xDeviceTable) x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
                            if (anchor.yDeviceTable) y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
                        }
                        return {
                            x: x,
                            y: y
                        };
                    };
                    _proto26.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
                        _OTProcessor2.prototype.applyFeatures.call(this, userFeatures, glyphs, advances);
                        for(var i = 0; i < this.glyphs.length; i++)this.fixCursiveAttachment(i);
                        this.fixMarkAttachment();
                    };
                    _proto26.fixCursiveAttachment = function fixCursiveAttachment(i) {
                        var glyph = this.glyphs[i];
                        if (glyph.cursiveAttachment != null) {
                            var j = glyph.cursiveAttachment;
                            glyph.cursiveAttachment = null;
                            this.fixCursiveAttachment(j);
                            this.positions[i].yOffset += this.positions[j].yOffset;
                        }
                    };
                    _proto26.fixMarkAttachment = function fixMarkAttachment() {
                        for(var i = 0; i < this.glyphs.length; i++){
                            var glyph = this.glyphs[i];
                            if (glyph.markAttachment != null) {
                                var j = glyph.markAttachment;
                                this.positions[i].xOffset += this.positions[j].xOffset;
                                this.positions[i].yOffset += this.positions[j].yOffset;
                                if (this.direction === 'ltr') for(var k = j; k < i; k++){
                                    this.positions[i].xOffset -= this.positions[k].xAdvance;
                                    this.positions[i].yOffset -= this.positions[k].yAdvance;
                                }
                                else for(var _k = j + 1; _k < i + 1; _k++){
                                    this.positions[i].xOffset += this.positions[_k].xAdvance;
                                    this.positions[i].yOffset += this.positions[_k].yAdvance;
                                }
                            }
                        }
                    };
                    return GPOSProcessor;
                }(OTProcessor);
                var OTLayoutEngine = /*#__PURE__*/ function() {
                    function OTLayoutEngine(font) {
                        this.font = font;
                        this.glyphInfos = null;
                        this.plan = null;
                        this.GSUBProcessor = null;
                        this.GPOSProcessor = null;
                        this.fallbackPosition = true;
                        if (font.GSUB) this.GSUBProcessor = new GSUBProcessor(font, font.GSUB);
                        if (font.GPOS) this.GPOSProcessor = new GPOSProcessor(font, font.GPOS);
                    }
                    var _proto27 = OTLayoutEngine.prototype;
                    _proto27.setup = function setup(glyphRun) {
                        var _this8 = this;
                        // Map glyphs to GlyphInfo objects so data can be passed between
                        // GSUB and GPOS without mutating the real (shared) Glyph objects.
                        this.glyphInfos = glyphRun.glyphs.map(function(glyph) {
                            return new GlyphInfo(_this8.font, glyph.id, [].concat(glyph.codePoints));
                        }); // Select a script based on what is available in GSUB/GPOS.
                        var script = null;
                        if (this.GPOSProcessor) script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
                        if (this.GSUBProcessor) script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
                         // Choose a shaper based on the script, and setup a shaping plan.
                        // This determines which features to apply to which glyphs.
                        this.shaper = choose(script);
                        this.plan = new ShapingPlan(this.font, script, glyphRun.direction);
                        this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features); // Assign chosen features to output glyph run
                        for(var key in this.plan.allFeatures)glyphRun.features[key] = true;
                    };
                    _proto27.substitute = function substitute(glyphRun) {
                        var _this9 = this;
                        if (this.GSUBProcessor) {
                            this.plan.process(this.GSUBProcessor, this.glyphInfos); // Map glyph infos back to normal Glyph objects
                            glyphRun.glyphs = this.glyphInfos.map(function(glyphInfo) {
                                return _this9.font.getGlyph(glyphInfo.id, glyphInfo.codePoints);
                            });
                        }
                    };
                    _proto27.position = function position(glyphRun) {
                        if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') this.zeroMarkAdvances(glyphRun.positions);
                        if (this.GPOSProcessor) this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
                        if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') this.zeroMarkAdvances(glyphRun.positions);
                         // Reverse the glyphs and positions if the script is right-to-left
                        if (glyphRun.direction === 'rtl') {
                            glyphRun.glyphs.reverse();
                            glyphRun.positions.reverse();
                        }
                        return this.GPOSProcessor && this.GPOSProcessor.features;
                    };
                    _proto27.zeroMarkAdvances = function zeroMarkAdvances(positions) {
                        for(var i = 0; i < this.glyphInfos.length; i++)if (this.glyphInfos[i].isMark) {
                            positions[i].xAdvance = 0;
                            positions[i].yAdvance = 0;
                        }
                    };
                    _proto27.cleanup = function cleanup() {
                        this.glyphInfos = null;
                        this.plan = null;
                        this.shaper = null;
                    };
                    _proto27.getAvailableFeatures = function getAvailableFeatures(script, language) {
                        var features = [];
                        if (this.GSUBProcessor) {
                            this.GSUBProcessor.selectScript(script, language);
                            features.push.apply(features, Object.keys(this.GSUBProcessor.features));
                        }
                        if (this.GPOSProcessor) {
                            this.GPOSProcessor.selectScript(script, language);
                            features.push.apply(features, Object.keys(this.GPOSProcessor.features));
                        }
                        return features;
                    };
                    return OTLayoutEngine;
                }();
                var LayoutEngine = /*#__PURE__*/ function() {
                    function LayoutEngine(font) {
                        this.font = font;
                        this.unicodeLayoutEngine = null;
                        this.kernProcessor = null; // Choose an advanced layout engine. We try the AAT morx table first since more
                        // scripts are currently supported because the shaping logic is built into the font.
                        if (this.font.morx) this.engine = new AATLayoutEngine(this.font);
                        else if (this.font.GSUB || this.font.GPOS) this.engine = new OTLayoutEngine(this.font);
                    }
                    var _proto28 = LayoutEngine.prototype;
                    _proto28.layout = function layout(string, features, script, language, direction) {
                        // Make the features parameter optional
                        if (typeof features === 'string') {
                            direction = language;
                            language = script;
                            script = features;
                            features = [];
                        } // Map string to glyphs if needed
                        if (typeof string === 'string') {
                            // Attempt to detect the script from the string if not provided.
                            if (script == null) script = forString(string);
                            var glyphs = this.font.glyphsForString(string);
                        } else {
                            // Attempt to detect the script from the glyph code points if not provided.
                            if (script == null) {
                                var codePoints = [];
                                for(var _iterator62 = _createForOfIteratorHelperLoose(string), _step62; !(_step62 = _iterator62()).done;){
                                    var glyph = _step62.value;
                                    codePoints.push.apply(codePoints, glyph.codePoints);
                                }
                                script = forCodePoints(codePoints);
                            }
                            var glyphs = string;
                        }
                        var glyphRun = new GlyphRun(glyphs, features, script, language, direction); // Return early if there are no glyphs
                        if (glyphs.length === 0) {
                            glyphRun.positions = [];
                            return glyphRun;
                        } // Setup the advanced layout engine
                        if (this.engine && this.engine.setup) this.engine.setup(glyphRun);
                         // Substitute and position the glyphs
                        this.substitute(glyphRun);
                        this.position(glyphRun);
                        this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions); // Let the layout engine clean up any state it might have
                        if (this.engine && this.engine.cleanup) this.engine.cleanup();
                        return glyphRun;
                    };
                    _proto28.substitute = function substitute(glyphRun) {
                        // Call the advanced layout engine to make substitutions
                        if (this.engine && this.engine.substitute) this.engine.substitute(glyphRun);
                    };
                    _proto28.position = function position(glyphRun) {
                        // Get initial glyph positions
                        glyphRun.positions = glyphRun.glyphs.map(function(glyph) {
                            return new GlyphPosition(glyph.advanceWidth);
                        });
                        var positioned = null; // Call the advanced layout engine. Returns the features applied.
                        if (this.engine && this.engine.position) positioned = this.engine.position(glyphRun);
                         // if there is no GPOS table, use unicode properties to position marks.
                        if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
                            if (!this.unicodeLayoutEngine) this.unicodeLayoutEngine = new UnicodeLayoutEngine(this.font);
                            this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
                        } // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
                        if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
                            if (!this.kernProcessor) this.kernProcessor = new KernProcessor(this.font);
                            this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
                            glyphRun.features.kern = true;
                        }
                    };
                    _proto28.hideDefaultIgnorables = function hideDefaultIgnorables(glyphs, positions) {
                        var space = this.font.glyphForCodePoint(0x20);
                        for(var i = 0; i < glyphs.length; i++)if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
                            glyphs[i] = space;
                            positions[i].xAdvance = 0;
                            positions[i].yAdvance = 0;
                        }
                    };
                    _proto28.isDefaultIgnorable = function isDefaultIgnorable(ch) {
                        // From DerivedCoreProperties.txt in the Unicode database,
                        // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
                        // Harfbuzz and Uniscribe do.
                        var plane = ch >> 16;
                        if (plane === 0) // BMP
                        switch(ch >> 8){
                            case 0x00:
                                return ch === 0x00AD;
                            case 0x03:
                                return ch === 0x034F;
                            case 0x06:
                                return ch === 0x061C;
                            case 0x17:
                                return 0x17B4 <= ch && ch <= 0x17B5;
                            case 0x18:
                                return 0x180B <= ch && ch <= 0x180E;
                            case 0x20:
                                return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
                            case 0xFE:
                                return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
                            case 0xFF:
                                return 0xFFF0 <= ch && ch <= 0xFFF8;
                            default:
                                return false;
                        }
                        else // Other planes
                        switch(plane){
                            case 0x01:
                                return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
                            case 0x0E:
                                return 0xE0000 <= ch && ch <= 0xE0FFF;
                            default:
                                return false;
                        }
                    };
                    _proto28.getAvailableFeatures = function getAvailableFeatures(script, language) {
                        var features = [];
                        if (this.engine) features.push.apply(features, this.engine.getAvailableFeatures(script, language));
                        if (this.font.kern && features.indexOf('kern') === -1) features.push('kern');
                        return features;
                    };
                    _proto28.stringsForGlyph = function stringsForGlyph(gid) {
                        var result = new Set();
                        var codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
                        for(var _iterator63 = _createForOfIteratorHelperLoose(codePoints), _step63; !(_step63 = _iterator63()).done;){
                            var codePoint = _step63.value;
                            result.add(String.fromCodePoint(codePoint));
                        }
                        if (this.engine && this.engine.stringsForGlyph) for(var _iterator64 = _createForOfIteratorHelperLoose(this.engine.stringsForGlyph(gid)), _step64; !(_step64 = _iterator64()).done;){
                            var string = _step64.value;
                            result.add(string);
                        }
                        return Array.from(result);
                    };
                    return LayoutEngine;
                }();
                var SVG_COMMANDS = {
                    moveTo: 'M',
                    lineTo: 'L',
                    quadraticCurveTo: 'Q',
                    bezierCurveTo: 'C',
                    closePath: 'Z'
                };
                /**
 * Path objects are returned by glyphs and represent the actual
 * vector outlines for each glyph in the font. Paths can be converted
 * to SVG path data strings, or to functions that can be applied to
 * render the path to a graphics context.
 */ var Path = /*#__PURE__*/ function() {
                    function Path() {
                        this.commands = [];
                        this._bbox = null;
                        this._cbox = null;
                    }
                    /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */ var _proto29 = Path.prototype;
                    _proto29.toFunction = function toFunction() {
                        var _this0 = this;
                        return function(ctx) {
                            _this0.commands.forEach(function(c) {
                                return ctx[c.command].apply(ctx, c.args);
                            });
                        };
                    } /**
   * Converts the path to an SVG path data string
   * @return {string}
   */ ;
                    _proto29.toSVG = function toSVG() {
                        var cmds = this.commands.map(function(c) {
                            var args = c.args.map(function(arg) {
                                return Math.round(arg * 100) / 100;
                            });
                            return "".concat(SVG_COMMANDS[c.command]).concat(args.join(' '));
                        });
                        return cmds.join('');
                    } /**
   * Gets the "control box" of a path.
   * This is like the bounding box, but it includes all points including
   * control points of bezier segments and is much faster to compute than
   * the real bounding box.
   * @type {BBox}
   */ ;
                    /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */ _proto29.mapPoints = function mapPoints(fn) {
                        var path = new Path();
                        for(var _iterator65 = _createForOfIteratorHelperLoose(this.commands), _step65; !(_step65 = _iterator65()).done;){
                            var c = _step65.value;
                            var args = [];
                            for(var i = 0; i < c.args.length; i += 2){
                                var _fn = fn(c.args[i], c.args[i + 1]), x = _fn[0], y = _fn[1];
                                args.push(x, y);
                            }
                            path[c.command].apply(path, args);
                        }
                        return path;
                    } /**
   * Transforms the path by the given matrix.
   */ ;
                    _proto29.transform = function transform(m0, m1, m2, m3, m4, m5) {
                        return this.mapPoints(function(x, y) {
                            x = m0 * x + m2 * y + m4;
                            y = m1 * x + m3 * y + m5;
                            return [
                                x,
                                y
                            ];
                        });
                    } /**
   * Translates the path by the given offset.
   */ ;
                    _proto29.translate = function translate(x, y) {
                        return this.transform(1, 0, 0, 1, x, y);
                    } /**
   * Rotates the path by the given angle (in radians).
   */ ;
                    _proto29.rotate = function rotate(angle) {
                        var cos = Math.cos(angle);
                        var sin = Math.sin(angle);
                        return this.transform(cos, sin, -sin, cos, 0, 0);
                    } /**
   * Scales the path.
   */ ;
                    _proto29.scale = function scale(scaleX, scaleY) {
                        if (scaleY === void 0) scaleY = scaleX;
                        return this.transform(scaleX, 0, 0, scaleY, 0, 0);
                    };
                    return _createClass(Path, [
                        {
                            key: "cbox",
                            get: function get() {
                                if (!this._cbox) {
                                    var cbox = new BBox();
                                    for(var _iterator66 = _createForOfIteratorHelperLoose(this.commands), _step66; !(_step66 = _iterator66()).done;){
                                        var command = _step66.value;
                                        for(var i = 0; i < command.args.length; i += 2)cbox.addPoint(command.args[i], command.args[i + 1]);
                                    }
                                    this._cbox = Object.freeze(cbox);
                                }
                                return this._cbox;
                            }
                        },
                        {
                            key: "bbox",
                            get: function get() {
                                if (this._bbox) return this._bbox;
                                var bbox = new BBox();
                                var cx = 0, cy = 0;
                                var f = function f(t) {
                                    return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
                                };
                                for(var _iterator67 = _createForOfIteratorHelperLoose(this.commands), _step67; !(_step67 = _iterator67()).done;){
                                    var c = _step67.value;
                                    switch(c.command){
                                        case 'moveTo':
                                        case 'lineTo':
                                            var _c$args = c.args, x = _c$args[0], y = _c$args[1];
                                            bbox.addPoint(x, y);
                                            cx = x;
                                            cy = y;
                                            break;
                                        case 'quadraticCurveTo':
                                        case 'bezierCurveTo':
                                            if (c.command === 'quadraticCurveTo') {
                                                // http://fontforge.org/bezier.html
                                                var _c$args2 = c.args, qp1x = _c$args2[0], qp1y = _c$args2[1], p3x = _c$args2[2], p3y = _c$args2[3];
                                                var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
                                                var cp1y = cy + 2 / 3 * (qp1y - cy);
                                                var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
                                                var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                                            } else var _c$args3 = c.args, cp1x = _c$args3[0], cp1y = _c$args3[1], cp2x = _c$args3[2], cp2y = _c$args3[3], p3x = _c$args3[4], p3y = _c$args3[5];
                                             // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
                                            bbox.addPoint(p3x, p3y);
                                            var p0 = [
                                                cx,
                                                cy
                                            ];
                                            var p1 = [
                                                cp1x,
                                                cp1y
                                            ];
                                            var p2 = [
                                                cp2x,
                                                cp2y
                                            ];
                                            var p3 = [
                                                p3x,
                                                p3y
                                            ];
                                            for(var i = 0; i <= 1; i++){
                                                var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                                                var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                                                c = 3 * p1[i] - 3 * p0[i];
                                                if (a === 0) {
                                                    if (b === 0) continue;
                                                    var t = -c / b;
                                                    if (0 < t && t < 1) {
                                                        if (i === 0) bbox.addPoint(f(t), bbox.maxY);
                                                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t));
                                                    }
                                                    continue;
                                                }
                                                var b2ac = Math.pow(b, 2) - 4 * c * a;
                                                if (b2ac < 0) continue;
                                                var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                                                if (0 < t1 && t1 < 1) {
                                                    if (i === 0) bbox.addPoint(f(t1), bbox.maxY);
                                                    else if (i === 1) bbox.addPoint(bbox.maxX, f(t1));
                                                }
                                                var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                                                if (0 < t2 && t2 < 1) {
                                                    if (i === 0) bbox.addPoint(f(t2), bbox.maxY);
                                                    else if (i === 1) bbox.addPoint(bbox.maxX, f(t2));
                                                }
                                            }
                                            cx = p3x;
                                            cy = p3y;
                                            break;
                                    }
                                }
                                return this._bbox = Object.freeze(bbox);
                            }
                        }
                    ]);
                }();
                var _loop = function _loop(command) {
                    Path.prototype[command] = function() {
                        this._bbox = this._cbox = null;
                        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                        this.commands.push({
                            command: command,
                            args: args
                        });
                        return this;
                    };
                };
                for(var _i1 = 0, _arr = [
                    'moveTo',
                    'lineTo',
                    'quadraticCurveTo',
                    'bezierCurveTo',
                    'closePath'
                ]; _i1 < _arr.length; _i1++){
                    var command = _arr[_i1];
                    _loop(command);
                }
                var StandardNames = [
                    '.notdef',
                    '.null',
                    'nonmarkingreturn',
                    'space',
                    'exclam',
                    'quotedbl',
                    'numbersign',
                    'dollar',
                    'percent',
                    'ampersand',
                    'quotesingle',
                    'parenleft',
                    'parenright',
                    'asterisk',
                    'plus',
                    'comma',
                    'hyphen',
                    'period',
                    'slash',
                    'zero',
                    'one',
                    'two',
                    'three',
                    'four',
                    'five',
                    'six',
                    'seven',
                    'eight',
                    'nine',
                    'colon',
                    'semicolon',
                    'less',
                    'equal',
                    'greater',
                    'question',
                    'at',
                    'A',
                    'B',
                    'C',
                    'D',
                    'E',
                    'F',
                    'G',
                    'H',
                    'I',
                    'J',
                    'K',
                    'L',
                    'M',
                    'N',
                    'O',
                    'P',
                    'Q',
                    'R',
                    'S',
                    'T',
                    'U',
                    'V',
                    'W',
                    'X',
                    'Y',
                    'Z',
                    'bracketleft',
                    'backslash',
                    'bracketright',
                    'asciicircum',
                    'underscore',
                    'grave',
                    'a',
                    'b',
                    'c',
                    'd',
                    'e',
                    'f',
                    'g',
                    'h',
                    'i',
                    'j',
                    'k',
                    'l',
                    'm',
                    'n',
                    'o',
                    'p',
                    'q',
                    'r',
                    's',
                    't',
                    'u',
                    'v',
                    'w',
                    'x',
                    'y',
                    'z',
                    'braceleft',
                    'bar',
                    'braceright',
                    'asciitilde',
                    'Adieresis',
                    'Aring',
                    'Ccedilla',
                    'Eacute',
                    'Ntilde',
                    'Odieresis',
                    'Udieresis',
                    'aacute',
                    'agrave',
                    'acircumflex',
                    'adieresis',
                    'atilde',
                    'aring',
                    'ccedilla',
                    'eacute',
                    'egrave',
                    'ecircumflex',
                    'edieresis',
                    'iacute',
                    'igrave',
                    'icircumflex',
                    'idieresis',
                    'ntilde',
                    'oacute',
                    'ograve',
                    'ocircumflex',
                    'odieresis',
                    'otilde',
                    'uacute',
                    'ugrave',
                    'ucircumflex',
                    'udieresis',
                    'dagger',
                    'degree',
                    'cent',
                    'sterling',
                    'section',
                    'bullet',
                    'paragraph',
                    'germandbls',
                    'registered',
                    'copyright',
                    'trademark',
                    'acute',
                    'dieresis',
                    'notequal',
                    'AE',
                    'Oslash',
                    'infinity',
                    'plusminus',
                    'lessequal',
                    'greaterequal',
                    'yen',
                    'mu',
                    'partialdiff',
                    'summation',
                    'product',
                    'pi',
                    'integral',
                    'ordfeminine',
                    'ordmasculine',
                    'Omega',
                    'ae',
                    'oslash',
                    'questiondown',
                    'exclamdown',
                    'logicalnot',
                    'radical',
                    'florin',
                    'approxequal',
                    'Delta',
                    'guillemotleft',
                    'guillemotright',
                    'ellipsis',
                    'nonbreakingspace',
                    'Agrave',
                    'Atilde',
                    'Otilde',
                    'OE',
                    'oe',
                    'endash',
                    'emdash',
                    'quotedblleft',
                    'quotedblright',
                    'quoteleft',
                    'quoteright',
                    'divide',
                    'lozenge',
                    'ydieresis',
                    'Ydieresis',
                    'fraction',
                    'currency',
                    'guilsinglleft',
                    'guilsinglright',
                    'fi',
                    'fl',
                    'daggerdbl',
                    'periodcentered',
                    'quotesinglbase',
                    'quotedblbase',
                    'perthousand',
                    'Acircumflex',
                    'Ecircumflex',
                    'Aacute',
                    'Edieresis',
                    'Egrave',
                    'Iacute',
                    'Icircumflex',
                    'Idieresis',
                    'Igrave',
                    'Oacute',
                    'Ocircumflex',
                    'apple',
                    'Ograve',
                    'Uacute',
                    'Ucircumflex',
                    'Ugrave',
                    'dotlessi',
                    'circumflex',
                    'tilde',
                    'macron',
                    'breve',
                    'dotaccent',
                    'ring',
                    'cedilla',
                    'hungarumlaut',
                    'ogonek',
                    'caron',
                    'Lslash',
                    'lslash',
                    'Scaron',
                    'scaron',
                    'Zcaron',
                    'zcaron',
                    'brokenbar',
                    'Eth',
                    'eth',
                    'Yacute',
                    'yacute',
                    'Thorn',
                    'thorn',
                    'minus',
                    'multiply',
                    'onesuperior',
                    'twosuperior',
                    'threesuperior',
                    'onehalf',
                    'onequarter',
                    'threequarters',
                    'franc',
                    'Gbreve',
                    'gbreve',
                    'Idotaccent',
                    'Scedilla',
                    'scedilla',
                    'Cacute',
                    'cacute',
                    'Ccaron',
                    'ccaron',
                    'dcroat'
                ];
                var _class$3;
                /**
 * Glyph objects represent a glyph in the font. They have various properties for accessing metrics and
 * the actual vector path the glyph represents, and methods for rendering the glyph to a graphics context.
 *
 * You do not create glyph objects directly. They are created by various methods on the font object.
 * There are several subclasses of the base Glyph class internally that may be returned depending
 * on the font format, but they all inherit from this class.
 */ var Glyph = (_class$3 = /*#__PURE__*/ function() {
                    function Glyph(id, codePoints, font) {
                        /**
     * The glyph id in the font
     * @type {number}
     */ this.id = id;
                        /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */ this.codePoints = codePoints;
                        this._font = font; // TODO: get this info from GDEF if available
                        this.isMark = this.codePoints.length > 0 && this.codePoints.every(unicode.isMark);
                        this.isLigature = this.codePoints.length > 1;
                    }
                    var _proto30 = Glyph.prototype;
                    _proto30._getPath = function _getPath() {
                        return new Path();
                    };
                    _proto30._getCBox = function _getCBox() {
                        return this.path.cbox;
                    };
                    _proto30._getBBox = function _getBBox() {
                        return this.path.bbox;
                    };
                    _proto30._getTableMetrics = function _getTableMetrics(table) {
                        if (this.id < table.metrics.length) return table.metrics.get(this.id);
                        var metric = table.metrics.get(table.metrics.length - 1);
                        var res = {
                            advance: metric ? metric.advance : 0,
                            bearing: table.bearings.get(this.id - table.metrics.length) || 0
                        };
                        return res;
                    };
                    _proto30._getMetrics = function _getMetrics(cbox) {
                        if (this._metrics) return this._metrics;
                        var _this$_getTableMetric = this._getTableMetrics(this._font.hmtx), advanceWidth = _this$_getTableMetric.advance, leftBearing = _this$_getTableMetric.bearing; // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea
                        if (this._font.vmtx) var _this$_getTableMetric2 = this._getTableMetrics(this._font.vmtx), advanceHeight = _this$_getTableMetric2.advance, topBearing = _this$_getTableMetric2.bearing;
                        else {
                            var os2;
                            if (typeof cbox === 'undefined' || cbox === null) cbox = this.cbox;
                            if ((os2 = this._font['OS/2']) && os2.version > 0) {
                                var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                                var topBearing = os2.typoAscender - cbox.maxY;
                            } else {
                                var hhea = this._font.hhea;
                                var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                                var topBearing = hhea.ascent - cbox.maxY;
                            }
                        }
                        if (this._font._variationProcessor && this._font.HVAR) advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
                        return this._metrics = {
                            advanceWidth: advanceWidth,
                            advanceHeight: advanceHeight,
                            leftBearing: leftBearing,
                            topBearing: topBearing
                        };
                    } /**
   * The glyph’s control box.
   * This is often the same as the bounding box, but is faster to compute.
   * Because of the way bezier curves are defined, some of the control points
   * can be outside of the bounding box. Where `bbox` takes this into account,
   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
   * for a more detailed description.
   *
   * @type {BBox}
   */ ;
                    /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */ _proto30.getScaledPath = function getScaledPath(size) {
                        var scale = 1 / this._font.unitsPerEm * size;
                        return this.path.scale(scale);
                    } /**
   * The glyph's advance width.
   * @type {number}
   */ ;
                    _proto30._getName = function _getName() {
                        var post = this._font.post;
                        if (!post) return null;
                        switch(post.version){
                            case 1:
                                return StandardNames[this.id];
                            case 2:
                                var id = post.glyphNameIndex[this.id];
                                if (id < StandardNames.length) return StandardNames[id];
                                return post.names[id - StandardNames.length];
                            case 2.5:
                                return StandardNames[this.id + post.offsets[this.id]];
                            case 4:
                                return String.fromCharCode(post.map[this.id]);
                        }
                    } /**
   * The glyph's name
   * @type {string}
   */ ;
                    /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */ _proto30.render = function render(ctx, size) {
                        ctx.save();
                        var scale = 1 / this._font.head.unitsPerEm * size;
                        ctx.scale(scale, scale);
                        var fn = this.path.toFunction();
                        fn(ctx);
                        ctx.fill();
                        ctx.restore();
                    };
                    return _createClass(Glyph, [
                        {
                            key: "cbox",
                            get: function get() {
                                return this._getCBox();
                            }
                        },
                        {
                            key: "bbox",
                            get: function get() {
                                return this._getBBox();
                            }
                        },
                        {
                            key: "path",
                            get: function get() {
                                // Cache the path so we only decode it once
                                // Decoding is actually performed by subclasses
                                return this._getPath();
                            }
                        },
                        {
                            key: "advanceWidth",
                            get: function get() {
                                return this._getMetrics().advanceWidth;
                            }
                        },
                        {
                            key: "advanceHeight",
                            get: function get() {
                                return this._getMetrics().advanceHeight;
                            }
                        },
                        {
                            key: "ligatureCaretPositions",
                            get: function get() {}
                        },
                        {
                            key: "name",
                            get: function get() {
                                return this._getName();
                            }
                        }
                    ]);
                }(), _applyDecoratedDescriptor(_class$3.prototype, "cbox", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "cbox"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "bbox", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "bbox"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "path", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "path"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "advanceWidth", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "advanceWidth"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "advanceHeight", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "advanceHeight"), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, "name", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$3.prototype, "name"), _class$3.prototype), _class$3);
                var GlyfHeader = new r.Struct({
                    numberOfContours: r.int16,
                    // if negative, this is a composite glyph
                    xMin: r.int16,
                    yMin: r.int16,
                    xMax: r.int16,
                    yMax: r.int16
                }); // Flags for simple glyphs
                var ON_CURVE = 1;
                var X_SHORT_VECTOR = 2;
                var Y_SHORT_VECTOR = 4;
                var REPEAT = 8;
                var SAME_X = 16;
                var SAME_Y = 32; // Flags for composite glyphs
                var ARG_1_AND_2_ARE_WORDS = 1;
                var WE_HAVE_A_SCALE = 8;
                var MORE_COMPONENTS = 32;
                var WE_HAVE_AN_X_AND_Y_SCALE = 64;
                var WE_HAVE_A_TWO_BY_TWO = 128;
                var WE_HAVE_INSTRUCTIONS = 256;
                var Point = /*#__PURE__*/ function() {
                    function Point(onCurve, endContour, x, y) {
                        if (x === void 0) x = 0;
                        if (y === void 0) y = 0;
                        this.onCurve = onCurve;
                        this.endContour = endContour;
                        this.x = x;
                        this.y = y;
                    }
                    var _proto31 = Point.prototype;
                    _proto31.copy = function copy() {
                        return new Point(this.onCurve, this.endContour, this.x, this.y);
                    };
                    return Point;
                }(); // Represents a component in a composite glyph
                var Component = function Component(glyphID, dx, dy) {
                    this.glyphID = glyphID;
                    this.dx = dx;
                    this.dy = dy;
                    this.pos = 0;
                    this.scaleX = this.scaleY = 1;
                    this.scale01 = this.scale10 = 0;
                };
                /**
 * Represents a TrueType glyph.
 */ var TTFGlyph = /*#__PURE__*/ function(_Glyph) {
                    function TTFGlyph() {
                        return _Glyph.apply(this, arguments) || this;
                    }
                    _inheritsLoose(TTFGlyph, _Glyph);
                    var _proto32 = TTFGlyph.prototype;
                    // Parses just the glyph header and returns the bounding box
                    _proto32._getCBox = function _getCBox(internal) {
                        // We need to decode the glyph if variation processing is requested,
                        // so it's easier just to recompute the path's cbox after decoding.
                        if (this._font._variationProcessor && !internal) return this.path.cbox;
                        var stream = this._font._getTableStream('glyf');
                        stream.pos += this._font.loca.offsets[this.id];
                        var glyph = GlyfHeader.decode(stream);
                        var cbox = new BBox(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
                        return Object.freeze(cbox);
                    } // Parses a single glyph coordinate
                    ;
                    _proto32._parseGlyphCoord = function _parseGlyphCoord(stream, prev, short, same) {
                        if (short) {
                            var val = stream.readUInt8();
                            if (!same) val = -val;
                            val += prev;
                        } else if (same) var val = prev;
                        else var val = prev + stream.readInt16BE();
                        return val;
                    } // Decodes the glyph data into points for simple glyphs,
                    ;
                    _proto32._decode = function _decode() {
                        var glyfPos = this._font.loca.offsets[this.id];
                        var nextPos = this._font.loca.offsets[this.id + 1]; // Nothing to do if there is no data for this glyph
                        if (glyfPos === nextPos) return null;
                        var stream = this._font._getTableStream('glyf');
                        stream.pos += glyfPos;
                        var startPos = stream.pos;
                        var glyph = GlyfHeader.decode(stream);
                        if (glyph.numberOfContours > 0) this._decodeSimple(glyph, stream);
                        else if (glyph.numberOfContours < 0) this._decodeComposite(glyph, stream, startPos);
                        return glyph;
                    };
                    _proto32._decodeSimple = function _decodeSimple(glyph, stream) {
                        // this is a simple glyph
                        glyph.points = [];
                        var endPtsOfContours = new r.Array(r.uint16, glyph.numberOfContours).decode(stream);
                        glyph.instructions = new r.Array(r.uint8, r.uint16).decode(stream);
                        var flags = [];
                        var numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
                        while(flags.length < numCoords){
                            var flag = stream.readUInt8();
                            flags.push(flag); // check for repeat flag
                            if (flag & REPEAT) {
                                var count = stream.readUInt8();
                                for(var j = 0; j < count; j++)flags.push(flag);
                            }
                        }
                        for(var i = 0; i < flags.length; i++){
                            var flag = flags[i];
                            var point = new Point(!!(flag & ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
                            glyph.points.push(point);
                        }
                        var px = 0;
                        for(var i = 0; i < flags.length; i++){
                            var flag = flags[i];
                            glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & X_SHORT_VECTOR, flag & SAME_X);
                        }
                        var py = 0;
                        for(var i = 0; i < flags.length; i++){
                            var flag = flags[i];
                            glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & Y_SHORT_VECTOR, flag & SAME_Y);
                        }
                        if (this._font._variationProcessor) {
                            var points = glyph.points.slice();
                            points.push.apply(points, this._getPhantomPoints(glyph));
                            this._font._variationProcessor.transformPoints(this.id, points);
                            glyph.phantomPoints = points.slice(-4);
                        }
                        return;
                    };
                    _proto32._decodeComposite = function _decodeComposite(glyph, stream, offset) {
                        if (offset === void 0) offset = 0;
                        // this is a composite glyph
                        glyph.components = [];
                        var haveInstructions = false;
                        var flags = MORE_COMPONENTS;
                        while(flags & MORE_COMPONENTS){
                            flags = stream.readUInt16BE();
                            var gPos = stream.pos - offset;
                            var glyphID = stream.readUInt16BE();
                            if (!haveInstructions) haveInstructions = (flags & WE_HAVE_INSTRUCTIONS) !== 0;
                            if (flags & ARG_1_AND_2_ARE_WORDS) {
                                var dx = stream.readInt16BE();
                                var dy = stream.readInt16BE();
                            } else {
                                var dx = stream.readInt8();
                                var dy = stream.readInt8();
                            }
                            var component = new Component(glyphID, dx, dy);
                            component.pos = gPos;
                            if (flags & WE_HAVE_A_SCALE) // fixed number with 14 bits of fraction
                            component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                            else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                            } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
                                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                                component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                                component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                            }
                            glyph.components.push(component);
                        }
                        if (this._font._variationProcessor) {
                            var points = [];
                            for(var j = 0; j < glyph.components.length; j++){
                                var component = glyph.components[j];
                                points.push(new Point(true, true, component.dx, component.dy));
                            }
                            points.push.apply(points, this._getPhantomPoints(glyph));
                            this._font._variationProcessor.transformPoints(this.id, points);
                            glyph.phantomPoints = points.splice(-4, 4);
                            for(var i = 0; i < points.length; i++){
                                var point = points[i];
                                glyph.components[i].dx = point.x;
                                glyph.components[i].dy = point.y;
                            }
                        }
                        return haveInstructions;
                    };
                    _proto32._getPhantomPoints = function _getPhantomPoints(glyph) {
                        var cbox = this._getCBox(true);
                        if (this._metrics == null) this._metrics = Glyph.prototype._getMetrics.call(this, cbox);
                        var _this$_metrics = this._metrics, advanceWidth = _this$_metrics.advanceWidth, advanceHeight = _this$_metrics.advanceHeight, leftBearing = _this$_metrics.leftBearing, topBearing = _this$_metrics.topBearing;
                        return [
                            new Point(false, true, glyph.xMin - leftBearing, 0),
                            new Point(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
                            new Point(false, true, 0, glyph.yMax + topBearing),
                            new Point(false, true, 0, glyph.yMax + topBearing + advanceHeight)
                        ];
                    } // Decodes font data, resolves composite glyphs, and returns an array of contours
                    ;
                    _proto32._getContours = function _getContours() {
                        var glyph = this._decode();
                        if (!glyph) return [];
                        var points = [];
                        if (glyph.numberOfContours < 0) // resolve composite glyphs
                        for(var _iterator68 = _createForOfIteratorHelperLoose(glyph.components), _step68; !(_step68 = _iterator68()).done;){
                            var component = _step68.value;
                            var _contours = this._font.getGlyph(component.glyphID)._getContours();
                            for(var i = 0; i < _contours.length; i++){
                                var contour = _contours[i];
                                for(var j = 0; j < contour.length; j++){
                                    var _point = contour[j];
                                    var x = _point.x * component.scaleX + _point.y * component.scale01 + component.dx;
                                    var y = _point.y * component.scaleY + _point.x * component.scale10 + component.dy;
                                    points.push(new Point(_point.onCurve, _point.endContour, x, y));
                                }
                            }
                        }
                        else points = glyph.points || [];
                         // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
                        if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
                            this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
                            this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
                            this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
                            this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
                        }
                        var contours = [];
                        var cur = [];
                        for(var k = 0; k < points.length; k++){
                            var point = points[k];
                            cur.push(point);
                            if (point.endContour) {
                                contours.push(cur);
                                cur = [];
                            }
                        }
                        return contours;
                    };
                    _proto32._getMetrics = function _getMetrics() {
                        if (this._metrics) return this._metrics;
                        var cbox = this._getCBox(true);
                        _Glyph.prototype._getMetrics.call(this, cbox);
                        if (this._font._variationProcessor && !this._font.HVAR) // No HVAR table, decode the glyph. This triggers recomputation of metrics.
                        this.path;
                        return this._metrics;
                    } // Converts contours to a Path object that can be rendered
                    ;
                    _proto32._getPath = function _getPath() {
                        var contours = this._getContours();
                        var path = new Path();
                        for(var i = 0; i < contours.length; i++){
                            var contour = contours[i];
                            var firstPt = contour[0];
                            var lastPt = contour[contour.length - 1];
                            var start = 0;
                            if (firstPt.onCurve) {
                                // The first point will be consumed by the moveTo command, so skip in the loop
                                var curvePt = null;
                                start = 1;
                            } else {
                                if (lastPt.onCurve) // Start at the last point if the first point is off curve and the last point is on curve
                                firstPt = lastPt;
                                else // Start at the middle if both the first and last points are off curve
                                firstPt = new Point(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                                var curvePt = firstPt;
                            }
                            path.moveTo(firstPt.x, firstPt.y);
                            for(var j = start; j < contour.length; j++){
                                var pt = contour[j];
                                var prevPt = j === 0 ? firstPt : contour[j - 1];
                                if (prevPt.onCurve && pt.onCurve) path.lineTo(pt.x, pt.y);
                                else if (prevPt.onCurve && !pt.onCurve) var curvePt = pt;
                                else if (!prevPt.onCurve && !pt.onCurve) {
                                    var midX = (prevPt.x + pt.x) / 2;
                                    var midY = (prevPt.y + pt.y) / 2;
                                    path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                                    var curvePt = pt;
                                } else if (!prevPt.onCurve && pt.onCurve) {
                                    path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                                    var curvePt = null;
                                } else throw new Error("Unknown TTF path state");
                            } // Connect the first and last points
                            if (curvePt) path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
                            path.closePath();
                        }
                        return path;
                    };
                    return TTFGlyph;
                }(Glyph);
                /**
 * Represents an OpenType PostScript glyph, in the Compact Font Format.
 */ var CFFGlyph = /*#__PURE__*/ function(_Glyph2) {
                    function CFFGlyph() {
                        return _Glyph2.apply(this, arguments) || this;
                    }
                    _inheritsLoose(CFFGlyph, _Glyph2);
                    var _proto33 = CFFGlyph.prototype;
                    _proto33._getName = function _getName() {
                        if (this._font.CFF2) return _Glyph2.prototype._getName.call(this);
                        return this._font['CFF '].getGlyphName(this.id);
                    };
                    _proto33.bias = function bias(s) {
                        if (s.length < 1240) return 107;
                        else if (s.length < 33900) return 1131;
                        else return 32768;
                    };
                    _proto33._getPath = function _getPath() {
                        var cff = this._font.CFF2 || this._font['CFF '];
                        var stream = cff.stream;
                        var str = cff.topDict.CharStrings[this.id];
                        var end = str.offset + str.length;
                        stream.pos = str.offset;
                        var path = new Path();
                        var stack = [];
                        var trans = [];
                        var width = null;
                        var nStems = 0;
                        var x = 0, y = 0;
                        var usedGsubrs;
                        var usedSubrs;
                        var open1 = false;
                        this._usedGsubrs = usedGsubrs = {};
                        this._usedSubrs = usedSubrs = {};
                        var gsubrs = cff.globalSubrIndex || [];
                        var gsubrsBias = this.bias(gsubrs);
                        var privateDict = cff.privateDictForGlyph(this.id) || {};
                        var subrs = privateDict.Subrs || [];
                        var subrsBias = this.bias(subrs);
                        var vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
                        var vsindex = privateDict.vsindex;
                        var variationProcessor = this._font._variationProcessor;
                        function checkWidth() {
                            if (width == null) width = stack.shift() + privateDict.nominalWidthX;
                        }
                        function parseStems() {
                            if (stack.length % 2 !== 0) checkWidth();
                            nStems += stack.length >> 1;
                            return stack.length = 0;
                        }
                        function moveTo(x, y) {
                            if (open1) path.closePath();
                            path.moveTo(x, y);
                            open1 = true;
                        }
                        var _parse = function parse() {
                            while(stream.pos < end){
                                var op = stream.readUInt8();
                                if (op < 32) switch(op){
                                    case 1:
                                    case 3:
                                    case 18:
                                    case 23:
                                        // vstemhm
                                        parseStems();
                                        break;
                                    case 4:
                                        // vmoveto
                                        if (stack.length > 1) checkWidth();
                                        y += stack.shift();
                                        moveTo(x, y);
                                        break;
                                    case 5:
                                        // rlineto
                                        while(stack.length >= 2){
                                            x += stack.shift();
                                            y += stack.shift();
                                            path.lineTo(x, y);
                                        }
                                        break;
                                    case 6:
                                    case 7:
                                        // vlineto
                                        var phase = op === 6;
                                        while(stack.length >= 1){
                                            if (phase) x += stack.shift();
                                            else y += stack.shift();
                                            path.lineTo(x, y);
                                            phase = !phase;
                                        }
                                        break;
                                    case 8:
                                        // rrcurveto
                                        while(stack.length > 0){
                                            var c1x = x + stack.shift();
                                            var c1y = y + stack.shift();
                                            var c2x = c1x + stack.shift();
                                            var c2y = c1y + stack.shift();
                                            x = c2x + stack.shift();
                                            y = c2y + stack.shift();
                                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                        }
                                        break;
                                    case 10:
                                        // callsubr
                                        var index = stack.pop() + subrsBias;
                                        var subr = subrs[index];
                                        if (subr) {
                                            usedSubrs[index] = true;
                                            var p = stream.pos;
                                            var e = end;
                                            stream.pos = subr.offset;
                                            end = subr.offset + subr.length;
                                            _parse();
                                            stream.pos = p;
                                            end = e;
                                        }
                                        break;
                                    case 11:
                                        // return
                                        if (cff.version >= 2) break;
                                        return;
                                    case 14:
                                        // endchar
                                        if (cff.version >= 2) break;
                                        if (stack.length > 0) checkWidth();
                                        if (open1) {
                                            path.closePath();
                                            open1 = false;
                                        }
                                        break;
                                    case 15:
                                        // vsindex
                                        if (cff.version < 2) throw new Error('vsindex operator not supported in CFF v1');
                                        vsindex = stack.pop();
                                        break;
                                    case 16:
                                        // blend
                                        if (cff.version < 2) throw new Error('blend operator not supported in CFF v1');
                                        if (!variationProcessor) throw new Error('blend operator in non-variation font');
                                        var blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                                        var numBlends = stack.pop();
                                        var numOperands = numBlends * blendVector.length;
                                        var delta = stack.length - numOperands;
                                        var base = delta - numBlends;
                                        for(var i = 0; i < numBlends; i++){
                                            var sum = stack[base + i];
                                            for(var j = 0; j < blendVector.length; j++)sum += blendVector[j] * stack[delta++];
                                            stack[base + i] = sum;
                                        }
                                        while(numOperands--)stack.pop();
                                        break;
                                    case 19:
                                    case 20:
                                        // cntrmask
                                        parseStems();
                                        stream.pos += nStems + 7 >> 3;
                                        break;
                                    case 21:
                                        // rmoveto
                                        if (stack.length > 2) checkWidth();
                                        x += stack.shift();
                                        y += stack.shift();
                                        moveTo(x, y);
                                        break;
                                    case 22:
                                        // hmoveto
                                        if (stack.length > 1) checkWidth();
                                        x += stack.shift();
                                        moveTo(x, y);
                                        break;
                                    case 24:
                                        // rcurveline
                                        while(stack.length >= 8){
                                            var c1x = x + stack.shift();
                                            var c1y = y + stack.shift();
                                            var c2x = c1x + stack.shift();
                                            var c2y = c1y + stack.shift();
                                            x = c2x + stack.shift();
                                            y = c2y + stack.shift();
                                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                        }
                                        x += stack.shift();
                                        y += stack.shift();
                                        path.lineTo(x, y);
                                        break;
                                    case 25:
                                        // rlinecurve
                                        while(stack.length >= 8){
                                            x += stack.shift();
                                            y += stack.shift();
                                            path.lineTo(x, y);
                                        }
                                        var c1x = x + stack.shift();
                                        var c1y = y + stack.shift();
                                        var c2x = c1x + stack.shift();
                                        var c2y = c1y + stack.shift();
                                        x = c2x + stack.shift();
                                        y = c2y + stack.shift();
                                        path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                        break;
                                    case 26:
                                        // vvcurveto
                                        if (stack.length % 2) x += stack.shift();
                                        while(stack.length >= 4){
                                            c1x = x;
                                            c1y = y + stack.shift();
                                            c2x = c1x + stack.shift();
                                            c2y = c1y + stack.shift();
                                            x = c2x;
                                            y = c2y + stack.shift();
                                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                        }
                                        break;
                                    case 27:
                                        // hhcurveto
                                        if (stack.length % 2) y += stack.shift();
                                        while(stack.length >= 4){
                                            c1x = x + stack.shift();
                                            c1y = y;
                                            c2x = c1x + stack.shift();
                                            c2y = c1y + stack.shift();
                                            x = c2x + stack.shift();
                                            y = c2y;
                                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                        }
                                        break;
                                    case 28:
                                        // shortint
                                        stack.push(stream.readInt16BE());
                                        break;
                                    case 29:
                                        // callgsubr
                                        index = stack.pop() + gsubrsBias;
                                        subr = gsubrs[index];
                                        if (subr) {
                                            usedGsubrs[index] = true;
                                            var p = stream.pos;
                                            var e = end;
                                            stream.pos = subr.offset;
                                            end = subr.offset + subr.length;
                                            _parse();
                                            stream.pos = p;
                                            end = e;
                                        }
                                        break;
                                    case 30:
                                    case 31:
                                        // hvcurveto
                                        phase = op === 31;
                                        while(stack.length >= 4){
                                            if (phase) {
                                                c1x = x + stack.shift();
                                                c1y = y;
                                                c2x = c1x + stack.shift();
                                                c2y = c1y + stack.shift();
                                                y = c2y + stack.shift();
                                                x = c2x + (stack.length === 1 ? stack.shift() : 0);
                                            } else {
                                                c1x = x;
                                                c1y = y + stack.shift();
                                                c2x = c1x + stack.shift();
                                                c2y = c1y + stack.shift();
                                                x = c2x + stack.shift();
                                                y = c2y + (stack.length === 1 ? stack.shift() : 0);
                                            }
                                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                            phase = !phase;
                                        }
                                        break;
                                    case 12:
                                        op = stream.readUInt8();
                                        switch(op){
                                            case 3:
                                                // and
                                                var a = stack.pop();
                                                var b = stack.pop();
                                                stack.push(a && b ? 1 : 0);
                                                break;
                                            case 4:
                                                // or
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a || b ? 1 : 0);
                                                break;
                                            case 5:
                                                // not
                                                a = stack.pop();
                                                stack.push(a ? 0 : 1);
                                                break;
                                            case 9:
                                                // abs
                                                a = stack.pop();
                                                stack.push(Math.abs(a));
                                                break;
                                            case 10:
                                                // add
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a + b);
                                                break;
                                            case 11:
                                                // sub
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a - b);
                                                break;
                                            case 12:
                                                // div
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a / b);
                                                break;
                                            case 14:
                                                // neg
                                                a = stack.pop();
                                                stack.push(-a);
                                                break;
                                            case 15:
                                                // eq
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a === b ? 1 : 0);
                                                break;
                                            case 18:
                                                // drop
                                                stack.pop();
                                                break;
                                            case 20:
                                                // put
                                                var val = stack.pop();
                                                var idx = stack.pop();
                                                trans[idx] = val;
                                                break;
                                            case 21:
                                                // get
                                                idx = stack.pop();
                                                stack.push(trans[idx] || 0);
                                                break;
                                            case 22:
                                                // ifelse
                                                var s1 = stack.pop();
                                                var s2 = stack.pop();
                                                var v1 = stack.pop();
                                                var v2 = stack.pop();
                                                stack.push(v1 <= v2 ? s1 : s2);
                                                break;
                                            case 23:
                                                // random
                                                stack.push(Math.random());
                                                break;
                                            case 24:
                                                // mul
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(a * b);
                                                break;
                                            case 26:
                                                // sqrt
                                                a = stack.pop();
                                                stack.push(Math.sqrt(a));
                                                break;
                                            case 27:
                                                // dup
                                                a = stack.pop();
                                                stack.push(a, a);
                                                break;
                                            case 28:
                                                // exch
                                                a = stack.pop();
                                                b = stack.pop();
                                                stack.push(b, a);
                                                break;
                                            case 29:
                                                // index
                                                idx = stack.pop();
                                                if (idx < 0) idx = 0;
                                                else if (idx > stack.length - 1) idx = stack.length - 1;
                                                stack.push(stack[idx]);
                                                break;
                                            case 30:
                                                // roll
                                                var n = stack.pop();
                                                var _j = stack.pop();
                                                if (_j >= 0) while(_j > 0){
                                                    var t = stack[n - 1];
                                                    for(var _i = n - 2; _i >= 0; _i--)stack[_i + 1] = stack[_i];
                                                    stack[0] = t;
                                                    _j--;
                                                }
                                                else while(_j < 0){
                                                    var t = stack[0];
                                                    for(var _i2 = 0; _i2 <= n; _i2++)stack[_i2] = stack[_i2 + 1];
                                                    stack[n - 1] = t;
                                                    _j++;
                                                }
                                                break;
                                            case 34:
                                                // hflex
                                                c1x = x + stack.shift();
                                                c1y = y;
                                                c2x = c1x + stack.shift();
                                                c2y = c1y + stack.shift();
                                                var c3x = c2x + stack.shift();
                                                var c3y = c2y;
                                                var c4x = c3x + stack.shift();
                                                var c4y = c3y;
                                                var c5x = c4x + stack.shift();
                                                var c5y = c4y;
                                                var c6x = c5x + stack.shift();
                                                var c6y = c5y;
                                                x = c6x;
                                                y = c6y;
                                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                                break;
                                            case 35:
                                                // flex
                                                var pts = [];
                                                for(var _i3 = 0; _i3 <= 5; _i3++){
                                                    x += stack.shift();
                                                    y += stack.shift();
                                                    pts.push(x, y);
                                                }
                                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                                path.bezierCurveTo.apply(path, pts.slice(6));
                                                stack.shift(); // fd
                                                break;
                                            case 36:
                                                // hflex1
                                                c1x = x + stack.shift();
                                                c1y = y + stack.shift();
                                                c2x = c1x + stack.shift();
                                                c2y = c1y + stack.shift();
                                                c3x = c2x + stack.shift();
                                                c3y = c2y;
                                                c4x = c3x + stack.shift();
                                                c4y = c3y;
                                                c5x = c4x + stack.shift();
                                                c5y = c4y + stack.shift();
                                                c6x = c5x + stack.shift();
                                                c6y = c5y;
                                                x = c6x;
                                                y = c6y;
                                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                                break;
                                            case 37:
                                                // flex1
                                                var startx = x;
                                                var starty = y;
                                                pts = [];
                                                for(var _i4 = 0; _i4 <= 4; _i4++){
                                                    x += stack.shift();
                                                    y += stack.shift();
                                                    pts.push(x, y);
                                                }
                                                if (Math.abs(x - startx) > Math.abs(y - starty)) {
                                                    // horizontal
                                                    x += stack.shift();
                                                    y = starty;
                                                } else {
                                                    x = startx;
                                                    y += stack.shift();
                                                }
                                                pts.push(x, y);
                                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                                path.bezierCurveTo.apply(path, pts.slice(6));
                                                break;
                                            default:
                                                throw new Error("Unknown op: 12 ".concat(op));
                                        }
                                        break;
                                    default:
                                        throw new Error("Unknown op: ".concat(op));
                                }
                                else if (op < 247) stack.push(op - 139);
                                else if (op < 251) {
                                    var b1 = stream.readUInt8();
                                    stack.push((op - 247) * 256 + b1 + 108);
                                } else if (op < 255) {
                                    var b1 = stream.readUInt8();
                                    stack.push(-(op - 251) * 256 - b1 - 108);
                                } else stack.push(stream.readInt32BE() / 65536);
                            }
                        };
                        _parse();
                        if (open1) path.closePath();
                        return path;
                    };
                    return CFFGlyph;
                }(Glyph);
                var SBIXImage = new r.Struct({
                    originX: r.uint16,
                    originY: r.uint16,
                    type: new r.String(4),
                    data: new r.Buffer(function(t) {
                        return t.parent.buflen - t._currentOffset;
                    })
                });
                /**
 * Represents a color (e.g. emoji) glyph in Apple's SBIX format.
 */ var SBIXGlyph = /*#__PURE__*/ function(_TTFGlyph) {
                    function SBIXGlyph() {
                        return _TTFGlyph.apply(this, arguments) || this;
                    }
                    _inheritsLoose(SBIXGlyph, _TTFGlyph);
                    var _proto34 = SBIXGlyph.prototype;
                    /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */ _proto34.getImageForSize = function getImageForSize(size) {
                        for(var i = 0; i < this._font.sbix.imageTables.length; i++){
                            var table = this._font.sbix.imageTables[i];
                            if (table.ppem >= size) break;
                        }
                        var offsets = table.imageOffsets;
                        var start = offsets[this.id];
                        var end = offsets[this.id + 1];
                        if (start === end) return null;
                        this._font.stream.pos = start;
                        return SBIXImage.decode(this._font.stream, {
                            buflen: end - start
                        });
                    };
                    _proto34.render = function render(ctx, size) {
                        var img = this.getImageForSize(size);
                        if (img != null) {
                            var scale = size / this._font.unitsPerEm;
                            ctx.image(img.data, {
                                height: size,
                                x: img.originX,
                                y: (this.bbox.minY - img.originY) * scale
                            });
                        }
                        if (this._font.sbix.flags.renderOutlines) _TTFGlyph.prototype.render.call(this, ctx, size);
                    };
                    return SBIXGlyph;
                }(TTFGlyph);
                var COLRLayer = function COLRLayer(glyph, color) {
                    this.glyph = glyph;
                    this.color = color;
                };
                /**
 * Represents a color (e.g. emoji) glyph in Microsoft's COLR format.
 * Each glyph in this format contain a list of colored layers, each
 * of which  is another vector glyph.
 */ var COLRGlyph = /*#__PURE__*/ function(_Glyph3) {
                    function COLRGlyph() {
                        return _Glyph3.apply(this, arguments) || this;
                    }
                    _inheritsLoose(COLRGlyph, _Glyph3);
                    var _proto35 = COLRGlyph.prototype;
                    _proto35._getBBox = function _getBBox() {
                        var bbox = new BBox();
                        for(var i = 0; i < this.layers.length; i++){
                            var layer = this.layers[i];
                            var b = layer.glyph.bbox;
                            bbox.addPoint(b.minX, b.minY);
                            bbox.addPoint(b.maxX, b.maxY);
                        }
                        return bbox;
                    } /**
   * Returns an array of objects containing the glyph and color for
   * each layer in the composite color glyph.
   * @type {object[]}
   */ ;
                    _proto35.render = function render(ctx, size) {
                        for(var _iterator69 = _createForOfIteratorHelperLoose(this.layers), _step69; !(_step69 = _iterator69()).done;){
                            var _step69$value = _step69.value, glyph = _step69$value.glyph, color = _step69$value.color;
                            ctx.fillColor([
                                color.red,
                                color.green,
                                color.blue
                            ], color.alpha / 255 * 100);
                            glyph.render(ctx, size);
                        }
                        return;
                    };
                    return _createClass(COLRGlyph, [
                        {
                            key: "layers",
                            get: function get() {
                                var cpal = this._font.CPAL;
                                var colr = this._font.COLR;
                                var low = 0;
                                var high = colr.baseGlyphRecord.length - 1;
                                while(low <= high){
                                    var mid = low + high >> 1;
                                    var rec = colr.baseGlyphRecord[mid];
                                    if (this.id < rec.gid) high = mid - 1;
                                    else if (this.id > rec.gid) low = mid + 1;
                                    else {
                                        var baseLayer = rec;
                                        break;
                                    }
                                } // if base glyph not found in COLR table,
                                // default to normal glyph from glyf or CFF
                                if (baseLayer == null) {
                                    var g = this._font._getBaseGlyph(this.id);
                                    var color = {
                                        red: 0,
                                        green: 0,
                                        blue: 0,
                                        alpha: 255
                                    };
                                    return [
                                        new COLRLayer(g, color)
                                    ];
                                } // otherwise, return an array of all the layers
                                var layers = [];
                                for(var i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++){
                                    var rec = colr.layerRecords[i];
                                    var color = cpal.colorRecords[rec.paletteIndex];
                                    var g = this._font._getBaseGlyph(rec.gid);
                                    layers.push(new COLRLayer(g, color));
                                }
                                return layers;
                            }
                        }
                    ]);
                }(Glyph);
                var TUPLES_SHARE_POINT_NUMBERS = 0x8000;
                var TUPLE_COUNT_MASK = 0x0fff;
                var EMBEDDED_TUPLE_COORD = 0x8000;
                var INTERMEDIATE_TUPLE = 0x4000;
                var PRIVATE_POINT_NUMBERS = 0x2000;
                var TUPLE_INDEX_MASK = 0x0fff;
                var POINTS_ARE_WORDS = 0x80;
                var POINT_RUN_COUNT_MASK = 0x7f;
                var DELTAS_ARE_ZERO = 0x80;
                var DELTAS_ARE_WORDS = 0x40;
                var DELTA_RUN_COUNT_MASK = 0x3f;
                /**
 * This class is transforms TrueType glyphs according to the data from
 * the Apple Advanced Typography variation tables (fvar, gvar, and avar).
 * These tables allow infinite adjustments to glyph weight, width, slant,
 * and optical size without the designer needing to specify every exact style.
 *
 * Apple's documentation for these tables is not great, so thanks to the
 * Freetype project for figuring much of this out.
 *
 * @private
 */ var GlyphVariationProcessor = /*#__PURE__*/ function() {
                    function GlyphVariationProcessor(font, coords) {
                        this.font = font;
                        this.normalizedCoords = this.normalizeCoords(coords);
                        this.blendVectors = new Map();
                    }
                    var _proto36 = GlyphVariationProcessor.prototype;
                    _proto36.normalizeCoords = function normalizeCoords(coords) {
                        // the default mapping is linear along each axis, in two segments:
                        // from the minValue to defaultValue, and from defaultValue to maxValue.
                        var normalized = [];
                        for(var i = 0; i < this.font.fvar.axis.length; i++){
                            var axis = this.font.fvar.axis[i];
                            if (coords[i] < axis.defaultValue) normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
                            else normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
                        } // if there is an avar table, the normalized value is calculated
                        // by interpolating between the two nearest mapped values.
                        if (this.font.avar) for(var i = 0; i < this.font.avar.segment.length; i++){
                            var segment = this.font.avar.segment[i];
                            for(var j = 0; j < segment.correspondence.length; j++){
                                var pair = segment.correspondence[j];
                                if (j >= 1 && normalized[i] < pair.fromCoord) {
                                    var prev = segment.correspondence[j - 1];
                                    normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + Number.EPSILON) / (pair.fromCoord - prev.fromCoord + Number.EPSILON) + prev.toCoord;
                                    break;
                                }
                            }
                        }
                        return normalized;
                    };
                    _proto36.transformPoints = function transformPoints(gid, glyphPoints) {
                        if (!this.font.fvar || !this.font.gvar) return;
                        var gvar = this.font.gvar;
                        if (gid >= gvar.glyphCount) return;
                        var offset = gvar.offsets[gid];
                        if (offset === gvar.offsets[gid + 1]) return;
                         // Read the gvar data for this glyph
                        var stream = this.font.stream;
                        stream.pos = offset;
                        if (stream.pos >= stream.length) return;
                        var tupleCount = stream.readUInt16BE();
                        var offsetToData = offset + stream.readUInt16BE();
                        if (tupleCount & TUPLES_SHARE_POINT_NUMBERS) {
                            var here = stream.pos;
                            stream.pos = offsetToData;
                            var sharedPoints = this.decodePoints();
                            offsetToData = stream.pos;
                            stream.pos = here;
                        }
                        var origPoints = glyphPoints.map(function(pt) {
                            return pt.copy();
                        });
                        tupleCount &= TUPLE_COUNT_MASK;
                        for(var i = 0; i < tupleCount; i++){
                            var tupleDataSize = stream.readUInt16BE();
                            var tupleIndex = stream.readUInt16BE();
                            if (tupleIndex & EMBEDDED_TUPLE_COORD) {
                                var tupleCoords = [];
                                for(var a = 0; a < gvar.axisCount; a++)tupleCoords.push(stream.readInt16BE() / 16384);
                            } else {
                                if ((tupleIndex & TUPLE_INDEX_MASK) >= gvar.globalCoordCount) throw new Error('Invalid gvar table');
                                var tupleCoords = gvar.globalCoords[tupleIndex & TUPLE_INDEX_MASK];
                            }
                            if (tupleIndex & INTERMEDIATE_TUPLE) {
                                var startCoords = [];
                                for(var _a = 0; _a < gvar.axisCount; _a++)startCoords.push(stream.readInt16BE() / 16384);
                                var endCoords = [];
                                for(var _a2 = 0; _a2 < gvar.axisCount; _a2++)endCoords.push(stream.readInt16BE() / 16384);
                            } // Get the factor at which to apply this tuple
                            var factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
                            if (factor === 0) {
                                offsetToData += tupleDataSize;
                                continue;
                            }
                            var here = stream.pos;
                            stream.pos = offsetToData;
                            if (tupleIndex & PRIVATE_POINT_NUMBERS) var points = this.decodePoints();
                            else var points = sharedPoints;
                             // points.length = 0 means there are deltas for all points
                            var nPoints = points.length === 0 ? glyphPoints.length : points.length;
                            var xDeltas = this.decodeDeltas(nPoints);
                            var yDeltas = this.decodeDeltas(nPoints);
                            if (points.length === 0) // all points
                            for(var _i = 0; _i < glyphPoints.length; _i++){
                                var point = glyphPoints[_i];
                                point.x += Math.round(xDeltas[_i] * factor);
                                point.y += Math.round(yDeltas[_i] * factor);
                            }
                            else {
                                var outPoints = origPoints.map(function(pt) {
                                    return pt.copy();
                                });
                                var hasDelta = glyphPoints.map(function() {
                                    return false;
                                });
                                for(var _i2 = 0; _i2 < points.length; _i2++){
                                    var idx = points[_i2];
                                    if (idx < glyphPoints.length) {
                                        var _point = outPoints[idx];
                                        hasDelta[idx] = true;
                                        _point.x += Math.round(xDeltas[_i2] * factor);
                                        _point.y += Math.round(yDeltas[_i2] * factor);
                                    }
                                }
                                this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
                                for(var _i3 = 0; _i3 < glyphPoints.length; _i3++){
                                    var deltaX = outPoints[_i3].x - origPoints[_i3].x;
                                    var deltaY = outPoints[_i3].y - origPoints[_i3].y;
                                    glyphPoints[_i3].x += deltaX;
                                    glyphPoints[_i3].y += deltaY;
                                }
                            }
                            offsetToData += tupleDataSize;
                            stream.pos = here;
                        }
                    };
                    _proto36.decodePoints = function decodePoints() {
                        var stream = this.font.stream;
                        var count = stream.readUInt8();
                        if (count & POINTS_ARE_WORDS) count = (count & POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
                        var points = new Uint16Array(count);
                        var i = 0;
                        var point = 0;
                        while(i < count){
                            var run = stream.readUInt8();
                            var runCount = (run & POINT_RUN_COUNT_MASK) + 1;
                            var fn = run & POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
                            for(var j = 0; j < runCount && i < count; j++){
                                point += fn.call(stream);
                                points[i++] = point;
                            }
                        }
                        return points;
                    };
                    _proto36.decodeDeltas = function decodeDeltas(count) {
                        var stream = this.font.stream;
                        var i = 0;
                        var deltas = new Int16Array(count);
                        while(i < count){
                            var run = stream.readUInt8();
                            var runCount = (run & DELTA_RUN_COUNT_MASK) + 1;
                            if (run & DELTAS_ARE_ZERO) i += runCount;
                            else {
                                var fn = run & DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
                                for(var j = 0; j < runCount && i < count; j++)deltas[i++] = fn.call(stream);
                            }
                        }
                        return deltas;
                    };
                    _proto36.tupleFactor = function tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
                        var normalized = this.normalizedCoords;
                        var gvar = this.font.gvar;
                        var factor = 1;
                        for(var i = 0; i < gvar.axisCount; i++){
                            if (tupleCoords[i] === 0) continue;
                            if (normalized[i] === 0) return 0;
                            if ((tupleIndex & INTERMEDIATE_TUPLE) === 0) {
                                if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) return 0;
                                factor = (factor * normalized[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
                            } else {
                                if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) return 0;
                                else if (normalized[i] < tupleCoords[i]) factor = factor * (normalized[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
                                else factor = factor * (endCoords[i] - normalized[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
                            }
                        }
                        return factor;
                    } // Interpolates points without delta values.
                    ;
                    _proto36.interpolateMissingDeltas = function interpolateMissingDeltas(points, inPoints, hasDelta) {
                        if (points.length === 0) return;
                        var point = 0;
                        while(point < points.length){
                            var firstPoint = point; // find the end point of the contour
                            var endPoint = point;
                            var pt = points[endPoint];
                            while(!pt.endContour)pt = points[++endPoint];
                             // find the first point that has a delta
                            while(point <= endPoint && !hasDelta[point])point++;
                            if (point > endPoint) continue;
                            var firstDelta = point;
                            var curDelta = point;
                            point++;
                            while(point <= endPoint){
                                // find the next point with a delta, and interpolate intermediate points
                                if (hasDelta[point]) {
                                    this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                                    curDelta = point;
                                }
                                point++;
                            } // shift contour if we only have a single delta
                            if (curDelta === firstDelta) this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
                            else {
                                // otherwise, handle the remaining points at the end and beginning of the contour
                                this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
                                if (firstDelta > 0) this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
                            }
                            point = endPoint + 1;
                        }
                    };
                    _proto36.deltaInterpolate = function deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
                        if (p1 > p2) return;
                        var iterable = [
                            'x',
                            'y'
                        ];
                        for(var i = 0; i < iterable.length; i++){
                            var k = iterable[i];
                            if (inPoints[ref1][k] > inPoints[ref2][k]) {
                                var p = ref1;
                                ref1 = ref2;
                                ref2 = p;
                            }
                            var in1 = inPoints[ref1][k];
                            var in2 = inPoints[ref2][k];
                            var out1 = outPoints[ref1][k];
                            var out2 = outPoints[ref2][k]; // If the reference points have the same coordinate but different
                            // delta, inferred delta is zero.  Otherwise interpolate.
                            if (in1 !== in2 || out1 === out2) {
                                var scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                                for(var _p = p1; _p <= p2; _p++){
                                    var out = inPoints[_p][k];
                                    if (out <= in1) out += out1 - in1;
                                    else if (out >= in2) out += out2 - in2;
                                    else out = out1 + (out - in1) * scale;
                                    outPoints[_p][k] = out;
                                }
                            }
                        }
                    };
                    _proto36.deltaShift = function deltaShift(p1, p2, ref, inPoints, outPoints) {
                        var deltaX = outPoints[ref].x - inPoints[ref].x;
                        var deltaY = outPoints[ref].y - inPoints[ref].y;
                        if (deltaX === 0 && deltaY === 0) return;
                        for(var p = p1; p <= p2; p++)if (p !== ref) {
                            outPoints[p].x += deltaX;
                            outPoints[p].y += deltaY;
                        }
                    };
                    _proto36.getAdvanceAdjustment = function getAdvanceAdjustment(gid, table) {
                        var outerIndex, innerIndex;
                        if (table.advanceWidthMapping) {
                            var idx = gid;
                            if (idx >= table.advanceWidthMapping.mapCount) idx = table.advanceWidthMapping.mapCount - 1;
                            var entryFormat = table.advanceWidthMapping.entryFormat;
                            var _table$advanceWidthMa = table.advanceWidthMapping.mapData[idx];
                            outerIndex = _table$advanceWidthMa.outerIndex;
                            innerIndex = _table$advanceWidthMa.innerIndex;
                        } else {
                            outerIndex = 0;
                            innerIndex = gid;
                        }
                        return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
                    } // See pseudo code from `Font Variations Overview'
                    ;
                    _proto36.getDelta = function getDelta(itemStore, outerIndex, innerIndex) {
                        if (outerIndex >= itemStore.itemVariationData.length) return 0;
                        var varData = itemStore.itemVariationData[outerIndex];
                        if (innerIndex >= varData.deltaSets.length) return 0;
                        var deltaSet = varData.deltaSets[innerIndex];
                        var blendVector = this.getBlendVector(itemStore, outerIndex);
                        var netAdjustment = 0;
                        for(var master = 0; master < varData.regionIndexCount; master++)netAdjustment += deltaSet.deltas[master] * blendVector[master];
                        return netAdjustment;
                    };
                    _proto36.getBlendVector = function getBlendVector(itemStore, outerIndex) {
                        var varData = itemStore.itemVariationData[outerIndex];
                        if (this.blendVectors.has(varData)) return this.blendVectors.get(varData);
                        var normalizedCoords = this.normalizedCoords;
                        var blendVector = []; // outer loop steps through master designs to be blended
                        for(var master = 0; master < varData.regionIndexCount; master++){
                            var scalar = 1;
                            var regionIndex = varData.regionIndexes[master];
                            var axes = itemStore.variationRegionList.variationRegions[regionIndex]; // inner loop steps through axes in this region
                            for(var j = 0; j < axes.length; j++){
                                var axis = axes[j];
                                var axisScalar = void 0; // compute the scalar contribution of this axis
                                // ignore invalid ranges
                                if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) axisScalar = 1;
                                else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) axisScalar = 1; // peak of 0 means ignore this axis
                                else if (axis.peakCoord === 0) axisScalar = 1; // ignore this region if coords are out of range
                                else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) axisScalar = 0; // calculate a proportional factor
                                else {
                                    if (normalizedCoords[j] === axis.peakCoord) axisScalar = 1;
                                    else if (normalizedCoords[j] < axis.peakCoord) axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
                                    else axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
                                } // take product of all the axis scalars
                                scalar *= axisScalar;
                            }
                            blendVector[master] = scalar;
                        }
                        this.blendVectors.set(varData, blendVector);
                        return blendVector;
                    };
                    return GlyphVariationProcessor;
                }();
                var resolved = Promise.resolve();
                var Subset = /*#__PURE__*/ function() {
                    function Subset(font) {
                        this.font = font;
                        this.glyphs = [];
                        this.mapping = {}; // always include the missing glyph
                        this.includeGlyph(0);
                    }
                    var _proto37 = Subset.prototype;
                    _proto37.includeGlyph = function includeGlyph(glyph) {
                        if (typeof glyph === 'object') glyph = glyph.id;
                        if (this.mapping[glyph] == null) {
                            this.glyphs.push(glyph);
                            this.mapping[glyph] = this.glyphs.length - 1;
                        }
                        return this.mapping[glyph];
                    };
                    _proto37.encodeStream = function encodeStream() {
                        var _this1 = this;
                        var s = new r.EncodeStream();
                        resolved.then(function() {
                            _this1.encode(s);
                            return s.end();
                        });
                        return s;
                    };
                    return Subset;
                }();
                var ON_CURVE$1 = 1;
                var X_SHORT_VECTOR$1 = 2;
                var Y_SHORT_VECTOR$1 = 4;
                var REPEAT$1 = 8;
                var SAME_X$1 = 16;
                var SAME_Y$1 = 32;
                var Point$1 = /*#__PURE__*/ function() {
                    function Point$1() {}
                    Point$1.size = function size(val) {
                        return val >= 0 && val <= 255 ? 1 : 2;
                    };
                    Point$1.encode = function encode(stream, value) {
                        if (value >= 0 && value <= 255) stream.writeUInt8(value);
                        else stream.writeInt16BE(value);
                    };
                    return Point$1;
                }();
                var Glyf = new r.Struct({
                    numberOfContours: r.int16,
                    // if negative, this is a composite glyph
                    xMin: r.int16,
                    yMin: r.int16,
                    xMax: r.int16,
                    yMax: r.int16,
                    endPtsOfContours: new r.Array(r.uint16, 'numberOfContours'),
                    instructions: new r.Array(r.uint8, r.uint16),
                    flags: new r.Array(r.uint8, 0),
                    xPoints: new r.Array(Point$1, 0),
                    yPoints: new r.Array(Point$1, 0)
                });
                /**
 * Encodes TrueType glyph outlines
 */ var TTFGlyphEncoder = /*#__PURE__*/ function() {
                    function TTFGlyphEncoder() {}
                    var _proto38 = TTFGlyphEncoder.prototype;
                    _proto38.encodeSimple = function encodeSimple(path, instructions) {
                        if (instructions === void 0) instructions = [];
                        var endPtsOfContours = [];
                        var xPoints = [];
                        var yPoints = [];
                        var flags = [];
                        var same = 0;
                        var lastX = 0, lastY = 0, lastFlag = 0;
                        var pointCount = 0;
                        for(var i = 0; i < path.commands.length; i++){
                            var c = path.commands[i];
                            for(var j = 0; j < c.args.length; j += 2){
                                var x = c.args[j];
                                var y = c.args[j + 1];
                                var flag = 0; // If the ending point of a quadratic curve is the midpoint
                                // between the control point and the control point of the next
                                // quadratic curve, we can omit the ending point.
                                if (c.command === 'quadraticCurveTo' && j === 2) {
                                    var next = path.commands[i + 1];
                                    if (next && next.command === 'quadraticCurveTo') {
                                        var midX = (lastX + next.args[0]) / 2;
                                        var midY = (lastY + next.args[1]) / 2;
                                        if (x === midX && y === midY) continue;
                                    }
                                } // All points except control points are on curve.
                                if (!(c.command === 'quadraticCurveTo' && j === 0)) flag |= ON_CURVE$1;
                                flag = this._encodePoint(x, lastX, xPoints, flag, X_SHORT_VECTOR$1, SAME_X$1);
                                flag = this._encodePoint(y, lastY, yPoints, flag, Y_SHORT_VECTOR$1, SAME_Y$1);
                                if (flag === lastFlag && same < 255) {
                                    flags[flags.length - 1] |= REPEAT$1;
                                    same++;
                                } else {
                                    if (same > 0) {
                                        flags.push(same);
                                        same = 0;
                                    }
                                    flags.push(flag);
                                    lastFlag = flag;
                                }
                                lastX = x;
                                lastY = y;
                                pointCount++;
                            }
                            if (c.command === 'closePath') endPtsOfContours.push(pointCount - 1);
                        } // Close the path if the last command didn't already
                        if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') endPtsOfContours.push(pointCount - 1);
                        var bbox = path.bbox;
                        var glyf = {
                            numberOfContours: endPtsOfContours.length,
                            xMin: bbox.minX,
                            yMin: bbox.minY,
                            xMax: bbox.maxX,
                            yMax: bbox.maxY,
                            endPtsOfContours: endPtsOfContours,
                            instructions: instructions,
                            flags: flags,
                            xPoints: xPoints,
                            yPoints: yPoints
                        };
                        var size = Glyf.size(glyf);
                        var tail = 4 - size % 4;
                        var stream = new r.EncodeStream(size + tail);
                        Glyf.encode(stream, glyf); // Align to 4-byte length
                        if (tail !== 0) stream.fill(0, tail);
                        return stream.buffer;
                    };
                    _proto38._encodePoint = function _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
                        var diff = value - last;
                        if (value === last) flag |= sameFlag;
                        else {
                            if (-255 <= diff && diff <= 255) {
                                flag |= shortFlag;
                                if (diff < 0) diff = -diff;
                                else flag |= sameFlag;
                            }
                            points.push(diff);
                        }
                        return flag;
                    };
                    return TTFGlyphEncoder;
                }();
                var TTFSubset = /*#__PURE__*/ function(_Subset) {
                    function TTFSubset(font) {
                        var _this10;
                        _this10 = _Subset.call(this, font) || this;
                        _this10.glyphEncoder = new TTFGlyphEncoder();
                        return _this10;
                    }
                    _inheritsLoose(TTFSubset, _Subset);
                    var _proto39 = TTFSubset.prototype;
                    _proto39._addGlyph = function _addGlyph(gid) {
                        var glyph = this.font.getGlyph(gid);
                        var glyf = glyph._decode(); // get the offset to the glyph from the loca table
                        var curOffset = this.font.loca.offsets[gid];
                        var nextOffset = this.font.loca.offsets[gid + 1];
                        var stream = this.font._getTableStream('glyf');
                        stream.pos += curOffset;
                        var buffer = stream.readBuffer(nextOffset - curOffset); // if it is a compound glyph, include its components
                        if (glyf && glyf.numberOfContours < 0) {
                            buffer = Buffer.from(buffer);
                            for(var _iterator70 = _createForOfIteratorHelperLoose(glyf.components), _step70; !(_step70 = _iterator70()).done;){
                                var component = _step70.value;
                                gid = this.includeGlyph(component.glyphID);
                                buffer.writeUInt16BE(gid, component.pos);
                            }
                        } else if (glyf && this.font._variationProcessor) // If this is a TrueType variation glyph, re-encode the path
                        buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
                        this.glyf.push(buffer);
                        this.loca.offsets.push(this.offset);
                        this.hmtx.metrics.push({
                            advance: glyph.advanceWidth,
                            bearing: glyph._getMetrics().leftBearing
                        });
                        this.offset += buffer.length;
                        return this.glyf.length - 1;
                    };
                    _proto39.encode = function encode(stream) {
                        // tables required by PDF spec:
                        //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
                        //
                        // additional tables required for standalone fonts:
                        //   name, cmap, OS/2, post
                        this.glyf = [];
                        this.offset = 0;
                        this.loca = {
                            offsets: [],
                            version: this.font.loca.version
                        };
                        this.hmtx = {
                            metrics: [],
                            bearings: []
                        }; // include all the glyphs
                        // not using a for loop because we need to support adding more
                        // glyphs to the array as we go, and CoffeeScript caches the length.
                        var i = 0;
                        while(i < this.glyphs.length)this._addGlyph(this.glyphs[i++]);
                        var maxp = cloneDeep(this.font.maxp);
                        maxp.numGlyphs = this.glyf.length;
                        this.loca.offsets.push(this.offset);
                        var head = cloneDeep(this.font.head);
                        head.indexToLocFormat = this.loca.version;
                        var hhea = cloneDeep(this.font.hhea);
                        hhea.numberOfMetrics = this.hmtx.metrics.length; // map = []
                        // for index in [0...256]
                        //     if index < @numGlyphs
                        //         map[index] = index
                        //     else
                        //         map[index] = 0
                        //
                        // cmapTable =
                        //     version: 0
                        //     length: 262
                        //     language: 0
                        //     codeMap: map
                        //
                        // cmap =
                        //     version: 0
                        //     numSubtables: 1
                        //     tables: [
                        //         platformID: 1
                        //         encodingID: 0
                        //         table: cmapTable
                        //     ]
                        // TODO: subset prep, cvt, fpgm?
                        Directory.encode(stream, {
                            tables: {
                                head: head,
                                hhea: hhea,
                                loca: this.loca,
                                maxp: maxp,
                                'cvt ': this.font['cvt '],
                                prep: this.font.prep,
                                glyf: this.glyf,
                                hmtx: this.hmtx,
                                fpgm: this.font.fpgm // name: clone @font.name
                            }
                        });
                    };
                    return TTFSubset;
                }(Subset);
                var CFFSubset = /*#__PURE__*/ function(_Subset2) {
                    function CFFSubset(font) {
                        var _this11;
                        _this11 = _Subset2.call(this, font) || this;
                        _this11.cff = _this11.font['CFF '];
                        if (!_this11.cff) throw new Error('Not a CFF Font');
                        return _this11;
                    }
                    _inheritsLoose(CFFSubset, _Subset2);
                    var _proto40 = CFFSubset.prototype;
                    _proto40.subsetCharstrings = function subsetCharstrings() {
                        this.charstrings = [];
                        var gsubrs = {};
                        for(var _iterator71 = _createForOfIteratorHelperLoose(this.glyphs), _step71; !(_step71 = _iterator71()).done;){
                            var gid = _step71.value;
                            this.charstrings.push(this.cff.getCharString(gid));
                            var glyph = this.font.getGlyph(gid);
                            var path = glyph.path; // this causes the glyph to be parsed
                            for(var subr in glyph._usedGsubrs)gsubrs[subr] = true;
                        }
                        this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
                    };
                    _proto40.subsetSubrs = function subsetSubrs(subrs, used) {
                        var res = [];
                        for(var i = 0; i < subrs.length; i++){
                            var subr = subrs[i];
                            if (used[i]) {
                                this.cff.stream.pos = subr.offset;
                                res.push(this.cff.stream.readBuffer(subr.length));
                            } else res.push(Buffer.from([
                                11
                            ])); // return
                        }
                        return res;
                    };
                    _proto40.subsetFontdict = function subsetFontdict(topDict) {
                        topDict.FDArray = [];
                        topDict.FDSelect = {
                            version: 0,
                            fds: []
                        };
                        var used_fds = {};
                        var used_subrs = [];
                        var fd_select = {};
                        for(var _iterator72 = _createForOfIteratorHelperLoose(this.glyphs), _step72; !(_step72 = _iterator72()).done;){
                            var gid = _step72.value;
                            var fd = this.cff.fdForGlyph(gid);
                            if (fd == null) continue;
                            if (!used_fds[fd]) {
                                topDict.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[fd]));
                                used_subrs.push({});
                                fd_select[fd] = topDict.FDArray.length - 1;
                            }
                            used_fds[fd] = true;
                            topDict.FDSelect.fds.push(fd_select[fd]);
                            var glyph = this.font.getGlyph(gid);
                            var path = glyph.path; // this causes the glyph to be parsed
                            for(var subr in glyph._usedSubrs)used_subrs[fd_select[fd]][subr] = true;
                        }
                        for(var i = 0; i < topDict.FDArray.length; i++){
                            var dict = topDict.FDArray[i];
                            delete dict.FontName;
                            if (dict.Private && dict.Private.Subrs) {
                                dict.Private = Object.assign({}, dict.Private);
                                dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
                            }
                        }
                        return;
                    };
                    _proto40.createCIDFontdict = function createCIDFontdict(topDict) {
                        var used_subrs = {};
                        for(var _iterator73 = _createForOfIteratorHelperLoose(this.glyphs), _step73; !(_step73 = _iterator73()).done;){
                            var gid = _step73.value;
                            var glyph = this.font.getGlyph(gid);
                            var path = glyph.path; // this causes the glyph to be parsed
                            for(var subr in glyph._usedSubrs)used_subrs[subr] = true;
                        }
                        var privateDict = Object.assign({}, this.cff.topDict.Private);
                        if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
                        topDict.FDArray = [
                            {
                                Private: privateDict
                            }
                        ];
                        return topDict.FDSelect = {
                            version: 3,
                            nRanges: 1,
                            ranges: [
                                {
                                    first: 0,
                                    fd: 0
                                }
                            ],
                            sentinel: this.charstrings.length
                        };
                    };
                    _proto40.addString = function addString(string) {
                        if (!string) return null;
                        if (!this.strings) this.strings = [];
                        this.strings.push(string);
                        return standardStrings.length + this.strings.length - 1;
                    };
                    _proto40.encode = function encode(stream) {
                        this.subsetCharstrings();
                        var charset = {
                            version: this.charstrings.length > 255 ? 2 : 1,
                            ranges: [
                                {
                                    first: 1,
                                    nLeft: this.charstrings.length - 2
                                }
                            ]
                        };
                        var topDict = Object.assign({}, this.cff.topDict);
                        topDict.Private = null;
                        topDict.charset = charset;
                        topDict.Encoding = null;
                        topDict.CharStrings = this.charstrings;
                        for(var _i22 = 0, _arr2 = [
                            'version',
                            'Notice',
                            'Copyright',
                            'FullName',
                            'FamilyName',
                            'Weight',
                            'PostScript',
                            'BaseFontName',
                            'FontName'
                        ]; _i22 < _arr2.length; _i22++){
                            var key = _arr2[_i22];
                            topDict[key] = this.addString(this.cff.string(topDict[key]));
                        }
                        topDict.ROS = [
                            this.addString('Adobe'),
                            this.addString('Identity'),
                            0
                        ];
                        topDict.CIDCount = this.charstrings.length;
                        if (this.cff.isCIDFont) this.subsetFontdict(topDict);
                        else this.createCIDFontdict(topDict);
                        var top = {
                            version: 1,
                            hdrSize: this.cff.hdrSize,
                            offSize: 4,
                            header: this.cff.header,
                            nameIndex: [
                                this.cff.postscriptName
                            ],
                            topDictIndex: [
                                topDict
                            ],
                            stringIndex: this.strings,
                            globalSubrIndex: this.gsubrs
                        };
                        CFFTop.encode(stream, top);
                    };
                    return CFFSubset;
                }(Subset);
                var _class$4;
                /**
 * This is the base class for all SFNT-based font formats in fontkit.
 * It supports TrueType, and PostScript glyphs, and several color glyph formats.
 */ var TTFFont = (_class$4 = /*#__PURE__*/ function() {
                    function TTFFont(stream, variationCoords) {
                        if (variationCoords === void 0) variationCoords = null;
                        this.defaultLanguage = null;
                        this.stream = stream;
                        this.variationCoords = variationCoords;
                        this._directoryPos = this.stream.pos;
                        this._tables = {};
                        this._glyphs = {};
                        this._decodeDirectory(); // define properties for each table to lazily parse
                        for(var tag in this.directory.tables){
                            var table = this.directory.tables[tag];
                            if (tables[tag] && table.length > 0) Object.defineProperty(this, tag, {
                                get: this._getTable.bind(this, table)
                            });
                        }
                    }
                    TTFFont.probe = function probe(buffer) {
                        var format = buffer.toString('ascii', 0, 4);
                        return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
                    };
                    var _proto41 = TTFFont.prototype;
                    _proto41.setDefaultLanguage = function setDefaultLanguage(lang) {
                        if (lang === void 0) lang = null;
                        this.defaultLanguage = lang;
                    };
                    _proto41._getTable = function _getTable(table) {
                        if (!(table.tag in this._tables)) try {
                            this._tables[table.tag] = this._decodeTable(table);
                        } catch (e) {
                            if (fontkit.logErrors) {
                                console.error("Error decoding table ".concat(table.tag));
                                console.error(e.stack);
                            }
                        }
                        return this._tables[table.tag];
                    };
                    _proto41._getTableStream = function _getTableStream(tag) {
                        var table = this.directory.tables[tag];
                        if (table) {
                            this.stream.pos = table.offset;
                            return this.stream;
                        }
                        return null;
                    };
                    _proto41._decodeDirectory = function _decodeDirectory() {
                        return this.directory = Directory.decode(this.stream, {
                            _startOffset: 0
                        });
                    };
                    _proto41._decodeTable = function _decodeTable(table) {
                        var pos = this.stream.pos;
                        var stream = this._getTableStream(table.tag);
                        var result = tables[table.tag].decode(stream, this, table.length);
                        this.stream.pos = pos;
                        return result;
                    } /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */ ;
                    _proto41.getName = function getName(key, lang) {
                        if (lang === void 0) lang = this.defaultLanguage || fontkit.defaultLanguage;
                        var record = this.name && this.name.records[key];
                        if (record) // Attempt to retrieve the entry, depending on which translation is available:
                        return record[lang] || record[this.defaultLanguage] || record[fontkit.defaultLanguage] || record['en'] || record[Object.keys(record)[0]] // Seriously, ANY language would be fine
                         || null;
                        return null;
                    } /**
   * The unique PostScript name for this font, e.g. "Helvetica-Bold"
   * @type {string}
   */ ;
                    /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */ _proto41.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
                        return !!this._cmapProcessor.lookup(codePoint);
                    } /**
   * Maps a single unicode code point to a Glyph object.
   * Does not perform any advanced substitutions (there is no context to do so).
   *
   * @param {number} codePoint
   * @return {Glyph}
   */ ;
                    _proto41.glyphForCodePoint = function glyphForCodePoint(codePoint) {
                        return this.getGlyph(this._cmapProcessor.lookup(codePoint), [
                            codePoint
                        ]);
                    } /**
   * Returns an array of Glyph objects for the given string.
   * This is only a one-to-one mapping from characters to glyphs.
   * For most uses, you should use font.layout (described below), which
   * provides a much more advanced mapping supporting AAT and OpenType shaping.
   *
   * @param {string} string
   * @return {Glyph[]}
   */ ;
                    _proto41.glyphsForString = function glyphsForString(string) {
                        var glyphs = [];
                        var len = string.length;
                        var idx = 0;
                        var last = -1;
                        var state = -1;
                        while(idx <= len){
                            var code = 0;
                            var nextState = 0;
                            if (idx < len) {
                                // Decode the next codepoint from UTF 16
                                code = string.charCodeAt(idx++);
                                if (0xd800 <= code && code <= 0xdbff && idx < len) {
                                    var next = string.charCodeAt(idx);
                                    if (0xdc00 <= next && next <= 0xdfff) {
                                        idx++;
                                        code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                                    }
                                } // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
                                nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
                            } else idx++;
                            if (state === 0 && nextState === 1) // Variation selector following normal codepoint.
                            glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [
                                last,
                                code
                            ]));
                            else if (state === 0 && nextState === 0) // Normal codepoint following normal codepoint.
                            glyphs.push(this.glyphForCodePoint(last));
                            last = code;
                            state = nextState;
                        }
                        return glyphs;
                    };
                    /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */ _proto41.layout = function layout(string, userFeatures, script, language, direction) {
                        return this._layoutEngine.layout(string, userFeatures, script, language, direction);
                    } /**
   * Returns an array of strings that map to the given glyph id.
   * @param {number} gid - glyph id
   */ ;
                    _proto41.stringsForGlyph = function stringsForGlyph(gid) {
                        return this._layoutEngine.stringsForGlyph(gid);
                    } /**
   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
   * (or mapped AAT tags) supported by the font.
   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
   *
   * @type {string[]}
   */ ;
                    _proto41.getAvailableFeatures = function getAvailableFeatures(script, language) {
                        return this._layoutEngine.getAvailableFeatures(script, language);
                    };
                    _proto41._getBaseGlyph = function _getBaseGlyph(glyph, characters) {
                        if (characters === void 0) characters = [];
                        if (!this._glyphs[glyph]) {
                            if (this.directory.tables.glyf) this._glyphs[glyph] = new TTFGlyph(glyph, characters, this);
                            else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) this._glyphs[glyph] = new CFFGlyph(glyph, characters, this);
                        }
                        return this._glyphs[glyph] || null;
                    } /**
   * Returns a glyph object for the given glyph id.
   * You can pass the array of code points this glyph represents for
   * your use later, and it will be stored in the glyph object.
   *
   * @param {number} glyph
   * @param {number[]} characters
   * @return {Glyph}
   */ ;
                    _proto41.getGlyph = function getGlyph(glyph, characters) {
                        if (characters === void 0) characters = [];
                        if (!this._glyphs[glyph]) {
                            if (this.directory.tables.sbix) this._glyphs[glyph] = new SBIXGlyph(glyph, characters, this);
                            else if (this.directory.tables.COLR && this.directory.tables.CPAL) this._glyphs[glyph] = new COLRGlyph(glyph, characters, this);
                            else this._getBaseGlyph(glyph, characters);
                        }
                        return this._glyphs[glyph] || null;
                    } /**
   * Returns a Subset for this font.
   * @return {Subset}
   */ ;
                    _proto41.createSubset = function createSubset() {
                        if (this.directory.tables['CFF ']) return new CFFSubset(this);
                        return new TTFSubset(this);
                    } /**
   * Returns an object describing the available variation axes
   * that this font supports. Keys are setting tags, and values
   * contain the axis name, range, and default value.
   *
   * @type {object}
   */ ;
                    /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */ _proto41.getVariation = function getVariation(settings) {
                        if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
                        if (typeof settings === 'string') settings = this.namedVariations[settings];
                        if (typeof settings !== 'object') throw new Error('Variation settings must be either a variation name or settings object.');
                         // normalize the coordinates
                        var coords = this.fvar.axis.map(function(axis, i) {
                            var axisTag = axis.axisTag.trim();
                            if (axisTag in settings) return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
                            else return axis.defaultValue;
                        });
                        var stream = new r.DecodeStream(this.stream.buffer);
                        stream.pos = this._directoryPos;
                        var font = new TTFFont(stream, coords);
                        font._tables = this._tables;
                        return font;
                    };
                    // Standardized format plugin API
                    _proto41.getFont = function getFont(name) {
                        return this.getVariation(name);
                    };
                    return _createClass(TTFFont, [
                        {
                            key: "postscriptName",
                            get: function get() {
                                return this.getName('postscriptName');
                            }
                        },
                        {
                            key: "fullName",
                            get: function get() {
                                return this.getName('fullName');
                            }
                        },
                        {
                            key: "familyName",
                            get: function get() {
                                return this.getName('fontFamily');
                            }
                        },
                        {
                            key: "subfamilyName",
                            get: function get() {
                                return this.getName('fontSubfamily');
                            }
                        },
                        {
                            key: "copyright",
                            get: function get() {
                                return this.getName('copyright');
                            }
                        },
                        {
                            key: "version",
                            get: function get() {
                                return this.getName('version');
                            }
                        },
                        {
                            key: "ascent",
                            get: function get() {
                                return this.hhea.ascent;
                            }
                        },
                        {
                            key: "descent",
                            get: function get() {
                                return this.hhea.descent;
                            }
                        },
                        {
                            key: "lineGap",
                            get: function get() {
                                return this.hhea.lineGap;
                            }
                        },
                        {
                            key: "underlinePosition",
                            get: function get() {
                                return this.post.underlinePosition;
                            }
                        },
                        {
                            key: "underlineThickness",
                            get: function get() {
                                return this.post.underlineThickness;
                            }
                        },
                        {
                            key: "italicAngle",
                            get: function get() {
                                return this.post.italicAngle;
                            }
                        },
                        {
                            key: "capHeight",
                            get: function get() {
                                var os2 = this['OS/2'];
                                return os2 ? os2.capHeight : this.ascent;
                            }
                        },
                        {
                            key: "xHeight",
                            get: function get() {
                                var os2 = this['OS/2'];
                                return os2 ? os2.xHeight : 0;
                            }
                        },
                        {
                            key: "numGlyphs",
                            get: function get() {
                                return this.maxp.numGlyphs;
                            }
                        },
                        {
                            key: "unitsPerEm",
                            get: function get() {
                                return this.head.unitsPerEm;
                            }
                        },
                        {
                            key: "bbox",
                            get: function get() {
                                return Object.freeze(new BBox(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
                            }
                        },
                        {
                            key: "_cmapProcessor",
                            get: function get() {
                                return new CmapProcessor(this.cmap);
                            }
                        },
                        {
                            key: "characterSet",
                            get: function get() {
                                return this._cmapProcessor.getCharacterSet();
                            }
                        },
                        {
                            key: "_layoutEngine",
                            get: function get() {
                                return new LayoutEngine(this);
                            }
                        },
                        {
                            key: "availableFeatures",
                            get: function get() {
                                return this._layoutEngine.getAvailableFeatures();
                            }
                        },
                        {
                            key: "variationAxes",
                            get: function get() {
                                var res = {};
                                if (!this.fvar) return res;
                                for(var _iterator74 = _createForOfIteratorHelperLoose(this.fvar.axis), _step74; !(_step74 = _iterator74()).done;){
                                    var axis = _step74.value;
                                    res[axis.axisTag.trim()] = {
                                        name: axis.name.en,
                                        min: axis.minValue,
                                        default: axis.defaultValue,
                                        max: axis.maxValue
                                    };
                                }
                                return res;
                            }
                        },
                        {
                            key: "namedVariations",
                            get: function get() {
                                var res = {};
                                if (!this.fvar) return res;
                                for(var _iterator75 = _createForOfIteratorHelperLoose(this.fvar.instance), _step75; !(_step75 = _iterator75()).done;){
                                    var instance = _step75.value;
                                    var settings = {};
                                    for(var i = 0; i < this.fvar.axis.length; i++){
                                        var axis = this.fvar.axis[i];
                                        settings[axis.axisTag.trim()] = instance.coord[i];
                                    }
                                    res[instance.name.en] = settings;
                                }
                                return res;
                            }
                        },
                        {
                            key: "_variationProcessor",
                            get: function get() {
                                if (!this.fvar) return null;
                                var variationCoords = this.variationCoords; // Ignore if no variation coords and not CFF2
                                if (!variationCoords && !this.CFF2) return null;
                                if (!variationCoords) variationCoords = this.fvar.axis.map(function(axis) {
                                    return axis.defaultValue;
                                });
                                return new GlyphVariationProcessor(this, variationCoords);
                            }
                        }
                    ]);
                }(), _applyDecoratedDescriptor(_class$4.prototype, "bbox", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "bbox"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "_cmapProcessor", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "_cmapProcessor"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "characterSet", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "characterSet"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "_layoutEngine", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "_layoutEngine"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "variationAxes", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "variationAxes"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "namedVariations", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "namedVariations"), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, "_variationProcessor", [
                    cache
                ], Object.getOwnPropertyDescriptor(_class$4.prototype, "_variationProcessor"), _class$4.prototype), _class$4);
                var WOFFDirectoryEntry = new r.Struct({
                    tag: new r.String(4),
                    offset: new r.Pointer(r.uint32, 'void', {
                        type: 'global'
                    }),
                    compLength: r.uint32,
                    length: r.uint32,
                    origChecksum: r.uint32
                });
                var WOFFDirectory = new r.Struct({
                    tag: new r.String(4),
                    // should be 'wOFF'
                    flavor: r.uint32,
                    length: r.uint32,
                    numTables: r.uint16,
                    reserved: new r.Reserved(r.uint16),
                    totalSfntSize: r.uint32,
                    majorVersion: r.uint16,
                    minorVersion: r.uint16,
                    metaOffset: r.uint32,
                    metaLength: r.uint32,
                    metaOrigLength: r.uint32,
                    privOffset: r.uint32,
                    privLength: r.uint32,
                    tables: new r.Array(WOFFDirectoryEntry, 'numTables')
                });
                WOFFDirectory.process = function() {
                    var tables = {};
                    for(var _iterator76 = _createForOfIteratorHelperLoose(this.tables), _step76; !(_step76 = _iterator76()).done;){
                        var table = _step76.value;
                        tables[table.tag] = table;
                    }
                    this.tables = tables;
                };
                var WOFFFont = /*#__PURE__*/ function(_TTFFont) {
                    function WOFFFont() {
                        return _TTFFont.apply(this, arguments) || this;
                    }
                    _inheritsLoose(WOFFFont, _TTFFont);
                    WOFFFont.probe = function probe(buffer) {
                        return buffer.toString('ascii', 0, 4) === 'wOFF';
                    };
                    var _proto42 = WOFFFont.prototype;
                    _proto42._decodeDirectory = function _decodeDirectory() {
                        this.directory = WOFFDirectory.decode(this.stream, {
                            _startOffset: 0
                        });
                    };
                    _proto42._getTableStream = function _getTableStream(tag) {
                        var table = this.directory.tables[tag];
                        if (table) {
                            this.stream.pos = table.offset;
                            if (table.compLength < table.length) {
                                this.stream.pos += 2; // skip deflate header
                                var outBuffer = Buffer.alloc(table.length);
                                var buf = inflate(this.stream.readBuffer(table.compLength - 2), outBuffer);
                                return new r.DecodeStream(buf);
                            } else return this.stream;
                        }
                        return null;
                    };
                    return WOFFFont;
                }(TTFFont);
                /**
 * Represents a TrueType glyph in the WOFF2 format, which compresses glyphs differently.
 */ var WOFF2Glyph = /*#__PURE__*/ function(_TTFGlyph2) {
                    function WOFF2Glyph() {
                        return _TTFGlyph2.apply(this, arguments) || this;
                    }
                    _inheritsLoose(WOFF2Glyph, _TTFGlyph2);
                    var _proto43 = WOFF2Glyph.prototype;
                    _proto43._decode = function _decode() {
                        // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
                        return this._font._transformedGlyphs[this.id];
                    };
                    _proto43._getCBox = function _getCBox() {
                        return this.path.bbox;
                    };
                    return WOFF2Glyph;
                }(TTFGlyph);
                var Base128 = {
                    decode: function decode(stream) {
                        var result = 0;
                        var iterable = [
                            0,
                            1,
                            2,
                            3,
                            4
                        ];
                        for(var j = 0; j < iterable.length; j++){
                            var code = stream.readUInt8(); // If any of the top seven bits are set then we're about to overflow.
                            if (result & 0xe0000000) throw new Error('Overflow');
                            result = result << 7 | code & 0x7f;
                            if ((code & 0x80) === 0) return result;
                        }
                        throw new Error('Bad base 128 number');
                    }
                };
                var knownTags = [
                    'cmap',
                    'head',
                    'hhea',
                    'hmtx',
                    'maxp',
                    'name',
                    'OS/2',
                    'post',
                    'cvt ',
                    'fpgm',
                    'glyf',
                    'loca',
                    'prep',
                    'CFF ',
                    'VORG',
                    'EBDT',
                    'EBLC',
                    'gasp',
                    'hdmx',
                    'kern',
                    'LTSH',
                    'PCLT',
                    'VDMX',
                    'vhea',
                    'vmtx',
                    'BASE',
                    'GDEF',
                    'GPOS',
                    'GSUB',
                    'EBSC',
                    'JSTF',
                    'MATH',
                    'CBDT',
                    'CBLC',
                    'COLR',
                    'CPAL',
                    'SVG ',
                    'sbix',
                    'acnt',
                    'avar',
                    'bdat',
                    'bloc',
                    'bsln',
                    'cvar',
                    'fdsc',
                    'feat',
                    'fmtx',
                    'fvar',
                    'gvar',
                    'hsty',
                    'just',
                    'lcar',
                    'mort',
                    'morx',
                    'opbd',
                    'prop',
                    'trak',
                    'Zapf',
                    'Silf',
                    'Glat',
                    'Gloc',
                    'Feat',
                    'Sill'
                ];
                var WOFF2DirectoryEntry = new r.Struct({
                    flags: r.uint8,
                    customTag: new r.Optional(new r.String(4), function(t) {
                        return (t.flags & 0x3f) === 0x3f;
                    }),
                    tag: function tag(t) {
                        return t.customTag || knownTags[t.flags & 0x3f];
                    },
                    // || (() => { throw new Error(`Bad tag: ${flags & 0x3f}`); })(); },
                    length: Base128,
                    transformVersion: function transformVersion(t) {
                        return t.flags >>> 6 & 0x03;
                    },
                    transformed: function transformed(t) {
                        return t.tag === 'glyf' || t.tag === 'loca' ? t.transformVersion === 0 : t.transformVersion !== 0;
                    },
                    transformLength: new r.Optional(Base128, function(t) {
                        return t.transformed;
                    })
                });
                var WOFF2Directory = new r.Struct({
                    tag: new r.String(4),
                    // should be 'wOF2'
                    flavor: r.uint32,
                    length: r.uint32,
                    numTables: r.uint16,
                    reserved: new r.Reserved(r.uint16),
                    totalSfntSize: r.uint32,
                    totalCompressedSize: r.uint32,
                    majorVersion: r.uint16,
                    minorVersion: r.uint16,
                    metaOffset: r.uint32,
                    metaLength: r.uint32,
                    metaOrigLength: r.uint32,
                    privOffset: r.uint32,
                    privLength: r.uint32,
                    tables: new r.Array(WOFF2DirectoryEntry, 'numTables')
                });
                WOFF2Directory.process = function() {
                    var tables = {};
                    for(var i = 0; i < this.tables.length; i++){
                        var table = this.tables[i];
                        tables[table.tag] = table;
                    }
                    return this.tables = tables;
                };
                /**
 * Subclass of TTFFont that represents a TTF/OTF font compressed by WOFF2
 * See spec here: http://www.w3.org/TR/WOFF2/
 */ var WOFF2Font = /*#__PURE__*/ function(_TTFFont2) {
                    function WOFF2Font() {
                        return _TTFFont2.apply(this, arguments) || this;
                    }
                    _inheritsLoose(WOFF2Font, _TTFFont2);
                    WOFF2Font.probe = function probe(buffer) {
                        return buffer.toString('ascii', 0, 4) === 'wOF2';
                    };
                    var _proto44 = WOFF2Font.prototype;
                    _proto44._decodeDirectory = function _decodeDirectory() {
                        this.directory = WOFF2Directory.decode(this.stream);
                        this._dataPos = this.stream.pos;
                    };
                    _proto44._decompress = function _decompress() {
                        // decompress data and setup table offsets if we haven't already
                        if (!this._decompressed) {
                            this.stream.pos = this._dataPos;
                            var buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
                            var decompressedSize = 0;
                            for(var tag in this.directory.tables){
                                var entry = this.directory.tables[tag];
                                entry.offset = decompressedSize;
                                decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
                            }
                            var decompressed = brotli(buffer, decompressedSize);
                            if (!decompressed) throw new Error('Error decoding compressed data in WOFF2');
                            this.stream = new r.DecodeStream(Buffer.from(decompressed));
                            this._decompressed = true;
                        }
                    };
                    _proto44._decodeTable = function _decodeTable(table) {
                        this._decompress();
                        return _TTFFont2.prototype._decodeTable.call(this, table);
                    } // Override this method to get a glyph and return our
                    ;
                    _proto44._getBaseGlyph = function _getBaseGlyph(glyph, characters) {
                        if (characters === void 0) characters = [];
                        if (!this._glyphs[glyph]) {
                            if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
                                if (!this._transformedGlyphs) this._transformGlyfTable();
                                return this._glyphs[glyph] = new WOFF2Glyph(glyph, characters, this);
                            } else return _TTFFont2.prototype._getBaseGlyph.call(this, glyph, characters);
                        }
                    };
                    _proto44._transformGlyfTable = function _transformGlyfTable() {
                        this._decompress();
                        this.stream.pos = this.directory.tables.glyf.offset;
                        var table = GlyfTable.decode(this.stream);
                        var glyphs = [];
                        for(var index = 0; index < table.numGlyphs; index++){
                            var glyph = {};
                            var nContours = table.nContours.readInt16BE();
                            glyph.numberOfContours = nContours;
                            if (nContours > 0) {
                                // simple glyph
                                var nPoints = [];
                                var totalPoints = 0;
                                for(var i = 0; i < nContours; i++){
                                    var _r = read255UInt16(table.nPoints);
                                    totalPoints += _r;
                                    nPoints.push(totalPoints);
                                }
                                glyph.points = decodeTriplet(table.flags, table.glyphs, totalPoints);
                                for(var _i = 0; _i < nContours; _i++)glyph.points[nPoints[_i] - 1].endContour = true;
                                var instructionSize = read255UInt16(table.glyphs);
                            } else if (nContours < 0) {
                                // composite glyph
                                var haveInstructions = TTFGlyph.prototype._decodeComposite.call({
                                    _font: this
                                }, glyph, table.composites);
                                if (haveInstructions) var instructionSize = read255UInt16(table.glyphs);
                            }
                            glyphs.push(glyph);
                        }
                        this._transformedGlyphs = glyphs;
                    };
                    return WOFF2Font;
                }(TTFFont); // Special class that accepts a length and returns a sub-stream for that data
                var Substream = /*#__PURE__*/ function() {
                    function Substream(length) {
                        this.length = length;
                        this._buf = new r.Buffer(length);
                    }
                    var _proto45 = Substream.prototype;
                    _proto45.decode = function decode(stream, parent) {
                        return new r.DecodeStream(this._buf.decode(stream, parent));
                    };
                    return Substream;
                }(); // This struct represents the entire glyf table
                var GlyfTable = new r.Struct({
                    version: r.uint32,
                    numGlyphs: r.uint16,
                    indexFormat: r.uint16,
                    nContourStreamSize: r.uint32,
                    nPointsStreamSize: r.uint32,
                    flagStreamSize: r.uint32,
                    glyphStreamSize: r.uint32,
                    compositeStreamSize: r.uint32,
                    bboxStreamSize: r.uint32,
                    instructionStreamSize: r.uint32,
                    nContours: new Substream('nContourStreamSize'),
                    nPoints: new Substream('nPointsStreamSize'),
                    flags: new Substream('flagStreamSize'),
                    glyphs: new Substream('glyphStreamSize'),
                    composites: new Substream('compositeStreamSize'),
                    bboxes: new Substream('bboxStreamSize'),
                    instructions: new Substream('instructionStreamSize')
                });
                var WORD_CODE = 253;
                var ONE_MORE_BYTE_CODE2 = 254;
                var ONE_MORE_BYTE_CODE1 = 255;
                var LOWEST_U_CODE = 253;
                function read255UInt16(stream) {
                    var code = stream.readUInt8();
                    if (code === WORD_CODE) return stream.readUInt16BE();
                    if (code === ONE_MORE_BYTE_CODE1) return stream.readUInt8() + LOWEST_U_CODE;
                    if (code === ONE_MORE_BYTE_CODE2) return stream.readUInt8() + LOWEST_U_CODE * 2;
                    return code;
                }
                function withSign(flag, baseval) {
                    return flag & 1 ? baseval : -baseval;
                }
                function decodeTriplet(flags, glyphs, nPoints) {
                    var y;
                    var x = y = 0;
                    var res = [];
                    for(var i = 0; i < nPoints; i++){
                        var dx = 0, dy = 0;
                        var flag = flags.readUInt8();
                        var onCurve = !(flag >> 7);
                        flag &= 0x7f;
                        if (flag < 10) {
                            dx = 0;
                            dy = withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
                        } else if (flag < 20) {
                            dx = withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
                            dy = 0;
                        } else if (flag < 84) {
                            var b0 = flag - 20;
                            var b1 = glyphs.readUInt8();
                            dx = withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
                            dy = withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
                        } else if (flag < 120) {
                            var b0 = flag - 84;
                            dx = withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
                            dy = withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
                        } else if (flag < 124) {
                            var b1 = glyphs.readUInt8();
                            var b2 = glyphs.readUInt8();
                            dx = withSign(flag, (b1 << 4) + (b2 >> 4));
                            dy = withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
                        } else {
                            dx = withSign(flag, glyphs.readUInt16BE());
                            dy = withSign(flag >> 1, glyphs.readUInt16BE());
                        }
                        x += dx;
                        y += dy;
                        res.push(new Point(onCurve, false, x, y));
                    }
                    return res;
                }
                var TTCHeader = new r.VersionedStruct(r.uint32, {
                    0x00010000: {
                        numFonts: r.uint32,
                        offsets: new r.Array(r.uint32, 'numFonts')
                    },
                    0x00020000: {
                        numFonts: r.uint32,
                        offsets: new r.Array(r.uint32, 'numFonts'),
                        dsigTag: r.uint32,
                        dsigLength: r.uint32,
                        dsigOffset: r.uint32
                    }
                });
                var TrueTypeCollection = /*#__PURE__*/ function() {
                    function TrueTypeCollection(stream) {
                        this.stream = stream;
                        if (stream.readString(4) !== 'ttcf') throw new Error('Not a TrueType collection');
                        this.header = TTCHeader.decode(stream);
                    }
                    TrueTypeCollection.probe = function probe(buffer) {
                        return buffer.toString('ascii', 0, 4) === 'ttcf';
                    };
                    var _proto46 = TrueTypeCollection.prototype;
                    _proto46.getFont = function getFont(name) {
                        for(var _iterator77 = _createForOfIteratorHelperLoose(this.header.offsets), _step77; !(_step77 = _iterator77()).done;){
                            var offset = _step77.value;
                            var stream = new r.DecodeStream(this.stream.buffer);
                            stream.pos = offset;
                            var font = new TTFFont(stream);
                            if (font.postscriptName === name) return font;
                        }
                        return null;
                    };
                    return _createClass(TrueTypeCollection, [
                        {
                            key: "fonts",
                            get: function get() {
                                var fonts = [];
                                for(var _iterator78 = _createForOfIteratorHelperLoose(this.header.offsets), _step78; !(_step78 = _iterator78()).done;){
                                    var offset = _step78.value;
                                    var stream = new r.DecodeStream(this.stream.buffer);
                                    stream.pos = offset;
                                    fonts.push(new TTFFont(stream));
                                }
                                return fonts;
                            }
                        }
                    ]);
                }();
                var DFontName = new r.String(r.uint8);
                var DFontData = new r.Struct({
                    len: r.uint32,
                    buf: new r.Buffer('len')
                });
                var Ref = new r.Struct({
                    id: r.uint16,
                    nameOffset: r.int16,
                    attr: r.uint8,
                    dataOffset: r.uint24,
                    handle: r.uint32
                });
                var Type = new r.Struct({
                    name: new r.String(4),
                    maxTypeIndex: r.uint16,
                    refList: new r.Pointer(r.uint16, new r.Array(Ref, function(t) {
                        return t.maxTypeIndex + 1;
                    }), {
                        type: 'parent'
                    })
                });
                var TypeList = new r.Struct({
                    length: r.uint16,
                    types: new r.Array(Type, function(t) {
                        return t.length + 1;
                    })
                });
                var DFontMap = new r.Struct({
                    reserved: new r.Reserved(r.uint8, 24),
                    typeList: new r.Pointer(r.uint16, TypeList),
                    nameListOffset: new r.Pointer(r.uint16, 'void')
                });
                var DFontHeader = new r.Struct({
                    dataOffset: r.uint32,
                    map: new r.Pointer(r.uint32, DFontMap),
                    dataLength: r.uint32,
                    mapLength: r.uint32
                });
                var DFont = /*#__PURE__*/ function() {
                    function DFont(stream) {
                        this.stream = stream;
                        this.header = DFontHeader.decode(this.stream);
                        for(var _iterator79 = _createForOfIteratorHelperLoose(this.header.map.typeList.types), _step79; !(_step79 = _iterator79()).done;){
                            var type = _step79.value;
                            for(var _iterator80 = _createForOfIteratorHelperLoose(type.refList), _step80; !(_step80 = _iterator80()).done;){
                                var ref = _step80.value;
                                if (ref.nameOffset >= 0) {
                                    this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                                    ref.name = DFontName.decode(this.stream);
                                } else ref.name = null;
                            }
                            if (type.name === 'sfnt') this.sfnt = type;
                        }
                    }
                    DFont.probe = function probe(buffer) {
                        var stream = new r.DecodeStream(buffer);
                        try {
                            var header = DFontHeader.decode(stream);
                        } catch (e) {
                            return false;
                        }
                        for(var _iterator81 = _createForOfIteratorHelperLoose(header.map.typeList.types), _step81; !(_step81 = _iterator81()).done;){
                            var type = _step81.value;
                            if (type.name === 'sfnt') return true;
                        }
                        return false;
                    };
                    var _proto47 = DFont.prototype;
                    _proto47.getFont = function getFont(name) {
                        if (!this.sfnt) return null;
                        for(var _iterator82 = _createForOfIteratorHelperLoose(this.sfnt.refList), _step82; !(_step82 = _iterator82()).done;){
                            var ref = _step82.value;
                            var pos = this.header.dataOffset + ref.dataOffset + 4;
                            var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
                            var font = new TTFFont(stream);
                            if (font.postscriptName === name) return font;
                        }
                        return null;
                    };
                    return _createClass(DFont, [
                        {
                            key: "fonts",
                            get: function get() {
                                var fonts = [];
                                for(var _iterator83 = _createForOfIteratorHelperLoose(this.sfnt.refList), _step83; !(_step83 = _iterator83()).done;){
                                    var ref = _step83.value;
                                    var pos = this.header.dataOffset + ref.dataOffset + 4;
                                    var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
                                    fonts.push(new TTFFont(stream));
                                }
                                return fonts;
                            }
                        }
                    ]);
                }();
                fontkit.registerFormat(TTFFont);
                fontkit.registerFormat(WOFFFont);
                fontkit.registerFormat(WOFF2Font);
                fontkit.registerFormat(TrueTypeCollection);
                fontkit.registerFormat(DFont);
                module1.exports = fontkit;
            /***/ },
            /***/ 10819: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* global ActiveXObject -- old IE, WSH */ var anObject = __webpack_require__(34984);
                var defineProperties = __webpack_require__(10196);
                var enumBugKeys = __webpack_require__(2416);
                var hiddenKeys = __webpack_require__(90682);
                var html = __webpack_require__(520);
                var documentCreateElement = __webpack_require__(12072);
                var sharedKey = __webpack_require__(82194);
                var GT = '>';
                var LT = '<';
                var PROTOTYPE = 'prototype';
                var SCRIPT = 'script';
                var IE_PROTO = sharedKey('IE_PROTO');
                var EmptyConstructor = function() {};
                var scriptTag = function(content) {
                    return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
                };
                // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
                var NullProtoObjectViaActiveX = function(activeXDocument) {
                    activeXDocument.write(scriptTag(''));
                    activeXDocument.close();
                    var temp = activeXDocument.parentWindow.Object;
                    activeXDocument = null; // avoid memory leak
                    return temp;
                };
                // Create object with fake `null` prototype: use iframe Object with cleared prototype
                var NullProtoObjectViaIFrame = function() {
                    // Thrash, waste and sodomy: IE GC bug
                    var iframe = documentCreateElement('iframe');
                    var JS = 'java' + SCRIPT + ':';
                    var iframeDocument;
                    iframe.style.display = 'none';
                    html.appendChild(iframe);
                    // https://github.com/zloirock/core-js/issues/475
                    iframe.src = String(JS);
                    iframeDocument = iframe.contentWindow.document;
                    iframeDocument.open();
                    iframeDocument.write(scriptTag('document.F=Object'));
                    iframeDocument.close();
                    return iframeDocument.F;
                };
                // Check for document.domain and active x support
                // No need to use active x approach when document.domain is not set
                // see https://github.com/es-shims/es5-shim/issues/150
                // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
                // avoid IE GC bug
                var activeXDocument;
                var NullProtoObject = function() {
                    try {
                        activeXDocument = new ActiveXObject('htmlfile');
                    } catch (error) {}
                    NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
                     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
                    var length = enumBugKeys.length;
                    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
                    return NullProtoObject();
                };
                hiddenKeys[IE_PROTO] = true;
                // `Object.create` method
                // https://tc39.es/ecma262/#sec-object.create
                module1.exports = Object.create || function create(O, Properties) {
                    var result;
                    if (O !== null) {
                        EmptyConstructor[PROTOTYPE] = anObject(O);
                        result = new EmptyConstructor();
                        EmptyConstructor[PROTOTYPE] = null;
                        // add "__proto__" for Object.getPrototypeOf polyfill
                        result[IE_PROTO] = O;
                    } else result = NullProtoObject();
                    return Properties === undefined ? result : defineProperties(result, Properties);
                };
            /***/ },
            /***/ 10821: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var possibleNames = __webpack_require__(10884);
                var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
                /** @type {import('.')} */ module1.exports = function availableTypedArrays() {
                    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
                    for(var i = 0; i < possibleNames.length; i++)if (typeof g[possibleNames[i]] === 'function') // @ts-expect-error
                    out[out.length] = possibleNames[i];
                    return out;
                };
            /***/ },
            /***/ 10849: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var toIntegerOrInfinity = __webpack_require__(26882);
                var thisNumberValue = __webpack_require__(16679);
                var $repeat = __webpack_require__(34858);
                var fails = __webpack_require__(47044);
                var RangeError1 = global.RangeError;
                var String1 = global.String;
                var floor = Math.floor;
                var repeat = uncurryThis($repeat);
                var stringSlice = uncurryThis(''.slice);
                var un$ToFixed = uncurryThis(1.0.toFixed);
                var pow = function(x, n, acc) {
                    return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
                };
                var log = function(x) {
                    var n = 0;
                    var x2 = x;
                    while(x2 >= 4096){
                        n += 12;
                        x2 /= 4096;
                    }
                    while(x2 >= 2){
                        n += 1;
                        x2 /= 2;
                    }
                    return n;
                };
                var multiply = function(data, n, c) {
                    var index = -1;
                    var c2 = c;
                    while(++index < 6){
                        c2 += n * data[index];
                        data[index] = c2 % 1e7;
                        c2 = floor(c2 / 1e7);
                    }
                };
                var divide = function(data, n) {
                    var index = 6;
                    var c = 0;
                    while(--index >= 0){
                        c += data[index];
                        data[index] = floor(c / n);
                        c = c % n * 1e7;
                    }
                };
                var dataToString = function(data) {
                    var index = 6;
                    var s = '';
                    while(--index >= 0)if (s !== '' || index === 0 || data[index] !== 0) {
                        var t = String1(data[index]);
                        s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
                    }
                    return s;
                };
                var FORCED = fails(function() {
                    return un$ToFixed(0.00008, 3) !== '0.000' || un$ToFixed(0.9, 0) !== '1' || un$ToFixed(1.255, 2) !== '1.25' || un$ToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
                }) || !fails(function() {
                    // V8 ~ Android 4.3-
                    un$ToFixed({});
                });
                // `Number.prototype.toFixed` method
                // https://tc39.es/ecma262/#sec-number.prototype.tofixed
                $({
                    target: 'Number',
                    proto: true,
                    forced: FORCED
                }, {
                    toFixed: function toFixed(fractionDigits) {
                        var number = thisNumberValue(this);
                        var fractDigits = toIntegerOrInfinity(fractionDigits);
                        var data = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ];
                        var sign = '';
                        var result = '0';
                        var e, z, j, k;
                        if (fractDigits < 0 || fractDigits > 20) throw RangeError1('Incorrect fraction digits');
                        // eslint-disable-next-line no-self-compare -- NaN check
                        if (number != number) return 'NaN';
                        if (number <= -1000000000000000000000 || number >= 1e21) return String1(number);
                        if (number < 0) {
                            sign = '-';
                            number = -number;
                        }
                        if (number > 1e-21) {
                            e = log(number * pow(2, 69, 1)) - 69;
                            z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
                            z *= 0x10000000000000;
                            e = 52 - e;
                            if (e > 0) {
                                multiply(data, 0, z);
                                j = fractDigits;
                                while(j >= 7){
                                    multiply(data, 1e7, 0);
                                    j -= 7;
                                }
                                multiply(data, pow(10, j, 1), 0);
                                j = e - 1;
                                while(j >= 23){
                                    divide(data, 8388608);
                                    j -= 23;
                                }
                                divide(data, 1 << j);
                                multiply(data, 1, 1);
                                divide(data, 2);
                                result = dataToString(data);
                            } else {
                                multiply(data, 0, z);
                                multiply(data, 1 << -e, 0);
                                result = dataToString(data) + repeat('0', fractDigits);
                            }
                        }
                        if (fractDigits > 0) {
                            k = result.length;
                            result = sign + (k <= fractDigits ? '0.' + repeat('0', fractDigits - k) + result : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
                        } else result = sign + result;
                        return result;
                    }
                });
            /***/ },
            /***/ 10884: /***/ function(module1) {
                "use strict";
                /** @type {import('.')} */ module1.exports = [
                    'Float16Array',
                    'Float32Array',
                    'Float64Array',
                    'Int8Array',
                    'Int16Array',
                    'Int32Array',
                    'Uint8Array',
                    'Uint8ClampedArray',
                    'Uint16Array',
                    'Uint32Array',
                    'BigInt64Array',
                    'BigUint64Array'
                ];
            /***/ },
            /***/ 11206: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                module1.exports = global;
            /***/ },
            /***/ 11220: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isUndefined = __webpack_require__(91867).isUndefined;
                var ElementWriter = __webpack_require__(54861);
                /**
 * Creates an instance of PageElementWriter - an extended ElementWriter
 * which can handle:
 * - page-breaks (it adds new pages when there's not enough space left),
 * - repeatable fragments (like table-headers, which are repeated everytime
 *                         a page-break occurs)
 * - transactions (used for unbreakable-blocks when we want to make sure
 *                 whole block will be rendered on the same page)
 */ function PageElementWriter(context, tracker) {
                    this.transactionLevel = 0;
                    this.repeatables = [];
                    this.tracker = tracker;
                    this.writer = new ElementWriter(context, tracker);
                }
                function fitOnPage(self1, addFct) {
                    var position = addFct(self1);
                    if (!position) {
                        self1.moveToNextPage();
                        position = addFct(self1);
                    }
                    return position;
                }
                PageElementWriter.prototype.addLine = function(line, dontUpdateContextPosition, index) {
                    return fitOnPage(this, function(self1) {
                        return self1.writer.addLine(line, dontUpdateContextPosition, index);
                    });
                };
                PageElementWriter.prototype.addImage = function(image, index) {
                    return fitOnPage(this, function(self1) {
                        return self1.writer.addImage(image, index);
                    });
                };
                PageElementWriter.prototype.addSVG = function(image, index) {
                    return fitOnPage(this, function(self1) {
                        return self1.writer.addSVG(image, index);
                    });
                };
                PageElementWriter.prototype.addQr = function(qr, index) {
                    return fitOnPage(this, function(self1) {
                        return self1.writer.addQr(qr, index);
                    });
                };
                PageElementWriter.prototype.addVector = function(vector, ignoreContextX, ignoreContextY, index, forcePage) {
                    return this.writer.addVector(vector, ignoreContextX, ignoreContextY, index, forcePage);
                };
                PageElementWriter.prototype.beginClip = function(width, height) {
                    return this.writer.beginClip(width, height);
                };
                PageElementWriter.prototype.endClip = function() {
                    return this.writer.endClip();
                };
                PageElementWriter.prototype.alignCanvas = function(node) {
                    this.writer.alignCanvas(node);
                };
                PageElementWriter.prototype.addFragment = function(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
                    if (!this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition)) {
                        this.moveToNextPage();
                        this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition);
                    }
                };
                PageElementWriter.prototype.moveToNextPage = function(pageOrientation) {
                    var nextPage = this.writer.context.moveToNextPage(pageOrientation);
                    // moveToNextPage is called multiple times for table, because is called for each column
                    // and repeatables are inserted only in the first time. If columns are used, is needed
                    // call for table in first column and then for table in the second column (is other repeatables).
                    this.repeatables.forEach(function(rep) {
                        if (isUndefined(rep.insertedOnPages[this.writer.context.page])) {
                            rep.insertedOnPages[this.writer.context.page] = true;
                            this.writer.addFragment(rep, true);
                        } else this.writer.context.moveDown(rep.height);
                    }, this);
                    this.writer.tracker.emit('pageChanged', {
                        prevPage: nextPage.prevPage,
                        prevY: nextPage.prevY,
                        y: this.writer.context.y
                    });
                };
                PageElementWriter.prototype.beginUnbreakableBlock = function(width, height) {
                    if (this.transactionLevel++ === 0) {
                        this.originalX = this.writer.context.x;
                        this.writer.pushContext(width, height);
                    }
                };
                PageElementWriter.prototype.commitUnbreakableBlock = function(forcedX, forcedY) {
                    if (--this.transactionLevel === 0) {
                        var unbreakableContext = this.writer.context;
                        this.writer.popContext();
                        var nbPages = unbreakableContext.pages.length;
                        if (nbPages > 0) {
                            // no support for multi-page unbreakableBlocks
                            var fragment = unbreakableContext.pages[0];
                            fragment.xOffset = forcedX;
                            fragment.yOffset = forcedY;
                            //TODO: vectors can influence height in some situations
                            if (nbPages > 1) {
                                // on out-of-context blocs (headers, footers, background) height should be the whole DocumentContext height
                                if (forcedX !== undefined || forcedY !== undefined) fragment.height = unbreakableContext.getCurrentPage().pageSize.height - unbreakableContext.pageMargins.top - unbreakableContext.pageMargins.bottom;
                                else {
                                    fragment.height = this.writer.context.getCurrentPage().pageSize.height - this.writer.context.pageMargins.top - this.writer.context.pageMargins.bottom;
                                    for(var i = 0, l = this.repeatables.length; i < l; i++)fragment.height -= this.repeatables[i].height;
                                }
                            } else fragment.height = unbreakableContext.y;
                            if (forcedX !== undefined || forcedY !== undefined) this.writer.addFragment(fragment, true, true, true);
                            else this.addFragment(fragment);
                        }
                    }
                };
                PageElementWriter.prototype.currentBlockToRepeatable = function() {
                    var unbreakableContext = this.writer.context;
                    var rep = {
                        items: []
                    };
                    unbreakableContext.pages[0].items.forEach(function(item) {
                        rep.items.push(item);
                    });
                    rep.xOffset = this.originalX;
                    //TODO: vectors can influence height in some situations
                    rep.height = unbreakableContext.y;
                    rep.insertedOnPages = [];
                    return rep;
                };
                PageElementWriter.prototype.pushToRepeatables = function(rep) {
                    this.repeatables.push(rep);
                };
                PageElementWriter.prototype.popFromRepeatables = function() {
                    this.repeatables.pop();
                };
                PageElementWriter.prototype.context = function() {
                    return this.writer.context;
                };
                module1.exports = PageElementWriter;
            /***/ },
            /***/ 11326: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(93143).Buffer;
                // UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
                // See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
                exports.utf7 = Utf7Codec;
                exports.unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
                function Utf7Codec(codecOptions, iconv) {
                    this.iconv = iconv;
                }
                Utf7Codec.prototype.encoder = Utf7Encoder;
                Utf7Codec.prototype.decoder = Utf7Decoder;
                Utf7Codec.prototype.bomAware = true;
                // -- Encoding
                var nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
                function Utf7Encoder(options, codec) {
                    this.iconv = codec.iconv;
                }
                Utf7Encoder.prototype.write = function(str) {
                    // Naive implementation.
                    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
                    return Buffer.from(str.replace(nonDirectChars, (function(chunk) {
                        return "+" + (chunk === '+' ? '' : this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) + "-";
                    }).bind(this)));
                };
                Utf7Encoder.prototype.end = function() {};
                // -- Decoding
                function Utf7Decoder(options, codec) {
                    this.iconv = codec.iconv;
                    this.inBase64 = false;
                    this.base64Accum = '';
                }
                var base64Regex = /[A-Za-z0-9\/+]/;
                var base64Chars = [];
                for(var i = 0; i < 256; i++)base64Chars[i] = base64Regex.test(String.fromCharCode(i));
                var plusChar = '+'.charCodeAt(0), minusChar = '-'.charCodeAt(0), andChar = '&'.charCodeAt(0);
                Utf7Decoder.prototype.write = function(buf) {
                    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
                    // The decoder is more involved as we must handle chunks in stream.
                    for(var i = 0; i < buf.length; i++){
                        if (!inBase64) // Write direct chars until '+'
                        {
                            if (buf[i] == plusChar) {
                                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                                lastI = i + 1;
                                inBase64 = true;
                            }
                        } else if (!base64Chars[buf[i]]) {
                            if (i == lastI && buf[i] == minusChar) res += "+";
                            else {
                                var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), "ascii");
                                res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
                            }
                            if (buf[i] != minusChar) i--;
                            lastI = i + 1;
                            inBase64 = false;
                            base64Accum = '';
                        }
                    }
                    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
                    else {
                        var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), "ascii");
                        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
                        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
                        b64str = b64str.slice(0, canBeDecoded);
                        res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
                    }
                    this.inBase64 = inBase64;
                    this.base64Accum = base64Accum;
                    return res;
                };
                Utf7Decoder.prototype.end = function() {
                    var res = "";
                    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), "utf16-be");
                    this.inBase64 = false;
                    this.base64Accum = '';
                    return res;
                };
                // UTF-7-IMAP codec.
                // RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
                // Differences:
                //  * Base64 part is started by "&" instead of "+"
                //  * Direct characters are 0x20-0x7E, except "&" (0x26)
                //  * In Base64, "," is used instead of "/"
                //  * Base64 must not be used to represent direct characters.
                //  * No implicit shift back from Base64 (should always end with '-')
                //  * String must end in non-shifted position.
                //  * "-&" while in base64 is not allowed.
                exports.utf7imap = Utf7IMAPCodec;
                function Utf7IMAPCodec(codecOptions, iconv) {
                    this.iconv = iconv;
                }
                Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
                Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
                Utf7IMAPCodec.prototype.bomAware = true;
                // -- Encoding
                function Utf7IMAPEncoder(options, codec) {
                    this.iconv = codec.iconv;
                    this.inBase64 = false;
                    this.base64Accum = Buffer.alloc(6);
                    this.base64AccumIdx = 0;
                }
                Utf7IMAPEncoder.prototype.write = function(str) {
                    var inBase64 = this.inBase64, base64Accum = this.base64Accum, base64AccumIdx = this.base64AccumIdx, buf = Buffer.alloc(str.length * 5 + 10), bufIdx = 0;
                    for(var i = 0; i < str.length; i++){
                        var uChar = str.charCodeAt(i);
                        if (0x20 <= uChar && uChar <= 0x7E) {
                            if (inBase64) {
                                if (base64AccumIdx > 0) {
                                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
                                    base64AccumIdx = 0;
                                }
                                buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
                                inBase64 = false;
                            }
                            if (!inBase64) {
                                buf[bufIdx++] = uChar; // Write direct character
                                if (uChar === andChar) buf[bufIdx++] = minusChar;
                            }
                        } else {
                            if (!inBase64) {
                                buf[bufIdx++] = andChar; // Write '&', then go to base64 mode.
                                inBase64 = true;
                            }
                            if (inBase64) {
                                base64Accum[base64AccumIdx++] = uChar >> 8;
                                base64Accum[base64AccumIdx++] = uChar & 0xFF;
                                if (base64AccumIdx == base64Accum.length) {
                                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
                                    base64AccumIdx = 0;
                                }
                            }
                        }
                    }
                    this.inBase64 = inBase64;
                    this.base64AccumIdx = base64AccumIdx;
                    return buf.slice(0, bufIdx);
                };
                Utf7IMAPEncoder.prototype.end = function() {
                    var buf = Buffer.alloc(10), bufIdx = 0;
                    if (this.inBase64) {
                        if (this.base64AccumIdx > 0) {
                            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
                            this.base64AccumIdx = 0;
                        }
                        buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
                        this.inBase64 = false;
                    }
                    return buf.slice(0, bufIdx);
                };
                // -- Decoding
                function Utf7IMAPDecoder(options, codec) {
                    this.iconv = codec.iconv;
                    this.inBase64 = false;
                    this.base64Accum = '';
                }
                var base64IMAPChars = base64Chars.slice();
                base64IMAPChars[','.charCodeAt(0)] = true;
                Utf7IMAPDecoder.prototype.write = function(buf) {
                    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
                    // The decoder is more involved as we must handle chunks in stream.
                    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
                    for(var i = 0; i < buf.length; i++){
                        if (!inBase64) // Write direct chars until '&'
                        {
                            if (buf[i] == andChar) {
                                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                                lastI = i + 1;
                                inBase64 = true;
                            }
                        } else if (!base64IMAPChars[buf[i]]) {
                            if (i == lastI && buf[i] == minusChar) res += "&";
                            else {
                                var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), "ascii").replace(/,/g, '/');
                                res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
                            }
                            if (buf[i] != minusChar) i--;
                            lastI = i + 1;
                            inBase64 = false;
                            base64Accum = '';
                        }
                    }
                    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
                    else {
                        var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), "ascii").replace(/,/g, '/');
                        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
                        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
                        b64str = b64str.slice(0, canBeDecoded);
                        res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
                    }
                    this.inBase64 = inBase64;
                    this.base64Accum = base64Accum;
                    return res;
                };
                Utf7IMAPDecoder.prototype.end = function() {
                    var res = "";
                    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), "utf16-be");
                    this.inBase64 = false;
                    this.base64Accum = '';
                    return res;
                };
            /***/ },
            /***/ 11432: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(41584);
                /* eslint-disable node/no-deprecated-api */ var buffer = __webpack_require__(14598);
                var Buffer = buffer.Buffer;
                // alternative to using Object.keys for old browsers
                function copyProps(src, dst) {
                    for(var key in src)dst[key] = src[key];
                }
                if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module1.exports = buffer;
                else {
                    // Copy properties from require('buffer')
                    copyProps(buffer, exports);
                    exports.Buffer = SafeBuffer;
                }
                function SafeBuffer(arg, encodingOrOffset, length) {
                    return Buffer(arg, encodingOrOffset, length);
                }
                // Copy static methods from Buffer
                copyProps(Buffer, SafeBuffer);
                SafeBuffer.from = function(arg, encodingOrOffset, length) {
                    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
                    return Buffer(arg, encodingOrOffset, length);
                };
                SafeBuffer.alloc = function(size, fill, encoding) {
                    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
                    var buf = Buffer(size);
                    if (fill !== undefined) {
                        if (typeof encoding === 'string') buf.fill(fill, encoding);
                        else buf.fill(fill);
                    } else buf.fill(0);
                    return buf;
                };
                SafeBuffer.allocUnsafe = function(size) {
                    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
                    return Buffer(size);
                };
                SafeBuffer.allocUnsafeSlow = function(size) {
                    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
                    return buffer.SlowBuffer(size);
                };
            /***/ },
            /***/ 11548: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isString = __webpack_require__(91867).isString;
                var isNumber = __webpack_require__(91867).isNumber;
                var isObject = __webpack_require__(91867).isObject;
                var isArray = __webpack_require__(91867).isArray;
                var isUndefined = __webpack_require__(91867).isUndefined;
                var LineBreaker = __webpack_require__(5417);
                var LEADING = /^(\s)+/g;
                var TRAILING = /(\s)+$/g;
                /**
 * Creates an instance of TextTools - text measurement utility
 *
 * @constructor
 * @param {FontProvider} fontProvider
 */ function TextTools(fontProvider) {
                    this.fontProvider = fontProvider;
                }
                /**
 * Converts an array of strings (or inline-definition-objects) into a collection
 * of inlines and calculated minWidth/maxWidth.
 * and their min/max widths
 * @param  {Object} textArray - an array of inline-definition-objects (or strings)
 * @param  {Object} styleContextStack current style stack
 * @return {Object}                   collection of inlines, minWidth, maxWidth
 */ TextTools.prototype.buildInlines = function(textArray, styleContextStack) {
                    var measured = measure(this.fontProvider, textArray, styleContextStack);
                    var minWidth = 0, maxWidth = 0, currentLineWidth;
                    measured.forEach(function(inline) {
                        minWidth = Math.max(minWidth, inline.width - inline.leadingCut - inline.trailingCut);
                        if (!currentLineWidth) currentLineWidth = {
                            width: 0,
                            leadingCut: inline.leadingCut,
                            trailingCut: 0
                        };
                        currentLineWidth.width += inline.width;
                        currentLineWidth.trailingCut = inline.trailingCut;
                        maxWidth = Math.max(maxWidth, getTrimmedWidth(currentLineWidth));
                        if (inline.lineEnd) currentLineWidth = null;
                    });
                    if (getStyleProperty({}, styleContextStack, 'noWrap', false)) minWidth = maxWidth;
                    return {
                        items: measured,
                        minWidth: minWidth,
                        maxWidth: maxWidth
                    };
                    function getTrimmedWidth(item) {
                        return Math.max(0, item.width - item.leadingCut - item.trailingCut);
                    }
                };
                /**
 * Returns size of the specified string (without breaking it) using the current style
 * @param  {String} text              text to be measured
 * @param  {Object} styleContextStack current style stack
 * @return {Object}                   size of the specified string
 */ TextTools.prototype.sizeOfString = function(text, styleContextStack) {
                    text = text ? text.toString().replace(/\t/g, '    ') : '';
                    //TODO: refactor - extract from measure
                    var fontName = getStyleProperty({}, styleContextStack, 'font', 'Roboto');
                    var fontSize = getStyleProperty({}, styleContextStack, 'fontSize', 12);
                    var fontFeatures = getStyleProperty({}, styleContextStack, 'fontFeatures', null);
                    var bold = getStyleProperty({}, styleContextStack, 'bold', false);
                    var italics = getStyleProperty({}, styleContextStack, 'italics', false);
                    var lineHeight = getStyleProperty({}, styleContextStack, 'lineHeight', 1);
                    var characterSpacing = getStyleProperty({}, styleContextStack, 'characterSpacing', 0);
                    var font = this.fontProvider.provideFont(fontName, bold, italics);
                    return {
                        width: widthOfString(text, font, fontSize, characterSpacing, fontFeatures),
                        height: font.lineHeight(fontSize) * lineHeight,
                        fontSize: fontSize,
                        lineHeight: lineHeight,
                        ascender: font.ascender / 1000 * fontSize,
                        descender: font.descender / 1000 * fontSize
                    };
                };
                /**
 * Returns size of the specified rotated string (without breaking it) using the current style
 *
 * @param  {string} text text to be measured
 * @param  {number} angle
 * @param  {object} styleContextStack current style stack
 * @returns {object} size of the specified string
 */ TextTools.prototype.sizeOfRotatedText = function(text, angle, styleContextStack) {
                    var angleRad = angle * Math.PI / -180;
                    var size = this.sizeOfString(text, styleContextStack);
                    return {
                        width: Math.abs(size.height * Math.sin(angleRad)) + Math.abs(size.width * Math.cos(angleRad)),
                        height: Math.abs(size.width * Math.sin(angleRad)) + Math.abs(size.height * Math.cos(angleRad))
                    };
                };
                TextTools.prototype.widthOfString = function(text, font, fontSize, characterSpacing, fontFeatures) {
                    return widthOfString(text, font, fontSize, characterSpacing, fontFeatures);
                };
                function splitWords(text, noWrap) {
                    var results = [];
                    text = text.replace(/\t/g, '    ');
                    if (noWrap) {
                        results.push({
                            text: text
                        });
                        return results;
                    }
                    var breaker = new LineBreaker(text);
                    var last = 0;
                    var bk;
                    while(bk = breaker.nextBreak()){
                        var word = text.slice(last, bk.position);
                        if (bk.required || word.match(/\r?\n$|\r$/)) {
                            word = word.replace(/\r?\n$|\r$/, '');
                            results.push({
                                text: word,
                                lineEnd: true
                            });
                        } else results.push({
                            text: word
                        });
                        last = bk.position;
                    }
                    return results;
                }
                function copyStyle(source, destination) {
                    destination = destination || {};
                    source = source || {}; //TODO: default style
                    for(var key in source)if (key != 'text' && source.hasOwnProperty(key)) destination[key] = source[key];
                    return destination;
                }
                function normalizeTextArray(array, styleContextStack) {
                    function flatten(array) {
                        return array.reduce(function(prev, cur) {
                            var current = isArray(cur.text) ? flatten(cur.text) : cur;
                            var more = [].concat(current).some(Array.isArray);
                            return prev.concat(more ? flatten(current) : current);
                        }, []);
                    }
                    function getOneWord(index, words, noWrap) {
                        if (isUndefined(words[index])) return null;
                        if (words[index].lineEnd) return null;
                        var word = words[index].text;
                        if (noWrap) {
                            var tmpWords = splitWords(normalizeString(word), false);
                            if (isUndefined(tmpWords[tmpWords.length - 1])) return null;
                            word = tmpWords[tmpWords.length - 1].text;
                        }
                        return word;
                    }
                    var results = [];
                    if (!isArray(array)) array = [
                        array
                    ];
                    array = flatten(array);
                    var lastWord = null;
                    for(var i = 0, l = array.length; i < l; i++){
                        var item = array[i];
                        var style = null;
                        var words;
                        var noWrap = getStyleProperty(item || {}, styleContextStack, 'noWrap', false);
                        if (isObject(item)) {
                            if (item._textRef && item._textRef._textNodeRef.text) item.text = item._textRef._textNodeRef.text;
                            words = splitWords(normalizeString(item.text), noWrap);
                            style = copyStyle(item);
                        } else words = splitWords(normalizeString(item), noWrap);
                        if (lastWord && words.length) {
                            var firstWord = getOneWord(0, words, noWrap);
                            var wrapWords = splitWords(normalizeString(lastWord + firstWord), false);
                            if (wrapWords.length === 1) results[results.length - 1].noNewLine = true;
                        }
                        for(var i2 = 0, l2 = words.length; i2 < l2; i2++){
                            var result = {
                                text: words[i2].text
                            };
                            if (words[i2].lineEnd) result.lineEnd = true;
                            copyStyle(style, result);
                            results.push(result);
                        }
                        lastWord = null;
                        if (i + 1 < l) lastWord = getOneWord(words.length - 1, words, noWrap);
                    }
                    return results;
                }
                function normalizeString(value) {
                    if (value === undefined || value === null) return '';
                    else if (isNumber(value)) return value.toString();
                    else if (isString(value)) return value;
                    else return value.toString();
                }
                function getStyleProperty(item, styleContextStack, property, defaultValue) {
                    var value;
                    if (item[property] !== undefined && item[property] !== null) // item defines this property
                    return item[property];
                    if (!styleContextStack) return defaultValue;
                    styleContextStack.auto(item, function() {
                        value = styleContextStack.getProperty(property);
                    });
                    if (value !== null && value !== undefined) return value;
                    else return defaultValue;
                }
                function measure(fontProvider, textArray, styleContextStack) {
                    var normalized = normalizeTextArray(textArray, styleContextStack);
                    if (normalized.length) {
                        var leadingIndent = getStyleProperty(normalized[0], styleContextStack, 'leadingIndent', 0);
                        if (leadingIndent) {
                            normalized[0].leadingCut = -leadingIndent;
                            normalized[0].leadingIndent = leadingIndent;
                        }
                    }
                    normalized.forEach(function(item) {
                        var fontName = getStyleProperty(item, styleContextStack, 'font', 'Roboto');
                        var fontSize = getStyleProperty(item, styleContextStack, 'fontSize', 12);
                        var fontFeatures = getStyleProperty(item, styleContextStack, 'fontFeatures', null);
                        var bold = getStyleProperty(item, styleContextStack, 'bold', false);
                        var italics = getStyleProperty(item, styleContextStack, 'italics', false);
                        var color = getStyleProperty(item, styleContextStack, 'color', 'black');
                        var decoration = getStyleProperty(item, styleContextStack, 'decoration', null);
                        var decorationColor = getStyleProperty(item, styleContextStack, 'decorationColor', null);
                        var decorationStyle = getStyleProperty(item, styleContextStack, 'decorationStyle', null);
                        var background = getStyleProperty(item, styleContextStack, 'background', null);
                        var lineHeight = getStyleProperty(item, styleContextStack, 'lineHeight', 1);
                        var characterSpacing = getStyleProperty(item, styleContextStack, 'characterSpacing', 0);
                        var link = getStyleProperty(item, styleContextStack, 'link', null);
                        var linkToPage = getStyleProperty(item, styleContextStack, 'linkToPage', null);
                        var linkToDestination = getStyleProperty(item, styleContextStack, 'linkToDestination', null);
                        var noWrap = getStyleProperty(item, styleContextStack, 'noWrap', null);
                        var preserveLeadingSpaces = getStyleProperty(item, styleContextStack, 'preserveLeadingSpaces', false);
                        var preserveTrailingSpaces = getStyleProperty(item, styleContextStack, 'preserveTrailingSpaces', false);
                        var opacity = getStyleProperty(item, styleContextStack, 'opacity', 1);
                        var sup = getStyleProperty(item, styleContextStack, 'sup', false);
                        var sub = getStyleProperty(item, styleContextStack, 'sub', false);
                        if ((sup || sub) && item.fontSize === undefined) // font size reduction taken from here: https://en.wikipedia.org/wiki/Subscript_and_superscript#Desktop_publishing
                        fontSize *= 0.58;
                        var font = fontProvider.provideFont(fontName, bold, italics);
                        item.width = widthOfString(item.text, font, fontSize, characterSpacing, fontFeatures);
                        item.height = font.lineHeight(fontSize) * lineHeight;
                        if (!item.leadingCut) item.leadingCut = 0;
                        var leadingSpaces;
                        if (!preserveLeadingSpaces && (leadingSpaces = item.text.match(LEADING))) item.leadingCut += widthOfString(leadingSpaces[0], font, fontSize, characterSpacing, fontFeatures);
                        var trailingSpaces;
                        if (!preserveTrailingSpaces && (trailingSpaces = item.text.match(TRAILING))) item.trailingCut = widthOfString(trailingSpaces[0], font, fontSize, characterSpacing, fontFeatures);
                        else item.trailingCut = 0;
                        item.alignment = getStyleProperty(item, styleContextStack, 'alignment', 'left');
                        item.font = font;
                        item.fontSize = fontSize;
                        item.fontFeatures = fontFeatures;
                        item.characterSpacing = characterSpacing;
                        item.color = color;
                        item.decoration = decoration;
                        item.decorationColor = decorationColor;
                        item.decorationStyle = decorationStyle;
                        item.background = background;
                        item.link = link;
                        item.linkToPage = linkToPage;
                        item.linkToDestination = linkToDestination;
                        item.noWrap = noWrap;
                        item.opacity = opacity;
                        item.sup = sup;
                        item.sub = sub;
                    });
                    return normalized;
                }
                function widthOfString(text, font, fontSize, characterSpacing, fontFeatures) {
                    return font.widthOfString(text, fontSize, fontFeatures) + (characterSpacing || 0) * (text.length - 1);
                }
                module1.exports = TextTools;
            /***/ },
            /***/ 11610: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(14032);
                __webpack_require__(68067);
                function _inheritsLoose(t, o) {
                    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
                }
                function _setPrototypeOf(t, e) {
                    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                        return t.__proto__ = e, t;
                    }, _setPrototypeOf(t, e);
                }
                var ArrayT = __webpack_require__(68332);
                var _require = __webpack_require__(56128), NumberT = _require.Number;
                var utils = __webpack_require__(18128);
                var _require2 = __webpack_require__(7187), _inspect = _require2.inspect;
                var LazyArrayT = /*#__PURE__*/ function(_ArrayT) {
                    function LazyArrayT() {
                        return _ArrayT.apply(this, arguments) || this;
                    }
                    _inheritsLoose(LazyArrayT, _ArrayT);
                    var _proto = LazyArrayT.prototype;
                    _proto.decode = function decode(stream, parent) {
                        var pos = stream.pos;
                        var length = utils.resolveLength(this.length, stream, parent);
                        if (this.length instanceof NumberT) parent = {
                            parent: parent,
                            _startOffset: pos,
                            _currentOffset: 0,
                            _length: length
                        };
                        var res = new LazyArray(this.type, length, stream, parent);
                        stream.pos += length * this.type.size(null, parent);
                        return res;
                    };
                    _proto.size = function size(val, ctx) {
                        if (val instanceof LazyArray) val = val.toArray();
                        return _ArrayT.prototype.size.call(this, val, ctx);
                    };
                    _proto.encode = function encode(stream, val, ctx) {
                        if (val instanceof LazyArray) val = val.toArray();
                        return _ArrayT.prototype.encode.call(this, stream, val, ctx);
                    };
                    return LazyArrayT;
                }(ArrayT);
                var LazyArray = /*#__PURE__*/ function() {
                    function LazyArray(type, length, stream, ctx) {
                        this.type = type;
                        this.length = length;
                        this.stream = stream;
                        this.ctx = ctx;
                        this.base = this.stream.pos;
                        this.items = [];
                    }
                    var _proto2 = LazyArray.prototype;
                    _proto2.get = function get(index) {
                        if (index < 0 || index >= this.length) return undefined;
                        if (this.items[index] == null) {
                            var pos = this.stream.pos;
                            this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
                            this.items[index] = this.type.decode(this.stream, this.ctx);
                            this.stream.pos = pos;
                        }
                        return this.items[index];
                    };
                    _proto2.toArray = function toArray() {
                        var result = [];
                        for(var i = 0, end = this.length; i < end; i++)result.push(this.get(i));
                        return result;
                    };
                    _proto2.inspect = function inspect() {
                        return _inspect(this.toArray());
                    };
                    return LazyArray;
                }();
                module1.exports = LazyArrayT;
            /***/ },
            /***/ 11765: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var from = __webpack_require__(95717);
                var checkCorrectnessOfIteration = __webpack_require__(46769);
                var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
                    // eslint-disable-next-line es/no-array-from -- required for testing
                    Array.from(iterable);
                });
                // `Array.from` method
                // https://tc39.es/ecma262/#sec-array.from
                $({
                    target: 'Array',
                    stat: true,
                    forced: INCORRECT_ITERATION
                }, {
                    from: from
                });
            /***/ },
            /***/ 11813: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // TODO: Remove from `core-js@4` since it's moved to entry points
                __webpack_require__(61726);
                var uncurryThis = __webpack_require__(38347);
                var redefine = __webpack_require__(13711);
                var regexpExec = __webpack_require__(49820);
                var fails = __webpack_require__(47044);
                var wellKnownSymbol = __webpack_require__(38688);
                var createNonEnumerableProperty = __webpack_require__(48914);
                var SPECIES = wellKnownSymbol('species');
                var RegExpPrototype = RegExp.prototype;
                module1.exports = function(KEY, exec, FORCED, SHAM) {
                    var SYMBOL = wellKnownSymbol(KEY);
                    var DELEGATES_TO_SYMBOL = !fails(function() {
                        // String methods call symbol-named RegEp methods
                        var O = {};
                        O[SYMBOL] = function() {
                            return 7;
                        };
                        return ''[KEY](O) != 7;
                    });
                    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
                        // Symbol-named RegExp methods call .exec
                        var execCalled = false;
                        var re = /a/;
                        if (KEY === 'split') {
                            // We can't use real regex here since it causes deoptimization
                            // and serious performance degradation in V8
                            // https://github.com/zloirock/core-js/issues/306
                            re = {};
                            // RegExp[@@split] doesn't call the regex's exec method, but first creates
                            // a new one. We need to return the patched regex when creating the new one.
                            re.constructor = {};
                            re.constructor[SPECIES] = function() {
                                return re;
                            };
                            re.flags = '';
                            re[SYMBOL] = /./[SYMBOL];
                        }
                        re.exec = function() {
                            execCalled = true;
                            return null;
                        };
                        re[SYMBOL]('');
                        return !execCalled;
                    });
                    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
                        var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
                        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
                            var uncurriedNativeMethod = uncurryThis(nativeMethod);
                            var $exec = regexp.exec;
                            if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
                                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                                // polyfilled function), leasing to infinite recursion.
                                // We avoid it by directly calling the native @@method method.
                                return {
                                    done: true,
                                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                                };
                                return {
                                    done: true,
                                    value: uncurriedNativeMethod(str, regexp, arg2)
                                };
                            }
                            return {
                                done: false
                            };
                        });
                        redefine(String.prototype, KEY, methods[0]);
                        redefine(RegExpPrototype, SYMBOL, methods[1]);
                    }
                    if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
                };
            /***/ },
            /***/ 11905: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(66664));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var C_algo = C.algo;
                        var SHA256 = C_algo.SHA256;
                        /**
     * SHA-224 hash algorithm.
     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
                            _doReset: function _doReset() {
                                this._hash = new WordArray.init([
                                    0xc1059ed8,
                                    0x367cd507,
                                    0x3070dd17,
                                    0xf70e5939,
                                    0xffc00b31,
                                    0x68581511,
                                    0x64f98fa7,
                                    0xbefa4fa4
                                ]);
                            },
                            _doFinalize: function _doFinalize() {
                                var hash = SHA256._doFinalize.call(this);
                                hash.sigBytes -= 4;
                                return hash;
                            }
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA224('message');
     *     var hash = CryptoJS.SHA224(wordArray);
     */ C.SHA224 = SHA256._createHelper(SHA224);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA224(message, key);
     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
                    })();
                    return CryptoJS.SHA224;
                });
            /***/ },
            /***/ 12072: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isObject = __webpack_require__(24517);
                var document1 = global.document;
                // typeof document.createElement is 'object' in old IE
                var EXISTS = isObject(document1) && isObject(document1.createElement);
                module1.exports = function(it) {
                    return EXISTS ? document1.createElement(it) : {};
                };
            /***/ },
            /***/ 12167: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Ported from https://github.com/mafintosh/end-of-stream with
                // permission from the author, Mathias Buus (@mafintosh).
                var ERR_STREAM_PREMATURE_CLOSE = __webpack_require__(83797)/* .codes */ .F.ERR_STREAM_PREMATURE_CLOSE;
                function once(callback) {
                    var called = false;
                    return function() {
                        if (called) return;
                        called = true;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        callback.apply(this, args);
                    };
                }
                function noop() {}
                function isRequest(stream) {
                    return stream.setHeader && typeof stream.abort === 'function';
                }
                function eos(stream, opts, callback) {
                    if (typeof opts === 'function') return eos(stream, null, opts);
                    if (!opts) opts = {};
                    callback = once(callback || noop);
                    var readable = opts.readable || opts.readable !== false && stream.readable;
                    var writable = opts.writable || opts.writable !== false && stream.writable;
                    var onlegacyfinish = function onlegacyfinish() {
                        if (!stream.writable) onfinish();
                    };
                    var writableEnded = stream._writableState && stream._writableState.finished;
                    var onfinish = function onfinish() {
                        writable = false;
                        writableEnded = true;
                        if (!readable) callback.call(stream);
                    };
                    var readableEnded = stream._readableState && stream._readableState.endEmitted;
                    var onend = function onend() {
                        readable = false;
                        readableEnded = true;
                        if (!writable) callback.call(stream);
                    };
                    var onerror = function onerror(err) {
                        callback.call(stream, err);
                    };
                    var onclose = function onclose() {
                        var err;
                        if (readable && !readableEnded) {
                            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                            return callback.call(stream, err);
                        }
                        if (writable && !writableEnded) {
                            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
                            return callback.call(stream, err);
                        }
                    };
                    var onrequest = function onrequest() {
                        stream.req.on('finish', onfinish);
                    };
                    if (isRequest(stream)) {
                        stream.on('complete', onfinish);
                        stream.on('abort', onclose);
                        if (stream.req) onrequest();
                        else stream.on('request', onrequest);
                    } else if (writable && !stream._writableState) {
                        // legacy streams
                        stream.on('end', onlegacyfinish);
                        stream.on('close', onlegacyfinish);
                    }
                    stream.on('end', onend);
                    stream.on('finish', onfinish);
                    if (opts.error !== false) stream.on('error', onerror);
                    stream.on('close', onclose);
                    return function() {
                        stream.removeListener('complete', onfinish);
                        stream.removeListener('abort', onclose);
                        stream.removeListener('request', onrequest);
                        if (stream.req) stream.req.removeListener('finish', onfinish);
                        stream.removeListener('end', onlegacyfinish);
                        stream.removeListener('close', onlegacyfinish);
                        stream.removeListener('finish', onfinish);
                        stream.removeListener('end', onend);
                        stream.removeListener('error', onerror);
                        stream.removeListener('close', onclose);
                    };
                }
                module1.exports = eos;
            /***/ },
            /***/ 12636: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toIndexedObject = __webpack_require__(98086);
                var toAbsoluteIndex = __webpack_require__(74841);
                var lengthOfArrayLike = __webpack_require__(45495);
                // `Array.prototype.{ indexOf, includes }` methods implementation
                var createMethod = function(IS_INCLUDES) {
                    return function($this, el, fromIndex) {
                        var O = toIndexedObject($this);
                        var length = lengthOfArrayLike(O);
                        var index = toAbsoluteIndex(fromIndex, length);
                        var value;
                        // Array#includes uses SameValueZero equality algorithm
                        // eslint-disable-next-line no-self-compare -- NaN check
                        if (IS_INCLUDES && el != el) while(length > index){
                            value = O[index++];
                            // eslint-disable-next-line no-self-compare -- NaN check
                            if (value != value) return true;
                        // Array#indexOf ignores holes, Array#includes - not
                        }
                        else for(; length > index; index++){
                            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                        }
                        return !IS_INCLUDES && -1;
                    };
                };
                module1.exports = {
                    // `Array.prototype.includes` method
                    // https://tc39.es/ecma262/#sec-array.prototype.includes
                    includes: createMethod(true),
                    // `Array.prototype.indexOf` method
                    // https://tc39.es/ecma262/#sec-array.prototype.indexof
                    indexOf: createMethod(false)
                };
            /***/ },
            /***/ 12719: /***/ function(module1) {
                "use strict";
                /* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
                var toStr = Object.prototype.toString;
                var max = Math.max;
                var funcType = '[object Function]';
                var concatty = function concatty(a, b) {
                    var arr = [];
                    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
                    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
                    return arr;
                };
                var slicy = function slicy(arrLike, offset) {
                    var arr = [];
                    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
                    return arr;
                };
                var joiny = function(arr, joiner) {
                    var str = '';
                    for(var i = 0; i < arr.length; i += 1){
                        str += arr[i];
                        if (i + 1 < arr.length) str += joiner;
                    }
                    return str;
                };
                module1.exports = function bind(that) {
                    var target = this;
                    if (typeof target !== 'function' || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
                    var args = slicy(arguments, 1);
                    var bound;
                    var binder = function() {
                        if (this instanceof bound) {
                            var result = target.apply(this, concatty(args, arguments));
                            if (Object(result) === result) return result;
                            return this;
                        }
                        return target.apply(that, concatty(args, arguments));
                    };
                    var boundLength = max(0, target.length - args.length);
                    var boundArgs = [];
                    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
                    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
                    if (target.prototype) {
                        var Empty = function Empty() {};
                        Empty.prototype = target.prototype;
                        bound.prototype = new Empty();
                        Empty.prototype = null;
                    }
                    return bound;
                };
            /***/ },
            /***/ 12843: /***/ function(module1) {
                "use strict";
                /** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module1.exports = function hasSymbols() {
                    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
                    if (typeof Symbol.iterator === 'symbol') return true;
                    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
                    var sym = Symbol('test');
                    var symObj = Object(sym);
                    if (typeof sym === 'string') return false;
                    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
                    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
                    // temp disabled per https://github.com/ljharb/object.assign/issues/17
                    // if (sym instanceof Symbol) { return false; }
                    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
                    // if (!(symObj instanceof Symbol)) { return false; }
                    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
                    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
                    var symVal = 42;
                    obj[sym] = symVal;
                    for(var _ in obj)return false;
                     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
                    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
                    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
                    var syms = Object.getOwnPropertySymbols(obj);
                    if (syms.length !== 1 || syms[0] !== sym) return false;
                    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
                    if (typeof Object.getOwnPropertyDescriptor === 'function') {
                        // eslint-disable-next-line no-extra-parens
                        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
                        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
                    }
                    return true;
                };
            /***/ },
            /***/ 13250: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var typedArraySpeciesConstructor = __webpack_require__(34815);
                var fails = __webpack_require__(47044);
                var arraySlice = __webpack_require__(73163);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var FORCED = fails(function() {
                    // eslint-disable-next-line es/no-typed-arrays -- required for testing
                    new Int8Array(1).slice();
                });
                // `%TypedArray%.prototype.slice` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
                exportTypedArrayMethod('slice', function slice(start, end) {
                    var list = arraySlice(aTypedArray(this), start, end);
                    var C = typedArraySpeciesConstructor(this);
                    var index = 0;
                    var length = list.length;
                    var result = new C(length);
                    while(length > index)result[index] = list[index++];
                    return result;
                }, FORCED);
            /***/ },
            /***/ 13501: /***/ function(module1) {
                module1.exports = "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";
            /***/ },
            /***/ 13549: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(41584);
                var utils = __webpack_require__(18128);
                var Reserved = /*#__PURE__*/ function() {
                    function Reserved(type, count) {
                        if (count === void 0) count = 1;
                        this.type = type;
                        this.count = count;
                    }
                    var _proto = Reserved.prototype;
                    _proto.decode = function decode(stream, parent) {
                        stream.pos += this.size(null, parent);
                        return undefined;
                    };
                    _proto.size = function size(data, parent) {
                        var count = utils.resolveLength(this.count, null, parent);
                        return this.type.size() * count;
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        return stream.fill(0, this.size(val, parent));
                    };
                    return Reserved;
                }();
                module1.exports = Reserved;
            /***/ },
            /***/ 13624: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $indexOf = __webpack_require__(12636).indexOf;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.indexOf` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
                exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */ ) {
                    return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 13711: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isCallable = __webpack_require__(94578);
                var hasOwn = __webpack_require__(20340);
                var createNonEnumerableProperty = __webpack_require__(48914);
                var setGlobal = __webpack_require__(7421);
                var inspectSource = __webpack_require__(10447);
                var InternalStateModule = __webpack_require__(70172);
                var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(7081).CONFIGURABLE;
                var getInternalState = InternalStateModule.get;
                var enforceInternalState = InternalStateModule.enforce;
                var TEMPLATE = String(String).split('String');
                (module1.exports = function(O, key, value, options) {
                    var unsafe = options ? !!options.unsafe : false;
                    var simple = options ? !!options.enumerable : false;
                    var noTargetGet = options ? !!options.noTargetGet : false;
                    var name = options && options.name !== undefined ? options.name : key;
                    var state;
                    if (isCallable(value)) {
                        if (String(name).slice(0, 7) === 'Symbol(') name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
                        if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) createNonEnumerableProperty(value, 'name', name);
                        state = enforceInternalState(value);
                        if (!state.source) state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
                    }
                    if (O === global) {
                        if (simple) O[key] = value;
                        else setGlobal(key, value);
                        return;
                    } else if (!unsafe) delete O[key];
                    else if (!noTargetGet && O[key]) simple = true;
                    if (simple) O[key] = value;
                    else createNonEnumerableProperty(O, key, value);
                // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
                })(Function.prototype, 'toString', function toString() {
                    return isCallable(this) && getInternalState(this).source || inspectSource(this);
                });
            /***/ },
            /***/ 13872: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var classof = __webpack_require__(52564);
                var getMethod = __webpack_require__(51839);
                var Iterators = __webpack_require__(15366);
                var wellKnownSymbol = __webpack_require__(38688);
                var ITERATOR = wellKnownSymbol('iterator');
                module1.exports = function(it) {
                    if (it != undefined) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
                };
            /***/ },
            /***/ 13945: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var IteratorPrototype = __webpack_require__(5844).IteratorPrototype;
                var create = __webpack_require__(10819);
                var createPropertyDescriptor = __webpack_require__(97841);
                var setToStringTag = __webpack_require__(15216);
                var Iterators = __webpack_require__(15366);
                var returnThis = function() {
                    return this;
                };
                module1.exports = function(IteratorConstructor, NAME, next) {
                    var TO_STRING_TAG = NAME + ' Iterator';
                    IteratorConstructor.prototype = create(IteratorPrototype, {
                        next: createPropertyDescriptor(1, next)
                    });
                    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
                    Iterators[TO_STRING_TAG] = returnThis;
                    return IteratorConstructor;
                };
            /***/ },
            /***/ 14032: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var TO_STRING_TAG_SUPPORT = __webpack_require__(24663);
                var redefine = __webpack_require__(13711);
                var toString = __webpack_require__(52598);
                // `Object.prototype.toString` method
                // https://tc39.es/ecma262/#sec-object.prototype.tostring
                if (!TO_STRING_TAG_SUPPORT) redefine(Object.prototype, 'toString', toString, {
                    unsafe: true
                });
            /***/ },
            /***/ 14287: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(81755);
                __webpack_require__(8953);
                __webpack_require__(14032);
                __webpack_require__(3131);
                __webpack_require__(90868);
                __webpack_require__(65553);
                __webpack_require__(75626);
                __webpack_require__(95756);
                __webpack_require__(56912);
                __webpack_require__(58099);
                __webpack_require__(47969);
                __webpack_require__(59735);
                __webpack_require__(73663);
                __webpack_require__(29883);
                __webpack_require__(35471);
                __webpack_require__(21012);
                __webpack_require__(88997);
                __webpack_require__(97464);
                __webpack_require__(2857);
                __webpack_require__(94715);
                __webpack_require__(13624);
                __webpack_require__(91132);
                __webpack_require__(62514);
                __webpack_require__(24597);
                __webpack_require__(88042);
                __webpack_require__(4660);
                __webpack_require__(92451);
                __webpack_require__(44206);
                __webpack_require__(66288);
                __webpack_require__(13250);
                __webpack_require__(3858);
                __webpack_require__(84538);
                __webpack_require__(64793);
                __webpack_require__(74202);
                __webpack_require__(52529);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Check if typed arrays are supported
                        if (typeof ArrayBuffer != 'function') return;
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        // Reference original init
                        var superInit = WordArray.init;
                        // Augment WordArray.init to handle typed arrays
                        var subInit = WordArray.init = function(typedArray) {
                            // Convert buffers to uint8
                            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
                            // Convert other array views to uint8
                            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
                            // Handle Uint8Array
                            if (typedArray instanceof Uint8Array) {
                                // Shortcut
                                var typedArrayByteLength = typedArray.byteLength;
                                // Extract bytes
                                var words = [];
                                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                                // Initialize this word array
                                superInit.call(this, words, typedArrayByteLength);
                            } else // Else call normal init
                            superInit.apply(this, arguments);
                        };
                        subInit.prototype = WordArray;
                    })();
                    return CryptoJS.lib.WordArray;
                });
            /***/ },
            /***/ 14598: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ __webpack_require__(65292);
                __webpack_require__(73844);
                __webpack_require__(5597);
                __webpack_require__(39081);
                __webpack_require__(68626);
                __webpack_require__(41584);
                __webpack_require__(58028);
                __webpack_require__(81755);
                __webpack_require__(20731);
                __webpack_require__(8953);
                __webpack_require__(7585);
                __webpack_require__(24863);
                __webpack_require__(7283);
                __webpack_require__(2876);
                __webpack_require__(14032);
                __webpack_require__(61726);
                __webpack_require__(57114);
                __webpack_require__(47458);
                __webpack_require__(46467);
                __webpack_require__(72095);
                __webpack_require__(56912);
                __webpack_require__(73663);
                __webpack_require__(29883);
                __webpack_require__(35471);
                __webpack_require__(21012);
                __webpack_require__(88997);
                __webpack_require__(97464);
                __webpack_require__(2857);
                __webpack_require__(94715);
                __webpack_require__(13624);
                __webpack_require__(91132);
                __webpack_require__(62514);
                __webpack_require__(24597);
                __webpack_require__(88042);
                __webpack_require__(4660);
                __webpack_require__(92451);
                __webpack_require__(44206);
                __webpack_require__(66288);
                __webpack_require__(13250);
                __webpack_require__(3858);
                __webpack_require__(84538);
                __webpack_require__(64793);
                __webpack_require__(74202);
                __webpack_require__(52529);
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == typeof i ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != typeof t || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                function _inheritsLoose(t, o) {
                    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
                }
                function _setPrototypeOf(t, e) {
                    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                        return t.__proto__ = e, t;
                    }, _setPrototypeOf(t, e);
                }
                var base64 = __webpack_require__(32504);
                var ieee754 = __webpack_require__(89029);
                var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
                 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
                 : null;
                exports.Buffer = Buffer;
                exports.SlowBuffer = SlowBuffer;
                exports.INSPECT_MAX_BYTES = 50;
                var K_MAX_LENGTH = 0x7fffffff;
                exports.kMaxLength = K_MAX_LENGTH;
                /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
                if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
                function typedArraySupport() {
                    // Can typed array instances can be augmented?
                    try {
                        var arr = new Uint8Array(1);
                        var proto = {
                            foo: function foo() {
                                return 42;
                            }
                        };
                        Object.setPrototypeOf(proto, Uint8Array.prototype);
                        Object.setPrototypeOf(arr, proto);
                        return arr.foo() === 42;
                    } catch (e) {
                        return false;
                    }
                }
                Object.defineProperty(Buffer.prototype, 'parent', {
                    enumerable: true,
                    get: function get() {
                        if (!Buffer.isBuffer(this)) return undefined;
                        return this.buffer;
                    }
                });
                Object.defineProperty(Buffer.prototype, 'offset', {
                    enumerable: true,
                    get: function get() {
                        if (!Buffer.isBuffer(this)) return undefined;
                        return this.byteOffset;
                    }
                });
                function createBuffer(length) {
                    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
                    // Return an augmented `Uint8Array` instance
                    var buf = new Uint8Array(length);
                    Object.setPrototypeOf(buf, Buffer.prototype);
                    return buf;
                }
                /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
                    // Common case.
                    if (typeof arg === 'number') {
                        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
                        return allocUnsafe(arg);
                    }
                    return from(arg, encodingOrOffset, length);
                }
                Buffer.poolSize = 8192; // not used by this implementation
                function from(value, encodingOrOffset, length) {
                    if (typeof value === 'string') return fromString(value, encodingOrOffset);
                    if (ArrayBuffer.isView(value)) return fromArrayView(value);
                    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
                    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
                    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
                    var valueOf = value.valueOf && value.valueOf();
                    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
                    var b = fromObject(value);
                    if (b) return b;
                    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
                    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                }
                /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
                    return from(value, encodingOrOffset, length);
                };
                // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
                // https://github.com/feross/buffer/pull/148
                Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
                Object.setPrototypeOf(Buffer, Uint8Array);
                function assertSize(size) {
                    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
                    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
                }
                function alloc(size, fill, encoding) {
                    assertSize(size);
                    if (size <= 0) return createBuffer(size);
                    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
                    // prevents accidentally sending in a number that would
                    // be interpreted as a start offset.
                    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
                    return createBuffer(size);
                }
                /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
                    return alloc(size, fill, encoding);
                };
                function allocUnsafe(size) {
                    assertSize(size);
                    return createBuffer(size < 0 ? 0 : checked(size) | 0);
                }
                /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
                    return allocUnsafe(size);
                };
                /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
                    return allocUnsafe(size);
                };
                function fromString(string, encoding) {
                    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
                    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
                    var length = byteLength(string, encoding) | 0;
                    var buf = createBuffer(length);
                    var actual = buf.write(string, encoding);
                    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
                    // cause everything after the first invalid character to be ignored. (e.g.
                    // 'abxxcd' will be treated as 'ab')
                    buf = buf.slice(0, actual);
                    return buf;
                }
                function fromArrayLike(array) {
                    var length = array.length < 0 ? 0 : checked(array.length) | 0;
                    var buf = createBuffer(length);
                    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
                    return buf;
                }
                function fromArrayView(arrayView) {
                    if (isInstance(arrayView, Uint8Array)) {
                        var copy = new Uint8Array(arrayView);
                        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
                    }
                    return fromArrayLike(arrayView);
                }
                function fromArrayBuffer(array, byteOffset, length) {
                    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
                    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
                    var buf;
                    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
                    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
                    else buf = new Uint8Array(array, byteOffset, length);
                    // Return an augmented `Uint8Array` instance
                    Object.setPrototypeOf(buf, Buffer.prototype);
                    return buf;
                }
                function fromObject(obj) {
                    if (Buffer.isBuffer(obj)) {
                        var len = checked(obj.length) | 0;
                        var buf = createBuffer(len);
                        if (buf.length === 0) return buf;
                        obj.copy(buf, 0, 0, len);
                        return buf;
                    }
                    if (obj.length !== undefined) {
                        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
                        return fromArrayLike(obj);
                    }
                    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
                }
                function checked(length) {
                    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
                    // length is NaN (which is otherwise coerced to zero.)
                    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
                    return length | 0;
                }
                function SlowBuffer(length) {
                    if (+length != length) // eslint-disable-line eqeqeq
                    length = 0;
                    return Buffer.alloc(+length);
                }
                Buffer.isBuffer = function isBuffer(b) {
                    return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
                };
                Buffer.compare = function compare(a, b) {
                    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
                    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
                    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                    if (a === b) return 0;
                    var x = a.length;
                    var y = b.length;
                    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                        x = a[i];
                        y = b[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                };
                Buffer.isEncoding = function isEncoding(encoding) {
                    switch(String(encoding).toLowerCase()){
                        case 'hex':
                        case 'utf8':
                        case 'utf-8':
                        case 'ascii':
                        case 'latin1':
                        case 'binary':
                        case 'base64':
                        case 'ucs2':
                        case 'ucs-2':
                        case 'utf16le':
                        case 'utf-16le':
                            return true;
                        default:
                            return false;
                    }
                };
                Buffer.concat = function concat(list, length) {
                    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
                    if (list.length === 0) return Buffer.alloc(0);
                    var i;
                    if (length === undefined) {
                        length = 0;
                        for(i = 0; i < list.length; ++i)length += list[i].length;
                    }
                    var buffer = Buffer.allocUnsafe(length);
                    var pos = 0;
                    for(i = 0; i < list.length; ++i){
                        var buf = list[i];
                        if (isInstance(buf, Uint8Array)) {
                            if (pos + buf.length > buffer.length) {
                                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                                buf.copy(buffer, pos);
                            } else Uint8Array.prototype.set.call(buffer, buf, pos);
                        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                        else buf.copy(buffer, pos);
                        pos += buf.length;
                    }
                    return buffer;
                };
                function byteLength(string, encoding) {
                    if (Buffer.isBuffer(string)) return string.length;
                    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
                    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
                    var len = string.length;
                    var mustMatch = arguments.length > 2 && arguments[2] === true;
                    if (!mustMatch && len === 0) return 0;
                    // Use a for loop to avoid recursion
                    var loweredCase = false;
                    for(;;)switch(encoding){
                        case 'ascii':
                        case 'latin1':
                        case 'binary':
                            return len;
                        case 'utf8':
                        case 'utf-8':
                            return utf8ToBytes(string).length;
                        case 'ucs2':
                        case 'ucs-2':
                        case 'utf16le':
                        case 'utf-16le':
                            return len * 2;
                        case 'hex':
                            return len >>> 1;
                        case 'base64':
                            return base64ToBytes(string).length;
                        default:
                            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                            encoding = ('' + encoding).toLowerCase();
                            loweredCase = true;
                    }
                }
                Buffer.byteLength = byteLength;
                function slowToString(encoding, start, end) {
                    var loweredCase = false;
                    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
                    // property of a typed array.
                    // This behaves neither like String nor Uint8Array in that we set start/end
                    // to their upper/lower bounds if the value passed is out of range.
                    // undefined is handled specially as per ECMA-262 6th Edition,
                    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
                    if (start === undefined || start < 0) start = 0;
                    // Return early if start > this.length. Done here to prevent potential uint32
                    // coercion fail below.
                    if (start > this.length) return '';
                    if (end === undefined || end > this.length) end = this.length;
                    if (end <= 0) return '';
                    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
                    end >>>= 0;
                    start >>>= 0;
                    if (end <= start) return '';
                    if (!encoding) encoding = 'utf8';
                    while(true)switch(encoding){
                        case 'hex':
                            return hexSlice(this, start, end);
                        case 'utf8':
                        case 'utf-8':
                            return utf8Slice(this, start, end);
                        case 'ascii':
                            return asciiSlice(this, start, end);
                        case 'latin1':
                        case 'binary':
                            return latin1Slice(this, start, end);
                        case 'base64':
                            return base64Slice(this, start, end);
                        case 'ucs2':
                        case 'ucs-2':
                        case 'utf16le':
                        case 'utf-16le':
                            return utf16leSlice(this, start, end);
                        default:
                            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                            encoding = (encoding + '').toLowerCase();
                            loweredCase = true;
                    }
                }
                // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
                // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
                // reliably in a browserify context because there could be multiple different
                // copies of the 'buffer' package in use. This method works even for Buffer
                // instances that were created from another copy of the `buffer` package.
                // See: https://github.com/feross/buffer/issues/154
                Buffer.prototype._isBuffer = true;
                function swap(b, n, m) {
                    var i = b[n];
                    b[n] = b[m];
                    b[m] = i;
                }
                Buffer.prototype.swap16 = function swap16() {
                    var len = this.length;
                    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
                    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
                    return this;
                };
                Buffer.prototype.swap32 = function swap32() {
                    var len = this.length;
                    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
                    for(var i = 0; i < len; i += 4){
                        swap(this, i, i + 3);
                        swap(this, i + 1, i + 2);
                    }
                    return this;
                };
                Buffer.prototype.swap64 = function swap64() {
                    var len = this.length;
                    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
                    for(var i = 0; i < len; i += 8){
                        swap(this, i, i + 7);
                        swap(this, i + 1, i + 6);
                        swap(this, i + 2, i + 5);
                        swap(this, i + 3, i + 4);
                    }
                    return this;
                };
                Buffer.prototype.toString = function toString() {
                    var length = this.length;
                    if (length === 0) return '';
                    if (arguments.length === 0) return utf8Slice(this, 0, length);
                    return slowToString.apply(this, arguments);
                };
                Buffer.prototype.toLocaleString = Buffer.prototype.toString;
                Buffer.prototype.equals = function equals(b) {
                    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
                    if (this === b) return true;
                    return Buffer.compare(this, b) === 0;
                };
                Buffer.prototype.inspect = function inspect() {
                    var str = '';
                    var max = exports.INSPECT_MAX_BYTES;
                    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
                    if (this.length > max) str += ' ... ';
                    return '<Buffer ' + str + '>';
                };
                if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
                Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
                    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
                    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
                    if (start === undefined) start = 0;
                    if (end === undefined) end = target ? target.length : 0;
                    if (thisStart === undefined) thisStart = 0;
                    if (thisEnd === undefined) thisEnd = this.length;
                    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
                    if (thisStart >= thisEnd && start >= end) return 0;
                    if (thisStart >= thisEnd) return -1;
                    if (start >= end) return 1;
                    start >>>= 0;
                    end >>>= 0;
                    thisStart >>>= 0;
                    thisEnd >>>= 0;
                    if (this === target) return 0;
                    var x = thisEnd - thisStart;
                    var y = end - start;
                    var len = Math.min(x, y);
                    var thisCopy = this.slice(thisStart, thisEnd);
                    var targetCopy = target.slice(start, end);
                    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                        x = thisCopy[i];
                        y = targetCopy[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                };
                // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
                // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
                //
                // Arguments:
                // - buffer - a Buffer to search
                // - val - a string, Buffer, or number
                // - byteOffset - an index into `buffer`; will be clamped to an int32
                // - encoding - an optional encoding, relevant is val is a string
                // - dir - true for indexOf, false for lastIndexOf
                function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
                    // Empty buffer means no match
                    if (buffer.length === 0) return -1;
                    // Normalize byteOffset
                    if (typeof byteOffset === 'string') {
                        encoding = byteOffset;
                        byteOffset = 0;
                    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
                    else if (byteOffset < -2147483648) byteOffset = -2147483648;
                    byteOffset = +byteOffset; // Coerce to Number.
                    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                    byteOffset = dir ? 0 : buffer.length - 1;
                    // Normalize byteOffset: negative offsets start from the end of the buffer
                    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
                    if (byteOffset >= buffer.length) {
                        if (dir) return -1;
                        else byteOffset = buffer.length - 1;
                    } else if (byteOffset < 0) {
                        if (dir) byteOffset = 0;
                        else return -1;
                    }
                    // Normalize val
                    if (typeof val === 'string') val = Buffer.from(val, encoding);
                    // Finally, search either indexOf (if dir is true) or lastIndexOf
                    if (Buffer.isBuffer(val)) {
                        // Special case: looking for empty string/buffer always fails
                        if (val.length === 0) return -1;
                        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
                    } else if (typeof val === 'number') {
                        val = val & 0xFF; // Search for a byte value [0-255]
                        if (typeof Uint8Array.prototype.indexOf === 'function') {
                            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                        }
                        return arrayIndexOf(buffer, [
                            val
                        ], byteOffset, encoding, dir);
                    }
                    throw new TypeError('val must be string, number or Buffer');
                }
                function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
                    var indexSize = 1;
                    var arrLength = arr.length;
                    var valLength = val.length;
                    if (encoding !== undefined) {
                        encoding = String(encoding).toLowerCase();
                        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                            if (arr.length < 2 || val.length < 2) return -1;
                            indexSize = 2;
                            arrLength /= 2;
                            valLength /= 2;
                            byteOffset /= 2;
                        }
                    }
                    function read(buf, i) {
                        if (indexSize === 1) return buf[i];
                        else return buf.readUInt16BE(i * indexSize);
                    }
                    var i;
                    if (dir) {
                        var foundIndex = -1;
                        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                            if (foundIndex === -1) foundIndex = i;
                            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                        } else {
                            if (foundIndex !== -1) i -= i - foundIndex;
                            foundIndex = -1;
                        }
                    } else {
                        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                        for(i = byteOffset; i >= 0; i--){
                            var found = true;
                            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                                found = false;
                                break;
                            }
                            if (found) return i;
                        }
                    }
                    return -1;
                }
                Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
                    return this.indexOf(val, byteOffset, encoding) !== -1;
                };
                Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
                    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
                };
                Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
                    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
                };
                function hexWrite(buf, string, offset, length) {
                    offset = Number(offset) || 0;
                    var remaining = buf.length - offset;
                    if (!length) length = remaining;
                    else {
                        length = Number(length);
                        if (length > remaining) length = remaining;
                    }
                    var strLen = string.length;
                    if (length > strLen / 2) length = strLen / 2;
                    var i;
                    for(i = 0; i < length; ++i){
                        var parsed = parseInt(string.substr(i * 2, 2), 16);
                        if (numberIsNaN(parsed)) return i;
                        buf[offset + i] = parsed;
                    }
                    return i;
                }
                function utf8Write(buf, string, offset, length) {
                    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
                }
                function asciiWrite(buf, string, offset, length) {
                    return blitBuffer(asciiToBytes(string), buf, offset, length);
                }
                function base64Write(buf, string, offset, length) {
                    return blitBuffer(base64ToBytes(string), buf, offset, length);
                }
                function ucs2Write(buf, string, offset, length) {
                    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
                }
                Buffer.prototype.write = function write(string, offset, length, encoding) {
                    // Buffer#write(string)
                    if (offset === undefined) {
                        encoding = 'utf8';
                        length = this.length;
                        offset = 0;
                    // Buffer#write(string, encoding)
                    } else if (length === undefined && typeof offset === 'string') {
                        encoding = offset;
                        length = this.length;
                        offset = 0;
                    // Buffer#write(string, offset[, length][, encoding])
                    } else if (isFinite(offset)) {
                        offset = offset >>> 0;
                        if (isFinite(length)) {
                            length = length >>> 0;
                            if (encoding === undefined) encoding = 'utf8';
                        } else {
                            encoding = length;
                            length = undefined;
                        }
                    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
                    var remaining = this.length - offset;
                    if (length === undefined || length > remaining) length = remaining;
                    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
                    if (!encoding) encoding = 'utf8';
                    var loweredCase = false;
                    for(;;)switch(encoding){
                        case 'hex':
                            return hexWrite(this, string, offset, length);
                        case 'utf8':
                        case 'utf-8':
                            return utf8Write(this, string, offset, length);
                        case 'ascii':
                        case 'latin1':
                        case 'binary':
                            return asciiWrite(this, string, offset, length);
                        case 'base64':
                            // Warning: maxLength not taken into account in base64Write
                            return base64Write(this, string, offset, length);
                        case 'ucs2':
                        case 'ucs-2':
                        case 'utf16le':
                        case 'utf-16le':
                            return ucs2Write(this, string, offset, length);
                        default:
                            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                            encoding = ('' + encoding).toLowerCase();
                            loweredCase = true;
                    }
                };
                Buffer.prototype.toJSON = function toJSON() {
                    return {
                        type: 'Buffer',
                        data: Array.prototype.slice.call(this._arr || this, 0)
                    };
                };
                function base64Slice(buf, start, end) {
                    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
                    else return base64.fromByteArray(buf.slice(start, end));
                }
                function utf8Slice(buf, start, end) {
                    end = Math.min(buf.length, end);
                    var res = [];
                    var i = start;
                    while(i < end){
                        var firstByte = buf[i];
                        var codePoint = null;
                        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
                        if (i + bytesPerSequence <= end) {
                            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
                            switch(bytesPerSequence){
                                case 1:
                                    if (firstByte < 0x80) codePoint = firstByte;
                                    break;
                                case 2:
                                    secondByte = buf[i + 1];
                                    if ((secondByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                                    }
                                    break;
                                case 3:
                                    secondByte = buf[i + 1];
                                    thirdByte = buf[i + 2];
                                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                                    }
                                    break;
                                case 4:
                                    secondByte = buf[i + 1];
                                    thirdByte = buf[i + 2];
                                    fourthByte = buf[i + 3];
                                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                                    }
                            }
                        }
                        if (codePoint === null) {
                            // we did not generate a valid codePoint so insert a
                            // replacement char (U+FFFD) and advance only 1 byte
                            codePoint = 0xFFFD;
                            bytesPerSequence = 1;
                        } else if (codePoint > 0xFFFF) {
                            // encode to utf16 (surrogate pair dance)
                            codePoint -= 0x10000;
                            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                            codePoint = 0xDC00 | codePoint & 0x3FF;
                        }
                        res.push(codePoint);
                        i += bytesPerSequence;
                    }
                    return decodeCodePointsArray(res);
                }
                // Based on http://stackoverflow.com/a/22747272/680742, the browser with
                // the lowest limit is Chrome, with 0x10000 args.
                // We go 1 magnitude less, for safety
                var MAX_ARGUMENTS_LENGTH = 0x1000;
                function decodeCodePointsArray(codePoints) {
                    var len = codePoints.length;
                    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
                    // Decode in chunks to avoid "call stack size exceeded".
                    var res = '';
                    var i = 0;
                    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
                    return res;
                }
                function asciiSlice(buf, start, end) {
                    var ret = '';
                    end = Math.min(buf.length, end);
                    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
                    return ret;
                }
                function latin1Slice(buf, start, end) {
                    var ret = '';
                    end = Math.min(buf.length, end);
                    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
                    return ret;
                }
                function hexSlice(buf, start, end) {
                    var len = buf.length;
                    if (!start || start < 0) start = 0;
                    if (!end || end < 0 || end > len) end = len;
                    var out = '';
                    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
                    return out;
                }
                function utf16leSlice(buf, start, end) {
                    var bytes = buf.slice(start, end);
                    var res = '';
                    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
                    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
                    return res;
                }
                Buffer.prototype.slice = function slice(start, end) {
                    var len = this.length;
                    start = ~~start;
                    end = end === undefined ? len : ~~end;
                    if (start < 0) {
                        start += len;
                        if (start < 0) start = 0;
                    } else if (start > len) start = len;
                    if (end < 0) {
                        end += len;
                        if (end < 0) end = 0;
                    } else if (end > len) end = len;
                    if (end < start) end = start;
                    var newBuf = this.subarray(start, end);
                    // Return an augmented `Uint8Array` instance
                    Object.setPrototypeOf(newBuf, Buffer.prototype);
                    return newBuf;
                };
                /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
                    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
                    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
                }
                Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset];
                    var mul = 1;
                    var i = 0;
                    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                    return val;
                };
                Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset + --byteLength];
                    var mul = 1;
                    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
                    return val;
                };
                Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 1, this.length);
                    return this[offset];
                };
                Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    return this[offset] | this[offset + 1] << 8;
                };
                Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    return this[offset] << 8 | this[offset + 1];
                };
                Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
                };
                Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
                };
                Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
                    offset = offset >>> 0;
                    validateNumber(offset, 'offset');
                    var first = this[offset];
                    var last = this[offset + 7];
                    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
                    var lo = first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
                    var hi = this[++offset] + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
                    return BigInt(lo) + (BigInt(hi) << BigInt(32));
                });
                Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
                    offset = offset >>> 0;
                    validateNumber(offset, 'offset');
                    var first = this[offset];
                    var last = this[offset + 7];
                    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
                    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
                    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last;
                    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
                });
                Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset];
                    var mul = 1;
                    var i = 0;
                    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                    mul *= 0x80;
                    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                    return val;
                };
                Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var i = byteLength;
                    var mul = 1;
                    var val = this[offset + --i];
                    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
                    mul *= 0x80;
                    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                    return val;
                };
                Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 1, this.length);
                    if (!(this[offset] & 0x80)) return this[offset];
                    return (0xff - this[offset] + 1) * -1;
                };
                Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    var val = this[offset] | this[offset + 1] << 8;
                    return val & 0x8000 ? val | 0xFFFF0000 : val;
                };
                Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    var val = this[offset + 1] | this[offset] << 8;
                    return val & 0x8000 ? val | 0xFFFF0000 : val;
                };
                Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
                };
                Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
                };
                Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
                    offset = offset >>> 0;
                    validateNumber(offset, 'offset');
                    var first = this[offset];
                    var last = this[offset + 7];
                    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
                    var val = this[offset + 4] + this[offset + 5] * Math.pow(2, 8) + this[offset + 6] * Math.pow(2, 16) + (last << 24); // Overflow
                    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
                });
                Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
                    offset = offset >>> 0;
                    validateNumber(offset, 'offset');
                    var first = this[offset];
                    var last = this[offset + 7];
                    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
                    var val = (first << 24) + // Overflow
                    this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
                    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last);
                });
                Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return ieee754.read(this, offset, true, 23, 4);
                };
                Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return ieee754.read(this, offset, false, 23, 4);
                };
                Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 8, this.length);
                    return ieee754.read(this, offset, true, 52, 8);
                };
                Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 8, this.length);
                    return ieee754.read(this, offset, false, 52, 8);
                };
                function checkInt(buf, value, offset, ext, max, min) {
                    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
                    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
                    if (offset + ext > buf.length) throw new RangeError('Index out of range');
                }
                Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                        checkInt(this, value, offset, byteLength, maxBytes, 0);
                    }
                    var mul = 1;
                    var i = 0;
                    this[offset] = value & 0xFF;
                    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                    return offset + byteLength;
                };
                Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                        checkInt(this, value, offset, byteLength, maxBytes, 0);
                    }
                    var i = byteLength - 1;
                    var mul = 1;
                    this[offset + i] = value & 0xFF;
                    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                    return offset + byteLength;
                };
                Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
                    this[offset] = value & 0xff;
                    return offset + 1;
                };
                Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    return offset + 2;
                };
                Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                    this[offset] = value >>> 8;
                    this[offset + 1] = value & 0xff;
                    return offset + 2;
                };
                Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                    this[offset + 3] = value >>> 24;
                    this[offset + 2] = value >>> 16;
                    this[offset + 1] = value >>> 8;
                    this[offset] = value & 0xff;
                    return offset + 4;
                };
                Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                    this[offset] = value >>> 24;
                    this[offset + 1] = value >>> 16;
                    this[offset + 2] = value >>> 8;
                    this[offset + 3] = value & 0xff;
                    return offset + 4;
                };
                function wrtBigUInt64LE(buf, value, offset, min, max) {
                    checkIntBI(value, min, max, buf, offset, 7);
                    var lo = Number(value & BigInt(0xffffffff));
                    buf[offset++] = lo;
                    lo = lo >> 8;
                    buf[offset++] = lo;
                    lo = lo >> 8;
                    buf[offset++] = lo;
                    lo = lo >> 8;
                    buf[offset++] = lo;
                    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
                    buf[offset++] = hi;
                    hi = hi >> 8;
                    buf[offset++] = hi;
                    hi = hi >> 8;
                    buf[offset++] = hi;
                    hi = hi >> 8;
                    buf[offset++] = hi;
                    return offset;
                }
                function wrtBigUInt64BE(buf, value, offset, min, max) {
                    checkIntBI(value, min, max, buf, offset, 7);
                    var lo = Number(value & BigInt(0xffffffff));
                    buf[offset + 7] = lo;
                    lo = lo >> 8;
                    buf[offset + 6] = lo;
                    lo = lo >> 8;
                    buf[offset + 5] = lo;
                    lo = lo >> 8;
                    buf[offset + 4] = lo;
                    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
                    buf[offset + 3] = hi;
                    hi = hi >> 8;
                    buf[offset + 2] = hi;
                    hi = hi >> 8;
                    buf[offset + 1] = hi;
                    hi = hi >> 8;
                    buf[offset] = hi;
                    return offset + 8;
                }
                Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset) {
                    if (offset === void 0) offset = 0;
                    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
                });
                Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset) {
                    if (offset === void 0) offset = 0;
                    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
                });
                Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) {
                        var limit = Math.pow(2, 8 * byteLength - 1);
                        checkInt(this, value, offset, byteLength, limit - 1, -limit);
                    }
                    var i = 0;
                    var mul = 1;
                    var sub = 0;
                    this[offset] = value & 0xFF;
                    while(++i < byteLength && (mul *= 0x100)){
                        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                    }
                    return offset + byteLength;
                };
                Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) {
                        var limit = Math.pow(2, 8 * byteLength - 1);
                        checkInt(this, value, offset, byteLength, limit - 1, -limit);
                    }
                    var i = byteLength - 1;
                    var mul = 1;
                    var sub = 0;
                    this[offset + i] = value & 0xFF;
                    while(--i >= 0 && (mul *= 0x100)){
                        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                    }
                    return offset + byteLength;
                };
                Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
                    if (value < 0) value = 0xff + value + 1;
                    this[offset] = value & 0xff;
                    return offset + 1;
                };
                Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    return offset + 2;
                };
                Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                    this[offset] = value >>> 8;
                    this[offset + 1] = value & 0xff;
                    return offset + 2;
                };
                Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    this[offset + 2] = value >>> 16;
                    this[offset + 3] = value >>> 24;
                    return offset + 4;
                };
                Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                    if (value < 0) value = 0xffffffff + value + 1;
                    this[offset] = value >>> 24;
                    this[offset + 1] = value >>> 16;
                    this[offset + 2] = value >>> 8;
                    this[offset + 3] = value & 0xff;
                    return offset + 4;
                };
                Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset) {
                    if (offset === void 0) offset = 0;
                    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
                });
                Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset) {
                    if (offset === void 0) offset = 0;
                    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
                });
                function checkIEEE754(buf, value, offset, ext, max, min) {
                    if (offset + ext > buf.length) throw new RangeError('Index out of range');
                    if (offset < 0) throw new RangeError('Index out of range');
                }
                function writeFloat(buf, value, offset, littleEndian, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
                    ieee754.write(buf, value, offset, littleEndian, 23, 4);
                    return offset + 4;
                }
                Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
                    return writeFloat(this, value, offset, true, noAssert);
                };
                Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
                    return writeFloat(this, value, offset, false, noAssert);
                };
                function writeDouble(buf, value, offset, littleEndian, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
                    ieee754.write(buf, value, offset, littleEndian, 52, 8);
                    return offset + 8;
                }
                Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
                    return writeDouble(this, value, offset, true, noAssert);
                };
                Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
                    return writeDouble(this, value, offset, false, noAssert);
                };
                // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
                Buffer.prototype.copy = function copy(target, targetStart, start, end) {
                    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
                    if (!start) start = 0;
                    if (!end && end !== 0) end = this.length;
                    if (targetStart >= target.length) targetStart = target.length;
                    if (!targetStart) targetStart = 0;
                    if (end > 0 && end < start) end = start;
                    // Copy 0 bytes; we're done
                    if (end === start) return 0;
                    if (target.length === 0 || this.length === 0) return 0;
                    // Fatal error conditions
                    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
                    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
                    if (end < 0) throw new RangeError('sourceEnd out of bounds');
                    // Are we oob?
                    if (end > this.length) end = this.length;
                    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
                    var len = end - start;
                    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
                    this.copyWithin(targetStart, start, end);
                    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
                    return len;
                };
                // Usage:
                //    buffer.fill(number[, offset[, end]])
                //    buffer.fill(buffer[, offset[, end]])
                //    buffer.fill(string[, offset[, end]][, encoding])
                Buffer.prototype.fill = function fill(val, start, end, encoding) {
                    // Handle string cases:
                    if (typeof val === 'string') {
                        if (typeof start === 'string') {
                            encoding = start;
                            start = 0;
                            end = this.length;
                        } else if (typeof end === 'string') {
                            encoding = end;
                            end = this.length;
                        }
                        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
                        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
                        if (val.length === 1) {
                            var code = val.charCodeAt(0);
                            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
                            val = code;
                        }
                    } else if (typeof val === 'number') val = val & 255;
                    else if (typeof val === 'boolean') val = Number(val);
                    // Invalid ranges are not set to a default, so can range check early.
                    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
                    if (end <= start) return this;
                    start = start >>> 0;
                    end = end === undefined ? this.length : end >>> 0;
                    if (!val) val = 0;
                    var i;
                    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
                    else {
                        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
                        var len = bytes.length;
                        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
                    }
                    return this;
                };
                // CUSTOM ERRORS
                // =============
                // Simplified versions from Node, changed for Buffer-only usage
                var errors = {};
                function E(sym, getMessage, Base) {
                    errors[sym] = /*#__PURE__*/ function(_Base) {
                        function NodeError() {
                            var _this;
                            _this = _Base.call(this) || this;
                            Object.defineProperty(_this, 'message', {
                                value: getMessage.apply(_this, arguments),
                                writable: true,
                                configurable: true
                            });
                            // Add the error code to the name to include it in the stack trace.
                            _this.name = _this.name + " [" + sym + "]";
                            // Access the stack to generate the error message including the error code
                            // from the name.
                            _this.stack; // eslint-disable-line no-unused-expressions
                            // Reset the name to the actual name.
                            delete _this.name;
                            return _this;
                        }
                        _inheritsLoose(NodeError, _Base);
                        var _proto = NodeError.prototype;
                        _proto.toString = function toString() {
                            return this.name + " [" + sym + "]: " + this.message;
                        };
                        return _createClass(NodeError, [
                            {
                                key: "code",
                                get: function get() {
                                    return sym;
                                },
                                set: function set(value) {
                                    Object.defineProperty(this, 'code', {
                                        configurable: true,
                                        enumerable: true,
                                        value: value,
                                        writable: true
                                    });
                                }
                            }
                        ]);
                    }(Base);
                }
                E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
                    if (name) return name + " is outside of buffer bounds";
                    return 'Attempt to access memory outside buffer bounds';
                }, RangeError);
                E('ERR_INVALID_ARG_TYPE', function(name, actual) {
                    return "The \"" + name + "\" argument must be of type number. Received type " + typeof actual;
                }, TypeError);
                E('ERR_OUT_OF_RANGE', function(str, range, input) {
                    var msg = "The value of \"" + str + "\" is out of range.";
                    var received = input;
                    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = addNumericalSeparator(String(input));
                    else if (typeof input === 'bigint') {
                        received = String(input);
                        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = addNumericalSeparator(received);
                        received += 'n';
                    }
                    msg += " It must be " + range + ". Received " + received;
                    return msg;
                }, RangeError);
                function addNumericalSeparator(val) {
                    var res = '';
                    var i = val.length;
                    var start = val[0] === '-' ? 1 : 0;
                    for(; i >= start + 4; i -= 3)res = "_" + val.slice(i - 3, i) + res;
                    return "" + val.slice(0, i) + res;
                }
                // CHECK FUNCTIONS
                // ===============
                function checkBounds(buf, offset, byteLength) {
                    validateNumber(offset, 'offset');
                    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
                }
                function checkIntBI(value, min, max, buf, offset, byteLength) {
                    if (value > max || value < min) {
                        var n = typeof min === 'bigint' ? 'n' : '';
                        var range;
                        if (byteLength > 3) {
                            if (min === 0 || min === BigInt(0)) range = ">= 0" + n + " and < 2" + n + " ** " + (byteLength + 1) * 8 + n;
                            else range = ">= -(2" + n + " ** " + ((byteLength + 1) * 8 - 1) + n + ") and < 2 ** " + ("" + ((byteLength + 1) * 8 - 1) + n);
                        } else range = ">= " + min + n + " and <= " + max + n;
                        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
                    }
                    checkBounds(buf, offset, byteLength);
                }
                function validateNumber(value, name) {
                    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
                }
                function boundsError(value, length, type) {
                    if (Math.floor(value) !== value) {
                        validateNumber(value, type);
                        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
                    }
                    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
                    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', ">= " + (type ? 1 : 0) + " and <= " + length, value);
                }
                // HELPER FUNCTIONS
                // ================
                var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
                function base64clean(str) {
                    // Node takes equal signs as end of the Base64 encoding
                    str = str.split('=')[0];
                    // Node strips out invalid characters like \n and \t from the string, base64-js does not
                    str = str.trim().replace(INVALID_BASE64_RE, '');
                    // Node converts strings with length < 2 to ''
                    if (str.length < 2) return '';
                    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
                    while(str.length % 4 !== 0)str = str + '=';
                    return str;
                }
                function utf8ToBytes(string, units) {
                    units = units || Infinity;
                    var codePoint;
                    var length = string.length;
                    var leadSurrogate = null;
                    var bytes = [];
                    for(var i = 0; i < length; ++i){
                        codePoint = string.charCodeAt(i);
                        // is surrogate component
                        if (codePoint > 0xD7FF && codePoint < 0xE000) {
                            // last char was a lead
                            if (!leadSurrogate) {
                                // no lead yet
                                if (codePoint > 0xDBFF) {
                                    // unexpected trail
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                    continue;
                                } else if (i + 1 === length) {
                                    // unpaired lead
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                    continue;
                                }
                                // valid lead
                                leadSurrogate = codePoint;
                                continue;
                            }
                            // 2 leads in a row
                            if (codePoint < 0xDC00) {
                                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                leadSurrogate = codePoint;
                                continue;
                            }
                            // valid surrogate pair
                            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
                        } else if (leadSurrogate) // valid bmp char, but last char was a lead
                        {
                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        }
                        leadSurrogate = null;
                        // encode utf8
                        if (codePoint < 0x80) {
                            if ((units -= 1) < 0) break;
                            bytes.push(codePoint);
                        } else if (codePoint < 0x800) {
                            if ((units -= 2) < 0) break;
                            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
                        } else if (codePoint < 0x10000) {
                            if ((units -= 3) < 0) break;
                            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                        } else if (codePoint < 0x110000) {
                            if ((units -= 4) < 0) break;
                            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                        } else throw new Error('Invalid code point');
                    }
                    return bytes;
                }
                function asciiToBytes(str) {
                    var byteArray = [];
                    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
                    byteArray.push(str.charCodeAt(i) & 0xFF);
                    return byteArray;
                }
                function utf16leToBytes(str, units) {
                    var c, hi, lo;
                    var byteArray = [];
                    for(var i = 0; i < str.length; ++i){
                        if ((units -= 2) < 0) break;
                        c = str.charCodeAt(i);
                        hi = c >> 8;
                        lo = c % 256;
                        byteArray.push(lo);
                        byteArray.push(hi);
                    }
                    return byteArray;
                }
                function base64ToBytes(str) {
                    return base64.toByteArray(base64clean(str));
                }
                function blitBuffer(src, dst, offset, length) {
                    var i;
                    for(i = 0; i < length; ++i){
                        if (i + offset >= dst.length || i >= src.length) break;
                        dst[i + offset] = src[i];
                    }
                    return i;
                }
                // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
                // the `instanceof` check but they should be treated as of that type.
                // See: https://github.com/feross/buffer/issues/166
                function isInstance(obj, type) {
                    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
                }
                function numberIsNaN(obj) {
                    // For IE11 support
                    return obj !== obj; // eslint-disable-line no-self-compare
                }
                // Create lookup table for `toString('hex')`
                // See: https://github.com/feross/buffer/issues/219
                var hexSliceLookupTable = function() {
                    var alphabet = '0123456789abcdef';
                    var table = new Array(256);
                    for(var i = 0; i < 16; ++i){
                        var i16 = i * 16;
                        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
                    }
                    return table;
                }();
                // Return not function with Error if BigInt not supported
                function defineBigIntMethod(fn) {
                    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
                }
                function BufferBigIntNotDefined() {
                    throw new Error('BigInt not supported');
                }
            /***/ },
            /***/ 14623: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(39081);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    /**
   * ISO/IEC 9797-1 Padding Method 2.
   */ CryptoJS.pad.Iso97971 = {
                        pad: function pad(data, blockSize) {
                            // Add 0x80 byte
                            data.concat(CryptoJS.lib.WordArray.create([
                                0x80000000
                            ], 1));
                            // Zero pad the rest
                            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
                        },
                        unpad: function unpad(data) {
                            // Remove zero padding
                            CryptoJS.pad.ZeroPadding.unpad(data);
                            // Remove one more byte -- the 0x80 byte
                            data.sigBytes--;
                        }
                    };
                    return CryptoJS.pad.Iso97971;
                });
            /***/ },
            /***/ 14903: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(9964);
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a duplex stream is just a stream that is both readable and writable.
                // Since JS doesn't have multiple prototypal inheritance, this class
                // prototypally inherits from Readable, and then parasitically from
                // Writable.
                /*<replacement>*/ var objectKeys = Object.keys || function(obj) {
                    var keys = [];
                    for(var key in obj)keys.push(key);
                    return keys;
                };
                /*</replacement>*/ module1.exports = Duplex;
                var Readable = __webpack_require__(88261);
                var Writable = __webpack_require__(29781);
                __webpack_require__(89784)(Duplex, Readable);
                // Allow the keys array to be GC'ed.
                var keys = objectKeys(Writable.prototype);
                for(var v = 0; v < keys.length; v++){
                    var method = keys[v];
                    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
                }
                function Duplex(options) {
                    if (!(this instanceof Duplex)) return new Duplex(options);
                    Readable.call(this, options);
                    Writable.call(this, options);
                    this.allowHalfOpen = true;
                    if (options) {
                        if (options.readable === false) this.readable = false;
                        if (options.writable === false) this.writable = false;
                        if (options.allowHalfOpen === false) {
                            this.allowHalfOpen = false;
                            this.once('end', onend);
                        }
                    }
                }
                Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState.highWaterMark;
                    }
                });
                Object.defineProperty(Duplex.prototype, 'writableBuffer', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState && this._writableState.getBuffer();
                    }
                });
                Object.defineProperty(Duplex.prototype, 'writableLength', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState.length;
                    }
                });
                // the no-half-open enforcer
                function onend() {
                    // If the writable side ended, then we're ok.
                    if (this._writableState.ended) return;
                    // no more data can be written.
                    // But allow more writes to happen in this tick.
                    process.nextTick(onEndNT, this);
                }
                function onEndNT(self1) {
                    self1.end();
                }
                Object.defineProperty(Duplex.prototype, 'destroyed', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        if (this._readableState === undefined || this._writableState === undefined) return false;
                        return this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function set(value) {
                        // we ignore the value if the stream
                        // has not been initialized yet
                        if (this._readableState === undefined || this._writableState === undefined) return;
                        // backward compatibility, the user is explicitly
                        // managing destroyed
                        this._readableState.destroyed = value;
                        this._writableState.destroyed = value;
                    }
                });
            /***/ },
            /***/ 15216: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var defineProperty = __webpack_require__(95892).f;
                var hasOwn = __webpack_require__(20340);
                var wellKnownSymbol = __webpack_require__(38688);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                module1.exports = function(it, TAG, STATIC) {
                    if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) defineProperty(it, TO_STRING_TAG, {
                        configurable: true,
                        value: TAG
                    });
                };
            /***/ },
            /***/ 15293: /***/ function(module1) {
                "use strict";
                /** @type {import('.')} */ module1.exports = Error;
            /***/ },
            /***/ 15341: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var redefine = __webpack_require__(13711);
                module1.exports = function(target, src, options) {
                    for(var key in src)redefine(target, key, src[key], options);
                    return target;
                };
            /***/ },
            /***/ 15366: /***/ function(module1) {
                module1.exports = {};
            /***/ },
            /***/ 15548: /***/ function(module1, exports, __webpack_require__) {
                var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
                (function(a, b) {
                    __WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = b, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this, function() {
                    "use strict";
                    function b(a, b) {
                        return "undefined" == typeof b ? b = {
                            autoBom: !1
                        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
                            autoBom: !b
                        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
                            "\uFEFF",
                            a
                        ], {
                            type: a.type
                        }) : a;
                    }
                    function c(a, b, c) {
                        var d = new XMLHttpRequest;
                        d.open("GET", a), d.responseType = "blob", d.onload = function() {
                            g(d.response, b, c);
                        }, d.onerror = function() {
                            console.error("could not download file");
                        }, d.send();
                    }
                    function d(a) {
                        var b = new XMLHttpRequest;
                        b.open("HEAD", a, !1);
                        try {
                            b.send();
                        } catch (a) {}
                        return 200 <= b.status && 299 >= b.status;
                    }
                    function e(a) {
                        try {
                            a.dispatchEvent(new MouseEvent("click"));
                        } catch (c) {
                            var b = document.createEvent("MouseEvents");
                            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
                        }
                    }
                    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof __webpack_require__.g && __webpack_require__.g.global === __webpack_require__.g ? __webpack_require__.g : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : typeof HTMLAnchorElement !== "undefined" && "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
                        var i = f.URL || f.webkitURL, j = document.createElement("a");
                        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
                            i.revokeObjectURL(j.href);
                        }, 4E4), setTimeout(function() {
                            e(j);
                        }, 0));
                    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
                        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
                        else if (d(f)) c(f, g, h);
                        else {
                            var i = document.createElement("a");
                            i.href = f, i.target = "_blank", setTimeout(function() {
                                e(i);
                            });
                        }
                    } : function(b, d, e, g) {
                        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
                        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
                        if ((j || h && i || a) && "undefined" != typeof FileReader) {
                            var k = new FileReader;
                            k.onloadend = function() {
                                var a = k.result;
                                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
                            }, k.readAsDataURL(b);
                        } else {
                            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
                            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                                l.revokeObjectURL(m);
                            }, 4E4);
                        }
                    });
                    f.saveAs = g.saveAs = g, module1.exports = g;
                });
            /***/ },
            /***/ 15567: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(47044);
                // Detect IE8's incomplete defineProperty implementation
                module1.exports = !fails(function() {
                    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
                    return Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1] != 7;
                });
            /***/ },
            /***/ 15892: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var call = __webpack_require__(2834);
                var aCallable = __webpack_require__(32631);
                var anObject = __webpack_require__(34984);
                var tryToString = __webpack_require__(68664);
                var getIteratorMethod = __webpack_require__(13872);
                var TypeError1 = global.TypeError;
                module1.exports = function(argument, usingIterator) {
                    var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
                    if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
                    throw TypeError1(tryToString(argument) + ' is not iterable');
                };
            /***/ },
            /***/ 16190: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(94845);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var C_enc = C.enc;
                        /**
     * Base64url encoding strategy.
     */ var Base64url = C_enc.Base64url = {
                            /**
       * Converts a word array to a Base64url string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @param {boolean} urlSafe Whether to use url safe
       *
       * @return {string} The Base64url string.
       *
       * @static
       *
       * @example
       *
       *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
       */ stringify: function stringify(wordArray, urlSafe) {
                                if (urlSafe === undefined) urlSafe = true;
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                var map = urlSafe ? this._safe_map : this._map;
                                // Clamp excess bits
                                wordArray.clamp();
                                // Convert
                                var base64Chars = [];
                                for(var i = 0; i < sigBytes; i += 3){
                                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                                }
                                // Add padding
                                var paddingChar = map.charAt(64);
                                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                                return base64Chars.join('');
                            },
                            /**
       * Converts a Base64url string to a word array.
       *
       * @param {string} base64Str The Base64url string.
       *
       * @param {boolean} urlSafe Whether to use url safe
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
       */ parse: function parse(base64Str, urlSafe) {
                                if (urlSafe === undefined) urlSafe = true;
                                // Shortcuts
                                var base64StrLength = base64Str.length;
                                var map = urlSafe ? this._safe_map : this._map;
                                var reverseMap = this._reverseMap;
                                if (!reverseMap) {
                                    reverseMap = this._reverseMap = [];
                                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                                }
                                // Ignore padding
                                var paddingChar = map.charAt(64);
                                if (paddingChar) {
                                    var paddingIndex = base64Str.indexOf(paddingChar);
                                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                                }
                                // Convert
                                return parseLoop(base64Str, base64StrLength, reverseMap);
                            },
                            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
                            _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
                        };
                        function parseLoop(base64Str, base64StrLength, reverseMap) {
                            var words = [];
                            var nBytes = 0;
                            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                                var bitsCombined = bits1 | bits2;
                                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                                nBytes++;
                            }
                            return WordArray.create(words, nBytes);
                        }
                    })();
                    return CryptoJS.enc.Base64url;
                });
            /***/ },
            /***/ 16403: /***/ function() {
            /* (ignored) */ /***/ },
            /***/ 16465: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /**
 * Module exports.
 */ module1.exports = deprecate;
                /**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
                    if (config('noDeprecation')) return fn;
                    var warned = false;
                    function deprecated() {
                        if (!warned) {
                            if (config('throwDeprecation')) throw new Error(msg);
                            else if (config('traceDeprecation')) console.trace(msg);
                            else console.warn(msg);
                            warned = true;
                        }
                        return fn.apply(this, arguments);
                    }
                    return deprecated;
                }
                /**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
                    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
                    try {
                        if (!__webpack_require__.g.localStorage) return false;
                    } catch (_) {
                        return false;
                    }
                    var val = __webpack_require__.g.localStorage[name];
                    if (null == val) return false;
                    return String(val).toLowerCase() === 'true';
                }
            /***/ },
            /***/ 16679: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                // `thisNumberValue` abstract operation
                // https://tc39.es/ecma262/#sec-thisnumbervalue
                module1.exports = uncurryThis(1.0.valueOf);
            /***/ },
            /***/ 16720: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(20731);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(18909));
                })(void 0, function(CryptoJS) {
                    (function(Math1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var Hasher = C_lib.Hasher;
                        var C_x64 = C.x64;
                        var X64Word = C_x64.Word;
                        var C_algo = C.algo;
                        // Constants tables
                        var RHO_OFFSETS = [];
                        var PI_INDEXES = [];
                        var ROUND_CONSTANTS = [];
                        // Compute Constants
                        (function() {
                            // Compute rho offset constants
                            var x = 1, y = 0;
                            for(var t = 0; t < 24; t++){
                                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                                var newX = y % 5;
                                var newY = (2 * x + 3 * y) % 5;
                                x = newX;
                                y = newY;
                            }
                            // Compute pi index constants
                            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
                            // Compute round constants
                            var LFSR = 0x01;
                            for(var i = 0; i < 24; i++){
                                var roundConstantMsw = 0;
                                var roundConstantLsw = 0;
                                for(var j = 0; j < 7; j++){
                                    if (LFSR & 0x01) {
                                        var bitPosition = (1 << j) - 1;
                                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                                        else roundConstantMsw ^= 1 << bitPosition - 32;
                                    }
                                    // Compute next LFSR
                                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                                    LFSR = LFSR << 1 ^ 0x71;
                                    else LFSR <<= 1;
                                }
                                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
                            }
                        })();
                        // Reusable objects for temporary values
                        var T = [];
                        (function() {
                            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
                        })();
                        /**
     * SHA-3 hash algorithm.
     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
                            /**
       * Configuration options.
       *
       * @property {number} outputLength
       *   The desired number of bits in the output hash.
       *   Only values permitted are: 224, 256, 384, 512.
       *   Default: 512
       */ cfg: Hasher.cfg.extend({
                                outputLength: 512
                            }),
                            _doReset: function _doReset() {
                                var state = this._state = [];
                                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcuts
                                var state = this._state;
                                var nBlockSizeLanes = this.blockSize / 2;
                                // Absorb
                                for(var i = 0; i < nBlockSizeLanes; i++){
                                    // Shortcuts
                                    var M2i = M[offset + 2 * i];
                                    var M2i1 = M[offset + 2 * i + 1];
                                    // Swap endian
                                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                                    // Absorb message into state
                                    var lane = state[i];
                                    lane.high ^= M2i1;
                                    lane.low ^= M2i;
                                }
                                // Rounds
                                for(var round = 0; round < 24; round++){
                                    // Theta
                                    for(var x = 0; x < 5; x++){
                                        // Mix column lanes
                                        var tMsw = 0, tLsw = 0;
                                        for(var y = 0; y < 5; y++){
                                            var lane = state[x + 5 * y];
                                            tMsw ^= lane.high;
                                            tLsw ^= lane.low;
                                        }
                                        // Temporary values
                                        var Tx = T[x];
                                        Tx.high = tMsw;
                                        Tx.low = tLsw;
                                    }
                                    for(var x = 0; x < 5; x++){
                                        // Shortcuts
                                        var Tx4 = T[(x + 4) % 5];
                                        var Tx1 = T[(x + 1) % 5];
                                        var Tx1Msw = Tx1.high;
                                        var Tx1Lsw = Tx1.low;
                                        // Mix surrounding columns
                                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                                        for(var y = 0; y < 5; y++){
                                            var lane = state[x + 5 * y];
                                            lane.high ^= tMsw;
                                            lane.low ^= tLsw;
                                        }
                                    }
                                    // Rho Pi
                                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                                        var tMsw;
                                        var tLsw;
                                        // Shortcuts
                                        var lane = state[laneIndex];
                                        var laneMsw = lane.high;
                                        var laneLsw = lane.low;
                                        var rhoOffset = RHO_OFFSETS[laneIndex];
                                        // Rotate lanes
                                        if (rhoOffset < 32) {
                                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                                        } else /* if (rhoOffset >= 32) */ {
                                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                                        }
                                        // Transpose lanes
                                        var TPiLane = T[PI_INDEXES[laneIndex]];
                                        TPiLane.high = tMsw;
                                        TPiLane.low = tLsw;
                                    }
                                    // Rho pi at x = y = 0
                                    var T0 = T[0];
                                    var state0 = state[0];
                                    T0.high = state0.high;
                                    T0.low = state0.low;
                                    // Chi
                                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                                        // Shortcuts
                                        var laneIndex = x + 5 * y;
                                        var lane = state[laneIndex];
                                        var TLane = T[laneIndex];
                                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                                        // Mix rows
                                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                                    }
                                    // Iota
                                    var lane = state[0];
                                    var roundConstant = ROUND_CONSTANTS[round];
                                    lane.high ^= roundConstant.high;
                                    lane.low ^= roundConstant.low;
                                }
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                var blockSizeBits = this.blockSize * 32;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                                data.sigBytes = dataWords.length * 4;
                                // Hash final blocks
                                this._process();
                                // Shortcuts
                                var state = this._state;
                                var outputLengthBytes = this.cfg.outputLength / 8;
                                var outputLengthLanes = outputLengthBytes / 8;
                                // Squeeze
                                var hashWords = [];
                                for(var i = 0; i < outputLengthLanes; i++){
                                    // Shortcuts
                                    var lane = state[i];
                                    var laneMsw = lane.high;
                                    var laneLsw = lane.low;
                                    // Swap endian
                                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                                    // Squeeze state to retrieve hash
                                    hashWords.push(laneLsw);
                                    hashWords.push(laneMsw);
                                }
                                // Return final computed hash
                                return new WordArray.init(hashWords, outputLengthBytes);
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                var state = clone._state = this._state.slice(0);
                                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                                return clone;
                            }
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA3('message');
     *     var hash = CryptoJS.SHA3(wordArray);
     */ C.SHA3 = Hasher._createHelper(SHA3);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA3(message, key);
     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
                    })(Math);
                    return CryptoJS.SHA3;
                });
            /***/ },
            /***/ 16793: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(93143).Buffer;
                // Export Node.js internal encodings.
                module1.exports = {
                    // Encodings
                    utf8: {
                        type: "_internal",
                        bomAware: true
                    },
                    cesu8: {
                        type: "_internal",
                        bomAware: true
                    },
                    unicode11utf8: "utf8",
                    ucs2: {
                        type: "_internal",
                        bomAware: true
                    },
                    utf16le: "ucs2",
                    binary: {
                        type: "_internal"
                    },
                    base64: {
                        type: "_internal"
                    },
                    hex: {
                        type: "_internal"
                    },
                    // Codec.
                    _internal: InternalCodec
                };
                //------------------------------------------------------------------------------
                function InternalCodec(codecOptions, iconv) {
                    this.enc = codecOptions.encodingName;
                    this.bomAware = codecOptions.bomAware;
                    if (this.enc === "base64") this.encoder = InternalEncoderBase64;
                    else if (this.enc === "cesu8") {
                        this.enc = "utf8"; // Use utf8 for decoding.
                        this.encoder = InternalEncoderCesu8;
                        // Add decoder for versions of Node not supporting CESU-8
                        if (Buffer.from('eda0bdedb2a9', 'hex').toString() !== "\uD83D\uDCA9") {
                            this.decoder = InternalDecoderCesu8;
                            this.defaultCharUnicode = iconv.defaultCharUnicode;
                        }
                    }
                }
                InternalCodec.prototype.encoder = InternalEncoder;
                InternalCodec.prototype.decoder = InternalDecoder;
                //------------------------------------------------------------------------------
                // We use node.js internal decoder. Its signature is the same as ours.
                var StringDecoder = __webpack_require__(43143)/* .StringDecoder */ .I;
                if (!StringDecoder.prototype.end) StringDecoder.prototype.end = function() {};
                function InternalDecoder(options, codec) {
                    this.decoder = new StringDecoder(codec.enc);
                }
                InternalDecoder.prototype.write = function(buf) {
                    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                    return this.decoder.write(buf);
                };
                InternalDecoder.prototype.end = function() {
                    return this.decoder.end();
                };
                //------------------------------------------------------------------------------
                // Encoder is mostly trivial
                function InternalEncoder(options, codec) {
                    this.enc = codec.enc;
                }
                InternalEncoder.prototype.write = function(str) {
                    return Buffer.from(str, this.enc);
                };
                InternalEncoder.prototype.end = function() {};
                //------------------------------------------------------------------------------
                // Except base64 encoder, which must keep its state.
                function InternalEncoderBase64(options, codec) {
                    this.prevStr = '';
                }
                InternalEncoderBase64.prototype.write = function(str) {
                    str = this.prevStr + str;
                    var completeQuads = str.length - str.length % 4;
                    this.prevStr = str.slice(completeQuads);
                    str = str.slice(0, completeQuads);
                    return Buffer.from(str, "base64");
                };
                InternalEncoderBase64.prototype.end = function() {
                    return Buffer.from(this.prevStr, "base64");
                };
                //------------------------------------------------------------------------------
                // CESU-8 encoder is also special.
                function InternalEncoderCesu8(options, codec) {}
                InternalEncoderCesu8.prototype.write = function(str) {
                    var buf = Buffer.alloc(str.length * 3), bufIdx = 0;
                    for(var i = 0; i < str.length; i++){
                        var charCode = str.charCodeAt(i);
                        // Naive implementation, but it works because CESU-8 is especially easy
                        // to convert from UTF-16 (which all JS strings are encoded in).
                        if (charCode < 0x80) buf[bufIdx++] = charCode;
                        else if (charCode < 0x800) {
                            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
                            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
                        } else {
                            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
                            buf[bufIdx++] = 0x80 + (charCode >>> 6 & 0x3f);
                            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
                        }
                    }
                    return buf.slice(0, bufIdx);
                };
                InternalEncoderCesu8.prototype.end = function() {};
                //------------------------------------------------------------------------------
                // CESU-8 decoder is not implemented in Node v4.0+
                function InternalDecoderCesu8(options, codec) {
                    this.acc = 0;
                    this.contBytes = 0;
                    this.accBytes = 0;
                    this.defaultCharUnicode = codec.defaultCharUnicode;
                }
                InternalDecoderCesu8.prototype.write = function(buf) {
                    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, res = '';
                    for(var i = 0; i < buf.length; i++){
                        var curByte = buf[i];
                        if ((curByte & 0xC0) !== 0x80) {
                            if (contBytes > 0) {
                                res += this.defaultCharUnicode;
                                contBytes = 0;
                            }
                            if (curByte < 0x80) res += String.fromCharCode(curByte);
                            else if (curByte < 0xE0) {
                                acc = curByte & 0x1F;
                                contBytes = 1;
                                accBytes = 1;
                            } else if (curByte < 0xF0) {
                                acc = curByte & 0x0F;
                                contBytes = 2;
                                accBytes = 1;
                            } else res += this.defaultCharUnicode;
                        } else if (contBytes > 0) {
                            acc = acc << 6 | curByte & 0x3f;
                            contBytes--;
                            accBytes++;
                            if (contBytes === 0) {
                                // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                                if (accBytes === 2 && acc < 0x80 && acc > 0) res += this.defaultCharUnicode;
                                else if (accBytes === 3 && acc < 0x800) res += this.defaultCharUnicode;
                                else // Actually add character.
                                res += String.fromCharCode(acc);
                            }
                        } else res += this.defaultCharUnicode;
                    }
                    this.acc = acc;
                    this.contBytes = contBytes;
                    this.accBytes = accBytes;
                    return res;
                };
                InternalDecoderCesu8.prototype.end = function() {
                    var res = 0;
                    if (this.contBytes > 0) res += this.defaultCharUnicode;
                    return res;
                };
            /***/ },
            /***/ 17100: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(93143).Buffer;
                // Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
                // == UTF16-BE codec. ==========================================================
                exports.utf16be = Utf16BECodec;
                function Utf16BECodec() {}
                Utf16BECodec.prototype.encoder = Utf16BEEncoder;
                Utf16BECodec.prototype.decoder = Utf16BEDecoder;
                Utf16BECodec.prototype.bomAware = true;
                // -- Encoding
                function Utf16BEEncoder() {}
                Utf16BEEncoder.prototype.write = function(str) {
                    var buf = Buffer.from(str, 'ucs2');
                    for(var i = 0; i < buf.length; i += 2){
                        var tmp = buf[i];
                        buf[i] = buf[i + 1];
                        buf[i + 1] = tmp;
                    }
                    return buf;
                };
                Utf16BEEncoder.prototype.end = function() {};
                // -- Decoding
                function Utf16BEDecoder() {
                    this.overflowByte = -1;
                }
                Utf16BEDecoder.prototype.write = function(buf) {
                    if (buf.length == 0) return '';
                    var buf2 = Buffer.alloc(buf.length + 1), i = 0, j = 0;
                    if (this.overflowByte !== -1) {
                        buf2[0] = buf[0];
                        buf2[1] = this.overflowByte;
                        i = 1;
                        j = 2;
                    }
                    for(; i < buf.length - 1; i += 2, j += 2){
                        buf2[j] = buf[i + 1];
                        buf2[j + 1] = buf[i];
                    }
                    this.overflowByte = i == buf.length - 1 ? buf[buf.length - 1] : -1;
                    return buf2.slice(0, j).toString('ucs2');
                };
                Utf16BEDecoder.prototype.end = function() {
                    this.overflowByte = -1;
                };
                // == UTF-16 codec =============================================================
                // Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
                // Defaults to UTF-16LE, as it's prevalent and default in Node.
                // http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
                // Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
                // Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
                exports.utf16 = Utf16Codec;
                function Utf16Codec(codecOptions, iconv) {
                    this.iconv = iconv;
                }
                Utf16Codec.prototype.encoder = Utf16Encoder;
                Utf16Codec.prototype.decoder = Utf16Decoder;
                // -- Encoding (pass-through)
                function Utf16Encoder(options, codec) {
                    options = options || {};
                    if (options.addBOM === undefined) options.addBOM = true;
                    this.encoder = codec.iconv.getEncoder('utf-16le', options);
                }
                Utf16Encoder.prototype.write = function(str) {
                    return this.encoder.write(str);
                };
                Utf16Encoder.prototype.end = function() {
                    return this.encoder.end();
                };
                // -- Decoding
                function Utf16Decoder(options, codec) {
                    this.decoder = null;
                    this.initialBufs = [];
                    this.initialBufsLen = 0;
                    this.options = options || {};
                    this.iconv = codec.iconv;
                }
                Utf16Decoder.prototype.write = function(buf) {
                    if (!this.decoder) {
                        // Codec is not chosen yet. Accumulate initial bytes.
                        this.initialBufs.push(buf);
                        this.initialBufsLen += buf.length;
                        if (this.initialBufsLen < 16) return '';
                        // We have enough bytes -> detect endianness.
                        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
                        this.decoder = this.iconv.getDecoder(encoding, this.options);
                        var resStr = '';
                        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
                        this.initialBufs.length = this.initialBufsLen = 0;
                        return resStr;
                    }
                    return this.decoder.write(buf);
                };
                Utf16Decoder.prototype.end = function() {
                    if (!this.decoder) {
                        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
                        this.decoder = this.iconv.getDecoder(encoding, this.options);
                        var resStr = '';
                        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
                        var trail = this.decoder.end();
                        if (trail) resStr += trail;
                        this.initialBufs.length = this.initialBufsLen = 0;
                        return resStr;
                    }
                    return this.decoder.end();
                };
                function detectEncoding(bufs, defaultEncoding) {
                    var b = [];
                    var charsProcessed = 0;
                    var asciiCharsLE = 0, asciiCharsBE = 0; // Number of ASCII chars when decoded as LE or BE.
                    outer_loop: for(var i = 0; i < bufs.length; i++){
                        var buf = bufs[i];
                        for(var j = 0; j < buf.length; j++){
                            b.push(buf[j]);
                            if (b.length === 2) {
                                if (charsProcessed === 0) {
                                    // Check BOM first.
                                    if (b[0] === 0xFF && b[1] === 0xFE) return 'utf-16le';
                                    if (b[0] === 0xFE && b[1] === 0xFF) return 'utf-16be';
                                }
                                if (b[0] === 0 && b[1] !== 0) asciiCharsBE++;
                                if (b[0] !== 0 && b[1] === 0) asciiCharsLE++;
                                b.length = 0;
                                charsProcessed++;
                                if (charsProcessed >= 100) break outer_loop;
                            }
                        }
                    }
                    // Make decisions.
                    // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
                    // So, we count ASCII as if it was LE or BE, and decide from that.
                    if (asciiCharsBE > asciiCharsLE) return 'utf-16be';
                    if (asciiCharsBE < asciiCharsLE) return 'utf-16le';
                    // Couldn't decide (likely all zeros or not enough data).
                    return defaultEncoding || 'utf-16le';
                }
            /***/ },
            /***/ 17506: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var isObject = __webpack_require__(24517);
                var floor = Math.floor;
                // `IsIntegralNumber` abstract operation
                // https://tc39.es/ecma262/#sec-isintegralnumber
                // eslint-disable-next-line es/no-number-isinteger -- safe
                module1.exports = Number.isInteger || function isInteger(it) {
                    return !isObject(it) && isFinite(it) && floor(it) === it;
                };
            /***/ },
            /***/ 17716: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var userAgent = __webpack_require__(40715);
                module1.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
            /***/ },
            /***/ 17723: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a passthrough stream.
                // basically just the most minimal sort of Transform stream.
                // Every written chunk gets output as-is.
                module1.exports = PassThrough;
                var Transform = __webpack_require__(48569);
                __webpack_require__(89784)(PassThrough, Transform);
                function PassThrough(options) {
                    if (!(this instanceof PassThrough)) return new PassThrough(options);
                    Transform.call(this, options);
                }
                PassThrough.prototype._transform = function(chunk, encoding, cb) {
                    cb(null, chunk);
                };
            /***/ },
            /***/ 17802: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var bind = __webpack_require__(5049);
                var $apply = __webpack_require__(73036);
                var $call = __webpack_require__(10078);
                var $reflectApply = __webpack_require__(61909);
                /** @type {import('./actualApply')} */ module1.exports = $reflectApply || bind.call($call, $apply);
            /***/ },
            /***/ 18128: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _require = __webpack_require__(56128), NumberT = _require.Number;
                exports.resolveLength = function(length, stream, parent) {
                    var res;
                    if (typeof length === 'number') res = length;
                    else if (typeof length === 'function') res = length.call(parent, parent);
                    else if (parent && typeof length === 'string') res = parent[length];
                    else if (stream && length instanceof NumberT) res = length.decode(stream);
                    if (isNaN(res)) throw new Error('Not a fixed size');
                    return res;
                };
                var PropertyDescriptor = function PropertyDescriptor(opts) {
                    if (opts === void 0) opts = {};
                    this.enumerable = true;
                    this.configurable = true;
                    for(var key in opts){
                        var val = opts[key];
                        this[key] = val;
                    }
                };
                exports.PropertyDescriptor = PropertyDescriptor;
            /***/ },
            /***/ 18425: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var createHTML = __webpack_require__(91159);
                var forcedStringHTMLMethod = __webpack_require__(7452);
                // `String.prototype.strike` method
                // https://tc39.es/ecma262/#sec-string.prototype.strike
                $({
                    target: 'String',
                    proto: true,
                    forced: forcedStringHTMLMethod('strike')
                }, {
                    strike: function strike() {
                        return createHTML(this, 'strike', '', '');
                    }
                });
            /***/ },
            /***/ 18645: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(65292);
                __webpack_require__(73844);
                __webpack_require__(11765);
                __webpack_require__(24863);
                __webpack_require__(71950);
                __webpack_require__(68067);
                __webpack_require__(57114);
                __webpack_require__(42437);
                __webpack_require__(69330);
                __webpack_require__(81755);
                __webpack_require__(20731);
                __webpack_require__(14032);
                __webpack_require__(61726);
                __webpack_require__(58281);
                __webpack_require__(6422);
                __webpack_require__(94712);
                function _createForOfIteratorHelperLoose(r, e) {
                    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                    if (t) return (t = t.call(r)).next.bind(t);
                    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
                        t && (r = t);
                        var o = 0;
                        return function() {
                            return o >= r.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: r[o++]
                            };
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(r, a) {
                    if (r) {
                        if ("string" == typeof r) return _arrayLikeToArray(r, a);
                        var t = ({}).toString.call(r).slice(8, -1);
                        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
                    }
                }
                function _arrayLikeToArray(r, a) {
                    (null == a || a > r.length) && (a = r.length);
                    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
                    return n;
                }
                function _regeneratorRuntime() {
                    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ 
                    _regeneratorRuntime = function _regeneratorRuntime() {
                        return r;
                    };
                    var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
                    function c(t, r, e, n) {
                        return Object.defineProperty(t, r, {
                            value: e,
                            enumerable: !n,
                            configurable: !n,
                            writable: !n
                        });
                    }
                    try {
                        c({}, "");
                    } catch (t) {
                        c = function c(t, r, e) {
                            return t[r] = e;
                        };
                    }
                    function h(r, e, n, o) {
                        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype);
                        return c(a, "_invoke", function(r, e, n) {
                            var o = 1;
                            return function(i, a) {
                                if (3 === o) throw Error("Generator is already running");
                                if (4 === o) {
                                    if ("throw" === i) throw a;
                                    return {
                                        value: t,
                                        done: !0
                                    };
                                }
                                for(n.method = i, n.arg = a;;){
                                    var u = n.delegate;
                                    if (u) {
                                        var c = d(u, n);
                                        if (c) {
                                            if (c === f) continue;
                                            return c;
                                        }
                                    }
                                    if ("next" === n.method) n.sent = n._sent = n.arg;
                                    else if ("throw" === n.method) {
                                        if (1 === o) throw o = 4, n.arg;
                                        n.dispatchException(n.arg);
                                    } else "return" === n.method && n.abrupt("return", n.arg);
                                    o = 3;
                                    var h = s(r, e, n);
                                    if ("normal" === h.type) {
                                        if (o = n.done ? 4 : 2, h.arg === f) continue;
                                        return {
                                            value: h.arg,
                                            done: n.done
                                        };
                                    }
                                    "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
                                }
                            };
                        }(r, n, new Context(o || [])), !0), a;
                    }
                    function s(t, r, e) {
                        try {
                            return {
                                type: "normal",
                                arg: t.call(r, e)
                            };
                        } catch (t) {
                            return {
                                type: "throw",
                                arg: t
                            };
                        }
                    }
                    r.wrap = h;
                    var f = {};
                    function Generator() {}
                    function GeneratorFunction() {}
                    function GeneratorFunctionPrototype() {}
                    var l = {};
                    c(l, i, function() {
                        return this;
                    });
                    var p = Object.getPrototypeOf, y = p && p(p(x([])));
                    y && y !== e && n.call(y, i) && (l = y);
                    var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
                    function g(t) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(r) {
                            c(t, r, function(t) {
                                return this._invoke(r, t);
                            });
                        });
                    }
                    function AsyncIterator(t, r) {
                        function e(o, i, a, u) {
                            var c = s(t[o], t, i);
                            if ("throw" !== c.type) {
                                var h = c.arg, f = h.value;
                                return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function(t) {
                                    e("next", t, a, u);
                                }, function(t) {
                                    e("throw", t, a, u);
                                }) : r.resolve(f).then(function(t) {
                                    h.value = t, a(h);
                                }, function(t) {
                                    return e("throw", t, a, u);
                                });
                            }
                            u(c.arg);
                        }
                        var o;
                        c(this, "_invoke", function(t, n) {
                            function i() {
                                return new r(function(r, o) {
                                    e(t, n, r, o);
                                });
                            }
                            return o = o ? o.then(i, i) : i();
                        }, !0);
                    }
                    function d(r, e) {
                        var n = e.method, o = r.i[n];
                        if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
                        var i = s(o, r.i, e.arg);
                        if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
                        var a = i.arg;
                        return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
                    }
                    function w(t) {
                        this.tryEntries.push(t);
                    }
                    function m(r) {
                        var e = r[4] || {};
                        e.type = "normal", e.arg = t, r[4] = e;
                    }
                    function Context(t) {
                        this.tryEntries = [
                            [
                                -1
                            ]
                        ], t.forEach(w, this), this.reset(!0);
                    }
                    function x(r) {
                        if (null != r) {
                            var e = r[i];
                            if (e) return e.call(r);
                            if ("function" == typeof r.next) return r;
                            if (!isNaN(r.length)) {
                                var o = -1, a = function e() {
                                    for(; ++o < r.length;)if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
                                    return e.value = t, e.done = !0, e;
                                };
                                return a.next = a;
                            }
                        }
                        throw new TypeError(typeof r + " is not iterable");
                    }
                    return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function(t) {
                        var r = "function" == typeof t && t.constructor;
                        return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
                    }, r.mark = function(t) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
                    }, r.awrap = function(t) {
                        return {
                            __await: t
                        };
                    }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function() {
                        return this;
                    }), r.AsyncIterator = AsyncIterator, r.async = function(t, e, n, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new AsyncIterator(h(t, e, n, o), i);
                        return r.isGeneratorFunction(e) ? a : a.next().then(function(t) {
                            return t.done ? t.value : a.next();
                        });
                    }, g(v), c(v, u, "Generator"), c(v, i, function() {
                        return this;
                    }), c(v, "toString", function() {
                        return "[object Generator]";
                    }), r.keys = function(t) {
                        var r = Object(t), e = [];
                        for(var n in r)e.unshift(n);
                        return function t() {
                            for(; e.length;)if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
                            return t.done = !0, t;
                        };
                    }, r.values = x, Context.prototype = {
                        constructor: Context,
                        reset: function reset(r) {
                            if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for(var e in this)"t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
                        },
                        stop: function stop() {
                            this.done = !0;
                            var t = this.tryEntries[0][4];
                            if ("throw" === t.type) throw t.arg;
                            return this.rval;
                        },
                        dispatchException: function dispatchException(r) {
                            if (this.done) throw r;
                            var e = this;
                            function n(t) {
                                a.type = "throw", a.arg = r, e.next = t;
                            }
                            for(var o = e.tryEntries.length - 1; o >= 0; --o){
                                var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2];
                                if (-1 === i[0]) return n("end"), !1;
                                if (!c && !h) throw Error("try statement without catch or finally");
                                if (null != i[0] && i[0] <= u) {
                                    if (u < c) return this.method = "next", this.arg = t, n(c), !0;
                                    if (u < h) return n(h), !1;
                                }
                            }
                        },
                        abrupt: function abrupt(t, r) {
                            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                                var n = this.tryEntries[e];
                                if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
                                    var o = n;
                                    break;
                                }
                            }
                            o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
                            var i = o ? o[4] : {};
                            return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
                        },
                        complete: function complete(t, r) {
                            if ("throw" === t.type) throw t.arg;
                            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
                        },
                        finish: function finish(t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var e = this.tryEntries[r];
                                if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
                            }
                        },
                        catch: function _catch(t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var e = this.tryEntries[r];
                                if (e[0] === t) {
                                    var n = e[4];
                                    if ("throw" === n.type) {
                                        var o = n.arg;
                                        m(e);
                                    }
                                    return o;
                                }
                            }
                            throw Error("illegal catch attempt");
                        },
                        delegateYield: function delegateYield(r, e, n) {
                            return this.delegate = {
                                i: x(r),
                                r: e,
                                n: n
                            }, "next" === this.method && (this.arg = t), f;
                        }
                    }, r;
                }
                var INITIAL_STATE = 1;
                var FAIL_STATE = 0;
                /**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */ var StateMachine = /*#__PURE__*/ function() {
                    function StateMachine(dfa) {
                        this.stateTable = dfa.stateTable;
                        this.accepting = dfa.accepting;
                        this.tags = dfa.tags;
                    }
                    /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */ var _proto = StateMachine.prototype;
                    _proto.match = function match(str) {
                        var _ref;
                        var self1 = this;
                        return _ref = {}, _ref[Symbol.iterator] = /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                            var state, startRun, lastAccepting, lastState, p, c;
                            return _regeneratorRuntime().wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        state = INITIAL_STATE;
                                        startRun = null;
                                        lastAccepting = null;
                                        lastState = null;
                                        p = 0;
                                    case 5:
                                        if (!(p < str.length)) {
                                            _context.next = 21;
                                            break;
                                        }
                                        c = str[p];
                                        lastState = state;
                                        state = self1.stateTable[state][c];
                                        if (!(state === FAIL_STATE)) {
                                            _context.next = 15;
                                            break;
                                        }
                                        if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                                            _context.next = 13;
                                            break;
                                        }
                                        _context.next = 13;
                                        return [
                                            startRun,
                                            lastAccepting,
                                            self1.tags[lastState]
                                        ];
                                    case 13:
                                        // reset the state as if we started over from the initial state
                                        state = self1.stateTable[INITIAL_STATE][c];
                                        startRun = null;
                                    case 15:
                                        // start a run if not in the failure state
                                        if (state !== FAIL_STATE && startRun == null) startRun = p;
                                         // if accepting, mark the potential match end
                                        if (self1.accepting[state]) lastAccepting = p;
                                         // reset the state to the initial state if we get into the failure state
                                        if (state === FAIL_STATE) state = INITIAL_STATE;
                                    case 18:
                                        p++;
                                        _context.next = 5;
                                        break;
                                    case 21:
                                        if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                                            _context.next = 24;
                                            break;
                                        }
                                        _context.next = 24;
                                        return [
                                            startRun,
                                            lastAccepting,
                                            self1.tags[state]
                                        ];
                                    case 24:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }), _ref;
                    } /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */ ;
                    _proto.apply = function apply(str, actions) {
                        for(var _iterator = _createForOfIteratorHelperLoose(this.match(str)), _step; !(_step = _iterator()).done;){
                            var _step$value = _step.value, start = _step$value[0], end = _step$value[1], tags = _step$value[2];
                            for(var _iterator2 = _createForOfIteratorHelperLoose(tags), _step2; !(_step2 = _iterator2()).done;){
                                var tag = _step2.value;
                                if (typeof actions[tag] === 'function') actions[tag](start, end, str.slice(start, end + 1));
                            }
                        }
                    };
                    return StateMachine;
                }();
                module1.exports = StateMachine;
            /***/ },
            /***/ 18756: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var assign = __webpack_require__(87146);
                // `Object.assign` method
                // https://tc39.es/ecma262/#sec-object.assign
                // eslint-disable-next-line es/no-object-assign -- required for testing
                $({
                    target: 'Object',
                    stat: true,
                    forced: Object.assign !== assign
                }, {
                    assign: assign
                });
            /***/ },
            /***/ 18828: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var collection = __webpack_require__(36673);
                var collectionStrong = __webpack_require__(9649);
                // `Map` constructor
                // https://tc39.es/ecma262/#sec-map-objects
                collection('Map', function(init) {
                    return function Map1() {
                        return init(this, arguments.length ? arguments[0] : undefined);
                    };
                }, collectionStrong);
            /***/ },
            /***/ 18888: /***/ function(module1) {
                "use strict";
                /** @type {import('./range')} */ module1.exports = RangeError;
            /***/ },
            /***/ 18890: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $defineProperty = __webpack_require__(56649);
                var hasPropertyDescriptors = function hasPropertyDescriptors() {
                    return !!$defineProperty;
                };
                hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
                    // node v0.6 has a bug where array lengths can be Set but not Defined
                    if (!$defineProperty) return null;
                    try {
                        return $defineProperty([], 'length', {
                            value: 1
                        }).length !== 1;
                    } catch (e) {
                        // In Firefox 4-22, defining length on an array throws an exception.
                        return true;
                    }
                };
                module1.exports = hasPropertyDescriptors;
            /***/ },
            /***/ 18904: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(15567);
                var fails = __webpack_require__(47044);
                var createElement = __webpack_require__(12072);
                // Thank's IE8 for his funny defineProperty
                module1.exports = !DESCRIPTORS && !fails(function() {
                    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
                    return Object.defineProperty(createElement('div'), 'a', {
                        get: function() {
                            return 7;
                        }
                    }).a != 7;
                });
            /***/ },
            /***/ 18909: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(20731);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352));
                })(void 0, function(CryptoJS) {
                    (function(undefined1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Base = C_lib.Base;
                        var X32WordArray = C_lib.WordArray;
                        /**
     * x64 namespace.
     */ var C_x64 = C.x64 = {};
                        /**
     * A 64-bit word.
     */ var X64Word = C_x64.Word = Base.extend({
                            /**
       * Initializes a newly created 64-bit word.
       *
       * @param {number} high The high 32 bits.
       * @param {number} low The low 32 bits.
       *
       * @example
       *
       *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
       */ init: function init(high, low) {
                                this.high = high;
                                this.low = low;
                            }
                        });
                        /**
     * An array of 64-bit words.
     *
     * @property {Array} words The array of CryptoJS.x64.Word objects.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */ var X64WordArray = C_x64.WordArray = Base.extend({
                            /**
       * Initializes a newly created word array.
       *
       * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
       * @param {number} sigBytes (Optional) The number of significant bytes in the words.
       *
       * @example
       *
       *     var wordArray = CryptoJS.x64.WordArray.create();
       *
       *     var wordArray = CryptoJS.x64.WordArray.create([
       *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
       *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
       *     ]);
       *
       *     var wordArray = CryptoJS.x64.WordArray.create([
       *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
       *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
       *     ], 10);
       */ init: function init(words, sigBytes) {
                                words = this.words = words || [];
                                if (sigBytes != undefined1) this.sigBytes = sigBytes;
                                else this.sigBytes = words.length * 8;
                            },
                            /**
       * Converts this 64-bit word array to a 32-bit word array.
       *
       * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
       *
       * @example
       *
       *     var x32WordArray = x64WordArray.toX32();
       */ toX32: function toX32() {
                                // Shortcuts
                                var x64Words = this.words;
                                var x64WordsLength = x64Words.length;
                                // Convert
                                var x32Words = [];
                                for(var i = 0; i < x64WordsLength; i++){
                                    var x64Word = x64Words[i];
                                    x32Words.push(x64Word.high);
                                    x32Words.push(x64Word.low);
                                }
                                return X32WordArray.create(x32Words, this.sigBytes);
                            },
                            /**
       * Creates a copy of this word array.
       *
       * @return {X64WordArray} The clone.
       *
       * @example
       *
       *     var clone = x64WordArray.clone();
       */ clone: function clone() {
                                var clone = Base.clone.call(this);
                                // Clone "words" array
                                var words = clone.words = this.words.slice(0);
                                // Clone each X64Word object
                                var wordsLength = words.length;
                                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                                return clone;
                            }
                        });
                    })();
                    return CryptoJS;
                });
            /***/ },
            /***/ 19292: /***/ function(module1) {
                "use strict";
                /** @type {import('./round')} */ module1.exports = Math.round;
            /***/ },
            /***/ 20340: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var toObject = __webpack_require__(43162);
                var hasOwnProperty = uncurryThis({}.hasOwnProperty);
                // `HasOwnProperty` abstract operation
                // https://tc39.es/ecma262/#sec-hasownproperty
                module1.exports = Object.hasOwn || function hasOwn(it, key) {
                    return hasOwnProperty(toObject(it), key);
                };
            /***/ },
            /***/ 20731: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var isArray = __webpack_require__(59113);
                var isConstructor = __webpack_require__(20884);
                var isObject = __webpack_require__(24517);
                var toAbsoluteIndex = __webpack_require__(74841);
                var lengthOfArrayLike = __webpack_require__(45495);
                var toIndexedObject = __webpack_require__(98086);
                var createProperty = __webpack_require__(38639);
                var wellKnownSymbol = __webpack_require__(38688);
                var arrayMethodHasSpeciesSupport = __webpack_require__(56280);
                var un$Slice = __webpack_require__(73163);
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
                var SPECIES = wellKnownSymbol('species');
                var Array1 = global.Array;
                var max = Math.max;
                // `Array.prototype.slice` method
                // https://tc39.es/ecma262/#sec-array.prototype.slice
                // fallback for not array-like ES3 strings and DOM objects
                $({
                    target: 'Array',
                    proto: true,
                    forced: !HAS_SPECIES_SUPPORT
                }, {
                    slice: function slice(start, end) {
                        var O = toIndexedObject(this);
                        var length = lengthOfArrayLike(O);
                        var k = toAbsoluteIndex(start, length);
                        var fin = toAbsoluteIndex(end === undefined ? length : end, length);
                        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
                        var Constructor, result, n;
                        if (isArray(O)) {
                            Constructor = O.constructor;
                            // cross-realm fallback
                            if (isConstructor(Constructor) && (Constructor === Array1 || isArray(Constructor.prototype))) Constructor = undefined;
                            else if (isObject(Constructor)) {
                                Constructor = Constructor[SPECIES];
                                if (Constructor === null) Constructor = undefined;
                            }
                            if (Constructor === Array1 || Constructor === undefined) return un$Slice(O, k, fin);
                        }
                        result = new (Constructor === undefined ? Array1 : Constructor)(max(fin - k, 0));
                        for(n = 0; k < fin; k++, n++)if (k in O) createProperty(result, n, O[k]);
                        result.length = n;
                        return result;
                    }
                });
            /***/ },
            /***/ 20884: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var fails = __webpack_require__(47044);
                var isCallable = __webpack_require__(94578);
                var classof = __webpack_require__(52564);
                var getBuiltIn = __webpack_require__(38486);
                var inspectSource = __webpack_require__(10447);
                var noop = function() {};
                var empty = [];
                var construct = getBuiltIn('Reflect', 'construct');
                var constructorRegExp = /^\s*(?:class|function)\b/;
                var exec = uncurryThis(constructorRegExp.exec);
                var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
                var isConstructorModern = function(argument) {
                    if (!isCallable(argument)) return false;
                    try {
                        construct(noop, empty, argument);
                        return true;
                    } catch (error) {
                        return false;
                    }
                };
                var isConstructorLegacy = function(argument) {
                    if (!isCallable(argument)) return false;
                    switch(classof(argument)){
                        case 'AsyncFunction':
                        case 'GeneratorFunction':
                        case 'AsyncGeneratorFunction':
                            return false;
                    }
                    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
                };
                // `IsConstructor` abstract operation
                // https://tc39.es/ecma262/#sec-isconstructor
                module1.exports = !construct || fails(function() {
                    var called;
                    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
                        called = true;
                    }) || called;
                }) ? isConstructorLegacy : isConstructorModern;
            /***/ },
            /***/ 20980: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __webpack_unused_export__;
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ var BrotliInput = __webpack_require__(98197)/* .BrotliInput */ .z;
                var BrotliOutput = __webpack_require__(98197)/* .BrotliOutput */ .y;
                var BrotliBitReader = __webpack_require__(34097);
                var BrotliDictionary = __webpack_require__(80614);
                var HuffmanCode = __webpack_require__(81561)/* .HuffmanCode */ .z;
                var BrotliBuildHuffmanTable = __webpack_require__(81561)/* .BrotliBuildHuffmanTable */ .u;
                var Context = __webpack_require__(7043);
                var Prefix = __webpack_require__(42210);
                var Transform = __webpack_require__(87984);
                var kDefaultCodeLength = 8;
                var kCodeLengthRepeatCode = 16;
                var kNumLiteralCodes = 256;
                var kNumInsertAndCopyCodes = 704;
                var kNumBlockLengthCodes = 26;
                var kLiteralContextBits = 6;
                var kDistanceContextBits = 2;
                var HUFFMAN_TABLE_BITS = 8;
                var HUFFMAN_TABLE_MASK = 0xff;
                /* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */ var HUFFMAN_MAX_TABLE_SIZE = 1080;
                var CODE_LENGTH_CODES = 18;
                var kCodeLengthCodeOrder = new Uint8Array([
                    1,
                    2,
                    3,
                    4,
                    0,
                    5,
                    17,
                    6,
                    16,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15
                ]);
                var NUM_DISTANCE_SHORT_CODES = 16;
                var kDistanceShortCodeIndexOffset = new Uint8Array([
                    3,
                    2,
                    1,
                    0,
                    3,
                    3,
                    3,
                    3,
                    3,
                    3,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2
                ]);
                var kDistanceShortCodeValueOffset = new Int8Array([
                    0,
                    0,
                    0,
                    0,
                    -1,
                    1,
                    -2,
                    2,
                    -3,
                    3,
                    -1,
                    1,
                    -2,
                    2,
                    -3,
                    3
                ]);
                var kMaxHuffmanTableSize = new Uint16Array([
                    256,
                    402,
                    436,
                    468,
                    500,
                    534,
                    566,
                    598,
                    630,
                    662,
                    694,
                    726,
                    758,
                    790,
                    822,
                    854,
                    886,
                    920,
                    952,
                    984,
                    1016,
                    1048,
                    1080
                ]);
                function DecodeWindowBits(br) {
                    var n;
                    if (br.readBits(1) === 0) return 16;
                    n = br.readBits(3);
                    if (n > 0) return 17 + n;
                    n = br.readBits(3);
                    if (n > 0) return 8 + n;
                    return 17;
                }
                /* Decodes a number in the range [0..255], by reading 1 - 11 bits. */ function DecodeVarLenUint8(br) {
                    if (br.readBits(1)) {
                        var nbits = br.readBits(3);
                        if (nbits === 0) return 1;
                        else return br.readBits(nbits) + (1 << nbits);
                    }
                    return 0;
                }
                function MetaBlockLength() {
                    this.meta_block_length = 0;
                    this.input_end = 0;
                    this.is_uncompressed = 0;
                    this.is_metadata = false;
                }
                function DecodeMetaBlockLength(br) {
                    var out = new MetaBlockLength;
                    var size_nibbles;
                    var size_bytes;
                    var i;
                    out.input_end = br.readBits(1);
                    if (out.input_end && br.readBits(1)) return out;
                    size_nibbles = br.readBits(2) + 4;
                    if (size_nibbles === 7) {
                        out.is_metadata = true;
                        if (br.readBits(1) !== 0) throw new Error('Invalid reserved bit');
                        size_bytes = br.readBits(2);
                        if (size_bytes === 0) return out;
                        for(i = 0; i < size_bytes; i++){
                            var next_byte = br.readBits(8);
                            if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0) throw new Error('Invalid size byte');
                            out.meta_block_length |= next_byte << i * 8;
                        }
                    } else for(i = 0; i < size_nibbles; ++i){
                        var next_nibble = br.readBits(4);
                        if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0) throw new Error('Invalid size nibble');
                        out.meta_block_length |= next_nibble << i * 4;
                    }
                    ++out.meta_block_length;
                    if (!out.input_end && !out.is_metadata) out.is_uncompressed = br.readBits(1);
                    return out;
                }
                /* Decodes the next Huffman code from bit-stream. */ function ReadSymbol(table, index, br) {
                    var start_index = index;
                    var nbits;
                    br.fillBitWindow();
                    index += br.val_ >>> br.bit_pos_ & HUFFMAN_TABLE_MASK;
                    nbits = table[index].bits - HUFFMAN_TABLE_BITS;
                    if (nbits > 0) {
                        br.bit_pos_ += HUFFMAN_TABLE_BITS;
                        index += table[index].value;
                        index += br.val_ >>> br.bit_pos_ & (1 << nbits) - 1;
                    }
                    br.bit_pos_ += table[index].bits;
                    return table[index].value;
                }
                function ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
                    var symbol = 0;
                    var prev_code_len = kDefaultCodeLength;
                    var repeat = 0;
                    var repeat_code_len = 0;
                    var space = 32768;
                    var table = [];
                    for(var i = 0; i < 32; i++)table.push(new HuffmanCode(0, 0));
                    BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, CODE_LENGTH_CODES);
                    while(symbol < num_symbols && space > 0){
                        var p = 0;
                        var code_len;
                        br.readMoreInput();
                        br.fillBitWindow();
                        p += br.val_ >>> br.bit_pos_ & 31;
                        br.bit_pos_ += table[p].bits;
                        code_len = table[p].value & 0xff;
                        if (code_len < kCodeLengthRepeatCode) {
                            repeat = 0;
                            code_lengths[symbol++] = code_len;
                            if (code_len !== 0) {
                                prev_code_len = code_len;
                                space -= 32768 >> code_len;
                            }
                        } else {
                            var extra_bits = code_len - 14;
                            var old_repeat;
                            var repeat_delta;
                            var new_len = 0;
                            if (code_len === kCodeLengthRepeatCode) new_len = prev_code_len;
                            if (repeat_code_len !== new_len) {
                                repeat = 0;
                                repeat_code_len = new_len;
                            }
                            old_repeat = repeat;
                            if (repeat > 0) {
                                repeat -= 2;
                                repeat <<= extra_bits;
                            }
                            repeat += br.readBits(extra_bits) + 3;
                            repeat_delta = repeat - old_repeat;
                            if (symbol + repeat_delta > num_symbols) throw new Error('[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols');
                            for(var x = 0; x < repeat_delta; x++)code_lengths[symbol + x] = repeat_code_len;
                            symbol += repeat_delta;
                            if (repeat_code_len !== 0) space -= repeat_delta << 15 - repeat_code_len;
                        }
                    }
                    if (space !== 0) throw new Error("[ReadHuffmanCodeLengths] space = " + space);
                    for(; symbol < num_symbols; symbol++)code_lengths[symbol] = 0;
                }
                function ReadHuffmanCode(alphabet_size, tables, table, br) {
                    var table_size = 0;
                    var simple_code_or_skip;
                    var code_lengths = new Uint8Array(alphabet_size);
                    br.readMoreInput();
                    /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */ simple_code_or_skip = br.readBits(2);
                    if (simple_code_or_skip === 1) {
                        /* Read symbols, codes & code lengths directly. */ var i;
                        var max_bits_counter = alphabet_size - 1;
                        var max_bits = 0;
                        var symbols = new Int32Array(4);
                        var num_symbols = br.readBits(2) + 1;
                        while(max_bits_counter){
                            max_bits_counter >>= 1;
                            ++max_bits;
                        }
                        for(i = 0; i < num_symbols; ++i){
                            symbols[i] = br.readBits(max_bits) % alphabet_size;
                            code_lengths[symbols[i]] = 2;
                        }
                        code_lengths[symbols[0]] = 1;
                        switch(num_symbols){
                            case 1:
                                break;
                            case 3:
                                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[1] === symbols[2]) throw new Error('[ReadHuffmanCode] invalid symbols');
                                break;
                            case 2:
                                if (symbols[0] === symbols[1]) throw new Error('[ReadHuffmanCode] invalid symbols');
                                code_lengths[symbols[1]] = 1;
                                break;
                            case 4:
                                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[0] === symbols[3] || symbols[1] === symbols[2] || symbols[1] === symbols[3] || symbols[2] === symbols[3]) throw new Error('[ReadHuffmanCode] invalid symbols');
                                if (br.readBits(1)) {
                                    code_lengths[symbols[2]] = 3;
                                    code_lengths[symbols[3]] = 3;
                                } else code_lengths[symbols[0]] = 2;
                                break;
                        }
                    } else {
                        var i;
                        var code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
                        var space = 32;
                        var num_codes = 0;
                        /* Static Huffman code for the code length code lengths */ var huff = [
                            new HuffmanCode(2, 0),
                            new HuffmanCode(2, 4),
                            new HuffmanCode(2, 3),
                            new HuffmanCode(3, 2),
                            new HuffmanCode(2, 0),
                            new HuffmanCode(2, 4),
                            new HuffmanCode(2, 3),
                            new HuffmanCode(4, 1),
                            new HuffmanCode(2, 0),
                            new HuffmanCode(2, 4),
                            new HuffmanCode(2, 3),
                            new HuffmanCode(3, 2),
                            new HuffmanCode(2, 0),
                            new HuffmanCode(2, 4),
                            new HuffmanCode(2, 3),
                            new HuffmanCode(4, 5)
                        ];
                        for(i = simple_code_or_skip; i < CODE_LENGTH_CODES && space > 0; ++i){
                            var code_len_idx = kCodeLengthCodeOrder[i];
                            var p = 0;
                            var v;
                            br.fillBitWindow();
                            p += br.val_ >>> br.bit_pos_ & 15;
                            br.bit_pos_ += huff[p].bits;
                            v = huff[p].value;
                            code_length_code_lengths[code_len_idx] = v;
                            if (v !== 0) {
                                space -= 32 >> v;
                                ++num_codes;
                            }
                        }
                        if (!(num_codes === 1 || space === 0)) throw new Error('[ReadHuffmanCode] invalid num_codes or space');
                        ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
                    }
                    table_size = BrotliBuildHuffmanTable(tables, table, HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
                    if (table_size === 0) throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
                    return table_size;
                }
                function ReadBlockLength(table, index, br) {
                    var code;
                    var nbits;
                    code = ReadSymbol(table, index, br);
                    nbits = Prefix.kBlockLengthPrefixCode[code].nbits;
                    return Prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
                }
                function TranslateShortCodes(code, ringbuffer, index) {
                    var val;
                    if (code < NUM_DISTANCE_SHORT_CODES) {
                        index += kDistanceShortCodeIndexOffset[code];
                        index &= 3;
                        val = ringbuffer[index] + kDistanceShortCodeValueOffset[code];
                    } else val = code - NUM_DISTANCE_SHORT_CODES + 1;
                    return val;
                }
                function MoveToFront(v, index) {
                    var value = v[index];
                    var i = index;
                    for(; i; --i)v[i] = v[i - 1];
                    v[0] = value;
                }
                function InverseMoveToFrontTransform(v, v_len) {
                    var mtf = new Uint8Array(256);
                    var i;
                    for(i = 0; i < 256; ++i)mtf[i] = i;
                    for(i = 0; i < v_len; ++i){
                        var index = v[i];
                        v[i] = mtf[index];
                        if (index) MoveToFront(mtf, index);
                    }
                }
                /* Contains a collection of huffman trees with the same alphabet size. */ function HuffmanTreeGroup(alphabet_size, num_htrees) {
                    this.alphabet_size = alphabet_size;
                    this.num_htrees = num_htrees;
                    this.codes = new Array(num_htrees + num_htrees * kMaxHuffmanTableSize[alphabet_size + 31 >>> 5]);
                    this.htrees = new Uint32Array(num_htrees);
                }
                HuffmanTreeGroup.prototype.decode = function(br) {
                    var i;
                    var table_size;
                    var next = 0;
                    for(i = 0; i < this.num_htrees; ++i){
                        this.htrees[i] = next;
                        table_size = ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
                        next += table_size;
                    }
                };
                function DecodeContextMap(context_map_size, br) {
                    var out = {
                        num_htrees: null,
                        context_map: null
                    };
                    var use_rle_for_zeros;
                    var max_run_length_prefix = 0;
                    var table;
                    var i;
                    br.readMoreInput();
                    var num_htrees = out.num_htrees = DecodeVarLenUint8(br) + 1;
                    var context_map = out.context_map = new Uint8Array(context_map_size);
                    if (num_htrees <= 1) return out;
                    use_rle_for_zeros = br.readBits(1);
                    if (use_rle_for_zeros) max_run_length_prefix = br.readBits(4) + 1;
                    table = [];
                    for(i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++)table[i] = new HuffmanCode(0, 0);
                    ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
                    for(i = 0; i < context_map_size;){
                        var code;
                        br.readMoreInput();
                        code = ReadSymbol(table, 0, br);
                        if (code === 0) {
                            context_map[i] = 0;
                            ++i;
                        } else if (code <= max_run_length_prefix) {
                            var reps = 1 + (1 << code) + br.readBits(code);
                            while(--reps){
                                if (i >= context_map_size) throw new Error("[DecodeContextMap] i >= context_map_size");
                                context_map[i] = 0;
                                ++i;
                            }
                        } else {
                            context_map[i] = code - max_run_length_prefix;
                            ++i;
                        }
                    }
                    if (br.readBits(1)) InverseMoveToFrontTransform(context_map, context_map_size);
                    return out;
                }
                function DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
                    var ringbuffer = tree_type * 2;
                    var index = tree_type;
                    var type_code = ReadSymbol(trees, tree_type * HUFFMAN_MAX_TABLE_SIZE, br);
                    var block_type;
                    if (type_code === 0) block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
                    else if (type_code === 1) block_type = ringbuffers[ringbuffer + (indexes[index] - 1 & 1)] + 1;
                    else block_type = type_code - 2;
                    if (block_type >= max_block_type) block_type -= max_block_type;
                    block_types[tree_type] = block_type;
                    ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
                    ++indexes[index];
                }
                function CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
                    var rb_size = ringbuffer_mask + 1;
                    var rb_pos = pos & ringbuffer_mask;
                    var br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
                    var nbytes;
                    /* For short lengths copy byte-by-byte */ if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
                        while(len-- > 0){
                            br.readMoreInput();
                            ringbuffer[rb_pos++] = br.readBits(8);
                            if (rb_pos === rb_size) {
                                output.write(ringbuffer, rb_size);
                                rb_pos = 0;
                            }
                        }
                        return;
                    }
                    if (br.bit_end_pos_ < 32) throw new Error('[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32');
                    /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */ while(br.bit_pos_ < 32){
                        ringbuffer[rb_pos] = br.val_ >>> br.bit_pos_;
                        br.bit_pos_ += 8;
                        ++rb_pos;
                        --len;
                    }
                    /* Copy remaining bytes from br.buf_ to ringbuffer. */ nbytes = br.bit_end_pos_ - br.bit_pos_ >> 3;
                    if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
                        var tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
                        for(var x = 0; x < tail; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
                        nbytes -= tail;
                        rb_pos += tail;
                        len -= tail;
                        br_pos = 0;
                    }
                    for(var x = 0; x < nbytes; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
                    rb_pos += nbytes;
                    len -= nbytes;
                    /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */ if (rb_pos >= rb_size) {
                        output.write(ringbuffer, rb_size);
                        rb_pos -= rb_size;
                        for(var x = 0; x < rb_pos; x++)ringbuffer[x] = ringbuffer[rb_size + x];
                    }
                    /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */ while(rb_pos + len >= rb_size){
                        nbytes = rb_size - rb_pos;
                        if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
                        output.write(ringbuffer, rb_size);
                        len -= nbytes;
                        rb_pos = 0;
                    }
                    /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */ if (br.input_.read(ringbuffer, rb_pos, len) < len) throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
                    /* Restore the state of the bit reader. */ br.reset();
                }
                /* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */ function JumpToByteBoundary(br) {
                    var new_bit_pos = br.bit_pos_ + 7 & -8;
                    var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
                    return pad_bits == 0;
                }
                function BrotliDecompressedSize(buffer) {
                    var input = new BrotliInput(buffer);
                    var br = new BrotliBitReader(input);
                    DecodeWindowBits(br);
                    var out = DecodeMetaBlockLength(br);
                    return out.meta_block_length;
                }
                __webpack_unused_export__ = BrotliDecompressedSize;
                function BrotliDecompressBuffer(buffer, output_size) {
                    var input = new BrotliInput(buffer);
                    if (output_size == null) output_size = BrotliDecompressedSize(buffer);
                    var output_buffer = new Uint8Array(output_size);
                    var output = new BrotliOutput(output_buffer);
                    BrotliDecompress(input, output);
                    if (output.pos < output.buffer.length) output.buffer = output.buffer.subarray(0, output.pos);
                    return output.buffer;
                }
                exports.BrotliDecompressBuffer = BrotliDecompressBuffer;
                function BrotliDecompress(input, output) {
                    var i;
                    var pos = 0;
                    var input_end = 0;
                    var window_bits = 0;
                    var max_backward_distance;
                    var max_distance = 0;
                    var ringbuffer_size;
                    var ringbuffer_mask;
                    var ringbuffer;
                    var ringbuffer_end;
                    /* This ring buffer holds a few past copy distances that will be used by */ /* some special distance codes. */ var dist_rb = [
                        16,
                        15,
                        11,
                        4
                    ];
                    var dist_rb_idx = 0;
                    /* The previous 2 bytes used for context. */ var prev_byte1 = 0;
                    var prev_byte2 = 0;
                    var hgroup = [
                        new HuffmanTreeGroup(0, 0),
                        new HuffmanTreeGroup(0, 0),
                        new HuffmanTreeGroup(0, 0)
                    ];
                    var block_type_trees;
                    var block_len_trees;
                    var br;
                    /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */ var kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;
                    br = new BrotliBitReader(input);
                    /* Decode window size. */ window_bits = DecodeWindowBits(br);
                    max_backward_distance = (1 << window_bits) - 16;
                    ringbuffer_size = 1 << window_bits;
                    ringbuffer_mask = ringbuffer_size - 1;
                    ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + BrotliDictionary.maxDictionaryWordLength);
                    ringbuffer_end = ringbuffer_size;
                    block_type_trees = [];
                    block_len_trees = [];
                    for(var x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++){
                        block_type_trees[x] = new HuffmanCode(0, 0);
                        block_len_trees[x] = new HuffmanCode(0, 0);
                    }
                    while(!input_end){
                        var meta_block_remaining_len = 0;
                        var is_uncompressed;
                        var block_length = [
                            268435456,
                            268435456,
                            268435456
                        ];
                        var block_type = [
                            0
                        ];
                        var num_block_types = [
                            1,
                            1,
                            1
                        ];
                        var block_type_rb = [
                            0,
                            1,
                            0,
                            1,
                            0,
                            1
                        ];
                        var block_type_rb_index = [
                            0
                        ];
                        var distance_postfix_bits;
                        var num_direct_distance_codes;
                        var distance_postfix_mask;
                        var num_distance_codes;
                        var context_map = null;
                        var context_modes = null;
                        var num_literal_htrees;
                        var dist_context_map = null;
                        var num_dist_htrees;
                        var context_offset = 0;
                        var context_map_slice = null;
                        var literal_htree_index = 0;
                        var dist_context_offset = 0;
                        var dist_context_map_slice = null;
                        var dist_htree_index = 0;
                        var context_lookup_offset1 = 0;
                        var context_lookup_offset2 = 0;
                        var context_mode;
                        var htree_command;
                        for(i = 0; i < 3; ++i){
                            hgroup[i].codes = null;
                            hgroup[i].htrees = null;
                        }
                        br.readMoreInput();
                        var _out = DecodeMetaBlockLength(br);
                        meta_block_remaining_len = _out.meta_block_length;
                        if (pos + meta_block_remaining_len > output.buffer.length) {
                            /* We need to grow the output buffer to fit the additional data. */ var tmp = new Uint8Array(pos + meta_block_remaining_len);
                            tmp.set(output.buffer);
                            output.buffer = tmp;
                        }
                        input_end = _out.input_end;
                        is_uncompressed = _out.is_uncompressed;
                        if (_out.is_metadata) {
                            JumpToByteBoundary(br);
                            for(; meta_block_remaining_len > 0; --meta_block_remaining_len){
                                br.readMoreInput();
                                /* Read one byte and ignore it. */ br.readBits(8);
                            }
                            continue;
                        }
                        if (meta_block_remaining_len === 0) continue;
                        if (is_uncompressed) {
                            br.bit_pos_ = br.bit_pos_ + 7 & -8;
                            CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos, ringbuffer, ringbuffer_mask, br);
                            pos += meta_block_remaining_len;
                            continue;
                        }
                        for(i = 0; i < 3; ++i){
                            num_block_types[i] = DecodeVarLenUint8(br) + 1;
                            if (num_block_types[i] >= 2) {
                                ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                                ReadHuffmanCode(kNumBlockLengthCodes, block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                                block_length[i] = ReadBlockLength(block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                                block_type_rb_index[i] = 1;
                            }
                        }
                        br.readMoreInput();
                        distance_postfix_bits = br.readBits(2);
                        num_direct_distance_codes = NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
                        distance_postfix_mask = (1 << distance_postfix_bits) - 1;
                        num_distance_codes = num_direct_distance_codes + (48 << distance_postfix_bits);
                        context_modes = new Uint8Array(num_block_types[0]);
                        for(i = 0; i < num_block_types[0]; ++i){
                            br.readMoreInput();
                            context_modes[i] = br.readBits(2) << 1;
                        }
                        var _o1 = DecodeContextMap(num_block_types[0] << kLiteralContextBits, br);
                        num_literal_htrees = _o1.num_htrees;
                        context_map = _o1.context_map;
                        var _o2 = DecodeContextMap(num_block_types[2] << kDistanceContextBits, br);
                        num_dist_htrees = _o2.num_htrees;
                        dist_context_map = _o2.context_map;
                        hgroup[0] = new HuffmanTreeGroup(kNumLiteralCodes, num_literal_htrees);
                        hgroup[1] = new HuffmanTreeGroup(kNumInsertAndCopyCodes, num_block_types[1]);
                        hgroup[2] = new HuffmanTreeGroup(num_distance_codes, num_dist_htrees);
                        for(i = 0; i < 3; ++i)hgroup[i].decode(br);
                        context_map_slice = 0;
                        dist_context_map_slice = 0;
                        context_mode = context_modes[block_type[0]];
                        context_lookup_offset1 = Context.lookupOffsets[context_mode];
                        context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
                        htree_command = hgroup[1].htrees[0];
                        while(meta_block_remaining_len > 0){
                            var cmd_code;
                            var range_idx;
                            var insert_code;
                            var copy_code;
                            var insert_length;
                            var copy_length;
                            var distance_code;
                            var distance;
                            var context;
                            var j;
                            var copy_dst;
                            br.readMoreInput();
                            if (block_length[1] === 0) {
                                DecodeBlockType(num_block_types[1], block_type_trees, 1, block_type, block_type_rb, block_type_rb_index, br);
                                block_length[1] = ReadBlockLength(block_len_trees, HUFFMAN_MAX_TABLE_SIZE, br);
                                htree_command = hgroup[1].htrees[block_type[1]];
                            }
                            --block_length[1];
                            cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
                            range_idx = cmd_code >> 6;
                            if (range_idx >= 2) {
                                range_idx -= 2;
                                distance_code = -1;
                            } else distance_code = 0;
                            insert_code = Prefix.kInsertRangeLut[range_idx] + (cmd_code >> 3 & 7);
                            copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
                            insert_length = Prefix.kInsertLengthPrefixCode[insert_code].offset + br.readBits(Prefix.kInsertLengthPrefixCode[insert_code].nbits);
                            copy_length = Prefix.kCopyLengthPrefixCode[copy_code].offset + br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
                            prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
                            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
                            for(j = 0; j < insert_length; ++j){
                                br.readMoreInput();
                                if (block_length[0] === 0) {
                                    DecodeBlockType(num_block_types[0], block_type_trees, 0, block_type, block_type_rb, block_type_rb_index, br);
                                    block_length[0] = ReadBlockLength(block_len_trees, 0, br);
                                    context_offset = block_type[0] << kLiteralContextBits;
                                    context_map_slice = context_offset;
                                    context_mode = context_modes[block_type[0]];
                                    context_lookup_offset1 = Context.lookupOffsets[context_mode];
                                    context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
                                }
                                context = Context.lookup[context_lookup_offset1 + prev_byte1] | Context.lookup[context_lookup_offset2 + prev_byte2];
                                literal_htree_index = context_map[context_map_slice + context];
                                --block_length[0];
                                prev_byte2 = prev_byte1;
                                prev_byte1 = ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
                                ringbuffer[pos & ringbuffer_mask] = prev_byte1;
                                if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                                ++pos;
                            }
                            meta_block_remaining_len -= insert_length;
                            if (meta_block_remaining_len <= 0) break;
                            if (distance_code < 0) {
                                var context;
                                br.readMoreInput();
                                if (block_length[2] === 0) {
                                    DecodeBlockType(num_block_types[2], block_type_trees, 2, block_type, block_type_rb, block_type_rb_index, br);
                                    block_length[2] = ReadBlockLength(block_len_trees, 2 * HUFFMAN_MAX_TABLE_SIZE, br);
                                    dist_context_offset = block_type[2] << kDistanceContextBits;
                                    dist_context_map_slice = dist_context_offset;
                                }
                                --block_length[2];
                                context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
                                dist_htree_index = dist_context_map[dist_context_map_slice + context];
                                distance_code = ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
                                if (distance_code >= num_direct_distance_codes) {
                                    var nbits;
                                    var postfix;
                                    var offset;
                                    distance_code -= num_direct_distance_codes;
                                    postfix = distance_code & distance_postfix_mask;
                                    distance_code >>= distance_postfix_bits;
                                    nbits = (distance_code >> 1) + 1;
                                    offset = (2 + (distance_code & 1) << nbits) - 4;
                                    distance_code = num_direct_distance_codes + (offset + br.readBits(nbits) << distance_postfix_bits) + postfix;
                                }
                            }
                            /* Convert the distance code to the actual distance by possibly looking */ /* up past distnaces from the ringbuffer. */ distance = TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
                            if (distance < 0) throw new Error('[BrotliDecompress] invalid distance');
                            if (pos < max_backward_distance && max_distance !== max_backward_distance) max_distance = pos;
                            else max_distance = max_backward_distance;
                            copy_dst = pos & ringbuffer_mask;
                            if (distance > max_distance) {
                                if (copy_length >= BrotliDictionary.minDictionaryWordLength && copy_length <= BrotliDictionary.maxDictionaryWordLength) {
                                    var offset = BrotliDictionary.offsetsByLength[copy_length];
                                    var word_id = distance - max_distance - 1;
                                    var shift = BrotliDictionary.sizeBitsByLength[copy_length];
                                    var mask = (1 << shift) - 1;
                                    var word_idx = word_id & mask;
                                    var transform_idx = word_id >> shift;
                                    offset += word_idx * copy_length;
                                    if (transform_idx < Transform.kNumTransforms) {
                                        var len = Transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
                                        copy_dst += len;
                                        pos += len;
                                        meta_block_remaining_len -= len;
                                        if (copy_dst >= ringbuffer_end) {
                                            output.write(ringbuffer, ringbuffer_size);
                                            for(var _x = 0; _x < copy_dst - ringbuffer_end; _x++)ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                                        }
                                    } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                                } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                            } else {
                                if (distance_code > 0) {
                                    dist_rb[dist_rb_idx & 3] = distance;
                                    ++dist_rb_idx;
                                }
                                if (copy_length > meta_block_remaining_len) throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                                for(j = 0; j < copy_length; ++j){
                                    ringbuffer[pos & ringbuffer_mask] = ringbuffer[pos - distance & ringbuffer_mask];
                                    if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                                    ++pos;
                                    --meta_block_remaining_len;
                                }
                            }
                            /* When we get here, we must have inserted at least one literal and */ /* made a copy of at least length two, therefore accessing the last 2 */ /* bytes is valid. */ prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
                            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
                        }
                        /* Protect pos from overflow, wrap it around at every GB of input data */ pos &= 0x3fffffff;
                    }
                    output.write(ringbuffer, pos & ringbuffer_mask);
                }
                __webpack_unused_export__ = BrotliDecompress;
                BrotliDictionary.init();
            /***/ },
            /***/ 21012: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $filter = __webpack_require__(91102).filter;
                var fromSpeciesAndList = __webpack_require__(59610);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.filter` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
                exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */ ) {
                    var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    return fromSpeciesAndList(this, list);
                });
            /***/ },
            /***/ 21166: /***/ function(module1) {
                "use strict";
                module1.exports = /*#__PURE__*/ JSON.parse('[["0","\\u0000",127],["8141","\uAC02\uAC03\uAC05\uAC06\uAC0B",4,"\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25",6,"\uAC2E\uAC32\uAC33\uAC34"],["8161","\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41",9,"\uAC4C\uAC4E",5,"\uAC55"],["8181","\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D",18,"\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B",4,"\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95",6,"\uAC9E\uACA2",5,"\uACAB\uACAD\uACAE\uACB1",6,"\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD",7,"\uACD6\uACD8",7,"\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7",4,"\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07",4,"\uAD0E\uAD10\uAD12\uAD13"],["8241","\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21",7,"\uAD2A\uAD2B\uAD2E",5],["8261","\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D",6,"\uAD46\uAD48\uAD4A",5,"\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57"],["8281","\uAD59",7,"\uAD62\uAD64",7,"\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83",4,"\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91",10,"\uAD9E",5,"\uADA5",17,"\uADB8",7,"\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9",6,"\uADD2\uADD4",7,"\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5",18],["8341","\uADFA\uADFB\uADFD\uADFE\uAE02",5,"\uAE0A\uAE0C\uAE0E",5,"\uAE15",7],["8361","\uAE1D",18,"\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C"],["8381","\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57",4,"\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71",6,"\uAE7A\uAE7E",5,"\uAE86",5,"\uAE8D",46,"\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5",6,"\uAECE\uAED2",5,"\uAEDA\uAEDB\uAEDD",8],["8441","\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE",5,"\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD",8],["8461","\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11",18],["8481","\uAF24",7,"\uAF2E\uAF2F\uAF31\uAF33\uAF35",6,"\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A",5,"\uAF51",10,"\uAF5E",5,"\uAF66",18,"\uAF7A",5,"\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89",6,"\uAF92\uAF93\uAF94\uAF96",5,"\uAF9D",26,"\uAFBA\uAFBB\uAFBD\uAFBE"],["8541","\uAFBF\uAFC1",5,"\uAFCA\uAFCC\uAFCF",4,"\uAFD5",6,"\uAFDD",4],["8561","\uAFE2",5,"\uAFEA",5,"\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9",6,"\uB002\uB003"],["8581","\uB005",6,"\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015",6,"\uB01E",9,"\uB029",26,"\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E",29,"\uB07E\uB07F\uB081\uB082\uB083\uB085",6,"\uB08E\uB090\uB092",5,"\uB09B\uB09D\uB09E\uB0A3\uB0A4"],["8641","\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD",6,"\uB0C6\uB0CA",5,"\uB0D2"],["8661","\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9",6,"\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6",10],["8681","\uB0F1",22,"\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E",4,"\uB126\uB127\uB129\uB12A\uB12B\uB12D",6,"\uB136\uB13A",5,"\uB142\uB143\uB145\uB146\uB147\uB149",6,"\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161",22,"\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183",4,"\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D"],["8741","\uB19E",9,"\uB1A9",15],["8761","\uB1B9",18,"\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5"],["8781","\uB1D6",5,"\uB1DE\uB1E0",7,"\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1",7,"\uB1FA\uB1FC\uB1FE",5,"\uB206\uB207\uB209\uB20A\uB20D",6,"\uB216\uB218\uB21A",5,"\uB221",18,"\uB235",6,"\uB23D",26,"\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261",6,"\uB26A",4],["8841","\uB26F",4,"\uB276",5,"\uB27D",6,"\uB286\uB287\uB288\uB28A",4],["8861","\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B",4,"\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7"],["8881","\uB2B8",15,"\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3",4,"\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309",6,"\uB312\uB316",5,"\uB31D",54,"\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363"],["8941","\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379",6,"\uB382\uB386",5,"\uB38D"],["8961","\uB38E\uB38F\uB391\uB392\uB393\uB395",10,"\uB3A2",5,"\uB3A9\uB3AA\uB3AB\uB3AD"],["8981","\uB3AE",21,"\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9",18,"\uB3FD",18,"\uB411",6,"\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421",6,"\uB42A\uB42C",7,"\uB435",15],["8a41","\uB445",10,"\uB452\uB453\uB455\uB456\uB457\uB459",6,"\uB462\uB464\uB466"],["8a61","\uB467",4,"\uB46D",18,"\uB481\uB482"],["8a81","\uB483",4,"\uB489",19,"\uB49E",5,"\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD",7,"\uB4B6\uB4B8\uB4BA",5,"\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9",6,"\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6",5,"\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7",4,"\uB4EE\uB4F0\uB4F2",5,"\uB4F9",26,"\uB516\uB517\uB519\uB51A\uB51D"],["8b41","\uB51E",5,"\uB526\uB52B",4,"\uB532\uB533\uB535\uB536\uB537\uB539",6,"\uB542\uB546"],["8b61","\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555",6,"\uB55E\uB562",8],["8b81","\uB56B",52,"\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6",4,"\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5",6,"\uB5CE\uB5D2",5,"\uB5D9",18,"\uB5ED",18],["8c41","\uB600",15,"\uB612\uB613\uB615\uB616\uB617\uB619",4],["8c61","\uB61E",6,"\uB626",5,"\uB62D",6,"\uB635",5],["8c81","\uB63B",12,"\uB649",26,"\uB665\uB666\uB667\uB669",50,"\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5",5,"\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2",16],["8d41","\uB6C3",16,"\uB6D5",8],["8d61","\uB6DE",17,"\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA"],["8d81","\uB6FB",4,"\uB702\uB703\uB704\uB706",33,"\uB72A\uB72B\uB72D\uB72E\uB731",6,"\uB73A\uB73C",7,"\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D",6,"\uB756",9,"\uB761\uB762\uB763\uB765\uB766\uB767\uB769",6,"\uB772\uB774\uB776",5,"\uB77E\uB77F\uB781\uB782\uB783\uB785",6,"\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E"],["8e41","\uB79F\uB7A1",6,"\uB7AA\uB7AE",5,"\uB7B6\uB7B7\uB7B9",8],["8e61","\uB7C2",4,"\uB7C8\uB7CA",19],["8e81","\uB7DE",13,"\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5",6,"\uB7FE\uB802",4,"\uB80A\uB80B\uB80D\uB80E\uB80F\uB811",6,"\uB81A\uB81C\uB81E",5,"\uB826\uB827\uB829\uB82A\uB82B\uB82D",6,"\uB836\uB83A",5,"\uB841\uB842\uB843\uB845",11,"\uB852\uB854",7,"\uB85E\uB85F\uB861\uB862\uB863\uB865",6,"\uB86E\uB870\uB872",5,"\uB879\uB87A\uB87B\uB87D",7],["8f41","\uB885",7,"\uB88E",17],["8f61","\uB8A0",7,"\uB8A9",6,"\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9",4],["8f81","\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6",5,"\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5",7,"\uB8DE\uB8E0\uB8E2",5,"\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1",6,"\uB8FA\uB8FC\uB8FE",5,"\uB905",18,"\uB919",6,"\uB921",26,"\uB93E\uB93F\uB941\uB942\uB943\uB945",6,"\uB94D\uB94E\uB950\uB952",5],["9041","\uB95A\uB95B\uB95D\uB95E\uB95F\uB961",6,"\uB96A\uB96C\uB96E",5,"\uB976\uB977\uB979\uB97A\uB97B\uB97D"],["9061","\uB97E",5,"\uB986\uB988\uB98B\uB98C\uB98F",15],["9081","\uB99F",12,"\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5",6,"\uB9BE\uB9C0\uB9C2",5,"\uB9CA\uB9CB\uB9CD\uB9D3",4,"\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED",6,"\uB9F6\uB9FB",4,"\uBA02",5,"\uBA09",11,"\uBA16",33,"\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46"],["9141","\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D",6,"\uBA66\uBA6A",5],["9161","\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79",9,"\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D",5],["9181","\uBA93",20,"\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3",4,"\uBABA\uBABC\uBABE",5,"\uBAC5\uBAC6\uBAC7\uBAC9",14,"\uBADA",33,"\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05",7,"\uBB0E\uBB10\uBB12",5,"\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21",6],["9241","\uBB28\uBB2A\uBB2C",7,"\uBB37\uBB39\uBB3A\uBB3F",4,"\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52"],["9261","\uBB53\uBB55\uBB56\uBB57\uBB59",7,"\uBB62\uBB64",7,"\uBB6D",4],["9281","\uBB72",21,"\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91",18,"\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD",6,"\uBBB5\uBBB6\uBBB8",7,"\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9",6,"\uBBD1\uBBD2\uBBD4",35,"\uBBFA\uBBFB\uBBFD\uBBFE\uBC01"],["9341","\uBC03",4,"\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35"],["9361","\uBC36\uBC37\uBC39",6,"\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51",8],["9381","\uBC5A\uBC5B\uBC5C\uBC5E",37,"\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F",4,"\uBC96\uBC98\uBC9B",4,"\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9",6,"\uBCB2\uBCB6",5,"\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5",7,"\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD",22,"\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD"],["9441","\uBCFE",5,"\uBD06\uBD08\uBD0A",5,"\uBD11\uBD12\uBD13\uBD15",8],["9461","\uBD1E",5,"\uBD25",6,"\uBD2D",12],["9481","\uBD3A",5,"\uBD41",6,"\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51",6,"\uBD5A",9,"\uBD65\uBD66\uBD67\uBD69",22,"\uBD82\uBD83\uBD85\uBD86\uBD8B",4,"\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D",6,"\uBDA5",10,"\uBDB1",6,"\uBDB9",24],["9541","\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD",11,"\uBDEA",5,"\uBDF1"],["9561","\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9",6,"\uBE01\uBE02\uBE04\uBE06",5,"\uBE0E\uBE0F\uBE11\uBE12\uBE13"],["9581","\uBE15",6,"\uBE1E\uBE20",35,"\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F",4,"\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B",4,"\uBE72\uBE76",4,"\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85",6,"\uBE8E\uBE92",5,"\uBE9A",13,"\uBEA9",14],["9641","\uBEB8",23,"\uBED2\uBED3"],["9661","\uBED5\uBED6\uBED9",6,"\uBEE1\uBEE2\uBEE6",5,"\uBEED",8],["9681","\uBEF6",10,"\uBF02",5,"\uBF0A",13,"\uBF1A\uBF1E",33,"\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49",6,"\uBF52\uBF53\uBF54\uBF56",44],["9741","\uBF83",16,"\uBF95",8],["9761","\uBF9E",17,"\uBFB1",7],["9781","\uBFB9",11,"\uBFC6",5,"\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5",6,"\uBFDD\uBFDE\uBFE0\uBFE2",89,"\uC03D\uC03E\uC03F"],["9841","\uC040",16,"\uC052",5,"\uC059\uC05A\uC05B"],["9861","\uC05D\uC05E\uC05F\uC061",6,"\uC06A",15],["9881","\uC07A",21,"\uC092\uC093\uC095\uC096\uC097\uC099",6,"\uC0A2\uC0A4\uC0A6",5,"\uC0AE\uC0B1\uC0B2\uC0B7",4,"\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1",6,"\uC0DA\uC0DE",5,"\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED",6,"\uC0F6\uC0F8\uC0FA",5,"\uC101\uC102\uC103\uC105\uC106\uC107\uC109",6,"\uC111\uC112\uC113\uC114\uC116",5,"\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E"],["9941","\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141",6,"\uC14A\uC14E",5,"\uC156\uC157"],["9961","\uC159\uC15A\uC15B\uC15D",6,"\uC166\uC16A",5,"\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B"],["9981","\uC17C",8,"\uC186",5,"\uC18F\uC191\uC192\uC193\uC195\uC197",4,"\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1",11,"\uC1BE",5,"\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD",6,"\uC1D5\uC1D6\uC1D9",6,"\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9",6,"\uC1F2\uC1F4",7,"\uC1FE\uC1FF\uC201\uC202\uC203\uC205",6,"\uC20E\uC210\uC212",5,"\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223"],["9a41","\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235",16],["9a61","\uC246\uC247\uC249",6,"\uC252\uC253\uC255\uC256\uC257\uC259",6,"\uC261\uC262\uC263\uC264\uC266"],["9a81","\uC267",4,"\uC26E\uC26F\uC271\uC272\uC273\uC275",6,"\uC27E\uC280\uC282",5,"\uC28A",5,"\uC291",6,"\uC299\uC29A\uC29C\uC29E",5,"\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE",5,"\uC2B6\uC2B8\uC2BA",33,"\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5",5,"\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301",6,"\uC30A\uC30B\uC30E\uC30F"],["9b41","\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D",6,"\uC326\uC327\uC32A",8],["9b61","\uC333",17,"\uC346",7],["9b81","\uC34E",25,"\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373",4,"\uC37A\uC37B\uC37E",5,"\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D",50,"\uC3C1",22,"\uC3DA"],["9c41","\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3",4,"\uC3EA\uC3EB\uC3EC\uC3EE",5,"\uC3F6\uC3F7\uC3F9",5],["9c61","\uC3FF",8,"\uC409",6,"\uC411",9],["9c81","\uC41B",8,"\uC425",6,"\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435",6,"\uC43E",9,"\uC449",26,"\uC466\uC467\uC469\uC46A\uC46B\uC46D",6,"\uC476\uC477\uC478\uC47A",5,"\uC481",18,"\uC495",6,"\uC49D",12],["9d41","\uC4AA",13,"\uC4B9\uC4BA\uC4BB\uC4BD",8],["9d61","\uC4C6",25],["9d81","\uC4E0",8,"\uC4EA",5,"\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502",9,"\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515",6,"\uC51D",10,"\uC52A\uC52B\uC52D\uC52E\uC52F\uC531",6,"\uC53A\uC53C\uC53E",5,"\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569",6,"\uC572\uC576",5,"\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594"],["9e41","\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1",7,"\uC5AA",9,"\uC5B6"],["9e61","\uC5B7\uC5BA\uC5BF",4,"\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9",6,"\uC5E2\uC5E4\uC5E6\uC5E7"],["9e81","\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611",6,"\uC61A\uC61D",6,"\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649",6,"\uC652\uC656",5,"\uC65E\uC65F\uC661",10,"\uC66D\uC66E\uC670\uC672",5,"\uC67A\uC67B\uC67D\uC67E\uC67F\uC681",6,"\uC68A\uC68C\uC68E",5,"\uC696\uC697\uC699\uC69A\uC69B\uC69D",6,"\uC6A6"],["9f41","\uC6A8\uC6AA",5,"\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB",4,"\uC6C2\uC6C4\uC6C6",5,"\uC6CE"],["9f61","\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5",6,"\uC6DE\uC6DF\uC6E2",5,"\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2"],["9f81","\uC6F3",4,"\uC6FA\uC6FB\uC6FC\uC6FE",5,"\uC706\uC707\uC709\uC70A\uC70B\uC70D",6,"\uC716\uC718\uC71A",5,"\uC722\uC723\uC725\uC726\uC727\uC729",6,"\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745",4,"\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761",6,"\uC769\uC76A\uC76C",7,"\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B",4,"\uC7A2\uC7A7",4,"\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7"],["a041","\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2",5,"\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1",6,"\uC7D9\uC7DA\uC7DB\uC7DC"],["a061","\uC7DE",5,"\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED",13],["a081","\uC7FB",4,"\uC802\uC803\uC805\uC806\uC807\uC809\uC80B",4,"\uC812\uC814\uC817",4,"\uC81E\uC81F\uC821\uC822\uC823\uC825",6,"\uC82E\uC830\uC832",5,"\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841",6,"\uC84A\uC84B\uC84E",5,"\uC855",26,"\uC872\uC873\uC875\uC876\uC877\uC879\uC87B",4,"\uC882\uC884\uC888\uC889\uC88A\uC88E",5,"\uC895",7,"\uC89E\uC8A0\uC8A2\uC8A3\uC8A4"],["a141","\uC8A5\uC8A6\uC8A7\uC8A9",18,"\uC8BE\uC8BF\uC8C0\uC8C1"],["a161","\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD",6,"\uC8D6\uC8D8\uC8DA",5,"\uC8E2\uC8E3\uC8E5"],["a181","\uC8E6",14,"\uC8F6",5,"\uC8FE\uC8FF\uC901\uC902\uC903\uC907",4,"\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008",9,"\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2"],["a241","\uC910\uC912",5,"\uC919",18],["a261","\uC92D",6,"\uC935",18],["a281","\uC948",7,"\uC952\uC953\uC955\uC956\uC957\uC959",6,"\uC962\uC964",7,"\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae"],["a341","\uC971\uC972\uC973\uC975",6,"\uC97D",10,"\uC98A\uC98B\uC98D\uC98E\uC98F"],["a361","\uC991",6,"\uC99A\uC99C\uC99E",16],["a381","\uC9AF",16,"\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB",4,"\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01",58,"\uFFE6\uFF3D",32,"\uFFE3"],["a441","\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2",5,"\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04"],["a461","\uCA05\uCA06\uCA07\uCA0A\uCA0E",5,"\uCA15\uCA16\uCA17\uCA19",12],["a481","\uCA26\uCA27\uCA28\uCA2A",28,"\u3131",93],["a541","\uCA47",4,"\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55",6,"\uCA5E\uCA62",5,"\uCA69\uCA6A"],["a561","\uCA6B",17,"\uCA7E",5,"\uCA85\uCA86"],["a581","\uCA87",16,"\uCA99",14,"\u2170",9],["a5b0","\u2160",9],["a5c1","\u0391",16,"\u03A3",6],["a5e1","\u03B1",16,"\u03C3",6],["a641","\uCAA8",19,"\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5"],["a661","\uCAC6",5,"\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA",5,"\uCAE1",6],["a681","\uCAE8\uCAE9\uCAEA\uCAEB\uCAED",6,"\uCAF5",18,"\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543",7],["a741","\uCB0B",4,"\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19",6,"\uCB22",7],["a761","\uCB2A",22,"\uCB42\uCB43\uCB44"],["a781","\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51",6,"\uCB5A\uCB5B\uCB5C\uCB5E",5,"\uCB65",7,"\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399",9,"\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0",9,"\u3380",4,"\u33BA",5,"\u3390",4,"\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6"],["a841","\uCB6D",10,"\uCB7A",14],["a861","\uCB89",18,"\uCB9D",6],["a881","\uCBA4",19,"\uCBB9",11,"\xc6\xd0\xaa\u0126"],["a8a6","\u0132"],["a8a8","\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A"],["a8b1","\u3260",27,"\u24D0",25,"\u2460",14,"\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E"],["a941","\uCBC5",14,"\uCBD5",10],["a961","\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA",18],["a981","\uCBFD",14,"\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15",6,"\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200",27,"\u249C",25,"\u2474",14,"\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084"],["aa41","\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31",6,"\uCC3A\uCC3F",4,"\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E"],["aa61","\uCC4F",4,"\uCC56\uCC5A",5,"\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69",6,"\uCC71\uCC72"],["aa81","\uCC73\uCC74\uCC76",29,"\u3041",82],["ab41","\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1",6,"\uCCAA\uCCAE",5,"\uCCB6\uCCB7\uCCB9"],["ab61","\uCCBA\uCCBB\uCCBD",6,"\uCCC6\uCCC8\uCCCA",5,"\uCCD1\uCCD2\uCCD3\uCCD5",5],["ab81","\uCCDB",8,"\uCCE5",6,"\uCCED\uCCEE\uCCEF\uCCF1",12,"\u30A1",85],["ac41","\uCCFE\uCCFF\uCD00\uCD02",5,"\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11",6,"\uCD1A\uCD1C\uCD1E\uCD1F\uCD20"],["ac61","\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D",11,"\uCD3A",4],["ac81","\uCD3F",28,"\uCD5D\uCD5E\uCD5F\u0410",5,"\u0401\u0416",25],["acd1","\u0430",5,"\u0451\u0436",25],["ad41","\uCD61\uCD62\uCD63\uCD65",6,"\uCD6E\uCD70\uCD72",5,"\uCD79",7],["ad61","\uCD81",6,"\uCD89",10,"\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F"],["ad81","\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA",5,"\uCDB1",18,"\uCDC5"],["ae41","\uCDC6",5,"\uCDCD\uCDCE\uCDCF\uCDD1",16],["ae61","\uCDE2",5,"\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1",6,"\uCDFA\uCDFC\uCDFE",4],["ae81","\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D",6,"\uCE15\uCE16\uCE17\uCE18\uCE1A",5,"\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B"],["af41","\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36",19],["af61","\uCE4A",13,"\uCE5A\uCE5B\uCE5D\uCE5E\uCE62",5,"\uCE6A\uCE6C"],["af81","\uCE6E",5,"\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D",6,"\uCE86\uCE88\uCE8A",5,"\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99"],["b041","\uCE9A",5,"\uCEA2\uCEA6",5,"\uCEAE",12],["b061","\uCEBB",5,"\uCEC2",19],["b081","\uCED6",13,"\uCEE6\uCEE7\uCEE9\uCEEA\uCEED",6,"\uCEF6\uCEFA",5,"\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10",7,"\uAC19",4,"\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06"],["b141","\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09",6,"\uCF12\uCF14\uCF16",5,"\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23"],["b161","\uCF25",6,"\uCF2E\uCF32",5,"\uCF39",11],["b181","\uCF45",14,"\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D",6,"\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78"],["b241","\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79",6,"\uCF81\uCF82\uCF83\uCF84\uCF86",5,"\uCF8D"],["b261","\uCF8E",18,"\uCFA2",5,"\uCFA9"],["b281","\uCFAA",5,"\uCFB1",18,"\uCFC5",6,"\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059"],["b341","\uCFCC",19,"\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9"],["b361","\uCFEA",5,"\uCFF2\uCFF4\uCFF6",5,"\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005",5],["b381","\uD00B",5,"\uD012",5,"\uD019",19,"\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB",4,"\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD"],["b441","\uD02E",5,"\uD036\uD037\uD039\uD03A\uD03B\uD03D",6,"\uD046\uD048\uD04A",5],["b461","\uD051\uD052\uD053\uD055\uD056\uD057\uD059",6,"\uD061",10,"\uD06E\uD06F"],["b481","\uD071\uD072\uD073\uD075",6,"\uD07E\uD07F\uD080\uD082",18,"\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB",4,"\uB2F3\uB2F4\uB2F5\uB2F7",4,"\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365"],["b541","\uD095",14,"\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD",5],["b561","\uD0B3\uD0B6\uD0B8\uD0BA",5,"\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA",5,"\uD0D2\uD0D6",4],["b581","\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5",6,"\uD0EE\uD0F2",5,"\uD0F9",11,"\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538"],["b641","\uD105",7,"\uD10E",17],["b661","\uD120",15,"\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E"],["b681","\uD13F\uD142\uD146",5,"\uD14E\uD14F\uD151\uD152\uD153\uD155",6,"\uD15E\uD160\uD162",5,"\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797"],["b741","\uD16E",13,"\uD17D",6,"\uD185\uD186\uD187\uD189\uD18A"],["b761","\uD18B",20,"\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7"],["b781","\uD1A9",6,"\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1",14,"\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969"],["b841","\uD1D0",7,"\uD1D9",17],["b861","\uD1EB",8,"\uD1F5\uD1F6\uD1F7\uD1F9",13],["b881","\uD208\uD20A",5,"\uD211",24,"\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE",4,"\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC"],["b941","\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235",6,"\uD23E\uD240\uD242",5,"\uD249\uD24A\uD24B\uD24C"],["b961","\uD24D",14,"\uD25D",6,"\uD265\uD266\uD267\uD268"],["b981","\uD269",22,"\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14",4,"\uBC1B",4,"\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97"],["ba41","\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296",5,"\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5",6,"\uD2AD"],["ba61","\uD2AE\uD2AF\uD2B0\uD2B2",5,"\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3",4,"\uD2CA\uD2CC",5],["ba81","\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD",6,"\uD2E6",9,"\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64"],["bb41","\uD2FB",4,"\uD302\uD304\uD306",5,"\uD30F\uD311\uD312\uD313\uD315\uD317",4,"\uD31E\uD322\uD323"],["bb61","\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331",6,"\uD33A\uD33E",5,"\uD346\uD347\uD348\uD349"],["bb81","\uD34A",31,"\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4"],["bc41","\uD36A",17,"\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387"],["bc61","\uD388\uD389\uD38A\uD38B\uD38E\uD392",5,"\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1",6,"\uD3AA\uD3AC\uD3AE"],["bc81","\uD3AF",4,"\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD",6,"\uD3C6\uD3C7\uD3CA",5,"\uD3D1",5,"\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C",4,"\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D"],["bd41","\uD3D7\uD3D9",7,"\uD3E2\uD3E4",7,"\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7"],["bd61","\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402",5,"\uD409",13],["bd81","\uD417",5,"\uD41E",25,"\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430"],["be41","\uD438",7,"\uD441\uD442\uD443\uD445",14],["be61","\uD454",7,"\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465",7,"\uD46E\uD470\uD471\uD472"],["be81","\uD473",4,"\uD47A\uD47B\uD47D\uD47E\uD481\uD483",4,"\uD48A\uD48C\uD48E",5,"\uD495",8,"\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4",6,"\uC5CC\uC5CE"],["bf41","\uD49E",10,"\uD4AA",14],["bf61","\uD4B9",18,"\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5"],["bf81","\uD4D6",5,"\uD4DD\uD4DE\uD4E0",7,"\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1",6,"\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC",5,"\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8"],["c041","\uD4FE",5,"\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D",6,"\uD516\uD518",5],["c061","\uD51E",25],["c081","\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545",6,"\uD54E\uD550\uD552",5,"\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751",7,"\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A"],["c141","\uD564\uD566\uD567\uD56A\uD56C\uD56E",5,"\uD576\uD577\uD579\uD57A\uD57B\uD57D",6,"\uD586\uD58A\uD58B"],["c161","\uD58C\uD58D\uD58E\uD58F\uD591",19,"\uD5A6\uD5A7"],["c181","\uD5A8",31,"\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3"],["c241","\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3",4,"\uD5DA\uD5DC\uD5DE",5,"\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE"],["c261","\uD5EF",4,"\uD5F6\uD5F8\uD5FA",5,"\uD602\uD603\uD605\uD606\uD607\uD609",6,"\uD612"],["c281","\uD616",5,"\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625",7,"\uD62E",9,"\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B"],["c341","\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D",4],["c361","\uD662",4,"\uD668\uD66A",5,"\uD672\uD673\uD675",11],["c381","\uD681\uD682\uD684\uD686",5,"\uD68E\uD68F\uD691\uD692\uD693\uD695",7,"\uD69E\uD6A0\uD6A2",5,"\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35"],["c441","\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1",7,"\uD6BA\uD6BC",7,"\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB"],["c461","\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA",5,"\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9",4],["c481","\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6",5,"\uD6FE\uD6FF\uD701\uD702\uD703\uD705",11,"\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C"],["c541","\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721",6,"\uD72A\uD72C\uD72E",5,"\uD736\uD737\uD739"],["c561","\uD73A\uD73B\uD73D",6,"\uD745\uD746\uD748\uD74A",5,"\uD752\uD753\uD755\uD75A",4],["c581","\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775",6,"\uD77E\uD77F\uD780\uD782",5,"\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C"],["c641","\uD78D\uD78E\uD78F\uD791",6,"\uD79A\uD79C\uD79E",5],["c6a1","\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401"],["c7a1","\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620"],["c8a1","\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D"],["caa1","\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95"],["cba1","\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2"],["cca1","\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0"],["cda1","\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC"],["cea1","\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE"],["cfa1","\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4"],["d0a1","\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3"],["d1a1","\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E",5,"\u90A3\uF914",4,"\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925"],["d2a1","\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928",4,"\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933",5,"\u99D1\uF939",10,"\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A",7,"\u5AE9\u8A25\u677B\u7D10\uF952",5,"\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336"],["d3a1","\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843"],["d4a1","\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85"],["d5a1","\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23"],["d6a1","\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC"],["d7a1","\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C"],["d8a1","\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5"],["d9a1","\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587"],["daa1","\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51"],["dba1","\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656"],["dca1","\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66"],["dda1","\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5"],["dea1","\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A"],["dfa1","\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72"],["e0a1","\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C"],["e1a1","\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101"],["e2a1","\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27"],["e3a1","\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81"],["e4a1","\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D"],["e5a1","\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982"],["e6a1","\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2"],["e7a1","\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3"],["e8a1","\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1"],["e9a1","\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553"],["eaa1","\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB"],["eba1","\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC"],["eca1","\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344"],["eda1","\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577"],["eea1","\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1"],["efa1","\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756"],["f0a1","\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B"],["f1a1","\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA"],["f2a1","\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F"],["f3a1","\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56"],["f4a1","\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2"],["f5a1","\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403"],["f6a1","\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17"],["f7a1","\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211"],["f8a1","\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43"],["f9a1","\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A"],["faa1","\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B"],["fba1","\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575"],["fca1","\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6"],["fda1","\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70"]]');
            /***/ },
            /***/ 21182: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var anObject = __webpack_require__(34984);
                // `RegExp.prototype.flags` getter implementation
                // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
                module1.exports = function() {
                    var that = anObject(this);
                    var result = '';
                    if (that.global) result += 'g';
                    if (that.ignoreCase) result += 'i';
                    if (that.multiline) result += 'm';
                    if (that.dotAll) result += 's';
                    if (that.unicode) result += 'u';
                    if (that.sticky) result += 'y';
                    return result;
                };
            /***/ },
            /***/ 21594: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var getBuiltIn = __webpack_require__(38486);
                var uncurryThis = __webpack_require__(38347);
                var getOwnPropertyNamesModule = __webpack_require__(6611);
                var getOwnPropertySymbolsModule = __webpack_require__(61146);
                var anObject = __webpack_require__(34984);
                var concat = uncurryThis([].concat);
                // all object keys, includes non-enumerable and symbols
                module1.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
                    var keys = getOwnPropertyNamesModule.f(anObject(it));
                    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
                };
            /***/ },
            /***/ 21983: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var UA = __webpack_require__(40715);
                module1.exports = /MSIE|Trident/.test(UA);
            /***/ },
            /***/ 22367: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                /* eslint-disable space-unary-ops */ var utils = __webpack_require__(72519);
                /* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
                //var Z_HUFFMAN_ONLY      = 2;
                //var Z_RLE               = 3;
                var Z_FIXED = 4;
                //var Z_DEFAULT_STRATEGY  = 0;
                /* Possible values of the data_type field (though see inflate()) */ var Z_BINARY = 0;
                var Z_TEXT = 1;
                //var Z_ASCII             = 1; // = Z_TEXT
                var Z_UNKNOWN = 2;
                /*============================================================================*/ function zero(buf) {
                    var len = buf.length;
                    while(--len >= 0)buf[len] = 0;
                }
                // From zutil.h
                var STORED_BLOCK = 0;
                var STATIC_TREES = 1;
                var DYN_TREES = 2;
                /* The three kinds of block type */ var MIN_MATCH = 3;
                var MAX_MATCH = 258;
                /* The minimum and maximum match lengths */ // From deflate.h
                /* ===========================================================================
 * Internal compression state.
 */ var LENGTH_CODES = 29;
                /* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
                /* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
                /* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
                /* number of distance codes */ var BL_CODES = 19;
                /* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
                /* maximum heap size */ var MAX_BITS = 15;
                /* All codes must not exceed MAX_BITS bits */ var Buf_size = 16;
                /* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var MAX_BL_BITS = 7;
                /* Bit length codes must not exceed MAX_BL_BITS bits */ var END_BLOCK = 256;
                /* end of block literal code */ var REP_3_6 = 16;
                /* repeat previous bit length 3-6 times (2 bits of repeat count) */ var REPZ_3_10 = 17;
                /* repeat a zero length 3-10 times  (3 bits of repeat count) */ var REPZ_11_138 = 18;
                /* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var extra_lbits = /* extra bits for each length code */ [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ];
                var extra_dbits = /* extra bits for each distance code */ [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ];
                var extra_blbits = /* extra bits for each bit length code */ [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ];
                var bl_order = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ];
                /* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
                var DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
                // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
                var static_ltree = new Array((L_CODES + 2) * 2);
                zero(static_ltree);
                /* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var static_dtree = new Array(D_CODES * 2);
                zero(static_dtree);
                /* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var _dist_code = new Array(DIST_CODE_LEN);
                zero(_dist_code);
                /* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
                zero(_length_code);
                /* length code for each normalized match length (0 == MIN_MATCH) */ var base_length = new Array(LENGTH_CODES);
                zero(base_length);
                /* First normalized length for each code (0 = MIN_MATCH) */ var base_dist = new Array(D_CODES);
                zero(base_dist);
                /* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
                    this.static_tree = static_tree; /* static tree or NULL */ 
                    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
                    this.extra_base = extra_base; /* base index for extra_bits */ 
                    this.elems = elems; /* max number of elements in the tree */ 
                    this.max_length = max_length; /* max bit length for the codes */ 
                    // show if `static_tree` has data or dummy - needed for monomorphic objects
                    this.has_stree = static_tree && static_tree.length;
                }
                var static_l_desc;
                var static_d_desc;
                var static_bl_desc;
                function TreeDesc(dyn_tree, stat_desc) {
                    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
                    this.max_code = 0; /* largest code with non zero frequency */ 
                    this.stat_desc = stat_desc; /* the corresponding static tree */ 
                }
                function d_code(dist) {
                    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
                }
                /* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function put_short(s, w) {
                    //    put_byte(s, (uch)((w) & 0xff));
                    //    put_byte(s, (uch)((ush)(w) >> 8));
                    s.pending_buf[s.pending++] = w & 0xff;
                    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
                }
                /* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function send_bits(s, value, length) {
                    if (s.bi_valid > Buf_size - length) {
                        s.bi_buf |= value << s.bi_valid & 0xffff;
                        put_short(s, s.bi_buf);
                        s.bi_buf = value >> Buf_size - s.bi_valid;
                        s.bi_valid += length - Buf_size;
                    } else {
                        s.bi_buf |= value << s.bi_valid & 0xffff;
                        s.bi_valid += length;
                    }
                }
                function send_code(s, c, tree) {
                    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
                }
                /* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function bi_reverse(code, len) {
                    var res = 0;
                    do {
                        res |= code & 1;
                        code >>>= 1;
                        res <<= 1;
                    }while (--len > 0);
                    return res >>> 1;
                }
                /* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function bi_flush(s) {
                    if (s.bi_valid === 16) {
                        put_short(s, s.bi_buf);
                        s.bi_buf = 0;
                        s.bi_valid = 0;
                    } else if (s.bi_valid >= 8) {
                        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                        s.bi_buf >>= 8;
                        s.bi_valid -= 8;
                    }
                }
                /* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function gen_bitlen(s, desc) //    deflate_state *s;
                //    tree_desc *desc;    /* the tree descriptor */
                {
                    var tree = desc.dyn_tree;
                    var max_code = desc.max_code;
                    var stree = desc.stat_desc.static_tree;
                    var has_stree = desc.stat_desc.has_stree;
                    var extra = desc.stat_desc.extra_bits;
                    var base = desc.stat_desc.extra_base;
                    var max_length = desc.stat_desc.max_length;
                    var h; /* heap index */ 
                    var n, m; /* iterate over the tree elements */ 
                    var bits; /* bit length */ 
                    var xbits; /* extra bits */ 
                    var f; /* frequency */ 
                    var overflow = 0; /* number of elements with bit length too large */ 
                    for(bits = 0; bits <= MAX_BITS; bits++)s.bl_count[bits] = 0;
                    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
                    for(h = s.heap_max + 1; h < HEAP_SIZE; h++){
                        n = s.heap[h];
                        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
                        if (bits > max_length) {
                            bits = max_length;
                            overflow++;
                        }
                        tree[n * 2 + 1] = bits;
                        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
                         /* not a leaf node */ 
                        s.bl_count[bits]++;
                        xbits = 0;
                        if (n >= base) xbits = extra[n - base];
                        f = tree[n * 2] /*.Freq*/ ;
                        s.opt_len += f * (bits + xbits);
                        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
                    }
                    if (overflow === 0) return;
                    // Trace((stderr,"\nbit length overflow\n"));
                    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
                        bits = max_length - 1;
                        while(s.bl_count[bits] === 0)bits--;
                        s.bl_count[bits]--; /* move one leaf down the tree */ 
                        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
                        s.bl_count[max_length]--;
                        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
                    }while (overflow > 0);
                    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
                        n = s.bl_count[bits];
                        while(n !== 0){
                            m = s.heap[--h];
                            if (m > max_code) continue;
                            if (tree[m * 2 + 1] !== bits) {
                                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                                tree[m * 2 + 1] = bits;
                            }
                            n--;
                        }
                    }
                }
                /* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
                //    int max_code;              /* largest code with non zero frequency */
                //    ushf *bl_count;            /* number of codes at each bit length */
                {
                    var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */ 
                    var code = 0; /* running code value */ 
                    var bits; /* bit index */ 
                    var n; /* code index */ 
                    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
                    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
                    //        "inconsistent bit counts");
                    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
                    for(n = 0; n <= max_code; n++){
                        var len = tree[n * 2 + 1] /*.Len*/ ;
                        if (len === 0) continue;
                        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
                    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
                    }
                }
                /* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function tr_static_init() {
                    var n; /* iterates over tree elements */ 
                    var bits; /* bit counter */ 
                    var length; /* length value */ 
                    var code; /* code value */ 
                    var dist; /* distance index */ 
                    var bl_count = new Array(MAX_BITS + 1);
                    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
                    //if (static_init_done) return;
                    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
                    for(code = 0; code < LENGTH_CODES - 1; code++){
                        base_length[code] = length;
                        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
                    }
                    //Assert (length == 256, "tr_static_init: length != 256");
                    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
                    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
                    for(code = 0; code < 16; code++){
                        base_dist[code] = dist;
                        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
                    }
                    //Assert (dist == 256, "tr_static_init: dist != 256");
                    dist >>= 7; /* from now on, all distances are divided by 128 */ 
                    for(; code < D_CODES; code++){
                        base_dist[code] = dist << 7;
                        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
                    }
                    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
                    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS; bits++)bl_count[bits] = 0;
                    n = 0;
                    while(n <= 143){
                        static_ltree[n * 2 + 1] = 8;
                        n++;
                        bl_count[8]++;
                    }
                    while(n <= 255){
                        static_ltree[n * 2 + 1] = 9;
                        n++;
                        bl_count[9]++;
                    }
                    while(n <= 279){
                        static_ltree[n * 2 + 1] = 7;
                        n++;
                        bl_count[7]++;
                    }
                    while(n <= 287){
                        static_ltree[n * 2 + 1] = 8;
                        n++;
                        bl_count[8]++;
                    }
                    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES + 1, bl_count);
                    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES; n++){
                        static_dtree[n * 2 + 1] = 5;
                        static_dtree[n * 2] = bi_reverse(n, 5);
                    }
                    // Now data ready and we can init static trees
                    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
                    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
                    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
                //static_init_done = true;
                }
                /* ===========================================================================
 * Initialize a new block.
 */ function init_block(s) {
                    var n; /* iterates over tree elements */ 
                    /* Initialize the trees. */ for(n = 0; n < L_CODES; n++)s.dyn_ltree[n * 2] = 0;
                    for(n = 0; n < D_CODES; n++)s.dyn_dtree[n * 2] = 0;
                    for(n = 0; n < BL_CODES; n++)s.bl_tree[n * 2] = 0;
                    s.dyn_ltree[END_BLOCK * 2] = 1;
                    s.opt_len = s.static_len = 0;
                    s.last_lit = s.matches = 0;
                }
                /* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function bi_windup(s) {
                    if (s.bi_valid > 8) put_short(s, s.bi_buf);
                    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
                    s.pending_buf[s.pending++] = s.bi_buf;
                    s.bi_buf = 0;
                    s.bi_valid = 0;
                }
                /* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function copy_block(s, buf, len, header) //DeflateState *s;
                //charf    *buf;    /* the input data */
                //unsigned len;     /* its length */
                //int      header;  /* true if block header must be written */
                {
                    bi_windup(s); /* align on byte boundary */ 
                    if (header) {
                        put_short(s, len);
                        put_short(s, ~len);
                    }
                    //  while (len--) {
                    //    put_byte(s, *buf++);
                    //  }
                    utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
                    s.pending += len;
                }
                /* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function smaller(tree, n, m, depth) {
                    var _n2 = n * 2;
                    var _m2 = m * 2;
                    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
                }
                /* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function pqdownheap(s, tree, k) //    deflate_state *s;
                //    ct_data *tree;  /* the tree to restore */
                //    int k;               /* node to move down */
                {
                    var v = s.heap[k];
                    var j = k << 1; /* left son of k */ 
                    while(j <= s.heap_len){
                        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
                        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
                        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
                        k = j;
                        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
                    }
                    s.heap[k] = v;
                }
                // inlined manually
                // var SMALLEST = 1;
                /* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function compress_block(s, ltree, dtree) //    deflate_state *s;
                //    const ct_data *ltree; /* literal tree */
                //    const ct_data *dtree; /* distance tree */
                {
                    var dist; /* distance of matched string */ 
                    var lc; /* match length or unmatched char (if dist == 0) */ 
                    var lx = 0; /* running index in l_buf */ 
                    var code; /* the code to send */ 
                    var extra; /* number of extra bits to send */ 
                    if (s.last_lit !== 0) do {
                        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
                        lc = s.pending_buf[s.l_buf + lx];
                        lx++;
                        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
                        else {
                            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
                            send_code(s, code + LITERALS + 1, ltree); /* send the length code */ 
                            extra = extra_lbits[code];
                            if (extra !== 0) {
                                lc -= base_length[code];
                                send_bits(s, lc, extra); /* send the extra length bits */ 
                            }
                            dist--; /* dist is now the match distance - 1 */ 
                            code = d_code(dist);
                            //Assert (code < D_CODES, "bad d_code");
                            send_code(s, code, dtree); /* send the distance code */ 
                            extra = extra_dbits[code];
                            if (extra !== 0) {
                                dist -= base_dist[code];
                                send_bits(s, dist, extra); /* send the extra distance bits */ 
                            }
                        } /* literal or match pair ? */ 
                    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                    //       "pendingBuf overflow");
                    }while (lx < s.last_lit);
                    send_code(s, END_BLOCK, ltree);
                }
                /* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function build_tree(s, desc) //    deflate_state *s;
                //    tree_desc *desc; /* the tree descriptor */
                {
                    var tree = desc.dyn_tree;
                    var stree = desc.stat_desc.static_tree;
                    var has_stree = desc.stat_desc.has_stree;
                    var elems = desc.stat_desc.elems;
                    var n, m; /* iterate over heap elements */ 
                    var max_code = -1; /* largest code with non zero frequency */ 
                    var node; /* new node being created */ 
                    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
                    s.heap_max = HEAP_SIZE;
                    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
                        s.heap[++s.heap_len] = max_code = n;
                        s.depth[n] = 0;
                    } else tree[n * 2 + 1] = 0;
                    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
                        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                        tree[node * 2] = 1;
                        s.depth[node] = 0;
                        s.opt_len--;
                        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
                    /* node is 0 or 1 so it does not have extra bits */ }
                    desc.max_code = max_code;
                    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
                    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
                    do {
                        //pqremove(s, tree, n);  /* n = node of least frequency */
                        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
                        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
                        pqdownheap(s, tree, 1 /*SMALLEST*/ );
                        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
                        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
                        s.heap[--s.heap_max] = m;
                        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
                        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
                        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
                        pqdownheap(s, tree, 1 /*SMALLEST*/ );
                    }while (s.heap_len >= 2);
                    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
                    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
                    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
                }
                /* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function scan_tree(s, tree, max_code) //    deflate_state *s;
                //    ct_data *tree;   /* the tree to be scanned */
                //    int max_code;    /* and its largest code of non zero frequency */
                {
                    var n; /* iterates over all tree elements */ 
                    var prevlen = -1; /* last emitted length */ 
                    var curlen; /* length of current code */ 
                    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
                    var count = 0; /* repeat count of the current code */ 
                    var max_count = 7; /* max repeat count */ 
                    var min_count = 4; /* min repeat count */ 
                    if (nextlen === 0) {
                        max_count = 138;
                        min_count = 3;
                    }
                    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
                    for(n = 0; n <= max_code; n++){
                        curlen = nextlen;
                        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
                        if (++count < max_count && curlen === nextlen) continue;
                        else if (count < min_count) s.bl_tree[curlen * 2] += count;
                        else if (curlen !== 0) {
                            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
                            s.bl_tree[REP_3_6 * 2]++;
                        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
                        else s.bl_tree[REPZ_11_138 * 2]++;
                        count = 0;
                        prevlen = curlen;
                        if (nextlen === 0) {
                            max_count = 138;
                            min_count = 3;
                        } else if (curlen === nextlen) {
                            max_count = 6;
                            min_count = 3;
                        } else {
                            max_count = 7;
                            min_count = 4;
                        }
                    }
                }
                /* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function send_tree(s, tree, max_code) //    deflate_state *s;
                //    ct_data *tree; /* the tree to be scanned */
                //    int max_code;       /* and its largest code of non zero frequency */
                {
                    var n; /* iterates over all tree elements */ 
                    var prevlen = -1; /* last emitted length */ 
                    var curlen; /* length of current code */ 
                    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
                    var count = 0; /* repeat count of the current code */ 
                    var max_count = 7; /* max repeat count */ 
                    var min_count = 4; /* min repeat count */ 
                    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
                        max_count = 138;
                        min_count = 3;
                    }
                    for(n = 0; n <= max_code; n++){
                        curlen = nextlen;
                        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
                        if (++count < max_count && curlen === nextlen) continue;
                        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
                        while (--count !== 0);
                        else if (curlen !== 0) {
                            if (curlen !== prevlen) {
                                send_code(s, curlen, s.bl_tree);
                                count--;
                            }
                            //Assert(count >= 3 && count <= 6, " 3_6?");
                            send_code(s, REP_3_6, s.bl_tree);
                            send_bits(s, count - 3, 2);
                        } else if (count <= 10) {
                            send_code(s, REPZ_3_10, s.bl_tree);
                            send_bits(s, count - 3, 3);
                        } else {
                            send_code(s, REPZ_11_138, s.bl_tree);
                            send_bits(s, count - 11, 7);
                        }
                        count = 0;
                        prevlen = curlen;
                        if (nextlen === 0) {
                            max_count = 138;
                            min_count = 3;
                        } else if (curlen === nextlen) {
                            max_count = 6;
                            min_count = 3;
                        } else {
                            max_count = 7;
                            min_count = 4;
                        }
                    }
                }
                /* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function build_bl_tree(s) {
                    var max_blindex; /* index of last bit length code of non zero freq */ 
                    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
                    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
                    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
                    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--){
                        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
                    }
                    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
                    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
                    //        s->opt_len, s->static_len));
                    return max_blindex;
                }
                /* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
                //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
                {
                    var rank; /* index in bl_order */ 
                    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
                    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
                    //        "too many codes");
                    //Tracev((stderr, "\nbl counts: "));
                    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
                    send_bits(s, dcodes - 1, 5);
                    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
                    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
                    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
                    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
                    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
                    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
                //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
                }
                /* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function detect_data_type(s) {
                    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
                    var n;
                    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
                        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
                    }
                    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
                    for(n = 32; n < LITERALS; n++){
                        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
                    }
                    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
                }
                var static_init_done = false;
                /* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function _tr_init(s) {
                    if (!static_init_done) {
                        tr_static_init();
                        static_init_done = true;
                    }
                    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
                    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
                    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
                    s.bi_buf = 0;
                    s.bi_valid = 0;
                    /* Initialize the first block of the first file: */ init_block(s);
                }
                /* ===========================================================================
 * Send a stored block
 */ function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
                //charf *buf;       /* input block */
                //ulg stored_len;   /* length of input block */
                //int last;         /* one if this is the last block for a file */
                {
                    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
                    copy_block(s, buf, stored_len, true); /* with header */ 
                }
                /* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function _tr_align(s) {
                    send_bits(s, STATIC_TREES << 1, 3);
                    send_code(s, END_BLOCK, static_ltree);
                    bi_flush(s);
                }
                /* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
                //charf *buf;       /* input block, or NULL if too old */
                //ulg stored_len;   /* length of input block */
                //int last;         /* one if this is the last block for a file */
                {
                    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
                    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
                    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
                        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN) s.strm.data_type = detect_data_type(s);
                        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
                        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                        //        s->static_len));
                        build_tree(s, s.d_desc);
                        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                        //        s->static_len));
                        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
                        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
                        static_lenb = s.static_len + 3 + 7 >>> 3;
                        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                        //        s->last_lit));
                        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
                    } else // Assert(buf != (char*)0, "lost buf");
                    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
                    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
                    else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                        compress_block(s, static_ltree, static_dtree);
                    } else {
                        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                        compress_block(s, s.dyn_ltree, s.dyn_dtree);
                    }
                    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
                    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
                    if (last) bi_windup(s);
                // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
                //       s->compressed_len-7*last));
                }
                /* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function _tr_tally(s, dist, lc) //    deflate_state *s;
                //    unsigned dist;  /* distance of matched string */
                //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
                {
                    //var out_length, in_length, dcode;
                    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
                    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
                    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
                    s.last_lit++;
                    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
                    else {
                        s.matches++;
                        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
                        //Assert((ush)dist < (ush)MAX_DIST(s) &&
                        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                        s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
                        s.dyn_dtree[d_code(dist) * 2]++;
                    }
                    // (!) This block is disabled in zlib defaults,
                    // don't enable it for binary compatibility
                    //#ifdef TRUNCATE_BLOCK
                    //  /* Try to guess if it is profitable to stop the current block here */
                    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
                    //    /* Compute an upper bound for the compressed length */
                    //    out_length = s.last_lit*8;
                    //    in_length = s.strstart - s.block_start;
                    //
                    //    for (dcode = 0; dcode < D_CODES; dcode++) {
                    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
                    //    }
                    //    out_length >>>= 3;
                    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
                    //    //       s->last_lit, in_length, out_length,
                    //    //       100L - out_length*100L/in_length));
                    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
                    //      return true;
                    //    }
                    //  }
                    //#endif
                    return s.last_lit === s.lit_bufsize - 1;
                /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
                exports._tr_init = _tr_init;
                exports._tr_stored_block = _tr_stored_block;
                exports._tr_flush_block = _tr_flush_block;
                exports._tr_tally = _tr_tally;
                exports._tr_align = _tr_align;
            /***/ },
            /***/ 22774: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var GetIntrinsic = __webpack_require__(28651);
                var callBindBasic = __webpack_require__(36688);
                /** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $indexOf = callBindBasic([
                    GetIntrinsic('%String.prototype.indexOf%')
                ]);
                /** @type {import('.')} */ module1.exports = function callBoundIntrinsic(name, allowMissing) {
                    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ GetIntrinsic(name, !!allowMissing);
                    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) return callBindBasic(/** @type {const} */ [
                        intrinsic
                    ]);
                    return intrinsic;
                };
            /***/ },
            /***/ 22925: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                var utils = __webpack_require__(72519);
                var trees = __webpack_require__(22367);
                var adler32 = __webpack_require__(46911);
                var crc32 = __webpack_require__(99049);
                var msg = __webpack_require__(56228);
                /* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var Z_NO_FLUSH = 0;
                var Z_PARTIAL_FLUSH = 1;
                //var Z_SYNC_FLUSH    = 2;
                var Z_FULL_FLUSH = 3;
                var Z_FINISH = 4;
                var Z_BLOCK = 5;
                //var Z_TREES         = 6;
                /* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
                var Z_STREAM_END = 1;
                //var Z_NEED_DICT     = 2;
                //var Z_ERRNO         = -1;
                var Z_STREAM_ERROR = -2;
                var Z_DATA_ERROR = -3;
                //var Z_MEM_ERROR     = -4;
                var Z_BUF_ERROR = -5;
                //var Z_VERSION_ERROR = -6;
                /* compression levels */ //var Z_NO_COMPRESSION      = 0;
                //var Z_BEST_SPEED          = 1;
                //var Z_BEST_COMPRESSION    = 9;
                var Z_DEFAULT_COMPRESSION = -1;
                var Z_FILTERED = 1;
                var Z_HUFFMAN_ONLY = 2;
                var Z_RLE = 3;
                var Z_FIXED = 4;
                var Z_DEFAULT_STRATEGY = 0;
                /* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
                //var Z_TEXT                = 1;
                //var Z_ASCII               = 1; // = Z_TEXT
                var Z_UNKNOWN = 2;
                /* The deflate compression method */ var Z_DEFLATED = 8;
                /*============================================================================*/ var MAX_MEM_LEVEL = 9;
                /* Maximum value for memLevel in deflateInit2 */ var MAX_WBITS = 15;
                /* 32K LZ77 window */ var DEF_MEM_LEVEL = 8;
                var LENGTH_CODES = 29;
                /* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
                /* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
                /* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
                /* number of distance codes */ var BL_CODES = 19;
                /* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
                /* maximum heap size */ var MAX_BITS = 15;
                /* All codes must not exceed MAX_BITS bits */ var MIN_MATCH = 3;
                var MAX_MATCH = 258;
                var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
                var PRESET_DICT = 0x20;
                var INIT_STATE = 42;
                var EXTRA_STATE = 69;
                var NAME_STATE = 73;
                var COMMENT_STATE = 91;
                var HCRC_STATE = 103;
                var BUSY_STATE = 113;
                var FINISH_STATE = 666;
                var BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
                var BS_BLOCK_DONE = 2; /* block flush performed */ 
                var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
                var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
                var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
                function err(strm, errorCode) {
                    strm.msg = msg[errorCode];
                    return errorCode;
                }
                function rank(f) {
                    return (f << 1) - (f > 4 ? 9 : 0);
                }
                function zero(buf) {
                    var len = buf.length;
                    while(--len >= 0)buf[len] = 0;
                }
                /* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function flush_pending(strm) {
                    var s = strm.state;
                    //_tr_flush_bits(s);
                    var len = s.pending;
                    if (len > strm.avail_out) len = strm.avail_out;
                    if (len === 0) return;
                    utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
                    strm.next_out += len;
                    s.pending_out += len;
                    strm.total_out += len;
                    strm.avail_out -= len;
                    s.pending -= len;
                    if (s.pending === 0) s.pending_out = 0;
                }
                function flush_block_only(s, last) {
                    trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
                    s.block_start = s.strstart;
                    flush_pending(s.strm);
                }
                function put_byte(s, b) {
                    s.pending_buf[s.pending++] = b;
                }
                /* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function putShortMSB(s, b) {
                    //  put_byte(s, (Byte)(b >> 8));
                    //  put_byte(s, (Byte)(b & 0xff));
                    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
                    s.pending_buf[s.pending++] = b & 0xff;
                }
                /* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function read_buf(strm, buf, start, size) {
                    var len = strm.avail_in;
                    if (len > size) len = size;
                    if (len === 0) return 0;
                    strm.avail_in -= len;
                    // zmemcpy(buf, strm->next_in, len);
                    utils.arraySet(buf, strm.input, strm.next_in, len, start);
                    if (strm.state.wrap === 1) strm.adler = adler32(strm.adler, buf, len, start);
                    else if (strm.state.wrap === 2) strm.adler = crc32(strm.adler, buf, len, start);
                    strm.next_in += len;
                    strm.total_in += len;
                    return len;
                }
                /* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function longest_match(s, cur_match) {
                    var chain_length = s.max_chain_length; /* max hash chain length */ 
                    var scan = s.strstart; /* current string */ 
                    var match; /* matched string */ 
                    var len; /* length of current match */ 
                    var best_len = s.prev_length; /* best match length so far */ 
                    var nice_match = s.nice_match; /* stop if match long enough */ 
                    var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
                    var _win = s.window; // shortcut
                    var wmask = s.w_mask;
                    var prev = s.prev;
                    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + MAX_MATCH;
                    var scan_end1 = _win[scan + best_len - 1];
                    var scan_end = _win[scan + best_len];
                    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
                    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
                    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
                    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
                    do {
                        // Assert(cur_match < s->strstart, "no future");
                        match = cur_match;
                        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
                        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
                        match++;
                        // Assert(*scan == *match, "match[2]?");
                        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
                        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
                        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                        len = MAX_MATCH - (strend - scan);
                        scan = strend - MAX_MATCH;
                        if (len > best_len) {
                            s.match_start = cur_match;
                            best_len = len;
                            if (len >= nice_match) break;
                            scan_end1 = _win[scan + best_len - 1];
                            scan_end = _win[scan + best_len];
                        }
                    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
                    if (best_len <= s.lookahead) return best_len;
                    return s.lookahead;
                }
                /* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function fill_window(s) {
                    var _w_size = s.w_size;
                    var p, n, m, more, str;
                    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
                    do {
                        more = s.window_size - s.lookahead - s.strstart;
                        // JS ints have 32 bit, block below not needed
                        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
                        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                        //        more = wsize;
                        //
                        //  } else if (more == (unsigned)(-1)) {
                        //        /* Very unlikely, but possible on 16 bit machine if
                        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                        //         */
                        //        more--;
                        //    }
                        //}
                        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
                            s.match_start -= _w_size;
                            s.strstart -= _w_size;
                            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
                            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
                            p = n;
                            do {
                                m = s.head[--p];
                                s.head[p] = m >= _w_size ? m - _w_size : 0;
                            }while (--n);
                            n = _w_size;
                            p = n;
                            do {
                                m = s.prev[--p];
                                s.prev[p] = m >= _w_size ? m - _w_size : 0;
                            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
                            more += _w_size;
                        }
                        if (s.strm.avail_in === 0) break;
                        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
                        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                        s.lookahead += n;
                        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
                            str = s.strstart - s.insert;
                            s.ins_h = s.window[str];
                            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
                            //#if MIN_MATCH != 3
                            //        Call update_hash() MIN_MATCH-3 more times
                            //#endif
                            while(s.insert){
                                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                                s.prev[str & s.w_mask] = s.head[s.ins_h];
                                s.head[s.ins_h] = str;
                                str++;
                                s.insert--;
                                if (s.lookahead + s.insert < MIN_MATCH) break;
                            }
                        }
                    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
                /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
                //    var curr = s.strstart + s.lookahead;
                //    var init = 0;
                //
                //    if (s.high_water < curr) {
                //      /* Previous high water mark below current data -- zero WIN_INIT
                //       * bytes or up to end of window, whichever is less.
                //       */
                //      init = s.window_size - curr;
                //      if (init > WIN_INIT)
                //        init = WIN_INIT;
                //      zmemzero(s->window + curr, (unsigned)init);
                //      s->high_water = curr + init;
                //    }
                //    else if (s->high_water < (ulg)curr + WIN_INIT) {
                //      /* High water mark at or above current data, but below current data
                //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
                //       * to end of window, whichever is less.
                //       */
                //      init = (ulg)curr + WIN_INIT - s->high_water;
                //      if (init > s->window_size - s->high_water)
                //        init = s->window_size - s->high_water;
                //      zmemzero(s->window + s->high_water, (unsigned)init);
                //      s->high_water += init;
                //    }
                //  }
                //
                //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
                //    "not enough room for search");
                }
                /* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function deflate_stored(s, flush) {
                    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
                    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
                    /* Copy as much as possible from input to output: */ for(;;){
                        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
                            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                            //  s->block_start >= (long)s->w_size, "slide too late");
                            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                            //        s.block_start >= s.w_size)) {
                            //        throw  new Error("slide too late");
                            //      }
                            fill_window(s);
                            if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                        /* flush the current block */ }
                        //Assert(s->block_start >= 0L, "block gone");
                        //    if (s.block_start < 0) throw new Error("block gone");
                        s.strstart += s.lookahead;
                        s.lookahead = 0;
                        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
                        if (s.strstart === 0 || s.strstart >= max_start) {
                            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
                            s.strstart = max_start;
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.strstart > s.block_start) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_NEED_MORE;
                }
                /* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function deflate_fast(s, flush) {
                    var hash_head; /* head of the hash chain */ 
                    var bflush; /* set if current block must be flushed */ 
                    for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
                            fill_window(s);
                            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break; /* flush the current block */ 
                        }
                        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
                        if (s.lookahead >= MIN_MATCH) {
                            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                        /***/ }
                        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
                        if (s.match_length >= MIN_MATCH) {
                            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
                            s.lookahead -= s.match_length;
                            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                                s.match_length--; /* string at strstart already in table */ 
                                do {
                                    s.strstart++;
                                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                                    s.head[s.ins_h] = s.strstart;
                                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                                s.strstart++;
                            } else {
                                s.strstart += s.match_length;
                                s.match_length = 0;
                                s.ins_h = s.window[s.strstart];
                                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
                            //#if MIN_MATCH != 3
                            //                Call UPDATE_HASH() MIN_MATCH-3 more times
                            //#endif
                            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
                        } else {
                            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
                            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                            s.lookahead--;
                            s.strstart++;
                        }
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function deflate_slow(s, flush) {
                    var hash_head; /* head of hash chain */ 
                    var bflush; /* set if current block must be flushed */ 
                    var max_insert;
                    /* Process the input block. */ for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
                            fill_window(s);
                            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                             /* flush the current block */ 
                        }
                        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
                        if (s.lookahead >= MIN_MATCH) {
                            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                        /***/ }
                        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
                        s.prev_match = s.match_start;
                        s.match_length = MIN_MATCH - 1;
                        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
                            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
                        }
                        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
                            max_insert = s.strstart + s.lookahead - MIN_MATCH;
                            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
                            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
                            s.prev_length -= 2;
                            do if (++s.strstart <= max_insert) {
                                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                                s.head[s.ins_h] = s.strstart;
                            /***/ }
                            while (--s.prev_length !== 0);
                            s.match_available = 0;
                            s.match_length = MIN_MATCH - 1;
                            s.strstart++;
                            if (bflush) {
                                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                                if (s.strm.avail_out === 0) return BS_NEED_MORE;
                            /***/ }
                        } else if (s.match_available) {
                            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
                            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
                            s.strstart++;
                            s.lookahead--;
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        } else {
                            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
                            s.strstart++;
                            s.lookahead--;
                        }
                    }
                    //Assert (flush != Z_NO_FLUSH, "no flush?");
                    if (s.match_available) {
                        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
                        s.match_available = 0;
                    }
                    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function deflate_rle(s, flush) {
                    var bflush; /* set if current block must be flushed */ 
                    var prev; /* byte at distance one to match */ 
                    var scan, strend; /* scan goes up to strend for length of run */ 
                    var _win = s.window;
                    for(;;){
                        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
                            fill_window(s);
                            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
                            if (s.lookahead === 0) break;
                             /* flush the current block */ 
                        }
                        /* See how many times the previous byte repeats */ s.match_length = 0;
                        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
                            scan = s.strstart - 1;
                            prev = _win[scan];
                            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                                strend = s.strstart + MAX_MATCH;
                                do ;
                                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                                s.match_length = MAX_MATCH - (strend - scan);
                                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
                            }
                        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                        }
                        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
                            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
                            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
                            s.lookahead -= s.match_length;
                            s.strstart += s.match_length;
                            s.match_length = 0;
                        } else {
                            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
                            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                            s.lookahead--;
                            s.strstart++;
                        }
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function deflate_huff(s, flush) {
                    var bflush; /* set if current block must be flushed */ 
                    for(;;){
                        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
                            fill_window(s);
                            if (s.lookahead === 0) {
                                if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                                break; /* flush the current block */ 
                            }
                        }
                        /* Output a literal byte */ s.match_length = 0;
                        //Tracevv((stderr,"%c", s->window[s->strstart]));
                        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                        s.lookahead--;
                        s.strstart++;
                        if (bflush) {
                            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                            if (s.strm.avail_out === 0) return BS_NEED_MORE;
                        /***/ }
                    }
                    s.insert = 0;
                    if (flush === Z_FINISH) {
                        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
                        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
                        /***/ return BS_FINISH_DONE;
                    }
                    if (s.last_lit) {
                        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                        if (s.strm.avail_out === 0) return BS_NEED_MORE;
                    /***/ }
                    return BS_BLOCK_DONE;
                }
                /* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
                    this.good_length = good_length;
                    this.max_lazy = max_lazy;
                    this.nice_length = nice_length;
                    this.max_chain = max_chain;
                    this.func = func;
                }
                var configuration_table;
                configuration_table = [
                    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
                    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
                    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
                    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
                    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
                    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
                    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
                    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
                    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
                    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
                ];
                /* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function lm_init(s) {
                    s.window_size = 2 * s.w_size;
                    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
                    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
                    s.good_match = configuration_table[s.level].good_length;
                    s.nice_match = configuration_table[s.level].nice_length;
                    s.max_chain_length = configuration_table[s.level].max_chain;
                    s.strstart = 0;
                    s.block_start = 0;
                    s.lookahead = 0;
                    s.insert = 0;
                    s.match_length = s.prev_length = MIN_MATCH - 1;
                    s.match_available = 0;
                    s.ins_h = 0;
                }
                function DeflateState() {
                    this.strm = null; /* pointer back to this zlib stream */ 
                    this.status = 0; /* as the name implies */ 
                    this.pending_buf = null; /* output still pending */ 
                    this.pending_buf_size = 0; /* size of pending_buf */ 
                    this.pending_out = 0; /* next pending byte to output to the stream */ 
                    this.pending = 0; /* nb of bytes in the pending buffer */ 
                    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
                    this.gzhead = null; /* gzip header information to write */ 
                    this.gzindex = 0; /* where in extra, name, or comment */ 
                    this.method = Z_DEFLATED; /* can only be DEFLATED */ 
                    this.last_flush = -1; /* value of flush param for previous deflate call */ 
                    this.w_size = 0; /* LZ77 window size (32K by default) */ 
                    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
                    this.w_mask = 0; /* w_size - 1 */ 
                    this.window = null;
                    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
                    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
                    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
                    this.ins_h = 0; /* hash index of string to be inserted */ 
                    this.hash_size = 0; /* number of elements in hash table */ 
                    this.hash_bits = 0; /* log2(hash_size) */ 
                    this.hash_mask = 0; /* hash_size-1 */ 
                    this.hash_shift = 0;
                    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
                    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
                    this.prev_match = 0; /* previous match */ 
                    this.match_available = 0; /* set if previous match exists */ 
                    this.strstart = 0; /* start of string to insert */ 
                    this.match_start = 0; /* start of matching string */ 
                    this.lookahead = 0; /* number of valid bytes ahead in window */ 
                    this.prev_length = 0;
                    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
                    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
                    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
                    //this.max_insert_length = 0;
                    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
                    this.strategy = 0; /* favor or force Huffman coding*/ 
                    this.good_match = 0;
                    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
                    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
                    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
                    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
                    // Use flat array of DOUBLE size, with interleaved fata,
                    // because JS does not support effective
                    this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
                    this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
                    this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
                    zero(this.dyn_ltree);
                    zero(this.dyn_dtree);
                    zero(this.bl_tree);
                    this.l_desc = null; /* desc. for literal tree */ 
                    this.d_desc = null; /* desc. for distance tree */ 
                    this.bl_desc = null; /* desc. for bit length tree */ 
                    //ush bl_count[MAX_BITS+1];
                    this.bl_count = new utils.Buf16(MAX_BITS + 1);
                    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
                    this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
                    zero(this.heap);
                    this.heap_len = 0; /* number of elements in the heap */ 
                    this.heap_max = 0; /* element of largest frequency */ 
                    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
                    zero(this.depth);
                    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
                    this.lit_bufsize = 0;
                    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
                    this.d_buf = 0;
                    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
                    this.static_len = 0; /* bit length of current block with static trees */ 
                    this.matches = 0; /* number of string matches in current block */ 
                    this.insert = 0; /* bytes at end of window left to insert */ 
                    this.bi_buf = 0;
                    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
                /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
                // sense only for pointers and memory check tools.
                //this.high_water = 0;
                /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
                function deflateResetKeep(strm) {
                    var s;
                    if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR);
                    strm.total_in = strm.total_out = 0;
                    strm.data_type = Z_UNKNOWN;
                    s = strm.state;
                    s.pending = 0;
                    s.pending_out = 0;
                    if (s.wrap < 0) s.wrap = -s.wrap;
                    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
                    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
                     : 1; // adler32(0, Z_NULL, 0)
                    s.last_flush = Z_NO_FLUSH;
                    trees._tr_init(s);
                    return Z_OK;
                }
                function deflateReset(strm) {
                    var ret = deflateResetKeep(strm);
                    if (ret === Z_OK) lm_init(strm.state);
                    return ret;
                }
                function deflateSetHeader(strm, head) {
                    if (!strm || !strm.state) return Z_STREAM_ERROR;
                    if (strm.state.wrap !== 2) return Z_STREAM_ERROR;
                    strm.state.gzhead = head;
                    return Z_OK;
                }
                function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
                    if (!strm) return Z_STREAM_ERROR;
                    var wrap = 1;
                    if (level === Z_DEFAULT_COMPRESSION) level = 6;
                    if (windowBits < 0) {
                        wrap = 0;
                        windowBits = -windowBits;
                    } else if (windowBits > 15) {
                        wrap = 2; /* write gzip wrapper instead */ 
                        windowBits -= 16;
                    }
                    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR);
                    if (windowBits === 8) windowBits = 9;
                    /* until 256-byte window bug fixed */ var s = new DeflateState();
                    strm.state = s;
                    s.strm = strm;
                    s.wrap = wrap;
                    s.gzhead = null;
                    s.w_bits = windowBits;
                    s.w_size = 1 << s.w_bits;
                    s.w_mask = s.w_size - 1;
                    s.hash_bits = memLevel + 7;
                    s.hash_size = 1 << s.hash_bits;
                    s.hash_mask = s.hash_size - 1;
                    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
                    s.window = new utils.Buf8(s.w_size * 2);
                    s.head = new utils.Buf16(s.hash_size);
                    s.prev = new utils.Buf16(s.w_size);
                    // Don't need mem init magic for JS.
                    //s.high_water = 0;  /* nothing written to s->window yet */
                    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
                    s.pending_buf_size = s.lit_bufsize * 4;
                    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
                    //s->pending_buf = (uchf *) overlay;
                    s.pending_buf = new utils.Buf8(s.pending_buf_size);
                    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
                    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
                    s.d_buf = 1 * s.lit_bufsize;
                    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
                    s.l_buf = 3 * s.lit_bufsize;
                    s.level = level;
                    s.strategy = strategy;
                    s.method = method;
                    return deflateReset(strm);
                }
                function deflateInit(strm, level) {
                    return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
                }
                function deflate(strm, flush) {
                    var old_flush, s;
                    var beg, val; // for gzip header write only
                    if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
                    s = strm.state;
                    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
                    s.strm = strm; /* just in case */ 
                    old_flush = s.last_flush;
                    s.last_flush = flush;
                    /* Write the header */ if (s.status === INIT_STATE) {
                        if (s.wrap === 2) {
                            strm.adler = 0; //crc32(0L, Z_NULL, 0);
                            put_byte(s, 31);
                            put_byte(s, 139);
                            put_byte(s, 8);
                            if (!s.gzhead) {
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, 0);
                                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                                put_byte(s, OS_CODE);
                                s.status = BUSY_STATE;
                            } else {
                                put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                                put_byte(s, s.gzhead.time & 0xff);
                                put_byte(s, s.gzhead.time >> 8 & 0xff);
                                put_byte(s, s.gzhead.time >> 16 & 0xff);
                                put_byte(s, s.gzhead.time >> 24 & 0xff);
                                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                                put_byte(s, s.gzhead.os & 0xff);
                                if (s.gzhead.extra && s.gzhead.extra.length) {
                                    put_byte(s, s.gzhead.extra.length & 0xff);
                                    put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                                }
                                if (s.gzhead.hcrc) strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                                s.gzindex = 0;
                                s.status = EXTRA_STATE;
                            }
                        } else {
                            var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
                            var level_flags = -1;
                            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
                            else if (s.level < 6) level_flags = 1;
                            else if (s.level === 6) level_flags = 2;
                            else level_flags = 3;
                            header |= level_flags << 6;
                            if (s.strstart !== 0) header |= PRESET_DICT;
                            header += 31 - header % 31;
                            s.status = BUSY_STATE;
                            putShortMSB(s, header);
                            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                                putShortMSB(s, strm.adler >>> 16);
                                putShortMSB(s, strm.adler & 0xffff);
                            }
                            strm.adler = 1; // adler32(0L, Z_NULL, 0);
                        }
                    }
                    //#ifdef GZIP
                    if (s.status === EXTRA_STATE) {
                        if (s.gzhead.extra /* != Z_NULL*/ ) {
                            beg = s.pending; /* start of bytes to update crc */ 
                            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                                if (s.pending === s.pending_buf_size) {
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    flush_pending(strm);
                                    beg = s.pending;
                                    if (s.pending === s.pending_buf_size) break;
                                }
                                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                                s.gzindex++;
                            }
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                            if (s.gzindex === s.gzhead.extra.length) {
                                s.gzindex = 0;
                                s.status = NAME_STATE;
                            }
                        } else s.status = NAME_STATE;
                    }
                    if (s.status === NAME_STATE) {
                        if (s.gzhead.name /* != Z_NULL*/ ) {
                            beg = s.pending; /* start of bytes to update crc */ 
                            //int val;
                            do {
                                if (s.pending === s.pending_buf_size) {
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    flush_pending(strm);
                                    beg = s.pending;
                                    if (s.pending === s.pending_buf_size) {
                                        val = 1;
                                        break;
                                    }
                                }
                                // JS specific: little magic to add zero terminator to end of string
                                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                                else val = 0;
                                put_byte(s, val);
                            }while (val !== 0);
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                            if (val === 0) {
                                s.gzindex = 0;
                                s.status = COMMENT_STATE;
                            }
                        } else s.status = COMMENT_STATE;
                    }
                    if (s.status === COMMENT_STATE) {
                        if (s.gzhead.comment /* != Z_NULL*/ ) {
                            beg = s.pending; /* start of bytes to update crc */ 
                            //int val;
                            do {
                                if (s.pending === s.pending_buf_size) {
                                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                                    flush_pending(strm);
                                    beg = s.pending;
                                    if (s.pending === s.pending_buf_size) {
                                        val = 1;
                                        break;
                                    }
                                }
                                // JS specific: little magic to add zero terminator to end of string
                                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                                else val = 0;
                                put_byte(s, val);
                            }while (val !== 0);
                            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                            if (val === 0) s.status = HCRC_STATE;
                        } else s.status = HCRC_STATE;
                    }
                    if (s.status === HCRC_STATE) {
                        if (s.gzhead.hcrc) {
                            if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
                            if (s.pending + 2 <= s.pending_buf_size) {
                                put_byte(s, strm.adler & 0xff);
                                put_byte(s, strm.adler >> 8 & 0xff);
                                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                                s.status = BUSY_STATE;
                            }
                        } else s.status = BUSY_STATE;
                    }
                    //#endif
                    /* Flush as much pending output as possible */ if (s.pending !== 0) {
                        flush_pending(strm);
                        if (strm.avail_out === 0) {
                            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
                            return Z_OK;
                        }
                    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) return err(strm, Z_BUF_ERROR);
                    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR);
                    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
                        var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
                        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
                        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                            if (strm.avail_out === 0) s.last_flush = -1;
                            return Z_OK;
                        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
                        if (bstate === BS_BLOCK_DONE) {
                            if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
                            else if (flush !== Z_BLOCK) {
                                trees._tr_stored_block(s, 0, 0, false);
                                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                                    if (s.lookahead === 0) {
                                        s.strstart = 0;
                                        s.block_start = 0;
                                        s.insert = 0;
                                    }
                                }
                            }
                            flush_pending(strm);
                            if (strm.avail_out === 0) {
                                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                                return Z_OK;
                            }
                        }
                    }
                    //Assert(strm->avail_out > 0, "bug2");
                    //if (strm.avail_out <= 0) { throw new Error("bug2");}
                    if (flush !== Z_FINISH) return Z_OK;
                    if (s.wrap <= 0) return Z_STREAM_END;
                    /* Write the trailer */ if (s.wrap === 2) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, strm.adler >> 8 & 0xff);
                        put_byte(s, strm.adler >> 16 & 0xff);
                        put_byte(s, strm.adler >> 24 & 0xff);
                        put_byte(s, strm.total_in & 0xff);
                        put_byte(s, strm.total_in >> 8 & 0xff);
                        put_byte(s, strm.total_in >> 16 & 0xff);
                        put_byte(s, strm.total_in >> 24 & 0xff);
                    } else {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    flush_pending(strm);
                    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
                    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK : Z_STREAM_END;
                }
                function deflateEnd(strm) {
                    var status;
                    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
                    status = strm.state.status;
                    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR);
                    strm.state = null;
                    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
                }
                /* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function deflateSetDictionary(strm, dictionary) {
                    var dictLength = dictionary.length;
                    var s;
                    var str, n;
                    var wrap;
                    var avail;
                    var next;
                    var input;
                    var tmpDict;
                    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
                    s = strm.state;
                    wrap = s.wrap;
                    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR;
                    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
                    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
                    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
                        if (wrap === 0) {
                            /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
                            s.strstart = 0;
                            s.block_start = 0;
                            s.insert = 0;
                        }
                        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
                        tmpDict = new utils.Buf8(s.w_size);
                        utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
                        dictionary = tmpDict;
                        dictLength = s.w_size;
                    }
                    /* insert dictionary into window and hash */ avail = strm.avail_in;
                    next = strm.next_in;
                    input = strm.input;
                    strm.avail_in = dictLength;
                    strm.next_in = 0;
                    strm.input = dictionary;
                    fill_window(s);
                    while(s.lookahead >= MIN_MATCH){
                        str = s.strstart;
                        n = s.lookahead - (MIN_MATCH - 1);
                        do {
                            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                            s.prev[str & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = str;
                            str++;
                        }while (--n);
                        s.strstart = str;
                        s.lookahead = MIN_MATCH - 1;
                        fill_window(s);
                    }
                    s.strstart += s.lookahead;
                    s.block_start = s.strstart;
                    s.insert = s.lookahead;
                    s.lookahead = 0;
                    s.match_length = s.prev_length = MIN_MATCH - 1;
                    s.match_available = 0;
                    strm.next_in = next;
                    strm.input = input;
                    strm.avail_in = avail;
                    s.wrap = wrap;
                    return Z_OK;
                }
                exports.deflateInit = deflateInit;
                exports.deflateInit2 = deflateInit2;
                exports.deflateReset = deflateReset;
                exports.deflateResetKeep = deflateResetKeep;
                exports.deflateSetHeader = deflateSetHeader;
                exports.deflate = deflate;
                exports.deflateEnd = deflateEnd;
                exports.deflateSetDictionary = deflateSetDictionary;
                exports.deflateInfo = 'pako deflate (from Nodeca project)';
            /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ /***/ },
            /***/ 22956: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(66947), __webpack_require__(68319), __webpack_require__(82747), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var BlockCipher = C_lib.BlockCipher;
                        var C_algo = C.algo;
                        // Lookup tables
                        var SBOX = [];
                        var INV_SBOX = [];
                        var SUB_MIX_0 = [];
                        var SUB_MIX_1 = [];
                        var SUB_MIX_2 = [];
                        var SUB_MIX_3 = [];
                        var INV_SUB_MIX_0 = [];
                        var INV_SUB_MIX_1 = [];
                        var INV_SUB_MIX_2 = [];
                        var INV_SUB_MIX_3 = [];
                        // Compute lookup tables
                        (function() {
                            // Compute double table
                            var d = [];
                            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
                            else d[i] = i << 1 ^ 0x11b;
                            // Walk GF(2^8)
                            var x = 0;
                            var xi = 0;
                            for(var i = 0; i < 256; i++){
                                // Compute sbox
                                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                                SBOX[x] = sx;
                                INV_SBOX[sx] = x;
                                // Compute multiplication
                                var x2 = d[x];
                                var x4 = d[x2];
                                var x8 = d[x4];
                                // Compute sub bytes, mix columns tables
                                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                                SUB_MIX_0[x] = t << 24 | t >>> 8;
                                SUB_MIX_1[x] = t << 16 | t >>> 16;
                                SUB_MIX_2[x] = t << 8 | t >>> 24;
                                SUB_MIX_3[x] = t;
                                // Compute inv sub bytes, inv mix columns tables
                                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                                INV_SUB_MIX_3[sx] = t;
                                // Compute next counter
                                if (!x) x = xi = 1;
                                else {
                                    x = x2 ^ d[d[d[x8 ^ x2]]];
                                    xi ^= d[d[xi]];
                                }
                            }
                        })();
                        // Precomputed Rcon lookup
                        var RCON = [
                            0x00,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36
                        ];
                        /**
     * AES block cipher algorithm.
     */ var AES = C_algo.AES = BlockCipher.extend({
                            _doReset: function _doReset() {
                                var t;
                                // Skip reset of nRounds has been set before and key did not change
                                if (this._nRounds && this._keyPriorReset === this._key) return;
                                // Shortcuts
                                var key = this._keyPriorReset = this._key;
                                var keyWords = key.words;
                                var keySize = key.sigBytes / 4;
                                // Compute number of rounds
                                var nRounds = this._nRounds = keySize + 6;
                                // Compute number of key schedule rows
                                var ksRows = (nRounds + 1) * 4;
                                // Compute key schedule
                                var keySchedule = this._keySchedule = [];
                                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                                else {
                                    t = keySchedule[ksRow - 1];
                                    if (!(ksRow % keySize)) {
                                        // Rot word
                                        t = t << 8 | t >>> 24;
                                        // Sub word
                                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                                        // Mix Rcon
                                        t ^= RCON[ksRow / keySize | 0] << 24;
                                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                                }
                                // Compute inv key schedule
                                var invKeySchedule = this._invKeySchedule = [];
                                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                                    var ksRow = ksRows - invKsRow;
                                    if (invKsRow % 4) var t = keySchedule[ksRow];
                                    else var t = keySchedule[ksRow - 4];
                                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                                }
                            },
                            encryptBlock: function encryptBlock(M, offset) {
                                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
                            },
                            decryptBlock: function decryptBlock(M, offset) {
                                // Swap 2nd and 4th rows
                                var t = M[offset + 1];
                                M[offset + 1] = M[offset + 3];
                                M[offset + 3] = t;
                                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                                // Inv swap 2nd and 4th rows
                                var t = M[offset + 1];
                                M[offset + 1] = M[offset + 3];
                                M[offset + 3] = t;
                            },
                            _doCryptBlock: function _doCryptBlock(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                                // Shortcut
                                var nRounds = this._nRounds;
                                // Get input, add round key
                                var s0 = M[offset] ^ keySchedule[0];
                                var s1 = M[offset + 1] ^ keySchedule[1];
                                var s2 = M[offset + 2] ^ keySchedule[2];
                                var s3 = M[offset + 3] ^ keySchedule[3];
                                // Key schedule row counter
                                var ksRow = 4;
                                // Rounds
                                for(var round = 1; round < nRounds; round++){
                                    // Shift rows, sub bytes, mix columns, add round key
                                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                                    // Update state
                                    s0 = t0;
                                    s1 = t1;
                                    s2 = t2;
                                    s3 = t3;
                                }
                                // Shift rows, sub bytes, add round key
                                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                                // Set output
                                M[offset] = t0;
                                M[offset + 1] = t1;
                                M[offset + 2] = t2;
                                M[offset + 3] = t3;
                            },
                            keySize: 8
                        });
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
     */ C.AES = BlockCipher._createHelper(AES);
                    })();
                    return CryptoJS.AES;
                });
            /***/ },
            /***/ 23327: /***/ function(module1) {
                // iterable DOM collections
                // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
                module1.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            /***/ },
            /***/ 23417: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toIntegerOrInfinity = __webpack_require__(26882);
                var min = Math.min;
                // `ToLength` abstract operation
                // https://tc39.es/ecma262/#sec-tolength
                module1.exports = function(argument) {
                    return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
                };
            /***/ },
            /***/ 23913: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var toAbsoluteIndex = __webpack_require__(74841);
                var toIntegerOrInfinity = __webpack_require__(26882);
                var lengthOfArrayLike = __webpack_require__(45495);
                var toObject = __webpack_require__(43162);
                var arraySpeciesCreate = __webpack_require__(45744);
                var createProperty = __webpack_require__(38639);
                var arrayMethodHasSpeciesSupport = __webpack_require__(56280);
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
                var TypeError1 = global.TypeError;
                var max = Math.max;
                var min = Math.min;
                var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
                var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';
                // `Array.prototype.splice` method
                // https://tc39.es/ecma262/#sec-array.prototype.splice
                // with adding support of @@species
                $({
                    target: 'Array',
                    proto: true,
                    forced: !HAS_SPECIES_SUPPORT
                }, {
                    splice: function splice(start, deleteCount /* , ...items */ ) {
                        var O = toObject(this);
                        var len = lengthOfArrayLike(O);
                        var actualStart = toAbsoluteIndex(start, len);
                        var argumentsLength = arguments.length;
                        var insertCount, actualDeleteCount, A, k, from, to;
                        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
                        else if (argumentsLength === 1) {
                            insertCount = 0;
                            actualDeleteCount = len - actualStart;
                        } else {
                            insertCount = argumentsLength - 2;
                            actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
                        }
                        if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) throw TypeError1(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
                        A = arraySpeciesCreate(O, actualDeleteCount);
                        for(k = 0; k < actualDeleteCount; k++){
                            from = actualStart + k;
                            if (from in O) createProperty(A, k, O[from]);
                        }
                        A.length = actualDeleteCount;
                        if (insertCount < actualDeleteCount) {
                            for(k = actualStart; k < len - actualDeleteCount; k++){
                                from = k + actualDeleteCount;
                                to = k + insertCount;
                                if (from in O) O[to] = O[from];
                                else delete O[to];
                            }
                            for(k = len; k > len - actualDeleteCount + insertCount; k--)delete O[k - 1];
                        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
                            from = k + actualDeleteCount - 1;
                            to = k + insertCount - 1;
                            if (from in O) O[to] = O[from];
                            else delete O[to];
                        }
                        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
                        O.length = len - actualDeleteCount + insertCount;
                        return A;
                    }
                });
            /***/ },
            /***/ 24107: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(20731);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(66947), __webpack_require__(68319), __webpack_require__(82747), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var BlockCipher = C_lib.BlockCipher;
                        var C_algo = C.algo;
                        // Permuted Choice 1 constants
                        var PC1 = [
                            57,
                            49,
                            41,
                            33,
                            25,
                            17,
                            9,
                            1,
                            58,
                            50,
                            42,
                            34,
                            26,
                            18,
                            10,
                            2,
                            59,
                            51,
                            43,
                            35,
                            27,
                            19,
                            11,
                            3,
                            60,
                            52,
                            44,
                            36,
                            63,
                            55,
                            47,
                            39,
                            31,
                            23,
                            15,
                            7,
                            62,
                            54,
                            46,
                            38,
                            30,
                            22,
                            14,
                            6,
                            61,
                            53,
                            45,
                            37,
                            29,
                            21,
                            13,
                            5,
                            28,
                            20,
                            12,
                            4
                        ];
                        // Permuted Choice 2 constants
                        var PC2 = [
                            14,
                            17,
                            11,
                            24,
                            1,
                            5,
                            3,
                            28,
                            15,
                            6,
                            21,
                            10,
                            23,
                            19,
                            12,
                            4,
                            26,
                            8,
                            16,
                            7,
                            27,
                            20,
                            13,
                            2,
                            41,
                            52,
                            31,
                            37,
                            47,
                            55,
                            30,
                            40,
                            51,
                            45,
                            33,
                            48,
                            44,
                            49,
                            39,
                            56,
                            34,
                            53,
                            46,
                            42,
                            50,
                            36,
                            29,
                            32
                        ];
                        // Cumulative bit shift constants
                        var BIT_SHIFTS = [
                            1,
                            2,
                            4,
                            6,
                            8,
                            10,
                            12,
                            14,
                            15,
                            17,
                            19,
                            21,
                            23,
                            25,
                            27,
                            28
                        ];
                        // SBOXes and round permutation constants
                        var SBOX_P = [
                            {
                                0x0: 0x808200,
                                0x10000000: 0x8000,
                                0x20000000: 0x808002,
                                0x30000000: 0x2,
                                0x40000000: 0x200,
                                0x50000000: 0x808202,
                                0x60000000: 0x800202,
                                0x70000000: 0x800000,
                                0x80000000: 0x202,
                                0x90000000: 0x800200,
                                0xa0000000: 0x8200,
                                0xb0000000: 0x808000,
                                0xc0000000: 0x8002,
                                0xd0000000: 0x800002,
                                0xe0000000: 0x0,
                                0xf0000000: 0x8202,
                                0x8000000: 0x0,
                                0x18000000: 0x808202,
                                0x28000000: 0x8202,
                                0x38000000: 0x8000,
                                0x48000000: 0x808200,
                                0x58000000: 0x200,
                                0x68000000: 0x808002,
                                0x78000000: 0x2,
                                0x88000000: 0x800200,
                                0x98000000: 0x8200,
                                0xa8000000: 0x808000,
                                0xb8000000: 0x800202,
                                0xc8000000: 0x800002,
                                0xd8000000: 0x8002,
                                0xe8000000: 0x202,
                                0xf8000000: 0x800000,
                                0x1: 0x8000,
                                0x10000001: 0x2,
                                0x20000001: 0x808200,
                                0x30000001: 0x800000,
                                0x40000001: 0x808002,
                                0x50000001: 0x8200,
                                0x60000001: 0x200,
                                0x70000001: 0x800202,
                                0x80000001: 0x808202,
                                0x90000001: 0x808000,
                                0xa0000001: 0x800002,
                                0xb0000001: 0x8202,
                                0xc0000001: 0x202,
                                0xd0000001: 0x800200,
                                0xe0000001: 0x8002,
                                0xf0000001: 0x0,
                                0x8000001: 0x808202,
                                0x18000001: 0x808000,
                                0x28000001: 0x800000,
                                0x38000001: 0x200,
                                0x48000001: 0x8000,
                                0x58000001: 0x800002,
                                0x68000001: 0x2,
                                0x78000001: 0x8202,
                                0x88000001: 0x8002,
                                0x98000001: 0x800202,
                                0xa8000001: 0x202,
                                0xb8000001: 0x808200,
                                0xc8000001: 0x800200,
                                0xd8000001: 0x0,
                                0xe8000001: 0x8200,
                                0xf8000001: 0x808002
                            },
                            {
                                0x0: 0x40084010,
                                0x1000000: 0x4000,
                                0x2000000: 0x80000,
                                0x3000000: 0x40080010,
                                0x4000000: 0x40000010,
                                0x5000000: 0x40084000,
                                0x6000000: 0x40004000,
                                0x7000000: 0x10,
                                0x8000000: 0x84000,
                                0x9000000: 0x40004010,
                                0xa000000: 0x40000000,
                                0xb000000: 0x84010,
                                0xc000000: 0x80010,
                                0xd000000: 0x0,
                                0xe000000: 0x4010,
                                0xf000000: 0x40080000,
                                0x800000: 0x40004000,
                                0x1800000: 0x84010,
                                0x2800000: 0x10,
                                0x3800000: 0x40004010,
                                0x4800000: 0x40084010,
                                0x5800000: 0x40000000,
                                0x6800000: 0x80000,
                                0x7800000: 0x40080010,
                                0x8800000: 0x80010,
                                0x9800000: 0x0,
                                0xa800000: 0x4000,
                                0xb800000: 0x40080000,
                                0xc800000: 0x40000010,
                                0xd800000: 0x84000,
                                0xe800000: 0x40084000,
                                0xf800000: 0x4010,
                                0x10000000: 0x0,
                                0x11000000: 0x40080010,
                                0x12000000: 0x40004010,
                                0x13000000: 0x40084000,
                                0x14000000: 0x40080000,
                                0x15000000: 0x10,
                                0x16000000: 0x84010,
                                0x17000000: 0x4000,
                                0x18000000: 0x4010,
                                0x19000000: 0x80000,
                                0x1a000000: 0x80010,
                                0x1b000000: 0x40000010,
                                0x1c000000: 0x84000,
                                0x1d000000: 0x40004000,
                                0x1e000000: 0x40000000,
                                0x1f000000: 0x40084010,
                                0x10800000: 0x84010,
                                0x11800000: 0x80000,
                                0x12800000: 0x40080000,
                                0x13800000: 0x4000,
                                0x14800000: 0x40004000,
                                0x15800000: 0x40084010,
                                0x16800000: 0x10,
                                0x17800000: 0x40000000,
                                0x18800000: 0x40084000,
                                0x19800000: 0x40000010,
                                0x1a800000: 0x40004010,
                                0x1b800000: 0x80010,
                                0x1c800000: 0x0,
                                0x1d800000: 0x4010,
                                0x1e800000: 0x40080010,
                                0x1f800000: 0x84000
                            },
                            {
                                0x0: 0x104,
                                0x100000: 0x0,
                                0x200000: 0x4000100,
                                0x300000: 0x10104,
                                0x400000: 0x10004,
                                0x500000: 0x4000004,
                                0x600000: 0x4010104,
                                0x700000: 0x4010000,
                                0x800000: 0x4000000,
                                0x900000: 0x4010100,
                                0xa00000: 0x10100,
                                0xb00000: 0x4010004,
                                0xc00000: 0x4000104,
                                0xd00000: 0x10000,
                                0xe00000: 0x4,
                                0xf00000: 0x100,
                                0x80000: 0x4010100,
                                0x180000: 0x4010004,
                                0x280000: 0x0,
                                0x380000: 0x4000100,
                                0x480000: 0x4000004,
                                0x580000: 0x10000,
                                0x680000: 0x10004,
                                0x780000: 0x104,
                                0x880000: 0x4,
                                0x980000: 0x100,
                                0xa80000: 0x4010000,
                                0xb80000: 0x10104,
                                0xc80000: 0x10100,
                                0xd80000: 0x4000104,
                                0xe80000: 0x4010104,
                                0xf80000: 0x4000000,
                                0x1000000: 0x4010100,
                                0x1100000: 0x10004,
                                0x1200000: 0x10000,
                                0x1300000: 0x4000100,
                                0x1400000: 0x100,
                                0x1500000: 0x4010104,
                                0x1600000: 0x4000004,
                                0x1700000: 0x0,
                                0x1800000: 0x4000104,
                                0x1900000: 0x4000000,
                                0x1a00000: 0x4,
                                0x1b00000: 0x10100,
                                0x1c00000: 0x4010000,
                                0x1d00000: 0x104,
                                0x1e00000: 0x10104,
                                0x1f00000: 0x4010004,
                                0x1080000: 0x4000000,
                                0x1180000: 0x104,
                                0x1280000: 0x4010100,
                                0x1380000: 0x0,
                                0x1480000: 0x10004,
                                0x1580000: 0x4000100,
                                0x1680000: 0x100,
                                0x1780000: 0x4010004,
                                0x1880000: 0x10000,
                                0x1980000: 0x4010104,
                                0x1a80000: 0x10104,
                                0x1b80000: 0x4000004,
                                0x1c80000: 0x4000104,
                                0x1d80000: 0x4010000,
                                0x1e80000: 0x4,
                                0x1f80000: 0x10100
                            },
                            {
                                0x0: 0x80401000,
                                0x10000: 0x80001040,
                                0x20000: 0x401040,
                                0x30000: 0x80400000,
                                0x40000: 0x0,
                                0x50000: 0x401000,
                                0x60000: 0x80000040,
                                0x70000: 0x400040,
                                0x80000: 0x80000000,
                                0x90000: 0x400000,
                                0xa0000: 0x40,
                                0xb0000: 0x80001000,
                                0xc0000: 0x80400040,
                                0xd0000: 0x1040,
                                0xe0000: 0x1000,
                                0xf0000: 0x80401040,
                                0x8000: 0x80001040,
                                0x18000: 0x40,
                                0x28000: 0x80400040,
                                0x38000: 0x80001000,
                                0x48000: 0x401000,
                                0x58000: 0x80401040,
                                0x68000: 0x0,
                                0x78000: 0x80400000,
                                0x88000: 0x1000,
                                0x98000: 0x80401000,
                                0xa8000: 0x400000,
                                0xb8000: 0x1040,
                                0xc8000: 0x80000000,
                                0xd8000: 0x400040,
                                0xe8000: 0x401040,
                                0xf8000: 0x80000040,
                                0x100000: 0x400040,
                                0x110000: 0x401000,
                                0x120000: 0x80000040,
                                0x130000: 0x0,
                                0x140000: 0x1040,
                                0x150000: 0x80400040,
                                0x160000: 0x80401000,
                                0x170000: 0x80001040,
                                0x180000: 0x80401040,
                                0x190000: 0x80000000,
                                0x1a0000: 0x80400000,
                                0x1b0000: 0x401040,
                                0x1c0000: 0x80001000,
                                0x1d0000: 0x400000,
                                0x1e0000: 0x40,
                                0x1f0000: 0x1000,
                                0x108000: 0x80400000,
                                0x118000: 0x80401040,
                                0x128000: 0x0,
                                0x138000: 0x401000,
                                0x148000: 0x400040,
                                0x158000: 0x80000000,
                                0x168000: 0x80001040,
                                0x178000: 0x40,
                                0x188000: 0x80000040,
                                0x198000: 0x1000,
                                0x1a8000: 0x80001000,
                                0x1b8000: 0x80400040,
                                0x1c8000: 0x1040,
                                0x1d8000: 0x80401000,
                                0x1e8000: 0x400000,
                                0x1f8000: 0x401040
                            },
                            {
                                0x0: 0x80,
                                0x1000: 0x1040000,
                                0x2000: 0x40000,
                                0x3000: 0x20000000,
                                0x4000: 0x20040080,
                                0x5000: 0x1000080,
                                0x6000: 0x21000080,
                                0x7000: 0x40080,
                                0x8000: 0x1000000,
                                0x9000: 0x20040000,
                                0xa000: 0x20000080,
                                0xb000: 0x21040080,
                                0xc000: 0x21040000,
                                0xd000: 0x0,
                                0xe000: 0x1040080,
                                0xf000: 0x21000000,
                                0x800: 0x1040080,
                                0x1800: 0x21000080,
                                0x2800: 0x80,
                                0x3800: 0x1040000,
                                0x4800: 0x40000,
                                0x5800: 0x20040080,
                                0x6800: 0x21040000,
                                0x7800: 0x20000000,
                                0x8800: 0x20040000,
                                0x9800: 0x0,
                                0xa800: 0x21040080,
                                0xb800: 0x1000080,
                                0xc800: 0x20000080,
                                0xd800: 0x21000000,
                                0xe800: 0x1000000,
                                0xf800: 0x40080,
                                0x10000: 0x40000,
                                0x11000: 0x80,
                                0x12000: 0x20000000,
                                0x13000: 0x21000080,
                                0x14000: 0x1000080,
                                0x15000: 0x21040000,
                                0x16000: 0x20040080,
                                0x17000: 0x1000000,
                                0x18000: 0x21040080,
                                0x19000: 0x21000000,
                                0x1a000: 0x1040000,
                                0x1b000: 0x20040000,
                                0x1c000: 0x40080,
                                0x1d000: 0x20000080,
                                0x1e000: 0x0,
                                0x1f000: 0x1040080,
                                0x10800: 0x21000080,
                                0x11800: 0x1000000,
                                0x12800: 0x1040000,
                                0x13800: 0x20040080,
                                0x14800: 0x20000000,
                                0x15800: 0x1040080,
                                0x16800: 0x80,
                                0x17800: 0x21040000,
                                0x18800: 0x40080,
                                0x19800: 0x21040080,
                                0x1a800: 0x0,
                                0x1b800: 0x21000000,
                                0x1c800: 0x1000080,
                                0x1d800: 0x40000,
                                0x1e800: 0x20040000,
                                0x1f800: 0x20000080
                            },
                            {
                                0x0: 0x10000008,
                                0x100: 0x2000,
                                0x200: 0x10200000,
                                0x300: 0x10202008,
                                0x400: 0x10002000,
                                0x500: 0x200000,
                                0x600: 0x200008,
                                0x700: 0x10000000,
                                0x800: 0x0,
                                0x900: 0x10002008,
                                0xa00: 0x202000,
                                0xb00: 0x8,
                                0xc00: 0x10200008,
                                0xd00: 0x202008,
                                0xe00: 0x2008,
                                0xf00: 0x10202000,
                                0x80: 0x10200000,
                                0x180: 0x10202008,
                                0x280: 0x8,
                                0x380: 0x200000,
                                0x480: 0x202008,
                                0x580: 0x10000008,
                                0x680: 0x10002000,
                                0x780: 0x2008,
                                0x880: 0x200008,
                                0x980: 0x2000,
                                0xa80: 0x10002008,
                                0xb80: 0x10200008,
                                0xc80: 0x0,
                                0xd80: 0x10202000,
                                0xe80: 0x202000,
                                0xf80: 0x10000000,
                                0x1000: 0x10002000,
                                0x1100: 0x10200008,
                                0x1200: 0x10202008,
                                0x1300: 0x2008,
                                0x1400: 0x200000,
                                0x1500: 0x10000000,
                                0x1600: 0x10000008,
                                0x1700: 0x202000,
                                0x1800: 0x202008,
                                0x1900: 0x0,
                                0x1a00: 0x8,
                                0x1b00: 0x10200000,
                                0x1c00: 0x2000,
                                0x1d00: 0x10002008,
                                0x1e00: 0x10202000,
                                0x1f00: 0x200008,
                                0x1080: 0x8,
                                0x1180: 0x202000,
                                0x1280: 0x200000,
                                0x1380: 0x10000008,
                                0x1480: 0x10002000,
                                0x1580: 0x2008,
                                0x1680: 0x10202008,
                                0x1780: 0x10200000,
                                0x1880: 0x10202000,
                                0x1980: 0x10200008,
                                0x1a80: 0x2000,
                                0x1b80: 0x202008,
                                0x1c80: 0x200008,
                                0x1d80: 0x0,
                                0x1e80: 0x10000000,
                                0x1f80: 0x10002008
                            },
                            {
                                0x0: 0x100000,
                                0x10: 0x2000401,
                                0x20: 0x400,
                                0x30: 0x100401,
                                0x40: 0x2100401,
                                0x50: 0x0,
                                0x60: 0x1,
                                0x70: 0x2100001,
                                0x80: 0x2000400,
                                0x90: 0x100001,
                                0xa0: 0x2000001,
                                0xb0: 0x2100400,
                                0xc0: 0x2100000,
                                0xd0: 0x401,
                                0xe0: 0x100400,
                                0xf0: 0x2000000,
                                0x8: 0x2100001,
                                0x18: 0x0,
                                0x28: 0x2000401,
                                0x38: 0x2100400,
                                0x48: 0x100000,
                                0x58: 0x2000001,
                                0x68: 0x2000000,
                                0x78: 0x401,
                                0x88: 0x100401,
                                0x98: 0x2000400,
                                0xa8: 0x2100000,
                                0xb8: 0x100001,
                                0xc8: 0x400,
                                0xd8: 0x2100401,
                                0xe8: 0x1,
                                0xf8: 0x100400,
                                0x100: 0x2000000,
                                0x110: 0x100000,
                                0x120: 0x2000401,
                                0x130: 0x2100001,
                                0x140: 0x100001,
                                0x150: 0x2000400,
                                0x160: 0x2100400,
                                0x170: 0x100401,
                                0x180: 0x401,
                                0x190: 0x2100401,
                                0x1a0: 0x100400,
                                0x1b0: 0x1,
                                0x1c0: 0x0,
                                0x1d0: 0x2100000,
                                0x1e0: 0x2000001,
                                0x1f0: 0x400,
                                0x108: 0x100400,
                                0x118: 0x2000401,
                                0x128: 0x2100001,
                                0x138: 0x1,
                                0x148: 0x2000000,
                                0x158: 0x100000,
                                0x168: 0x401,
                                0x178: 0x2100400,
                                0x188: 0x2000001,
                                0x198: 0x2100000,
                                0x1a8: 0x0,
                                0x1b8: 0x2100401,
                                0x1c8: 0x100401,
                                0x1d8: 0x400,
                                0x1e8: 0x2000400,
                                0x1f8: 0x100001
                            },
                            {
                                0x0: 0x8000820,
                                0x1: 0x20000,
                                0x2: 0x8000000,
                                0x3: 0x20,
                                0x4: 0x20020,
                                0x5: 0x8020820,
                                0x6: 0x8020800,
                                0x7: 0x800,
                                0x8: 0x8020000,
                                0x9: 0x8000800,
                                0xa: 0x20800,
                                0xb: 0x8020020,
                                0xc: 0x820,
                                0xd: 0x0,
                                0xe: 0x8000020,
                                0xf: 0x20820,
                                0x80000000: 0x800,
                                0x80000001: 0x8020820,
                                0x80000002: 0x8000820,
                                0x80000003: 0x8000000,
                                0x80000004: 0x8020000,
                                0x80000005: 0x20800,
                                0x80000006: 0x20820,
                                0x80000007: 0x20,
                                0x80000008: 0x8000020,
                                0x80000009: 0x820,
                                0x8000000a: 0x20020,
                                0x8000000b: 0x8020800,
                                0x8000000c: 0x0,
                                0x8000000d: 0x8020020,
                                0x8000000e: 0x8000800,
                                0x8000000f: 0x20000,
                                0x10: 0x20820,
                                0x11: 0x8020800,
                                0x12: 0x20,
                                0x13: 0x800,
                                0x14: 0x8000800,
                                0x15: 0x8000020,
                                0x16: 0x8020020,
                                0x17: 0x20000,
                                0x18: 0x0,
                                0x19: 0x20020,
                                0x1a: 0x8020000,
                                0x1b: 0x8000820,
                                0x1c: 0x8020820,
                                0x1d: 0x20800,
                                0x1e: 0x820,
                                0x1f: 0x8000000,
                                0x80000010: 0x20000,
                                0x80000011: 0x800,
                                0x80000012: 0x8020020,
                                0x80000013: 0x20820,
                                0x80000014: 0x20,
                                0x80000015: 0x8020000,
                                0x80000016: 0x8000000,
                                0x80000017: 0x8000820,
                                0x80000018: 0x8020820,
                                0x80000019: 0x8000020,
                                0x8000001a: 0x8000800,
                                0x8000001b: 0x0,
                                0x8000001c: 0x20800,
                                0x8000001d: 0x820,
                                0x8000001e: 0x20020,
                                0x8000001f: 0x8020800
                            }
                        ];
                        // Masks that select the SBOX input
                        var SBOX_MASK = [
                            0xf8000001,
                            0x1f800000,
                            0x01f80000,
                            0x001f8000,
                            0x0001f800,
                            0x00001f80,
                            0x000001f8,
                            0x8000001f
                        ];
                        /**
     * DES block cipher algorithm.
     */ var DES = C_algo.DES = BlockCipher.extend({
                            _doReset: function _doReset() {
                                // Shortcuts
                                var key = this._key;
                                var keyWords = key.words;
                                // Select 56 bits according to PC1
                                var keyBits = [];
                                for(var i = 0; i < 56; i++){
                                    var keyBitPos = PC1[i] - 1;
                                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                                }
                                // Assemble 16 subkeys
                                var subKeys = this._subKeys = [];
                                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                                    // Create subkey
                                    var subKey = subKeys[nSubKey] = [];
                                    // Shortcut
                                    var bitShift = BIT_SHIFTS[nSubKey];
                                    // Select 48 bits according to PC2
                                    for(var i = 0; i < 24; i++){
                                        // Select from the left 28 key bits
                                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                                        // Select from the right 28 key bits
                                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                                    }
                                    // Since each subkey is applied to an expanded 32-bit input,
                                    // the subkey can be broken into 8 values scaled to 32-bits,
                                    // which allows the key to be used without expansion
                                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                                }
                                // Compute inverse subkeys
                                var invSubKeys = this._invSubKeys = [];
                                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
                            },
                            encryptBlock: function encryptBlock(M, offset) {
                                this._doCryptBlock(M, offset, this._subKeys);
                            },
                            decryptBlock: function decryptBlock(M, offset) {
                                this._doCryptBlock(M, offset, this._invSubKeys);
                            },
                            _doCryptBlock: function _doCryptBlock(M, offset, subKeys) {
                                // Get input
                                this._lBlock = M[offset];
                                this._rBlock = M[offset + 1];
                                // Initial permutation
                                exchangeLR.call(this, 4, 0x0f0f0f0f);
                                exchangeLR.call(this, 16, 0x0000ffff);
                                exchangeRL.call(this, 2, 0x33333333);
                                exchangeRL.call(this, 8, 0x00ff00ff);
                                exchangeLR.call(this, 1, 0x55555555);
                                // Rounds
                                for(var round = 0; round < 16; round++){
                                    // Shortcuts
                                    var subKey = subKeys[round];
                                    var lBlock = this._lBlock;
                                    var rBlock = this._rBlock;
                                    // Feistel function
                                    var f = 0;
                                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                                    this._lBlock = rBlock;
                                    this._rBlock = lBlock ^ f;
                                }
                                // Undo swap from last round
                                var t = this._lBlock;
                                this._lBlock = this._rBlock;
                                this._rBlock = t;
                                // Final permutation
                                exchangeLR.call(this, 1, 0x55555555);
                                exchangeRL.call(this, 8, 0x00ff00ff);
                                exchangeRL.call(this, 2, 0x33333333);
                                exchangeLR.call(this, 16, 0x0000ffff);
                                exchangeLR.call(this, 4, 0x0f0f0f0f);
                                // Set output
                                M[offset] = this._lBlock;
                                M[offset + 1] = this._rBlock;
                            },
                            keySize: 2,
                            ivSize: 2,
                            blockSize: 2
                        });
                        // Swap bits across the left and right words
                        function exchangeLR(offset, mask) {
                            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
                            this._rBlock ^= t;
                            this._lBlock ^= t << offset;
                        }
                        function exchangeRL(offset, mask) {
                            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
                            this._lBlock ^= t;
                            this._rBlock ^= t << offset;
                        }
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
     */ C.DES = BlockCipher._createHelper(DES);
                        /**
     * Triple-DES block cipher algorithm.
     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
                            _doReset: function _doReset() {
                                // Shortcuts
                                var key = this._key;
                                var keyWords = key.words;
                                // Make sure the key length is valid (64, 128 or >= 192 bit)
                                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
                                // Extend the key according to the keying options defined in 3DES standard
                                var key1 = keyWords.slice(0, 2);
                                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                                // Create DES instances
                                this._des1 = DES.createEncryptor(WordArray.create(key1));
                                this._des2 = DES.createEncryptor(WordArray.create(key2));
                                this._des3 = DES.createEncryptor(WordArray.create(key3));
                            },
                            encryptBlock: function encryptBlock(M, offset) {
                                this._des1.encryptBlock(M, offset);
                                this._des2.decryptBlock(M, offset);
                                this._des3.encryptBlock(M, offset);
                            },
                            decryptBlock: function decryptBlock(M, offset) {
                                this._des3.decryptBlock(M, offset);
                                this._des2.encryptBlock(M, offset);
                                this._des1.decryptBlock(M, offset);
                            },
                            keySize: 6,
                            ivSize: 2,
                            blockSize: 2
                        });
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
                    })();
                    return CryptoJS.TripleDES;
                });
            /***/ },
            /***/ 24162: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(93143).Buffer;
                // == UTF32-LE/BE codec. ==========================================================
                exports._utf32 = Utf32Codec;
                function Utf32Codec(codecOptions, iconv) {
                    this.iconv = iconv;
                    this.bomAware = true;
                    this.isLE = codecOptions.isLE;
                }
                exports.utf32le = {
                    type: '_utf32',
                    isLE: true
                };
                exports.utf32be = {
                    type: '_utf32',
                    isLE: false
                };
                // Aliases
                exports.ucs4le = 'utf32le';
                exports.ucs4be = 'utf32be';
                Utf32Codec.prototype.encoder = Utf32Encoder;
                Utf32Codec.prototype.decoder = Utf32Decoder;
                // -- Encoding
                function Utf32Encoder(options, codec) {
                    this.isLE = codec.isLE;
                    this.highSurrogate = 0;
                }
                Utf32Encoder.prototype.write = function(str) {
                    var src = Buffer.from(str, 'ucs2');
                    var dst = Buffer.alloc(src.length * 2);
                    var write32 = this.isLE ? dst.writeUInt32LE : dst.writeUInt32BE;
                    var offset = 0;
                    for(var i = 0; i < src.length; i += 2){
                        var code = src.readUInt16LE(i);
                        var isHighSurrogate = 0xD800 <= code && code < 0xDC00;
                        var isLowSurrogate = 0xDC00 <= code && code < 0xE000;
                        if (this.highSurrogate) {
                            if (isHighSurrogate || !isLowSurrogate) {
                                // There shouldn't be two high surrogates in a row, nor a high surrogate which isn't followed by a low
                                // surrogate. If this happens, keep the pending high surrogate as a stand-alone semi-invalid character
                                // (technically wrong, but expected by some applications, like Windows file names).
                                write32.call(dst, this.highSurrogate, offset);
                                offset += 4;
                            } else {
                                // Create 32-bit value from high and low surrogates;
                                var codepoint = (this.highSurrogate - 0xD800 << 10 | code - 0xDC00) + 0x10000;
                                write32.call(dst, codepoint, offset);
                                offset += 4;
                                this.highSurrogate = 0;
                                continue;
                            }
                        }
                        if (isHighSurrogate) this.highSurrogate = code;
                        else {
                            // Even if the current character is a low surrogate, with no previous high surrogate, we'll
                            // encode it as a semi-invalid stand-alone character for the same reasons expressed above for
                            // unpaired high surrogates.
                            write32.call(dst, code, offset);
                            offset += 4;
                            this.highSurrogate = 0;
                        }
                    }
                    if (offset < dst.length) dst = dst.slice(0, offset);
                    return dst;
                };
                Utf32Encoder.prototype.end = function() {
                    // Treat any leftover high surrogate as a semi-valid independent character.
                    if (!this.highSurrogate) return;
                    var buf = Buffer.alloc(4);
                    if (this.isLE) buf.writeUInt32LE(this.highSurrogate, 0);
                    else buf.writeUInt32BE(this.highSurrogate, 0);
                    this.highSurrogate = 0;
                    return buf;
                };
                // -- Decoding
                function Utf32Decoder(options, codec) {
                    this.isLE = codec.isLE;
                    this.badChar = codec.iconv.defaultCharUnicode.charCodeAt(0);
                    this.overflow = [];
                }
                Utf32Decoder.prototype.write = function(src) {
                    if (src.length === 0) return '';
                    var i = 0;
                    var codepoint = 0;
                    var dst = Buffer.alloc(src.length + 4);
                    var offset = 0;
                    var isLE = this.isLE;
                    var overflow = this.overflow;
                    var badChar = this.badChar;
                    if (overflow.length > 0) {
                        for(; i < src.length && overflow.length < 4; i++)overflow.push(src[i]);
                        if (overflow.length === 4) {
                            // NOTE: codepoint is a signed int32 and can be negative.
                            // NOTE: We copied this block from below to help V8 optimize it (it works with array, not buffer).
                            if (isLE) codepoint = overflow[i] | overflow[i + 1] << 8 | overflow[i + 2] << 16 | overflow[i + 3] << 24;
                            else codepoint = overflow[i + 3] | overflow[i + 2] << 8 | overflow[i + 1] << 16 | overflow[i] << 24;
                            overflow.length = 0;
                            offset = _writeCodepoint(dst, offset, codepoint, badChar);
                        }
                    }
                    // Main loop. Should be as optimized as possible.
                    for(; i < src.length - 3; i += 4){
                        // NOTE: codepoint is a signed int32 and can be negative.
                        if (isLE) codepoint = src[i] | src[i + 1] << 8 | src[i + 2] << 16 | src[i + 3] << 24;
                        else codepoint = src[i + 3] | src[i + 2] << 8 | src[i + 1] << 16 | src[i] << 24;
                        offset = _writeCodepoint(dst, offset, codepoint, badChar);
                    }
                    // Keep overflowing bytes.
                    for(; i < src.length; i++)overflow.push(src[i]);
                    return dst.slice(0, offset).toString('ucs2');
                };
                function _writeCodepoint(dst, offset, codepoint, badChar) {
                    // NOTE: codepoint is signed int32 and can be negative. We keep it that way to help V8 with optimizations.
                    if (codepoint < 0 || codepoint > 0x10FFFF) // Not a valid Unicode codepoint
                    codepoint = badChar;
                    // Ephemeral Planes: Write high surrogate.
                    if (codepoint >= 0x10000) {
                        codepoint -= 0x10000;
                        var high = 0xD800 | codepoint >> 10;
                        dst[offset++] = high & 0xff;
                        dst[offset++] = high >> 8;
                        // Low surrogate is written below.
                        var codepoint = 0xDC00 | codepoint & 0x3FF;
                    }
                    // Write BMP char or low surrogate.
                    dst[offset++] = codepoint & 0xff;
                    dst[offset++] = codepoint >> 8;
                    return offset;
                }
                Utf32Decoder.prototype.end = function() {
                    this.overflow.length = 0;
                };
                // == UTF-32 Auto codec =============================================================
                // Decoder chooses automatically from UTF-32LE and UTF-32BE using BOM and space-based heuristic.
                // Defaults to UTF-32LE. http://en.wikipedia.org/wiki/UTF-32
                // Encoder/decoder default can be changed: iconv.decode(buf, 'utf32', {defaultEncoding: 'utf-32be'});
                // Encoder prepends BOM (which can be overridden with (addBOM: false}).
                exports.utf32 = Utf32AutoCodec;
                exports.ucs4 = 'utf32';
                function Utf32AutoCodec(options, iconv) {
                    this.iconv = iconv;
                }
                Utf32AutoCodec.prototype.encoder = Utf32AutoEncoder;
                Utf32AutoCodec.prototype.decoder = Utf32AutoDecoder;
                // -- Encoding
                function Utf32AutoEncoder(options, codec) {
                    options = options || {};
                    if (options.addBOM === undefined) options.addBOM = true;
                    this.encoder = codec.iconv.getEncoder(options.defaultEncoding || 'utf-32le', options);
                }
                Utf32AutoEncoder.prototype.write = function(str) {
                    return this.encoder.write(str);
                };
                Utf32AutoEncoder.prototype.end = function() {
                    return this.encoder.end();
                };
                // -- Decoding
                function Utf32AutoDecoder(options, codec) {
                    this.decoder = null;
                    this.initialBufs = [];
                    this.initialBufsLen = 0;
                    this.options = options || {};
                    this.iconv = codec.iconv;
                }
                Utf32AutoDecoder.prototype.write = function(buf) {
                    if (!this.decoder) {
                        // Codec is not chosen yet. Accumulate initial bytes.
                        this.initialBufs.push(buf);
                        this.initialBufsLen += buf.length;
                        if (this.initialBufsLen < 32) return '';
                        // We have enough bytes -> detect endianness.
                        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
                        this.decoder = this.iconv.getDecoder(encoding, this.options);
                        var resStr = '';
                        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
                        this.initialBufs.length = this.initialBufsLen = 0;
                        return resStr;
                    }
                    return this.decoder.write(buf);
                };
                Utf32AutoDecoder.prototype.end = function() {
                    if (!this.decoder) {
                        var encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
                        this.decoder = this.iconv.getDecoder(encoding, this.options);
                        var resStr = '';
                        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
                        var trail = this.decoder.end();
                        if (trail) resStr += trail;
                        this.initialBufs.length = this.initialBufsLen = 0;
                        return resStr;
                    }
                    return this.decoder.end();
                };
                function detectEncoding(bufs, defaultEncoding) {
                    var b = [];
                    var charsProcessed = 0;
                    var invalidLE = 0, invalidBE = 0; // Number of invalid chars when decoded as LE or BE.
                    var bmpCharsLE = 0, bmpCharsBE = 0; // Number of BMP chars when decoded as LE or BE.
                    outer_loop: for(var i = 0; i < bufs.length; i++){
                        var buf = bufs[i];
                        for(var j = 0; j < buf.length; j++){
                            b.push(buf[j]);
                            if (b.length === 4) {
                                if (charsProcessed === 0) {
                                    // Check BOM first.
                                    if (b[0] === 0xFF && b[1] === 0xFE && b[2] === 0 && b[3] === 0) return 'utf-32le';
                                    if (b[0] === 0 && b[1] === 0 && b[2] === 0xFE && b[3] === 0xFF) return 'utf-32be';
                                }
                                if (b[0] !== 0 || b[1] > 0x10) invalidBE++;
                                if (b[3] !== 0 || b[2] > 0x10) invalidLE++;
                                if (b[0] === 0 && b[1] === 0 && (b[2] !== 0 || b[3] !== 0)) bmpCharsBE++;
                                if ((b[0] !== 0 || b[1] !== 0) && b[2] === 0 && b[3] === 0) bmpCharsLE++;
                                b.length = 0;
                                charsProcessed++;
                                if (charsProcessed >= 100) break outer_loop;
                            }
                        }
                    }
                    // Make decisions.
                    if (bmpCharsBE - invalidBE > bmpCharsLE - invalidLE) return 'utf-32be';
                    if (bmpCharsBE - invalidBE < bmpCharsLE - invalidLE) return 'utf-32le';
                    // Couldn't decide (likely all zeros or not enough data).
                    return defaultEncoding || 'utf-32le';
                }
            /***/ },
            /***/ 24433: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(65292);
                __webpack_require__(5597);
                __webpack_require__(49063);
                __webpack_require__(20731);
                __webpack_require__(7585);
                __webpack_require__(7283);
                __webpack_require__(57444);
                __webpack_require__(28331);
                __webpack_require__(37309);
                __webpack_require__(14032);
                __webpack_require__(42437);
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return typeof key === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (typeof input !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (typeof res !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                var _require = __webpack_require__(14598), Buffer = _require.Buffer;
                var _require2 = __webpack_require__(63779), inspect = _require2.inspect;
                var custom = inspect && inspect.custom || 'inspect';
                function copyBuffer(src, target, offset) {
                    Buffer.prototype.copy.call(src, target, offset);
                }
                module1.exports = /*#__PURE__*/ function() {
                    function BufferList() {
                        _classCallCheck(this, BufferList);
                        this.head = null;
                        this.tail = null;
                        this.length = 0;
                    }
                    _createClass(BufferList, [
                        {
                            key: "push",
                            value: function push(v) {
                                var entry = {
                                    data: v,
                                    next: null
                                };
                                if (this.length > 0) this.tail.next = entry;
                                else this.head = entry;
                                this.tail = entry;
                                ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function unshift(v) {
                                var entry = {
                                    data: v,
                                    next: this.head
                                };
                                if (this.length === 0) this.tail = entry;
                                this.head = entry;
                                ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function shift() {
                                if (this.length === 0) return;
                                var ret = this.head.data;
                                if (this.length === 1) this.head = this.tail = null;
                                else this.head = this.head.next;
                                --this.length;
                                return ret;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.head = this.tail = null;
                                this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function join(s) {
                                if (this.length === 0) return '';
                                var p = this.head;
                                var ret = '' + p.data;
                                while(p = p.next)ret += s + p.data;
                                return ret;
                            }
                        },
                        {
                            key: "concat",
                            value: function concat(n) {
                                if (this.length === 0) return Buffer.alloc(0);
                                var ret = Buffer.allocUnsafe(n >>> 0);
                                var p = this.head;
                                var i = 0;
                                while(p){
                                    copyBuffer(p.data, ret, i);
                                    i += p.data.length;
                                    p = p.next;
                                }
                                return ret;
                            }
                        },
                        {
                            key: "consume",
                            value: function consume(n, hasStrings) {
                                var ret;
                                if (n < this.head.data.length) {
                                    // `slice` is the same for buffers and strings.
                                    ret = this.head.data.slice(0, n);
                                    this.head.data = this.head.data.slice(n);
                                } else if (n === this.head.data.length) // First chunk is a perfect match.
                                ret = this.shift();
                                else // Result spans more than one buffer.
                                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                                return ret;
                            }
                        },
                        {
                            key: "first",
                            value: function first() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function _getString(n) {
                                var p = this.head;
                                var c = 1;
                                var ret = p.data;
                                n -= ret.length;
                                while(p = p.next){
                                    var str = p.data;
                                    var nb = n > str.length ? str.length : n;
                                    if (nb === str.length) ret += str;
                                    else ret += str.slice(0, n);
                                    n -= nb;
                                    if (n === 0) {
                                        if (nb === str.length) {
                                            ++c;
                                            if (p.next) this.head = p.next;
                                            else this.head = this.tail = null;
                                        } else {
                                            this.head = p;
                                            p.data = str.slice(nb);
                                        }
                                        break;
                                    }
                                    ++c;
                                }
                                this.length -= c;
                                return ret;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function _getBuffer(n) {
                                var ret = Buffer.allocUnsafe(n);
                                var p = this.head;
                                var c = 1;
                                p.data.copy(ret);
                                n -= p.data.length;
                                while(p = p.next){
                                    var buf = p.data;
                                    var nb = n > buf.length ? buf.length : n;
                                    buf.copy(ret, ret.length - n, 0, nb);
                                    n -= nb;
                                    if (n === 0) {
                                        if (nb === buf.length) {
                                            ++c;
                                            if (p.next) this.head = p.next;
                                            else this.head = this.tail = null;
                                        } else {
                                            this.head = p;
                                            p.data = buf.slice(nb);
                                        }
                                        break;
                                    }
                                    ++c;
                                }
                                this.length -= c;
                                return ret;
                            }
                        },
                        {
                            key: custom,
                            value: function value(_, options) {
                                return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
                                    // Only inspect one level.
                                    depth: 0,
                                    // It should not recurse.
                                    customInspect: false
                                }));
                            }
                        }
                    ]);
                    return BufferList;
                }();
            /***/ },
            /***/ 24517: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var isCallable = __webpack_require__(94578);
                module1.exports = function(it) {
                    return typeof it == 'object' ? it !== null : isCallable(it);
                };
            /***/ },
            /***/ 24597: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var apply = __webpack_require__(58448);
                var $lastIndexOf = __webpack_require__(84320);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.lastIndexOf` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
                exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */ ) {
                    var length = arguments.length;
                    return apply($lastIndexOf, aTypedArray(this), length > 1 ? [
                        searchElement,
                        arguments[1]
                    ] : [
                        searchElement
                    ]);
                });
            /***/ },
            /***/ 24663: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(38688);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var test = {};
                test[TO_STRING_TAG] = 'z';
                module1.exports = String(test) === '[object z]';
            /***/ },
            /***/ 24766: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var $c5L0i$base64js = __webpack_require__(32504);
                var $c5L0i$unicodetrie = __webpack_require__(59006);
                function $parcel$interopDefault(a) {
                    return a && a.__esModule ? a.default : a;
                }
                function $parcel$defineInteropFlag(a) {
                    Object.defineProperty(a, '__esModule', {
                        value: true,
                        configurable: true
                    });
                }
                function $parcel$export(e, n, v, s) {
                    Object.defineProperty(e, n, {
                        get: v,
                        set: s,
                        enumerable: true,
                        configurable: true
                    });
                }
                $parcel$defineInteropFlag(module1.exports);
                $parcel$export(module1.exports, "getCategory", ()=>$43d7963e56408b24$export$410364bbb673ddbc);
                $parcel$export(module1.exports, "getCombiningClass", ()=>$43d7963e56408b24$export$c03b919c6651ed55);
                $parcel$export(module1.exports, "getScript", ()=>$43d7963e56408b24$export$941569448d136665);
                $parcel$export(module1.exports, "getEastAsianWidth", ()=>$43d7963e56408b24$export$92f6187db8ca6d26);
                $parcel$export(module1.exports, "getNumericValue", ()=>$43d7963e56408b24$export$7d1258ebb7625a0d);
                $parcel$export(module1.exports, "isAlphabetic", ()=>$43d7963e56408b24$export$52c8ea63abd07594);
                $parcel$export(module1.exports, "isDigit", ()=>$43d7963e56408b24$export$727d9dbc4fbb948f);
                $parcel$export(module1.exports, "isPunctuation", ()=>$43d7963e56408b24$export$a5b49f4dc6a07d2c);
                $parcel$export(module1.exports, "isLowerCase", ()=>$43d7963e56408b24$export$7b6804e8df61fcf5);
                $parcel$export(module1.exports, "isUpperCase", ()=>$43d7963e56408b24$export$aebd617640818cda);
                $parcel$export(module1.exports, "isTitleCase", ()=>$43d7963e56408b24$export$de8b4ee23b2cf823);
                $parcel$export(module1.exports, "isWhiteSpace", ()=>$43d7963e56408b24$export$3c52dd84024ae72c);
                $parcel$export(module1.exports, "isBaseForm", ()=>$43d7963e56408b24$export$a11bdcffe109e74b);
                $parcel$export(module1.exports, "isMark", ()=>$43d7963e56408b24$export$e33ad6871e762338);
                $parcel$export(module1.exports, "default", ()=>$43d7963e56408b24$export$2e2bcd8739ae039);
                var $29668e65f2091c2c$exports = {};
                $29668e65f2091c2c$exports = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
                const $43d7963e56408b24$var$trie = new ($parcel$interopDefault($c5L0i$unicodetrie))($parcel$interopDefault($c5L0i$base64js).toByteArray("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"));
                const $43d7963e56408b24$var$log2 = Math.log2 || ((n)=>Math.log(n) / Math.LN2);
                const $43d7963e56408b24$var$bits = (n)=>$43d7963e56408b24$var$log2(n) + 1 | 0;
                // compute the number of bits stored for each field
                const $43d7963e56408b24$var$CATEGORY_BITS = $43d7963e56408b24$var$bits(/*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).categories.length - 1);
                const $43d7963e56408b24$var$COMBINING_BITS = $43d7963e56408b24$var$bits(/*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).combiningClasses.length - 1);
                const $43d7963e56408b24$var$SCRIPT_BITS = $43d7963e56408b24$var$bits(/*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).scripts.length - 1);
                const $43d7963e56408b24$var$EAW_BITS = $43d7963e56408b24$var$bits(/*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).eaw.length - 1);
                const $43d7963e56408b24$var$NUMBER_BITS = 10;
                // compute shift and mask values for each field
                const $43d7963e56408b24$var$CATEGORY_SHIFT = $43d7963e56408b24$var$COMBINING_BITS + $43d7963e56408b24$var$SCRIPT_BITS + $43d7963e56408b24$var$EAW_BITS + $43d7963e56408b24$var$NUMBER_BITS;
                const $43d7963e56408b24$var$COMBINING_SHIFT = $43d7963e56408b24$var$SCRIPT_BITS + $43d7963e56408b24$var$EAW_BITS + $43d7963e56408b24$var$NUMBER_BITS;
                const $43d7963e56408b24$var$SCRIPT_SHIFT = $43d7963e56408b24$var$EAW_BITS + $43d7963e56408b24$var$NUMBER_BITS;
                const $43d7963e56408b24$var$EAW_SHIFT = $43d7963e56408b24$var$NUMBER_BITS;
                const $43d7963e56408b24$var$CATEGORY_MASK = (1 << $43d7963e56408b24$var$CATEGORY_BITS) - 1;
                const $43d7963e56408b24$var$COMBINING_MASK = (1 << $43d7963e56408b24$var$COMBINING_BITS) - 1;
                const $43d7963e56408b24$var$SCRIPT_MASK = (1 << $43d7963e56408b24$var$SCRIPT_BITS) - 1;
                const $43d7963e56408b24$var$EAW_MASK = (1 << $43d7963e56408b24$var$EAW_BITS) - 1;
                const $43d7963e56408b24$var$NUMBER_MASK = (1 << $43d7963e56408b24$var$NUMBER_BITS) - 1;
                function $43d7963e56408b24$export$410364bbb673ddbc(codePoint) {
                    const val = $43d7963e56408b24$var$trie.get(codePoint);
                    return /*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).categories[val >> $43d7963e56408b24$var$CATEGORY_SHIFT & $43d7963e56408b24$var$CATEGORY_MASK];
                }
                function $43d7963e56408b24$export$c03b919c6651ed55(codePoint) {
                    const val = $43d7963e56408b24$var$trie.get(codePoint);
                    return /*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).combiningClasses[val >> $43d7963e56408b24$var$COMBINING_SHIFT & $43d7963e56408b24$var$COMBINING_MASK];
                }
                function $43d7963e56408b24$export$941569448d136665(codePoint) {
                    const val = $43d7963e56408b24$var$trie.get(codePoint);
                    return /*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).scripts[val >> $43d7963e56408b24$var$SCRIPT_SHIFT & $43d7963e56408b24$var$SCRIPT_MASK];
                }
                function $43d7963e56408b24$export$92f6187db8ca6d26(codePoint) {
                    const val = $43d7963e56408b24$var$trie.get(codePoint);
                    return /*@__PURE__*/ $parcel$interopDefault($29668e65f2091c2c$exports).eaw[val >> $43d7963e56408b24$var$EAW_SHIFT & $43d7963e56408b24$var$EAW_MASK];
                }
                function $43d7963e56408b24$export$7d1258ebb7625a0d(codePoint) {
                    let val = $43d7963e56408b24$var$trie.get(codePoint);
                    let num = val & $43d7963e56408b24$var$NUMBER_MASK;
                    if (num === 0) return null;
                    else if (num <= 50) return num - 1;
                    else if (num < 0x1e0) {
                        const numerator = (num >> 4) - 12;
                        const denominator = (num & 0xf) + 1;
                        return numerator / denominator;
                    } else if (num < 0x300) {
                        val = (num >> 5) - 14;
                        let exp = (num & 0x1f) + 2;
                        while(exp > 0){
                            val *= 10;
                            exp--;
                        }
                        return val;
                    } else {
                        val = (num >> 2) - 0xbf;
                        let exp = (num & 3) + 1;
                        while(exp > 0){
                            val *= 60;
                            exp--;
                        }
                        return val;
                    }
                }
                function $43d7963e56408b24$export$52c8ea63abd07594(codePoint) {
                    const category = $43d7963e56408b24$export$410364bbb673ddbc(codePoint);
                    return category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Nl";
                }
                function $43d7963e56408b24$export$727d9dbc4fbb948f(codePoint) {
                    return $43d7963e56408b24$export$410364bbb673ddbc(codePoint) === "Nd";
                }
                function $43d7963e56408b24$export$a5b49f4dc6a07d2c(codePoint) {
                    const category = $43d7963e56408b24$export$410364bbb673ddbc(codePoint);
                    return category === "Pc" || category === "Pd" || category === "Pe" || category === "Pf" || category === "Pi" || category === "Po" || category === "Ps";
                }
                function $43d7963e56408b24$export$7b6804e8df61fcf5(codePoint) {
                    return $43d7963e56408b24$export$410364bbb673ddbc(codePoint) === "Ll";
                }
                function $43d7963e56408b24$export$aebd617640818cda(codePoint) {
                    return $43d7963e56408b24$export$410364bbb673ddbc(codePoint) === "Lu";
                }
                function $43d7963e56408b24$export$de8b4ee23b2cf823(codePoint) {
                    return $43d7963e56408b24$export$410364bbb673ddbc(codePoint) === "Lt";
                }
                function $43d7963e56408b24$export$3c52dd84024ae72c(codePoint) {
                    const category = $43d7963e56408b24$export$410364bbb673ddbc(codePoint);
                    return category === "Zs" || category === "Zl" || category === "Zp";
                }
                function $43d7963e56408b24$export$a11bdcffe109e74b(codePoint) {
                    const category = $43d7963e56408b24$export$410364bbb673ddbc(codePoint);
                    return category === "Nd" || category === "No" || category === "Nl" || category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Me" || category === "Mc";
                }
                function $43d7963e56408b24$export$e33ad6871e762338(codePoint) {
                    const category = $43d7963e56408b24$export$410364bbb673ddbc(codePoint);
                    return category === "Mn" || category === "Me" || category === "Mc";
                }
                var $43d7963e56408b24$export$2e2bcd8739ae039 = {
                    getCategory: $43d7963e56408b24$export$410364bbb673ddbc,
                    getCombiningClass: $43d7963e56408b24$export$c03b919c6651ed55,
                    getScript: $43d7963e56408b24$export$941569448d136665,
                    getEastAsianWidth: $43d7963e56408b24$export$92f6187db8ca6d26,
                    getNumericValue: $43d7963e56408b24$export$7d1258ebb7625a0d,
                    isAlphabetic: $43d7963e56408b24$export$52c8ea63abd07594,
                    isDigit: $43d7963e56408b24$export$727d9dbc4fbb948f,
                    isPunctuation: $43d7963e56408b24$export$a5b49f4dc6a07d2c,
                    isLowerCase: $43d7963e56408b24$export$7b6804e8df61fcf5,
                    isUpperCase: $43d7963e56408b24$export$aebd617640818cda,
                    isTitleCase: $43d7963e56408b24$export$de8b4ee23b2cf823,
                    isWhiteSpace: $43d7963e56408b24$export$3c52dd84024ae72c,
                    isBaseForm: $43d7963e56408b24$export$a11bdcffe109e74b,
                    isMark: $43d7963e56408b24$export$e33ad6871e762338
                };
            /***/ },
            /***/ 24863: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(15567);
                var FUNCTION_NAME_EXISTS = __webpack_require__(7081).EXISTS;
                var uncurryThis = __webpack_require__(38347);
                var defineProperty = __webpack_require__(95892).f;
                var FunctionPrototype = Function.prototype;
                var functionToString = uncurryThis(FunctionPrototype.toString);
                var nameRE = /^\s*function ([^ (]*)/;
                var regExpExec = uncurryThis(nameRE.exec);
                var NAME = 'name';
                // Function instances `.name` property
                // https://tc39.es/ecma262/#sec-function-instances-name
                if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) defineProperty(FunctionPrototype, NAME, {
                    configurable: true,
                    get: function() {
                        try {
                            return regExpExec(nameRE, functionToString(this))[1];
                        } catch (error) {
                            return '';
                        }
                    }
                });
            /***/ },
            /***/ 25096: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var classof = __webpack_require__(52564);
                var String1 = global.String;
                module1.exports = function(argument) {
                    if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
                    return String1(argument);
                };
            /***/ },
            /***/ 25567: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var aCallable = __webpack_require__(32631);
                var bind = uncurryThis(uncurryThis.bind);
                // optional / simple context binding
                module1.exports = function(fn, that) {
                    aCallable(fn);
                    return that === undefined ? fn : bind ? bind(fn, that) : function() {
                        return fn.apply(that, arguments);
                    };
                };
            /***/ },
            /***/ 26168: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isCallable = __webpack_require__(94578);
                var inspectSource = __webpack_require__(10447);
                var WeakMap1 = global.WeakMap;
                module1.exports = isCallable(WeakMap1) && /native code/.test(inspectSource(WeakMap1));
            /***/ },
            /***/ 26326: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // Update this array if you add/rename/remove files in this directory.
                // We support Browserify by skipping automatic module discovery and requiring modules directly.
                var modules = [
                    __webpack_require__(16793),
                    __webpack_require__(24162),
                    __webpack_require__(17100),
                    __webpack_require__(11326),
                    __webpack_require__(99948),
                    __webpack_require__(99900),
                    __webpack_require__(81492),
                    __webpack_require__(35143),
                    __webpack_require__(90481)
                ];
                // Put all encoding/alias/codec definitions to single object and export it.
                for(var i = 0; i < modules.length; i++){
                    var module1 = modules[i];
                    for(var enc in module1)if (Object.prototype.hasOwnProperty.call(module1, enc)) exports[enc] = module1[enc];
                }
            /***/ },
            /***/ 26601: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var setFunctionLength = __webpack_require__(86255);
                var $defineProperty = __webpack_require__(56649);
                var callBindBasic = __webpack_require__(36688);
                var applyBind = __webpack_require__(28619);
                module1.exports = function callBind(originalFunction) {
                    var func = callBindBasic(arguments);
                    var adjustedLength = originalFunction.length - (arguments.length - 1);
                    return setFunctionLength(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
                };
                if ($defineProperty) $defineProperty(module1.exports, 'apply', {
                    value: applyBind
                });
                else module1.exports.apply = applyBind;
            /***/ },
            /***/ 26626: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var hasSymbols = __webpack_require__(12843);
                /** @type {import('.')} */ module1.exports = function hasToStringTagShams() {
                    return hasSymbols() && !!Symbol.toStringTag;
                };
            /***/ },
            /***/ 26663: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var codeAt = __webpack_require__(69510).codeAt;
                // `String.prototype.codePointAt` method
                // https://tc39.es/ecma262/#sec-string.prototype.codepointat
                $({
                    target: 'String',
                    proto: true
                }, {
                    codePointAt: function codePointAt(pos) {
                        return codeAt(this, pos);
                    }
                });
            /***/ },
            /***/ 26882: /***/ function(module1) {
                var ceil = Math.ceil;
                var floor = Math.floor;
                // `ToIntegerOrInfinity` abstract operation
                // https://tc39.es/ecma262/#sec-tointegerorinfinity
                module1.exports = function(argument) {
                    var number = +argument;
                    // eslint-disable-next-line no-self-compare -- safe
                    return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
                };
            /***/ },
            /***/ 27754: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var anObject = __webpack_require__(34984);
                var aConstructor = __webpack_require__(69075);
                var wellKnownSymbol = __webpack_require__(38688);
                var SPECIES = wellKnownSymbol('species');
                // `SpeciesConstructor` abstract operation
                // https://tc39.es/ecma262/#sec-speciesconstructor
                module1.exports = function(O, defaultConstructor) {
                    var C = anObject(O).constructor;
                    var S;
                    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
                };
            /***/ },
            /***/ 27772: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(18909), __webpack_require__(51965));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_x64 = C.x64;
                        var X64Word = C_x64.Word;
                        var X64WordArray = C_x64.WordArray;
                        var C_algo = C.algo;
                        var SHA512 = C_algo.SHA512;
                        /**
     * SHA-384 hash algorithm.
     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
                            _doReset: function _doReset() {
                                this._hash = new X64WordArray.init([
                                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                                    new X64Word.init(0x629a292a, 0x367cd507),
                                    new X64Word.init(0x9159015a, 0x3070dd17),
                                    new X64Word.init(0x152fecd8, 0xf70e5939),
                                    new X64Word.init(0x67332667, 0xffc00b31),
                                    new X64Word.init(0x8eb44a87, 0x68581511),
                                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                                ]);
                            },
                            _doFinalize: function _doFinalize() {
                                var hash = SHA512._doFinalize.call(this);
                                hash.sigBytes -= 16;
                                return hash;
                            }
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA384('message');
     *     var hash = CryptoJS.SHA384(wordArray);
     */ C.SHA384 = SHA512._createHelper(SHA384);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA384(message, key);
     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
                    })();
                    return CryptoJS.SHA384;
                });
            /***/ },
            /***/ 28164: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    /**
   * ANSI X.923 padding strategy.
   */ CryptoJS.pad.AnsiX923 = {
                        pad: function pad(data, blockSize) {
                            // Shortcuts
                            var dataSigBytes = data.sigBytes;
                            var blockSizeBytes = blockSize * 4;
                            // Count padding bytes
                            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
                            // Compute last byte position
                            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
                            // Pad
                            data.clamp();
                            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
                            data.sigBytes += nPaddingBytes;
                        },
                        unpad: function unpad(data) {
                            // Get number of padding bytes from last byte
                            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                            // Remove padding
                            data.sigBytes -= nPaddingBytes;
                        }
                    };
                    return CryptoJS.pad.Ansix923;
                });
            /***/ },
            /***/ 28264: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var repeat = __webpack_require__(34858);
                // `String.prototype.repeat` method
                // https://tc39.es/ecma262/#sec-string.prototype.repeat
                $({
                    target: 'String',
                    proto: true
                }, {
                    repeat: repeat
                });
            /***/ },
            /***/ 28284: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isArray = __webpack_require__(91867).isArray;
                function typeName(bold, italics) {
                    var type = 'normal';
                    if (bold && italics) type = 'bolditalics';
                    else if (bold) type = 'bold';
                    else if (italics) type = 'italics';
                    return type;
                }
                function FontProvider(fontDescriptors, pdfKitDoc) {
                    this.fonts = {};
                    this.pdfKitDoc = pdfKitDoc;
                    this.fontCache = {};
                    for(var font in fontDescriptors)if (fontDescriptors.hasOwnProperty(font)) {
                        var fontDef = fontDescriptors[font];
                        this.fonts[font] = {
                            normal: fontDef.normal,
                            bold: fontDef.bold,
                            italics: fontDef.italics,
                            bolditalics: fontDef.bolditalics
                        };
                    }
                }
                FontProvider.prototype.getFontType = function(bold, italics) {
                    return typeName(bold, italics);
                };
                FontProvider.prototype.getFontFile = function(familyName, bold, italics) {
                    var type = this.getFontType(bold, italics);
                    if (!this.fonts[familyName] || !this.fonts[familyName][type]) return null;
                    return this.fonts[familyName][type];
                };
                FontProvider.prototype.provideFont = function(familyName, bold, italics) {
                    var type = this.getFontType(bold, italics);
                    if (this.getFontFile(familyName, bold, italics) === null) throw new Error('Font \'' + familyName + '\' in style \'' + type + '\' is not defined in the font section of the document definition.');
                    this.fontCache[familyName] = this.fontCache[familyName] || {};
                    if (!this.fontCache[familyName][type]) {
                        var def = this.fonts[familyName][type];
                        if (!isArray(def)) def = [
                            def
                        ];
                        this.fontCache[familyName][type] = this.pdfKitDoc.font.apply(this.pdfKitDoc, def)._font;
                    }
                    return this.fontCache[familyName][type];
                };
                module1.exports = FontProvider;
            /***/ },
            /***/ 28331: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var DESCRIPTORS = __webpack_require__(15567);
                var ownKeys = __webpack_require__(21594);
                var toIndexedObject = __webpack_require__(98086);
                var getOwnPropertyDescriptorModule = __webpack_require__(72062);
                var createProperty = __webpack_require__(38639);
                // `Object.getOwnPropertyDescriptors` method
                // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
                $({
                    target: 'Object',
                    stat: true,
                    sham: !DESCRIPTORS
                }, {
                    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
                        var O = toIndexedObject(object);
                        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                        var keys = ownKeys(O);
                        var result = {};
                        var index = 0;
                        var key, descriptor;
                        while(keys.length > index){
                            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
                            if (descriptor !== undefined) createProperty(result, key, descriptor);
                        }
                        return result;
                    }
                });
            /***/ },
            /***/ 28356: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var createHTML = __webpack_require__(91159);
                var forcedStringHTMLMethod = __webpack_require__(7452);
                // `String.prototype.bold` method
                // https://tc39.es/ecma262/#sec-string.prototype.bold
                $({
                    target: 'String',
                    proto: true,
                    forced: forcedStringHTMLMethod('bold')
                }, {
                    bold: function bold() {
                        return createHTML(this, 'b', '', '');
                    }
                });
            /***/ },
            /***/ 28617: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var anObject = __webpack_require__(34984);
                var isObject = __webpack_require__(24517);
                var newPromiseCapability = __webpack_require__(56614);
                module1.exports = function(C, x) {
                    anObject(C);
                    if (isObject(x) && x.constructor === C) return x;
                    var promiseCapability = newPromiseCapability.f(C);
                    var resolve = promiseCapability.resolve;
                    resolve(x);
                    return promiseCapability.promise;
                };
            /***/ },
            /***/ 28619: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var bind = __webpack_require__(5049);
                var $apply = __webpack_require__(73036);
                var actualApply = __webpack_require__(17802);
                /** @type {import('./applyBind')} */ module1.exports = function applyBind() {
                    return actualApply(bind, $apply, arguments);
                };
            /***/ },
            /***/ 28651: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var undefined1;
                var $Object = __webpack_require__(75846);
                var $Error = __webpack_require__(15293);
                var $EvalError = __webpack_require__(29055);
                var $RangeError = __webpack_require__(18888);
                var $ReferenceError = __webpack_require__(47900);
                var $SyntaxError = __webpack_require__(57770);
                var $TypeError = __webpack_require__(96785);
                var $URIError = __webpack_require__(54055);
                var abs = __webpack_require__(50716);
                var floor = __webpack_require__(77450);
                var max = __webpack_require__(3774);
                var min = __webpack_require__(47552);
                var pow = __webpack_require__(75874);
                var round = __webpack_require__(19292);
                var sign = __webpack_require__(46071);
                var $Function = Function;
                // eslint-disable-next-line consistent-return
                var getEvalledConstructor = function(expressionSyntax) {
                    try {
                        return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
                    } catch (e) {}
                };
                var $gOPD = __webpack_require__(68109);
                var $defineProperty = __webpack_require__(56649);
                var throwTypeError = function() {
                    throw new $TypeError();
                };
                var ThrowTypeError = $gOPD ? function() {
                    try {
                        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
                        arguments.callee; // IE 8 does not throw here
                        return throwTypeError;
                    } catch (calleeThrows) {
                        try {
                            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
                            return $gOPD(arguments, 'callee').get;
                        } catch (gOPDthrows) {
                            return throwTypeError;
                        }
                    }
                }() : throwTypeError;
                var hasSymbols = __webpack_require__(73257)();
                var getProto = __webpack_require__(87106);
                var $ObjectGPO = __webpack_require__(33766);
                var $ReflectGPO = __webpack_require__(86822);
                var $apply = __webpack_require__(73036);
                var $call = __webpack_require__(10078);
                var needsEval = {};
                var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined1 : getProto(Uint8Array);
                var INTRINSICS = {
                    __proto__: null,
                    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined1 : AggregateError,
                    '%Array%': Array,
                    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined1 : ArrayBuffer,
                    '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined1,
                    '%AsyncFromSyncIteratorPrototype%': undefined1,
                    '%AsyncFunction%': needsEval,
                    '%AsyncGenerator%': needsEval,
                    '%AsyncGeneratorFunction%': needsEval,
                    '%AsyncIteratorPrototype%': needsEval,
                    '%Atomics%': typeof Atomics === 'undefined' ? undefined1 : Atomics,
                    '%BigInt%': typeof BigInt === 'undefined' ? undefined1 : BigInt,
                    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined1 : BigInt64Array,
                    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined1 : BigUint64Array,
                    '%Boolean%': Boolean,
                    '%DataView%': typeof DataView === 'undefined' ? undefined1 : DataView,
                    '%Date%': Date,
                    '%decodeURI%': decodeURI,
                    '%decodeURIComponent%': decodeURIComponent,
                    '%encodeURI%': encodeURI,
                    '%encodeURIComponent%': encodeURIComponent,
                    '%Error%': $Error,
                    '%eval%': eval,
                    '%EvalError%': $EvalError,
                    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined1 : Float16Array,
                    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined1 : Float32Array,
                    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined1 : Float64Array,
                    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined1 : FinalizationRegistry,
                    '%Function%': $Function,
                    '%GeneratorFunction%': needsEval,
                    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined1 : Int8Array,
                    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined1 : Int16Array,
                    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined1 : Int32Array,
                    '%isFinite%': isFinite,
                    '%isNaN%': isNaN,
                    '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined1,
                    '%JSON%': typeof JSON === 'object' ? JSON : undefined1,
                    '%Map%': typeof Map === 'undefined' ? undefined1 : Map,
                    '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined1 : getProto(new Map()[Symbol.iterator]()),
                    '%Math%': Math,
                    '%Number%': Number,
                    '%Object%': $Object,
                    '%Object.getOwnPropertyDescriptor%': $gOPD,
                    '%parseFloat%': parseFloat,
                    '%parseInt%': parseInt,
                    '%Promise%': typeof Promise === 'undefined' ? undefined1 : Promise,
                    '%Proxy%': typeof Proxy === 'undefined' ? undefined1 : Proxy,
                    '%RangeError%': $RangeError,
                    '%ReferenceError%': $ReferenceError,
                    '%Reflect%': typeof Reflect === 'undefined' ? undefined1 : Reflect,
                    '%RegExp%': RegExp,
                    '%Set%': typeof Set === 'undefined' ? undefined1 : Set,
                    '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined1 : getProto(new Set()[Symbol.iterator]()),
                    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined1 : SharedArrayBuffer,
                    '%String%': String,
                    '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined1,
                    '%Symbol%': hasSymbols ? Symbol : undefined1,
                    '%SyntaxError%': $SyntaxError,
                    '%ThrowTypeError%': ThrowTypeError,
                    '%TypedArray%': TypedArray,
                    '%TypeError%': $TypeError,
                    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined1 : Uint8Array,
                    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined1 : Uint8ClampedArray,
                    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined1 : Uint16Array,
                    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined1 : Uint32Array,
                    '%URIError%': $URIError,
                    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined1 : WeakMap,
                    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined1 : WeakRef,
                    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined1 : WeakSet,
                    '%Function.prototype.call%': $call,
                    '%Function.prototype.apply%': $apply,
                    '%Object.defineProperty%': $defineProperty,
                    '%Object.getPrototypeOf%': $ObjectGPO,
                    '%Math.abs%': abs,
                    '%Math.floor%': floor,
                    '%Math.max%': max,
                    '%Math.min%': min,
                    '%Math.pow%': pow,
                    '%Math.round%': round,
                    '%Math.sign%': sign,
                    '%Reflect.getPrototypeOf%': $ReflectGPO
                };
                if (getProto) try {
                    null.error; // eslint-disable-line no-unused-expressions
                } catch (e) {
                    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
                    var errorProto = getProto(getProto(e));
                    INTRINSICS['%Error.prototype%'] = errorProto;
                }
                var doEval = function doEval(name) {
                    var value;
                    if (name === '%AsyncFunction%') value = getEvalledConstructor('async function () {}');
                    else if (name === '%GeneratorFunction%') value = getEvalledConstructor('function* () {}');
                    else if (name === '%AsyncGeneratorFunction%') value = getEvalledConstructor('async function* () {}');
                    else if (name === '%AsyncGenerator%') {
                        var fn = doEval('%AsyncGeneratorFunction%');
                        if (fn) value = fn.prototype;
                    } else if (name === '%AsyncIteratorPrototype%') {
                        var gen = doEval('%AsyncGenerator%');
                        if (gen && getProto) value = getProto(gen.prototype);
                    }
                    INTRINSICS[name] = value;
                    return value;
                };
                var LEGACY_ALIASES = {
                    __proto__: null,
                    '%ArrayBufferPrototype%': [
                        'ArrayBuffer',
                        'prototype'
                    ],
                    '%ArrayPrototype%': [
                        'Array',
                        'prototype'
                    ],
                    '%ArrayProto_entries%': [
                        'Array',
                        'prototype',
                        'entries'
                    ],
                    '%ArrayProto_forEach%': [
                        'Array',
                        'prototype',
                        'forEach'
                    ],
                    '%ArrayProto_keys%': [
                        'Array',
                        'prototype',
                        'keys'
                    ],
                    '%ArrayProto_values%': [
                        'Array',
                        'prototype',
                        'values'
                    ],
                    '%AsyncFunctionPrototype%': [
                        'AsyncFunction',
                        'prototype'
                    ],
                    '%AsyncGenerator%': [
                        'AsyncGeneratorFunction',
                        'prototype'
                    ],
                    '%AsyncGeneratorPrototype%': [
                        'AsyncGeneratorFunction',
                        'prototype',
                        'prototype'
                    ],
                    '%BooleanPrototype%': [
                        'Boolean',
                        'prototype'
                    ],
                    '%DataViewPrototype%': [
                        'DataView',
                        'prototype'
                    ],
                    '%DatePrototype%': [
                        'Date',
                        'prototype'
                    ],
                    '%ErrorPrototype%': [
                        'Error',
                        'prototype'
                    ],
                    '%EvalErrorPrototype%': [
                        'EvalError',
                        'prototype'
                    ],
                    '%Float32ArrayPrototype%': [
                        'Float32Array',
                        'prototype'
                    ],
                    '%Float64ArrayPrototype%': [
                        'Float64Array',
                        'prototype'
                    ],
                    '%FunctionPrototype%': [
                        'Function',
                        'prototype'
                    ],
                    '%Generator%': [
                        'GeneratorFunction',
                        'prototype'
                    ],
                    '%GeneratorPrototype%': [
                        'GeneratorFunction',
                        'prototype',
                        'prototype'
                    ],
                    '%Int8ArrayPrototype%': [
                        'Int8Array',
                        'prototype'
                    ],
                    '%Int16ArrayPrototype%': [
                        'Int16Array',
                        'prototype'
                    ],
                    '%Int32ArrayPrototype%': [
                        'Int32Array',
                        'prototype'
                    ],
                    '%JSONParse%': [
                        'JSON',
                        'parse'
                    ],
                    '%JSONStringify%': [
                        'JSON',
                        'stringify'
                    ],
                    '%MapPrototype%': [
                        'Map',
                        'prototype'
                    ],
                    '%NumberPrototype%': [
                        'Number',
                        'prototype'
                    ],
                    '%ObjectPrototype%': [
                        'Object',
                        'prototype'
                    ],
                    '%ObjProto_toString%': [
                        'Object',
                        'prototype',
                        'toString'
                    ],
                    '%ObjProto_valueOf%': [
                        'Object',
                        'prototype',
                        'valueOf'
                    ],
                    '%PromisePrototype%': [
                        'Promise',
                        'prototype'
                    ],
                    '%PromiseProto_then%': [
                        'Promise',
                        'prototype',
                        'then'
                    ],
                    '%Promise_all%': [
                        'Promise',
                        'all'
                    ],
                    '%Promise_reject%': [
                        'Promise',
                        'reject'
                    ],
                    '%Promise_resolve%': [
                        'Promise',
                        'resolve'
                    ],
                    '%RangeErrorPrototype%': [
                        'RangeError',
                        'prototype'
                    ],
                    '%ReferenceErrorPrototype%': [
                        'ReferenceError',
                        'prototype'
                    ],
                    '%RegExpPrototype%': [
                        'RegExp',
                        'prototype'
                    ],
                    '%SetPrototype%': [
                        'Set',
                        'prototype'
                    ],
                    '%SharedArrayBufferPrototype%': [
                        'SharedArrayBuffer',
                        'prototype'
                    ],
                    '%StringPrototype%': [
                        'String',
                        'prototype'
                    ],
                    '%SymbolPrototype%': [
                        'Symbol',
                        'prototype'
                    ],
                    '%SyntaxErrorPrototype%': [
                        'SyntaxError',
                        'prototype'
                    ],
                    '%TypedArrayPrototype%': [
                        'TypedArray',
                        'prototype'
                    ],
                    '%TypeErrorPrototype%': [
                        'TypeError',
                        'prototype'
                    ],
                    '%Uint8ArrayPrototype%': [
                        'Uint8Array',
                        'prototype'
                    ],
                    '%Uint8ClampedArrayPrototype%': [
                        'Uint8ClampedArray',
                        'prototype'
                    ],
                    '%Uint16ArrayPrototype%': [
                        'Uint16Array',
                        'prototype'
                    ],
                    '%Uint32ArrayPrototype%': [
                        'Uint32Array',
                        'prototype'
                    ],
                    '%URIErrorPrototype%': [
                        'URIError',
                        'prototype'
                    ],
                    '%WeakMapPrototype%': [
                        'WeakMap',
                        'prototype'
                    ],
                    '%WeakSetPrototype%': [
                        'WeakSet',
                        'prototype'
                    ]
                };
                var bind = __webpack_require__(5049);
                var hasOwn = __webpack_require__(55215);
                var $concat = bind.call($call, Array.prototype.concat);
                var $spliceApply = bind.call($apply, Array.prototype.splice);
                var $replace = bind.call($call, String.prototype.replace);
                var $strSlice = bind.call($call, String.prototype.slice);
                var $exec = bind.call($call, RegExp.prototype.exec);
                /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
                var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
                var stringToPath = function stringToPath(string) {
                    var first = $strSlice(string, 0, 1);
                    var last = $strSlice(string, -1);
                    if (first === '%' && last !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
                    else if (last === '%' && first !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
                    var result = [];
                    $replace(string, rePropName, function(match, number, quote, subString) {
                        result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
                    });
                    return result;
                };
                /* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
                    var intrinsicName = name;
                    var alias;
                    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
                        alias = LEGACY_ALIASES[intrinsicName];
                        intrinsicName = '%' + alias[0] + '%';
                    }
                    if (hasOwn(INTRINSICS, intrinsicName)) {
                        var value = INTRINSICS[intrinsicName];
                        if (value === needsEval) value = doEval(intrinsicName);
                        if (typeof value === 'undefined' && !allowMissing) throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
                        return {
                            alias: alias,
                            name: intrinsicName,
                            value: value
                        };
                    }
                    throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
                };
                module1.exports = function GetIntrinsic(name, allowMissing) {
                    if (typeof name !== 'string' || name.length === 0) throw new $TypeError('intrinsic name must be a non-empty string');
                    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $TypeError('"allowMissing" argument must be a boolean');
                    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
                    var parts = stringToPath(name);
                    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
                    var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
                    var intrinsicRealName = intrinsic.name;
                    var value = intrinsic.value;
                    var skipFurtherCaching = false;
                    var alias = intrinsic.alias;
                    if (alias) {
                        intrinsicBaseName = alias[0];
                        $spliceApply(parts, $concat([
                            0,
                            1
                        ], alias));
                    }
                    for(var i = 1, isOwn = true; i < parts.length; i += 1){
                        var part = parts[i];
                        var first = $strSlice(part, 0, 1);
                        var last = $strSlice(part, -1);
                        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $SyntaxError('property names with quotes must have matching quotes');
                        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
                        intrinsicBaseName += '.' + part;
                        intrinsicRealName = '%' + intrinsicBaseName + '%';
                        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
                        else if (value != null) {
                            if (!(part in value)) {
                                if (!allowMissing) throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                                return void 0;
                            }
                            if ($gOPD && i + 1 >= parts.length) {
                                var desc = $gOPD(value, part);
                                isOwn = !!desc;
                                // By convention, when a data property is converted to an accessor
                                // property to emulate a data property that does not suffer from
                                // the override mistake, that accessor's getter is marked with
                                // an `originalValue` property. Here, when we detect this, we
                                // uphold the illusion by pretending to see that original data
                                // property, i.e., returning the value rather than the getter
                                // itself.
                                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                                else value = value[part];
                            } else {
                                isOwn = hasOwn(value, part);
                                value = value[part];
                            }
                            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
                        }
                    }
                    return value;
                };
            /***/ },
            /***/ 28831: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var isObject = __webpack_require__(24517);
                var classof = __webpack_require__(93975);
                var wellKnownSymbol = __webpack_require__(38688);
                var MATCH = wellKnownSymbol('match');
                // `IsRegExp` abstract operation
                // https://tc39.es/ecma262/#sec-isregexp
                module1.exports = function(it) {
                    var isRegExp;
                    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
                };
            /***/ },
            /***/ 28834: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* eslint-disable no-new -- required for testing */ var global = __webpack_require__(32010);
                var fails = __webpack_require__(47044);
                var checkCorrectnessOfIteration = __webpack_require__(46769);
                var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(59754).NATIVE_ARRAY_BUFFER_VIEWS;
                var ArrayBuffer1 = global.ArrayBuffer;
                var Int8Array1 = global.Int8Array;
                module1.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function() {
                    Int8Array1(1);
                }) || !fails(function() {
                    new Int8Array1(-1);
                }) || !checkCorrectnessOfIteration(function(iterable) {
                    new Int8Array1();
                    new Int8Array1(null);
                    new Int8Array1(1.5);
                    new Int8Array1(iterable);
                }, true) || fails(function() {
                    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
                    return new Int8Array1(new ArrayBuffer1(2), 1, undefined).length !== 1;
                });
            /***/ },
            /***/ 29055: /***/ function(module1) {
                "use strict";
                /** @type {import('./eval')} */ module1.exports = EvalError;
            /***/ },
            /***/ 29490: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // Currently in sync with Node.js lib/internal/util/types.js
                // https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
                var isArgumentsObject = __webpack_require__(67906);
                var isGeneratorFunction = __webpack_require__(44610);
                var whichTypedArray = __webpack_require__(43381);
                var isTypedArray = __webpack_require__(46094);
                function uncurryThis(f) {
                    return f.call.bind(f);
                }
                var BigIntSupported = typeof BigInt !== 'undefined';
                var SymbolSupported = typeof Symbol !== 'undefined';
                var ObjectToString = uncurryThis(Object.prototype.toString);
                var numberValue = uncurryThis(Number.prototype.valueOf);
                var stringValue = uncurryThis(String.prototype.valueOf);
                var booleanValue = uncurryThis(Boolean.prototype.valueOf);
                if (BigIntSupported) var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
                if (SymbolSupported) var symbolValue = uncurryThis(Symbol.prototype.valueOf);
                function checkBoxedPrimitive(value, prototypeValueOf) {
                    if (typeof value !== 'object') return false;
                    try {
                        prototypeValueOf(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                exports.isArgumentsObject = isArgumentsObject;
                exports.isGeneratorFunction = isGeneratorFunction;
                exports.isTypedArray = isTypedArray;
                // Taken from here and modified for better browser support
                // https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
                function isPromise(input) {
                    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
                }
                exports.isPromise = isPromise;
                function isArrayBufferView(value) {
                    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
                    return isTypedArray(value) || isDataView(value);
                }
                exports.isArrayBufferView = isArrayBufferView;
                function isUint8Array(value) {
                    return whichTypedArray(value) === 'Uint8Array';
                }
                exports.isUint8Array = isUint8Array;
                function isUint8ClampedArray(value) {
                    return whichTypedArray(value) === 'Uint8ClampedArray';
                }
                exports.isUint8ClampedArray = isUint8ClampedArray;
                function isUint16Array(value) {
                    return whichTypedArray(value) === 'Uint16Array';
                }
                exports.isUint16Array = isUint16Array;
                function isUint32Array(value) {
                    return whichTypedArray(value) === 'Uint32Array';
                }
                exports.isUint32Array = isUint32Array;
                function isInt8Array(value) {
                    return whichTypedArray(value) === 'Int8Array';
                }
                exports.isInt8Array = isInt8Array;
                function isInt16Array(value) {
                    return whichTypedArray(value) === 'Int16Array';
                }
                exports.isInt16Array = isInt16Array;
                function isInt32Array(value) {
                    return whichTypedArray(value) === 'Int32Array';
                }
                exports.isInt32Array = isInt32Array;
                function isFloat32Array(value) {
                    return whichTypedArray(value) === 'Float32Array';
                }
                exports.isFloat32Array = isFloat32Array;
                function isFloat64Array(value) {
                    return whichTypedArray(value) === 'Float64Array';
                }
                exports.isFloat64Array = isFloat64Array;
                function isBigInt64Array(value) {
                    return whichTypedArray(value) === 'BigInt64Array';
                }
                exports.isBigInt64Array = isBigInt64Array;
                function isBigUint64Array(value) {
                    return whichTypedArray(value) === 'BigUint64Array';
                }
                exports.isBigUint64Array = isBigUint64Array;
                function isMapToString(value) {
                    return ObjectToString(value) === '[object Map]';
                }
                isMapToString.working = typeof Map !== 'undefined' && isMapToString(new Map());
                function isMap(value) {
                    if (typeof Map === 'undefined') return false;
                    return isMapToString.working ? isMapToString(value) : value instanceof Map;
                }
                exports.isMap = isMap;
                function isSetToString(value) {
                    return ObjectToString(value) === '[object Set]';
                }
                isSetToString.working = typeof Set !== 'undefined' && isSetToString(new Set());
                function isSet(value) {
                    if (typeof Set === 'undefined') return false;
                    return isSetToString.working ? isSetToString(value) : value instanceof Set;
                }
                exports.isSet = isSet;
                function isWeakMapToString(value) {
                    return ObjectToString(value) === '[object WeakMap]';
                }
                isWeakMapToString.working = typeof WeakMap !== 'undefined' && isWeakMapToString(new WeakMap());
                function isWeakMap(value) {
                    if (typeof WeakMap === 'undefined') return false;
                    return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
                }
                exports.isWeakMap = isWeakMap;
                function isWeakSetToString(value) {
                    return ObjectToString(value) === '[object WeakSet]';
                }
                isWeakSetToString.working = typeof WeakSet !== 'undefined' && isWeakSetToString(new WeakSet());
                function isWeakSet(value) {
                    return isWeakSetToString(value);
                }
                exports.isWeakSet = isWeakSet;
                function isArrayBufferToString(value) {
                    return ObjectToString(value) === '[object ArrayBuffer]';
                }
                isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && isArrayBufferToString(new ArrayBuffer());
                function isArrayBuffer(value) {
                    if (typeof ArrayBuffer === 'undefined') return false;
                    return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
                }
                exports.isArrayBuffer = isArrayBuffer;
                function isDataViewToString(value) {
                    return ObjectToString(value) === '[object DataView]';
                }
                isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
                function isDataView(value) {
                    if (typeof DataView === 'undefined') return false;
                    return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
                }
                exports.isDataView = isDataView;
                // Store a copy of SharedArrayBuffer in case it's deleted elsewhere
                var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
                function isSharedArrayBufferToString(value) {
                    return ObjectToString(value) === '[object SharedArrayBuffer]';
                }
                function isSharedArrayBuffer(value) {
                    if (typeof SharedArrayBufferCopy === 'undefined') return false;
                    if (typeof isSharedArrayBufferToString.working === 'undefined') isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
                    return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
                }
                exports.isSharedArrayBuffer = isSharedArrayBuffer;
                function isAsyncFunction(value) {
                    return ObjectToString(value) === '[object AsyncFunction]';
                }
                exports.isAsyncFunction = isAsyncFunction;
                function isMapIterator(value) {
                    return ObjectToString(value) === '[object Map Iterator]';
                }
                exports.isMapIterator = isMapIterator;
                function isSetIterator(value) {
                    return ObjectToString(value) === '[object Set Iterator]';
                }
                exports.isSetIterator = isSetIterator;
                function isGeneratorObject(value) {
                    return ObjectToString(value) === '[object Generator]';
                }
                exports.isGeneratorObject = isGeneratorObject;
                function isWebAssemblyCompiledModule(value) {
                    return ObjectToString(value) === '[object WebAssembly.Module]';
                }
                exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
                function isNumberObject(value) {
                    return checkBoxedPrimitive(value, numberValue);
                }
                exports.isNumberObject = isNumberObject;
                function isStringObject(value) {
                    return checkBoxedPrimitive(value, stringValue);
                }
                exports.isStringObject = isStringObject;
                function isBooleanObject(value) {
                    return checkBoxedPrimitive(value, booleanValue);
                }
                exports.isBooleanObject = isBooleanObject;
                function isBigIntObject(value) {
                    return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
                }
                exports.isBigIntObject = isBigIntObject;
                function isSymbolObject(value) {
                    return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
                }
                exports.isSymbolObject = isSymbolObject;
                function isBoxedPrimitive(value) {
                    return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
                }
                exports.isBoxedPrimitive = isBoxedPrimitive;
                function isAnyArrayBuffer(value) {
                    return typeof Uint8Array !== 'undefined' && (isArrayBuffer(value) || isSharedArrayBuffer(value));
                }
                exports.isAnyArrayBuffer = isAnyArrayBuffer;
                [
                    'isProxy',
                    'isExternal',
                    'isModuleNamespaceObject'
                ].forEach(function(method) {
                    Object.defineProperty(exports, method, {
                        enumerable: false,
                        value: function() {
                            throw new Error(method + ' is not supported in userland');
                        }
                    });
                });
            /***/ },
            /***/ 29519: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var toObject = __webpack_require__(43162);
                var floor = Math.floor;
                var charAt = uncurryThis(''.charAt);
                var replace = uncurryThis(''.replace);
                var stringSlice = uncurryThis(''.slice);
                var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
                var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
                // `GetSubstitution` abstract operation
                // https://tc39.es/ecma262/#sec-getsubstitution
                module1.exports = function(matched, str, position, captures, namedCaptures, replacement) {
                    var tailPos = position + matched.length;
                    var m = captures.length;
                    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
                    if (namedCaptures !== undefined) {
                        namedCaptures = toObject(namedCaptures);
                        symbols = SUBSTITUTION_SYMBOLS;
                    }
                    return replace(replacement, symbols, function(match, ch) {
                        var capture;
                        switch(charAt(ch, 0)){
                            case '$':
                                return '$';
                            case '&':
                                return matched;
                            case '`':
                                return stringSlice(str, 0, position);
                            case "'":
                                return stringSlice(str, tailPos);
                            case '<':
                                capture = namedCaptures[stringSlice(ch, 1, -1)];
                                break;
                            default:
                                var n = +ch;
                                if (n === 0) return match;
                                if (n > m) {
                                    var f = floor(n / 10);
                                    if (f === 0) return match;
                                    if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
                                    return match;
                                }
                                capture = captures[n - 1];
                        }
                        return capture === undefined ? '' : capture;
                    });
                };
            /***/ },
            /***/ 29781: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(9964);
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // A bit simpler than readable streams.
                // Implement an async ._write(chunk, encoding, cb), and it'll handle all
                // the drain event emission and buffering.
                module1.exports = Writable;
                /* <replacement> */ function WriteReq(chunk, encoding, cb) {
                    this.chunk = chunk;
                    this.encoding = encoding;
                    this.callback = cb;
                    this.next = null;
                }
                // It seems a linked list but it is not
                // there will be only 2 of these for each stream
                function CorkedRequest(state) {
                    var _this = this;
                    this.next = null;
                    this.entry = null;
                    this.finish = function() {
                        onCorkedFinish(_this, state);
                    };
                }
                /* </replacement> */ /*<replacement>*/ var Duplex;
                /*</replacement>*/ Writable.WritableState = WritableState;
                /*<replacement>*/ var internalUtil = {
                    deprecate: __webpack_require__(16465)
                };
                /*</replacement>*/ /*<replacement>*/ var Stream = __webpack_require__(99018);
                /*</replacement>*/ var Buffer = __webpack_require__(14598).Buffer;
                var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
                function _uint8ArrayToBuffer(chunk) {
                    return Buffer.from(chunk);
                }
                function _isUint8Array(obj) {
                    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                }
                var destroyImpl = __webpack_require__(37385);
                var _require = __webpack_require__(68130), getHighWaterMark = _require.getHighWaterMark;
                var _require$codes = __webpack_require__(83797)/* .codes */ .F, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
                var errorOrDestroy = destroyImpl.errorOrDestroy;
                __webpack_require__(89784)(Writable, Stream);
                function nop() {}
                function WritableState(options, stream, isDuplex) {
                    Duplex = Duplex || __webpack_require__(14903);
                    options = options || {};
                    // Duplex streams are both readable and writable, but share
                    // the same options object.
                    // However, some cases require setting options to different
                    // values for the readable and the writable sides of the duplex stream,
                    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
                    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;
                    // object stream flag to indicate whether or not this stream
                    // contains buffers or objects.
                    this.objectMode = !!options.objectMode;
                    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
                    // the point at which write() starts returning false
                    // Note: 0 is a valid value, means that we always return false if
                    // the entire buffer is not flushed immediately on write()
                    this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
                    // if _final has been called
                    this.finalCalled = false;
                    // drain event flag.
                    this.needDrain = false;
                    // at the start of calling end()
                    this.ending = false;
                    // when end() has been called, and returned
                    this.ended = false;
                    // when 'finish' is emitted
                    this.finished = false;
                    // has it been destroyed
                    this.destroyed = false;
                    // should we decode strings into buffers before passing to _write?
                    // this is here so that some node-core streams can optimize string
                    // handling at a lower level.
                    var noDecode = options.decodeStrings === false;
                    this.decodeStrings = !noDecode;
                    // Crypto is kind of old and crusty.  Historically, its default string
                    // encoding is 'binary' so we have to make this configurable.
                    // Everything else in the universe uses 'utf8', though.
                    this.defaultEncoding = options.defaultEncoding || 'utf8';
                    // not an actual buffer we keep track of, but a measurement
                    // of how much we're waiting to get pushed to some underlying
                    // socket or file.
                    this.length = 0;
                    // a flag to see when we're in the middle of a write.
                    this.writing = false;
                    // when true all writes will be buffered until .uncork() call
                    this.corked = 0;
                    // a flag to be able to tell if the onwrite cb is called immediately,
                    // or on a later tick.  We set this to true at first, because any
                    // actions that shouldn't happen until "later" should generally also
                    // not happen before the first write call.
                    this.sync = true;
                    // a flag to know if we're processing previously buffered items, which
                    // may call the _write() callback in the same tick, so that we don't
                    // end up in an overlapped onwrite situation.
                    this.bufferProcessing = false;
                    // the callback that's passed to _write(chunk,cb)
                    this.onwrite = function(er) {
                        onwrite(stream, er);
                    };
                    // the callback that the user supplies to write(chunk,encoding,cb)
                    this.writecb = null;
                    // the amount that is being written when _write is called.
                    this.writelen = 0;
                    this.bufferedRequest = null;
                    this.lastBufferedRequest = null;
                    // number of pending user-supplied write callbacks
                    // this must be 0 before 'finish' can be emitted
                    this.pendingcb = 0;
                    // emit prefinish if the only thing we're waiting for is _write cbs
                    // This is relevant for synchronous Transform streams
                    this.prefinished = false;
                    // True if the error was already emitted and should not be thrown again
                    this.errorEmitted = false;
                    // Should close be emitted on destroy. Defaults to true.
                    this.emitClose = options.emitClose !== false;
                    // Should .destroy() be called after 'finish' (and potentially 'end')
                    this.autoDestroy = !!options.autoDestroy;
                    // count buffered requests
                    this.bufferedRequestCount = 0;
                    // allocate the first CorkedRequest, there is always
                    // one allocated and free to use, and we maintain at most two
                    this.corkedRequestsFree = new CorkedRequest(this);
                }
                WritableState.prototype.getBuffer = function getBuffer() {
                    var current = this.bufferedRequest;
                    var out = [];
                    while(current){
                        out.push(current);
                        current = current.next;
                    }
                    return out;
                };
                (function() {
                    try {
                        Object.defineProperty(WritableState.prototype, 'buffer', {
                            get: internalUtil.deprecate(function writableStateBufferGetter() {
                                return this.getBuffer();
                            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
                        });
                    } catch (_) {}
                })();
                // Test _writableState for inheritance to account for Duplex streams,
                // whose prototype chain only points to Readable.
                var realHasInstance;
                if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
                    realHasInstance = Function.prototype[Symbol.hasInstance];
                    Object.defineProperty(Writable, Symbol.hasInstance, {
                        value: function value(object) {
                            if (realHasInstance.call(this, object)) return true;
                            if (this !== Writable) return false;
                            return object && object._writableState instanceof WritableState;
                        }
                    });
                } else realHasInstance = function realHasInstance(object) {
                    return object instanceof this;
                };
                function Writable(options) {
                    Duplex = Duplex || __webpack_require__(14903);
                    // Writable ctor is applied to Duplexes, too.
                    // `realHasInstance` is necessary because using plain `instanceof`
                    // would return false, as no `_writableState` property is attached.
                    // Trying to use the custom `instanceof` for Writable here will also break the
                    // Node.js LazyTransform implementation, which has a non-trivial getter for
                    // `_writableState` that would lead to infinite recursion.
                    // Checking for a Stream.Duplex instance is faster here instead of inside
                    // the WritableState constructor, at least with V8 6.5
                    var isDuplex = this instanceof Duplex;
                    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
                    this._writableState = new WritableState(options, this, isDuplex);
                    // legacy.
                    this.writable = true;
                    if (options) {
                        if (typeof options.write === 'function') this._write = options.write;
                        if (typeof options.writev === 'function') this._writev = options.writev;
                        if (typeof options.destroy === 'function') this._destroy = options.destroy;
                        if (typeof options.final === 'function') this._final = options.final;
                    }
                    Stream.call(this);
                }
                // Otherwise people can pipe Writable streams, which is just wrong.
                Writable.prototype.pipe = function() {
                    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
                };
                function writeAfterEnd(stream, cb) {
                    var er = new ERR_STREAM_WRITE_AFTER_END();
                    // TODO: defer error events consistently everywhere, not just the cb
                    errorOrDestroy(stream, er);
                    process.nextTick(cb, er);
                }
                // Checks that a user-supplied chunk is valid, especially for the particular
                // mode the stream is in. Currently this means that `null` is never accepted
                // and undefined/non-string values are only allowed in object mode.
                function validChunk(stream, state, chunk, cb) {
                    var er;
                    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
                    else if (typeof chunk !== 'string' && !state.objectMode) er = new ERR_INVALID_ARG_TYPE('chunk', [
                        'string',
                        'Buffer'
                    ], chunk);
                    if (er) {
                        errorOrDestroy(stream, er);
                        process.nextTick(cb, er);
                        return false;
                    }
                    return true;
                }
                Writable.prototype.write = function(chunk, encoding, cb) {
                    var state = this._writableState;
                    var ret = false;
                    var isBuf = !state.objectMode && _isUint8Array(chunk);
                    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
                    if (typeof encoding === 'function') {
                        cb = encoding;
                        encoding = null;
                    }
                    if (isBuf) encoding = 'buffer';
                    else if (!encoding) encoding = state.defaultEncoding;
                    if (typeof cb !== 'function') cb = nop;
                    if (state.ending) writeAfterEnd(this, cb);
                    else if (isBuf || validChunk(this, state, chunk, cb)) {
                        state.pendingcb++;
                        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
                    }
                    return ret;
                };
                Writable.prototype.cork = function() {
                    this._writableState.corked++;
                };
                Writable.prototype.uncork = function() {
                    var state = this._writableState;
                    if (state.corked) {
                        state.corked--;
                        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
                    }
                };
                Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
                    // node::ParseEncoding() requires lower case.
                    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
                    if (!([
                        'hex',
                        'utf8',
                        'utf-8',
                        'ascii',
                        'binary',
                        'base64',
                        'ucs2',
                        'ucs-2',
                        'utf16le',
                        'utf-16le',
                        'raw'
                    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
                    this._writableState.defaultEncoding = encoding;
                    return this;
                };
                Object.defineProperty(Writable.prototype, 'writableBuffer', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState && this._writableState.getBuffer();
                    }
                });
                function decodeChunk(state, chunk, encoding) {
                    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = Buffer.from(chunk, encoding);
                    return chunk;
                }
                Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState.highWaterMark;
                    }
                });
                // if we're already writing something, then just put this
                // in the queue, and wait our turn.  Otherwise, call _write
                // If we return false, then we need a drain event, so set that flag.
                function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
                    if (!isBuf) {
                        var newChunk = decodeChunk(state, chunk, encoding);
                        if (chunk !== newChunk) {
                            isBuf = true;
                            encoding = 'buffer';
                            chunk = newChunk;
                        }
                    }
                    var len = state.objectMode ? 1 : chunk.length;
                    state.length += len;
                    var ret = state.length < state.highWaterMark;
                    // we must ensure that previous needDrain will not be reset to false.
                    if (!ret) state.needDrain = true;
                    if (state.writing || state.corked) {
                        var last = state.lastBufferedRequest;
                        state.lastBufferedRequest = {
                            chunk: chunk,
                            encoding: encoding,
                            isBuf: isBuf,
                            callback: cb,
                            next: null
                        };
                        if (last) last.next = state.lastBufferedRequest;
                        else state.bufferedRequest = state.lastBufferedRequest;
                        state.bufferedRequestCount += 1;
                    } else doWrite(stream, state, false, len, chunk, encoding, cb);
                    return ret;
                }
                function doWrite(stream, state, writev, len, chunk, encoding, cb) {
                    state.writelen = len;
                    state.writecb = cb;
                    state.writing = true;
                    state.sync = true;
                    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));
                    else if (writev) stream._writev(chunk, state.onwrite);
                    else stream._write(chunk, encoding, state.onwrite);
                    state.sync = false;
                }
                function onwriteError(stream, state, sync, er, cb) {
                    --state.pendingcb;
                    if (sync) {
                        // defer the callback if we are being called synchronously
                        // to avoid piling up things on the stack
                        process.nextTick(cb, er);
                        // this can emit finish, and it will always happen
                        // after error
                        process.nextTick(finishMaybe, stream, state);
                        stream._writableState.errorEmitted = true;
                        errorOrDestroy(stream, er);
                    } else {
                        // the caller expect this to happen before if
                        // it is async
                        cb(er);
                        stream._writableState.errorEmitted = true;
                        errorOrDestroy(stream, er);
                        // this can emit finish, but finish must
                        // always follow error
                        finishMaybe(stream, state);
                    }
                }
                function onwriteStateUpdate(state) {
                    state.writing = false;
                    state.writecb = null;
                    state.length -= state.writelen;
                    state.writelen = 0;
                }
                function onwrite(stream, er) {
                    var state = stream._writableState;
                    var sync = state.sync;
                    var cb = state.writecb;
                    if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
                    onwriteStateUpdate(state);
                    if (er) onwriteError(stream, state, sync, er, cb);
                    else {
                        // Check if we're actually ready to finish, but don't emit yet
                        var finished = needFinish(state) || stream.destroyed;
                        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
                        if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
                        else afterWrite(stream, state, finished, cb);
                    }
                }
                function afterWrite(stream, state, finished, cb) {
                    if (!finished) onwriteDrain(stream, state);
                    state.pendingcb--;
                    cb();
                    finishMaybe(stream, state);
                }
                // Must force callback to be called on nextTick, so that we don't
                // emit 'drain' before the write() consumer gets the 'false' return
                // value, and has a chance to attach a 'drain' listener.
                function onwriteDrain(stream, state) {
                    if (state.length === 0 && state.needDrain) {
                        state.needDrain = false;
                        stream.emit('drain');
                    }
                }
                // if there's something in the buffer waiting, then process it
                function clearBuffer(stream, state) {
                    state.bufferProcessing = true;
                    var entry = state.bufferedRequest;
                    if (stream._writev && entry && entry.next) {
                        // Fast case, write everything using _writev()
                        var l = state.bufferedRequestCount;
                        var buffer = new Array(l);
                        var holder = state.corkedRequestsFree;
                        holder.entry = entry;
                        var count = 0;
                        var allBuffers = true;
                        while(entry){
                            buffer[count] = entry;
                            if (!entry.isBuf) allBuffers = false;
                            entry = entry.next;
                            count += 1;
                        }
                        buffer.allBuffers = allBuffers;
                        doWrite(stream, state, true, state.length, buffer, '', holder.finish);
                        // doWrite is almost always async, defer these to save a bit of time
                        // as the hot path ends with doWrite
                        state.pendingcb++;
                        state.lastBufferedRequest = null;
                        if (holder.next) {
                            state.corkedRequestsFree = holder.next;
                            holder.next = null;
                        } else state.corkedRequestsFree = new CorkedRequest(state);
                        state.bufferedRequestCount = 0;
                    } else {
                        // Slow case, write chunks one-by-one
                        while(entry){
                            var chunk = entry.chunk;
                            var encoding = entry.encoding;
                            var cb = entry.callback;
                            var len = state.objectMode ? 1 : chunk.length;
                            doWrite(stream, state, false, len, chunk, encoding, cb);
                            entry = entry.next;
                            state.bufferedRequestCount--;
                            // if we didn't call the onwrite immediately, then
                            // it means that we need to wait until it does.
                            // also, that means that the chunk and cb are currently
                            // being processed, so move the buffer counter past them.
                            if (state.writing) break;
                        }
                        if (entry === null) state.lastBufferedRequest = null;
                    }
                    state.bufferedRequest = entry;
                    state.bufferProcessing = false;
                }
                Writable.prototype._write = function(chunk, encoding, cb) {
                    cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
                };
                Writable.prototype._writev = null;
                Writable.prototype.end = function(chunk, encoding, cb) {
                    var state = this._writableState;
                    if (typeof chunk === 'function') {
                        cb = chunk;
                        chunk = null;
                        encoding = null;
                    } else if (typeof encoding === 'function') {
                        cb = encoding;
                        encoding = null;
                    }
                    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
                    // .end() fully uncorks
                    if (state.corked) {
                        state.corked = 1;
                        this.uncork();
                    }
                    // ignore unnecessary end() calls.
                    if (!state.ending) endWritable(this, state, cb);
                    return this;
                };
                Object.defineProperty(Writable.prototype, 'writableLength', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._writableState.length;
                    }
                });
                function needFinish(state) {
                    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
                }
                function callFinal(stream, state) {
                    stream._final(function(err) {
                        state.pendingcb--;
                        if (err) errorOrDestroy(stream, err);
                        state.prefinished = true;
                        stream.emit('prefinish');
                        finishMaybe(stream, state);
                    });
                }
                function prefinish(stream, state) {
                    if (!state.prefinished && !state.finalCalled) {
                        if (typeof stream._final === 'function' && !state.destroyed) {
                            state.pendingcb++;
                            state.finalCalled = true;
                            process.nextTick(callFinal, stream, state);
                        } else {
                            state.prefinished = true;
                            stream.emit('prefinish');
                        }
                    }
                }
                function finishMaybe(stream, state) {
                    var need = needFinish(state);
                    if (need) {
                        prefinish(stream, state);
                        if (state.pendingcb === 0) {
                            state.finished = true;
                            stream.emit('finish');
                            if (state.autoDestroy) {
                                // In case of duplex streams we need a way to detect
                                // if the readable side is ready for autoDestroy as well
                                var rState = stream._readableState;
                                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
                            }
                        }
                    }
                    return need;
                }
                function endWritable(stream, state, cb) {
                    state.ending = true;
                    finishMaybe(stream, state);
                    if (cb) {
                        if (state.finished) process.nextTick(cb);
                        else stream.once('finish', cb);
                    }
                    state.ended = true;
                    stream.writable = false;
                }
                function onCorkedFinish(corkReq, state, err) {
                    var entry = corkReq.entry;
                    corkReq.entry = null;
                    while(entry){
                        var cb = entry.callback;
                        state.pendingcb--;
                        cb(err);
                        entry = entry.next;
                    }
                    // reuse the free corkReq.
                    state.corkedRequestsFree.next = corkReq;
                }
                Object.defineProperty(Writable.prototype, 'destroyed', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        if (this._writableState === undefined) return false;
                        return this._writableState.destroyed;
                    },
                    set: function set(value) {
                        // we ignore the value if the stream
                        // has not been initialized yet
                        if (!this._writableState) return;
                        // backward compatibility, the user is explicitly
                        // managing destroyed
                        this._writableState.destroyed = value;
                    }
                });
                Writable.prototype.destroy = destroyImpl.destroy;
                Writable.prototype._undestroy = destroyImpl.undestroy;
                Writable.prototype._destroy = function(err, cb) {
                    cb(err);
                };
            /***/ },
            /***/ 29819: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    /**
   * Electronic Codebook block mode.
   */ CryptoJS.mode.ECB = function() {
                        var ECB = CryptoJS.lib.BlockCipherMode.extend();
                        ECB.Encryptor = ECB.extend({
                            processBlock: function processBlock(words, offset) {
                                this._cipher.encryptBlock(words, offset);
                            }
                        });
                        ECB.Decryptor = ECB.extend({
                            processBlock: function processBlock(words, offset) {
                                this._cipher.decryptBlock(words, offset);
                            }
                        });
                        return ECB;
                    }();
                    return CryptoJS.mode.ECB;
                });
            /***/ },
            /***/ 29841: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var requireObjectCoercible = __webpack_require__(83943);
                var toString = __webpack_require__(25096);
                var whitespaces = __webpack_require__(43187);
                var replace = uncurryThis(''.replace);
                var whitespace = '[' + whitespaces + ']';
                var ltrim = RegExp('^' + whitespace + whitespace + '*');
                var rtrim = RegExp(whitespace + whitespace + '*$');
                // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
                var createMethod = function(TYPE) {
                    return function($this) {
                        var string = toString(requireObjectCoercible($this));
                        if (TYPE & 1) string = replace(string, ltrim, '');
                        if (TYPE & 2) string = replace(string, rtrim, '');
                        return string;
                    };
                };
                module1.exports = {
                    // `String.prototype.{ trimLeft, trimStart }` methods
                    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
                    start: createMethod(1),
                    // `String.prototype.{ trimRight, trimEnd }` methods
                    // https://tc39.es/ecma262/#sec-string.prototype.trimend
                    end: createMethod(2),
                    // `String.prototype.trim` method
                    // https://tc39.es/ecma262/#sec-string.prototype.trim
                    trim: createMethod(3)
                };
            /***/ },
            /***/ 29883: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $every = __webpack_require__(91102).every;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.every` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
                exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */ ) {
                    return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 30450: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(8953);
                __webpack_require__(14032);
                // eslint-disable-next-line es/no-typed-arrays -- safe
                module1.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';
            /***/ },
            /***/ 32010: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var check = function(it) {
                    return it && it.Math == Math && it;
                };
                // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
                module1.exports = // eslint-disable-next-line es/no-global-this -- safe
                check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
                check(typeof self == 'object' && self) || check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) || // eslint-disable-next-line no-new-func -- fallback
                function() {
                    return this;
                }() || Function('return this')();
            /***/ },
            /***/ 32504: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                exports.byteLength = byteLength;
                exports.toByteArray = toByteArray;
                exports.fromByteArray = fromByteArray;
                var lookup = [];
                var revLookup = [];
                var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
                var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                for(var i = 0, len = code.length; i < len; ++i){
                    lookup[i] = code[i];
                    revLookup[code.charCodeAt(i)] = i;
                }
                // Support decoding URL-safe base64 strings, as Node.js does.
                // See: https://en.wikipedia.org/wiki/Base64#URL_applications
                revLookup['-'.charCodeAt(0)] = 62;
                revLookup['_'.charCodeAt(0)] = 63;
                function getLens(b64) {
                    var len = b64.length;
                    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
                    // Trim off extra bytes after placeholder bytes are found
                    // See: https://github.com/beatgammit/base64-js/issues/42
                    var validLen = b64.indexOf('=');
                    if (validLen === -1) validLen = len;
                    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
                    return [
                        validLen,
                        placeHoldersLen
                    ];
                }
                // base64 is 4/3 + up to two characters of the original data
                function byteLength(b64) {
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function _byteLength(b64, validLen, placeHoldersLen) {
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function toByteArray(b64) {
                    var tmp;
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
                    var curByte = 0;
                    // if there are placeholders, only get up to the last complete 4 chars
                    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
                    var i;
                    for(i = 0; i < len; i += 4){
                        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
                        arr[curByte++] = tmp >> 16 & 0xFF;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 2) {
                        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 1) {
                        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    return arr;
                }
                function tripletToBase64(num) {
                    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
                }
                function encodeChunk(uint8, start, end) {
                    var tmp;
                    var output = [];
                    for(var i = start; i < end; i += 3){
                        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
                        output.push(tripletToBase64(tmp));
                    }
                    return output.join('');
                }
                function fromByteArray(uint8) {
                    var tmp;
                    var len = uint8.length;
                    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
                    ;
                    var parts = [];
                    var maxChunkLength = 16383 // must be multiple of 3
                    ;
                    // go through the array every three bytes, we'll deal with trailing stuff later
                    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
                    // pad the end with zeros, but make sure to not forget the extra bytes
                    if (extraBytes === 1) {
                        tmp = uint8[len - 1];
                        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
                    } else if (extraBytes === 2) {
                        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
                    }
                    return parts.join('');
                }
            /***/ },
            /***/ 32631: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isCallable = __webpack_require__(94578);
                var tryToString = __webpack_require__(68664);
                var TypeError1 = global.TypeError;
                // `Assert: IsCallable(argument) is true`
                module1.exports = function(argument) {
                    if (isCallable(argument)) return argument;
                    throw TypeError1(tryToString(argument) + ' is not a function');
                };
            /***/ },
            /***/ 32843: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var aCallable = __webpack_require__(32631);
                var toObject = __webpack_require__(43162);
                var IndexedObject = __webpack_require__(7514);
                var lengthOfArrayLike = __webpack_require__(45495);
                var TypeError1 = global.TypeError;
                // `Array.prototype.{ reduce, reduceRight }` methods implementation
                var createMethod = function(IS_RIGHT) {
                    return function(that, callbackfn, argumentsLength, memo) {
                        aCallable(callbackfn);
                        var O = toObject(that);
                        var self1 = IndexedObject(O);
                        var length = lengthOfArrayLike(O);
                        var index = IS_RIGHT ? length - 1 : 0;
                        var i = IS_RIGHT ? -1 : 1;
                        if (argumentsLength < 2) while(true){
                            if (index in self1) {
                                memo = self1[index];
                                index += i;
                                break;
                            }
                            index += i;
                            if (IS_RIGHT ? index < 0 : length <= index) throw TypeError1('Reduce of empty array with no initial value');
                        }
                        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
                        return memo;
                    };
                };
                module1.exports = {
                    // `Array.prototype.reduce` method
                    // https://tc39.es/ecma262/#sec-array.prototype.reduce
                    left: createMethod(false),
                    // `Array.prototype.reduceRight` method
                    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
                    right: createMethod(true)
                };
            /***/ },
            /***/ 33766: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $Object = __webpack_require__(75846);
                /** @type {import('./Object.getPrototypeOf')} */ module1.exports = $Object.getPrototypeOf || null;
            /***/ },
            /***/ 34074: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var arraySlice = __webpack_require__(73163);
                var replace = uncurryThis(''.replace);
                var split = uncurryThis(''.split);
                var join = uncurryThis([].join);
                var TEST = function(arg) {
                    return String(Error(arg).stack);
                }('zxcasd');
                var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
                var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
                var IS_FIREFOX_OR_SAFARI_STACK = /@[^\n]*\n/.test(TEST) && !/zxcasd/.test(TEST);
                module1.exports = function(stack, dropEntries) {
                    if (typeof stack != 'string') return stack;
                    if (IS_V8_OR_CHAKRA_STACK) while(dropEntries--)stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
                    else if (IS_FIREFOX_OR_SAFARI_STACK) return join(arraySlice(split(stack, '\n'), dropEntries), '\n');
                    return stack;
                };
            /***/ },
            /***/ 34097: /***/ function(module1) {
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/ var BROTLI_READ_SIZE = 4096;
                var BROTLI_IBUF_SIZE = 2 * BROTLI_READ_SIZE + 32;
                var BROTLI_IBUF_MASK = 2 * BROTLI_READ_SIZE - 1;
                var kBitMask = new Uint32Array([
                    0,
                    1,
                    3,
                    7,
                    15,
                    31,
                    63,
                    127,
                    255,
                    511,
                    1023,
                    2047,
                    4095,
                    8191,
                    16383,
                    32767,
                    65535,
                    131071,
                    262143,
                    524287,
                    1048575,
                    2097151,
                    4194303,
                    8388607,
                    16777215
                ]);
                /* Input byte buffer, consist of a ringbuffer and a "slack" region where */ /* bytes from the start of the ringbuffer are copied. */ function BrotliBitReader(input) {
                    this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
                    this.input_ = input; /* input callback */ 
                    this.reset();
                }
                BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
                BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;
                BrotliBitReader.prototype.reset = function() {
                    this.buf_ptr_ = 0; /* next input will write here */ 
                    this.val_ = 0; /* pre-fetched bits */ 
                    this.pos_ = 0; /* byte position in stream */ 
                    this.bit_pos_ = 0; /* current bit-reading position in val_ */ 
                    this.bit_end_pos_ = 0; /* bit-reading end position from LSB of val_ */ 
                    this.eos_ = 0; /* input stream is finished */ 
                    this.readMoreInput();
                    for(var i = 0; i < 4; i++){
                        this.val_ |= this.buf_[this.pos_] << 8 * i;
                        ++this.pos_;
                    }
                    return this.bit_end_pos_ > 0;
                };
                /* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/ BrotliBitReader.prototype.readMoreInput = function() {
                    if (this.bit_end_pos_ > 256) return;
                    else if (this.eos_) {
                        if (this.bit_pos_ > this.bit_end_pos_) throw new Error('Unexpected end of input ' + this.bit_pos_ + ' ' + this.bit_end_pos_);
                    } else {
                        var dst = this.buf_ptr_;
                        var bytes_read = this.input_.read(this.buf_, dst, BROTLI_READ_SIZE);
                        if (bytes_read < 0) throw new Error('Unexpected end of input');
                        if (bytes_read < BROTLI_READ_SIZE) {
                            this.eos_ = 1;
                            /* Store 32 bytes of zero after the stream end. */ for(var p = 0; p < 32; p++)this.buf_[dst + bytes_read + p] = 0;
                        }
                        if (dst === 0) {
                            /* Copy the head of the ringbuffer to the slack region. */ for(var p = 0; p < 32; p++)this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
                            this.buf_ptr_ = BROTLI_READ_SIZE;
                        } else this.buf_ptr_ = 0;
                        this.bit_end_pos_ += bytes_read << 3;
                    }
                };
                /* Guarantees that there are at least 24 bits in the buffer. */ BrotliBitReader.prototype.fillBitWindow = function() {
                    while(this.bit_pos_ >= 8){
                        this.val_ >>>= 8;
                        this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
                        ++this.pos_;
                        this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
                        this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
                    }
                };
                /* Reads the specified number of bits from Read Buffer. */ BrotliBitReader.prototype.readBits = function(n_bits) {
                    if (32 - this.bit_pos_ < n_bits) this.fillBitWindow();
                    var val = this.val_ >>> this.bit_pos_ & kBitMask[n_bits];
                    this.bit_pos_ += n_bits;
                    return val;
                };
                module1.exports = BrotliBitReader;
            /***/ },
            /***/ 34269: /***/ function(module1) {
                module1.exports = function(Constructor, list) {
                    var index = 0;
                    var length = list.length;
                    var result = new Constructor(length);
                    while(length > index)result[index] = list[index++];
                    return result;
                };
            /***/ },
            /***/ 34460: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                module1.exports = __webpack_require__(20980).BrotliDecompressBuffer;
            /***/ },
            /***/ 34506: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(93143).Buffer;
                // NOTE: Due to 'stream' module being pretty large (~100Kb, significant in browser environments), 
                // we opt to dependency-inject it instead of creating a hard dependency.
                module1.exports = function(stream_module) {
                    var Transform = stream_module.Transform;
                    // == Encoder stream =======================================================
                    function IconvLiteEncoderStream(conv, options) {
                        this.conv = conv;
                        options = options || {};
                        options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
                        Transform.call(this, options);
                    }
                    IconvLiteEncoderStream.prototype = Object.create(Transform.prototype, {
                        constructor: {
                            value: IconvLiteEncoderStream
                        }
                    });
                    IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
                        if (typeof chunk != 'string') return done(new Error("Iconv encoding stream needs strings as its input."));
                        try {
                            var res = this.conv.write(chunk);
                            if (res && res.length) this.push(res);
                            done();
                        } catch (e) {
                            done(e);
                        }
                    };
                    IconvLiteEncoderStream.prototype._flush = function(done) {
                        try {
                            var res = this.conv.end();
                            if (res && res.length) this.push(res);
                            done();
                        } catch (e) {
                            done(e);
                        }
                    };
                    IconvLiteEncoderStream.prototype.collect = function(cb) {
                        var chunks = [];
                        this.on('error', cb);
                        this.on('data', function(chunk) {
                            chunks.push(chunk);
                        });
                        this.on('end', function() {
                            cb(null, Buffer.concat(chunks));
                        });
                        return this;
                    };
                    // == Decoder stream =======================================================
                    function IconvLiteDecoderStream(conv, options) {
                        this.conv = conv;
                        options = options || {};
                        options.encoding = this.encoding = 'utf8'; // We output strings.
                        Transform.call(this, options);
                    }
                    IconvLiteDecoderStream.prototype = Object.create(Transform.prototype, {
                        constructor: {
                            value: IconvLiteDecoderStream
                        }
                    });
                    IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
                        if (!Buffer.isBuffer(chunk) && !(chunk instanceof Uint8Array)) return done(new Error("Iconv decoding stream needs buffers as its input."));
                        try {
                            var res = this.conv.write(chunk);
                            if (res && res.length) this.push(res, this.encoding);
                            done();
                        } catch (e) {
                            done(e);
                        }
                    };
                    IconvLiteDecoderStream.prototype._flush = function(done) {
                        try {
                            var res = this.conv.end();
                            if (res && res.length) this.push(res, this.encoding);
                            done();
                        } catch (e) {
                            done(e);
                        }
                    };
                    IconvLiteDecoderStream.prototype.collect = function(cb) {
                        var res = '';
                        this.on('error', cb);
                        this.on('data', function(chunk) {
                            res += chunk;
                        });
                        this.on('end', function() {
                            cb(null, res);
                        });
                        return this;
                    };
                    return {
                        IconvLiteEncoderStream: IconvLiteEncoderStream,
                        IconvLiteDecoderStream: IconvLiteDecoderStream
                    };
                };
            /***/ },
            /***/ 34815: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var ArrayBufferViewCore = __webpack_require__(59754);
                var speciesConstructor = __webpack_require__(27754);
                var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
                var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
                // a part of `TypedArraySpeciesCreate` abstract operation
                // https://tc39.es/ecma262/#typedarray-species-create
                module1.exports = function(originalArray) {
                    return aTypedArrayConstructor(speciesConstructor(originalArray, originalArray[TYPED_ARRAY_CONSTRUCTOR]));
                };
            /***/ },
            /***/ 34858: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(32010);
                var toIntegerOrInfinity = __webpack_require__(26882);
                var toString = __webpack_require__(25096);
                var requireObjectCoercible = __webpack_require__(83943);
                var RangeError1 = global.RangeError;
                // `String.prototype.repeat` method implementation
                // https://tc39.es/ecma262/#sec-string.prototype.repeat
                module1.exports = function repeat(count) {
                    var str = toString(requireObjectCoercible(this));
                    var result = '';
                    var n = toIntegerOrInfinity(count);
                    if (n < 0 || n == Infinity) throw RangeError1('Wrong number of repetitions');
                    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) result += str;
                    return result;
                };
            /***/ },
            /***/ 34984: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isObject = __webpack_require__(24517);
                var String1 = global.String;
                var TypeError1 = global.TypeError;
                // `Assert: Type(argument) is Object`
                module1.exports = function(argument) {
                    if (isObject(argument)) return argument;
                    throw TypeError1(String1(argument) + ' is not an object');
                };
            /***/ },
            /***/ 35074: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var define = __webpack_require__(77802);
                var getPolyfill = __webpack_require__(61320);
                /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module1.exports = function shimNumberIsNaN() {
                    var polyfill = getPolyfill();
                    define(Number, {
                        isNaN: polyfill
                    }, {
                        isNaN: function testIsNaN() {
                            return Number.isNaN !== polyfill;
                        }
                    });
                    return polyfill;
                };
            /***/ },
            /***/ 35143: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(93143).Buffer;
                // Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
                // Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
                // To save memory and loading time, we read table files only when requested.
                exports._dbcs = DBCSCodec;
                var UNASSIGNED = -1, GB18030_CODE = -2, SEQ_START = -10, NODE_START = -1000, UNASSIGNED_NODE = new Array(0x100), DEF_CHAR = -1;
                for(var i = 0; i < 0x100; i++)UNASSIGNED_NODE[i] = UNASSIGNED;
                // Class DBCSCodec reads and initializes mapping tables.
                function DBCSCodec(codecOptions, iconv) {
                    this.encodingName = codecOptions.encodingName;
                    if (!codecOptions) throw new Error("DBCS codec is called without the data.");
                    if (!codecOptions.table) throw new Error("Encoding '" + this.encodingName + "' has no data.");
                    // Load tables.
                    var mappingTable = codecOptions.table();
                    // Decode tables: MBCS -> Unicode.
                    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
                    // Trie root is decodeTables[0].
                    // Values: >=  0 -> unicode character code. can be > 0xFFFF
                    //         == UNASSIGNED -> unknown/unassigned sequence.
                    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
                    //         <= NODE_START -> index of the next node in our trie to process next byte.
                    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
                    this.decodeTables = [];
                    this.decodeTables[0] = UNASSIGNED_NODE.slice(0); // Create root node.
                    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
                    this.decodeTableSeq = [];
                    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
                    for(var i = 0; i < mappingTable.length; i++)this._addDecodeChunk(mappingTable[i]);
                    // Load & create GB18030 tables when needed.
                    if (typeof codecOptions.gb18030 === 'function') {
                        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
                        // Add GB18030 common decode nodes.
                        var commonThirdByteNodeIdx = this.decodeTables.length;
                        this.decodeTables.push(UNASSIGNED_NODE.slice(0));
                        var commonFourthByteNodeIdx = this.decodeTables.length;
                        this.decodeTables.push(UNASSIGNED_NODE.slice(0));
                        // Fill out the tree
                        var firstByteNode = this.decodeTables[0];
                        for(var i = 0x81; i <= 0xFE; i++){
                            var secondByteNode = this.decodeTables[NODE_START - firstByteNode[i]];
                            for(var j = 0x30; j <= 0x39; j++){
                                if (secondByteNode[j] === UNASSIGNED) secondByteNode[j] = NODE_START - commonThirdByteNodeIdx;
                                else if (secondByteNode[j] > NODE_START) throw new Error("gb18030 decode tables conflict at byte 2");
                                var thirdByteNode = this.decodeTables[NODE_START - secondByteNode[j]];
                                for(var k = 0x81; k <= 0xFE; k++){
                                    if (thirdByteNode[k] === UNASSIGNED) thirdByteNode[k] = NODE_START - commonFourthByteNodeIdx;
                                    else if (thirdByteNode[k] === NODE_START - commonFourthByteNodeIdx) continue;
                                    else if (thirdByteNode[k] > NODE_START) throw new Error("gb18030 decode tables conflict at byte 3");
                                    var fourthByteNode = this.decodeTables[NODE_START - thirdByteNode[k]];
                                    for(var l = 0x30; l <= 0x39; l++)if (fourthByteNode[l] === UNASSIGNED) fourthByteNode[l] = GB18030_CODE;
                                }
                            }
                        }
                    }
                    this.defaultCharUnicode = iconv.defaultCharUnicode;
                    // Encode tables: Unicode -> DBCS.
                    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
                    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
                    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
                    //         == UNASSIGNED -> no conversion found. Output a default char.
                    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
                    this.encodeTable = [];
                    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
                    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
                    // means end of sequence (needed when one sequence is a strict subsequence of another).
                    // Objects are kept separately from encodeTable to increase performance.
                    this.encodeTableSeq = [];
                    // Some chars can be decoded, but need not be encoded.
                    var skipEncodeChars = {};
                    if (codecOptions.encodeSkipVals) for(var i = 0; i < codecOptions.encodeSkipVals.length; i++){
                        var val = codecOptions.encodeSkipVals[i];
                        if (typeof val === 'number') skipEncodeChars[val] = true;
                        else for(var j = val.from; j <= val.to; j++)skipEncodeChars[j] = true;
                    }
                    // Use decode trie to recursively fill out encode tables.
                    this._fillEncodeTable(0, 0, skipEncodeChars);
                    // Add more encoding pairs when needed.
                    if (codecOptions.encodeAdd) {
                        for(var uChar in codecOptions.encodeAdd)if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar)) this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
                    }
                    this.defCharSB = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
                    if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
                    if (this.defCharSB === UNASSIGNED) this.defCharSB = "?".charCodeAt(0);
                }
                DBCSCodec.prototype.encoder = DBCSEncoder;
                DBCSCodec.prototype.decoder = DBCSDecoder;
                // Decoder helpers
                DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
                    var bytes = [];
                    for(; addr > 0; addr >>>= 8)bytes.push(addr & 0xFF);
                    if (bytes.length == 0) bytes.push(0);
                    var node = this.decodeTables[0];
                    for(var i = bytes.length - 1; i > 0; i--){
                        var val = node[bytes[i]];
                        if (val == UNASSIGNED) {
                            node[bytes[i]] = NODE_START - this.decodeTables.length;
                            this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
                        } else if (val <= NODE_START) node = this.decodeTables[NODE_START - val];
                        else throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
                    }
                    return node;
                };
                DBCSCodec.prototype._addDecodeChunk = function(chunk) {
                    // First element of chunk is the hex mbcs code where we start.
                    var curAddr = parseInt(chunk[0], 16);
                    // Choose the decoding node where we'll write our chars.
                    var writeTable = this._getDecodeTrieNode(curAddr);
                    curAddr = curAddr & 0xFF;
                    // Write all other elements of the chunk to the table.
                    for(var k = 1; k < chunk.length; k++){
                        var part = chunk[k];
                        if (typeof part === "string") for(var l = 0; l < part.length;){
                            var code = part.charCodeAt(l++);
                            if (0xD800 <= code && code < 0xDC00) {
                                var codeTrail = part.charCodeAt(l++);
                                if (0xDC00 <= codeTrail && codeTrail < 0xE000) writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                                else throw new Error("Incorrect surrogate pair in " + this.encodingName + " at chunk " + chunk[0]);
                            } else if (0x0FF0 < code && code <= 0x0FFF) {
                                var len = 0xFFF - code + 2;
                                var seq = [];
                                for(var m = 0; m < len; m++)seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.
                                writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
                                this.decodeTableSeq.push(seq);
                            } else writeTable[curAddr++] = code; // Basic char
                        }
                        else if (typeof part === "number") {
                            var charCode = writeTable[curAddr - 1] + 1;
                            for(var l = 0; l < part; l++)writeTable[curAddr++] = charCode++;
                        } else throw new Error("Incorrect type '" + typeof part + "' given in " + this.encodingName + " at chunk " + chunk[0]);
                    }
                    if (curAddr > 0xFF) throw new Error("Incorrect chunk in " + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
                };
                // Encoder helpers
                DBCSCodec.prototype._getEncodeBucket = function(uCode) {
                    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
                    if (this.encodeTable[high] === undefined) this.encodeTable[high] = UNASSIGNED_NODE.slice(0); // Create bucket on demand.
                    return this.encodeTable[high];
                };
                DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
                    var bucket = this._getEncodeBucket(uCode);
                    var low = uCode & 0xFF;
                    if (bucket[low] <= SEQ_START) this.encodeTableSeq[SEQ_START - bucket[low]][DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
                    else if (bucket[low] == UNASSIGNED) bucket[low] = dbcsCode;
                };
                DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
                    // Get the root of character tree according to first character of the sequence.
                    var uCode = seq[0];
                    var bucket = this._getEncodeBucket(uCode);
                    var low = uCode & 0xFF;
                    var node;
                    if (bucket[low] <= SEQ_START) // There's already a sequence with  - use it.
                    node = this.encodeTableSeq[SEQ_START - bucket[low]];
                    else {
                        // There was no sequence object - allocate a new one.
                        node = {};
                        if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
                        bucket[low] = SEQ_START - this.encodeTableSeq.length;
                        this.encodeTableSeq.push(node);
                    }
                    // Traverse the character tree, allocating new nodes as needed.
                    for(var j = 1; j < seq.length - 1; j++){
                        var oldVal = node[uCode];
                        if (typeof oldVal === 'object') node = oldVal;
                        else {
                            node = node[uCode] = {};
                            if (oldVal !== undefined) node[DEF_CHAR] = oldVal;
                        }
                    }
                    // Set the leaf to given dbcsCode.
                    uCode = seq[seq.length - 1];
                    node[uCode] = dbcsCode;
                };
                DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
                    var node = this.decodeTables[nodeIdx];
                    var hasValues = false;
                    var subNodeEmpty = {};
                    for(var i = 0; i < 0x100; i++){
                        var uCode = node[i];
                        var mbCode = prefix + i;
                        if (skipEncodeChars[mbCode]) continue;
                        if (uCode >= 0) {
                            this._setEncodeChar(uCode, mbCode);
                            hasValues = true;
                        } else if (uCode <= NODE_START) {
                            var subNodeIdx = NODE_START - uCode;
                            if (!subNodeEmpty[subNodeIdx]) {
                                var newPrefix = mbCode << 8 >>> 0; // NOTE: '>>> 0' keeps 32-bit num positive.
                                if (this._fillEncodeTable(subNodeIdx, newPrefix, skipEncodeChars)) hasValues = true;
                                else subNodeEmpty[subNodeIdx] = true;
                            }
                        } else if (uCode <= SEQ_START) {
                            this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
                            hasValues = true;
                        }
                    }
                    return hasValues;
                };
                // == Encoder ==================================================================
                function DBCSEncoder(options, codec) {
                    // Encoder state
                    this.leadSurrogate = -1;
                    this.seqObj = undefined;
                    // Static data
                    this.encodeTable = codec.encodeTable;
                    this.encodeTableSeq = codec.encodeTableSeq;
                    this.defaultCharSingleByte = codec.defCharSB;
                    this.gb18030 = codec.gb18030;
                }
                DBCSEncoder.prototype.write = function(str) {
                    var newBuf = Buffer.alloc(str.length * (this.gb18030 ? 4 : 3)), leadSurrogate = this.leadSurrogate, seqObj = this.seqObj, nextChar = -1, i = 0, j = 0;
                    while(true){
                        // 0. Get next character.
                        if (nextChar === -1) {
                            if (i == str.length) break;
                            var uCode = str.charCodeAt(i++);
                        } else {
                            var uCode = nextChar;
                            nextChar = -1;
                        }
                        // 1. Handle surrogates.
                        if (0xD800 <= uCode && uCode < 0xE000) {
                            if (uCode < 0xDC00) {
                                if (leadSurrogate === -1) {
                                    leadSurrogate = uCode;
                                    continue;
                                } else {
                                    leadSurrogate = uCode;
                                    // Double lead surrogate found.
                                    uCode = UNASSIGNED;
                                }
                            } else if (leadSurrogate !== -1) {
                                uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                                leadSurrogate = -1;
                            } else // Incomplete surrogate pair - only trail surrogate found.
                            uCode = UNASSIGNED;
                        } else if (leadSurrogate !== -1) {
                            // Incomplete surrogate pair - only lead surrogate found.
                            nextChar = uCode;
                            uCode = UNASSIGNED; // Write an error, then current char.
                            leadSurrogate = -1;
                        }
                        // 2. Convert uCode character.
                        var dbcsCode = UNASSIGNED;
                        if (seqObj !== undefined && uCode != UNASSIGNED) {
                            var resCode = seqObj[uCode];
                            if (typeof resCode === 'object') {
                                seqObj = resCode;
                                continue;
                            } else if (typeof resCode == 'number') dbcsCode = resCode;
                            else if (resCode == undefined) {
                                // Try default character for this sequence
                                resCode = seqObj[DEF_CHAR];
                                if (resCode !== undefined) {
                                    dbcsCode = resCode; // Found. Write it.
                                    nextChar = uCode; // Current character will be written too in the next iteration.
                                }
                            }
                            seqObj = undefined;
                        } else if (uCode >= 0) {
                            var subtable = this.encodeTable[uCode >> 8];
                            if (subtable !== undefined) dbcsCode = subtable[uCode & 0xFF];
                            if (dbcsCode <= SEQ_START) {
                                seqObj = this.encodeTableSeq[SEQ_START - dbcsCode];
                                continue;
                            }
                            if (dbcsCode == UNASSIGNED && this.gb18030) {
                                // Use GB18030 algorithm to find character(s) to write.
                                var idx = findIdx(this.gb18030.uChars, uCode);
                                if (idx != -1) {
                                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600);
                                    dbcsCode = dbcsCode % 12600;
                                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260);
                                    dbcsCode = dbcsCode % 1260;
                                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10);
                                    dbcsCode = dbcsCode % 10;
                                    newBuf[j++] = 0x30 + dbcsCode;
                                    continue;
                                }
                            }
                        }
                        // 3. Write dbcsCode character.
                        if (dbcsCode === UNASSIGNED) dbcsCode = this.defaultCharSingleByte;
                        if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
                        else if (dbcsCode < 0x10000) {
                            newBuf[j++] = dbcsCode >> 8; // high byte
                            newBuf[j++] = dbcsCode & 0xFF; // low byte
                        } else if (dbcsCode < 0x1000000) {
                            newBuf[j++] = dbcsCode >> 16;
                            newBuf[j++] = dbcsCode >> 8 & 0xFF;
                            newBuf[j++] = dbcsCode & 0xFF;
                        } else {
                            newBuf[j++] = dbcsCode >>> 24;
                            newBuf[j++] = dbcsCode >>> 16 & 0xFF;
                            newBuf[j++] = dbcsCode >>> 8 & 0xFF;
                            newBuf[j++] = dbcsCode & 0xFF;
                        }
                    }
                    this.seqObj = seqObj;
                    this.leadSurrogate = leadSurrogate;
                    return newBuf.slice(0, j);
                };
                DBCSEncoder.prototype.end = function() {
                    if (this.leadSurrogate === -1 && this.seqObj === undefined) return; // All clean. Most often case.
                    var newBuf = Buffer.alloc(10), j = 0;
                    if (this.seqObj) {
                        var dbcsCode = this.seqObj[DEF_CHAR];
                        if (dbcsCode !== undefined) {
                            if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
                            else {
                                newBuf[j++] = dbcsCode >> 8; // high byte
                                newBuf[j++] = dbcsCode & 0xFF; // low byte
                            }
                        } else ;
                        this.seqObj = undefined;
                    }
                    if (this.leadSurrogate !== -1) {
                        // Incomplete surrogate pair - only lead surrogate found.
                        newBuf[j++] = this.defaultCharSingleByte;
                        this.leadSurrogate = -1;
                    }
                    return newBuf.slice(0, j);
                };
                // Export for testing
                DBCSEncoder.prototype.findIdx = findIdx;
                // == Decoder ==================================================================
                function DBCSDecoder(options, codec) {
                    // Decoder state
                    this.nodeIdx = 0;
                    this.prevBytes = [];
                    // Static data
                    this.decodeTables = codec.decodeTables;
                    this.decodeTableSeq = codec.decodeTableSeq;
                    this.defaultCharUnicode = codec.defaultCharUnicode;
                    this.gb18030 = codec.gb18030;
                }
                DBCSDecoder.prototype.write = function(buf) {
                    var newBuf = Buffer.alloc(buf.length * 2), nodeIdx = this.nodeIdx, prevBytes = this.prevBytes, prevOffset = this.prevBytes.length, seqStart = -this.prevBytes.length, uCode;
                    for(var i = 0, j = 0; i < buf.length; i++){
                        var curByte = i >= 0 ? buf[i] : prevBytes[i + prevOffset];
                        // Lookup in current trie node.
                        var uCode = this.decodeTables[nodeIdx][curByte];
                        if (uCode >= 0) ;
                        else if (uCode === UNASSIGNED) {
                            // TODO: Callback with seq.
                            uCode = this.defaultCharUnicode.charCodeAt(0);
                            i = seqStart; // Skip one byte ('i' will be incremented by the for loop) and try to parse again.
                        } else if (uCode === GB18030_CODE) {
                            if (i >= 3) var ptr = (buf[i - 3] - 0x81) * 12600 + (buf[i - 2] - 0x30) * 1260 + (buf[i - 1] - 0x81) * 10 + (curByte - 0x30);
                            else var ptr = (prevBytes[i - 3 + prevOffset] - 0x81) * 12600 + ((i - 2 >= 0 ? buf[i - 2] : prevBytes[i - 2 + prevOffset]) - 0x30) * 1260 + ((i - 1 >= 0 ? buf[i - 1] : prevBytes[i - 1 + prevOffset]) - 0x81) * 10 + (curByte - 0x30);
                            var idx = findIdx(this.gb18030.gbChars, ptr);
                            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
                        } else if (uCode <= NODE_START) {
                            nodeIdx = NODE_START - uCode;
                            continue;
                        } else if (uCode <= SEQ_START) {
                            var seq = this.decodeTableSeq[SEQ_START - uCode];
                            for(var k = 0; k < seq.length - 1; k++){
                                uCode = seq[k];
                                newBuf[j++] = uCode & 0xFF;
                                newBuf[j++] = uCode >> 8;
                            }
                            uCode = seq[seq.length - 1];
                        } else throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);
                        // Write the character to buffer, handling higher planes using surrogate pair.
                        if (uCode >= 0x10000) {
                            uCode -= 0x10000;
                            var uCodeLead = 0xD800 | uCode >> 10;
                            newBuf[j++] = uCodeLead & 0xFF;
                            newBuf[j++] = uCodeLead >> 8;
                            uCode = 0xDC00 | uCode & 0x3FF;
                        }
                        newBuf[j++] = uCode & 0xFF;
                        newBuf[j++] = uCode >> 8;
                        // Reset trie node.
                        nodeIdx = 0;
                        seqStart = i + 1;
                    }
                    this.nodeIdx = nodeIdx;
                    this.prevBytes = seqStart >= 0 ? Array.prototype.slice.call(buf, seqStart) : prevBytes.slice(seqStart + prevOffset).concat(Array.prototype.slice.call(buf));
                    return newBuf.slice(0, j).toString('ucs2');
                };
                DBCSDecoder.prototype.end = function() {
                    var ret = '';
                    // Try to parse all remaining chars.
                    while(this.prevBytes.length > 0){
                        // Skip 1 character in the buffer.
                        ret += this.defaultCharUnicode;
                        var bytesArr = this.prevBytes.slice(1);
                        // Parse remaining as usual.
                        this.prevBytes = [];
                        this.nodeIdx = 0;
                        if (bytesArr.length > 0) ret += this.write(bytesArr);
                    }
                    this.prevBytes = [];
                    this.nodeIdx = 0;
                    return ret;
                };
                // Binary search for GB18030. Returns largest i such that table[i] <= val.
                function findIdx(table, val) {
                    if (table[0] > val) return -1;
                    var l = 0, r = table.length;
                    while(l < r - 1){
                        var mid = l + (r - l + 1 >> 1);
                        if (table[mid] <= val) l = mid;
                        else r = mid;
                    }
                    return l;
                }
            /***/ },
            /***/ 35403: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Currently in sync with Node.js lib/internal/errors.js
                // https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
                /* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ // The whole point behind this internal module is to allow Node.js to no
                // longer be forced to treat every error message change as a semver-major
                // change. The NodeError classes here all expose a `code` property whose
                // value statically and permanently identifies the error. While the error
                // message may change, the code should not.
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    Object.defineProperty(subClass, "prototype", {
                        writable: false
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                var codes = {};
                // Lazy loaded
                var assert;
                var util;
                function createErrorType(code, message, Base) {
                    if (!Base) Base = Error;
                    function getMessage(arg1, arg2, arg3) {
                        if (typeof message === 'string') return message;
                        else return message(arg1, arg2, arg3);
                    }
                    var NodeError = /*#__PURE__*/ function(_Base) {
                        _inherits(NodeError, _Base);
                        var _super = _createSuper(NodeError);
                        function NodeError(arg1, arg2, arg3) {
                            var _this;
                            _classCallCheck(this, NodeError);
                            _this = _super.call(this, getMessage(arg1, arg2, arg3));
                            _this.code = code;
                            return _this;
                        }
                        return _createClass(NodeError);
                    }(Base);
                    codes[code] = NodeError;
                }
                // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
                function oneOf(expected, thing) {
                    if (Array.isArray(expected)) {
                        var len = expected.length;
                        expected = expected.map(function(i) {
                            return String(i);
                        });
                        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
                        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
                        else return "of ".concat(thing, " ").concat(expected[0]);
                    } else return "of ".concat(thing, " ").concat(String(expected));
                }
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
                function startsWith(str, search, pos) {
                    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
                }
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
                function endsWith(str, search, this_len) {
                    if (this_len === undefined || this_len > str.length) this_len = str.length;
                    return str.substring(this_len - search.length, this_len) === search;
                }
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
                function includes(str, search, start) {
                    if (typeof start !== 'number') start = 0;
                    if (start + search.length > str.length) return false;
                    else return str.indexOf(search, start) !== -1;
                }
                createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);
                createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
                    if (assert === undefined) assert = __webpack_require__(80182);
                    assert(typeof name === 'string', "'name' must be a string");
                    // determiner: 'must be' or 'must not be'
                    var determiner;
                    if (typeof expected === 'string' && startsWith(expected, 'not ')) {
                        determiner = 'must not be';
                        expected = expected.replace(/^not /, '');
                    } else determiner = 'must be';
                    var msg;
                    if (endsWith(name, ' argument')) // For cases like 'first argument'
                    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
                    else {
                        var type = includes(name, '.') ? 'property' : 'argument';
                        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
                    }
                    // TODO(BridgeAR): Improve the output by showing `null` and similar.
                    msg += ". Received type ".concat(_typeof(actual));
                    return msg;
                }, TypeError);
                createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
                    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
                    if (util === undefined) util = __webpack_require__(7187);
                    var inspected = util.inspect(value);
                    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
                    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
                }, TypeError, RangeError);
                createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
                    var type;
                    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
                    else type = "type ".concat(_typeof(value));
                    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
                }, TypeError);
                createErrorType('ERR_MISSING_ARGS', function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    if (assert === undefined) assert = __webpack_require__(80182);
                    assert(args.length > 0, 'At least one arg needs to be specified');
                    var msg = 'The ';
                    var len = args.length;
                    args = args.map(function(a) {
                        return "\"".concat(a, "\"");
                    });
                    switch(len){
                        case 1:
                            msg += "".concat(args[0], " argument");
                            break;
                        case 2:
                            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
                            break;
                        default:
                            msg += args.slice(0, len - 1).join(', ');
                            msg += ", and ".concat(args[len - 1], " arguments");
                            break;
                    }
                    return "".concat(msg, " must be specified");
                }, TypeError);
                module1.exports.codes = codes;
            /***/ },
            /***/ 35471: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var call = __webpack_require__(2834);
                var $fill = __webpack_require__(72864);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.fill` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
                exportTypedArrayMethod('fill', function fill(value /* , start, end */ ) {
                    var length = arguments.length;
                    return call($fill, aTypedArray(this), value, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
                });
            /***/ },
            /***/ 35643: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var slice = Array.prototype.slice;
                var isArgs = __webpack_require__(76515);
                var origKeys = Object.keys;
                var keysShim = origKeys ? function keys(o) {
                    return origKeys(o);
                } : __webpack_require__(48461);
                var originalKeys = Object.keys;
                keysShim.shim = function shimObjectKeys() {
                    if (Object.keys) {
                        var keysWorksWithArguments = function() {
                            // Safari 5.0 bug
                            var args = Object.keys(arguments);
                            return args && args.length === arguments.length;
                        }(1, 2);
                        if (!keysWorksWithArguments) Object.keys = function keys(object) {
                            if (isArgs(object)) return originalKeys(slice.call(object));
                            return originalKeys(object);
                        };
                    } else Object.keys = keysShim;
                    return Object.keys || keysShim;
                };
                module1.exports = keysShim;
            /***/ },
            /***/ 36316: /***/ function(module1) {
                "use strict";
                var Enum = /*#__PURE__*/ function() {
                    function Enum(type, options) {
                        if (options === void 0) options = [];
                        this.type = type;
                        this.options = options;
                    }
                    var _proto = Enum.prototype;
                    _proto.decode = function decode(stream) {
                        var index = this.type.decode(stream);
                        return this.options[index] || index;
                    };
                    _proto.size = function size() {
                        return this.type.size();
                    };
                    _proto.encode = function encode(stream, val) {
                        var index = this.options.indexOf(val);
                        if (index === -1) throw new Error("Unknown option in enum: " + val);
                        return this.type.encode(stream, index);
                    };
                    return Enum;
                }();
                module1.exports = Enum;
            /***/ },
            /***/ 36352: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var charAt = __webpack_require__(69510).charAt;
                // `AdvanceStringIndex` abstract operation
                // https://tc39.es/ecma262/#sec-advancestringindex
                module1.exports = function(S, index, unicode) {
                    return index + (unicode ? charAt(S, index).length : 1);
                };
            /***/ },
            /***/ 36521: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // modified from https://github.com/es-shims/es6-shim
                var objectKeys = __webpack_require__(35643);
                var hasSymbols = __webpack_require__(12843)();
                var callBound = __webpack_require__(22774);
                var $Object = __webpack_require__(75846);
                var $push = callBound('Array.prototype.push');
                var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
                var originalGetSymbols = hasSymbols ? $Object.getOwnPropertySymbols : null;
                // eslint-disable-next-line no-unused-vars
                module1.exports = function assign(target, source1) {
                    if (target == null) throw new TypeError('target must be an object');
                    var to = $Object(target); // step 1
                    if (arguments.length === 1) return to; // step 2
                    for(var s = 1; s < arguments.length; ++s){
                        var from = $Object(arguments[s]); // step 3.a.i
                        // step 3.a.ii:
                        var keys = objectKeys(from);
                        var getSymbols = hasSymbols && ($Object.getOwnPropertySymbols || originalGetSymbols);
                        if (getSymbols) {
                            var syms = getSymbols(from);
                            for(var j = 0; j < syms.length; ++j){
                                var key = syms[j];
                                if ($propIsEnumerable(from, key)) $push(keys, key);
                            }
                        }
                        // step 3.a.iii:
                        for(var i = 0; i < keys.length; ++i){
                            var nextKey = keys[i];
                            if ($propIsEnumerable(from, nextKey)) {
                                var propValue = from[nextKey]; // step 3.a.iii.2.a
                                to[nextKey] = propValue; // step 3.a.iii.2.b
                            }
                        }
                    }
                    return to; // step 4
                };
            /***/ },
            /***/ 36673: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var isForced = __webpack_require__(39599);
                var redefine = __webpack_require__(13711);
                var InternalMetadataModule = __webpack_require__(62148);
                var iterate = __webpack_require__(80383);
                var anInstance = __webpack_require__(2868);
                var isCallable = __webpack_require__(94578);
                var isObject = __webpack_require__(24517);
                var fails = __webpack_require__(47044);
                var checkCorrectnessOfIteration = __webpack_require__(46769);
                var setToStringTag = __webpack_require__(15216);
                var inheritIfRequired = __webpack_require__(51868);
                module1.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
                    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
                    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
                    var ADDER = IS_MAP ? 'set' : 'add';
                    var NativeConstructor = global[CONSTRUCTOR_NAME];
                    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
                    var Constructor = NativeConstructor;
                    var exported = {};
                    var fixMethod = function(KEY) {
                        var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
                        redefine(NativePrototype, KEY, KEY == 'add' ? function add(value) {
                            uncurriedNativeMethod(this, value === 0 ? 0 : value);
                            return this;
                        } : KEY == 'delete' ? function(key) {
                            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                        } : KEY == 'get' ? function get(key) {
                            return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                        } : KEY == 'has' ? function has(key) {
                            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
                        } : function set(key, value) {
                            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
                            return this;
                        });
                    };
                    var REPLACE = isForced(CONSTRUCTOR_NAME, !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function() {
                        new NativeConstructor().entries().next();
                    })));
                    if (REPLACE) {
                        // create collection constructor
                        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
                        InternalMetadataModule.enable();
                    } else if (isForced(CONSTRUCTOR_NAME, true)) {
                        var instance = new Constructor();
                        // early implementations not supports chaining
                        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
                        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
                        var THROWS_ON_PRIMITIVES = fails(function() {
                            instance.has(1);
                        });
                        // most early implementations doesn't supports iterables, most modern - not close it correctly
                        // eslint-disable-next-line no-new -- required for testing
                        var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function(iterable) {
                            new NativeConstructor(iterable);
                        });
                        // for early implementations -0 and +0 not the same
                        var BUGGY_ZERO = !IS_WEAK && fails(function() {
                            // V8 ~ Chromium 42- fails only with 5+ elements
                            var $instance = new NativeConstructor();
                            var index = 5;
                            while(index--)$instance[ADDER](index, index);
                            return !$instance.has(-0);
                        });
                        if (!ACCEPT_ITERABLES) {
                            Constructor = wrapper(function(dummy, iterable) {
                                anInstance(dummy, NativePrototype);
                                var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
                                if (iterable != undefined) iterate(iterable, that[ADDER], {
                                    that: that,
                                    AS_ENTRIES: IS_MAP
                                });
                                return that;
                            });
                            Constructor.prototype = NativePrototype;
                            NativePrototype.constructor = Constructor;
                        }
                        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
                            fixMethod('delete');
                            fixMethod('has');
                            IS_MAP && fixMethod('get');
                        }
                        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
                        // weak collections should not contains .clear method
                        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
                    }
                    exported[CONSTRUCTOR_NAME] = Constructor;
                    $({
                        global: true,
                        forced: Constructor != NativeConstructor
                    }, exported);
                    setToStringTag(Constructor, CONSTRUCTOR_NAME);
                    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
                    return Constructor;
                };
            /***/ },
            /***/ 36688: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var bind = __webpack_require__(5049);
                var $TypeError = __webpack_require__(96785);
                var $call = __webpack_require__(10078);
                var $actualApply = __webpack_require__(17802);
                /** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module1.exports = function callBindBasic(args) {
                    if (args.length < 1 || typeof args[0] !== 'function') throw new $TypeError('a function is required');
                    return $actualApply(bind, $call, args);
                };
            /***/ },
            /***/ 37146: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var Hasher = C_lib.Hasher;
                        var C_algo = C.algo;
                        // Reusable object
                        var W = [];
                        /**
     * SHA-1 hash algorithm.
     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
                            _doReset: function _doReset() {
                                this._hash = new WordArray.init([
                                    0x67452301,
                                    0xefcdab89,
                                    0x98badcfe,
                                    0x10325476,
                                    0xc3d2e1f0
                                ]);
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcut
                                var H = this._hash.words;
                                // Working variables
                                var a = H[0];
                                var b = H[1];
                                var c = H[2];
                                var d = H[3];
                                var e = H[4];
                                // Computation
                                for(var i = 0; i < 80; i++){
                                    if (i < 16) W[i] = M[offset + i] | 0;
                                    else {
                                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                                        W[i] = n << 1 | n >>> 31;
                                    }
                                    var t = (a << 5 | a >>> 27) + e + W[i];
                                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                                    else t += (b ^ c ^ d) - 0x359d3e2a;
                                    e = d;
                                    d = c;
                                    c = b << 30 | b >>> 2;
                                    b = a;
                                    a = t;
                                }
                                // Intermediate hash value
                                H[0] = H[0] + a | 0;
                                H[1] = H[1] + b | 0;
                                H[2] = H[2] + c | 0;
                                H[3] = H[3] + d | 0;
                                H[4] = H[4] + e | 0;
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                                data.sigBytes = dataWords.length * 4;
                                // Hash final blocks
                                this._process();
                                // Return final computed hash
                                return this._hash;
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                clone._hash = this._hash.clone();
                                return clone;
                            }
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA1('message');
     *     var hash = CryptoJS.SHA1(wordArray);
     */ C.SHA1 = Hasher._createHelper(SHA1);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA1(message, key);
     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
                    })();
                    return CryptoJS.SHA1;
                });
            /***/ },
            /***/ 37309: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var toObject = __webpack_require__(43162);
                var nativeKeys = __webpack_require__(84675);
                var fails = __webpack_require__(47044);
                var FAILS_ON_PRIMITIVES = fails(function() {
                    nativeKeys(1);
                });
                // `Object.keys` method
                // https://tc39.es/ecma262/#sec-object.keys
                $({
                    target: 'Object',
                    stat: true,
                    forced: FAILS_ON_PRIMITIVES
                }, {
                    keys: function keys(it) {
                        return nativeKeys(toObject(it));
                    }
                });
            /***/ },
            /***/ 37385: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(9964);
                // undocumented cb() API, needed for core, not for public API
                function destroy(err, cb) {
                    var _this = this;
                    var readableDestroyed = this._readableState && this._readableState.destroyed;
                    var writableDestroyed = this._writableState && this._writableState.destroyed;
                    if (readableDestroyed || writableDestroyed) {
                        if (cb) cb(err);
                        else if (err) {
                            if (!this._writableState) process.nextTick(emitErrorNT, this, err);
                            else if (!this._writableState.errorEmitted) {
                                this._writableState.errorEmitted = true;
                                process.nextTick(emitErrorNT, this, err);
                            }
                        }
                        return this;
                    }
                    // we set destroyed to true before firing error callbacks in order
                    // to make it re-entrance safe in case destroy() is called within callbacks
                    if (this._readableState) this._readableState.destroyed = true;
                    // if this is a duplex stream mark the writable part as destroyed as well
                    if (this._writableState) this._writableState.destroyed = true;
                    this._destroy(err || null, function(err) {
                        if (!cb && err) {
                            if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
                            else if (!_this._writableState.errorEmitted) {
                                _this._writableState.errorEmitted = true;
                                process.nextTick(emitErrorAndCloseNT, _this, err);
                            } else process.nextTick(emitCloseNT, _this);
                        } else if (cb) {
                            process.nextTick(emitCloseNT, _this);
                            cb(err);
                        } else process.nextTick(emitCloseNT, _this);
                    });
                    return this;
                }
                function emitErrorAndCloseNT(self1, err) {
                    emitErrorNT(self1, err);
                    emitCloseNT(self1);
                }
                function emitCloseNT(self1) {
                    if (self1._writableState && !self1._writableState.emitClose) return;
                    if (self1._readableState && !self1._readableState.emitClose) return;
                    self1.emit('close');
                }
                function undestroy() {
                    if (this._readableState) {
                        this._readableState.destroyed = false;
                        this._readableState.reading = false;
                        this._readableState.ended = false;
                        this._readableState.endEmitted = false;
                    }
                    if (this._writableState) {
                        this._writableState.destroyed = false;
                        this._writableState.ended = false;
                        this._writableState.ending = false;
                        this._writableState.finalCalled = false;
                        this._writableState.prefinished = false;
                        this._writableState.finished = false;
                        this._writableState.errorEmitted = false;
                    }
                }
                function emitErrorNT(self1, err) {
                    self1.emit('error', err);
                }
                function errorOrDestroy(stream, err) {
                    // We have tests that rely on errors being emitted
                    // in the same tick, so changing this is semver major.
                    // For now when you opt-in to autoDestroy we allow
                    // the error to be emitted nextTick. In a future
                    // semver major update we should change the default to this.
                    var rState = stream._readableState;
                    var wState = stream._writableState;
                    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
                    else stream.emit('error', err);
                }
                module1.exports = {
                    destroy: destroy,
                    undestroy: undestroy,
                    errorOrDestroy: errorOrDestroy
                };
            /***/ },
            /***/ 37468: /***/ function(module1) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                function ZStream() {
                    /* next input byte */ this.input = null; // JS specific, because we have no pointers
                    this.next_in = 0;
                    /* number of bytes available at input */ this.avail_in = 0;
                    /* total number of input bytes read so far */ this.total_in = 0;
                    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
                    this.next_out = 0;
                    /* remaining free space at output */ this.avail_out = 0;
                    /* total number of bytes output so far */ this.total_out = 0;
                    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
                    /* not visible by applications */ this.state = null;
                    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
                    /* adler32 value of the uncompressed data */ this.adler = 0;
                }
                module1.exports = ZStream;
            /***/ },
            /***/ 37596: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var implementation = __webpack_require__(36521);
                var lacksProperEnumerationOrder = function() {
                    if (!Object.assign) return false;
                    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
                    var letters = str.split('');
                    var map = {};
                    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
                    var obj = Object.assign({}, map);
                    var actual = '';
                    for(var k in obj)actual += k;
                    return str !== actual;
                };
                var assignHasPendingExceptions = function() {
                    if (!Object.assign || !Object.preventExtensions) return false;
                    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
                        1: 2
                    });
                    try {
                        Object.assign(thrower, 'xy');
                    } catch (e) {
                        return thrower[1] === 'y';
                    }
                    return false;
                };
                module1.exports = function getPolyfill() {
                    if (!Object.assign) return implementation;
                    if (lacksProperEnumerationOrder()) return implementation;
                    if (assignHasPendingExceptions()) return implementation;
                    return Object.assign;
                };
            /***/ },
            /***/ 38347: /***/ function(module1) {
                var FunctionPrototype = Function.prototype;
                var bind = FunctionPrototype.bind;
                var call = FunctionPrototype.call;
                var callBind = bind && bind.bind(call);
                module1.exports = bind ? function(fn) {
                    return fn && callBind(call, fn);
                } : function(fn) {
                    return fn && function() {
                        return call.apply(fn, arguments);
                    };
                };
            /***/ },
            /***/ 38486: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isCallable = __webpack_require__(94578);
                var aFunction = function(argument) {
                    return isCallable(argument) ? argument : undefined;
                };
                module1.exports = function(namespace, method) {
                    return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
                };
            /***/ },
            /***/ 38639: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toPropertyKey = __webpack_require__(63918);
                var definePropertyModule = __webpack_require__(95892);
                var createPropertyDescriptor = __webpack_require__(97841);
                module1.exports = function(object, key, value) {
                    var propertyKey = toPropertyKey(key);
                    if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
                    else object[propertyKey] = value;
                };
            /***/ },
            /***/ 38688: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var shared = __webpack_require__(464);
                var hasOwn = __webpack_require__(20340);
                var uid = __webpack_require__(46859);
                var NATIVE_SYMBOL = __webpack_require__(46887);
                var USE_SYMBOL_AS_UID = __webpack_require__(9567);
                var WellKnownSymbolsStore = shared('wks');
                var Symbol1 = global.Symbol;
                var symbolFor = Symbol1 && Symbol1['for'];
                var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
                module1.exports = function(name) {
                    if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
                        var description = 'Symbol.' + name;
                        if (NATIVE_SYMBOL && hasOwn(Symbol1, name)) WellKnownSymbolsStore[name] = Symbol1[name];
                        else if (USE_SYMBOL_AS_UID && symbolFor) WellKnownSymbolsStore[name] = symbolFor(description);
                        else WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
                    }
                    return WellKnownSymbolsStore[name];
                };
            /***/ },
            /***/ 38834: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _fs = __webpack_require__(48181);
                var _fs2 = _interopRequireDefault(_fs);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var tags = __webpack_require__(9240);
                /*
 unsignedByte,
 asciiStrings,
 unsignedShort,
 unsignedLong,
 unsignedRational,
 signedByte,
 undefined,
 signedShort,
 signedLong,
 signedRational,
 singleFloat,
 doubleFloat
 */ var bytes = [
                    0,
                    1,
                    1,
                    2,
                    4,
                    8,
                    1,
                    1,
                    2,
                    4,
                    8,
                    4,
                    8
                ];
                var SOIMarkerLength = 2;
                var JPEGSOIMarker = 0xffd8;
                var TIFFINTEL = 0x4949;
                var TIFFMOTOROLA = 0x4d4d;
                var APPMarkerLength = 2;
                var APPMarkerBegin = 0xffe0;
                var APPMarkerEnd = 0xffef;
                var data = void 0;
                /**
 * @param buffer {Buffer}
 * @returns {Boolean}
 * @example
 * var content = fs.readFileSync("~/Picture/IMG_0911.JPG");
 * var isImage = isValid(content);
 * console.log(isImage);
 */ var isValid = function isValid(buffer) {
                    try {
                        var SOIMarker = buffer.readUInt16BE(0);
                        return SOIMarker === JPEGSOIMarker;
                    } catch (e) {
                        throw new Error('Unsupport file format.');
                    }
                };
                /**
 * @param buffer {Buffer}
 * @returns {Boolean}
 * @example
 */ var isTiff = function isTiff(buffer) {
                    try {
                        var SOIMarker = buffer.readUInt16BE(0);
                        return SOIMarker === TIFFINTEL || SOIMarker === TIFFMOTOROLA;
                    } catch (e) {
                        throw new Error('Unsupport file format.');
                    }
                };
                /**
 * @param buffer {Buffer}
 * @returns {Number}
 * @example
 * var content = fs.readFileSync("~/Picture/IMG_0911.JPG");
 * var APPNumber = checkAPPn(content);
 * console.log(APPNumber);
 */ var checkAPPn = function checkAPPn(buffer) {
                    try {
                        var APPMarkerTag = buffer.readUInt16BE(0);
                        var isInRange = APPMarkerTag >= APPMarkerBegin && APPMarkerTag <= APPMarkerEnd;
                        return isInRange ? APPMarkerTag - APPMarkerBegin : false;
                    } catch (e) {
                        throw new Error('Invalid APP Tag.');
                    }
                };
                /**
 * @param buffer {Buffer}
 * @param tagCollection {Object}
 * @param order {Boolean}
 * @param offset {Number}
 * @returns {Object}
 * @example
 * var content = fs.readFileSync("~/Picture/IMG_0911.JPG");
 * var exifFragments = IFDHandler(content, 0, true, 8);
 * console.log(exifFragments.value);
 */ var IFDHandler = function IFDHandler(buffer, tagCollection, order, offset) {
                    var entriesNumber = order ? buffer.readUInt16BE(0) : buffer.readUInt16LE(0);
                    if (entriesNumber === 0) return {};
                    var entriesNumberLength = 2;
                    var entries = buffer.slice(entriesNumberLength);
                    var entryLength = 12;
                    // let nextIFDPointerBegin = entriesNumberLength + entryLength * entriesNumber;
                    // let bigNextIFDPointer= buffer.readUInt32BE(nextIFDPointerBegin) ;
                    // let littleNextIFDPointer= buffer.readUInt32LE(nextIFDPointerBegin);
                    // let nextIFDPointer = order ?bigNextIFDPointer:littleNextIFDPointer;
                    var exif = {};
                    var entryCount = 0;
                    for(entryCount; entryCount < entriesNumber; entryCount += 1){
                        var entryBegin = entryCount * entryLength;
                        var entry = entries.slice(entryBegin, entryBegin + entryLength);
                        var tagBegin = 0;
                        var tagLength = 2;
                        var dataFormatBegin = tagBegin + tagLength;
                        var dataFormatLength = 2;
                        var componentsBegin = dataFormatBegin + dataFormatLength;
                        var componentsNumberLength = 4;
                        var dataValueBegin = componentsBegin + componentsNumberLength;
                        var dataValueLength = 4;
                        var tagAddress = entry.slice(tagBegin, dataFormatBegin);
                        var tagNumber = order ? tagAddress.toString('hex') : tagAddress.reverse().toString('hex');
                        var tagName = tagCollection[tagNumber];
                        var bigDataFormat = entry.readUInt16BE(dataFormatBegin);
                        var littleDataFormat = entry.readUInt16LE(dataFormatBegin);
                        var dataFormat = order ? bigDataFormat : littleDataFormat;
                        var componentsByte = bytes[dataFormat];
                        var bigComponentsNumber = entry.readUInt32BE(componentsBegin);
                        var littleComponentNumber = entry.readUInt32LE(componentsBegin);
                        var componentsNumber = order ? bigComponentsNumber : littleComponentNumber;
                        var dataLength = componentsNumber * componentsByte;
                        var dataValue = entry.slice(dataValueBegin, dataValueBegin + dataValueLength);
                        if (dataLength > 4) {
                            var dataOffset = (order ? dataValue.readUInt32BE(0) : dataValue.readUInt32LE(0)) - offset;
                            dataValue = buffer.slice(dataOffset, dataOffset + dataLength);
                        }
                        var tagValue = void 0;
                        if (tagName) {
                            switch(dataFormat){
                                case 1:
                                    tagValue = dataValue.readUInt8(0);
                                    break;
                                case 2:
                                    tagValue = dataValue.toString('ascii').replace(/\0+$/, '');
                                    break;
                                case 3:
                                    tagValue = order ? dataValue.readUInt16BE(0) : dataValue.readUInt16LE(0);
                                    break;
                                case 4:
                                    tagValue = order ? dataValue.readUInt32BE(0) : dataValue.readUInt32LE(0);
                                    break;
                                case 5:
                                    tagValue = [];
                                    for(var i = 0; i < dataValue.length; i += 8){
                                        var bigTagValue = dataValue.readUInt32BE(i) / dataValue.readUInt32BE(i + 4);
                                        var littleTagValue = dataValue.readUInt32LE(i) / dataValue.readUInt32LE(i + 4);
                                        tagValue.push(order ? bigTagValue : littleTagValue);
                                    }
                                    break;
                                case 7:
                                    switch(tagName){
                                        case 'ExifVersion':
                                            tagValue = dataValue.toString();
                                            break;
                                        case 'FlashPixVersion':
                                            tagValue = dataValue.toString();
                                            break;
                                        case 'SceneType':
                                            tagValue = dataValue.readUInt8(0);
                                            break;
                                        default:
                                            tagValue = '0x' + dataValue.toString('hex', 0, 15);
                                            break;
                                    }
                                    break;
                                case 10:
                                    var bigOrder = dataValue.readInt32BE(0) / dataValue.readInt32BE(4);
                                    var littleOrder = dataValue.readInt32LE(0) / dataValue.readInt32LE(4);
                                    tagValue = order ? bigOrder : littleOrder;
                                    break;
                                default:
                                    tagValue = '0x' + dataValue.toString('hex');
                                    break;
                            }
                            exif[tagName] = tagValue;
                        }
                    /*
     else {
     console.log(`Unkown Tag [0x${tagNumber}].`);
     }
     */ }
                    return exif;
                };
                /**
 * @param buf {Buffer}
 * @returns {Undefined}
 * @example
 * var content = fs.readFileSync("~/Picture/IMG_0911.JPG");
 * var exifFragments = EXIFHandler(content);
 */ var EXIFHandler = function EXIFHandler(buf) {
                    var pad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var buffer = buf;
                    if (pad) {
                        buffer = buf.slice(APPMarkerLength);
                        var length = buffer.readUInt16BE(0);
                        buffer = buffer.slice(0, length);
                        var lengthLength = 2;
                        buffer = buffer.slice(lengthLength);
                        var identifierLength = 5;
                        buffer = buffer.slice(identifierLength);
                        var padLength = 1;
                        buffer = buffer.slice(padLength);
                    }
                    var byteOrderLength = 2;
                    var byteOrder = buffer.toString('ascii', 0, byteOrderLength) === 'MM';
                    var fortyTwoLength = 2;
                    var fortyTwoEnd = byteOrderLength + fortyTwoLength;
                    var big42 = buffer.readUInt32BE(fortyTwoEnd);
                    var little42 = buffer.readUInt32LE(fortyTwoEnd);
                    var offsetOfIFD = byteOrder ? big42 : little42;
                    buffer = buffer.slice(offsetOfIFD);
                    if (buffer.length > 0) {
                        data = IFDHandler(buffer, tags.ifd, byteOrder, offsetOfIFD);
                        if (data.ExifIFDPointer) {
                            buffer = buffer.slice(data.ExifIFDPointer - offsetOfIFD);
                            data.SubExif = IFDHandler(buffer, tags.ifd, byteOrder, data.ExifIFDPointer);
                        }
                        if (data.GPSInfoIFDPointer) {
                            var gps = data.GPSInfoIFDPointer;
                            buffer = buffer.slice(data.ExifIFDPointer ? gps - data.ExifIFDPointer : gps - offsetOfIFD);
                            data.GPSInfo = IFDHandler(buffer, tags.gps, byteOrder, gps);
                        }
                    }
                };
                /**
 * @param buffer {Buffer}
 * @returns {Undefined}
 * @example
 * var content = fs.readFileSync("~/Picture/IMG_0911.JPG");
 * var exifFragments = APPnHandler(content);
 */ var APPnHandler = function APPnHandler(buffer) {
                    var APPMarkerTag = checkAPPn(buffer);
                    if (APPMarkerTag !== false) {
                        // APP0 is 0, and 0==false
                        var length = buffer.readUInt16BE(APPMarkerLength);
                        switch(APPMarkerTag){
                            case 1:
                                // EXIF
                                EXIFHandler(buffer);
                                break;
                            default:
                                APPnHandler(buffer.slice(APPMarkerLength + length));
                                break;
                        }
                    }
                };
                /**
 * @param buffer {Buffer}
 * @returns {Object}
 * @example
 */ var fromBuffer = function fromBuffer(buffer) {
                    if (!buffer) throw new Error('buffer not found');
                    data = undefined;
                    if (isValid(buffer)) {
                        buffer = buffer.slice(SOIMarkerLength);
                        data = {};
                        APPnHandler(buffer);
                    } else if (isTiff(buffer)) {
                        data = {};
                        EXIFHandler(buffer, false);
                    }
                    return data;
                };
                /**
 * @param file {String}
 * @returns {Object}
 * @example
 * var exif = sync("~/Picture/IMG_1981.JPG");
 * console.log(exif.createTime);
 */ var sync = function sync(file) {
                    if (!file) throw new Error('File not found');
                    var buffer = _fs2.default.readFileSync(file);
                    return fromBuffer(buffer);
                };
                /**
 * @param file {String}
 * @param callback {Function}
 * @example
 * async("~/Picture/IMG_0707.JPG", (err, data) => {
 *     if(err) {
 *         console.log(err);
 *     }
 *     if(data) {
 *         console.log(data.ExifOffset.createTime);
 *     }
 * }
 */ var async = function async(file, callback) {
                    data = undefined;
                    new Promise(function(resolve, reject) {
                        if (!file) reject(new Error("\u2753File not found."));
                        _fs2.default.readFile(file, function(err, buffer) {
                            if (err) reject(err);
                            else try {
                                if (isValid(buffer)) {
                                    var buf = buffer.slice(SOIMarkerLength);
                                    data = {};
                                    APPnHandler(buf);
                                    resolve(data);
                                } else if (isTiff(buffer)) {
                                    data = {};
                                    EXIFHandler(buffer, false);
                                    resolve(data);
                                } else reject(new Error("\uD83D\uDE31Unsupport file type."));
                            } catch (e) {
                                reject(e);
                            }
                        });
                    }, function(error) {
                        callback(error, undefined);
                    }).then(function(d) {
                        callback(undefined, d);
                    }).catch(function(error) {
                        callback(error, undefined);
                    });
                };
                exports.fromBuffer = fromBuffer;
                exports.parse = async;
                exports.parseSync = sync;
            /***/ },
            /***/ 39081: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var fails = __webpack_require__(47044);
                var isArray = __webpack_require__(59113);
                var isObject = __webpack_require__(24517);
                var toObject = __webpack_require__(43162);
                var lengthOfArrayLike = __webpack_require__(45495);
                var createProperty = __webpack_require__(38639);
                var arraySpeciesCreate = __webpack_require__(45744);
                var arrayMethodHasSpeciesSupport = __webpack_require__(56280);
                var wellKnownSymbol = __webpack_require__(38688);
                var V8_VERSION = __webpack_require__(70091);
                var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
                var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
                var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
                var TypeError1 = global.TypeError;
                // We can't use this feature detection in V8 since it causes
                // deoptimization and serious performance degradation
                // https://github.com/zloirock/core-js/issues/679
                var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function() {
                    var array = [];
                    array[IS_CONCAT_SPREADABLE] = false;
                    return array.concat()[0] !== array;
                });
                var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');
                var isConcatSpreadable = function(O) {
                    if (!isObject(O)) return false;
                    var spreadable = O[IS_CONCAT_SPREADABLE];
                    return spreadable !== undefined ? !!spreadable : isArray(O);
                };
                var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;
                // `Array.prototype.concat` method
                // https://tc39.es/ecma262/#sec-array.prototype.concat
                // with adding support of @@isConcatSpreadable and @@species
                $({
                    target: 'Array',
                    proto: true,
                    forced: FORCED
                }, {
                    // eslint-disable-next-line no-unused-vars -- required for `.length`
                    concat: function concat(arg) {
                        var O = toObject(this);
                        var A = arraySpeciesCreate(O, 0);
                        var n = 0;
                        var i, k, length, len, E;
                        for(i = -1, length = arguments.length; i < length; i++){
                            E = i === -1 ? O : arguments[i];
                            if (isConcatSpreadable(E)) {
                                len = lengthOfArrayLike(E);
                                if (n + len > MAX_SAFE_INTEGER) throw TypeError1(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                                for(k = 0; k < len; k++, n++)if (k in E) createProperty(A, n, E[k]);
                            } else {
                                if (n >= MAX_SAFE_INTEGER) throw TypeError1(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                                createProperty(A, n++, E);
                            }
                        }
                        A.length = n;
                        return A;
                    }
                });
            /***/ },
            /***/ 39599: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(47044);
                var isCallable = __webpack_require__(94578);
                var replacement = /#|\.prototype\./;
                var isForced = function(feature, detection) {
                    var value = data[normalize(feature)];
                    return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
                };
                var normalize = isForced.normalize = function(string) {
                    return String(string).replace(replacement, '.').toLowerCase();
                };
                var data = isForced.data = {};
                var NATIVE = isForced.NATIVE = 'N';
                var POLYFILL = isForced.POLYFILL = 'P';
                module1.exports = isForced;
            /***/ },
            /***/ 39629: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var call = __webpack_require__(2834);
                var isCallable = __webpack_require__(94578);
                var isObject = __webpack_require__(24517);
                var TypeError1 = global.TypeError;
                // `OrdinaryToPrimitive` abstract operation
                // https://tc39.es/ecma262/#sec-ordinarytoprimitive
                module1.exports = function(input, pref) {
                    var fn, val;
                    if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
                    if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                    throw TypeError1("Can't convert object to primitive value");
                };
            /***/ },
            /***/ 40679: /***/ function(module1) {
                "use strict";
                module1.exports = /*#__PURE__*/ JSON.parse('[["0","\\u0000",128],["a1","\uFF61",62],["8140","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7"],["8180","\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["81b8","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["81c8","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["81da","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["81f0","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["81fc","\u25EF"],["824f","\uFF10",9],["8260","\uFF21",25],["8281","\uFF41",25],["829f","\u3041",82],["8340","\u30A1",62],["8380","\u30E0",22],["839f","\u0391",16,"\u03A3",6],["83bf","\u03B1",16,"\u03C3",6],["8440","\u0410",5,"\u0401\u0416",25],["8470","\u0430",5,"\u0451\u0436",7],["8480","\u043E",17],["849f","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["8740","\u2460",19,"\u2160",9],["875f","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["877e","\u337B"],["8780","\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["889f","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["8940","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186"],["8980","\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["8a40","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B"],["8a80","\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["8b40","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551"],["8b80","\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["8c40","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8"],["8c80","\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["8d40","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D"],["8d80","\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["8e40","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62"],["8e80","\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["8f40","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3"],["8f80","\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["9040","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8"],["9080","\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["9140","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB"],["9180","\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["9240","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4"],["9280","\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["9340","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC"],["9380","\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["9440","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885"],["9480","\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["9540","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577"],["9580","\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["9640","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6"],["9680","\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["9740","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32"],["9780","\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["9840","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["989f","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["9940","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED"],["9980","\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["9a40","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638"],["9a80","\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["9b40","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80"],["9b80","\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["9c40","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060"],["9c80","\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["9d40","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B"],["9d80","\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["9e40","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E"],["9e80","\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["9f40","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF"],["9f80","\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["e040","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD"],["e080","\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e140","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF"],["e180","\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e240","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0"],["e280","\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e340","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37"],["e380","\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e440","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264"],["e480","\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e540","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC"],["e580","\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["e640","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7"],["e680","\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["e740","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C"],["e780","\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["e840","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599"],["e880","\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["e940","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43"],["e980","\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["ea40","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF"],["ea80","\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199"],["ed40","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F"],["ed80","\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["ee40","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559"],["ee80","\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["eeef","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["f040","\uE000",62],["f080","\uE03F",124],["f140","\uE0BC",62],["f180","\uE0FB",124],["f240","\uE178",62],["f280","\uE1B7",124],["f340","\uE234",62],["f380","\uE273",124],["f440","\uE2F0",62],["f480","\uE32F",124],["f540","\uE3AC",62],["f580","\uE3EB",124],["f640","\uE468",62],["f680","\uE4A7",124],["f740","\uE524",62],["f780","\uE563",124],["f840","\uE5E0",62],["f880","\uE61F",124],["f940","\uE69C"],["fa40","\u2170",9,"\u2160",9,"\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A"],["fa80","\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F"],["fb40","\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19"],["fb80","\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9"],["fc40","\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"]]');
            /***/ },
            /***/ 40715: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var getBuiltIn = __webpack_require__(38486);
                module1.exports = getBuiltIn('navigator', 'userAgent') || '';
            /***/ },
            /***/ 41201: /***/ function(module1) {
                module1.exports = function isBuffer(arg) {
                    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
                };
            /***/ },
            /***/ 41584: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var fill = __webpack_require__(72864);
                var addToUnscopables = __webpack_require__(71156);
                // `Array.prototype.fill` method
                // https://tc39.es/ecma262/#sec-array.prototype.fill
                $({
                    target: 'Array',
                    proto: true
                }, {
                    fill: fill
                });
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                addToUnscopables('fill');
            /***/ },
            /***/ 41613: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                var clone = function() {
                    'use strict';
                    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/ function clone(parent, circular, depth, prototype) {
                        var filter;
                        if (typeof circular === 'object') {
                            depth = circular.depth;
                            prototype = circular.prototype;
                            filter = circular.filter;
                            circular = circular.circular;
                        }
                        // maintain two arrays for circular references, where corresponding parents
                        // and children have the same index
                        var allParents = [];
                        var allChildren = [];
                        var useBuffer = typeof Buffer != 'undefined';
                        if (typeof circular == 'undefined') circular = true;
                        if (typeof depth == 'undefined') depth = Infinity;
                        // recurse this function so we don't reset allParents and allChildren
                        function _clone(parent, depth) {
                            // cloning null always returns null
                            if (parent === null) return null;
                            if (depth == 0) return parent;
                            var child;
                            var proto;
                            if (typeof parent != 'object') return parent;
                            if (clone.__isArray(parent)) child = [];
                            else if (clone.__isRegExp(parent)) {
                                child = new RegExp(parent.source, __getRegExpFlags(parent));
                                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
                            else if (useBuffer && Buffer.isBuffer(parent)) {
                                if (Buffer.allocUnsafe) // Node.js >= 4.5.0
                                child = Buffer.allocUnsafe(parent.length);
                                else // Older Node.js versions
                                child = new Buffer(parent.length);
                                parent.copy(child);
                                return child;
                            } else if (typeof prototype == 'undefined') {
                                proto = Object.getPrototypeOf(parent);
                                child = Object.create(proto);
                            } else {
                                child = Object.create(prototype);
                                proto = prototype;
                            }
                            if (circular) {
                                var index = allParents.indexOf(parent);
                                if (index != -1) return allChildren[index];
                                allParents.push(parent);
                                allChildren.push(child);
                            }
                            for(var i in parent){
                                var attrs;
                                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                                if (attrs && attrs.set == null) continue;
                                child[i] = _clone(parent[i], depth - 1);
                            }
                            return child;
                        }
                        return _clone(parent, depth);
                    }
                    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
                        if (parent === null) return null;
                        var c = function() {};
                        c.prototype = parent;
                        return new c();
                    };
                    // private utility functions
                    function __objToStr(o) {
                        return Object.prototype.toString.call(o);
                    }
                    clone.__objToStr = __objToStr;
                    function __isDate(o) {
                        return typeof o === 'object' && __objToStr(o) === '[object Date]';
                    }
                    clone.__isDate = __isDate;
                    function __isArray(o) {
                        return typeof o === 'object' && __objToStr(o) === '[object Array]';
                    }
                    clone.__isArray = __isArray;
                    function __isRegExp(o) {
                        return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
                    }
                    clone.__isRegExp = __isRegExp;
                    function __getRegExpFlags(re) {
                        var flags = '';
                        if (re.global) flags += 'g';
                        if (re.ignoreCase) flags += 'i';
                        if (re.multiline) flags += 'm';
                        return flags;
                    }
                    clone.__getRegExpFlags = __getRegExpFlags;
                    return clone;
                }();
                if (0, module1.exports) module1.exports = clone;
            /***/ },
            /***/ 41731: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var userAgent = __webpack_require__(40715);
                var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
                module1.exports = !!webkit && +webkit[1];
            /***/ },
            /***/ 42075: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                __webpack_require__(94910);
                __webpack_require__(81755);
                __webpack_require__(14032);
                __webpack_require__(68067);
                __webpack_require__(77074);
                __webpack_require__(44455);
                __webpack_require__(80986);
                __webpack_require__(58281);
                var path = __webpack_require__(11206);
                module1.exports = path.Promise;
            /***/ },
            /***/ 42210: /***/ function(__unused_webpack_module, exports) {
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/ /* Represents the range of values belonging to a prefix code: */ /* [offset, offset + 2^nbits) */ function PrefixCodeRange(offset, nbits) {
                    this.offset = offset;
                    this.nbits = nbits;
                }
                exports.kBlockLengthPrefixCode = [
                    new PrefixCodeRange(1, 2),
                    new PrefixCodeRange(5, 2),
                    new PrefixCodeRange(9, 2),
                    new PrefixCodeRange(13, 2),
                    new PrefixCodeRange(17, 3),
                    new PrefixCodeRange(25, 3),
                    new PrefixCodeRange(33, 3),
                    new PrefixCodeRange(41, 3),
                    new PrefixCodeRange(49, 4),
                    new PrefixCodeRange(65, 4),
                    new PrefixCodeRange(81, 4),
                    new PrefixCodeRange(97, 4),
                    new PrefixCodeRange(113, 5),
                    new PrefixCodeRange(145, 5),
                    new PrefixCodeRange(177, 5),
                    new PrefixCodeRange(209, 5),
                    new PrefixCodeRange(241, 6),
                    new PrefixCodeRange(305, 6),
                    new PrefixCodeRange(369, 7),
                    new PrefixCodeRange(497, 8),
                    new PrefixCodeRange(753, 9),
                    new PrefixCodeRange(1265, 10),
                    new PrefixCodeRange(2289, 11),
                    new PrefixCodeRange(4337, 12),
                    new PrefixCodeRange(8433, 13),
                    new PrefixCodeRange(16625, 24)
                ];
                exports.kInsertLengthPrefixCode = [
                    new PrefixCodeRange(0, 0),
                    new PrefixCodeRange(1, 0),
                    new PrefixCodeRange(2, 0),
                    new PrefixCodeRange(3, 0),
                    new PrefixCodeRange(4, 0),
                    new PrefixCodeRange(5, 0),
                    new PrefixCodeRange(6, 1),
                    new PrefixCodeRange(8, 1),
                    new PrefixCodeRange(10, 2),
                    new PrefixCodeRange(14, 2),
                    new PrefixCodeRange(18, 3),
                    new PrefixCodeRange(26, 3),
                    new PrefixCodeRange(34, 4),
                    new PrefixCodeRange(50, 4),
                    new PrefixCodeRange(66, 5),
                    new PrefixCodeRange(98, 5),
                    new PrefixCodeRange(130, 6),
                    new PrefixCodeRange(194, 7),
                    new PrefixCodeRange(322, 8),
                    new PrefixCodeRange(578, 9),
                    new PrefixCodeRange(1090, 10),
                    new PrefixCodeRange(2114, 12),
                    new PrefixCodeRange(6210, 14),
                    new PrefixCodeRange(22594, 24)
                ];
                exports.kCopyLengthPrefixCode = [
                    new PrefixCodeRange(2, 0),
                    new PrefixCodeRange(3, 0),
                    new PrefixCodeRange(4, 0),
                    new PrefixCodeRange(5, 0),
                    new PrefixCodeRange(6, 0),
                    new PrefixCodeRange(7, 0),
                    new PrefixCodeRange(8, 0),
                    new PrefixCodeRange(9, 0),
                    new PrefixCodeRange(10, 1),
                    new PrefixCodeRange(12, 1),
                    new PrefixCodeRange(14, 2),
                    new PrefixCodeRange(18, 2),
                    new PrefixCodeRange(22, 3),
                    new PrefixCodeRange(30, 3),
                    new PrefixCodeRange(38, 4),
                    new PrefixCodeRange(54, 4),
                    new PrefixCodeRange(70, 5),
                    new PrefixCodeRange(102, 5),
                    new PrefixCodeRange(134, 6),
                    new PrefixCodeRange(198, 7),
                    new PrefixCodeRange(326, 8),
                    new PrefixCodeRange(582, 9),
                    new PrefixCodeRange(1094, 10),
                    new PrefixCodeRange(2118, 24)
                ];
                exports.kInsertRangeLut = [
                    0,
                    0,
                    8,
                    8,
                    0,
                    16,
                    8,
                    16,
                    16
                ];
                exports.kCopyRangeLut = [
                    0,
                    8,
                    0,
                    8,
                    16,
                    0,
                    16,
                    8,
                    16
                ];
            /***/ },
            /***/ 42437: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var DOMIterables = __webpack_require__(23327);
                var DOMTokenListPrototype = __webpack_require__(67797);
                var forEach = __webpack_require__(82938);
                var createNonEnumerableProperty = __webpack_require__(48914);
                var handlePrototype = function(CollectionPrototype) {
                    // some Chrome versions have non-configurable methods on DOMTokenList
                    if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
                        createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
                    } catch (error) {
                        CollectionPrototype.forEach = forEach;
                    }
                };
                for(var COLLECTION_NAME in DOMIterables)if (DOMIterables[COLLECTION_NAME]) handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
                handlePrototype(DOMTokenListPrototype);
            /***/ },
            /***/ 42526: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /*eslint no-unused-vars: ["error", {"args": "none"}]*/ var TextTools = __webpack_require__(11548);
                var StyleContextStack = __webpack_require__(76442);
                var ColumnCalculator = __webpack_require__(77530);
                var isString = __webpack_require__(91867).isString;
                var isNumber = __webpack_require__(91867).isNumber;
                var isObject = __webpack_require__(91867).isObject;
                var isArray = __webpack_require__(91867).isArray;
                var fontStringify = __webpack_require__(91867).fontStringify;
                var getNodeId = __webpack_require__(91867).getNodeId;
                var pack = __webpack_require__(91867).pack;
                var qrEncoder = __webpack_require__(72155);
                /**
 * @private
 */ function DocMeasure(fontProvider, styleDictionary, defaultStyle, imageMeasure, svgMeasure, tableLayouts, images) {
                    this.textTools = new TextTools(fontProvider);
                    this.styleStack = new StyleContextStack(styleDictionary, defaultStyle);
                    this.imageMeasure = imageMeasure;
                    this.svgMeasure = svgMeasure;
                    this.tableLayouts = tableLayouts;
                    this.images = images;
                    this.autoImageIndex = 1;
                }
                /**
 * Measures all nodes and sets min/max-width properties required for the second
 * layout-pass.
 * @param  {Object} docStructure document-definition-object
 * @return {Object}              document-measurement-object
 */ DocMeasure.prototype.measureDocument = function(docStructure) {
                    return this.measureNode(docStructure);
                };
                DocMeasure.prototype.measureNode = function(node) {
                    var self1 = this;
                    return this.styleStack.auto(node, function() {
                        // TODO: refactor + rethink whether this is the proper way to handle margins
                        node._margin = getNodeMargin(node);
                        if (node.columns) return extendMargins(self1.measureColumns(node));
                        else if (node.stack) return extendMargins(self1.measureVerticalContainer(node));
                        else if (node.ul) return extendMargins(self1.measureUnorderedList(node));
                        else if (node.ol) return extendMargins(self1.measureOrderedList(node));
                        else if (node.table) return extendMargins(self1.measureTable(node));
                        else if (node.text !== undefined) return extendMargins(self1.measureLeaf(node));
                        else if (node.toc) return extendMargins(self1.measureToc(node));
                        else if (node.image) return extendMargins(self1.measureImage(node));
                        else if (node.svg) return extendMargins(self1.measureSVG(node));
                        else if (node.canvas) return extendMargins(self1.measureCanvas(node));
                        else if (node.qr) return extendMargins(self1.measureQr(node));
                        else throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
                    });
                    function extendMargins(node) {
                        var margin = node._margin;
                        if (margin) {
                            node._minWidth += margin[0] + margin[2];
                            node._maxWidth += margin[0] + margin[2];
                        }
                        return node;
                    }
                    function getNodeMargin() {
                        function processSingleMargins(node, currentMargin) {
                            if (node.marginLeft || node.marginTop || node.marginRight || node.marginBottom) return [
                                node.marginLeft || currentMargin[0] || 0,
                                node.marginTop || currentMargin[1] || 0,
                                node.marginRight || currentMargin[2] || 0,
                                node.marginBottom || currentMargin[3] || 0
                            ];
                            return currentMargin;
                        }
                        function flattenStyleArray(styleArray) {
                            var flattenedStyles = {};
                            for(var i = styleArray.length - 1; i >= 0; i--){
                                var styleName = styleArray[i];
                                var style = self1.styleStack.styleDictionary[styleName];
                                for(var key in style)if (style.hasOwnProperty(key)) flattenedStyles[key] = style[key];
                            }
                            return flattenedStyles;
                        }
                        function convertMargin(margin) {
                            if (isNumber(margin)) margin = [
                                margin,
                                margin,
                                margin,
                                margin
                            ];
                            else if (isArray(margin)) {
                                if (margin.length === 2) margin = [
                                    margin[0],
                                    margin[1],
                                    margin[0],
                                    margin[1]
                                ];
                            }
                            return margin;
                        }
                        var margin = [
                            undefined,
                            undefined,
                            undefined,
                            undefined
                        ];
                        if (node.style) {
                            var styleArray = isArray(node.style) ? node.style : [
                                node.style
                            ];
                            var flattenedStyleArray = flattenStyleArray(styleArray);
                            if (flattenedStyleArray) margin = processSingleMargins(flattenedStyleArray, margin);
                            if (flattenedStyleArray.margin) margin = convertMargin(flattenedStyleArray.margin);
                        }
                        margin = processSingleMargins(node, margin);
                        if (node.margin) margin = convertMargin(node.margin);
                        if (margin[0] === undefined && margin[1] === undefined && margin[2] === undefined && margin[3] === undefined) return null;
                        else return margin;
                    }
                };
                DocMeasure.prototype.convertIfBase64Image = function(node) {
                    if (/^data:image\/(jpeg|jpg|png);base64,/.test(node.image)) {
                        var label = '$$pdfmake$$' + this.autoImageIndex++;
                        this.images[label] = node.image;
                        node.image = label;
                    }
                };
                DocMeasure.prototype.measureImageWithDimensions = function(node, dimensions) {
                    if (node.fit) {
                        var factor = dimensions.width / dimensions.height > node.fit[0] / node.fit[1] ? node.fit[0] / dimensions.width : node.fit[1] / dimensions.height;
                        node._width = node._minWidth = node._maxWidth = dimensions.width * factor;
                        node._height = dimensions.height * factor;
                    } else if (node.cover) {
                        node._width = node._minWidth = node._maxWidth = node.cover.width;
                        node._height = node._minHeight = node._maxHeight = node.cover.height;
                    } else {
                        node._width = node._minWidth = node._maxWidth = node.width || dimensions.width;
                        node._height = node.height || dimensions.height * node._width / dimensions.width;
                        if (isNumber(node.maxWidth) && node.maxWidth < node._width) {
                            node._width = node._minWidth = node._maxWidth = node.maxWidth;
                            node._height = node._width * dimensions.height / dimensions.width;
                        }
                        if (isNumber(node.maxHeight) && node.maxHeight < node._height) {
                            node._height = node.maxHeight;
                            node._width = node._minWidth = node._maxWidth = node._height * dimensions.width / dimensions.height;
                        }
                        if (isNumber(node.minWidth) && node.minWidth > node._width) {
                            node._width = node._minWidth = node._maxWidth = node.minWidth;
                            node._height = node._width * dimensions.height / dimensions.width;
                        }
                        if (isNumber(node.minHeight) && node.minHeight > node._height) {
                            node._height = node.minHeight;
                            node._width = node._minWidth = node._maxWidth = node._height * dimensions.width / dimensions.height;
                        }
                    }
                    node._alignment = this.styleStack.getProperty('alignment');
                };
                DocMeasure.prototype.measureImage = function(node) {
                    if (this.images) this.convertIfBase64Image(node);
                    var dimensions = this.imageMeasure.measureImage(node.image);
                    this.measureImageWithDimensions(node, dimensions);
                    return node;
                };
                DocMeasure.prototype.measureSVG = function(node) {
                    var dimensions = this.svgMeasure.measureSVG(node.svg);
                    this.measureImageWithDimensions(node, dimensions);
                    node.font = this.styleStack.getProperty('font');
                    // scale SVG based on final dimension
                    node.svg = this.svgMeasure.writeDimensions(node.svg, {
                        width: node._width,
                        height: node._height
                    });
                    return node;
                };
                DocMeasure.prototype.measureLeaf = function(node) {
                    if (node._textRef && node._textRef._textNodeRef.text) node.text = node._textRef._textNodeRef.text;
                    // Make sure style properties of the node itself are considered when building inlines.
                    // We could also just pass [node] to buildInlines, but that fails for bullet points.
                    var styleStack = this.styleStack.clone();
                    styleStack.push(node);
                    var data = this.textTools.buildInlines(node.text, styleStack);
                    node._inlines = data.items;
                    node._minWidth = data.minWidth;
                    node._maxWidth = data.maxWidth;
                    return node;
                };
                DocMeasure.prototype.measureToc = function(node) {
                    if (node.toc.title) node.toc.title = this.measureNode(node.toc.title);
                    if (node.toc._items.length > 0) {
                        var body = [];
                        var textStyle = node.toc.textStyle || {};
                        var numberStyle = node.toc.numberStyle || textStyle;
                        var textMargin = node.toc.textMargin || [
                            0,
                            0,
                            0,
                            0
                        ];
                        for(var i = 0, l = node.toc._items.length; i < l; i++){
                            var item = node.toc._items[i];
                            var lineStyle = item._textNodeRef.tocStyle || textStyle;
                            var lineMargin = item._textNodeRef.tocMargin || textMargin;
                            var lineNumberStyle = item._textNodeRef.tocNumberStyle || numberStyle;
                            var destination = getNodeId(item._nodeRef);
                            body.push([
                                {
                                    text: item._textNodeRef.text,
                                    linkToDestination: destination,
                                    alignment: 'left',
                                    style: lineStyle,
                                    margin: lineMargin
                                },
                                {
                                    text: '00000',
                                    linkToDestination: destination,
                                    alignment: 'right',
                                    _tocItemRef: item._nodeRef,
                                    style: lineNumberStyle,
                                    margin: [
                                        0,
                                        lineMargin[1],
                                        0,
                                        lineMargin[3]
                                    ]
                                }
                            ]);
                        }
                        node.toc._table = {
                            table: {
                                dontBreakRows: true,
                                widths: [
                                    '*',
                                    'auto'
                                ],
                                body: body
                            },
                            layout: 'noBorders'
                        };
                        node.toc._table = this.measureNode(node.toc._table);
                    }
                    return node;
                };
                DocMeasure.prototype.measureVerticalContainer = function(node) {
                    var items = node.stack;
                    node._minWidth = 0;
                    node._maxWidth = 0;
                    for(var i = 0, l = items.length; i < l; i++){
                        items[i] = this.measureNode(items[i]);
                        node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
                        node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);
                    }
                    return node;
                };
                DocMeasure.prototype.gapSizeForList = function() {
                    return this.textTools.sizeOfString('9. ', this.styleStack);
                };
                DocMeasure.prototype.buildUnorderedMarker = function(styleStack, gapSize, type) {
                    function buildDisc(gapSize, color) {
                        // TODO: ascender-based calculations
                        var radius = gapSize.fontSize / 6;
                        return {
                            canvas: [
                                {
                                    x: radius,
                                    y: gapSize.height / gapSize.lineHeight + gapSize.descender - gapSize.fontSize / 3,
                                    r1: radius,
                                    r2: radius,
                                    type: 'ellipse',
                                    color: color
                                }
                            ]
                        };
                    }
                    function buildSquare(gapSize, color) {
                        // TODO: ascender-based calculations
                        var size = gapSize.fontSize / 3;
                        return {
                            canvas: [
                                {
                                    x: 0,
                                    y: gapSize.height / gapSize.lineHeight + gapSize.descender - gapSize.fontSize / 3 - size / 2,
                                    h: size,
                                    w: size,
                                    type: 'rect',
                                    color: color
                                }
                            ]
                        };
                    }
                    function buildCircle(gapSize, color) {
                        // TODO: ascender-based calculations
                        var radius = gapSize.fontSize / 6;
                        return {
                            canvas: [
                                {
                                    x: radius,
                                    y: gapSize.height / gapSize.lineHeight + gapSize.descender - gapSize.fontSize / 3,
                                    r1: radius,
                                    r2: radius,
                                    type: 'ellipse',
                                    lineColor: color
                                }
                            ]
                        };
                    }
                    var marker;
                    var color = styleStack.getProperty('markerColor') || styleStack.getProperty('color') || 'black';
                    switch(type){
                        case 'circle':
                            marker = buildCircle(gapSize, color);
                            break;
                        case 'square':
                            marker = buildSquare(gapSize, color);
                            break;
                        case 'none':
                            marker = {};
                            break;
                        case 'disc':
                        default:
                            marker = buildDisc(gapSize, color);
                            break;
                    }
                    marker._minWidth = marker._maxWidth = gapSize.width;
                    marker._minHeight = marker._maxHeight = gapSize.height;
                    return marker;
                };
                DocMeasure.prototype.buildOrderedMarker = function(counter, styleStack, type, separator) {
                    function prepareAlpha(counter) {
                        function toAlpha(num) {
                            return (num >= 26 ? toAlpha((num / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[num % 26 >> 0];
                        }
                        if (counter < 1) return counter.toString();
                        return toAlpha(counter - 1);
                    }
                    function prepareRoman(counter) {
                        if (counter < 1 || counter > 4999) return counter.toString();
                        var num = counter;
                        var lookup = {
                            M: 1000,
                            CM: 900,
                            D: 500,
                            CD: 400,
                            C: 100,
                            XC: 90,
                            L: 50,
                            XL: 40,
                            X: 10,
                            IX: 9,
                            V: 5,
                            IV: 4,
                            I: 1
                        }, roman = '', i;
                        for(i in lookup)while(num >= lookup[i]){
                            roman += i;
                            num -= lookup[i];
                        }
                        return roman;
                    }
                    function prepareDecimal(counter) {
                        return counter.toString();
                    }
                    var counterText;
                    switch(type){
                        case 'none':
                            counterText = null;
                            break;
                        case 'upper-alpha':
                            counterText = prepareAlpha(counter).toUpperCase();
                            break;
                        case 'lower-alpha':
                            counterText = prepareAlpha(counter);
                            break;
                        case 'upper-roman':
                            counterText = prepareRoman(counter);
                            break;
                        case 'lower-roman':
                            counterText = prepareRoman(counter).toLowerCase();
                            break;
                        case 'decimal':
                        default:
                            counterText = prepareDecimal(counter);
                            break;
                    }
                    if (counterText === null) return {};
                    if (separator) {
                        if (isArray(separator)) {
                            if (separator[0]) counterText = separator[0] + counterText;
                            if (separator[1]) counterText += separator[1];
                            counterText += ' ';
                        } else counterText += separator + ' ';
                    }
                    var textArray = {
                        text: counterText
                    };
                    var markerColor = styleStack.getProperty('markerColor');
                    if (markerColor) textArray.color = markerColor;
                    return {
                        _inlines: this.textTools.buildInlines(textArray, styleStack).items
                    };
                };
                DocMeasure.prototype.measureUnorderedList = function(node) {
                    var style = this.styleStack.clone();
                    var items = node.ul;
                    node.type = node.type || 'disc';
                    node._gapSize = this.gapSizeForList();
                    node._minWidth = 0;
                    node._maxWidth = 0;
                    for(var i = 0, l = items.length; i < l; i++){
                        var item = items[i] = this.measureNode(items[i]);
                        if (!item.ol && !item.ul) item.listMarker = this.buildUnorderedMarker(style, node._gapSize, item.listType || node.type);
                        node._minWidth = Math.max(node._minWidth, items[i]._minWidth + node._gapSize.width);
                        node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth + node._gapSize.width);
                    }
                    return node;
                };
                DocMeasure.prototype.measureOrderedList = function(node) {
                    var style = this.styleStack.clone();
                    var items = node.ol;
                    node.type = node.type || 'decimal';
                    node.separator = node.separator || '.';
                    node.reversed = node.reversed || false;
                    if (!isNumber(node.start)) node.start = node.reversed ? items.length : 1;
                    node._gapSize = this.gapSizeForList();
                    node._minWidth = 0;
                    node._maxWidth = 0;
                    var counter = node.start;
                    for(var i = 0, l = items.length; i < l; i++){
                        var item = items[i] = this.measureNode(items[i]);
                        if (!item.ol && !item.ul) {
                            var counterValue = isNumber(item.counter) ? item.counter : counter;
                            item.listMarker = this.buildOrderedMarker(counterValue, style, item.listType || node.type, node.separator);
                            if (item.listMarker._inlines) node._gapSize.width = Math.max(node._gapSize.width, item.listMarker._inlines[0].width);
                            if (node.reversed) counter--;
                            else counter++;
                        }
                        node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
                        node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);
                    }
                    node._minWidth += node._gapSize.width;
                    node._maxWidth += node._gapSize.width;
                    for(var i = 0, l = items.length; i < l; i++){
                        var item = items[i];
                        if (!item.ol && !item.ul) item.listMarker._minWidth = item.listMarker._maxWidth = node._gapSize.width;
                    }
                    return node;
                };
                DocMeasure.prototype.measureColumns = function(node) {
                    var columns = node.columns;
                    node._gap = this.styleStack.getProperty('columnGap') || 0;
                    for(var i = 0, l = columns.length; i < l; i++)columns[i] = this.measureNode(columns[i]);
                    var measures = ColumnCalculator.measureMinMax(columns);
                    var numGaps = columns.length > 0 ? columns.length - 1 : 0;
                    node._minWidth = measures.min + node._gap * numGaps;
                    node._maxWidth = measures.max + node._gap * numGaps;
                    return node;
                };
                DocMeasure.prototype.measureTable = function(node) {
                    extendTableWidths(node);
                    node._layout = getLayout(this.tableLayouts);
                    node._offsets = getOffsets(node._layout);
                    var colSpans = [];
                    var col, row, cols, rows;
                    for(col = 0, cols = node.table.body[0].length; col < cols; col++){
                        var c = node.table.widths[col];
                        c._minWidth = 0;
                        c._maxWidth = 0;
                        for(row = 0, rows = node.table.body.length; row < rows; row++){
                            var rowData = node.table.body[row];
                            var data = rowData[col];
                            if (data === undefined) {
                                console.error('Malformed table row ', rowData, 'in node ', node);
                                throw 'Malformed table row, a cell is undefined.';
                            }
                            if (data === null) data = '';
                            if (!data._span) {
                                data = rowData[col] = this.styleStack.auto(data, measureCb(this, data));
                                if (data.colSpan && data.colSpan > 1) {
                                    markSpans(rowData, col, data.colSpan);
                                    colSpans.push({
                                        col: col,
                                        span: data.colSpan,
                                        minWidth: data._minWidth,
                                        maxWidth: data._maxWidth
                                    });
                                } else {
                                    c._minWidth = Math.max(c._minWidth, data._minWidth);
                                    c._maxWidth = Math.max(c._maxWidth, data._maxWidth);
                                }
                            }
                            if (data.rowSpan && data.rowSpan > 1) markVSpans(node.table, row, col, data.rowSpan);
                        }
                    }
                    extendWidthsForColSpans();
                    var measures = ColumnCalculator.measureMinMax(node.table.widths);
                    node._minWidth = measures.min + node._offsets.total;
                    node._maxWidth = measures.max + node._offsets.total;
                    return node;
                    function measureCb(_this, data) {
                        return function() {
                            if (isObject(data)) {
                                data.fillColor = _this.styleStack.getProperty('fillColor');
                                data.fillOpacity = _this.styleStack.getProperty('fillOpacity');
                            }
                            return _this.measureNode(data);
                        };
                    }
                    function getLayout(tableLayouts) {
                        var layout = node.layout;
                        if (isString(layout)) layout = tableLayouts[layout];
                        var defaultLayout = {
                            hLineWidth: function(i, node) {
                                return 1;
                            },
                            vLineWidth: function(i, node) {
                                return 1;
                            },
                            hLineColor: function(i, node) {
                                return 'black';
                            },
                            vLineColor: function(i, node) {
                                return 'black';
                            },
                            hLineStyle: function(i, node) {
                                return null;
                            },
                            vLineStyle: function(i, node) {
                                return null;
                            },
                            paddingLeft: function(i, node) {
                                return 4;
                            },
                            paddingRight: function(i, node) {
                                return 4;
                            },
                            paddingTop: function(i, node) {
                                return 2;
                            },
                            paddingBottom: function(i, node) {
                                return 2;
                            },
                            fillColor: function(i, node) {
                                return null;
                            },
                            fillOpacity: function(i, node) {
                                return 1;
                            },
                            defaultBorder: true
                        };
                        return pack(defaultLayout, layout);
                    }
                    function getOffsets(layout) {
                        var offsets = [];
                        var totalOffset = 0;
                        var prevRightPadding = 0;
                        for(var i = 0, l = node.table.widths.length; i < l; i++){
                            var lOffset = prevRightPadding + layout.vLineWidth(i, node) + layout.paddingLeft(i, node);
                            offsets.push(lOffset);
                            totalOffset += lOffset;
                            prevRightPadding = layout.paddingRight(i, node);
                        }
                        totalOffset += prevRightPadding + layout.vLineWidth(node.table.widths.length, node);
                        return {
                            total: totalOffset,
                            offsets: offsets
                        };
                    }
                    function extendWidthsForColSpans() {
                        var q, j;
                        for(var i = 0, l = colSpans.length; i < l; i++){
                            var span = colSpans[i];
                            var currentMinMax = getMinMax(span.col, span.span, node._offsets);
                            var minDifference = span.minWidth - currentMinMax.minWidth;
                            var maxDifference = span.maxWidth - currentMinMax.maxWidth;
                            if (minDifference > 0) {
                                q = minDifference / span.span;
                                for(j = 0; j < span.span; j++)node.table.widths[span.col + j]._minWidth += q;
                            }
                            if (maxDifference > 0) {
                                q = maxDifference / span.span;
                                for(j = 0; j < span.span; j++)node.table.widths[span.col + j]._maxWidth += q;
                            }
                        }
                    }
                    function getMinMax(col, span, offsets) {
                        var result = {
                            minWidth: 0,
                            maxWidth: 0
                        };
                        for(var i = 0; i < span; i++){
                            result.minWidth += node.table.widths[col + i]._minWidth + (i ? offsets.offsets[col + i] : 0);
                            result.maxWidth += node.table.widths[col + i]._maxWidth + (i ? offsets.offsets[col + i] : 0);
                        }
                        return result;
                    }
                    function markSpans(rowData, col, span) {
                        for(var i = 1; i < span; i++)rowData[col + i] = {
                            _span: true,
                            _minWidth: 0,
                            _maxWidth: 0,
                            rowSpan: rowData[col].rowSpan
                        };
                    }
                    function markVSpans(table, row, col, span) {
                        for(var i = 1; i < span; i++)table.body[row + i][col] = {
                            _span: true,
                            _minWidth: 0,
                            _maxWidth: 0,
                            fillColor: table.body[row][col].fillColor,
                            fillOpacity: table.body[row][col].fillOpacity
                        };
                    }
                    function extendTableWidths(node) {
                        if (!node.table.widths) node.table.widths = 'auto';
                        if (isString(node.table.widths)) {
                            node.table.widths = [
                                node.table.widths
                            ];
                            while(node.table.widths.length < node.table.body[0].length)node.table.widths.push(node.table.widths[node.table.widths.length - 1]);
                        }
                        for(var i = 0, l = node.table.widths.length; i < l; i++){
                            var w = node.table.widths[i];
                            if (isNumber(w) || isString(w)) node.table.widths[i] = {
                                width: w
                            };
                        }
                    }
                };
                DocMeasure.prototype.measureCanvas = function(node) {
                    var w = 0, h = 0;
                    for(var i = 0, l = node.canvas.length; i < l; i++){
                        var vector = node.canvas[i];
                        switch(vector.type){
                            case 'ellipse':
                                w = Math.max(w, vector.x + vector.r1);
                                h = Math.max(h, vector.y + vector.r2);
                                break;
                            case 'rect':
                                w = Math.max(w, vector.x + vector.w);
                                h = Math.max(h, vector.y + vector.h);
                                break;
                            case 'line':
                                w = Math.max(w, vector.x1, vector.x2);
                                h = Math.max(h, vector.y1, vector.y2);
                                break;
                            case 'polyline':
                                for(var i2 = 0, l2 = vector.points.length; i2 < l2; i2++){
                                    w = Math.max(w, vector.points[i2].x);
                                    h = Math.max(h, vector.points[i2].y);
                                }
                                break;
                        }
                    }
                    node._minWidth = node._maxWidth = w;
                    node._minHeight = node._maxHeight = h;
                    node._alignment = this.styleStack.getProperty('alignment');
                    return node;
                };
                DocMeasure.prototype.measureQr = function(node) {
                    node = qrEncoder.measure(node);
                    node._alignment = this.styleStack.getProperty('alignment');
                    return node;
                };
                module1.exports = DocMeasure;
            /***/ },
            /***/ 43143: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                /*<replacement>*/ var Buffer = __webpack_require__(11432).Buffer;
                /*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
                    encoding = '' + encoding;
                    switch(encoding && encoding.toLowerCase()){
                        case 'hex':
                        case 'utf8':
                        case 'utf-8':
                        case 'ascii':
                        case 'binary':
                        case 'base64':
                        case 'ucs2':
                        case 'ucs-2':
                        case 'utf16le':
                        case 'utf-16le':
                        case 'raw':
                            return true;
                        default:
                            return false;
                    }
                };
                function _normalizeEncoding(enc) {
                    if (!enc) return 'utf8';
                    var retried;
                    while(true)switch(enc){
                        case 'utf8':
                        case 'utf-8':
                            return 'utf8';
                        case 'ucs2':
                        case 'ucs-2':
                        case 'utf16le':
                        case 'utf-16le':
                            return 'utf16le';
                        case 'latin1':
                        case 'binary':
                            return 'latin1';
                        case 'base64':
                        case 'ascii':
                        case 'hex':
                            return enc;
                        default:
                            if (retried) return; // undefined
                            enc = ('' + enc).toLowerCase();
                            retried = true;
                    }
                }
                // Do not cache `Buffer.isEncoding` when checking encoding names as some
                // modules monkey-patch it to support additional encodings
                function normalizeEncoding(enc) {
                    var nenc = _normalizeEncoding(enc);
                    if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
                    return nenc || enc;
                }
                // StringDecoder provides an interface for efficiently splitting a series of
                // buffers into a series of JS strings without breaking apart multi-byte
                // characters.
                exports.I = StringDecoder;
                function StringDecoder(encoding) {
                    this.encoding = normalizeEncoding(encoding);
                    var nb;
                    switch(this.encoding){
                        case 'utf16le':
                            this.text = utf16Text;
                            this.end = utf16End;
                            nb = 4;
                            break;
                        case 'utf8':
                            this.fillLast = utf8FillLast;
                            nb = 4;
                            break;
                        case 'base64':
                            this.text = base64Text;
                            this.end = base64End;
                            nb = 3;
                            break;
                        default:
                            this.write = simpleWrite;
                            this.end = simpleEnd;
                            return;
                    }
                    this.lastNeed = 0;
                    this.lastTotal = 0;
                    this.lastChar = Buffer.allocUnsafe(nb);
                }
                StringDecoder.prototype.write = function(buf) {
                    if (buf.length === 0) return '';
                    var r;
                    var i;
                    if (this.lastNeed) {
                        r = this.fillLast(buf);
                        if (r === undefined) return '';
                        i = this.lastNeed;
                        this.lastNeed = 0;
                    } else i = 0;
                    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
                    return r || '';
                };
                StringDecoder.prototype.end = utf8End;
                // Returns only complete characters in a Buffer
                StringDecoder.prototype.text = utf8Text;
                // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
                StringDecoder.prototype.fillLast = function(buf) {
                    if (this.lastNeed <= buf.length) {
                        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
                        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    }
                    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
                    this.lastNeed -= buf.length;
                };
                // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
                // continuation byte. If an invalid byte is detected, -2 is returned.
                function utf8CheckByte(byte) {
                    if (byte <= 0x7F) return 0;
                    else if (byte >> 5 === 0x06) return 2;
                    else if (byte >> 4 === 0x0E) return 3;
                    else if (byte >> 3 === 0x1E) return 4;
                    return byte >> 6 === 0x02 ? -1 : -2;
                }
                // Checks at most 3 bytes at the end of a Buffer in order to detect an
                // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
                // needed to complete the UTF-8 character (if applicable) are returned.
                function utf8CheckIncomplete(self1, buf, i) {
                    var j = buf.length - 1;
                    if (j < i) return 0;
                    var nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) self1.lastNeed = nb - 1;
                        return nb;
                    }
                    if (--j < i || nb === -2) return 0;
                    nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) self1.lastNeed = nb - 2;
                        return nb;
                    }
                    if (--j < i || nb === -2) return 0;
                    nb = utf8CheckByte(buf[j]);
                    if (nb >= 0) {
                        if (nb > 0) {
                            if (nb === 2) nb = 0;
                            else self1.lastNeed = nb - 3;
                        }
                        return nb;
                    }
                    return 0;
                }
                // Validates as many continuation bytes for a multi-byte UTF-8 character as
                // needed or are available. If we see a non-continuation byte where we expect
                // one, we "replace" the validated continuation bytes we've seen so far with
                // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
                // behavior. The continuation byte check is included three times in the case
                // where all of the continuation bytes for a character exist in the same buffer.
                // It is also done this way as a slight performance increase instead of using a
                // loop.
                function utf8CheckExtraBytes(self1, buf, p) {
                    if ((buf[0] & 0xC0) !== 0x80) {
                        self1.lastNeed = 0;
                        return '\ufffd';
                    }
                    if (self1.lastNeed > 1 && buf.length > 1) {
                        if ((buf[1] & 0xC0) !== 0x80) {
                            self1.lastNeed = 1;
                            return '\ufffd';
                        }
                        if (self1.lastNeed > 2 && buf.length > 2) {
                            if ((buf[2] & 0xC0) !== 0x80) {
                                self1.lastNeed = 2;
                                return '\ufffd';
                            }
                        }
                    }
                }
                // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
                function utf8FillLast(buf) {
                    var p = this.lastTotal - this.lastNeed;
                    var r = utf8CheckExtraBytes(this, buf, p);
                    if (r !== undefined) return r;
                    if (this.lastNeed <= buf.length) {
                        buf.copy(this.lastChar, p, 0, this.lastNeed);
                        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    }
                    buf.copy(this.lastChar, p, 0, buf.length);
                    this.lastNeed -= buf.length;
                }
                // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
                // partial character, the character's bytes are buffered until the required
                // number of bytes are available.
                function utf8Text(buf, i) {
                    var total = utf8CheckIncomplete(this, buf, i);
                    if (!this.lastNeed) return buf.toString('utf8', i);
                    this.lastTotal = total;
                    var end = buf.length - (total - this.lastNeed);
                    buf.copy(this.lastChar, 0, end);
                    return buf.toString('utf8', i, end);
                }
                // For UTF-8, a replacement character is added when ending on a partial
                // character.
                function utf8End(buf) {
                    var r = buf && buf.length ? this.write(buf) : '';
                    if (this.lastNeed) return r + '\ufffd';
                    return r;
                }
                // UTF-16LE typically needs two bytes per character, but even if we have an even
                // number of bytes available, we need to check if we end on a leading/high
                // surrogate. In that case, we need to wait for the next two bytes in order to
                // decode the last character properly.
                function utf16Text(buf, i) {
                    if ((buf.length - i) % 2 === 0) {
                        var r = buf.toString('utf16le', i);
                        if (r) {
                            var c = r.charCodeAt(r.length - 1);
                            if (c >= 0xD800 && c <= 0xDBFF) {
                                this.lastNeed = 2;
                                this.lastTotal = 4;
                                this.lastChar[0] = buf[buf.length - 2];
                                this.lastChar[1] = buf[buf.length - 1];
                                return r.slice(0, -1);
                            }
                        }
                        return r;
                    }
                    this.lastNeed = 1;
                    this.lastTotal = 2;
                    this.lastChar[0] = buf[buf.length - 1];
                    return buf.toString('utf16le', i, buf.length - 1);
                }
                // For UTF-16LE we do not explicitly append special replacement characters if we
                // end on a partial character, we simply let v8 handle that.
                function utf16End(buf) {
                    var r = buf && buf.length ? this.write(buf) : '';
                    if (this.lastNeed) {
                        var end = this.lastTotal - this.lastNeed;
                        return r + this.lastChar.toString('utf16le', 0, end);
                    }
                    return r;
                }
                function base64Text(buf, i) {
                    var n = (buf.length - i) % 3;
                    if (n === 0) return buf.toString('base64', i);
                    this.lastNeed = 3 - n;
                    this.lastTotal = 3;
                    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
                    else {
                        this.lastChar[0] = buf[buf.length - 2];
                        this.lastChar[1] = buf[buf.length - 1];
                    }
                    return buf.toString('base64', i, buf.length - n);
                }
                function base64End(buf) {
                    var r = buf && buf.length ? this.write(buf) : '';
                    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
                    return r;
                }
                // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
                function simpleWrite(buf) {
                    return buf.toString(this.encoding);
                }
                function simpleEnd(buf) {
                    return buf && buf.length ? this.write(buf) : '';
                }
            /***/ },
            /***/ 43162: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var requireObjectCoercible = __webpack_require__(83943);
                var Object1 = global.Object;
                // `ToObject` abstract operation
                // https://tc39.es/ecma262/#sec-toobject
                module1.exports = function(argument) {
                    return Object1(requireObjectCoercible(argument));
                };
            /***/ },
            /***/ 43187: /***/ function(module1) {
                // a string of all valid unicode whitespaces
                module1.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
            /***/ },
            /***/ 43267: /***/ function(module1) {
                "use strict";
                module1.exports = /*#__PURE__*/ JSON.parse('[["8740","\u43F0\u4C32\u4603\u45A6\u4578\uD85C\uDE67\u4D77\u45B3\uD85F\uDCB1\u4CE2\uD85F\uDCC5\u3B95\u4736\u4744\u4C47\u4C40\uD850\uDEBF\uD84D\uDE17\uD85C\uDF52\uD85B\uDE8B\uD85C\uDCD2\u4C57\uD868\uDF51\u474F\u45DA\u4C85\uD85F\uDC6C\u4D07\u4AA4\u46A1\uD85A\uDF23\u7225\uD856\uDE54\uD846\uDE63\uD84F\uDE06\uD84F\uDF61\u664D\u56FB"],["8767","\u7D95\u591D\uD862\uDFB9\u3DF4\u9734\uD85E\uDFEF\u5BDB\uD847\uDD5E\u5AA4\u3625\uD867\uDEB0\u5AD1\u5BB7\u5CFC\u676E\u8593\uD866\uDD45\u7461\u749D\u3875\uD847\uDD53\uD84D\uDE9E\uD858\uDC21\u3EEC"],["87a1","\uD856\uDCDE\u3AF5\u7AFC\u9F97\uD850\uDD61\uD862\uDD0D\uD84C\uDDEA\uD842\uDE8A\uD84C\uDE5E\u430A\u8484\u9F96\u942F\u4930\u8613\u5896\u974A\u9218\u79D0\u7A32\u6660\u6A29\u889D\u744C\u7BC5\u6782\u7A2C\u524F\u9046\u34E6\u73C4\uD857\uDDB9\u74C6\u9FC7\u57B3\u492F\u544C\u4131\uD84D\uDE8E\u5818\u7A72\uD85E\uDF65\u8B8F\u46AE\uD85B\uDE88\u4181\uD857\uDD99\u7BAE\uD849\uDCBC\u9FC8\uD849\uDCC1\uD849\uDCC9\uD849\uDCCC\u9FC9\u8504\uD84D\uDDBB\u40B4\u9FCA\u44E1\uD86B\uDDFF\u62C1\u706E\u9FCB"],["8840","\u31C0",4,"\uD840\uDD0C\u31C5\uD840\uDCD1\uD840\uDCCD\u31C6\u31C7\uD840\uDCCB\uD847\uDFE8\u31C8\uD840\uDCCA\u31C9\u31CA\u31CB\u31CC\uD840\uDD0E\u31CD\u31CE\u0100\xc1\u01CD\xc0\u0112\xc9\u011A\xc8\u014C\xd3\u01D1\xd2\u0FFF\xca\u0304\u1EBE\u0FFF\xca\u030C\u1EC0\xca\u0101\xe1\u01CE\xe0\u0251\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA"],["88a1","\u01DC\xfc\u0FFF\xea\u0304\u1EBF\u0FFF\xea\u030C\u1EC1\xea\u0261\u23DA\u23DB"],["8940","\uD868\uDFA9\uD844\uDD45"],["8943","\u650A"],["8946","\u4E3D\u6EDD\u9D4E\u91DF"],["894c","\uD85D\uDF35\u6491\u4F1A\u4F28\u4FA8\u5156\u5174\u519C\u51E4\u52A1\u52A8\u533B\u534E\u53D1\u53D8\u56E2\u58F0\u5904\u5907\u5932\u5934\u5B66\u5B9E\u5B9F\u5C9A\u5E86\u603B\u6589\u67FE\u6804\u6865\u6D4E\u70BC\u7535\u7EA4\u7EAC\u7EBA\u7EC7\u7ECF\u7EDF\u7F06\u7F37\u827A\u82CF\u836F\u89C6\u8BBE\u8BE2\u8F66\u8F67\u8F6E"],["89a1","\u7411\u7CFC\u7DCD\u6946\u7AC9\u5227"],["89ab","\u918C\u78B8\u915E\u80BC"],["89b0","\u8D0B\u80F6\uD842\uDDE7"],["89b5","\u809F\u9EC7\u4CCD\u9DC9\u9E0C\u4C3E\uD867\uDDF6\uD85C\uDC0E\u9E0A\uD868\uDD33\u35C1"],["89c1","\u6E9A\u823E\u7519"],["89c5","\u4911\u9A6C\u9A8F\u9F99\u7987\uD861\uDC6C\uD847\uDDCA\uD841\uDDD0\uD84A\uDEE6\u4E24\u4E81\u4E80\u4E87\u4EBF\u4EEB\u4F37\u344C\u4FBD\u3E48\u5003\u5088\u347D\u3493\u34A5\u5186\u5905\u51DB\u51FC\u5205\u4E89\u5279\u5290\u5327\u35C7\u53A9\u3551\u53B0\u3553\u53C2\u5423\u356D\u3572\u3681\u5493\u54A3\u54B4\u54B9\u54D0\u54EF\u5518\u5523\u5528\u3598\u553F\u35A5\u35BF\u55D7\u35C5"],["8a40","\uD85F\uDD84\u5525"],["8a43","\uD843\uDC42\uD843\uDD15\uD854\uDD2B\u5590\uD84B\uDCC6\u39EC\uD840\uDF41\u8E46\uD853\uDDB8\uD865\uDCE5\u4053\uD860\uDCBE\u777A\uD84B\uDC38\u3A34\u47D5\uD860\uDD5D\uD85A\uDDF2\uD853\uDDEA\u64DD\uD843\uDD7C\uD843\uDFB4\uD843\uDCD5\uD844\uDCF4\u648D\u8E7E\uD843\uDE96\uD843\uDC0B\uD843\uDF64\uD84B\uDCA9\uD860\uDE56\uD851\uDCD3"],["8a64","\uD843\uDD46\uD866\uDE4D\uD860\uDCE9\u47F4\uD853\uDEA7\uD84B\uDCC2\u9AB2\u3A67\uD865\uDDF4\u3FED\u3506\uD854\uDEC7\uD865\uDFD4\uD85E\uDCC8\uD84B\uDD44\u9D6E\u9815"],["8a76","\u43D9\uD858\uDCA5\u64B4\u54E3\uD84B\uDD4C\uD84A\uDFCA\uD844\uDC77\u39FB\uD844\uDC6F"],["8aa1","\uD859\uDEDA\uD859\uDF16\uD85E\uDDA0\u64EA\uD854\uDC52\uD843\uDC43\u8E68\uD848\uDDA1\uD862\uDF4C\uD841\uDF31"],["8aac","\u480B\uD840\uDDA9\u3FFA\u5873\uD84B\uDD8D"],["8ab2","\uD851\uDDC8\uD841\uDCFC\uD858\uDC97\uD843\uDF4C\uD843\uDD96\u5579\u40BB\u43BA"],["8abb","\u4AB4\uD84A\uDE66\uD844\uDC9D\u81AA\u98F5\uD843\uDD9C\u6379\u39FE\uD849\uDF75\u8DC0\u56A1\u647C\u3E43"],["8ac9","\uD869\uDE01\uD843\uDE09\uD84A\uDECF\uD84B\uDCC9"],["8ace","\uD844\uDCC8\uD84E\uDDC2\u3992\u3A06\uD860\uDE9B\u3578\uD857\uDE49\uD848\uDCC7\u5652\uD843\uDF31\uD84B\uDCB2\uD865\uDF20\u34BC\u6C3D\uD853\uDE3B"],["8adf","\uD85D\uDD74\uD84B\uDE8B\uD848\uDE08\uD869\uDE5B\uD863\uDCCD\uD843\uDE7A\uD843\uDC34\uD85A\uDC1C\u7F93\uD844\uDCCF\uD84A\uDC03\uD84A\uDD39\u35FB\uD854\uDDE3\uD843\uDE8C\uD843\uDF8D\uD843\uDEAA\u3F93\uD843\uDF30\uD843\uDD47\uD844\uDD4F\uD843\uDE4C"],["8af6","\uD843\uDEAB\uD842\uDFA9\uD843\uDD48\uD844\uDCC0\uD844\uDD3D\u3FF9\uD849\uDE96\u6432\uD843\uDFAD"],["8b40","\uD84C\uDFF4\uD85D\uDE39\uD84A\uDFCE\uD843\uDD7E\uD843\uDD7F\uD84B\uDC51\uD84B\uDC55\u3A18\uD843\uDE98\uD844\uDCC7\uD843\uDF2E\uD869\uDE32\uD85A\uDF50\uD863\uDCD2\uD863\uDD99\uD863\uDCCA\u95AA\u54CC\u82C4\u55B9"],["8b55","\uD867\uDEC3\u9C26\u9AB6\uD85D\uDF5E\uD84B\uDDEE\u7140\u816D\u80EC\u5C1C\uD859\uDD72\u8134\u3797\u535F\uD860\uDCBD\u91B6\uD843\uDEFA\uD843\uDE0F\uD843\uDE77\uD843\uDEFB\u35DD\uD853\uDDEB\u3609\uD843\uDCD6\u56AF\uD849\uDFB5\uD844\uDCC9\uD843\uDE10\uD843\uDE78\uD844\uDC78\uD844\uDD48\uD860\uDE07\uD845\uDC55\uD843\uDE79\uD853\uDE50\uD84B\uDDA4\u5A54\uD844\uDC1D\uD844\uDC1E\uD844\uDCF5\uD844\uDCF6\u579C\uD843\uDE11"],["8ba1","\uD85D\uDE94\uD860\uDECD\uD843\uDFB5\uD843\uDE7B\uD854\uDD7E\u3703\uD843\uDFB6\uD844\uDD80\uD854\uDED8\uD868\uDEBD\uD852\uDDDA\uD846\uDC3A\uD850\uDD77\uD860\uDE7C\u5899\u5268\u361A\uD855\uDF3D\u7BB2\u5B68\u4800\u4B2C\u9F27\u49E7\u9C1F\u9B8D\uD856\uDF74\uD84C\uDD3D\u55FB\u35F2\u5689\u4E28\u5902\uD846\uDFC1\uD87E\uDC78\u9751\uD840\uDC86\u4E5B\u4EBB\u353E\u5C23\u5F51\u5FC4\u38FA\u624C\u6535\u6B7A\u6C35\u6C3A\u706C\u722B\u4E2C\u72AD\uD852\uDCE9\u7F52\u793B\u7CF9\u7F53\uD858\uDE6A\u34C1"],["8bde","\uD858\uDF4B\u8002\u8080\uD859\uDE12\uD85A\uDD51\u535D\u8864\u89C1\uD85E\uDCB2\u8BA0\u8D1D\u9485\u9578\u957F\u95E8\uD863\uDE0F\u97E6\u9875\u98CE\u98DE\u9963\uD866\uDC10\u9C7C\u9E1F\u9EC4\u6B6F\uF907\u4E37\uD840\uDC87\u961D\u6237\u94A2"],["8c40","\u503B\u6DFE\uD867\uDC73\u9FA6\u3DC9\u888F\uD850\uDD4E\u7077\u5CF5\u4B20\uD854\uDDCD\u3559\uD857\uDD30\u6122\uD862\uDE32\u8FA7\u91F6\u7191\u6719\u73BA\uD84C\uDE81\uD868\uDD07\u3C8B\uD846\uDD80\u4B10\u78E4\u7402\u51AE\uD861\uDF0F\u4009\u6A63\uD868\uDEBA\u4223\u860F\uD842\uDE6F\u7A2A\uD866\uDD47\uD862\uDEEA\u9755\u704D\u5324\uD848\uDC7E\u93F4\u76D9\uD862\uDDE3\u9FA7\u77DD\u4EA3\u4FF0\u50BC\u4E2F\u4F17\u9FA8\u5434\u7D8B\u5892\u58D0\uD847\uDDB6\u5E92\u5E99\u5FC2\uD849\uDF12\u658B"],["8ca1","\uD84C\uDFF9\u6919\u6A43\uD84F\uDC63\u6CFF"],["8ca7","\u7200\uD851\uDD05\u738C\u3EDB\uD852\uDE13\u5B15\u74B9\u8B83\uD857\uDCA4\uD855\uDE95\u7A93\u7BEC\u7CC3\u7E6C\u82F8\u8597\u9FA9\u8890\u9FAA\u8EB9\u9FAB\u8FCF\u855F\u99E0\u9221\u9FAC\uD863\uDDB9\uD845\uDC3F\u4071\u42A2\u5A1A"],["8cc9","\u9868\u676B\u4276\u573D"],["8cce","\u85D6\uD852\uDD7B\u82BF\uD85C\uDD0D\u4C81\uD85B\uDD74\u5D7B\uD85A\uDF15\uD85B\uDFBE\u9FAD\u9FAE\u5B96\u9FAF\u66E7\u7E5B\u6E57\u79CA\u3D88\u44C3\uD84C\uDE56\uD849\uDF96\u439A\u4536"],["8ce6","\u5CD5\uD84E\uDF1A\u8AF9\u5C78\u3D12\uD84D\uDD51\u5D78\u9FB2\u7157\u4558\uD850\uDCEC\uD847\uDE23\u4C77\u3978\u344A\uD840\uDDA4\uD85B\uDC41\u8ACC\u4FB4\uD840\uDE39\u59BF\u816C\u9856\uD866\uDCFA\u5F3B"],["8d40","\uD842\uDF9F"],["8d42","\uD848\uDDC1\uD862\uDD6D\u4102\u46BB\uD864\uDC79\u3F07\u9FB3\uD868\uDDB5\u40F8\u37D6\u46F7\uD85B\uDC46\u417C\uD861\uDEB2\uD85C\uDFFF\u456D\u38D4\uD855\uDC9A\u4561\u451B\u4D89\u4C7B\u4D76\u45EA\u3FC8\uD852\uDF0F\u3661\u44DE\u44BD\u41ED\u5D3E\u5D48\u5D56\u3DFC\u380F\u5DA4\u5DB9\u3820\u3838\u5E42\u5EBD\u5F25\u5F83\u3908\u3914\u393F\u394D\u60D7\u613D\u5CE5\u3989\u61B7\u61B9\u61CF\u39B8\u622C\u6290\u62E5\u6318\u39F8\u56B1"],["8da1","\u3A03\u63E2\u63FB\u6407\u645A\u3A4B\u64C0\u5D15\u5621\u9F9F\u3A97\u6586\u3ABD\u65FF\u6653\u3AF2\u6692\u3B22\u6716\u3B42\u67A4\u6800\u3B58\u684A\u6884\u3B72\u3B71\u3B7B\u6909\u6943\u725C\u6964\u699F\u6985\u3BBC\u69D6\u3BDD\u6A65\u6A74\u6A71\u6A82\u3BEC\u6A99\u3BF2\u6AAB\u6AB5\u6AD4\u6AF6\u6B81\u6BC1\u6BEA\u6C75\u6CAA\u3CCB\u6D02\u6D06\u6D26\u6D81\u3CEF\u6DA4\u6DB1\u6E15\u6E18\u6E29\u6E86\uD862\uDDC0\u6EBB\u6EE2\u6EDA\u9F7F\u6EE8\u6EE9\u6F24\u6F34\u3D46\uD84F\uDF41\u6F81\u6FBE\u3D6A\u3D75\u71B7\u5C99\u3D8A\u702C\u3D91\u7050\u7054\u706F\u707F\u7089\uD840\uDF25\u43C1\u35F1\uD843\uDED8"],["8e40","\uD84F\uDED7\u57BE\uD85B\uDED3\u713E\uD855\uDFE0\u364E\u69A2\uD862\uDFE9\u5B74\u7A49\uD856\uDCE1\uD865\uDCD9\u7A65\u7A7D\uD856\uDDAC\u7ABB\u7AB0\u7AC2\u7AC3\u71D1\uD859\uDC8D\u41CA\u7ADA\u7ADD\u7AEA\u41EF\u54B2\uD857\uDC01\u7B0B\u7B55\u7B29\uD854\uDF0E\uD857\uDCFE\u7BA2\u7B6F\u839C\uD856\uDFB4\uD85B\uDC7F\u7BD0\u8421\u7B92\u7BB8\uD857\uDD20\u3DAD\uD857\uDC65\u8492\u7BFA\u7C06\u7C35\uD857\uDCC1\u7C44\u7C83\uD852\uDC82\u7CA6\u667D\uD851\uDD78\u7CC9\u7CC7\u7CE6\u7C74\u7CF3\u7CF5\u7CCE"],["8ea1","\u7E67\u451D\uD85B\uDE44\u7D5D\uD85B\uDED6\u748D\u7D89\u7DAB\u7135\u7DB3\u7DD2\uD850\uDC57\uD858\uDC29\u7DE4\u3D13\u7DF5\uD845\uDFF9\u7DE5\uD860\uDF6D\u7E1D\uD858\uDD21\uD858\uDD5A\u7E6E\u7E92\u432B\u946C\u7E27\u7F40\u7F41\u7F47\u7936\uD858\uDED0\u99E1\u7F97\uD858\uDF51\u7FA3\uD845\uDE61\uD840\uDC68\u455C\uD84D\uDF66\u4503\uD860\uDF3A\u7FFA\uD859\uDC89\u8005\u8008\u801D\u8028\u802F\uD868\uDC87\uD85B\uDCC3\u803B\u803C\u8061\uD849\uDF14\u4989\uD859\uDE26\uD84F\uDDE3\uD859\uDEE8\u6725\u80A7\uD862\uDE48\u8107\u811A\u58B0\uD849\uDEF6\u6C7F\uD859\uDC98\uD853\uDFB8\u64E7\uD845\uDC8A\u8218\uD846\uDC5E\u6A53\uD852\uDE65\uD852\uDE95\u447A\u8229\uD842\uDF0D\uD85A\uDE52\uD84F\uDD7E\u4FF9\uD845\uDCFD\u84E2\u8362\uD85A\uDF0A\uD852\uDDA7\uD84D\uDD30\uD845\uDF73\uD84F\uDDF8\u82AA\u691B\uD87E\uDD94\u41DB"],["8f40","\u854B\u82D0\u831A\uD843\uDE16\uD845\uDFB4\u36C1\uD84C\uDD7D\uD84D\uDD5A\u827B\u82E2\u8318\uD84F\uDE8B\uD85B\uDDA3\uD85A\uDF05\uD85A\uDF97\uD84D\uDDCE\u3DBF\u831D\u55EC\u8385\u450B\uD85B\uDDA5\u83AC\u83C1\u83D3\u347E\uD85B\uDED4\u6A57\u855A\u3496\uD85B\uDE42\uD84B\uDEEF\u8458\uD856\uDFE4\u8471\u3DD3\u44E4\u6AA7\u844A\uD84F\uDCB5\u7958\u84A8\uD85A\uDF96\uD85B\uDE77\uD85B\uDE43\u84DE\u840F\u8391\u44A0\u8493\u84E4\uD857\uDC91\u4240\uD857\uDCC0\u4543\u8534\u5AF2\uD85B\uDE99\u4527\u8573\u4516\u67BF\u8616"],["8fa1","\uD861\uDE25\uD861\uDE3B\u85C1\uD85C\uDC88\u8602\uD845\uDD82\uD85C\uDCCD\uD87E\uDDB2\u456A\u8628\u3648\uD846\uDCA2\u53F7\uD85C\uDF9A\u867E\u8771\uD868\uDCF8\u87EE\uD84B\uDC27\u87B1\u87DA\u880F\u5661\u866C\u6856\u460F\u8845\u8846\uD85D\uDDE0\uD84F\uDDB9\uD85D\uDDE4\u885E\u889C\u465B\u88B4\u88B5\u63C1\u88C5\u7777\uD85D\uDF0F\u8987\u898A\u89A6\u89A9\u89A7\u89BC\uD862\uDE25\u89E7\uD85E\uDD24\uD85E\uDEBD\u8A9C\u7793\u91FE\u8A90\uD85E\uDE59\u7AE9\uD85E\uDF3A\uD84F\uDF8F\u4713\uD85E\uDF38\u717C\u8B0C\u8B1F\uD855\uDC30\uD855\uDD65\u8B3F\u8B4C\u8B4D\u8AA9\uD852\uDE7A\u8B90\u8B9B\u8AAF\uD845\uDEDF\u4615\u884F\u8C9B\uD85F\uDD54\uD85F\uDD8F\uD87E\uDDD4\u3725\uD85F\uDD53\u8CD6\uD85F\uDD98\uD85F\uDDBD\u8D12\u8D03\uD846\uDD10\u8CDB\u705C\u8D11\uD853\uDCC9\u3ED0\u8D77"],["9040","\u8DA9\uD860\uDC02\uD844\uDC14\uD852\uDD8A\u3B7C\uD860\uDDBC\uD85C\uDD0C\u7AE7\u8EAD\u8EB6\u8EC3\u92D4\u8F19\u8F2D\uD860\uDF65\uD861\uDC12\u8FA5\u9303\uD868\uDE9F\uD842\uDE50\u8FB3\u492A\uD862\uDDDE\uD861\uDD3D\uD84F\uDDBB\u5EF8\uD84C\uDE62\u8FF9\uD868\uDC14\uD861\uDEBC\uD861\uDD01\uD848\uDF25\u3980\uD85B\uDED7\u9037\uD861\uDD3C\uD85E\uDEBE\u9061\uD861\uDD6C\uD861\uDE0B\u90A8\uD861\uDF13\u90C4\uD861\uDEE6\u90AE\u90FD\u9167\u3AF0\u91A9\u91C4\u7CAC\uD862\uDD33\uD847\uDE89\u920E\u6C9F\u9241\u9262\uD855\uDDB9\u92B9\uD862\uDEC6\uD84F\uDC9B\uD862\uDF0C\uD855\uDDDB"],["90a1","\uD843\uDD31\u932C\u936B\uD862\uDEE1\uD862\uDFEB\u708F\u5AC3\uD862\uDEE2\uD862\uDEE5\u4965\u9244\uD862\uDFEC\uD863\uDC39\uD862\uDFFF\u9373\u945B\u8EBC\u9585\u95A6\u9426\u95A0\u6FF6\u42B9\uD849\uDE7A\uD861\uDED8\uD844\uDE7C\uD84F\uDE2E\u49DF\u6C1C\u967B\u9696\u416C\u96A3\uD85B\uDED5\u61DA\u96B6\u78F5\uD862\uDEE0\u96BD\u53CC\u49A1\uD85B\uDCB8\uD840\uDE74\uD859\uDC10\uD864\uDCAF\uD864\uDCE5\uD852\uDED1\uD846\uDD15\uD84C\uDF0A\u9731\u8642\u9736\u4A0F\u453D\u4585\uD852\uDEE9\u7075\u5B41\u971B\u975C\uD864\uDDD5\u9757\u5B4A\uD864\uDDEB\u975F\u9425\u50D0\uD84C\uDCB7\uD84C\uDCBC\u9789\u979F\u97B1\u97BE\u97C0\u97D2\u97E0\uD855\uDC6C\u97EE\u741C\uD865\uDC33\u97FF\u97F5\uD865\uDC1D\uD85E\uDD7A\u4AD1\u9834\u9833\u984B\u9866\u3B0E\uD85C\uDD75\u3D51\uD841\uDE30\uD850\uDD5C"],["9140","\uD855\uDF06\u98CA\u98B7\u98C8\u98C7\u4AFF\uD85B\uDD27\uD845\uDED3\u55B0\u98E1\u98E6\u98EC\u9378\u9939\uD852\uDE29\u4B72\uD866\uDC57\uD866\uDD05\u99F5\u9A0C\u9A3B\u9A10\u9A58\uD855\uDF25\u36C4\uD864\uDCB1\uD866\uDFD5\u9AE0\u9AE2\uD866\uDF05\u9AF4\u4C0E\u9B14\u9B2D\uD861\uDE00\u5034\u9B34\uD85A\uDDA8\u38C3\uD84C\uDC7D\u9B50\u9B40\uD867\uDD3E\u5A45\uD846\uDC63\u9B8E\uD850\uDE4B\u9C02\u9BFF\u9C0C\uD867\uDE68\u9DD4\uD867\uDFB7\uD868\uDD92\uD868\uDDAB\uD868\uDCE1\uD868\uDD23\uD868\uDDDF\u9D7E\u9D83\uD868\uDD34\u9E0E\u6888"],["91a1","\u9DC4\uD848\uDD5B\uD868\uDD93\uD868\uDE20\uD846\uDD3B\uD868\uDE33\u9D39\uD868\uDCB9\uD868\uDEB4\u9E90\u9E95\u9E9E\u9EA2\u4D34\u9EAA\u9EAF\uD850\uDF64\u9EC1\u3B60\u39E5\u3D1D\u4F32\u37BE\uD863\uDC2B\u9F02\u9F08\u4B96\u9424\uD85B\uDDA2\u9F17\u9F16\u9F39\u569F\u568A\u9F45\u99B8\uD864\uDC8B\u97F2\u847F\u9F62\u9F69\u7ADC\u9F8E\u7216\u4BBE\uD852\uDD75\uD852\uDDBB\u7177\uD852\uDDF8\uD850\uDF48\uD852\uDE51\u739E\uD862\uDFDA\uD846\uDCFA\u799F\uD862\uDD7E\uD863\uDE36\u9369\u93F3\uD862\uDE44\u92EC\u9381\u93CB\uD862\uDD6C\uD851\uDCB9\u7217\u3EEB\u7772\u7A43\u70D0\uD851\uDC73\uD850\uDFF8\u717E\uD845\uDFEF\u70A3\uD846\uDCBE\uD84D\uDD99\u3EC7\uD846\uDC85\uD855\uDC2F\uD845\uDFF8\u3722\uD845\uDEFB\uD846\uDC39\u36E1\uD845\uDF74\uD846\uDCD1\uD857\uDF4B\u3723\uD845\uDEC0\u575B\uD852\uDE25\uD844\uDFFE\uD844\uDEA8"],["9240","\uD844\uDFC6\uD845\uDCB6\u8503\uD84D\uDEA6\u8503\u8455\uD852\uDD94\uD85C\uDD65\uD84F\uDE31\uD855\uDD5C\uD84F\uDEFB\uD85C\uDC52\u44F4\uD84D\uDEEE\uD866\uDD9D\uD85B\uDF26\u67F9\u3733\u3C15\u3DE7\u586C\uD846\uDD22\u6810\u4057\uD84D\uDF3F\uD850\uDCE1\uD850\uDC8B\uD850\uDD0F\uD85B\uDC21\u54CB\u569E\uD859\uDEB1\u5692\uD843\uDFDF\uD842\uDFA8\uD843\uDE0D\u93C6\uD862\uDF13\u939C\u4EF8\u512B\u3819\uD851\uDC36\u4EBC\uD841\uDC65\uD840\uDF7F\u4F4B\u4F8A\uD855\uDE51\u5A68\uD840\uDDAB\uD840\uDFCB\u3999\uD840\uDF0A\uD841\uDC14\u3435\u4F29\uD840\uDEC0\uD863\uDEB3\uD840\uDE75\u8ADA\uD840\uDE0C\u4E98"],["92a1","\u50CD\u510D\u4FA2\u4F03\uD852\uDE0E\uD84F\uDE8A\u4F42\u502E\u506C\u5081\u4FCC\u4FE5\u5058\u50FC\u5159\u515B\u515D\u515E\u6E76\uD84D\uDD95\uD84F\uDE39\uD84F\uDEBF\u6D72\uD846\uDC84\uD84F\uDE89\u51A8\u51C3\uD841\uDDE0\u44DD\uD841\uDCA3\uD841\uDC92\uD841\uDC91\u8D7A\uD862\uDE9C\uD841\uDF0E\u5259\u52A4\uD842\uDC73\u52E1\u936E\u467A\u718C\uD850\uDF8C\uD843\uDC20\uD852\uDDAC\uD844\uDCE4\u69D1\uD843\uDE1D\u7479\u3EDE\u7499\u7414\u7456\u7398\u4B8E\uD852\uDEBC\uD850\uDC8D\u53D0\u3584\u720F\uD850\uDCC9\u55B4\uD840\uDF45\u54CD\uD842\uDFC6\u571D\u925D\u96F4\u9366\u57DD\u578D\u577F\u363E\u58CB\u5A99\uD862\uDE46\uD845\uDEFA\uD845\uDF6F\uD845\uDF10\u5A2C\u59B8\u928F\u5A7E\u5ACF\u5A12\uD856\uDD46\uD846\uDDF3\uD846\uDC61\uD850\uDE95\u36F5\u6D05\u7443\u5A21\uD857\uDE83"],["9340","\u5A81\uD862\uDFD7\uD841\uDC13\u93E0\u748C\uD844\uDF03\u7105\u4972\u9408\uD862\uDDFB\u93BD\u37A0\u5C1E\u5C9E\u5E5E\u5E48\uD846\uDD96\uD846\uDD7C\uD84E\uDEEE\u5ECD\u5B4F\uD846\uDD03\uD846\uDD04\u3701\uD846\uDCA0\u36DD\uD845\uDEFE\u36D3\u812A\uD862\uDE47\uD847\uDDBA\uD84D\uDC72\uD862\uDDA8\u5F0C\u5F0E\uD846\uDD27\uD845\uDFAB\u5A6B\uD845\uDF3B\u5B44\u8614\uD85D\uDDFD\u8860\u607E\uD84A\uDC60\uD849\uDE2B\u5FDB\u3EB8\uD849\uDDAF\uD849\uDDBE\uD864\uDC88\uD85B\uDF73\u61C0\uD840\uDC3E\uD840\uDC46\uD849\uDE1B\u6199\u6198\u6075\uD84B\uDC9B\uD84B\uDD07\uD851\uDED4\uD864\uDD4D"],["93a1","\u6471\uD851\uDE65\uD84A\uDF6A\u3A29\uD84A\uDF22\uD84D\uDC50\uD866\uDCEA\uD84B\uDE78\u6337\uD869\uDC5B\u64B6\u6331\u63D1\uD852\uDDE3\uD84B\uDD67\u62A4\uD84B\uDCA1\u643B\u656B\u6972\u3BF4\uD84C\uDC8E\uD84C\uDEAD\uD852\uDD89\uD84C\uDEAB\u550D\uD84C\uDEE0\uD846\uDCD9\uD865\uDC3F\u66CE\uD84C\uDE89\uD84C\uDDB3\u3AE0\u4190\uD855\uDD84\uD862\uDF22\uD855\uDD8F\uD845\uDEFC\uD855\uDD5B\uD855\uDC25\u78EE\uD84C\uDD03\uD846\uDC2A\uD84C\uDE34\u3464\uD84C\uDE0F\uD84C\uDD82\uD850\uDEC9\u668E\uD85B\uDD24\u666B\u4B93\u6630\uD85E\uDC70\uD847\uDDEB\u6663\uD84C\uDED2\uD84C\uDEE1\u661E\uD856\uDC72\u38D1\uD84E\uDC3A\uD84D\uDFBC\u3B99\uD84D\uDFA2\uD84C\uDFFE\u74D0\u3B96\u678F\uD851\uDE2A\u68B6\u681E\u3BC4\u6ABE\u3863\uD84D\uDFD5\uD851\uDC87\u6A33\u6A52\u6AC9\u6B05\uD846\uDD12\u6511\u6898\u6A4C\u3BD7\u6A7A\u6B57\uD84F\uDFC0\uD84F\uDC9A\u93A0\u92F2\uD862\uDFEA\uD862\uDECB"],["9440","\u9289\uD860\uDC1E\uD862\uDDDC\u9467\u6DA5\u6F0B\uD852\uDDEC\u6D67\uD84F\uDF7F\u3D8F\u6E04\uD850\uDC3C\u5A3D\u6E0A\u5847\u6D24\u7842\u713B\uD850\uDF1A\uD850\uDE76\u70F1\u7250\u7287\u7294\uD851\uDF8F\uD851\uDF25\u5179\uD852\uDEA4\uD841\uDDEB\u747A\uD84F\uDEF8\uD84D\uDE5F\uD852\uDE4A\uD852\uDD17\uD857\uDFE1\u3F06\u3EB1\uD852\uDEDF\uD863\uDC23\uD84F\uDF35\u60A7\u3EF3\u74CC\u743C\u9387\u7437\u449F\uD85B\uDDEA\u4551\u7583\u3F63\uD853\uDCD9\uD853\uDD06\u3F58\u7555\u7673\uD869\uDDC6\u3B19\u7468\uD862\uDECC\uD852\uDDAB\uD852\uDD8E\u3AFB"],["94a1","\u3DCD\uD852\uDE4E\u3EFF\uD852\uDDC5\uD852\uDCF3\u91FA\u5732\u9342\uD862\uDEE3\uD846\uDC64\u50DF\uD854\uDE21\uD854\uDDE7\u7778\uD84C\uDE32\u770E\u770F\u777B\uD851\uDE97\uD84D\uDF81\u3A5E\uD852\uDCF0\u7438\u749B\u3EBF\uD852\uDEBA\uD852\uDEC7\u40C8\uD852\uDE96\uD858\uDDAE\u9307\uD855\uDD81\u781E\u788D\u7888\u78D2\u73D0\u7959\uD85D\uDF41\uD855\uDEE3\u410E\u799B\u8496\u79A5\u6A2D\uD84F\uDEFA\u7A3A\u79F4\u416E\uD845\uDEE6\u4132\u9235\u79F1\uD843\uDD4C\uD852\uDD8C\uD840\uDE99\uD84F\uDDBA\uD845\uDF6E\u3597\u556B\u3570\u36AA\uD840\uDDD4\uD843\uDC0D\u7AE2\u5A59\uD849\uDEF5\uD856\uDEAF\uD856\uDE9C\u5A0D\uD840\uDE5B\u78F0\u5A2A\uD856\uDFC6\u7AFE\u41F9\u7C5D\u7C6D\u4211\uD856\uDFB3\uD857\uDEBC\uD857\uDEA6\u7CCD\uD852\uDDF9\uD845\uDFB0\u7C8E\u7C7C\u7CAE\u6AB2\u7DDC\u7E07\u7DD3\u7F4E\uD858\uDE61"],["9540","\uD858\uDD5C\uD85E\uDF48\u7D97\uD857\uDE82\u426A\uD85A\uDF75\uD842\uDD16\u67D6\uD840\uDC4E\uD84D\uDDCF\u57C4\uD859\uDC12\uD858\uDFF8\uD852\uDD62\u7FDD\u7B27\uD842\uDC2C\uD856\uDEE9\uD857\uDD43\u7B0C\uD857\uDE0E\u99E6\u8645\u9A63\u6A1C\uD84D\uDC3F\u39E2\uD852\uDDF7\uD859\uDDAD\u9A1F\uD859\uDDA0\u8480\uD85C\uDD27\uD85B\uDCD1\u44EA\u8137\u4402\u80C6\u8109\u8142\uD859\uDFB4\u98C3\uD85A\uDE42\u8262\u8265\uD85A\uDE51\u8453\uD85B\uDDA7\u8610\uD85C\uDE1B\u5A86\u417F\uD846\uDC40\u5B2B\uD846\uDCA1\u5AE4\uD846\uDCD8\u86A0\uD87E\uDDBC\uD84F\uDD8F\u882D\uD85D\uDC22\u5A02"],["95a1","\u886E\u4F45\u8887\u88BF\u88E6\u8965\u894D\uD855\uDE83\u8954\uD85D\uDF85\uD85D\uDF84\uD862\uDFF5\uD862\uDFD9\uD862\uDF9C\uD862\uDDF9\u3EAD\u84A3\u46F5\u46CF\u37F2\u8A3D\u8A1C\uD865\uDC48\u5F4D\u922B\uD850\uDE84\u65D4\u7129\u70C4\uD846\uDC45\u9D6D\u8C9F\u8CE9\uD85F\uDDDC\u599A\u77C3\u59F0\u436E\u36D4\u8E2A\u8EA7\uD853\uDC09\u8F30\u8F4A\u42F4\u6C58\u6FBB\uD848\uDF21\u489B\u6F79\u6E8B\uD845\uDFDA\u9BE9\u36B5\uD852\uDD2F\u90BB\u9097\u5571\u4906\u91BB\u9404\uD862\uDE4B\u4062\uD862\uDEFC\u9427\uD863\uDC1D\uD863\uDC3B\u84E5\u8A2B\u9599\u95A7\u9597\u9596\uD863\uDD34\u7445\u3EC2\uD852\uDCFF\uD852\uDE42\uD850\uDFEA\u3EE7\uD84C\uDE25\u968F\uD863\uDEE7\uD863\uDE66\uD863\uDE65\u3ECC\uD852\uDDED\uD852\uDE78\uD84F\uDFEE\u7412\u746B\u3EFC\u9741\uD864\uDCB0"],["9640","\u6847\u4A1D\uD864\uDC93\uD855\uDFDF\u975D\u9368\uD862\uDD89\uD863\uDC26\uD862\uDF2F\uD858\uDFBE\u92BA\u5B11\u8B69\u493C\u73F9\uD850\uDE1B\u979B\u9771\u9938\uD843\uDF26\u5DC1\uD862\uDFC5\uD852\uDEB2\u981F\uD865\uDCDA\u92F6\uD865\uDDD7\u91E5\u44C0\uD862\uDF50\uD852\uDE67\uD862\uDF64\u98DC\uD862\uDE45\u3F00\u922A\u4925\u8414\u993B\u994D\uD85E\uDF06\u3DFD\u999B\u4B6F\u99AA\u9A5C\uD862\uDF65\uD856\uDCC8\u6A8F\u9A21\u5AFE\u9A2F\uD866\uDCF1\u4B90\uD866\uDD48\u99BC\u4BBD\u4B97\u937D\u5872\uD844\uDF02\u5822\uD852\uDDB8"],["96a1","\uD845\uDCE8\u7844\uD849\uDF1F\uD84F\uDDB8\u68C5\u3D7D\u9458\u3927\u6150\uD849\uDF81\uD84A\uDD6B\u6107\u9C4F\u9C53\u9C7B\u9C35\u9C10\u9B7F\u9BCF\uD867\uDE2D\u9B9F\uD868\uDDF5\uD868\uDCFE\u9D21\u4CAE\uD850\uDD04\u9E18\u4CB0\u9D0C\uD868\uDDB4\uD868\uDCED\uD868\uDCF3\uD866\uDD2F\u9DA5\u84BD\uD85B\uDE12\uD85B\uDFDF\uD85A\uDF82\u85FC\u4533\uD85B\uDDA4\uD85B\uDE84\uD85B\uDDF0\u8420\u85EE\uD85B\uDE00\uD84D\uDFD7\uD858\uDC64\u79E2\uD84D\uDD9C\uD84D\uDE40\u492D\uD852\uDDDE\u3D62\u93DB\u92BE\u9348\uD840\uDEBF\u78B9\u9277\u944D\u4FE4\u3440\u9064\uD855\uDD5D\u783D\u7854\u78B6\u784B\uD845\uDF57\uD84C\uDDC9\uD852\uDD41\u369A\u4F72\u6FDA\u6FD9\u701E\u701E\u5414\uD850\uDDB5\u57BB\u58F3\u578A\u9D16\u57D7\u7134\u34AF\uD850\uDDAC\u71EB\uD85B\uDC40\uD853\uDF97\u5B28\uD845\uDFB5\uD862\uDE49"],["9740","\u610C\u5ACE\u5A0B\u42BC\uD851\uDC88\u372C\u4B7B\uD862\uDDFC\u93BB\u93B8\uD846\uDCD6\uD843\uDF1D\u8472\uD85B\uDCC0\uD845\uDC13\uD850\uDEFA\uD84B\uDC26\uD850\uDFC1\u5994\uD84F\uDDB7\uD859\uDF41\u7DA8\uD858\uDD5B\uD858\uDCA4\uD852\uDDB9\uD852\uDD8B\uD862\uDDFA\u92E5\u73E2\u3EE9\u74B4\uD862\uDF63\uD846\uDC9F\u3EE1\uD852\uDEB3\u6AD8\u73F3\u73FB\u3ED6\uD852\uDE3E\uD852\uDE94\uD845\uDFD9\uD852\uDE66\uD840\uDFA7\uD845\uDC24\uD852\uDDE5\u7448\uD852\uDD16\u70A5\uD852\uDD76\u9284\u73E6\u935F\uD841\uDCFE\u9331\uD862\uDECE\uD862\uDE16\u9386\uD862\uDFE7\uD855\uDDD5\u4935\uD862\uDE82\u716B"],["97a1","\uD852\uDD43\uD843\uDCFF\u56A4\uD841\uDE1A\uD842\uDFEB\uD843\uDCB8\u5502\u79C4\uD845\uDFFA\u7DFE\uD845\uDEC2\uD852\uDE50\uD846\uDC52\u452E\u9401\u370A\uD862\uDEC0\uD852\uDDAD\u59B0\uD846\uDCBF\uD846\uDC83\uD85D\uDC84\u5AA1\u36E2\uD84F\uDD5B\u36B0\u925F\u5A79\uD862\uDE81\uD846\uDC62\u9374\u3CCD\uD842\uDEB4\u4A96\u398A\u50F4\u3D69\u3D4C\uD844\uDF9C\u7175\u42FB\uD860\uDE18\u6E0F\uD864\uDCE4\u44EB\u6D57\uD85F\uDE4F\u7067\u6CAF\u3CD6\uD84F\uDFED\uD84F\uDE2D\u6E02\u6F0C\u3D6F\uD840\uDFF5\u7551\u36BC\u34C8\u4680\u3EDA\u4871\u59C4\u926E\u493E\u8F41\uD863\uDC1C\uD85A\uDFC0\u5812\u57C8\u36D6\uD845\uDC52\u70FE\uD850\uDF62\uD852\uDE71\uD84B\uDFE3\uD844\uDEB0\uD848\uDFBD\u68B9\u6967\uD844\uDF98\uD84D\uDCE5\uD85E\uDFF4\uD84D\uDEDF\uD862\uDE83\uD84D\uDFD6\uD84C\uDFFA\uD853\uDC9F\u6A1A\uD84D\uDEAD\uD85B\uDCB7\u843E\u44DF\u44CE"],["9840","\uD85B\uDD26\uD85B\uDD51\uD85B\uDC82\uD85B\uDFDE\u6F17\uD85C\uDD09\u833D\uD845\uDF3A\u83ED\uD85B\uDC80\uD85C\uDC53\uD845\uDFDB\u5989\u5A82\uD845\uDFB3\u5A61\u5A71\uD846\uDD05\uD850\uDDFC\u372D\u59EF\uD845\uDF3C\u36C7\u718E\u9390\u669A\uD850\uDEA5\u5A6E\u5A2B\uD850\uDE93\u6A2B\uD84F\uDEF9\uD85D\uDF36\uD851\uDC5B\uD850\uDECA\u711D\uD850\uDE59\uD862\uDDE1\u4FB0\uD85B\uDD28\u5CC2\uD851\uDCCE\uD85F\uDE4D\uD850\uDFBD\u6A0C\uD850\uDE56\uD844\uDF04\u70A6\u7133\uD850\uDFE9\u3DA5\u6CDF\uD87E\uDC25\uD852\uDE4F\u7E65\u59EB\u5D2F\u3DF3\u5F5C\uD852\uDE5D\uD845\uDFDF\u7DA4\u8426"],["98a1","\u5485\uD84E\uDEFA\uD84C\uDF00\uD840\uDE14\u577E\uD842\uDCD5\uD841\uDE19\u3FE5\uD847\uDF9E\uD868\uDEB6\u7003\uD864\uDD5B\u5D70\u738F\u7CD3\uD862\uDE59\uD865\uDC20\u4FC8\u7FE7\u72CD\u7310\uD85E\uDEF4\u7338\u7339\uD855\uDEF6\u7341\u7348\u3EA9\uD85E\uDF18\u906C\u71F5\uD852\uDCF2\u73E1\u81F6\u3ECA\u770C\u3ED1\u6CA2\u56FD\u7419\u741E\u741F\u3EE2\u3EF0\u3EF4\u3EFA\u74D3\u3F0E\u3F53\u7542\u756D\u7572\u758D\u3F7C\u75C8\u75DC\u3FC0\u764D\u3FD7\u7674\u3FDC\u767A\uD853\uDF5C\u7188\u5623\u8980\u5869\u401D\u7743\u4039\u6761\u4045\u35DB\u7798\u406A\u406F\u5C5E\u77BE\u77CB\u58F2\u7818\u70B9\u781C\u40A8\u7839\u7847\u7851\u7866\u8448\uD855\uDD35\u7933\u6803\u7932\u4103"],["9940","\u4109\u7991\u7999\u8FBB\u7A06\u8FBC\u4167\u7A91\u41B2\u7ABC\u8279\u41C4\u7ACF\u7ADB\u41CF\u4E21\u7B62\u7B6C\u7B7B\u7C12\u7C1B\u4260\u427A\u7C7B\u7C9C\u428C\u7CB8\u4294\u7CED\u8F93\u70C0\uD843\uDCCF\u7DCF\u7DD4\u7DD0\u7DFD\u7FAE\u7FB4\u729F\u4397\u8020\u8025\u7B39\u802E\u8031\u8054\u3DCC\u57B4\u70A0\u80B7\u80E9\u43ED\u810C\u732A\u810E\u8112\u7560\u8114\u4401\u3B39\u8156\u8159\u815A"],["99a1","\u4413\u583A\u817C\u8184\u4425\u8193\u442D\u81A5\u57EF\u81C1\u81E4\u8254\u448F\u82A6\u8276\u82CA\u82D8\u82FF\u44B0\u8357\u9669\u698A\u8405\u70F5\u8464\u60E3\u8488\u4504\u84BE\u84E1\u84F8\u8510\u8538\u8552\u453B\u856F\u8570\u85E0\u4577\u8672\u8692\u86B2\u86EF\u9645\u878B\u4606\u4617\u88AE\u88FF\u8924\u8947\u8991\uD85E\uDD67\u8A29\u8A38\u8A94\u8AB4\u8C51\u8CD4\u8CF2\u8D1C\u4798\u585F\u8DC3\u47ED\u4EEE\u8E3A\u55D8\u5754\u8E71\u55F5\u8EB0\u4837\u8ECE\u8EE2\u8EE4\u8EED\u8EF2\u8FB7\u8FC1\u8FCA\u8FCC\u9033\u99C4\u48AD\u98E0\u9213\u491E\u9228\u9258\u926B\u92B1\u92AE\u92BF"],["9a40","\u92E3\u92EB\u92F3\u92F4\u92FD\u9343\u9384\u93AD\u4945\u4951\u9EBF\u9417\u5301\u941D\u942D\u943E\u496A\u9454\u9479\u952D\u95A2\u49A7\u95F4\u9633\u49E5\u67A0\u4A24\u9740\u4A35\u97B2\u97C2\u5654\u4AE4\u60E8\u98B9\u4B19\u98F1\u5844\u990E\u9919\u51B4\u991C\u9937\u9942\u995D\u9962\u4B70\u99C5\u4B9D\u9A3C\u9B0F\u7A83\u9B69\u9B81\u9BDD\u9BF1\u9BF4\u4C6D\u9C20\u376F\uD846\uDFC2\u9D49\u9C3A"],["9aa1","\u9EFE\u5650\u9D93\u9DBD\u9DC0\u9DFC\u94F6\u8FB6\u9E7B\u9EAC\u9EB1\u9EBD\u9EC6\u94DC\u9EE2\u9EF1\u9EF8\u7AC8\u9F44\uD840\uDC94\uD840\uDEB7\uD840\uDFA0\u691A\u94C3\u59AC\uD841\uDCD7\u5840\u94C1\u37B9\uD841\uDDD5\uD841\uDE15\uD841\uDE76\uD845\uDEBA\u5757\u7173\uD842\uDEC2\uD842\uDECD\uD842\uDFBF\u546A\uD87E\uDC3B\uD842\uDFCB\u549E\uD842\uDFFB\uD843\uDC3B\uD843\uDC53\uD843\uDC65\uD843\uDC7C\u60E7\uD843\uDC8D\u567A\uD843\uDCB5\uD843\uDCDD\uD843\uDCED\uD843\uDD6F\uD843\uDDB2\uD843\uDDC8\u6955\u9C2F\u87A5\uD843\uDE04\uD843\uDE0E\uD843\uDED7\uD843\uDF90\uD843\uDF2D\uD843\uDE73\u5C20\uD843\uDFBC\u5E0B\uD844\uDC5C\uD844\uDC4F\uD844\uDC76\u671E\uD844\uDC7B\uD844\uDC88\uD844\uDC96\u3647\uD844\uDCBF\uD844\uDCD3\uD844\uDD2F\uD844\uDD3B\u5364\u84AD\uD844\uDEE3\uD844\uDF75\uD844\uDF36\u8B81\uD845\uDD77\uD845\uDE19\uD845\uDFC3\uD845\uDFC7\u4E78\u70BB\uD846\uDC2D\uD846\uDD6A"],["9b40","\uD846\uDE2D\uD846\uDE45\uD847\uDC2A\uD847\uDC70\uD847\uDCAC\uD847\uDEC8\u62C3\uD847\uDED5\uD847\uDF15\u7198\u6855\uD848\uDC45\u69E9\u36C8\uD848\uDE7C\uD848\uDFD7\uD848\uDFFA\uD849\uDF2A\uD84A\uDC71\uD84A\uDD4F\u82FD\uD84A\uDD67\uD84A\uDD93\uD84A\uDED5\u89A5\uD84A\uDEE8\u8FA0\uD84A\uDF0E\u97B8\uD84A\uDF3F\u9847\u9ABD\uD84B\uDC4C"],["9b62","\uD84B\uDC88\uD84B\uDCB7\uD856\uDFE8\uD84B\uDD08\uD84B\uDD12\uD84B\uDDB7\uD84B\uDD95\uD84B\uDE42\uD84B\uDF74\uD84B\uDFCC\uD84C\uDC33\uD84C\uDC66\uD84C\uDF1F\uD84C\uDFDE\u5FB1\u6648\u66BF\uD85E\uDE79\uD84D\uDD67\uD84D\uDDF3\u7201\uD852\uDDBA\u77D7\uD84D\uDE1A\uD84D\uDF16\u7E87\uD840\uDF46\u58B5\u670E"],["9ba1","\u6918\uD84E\uDEA7\uD85D\uDE57\uD857\uDFE2\uD84F\uDE11\uD84F\uDEB9\uD85D\uDDFE\uD848\uDC9A\u48D0\u4AB8\uD850\uDD19\uD862\uDE9A\uD850\uDEEE\uD850\uDF0D\uD850\uDC3B\uD850\uDF34\uD850\uDF96\uD852\uDE45\uD841\uDDCA\u51D2\uD841\uDE11\u599F\uD847\uDEA8\u3BBE\uD84F\uDCFF\uD851\uDC04\uD851\uDCD6\u5788\uD851\uDE74\u399B\uD851\uDF2F\uD861\uDDE8\uD866\uDDC9\u3762\uD848\uDDC3\u8B5E\uD862\uDF4E\u99D6\uD852\uDC12\uD852\uDCFB\uD852\uDE15\u7209\uD852\uDEC0\uD843\uDC78\u5965\uD853\uDEA5\uD853\uDF86\uD841\uDF79\u8EDA\uD854\uDC2C\u528F\u573F\u7171\uD854\uDE99\uD855\uDC19\uD84F\uDF4A\uD852\uDEA7\u55BC\uD855\uDC46\uD855\uDC6E\uD85A\uDF52\u91D4\u3473\uD855\uDD3F\uD85D\uDE32\uD855\uDD5E\u4718\uD855\uDD62\uD855\uDD66\uD855\uDFC7\uD852\uDD3F\uD856\uDC5D\u5066\u34FB\uD84C\uDFCC\u60DE\uD856\uDD03\u477C\uD862\uDD48\uD856\uDEAE\uD856\uDF89\uD857\uDC06\uD847\uDD90\u57A1\u7151\u6FB6\uD858\uDD02\uD85F\uDC12\u9056\uD858\uDDB2\uD853\uDF9A\u8B62\uD859\uDC02\uD859\uDC4A"],["9c40","\u5D5B\uD85A\uDFF7\u8F36\uD859\uDC84\uD846\uDD1C\u8AEA\uD852\uDDF6\uD859\uDC88\uD84F\uDFEF\uD859\uDD12\u4BC0\uD859\uDDBF\uD859\uDEB5\uD849\uDF1B\u9465\uD855\uDFE1\u6195\u5A27\uD87E\uDCCD\u4FBB\u56B9\uD851\uDD21\uD859\uDEFC\u4E6A\uD852\uDD34\u9656\u6D8F\uD85B\uDCBD\u3618\u8977\uD859\uDF99\uD85A\uDC6E\uD859\uDC11\uD85A\uDC5E\u71DF\uD85A\uDCC7\u7B42\uD864\uDCC0\uD842\uDE11\uD85A\uDD26\u9104\uD85A\uDD39\u7A45\u9DF0\uD85A\uDDFA\u9A26\uD85A\uDE2D\u365F\uD859\uDC69\uD840\uDC21\u7983\uD85A\uDE34\uD85A\uDF5B\u5D2C\uD84D\uDD19\u83CF\uD85A\uDF9D\u46D0\uD85B\uDCA4\u753B\u8865\uD85B\uDDAE\u58B6"],["9ca1","\u371C\uD849\uDD8D\uD85C\uDC4B\uD85C\uDDCD\u3C54\uD85C\uDE80\uD85C\uDE85\u9281\uD848\uDD7A\uD85C\uDE8B\u9330\uD85C\uDEE6\uD852\uDDD0\u6C39\u949F\uD85D\uDC50\uD843\uDEF8\u8827\u88F5\uD84A\uDD26\uD861\uDC73\uD845\uDFB1\u6EB8\uD852\uDE2A\uD846\uDC20\u39A4\u36B9\u5C10\u79E3\u453F\u66B6\uD867\uDCAD\uD866\uDCA4\u8943\uD85D\uDFCC\uD85E\uDC58\u56D6\u40DF\uD845\uDE0A\u39A1\uD84D\uDF2F\uD860\uDCE8\uD844\uDFC5\u71AD\u8366\uD85E\uDDDD\uD864\uDDA8\u5A67\u4CB7\uD85C\uDCAF\uD862\uDDAB\uD85E\uDDFD\uD85E\uDE0A\uD85E\uDF0B\uD85F\uDD66\uD850\uDD7A\u7B43\u797E\uD860\uDC09\u6FB5\uD868\uDEDF\u6A03\uD860\uDF18\u53A2\uD85B\uDE07\u93BF\u6836\u975D\uD860\uDD6F\uD860\uDC23\uD85A\uDDB5\uD844\uDFED\uD84C\uDE2F\uD860\uDC48\u5D85\uD863\uDC30\uD860\uDC83\u5715\u9823\uD862\uDD49\u5DAB\uD852\uDD88\u65BE\u69D5\u53D2\uD852\uDEA5\uD84F\uDF81\u3C11\u6736\uD860\uDC90\uD860\uDCF4\uD860\uDD2E\uD847\uDFA1\uD860\uDD4F"],["9d40","\uD860\uDD89\uD860\uDDAF\uD860\uDE1A\uD860\uDF06\uD860\uDF2F\uD860\uDF8A\u35CA\uD861\uDC68\uD861\uDEAA\u48FA\u63E6\uD862\uDD56\u7808\u9255\uD862\uDDB8\u43F2\uD862\uDDE7\u43DF\uD862\uDDE8\uD862\uDF46\uD862\uDFD4\u59F8\uD863\uDC09\u8F0B\uD863\uDFC5\uD864\uDCEC\u7B51\uD864\uDD10\uD864\uDD3C\u3DF7\uD864\uDD5E\uD852\uDECA\u8FD0\u728F\u568B\uD865\uDCE7\uD865\uDDE9\uD865\uDDB0\uD865\uDDB8\uD865\uDF32\uD866\uDCD1\uD866\uDD49\uD866\uDD6A\uD866\uDDC3\uD866\uDE28\uD866\uDF0E\uD867\uDD5A\uD867\uDD9B\u7E9F\uD867\uDEF8\uD867\uDF23\u4CA4\u9547\uD868\uDE93\u71A2\uD868\uDEFF\u4D91\u9012\uD869\uDDCB\u4D9C\uD843\uDC9C\u8FBE\u55C1"],["9da1","\u8FBA\uD849\uDCB0\u8FB9\uD852\uDE93\u4509\u7E7F\u6F56\u6AB1\u4EEA\u34E4\uD862\uDF2C\uD85E\uDC9D\u373A\u8E80\uD845\uDFF5\uD860\uDC24\uD862\uDF6C\uD862\uDF99\uD85E\uDE3E\uD859\uDEAF\u3DEB\uD85D\uDE55\uD84F\uDCB7\uD855\uDE35\uD856\uDD56\u4E9A\uD857\uDE81\uD858\uDE58\u56BF\uD843\uDE6D\u8E0E\u5B6D\uD84F\uDE88\uD853\uDC9E\u63DE\u62D0\uD845\uDFF6\uD846\uDC7B\u6530\u562D\uD857\uDC4A\u541A\uD854\uDF11\u3DC6\uD867\uDD98\u4C7D\u5622\u561E\u7F49\uD857\uDED8\u5975\uD84F\uDD40\u8770\u4E1C\uD843\uDFEA\uD843\uDD49\uD84D\uDEBA\u8117\u9D5E\u8D18\u763B\u9C45\u764E\u77B9\u9345\u5432\u8148\u82F7\u5625\u8132\u8418\u80BD\u55EA\u7962\u5643\u5416\uD843\uDE9D\u35CE\u5605\u55F1\u66F1\uD860\uDEE2\u362D\u7534\u55F0\u55BA\u5497\u5572\uD843\uDC41\uD843\uDC96\u5ED0\uD854\uDD48\uD843\uDE76\uD84B\uDC62"],["9e40","\uD843\uDEA2\u9EAB\u7D5A\u55DE\uD844\uDC75\u629D\u976D\u5494\u8CCD\u71F6\u9176\u63FC\u63B9\u63FE\u5569\uD84A\uDF43\u9C72\uD84B\uDEB3\u519A\u34DF\uD843\uDDA7\u51A7\u544D\u551E\u5513\u7666\u8E2D\uD85A\uDC8A\u75B1\u80B6\u8804\u8786\u88C7\u81B6\u841C\uD844\uDCC1\u44EC\u7304\uD851\uDF06\u5B90\u830B\uD85A\uDC93\u567B\uD849\uDEF4\uD85F\uDD2F\uD850\uDDA3\uD85F\uDD73\uD85B\uDED0\uD85C\uDEB6\u9170\uD844\uDDD9\u9208\uD84F\uDCFC\uD869\uDEA9\uD843\uDEAC\uD843\uDEF9\u7266\uD847\uDCA2\u474E\uD853\uDFC2\uD85F\uDFF9\uD843\uDFEB\u40FA"],["9ea1","\u9C5D\u651F\uD84B\uDDA0\u48F3\uD851\uDFE0\uD867\uDD7C\uD843\uDFEC\uD843\uDE0A\u6062\uD85D\uDDA3\uD843\uDFED"],["9ead","\uD858\uDC48\uD844\uDD87\u71A3\u7E8E\u9D50\u4E1A\u4E04\u3577\u5B0D\u6CB2\u5367\u36AC\u39DC\u537D\u36A5\uD851\uDE18\u589A\uD852\uDF6E\u822D\u544B\u57AA\uD856\uDE95\uD842\uDD79"],["9ec5","\u3A52\uD849\uDC65\u7374\uD867\uDEAC\u4D09\u9BED\uD84F\uDCFE\uD867\uDF30\u4C5B\uD853\uDFA9\uD865\uDD9E\uD867\uDFDE\u845C\uD84F\uDDB6\uD85C\uDEB2\uD859\uDFB3\uD84D\uDF20\u632E\u7D25\uD84F\uDEF7\uD84F\uDE2C\u3A2A\u9008\u52CC\u3E74\u367A\u45E9\uD841\uDC8E\u7640\u5AF0\uD843\uDEB6\u787A\uD85F\uDF2E\u58A7\u40BF\u567C\u9B8B\u5D74\u7654\uD869\uDC34\u9E85\u4CE1\u75F9\u37FB\u6119\uD84C\uDCDA\uD850\uDFF2"],["9ef5","\u565D\uD844\uDEA9\u57A7\uD852\uDD63\uD867\uDE06\u5234\uD85C\uDCAE\u35AD\u6C4A\u9D7C"],["9f40","\u7C56\u9B39\u57DE\uD845\uDF6C\u5C53\u64D3\uD865\uDCD0\uD858\uDF35\uD85C\uDD64\u86AD\uD843\uDD28\uD85B\uDD22\uD852\uDEE2\uD843\uDD71"],["9f4f","\u51FE\uD847\uDF0F\u5D8E\u9703\uD847\uDDD1\u9E81\u904C\u7B1F\u9B02\u5CD1\u7BA3\u6268\u6335\u9AFF\u7BCF\u9B2A\u7C7E\u9B2E\u7C42\u7C86\u9C15\u7BFC\u9B09\u9F17\u9C1B\uD852\uDD3E\u9F5A\u5573\u5BC3\u4FFD\u9E98\u4FF2\u5260\u3E06\u52D1\u5767\u5056\u59B7\u5E12\u97C8\u9DAB\u8F5C\u5469\u97B4\u9940\u97BA\u532C\u6130"],["9fa1","\u692C\u53DA\u9C0A\u9D02\u4C3B\u9641\u6980\u50A6\u7546\uD845\uDF6D\u99DA\u5273"],["9fae","\u9159\u9681\u915C"],["9fb2","\u9151\uD863\uDE97\u637F\uD85B\uDD23\u6ACA\u5611\u918E\u757A\u6285\uD840\uDFFC\u734F\u7C70\uD857\uDC21\uD84F\uDCFD"],["9fc1","\uD852\uDD19\u76D6\u9B9D\u4E2A\uD843\uDCD4\u83BE\u8842"],["9fc9","\u5C4A\u69C0\u50ED\u577A\u521F\u5DF5\u4ECE\u6C31\uD840\uDDF2\u4F39\u549C\u54DA\u529A\u8D82\u35FE\u5F0C\u35F3"],["9fdb","\u6B52\u917C\u9FA5\u9B97\u982E\u98B4\u9ABA\u9EA8\u9E84\u717A\u7B14"],["9fe7","\u6BFA\u8818\u7F78"],["9feb","\u5620\uD869\uDE4A\u8E77\u9F53"],["9ff0","\u8DD4\u8E4F\u9E1C\u8E01\u6282\uD860\uDF7D\u8E28\u8E75\u7AD3\uD852\uDE77\u7A3E\u78D8\u6CEA\u8A67\u7607"],["a040","\uD862\uDE5A\u9F26\u6CCE\u87D6\u75C3\uD868\uDEB2\u7853\uD87E\uDC40\u8D0C\u72E2\u7371\u8B2D\u7302\u74F1\u8CEB\uD852\uDEBB\u862F\u5FBA\u88A0\u44B7"],["a055","\uD846\uDC3B\uD85B\uDE05"],["a058","\u8A7E\uD849\uDD1B"],["a05b","\u60FD\u7667\u9AD7\u9D44\u936E\u9B8F\u87F5"],["a063","\u880F\u8CF7\u732C\u9721\u9BB0\u35D6\u72B2\u4C07\u7C51\u994A\uD858\uDD59\u6159\u4C04\u9E96\u617D"],["a073","\u575F\u616F\u62A6\u6239\u62CE\u3A5C\u61E2\u53AA\uD84C\uDFF5\u6364\u6802\u35D2"],["a0a1","\u5D57\uD862\uDFC2\u8FDA\uD863\uDE39"],["a0a6","\u50D9\uD847\uDD46\u7906\u5332\u9638\uD843\uDF3B\u4065"],["a0ae","\u77FE"],["a0b0","\u7CC2\uD857\uDF1A\u7CDA\u7A2D\u8066\u8063\u7D4D\u7505\u74F2\u8994\u821A\u670C\u8062\uD85D\uDC86\u805B\u74F0\u8103\u7724\u8989\uD859\uDFCC\u7553\uD85B\uDED1\u87A9\u87CE\u81C8\u878C\u8A49\u8CAD\u8B43\u772B\u74F8\u84DA\u3635\u69B2\u8DA6"],["a0d4","\u89A9\u7468\u6DB9\u87C1\uD850\uDC11\u74E7\u3DDB\u7176\u60A4\u619C\u3CD1\u7162\u6077"],["a0e2","\u7F71\uD862\uDF2D\u7250\u60E9\u4B7E\u5220\u3C18\uD84F\uDCC7\uD857\uDED7\uD85D\uDE56\uD855\uDD31\uD846\uDD44\uD844\uDEFE\uD866\uDD03\uD85B\uDDDC\uD85C\uDCAD\u5CC1\uD858\uDDAD\uD862\uDE0F\uD84D\uDE77\uD840\uDCEE\uD85A\uDC46\uD853\uDF0E\u4562\u5B1F\uD858\uDF4C\u9F50\u9EA6\uD858\uDE6B"],["a3c0","\u2400",31,"\u2421"],["c6a1","\u2460",9,"\u2474",9,"\u2170",9,"\u4E36\u4E3F\u4E85\u4EA0\u5182\u5196\u51AB\u52F9\u5338\u5369\u53B6\u590A\u5B80\u5DDB\u2F33\u5E7F\u5EF4\u5F50\u5F61\u6534\u65E0\u7592\u7676\u8FB5\u96B6\xa8\u02C6\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\uFF3B\uFF3D\u273D\u3041",23],["c740","\u3059",58,"\u30A1\u30A2\u30A3\u30A4"],["c7a1","\u30A5",81,"\u0410",5,"\u0401\u0416",4],["c840","\u041B",26,"\u0451\u0436",25,"\u21E7\u21B8\u21B9\u31CF\uD840\uDCCC\u4E5A\uD840\uDC8A\u5202\u4491"],["c8a1","\u9FB0\u5188\u9FB1\uD85D\uDE07"],["c8cd","\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u309B\u309C\u2E80\u2E84\u2E86\u2E87\u2E88\u2E8A\u2E8C\u2E8D\u2E95\u2E9C\u2E9D\u2EA5\u2EA7\u2EAA\u2EAC\u2EAE\u2EB6\u2EBC\u2EBE\u2EC6\u2ECA\u2ECC\u2ECD\u2ECF\u2ED6\u2ED7\u2EDE\u2EE3"],["c8f5","\u0283\u0250\u025B\u0254\u0275\u0153\xf8\u014B\u028A\u026A"],["f9fe","\uFFED"],["fa40","\uD841\uDD47\u92DB\uD841\uDDDF\uD84F\uDFC5\u854C\u42B5\u73EF\u51B5\u3649\uD852\uDD42\uD862\uDDE4\u9344\uD846\uDDDB\u82EE\uD84F\uDCC8\u783C\u6744\u62DF\uD852\uDD33\uD862\uDDAA\uD840\uDEA0\uD85A\uDFB3\uD844\uDF05\u4FAB\uD849\uDCED\u5008\uD85B\uDD29\uD85E\uDE84\uD84D\uDE00\uD852\uDEB1\uD849\uDD13\u5029\uD840\uDF7E\u5FA4\uD840\uDF80\uD840\uDF47\u6EDB\uD841\uDC1F\u507D\u5101\u347A\u510E\u986C\u3743\u8416\uD852\uDDA4\uD841\uDC87\u5160\uD84C\uDFB4\u516A\uD842\uDFFF\uD848\uDCFC\uD840\uDEE5\uD849\uDD30\uD841\uDD8E\uD84C\uDE33\uD846\uDD83\u5B82\u877D\uD841\uDDB3\uD84F\uDC99\u51B2\u51B8"],["faa1","\u9D34\u51C9\u51CF\u51D1\u3CDC\u51D3\uD852\uDEA6\u51B3\u51E2\u5342\u51ED\u83CD\u693E\uD84D\uDF2D\u5F7B\u520B\u5226\u523C\u52B5\u5257\u5294\u52B9\u52C5\u7C15\u8542\u52E0\u860D\uD85A\uDF13\u5305\uD862\uDEDE\u5549\u6ED9\uD84F\uDF80\uD842\uDD54\uD84F\uDFEC\u5333\u5344\uD842\uDFE2\u6CCB\uD845\uDF26\u681B\u73D5\u604A\u3EAA\u38CC\uD845\uDEE8\u71DD\u44A2\u536D\u5374\uD861\uDEAB\u537E\u537F\uD845\uDD96\uD845\uDE13\u77E6\u5393\uD862\uDE9B\u53A0\u53AB\u53AE\u73A7\uD855\uDF72\u3F59\u739C\u53C1\u53C5\u6C49\u4E49\u57FE\u53D9\u3AAB\uD842\uDF8F\u53E0\uD84F\uDFEB\uD84B\uDDA3\u53F6\uD843\uDC77\u5413\u7079\u552B\u6657\u6D5B\u546D\uD85A\uDF53\uD843\uDD74\u555D\u548F\u54A4\u47A6\uD845\uDF0D\uD843\uDEDD\u3DB4\uD843\uDD4D"],["fb40","\uD862\uDDBC\uD849\uDE98\u5547\u4CED\u542F\u7417\u5586\u55A9\u5605\uD846\uDCD7\uD850\uDC3A\u4552\uD851\uDC35\u66B3\uD844\uDCB4\u5637\u66CD\uD84C\uDE8A\u66A4\u66AD\u564D\u564F\u78F1\u56F1\u9787\u53FE\u5700\u56EF\u56ED\uD862\uDF66\u3623\uD844\uDE4F\u5746\uD850\uDDA5\u6C6E\u708B\u5742\u36B1\uD85B\uDC7E\u57E6\uD845\uDC16\u5803\uD845\uDC54\uD850\uDF63\u5826\uD852\uDFF5\u585C\u58AA\u3561\u58E0\u58DC\uD844\uDE3C\u58FB\u5BFF\u5743\uD868\uDD50\uD850\uDE78\u93D3\u35A1\u591F\u68A6\u36C3\u6E59"],["fba1","\uD845\uDE3E\u5A24\u5553\uD845\uDE92\u8505\u59C9\uD843\uDD4E\uD85B\uDC81\uD85B\uDD2A\uD845\uDFDC\u59D9\uD845\uDFFB\uD845\uDFB2\uD85B\uDDA6\u6D71\uD846\uDC28\uD845\uDED5\u59F9\uD85B\uDE45\u5AAB\u5A63\u36E6\uD852\uDDA9\u5A77\u3708\u5A96\u7465\u5AD3\uD85B\uDFA1\uD849\uDD54\u3D85\uD846\uDD11\u3732\uD845\uDEB8\u5E83\u52D0\u5B76\u6588\u5B7C\uD85E\uDE0E\u4004\u485D\uD840\uDE04\u5BD5\u6160\uD846\uDE34\uD856\uDDCC\uD841\uDDA5\u5BF3\u5B9D\u4D10\u5C05\uD846\uDF44\u5C13\u73CE\u5C14\uD847\uDCA5\uD85A\uDF28\u5C49\u48DD\u5C85\u5CE9\u5CEF\u5D8B\uD847\uDDF9\uD847\uDE37\u5D10\u5D18\u5D46\uD847\uDEA4\u5CBA\u5DD7\u82FC\u382D\uD852\uDD01\uD848\uDC49\uD848\uDD73\u8287\u3836\u3BC2\u5E2E\u6A8A\u5E75\u5E7A\uD851\uDCBC\uD843\uDCD3\u53A6\u4EB7\u5ED0\u53A8\uD845\uDF71\u5E09\u5EF4\uD861\uDC82"],["fc40","\u5EF9\u5EFB\u38A0\u5EFC\u683E\u941B\u5F0D\uD840\uDDC1\uD87E\uDC94\u3ADE\u48AE\uD844\uDF3A\u5F3A\uD85A\uDC88\uD848\uDFD0\u5F58\uD849\uDC71\u5F63\u97BD\uD85B\uDE6E\u5F72\u9340\uD862\uDE36\u5FA7\u5DB6\u3D5F\uD854\uDE50\uD847\uDF6A\uD85C\uDCF8\uD849\uDE68\u91D6\uD840\uDE9E\uD862\uDE29\u6031\u6685\uD846\uDC77\u3963\u3DC7\u3639\u5790\uD849\uDFB4\u7971\u3E40\u609E\u60A4\u60B3\uD852\uDD82\uD852\uDD8F\uD85E\uDE53\u74A4\u50E1\u5AA0\u6164\u8424\u6142\uD87E\uDCA6\uD85B\uDED2\u6181\u51F4\uD841\uDE56\u6187\u5BAA\uD84F\uDFB7"],["fca1","\uD84A\uDC5F\u61D3\uD862\uDF9D\uD866\uDD5D\u61D0\u3932\uD84A\uDD80\uD84A\uDCC1\u6023\u615C\u651E\u638B\uD840\uDD18\u62C5\uD845\uDF70\u62D5\uD84B\uDE0D\u636C\uD852\uDDDF\u3A17\u6438\u63F8\uD844\uDF8E\uD845\uDFFC\u6490\u6F8A\uD84B\uDE36\u9814\uD850\uDC8C\uD855\uDF1D\u64E1\u64E5\u947B\u3A66\u643A\u3A57\u654D\u6F16\uD852\uDE28\uD852\uDE23\u6585\u656D\u655F\uD84C\uDC7E\u65B5\uD852\uDD40\u4B37\u65D1\u40D8\uD846\uDC29\u65E0\u65E3\u5FDF\uD84D\uDC00\u6618\uD84C\uDDF7\uD84C\uDDF8\u6644\uD84C\uDDA4\uD84C\uDDA5\u664B\uD843\uDE75\u6667\uD854\uDDE6\u6673\u6674\uD847\uDE3D\uD84C\uDE31\uD861\uDDF4\uD84C\uDDC8\uD854\uDF13\u77C5\uD84A\uDCF7\u99A4\u6702\uD850\uDF9C\uD852\uDE21\u3B2B\u69FA\uD84D\uDFC2\u675E\u6767\u6762\uD850\uDDCD\uD864\uDCED\u67D7\u44E9\u6822\u6E50\u923C\u6801\uD84C\uDFE6\uD85B\uDDA0\u685D"],["fd40","\uD84D\uDC6F\u69E1\u6A0B\uD862\uDEDF\u6973\u68C3\uD84D\uDDCD\u6901\u6900\u3D32\u3A01\uD84D\uDE3C\u3B80\u67AC\u6961\uD862\uDE4A\u42FC\u6936\u6998\u3BA1\uD840\uDFC9\u8363\u5090\u69F9\uD84D\uDE59\uD848\uDD2A\u6A45\uD84D\uDF03\u6A9D\u3BF3\u67B1\u6AC8\uD864\uDD9C\u3C0D\u6B1D\uD842\uDD23\u60DE\u6B35\u6B74\uD849\uDFCD\u6EB5\uD84E\uDEDB\uD840\uDFB5\uD846\uDD58\u3740\u5421\uD84E\uDF5A\u6BE1\uD84F\uDEFC\u6BDC\u6C37\uD849\uDC8B\uD852\uDCF1\uD85A\uDF51\u6C5A\u8226\u6C79\uD84F\uDDBC\u44C5\uD84F\uDDBD\uD850\uDDA4\uD852\uDD0C\uD852\uDD00"],["fda1","\uD84F\uDCC9\u36E5\u3CEB\uD843\uDD32\u9B83\uD84C\uDDF9\uD849\uDC91\u7F8F\u6837\uD85B\uDD25\uD85B\uDDA1\uD85B\uDDEB\u6D96\u6D5C\u6E7C\u6F04\uD852\uDD7F\uD850\uDC85\uD85B\uDE72\u8533\uD85B\uDF74\u51C7\u6C9C\u6E1D\u842E\uD862\uDF21\u6E2F\uD84F\uDE2F\u7453\uD84F\uDF82\u79CC\u6E4F\u5A91\uD84C\uDC4B\u6FF8\u370D\u6F9D\uD84F\uDE30\u6EFA\uD845\uDC97\uD850\uDC3D\u4555\u93F0\u6F44\u6F5C\u3D4E\u6F74\uD864\uDD70\u3D3B\u6F9F\uD850\uDD44\u6FD3\uD850\uDC91\uD850\uDD55\uD850\uDC39\uD84F\uDFF0\uD84F\uDFB4\uD850\uDD3F\u51DF\uD850\uDD56\uD850\uDD57\uD850\uDD40\uD858\uDDDD\u704B\u707E\u70A7\u7081\u70CC\u70D5\u70D6\u70DF\u4104\u3DE8\u71B4\u7196\uD850\uDE77\u712B\u7145\u5A88\u714A\u716E\u5C9C\uD850\uDF65\u714F\u9362\uD850\uDEC1\u712C\uD851\uDC5A\uD852\uDE27\uD852\uDE22\u71BA\uD862\uDFE8\u70BD\u720E"],["fe40","\u9442\u7215\u5911\u9443\u7224\u9341\uD855\uDE05\u722E\u7240\uD852\uDD74\u68BD\u7255\u7257\u3E55\uD84C\uDC44\u680D\u6F3D\u7282\u732A\u732B\uD852\uDC23\uD862\uDC2B\u48ED\uD862\uDC04\u7328\u732E\u73CF\u73AA\uD843\uDC3A\uD85A\uDE2E\u73C9\u7449\uD850\uDDE2\uD845\uDEE7\uD852\uDE24\u6623\u36C5\uD852\uDDB7\uD852\uDD8D\uD852\uDDFB\u73F7\u7415\u6903\uD852\uDE26\u7439\uD841\uDDC3\u3ED7\u745C\uD84A\uDCAD\u7460\uD863\uDEB2\u7447\u73E4\u7476\u83B9\u746C\u3730\u7474\u93F1\u6A2C\u7482\u4953\uD852\uDE8C"],["fea1","\uD850\uDD5F\uD852\uDE79\uD862\uDF8F\u5B46\uD863\uDC03\uD846\uDC9E\u74C8\uD846\uDD88\u750E\u74E9\u751E\uD863\uDED9\uD846\uDE4B\u5BD7\uD863\uDEAC\u9385\u754D\u754A\u7567\u756E\uD853\uDF82\u3F04\uD853\uDD13\u758E\u745D\u759E\u75B4\u7602\u762C\u7651\u764F\u766F\u7676\uD858\uDFF5\u7690\u81EF\u37F8\uD85A\uDD11\uD85A\uDD0E\u76A1\u76A5\u76B7\u76CC\uD85B\uDF9F\u8462\uD854\uDC9D\uD854\uDD7D\uD847\uDE1C\u771E\u7726\u7740\u64AF\uD854\uDE20\u7758\uD84C\uDEAC\u77AF\uD862\uDD64\uD862\uDD68\uD845\uDEC1\u77F4\u7809\uD844\uDF76\uD852\uDE12\u68CA\u78AF\u78C7\u78D3\u96A5\u792E\uD855\uDDE0\u78D7\u7934\u78B1\uD85D\uDE0C\u8FB8\u8884\uD862\uDF2B\uD858\uDC83\uD849\uDE1C\u7986\u8900\u6902\u7980\uD856\uDC57\u799D\uD85E\uDF39\u793C\u79A9\u6E2A\uD85C\uDD26\u3EA8\u79C6\uD864\uDD0D\u79D4"]]');
            /***/ },
            /***/ 43381: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var forEach = __webpack_require__(68404);
                var availableTypedArrays = __webpack_require__(10821);
                var callBind = __webpack_require__(26601);
                var callBound = __webpack_require__(22774);
                var gOPD = __webpack_require__(68109);
                var getProto = __webpack_require__(87106);
                var $toString = callBound('Object.prototype.toString');
                var hasToStringTag = __webpack_require__(26626)();
                var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
                var typedArrays = availableTypedArrays();
                var $slice = callBound('String.prototype.slice');
                /** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
                    for(var i = 0; i < array.length; i += 1){
                        if (array[i] === value) return i;
                    }
                    return -1;
                };
                /** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var cache = {
                    __proto__: null
                };
                if (hasToStringTag && gOPD && getProto) forEach(typedArrays, function(typedArray) {
                    var arr = new g[typedArray]();
                    if (Symbol.toStringTag in arr && getProto) {
                        var proto = getProto(arr);
                        // @ts-expect-error TS won't narrow inside a closure
                        var descriptor = gOPD(proto, Symbol.toStringTag);
                        if (!descriptor && proto) {
                            var superProto = getProto(proto);
                            // @ts-expect-error TS won't narrow inside a closure
                            descriptor = gOPD(superProto, Symbol.toStringTag);
                        }
                        // @ts-expect-error TODO: fix
                        cache['$' + typedArray] = callBind(descriptor.get);
                    }
                });
                else forEach(typedArrays, function(typedArray) {
                    var arr = new g[typedArray]();
                    var fn = arr.slice || arr.set;
                    if (fn) cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
                    callBind(fn);
                });
                /** @type {(value: object) => false | import('.').TypedArrayName} */ var tryTypedArrays = function tryAllTypedArrays(value) {
                    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
                    forEach(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
                        if (!found) try {
                            // @ts-expect-error a throw is fine here
                            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $slice(typedArray, 1);
                        } catch (e) {}
                    });
                    return found;
                };
                /** @type {(value: object) => false | import('.').TypedArrayName} */ var trySlices = function tryAllSlices(value) {
                    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
                    forEach(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
                        if (!found) try {
                            // @ts-expect-error a throw is fine here
                            getter(value);
                            found = /** @type {import('.').TypedArrayName} */ $slice(name, 1);
                        } catch (e) {}
                    });
                    return found;
                };
                /** @type {import('.')} */ module1.exports = function whichTypedArray(value) {
                    if (!value || typeof value !== 'object') return false;
                    if (!hasToStringTag) {
                        /** @type {string} */ var tag = $slice($toString(value), 8, -1);
                        if ($indexOf(typedArrays, tag) > -1) return tag;
                        if (tag !== 'Object') return false;
                        // node < 0.6 hits here on real Typed Arrays
                        return trySlices(value);
                    }
                    if (!gOPD) return null;
                     // unknown engine
                    return tryTypedArrays(value);
                };
            /***/ },
            /***/ 43765: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Ported from https://github.com/mafintosh/pump with
                // permission from the author, Mathias Buus (@mafintosh).
                var eos;
                function once(callback) {
                    var called = false;
                    return function() {
                        if (called) return;
                        called = true;
                        callback.apply(void 0, arguments);
                    };
                }
                var _require$codes = __webpack_require__(83797)/* .codes */ .F, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
                function noop(err) {
                    // Rethrow the error if it exists to avoid swallowing it
                    if (err) throw err;
                }
                function isRequest(stream) {
                    return stream.setHeader && typeof stream.abort === 'function';
                }
                function destroyer(stream, reading, writing, callback) {
                    callback = once(callback);
                    var closed = false;
                    stream.on('close', function() {
                        closed = true;
                    });
                    if (eos === undefined) eos = __webpack_require__(12167);
                    eos(stream, {
                        readable: reading,
                        writable: writing
                    }, function(err) {
                        if (err) return callback(err);
                        closed = true;
                        callback();
                    });
                    var destroyed = false;
                    return function(err) {
                        if (closed) return;
                        if (destroyed) return;
                        destroyed = true;
                        // request.destroy just do .end - .abort is what we want
                        if (isRequest(stream)) return stream.abort();
                        if (typeof stream.destroy === 'function') return stream.destroy();
                        callback(err || new ERR_STREAM_DESTROYED('pipe'));
                    };
                }
                function call(fn) {
                    fn();
                }
                function pipe(from, to) {
                    return from.pipe(to);
                }
                function popCallback(streams) {
                    if (!streams.length) return noop;
                    if (typeof streams[streams.length - 1] !== 'function') return noop;
                    return streams.pop();
                }
                function pipeline() {
                    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
                    var callback = popCallback(streams);
                    if (Array.isArray(streams[0])) streams = streams[0];
                    if (streams.length < 2) throw new ERR_MISSING_ARGS('streams');
                    var error;
                    var destroys = streams.map(function(stream, i) {
                        var reading = i < streams.length - 1;
                        var writing = i > 0;
                        return destroyer(stream, reading, writing, function(err) {
                            if (!error) error = err;
                            if (err) destroys.forEach(call);
                            if (reading) return;
                            destroys.forEach(call);
                            callback(error);
                        });
                    });
                    return streams.reduce(pipe);
                }
                module1.exports = pipeline;
            /***/ },
            /***/ 43977: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var arraySlice = __webpack_require__(73163);
                var floor = Math.floor;
                var mergeSort = function(array, comparefn) {
                    var length = array.length;
                    var middle = floor(length / 2);
                    return length < 8 ? insertionSort(array, comparefn) : merge(array, mergeSort(arraySlice(array, 0, middle), comparefn), mergeSort(arraySlice(array, middle), comparefn), comparefn);
                };
                var insertionSort = function(array, comparefn) {
                    var length = array.length;
                    var i = 1;
                    var element, j;
                    while(i < length){
                        j = i;
                        element = array[i];
                        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
                        if (j !== i++) array[j] = element;
                    }
                    return array;
                };
                var merge = function(array, left, right, comparefn) {
                    var llength = left.length;
                    var rlength = right.length;
                    var lindex = 0;
                    var rindex = 0;
                    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
                    return array;
                };
                module1.exports = mergeSort;
            /***/ },
            /***/ 44130: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(39081);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(66664), __webpack_require__(4420));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Base = C_lib.Base;
                        var WordArray = C_lib.WordArray;
                        var C_algo = C.algo;
                        var SHA256 = C_algo.SHA256;
                        var HMAC = C_algo.HMAC;
                        /**
     * Password-Based Key Derivation Function 2 algorithm.
     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
                            /**
       * Configuration options.
       *
       * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
       * @property {Hasher} hasher The hasher to use. Default: SHA256
       * @property {number} iterations The number of iterations to perform. Default: 250000
       */ cfg: Base.extend({
                                keySize: 4,
                                hasher: SHA256,
                                iterations: 250000
                            }),
                            /**
       * Initializes a newly created key derivation function.
       *
       * @param {Object} cfg (Optional) The configuration options to use for the derivation.
       *
       * @example
       *
       *     var kdf = CryptoJS.algo.PBKDF2.create();
       *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
       *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
       */ init: function init(cfg) {
                                this.cfg = this.cfg.extend(cfg);
                            },
                            /**
       * Computes the Password-Based Key Derivation Function 2.
       *
       * @param {WordArray|string} password The password.
       * @param {WordArray|string} salt A salt.
       *
       * @return {WordArray} The derived key.
       *
       * @example
       *
       *     var key = kdf.compute(password, salt);
       */ compute: function compute(password, salt) {
                                // Shortcut
                                var cfg = this.cfg;
                                // Init HMAC
                                var hmac = HMAC.create(cfg.hasher, password);
                                // Initial values
                                var derivedKey = WordArray.create();
                                var blockIndex = WordArray.create([
                                    0x00000001
                                ]);
                                // Shortcuts
                                var derivedKeyWords = derivedKey.words;
                                var blockIndexWords = blockIndex.words;
                                var keySize = cfg.keySize;
                                var iterations = cfg.iterations;
                                // Generate key
                                while(derivedKeyWords.length < keySize){
                                    var block = hmac.update(salt).finalize(blockIndex);
                                    hmac.reset();
                                    // Shortcuts
                                    var blockWords = block.words;
                                    var blockWordsLength = blockWords.length;
                                    // Iterations
                                    var intermediate = block;
                                    for(var i = 1; i < iterations; i++){
                                        intermediate = hmac.finalize(intermediate);
                                        hmac.reset();
                                        // Shortcut
                                        var intermediateWords = intermediate.words;
                                        // XOR intermediate with block
                                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                                    }
                                    derivedKey.concat(block);
                                    blockIndexWords[0]++;
                                }
                                derivedKey.sigBytes = keySize * 4;
                                return derivedKey;
                            }
                        });
                        /**
     * Computes the Password-Based Key Derivation Function 2.
     *
     * @param {WordArray|string} password The password.
     * @param {WordArray|string} salt A salt.
     * @param {Object} cfg (Optional) The configuration options to use for this computation.
     *
     * @return {WordArray} The derived key.
     *
     * @static
     *
     * @example
     *
     *     var key = CryptoJS.PBKDF2(password, salt);
     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
     */ C.PBKDF2 = function(password, salt, cfg) {
                            return PBKDF2.create(cfg).compute(password, salt);
                        };
                    })();
                    return CryptoJS.PBKDF2;
                });
            /***/ },
            /***/ 44206: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var floor = Math.floor;
                // `%TypedArray%.prototype.reverse` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
                exportTypedArrayMethod('reverse', function reverse() {
                    var that = this;
                    var length = aTypedArray(that).length;
                    var middle = floor(length / 2);
                    var index = 0;
                    var value;
                    while(index < middle){
                        value = that[index];
                        that[index++] = that[--length];
                        that[length] = value;
                    }
                    return that;
                });
            /***/ },
            /***/ 44455: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var aCallable = __webpack_require__(32631);
                var getBuiltIn = __webpack_require__(38486);
                var call = __webpack_require__(2834);
                var newPromiseCapabilityModule = __webpack_require__(56614);
                var perform = __webpack_require__(61900);
                var iterate = __webpack_require__(80383);
                var PROMISE_ANY_ERROR = 'No one promise resolved';
                // `Promise.any` method
                // https://tc39.es/ecma262/#sec-promise.any
                $({
                    target: 'Promise',
                    stat: true
                }, {
                    any: function any(iterable) {
                        var C = this;
                        var AggregateError1 = getBuiltIn('AggregateError');
                        var capability = newPromiseCapabilityModule.f(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var promiseResolve = aCallable(C.resolve);
                            var errors = [];
                            var counter = 0;
                            var remaining = 1;
                            var alreadyResolved = false;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyRejected = false;
                                remaining++;
                                call(promiseResolve, C, promise).then(function(value) {
                                    if (alreadyRejected || alreadyResolved) return;
                                    alreadyResolved = true;
                                    resolve(value);
                                }, function(error) {
                                    if (alreadyRejected || alreadyResolved) return;
                                    alreadyRejected = true;
                                    errors[index] = error;
                                    --remaining || reject(new AggregateError1(errors, PROMISE_ANY_ERROR));
                                });
                            });
                            --remaining || reject(new AggregateError1(errors, PROMISE_ANY_ERROR));
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /***/ 44610: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var callBound = __webpack_require__(22774);
                var safeRegexTest = __webpack_require__(58843);
                var isFnRegex = safeRegexTest(/^\s*(?:function)?\*/);
                var hasToStringTag = __webpack_require__(26626)();
                var getProto = __webpack_require__(87106);
                var toStr = callBound('Object.prototype.toString');
                var fnToStr = callBound('Function.prototype.toString');
                var getGeneratorFunc = function() {
                    if (!hasToStringTag) return false;
                    try {
                        return Function('return function*() {}')();
                    } catch (e) {}
                };
                /** @type {undefined | false | null | GeneratorFunctionConstructor} */ var GeneratorFunction;
                /** @type {import('.')} */ module1.exports = function isGeneratorFunction(fn) {
                    if (typeof fn !== 'function') return false;
                    if (isFnRegex(fnToStr(fn))) return true;
                    if (!hasToStringTag) {
                        var str = toStr(fn);
                        return str === '[object GeneratorFunction]';
                    }
                    if (!getProto) return false;
                    if (typeof GeneratorFunction === 'undefined') {
                        var generatorFunc = getGeneratorFunc();
                        GeneratorFunction = generatorFunc ? /** @type {GeneratorFunctionConstructor} */ getProto(generatorFunc) : false;
                    }
                    return getProto(fn) === GeneratorFunction;
                };
            /***/ },
            /***/ 45144: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(47044);
                var createPropertyDescriptor = __webpack_require__(97841);
                module1.exports = !fails(function() {
                    var error = Error('a');
                    if (!('stack' in error)) return true;
                    // eslint-disable-next-line es/no-object-defineproperty -- safe
                    Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
                    return error.stack !== 7;
                });
            /***/ },
            /***/ 45314: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                var isFunction = __webpack_require__(91867).isFunction;
                var isUndefined = __webpack_require__(91867).isUndefined;
                //var isNull = require('../helpers').isNull;
                var pack = __webpack_require__(91867).pack;
                var FileSaver = __webpack_require__(15548);
                var saveAs = FileSaver.saveAs;
                var defaultClientFonts = {
                    Roboto: {
                        normal: 'Roboto-Regular.ttf',
                        bold: 'Roboto-Medium.ttf',
                        italics: 'Roboto-Italic.ttf',
                        bolditalics: 'Roboto-MediumItalic.ttf'
                    }
                };
                var globalVfs;
                var globalFonts;
                var globalTableLayouts;
                function Document(docDefinition, tableLayouts, fonts, vfs) {
                    this.docDefinition = docDefinition;
                    this.tableLayouts = tableLayouts || null;
                    this.fonts = fonts || defaultClientFonts;
                    this.vfs = vfs;
                }
                function canCreatePdf() {
                    // Ensure the browser provides the level of support needed
                    try {
                        var arr = new Uint8Array(1);
                        var proto = {
                            foo: function() {
                                return 42;
                            }
                        };
                        Object.setPrototypeOf(proto, Uint8Array.prototype);
                        Object.setPrototypeOf(arr, proto);
                        return arr.foo() === 42;
                    } catch (e) {
                        return false;
                    }
                }
                Document.prototype._createDoc = function(options, cb) {
                    var getExtendedUrl = function(url) {
                        if (typeof url === 'object') return {
                            url: url.url,
                            headers: url.headers
                        };
                        return {
                            url: url,
                            headers: {}
                        };
                    };
                    options = options || {};
                    if (this.tableLayouts) options.tableLayouts = this.tableLayouts;
                    var PdfPrinter = __webpack_require__(81566);
                    var printer = new PdfPrinter(this.fonts);
                    __webpack_require__(48181).bindFS(this.vfs); // bind virtual file system to file system
                    if (!isFunction(cb)) {
                        var doc = printer.createPdfKitDocument(this.docDefinition, options);
                        return doc;
                    }
                    var URLBrowserResolver = __webpack_require__(7785);
                    var urlResolver = new URLBrowserResolver(__webpack_require__(48181));
                    for(var font in this.fonts)if (this.fonts.hasOwnProperty(font)) {
                        if (this.fonts[font].normal) {
                            if (Array.isArray(this.fonts[font].normal)) {
                                var url = getExtendedUrl(this.fonts[font].normal[0]);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].normal[0] = url.url;
                            } else {
                                var url = getExtendedUrl(this.fonts[font].normal);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].normal = url.url;
                            }
                        }
                        if (this.fonts[font].bold) {
                            if (Array.isArray(this.fonts[font].bold)) {
                                var url = getExtendedUrl(this.fonts[font].bold[0]);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].bold[0] = url.url;
                            } else {
                                var url = getExtendedUrl(this.fonts[font].bold);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].bold = url.url;
                            }
                        }
                        if (this.fonts[font].italics) {
                            if (Array.isArray(this.fonts[font].italics)) {
                                var url = getExtendedUrl(this.fonts[font].italics[0]);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].italics[0] = url.url;
                            } else {
                                var url = getExtendedUrl(this.fonts[font].italics);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].italics = url.url;
                            }
                        }
                        if (this.fonts[font].bolditalics) {
                            if (Array.isArray(this.fonts[font].bolditalics)) {
                                var url = getExtendedUrl(this.fonts[font].bolditalics[0]);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].bolditalics[0] = url.url;
                            } else {
                                var url = getExtendedUrl(this.fonts[font].bolditalics);
                                urlResolver.resolve(url.url, url.headers);
                                this.fonts[font].bolditalics = url.url;
                            }
                        }
                    }
                    if (this.docDefinition.images) {
                        for(var image in this.docDefinition.images)if (this.docDefinition.images.hasOwnProperty(image)) {
                            var url = getExtendedUrl(this.docDefinition.images[image]);
                            urlResolver.resolve(url.url, url.headers);
                            this.docDefinition.images[image] = url.url;
                        }
                    }
                    var _this = this;
                    urlResolver.resolved().then(function() {
                        var doc = printer.createPdfKitDocument(_this.docDefinition, options);
                        cb(doc);
                    }, function(result) {
                        throw result;
                    });
                };
                Document.prototype._flushDoc = function(doc, callback) {
                    var chunks = [];
                    var result;
                    doc.on('readable', function() {
                        var chunk;
                        while((chunk = doc.read(9007199254740991)) !== null)chunks.push(chunk);
                    });
                    doc.on('end', function() {
                        result = Buffer.concat(chunks);
                        callback(result, doc._pdfMakePages);
                    });
                    doc.end();
                };
                Document.prototype._getPages = function(options, cb) {
                    if (!cb) throw '_getPages is an async method and needs a callback argument';
                    var _this = this;
                    this._createDoc(options, function(doc) {
                        _this._flushDoc(doc, function(ignoreBuffer, pages) {
                            cb(pages);
                        });
                    });
                };
                Document.prototype._bufferToBlob = function(buffer) {
                    var blob;
                    try {
                        blob = new Blob([
                            buffer
                        ], {
                            type: 'application/pdf'
                        });
                    } catch (e) {
                        // Old browser which can't handle it without making it an byte array (ie10)
                        if (e.name === 'InvalidStateError') {
                            var byteArray = new Uint8Array(buffer);
                            blob = new Blob([
                                byteArray.buffer
                            ], {
                                type: 'application/pdf'
                            });
                        }
                    }
                    if (!blob) throw 'Could not generate blob';
                    return blob;
                };
                Document.prototype._openWindow = function() {
                    // we have to open the window immediately and store the reference
                    // otherwise popup blockers will stop us
                    var win = window.open('', '_blank');
                    if (win === null) throw 'Open PDF in new window blocked by browser';
                    return win;
                };
                Document.prototype._openPdf = function(options, win) {
                    if (!win) win = this._openWindow();
                    try {
                        this.getBlob(function(result) {
                            var urlCreator = window.URL || window.webkitURL;
                            var pdfUrl = urlCreator.createObjectURL(result);
                            win.location.href = pdfUrl;
                        /* temporarily disabled
			if (win !== window) {
				setTimeout(function () {
					if (isNull(win.window)) { // is closed by AdBlock
						window.location.href = pdfUrl; // open in actual window
					}
				}, 500);
			}
			*/ }, options);
                    } catch (e) {
                        win.close();
                        throw e;
                    }
                };
                Document.prototype.open = function(options, win) {
                    options = options || {};
                    options.autoPrint = false;
                    win = win || null;
                    this._openPdf(options, win);
                };
                Document.prototype.print = function(options, win) {
                    options = options || {};
                    options.autoPrint = true;
                    win = win || null;
                    this._openPdf(options, win);
                };
                /**
 * download(defaultFileName = 'file.pdf', cb = null, options = {})
 * or
 * download(cb, options = {})
 */ Document.prototype.download = function(defaultFileName, cb, options) {
                    if (isFunction(defaultFileName)) {
                        if (!isUndefined(cb)) options = cb;
                        cb = defaultFileName;
                        defaultFileName = null;
                    }
                    defaultFileName = defaultFileName || 'file.pdf';
                    this.getBlob(function(result) {
                        saveAs(result, defaultFileName);
                        if (isFunction(cb)) cb();
                    }, options);
                };
                Document.prototype.getBase64 = function(cb, options) {
                    if (!cb) throw 'getBase64 is an async method and needs a callback argument';
                    this.getBuffer(function(buffer) {
                        cb(buffer.toString('base64'));
                    }, options);
                };
                Document.prototype.getDataUrl = function(cb, options) {
                    if (!cb) throw 'getDataUrl is an async method and needs a callback argument';
                    this.getBuffer(function(buffer) {
                        cb('data:application/pdf;base64,' + buffer.toString('base64'));
                    }, options);
                };
                Document.prototype.getBlob = function(cb, options) {
                    if (!cb) throw 'getBlob is an async method and needs a callback argument';
                    var that = this;
                    this.getBuffer(function(result) {
                        var blob = that._bufferToBlob(result);
                        cb(blob);
                    }, options);
                };
                Document.prototype.getBuffer = function(cb, options) {
                    if (!cb) throw 'getBuffer is an async method and needs a callback argument';
                    var _this = this;
                    this._createDoc(options, function(doc) {
                        _this._flushDoc(doc, function(buffer) {
                            cb(buffer);
                        });
                    });
                };
                Document.prototype.getStream = function(options, cb) {
                    if (!isFunction(cb)) {
                        var doc = this._createDoc(options);
                        return doc;
                    }
                    this._createDoc(options, function(doc) {
                        cb(doc);
                    });
                };
                module1.exports = {
                    createPdf: function(docDefinition, tableLayouts, fonts, vfs) {
                        if (!canCreatePdf()) throw 'Your browser does not provide the level of support needed';
                        return new Document(docDefinition, tableLayouts || globalTableLayouts || __webpack_require__.g.pdfMake.tableLayouts, fonts || globalFonts || __webpack_require__.g.pdfMake.fonts, vfs || globalVfs || __webpack_require__.g.pdfMake.vfs);
                    },
                    addVirtualFileSystem: function(vfs) {
                        globalVfs = vfs;
                    },
                    addFonts: function(fonts) {
                        globalFonts = pack(globalFonts, fonts);
                    },
                    setFonts: function(fonts) {
                        globalFonts = fonts;
                    },
                    clearFonts: function() {
                        globalFonts = undefined;
                    },
                    addTableLayouts: function(tableLayouts) {
                        globalTableLayouts = pack(globalTableLayouts, tableLayouts);
                    },
                    setTableLayouts: function(tableLayouts) {
                        globalTableLayouts = tableLayouts;
                    },
                    clearTableLayouts: function() {
                        globalTableLayouts = undefined;
                    }
                };
            /***/ },
            /***/ 45337: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var uncurryThis = __webpack_require__(38347);
                var aCallable = __webpack_require__(32631);
                var toObject = __webpack_require__(43162);
                var lengthOfArrayLike = __webpack_require__(45495);
                var toString = __webpack_require__(25096);
                var fails = __webpack_require__(47044);
                var internalSort = __webpack_require__(43977);
                var arrayMethodIsStrict = __webpack_require__(81007);
                var FF = __webpack_require__(3809);
                var IE_OR_EDGE = __webpack_require__(21983);
                var V8 = __webpack_require__(70091);
                var WEBKIT = __webpack_require__(41731);
                var test = [];
                var un$Sort = uncurryThis(test.sort);
                var push = uncurryThis(test.push);
                // IE8-
                var FAILS_ON_UNDEFINED = fails(function() {
                    test.sort(undefined);
                });
                // V8 bug
                var FAILS_ON_NULL = fails(function() {
                    test.sort(null);
                });
                // Old WebKit
                var STRICT_METHOD = arrayMethodIsStrict('sort');
                var STABLE_SORT = !fails(function() {
                    // feature detection can be too slow, so check engines versions
                    if (V8) return V8 < 70;
                    if (FF && FF > 3) return;
                    if (IE_OR_EDGE) return true;
                    if (WEBKIT) return WEBKIT < 603;
                    var result = '';
                    var code, chr, value, index;
                    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
                    for(code = 65; code < 76; code++){
                        chr = String.fromCharCode(code);
                        switch(code){
                            case 66:
                            case 69:
                            case 70:
                            case 72:
                                value = 3;
                                break;
                            case 68:
                            case 71:
                                value = 4;
                                break;
                            default:
                                value = 2;
                        }
                        for(index = 0; index < 47; index++)test.push({
                            k: chr + index,
                            v: value
                        });
                    }
                    test.sort(function(a, b) {
                        return b.v - a.v;
                    });
                    for(index = 0; index < test.length; index++){
                        chr = test[index].k.charAt(0);
                        if (result.charAt(result.length - 1) !== chr) result += chr;
                    }
                    return result !== 'DGBEFHACIJK';
                });
                var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
                var getSortCompare = function(comparefn) {
                    return function(x, y) {
                        if (y === undefined) return -1;
                        if (x === undefined) return 1;
                        if (comparefn !== undefined) return +comparefn(x, y) || 0;
                        return toString(x) > toString(y) ? 1 : -1;
                    };
                };
                // `Array.prototype.sort` method
                // https://tc39.es/ecma262/#sec-array.prototype.sort
                $({
                    target: 'Array',
                    proto: true,
                    forced: FORCED
                }, {
                    sort: function sort(comparefn) {
                        if (comparefn !== undefined) aCallable(comparefn);
                        var array = toObject(this);
                        if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);
                        var items = [];
                        var arrayLength = lengthOfArrayLike(array);
                        var itemsLength, index;
                        for(index = 0; index < arrayLength; index++)if (index in array) push(items, array[index]);
                        internalSort(items, getSortCompare(comparefn));
                        itemsLength = items.length;
                        index = 0;
                        while(index < itemsLength)array[index] = items[index++];
                        while(index < arrayLength)delete array[index++];
                        return array;
                    }
                });
            /***/ },
            /***/ 45495: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toLength = __webpack_require__(23417);
                // `LengthOfArrayLike` abstract operation
                // https://tc39.es/ecma262/#sec-lengthofarraylike
                module1.exports = function(obj) {
                    return toLength(obj.length);
                };
            /***/ },
            /***/ 45728: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var objectKeys = __webpack_require__(35643);
                var isArguments = __webpack_require__(67906);
                var is = __webpack_require__(98527);
                var isRegex = __webpack_require__(71689);
                var flags = __webpack_require__(64607);
                var isDate = __webpack_require__(71230);
                var getTime = Date.prototype.getTime;
                function deepEqual(actual, expected, options) {
                    var opts = options || {};
                    // 7.1. All identical values are equivalent, as determined by ===.
                    if (opts.strict ? is(actual, expected) : actual === expected) return true;
                    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
                    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? is(actual, expected) : actual == expected;
                    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
                    return objEquiv(actual, expected, opts);
                }
                function isUndefinedOrNull(value) {
                    return value === null || value === undefined;
                }
                function isBuffer(x) {
                    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
                    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
                    if (x.length > 0 && typeof x[0] !== 'number') return false;
                    return true;
                }
                function objEquiv(a, b, opts) {
                    /* eslint max-statements: [2, 50] */ var i, key;
                    if (typeof a !== typeof b) return false;
                    if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
                    // an identical 'prototype' property.
                    if (a.prototype !== b.prototype) return false;
                    if (isArguments(a) !== isArguments(b)) return false;
                    var aIsRegex = isRegex(a);
                    var bIsRegex = isRegex(b);
                    if (aIsRegex !== bIsRegex) return false;
                    if (aIsRegex || bIsRegex) return a.source === b.source && flags(a) === flags(b);
                    if (isDate(a) && isDate(b)) return getTime.call(a) === getTime.call(b);
                    var aIsBuffer = isBuffer(a);
                    var bIsBuffer = isBuffer(b);
                    if (aIsBuffer !== bIsBuffer) return false;
                    if (aIsBuffer || bIsBuffer) {
                        if (a.length !== b.length) return false;
                        for(i = 0; i < a.length; i++){
                            if (a[i] !== b[i]) return false;
                        }
                        return true;
                    }
                    if (typeof a !== typeof b) return false;
                    try {
                        var ka = objectKeys(a);
                        var kb = objectKeys(b);
                    } catch (e) {
                        return false;
                    }
                    // having the same number of owned properties (keys incorporates hasOwnProperty)
                    if (ka.length !== kb.length) return false;
                    // the same set of keys (although not necessarily the same order),
                    ka.sort();
                    kb.sort();
                    // ~~~cheap key test
                    for(i = ka.length - 1; i >= 0; i--){
                        if (ka[i] != kb[i]) return false;
                    }
                    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
                    for(i = ka.length - 1; i >= 0; i--){
                        key = ka[i];
                        if (!deepEqual(a[key], b[key], opts)) return false;
                    }
                    return true;
                }
                module1.exports = deepEqual;
            /***/ },
            /***/ 45744: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var arraySpeciesConstructor = __webpack_require__(98578);
                // `ArraySpeciesCreate` abstract operation
                // https://tc39.es/ecma262/#sec-arrayspeciescreate
                module1.exports = function(originalArray, length) {
                    return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
                };
            /***/ },
            /***/ 46042: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var path = __webpack_require__(11206);
                var hasOwn = __webpack_require__(20340);
                var wrappedWellKnownSymbolModule = __webpack_require__(75960);
                var defineProperty = __webpack_require__(95892).f;
                module1.exports = function(NAME) {
                    var Symbol1 = path.Symbol || (path.Symbol = {});
                    if (!hasOwn(Symbol1, NAME)) defineProperty(Symbol1, NAME, {
                        value: wrappedWellKnownSymbolModule.f(NAME)
                    });
                };
            /***/ },
            /***/ 46071: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $isNaN = __webpack_require__(10713);
                /** @type {import('./sign')} */ module1.exports = function sign(number) {
                    if ($isNaN(number) || number === 0) return number;
                    return number < 0 ? -1 : 1;
                };
            /***/ },
            /***/ 46094: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var whichTypedArray = __webpack_require__(43381);
                /** @type {import('.')} */ module1.exports = function isTypedArray(value) {
                    return !!whichTypedArray(value);
                };
            /***/ },
            /***/ 46290: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var getBuiltIn = __webpack_require__(38486);
                var isCallable = __webpack_require__(94578);
                var isPrototypeOf = __webpack_require__(70176);
                var USE_SYMBOL_AS_UID = __webpack_require__(9567);
                var Object1 = global.Object;
                module1.exports = USE_SYMBOL_AS_UID ? function(it) {
                    return typeof it == 'symbol';
                } : function(it) {
                    var $Symbol = getBuiltIn('Symbol');
                    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object1(it));
                };
            /***/ },
            /***/ 46467: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var apply = __webpack_require__(58448);
                var call = __webpack_require__(2834);
                var uncurryThis = __webpack_require__(38347);
                var fixRegExpWellKnownSymbolLogic = __webpack_require__(11813);
                var fails = __webpack_require__(47044);
                var anObject = __webpack_require__(34984);
                var isCallable = __webpack_require__(94578);
                var toIntegerOrInfinity = __webpack_require__(26882);
                var toLength = __webpack_require__(23417);
                var toString = __webpack_require__(25096);
                var requireObjectCoercible = __webpack_require__(83943);
                var advanceStringIndex = __webpack_require__(36352);
                var getMethod = __webpack_require__(51839);
                var getSubstitution = __webpack_require__(29519);
                var regExpExec = __webpack_require__(66723);
                var wellKnownSymbol = __webpack_require__(38688);
                var REPLACE = wellKnownSymbol('replace');
                var max = Math.max;
                var min = Math.min;
                var concat = uncurryThis([].concat);
                var push = uncurryThis([].push);
                var stringIndexOf = uncurryThis(''.indexOf);
                var stringSlice = uncurryThis(''.slice);
                var maybeToString = function(it) {
                    return it === undefined ? it : String(it);
                };
                // IE <= 11 replaces $0 with the whole match, as if it was $&
                // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
                var REPLACE_KEEPS_$0 = function() {
                    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
                    return 'a'.replace(/./, '$0') === '$0';
                }();
                // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
                var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
                    if (/./[REPLACE]) return /./[REPLACE]('a', '$0') === '';
                    return false;
                }();
                var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
                    var re = /./;
                    re.exec = function() {
                        var result = [];
                        result.groups = {
                            a: '7'
                        };
                        return result;
                    };
                    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
                    return ''.replace(re, '$<a>') !== '7';
                });
                // @@replace logic
                fixRegExpWellKnownSymbolLogic('replace', function(_, nativeReplace, maybeCallNative) {
                    var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
                    return [
                        // `String.prototype.replace` method
                        // https://tc39.es/ecma262/#sec-string.prototype.replace
                        function replace(searchValue, replaceValue) {
                            var O = requireObjectCoercible(this);
                            var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
                            return replacer ? call(replacer, searchValue, O, replaceValue) : call(nativeReplace, toString(O), searchValue, replaceValue);
                        },
                        // `RegExp.prototype[@@replace]` method
                        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
                        function(string, replaceValue) {
                            var rx = anObject(this);
                            var S = toString(string);
                            if (typeof replaceValue == 'string' && stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf(replaceValue, '$<') === -1) {
                                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                                if (res.done) return res.value;
                            }
                            var functionalReplace = isCallable(replaceValue);
                            if (!functionalReplace) replaceValue = toString(replaceValue);
                            var global = rx.global;
                            if (global) {
                                var fullUnicode = rx.unicode;
                                rx.lastIndex = 0;
                            }
                            var results = [];
                            while(true){
                                var result = regExpExec(rx, S);
                                if (result === null) break;
                                push(results, result);
                                if (!global) break;
                                var matchStr = toString(result[0]);
                                if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                            }
                            var accumulatedResult = '';
                            var nextSourcePosition = 0;
                            for(var i = 0; i < results.length; i++){
                                result = results[i];
                                var matched = toString(result[0]);
                                var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
                                var captures = [];
                                // NOTE: This is equivalent to
                                //   captures = result.slice(1).map(maybeToString)
                                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                                for(var j = 1; j < result.length; j++)push(captures, maybeToString(result[j]));
                                var namedCaptures = result.groups;
                                if (functionalReplace) {
                                    var replacerArgs = concat([
                                        matched
                                    ], captures, position, S);
                                    if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
                                    var replacement = toString(apply(replaceValue, undefined, replacerArgs));
                                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                                if (position >= nextSourcePosition) {
                                    accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
                                    nextSourcePosition = position + matched.length;
                                }
                            }
                            return accumulatedResult + stringSlice(S, nextSourcePosition);
                        }
                    ];
                }, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
            /***/ },
            /***/ 46769: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(38688);
                var ITERATOR = wellKnownSymbol('iterator');
                var SAFE_CLOSING = false;
                try {
                    var called = 0;
                    var iteratorWithReturn = {
                        next: function() {
                            return {
                                done: !!called++
                            };
                        },
                        'return': function() {
                            SAFE_CLOSING = true;
                        }
                    };
                    iteratorWithReturn[ITERATOR] = function() {
                        return this;
                    };
                    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
                    Array.from(iteratorWithReturn, function() {
                        throw 2;
                    });
                } catch (error) {}
                module1.exports = function(exec, SKIP_CLOSING) {
                    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
                    var ITERATION_SUPPORT = false;
                    try {
                        var object = {};
                        object[ITERATOR] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: ITERATION_SUPPORT = true
                                    };
                                }
                            };
                        };
                        exec(object);
                    } catch (error) {}
                    return ITERATION_SUPPORT;
                };
            /***/ },
            /***/ 46859: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var id = 0;
                var postfix = Math.random();
                var toString = uncurryThis(1.0.toString);
                module1.exports = function(key) {
                    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
                };
            /***/ },
            /***/ 46887: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = __webpack_require__(70091);
                var fails = __webpack_require__(47044);
                // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
                module1.exports = !!Object.getOwnPropertySymbols && !fails(function() {
                    var symbol = Symbol();
                    // Chrome 38 Symbol has incorrect toString conversion
                    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
                    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
                    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
                });
            /***/ },
            /***/ 46911: /***/ function(module1) {
                "use strict";
                // Note: adler32 takes 12% for level 0 and 2% for level 6.
                // It isn't worth it to make additional optimizations as in original.
                // Small size is preferable.
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                function adler32(adler, buf, len, pos) {
                    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
                    while(len !== 0){
                        // Set limit ~ twice less than 5552, to keep
                        // s2 in 31-bits, because we force signed ints.
                        // in other case %= will fail.
                        n = len > 2000 ? 2000 : len;
                        len -= n;
                        do {
                            s1 = s1 + buf[pos++] | 0;
                            s2 = s2 + s1 | 0;
                        }while (--n);
                        s1 %= 65521;
                        s2 %= 65521;
                    }
                    return s1 | s2 << 16 | 0;
                }
                module1.exports = adler32;
            /***/ },
            /***/ 47044: /***/ function(module1) {
                module1.exports = function(exec) {
                    try {
                        return !!exec();
                    } catch (error) {
                        return true;
                    }
                };
            /***/ },
            /***/ 47259: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var createHTML = __webpack_require__(91159);
                var forcedStringHTMLMethod = __webpack_require__(7452);
                // `String.prototype.link` method
                // https://tc39.es/ecma262/#sec-string.prototype.link
                $({
                    target: 'String',
                    proto: true,
                    forced: forcedStringHTMLMethod('link')
                }, {
                    link: function link(url) {
                        return createHTML(this, 'a', 'href', url);
                    }
                });
            /***/ },
            /***/ 47458: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var uncurryThis = __webpack_require__(38347);
                var notARegExp = __webpack_require__(93666);
                var requireObjectCoercible = __webpack_require__(83943);
                var toString = __webpack_require__(25096);
                var correctIsRegExpLogic = __webpack_require__(91151);
                var stringIndexOf = uncurryThis(''.indexOf);
                // `String.prototype.includes` method
                // https://tc39.es/ecma262/#sec-string.prototype.includes
                $({
                    target: 'String',
                    proto: true,
                    forced: !correctIsRegExpLogic('includes')
                }, {
                    includes: function includes(searchString /* , position = 0 */ ) {
                        return !!~stringIndexOf(toString(requireObjectCoercible(this)), toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
            /***/ },
            /***/ 47552: /***/ function(module1) {
                "use strict";
                /** @type {import('./min')} */ module1.exports = Math.min;
            /***/ },
            /***/ 47900: /***/ function(module1) {
                "use strict";
                /** @type {import('./ref')} */ module1.exports = ReferenceError;
            /***/ },
            /***/ 47969: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(98828);
                // `Uint16Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor('Uint16', function(init) {
                    return function Uint16Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 48181: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var __dirname = "/";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                function VirtualFileSystem() {
                    this.fileSystem = {};
                    this.dataSystem = {};
                }
                VirtualFileSystem.prototype.existsSync = function(filename) {
                    filename = fixFilename(filename);
                    return typeof this.fileSystem[filename] !== 'undefined' || typeof this.dataSystem[filename] !== 'undefined';
                };
                VirtualFileSystem.prototype.readFileSync = function(filename, options) {
                    filename = fixFilename(filename);
                    var dataContent = this.dataSystem[filename];
                    if (typeof dataContent === 'string' && options === 'utf8') return dataContent;
                    if (dataContent) return new Buffer(dataContent, typeof dataContent === 'string' ? 'base64' : undefined);
                    var content = this.fileSystem[filename];
                    if (content) return content;
                    throw 'File \'' + filename + '\' not found in virtual file system';
                };
                VirtualFileSystem.prototype.writeFileSync = function(filename, content) {
                    this.fileSystem[fixFilename(filename)] = content;
                };
                VirtualFileSystem.prototype.bindFS = function(data) {
                    this.dataSystem = data || {};
                };
                function fixFilename(filename) {
                    if (filename.indexOf(__dirname) === 0) filename = filename.substring(__dirname.length);
                    if (filename.indexOf('/') === 0) filename = filename.substring(1);
                    return filename;
                }
                module1.exports = new VirtualFileSystem();
            /***/ },
            /***/ 48306: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(20731);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    /**
   * Counter block mode.
   */ CryptoJS.mode.CTR = function() {
                        var CTR = CryptoJS.lib.BlockCipherMode.extend();
                        var Encryptor = CTR.Encryptor = CTR.extend({
                            processBlock: function processBlock(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                var iv = this._iv;
                                var counter = this._counter;
                                // Generate keystream
                                if (iv) {
                                    counter = this._counter = iv.slice(0);
                                    // Remove IV for subsequent blocks
                                    this._iv = undefined;
                                }
                                var keystream = counter.slice(0);
                                cipher.encryptBlock(keystream, 0);
                                // Increment counter
                                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                                // Encrypt
                                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                            }
                        });
                        CTR.Decryptor = Encryptor;
                        return CTR;
                    }();
                    return CryptoJS.mode.CTR;
                });
            /***/ },
            /***/ 48352: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(39081);
                __webpack_require__(81755);
                __webpack_require__(94845);
                __webpack_require__(20731);
                __webpack_require__(23913);
                __webpack_require__(8953);
                __webpack_require__(14032);
                __webpack_require__(57114);
                __webpack_require__(59735);
                __webpack_require__(73663);
                __webpack_require__(29883);
                __webpack_require__(35471);
                __webpack_require__(21012);
                __webpack_require__(88997);
                __webpack_require__(97464);
                __webpack_require__(2857);
                __webpack_require__(94715);
                __webpack_require__(13624);
                __webpack_require__(91132);
                __webpack_require__(62514);
                __webpack_require__(24597);
                __webpack_require__(88042);
                __webpack_require__(4660);
                __webpack_require__(92451);
                __webpack_require__(44206);
                __webpack_require__(66288);
                __webpack_require__(13250);
                __webpack_require__(3858);
                __webpack_require__(84538);
                __webpack_require__(64793);
                __webpack_require__(74202);
                __webpack_require__(52529);
                __webpack_require__(49109);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory();
                })(void 0, function() {
                    /*globals window, global, require*/ /**
   * CryptoJS core components.
   */ var CryptoJS = CryptoJS || function(Math1, undefined1) {
                        var crypto;
                        // Native crypto from window (Browser)
                        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
                        // Native crypto in web worker (Browser)
                        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
                        // Native crypto from worker
                        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
                        // Native (experimental IE 11) crypto from window (Browser)
                        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
                        // Native crypto from global (NodeJS)
                        if (!crypto && typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.crypto) crypto = __webpack_require__.g.crypto;
                        // Native crypto import via require (NodeJS)
                        if (!crypto && true) try {
                            crypto = __webpack_require__(50477);
                        } catch (err) {}
                        /*
     * Cryptographically secure pseudorandom number generator
     *
     * As Math.random() is cryptographically not safe to use
     */ var cryptoSecureRandomInt = function cryptoSecureRandomInt() {
                            if (crypto) {
                                // Use getRandomValues method (Browser)
                                if (typeof crypto.getRandomValues === 'function') try {
                                    return crypto.getRandomValues(new Uint32Array(1))[0];
                                } catch (err) {}
                                // Use randomBytes method (NodeJS)
                                if (typeof crypto.randomBytes === 'function') try {
                                    return crypto.randomBytes(4).readInt32LE();
                                } catch (err) {}
                            }
                            throw new Error('Native crypto module could not be used to get secure random number.');
                        };
                        /*
     * Local polyfill of Object.create
      */ var create = Object.create || function() {
                            function F() {}
                            return function(obj) {
                                var subtype;
                                F.prototype = obj;
                                subtype = new F();
                                F.prototype = null;
                                return subtype;
                            };
                        }();
                        /**
     * CryptoJS namespace.
     */ var C = {};
                        /**
     * Library namespace.
     */ var C_lib = C.lib = {};
                        /**
     * Base object for prototypal inheritance.
     */ var Base = C_lib.Base = function() {
                            return {
                                /**
         * Creates a new object that inherits from this object.
         *
         * @param {Object} overrides Properties to copy into the new object.
         *
         * @return {Object} The new object.
         *
         * @static
         *
         * @example
         *
         *     var MyType = CryptoJS.lib.Base.extend({
         *         field: 'value',
         *
         *         method: function () {
         *         }
         *     });
         */ extend: function extend(overrides) {
                                    // Spawn
                                    var subtype = create(this);
                                    // Augment
                                    if (overrides) subtype.mixIn(overrides);
                                    // Create default initializer
                                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                                        subtype.$super.init.apply(this, arguments);
                                    };
                                    // Initializer's prototype is the subtype object
                                    subtype.init.prototype = subtype;
                                    // Reference supertype
                                    subtype.$super = this;
                                    return subtype;
                                },
                                /**
         * Extends this object and runs the init method.
         * Arguments to create() will be passed to init().
         *
         * @return {Object} The new object.
         *
         * @static
         *
         * @example
         *
         *     var instance = MyType.create();
         */ create: function create() {
                                    var instance = this.extend();
                                    instance.init.apply(instance, arguments);
                                    return instance;
                                },
                                /**
         * Initializes a newly created object.
         * Override this method to add some logic when your objects are created.
         *
         * @example
         *
         *     var MyType = CryptoJS.lib.Base.extend({
         *         init: function () {
         *             // ...
         *         }
         *     });
         */ init: function init() {},
                                /**
         * Copies properties into this object.
         *
         * @param {Object} properties The properties to mix in.
         *
         * @example
         *
         *     MyType.mixIn({
         *         field: 'value'
         *     });
         */ mixIn: function mixIn(properties) {
                                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                                    // IE won't copy toString using the loop above
                                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                                },
                                /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = instance.clone();
         */ clone: function clone() {
                                    return this.init.prototype.extend(this);
                                }
                            };
                        }();
                        /**
     * An array of 32-bit words.
     *
     * @property {Array} words The array of 32-bit words.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */ var WordArray = C_lib.WordArray = Base.extend({
                            /**
       * Initializes a newly created word array.
       *
       * @param {Array} words (Optional) An array of 32-bit words.
       * @param {number} sigBytes (Optional) The number of significant bytes in the words.
       *
       * @example
       *
       *     var wordArray = CryptoJS.lib.WordArray.create();
       *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
       *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
       */ init: function init(words, sigBytes) {
                                words = this.words = words || [];
                                if (sigBytes != undefined1) this.sigBytes = sigBytes;
                                else this.sigBytes = words.length * 4;
                            },
                            /**
       * Converts this word array to a string.
       *
       * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
       *
       * @return {string} The stringified word array.
       *
       * @example
       *
       *     var string = wordArray + '';
       *     var string = wordArray.toString();
       *     var string = wordArray.toString(CryptoJS.enc.Utf8);
       */ toString: function toString(encoder) {
                                return (encoder || Hex).stringify(this);
                            },
                            /**
       * Concatenates a word array to this word array.
       *
       * @param {WordArray} wordArray The word array to append.
       *
       * @return {WordArray} This word array.
       *
       * @example
       *
       *     wordArray1.concat(wordArray2);
       */ concat: function concat(wordArray) {
                                // Shortcuts
                                var thisWords = this.words;
                                var thatWords = wordArray.words;
                                var thisSigBytes = this.sigBytes;
                                var thatSigBytes = wordArray.sigBytes;
                                // Clamp excess bits
                                this.clamp();
                                // Concat
                                if (thisSigBytes % 4) // Copy one byte at a time
                                for(var i = 0; i < thatSigBytes; i++){
                                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                                }
                                else // Copy one word at a time
                                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                                this.sigBytes += thatSigBytes;
                                // Chainable
                                return this;
                            },
                            /**
       * Removes insignificant bits.
       *
       * @example
       *
       *     wordArray.clamp();
       */ clamp: function clamp() {
                                // Shortcuts
                                var words = this.words;
                                var sigBytes = this.sigBytes;
                                // Clamp
                                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                                words.length = Math1.ceil(sigBytes / 4);
                            },
                            /**
       * Creates a copy of this word array.
       *
       * @return {WordArray} The clone.
       *
       * @example
       *
       *     var clone = wordArray.clone();
       */ clone: function clone() {
                                var clone = Base.clone.call(this);
                                clone.words = this.words.slice(0);
                                return clone;
                            },
                            /**
       * Creates a word array filled with random bytes.
       *
       * @param {number} nBytes The number of random bytes to generate.
       *
       * @return {WordArray} The random word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.lib.WordArray.random(16);
       */ random: function random(nBytes) {
                                var words = [];
                                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                                return new WordArray.init(words, nBytes);
                            }
                        });
                        /**
     * Encoder namespace.
     */ var C_enc = C.enc = {};
                        /**
     * Hex encoding strategy.
     */ var Hex = C_enc.Hex = {
                            /**
       * Converts a word array to a hex string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The hex string.
       *
       * @static
       *
       * @example
       *
       *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                // Convert
                                var hexChars = [];
                                for(var i = 0; i < sigBytes; i++){
                                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                    hexChars.push((bite >>> 4).toString(16));
                                    hexChars.push((bite & 0x0f).toString(16));
                                }
                                return hexChars.join('');
                            },
                            /**
       * Converts a hex string to a word array.
       *
       * @param {string} hexStr The hex string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
       */ parse: function parse(hexStr) {
                                // Shortcut
                                var hexStrLength = hexStr.length;
                                // Convert
                                var words = [];
                                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                                return new WordArray.init(words, hexStrLength / 2);
                            }
                        };
                        /**
     * Latin1 encoding strategy.
     */ var Latin1 = C_enc.Latin1 = {
                            /**
       * Converts a word array to a Latin1 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The Latin1 string.
       *
       * @static
       *
       * @example
       *
       *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                // Convert
                                var latin1Chars = [];
                                for(var i = 0; i < sigBytes; i++){
                                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                    latin1Chars.push(String.fromCharCode(bite));
                                }
                                return latin1Chars.join('');
                            },
                            /**
       * Converts a Latin1 string to a word array.
       *
       * @param {string} latin1Str The Latin1 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
       */ parse: function parse(latin1Str) {
                                // Shortcut
                                var latin1StrLength = latin1Str.length;
                                // Convert
                                var words = [];
                                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                                return new WordArray.init(words, latin1StrLength);
                            }
                        };
                        /**
     * UTF-8 encoding strategy.
     */ var Utf8 = C_enc.Utf8 = {
                            /**
       * Converts a word array to a UTF-8 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-8 string.
       *
       * @static
       *
       * @example
       *
       *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                try {
                                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                                } catch (e) {
                                    throw new Error('Malformed UTF-8 data');
                                }
                            },
                            /**
       * Converts a UTF-8 string to a word array.
       *
       * @param {string} utf8Str The UTF-8 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
       */ parse: function parse(utf8Str) {
                                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
                            }
                        };
                        /**
     * Abstract buffered block algorithm template.
     *
     * The property blockSize must be implemented in a concrete subtype.
     *
     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
                            /**
       * Resets this block algorithm's data buffer to its initial state.
       *
       * @example
       *
       *     bufferedBlockAlgorithm.reset();
       */ reset: function reset() {
                                // Initial values
                                this._data = new WordArray.init();
                                this._nDataBytes = 0;
                            },
                            /**
       * Adds new data to this block algorithm's buffer.
       *
       * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
       *
       * @example
       *
       *     bufferedBlockAlgorithm._append('data');
       *     bufferedBlockAlgorithm._append(wordArray);
       */ _append: function _append(data) {
                                // Convert string to WordArray, else assume WordArray already
                                if (typeof data == 'string') data = Utf8.parse(data);
                                // Append
                                this._data.concat(data);
                                this._nDataBytes += data.sigBytes;
                            },
                            /**
       * Processes available data blocks.
       *
       * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
       *
       * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
       *
       * @return {WordArray} The processed data.
       *
       * @example
       *
       *     var processedData = bufferedBlockAlgorithm._process();
       *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
       */ _process: function _process(doFlush) {
                                var processedWords;
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var dataSigBytes = data.sigBytes;
                                var blockSize = this.blockSize;
                                var blockSizeBytes = blockSize * 4;
                                // Count blocks ready
                                var nBlocksReady = dataSigBytes / blockSizeBytes;
                                if (doFlush) // Round up to include partial blocks
                                nBlocksReady = Math1.ceil(nBlocksReady);
                                else // Round down to include only full blocks,
                                // less the number of blocks that must remain in the buffer
                                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                                // Count words ready
                                var nWordsReady = nBlocksReady * blockSize;
                                // Count bytes ready
                                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                                // Process blocks
                                if (nWordsReady) {
                                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                                    this._doProcessBlock(dataWords, offset);
                                    // Remove processed words
                                    processedWords = dataWords.splice(0, nWordsReady);
                                    data.sigBytes -= nBytesReady;
                                }
                                // Return processed words
                                return new WordArray.init(processedWords, nBytesReady);
                            },
                            /**
       * Creates a copy of this object.
       *
       * @return {Object} The clone.
       *
       * @example
       *
       *     var clone = bufferedBlockAlgorithm.clone();
       */ clone: function clone() {
                                var clone = Base.clone.call(this);
                                clone._data = this._data.clone();
                                return clone;
                            },
                            _minBufferSize: 0
                        });
                        /**
     * Abstract hasher template.
     *
     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
                            /**
       * Configuration options.
       */ cfg: Base.extend(),
                            /**
       * Initializes a newly created hasher.
       *
       * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
       *
       * @example
       *
       *     var hasher = CryptoJS.algo.SHA256.create();
       */ init: function init(cfg) {
                                // Apply config defaults
                                this.cfg = this.cfg.extend(cfg);
                                // Set initial values
                                this.reset();
                            },
                            /**
       * Resets this hasher to its initial state.
       *
       * @example
       *
       *     hasher.reset();
       */ reset: function reset() {
                                // Reset data buffer
                                BufferedBlockAlgorithm.reset.call(this);
                                // Perform concrete-hasher logic
                                this._doReset();
                            },
                            /**
       * Updates this hasher with a message.
       *
       * @param {WordArray|string} messageUpdate The message to append.
       *
       * @return {Hasher} This hasher.
       *
       * @example
       *
       *     hasher.update('message');
       *     hasher.update(wordArray);
       */ update: function update(messageUpdate) {
                                // Append
                                this._append(messageUpdate);
                                // Update the hash
                                this._process();
                                // Chainable
                                return this;
                            },
                            /**
       * Finalizes the hash computation.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} messageUpdate (Optional) A final message update.
       *
       * @return {WordArray} The hash.
       *
       * @example
       *
       *     var hash = hasher.finalize();
       *     var hash = hasher.finalize('message');
       *     var hash = hasher.finalize(wordArray);
       */ finalize: function finalize(messageUpdate) {
                                // Final message update
                                if (messageUpdate) this._append(messageUpdate);
                                // Perform concrete-hasher logic
                                var hash = this._doFinalize();
                                return hash;
                            },
                            blockSize: 16,
                            /**
       * Creates a shortcut function to a hasher's object interface.
       *
       * @param {Hasher} hasher The hasher to create a helper for.
       *
       * @return {Function} The shortcut function.
       *
       * @static
       *
       * @example
       *
       *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
       */ _createHelper: function _createHelper(hasher) {
                                return function(message, cfg) {
                                    return new hasher.init(cfg).finalize(message);
                                };
                            },
                            /**
       * Creates a shortcut function to the HMAC's object interface.
       *
       * @param {Hasher} hasher The hasher to use in this HMAC helper.
       *
       * @return {Function} The shortcut function.
       *
       * @static
       *
       * @example
       *
       *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
       */ _createHmacHelper: function _createHmacHelper(hasher) {
                                return function(message, key) {
                                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                                };
                            }
                        });
                        /**
     * Algorithm namespace.
     */ var C_algo = C.algo = {};
                        return C;
                    }(Math);
                    return CryptoJS;
                });
            /***/ },
            /***/ 48461: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var keysShim;
                if (!Object.keys) {
                    // modified from https://github.com/es-shims/es5-shim
                    var has = Object.prototype.hasOwnProperty;
                    var toStr = Object.prototype.toString;
                    var isArgs = __webpack_require__(76515); // eslint-disable-line global-require
                    var isEnumerable = Object.prototype.propertyIsEnumerable;
                    var hasDontEnumBug = !isEnumerable.call({
                        toString: null
                    }, 'toString');
                    var hasProtoEnumBug = isEnumerable.call(function() {}, 'prototype');
                    var dontEnums = [
                        'toString',
                        'toLocaleString',
                        'valueOf',
                        'hasOwnProperty',
                        'isPrototypeOf',
                        'propertyIsEnumerable',
                        'constructor'
                    ];
                    var equalsConstructorPrototype = function(o) {
                        var ctor = o.constructor;
                        return ctor && ctor.prototype === o;
                    };
                    var excludedKeys = {
                        $applicationCache: true,
                        $console: true,
                        $external: true,
                        $frame: true,
                        $frameElement: true,
                        $frames: true,
                        $innerHeight: true,
                        $innerWidth: true,
                        $onmozfullscreenchange: true,
                        $onmozfullscreenerror: true,
                        $outerHeight: true,
                        $outerWidth: true,
                        $pageXOffset: true,
                        $pageYOffset: true,
                        $parent: true,
                        $scrollLeft: true,
                        $scrollTop: true,
                        $scrollX: true,
                        $scrollY: true,
                        $self: true,
                        $webkitIndexedDB: true,
                        $webkitStorageInfo: true,
                        $window: true
                    };
                    var hasAutomationEqualityBug = function() {
                        /* global window */ if (typeof window === 'undefined') return false;
                        for(var k in window)try {
                            if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                                equalsConstructorPrototype(window[k]);
                            } catch (e) {
                                return true;
                            }
                        } catch (e) {
                            return true;
                        }
                        return false;
                    }();
                    var equalsConstructorPrototypeIfNotBuggy = function(o) {
                        /* global window */ if (typeof window === 'undefined' || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
                        try {
                            return equalsConstructorPrototype(o);
                        } catch (e) {
                            return false;
                        }
                    };
                    keysShim = function keys(object) {
                        var isObject = object !== null && typeof object === 'object';
                        var isFunction = toStr.call(object) === '[object Function]';
                        var isArguments = isArgs(object);
                        var isString = isObject && toStr.call(object) === '[object String]';
                        var theKeys = [];
                        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
                        var skipProto = hasProtoEnumBug && isFunction;
                        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
                        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
                        else {
                            for(var name in object)if (!(skipProto && name === 'prototype') && has.call(object, name)) theKeys.push(String(name));
                        }
                        if (hasDontEnumBug) {
                            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
                            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
                        }
                        return theKeys;
                    };
                }
                module1.exports = keysShim;
            /***/ },
            /***/ 48569: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // a transform stream is a readable/writable stream where you do
                // something with the data.  Sometimes it's called a "filter",
                // but that's not a great name for it, since that implies a thing where
                // some bits pass through, and others are simply ignored.  (That would
                // be a valid example of a transform, of course.)
                //
                // While the output is causally related to the input, it's not a
                // necessarily symmetric or synchronous transformation.  For example,
                // a zlib stream might take multiple plain-text writes(), and then
                // emit a single compressed chunk some time in the future.
                //
                // Here's how this works:
                //
                // The Transform stream has all the aspects of the readable and writable
                // stream classes.  When you write(chunk), that calls _write(chunk,cb)
                // internally, and returns false if there's a lot of pending writes
                // buffered up.  When you call read(), that calls _read(n) until
                // there's enough pending readable data buffered up.
                //
                // In a transform stream, the written data is placed in a buffer.  When
                // _read(n) is called, it transforms the queued up data, calling the
                // buffered _write cb's as it consumes chunks.  If consuming a single
                // written chunk would result in multiple output chunks, then the first
                // outputted bit calls the readcb, and subsequent chunks just go into
                // the read buffer, and will cause it to emit 'readable' if necessary.
                //
                // This way, back-pressure is actually determined by the reading side,
                // since _read has to be called to start processing a new chunk.  However,
                // a pathological inflate type of transform can cause excessive buffering
                // here.  For example, imagine a stream where every byte of input is
                // interpreted as an integer from 0-255, and then results in that many
                // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
                // 1kb of data being output.  In this case, you could write a very small
                // amount of input, and end up with a very large amount of output.  In
                // such a pathological inflating mechanism, there'd be no way to tell
                // the system to stop doing the transform.  A single 4MB write could
                // cause the system to run out of memory.
                //
                // However, even in such a pathological case, only a single written chunk
                // would be consumed, and then the rest would wait (un-transformed) until
                // the results of the previous transformed chunk were consumed.
                module1.exports = Transform;
                var _require$codes = __webpack_require__(83797)/* .codes */ .F, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
                var Duplex = __webpack_require__(14903);
                __webpack_require__(89784)(Transform, Duplex);
                function afterTransform(er, data) {
                    var ts = this._transformState;
                    ts.transforming = false;
                    var cb = ts.writecb;
                    if (cb === null) return this.emit('error', new ERR_MULTIPLE_CALLBACK());
                    ts.writechunk = null;
                    ts.writecb = null;
                    if (data != null) // single equals check for both `null` and `undefined`
                    this.push(data);
                    cb(er);
                    var rs = this._readableState;
                    rs.reading = false;
                    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                }
                function Transform(options) {
                    if (!(this instanceof Transform)) return new Transform(options);
                    Duplex.call(this, options);
                    this._transformState = {
                        afterTransform: afterTransform.bind(this),
                        needTransform: false,
                        transforming: false,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    };
                    // start out asking for a readable event once data is transformed.
                    this._readableState.needReadable = true;
                    // we have implemented the _read method, and done the other things
                    // that Readable wants before the first _read call, so unset the
                    // sync guard flag.
                    this._readableState.sync = false;
                    if (options) {
                        if (typeof options.transform === 'function') this._transform = options.transform;
                        if (typeof options.flush === 'function') this._flush = options.flush;
                    }
                    // When the writable side finishes, then flush out anything remaining.
                    this.on('prefinish', prefinish);
                }
                function prefinish() {
                    var _this = this;
                    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
                        done(_this, er, data);
                    });
                    else done(this, null, null);
                }
                Transform.prototype.push = function(chunk, encoding) {
                    this._transformState.needTransform = false;
                    return Duplex.prototype.push.call(this, chunk, encoding);
                };
                // This is the part where you do stuff!
                // override this function in implementation classes.
                // 'chunk' is an input chunk.
                //
                // Call `push(newChunk)` to pass along transformed output
                // to the readable side.  You may call 'push' zero or more times.
                //
                // Call `cb(err)` when you are done with this chunk.  If you pass
                // an error, then that'll put the hurt on the whole operation.  If you
                // never call cb(), then you'll never get another chunk.
                Transform.prototype._transform = function(chunk, encoding, cb) {
                    cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
                };
                Transform.prototype._write = function(chunk, encoding, cb) {
                    var ts = this._transformState;
                    ts.writecb = cb;
                    ts.writechunk = chunk;
                    ts.writeencoding = encoding;
                    if (!ts.transforming) {
                        var rs = this._readableState;
                        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
                    }
                };
                // Doesn't matter what the args are here.
                // _transform does all the work.
                // That we got here means that the readable side wants more data.
                Transform.prototype._read = function(n) {
                    var ts = this._transformState;
                    if (ts.writechunk !== null && !ts.transforming) {
                        ts.transforming = true;
                        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
                    } else // mark that we need a transform, so that any data that comes in
                    // will get processed, now that we've asked for it.
                    ts.needTransform = true;
                };
                Transform.prototype._destroy = function(err, cb) {
                    Duplex.prototype._destroy.call(this, err, function(err2) {
                        cb(err2);
                    });
                };
                function done(stream, er, data) {
                    if (er) return stream.emit('error', er);
                    if (data != null) // single equals check for both `null` and `undefined`
                    stream.push(data);
                    // TODO(BridgeAR): Write a test for these two error cases
                    // if there's nothing in the write buffer, then that means
                    // that nothing more will ever be provided
                    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
                    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
                    return stream.push(null);
                }
            /***/ },
            /***/ 48914: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(15567);
                var definePropertyModule = __webpack_require__(95892);
                var createPropertyDescriptor = __webpack_require__(97841);
                module1.exports = DESCRIPTORS ? function(object, key, value) {
                    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
                } : function(object, key, value) {
                    object[key] = value;
                    return object;
                };
            /***/ },
            /***/ 49063: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var $filter = __webpack_require__(91102).filter;
                var arrayMethodHasSpeciesSupport = __webpack_require__(56280);
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
                // `Array.prototype.filter` method
                // https://tc39.es/ecma262/#sec-array.prototype.filter
                // with adding support of @@species
                $({
                    target: 'Array',
                    proto: true,
                    forced: !HAS_SPECIES_SUPPORT
                }, {
                    filter: function filter(callbackfn /* , thisArg */ ) {
                        return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
            /***/ },
            /***/ 49109: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(64384);
            /***/ },
            /***/ 49261: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var newPromiseCapabilityModule = __webpack_require__(56614);
                var perform = __webpack_require__(61900);
                // `Promise.try` method
                // https://github.com/tc39/proposal-promise-try
                $({
                    target: 'Promise',
                    stat: true
                }, {
                    'try': function(callbackfn) {
                        var promiseCapability = newPromiseCapabilityModule.f(this);
                        var result = perform(callbackfn);
                        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
                        return promiseCapability.promise;
                    }
                });
            /***/ },
            /***/ 49820: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var call = __webpack_require__(2834);
                var uncurryThis = __webpack_require__(38347);
                var toString = __webpack_require__(25096);
                var regexpFlags = __webpack_require__(21182);
                var stickyHelpers = __webpack_require__(74846);
                var shared = __webpack_require__(464);
                var create = __webpack_require__(10819);
                var getInternalState = __webpack_require__(70172).get;
                var UNSUPPORTED_DOT_ALL = __webpack_require__(84030);
                var UNSUPPORTED_NCG = __webpack_require__(97739);
                var nativeReplace = shared('native-string-replace', String.prototype.replace);
                var nativeExec = RegExp.prototype.exec;
                var patchedExec = nativeExec;
                var charAt = uncurryThis(''.charAt);
                var indexOf = uncurryThis(''.indexOf);
                var replace = uncurryThis(''.replace);
                var stringSlice = uncurryThis(''.slice);
                var UPDATES_LAST_INDEX_WRONG = function() {
                    var re1 = /a/;
                    var re2 = /b*/g;
                    call(nativeExec, re1, 'a');
                    call(nativeExec, re2, 'a');
                    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
                }();
                var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;
                // nonparticipating capturing group, copied from es5-shim's String#split patch.
                var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
                var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
                if (PATCH) // eslint-disable-next-line max-statements -- TODO
                patchedExec = function exec(string) {
                    var re = this;
                    var state = getInternalState(re);
                    var str = toString(string);
                    var raw = state.raw;
                    var result, reCopy, lastIndex, match, i, object, group;
                    if (raw) {
                        raw.lastIndex = re.lastIndex;
                        result = call(patchedExec, raw, str);
                        re.lastIndex = raw.lastIndex;
                        return result;
                    }
                    var groups = state.groups;
                    var sticky = UNSUPPORTED_Y && re.sticky;
                    var flags = call(regexpFlags, re);
                    var source = re.source;
                    var charsAdded = 0;
                    var strCopy = str;
                    if (sticky) {
                        flags = replace(flags, 'y', '');
                        if (indexOf(flags, 'g') === -1) flags += 'g';
                        strCopy = stringSlice(str, re.lastIndex);
                        // Support anchored sticky behavior.
                        if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
                            source = '(?: ' + source + ')';
                            strCopy = ' ' + strCopy;
                            charsAdded++;
                        }
                        // ^(? + rx + ) is needed, in combination with some str slicing, to
                        // simulate the 'y' flag.
                        reCopy = new RegExp('^(?:' + source + ')', flags);
                    }
                    if (NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
                    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
                    match = call(nativeExec, sticky ? reCopy : re, strCopy);
                    if (sticky) {
                        if (match) {
                            match.input = stringSlice(match.input, charsAdded);
                            match[0] = stringSlice(match[0], charsAdded);
                            match.index = re.lastIndex;
                            re.lastIndex += match[0].length;
                        } else re.lastIndex = 0;
                    } else if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
                    if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
                    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
                    call(nativeReplace, match[0], reCopy, function() {
                        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
                    });
                    if (match && groups) {
                        match.groups = object = create(null);
                        for(i = 0; i < groups.length; i++){
                            group = groups[i];
                            object[group[0]] = match[group[1]];
                        }
                    }
                    return match;
                };
                module1.exports = patchedExec;
            /***/ },
            /***/ 50194: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var call = __webpack_require__(2834);
                var anObject = __webpack_require__(34984);
                var getMethod = __webpack_require__(51839);
                module1.exports = function(iterator, kind, value) {
                    var innerResult, innerError;
                    anObject(iterator);
                    try {
                        innerResult = getMethod(iterator, 'return');
                        if (!innerResult) {
                            if (kind === 'throw') throw value;
                            return value;
                        }
                        innerResult = call(innerResult, iterator);
                    } catch (error) {
                        innerError = true;
                        innerResult = error;
                    }
                    if (kind === 'throw') throw value;
                    if (innerError) throw innerResult;
                    anObject(innerResult);
                    return value;
                };
            /***/ },
            /***/ 50477: /***/ function() {
            /* (ignored) */ /***/ },
            /***/ 50716: /***/ function(module1) {
                "use strict";
                /** @type {import('./abs')} */ module1.exports = Math.abs;
            /***/ },
            /***/ 51270: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(39081);
                __webpack_require__(20731);
                __webpack_require__(23913);
                __webpack_require__(14032);
                __webpack_require__(57114);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(82747));
                })(void 0, function(CryptoJS) {
                    /**
   * Cipher core components.
   */ CryptoJS.lib.Cipher || function(undefined1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Base = C_lib.Base;
                        var WordArray = C_lib.WordArray;
                        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
                        var C_enc = C.enc;
                        var Utf8 = C_enc.Utf8;
                        var Base64 = C_enc.Base64;
                        var C_algo = C.algo;
                        var EvpKDF = C_algo.EvpKDF;
                        /**
     * Abstract base cipher template.
     *
     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
                            /**
       * Configuration options.
       *
       * @property {WordArray} iv The IV to use for this operation.
       */ cfg: Base.extend(),
                            /**
       * Creates this cipher in encryption mode.
       *
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {Cipher} A cipher instance.
       *
       * @static
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
       */ createEncryptor: function createEncryptor(key, cfg) {
                                return this.create(this._ENC_XFORM_MODE, key, cfg);
                            },
                            /**
       * Creates this cipher in decryption mode.
       *
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {Cipher} A cipher instance.
       *
       * @static
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
       */ createDecryptor: function createDecryptor(key, cfg) {
                                return this.create(this._DEC_XFORM_MODE, key, cfg);
                            },
                            /**
       * Initializes a newly created cipher.
       *
       * @param {number} xformMode Either the encryption or decryption transormation mode constant.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
       */ init: function init(xformMode, key, cfg) {
                                // Apply config defaults
                                this.cfg = this.cfg.extend(cfg);
                                // Store transform mode and key
                                this._xformMode = xformMode;
                                this._key = key;
                                // Set initial values
                                this.reset();
                            },
                            /**
       * Resets this cipher to its initial state.
       *
       * @example
       *
       *     cipher.reset();
       */ reset: function reset() {
                                // Reset data buffer
                                BufferedBlockAlgorithm.reset.call(this);
                                // Perform concrete-cipher logic
                                this._doReset();
                            },
                            /**
       * Adds data to be encrypted or decrypted.
       *
       * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
       *
       * @return {WordArray} The data after processing.
       *
       * @example
       *
       *     var encrypted = cipher.process('data');
       *     var encrypted = cipher.process(wordArray);
       */ process: function process(dataUpdate) {
                                // Append
                                this._append(dataUpdate);
                                // Process available blocks
                                return this._process();
                            },
                            /**
       * Finalizes the encryption or decryption process.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
       *
       * @return {WordArray} The data after final processing.
       *
       * @example
       *
       *     var encrypted = cipher.finalize();
       *     var encrypted = cipher.finalize('data');
       *     var encrypted = cipher.finalize(wordArray);
       */ finalize: function finalize(dataUpdate) {
                                // Final data update
                                if (dataUpdate) this._append(dataUpdate);
                                // Perform concrete-cipher logic
                                var finalProcessedData = this._doFinalize();
                                return finalProcessedData;
                            },
                            keySize: 4,
                            ivSize: 4,
                            _ENC_XFORM_MODE: 1,
                            _DEC_XFORM_MODE: 2,
                            /**
       * Creates shortcut functions to a cipher's object interface.
       *
       * @param {Cipher} cipher The cipher to create a helper for.
       *
       * @return {Object} An object with encrypt and decrypt shortcut functions.
       *
       * @static
       *
       * @example
       *
       *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
       */ _createHelper: function() {
                                function selectCipherStrategy(key) {
                                    if (typeof key == 'string') return PasswordBasedCipher;
                                    else return SerializableCipher;
                                }
                                return function(cipher) {
                                    return {
                                        encrypt: function encrypt(message, key, cfg) {
                                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                                        },
                                        decrypt: function decrypt(ciphertext, key, cfg) {
                                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                                        }
                                    };
                                };
                            }()
                        });
                        /**
     * Abstract base stream cipher template.
     *
     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
                            _doFinalize: function _doFinalize() {
                                // Process partial blocks
                                var finalProcessedBlocks = this._process(true);
                                return finalProcessedBlocks;
                            },
                            blockSize: 1
                        });
                        /**
     * Mode namespace.
     */ var C_mode = C.mode = {};
                        /**
     * Abstract base block cipher mode template.
     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
                            /**
       * Creates this mode for encryption.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @static
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
       */ createEncryptor: function createEncryptor(cipher, iv) {
                                return this.Encryptor.create(cipher, iv);
                            },
                            /**
       * Creates this mode for decryption.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @static
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
       */ createDecryptor: function createDecryptor(cipher, iv) {
                                return this.Decryptor.create(cipher, iv);
                            },
                            /**
       * Initializes a newly created mode.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
       */ init: function init(cipher, iv) {
                                this._cipher = cipher;
                                this._iv = iv;
                            }
                        });
                        /**
     * Cipher Block Chaining mode.
     */ var CBC = C_mode.CBC = function() {
                            /**
       * Abstract base CBC mode.
       */ var CBC = BlockCipherMode.extend();
                            /**
       * CBC encryptor.
       */ CBC.Encryptor = CBC.extend({
                                /**
         * Processes the data block at offset.
         *
         * @param {Array} words The data words to operate on.
         * @param {number} offset The offset where the block starts.
         *
         * @example
         *
         *     mode.processBlock(data.words, offset);
         */ processBlock: function processBlock(words, offset) {
                                    // Shortcuts
                                    var cipher = this._cipher;
                                    var blockSize = cipher.blockSize;
                                    // XOR and encrypt
                                    xorBlock.call(this, words, offset, blockSize);
                                    cipher.encryptBlock(words, offset);
                                    // Remember this block to use with next block
                                    this._prevBlock = words.slice(offset, offset + blockSize);
                                }
                            });
                            /**
       * CBC decryptor.
       */ CBC.Decryptor = CBC.extend({
                                /**
         * Processes the data block at offset.
         *
         * @param {Array} words The data words to operate on.
         * @param {number} offset The offset where the block starts.
         *
         * @example
         *
         *     mode.processBlock(data.words, offset);
         */ processBlock: function processBlock(words, offset) {
                                    // Shortcuts
                                    var cipher = this._cipher;
                                    var blockSize = cipher.blockSize;
                                    // Remember this block to use with next block
                                    var thisBlock = words.slice(offset, offset + blockSize);
                                    // Decrypt and XOR
                                    cipher.decryptBlock(words, offset);
                                    xorBlock.call(this, words, offset, blockSize);
                                    // This block becomes the previous block
                                    this._prevBlock = thisBlock;
                                }
                            });
                            function xorBlock(words, offset, blockSize) {
                                var block;
                                // Shortcut
                                var iv = this._iv;
                                // Choose mixing block
                                if (iv) {
                                    block = iv;
                                    // Remove IV for subsequent blocks
                                    this._iv = undefined1;
                                } else block = this._prevBlock;
                                // XOR blocks
                                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
                            }
                            return CBC;
                        }();
                        /**
     * Padding namespace.
     */ var C_pad = C.pad = {};
                        /**
     * PKCS #5/7 padding strategy.
     */ var Pkcs7 = C_pad.Pkcs7 = {
                            /**
       * Pads data using the algorithm defined in PKCS #5/7.
       *
       * @param {WordArray} data The data to pad.
       * @param {number} blockSize The multiple that the data should be padded to.
       *
       * @static
       *
       * @example
       *
       *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
       */ pad: function pad(data, blockSize) {
                                // Shortcut
                                var blockSizeBytes = blockSize * 4;
                                // Count padding bytes
                                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                                // Create padding word
                                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                                // Create padding
                                var paddingWords = [];
                                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                                var padding = WordArray.create(paddingWords, nPaddingBytes);
                                // Add padding
                                data.concat(padding);
                            },
                            /**
       * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
       *
       * @param {WordArray} data The data to unpad.
       *
       * @static
       *
       * @example
       *
       *     CryptoJS.pad.Pkcs7.unpad(wordArray);
       */ unpad: function unpad(data) {
                                // Get number of padding bytes from last byte
                                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                                // Remove padding
                                data.sigBytes -= nPaddingBytes;
                            }
                        };
                        /**
     * Abstract base block cipher template.
     *
     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
                            /**
       * Configuration options.
       *
       * @property {Mode} mode The block mode to use. Default: CBC
       * @property {Padding} padding The padding strategy to use. Default: Pkcs7
       */ cfg: Cipher.cfg.extend({
                                mode: CBC,
                                padding: Pkcs7
                            }),
                            reset: function reset() {
                                var modeCreator;
                                // Reset cipher
                                Cipher.reset.call(this);
                                // Shortcuts
                                var cfg = this.cfg;
                                var iv = cfg.iv;
                                var mode = cfg.mode;
                                // Reset block mode
                                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                                    modeCreator = mode.createDecryptor;
                                    // Keep at least one block in the buffer for unpadding
                                    this._minBufferSize = 1;
                                }
                                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                                else {
                                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                                    this._mode.__creator = modeCreator;
                                }
                            },
                            _doProcessBlock: function _doProcessBlock(words, offset) {
                                this._mode.processBlock(words, offset);
                            },
                            _doFinalize: function _doFinalize() {
                                var finalProcessedBlocks;
                                // Shortcut
                                var padding = this.cfg.padding;
                                // Finalize
                                if (this._xformMode == this._ENC_XFORM_MODE) {
                                    // Pad data
                                    padding.pad(this._data, this.blockSize);
                                    // Process final blocks
                                    finalProcessedBlocks = this._process(true);
                                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                                    // Process final blocks
                                    finalProcessedBlocks = this._process(true);
                                    // Unpad data
                                    padding.unpad(finalProcessedBlocks);
                                }
                                return finalProcessedBlocks;
                            },
                            blockSize: 4
                        });
                        /**
     * A collection of cipher parameters.
     *
     * @property {WordArray} ciphertext The raw ciphertext.
     * @property {WordArray} key The key to this ciphertext.
     * @property {WordArray} iv The IV used in the ciphering operation.
     * @property {WordArray} salt The salt used with a key derivation function.
     * @property {Cipher} algorithm The cipher algorithm.
     * @property {Mode} mode The block mode used in the ciphering operation.
     * @property {Padding} padding The padding scheme used in the ciphering operation.
     * @property {number} blockSize The block size of the cipher.
     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
     */ var CipherParams = C_lib.CipherParams = Base.extend({
                            /**
       * Initializes a newly created cipher params object.
       *
       * @param {Object} cipherParams An object with any of the possible cipher parameters.
       *
       * @example
       *
       *     var cipherParams = CryptoJS.lib.CipherParams.create({
       *         ciphertext: ciphertextWordArray,
       *         key: keyWordArray,
       *         iv: ivWordArray,
       *         salt: saltWordArray,
       *         algorithm: CryptoJS.algo.AES,
       *         mode: CryptoJS.mode.CBC,
       *         padding: CryptoJS.pad.PKCS7,
       *         blockSize: 4,
       *         formatter: CryptoJS.format.OpenSSL
       *     });
       */ init: function init(cipherParams) {
                                this.mixIn(cipherParams);
                            },
                            /**
       * Converts this cipher params object to a string.
       *
       * @param {Format} formatter (Optional) The formatting strategy to use.
       *
       * @return {string} The stringified cipher params.
       *
       * @throws Error If neither the formatter nor the default formatter is set.
       *
       * @example
       *
       *     var string = cipherParams + '';
       *     var string = cipherParams.toString();
       *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
       */ toString: function toString(formatter) {
                                return (formatter || this.formatter).stringify(this);
                            }
                        });
                        /**
     * Format namespace.
     */ var C_format = C.format = {};
                        /**
     * OpenSSL formatting strategy.
     */ var OpenSSLFormatter = C_format.OpenSSL = {
                            /**
       * Converts a cipher params object to an OpenSSL-compatible string.
       *
       * @param {CipherParams} cipherParams The cipher params object.
       *
       * @return {string} The OpenSSL-compatible string.
       *
       * @static
       *
       * @example
       *
       *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
       */ stringify: function stringify(cipherParams) {
                                var wordArray;
                                // Shortcuts
                                var ciphertext = cipherParams.ciphertext;
                                var salt = cipherParams.salt;
                                // Format
                                if (salt) wordArray = WordArray.create([
                                    0x53616c74,
                                    0x65645f5f
                                ]).concat(salt).concat(ciphertext);
                                else wordArray = ciphertext;
                                return wordArray.toString(Base64);
                            },
                            /**
       * Converts an OpenSSL-compatible string to a cipher params object.
       *
       * @param {string} openSSLStr The OpenSSL-compatible string.
       *
       * @return {CipherParams} The cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
       */ parse: function parse(openSSLStr) {
                                var salt;
                                // Parse base64
                                var ciphertext = Base64.parse(openSSLStr);
                                // Shortcut
                                var ciphertextWords = ciphertext.words;
                                // Test for salt
                                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                                    // Extract salt
                                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                                    // Remove salt from ciphertext
                                    ciphertextWords.splice(0, 4);
                                    ciphertext.sigBytes -= 16;
                                }
                                return CipherParams.create({
                                    ciphertext: ciphertext,
                                    salt: salt
                                });
                            }
                        };
                        /**
     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
                            /**
       * Configuration options.
       *
       * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
       */ cfg: Base.extend({
                                format: OpenSSLFormatter
                            }),
                            /**
       * Encrypts a message.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {WordArray|string} message The message to encrypt.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {CipherParams} A cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       */ encrypt: function encrypt(cipher, message, key, cfg) {
                                // Apply config defaults
                                cfg = this.cfg.extend(cfg);
                                // Encrypt
                                var encryptor = cipher.createEncryptor(key, cfg);
                                var ciphertext = encryptor.finalize(message);
                                // Shortcut
                                var cipherCfg = encryptor.cfg;
                                // Create and return serializable cipher params
                                return CipherParams.create({
                                    ciphertext: ciphertext,
                                    key: key,
                                    iv: cipherCfg.iv,
                                    algorithm: cipher,
                                    mode: cipherCfg.mode,
                                    padding: cipherCfg.padding,
                                    blockSize: cipher.blockSize,
                                    formatter: cfg.format
                                });
                            },
                            /**
       * Decrypts serialized ciphertext.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {WordArray} The plaintext.
       *
       * @static
       *
       * @example
       *
       *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       */ decrypt: function decrypt(cipher, ciphertext, key, cfg) {
                                // Apply config defaults
                                cfg = this.cfg.extend(cfg);
                                // Convert string to CipherParams
                                ciphertext = this._parse(ciphertext, cfg.format);
                                // Decrypt
                                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                                return plaintext;
                            },
                            /**
       * Converts serialized ciphertext to CipherParams,
       * else assumed CipherParams already and returns ciphertext unchanged.
       *
       * @param {CipherParams|string} ciphertext The ciphertext.
       * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
       *
       * @return {CipherParams} The unserialized ciphertext.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
       */ _parse: function _parse(ciphertext, format) {
                                if (typeof ciphertext == 'string') return format.parse(ciphertext, this);
                                else return ciphertext;
                            }
                        });
                        /**
     * Key derivation function namespace.
     */ var C_kdf = C.kdf = {};
                        /**
     * OpenSSL key derivation function.
     */ var OpenSSLKdf = C_kdf.OpenSSL = {
                            /**
       * Derives a key and IV from a password.
       *
       * @param {string} password The password to derive from.
       * @param {number} keySize The size in words of the key to generate.
       * @param {number} ivSize The size in words of the IV to generate.
       * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
       *
       * @return {CipherParams} A cipher params object with the key, IV, and salt.
       *
       * @static
       *
       * @example
       *
       *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
       *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
       */ execute: function execute(password, keySize, ivSize, salt, hasher) {
                                // Generate random salt
                                if (!salt) salt = WordArray.random(8);
                                // Derive key and IV
                                if (!hasher) var key = EvpKDF.create({
                                    keySize: keySize + ivSize
                                }).compute(password, salt);
                                else var key = EvpKDF.create({
                                    keySize: keySize + ivSize,
                                    hasher: hasher
                                }).compute(password, salt);
                                // Separate key and IV
                                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                                key.sigBytes = keySize * 4;
                                // Return params
                                return CipherParams.create({
                                    key: key,
                                    iv: iv,
                                    salt: salt
                                });
                            }
                        };
                        /**
     * A serializable cipher wrapper that derives the key from a password,
     * and returns ciphertext as a serializable cipher params object.
     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
                            /**
       * Configuration options.
       *
       * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
       */ cfg: SerializableCipher.cfg.extend({
                                kdf: OpenSSLKdf
                            }),
                            /**
       * Encrypts a message using a password.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {WordArray|string} message The message to encrypt.
       * @param {string} password The password.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {CipherParams} A cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
       *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
       */ encrypt: function encrypt(cipher, message, password, cfg) {
                                // Apply config defaults
                                cfg = this.cfg.extend(cfg);
                                // Derive key and other params
                                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                                // Add IV to config
                                cfg.iv = derivedParams.iv;
                                // Encrypt
                                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                                // Mix in derived params
                                ciphertext.mixIn(derivedParams);
                                return ciphertext;
                            },
                            /**
       * Decrypts serialized ciphertext using a password.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
       * @param {string} password The password.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {WordArray} The plaintext.
       *
       * @static
       *
       * @example
       *
       *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
       *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
       */ decrypt: function decrypt(cipher, ciphertext, password, cfg) {
                                // Apply config defaults
                                cfg = this.cfg.extend(cfg);
                                // Convert string to CipherParams
                                ciphertext = this._parse(ciphertext, cfg.format);
                                // Derive key and other params
                                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                                // Add IV to config
                                cfg.iv = derivedParams.iv;
                                // Decrypt
                                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                                return plaintext;
                            }
                        });
                    }();
                });
            /***/ },
            /***/ 51334: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var getBuiltIn = __webpack_require__(38486);
                var definePropertyModule = __webpack_require__(95892);
                var wellKnownSymbol = __webpack_require__(38688);
                var DESCRIPTORS = __webpack_require__(15567);
                var SPECIES = wellKnownSymbol('species');
                module1.exports = function(CONSTRUCTOR_NAME) {
                    var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
                    var defineProperty = definePropertyModule.f;
                    if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) defineProperty(Constructor, SPECIES, {
                        configurable: true,
                        get: function() {
                            return this;
                        }
                    });
                };
            /***/ },
            /***/ 51374: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var supportsDescriptors = __webpack_require__(77802).supportsDescriptors;
                var getPolyfill = __webpack_require__(7844);
                var gOPD = __webpack_require__(68109);
                var defineProperty = Object.defineProperty;
                var $TypeError = __webpack_require__(15293);
                var getProto = __webpack_require__(87106);
                var regex = /a/;
                module1.exports = function shimFlags() {
                    if (!supportsDescriptors || !getProto) throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
                    var polyfill = getPolyfill();
                    var proto = getProto(regex);
                    var descriptor = gOPD(proto, 'flags');
                    if (!descriptor || descriptor.get !== polyfill) defineProperty(proto, 'flags', {
                        configurable: true,
                        enumerable: false,
                        get: polyfill
                    });
                    return polyfill;
                };
            /***/ },
            /***/ 51839: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var aCallable = __webpack_require__(32631);
                // `GetMethod` abstract operation
                // https://tc39.es/ecma262/#sec-getmethod
                module1.exports = function(V, P) {
                    var func = V[P];
                    return func == null ? undefined : aCallable(func);
                };
            /***/ },
            /***/ 51868: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var isCallable = __webpack_require__(94578);
                var isObject = __webpack_require__(24517);
                var setPrototypeOf = __webpack_require__(3840);
                // makes subclassing work correct for wrapped built-ins
                module1.exports = function($this, dummy, Wrapper) {
                    var NewTarget, NewTargetPrototype;
                    if (// it can work only with native `setPrototypeOf`
                    setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
                    isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
                    return $this;
                };
            /***/ },
            /***/ 51965: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(18909));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Hasher = C_lib.Hasher;
                        var C_x64 = C.x64;
                        var X64Word = C_x64.Word;
                        var X64WordArray = C_x64.WordArray;
                        var C_algo = C.algo;
                        function X64Word_create() {
                            return X64Word.create.apply(X64Word, arguments);
                        }
                        // Constants
                        var K = [
                            X64Word_create(0x428a2f98, 0xd728ae22),
                            X64Word_create(0x71374491, 0x23ef65cd),
                            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
                            X64Word_create(0xe9b5dba5, 0x8189dbbc),
                            X64Word_create(0x3956c25b, 0xf348b538),
                            X64Word_create(0x59f111f1, 0xb605d019),
                            X64Word_create(0x923f82a4, 0xaf194f9b),
                            X64Word_create(0xab1c5ed5, 0xda6d8118),
                            X64Word_create(0xd807aa98, 0xa3030242),
                            X64Word_create(0x12835b01, 0x45706fbe),
                            X64Word_create(0x243185be, 0x4ee4b28c),
                            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
                            X64Word_create(0x72be5d74, 0xf27b896f),
                            X64Word_create(0x80deb1fe, 0x3b1696b1),
                            X64Word_create(0x9bdc06a7, 0x25c71235),
                            X64Word_create(0xc19bf174, 0xcf692694),
                            X64Word_create(0xe49b69c1, 0x9ef14ad2),
                            X64Word_create(0xefbe4786, 0x384f25e3),
                            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
                            X64Word_create(0x240ca1cc, 0x77ac9c65),
                            X64Word_create(0x2de92c6f, 0x592b0275),
                            X64Word_create(0x4a7484aa, 0x6ea6e483),
                            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
                            X64Word_create(0x76f988da, 0x831153b5),
                            X64Word_create(0x983e5152, 0xee66dfab),
                            X64Word_create(0xa831c66d, 0x2db43210),
                            X64Word_create(0xb00327c8, 0x98fb213f),
                            X64Word_create(0xbf597fc7, 0xbeef0ee4),
                            X64Word_create(0xc6e00bf3, 0x3da88fc2),
                            X64Word_create(0xd5a79147, 0x930aa725),
                            X64Word_create(0x06ca6351, 0xe003826f),
                            X64Word_create(0x14292967, 0x0a0e6e70),
                            X64Word_create(0x27b70a85, 0x46d22ffc),
                            X64Word_create(0x2e1b2138, 0x5c26c926),
                            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
                            X64Word_create(0x53380d13, 0x9d95b3df),
                            X64Word_create(0x650a7354, 0x8baf63de),
                            X64Word_create(0x766a0abb, 0x3c77b2a8),
                            X64Word_create(0x81c2c92e, 0x47edaee6),
                            X64Word_create(0x92722c85, 0x1482353b),
                            X64Word_create(0xa2bfe8a1, 0x4cf10364),
                            X64Word_create(0xa81a664b, 0xbc423001),
                            X64Word_create(0xc24b8b70, 0xd0f89791),
                            X64Word_create(0xc76c51a3, 0x0654be30),
                            X64Word_create(0xd192e819, 0xd6ef5218),
                            X64Word_create(0xd6990624, 0x5565a910),
                            X64Word_create(0xf40e3585, 0x5771202a),
                            X64Word_create(0x106aa070, 0x32bbd1b8),
                            X64Word_create(0x19a4c116, 0xb8d2d0c8),
                            X64Word_create(0x1e376c08, 0x5141ab53),
                            X64Word_create(0x2748774c, 0xdf8eeb99),
                            X64Word_create(0x34b0bcb5, 0xe19b48a8),
                            X64Word_create(0x391c0cb3, 0xc5c95a63),
                            X64Word_create(0x4ed8aa4a, 0xe3418acb),
                            X64Word_create(0x5b9cca4f, 0x7763e373),
                            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
                            X64Word_create(0x748f82ee, 0x5defb2fc),
                            X64Word_create(0x78a5636f, 0x43172f60),
                            X64Word_create(0x84c87814, 0xa1f0ab72),
                            X64Word_create(0x8cc70208, 0x1a6439ec),
                            X64Word_create(0x90befffa, 0x23631e28),
                            X64Word_create(0xa4506ceb, 0xde82bde9),
                            X64Word_create(0xbef9a3f7, 0xb2c67915),
                            X64Word_create(0xc67178f2, 0xe372532b),
                            X64Word_create(0xca273ece, 0xea26619c),
                            X64Word_create(0xd186b8c7, 0x21c0c207),
                            X64Word_create(0xeada7dd6, 0xcde0eb1e),
                            X64Word_create(0xf57d4f7f, 0xee6ed178),
                            X64Word_create(0x06f067aa, 0x72176fba),
                            X64Word_create(0x0a637dc5, 0xa2c898a6),
                            X64Word_create(0x113f9804, 0xbef90dae),
                            X64Word_create(0x1b710b35, 0x131c471b),
                            X64Word_create(0x28db77f5, 0x23047d84),
                            X64Word_create(0x32caab7b, 0x40c72493),
                            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
                            X64Word_create(0x431d67c4, 0x9c100d4c),
                            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
                            X64Word_create(0x597f299c, 0xfc657e2a),
                            X64Word_create(0x5fcb6fab, 0x3ad6faec),
                            X64Word_create(0x6c44198c, 0x4a475817)
                        ];
                        // Reusable objects
                        var W = [];
                        (function() {
                            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
                        })();
                        /**
     * SHA-512 hash algorithm.
     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
                            _doReset: function _doReset() {
                                this._hash = new X64WordArray.init([
                                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                                    new X64Word.init(0x510e527f, 0xade682d1),
                                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                                    new X64Word.init(0x5be0cd19, 0x137e2179)
                                ]);
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcuts
                                var H = this._hash.words;
                                var H0 = H[0];
                                var H1 = H[1];
                                var H2 = H[2];
                                var H3 = H[3];
                                var H4 = H[4];
                                var H5 = H[5];
                                var H6 = H[6];
                                var H7 = H[7];
                                var H0h = H0.high;
                                var H0l = H0.low;
                                var H1h = H1.high;
                                var H1l = H1.low;
                                var H2h = H2.high;
                                var H2l = H2.low;
                                var H3h = H3.high;
                                var H3l = H3.low;
                                var H4h = H4.high;
                                var H4l = H4.low;
                                var H5h = H5.high;
                                var H5l = H5.low;
                                var H6h = H6.high;
                                var H6l = H6.low;
                                var H7h = H7.high;
                                var H7l = H7.low;
                                // Working variables
                                var ah = H0h;
                                var al = H0l;
                                var bh = H1h;
                                var bl = H1l;
                                var ch = H2h;
                                var cl = H2l;
                                var dh = H3h;
                                var dl = H3l;
                                var eh = H4h;
                                var el = H4l;
                                var fh = H5h;
                                var fl = H5l;
                                var gh = H6h;
                                var gl = H6l;
                                var hh = H7h;
                                var hl = H7l;
                                // Rounds
                                for(var i = 0; i < 80; i++){
                                    var Wil;
                                    var Wih;
                                    // Shortcut
                                    var Wi = W[i];
                                    // Extend message
                                    if (i < 16) {
                                        Wih = Wi.high = M[offset + i * 2] | 0;
                                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                                    } else {
                                        // Gamma0
                                        var gamma0x = W[i - 15];
                                        var gamma0xh = gamma0x.high;
                                        var gamma0xl = gamma0x.low;
                                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                                        // Gamma1
                                        var gamma1x = W[i - 2];
                                        var gamma1xh = gamma1x.high;
                                        var gamma1xl = gamma1x.low;
                                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                                        var Wi7 = W[i - 7];
                                        var Wi7h = Wi7.high;
                                        var Wi7l = Wi7.low;
                                        var Wi16 = W[i - 16];
                                        var Wi16h = Wi16.high;
                                        var Wi16l = Wi16.low;
                                        Wil = gamma0l + Wi7l;
                                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                                        Wil = Wil + gamma1l;
                                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                                        Wil = Wil + Wi16l;
                                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                                        Wi.high = Wih;
                                        Wi.low = Wil;
                                    }
                                    var chh = eh & fh ^ ~eh & gh;
                                    var chl = el & fl ^ ~el & gl;
                                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                                    var majl = al & bl ^ al & cl ^ bl & cl;
                                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                                    // t1 = h + sigma1 + ch + K[i] + W[i]
                                    var Ki = K[i];
                                    var Kih = Ki.high;
                                    var Kil = Ki.low;
                                    var t1l = hl + sigma1l;
                                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                                    var t1l = t1l + chl;
                                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                                    var t1l = t1l + Kil;
                                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                                    var t1l = t1l + Wil;
                                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                                    // t2 = sigma0 + maj
                                    var t2l = sigma0l + majl;
                                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                                    // Update working variables
                                    hh = gh;
                                    hl = gl;
                                    gh = fh;
                                    gl = fl;
                                    fh = eh;
                                    fl = el;
                                    el = dl + t1l | 0;
                                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                                    dh = ch;
                                    dl = cl;
                                    ch = bh;
                                    cl = bl;
                                    bh = ah;
                                    bl = al;
                                    al = t1l + t2l | 0;
                                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                                }
                                // Intermediate hash value
                                H0l = H0.low = H0l + al;
                                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                                H1l = H1.low = H1l + bl;
                                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                                H2l = H2.low = H2l + cl;
                                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                                H3l = H3.low = H3l + dl;
                                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                                H4l = H4.low = H4l + el;
                                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                                H5l = H5.low = H5l + fl;
                                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                                H6l = H6.low = H6l + gl;
                                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                                H7l = H7.low = H7l + hl;
                                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                                data.sigBytes = dataWords.length * 4;
                                // Hash final blocks
                                this._process();
                                // Convert hash to 32-bit word array before returning
                                var hash = this._hash.toX32();
                                // Return final computed hash
                                return hash;
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                clone._hash = this._hash.clone();
                                return clone;
                            },
                            blockSize: 32
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA512('message');
     *     var hash = CryptoJS.SHA512(wordArray);
     */ C.SHA512 = Hasher._createHelper(SHA512);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA512(message, key);
     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
                    })();
                    return CryptoJS.SHA512;
                });
            /***/ },
            /***/ 52331: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var BOMChar = '\uFEFF';
                exports.PrependBOM = PrependBOMWrapper;
                function PrependBOMWrapper(encoder, options) {
                    this.encoder = encoder;
                    this.addBOM = true;
                }
                PrependBOMWrapper.prototype.write = function(str) {
                    if (this.addBOM) {
                        str = BOMChar + str;
                        this.addBOM = false;
                    }
                    return this.encoder.write(str);
                };
                PrependBOMWrapper.prototype.end = function() {
                    return this.encoder.end();
                };
                //------------------------------------------------------------------------------
                exports.StripBOM = StripBOMWrapper;
                function StripBOMWrapper(decoder, options) {
                    this.decoder = decoder;
                    this.pass = false;
                    this.options = options || {};
                }
                StripBOMWrapper.prototype.write = function(buf) {
                    var res = this.decoder.write(buf);
                    if (this.pass || !res) return res;
                    if (res[0] === BOMChar) {
                        res = res.slice(1);
                        if (typeof this.options.stripBOM === 'function') this.options.stripBOM();
                    }
                    this.pass = true;
                    return res;
                };
                StripBOMWrapper.prototype.end = function() {
                    return this.decoder.end();
                };
            /***/ },
            /***/ 52529: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var exportTypedArrayMethod = __webpack_require__(59754).exportTypedArrayMethod;
                var fails = __webpack_require__(47044);
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var Uint8Array1 = global.Uint8Array;
                var Uint8ArrayPrototype = Uint8Array1 && Uint8Array1.prototype || {};
                var arrayToString = [].toString;
                var join = uncurryThis([].join);
                if (fails(function() {
                    arrayToString.call({});
                })) arrayToString = function toString() {
                    return join(this);
                };
                var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;
                // `%TypedArray%.prototype.toString` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
                exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);
            /***/ },
            /***/ 52564: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var TO_STRING_TAG_SUPPORT = __webpack_require__(24663);
                var isCallable = __webpack_require__(94578);
                var classofRaw = __webpack_require__(93975);
                var wellKnownSymbol = __webpack_require__(38688);
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var Object1 = global.Object;
                // ES3 wrong here
                var CORRECT_ARGUMENTS = classofRaw(function() {
                    return arguments;
                }()) == 'Arguments';
                // fallback for IE11 Script Access Denied error
                var tryGet = function(it, key) {
                    try {
                        return it[key];
                    } catch (error) {}
                };
                // getting tag from ES6+ `Object.prototype.toString`
                module1.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
                    var O, tag, result;
                    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = Object1(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
                };
            /***/ },
            /***/ 52598: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var TO_STRING_TAG_SUPPORT = __webpack_require__(24663);
                var classof = __webpack_require__(52564);
                // `Object.prototype.toString` method implementation
                // https://tc39.es/ecma262/#sec-object.prototype.tostring
                module1.exports = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
                    return '[object ' + classof(this) + ']';
                };
            /***/ },
            /***/ 52676: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                var _require = __webpack_require__(56128), NumberT = _require.Number;
                var utils = __webpack_require__(18128);
                var StringT = /*#__PURE__*/ function() {
                    function StringT(length, encoding) {
                        if (encoding === void 0) encoding = 'ascii';
                        this.length = length;
                        this.encoding = encoding;
                    }
                    var _proto = StringT.prototype;
                    _proto.decode = function decode(stream, parent) {
                        var length, pos;
                        if (this.length != null) length = utils.resolveLength(this.length, stream, parent);
                        else {
                            var buffer;
                            buffer = stream.buffer;
                            length = stream.length;
                            pos = stream.pos;
                            while(pos < length && buffer[pos] !== 0x00)++pos;
                            length = pos - stream.pos;
                        }
                        var encoding = this.encoding;
                        if (typeof encoding === 'function') encoding = encoding.call(parent, parent) || 'ascii';
                        var string = stream.readString(length, encoding);
                        if (this.length == null && stream.pos < stream.length) stream.pos++;
                        return string;
                    };
                    _proto.size = function size(val, parent) {
                        // Use the defined value if no value was given
                        if (!val) return utils.resolveLength(this.length, null, parent);
                        var encoding = this.encoding;
                        if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
                        if (encoding === 'utf16be') encoding = 'utf16le';
                        var size = Buffer.byteLength(val, encoding);
                        if (this.length instanceof NumberT) size += this.length.size();
                        if (this.length == null) size++;
                        return size;
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        var encoding = this.encoding;
                        if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
                        if (this.length instanceof NumberT) this.length.encode(stream, Buffer.byteLength(val, encoding));
                        stream.writeString(val, encoding);
                        if (this.length == null) return stream.writeUInt8(0x00);
                    };
                    return StringT;
                }();
                module1.exports = StringT;
            /***/ },
            /***/ 53087: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(32010);
                var anObject = __webpack_require__(34984);
                var ordinaryToPrimitive = __webpack_require__(39629);
                var TypeError1 = global.TypeError;
                // `Date.prototype[@@toPrimitive](hint)` method implementation
                // https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
                module1.exports = function(hint) {
                    anObject(this);
                    if (hint === 'string' || hint === 'default') hint = 'string';
                    else if (hint !== 'number') throw TypeError1('Incorrect hint');
                    return ordinaryToPrimitive(this, hint);
                };
            /***/ },
            /***/ 54055: /***/ function(module1) {
                "use strict";
                /** @type {import('./uri')} */ module1.exports = URIError;
            /***/ },
            /***/ 54171: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(93143).Buffer;
                var bomHandling = __webpack_require__(52331), iconv = module1.exports;
                // All codecs and aliases are kept here, keyed by encoding name/alias.
                // They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
                iconv.encodings = null;
                // Characters emitted in case of error.
                iconv.defaultCharUnicode = "\uFFFD";
                iconv.defaultCharSingleByte = '?';
                // Public API.
                iconv.encode = function encode(str, encoding, options) {
                    str = "" + (str || ""); // Ensure string.
                    var encoder = iconv.getEncoder(encoding, options);
                    var res = encoder.write(str);
                    var trail = encoder.end();
                    return trail && trail.length > 0 ? Buffer.concat([
                        res,
                        trail
                    ]) : res;
                };
                iconv.decode = function decode(buf, encoding, options) {
                    if (typeof buf === 'string') {
                        if (!iconv.skipDecodeWarning) {
                            console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
                            iconv.skipDecodeWarning = true;
                        }
                        buf = Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
                    }
                    var decoder = iconv.getDecoder(encoding, options);
                    var res = decoder.write(buf);
                    var trail = decoder.end();
                    return trail ? res + trail : res;
                };
                iconv.encodingExists = function encodingExists(enc) {
                    try {
                        iconv.getCodec(enc);
                        return true;
                    } catch (e) {
                        return false;
                    }
                };
                // Legacy aliases to convert functions
                iconv.toEncoding = iconv.encode;
                iconv.fromEncoding = iconv.decode;
                // Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
                iconv._codecDataCache = {};
                iconv.getCodec = function getCodec(encoding) {
                    if (!iconv.encodings) iconv.encodings = __webpack_require__(26326); // Lazy load all encoding definitions.
                    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
                    var enc = iconv._canonicalizeEncoding(encoding);
                    // Traverse iconv.encodings to find actual codec.
                    var codecOptions = {};
                    while(true){
                        var codec = iconv._codecDataCache[enc];
                        if (codec) return codec;
                        var codecDef = iconv.encodings[enc];
                        switch(typeof codecDef){
                            case "string":
                                enc = codecDef;
                                break;
                            case "object":
                                for(var key in codecDef)codecOptions[key] = codecDef[key];
                                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                                enc = codecDef.type;
                                break;
                            case "function":
                                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                                // The codec function must load all tables and return object with .encoder and .decoder methods.
                                // It'll be called only once (for each different options object).
                                codec = new codecDef(codecOptions, iconv);
                                iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                                return codec;
                            default:
                                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '" + enc + "')");
                        }
                    }
                };
                iconv._canonicalizeEncoding = function(encoding) {
                    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
                    return ('' + encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
                };
                iconv.getEncoder = function getEncoder(encoding, options) {
                    var codec = iconv.getCodec(encoding), encoder = new codec.encoder(options, codec);
                    if (codec.bomAware && options && options.addBOM) encoder = new bomHandling.PrependBOM(encoder, options);
                    return encoder;
                };
                iconv.getDecoder = function getDecoder(encoding, options) {
                    var codec = iconv.getCodec(encoding), decoder = new codec.decoder(options, codec);
                    if (codec.bomAware && !(options && options.stripBOM === false)) decoder = new bomHandling.StripBOM(decoder, options);
                    return decoder;
                };
                // Streaming API
                // NOTE: Streaming API naturally depends on 'stream' module from Node.js. Unfortunately in browser environments this module can add
                // up to 100Kb to the output bundle. To avoid unnecessary code bloat, we don't enable Streaming API in browser by default.
                // If you would like to enable it explicitly, please add the following code to your app:
                // > iconv.enableStreamingAPI(require('stream'));
                iconv.enableStreamingAPI = function enableStreamingAPI(stream_module) {
                    if (iconv.supportsStreams) return;
                    // Dependency-inject stream module to create IconvLite stream classes.
                    var streams = __webpack_require__(34506)(stream_module);
                    // Not public API yet, but expose the stream classes.
                    iconv.IconvLiteEncoderStream = streams.IconvLiteEncoderStream;
                    iconv.IconvLiteDecoderStream = streams.IconvLiteDecoderStream;
                    // Streaming API.
                    iconv.encodeStream = function encodeStream(encoding, options) {
                        return new iconv.IconvLiteEncoderStream(iconv.getEncoder(encoding, options), options);
                    };
                    iconv.decodeStream = function decodeStream(encoding, options) {
                        return new iconv.IconvLiteDecoderStream(iconv.getDecoder(encoding, options), options);
                    };
                    iconv.supportsStreams = true;
                };
                // Enable Streaming API automatically if 'stream' module is available and non-empty (the majority of environments).
                var stream_module;
                try {
                    stream_module = __webpack_require__(16403);
                } catch (e) {}
                if (stream_module && stream_module.Transform) iconv.enableStreamingAPI(stream_module);
                else // In rare cases where 'stream' module is not available by default, throw a helpful exception.
                iconv.encodeStream = iconv.decodeStream = function() {
                    throw new Error("iconv-lite Streaming API is not enabled. Use iconv.enableStreamingAPI(require('stream')); to enable it.");
                };
            /***/ },
            /***/ 54861: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var Line = __webpack_require__(70770);
                var isNumber = __webpack_require__(91867).isNumber;
                var pack = __webpack_require__(91867).pack;
                var offsetVector = __webpack_require__(91867).offsetVector;
                var DocumentContext = __webpack_require__(79178);
                /**
 * Creates an instance of ElementWriter - a line/vector writer, which adds
 * elements to current page and sets their positions based on the context
 */ function ElementWriter(context, tracker) {
                    this.context = context;
                    this.contextStack = [];
                    this.tracker = tracker;
                }
                function addPageItem(page, item, index) {
                    if (index === null || index === undefined || index < 0 || index > page.items.length) page.items.push(item);
                    else page.items.splice(index, 0, item);
                }
                ElementWriter.prototype.addLine = function(line, dontUpdateContextPosition, index) {
                    var height = line.getHeight();
                    var context = this.context;
                    var page = context.getCurrentPage(), position = this.getCurrentPositionOnPage();
                    if (context.availableHeight < height || !page) return false;
                    line.x = context.x + (line.x || 0);
                    line.y = context.y + (line.y || 0);
                    this.alignLine(line);
                    addPageItem(page, {
                        type: 'line',
                        item: line
                    }, index);
                    this.tracker.emit('lineAdded', line);
                    if (!dontUpdateContextPosition) context.moveDown(height);
                    return position;
                };
                ElementWriter.prototype.alignLine = function(line) {
                    var width = this.context.availableWidth;
                    var lineWidth = line.getWidth();
                    var alignment = line.inlines && line.inlines.length > 0 && line.inlines[0].alignment;
                    var offset = 0;
                    switch(alignment){
                        case 'right':
                            offset = width - lineWidth;
                            break;
                        case 'center':
                            offset = (width - lineWidth) / 2;
                            break;
                    }
                    if (offset) line.x = (line.x || 0) + offset;
                    if (alignment === 'justify' && !line.newLineForced && !line.lastLineInParagraph && line.inlines.length > 1) {
                        var additionalSpacing = (width - lineWidth) / (line.inlines.length - 1);
                        for(var i = 1, l = line.inlines.length; i < l; i++){
                            offset = i * additionalSpacing;
                            line.inlines[i].x += offset;
                            line.inlines[i].justifyShift = additionalSpacing;
                        }
                    }
                };
                ElementWriter.prototype.addImage = function(image, index, type) {
                    var context = this.context;
                    var page = context.getCurrentPage(), position = this.getCurrentPositionOnPage();
                    if (!page || image.absolutePosition === undefined && context.availableHeight < image._height && page.items.length > 0) return false;
                    if (image._x === undefined) image._x = image.x || 0;
                    image.x = context.x + image._x;
                    image.y = context.y;
                    this.alignImage(image);
                    addPageItem(page, {
                        type: type || 'image',
                        item: image
                    }, index);
                    context.moveDown(image._height);
                    return position;
                };
                ElementWriter.prototype.addSVG = function(image, index) {
                    return this.addImage(image, index, 'svg');
                };
                ElementWriter.prototype.addQr = function(qr, index) {
                    var context = this.context;
                    var page = context.getCurrentPage(), position = this.getCurrentPositionOnPage();
                    if (!page || qr.absolutePosition === undefined && context.availableHeight < qr._height) return false;
                    if (qr._x === undefined) qr._x = qr.x || 0;
                    qr.x = context.x + qr._x;
                    qr.y = context.y;
                    this.alignImage(qr);
                    for(var i = 0, l = qr._canvas.length; i < l; i++){
                        var vector = qr._canvas[i];
                        vector.x += qr.x;
                        vector.y += qr.y;
                        this.addVector(vector, true, true, index);
                    }
                    context.moveDown(qr._height);
                    return position;
                };
                ElementWriter.prototype.alignImage = function(image) {
                    var width = this.context.availableWidth;
                    var imageWidth = image._minWidth;
                    var offset = 0;
                    switch(image._alignment){
                        case 'right':
                            offset = width - imageWidth;
                            break;
                        case 'center':
                            offset = (width - imageWidth) / 2;
                            break;
                    }
                    if (offset) image.x = (image.x || 0) + offset;
                };
                ElementWriter.prototype.alignCanvas = function(node) {
                    var width = this.context.availableWidth;
                    var canvasWidth = node._minWidth;
                    var offset = 0;
                    switch(node._alignment){
                        case 'right':
                            offset = width - canvasWidth;
                            break;
                        case 'center':
                            offset = (width - canvasWidth) / 2;
                            break;
                    }
                    if (offset) node.canvas.forEach(function(vector) {
                        offsetVector(vector, offset, 0);
                    });
                };
                ElementWriter.prototype.addVector = function(vector, ignoreContextX, ignoreContextY, index, forcePage) {
                    var context = this.context;
                    var page = context.getCurrentPage();
                    if (isNumber(forcePage)) page = context.pages[forcePage];
                    var position = this.getCurrentPositionOnPage();
                    if (page) {
                        offsetVector(vector, ignoreContextX ? 0 : context.x, ignoreContextY ? 0 : context.y);
                        addPageItem(page, {
                            type: 'vector',
                            item: vector
                        }, index);
                        return position;
                    }
                };
                ElementWriter.prototype.beginClip = function(width, height) {
                    var ctx = this.context;
                    var page = ctx.getCurrentPage();
                    page.items.push({
                        type: 'beginClip',
                        item: {
                            x: ctx.x,
                            y: ctx.y,
                            width: width,
                            height: height
                        }
                    });
                    return true;
                };
                ElementWriter.prototype.endClip = function() {
                    var ctx = this.context;
                    var page = ctx.getCurrentPage();
                    page.items.push({
                        type: 'endClip'
                    });
                    return true;
                };
                function cloneLine(line) {
                    var result = new Line(line.maxWidth);
                    for(var key in line)if (line.hasOwnProperty(key)) result[key] = line[key];
                    return result;
                }
                ElementWriter.prototype.addFragment = function(block, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
                    var ctx = this.context;
                    var page = ctx.getCurrentPage();
                    if (!useBlockXOffset && block.height > ctx.availableHeight) return false;
                    block.items.forEach(function(item) {
                        switch(item.type){
                            case 'line':
                                var l = cloneLine(item.item);
                                if (l._node) l._node.positions[0].pageNumber = ctx.page + 1;
                                l.x = (l.x || 0) + (useBlockXOffset ? block.xOffset || 0 : ctx.x);
                                l.y = (l.y || 0) + (useBlockYOffset ? block.yOffset || 0 : ctx.y);
                                page.items.push({
                                    type: 'line',
                                    item: l
                                });
                                break;
                            case 'vector':
                                var v = pack(item.item);
                                offsetVector(v, useBlockXOffset ? block.xOffset || 0 : ctx.x, useBlockYOffset ? block.yOffset || 0 : ctx.y);
                                if (v._isFillColorFromUnbreakable) {
                                    // If the item is a fillColor from an unbreakable block
                                    // We have to add it at the beginning of the items body array of the page
                                    delete v._isFillColorFromUnbreakable;
                                    const endOfBackgroundItemsIndex = ctx.backgroundLength[ctx.page];
                                    page.items.splice(endOfBackgroundItemsIndex, 0, {
                                        type: 'vector',
                                        item: v
                                    });
                                } else page.items.push({
                                    type: 'vector',
                                    item: v
                                });
                                break;
                            case 'image':
                            case 'svg':
                                var img = pack(item.item);
                                img.x = (img.x || 0) + (useBlockXOffset ? block.xOffset || 0 : ctx.x);
                                img.y = (img.y || 0) + (useBlockYOffset ? block.yOffset || 0 : ctx.y);
                                page.items.push({
                                    type: item.type,
                                    item: img
                                });
                                break;
                        }
                    });
                    if (!dontUpdateContextPosition) ctx.moveDown(block.height);
                    return true;
                };
                /**
 * Pushes the provided context onto the stack or creates a new one
 *
 * pushContext(context) - pushes the provided context and makes it current
 * pushContext(width, height) - creates and pushes a new context with the specified width and height
 * pushContext() - creates a new context for unbreakable blocks (with current availableWidth and full-page-height)
 */ ElementWriter.prototype.pushContext = function(contextOrWidth, height) {
                    if (contextOrWidth === undefined) {
                        height = this.context.getCurrentPage().height - this.context.pageMargins.top - this.context.pageMargins.bottom;
                        contextOrWidth = this.context.availableWidth;
                    }
                    if (isNumber(contextOrWidth)) contextOrWidth = new DocumentContext({
                        width: contextOrWidth,
                        height: height
                    }, {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    });
                    this.contextStack.push(this.context);
                    this.context = contextOrWidth;
                };
                ElementWriter.prototype.popContext = function() {
                    this.context = this.contextStack.pop();
                };
                ElementWriter.prototype.getCurrentPositionOnPage = function() {
                    return (this.contextStack[0] || this.context).getCurrentPosition();
                };
                module1.exports = ElementWriter;
            /***/ },
            /***/ 55215: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var call = Function.prototype.call;
                var $hasOwn = Object.prototype.hasOwnProperty;
                var bind = __webpack_require__(5049);
                /** @type {import('.')} */ module1.exports = bind.call(call, $hasOwn);
            /***/ },
            /***/ 55480: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var setGlobal = __webpack_require__(7421);
                var SHARED = '__core-js_shared__';
                var store = global[SHARED] || setGlobal(SHARED, {});
                module1.exports = store;
            /***/ },
            /***/ 55481: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(47044);
                module1.exports = !fails(function() {
                    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
                    return Object.isExtensible(Object.preventExtensions({}));
                });
            /***/ },
            /***/ 55574: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var $propertyIsEnumerable = {}.propertyIsEnumerable;
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                // Nashorn ~ JDK8 bug
                var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
                    1: 2
                }, 1);
                // `Object.prototype.propertyIsEnumerable` method implementation
                // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
                exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
                    var descriptor = getOwnPropertyDescriptor(this, V);
                    return !!descriptor && descriptor.enumerable;
                } : $propertyIsEnumerable;
            /***/ },
            /***/ 55914: /***/ function(module1) {
                "use strict";
                module1.exports = /*#__PURE__*/ JSON.parse('[["a140","\uE4C6",62],["a180","\uE505",32],["a240","\uE526",62],["a280","\uE565",32],["a2ab","\uE766",5],["a2e3","\u20AC\uE76D"],["a2ef","\uE76E\uE76F"],["a2fd","\uE770\uE771"],["a340","\uE586",62],["a380","\uE5C5",31,"\u3000"],["a440","\uE5E6",62],["a480","\uE625",32],["a4f4","\uE772",10],["a540","\uE646",62],["a580","\uE685",32],["a5f7","\uE77D",7],["a640","\uE6A6",62],["a680","\uE6E5",32],["a6b9","\uE785",7],["a6d9","\uE78D",6],["a6ec","\uE794\uE795"],["a6f3","\uE796"],["a6f6","\uE797",8],["a740","\uE706",62],["a780","\uE745",32],["a7c2","\uE7A0",14],["a7f2","\uE7AF",12],["a896","\uE7BC",10],["a8bc","\u1E3F"],["a8bf","\u01F9"],["a8c1","\uE7C9\uE7CA\uE7CB\uE7CC"],["a8ea","\uE7CD",20],["a958","\uE7E2"],["a95b","\uE7E3"],["a95d","\uE7E4\uE7E5\uE7E6"],["a989","\u303E\u2FF0",11],["a997","\uE7F4",12],["a9f0","\uE801",14],["aaa1","\uE000",93],["aba1","\uE05E",93],["aca1","\uE0BC",93],["ada1","\uE11A",93],["aea1","\uE178",93],["afa1","\uE1D6",93],["d7fa","\uE810",4],["f8a1","\uE234",93],["f9a1","\uE292",93],["faa1","\uE2F0",93],["fba1","\uE34E",93],["fca1","\uE3AC",93],["fda1","\uE40A",93],["fe50","\u2E81\uE816\uE817\uE818\u2E84\u3473\u3447\u2E88\u2E8B\uE81E\u359E\u361A\u360E\u2E8C\u2E97\u396E\u3918\uE826\u39CF\u39DF\u3A73\u39D0\uE82B\uE82C\u3B4E\u3C6E\u3CE0\u2EA7\uE831\uE832\u2EAA\u4056\u415F\u2EAE\u4337\u2EB3\u2EB6\u2EB7\uE83B\u43B1\u43AC\u2EBB\u43DD\u44D6\u4661\u464C\uE843"],["fe80","\u4723\u4729\u477C\u478D\u2ECA\u4947\u497A\u497D\u4982\u4983\u4985\u4986\u499F\u499B\u49B7\u49B6\uE854\uE855\u4CA3\u4C9F\u4CA0\u4CA1\u4C77\u4CA2\u4D13",6,"\u4DAE\uE864\uE468",93],["8135f437","\uE7C7"]]');
            /***/ },
            /***/ 56128: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                function _inheritsLoose(t, o) {
                    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
                }
                function _setPrototypeOf(t, e) {
                    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                        return t.__proto__ = e, t;
                    }, _setPrototypeOf(t, e);
                }
                var DecodeStream = __webpack_require__(69591);
                var NumberT = /*#__PURE__*/ function() {
                    function NumberT(type, endian) {
                        if (endian === void 0) endian = 'BE';
                        this.type = type;
                        this.endian = endian;
                        this.fn = this.type;
                        if (this.type[this.type.length - 1] !== '8') this.fn += this.endian;
                    }
                    var _proto = NumberT.prototype;
                    _proto.size = function size() {
                        return DecodeStream.TYPES[this.type];
                    };
                    _proto.decode = function decode(stream) {
                        return stream["read" + this.fn]();
                    };
                    _proto.encode = function encode(stream, val) {
                        return stream["write" + this.fn](val);
                    };
                    return NumberT;
                }();
                exports.Number = NumberT;
                exports.uint8 = new NumberT('UInt8');
                exports.uint16be = exports.uint16 = new NumberT('UInt16', 'BE');
                exports.uint16le = new NumberT('UInt16', 'LE');
                exports.uint24be = exports.uint24 = new NumberT('UInt24', 'BE');
                exports.uint24le = new NumberT('UInt24', 'LE');
                exports.uint32be = exports.uint32 = new NumberT('UInt32', 'BE');
                exports.uint32le = new NumberT('UInt32', 'LE');
                exports.int8 = new NumberT('Int8');
                exports.int16be = exports.int16 = new NumberT('Int16', 'BE');
                exports.int16le = new NumberT('Int16', 'LE');
                exports.int24be = exports.int24 = new NumberT('Int24', 'BE');
                exports.int24le = new NumberT('Int24', 'LE');
                exports.int32be = exports.int32 = new NumberT('Int32', 'BE');
                exports.int32le = new NumberT('Int32', 'LE');
                exports.floatbe = exports.float = new NumberT('Float', 'BE');
                exports.floatle = new NumberT('Float', 'LE');
                exports.doublebe = exports.double = new NumberT('Double', 'BE');
                exports.doublele = new NumberT('Double', 'LE');
                var Fixed = /*#__PURE__*/ function(_NumberT) {
                    function Fixed(size, endian, fracBits) {
                        var _this;
                        if (fracBits === void 0) fracBits = size >> 1;
                        _this = _NumberT.call(this, "Int" + size, endian) || this;
                        _this._point = 1 << fracBits;
                        return _this;
                    }
                    _inheritsLoose(Fixed, _NumberT);
                    var _proto2 = Fixed.prototype;
                    _proto2.decode = function decode(stream) {
                        return _NumberT.prototype.decode.call(this, stream) / this._point;
                    };
                    _proto2.encode = function encode(stream, val) {
                        return _NumberT.prototype.encode.call(this, stream, val * this._point | 0);
                    };
                    return Fixed;
                }(NumberT);
                exports.Fixed = Fixed;
                exports.fixed16be = exports.fixed16 = new Fixed(16, 'BE');
                exports.fixed16le = new Fixed(16, 'LE');
                exports.fixed32be = exports.fixed32 = new Fixed(32, 'BE');
                exports.fixed32le = new Fixed(32, 'LE');
            /***/ },
            /***/ 56228: /***/ function(module1) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                module1.exports = {
                    2: 'need dictionary',
                    /* Z_NEED_DICT       2  */ 1: 'stream end',
                    /* Z_STREAM_END      1  */ 0: '',
                    /* Z_OK              0  */ '-1': 'file error',
                    /* Z_ERRNO         (-1) */ '-2': 'stream error',
                    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
                    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
                    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
                    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
                };
            /***/ },
            /***/ 56280: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(47044);
                var wellKnownSymbol = __webpack_require__(38688);
                var V8_VERSION = __webpack_require__(70091);
                var SPECIES = wellKnownSymbol('species');
                module1.exports = function(METHOD_NAME) {
                    // We can't use this feature detection in V8 since it causes
                    // deoptimization and serious performance degradation
                    // https://github.com/zloirock/core-js/issues/677
                    return V8_VERSION >= 51 || !fails(function() {
                        var array = [];
                        var constructor = array.constructor = {};
                        constructor[SPECIES] = function() {
                            return {
                                foo: 1
                            };
                        };
                        return array[METHOD_NAME](Boolean).foo !== 1;
                    });
                };
            /***/ },
            /***/ 56406: /***/ function(module1) {
                "use strict";
                module1.exports = /*#__PURE__*/ JSON.parse('[["0","\\u0000",127],["8ea1","\uFF61",62],["a1a1","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7"],["a2a1","\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["a2ba","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["a2ca","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["a2dc","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["a2f2","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["a2fe","\u25EF"],["a3b0","\uFF10",9],["a3c1","\uFF21",25],["a3e1","\uFF41",25],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a8a1","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["ada1","\u2460",19,"\u2160",9],["adc0","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["addf","\u337B\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["b0a1","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["b1a1","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC"],["b2a1","\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["b3a1","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431"],["b4a1","\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["b5a1","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC"],["b6a1","\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["b7a1","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372"],["b8a1","\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["b9a1","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC"],["baa1","\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["bba1","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642"],["bca1","\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["bda1","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F"],["bea1","\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["bfa1","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE"],["c0a1","\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["c1a1","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E"],["c2a1","\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["c3a1","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5"],["c4a1","\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["c5a1","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230"],["c6a1","\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["c7a1","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6"],["c8a1","\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["c9a1","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D"],["caa1","\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["cba1","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80"],["cca1","\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["cda1","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483"],["cea1","\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["cfa1","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["d0a1","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["d1a1","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8"],["d2a1","\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["d3a1","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709"],["d4a1","\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["d5a1","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53"],["d6a1","\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["d7a1","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A"],["d8a1","\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["d9a1","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC"],["daa1","\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["dba1","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD"],["dca1","\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["dda1","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE"],["dea1","\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["dfa1","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC"],["e0a1","\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e1a1","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670"],["e2a1","\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e3a1","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50"],["e4a1","\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e5a1","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A"],["e6a1","\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e7a1","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9"],["e8a1","\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e9a1","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759"],["eaa1","\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["eba1","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B"],["eca1","\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["eda1","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8"],["eea1","\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["efa1","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E"],["f0a1","\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["f1a1","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7"],["f2a1","\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["f3a1","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0"],["f4a1","\u582F\u69C7\u9059\u7464\u51DC\u7199"],["f9a1","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7"],["faa1","\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["fba1","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA"],["fca1","\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["fcf1","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["8fa2af","\u02D8\u02C7\xb8\u02D9\u02DD\xaf\u02DB\u02DA\uFF5E\u0384\u0385"],["8fa2c2","\xa1\xa6\xbf"],["8fa2eb","\xba\xaa\xa9\xae\u2122\xa4\u2116"],["8fa6e1","\u0386\u0388\u0389\u038A\u03AA"],["8fa6e7","\u038C"],["8fa6e9","\u038E\u03AB"],["8fa6ec","\u038F"],["8fa6f1","\u03AC\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03C2\u03CD\u03CB\u03B0\u03CE"],["8fa7c2","\u0402",10,"\u040E\u040F"],["8fa7f2","\u0452",10,"\u045E\u045F"],["8fa9a1","\xc6\u0110"],["8fa9a4","\u0126"],["8fa9a6","\u0132"],["8fa9a8","\u0141\u013F"],["8fa9ab","\u014A\xd8\u0152"],["8fa9af","\u0166\xde"],["8fa9c1","\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0142\u0140\u0149\u014B\xf8\u0153\xdf\u0167\xfe"],["8faaa1","\xc1\xc0\xc4\xc2\u0102\u01CD\u0100\u0104\xc5\xc3\u0106\u0108\u010C\xc7\u010A\u010E\xc9\xc8\xcb\xca\u011A\u0116\u0112\u0118"],["8faaba","\u011C\u011E\u0122\u0120\u0124\xcd\xcc\xcf\xce\u01CF\u0130\u012A\u012E\u0128\u0134\u0136\u0139\u013D\u013B\u0143\u0147\u0145\xd1\xd3\xd2\xd6\xd4\u01D1\u0150\u014C\xd5\u0154\u0158\u0156\u015A\u015C\u0160\u015E\u0164\u0162\xda\xd9\xdc\xdb\u016C\u01D3\u0170\u016A\u0172\u016E\u0168\u01D7\u01DB\u01D9\u01D5\u0174\xdd\u0178\u0176\u0179\u017D\u017B"],["8faba1","\xe1\xe0\xe4\xe2\u0103\u01CE\u0101\u0105\xe5\xe3\u0107\u0109\u010D\xe7\u010B\u010F\xe9\xe8\xeb\xea\u011B\u0117\u0113\u0119\u01F5\u011D\u011F"],["8fabbd","\u0121\u0125\xed\xec\xef\xee\u01D0"],["8fabc5","\u012B\u012F\u0129\u0135\u0137\u013A\u013E\u013C\u0144\u0148\u0146\xf1\xf3\xf2\xf6\xf4\u01D2\u0151\u014D\xf5\u0155\u0159\u0157\u015B\u015D\u0161\u015F\u0165\u0163\xfa\xf9\xfc\xfb\u016D\u01D4\u0171\u016B\u0173\u016F\u0169\u01D8\u01DC\u01DA\u01D6\u0175\xfd\xff\u0177\u017A\u017E\u017C"],["8fb0a1","\u4E02\u4E04\u4E05\u4E0C\u4E12\u4E1F\u4E23\u4E24\u4E28\u4E2B\u4E2E\u4E2F\u4E30\u4E35\u4E40\u4E41\u4E44\u4E47\u4E51\u4E5A\u4E5C\u4E63\u4E68\u4E69\u4E74\u4E75\u4E79\u4E7F\u4E8D\u4E96\u4E97\u4E9D\u4EAF\u4EB9\u4EC3\u4ED0\u4EDA\u4EDB\u4EE0\u4EE1\u4EE2\u4EE8\u4EEF\u4EF1\u4EF3\u4EF5\u4EFD\u4EFE\u4EFF\u4F00\u4F02\u4F03\u4F08\u4F0B\u4F0C\u4F12\u4F15\u4F16\u4F17\u4F19\u4F2E\u4F31\u4F60\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F40\u4F42\u4F48\u4F49\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F58\u4F5F\u4F63\u4F6A\u4F6C\u4F6E\u4F71\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F7E\u4F81\u4F82\u4F84"],["8fb1a1","\u4F85\u4F89\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F94\u4F97\u4F99\u4F9A\u4F9E\u4F9F\u4FB2\u4FB7\u4FB9\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC5\u4FC6\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FCF\u4FD2\u4FDC\u4FE0\u4FE2\u4FF0\u4FF2\u4FFC\u4FFD\u4FFF\u5000\u5001\u5004\u5007\u500A\u500C\u500E\u5010\u5013\u5017\u5018\u501B\u501C\u501D\u501E\u5022\u5027\u502E\u5030\u5032\u5033\u5035\u5040\u5041\u5042\u5045\u5046\u504A\u504C\u504E\u5051\u5052\u5053\u5057\u5059\u505F\u5060\u5062\u5063\u5066\u5067\u506A\u506D\u5070\u5071\u503B\u5081\u5083\u5084\u5086\u508A\u508E\u508F\u5090"],["8fb2a1","\u5092\u5093\u5094\u5096\u509B\u509C\u509E",4,"\u50AA\u50AF\u50B0\u50B9\u50BA\u50BD\u50C0\u50C3\u50C4\u50C7\u50CC\u50CE\u50D0\u50D3\u50D4\u50D8\u50DC\u50DD\u50DF\u50E2\u50E4\u50E6\u50E8\u50E9\u50EF\u50F1\u50F6\u50FA\u50FE\u5103\u5106\u5107\u5108\u510B\u510C\u510D\u510E\u50F2\u5110\u5117\u5119\u511B\u511C\u511D\u511E\u5123\u5127\u5128\u512C\u512D\u512F\u5131\u5133\u5134\u5135\u5138\u5139\u5142\u514A\u514F\u5153\u5155\u5157\u5158\u515F\u5164\u5166\u517E\u5183\u5184\u518B\u518E\u5198\u519D\u51A1\u51A3\u51AD\u51B8\u51BA\u51BC\u51BE\u51BF\u51C2"],["8fb3a1","\u51C8\u51CF\u51D1\u51D2\u51D3\u51D5\u51D8\u51DE\u51E2\u51E5\u51EE\u51F2\u51F3\u51F4\u51F7\u5201\u5202\u5205\u5212\u5213\u5215\u5216\u5218\u5222\u5228\u5231\u5232\u5235\u523C\u5245\u5249\u5255\u5257\u5258\u525A\u525C\u525F\u5260\u5261\u5266\u526E\u5277\u5278\u5279\u5280\u5282\u5285\u528A\u528C\u5293\u5295\u5296\u5297\u5298\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AF\u52B0\u52B6\u52B7\u52B8\u52BA\u52BB\u52BD\u52C0\u52C4\u52C6\u52C8\u52CC\u52CF\u52D1\u52D4\u52D6\u52DB\u52DC\u52E1\u52E5\u52E8\u52E9\u52EA\u52EC\u52F0\u52F1\u52F4\u52F6\u52F7\u5300\u5303\u530A\u530B"],["8fb4a1","\u530C\u5311\u5313\u5318\u531B\u531C\u531E\u531F\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u5330\u5332\u5335\u533C\u533D\u533E\u5342\u534C\u534B\u5359\u535B\u5361\u5363\u5365\u536C\u536D\u5372\u5379\u537E\u5383\u5387\u5388\u538E\u5393\u5394\u5399\u539D\u53A1\u53A4\u53AA\u53AB\u53AF\u53B2\u53B4\u53B5\u53B7\u53B8\u53BA\u53BD\u53C0\u53C5\u53CF\u53D2\u53D3\u53D5\u53DA\u53DD\u53DE\u53E0\u53E6\u53E7\u53F5\u5402\u5413\u541A\u5421\u5427\u5428\u542A\u542F\u5431\u5434\u5435\u5443\u5444\u5447\u544D\u544F\u545E\u5462\u5464\u5466\u5467\u5469\u546B\u546D\u546E\u5474\u547F"],["8fb5a1","\u5481\u5483\u5485\u5488\u5489\u548D\u5491\u5495\u5496\u549C\u549F\u54A1\u54A6\u54A7\u54A9\u54AA\u54AD\u54AE\u54B1\u54B7\u54B9\u54BA\u54BB\u54BF\u54C6\u54CA\u54CD\u54CE\u54E0\u54EA\u54EC\u54EF\u54F6\u54FC\u54FE\u54FF\u5500\u5501\u5505\u5508\u5509\u550C\u550D\u550E\u5515\u552A\u552B\u5532\u5535\u5536\u553B\u553C\u553D\u5541\u5547\u5549\u554A\u554D\u5550\u5551\u5558\u555A\u555B\u555E\u5560\u5561\u5564\u5566\u557F\u5581\u5582\u5586\u5588\u558E\u558F\u5591\u5592\u5593\u5594\u5597\u55A3\u55A4\u55AD\u55B2\u55BF\u55C1\u55C3\u55C6\u55C9\u55CB\u55CC\u55CE\u55D1\u55D2"],["8fb6a1","\u55D3\u55D7\u55D8\u55DB\u55DE\u55E2\u55E9\u55F6\u55FF\u5605\u5608\u560A\u560D",5,"\u5619\u562C\u5630\u5633\u5635\u5637\u5639\u563B\u563C\u563D\u563F\u5640\u5641\u5643\u5644\u5646\u5649\u564B\u564D\u564F\u5654\u565E\u5660\u5661\u5662\u5663\u5666\u5669\u566D\u566F\u5671\u5672\u5675\u5684\u5685\u5688\u568B\u568C\u5695\u5699\u569A\u569D\u569E\u569F\u56A6\u56A7\u56A8\u56A9\u56AB\u56AC\u56AD\u56B1\u56B3\u56B7\u56BE\u56C5\u56C9\u56CA\u56CB\u56CF\u56D0\u56CC\u56CD\u56D9\u56DC\u56DD\u56DF\u56E1\u56E4",4,"\u56F1\u56EB\u56ED"],["8fb7a1","\u56F6\u56F7\u5701\u5702\u5707\u570A\u570C\u5711\u5715\u571A\u571B\u571D\u5720\u5722\u5723\u5724\u5725\u5729\u572A\u572C\u572E\u572F\u5733\u5734\u573D\u573E\u573F\u5745\u5746\u574C\u574D\u5752\u5762\u5765\u5767\u5768\u576B\u576D",4,"\u5773\u5774\u5775\u5777\u5779\u577A\u577B\u577C\u577E\u5781\u5783\u578C\u5794\u5797\u5799\u579A\u579C\u579D\u579E\u579F\u57A1\u5795\u57A7\u57A8\u57A9\u57AC\u57B8\u57BD\u57C7\u57C8\u57CC\u57CF\u57D5\u57DD\u57DE\u57E4\u57E6\u57E7\u57E9\u57ED\u57F0\u57F5\u57F6\u57F8\u57FD\u57FE\u57FF\u5803\u5804\u5808\u5809\u57E1"],["8fb8a1","\u580C\u580D\u581B\u581E\u581F\u5820\u5826\u5827\u582D\u5832\u5839\u583F\u5849\u584C\u584D\u584F\u5850\u5855\u585F\u5861\u5864\u5867\u5868\u5878\u587C\u587F\u5880\u5881\u5887\u5888\u5889\u588A\u588C\u588D\u588F\u5890\u5894\u5896\u589D\u58A0\u58A1\u58A2\u58A6\u58A9\u58B1\u58B2\u58C4\u58BC\u58C2\u58C8\u58CD\u58CE\u58D0\u58D2\u58D4\u58D6\u58DA\u58DD\u58E1\u58E2\u58E9\u58F3\u5905\u5906\u590B\u590C\u5912\u5913\u5914\u8641\u591D\u5921\u5923\u5924\u5928\u592F\u5930\u5933\u5935\u5936\u593F\u5943\u5946\u5952\u5953\u5959\u595B\u595D\u595E\u595F\u5961\u5963\u596B\u596D"],["8fb9a1","\u596F\u5972\u5975\u5976\u5979\u597B\u597C\u598B\u598C\u598E\u5992\u5995\u5997\u599F\u59A4\u59A7\u59AD\u59AE\u59AF\u59B0\u59B3\u59B7\u59BA\u59BC\u59C1\u59C3\u59C4\u59C8\u59CA\u59CD\u59D2\u59DD\u59DE\u59DF\u59E3\u59E4\u59E7\u59EE\u59EF\u59F1\u59F2\u59F4\u59F7\u5A00\u5A04\u5A0C\u5A0D\u5A0E\u5A12\u5A13\u5A1E\u5A23\u5A24\u5A27\u5A28\u5A2A\u5A2D\u5A30\u5A44\u5A45\u5A47\u5A48\u5A4C\u5A50\u5A55\u5A5E\u5A63\u5A65\u5A67\u5A6D\u5A77\u5A7A\u5A7B\u5A7E\u5A8B\u5A90\u5A93\u5A96\u5A99\u5A9C\u5A9E\u5A9F\u5AA0\u5AA2\u5AA7\u5AAC\u5AB1\u5AB2\u5AB3\u5AB5\u5AB8\u5ABA\u5ABB\u5ABF"],["8fbaa1","\u5AC4\u5AC6\u5AC8\u5ACF\u5ADA\u5ADC\u5AE0\u5AE5\u5AEA\u5AEE\u5AF5\u5AF6\u5AFD\u5B00\u5B01\u5B08\u5B17\u5B34\u5B19\u5B1B\u5B1D\u5B21\u5B25\u5B2D\u5B38\u5B41\u5B4B\u5B4C\u5B52\u5B56\u5B5E\u5B68\u5B6E\u5B6F\u5B7C\u5B7D\u5B7E\u5B7F\u5B81\u5B84\u5B86\u5B8A\u5B8E\u5B90\u5B91\u5B93\u5B94\u5B96\u5BA8\u5BA9\u5BAC\u5BAD\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBC\u5BC0\u5BC1\u5BCD\u5BCF\u5BD6",4,"\u5BE0\u5BEF\u5BF1\u5BF4\u5BFD\u5C0C\u5C17\u5C1E\u5C1F\u5C23\u5C26\u5C29\u5C2B\u5C2C\u5C2E\u5C30\u5C32\u5C35\u5C36\u5C59\u5C5A\u5C5C\u5C62\u5C63\u5C67\u5C68\u5C69"],["8fbba1","\u5C6D\u5C70\u5C74\u5C75\u5C7A\u5C7B\u5C7C\u5C7D\u5C87\u5C88\u5C8A\u5C8F\u5C92\u5C9D\u5C9F\u5CA0\u5CA2\u5CA3\u5CA6\u5CAA\u5CB2\u5CB4\u5CB5\u5CBA\u5CC9\u5CCB\u5CD2\u5CDD\u5CD7\u5CEE\u5CF1\u5CF2\u5CF4\u5D01\u5D06\u5D0D\u5D12\u5D2B\u5D23\u5D24\u5D26\u5D27\u5D31\u5D34\u5D39\u5D3D\u5D3F\u5D42\u5D43\u5D46\u5D48\u5D55\u5D51\u5D59\u5D4A\u5D5F\u5D60\u5D61\u5D62\u5D64\u5D6A\u5D6D\u5D70\u5D79\u5D7A\u5D7E\u5D7F\u5D81\u5D83\u5D88\u5D8A\u5D92\u5D93\u5D94\u5D95\u5D99\u5D9B\u5D9F\u5DA0\u5DA7\u5DAB\u5DB0\u5DB4\u5DB8\u5DB9\u5DC3\u5DC7\u5DCB\u5DD0\u5DCE\u5DD8\u5DD9\u5DE0\u5DE4"],["8fbca1","\u5DE9\u5DF8\u5DF9\u5E00\u5E07\u5E0D\u5E12\u5E14\u5E15\u5E18\u5E1F\u5E20\u5E2E\u5E28\u5E32\u5E35\u5E3E\u5E4B\u5E50\u5E49\u5E51\u5E56\u5E58\u5E5B\u5E5C\u5E5E\u5E68\u5E6A",4,"\u5E70\u5E80\u5E8B\u5E8E\u5EA2\u5EA4\u5EA5\u5EA8\u5EAA\u5EAC\u5EB1\u5EB3\u5EBD\u5EBE\u5EBF\u5EC6\u5ECC\u5ECB\u5ECE\u5ED1\u5ED2\u5ED4\u5ED5\u5EDC\u5EDE\u5EE5\u5EEB\u5F02\u5F06\u5F07\u5F08\u5F0E\u5F19\u5F1C\u5F1D\u5F21\u5F22\u5F23\u5F24\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F34\u5F36\u5F3B\u5F3D\u5F3F\u5F40\u5F44\u5F45\u5F47\u5F4D\u5F50\u5F54\u5F58\u5F5B\u5F60\u5F63\u5F64\u5F67"],["8fbda1","\u5F6F\u5F72\u5F74\u5F75\u5F78\u5F7A\u5F7D\u5F7E\u5F89\u5F8D\u5F8F\u5F96\u5F9C\u5F9D\u5FA2\u5FA7\u5FAB\u5FA4\u5FAC\u5FAF\u5FB0\u5FB1\u5FB8\u5FC4\u5FC7\u5FC8\u5FC9\u5FCB\u5FD0",4,"\u5FDE\u5FE1\u5FE2\u5FE8\u5FE9\u5FEA\u5FEC\u5FED\u5FEE\u5FEF\u5FF2\u5FF3\u5FF6\u5FFA\u5FFC\u6007\u600A\u600D\u6013\u6014\u6017\u6018\u601A\u601F\u6024\u602D\u6033\u6035\u6040\u6047\u6048\u6049\u604C\u6051\u6054\u6056\u6057\u605D\u6061\u6067\u6071\u607E\u607F\u6082\u6086\u6088\u608A\u608E\u6091\u6093\u6095\u6098\u609D\u609E\u60A2\u60A4\u60A5\u60A8\u60B0\u60B1\u60B7"],["8fbea1","\u60BB\u60BE\u60C2\u60C4\u60C8\u60C9\u60CA\u60CB\u60CE\u60CF\u60D4\u60D5\u60D9\u60DB\u60DD\u60DE\u60E2\u60E5\u60F2\u60F5\u60F8\u60FC\u60FD\u6102\u6107\u610A\u610C\u6110",4,"\u6116\u6117\u6119\u611C\u611E\u6122\u612A\u612B\u6130\u6131\u6135\u6136\u6137\u6139\u6141\u6145\u6146\u6149\u615E\u6160\u616C\u6172\u6178\u617B\u617C\u617F\u6180\u6181\u6183\u6184\u618B\u618D\u6192\u6193\u6197\u6198\u619C\u619D\u619F\u61A0\u61A5\u61A8\u61AA\u61AD\u61B8\u61B9\u61BC\u61C0\u61C1\u61C2\u61CE\u61CF\u61D5\u61DC\u61DD\u61DE\u61DF\u61E1\u61E2\u61E7\u61E9\u61E5"],["8fbfa1","\u61EC\u61ED\u61EF\u6201\u6203\u6204\u6207\u6213\u6215\u621C\u6220\u6222\u6223\u6227\u6229\u622B\u6239\u623D\u6242\u6243\u6244\u6246\u624C\u6250\u6251\u6252\u6254\u6256\u625A\u625C\u6264\u626D\u626F\u6273\u627A\u627D\u628D\u628E\u628F\u6290\u62A6\u62A8\u62B3\u62B6\u62B7\u62BA\u62BE\u62BF\u62C4\u62CE\u62D5\u62D6\u62DA\u62EA\u62F2\u62F4\u62FC\u62FD\u6303\u6304\u630A\u630B\u630D\u6310\u6313\u6316\u6318\u6329\u632A\u632D\u6335\u6336\u6339\u633C\u6341\u6342\u6343\u6344\u6346\u634A\u634B\u634E\u6352\u6353\u6354\u6358\u635B\u6365\u6366\u636C\u636D\u6371\u6374\u6375"],["8fc0a1","\u6378\u637C\u637D\u637F\u6382\u6384\u6387\u638A\u6390\u6394\u6395\u6399\u639A\u639E\u63A4\u63A6\u63AD\u63AE\u63AF\u63BD\u63C1\u63C5\u63C8\u63CE\u63D1\u63D3\u63D4\u63D5\u63DC\u63E0\u63E5\u63EA\u63EC\u63F2\u63F3\u63F5\u63F8\u63F9\u6409\u640A\u6410\u6412\u6414\u6418\u641E\u6420\u6422\u6424\u6425\u6429\u642A\u642F\u6430\u6435\u643D\u643F\u644B\u644F\u6451\u6452\u6453\u6454\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6463\u646D\u6473\u6474\u647B\u647D\u6485\u6487\u648F\u6490\u6491\u6498\u6499\u649B\u649D\u649F\u64A1\u64A3\u64A6\u64A8\u64AC\u64B3\u64BD\u64BE\u64BF"],["8fc1a1","\u64C4\u64C9\u64CA\u64CB\u64CC\u64CE\u64D0\u64D1\u64D5\u64D7\u64E4\u64E5\u64E9\u64EA\u64ED\u64F0\u64F5\u64F7\u64FB\u64FF\u6501\u6504\u6508\u6509\u650A\u650F\u6513\u6514\u6516\u6519\u651B\u651E\u651F\u6522\u6526\u6529\u652E\u6531\u653A\u653C\u653D\u6543\u6547\u6549\u6550\u6552\u6554\u655F\u6560\u6567\u656B\u657A\u657D\u6581\u6585\u658A\u6592\u6595\u6598\u659D\u65A0\u65A3\u65A6\u65AE\u65B2\u65B3\u65B4\u65BF\u65C2\u65C8\u65C9\u65CE\u65D0\u65D4\u65D6\u65D8\u65DF\u65F0\u65F2\u65F4\u65F5\u65F9\u65FE\u65FF\u6600\u6604\u6608\u6609\u660D\u6611\u6612\u6615\u6616\u661D"],["8fc2a1","\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6631\u6633\u6639\u6637\u6640\u6645\u6646\u664A\u664C\u6651\u664E\u6657\u6658\u6659\u665B\u665C\u6660\u6661\u66FB\u666A\u666B\u666C\u667E\u6673\u6675\u667F\u6677\u6678\u6679\u667B\u6680\u667C\u668B\u668C\u668D\u6690\u6692\u6699\u669A\u669B\u669C\u669F\u66A0\u66A4\u66AD\u66B1\u66B2\u66B5\u66BB\u66BF\u66C0\u66C2\u66C3\u66C8\u66CC\u66CE\u66CF\u66D4\u66DB\u66DF\u66E8\u66EB\u66EC\u66EE\u66FA\u6705\u6707\u670E\u6713\u6719\u671C\u6720\u6722\u6733\u673E\u6745\u6747\u6748\u674C\u6754\u6755\u675D"],["8fc3a1","\u6766\u676C\u676E\u6774\u6776\u677B\u6781\u6784\u678E\u678F\u6791\u6793\u6796\u6798\u6799\u679B\u67B0\u67B1\u67B2\u67B5\u67BB\u67BC\u67BD\u67F9\u67C0\u67C2\u67C3\u67C5\u67C8\u67C9\u67D2\u67D7\u67D9\u67DC\u67E1\u67E6\u67F0\u67F2\u67F6\u67F7\u6852\u6814\u6819\u681D\u681F\u6828\u6827\u682C\u682D\u682F\u6830\u6831\u6833\u683B\u683F\u6844\u6845\u684A\u684C\u6855\u6857\u6858\u685B\u686B\u686E",4,"\u6875\u6879\u687A\u687B\u687C\u6882\u6884\u6886\u6888\u6896\u6898\u689A\u689C\u68A1\u68A3\u68A5\u68A9\u68AA\u68AE\u68B2\u68BB\u68C5\u68C8\u68CC\u68CF"],["8fc4a1","\u68D0\u68D1\u68D3\u68D6\u68D9\u68DC\u68DD\u68E5\u68E8\u68EA\u68EB\u68EC\u68ED\u68F0\u68F1\u68F5\u68F6\u68FB\u68FC\u68FD\u6906\u6909\u690A\u6910\u6911\u6913\u6916\u6917\u6931\u6933\u6935\u6938\u693B\u6942\u6945\u6949\u694E\u6957\u695B\u6963\u6964\u6965\u6966\u6968\u6969\u696C\u6970\u6971\u6972\u697A\u697B\u697F\u6980\u698D\u6992\u6996\u6998\u69A1\u69A5\u69A6\u69A8\u69AB\u69AD\u69AF\u69B7\u69B8\u69BA\u69BC\u69C5\u69C8\u69D1\u69D6\u69D7\u69E2\u69E5\u69EE\u69EF\u69F1\u69F3\u69F5\u69FE\u6A00\u6A01\u6A03\u6A0F\u6A11\u6A15\u6A1A\u6A1D\u6A20\u6A24\u6A28\u6A30\u6A32"],["8fc5a1","\u6A34\u6A37\u6A3B\u6A3E\u6A3F\u6A45\u6A46\u6A49\u6A4A\u6A4E\u6A50\u6A51\u6A52\u6A55\u6A56\u6A5B\u6A64\u6A67\u6A6A\u6A71\u6A73\u6A7E\u6A81\u6A83\u6A86\u6A87\u6A89\u6A8B\u6A91\u6A9B\u6A9D\u6A9E\u6A9F\u6AA5\u6AAB\u6AAF\u6AB0\u6AB1\u6AB4\u6ABD\u6ABE\u6ABF\u6AC6\u6AC9\u6AC8\u6ACC\u6AD0\u6AD4\u6AD5\u6AD6\u6ADC\u6ADD\u6AE4\u6AE7\u6AEC\u6AF0\u6AF1\u6AF2\u6AFC\u6AFD\u6B02\u6B03\u6B06\u6B07\u6B09\u6B0F\u6B10\u6B11\u6B17\u6B1B\u6B1E\u6B24\u6B28\u6B2B\u6B2C\u6B2F\u6B35\u6B36\u6B3B\u6B3F\u6B46\u6B4A\u6B4D\u6B52\u6B56\u6B58\u6B5D\u6B60\u6B67\u6B6B\u6B6E\u6B70\u6B75\u6B7D"],["8fc6a1","\u6B7E\u6B82\u6B85\u6B97\u6B9B\u6B9F\u6BA0\u6BA2\u6BA3\u6BA8\u6BA9\u6BAC\u6BAD\u6BAE\u6BB0\u6BB8\u6BB9\u6BBD\u6BBE\u6BC3\u6BC4\u6BC9\u6BCC\u6BD6\u6BDA\u6BE1\u6BE3\u6BE6\u6BE7\u6BEE\u6BF1\u6BF7\u6BF9\u6BFF\u6C02\u6C04\u6C05\u6C09\u6C0D\u6C0E\u6C10\u6C12\u6C19\u6C1F\u6C26\u6C27\u6C28\u6C2C\u6C2E\u6C33\u6C35\u6C36\u6C3A\u6C3B\u6C3F\u6C4A\u6C4B\u6C4D\u6C4F\u6C52\u6C54\u6C59\u6C5B\u6C5C\u6C6B\u6C6D\u6C6F\u6C74\u6C76\u6C78\u6C79\u6C7B\u6C85\u6C86\u6C87\u6C89\u6C94\u6C95\u6C97\u6C98\u6C9C\u6C9F\u6CB0\u6CB2\u6CB4\u6CC2\u6CC6\u6CCD\u6CCF\u6CD0\u6CD1\u6CD2\u6CD4\u6CD6"],["8fc7a1","\u6CDA\u6CDC\u6CE0\u6CE7\u6CE9\u6CEB\u6CEC\u6CEE\u6CF2\u6CF4\u6D04\u6D07\u6D0A\u6D0E\u6D0F\u6D11\u6D13\u6D1A\u6D26\u6D27\u6D28\u6C67\u6D2E\u6D2F\u6D31\u6D39\u6D3C\u6D3F\u6D57\u6D5E\u6D5F\u6D61\u6D65\u6D67\u6D6F\u6D70\u6D7C\u6D82\u6D87\u6D91\u6D92\u6D94\u6D96\u6D97\u6D98\u6DAA\u6DAC\u6DB4\u6DB7\u6DB9\u6DBD\u6DBF\u6DC4\u6DC8\u6DCA\u6DCE\u6DCF\u6DD6\u6DDB\u6DDD\u6DDF\u6DE0\u6DE2\u6DE5\u6DE9\u6DEF\u6DF0\u6DF4\u6DF6\u6DFC\u6E00\u6E04\u6E1E\u6E22\u6E27\u6E32\u6E36\u6E39\u6E3B\u6E3C\u6E44\u6E45\u6E48\u6E49\u6E4B\u6E4F\u6E51\u6E52\u6E53\u6E54\u6E57\u6E5C\u6E5D\u6E5E"],["8fc8a1","\u6E62\u6E63\u6E68\u6E73\u6E7B\u6E7D\u6E8D\u6E93\u6E99\u6EA0\u6EA7\u6EAD\u6EAE\u6EB1\u6EB3\u6EBB\u6EBF\u6EC0\u6EC1\u6EC3\u6EC7\u6EC8\u6ECA\u6ECD\u6ECE\u6ECF\u6EEB\u6EED\u6EEE\u6EF9\u6EFB\u6EFD\u6F04\u6F08\u6F0A\u6F0C\u6F0D\u6F16\u6F18\u6F1A\u6F1B\u6F26\u6F29\u6F2A\u6F2F\u6F30\u6F33\u6F36\u6F3B\u6F3C\u6F2D\u6F4F\u6F51\u6F52\u6F53\u6F57\u6F59\u6F5A\u6F5D\u6F5E\u6F61\u6F62\u6F68\u6F6C\u6F7D\u6F7E\u6F83\u6F87\u6F88\u6F8B\u6F8C\u6F8D\u6F90\u6F92\u6F93\u6F94\u6F96\u6F9A\u6F9F\u6FA0\u6FA5\u6FA6\u6FA7\u6FA8\u6FAE\u6FAF\u6FB0\u6FB5\u6FB6\u6FBC\u6FC5\u6FC7\u6FC8\u6FCA"],["8fc9a1","\u6FDA\u6FDE\u6FE8\u6FE9\u6FF0\u6FF5\u6FF9\u6FFC\u6FFD\u7000\u7005\u7006\u7007\u700D\u7017\u7020\u7023\u702F\u7034\u7037\u7039\u703C\u7043\u7044\u7048\u7049\u704A\u704B\u7054\u7055\u705D\u705E\u704E\u7064\u7065\u706C\u706E\u7075\u7076\u707E\u7081\u7085\u7086\u7094",4,"\u709B\u70A4\u70AB\u70B0\u70B1\u70B4\u70B7\u70CA\u70D1\u70D3\u70D4\u70D5\u70D6\u70D8\u70DC\u70E4\u70FA\u7103",4,"\u710B\u710C\u710F\u711E\u7120\u712B\u712D\u712F\u7130\u7131\u7138\u7141\u7145\u7146\u7147\u714A\u714B\u7150\u7152\u7157\u715A\u715C\u715E\u7160"],["8fcaa1","\u7168\u7179\u7180\u7185\u7187\u718C\u7192\u719A\u719B\u71A0\u71A2\u71AF\u71B0\u71B2\u71B3\u71BA\u71BF\u71C0\u71C1\u71C4\u71CB\u71CC\u71D3\u71D6\u71D9\u71DA\u71DC\u71F8\u71FE\u7200\u7207\u7208\u7209\u7213\u7217\u721A\u721D\u721F\u7224\u722B\u722F\u7234\u7238\u7239\u7241\u7242\u7243\u7245\u724E\u724F\u7250\u7253\u7255\u7256\u725A\u725C\u725E\u7260\u7263\u7268\u726B\u726E\u726F\u7271\u7277\u7278\u727B\u727C\u727F\u7284\u7289\u728D\u728E\u7293\u729B\u72A8\u72AD\u72AE\u72B1\u72B4\u72BE\u72C1\u72C7\u72C9\u72CC\u72D5\u72D6\u72D8\u72DF\u72E5\u72F3\u72F4\u72FA\u72FB"],["8fcba1","\u72FE\u7302\u7304\u7305\u7307\u730B\u730D\u7312\u7313\u7318\u7319\u731E\u7322\u7324\u7327\u7328\u732C\u7331\u7332\u7335\u733A\u733B\u733D\u7343\u734D\u7350\u7352\u7356\u7358\u735D\u735E\u735F\u7360\u7366\u7367\u7369\u736B\u736C\u736E\u736F\u7371\u7377\u7379\u737C\u7380\u7381\u7383\u7385\u7386\u738E\u7390\u7393\u7395\u7397\u7398\u739C\u739E\u739F\u73A0\u73A2\u73A5\u73A6\u73AA\u73AB\u73AD\u73B5\u73B7\u73B9\u73BC\u73BD\u73BF\u73C5\u73C6\u73C9\u73CB\u73CC\u73CF\u73D2\u73D3\u73D6\u73D9\u73DD\u73E1\u73E3\u73E6\u73E7\u73E9\u73F4\u73F5\u73F7\u73F9\u73FA\u73FB\u73FD"],["8fcca1","\u73FF\u7400\u7401\u7404\u7407\u740A\u7411\u741A\u741B\u7424\u7426\u7428",9,"\u7439\u7440\u7443\u7444\u7446\u7447\u744B\u744D\u7451\u7452\u7457\u745D\u7462\u7466\u7467\u7468\u746B\u746D\u746E\u7471\u7472\u7480\u7481\u7485\u7486\u7487\u7489\u748F\u7490\u7491\u7492\u7498\u7499\u749A\u749C\u749F\u74A0\u74A1\u74A3\u74A6\u74A8\u74A9\u74AA\u74AB\u74AE\u74AF\u74B1\u74B2\u74B5\u74B9\u74BB\u74BF\u74C8\u74C9\u74CC\u74D0\u74D3\u74D8\u74DA\u74DB\u74DE\u74DF\u74E4\u74E8\u74EA\u74EB\u74EF\u74F4\u74FA\u74FB\u74FC\u74FF\u7506"],["8fcda1","\u7512\u7516\u7517\u7520\u7521\u7524\u7527\u7529\u752A\u752F\u7536\u7539\u753D\u753E\u753F\u7540\u7543\u7547\u7548\u754E\u7550\u7552\u7557\u755E\u755F\u7561\u756F\u7571\u7579",5,"\u7581\u7585\u7590\u7592\u7593\u7595\u7599\u759C\u75A2\u75A4\u75B4\u75BA\u75BF\u75C0\u75C1\u75C4\u75C6\u75CC\u75CE\u75CF\u75D7\u75DC\u75DF\u75E0\u75E1\u75E4\u75E7\u75EC\u75EE\u75EF\u75F1\u75F9\u7600\u7602\u7603\u7604\u7607\u7608\u760A\u760C\u760F\u7612\u7613\u7615\u7616\u7619\u761B\u761C\u761D\u761E\u7623\u7625\u7626\u7629\u762D\u7632\u7633\u7635\u7638\u7639"],["8fcea1","\u763A\u763C\u764A\u7640\u7641\u7643\u7644\u7645\u7649\u764B\u7655\u7659\u765F\u7664\u7665\u766D\u766E\u766F\u7671\u7674\u7681\u7685\u768C\u768D\u7695\u769B\u769C\u769D\u769F\u76A0\u76A2",6,"\u76AA\u76AD\u76BD\u76C1\u76C5\u76C9\u76CB\u76CC\u76CE\u76D4\u76D9\u76E0\u76E6\u76E8\u76EC\u76F0\u76F1\u76F6\u76F9\u76FC\u7700\u7706\u770A\u770E\u7712\u7714\u7715\u7717\u7719\u771A\u771C\u7722\u7728\u772D\u772E\u772F\u7734\u7735\u7736\u7739\u773D\u773E\u7742\u7745\u7746\u774A\u774D\u774E\u774F\u7752\u7756\u7757\u775C\u775E\u775F\u7760\u7762"],["8fcfa1","\u7764\u7767\u776A\u776C\u7770\u7772\u7773\u7774\u777A\u777D\u7780\u7784\u778C\u778D\u7794\u7795\u7796\u779A\u779F\u77A2\u77A7\u77AA\u77AE\u77AF\u77B1\u77B5\u77BE\u77C3\u77C9\u77D1\u77D2\u77D5\u77D9\u77DE\u77DF\u77E0\u77E4\u77E6\u77EA\u77EC\u77F0\u77F1\u77F4\u77F8\u77FB\u7805\u7806\u7809\u780D\u780E\u7811\u781D\u7821\u7822\u7823\u782D\u782E\u7830\u7835\u7837\u7843\u7844\u7847\u7848\u784C\u784E\u7852\u785C\u785E\u7860\u7861\u7863\u7864\u7868\u786A\u786E\u787A\u787E\u788A\u788F\u7894\u7898\u78A1\u789D\u789E\u789F\u78A4\u78A8\u78AC\u78AD\u78B0\u78B1\u78B2\u78B3"],["8fd0a1","\u78BB\u78BD\u78BF\u78C7\u78C8\u78C9\u78CC\u78CE\u78D2\u78D3\u78D5\u78D6\u78E4\u78DB\u78DF\u78E0\u78E1\u78E6\u78EA\u78F2\u78F3\u7900\u78F6\u78F7\u78FA\u78FB\u78FF\u7906\u790C\u7910\u791A\u791C\u791E\u791F\u7920\u7925\u7927\u7929\u792D\u7931\u7934\u7935\u793B\u793D\u793F\u7944\u7945\u7946\u794A\u794B\u794F\u7951\u7954\u7958\u795B\u795C\u7967\u7969\u796B\u7972\u7979\u797B\u797C\u797E\u798B\u798C\u7991\u7993\u7994\u7995\u7996\u7998\u799B\u799C\u79A1\u79A8\u79A9\u79AB\u79AF\u79B1\u79B4\u79B8\u79BB\u79C2\u79C4\u79C7\u79C8\u79CA\u79CF\u79D4\u79D6\u79DA\u79DD\u79DE"],["8fd1a1","\u79E0\u79E2\u79E5\u79EA\u79EB\u79ED\u79F1\u79F8\u79FC\u7A02\u7A03\u7A07\u7A09\u7A0A\u7A0C\u7A11\u7A15\u7A1B\u7A1E\u7A21\u7A27\u7A2B\u7A2D\u7A2F\u7A30\u7A34\u7A35\u7A38\u7A39\u7A3A\u7A44\u7A45\u7A47\u7A48\u7A4C\u7A55\u7A56\u7A59\u7A5C\u7A5D\u7A5F\u7A60\u7A65\u7A67\u7A6A\u7A6D\u7A75\u7A78\u7A7E\u7A80\u7A82\u7A85\u7A86\u7A8A\u7A8B\u7A90\u7A91\u7A94\u7A9E\u7AA0\u7AA3\u7AAC\u7AB3\u7AB5\u7AB9\u7ABB\u7ABC\u7AC6\u7AC9\u7ACC\u7ACE\u7AD1\u7ADB\u7AE8\u7AE9\u7AEB\u7AEC\u7AF1\u7AF4\u7AFB\u7AFD\u7AFE\u7B07\u7B14\u7B1F\u7B23\u7B27\u7B29\u7B2A\u7B2B\u7B2D\u7B2E\u7B2F\u7B30"],["8fd2a1","\u7B31\u7B34\u7B3D\u7B3F\u7B40\u7B41\u7B47\u7B4E\u7B55\u7B60\u7B64\u7B66\u7B69\u7B6A\u7B6D\u7B6F\u7B72\u7B73\u7B77\u7B84\u7B89\u7B8E\u7B90\u7B91\u7B96\u7B9B\u7B9E\u7BA0\u7BA5\u7BAC\u7BAF\u7BB0\u7BB2\u7BB5\u7BB6\u7BBA\u7BBB\u7BBC\u7BBD\u7BC2\u7BC5\u7BC8\u7BCA\u7BD4\u7BD6\u7BD7\u7BD9\u7BDA\u7BDB\u7BE8\u7BEA\u7BF2\u7BF4\u7BF5\u7BF8\u7BF9\u7BFA\u7BFC\u7BFE\u7C01\u7C02\u7C03\u7C04\u7C06\u7C09\u7C0B\u7C0C\u7C0E\u7C0F\u7C19\u7C1B\u7C20\u7C25\u7C26\u7C28\u7C2C\u7C31\u7C33\u7C34\u7C36\u7C39\u7C3A\u7C46\u7C4A\u7C55\u7C51\u7C52\u7C53\u7C59",5],["8fd3a1","\u7C61\u7C63\u7C67\u7C69\u7C6D\u7C6E\u7C70\u7C72\u7C79\u7C7C\u7C7D\u7C86\u7C87\u7C8F\u7C94\u7C9E\u7CA0\u7CA6\u7CB0\u7CB6\u7CB7\u7CBA\u7CBB\u7CBC\u7CBF\u7CC4\u7CC7\u7CC8\u7CC9\u7CCD\u7CCF\u7CD3\u7CD4\u7CD5\u7CD7\u7CD9\u7CDA\u7CDD\u7CE6\u7CE9\u7CEB\u7CF5\u7D03\u7D07\u7D08\u7D09\u7D0F\u7D11\u7D12\u7D13\u7D16\u7D1D\u7D1E\u7D23\u7D26\u7D2A\u7D2D\u7D31\u7D3C\u7D3D\u7D3E\u7D40\u7D41\u7D47\u7D48\u7D4D\u7D51\u7D53\u7D57\u7D59\u7D5A\u7D5C\u7D5D\u7D65\u7D67\u7D6A\u7D70\u7D78\u7D7A\u7D7B\u7D7F\u7D81\u7D82\u7D83\u7D85\u7D86\u7D88\u7D8B\u7D8C\u7D8D\u7D91\u7D96\u7D97\u7D9D"],["8fd4a1","\u7D9E\u7DA6\u7DA7\u7DAA\u7DB3\u7DB6\u7DB7\u7DB9\u7DC2",4,"\u7DCC\u7DCD\u7DCE\u7DD7\u7DD9\u7E00\u7DE2\u7DE5\u7DE6\u7DEA\u7DEB\u7DED\u7DF1\u7DF5\u7DF6\u7DF9\u7DFA\u7E08\u7E10\u7E11\u7E15\u7E17\u7E1C\u7E1D\u7E20\u7E27\u7E28\u7E2C\u7E2D\u7E2F\u7E33\u7E36\u7E3F\u7E44\u7E45\u7E47\u7E4E\u7E50\u7E52\u7E58\u7E5F\u7E61\u7E62\u7E65\u7E6B\u7E6E\u7E6F\u7E73\u7E78\u7E7E\u7E81\u7E86\u7E87\u7E8A\u7E8D\u7E91\u7E95\u7E98\u7E9A\u7E9D\u7E9E\u7F3C\u7F3B\u7F3D\u7F3E\u7F3F\u7F43\u7F44\u7F47\u7F4F\u7F52\u7F53\u7F5B\u7F5C\u7F5D\u7F61\u7F63\u7F64\u7F65\u7F66\u7F6D"],["8fd5a1","\u7F71\u7F7D\u7F7E\u7F7F\u7F80\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F96\u7F97\u7F9C\u7FA1\u7FA2\u7FA6\u7FAA\u7FAD\u7FB4\u7FBC\u7FBF\u7FC0\u7FC3\u7FC8\u7FCE\u7FCF\u7FDB\u7FDF\u7FE3\u7FE5\u7FE8\u7FEC\u7FEE\u7FEF\u7FF2\u7FFA\u7FFD\u7FFE\u7FFF\u8007\u8008\u800A\u800D\u800E\u800F\u8011\u8013\u8014\u8016\u801D\u801E\u801F\u8020\u8024\u8026\u802C\u802E\u8030\u8034\u8035\u8037\u8039\u803A\u803C\u803E\u8040\u8044\u8060\u8064\u8066\u806D\u8071\u8075\u8081\u8088\u808E\u809C\u809E\u80A6\u80A7\u80AB\u80B8\u80B9\u80C8\u80CD\u80CF\u80D2\u80D4\u80D5\u80D7\u80D8\u80E0\u80ED\u80EE"],["8fd6a1","\u80F0\u80F2\u80F3\u80F6\u80F9\u80FA\u80FE\u8103\u810B\u8116\u8117\u8118\u811C\u811E\u8120\u8124\u8127\u812C\u8130\u8135\u813A\u813C\u8145\u8147\u814A\u814C\u8152\u8157\u8160\u8161\u8167\u8168\u8169\u816D\u816F\u8177\u8181\u8190\u8184\u8185\u8186\u818B\u818E\u8196\u8198\u819B\u819E\u81A2\u81AE\u81B2\u81B4\u81BB\u81CB\u81C3\u81C5\u81CA\u81CE\u81CF\u81D5\u81D7\u81DB\u81DD\u81DE\u81E1\u81E4\u81EB\u81EC\u81F0\u81F1\u81F2\u81F5\u81F6\u81F8\u81F9\u81FD\u81FF\u8200\u8203\u820F\u8213\u8214\u8219\u821A\u821D\u8221\u8222\u8228\u8232\u8234\u823A\u8243\u8244\u8245\u8246"],["8fd7a1","\u824B\u824E\u824F\u8251\u8256\u825C\u8260\u8263\u8267\u826D\u8274\u827B\u827D\u827F\u8280\u8281\u8283\u8284\u8287\u8289\u828A\u828E\u8291\u8294\u8296\u8298\u829A\u829B\u82A0\u82A1\u82A3\u82A4\u82A7\u82A8\u82A9\u82AA\u82AE\u82B0\u82B2\u82B4\u82B7\u82BA\u82BC\u82BE\u82BF\u82C6\u82D0\u82D5\u82DA\u82E0\u82E2\u82E4\u82E8\u82EA\u82ED\u82EF\u82F6\u82F7\u82FD\u82FE\u8300\u8301\u8307\u8308\u830A\u830B\u8354\u831B\u831D\u831E\u831F\u8321\u8322\u832C\u832D\u832E\u8330\u8333\u8337\u833A\u833C\u833D\u8342\u8343\u8344\u8347\u834D\u834E\u8351\u8355\u8356\u8357\u8370\u8378"],["8fd8a1","\u837D\u837F\u8380\u8382\u8384\u8386\u838D\u8392\u8394\u8395\u8398\u8399\u839B\u839C\u839D\u83A6\u83A7\u83A9\u83AC\u83BE\u83BF\u83C0\u83C7\u83C9\u83CF\u83D0\u83D1\u83D4\u83DD\u8353\u83E8\u83EA\u83F6\u83F8\u83F9\u83FC\u8401\u8406\u840A\u840F\u8411\u8415\u8419\u83AD\u842F\u8439\u8445\u8447\u8448\u844A\u844D\u844F\u8451\u8452\u8456\u8458\u8459\u845A\u845C\u8460\u8464\u8465\u8467\u846A\u8470\u8473\u8474\u8476\u8478\u847C\u847D\u8481\u8485\u8492\u8493\u8495\u849E\u84A6\u84A8\u84A9\u84AA\u84AF\u84B1\u84B4\u84BA\u84BD\u84BE\u84C0\u84C2\u84C7\u84C8\u84CC\u84CF\u84D3"],["8fd9a1","\u84DC\u84E7\u84EA\u84EF\u84F0\u84F1\u84F2\u84F7\u8532\u84FA\u84FB\u84FD\u8502\u8503\u8507\u850C\u850E\u8510\u851C\u851E\u8522\u8523\u8524\u8525\u8527\u852A\u852B\u852F\u8533\u8534\u8536\u853F\u8546\u854F",4,"\u8556\u8559\u855C",6,"\u8564\u856B\u856F\u8579\u857A\u857B\u857D\u857F\u8581\u8585\u8586\u8589\u858B\u858C\u858F\u8593\u8598\u859D\u859F\u85A0\u85A2\u85A5\u85A7\u85B4\u85B6\u85B7\u85B8\u85BC\u85BD\u85BE\u85BF\u85C2\u85C7\u85CA\u85CB\u85CE\u85AD\u85D8\u85DA\u85DF\u85E0\u85E6\u85E8\u85ED\u85F3\u85F6\u85FC"],["8fdaa1","\u85FF\u8600\u8604\u8605\u860D\u860E\u8610\u8611\u8612\u8618\u8619\u861B\u861E\u8621\u8627\u8629\u8636\u8638\u863A\u863C\u863D\u8640\u8642\u8646\u8652\u8653\u8656\u8657\u8658\u8659\u865D\u8660",4,"\u8669\u866C\u866F\u8675\u8676\u8677\u867A\u868D\u8691\u8696\u8698\u869A\u869C\u86A1\u86A6\u86A7\u86A8\u86AD\u86B1\u86B3\u86B4\u86B5\u86B7\u86B8\u86B9\u86BF\u86C0\u86C1\u86C3\u86C5\u86D1\u86D2\u86D5\u86D7\u86DA\u86DC\u86E0\u86E3\u86E5\u86E7\u8688\u86FA\u86FC\u86FD\u8704\u8705\u8707\u870B\u870E\u870F\u8710\u8713\u8714\u8719\u871E\u871F\u8721\u8723"],["8fdba1","\u8728\u872E\u872F\u8731\u8732\u8739\u873A\u873C\u873D\u873E\u8740\u8743\u8745\u874D\u8758\u875D\u8761\u8764\u8765\u876F\u8771\u8772\u877B\u8783",6,"\u878B\u878C\u8790\u8793\u8795\u8797\u8798\u8799\u879E\u87A0\u87A3\u87A7\u87AC\u87AD\u87AE\u87B1\u87B5\u87BE\u87BF\u87C1\u87C8\u87C9\u87CA\u87CE\u87D5\u87D6\u87D9\u87DA\u87DC\u87DF\u87E2\u87E3\u87E4\u87EA\u87EB\u87ED\u87F1\u87F3\u87F8\u87FA\u87FF\u8801\u8803\u8806\u8809\u880A\u880B\u8810\u8819\u8812\u8813\u8814\u8818\u881A\u881B\u881C\u881E\u881F\u8828\u882D\u882E\u8830\u8832\u8835"],["8fdca1","\u883A\u883C\u8841\u8843\u8845\u8848\u8849\u884A\u884B\u884E\u8851\u8855\u8856\u8858\u885A\u885C\u885F\u8860\u8864\u8869\u8871\u8879\u887B\u8880\u8898\u889A\u889B\u889C\u889F\u88A0\u88A8\u88AA\u88BA\u88BD\u88BE\u88C0\u88CA",4,"\u88D1\u88D2\u88D3\u88DB\u88DE\u88E7\u88EF\u88F0\u88F1\u88F5\u88F7\u8901\u8906\u890D\u890E\u890F\u8915\u8916\u8918\u8919\u891A\u891C\u8920\u8926\u8927\u8928\u8930\u8931\u8932\u8935\u8939\u893A\u893E\u8940\u8942\u8945\u8946\u8949\u894F\u8952\u8957\u895A\u895B\u895C\u8961\u8962\u8963\u896B\u896E\u8970\u8973\u8975\u897A"],["8fdda1","\u897B\u897C\u897D\u8989\u898D\u8990\u8994\u8995\u899B\u899C\u899F\u89A0\u89A5\u89B0\u89B4\u89B5\u89B6\u89B7\u89BC\u89D4",4,"\u89E5\u89E9\u89EB\u89ED\u89F1\u89F3\u89F6\u89F9\u89FD\u89FF\u8A04\u8A05\u8A07\u8A0F\u8A11\u8A12\u8A14\u8A15\u8A1E\u8A20\u8A22\u8A24\u8A26\u8A2B\u8A2C\u8A2F\u8A35\u8A37\u8A3D\u8A3E\u8A40\u8A43\u8A45\u8A47\u8A49\u8A4D\u8A4E\u8A53\u8A56\u8A57\u8A58\u8A5C\u8A5D\u8A61\u8A65\u8A67\u8A75\u8A76\u8A77\u8A79\u8A7A\u8A7B\u8A7E\u8A7F\u8A80\u8A83\u8A86\u8A8B\u8A8F\u8A90\u8A92\u8A96\u8A97\u8A99\u8A9F\u8AA7\u8AA9\u8AAE\u8AAF\u8AB3"],["8fdea1","\u8AB6\u8AB7\u8ABB\u8ABE\u8AC3\u8AC6\u8AC8\u8AC9\u8ACA\u8AD1\u8AD3\u8AD4\u8AD5\u8AD7\u8ADD\u8ADF\u8AEC\u8AF0\u8AF4\u8AF5\u8AF6\u8AFC\u8AFF\u8B05\u8B06\u8B0B\u8B11\u8B1C\u8B1E\u8B1F\u8B0A\u8B2D\u8B30\u8B37\u8B3C\u8B42",4,"\u8B48\u8B52\u8B53\u8B54\u8B59\u8B4D\u8B5E\u8B63\u8B6D\u8B76\u8B78\u8B79\u8B7C\u8B7E\u8B81\u8B84\u8B85\u8B8B\u8B8D\u8B8F\u8B94\u8B95\u8B9C\u8B9E\u8B9F\u8C38\u8C39\u8C3D\u8C3E\u8C45\u8C47\u8C49\u8C4B\u8C4F\u8C51\u8C53\u8C54\u8C57\u8C58\u8C5B\u8C5D\u8C59\u8C63\u8C64\u8C66\u8C68\u8C69\u8C6D\u8C73\u8C75\u8C76\u8C7B\u8C7E\u8C86"],["8fdfa1","\u8C87\u8C8B\u8C90\u8C92\u8C93\u8C99\u8C9B\u8C9C\u8CA4\u8CB9\u8CBA\u8CC5\u8CC6\u8CC9\u8CCB\u8CCF\u8CD6\u8CD5\u8CD9\u8CDD\u8CE1\u8CE8\u8CEC\u8CEF\u8CF0\u8CF2\u8CF5\u8CF7\u8CF8\u8CFE\u8CFF\u8D01\u8D03\u8D09\u8D12\u8D17\u8D1B\u8D65\u8D69\u8D6C\u8D6E\u8D7F\u8D82\u8D84\u8D88\u8D8D\u8D90\u8D91\u8D95\u8D9E\u8D9F\u8DA0\u8DA6\u8DAB\u8DAC\u8DAF\u8DB2\u8DB5\u8DB7\u8DB9\u8DBB\u8DC0\u8DC5\u8DC6\u8DC7\u8DC8\u8DCA\u8DCE\u8DD1\u8DD4\u8DD5\u8DD7\u8DD9\u8DE4\u8DE5\u8DE7\u8DEC\u8DF0\u8DBC\u8DF1\u8DF2\u8DF4\u8DFD\u8E01\u8E04\u8E05\u8E06\u8E0B\u8E11\u8E14\u8E16\u8E20\u8E21\u8E22"],["8fe0a1","\u8E23\u8E26\u8E27\u8E31\u8E33\u8E36\u8E37\u8E38\u8E39\u8E3D\u8E40\u8E41\u8E4B\u8E4D\u8E4E\u8E4F\u8E54\u8E5B\u8E5C\u8E5D\u8E5E\u8E61\u8E62\u8E69\u8E6C\u8E6D\u8E6F\u8E70\u8E71\u8E79\u8E7A\u8E7B\u8E82\u8E83\u8E89\u8E90\u8E92\u8E95\u8E9A\u8E9B\u8E9D\u8E9E\u8EA2\u8EA7\u8EA9\u8EAD\u8EAE\u8EB3\u8EB5\u8EBA\u8EBB\u8EC0\u8EC1\u8EC3\u8EC4\u8EC7\u8ECF\u8ED1\u8ED4\u8EDC\u8EE8\u8EEE\u8EF0\u8EF1\u8EF7\u8EF9\u8EFA\u8EED\u8F00\u8F02\u8F07\u8F08\u8F0F\u8F10\u8F16\u8F17\u8F18\u8F1E\u8F20\u8F21\u8F23\u8F25\u8F27\u8F28\u8F2C\u8F2D\u8F2E\u8F34\u8F35\u8F36\u8F37\u8F3A\u8F40\u8F41"],["8fe1a1","\u8F43\u8F47\u8F4F\u8F51",4,"\u8F58\u8F5D\u8F5E\u8F65\u8F9D\u8FA0\u8FA1\u8FA4\u8FA5\u8FA6\u8FB5\u8FB6\u8FB8\u8FBE\u8FC0\u8FC1\u8FC6\u8FCA\u8FCB\u8FCD\u8FD0\u8FD2\u8FD3\u8FD5\u8FE0\u8FE3\u8FE4\u8FE8\u8FEE\u8FF1\u8FF5\u8FF6\u8FFB\u8FFE\u9002\u9004\u9008\u900C\u9018\u901B\u9028\u9029\u902F\u902A\u902C\u902D\u9033\u9034\u9037\u903F\u9043\u9044\u904C\u905B\u905D\u9062\u9066\u9067\u906C\u9070\u9074\u9079\u9085\u9088\u908B\u908C\u908E\u9090\u9095\u9097\u9098\u9099\u909B\u90A0\u90A1\u90A2\u90A5\u90B0\u90B2\u90B3\u90B4\u90B6\u90BD\u90CC\u90BE\u90C3"],["8fe2a1","\u90C4\u90C5\u90C7\u90C8\u90D5\u90D7\u90D8\u90D9\u90DC\u90DD\u90DF\u90E5\u90D2\u90F6\u90EB\u90EF\u90F0\u90F4\u90FE\u90FF\u9100\u9104\u9105\u9106\u9108\u910D\u9110\u9114\u9116\u9117\u9118\u911A\u911C\u911E\u9120\u9125\u9122\u9123\u9127\u9129\u912E\u912F\u9131\u9134\u9136\u9137\u9139\u913A\u913C\u913D\u9143\u9147\u9148\u914F\u9153\u9157\u9159\u915A\u915B\u9161\u9164\u9167\u916D\u9174\u9179\u917A\u917B\u9181\u9183\u9185\u9186\u918A\u918E\u9191\u9193\u9194\u9195\u9198\u919E\u91A1\u91A6\u91A8\u91AC\u91AD\u91AE\u91B0\u91B1\u91B2\u91B3\u91B6\u91BB\u91BC\u91BD\u91BF"],["8fe3a1","\u91C2\u91C3\u91C5\u91D3\u91D4\u91D7\u91D9\u91DA\u91DE\u91E4\u91E5\u91E9\u91EA\u91EC",5,"\u91F7\u91F9\u91FB\u91FD\u9200\u9201\u9204\u9205\u9206\u9207\u9209\u920A\u920C\u9210\u9212\u9213\u9216\u9218\u921C\u921D\u9223\u9224\u9225\u9226\u9228\u922E\u922F\u9230\u9233\u9235\u9236\u9238\u9239\u923A\u923C\u923E\u9240\u9242\u9243\u9246\u9247\u924A\u924D\u924E\u924F\u9251\u9258\u9259\u925C\u925D\u9260\u9261\u9265\u9267\u9268\u9269\u926E\u926F\u9270\u9275",4,"\u927B\u927C\u927D\u927F\u9288\u9289\u928A\u928D\u928E\u9292\u9297"],["8fe4a1","\u9299\u929F\u92A0\u92A4\u92A5\u92A7\u92A8\u92AB\u92AF\u92B2\u92B6\u92B8\u92BA\u92BB\u92BC\u92BD\u92BF",4,"\u92C5\u92C6\u92C7\u92C8\u92CB\u92CC\u92CD\u92CE\u92D0\u92D3\u92D5\u92D7\u92D8\u92D9\u92DC\u92DD\u92DF\u92E0\u92E1\u92E3\u92E5\u92E7\u92E8\u92EC\u92EE\u92F0\u92F9\u92FB\u92FF\u9300\u9302\u9308\u930D\u9311\u9314\u9315\u931C\u931D\u931E\u931F\u9321\u9324\u9325\u9327\u9329\u932A\u9333\u9334\u9336\u9337\u9347\u9348\u9349\u9350\u9351\u9352\u9355\u9357\u9358\u935A\u935E\u9364\u9365\u9367\u9369\u936A\u936D\u936F\u9370\u9371\u9373\u9374\u9376"],["8fe5a1","\u937A\u937D\u937F\u9380\u9381\u9382\u9388\u938A\u938B\u938D\u938F\u9392\u9395\u9398\u939B\u939E\u93A1\u93A3\u93A4\u93A6\u93A8\u93AB\u93B4\u93B5\u93B6\u93BA\u93A9\u93C1\u93C4\u93C5\u93C6\u93C7\u93C9",4,"\u93D3\u93D9\u93DC\u93DE\u93DF\u93E2\u93E6\u93E7\u93F9\u93F7\u93F8\u93FA\u93FB\u93FD\u9401\u9402\u9404\u9408\u9409\u940D\u940E\u940F\u9415\u9416\u9417\u941F\u942E\u942F\u9431\u9432\u9433\u9434\u943B\u943F\u943D\u9443\u9445\u9448\u944A\u944C\u9455\u9459\u945C\u945F\u9461\u9463\u9468\u946B\u946D\u946E\u946F\u9471\u9472\u9484\u9483\u9578\u9579"],["8fe6a1","\u957E\u9584\u9588\u958C\u958D\u958E\u959D\u959E\u959F\u95A1\u95A6\u95A9\u95AB\u95AC\u95B4\u95B6\u95BA\u95BD\u95BF\u95C6\u95C8\u95C9\u95CB\u95D0\u95D1\u95D2\u95D3\u95D9\u95DA\u95DD\u95DE\u95DF\u95E0\u95E4\u95E6\u961D\u961E\u9622\u9624\u9625\u9626\u962C\u9631\u9633\u9637\u9638\u9639\u963A\u963C\u963D\u9641\u9652\u9654\u9656\u9657\u9658\u9661\u966E\u9674\u967B\u967C\u967E\u967F\u9681\u9682\u9683\u9684\u9689\u9691\u9696\u969A\u969D\u969F\u96A4\u96A5\u96A6\u96A9\u96AE\u96AF\u96B3\u96BA\u96CA\u96D2\u5DB2\u96D8\u96DA\u96DD\u96DE\u96DF\u96E9\u96EF\u96F1\u96FA\u9702"],["8fe7a1","\u9703\u9705\u9709\u971A\u971B\u971D\u9721\u9722\u9723\u9728\u9731\u9733\u9741\u9743\u974A\u974E\u974F\u9755\u9757\u9758\u975A\u975B\u9763\u9767\u976A\u976E\u9773\u9776\u9777\u9778\u977B\u977D\u977F\u9780\u9789\u9795\u9796\u9797\u9799\u979A\u979E\u979F\u97A2\u97AC\u97AE\u97B1\u97B2\u97B5\u97B6\u97B8\u97B9\u97BA\u97BC\u97BE\u97BF\u97C1\u97C4\u97C5\u97C7\u97C9\u97CA\u97CC\u97CD\u97CE\u97D0\u97D1\u97D4\u97D7\u97D8\u97D9\u97DD\u97DE\u97E0\u97DB\u97E1\u97E4\u97EF\u97F1\u97F4\u97F7\u97F8\u97FA\u9807\u980A\u9819\u980D\u980E\u9814\u9816\u981C\u981E\u9820\u9823\u9826"],["8fe8a1","\u982B\u982E\u982F\u9830\u9832\u9833\u9835\u9825\u983E\u9844\u9847\u984A\u9851\u9852\u9853\u9856\u9857\u9859\u985A\u9862\u9863\u9865\u9866\u986A\u986C\u98AB\u98AD\u98AE\u98B0\u98B4\u98B7\u98B8\u98BA\u98BB\u98BF\u98C2\u98C5\u98C8\u98CC\u98E1\u98E3\u98E5\u98E6\u98E7\u98EA\u98F3\u98F6\u9902\u9907\u9908\u9911\u9915\u9916\u9917\u991A\u991B\u991C\u991F\u9922\u9926\u9927\u992B\u9931",4,"\u9939\u993A\u993B\u993C\u9940\u9941\u9946\u9947\u9948\u994D\u994E\u9954\u9958\u9959\u995B\u995C\u995E\u995F\u9960\u999B\u999D\u999F\u99A6\u99B0\u99B1\u99B2\u99B5"],["8fe9a1","\u99B9\u99BA\u99BD\u99BF\u99C3\u99C9\u99D3\u99D4\u99D9\u99DA\u99DC\u99DE\u99E7\u99EA\u99EB\u99EC\u99F0\u99F4\u99F5\u99F9\u99FD\u99FE\u9A02\u9A03\u9A04\u9A0B\u9A0C\u9A10\u9A11\u9A16\u9A1E\u9A20\u9A22\u9A23\u9A24\u9A27\u9A2D\u9A2E\u9A33\u9A35\u9A36\u9A38\u9A47\u9A41\u9A44\u9A4A\u9A4B\u9A4C\u9A4E\u9A51\u9A54\u9A56\u9A5D\u9AAA\u9AAC\u9AAE\u9AAF\u9AB2\u9AB4\u9AB5\u9AB6\u9AB9\u9ABB\u9ABE\u9ABF\u9AC1\u9AC3\u9AC6\u9AC8\u9ACE\u9AD0\u9AD2\u9AD5\u9AD6\u9AD7\u9ADB\u9ADC\u9AE0\u9AE4\u9AE5\u9AE7\u9AE9\u9AEC\u9AF2\u9AF3\u9AF5\u9AF9\u9AFA\u9AFD\u9AFF",4],["8feaa1","\u9B04\u9B05\u9B08\u9B09\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B12\u9B16\u9B19\u9B1B\u9B1C\u9B20\u9B26\u9B2B\u9B2D\u9B33\u9B34\u9B35\u9B37\u9B39\u9B3A\u9B3D\u9B48\u9B4B\u9B4C\u9B55\u9B56\u9B57\u9B5B\u9B5E\u9B61\u9B63\u9B65\u9B66\u9B68\u9B6A",4,"\u9B73\u9B75\u9B77\u9B78\u9B79\u9B7F\u9B80\u9B84\u9B85\u9B86\u9B87\u9B89\u9B8A\u9B8B\u9B8D\u9B8F\u9B90\u9B94\u9B9A\u9B9D\u9B9E\u9BA6\u9BA7\u9BA9\u9BAC\u9BB0\u9BB1\u9BB2\u9BB7\u9BB8\u9BBB\u9BBC\u9BBE\u9BBF\u9BC1\u9BC7\u9BC8\u9BCE\u9BD0\u9BD7\u9BD8\u9BDD\u9BDF\u9BE5\u9BE7\u9BEA\u9BEB\u9BEF\u9BF3\u9BF7\u9BF8"],["8feba1","\u9BF9\u9BFA\u9BFD\u9BFF\u9C00\u9C02\u9C0B\u9C0F\u9C11\u9C16\u9C18\u9C19\u9C1A\u9C1C\u9C1E\u9C22\u9C23\u9C26",4,"\u9C31\u9C35\u9C36\u9C37\u9C3D\u9C41\u9C43\u9C44\u9C45\u9C49\u9C4A\u9C4E\u9C4F\u9C50\u9C53\u9C54\u9C56\u9C58\u9C5B\u9C5D\u9C5E\u9C5F\u9C63\u9C69\u9C6A\u9C5C\u9C6B\u9C68\u9C6E\u9C70\u9C72\u9C75\u9C77\u9C7B\u9CE6\u9CF2\u9CF7\u9CF9\u9D0B\u9D02\u9D11\u9D17\u9D18\u9D1C\u9D1D\u9D1E\u9D2F\u9D30\u9D32\u9D33\u9D34\u9D3A\u9D3C\u9D45\u9D3D\u9D42\u9D43\u9D47\u9D4A\u9D53\u9D54\u9D5F\u9D63\u9D62\u9D65\u9D69\u9D6A\u9D6B\u9D70\u9D76\u9D77\u9D7B"],["8feca1","\u9D7C\u9D7E\u9D83\u9D84\u9D86\u9D8A\u9D8D\u9D8E\u9D92\u9D93\u9D95\u9D96\u9D97\u9D98\u9DA1\u9DAA\u9DAC\u9DAE\u9DB1\u9DB5\u9DB9\u9DBC\u9DBF\u9DC3\u9DC7\u9DC9\u9DCA\u9DD4\u9DD5\u9DD6\u9DD7\u9DDA\u9DDE\u9DDF\u9DE0\u9DE5\u9DE7\u9DE9\u9DEB\u9DEE\u9DF0\u9DF3\u9DF4\u9DFE\u9E0A\u9E02\u9E07\u9E0E\u9E10\u9E11\u9E12\u9E15\u9E16\u9E19\u9E1C\u9E1D\u9E7A\u9E7B\u9E7C\u9E80\u9E82\u9E83\u9E84\u9E85\u9E87\u9E8E\u9E8F\u9E96\u9E98\u9E9B\u9E9E\u9EA4\u9EA8\u9EAC\u9EAE\u9EAF\u9EB0\u9EB3\u9EB4\u9EB5\u9EC6\u9EC8\u9ECB\u9ED5\u9EDF\u9EE4\u9EE7\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF5"],["8feda1","\u9EF8\u9EFF\u9F02\u9F03\u9F09\u9F0F\u9F10\u9F11\u9F12\u9F14\u9F16\u9F17\u9F19\u9F1A\u9F1B\u9F1F\u9F22\u9F26\u9F2A\u9F2B\u9F2F\u9F31\u9F32\u9F34\u9F37\u9F39\u9F3A\u9F3C\u9F3D\u9F3F\u9F41\u9F43",4,"\u9F53\u9F55\u9F56\u9F57\u9F58\u9F5A\u9F5D\u9F5E\u9F68\u9F69\u9F6D",4,"\u9F73\u9F75\u9F7A\u9F7D\u9F8F\u9F90\u9F91\u9F92\u9F94\u9F96\u9F97\u9F9E\u9FA1\u9FA2\u9FA3\u9FA5"]]');
            /***/ },
            /***/ 56475: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var getOwnPropertyDescriptor = __webpack_require__(72062).f;
                var createNonEnumerableProperty = __webpack_require__(48914);
                var redefine = __webpack_require__(13711);
                var setGlobal = __webpack_require__(7421);
                var copyConstructorProperties = __webpack_require__(2675);
                var isForced = __webpack_require__(39599);
                /*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/ module1.exports = function(options, source) {
                    var TARGET = options.target;
                    var GLOBAL = options.global;
                    var STATIC = options.stat;
                    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
                    if (GLOBAL) target = global;
                    else if (STATIC) target = global[TARGET] || setGlobal(TARGET, {});
                    else target = (global[TARGET] || {}).prototype;
                    if (target) for(key in source){
                        sourceProperty = source[key];
                        if (options.noTargetGet) {
                            descriptor = getOwnPropertyDescriptor(target, key);
                            targetProperty = descriptor && descriptor.value;
                        } else targetProperty = target[key];
                        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
                        // contained in target
                        if (!FORCED && targetProperty !== undefined) {
                            if (typeof sourceProperty == typeof targetProperty) continue;
                            copyConstructorProperties(sourceProperty, targetProperty);
                        }
                        // add a flag to not completely full polyfills
                        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, 'sham', true);
                        // extend global
                        redefine(target, key, sourceProperty, options);
                    }
                };
            /***/ },
            /***/ 56614: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var aCallable = __webpack_require__(32631);
                var PromiseCapability = function(C) {
                    var resolve, reject;
                    this.promise = new C(function($$resolve, $$reject) {
                        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
                        resolve = $$resolve;
                        reject = $$reject;
                    });
                    this.resolve = aCallable(resolve);
                    this.reject = aCallable(reject);
                };
                // `NewPromiseCapability` abstract operation
                // https://tc39.es/ecma262/#sec-newpromisecapability
                module1.exports.f = function(C) {
                    return new PromiseCapability(C);
                };
            /***/ },
            /***/ 56649: /***/ function(module1) {
                "use strict";
                /** @type {import('.')} */ var $defineProperty = Object.defineProperty || false;
                if ($defineProperty) try {
                    $defineProperty({}, 'a', {
                        value: 1
                    });
                } catch (e) {
                    // IE 8 has a broken defineProperty
                    $defineProperty = false;
                }
                module1.exports = $defineProperty;
            /***/ },
            /***/ 56711: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var utils = __webpack_require__(18128);
                var _require = __webpack_require__(56128), NumberT = _require.Number;
                var BufferT = /*#__PURE__*/ function() {
                    function BufferT(length) {
                        this.length = length;
                    }
                    var _proto = BufferT.prototype;
                    _proto.decode = function decode(stream, parent) {
                        var length = utils.resolveLength(this.length, stream, parent);
                        return stream.readBuffer(length);
                    };
                    _proto.size = function size(val, parent) {
                        if (!val) return utils.resolveLength(this.length, null, parent);
                        return val.length;
                    };
                    _proto.encode = function encode(stream, buf, parent) {
                        if (this.length instanceof NumberT) this.length.encode(stream, buf.length);
                        return stream.writeBuffer(buf);
                    };
                    return BufferT;
                }();
                module1.exports = BufferT;
            /***/ },
            /***/ 56912: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(98828);
                // `Uint8Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor('Uint8', function(init) {
                    return function Uint8Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 57114: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(38347);
                var PROPER_FUNCTION_NAME = __webpack_require__(7081).PROPER;
                var redefine = __webpack_require__(13711);
                var anObject = __webpack_require__(34984);
                var isPrototypeOf = __webpack_require__(70176);
                var $toString = __webpack_require__(25096);
                var fails = __webpack_require__(47044);
                var regExpFlags = __webpack_require__(21182);
                var TO_STRING = 'toString';
                var RegExpPrototype = RegExp.prototype;
                var n$ToString = RegExpPrototype[TO_STRING];
                var getFlags = uncurryThis(regExpFlags);
                var NOT_GENERIC = fails(function() {
                    return n$ToString.call({
                        source: 'a',
                        flags: 'b'
                    }) != '/a/b';
                });
                // FF44- RegExp#toString has a wrong name
                var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;
                // `RegExp.prototype.toString` method
                // https://tc39.es/ecma262/#sec-regexp.prototype.tostring
                if (NOT_GENERIC || INCORRECT_NAME) redefine(RegExp.prototype, TO_STRING, function toString() {
                    var R = anObject(this);
                    var p = $toString(R.source);
                    var rf = R.flags;
                    var f = $toString(rf === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype) ? getFlags(R) : rf);
                    return '/' + p + '/' + f;
                }, {
                    unsafe: true
                });
            /***/ },
            /***/ 57444: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var fails = __webpack_require__(47044);
                var toIndexedObject = __webpack_require__(98086);
                var nativeGetOwnPropertyDescriptor = __webpack_require__(72062).f;
                var DESCRIPTORS = __webpack_require__(15567);
                var FAILS_ON_PRIMITIVES = fails(function() {
                    nativeGetOwnPropertyDescriptor(1);
                });
                var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;
                // `Object.getOwnPropertyDescriptor` method
                // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
                $({
                    target: 'Object',
                    stat: true,
                    forced: FORCED,
                    sham: !DESCRIPTORS
                }, {
                    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
                        return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
                    }
                });
            /***/ },
            /***/ 57770: /***/ function(module1) {
                "use strict";
                /** @type {import('./syntax')} */ module1.exports = SyntaxError;
            /***/ },
            /***/ 58028: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var $includes = __webpack_require__(12636).includes;
                var addToUnscopables = __webpack_require__(71156);
                // `Array.prototype.includes` method
                // https://tc39.es/ecma262/#sec-array.prototype.includes
                $({
                    target: 'Array',
                    proto: true
                }, {
                    includes: function includes(el /* , fromIndex = 0 */ ) {
                        return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                addToUnscopables('includes');
            /***/ },
            /***/ 58099: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(98828);
                // `Uint8ClampedArray` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor('Uint8', function(init) {
                    return function Uint8ClampedArray1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                }, true);
            /***/ },
            /***/ 58281: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var charAt = __webpack_require__(69510).charAt;
                var toString = __webpack_require__(25096);
                var InternalStateModule = __webpack_require__(70172);
                var defineIterator = __webpack_require__(97001);
                var STRING_ITERATOR = 'String Iterator';
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
                // `String.prototype[@@iterator]` method
                // https://tc39.es/ecma262/#sec-string.prototype-@@iterator
                defineIterator(String, 'String', function(iterated) {
                    setInternalState(this, {
                        type: STRING_ITERATOR,
                        string: toString(iterated),
                        index: 0
                    });
                // `%StringIteratorPrototype%.next` method
                // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
                }, function next() {
                    var state = getInternalState(this);
                    var string = state.string;
                    var index = state.index;
                    var point;
                    if (index >= string.length) return {
                        value: undefined,
                        done: true
                    };
                    point = charAt(string, index);
                    state.index += point.length;
                    return {
                        value: point,
                        done: false
                    };
                });
            /***/ },
            /***/ 58448: /***/ function(module1) {
                var FunctionPrototype = Function.prototype;
                var apply = FunctionPrototype.apply;
                var bind = FunctionPrototype.bind;
                var call = FunctionPrototype.call;
                // eslint-disable-next-line es/no-reflect -- safe
                module1.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function() {
                    return call.apply(apply, arguments);
                });
            /***/ },
            /***/ 58549: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                // `Number.EPSILON` constant
                // https://tc39.es/ecma262/#sec-number.epsilon
                $({
                    target: 'Number',
                    stat: true
                }, {
                    EPSILON: Math.pow(2, -52)
                });
            /***/ },
            /***/ 58659: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isCallable = __webpack_require__(94578);
                var String1 = global.String;
                var TypeError1 = global.TypeError;
                module1.exports = function(argument) {
                    if (typeof argument == 'object' || isCallable(argument)) return argument;
                    throw TypeError1("Can't set " + String1(argument) + ' as a prototype');
                };
            /***/ },
            /***/ 58843: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var callBound = __webpack_require__(22774);
                var isRegex = __webpack_require__(71689);
                var $exec = callBound('RegExp.prototype.exec');
                var $TypeError = __webpack_require__(96785);
                /** @type {import('.')} */ module1.exports = function regexTester(regex) {
                    if (!isRegex(regex)) throw new $TypeError('`regex` must be a RegExp');
                    return function test(s) {
                        return $exec(regex, s) !== null;
                    };
                };
            /***/ },
            /***/ 59006: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(81755);
                __webpack_require__(20731);
                __webpack_require__(8953);
                __webpack_require__(14032);
                __webpack_require__(56912);
                __webpack_require__(59735);
                __webpack_require__(73663);
                __webpack_require__(29883);
                __webpack_require__(35471);
                __webpack_require__(21012);
                __webpack_require__(88997);
                __webpack_require__(97464);
                __webpack_require__(2857);
                __webpack_require__(94715);
                __webpack_require__(13624);
                __webpack_require__(91132);
                __webpack_require__(62514);
                __webpack_require__(24597);
                __webpack_require__(88042);
                __webpack_require__(4660);
                __webpack_require__(92451);
                __webpack_require__(44206);
                __webpack_require__(66288);
                __webpack_require__(13250);
                __webpack_require__(3858);
                __webpack_require__(84538);
                __webpack_require__(64793);
                __webpack_require__(74202);
                __webpack_require__(52529);
                var inflate = __webpack_require__(3483);
                var _require = __webpack_require__(84327), swap32LE = _require.swap32LE;
                // Shift size for getting the index-1 table offset.
                var SHIFT_1 = 11;
                // Shift size for getting the index-2 table offset.
                var SHIFT_2 = 5;
                // Difference between the two shift sizes,
                // for getting an index-1 offset from an index-2 offset. 6=11-5
                var SHIFT_1_2 = SHIFT_1 - SHIFT_2;
                // Number of index-1 entries for the BMP. 32=0x20
                // This part of the index-1 table is omitted from the serialized form.
                var OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
                // Number of entries in an index-2 block. 64=0x40
                var INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
                // Mask for getting the lower bits for the in-index-2-block offset. */
                var INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
                // Shift size for shifting left the index array values.
                // Increases possible data size with 16-bit index values at the cost
                // of compactability.
                // This requires data blocks to be aligned by DATA_GRANULARITY.
                var INDEX_SHIFT = 2;
                // Number of entries in a data block. 32=0x20
                var DATA_BLOCK_LENGTH = 1 << SHIFT_2;
                // Mask for getting the lower bits for the in-data-block offset.
                var DATA_MASK = DATA_BLOCK_LENGTH - 1;
                // The part of the index-2 table for U+D800..U+DBFF stores values for
                // lead surrogate code _units_ not code _points_.
                // Values for lead surrogate code _points_ are indexed with this portion of the table.
                // Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)
                var LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
                var LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
                // Count the lengths of both BMP pieces. 2080=0x820
                var INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
                // The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
                // Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.
                var UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
                var UTF8_2B_INDEX_2_LENGTH = 32; // U+0800 is the first code point after 2-byte UTF-8
                // The index-1 table, only used for supplementary code points, at offset 2112=0x840.
                // Variable length, for code points up to highStart, where the last single-value range starts.
                // Maximum length 512=0x200=0x100000>>SHIFT_1.
                // (For 0x100000 supplementary code points U+10000..U+10ffff.)
                //
                // The part of the index-2 table for supplementary code points starts
                // after this index-1 table.
                //
                // Both the index-1 table and the following part of the index-2 table
                // are omitted completely if there is only BMP data.
                var INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
                // The alignment size of a data block. Also the granularity for compaction.
                var DATA_GRANULARITY = 1 << INDEX_SHIFT;
                var UnicodeTrie = /*#__PURE__*/ function() {
                    function UnicodeTrie(data) {
                        var isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
                        if (isBuffer || data instanceof Uint8Array) {
                            // read binary format
                            var uncompressedLength;
                            if (isBuffer) {
                                this.highStart = data.readUInt32LE(0);
                                this.errorValue = data.readUInt32LE(4);
                                uncompressedLength = data.readUInt32LE(8);
                                data = data.slice(12);
                            } else {
                                var view = new DataView(data.buffer);
                                this.highStart = view.getUint32(0, true);
                                this.errorValue = view.getUint32(4, true);
                                uncompressedLength = view.getUint32(8, true);
                                data = data.subarray(12);
                            }
                            // double inflate the actual trie data
                            data = inflate(data, new Uint8Array(uncompressedLength));
                            data = inflate(data, new Uint8Array(uncompressedLength));
                            // swap bytes from little-endian
                            swap32LE(data);
                            this.data = new Uint32Array(data.buffer);
                        } else {
                            // pre-parsed data
                            var _data = data;
                            this.data = _data.data;
                            this.highStart = _data.highStart;
                            this.errorValue = _data.errorValue;
                        }
                    }
                    var _proto = UnicodeTrie.prototype;
                    _proto.get = function get(codePoint) {
                        var index;
                        if (codePoint < 0 || codePoint > 0x10ffff) return this.errorValue;
                        if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
                            // Ordinary BMP code point, excluding leading surrogates.
                            // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
                            // data is stored in the index array itself.
                            index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
                            return this.data[index];
                        }
                        if (codePoint <= 0xffff) {
                            // Lead Surrogate Code Point.  A Separate index section is stored for
                            // lead surrogate code units and code points.
                            //   The main index has the code unit data.
                            //   For this function, we need the code point data.
                            index = (this.data[LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
                            return this.data[index];
                        }
                        if (codePoint < this.highStart) {
                            // Supplemental code point, use two-level lookup.
                            index = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> SHIFT_1)];
                            index = this.data[index + (codePoint >> SHIFT_2 & INDEX_2_MASK)];
                            index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
                            return this.data[index];
                        }
                        return this.data[this.data.length - DATA_GRANULARITY];
                    };
                    return UnicodeTrie;
                }();
                module1.exports = UnicodeTrie;
            /***/ },
            /***/ 59113: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var classof = __webpack_require__(93975);
                // `IsArray` abstract operation
                // https://tc39.es/ecma262/#sec-isarray
                // eslint-disable-next-line es/no-array-isarray -- safe
                module1.exports = Array.isArray || function isArray(argument) {
                    return classof(argument) == 'Array';
                };
            /***/ },
            /***/ 59610: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var arrayFromConstructorAndList = __webpack_require__(34269);
                var typedArraySpeciesConstructor = __webpack_require__(34815);
                module1.exports = function(instance, list) {
                    return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
                };
            /***/ },
            /***/ 59735: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(98828);
                // `Uint32Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor('Uint32', function(init) {
                    return function Uint32Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 59754: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var NATIVE_ARRAY_BUFFER = __webpack_require__(30450);
                var DESCRIPTORS = __webpack_require__(15567);
                var global = __webpack_require__(32010);
                var isCallable = __webpack_require__(94578);
                var isObject = __webpack_require__(24517);
                var hasOwn = __webpack_require__(20340);
                var classof = __webpack_require__(52564);
                var tryToString = __webpack_require__(68664);
                var createNonEnumerableProperty = __webpack_require__(48914);
                var redefine = __webpack_require__(13711);
                var defineProperty = __webpack_require__(95892).f;
                var isPrototypeOf = __webpack_require__(70176);
                var getPrototypeOf = __webpack_require__(69548);
                var setPrototypeOf = __webpack_require__(3840);
                var wellKnownSymbol = __webpack_require__(38688);
                var uid = __webpack_require__(46859);
                var Int8Array1 = global.Int8Array;
                var Int8ArrayPrototype = Int8Array1 && Int8Array1.prototype;
                var Uint8ClampedArray1 = global.Uint8ClampedArray;
                var Uint8ClampedArrayPrototype = Uint8ClampedArray1 && Uint8ClampedArray1.prototype;
                var TypedArray = Int8Array1 && getPrototypeOf(Int8Array1);
                var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
                var ObjectPrototype = Object.prototype;
                var TypeError1 = global.TypeError;
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
                var TYPED_ARRAY_CONSTRUCTOR = uid('TYPED_ARRAY_CONSTRUCTOR');
                // Fixing native typed arrays in Opera Presto crashes the browser, see #595
                var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
                var TYPED_ARRAY_TAG_REQIRED = false;
                var NAME, Constructor, Prototype;
                var TypedArrayConstructorsList = {
                    Int8Array: 1,
                    Uint8Array: 1,
                    Uint8ClampedArray: 1,
                    Int16Array: 2,
                    Uint16Array: 2,
                    Int32Array: 4,
                    Uint32Array: 4,
                    Float32Array: 4,
                    Float64Array: 8
                };
                var BigIntArrayConstructorsList = {
                    BigInt64Array: 8,
                    BigUint64Array: 8
                };
                var isView = function isView(it) {
                    if (!isObject(it)) return false;
                    var klass = classof(it);
                    return klass === 'DataView' || hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
                };
                var isTypedArray = function isTypedArray(it) {
                    if (!isObject(it)) return false;
                    var klass = classof(it);
                    return hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
                };
                var aTypedArray = function aTypedArray(it) {
                    if (isTypedArray(it)) return it;
                    throw TypeError1('Target is not a typed array');
                };
                var aTypedArrayConstructor = function aTypedArrayConstructor(C) {
                    if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
                    throw TypeError1(tryToString(C) + ' is not a typed array constructor');
                };
                var exportTypedArrayMethod = function exportTypedArrayMethod(KEY, property, forced) {
                    if (!DESCRIPTORS) return;
                    if (forced) for(var ARRAY in TypedArrayConstructorsList){
                        var TypedArrayConstructor = global[ARRAY];
                        if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
                            delete TypedArrayConstructor.prototype[KEY];
                        } catch (error) {}
                    }
                    if (!TypedArrayPrototype[KEY] || forced) redefine(TypedArrayPrototype, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property);
                };
                var exportTypedArrayStaticMethod = function exportTypedArrayStaticMethod(KEY, property, forced) {
                    var ARRAY, TypedArrayConstructor;
                    if (!DESCRIPTORS) return;
                    if (setPrototypeOf) {
                        if (forced) for(ARRAY in TypedArrayConstructorsList){
                            TypedArrayConstructor = global[ARRAY];
                            if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
                                delete TypedArrayConstructor[KEY];
                            } catch (error) {}
                        }
                        if (!TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
                        try {
                            return redefine(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
                        } catch (error) {}
                        else return;
                    }
                    for(ARRAY in TypedArrayConstructorsList){
                        TypedArrayConstructor = global[ARRAY];
                        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) redefine(TypedArrayConstructor, KEY, property);
                    }
                };
                for(NAME in TypedArrayConstructorsList){
                    Constructor = global[NAME];
                    Prototype = Constructor && Constructor.prototype;
                    if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
                    else NATIVE_ARRAY_BUFFER_VIEWS = false;
                }
                for(NAME in BigIntArrayConstructorsList){
                    Constructor = global[NAME];
                    Prototype = Constructor && Constructor.prototype;
                    if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
                }
                // WebKit bug - typed arrays constructors prototype is Object.prototype
                if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
                    // eslint-disable-next-line no-shadow -- safe
                    TypedArray = function TypedArray() {
                        throw TypeError1('Incorrect invocation');
                    };
                    if (NATIVE_ARRAY_BUFFER_VIEWS) {
                        for(NAME in TypedArrayConstructorsList)if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
                    }
                }
                if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
                    TypedArrayPrototype = TypedArray.prototype;
                    if (NATIVE_ARRAY_BUFFER_VIEWS) {
                        for(NAME in TypedArrayConstructorsList)if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
                    }
                }
                // WebKit bug - one more object in Uint8ClampedArray prototype chain
                if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
                if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
                    TYPED_ARRAY_TAG_REQIRED = true;
                    defineProperty(TypedArrayPrototype, TO_STRING_TAG, {
                        get: function get() {
                            return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
                        }
                    });
                    for(NAME in TypedArrayConstructorsList)if (global[NAME]) createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
                }
                module1.exports = {
                    NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
                    TYPED_ARRAY_CONSTRUCTOR: TYPED_ARRAY_CONSTRUCTOR,
                    TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQIRED && TYPED_ARRAY_TAG,
                    aTypedArray: aTypedArray,
                    aTypedArrayConstructor: aTypedArrayConstructor,
                    exportTypedArrayMethod: exportTypedArrayMethod,
                    exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
                    isView: isView,
                    isTypedArray: isTypedArray,
                    TypedArray: TypedArray,
                    TypedArrayPrototype: TypedArrayPrototype
                };
            /***/ },
            /***/ 59804: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var bind = __webpack_require__(25567);
                var getOwnPropertyDescriptor = __webpack_require__(72062).f;
                var macrotask = __webpack_require__(6616).set;
                var IS_IOS = __webpack_require__(17716);
                var IS_IOS_PEBBLE = __webpack_require__(70573);
                var IS_WEBOS_WEBKIT = __webpack_require__(664);
                var IS_NODE = __webpack_require__(95053);
                var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
                var document1 = global.document;
                var process = global.process;
                var Promise1 = global.Promise;
                // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
                var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
                var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
                var flush, head, last, notify, toggle, node, promise, then;
                // modern engines have queueMicrotask method
                if (!queueMicrotask) {
                    flush = function() {
                        var parent, fn;
                        if (IS_NODE && (parent = process.domain)) parent.exit();
                        while(head){
                            fn = head.fn;
                            head = head.next;
                            try {
                                fn();
                            } catch (error) {
                                if (head) notify();
                                else last = undefined;
                                throw error;
                            }
                        }
                        last = undefined;
                        if (parent) parent.enter();
                    };
                    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
                    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
                    if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document1) {
                        toggle = true;
                        node = document1.createTextNode('');
                        new MutationObserver(flush).observe(node, {
                            characterData: true
                        });
                        notify = function() {
                            node.data = toggle = !toggle;
                        };
                    // environments with maybe non-completely correct, but existent Promise
                    } else if (!IS_IOS_PEBBLE && Promise1 && Promise1.resolve) {
                        // Promise.resolve without an argument throws an error in LG WebOS 2
                        promise = Promise1.resolve(undefined);
                        // workaround of WebKit ~ iOS Safari 10.1 bug
                        promise.constructor = Promise1;
                        then = bind(promise.then, promise);
                        notify = function() {
                            then(flush);
                        };
                    // Node.js without promises
                    } else if (IS_NODE) notify = function() {
                        process.nextTick(flush);
                    };
                    else {
                        // strange IE + webpack dev server bug - use .bind(global)
                        macrotask = bind(macrotask, global);
                        notify = function() {
                            macrotask(flush);
                        };
                    }
                }
                module1.exports = queueMicrotask || function(fn) {
                    var task = {
                        fn: fn,
                        next: undefined
                    };
                    if (last) last.next = task;
                    if (!head) {
                        head = task;
                        notify();
                    }
                    last = task;
                };
            /***/ },
            /***/ 59805: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var globalIsFinite = global.isFinite;
                // `Number.isFinite` method
                // https://tc39.es/ecma262/#sec-number.isfinite
                // eslint-disable-next-line es/no-number-isfinite -- safe
                module1.exports = Number.isFinite || function isFinite1(it) {
                    return typeof it == 'number' && globalIsFinite(it);
                };
            /***/ },
            /***/ 59883: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var $values = __webpack_require__(80754).values;
                // `Object.values` method
                // https://tc39.es/ecma262/#sec-object.values
                $({
                    target: 'Object',
                    stat: true
                }, {
                    values: function values(O) {
                        return $values(O);
                    }
                });
            /***/ },
            /***/ 60378: /***/ function(module1) {
                module1.exports = function() {
                    throw new Error('Readable.from is not available in the browser');
                };
            /***/ },
            /***/ 60480: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(74516);
                var Bitfield = /*#__PURE__*/ function() {
                    function Bitfield(type, flags) {
                        if (flags === void 0) flags = [];
                        this.type = type;
                        this.flags = flags;
                    }
                    var _proto = Bitfield.prototype;
                    _proto.decode = function decode(stream) {
                        var val = this.type.decode(stream);
                        var res = {};
                        for(var i = 0; i < this.flags.length; i++){
                            var flag = this.flags[i];
                            if (flag != null) res[flag] = !!(val & 1 << i);
                        }
                        return res;
                    };
                    _proto.size = function size() {
                        return this.type.size();
                    };
                    _proto.encode = function encode(stream, keys) {
                        var val = 0;
                        for(var i = 0; i < this.flags.length; i++){
                            var flag = this.flags[i];
                            if (flag != null) {
                                if (keys[flag]) val |= 1 << i;
                            }
                        }
                        return this.type.encode(stream, val);
                    };
                    return Bitfield;
                }();
                module1.exports = Bitfield;
            /***/ },
            /***/ 61084: /***/ function(module1) {
                "use strict";
                var functionsHaveNames = function functionsHaveNames() {
                    return typeof (function f() {}).name === 'string';
                };
                var gOPD = Object.getOwnPropertyDescriptor;
                if (gOPD) try {
                    gOPD([], 'length');
                } catch (e) {
                    // IE 8 has a broken gOPD
                    gOPD = null;
                }
                functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
                    if (!functionsHaveNames() || !gOPD) return false;
                    var desc = gOPD(function() {}, 'name');
                    return !!desc && !!desc.configurable;
                };
                var $bind = Function.prototype.bind;
                functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
                    return functionsHaveNames() && typeof $bind === 'function' && (function f() {}).bind().name !== '';
                };
                module1.exports = functionsHaveNames;
            /***/ },
            /***/ 61144: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                module1.exports = function(a, b) {
                    var console1 = global.console;
                    if (console1 && console1.error) arguments.length == 1 ? console1.error(a) : console1.error(a, b);
                };
            /***/ },
            /***/ 61146: /***/ function(__unused_webpack_module, exports) {
                // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
                exports.f = Object.getOwnPropertySymbols;
            /***/ },
            /***/ 61320: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var implementation = __webpack_require__(82621);
                module1.exports = function getPolyfill() {
                    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
                    return implementation;
                };
            /***/ },
            /***/ 61726: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var exec = __webpack_require__(49820);
                // `RegExp.prototype.exec` method
                // https://tc39.es/ecma262/#sec-regexp.prototype.exec
                $({
                    target: 'RegExp',
                    proto: true,
                    forced: /./.exec !== exec
                }, {
                    exec: exec
                });
            /***/ },
            /***/ 61733: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                (function(sax) {
                    sax.parser = function(strict, opt) {
                        return new SAXParser(strict, opt);
                    };
                    sax.SAXParser = SAXParser;
                    sax.SAXStream = SAXStream;
                    sax.createStream = createStream;
                    // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
                    // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
                    // since that's the earliest that a buffer overrun could occur.  This way, checks are
                    // as rare as required, but as often as necessary to ensure never crossing this bound.
                    // Furthermore, buffers are only tested at most once per write(), so passing a very
                    // large string into write() might have undesirable effects, but this is manageable by
                    // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
                    // edge case, result in creating at most one complete copy of the string passed in.
                    // Set to Infinity to have unlimited buffers.
                    sax.MAX_BUFFER_LENGTH = 65536;
                    var buffers = [
                        'comment',
                        'sgmlDecl',
                        'textNode',
                        'tagName',
                        'doctype',
                        'procInstName',
                        'procInstBody',
                        'entity',
                        'attribName',
                        'attribValue',
                        'cdata',
                        'script'
                    ];
                    sax.EVENTS = [
                        'text',
                        'processinginstruction',
                        'sgmldeclaration',
                        'doctype',
                        'comment',
                        'opentagstart',
                        'attribute',
                        'opentag',
                        'closetag',
                        'opencdata',
                        'cdata',
                        'closecdata',
                        'error',
                        'end',
                        'ready',
                        'script',
                        'opennamespace',
                        'closenamespace'
                    ];
                    function SAXParser(strict, opt) {
                        if (!(this instanceof SAXParser)) return new SAXParser(strict, opt);
                        var parser = this;
                        clearBuffers(parser);
                        parser.q = parser.c = '';
                        parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
                        parser.opt = opt || {};
                        parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
                        parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase';
                        parser.tags = [];
                        parser.closed = parser.closedRoot = parser.sawRoot = false;
                        parser.tag = parser.error = null;
                        parser.strict = !!strict;
                        parser.noscript = !!(strict || parser.opt.noscript);
                        parser.state = S.BEGIN;
                        parser.strictEntities = parser.opt.strictEntities;
                        parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
                        parser.attribList = [];
                        // namespaces form a prototype chain.
                        // it always points at the current tag,
                        // which protos to its parent tag.
                        if (parser.opt.xmlns) parser.ns = Object.create(rootNS);
                        // disallow unquoted attribute values if not otherwise configured
                        // and strict mode is true
                        if (parser.opt.unquotedAttributeValues === undefined) parser.opt.unquotedAttributeValues = !strict;
                        // mostly just for error reporting
                        parser.trackPosition = parser.opt.position !== false;
                        if (parser.trackPosition) parser.position = parser.line = parser.column = 0;
                        emit(parser, 'onready');
                    }
                    if (!Object.create) Object.create = function(o) {
                        function F() {}
                        F.prototype = o;
                        var newf = new F();
                        return newf;
                    };
                    if (!Object.keys) Object.keys = function(o) {
                        var a = [];
                        for(var i in o)if (o.hasOwnProperty(i)) a.push(i);
                        return a;
                    };
                    function checkBufferLength(parser) {
                        var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
                        var maxActual = 0;
                        for(var i = 0, l = buffers.length; i < l; i++){
                            var len = parser[buffers[i]].length;
                            if (len > maxAllowed) // Text/cdata nodes can get big, and since they're buffered,
                            // we can get here under normal conditions.
                            // Avoid issues by emitting the text node now,
                            // so at least it won't get any bigger.
                            switch(buffers[i]){
                                case 'textNode':
                                    closeText(parser);
                                    break;
                                case 'cdata':
                                    emitNode(parser, 'oncdata', parser.cdata);
                                    parser.cdata = '';
                                    break;
                                case 'script':
                                    emitNode(parser, 'onscript', parser.script);
                                    parser.script = '';
                                    break;
                                default:
                                    error(parser, 'Max buffer length exceeded: ' + buffers[i]);
                            }
                            maxActual = Math.max(maxActual, len);
                        }
                        // schedule the next check for the earliest possible buffer overrun.
                        var m = sax.MAX_BUFFER_LENGTH - maxActual;
                        parser.bufferCheckPosition = m + parser.position;
                    }
                    function clearBuffers(parser) {
                        for(var i = 0, l = buffers.length; i < l; i++)parser[buffers[i]] = '';
                    }
                    function flushBuffers(parser) {
                        closeText(parser);
                        if (parser.cdata !== '') {
                            emitNode(parser, 'oncdata', parser.cdata);
                            parser.cdata = '';
                        }
                        if (parser.script !== '') {
                            emitNode(parser, 'onscript', parser.script);
                            parser.script = '';
                        }
                    }
                    SAXParser.prototype = {
                        end: function() {
                            end(this);
                        },
                        write: write,
                        resume: function() {
                            this.error = null;
                            return this;
                        },
                        close: function() {
                            return this.write(null);
                        },
                        flush: function() {
                            flushBuffers(this);
                        }
                    };
                    var Stream;
                    try {
                        Stream = __webpack_require__(9760).Stream;
                    } catch (ex) {
                        Stream = function() {};
                    }
                    if (!Stream) Stream = function() {};
                    var streamWraps = sax.EVENTS.filter(function(ev) {
                        return ev !== 'error' && ev !== 'end';
                    });
                    function createStream(strict, opt) {
                        return new SAXStream(strict, opt);
                    }
                    function SAXStream(strict, opt) {
                        if (!(this instanceof SAXStream)) return new SAXStream(strict, opt);
                        Stream.apply(this);
                        this._parser = new SAXParser(strict, opt);
                        this.writable = true;
                        this.readable = true;
                        var me = this;
                        this._parser.onend = function() {
                            me.emit('end');
                        };
                        this._parser.onerror = function(er) {
                            me.emit('error', er);
                            // if didn't throw, then means error was handled.
                            // go ahead and clear error, so we can write again.
                            me._parser.error = null;
                        };
                        this._decoder = null;
                        streamWraps.forEach(function(ev) {
                            Object.defineProperty(me, 'on' + ev, {
                                get: function() {
                                    return me._parser['on' + ev];
                                },
                                set: function(h) {
                                    if (!h) {
                                        me.removeAllListeners(ev);
                                        me._parser['on' + ev] = h;
                                        return h;
                                    }
                                    me.on(ev, h);
                                },
                                enumerable: true,
                                configurable: false
                            });
                        });
                    }
                    SAXStream.prototype = Object.create(Stream.prototype, {
                        constructor: {
                            value: SAXStream
                        }
                    });
                    SAXStream.prototype.write = function(data) {
                        if (typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function' && Buffer.isBuffer(data)) {
                            if (!this._decoder) {
                                var SD = __webpack_require__(43143)/* .StringDecoder */ .I;
                                this._decoder = new SD('utf8');
                            }
                            data = this._decoder.write(data);
                        }
                        this._parser.write(data.toString());
                        this.emit('data', data);
                        return true;
                    };
                    SAXStream.prototype.end = function(chunk) {
                        if (chunk && chunk.length) this.write(chunk);
                        this._parser.end();
                        return true;
                    };
                    SAXStream.prototype.on = function(ev, handler) {
                        var me = this;
                        if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) me._parser['on' + ev] = function() {
                            var args = arguments.length === 1 ? [
                                arguments[0]
                            ] : Array.apply(null, arguments);
                            args.splice(0, 0, ev);
                            me.emit.apply(me, args);
                        };
                        return Stream.prototype.on.call(me, ev, handler);
                    };
                    // this really needs to be replaced with character classes.
                    // XML allows all manner of ridiculous numbers and digits.
                    var CDATA = '[CDATA[';
                    var DOCTYPE = 'DOCTYPE';
                    var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
                    var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/';
                    var rootNS = {
                        xml: XML_NAMESPACE,
                        xmlns: XMLNS_NAMESPACE
                    };
                    // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
                    // This implementation works on strings, a single character at a time
                    // as such, it cannot ever support astral-plane characters (10000-EFFFF)
                    // without a significant breaking change to either this  parser, or the
                    // JavaScript language.  Implementation of an emoji-capable xml parser
                    // is left as an exercise for the reader.
                    var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
                    var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
                    var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
                    var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
                    function isWhitespace(c) {
                        return c === ' ' || c === '\n' || c === '\r' || c === '\t';
                    }
                    function isQuote(c) {
                        return c === '"' || c === '\'';
                    }
                    function isAttribEnd(c) {
                        return c === '>' || isWhitespace(c);
                    }
                    function isMatch(regex, c) {
                        return regex.test(c);
                    }
                    function notMatch(regex, c) {
                        return !isMatch(regex, c);
                    }
                    var S = 0;
                    sax.STATE = {
                        BEGIN: S++,
                        BEGIN_WHITESPACE: S++,
                        TEXT: S++,
                        TEXT_ENTITY: S++,
                        OPEN_WAKA: S++,
                        SGML_DECL: S++,
                        SGML_DECL_QUOTED: S++,
                        DOCTYPE: S++,
                        DOCTYPE_QUOTED: S++,
                        DOCTYPE_DTD: S++,
                        DOCTYPE_DTD_QUOTED: S++,
                        COMMENT_STARTING: S++,
                        COMMENT: S++,
                        COMMENT_ENDING: S++,
                        COMMENT_ENDED: S++,
                        CDATA: S++,
                        CDATA_ENDING: S++,
                        CDATA_ENDING_2: S++,
                        PROC_INST: S++,
                        PROC_INST_BODY: S++,
                        PROC_INST_ENDING: S++,
                        OPEN_TAG: S++,
                        OPEN_TAG_SLASH: S++,
                        ATTRIB: S++,
                        ATTRIB_NAME: S++,
                        ATTRIB_NAME_SAW_WHITE: S++,
                        ATTRIB_VALUE: S++,
                        ATTRIB_VALUE_QUOTED: S++,
                        ATTRIB_VALUE_CLOSED: S++,
                        ATTRIB_VALUE_UNQUOTED: S++,
                        ATTRIB_VALUE_ENTITY_Q: S++,
                        ATTRIB_VALUE_ENTITY_U: S++,
                        CLOSE_TAG: S++,
                        CLOSE_TAG_SAW_WHITE: S++,
                        SCRIPT: S++,
                        SCRIPT_ENDING: S++ // <script> ... <
                    };
                    sax.XML_ENTITIES = {
                        'amp': '&',
                        'gt': '>',
                        'lt': '<',
                        'quot': '"',
                        'apos': "'"
                    };
                    sax.ENTITIES = {
                        'amp': '&',
                        'gt': '>',
                        'lt': '<',
                        'quot': '"',
                        'apos': "'",
                        'AElig': 198,
                        'Aacute': 193,
                        'Acirc': 194,
                        'Agrave': 192,
                        'Aring': 197,
                        'Atilde': 195,
                        'Auml': 196,
                        'Ccedil': 199,
                        'ETH': 208,
                        'Eacute': 201,
                        'Ecirc': 202,
                        'Egrave': 200,
                        'Euml': 203,
                        'Iacute': 205,
                        'Icirc': 206,
                        'Igrave': 204,
                        'Iuml': 207,
                        'Ntilde': 209,
                        'Oacute': 211,
                        'Ocirc': 212,
                        'Ograve': 210,
                        'Oslash': 216,
                        'Otilde': 213,
                        'Ouml': 214,
                        'THORN': 222,
                        'Uacute': 218,
                        'Ucirc': 219,
                        'Ugrave': 217,
                        'Uuml': 220,
                        'Yacute': 221,
                        'aacute': 225,
                        'acirc': 226,
                        'aelig': 230,
                        'agrave': 224,
                        'aring': 229,
                        'atilde': 227,
                        'auml': 228,
                        'ccedil': 231,
                        'eacute': 233,
                        'ecirc': 234,
                        'egrave': 232,
                        'eth': 240,
                        'euml': 235,
                        'iacute': 237,
                        'icirc': 238,
                        'igrave': 236,
                        'iuml': 239,
                        'ntilde': 241,
                        'oacute': 243,
                        'ocirc': 244,
                        'ograve': 242,
                        'oslash': 248,
                        'otilde': 245,
                        'ouml': 246,
                        'szlig': 223,
                        'thorn': 254,
                        'uacute': 250,
                        'ucirc': 251,
                        'ugrave': 249,
                        'uuml': 252,
                        'yacute': 253,
                        'yuml': 255,
                        'copy': 169,
                        'reg': 174,
                        'nbsp': 160,
                        'iexcl': 161,
                        'cent': 162,
                        'pound': 163,
                        'curren': 164,
                        'yen': 165,
                        'brvbar': 166,
                        'sect': 167,
                        'uml': 168,
                        'ordf': 170,
                        'laquo': 171,
                        'not': 172,
                        'shy': 173,
                        'macr': 175,
                        'deg': 176,
                        'plusmn': 177,
                        'sup1': 185,
                        'sup2': 178,
                        'sup3': 179,
                        'acute': 180,
                        'micro': 181,
                        'para': 182,
                        'middot': 183,
                        'cedil': 184,
                        'ordm': 186,
                        'raquo': 187,
                        'frac14': 188,
                        'frac12': 189,
                        'frac34': 190,
                        'iquest': 191,
                        'times': 215,
                        'divide': 247,
                        'OElig': 338,
                        'oelig': 339,
                        'Scaron': 352,
                        'scaron': 353,
                        'Yuml': 376,
                        'fnof': 402,
                        'circ': 710,
                        'tilde': 732,
                        'Alpha': 913,
                        'Beta': 914,
                        'Gamma': 915,
                        'Delta': 916,
                        'Epsilon': 917,
                        'Zeta': 918,
                        'Eta': 919,
                        'Theta': 920,
                        'Iota': 921,
                        'Kappa': 922,
                        'Lambda': 923,
                        'Mu': 924,
                        'Nu': 925,
                        'Xi': 926,
                        'Omicron': 927,
                        'Pi': 928,
                        'Rho': 929,
                        'Sigma': 931,
                        'Tau': 932,
                        'Upsilon': 933,
                        'Phi': 934,
                        'Chi': 935,
                        'Psi': 936,
                        'Omega': 937,
                        'alpha': 945,
                        'beta': 946,
                        'gamma': 947,
                        'delta': 948,
                        'epsilon': 949,
                        'zeta': 950,
                        'eta': 951,
                        'theta': 952,
                        'iota': 953,
                        'kappa': 954,
                        'lambda': 955,
                        'mu': 956,
                        'nu': 957,
                        'xi': 958,
                        'omicron': 959,
                        'pi': 960,
                        'rho': 961,
                        'sigmaf': 962,
                        'sigma': 963,
                        'tau': 964,
                        'upsilon': 965,
                        'phi': 966,
                        'chi': 967,
                        'psi': 968,
                        'omega': 969,
                        'thetasym': 977,
                        'upsih': 978,
                        'piv': 982,
                        'ensp': 8194,
                        'emsp': 8195,
                        'thinsp': 8201,
                        'zwnj': 8204,
                        'zwj': 8205,
                        'lrm': 8206,
                        'rlm': 8207,
                        'ndash': 8211,
                        'mdash': 8212,
                        'lsquo': 8216,
                        'rsquo': 8217,
                        'sbquo': 8218,
                        'ldquo': 8220,
                        'rdquo': 8221,
                        'bdquo': 8222,
                        'dagger': 8224,
                        'Dagger': 8225,
                        'bull': 8226,
                        'hellip': 8230,
                        'permil': 8240,
                        'prime': 8242,
                        'Prime': 8243,
                        'lsaquo': 8249,
                        'rsaquo': 8250,
                        'oline': 8254,
                        'frasl': 8260,
                        'euro': 8364,
                        'image': 8465,
                        'weierp': 8472,
                        'real': 8476,
                        'trade': 8482,
                        'alefsym': 8501,
                        'larr': 8592,
                        'uarr': 8593,
                        'rarr': 8594,
                        'darr': 8595,
                        'harr': 8596,
                        'crarr': 8629,
                        'lArr': 8656,
                        'uArr': 8657,
                        'rArr': 8658,
                        'dArr': 8659,
                        'hArr': 8660,
                        'forall': 8704,
                        'part': 8706,
                        'exist': 8707,
                        'empty': 8709,
                        'nabla': 8711,
                        'isin': 8712,
                        'notin': 8713,
                        'ni': 8715,
                        'prod': 8719,
                        'sum': 8721,
                        'minus': 8722,
                        'lowast': 8727,
                        'radic': 8730,
                        'prop': 8733,
                        'infin': 8734,
                        'ang': 8736,
                        'and': 8743,
                        'or': 8744,
                        'cap': 8745,
                        'cup': 8746,
                        'int': 8747,
                        'there4': 8756,
                        'sim': 8764,
                        'cong': 8773,
                        'asymp': 8776,
                        'ne': 8800,
                        'equiv': 8801,
                        'le': 8804,
                        'ge': 8805,
                        'sub': 8834,
                        'sup': 8835,
                        'nsub': 8836,
                        'sube': 8838,
                        'supe': 8839,
                        'oplus': 8853,
                        'otimes': 8855,
                        'perp': 8869,
                        'sdot': 8901,
                        'lceil': 8968,
                        'rceil': 8969,
                        'lfloor': 8970,
                        'rfloor': 8971,
                        'lang': 9001,
                        'rang': 9002,
                        'loz': 9674,
                        'spades': 9824,
                        'clubs': 9827,
                        'hearts': 9829,
                        'diams': 9830
                    };
                    Object.keys(sax.ENTITIES).forEach(function(key) {
                        var e = sax.ENTITIES[key];
                        var s = typeof e === 'number' ? String.fromCharCode(e) : e;
                        sax.ENTITIES[key] = s;
                    });
                    for(var s in sax.STATE)sax.STATE[sax.STATE[s]] = s;
                    // shorthand
                    S = sax.STATE;
                    function emit(parser, event, data) {
                        parser[event] && parser[event](data);
                    }
                    function emitNode(parser, nodeType, data) {
                        if (parser.textNode) closeText(parser);
                        emit(parser, nodeType, data);
                    }
                    function closeText(parser) {
                        parser.textNode = textopts(parser.opt, parser.textNode);
                        if (parser.textNode) emit(parser, 'ontext', parser.textNode);
                        parser.textNode = '';
                    }
                    function textopts(opt, text) {
                        if (opt.trim) text = text.trim();
                        if (opt.normalize) text = text.replace(/\s+/g, ' ');
                        return text;
                    }
                    function error(parser, er) {
                        closeText(parser);
                        if (parser.trackPosition) er += '\nLine: ' + parser.line + '\nColumn: ' + parser.column + '\nChar: ' + parser.c;
                        er = new Error(er);
                        parser.error = er;
                        emit(parser, 'onerror', er);
                        return parser;
                    }
                    function end(parser) {
                        if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag');
                        if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) error(parser, 'Unexpected end');
                        closeText(parser);
                        parser.c = '';
                        parser.closed = true;
                        emit(parser, 'onend');
                        SAXParser.call(parser, parser.strict, parser.opt);
                        return parser;
                    }
                    function strictFail(parser, message) {
                        if (typeof parser !== 'object' || !(parser instanceof SAXParser)) throw new Error('bad call to strictFail');
                        if (parser.strict) error(parser, message);
                    }
                    function newTag(parser) {
                        if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
                        var parent = parser.tags[parser.tags.length - 1] || parser;
                        var tag = parser.tag = {
                            name: parser.tagName,
                            attributes: {}
                        };
                        // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
                        if (parser.opt.xmlns) tag.ns = parent.ns;
                        parser.attribList.length = 0;
                        emitNode(parser, 'onopentagstart', tag);
                    }
                    function qname(name, attribute) {
                        var i = name.indexOf(':');
                        var qualName = i < 0 ? [
                            '',
                            name
                        ] : name.split(':');
                        var prefix = qualName[0];
                        var local = qualName[1];
                        // <x "xmlns"="http://foo">
                        if (attribute && name === 'xmlns') {
                            prefix = 'xmlns';
                            local = '';
                        }
                        return {
                            prefix: prefix,
                            local: local
                        };
                    }
                    function attrib(parser) {
                        if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]();
                        if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
                            parser.attribName = parser.attribValue = '';
                            return;
                        }
                        if (parser.opt.xmlns) {
                            var qn = qname(parser.attribName, true);
                            var prefix = qn.prefix;
                            var local = qn.local;
                            if (prefix === 'xmlns') {
                                // namespace binding attribute. push the binding into scope
                                if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) strictFail(parser, 'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' + 'Actual: ' + parser.attribValue);
                                else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) strictFail(parser, 'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' + 'Actual: ' + parser.attribValue);
                                else {
                                    var tag = parser.tag;
                                    var parent = parser.tags[parser.tags.length - 1] || parser;
                                    if (tag.ns === parent.ns) tag.ns = Object.create(parent.ns);
                                    tag.ns[local] = parser.attribValue;
                                }
                            }
                            // defer onattribute events until all attributes have been seen
                            // so any new bindings can take effect. preserve attribute order
                            // so deferred events can be emitted in document order
                            parser.attribList.push([
                                parser.attribName,
                                parser.attribValue
                            ]);
                        } else {
                            // in non-xmlns mode, we can emit the event right away
                            parser.tag.attributes[parser.attribName] = parser.attribValue;
                            emitNode(parser, 'onattribute', {
                                name: parser.attribName,
                                value: parser.attribValue
                            });
                        }
                        parser.attribName = parser.attribValue = '';
                    }
                    function openTag(parser, selfClosing) {
                        if (parser.opt.xmlns) {
                            // emit namespace binding events
                            var tag = parser.tag;
                            // add namespace info to tag
                            var qn = qname(parser.tagName);
                            tag.prefix = qn.prefix;
                            tag.local = qn.local;
                            tag.uri = tag.ns[qn.prefix] || '';
                            if (tag.prefix && !tag.uri) {
                                strictFail(parser, 'Unbound namespace prefix: ' + JSON.stringify(parser.tagName));
                                tag.uri = qn.prefix;
                            }
                            var parent = parser.tags[parser.tags.length - 1] || parser;
                            if (tag.ns && parent.ns !== tag.ns) Object.keys(tag.ns).forEach(function(p) {
                                emitNode(parser, 'onopennamespace', {
                                    prefix: p,
                                    uri: tag.ns[p]
                                });
                            });
                            // handle deferred onattribute events
                            // Note: do not apply default ns to attributes:
                            //   http://www.w3.org/TR/REC-xml-names/#defaulting
                            for(var i = 0, l = parser.attribList.length; i < l; i++){
                                var nv = parser.attribList[i];
                                var name = nv[0];
                                var value = nv[1];
                                var qualName = qname(name, true);
                                var prefix = qualName.prefix;
                                var local = qualName.local;
                                var uri = prefix === '' ? '' : tag.ns[prefix] || '';
                                var a = {
                                    name: name,
                                    value: value,
                                    prefix: prefix,
                                    local: local,
                                    uri: uri
                                };
                                // if there's any attributes with an undefined namespace,
                                // then fail on them now.
                                if (prefix && prefix !== 'xmlns' && !uri) {
                                    strictFail(parser, 'Unbound namespace prefix: ' + JSON.stringify(prefix));
                                    a.uri = prefix;
                                }
                                parser.tag.attributes[name] = a;
                                emitNode(parser, 'onattribute', a);
                            }
                            parser.attribList.length = 0;
                        }
                        parser.tag.isSelfClosing = !!selfClosing;
                        // process the tag
                        parser.sawRoot = true;
                        parser.tags.push(parser.tag);
                        emitNode(parser, 'onopentag', parser.tag);
                        if (!selfClosing) {
                            // special case for <script> in non-strict mode.
                            if (!parser.noscript && parser.tagName.toLowerCase() === 'script') parser.state = S.SCRIPT;
                            else parser.state = S.TEXT;
                            parser.tag = null;
                            parser.tagName = '';
                        }
                        parser.attribName = parser.attribValue = '';
                        parser.attribList.length = 0;
                    }
                    function closeTag(parser) {
                        if (!parser.tagName) {
                            strictFail(parser, 'Weird empty close tag.');
                            parser.textNode += '</>';
                            parser.state = S.TEXT;
                            return;
                        }
                        if (parser.script) {
                            if (parser.tagName !== 'script') {
                                parser.script += '</' + parser.tagName + '>';
                                parser.tagName = '';
                                parser.state = S.SCRIPT;
                                return;
                            }
                            emitNode(parser, 'onscript', parser.script);
                            parser.script = '';
                        }
                        // first make sure that the closing tag actually exists.
                        // <a><b></c></b></a> will close everything, otherwise.
                        var t = parser.tags.length;
                        var tagName = parser.tagName;
                        if (!parser.strict) tagName = tagName[parser.looseCase]();
                        var closeTo = tagName;
                        while(t--){
                            var close = parser.tags[t];
                            if (close.name !== closeTo) // fail the first time in strict mode
                            strictFail(parser, 'Unexpected close tag');
                            else break;
                        }
                        // didn't find it.  we already failed for strict, so just abort.
                        if (t < 0) {
                            strictFail(parser, 'Unmatched closing tag: ' + parser.tagName);
                            parser.textNode += '</' + parser.tagName + '>';
                            parser.state = S.TEXT;
                            return;
                        }
                        parser.tagName = tagName;
                        var s = parser.tags.length;
                        while(s-- > t){
                            var tag = parser.tag = parser.tags.pop();
                            parser.tagName = parser.tag.name;
                            emitNode(parser, 'onclosetag', parser.tagName);
                            var x = {};
                            for(var i in tag.ns)x[i] = tag.ns[i];
                            var parent = parser.tags[parser.tags.length - 1] || parser;
                            if (parser.opt.xmlns && tag.ns !== parent.ns) // remove namespace bindings introduced by tag
                            Object.keys(tag.ns).forEach(function(p) {
                                var n = tag.ns[p];
                                emitNode(parser, 'onclosenamespace', {
                                    prefix: p,
                                    uri: n
                                });
                            });
                        }
                        if (t === 0) parser.closedRoot = true;
                        parser.tagName = parser.attribValue = parser.attribName = '';
                        parser.attribList.length = 0;
                        parser.state = S.TEXT;
                    }
                    function parseEntity(parser) {
                        var entity = parser.entity;
                        var entityLC = entity.toLowerCase();
                        var num;
                        var numStr = '';
                        if (parser.ENTITIES[entity]) return parser.ENTITIES[entity];
                        if (parser.ENTITIES[entityLC]) return parser.ENTITIES[entityLC];
                        entity = entityLC;
                        if (entity.charAt(0) === '#') {
                            if (entity.charAt(1) === 'x') {
                                entity = entity.slice(2);
                                num = parseInt(entity, 16);
                                numStr = num.toString(16);
                            } else {
                                entity = entity.slice(1);
                                num = parseInt(entity, 10);
                                numStr = num.toString(10);
                            }
                        }
                        entity = entity.replace(/^0+/, '');
                        if (isNaN(num) || numStr.toLowerCase() !== entity) {
                            strictFail(parser, 'Invalid character entity');
                            return '&' + parser.entity + ';';
                        }
                        return String.fromCodePoint(num);
                    }
                    function beginWhiteSpace(parser, c) {
                        if (c === '<') {
                            parser.state = S.OPEN_WAKA;
                            parser.startTagPosition = parser.position;
                        } else if (!isWhitespace(c)) {
                            // have to process this as a text node.
                            // weird, but happens.
                            strictFail(parser, 'Non-whitespace before first tag.');
                            parser.textNode = c;
                            parser.state = S.TEXT;
                        }
                    }
                    function charAt(chunk, i) {
                        var result = '';
                        if (i < chunk.length) result = chunk.charAt(i);
                        return result;
                    }
                    function write(chunk) {
                        var parser = this;
                        if (this.error) throw this.error;
                        if (parser.closed) return error(parser, 'Cannot write after close. Assign an onready handler.');
                        if (chunk === null) return end(parser);
                        if (typeof chunk === 'object') chunk = chunk.toString();
                        var i = 0;
                        var c = '';
                        while(true){
                            c = charAt(chunk, i++);
                            parser.c = c;
                            if (!c) break;
                            if (parser.trackPosition) {
                                parser.position++;
                                if (c === '\n') {
                                    parser.line++;
                                    parser.column = 0;
                                } else parser.column++;
                            }
                            switch(parser.state){
                                case S.BEGIN:
                                    parser.state = S.BEGIN_WHITESPACE;
                                    if (c === '\uFEFF') continue;
                                    beginWhiteSpace(parser, c);
                                    continue;
                                case S.BEGIN_WHITESPACE:
                                    beginWhiteSpace(parser, c);
                                    continue;
                                case S.TEXT:
                                    if (parser.sawRoot && !parser.closedRoot) {
                                        var starti = i - 1;
                                        while(c && c !== '<' && c !== '&'){
                                            c = charAt(chunk, i++);
                                            if (c && parser.trackPosition) {
                                                parser.position++;
                                                if (c === '\n') {
                                                    parser.line++;
                                                    parser.column = 0;
                                                } else parser.column++;
                                            }
                                        }
                                        parser.textNode += chunk.substring(starti, i - 1);
                                    }
                                    if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
                                        parser.state = S.OPEN_WAKA;
                                        parser.startTagPosition = parser.position;
                                    } else {
                                        if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) strictFail(parser, 'Text data outside of root node.');
                                        if (c === '&') parser.state = S.TEXT_ENTITY;
                                        else parser.textNode += c;
                                    }
                                    continue;
                                case S.SCRIPT:
                                    // only non-strict
                                    if (c === '<') parser.state = S.SCRIPT_ENDING;
                                    else parser.script += c;
                                    continue;
                                case S.SCRIPT_ENDING:
                                    if (c === '/') parser.state = S.CLOSE_TAG;
                                    else {
                                        parser.script += '<' + c;
                                        parser.state = S.SCRIPT;
                                    }
                                    continue;
                                case S.OPEN_WAKA:
                                    // either a /, ?, !, or text is coming next.
                                    if (c === '!') {
                                        parser.state = S.SGML_DECL;
                                        parser.sgmlDecl = '';
                                    } else if (isWhitespace(c)) ;
                                    else if (isMatch(nameStart, c)) {
                                        parser.state = S.OPEN_TAG;
                                        parser.tagName = c;
                                    } else if (c === '/') {
                                        parser.state = S.CLOSE_TAG;
                                        parser.tagName = '';
                                    } else if (c === '?') {
                                        parser.state = S.PROC_INST;
                                        parser.procInstName = parser.procInstBody = '';
                                    } else {
                                        strictFail(parser, 'Unencoded <');
                                        // if there was some whitespace, then add that in.
                                        if (parser.startTagPosition + 1 < parser.position) {
                                            var pad = parser.position - parser.startTagPosition;
                                            c = new Array(pad).join(' ') + c;
                                        }
                                        parser.textNode += '<' + c;
                                        parser.state = S.TEXT;
                                    }
                                    continue;
                                case S.SGML_DECL:
                                    if (parser.sgmlDecl + c === '--') {
                                        parser.state = S.COMMENT;
                                        parser.comment = '';
                                        parser.sgmlDecl = '';
                                        continue;
                                    }
                                    if (parser.doctype && parser.doctype !== true && parser.sgmlDecl) {
                                        parser.state = S.DOCTYPE_DTD;
                                        parser.doctype += '<!' + parser.sgmlDecl + c;
                                        parser.sgmlDecl = '';
                                    } else if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
                                        emitNode(parser, 'onopencdata');
                                        parser.state = S.CDATA;
                                        parser.sgmlDecl = '';
                                        parser.cdata = '';
                                    } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
                                        parser.state = S.DOCTYPE;
                                        if (parser.doctype || parser.sawRoot) strictFail(parser, 'Inappropriately located doctype declaration');
                                        parser.doctype = '';
                                        parser.sgmlDecl = '';
                                    } else if (c === '>') {
                                        emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl);
                                        parser.sgmlDecl = '';
                                        parser.state = S.TEXT;
                                    } else if (isQuote(c)) {
                                        parser.state = S.SGML_DECL_QUOTED;
                                        parser.sgmlDecl += c;
                                    } else parser.sgmlDecl += c;
                                    continue;
                                case S.SGML_DECL_QUOTED:
                                    if (c === parser.q) {
                                        parser.state = S.SGML_DECL;
                                        parser.q = '';
                                    }
                                    parser.sgmlDecl += c;
                                    continue;
                                case S.DOCTYPE:
                                    if (c === '>') {
                                        parser.state = S.TEXT;
                                        emitNode(parser, 'ondoctype', parser.doctype);
                                        parser.doctype = true // just remember that we saw it.
                                        ;
                                    } else {
                                        parser.doctype += c;
                                        if (c === '[') parser.state = S.DOCTYPE_DTD;
                                        else if (isQuote(c)) {
                                            parser.state = S.DOCTYPE_QUOTED;
                                            parser.q = c;
                                        }
                                    }
                                    continue;
                                case S.DOCTYPE_QUOTED:
                                    parser.doctype += c;
                                    if (c === parser.q) {
                                        parser.q = '';
                                        parser.state = S.DOCTYPE;
                                    }
                                    continue;
                                case S.DOCTYPE_DTD:
                                    if (c === ']') {
                                        parser.doctype += c;
                                        parser.state = S.DOCTYPE;
                                    } else if (c === '<') {
                                        parser.state = S.OPEN_WAKA;
                                        parser.startTagPosition = parser.position;
                                    } else if (isQuote(c)) {
                                        parser.doctype += c;
                                        parser.state = S.DOCTYPE_DTD_QUOTED;
                                        parser.q = c;
                                    } else parser.doctype += c;
                                    continue;
                                case S.DOCTYPE_DTD_QUOTED:
                                    parser.doctype += c;
                                    if (c === parser.q) {
                                        parser.state = S.DOCTYPE_DTD;
                                        parser.q = '';
                                    }
                                    continue;
                                case S.COMMENT:
                                    if (c === '-') parser.state = S.COMMENT_ENDING;
                                    else parser.comment += c;
                                    continue;
                                case S.COMMENT_ENDING:
                                    if (c === '-') {
                                        parser.state = S.COMMENT_ENDED;
                                        parser.comment = textopts(parser.opt, parser.comment);
                                        if (parser.comment) emitNode(parser, 'oncomment', parser.comment);
                                        parser.comment = '';
                                    } else {
                                        parser.comment += '-' + c;
                                        parser.state = S.COMMENT;
                                    }
                                    continue;
                                case S.COMMENT_ENDED:
                                    if (c !== '>') {
                                        strictFail(parser, 'Malformed comment');
                                        // allow <!-- blah -- bloo --> in non-strict mode,
                                        // which is a comment of " blah -- bloo "
                                        parser.comment += '--' + c;
                                        parser.state = S.COMMENT;
                                    } else if (parser.doctype && parser.doctype !== true) parser.state = S.DOCTYPE_DTD;
                                    else parser.state = S.TEXT;
                                    continue;
                                case S.CDATA:
                                    if (c === ']') parser.state = S.CDATA_ENDING;
                                    else parser.cdata += c;
                                    continue;
                                case S.CDATA_ENDING:
                                    if (c === ']') parser.state = S.CDATA_ENDING_2;
                                    else {
                                        parser.cdata += ']' + c;
                                        parser.state = S.CDATA;
                                    }
                                    continue;
                                case S.CDATA_ENDING_2:
                                    if (c === '>') {
                                        if (parser.cdata) emitNode(parser, 'oncdata', parser.cdata);
                                        emitNode(parser, 'onclosecdata');
                                        parser.cdata = '';
                                        parser.state = S.TEXT;
                                    } else if (c === ']') parser.cdata += ']';
                                    else {
                                        parser.cdata += ']]' + c;
                                        parser.state = S.CDATA;
                                    }
                                    continue;
                                case S.PROC_INST:
                                    if (c === '?') parser.state = S.PROC_INST_ENDING;
                                    else if (isWhitespace(c)) parser.state = S.PROC_INST_BODY;
                                    else parser.procInstName += c;
                                    continue;
                                case S.PROC_INST_BODY:
                                    if (!parser.procInstBody && isWhitespace(c)) continue;
                                    else if (c === '?') parser.state = S.PROC_INST_ENDING;
                                    else parser.procInstBody += c;
                                    continue;
                                case S.PROC_INST_ENDING:
                                    if (c === '>') {
                                        emitNode(parser, 'onprocessinginstruction', {
                                            name: parser.procInstName,
                                            body: parser.procInstBody
                                        });
                                        parser.procInstName = parser.procInstBody = '';
                                        parser.state = S.TEXT;
                                    } else {
                                        parser.procInstBody += '?' + c;
                                        parser.state = S.PROC_INST_BODY;
                                    }
                                    continue;
                                case S.OPEN_TAG:
                                    if (isMatch(nameBody, c)) parser.tagName += c;
                                    else {
                                        newTag(parser);
                                        if (c === '>') openTag(parser);
                                        else if (c === '/') parser.state = S.OPEN_TAG_SLASH;
                                        else {
                                            if (!isWhitespace(c)) strictFail(parser, 'Invalid character in tag name');
                                            parser.state = S.ATTRIB;
                                        }
                                    }
                                    continue;
                                case S.OPEN_TAG_SLASH:
                                    if (c === '>') {
                                        openTag(parser, true);
                                        closeTag(parser);
                                    } else {
                                        strictFail(parser, 'Forward-slash in opening tag not followed by >');
                                        parser.state = S.ATTRIB;
                                    }
                                    continue;
                                case S.ATTRIB:
                                    // haven't read the attribute name yet.
                                    if (isWhitespace(c)) continue;
                                    else if (c === '>') openTag(parser);
                                    else if (c === '/') parser.state = S.OPEN_TAG_SLASH;
                                    else if (isMatch(nameStart, c)) {
                                        parser.attribName = c;
                                        parser.attribValue = '';
                                        parser.state = S.ATTRIB_NAME;
                                    } else strictFail(parser, 'Invalid attribute name');
                                    continue;
                                case S.ATTRIB_NAME:
                                    if (c === '=') parser.state = S.ATTRIB_VALUE;
                                    else if (c === '>') {
                                        strictFail(parser, 'Attribute without value');
                                        parser.attribValue = parser.attribName;
                                        attrib(parser);
                                        openTag(parser);
                                    } else if (isWhitespace(c)) parser.state = S.ATTRIB_NAME_SAW_WHITE;
                                    else if (isMatch(nameBody, c)) parser.attribName += c;
                                    else strictFail(parser, 'Invalid attribute name');
                                    continue;
                                case S.ATTRIB_NAME_SAW_WHITE:
                                    if (c === '=') parser.state = S.ATTRIB_VALUE;
                                    else if (isWhitespace(c)) continue;
                                    else {
                                        strictFail(parser, 'Attribute without value');
                                        parser.tag.attributes[parser.attribName] = '';
                                        parser.attribValue = '';
                                        emitNode(parser, 'onattribute', {
                                            name: parser.attribName,
                                            value: ''
                                        });
                                        parser.attribName = '';
                                        if (c === '>') openTag(parser);
                                        else if (isMatch(nameStart, c)) {
                                            parser.attribName = c;
                                            parser.state = S.ATTRIB_NAME;
                                        } else {
                                            strictFail(parser, 'Invalid attribute name');
                                            parser.state = S.ATTRIB;
                                        }
                                    }
                                    continue;
                                case S.ATTRIB_VALUE:
                                    if (isWhitespace(c)) continue;
                                    else if (isQuote(c)) {
                                        parser.q = c;
                                        parser.state = S.ATTRIB_VALUE_QUOTED;
                                    } else {
                                        if (!parser.opt.unquotedAttributeValues) error(parser, 'Unquoted attribute value');
                                        parser.state = S.ATTRIB_VALUE_UNQUOTED;
                                        parser.attribValue = c;
                                    }
                                    continue;
                                case S.ATTRIB_VALUE_QUOTED:
                                    if (c !== parser.q) {
                                        if (c === '&') parser.state = S.ATTRIB_VALUE_ENTITY_Q;
                                        else parser.attribValue += c;
                                        continue;
                                    }
                                    attrib(parser);
                                    parser.q = '';
                                    parser.state = S.ATTRIB_VALUE_CLOSED;
                                    continue;
                                case S.ATTRIB_VALUE_CLOSED:
                                    if (isWhitespace(c)) parser.state = S.ATTRIB;
                                    else if (c === '>') openTag(parser);
                                    else if (c === '/') parser.state = S.OPEN_TAG_SLASH;
                                    else if (isMatch(nameStart, c)) {
                                        strictFail(parser, 'No whitespace between attributes');
                                        parser.attribName = c;
                                        parser.attribValue = '';
                                        parser.state = S.ATTRIB_NAME;
                                    } else strictFail(parser, 'Invalid attribute name');
                                    continue;
                                case S.ATTRIB_VALUE_UNQUOTED:
                                    if (!isAttribEnd(c)) {
                                        if (c === '&') parser.state = S.ATTRIB_VALUE_ENTITY_U;
                                        else parser.attribValue += c;
                                        continue;
                                    }
                                    attrib(parser);
                                    if (c === '>') openTag(parser);
                                    else parser.state = S.ATTRIB;
                                    continue;
                                case S.CLOSE_TAG:
                                    if (!parser.tagName) {
                                        if (isWhitespace(c)) continue;
                                        else if (notMatch(nameStart, c)) {
                                            if (parser.script) {
                                                parser.script += '</' + c;
                                                parser.state = S.SCRIPT;
                                            } else strictFail(parser, 'Invalid tagname in closing tag.');
                                        } else parser.tagName = c;
                                    } else if (c === '>') closeTag(parser);
                                    else if (isMatch(nameBody, c)) parser.tagName += c;
                                    else if (parser.script) {
                                        parser.script += '</' + parser.tagName;
                                        parser.tagName = '';
                                        parser.state = S.SCRIPT;
                                    } else {
                                        if (!isWhitespace(c)) strictFail(parser, 'Invalid tagname in closing tag');
                                        parser.state = S.CLOSE_TAG_SAW_WHITE;
                                    }
                                    continue;
                                case S.CLOSE_TAG_SAW_WHITE:
                                    if (isWhitespace(c)) continue;
                                    if (c === '>') closeTag(parser);
                                    else strictFail(parser, 'Invalid characters in closing tag');
                                    continue;
                                case S.TEXT_ENTITY:
                                case S.ATTRIB_VALUE_ENTITY_Q:
                                case S.ATTRIB_VALUE_ENTITY_U:
                                    var returnState;
                                    var buffer;
                                    switch(parser.state){
                                        case S.TEXT_ENTITY:
                                            returnState = S.TEXT;
                                            buffer = 'textNode';
                                            break;
                                        case S.ATTRIB_VALUE_ENTITY_Q:
                                            returnState = S.ATTRIB_VALUE_QUOTED;
                                            buffer = 'attribValue';
                                            break;
                                        case S.ATTRIB_VALUE_ENTITY_U:
                                            returnState = S.ATTRIB_VALUE_UNQUOTED;
                                            buffer = 'attribValue';
                                            break;
                                    }
                                    if (c === ';') {
                                        var parsedEntity = parseEntity(parser);
                                        if (parser.opt.unparsedEntities && !Object.values(sax.XML_ENTITIES).includes(parsedEntity)) {
                                            parser.entity = '';
                                            parser.state = returnState;
                                            parser.write(parsedEntity);
                                        } else {
                                            parser[buffer] += parsedEntity;
                                            parser.entity = '';
                                            parser.state = returnState;
                                        }
                                    } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) parser.entity += c;
                                    else {
                                        strictFail(parser, 'Invalid character in entity name');
                                        parser[buffer] += '&' + parser.entity + c;
                                        parser.entity = '';
                                        parser.state = returnState;
                                    }
                                    continue;
                                default:
                                    throw new Error(parser, 'Unknown state: ' + parser.state);
                            }
                        } // while
                        if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser);
                        return parser;
                    }
                    /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */ /* istanbul ignore next */ if (!String.fromCodePoint) (function() {
                        var stringFromCharCode = String.fromCharCode;
                        var floor = Math.floor;
                        var fromCodePoint = function() {
                            var MAX_SIZE = 0x4000;
                            var codeUnits = [];
                            var highSurrogate;
                            var lowSurrogate;
                            var index = -1;
                            var length = arguments.length;
                            if (!length) return '';
                            var result = '';
                            while(++index < length){
                                var codePoint = Number(arguments[index]);
                                if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                                codePoint < 0 || // not a valid Unicode code point
                                codePoint > 0x10FFFF || // not a valid Unicode code point
                                floor(codePoint) !== codePoint // not an integer
                                ) throw RangeError('Invalid code point: ' + codePoint);
                                if (codePoint <= 0xFFFF) codeUnits.push(codePoint);
                                else {
                                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                                    codePoint -= 0x10000;
                                    highSurrogate = (codePoint >> 10) + 0xD800;
                                    lowSurrogate = codePoint % 0x400 + 0xDC00;
                                    codeUnits.push(highSurrogate, lowSurrogate);
                                }
                                if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                                    result += stringFromCharCode.apply(null, codeUnits);
                                    codeUnits.length = 0;
                                }
                            }
                            return result;
                        };
                        /* istanbul ignore next */ if (Object.defineProperty) Object.defineProperty(String, 'fromCodePoint', {
                            value: fromCodePoint,
                            configurable: true,
                            writable: true
                        });
                        else String.fromCodePoint = fromCodePoint;
                    })();
                })(exports);
            /***/ },
            /***/ 61807: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    /**
   * A noop padding strategy.
   */ CryptoJS.pad.NoPadding = {
                        pad: function pad() {},
                        unpad: function unpad() {}
                    };
                    return CryptoJS.pad.NoPadding;
                });
            /***/ },
            /***/ 61900: /***/ function(module1) {
                module1.exports = function(exec) {
                    try {
                        return {
                            error: false,
                            value: exec()
                        };
                    } catch (error) {
                        return {
                            error: true,
                            value: error
                        };
                    }
                };
            /***/ },
            /***/ 61909: /***/ function(module1) {
                "use strict";
                /** @type {import('./reflectApply')} */ module1.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;
            /***/ },
            /***/ 62046: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var createHTML = __webpack_require__(91159);
                var forcedStringHTMLMethod = __webpack_require__(7452);
                // `String.prototype.italics` method
                // https://tc39.es/ecma262/#sec-string.prototype.italics
                $({
                    target: 'String',
                    proto: true,
                    forced: forcedStringHTMLMethod('italics')
                }, {
                    italics: function italics() {
                        return createHTML(this, 'i', '', '');
                    }
                });
            /***/ },
            /***/ 62148: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var uncurryThis = __webpack_require__(38347);
                var hiddenKeys = __webpack_require__(90682);
                var isObject = __webpack_require__(24517);
                var hasOwn = __webpack_require__(20340);
                var defineProperty = __webpack_require__(95892).f;
                var getOwnPropertyNamesModule = __webpack_require__(6611);
                var getOwnPropertyNamesExternalModule = __webpack_require__(8807);
                var uid = __webpack_require__(46859);
                var FREEZING = __webpack_require__(55481);
                var REQUIRED = false;
                var METADATA = uid('meta');
                var id = 0;
                // eslint-disable-next-line es/no-object-isextensible -- safe
                var isExtensible = Object.isExtensible || function() {
                    return true;
                };
                var setMetadata = function(it) {
                    defineProperty(it, METADATA, {
                        value: {
                            objectID: 'O' + id++,
                            weakData: {} // weak collections IDs
                        }
                    });
                };
                var fastKey = function(it, create) {
                    // return a primitive with prefix
                    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
                    if (!hasOwn(it, METADATA)) {
                        // can't set metadata to uncaught frozen object
                        if (!isExtensible(it)) return 'F';
                        // not necessary to add metadata
                        if (!create) return 'E';
                        // add missing metadata
                        setMetadata(it);
                    // return object ID
                    }
                    return it[METADATA].objectID;
                };
                var getWeakData = function(it, create) {
                    if (!hasOwn(it, METADATA)) {
                        // can't set metadata to uncaught frozen object
                        if (!isExtensible(it)) return true;
                        // not necessary to add metadata
                        if (!create) return false;
                        // add missing metadata
                        setMetadata(it);
                    // return the store of weak collections IDs
                    }
                    return it[METADATA].weakData;
                };
                // add metadata on freeze-family methods calling
                var onFreeze = function(it) {
                    if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
                    return it;
                };
                var enable = function() {
                    meta.enable = function() {};
                    REQUIRED = true;
                    var getOwnPropertyNames = getOwnPropertyNamesModule.f;
                    var splice = uncurryThis([].splice);
                    var test = {};
                    test[METADATA] = 1;
                    // prevent exposing of metadata key
                    if (getOwnPropertyNames(test).length) {
                        getOwnPropertyNamesModule.f = function(it) {
                            var result = getOwnPropertyNames(it);
                            for(var i = 0, length = result.length; i < length; i++)if (result[i] === METADATA) {
                                splice(result, i, 1);
                                break;
                            }
                            return result;
                        };
                        $({
                            target: 'Object',
                            stat: true,
                            forced: true
                        }, {
                            getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
                        });
                    }
                };
                var meta = module1.exports = {
                    enable: enable,
                    fastKey: fastKey,
                    getWeakData: getWeakData,
                    onFreeze: onFreeze
                };
                hiddenKeys[METADATA] = true;
            /***/ },
            /***/ 62256: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(20731);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    /**
   * Cipher Feedback block mode.
   */ CryptoJS.mode.CFB = function() {
                        var CFB = CryptoJS.lib.BlockCipherMode.extend();
                        CFB.Encryptor = CFB.extend({
                            processBlock: function processBlock(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                                // Remember this block to use with next block
                                this._prevBlock = words.slice(offset, offset + blockSize);
                            }
                        });
                        CFB.Decryptor = CFB.extend({
                            processBlock: function processBlock(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                // Remember this block to use with next block
                                var thisBlock = words.slice(offset, offset + blockSize);
                                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                                // This block becomes the previous block
                                this._prevBlock = thisBlock;
                            }
                        });
                        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
                            var keystream;
                            // Shortcut
                            var iv = this._iv;
                            // Generate keystream
                            if (iv) {
                                keystream = iv.slice(0);
                                // Remove IV for subsequent blocks
                                this._iv = undefined;
                            } else keystream = this._prevBlock;
                            cipher.encryptBlock(keystream, 0);
                            // Encrypt
                            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                        }
                        return CFB;
                    }();
                    return CryptoJS.mode.CFB;
                });
            /***/ },
            /***/ 62420: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(18756);
                exports.EncodeStream = __webpack_require__(95291);
                exports.DecodeStream = __webpack_require__(69591);
                exports.Array = __webpack_require__(68332);
                exports.LazyArray = __webpack_require__(11610);
                exports.Bitfield = __webpack_require__(60480);
                exports.Boolean = __webpack_require__(75041);
                exports.Buffer = __webpack_require__(56711);
                exports.Enum = __webpack_require__(36316);
                exports.Optional = __webpack_require__(64241);
                exports.Reserved = __webpack_require__(13549);
                exports.String = __webpack_require__(52676);
                exports.Struct = __webpack_require__(88152);
                exports.VersionedStruct = __webpack_require__(99757);
                var utils = __webpack_require__(18128);
                var NumberT = __webpack_require__(56128);
                var Pointer = __webpack_require__(9324);
                Object.assign(exports, utils, NumberT, Pointer);
            /***/ },
            /***/ 62514: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var uncurryThis = __webpack_require__(38347);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var $join = uncurryThis([].join);
                // `%TypedArray%.prototype.join` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
                exportTypedArrayMethod('join', function join(separator) {
                    return $join(aTypedArray(this), separator);
                });
            /***/ },
            /***/ 63249: /***/ function(module1) {
                "use strict";
                var numberIsNaN = function(value) {
                    return value !== value;
                };
                module1.exports = function is(a, b) {
                    if (a === 0 && b === 0) return 1 / a === 1 / b;
                    if (a === b) return true;
                    if (numberIsNaN(a) && numberIsNaN(b)) return true;
                    return false;
                };
            /***/ },
            /***/ 63432: /***/ function(module1) {
                module1.exports = false;
            /***/ },
            /***/ 63779: /***/ function() {
            /* (ignored) */ /***/ },
            /***/ 63918: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toPrimitive = __webpack_require__(2644);
                var isSymbol = __webpack_require__(46290);
                // `ToPropertyKey` abstract operation
                // https://tc39.es/ecma262/#sec-topropertykey
                module1.exports = function(argument) {
                    var key = toPrimitive(argument, 'string');
                    return isSymbol(key) ? key : key + '';
                };
            /***/ },
            /***/ 64241: /***/ function(module1) {
                "use strict";
                var Optional = /*#__PURE__*/ function() {
                    function Optional(type, condition) {
                        if (condition === void 0) condition = true;
                        this.type = type;
                        this.condition = condition;
                    }
                    var _proto = Optional.prototype;
                    _proto.decode = function decode(stream, parent) {
                        var condition = this.condition;
                        if (typeof condition === 'function') condition = condition.call(parent, parent);
                        if (condition) return this.type.decode(stream, parent);
                    };
                    _proto.size = function size(val, parent) {
                        var condition = this.condition;
                        if (typeof condition === 'function') condition = condition.call(parent, parent);
                        if (condition) return this.type.size(val, parent);
                        else return 0;
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        var condition = this.condition;
                        if (typeof condition === 'function') condition = condition.call(parent, parent);
                        if (condition) return this.type.encode(stream, val, parent);
                    };
                    return Optional;
                }();
                module1.exports = Optional;
            /***/ },
            /***/ 64384: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                // `globalThis` object
                // https://tc39.es/ecma262/#sec-globalthis
                $({
                    global: true
                }, {
                    globalThis: global
                });
            /***/ },
            /***/ 64397: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                // IEEE754 conversions based on https://github.com/feross/ieee754
                var global = __webpack_require__(32010);
                var Array1 = global.Array;
                var abs = Math.abs;
                var pow = Math.pow;
                var floor = Math.floor;
                var log = Math.log;
                var LN2 = Math.LN2;
                var pack = function(number, mantissaLength, bytes) {
                    var buffer = Array1(bytes);
                    var exponentLength = bytes * 8 - mantissaLength - 1;
                    var eMax = (1 << exponentLength) - 1;
                    var eBias = eMax >> 1;
                    var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
                    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
                    var index = 0;
                    var exponent, mantissa, c;
                    number = abs(number);
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (number != number || number === Infinity) {
                        // eslint-disable-next-line no-self-compare -- NaN check
                        mantissa = number != number ? 1 : 0;
                        exponent = eMax;
                    } else {
                        exponent = floor(log(number) / LN2);
                        if (number * (c = pow(2, -exponent)) < 1) {
                            exponent--;
                            c *= 2;
                        }
                        if (exponent + eBias >= 1) number += rt / c;
                        else number += rt * pow(2, 1 - eBias);
                        if (number * c >= 2) {
                            exponent++;
                            c /= 2;
                        }
                        if (exponent + eBias >= eMax) {
                            mantissa = 0;
                            exponent = eMax;
                        } else if (exponent + eBias >= 1) {
                            mantissa = (number * c - 1) * pow(2, mantissaLength);
                            exponent = exponent + eBias;
                        } else {
                            mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
                            exponent = 0;
                        }
                    }
                    for(; mantissaLength >= 8; buffer[index++] = mantissa & 255, mantissa /= 256, mantissaLength -= 8);
                    exponent = exponent << mantissaLength | mantissa;
                    exponentLength += mantissaLength;
                    for(; exponentLength > 0; buffer[index++] = exponent & 255, exponent /= 256, exponentLength -= 8);
                    buffer[--index] |= sign * 128;
                    return buffer;
                };
                var unpack = function(buffer, mantissaLength) {
                    var bytes = buffer.length;
                    var exponentLength = bytes * 8 - mantissaLength - 1;
                    var eMax = (1 << exponentLength) - 1;
                    var eBias = eMax >> 1;
                    var nBits = exponentLength - 7;
                    var index = bytes - 1;
                    var sign = buffer[index--];
                    var exponent = sign & 127;
                    var mantissa;
                    sign >>= 7;
                    for(; nBits > 0; exponent = exponent * 256 + buffer[index], index--, nBits -= 8);
                    mantissa = exponent & (1 << -nBits) - 1;
                    exponent >>= -nBits;
                    nBits += mantissaLength;
                    for(; nBits > 0; mantissa = mantissa * 256 + buffer[index], index--, nBits -= 8);
                    if (exponent === 0) exponent = 1 - eBias;
                    else if (exponent === eMax) return mantissa ? NaN : sign ? -Infinity : Infinity;
                    else {
                        mantissa = mantissa + pow(2, mantissaLength);
                        exponent = exponent - eBias;
                    }
                    return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
                };
                module1.exports = {
                    pack: pack,
                    unpack: unpack
                };
            /***/ },
            /***/ 64429: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var hasOwn = __webpack_require__(20340);
                var toIndexedObject = __webpack_require__(98086);
                var indexOf = __webpack_require__(12636).indexOf;
                var hiddenKeys = __webpack_require__(90682);
                var push = uncurryThis([].push);
                module1.exports = function(object, names) {
                    var O = toIndexedObject(object);
                    var i = 0;
                    var result = [];
                    var key;
                    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
                    // Don't enum bug & hidden keys
                    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
                    return result;
                };
            /***/ },
            /***/ 64607: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var define = __webpack_require__(77802);
                var callBind = __webpack_require__(26601);
                var implementation = __webpack_require__(83089);
                var getPolyfill = __webpack_require__(7844);
                var shim = __webpack_require__(51374);
                var flagsBound = callBind(getPolyfill());
                define(flagsBound, {
                    getPolyfill: getPolyfill,
                    implementation: implementation,
                    shim: shim
                });
                module1.exports = flagsBound;
            /***/ },
            /***/ 64654: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(1593);
            /***/ },
            /***/ 64781: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* module decorator */ module1 = __webpack_require__.nmd(module1);
                __webpack_require__(39081);
                __webpack_require__(41584);
                __webpack_require__(81755);
                __webpack_require__(20731);
                __webpack_require__(24863);
                __webpack_require__(7283);
                __webpack_require__(37309);
                __webpack_require__(14032);
                __webpack_require__(61726);
                __webpack_require__(6422);
                __webpack_require__(46467);
                __webpack_require__(7851);
                __webpack_require__(72095);
                __webpack_require__(47259);
                __webpack_require__(1083);
                __webpack_require__(94712);
                var SVGtoPDF = function SVGtoPDF(doc, svg, x, y, options) {
                    "use strict";
                    var NamedColors = {
                        aliceblue: [
                            240,
                            248,
                            255
                        ],
                        antiquewhite: [
                            250,
                            235,
                            215
                        ],
                        aqua: [
                            0,
                            255,
                            255
                        ],
                        aquamarine: [
                            127,
                            255,
                            212
                        ],
                        azure: [
                            240,
                            255,
                            255
                        ],
                        beige: [
                            245,
                            245,
                            220
                        ],
                        bisque: [
                            255,
                            228,
                            196
                        ],
                        black: [
                            0,
                            0,
                            0
                        ],
                        blanchedalmond: [
                            255,
                            235,
                            205
                        ],
                        blue: [
                            0,
                            0,
                            255
                        ],
                        blueviolet: [
                            138,
                            43,
                            226
                        ],
                        brown: [
                            165,
                            42,
                            42
                        ],
                        burlywood: [
                            222,
                            184,
                            135
                        ],
                        cadetblue: [
                            95,
                            158,
                            160
                        ],
                        chartreuse: [
                            127,
                            255,
                            0
                        ],
                        chocolate: [
                            210,
                            105,
                            30
                        ],
                        coral: [
                            255,
                            127,
                            80
                        ],
                        cornflowerblue: [
                            100,
                            149,
                            237
                        ],
                        cornsilk: [
                            255,
                            248,
                            220
                        ],
                        crimson: [
                            220,
                            20,
                            60
                        ],
                        cyan: [
                            0,
                            255,
                            255
                        ],
                        darkblue: [
                            0,
                            0,
                            139
                        ],
                        darkcyan: [
                            0,
                            139,
                            139
                        ],
                        darkgoldenrod: [
                            184,
                            134,
                            11
                        ],
                        darkgray: [
                            169,
                            169,
                            169
                        ],
                        darkgrey: [
                            169,
                            169,
                            169
                        ],
                        darkgreen: [
                            0,
                            100,
                            0
                        ],
                        darkkhaki: [
                            189,
                            183,
                            107
                        ],
                        darkmagenta: [
                            139,
                            0,
                            139
                        ],
                        darkolivegreen: [
                            85,
                            107,
                            47
                        ],
                        darkorange: [
                            255,
                            140,
                            0
                        ],
                        darkorchid: [
                            153,
                            50,
                            204
                        ],
                        darkred: [
                            139,
                            0,
                            0
                        ],
                        darksalmon: [
                            233,
                            150,
                            122
                        ],
                        darkseagreen: [
                            143,
                            188,
                            143
                        ],
                        darkslateblue: [
                            72,
                            61,
                            139
                        ],
                        darkslategray: [
                            47,
                            79,
                            79
                        ],
                        darkslategrey: [
                            47,
                            79,
                            79
                        ],
                        darkturquoise: [
                            0,
                            206,
                            209
                        ],
                        darkviolet: [
                            148,
                            0,
                            211
                        ],
                        deeppink: [
                            255,
                            20,
                            147
                        ],
                        deepskyblue: [
                            0,
                            191,
                            255
                        ],
                        dimgray: [
                            105,
                            105,
                            105
                        ],
                        dimgrey: [
                            105,
                            105,
                            105
                        ],
                        dodgerblue: [
                            30,
                            144,
                            255
                        ],
                        firebrick: [
                            178,
                            34,
                            34
                        ],
                        floralwhite: [
                            255,
                            250,
                            240
                        ],
                        forestgreen: [
                            34,
                            139,
                            34
                        ],
                        fuchsia: [
                            255,
                            0,
                            255
                        ],
                        gainsboro: [
                            220,
                            220,
                            220
                        ],
                        ghostwhite: [
                            248,
                            248,
                            255
                        ],
                        gold: [
                            255,
                            215,
                            0
                        ],
                        goldenrod: [
                            218,
                            165,
                            32
                        ],
                        gray: [
                            128,
                            128,
                            128
                        ],
                        grey: [
                            128,
                            128,
                            128
                        ],
                        green: [
                            0,
                            128,
                            0
                        ],
                        greenyellow: [
                            173,
                            255,
                            47
                        ],
                        honeydew: [
                            240,
                            255,
                            240
                        ],
                        hotpink: [
                            255,
                            105,
                            180
                        ],
                        indianred: [
                            205,
                            92,
                            92
                        ],
                        indigo: [
                            75,
                            0,
                            130
                        ],
                        ivory: [
                            255,
                            255,
                            240
                        ],
                        khaki: [
                            240,
                            230,
                            140
                        ],
                        lavender: [
                            230,
                            230,
                            250
                        ],
                        lavenderblush: [
                            255,
                            240,
                            245
                        ],
                        lawngreen: [
                            124,
                            252,
                            0
                        ],
                        lemonchiffon: [
                            255,
                            250,
                            205
                        ],
                        lightblue: [
                            173,
                            216,
                            230
                        ],
                        lightcoral: [
                            240,
                            128,
                            128
                        ],
                        lightcyan: [
                            224,
                            255,
                            255
                        ],
                        lightgoldenrodyellow: [
                            250,
                            250,
                            210
                        ],
                        lightgray: [
                            211,
                            211,
                            211
                        ],
                        lightgrey: [
                            211,
                            211,
                            211
                        ],
                        lightgreen: [
                            144,
                            238,
                            144
                        ],
                        lightpink: [
                            255,
                            182,
                            193
                        ],
                        lightsalmon: [
                            255,
                            160,
                            122
                        ],
                        lightseagreen: [
                            32,
                            178,
                            170
                        ],
                        lightskyblue: [
                            135,
                            206,
                            250
                        ],
                        lightslategray: [
                            119,
                            136,
                            153
                        ],
                        lightslategrey: [
                            119,
                            136,
                            153
                        ],
                        lightsteelblue: [
                            176,
                            196,
                            222
                        ],
                        lightyellow: [
                            255,
                            255,
                            224
                        ],
                        lime: [
                            0,
                            255,
                            0
                        ],
                        limegreen: [
                            50,
                            205,
                            50
                        ],
                        linen: [
                            250,
                            240,
                            230
                        ],
                        magenta: [
                            255,
                            0,
                            255
                        ],
                        maroon: [
                            128,
                            0,
                            0
                        ],
                        mediumaquamarine: [
                            102,
                            205,
                            170
                        ],
                        mediumblue: [
                            0,
                            0,
                            205
                        ],
                        mediumorchid: [
                            186,
                            85,
                            211
                        ],
                        mediumpurple: [
                            147,
                            112,
                            219
                        ],
                        mediumseagreen: [
                            60,
                            179,
                            113
                        ],
                        mediumslateblue: [
                            123,
                            104,
                            238
                        ],
                        mediumspringgreen: [
                            0,
                            250,
                            154
                        ],
                        mediumturquoise: [
                            72,
                            209,
                            204
                        ],
                        mediumvioletred: [
                            199,
                            21,
                            133
                        ],
                        midnightblue: [
                            25,
                            25,
                            112
                        ],
                        mintcream: [
                            245,
                            255,
                            250
                        ],
                        mistyrose: [
                            255,
                            228,
                            225
                        ],
                        moccasin: [
                            255,
                            228,
                            181
                        ],
                        navajowhite: [
                            255,
                            222,
                            173
                        ],
                        navy: [
                            0,
                            0,
                            128
                        ],
                        oldlace: [
                            253,
                            245,
                            230
                        ],
                        olive: [
                            128,
                            128,
                            0
                        ],
                        olivedrab: [
                            107,
                            142,
                            35
                        ],
                        orange: [
                            255,
                            165,
                            0
                        ],
                        orangered: [
                            255,
                            69,
                            0
                        ],
                        orchid: [
                            218,
                            112,
                            214
                        ],
                        palegoldenrod: [
                            238,
                            232,
                            170
                        ],
                        palegreen: [
                            152,
                            251,
                            152
                        ],
                        paleturquoise: [
                            175,
                            238,
                            238
                        ],
                        palevioletred: [
                            219,
                            112,
                            147
                        ],
                        papayawhip: [
                            255,
                            239,
                            213
                        ],
                        peachpuff: [
                            255,
                            218,
                            185
                        ],
                        peru: [
                            205,
                            133,
                            63
                        ],
                        pink: [
                            255,
                            192,
                            203
                        ],
                        plum: [
                            221,
                            160,
                            221
                        ],
                        powderblue: [
                            176,
                            224,
                            230
                        ],
                        purple: [
                            128,
                            0,
                            128
                        ],
                        rebeccapurple: [
                            102,
                            51,
                            153
                        ],
                        red: [
                            255,
                            0,
                            0
                        ],
                        rosybrown: [
                            188,
                            143,
                            143
                        ],
                        royalblue: [
                            65,
                            105,
                            225
                        ],
                        saddlebrown: [
                            139,
                            69,
                            19
                        ],
                        salmon: [
                            250,
                            128,
                            114
                        ],
                        sandybrown: [
                            244,
                            164,
                            96
                        ],
                        seagreen: [
                            46,
                            139,
                            87
                        ],
                        seashell: [
                            255,
                            245,
                            238
                        ],
                        sienna: [
                            160,
                            82,
                            45
                        ],
                        silver: [
                            192,
                            192,
                            192
                        ],
                        skyblue: [
                            135,
                            206,
                            235
                        ],
                        slateblue: [
                            106,
                            90,
                            205
                        ],
                        slategray: [
                            112,
                            128,
                            144
                        ],
                        slategrey: [
                            112,
                            128,
                            144
                        ],
                        snow: [
                            255,
                            250,
                            250
                        ],
                        springgreen: [
                            0,
                            255,
                            127
                        ],
                        steelblue: [
                            70,
                            130,
                            180
                        ],
                        tan: [
                            210,
                            180,
                            140
                        ],
                        teal: [
                            0,
                            128,
                            128
                        ],
                        thistle: [
                            216,
                            191,
                            216
                        ],
                        tomato: [
                            255,
                            99,
                            71
                        ],
                        turquoise: [
                            64,
                            224,
                            208
                        ],
                        violet: [
                            238,
                            130,
                            238
                        ],
                        wheat: [
                            245,
                            222,
                            179
                        ],
                        white: [
                            255,
                            255,
                            255
                        ],
                        whitesmoke: [
                            245,
                            245,
                            245
                        ],
                        yellow: [
                            255,
                            255,
                            0
                        ]
                    };
                    var DefaultColors = {
                        black: [
                            NamedColors.black,
                            1
                        ],
                        white: [
                            NamedColors.white,
                            1
                        ],
                        transparent: [
                            NamedColors.black,
                            0
                        ]
                    };
                    var Entities = {
                        quot: 34,
                        amp: 38,
                        lt: 60,
                        gt: 62,
                        apos: 39,
                        OElig: 338,
                        oelig: 339,
                        Scaron: 352,
                        scaron: 353,
                        Yuml: 376,
                        circ: 710,
                        tilde: 732,
                        ensp: 8194,
                        emsp: 8195,
                        thinsp: 8201,
                        zwnj: 8204,
                        zwj: 8205,
                        lrm: 8206,
                        rlm: 8207,
                        ndash: 8211,
                        mdash: 8212,
                        lsquo: 8216,
                        rsquo: 8217,
                        sbquo: 8218,
                        ldquo: 8220,
                        rdquo: 8221,
                        bdquo: 8222,
                        dagger: 8224,
                        Dagger: 8225,
                        permil: 8240,
                        lsaquo: 8249,
                        rsaquo: 8250,
                        euro: 8364,
                        nbsp: 160,
                        iexcl: 161,
                        cent: 162,
                        pound: 163,
                        curren: 164,
                        yen: 165,
                        brvbar: 166,
                        sect: 167,
                        uml: 168,
                        copy: 169,
                        ordf: 170,
                        laquo: 171,
                        not: 172,
                        shy: 173,
                        reg: 174,
                        macr: 175,
                        deg: 176,
                        plusmn: 177,
                        sup2: 178,
                        sup3: 179,
                        acute: 180,
                        micro: 181,
                        para: 182,
                        middot: 183,
                        cedil: 184,
                        sup1: 185,
                        ordm: 186,
                        raquo: 187,
                        frac14: 188,
                        frac12: 189,
                        frac34: 190,
                        iquest: 191,
                        Agrave: 192,
                        Aacute: 193,
                        Acirc: 194,
                        Atilde: 195,
                        Auml: 196,
                        Aring: 197,
                        AElig: 198,
                        Ccedil: 199,
                        Egrave: 200,
                        Eacute: 201,
                        Ecirc: 202,
                        Euml: 203,
                        Igrave: 204,
                        Iacute: 205,
                        Icirc: 206,
                        Iuml: 207,
                        ETH: 208,
                        Ntilde: 209,
                        Ograve: 210,
                        Oacute: 211,
                        Ocirc: 212,
                        Otilde: 213,
                        Ouml: 214,
                        times: 215,
                        Oslash: 216,
                        Ugrave: 217,
                        Uacute: 218,
                        Ucirc: 219,
                        Uuml: 220,
                        Yacute: 221,
                        THORN: 222,
                        szlig: 223,
                        agrave: 224,
                        aacute: 225,
                        acirc: 226,
                        atilde: 227,
                        auml: 228,
                        aring: 229,
                        aelig: 230,
                        ccedil: 231,
                        egrave: 232,
                        eacute: 233,
                        ecirc: 234,
                        euml: 235,
                        igrave: 236,
                        iacute: 237,
                        icirc: 238,
                        iuml: 239,
                        eth: 240,
                        ntilde: 241,
                        ograve: 242,
                        oacute: 243,
                        ocirc: 244,
                        otilde: 245,
                        ouml: 246,
                        divide: 247,
                        oslash: 248,
                        ugrave: 249,
                        uacute: 250,
                        ucirc: 251,
                        uuml: 252,
                        yacute: 253,
                        thorn: 254,
                        yuml: 255,
                        fnof: 402,
                        Alpha: 913,
                        Beta: 914,
                        Gamma: 915,
                        Delta: 916,
                        Epsilon: 917,
                        Zeta: 918,
                        Eta: 919,
                        Theta: 920,
                        Iota: 921,
                        Kappa: 922,
                        Lambda: 923,
                        Mu: 924,
                        Nu: 925,
                        Xi: 926,
                        Omicron: 927,
                        Pi: 928,
                        Rho: 929,
                        Sigma: 931,
                        Tau: 932,
                        Upsilon: 933,
                        Phi: 934,
                        Chi: 935,
                        Psi: 936,
                        Omega: 937,
                        alpha: 945,
                        beta: 946,
                        gamma: 947,
                        delta: 948,
                        epsilon: 949,
                        zeta: 950,
                        eta: 951,
                        theta: 952,
                        iota: 953,
                        kappa: 954,
                        lambda: 955,
                        mu: 956,
                        nu: 957,
                        xi: 958,
                        omicron: 959,
                        pi: 960,
                        rho: 961,
                        sigmaf: 962,
                        sigma: 963,
                        tau: 964,
                        upsilon: 965,
                        phi: 966,
                        chi: 967,
                        psi: 968,
                        omega: 969,
                        thetasym: 977,
                        upsih: 978,
                        piv: 982,
                        bull: 8226,
                        hellip: 8230,
                        prime: 8242,
                        Prime: 8243,
                        oline: 8254,
                        frasl: 8260,
                        weierp: 8472,
                        image: 8465,
                        real: 8476,
                        trade: 8482,
                        alefsym: 8501,
                        larr: 8592,
                        uarr: 8593,
                        rarr: 8594,
                        darr: 8595,
                        harr: 8596,
                        crarr: 8629,
                        lArr: 8656,
                        uArr: 8657,
                        rArr: 8658,
                        dArr: 8659,
                        hArr: 8660,
                        forall: 8704,
                        part: 8706,
                        exist: 8707,
                        empty: 8709,
                        nabla: 8711,
                        isin: 8712,
                        notin: 8713,
                        ni: 8715,
                        prod: 8719,
                        sum: 8721,
                        minus: 8722,
                        lowast: 8727,
                        radic: 8730,
                        prop: 8733,
                        infin: 8734,
                        ang: 8736,
                        and: 8743,
                        or: 8744,
                        cap: 8745,
                        cup: 8746,
                        int: 8747,
                        there4: 8756,
                        sim: 8764,
                        cong: 8773,
                        asymp: 8776,
                        ne: 8800,
                        equiv: 8801,
                        le: 8804,
                        ge: 8805,
                        sub: 8834,
                        sup: 8835,
                        nsub: 8836,
                        sube: 8838,
                        supe: 8839,
                        oplus: 8853,
                        otimes: 8855,
                        perp: 8869,
                        sdot: 8901,
                        lceil: 8968,
                        rceil: 8969,
                        lfloor: 8970,
                        rfloor: 8971,
                        lang: 9001,
                        rang: 9002,
                        loz: 9674,
                        spades: 9824,
                        clubs: 9827,
                        hearts: 9829,
                        diams: 9830
                    };
                    var PathArguments = {
                        A: 7,
                        a: 7,
                        C: 6,
                        c: 6,
                        H: 1,
                        h: 1,
                        L: 2,
                        l: 2,
                        M: 2,
                        m: 2,
                        Q: 4,
                        q: 4,
                        S: 4,
                        s: 4,
                        T: 2,
                        t: 2,
                        V: 1,
                        v: 1,
                        Z: 0,
                        z: 0
                    };
                    var PathFlags = {
                        A3: true,
                        A4: true,
                        a3: true,
                        a4: true
                    };
                    var Properties = {
                        'color': {
                            inherit: true,
                            initial: undefined
                        },
                        'visibility': {
                            inherit: true,
                            initial: 'visible',
                            values: {
                                'hidden': 'hidden',
                                'collapse': 'hidden',
                                'visible': 'visible'
                            }
                        },
                        'fill': {
                            inherit: true,
                            initial: DefaultColors.black
                        },
                        'stroke': {
                            inherit: true,
                            initial: 'none'
                        },
                        'stop-color': {
                            inherit: false,
                            initial: DefaultColors.black
                        },
                        'fill-opacity': {
                            inherit: true,
                            initial: 1
                        },
                        'stroke-opacity': {
                            inherit: true,
                            initial: 1
                        },
                        'stop-opacity': {
                            inherit: false,
                            initial: 1
                        },
                        'fill-rule': {
                            inherit: true,
                            initial: 'nonzero',
                            values: {
                                'nonzero': 'nonzero',
                                'evenodd': 'evenodd'
                            }
                        },
                        'clip-rule': {
                            inherit: true,
                            initial: 'nonzero',
                            values: {
                                'nonzero': 'nonzero',
                                'evenodd': 'evenodd'
                            }
                        },
                        'stroke-width': {
                            inherit: true,
                            initial: 1
                        },
                        'stroke-dasharray': {
                            inherit: true,
                            initial: []
                        },
                        'stroke-dashoffset': {
                            inherit: true,
                            initial: 0
                        },
                        'stroke-miterlimit': {
                            inherit: true,
                            initial: 4
                        },
                        'stroke-linejoin': {
                            inherit: true,
                            initial: 'miter',
                            values: {
                                'miter': 'miter',
                                'round': 'round',
                                'bevel': 'bevel'
                            }
                        },
                        'stroke-linecap': {
                            inherit: true,
                            initial: 'butt',
                            values: {
                                'butt': 'butt',
                                'round': 'round',
                                'square': 'square'
                            }
                        },
                        'font-size': {
                            inherit: true,
                            initial: 16,
                            values: {
                                'xx-small': 9,
                                'x-small': 10,
                                'small': 13,
                                'medium': 16,
                                'large': 18,
                                'x-large': 24,
                                'xx-large': 32
                            }
                        },
                        'font-family': {
                            inherit: true,
                            initial: 'sans-serif'
                        },
                        'font-weight': {
                            inherit: true,
                            initial: 'normal',
                            values: {
                                '600': 'bold',
                                '700': 'bold',
                                '800': 'bold',
                                '900': 'bold',
                                'bold': 'bold',
                                'bolder': 'bold',
                                '500': 'normal',
                                '400': 'normal',
                                '300': 'normal',
                                '200': 'normal',
                                '100': 'normal',
                                'normal': 'normal',
                                'lighter': 'normal'
                            }
                        },
                        'font-style': {
                            inherit: true,
                            initial: 'normal',
                            values: {
                                'italic': 'italic',
                                'oblique': 'italic',
                                'normal': 'normal'
                            }
                        },
                        'text-anchor': {
                            inherit: true,
                            initial: 'start',
                            values: {
                                'start': 'start',
                                'middle': 'middle',
                                'end': 'end'
                            }
                        },
                        'direction': {
                            inherit: true,
                            initial: 'ltr',
                            values: {
                                'ltr': 'ltr',
                                'rtl': 'rtl'
                            }
                        },
                        'dominant-baseline': {
                            inherit: true,
                            initial: 'baseline',
                            values: {
                                'auto': 'baseline',
                                'baseline': 'baseline',
                                'before-edge': 'before-edge',
                                'text-before-edge': 'before-edge',
                                'middle': 'middle',
                                'central': 'central',
                                'after-edge': 'after-edge',
                                'text-after-edge': 'after-edge',
                                'ideographic': 'ideographic',
                                'alphabetic': 'alphabetic',
                                'hanging': 'hanging',
                                'mathematical': 'mathematical'
                            }
                        },
                        'alignment-baseline': {
                            inherit: false,
                            initial: undefined,
                            values: {
                                'auto': 'baseline',
                                'baseline': 'baseline',
                                'before-edge': 'before-edge',
                                'text-before-edge': 'before-edge',
                                'middle': 'middle',
                                'central': 'central',
                                'after-edge': 'after-edge',
                                'text-after-edge': 'after-edge',
                                'ideographic': 'ideographic',
                                'alphabetic': 'alphabetic',
                                'hanging': 'hanging',
                                'mathematical': 'mathematical'
                            }
                        },
                        'baseline-shift': {
                            inherit: true,
                            initial: 'baseline',
                            values: {
                                'baseline': 'baseline',
                                'sub': 'sub',
                                'super': 'super'
                            }
                        },
                        'word-spacing': {
                            inherit: true,
                            initial: 0,
                            values: {
                                normal: 0
                            }
                        },
                        'letter-spacing': {
                            inherit: true,
                            initial: 0,
                            values: {
                                normal: 0
                            }
                        },
                        'text-decoration': {
                            inherit: false,
                            initial: 'none',
                            values: {
                                'none': 'none',
                                'underline': 'underline',
                                'overline': 'overline',
                                'line-through': 'line-through'
                            }
                        },
                        'xml:space': {
                            inherit: true,
                            initial: 'default',
                            css: 'white-space',
                            values: {
                                'preserve': 'preserve',
                                'default': 'default',
                                'pre': 'preserve',
                                'pre-line': 'preserve',
                                'pre-wrap': 'preserve',
                                'nowrap': 'default'
                            }
                        },
                        'marker-start': {
                            inherit: true,
                            initial: 'none'
                        },
                        'marker-mid': {
                            inherit: true,
                            initial: 'none'
                        },
                        'marker-end': {
                            inherit: true,
                            initial: 'none'
                        },
                        'opacity': {
                            inherit: false,
                            initial: 1
                        },
                        'transform': {
                            inherit: false,
                            initial: [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ]
                        },
                        'display': {
                            inherit: false,
                            initial: 'inline',
                            values: {
                                'none': 'none',
                                'inline': 'inline',
                                'block': 'inline'
                            }
                        },
                        'clip-path': {
                            inherit: false,
                            initial: 'none'
                        },
                        'mask': {
                            inherit: false,
                            initial: 'none'
                        },
                        'overflow': {
                            inherit: false,
                            initial: 'hidden',
                            values: {
                                'hidden': 'hidden',
                                'scroll': 'hidden',
                                'visible': 'visible'
                            }
                        }
                    };
                    function docBeginGroup(bbox) {
                        var group = new function PDFGroup() {}();
                        group.name = 'G' + (doc._groupCount = (doc._groupCount || 0) + 1);
                        group.resources = doc.ref();
                        group.xobj = doc.ref({
                            Type: 'XObject',
                            Subtype: 'Form',
                            FormType: 1,
                            BBox: bbox,
                            Group: {
                                S: 'Transparency',
                                CS: 'DeviceRGB',
                                I: true,
                                K: false
                            },
                            Resources: group.resources
                        });
                        group.xobj.write('');
                        group.savedMatrix = doc._ctm;
                        group.savedPage = doc.page;
                        groupStack.push(group);
                        doc._ctm = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        doc.page = {
                            width: doc.page.width,
                            height: doc.page.height,
                            write: function write(data) {
                                group.xobj.write(data);
                            },
                            fonts: {},
                            xobjects: {},
                            ext_gstates: {},
                            patterns: {}
                        };
                        return group;
                    }
                    function docEndGroup(group) {
                        if (group !== groupStack.pop()) throw 'Group not matching';
                        if (Object.keys(doc.page.fonts).length) group.resources.data.Font = doc.page.fonts;
                        if (Object.keys(doc.page.xobjects).length) group.resources.data.XObject = doc.page.xobjects;
                        if (Object.keys(doc.page.ext_gstates).length) group.resources.data.ExtGState = doc.page.ext_gstates;
                        if (Object.keys(doc.page.patterns).length) group.resources.data.Pattern = doc.page.patterns;
                        group.resources.end();
                        group.xobj.end();
                        doc._ctm = group.savedMatrix;
                        doc.page = group.savedPage;
                    }
                    function docInsertGroup(group) {
                        doc.page.xobjects[group.name] = group.xobj;
                        doc.addContent('/' + group.name + ' Do');
                    }
                    function docApplyMask(group, clip) {
                        var name = 'M' + (doc._maskCount = (doc._maskCount || 0) + 1);
                        var gstate = doc.ref({
                            Type: 'ExtGState',
                            CA: 1,
                            ca: 1,
                            BM: 'Normal',
                            SMask: {
                                S: 'Luminosity',
                                G: group.xobj,
                                BC: clip ? [
                                    0,
                                    0,
                                    0
                                ] : [
                                    1,
                                    1,
                                    1
                                ]
                            }
                        });
                        gstate.end();
                        doc.page.ext_gstates[name] = gstate;
                        doc.addContent('/' + name + ' gs');
                    }
                    function docCreatePattern(group, dx, dy, matrix) {
                        var pattern = new function PDFPattern() {}();
                        pattern.group = group;
                        pattern.dx = dx;
                        pattern.dy = dy;
                        pattern.matrix = matrix || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        return pattern;
                    }
                    function docUsePattern(pattern, stroke) {
                        var name = 'P' + (doc._patternCount = (doc._patternCount || 0) + 1);
                        var ref = doc.ref({
                            Type: 'Pattern',
                            PatternType: 1,
                            PaintType: 1,
                            TilingType: 2,
                            BBox: [
                                0,
                                0,
                                pattern.dx,
                                pattern.dy
                            ],
                            XStep: pattern.dx,
                            YStep: pattern.dy,
                            Matrix: multiplyMatrix(doc._ctm, pattern.matrix),
                            Resources: {
                                ProcSet: [
                                    'PDF',
                                    'Text',
                                    'ImageB',
                                    'ImageC',
                                    'ImageI'
                                ],
                                XObject: function() {
                                    var temp = {};
                                    temp[pattern.group.name] = pattern.group.xobj;
                                    return temp;
                                }()
                            }
                        });
                        ref.write('/' + pattern.group.name + ' Do');
                        ref.end();
                        doc.page.patterns[name] = ref;
                        if (stroke) {
                            doc.addContent('/Pattern CS');
                            doc.addContent('/' + name + ' SCN');
                        } else {
                            doc.addContent('/Pattern cs');
                            doc.addContent('/' + name + ' scn');
                        }
                    }
                    function docBeginText(font, size) {
                        if (!doc.page.fonts[font.id]) doc.page.fonts[font.id] = font.ref();
                        doc.addContent('BT').addContent('/' + font.id + ' ' + size + ' Tf');
                    }
                    function docSetTextMatrix(a, b, c, d, e, f) {
                        doc.addContent(validateNumber(a) + ' ' + validateNumber(b) + ' ' + validateNumber(-c) + ' ' + validateNumber(-d) + ' ' + validateNumber(e) + ' ' + validateNumber(f) + ' Tm');
                    }
                    function docSetTextMode(fill, stroke) {
                        var mode = fill && stroke ? 2 : stroke ? 1 : fill ? 0 : 3;
                        doc.addContent(mode + ' Tr');
                    }
                    function docWriteGlyph(glyph) {
                        doc.addContent('<' + glyph + '> Tj');
                    }
                    function docEndText() {
                        doc.addContent('ET');
                    }
                    function docFillColor(color) {
                        if (color[0].constructor.name === 'PDFPattern') {
                            doc.fillOpacity(color[1]);
                            docUsePattern(color[0], false);
                        } else doc.fillColor(color[0], color[1]);
                    }
                    function docStrokeColor(color) {
                        if (color[0].constructor.name === 'PDFPattern') {
                            doc.strokeOpacity(color[1]);
                            docUsePattern(color[0], true);
                        } else doc.strokeColor(color[0], color[1]);
                    }
                    function docInsertLink(x, y, w, h, url) {
                        var ref = doc.ref({
                            Type: 'Annot',
                            Subtype: 'Link',
                            Rect: [
                                x,
                                y,
                                w,
                                h
                            ],
                            Border: [
                                0,
                                0,
                                0
                            ],
                            A: {
                                S: 'URI',
                                URI: new String(url)
                            }
                        });
                        ref.end();
                        links.push(ref);
                    }
                    function parseXml(xml) {
                        var SvgNode = function SvgNode(tag, type, value, error) {
                            this.error = error;
                            this.nodeName = tag;
                            this.nodeValue = value;
                            this.nodeType = type;
                            this.attributes = Object.create(null);
                            this.childNodes = [];
                            this.parentNode = null;
                            this.id = '';
                            this.textContent = '';
                            this.classList = [];
                        };
                        SvgNode.prototype.getAttribute = function(attr) {
                            return this.attributes[attr] != null ? this.attributes[attr] : null;
                        };
                        SvgNode.prototype.getElementById = function(id) {
                            var result = null;
                            (function recursive(node) {
                                if (result) return;
                                if (node.nodeType === 1) {
                                    if (node.id === id) result = node;
                                    for(var i = 0; i < node.childNodes.length; i++)recursive(node.childNodes[i]);
                                }
                            })(this);
                            return result;
                        };
                        SvgNode.prototype.getElementsByTagName = function(tag) {
                            var result = [];
                            (function recursive(node) {
                                if (node.nodeType === 1) {
                                    if (node.nodeName === tag) result.push(node);
                                    for(var i = 0; i < node.childNodes.length; i++)recursive(node.childNodes[i]);
                                }
                            })(this);
                            return result;
                        };
                        var parser = new StringParser(xml.trim()), result, child, error = false;
                        var _recursive = function recursive() {
                            var temp, child;
                            if (temp = parser.match(/^<([\w:.-]+)\s*/, true)) {
                                // Opening tag
                                var node = new SvgNode(temp[1], 1, null, error);
                                while(temp = parser.match(/^([\w:.-]+)(?:\s*=\s*"([^"]*)"|\s*=\s*'([^']*)')?\s*/, true)){
                                    // Attribute
                                    var attr = temp[1], value = decodeEntities(temp[2] || temp[3] || '');
                                    if (!node.attributes[attr]) {
                                        node.attributes[attr] = value;
                                        if (attr === 'id') node.id = value;
                                        if (attr === 'class') node.classList = value.split(' ');
                                    } else {
                                        warningCallback('parseXml: duplicate attribute "' + attr + '"');
                                        error = true;
                                    }
                                }
                                if (parser.match(/^>/)) {
                                    // End of opening tag
                                    while(child = _recursive()){
                                        node.childNodes.push(child);
                                        child.parentNode = node;
                                        node.textContent += child.nodeType === 3 || child.nodeType === 4 ? child.nodeValue : child.textContent;
                                    }
                                    if (temp = parser.match(/^<\/([\w:.-]+)\s*>/, true)) {
                                        // Closing tag
                                        if (temp[1] === node.nodeName) return node;
                                        else {
                                            warningCallback('parseXml: tag not matching, opening "' + node.nodeName + '" & closing "' + temp[1] + '"');
                                            error = true;
                                            return node;
                                        }
                                    } else {
                                        warningCallback('parseXml: tag not matching, opening "' + node.nodeName + '" & not closing');
                                        error = true;
                                        return node;
                                    }
                                } else if (parser.match(/^\/>/)) // Self-closing tag
                                return node;
                                else {
                                    warningCallback('parseXml: tag could not be parsed "' + node.nodeName + '"');
                                    error = true;
                                }
                            } else if (temp = parser.match(/^<!--[\s\S]*?-->/)) // Comment
                            return new SvgNode(null, 8, temp, error);
                            else if (temp = parser.match(/^<\?[\s\S]*?\?>/)) // Processing instructions
                            return new SvgNode(null, 7, temp, error);
                            else if (temp = parser.match(/^<!DOCTYPE\s*([\s\S]*?)>/)) // Doctype
                            return new SvgNode(null, 10, temp, error);
                            else if (temp = parser.match(/^<!\[CDATA\[([\s\S]*?)\]\]>/, true)) // Cdata node
                            return new SvgNode('#cdata-section', 4, temp[1], error);
                            else if (temp = parser.match(/^([^<]+)/, true)) // Text node
                            return new SvgNode('#text', 3, decodeEntities(temp[1]), error);
                        };
                        while(child = _recursive()){
                            if (child.nodeType === 1 && !result) result = child;
                            else if (child.nodeType === 1 || child.nodeType === 3 && child.nodeValue.trim() !== '') warningCallback('parseXml: data after document end has been discarded');
                        }
                        if (parser.matchAll()) warningCallback('parseXml: parsing error');
                        return result;
                    }
                    function decodeEntities(str) {
                        return str.replace(/&(?:#([0-9]+)|#[xX]([0-9A-Fa-f]+)|([0-9A-Za-z]+));/g, function(mt, m0, m1, m2) {
                            if (m0) return String.fromCharCode(parseInt(m0, 10));
                            else if (m1) return String.fromCharCode(parseInt(m1, 16));
                            else if (m2 && Entities[m2]) return String.fromCharCode(Entities[m2]);
                            else return mt;
                        });
                    }
                    function parseColor(raw) {
                        var temp, result;
                        raw = (raw || '').trim();
                        if (temp = NamedColors[raw]) result = [
                            temp.slice(),
                            1
                        ];
                        else if (temp = raw.match(/^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)$/i)) {
                            temp[1] = parseInt(temp[1]);
                            temp[2] = parseInt(temp[2]);
                            temp[3] = parseInt(temp[3]);
                            temp[4] = parseFloat(temp[4]);
                            if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256 && temp[4] <= 1) result = [
                                temp.slice(1, 4),
                                temp[4]
                            ];
                        } else if (temp = raw.match(/^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)$/i)) {
                            temp[1] = parseInt(temp[1]);
                            temp[2] = parseInt(temp[2]);
                            temp[3] = parseInt(temp[3]);
                            if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256) result = [
                                temp.slice(1, 4),
                                1
                            ];
                        } else if (temp = raw.match(/^rgb\(\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*\)$/i)) {
                            temp[1] = 2.55 * parseFloat(temp[1]);
                            temp[2] = 2.55 * parseFloat(temp[2]);
                            temp[3] = 2.55 * parseFloat(temp[3]);
                            if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256) result = [
                                temp.slice(1, 4),
                                1
                            ];
                        } else if (temp = raw.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i)) result = [
                            [
                                parseInt(temp[1], 16),
                                parseInt(temp[2], 16),
                                parseInt(temp[3], 16)
                            ],
                            1
                        ];
                        else if (temp = raw.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i)) result = [
                            [
                                0x11 * parseInt(temp[1], 16),
                                0x11 * parseInt(temp[2], 16),
                                0x11 * parseInt(temp[3], 16)
                            ],
                            1
                        ];
                        return colorCallback ? colorCallback(result, raw) : result;
                    }
                    function opacityToColor(color, opacity, isMask) {
                        var newColor = color[0].slice(), newOpacity = color[1] * opacity;
                        if (isMask) {
                            for(var i = 0; i < color.length; i++)newColor[i] *= newOpacity;
                            return [
                                newColor,
                                1
                            ];
                        } else return [
                            newColor,
                            newOpacity
                        ];
                    }
                    function multiplyMatrix() {
                        function multiply(a, b) {
                            return [
                                a[0] * b[0] + a[2] * b[1],
                                a[1] * b[0] + a[3] * b[1],
                                a[0] * b[2] + a[2] * b[3],
                                a[1] * b[2] + a[3] * b[3],
                                a[0] * b[4] + a[2] * b[5] + a[4],
                                a[1] * b[4] + a[3] * b[5] + a[5]
                            ];
                        }
                        var result = arguments[0];
                        for(var i = 1; i < arguments.length; i++)result = multiply(result, arguments[i]);
                        return result;
                    }
                    function transformPoint(p, m) {
                        return [
                            m[0] * p[0] + m[2] * p[1] + m[4],
                            m[1] * p[0] + m[3] * p[1] + m[5]
                        ];
                    }
                    function getGlobalMatrix() {
                        var ctm = doc._ctm;
                        for(var i = groupStack.length - 1; i >= 0; i--)ctm = multiplyMatrix(groupStack[i].savedMatrix, ctm);
                        return ctm;
                    }
                    function getPageBBox() {
                        return new _SvgShape().M(0, 0).L(doc.page.width, 0).L(doc.page.width, doc.page.height).L(0, doc.page.height).transform(inverseMatrix(getGlobalMatrix())).getBoundingBox();
                    }
                    function inverseMatrix(m) {
                        var dt = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / dt,
                            -m[1] / dt,
                            -m[2] / dt,
                            m[0] / dt,
                            (m[2] * m[5] - m[3] * m[4]) / dt,
                            (m[1] * m[4] - m[0] * m[5]) / dt
                        ];
                    }
                    function validateMatrix(m) {
                        var m0 = validateNumber(m[0]), m1 = validateNumber(m[1]), m2 = validateNumber(m[2]), m3 = validateNumber(m[3]), m4 = validateNumber(m[4]), m5 = validateNumber(m[5]);
                        if (isNotEqual(m0 * m3 - m1 * m2, 0)) return [
                            m0,
                            m1,
                            m2,
                            m3,
                            m4,
                            m5
                        ];
                    }
                    function solveEquation(curve) {
                        var a = curve[2] || 0, b = curve[1] || 0, c = curve[0] || 0;
                        if (isEqual(a, 0) && isEqual(b, 0)) return [];
                        else if (isEqual(a, 0)) return [
                            -c / b
                        ];
                        else {
                            var d = b * b - 4 * a * c;
                            if (isNotEqual(d, 0) && d > 0) return [
                                (-b + Math.sqrt(d)) / (2 * a),
                                (-b - Math.sqrt(d)) / (2 * a)
                            ];
                            else if (isEqual(d, 0)) return [
                                -b / (2 * a)
                            ];
                            else return [];
                        }
                    }
                    function getCurveValue(t, curve) {
                        return (curve[0] || 0) + (curve[1] || 0) * t + (curve[2] || 0) * t * t + (curve[3] || 0) * t * t * t;
                    }
                    function isEqual(number, ref) {
                        return Math.abs(number - ref) < 1e-10;
                    }
                    function isNotEqual(number, ref) {
                        return Math.abs(number - ref) >= 1e-10;
                    }
                    function validateNumber(n) {
                        return n > -1000000000000000000000 && n < 1e21 ? Math.round(n * 1e6) / 1e6 : 0;
                    }
                    function isArrayLike(v) {
                        return typeof v === 'object' && v !== null && typeof v.length === 'number';
                    }
                    function parseTranform(v) {
                        var parser = new StringParser((v || '').trim()), result = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ], temp;
                        while(temp = parser.match(/^([A-Za-z]+)\s*[(]([^(]+)[)]/, true)){
                            var func = temp[1], nums = [], parser2 = new StringParser(temp[2].trim()), temp2 = void 0;
                            while(temp2 = parser2.matchNumber()){
                                nums.push(Number(temp2));
                                parser2.matchSeparator();
                            }
                            if (func === 'matrix' && nums.length === 6) result = multiplyMatrix(result, [
                                nums[0],
                                nums[1],
                                nums[2],
                                nums[3],
                                nums[4],
                                nums[5]
                            ]);
                            else if (func === 'translate' && nums.length === 2) result = multiplyMatrix(result, [
                                1,
                                0,
                                0,
                                1,
                                nums[0],
                                nums[1]
                            ]);
                            else if (func === 'translate' && nums.length === 1) result = multiplyMatrix(result, [
                                1,
                                0,
                                0,
                                1,
                                nums[0],
                                0
                            ]);
                            else if (func === 'scale' && nums.length === 2) result = multiplyMatrix(result, [
                                nums[0],
                                0,
                                0,
                                nums[1],
                                0,
                                0
                            ]);
                            else if (func === 'scale' && nums.length === 1) result = multiplyMatrix(result, [
                                nums[0],
                                0,
                                0,
                                nums[0],
                                0,
                                0
                            ]);
                            else if (func === 'rotate' && nums.length === 3) {
                                var a = nums[0] * Math.PI / 180;
                                result = multiplyMatrix(result, [
                                    1,
                                    0,
                                    0,
                                    1,
                                    nums[1],
                                    nums[2]
                                ], [
                                    Math.cos(a),
                                    Math.sin(a),
                                    -Math.sin(a),
                                    Math.cos(a),
                                    0,
                                    0
                                ], [
                                    1,
                                    0,
                                    0,
                                    1,
                                    -nums[1],
                                    -nums[2]
                                ]);
                            } else if (func === 'rotate' && nums.length === 1) {
                                var _a = nums[0] * Math.PI / 180;
                                result = multiplyMatrix(result, [
                                    Math.cos(_a),
                                    Math.sin(_a),
                                    -Math.sin(_a),
                                    Math.cos(_a),
                                    0,
                                    0
                                ]);
                            } else if (func === 'skewX' && nums.length === 1) {
                                var _a2 = nums[0] * Math.PI / 180;
                                result = multiplyMatrix(result, [
                                    1,
                                    0,
                                    Math.tan(_a2),
                                    1,
                                    0,
                                    0
                                ]);
                            } else if (func === 'skewY' && nums.length === 1) {
                                var _a3 = nums[0] * Math.PI / 180;
                                result = multiplyMatrix(result, [
                                    1,
                                    Math.tan(_a3),
                                    0,
                                    1,
                                    0,
                                    0
                                ]);
                            } else return;
                            parser.matchSeparator();
                        }
                        if (parser.matchAll()) return;
                        return result;
                    }
                    function parseAspectRatio(aspectRatio, availWidth, availHeight, elemWidth, elemHeight, initAlign) {
                        var temp = (aspectRatio || '').trim().match(/^(none)$|^x(Min|Mid|Max)Y(Min|Mid|Max)(?:\s+(meet|slice))?$/) || [], ratioType = temp[1] || temp[4] || 'meet', xAlign = temp[2] || 'Mid', yAlign = temp[3] || 'Mid', scaleX = availWidth / elemWidth, scaleY = availHeight / elemHeight, dx = {
                            'Min': 0,
                            'Mid': 0.5,
                            'Max': 1
                        }[xAlign] - (initAlign || 0), dy = {
                            'Min': 0,
                            'Mid': 0.5,
                            'Max': 1
                        }[yAlign] - (initAlign || 0);
                        if (ratioType === 'slice') scaleY = scaleX = Math.max(scaleX, scaleY);
                        else if (ratioType === 'meet') scaleY = scaleX = Math.min(scaleX, scaleY);
                        return [
                            scaleX,
                            0,
                            0,
                            scaleY,
                            dx * (availWidth - elemWidth * scaleX),
                            dy * (availHeight - elemHeight * scaleY)
                        ];
                    }
                    function parseStyleAttr(v) {
                        var result = Object.create(null);
                        v = (v || '').trim().split(/;/);
                        for(var i = 0; i < v.length; i++){
                            var key = (v[i].split(':')[0] || '').trim(), value = (v[i].split(':')[1] || '').trim();
                            if (key) result[key] = value;
                        }
                        if (result['marker']) {
                            if (!result['marker-start']) result['marker-start'] = result['marker'];
                            if (!result['marker-mid']) result['marker-mid'] = result['marker'];
                            if (!result['marker-end']) result['marker-end'] = result['marker'];
                        }
                        if (result['font']) {
                            var fontFamily = null, fontSize = null, fontStyle = "normal", fontWeight = "normal", fontVariant = "normal";
                            var parts = result['font'].split(/\s+/);
                            for(var _i = 0; _i < parts.length; _i++)switch(parts[_i]){
                                case "normal":
                                    break;
                                case "italic":
                                case "oblique":
                                    fontStyle = parts[_i];
                                    break;
                                case "small-caps":
                                    fontVariant = parts[_i];
                                    break;
                                case "bold":
                                case "bolder":
                                case "lighter":
                                case "100":
                                case "200":
                                case "300":
                                case "400":
                                case "500":
                                case "600":
                                case "700":
                                case "800":
                                case "900":
                                    fontWeight = parts[_i];
                                    break;
                                default:
                                    if (!fontSize) fontSize = parts[_i].split('/')[0];
                                    else if (!fontFamily) fontFamily = parts[_i];
                                    else fontFamily += ' ' + parts[_i];
                                    break;
                            }
                            if (!result['font-style']) result['font-style'] = fontStyle;
                            if (!result['font-variant']) result['font-variant'] = fontVariant;
                            if (!result['font-weight']) result['font-weight'] = fontWeight;
                            if (!result['font-size']) result['font-size'] = fontSize;
                            if (!result['font-family']) result['font-family'] = fontFamily;
                        }
                        return result;
                    }
                    function parseSelector(v) {
                        var parts = v.split(/(?=[.#])/g), ids = [], classes = [], tags = [], temp;
                        for(var i = 0; i < parts.length; i++){
                            if (temp = parts[i].match(/^[#]([_A-Za-z0-9-]+)$/)) ids.push(temp[1]);
                            else if (temp = parts[i].match(/^[.]([_A-Za-z0-9-]+)$/)) classes.push(temp[1]);
                            else if (temp = parts[i].match(/^([_A-Za-z0-9-]+)$/)) tags.push(temp[1]);
                            else if (parts[i] !== '*') return;
                        }
                        return {
                            tags: tags,
                            ids: ids,
                            classes: classes,
                            specificity: ids.length * 10000 + classes.length * 100 + tags.length
                        };
                    }
                    function parseStyleSheet(v) {
                        var parser = new StringParser(v.trim()), rules = [], rule;
                        while(rule = parser.match(/^\s*([^\{\}]*?)\s*\{([^\{\}]*?)\}/, true)){
                            var selectors = rule[1].split(/\s*,\s*/g), css = parseStyleAttr(rule[2]);
                            for(var i = 0; i < selectors.length; i++){
                                var selector = parseSelector(selectors[i]);
                                if (selector) rules.push({
                                    selector: selector,
                                    css: css
                                });
                            }
                        }
                        return rules;
                    }
                    function matchesSelector(elem, selector) {
                        if (elem.nodeType !== 1) return false;
                        for(var i = 0; i < selector.tags.length; i++){
                            if (selector.tags[i] !== elem.nodeName) return false;
                        }
                        for(var _i2 = 0; _i2 < selector.ids.length; _i2++){
                            if (selector.ids[_i2] !== elem.id) return false;
                        }
                        for(var _i3 = 0; _i3 < selector.classes.length; _i3++){
                            if (elem.classList.indexOf(selector.classes[_i3]) === -1) return false;
                        }
                        return true;
                    }
                    function getStyle(elem) {
                        var result = Object.create(null);
                        var specificities = Object.create(null);
                        for(var i = 0; i < styleRules.length; i++){
                            var rule = styleRules[i];
                            if (matchesSelector(elem, rule.selector)) {
                                for(var key in rule.css)if (!(specificities[key] > rule.selector.specificity)) {
                                    result[key] = rule.css[key];
                                    specificities[key] = rule.selector.specificity;
                                }
                            }
                        }
                        return result;
                    }
                    function combineArrays(array1, array2) {
                        return array1.concat(array2.slice(array1.length));
                    }
                    function getAscent(font, size) {
                        return Math.max(font.ascender, (font.bbox[3] || font.bbox.maxY) * (font.scale || 1)) * size / 1000;
                    }
                    function getDescent(font, size) {
                        return Math.min(font.descender, (font.bbox[1] || font.bbox.minY) * (font.scale || 1)) * size / 1000;
                    }
                    function getXHeight(font, size) {
                        return (font.xHeight || 0.5 * (font.ascender - font.descender)) * size / 1000;
                    }
                    function getBaseline(font, size, baseline, shift) {
                        var dy1, dy2;
                        switch(baseline){
                            case 'middle':
                                dy1 = 0.5 * getXHeight(font, size);
                                break;
                            case 'central':
                                dy1 = 0.5 * (getDescent(font, size) + getAscent(font, size));
                                break;
                            case 'after-edge':
                            case 'text-after-edge':
                                dy1 = getDescent(font, size);
                                break;
                            case 'alphabetic':
                            case 'auto':
                            case 'baseline':
                                dy1 = 0;
                                break;
                            case 'mathematical':
                                dy1 = 0.5 * getAscent(font, size);
                                break;
                            case 'hanging':
                                dy1 = 0.8 * getAscent(font, size);
                                break;
                            case 'before-edge':
                            case 'text-before-edge':
                                dy1 = getAscent(font, size);
                                break;
                            default:
                                dy1 = 0;
                                break;
                        }
                        switch(shift){
                            case 'baseline':
                                dy2 = 0;
                                break;
                            case 'super':
                                dy2 = 0.6 * size;
                                break;
                            case 'sub':
                                dy2 = -0.6 * size;
                                break;
                            default:
                                dy2 = shift;
                                break;
                        }
                        return dy1 - dy2;
                    }
                    function getTextPos(font, size, text) {
                        var encoded = font.encode('' + text), hex = encoded[0], pos = encoded[1], data = [];
                        for(var i = 0; i < hex.length; i++){
                            var unicode = font.unicode ? font.unicode[parseInt(hex[i], 16)] : [
                                text.charCodeAt(i)
                            ];
                            data.push({
                                glyph: hex[i],
                                unicode: unicode,
                                width: pos[i].advanceWidth * size / 1000,
                                xOffset: pos[i].xOffset * size / 1000,
                                yOffset: pos[i].yOffset * size / 1000,
                                xAdvance: pos[i].xAdvance * size / 1000,
                                yAdvance: pos[i].yAdvance * size / 1000
                            });
                        }
                        return data;
                    }
                    function createSVGElement(obj, inherits) {
                        switch(obj.nodeName){
                            case 'use':
                                return new SvgElemUse(obj, inherits);
                            case 'symbol':
                                return new SvgElemSymbol(obj, inherits);
                            case 'g':
                                return new SvgElemGroup(obj, inherits);
                            case 'a':
                                return new SvgElemLink(obj, inherits);
                            case 'svg':
                                return new SvgElemSvg(obj, inherits);
                            case 'image':
                                return new SVGElemImage(obj, inherits);
                            case 'rect':
                                return new SvgElemRect(obj, inherits);
                            case 'circle':
                                return new SvgElemCircle(obj, inherits);
                            case 'ellipse':
                                return new SvgElemEllipse(obj, inherits);
                            case 'line':
                                return new SvgElemLine(obj, inherits);
                            case 'polyline':
                                return new SvgElemPolyline(obj, inherits);
                            case 'polygon':
                                return new SvgElemPolygon(obj, inherits);
                            case 'path':
                                return new SvgElemPath(obj, inherits);
                            case 'text':
                                return new SvgElemText(obj, inherits);
                            case 'tspan':
                                return new SvgElemTspan(obj, inherits);
                            case 'textPath':
                                return new SvgElemTextPath(obj, inherits);
                            case '#text':
                            case '#cdata-section':
                                return new SvgElemTextNode(obj, inherits);
                            default:
                                return new SvgElem(obj, inherits);
                        }
                    }
                    var StringParser = function StringParser(str) {
                        this.match = function(exp, all) {
                            var temp = str.match(exp);
                            if (!temp || temp.index !== 0) return;
                            str = str.substring(temp[0].length);
                            return all ? temp : temp[0];
                        };
                        this.matchSeparator = function() {
                            return this.match(/^(?:\s*,\s*|\s*|)/);
                        };
                        this.matchSpace = function() {
                            return this.match(/^(?:\s*)/);
                        };
                        this.matchLengthUnit = function() {
                            return this.match(/^(?:px|pt|cm|mm|in|pc|em|ex|%|)/);
                        };
                        this.matchNumber = function() {
                            return this.match(/^(?:[-+]?(?:[0-9]+[.][0-9]+|[0-9]+[.]|[.][0-9]+|[0-9]+)(?:[eE][-+]?[0-9]+)?)/);
                        };
                        this.matchAll = function() {
                            return this.match(/^[\s\S]+/);
                        };
                    };
                    var BezierSegment = function BezierSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
                        var divisions = 6 * precision;
                        var equationX = [
                            p1x,
                            -3 * p1x + 3 * c1x,
                            3 * p1x - 6 * c1x + 3 * c2x,
                            -p1x + 3 * c1x - 3 * c2x + p2x
                        ];
                        var equationY = [
                            p1y,
                            -3 * p1y + 3 * c1y,
                            3 * p1y - 6 * c1y + 3 * c2y,
                            -p1y + 3 * c1y - 3 * c2y + p2y
                        ];
                        var derivativeX = [
                            -3 * p1x + 3 * c1x,
                            6 * p1x - 12 * c1x + 6 * c2x,
                            -3 * p1x + 9 * c1x - 9 * c2x + 3 * p2x
                        ];
                        var derivativeY = [
                            -3 * p1y + 3 * c1y,
                            6 * p1y - 12 * c1y + 6 * c2y,
                            -3 * p1y + 9 * c1y - 9 * c2y + 3 * p2y
                        ];
                        var lengthMap = [
                            0
                        ];
                        for(var i = 1; i <= divisions; i++){
                            var t = (i - 0.5) / divisions;
                            var dx = getCurveValue(t, derivativeX) / divisions, dy = getCurveValue(t, derivativeY) / divisions, l = Math.sqrt(dx * dx + dy * dy);
                            lengthMap[i] = lengthMap[i - 1] + l;
                        }
                        this.totalLength = lengthMap[divisions];
                        this.startPoint = [
                            p1x,
                            p1y,
                            isEqual(p1x, c1x) && isEqual(p1y, c1y) ? Math.atan2(c2y - c1y, c2x - c1x) : Math.atan2(c1y - p1y, c1x - p1x)
                        ];
                        this.endPoint = [
                            p2x,
                            p2y,
                            isEqual(c2x, p2x) && isEqual(c2y, p2y) ? Math.atan2(c2y - c1y, c2x - c1x) : Math.atan2(p2y - c2y, p2x - c2x)
                        ];
                        this.getBoundingBox = function() {
                            var temp;
                            var minX = getCurveValue(0, equationX), minY = getCurveValue(0, equationY), maxX = getCurveValue(1, equationX), maxY = getCurveValue(1, equationY);
                            if (minX > maxX) {
                                temp = maxX;
                                maxX = minX;
                                minX = temp;
                            }
                            if (minY > maxY) {
                                temp = maxY;
                                maxY = minY;
                                minY = temp;
                            }
                            var rootsX = solveEquation(derivativeX);
                            for(var _i4 = 0; _i4 < rootsX.length; _i4++)if (rootsX[_i4] >= 0 && rootsX[_i4] <= 1) {
                                var _x = getCurveValue(rootsX[_i4], equationX);
                                if (_x < minX) minX = _x;
                                if (_x > maxX) maxX = _x;
                            }
                            var rootsY = solveEquation(derivativeY);
                            for(var _i5 = 0; _i5 < rootsY.length; _i5++)if (rootsY[_i5] >= 0 && rootsY[_i5] <= 1) {
                                var _y = getCurveValue(rootsY[_i5], equationY);
                                if (_y < minY) minY = _y;
                                if (_y > maxY) maxY = _y;
                            }
                            return [
                                minX,
                                minY,
                                maxX,
                                maxY
                            ];
                        };
                        this.getPointAtLength = function(l) {
                            if (isEqual(l, 0)) return this.startPoint;
                            if (isEqual(l, this.totalLength)) return this.endPoint;
                            if (l < 0 || l > this.totalLength) return;
                            for(var _i6 = 1; _i6 <= divisions; _i6++){
                                var l1 = lengthMap[_i6 - 1], l2 = lengthMap[_i6];
                                if (l1 <= l && l <= l2) {
                                    var _t = (_i6 - (l2 - l) / (l2 - l1)) / divisions, _x2 = getCurveValue(_t, equationX), _y2 = getCurveValue(_t, equationY), _dx = getCurveValue(_t, derivativeX), _dy = getCurveValue(_t, derivativeY);
                                    return [
                                        _x2,
                                        _y2,
                                        Math.atan2(_dy, _dx)
                                    ];
                                }
                            }
                        };
                    };
                    var LineSegment = function LineSegment(p1x, p1y, p2x, p2y) {
                        this.totalLength = Math.sqrt((p2x - p1x) * (p2x - p1x) + (p2y - p1y) * (p2y - p1y));
                        this.startPoint = [
                            p1x,
                            p1y,
                            Math.atan2(p2y - p1y, p2x - p1x)
                        ];
                        this.endPoint = [
                            p2x,
                            p2y,
                            Math.atan2(p2y - p1y, p2x - p1x)
                        ];
                        this.getBoundingBox = function() {
                            return [
                                Math.min(this.startPoint[0], this.endPoint[0]),
                                Math.min(this.startPoint[1], this.endPoint[1]),
                                Math.max(this.startPoint[0], this.endPoint[0]),
                                Math.max(this.startPoint[1], this.endPoint[1])
                            ];
                        };
                        this.getPointAtLength = function(l) {
                            if (l >= 0 && l <= this.totalLength) {
                                var r = l / this.totalLength || 0, _x3 = this.startPoint[0] + r * (this.endPoint[0] - this.startPoint[0]), _y3 = this.startPoint[1] + r * (this.endPoint[1] - this.startPoint[1]);
                                return [
                                    _x3,
                                    _y3,
                                    this.startPoint[2]
                                ];
                            }
                        };
                    };
                    var _SvgShape = function SvgShape() {
                        this.pathCommands = [];
                        this.pathSegments = [];
                        this.startPoint = null;
                        this.endPoint = null;
                        this.totalLength = 0;
                        var startX = 0, startY = 0, currX = 0, currY = 0, lastCom, lastCtrlX, lastCtrlY;
                        this.move = function(x, y) {
                            startX = currX = x;
                            startY = currY = y;
                            return null;
                        };
                        this.line = function(x, y) {
                            var segment = new LineSegment(currX, currY, x, y);
                            currX = x;
                            currY = y;
                            return segment;
                        };
                        this.curve = function(c1x, c1y, c2x, c2y, x, y) {
                            var segment = new BezierSegment(currX, currY, c1x, c1y, c2x, c2y, x, y);
                            currX = x;
                            currY = y;
                            return segment;
                        };
                        this.close = function() {
                            var segment = new LineSegment(currX, currY, startX, startY);
                            currX = startX;
                            currY = startY;
                            return segment;
                        };
                        this.addCommand = function(data) {
                            this.pathCommands.push(data);
                            var segment = this[data[0]].apply(this, data.slice(3));
                            if (segment) {
                                segment.hasStart = data[1];
                                segment.hasEnd = data[2];
                                this.startPoint = this.startPoint || segment.startPoint;
                                this.endPoint = segment.endPoint;
                                this.pathSegments.push(segment);
                                this.totalLength += segment.totalLength;
                            }
                        };
                        this.M = function(x, y) {
                            this.addCommand([
                                'move',
                                true,
                                true,
                                x,
                                y
                            ]);
                            lastCom = 'M';
                            return this;
                        };
                        this.m = function(x, y) {
                            return this.M(currX + x, currY + y);
                        };
                        this.Z = this.z = function() {
                            this.addCommand([
                                'close',
                                true,
                                true
                            ]);
                            lastCom = 'Z';
                            return this;
                        };
                        this.L = function(x, y) {
                            this.addCommand([
                                'line',
                                true,
                                true,
                                x,
                                y
                            ]);
                            lastCom = 'L';
                            return this;
                        };
                        this.l = function(x, y) {
                            return this.L(currX + x, currY + y);
                        };
                        this.H = function(x) {
                            return this.L(x, currY);
                        };
                        this.h = function(x) {
                            return this.L(currX + x, currY);
                        };
                        this.V = function(y) {
                            return this.L(currX, y);
                        };
                        this.v = function(y) {
                            return this.L(currX, currY + y);
                        };
                        this.C = function(c1x, c1y, c2x, c2y, x, y) {
                            this.addCommand([
                                'curve',
                                true,
                                true,
                                c1x,
                                c1y,
                                c2x,
                                c2y,
                                x,
                                y
                            ]);
                            lastCom = 'C';
                            lastCtrlX = c2x;
                            lastCtrlY = c2y;
                            return this;
                        };
                        this.c = function(c1x, c1y, c2x, c2y, x, y) {
                            return this.C(currX + c1x, currY + c1y, currX + c2x, currY + c2y, currX + x, currY + y);
                        };
                        this.S = function(c1x, c1y, x, y) {
                            return this.C(currX + (lastCom === 'C' ? currX - lastCtrlX : 0), currY + (lastCom === 'C' ? currY - lastCtrlY : 0), c1x, c1y, x, y);
                        };
                        this.s = function(c1x, c1y, x, y) {
                            return this.C(currX + (lastCom === 'C' ? currX - lastCtrlX : 0), currY + (lastCom === 'C' ? currY - lastCtrlY : 0), currX + c1x, currY + c1y, currX + x, currY + y);
                        };
                        this.Q = function(cx, cy, x, y) {
                            var c1x = currX + 2 / 3 * (cx - currX), c1y = currY + 2 / 3 * (cy - currY), c2x = x + 2 / 3 * (cx - x), c2y = y + 2 / 3 * (cy - y);
                            this.addCommand([
                                'curve',
                                true,
                                true,
                                c1x,
                                c1y,
                                c2x,
                                c2y,
                                x,
                                y
                            ]);
                            lastCom = 'Q';
                            lastCtrlX = cx;
                            lastCtrlY = cy;
                            return this;
                        };
                        this.q = function(c1x, c1y, x, y) {
                            return this.Q(currX + c1x, currY + c1y, currX + x, currY + y);
                        };
                        this.T = function(x, y) {
                            return this.Q(currX + (lastCom === 'Q' ? currX - lastCtrlX : 0), currY + (lastCom === 'Q' ? currY - lastCtrlY : 0), x, y);
                        };
                        this.t = function(x, y) {
                            return this.Q(currX + (lastCom === 'Q' ? currX - lastCtrlX : 0), currY + (lastCom === 'Q' ? currY - lastCtrlY : 0), currX + x, currY + y);
                        };
                        this.A = function(rx, ry, fi, fa, fs, x, y) {
                            if (isEqual(rx, 0) || isEqual(ry, 0)) this.addCommand([
                                'line',
                                true,
                                true,
                                x,
                                y
                            ]);
                            else {
                                fi = fi * (Math.PI / 180);
                                rx = Math.abs(rx);
                                ry = Math.abs(ry);
                                fa = 1 * !!fa;
                                fs = 1 * !!fs;
                                var x1 = Math.cos(fi) * (currX - x) / 2 + Math.sin(fi) * (currY - y) / 2, y1 = Math.cos(fi) * (currY - y) / 2 - Math.sin(fi) * (currX - x) / 2, lambda = x1 * x1 / (rx * rx) + y1 * y1 / (ry * ry);
                                if (lambda > 1) {
                                    rx *= Math.sqrt(lambda);
                                    ry *= Math.sqrt(lambda);
                                }
                                var r = Math.sqrt(Math.max(0, rx * rx * ry * ry - rx * rx * y1 * y1 - ry * ry * x1 * x1) / (rx * rx * y1 * y1 + ry * ry * x1 * x1)), x2 = (fa === fs ? -1 : 1) * r * rx * y1 / ry, y2 = (fa === fs ? 1 : -1) * r * ry * x1 / rx;
                                var cx = Math.cos(fi) * x2 - Math.sin(fi) * y2 + (currX + x) / 2, cy = Math.sin(fi) * x2 + Math.cos(fi) * y2 + (currY + y) / 2, th1 = Math.atan2((y1 - y2) / ry, (x1 - x2) / rx), th2 = Math.atan2((-y1 - y2) / ry, (-x1 - x2) / rx);
                                if (fs === 0 && th2 - th1 > 0) th2 -= 2 * Math.PI;
                                else if (fs === 1 && th2 - th1 < 0) th2 += 2 * Math.PI;
                                var segms = Math.ceil(Math.abs(th2 - th1) / (Math.PI / precision));
                                for(var i = 0; i < segms; i++){
                                    var th3 = th1 + i * (th2 - th1) / segms, th4 = th1 + (i + 1) * (th2 - th1) / segms, t = 4 / 3 * Math.tan((th4 - th3) / 4);
                                    var c1x = cx + Math.cos(fi) * rx * (Math.cos(th3) - t * Math.sin(th3)) - Math.sin(fi) * ry * (Math.sin(th3) + t * Math.cos(th3)), c1y = cy + Math.sin(fi) * rx * (Math.cos(th3) - t * Math.sin(th3)) + Math.cos(fi) * ry * (Math.sin(th3) + t * Math.cos(th3)), c2x = cx + Math.cos(fi) * rx * (Math.cos(th4) + t * Math.sin(th4)) - Math.sin(fi) * ry * (Math.sin(th4) - t * Math.cos(th4)), c2y = cy + Math.sin(fi) * rx * (Math.cos(th4) + t * Math.sin(th4)) + Math.cos(fi) * ry * (Math.sin(th4) - t * Math.cos(th4)), endX = cx + Math.cos(fi) * rx * Math.cos(th4) - Math.sin(fi) * ry * Math.sin(th4), endY = cy + Math.sin(fi) * rx * Math.cos(th4) + Math.cos(fi) * ry * Math.sin(th4);
                                    this.addCommand([
                                        'curve',
                                        i === 0,
                                        i === segms - 1,
                                        c1x,
                                        c1y,
                                        c2x,
                                        c2y,
                                        endX,
                                        endY
                                    ]);
                                }
                            }
                            lastCom = 'A';
                            return this;
                        };
                        this.a = function(rx, ry, fi, fa, fs, x, y) {
                            return this.A(rx, ry, fi, fa, fs, currX + x, currY + y);
                        };
                        this.path = function(d) {
                            var command, value, temp, parser = new StringParser((d || '').trim());
                            while(command = parser.match(/^[astvzqmhlcASTVZQMHLC]/)){
                                parser.matchSeparator();
                                var values = [];
                                while(value = PathFlags[command + values.length] ? parser.match(/^[01]/) : parser.matchNumber()){
                                    parser.matchSeparator();
                                    if (values.length === PathArguments[command]) {
                                        this[command].apply(this, values);
                                        values = [];
                                        if (command === 'M') command = 'L';
                                        else if (command === 'm') command = 'l';
                                    }
                                    values.push(Number(value));
                                }
                                if (values.length === PathArguments[command]) this[command].apply(this, values);
                                else {
                                    warningCallback('SvgPath: command ' + command + ' with ' + values.length + ' numbers');
                                    return;
                                }
                            }
                            if (temp = parser.matchAll()) warningCallback('SvgPath: unexpected string ' + temp);
                            return this;
                        };
                        this.getBoundingBox = function() {
                            var bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            function addBounds(bbox1) {
                                if (bbox1[0] < bbox[0]) bbox[0] = bbox1[0];
                                if (bbox1[2] > bbox[2]) bbox[2] = bbox1[2];
                                if (bbox1[1] < bbox[1]) bbox[1] = bbox1[1];
                                if (bbox1[3] > bbox[3]) bbox[3] = bbox1[3];
                            }
                            for(var i = 0; i < this.pathSegments.length; i++)addBounds(this.pathSegments[i].getBoundingBox());
                            if (bbox[0] === Infinity) bbox[0] = 0;
                            if (bbox[1] === Infinity) bbox[1] = 0;
                            if (bbox[2] === -Infinity) bbox[2] = 0;
                            if (bbox[3] === -Infinity) bbox[3] = 0;
                            return bbox;
                        };
                        this.getPointAtLength = function(l) {
                            if (l >= 0 && l <= this.totalLength) {
                                var temp;
                                for(var i = 0; i < this.pathSegments.length; i++){
                                    if (temp = this.pathSegments[i].getPointAtLength(l)) return temp;
                                    l -= this.pathSegments[i].totalLength;
                                }
                                return this.endPoint;
                            }
                        };
                        this.transform = function(m) {
                            this.pathSegments = [];
                            this.startPoint = null;
                            this.endPoint = null;
                            this.totalLength = 0;
                            for(var i = 0; i < this.pathCommands.length; i++){
                                var data = this.pathCommands.shift();
                                for(var j = 3; j < data.length; j += 2){
                                    var p = transformPoint([
                                        data[j],
                                        data[j + 1]
                                    ], m);
                                    data[j] = p[0];
                                    data[j + 1] = p[1];
                                }
                                this.addCommand(data);
                            }
                            return this;
                        };
                        this.mergeShape = function(shape) {
                            for(var i = 0; i < shape.pathCommands.length; i++)this.addCommand(shape.pathCommands[i].slice());
                            return this;
                        };
                        this.clone = function() {
                            return new _SvgShape().mergeShape(this);
                        };
                        this.insertInDocument = function() {
                            for(var i = 0; i < this.pathCommands.length; i++){
                                var command = this.pathCommands[i][0], values = this.pathCommands[i].slice(3);
                                switch(command){
                                    case 'move':
                                        doc.moveTo(values[0], values[1]);
                                        break;
                                    case 'line':
                                        doc.lineTo(values[0], values[1]);
                                        break;
                                    case 'curve':
                                        doc.bezierCurveTo(values[0], values[1], values[2], values[3], values[4], values[5]);
                                        break;
                                    case 'close':
                                        doc.closePath();
                                        break;
                                }
                            }
                        };
                        this.getSubPaths = function() {
                            var subPaths = [], shape = new _SvgShape();
                            for(var i = 0; i < this.pathCommands.length; i++){
                                var data = this.pathCommands[i], command = this.pathCommands[i][0];
                                if (command === 'move' && i !== 0) {
                                    subPaths.push(shape);
                                    shape = new _SvgShape();
                                }
                                shape.addCommand(data);
                            }
                            subPaths.push(shape);
                            return subPaths;
                        };
                        this.getMarkers = function() {
                            var markers = [], subPaths = this.getSubPaths();
                            for(var i = 0; i < subPaths.length; i++){
                                var subPath = subPaths[i], subPathMarkers = [];
                                for(var j = 0; j < subPath.pathSegments.length; j++){
                                    var segment = subPath.pathSegments[j];
                                    if (isNotEqual(segment.totalLength, 0) || j === 0 || j === subPath.pathSegments.length - 1) {
                                        if (segment.hasStart) {
                                            var startMarker = segment.getPointAtLength(0), prevEndMarker = subPathMarkers.pop();
                                            if (prevEndMarker) startMarker[2] = 0.5 * (prevEndMarker[2] + startMarker[2]);
                                            subPathMarkers.push(startMarker);
                                        }
                                        if (segment.hasEnd) {
                                            var endMarker = segment.getPointAtLength(segment.totalLength);
                                            subPathMarkers.push(endMarker);
                                        }
                                    }
                                }
                                markers = markers.concat(subPathMarkers);
                            }
                            return markers;
                        };
                    };
                    var SvgElem = function SvgElem(obj, inherits) {
                        var styleCache = Object.create(null);
                        var childrenCache = null;
                        this.name = obj.nodeName;
                        this.isOuterElement = obj === svg || !obj.parentNode;
                        this.inherits = inherits || (!this.isOuterElement ? createSVGElement(obj.parentNode, null) : null);
                        this.stack = this.inherits ? this.inherits.stack.concat(obj) : [
                            obj
                        ];
                        this.style = parseStyleAttr(typeof obj.getAttribute === 'function' && obj.getAttribute('style'));
                        this.css = useCSS ? getComputedStyle(obj) : getStyle(obj);
                        this.allowedChildren = [];
                        this.attr = function(key) {
                            if (typeof obj.getAttribute === 'function') return obj.getAttribute(key);
                        };
                        this.resolveUrl = function(value) {
                            var temp = (value || '').match(/^\s*(?:url\("(.*)#(.*)"\)|url\('(.*)#(.*)'\)|url\((.*)#(.*)\)|(.*)#(.*))\s*$/) || [];
                            var file = temp[1] || temp[3] || temp[5] || temp[7], id = temp[2] || temp[4] || temp[6] || temp[8];
                            if (id) {
                                if (!file) {
                                    var svgObj = svg.getElementById(id);
                                    if (svgObj) {
                                        if (this.stack.indexOf(svgObj) === -1) return svgObj;
                                        else {
                                            warningCallback('SVGtoPDF: loop of circular references for id "' + id + '"');
                                            return;
                                        }
                                    }
                                }
                                if (documentCallback) {
                                    var svgs = documentCache[file];
                                    if (!svgs) {
                                        svgs = documentCallback(file);
                                        if (!isArrayLike(svgs)) svgs = [
                                            svgs
                                        ];
                                        for(var i = 0; i < svgs.length; i++)if (typeof svgs[i] === 'string') svgs[i] = parseXml(svgs[i]);
                                        documentCache[file] = svgs;
                                    }
                                    for(var _i7 = 0; _i7 < svgs.length; _i7++){
                                        var _svgObj = svgs[_i7].getElementById(id);
                                        if (_svgObj) {
                                            if (this.stack.indexOf(_svgObj) === -1) return _svgObj;
                                            else {
                                                warningCallback('SVGtoPDF: loop of circular references for id "' + file + '#' + id + '"');
                                                return;
                                            }
                                        }
                                    }
                                }
                            }
                        };
                        this.computeUnits = function(value, unit, percent, isFontSize) {
                            if (unit === '%') return parseFloat(value) / 100 * (isFontSize || percent != null ? percent : this.getViewport());
                            else if (unit === 'ex' || unit === 'em') return value * ({
                                'em': 1,
                                'ex': 0.5
                            })[unit] * (isFontSize ? percent : this.get('font-size'));
                            else return value * ({
                                '': 1,
                                'px': 1,
                                'pt': 96 / 72,
                                'cm': 96 / 2.54,
                                'mm': 96 / 25.4,
                                'in': 96,
                                'pc': 16
                            })[unit];
                        };
                        this.computeLength = function(value, percent, initial, isFontSize) {
                            var parser = new StringParser((value || '').trim()), temp1, temp2;
                            if (typeof (temp1 = parser.matchNumber()) === 'string' && typeof (temp2 = parser.matchLengthUnit()) === 'string' && !parser.matchAll()) return this.computeUnits(temp1, temp2, percent, isFontSize);
                            return initial;
                        };
                        this.computeLengthList = function(value, percent, strict) {
                            var parser = new StringParser((value || '').trim()), result = [], temp1, temp2;
                            while(typeof (temp1 = parser.matchNumber()) === 'string' && typeof (temp2 = parser.matchLengthUnit()) === 'string'){
                                result.push(this.computeUnits(temp1, temp2, percent));
                                parser.matchSeparator();
                            }
                            if (strict && parser.matchAll()) return;
                            return result;
                        };
                        this.getLength = function(key, percent, initial) {
                            return this.computeLength(this.attr(key), percent, initial);
                        };
                        this.getLengthList = function(key, percent) {
                            return this.computeLengthList(this.attr(key), percent);
                        };
                        this.getUrl = function(key) {
                            return this.resolveUrl(this.attr(key));
                        };
                        this.getNumberList = function(key) {
                            var parser = new StringParser((this.attr(key) || '').trim()), result = [], temp;
                            while(temp = parser.matchNumber()){
                                result.push(Number(temp));
                                parser.matchSeparator();
                            }
                            result.error = parser.matchAll();
                            return result;
                        };
                        this.getViewbox = function(key, initial) {
                            var viewBox = this.getNumberList(key);
                            if (viewBox.length === 4 && viewBox[2] >= 0 && viewBox[3] >= 0) return viewBox;
                            return initial;
                        };
                        this.getPercent = function(key, initial) {
                            var value = this.attr(key);
                            var parser = new StringParser((value || '').trim()), temp1, temp2;
                            var number = parser.matchNumber();
                            if (!number) return initial;
                            if (parser.match('%')) number *= 0.01;
                            if (parser.matchAll()) return initial;
                            return Math.max(0, Math.min(1, number));
                        };
                        this.chooseValue = function(args) {
                            for(var i = 0; i < arguments.length; i++){
                                if (arguments[i] != null && arguments[i] === arguments[i]) return arguments[i];
                            }
                            return arguments[arguments.length - 1];
                        };
                        this.get = function(key) {
                            if (styleCache[key] !== undefined) return styleCache[key];
                            var keyInfo = Properties[key] || {}, value, result;
                            for(var i = 0; i < 3; i++){
                                switch(i){
                                    case 0:
                                        if (key !== 'transform') // the CSS transform behaves strangely
                                        value = this.css[keyInfo.css || key];
                                        break;
                                    case 1:
                                        value = this.style[key];
                                        break;
                                    case 2:
                                        value = this.attr(key);
                                        break;
                                }
                                if (value === 'inherit') {
                                    result = this.inherits ? this.inherits.get(key) : keyInfo.initial;
                                    if (result != null) return styleCache[key] = result;
                                }
                                if (keyInfo.values != null) {
                                    result = keyInfo.values[value];
                                    if (result != null) return styleCache[key] = result;
                                }
                                if (value != null) {
                                    var parsed = void 0;
                                    switch(key){
                                        case 'font-size':
                                            result = this.computeLength(value, this.inherits ? this.inherits.get(key) : keyInfo.initial, undefined, true);
                                            break;
                                        case 'baseline-shift':
                                            result = this.computeLength(value, this.get('font-size'));
                                            break;
                                        case 'font-family':
                                            result = value || undefined;
                                            break;
                                        case 'opacity':
                                        case 'stroke-opacity':
                                        case 'fill-opacity':
                                        case 'stop-opacity':
                                            parsed = parseFloat(value);
                                            if (!isNaN(parsed)) result = Math.max(0, Math.min(1, parsed));
                                            break;
                                        case 'transform':
                                            result = parseTranform(value);
                                            break;
                                        case 'stroke-dasharray':
                                            if (value === 'none') result = [];
                                            else if (parsed = this.computeLengthList(value, this.getViewport(), true)) {
                                                var sum = 0, error = false;
                                                for(var j = 0; j < parsed.length; j++){
                                                    if (parsed[j] < 0) error = true;
                                                    sum += parsed[j];
                                                }
                                                if (!error) {
                                                    if (parsed.length % 2 === 1) parsed = parsed.concat(parsed);
                                                    result = sum === 0 ? [] : parsed;
                                                }
                                            }
                                            break;
                                        case 'color':
                                            if (value === 'none' || value === 'transparent') result = 'none';
                                            else result = parseColor(value);
                                            break;
                                        case 'fill':
                                        case 'stroke':
                                            if (value === 'none' || value === 'transparent') result = 'none';
                                            else if (value === 'currentColor') result = this.get('color');
                                            else if (parsed = parseColor(value)) return parsed;
                                            else if (parsed = (value || '').split(' ')) {
                                                var object = this.resolveUrl(parsed[0]), fallbackColor = parseColor(parsed[1]);
                                                if (object == null) result = fallbackColor;
                                                else if (object.nodeName === 'linearGradient' || object.nodeName === 'radialGradient') result = new _SvgElemGradient(object, null, fallbackColor);
                                                else if (object.nodeName === 'pattern') result = new _SvgElemPattern(object, null, fallbackColor);
                                                else result = fallbackColor;
                                            }
                                            break;
                                        case 'stop-color':
                                            if (value === 'none' || value === 'transparent') result = 'none';
                                            else if (value === 'currentColor') result = this.get('color');
                                            else result = parseColor(value);
                                            break;
                                        case 'marker-start':
                                        case 'marker-mid':
                                        case 'marker-end':
                                        case 'clip-path':
                                        case 'mask':
                                            if (value === 'none') result = 'none';
                                            else result = this.resolveUrl(value);
                                            break;
                                        case 'stroke-width':
                                            parsed = this.computeLength(value, this.getViewport());
                                            if (parsed != null && parsed >= 0) result = parsed;
                                            break;
                                        case 'stroke-miterlimit':
                                            parsed = parseFloat(value);
                                            if (parsed != null && parsed >= 1) result = parsed;
                                            break;
                                        case 'word-spacing':
                                        case 'letter-spacing':
                                            result = this.computeLength(value, this.getViewport());
                                            break;
                                        case 'stroke-dashoffset':
                                            result = this.computeLength(value, this.getViewport());
                                            if (result != null) {
                                                if (result < 0) {
                                                    // fix for crbug.com/660850
                                                    var dasharray = this.get('stroke-dasharray');
                                                    for(var _j = 0; _j < dasharray.length; _j++)result += dasharray[_j];
                                                }
                                            }
                                            break;
                                    }
                                    if (result != null) return styleCache[key] = result;
                                }
                            }
                            return styleCache[key] = keyInfo.inherit && this.inherits ? this.inherits.get(key) : keyInfo.initial;
                        };
                        this.getChildren = function() {
                            if (childrenCache != null) return childrenCache;
                            var children = [];
                            for(var i = 0; i < obj.childNodes.length; i++){
                                var child = obj.childNodes[i];
                                if (!child.error && this.allowedChildren.indexOf(child.nodeName) !== -1) children.push(createSVGElement(child, this));
                            }
                            return childrenCache = children;
                        };
                        this.getParentVWidth = function() {
                            return this.inherits ? this.inherits.getVWidth() : viewportWidth;
                        };
                        this.getParentVHeight = function() {
                            return this.inherits ? this.inherits.getVHeight() : viewportHeight;
                        };
                        this.getParentViewport = function() {
                            return Math.sqrt(0.5 * this.getParentVWidth() * this.getParentVWidth() + 0.5 * this.getParentVHeight() * this.getParentVHeight());
                        };
                        this.getVWidth = function() {
                            return this.getParentVWidth();
                        };
                        this.getVHeight = function() {
                            return this.getParentVHeight();
                        };
                        this.getViewport = function() {
                            return Math.sqrt(0.5 * this.getVWidth() * this.getVWidth() + 0.5 * this.getVHeight() * this.getVHeight());
                        };
                        this.getBoundingBox = function() {
                            var shape = this.getBoundingShape();
                            return shape.getBoundingBox();
                        };
                    };
                    var SvgElemStylable = function SvgElemStylable(obj, inherits) {
                        SvgElem.call(this, obj, inherits);
                        this.transform = function() {
                            doc.transform.apply(doc, this.getTransformation());
                        };
                        this.clip = function() {
                            if (this.get('clip-path') !== 'none') {
                                var clipPath = new SvgElemClipPath(this.get('clip-path'), null);
                                clipPath.useMask(this.getBoundingBox());
                                return true;
                            }
                        };
                        this.mask = function() {
                            if (this.get('mask') !== 'none') {
                                var mask = new SvgElemMask(this.get('mask'), null);
                                mask.useMask(this.getBoundingBox());
                                return true;
                            }
                        };
                        this.getFill = function(isClip, isMask) {
                            var opacity = this.get('opacity'), fill = this.get('fill'), fillOpacity = this.get('fill-opacity');
                            if (isClip) return DefaultColors.white;
                            if (fill !== 'none' && opacity && fillOpacity) {
                                if (fill instanceof _SvgElemGradient || fill instanceof _SvgElemPattern) return fill.getPaint(this.getBoundingBox(), fillOpacity * opacity, isClip, isMask);
                                return opacityToColor(fill, fillOpacity * opacity, isMask);
                            }
                        };
                        this.getStroke = function(isClip, isMask) {
                            var opacity = this.get('opacity'), stroke = this.get('stroke'), strokeOpacity = this.get('stroke-opacity');
                            if (isClip || isEqual(this.get('stroke-width'), 0)) return;
                            if (stroke !== 'none' && opacity && strokeOpacity) {
                                if (stroke instanceof _SvgElemGradient || stroke instanceof _SvgElemPattern) return stroke.getPaint(this.getBoundingBox(), strokeOpacity * opacity, isClip, isMask);
                                return opacityToColor(stroke, strokeOpacity * opacity, isMask);
                            }
                        };
                    };
                    var SvgElemHasChildren = function SvgElemHasChildren(obj, inherits) {
                        SvgElemStylable.call(this, obj, inherits);
                        this.allowedChildren = [
                            'use',
                            'g',
                            'a',
                            'svg',
                            'image',
                            'rect',
                            'circle',
                            'ellipse',
                            'line',
                            'polyline',
                            'polygon',
                            'path',
                            'text'
                        ];
                        this.getBoundingShape = function() {
                            var shape = new _SvgShape(), children = this.getChildren();
                            for(var i = 0; i < children.length; i++){
                                if (children[i].get('display') !== 'none') {
                                    if (typeof children[i].getBoundingShape === 'function') {
                                        var childShape = children[i].getBoundingShape().clone();
                                        if (typeof children[i].getTransformation === 'function') childShape.transform(children[i].getTransformation());
                                        shape.mergeShape(childShape);
                                    }
                                }
                            }
                            return shape;
                        };
                        this.drawChildren = function(isClip, isMask) {
                            var children = this.getChildren();
                            for(var i = 0; i < children.length; i++){
                                if (children[i].get('display') !== 'none') {
                                    if (typeof children[i].drawInDocument === 'function') children[i].drawInDocument(isClip, isMask);
                                }
                            }
                        };
                    };
                    var SvgElemContainer = function SvgElemContainer(obj, inherits) {
                        SvgElemHasChildren.call(this, obj, inherits);
                        this.drawContent = function(isClip, isMask) {
                            this.transform();
                            var clipped = this.clip(), masked = this.mask(), group;
                            if ((this.get('opacity') < 1 || clipped || masked) && !isClip) group = docBeginGroup(getPageBBox());
                            this.drawChildren(isClip, isMask);
                            if (group) {
                                docEndGroup(group);
                                doc.fillOpacity(this.get('opacity'));
                                docInsertGroup(group);
                            }
                        };
                    };
                    var SvgElemUse = function SvgElemUse(obj, inherits) {
                        SvgElemContainer.call(this, obj, inherits);
                        var x = this.getLength('x', this.getVWidth(), 0), y = this.getLength('y', this.getVHeight(), 0), child = this.getUrl('href') || this.getUrl('xlink:href');
                        if (child) child = createSVGElement(child, this);
                        this.getChildren = function() {
                            return child ? [
                                child
                            ] : [];
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            doc.save();
                            this.drawContent(isClip, isMask);
                            doc.restore();
                        };
                        this.getTransformation = function() {
                            return multiplyMatrix(this.get('transform'), [
                                1,
                                0,
                                0,
                                1,
                                x,
                                y
                            ]);
                        };
                    };
                    var SvgElemSymbol = function SvgElemSymbol(obj, inherits) {
                        SvgElemContainer.call(this, obj, inherits);
                        var width = this.getLength('width', this.getParentVWidth(), this.getParentVWidth()), height = this.getLength('height', this.getParentVHeight(), this.getParentVHeight());
                        if (inherits instanceof SvgElemUse) {
                            width = inherits.getLength('width', inherits.getParentVWidth(), width);
                            height = inherits.getLength('height', inherits.getParentVHeight(), height);
                        }
                        var aspectRatio = (this.attr('preserveAspectRatio') || '').trim(), viewBox = this.getViewbox('viewBox', [
                            0,
                            0,
                            width,
                            height
                        ]);
                        this.getVWidth = function() {
                            return viewBox[2];
                        };
                        this.getVHeight = function() {
                            return viewBox[3];
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            doc.save();
                            this.drawContent(isClip, isMask);
                            doc.restore();
                        };
                        this.getTransformation = function() {
                            return multiplyMatrix(parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3]), [
                                1,
                                0,
                                0,
                                1,
                                -viewBox[0],
                                -viewBox[1]
                            ]);
                        };
                    };
                    var SvgElemGroup = function SvgElemGroup(obj, inherits) {
                        SvgElemContainer.call(this, obj, inherits);
                        this.drawInDocument = function(isClip, isMask) {
                            doc.save();
                            if (this.link && !isClip && !isMask) this.addLink();
                            this.drawContent(isClip, isMask);
                            doc.restore();
                        };
                        this.getTransformation = function() {
                            return this.get('transform');
                        };
                    };
                    var SvgElemLink = function SvgElemLink(obj, inherits) {
                        if (inherits && inherits.isText) {
                            SvgElemTspan.call(this, obj, inherits);
                            this.allowedChildren = [
                                'textPath',
                                'tspan',
                                '#text',
                                '#cdata-section',
                                'a'
                            ];
                        } else SvgElemGroup.call(this, obj, inherits);
                        this.link = this.attr('href') || this.attr('xlink:href');
                        this.addLink = function() {
                            if (this.link.match(/^(?:[a-z][a-z0-9+.-]*:|\/\/)?/i) && this.getChildren().length) {
                                var bbox = this.getBoundingShape().transform(getGlobalMatrix()).getBoundingBox();
                                docInsertLink(bbox[0], bbox[1], bbox[2], bbox[3], this.link);
                            }
                        };
                    };
                    var SvgElemSvg = function SvgElemSvg(obj, inherits) {
                        SvgElemContainer.call(this, obj, inherits);
                        var width = this.getLength('width', this.getParentVWidth(), this.getParentVWidth()), height = this.getLength('height', this.getParentVHeight(), this.getParentVHeight()), x = this.getLength('x', this.getParentVWidth(), 0), y = this.getLength('y', this.getParentVHeight(), 0);
                        if (inherits instanceof SvgElemUse) {
                            width = inherits.getLength('width', inherits.getParentVWidth(), width);
                            height = inherits.getLength('height', inherits.getParentVHeight(), height);
                        }
                        var aspectRatio = this.attr('preserveAspectRatio'), viewBox = this.getViewbox('viewBox', [
                            0,
                            0,
                            width,
                            height
                        ]);
                        if (this.isOuterElement && preserveAspectRatio) {
                            x = y = 0;
                            width = viewportWidth;
                            height = viewportHeight;
                            aspectRatio = preserveAspectRatio;
                        }
                        this.getVWidth = function() {
                            return viewBox[2];
                        };
                        this.getVHeight = function() {
                            return viewBox[3];
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            doc.save();
                            if (this.get('overflow') === 'hidden') {
                                new _SvgShape().M(x, y).L(x + width, y).L(x + width, y + height).L(x, y + height).Z().transform(this.get('transform')).insertInDocument();
                                doc.clip();
                            }
                            this.drawContent(isClip, isMask);
                            doc.restore();
                        };
                        this.getTransformation = function() {
                            return multiplyMatrix(this.get('transform'), [
                                1,
                                0,
                                0,
                                1,
                                x,
                                y
                            ], parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3]), [
                                1,
                                0,
                                0,
                                1,
                                -viewBox[0],
                                -viewBox[1]
                            ]);
                        };
                    };
                    var SVGElemImage = function SVGElemImage(obj, inherits) {
                        SvgElemStylable.call(this, obj, inherits);
                        var link = imageCallback(this.attr('href') || this.attr('xlink:href') || ''), x = this.getLength('x', this.getVWidth(), 0), y = this.getLength('y', this.getVHeight(), 0), width = this.getLength('width', this.getVWidth(), 'auto'), height = this.getLength('height', this.getVHeight(), 'auto'), image;
                        try {
                            image = doc.openImage(link);
                        } catch (e) {
                            warningCallback('SVGElemImage: failed to open image "' + link + '" in PDFKit');
                        }
                        if (image) {
                            if (width === 'auto' && height !== 'auto') width = height * image.width / image.height;
                            else if (height === 'auto' && width !== 'auto') height = width * image.height / image.width;
                            else if (width === 'auto' && height === 'auto') {
                                width = image.width;
                                height = image.height;
                            }
                        }
                        if (width === 'auto' || width < 0) width = 0;
                        if (height === 'auto' || height < 0) height = 0;
                        this.getTransformation = function() {
                            return this.get('transform');
                        };
                        this.getBoundingShape = function() {
                            return new _SvgShape().M(x, y).L(x + width, y).M(x + width, y + height).L(x, y + height);
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            if (this.get('visibility') === 'hidden' || !image) return;
                            doc.save();
                            this.transform();
                            if (this.get('overflow') === 'hidden') doc.rect(x, y, width, height).clip();
                            this.clip();
                            this.mask();
                            doc.translate(x, y);
                            doc.transform.apply(doc, parseAspectRatio(this.attr('preserveAspectRatio'), width, height, image ? image.width : width, image ? image.height : height));
                            if (!isClip) {
                                doc.fillOpacity(this.get('opacity'));
                                doc.image(image, 0, 0);
                            } else {
                                doc.rect(0, 0, image.width, image.height);
                                docFillColor(DefaultColors.white).fill();
                            }
                            doc.restore();
                        };
                    };
                    var _SvgElemPattern = function SvgElemPattern(obj, inherits, fallback) {
                        SvgElemHasChildren.call(this, obj, inherits);
                        this.ref = (function() {
                            var ref = this.getUrl('href') || this.getUrl('xlink:href');
                            if (ref && ref.nodeName === obj.nodeName) return new _SvgElemPattern(ref, inherits, fallback);
                        }).call(this);
                        var _attr = this.attr;
                        this.attr = function(key) {
                            var attr = _attr.call(this, key);
                            if (attr != null || key === 'href' || key === 'xlink:href') return attr;
                            return this.ref ? this.ref.attr(key) : null;
                        };
                        var _getChildren = this.getChildren;
                        this.getChildren = function() {
                            var children = _getChildren.call(this);
                            if (children.length > 0) return children;
                            return this.ref ? this.ref.getChildren() : [];
                        };
                        this.getPaint = function(bBox, gOpacity, isClip, isMask) {
                            var bBoxUnitsPattern = this.attr('patternUnits') !== 'userSpaceOnUse', bBoxUnitsContent = this.attr('patternContentUnits') === 'objectBoundingBox', x = this.getLength('x', bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0), y = this.getLength('y', bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0), width = this.getLength('width', bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0), height = this.getLength('height', bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0);
                            if (bBoxUnitsContent && !bBoxUnitsPattern) {
                                // Use the same units for pattern & pattern content
                                x = (x - bBox[0]) / (bBox[2] - bBox[0]) || 0;
                                y = (y - bBox[1]) / (bBox[3] - bBox[1]) || 0;
                                width = width / (bBox[2] - bBox[0]) || 0;
                                height = height / (bBox[3] - bBox[1]) || 0;
                            } else if (!bBoxUnitsContent && bBoxUnitsPattern) {
                                x = bBox[0] + x * (bBox[2] - bBox[0]);
                                y = bBox[1] + y * (bBox[3] - bBox[1]);
                                width = width * (bBox[2] - bBox[0]);
                                height = height * (bBox[3] - bBox[1]);
                            }
                            var viewBox = this.getViewbox('viewBox', [
                                0,
                                0,
                                width,
                                height
                            ]), aspectRatio = (this.attr('preserveAspectRatio') || '').trim(), aspectRatioMatrix = multiplyMatrix(parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3], 0), [
                                1,
                                0,
                                0,
                                1,
                                -viewBox[0],
                                -viewBox[1]
                            ]), matrix = parseTranform(this.attr('patternTransform'));
                            if (bBoxUnitsContent) matrix = multiplyMatrix([
                                bBox[2] - bBox[0],
                                0,
                                0,
                                bBox[3] - bBox[1],
                                bBox[0],
                                bBox[1]
                            ], matrix);
                            matrix = multiplyMatrix(matrix, [
                                1,
                                0,
                                0,
                                1,
                                x,
                                y
                            ]);
                            if ((matrix = validateMatrix(matrix)) && (aspectRatioMatrix = validateMatrix(aspectRatioMatrix)) && (width = validateNumber(width)) && (height = validateNumber(height))) {
                                var group = docBeginGroup([
                                    0,
                                    0,
                                    width,
                                    height
                                ]);
                                doc.transform.apply(doc, aspectRatioMatrix);
                                this.drawChildren(isClip, isMask);
                                docEndGroup(group);
                                return [
                                    docCreatePattern(group, width, height, matrix),
                                    gOpacity
                                ];
                            } else return fallback ? [
                                fallback[0],
                                fallback[1] * gOpacity
                            ] : undefined;
                        };
                        this.getVWidth = function() {
                            var bBoxUnitsPattern = this.attr('patternUnits') !== 'userSpaceOnUse', width = this.getLength('width', bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0);
                            return this.getViewbox('viewBox', [
                                0,
                                0,
                                width,
                                0
                            ])[2];
                        };
                        this.getVHeight = function() {
                            var bBoxUnitsPattern = this.attr('patternUnits') !== 'userSpaceOnUse', height = this.getLength('height', bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0);
                            return this.getViewbox('viewBox', [
                                0,
                                0,
                                0,
                                height
                            ])[3];
                        };
                    };
                    var _SvgElemGradient = function SvgElemGradient(obj, inherits, fallback) {
                        SvgElem.call(this, obj, inherits);
                        this.allowedChildren = [
                            'stop'
                        ];
                        this.ref = (function() {
                            var ref = this.getUrl('href') || this.getUrl('xlink:href');
                            if (ref && ref.nodeName === obj.nodeName) return new _SvgElemGradient(ref, inherits, fallback);
                        }).call(this);
                        var _attr = this.attr;
                        this.attr = function(key) {
                            var attr = _attr.call(this, key);
                            if (attr != null || key === 'href' || key === 'xlink:href') return attr;
                            return this.ref ? this.ref.attr(key) : null;
                        };
                        var _getChildren = this.getChildren;
                        this.getChildren = function() {
                            var children = _getChildren.call(this);
                            if (children.length > 0) return children;
                            return this.ref ? this.ref.getChildren() : [];
                        };
                        this.getPaint = function(bBox, gOpacity, isClip, isMask) {
                            var children = this.getChildren();
                            if (children.length === 0) return;
                            if (children.length === 1) {
                                var child = children[0], stopColor = child.get('stop-color');
                                if (stopColor === 'none') return;
                                return opacityToColor(stopColor, child.get('stop-opacity') * gOpacity, isMask);
                            }
                            var bBoxUnits = this.attr('gradientUnits') !== 'userSpaceOnUse', matrix = parseTranform(this.attr('gradientTransform')), spread = this.attr('spreadMethod'), grad, x1, x2, y1, y2, r2, nAfter = 0, nBefore = 0, nTotal = 1;
                            if (bBoxUnits) matrix = multiplyMatrix([
                                bBox[2] - bBox[0],
                                0,
                                0,
                                bBox[3] - bBox[1],
                                bBox[0],
                                bBox[1]
                            ], matrix);
                            if (matrix = validateMatrix(matrix)) {
                                if (this.name === 'linearGradient') {
                                    x1 = this.getLength('x1', bBoxUnits ? 1 : this.getVWidth(), 0);
                                    x2 = this.getLength('x2', bBoxUnits ? 1 : this.getVWidth(), bBoxUnits ? 1 : this.getVWidth());
                                    y1 = this.getLength('y1', bBoxUnits ? 1 : this.getVHeight(), 0);
                                    y2 = this.getLength('y2', bBoxUnits ? 1 : this.getVHeight(), 0);
                                } else {
                                    x2 = this.getLength('cx', bBoxUnits ? 1 : this.getVWidth(), bBoxUnits ? 0.5 : 0.5 * this.getVWidth());
                                    y2 = this.getLength('cy', bBoxUnits ? 1 : this.getVHeight(), bBoxUnits ? 0.5 : 0.5 * this.getVHeight());
                                    r2 = this.getLength('r', bBoxUnits ? 1 : this.getViewport(), bBoxUnits ? 0.5 : 0.5 * this.getViewport());
                                    x1 = this.getLength('fx', bBoxUnits ? 1 : this.getVWidth(), x2);
                                    y1 = this.getLength('fy', bBoxUnits ? 1 : this.getVHeight(), y2);
                                    if (r2 < 0) warningCallback('SvgElemGradient: negative r value');
                                    var d = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), multiplier = 1;
                                    if (d > r2) {
                                        // according to specification
                                        multiplier = r2 / d;
                                        x1 = x2 + (x1 - x2) * multiplier;
                                        y1 = y2 + (y1 - y2) * multiplier;
                                    }
                                    r2 = Math.max(r2, d * multiplier * (1 + 1e-6)); // fix for edge-case gradients see issue #84
                                }
                                if (spread === 'reflect' || spread === 'repeat') {
                                    var inv = inverseMatrix(matrix), corner1 = transformPoint([
                                        bBox[0],
                                        bBox[1]
                                    ], inv), corner2 = transformPoint([
                                        bBox[2],
                                        bBox[1]
                                    ], inv), corner3 = transformPoint([
                                        bBox[2],
                                        bBox[3]
                                    ], inv), corner4 = transformPoint([
                                        bBox[0],
                                        bBox[3]
                                    ], inv);
                                    if (this.name === 'linearGradient') {
                                        // See file 'gradient-repeat-maths.png'
                                        nAfter = Math.max((corner1[0] - x2) * (x2 - x1) + (corner1[1] - y2) * (y2 - y1), (corner2[0] - x2) * (x2 - x1) + (corner2[1] - y2) * (y2 - y1), (corner3[0] - x2) * (x2 - x1) + (corner3[1] - y2) * (y2 - y1), (corner4[0] - x2) * (x2 - x1) + (corner4[1] - y2) * (y2 - y1)) / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                                        nBefore = Math.max((corner1[0] - x1) * (x1 - x2) + (corner1[1] - y1) * (y1 - y2), (corner2[0] - x1) * (x1 - x2) + (corner2[1] - y1) * (y1 - y2), (corner3[0] - x1) * (x1 - x2) + (corner3[1] - y1) * (y1 - y2), (corner4[0] - x1) * (x1 - x2) + (corner4[1] - y1) * (y1 - y2)) / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                                    } else nAfter = Math.sqrt(Math.max(Math.pow(corner1[0] - x2, 2) + Math.pow(corner1[1] - y2, 2), Math.pow(corner2[0] - x2, 2) + Math.pow(corner2[1] - y2, 2), Math.pow(corner3[0] - x2, 2) + Math.pow(corner3[1] - y2, 2), Math.pow(corner4[0] - x2, 2) + Math.pow(corner4[1] - y2, 2))) / r2 - 1;
                                    nAfter = Math.ceil(nAfter + 0.5); // Add a little more because the stroke can extend outside of the bounding box
                                    nBefore = Math.ceil(nBefore + 0.5);
                                    nTotal = nBefore + 1 + nAfter; // How many times the gradient needs to be repeated to fill the object bounding box
                                }
                                if (this.name === 'linearGradient') grad = doc.linearGradient(x1 - nBefore * (x2 - x1), y1 - nBefore * (y2 - y1), x2 + nAfter * (x2 - x1), y2 + nAfter * (y2 - y1));
                                else grad = doc.radialGradient(x1, y1, 0, x2, y2, r2 + nAfter * r2);
                                for(var n = 0; n < nTotal; n++){
                                    var offset = 0, inOrder = spread !== 'reflect' || (n - nBefore) % 2 === 0;
                                    for(var i = 0; i < children.length; i++){
                                        var _child = children[inOrder ? i : children.length - 1 - i], _stopColor = _child.get('stop-color');
                                        if (_stopColor === 'none') _stopColor = DefaultColors.transparent;
                                        _stopColor = opacityToColor(_stopColor, _child.get('stop-opacity') * gOpacity, isMask);
                                        offset = Math.max(offset, inOrder ? _child.getPercent('offset', 0) : 1 - _child.getPercent('offset', 0));
                                        if (i === 0 && _stopColor[0].length === 4) grad._colorSpace = 'DeviceCMYK';
                                         // Fix until PR #763 is merged into PDFKit
                                        if (i === 0 && offset > 0) grad.stop((n + 0) / nTotal, _stopColor[0], _stopColor[1]);
                                        grad.stop((n + offset) / (nAfter + nBefore + 1), _stopColor[0], _stopColor[1]);
                                        if (i === children.length - 1 && offset < 1) grad.stop((n + 1) / nTotal, _stopColor[0], _stopColor[1]);
                                    }
                                }
                                grad.setTransform.apply(grad, matrix);
                                return [
                                    grad,
                                    1
                                ];
                            } else return fallback ? [
                                fallback[0],
                                fallback[1] * gOpacity
                            ] : undefined;
                        };
                    };
                    var SvgElemBasicShape = function SvgElemBasicShape(obj, inherits) {
                        SvgElemStylable.call(this, obj, inherits);
                        this.dashScale = 1;
                        this.getBoundingShape = function() {
                            return this.shape;
                        };
                        this.getTransformation = function() {
                            return this.get('transform');
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            if (this.get('visibility') === 'hidden' || !this.shape) return;
                            doc.save();
                            this.transform();
                            this.clip();
                            if (!isClip) {
                                var masked = this.mask(), group;
                                if (masked) group = docBeginGroup(getPageBBox());
                                var subPaths = this.shape.getSubPaths(), fill = this.getFill(isClip, isMask), stroke = this.getStroke(isClip, isMask), lineWidth = this.get('stroke-width'), lineCap = this.get('stroke-linecap');
                                if (fill || stroke) {
                                    if (fill) docFillColor(fill);
                                    if (stroke) {
                                        for(var j = 0; j < subPaths.length; j++)if (isEqual(subPaths[j].totalLength, 0)) {
                                            if ((lineCap === 'square' || lineCap === 'round') && lineWidth > 0) {
                                                if (subPaths[j].startPoint && subPaths[j].startPoint.length > 1) {
                                                    var _x4 = subPaths[j].startPoint[0], _y4 = subPaths[j].startPoint[1];
                                                    docFillColor(stroke);
                                                    if (lineCap === 'square') doc.rect(_x4 - 0.5 * lineWidth, _y4 - 0.5 * lineWidth, lineWidth, lineWidth);
                                                    else if (lineCap === 'round') doc.circle(_x4, _y4, 0.5 * lineWidth);
                                                    doc.fill();
                                                }
                                            }
                                        }
                                        var dashArray = this.get('stroke-dasharray'), dashOffset = this.get('stroke-dashoffset');
                                        if (isNotEqual(this.dashScale, 1)) {
                                            for(var _j2 = 0; _j2 < dashArray.length; _j2++)dashArray[_j2] *= this.dashScale;
                                            dashOffset *= this.dashScale;
                                        }
                                        docStrokeColor(stroke);
                                        doc.lineWidth(lineWidth).miterLimit(this.get('stroke-miterlimit')).lineJoin(this.get('stroke-linejoin')).lineCap(lineCap).dash(dashArray, {
                                            phase: dashOffset
                                        });
                                    }
                                    for(var _j3 = 0; _j3 < subPaths.length; _j3++)if (subPaths[_j3].totalLength > 0) subPaths[_j3].insertInDocument();
                                    if (fill && stroke) doc.fillAndStroke(this.get('fill-rule'));
                                    else if (fill) doc.fill(this.get('fill-rule'));
                                    else if (stroke) doc.stroke();
                                }
                                var markerStart = this.get('marker-start'), markerMid = this.get('marker-mid'), markerEnd = this.get('marker-end');
                                if (markerStart !== 'none' || markerMid !== 'none' || markerEnd !== 'none') {
                                    var markersPos = this.shape.getMarkers();
                                    if (markerStart !== 'none') {
                                        var marker = new SvgElemMarker(markerStart, null);
                                        marker.drawMarker(false, isMask, markersPos[0], lineWidth);
                                    }
                                    if (markerMid !== 'none') for(var i = 1; i < markersPos.length - 1; i++){
                                        var _marker = new SvgElemMarker(markerMid, null);
                                        _marker.drawMarker(false, isMask, markersPos[i], lineWidth);
                                    }
                                    if (markerEnd !== 'none') {
                                        var _marker2 = new SvgElemMarker(markerEnd, null);
                                        _marker2.drawMarker(false, isMask, markersPos[markersPos.length - 1], lineWidth);
                                    }
                                }
                                if (group) {
                                    docEndGroup(group);
                                    docInsertGroup(group);
                                }
                            } else {
                                this.shape.insertInDocument();
                                docFillColor(DefaultColors.white);
                                doc.fill(this.get('clip-rule'));
                            }
                            doc.restore();
                        };
                    };
                    var SvgElemRect = function SvgElemRect(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var x = this.getLength('x', this.getVWidth(), 0), y = this.getLength('y', this.getVHeight(), 0), w = this.getLength('width', this.getVWidth(), 0), h = this.getLength('height', this.getVHeight(), 0), rx = this.getLength('rx', this.getVWidth()), ry = this.getLength('ry', this.getVHeight());
                        if (rx === undefined && ry === undefined) rx = ry = 0;
                        else if (rx === undefined && ry !== undefined) rx = ry;
                        else if (rx !== undefined && ry === undefined) ry = rx;
                        if (w > 0 && h > 0) {
                            if (rx && ry) {
                                rx = Math.min(rx, 0.5 * w);
                                ry = Math.min(ry, 0.5 * h);
                                this.shape = new _SvgShape().M(x + rx, y).L(x + w - rx, y).A(rx, ry, 0, 0, 1, x + w, y + ry).L(x + w, y + h - ry).A(rx, ry, 0, 0, 1, x + w - rx, y + h).L(x + rx, y + h).A(rx, ry, 0, 0, 1, x, y + h - ry).L(x, y + ry).A(rx, ry, 0, 0, 1, x + rx, y).Z();
                            } else this.shape = new _SvgShape().M(x, y).L(x + w, y).L(x + w, y + h).L(x, y + h).Z();
                        } else this.shape = new _SvgShape();
                    };
                    var SvgElemCircle = function SvgElemCircle(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var cx = this.getLength('cx', this.getVWidth(), 0), cy = this.getLength('cy', this.getVHeight(), 0), r = this.getLength('r', this.getViewport(), 0);
                        if (r > 0) this.shape = new _SvgShape().M(cx + r, cy).A(r, r, 0, 0, 1, cx - r, cy).A(r, r, 0, 0, 1, cx + r, cy).Z();
                        else this.shape = new _SvgShape();
                    };
                    var SvgElemEllipse = function SvgElemEllipse(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var cx = this.getLength('cx', this.getVWidth(), 0), cy = this.getLength('cy', this.getVHeight(), 0), rx = this.getLength('rx', this.getVWidth(), 0), ry = this.getLength('ry', this.getVHeight(), 0);
                        if (rx > 0 && ry > 0) this.shape = new _SvgShape().M(cx + rx, cy).A(rx, ry, 0, 0, 1, cx - rx, cy).A(rx, ry, 0, 0, 1, cx + rx, cy).Z();
                        else this.shape = new _SvgShape();
                    };
                    var SvgElemLine = function SvgElemLine(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var x1 = this.getLength('x1', this.getVWidth(), 0), y1 = this.getLength('y1', this.getVHeight(), 0), x2 = this.getLength('x2', this.getVWidth(), 0), y2 = this.getLength('y2', this.getVHeight(), 0);
                        this.shape = new _SvgShape().M(x1, y1).L(x2, y2);
                    };
                    var SvgElemPolyline = function SvgElemPolyline(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var points = this.getNumberList('points');
                        this.shape = new _SvgShape();
                        for(var i = 0; i < points.length - 1; i += 2)if (i === 0) this.shape.M(points[i], points[i + 1]);
                        else this.shape.L(points[i], points[i + 1]);
                        if (points.error) warningCallback('SvgElemPolygon: unexpected string ' + points.error);
                        if (points.length % 2 === 1) warningCallback('SvgElemPolyline: uneven number of coordinates');
                    };
                    var SvgElemPolygon = function SvgElemPolygon(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        var points = this.getNumberList('points');
                        this.shape = new _SvgShape();
                        for(var i = 0; i < points.length - 1; i += 2)if (i === 0) this.shape.M(points[i], points[i + 1]);
                        else this.shape.L(points[i], points[i + 1]);
                        this.shape.Z();
                        if (points.error) warningCallback('SvgElemPolygon: unexpected string ' + points.error);
                        if (points.length % 2 === 1) warningCallback('SvgElemPolygon: uneven number of coordinates');
                    };
                    var SvgElemPath = function SvgElemPath(obj, inherits) {
                        SvgElemBasicShape.call(this, obj, inherits);
                        this.shape = new _SvgShape().path(this.attr('d'));
                        var pathLength = this.getLength('pathLength', this.getViewport());
                        this.pathLength = pathLength > 0 ? pathLength : undefined;
                        this.dashScale = this.pathLength !== undefined ? this.shape.totalLength / this.pathLength : 1;
                    };
                    var SvgElemMarker = function SvgElemMarker(obj, inherits) {
                        SvgElemHasChildren.call(this, obj, inherits);
                        var width = this.getLength('markerWidth', this.getParentVWidth(), 3), height = this.getLength('markerHeight', this.getParentVHeight(), 3), viewBox = this.getViewbox('viewBox', [
                            0,
                            0,
                            width,
                            height
                        ]);
                        this.getVWidth = function() {
                            return viewBox[2];
                        };
                        this.getVHeight = function() {
                            return viewBox[3];
                        };
                        this.drawMarker = function(isClip, isMask, posArray, strokeWidth) {
                            doc.save();
                            var orient = this.attr('orient'), units = this.attr('markerUnits'), rotate = orient === 'auto' ? posArray[2] : (parseFloat(orient) || 0) * Math.PI / 180, scale = units === 'userSpaceOnUse' ? 1 : strokeWidth;
                            doc.transform(Math.cos(rotate) * scale, Math.sin(rotate) * scale, -Math.sin(rotate) * scale, Math.cos(rotate) * scale, posArray[0], posArray[1]);
                            var refX = this.getLength('refX', this.getVWidth(), 0), refY = this.getLength('refY', this.getVHeight(), 0), aspectRatioMatrix = parseAspectRatio(this.attr('preserveAspectRatio'), width, height, viewBox[2], viewBox[3], 0.5);
                            if (this.get('overflow') === 'hidden') doc.rect(aspectRatioMatrix[0] * (viewBox[0] + viewBox[2] / 2 - refX) - width / 2, aspectRatioMatrix[3] * (viewBox[1] + viewBox[3] / 2 - refY) - height / 2, width, height).clip();
                            doc.transform.apply(doc, aspectRatioMatrix);
                            doc.translate(-refX, -refY);
                            var group;
                            if (this.get('opacity') < 1 && !isClip) group = docBeginGroup(getPageBBox());
                            this.drawChildren(isClip, isMask);
                            if (group) {
                                docEndGroup(group);
                                doc.fillOpacity(this.get('opacity'));
                                docInsertGroup(group);
                            }
                            doc.restore();
                        };
                    };
                    var SvgElemClipPath = function SvgElemClipPath(obj, inherits) {
                        SvgElemHasChildren.call(this, obj, inherits);
                        this.useMask = function(bBox) {
                            var group = docBeginGroup(getPageBBox());
                            doc.save();
                            if (this.attr('clipPathUnits') === 'objectBoundingBox') doc.transform(bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]);
                            this.clip();
                            this.drawChildren(true, false);
                            doc.restore();
                            docEndGroup(group);
                            docApplyMask(group, true);
                        };
                    };
                    var SvgElemMask = function SvgElemMask(obj, inherits) {
                        SvgElemHasChildren.call(this, obj, inherits);
                        this.useMask = function(bBox) {
                            var group = docBeginGroup(getPageBBox());
                            doc.save();
                            var x, y, w, h;
                            if (this.attr('maskUnits') === 'userSpaceOnUse') {
                                x = this.getLength('x', this.getVWidth(), -0.1 * (bBox[2] - bBox[0]) + bBox[0]);
                                y = this.getLength('y', this.getVHeight(), -0.1 * (bBox[3] - bBox[1]) + bBox[1]);
                                w = this.getLength('width', this.getVWidth(), 1.2 * (bBox[2] - bBox[0]));
                                h = this.getLength('height', this.getVHeight(), 1.2 * (bBox[3] - bBox[1]));
                            } else {
                                x = this.getLength('x', this.getVWidth(), -0.1) * (bBox[2] - bBox[0]) + bBox[0];
                                y = this.getLength('y', this.getVHeight(), -0.1) * (bBox[3] - bBox[1]) + bBox[1];
                                w = this.getLength('width', this.getVWidth(), 1.2) * (bBox[2] - bBox[0]);
                                h = this.getLength('height', this.getVHeight(), 1.2) * (bBox[3] - bBox[1]);
                            }
                            doc.rect(x, y, w, h).clip();
                            if (this.attr('maskContentUnits') === 'objectBoundingBox') doc.transform(bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]);
                            this.clip();
                            this.drawChildren(false, true);
                            doc.restore();
                            docEndGroup(group);
                            docApplyMask(group, true);
                        };
                    };
                    var SvgElemTextContainer = function SvgElemTextContainer(obj, inherits) {
                        SvgElemStylable.call(this, obj, inherits);
                        this.allowedChildren = [
                            'tspan',
                            '#text',
                            '#cdata-section',
                            'a'
                        ];
                        this.isText = true;
                        this.getBoundingShape = function() {
                            var shape = new _SvgShape();
                            for(var i = 0; i < this._pos.length; i++){
                                var pos = this._pos[i];
                                if (!pos.hidden) {
                                    var dx0 = pos.ascent * Math.sin(pos.rotate), dy0 = -pos.ascent * Math.cos(pos.rotate), dx1 = pos.descent * Math.sin(pos.rotate), dy1 = -pos.descent * Math.cos(pos.rotate), dx2 = pos.width * Math.cos(pos.rotate), dy2 = pos.width * Math.sin(pos.rotate);
                                    shape.M(pos.x + dx0, pos.y + dy0).L(pos.x + dx0 + dx2, pos.y + dy0 + dy2).M(pos.x + dx1 + dx2, pos.y + dy1 + dy2).L(pos.x + dx1, pos.y + dy1);
                                }
                            }
                            return shape;
                        };
                        this.drawTextInDocument = function(isClip, isMask) {
                            if (this.link && !isClip && !isMask) this.addLink();
                            if (this.get('text-decoration') === 'underline') this.decorate(0.05 * this._font.size, -0.075 * this._font.size, isClip, isMask);
                            if (this.get('text-decoration') === 'overline') this.decorate(0.05 * this._font.size, getAscent(this._font.font, this._font.size) + 0.075 * this._font.size, isClip, isMask);
                            var fill = this.getFill(isClip, isMask), stroke = this.getStroke(isClip, isMask), strokeWidth = this.get('stroke-width');
                            if (this._font.fauxBold) {
                                if (!stroke) {
                                    stroke = fill;
                                    strokeWidth = this._font.size * 0.03;
                                } else strokeWidth += this._font.size * 0.03;
                            }
                            var children = this.getChildren();
                            for(var i = 0; i < children.length; i++){
                                var childElem = children[i];
                                switch(childElem.name){
                                    case 'tspan':
                                    case 'textPath':
                                    case 'a':
                                        if (childElem.get('display') !== 'none') childElem.drawTextInDocument(isClip, isMask);
                                        break;
                                    case '#text':
                                    case '#cdata-section':
                                        if (this.get('visibility') === 'hidden') continue;
                                        if (fill || stroke || isClip) {
                                            if (fill) docFillColor(fill);
                                            if (stroke && strokeWidth) {
                                                docStrokeColor(stroke);
                                                doc.lineWidth(strokeWidth).miterLimit(this.get('stroke-miterlimit')).lineJoin(this.get('stroke-linejoin')).lineCap(this.get('stroke-linecap')).dash(this.get('stroke-dasharray'), {
                                                    phase: this.get('stroke-dashoffset')
                                                });
                                            }
                                            docBeginText(this._font.font, this._font.size);
                                            docSetTextMode(!!fill, !!stroke);
                                            for(var j = 0, pos = childElem._pos; j < pos.length; j++)if (!pos[j].hidden && isNotEqual(pos[j].width, 0)) {
                                                var cos = Math.cos(pos[j].rotate), sin = Math.sin(pos[j].rotate), skew = this._font.fauxItalic ? -0.25 : 0;
                                                docSetTextMatrix(cos * pos[j].scale, sin * pos[j].scale, cos * skew - sin, sin * skew + cos, pos[j].x, pos[j].y);
                                                docWriteGlyph(pos[j].glyph);
                                            }
                                            docEndText();
                                        }
                                        break;
                                }
                            }
                            if (this.get('text-decoration') === 'line-through') this.decorate(0.05 * this._font.size, 0.5 * (getAscent(this._font.font, this._font.size) + getDescent(this._font.font, this._font.size)), isClip, isMask);
                        };
                        this.decorate = function(lineWidth, linePosition, isClip, isMask) {
                            var fill = this.getFill(isClip, isMask), stroke = this.getStroke(isClip, isMask);
                            if (fill) docFillColor(fill);
                            if (stroke) {
                                docStrokeColor(stroke);
                                doc.lineWidth(this.get('stroke-width')).miterLimit(this.get('stroke-miterlimit')).lineJoin(this.get('stroke-linejoin')).lineCap(this.get('stroke-linecap')).dash(this.get('stroke-dasharray'), {
                                    phase: this.get('stroke-dashoffset')
                                });
                            }
                            for(var j = 0, pos = this._pos; j < pos.length; j++)if (!pos[j].hidden && isNotEqual(pos[j].width, 0)) {
                                var dx0 = (linePosition + lineWidth / 2) * Math.sin(pos[j].rotate), dy0 = -(linePosition + lineWidth / 2) * Math.cos(pos[j].rotate), dx1 = (linePosition - lineWidth / 2) * Math.sin(pos[j].rotate), dy1 = -(linePosition - lineWidth / 2) * Math.cos(pos[j].rotate), dx2 = pos[j].width * Math.cos(pos[j].rotate), dy2 = pos[j].width * Math.sin(pos[j].rotate);
                                new _SvgShape().M(pos[j].x + dx0, pos[j].y + dy0).L(pos[j].x + dx0 + dx2, pos[j].y + dy0 + dy2).L(pos[j].x + dx1 + dx2, pos[j].y + dy1 + dy2).L(pos[j].x + dx1, pos[j].y + dy1).Z().insertInDocument();
                                if (fill && stroke) doc.fillAndStroke();
                                else if (fill) doc.fill();
                                else if (stroke) doc.stroke();
                            }
                        };
                    };
                    var SvgElemTextNode = function SvgElemTextNode(obj, inherits) {
                        this.name = obj.nodeName;
                        this.textContent = obj.nodeValue;
                    };
                    var SvgElemTspan = function SvgElemTspan(obj, inherits) {
                        SvgElemTextContainer.call(this, obj, inherits);
                    };
                    var SvgElemTextPath = function SvgElemTextPath(obj, inherits) {
                        SvgElemTextContainer.call(this, obj, inherits);
                        var pathObject, pathLength, temp;
                        if ((temp = this.attr('path')) && temp.trim() !== '') {
                            var _pathLength = this.getLength('pathLength', this.getViewport());
                            this.pathObject = new _SvgShape().path(temp);
                            this.pathLength = _pathLength > 0 ? _pathLength : this.pathObject.totalLength;
                            this.pathScale = this.pathObject.totalLength / this.pathLength;
                        } else if ((temp = this.getUrl('href') || this.getUrl('xlink:href')) && temp.nodeName === 'path') {
                            var pathElem = new SvgElemPath(temp, this);
                            this.pathObject = pathElem.shape.clone().transform(pathElem.get('transform'));
                            this.pathLength = this.chooseValue(pathElem.pathLength, this.pathObject.totalLength);
                            this.pathScale = this.pathObject.totalLength / this.pathLength;
                        }
                    };
                    var SvgElemText = function SvgElemText(obj, inherits) {
                        SvgElemTextContainer.call(this, obj, inherits);
                        this.allowedChildren = [
                            'textPath',
                            'tspan',
                            '#text',
                            '#cdata-section',
                            'a'
                        ];
                        (function(textParentElem) {
                            var processedText = '', remainingText = obj.textContent, textPaths = [], currentChunk = [], currentAnchor, currentDirection, currentX = 0, currentY = 0;
                            function doAnchoring() {
                                if (currentChunk.length) {
                                    var last = currentChunk[currentChunk.length - 1];
                                    var first = currentChunk[0];
                                    var width = last.x + last.width - first.x;
                                    var anchordx = {
                                        'startltr': 0,
                                        'middleltr': 0.5,
                                        'endltr': 1,
                                        'startrtl': 1,
                                        'middlertl': 0.5,
                                        'endrtl': 0
                                    }[currentAnchor + currentDirection] * width || 0;
                                    for(var i = 0; i < currentChunk.length; i++)currentChunk[i].x -= anchordx;
                                }
                                currentChunk = [];
                            }
                            function adjustLength(pos, length, spacingAndGlyphs) {
                                var firstChar = pos[0], lastChar = pos[pos.length - 1], startX = firstChar.x, endX = lastChar.x + lastChar.width;
                                if (spacingAndGlyphs) {
                                    var textScale = length / (endX - startX);
                                    if (textScale > 0 && textScale < Infinity) for(var j = 0; j < pos.length; j++){
                                        pos[j].x = startX + textScale * (pos[j].x - startX);
                                        pos[j].scale *= textScale;
                                        pos[j].width *= textScale;
                                    }
                                } else if (pos.length >= 2) {
                                    var spaceDiff = (length - (endX - startX)) / (pos.length - 1);
                                    for(var _j4 = 0; _j4 < pos.length; _j4++)pos[_j4].x += _j4 * spaceDiff;
                                }
                                currentX += length - (endX - startX);
                            }
                            function recursive(currentElem, parentElem) {
                                currentElem._x = combineArrays(currentElem.getLengthList('x', currentElem.getVWidth()), parentElem ? parentElem._x.slice(parentElem._pos.length) : []);
                                currentElem._y = combineArrays(currentElem.getLengthList('y', currentElem.getVHeight()), parentElem ? parentElem._y.slice(parentElem._pos.length) : []);
                                currentElem._dx = combineArrays(currentElem.getLengthList('dx', currentElem.getVWidth()), parentElem ? parentElem._dx.slice(parentElem._pos.length) : []);
                                currentElem._dy = combineArrays(currentElem.getLengthList('dy', currentElem.getVHeight()), parentElem ? parentElem._dy.slice(parentElem._pos.length) : []);
                                currentElem._rot = combineArrays(currentElem.getNumberList('rotate'), parentElem ? parentElem._rot.slice(parentElem._pos.length) : []);
                                currentElem._defRot = currentElem.chooseValue(currentElem._rot[currentElem._rot.length - 1], parentElem && parentElem._defRot, 0);
                                if (currentElem.name === 'textPath') currentElem._y = [];
                                var fontOptions = {
                                    fauxItalic: false,
                                    fauxBold: false
                                }, fontNameorLink = fontCallback(currentElem.get('font-family'), currentElem.get('font-weight') === 'bold', currentElem.get('font-style') === 'italic', fontOptions);
                                try {
                                    doc.font(fontNameorLink);
                                } catch (e) {
                                    warningCallback('SVGElemText: failed to open font "' + fontNameorLink + '" in PDFKit');
                                }
                                currentElem._pos = [];
                                currentElem._index = 0;
                                currentElem._font = {
                                    font: doc._font,
                                    size: currentElem.get('font-size'),
                                    fauxItalic: fontOptions.fauxItalic,
                                    fauxBold: fontOptions.fauxBold
                                };
                                var textLength = currentElem.getLength('textLength', currentElem.getVWidth(), undefined), spacingAndGlyphs = currentElem.attr('lengthAdjust') === 'spacingAndGlyphs', wordSpacing = currentElem.get('word-spacing'), letterSpacing = currentElem.get('letter-spacing'), textAnchor = currentElem.get('text-anchor'), textDirection = currentElem.get('direction'), baseline = getBaseline(currentElem._font.font, currentElem._font.size, currentElem.get('alignment-baseline') || currentElem.get('dominant-baseline'), currentElem.get('baseline-shift'));
                                if (currentElem.name === 'textPath') {
                                    doAnchoring();
                                    currentX = currentY = 0;
                                }
                                var children = currentElem.getChildren();
                                for(var i = 0; i < children.length; i++){
                                    var childElem = children[i];
                                    switch(childElem.name){
                                        case 'tspan':
                                        case 'textPath':
                                        case 'a':
                                            recursive(childElem, currentElem);
                                            break;
                                        case '#text':
                                        case '#cdata-section':
                                            var rawText = childElem.textContent, renderedText = rawText, words = void 0;
                                            childElem._font = currentElem._font;
                                            childElem._pos = [];
                                            remainingText = remainingText.substring(rawText.length);
                                            if (currentElem.get('xml:space') === 'preserve') renderedText = renderedText.replace(/[\s]/g, ' ');
                                            else {
                                                renderedText = renderedText.replace(/[\s]+/g, ' ');
                                                if (processedText.match(/[\s]$|^$/)) renderedText = renderedText.replace(/^[\s]/, '');
                                                if (remainingText.match(/^[\s]*$/)) renderedText = renderedText.replace(/[\s]$/, '');
                                            }
                                            processedText += rawText;
                                            if (wordSpacing === 0) words = [
                                                renderedText
                                            ];
                                            else words = renderedText.split(/(\s)/);
                                            for(var w = 0; w < words.length; w++){
                                                var pos = getTextPos(currentElem._font.font, currentElem._font.size, words[w]);
                                                for(var j = 0; j < pos.length; j++){
                                                    var index = currentElem._index, xAttr = currentElem._x[index], yAttr = currentElem._y[index], dxAttr = currentElem._dx[index], dyAttr = currentElem._dy[index], rotAttr = currentElem._rot[index], continuous = !(w === 0 && j === 0);
                                                    if (xAttr !== undefined) {
                                                        continuous = false;
                                                        doAnchoring();
                                                        currentX = xAttr;
                                                    }
                                                    if (yAttr !== undefined) {
                                                        continuous = false;
                                                        doAnchoring();
                                                        currentY = yAttr;
                                                    }
                                                    if (dxAttr !== undefined) {
                                                        continuous = false;
                                                        currentX += dxAttr;
                                                    }
                                                    if (dyAttr !== undefined) {
                                                        continuous = false;
                                                        currentY += dyAttr;
                                                    }
                                                    if (rotAttr !== undefined || currentElem._defRot !== 0) continuous = false;
                                                    var position = {
                                                        glyph: pos[j].glyph,
                                                        rotate: Math.PI / 180 * currentElem.chooseValue(rotAttr, currentElem._defRot),
                                                        x: currentX + pos[j].xOffset,
                                                        y: currentY + baseline + pos[j].yOffset,
                                                        width: pos[j].width,
                                                        ascent: getAscent(currentElem._font.font, currentElem._font.size),
                                                        descent: getDescent(currentElem._font.font, currentElem._font.size),
                                                        scale: 1,
                                                        hidden: false,
                                                        continuous: continuous
                                                    };
                                                    currentChunk.push(position);
                                                    childElem._pos.push(position);
                                                    currentElem._pos.push(position);
                                                    currentElem._index += pos[j].unicode.length;
                                                    if (currentChunk.length === 1) {
                                                        currentAnchor = textAnchor;
                                                        currentDirection = textDirection;
                                                    }
                                                    currentX += pos[j].xAdvance + letterSpacing;
                                                    currentY += pos[j].yAdvance;
                                                }
                                                if (words[w] === ' ') currentX += wordSpacing;
                                            }
                                            break;
                                        default:
                                            remainingText = remainingText.substring(childElem.textContent.length);
                                    }
                                }
                                if (textLength && currentElem._pos.length) adjustLength(currentElem._pos, textLength, spacingAndGlyphs);
                                if (currentElem.name === 'textPath' || currentElem.name === 'text') doAnchoring();
                                if (currentElem.name === 'textPath') {
                                    textPaths.push(currentElem);
                                    var pathObject = currentElem.pathObject;
                                    if (pathObject) {
                                        currentX = pathObject.endPoint[0];
                                        currentY = pathObject.endPoint[1];
                                    }
                                }
                                if (parentElem) {
                                    parentElem._pos = parentElem._pos.concat(currentElem._pos);
                                    parentElem._index += currentElem._index;
                                }
                            }
                            function textOnPath(currentElem) {
                                var pathObject = currentElem.pathObject, pathLength = currentElem.pathLength, pathScale = currentElem.pathScale;
                                if (pathObject) {
                                    var textOffset = currentElem.getLength('startOffset', pathLength, 0);
                                    for(var j = 0; j < currentElem._pos.length; j++){
                                        var charMidX = textOffset + currentElem._pos[j].x + 0.5 * currentElem._pos[j].width;
                                        if (charMidX > pathLength || charMidX < 0) currentElem._pos[j].hidden = true;
                                        else {
                                            var pointOnPath = pathObject.getPointAtLength(charMidX * pathScale);
                                            if (isNotEqual(pathScale, 1)) {
                                                currentElem._pos[j].scale *= pathScale;
                                                currentElem._pos[j].width *= pathScale;
                                            }
                                            currentElem._pos[j].x = pointOnPath[0] - 0.5 * currentElem._pos[j].width * Math.cos(pointOnPath[2]) - currentElem._pos[j].y * Math.sin(pointOnPath[2]);
                                            currentElem._pos[j].y = pointOnPath[1] - 0.5 * currentElem._pos[j].width * Math.sin(pointOnPath[2]) + currentElem._pos[j].y * Math.cos(pointOnPath[2]);
                                            currentElem._pos[j].rotate = pointOnPath[2] + currentElem._pos[j].rotate;
                                            currentElem._pos[j].continuous = false;
                                        }
                                    }
                                } else for(var _j5 = 0; _j5 < currentElem._pos.length; _j5++)currentElem._pos[_j5].hidden = true;
                            }
                            recursive(textParentElem, null);
                            for(var i = 0; i < textPaths.length; i++)textOnPath(textPaths[i]);
                        })(this);
                        this.getTransformation = function() {
                            return this.get('transform');
                        };
                        this.drawInDocument = function(isClip, isMask) {
                            doc.save();
                            this.transform();
                            this.clip();
                            var masked = this.mask(), group;
                            if (masked) group = docBeginGroup(getPageBBox());
                            this.drawTextInDocument(isClip, isMask);
                            if (group) {
                                docEndGroup(group);
                                docInsertGroup(group);
                            }
                            doc.restore();
                        };
                    };
                    options = options || {};
                    var pxToPt = options.assumePt ? 1 : 0.75, // 1px = 72/96pt, but only if assumePt is false
                    viewportWidth = (options.width || doc.page.width) / pxToPt, viewportHeight = (options.height || doc.page.height) / pxToPt, preserveAspectRatio = options.preserveAspectRatio || null, // default to null so that the attr can override if not passed
                    useCSS = options.useCSS && typeof SVGElement !== 'undefined' && svg instanceof SVGElement && typeof getComputedStyle === 'function', warningCallback = options.warningCallback, fontCallback = options.fontCallback, imageCallback = options.imageCallback, colorCallback = options.colorCallback, documentCallback = options.documentCallback, precision = Math.ceil(Math.max(1, options.precision)) || 3, groupStack = [], documentCache = {}, links = [], styleRules = [];
                    if (typeof warningCallback !== 'function') warningCallback = function warningCallback(str) {
                        if (typeof console.warn === 'function') console.warn(str);
                    };
                    if (typeof fontCallback !== 'function') fontCallback = function fontCallback(family, bold, italic, fontOptions) {
                        // Check if the font is already registered in the document
                        if (bold && italic) {
                            if (doc._registeredFonts.hasOwnProperty(family + '-BoldItalic')) return family + '-BoldItalic';
                            else if (doc._registeredFonts.hasOwnProperty(family + '-Italic')) {
                                fontOptions.fauxBold = true;
                                return family + '-Italic';
                            } else if (doc._registeredFonts.hasOwnProperty(family + '-Bold')) {
                                fontOptions.fauxItalic = true;
                                return family + '-Bold';
                            } else if (doc._registeredFonts.hasOwnProperty(family)) {
                                fontOptions.fauxBold = true;
                                fontOptions.fauxItalic = true;
                                return family;
                            }
                        }
                        if (bold && !italic) {
                            if (doc._registeredFonts.hasOwnProperty(family + '-Bold')) return family + '-Bold';
                            else if (doc._registeredFonts.hasOwnProperty(family)) {
                                fontOptions.fauxBold = true;
                                return family;
                            }
                        }
                        if (!bold && italic) {
                            if (doc._registeredFonts.hasOwnProperty(family + '-Italic')) return family + '-Italic';
                            else if (doc._registeredFonts.hasOwnProperty(family)) {
                                fontOptions.fauxItalic = true;
                                return family;
                            }
                        }
                        if (!bold && !italic) {
                            if (doc._registeredFonts.hasOwnProperty(family)) return family;
                        }
                        // Use standard fonts as fallback
                        if (family.match(/(?:^|,)\s*serif\s*$/)) {
                            if (bold && italic) return 'Times-BoldItalic';
                            if (bold && !italic) return 'Times-Bold';
                            if (!bold && italic) return 'Times-Italic';
                            if (!bold && !italic) return 'Times-Roman';
                        } else if (family.match(/(?:^|,)\s*monospace\s*$/)) {
                            if (bold && italic) return 'Courier-BoldOblique';
                            if (bold && !italic) return 'Courier-Bold';
                            if (!bold && italic) return 'Courier-Oblique';
                            if (!bold && !italic) return 'Courier';
                        } else {
                            family.match(/(?:^|,)\s*sans-serif\s*$/);
                            if (bold && italic) return 'Helvetica-BoldOblique';
                            if (bold && !italic) return 'Helvetica-Bold';
                            if (!bold && italic) return 'Helvetica-Oblique';
                            if (!bold && !italic) return 'Helvetica';
                        }
                    };
                    if (typeof imageCallback !== 'function') imageCallback = function imageCallback(link) {
                        return link.replace(/\s+/g, '');
                    };
                    if (typeof colorCallback !== 'function') colorCallback = null;
                    else for(var color in DefaultColors){
                        var newColor = colorCallback(DefaultColors[color]);
                        DefaultColors[color][0] = newColor[0];
                        DefaultColors[color][1] = newColor[1];
                    }
                    if (typeof documentCallback !== 'function') documentCallback = null;
                    if (typeof svg === 'string') svg = parseXml(svg);
                    if (svg) {
                        var styles = svg.getElementsByTagName('style');
                        for(var i = 0; i < styles.length; i++)styleRules = styleRules.concat(parseStyleSheet(styles[i].textContent));
                        var elem = createSVGElement(svg, null);
                        if (typeof elem.drawInDocument === 'function') {
                            if (options.useCSS && !useCSS) warningCallback('SVGtoPDF: useCSS option can only be used for SVG *elements* in compatible browsers');
                            var savedFillColor = doc._fillColor;
                            doc.save().translate(x || 0, y || 0).scale(pxToPt);
                            elem.drawInDocument();
                            for(var _i8 = 0; _i8 < links.length; _i8++)doc.page.annotations.push(links[_i8]);
                            doc.restore();
                            doc._fillColor = savedFillColor;
                        } else warningCallback('SVGtoPDF: this element can\'t be rendered directly: ' + svg.nodeName);
                    } else warningCallback('SVGtoPDF: the input does not look like a valid SVG');
                };
                if (module1 && typeof module1.exports !== 'undefined') module1.exports = SVGtoPDF;
            /***/ },
            /***/ 64785: /***/ function(module1) {
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var R = typeof Reflect === 'object' ? Reflect : null;
                var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
                    return Function.prototype.apply.call(target, receiver, args);
                };
                var ReflectOwnKeys;
                if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
                else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
                };
                else ReflectOwnKeys = function ReflectOwnKeys(target) {
                    return Object.getOwnPropertyNames(target);
                };
                function ProcessEmitWarning(warning) {
                    if (console && console.warn) console.warn(warning);
                }
                var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
                    return value !== value;
                };
                function EventEmitter() {
                    EventEmitter.init.call(this);
                }
                module1.exports = EventEmitter;
                module1.exports.once = once;
                // Backwards-compat with node 0.10.x
                EventEmitter.EventEmitter = EventEmitter;
                EventEmitter.prototype._events = undefined;
                EventEmitter.prototype._eventsCount = 0;
                EventEmitter.prototype._maxListeners = undefined;
                // By default EventEmitters will print a warning if more than 10 listeners are
                // added to it. This is a useful default which helps finding memory leaks.
                var defaultMaxListeners = 10;
                function checkListener(listener) {
                    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
                }
                Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
                    enumerable: true,
                    get: function() {
                        return defaultMaxListeners;
                    },
                    set: function(arg) {
                        if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
                        defaultMaxListeners = arg;
                    }
                });
                EventEmitter.init = function() {
                    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                    }
                    this._maxListeners = this._maxListeners || undefined;
                };
                // Obviously not all Emitters should be limited to 10. This function allows
                // that to be increased. Set to zero for unlimited.
                EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
                    if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
                    this._maxListeners = n;
                    return this;
                };
                function _getMaxListeners(that) {
                    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
                    return that._maxListeners;
                }
                EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
                    return _getMaxListeners(this);
                };
                EventEmitter.prototype.emit = function emit(type) {
                    var args = [];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    var doError = type === 'error';
                    var events = this._events;
                    if (events !== undefined) doError = doError && events.error === undefined;
                    else if (!doError) return false;
                    // If there is no 'error' event listener then throw.
                    if (doError) {
                        var er;
                        if (args.length > 0) er = args[0];
                        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
                        // up in Node's output if this results in an unhandled exception.
                        throw er; // Unhandled 'error' event
                        // At least give some kind of context to the user
                        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
                        err.context = er;
                        throw err; // Unhandled 'error' event
                    }
                    var handler = events[type];
                    if (handler === undefined) return false;
                    if (typeof handler === 'function') ReflectApply(handler, this, args);
                    else {
                        var len = handler.length;
                        var listeners = arrayClone(handler, len);
                        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
                    }
                    return true;
                };
                function _addListener(target, type, listener, prepend) {
                    var m;
                    var events;
                    var existing;
                    checkListener(listener);
                    events = target._events;
                    if (events === undefined) {
                        events = target._events = Object.create(null);
                        target._eventsCount = 0;
                    } else {
                        // To avoid recursion in the case that type === "newListener"! Before
                        // adding it to the listeners, first emit "newListener".
                        if (events.newListener !== undefined) {
                            target.emit('newListener', type, listener.listener ? listener.listener : listener);
                            // Re-assign `events` because a newListener handler could have caused the
                            // this._events to be assigned to a new object
                            events = target._events;
                        }
                        existing = events[type];
                    }
                    if (existing === undefined) {
                        // Optimize the case of one listener. Don't need the extra array object.
                        existing = events[type] = listener;
                        ++target._eventsCount;
                    } else {
                        if (typeof existing === 'function') // Adding the second element, need to change to array.
                        existing = events[type] = prepend ? [
                            listener,
                            existing
                        ] : [
                            existing,
                            listener
                        ];
                        else if (prepend) existing.unshift(listener);
                        else existing.push(listener);
                        // Check for listener leak
                        m = _getMaxListeners(target);
                        if (m > 0 && existing.length > m && !existing.warned) {
                            existing.warned = true;
                            // No error code for this since it is a Warning
                            // eslint-disable-next-line no-restricted-syntax
                            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                            w.name = 'MaxListenersExceededWarning';
                            w.emitter = target;
                            w.type = type;
                            w.count = existing.length;
                            ProcessEmitWarning(w);
                        }
                    }
                    return target;
                }
                EventEmitter.prototype.addListener = function addListener(type, listener) {
                    return _addListener(this, type, listener, false);
                };
                EventEmitter.prototype.on = EventEmitter.prototype.addListener;
                EventEmitter.prototype.prependListener = function prependListener(type, listener) {
                    return _addListener(this, type, listener, true);
                };
                function onceWrapper() {
                    if (!this.fired) {
                        this.target.removeListener(this.type, this.wrapFn);
                        this.fired = true;
                        if (arguments.length === 0) return this.listener.call(this.target);
                        return this.listener.apply(this.target, arguments);
                    }
                }
                function _onceWrap(target, type, listener) {
                    var state = {
                        fired: false,
                        wrapFn: undefined,
                        target: target,
                        type: type,
                        listener: listener
                    };
                    var wrapped = onceWrapper.bind(state);
                    wrapped.listener = listener;
                    state.wrapFn = wrapped;
                    return wrapped;
                }
                EventEmitter.prototype.once = function once(type, listener) {
                    checkListener(listener);
                    this.on(type, _onceWrap(this, type, listener));
                    return this;
                };
                EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
                    checkListener(listener);
                    this.prependListener(type, _onceWrap(this, type, listener));
                    return this;
                };
                // Emits a 'removeListener' event if and only if the listener was removed.
                EventEmitter.prototype.removeListener = function removeListener(type, listener) {
                    var list, events, position, i, originalListener;
                    checkListener(listener);
                    events = this._events;
                    if (events === undefined) return this;
                    list = events[type];
                    if (list === undefined) return this;
                    if (list === listener || list.listener === listener) {
                        if (--this._eventsCount === 0) this._events = Object.create(null);
                        else {
                            delete events[type];
                            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
                        }
                    } else if (typeof list !== 'function') {
                        position = -1;
                        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                            originalListener = list[i].listener;
                            position = i;
                            break;
                        }
                        if (position < 0) return this;
                        if (position === 0) list.shift();
                        else spliceOne(list, position);
                        if (list.length === 1) events[type] = list[0];
                        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
                    }
                    return this;
                };
                EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
                EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
                    var listeners, events, i;
                    events = this._events;
                    if (events === undefined) return this;
                    // not listening for removeListener, no need to emit
                    if (events.removeListener === undefined) {
                        if (arguments.length === 0) {
                            this._events = Object.create(null);
                            this._eventsCount = 0;
                        } else if (events[type] !== undefined) {
                            if (--this._eventsCount === 0) this._events = Object.create(null);
                            else delete events[type];
                        }
                        return this;
                    }
                    // emit removeListener for all listeners on all events
                    if (arguments.length === 0) {
                        var keys = Object.keys(events);
                        var key;
                        for(i = 0; i < keys.length; ++i){
                            key = keys[i];
                            if (key === 'removeListener') continue;
                            this.removeAllListeners(key);
                        }
                        this.removeAllListeners('removeListener');
                        this._events = Object.create(null);
                        this._eventsCount = 0;
                        return this;
                    }
                    listeners = events[type];
                    if (typeof listeners === 'function') this.removeListener(type, listeners);
                    else if (listeners !== undefined) // LIFO order
                    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
                    return this;
                };
                function _listeners(target, type, unwrap) {
                    var events = target._events;
                    if (events === undefined) return [];
                    var evlistener = events[type];
                    if (evlistener === undefined) return [];
                    if (typeof evlistener === 'function') return unwrap ? [
                        evlistener.listener || evlistener
                    ] : [
                        evlistener
                    ];
                    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
                }
                EventEmitter.prototype.listeners = function listeners(type) {
                    return _listeners(this, type, true);
                };
                EventEmitter.prototype.rawListeners = function rawListeners(type) {
                    return _listeners(this, type, false);
                };
                EventEmitter.listenerCount = function(emitter, type) {
                    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
                    else return listenerCount.call(emitter, type);
                };
                EventEmitter.prototype.listenerCount = listenerCount;
                function listenerCount(type) {
                    var events = this._events;
                    if (events !== undefined) {
                        var evlistener = events[type];
                        if (typeof evlistener === 'function') return 1;
                        else if (evlistener !== undefined) return evlistener.length;
                    }
                    return 0;
                }
                EventEmitter.prototype.eventNames = function eventNames() {
                    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
                };
                function arrayClone(arr, n) {
                    var copy = new Array(n);
                    for(var i = 0; i < n; ++i)copy[i] = arr[i];
                    return copy;
                }
                function spliceOne(list, index) {
                    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
                    list.pop();
                }
                function unwrapListeners(arr) {
                    var ret = new Array(arr.length);
                    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
                    return ret;
                }
                function once(emitter, name) {
                    return new Promise(function(resolve, reject) {
                        function errorListener(err) {
                            emitter.removeListener(name, resolver);
                            reject(err);
                        }
                        function resolver() {
                            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
                            resolve([].slice.call(arguments));
                        }
                        eventTargetAgnosticAddListener(emitter, name, resolver, {
                            once: true
                        });
                        if (name !== 'error') addErrorHandlerIfEventEmitter(emitter, errorListener, {
                            once: true
                        });
                    });
                }
                function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
                    if (typeof emitter.on === 'function') eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
                }
                function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
                    if (typeof emitter.on === 'function') {
                        if (flags.once) emitter.once(name, listener);
                        else emitter.on(name, listener);
                    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
                    // EventEmitters, we do not listen for `error` events here.
                    emitter.addEventListener(name, function wrapListener(arg) {
                        // IE does not have builtin `{ once: true }` support so we
                        // have to do it manually.
                        if (flags.once) emitter.removeEventListener(name, wrapListener);
                        listener(arg);
                    });
                    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
                }
            /***/ },
            /***/ 64793: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var toLength = __webpack_require__(23417);
                var toAbsoluteIndex = __webpack_require__(74841);
                var typedArraySpeciesConstructor = __webpack_require__(34815);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.subarray` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
                exportTypedArrayMethod('subarray', function subarray(begin, end) {
                    var O = aTypedArray(this);
                    var length = O.length;
                    var beginIndex = toAbsoluteIndex(begin, length);
                    var C = typedArraySpeciesConstructor(O);
                    return new C(O.buffer, O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex));
                });
            /***/ },
            /***/ 64913: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var toIntegerOrInfinity = __webpack_require__(26882);
                var RangeError1 = global.RangeError;
                module1.exports = function(it) {
                    var result = toIntegerOrInfinity(it);
                    if (result < 0) throw RangeError1("The argument can't be less than 0");
                    return result;
                };
            /***/ },
            /***/ 65292: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var getBuiltIn = __webpack_require__(38486);
                var apply = __webpack_require__(58448);
                var call = __webpack_require__(2834);
                var uncurryThis = __webpack_require__(38347);
                var IS_PURE = __webpack_require__(63432);
                var DESCRIPTORS = __webpack_require__(15567);
                var NATIVE_SYMBOL = __webpack_require__(46887);
                var fails = __webpack_require__(47044);
                var hasOwn = __webpack_require__(20340);
                var isArray = __webpack_require__(59113);
                var isCallable = __webpack_require__(94578);
                var isObject = __webpack_require__(24517);
                var isPrototypeOf = __webpack_require__(70176);
                var isSymbol = __webpack_require__(46290);
                var anObject = __webpack_require__(34984);
                var toObject = __webpack_require__(43162);
                var toIndexedObject = __webpack_require__(98086);
                var toPropertyKey = __webpack_require__(63918);
                var $toString = __webpack_require__(25096);
                var createPropertyDescriptor = __webpack_require__(97841);
                var nativeObjectCreate = __webpack_require__(10819);
                var objectKeys = __webpack_require__(84675);
                var getOwnPropertyNamesModule = __webpack_require__(6611);
                var getOwnPropertyNamesExternal = __webpack_require__(8807);
                var getOwnPropertySymbolsModule = __webpack_require__(61146);
                var getOwnPropertyDescriptorModule = __webpack_require__(72062);
                var definePropertyModule = __webpack_require__(95892);
                var propertyIsEnumerableModule = __webpack_require__(55574);
                var arraySlice = __webpack_require__(73163);
                var redefine = __webpack_require__(13711);
                var shared = __webpack_require__(464);
                var sharedKey = __webpack_require__(82194);
                var hiddenKeys = __webpack_require__(90682);
                var uid = __webpack_require__(46859);
                var wellKnownSymbol = __webpack_require__(38688);
                var wrappedWellKnownSymbolModule = __webpack_require__(75960);
                var defineWellKnownSymbol = __webpack_require__(46042);
                var setToStringTag = __webpack_require__(15216);
                var InternalStateModule = __webpack_require__(70172);
                var $forEach = __webpack_require__(91102).forEach;
                var HIDDEN = sharedKey('hidden');
                var SYMBOL = 'Symbol';
                var PROTOTYPE = 'prototype';
                var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(SYMBOL);
                var ObjectPrototype = Object[PROTOTYPE];
                var $Symbol = global.Symbol;
                var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
                var TypeError1 = global.TypeError;
                var QObject = global.QObject;
                var $stringify = getBuiltIn('JSON', 'stringify');
                var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                var nativeDefineProperty = definePropertyModule.f;
                var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
                var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
                var push = uncurryThis([].push);
                var AllSymbols = shared('symbols');
                var ObjectPrototypeSymbols = shared('op-symbols');
                var StringToSymbolRegistry = shared('string-to-symbol-registry');
                var SymbolToStringRegistry = shared('symbol-to-string-registry');
                var WellKnownSymbolsStore = shared('wks');
                // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
                var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
                // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
                var setSymbolDescriptor = DESCRIPTORS && fails(function() {
                    return nativeObjectCreate(nativeDefineProperty({}, 'a', {
                        get: function() {
                            return nativeDefineProperty(this, 'a', {
                                value: 7
                            }).a;
                        }
                    })).a != 7;
                }) ? function(O, P, Attributes) {
                    var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
                    if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
                    nativeDefineProperty(O, P, Attributes);
                    if (ObjectPrototypeDescriptor && O !== ObjectPrototype) nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
                } : nativeDefineProperty;
                var wrap = function(tag, description) {
                    var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
                    setInternalState(symbol, {
                        type: SYMBOL,
                        tag: tag,
                        description: description
                    });
                    if (!DESCRIPTORS) symbol.description = description;
                    return symbol;
                };
                var $defineProperty = function defineProperty(O, P, Attributes) {
                    if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
                    anObject(O);
                    var key = toPropertyKey(P);
                    anObject(Attributes);
                    if (hasOwn(AllSymbols, key)) {
                        if (!Attributes.enumerable) {
                            if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
                            O[HIDDEN][key] = true;
                        } else {
                            if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
                            Attributes = nativeObjectCreate(Attributes, {
                                enumerable: createPropertyDescriptor(0, false)
                            });
                        }
                        return setSymbolDescriptor(O, key, Attributes);
                    }
                    return nativeDefineProperty(O, key, Attributes);
                };
                var $defineProperties = function defineProperties(O, Properties) {
                    anObject(O);
                    var properties = toIndexedObject(Properties);
                    var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
                    $forEach(keys, function(key) {
                        if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
                    });
                    return O;
                };
                var $create = function create(O, Properties) {
                    return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
                };
                var $propertyIsEnumerable = function propertyIsEnumerable(V) {
                    var P = toPropertyKey(V);
                    var enumerable = call(nativePropertyIsEnumerable, this, P);
                    if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
                    return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
                };
                var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
                    var it = toIndexedObject(O);
                    var key = toPropertyKey(P);
                    if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
                    var descriptor = nativeGetOwnPropertyDescriptor(it, key);
                    if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) descriptor.enumerable = true;
                    return descriptor;
                };
                var $getOwnPropertyNames = function getOwnPropertyNames(O) {
                    var names = nativeGetOwnPropertyNames(toIndexedObject(O));
                    var result = [];
                    $forEach(names, function(key) {
                        if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
                    });
                    return result;
                };
                var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
                    var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
                    var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
                    var result = [];
                    $forEach(names, function(key) {
                        if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) push(result, AllSymbols[key]);
                    });
                    return result;
                };
                // `Symbol` constructor
                // https://tc39.es/ecma262/#sec-symbol-constructor
                if (!NATIVE_SYMBOL) {
                    $Symbol = function Symbol1() {
                        if (isPrototypeOf(SymbolPrototype, this)) throw TypeError1('Symbol is not a constructor');
                        var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
                        var tag = uid(description);
                        var setter = function(value) {
                            if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
                            if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                            setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
                        };
                        if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
                            configurable: true,
                            set: setter
                        });
                        return wrap(tag, description);
                    };
                    SymbolPrototype = $Symbol[PROTOTYPE];
                    redefine(SymbolPrototype, 'toString', function toString() {
                        return getInternalState(this).tag;
                    });
                    redefine($Symbol, 'withoutSetter', function(description) {
                        return wrap(uid(description), description);
                    });
                    propertyIsEnumerableModule.f = $propertyIsEnumerable;
                    definePropertyModule.f = $defineProperty;
                    getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
                    getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
                    getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
                    wrappedWellKnownSymbolModule.f = function(name) {
                        return wrap(wellKnownSymbol(name), name);
                    };
                    if (DESCRIPTORS) {
                        // https://github.com/tc39/proposal-Symbol-description
                        nativeDefineProperty(SymbolPrototype, 'description', {
                            configurable: true,
                            get: function description() {
                                return getInternalState(this).description;
                            }
                        });
                        if (!IS_PURE) redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, {
                            unsafe: true
                        });
                    }
                }
                $({
                    global: true,
                    wrap: true,
                    forced: !NATIVE_SYMBOL,
                    sham: !NATIVE_SYMBOL
                }, {
                    Symbol: $Symbol
                });
                $forEach(objectKeys(WellKnownSymbolsStore), function(name) {
                    defineWellKnownSymbol(name);
                });
                $({
                    target: SYMBOL,
                    stat: true,
                    forced: !NATIVE_SYMBOL
                }, {
                    // `Symbol.for` method
                    // https://tc39.es/ecma262/#sec-symbol.for
                    'for': function(key) {
                        var string = $toString(key);
                        if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
                        var symbol = $Symbol(string);
                        StringToSymbolRegistry[string] = symbol;
                        SymbolToStringRegistry[symbol] = string;
                        return symbol;
                    },
                    // `Symbol.keyFor` method
                    // https://tc39.es/ecma262/#sec-symbol.keyfor
                    keyFor: function keyFor(sym) {
                        if (!isSymbol(sym)) throw TypeError1(sym + ' is not a symbol');
                        if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
                    },
                    useSetter: function() {
                        USE_SETTER = true;
                    },
                    useSimple: function() {
                        USE_SETTER = false;
                    }
                });
                $({
                    target: 'Object',
                    stat: true,
                    forced: !NATIVE_SYMBOL,
                    sham: !DESCRIPTORS
                }, {
                    // `Object.create` method
                    // https://tc39.es/ecma262/#sec-object.create
                    create: $create,
                    // `Object.defineProperty` method
                    // https://tc39.es/ecma262/#sec-object.defineproperty
                    defineProperty: $defineProperty,
                    // `Object.defineProperties` method
                    // https://tc39.es/ecma262/#sec-object.defineproperties
                    defineProperties: $defineProperties,
                    // `Object.getOwnPropertyDescriptor` method
                    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
                    getOwnPropertyDescriptor: $getOwnPropertyDescriptor
                });
                $({
                    target: 'Object',
                    stat: true,
                    forced: !NATIVE_SYMBOL
                }, {
                    // `Object.getOwnPropertyNames` method
                    // https://tc39.es/ecma262/#sec-object.getownpropertynames
                    getOwnPropertyNames: $getOwnPropertyNames,
                    // `Object.getOwnPropertySymbols` method
                    // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
                    getOwnPropertySymbols: $getOwnPropertySymbols
                });
                // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
                // https://bugs.chromium.org/p/v8/issues/detail?id=3443
                $({
                    target: 'Object',
                    stat: true,
                    forced: fails(function() {
                        getOwnPropertySymbolsModule.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
                        return getOwnPropertySymbolsModule.f(toObject(it));
                    }
                });
                // `JSON.stringify` method behavior with symbols
                // https://tc39.es/ecma262/#sec-json.stringify
                if ($stringify) {
                    var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function() {
                        var symbol = $Symbol();
                        // MS Edge converts symbol values to JSON as {}
                        return $stringify([
                            symbol
                        ]) != '[null]' || $stringify({
                            a: symbol
                        }) != '{}' || $stringify(Object(symbol)) != '{}';
                    });
                    $({
                        target: 'JSON',
                        stat: true,
                        forced: FORCED_JSON_STRINGIFY
                    }, {
                        // eslint-disable-next-line no-unused-vars -- required for `.length`
                        stringify: function stringify(it, replacer, space) {
                            var args = arraySlice(arguments);
                            var $replacer = replacer;
                            if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
                            if (!isArray(replacer)) replacer = function(key, value) {
                                if (isCallable($replacer)) value = call($replacer, this, key, value);
                                if (!isSymbol(value)) return value;
                            };
                            args[1] = replacer;
                            return apply($stringify, null, args);
                        }
                    });
                }
                // `Symbol.prototype[@@toPrimitive]` method
                // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
                if (!SymbolPrototype[TO_PRIMITIVE]) {
                    var valueOf = SymbolPrototype.valueOf;
                    // eslint-disable-next-line no-unused-vars -- required for .length
                    redefine(SymbolPrototype, TO_PRIMITIVE, function(hint) {
                        // TODO: improve hint logic
                        return call(valueOf, this);
                    });
                }
                // `Symbol.prototype[@@toStringTag]` property
                // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
                setToStringTag($Symbol, SYMBOL);
                hiddenKeys[HIDDEN] = true;
            /***/ },
            /***/ 65300: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(49063);
                __webpack_require__(97514);
                __webpack_require__(11765);
                __webpack_require__(81755);
                __webpack_require__(80055);
                __webpack_require__(20731);
                __webpack_require__(7283);
                __webpack_require__(18756);
                __webpack_require__(37309);
                __webpack_require__(14032);
                __webpack_require__(76014);
                __webpack_require__(58281);
                __webpack_require__(28356);
                __webpack_require__(42437);
                __webpack_require__(94712);
                var TraversalTracker = __webpack_require__(2318);
                var DocPreprocessor = __webpack_require__(98883);
                var DocMeasure = __webpack_require__(42526);
                var DocumentContext = __webpack_require__(79178);
                var PageElementWriter = __webpack_require__(11220);
                var ColumnCalculator = __webpack_require__(77530);
                var TableProcessor = __webpack_require__(89836);
                var Line = __webpack_require__(70770);
                var isString = __webpack_require__(91867).isString;
                var isArray = __webpack_require__(91867).isArray;
                var isUndefined = __webpack_require__(91867).isUndefined;
                var isNull = __webpack_require__(91867).isNull;
                var pack = __webpack_require__(91867).pack;
                var offsetVector = __webpack_require__(91867).offsetVector;
                var fontStringify = __webpack_require__(91867).fontStringify;
                var getNodeId = __webpack_require__(91867).getNodeId;
                var isFunction = __webpack_require__(91867).isFunction;
                var TextTools = __webpack_require__(11548);
                var StyleContextStack = __webpack_require__(76442);
                var isNumber = __webpack_require__(91867).isNumber;
                function addAll(target, otherArray) {
                    otherArray.forEach(function(item) {
                        target.push(item);
                    });
                }
                /**
 * Creates an instance of LayoutBuilder - layout engine which turns document-definition-object
 * into a set of pages, lines, inlines and vectors ready to be rendered into a PDF
 *
 * @param {Object} pageSize - an object defining page width and height
 * @param {Object} pageMargins - an object defining top, left, right and bottom margins
 */ function LayoutBuilder(pageSize, pageMargins, imageMeasure, svgMeasure) {
                    this.pageSize = pageSize;
                    this.pageMargins = pageMargins;
                    this.tracker = new TraversalTracker();
                    this.imageMeasure = imageMeasure;
                    this.svgMeasure = svgMeasure;
                    this.tableLayouts = {};
                    this.nestedLevel = 0;
                }
                LayoutBuilder.prototype.registerTableLayouts = function(tableLayouts) {
                    this.tableLayouts = pack(this.tableLayouts, tableLayouts);
                };
                /**
 * Executes layout engine on document-definition-object and creates an array of pages
 * containing positioned Blocks, Lines and inlines
 *
 * @param {Object} docStructure document-definition-object
 * @param {Object} fontProvider font provider
 * @param {Object} styleDictionary dictionary with style definitions
 * @param {Object} defaultStyle default style definition
 * @return {Array} an array of pages
 */ LayoutBuilder.prototype.layoutDocument = function(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {
                    function addPageBreaksIfNecessary(linearNodeList, pages) {
                        if (!isFunction(pageBreakBeforeFct)) return false;
                        linearNodeList = linearNodeList.filter(function(node) {
                            return node.positions.length > 0;
                        });
                        linearNodeList.forEach(function(node) {
                            var nodeInfo = {};
                            [
                                'id',
                                'text',
                                'ul',
                                'ol',
                                'table',
                                'image',
                                'qr',
                                'canvas',
                                'svg',
                                'columns',
                                'headlineLevel',
                                'style',
                                'pageBreak',
                                'pageOrientation',
                                'width',
                                'height'
                            ].forEach(function(key) {
                                if (node[key] !== undefined) nodeInfo[key] = node[key];
                            });
                            nodeInfo.startPosition = node.positions[0];
                            nodeInfo.pageNumbers = Array.from(new Set(node.positions.map(function(node) {
                                return node.pageNumber;
                            })));
                            nodeInfo.pages = pages.length;
                            nodeInfo.stack = isArray(node.stack);
                            node.nodeInfo = nodeInfo;
                        });
                        for(var index = 0; index < linearNodeList.length; index++){
                            var node = linearNodeList[index];
                            if (node.pageBreak !== 'before' && !node.pageBreakCalculated) {
                                node.pageBreakCalculated = true;
                                var pageNumber = node.nodeInfo.pageNumbers[0];
                                var followingNodesOnPage = [];
                                var nodesOnNextPage = [];
                                var previousNodesOnPage = [];
                                if (pageBreakBeforeFct.length > 1) for(var ii = index + 1, l = linearNodeList.length; ii < l; ii++){
                                    if (linearNodeList[ii].nodeInfo.pageNumbers.indexOf(pageNumber) > -1) followingNodesOnPage.push(linearNodeList[ii].nodeInfo);
                                    if (pageBreakBeforeFct.length > 2 && linearNodeList[ii].nodeInfo.pageNumbers.indexOf(pageNumber + 1) > -1) nodesOnNextPage.push(linearNodeList[ii].nodeInfo);
                                }
                                if (pageBreakBeforeFct.length > 3) {
                                    for(var ii = 0; ii < index; ii++)if (linearNodeList[ii].nodeInfo.pageNumbers.indexOf(pageNumber) > -1) previousNodesOnPage.push(linearNodeList[ii].nodeInfo);
                                }
                                if (pageBreakBeforeFct(node.nodeInfo, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage)) {
                                    node.pageBreak = 'before';
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                    this.docPreprocessor = new DocPreprocessor();
                    this.docMeasure = new DocMeasure(fontProvider, styleDictionary, defaultStyle, this.imageMeasure, this.svgMeasure, this.tableLayouts, images);
                    function resetXYs(result) {
                        result.linearNodeList.forEach(function(node) {
                            node.resetXY();
                        });
                    }
                    var result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
                    while(addPageBreaksIfNecessary(result.linearNodeList, result.pages)){
                        resetXYs(result);
                        result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
                    }
                    return result.pages;
                };
                LayoutBuilder.prototype.tryLayoutDocument = function(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {
                    this.linearNodeList = [];
                    docStructure = this.docPreprocessor.preprocessDocument(docStructure);
                    docStructure = this.docMeasure.measureDocument(docStructure);
                    this.writer = new PageElementWriter(new DocumentContext(this.pageSize, this.pageMargins), this.tracker);
                    var _this = this;
                    this.writer.context().tracker.startTracking('pageAdded', function() {
                        _this.addBackground(background);
                    });
                    this.addBackground(background);
                    this.processNode(docStructure);
                    this.addHeadersAndFooters(header, footer);
                    if (watermark != null) this.addWatermark(watermark, fontProvider, defaultStyle);
                    return {
                        pages: this.writer.context().pages,
                        linearNodeList: this.linearNodeList
                    };
                };
                LayoutBuilder.prototype.addBackground = function(background) {
                    var backgroundGetter = isFunction(background) ? background : function() {
                        return background;
                    };
                    var context = this.writer.context();
                    var pageSize = context.getCurrentPage().pageSize;
                    var pageBackground = backgroundGetter(context.page + 1, pageSize);
                    if (pageBackground) {
                        this.writer.beginUnbreakableBlock(pageSize.width, pageSize.height);
                        pageBackground = this.docPreprocessor.preprocessDocument(pageBackground);
                        this.processNode(this.docMeasure.measureDocument(pageBackground));
                        this.writer.commitUnbreakableBlock(0, 0);
                        context.backgroundLength[context.page] += pageBackground.positions.length;
                    }
                };
                LayoutBuilder.prototype.addStaticRepeatable = function(headerOrFooter, sizeFunction) {
                    this.addDynamicRepeatable(function() {
                        return JSON.parse(JSON.stringify(headerOrFooter)); // copy to new object
                    }, sizeFunction);
                };
                LayoutBuilder.prototype.addDynamicRepeatable = function(nodeGetter, sizeFunction) {
                    var pages = this.writer.context().pages;
                    for(var pageIndex = 0, l = pages.length; pageIndex < l; pageIndex++){
                        this.writer.context().page = pageIndex;
                        var node = nodeGetter(pageIndex + 1, l, this.writer.context().pages[pageIndex].pageSize);
                        if (node) {
                            var sizes = sizeFunction(this.writer.context().getCurrentPage().pageSize, this.pageMargins);
                            this.writer.beginUnbreakableBlock(sizes.width, sizes.height);
                            node = this.docPreprocessor.preprocessDocument(node);
                            this.processNode(this.docMeasure.measureDocument(node));
                            this.writer.commitUnbreakableBlock(sizes.x, sizes.y);
                        }
                    }
                };
                LayoutBuilder.prototype.addHeadersAndFooters = function(header, footer) {
                    var headerSizeFct = function headerSizeFct(pageSize, pageMargins) {
                        return {
                            x: 0,
                            y: 0,
                            width: pageSize.width,
                            height: pageMargins.top
                        };
                    };
                    var footerSizeFct = function footerSizeFct(pageSize, pageMargins) {
                        return {
                            x: 0,
                            y: pageSize.height - pageMargins.bottom,
                            width: pageSize.width,
                            height: pageMargins.bottom
                        };
                    };
                    if (isFunction(header)) this.addDynamicRepeatable(header, headerSizeFct);
                    else if (header) this.addStaticRepeatable(header, headerSizeFct);
                    if (isFunction(footer)) this.addDynamicRepeatable(footer, footerSizeFct);
                    else if (footer) this.addStaticRepeatable(footer, footerSizeFct);
                };
                LayoutBuilder.prototype.addWatermark = function(watermark, fontProvider, defaultStyle) {
                    if (isString(watermark)) watermark = {
                        'text': watermark
                    };
                    if (!watermark.text) // empty watermark text
                    return;
                    var pages = this.writer.context().pages;
                    for(var i = 0, l = pages.length; i < l; i++)pages[i].watermark = getWatermarkObject(Object.assign({}, watermark), pages[i].pageSize, fontProvider, defaultStyle);
                    function getWatermarkObject(watermark, pageSize, fontProvider, defaultStyle) {
                        watermark.font = watermark.font || defaultStyle.font || 'Roboto';
                        watermark.fontSize = watermark.fontSize || 'auto';
                        watermark.color = watermark.color || 'black';
                        watermark.opacity = isNumber(watermark.opacity) ? watermark.opacity : 0.6;
                        watermark.bold = watermark.bold || false;
                        watermark.italics = watermark.italics || false;
                        watermark.angle = !isUndefined(watermark.angle) && !isNull(watermark.angle) ? watermark.angle : null;
                        if (watermark.angle === null) watermark.angle = Math.atan2(pageSize.height, pageSize.width) * -180 / Math.PI;
                        if (watermark.fontSize === 'auto') watermark.fontSize = getWatermarkFontSize(pageSize, watermark, fontProvider);
                        var watermarkObject = {
                            text: watermark.text,
                            font: fontProvider.provideFont(watermark.font, watermark.bold, watermark.italics),
                            fontSize: watermark.fontSize,
                            color: watermark.color,
                            opacity: watermark.opacity,
                            angle: watermark.angle
                        };
                        watermarkObject._size = getWatermarkSize(watermark, fontProvider);
                        return watermarkObject;
                    }
                    function getWatermarkSize(watermark, fontProvider) {
                        var textTools = new TextTools(fontProvider);
                        var styleContextStack = new StyleContextStack(null, {
                            font: watermark.font,
                            bold: watermark.bold,
                            italics: watermark.italics
                        });
                        styleContextStack.push({
                            fontSize: watermark.fontSize
                        });
                        var size = textTools.sizeOfString(watermark.text, styleContextStack);
                        var rotatedSize = textTools.sizeOfRotatedText(watermark.text, watermark.angle, styleContextStack);
                        return {
                            size: size,
                            rotatedSize: rotatedSize
                        };
                    }
                    function getWatermarkFontSize(pageSize, watermark, fontProvider) {
                        var textTools = new TextTools(fontProvider);
                        var styleContextStack = new StyleContextStack(null, {
                            font: watermark.font,
                            bold: watermark.bold,
                            italics: watermark.italics
                        });
                        var rotatedSize;
                        /**
     * Binary search the best font size.
     * Initial bounds [0, 1000]
     * Break when range < 1
     */ var a = 0;
                        var b = 1000;
                        var c = (a + b) / 2;
                        while(Math.abs(a - b) > 1){
                            styleContextStack.push({
                                fontSize: c
                            });
                            rotatedSize = textTools.sizeOfRotatedText(watermark.text, watermark.angle, styleContextStack);
                            if (rotatedSize.width > pageSize.width) {
                                b = c;
                                c = (a + b) / 2;
                            } else if (rotatedSize.width < pageSize.width) {
                                if (rotatedSize.height > pageSize.height) {
                                    b = c;
                                    c = (a + b) / 2;
                                } else {
                                    a = c;
                                    c = (a + b) / 2;
                                }
                            }
                            styleContextStack.pop();
                        }
                        /*
     End binary search
     */ return c;
                    }
                };
                function decorateNode(node) {
                    var x = node.x, y = node.y;
                    node.positions = [];
                    if (isArray(node.canvas)) node.canvas.forEach(function(vector) {
                        var x = vector.x, y = vector.y, x1 = vector.x1, y1 = vector.y1, x2 = vector.x2, y2 = vector.y2;
                        vector.resetXY = function() {
                            vector.x = x;
                            vector.y = y;
                            vector.x1 = x1;
                            vector.y1 = y1;
                            vector.x2 = x2;
                            vector.y2 = y2;
                        };
                    });
                    node.resetXY = function() {
                        node.x = x;
                        node.y = y;
                        if (isArray(node.canvas)) node.canvas.forEach(function(vector) {
                            vector.resetXY();
                        });
                    };
                }
                LayoutBuilder.prototype.processNode = function(node) {
                    var self1 = this;
                    this.linearNodeList.push(node);
                    decorateNode(node);
                    applyMargins(function() {
                        var unbreakable = node.unbreakable;
                        if (unbreakable) self1.writer.beginUnbreakableBlock();
                        var absPosition = node.absolutePosition;
                        if (absPosition) {
                            self1.writer.context().beginDetachedBlock();
                            self1.writer.context().moveTo(absPosition.x || 0, absPosition.y || 0);
                        }
                        var relPosition = node.relativePosition;
                        if (relPosition) {
                            self1.writer.context().beginDetachedBlock();
                            self1.writer.context().moveToRelative(relPosition.x || 0, relPosition.y || 0);
                        }
                        if (node.stack) self1.processVerticalContainer(node);
                        else if (node.columns) self1.processColumns(node);
                        else if (node.ul) self1.processList(false, node);
                        else if (node.ol) self1.processList(true, node);
                        else if (node.table) self1.processTable(node);
                        else if (node.text !== undefined) self1.processLeaf(node);
                        else if (node.toc) self1.processToc(node);
                        else if (node.image) self1.processImage(node);
                        else if (node.svg) self1.processSVG(node);
                        else if (node.canvas) self1.processCanvas(node);
                        else if (node.qr) self1.processQr(node);
                        else if (!node._span) throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
                        if (absPosition || relPosition) self1.writer.context().endDetachedBlock();
                        if (unbreakable) self1.writer.commitUnbreakableBlock();
                    });
                    function applyMargins(callback) {
                        var margin = node._margin;
                        if (node.pageBreak === 'before') self1.writer.moveToNextPage(node.pageOrientation);
                        else if (node.pageBreak === 'beforeOdd') {
                            self1.writer.moveToNextPage(node.pageOrientation);
                            if ((self1.writer.context().page + 1) % 2 === 1) self1.writer.moveToNextPage(node.pageOrientation);
                        } else if (node.pageBreak === 'beforeEven') {
                            self1.writer.moveToNextPage(node.pageOrientation);
                            if ((self1.writer.context().page + 1) % 2 === 0) self1.writer.moveToNextPage(node.pageOrientation);
                        }
                        var isDetachedBlock = node.relativePosition || node.absolutePosition;
                        // Detached nodes have no margins, their position is only determined by 'x' and 'y'
                        if (margin && !isDetachedBlock) {
                            var availableHeight = self1.writer.context().availableHeight;
                            // If top margin is bigger than available space, move to next page
                            // Necessary for nodes inside tables
                            if (availableHeight - margin[1] < 0) {
                                // Consume the whole available space
                                self1.writer.context().moveDown(availableHeight);
                                self1.writer.moveToNextPage(node.pageOrientation);
                            /**
         * TODO - Something to consider:
         * Right now the node starts at the top of next page (after header)
         * Another option would be to apply just the top margin that has not been consumed in the page before
         * It would something like: this.write.context().moveDown(margin[1] - availableHeight)
         */ } else self1.writer.context().moveDown(margin[1]);
                            // Apply lateral margins
                            self1.writer.context().addMargin(margin[0], margin[2]);
                        }
                        callback();
                        // Detached nodes have no margins, their position is only determined by 'x' and 'y'
                        if (margin && !isDetachedBlock) {
                            var _availableHeight = self1.writer.context().availableHeight;
                            // If bottom margin is bigger than available space, move to next page
                            // Necessary for nodes inside tables
                            if (_availableHeight - margin[3] < 0) {
                                self1.writer.context().moveDown(_availableHeight);
                                self1.writer.moveToNextPage(node.pageOrientation);
                            /**
         * TODO - Something to consider:
         * Right now next node starts at the top of next page (after header)
         * Another option would be to apply the bottom margin that has not been consumed in the next page?
         * It would something like: this.write.context().moveDown(margin[3] - availableHeight)
         */ } else self1.writer.context().moveDown(margin[3]);
                            // Apply lateral margins
                            self1.writer.context().addMargin(-margin[0], -margin[2]);
                        }
                        if (node.pageBreak === 'after') self1.writer.moveToNextPage(node.pageOrientation);
                        else if (node.pageBreak === 'afterOdd') {
                            self1.writer.moveToNextPage(node.pageOrientation);
                            if ((self1.writer.context().page + 1) % 2 === 1) self1.writer.moveToNextPage(node.pageOrientation);
                        } else if (node.pageBreak === 'afterEven') {
                            self1.writer.moveToNextPage(node.pageOrientation);
                            if ((self1.writer.context().page + 1) % 2 === 0) self1.writer.moveToNextPage(node.pageOrientation);
                        }
                    }
                };
                // vertical container
                LayoutBuilder.prototype.processVerticalContainer = function(node) {
                    var self1 = this;
                    node.stack.forEach(function(item) {
                        self1.processNode(item);
                        addAll(node.positions, item.positions);
                    //TODO: paragraph gap
                    });
                };
                // columns
                LayoutBuilder.prototype.processColumns = function(columnNode) {
                    this.nestedLevel++;
                    var columns = columnNode.columns;
                    var availableWidth = this.writer.context().availableWidth;
                    var gaps = gapArray(columnNode._gap);
                    if (gaps) availableWidth -= (gaps.length - 1) * columnNode._gap;
                    ColumnCalculator.buildColumnWidths(columns, availableWidth);
                    var result = this.processRow({
                        marginX: columnNode._margin ? [
                            columnNode._margin[0],
                            columnNode._margin[2]
                        ] : [
                            0,
                            0
                        ],
                        cells: columns,
                        widths: columns,
                        gaps: gaps
                    });
                    addAll(columnNode.positions, result.positions);
                    this.nestedLevel--;
                    if (this.nestedLevel === 0) this.writer.context().resetMarginXTopParent();
                    function gapArray(gap) {
                        if (!gap) return null;
                        var gaps = [];
                        gaps.push(0);
                        for(var i = columns.length - 1; i > 0; i--)gaps.push(gap);
                        return gaps;
                    }
                };
                /**
 * Searches for a cell in the same row that starts a rowspan and is positioned immediately before the current cell.
 * Alternatively, it finds a cell where the colspan initiating the rowspan extends to the cell just before the current one.
 *
 * @param {Array<object>} arr - An array representing cells in a row.
 * @param {number} i - The index of the current cell to search backward from.
 * @returns {object|null} The starting cell of the rowspan if found; otherwise, `null`.
 */ LayoutBuilder.prototype._findStartingRowSpanCell = function(arr, i) {
                    var requiredColspan = 1;
                    for(var index = i - 1; index >= 0; index--){
                        if (!arr[index]._span) {
                            if (arr[index].rowSpan > 1 && (arr[index].colSpan || 1) === requiredColspan) return arr[index];
                            else return null;
                        }
                        requiredColspan++;
                    }
                    return null;
                };
                /**
 * Retrieves a page break description for a specified page from a list of page breaks.
 *
 * @param {Array<object>} pageBreaks - An array of page break descriptions, each containing `prevPage` properties.
 * @param {number} page - The page number to find the associated page break for.
 * @returns {object|undefined} The page break description object for the specified page if found; otherwise, `undefined`.
 */ LayoutBuilder.prototype._getPageBreak = function(pageBreaks, page) {
                    return pageBreaks.find(function(desc) {
                        return desc.prevPage === page;
                    });
                };
                LayoutBuilder.prototype._getPageBreakListBySpan = function(tableNode, page, rowIndex) {
                    if (!tableNode || !tableNode._breaksBySpan) return null;
                    var breaksList = tableNode._breaksBySpan.filter(function(desc) {
                        return desc.prevPage === page && rowIndex <= desc.rowIndexOfSpanEnd;
                    });
                    var y = Number.MAX_VALUE, prevY = Number.MIN_VALUE;
                    breaksList.forEach(function(b) {
                        prevY = Math.max(b.prevY, prevY);
                        y = Math.min(b.y, y);
                    });
                    return {
                        prevPage: page,
                        prevY: prevY,
                        y: y
                    };
                };
                LayoutBuilder.prototype._findSameRowPageBreakByRowSpanData = function(breaksBySpan, page, rowIndex) {
                    if (!breaksBySpan) return null;
                    return breaksBySpan.find(function(desc) {
                        return desc.prevPage === page && rowIndex === desc.rowIndexOfSpanEnd;
                    });
                };
                LayoutBuilder.prototype._updatePageBreaksData = function(pageBreaks, tableNode, rowIndex) {
                    var _this2 = this;
                    Object.keys(tableNode._bottomByPage).forEach(function(p) {
                        var page = Number(p);
                        var pageBreak = _this2._getPageBreak(pageBreaks, page);
                        if (pageBreak) pageBreak.prevY = Math.max(pageBreak.prevY, tableNode._bottomByPage[page]);
                        if (tableNode._breaksBySpan && tableNode._breaksBySpan.length > 0) {
                            var breaksBySpanList = tableNode._breaksBySpan.filter(function(pb) {
                                return pb.prevPage === page && rowIndex <= pb.rowIndexOfSpanEnd;
                            });
                            if (breaksBySpanList && breaksBySpanList.length > 0) breaksBySpanList.forEach(function(b) {
                                b.prevY = Math.max(b.prevY, tableNode._bottomByPage[page]);
                            });
                        }
                    });
                };
                /**
 * Resolves the Y-coordinates for a target object by comparing two break points.
 *
 * @param {object} break1 - The first break point with `prevY` and `y` properties.
 * @param {object} break2 - The second break point with `prevY` and `y` properties.
 * @param {object} target - The target object to be updated with resolved Y-coordinates.
 * @property {number} target.prevY - Updated to the maximum `prevY` value between `break1` and `break2`.
 * @property {number} target.y - Updated to the minimum `y` value between `break1` and `break2`.
 */ LayoutBuilder.prototype._resolveBreakY = function(break1, break2, target) {
                    target.prevY = Math.max(break1.prevY, break2.prevY);
                    target.y = Math.min(break1.y, break2.y);
                };
                LayoutBuilder.prototype._storePageBreakData = function(data, startsRowSpan, pageBreaks, tableNode) {
                    var pageDesc;
                    var pageDescBySpan;
                    if (!startsRowSpan) {
                        pageDesc = this._getPageBreak(pageBreaks, data.prevPage);
                        pageDescBySpan = this._getPageBreakListBySpan(tableNode, data.prevPage, data.rowIndex);
                        if (!pageDesc) {
                            pageDesc = Object.assign({}, data);
                            pageBreaks.push(pageDesc);
                        }
                        if (pageDescBySpan) this._resolveBreakY(pageDesc, pageDescBySpan, pageDesc);
                        this._resolveBreakY(pageDesc, data, pageDesc);
                    } else {
                        var breaksBySpan = tableNode && tableNode._breaksBySpan || null;
                        pageDescBySpan = this._findSameRowPageBreakByRowSpanData(breaksBySpan, data.prevPage, data.rowIndex);
                        if (!pageDescBySpan) {
                            pageDescBySpan = Object.assign({}, data, {
                                rowIndexOfSpanEnd: data.rowIndex + data.rowSpan - 1
                            });
                            if (!tableNode._breaksBySpan) tableNode._breaksBySpan = [];
                            tableNode._breaksBySpan.push(pageDescBySpan);
                        }
                        pageDescBySpan.prevY = Math.max(pageDescBySpan.prevY, data.prevY);
                        pageDescBySpan.y = Math.min(pageDescBySpan.y, data.y);
                        pageDesc = this._getPageBreak(pageBreaks, data.prevPage);
                        if (pageDesc) this._resolveBreakY(pageDesc, pageDescBySpan, pageDesc);
                    }
                };
                /**
 * Calculates the left offset for a column based on the specified gap values.
 *
 * @param {number} i - The index of the column for which the offset is being calculated.
 * @param {Array<number>} gaps - An array of gap values for each column.
 * @returns {number} The left offset for the column. Returns `gaps[i]` if it exists, otherwise `0`.
 */ LayoutBuilder.prototype._colLeftOffset = function(i, gaps) {
                    if (gaps && gaps.length > i) return gaps[i];
                    return 0;
                };
                /**
 * Retrieves the ending cell for a row span in case it exists in a specified table column.
 *
 * @param {Array<Array<object>>} tableBody - The table body, represented as a 2D array of cell objects.
 * @param {number} rowIndex - The index of the starting row for the row span.
 * @param {object} column - The column object containing row span information.
 * @param {number} columnIndex - The index of the column within the row.
 * @returns {object|null} The cell at the end of the row span if it exists; otherwise, `null`.
 * @throws {Error} If the row span extends beyond the total row count.
 */ LayoutBuilder.prototype._getRowSpanEndingCell = function(tableBody, rowIndex, column, columnIndex) {
                    if (column.rowSpan && column.rowSpan > 1) {
                        var endingRow = rowIndex + column.rowSpan - 1;
                        if (endingRow >= tableBody.length) throw new Error("Row span for column " + columnIndex + " (with indexes starting from 0) exceeded row count");
                        return tableBody[endingRow][columnIndex];
                    }
                    return null;
                };
                LayoutBuilder.prototype.processRow = function(_ref) {
                    var _ref$marginX = _ref.marginX, marginX = _ref$marginX === void 0 ? [
                        0,
                        0
                    ] : _ref$marginX, _ref$dontBreakRows = _ref.dontBreakRows, dontBreakRows = _ref$dontBreakRows === void 0 ? false : _ref$dontBreakRows, _ref$rowsWithoutPageB = _ref.rowsWithoutPageBreak, rowsWithoutPageBreak = _ref$rowsWithoutPageB === void 0 ? 0 : _ref$rowsWithoutPageB, cells = _ref.cells, widths = _ref.widths, gaps = _ref.gaps, tableNode = _ref.tableNode, tableBody = _ref.tableBody, rowIndex = _ref.rowIndex, height = _ref.height;
                    var self1 = this;
                    var isUnbreakableRow = dontBreakRows || rowIndex <= rowsWithoutPageBreak - 1;
                    var pageBreaks = [];
                    var pageBreaksByRowSpan = [];
                    var positions = [];
                    var willBreakByHeight = false;
                    widths = widths || cells;
                    // Check if row should break by height
                    if (!isUnbreakableRow && height > self1.writer.context().availableHeight) willBreakByHeight = true;
                    // Use the marginX if we are in a top level table/column (not nested)
                    var marginXParent = self1.nestedLevel === 1 ? marginX : null;
                    var _bottomByPage = tableNode ? tableNode._bottomByPage : null;
                    this.writer.context().beginColumnGroup(marginXParent, _bottomByPage);
                    for(var i = 0, l = cells.length; i < l; i++){
                        var cell = cells[i];
                        // Page change handler
                        this.tracker.auto('pageChanged', storePageBreakClosure, function() {
                            var width = widths[i]._calcWidth;
                            var leftOffset = self1._colLeftOffset(i, gaps);
                            // Check if exists and retrieve the cell that started the rowspan in case we are in the cell just after
                            var startingSpanCell = self1._findStartingRowSpanCell(cells, i);
                            if (cell.colSpan && cell.colSpan > 1) for(var j = 1; j < cell.colSpan; j++)width += widths[++i]._calcWidth + gaps[i];
                            // if rowspan starts in this cell, we retrieve the last cell affected by the rowspan
                            var rowSpanEndingCell = self1._getRowSpanEndingCell(tableBody, rowIndex, cell, i);
                            if (rowSpanEndingCell) {
                                // We store a reference of the ending cell in the first cell of the rowspan
                                cell._endingCell = rowSpanEndingCell;
                                cell._endingCell._startingRowSpanY = cell._startingRowSpanY;
                            }
                            // If we are after a cell that started a rowspan
                            var endOfRowSpanCell = null;
                            if (startingSpanCell && startingSpanCell._endingCell) {
                                // Reference to the last cell of the rowspan
                                endOfRowSpanCell = startingSpanCell._endingCell;
                                // Store if we are in an unbreakable block when we save the context and the originalX
                                if (self1.writer.transactionLevel > 0) {
                                    endOfRowSpanCell._isUnbreakableContext = true;
                                    endOfRowSpanCell._originalXOffset = self1.writer.originalX;
                                }
                            }
                            // We pass the endingSpanCell reference to store the context just after processing rowspan cell
                            self1.writer.context().beginColumn(width, leftOffset, endOfRowSpanCell);
                            if (!cell._span) {
                                self1.processNode(cell);
                                self1.writer.context().updateBottomByPage();
                                addAll(positions, cell.positions);
                            } else if (cell._columnEndingContext) {
                                var discountY = 0;
                                if (dontBreakRows) {
                                    // Calculate how many points we have to discount to Y when dontBreakRows and rowSpan are combined
                                    var ctxBeforeRowSpanLastRow = self1.writer.writer.contextStack[self1.writer.writer.contextStack.length - 1];
                                    discountY = ctxBeforeRowSpanLastRow.y - cell._startingRowSpanY;
                                }
                                var originalXOffset = 0;
                                // If context was saved from an unbreakable block and we are not in an unbreakable block anymore
                                // We have to sum the originalX (X before starting unbreakable block) to X
                                if (cell._isUnbreakableContext && !self1.writer.transactionLevel) originalXOffset = cell._originalXOffset;
                                // row-span ending
                                // Recover the context after processing the rowspanned cell
                                self1.writer.context().markEnding(cell, originalXOffset, discountY);
                            }
                        });
                    }
                    // Check if last cell is part of a span
                    var endingSpanCell = null;
                    var lastColumn = cells.length > 0 ? cells[cells.length - 1] : null;
                    if (lastColumn) {
                        // Previous column cell has a rowspan
                        if (lastColumn._endingCell) endingSpanCell = lastColumn._endingCell;
                        else if (lastColumn._span === true) {
                            // We get the cell that started the span where we set a reference to the ending cell
                            var startingSpanCell = this._findStartingRowSpanCell(cells, cells.length);
                            if (startingSpanCell) {
                                // Context will be stored here (ending cell)
                                endingSpanCell = startingSpanCell._endingCell;
                                // Store if we are in an unbreakable block when we save the context and the originalX
                                if (this.writer.transactionLevel > 0) {
                                    endingSpanCell._isUnbreakableContext = true;
                                    endingSpanCell._originalXOffset = this.writer.originalX;
                                }
                            }
                        }
                    }
                    // If content did not break page, check if we should break by height
                    if (willBreakByHeight && !isUnbreakableRow && pageBreaks.length === 0) {
                        this.writer.context().moveDown(this.writer.context().availableHeight);
                        this.writer.moveToNextPage();
                    }
                    var bottomByPage = this.writer.context().completeColumnGroup(height, endingSpanCell);
                    if (tableNode) {
                        tableNode._bottomByPage = bottomByPage;
                        // If there are page breaks in this row, update data with prevY of last cell
                        this._updatePageBreaksData(pageBreaks, tableNode, rowIndex);
                    }
                    return {
                        pageBreaksBySpan: pageBreaksByRowSpan,
                        pageBreaks: pageBreaks,
                        positions: positions
                    };
                    function storePageBreakClosure(data) {
                        var startsRowSpan = cell.rowSpan && cell.rowSpan > 1;
                        if (startsRowSpan) data.rowSpan = cell.rowSpan;
                        data.rowIndex = rowIndex;
                        self1._storePageBreakData(data, startsRowSpan, pageBreaks, tableNode);
                    }
                };
                // lists
                LayoutBuilder.prototype.processList = function(orderedList, node) {
                    var self1 = this, items = orderedList ? node.ol : node.ul, gapSize = node._gapSize;
                    this.writer.context().addMargin(gapSize.width);
                    var nextMarker;
                    this.tracker.auto('lineAdded', addMarkerToFirstLeaf, function() {
                        items.forEach(function(item) {
                            nextMarker = item.listMarker;
                            self1.processNode(item);
                            addAll(node.positions, item.positions);
                        });
                    });
                    this.writer.context().addMargin(-gapSize.width);
                    function addMarkerToFirstLeaf(line) {
                        // I'm not very happy with the way list processing is implemented
                        // (both code and algorithm should be rethinked)
                        if (nextMarker) {
                            var marker = nextMarker;
                            nextMarker = null;
                            if (marker.canvas) {
                                var vector = marker.canvas[0];
                                offsetVector(vector, -marker._minWidth, 0);
                                self1.writer.addVector(vector);
                            } else if (marker._inlines) {
                                var markerLine = new Line(self1.pageSize.width);
                                markerLine.addInline(marker._inlines[0]);
                                markerLine.x = -marker._minWidth;
                                markerLine.y = line.getAscenderHeight() - markerLine.getAscenderHeight();
                                self1.writer.addLine(markerLine, true);
                            }
                        }
                    }
                };
                // tables
                LayoutBuilder.prototype.processTable = function(tableNode) {
                    var _this3 = this;
                    this.nestedLevel++;
                    var processor = new TableProcessor(tableNode);
                    processor.beginTable(this.writer);
                    var rowHeights = tableNode.table.heights;
                    for(var i = 0, l = tableNode.table.body.length; i < l; i++){
                        // if dontBreakRows and row starts a rowspan
                        // we store the 'y' of the beginning of each rowSpan
                        if (processor.dontBreakRows) tableNode.table.body[i].forEach(function(cell) {
                            if (cell.rowSpan && cell.rowSpan > 1) cell._startingRowSpanY = _this3.writer.context().y;
                        });
                        processor.beginRow(i, this.writer);
                        var height;
                        if (isFunction(rowHeights)) height = rowHeights(i);
                        else if (isArray(rowHeights)) height = rowHeights[i];
                        else height = rowHeights;
                        if (height === 'auto') height = undefined;
                        var pageBeforeProcessing = this.writer.context().page;
                        var result = this.processRow({
                            marginX: tableNode._margin ? [
                                tableNode._margin[0],
                                tableNode._margin[2]
                            ] : [
                                0,
                                0
                            ],
                            dontBreakRows: processor.dontBreakRows,
                            rowsWithoutPageBreak: processor.rowsWithoutPageBreak,
                            cells: tableNode.table.body[i],
                            widths: tableNode.table.widths,
                            gaps: tableNode._offsets.offsets,
                            tableBody: tableNode.table.body,
                            tableNode: tableNode,
                            rowIndex: i,
                            height: height
                        });
                        addAll(tableNode.positions, result.positions);
                        if (!result.pageBreaks || result.pageBreaks.length === 0) {
                            var breaksBySpan = tableNode && tableNode._breaksBySpan || null;
                            var breakBySpanData = this._findSameRowPageBreakByRowSpanData(breaksBySpan, pageBeforeProcessing, i);
                            if (breakBySpanData) {
                                var finalBreakBySpanData = this._getPageBreakListBySpan(tableNode, breakBySpanData.prevPage, i);
                                result.pageBreaks.push(finalBreakBySpanData);
                            }
                        }
                        processor.endRow(i, this.writer, result.pageBreaks);
                    }
                    processor.endTable(this.writer);
                    this.nestedLevel--;
                    if (this.nestedLevel === 0) this.writer.context().resetMarginXTopParent();
                };
                // leafs (texts)
                LayoutBuilder.prototype.processLeaf = function(node) {
                    var line = this.buildNextLine(node);
                    if (line && (node.tocItem || node.id)) line._node = node;
                    var currentHeight = line ? line.getHeight() : 0;
                    var maxHeight = node.maxHeight || -1;
                    if (line) {
                        var nodeId = getNodeId(node);
                        if (nodeId) line.id = nodeId;
                    }
                    if (node._tocItemRef) line._pageNodeRef = node._tocItemRef;
                    if (node._pageRef) line._pageNodeRef = node._pageRef._nodeRef;
                    if (line && line.inlines && isArray(line.inlines)) for(var i = 0, l = line.inlines.length; i < l; i++){
                        if (line.inlines[i]._tocItemRef) line.inlines[i]._pageNodeRef = line.inlines[i]._tocItemRef;
                        if (line.inlines[i]._pageRef) line.inlines[i]._pageNodeRef = line.inlines[i]._pageRef._nodeRef;
                    }
                    while(line && (maxHeight === -1 || currentHeight < maxHeight)){
                        var positions = this.writer.addLine(line);
                        node.positions.push(positions);
                        line = this.buildNextLine(node);
                        if (line) currentHeight += line.getHeight();
                    }
                };
                LayoutBuilder.prototype.processToc = function(node) {
                    if (node.toc.title) this.processNode(node.toc.title);
                    if (node.toc._table) this.processNode(node.toc._table);
                };
                LayoutBuilder.prototype.buildNextLine = function(textNode) {
                    function cloneInline(inline) {
                        var newInline = inline.constructor();
                        for(var key in inline)newInline[key] = inline[key];
                        return newInline;
                    }
                    function findMaxFitLength(text, maxWidth, measureFn) {
                        var low = 1;
                        var high = text.length;
                        var bestFit = 1;
                        while(low <= high){
                            var mid = Math.floor((low + high) / 2);
                            var part = text.substring(0, mid);
                            var width = measureFn(part);
                            if (width <= maxWidth) {
                                bestFit = mid;
                                low = mid + 1;
                            } else high = mid - 1;
                        }
                        return bestFit;
                    }
                    if (!textNode._inlines || textNode._inlines.length === 0) return null;
                    var line = new Line(this.writer.context().availableWidth);
                    var textTools = new TextTools(null);
                    var isForceContinue = false;
                    while(textNode._inlines && textNode._inlines.length > 0 && (line.hasEnoughSpaceForInline(textNode._inlines[0], textNode._inlines.slice(1)) || isForceContinue)){
                        var isHardWrap = false;
                        var inline = textNode._inlines.shift();
                        isForceContinue = false;
                        if (!inline.noWrap && inline.text.length > 1 && inline.width > line.getAvailableWidth()) {
                            var maxChars = findMaxFitLength(inline.text, line.getAvailableWidth(), function(txt) {
                                return textTools.widthOfString(txt, inline.font, inline.fontSize, inline.characterSpacing, inline.fontFeatures);
                            });
                            if (maxChars < inline.text.length) {
                                var newInline = cloneInline(inline);
                                newInline.text = inline.text.substr(maxChars);
                                inline.text = inline.text.substr(0, maxChars);
                                newInline.width = textTools.widthOfString(newInline.text, newInline.font, newInline.fontSize, newInline.characterSpacing, newInline.fontFeatures);
                                inline.width = textTools.widthOfString(inline.text, inline.font, inline.fontSize, inline.characterSpacing, inline.fontFeatures);
                                textNode._inlines.unshift(newInline);
                                isHardWrap = true;
                            }
                        }
                        line.addInline(inline);
                        isForceContinue = inline.noNewLine && !isHardWrap;
                    }
                    line.lastLineInParagraph = textNode._inlines.length === 0;
                    return line;
                };
                // images
                LayoutBuilder.prototype.processImage = function(node) {
                    var position = this.writer.addImage(node);
                    node.positions.push(position);
                };
                LayoutBuilder.prototype.processSVG = function(node) {
                    var position = this.writer.addSVG(node);
                    node.positions.push(position);
                };
                LayoutBuilder.prototype.processCanvas = function(node) {
                    var height = node._minHeight;
                    if (node.absolutePosition === undefined && this.writer.context().availableHeight < height) // TODO: support for canvas larger than a page
                    // TODO: support for other overflow methods
                    this.writer.moveToNextPage();
                    this.writer.alignCanvas(node);
                    node.canvas.forEach(function(vector) {
                        var position = this.writer.addVector(vector);
                        node.positions.push(position);
                    }, this);
                    this.writer.context().moveDown(height);
                };
                LayoutBuilder.prototype.processQr = function(node) {
                    var position = this.writer.addQr(node);
                    node.positions.push(position);
                };
                module1.exports = LayoutBuilder;
            /***/ },
            /***/ 65553: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(98828);
                // `Int8Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor('Int8', function(init) {
                    return function Int8Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 65578: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var toAbsoluteIndex = __webpack_require__(74841);
                var RangeError1 = global.RangeError;
                var fromCharCode = String.fromCharCode;
                // eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
                var $fromCodePoint = String.fromCodePoint;
                var join = uncurryThis([].join);
                // length should be 1, old FF problem
                var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length != 1;
                // `String.fromCodePoint` method
                // https://tc39.es/ecma262/#sec-string.fromcodepoint
                $({
                    target: 'String',
                    stat: true,
                    forced: INCORRECT_LENGTH
                }, {
                    // eslint-disable-next-line no-unused-vars -- required for `.length`
                    fromCodePoint: function fromCodePoint(x) {
                        var elements = [];
                        var length = arguments.length;
                        var i = 0;
                        var code;
                        while(length > i){
                            code = +arguments[i++];
                            if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw RangeError1(code + ' is not a valid code point');
                            elements[i] = code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
                        }
                        return join(elements, '');
                    }
                });
            /***/ },
            /***/ 65881: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(20731);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    /** @preserve
   * Counter block mode compatible with  Dr Brian Gladman fileenc.c
   * derived from CryptoJS.mode.CTR
   * Jan Hruby jhruby.web@gmail.com
   */ CryptoJS.mode.CTRGladman = function() {
                        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
                        function incWord(word) {
                            if ((word >> 24 & 0xff) === 0xff) {
                                //overflow
                                var b1 = word >> 16 & 0xff;
                                var b2 = word >> 8 & 0xff;
                                var b3 = word & 0xff;
                                if (b1 === 0xff) // overflow b1
                                {
                                    b1 = 0;
                                    if (b2 === 0xff) {
                                        b2 = 0;
                                        if (b3 === 0xff) b3 = 0;
                                        else ++b3;
                                    } else ++b2;
                                } else ++b1;
                                word = 0;
                                word += b1 << 16;
                                word += b2 << 8;
                                word += b3;
                            } else word += 16777216;
                            return word;
                        }
                        function incCounter(counter) {
                            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
                            counter[1] = incWord(counter[1]);
                            return counter;
                        }
                        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
                            processBlock: function processBlock(words, offset) {
                                // Shortcuts
                                var cipher = this._cipher;
                                var blockSize = cipher.blockSize;
                                var iv = this._iv;
                                var counter = this._counter;
                                // Generate keystream
                                if (iv) {
                                    counter = this._counter = iv.slice(0);
                                    // Remove IV for subsequent blocks
                                    this._iv = undefined;
                                }
                                incCounter(counter);
                                var keystream = counter.slice(0);
                                cipher.encryptBlock(keystream, 0);
                                // Encrypt
                                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
                            }
                        });
                        CTRGladman.Decryptor = Encryptor;
                        return CTRGladman;
                    }();
                    return CryptoJS.mode.CTRGladman;
                });
            /***/ },
            /***/ 66288: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(32010);
                var ArrayBufferViewCore = __webpack_require__(59754);
                var lengthOfArrayLike = __webpack_require__(45495);
                var toOffset = __webpack_require__(80670);
                var toObject = __webpack_require__(43162);
                var fails = __webpack_require__(47044);
                var RangeError1 = global.RangeError;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var FORCED = fails(function() {
                    // eslint-disable-next-line es/no-typed-arrays -- required for testing
                    new Int8Array(1).set({});
                });
                // `%TypedArray%.prototype.set` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
                exportTypedArrayMethod('set', function set(arrayLike /* , offset */ ) {
                    aTypedArray(this);
                    var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
                    var length = this.length;
                    var src = toObject(arrayLike);
                    var len = lengthOfArrayLike(src);
                    var index = 0;
                    if (len + offset > length) throw RangeError1('Wrong length');
                    while(index < len)this[offset + index] = src[index++];
                }, FORCED);
            /***/ },
            /***/ 66664: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(20731);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352));
                })(void 0, function(CryptoJS) {
                    (function(Math1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var Hasher = C_lib.Hasher;
                        var C_algo = C.algo;
                        // Initialization and round constants tables
                        var H = [];
                        var K = [];
                        // Compute constants
                        (function() {
                            function isPrime(n) {
                                var sqrtN = Math1.sqrt(n);
                                for(var factor = 2; factor <= sqrtN; factor++){
                                    if (!(n % factor)) return false;
                                }
                                return true;
                            }
                            function getFractionalBits(n) {
                                return (n - (n | 0)) * 0x100000000 | 0;
                            }
                            var n = 2;
                            var nPrime = 0;
                            while(nPrime < 64){
                                if (isPrime(n)) {
                                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                                    nPrime++;
                                }
                                n++;
                            }
                        })();
                        // Reusable object
                        var W = [];
                        /**
     * SHA-256 hash algorithm.
     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
                            _doReset: function _doReset() {
                                this._hash = new WordArray.init(H.slice(0));
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcut
                                var H = this._hash.words;
                                // Working variables
                                var a = H[0];
                                var b = H[1];
                                var c = H[2];
                                var d = H[3];
                                var e = H[4];
                                var f = H[5];
                                var g = H[6];
                                var h = H[7];
                                // Computation
                                for(var i = 0; i < 64; i++){
                                    if (i < 16) W[i] = M[offset + i] | 0;
                                    else {
                                        var gamma0x = W[i - 15];
                                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                                        var gamma1x = W[i - 2];
                                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                                    }
                                    var ch = e & f ^ ~e & g;
                                    var maj = a & b ^ a & c ^ b & c;
                                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                                    var t1 = h + sigma1 + ch + K[i] + W[i];
                                    var t2 = sigma0 + maj;
                                    h = g;
                                    g = f;
                                    f = e;
                                    e = d + t1 | 0;
                                    d = c;
                                    c = b;
                                    b = a;
                                    a = t1 + t2 | 0;
                                }
                                // Intermediate hash value
                                H[0] = H[0] + a | 0;
                                H[1] = H[1] + b | 0;
                                H[2] = H[2] + c | 0;
                                H[3] = H[3] + d | 0;
                                H[4] = H[4] + e | 0;
                                H[5] = H[5] + f | 0;
                                H[6] = H[6] + g | 0;
                                H[7] = H[7] + h | 0;
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                                data.sigBytes = dataWords.length * 4;
                                // Hash final blocks
                                this._process();
                                // Return final computed hash
                                return this._hash;
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                clone._hash = this._hash.clone();
                                return clone;
                            }
                        });
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA256('message');
     *     var hash = CryptoJS.SHA256(wordArray);
     */ C.SHA256 = Hasher._createHelper(SHA256);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA256(message, key);
     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
                    })(Math);
                    return CryptoJS.SHA256;
                });
            /***/ },
            /***/ 66723: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var call = __webpack_require__(2834);
                var anObject = __webpack_require__(34984);
                var isCallable = __webpack_require__(94578);
                var classof = __webpack_require__(93975);
                var regexpExec = __webpack_require__(49820);
                var TypeError1 = global.TypeError;
                // `RegExpExec` abstract operation
                // https://tc39.es/ecma262/#sec-regexpexec
                module1.exports = function(R, S) {
                    var exec = R.exec;
                    if (isCallable(exec)) {
                        var result = call(exec, R, S);
                        if (result !== null) anObject(result);
                        return result;
                    }
                    if (classof(R) === 'RegExp') return call(regexpExec, R, S);
                    throw TypeError1('RegExp#exec called on incompatible receiver');
                };
            /***/ },
            /***/ 66947: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(94845);
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var C_enc = C.enc;
                        /**
     * Base64 encoding strategy.
     */ var Base64 = C_enc.Base64 = {
                            /**
       * Converts a word array to a Base64 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The Base64 string.
       *
       * @static
       *
       * @example
       *
       *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
       */ stringify: function stringify(wordArray) {
                                // Shortcuts
                                var words = wordArray.words;
                                var sigBytes = wordArray.sigBytes;
                                var map = this._map;
                                // Clamp excess bits
                                wordArray.clamp();
                                // Convert
                                var base64Chars = [];
                                for(var i = 0; i < sigBytes; i += 3){
                                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                                }
                                // Add padding
                                var paddingChar = map.charAt(64);
                                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                                return base64Chars.join('');
                            },
                            /**
       * Converts a Base64 string to a word array.
       *
       * @param {string} base64Str The Base64 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
       */ parse: function parse(base64Str) {
                                // Shortcuts
                                var base64StrLength = base64Str.length;
                                var map = this._map;
                                var reverseMap = this._reverseMap;
                                if (!reverseMap) {
                                    reverseMap = this._reverseMap = [];
                                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                                }
                                // Ignore padding
                                var paddingChar = map.charAt(64);
                                if (paddingChar) {
                                    var paddingIndex = base64Str.indexOf(paddingChar);
                                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                                }
                                // Convert
                                return parseLoop(base64Str, base64StrLength, reverseMap);
                            },
                            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
                        };
                        function parseLoop(base64Str, base64StrLength, reverseMap) {
                            var words = [];
                            var nBytes = 0;
                            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                                var bitsCombined = bits1 | bits2;
                                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                                nBytes++;
                            }
                            return WordArray.create(words, nBytes);
                        }
                    })();
                    return CryptoJS.enc.Base64;
                });
            /***/ },
            /***/ 67797: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                // in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
                var documentCreateElement = __webpack_require__(12072);
                var classList = documentCreateElement('span').classList;
                var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
                module1.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;
            /***/ },
            /***/ 67858: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(44455);
            /***/ },
            /***/ 67906: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var hasToStringTag = __webpack_require__(26626)();
                var callBound = __webpack_require__(22774);
                var $toString = callBound('Object.prototype.toString');
                /** @type {import('.')} */ var isStandardArguments = function isArguments(value) {
                    if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
                    return $toString(value) === '[object Arguments]';
                };
                /** @type {import('.')} */ var isLegacyArguments = function isArguments(value) {
                    if (isStandardArguments(value)) return true;
                    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $toString(value) !== '[object Array]' && 'callee' in value && $toString(value.callee) === '[object Function]';
                };
                var supportsStandardArguments = function() {
                    return isStandardArguments(arguments);
                }();
                // @ts-expect-error TODO make this not error
                isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
                /** @type {import('.')} */ module1.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
            /***/ },
            /***/ 67913: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var GetIntrinsic = __webpack_require__(28651);
                var callBind = __webpack_require__(26601);
                var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
                module1.exports = function callBoundIntrinsic(name, allowMissing) {
                    var intrinsic = GetIntrinsic(name, !!allowMissing);
                    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) return callBind(intrinsic);
                    return intrinsic;
                };
            /***/ },
            /***/ 68067: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var IS_PURE = __webpack_require__(63432);
                var global = __webpack_require__(32010);
                var getBuiltIn = __webpack_require__(38486);
                var call = __webpack_require__(2834);
                var NativePromise = __webpack_require__(5155);
                var redefine = __webpack_require__(13711);
                var redefineAll = __webpack_require__(15341);
                var setPrototypeOf = __webpack_require__(3840);
                var setToStringTag = __webpack_require__(15216);
                var setSpecies = __webpack_require__(51334);
                var aCallable = __webpack_require__(32631);
                var isCallable = __webpack_require__(94578);
                var isObject = __webpack_require__(24517);
                var anInstance = __webpack_require__(2868);
                var inspectSource = __webpack_require__(10447);
                var iterate = __webpack_require__(80383);
                var checkCorrectnessOfIteration = __webpack_require__(46769);
                var speciesConstructor = __webpack_require__(27754);
                var task = __webpack_require__(6616).set;
                var microtask = __webpack_require__(59804);
                var promiseResolve = __webpack_require__(28617);
                var hostReportErrors = __webpack_require__(61144);
                var newPromiseCapabilityModule = __webpack_require__(56614);
                var perform = __webpack_require__(61900);
                var InternalStateModule = __webpack_require__(70172);
                var isForced = __webpack_require__(39599);
                var wellKnownSymbol = __webpack_require__(38688);
                var IS_BROWSER = __webpack_require__(3157);
                var IS_NODE = __webpack_require__(95053);
                var V8_VERSION = __webpack_require__(70091);
                var SPECIES = wellKnownSymbol('species');
                var PROMISE = 'Promise';
                var getInternalState = InternalStateModule.get;
                var setInternalState = InternalStateModule.set;
                var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
                var NativePromisePrototype = NativePromise && NativePromise.prototype;
                var PromiseConstructor = NativePromise;
                var PromisePrototype = NativePromisePrototype;
                var TypeError1 = global.TypeError;
                var document1 = global.document;
                var process = global.process;
                var newPromiseCapability = newPromiseCapabilityModule.f;
                var newGenericPromiseCapability = newPromiseCapability;
                var DISPATCH_EVENT = !!(document1 && document1.createEvent && global.dispatchEvent);
                var NATIVE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
                var UNHANDLED_REJECTION = 'unhandledrejection';
                var REJECTION_HANDLED = 'rejectionhandled';
                var PENDING = 0;
                var FULFILLED = 1;
                var REJECTED = 2;
                var HANDLED = 1;
                var UNHANDLED = 2;
                var SUBCLASSING = false;
                var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
                var FORCED = isForced(PROMISE, function() {
                    var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
                    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
                    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
                    // We can't detect it synchronously, so just check versions
                    if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
                    // We need Promise#finally in the pure version for preventing prototype pollution
                    if (IS_PURE && !PromisePrototype['finally']) return true;
                    // We can't use @@species feature detection in V8 since it causes
                    // deoptimization and performance degradation
                    // https://github.com/zloirock/core-js/issues/679
                    if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
                    // Detect correctness of subclassing with @@species support
                    var promise = new PromiseConstructor(function(resolve) {
                        resolve(1);
                    });
                    var FakePromise = function(exec) {
                        exec(function() {}, function() {});
                    };
                    var constructor = promise.constructor = {};
                    constructor[SPECIES] = FakePromise;
                    SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
                    if (!SUBCLASSING) return true;
                    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
                    return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
                });
                var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function(iterable) {
                    PromiseConstructor.all(iterable)['catch'](function() {});
                });
                // helpers
                var isThenable = function(it) {
                    var then;
                    return isObject(it) && isCallable(then = it.then) ? then : false;
                };
                var notify = function(state, isReject) {
                    if (state.notified) return;
                    state.notified = true;
                    var chain = state.reactions;
                    microtask(function() {
                        var value = state.value;
                        var ok = state.state == FULFILLED;
                        var index = 0;
                        // variable length - can't use forEach
                        while(chain.length > index){
                            var reaction = chain[index++];
                            var handler = ok ? reaction.ok : reaction.fail;
                            var resolve = reaction.resolve;
                            var reject = reaction.reject;
                            var domain = reaction.domain;
                            var result, then, exited;
                            try {
                                if (handler) {
                                    if (!ok) {
                                        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                                        state.rejection = HANDLED;
                                    }
                                    if (handler === true) result = value;
                                    else {
                                        if (domain) domain.enter();
                                        result = handler(value); // can throw
                                        if (domain) {
                                            domain.exit();
                                            exited = true;
                                        }
                                    }
                                    if (result === reaction.promise) reject(TypeError1('Promise-chain cycle'));
                                    else if (then = isThenable(result)) call(then, result, resolve, reject);
                                    else resolve(result);
                                } else reject(value);
                            } catch (error) {
                                if (domain && !exited) domain.exit();
                                reject(error);
                            }
                        }
                        state.reactions = [];
                        state.notified = false;
                        if (isReject && !state.rejection) onUnhandled(state);
                    });
                };
                var dispatchEvent = function(name, promise, reason) {
                    var event, handler;
                    if (DISPATCH_EVENT) {
                        event = document1.createEvent('Event');
                        event.promise = promise;
                        event.reason = reason;
                        event.initEvent(name, false, true);
                        global.dispatchEvent(event);
                    } else event = {
                        promise: promise,
                        reason: reason
                    };
                    if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
                    else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
                };
                var onUnhandled = function(state) {
                    call(task, global, function() {
                        var promise = state.facade;
                        var value = state.value;
                        var IS_UNHANDLED = isUnhandled(state);
                        var result;
                        if (IS_UNHANDLED) {
                            result = perform(function() {
                                if (IS_NODE) process.emit('unhandledRejection', value, promise);
                                else dispatchEvent(UNHANDLED_REJECTION, promise, value);
                            });
                            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
                            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
                            if (result.error) throw result.value;
                        }
                    });
                };
                var isUnhandled = function(state) {
                    return state.rejection !== HANDLED && !state.parent;
                };
                var onHandleUnhandled = function(state) {
                    call(task, global, function() {
                        var promise = state.facade;
                        if (IS_NODE) process.emit('rejectionHandled', promise);
                        else dispatchEvent(REJECTION_HANDLED, promise, state.value);
                    });
                };
                var bind = function(fn, state, unwrap) {
                    return function(value) {
                        fn(state, value, unwrap);
                    };
                };
                var internalReject = function(state, value, unwrap) {
                    if (state.done) return;
                    state.done = true;
                    if (unwrap) state = unwrap;
                    state.value = value;
                    state.state = REJECTED;
                    notify(state, true);
                };
                var internalResolve = function(state, value, unwrap) {
                    if (state.done) return;
                    state.done = true;
                    if (unwrap) state = unwrap;
                    try {
                        if (state.facade === value) throw TypeError1("Promise can't be resolved itself");
                        var then = isThenable(value);
                        if (then) microtask(function() {
                            var wrapper = {
                                done: false
                            };
                            try {
                                call(then, value, bind(internalResolve, wrapper, state), bind(internalReject, wrapper, state));
                            } catch (error) {
                                internalReject(wrapper, error, state);
                            }
                        });
                        else {
                            state.value = value;
                            state.state = FULFILLED;
                            notify(state, false);
                        }
                    } catch (error) {
                        internalReject({
                            done: false
                        }, error, state);
                    }
                };
                // constructor polyfill
                if (FORCED) {
                    // 25.4.3.1 Promise(executor)
                    PromiseConstructor = function Promise1(executor) {
                        anInstance(this, PromisePrototype);
                        aCallable(executor);
                        call(Internal, this);
                        var state = getInternalState(this);
                        try {
                            executor(bind(internalResolve, state), bind(internalReject, state));
                        } catch (error) {
                            internalReject(state, error);
                        }
                    };
                    PromisePrototype = PromiseConstructor.prototype;
                    // eslint-disable-next-line no-unused-vars -- required for `.length`
                    Internal = function Promise1(executor) {
                        setInternalState(this, {
                            type: PROMISE,
                            done: false,
                            notified: false,
                            parent: false,
                            reactions: [],
                            rejection: false,
                            state: PENDING,
                            value: undefined
                        });
                    };
                    Internal.prototype = redefineAll(PromisePrototype, {
                        // `Promise.prototype.then` method
                        // https://tc39.es/ecma262/#sec-promise.prototype.then
                        then: function then(onFulfilled, onRejected) {
                            var state = getInternalPromiseState(this);
                            var reactions = state.reactions;
                            var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
                            reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
                            reaction.fail = isCallable(onRejected) && onRejected;
                            reaction.domain = IS_NODE ? process.domain : undefined;
                            state.parent = true;
                            reactions[reactions.length] = reaction;
                            if (state.state != PENDING) notify(state, false);
                            return reaction.promise;
                        },
                        // `Promise.prototype.catch` method
                        // https://tc39.es/ecma262/#sec-promise.prototype.catch
                        'catch': function(onRejected) {
                            return this.then(undefined, onRejected);
                        }
                    });
                    OwnPromiseCapability = function() {
                        var promise = new Internal();
                        var state = getInternalState(promise);
                        this.promise = promise;
                        this.resolve = bind(internalResolve, state);
                        this.reject = bind(internalReject, state);
                    };
                    newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
                        return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
                    };
                    if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
                        nativeThen = NativePromisePrototype.then;
                        if (!SUBCLASSING) {
                            // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
                            redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
                                var that = this;
                                return new PromiseConstructor(function(resolve, reject) {
                                    call(nativeThen, that, resolve, reject);
                                }).then(onFulfilled, onRejected);
                            // https://github.com/zloirock/core-js/issues/640
                            }, {
                                unsafe: true
                            });
                            // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
                            redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], {
                                unsafe: true
                            });
                        }
                        // make `.constructor === Promise` work for native promise-based APIs
                        try {
                            delete NativePromisePrototype.constructor;
                        } catch (error) {}
                        // make `instanceof Promise` work for native promise-based APIs
                        if (setPrototypeOf) setPrototypeOf(NativePromisePrototype, PromisePrototype);
                    }
                }
                $({
                    global: true,
                    wrap: true,
                    forced: FORCED
                }, {
                    Promise: PromiseConstructor
                });
                setToStringTag(PromiseConstructor, PROMISE, false, true);
                setSpecies(PROMISE);
                PromiseWrapper = getBuiltIn(PROMISE);
                // statics
                $({
                    target: PROMISE,
                    stat: true,
                    forced: FORCED
                }, {
                    // `Promise.reject` method
                    // https://tc39.es/ecma262/#sec-promise.reject
                    reject: function reject(r) {
                        var capability = newPromiseCapability(this);
                        call(capability.reject, undefined, r);
                        return capability.promise;
                    }
                });
                $({
                    target: PROMISE,
                    stat: true,
                    forced: IS_PURE || FORCED
                }, {
                    // `Promise.resolve` method
                    // https://tc39.es/ecma262/#sec-promise.resolve
                    resolve: function resolve(x) {
                        return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
                    }
                });
                $({
                    target: PROMISE,
                    stat: true,
                    forced: INCORRECT_ITERATION
                }, {
                    // `Promise.all` method
                    // https://tc39.es/ecma262/#sec-promise.all
                    all: function all(iterable) {
                        var C = this;
                        var capability = newPromiseCapability(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var $promiseResolve = aCallable(C.resolve);
                            var values = [];
                            var counter = 0;
                            var remaining = 1;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyCalled = false;
                                remaining++;
                                call($promiseResolve, C, promise).then(function(value) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = value;
                                    --remaining || resolve(values);
                                }, reject);
                            });
                            --remaining || resolve(values);
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    },
                    // `Promise.race` method
                    // https://tc39.es/ecma262/#sec-promise.race
                    race: function race(iterable) {
                        var C = this;
                        var capability = newPromiseCapability(C);
                        var reject = capability.reject;
                        var result = perform(function() {
                            var $promiseResolve = aCallable(C.resolve);
                            iterate(iterable, function(promise) {
                                call($promiseResolve, C, promise).then(capability.resolve, reject);
                            });
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /***/ 68109: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /** @type {import('.')} */ var $gOPD = __webpack_require__(85567);
                if ($gOPD) try {
                    $gOPD([], 'length');
                } catch (e) {
                    // IE 8 has a broken gOPD
                    $gOPD = null;
                }
                module1.exports = $gOPD;
            /***/ },
            /***/ 68130: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ERR_INVALID_OPT_VALUE = __webpack_require__(83797)/* .codes */ .F.ERR_INVALID_OPT_VALUE;
                function highWaterMarkFrom(options, isDuplex, duplexKey) {
                    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
                }
                function getHighWaterMark(state, options, duplexKey, isDuplex) {
                    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
                    if (hwm != null) {
                        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                            var name = isDuplex ? duplexKey : 'highWaterMark';
                            throw new ERR_INVALID_OPT_VALUE(name, hwm);
                        }
                        return Math.floor(hwm);
                    }
                    // Default value
                    return state.objectMode ? 16 : 16384;
                }
                module1.exports = {
                    getHighWaterMark: getHighWaterMark
                };
            /***/ },
            /***/ 68319: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352));
                })(void 0, function(CryptoJS) {
                    (function(Math1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var WordArray = C_lib.WordArray;
                        var Hasher = C_lib.Hasher;
                        var C_algo = C.algo;
                        // Constants table
                        var T = [];
                        // Compute constants
                        (function() {
                            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
                        })();
                        /**
     * MD5 hash algorithm.
     */ var MD5 = C_algo.MD5 = Hasher.extend({
                            _doReset: function _doReset() {
                                this._hash = new WordArray.init([
                                    0x67452301,
                                    0xefcdab89,
                                    0x98badcfe,
                                    0x10325476
                                ]);
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Swap endian
                                for(var i = 0; i < 16; i++){
                                    // Shortcuts
                                    var offset_i = offset + i;
                                    var M_offset_i = M[offset_i];
                                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                                }
                                // Shortcuts
                                var H = this._hash.words;
                                var M_offset_0 = M[offset + 0];
                                var M_offset_1 = M[offset + 1];
                                var M_offset_2 = M[offset + 2];
                                var M_offset_3 = M[offset + 3];
                                var M_offset_4 = M[offset + 4];
                                var M_offset_5 = M[offset + 5];
                                var M_offset_6 = M[offset + 6];
                                var M_offset_7 = M[offset + 7];
                                var M_offset_8 = M[offset + 8];
                                var M_offset_9 = M[offset + 9];
                                var M_offset_10 = M[offset + 10];
                                var M_offset_11 = M[offset + 11];
                                var M_offset_12 = M[offset + 12];
                                var M_offset_13 = M[offset + 13];
                                var M_offset_14 = M[offset + 14];
                                var M_offset_15 = M[offset + 15];
                                // Working variables
                                var a = H[0];
                                var b = H[1];
                                var c = H[2];
                                var d = H[3];
                                // Computation
                                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                                // Intermediate hash value
                                H[0] = H[0] + a | 0;
                                H[1] = H[1] + b | 0;
                                H[2] = H[2] + c | 0;
                                H[3] = H[3] + d | 0;
                            },
                            _doFinalize: function _doFinalize() {
                                // Shortcuts
                                var data = this._data;
                                var dataWords = data.words;
                                var nBitsTotal = this._nDataBytes * 8;
                                var nBitsLeft = data.sigBytes * 8;
                                // Add padding
                                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                                var nBitsTotalL = nBitsTotal;
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                                data.sigBytes = (dataWords.length + 1) * 4;
                                // Hash final blocks
                                this._process();
                                // Shortcuts
                                var hash = this._hash;
                                var H = hash.words;
                                // Swap endian
                                for(var i = 0; i < 4; i++){
                                    // Shortcut
                                    var H_i = H[i];
                                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                                }
                                // Return final computed hash
                                return hash;
                            },
                            clone: function clone() {
                                var clone = Hasher.clone.call(this);
                                clone._hash = this._hash.clone();
                                return clone;
                            }
                        });
                        function FF(a, b, c, d, x, s, t) {
                            var n = a + (b & c | ~b & d) + x + t;
                            return (n << s | n >>> 32 - s) + b;
                        }
                        function GG(a, b, c, d, x, s, t) {
                            var n = a + (b & d | c & ~d) + x + t;
                            return (n << s | n >>> 32 - s) + b;
                        }
                        function HH(a, b, c, d, x, s, t) {
                            var n = a + (b ^ c ^ d) + x + t;
                            return (n << s | n >>> 32 - s) + b;
                        }
                        function II(a, b, c, d, x, s, t) {
                            var n = a + (c ^ (b | ~d)) + x + t;
                            return (n << s | n >>> 32 - s) + b;
                        }
                        /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.MD5('message');
     *     var hash = CryptoJS.MD5(wordArray);
     */ C.MD5 = Hasher._createHelper(MD5);
                        /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacMD5(message, key);
     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
                    })(Math);
                    return CryptoJS.MD5;
                });
            /***/ },
            /***/ 68332: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(65292);
                __webpack_require__(73844);
                __webpack_require__(69330);
                __webpack_require__(11765);
                __webpack_require__(81755);
                __webpack_require__(20731);
                __webpack_require__(24863);
                __webpack_require__(14032);
                __webpack_require__(61726);
                __webpack_require__(57114);
                __webpack_require__(58281);
                __webpack_require__(94712);
                function _createForOfIteratorHelperLoose(r, e) {
                    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                    if (t) return (t = t.call(r)).next.bind(t);
                    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
                        t && (r = t);
                        var o = 0;
                        return function() {
                            return o >= r.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: r[o++]
                            };
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(r, a) {
                    if (r) {
                        if ("string" == typeof r) return _arrayLikeToArray(r, a);
                        var t = ({}).toString.call(r).slice(8, -1);
                        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
                    }
                }
                function _arrayLikeToArray(r, a) {
                    (null == a || a > r.length) && (a = r.length);
                    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
                    return n;
                }
                var _require = __webpack_require__(56128), NumberT = _require.Number;
                var utils = __webpack_require__(18128);
                var ArrayT = /*#__PURE__*/ function() {
                    function ArrayT(type, length, lengthType) {
                        if (lengthType === void 0) lengthType = 'count';
                        this.type = type;
                        this.length = length;
                        this.lengthType = lengthType;
                    }
                    var _proto = ArrayT.prototype;
                    _proto.decode = function decode(stream, parent) {
                        var length;
                        var pos = stream.pos;
                        var res = [];
                        var ctx = parent;
                        if (this.length != null) length = utils.resolveLength(this.length, stream, parent);
                        if (this.length instanceof NumberT) {
                            // define hidden properties
                            Object.defineProperties(res, {
                                parent: {
                                    value: parent
                                },
                                _startOffset: {
                                    value: pos
                                },
                                _currentOffset: {
                                    value: 0,
                                    writable: true
                                },
                                _length: {
                                    value: length
                                }
                            });
                            ctx = res;
                        }
                        if (length == null || this.lengthType === 'bytes') {
                            var target = length != null ? stream.pos + length : (parent != null ? parent._length : undefined) ? parent._startOffset + parent._length : stream.length;
                            while(stream.pos < target)res.push(this.type.decode(stream, ctx));
                        } else for(var i = 0, end = length; i < end; i++)res.push(this.type.decode(stream, ctx));
                        return res;
                    };
                    _proto.size = function size(array, ctx) {
                        if (!array) return this.type.size(null, ctx) * utils.resolveLength(this.length, null, ctx);
                        var size = 0;
                        if (this.length instanceof NumberT) {
                            size += this.length.size();
                            ctx = {
                                parent: ctx
                            };
                        }
                        for(var _iterator = _createForOfIteratorHelperLoose(array), _step; !(_step = _iterator()).done;){
                            var item = _step.value;
                            size += this.type.size(item, ctx);
                        }
                        return size;
                    };
                    _proto.encode = function encode(stream, array, parent) {
                        var ctx = parent;
                        if (this.length instanceof NumberT) {
                            ctx = {
                                pointers: [],
                                startOffset: stream.pos,
                                parent: parent
                            };
                            ctx.pointerOffset = stream.pos + this.size(array, ctx);
                            this.length.encode(stream, array.length);
                        }
                        for(var _iterator2 = _createForOfIteratorHelperLoose(array), _step2; !(_step2 = _iterator2()).done;){
                            var item = _step2.value;
                            this.type.encode(stream, item, ctx);
                        }
                        if (this.length instanceof NumberT) {
                            var i = 0;
                            while(i < ctx.pointers.length){
                                var ptr = ctx.pointers[i++];
                                ptr.type.encode(stream, ptr.val);
                            }
                        }
                    };
                    return ArrayT;
                }();
                module1.exports = ArrayT;
            /***/ },
            /***/ 68404: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isCallable = __webpack_require__(3746);
                var toStr = Object.prototype.toString;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                /** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var forEachArray = function forEachArray(array, iterator, receiver) {
                    for(var i = 0, len = array.length; i < len; i++)if (hasOwnProperty.call(array, i)) {
                        if (receiver == null) iterator(array[i], i, array);
                        else iterator.call(receiver, array[i], i, array);
                    }
                };
                /** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var forEachString = function forEachString(string, iterator, receiver) {
                    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
                    if (receiver == null) iterator(string.charAt(i), i, string);
                    else iterator.call(receiver, string.charAt(i), i, string);
                };
                /** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var forEachObject = function forEachObject(object, iterator, receiver) {
                    for(var k in object)if (hasOwnProperty.call(object, k)) {
                        if (receiver == null) iterator(object[k], k, object);
                        else iterator.call(receiver, object[k], k, object);
                    }
                };
                /** @type {(x: unknown) => x is readonly unknown[]} */ function isArray(x) {
                    return toStr.call(x) === '[object Array]';
                }
                /** @type {import('.')._internal} */ module1.exports = function forEach(list, iterator, thisArg) {
                    if (!isCallable(iterator)) throw new TypeError('iterator must be a function');
                    var receiver;
                    if (arguments.length >= 3) receiver = thisArg;
                    if (isArray(list)) forEachArray(list, iterator, receiver);
                    else if (typeof list === 'string') forEachString(list, iterator, receiver);
                    else forEachObject(list, iterator, receiver);
                };
            /***/ },
            /***/ 68494: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(47044);
                module1.exports = !fails(function() {
                    function F() {}
                    F.prototype.constructor = null;
                    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
                    return Object.getPrototypeOf(new F()) !== F.prototype;
                });
            /***/ },
            /***/ 68626: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var copyWithin = __webpack_require__(92642);
                var addToUnscopables = __webpack_require__(71156);
                // `Array.prototype.copyWithin` method
                // https://tc39.es/ecma262/#sec-array.prototype.copywithin
                $({
                    target: 'Array',
                    proto: true
                }, {
                    copyWithin: copyWithin
                });
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                addToUnscopables('copyWithin');
            /***/ },
            /***/ 68664: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var String1 = global.String;
                module1.exports = function(argument) {
                    try {
                        return String1(argument);
                    } catch (error) {
                        return 'Object';
                    }
                };
            /***/ },
            /***/ 68899: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var PROPER_FUNCTION_NAME = __webpack_require__(7081).PROPER;
                var fails = __webpack_require__(47044);
                var whitespaces = __webpack_require__(43187);
                var non = '\u200B\u0085\u180E';
                // check that a method works with the correct list
                // of whitespaces and has a correct name
                module1.exports = function(METHOD_NAME) {
                    return fails(function() {
                        return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
                    });
                };
            /***/ },
            /***/ 69075: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isConstructor = __webpack_require__(20884);
                var tryToString = __webpack_require__(68664);
                var TypeError1 = global.TypeError;
                // `Assert: IsConstructor(argument) is true`
                module1.exports = function(argument) {
                    if (isConstructor(argument)) return argument;
                    throw TypeError1(tryToString(argument) + ' is not a constructor');
                };
            /***/ },
            /***/ 69330: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var defineWellKnownSymbol = __webpack_require__(46042);
                // `Symbol.iterator` well-known symbol
                // https://tc39.es/ecma262/#sec-symbol.iterator
                defineWellKnownSymbol('iterator');
            /***/ },
            /***/ 69510: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var toIntegerOrInfinity = __webpack_require__(26882);
                var toString = __webpack_require__(25096);
                var requireObjectCoercible = __webpack_require__(83943);
                var charAt = uncurryThis(''.charAt);
                var charCodeAt = uncurryThis(''.charCodeAt);
                var stringSlice = uncurryThis(''.slice);
                var createMethod = function(CONVERT_TO_STRING) {
                    return function($this, pos) {
                        var S = toString(requireObjectCoercible($this));
                        var position = toIntegerOrInfinity(pos);
                        var size = S.length;
                        var first, second;
                        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
                        first = charCodeAt(S, position);
                        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
                    };
                };
                module1.exports = {
                    // `String.prototype.codePointAt` method
                    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
                    codeAt: createMethod(false),
                    // `String.prototype.at` method
                    // https://github.com/mathiasbynens/String.prototype.at
                    charAt: createMethod(true)
                };
            /***/ },
            /***/ 69548: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var hasOwn = __webpack_require__(20340);
                var isCallable = __webpack_require__(94578);
                var toObject = __webpack_require__(43162);
                var sharedKey = __webpack_require__(82194);
                var CORRECT_PROTOTYPE_GETTER = __webpack_require__(68494);
                var IE_PROTO = sharedKey('IE_PROTO');
                var Object1 = global.Object;
                var ObjectPrototype = Object1.prototype;
                // `Object.getPrototypeOf` method
                // https://tc39.es/ecma262/#sec-object.getprototypeof
                module1.exports = CORRECT_PROTOTYPE_GETTER ? Object1.getPrototypeOf : function(O) {
                    var object = toObject(O);
                    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
                    var constructor = object.constructor;
                    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
                    return object instanceof Object1 ? ObjectPrototype : null;
                };
            /***/ },
            /***/ 69591: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                __webpack_require__(20731);
                __webpack_require__(14032);
                __webpack_require__(61726);
                __webpack_require__(57114);
                __webpack_require__(46467);
                var iconv;
                try {
                    iconv = __webpack_require__(54171);
                } catch (error) {}
                var DecodeStream = /*#__PURE__*/ function() {
                    function DecodeStream(buffer) {
                        this.buffer = buffer;
                        this.pos = 0;
                        this.length = this.buffer.length;
                    }
                    var _proto = DecodeStream.prototype;
                    _proto.readString = function readString(length, encoding) {
                        if (encoding === void 0) encoding = 'ascii';
                        switch(encoding){
                            case 'utf16le':
                            case 'ucs2':
                            case 'utf8':
                            case 'ascii':
                                return this.buffer.toString(encoding, this.pos, this.pos += length);
                            case 'utf16be':
                                var buf = Buffer.from(this.readBuffer(length));
                                // swap the bytes
                                for(var i = 0, end = buf.length - 1; i < end; i += 2){
                                    var byte = buf[i];
                                    buf[i] = buf[i + 1];
                                    buf[i + 1] = byte;
                                }
                                return buf.toString('utf16le');
                            default:
                                buf = this.readBuffer(length);
                                if (iconv) try {
                                    return iconv.decode(buf, encoding);
                                } catch (error1) {}
                                return buf;
                        }
                    };
                    _proto.readBuffer = function readBuffer(length) {
                        return this.buffer.slice(this.pos, this.pos += length);
                    };
                    _proto.readUInt24BE = function readUInt24BE() {
                        return (this.readUInt16BE() << 8) + this.readUInt8();
                    };
                    _proto.readUInt24LE = function readUInt24LE() {
                        return this.readUInt16LE() + (this.readUInt8() << 16);
                    };
                    _proto.readInt24BE = function readInt24BE() {
                        return (this.readInt16BE() << 8) + this.readUInt8();
                    };
                    _proto.readInt24LE = function readInt24LE() {
                        return this.readUInt16LE() + (this.readInt8() << 16);
                    };
                    return DecodeStream;
                }();
                DecodeStream.TYPES = {
                    UInt8: 1,
                    UInt16: 2,
                    UInt24: 3,
                    UInt32: 4,
                    Int8: 1,
                    Int16: 2,
                    Int24: 3,
                    Int32: 4,
                    Float: 4,
                    Double: 8
                };
                var _loop = function _loop(key) {
                    if (key.slice(0, 4) === 'read') {
                        var bytes = DecodeStream.TYPES[key.replace(/read|[BL]E/g, '')];
                        DecodeStream.prototype[key] = function() {
                            var ret = this.buffer[key](this.pos);
                            this.pos += bytes;
                            return ret;
                        };
                    }
                };
                for(var key in Buffer.prototype)_loop(key);
                module1.exports = DecodeStream;
            /***/ },
            /***/ 70091: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var userAgent = __webpack_require__(40715);
                var process = global.process;
                var Deno = global.Deno;
                var versions = process && process.versions || Deno && Deno.version;
                var v8 = versions && versions.v8;
                var match, version;
                if (v8) {
                    match = v8.split('.');
                    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
                    // but their correct versions are not interesting for us
                    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
                }
                // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
                // so check `userAgent` even if `.v8` exists, but 0
                if (!version && userAgent) {
                    match = userAgent.match(/Edge\/(\d+)/);
                    if (!match || match[1] >= 74) {
                        match = userAgent.match(/Chrome\/(\d+)/);
                        if (match) version = +match[1];
                    }
                }
                module1.exports = version;
            /***/ },
            /***/ 70095: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var numberIsFinite = __webpack_require__(59805);
                // `Number.isFinite` method
                // https://tc39.es/ecma262/#sec-number.isfinite
                $({
                    target: 'Number',
                    stat: true
                }, {
                    isFinite: numberIsFinite
                });
            /***/ },
            /***/ 70098: /***/ function(module1) {
                "use strict";
                module1.exports = {
                    '4A0': [
                        4767.87,
                        6740.79
                    ],
                    '2A0': [
                        3370.39,
                        4767.87
                    ],
                    A0: [
                        2383.94,
                        3370.39
                    ],
                    A1: [
                        1683.78,
                        2383.94
                    ],
                    A2: [
                        1190.55,
                        1683.78
                    ],
                    A3: [
                        841.89,
                        1190.55
                    ],
                    A4: [
                        595.28,
                        841.89
                    ],
                    A5: [
                        419.53,
                        595.28
                    ],
                    A6: [
                        297.64,
                        419.53
                    ],
                    A7: [
                        209.76,
                        297.64
                    ],
                    A8: [
                        147.40,
                        209.76
                    ],
                    A9: [
                        104.88,
                        147.40
                    ],
                    A10: [
                        73.70,
                        104.88
                    ],
                    B0: [
                        2834.65,
                        4008.19
                    ],
                    B1: [
                        2004.09,
                        2834.65
                    ],
                    B2: [
                        1417.32,
                        2004.09
                    ],
                    B3: [
                        1000.63,
                        1417.32
                    ],
                    B4: [
                        708.66,
                        1000.63
                    ],
                    B5: [
                        498.90,
                        708.66
                    ],
                    B6: [
                        354.33,
                        498.90
                    ],
                    B7: [
                        249.45,
                        354.33
                    ],
                    B8: [
                        175.75,
                        249.45
                    ],
                    B9: [
                        124.72,
                        175.75
                    ],
                    B10: [
                        87.87,
                        124.72
                    ],
                    C0: [
                        2599.37,
                        3676.54
                    ],
                    C1: [
                        1836.85,
                        2599.37
                    ],
                    C2: [
                        1298.27,
                        1836.85
                    ],
                    C3: [
                        918.43,
                        1298.27
                    ],
                    C4: [
                        649.13,
                        918.43
                    ],
                    C5: [
                        459.21,
                        649.13
                    ],
                    C6: [
                        323.15,
                        459.21
                    ],
                    C7: [
                        229.61,
                        323.15
                    ],
                    C8: [
                        161.57,
                        229.61
                    ],
                    C9: [
                        113.39,
                        161.57
                    ],
                    C10: [
                        79.37,
                        113.39
                    ],
                    RA0: [
                        2437.80,
                        3458.27
                    ],
                    RA1: [
                        1729.13,
                        2437.80
                    ],
                    RA2: [
                        1218.90,
                        1729.13
                    ],
                    RA3: [
                        864.57,
                        1218.90
                    ],
                    RA4: [
                        609.45,
                        864.57
                    ],
                    SRA0: [
                        2551.18,
                        3628.35
                    ],
                    SRA1: [
                        1814.17,
                        2551.18
                    ],
                    SRA2: [
                        1275.59,
                        1814.17
                    ],
                    SRA3: [
                        907.09,
                        1275.59
                    ],
                    SRA4: [
                        637.80,
                        907.09
                    ],
                    EXECUTIVE: [
                        521.86,
                        756.00
                    ],
                    FOLIO: [
                        612.00,
                        936.00
                    ],
                    LEGAL: [
                        612.00,
                        1008.00
                    ],
                    LETTER: [
                        612.00,
                        792.00
                    ],
                    TABLOID: [
                        792.00,
                        1224.00
                    ]
                };
            /***/ },
            /***/ 70172: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var NATIVE_WEAK_MAP = __webpack_require__(26168);
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var isObject = __webpack_require__(24517);
                var createNonEnumerableProperty = __webpack_require__(48914);
                var hasOwn = __webpack_require__(20340);
                var shared = __webpack_require__(55480);
                var sharedKey = __webpack_require__(82194);
                var hiddenKeys = __webpack_require__(90682);
                var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
                var TypeError1 = global.TypeError;
                var WeakMap1 = global.WeakMap;
                var set, get, has;
                var enforce = function(it) {
                    return has(it) ? get(it) : set(it, {});
                };
                var getterFor = function(TYPE) {
                    return function(it) {
                        var state;
                        if (!isObject(it) || (state = get(it)).type !== TYPE) throw TypeError1('Incompatible receiver, ' + TYPE + ' required');
                        return state;
                    };
                };
                if (NATIVE_WEAK_MAP || shared.state) {
                    var store = shared.state || (shared.state = new WeakMap1());
                    var wmget = uncurryThis(store.get);
                    var wmhas = uncurryThis(store.has);
                    var wmset = uncurryThis(store.set);
                    set = function(it, metadata) {
                        if (wmhas(store, it)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                        metadata.facade = it;
                        wmset(store, it, metadata);
                        return metadata;
                    };
                    get = function(it) {
                        return wmget(store, it) || {};
                    };
                    has = function(it) {
                        return wmhas(store, it);
                    };
                } else {
                    var STATE = sharedKey('state');
                    hiddenKeys[STATE] = true;
                    set = function(it, metadata) {
                        if (hasOwn(it, STATE)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                        metadata.facade = it;
                        createNonEnumerableProperty(it, STATE, metadata);
                        return metadata;
                    };
                    get = function(it) {
                        return hasOwn(it, STATE) ? it[STATE] : {};
                    };
                    has = function(it) {
                        return hasOwn(it, STATE);
                    };
                }
                module1.exports = {
                    set: set,
                    get: get,
                    has: has,
                    enforce: enforce,
                    getterFor: getterFor
                };
            /***/ },
            /***/ 70176: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                module1.exports = uncurryThis({}.isPrototypeOf);
            /***/ },
            /***/ 70573: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var userAgent = __webpack_require__(40715);
                var global = __webpack_require__(32010);
                module1.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;
            /***/ },
            /***/ 70770: /***/ function(module1) {
                "use strict";
                /**
 * Creates an instance of Line
 *
 * @constructor
 * @this {Line}
 * @param {Number} Maximum width this line can have
 */ function Line(maxWidth) {
                    this.maxWidth = maxWidth;
                    this.leadingCut = 0;
                    this.trailingCut = 0;
                    this.inlineWidths = 0;
                    this.inlines = [];
                }
                Line.prototype.getAscenderHeight = function() {
                    var y = 0;
                    this.inlines.forEach(function(inline) {
                        y = Math.max(y, inline.font.ascender / 1000 * inline.fontSize);
                    });
                    return y;
                };
                Line.prototype.hasEnoughSpaceForInline = function(inline, nextInlines) {
                    nextInlines = nextInlines || [];
                    if (this.inlines.length === 0) return true;
                    if (this.newLineForced) return false;
                    var inlineWidth = inline.width;
                    var inlineTrailingCut = inline.trailingCut || 0;
                    if (inline.noNewLine) for(var i = 0, l = nextInlines.length; i < l; i++){
                        var nextInline = nextInlines[i];
                        inlineWidth += nextInline.width;
                        inlineTrailingCut += nextInline.trailingCut || 0;
                        if (!nextInline.noNewLine) break;
                    }
                    return this.inlineWidths + inlineWidth - this.leadingCut - inlineTrailingCut <= this.maxWidth;
                };
                Line.prototype.addInline = function(inline) {
                    if (this.inlines.length === 0) this.leadingCut = inline.leadingCut || 0;
                    this.trailingCut = inline.trailingCut || 0;
                    inline.x = this.inlineWidths - this.leadingCut;
                    this.inlines.push(inline);
                    this.inlineWidths += inline.width;
                    if (inline.lineEnd) this.newLineForced = true;
                };
                Line.prototype.getWidth = function() {
                    return this.inlineWidths - this.leadingCut - this.trailingCut;
                };
                Line.prototype.getAvailableWidth = function() {
                    return this.maxWidth - this.getWidth();
                };
                /**
 * Returns line height
 * @return {Number}
 */ Line.prototype.getHeight = function() {
                    var max = 0;
                    this.inlines.forEach(function(item) {
                        max = Math.max(max, item.height || 0);
                    });
                    return max;
                };
                module1.exports = Line;
            /***/ },
            /***/ 71156: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(38688);
                var create = __webpack_require__(10819);
                var definePropertyModule = __webpack_require__(95892);
                var UNSCOPABLES = wellKnownSymbol('unscopables');
                var ArrayPrototype = Array.prototype;
                // Array.prototype[@@unscopables]
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                if (ArrayPrototype[UNSCOPABLES] == undefined) definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
                    configurable: true,
                    value: create(null)
                });
                // add a key to Array.prototype[@@unscopables]
                module1.exports = function(key) {
                    ArrayPrototype[UNSCOPABLES][key] = true;
                };
            /***/ },
            /***/ 71230: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var callBound = __webpack_require__(22774);
                var getDay = callBound('Date.prototype.getDay');
                /** @type {import('.')} */ var tryDateObject = function tryDateGetDayCall(value) {
                    try {
                        getDay(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                };
                /** @type {(value: unknown) => string} */ var toStr = callBound('Object.prototype.toString');
                var dateClass = '[object Date]';
                var hasToStringTag = __webpack_require__(26626)();
                /** @type {import('.')} */ module1.exports = function isDateObject(value) {
                    if (typeof value !== 'object' || value === null) return false;
                    return hasToStringTag ? tryDateObject(value) : toStr(value) === dateClass;
                };
            /***/ },
            /***/ 71265: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var toIntegerOrInfinity = __webpack_require__(26882);
                var toLength = __webpack_require__(23417);
                var RangeError1 = global.RangeError;
                // `ToIndex` abstract operation
                // https://tc39.es/ecma262/#sec-toindex
                module1.exports = function(it) {
                    if (it === undefined) return 0;
                    var number = toIntegerOrInfinity(it);
                    var length = toLength(number);
                    if (number !== length) throw RangeError1('Wrong length or index');
                    return length;
                };
            /***/ },
            /***/ 71689: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var callBound = __webpack_require__(22774);
                var hasToStringTag = __webpack_require__(26626)();
                var hasOwn = __webpack_require__(55215);
                var gOPD = __webpack_require__(68109);
                /** @type {import('.')} */ var fn;
                if (hasToStringTag) {
                    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $exec = callBound('RegExp.prototype.exec');
                    /** @type {object} */ var isRegexMarker = {};
                    var throwRegexMarker = function() {
                        throw isRegexMarker;
                    };
                    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var badStringifier = {
                        toString: throwRegexMarker,
                        valueOf: throwRegexMarker
                    };
                    if (typeof Symbol.toPrimitive === 'symbol') badStringifier[Symbol.toPrimitive] = throwRegexMarker;
                    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
                    // eslint-disable-next-line consistent-return
                    fn = function isRegex(value) {
                        if (!value || typeof value !== 'object') return false;
                        // eslint-disable-next-line no-extra-parens
                        var descriptor = /** @type {NonNullable<typeof gOPD>} */ gOPD(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
                        var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
                        if (!hasLastIndexDataProperty) return false;
                        try {
                            // eslint-disable-next-line no-extra-parens
                            $exec(value, /** @type {unknown} */ badStringifier);
                        } catch (e) {
                            return e === isRegexMarker;
                        }
                    };
                } else {
                    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $toString = callBound('Object.prototype.toString');
                    /** @const @type {'[object RegExp]'} */ var regexClass = '[object RegExp]';
                    /** @type {import('.')} */ fn = function isRegex(value) {
                        // In older browsers, typeof regex incorrectly returns 'function'
                        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
                        return $toString(value) === regexClass;
                    };
                }
                module1.exports = fn;
            /***/ },
            /***/ 71768: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable es/no-string-prototype-matchall -- safe */ var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var call = __webpack_require__(2834);
                var uncurryThis = __webpack_require__(38347);
                var createIteratorConstructor = __webpack_require__(13945);
                var requireObjectCoercible = __webpack_require__(83943);
                var toLength = __webpack_require__(23417);
                var toString = __webpack_require__(25096);
                var anObject = __webpack_require__(34984);
                var classof = __webpack_require__(93975);
                var isPrototypeOf = __webpack_require__(70176);
                var isRegExp = __webpack_require__(28831);
                var regExpFlags = __webpack_require__(21182);
                var getMethod = __webpack_require__(51839);
                var redefine = __webpack_require__(13711);
                var fails = __webpack_require__(47044);
                var wellKnownSymbol = __webpack_require__(38688);
                var speciesConstructor = __webpack_require__(27754);
                var advanceStringIndex = __webpack_require__(36352);
                var regExpExec = __webpack_require__(66723);
                var InternalStateModule = __webpack_require__(70172);
                var IS_PURE = __webpack_require__(63432);
                var MATCH_ALL = wellKnownSymbol('matchAll');
                var REGEXP_STRING = 'RegExp String';
                var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
                var RegExpPrototype = RegExp.prototype;
                var TypeError1 = global.TypeError;
                var getFlags = uncurryThis(regExpFlags);
                var stringIndexOf = uncurryThis(''.indexOf);
                var un$MatchAll = uncurryThis(''.matchAll);
                var WORKS_WITH_NON_GLOBAL_REGEX = !!un$MatchAll && !fails(function() {
                    un$MatchAll('a', /./);
                });
                var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
                    setInternalState(this, {
                        type: REGEXP_STRING_ITERATOR,
                        regexp: regexp,
                        string: string,
                        global: $global,
                        unicode: fullUnicode,
                        done: false
                    });
                }, REGEXP_STRING, function next() {
                    var state = getInternalState(this);
                    if (state.done) return {
                        value: undefined,
                        done: true
                    };
                    var R = state.regexp;
                    var S = state.string;
                    var match = regExpExec(R, S);
                    if (match === null) return {
                        value: undefined,
                        done: state.done = true
                    };
                    if (state.global) {
                        if (toString(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
                        return {
                            value: match,
                            done: false
                        };
                    }
                    state.done = true;
                    return {
                        value: match,
                        done: false
                    };
                });
                var $matchAll = function(string) {
                    var R = anObject(this);
                    var S = toString(string);
                    var C, flagsValue, flags, matcher, $global, fullUnicode;
                    C = speciesConstructor(R, RegExp);
                    flagsValue = R.flags;
                    if (flagsValue === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype)) flagsValue = getFlags(R);
                    flags = flagsValue === undefined ? '' : toString(flagsValue);
                    matcher = new C(C === RegExp ? R.source : R, flags);
                    $global = !!~stringIndexOf(flags, 'g');
                    fullUnicode = !!~stringIndexOf(flags, 'u');
                    matcher.lastIndex = toLength(R.lastIndex);
                    return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
                };
                // `String.prototype.matchAll` method
                // https://tc39.es/ecma262/#sec-string.prototype.matchall
                $({
                    target: 'String',
                    proto: true,
                    forced: WORKS_WITH_NON_GLOBAL_REGEX
                }, {
                    matchAll: function matchAll(regexp) {
                        var O = requireObjectCoercible(this);
                        var flags, S, matcher, rx;
                        if (regexp != null) {
                            if (isRegExp(regexp)) {
                                flags = toString(requireObjectCoercible('flags' in RegExpPrototype ? regexp.flags : getFlags(regexp)));
                                if (!~stringIndexOf(flags, 'g')) throw TypeError1('`.matchAll` does not allow non-global regexes');
                            }
                            if (WORKS_WITH_NON_GLOBAL_REGEX) return un$MatchAll(O, regexp);
                            matcher = getMethod(regexp, MATCH_ALL);
                            if (matcher === undefined && IS_PURE && classof(regexp) == 'RegExp') matcher = $matchAll;
                            if (matcher) return call(matcher, regexp, O);
                        } else if (WORKS_WITH_NON_GLOBAL_REGEX) return un$MatchAll(O, regexp);
                        S = toString(O);
                        rx = new RegExp(regexp, 'g');
                        return IS_PURE ? call($matchAll, rx, S) : rx[MATCH_ALL](S);
                    }
                });
                IS_PURE || MATCH_ALL in RegExpPrototype || redefine(RegExpPrototype, MATCH_ALL, $matchAll);
            /***/ },
            /***/ 71950: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var fails = __webpack_require__(47044);
                var toObject = __webpack_require__(43162);
                var nativeGetPrototypeOf = __webpack_require__(69548);
                var CORRECT_PROTOTYPE_GETTER = __webpack_require__(68494);
                var FAILS_ON_PRIMITIVES = fails(function() {
                    nativeGetPrototypeOf(1);
                });
                // `Object.getPrototypeOf` method
                // https://tc39.es/ecma262/#sec-object.getprototypeof
                $({
                    target: 'Object',
                    stat: true,
                    forced: FAILS_ON_PRIMITIVES,
                    sham: !CORRECT_PROTOTYPE_GETTER
                }, {
                    getPrototypeOf: function getPrototypeOf(it) {
                        return nativeGetPrototypeOf(toObject(it));
                    }
                });
            /***/ },
            /***/ 72022: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // eslint-disable-next-line func-names
                module1.exports = function() {
                    if (typeof globalThis === "object") return globalThis;
                    var g;
                    try {
                        // This works if eval is allowed (see CSP)
                        // eslint-disable-next-line no-new-func
                        g = this || new Function("return this")();
                    } catch (e) {
                        // This works if the window reference is available
                        if (typeof window === "object") return window;
                        // This works if the self reference is available
                        if (typeof self === "object") return self;
                        // This works if the global reference is available
                        if (typeof __webpack_require__.g !== "undefined") return __webpack_require__.g;
                    }
                    return g;
                }();
            /***/ },
            /***/ 72062: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(15567);
                var call = __webpack_require__(2834);
                var propertyIsEnumerableModule = __webpack_require__(55574);
                var createPropertyDescriptor = __webpack_require__(97841);
                var toIndexedObject = __webpack_require__(98086);
                var toPropertyKey = __webpack_require__(63918);
                var hasOwn = __webpack_require__(20340);
                var IE8_DOM_DEFINE = __webpack_require__(18904);
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                // `Object.getOwnPropertyDescriptor` method
                // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
                exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
                    O = toIndexedObject(O);
                    P = toPropertyKey(P);
                    if (IE8_DOM_DEFINE) try {
                        return $getOwnPropertyDescriptor(O, P);
                    } catch (error) {}
                    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
                };
            /***/ },
            /***/ 72095: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var $trim = __webpack_require__(29841).trim;
                var forcedStringTrimMethod = __webpack_require__(68899);
                // `String.prototype.trim` method
                // https://tc39.es/ecma262/#sec-string.prototype.trim
                $({
                    target: 'String',
                    proto: true,
                    forced: forcedStringTrimMethod('trim')
                }, {
                    trim: function trim() {
                        return $trim(this);
                    }
                });
            /***/ },
            /***/ 72155: /***/ function(module1) {
                "use strict";
                /*eslint no-unused-vars: ["error", {"args": "none"}]*/ /*eslint no-redeclare: "off"*/ /* qr.js -- QR code generator in Javascript (revision 2011-01-19)
 * Written by Kang Seonghoon <public+qrjs@mearie.org>.
 *
 * This source code is in the public domain; if your jurisdiction does not
 * recognize the public domain the terms of Creative Commons CC0 license
 * apply. In the other words, you can always do what you want.
 */ // per-version information (cf. JIS X 0510:2004 pp. 30--36, 71)
                //
                // [0]: the degree of generator polynomial by ECC levels
                // [1]: # of code blocks by ECC levels
                // [2]: left-top positions of alignment patterns
                //
                // the number in this table (in particular, [0]) does not exactly match with
                // the numbers in the specficiation. see augumenteccs below for the reason.
                var VERSIONS = [
                    null,
                    [
                        [
                            10,
                            7,
                            17,
                            13
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        []
                    ],
                    [
                        [
                            16,
                            10,
                            28,
                            22
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            4,
                            16
                        ]
                    ],
                    [
                        [
                            26,
                            15,
                            22,
                            18
                        ],
                        [
                            1,
                            1,
                            2,
                            2
                        ],
                        [
                            4,
                            20
                        ]
                    ],
                    [
                        [
                            18,
                            20,
                            16,
                            26
                        ],
                        [
                            2,
                            1,
                            4,
                            2
                        ],
                        [
                            4,
                            24
                        ]
                    ],
                    [
                        [
                            24,
                            26,
                            22,
                            18
                        ],
                        [
                            2,
                            1,
                            4,
                            4
                        ],
                        [
                            4,
                            28
                        ]
                    ],
                    [
                        [
                            16,
                            18,
                            28,
                            24
                        ],
                        [
                            4,
                            2,
                            4,
                            4
                        ],
                        [
                            4,
                            32
                        ]
                    ],
                    [
                        [
                            18,
                            20,
                            26,
                            18
                        ],
                        [
                            4,
                            2,
                            5,
                            6
                        ],
                        [
                            4,
                            20,
                            36
                        ]
                    ],
                    [
                        [
                            22,
                            24,
                            26,
                            22
                        ],
                        [
                            4,
                            2,
                            6,
                            6
                        ],
                        [
                            4,
                            22,
                            40
                        ]
                    ],
                    [
                        [
                            22,
                            30,
                            24,
                            20
                        ],
                        [
                            5,
                            2,
                            8,
                            8
                        ],
                        [
                            4,
                            24,
                            44
                        ]
                    ],
                    [
                        [
                            26,
                            18,
                            28,
                            24
                        ],
                        [
                            5,
                            4,
                            8,
                            8
                        ],
                        [
                            4,
                            26,
                            48
                        ]
                    ],
                    [
                        [
                            30,
                            20,
                            24,
                            28
                        ],
                        [
                            5,
                            4,
                            11,
                            8
                        ],
                        [
                            4,
                            28,
                            52
                        ]
                    ],
                    [
                        [
                            22,
                            24,
                            28,
                            26
                        ],
                        [
                            8,
                            4,
                            11,
                            10
                        ],
                        [
                            4,
                            30,
                            56
                        ]
                    ],
                    [
                        [
                            22,
                            26,
                            22,
                            24
                        ],
                        [
                            9,
                            4,
                            16,
                            12
                        ],
                        [
                            4,
                            32,
                            60
                        ]
                    ],
                    [
                        [
                            24,
                            30,
                            24,
                            20
                        ],
                        [
                            9,
                            4,
                            16,
                            16
                        ],
                        [
                            4,
                            24,
                            44,
                            64
                        ]
                    ],
                    [
                        [
                            24,
                            22,
                            24,
                            30
                        ],
                        [
                            10,
                            6,
                            18,
                            12
                        ],
                        [
                            4,
                            24,
                            46,
                            68
                        ]
                    ],
                    [
                        [
                            28,
                            24,
                            30,
                            24
                        ],
                        [
                            10,
                            6,
                            16,
                            17
                        ],
                        [
                            4,
                            24,
                            48,
                            72
                        ]
                    ],
                    [
                        [
                            28,
                            28,
                            28,
                            28
                        ],
                        [
                            11,
                            6,
                            19,
                            16
                        ],
                        [
                            4,
                            28,
                            52,
                            76
                        ]
                    ],
                    [
                        [
                            26,
                            30,
                            28,
                            28
                        ],
                        [
                            13,
                            6,
                            21,
                            18
                        ],
                        [
                            4,
                            28,
                            54,
                            80
                        ]
                    ],
                    [
                        [
                            26,
                            28,
                            26,
                            26
                        ],
                        [
                            14,
                            7,
                            25,
                            21
                        ],
                        [
                            4,
                            28,
                            56,
                            84
                        ]
                    ],
                    [
                        [
                            26,
                            28,
                            28,
                            30
                        ],
                        [
                            16,
                            8,
                            25,
                            20
                        ],
                        [
                            4,
                            32,
                            60,
                            88
                        ]
                    ],
                    [
                        [
                            26,
                            28,
                            30,
                            28
                        ],
                        [
                            17,
                            8,
                            25,
                            23
                        ],
                        [
                            4,
                            26,
                            48,
                            70,
                            92
                        ]
                    ],
                    [
                        [
                            28,
                            28,
                            24,
                            30
                        ],
                        [
                            17,
                            9,
                            34,
                            23
                        ],
                        [
                            4,
                            24,
                            48,
                            72,
                            96
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            18,
                            9,
                            30,
                            25
                        ],
                        [
                            4,
                            28,
                            52,
                            76,
                            100
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            20,
                            10,
                            32,
                            27
                        ],
                        [
                            4,
                            26,
                            52,
                            78,
                            104
                        ]
                    ],
                    [
                        [
                            28,
                            26,
                            30,
                            30
                        ],
                        [
                            21,
                            12,
                            35,
                            29
                        ],
                        [
                            4,
                            30,
                            56,
                            82,
                            108
                        ]
                    ],
                    [
                        [
                            28,
                            28,
                            30,
                            28
                        ],
                        [
                            23,
                            12,
                            37,
                            34
                        ],
                        [
                            4,
                            28,
                            56,
                            84,
                            112
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            25,
                            12,
                            40,
                            34
                        ],
                        [
                            4,
                            32,
                            60,
                            88,
                            116
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            26,
                            13,
                            42,
                            35
                        ],
                        [
                            4,
                            24,
                            48,
                            72,
                            96,
                            120
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            28,
                            14,
                            45,
                            38
                        ],
                        [
                            4,
                            28,
                            52,
                            76,
                            100,
                            124
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            29,
                            15,
                            48,
                            40
                        ],
                        [
                            4,
                            24,
                            50,
                            76,
                            102,
                            128
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            31,
                            16,
                            51,
                            43
                        ],
                        [
                            4,
                            28,
                            54,
                            80,
                            106,
                            132
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            33,
                            17,
                            54,
                            45
                        ],
                        [
                            4,
                            32,
                            58,
                            84,
                            110,
                            136
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            35,
                            18,
                            57,
                            48
                        ],
                        [
                            4,
                            28,
                            56,
                            84,
                            112,
                            140
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            37,
                            19,
                            60,
                            51
                        ],
                        [
                            4,
                            32,
                            60,
                            88,
                            116,
                            144
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            38,
                            19,
                            63,
                            53
                        ],
                        [
                            4,
                            28,
                            52,
                            76,
                            100,
                            124,
                            148
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            40,
                            20,
                            66,
                            56
                        ],
                        [
                            4,
                            22,
                            48,
                            74,
                            100,
                            126,
                            152
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            43,
                            21,
                            70,
                            59
                        ],
                        [
                            4,
                            26,
                            52,
                            78,
                            104,
                            130,
                            156
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            45,
                            22,
                            74,
                            62
                        ],
                        [
                            4,
                            30,
                            56,
                            82,
                            108,
                            134,
                            160
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            47,
                            24,
                            77,
                            65
                        ],
                        [
                            4,
                            24,
                            52,
                            80,
                            108,
                            136,
                            164
                        ]
                    ],
                    [
                        [
                            28,
                            30,
                            30,
                            30
                        ],
                        [
                            49,
                            25,
                            81,
                            68
                        ],
                        [
                            4,
                            28,
                            56,
                            84,
                            112,
                            140,
                            168
                        ]
                    ]
                ];
                // mode constants (cf. Table 2 in JIS X 0510:2004 p. 16)
                var MODE_TERMINATOR = 0;
                var MODE_NUMERIC = 1, MODE_ALPHANUMERIC = 2, MODE_OCTET = 4, MODE_KANJI = 8;
                // validation regexps
                var NUMERIC_REGEXP = /^\d*$/;
                var ALPHANUMERIC_REGEXP = /^[A-Za-z0-9 $%*+\-./:]*$/;
                var ALPHANUMERIC_OUT_REGEXP = /^[A-Z0-9 $%*+\-./:]*$/;
                // ECC levels (cf. Table 22 in JIS X 0510:2004 p. 45)
                var ECCLEVEL_L = 1, ECCLEVEL_M = 0, ECCLEVEL_Q = 3, ECCLEVEL_H = 2;
                // GF(2^8)-to-integer mapping with a reducing polynomial x^8+x^4+x^3+x^2+1
                // invariant: GF256_MAP[GF256_INVMAP[i]] == i for all i in [1,256)
                var GF256_MAP = [], GF256_INVMAP = [
                    -1
                ];
                for(var i = 0, v = 1; i < 255; ++i){
                    GF256_MAP.push(v);
                    GF256_INVMAP[v] = i;
                    v = v * 2 ^ (v >= 128 ? 0x11d : 0);
                }
                // generator polynomials up to degree 30
                // (should match with polynomials in JIS X 0510:2004 Appendix A)
                //
                // generator polynomial of degree K is product of (x-\alpha^0), (x-\alpha^1),
                // ..., (x-\alpha^(K-1)). by convention, we omit the K-th coefficient (always 1)
                // from the result; also other coefficients are written in terms of the exponent
                // to \alpha to avoid the redundant calculation. (see also calculateecc below.)
                var GF256_GENPOLY = [
                    []
                ];
                for(var i = 0; i < 30; ++i){
                    var prevpoly = GF256_GENPOLY[i], poly = [];
                    for(var j = 0; j <= i; ++j){
                        var a = j < i ? GF256_MAP[prevpoly[j]] : 0;
                        var b = GF256_MAP[(i + (prevpoly[j - 1] || 0)) % 255];
                        poly.push(GF256_INVMAP[a ^ b]);
                    }
                    GF256_GENPOLY.push(poly);
                }
                // alphanumeric character mapping (cf. Table 5 in JIS X 0510:2004 p. 19)
                var ALPHANUMERIC_MAP = {};
                for(var i = 0; i < 45; ++i)ALPHANUMERIC_MAP['0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:'.charAt(i)] = i;
                // mask functions in terms of row # and column #
                // (cf. Table 20 in JIS X 0510:2004 p. 42)
                /*jshint unused: false */ var MASKFUNCS = [
                    function(i, j) {
                        return (i + j) % 2 === 0;
                    },
                    function(i, j) {
                        return i % 2 === 0;
                    },
                    function(i, j) {
                        return j % 3 === 0;
                    },
                    function(i, j) {
                        return (i + j) % 3 === 0;
                    },
                    function(i, j) {
                        return ((i / 2 | 0) + (j / 3 | 0)) % 2 === 0;
                    },
                    function(i, j) {
                        return i * j % 2 + i * j % 3 === 0;
                    },
                    function(i, j) {
                        return (i * j % 2 + i * j % 3) % 2 === 0;
                    },
                    function(i, j) {
                        return ((i + j) % 2 + i * j % 3) % 2 === 0;
                    }
                ];
                // returns true when the version information has to be embeded.
                var needsverinfo = function(ver) {
                    return ver > 6;
                };
                // returns the size of entire QR code for given version.
                var getsizebyver = function(ver) {
                    return 4 * ver + 17;
                };
                // returns the number of bits available for code words in this version.
                var nfullbits = function(ver) {
                    /*
	 * |<--------------- n --------------->|
	 * |        |<----- n-17 ---->|        |
	 * +-------+                ///+-------+ ----
	 * |       |                ///|       |    ^
	 * |  9x9  |       @@@@@    ///|  9x8  |    |
	 * |       | # # # @5x5@ # # # |       |    |
	 * +-------+       @@@@@       +-------+    |
	 *       #                               ---|
	 *                                        ^ |
	 *       #                                |
	 *     @@@@@       @@@@@       @@@@@      | n
	 *     @5x5@       @5x5@       @5x5@   n-17
	 *     @@@@@       @@@@@       @@@@@      | |
	 *       #                                | |
	 * //////                                 v |
	 * //////#                               ---|
	 * +-------+       @@@@@       @@@@@        |
	 * |       |       @5x5@       @5x5@        |
	 * |  8x9  |       @@@@@       @@@@@        |
	 * |       |                                v
	 * +-------+                             ----
	 *
	 * when the entire code has n^2 modules and there are m^2-3 alignment
	 * patterns, we have:
	 * - 225 (= 9x9 + 9x8 + 8x9) modules for finder patterns and
	 *   format information;
	 * - 2n-34 (= 2(n-17)) modules for timing patterns;
	 * - 36 (= 3x6 + 6x3) modules for version information, if any;
	 * - 25m^2-75 (= (m^2-3)(5x5)) modules for alignment patterns
	 *   if any, but 10m-20 (= 2(m-2)x5) of them overlaps with
	 *   timing patterns.
	 */ var v = VERSIONS[ver];
                    var nbits = 16 * ver * ver + 128 * ver + 64; // finder, timing and format info.
                    if (needsverinfo(ver)) nbits -= 36; // version information
                    if (v[2].length) nbits -= 25 * v[2].length * v[2].length - 10 * v[2].length - 55;
                    return nbits;
                };
                // returns the number of bits available for data portions (i.e. excludes ECC
                // bits but includes mode and length bits) in this version and ECC level.
                var ndatabits = function(ver, ecclevel) {
                    var nbits = nfullbits(ver) & -8; // no sub-octet code words
                    var v = VERSIONS[ver];
                    nbits -= 8 * v[0][ecclevel] * v[1][ecclevel]; // ecc bits
                    return nbits;
                };
                // returns the number of bits required for the length of data.
                // (cf. Table 3 in JIS X 0510:2004 p. 16)
                var ndatalenbits = function(ver, mode) {
                    switch(mode){
                        case MODE_NUMERIC:
                            return ver < 10 ? 10 : ver < 27 ? 12 : 14;
                        case MODE_ALPHANUMERIC:
                            return ver < 10 ? 9 : ver < 27 ? 11 : 13;
                        case MODE_OCTET:
                            return ver < 10 ? 8 : 16;
                        case MODE_KANJI:
                            return ver < 10 ? 8 : ver < 27 ? 10 : 12;
                    }
                };
                // returns the maximum length of data possible in given configuration.
                var getmaxdatalen = function(ver, mode, ecclevel) {
                    var nbits = ndatabits(ver, ecclevel) - 4 - ndatalenbits(ver, mode); // 4 for mode bits
                    switch(mode){
                        case MODE_NUMERIC:
                            return (nbits / 10 | 0) * 3 + (nbits % 10 < 4 ? 0 : nbits % 10 < 7 ? 1 : 2);
                        case MODE_ALPHANUMERIC:
                            return (nbits / 11 | 0) * 2 + (nbits % 11 < 6 ? 0 : 1);
                        case MODE_OCTET:
                            return nbits / 8 | 0;
                        case MODE_KANJI:
                            return nbits / 13 | 0;
                    }
                };
                // checks if the given data can be encoded in given mode, and returns
                // the converted data for the further processing if possible. otherwise
                // returns null.
                //
                // this function does not check the length of data; it is a duty of
                // encode function below (as it depends on the version and ECC level too).
                var validatedata = function(mode, data) {
                    switch(mode){
                        case MODE_NUMERIC:
                            if (!data.match(NUMERIC_REGEXP)) return null;
                            return data;
                        case MODE_ALPHANUMERIC:
                            if (!data.match(ALPHANUMERIC_REGEXP)) return null;
                            return data.toUpperCase();
                        case MODE_OCTET:
                            if (typeof data === 'string') {
                                var newdata = [];
                                for(var i = 0; i < data.length; ++i){
                                    var ch = data.charCodeAt(i);
                                    if (ch < 0x80) newdata.push(ch);
                                    else if (ch < 0x800) newdata.push(0xc0 | ch >> 6, 0x80 | ch & 0x3f);
                                    else if (ch < 0x10000) newdata.push(0xe0 | ch >> 12, 0x80 | ch >> 6 & 0x3f, 0x80 | ch & 0x3f);
                                    else newdata.push(0xf0 | ch >> 18, 0x80 | ch >> 12 & 0x3f, 0x80 | ch >> 6 & 0x3f, 0x80 | ch & 0x3f);
                                }
                                return newdata;
                            } else return data;
                    }
                };
                // returns the code words (sans ECC bits) for given data and configurations.
                // requires data to be preprocessed by validatedata. no length check is
                // performed, and everything has to be checked before calling this function.
                var encode = function(ver, mode, data, maxbuflen) {
                    var buf = [];
                    var bits = 0, remaining = 8;
                    var datalen = data.length;
                    // this function is intentionally no-op when n=0.
                    var pack = function(x, n) {
                        if (n >= remaining) {
                            buf.push(bits | x >> (n -= remaining));
                            while(n >= 8)buf.push(x >> (n -= 8) & 255);
                            bits = 0;
                            remaining = 8;
                        }
                        if (n > 0) bits |= (x & (1 << n) - 1) << (remaining -= n);
                    };
                    var nlenbits = ndatalenbits(ver, mode);
                    pack(mode, 4);
                    pack(datalen, nlenbits);
                    switch(mode){
                        case MODE_NUMERIC:
                            for(var i = 2; i < datalen; i += 3)pack(parseInt(data.substring(i - 2, i + 1), 10), 10);
                            pack(parseInt(data.substring(i - 2), 10), [
                                0,
                                4,
                                7
                            ][datalen % 3]);
                            break;
                        case MODE_ALPHANUMERIC:
                            for(var i = 1; i < datalen; i += 2)pack(ALPHANUMERIC_MAP[data.charAt(i - 1)] * 45 + ALPHANUMERIC_MAP[data.charAt(i)], 11);
                            if (datalen % 2 == 1) pack(ALPHANUMERIC_MAP[data.charAt(i - 1)], 6);
                            break;
                        case MODE_OCTET:
                            for(var i = 0; i < datalen; ++i)pack(data[i], 8);
                            break;
                    }
                    // final bits. it is possible that adding terminator causes the buffer
                    // to overflow, but then the buffer truncated to the maximum size will
                    // be valid as the truncated terminator mode bits and padding is
                    // identical in appearance (cf. JIS X 0510:2004 sec 8.4.8).
                    pack(MODE_TERMINATOR, 4);
                    if (remaining < 8) buf.push(bits);
                    // the padding to fill up the remaining space. we should not add any
                    // words when the overflow already occurred.
                    while(buf.length + 1 < maxbuflen)buf.push(0xec, 0x11);
                    if (buf.length < maxbuflen) buf.push(0xec);
                    return buf;
                };
                // calculates ECC code words for given code words and generator polynomial.
                //
                // this is quite similar to CRC calculation as both Reed-Solomon and CRC use
                // the certain kind of cyclic codes, which is effectively the division of
                // zero-augumented polynomial by the generator polynomial. the only difference
                // is that Reed-Solomon uses GF(2^8), instead of CRC's GF(2), and Reed-Solomon
                // uses the different generator polynomial than CRC's.
                var calculateecc = function(poly, genpoly) {
                    var modulus = poly.slice(0);
                    var polylen = poly.length, genpolylen = genpoly.length;
                    for(var i = 0; i < genpolylen; ++i)modulus.push(0);
                    for(var i = 0; i < polylen;){
                        var quotient = GF256_INVMAP[modulus[i++]];
                        if (quotient >= 0) for(var j = 0; j < genpolylen; ++j)modulus[i + j] ^= GF256_MAP[(quotient + genpoly[j]) % 255];
                    }
                    return modulus.slice(polylen);
                };
                // auguments ECC code words to given code words. the resulting words are
                // ready to be encoded in the matrix.
                //
                // the much of actual augumenting procedure follows JIS X 0510:2004 sec 8.7.
                // the code is simplified using the fact that the size of each code & ECC
                // blocks is almost same; for example, when we have 4 blocks and 46 data words
                // the number of code words in those blocks are 11, 11, 12, 12 respectively.
                var augumenteccs = function(poly, nblocks, genpoly) {
                    var subsizes = [];
                    var subsize = poly.length / nblocks | 0, subsize0 = 0;
                    var pivot = nblocks - poly.length % nblocks;
                    for(var i = 0; i < pivot; ++i){
                        subsizes.push(subsize0);
                        subsize0 += subsize;
                    }
                    for(var i = pivot; i < nblocks; ++i){
                        subsizes.push(subsize0);
                        subsize0 += subsize + 1;
                    }
                    subsizes.push(subsize0);
                    var eccs = [];
                    for(var i = 0; i < nblocks; ++i)eccs.push(calculateecc(poly.slice(subsizes[i], subsizes[i + 1]), genpoly));
                    var result = [];
                    var nitemsperblock = poly.length / nblocks | 0;
                    for(var i = 0; i < nitemsperblock; ++i)for(var j = 0; j < nblocks; ++j)result.push(poly[subsizes[j] + i]);
                    for(var j = pivot; j < nblocks; ++j)result.push(poly[subsizes[j + 1] - 1]);
                    for(var i = 0; i < genpoly.length; ++i)for(var j = 0; j < nblocks; ++j)result.push(eccs[j][i]);
                    return result;
                };
                // auguments BCH(p+q,q) code to the polynomial over GF(2), given the proper
                // genpoly. the both input and output are in binary numbers, and unlike
                // calculateecc genpoly should include the 1 bit for the highest degree.
                //
                // actual polynomials used for this procedure are as follows:
                // - p=10, q=5, genpoly=x^10+x^8+x^5+x^4+x^2+x+1 (JIS X 0510:2004 Appendix C)
                // - p=18, q=6, genpoly=x^12+x^11+x^10+x^9+x^8+x^5+x^2+1 (ibid. Appendix D)
                var augumentbch = function(poly, p, genpoly, q) {
                    var modulus = poly << q;
                    for(var i = p - 1; i >= 0; --i)if (modulus >> q + i & 1) modulus ^= genpoly << i;
                    return poly << q | modulus;
                };
                // creates the base matrix for given version. it returns two matrices, one of
                // them is the actual one and the another represents the "reserved" portion
                // (e.g. finder and timing patterns) of the matrix.
                //
                // some entries in the matrix may be undefined, rather than 0 or 1. this is
                // intentional (no initialization needed!), and putdata below will fill
                // the remaining ones.
                var makebasematrix = function(ver) {
                    var v = VERSIONS[ver], n = getsizebyver(ver);
                    var matrix = [], reserved = [];
                    for(var i = 0; i < n; ++i){
                        matrix.push([]);
                        reserved.push([]);
                    }
                    var blit = function(y, x, h, w, bits) {
                        for(var i = 0; i < h; ++i)for(var j = 0; j < w; ++j){
                            matrix[y + i][x + j] = bits[i] >> j & 1;
                            reserved[y + i][x + j] = 1;
                        }
                    };
                    // finder patterns and a part of timing patterns
                    // will also mark the format information area (not yet written) as reserved.
                    blit(0, 0, 9, 9, [
                        0x7f,
                        0x41,
                        0x5d,
                        0x5d,
                        0x5d,
                        0x41,
                        0x17f,
                        0x00,
                        0x40
                    ]);
                    blit(n - 8, 0, 8, 9, [
                        0x100,
                        0x7f,
                        0x41,
                        0x5d,
                        0x5d,
                        0x5d,
                        0x41,
                        0x7f
                    ]);
                    blit(0, n - 8, 9, 8, [
                        0xfe,
                        0x82,
                        0xba,
                        0xba,
                        0xba,
                        0x82,
                        0xfe,
                        0x00,
                        0x00
                    ]);
                    // the rest of timing patterns
                    for(var i = 9; i < n - 8; ++i){
                        matrix[6][i] = matrix[i][6] = ~i & 1;
                        reserved[6][i] = reserved[i][6] = 1;
                    }
                    // alignment patterns
                    var aligns = v[2], m = aligns.length;
                    for(var i = 0; i < m; ++i){
                        var minj = i === 0 || i === m - 1 ? 1 : 0, maxj = i === 0 ? m - 1 : m;
                        for(var j = minj; j < maxj; ++j)blit(aligns[i], aligns[j], 5, 5, [
                            0x1f,
                            0x11,
                            0x15,
                            0x11,
                            0x1f
                        ]);
                    }
                    // version information
                    if (needsverinfo(ver)) {
                        var code = augumentbch(ver, 6, 0x1f25, 12);
                        var k = 0;
                        for(var i = 0; i < 6; ++i)for(var j = 0; j < 3; ++j){
                            matrix[i][n - 11 + j] = matrix[n - 11 + j][i] = code >> k++ & 1;
                            reserved[i][n - 11 + j] = reserved[n - 11 + j][i] = 1;
                        }
                    }
                    return {
                        matrix: matrix,
                        reserved: reserved
                    };
                };
                // fills the data portion (i.e. unmarked in reserved) of the matrix with given
                // code words. the size of code words should be no more than available bits,
                // and remaining bits are padded to 0 (cf. JIS X 0510:2004 sec 8.7.3).
                var putdata = function(matrix, reserved, buf) {
                    var n = matrix.length;
                    var k = 0, dir = -1;
                    for(var i = n - 1; i >= 0; i -= 2){
                        if (i == 6) --i; // skip the entire timing pattern column
                        var jj = dir < 0 ? n - 1 : 0;
                        for(var j = 0; j < n; ++j){
                            for(var ii = i; ii > i - 2; --ii)if (!reserved[jj][ii]) {
                                // may overflow, but (undefined >> x)
                                // is 0 so it will auto-pad to zero.
                                matrix[jj][ii] = buf[k >> 3] >> (~k & 7) & 1;
                                ++k;
                            }
                            jj += dir;
                        }
                        dir = -dir;
                    }
                    return matrix;
                };
                // XOR-masks the data portion of the matrix. repeating the call with the same
                // arguments will revert the prior call (convenient in the matrix evaluation).
                var maskdata = function(matrix, reserved, mask) {
                    var maskf = MASKFUNCS[mask];
                    var n = matrix.length;
                    for(var i = 0; i < n; ++i){
                        for(var j = 0; j < n; ++j)if (!reserved[i][j]) matrix[i][j] ^= maskf(i, j);
                    }
                    return matrix;
                };
                // puts the format information.
                var putformatinfo = function(matrix, reserved, ecclevel, mask) {
                    var n = matrix.length;
                    var code = augumentbch(ecclevel << 3 | mask, 5, 0x537, 10) ^ 0x5412;
                    for(var i = 0; i < 15; ++i){
                        var r = [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            7,
                            8,
                            n - 7,
                            n - 6,
                            n - 5,
                            n - 4,
                            n - 3,
                            n - 2,
                            n - 1
                        ][i];
                        var c = [
                            n - 1,
                            n - 2,
                            n - 3,
                            n - 4,
                            n - 5,
                            n - 6,
                            n - 7,
                            n - 8,
                            7,
                            5,
                            4,
                            3,
                            2,
                            1,
                            0
                        ][i];
                        matrix[r][8] = matrix[8][c] = code >> i & 1;
                    // we don't have to mark those bits reserved; always done
                    // in makebasematrix above.
                    }
                    return matrix;
                };
                // evaluates the resulting matrix and returns the score (lower is better).
                // (cf. JIS X 0510:2004 sec 8.8.2)
                //
                // the evaluation procedure tries to avoid the problematic patterns naturally
                // occuring from the original matrix. for example, it penaltizes the patterns
                // which just look like the finder pattern which will confuse the decoder.
                // we choose the mask which results in the lowest score among 8 possible ones.
                //
                // note: zxing seems to use the same procedure and in many cases its choice
                // agrees to ours, but sometimes it does not. practically it doesn't matter.
                var evaluatematrix = function(matrix) {
                    // N1+(k-5) points for each consecutive row of k same-colored modules,
                    // where k >= 5. no overlapping row counts.
                    var PENALTY_CONSECUTIVE = 3;
                    // N2 points for each 2x2 block of same-colored modules.
                    // overlapping block does count.
                    var PENALTY_TWOBYTWO = 3;
                    // N3 points for each pattern with >4W:1B:1W:3B:1W:1B or
                    // 1B:1W:3B:1W:1B:>4W, or their multiples (e.g. highly unlikely,
                    // but 13W:3B:3W:9B:3W:3B counts).
                    var PENALTY_FINDERLIKE = 40;
                    // N4*k points for every (5*k)% deviation from 50% black density.
                    // i.e. k=1 for 55~60% and 40~45%, k=2 for 60~65% and 35~40%, etc.
                    var PENALTY_DENSITY = 10;
                    var evaluategroup = function(groups) {
                        var score = 0;
                        for(var i = 0; i < groups.length; ++i)if (groups[i] >= 5) score += PENALTY_CONSECUTIVE + (groups[i] - 5);
                        for(var i = 5; i < groups.length; i += 2){
                            var p = groups[i];
                            if (groups[i - 1] == p && groups[i - 2] == 3 * p && groups[i - 3] == p && groups[i - 4] == p && (groups[i - 5] >= 4 * p || groups[i + 1] >= 4 * p)) // this part differs from zxing...
                            score += PENALTY_FINDERLIKE;
                        }
                        return score;
                    };
                    var n = matrix.length;
                    var score = 0, nblacks = 0;
                    for(var i = 0; i < n; ++i){
                        var row = matrix[i];
                        var groups;
                        // evaluate the current row
                        groups = [
                            0
                        ]; // the first empty group of white
                        for(var j = 0; j < n;){
                            var k;
                            for(k = 0; j < n && row[j]; ++k)++j;
                            groups.push(k);
                            for(k = 0; j < n && !row[j]; ++k)++j;
                            groups.push(k);
                        }
                        score += evaluategroup(groups);
                        // evaluate the current column
                        groups = [
                            0
                        ];
                        for(var j = 0; j < n;){
                            var k;
                            for(k = 0; j < n && matrix[j][i]; ++k)++j;
                            groups.push(k);
                            for(k = 0; j < n && !matrix[j][i]; ++k)++j;
                            groups.push(k);
                        }
                        score += evaluategroup(groups);
                        // check the 2x2 box and calculate the density
                        var nextrow = matrix[i + 1] || [];
                        nblacks += row[0];
                        for(var j = 1; j < n; ++j){
                            var p = row[j];
                            nblacks += p;
                            // at least comparison with next row should be strict...
                            if (row[j - 1] == p && nextrow[j] === p && nextrow[j - 1] === p) score += PENALTY_TWOBYTWO;
                        }
                    }
                    score += PENALTY_DENSITY * (Math.abs(nblacks / n / n - 0.5) / 0.05 | 0);
                    return score;
                };
                // returns the fully encoded QR code matrix which contains given data.
                // it also chooses the best mask automatically when mask is -1.
                var generate = function(data, ver, mode, ecclevel, mask) {
                    var v = VERSIONS[ver];
                    var buf = encode(ver, mode, data, ndatabits(ver, ecclevel) >> 3);
                    buf = augumenteccs(buf, v[1][ecclevel], GF256_GENPOLY[v[0][ecclevel]]);
                    var result = makebasematrix(ver);
                    var matrix = result.matrix, reserved = result.reserved;
                    putdata(matrix, reserved, buf);
                    if (mask < 0) {
                        // find the best mask
                        maskdata(matrix, reserved, 0);
                        putformatinfo(matrix, reserved, ecclevel, 0);
                        var bestmask = 0, bestscore = evaluatematrix(matrix);
                        maskdata(matrix, reserved, 0);
                        for(mask = 1; mask < 8; ++mask){
                            maskdata(matrix, reserved, mask);
                            putformatinfo(matrix, reserved, ecclevel, mask);
                            var score = evaluatematrix(matrix);
                            if (bestscore > score) {
                                bestscore = score;
                                bestmask = mask;
                            }
                            maskdata(matrix, reserved, mask);
                        }
                        mask = bestmask;
                    }
                    maskdata(matrix, reserved, mask);
                    putformatinfo(matrix, reserved, ecclevel, mask);
                    return matrix;
                };
                // the public interface is trivial; the options available are as follows:
                //
                // - version: an integer in [1,40]. when omitted (or -1) the smallest possible
                //   version is chosen.
                // - mode: one of 'numeric', 'alphanumeric', 'octet'. when omitted the smallest
                //   possible mode is chosen.
                // - eccLevel: one of 'L', 'M', 'Q', 'H'. defaults to 'L'.
                // - mask: an integer in [0,7]. when omitted (or -1) the best mask is chosen.
                //
                function generateFrame(data, options) {
                    var MODES = {
                        'numeric': MODE_NUMERIC,
                        'alphanumeric': MODE_ALPHANUMERIC,
                        'octet': MODE_OCTET
                    };
                    var ECCLEVELS = {
                        'L': ECCLEVEL_L,
                        'M': ECCLEVEL_M,
                        'Q': ECCLEVEL_Q,
                        'H': ECCLEVEL_H
                    };
                    options = options || {};
                    var ver = options.version || -1;
                    var ecclevel = ECCLEVELS[(options.eccLevel || 'L').toUpperCase()];
                    var mode = options.mode ? MODES[options.mode.toLowerCase()] : -1;
                    var mask = 'mask' in options ? options.mask : -1;
                    if (mode < 0) {
                        if (typeof data === 'string') {
                            if (data.match(NUMERIC_REGEXP)) mode = MODE_NUMERIC;
                            else if (data.match(ALPHANUMERIC_OUT_REGEXP)) // while encode supports case-insensitive encoding, we restrict the data to be uppercased when auto-selecting the mode.
                            mode = MODE_ALPHANUMERIC;
                            else mode = MODE_OCTET;
                        } else mode = MODE_OCTET;
                    } else if (!(mode == MODE_NUMERIC || mode == MODE_ALPHANUMERIC || mode == MODE_OCTET)) throw 'invalid or unsupported mode';
                    data = validatedata(mode, data);
                    if (data === null) throw 'invalid data format';
                    if (ecclevel < 0 || ecclevel > 3) throw 'invalid ECC level';
                    if (ver < 0) {
                        for(ver = 1; ver <= 40; ++ver){
                            if (data.length <= getmaxdatalen(ver, mode, ecclevel)) break;
                        }
                        if (ver > 40) throw 'too large data for the Qr format';
                    } else if (ver < 1 || ver > 40) throw 'invalid Qr version! should be between 1 and 40';
                    if (mask != -1 && (mask < 0 || mask > 8)) throw 'invalid mask';
                    //console.log('version:', ver, 'mode:', mode, 'ECC:', ecclevel, 'mask:', mask )
                    return generate(data, ver, mode, ecclevel, mask);
                }
                // options
                // - modulesize: a number. this is a size of each modules in pixels, and
                //   defaults to 5px.
                // - margin: a number. this is a size of margin in *modules*, and defaults to
                //   4 (white modules). the specficiation mandates the margin no less than 4
                //   modules, so it is better not to alter this value unless you know what
                //   you're doing.
                function buildCanvas(data, options) {
                    var canvas = [];
                    var background = options.background || '#fff';
                    var foreground = options.foreground || '#000';
                    var padding = options.padding || 0;
                    //var margin = options.margin || 4;
                    var matrix = generateFrame(data, options);
                    var n = matrix.length;
                    var modSize = Math.floor(options.fit ? options.fit / n : 5);
                    var size = n * modSize + modSize * padding * 2;
                    var paddingXY = modSize * padding;
                    canvas.push({
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: size,
                        h: size,
                        lineWidth: 0,
                        color: background
                    });
                    for(var i = 0; i < n; ++i){
                        for(var j = 0; j < n; ++j)if (matrix[i][j]) canvas.push({
                            type: 'rect',
                            x: modSize * j + paddingXY,
                            y: modSize * i + paddingXY,
                            w: modSize,
                            h: modSize,
                            lineWidth: 0,
                            color: foreground
                        });
                    }
                    return {
                        canvas: canvas,
                        size: size
                    };
                }
                function measure(node) {
                    var cd = buildCanvas(node.qr, node);
                    node._canvas = cd.canvas;
                    node._width = node._height = node._minWidth = node._maxWidth = node._minHeight = node._maxHeight = cd.size;
                    return node;
                }
                module1.exports = {
                    measure: measure
                };
            /***/ },
            /***/ 72324: /***/ function(module1) {
                "use strict";
                module1.exports = /*#__PURE__*/ JSON.parse('[["0","\\u0000",127],["a140","\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A"],["a1a1","\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62",4,"\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F"],["a240","\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581",7,"\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D"],["a2a1","\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10",9,"\u2160",9,"\u3021",8,"\u5341\u5344\u5345\uFF21",25,"\uFF41",21],["a340","\uFF57\uFF58\uFF59\uFF5A\u0391",16,"\u03A3",6,"\u03B1",16,"\u03C3",6,"\u3105",10],["a3a1","\u3110",25,"\u02D9\u02C9\u02CA\u02C7\u02CB"],["a3e1","\u20AC"],["a440","\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D"],["a4a1","\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19"],["a540","\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916"],["a5a1","\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168"],["a640","\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74"],["a6a1","\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63"],["a740","\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D"],["a7a1","\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760"],["a840","\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292"],["a8a1","\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475"],["a940","\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45"],["a9a1","\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A"],["aa40","\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0"],["aaa1","\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644"],["ab40","\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1"],["aba1","\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7"],["ac40","\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17"],["aca1","\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004"],["ad40","\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5"],["ada1","\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA"],["ae40","\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059"],["aea1","\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93"],["af40","\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837"],["afa1","\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343"],["b040","\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661"],["b0a1","\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40"],["b140","\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD"],["b1a1","\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA"],["b240","\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6"],["b2a1","\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C"],["b340","\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014"],["b3a1","\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960"],["b440","\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD"],["b4a1","\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB"],["b540","\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98"],["b5a1","\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41"],["b640","\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591"],["b6a1","\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC"],["b740","\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D"],["b7a1","\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763"],["b840","\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B"],["b8a1","\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A"],["b940","\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4"],["b9a1","\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147"],["ba40","\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22"],["baa1","\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC"],["bb40","\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4"],["bba1","\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC"],["bc40","\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182"],["bca1","\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483"],["bd40","\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF"],["bda1","\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E"],["be40","\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09"],["bea1","\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1"],["bf40","\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A"],["bfa1","\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A"],["c040","\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687"],["c0a1","\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC"],["c140","\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA"],["c1a1","\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01"],["c240","\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658"],["c2a1","\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6"],["c340","\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378"],["c3a1","\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E"],["c440","\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C"],["c4a1","\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74"],["c540","\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C"],["c5a1","\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92"],["c640","\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72"],["c940","\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15"],["c9a1","\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B"],["ca40","\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418"],["caa1","\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747"],["cb40","\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293"],["cba1","\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762"],["cc40","\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B"],["cca1","\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2"],["cd40","\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA"],["cda1","\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF"],["ce40","\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB"],["cea1","\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA"],["cf40","\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42"],["cfa1","\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80"],["d040","\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA"],["d0a1","\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1"],["d140","\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067"],["d1a1","\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4"],["d240","\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278"],["d2a1","\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10"],["d340","\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322"],["d3a1","\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150"],["d440","\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545"],["d4a1","\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F"],["d540","\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F"],["d5a1","\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9"],["d640","\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF"],["d6a1","\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F"],["d740","\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7"],["d7a1","\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA"],["d840","\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837"],["d8a1","\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114"],["d940","\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2"],["d9a1","\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E"],["da40","\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416"],["daa1","\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65"],["db40","\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3"],["dba1","\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA"],["dc40","\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688"],["dca1","\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6"],["dd40","\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424"],["dda1","\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC"],["de40","\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153"],["dea1","\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13"],["df40","\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F"],["dfa1","\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4"],["e040","\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F"],["e0a1","\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0"],["e140","\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0"],["e1a1","\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9"],["e240","\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A"],["e2a1","\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993"],["e340","\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE"],["e3a1","\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB"],["e440","\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D"],["e4a1","\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658"],["e540","\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189"],["e5a1","\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92"],["e640","\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359"],["e6a1","\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F"],["e740","\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662"],["e7a1","\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27"],["e840","\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3"],["e8a1","\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E"],["e940","\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA"],["e9a1","\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8"],["ea40","\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799"],["eaa1","\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558"],["eb40","\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0"],["eba1","\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C"],["ec40","\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95"],["eca1","\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E"],["ed40","\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6"],["eda1","\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E"],["ee40","\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E"],["eea1","\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C"],["ef40","\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30"],["efa1","\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376"],["f040","\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2"],["f0a1","\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67"],["f140","\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA"],["f1a1","\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70"],["f240","\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B"],["f2a1","\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55"],["f340","\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726"],["f3a1","\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2"],["f440","\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929"],["f4a1","\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF"],["f540","\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B"],["f5a1","\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625"],["f640","\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A"],["f6a1","\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A"],["f740","\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A"],["f7a1","\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE"],["f840","\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F"],["f8a1","\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A"],["f940","\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A"],["f9a1","\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593"]]');
            /***/ },
            /***/ 72519: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
                function _has(obj, key) {
                    return Object.prototype.hasOwnProperty.call(obj, key);
                }
                exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
                    var sources = Array.prototype.slice.call(arguments, 1);
                    while(sources.length){
                        var source = sources.shift();
                        if (!source) continue;
                        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
                        for(var p in source)if (_has(source, p)) obj[p] = source[p];
                    }
                    return obj;
                };
                // reduce buffer size, avoiding mem copy
                exports.shrinkBuf = function(buf, size) {
                    if (buf.length === size) return buf;
                    if (buf.subarray) return buf.subarray(0, size);
                    buf.length = size;
                    return buf;
                };
                var fnTyped = {
                    arraySet: function(dest, src, src_offs, len, dest_offs) {
                        if (src.subarray && dest.subarray) {
                            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
                            return;
                        }
                        // Fallback to ordinary array
                        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
                    },
                    // Join array of chunks to single array.
                    flattenChunks: function(chunks) {
                        var i, l, len, pos, chunk, result;
                        // calculate data length
                        len = 0;
                        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
                        // join chunks
                        result = new Uint8Array(len);
                        pos = 0;
                        for(i = 0, l = chunks.length; i < l; i++){
                            chunk = chunks[i];
                            result.set(chunk, pos);
                            pos += chunk.length;
                        }
                        return result;
                    }
                };
                var fnUntyped = {
                    arraySet: function(dest, src, src_offs, len, dest_offs) {
                        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
                    },
                    // Join array of chunks to single array.
                    flattenChunks: function(chunks) {
                        return [].concat.apply([], chunks);
                    }
                };
                // Enable/Disable typed arrays use, for testing
                //
                exports.setTyped = function(on) {
                    if (on) {
                        exports.Buf8 = Uint8Array;
                        exports.Buf16 = Uint16Array;
                        exports.Buf32 = Int32Array;
                        exports.assign(exports, fnTyped);
                    } else {
                        exports.Buf8 = Array;
                        exports.Buf16 = Array;
                        exports.Buf32 = Array;
                        exports.assign(exports, fnUntyped);
                    }
                };
                exports.setTyped(TYPED_OK);
            /***/ },
            /***/ 72864: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toObject = __webpack_require__(43162);
                var toAbsoluteIndex = __webpack_require__(74841);
                var lengthOfArrayLike = __webpack_require__(45495);
                // `Array.prototype.fill` method implementation
                // https://tc39.es/ecma262/#sec-array.prototype.fill
                module1.exports = function fill(value /* , start = 0, end = @length */ ) {
                    var O = toObject(this);
                    var length = lengthOfArrayLike(O);
                    var argumentsLength = arguments.length;
                    var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
                    var end = argumentsLength > 2 ? arguments[2] : undefined;
                    var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
                    while(endPos > index)O[index++] = value;
                    return O;
                };
            /***/ },
            /***/ 72908: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                /* provided dependency */ var process = __webpack_require__(9964);
                /* eslint camelcase: "off" */ var assert = __webpack_require__(80182);
                var Zstream = __webpack_require__(37468);
                var zlib_deflate = __webpack_require__(22925);
                var zlib_inflate = __webpack_require__(2269);
                var constants = __webpack_require__(81607);
                for(var key in constants)exports[key] = constants[key];
                // zlib modes
                exports.NONE = 0;
                exports.DEFLATE = 1;
                exports.INFLATE = 2;
                exports.GZIP = 3;
                exports.GUNZIP = 4;
                exports.DEFLATERAW = 5;
                exports.INFLATERAW = 6;
                exports.UNZIP = 7;
                var GZIP_HEADER_ID1 = 0x1f;
                var GZIP_HEADER_ID2 = 0x8b;
                /**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function Zlib(mode) {
                    if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) throw new TypeError('Bad argument');
                    this.dictionary = null;
                    this.err = 0;
                    this.flush = 0;
                    this.init_done = false;
                    this.level = 0;
                    this.memLevel = 0;
                    this.mode = mode;
                    this.strategy = 0;
                    this.windowBits = 0;
                    this.write_in_progress = false;
                    this.pending_close = false;
                    this.gzip_id_bytes_read = 0;
                }
                Zlib.prototype.close = function() {
                    if (this.write_in_progress) {
                        this.pending_close = true;
                        return;
                    }
                    this.pending_close = false;
                    assert(this.init_done, 'close before init');
                    assert(this.mode <= exports.UNZIP);
                    if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) zlib_deflate.deflateEnd(this.strm);
                    else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) zlib_inflate.inflateEnd(this.strm);
                    this.mode = exports.NONE;
                    this.dictionary = null;
                };
                Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
                    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
                };
                Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
                    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
                };
                Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
                    assert.equal(arguments.length, 8);
                    assert(this.init_done, 'write before init');
                    assert(this.mode !== exports.NONE, 'already finalized');
                    assert.equal(false, this.write_in_progress, 'write already in progress');
                    assert.equal(false, this.pending_close, 'close is pending');
                    this.write_in_progress = true;
                    assert.equal(false, flush === undefined, 'must provide flush value');
                    this.write_in_progress = true;
                    if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) throw new Error('Invalid flush value');
                    if (input == null) {
                        input = Buffer.alloc(0);
                        in_len = 0;
                        in_off = 0;
                    }
                    this.strm.avail_in = in_len;
                    this.strm.input = input;
                    this.strm.next_in = in_off;
                    this.strm.avail_out = out_len;
                    this.strm.output = out;
                    this.strm.next_out = out_off;
                    this.flush = flush;
                    if (!async) {
                        // sync version
                        this._process();
                        if (this._checkError()) return this._afterSync();
                        return;
                    }
                    // async version
                    var self1 = this;
                    process.nextTick(function() {
                        self1._process();
                        self1._after();
                    });
                    return this;
                };
                Zlib.prototype._afterSync = function() {
                    var avail_out = this.strm.avail_out;
                    var avail_in = this.strm.avail_in;
                    this.write_in_progress = false;
                    return [
                        avail_in,
                        avail_out
                    ];
                };
                Zlib.prototype._process = function() {
                    var next_expected_header_byte = null;
                    // If the avail_out is left at 0, then it means that it ran out
                    // of room.  If there was avail_out left over, then it means
                    // that all of the input was consumed.
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.GZIP:
                        case exports.DEFLATERAW:
                            this.err = zlib_deflate.deflate(this.strm, this.flush);
                            break;
                        case exports.UNZIP:
                            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
                            switch(this.gzip_id_bytes_read){
                                case 0:
                                    if (next_expected_header_byte === null) break;
                                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                                        this.gzip_id_bytes_read = 1;
                                        next_expected_header_byte++;
                                        if (this.strm.avail_in === 1) break;
                                    } else {
                                        this.mode = exports.INFLATE;
                                        break;
                                    }
                                // fallthrough
                                case 1:
                                    if (next_expected_header_byte === null) break;
                                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                                        this.gzip_id_bytes_read = 2;
                                        this.mode = exports.GUNZIP;
                                    } else // There is no actual difference between INFLATE and INFLATERAW
                                    // (after initialization).
                                    this.mode = exports.INFLATE;
                                    break;
                                default:
                                    throw new Error('invalid number of gzip magic number bytes read');
                            }
                        // fallthrough
                        case exports.INFLATE:
                        case exports.GUNZIP:
                        case exports.INFLATERAW:
                            this.err = zlib_inflate.inflate(this.strm, this.flush);
                            if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                                // Load it
                                this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                                if (this.err === exports.Z_OK) // And try to decode again
                                this.err = zlib_inflate.inflate(this.strm, this.flush);
                                else if (this.err === exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                                // Make it possible for After() to tell a bad dictionary from bad
                                // input.
                                this.err = exports.Z_NEED_DICT;
                            }
                            while(this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                                // Bytes remain in input buffer. Perhaps this is another compressed
                                // member in the same archive, or just trailing garbage.
                                // Trailing zero bytes are okay, though, since they are frequently
                                // used for padding.
                                this.reset();
                                this.err = zlib_inflate.inflate(this.strm, this.flush);
                            }
                            break;
                        default:
                            throw new Error('Unknown mode ' + this.mode);
                    }
                };
                Zlib.prototype._checkError = function() {
                    // Acceptable error states depend on the type of zlib stream.
                    switch(this.err){
                        case exports.Z_OK:
                        case exports.Z_BUF_ERROR:
                            if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                                this._error('unexpected end of file');
                                return false;
                            }
                            break;
                        case exports.Z_STREAM_END:
                            break;
                        case exports.Z_NEED_DICT:
                            if (this.dictionary == null) this._error('Missing dictionary');
                            else this._error('Bad dictionary');
                            return false;
                        default:
                            // something else.
                            this._error('Zlib error');
                            return false;
                    }
                    return true;
                };
                Zlib.prototype._after = function() {
                    if (!this._checkError()) return;
                    var avail_out = this.strm.avail_out;
                    var avail_in = this.strm.avail_in;
                    this.write_in_progress = false;
                    // call the write() cb
                    this.callback(avail_in, avail_out);
                    if (this.pending_close) this.close();
                };
                Zlib.prototype._error = function(message) {
                    if (this.strm.msg) message = this.strm.msg;
                    this.onerror(message, this.err);
                    this.write_in_progress = false;
                    if (this.pending_close) this.close();
                };
                Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
                    assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');
                    assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
                    assert(level >= -1 && level <= 9, 'invalid compression level');
                    assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');
                    assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');
                    this._init(level, windowBits, memLevel, strategy, dictionary);
                    this._setDictionary();
                };
                Zlib.prototype.params = function() {
                    throw new Error('deflateParams Not supported');
                };
                Zlib.prototype.reset = function() {
                    this._reset();
                    this._setDictionary();
                };
                Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
                    this.level = level;
                    this.windowBits = windowBits;
                    this.memLevel = memLevel;
                    this.strategy = strategy;
                    this.flush = exports.Z_NO_FLUSH;
                    this.err = exports.Z_OK;
                    if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) this.windowBits += 16;
                    if (this.mode === exports.UNZIP) this.windowBits += 32;
                    if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
                    this.strm = new Zstream();
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.GZIP:
                        case exports.DEFLATERAW:
                            this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                            break;
                        case exports.INFLATE:
                        case exports.GUNZIP:
                        case exports.INFLATERAW:
                        case exports.UNZIP:
                            this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
                            break;
                        default:
                            throw new Error('Unknown mode ' + this.mode);
                    }
                    if (this.err !== exports.Z_OK) this._error('Init error');
                    this.dictionary = dictionary;
                    this.write_in_progress = false;
                    this.init_done = true;
                };
                Zlib.prototype._setDictionary = function() {
                    if (this.dictionary == null) return;
                    this.err = exports.Z_OK;
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.DEFLATERAW:
                            this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
                            break;
                        default:
                            break;
                    }
                    if (this.err !== exports.Z_OK) this._error('Failed to set dictionary');
                };
                Zlib.prototype._reset = function() {
                    this.err = exports.Z_OK;
                    switch(this.mode){
                        case exports.DEFLATE:
                        case exports.DEFLATERAW:
                        case exports.GZIP:
                            this.err = zlib_deflate.deflateReset(this.strm);
                            break;
                        case exports.INFLATE:
                        case exports.INFLATERAW:
                        case exports.GUNZIP:
                            this.err = zlib_inflate.inflateReset(this.strm);
                            break;
                        default:
                            break;
                    }
                    if (this.err !== exports.Z_OK) this._error('Failed to reset stream');
                };
                exports.Zlib = Zlib;
            /***/ },
            /***/ 73036: /***/ function(module1) {
                "use strict";
                /** @type {import('./functionApply')} */ module1.exports = Function.prototype.apply;
            /***/ },
            /***/ 73163: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                module1.exports = uncurryThis([].slice);
            /***/ },
            /***/ 73257: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var origSymbol = typeof Symbol !== 'undefined' && Symbol;
                var hasSymbolSham = __webpack_require__(12843);
                /** @type {import('.')} */ module1.exports = function hasNativeSymbols() {
                    if (typeof origSymbol !== 'function') return false;
                    if (typeof Symbol !== 'function') return false;
                    if (typeof origSymbol('foo') !== 'symbol') return false;
                    if (typeof Symbol('bar') !== 'symbol') return false;
                    return hasSymbolSham();
                };
            /***/ },
            /***/ 73517: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(66947), __webpack_require__(68319), __webpack_require__(82747), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var BlockCipher = C_lib.BlockCipher;
                        var C_algo = C.algo;
                        var N = 16;
                        //Origin pbox and sbox, derived from PI
                        var ORIG_P = [
                            0x243F6A88,
                            0x85A308D3,
                            0x13198A2E,
                            0x03707344,
                            0xA4093822,
                            0x299F31D0,
                            0x082EFA98,
                            0xEC4E6C89,
                            0x452821E6,
                            0x38D01377,
                            0xBE5466CF,
                            0x34E90C6C,
                            0xC0AC29B7,
                            0xC97C50DD,
                            0x3F84D5B5,
                            0xB5470917,
                            0x9216D5D9,
                            0x8979FB1B
                        ];
                        var ORIG_S = [
                            [
                                0xD1310BA6,
                                0x98DFB5AC,
                                0x2FFD72DB,
                                0xD01ADFB7,
                                0xB8E1AFED,
                                0x6A267E96,
                                0xBA7C9045,
                                0xF12C7F99,
                                0x24A19947,
                                0xB3916CF7,
                                0x0801F2E2,
                                0x858EFC16,
                                0x636920D8,
                                0x71574E69,
                                0xA458FEA3,
                                0xF4933D7E,
                                0x0D95748F,
                                0x728EB658,
                                0x718BCD58,
                                0x82154AEE,
                                0x7B54A41D,
                                0xC25A59B5,
                                0x9C30D539,
                                0x2AF26013,
                                0xC5D1B023,
                                0x286085F0,
                                0xCA417918,
                                0xB8DB38EF,
                                0x8E79DCB0,
                                0x603A180E,
                                0x6C9E0E8B,
                                0xB01E8A3E,
                                0xD71577C1,
                                0xBD314B27,
                                0x78AF2FDA,
                                0x55605C60,
                                0xE65525F3,
                                0xAA55AB94,
                                0x57489862,
                                0x63E81440,
                                0x55CA396A,
                                0x2AAB10B6,
                                0xB4CC5C34,
                                0x1141E8CE,
                                0xA15486AF,
                                0x7C72E993,
                                0xB3EE1411,
                                0x636FBC2A,
                                0x2BA9C55D,
                                0x741831F6,
                                0xCE5C3E16,
                                0x9B87931E,
                                0xAFD6BA33,
                                0x6C24CF5C,
                                0x7A325381,
                                0x28958677,
                                0x3B8F4898,
                                0x6B4BB9AF,
                                0xC4BFE81B,
                                0x66282193,
                                0x61D809CC,
                                0xFB21A991,
                                0x487CAC60,
                                0x5DEC8032,
                                0xEF845D5D,
                                0xE98575B1,
                                0xDC262302,
                                0xEB651B88,
                                0x23893E81,
                                0xD396ACC5,
                                0x0F6D6FF3,
                                0x83F44239,
                                0x2E0B4482,
                                0xA4842004,
                                0x69C8F04A,
                                0x9E1F9B5E,
                                0x21C66842,
                                0xF6E96C9A,
                                0x670C9C61,
                                0xABD388F0,
                                0x6A51A0D2,
                                0xD8542F68,
                                0x960FA728,
                                0xAB5133A3,
                                0x6EEF0B6C,
                                0x137A3BE4,
                                0xBA3BF050,
                                0x7EFB2A98,
                                0xA1F1651D,
                                0x39AF0176,
                                0x66CA593E,
                                0x82430E88,
                                0x8CEE8619,
                                0x456F9FB4,
                                0x7D84A5C3,
                                0x3B8B5EBE,
                                0xE06F75D8,
                                0x85C12073,
                                0x401A449F,
                                0x56C16AA6,
                                0x4ED3AA62,
                                0x363F7706,
                                0x1BFEDF72,
                                0x429B023D,
                                0x37D0D724,
                                0xD00A1248,
                                0xDB0FEAD3,
                                0x49F1C09B,
                                0x075372C9,
                                0x80991B7B,
                                0x25D479D8,
                                0xF6E8DEF7,
                                0xE3FE501A,
                                0xB6794C3B,
                                0x976CE0BD,
                                0x04C006BA,
                                0xC1A94FB6,
                                0x409F60C4,
                                0x5E5C9EC2,
                                0x196A2463,
                                0x68FB6FAF,
                                0x3E6C53B5,
                                0x1339B2EB,
                                0x3B52EC6F,
                                0x6DFC511F,
                                0x9B30952C,
                                0xCC814544,
                                0xAF5EBD09,
                                0xBEE3D004,
                                0xDE334AFD,
                                0x660F2807,
                                0x192E4BB3,
                                0xC0CBA857,
                                0x45C8740F,
                                0xD20B5F39,
                                0xB9D3FBDB,
                                0x5579C0BD,
                                0x1A60320A,
                                0xD6A100C6,
                                0x402C7279,
                                0x679F25FE,
                                0xFB1FA3CC,
                                0x8EA5E9F8,
                                0xDB3222F8,
                                0x3C7516DF,
                                0xFD616B15,
                                0x2F501EC8,
                                0xAD0552AB,
                                0x323DB5FA,
                                0xFD238760,
                                0x53317B48,
                                0x3E00DF82,
                                0x9E5C57BB,
                                0xCA6F8CA0,
                                0x1A87562E,
                                0xDF1769DB,
                                0xD542A8F6,
                                0x287EFFC3,
                                0xAC6732C6,
                                0x8C4F5573,
                                0x695B27B0,
                                0xBBCA58C8,
                                0xE1FFA35D,
                                0xB8F011A0,
                                0x10FA3D98,
                                0xFD2183B8,
                                0x4AFCB56C,
                                0x2DD1D35B,
                                0x9A53E479,
                                0xB6F84565,
                                0xD28E49BC,
                                0x4BFB9790,
                                0xE1DDF2DA,
                                0xA4CB7E33,
                                0x62FB1341,
                                0xCEE4C6E8,
                                0xEF20CADA,
                                0x36774C01,
                                0xD07E9EFE,
                                0x2BF11FB4,
                                0x95DBDA4D,
                                0xAE909198,
                                0xEAAD8E71,
                                0x6B93D5A0,
                                0xD08ED1D0,
                                0xAFC725E0,
                                0x8E3C5B2F,
                                0x8E7594B7,
                                0x8FF6E2FB,
                                0xF2122B64,
                                0x8888B812,
                                0x900DF01C,
                                0x4FAD5EA0,
                                0x688FC31C,
                                0xD1CFF191,
                                0xB3A8C1AD,
                                0x2F2F2218,
                                0xBE0E1777,
                                0xEA752DFE,
                                0x8B021FA1,
                                0xE5A0CC0F,
                                0xB56F74E8,
                                0x18ACF3D6,
                                0xCE89E299,
                                0xB4A84FE0,
                                0xFD13E0B7,
                                0x7CC43B81,
                                0xD2ADA8D9,
                                0x165FA266,
                                0x80957705,
                                0x93CC7314,
                                0x211A1477,
                                0xE6AD2065,
                                0x77B5FA86,
                                0xC75442F5,
                                0xFB9D35CF,
                                0xEBCDAF0C,
                                0x7B3E89A0,
                                0xD6411BD3,
                                0xAE1E7E49,
                                0x00250E2D,
                                0x2071B35E,
                                0x226800BB,
                                0x57B8E0AF,
                                0x2464369B,
                                0xF009B91E,
                                0x5563911D,
                                0x59DFA6AA,
                                0x78C14389,
                                0xD95A537F,
                                0x207D5BA2,
                                0x02E5B9C5,
                                0x83260376,
                                0x6295CFA9,
                                0x11C81968,
                                0x4E734A41,
                                0xB3472DCA,
                                0x7B14A94A,
                                0x1B510052,
                                0x9A532915,
                                0xD60F573F,
                                0xBC9BC6E4,
                                0x2B60A476,
                                0x81E67400,
                                0x08BA6FB5,
                                0x571BE91F,
                                0xF296EC6B,
                                0x2A0DD915,
                                0xB6636521,
                                0xE7B9F9B6,
                                0xFF34052E,
                                0xC5855664,
                                0x53B02D5D,
                                0xA99F8FA1,
                                0x08BA4799,
                                0x6E85076A
                            ],
                            [
                                0x4B7A70E9,
                                0xB5B32944,
                                0xDB75092E,
                                0xC4192623,
                                0xAD6EA6B0,
                                0x49A7DF7D,
                                0x9CEE60B8,
                                0x8FEDB266,
                                0xECAA8C71,
                                0x699A17FF,
                                0x5664526C,
                                0xC2B19EE1,
                                0x193602A5,
                                0x75094C29,
                                0xA0591340,
                                0xE4183A3E,
                                0x3F54989A,
                                0x5B429D65,
                                0x6B8FE4D6,
                                0x99F73FD6,
                                0xA1D29C07,
                                0xEFE830F5,
                                0x4D2D38E6,
                                0xF0255DC1,
                                0x4CDD2086,
                                0x8470EB26,
                                0x6382E9C6,
                                0x021ECC5E,
                                0x09686B3F,
                                0x3EBAEFC9,
                                0x3C971814,
                                0x6B6A70A1,
                                0x687F3584,
                                0x52A0E286,
                                0xB79C5305,
                                0xAA500737,
                                0x3E07841C,
                                0x7FDEAE5C,
                                0x8E7D44EC,
                                0x5716F2B8,
                                0xB03ADA37,
                                0xF0500C0D,
                                0xF01C1F04,
                                0x0200B3FF,
                                0xAE0CF51A,
                                0x3CB574B2,
                                0x25837A58,
                                0xDC0921BD,
                                0xD19113F9,
                                0x7CA92FF6,
                                0x94324773,
                                0x22F54701,
                                0x3AE5E581,
                                0x37C2DADC,
                                0xC8B57634,
                                0x9AF3DDA7,
                                0xA9446146,
                                0x0FD0030E,
                                0xECC8C73E,
                                0xA4751E41,
                                0xE238CD99,
                                0x3BEA0E2F,
                                0x3280BBA1,
                                0x183EB331,
                                0x4E548B38,
                                0x4F6DB908,
                                0x6F420D03,
                                0xF60A04BF,
                                0x2CB81290,
                                0x24977C79,
                                0x5679B072,
                                0xBCAF89AF,
                                0xDE9A771F,
                                0xD9930810,
                                0xB38BAE12,
                                0xDCCF3F2E,
                                0x5512721F,
                                0x2E6B7124,
                                0x501ADDE6,
                                0x9F84CD87,
                                0x7A584718,
                                0x7408DA17,
                                0xBC9F9ABC,
                                0xE94B7D8C,
                                0xEC7AEC3A,
                                0xDB851DFA,
                                0x63094366,
                                0xC464C3D2,
                                0xEF1C1847,
                                0x3215D908,
                                0xDD433B37,
                                0x24C2BA16,
                                0x12A14D43,
                                0x2A65C451,
                                0x50940002,
                                0x133AE4DD,
                                0x71DFF89E,
                                0x10314E55,
                                0x81AC77D6,
                                0x5F11199B,
                                0x043556F1,
                                0xD7A3C76B,
                                0x3C11183B,
                                0x5924A509,
                                0xF28FE6ED,
                                0x97F1FBFA,
                                0x9EBABF2C,
                                0x1E153C6E,
                                0x86E34570,
                                0xEAE96FB1,
                                0x860E5E0A,
                                0x5A3E2AB3,
                                0x771FE71C,
                                0x4E3D06FA,
                                0x2965DCB9,
                                0x99E71D0F,
                                0x803E89D6,
                                0x5266C825,
                                0x2E4CC978,
                                0x9C10B36A,
                                0xC6150EBA,
                                0x94E2EA78,
                                0xA5FC3C53,
                                0x1E0A2DF4,
                                0xF2F74EA7,
                                0x361D2B3D,
                                0x1939260F,
                                0x19C27960,
                                0x5223A708,
                                0xF71312B6,
                                0xEBADFE6E,
                                0xEAC31F66,
                                0xE3BC4595,
                                0xA67BC883,
                                0xB17F37D1,
                                0x018CFF28,
                                0xC332DDEF,
                                0xBE6C5AA5,
                                0x65582185,
                                0x68AB9802,
                                0xEECEA50F,
                                0xDB2F953B,
                                0x2AEF7DAD,
                                0x5B6E2F84,
                                0x1521B628,
                                0x29076170,
                                0xECDD4775,
                                0x619F1510,
                                0x13CCA830,
                                0xEB61BD96,
                                0x0334FE1E,
                                0xAA0363CF,
                                0xB5735C90,
                                0x4C70A239,
                                0xD59E9E0B,
                                0xCBAADE14,
                                0xEECC86BC,
                                0x60622CA7,
                                0x9CAB5CAB,
                                0xB2F3846E,
                                0x648B1EAF,
                                0x19BDF0CA,
                                0xA02369B9,
                                0x655ABB50,
                                0x40685A32,
                                0x3C2AB4B3,
                                0x319EE9D5,
                                0xC021B8F7,
                                0x9B540B19,
                                0x875FA099,
                                0x95F7997E,
                                0x623D7DA8,
                                0xF837889A,
                                0x97E32D77,
                                0x11ED935F,
                                0x16681281,
                                0x0E358829,
                                0xC7E61FD6,
                                0x96DEDFA1,
                                0x7858BA99,
                                0x57F584A5,
                                0x1B227263,
                                0x9B83C3FF,
                                0x1AC24696,
                                0xCDB30AEB,
                                0x532E3054,
                                0x8FD948E4,
                                0x6DBC3128,
                                0x58EBF2EF,
                                0x34C6FFEA,
                                0xFE28ED61,
                                0xEE7C3C73,
                                0x5D4A14D9,
                                0xE864B7E3,
                                0x42105D14,
                                0x203E13E0,
                                0x45EEE2B6,
                                0xA3AAABEA,
                                0xDB6C4F15,
                                0xFACB4FD0,
                                0xC742F442,
                                0xEF6ABBB5,
                                0x654F3B1D,
                                0x41CD2105,
                                0xD81E799E,
                                0x86854DC7,
                                0xE44B476A,
                                0x3D816250,
                                0xCF62A1F2,
                                0x5B8D2646,
                                0xFC8883A0,
                                0xC1C7B6A3,
                                0x7F1524C3,
                                0x69CB7492,
                                0x47848A0B,
                                0x5692B285,
                                0x095BBF00,
                                0xAD19489D,
                                0x1462B174,
                                0x23820E00,
                                0x58428D2A,
                                0x0C55F5EA,
                                0x1DADF43E,
                                0x233F7061,
                                0x3372F092,
                                0x8D937E41,
                                0xD65FECF1,
                                0x6C223BDB,
                                0x7CDE3759,
                                0xCBEE7460,
                                0x4085F2A7,
                                0xCE77326E,
                                0xA6078084,
                                0x19F8509E,
                                0xE8EFD855,
                                0x61D99735,
                                0xA969A7AA,
                                0xC50C06C2,
                                0x5A04ABFC,
                                0x800BCADC,
                                0x9E447A2E,
                                0xC3453484,
                                0xFDD56705,
                                0x0E1E9EC9,
                                0xDB73DBD3,
                                0x105588CD,
                                0x675FDA79,
                                0xE3674340,
                                0xC5C43465,
                                0x713E38D8,
                                0x3D28F89E,
                                0xF16DFF20,
                                0x153E21E7,
                                0x8FB03D4A,
                                0xE6E39F2B,
                                0xDB83ADF7
                            ],
                            [
                                0xE93D5A68,
                                0x948140F7,
                                0xF64C261C,
                                0x94692934,
                                0x411520F7,
                                0x7602D4F7,
                                0xBCF46B2E,
                                0xD4A20068,
                                0xD4082471,
                                0x3320F46A,
                                0x43B7D4B7,
                                0x500061AF,
                                0x1E39F62E,
                                0x97244546,
                                0x14214F74,
                                0xBF8B8840,
                                0x4D95FC1D,
                                0x96B591AF,
                                0x70F4DDD3,
                                0x66A02F45,
                                0xBFBC09EC,
                                0x03BD9785,
                                0x7FAC6DD0,
                                0x31CB8504,
                                0x96EB27B3,
                                0x55FD3941,
                                0xDA2547E6,
                                0xABCA0A9A,
                                0x28507825,
                                0x530429F4,
                                0x0A2C86DA,
                                0xE9B66DFB,
                                0x68DC1462,
                                0xD7486900,
                                0x680EC0A4,
                                0x27A18DEE,
                                0x4F3FFEA2,
                                0xE887AD8C,
                                0xB58CE006,
                                0x7AF4D6B6,
                                0xAACE1E7C,
                                0xD3375FEC,
                                0xCE78A399,
                                0x406B2A42,
                                0x20FE9E35,
                                0xD9F385B9,
                                0xEE39D7AB,
                                0x3B124E8B,
                                0x1DC9FAF7,
                                0x4B6D1856,
                                0x26A36631,
                                0xEAE397B2,
                                0x3A6EFA74,
                                0xDD5B4332,
                                0x6841E7F7,
                                0xCA7820FB,
                                0xFB0AF54E,
                                0xD8FEB397,
                                0x454056AC,
                                0xBA489527,
                                0x55533A3A,
                                0x20838D87,
                                0xFE6BA9B7,
                                0xD096954B,
                                0x55A867BC,
                                0xA1159A58,
                                0xCCA92963,
                                0x99E1DB33,
                                0xA62A4A56,
                                0x3F3125F9,
                                0x5EF47E1C,
                                0x9029317C,
                                0xFDF8E802,
                                0x04272F70,
                                0x80BB155C,
                                0x05282CE3,
                                0x95C11548,
                                0xE4C66D22,
                                0x48C1133F,
                                0xC70F86DC,
                                0x07F9C9EE,
                                0x41041F0F,
                                0x404779A4,
                                0x5D886E17,
                                0x325F51EB,
                                0xD59BC0D1,
                                0xF2BCC18F,
                                0x41113564,
                                0x257B7834,
                                0x602A9C60,
                                0xDFF8E8A3,
                                0x1F636C1B,
                                0x0E12B4C2,
                                0x02E1329E,
                                0xAF664FD1,
                                0xCAD18115,
                                0x6B2395E0,
                                0x333E92E1,
                                0x3B240B62,
                                0xEEBEB922,
                                0x85B2A20E,
                                0xE6BA0D99,
                                0xDE720C8C,
                                0x2DA2F728,
                                0xD0127845,
                                0x95B794FD,
                                0x647D0862,
                                0xE7CCF5F0,
                                0x5449A36F,
                                0x877D48FA,
                                0xC39DFD27,
                                0xF33E8D1E,
                                0x0A476341,
                                0x992EFF74,
                                0x3A6F6EAB,
                                0xF4F8FD37,
                                0xA812DC60,
                                0xA1EBDDF8,
                                0x991BE14C,
                                0xDB6E6B0D,
                                0xC67B5510,
                                0x6D672C37,
                                0x2765D43B,
                                0xDCD0E804,
                                0xF1290DC7,
                                0xCC00FFA3,
                                0xB5390F92,
                                0x690FED0B,
                                0x667B9FFB,
                                0xCEDB7D9C,
                                0xA091CF0B,
                                0xD9155EA3,
                                0xBB132F88,
                                0x515BAD24,
                                0x7B9479BF,
                                0x763BD6EB,
                                0x37392EB3,
                                0xCC115979,
                                0x8026E297,
                                0xF42E312D,
                                0x6842ADA7,
                                0xC66A2B3B,
                                0x12754CCC,
                                0x782EF11C,
                                0x6A124237,
                                0xB79251E7,
                                0x06A1BBE6,
                                0x4BFB6350,
                                0x1A6B1018,
                                0x11CAEDFA,
                                0x3D25BDD8,
                                0xE2E1C3C9,
                                0x44421659,
                                0x0A121386,
                                0xD90CEC6E,
                                0xD5ABEA2A,
                                0x64AF674E,
                                0xDA86A85F,
                                0xBEBFE988,
                                0x64E4C3FE,
                                0x9DBC8057,
                                0xF0F7C086,
                                0x60787BF8,
                                0x6003604D,
                                0xD1FD8346,
                                0xF6381FB0,
                                0x7745AE04,
                                0xD736FCCC,
                                0x83426B33,
                                0xF01EAB71,
                                0xB0804187,
                                0x3C005E5F,
                                0x77A057BE,
                                0xBDE8AE24,
                                0x55464299,
                                0xBF582E61,
                                0x4E58F48F,
                                0xF2DDFDA2,
                                0xF474EF38,
                                0x8789BDC2,
                                0x5366F9C3,
                                0xC8B38E74,
                                0xB475F255,
                                0x46FCD9B9,
                                0x7AEB2661,
                                0x8B1DDF84,
                                0x846A0E79,
                                0x915F95E2,
                                0x466E598E,
                                0x20B45770,
                                0x8CD55591,
                                0xC902DE4C,
                                0xB90BACE1,
                                0xBB8205D0,
                                0x11A86248,
                                0x7574A99E,
                                0xB77F19B6,
                                0xE0A9DC09,
                                0x662D09A1,
                                0xC4324633,
                                0xE85A1F02,
                                0x09F0BE8C,
                                0x4A99A025,
                                0x1D6EFE10,
                                0x1AB93D1D,
                                0x0BA5A4DF,
                                0xA186F20F,
                                0x2868F169,
                                0xDCB7DA83,
                                0x573906FE,
                                0xA1E2CE9B,
                                0x4FCD7F52,
                                0x50115E01,
                                0xA70683FA,
                                0xA002B5C4,
                                0x0DE6D027,
                                0x9AF88C27,
                                0x773F8641,
                                0xC3604C06,
                                0x61A806B5,
                                0xF0177A28,
                                0xC0F586E0,
                                0x006058AA,
                                0x30DC7D62,
                                0x11E69ED7,
                                0x2338EA63,
                                0x53C2DD94,
                                0xC2C21634,
                                0xBBCBEE56,
                                0x90BCB6DE,
                                0xEBFC7DA1,
                                0xCE591D76,
                                0x6F05E409,
                                0x4B7C0188,
                                0x39720A3D,
                                0x7C927C24,
                                0x86E3725F,
                                0x724D9DB9,
                                0x1AC15BB4,
                                0xD39EB8FC,
                                0xED545578,
                                0x08FCA5B5,
                                0xD83D7CD3,
                                0x4DAD0FC4,
                                0x1E50EF5E,
                                0xB161E6F8,
                                0xA28514D9,
                                0x6C51133C,
                                0x6FD5C7E7,
                                0x56E14EC4,
                                0x362ABFCE,
                                0xDDC6C837,
                                0xD79A3234,
                                0x92638212,
                                0x670EFA8E,
                                0x406000E0
                            ],
                            [
                                0x3A39CE37,
                                0xD3FAF5CF,
                                0xABC27737,
                                0x5AC52D1B,
                                0x5CB0679E,
                                0x4FA33742,
                                0xD3822740,
                                0x99BC9BBE,
                                0xD5118E9D,
                                0xBF0F7315,
                                0xD62D1C7E,
                                0xC700C47B,
                                0xB78C1B6B,
                                0x21A19045,
                                0xB26EB1BE,
                                0x6A366EB4,
                                0x5748AB2F,
                                0xBC946E79,
                                0xC6A376D2,
                                0x6549C2C8,
                                0x530FF8EE,
                                0x468DDE7D,
                                0xD5730A1D,
                                0x4CD04DC6,
                                0x2939BBDB,
                                0xA9BA4650,
                                0xAC9526E8,
                                0xBE5EE304,
                                0xA1FAD5F0,
                                0x6A2D519A,
                                0x63EF8CE2,
                                0x9A86EE22,
                                0xC089C2B8,
                                0x43242EF6,
                                0xA51E03AA,
                                0x9CF2D0A4,
                                0x83C061BA,
                                0x9BE96A4D,
                                0x8FE51550,
                                0xBA645BD6,
                                0x2826A2F9,
                                0xA73A3AE1,
                                0x4BA99586,
                                0xEF5562E9,
                                0xC72FEFD3,
                                0xF752F7DA,
                                0x3F046F69,
                                0x77FA0A59,
                                0x80E4A915,
                                0x87B08601,
                                0x9B09E6AD,
                                0x3B3EE593,
                                0xE990FD5A,
                                0x9E34D797,
                                0x2CF0B7D9,
                                0x022B8B51,
                                0x96D5AC3A,
                                0x017DA67D,
                                0xD1CF3ED6,
                                0x7C7D2D28,
                                0x1F9F25CF,
                                0xADF2B89B,
                                0x5AD6B472,
                                0x5A88F54C,
                                0xE029AC71,
                                0xE019A5E6,
                                0x47B0ACFD,
                                0xED93FA9B,
                                0xE8D3C48D,
                                0x283B57CC,
                                0xF8D56629,
                                0x79132E28,
                                0x785F0191,
                                0xED756055,
                                0xF7960E44,
                                0xE3D35E8C,
                                0x15056DD4,
                                0x88F46DBA,
                                0x03A16125,
                                0x0564F0BD,
                                0xC3EB9E15,
                                0x3C9057A2,
                                0x97271AEC,
                                0xA93A072A,
                                0x1B3F6D9B,
                                0x1E6321F5,
                                0xF59C66FB,
                                0x26DCF319,
                                0x7533D928,
                                0xB155FDF5,
                                0x03563482,
                                0x8ABA3CBB,
                                0x28517711,
                                0xC20AD9F8,
                                0xABCC5167,
                                0xCCAD925F,
                                0x4DE81751,
                                0x3830DC8E,
                                0x379D5862,
                                0x9320F991,
                                0xEA7A90C2,
                                0xFB3E7BCE,
                                0x5121CE64,
                                0x774FBE32,
                                0xA8B6E37E,
                                0xC3293D46,
                                0x48DE5369,
                                0x6413E680,
                                0xA2AE0810,
                                0xDD6DB224,
                                0x69852DFD,
                                0x09072166,
                                0xB39A460A,
                                0x6445C0DD,
                                0x586CDECF,
                                0x1C20C8AE,
                                0x5BBEF7DD,
                                0x1B588D40,
                                0xCCD2017F,
                                0x6BB4E3BB,
                                0xDDA26A7E,
                                0x3A59FF45,
                                0x3E350A44,
                                0xBCB4CDD5,
                                0x72EACEA8,
                                0xFA6484BB,
                                0x8D6612AE,
                                0xBF3C6F47,
                                0xD29BE463,
                                0x542F5D9E,
                                0xAEC2771B,
                                0xF64E6370,
                                0x740E0D8D,
                                0xE75B1357,
                                0xF8721671,
                                0xAF537D5D,
                                0x4040CB08,
                                0x4EB4E2CC,
                                0x34D2466A,
                                0x0115AF84,
                                0xE1B00428,
                                0x95983A1D,
                                0x06B89FB4,
                                0xCE6EA048,
                                0x6F3F3B82,
                                0x3520AB82,
                                0x011A1D4B,
                                0x277227F8,
                                0x611560B1,
                                0xE7933FDC,
                                0xBB3A792B,
                                0x344525BD,
                                0xA08839E1,
                                0x51CE794B,
                                0x2F32C9B7,
                                0xA01FBAC9,
                                0xE01CC87E,
                                0xBCC7D1F6,
                                0xCF0111C3,
                                0xA1E8AAC7,
                                0x1A908749,
                                0xD44FBD9A,
                                0xD0DADECB,
                                0xD50ADA38,
                                0x0339C32A,
                                0xC6913667,
                                0x8DF9317C,
                                0xE0B12B4F,
                                0xF79E59B7,
                                0x43F5BB3A,
                                0xF2D519FF,
                                0x27D9459C,
                                0xBF97222C,
                                0x15E6FC2A,
                                0x0F91FC71,
                                0x9B941525,
                                0xFAE59361,
                                0xCEB69CEB,
                                0xC2A86459,
                                0x12BAA8D1,
                                0xB6C1075E,
                                0xE3056A0C,
                                0x10D25065,
                                0xCB03A442,
                                0xE0EC6E0E,
                                0x1698DB3B,
                                0x4C98A0BE,
                                0x3278E964,
                                0x9F1F9532,
                                0xE0D392DF,
                                0xD3A0342B,
                                0x8971F21E,
                                0x1B0A7441,
                                0x4BA3348C,
                                0xC5BE7120,
                                0xC37632D8,
                                0xDF359F8D,
                                0x9B992F2E,
                                0xE60B6F47,
                                0x0FE3F11D,
                                0xE54CDA54,
                                0x1EDAD891,
                                0xCE6279CF,
                                0xCD3E7E6F,
                                0x1618B166,
                                0xFD2C1D05,
                                0x848FD2C5,
                                0xF6FB2299,
                                0xF523F357,
                                0xA6327623,
                                0x93A83531,
                                0x56CCCD02,
                                0xACF08162,
                                0x5A75EBB5,
                                0x6E163697,
                                0x88D273CC,
                                0xDE966292,
                                0x81B949D0,
                                0x4C50901B,
                                0x71C65614,
                                0xE6C6C7BD,
                                0x327A140A,
                                0x45E1D006,
                                0xC3F27B9A,
                                0xC9AA53FD,
                                0x62A80F00,
                                0xBB25BFE2,
                                0x35BDD2F6,
                                0x71126905,
                                0xB2040222,
                                0xB6CBCF7C,
                                0xCD769C2B,
                                0x53113EC0,
                                0x1640E3D3,
                                0x38ABBD60,
                                0x2547ADF0,
                                0xBA38209C,
                                0xF746CE76,
                                0x77AFA1C5,
                                0x20756060,
                                0x85CBFE4E,
                                0x8AE88DD8,
                                0x7AAAF9B0,
                                0x4CF9AA7E,
                                0x1948C25C,
                                0x02FB8A8C,
                                0x01C36AE4,
                                0xD6EBE1F9,
                                0x90D4F869,
                                0xA65CDEA0,
                                0x3F09252D,
                                0xC208E69F,
                                0xB74E6132,
                                0xCE77E25B,
                                0x578FDFE3,
                                0x3AC372E6
                            ]
                        ];
                        var BLOWFISH_CTX = {
                            pbox: [],
                            sbox: []
                        };
                        function F(ctx, x) {
                            var a = x >> 24 & 0xFF;
                            var b = x >> 16 & 0xFF;
                            var c = x >> 8 & 0xFF;
                            var d = x & 0xFF;
                            var y = ctx.sbox[0][a] + ctx.sbox[1][b];
                            y = y ^ ctx.sbox[2][c];
                            y = y + ctx.sbox[3][d];
                            return y;
                        }
                        function BlowFish_Encrypt(ctx, left, right) {
                            var Xl = left;
                            var Xr = right;
                            var temp;
                            for(var i = 0; i < N; ++i){
                                Xl = Xl ^ ctx.pbox[i];
                                Xr = F(ctx, Xl) ^ Xr;
                                temp = Xl;
                                Xl = Xr;
                                Xr = temp;
                            }
                            temp = Xl;
                            Xl = Xr;
                            Xr = temp;
                            Xr = Xr ^ ctx.pbox[N];
                            Xl = Xl ^ ctx.pbox[N + 1];
                            return {
                                left: Xl,
                                right: Xr
                            };
                        }
                        function BlowFish_Decrypt(ctx, left, right) {
                            var Xl = left;
                            var Xr = right;
                            var temp;
                            for(var i = N + 1; i > 1; --i){
                                Xl = Xl ^ ctx.pbox[i];
                                Xr = F(ctx, Xl) ^ Xr;
                                temp = Xl;
                                Xl = Xr;
                                Xr = temp;
                            }
                            temp = Xl;
                            Xl = Xr;
                            Xr = temp;
                            Xr = Xr ^ ctx.pbox[1];
                            Xl = Xl ^ ctx.pbox[0];
                            return {
                                left: Xl,
                                right: Xr
                            };
                        }
                        /**
     * Initialization ctx's pbox and sbox.
     *
     * @param {Object} ctx The object has pbox and sbox.
     * @param {Array} key An array of 32-bit words.
     * @param {int} keysize The length of the key.
     *
     * @example
     *
     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
     */ function BlowFishInit(ctx, key, keysize) {
                            for(var Row = 0; Row < 4; Row++){
                                ctx.sbox[Row] = [];
                                for(var Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
                            }
                            var keyIndex = 0;
                            for(var index = 0; index < N + 2; index++){
                                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                                keyIndex++;
                                if (keyIndex >= keysize) keyIndex = 0;
                            }
                            var Data1 = 0;
                            var Data2 = 0;
                            var res = 0;
                            for(var i = 0; i < N + 2; i += 2){
                                res = BlowFish_Encrypt(ctx, Data1, Data2);
                                Data1 = res.left;
                                Data2 = res.right;
                                ctx.pbox[i] = Data1;
                                ctx.pbox[i + 1] = Data2;
                            }
                            for(var _i = 0; _i < 4; _i++)for(var j = 0; j < 256; j += 2){
                                res = BlowFish_Encrypt(ctx, Data1, Data2);
                                Data1 = res.left;
                                Data2 = res.right;
                                ctx.sbox[_i][j] = Data1;
                                ctx.sbox[_i][j + 1] = Data2;
                            }
                            return true;
                        }
                        /**
     * Blowfish block cipher algorithm.
     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
                            _doReset: function _doReset() {
                                // Skip reset of nRounds has been set before and key did not change
                                if (this._keyPriorReset === this._key) return;
                                // Shortcuts
                                var key = this._keyPriorReset = this._key;
                                var keyWords = key.words;
                                var keySize = key.sigBytes / 4;
                                //Initialization pbox and sbox
                                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
                            },
                            encryptBlock: function encryptBlock(M, offset) {
                                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                                M[offset] = res.left;
                                M[offset + 1] = res.right;
                            },
                            decryptBlock: function decryptBlock(M, offset) {
                                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                                M[offset] = res.left;
                                M[offset + 1] = res.right;
                            },
                            blockSize: 2,
                            keySize: 4,
                            ivSize: 2
                        });
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
                    })();
                    return CryptoJS.Blowfish;
                });
            /***/ },
            /***/ 73663: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var uncurryThis = __webpack_require__(38347);
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $ArrayCopyWithin = __webpack_require__(92642);
                var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.copyWithin` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
                exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */ ) {
                    return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
                });
            /***/ },
            /***/ 73751: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var ___EXPOSE_LOADER_IMPORT___ = __webpack_require__(45314);
                var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = __webpack_require__(72022);
                var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
                if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["pdfMake"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["pdfMake"] = ___EXPOSE_LOADER_IMPORT___;
                module1.exports = ___EXPOSE_LOADER_IMPORT___;
            /***/ },
            /***/ 73844: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // `Symbol.prototype.description` getter
                // https://tc39.es/ecma262/#sec-symbol.prototype.description
                var $ = __webpack_require__(56475);
                var DESCRIPTORS = __webpack_require__(15567);
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var hasOwn = __webpack_require__(20340);
                var isCallable = __webpack_require__(94578);
                var isPrototypeOf = __webpack_require__(70176);
                var toString = __webpack_require__(25096);
                var defineProperty = __webpack_require__(95892).f;
                var copyConstructorProperties = __webpack_require__(2675);
                var NativeSymbol = global.Symbol;
                var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
                if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) || // Safari 12 bug
                NativeSymbol().description !== undefined)) {
                    var EmptyStringDescriptionStore = {};
                    // wrap Symbol constructor for correct work with undefined description
                    var SymbolWrapper = function Symbol1() {
                        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
                        var result = isPrototypeOf(SymbolPrototype, this) ? new NativeSymbol(description) : description === undefined ? NativeSymbol() : NativeSymbol(description);
                        if (description === '') EmptyStringDescriptionStore[result] = true;
                        return result;
                    };
                    copyConstructorProperties(SymbolWrapper, NativeSymbol);
                    SymbolWrapper.prototype = SymbolPrototype;
                    SymbolPrototype.constructor = SymbolWrapper;
                    var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
                    var symbolToString = uncurryThis(SymbolPrototype.toString);
                    var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
                    var regexp = /^Symbol\((.*)\)[^)]+$/;
                    var replace = uncurryThis(''.replace);
                    var stringSlice = uncurryThis(''.slice);
                    defineProperty(SymbolPrototype, 'description', {
                        configurable: true,
                        get: function description() {
                            var symbol = symbolValueOf(this);
                            var string = symbolToString(symbol);
                            if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
                            var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
                            return desc === '' ? undefined : desc;
                        }
                    });
                    $({
                        global: true,
                        forced: true
                    }, {
                        Symbol: SymbolWrapper
                    });
                }
            /***/ },
            /***/ 73948: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(14032);
                __webpack_require__(57114);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    (function(undefined1) {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var CipherParams = C_lib.CipherParams;
                        var C_enc = C.enc;
                        var Hex = C_enc.Hex;
                        var C_format = C.format;
                        var HexFormatter = C_format.Hex = {
                            /**
       * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
       *
       * @param {CipherParams} cipherParams The cipher params object.
       *
       * @return {string} The hexadecimally encoded string.
       *
       * @static
       *
       * @example
       *
       *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
       */ stringify: function stringify(cipherParams) {
                                return cipherParams.ciphertext.toString(Hex);
                            },
                            /**
       * Converts a hexadecimally encoded ciphertext string to a cipher params object.
       *
       * @param {string} input The hexadecimally encoded string.
       *
       * @return {CipherParams} The cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
       */ parse: function parse(input) {
                                var ciphertext = Hex.parse(input);
                                return CipherParams.create({
                                    ciphertext: ciphertext
                                });
                            }
                        };
                    })();
                    return CryptoJS.format.Hex;
                });
            /***/ },
            /***/ 74202: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(32010);
                var apply = __webpack_require__(58448);
                var ArrayBufferViewCore = __webpack_require__(59754);
                var fails = __webpack_require__(47044);
                var arraySlice = __webpack_require__(73163);
                var Int8Array1 = global.Int8Array;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var $toLocaleString = [].toLocaleString;
                // iOS Safari 6.x fails here
                var TO_LOCALE_STRING_BUG = !!Int8Array1 && fails(function() {
                    $toLocaleString.call(new Int8Array1(1));
                });
                var FORCED = fails(function() {
                    return [
                        1,
                        2
                    ].toLocaleString() != new Int8Array1([
                        1,
                        2
                    ]).toLocaleString();
                }) || !fails(function() {
                    Int8Array1.prototype.toLocaleString.call([
                        1,
                        2
                    ]);
                });
                // `%TypedArray%.prototype.toLocaleString` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
                exportTypedArrayMethod('toLocaleString', function toLocaleString() {
                    return apply($toLocaleString, TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this), arraySlice(arguments));
                }, FORCED);
            /***/ },
            /***/ 74488: /***/ function(module1) {
                "use strict";
                module1.exports = /*#__PURE__*/ JSON.parse('[["0","\\u0000",127,"\u20AC"],["8140","\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A",5,"\u4E72\u4E74",9,"\u4E7F",6,"\u4E87\u4E8A"],["8180","\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02",6,"\u4F0B\u4F0C\u4F12",4,"\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E",4,"\u4F44\u4F45\u4F47",5,"\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2"],["8240","\u4FA4\u4FAB\u4FAD\u4FB0",4,"\u4FB6",8,"\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2",4,"\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF",11],["8280","\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F",10,"\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050",4,"\u5056\u5057\u5058\u5059\u505B\u505D",7,"\u5066",5,"\u506D",8,"\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E",20,"\u50A4\u50A6\u50AA\u50AB\u50AD",4,"\u50B3",6,"\u50BC"],["8340","\u50BD",17,"\u50D0",5,"\u50D7\u50D8\u50D9\u50DB",10,"\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6",4,"\u50FC",9,"\u5108"],["8380","\u5109\u510A\u510C",5,"\u5113",13,"\u5122",28,"\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D",4,"\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6",4,"\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2",5],["8440","\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5",5,"\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244",5,"\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258"],["8480","\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273",9,"\u527E\u5280\u5283",4,"\u5289",6,"\u5291\u5292\u5294",6,"\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4",9,"\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9",5,"\u52E0\u52E1\u52E2\u52E3\u52E5",10,"\u52F1",7,"\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E"],["8540","\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F",9,"\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F"],["8580","\u5390",4,"\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF",6,"\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3",4,"\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D",4,"\u5463\u5465\u5467\u5469",7,"\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1"],["8640","\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0",4,"\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4",5,"\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A",4,"\u5512\u5513\u5515",5,"\u551C\u551D\u551E\u551F\u5521\u5525\u5526"],["8680","\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B",4,"\u5551\u5552\u5553\u5554\u5557",4,"\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F",5,"\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0",6,"\u55A8",8,"\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF",4,"\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7",4,"\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8",4,"\u55FF\u5602\u5603\u5604\u5605"],["8740","\u5606\u5607\u560A\u560B\u560D\u5610",7,"\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640",11,"\u564F",4,"\u5655\u5656\u565A\u565B\u565D",4],["8780","\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D",7,"\u5687",6,"\u5690\u5691\u5692\u5694",14,"\u56A4",10,"\u56B0",6,"\u56B8\u56B9\u56BA\u56BB\u56BD",12,"\u56CB",8,"\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5",5,"\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B",6],["8840","\u5712",9,"\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734",4,"\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752",4,"\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780"],["8880","\u5781\u5787\u5788\u5789\u578A\u578D",4,"\u5794",6,"\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9",8,"\u57C4",6,"\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5",7,"\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825",4,"\u582B",4,"\u5831\u5832\u5833\u5834\u5836",7],["8940","\u583E",5,"\u5845",6,"\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859",4,"\u585F",5,"\u5866",4,"\u586D",16,"\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C"],["8980","\u588D",4,"\u5894",4,"\u589B\u589C\u589D\u58A0",7,"\u58AA",17,"\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6",10,"\u58D2\u58D3\u58D4\u58D6",13,"\u58E5",5,"\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA",7,"\u5903\u5905\u5906\u5908",4,"\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B"],["8a40","\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B",4,"\u5961\u5963\u5964\u5966",12,"\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6"],["8a80","\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3",5,"\u59BA\u59BC\u59BD\u59BF",6,"\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE",4,"\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED",11,"\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A",6,"\u5A33\u5A35\u5A37",4,"\u5A3D\u5A3E\u5A3F\u5A41",4,"\u5A47\u5A48\u5A4B",9,"\u5A56\u5A57\u5A58\u5A59\u5A5B",5],["8b40","\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B",8,"\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80",17,"\u5A93",6,"\u5A9C",13,"\u5AAB\u5AAC"],["8b80","\u5AAD",4,"\u5AB4\u5AB6\u5AB7\u5AB9",4,"\u5ABF\u5AC0\u5AC3",5,"\u5ACA\u5ACB\u5ACD",4,"\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC",4,"\u5AF2",22,"\u5B0A",11,"\u5B18",25,"\u5B33\u5B35\u5B36\u5B38",7,"\u5B41",6],["8c40","\u5B48",7,"\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF"],["8c80","\u5BD1\u5BD4",8,"\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9",4,"\u5BEF\u5BF1",6,"\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67",6,"\u5C70\u5C72",6,"\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83",4,"\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D",4,"\u5CA4",4],["8d40","\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5",5,"\u5CCC",5,"\u5CD3",5,"\u5CDA",6,"\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1",9,"\u5CFC",4],["8d80","\u5D01\u5D04\u5D05\u5D08",5,"\u5D0F",4,"\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F",4,"\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F",4,"\u5D35",7,"\u5D3F",7,"\u5D48\u5D49\u5D4D",10,"\u5D59\u5D5A\u5D5C\u5D5E",10,"\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75",12,"\u5D83",21,"\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0"],["8e40","\u5DA1",21,"\u5DB8",12,"\u5DC6",6,"\u5DCE",12,"\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED"],["8e80","\u5DF0\u5DF5\u5DF6\u5DF8",4,"\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E",7,"\u5E28",4,"\u5E2F\u5E30\u5E32",4,"\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46",5,"\u5E4D",6,"\u5E56",4,"\u5E5C\u5E5D\u5E5F\u5E60\u5E63",14,"\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8",4,"\u5EAE",4,"\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF",6],["8f40","\u5EC6\u5EC7\u5EC8\u5ECB",5,"\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC",11,"\u5EE9\u5EEB",8,"\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24"],["8f80","\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32",6,"\u5F3B\u5F3D\u5F3E\u5F3F\u5F41",14,"\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2",5,"\u5FA9\u5FAB\u5FAC\u5FAF",5,"\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE",4,"\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007"],["9040","\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030",4,"\u6036",4,"\u603D\u603E\u6040\u6044",6,"\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080"],["9080","\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD",7,"\u60C7\u60C8\u60C9\u60CC",4,"\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1",4,"\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB",4,"\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110",4,"\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C",18,"\u6140",6],["9140","\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156",6,"\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169",6,"\u6171\u6172\u6173\u6174\u6176\u6178",18,"\u618C\u618D\u618F",4,"\u6195"],["9180","\u6196",6,"\u619E",8,"\u61AA\u61AB\u61AD",9,"\u61B8",5,"\u61BF\u61C0\u61C1\u61C3",4,"\u61C9\u61CC",4,"\u61D3\u61D5",16,"\u61E7",13,"\u61F6",8,"\u6200",5,"\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238",4,"\u6242\u6244\u6245\u6246\u624A"],["9240","\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C",6,"\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B",5,"\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1"],["9280","\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333",5,"\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356",7,"\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399",6,"\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0"],["9340","\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7",6,"\u63DF\u63E2\u63E4",4,"\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406",4,"\u640D\u640E\u6411\u6412\u6415",5,"\u641D\u641F\u6422\u6423\u6424"],["9380","\u6425\u6427\u6428\u6429\u642B\u642E",5,"\u6435",4,"\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B",6,"\u6453\u6455\u6456\u6457\u6459",4,"\u645F",7,"\u6468\u646A\u646B\u646C\u646E",9,"\u647B",6,"\u6483\u6486\u6488",8,"\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F",4,"\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6",6,"\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA"],["9440","\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7",24,"\u6501",7,"\u650A",7,"\u6513",4,"\u6519",8],["9480","\u6522\u6523\u6524\u6526",4,"\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540",4,"\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578",14,"\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1",7,"\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8",7,"\u65E1\u65E3\u65E4\u65EA\u65EB"],["9540","\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB",4,"\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637",4,"\u663D\u663F\u6640\u6642\u6644",6,"\u664D\u664E\u6650\u6651\u6658"],["9580","\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669",4,"\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698",4,"\u669E",8,"\u66A9",4,"\u66AF",4,"\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF",25,"\u66DA\u66DE",7,"\u66E7\u66E8\u66EA",5,"\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703"],["9640","\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720",5,"\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757",4,"\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776"],["9680","\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9",7,"\u67C2\u67C5",9,"\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5",7,"\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818",4,"\u681E\u681F\u6820\u6822",6,"\u682B",6,"\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856",5],["9740","\u685C\u685D\u685E\u685F\u686A\u686C",7,"\u6875\u6878",8,"\u6882\u6884\u6887",7,"\u6890\u6891\u6892\u6894\u6895\u6896\u6898",9,"\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8"],["9780","\u68B9",6,"\u68C1\u68C3",5,"\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB",4,"\u68E1\u68E2\u68E4",9,"\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906",4,"\u690C\u690F\u6911\u6913",11,"\u6921\u6922\u6923\u6925",7,"\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943",16,"\u6955\u6956\u6958\u6959\u695B\u695C\u695F"],["9840","\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972",4,"\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E",5,"\u6996\u6997\u6999\u699A\u699D",9,"\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD"],["9880","\u69BE\u69BF\u69C0\u69C2",7,"\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5",5,"\u69DC\u69DD\u69DE\u69E1",11,"\u69EE\u69EF\u69F0\u69F1\u69F3",9,"\u69FE\u6A00",9,"\u6A0B",11,"\u6A19",5,"\u6A20\u6A22",5,"\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36",6,"\u6A3F",4,"\u6A45\u6A46\u6A48",7,"\u6A51",6,"\u6A5A"],["9940","\u6A5C",4,"\u6A62\u6A63\u6A64\u6A66",10,"\u6A72",6,"\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85",8,"\u6A8F\u6A92",4,"\u6A98",7,"\u6AA1",5],["9980","\u6AA7\u6AA8\u6AAA\u6AAD",114,"\u6B25\u6B26\u6B28",6],["9a40","\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D",11,"\u6B5A",7,"\u6B68\u6B69\u6B6B",13,"\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88"],["9a80","\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C",4,"\u6BA2",7,"\u6BAB",7,"\u6BB6\u6BB8",6,"\u6BC0\u6BC3\u6BC4\u6BC6",4,"\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC",4,"\u6BE2",7,"\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE",6,"\u6C08",4,"\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B",4,"\u6C51\u6C52\u6C53\u6C56\u6C58"],["9b40","\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B",4,"\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8"],["9b80","\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F",5,"\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D",4,"\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96",4,"\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9",5,"\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA"],["9c40","\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD",7,"\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35"],["9c80","\u6E36\u6E37\u6E39\u6E3B",7,"\u6E45",7,"\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60",10,"\u6E6C\u6E6D\u6E6F",14,"\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A",4,"\u6E91",6,"\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA",5],["9d40","\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA",7,"\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A",4,"\u6F10\u6F11\u6F12\u6F16",9,"\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37",6,"\u6F3F\u6F40\u6F41\u6F42"],["9d80","\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E",9,"\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67",5,"\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D",6,"\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F",12,"\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2",4,"\u6FA8",10,"\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA",5,"\u6FC1\u6FC3",5,"\u6FCA",6,"\u6FD3",10,"\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5"],["9e40","\u6FE6",7,"\u6FF0",32,"\u7012",7,"\u701C",6,"\u7024",6],["9e80","\u702B",9,"\u7036\u7037\u7038\u703A",17,"\u704D\u704E\u7050",13,"\u705F",11,"\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E",12,"\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB",12,"\u70DA"],["9f40","\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0",6,"\u70F8\u70FA\u70FB\u70FC\u70FE",10,"\u710B",4,"\u7111\u7112\u7114\u7117\u711B",10,"\u7127",7,"\u7132\u7133\u7134"],["9f80","\u7135\u7137",13,"\u7146\u7147\u7148\u7149\u714B\u714D\u714F",12,"\u715D\u715F",4,"\u7165\u7169",4,"\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E",5,"\u7185",4,"\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A",4,"\u71A1",6,"\u71A9\u71AA\u71AB\u71AD",5,"\u71B4\u71B6\u71B7\u71B8\u71BA",8,"\u71C4",9,"\u71CF",4],["a040","\u71D6",9,"\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8",5,"\u71EF",9,"\u71FA",11,"\u7207",19],["a080","\u721B\u721C\u721E",9,"\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240",6,"\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285",4,"\u728C\u728E\u7290\u7291\u7293",11,"\u72A0",11,"\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA",6,"\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB"],["a1a1","\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008",7,"\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013"],["a2a1","\u2170",9],["a2b1","\u2488",19,"\u2474",19,"\u2460",9],["a2e5","\u3220",9],["a2f1","\u2160",11],["a3a1","\uFF01\uFF02\uFF03\uFFE5\uFF05",88,"\uFFE3"],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a6e0","\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44"],["a6ee","\uFE3B\uFE3C\uFE37\uFE38\uFE31"],["a6f4","\uFE33\uFE34"],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a840","\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550",35,"\u2581",6],["a880","\u2588",7,"\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E"],["a8a1","\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251"],["a8bd","\u0144\u0148"],["a8c0","\u0261"],["a8c5","\u3105",36],["a940","\u3021",8,"\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4"],["a959","\u2121\u3231"],["a95c","\u2010"],["a960","\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49",9,"\uFE54\uFE55\uFE56\uFE57\uFE59",8],["a980","\uFE62",4,"\uFE68\uFE69\uFE6A\uFE6B"],["a996","\u3007"],["a9a4","\u2500",75],["aa40","\u72DC\u72DD\u72DF\u72E2",5,"\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304",5,"\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340",8],["aa80","\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358",7,"\u7361",10,"\u736E\u7370\u7371"],["ab40","\u7372",11,"\u737F",4,"\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3",5,"\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3",4],["ab80","\u73CB\u73CC\u73CE\u73D2",6,"\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3",4],["ac40","\u73F8",10,"\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411",8,"\u741C",5,"\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437",4,"\u743D\u743E\u743F\u7440\u7442",11],["ac80","\u744E",6,"\u7456\u7458\u745D\u7460",12,"\u746E\u746F\u7471",4,"\u7478\u7479\u747A"],["ad40","\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491",10,"\u749D\u749F",7,"\u74AA",15,"\u74BB",12],["ad80","\u74C8",9,"\u74D3",8,"\u74DD\u74DF\u74E1\u74E5\u74E7",6,"\u74F0\u74F1\u74F2"],["ae40","\u74F3\u74F5\u74F8",6,"\u7500\u7501\u7502\u7503\u7505",7,"\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520",4,"\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558"],["ae80","\u755D",7,"\u7567\u7568\u7569\u756B",6,"\u7573\u7575\u7576\u7577\u757A",4,"\u7580\u7581\u7582\u7584\u7585\u7587"],["af40","\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6",4,"\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607"],["af80","\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644"],["b040","\u7645",6,"\u764E",5,"\u7655\u7657",4,"\u765D\u765F\u7660\u7661\u7662\u7664",6,"\u766C\u766D\u766E\u7670",7,"\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B"],["b080","\u769C",7,"\u76A5",8,"\u76AF\u76B0\u76B3\u76B5",9,"\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265"],["b140","\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0",4,"\u76E6",7,"\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E",10,"\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B"],["b180","\u772C\u772E\u7730",4,"\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748",7,"\u7752",7,"\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3"],["b240","\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D",11,"\u777A\u777B\u777C\u7781\u7782\u7783\u7786",5,"\u778F\u7790\u7793",11,"\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6",4],["b280","\u77BC\u77BE\u77C0",12,"\u77CE",8,"\u77D8\u77D9\u77DA\u77DD",4,"\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316"],["b340","\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803",5,"\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A"],["b380","\u785B\u785C\u785E",11,"\u786F",7,"\u7878\u7879\u787A\u787B\u787D",6,"\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A"],["b440","\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8",7,"\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA",9],["b480","\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED",4,"\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB",5,"\u7902\u7903\u7904\u7906",6,"\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E"],["b540","\u790D",5,"\u7914",9,"\u791F",4,"\u7925",14,"\u7935",4,"\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A",8,"\u7954\u7955\u7958\u7959\u7961\u7963"],["b580","\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970",6,"\u7979\u797B",4,"\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0"],["b640","\u7993",6,"\u799B",11,"\u79A8",10,"\u79B4",4,"\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9",5,"\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA"],["b680","\u79EC\u79EE\u79F1",6,"\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F",4,"\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C"],["b740","\u7A1D\u7A1F\u7A21\u7A22\u7A24",14,"\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40",5,"\u7A47",9,"\u7A52",4,"\u7A58",16],["b780","\u7A69",6,"\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D"],["b840","\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE",4,"\u7AB4",10,"\u7AC0",10,"\u7ACC",9,"\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7",5,"\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3"],["b880","\u7AF4",4,"\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9"],["b940","\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F",5,"\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63",10,"\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86",6,"\u7B8E\u7B8F"],["b980","\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9",7,"\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8"],["ba40","\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4",4,"\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2",4,"\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF",7,"\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10",5,"\u7C17\u7C18\u7C19"],["ba80","\u7C1A",4,"\u7C20",5,"\u7C28\u7C29\u7C2B",12,"\u7C39",5,"\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56"],["bb40","\u7C43",9,"\u7C4E",36,"\u7C75",5,"\u7C7E",9],["bb80","\u7C88\u7C8A",6,"\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4",4,"\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95"],["bc40","\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE",6,"\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1",6,"\u7CE9",5,"\u7CF0",7,"\u7CF9\u7CFA\u7CFC",13,"\u7D0B",5],["bc80","\u7D11",14,"\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30",6,"\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6"],["bd40","\u7D37",54,"\u7D6F",7],["bd80","\u7D78",32,"\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78"],["be40","\u7D99",12,"\u7DA7",6,"\u7DAF",42],["be80","\u7DDA",32,"\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB"],["bf40","\u7DFB",62],["bf80","\u7E3A\u7E3C",4,"\u7E42",4,"\u7E48",21,"\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080"],["c040","\u7E5E",35,"\u7E83",23,"\u7E9C\u7E9D\u7E9E"],["c080","\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B",6,"\u7F43\u7F46",9,"\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0"],["c140","\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63",4,"\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82",7,"\u7F8B\u7F8D\u7F8F",4,"\u7F95",4,"\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8",6,"\u7FB1"],["c180","\u7FB3",4,"\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF",4,"\u7FD6\u7FD7\u7FD9",5,"\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF"],["c240","\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4",6,"\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B",5,"\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057"],["c280","\u8059\u805B",13,"\u806B",5,"\u8072",11,"\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B"],["c340","\u807E\u8081\u8082\u8085\u8088\u808A\u808D",5,"\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7",4,"\u80CF",6,"\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B"],["c380","\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F",12,"\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139",4,"\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478"],["c440","\u8140",5,"\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B",4,"\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183",4,"\u8189\u818B\u818C\u818D\u818E\u8190\u8192",5,"\u8199\u819A\u819E",4,"\u81A4\u81A5"],["c480","\u81A7\u81A9\u81AB",7,"\u81B4",5,"\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD",6,"\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81"],["c540","\u81D4",14,"\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE",4,"\u81F5",5,"\u81FD\u81FF\u8203\u8207",4,"\u820E\u820F\u8211\u8213\u8215",5,"\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F"],["c580","\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250",7,"\u8259\u825B\u825C\u825D\u825E\u8260",7,"\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7"],["c640","\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8"],["c680","\u82FA\u82FC",4,"\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D",9,"\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390"],["c740","\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A",4,"\u8353\u8355",4,"\u835D\u8362\u8370",6,"\u8379\u837A\u837E",6,"\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1",6,"\u83AC\u83AD\u83AE"],["c780","\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20"],["c840","\u83EE\u83EF\u83F3",4,"\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412",5,"\u8419\u841A\u841B\u841E",5,"\u8429",7,"\u8432",5,"\u8439\u843A\u843B\u843E",7,"\u8447\u8448\u8449"],["c880","\u844A",6,"\u8452",4,"\u8458\u845D\u845E\u845F\u8460\u8462\u8464",4,"\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1"],["c940","\u847D",4,"\u8483\u8484\u8485\u8486\u848A\u848D\u848F",7,"\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2",12,"\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7"],["c980","\u84D8",4,"\u84DE\u84E1\u84E2\u84E4\u84E7",4,"\u84ED\u84EE\u84EF\u84F1",10,"\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3"],["ca40","\u8503",8,"\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522",8,"\u852D",9,"\u853E",4,"\u8544\u8545\u8546\u8547\u854B",10],["ca80","\u8557\u8558\u855A\u855B\u855C\u855D\u855F",4,"\u8565\u8566\u8567\u8569",8,"\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31"],["cb40","\u8582\u8583\u8586\u8588",6,"\u8590",10,"\u859D",6,"\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1",5,"\u85B8\u85BA",6,"\u85C2",6,"\u85CA",4,"\u85D1\u85D2"],["cb80","\u85D4\u85D6",5,"\u85DD",6,"\u85E5\u85E6\u85E7\u85E8\u85EA",14,"\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854"],["cc40","\u85F9\u85FA\u85FC\u85FD\u85FE\u8600",4,"\u8606",10,"\u8612\u8613\u8614\u8615\u8617",15,"\u8628\u862A",13,"\u8639\u863A\u863B\u863D\u863E\u863F\u8640"],["cc80","\u8641",11,"\u8652\u8653\u8655",4,"\u865B\u865C\u865D\u865F\u8660\u8661\u8663",7,"\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3"],["cd40","\u866D\u866F\u8670\u8672",6,"\u8683",6,"\u868E",4,"\u8694\u8696",5,"\u869E",4,"\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB",4,"\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC"],["cd80","\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01"],["ce40","\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740",6,"\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A",5,"\u8761\u8762\u8766",7,"\u876F\u8771\u8772\u8773\u8775"],["ce80","\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E",4,"\u8794\u8795\u8796\u8798",6,"\u87A0",4,"\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A"],["cf40","\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1",4,"\u87C7\u87C8\u87C9\u87CC",4,"\u87D4",6,"\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF",9],["cf80","\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804",5,"\u880B",7,"\u8814\u8817\u8818\u8819\u881A\u881C",4,"\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653"],["d040","\u8824",13,"\u8833",5,"\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846",5,"\u884E",5,"\u8855\u8856\u8858\u885A",6,"\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A"],["d080","\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897",4,"\u889D",4,"\u88A3\u88A5",5,"\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384"],["d140","\u88AC\u88AE\u88AF\u88B0\u88B2",4,"\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA",4,"\u88E0\u88E1\u88E6\u88E7\u88E9",6,"\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903",5],["d180","\u8909\u890B",4,"\u8911\u8914",4,"\u891C",4,"\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476"],["d240","\u8938",8,"\u8942\u8943\u8945",24,"\u8960",5,"\u8967",19,"\u897C"],["d280","\u897D\u897E\u8980\u8982\u8984\u8985\u8987",26,"\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690"],["d340","\u89A2",30,"\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4",6],["d380","\u89FB",4,"\u8A01",5,"\u8A08",21,"\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89"],["d440","\u8A1E",31,"\u8A3F",8,"\u8A49",21],["d480","\u8A5F",25,"\u8A7A",6,"\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67"],["d540","\u8A81",7,"\u8A8B",7,"\u8A94",46],["d580","\u8AC3",32,"\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F"],["d640","\u8AE4",34,"\u8B08",27],["d680","\u8B24\u8B25\u8B27",30,"\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51"],["d740","\u8B46",31,"\u8B67",4,"\u8B6D",25],["d780","\u8B87",24,"\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7"],["d840","\u8C38",8,"\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D",7,"\u8C56\u8C57\u8C58\u8C59\u8C5B",5,"\u8C63",6,"\u8C6C",6,"\u8C74\u8C75\u8C76\u8C77\u8C7B",6,"\u8C83\u8C84\u8C86\u8C87"],["d880","\u8C88\u8C8B\u8C8D",6,"\u8C95\u8C96\u8C97\u8C99",20,"\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D"],["d940","\u8CAE",62],["d980","\u8CED",32,"\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC"],["da40","\u8D0E",14,"\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78",8,"\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C",4,"\u8D92\u8D93\u8D95",9,"\u8DA0\u8DA1"],["da80","\u8DA2\u8DA4",12,"\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA"],["db40","\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE",6,"\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15",7,"\u8E20\u8E21\u8E24",4,"\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E"],["db80","\u8E3F\u8E43\u8E45\u8E46\u8E4C",4,"\u8E53",5,"\u8E5A",11,"\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD"],["dc40","\u8E73\u8E75\u8E77",4,"\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88",6,"\u8E91\u8E92\u8E93\u8E95",6,"\u8E9D\u8E9F",11,"\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3",6,"\u8EBB",7],["dc80","\u8EC3",10,"\u8ECF",21,"\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365"],["dd40","\u8EE5",62],["dd80","\u8F24",32,"\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A"],["de40","\u8F45",32,"\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6"],["de80","\u8FC9",4,"\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496"],["df40","\u9019\u901C\u9023\u9024\u9025\u9027",5,"\u9030",4,"\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048",4,"\u904E\u9054\u9055\u9056\u9059\u905A\u905C",5,"\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F",4,"\u9076",6,"\u907E\u9081"],["df80","\u9084\u9085\u9086\u9087\u9089\u908A\u908C",4,"\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C"],["e040","\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105",19,"\u911A\u911B\u911C"],["e080","\u911D\u911F\u9120\u9121\u9124",10,"\u9130\u9132",6,"\u913A",8,"\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C"],["e140","\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180",4,"\u9186\u9188\u918A\u918E\u918F\u9193",6,"\u919C",5,"\u91A4",5,"\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB"],["e180","\u91BC",10,"\u91C8\u91CB\u91D0\u91D2",9,"\u91DD",8,"\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA"],["e240","\u91E6",62],["e280","\u9225",32,"\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967",5,"\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042"],["e340","\u9246",45,"\u9275",16],["e380","\u9286",7,"\u928F",24,"\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE"],["e440","\u92A8",5,"\u92AF",24,"\u92C9",31],["e480","\u92E9",32,"\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1"],["e540","\u930A",51,"\u933F",10],["e580","\u934A",31,"\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3"],["e640","\u936C",34,"\u9390",27],["e680","\u93AC",29,"\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9"],["e740","\u93CE",7,"\u93D7",54],["e780","\u940E",32,"\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21",6,"\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F",4,"\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C"],["e840","\u942F",14,"\u943F",43,"\u946C\u946D\u946E\u946F"],["e880","\u9470",20,"\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9"],["e940","\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577",7,"\u9580",42],["e980","\u95AB",32,"\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B"],["ea40","\u95CC",27,"\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623",6,"\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657"],["ea80","\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D",4,"\u9673\u9678",12,"\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0"],["eb40","\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D",9,"\u96A8",7,"\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6",9,"\u96E1",6,"\u96EB"],["eb80","\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717",4,"\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB"],["ec40","\u9721",8,"\u972B\u972C\u972E\u972F\u9731\u9733",4,"\u973A\u973B\u973C\u973D\u973F",18,"\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A",7],["ec80","\u9772\u9775\u9777",4,"\u977D",7,"\u9786",4,"\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799",4,"\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0"],["ed40","\u979E\u979F\u97A1\u97A2\u97A4",6,"\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5",46],["ed80","\u97E4\u97E5\u97E8\u97EE",4,"\u97F4\u97F7",23,"\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768"],["ee40","\u980F",62],["ee80","\u984E",32,"\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6",4,"\u94BC\u94BD\u94BF\u94C4\u94C8",6,"\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA"],["ef40","\u986F",5,"\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8",37,"\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0",4],["ef80","\u98E5\u98E6\u98E9",30,"\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512",4,"\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564",8,"\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14"],["f040","\u9908",4,"\u990E\u990F\u9911",28,"\u992F",26],["f080","\u994A",9,"\u9956",12,"\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28",4,"\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66",6,"\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619"],["f140","\u998C\u998E\u999A",10,"\u99A6\u99A7\u99A9",47],["f180","\u99D9",32,"\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883"],["f240","\u99FA",62],["f280","\u9A39",32,"\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2"],["f340","\u9A5A",17,"\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9",6,"\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6",4,"\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC"],["f380","\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0",8,"\u9AFA\u9AFC",6,"\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B"],["f440","\u9B07\u9B09",5,"\u9B10\u9B11\u9B12\u9B14",10,"\u9B20\u9B21\u9B22\u9B24",10,"\u9B30\u9B31\u9B33",7,"\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55",5],["f480","\u9B5B",32,"\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164"],["f540","\u9B7C",62],["f580","\u9BBB",32,"\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC"],["f640","\u9BDC",62],["f680","\u9C1B",32,"\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85",5,"\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E",5,"\u9CA5",4,"\u9CAB\u9CAD\u9CAE\u9CB0",7,"\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB"],["f740","\u9C3C",62],["f780","\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE",4,"\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC",4,"\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44"],["f840","\u9CE3",62],["f880","\u9D22",32],["f940","\u9D43",62],["f980","\u9D82",32],["fa40","\u9DA3",62],["fa80","\u9DE2",32],["fb40","\u9E03",27,"\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74",9,"\u9E80"],["fb80","\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C",5,"\u9E94",8,"\u9E9E\u9EA0",5,"\u9EA7\u9EA8\u9EA9\u9EAA"],["fc40","\u9EAB",8,"\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF",4,"\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0",8,"\u9EFA\u9EFD\u9EFF",6],["fc80","\u9F06",4,"\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A",5,"\u9F21\u9F23",8,"\u9F2D\u9F2E\u9F30\u9F31"],["fd40","\u9F32",4,"\u9F38\u9F3A\u9F3C\u9F3F",4,"\u9F45",10,"\u9F52",38],["fd80","\u9F79",5,"\u9F81\u9F82\u9F8D",11,"\u9F9C\u9F9D\u9F9E\u9FA1",4,"\uF92C\uF979\uF995\uF9E7\uF9F1"],["fe40","\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29"]]');
            /***/ },
            /***/ 74516: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(15567);
                var objectDefinePropertyModule = __webpack_require__(95892);
                var regExpFlags = __webpack_require__(21182);
                var fails = __webpack_require__(47044);
                var RegExpPrototype = RegExp.prototype;
                var FORCED = DESCRIPTORS && fails(function() {
                    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                    return Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call({
                        dotAll: true,
                        sticky: true
                    }) !== 'sy';
                });
                // `RegExp.prototype.flags` getter
                // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
                if (FORCED) objectDefinePropertyModule.f(RegExpPrototype, 'flags', {
                    configurable: true,
                    get: regExpFlags
                });
            /***/ },
            /***/ 74841: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toIntegerOrInfinity = __webpack_require__(26882);
                var max = Math.max;
                var min = Math.min;
                // Helper for a popular repeating case of the spec:
                // Let integer be ? ToInteger(index).
                // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
                module1.exports = function(index, length) {
                    var integer = toIntegerOrInfinity(index);
                    return integer < 0 ? max(integer + length, 0) : min(integer, length);
                };
            /***/ },
            /***/ 74846: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var fails = __webpack_require__(47044);
                var global = __webpack_require__(32010);
                // babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
                var $RegExp = global.RegExp;
                exports.UNSUPPORTED_Y = fails(function() {
                    var re = $RegExp('a', 'y');
                    re.lastIndex = 2;
                    return re.exec('abcd') != null;
                });
                exports.BROKEN_CARET = fails(function() {
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
                    var re = $RegExp('^r', 'gy');
                    re.lastIndex = 2;
                    return re.exec('str') != null;
                });
            /***/ },
            /***/ 74878: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                (function() {
                    var sax;
                    if ((0, module1.exports) && !__webpack_require__.g.xmldocAssumeBrowser) // We're being used in a Node-like environment
                    sax = __webpack_require__(61733);
                    else {
                        // assume it's attached to the Window object in a browser
                        sax = this.sax;
                        if (!sax) // no sax for you!
                        throw new Error("Expected sax to be defined. Make sure you're including sax.js before this file.");
                    }
                    /**
   * XmlElement is our basic building block. Everything is an XmlElement; even XmlDocument
   * behaves like an XmlElement by inheriting its attributes and functions.
   */ function XmlElement(tag, parser) {
                        // If you didn't hand us a parser (common case) see if we can grab one
                        // from the current execution stack.
                        if (!parser) {
                            var delegate = delegates[delegates.length - 1];
                            if (delegate.parser) parser = delegate.parser;
                        }
                        this.name = tag.name;
                        this.attr = tag.attributes;
                        this.val = "";
                        this.children = [];
                        this.firstChild = null;
                        this.lastChild = null;
                        // Assign parse information
                        this.line = parser ? parser.line : null;
                        this.column = parser ? parser.column : null;
                        this.position = parser ? parser.position : null;
                        this.startTagPosition = parser ? parser.startTagPosition : null;
                    }
                    // Private methods
                    XmlElement.prototype._addChild = function(child) {
                        // add to our children array
                        this.children.push(child);
                        // update first/last pointers
                        if (!this.firstChild) this.firstChild = child;
                        this.lastChild = child;
                    };
                    // SaxParser handlers
                    XmlElement.prototype._opentag = function(tag) {
                        var child = new XmlElement(tag);
                        this._addChild(child);
                        delegates.unshift(child);
                    };
                    XmlElement.prototype._closetag = function() {
                        delegates.shift();
                    };
                    XmlElement.prototype._text = function(text) {
                        if (typeof this.children === "undefined") return;
                        this.val += text;
                        this._addChild(new XmlTextNode(text));
                    };
                    XmlElement.prototype._cdata = function(cdata) {
                        this.val += cdata;
                        this._addChild(new XmlCDataNode(cdata));
                    };
                    XmlElement.prototype._comment = function(comment) {
                        if (typeof this.children === "undefined") return;
                        this._addChild(new XmlCommentNode(comment));
                    };
                    XmlElement.prototype._error = function(err) {
                        throw err;
                    };
                    // Useful functions
                    XmlElement.prototype.eachChild = function(iterator, context) {
                        for(var i = 0, l = this.children.length; i < l; i++)if (this.children[i].type === "element") {
                            if (iterator.call(context, this.children[i], i, this.children) === false) return;
                        }
                    };
                    XmlElement.prototype.childNamed = function(name) {
                        for(var i = 0, l = this.children.length; i < l; i++){
                            var child = this.children[i];
                            if (child.name === name) return child;
                        }
                        return undefined;
                    };
                    XmlElement.prototype.childrenNamed = function(name) {
                        var matches = [];
                        for(var i = 0, l = this.children.length; i < l; i++)if (this.children[i].name === name) matches.push(this.children[i]);
                        return matches;
                    };
                    XmlElement.prototype.childWithAttribute = function(name, value) {
                        for(var i = 0, l = this.children.length; i < l; i++){
                            var child = this.children[i];
                            if (child.type === "element" && (value && child.attr[name] === value || !value && child.attr[name])) return child;
                        }
                        return undefined;
                    };
                    XmlElement.prototype.descendantsNamed = function(name) {
                        var matches = [];
                        for(var i = 0, l = this.children.length; i < l; i++){
                            var child = this.children[i];
                            if (child.type === "element") {
                                if (child.name === name) matches.push(child);
                                matches = matches.concat(child.descendantsNamed(name));
                            }
                        }
                        return matches;
                    };
                    XmlElement.prototype.descendantWithPath = function(path) {
                        var descendant = this;
                        var components = path.split(".");
                        for(var i = 0, l = components.length; i < l; i++)if (descendant && descendant.type === "element") descendant = descendant.childNamed(components[i]);
                        else return undefined;
                        return descendant;
                    };
                    XmlElement.prototype.valueWithPath = function(path) {
                        var components = path.split("@");
                        var descendant = this.descendantWithPath(components[0]);
                        if (descendant) return components.length > 1 ? descendant.attr[components[1]] : descendant.val;
                        else return undefined;
                    };
                    // String formatting (for debugging)
                    XmlElement.prototype.toString = function(options) {
                        return this.toStringWithIndent("", options);
                    };
                    XmlElement.prototype.toStringWithIndent = function(indent, options) {
                        var s = indent + "<" + this.name;
                        var linebreak = options && options.compressed ? "" : "\n";
                        var preserveWhitespace = options && options.preserveWhitespace;
                        for(var name in this.attr)if (Object.prototype.hasOwnProperty.call(this.attr, name)) s += " " + name + '="' + escapeXML(this.attr[name]) + '"';
                        if (this.children.length === 1 && this.children[0].type !== "element") s += ">" + this.children[0].toString(options) + "</" + this.name + ">";
                        else if (this.children.length) {
                            s += ">" + linebreak;
                            var childIndent = indent + (options && options.compressed ? "" : "  ");
                            for(var i = 0, l = this.children.length; i < l; i++)s += this.children[i].toStringWithIndent(childIndent, options) + linebreak;
                            s += indent + "</" + this.name + ">";
                        } else if (options && options.html) {
                            var whiteList = [
                                "area",
                                "base",
                                "br",
                                "col",
                                "embed",
                                "frame",
                                "hr",
                                "img",
                                "input",
                                "keygen",
                                "link",
                                "menuitem",
                                "meta",
                                "param",
                                "source",
                                "track",
                                "wbr"
                            ];
                            if (whiteList.indexOf(this.name) !== -1) s += "/>";
                            else s += "></" + this.name + ">";
                        } else s += "/>";
                        return s;
                    };
                    // Alternative XML nodes
                    function XmlTextNode(text) {
                        this.text = text;
                    }
                    XmlTextNode.prototype.toString = function(options) {
                        return formatText(escapeXML(this.text), options);
                    };
                    XmlTextNode.prototype.toStringWithIndent = function(indent, options) {
                        return indent + this.toString(options);
                    };
                    function XmlCDataNode(cdata) {
                        this.cdata = cdata;
                    }
                    XmlCDataNode.prototype.toString = function(options) {
                        return "<![CDATA[" + formatText(this.cdata, options) + "]]>";
                    };
                    XmlCDataNode.prototype.toStringWithIndent = function(indent, options) {
                        return indent + this.toString(options);
                    };
                    function XmlCommentNode(comment) {
                        this.comment = comment;
                    }
                    XmlCommentNode.prototype.toString = function(options) {
                        return "<!--" + formatText(escapeXML(this.comment), options) + "-->";
                    };
                    XmlCommentNode.prototype.toStringWithIndent = function(indent, options) {
                        return indent + this.toString(options);
                    };
                    // Node type tag
                    XmlElement.prototype.type = "element";
                    XmlTextNode.prototype.type = "text";
                    XmlCDataNode.prototype.type = "cdata";
                    XmlCommentNode.prototype.type = "comment";
                    /**
   * XmlDocument is the class we expose to the user; it uses the sax parser to create a hierarchy
   * of XmlElements.
   */ function XmlDocument(xml) {
                        xml && (xml = xml.toString().trim());
                        if (!xml) throw new Error("No XML to parse!");
                        // Stores doctype (if defined)
                        this.doctype = "";
                        // Expose the parser to the other delegates while the parser is running
                        this.parser = sax.parser(true); // strict
                        addParserEvents(this.parser);
                        // We'll use the file-scoped "delegates" var to remember what elements we're currently
                        // parsing; they will push and pop off the stack as we get deeper into the XML hierarchy.
                        // It's safe to use a global because JS is single-threaded.
                        delegates = [
                            this
                        ];
                        try {
                            this.parser.write(xml);
                        } finally{
                            // Remove the parser as it is no longer needed and should not be exposed to clients
                            delete this.parser;
                        }
                    }
                    // make XmlDocument inherit XmlElement's methods
                    extend(XmlDocument.prototype, XmlElement.prototype);
                    XmlDocument.prototype._opentag = function(tag) {
                        if (typeof this.children === "undefined") // the first tag we encounter should be the root - we'll "become" the root XmlElement
                        XmlElement.call(this, tag);
                        else XmlElement.prototype._opentag.apply(this, arguments);
                    };
                    XmlDocument.prototype._doctype = function(doctype) {
                        this.doctype += doctype;
                    };
                    // file-scoped global stack of delegates
                    var delegates = null;
                    /*
   * Helper functions
   */ function addParserEvents(parser) {
                        parser.onopentag = parser_opentag;
                        parser.onclosetag = parser_closetag;
                        parser.ontext = parser_text;
                        parser.oncdata = parser_cdata;
                        parser.oncomment = parser_comment;
                        parser.ondoctype = parser_doctype;
                        parser.onerror = parser_error;
                    }
                    // create these closures and cache them by keeping them file-scoped
                    function parser_opentag() {
                        delegates[0] && delegates[0]._opentag.apply(delegates[0], arguments);
                    }
                    function parser_closetag() {
                        delegates[0] && delegates[0]._closetag.apply(delegates[0], arguments);
                    }
                    function parser_text() {
                        delegates[0] && delegates[0]._text.apply(delegates[0], arguments);
                    }
                    function parser_cdata() {
                        delegates[0] && delegates[0]._cdata.apply(delegates[0], arguments);
                    }
                    function parser_comment() {
                        delegates[0] && delegates[0]._comment.apply(delegates[0], arguments);
                    }
                    function parser_doctype() {
                        delegates[0] && delegates[0]._doctype.apply(delegates[0], arguments);
                    }
                    function parser_error() {
                        delegates[0] && delegates[0]._error.apply(delegates[0], arguments);
                    }
                    // a relatively standard extend method
                    function extend(destination, source) {
                        for(var prop in source)if (source.hasOwnProperty(prop)) destination[prop] = source[prop];
                    }
                    // escapes XML entities like "<", "&", etc.
                    function escapeXML(value) {
                        return value.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&apos;").replace(/"/g, "&quot;");
                    }
                    // formats some text for debugging given a few options
                    function formatText(text, options) {
                        var finalText = text;
                        if (options && options.trimmed && text.length > 25) finalText = finalText.substring(0, 25).trim() + "\u2026";
                        if (!(options && options.preserveWhitespace)) finalText = finalText.trim();
                        return finalText;
                    }
                    // Are we being used in a Node-like environment?
                    if ((0, module1.exports) && !__webpack_require__.g.xmldocAssumeBrowser) {
                        module1.exports.XmlDocument = XmlDocument;
                        module1.exports.XmlElement = XmlElement;
                        module1.exports.XmlTextNode = XmlTextNode;
                        module1.exports.XmlCDataNode = XmlCDataNode;
                        module1.exports.XmlCommentNode = XmlCommentNode;
                    } else {
                        this.XmlDocument = XmlDocument;
                        this.XmlElement = XmlElement;
                        this.XmlTextNode = XmlTextNode;
                        this.XmlCDataNode = XmlCDataNode;
                        this.XmlCommentNode = XmlCommentNode;
                    }
                })();
            /***/ },
            /***/ 75041: /***/ function(module1) {
                "use strict";
                var BooleanT = /*#__PURE__*/ function() {
                    function BooleanT(type) {
                        this.type = type;
                    }
                    var _proto = BooleanT.prototype;
                    _proto.decode = function decode(stream, parent) {
                        return !!this.type.decode(stream, parent);
                    };
                    _proto.size = function size(val, parent) {
                        return this.type.size(val, parent);
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        return this.type.encode(stream, +val, parent);
                    };
                    return BooleanT;
                }();
                module1.exports = BooleanT;
            /***/ },
            /***/ 75174: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var $ = __webpack_require__(56475);
                var FREEZING = __webpack_require__(55481);
                var fails = __webpack_require__(47044);
                var isObject = __webpack_require__(24517);
                var onFreeze = __webpack_require__(62148).onFreeze;
                // eslint-disable-next-line es/no-object-freeze -- safe
                var $freeze = Object.freeze;
                var FAILS_ON_PRIMITIVES = fails(function() {
                    $freeze(1);
                });
                // `Object.freeze` method
                // https://tc39.es/ecma262/#sec-object.freeze
                $({
                    target: 'Object',
                    stat: true,
                    forced: FAILS_ON_PRIMITIVES,
                    sham: !FREEZING
                }, {
                    freeze: function freeze(it) {
                        return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
                    }
                });
            /***/ },
            /***/ 75626: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(98828);
                // `Int16Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor('Int16', function(init) {
                    return function Int16Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 75846: /***/ function(module1) {
                "use strict";
                /** @type {import('.')} */ module1.exports = Object;
            /***/ },
            /***/ 75874: /***/ function(module1) {
                "use strict";
                /** @type {import('./pow')} */ module1.exports = Math.pow;
            /***/ },
            /***/ 75891: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(66947), __webpack_require__(68319), __webpack_require__(82747), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var StreamCipher = C_lib.StreamCipher;
                        var C_algo = C.algo;
                        // Reusable objects
                        var S = [];
                        var C_ = [];
                        var G = [];
                        /**
     * Rabbit stream cipher algorithm.
     *
     * This is a legacy version that neglected to convert the key to little-endian.
     * This error doesn't affect the cipher's security,
     * but it does affect its compatibility with other implementations.
     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
                            _doReset: function _doReset() {
                                // Shortcuts
                                var K = this._key.words;
                                var iv = this.cfg.iv;
                                // Generate initial state values
                                var X = this._X = [
                                    K[0],
                                    K[3] << 16 | K[2] >>> 16,
                                    K[1],
                                    K[0] << 16 | K[3] >>> 16,
                                    K[2],
                                    K[1] << 16 | K[0] >>> 16,
                                    K[3],
                                    K[2] << 16 | K[1] >>> 16
                                ];
                                // Generate initial counter values
                                var C = this._C = [
                                    K[2] << 16 | K[2] >>> 16,
                                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                                    K[3] << 16 | K[3] >>> 16,
                                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                                    K[0] << 16 | K[0] >>> 16,
                                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                                    K[1] << 16 | K[1] >>> 16,
                                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                                ];
                                // Carry bit
                                this._b = 0;
                                // Iterate the system four times
                                for(var i = 0; i < 4; i++)nextState.call(this);
                                // Modify the counters
                                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                                // IV setup
                                if (iv) {
                                    // Shortcuts
                                    var IV = iv.words;
                                    var IV_0 = IV[0];
                                    var IV_1 = IV[1];
                                    // Generate four subvectors
                                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                                    // Modify counter values
                                    C[0] ^= i0;
                                    C[1] ^= i1;
                                    C[2] ^= i2;
                                    C[3] ^= i3;
                                    C[4] ^= i0;
                                    C[5] ^= i1;
                                    C[6] ^= i2;
                                    C[7] ^= i3;
                                    // Iterate the system four times
                                    for(var i = 0; i < 4; i++)nextState.call(this);
                                }
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                // Shortcut
                                var X = this._X;
                                // Iterate the system
                                nextState.call(this);
                                // Generate four keystream words
                                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                                for(var i = 0; i < 4; i++){
                                    // Swap endian
                                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                                    // Encrypt
                                    M[offset + i] ^= S[i];
                                }
                            },
                            blockSize: 4,
                            ivSize: 2
                        });
                        function nextState() {
                            // Shortcuts
                            var X = this._X;
                            var C = this._C;
                            // Save old counter values
                            for(var i = 0; i < 8; i++)C_[i] = C[i];
                            // Calculate new counter values
                            C[0] = C[0] + 0x4d34d34d + this._b | 0;
                            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
                            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
                            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
                            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
                            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
                            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
                            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
                            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
                            // Calculate the g-values
                            for(var i = 0; i < 8; i++){
                                var gx = X[i] + C[i];
                                // Construct high and low argument for squaring
                                var ga = gx & 0xffff;
                                var gb = gx >>> 16;
                                // Calculate high and low result of squaring
                                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                                // High XOR low
                                G[i] = gh ^ gl;
                            }
                            // Calculate new state values
                            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
                            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
                            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
                            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
                            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
                            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
                            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
                            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
                        }
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
                    })();
                    return CryptoJS.RabbitLegacy;
                });
            /***/ },
            /***/ 75960: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(38688);
                exports.f = wellKnownSymbol;
            /***/ },
            /***/ 76014: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var collection = __webpack_require__(36673);
                var collectionStrong = __webpack_require__(9649);
                // `Set` constructor
                // https://tc39.es/ecma262/#sec-set-objects
                collection('Set', function(init) {
                    return function Set1() {
                        return init(this, arguments.length ? arguments[0] : undefined);
                    };
                }, collectionStrong);
            /***/ },
            /***/ 76442: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isString = __webpack_require__(91867).isString;
                var isArray = __webpack_require__(91867).isArray;
                var isUndefined = __webpack_require__(91867).isUndefined;
                var isNull = __webpack_require__(91867).isNull;
                /**
 * Creates an instance of StyleContextStack used for style inheritance and style overrides
 *
 * @constructor
 * @this {StyleContextStack}
 * @param {Object} named styles dictionary
 * @param {Object} optional default style definition
 */ function StyleContextStack(styleDictionary, defaultStyle) {
                    this.defaultStyle = defaultStyle || {};
                    this.styleDictionary = styleDictionary;
                    this.styleOverrides = [];
                }
                /**
 * Creates cloned version of current stack
 * @return {StyleContextStack} current stack snapshot
 */ StyleContextStack.prototype.clone = function() {
                    var stack = new StyleContextStack(this.styleDictionary, this.defaultStyle);
                    this.styleOverrides.forEach(function(item) {
                        stack.styleOverrides.push(item);
                    });
                    return stack;
                };
                /**
 * Pushes style-name or style-overrides-object onto the stack for future evaluation
 *
 * @param {String|Object} styleNameOrOverride style-name (referring to styleDictionary) or
 *                                            a new dictionary defining overriding properties
 */ StyleContextStack.prototype.push = function(styleNameOrOverride) {
                    this.styleOverrides.push(styleNameOrOverride);
                };
                /**
 * Removes last style-name or style-overrides-object from the stack
 *
 * @param {Number} howMany - optional number of elements to be popped (if not specified,
 *                           one element will be removed from the stack)
 */ StyleContextStack.prototype.pop = function(howMany) {
                    howMany = howMany || 1;
                    while(howMany-- > 0)this.styleOverrides.pop();
                };
                /**
 * Creates a set of named styles or/and a style-overrides-object based on the item,
 * pushes those elements onto the stack for future evaluation and returns the number
 * of elements pushed, so they can be easily poped then.
 *
 * @param {Object} item - an object with optional style property and/or style overrides
 * @return the number of items pushed onto the stack
 */ StyleContextStack.prototype.autopush = function(item) {
                    if (isString(item)) return 0;
                    var styleNames = [];
                    if (item.style) {
                        if (isArray(item.style)) styleNames = item.style;
                        else styleNames = [
                            item.style
                        ];
                    }
                    for(var i = 0, l = styleNames.length; i < l; i++)this.push(styleNames[i]);
                    // rather than spend significant time making a styleOverrideObject, just add item
                    this.push(item);
                    return styleNames.length + 1;
                };
                /**
 * Automatically pushes elements onto the stack, using autopush based on item,
 * executes callback and then pops elements back. Returns value returned by callback
 *
 * @param  {Object}   item - an object with optional style property and/or style overrides
 * @param  {Function} function to be called between autopush and pop
 * @return {Object} value returned by callback
 */ StyleContextStack.prototype.auto = function(item, callback) {
                    var pushedItems = this.autopush(item);
                    var result = callback();
                    if (pushedItems > 0) this.pop(pushedItems);
                    return result;
                };
                /**
 * Evaluates stack and returns value of a named property
 *
 * @param {String} property - property name
 * @return property value or null if not found
 */ StyleContextStack.prototype.getProperty = function(property) {
                    if (this.styleOverrides) for(var i = this.styleOverrides.length - 1; i >= 0; i--){
                        var item = this.styleOverrides[i];
                        if (isString(item)) {
                            // named-style-override
                            var style = this.styleDictionary[item];
                            if (style && !isUndefined(style[property]) && !isNull(style[property])) return style[property];
                        } else if (!isUndefined(item[property]) && !isNull(item[property])) // style-overrides-object
                        return item[property];
                    }
                    return this.defaultStyle && this.defaultStyle[property];
                };
                module1.exports = StyleContextStack;
            /***/ },
            /***/ 76515: /***/ function(module1) {
                "use strict";
                var toStr = Object.prototype.toString;
                module1.exports = function isArguments(value) {
                    var str = toStr.call(value);
                    var isArgs = str === '[object Arguments]';
                    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
                    return isArgs;
                };
            /***/ },
            /***/ 77074: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var call = __webpack_require__(2834);
                var aCallable = __webpack_require__(32631);
                var newPromiseCapabilityModule = __webpack_require__(56614);
                var perform = __webpack_require__(61900);
                var iterate = __webpack_require__(80383);
                // `Promise.allSettled` method
                // https://tc39.es/ecma262/#sec-promise.allsettled
                $({
                    target: 'Promise',
                    stat: true
                }, {
                    allSettled: function allSettled(iterable) {
                        var C = this;
                        var capability = newPromiseCapabilityModule.f(C);
                        var resolve = capability.resolve;
                        var reject = capability.reject;
                        var result = perform(function() {
                            var promiseResolve = aCallable(C.resolve);
                            var values = [];
                            var counter = 0;
                            var remaining = 1;
                            iterate(iterable, function(promise) {
                                var index = counter++;
                                var alreadyCalled = false;
                                remaining++;
                                call(promiseResolve, C, promise).then(function(value) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = {
                                        status: 'fulfilled',
                                        value: value
                                    };
                                    --remaining || resolve(values);
                                }, function(error) {
                                    if (alreadyCalled) return;
                                    alreadyCalled = true;
                                    values[index] = {
                                        status: 'rejected',
                                        reason: error
                                    };
                                    --remaining || resolve(values);
                                });
                            });
                            --remaining || resolve(values);
                        });
                        if (result.error) reject(result.value);
                        return capability.promise;
                    }
                });
            /***/ },
            /***/ 77199: /***/ function() {
            /* (ignored) */ /***/ },
            /***/ 77450: /***/ function(module1) {
                "use strict";
                /** @type {import('./floor')} */ module1.exports = Math.floor;
            /***/ },
            /***/ 77530: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isString = __webpack_require__(91867).isString;
                function buildColumnWidths(columns, availableWidth, offsetTotal = 0, tableNode) {
                    var autoColumns = [], autoMin = 0, autoMax = 0, starColumns = [], starMaxMin = 0, starMaxMax = 0, fixedColumns = [], initial_availableWidth = availableWidth;
                    columns.forEach(function(column) {
                        if (isAutoColumn(column)) {
                            autoColumns.push(column);
                            autoMin += column._minWidth;
                            autoMax += column._maxWidth;
                        } else if (isStarColumn(column)) {
                            starColumns.push(column);
                            starMaxMin = Math.max(starMaxMin, column._minWidth);
                            starMaxMax = Math.max(starMaxMax, column._maxWidth);
                        } else fixedColumns.push(column);
                    });
                    fixedColumns.forEach(function(col, colIndex) {
                        // width specified as %
                        if (isString(col.width) && /\d+%/.test(col.width)) {
                            // In tables we have to take into consideration the reserved width for paddings and borders
                            var reservedWidth = 0;
                            if (tableNode) {
                                var paddingLeft = tableNode._layout.paddingLeft(colIndex, tableNode);
                                var paddingRight = tableNode._layout.paddingRight(colIndex, tableNode);
                                var borderLeft = tableNode._layout.vLineWidth(colIndex, tableNode);
                                var borderRight = tableNode._layout.vLineWidth(colIndex + 1, tableNode);
                                if (colIndex === 0) // first column assumes whole borderLeft and half of border right
                                reservedWidth = paddingLeft + paddingRight + borderLeft + borderRight / 2;
                                else if (colIndex === fixedColumns.length - 1) // last column assumes whole borderRight and half of border left
                                reservedWidth = paddingLeft + paddingRight + borderLeft / 2 + borderRight;
                                else // Columns in the middle assume half of each border
                                reservedWidth = paddingLeft + paddingRight + borderLeft / 2 + borderRight / 2;
                            }
                            var totalAvailableWidth = initial_availableWidth + offsetTotal;
                            col.width = parseFloat(col.width) * totalAvailableWidth / 100 - reservedWidth;
                        }
                        if (col.width < col._minWidth && col.elasticWidth) col._calcWidth = col._minWidth;
                        else col._calcWidth = col.width;
                        availableWidth -= col._calcWidth;
                    });
                    // http://www.freesoft.org/CIE/RFC/1942/18.htm
                    // http://www.w3.org/TR/CSS2/tables.html#width-layout
                    // http://dev.w3.org/csswg/css3-tables-algorithms/Overview.src.htm
                    var minW = autoMin + starMaxMin * starColumns.length;
                    var maxW = autoMax + starMaxMax * starColumns.length;
                    if (minW >= availableWidth) {
                        // case 1 - there's no way to fit all columns within available width
                        // that's actually pretty bad situation with PDF as we have no horizontal scroll
                        // no easy workaround (unless we decide, in the future, to split single words)
                        // currently we simply use minWidths for all columns
                        autoColumns.forEach(function(col) {
                            col._calcWidth = col._minWidth;
                        });
                        starColumns.forEach(function(col) {
                            col._calcWidth = starMaxMin; // starMaxMin already contains padding
                        });
                    } else {
                        if (maxW < availableWidth) // case 2 - we can fit rest of the table within available space
                        autoColumns.forEach(function(col) {
                            col._calcWidth = col._maxWidth;
                            availableWidth -= col._calcWidth;
                        });
                        else {
                            // maxW is too large, but minW fits within available width
                            var W = availableWidth - minW;
                            var D = maxW - minW;
                            autoColumns.forEach(function(col) {
                                var d = col._maxWidth - col._minWidth;
                                col._calcWidth = col._minWidth + d * W / D;
                                availableWidth -= col._calcWidth;
                            });
                        }
                        if (starColumns.length > 0) {
                            var starSize = availableWidth / starColumns.length;
                            starColumns.forEach(function(col) {
                                col._calcWidth = starSize;
                            });
                        }
                    }
                }
                function isAutoColumn(column) {
                    return column.width === 'auto';
                }
                function isStarColumn(column) {
                    return column.width === null || column.width === undefined || column.width === '*' || column.width === 'star';
                }
                //TODO: refactor and reuse in measureTable
                function measureMinMax(columns) {
                    var result = {
                        min: 0,
                        max: 0
                    };
                    var maxStar = {
                        min: 0,
                        max: 0
                    };
                    var starCount = 0;
                    for(var i = 0, l = columns.length; i < l; i++){
                        var c = columns[i];
                        if (isStarColumn(c)) {
                            maxStar.min = Math.max(maxStar.min, c._minWidth);
                            maxStar.max = Math.max(maxStar.max, c._maxWidth);
                            starCount++;
                        } else if (isAutoColumn(c)) {
                            result.min += c._minWidth;
                            result.max += c._maxWidth;
                        } else {
                            result.min += c.width !== undefined && c.width || c._minWidth;
                            result.max += c.width !== undefined && c.width || c._maxWidth;
                        }
                    }
                    if (starCount) {
                        result.min += starCount * maxStar.min;
                        result.max += starCount * maxStar.max;
                    }
                    return result;
                }
                /**
 * Calculates column widths
 * @private
 */ module1.exports = {
                    buildColumnWidths: buildColumnWidths,
                    measureMinMax: measureMinMax,
                    isAutoColumn: isAutoColumn,
                    isStarColumn: isStarColumn
                };
            /***/ },
            /***/ 77802: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var keys = __webpack_require__(35643);
                var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
                var toStr = Object.prototype.toString;
                var concat = Array.prototype.concat;
                var defineDataProperty = __webpack_require__(89295);
                var isFunction = function(fn) {
                    return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
                };
                var supportsDescriptors = __webpack_require__(18890)();
                var defineProperty = function(object, name, value, predicate) {
                    if (name in object) {
                        if (predicate === true) {
                            if (object[name] === value) return;
                        } else if (!isFunction(predicate) || !predicate()) return;
                    }
                    if (supportsDescriptors) defineDataProperty(object, name, value, true);
                    else defineDataProperty(object, name, value);
                };
                var defineProperties = function(object, map) {
                    var predicates = arguments.length > 2 ? arguments[2] : {};
                    var props = keys(map);
                    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
                    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
                };
                defineProperties.supportsDescriptors = !!supportsDescriptors;
                module1.exports = defineProperties;
            /***/ },
            /***/ 79178: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var TraversalTracker = __webpack_require__(2318);
                var isString = __webpack_require__(91867).isString;
                /**
 * Creates an instance of DocumentContext - a store for current x, y positions and available width/height.
 * It facilitates column divisions and vertical sync
 */ function DocumentContext(pageSize, pageMargins) {
                    this.pages = [];
                    this.pageMargins = pageMargins;
                    this.x = pageMargins.left;
                    this.availableWidth = pageSize.width - pageMargins.left - pageMargins.right;
                    this.availableHeight = 0;
                    this.page = -1;
                    this.snapshots = [];
                    this.tracker = new TraversalTracker();
                    this.backgroundLength = [];
                    this.addPage(pageSize);
                }
                DocumentContext.prototype.beginColumnGroup = function(marginXTopParent, bottomByPage = {}) {
                    this.snapshots.push({
                        x: this.x,
                        y: this.y,
                        availableHeight: this.availableHeight,
                        availableWidth: this.availableWidth,
                        page: this.page,
                        bottomByPage: bottomByPage ? bottomByPage : {},
                        bottomMost: {
                            x: this.x,
                            y: this.y,
                            availableHeight: this.availableHeight,
                            availableWidth: this.availableWidth,
                            page: this.page
                        },
                        lastColumnWidth: this.lastColumnWidth
                    });
                    this.lastColumnWidth = 0;
                    if (marginXTopParent) this.marginXTopParent = marginXTopParent;
                };
                DocumentContext.prototype.updateBottomByPage = function() {
                    const lastSnapshot = this.snapshots[this.snapshots.length - 1];
                    const lastPage = this.page;
                    let previousBottom = -Number.MIN_VALUE;
                    if (lastSnapshot.bottomByPage[lastPage]) previousBottom = lastSnapshot.bottomByPage[lastPage];
                    lastSnapshot.bottomByPage[lastPage] = Math.max(previousBottom, this.y);
                };
                DocumentContext.prototype.resetMarginXTopParent = function() {
                    this.marginXTopParent = null;
                };
                DocumentContext.prototype.beginColumn = function(width, offset, endingCell) {
                    var saved = this.snapshots[this.snapshots.length - 1];
                    this.calculateBottomMost(saved, endingCell);
                    this.page = saved.page;
                    this.x = this.x + this.lastColumnWidth + (offset || 0);
                    this.y = saved.y;
                    this.availableWidth = width; //saved.availableWidth - offset;
                    this.availableHeight = saved.availableHeight;
                    this.lastColumnWidth = width;
                };
                DocumentContext.prototype.calculateBottomMost = function(destContext, endingCell) {
                    if (endingCell) this.saveContextInEndingCell(endingCell);
                    else destContext.bottomMost = bottomMostContext(this, destContext.bottomMost);
                };
                DocumentContext.prototype.markEnding = function(endingCell, originalXOffset, discountY) {
                    this.page = endingCell._columnEndingContext.page;
                    this.x = endingCell._columnEndingContext.x + originalXOffset;
                    this.y = endingCell._columnEndingContext.y - discountY;
                    this.availableWidth = endingCell._columnEndingContext.availableWidth;
                    this.availableHeight = endingCell._columnEndingContext.availableHeight;
                    this.lastColumnWidth = endingCell._columnEndingContext.lastColumnWidth;
                };
                DocumentContext.prototype.saveContextInEndingCell = function(endingCell) {
                    endingCell._columnEndingContext = {
                        page: this.page,
                        x: this.x,
                        y: this.y,
                        availableHeight: this.availableHeight,
                        availableWidth: this.availableWidth,
                        lastColumnWidth: this.lastColumnWidth
                    };
                };
                DocumentContext.prototype.completeColumnGroup = function(height, endingCell) {
                    var saved = this.snapshots.pop();
                    this.calculateBottomMost(saved, endingCell);
                    this.x = saved.x;
                    var y = saved.bottomMost.y;
                    if (height) {
                        if (saved.page === saved.bottomMost.page) {
                            if (saved.y + height > y) y = saved.y + height;
                        } else y += height;
                    }
                    this.y = y;
                    this.page = saved.bottomMost.page;
                    this.availableWidth = saved.availableWidth;
                    this.availableHeight = saved.bottomMost.availableHeight;
                    if (height) this.availableHeight -= y - saved.bottomMost.y;
                    this.lastColumnWidth = saved.lastColumnWidth;
                    return saved.bottomByPage;
                };
                DocumentContext.prototype.addMargin = function(left, right) {
                    this.x += left;
                    this.availableWidth -= left + (right || 0);
                };
                DocumentContext.prototype.moveDown = function(offset) {
                    this.y += offset;
                    this.availableHeight -= offset;
                    return this.availableHeight > 0;
                };
                DocumentContext.prototype.initializePage = function() {
                    this.y = this.pageMargins.top;
                    this.availableHeight = this.getCurrentPage().pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
                    const { pageCtx: pageCtx, isSnapshot: isSnapshot } = this.pageSnapshot();
                    pageCtx.availableWidth = this.getCurrentPage().pageSize.width - this.pageMargins.left - this.pageMargins.right;
                    if (isSnapshot && this.marginXTopParent) {
                        pageCtx.availableWidth -= this.marginXTopParent[0];
                        pageCtx.availableWidth -= this.marginXTopParent[1];
                    }
                };
                DocumentContext.prototype.pageSnapshot = function() {
                    if (this.snapshots[0]) return {
                        pageCtx: this.snapshots[0],
                        isSnapshot: true
                    };
                    else return {
                        pageCtx: this,
                        isSnapshot: false
                    };
                };
                DocumentContext.prototype.moveTo = function(x, y) {
                    if (x !== undefined && x !== null) {
                        this.x = x;
                        this.availableWidth = this.getCurrentPage().pageSize.width - this.x - this.pageMargins.right;
                    }
                    if (y !== undefined && y !== null) {
                        this.y = y;
                        this.availableHeight = this.getCurrentPage().pageSize.height - this.y - this.pageMargins.bottom;
                    }
                };
                DocumentContext.prototype.moveToRelative = function(x, y) {
                    if (x !== undefined && x !== null) this.x = this.x + x;
                    if (y !== undefined && y !== null) this.y = this.y + y;
                };
                DocumentContext.prototype.beginDetachedBlock = function() {
                    this.snapshots.push({
                        x: this.x,
                        y: this.y,
                        availableHeight: this.availableHeight,
                        availableWidth: this.availableWidth,
                        page: this.page,
                        lastColumnWidth: this.lastColumnWidth
                    });
                };
                DocumentContext.prototype.endDetachedBlock = function() {
                    var saved = this.snapshots.pop();
                    this.x = saved.x;
                    this.y = saved.y;
                    this.availableWidth = saved.availableWidth;
                    this.availableHeight = saved.availableHeight;
                    this.page = saved.page;
                    this.lastColumnWidth = saved.lastColumnWidth;
                };
                function pageOrientation(pageOrientationString, currentPageOrientation) {
                    if (pageOrientationString === undefined) return currentPageOrientation;
                    else if (isString(pageOrientationString) && pageOrientationString.toLowerCase() === 'landscape') return 'landscape';
                    else return 'portrait';
                }
                var getPageSize = function(currentPage, newPageOrientation) {
                    newPageOrientation = pageOrientation(newPageOrientation, currentPage.pageSize.orientation);
                    if (newPageOrientation !== currentPage.pageSize.orientation) return {
                        orientation: newPageOrientation,
                        width: currentPage.pageSize.height,
                        height: currentPage.pageSize.width
                    };
                    else return {
                        orientation: currentPage.pageSize.orientation,
                        width: currentPage.pageSize.width,
                        height: currentPage.pageSize.height
                    };
                };
                DocumentContext.prototype.moveToNextPage = function(pageOrientation) {
                    var nextPageIndex = this.page + 1;
                    var prevPage = this.page;
                    var prevY = this.y;
                    // If we are in a column group
                    if (this.snapshots.length > 0) {
                        var lastSnapshot = this.snapshots[this.snapshots.length - 1];
                        // We have to update prevY accordingly by also taking into consideration
                        // the 'y' of cells that don't break page
                        if (lastSnapshot.bottomMost && lastSnapshot.bottomMost.y) prevY = Math.max(this.y, lastSnapshot.bottomMost.y);
                    }
                    var createNewPage = nextPageIndex >= this.pages.length;
                    if (createNewPage) {
                        var currentAvailableWidth = this.availableWidth;
                        var currentPageOrientation = this.getCurrentPage().pageSize.orientation;
                        var pageSize = getPageSize(this.getCurrentPage(), pageOrientation);
                        this.addPage(pageSize);
                        if (currentPageOrientation === pageSize.orientation) this.availableWidth = currentAvailableWidth;
                    } else {
                        this.page = nextPageIndex;
                        this.initializePage();
                    }
                    return {
                        newPageCreated: createNewPage,
                        prevPage: prevPage,
                        prevY: prevY,
                        y: this.y
                    };
                };
                DocumentContext.prototype.addPage = function(pageSize) {
                    var page = {
                        items: [],
                        pageSize: pageSize
                    };
                    this.pages.push(page);
                    this.backgroundLength.push(0);
                    this.page = this.pages.length - 1;
                    this.initializePage();
                    this.tracker.emit('pageAdded');
                    return page;
                };
                DocumentContext.prototype.getCurrentPage = function() {
                    if (this.page < 0 || this.page >= this.pages.length) return null;
                    return this.pages[this.page];
                };
                DocumentContext.prototype.getCurrentPosition = function() {
                    var pageSize = this.getCurrentPage().pageSize;
                    var innerHeight = pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
                    var innerWidth = pageSize.width - this.pageMargins.left - this.pageMargins.right;
                    return {
                        pageNumber: this.page + 1,
                        pageOrientation: pageSize.orientation,
                        pageInnerHeight: innerHeight,
                        pageInnerWidth: innerWidth,
                        left: this.x,
                        top: this.y,
                        verticalRatio: (this.y - this.pageMargins.top) / innerHeight,
                        horizontalRatio: (this.x - this.pageMargins.left) / innerWidth
                    };
                };
                function bottomMostContext(c1, c2) {
                    var r;
                    if (c1.page > c2.page) r = c1;
                    else if (c2.page > c1.page) r = c2;
                    else r = c1.y > c2.y ? c1 : c2;
                    return {
                        page: r.page,
                        x: r.x,
                        y: r.y,
                        availableHeight: r.availableHeight,
                        availableWidth: r.availableWidth
                    };
                }
                module1.exports = DocumentContext;
            /***/ },
            /***/ 79676: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(9964);
                var _Object$setPrototypeO;
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return typeof key === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (typeof input !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (typeof res !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                var finished = __webpack_require__(12167);
                var kLastResolve = Symbol('lastResolve');
                var kLastReject = Symbol('lastReject');
                var kError = Symbol('error');
                var kEnded = Symbol('ended');
                var kLastPromise = Symbol('lastPromise');
                var kHandlePromise = Symbol('handlePromise');
                var kStream = Symbol('stream');
                function createIterResult(value, done) {
                    return {
                        value: value,
                        done: done
                    };
                }
                function readAndResolve(iter) {
                    var resolve = iter[kLastResolve];
                    if (resolve !== null) {
                        var data = iter[kStream].read();
                        // we defer if data is null
                        // we can be expecting either 'end' or
                        // 'error'
                        if (data !== null) {
                            iter[kLastPromise] = null;
                            iter[kLastResolve] = null;
                            iter[kLastReject] = null;
                            resolve(createIterResult(data, false));
                        }
                    }
                }
                function onReadable(iter) {
                    // we wait for the next tick, because it might
                    // emit an error with process.nextTick
                    process.nextTick(readAndResolve, iter);
                }
                function wrapForNext(lastPromise, iter) {
                    return function(resolve, reject) {
                        lastPromise.then(function() {
                            if (iter[kEnded]) {
                                resolve(createIterResult(undefined, true));
                                return;
                            }
                            iter[kHandlePromise](resolve, reject);
                        }, reject);
                    };
                }
                var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
                var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
                    get stream () {
                        return this[kStream];
                    },
                    next: function next() {
                        var _this = this;
                        // if we have detected an error in the meanwhile
                        // reject straight away
                        var error = this[kError];
                        if (error !== null) return Promise.reject(error);
                        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
                        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
                        // called, the error will be emitted via nextTick, and
                        // we cannot guarantee that there is no error lingering around
                        // waiting to be emitted.
                        return new Promise(function(resolve, reject) {
                            process.nextTick(function() {
                                if (_this[kError]) reject(_this[kError]);
                                else resolve(createIterResult(undefined, true));
                            });
                        });
                        // if we have multiple next() calls
                        // we will wait for the previous Promise to finish
                        // this logic is optimized to support for await loops,
                        // where next() is only called once at a time
                        var lastPromise = this[kLastPromise];
                        var promise;
                        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
                        else {
                            // fast path needed to support multiple this.push()
                            // without triggering the next() queue
                            var data = this[kStream].read();
                            if (data !== null) return Promise.resolve(createIterResult(data, false));
                            promise = new Promise(this[kHandlePromise]);
                        }
                        this[kLastPromise] = promise;
                        return promise;
                    }
                }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
                    return this;
                }), _defineProperty(_Object$setPrototypeO, "return", function _return() {
                    var _this2 = this;
                    // destroy(err, cb) is a private API
                    // we can guarantee we have that here, because we control the
                    // Readable class this is attached to
                    return new Promise(function(resolve, reject) {
                        _this2[kStream].destroy(null, function(err) {
                            if (err) {
                                reject(err);
                                return;
                            }
                            resolve(createIterResult(undefined, true));
                        });
                    });
                }), _Object$setPrototypeO), AsyncIteratorPrototype);
                var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
                    var _Object$create;
                    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
                        value: stream,
                        writable: true
                    }), _defineProperty(_Object$create, kLastResolve, {
                        value: null,
                        writable: true
                    }), _defineProperty(_Object$create, kLastReject, {
                        value: null,
                        writable: true
                    }), _defineProperty(_Object$create, kError, {
                        value: null,
                        writable: true
                    }), _defineProperty(_Object$create, kEnded, {
                        value: stream._readableState.endEmitted,
                        writable: true
                    }), _defineProperty(_Object$create, kHandlePromise, {
                        value: function value(resolve, reject) {
                            var data = iterator[kStream].read();
                            if (data) {
                                iterator[kLastPromise] = null;
                                iterator[kLastResolve] = null;
                                iterator[kLastReject] = null;
                                resolve(createIterResult(data, false));
                            } else {
                                iterator[kLastResolve] = resolve;
                                iterator[kLastReject] = reject;
                            }
                        },
                        writable: true
                    }), _Object$create));
                    iterator[kLastPromise] = null;
                    finished(stream, function(err) {
                        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
                            var reject = iterator[kLastReject];
                            // reject if we are waiting for data in the Promise
                            // returned by next() and store the error
                            if (reject !== null) {
                                iterator[kLastPromise] = null;
                                iterator[kLastResolve] = null;
                                iterator[kLastReject] = null;
                                reject(err);
                            }
                            iterator[kError] = err;
                            return;
                        }
                        var resolve = iterator[kLastResolve];
                        if (resolve !== null) {
                            iterator[kLastPromise] = null;
                            iterator[kLastResolve] = null;
                            iterator[kLastReject] = null;
                            resolve(createIterResult(undefined, true));
                        }
                        iterator[kEnded] = true;
                    });
                    stream.on('readable', onReadable.bind(null, iterator));
                    return iterator;
                };
                module1.exports = createReadableStreamAsyncIterator;
            /***/ },
            /***/ 80055: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var $map = __webpack_require__(91102).map;
                var arrayMethodHasSpeciesSupport = __webpack_require__(56280);
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
                // `Array.prototype.map` method
                // https://tc39.es/ecma262/#sec-array.prototype.map
                // with adding support of @@species
                $({
                    target: 'Array',
                    proto: true,
                    forced: !HAS_SPECIES_SUPPORT
                }, {
                    map: function map(callbackfn /* , thisArg */ ) {
                        return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
            /***/ },
            /***/ 80182: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(9964);
                // Currently in sync with Node.js lib/assert.js
                // https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
                // Originally from narwhal.js (http://narwhaljs.org)
                // Copyright (c) 2009 Thomas Robinson <280north.com>
                //
                // Permission is hereby granted, free of charge, to any person obtaining a copy
                // of this software and associated documentation files (the 'Software'), to
                // deal in the Software without restriction, including without limitation the
                // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
                // sell copies of the Software, and to permit persons to whom the Software is
                // furnished to do so, subject to the following conditions:
                //
                // The above copyright notice and this permission notice shall be included in
                // all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                // AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
                // ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
                // WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var _require = __webpack_require__(35403), _require$codes = _require.codes, ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE, ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;
                var AssertionError = __webpack_require__(85416);
                var _require2 = __webpack_require__(7187), inspect = _require2.inspect;
                var _require$types = __webpack_require__(7187).types, isPromise = _require$types.isPromise, isRegExp = _require$types.isRegExp;
                var objectAssign = __webpack_require__(37596)();
                var objectIs = __webpack_require__(89636)();
                var RegExpPrototypeTest = __webpack_require__(67913)('RegExp.prototype.test');
                var errorCache = new Map();
                var isDeepEqual;
                var isDeepStrictEqual;
                var parseExpressionAt;
                var findNodeAround;
                var decoder;
                function lazyLoadComparison() {
                    var comparison = __webpack_require__(86781);
                    isDeepEqual = comparison.isDeepEqual;
                    isDeepStrictEqual = comparison.isDeepStrictEqual;
                }
                // Escape control characters but not \n and \t to keep the line breaks and
                // indentation intact.
                // eslint-disable-next-line no-control-regex
                var escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
                var meta = /* unused pure expression or super */ null;
                var escapeFn = function escapeFn(str) {
                    return meta[str.charCodeAt(0)];
                };
                var warned = false;
                // The assert module provides functions that throw
                // AssertionError's when particular conditions are not met. The
                // assert module must conform to the following interface.
                var assert = module1.exports = ok;
                var NO_EXCEPTION_SENTINEL = {};
                // All of the following functions must throw an AssertionError
                // when a corresponding condition is not met, with a message that
                // may be undefined if not provided. All assertion methods provide
                // both the actual and expected values to the assertion error for
                // display purposes.
                function innerFail(obj) {
                    if (obj.message instanceof Error) throw obj.message;
                    throw new AssertionError(obj);
                }
                function fail(actual, expected, message, operator, stackStartFn) {
                    var argsLen = arguments.length;
                    var internalMessage;
                    if (argsLen === 0) internalMessage = 'Failed';
                    else if (argsLen === 1) {
                        message = actual;
                        actual = undefined;
                    } else {
                        if (warned === false) {
                            warned = true;
                            var warn = process.emitWarning ? process.emitWarning : console.warn.bind(console);
                            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
                        }
                        if (argsLen === 2) operator = '!=';
                    }
                    if (message instanceof Error) throw message;
                    var errArgs = {
                        actual: actual,
                        expected: expected,
                        operator: operator === undefined ? 'fail' : operator,
                        stackStartFn: stackStartFn || fail
                    };
                    if (message !== undefined) errArgs.message = message;
                    var err = new AssertionError(errArgs);
                    if (internalMessage) {
                        err.message = internalMessage;
                        err.generatedMessage = true;
                    }
                    throw err;
                }
                assert.fail = fail;
                // The AssertionError is defined in internal/error.
                assert.AssertionError = AssertionError;
                function innerOk(fn, argLen, value, message) {
                    if (!value) {
                        var generatedMessage = false;
                        if (argLen === 0) {
                            generatedMessage = true;
                            message = 'No value argument passed to `assert.ok()`';
                        } else if (message instanceof Error) throw message;
                        var err = new AssertionError({
                            actual: value,
                            expected: true,
                            message: message,
                            operator: '==',
                            stackStartFn: fn
                        });
                        err.generatedMessage = generatedMessage;
                        throw err;
                    }
                }
                // Pure assertion tests whether a value is truthy, as determined
                // by !!value.
                function ok() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    innerOk.apply(void 0, [
                        ok,
                        args.length
                    ].concat(args));
                }
                assert.ok = ok;
                // The equality assertion tests shallow, coercive equality with ==.
                /* eslint-disable no-restricted-properties */ assert.equal = function equal(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
                    // eslint-disable-next-line eqeqeq
                    if (actual != expected) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: '==',
                        stackStartFn: equal
                    });
                };
                // The non-equality assertion tests for whether two objects are not
                // equal with !=.
                assert.notEqual = function notEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
                    // eslint-disable-next-line eqeqeq
                    if (actual == expected) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: '!=',
                        stackStartFn: notEqual
                    });
                };
                // The equivalence assertion tests a deep equality relation.
                assert.deepEqual = function deepEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
                    if (isDeepEqual === undefined) lazyLoadComparison();
                    if (!isDeepEqual(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: 'deepEqual',
                        stackStartFn: deepEqual
                    });
                };
                // The non-equivalence assertion tests for any deep inequality.
                assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
                    if (isDeepEqual === undefined) lazyLoadComparison();
                    if (isDeepEqual(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: 'notDeepEqual',
                        stackStartFn: notDeepEqual
                    });
                };
                /* eslint-enable */ assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
                    if (isDeepEqual === undefined) lazyLoadComparison();
                    if (!isDeepStrictEqual(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: 'deepStrictEqual',
                        stackStartFn: deepStrictEqual
                    });
                };
                assert.notDeepStrictEqual = notDeepStrictEqual;
                function notDeepStrictEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
                    if (isDeepEqual === undefined) lazyLoadComparison();
                    if (isDeepStrictEqual(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: 'notDeepStrictEqual',
                        stackStartFn: notDeepStrictEqual
                    });
                }
                assert.strictEqual = function strictEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
                    if (!objectIs(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: 'strictEqual',
                        stackStartFn: strictEqual
                    });
                };
                assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
                    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
                    if (objectIs(actual, expected)) innerFail({
                        actual: actual,
                        expected: expected,
                        message: message,
                        operator: 'notStrictEqual',
                        stackStartFn: notStrictEqual
                    });
                };
                var Comparison = /*#__PURE__*/ _createClass(function Comparison(obj, keys, actual) {
                    var _this = this;
                    _classCallCheck(this, Comparison);
                    keys.forEach(function(key) {
                        if (key in obj) {
                            if (actual !== undefined && typeof actual[key] === 'string' && isRegExp(obj[key]) && RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
                            else _this[key] = obj[key];
                        }
                    });
                });
                function compareExceptionKey(actual, expected, key, message, keys, fn) {
                    if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
                        if (!message) {
                            // Create placeholder objects to create a nice output.
                            var a = new Comparison(actual, keys);
                            var b = new Comparison(expected, keys, actual);
                            var err = new AssertionError({
                                actual: a,
                                expected: b,
                                operator: 'deepStrictEqual',
                                stackStartFn: fn
                            });
                            err.actual = actual;
                            err.expected = expected;
                            err.operator = fn.name;
                            throw err;
                        }
                        innerFail({
                            actual: actual,
                            expected: expected,
                            message: message,
                            operator: fn.name,
                            stackStartFn: fn
                        });
                    }
                }
                function expectedException(actual, expected, msg, fn) {
                    if (typeof expected !== 'function') {
                        if (isRegExp(expected)) return RegExpPrototypeTest(expected, actual);
                        // assert.doesNotThrow does not accept objects.
                        if (arguments.length === 2) throw new ERR_INVALID_ARG_TYPE('expected', [
                            'Function',
                            'RegExp'
                        ], expected);
                        // Handle primitives properly.
                        if (_typeof(actual) !== 'object' || actual === null) {
                            var err = new AssertionError({
                                actual: actual,
                                expected: expected,
                                message: msg,
                                operator: 'deepStrictEqual',
                                stackStartFn: fn
                            });
                            err.operator = fn.name;
                            throw err;
                        }
                        var keys = Object.keys(expected);
                        // Special handle errors to make sure the name and the message are compared
                        // as well.
                        if (expected instanceof Error) keys.push('name', 'message');
                        else if (keys.length === 0) throw new ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
                        if (isDeepEqual === undefined) lazyLoadComparison();
                        keys.forEach(function(key) {
                            if (typeof actual[key] === 'string' && isRegExp(expected[key]) && RegExpPrototypeTest(expected[key], actual[key])) return;
                            compareExceptionKey(actual, expected, key, msg, keys, fn);
                        });
                        return true;
                    }
                    // Guard instanceof against arrow functions as they don't have a prototype.
                    if (expected.prototype !== undefined && actual instanceof expected) return true;
                    if (Error.isPrototypeOf(expected)) return false;
                    return expected.call({}, actual) === true;
                }
                function getActual(fn) {
                    if (typeof fn !== 'function') throw new ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
                    try {
                        fn();
                    } catch (e) {
                        return e;
                    }
                    return NO_EXCEPTION_SENTINEL;
                }
                function checkIsPromise(obj) {
                    // Accept native ES6 promises and promises that are implemented in a similar
                    // way. Do not accept thenables that use a function as `obj` and that have no
                    // `catch` handler.
                    // TODO: thenables are checked up until they have the correct methods,
                    // but according to documentation, the `then` method should receive
                    // the `fulfill` and `reject` arguments as well or it may be never resolved.
                    return isPromise(obj) || obj !== null && _typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
                }
                function waitForActual(promiseFn) {
                    return Promise.resolve().then(function() {
                        var resultPromise;
                        if (typeof promiseFn === 'function') {
                            // Return a rejected promise if `promiseFn` throws synchronously.
                            resultPromise = promiseFn();
                            // Fail in case no promise is returned.
                            if (!checkIsPromise(resultPromise)) throw new ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
                        } else if (checkIsPromise(promiseFn)) resultPromise = promiseFn;
                        else throw new ERR_INVALID_ARG_TYPE('promiseFn', [
                            'Function',
                            'Promise'
                        ], promiseFn);
                        return Promise.resolve().then(function() {
                            return resultPromise;
                        }).then(function() {
                            return NO_EXCEPTION_SENTINEL;
                        }).catch(function(e) {
                            return e;
                        });
                    });
                }
                function expectsError(stackStartFn, actual, error, message) {
                    if (typeof error === 'string') {
                        if (arguments.length === 4) throw new ERR_INVALID_ARG_TYPE('error', [
                            'Object',
                            'Error',
                            'Function',
                            'RegExp'
                        ], error);
                        if (_typeof(actual) === 'object' && actual !== null) {
                            if (actual.message === error) throw new ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
                        } else if (actual === error) throw new ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
                        message = error;
                        error = undefined;
                    } else if (error != null && _typeof(error) !== 'object' && typeof error !== 'function') throw new ERR_INVALID_ARG_TYPE('error', [
                        'Object',
                        'Error',
                        'Function',
                        'RegExp'
                    ], error);
                    if (actual === NO_EXCEPTION_SENTINEL) {
                        var details = '';
                        if (error && error.name) details += " (".concat(error.name, ")");
                        details += message ? ": ".concat(message) : '.';
                        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
                        innerFail({
                            actual: undefined,
                            expected: error,
                            operator: stackStartFn.name,
                            message: "Missing expected ".concat(fnType).concat(details),
                            stackStartFn: stackStartFn
                        });
                    }
                    if (error && !expectedException(actual, error, message, stackStartFn)) throw actual;
                }
                function expectsNoError(stackStartFn, actual, error, message) {
                    if (actual === NO_EXCEPTION_SENTINEL) return;
                    if (typeof error === 'string') {
                        message = error;
                        error = undefined;
                    }
                    if (!error || expectedException(actual, error)) {
                        var details = message ? ": ".concat(message) : '.';
                        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
                        innerFail({
                            actual: actual,
                            expected: error,
                            operator: stackStartFn.name,
                            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
                            stackStartFn: stackStartFn
                        });
                    }
                    throw actual;
                }
                assert.throws = function throws(promiseFn) {
                    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                    expectsError.apply(void 0, [
                        throws,
                        getActual(promiseFn)
                    ].concat(args));
                };
                assert.rejects = function rejects(promiseFn) {
                    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
                    return waitForActual(promiseFn).then(function(result) {
                        return expectsError.apply(void 0, [
                            rejects,
                            result
                        ].concat(args));
                    });
                };
                assert.doesNotThrow = function doesNotThrow(fn) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    expectsNoError.apply(void 0, [
                        doesNotThrow,
                        getActual(fn)
                    ].concat(args));
                };
                assert.doesNotReject = function doesNotReject(fn) {
                    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
                    return waitForActual(fn).then(function(result) {
                        return expectsNoError.apply(void 0, [
                            doesNotReject,
                            result
                        ].concat(args));
                    });
                };
                assert.ifError = function ifError(err) {
                    if (err !== null && err !== undefined) {
                        var message = 'ifError got unwanted exception: ';
                        if (_typeof(err) === 'object' && typeof err.message === 'string') {
                            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
                            else message += err.message;
                        } else message += inspect(err);
                        var newErr = new AssertionError({
                            actual: err,
                            expected: null,
                            operator: 'ifError',
                            message: message,
                            stackStartFn: ifError
                        });
                        // Make sure we actually have a stack trace!
                        var origStack = err.stack;
                        if (typeof origStack === 'string') {
                            // This will remove any duplicated frames from the error frames taken
                            // from within `ifError` and add the original error frames to the newly
                            // created ones.
                            var tmp2 = origStack.split('\n');
                            tmp2.shift();
                            // Filter all frames existing in err.stack.
                            var tmp1 = newErr.stack.split('\n');
                            for(var i = 0; i < tmp2.length; i++){
                                // Find the first occurrence of the frame.
                                var pos = tmp1.indexOf(tmp2[i]);
                                if (pos !== -1) {
                                    // Only keep new frames.
                                    tmp1 = tmp1.slice(0, pos);
                                    break;
                                }
                            }
                            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
                        }
                        throw newErr;
                    }
                };
                // Currently in sync with Node.js lib/assert.js
                // https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
                function internalMatch(string, regexp, message, fn, fnName) {
                    if (!isRegExp(regexp)) throw new ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
                    var match = fnName === 'match';
                    if (typeof string !== 'string' || RegExpPrototypeTest(regexp, string) !== match) {
                        if (message instanceof Error) throw message;
                        var generatedMessage = !message;
                        // 'The input was expected to not match the regular expression ' +
                        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat(_typeof(string), " (").concat(inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat(inspect(regexp), ". Input:\n\n").concat(inspect(string), "\n"));
                        var err = new AssertionError({
                            actual: string,
                            expected: regexp,
                            message: message,
                            operator: fnName,
                            stackStartFn: fn
                        });
                        err.generatedMessage = generatedMessage;
                        throw err;
                    }
                }
                assert.match = function match(string, regexp, message) {
                    internalMatch(string, regexp, message, match, 'match');
                };
                assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
                    internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
                };
                // Expose a strict only variant of assert
                function strict() {
                    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
                    innerOk.apply(void 0, [
                        strict,
                        args.length
                    ].concat(args));
                }
                assert.strict = objectAssign(strict, assert, {
                    equal: assert.strictEqual,
                    deepEqual: assert.deepStrictEqual,
                    notEqual: assert.notStrictEqual,
                    notDeepEqual: assert.notDeepStrictEqual
                });
                assert.strict.strict = assert.strict;
            /***/ },
            /***/ 80383: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var bind = __webpack_require__(25567);
                var call = __webpack_require__(2834);
                var anObject = __webpack_require__(34984);
                var tryToString = __webpack_require__(68664);
                var isArrayIteratorMethod = __webpack_require__(89564);
                var lengthOfArrayLike = __webpack_require__(45495);
                var isPrototypeOf = __webpack_require__(70176);
                var getIterator = __webpack_require__(15892);
                var getIteratorMethod = __webpack_require__(13872);
                var iteratorClose = __webpack_require__(50194);
                var TypeError1 = global.TypeError;
                var Result = function(stopped, result) {
                    this.stopped = stopped;
                    this.result = result;
                };
                var ResultPrototype = Result.prototype;
                module1.exports = function(iterable, unboundFunction, options) {
                    var that = options && options.that;
                    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
                    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
                    var INTERRUPTED = !!(options && options.INTERRUPTED);
                    var fn = bind(unboundFunction, that);
                    var iterator, iterFn, index, length, result, next, step;
                    var stop = function(condition) {
                        if (iterator) iteratorClose(iterator, 'normal', condition);
                        return new Result(true, condition);
                    };
                    var callFn = function(value) {
                        if (AS_ENTRIES) {
                            anObject(value);
                            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
                        }
                        return INTERRUPTED ? fn(value, stop) : fn(value);
                    };
                    if (IS_ITERATOR) iterator = iterable;
                    else {
                        iterFn = getIteratorMethod(iterable);
                        if (!iterFn) throw TypeError1(tryToString(iterable) + ' is not iterable');
                        // optimisation for array iterators
                        if (isArrayIteratorMethod(iterFn)) {
                            for(index = 0, length = lengthOfArrayLike(iterable); length > index; index++){
                                result = callFn(iterable[index]);
                                if (result && isPrototypeOf(ResultPrototype, result)) return result;
                            }
                            return new Result(false);
                        }
                        iterator = getIterator(iterable, iterFn);
                    }
                    next = iterator.next;
                    while(!(step = call(next, iterator)).done){
                        try {
                            result = callFn(step.value);
                        } catch (error) {
                            iteratorClose(iterator, 'throw', error);
                        }
                        if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
                    }
                    return new Result(false);
                };
            /***/ },
            /***/ 80614: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Collection of static dictionary words.
*/ var data = __webpack_require__(84543);
                exports.init = function() {
                    exports.dictionary = data.init();
                };
                exports.offsetsByLength = new Uint32Array([
                    0,
                    0,
                    0,
                    0,
                    0,
                    4096,
                    9216,
                    21504,
                    35840,
                    44032,
                    53248,
                    63488,
                    74752,
                    87040,
                    93696,
                    100864,
                    104704,
                    106752,
                    108928,
                    113536,
                    115968,
                    118528,
                    119872,
                    121280,
                    122016
                ]);
                exports.sizeBitsByLength = new Uint8Array([
                    0,
                    0,
                    0,
                    0,
                    10,
                    10,
                    11,
                    11,
                    10,
                    10,
                    10,
                    10,
                    10,
                    9,
                    9,
                    8,
                    7,
                    7,
                    8,
                    7,
                    7,
                    6,
                    6,
                    5,
                    5
                ]);
                exports.minDictionaryWordLength = 4;
                exports.maxDictionaryWordLength = 24;
            /***/ },
            /***/ 80670: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var toPositiveInteger = __webpack_require__(64913);
                var RangeError1 = global.RangeError;
                module1.exports = function(it, BYTES) {
                    var offset = toPositiveInteger(it);
                    if (offset % BYTES) throw RangeError1('Wrong offset');
                    return offset;
                };
            /***/ },
            /***/ 80754: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__(15567);
                var uncurryThis = __webpack_require__(38347);
                var objectKeys = __webpack_require__(84675);
                var toIndexedObject = __webpack_require__(98086);
                var $propertyIsEnumerable = __webpack_require__(55574).f;
                var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
                var push = uncurryThis([].push);
                // `Object.{ entries, values }` methods implementation
                var createMethod = function(TO_ENTRIES) {
                    return function(it) {
                        var O = toIndexedObject(it);
                        var keys = objectKeys(O);
                        var length = keys.length;
                        var i = 0;
                        var result = [];
                        var key;
                        while(length > i){
                            key = keys[i++];
                            if (!DESCRIPTORS || propertyIsEnumerable(O, key)) push(result, TO_ENTRIES ? [
                                key,
                                O[key]
                            ] : O[key]);
                        }
                        return result;
                    };
                };
                module1.exports = {
                    // `Object.entries` method
                    // https://tc39.es/ecma262/#sec-object.entries
                    entries: createMethod(true),
                    // `Object.values` method
                    // https://tc39.es/ecma262/#sec-object.values
                    values: createMethod(false)
                };
            /***/ },
            /***/ 80986: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var IS_PURE = __webpack_require__(63432);
                var NativePromise = __webpack_require__(5155);
                var fails = __webpack_require__(47044);
                var getBuiltIn = __webpack_require__(38486);
                var isCallable = __webpack_require__(94578);
                var speciesConstructor = __webpack_require__(27754);
                var promiseResolve = __webpack_require__(28617);
                var redefine = __webpack_require__(13711);
                // Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
                var NON_GENERIC = !!NativePromise && fails(function() {
                    NativePromise.prototype['finally'].call({
                        then: function() {}
                    }, function() {});
                });
                // `Promise.prototype.finally` method
                // https://tc39.es/ecma262/#sec-promise.prototype.finally
                $({
                    target: 'Promise',
                    proto: true,
                    real: true,
                    forced: NON_GENERIC
                }, {
                    'finally': function(onFinally) {
                        var C = speciesConstructor(this, getBuiltIn('Promise'));
                        var isFunction = isCallable(onFinally);
                        return this.then(isFunction ? function(x) {
                            return promiseResolve(C, onFinally()).then(function() {
                                return x;
                            });
                        } : onFinally, isFunction ? function(e) {
                            return promiseResolve(C, onFinally()).then(function() {
                                throw e;
                            });
                        } : onFinally);
                    }
                });
                // makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
                if (!IS_PURE && isCallable(NativePromise)) {
                    var method = getBuiltIn('Promise').prototype['finally'];
                    if (NativePromise.prototype['finally'] !== method) redefine(NativePromise.prototype, 'finally', method, {
                        unsafe: true
                    });
                }
            /***/ },
            /***/ 81007: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__(47044);
                module1.exports = function(METHOD_NAME, argument) {
                    var method = [][METHOD_NAME];
                    return !!method && fails(function() {
                        // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
                        method.call(null, argument || function() {
                            throw 1;
                        }, 1);
                    });
                };
            /***/ },
            /***/ 81492: /***/ function(module1) {
                "use strict";
                // Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
                module1.exports = {
                    "437": "cp437",
                    "737": "cp737",
                    "775": "cp775",
                    "850": "cp850",
                    "852": "cp852",
                    "855": "cp855",
                    "856": "cp856",
                    "857": "cp857",
                    "858": "cp858",
                    "860": "cp860",
                    "861": "cp861",
                    "862": "cp862",
                    "863": "cp863",
                    "864": "cp864",
                    "865": "cp865",
                    "866": "cp866",
                    "869": "cp869",
                    "874": "windows874",
                    "922": "cp922",
                    "1046": "cp1046",
                    "1124": "cp1124",
                    "1125": "cp1125",
                    "1129": "cp1129",
                    "1133": "cp1133",
                    "1161": "cp1161",
                    "1162": "cp1162",
                    "1163": "cp1163",
                    "1250": "windows1250",
                    "1251": "windows1251",
                    "1252": "windows1252",
                    "1253": "windows1253",
                    "1254": "windows1254",
                    "1255": "windows1255",
                    "1256": "windows1256",
                    "1257": "windows1257",
                    "1258": "windows1258",
                    "28591": "iso88591",
                    "28592": "iso88592",
                    "28593": "iso88593",
                    "28594": "iso88594",
                    "28595": "iso88595",
                    "28596": "iso88596",
                    "28597": "iso88597",
                    "28598": "iso88598",
                    "28599": "iso88599",
                    "28600": "iso885910",
                    "28601": "iso885911",
                    "28603": "iso885913",
                    "28604": "iso885914",
                    "28605": "iso885915",
                    "28606": "iso885916",
                    "windows874": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "win874": "windows874",
                    "cp874": "windows874",
                    "windows1250": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
                    },
                    "win1250": "windows1250",
                    "cp1250": "windows1250",
                    "windows1251": {
                        "type": "_sbcs",
                        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
                    },
                    "win1251": "windows1251",
                    "cp1251": "windows1251",
                    "windows1252": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
                    },
                    "win1252": "windows1252",
                    "cp1252": "windows1252",
                    "windows1253": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
                    },
                    "win1253": "windows1253",
                    "cp1253": "windows1253",
                    "windows1254": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
                    },
                    "win1254": "windows1254",
                    "cp1254": "windows1254",
                    "windows1255": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\u05BA\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
                    },
                    "win1255": "windows1255",
                    "cp1255": "windows1255",
                    "windows1256": {
                        "type": "_sbcs",
                        "chars": "\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2"
                    },
                    "win1256": "windows1256",
                    "cp1256": "windows1256",
                    "windows1257": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9"
                    },
                    "win1257": "windows1257",
                    "cp1257": "windows1257",
                    "windows1258": {
                        "type": "_sbcs",
                        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
                    },
                    "win1258": "windows1258",
                    "cp1258": "windows1258",
                    "iso88591": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
                    },
                    "cp28591": "iso88591",
                    "iso88592": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u02D8\u0141\xa4\u013D\u015A\xa7\xa8\u0160\u015E\u0164\u0179\xad\u017D\u017B\xb0\u0105\u02DB\u0142\xb4\u013E\u015B\u02C7\xb8\u0161\u015F\u0165\u017A\u02DD\u017E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
                    },
                    "cp28592": "iso88592",
                    "iso88593": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0126\u02D8\xa3\xa4\uFFFD\u0124\xa7\xa8\u0130\u015E\u011E\u0134\xad\uFFFD\u017B\xb0\u0127\xb2\xb3\xb4\xb5\u0125\xb7\xb8\u0131\u015F\u011F\u0135\xbd\uFFFD\u017C\xc0\xc1\xc2\uFFFD\xc4\u010A\u0108\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\uFFFD\xd1\xd2\xd3\xd4\u0120\xd6\xd7\u011C\xd9\xda\xdb\xdc\u016C\u015C\xdf\xe0\xe1\xe2\uFFFD\xe4\u010B\u0109\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\uFFFD\xf1\xf2\xf3\xf4\u0121\xf6\xf7\u011D\xf9\xfa\xfb\xfc\u016D\u015D\u02D9"
                    },
                    "cp28593": "iso88593",
                    "iso88594": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0138\u0156\xa4\u0128\u013B\xa7\xa8\u0160\u0112\u0122\u0166\xad\u017D\xaf\xb0\u0105\u02DB\u0157\xb4\u0129\u013C\u02C7\xb8\u0161\u0113\u0123\u0167\u014A\u017E\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\u012A\u0110\u0145\u014C\u0136\xd4\xd5\xd6\xd7\xd8\u0172\xda\xdb\xdc\u0168\u016A\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\u012B\u0111\u0146\u014D\u0137\xf4\xf5\xf6\xf7\xf8\u0173\xfa\xfb\xfc\u0169\u016B\u02D9"
                    },
                    "cp28594": "iso88594",
                    "iso88595": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0403\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
                    },
                    "cp28595": "iso88595",
                    "iso88596": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\uFFFD\uFFFD\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u060C\xad\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u061B\uFFFD\uFFFD\uFFFD\u061F\uFFFD\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\u0638\u0639\u063A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "cp28596": "iso88596",
                    "iso88597": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u2018\u2019\xa3\u20AC\u20AF\xa6\xa7\xa8\xa9\u037A\xab\xac\xad\uFFFD\u2015\xb0\xb1\xb2\xb3\u0384\u0385\u0386\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
                    },
                    "cp28597": "iso88597",
                    "iso88598": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2017\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
                    },
                    "cp28598": "iso88598",
                    "iso88599": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
                    },
                    "cp28599": "iso88599",
                    "iso885910": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0112\u0122\u012A\u0128\u0136\xa7\u013B\u0110\u0160\u0166\u017D\xad\u016A\u014A\xb0\u0105\u0113\u0123\u012B\u0129\u0137\xb7\u013C\u0111\u0161\u0167\u017E\u2015\u016B\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\xcf\xd0\u0145\u014C\xd3\xd4\xd5\xd6\u0168\xd8\u0172\xda\xdb\xdc\xdd\xde\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\xef\xf0\u0146\u014D\xf3\xf4\xf5\xf6\u0169\xf8\u0173\xfa\xfb\xfc\xfd\xfe\u0138"
                    },
                    "cp28600": "iso885910",
                    "iso885911": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "cp28601": "iso885911",
                    "iso885913": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u201D\xa2\xa3\xa4\u201E\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\u201C\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u2019"
                    },
                    "cp28603": "iso885913",
                    "iso885914": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u1E02\u1E03\xa3\u010A\u010B\u1E0A\xa7\u1E80\xa9\u1E82\u1E0B\u1EF2\xad\xae\u0178\u1E1E\u1E1F\u0120\u0121\u1E40\u1E41\xb6\u1E56\u1E81\u1E57\u1E83\u1E60\u1EF3\u1E84\u1E85\u1E61\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0174\xd1\xd2\xd3\xd4\xd5\xd6\u1E6A\xd8\xd9\xda\xdb\xdc\xdd\u0176\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0175\xf1\xf2\xf3\xf4\xf5\xf6\u1E6B\xf8\xf9\xfa\xfb\xfc\xfd\u0177\xff"
                    },
                    "cp28604": "iso885914",
                    "iso885915": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\u0160\xa7\u0161\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u017D\xb5\xb6\xb7\u017E\xb9\xba\xbb\u0152\u0153\u0178\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
                    },
                    "cp28605": "iso885915",
                    "iso885916": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0105\u0141\u20AC\u201E\u0160\xa7\u0161\xa9\u0218\xab\u0179\xad\u017A\u017B\xb0\xb1\u010C\u0142\u017D\u201D\xb6\xb7\u017E\u010D\u0219\xbb\u0152\u0153\u0178\u017C\xc0\xc1\xc2\u0102\xc4\u0106\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0110\u0143\xd2\xd3\xd4\u0150\xd6\u015A\u0170\xd9\xda\xdb\xdc\u0118\u021A\xdf\xe0\xe1\xe2\u0103\xe4\u0107\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0111\u0144\xf2\xf3\xf4\u0151\xf6\u015B\u0171\xf9\xfa\xfb\xfc\u0119\u021B\xff"
                    },
                    "cp28606": "iso885916",
                    "cp437": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm437": "cp437",
                    "csibm437": "cp437",
                    "cp737": {
                        "type": "_sbcs",
                        "chars": "\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm737": "cp737",
                    "csibm737": "cp737",
                    "cp775": {
                        "type": "_sbcs",
                        "chars": "\u0106\xfc\xe9\u0101\xe4\u0123\xe5\u0107\u0142\u0113\u0156\u0157\u012B\u0179\xc4\xc5\xc9\xe6\xc6\u014D\xf6\u0122\xa2\u015A\u015B\xd6\xdc\xf8\xa3\xd8\xd7\xa4\u0100\u012A\xf3\u017B\u017C\u017A\u201D\xa6\xa9\xae\xac\xbd\xbc\u0141\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0104\u010C\u0118\u0116\u2563\u2551\u2557\u255D\u012E\u0160\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0172\u016A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u017D\u0105\u010D\u0119\u0117\u012F\u0161\u0173\u016B\u017E\u2518\u250C\u2588\u2584\u258C\u2590\u2580\xd3\xdf\u014C\u0143\xf5\xd5\xb5\u0144\u0136\u0137\u013B\u013C\u0146\u0112\u0145\u2019\xad\xb1\u201C\xbe\xb6\xa7\xf7\u201E\xb0\u2219\xb7\xb9\xb3\xb2\u25A0\xa0"
                    },
                    "ibm775": "cp775",
                    "csibm775": "cp775",
                    "cp850": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
                    },
                    "ibm850": "cp850",
                    "csibm850": "cp850",
                    "cp852": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0"
                    },
                    "ibm852": "cp852",
                    "csibm852": "cp852",
                    "cp855": {
                        "type": "_sbcs",
                        "chars": "\u0452\u0402\u0453\u0403\u0451\u0401\u0454\u0404\u0455\u0405\u0456\u0406\u0457\u0407\u0458\u0408\u0459\u0409\u045A\u040A\u045B\u040B\u045C\u040C\u045E\u040E\u045F\u040F\u044E\u042E\u044A\u042A\u0430\u0410\u0431\u0411\u0446\u0426\u0434\u0414\u0435\u0415\u0444\u0424\u0433\u0413\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0445\u0425\u0438\u0418\u2563\u2551\u2557\u255D\u0439\u0419\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u043A\u041A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u043B\u041B\u043C\u041C\u043D\u041D\u043E\u041E\u043F\u2518\u250C\u2588\u2584\u041F\u044F\u2580\u042F\u0440\u0420\u0441\u0421\u0442\u0422\u0443\u0423\u0436\u0416\u0432\u0412\u044C\u042C\u2116\xad\u044B\u042B\u0437\u0417\u0448\u0428\u044D\u042D\u0449\u0429\u0447\u0427\xa7\u25A0\xa0"
                    },
                    "ibm855": "cp855",
                    "csibm855": "cp855",
                    "cp856": {
                        "type": "_sbcs",
                        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\xa3\uFFFD\xd7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xae\xac\xbd\xbc\uFFFD\xab\xbb\u2591\u2592\u2593\u2502\u2524\uFFFD\uFFFD\uFFFD\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\uFFFD\uFFFD\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2518\u250C\u2588\u2584\xa6\uFFFD\u2580\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xb5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
                    },
                    "ibm856": "cp856",
                    "csibm856": "cp856",
                    "cp857": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
                    },
                    "ibm857": "cp857",
                    "csibm857": "cp857",
                    "cp858": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u20AC\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
                    },
                    "ibm858": "cp858",
                    "csibm858": "cp858",
                    "cp860": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe3\xe0\xc1\xe7\xea\xca\xe8\xcd\xd4\xec\xc3\xc2\xc9\xc0\xc8\xf4\xf5\xf2\xda\xf9\xcc\xd5\xdc\xa2\xa3\xd9\u20A7\xd3\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xd2\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm860": "cp860",
                    "csibm860": "cp860",
                    "cp861": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm861": "cp861",
                    "csibm861": "cp861",
                    "cp862": {
                        "type": "_sbcs",
                        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm862": "cp862",
                    "csibm862": "cp862",
                    "cp863": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xc2\xe0\xb6\xe7\xea\xeb\xe8\xef\xee\u2017\xc0\xa7\xc9\xc8\xca\xf4\xcb\xcf\xfb\xf9\xa4\xd4\xdc\xa2\xa3\xd9\xdb\u0192\xa6\xb4\xf3\xfa\xa8\xb8\xb3\xaf\xce\u2310\xac\xbd\xbc\xbe\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm863": "cp863",
                    "csibm863": "cp863",
                    "cp864": {
                        "type": "_sbcs",
                        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$\u066A&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xb0\xb7\u2219\u221A\u2592\u2500\u2502\u253C\u2524\u252C\u251C\u2534\u2510\u250C\u2514\u2518\u03B2\u221E\u03C6\xb1\xbd\xbc\u2248\xab\xbb\uFEF7\uFEF8\uFFFD\uFFFD\uFEFB\uFEFC\uFFFD\xa0\xad\uFE82\xa3\xa4\uFE84\uFFFD\uFFFD\uFE8E\uFE8F\uFE95\uFE99\u060C\uFE9D\uFEA1\uFEA5\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFED1\u061B\uFEB1\uFEB5\uFEB9\u061F\xa2\uFE80\uFE81\uFE83\uFE85\uFECA\uFE8B\uFE8D\uFE91\uFE93\uFE97\uFE9B\uFE9F\uFEA3\uFEA7\uFEA9\uFEAB\uFEAD\uFEAF\uFEB3\uFEB7\uFEBB\uFEBF\uFEC1\uFEC5\uFECB\uFECF\xa6\xac\xf7\xd7\uFEC9\u0640\uFED3\uFED7\uFEDB\uFEDF\uFEE3\uFEE7\uFEEB\uFEED\uFEEF\uFEF3\uFEBD\uFECC\uFECE\uFECD\uFEE1\uFE7D\u0651\uFEE5\uFEE9\uFEEC\uFEF0\uFEF2\uFED0\uFED5\uFEF5\uFEF6\uFEDD\uFED9\uFEF1\u25A0\uFFFD"
                    },
                    "ibm864": "cp864",
                    "csibm864": "cp864",
                    "cp865": {
                        "type": "_sbcs",
                        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "ibm865": "cp865",
                    "csibm865": "cp865",
                    "cp866": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0"
                    },
                    "ibm866": "cp866",
                    "csibm866": "cp866",
                    "cp869": {
                        "type": "_sbcs",
                        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0386\uFFFD\xb7\xac\xa6\u2018\u2019\u0388\u2015\u0389\u038A\u03AA\u038C\uFFFD\uFFFD\u038E\u03AB\xa9\u038F\xb2\xb3\u03AC\xa3\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03CD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\xbd\u0398\u0399\xab\xbb\u2591\u2592\u2593\u2502\u2524\u039A\u039B\u039C\u039D\u2563\u2551\u2557\u255D\u039E\u039F\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u03A0\u03A1\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u2518\u250C\u2588\u2584\u03B4\u03B5\u2580\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u0384\xad\xb1\u03C5\u03C6\u03C7\xa7\u03C8\u0385\xb0\xa8\u03C9\u03CB\u03B0\u03CE\u25A0\xa0"
                    },
                    "ibm869": "cp869",
                    "csibm869": "cp869",
                    "cp922": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\u203E\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0160\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\u017D\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0161\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\u017E\xff"
                    },
                    "ibm922": "cp922",
                    "csibm922": "cp922",
                    "cp1046": {
                        "type": "_sbcs",
                        "chars": "\uFE88\xd7\xf7\uF8F6\uF8F5\uF8F4\uF8F7\uFE71\x88\u25A0\u2502\u2500\u2510\u250C\u2514\u2518\uFE79\uFE7B\uFE7D\uFE7F\uFE77\uFE8A\uFEF0\uFEF3\uFEF2\uFECE\uFECF\uFED0\uFEF6\uFEF8\uFEFA\uFEFC\xa0\uF8FA\uF8F9\uF8F8\xa4\uF8FB\uFE8B\uFE91\uFE97\uFE9B\uFE9F\uFEA3\u060C\xad\uFEA7\uFEB3\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFEB7\u061B\uFEBB\uFEBF\uFECA\u061F\uFECB\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\uFEC7\u0639\u063A\uFECC\uFE82\uFE84\uFE8E\uFED3\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFED7\uFEDB\uFEDF\uF8FC\uFEF5\uFEF7\uFEF9\uFEFB\uFEE3\uFEE7\uFEEC\uFEE9\uFFFD"
                    },
                    "ibm1046": "cp1046",
                    "csibm1046": "cp1046",
                    "cp1124": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0490\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0491\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
                    },
                    "ibm1124": "cp1124",
                    "csibm1124": "cp1124",
                    "cp1125": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0490\u0491\u0404\u0454\u0406\u0456\u0407\u0457\xb7\u221A\u2116\xa4\u25A0\xa0"
                    },
                    "ibm1125": "cp1125",
                    "csibm1125": "cp1125",
                    "cp1129": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
                    },
                    "ibm1129": "cp1129",
                    "csibm1129": "cp1129",
                    "cp1133": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E81\u0E82\u0E84\u0E87\u0E88\u0EAA\u0E8A\u0E8D\u0E94\u0E95\u0E96\u0E97\u0E99\u0E9A\u0E9B\u0E9C\u0E9D\u0E9E\u0E9F\u0EA1\u0EA2\u0EA3\u0EA5\u0EA7\u0EAB\u0EAD\u0EAE\uFFFD\uFFFD\uFFFD\u0EAF\u0EB0\u0EB2\u0EB3\u0EB4\u0EB5\u0EB6\u0EB7\u0EB8\u0EB9\u0EBC\u0EB1\u0EBB\u0EBD\uFFFD\uFFFD\uFFFD\u0EC0\u0EC1\u0EC2\u0EC3\u0EC4\u0EC8\u0EC9\u0ECA\u0ECB\u0ECC\u0ECD\u0EC6\uFFFD\u0EDC\u0EDD\u20AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0ED0\u0ED1\u0ED2\u0ED3\u0ED4\u0ED5\u0ED6\u0ED7\u0ED8\u0ED9\uFFFD\uFFFD\xa2\xac\xa6\uFFFD"
                    },
                    "ibm1133": "cp1133",
                    "csibm1133": "cp1133",
                    "cp1161": {
                        "type": "_sbcs",
                        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E48\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\u0E49\u0E4A\u0E4B\u20AC\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\xa2\xac\xa6\xa0"
                    },
                    "ibm1161": "cp1161",
                    "csibm1161": "cp1161",
                    "cp1162": {
                        "type": "_sbcs",
                        "chars": "\u20AC\x81\x82\x83\x84\u2026\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "ibm1162": "cp1162",
                    "csibm1162": "cp1162",
                    "cp1163": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
                    },
                    "ibm1163": "cp1163",
                    "csibm1163": "cp1163",
                    "maccroatian": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u2126\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uFFFD\xa9\u2044\xa4\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7"
                    },
                    "maccyrillic": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
                    },
                    "macgreek": {
                        "type": "_sbcs",
                        "chars": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD"
                    },
                    "maciceland": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                    },
                    "macroman": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                    },
                    "macromania": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u015E\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\u0103\u015F\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\u0162\u0163\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                    },
                    "macthai": {
                        "type": "_sbcs",
                        "chars": "\xab\xbb\u2026\uF88C\uF88F\uF892\uF895\uF898\uF88B\uF88E\uF891\uF894\uF897\u201C\u201D\uF899\uFFFD\u2022\uF884\uF889\uF885\uF886\uF887\uF888\uF88A\uF88D\uF890\uF893\uF896\u2018\u2019\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFEFF\u200B\u2013\u2014\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u2122\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\xae\xa9\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "macturkish": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                    },
                    "macukraine": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
                    },
                    "koi8r": {
                        "type": "_sbcs",
                        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u0401\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
                    },
                    "koi8u": {
                        "type": "_sbcs",
                        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u255D\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
                    },
                    "koi8ru": {
                        "type": "_sbcs",
                        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u045E\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u040E\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
                    },
                    "koi8t": {
                        "type": "_sbcs",
                        "chars": "\u049B\u0493\u201A\u0492\u201E\u2026\u2020\u2021\uFFFD\u2030\u04B3\u2039\u04B2\u04B7\u04B6\uFFFD\u049A\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u04EF\u04EE\u0451\xa4\u04E3\xa6\xa7\uFFFD\uFFFD\uFFFD\xab\xac\xad\xae\uFFFD\xb0\xb1\xb2\u0401\uFFFD\u04E2\xb6\xb7\uFFFD\u2116\uFFFD\xbb\uFFFD\uFFFD\uFFFD\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
                    },
                    "armscii8": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\u0587\u0589)(\xbb\xab\u2014.\u055D,-\u058A\u2026\u055C\u055B\u055E\u0531\u0561\u0532\u0562\u0533\u0563\u0534\u0564\u0535\u0565\u0536\u0566\u0537\u0567\u0538\u0568\u0539\u0569\u053A\u056A\u053B\u056B\u053C\u056C\u053D\u056D\u053E\u056E\u053F\u056F\u0540\u0570\u0541\u0571\u0542\u0572\u0543\u0573\u0544\u0574\u0545\u0575\u0546\u0576\u0547\u0577\u0548\u0578\u0549\u0579\u054A\u057A\u054B\u057B\u054C\u057C\u054D\u057D\u054E\u057E\u054F\u057F\u0550\u0580\u0551\u0581\u0552\u0582\u0553\u0583\u0554\u0584\u0555\u0585\u0556\u0586\u055A\uFFFD"
                    },
                    "rk1048": {
                        "type": "_sbcs",
                        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u049A\u04BA\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u049B\u04BB\u045F\xa0\u04B0\u04B1\u04D8\xa4\u04E8\xa6\xa7\u0401\xa9\u0492\xab\xac\xad\xae\u04AE\xb0\xb1\u0406\u0456\u04E9\xb5\xb6\xb7\u0451\u2116\u0493\xbb\u04D9\u04A2\u04A3\u04AF\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
                    },
                    "tcvn": {
                        "type": "_sbcs",
                        "chars": "\0\xda\u1EE4\x03\u1EEA\u1EEC\u1EEE\x07\b	\n\v\f\r\x0e\x0f\x10\u1EE8\u1EF0\u1EF2\u1EF6\u1EF8\xdd\u1EF4\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc0\u1EA2\xc3\xc1\u1EA0\u1EB6\u1EAC\xc8\u1EBA\u1EBC\xc9\u1EB8\u1EC6\xcc\u1EC8\u0128\xcd\u1ECA\xd2\u1ECE\xd5\xd3\u1ECC\u1ED8\u1EDC\u1EDE\u1EE0\u1EDA\u1EE2\xd9\u1EE6\u0168\xa0\u0102\xc2\xca\xd4\u01A0\u01AF\u0110\u0103\xe2\xea\xf4\u01A1\u01B0\u0111\u1EB0\u0300\u0309\u0303\u0301\u0323\xe0\u1EA3\xe3\xe1\u1EA1\u1EB2\u1EB1\u1EB3\u1EB5\u1EAF\u1EB4\u1EAE\u1EA6\u1EA8\u1EAA\u1EA4\u1EC0\u1EB7\u1EA7\u1EA9\u1EAB\u1EA5\u1EAD\xe8\u1EC2\u1EBB\u1EBD\xe9\u1EB9\u1EC1\u1EC3\u1EC5\u1EBF\u1EC7\xec\u1EC9\u1EC4\u1EBE\u1ED2\u0129\xed\u1ECB\xf2\u1ED4\u1ECF\xf5\xf3\u1ECD\u1ED3\u1ED5\u1ED7\u1ED1\u1ED9\u1EDD\u1EDF\u1EE1\u1EDB\u1EE3\xf9\u1ED6\u1EE7\u0169\xfa\u1EE5\u1EEB\u1EED\u1EEF\u1EE9\u1EF1\u1EF3\u1EF7\u1EF9\xfd\u1EF5\u1ED0"
                    },
                    "georgianacademy": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10EF\u10F0\u10F1\u10F2\u10F3\u10F4\u10F5\u10F6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
                    },
                    "georgianps": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10F1\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10F2\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10F3\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10F4\u10EF\u10F0\u10F5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
                    },
                    "pt154": {
                        "type": "_sbcs",
                        "chars": "\u0496\u0492\u04EE\u0493\u201E\u2026\u04B6\u04AE\u04B2\u04AF\u04A0\u04E2\u04A2\u049A\u04BA\u04B8\u0497\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u04B3\u04B7\u04A1\u04E3\u04A3\u049B\u04BB\u04B9\xa0\u040E\u045E\u0408\u04E8\u0498\u04B0\xa7\u0401\xa9\u04D8\xab\xac\u04EF\xae\u049C\xb0\u04B1\u0406\u0456\u0499\u04E9\xb6\xb7\u0451\u2116\u04D9\xbb\u0458\u04AA\u04AB\u049D\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
                    },
                    "viscii": {
                        "type": "_sbcs",
                        "chars": "\0\x01\u1EB2\x03\x04\u1EB4\u1EAA\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\u1EF6\x15\x16\x17\x18\u1EF8\x1a\x1b\x1c\x1d\u1EF4\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u1EA0\u1EAE\u1EB0\u1EB6\u1EA4\u1EA6\u1EA8\u1EAC\u1EBC\u1EB8\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EE2\u1EDA\u1EDC\u1EDE\u1ECA\u1ECE\u1ECC\u1EC8\u1EE6\u0168\u1EE4\u1EF2\xd5\u1EAF\u1EB1\u1EB7\u1EA5\u1EA7\u1EA9\u1EAD\u1EBD\u1EB9\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1ED1\u1ED3\u1ED5\u1ED7\u1EE0\u01A0\u1ED9\u1EDD\u1EDF\u1ECB\u1EF0\u1EE8\u1EEA\u1EEC\u01A1\u1EDB\u01AF\xc0\xc1\xc2\xc3\u1EA2\u0102\u1EB3\u1EB5\xc8\xc9\xca\u1EBA\xcc\xcd\u0128\u1EF3\u0110\u1EE9\xd2\xd3\xd4\u1EA1\u1EF7\u1EEB\u1EED\xd9\xda\u1EF9\u1EF5\xdd\u1EE1\u01B0\xe0\xe1\xe2\xe3\u1EA3\u0103\u1EEF\u1EAB\xe8\xe9\xea\u1EBB\xec\xed\u0129\u1EC9\u0111\u1EF1\xf2\xf3\xf4\xf5\u1ECF\u1ECD\u1EE5\xf9\xfa\u0169\u1EE7\xfd\u1EE3\u1EEE"
                    },
                    "iso646cn": {
                        "type": "_sbcs",
                        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#\xa5%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "iso646jp": {
                        "type": "_sbcs",
                        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\xa5]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "hproman8": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xc0\xc2\xc8\xca\xcb\xce\xcf\xb4\u02CB\u02C6\xa8\u02DC\xd9\xdb\u20A4\xaf\xdd\xfd\xb0\xc7\xe7\xd1\xf1\xa1\xbf\xa4\xa3\xa5\xa7\u0192\xa2\xe2\xea\xf4\xfb\xe1\xe9\xf3\xfa\xe0\xe8\xf2\xf9\xe4\xeb\xf6\xfc\xc5\xee\xd8\xc6\xe5\xed\xf8\xe6\xc4\xec\xd6\xdc\xc9\xef\xdf\xd4\xc1\xc3\xe3\xd0\xf0\xcd\xcc\xd3\xd2\xd5\xf5\u0160\u0161\xda\u0178\xff\xde\xfe\xb7\xb5\xb6\xbe\u2014\xbc\xbd\xaa\xba\xab\u25A0\xbb\xb1\uFFFD"
                    },
                    "macintosh": {
                        "type": "_sbcs",
                        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                    },
                    "ascii": {
                        "type": "_sbcs",
                        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
                    },
                    "tis620": {
                        "type": "_sbcs",
                        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
                    }
                };
            /***/ },
            /***/ 81561: /***/ function(__unused_webpack_module, exports) {
                function HuffmanCode(bits, value) {
                    this.bits = bits; /* number of bits used for this symbol */ 
                    this.value = value; /* symbol value or table offset */ 
                }
                exports.z = HuffmanCode;
                var MAX_LENGTH = 15;
                /* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */ function GetNextKey(key, len) {
                    var step = 1 << len - 1;
                    while(key & step)step >>= 1;
                    return (key & step - 1) + step;
                }
                /* Stores code in table[0], table[step], table[2*step], ..., table[end] */ /* Assumes that end is an integer multiple of step */ function ReplicateValue(table, i, step, end, code) {
                    do {
                        end -= step;
                        table[i + end] = new HuffmanCode(code.bits, code.value);
                    }while (end > 0);
                }
                /* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */ function NextTableBitSize(count, len, root_bits) {
                    var left = 1 << len - root_bits;
                    while(len < MAX_LENGTH){
                        left -= count[len];
                        if (left <= 0) break;
                        ++len;
                        left <<= 1;
                    }
                    return len - root_bits;
                }
                exports.u = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
                    var start_table = table;
                    var code; /* current table entry */ 
                    var len; /* current code length */ 
                    var symbol; /* symbol index in original or sorted table */ 
                    var key; /* reversed prefix code */ 
                    var step; /* step size to replicate values in current table */ 
                    var low; /* low bits for current root entry */ 
                    var mask; /* mask for low bits */ 
                    var table_bits; /* key length of current table */ 
                    var table_size; /* size of current table */ 
                    var total_size; /* sum of root table size and 2nd level table sizes */ 
                    var sorted; /* symbols sorted by code length */ 
                    var count = new Int32Array(MAX_LENGTH + 1); /* number of codes of each length */ 
                    var offset = new Int32Array(MAX_LENGTH + 1); /* offsets in sorted table for each length */ 
                    sorted = new Int32Array(code_lengths_size);
                    /* build histogram of code lengths */ for(symbol = 0; symbol < code_lengths_size; symbol++)count[code_lengths[symbol]]++;
                    /* generate offsets into sorted symbol table by code length */ offset[1] = 0;
                    for(len = 1; len < MAX_LENGTH; len++)offset[len + 1] = offset[len] + count[len];
                    /* sort symbols by length, by symbol order within each length */ for(symbol = 0; symbol < code_lengths_size; symbol++)if (code_lengths[symbol] !== 0) sorted[offset[code_lengths[symbol]]++] = symbol;
                    table_bits = root_bits;
                    table_size = 1 << table_bits;
                    total_size = table_size;
                    /* special case code with only one value */ if (offset[MAX_LENGTH] === 1) {
                        for(key = 0; key < total_size; ++key)root_table[table + key] = new HuffmanCode(0, sorted[0] & 0xffff);
                        return total_size;
                    }
                    /* fill in root table */ key = 0;
                    symbol = 0;
                    for(len = 1, step = 2; len <= root_bits; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
                        code = new HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
                        ReplicateValue(root_table, table + key, step, table_size, code);
                        key = GetNextKey(key, len);
                    }
                    /* fill in 2nd level tables and add pointers to root table */ mask = total_size - 1;
                    low = -1;
                    for(len = root_bits + 1, step = 2; len <= MAX_LENGTH; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
                        if ((key & mask) !== low) {
                            table += table_size;
                            table_bits = NextTableBitSize(count, len, root_bits);
                            table_size = 1 << table_bits;
                            total_size += table_size;
                            low = key & mask;
                            root_table[start_table + low] = new HuffmanCode(table_bits + root_bits & 0xff, table - start_table - low & 0xffff);
                        }
                        code = new HuffmanCode(len - root_bits & 0xff, sorted[symbol++] & 0xffff);
                        ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
                        key = GetNextKey(key, len);
                    }
                    return total_size;
                };
            /***/ },
            /***/ 81566: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /*eslint no-unused-vars: ["error", {"args": "none"}]*/ var PdfKitEngine = __webpack_require__(85208);
                var FontProvider = __webpack_require__(28284);
                var LayoutBuilder = __webpack_require__(65300);
                var sizes = __webpack_require__(70098);
                var ImageMeasure = __webpack_require__(93415);
                var SVGMeasure = __webpack_require__(89638);
                var textDecorator = __webpack_require__(84786);
                var TextTools = __webpack_require__(11548);
                var isFunction = __webpack_require__(91867).isFunction;
                var isString = __webpack_require__(91867).isString;
                var isNumber = __webpack_require__(91867).isNumber;
                var isBoolean = __webpack_require__(91867).isBoolean;
                var isArray = __webpack_require__(91867).isArray;
                var isUndefined = __webpack_require__(91867).isUndefined;
                var isPattern = __webpack_require__(91867).isPattern;
                var getPattern = __webpack_require__(91867).getPattern;
                var SVGtoPDF = __webpack_require__(5557);
                var findFont = function(fonts, requiredFonts, defaultFont) {
                    for(var i = 0; i < requiredFonts.length; i++){
                        var requiredFont = requiredFonts[i].toLowerCase();
                        for(var font in fonts){
                            if (font.toLowerCase() === requiredFont) return font;
                        }
                    }
                    return defaultFont;
                };
                ////////////////////////////////////////
                // PdfPrinter
                /**
 * @class Creates an instance of a PdfPrinter which turns document definition into a pdf
 *
 * @param {Object} fontDescriptors font definition dictionary
 *
 * @example
 * var fontDescriptors = {
 *	Roboto: {
 *		normal: 'fonts/Roboto-Regular.ttf',
 *		bold: 'fonts/Roboto-Medium.ttf',
 *		italics: 'fonts/Roboto-Italic.ttf',
 *		bolditalics: 'fonts/Roboto-MediumItalic.ttf'
 *	}
 * };
 *
 * var printer = new PdfPrinter(fontDescriptors);
 */ function PdfPrinter(fontDescriptors) {
                    this.fontDescriptors = fontDescriptors;
                }
                /**
 * Executes layout engine for the specified document and renders it into a pdfkit document
 * ready to be saved.
 *
 * @param {Object} docDefinition document definition
 * @param {Object} docDefinition.content an array describing the pdf structure (for more information take a look at the examples in the /examples folder)
 * @param {Object} [docDefinition.defaultStyle] default (implicit) style definition
 * @param {Object} [docDefinition.styles] dictionary defining all styles which can be used in the document
 * @param {Object} [docDefinition.pageSize] page size (pdfkit units, A4 dimensions by default)
 * @param {Number} docDefinition.pageSize.width width
 * @param {Number} docDefinition.pageSize.height height
 * @param {Object} [docDefinition.pageMargins] page margins (pdfkit units)
 * @param {Number} docDefinition.maxPagesNumber maximum number of pages to render
 *
 * @example
 *
 * var docDefinition = {
 * 	info: {
 *		title: 'awesome Document',
 *		author: 'john doe',
 *		subject: 'subject of document',
 *		keywords: 'keywords for document',
 * 	},
 *	content: [
 *		'First paragraph',
 *		'Second paragraph, this time a little bit longer',
 *		{ text: 'Third paragraph, slightly bigger font size', fontSize: 20 },
 *		{ text: 'Another paragraph using a named style', style: 'header' },
 *		{ text: ['playing with ', 'inlines' ] },
 *		{ text: ['and ', { text: 'restyling ', bold: true }, 'them'] },
 *	],
 *	styles: {
 *		header: { fontSize: 30, bold: true }
 *	},
 *	patterns: {
 *		stripe45d: {
 *			boundingBox: [1, 1, 4, 4],
 *			xStep: 3,
 *			yStep: 3,
 *			pattern: '1 w 0 1 m 4 5 l s 2 0 m 5 3 l s'
 *		}
 *	}
 * };
 *
 * var pdfKitDoc = printer.createPdfKitDocument(docDefinition);
 *
 * pdfKitDoc.pipe(fs.createWriteStream('sample.pdf'));
 * pdfKitDoc.end();
 *
 * @return {Object} a pdfKit document object which can be saved or encode to data-url
 */ PdfPrinter.prototype.createPdfKitDocument = function(docDefinition, options) {
                    options = options || {};
                    docDefinition.version = docDefinition.version || '1.3';
                    docDefinition.subset = docDefinition.subset || undefined;
                    docDefinition.tagged = typeof docDefinition.tagged === 'boolean' ? docDefinition.tagged : false;
                    docDefinition.displayTitle = typeof docDefinition.displayTitle === 'boolean' ? docDefinition.displayTitle : false;
                    docDefinition.compress = isBoolean(docDefinition.compress) ? docDefinition.compress : true;
                    docDefinition.images = docDefinition.images || {};
                    docDefinition.pageMargins = docDefinition.pageMargins !== undefined && docDefinition.pageMargins !== null ? docDefinition.pageMargins : 40;
                    var pageSize = fixPageSize(docDefinition.pageSize, docDefinition.pageOrientation);
                    var pdfOptions = {
                        size: [
                            pageSize.width,
                            pageSize.height
                        ],
                        pdfVersion: docDefinition.version,
                        subset: docDefinition.subset,
                        tagged: docDefinition.tagged,
                        displayTitle: docDefinition.displayTitle,
                        compress: docDefinition.compress,
                        userPassword: docDefinition.userPassword,
                        ownerPassword: docDefinition.ownerPassword,
                        permissions: docDefinition.permissions,
                        lang: docDefinition.language,
                        fontLayoutCache: isBoolean(options.fontLayoutCache) ? options.fontLayoutCache : true,
                        bufferPages: options.bufferPages || false,
                        autoFirstPage: false,
                        info: createMetadata(docDefinition),
                        font: null
                    };
                    this.pdfKitDoc = PdfKitEngine.createPdfDocument(pdfOptions);
                    this.fontProvider = new FontProvider(this.fontDescriptors, this.pdfKitDoc);
                    var builder = new LayoutBuilder(pageSize, fixPageMargins(docDefinition.pageMargins), new ImageMeasure(this.pdfKitDoc, docDefinition.images), new SVGMeasure());
                    registerDefaultTableLayouts(builder);
                    if (options.tableLayouts) builder.registerTableLayouts(options.tableLayouts);
                    var pages = builder.layoutDocument(docDefinition.content, this.fontProvider, docDefinition.styles || {}, docDefinition.defaultStyle || {
                        fontSize: 12,
                        font: 'Roboto'
                    }, docDefinition.background, docDefinition.header, docDefinition.footer, docDefinition.images, docDefinition.watermark, docDefinition.pageBreakBefore);
                    var maxNumberPages = docDefinition.maxPagesNumber || -1;
                    if (isNumber(maxNumberPages) && maxNumberPages > -1) pages = pages.slice(0, maxNumberPages);
                    // if pageSize.height is set to Infinity, calculate the actual height of the page that
                    // was laid out using the height of each of the items in the page.
                    if (pageSize.height === Infinity) {
                        var pageHeight = calculatePageHeight(pages, docDefinition.pageMargins);
                        this.pdfKitDoc.options.size = [
                            pageSize.width,
                            pageHeight
                        ];
                    }
                    var patterns = createPatterns(docDefinition.patterns || {}, this.pdfKitDoc);
                    renderPages(pages, this.fontProvider, this.pdfKitDoc, patterns, options.progressCallback);
                    if (options.autoPrint) {
                        var printActionRef = this.pdfKitDoc.ref({
                            Type: 'Action',
                            S: 'Named',
                            N: 'Print'
                        });
                        this.pdfKitDoc._root.data.OpenAction = printActionRef;
                        printActionRef.end();
                    }
                    return this.pdfKitDoc;
                };
                function createMetadata(docDefinition) {
                    // PDF standard has these properties reserved: Title, Author, Subject, Keywords,
                    // Creator, Producer, CreationDate, ModDate, Trapped.
                    // To keep the pdfmake api consistent, the info field are defined lowercase.
                    // Custom properties don't contain a space.
                    function standardizePropertyKey(key) {
                        var standardProperties = [
                            'Title',
                            'Author',
                            'Subject',
                            'Keywords',
                            'Creator',
                            'Producer',
                            'CreationDate',
                            'ModDate',
                            'Trapped'
                        ];
                        var standardizedKey = key.charAt(0).toUpperCase() + key.slice(1);
                        if (standardProperties.indexOf(standardizedKey) !== -1) return standardizedKey;
                        return key.replace(/\s+/g, '');
                    }
                    var info = {
                        Producer: 'pdfmake',
                        Creator: 'pdfmake'
                    };
                    if (docDefinition.info) for(var key in docDefinition.info){
                        var value = docDefinition.info[key];
                        if (value) {
                            key = standardizePropertyKey(key);
                            info[key] = value;
                        }
                    }
                    return info;
                }
                function calculatePageHeight(pages, margins) {
                    function getItemHeight(item) {
                        if (isFunction(item.item.getHeight)) return item.item.getHeight();
                        else if (item.item._height) return item.item._height;
                        else if (item.type === 'vector') {
                            if (typeof item.item.y1 !== 'undefined') return item.item.y1 > item.item.y2 ? item.item.y1 : item.item.y2;
                            else return item.item.h;
                        } else // TODO: add support for next item types
                        return 0;
                    }
                    function getBottomPosition(item) {
                        var top = item.item.y || 0;
                        var height = getItemHeight(item);
                        return top + height;
                    }
                    var fixedMargins = fixPageMargins(margins || 40);
                    var height = fixedMargins.top;
                    pages.forEach(function(page) {
                        page.items.forEach(function(item) {
                            var bottomPosition = getBottomPosition(item);
                            if (bottomPosition > height) height = bottomPosition;
                        });
                    });
                    height += fixedMargins.bottom;
                    return height;
                }
                function fixPageSize(pageSize, pageOrientation) {
                    function isNeedSwapPageSizes(pageOrientation) {
                        if (isString(pageOrientation)) {
                            pageOrientation = pageOrientation.toLowerCase();
                            return pageOrientation === 'portrait' && size.width > size.height || pageOrientation === 'landscape' && size.width < size.height;
                        }
                        return false;
                    }
                    // if pageSize.height is set to auto, set the height to infinity so there are no page breaks.
                    if (pageSize && pageSize.height === 'auto') pageSize.height = Infinity;
                    var size = pageSize2widthAndHeight(pageSize || 'A4');
                    if (isNeedSwapPageSizes(pageOrientation)) size = {
                        width: size.height,
                        height: size.width
                    };
                    size.orientation = size.width > size.height ? 'landscape' : 'portrait';
                    return size;
                }
                function fixPageMargins(margin) {
                    if (isNumber(margin)) margin = {
                        left: margin,
                        right: margin,
                        top: margin,
                        bottom: margin
                    };
                    else if (isArray(margin)) {
                        if (margin.length === 2) margin = {
                            left: margin[0],
                            top: margin[1],
                            right: margin[0],
                            bottom: margin[1]
                        };
                        else if (margin.length === 4) margin = {
                            left: margin[0],
                            top: margin[1],
                            right: margin[2],
                            bottom: margin[3]
                        };
                        else throw 'Invalid pageMargins definition';
                    }
                    return margin;
                }
                function registerDefaultTableLayouts(layoutBuilder) {
                    layoutBuilder.registerTableLayouts({
                        noBorders: {
                            hLineWidth: function(i) {
                                return 0;
                            },
                            vLineWidth: function(i) {
                                return 0;
                            },
                            paddingLeft: function(i) {
                                return i && 4 || 0;
                            },
                            paddingRight: function(i, node) {
                                return i < node.table.widths.length - 1 ? 4 : 0;
                            }
                        },
                        headerLineOnly: {
                            hLineWidth: function(i, node) {
                                if (i === 0 || i === node.table.body.length) return 0;
                                return i === node.table.headerRows ? 2 : 0;
                            },
                            vLineWidth: function(i) {
                                return 0;
                            },
                            paddingLeft: function(i) {
                                return i === 0 ? 0 : 8;
                            },
                            paddingRight: function(i, node) {
                                return i === node.table.widths.length - 1 ? 0 : 8;
                            }
                        },
                        lightHorizontalLines: {
                            hLineWidth: function(i, node) {
                                if (i === 0 || i === node.table.body.length) return 0;
                                return i === node.table.headerRows ? 2 : 1;
                            },
                            vLineWidth: function(i) {
                                return 0;
                            },
                            hLineColor: function(i) {
                                return i === 1 ? 'black' : '#aaa';
                            },
                            paddingLeft: function(i) {
                                return i === 0 ? 0 : 8;
                            },
                            paddingRight: function(i, node) {
                                return i === node.table.widths.length - 1 ? 0 : 8;
                            }
                        }
                    });
                }
                function pageSize2widthAndHeight(pageSize) {
                    if (isString(pageSize)) {
                        var size = sizes[pageSize.toUpperCase()];
                        if (!size) throw 'Page size ' + pageSize + ' not recognized';
                        return {
                            width: size[0],
                            height: size[1]
                        };
                    }
                    return pageSize;
                }
                function updatePageOrientationInOptions(currentPage, pdfKitDoc) {
                    var previousPageOrientation = pdfKitDoc.options.size[0] > pdfKitDoc.options.size[1] ? 'landscape' : 'portrait';
                    if (currentPage.pageSize.orientation !== previousPageOrientation) {
                        var width = pdfKitDoc.options.size[0];
                        var height = pdfKitDoc.options.size[1];
                        pdfKitDoc.options.size = [
                            height,
                            width
                        ];
                    }
                }
                function renderPages(pages, fontProvider, pdfKitDoc, patterns, progressCallback) {
                    pdfKitDoc._pdfMakePages = pages;
                    pdfKitDoc.addPage();
                    var totalItems = 0;
                    if (progressCallback) pages.forEach(function(page) {
                        totalItems += page.items.length;
                    });
                    var renderedItems = 0;
                    progressCallback = progressCallback || function() {};
                    for(var i = 0; i < pages.length; i++){
                        if (i > 0) {
                            updatePageOrientationInOptions(pages[i], pdfKitDoc);
                            pdfKitDoc.addPage(pdfKitDoc.options);
                        }
                        var page = pages[i];
                        for(var ii = 0, il = page.items.length; ii < il; ii++){
                            var item = page.items[ii];
                            switch(item.type){
                                case 'vector':
                                    renderVector(item.item, patterns, pdfKitDoc);
                                    break;
                                case 'line':
                                    renderLine(item.item, item.item.x, item.item.y, patterns, pdfKitDoc);
                                    break;
                                case 'image':
                                    renderImage(item.item, item.item.x, item.item.y, pdfKitDoc);
                                    break;
                                case 'svg':
                                    renderSVG(item.item, item.item.x, item.item.y, pdfKitDoc, fontProvider);
                                    break;
                                case 'beginClip':
                                    beginClip(item.item, pdfKitDoc);
                                    break;
                                case 'endClip':
                                    endClip(pdfKitDoc);
                                    break;
                            }
                            renderedItems++;
                            progressCallback(renderedItems / totalItems);
                        }
                        if (page.watermark) renderWatermark(page, pdfKitDoc);
                    }
                }
                /**
 * Shift the "y" height of the text baseline up or down (superscript or subscript,
 * respectively). The exact shift can / should be changed according to standard
 * conventions.
 *
 * @param {number} y
 * @param {any} inline
 */ function offsetText(y, inline) {
                    var newY = y;
                    if (inline.sup) newY -= inline.fontSize * 0.75;
                    if (inline.sub) newY += inline.fontSize * 0.35;
                    return newY;
                }
                function renderLine(line, x, y, patterns, pdfKitDoc) {
                    function preparePageNodeRefLine(_pageNodeRef, inline) {
                        var newWidth;
                        var diffWidth;
                        var textTools = new TextTools(null);
                        if (isUndefined(_pageNodeRef.positions)) throw 'Page reference id not found';
                        var pageNumber = _pageNodeRef.positions[0].pageNumber.toString();
                        inline.text = pageNumber;
                        newWidth = textTools.widthOfString(inline.text, inline.font, inline.fontSize, inline.characterSpacing, inline.fontFeatures);
                        diffWidth = inline.width - newWidth;
                        inline.width = newWidth;
                        switch(inline.alignment){
                            case 'right':
                                inline.x += diffWidth;
                                break;
                            case 'center':
                                inline.x += diffWidth / 2;
                                break;
                        }
                    }
                    if (line._pageNodeRef) preparePageNodeRefLine(line._pageNodeRef, line.inlines[0]);
                    x = x || 0;
                    y = y || 0;
                    var lineHeight = line.getHeight();
                    var ascenderHeight = line.getAscenderHeight();
                    var descent = lineHeight - ascenderHeight;
                    textDecorator.drawBackground(line, x, y, patterns, pdfKitDoc);
                    //TODO: line.optimizeInlines();
                    for(var i = 0, l = line.inlines.length; i < l; i++){
                        var inline = line.inlines[i];
                        var shiftToBaseline = lineHeight - inline.font.ascender / 1000 * inline.fontSize - descent;
                        if (inline._pageNodeRef) preparePageNodeRefLine(inline._pageNodeRef, inline);
                        var options = {
                            lineBreak: false,
                            textWidth: inline.width,
                            characterSpacing: inline.characterSpacing,
                            wordCount: 1,
                            link: inline.link
                        };
                        if (inline.linkToDestination) options.goTo = inline.linkToDestination;
                        if (line.id && i === 0) options.destination = line.id;
                        if (inline.fontFeatures) options.features = inline.fontFeatures;
                        var opacity = isNumber(inline.opacity) ? inline.opacity : 1;
                        pdfKitDoc.opacity(opacity);
                        pdfKitDoc.fill(inline.color || 'black');
                        pdfKitDoc._font = inline.font;
                        pdfKitDoc.fontSize(inline.fontSize);
                        var shiftedY = offsetText(y + shiftToBaseline, inline);
                        pdfKitDoc.text(inline.text, x + inline.x, shiftedY, options);
                        if (inline.linkToPage) {
                            var _ref = pdfKitDoc.ref({
                                Type: 'Action',
                                S: 'GoTo',
                                D: [
                                    inline.linkToPage,
                                    0,
                                    0
                                ]
                            }).end();
                            pdfKitDoc.annotate(x + inline.x, shiftedY, inline.width, inline.height, {
                                Subtype: 'Link',
                                Dest: [
                                    inline.linkToPage - 1,
                                    'XYZ',
                                    null,
                                    null,
                                    null
                                ]
                            });
                        }
                    }
                    // Decorations won't draw correctly for superscript
                    textDecorator.drawDecorations(line, x, y, pdfKitDoc);
                }
                function renderWatermark(page, pdfKitDoc) {
                    var watermark = page.watermark;
                    pdfKitDoc.fill(watermark.color);
                    pdfKitDoc.opacity(watermark.opacity);
                    pdfKitDoc.save();
                    pdfKitDoc.rotate(watermark.angle, {
                        origin: [
                            pdfKitDoc.page.width / 2,
                            pdfKitDoc.page.height / 2
                        ]
                    });
                    var x = pdfKitDoc.page.width / 2 - watermark._size.size.width / 2;
                    var y = pdfKitDoc.page.height / 2 - watermark._size.size.height / 2;
                    pdfKitDoc._font = watermark.font;
                    pdfKitDoc.fontSize(watermark.fontSize);
                    pdfKitDoc.text(watermark.text, x, y, {
                        lineBreak: false
                    });
                    pdfKitDoc.restore();
                }
                function renderVector(vector, patterns, pdfKitDoc) {
                    //TODO: pdf optimization (there's no need to write all properties everytime)
                    pdfKitDoc.lineWidth(vector.lineWidth || 1);
                    if (vector.dash) pdfKitDoc.dash(vector.dash.length, {
                        space: vector.dash.space || vector.dash.length,
                        phase: vector.dash.phase || 0
                    });
                    else pdfKitDoc.undash();
                    pdfKitDoc.lineJoin(vector.lineJoin || 'miter');
                    pdfKitDoc.lineCap(vector.lineCap || 'butt');
                    //TODO: clipping
                    var gradient = null;
                    switch(vector.type){
                        case 'ellipse':
                            pdfKitDoc.ellipse(vector.x, vector.y, vector.r1, vector.r2);
                            if (vector.linearGradient) gradient = pdfKitDoc.linearGradient(vector.x - vector.r1, vector.y, vector.x + vector.r1, vector.y);
                            break;
                        case 'rect':
                            if (vector.r) pdfKitDoc.roundedRect(vector.x, vector.y, vector.w, vector.h, vector.r);
                            else pdfKitDoc.rect(vector.x, vector.y, vector.w, vector.h);
                            if (vector.linearGradient) gradient = pdfKitDoc.linearGradient(vector.x, vector.y, vector.x + vector.w, vector.y);
                            break;
                        case 'line':
                            pdfKitDoc.moveTo(vector.x1, vector.y1);
                            pdfKitDoc.lineTo(vector.x2, vector.y2);
                            break;
                        case 'polyline':
                            if (vector.points.length === 0) break;
                            pdfKitDoc.moveTo(vector.points[0].x, vector.points[0].y);
                            for(var i = 1, l = vector.points.length; i < l; i++)pdfKitDoc.lineTo(vector.points[i].x, vector.points[i].y);
                            if (vector.points.length > 1) {
                                var p1 = vector.points[0];
                                var pn = vector.points[vector.points.length - 1];
                                if (vector.closePath || p1.x === pn.x && p1.y === pn.y) pdfKitDoc.closePath();
                            }
                            break;
                        case 'path':
                            pdfKitDoc.path(vector.d);
                            break;
                    }
                    if (vector.linearGradient && gradient) {
                        var step = 1 / (vector.linearGradient.length - 1);
                        for(var i = 0; i < vector.linearGradient.length; i++)gradient.stop(i * step, vector.linearGradient[i]);
                        vector.color = gradient;
                    }
                    if (isPattern(vector.color)) vector.color = getPattern(vector.color, patterns);
                    var fillOpacity = isNumber(vector.fillOpacity) ? vector.fillOpacity : 1;
                    var strokeOpacity = isNumber(vector.strokeOpacity) ? vector.strokeOpacity : 1;
                    if (vector.color && vector.lineColor) {
                        pdfKitDoc.fillColor(vector.color, fillOpacity);
                        pdfKitDoc.strokeColor(vector.lineColor, strokeOpacity);
                        pdfKitDoc.fillAndStroke();
                    } else if (vector.color) {
                        pdfKitDoc.fillColor(vector.color, fillOpacity);
                        pdfKitDoc.fill();
                    } else {
                        pdfKitDoc.strokeColor(vector.lineColor || 'black', strokeOpacity);
                        pdfKitDoc.stroke();
                    }
                }
                function renderImage(image, x, y, pdfKitDoc) {
                    var opacity = isNumber(image.opacity) ? image.opacity : 1;
                    pdfKitDoc.opacity(opacity);
                    if (image.cover) {
                        var align = image.cover.align || 'center';
                        var valign = image.cover.valign || 'center';
                        var width = image.cover.width ? image.cover.width : image.width;
                        var height = image.cover.height ? image.cover.height : image.height;
                        pdfKitDoc.save();
                        pdfKitDoc.rect(image.x, image.y, width, height).clip();
                        pdfKitDoc.image(image.image, image.x, image.y, {
                            cover: [
                                width,
                                height
                            ],
                            align: align,
                            valign: valign
                        });
                        pdfKitDoc.restore();
                    } else pdfKitDoc.image(image.image, image.x, image.y, {
                        width: image._width,
                        height: image._height
                    });
                    if (image.link) pdfKitDoc.link(image.x, image.y, image._width, image._height, image.link);
                    if (image.linkToPage) {
                        pdfKitDoc.ref({
                            Type: 'Action',
                            S: 'GoTo',
                            D: [
                                image.linkToPage,
                                0,
                                0
                            ]
                        }).end();
                        pdfKitDoc.annotate(image.x, image.y, image._width, image._height, {
                            Subtype: 'Link',
                            Dest: [
                                image.linkToPage - 1,
                                'XYZ',
                                null,
                                null,
                                null
                            ]
                        });
                    }
                    if (image.linkToDestination) pdfKitDoc.goTo(image.x, image.y, image._width, image._height, image.linkToDestination);
                }
                function renderSVG(svg, x, y, pdfKitDoc, fontProvider) {
                    var options = Object.assign({
                        width: svg._width,
                        height: svg._height,
                        assumePt: true
                    }, svg.options);
                    options.fontCallback = function(family, bold, italic) {
                        var fontsFamily = family.split(',').map(function(f) {
                            return f.trim().replace(/('|")/g, '');
                        });
                        var font = findFont(fontProvider.fonts, fontsFamily, svg.font || 'Roboto');
                        var fontFile = fontProvider.getFontFile(font, bold, italic);
                        if (fontFile === null) {
                            var type = fontProvider.getFontType(bold, italic);
                            throw new Error('Font \'' + font + '\' in style \'' + type + '\' is not defined in the font section of the document definition.');
                        }
                        return fontFile;
                    };
                    SVGtoPDF(pdfKitDoc, svg.svg, svg.x, svg.y, options);
                    if (svg.link) pdfKitDoc.link(svg.x, svg.y, svg._width, svg._height, svg.link);
                    if (svg.linkToPage) {
                        pdfKitDoc.ref({
                            Type: 'Action',
                            S: 'GoTo',
                            D: [
                                svg.linkToPage,
                                0,
                                0
                            ]
                        }).end();
                        pdfKitDoc.annotate(svg.x, svg.y, svg._width, svg._height, {
                            Subtype: 'Link',
                            Dest: [
                                svg.linkToPage - 1,
                                'XYZ',
                                null,
                                null,
                                null
                            ]
                        });
                    }
                    if (svg.linkToDestination) pdfKitDoc.goTo(svg.x, svg.y, svg._width, svg._height, svg.linkToDestination);
                }
                function beginClip(rect, pdfKitDoc) {
                    pdfKitDoc.save();
                    pdfKitDoc.addContent('' + rect.x + ' ' + rect.y + ' ' + rect.width + ' ' + rect.height + ' re');
                    pdfKitDoc.clip();
                }
                function endClip(pdfKitDoc) {
                    pdfKitDoc.restore();
                }
                function createPatterns(patternDefinitions, pdfKitDoc) {
                    var patterns = {};
                    Object.keys(patternDefinitions).forEach(function(p) {
                        var pattern = patternDefinitions[p];
                        patterns[p] = pdfKitDoc.pattern(pattern.boundingBox, pattern.xStep, pattern.yStep, pattern.pattern, pattern.colored);
                    });
                    return patterns;
                }
                module1.exports = PdfPrinter;
            /***/ },
            /***/ 81607: /***/ function(module1) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                module1.exports = {
                    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    //Z_MEM_ERROR:     -4,
                    Z_BUF_ERROR: -5,
                    //Z_VERSION_ERROR: -6,
                    /* compression levels */ Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
                    Z_TEXT: 1,
                    //Z_ASCII:                1, // = Z_TEXT (deprecated)
                    Z_UNKNOWN: 2,
                    /* The deflate compression method */ Z_DEFLATED: 8
                };
            /***/ },
            /***/ 81755: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toIndexedObject = __webpack_require__(98086);
                var addToUnscopables = __webpack_require__(71156);
                var Iterators = __webpack_require__(15366);
                var InternalStateModule = __webpack_require__(70172);
                var defineIterator = __webpack_require__(97001);
                var ARRAY_ITERATOR = 'Array Iterator';
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
                // `Array.prototype.entries` method
                // https://tc39.es/ecma262/#sec-array.prototype.entries
                // `Array.prototype.keys` method
                // https://tc39.es/ecma262/#sec-array.prototype.keys
                // `Array.prototype.values` method
                // https://tc39.es/ecma262/#sec-array.prototype.values
                // `Array.prototype[@@iterator]` method
                // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
                // `CreateArrayIterator` internal method
                // https://tc39.es/ecma262/#sec-createarrayiterator
                module1.exports = defineIterator(Array, 'Array', function(iterated, kind) {
                    setInternalState(this, {
                        type: ARRAY_ITERATOR,
                        target: toIndexedObject(iterated),
                        index: 0,
                        kind: kind // kind
                    });
                // `%ArrayIteratorPrototype%.next` method
                // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
                }, function() {
                    var state = getInternalState(this);
                    var target = state.target;
                    var kind = state.kind;
                    var index = state.index++;
                    if (!target || index >= target.length) {
                        state.target = undefined;
                        return {
                            value: undefined,
                            done: true
                        };
                    }
                    if (kind == 'keys') return {
                        value: index,
                        done: false
                    };
                    if (kind == 'values') return {
                        value: target[index],
                        done: false
                    };
                    return {
                        value: [
                            index,
                            target[index]
                        ],
                        done: false
                    };
                }, 'values');
                // argumentsList[@@iterator] is %ArrayProto_values%
                // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
                // https://tc39.es/ecma262/#sec-createmappedargumentsobject
                Iterators.Arguments = Iterators.Array;
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                addToUnscopables('keys');
                addToUnscopables('values');
                addToUnscopables('entries');
            /***/ },
            /***/ 82194: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var shared = __webpack_require__(464);
                var uid = __webpack_require__(46859);
                var keys = shared('keys');
                module1.exports = function(key) {
                    return keys[key] || (keys[key] = uid(key));
                };
            /***/ },
            /***/ 82621: /***/ function(module1) {
                "use strict";
                /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module1.exports = function isNaN1(value) {
                    return value !== value;
                };
            /***/ },
            /***/ 82747: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(39081);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(37146), __webpack_require__(4420));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var Base = C_lib.Base;
                        var WordArray = C_lib.WordArray;
                        var C_algo = C.algo;
                        var MD5 = C_algo.MD5;
                        /**
     * This key derivation function is meant to conform with EVP_BytesToKey.
     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
                            /**
       * Configuration options.
       *
       * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
       * @property {Hasher} hasher The hash algorithm to use. Default: MD5
       * @property {number} iterations The number of iterations to perform. Default: 1
       */ cfg: Base.extend({
                                keySize: 4,
                                hasher: MD5,
                                iterations: 1
                            }),
                            /**
       * Initializes a newly created key derivation function.
       *
       * @param {Object} cfg (Optional) The configuration options to use for the derivation.
       *
       * @example
       *
       *     var kdf = CryptoJS.algo.EvpKDF.create();
       *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
       *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
       */ init: function init(cfg) {
                                this.cfg = this.cfg.extend(cfg);
                            },
                            /**
       * Derives a key from a password.
       *
       * @param {WordArray|string} password The password.
       * @param {WordArray|string} salt A salt.
       *
       * @return {WordArray} The derived key.
       *
       * @example
       *
       *     var key = kdf.compute(password, salt);
       */ compute: function compute(password, salt) {
                                var block;
                                // Shortcut
                                var cfg = this.cfg;
                                // Init hasher
                                var hasher = cfg.hasher.create();
                                // Initial values
                                var derivedKey = WordArray.create();
                                // Shortcuts
                                var derivedKeyWords = derivedKey.words;
                                var keySize = cfg.keySize;
                                var iterations = cfg.iterations;
                                // Generate key
                                while(derivedKeyWords.length < keySize){
                                    if (block) hasher.update(block);
                                    block = hasher.update(password).finalize(salt);
                                    hasher.reset();
                                    // Iterations
                                    for(var i = 1; i < iterations; i++){
                                        block = hasher.finalize(block);
                                        hasher.reset();
                                    }
                                    derivedKey.concat(block);
                                }
                                derivedKey.sigBytes = keySize * 4;
                                return derivedKey;
                            }
                        });
                        /**
     * Derives a key from a password.
     *
     * @param {WordArray|string} password The password.
     * @param {WordArray|string} salt A salt.
     * @param {Object} cfg (Optional) The configuration options to use for this computation.
     *
     * @return {WordArray} The derived key.
     *
     * @static
     *
     * @example
     *
     *     var key = CryptoJS.EvpKDF(password, salt);
     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
     */ C.EvpKDF = function(password, salt, cfg) {
                            return EvpKDF.create(cfg).compute(password, salt);
                        };
                    })();
                    return CryptoJS.EvpKDF;
                });
            /***/ },
            /***/ 82938: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $forEach = __webpack_require__(91102).forEach;
                var arrayMethodIsStrict = __webpack_require__(81007);
                var STRICT_METHOD = arrayMethodIsStrict('forEach');
                // `Array.prototype.forEach` method implementation
                // https://tc39.es/ecma262/#sec-array.prototype.foreach
                module1.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
                    return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                // eslint-disable-next-line es/no-array-prototype-foreach -- safe
                } : [].forEach;
            /***/ },
            /***/ 83043: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                __webpack_require__(59883);
                var path = __webpack_require__(11206);
                module1.exports = path.Object.values;
            /***/ },
            /***/ 83089: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var setFunctionName = __webpack_require__(95304);
                var $TypeError = __webpack_require__(96785);
                var $Object = Object;
                module1.exports = setFunctionName(function flags() {
                    if (this == null || this !== $Object(this)) throw new $TypeError('RegExp.prototype.flags getter called on non-object');
                    var result = '';
                    if (this.hasIndices) result += 'd';
                    if (this.global) result += 'g';
                    if (this.ignoreCase) result += 'i';
                    if (this.multiline) result += 'm';
                    if (this.dotAll) result += 's';
                    if (this.unicode) result += 'u';
                    if (this.unicodeSets) result += 'v';
                    if (this.sticky) result += 'y';
                    return result;
                }, 'get flags', true);
            /***/ },
            /***/ 83124: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(24863);
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var DESCRIPTORS = __webpack_require__(15567);
                var NATIVE_ARRAY_BUFFER = __webpack_require__(30450);
                var FunctionName = __webpack_require__(7081);
                var createNonEnumerableProperty = __webpack_require__(48914);
                var redefineAll = __webpack_require__(15341);
                var fails = __webpack_require__(47044);
                var anInstance = __webpack_require__(2868);
                var toIntegerOrInfinity = __webpack_require__(26882);
                var toLength = __webpack_require__(23417);
                var toIndex = __webpack_require__(71265);
                var IEEE754 = __webpack_require__(64397);
                var getPrototypeOf = __webpack_require__(69548);
                var setPrototypeOf = __webpack_require__(3840);
                var getOwnPropertyNames = __webpack_require__(6611).f;
                var defineProperty = __webpack_require__(95892).f;
                var arrayFill = __webpack_require__(72864);
                var arraySlice = __webpack_require__(73163);
                var setToStringTag = __webpack_require__(15216);
                var InternalStateModule = __webpack_require__(70172);
                var PROPER_FUNCTION_NAME = FunctionName.PROPER;
                var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
                var getInternalState = InternalStateModule.get;
                var setInternalState = InternalStateModule.set;
                var ARRAY_BUFFER = 'ArrayBuffer';
                var DATA_VIEW = 'DataView';
                var PROTOTYPE = 'prototype';
                var WRONG_LENGTH = 'Wrong length';
                var WRONG_INDEX = 'Wrong index';
                var NativeArrayBuffer = global[ARRAY_BUFFER];
                var $ArrayBuffer = NativeArrayBuffer;
                var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
                var $DataView = global[DATA_VIEW];
                var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
                var ObjectPrototype = Object.prototype;
                var Array1 = global.Array;
                var RangeError1 = global.RangeError;
                var fill = uncurryThis(arrayFill);
                var reverse = uncurryThis([].reverse);
                var packIEEE754 = IEEE754.pack;
                var unpackIEEE754 = IEEE754.unpack;
                var packInt8 = function packInt8(number) {
                    return [
                        number & 0xFF
                    ];
                };
                var packInt16 = function packInt16(number) {
                    return [
                        number & 0xFF,
                        number >> 8 & 0xFF
                    ];
                };
                var packInt32 = function packInt32(number) {
                    return [
                        number & 0xFF,
                        number >> 8 & 0xFF,
                        number >> 16 & 0xFF,
                        number >> 24 & 0xFF
                    ];
                };
                var unpackInt32 = function unpackInt32(buffer) {
                    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
                };
                var packFloat32 = function packFloat32(number) {
                    return packIEEE754(number, 23, 4);
                };
                var packFloat64 = function packFloat64(number) {
                    return packIEEE754(number, 52, 8);
                };
                var addGetter = function addGetter(Constructor, key) {
                    defineProperty(Constructor[PROTOTYPE], key, {
                        get: function get() {
                            return getInternalState(this)[key];
                        }
                    });
                };
                var get = function get(view, count, index, isLittleEndian) {
                    var intIndex = toIndex(index);
                    var store = getInternalState(view);
                    if (intIndex + count > store.byteLength) throw RangeError1(WRONG_INDEX);
                    var bytes = getInternalState(store.buffer).bytes;
                    var start = intIndex + store.byteOffset;
                    var pack = arraySlice(bytes, start, start + count);
                    return isLittleEndian ? pack : reverse(pack);
                };
                var set = function set(view, count, index, conversion, value, isLittleEndian) {
                    var intIndex = toIndex(index);
                    var store = getInternalState(view);
                    if (intIndex + count > store.byteLength) throw RangeError1(WRONG_INDEX);
                    var bytes = getInternalState(store.buffer).bytes;
                    var start = intIndex + store.byteOffset;
                    var pack = conversion(+value);
                    for(var i = 0; i < count; i++)bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
                };
                if (!NATIVE_ARRAY_BUFFER) {
                    $ArrayBuffer = function ArrayBuffer1(length) {
                        anInstance(this, ArrayBufferPrototype);
                        var byteLength = toIndex(length);
                        setInternalState(this, {
                            bytes: fill(Array1(byteLength), 0),
                            byteLength: byteLength
                        });
                        if (!DESCRIPTORS) this.byteLength = byteLength;
                    };
                    ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];
                    $DataView = function DataView1(buffer, byteOffset, byteLength) {
                        anInstance(this, DataViewPrototype);
                        anInstance(buffer, ArrayBufferPrototype);
                        var bufferLength = getInternalState(buffer).byteLength;
                        var offset = toIntegerOrInfinity(byteOffset);
                        if (offset < 0 || offset > bufferLength) throw RangeError1('Wrong offset');
                        byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
                        if (offset + byteLength > bufferLength) throw RangeError1(WRONG_LENGTH);
                        setInternalState(this, {
                            buffer: buffer,
                            byteLength: byteLength,
                            byteOffset: offset
                        });
                        if (!DESCRIPTORS) {
                            this.buffer = buffer;
                            this.byteLength = byteLength;
                            this.byteOffset = offset;
                        }
                    };
                    DataViewPrototype = $DataView[PROTOTYPE];
                    if (DESCRIPTORS) {
                        addGetter($ArrayBuffer, 'byteLength');
                        addGetter($DataView, 'buffer');
                        addGetter($DataView, 'byteLength');
                        addGetter($DataView, 'byteOffset');
                    }
                    redefineAll(DataViewPrototype, {
                        getInt8: function getInt8(byteOffset) {
                            return get(this, 1, byteOffset)[0] << 24 >> 24;
                        },
                        getUint8: function getUint8(byteOffset) {
                            return get(this, 1, byteOffset)[0];
                        },
                        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
                            var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
                            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
                        },
                        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
                            var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
                            return bytes[1] << 8 | bytes[0];
                        },
                        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
                            return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
                        },
                        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
                            return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
                        },
                        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
                            return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
                        },
                        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
                            return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
                        },
                        setInt8: function setInt8(byteOffset, value) {
                            set(this, 1, byteOffset, packInt8, value);
                        },
                        setUint8: function setUint8(byteOffset, value) {
                            set(this, 1, byteOffset, packInt8, value);
                        },
                        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
                            set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
                        },
                        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
                            set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
                        },
                        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
                            set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
                        },
                        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
                            set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
                        },
                        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
                            set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
                        },
                        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
                            set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
                        }
                    });
                } else {
                    var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
                    /* eslint-disable no-new -- required for testing */ if (!fails(function() {
                        NativeArrayBuffer(1);
                    }) || !fails(function() {
                        new NativeArrayBuffer(-1);
                    }) || fails(function() {
                        new NativeArrayBuffer();
                        new NativeArrayBuffer(1.5);
                        new NativeArrayBuffer(NaN);
                        return INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
                    })) {
                        /* eslint-enable no-new -- required for testing */ $ArrayBuffer = function ArrayBuffer1(length) {
                            anInstance(this, ArrayBufferPrototype);
                            return new NativeArrayBuffer(toIndex(length));
                        };
                        $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;
                        for(var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;)if (!((key = keys[j++]) in $ArrayBuffer)) createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
                        ArrayBufferPrototype.constructor = $ArrayBuffer;
                    } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
                    // WebKit bug - the same parent prototype for typed arrays and data view
                    if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) setPrototypeOf(DataViewPrototype, ObjectPrototype);
                    // iOS Safari 7.x bug
                    var testView = new $DataView(new $ArrayBuffer(2));
                    var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
                    testView.setInt8(0, 2147483648);
                    testView.setInt8(1, 2147483649);
                    if (testView.getInt8(0) || !testView.getInt8(1)) redefineAll(DataViewPrototype, {
                        setInt8: function setInt8(byteOffset, value) {
                            $setInt8(this, byteOffset, value << 24 >> 24);
                        },
                        setUint8: function setUint8(byteOffset, value) {
                            $setInt8(this, byteOffset, value << 24 >> 24);
                        }
                    }, {
                        unsafe: true
                    });
                }
                setToStringTag($ArrayBuffer, ARRAY_BUFFER);
                setToStringTag($DataView, DATA_VIEW);
                module1.exports = {
                    ArrayBuffer: $ArrayBuffer,
                    DataView: $DataView
                };
            /***/ },
            /***/ 83326: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(28834);
                var exportTypedArrayStaticMethod = __webpack_require__(59754).exportTypedArrayStaticMethod;
                var typedArrayFrom = __webpack_require__(83590);
                // `%TypedArray%.from` method
                // https://tc39.es/ecma262/#sec-%typedarray%.from
                exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);
            /***/ },
            /***/ 83590: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var bind = __webpack_require__(25567);
                var call = __webpack_require__(2834);
                var aConstructor = __webpack_require__(69075);
                var toObject = __webpack_require__(43162);
                var lengthOfArrayLike = __webpack_require__(45495);
                var getIterator = __webpack_require__(15892);
                var getIteratorMethod = __webpack_require__(13872);
                var isArrayIteratorMethod = __webpack_require__(89564);
                var aTypedArrayConstructor = __webpack_require__(59754).aTypedArrayConstructor;
                module1.exports = function from(source /* , mapfn, thisArg */ ) {
                    var C = aConstructor(this);
                    var O = toObject(source);
                    var argumentsLength = arguments.length;
                    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
                    var mapping = mapfn !== undefined;
                    var iteratorMethod = getIteratorMethod(O);
                    var i, length, result, step, iterator, next;
                    if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
                        iterator = getIterator(O, iteratorMethod);
                        next = iterator.next;
                        O = [];
                        while(!(step = call(next, iterator)).done)O.push(step.value);
                    }
                    if (mapping && argumentsLength > 2) mapfn = bind(mapfn, arguments[2]);
                    length = lengthOfArrayLike(O);
                    result = new (aTypedArrayConstructor(C))(length);
                    for(i = 0; length > i; i++)result[i] = mapping ? mapfn(O[i], i) : O[i];
                    return result;
                };
            /***/ },
            /***/ 83797: /***/ function(module1) {
                "use strict";
                function _inheritsLoose(subClass, superClass) {
                    subClass.prototype = Object.create(superClass.prototype);
                    subClass.prototype.constructor = subClass;
                    subClass.__proto__ = superClass;
                }
                var codes = {};
                function createErrorType(code, message, Base) {
                    if (!Base) Base = Error;
                    function getMessage(arg1, arg2, arg3) {
                        if (typeof message === 'string') return message;
                        else return message(arg1, arg2, arg3);
                    }
                    var NodeError = /*#__PURE__*/ function(_Base) {
                        _inheritsLoose(NodeError, _Base);
                        function NodeError(arg1, arg2, arg3) {
                            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
                        }
                        return NodeError;
                    }(Base);
                    NodeError.prototype.name = Base.name;
                    NodeError.prototype.code = code;
                    codes[code] = NodeError;
                } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
                function oneOf(expected, thing) {
                    if (Array.isArray(expected)) {
                        var len = expected.length;
                        expected = expected.map(function(i) {
                            return String(i);
                        });
                        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
                        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
                        else return "of ".concat(thing, " ").concat(expected[0]);
                    } else return "of ".concat(thing, " ").concat(String(expected));
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
                function startsWith(str, search, pos) {
                    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
                function endsWith(str, search, this_len) {
                    if (this_len === undefined || this_len > str.length) this_len = str.length;
                    return str.substring(this_len - search.length, this_len) === search;
                } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
                function includes(str, search, start) {
                    if (typeof start !== 'number') start = 0;
                    if (start + search.length > str.length) return false;
                    else return str.indexOf(search, start) !== -1;
                }
                createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
                    return 'The value "' + value + '" is invalid for option "' + name + '"';
                }, TypeError);
                createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
                    // determiner: 'must be' or 'must not be'
                    var determiner;
                    if (typeof expected === 'string' && startsWith(expected, 'not ')) {
                        determiner = 'must not be';
                        expected = expected.replace(/^not /, '');
                    } else determiner = 'must be';
                    var msg;
                    if (endsWith(name, ' argument')) // For cases like 'first argument'
                    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
                    else {
                        var type = includes(name, '.') ? 'property' : 'argument';
                        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
                    }
                    msg += ". Received type ".concat(typeof actual);
                    return msg;
                }, TypeError);
                createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
                createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
                    return 'The ' + name + ' method is not implemented';
                });
                createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
                createErrorType('ERR_STREAM_DESTROYED', function(name) {
                    return 'Cannot call ' + name + ' after a stream was destroyed';
                });
                createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
                createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
                createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
                createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
                createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
                    return 'Unknown encoding: ' + arg;
                }, TypeError);
                createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
                module1.exports.F = codes;
            /***/ },
            /***/ 83943: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var TypeError1 = global.TypeError;
                // `RequireObjectCoercible` abstract operation
                // https://tc39.es/ecma262/#sec-requireobjectcoercible
                module1.exports = function(it) {
                    if (it == undefined) throw TypeError1("Can't call method on " + it);
                    return it;
                };
            /***/ },
            /***/ 84030: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(47044);
                var global = __webpack_require__(32010);
                // babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
                var $RegExp = global.RegExp;
                module1.exports = fails(function() {
                    var re = $RegExp('.', 's');
                    return !(re.dotAll && re.exec('\n') && re.flags === 's');
                });
            /***/ },
            /***/ 84151: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(94910);
            /***/ },
            /***/ 84320: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* eslint-disable es/no-array-prototype-lastindexof -- safe */ var apply = __webpack_require__(58448);
                var toIndexedObject = __webpack_require__(98086);
                var toIntegerOrInfinity = __webpack_require__(26882);
                var lengthOfArrayLike = __webpack_require__(45495);
                var arrayMethodIsStrict = __webpack_require__(81007);
                var min = Math.min;
                var $lastIndexOf = [].lastIndexOf;
                var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [
                    1
                ].lastIndexOf(1, -0) < 0;
                var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
                var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;
                // `Array.prototype.lastIndexOf` method implementation
                // https://tc39.es/ecma262/#sec-array.prototype.lastindexof
                module1.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
                    // convert -0 to +0
                    if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
                    var O = toIndexedObject(this);
                    var length = lengthOfArrayLike(O);
                    var index = length - 1;
                    if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
                    if (index < 0) index = length + index;
                    for(; index >= 0; index--)if (index in O && O[index] === searchElement) return index || 0;
                    return -1;
                } : $lastIndexOf;
            /***/ },
            /***/ 84327: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(81755);
                __webpack_require__(8953);
                __webpack_require__(14032);
                __webpack_require__(56912);
                __webpack_require__(59735);
                __webpack_require__(73663);
                __webpack_require__(29883);
                __webpack_require__(35471);
                __webpack_require__(21012);
                __webpack_require__(88997);
                __webpack_require__(97464);
                __webpack_require__(2857);
                __webpack_require__(94715);
                __webpack_require__(13624);
                __webpack_require__(91132);
                __webpack_require__(62514);
                __webpack_require__(24597);
                __webpack_require__(88042);
                __webpack_require__(4660);
                __webpack_require__(92451);
                __webpack_require__(44206);
                __webpack_require__(66288);
                __webpack_require__(13250);
                __webpack_require__(3858);
                __webpack_require__(84538);
                __webpack_require__(64793);
                __webpack_require__(74202);
                __webpack_require__(52529);
                var isBigEndian = new Uint8Array(new Uint32Array([
                    0x12345678
                ]).buffer)[0] === 0x12;
                var swap = function swap(b, n, m) {
                    var i = b[n];
                    b[n] = b[m];
                    b[m] = i;
                };
                var swap32 = function swap32(array) {
                    var len = array.length;
                    for(var i = 0; i < len; i += 4){
                        swap(array, i, i + 3);
                        swap(array, i + 1, i + 2);
                    }
                };
                var swap32LE = function swap32LE(array) {
                    if (isBigEndian) swap32(array);
                };
                module1.exports = {
                    swap32LE: swap32LE
                };
            /***/ },
            /***/ 84490: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                // The following break classes are handled by the pair table
                exports.OP = 0; // Opening punctuation
                exports.CL = 1; // Closing punctuation
                exports.CP = 2; // Closing parenthesis
                exports.QU = 3; // Ambiguous quotation
                exports.GL = 4; // Glue
                exports.NS = 5; // Non-starters
                exports.EX = 6; // Exclamation/Interrogation
                exports.SY = 7; // Symbols allowing break after
                exports.IS = 8; // Infix separator
                exports.PR = 9; // Prefix
                exports.PO = 10; // Postfix
                exports.NU = 11; // Numeric
                exports.AL = 12; // Alphabetic
                exports.HL = 13; // Hebrew Letter
                exports.ID = 14; // Ideographic
                exports.IN = 15; // Inseparable characters
                exports.HY = 16; // Hyphen
                exports.BA = 17; // Break after
                exports.BB = 18; // Break before
                exports.B2 = 19; // Break on either side (but not pair)
                exports.ZW = 20; // Zero-width space
                exports.CM = 21; // Combining marks
                exports.WJ = 22; // Word joiner
                exports.H2 = 23; // Hangul LV
                exports.H3 = 24; // Hangul LVT
                exports.JL = 25; // Hangul L Jamo
                exports.JV = 26; // Hangul V Jamo
                exports.JT = 27; // Hangul T Jamo
                exports.RI = 28; // Regional Indicator
                exports.EB = 29; // Emoji Base
                exports.EM = 30; // Emoji Modifier
                exports.ZWJ = 31; // Zero Width Joiner
                exports.CB = 32; // Contingent break
                // The following break classes are not handled by the pair table
                exports.AI = 33; // Ambiguous (Alphabetic or Ideograph)
                exports.BK = 34; // Break (mandatory)
                exports.CJ = 35; // Conditional Japanese Starter
                exports.CR = 36; // Carriage return
                exports.LF = 37; // Line feed
                exports.NL = 38; // Next line
                exports.SA = 39; // South-East Asian
                exports.SG = 40; // Surrogates
                exports.SP = 41; // Space
                exports.XX = 42; // Unknown
            /***/ },
            /***/ 84538: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var fails = __webpack_require__(47044);
                var aCallable = __webpack_require__(32631);
                var internalSort = __webpack_require__(43977);
                var ArrayBufferViewCore = __webpack_require__(59754);
                var FF = __webpack_require__(3809);
                var IE_OR_EDGE = __webpack_require__(21983);
                var V8 = __webpack_require__(70091);
                var WEBKIT = __webpack_require__(41731);
                var Array1 = global.Array;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var Uint16Array1 = global.Uint16Array;
                var un$Sort = Uint16Array1 && uncurryThis(Uint16Array1.prototype.sort);
                // WebKit
                var ACCEPT_INCORRECT_ARGUMENTS = !!un$Sort && !(fails(function() {
                    un$Sort(new Uint16Array1(2), null);
                }) && fails(function() {
                    un$Sort(new Uint16Array1(2), {});
                }));
                var STABLE_SORT = !!un$Sort && !fails(function() {
                    // feature detection can be too slow, so check engines versions
                    if (V8) return V8 < 74;
                    if (FF) return FF < 67;
                    if (IE_OR_EDGE) return true;
                    if (WEBKIT) return WEBKIT < 602;
                    var array = new Uint16Array1(516);
                    var expected = Array1(516);
                    var index, mod;
                    for(index = 0; index < 516; index++){
                        mod = index % 4;
                        array[index] = 515 - index;
                        expected[index] = index - 2 * mod + 3;
                    }
                    un$Sort(array, function(a, b) {
                        return (a / 4 | 0) - (b / 4 | 0);
                    });
                    for(index = 0; index < 516; index++){
                        if (array[index] !== expected[index]) return true;
                    }
                });
                var getSortCompare = function(comparefn) {
                    return function(x, y) {
                        if (comparefn !== undefined) return +comparefn(x, y) || 0;
                        // eslint-disable-next-line no-self-compare -- NaN check
                        if (y !== y) return -1;
                        // eslint-disable-next-line no-self-compare -- NaN check
                        if (x !== x) return 1;
                        if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
                        return x > y;
                    };
                };
                // `%TypedArray%.prototype.sort` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
                exportTypedArrayMethod('sort', function sort(comparefn) {
                    if (comparefn !== undefined) aCallable(comparefn);
                    if (STABLE_SORT) return un$Sort(this, comparefn);
                    return internalSort(aTypedArray(this), getSortCompare(comparefn));
                }, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);
            /***/ },
            /***/ 84543: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var base64 = __webpack_require__(32504);
                /**
 * The normal dictionary-data.js is quite large, which makes it 
 * unsuitable for browser usage. In order to make it smaller, 
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses 
 * it's own dictionary. 😜
 */ exports.init = function() {
                    var BrotliDecompressBuffer = __webpack_require__(20980).BrotliDecompressBuffer;
                    var compressed = base64.toByteArray(__webpack_require__(13501));
                    return BrotliDecompressBuffer(compressed);
                };
            /***/ },
            /***/ 84675: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var internalObjectKeys = __webpack_require__(64429);
                var enumBugKeys = __webpack_require__(2416);
                // `Object.keys` method
                // https://tc39.es/ecma262/#sec-object.keys
                // eslint-disable-next-line es/no-object-keys -- safe
                module1.exports = Object.keys || function keys(O) {
                    return internalObjectKeys(O, enumBugKeys);
                };
            /***/ },
            /***/ 84695: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                __webpack_require__(58028);
                __webpack_require__(20731);
                __webpack_require__(14032);
                __webpack_require__(68067);
                /*
 * MIT LICENSE
 * Copyright (c) 2011 Devon Govett
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
 * software and associated documentation files (the "Software"), to deal in the Software
 * without restriction, including without limitation the rights to use, copy, modify, merge,
 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons
 * to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or
 * substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
 * BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ var fs = __webpack_require__(48181);
                var zlib = __webpack_require__(6729);
                module1.exports = /*#__PURE__*/ function() {
                    function PNG(data) {
                        var i;
                        this.data = data;
                        this.pos = 8; // Skip the default header
                        this.palette = [];
                        this.imgData = [];
                        this.transparency = {};
                        this.text = {};
                        while(true){
                            var chunkSize = this.readUInt32();
                            var section = '';
                            for(i = 0; i < 4; i++)section += String.fromCharCode(this.data[this.pos++]);
                            switch(section){
                                case 'IHDR':
                                    // we can grab  interesting values from here (like width, height, etc)
                                    this.width = this.readUInt32();
                                    this.height = this.readUInt32();
                                    this.bits = this.data[this.pos++];
                                    this.colorType = this.data[this.pos++];
                                    this.compressionMethod = this.data[this.pos++];
                                    this.filterMethod = this.data[this.pos++];
                                    this.interlaceMethod = this.data[this.pos++];
                                    break;
                                case 'PLTE':
                                    this.palette = this.read(chunkSize);
                                    break;
                                case 'IDAT':
                                    for(i = 0; i < chunkSize; i++)this.imgData.push(this.data[this.pos++]);
                                    break;
                                case 'tRNS':
                                    // This chunk can only occur once and it must occur after the
                                    // PLTE chunk and before the IDAT chunk.
                                    this.transparency = {};
                                    switch(this.colorType){
                                        case 3:
                                            // Indexed color, RGB. Each byte in this chunk is an alpha for
                                            // the palette index in the PLTE ("palette") chunk up until the
                                            // last non-opaque entry. Set up an array, stretching over all
                                            // palette entries which will be 0 (opaque) or 1 (transparent).
                                            this.transparency.indexed = this.read(chunkSize);
                                            var short = 255 - this.transparency.indexed.length;
                                            if (short > 0) for(i = 0; i < short; i++)this.transparency.indexed.push(255);
                                            break;
                                        case 0:
                                            // Greyscale. Corresponding to entries in the PLTE chunk.
                                            // Grey is two bytes, range 0 .. (2 ^ bit-depth) - 1
                                            this.transparency.grayscale = this.read(chunkSize)[0];
                                            break;
                                        case 2:
                                            // True color with proper alpha channel.
                                            this.transparency.rgb = this.read(chunkSize);
                                            break;
                                    }
                                    break;
                                case 'tEXt':
                                    var text = this.read(chunkSize);
                                    var index = text.indexOf(0);
                                    var key = String.fromCharCode.apply(String, text.slice(0, index));
                                    this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
                                    break;
                                case 'IEND':
                                    // we've got everything we need!
                                    switch(this.colorType){
                                        case 0:
                                        case 3:
                                        case 4:
                                            this.colors = 1;
                                            break;
                                        case 2:
                                        case 6:
                                            this.colors = 3;
                                            break;
                                    }
                                    this.hasAlphaChannel = [
                                        4,
                                        6
                                    ].includes(this.colorType);
                                    var colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
                                    this.pixelBitlength = this.bits * colors;
                                    switch(this.colors){
                                        case 1:
                                            this.colorSpace = 'DeviceGray';
                                            break;
                                        case 3:
                                            this.colorSpace = 'DeviceRGB';
                                            break;
                                    }
                                    this.imgData = new Buffer(this.imgData);
                                    return;
                                default:
                                    // unknown (or unimportant) section, skip it
                                    this.pos += chunkSize;
                            }
                            this.pos += 4; // Skip the CRC
                            if (this.pos > this.data.length) throw new Error('Incomplete or corrupt PNG file');
                        }
                    }
                    PNG.decode = function decode(path, fn) {
                        return fs.readFile(path, function(err, file) {
                            var png = new PNG(file);
                            return png.decode(function(pixels) {
                                return fn(pixels);
                            });
                        });
                    };
                    PNG.load = function load(path) {
                        var file = fs.readFileSync(path);
                        return new PNG(file);
                    };
                    var _proto = PNG.prototype;
                    _proto.read = function read(bytes) {
                        var result = new Array(bytes);
                        for(var i = 0; i < bytes; i++)result[i] = this.data[this.pos++];
                        return result;
                    };
                    _proto.readUInt32 = function readUInt32() {
                        var b1 = this.data[this.pos++] << 24;
                        var b2 = this.data[this.pos++] << 16;
                        var b3 = this.data[this.pos++] << 8;
                        var b4 = this.data[this.pos++];
                        return b1 | b2 | b3 | b4;
                    };
                    _proto.readUInt16 = function readUInt16() {
                        var b1 = this.data[this.pos++] << 8;
                        var b2 = this.data[this.pos++];
                        return b1 | b2;
                    };
                    _proto.decodePixels = function decodePixels(fn) {
                        var _this = this;
                        return zlib.inflate(this.imgData, function(err, data) {
                            if (err) throw err;
                            var width = _this.width, height = _this.height;
                            var pixelBytes = _this.pixelBitlength / 8;
                            var pixels = new Buffer(width * height * pixelBytes);
                            var length = data.length;
                            var pos = 0;
                            function pass(x0, y0, dx, dy, singlePass) {
                                if (singlePass === void 0) singlePass = false;
                                var w = Math.ceil((width - x0) / dx);
                                var h = Math.ceil((height - y0) / dy);
                                var scanlineLength = pixelBytes * w;
                                var buffer = singlePass ? pixels : new Buffer(scanlineLength * h);
                                var row = 0;
                                var c = 0;
                                while(row < h && pos < length){
                                    var byte, col, i, left, upper;
                                    switch(data[pos++]){
                                        case 0:
                                            // None
                                            for(i = 0; i < scanlineLength; i++)buffer[c++] = data[pos++];
                                            break;
                                        case 1:
                                            // Sub
                                            for(i = 0; i < scanlineLength; i++){
                                                byte = data[pos++];
                                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                                buffer[c++] = (byte + left) % 256;
                                            }
                                            break;
                                        case 2:
                                            // Up
                                            for(i = 0; i < scanlineLength; i++){
                                                byte = data[pos++];
                                                col = (i - i % pixelBytes) / pixelBytes;
                                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                                buffer[c++] = (upper + byte) % 256;
                                            }
                                            break;
                                        case 3:
                                            // Average
                                            for(i = 0; i < scanlineLength; i++){
                                                byte = data[pos++];
                                                col = (i - i % pixelBytes) / pixelBytes;
                                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                                buffer[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
                                            }
                                            break;
                                        case 4:
                                            // Paeth
                                            for(i = 0; i < scanlineLength; i++){
                                                var paeth, upperLeft;
                                                byte = data[pos++];
                                                col = (i - i % pixelBytes) / pixelBytes;
                                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                                if (row === 0) upper = upperLeft = 0;
                                                else {
                                                    upper = buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                                    upperLeft = col && buffer[(row - 1) * scanlineLength + (col - 1) * pixelBytes + i % pixelBytes];
                                                }
                                                var p = left + upper - upperLeft;
                                                var pa = Math.abs(p - left);
                                                var pb = Math.abs(p - upper);
                                                var pc = Math.abs(p - upperLeft);
                                                if (pa <= pb && pa <= pc) paeth = left;
                                                else if (pb <= pc) paeth = upper;
                                                else paeth = upperLeft;
                                                buffer[c++] = (byte + paeth) % 256;
                                            }
                                            break;
                                        default:
                                            throw new Error("Invalid filter algorithm: " + data[pos - 1]);
                                    }
                                    if (!singlePass) {
                                        var pixelsPos = ((y0 + row * dy) * width + x0) * pixelBytes;
                                        var bufferPos = row * scanlineLength;
                                        for(i = 0; i < w; i++){
                                            for(var j = 0; j < pixelBytes; j++)pixels[pixelsPos++] = buffer[bufferPos++];
                                            pixelsPos += (dx - 1) * pixelBytes;
                                        }
                                    }
                                    row++;
                                }
                            }
                            if (_this.interlaceMethod === 1) {
                                /*
          1 6 4 6 2 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
          3 6 4 6 3 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
        */ pass(0, 0, 8, 8); // 1
                                pass(4, 0, 8, 8); // 2
                                pass(0, 4, 4, 8); // 3
                                pass(2, 0, 4, 4); // 4
                                pass(0, 2, 2, 4); // 5
                                pass(1, 0, 2, 2); // 6
                                pass(0, 1, 1, 2); // 7
                            } else pass(0, 0, 1, 1, true);
                            return fn(pixels);
                        });
                    };
                    _proto.decodePalette = function decodePalette() {
                        var palette = this.palette;
                        var length = palette.length;
                        var transparency = this.transparency.indexed || [];
                        var ret = new Buffer(transparency.length + length);
                        var pos = 0;
                        var c = 0;
                        for(var i = 0; i < length; i += 3){
                            var left;
                            ret[pos++] = palette[i];
                            ret[pos++] = palette[i + 1];
                            ret[pos++] = palette[i + 2];
                            ret[pos++] = (left = transparency[c++]) != null ? left : 255;
                        }
                        return ret;
                    };
                    _proto.copyToImageData = function copyToImageData(imageData, pixels) {
                        var j, k;
                        var colors = this.colors;
                        var palette = null;
                        var alpha = this.hasAlphaChannel;
                        if (this.palette.length) {
                            palette = this._decodedPalette || (this._decodedPalette = this.decodePalette());
                            colors = 4;
                            alpha = true;
                        }
                        var data = imageData.data || imageData;
                        var length = data.length;
                        var input = palette || pixels;
                        var i = j = 0;
                        if (colors === 1) while(i < length){
                            k = palette ? pixels[i / 4] * 4 : j;
                            var v = input[k++];
                            data[i++] = v;
                            data[i++] = v;
                            data[i++] = v;
                            data[i++] = alpha ? input[k++] : 255;
                            j = k;
                        }
                        else while(i < length){
                            k = palette ? pixels[i / 4] * 4 : j;
                            data[i++] = input[k++];
                            data[i++] = input[k++];
                            data[i++] = input[k++];
                            data[i++] = alpha ? input[k++] : 255;
                            j = k;
                        }
                    };
                    _proto.decode = function decode(fn) {
                        var _this2 = this;
                        var ret = new Buffer(this.width * this.height * 4);
                        return this.decodePixels(function(pixels) {
                            _this2.copyToImageData(ret, pixels);
                            return fn(ret);
                        });
                    };
                    return PNG;
                }();
            /***/ },
            /***/ 84786: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var isArray = __webpack_require__(91867).isArray;
                var isPattern = __webpack_require__(91867).isPattern;
                var getPattern = __webpack_require__(91867).getPattern;
                function groupDecorations(line) {
                    var groups = [], currentGroup = null;
                    for(var i = 0, l = line.inlines.length; i < l; i++){
                        var inline = line.inlines[i];
                        var decoration = inline.decoration;
                        if (!decoration) {
                            currentGroup = null;
                            continue;
                        }
                        if (!isArray(decoration)) decoration = [
                            decoration
                        ];
                        var color = inline.decorationColor || inline.color || 'black';
                        var style = inline.decorationStyle || 'solid';
                        for(var ii = 0, ll = decoration.length; ii < ll; ii++){
                            var decorationItem = decoration[ii];
                            if (!currentGroup || decorationItem !== currentGroup.decoration || style !== currentGroup.decorationStyle || color !== currentGroup.decorationColor) {
                                currentGroup = {
                                    line: line,
                                    decoration: decorationItem,
                                    decorationColor: color,
                                    decorationStyle: style,
                                    inlines: [
                                        inline
                                    ]
                                };
                                groups.push(currentGroup);
                            } else currentGroup.inlines.push(inline);
                        }
                    }
                    return groups;
                }
                function drawDecoration(group, x, y, pdfKitDoc) {
                    function maxInline() {
                        var max = 0;
                        for(var i = 0, l = group.inlines.length; i < l; i++){
                            var inline = group.inlines[i];
                            max = inline.fontSize > max ? i : max;
                        }
                        return group.inlines[max];
                    }
                    function width() {
                        var sum = 0;
                        for(var i = 0, l = group.inlines.length; i < l; i++){
                            var justifyShift = group.inlines[i].justifyShift || 0;
                            sum += group.inlines[i].width + justifyShift;
                        }
                        return sum;
                    }
                    var firstInline = group.inlines[0], biggerInline = maxInline(), totalWidth = width(), lineAscent = group.line.getAscenderHeight(), ascent = biggerInline.font.ascender / 1000 * biggerInline.fontSize, height = biggerInline.height, descent = height - ascent;
                    var lw = 0.5 + Math.floor(Math.max(biggerInline.fontSize - 8, 0) / 2) * 0.12;
                    switch(group.decoration){
                        case 'underline':
                            y += lineAscent + descent * 0.45;
                            break;
                        case 'overline':
                            y += lineAscent - ascent * 0.85;
                            break;
                        case 'lineThrough':
                            y += lineAscent - ascent * 0.25;
                            break;
                        default:
                            throw 'Unknown decoration : ' + group.decoration;
                    }
                    pdfKitDoc.save();
                    if (group.decorationStyle === 'double') {
                        var gap = Math.max(0.5, lw * 2);
                        pdfKitDoc.fillColor(group.decorationColor).rect(x + firstInline.x, y - lw / 2, totalWidth, lw / 2).fill().rect(x + firstInline.x, y + gap - lw / 2, totalWidth, lw / 2).fill();
                    } else if (group.decorationStyle === 'dashed') {
                        var nbDashes = Math.ceil(totalWidth / 6.8);
                        var rdx = x + firstInline.x;
                        pdfKitDoc.rect(rdx, y, totalWidth, lw).clip();
                        pdfKitDoc.fillColor(group.decorationColor);
                        for(var i = 0; i < nbDashes; i++){
                            pdfKitDoc.rect(rdx, y - lw / 2, 3.96, lw).fill();
                            rdx += 6.8;
                        }
                    } else if (group.decorationStyle === 'dotted') {
                        var nbDots = Math.ceil(totalWidth / (lw * 3));
                        var rx = x + firstInline.x;
                        pdfKitDoc.rect(rx, y, totalWidth, lw).clip();
                        pdfKitDoc.fillColor(group.decorationColor);
                        for(var ii = 0; ii < nbDots; ii++){
                            pdfKitDoc.rect(rx, y - lw / 2, lw, lw).fill();
                            rx += lw * 3;
                        }
                    } else if (group.decorationStyle === 'wavy') {
                        var sh = 0.7, sv = 1;
                        var nbWaves = Math.ceil(totalWidth / (sh * 2)) + 1;
                        var rwx = x + firstInline.x - 1;
                        pdfKitDoc.rect(x + firstInline.x, y - sv, totalWidth, y + sv).clip();
                        pdfKitDoc.lineWidth(0.24);
                        pdfKitDoc.moveTo(rwx, y);
                        for(var iii = 0; iii < nbWaves; iii++){
                            pdfKitDoc.bezierCurveTo(rwx + sh, y - sv, rwx + sh * 2, y - sv, rwx + sh * 3, y).bezierCurveTo(rwx + sh * 4, y + sv, rwx + sh * 5, y + sv, rwx + sh * 6, y);
                            rwx += sh * 6;
                        }
                        pdfKitDoc.stroke(group.decorationColor);
                    } else pdfKitDoc.fillColor(group.decorationColor).rect(x + firstInline.x, y - lw / 2, totalWidth, lw).fill();
                    pdfKitDoc.restore();
                }
                function drawDecorations(line, x, y, pdfKitDoc) {
                    var groups = groupDecorations(line);
                    for(var i = 0, l = groups.length; i < l; i++)drawDecoration(groups[i], x, y, pdfKitDoc);
                }
                function drawBackground(line, x, y, patterns, pdfKitDoc) {
                    var height = line.getHeight();
                    for(var i = 0, l = line.inlines.length; i < l; i++){
                        var inline = line.inlines[i];
                        if (!inline.background) continue;
                        var color = inline.background;
                        if (isPattern(inline.background)) color = getPattern(inline.background, patterns);
                        var justifyShift = inline.justifyShift || 0;
                        pdfKitDoc.fillColor(color).rect(x + inline.x - justifyShift, y, inline.width + justifyShift, height).fill();
                    }
                }
                module1.exports = {
                    drawBackground: drawBackground,
                    drawDecorations: drawDecorations
                };
            /***/ },
            /***/ 85208: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                function _interopDefault(ex) {
                    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
                }
                var PdfKit = _interopDefault(__webpack_require__(90760));
                function getEngineInstance() {
                    return PdfKit;
                }
                function createPdfDocument(options) {
                    options = options || {};
                    return new PdfKit(options);
                }
                module1.exports = {
                    getEngineInstance: getEngineInstance,
                    createPdfDocument: createPdfDocument
                };
            /***/ },
            /***/ 85416: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(9964);
                // Currently in sync with Node.js lib/internal/assert/assertion_error.js
                // https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c
                function ownKeys(e, r) {
                    var t = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        r && (o = o.filter(function(r) {
                            return Object.getOwnPropertyDescriptor(e, r).enumerable;
                        })), t.push.apply(t, o);
                    }
                    return t;
                }
                function _objectSpread(e) {
                    for(var r = 1; r < arguments.length; r++){
                        var t = null != arguments[r] ? arguments[r] : {};
                        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                            _defineProperty(e, r, t[r]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                        });
                    }
                    return e;
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    Object.defineProperty(Constructor, "prototype", {
                        writable: false
                    });
                    return Constructor;
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    Object.defineProperty(subClass, "prototype", {
                        writable: false
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _wrapNativeSuper(Class) {
                    var _cache = typeof Map === "function" ? new Map() : undefined;
                    _wrapNativeSuper = function _wrapNativeSuper(Class) {
                        if (Class === null || !_isNativeFunction(Class)) return Class;
                        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
                        if (typeof _cache !== "undefined") {
                            if (_cache.has(Class)) return _cache.get(Class);
                            _cache.set(Class, Wrapper);
                        }
                        function Wrapper() {
                            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
                        }
                        Wrapper.prototype = Object.create(Class.prototype, {
                            constructor: {
                                value: Wrapper,
                                enumerable: false,
                                writable: true,
                                configurable: true
                            }
                        });
                        return _setPrototypeOf(Wrapper, Class);
                    };
                    return _wrapNativeSuper(Class);
                }
                function _construct(Parent, args, Class) {
                    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
                    else _construct = function _construct(Parent, args, Class) {
                        var a = [
                            null
                        ];
                        a.push.apply(a, args);
                        var Constructor = Function.bind.apply(Parent, a);
                        var instance = new Constructor();
                        if (Class) _setPrototypeOf(instance, Class.prototype);
                        return instance;
                    };
                    return _construct.apply(null, arguments);
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _isNativeFunction(fn) {
                    return Function.toString.call(fn).indexOf("[native code]") !== -1;
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                var _require = __webpack_require__(7187), inspect = _require.inspect;
                var _require2 = __webpack_require__(35403), ERR_INVALID_ARG_TYPE = _require2.codes.ERR_INVALID_ARG_TYPE;
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
                function endsWith(str, search, this_len) {
                    if (this_len === undefined || this_len > str.length) this_len = str.length;
                    return str.substring(this_len - search.length, this_len) === search;
                }
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
                function repeat(str, count) {
                    count = Math.floor(count);
                    if (str.length == 0 || count == 0) return '';
                    var maxCount = str.length * count;
                    count = Math.floor(Math.log(count) / Math.log(2));
                    while(count){
                        str += str;
                        count--;
                    }
                    str += str.substring(0, maxCount - str.length);
                    return str;
                }
                var blue = '';
                var green = '';
                var red = '';
                var white = '';
                var kReadableOperator = {
                    deepStrictEqual: 'Expected values to be strictly deep-equal:',
                    strictEqual: 'Expected values to be strictly equal:',
                    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
                    deepEqual: 'Expected values to be loosely deep-equal:',
                    equal: 'Expected values to be loosely equal:',
                    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
                    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
                    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
                    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
                    notEqual: 'Expected "actual" to be loosely unequal to:',
                    notIdentical: 'Values identical but not reference-equal:'
                };
                // Comparing short primitives should just show === / !== instead of using the
                // diff.
                var kMaxShortLength = 10;
                function copyError(source) {
                    var keys = Object.keys(source);
                    var target = Object.create(Object.getPrototypeOf(source));
                    keys.forEach(function(key) {
                        target[key] = source[key];
                    });
                    Object.defineProperty(target, 'message', {
                        value: source.message
                    });
                    return target;
                }
                function inspectValue(val) {
                    // The util.inspect default values could be changed. This makes sure the
                    // error messages contain the necessary information nevertheless.
                    return inspect(val, {
                        compact: false,
                        customInspect: false,
                        depth: 1000,
                        maxArrayLength: Infinity,
                        // Assert compares only enumerable properties (with a few exceptions).
                        showHidden: false,
                        // Having a long line as error is better than wrapping the line for
                        // comparison for now.
                        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
                        // have meta information about the inspected properties (i.e., know where
                        // in what line the property starts and ends).
                        breakLength: Infinity,
                        // Assert does not detect proxies currently.
                        showProxy: false,
                        sorted: true,
                        // Inspect getters as we also check them when comparing entries.
                        getters: true
                    });
                }
                function createErrDiff(actual, expected, operator) {
                    var other = '';
                    var res = '';
                    var lastPos = 0;
                    var end = '';
                    var skipped = false;
                    var actualInspected = inspectValue(actual);
                    var actualLines = actualInspected.split('\n');
                    var expectedLines = inspectValue(expected).split('\n');
                    var i = 0;
                    var indicator = '';
                    // In case both values are objects explicitly mark them as not reference equal
                    // for the `strictEqual` operator.
                    if (operator === 'strictEqual' && _typeof(actual) === 'object' && _typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
                    // If "actual" and "expected" fit on a single line and they are not strictly
                    // equal, check further special handling.
                    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
                        var inputLength = actualLines[0].length + expectedLines[0].length;
                        // If the character length of "actual" and "expected" together is less than
                        // kMaxShortLength and if neither is an object and at least one of them is
                        // not `zero`, use the strict equal comparison to visualize the output.
                        if (inputLength <= kMaxShortLength) {
                            if ((_typeof(actual) !== 'object' || actual === null) && (_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
                            return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
                        } else if (operator !== 'strictEqualObject') {
                            // If the stderr is a tty and the input length is lower than the current
                            // columns per line, add a mismatch indicator below the output. If it is
                            // not a tty, use a default value of 80 characters.
                            var maxLength = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
                            if (inputLength < maxLength) {
                                while(actualLines[0][i] === expectedLines[0][i])i++;
                                // Ignore the first characters.
                                if (i > 2) {
                                    // Add position indicator for the first mismatch in case it is a
                                    // single line and the input length is less than the column length.
                                    indicator = "\n  ".concat(repeat(' ', i), "^");
                                    i = 0;
                                }
                            }
                        }
                    }
                    // Remove all ending lines that match (this optimizes the output for
                    // readability by reducing the number of total changed lines).
                    var a = actualLines[actualLines.length - 1];
                    var b = expectedLines[expectedLines.length - 1];
                    while(a === b){
                        if (i++ < 2) end = "\n  ".concat(a).concat(end);
                        else other = a;
                        actualLines.pop();
                        expectedLines.pop();
                        if (actualLines.length === 0 || expectedLines.length === 0) break;
                        a = actualLines[actualLines.length - 1];
                        b = expectedLines[expectedLines.length - 1];
                    }
                    var maxLines = Math.max(actualLines.length, expectedLines.length);
                    // Strict equal with identical objects that are not identical by reference.
                    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
                    if (maxLines === 0) {
                        // We have to get the result again. The lines were all removed before.
                        var _actualLines = actualInspected.split('\n');
                        // Only remove lines in case it makes sense to collapse those.
                        // TODO: Accept env to always show the full error.
                        if (_actualLines.length > 30) {
                            _actualLines[26] = "".concat(blue, "...").concat(white);
                            while(_actualLines.length > 27)_actualLines.pop();
                        }
                        return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
                    }
                    if (i > 3) {
                        end = "\n".concat(blue, "...").concat(white).concat(end);
                        skipped = true;
                    }
                    if (other !== '') {
                        end = "\n  ".concat(other).concat(end);
                        other = '';
                    }
                    var printedLines = 0;
                    var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
                    var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");
                    for(i = 0; i < maxLines; i++){
                        // Only extra expected lines exist
                        var cur = i - lastPos;
                        if (actualLines.length < i + 1) {
                            // If the last diverging line is more than one line above and the
                            // current line is at least line three, add some of the former lines and
                            // also add dots to indicate skipped entries.
                            if (cur > 1 && i > 2) {
                                if (cur > 4) {
                                    res += "\n".concat(blue, "...").concat(white);
                                    skipped = true;
                                } else if (cur > 3) {
                                    res += "\n  ".concat(expectedLines[i - 2]);
                                    printedLines++;
                                }
                                res += "\n  ".concat(expectedLines[i - 1]);
                                printedLines++;
                            }
                            // Mark the current line as the last diverging one.
                            lastPos = i;
                            // Add the expected line to the cache.
                            other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
                            printedLines++;
                        // Only extra actual lines exist
                        } else if (expectedLines.length < i + 1) {
                            // If the last diverging line is more than one line above and the
                            // current line is at least line three, add some of the former lines and
                            // also add dots to indicate skipped entries.
                            if (cur > 1 && i > 2) {
                                if (cur > 4) {
                                    res += "\n".concat(blue, "...").concat(white);
                                    skipped = true;
                                } else if (cur > 3) {
                                    res += "\n  ".concat(actualLines[i - 2]);
                                    printedLines++;
                                }
                                res += "\n  ".concat(actualLines[i - 1]);
                                printedLines++;
                            }
                            // Mark the current line as the last diverging one.
                            lastPos = i;
                            // Add the actual line to the result.
                            res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
                            printedLines++;
                        // Lines diverge
                        } else {
                            var expectedLine = expectedLines[i];
                            var actualLine = actualLines[i];
                            // If the lines diverge, specifically check for lines that only diverge by
                            // a trailing comma. In that case it is actually identical and we should
                            // mark it as such.
                            var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
                            // If the expected line has a trailing comma but is otherwise identical,
                            // add a comma at the end of the actual line. Otherwise the output could
                            // look weird as in:
                            //
                            //   [
                            //     1         // No comma at the end!
                            // +   2
                            //   ]
                            //
                            if (divergingLines && endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                                divergingLines = false;
                                actualLine += ',';
                            }
                            if (divergingLines) {
                                // If the last diverging line is more than one line above and the
                                // current line is at least line three, add some of the former lines and
                                // also add dots to indicate skipped entries.
                                if (cur > 1 && i > 2) {
                                    if (cur > 4) {
                                        res += "\n".concat(blue, "...").concat(white);
                                        skipped = true;
                                    } else if (cur > 3) {
                                        res += "\n  ".concat(actualLines[i - 2]);
                                        printedLines++;
                                    }
                                    res += "\n  ".concat(actualLines[i - 1]);
                                    printedLines++;
                                }
                                // Mark the current line as the last diverging one.
                                lastPos = i;
                                // Add the actual line to the result and cache the expected diverging
                                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                                res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
                                other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
                                printedLines += 2;
                            // Lines are identical
                            } else {
                                // Add all cached information to the result before adding other things
                                // and reset the cache.
                                res += other;
                                other = '';
                                // If the last diverging line is exactly one line above or if it is the
                                // very first line, add the line to the result.
                                if (cur === 1 || i === 0) {
                                    res += "\n  ".concat(actualLine);
                                    printedLines++;
                                }
                            }
                        }
                        // Inspected object to big (Show ~20 rows max)
                        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
                    }
                    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
                }
                var AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
                    _inherits(AssertionError, _Error);
                    var _super = _createSuper(AssertionError);
                    function AssertionError(options) {
                        var _this;
                        _classCallCheck(this, AssertionError);
                        if (_typeof(options) !== 'object' || options === null) throw new ERR_INVALID_ARG_TYPE('options', 'Object', options);
                        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
                        var actual = options.actual, expected = options.expected;
                        var limit = Error.stackTraceLimit;
                        Error.stackTraceLimit = 0;
                        if (message != null) _this = _super.call(this, String(message));
                        else {
                            if (process.stderr && process.stderr.isTTY) {
                                // Reset on each call to make sure we handle dynamically set environment
                                // variables correct.
                                if (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1) {
                                    blue = "\x1B[34m";
                                    green = "\x1B[32m";
                                    white = "\x1B[39m";
                                    red = "\x1B[31m";
                                } else {
                                    blue = '';
                                    green = '';
                                    white = '';
                                    red = '';
                                }
                            }
                            // Prevent the error stack from being visible by duplicating the error
                            // in a very close way to the original in case both sides are actually
                            // instances of Error.
                            if (_typeof(actual) === 'object' && actual !== null && _typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                                actual = copyError(actual);
                                expected = copyError(expected);
                            }
                            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, createErrDiff(actual, expected, operator));
                            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                                // In case the objects are equal but the operator requires unequal, show
                                // the first object and say A equals B
                                var base = kReadableOperator[operator];
                                var res = inspectValue(actual).split('\n');
                                // In case "actual" is an object, it should not be reference equal.
                                if (operator === 'notStrictEqual' && _typeof(actual) === 'object' && actual !== null) base = kReadableOperator.notStrictEqualObject;
                                // Only remove lines in case it makes sense to collapse those.
                                // TODO: Accept env to always show the full error.
                                if (res.length > 30) {
                                    res[26] = "".concat(blue, "...").concat(white);
                                    while(res.length > 27)res.pop();
                                }
                                // Only print a single input.
                                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
                            } else {
                                var _res = inspectValue(actual);
                                var other = '';
                                var knownOperators = kReadableOperator[operator];
                                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                                    _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);
                                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                                } else {
                                    other = "".concat(inspectValue(expected));
                                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                                    else other = " ".concat(operator, " ").concat(other);
                                }
                                _this = _super.call(this, "".concat(_res).concat(other));
                            }
                        }
                        Error.stackTraceLimit = limit;
                        _this.generatedMessage = !message;
                        Object.defineProperty(_assertThisInitialized(_this), 'name', {
                            value: 'AssertionError [ERR_ASSERTION]',
                            enumerable: false,
                            writable: true,
                            configurable: true
                        });
                        _this.code = 'ERR_ASSERTION';
                        _this.actual = actual;
                        _this.expected = expected;
                        _this.operator = operator;
                        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
                        Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
                        // Create error message including the error code in the name.
                        _this.stack;
                        // Reset the name.
                        _this.name = 'AssertionError';
                        return _possibleConstructorReturn(_this);
                    }
                    _createClass(AssertionError, [
                        {
                            key: "toString",
                            value: function toString() {
                                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                            }
                        },
                        {
                            key: _inspect$custom,
                            value: function value(recurseTimes, ctx) {
                                // This limits the `actual` and `expected` property default inspection to
                                // the minimum depth. Otherwise those values would be too verbose compared
                                // to the actual error message which contains a combined view of these two
                                // input values.
                                return inspect(this, _objectSpread(_objectSpread({}, ctx), {}, {
                                    customInspect: false,
                                    depth: 0
                                }));
                            }
                        }
                    ]);
                    return AssertionError;
                }(/*#__PURE__*/ _wrapNativeSuper(Error), inspect.custom);
                module1.exports = AssertionError;
            /***/ },
            /***/ 85567: /***/ function(module1) {
                "use strict";
                /** @type {import('./gOPD')} */ module1.exports = Object.getOwnPropertyDescriptor;
            /***/ },
            /***/ 85628: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    /**
   * Zero padding strategy.
   */ CryptoJS.pad.ZeroPadding = {
                        pad: function pad(data, blockSize) {
                            // Shortcut
                            var blockSizeBytes = blockSize * 4;
                            // Pad
                            data.clamp();
                            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
                        },
                        unpad: function unpad(data) {
                            // Shortcut
                            var dataWords = data.words;
                            // Unpad
                            var i = data.sigBytes - 1;
                            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                                data.sigBytes = i + 1;
                                break;
                            }
                        }
                    };
                    return CryptoJS.pad.ZeroPadding;
                });
            /***/ },
            /***/ 86255: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var GetIntrinsic = __webpack_require__(28651);
                var define = __webpack_require__(89295);
                var hasDescriptors = __webpack_require__(18890)();
                var gOPD = __webpack_require__(68109);
                var $TypeError = __webpack_require__(96785);
                var $floor = GetIntrinsic('%Math.floor%');
                /** @type {import('.')} */ module1.exports = function setFunctionLength(fn, length) {
                    if (typeof fn !== 'function') throw new $TypeError('`fn` is not a function');
                    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) throw new $TypeError('`length` must be a positive 32-bit integer');
                    var loose = arguments.length > 2 && !!arguments[2];
                    var functionLengthIsConfigurable = true;
                    var functionLengthIsWritable = true;
                    if ('length' in fn && gOPD) {
                        var desc = gOPD(fn, 'length');
                        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
                        if (desc && !desc.writable) functionLengthIsWritable = false;
                    }
                    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
                        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
                        else define(/** @type {Parameters<define>[0]} */ fn, 'length', length);
                    }
                    return fn;
                };
            /***/ },
            /***/ 86392: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toString = __webpack_require__(25096);
                module1.exports = function(argument, $default) {
                    return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
                };
            /***/ },
            /***/ 86781: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Currently in sync with Node.js lib/internal/util/comparisons.js
                // https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
                function _slicedToArray(arr, i) {
                    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o, minLen) {
                    if (!o) return;
                    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                    var n = Object.prototype.toString.call(o).slice(8, -1);
                    if (n === "Object" && o.constructor) n = o.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(o);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _arrayLikeToArray(arr, len) {
                    if (len == null || len > arr.length) len = arr.length;
                    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                    return arr2;
                }
                function _iterableToArrayLimit(r, l) {
                    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                    if (null != t) {
                        var e, n, i, u, a = [], f = !0, o = !1;
                        try {
                            if (i = (t = t.call(r)).next, 0 === l) {
                                if (Object(t) !== t) return;
                                f = !1;
                            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
                        } catch (r) {
                            o = !0, n = r;
                        } finally{
                            try {
                                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                            } finally{
                                if (o) throw n;
                            }
                        }
                        return a;
                    }
                }
                function _arrayWithHoles(arr) {
                    if (Array.isArray(arr)) return arr;
                }
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                var regexFlagsSupported = /a/g.flags !== undefined;
                var arrayFromSet = function arrayFromSet(set) {
                    var array = [];
                    set.forEach(function(value) {
                        return array.push(value);
                    });
                    return array;
                };
                var arrayFromMap = function arrayFromMap(map) {
                    var array = [];
                    map.forEach(function(value, key) {
                        return array.push([
                            key,
                            value
                        ]);
                    });
                    return array;
                };
                var objectIs = Object.is ? Object.is : __webpack_require__(98527);
                var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
                    return [];
                };
                var numberIsNaN = Number.isNaN ? Number.isNaN : __webpack_require__(7051);
                function uncurryThis(f) {
                    return f.call.bind(f);
                }
                var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
                var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
                var objectToString = uncurryThis(Object.prototype.toString);
                var _require$types = __webpack_require__(7187).types, isAnyArrayBuffer = _require$types.isAnyArrayBuffer, isArrayBufferView = _require$types.isArrayBufferView, isDate = _require$types.isDate, isMap = _require$types.isMap, isRegExp = _require$types.isRegExp, isSet = _require$types.isSet, isNativeError = _require$types.isNativeError, isBoxedPrimitive = _require$types.isBoxedPrimitive, isNumberObject = _require$types.isNumberObject, isStringObject = _require$types.isStringObject, isBooleanObject = _require$types.isBooleanObject, isBigIntObject = _require$types.isBigIntObject, isSymbolObject = _require$types.isSymbolObject, isFloat32Array = _require$types.isFloat32Array, isFloat64Array = _require$types.isFloat64Array;
                function isNonIndex(key) {
                    if (key.length === 0 || key.length > 10) return true;
                    for(var i = 0; i < key.length; i++){
                        var code = key.charCodeAt(i);
                        if (code < 48 || code > 57) return true;
                    }
                    // The maximum size for an array is 2 ** 32 -1.
                    return key.length === 10 && key >= Math.pow(2, 32);
                }
                function getOwnNonIndexProperties(value) {
                    return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
                }
                // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
                // original notice:
                /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function compare(a, b) {
                    if (a === b) return 0;
                    var x = a.length;
                    var y = b.length;
                    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                        x = a[i];
                        y = b[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                }
                var ONLY_ENUMERABLE = undefined;
                var kStrict = true;
                var kLoose = false;
                var kNoIterator = 0;
                var kIsArray = 1;
                var kIsSet = 2;
                var kIsMap = 3;
                // Check if they have the same source and flags
                function areSimilarRegExps(a, b) {
                    return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
                }
                function areSimilarFloatArrays(a, b) {
                    if (a.byteLength !== b.byteLength) return false;
                    for(var offset = 0; offset < a.byteLength; offset++){
                        if (a[offset] !== b[offset]) return false;
                    }
                    return true;
                }
                function areSimilarTypedArrays(a, b) {
                    if (a.byteLength !== b.byteLength) return false;
                    return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
                }
                function areEqualArrayBuffers(buf1, buf2) {
                    return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
                }
                function isEqualBoxedPrimitive(val1, val2) {
                    if (isNumberObject(val1)) return isNumberObject(val2) && objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
                    if (isStringObject(val1)) return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
                    if (isBooleanObject(val1)) return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
                    if (isBigIntObject(val1)) return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
                    return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
                }
                // Notes: Type tags are historical [[Class]] properties that can be set by
                // FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
                // and retrieved using Object.prototype.toString.call(obj) in JS
                // See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
                // for a list of tags pre-defined in the spec.
                // There are some unspecified tags in the wild too (e.g. typed array tags).
                // Since tags can be altered, they only serve fast failures
                //
                // Typed arrays and buffers are checked by comparing the content in their
                // underlying ArrayBuffer. This optimization requires that it's
                // reasonable to interpret their underlying memory in the same way,
                // which is checked by comparing their type tags.
                // (e.g. a Uint8Array and a Uint16Array with the same memory content
                // could still be different because they will be interpreted differently).
                //
                // For strict comparison, objects should have
                // a) The same built-in type tags
                // b) The same prototypes.
                function innerDeepEqual(val1, val2, strict, memos) {
                    // All identical values are equivalent, as determined by ===.
                    if (val1 === val2) {
                        if (val1 !== 0) return true;
                        return strict ? objectIs(val1, val2) : true;
                    }
                    // Check more closely if val1 and val2 are equal.
                    if (strict) {
                        if (_typeof(val1) !== 'object') return typeof val1 === 'number' && numberIsNaN(val1) && numberIsNaN(val2);
                        if (_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
                        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
                    } else {
                        if (val1 === null || _typeof(val1) !== 'object') {
                            if (val2 === null || _typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
                            return val1 == val2;
                            return false;
                        }
                        if (val2 === null || _typeof(val2) !== 'object') return false;
                    }
                    var val1Tag = objectToString(val1);
                    var val2Tag = objectToString(val2);
                    if (val1Tag !== val2Tag) return false;
                    if (Array.isArray(val1)) {
                        // Check for sparse arrays and general fast path
                        if (val1.length !== val2.length) return false;
                        var keys1 = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
                        var keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
                        if (keys1.length !== keys2.length) return false;
                        return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
                    }
                    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
                    // wan't to early return out of the rest of the checks. However we can check
                    // if the second value is one of these values and the first isn't.
                    if (val1Tag === '[object Object]') {
                        // return keyCheck(val1, val2, strict, memos, kNoIterator);
                        if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) return false;
                    }
                    if (isDate(val1)) {
                        if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
                    } else if (isRegExp(val1)) {
                        if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) return false;
                    } else if (isNativeError(val1) || val1 instanceof Error) {
                        // Do not compare the stack as it might differ even though the error itself
                        // is otherwise identical.
                        if (val1.message !== val2.message || val1.name !== val2.name) return false;
                    } else if (isArrayBufferView(val1)) {
                        if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
                            if (!areSimilarFloatArrays(val1, val2)) return false;
                        } else if (!areSimilarTypedArrays(val1, val2)) return false;
                        // Buffer.compare returns true, so val1.length === val2.length. If they both
                        // only contain numeric keys, we don't need to exam further than checking
                        // the symbols.
                        var _keys = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
                        var _keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
                        if (_keys.length !== _keys2.length) return false;
                        return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
                    } else if (isSet(val1)) {
                        if (!isSet(val2) || val1.size !== val2.size) return false;
                        return keyCheck(val1, val2, strict, memos, kIsSet);
                    } else if (isMap(val1)) {
                        if (!isMap(val2) || val1.size !== val2.size) return false;
                        return keyCheck(val1, val2, strict, memos, kIsMap);
                    } else if (isAnyArrayBuffer(val1)) {
                        if (!areEqualArrayBuffers(val1, val2)) return false;
                    } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) return false;
                    return keyCheck(val1, val2, strict, memos, kNoIterator);
                }
                function getEnumerables(val, keys) {
                    return keys.filter(function(k) {
                        return propertyIsEnumerable(val, k);
                    });
                }
                function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
                    // For all remaining Object pairs, including Array, objects and Maps,
                    // equivalence is determined by having:
                    // a) The same number of owned enumerable properties
                    // b) The same set of keys/indexes (although not necessarily the same order)
                    // c) Equivalent values for every corresponding key/index
                    // d) For Sets and Maps, equal contents
                    // Note: this accounts for both named and indexed properties on Arrays.
                    if (arguments.length === 5) {
                        aKeys = Object.keys(val1);
                        var bKeys = Object.keys(val2);
                        // The pair must have the same number of owned properties.
                        if (aKeys.length !== bKeys.length) return false;
                    }
                    // Cheap key test
                    var i = 0;
                    for(; i < aKeys.length; i++){
                        if (!hasOwnProperty(val2, aKeys[i])) return false;
                    }
                    if (strict && arguments.length === 5) {
                        var symbolKeysA = objectGetOwnPropertySymbols(val1);
                        if (symbolKeysA.length !== 0) {
                            var count = 0;
                            for(i = 0; i < symbolKeysA.length; i++){
                                var key = symbolKeysA[i];
                                if (propertyIsEnumerable(val1, key)) {
                                    if (!propertyIsEnumerable(val2, key)) return false;
                                    aKeys.push(key);
                                    count++;
                                } else if (propertyIsEnumerable(val2, key)) return false;
                            }
                            var symbolKeysB = objectGetOwnPropertySymbols(val2);
                            if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) return false;
                        } else {
                            var _symbolKeysB = objectGetOwnPropertySymbols(val2);
                            if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) return false;
                        }
                    }
                    if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) return true;
                    // Use memos to handle cycles.
                    if (memos === undefined) memos = {
                        val1: new Map(),
                        val2: new Map(),
                        position: 0
                    };
                    else {
                        // We prevent up to two map.has(x) calls by directly retrieving the value
                        // and checking for undefined. The map can only contain numbers, so it is
                        // safe to check for undefined only.
                        var val2MemoA = memos.val1.get(val1);
                        if (val2MemoA !== undefined) {
                            var val2MemoB = memos.val2.get(val2);
                            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
                        }
                        memos.position++;
                    }
                    memos.val1.set(val1, memos.position);
                    memos.val2.set(val2, memos.position);
                    var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
                    memos.val1.delete(val1);
                    memos.val2.delete(val2);
                    return areEq;
                }
                function setHasEqualElement(set, val1, strict, memo) {
                    // Go looking.
                    var setValues = arrayFromSet(set);
                    for(var i = 0; i < setValues.length; i++){
                        var val2 = setValues[i];
                        if (innerDeepEqual(val1, val2, strict, memo)) {
                            // Remove the matching element to make sure we do not check that again.
                            set.delete(val2);
                            return true;
                        }
                    }
                    return false;
                }
                // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
                // Sadly it is not possible to detect corresponding values properly in case the
                // type is a string, number, bigint or boolean. The reason is that those values
                // can match lots of different string values (e.g., 1n == '+00001').
                function findLooseMatchingPrimitives(prim) {
                    switch(_typeof(prim)){
                        case 'undefined':
                            return null;
                        case 'object':
                            // Only pass in null as object!
                            return undefined;
                        case 'symbol':
                            return false;
                        case 'string':
                            prim = +prim;
                        // Loose equal entries exist only if the string is possible to convert to
                        // a regular number and not NaN.
                        // Fall through
                        case 'number':
                            if (numberIsNaN(prim)) return false;
                    }
                    return true;
                }
                function setMightHaveLoosePrim(a, b, prim) {
                    var altValue = findLooseMatchingPrimitives(prim);
                    if (altValue != null) return altValue;
                    return b.has(altValue) && !a.has(altValue);
                }
                function mapMightHaveLoosePrim(a, b, prim, item, memo) {
                    var altValue = findLooseMatchingPrimitives(prim);
                    if (altValue != null) return altValue;
                    var curB = b.get(altValue);
                    if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) return false;
                    return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
                }
                function setEquiv(a, b, strict, memo) {
                    // This is a lazily initiated Set of entries which have to be compared
                    // pairwise.
                    var set = null;
                    var aValues = arrayFromSet(a);
                    for(var i = 0; i < aValues.length; i++){
                        var val = aValues[i];
                        // Note: Checking for the objects first improves the performance for object
                        // heavy sets but it is a minor slow down for primitives. As they are fast
                        // to check this improves the worst case scenario instead.
                        if (_typeof(val) === 'object' && val !== null) {
                            if (set === null) set = new Set();
                            // If the specified value doesn't exist in the second set its an not null
                            // object (or non strict only: a not matching primitive) we'll need to go
                            // hunting for something thats deep-(strict-)equal to it. To make this
                            // O(n log n) complexity we have to copy these values in a new set first.
                            set.add(val);
                        } else if (!b.has(val)) {
                            if (strict) return false;
                            // Fast path to detect missing string, symbol, undefined and null values.
                            if (!setMightHaveLoosePrim(a, b, val)) return false;
                            if (set === null) set = new Set();
                            set.add(val);
                        }
                    }
                    if (set !== null) {
                        var bValues = arrayFromSet(b);
                        for(var _i = 0; _i < bValues.length; _i++){
                            var _val = bValues[_i];
                            // We have to check if a primitive value is already
                            // matching and only if it's not, go hunting for it.
                            if (_typeof(_val) === 'object' && _val !== null) {
                                if (!setHasEqualElement(set, _val, strict, memo)) return false;
                            } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) return false;
                        }
                        return set.size === 0;
                    }
                    return true;
                }
                function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
                    // To be able to handle cases like:
                    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
                    // ... we need to consider *all* matching keys, not just the first we find.
                    var setValues = arrayFromSet(set);
                    for(var i = 0; i < setValues.length; i++){
                        var key2 = setValues[i];
                        if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
                            set.delete(key2);
                            return true;
                        }
                    }
                    return false;
                }
                function mapEquiv(a, b, strict, memo) {
                    var set = null;
                    var aEntries = arrayFromMap(a);
                    for(var i = 0; i < aEntries.length; i++){
                        var _aEntries$i = _slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
                        if (_typeof(key) === 'object' && key !== null) {
                            if (set === null) set = new Set();
                            set.add(key);
                        } else {
                            // By directly retrieving the value we prevent another b.has(key) check in
                            // almost all possible cases.
                            var item2 = b.get(key);
                            if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
                                if (strict) return false;
                                // Fast path to detect missing string, symbol, undefined and null
                                // keys.
                                if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                                if (set === null) set = new Set();
                                set.add(key);
                            }
                        }
                    }
                    if (set !== null) {
                        var bEntries = arrayFromMap(b);
                        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
                            var _bEntries$_i = _slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
                            if (_typeof(_key) === 'object' && _key !== null) {
                                if (!mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
                            } else if (!strict && (!a.has(_key) || !innerDeepEqual(a.get(_key), item, false, memo)) && !mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
                        }
                        return set.size === 0;
                    }
                    return true;
                }
                function objEquiv(a, b, strict, keys, memos, iterationType) {
                    // Sets and maps don't have their entries accessible via normal object
                    // properties.
                    var i = 0;
                    if (iterationType === kIsSet) {
                        if (!setEquiv(a, b, strict, memos)) return false;
                    } else if (iterationType === kIsMap) {
                        if (!mapEquiv(a, b, strict, memos)) return false;
                    } else if (iterationType === kIsArray) for(; i < a.length; i++){
                        if (hasOwnProperty(a, i)) {
                            if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) return false;
                        } else if (hasOwnProperty(b, i)) return false;
                        else {
                            // Array is sparse.
                            var keysA = Object.keys(a);
                            for(; i < keysA.length; i++){
                                var key = keysA[i];
                                if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) return false;
                            }
                            if (keysA.length !== Object.keys(b).length) return false;
                            return true;
                        }
                    }
                    // The pair must have equivalent values for every corresponding key.
                    // Possibly expensive deep test:
                    for(i = 0; i < keys.length; i++){
                        var _key2 = keys[i];
                        if (!innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
                    }
                    return true;
                }
                function isDeepEqual(val1, val2) {
                    return innerDeepEqual(val1, val2, kLoose);
                }
                function isDeepStrictEqual(val1, val2) {
                    return innerDeepEqual(val1, val2, kStrict);
                }
                module1.exports = {
                    isDeepEqual: isDeepEqual,
                    isDeepStrictEqual: isDeepStrictEqual
                };
            /***/ },
            /***/ 86822: /***/ function(module1) {
                "use strict";
                /** @type {import('./Reflect.getPrototypeOf')} */ module1.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;
            /***/ },
            /***/ 87106: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var reflectGetProto = __webpack_require__(86822);
                var originalGetProto = __webpack_require__(33766);
                var getDunderProto = __webpack_require__(89302);
                /** @type {import('.')} */ module1.exports = reflectGetProto ? function getProto(O) {
                    // @ts-expect-error TS can't narrow inside a closure, for some reason
                    return reflectGetProto(O);
                } : originalGetProto ? function getProto(O) {
                    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
                    // @ts-expect-error TS can't narrow inside a closure, for some reason
                    return originalGetProto(O);
                } : getDunderProto ? function getProto(O) {
                    // @ts-expect-error TS can't narrow inside a closure, for some reason
                    return getDunderProto(O);
                } : null;
            /***/ },
            /***/ 87146: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var DESCRIPTORS = __webpack_require__(15567);
                var uncurryThis = __webpack_require__(38347);
                var call = __webpack_require__(2834);
                var fails = __webpack_require__(47044);
                var objectKeys = __webpack_require__(84675);
                var getOwnPropertySymbolsModule = __webpack_require__(61146);
                var propertyIsEnumerableModule = __webpack_require__(55574);
                var toObject = __webpack_require__(43162);
                var IndexedObject = __webpack_require__(7514);
                // eslint-disable-next-line es/no-object-assign -- safe
                var $assign = Object.assign;
                // eslint-disable-next-line es/no-object-defineproperty -- required for testing
                var defineProperty = Object.defineProperty;
                var concat = uncurryThis([].concat);
                // `Object.assign` method
                // https://tc39.es/ecma262/#sec-object.assign
                module1.exports = !$assign || fails(function() {
                    // should have correct order of operations (Edge bug)
                    if (DESCRIPTORS && $assign({
                        b: 1
                    }, $assign(defineProperty({}, 'a', {
                        enumerable: true,
                        get: function() {
                            defineProperty(this, 'b', {
                                value: 3,
                                enumerable: false
                            });
                        }
                    }), {
                        b: 2
                    })).b !== 1) return true;
                    // should work with symbols and should have deterministic property order (V8 bug)
                    var A = {};
                    var B = {};
                    // eslint-disable-next-line es/no-symbol -- safe
                    var symbol = Symbol();
                    var alphabet = 'abcdefghijklmnopqrst';
                    A[symbol] = 7;
                    alphabet.split('').forEach(function(chr) {
                        B[chr] = chr;
                    });
                    return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
                }) ? function assign(target, source) {
                    var T = toObject(target);
                    var argumentsLength = arguments.length;
                    var index = 1;
                    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                    var propertyIsEnumerable = propertyIsEnumerableModule.f;
                    while(argumentsLength > index){
                        var S = IndexedObject(arguments[index++]);
                        var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
                        var length = keys.length;
                        var j = 0;
                        var key;
                        while(length > j){
                            key = keys[j++];
                            if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
                        }
                    }
                    return T;
                } : $assign;
            /***/ },
            /***/ 87811: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var isObject = __webpack_require__(24517);
                var createNonEnumerableProperty = __webpack_require__(48914);
                // `InstallErrorCause` abstract operation
                // https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
                module1.exports = function(O, options) {
                    if (isObject(options) && 'cause' in options) createNonEnumerableProperty(O, 'cause', options.cause);
                };
            /***/ },
            /***/ 87984: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/ var BrotliDictionary = __webpack_require__(80614);
                var kIdentity = 0;
                var kOmitLast1 = 1;
                var kOmitLast2 = 2;
                var kOmitLast3 = 3;
                var kOmitLast4 = 4;
                var kOmitLast5 = 5;
                var kOmitLast6 = 6;
                var kOmitLast7 = 7;
                var kOmitLast8 = 8;
                var kOmitLast9 = 9;
                var kUppercaseFirst = 10;
                var kUppercaseAll = 11;
                var kOmitFirst1 = 12;
                var kOmitFirst2 = 13;
                var kOmitFirst3 = 14;
                var kOmitFirst4 = 15;
                var kOmitFirst5 = 16;
                var kOmitFirst6 = 17;
                var kOmitFirst7 = 18;
                var kOmitFirst8 = 19;
                var kOmitFirst9 = 20;
                function Transform(prefix, transform, suffix) {
                    this.prefix = new Uint8Array(prefix.length);
                    this.transform = transform;
                    this.suffix = new Uint8Array(suffix.length);
                    for(var i = 0; i < prefix.length; i++)this.prefix[i] = prefix.charCodeAt(i);
                    for(var i = 0; i < suffix.length; i++)this.suffix[i] = suffix.charCodeAt(i);
                }
                var kTransforms = [
                    new Transform("", kIdentity, ""),
                    new Transform("", kIdentity, " "),
                    new Transform(" ", kIdentity, " "),
                    new Transform("", kOmitFirst1, ""),
                    new Transform("", kUppercaseFirst, " "),
                    new Transform("", kIdentity, " the "),
                    new Transform(" ", kIdentity, ""),
                    new Transform("s ", kIdentity, " "),
                    new Transform("", kIdentity, " of "),
                    new Transform("", kUppercaseFirst, ""),
                    new Transform("", kIdentity, " and "),
                    new Transform("", kOmitFirst2, ""),
                    new Transform("", kOmitLast1, ""),
                    new Transform(", ", kIdentity, " "),
                    new Transform("", kIdentity, ", "),
                    new Transform(" ", kUppercaseFirst, " "),
                    new Transform("", kIdentity, " in "),
                    new Transform("", kIdentity, " to "),
                    new Transform("e ", kIdentity, " "),
                    new Transform("", kIdentity, "\""),
                    new Transform("", kIdentity, "."),
                    new Transform("", kIdentity, "\">"),
                    new Transform("", kIdentity, "\n"),
                    new Transform("", kOmitLast3, ""),
                    new Transform("", kIdentity, "]"),
                    new Transform("", kIdentity, " for "),
                    new Transform("", kOmitFirst3, ""),
                    new Transform("", kOmitLast2, ""),
                    new Transform("", kIdentity, " a "),
                    new Transform("", kIdentity, " that "),
                    new Transform(" ", kUppercaseFirst, ""),
                    new Transform("", kIdentity, ". "),
                    new Transform(".", kIdentity, ""),
                    new Transform(" ", kIdentity, ", "),
                    new Transform("", kOmitFirst4, ""),
                    new Transform("", kIdentity, " with "),
                    new Transform("", kIdentity, "'"),
                    new Transform("", kIdentity, " from "),
                    new Transform("", kIdentity, " by "),
                    new Transform("", kOmitFirst5, ""),
                    new Transform("", kOmitFirst6, ""),
                    new Transform(" the ", kIdentity, ""),
                    new Transform("", kOmitLast4, ""),
                    new Transform("", kIdentity, ". The "),
                    new Transform("", kUppercaseAll, ""),
                    new Transform("", kIdentity, " on "),
                    new Transform("", kIdentity, " as "),
                    new Transform("", kIdentity, " is "),
                    new Transform("", kOmitLast7, ""),
                    new Transform("", kOmitLast1, "ing "),
                    new Transform("", kIdentity, "\n\t"),
                    new Transform("", kIdentity, ":"),
                    new Transform(" ", kIdentity, ". "),
                    new Transform("", kIdentity, "ed "),
                    new Transform("", kOmitFirst9, ""),
                    new Transform("", kOmitFirst7, ""),
                    new Transform("", kOmitLast6, ""),
                    new Transform("", kIdentity, "("),
                    new Transform("", kUppercaseFirst, ", "),
                    new Transform("", kOmitLast8, ""),
                    new Transform("", kIdentity, " at "),
                    new Transform("", kIdentity, "ly "),
                    new Transform(" the ", kIdentity, " of "),
                    new Transform("", kOmitLast5, ""),
                    new Transform("", kOmitLast9, ""),
                    new Transform(" ", kUppercaseFirst, ", "),
                    new Transform("", kUppercaseFirst, "\""),
                    new Transform(".", kIdentity, "("),
                    new Transform("", kUppercaseAll, " "),
                    new Transform("", kUppercaseFirst, "\">"),
                    new Transform("", kIdentity, "=\""),
                    new Transform(" ", kIdentity, "."),
                    new Transform(".com/", kIdentity, ""),
                    new Transform(" the ", kIdentity, " of the "),
                    new Transform("", kUppercaseFirst, "'"),
                    new Transform("", kIdentity, ". This "),
                    new Transform("", kIdentity, ","),
                    new Transform(".", kIdentity, " "),
                    new Transform("", kUppercaseFirst, "("),
                    new Transform("", kUppercaseFirst, "."),
                    new Transform("", kIdentity, " not "),
                    new Transform(" ", kIdentity, "=\""),
                    new Transform("", kIdentity, "er "),
                    new Transform(" ", kUppercaseAll, " "),
                    new Transform("", kIdentity, "al "),
                    new Transform(" ", kUppercaseAll, ""),
                    new Transform("", kIdentity, "='"),
                    new Transform("", kUppercaseAll, "\""),
                    new Transform("", kUppercaseFirst, ". "),
                    new Transform(" ", kIdentity, "("),
                    new Transform("", kIdentity, "ful "),
                    new Transform(" ", kUppercaseFirst, ". "),
                    new Transform("", kIdentity, "ive "),
                    new Transform("", kIdentity, "less "),
                    new Transform("", kUppercaseAll, "'"),
                    new Transform("", kIdentity, "est "),
                    new Transform(" ", kUppercaseFirst, "."),
                    new Transform("", kUppercaseAll, "\">"),
                    new Transform(" ", kIdentity, "='"),
                    new Transform("", kUppercaseFirst, ","),
                    new Transform("", kIdentity, "ize "),
                    new Transform("", kUppercaseAll, "."),
                    new Transform("\xc2\xa0", kIdentity, ""),
                    new Transform(" ", kIdentity, ","),
                    new Transform("", kUppercaseFirst, "=\""),
                    new Transform("", kUppercaseAll, "=\""),
                    new Transform("", kIdentity, "ous "),
                    new Transform("", kUppercaseAll, ", "),
                    new Transform("", kUppercaseFirst, "='"),
                    new Transform(" ", kUppercaseFirst, ","),
                    new Transform(" ", kUppercaseAll, "=\""),
                    new Transform(" ", kUppercaseAll, ", "),
                    new Transform("", kUppercaseAll, ","),
                    new Transform("", kUppercaseAll, "("),
                    new Transform("", kUppercaseAll, ". "),
                    new Transform(" ", kUppercaseAll, "."),
                    new Transform("", kUppercaseAll, "='"),
                    new Transform(" ", kUppercaseAll, ". "),
                    new Transform(" ", kUppercaseFirst, "=\""),
                    new Transform(" ", kUppercaseAll, "='"),
                    new Transform(" ", kUppercaseFirst, "='")
                ];
                exports.kTransforms = kTransforms;
                exports.kNumTransforms = kTransforms.length;
                function ToUpperCase(p, i) {
                    if (p[i] < 0xc0) {
                        if (p[i] >= 97 && p[i] <= 122) p[i] ^= 32;
                        return 1;
                    }
                    /* An overly simplified uppercasing model for utf-8. */ if (p[i] < 0xe0) {
                        p[i + 1] ^= 32;
                        return 2;
                    }
                    /* An arbitrary transform for three byte characters. */ p[i + 2] ^= 5;
                    return 3;
                }
                exports.transformDictionaryWord = function(dst, idx, word, len, transform) {
                    var prefix = kTransforms[transform].prefix;
                    var suffix = kTransforms[transform].suffix;
                    var t = kTransforms[transform].transform;
                    var skip = t < kOmitFirst1 ? 0 : t - (kOmitFirst1 - 1);
                    var i = 0;
                    var start_idx = idx;
                    var uppercase;
                    if (skip > len) skip = len;
                    var prefix_pos = 0;
                    while(prefix_pos < prefix.length)dst[idx++] = prefix[prefix_pos++];
                    word += skip;
                    len -= skip;
                    if (t <= kOmitLast9) len -= t;
                    for(i = 0; i < len; i++)dst[idx++] = BrotliDictionary.dictionary[word + i];
                    uppercase = idx - len;
                    if (t === kUppercaseFirst) ToUpperCase(dst, uppercase);
                    else if (t === kUppercaseAll) while(len > 0){
                        var step = ToUpperCase(dst, uppercase);
                        uppercase += step;
                        len -= step;
                    }
                    var suffix_pos = 0;
                    while(suffix_pos < suffix.length)dst[idx++] = suffix[suffix_pos++];
                    return idx - start_idx;
                };
            /***/ },
            /***/ 88042: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $map = __webpack_require__(91102).map;
                var typedArraySpeciesConstructor = __webpack_require__(34815);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.map` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
                exportTypedArrayMethod('map', function map(mapfn /* , thisArg */ ) {
                    return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function(O, length) {
                        return new (typedArraySpeciesConstructor(O))(length);
                    });
                });
            /***/ },
            /***/ 88152: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var utils = __webpack_require__(18128);
                var Struct = /*#__PURE__*/ function() {
                    function Struct(fields) {
                        if (fields === void 0) fields = {};
                        this.fields = fields;
                    }
                    var _proto = Struct.prototype;
                    _proto.decode = function decode(stream, parent, length) {
                        if (length === void 0) length = 0;
                        var res = this._setup(stream, parent, length);
                        this._parseFields(stream, res, this.fields);
                        if (this.process != null) this.process.call(res, stream);
                        return res;
                    };
                    _proto._setup = function _setup(stream, parent, length) {
                        var res = {};
                        // define hidden properties
                        Object.defineProperties(res, {
                            parent: {
                                value: parent
                            },
                            _startOffset: {
                                value: stream.pos
                            },
                            _currentOffset: {
                                value: 0,
                                writable: true
                            },
                            _length: {
                                value: length
                            }
                        });
                        return res;
                    };
                    _proto._parseFields = function _parseFields(stream, res, fields) {
                        for(var key in fields){
                            var val;
                            var type = fields[key];
                            if (typeof type === 'function') val = type.call(res, res);
                            else val = type.decode(stream, res);
                            if (val !== undefined) {
                                if (val instanceof utils.PropertyDescriptor) Object.defineProperty(res, key, val);
                                else res[key] = val;
                            }
                            res._currentOffset = stream.pos - res._startOffset;
                        }
                    };
                    _proto.size = function size(val, parent, includePointers) {
                        if (val == null) val = {};
                        if (includePointers == null) includePointers = true;
                        var ctx = {
                            parent: parent,
                            val: val,
                            pointerSize: 0
                        };
                        var size = 0;
                        for(var key in this.fields){
                            var type = this.fields[key];
                            if (type.size != null) size += type.size(val[key], ctx);
                        }
                        if (includePointers) size += ctx.pointerSize;
                        return size;
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        var type;
                        if (this.preEncode != null) this.preEncode.call(val, stream);
                        var ctx = {
                            pointers: [],
                            startOffset: stream.pos,
                            parent: parent,
                            val: val,
                            pointerSize: 0
                        };
                        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
                        for(var key in this.fields){
                            type = this.fields[key];
                            if (type.encode != null) type.encode(stream, val[key], ctx);
                        }
                        var i = 0;
                        while(i < ctx.pointers.length){
                            var ptr = ctx.pointers[i++];
                            ptr.type.encode(stream, ptr.val, ptr.parent);
                        }
                    };
                    return Struct;
                }();
                module1.exports = Struct;
            /***/ },
            /***/ 88261: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(9964);
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                module1.exports = Readable;
                /*<replacement>*/ var Duplex;
                /*</replacement>*/ Readable.ReadableState = ReadableState;
                /*<replacement>*/ var EE = __webpack_require__(64785).EventEmitter;
                var EElistenerCount = function EElistenerCount(emitter, type) {
                    return emitter.listeners(type).length;
                };
                /*</replacement>*/ /*<replacement>*/ var Stream = __webpack_require__(99018);
                /*</replacement>*/ var Buffer = __webpack_require__(14598).Buffer;
                var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
                function _uint8ArrayToBuffer(chunk) {
                    return Buffer.from(chunk);
                }
                function _isUint8Array(obj) {
                    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                }
                /*<replacement>*/ var debugUtil = __webpack_require__(77199);
                var debug;
                if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog('stream');
                else debug = function debug() {};
                /*</replacement>*/ var BufferList = __webpack_require__(24433);
                var destroyImpl = __webpack_require__(37385);
                var _require = __webpack_require__(68130), getHighWaterMark = _require.getHighWaterMark;
                var _require$codes = __webpack_require__(83797)/* .codes */ .F, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                // Lazy loaded to improve the startup performance.
                var StringDecoder;
                var createReadableStreamAsyncIterator;
                var from;
                __webpack_require__(89784)(Readable, Stream);
                var errorOrDestroy = destroyImpl.errorOrDestroy;
                var kProxyEvents = [
                    'error',
                    'close',
                    'destroy',
                    'pause',
                    'resume'
                ];
                function prependListener(emitter, event, fn) {
                    // Sadly this is not cacheable as some libraries bundle their own
                    // event emitter implementation with them.
                    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
                    // This is a hack to make sure that our error handler is attached before any
                    // userland ones.  NEVER DO THIS. This is here only because this code needs
                    // to continue to work with older versions of Node.js that do not include
                    // the prependListener() method. The goal is to eventually remove this hack.
                    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
                    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
                    else emitter._events[event] = [
                        fn,
                        emitter._events[event]
                    ];
                }
                function ReadableState(options, stream, isDuplex) {
                    Duplex = Duplex || __webpack_require__(14903);
                    options = options || {};
                    // Duplex streams are both readable and writable, but share
                    // the same options object.
                    // However, some cases require setting options to different
                    // values for the readable and the writable sides of the duplex stream.
                    // These options can be provided separately as readableXXX and writableXXX.
                    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;
                    // object stream flag. Used to make read(n) ignore n and to
                    // make all the buffer merging and length checks go away
                    this.objectMode = !!options.objectMode;
                    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
                    // the point at which it stops calling _read() to fill the buffer
                    // Note: 0 is a valid value, means "don't call _read preemptively ever"
                    this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
                    // A linked list is used to store data chunks instead of an array because the
                    // linked list can remove elements from the beginning faster than
                    // array.shift()
                    this.buffer = new BufferList();
                    this.length = 0;
                    this.pipes = null;
                    this.pipesCount = 0;
                    this.flowing = null;
                    this.ended = false;
                    this.endEmitted = false;
                    this.reading = false;
                    // a flag to be able to tell if the event 'readable'/'data' is emitted
                    // immediately, or on a later tick.  We set this to true at first, because
                    // any actions that shouldn't happen until "later" should generally also
                    // not happen before the first read call.
                    this.sync = true;
                    // whenever we return null, then we set a flag to say
                    // that we're awaiting a 'readable' event emission.
                    this.needReadable = false;
                    this.emittedReadable = false;
                    this.readableListening = false;
                    this.resumeScheduled = false;
                    this.paused = true;
                    // Should close be emitted on destroy. Defaults to true.
                    this.emitClose = options.emitClose !== false;
                    // Should .destroy() be called after 'end' (and potentially 'finish')
                    this.autoDestroy = !!options.autoDestroy;
                    // has it been destroyed
                    this.destroyed = false;
                    // Crypto is kind of old and crusty.  Historically, its default string
                    // encoding is 'binary' so we have to make this configurable.
                    // Everything else in the universe uses 'utf8', though.
                    this.defaultEncoding = options.defaultEncoding || 'utf8';
                    // the number of writers that are awaiting a drain event in .pipe()s
                    this.awaitDrain = 0;
                    // if true, a maybeReadMore has been scheduled
                    this.readingMore = false;
                    this.decoder = null;
                    this.encoding = null;
                    if (options.encoding) {
                        if (!StringDecoder) StringDecoder = __webpack_require__(43143)/* .StringDecoder */ .I;
                        this.decoder = new StringDecoder(options.encoding);
                        this.encoding = options.encoding;
                    }
                }
                function Readable(options) {
                    Duplex = Duplex || __webpack_require__(14903);
                    if (!(this instanceof Readable)) return new Readable(options);
                    // Checking for a Stream.Duplex instance is faster here instead of inside
                    // the ReadableState constructor, at least with V8 6.5
                    var isDuplex = this instanceof Duplex;
                    this._readableState = new ReadableState(options, this, isDuplex);
                    // legacy
                    this.readable = true;
                    if (options) {
                        if (typeof options.read === 'function') this._read = options.read;
                        if (typeof options.destroy === 'function') this._destroy = options.destroy;
                    }
                    Stream.call(this);
                }
                Object.defineProperty(Readable.prototype, 'destroyed', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        if (this._readableState === undefined) return false;
                        return this._readableState.destroyed;
                    },
                    set: function set(value) {
                        // we ignore the value if the stream
                        // has not been initialized yet
                        if (!this._readableState) return;
                        // backward compatibility, the user is explicitly
                        // managing destroyed
                        this._readableState.destroyed = value;
                    }
                });
                Readable.prototype.destroy = destroyImpl.destroy;
                Readable.prototype._undestroy = destroyImpl.undestroy;
                Readable.prototype._destroy = function(err, cb) {
                    cb(err);
                };
                // Manually shove something into the read() buffer.
                // This returns true if the highWaterMark has not been hit yet,
                // similar to how Writable.write() returns true if you should
                // write() some more.
                Readable.prototype.push = function(chunk, encoding) {
                    var state = this._readableState;
                    var skipChunkCheck;
                    if (!state.objectMode) {
                        if (typeof chunk === 'string') {
                            encoding = encoding || state.defaultEncoding;
                            if (encoding !== state.encoding) {
                                chunk = Buffer.from(chunk, encoding);
                                encoding = '';
                            }
                            skipChunkCheck = true;
                        }
                    } else skipChunkCheck = true;
                    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
                };
                // Unshift should *always* be something directly out of read()
                Readable.prototype.unshift = function(chunk) {
                    return readableAddChunk(this, chunk, null, true, false);
                };
                function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
                    debug('readableAddChunk', chunk);
                    var state = stream._readableState;
                    if (chunk === null) {
                        state.reading = false;
                        onEofChunk(stream, state);
                    } else {
                        var er;
                        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
                        if (er) errorOrDestroy(stream, er);
                        else if (state.objectMode || chunk && chunk.length > 0) {
                            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
                            if (addToFront) {
                                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                                else addChunk(stream, state, chunk, true);
                            } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
                            else if (state.destroyed) return false;
                            else {
                                state.reading = false;
                                if (state.decoder && !encoding) {
                                    chunk = state.decoder.write(chunk);
                                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                                    else maybeReadMore(stream, state);
                                } else addChunk(stream, state, chunk, false);
                            }
                        } else if (!addToFront) {
                            state.reading = false;
                            maybeReadMore(stream, state);
                        }
                    }
                    // We can push more data if we are below the highWaterMark.
                    // Also, if we have no data yet, we can stand some more bytes.
                    // This is to work around cases where hwm=0, such as the repl.
                    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
                }
                function addChunk(stream, state, chunk, addToFront) {
                    if (state.flowing && state.length === 0 && !state.sync) {
                        state.awaitDrain = 0;
                        stream.emit('data', chunk);
                    } else {
                        // update the buffer info.
                        state.length += state.objectMode ? 1 : chunk.length;
                        if (addToFront) state.buffer.unshift(chunk);
                        else state.buffer.push(chunk);
                        if (state.needReadable) emitReadable(stream);
                    }
                    maybeReadMore(stream, state);
                }
                function chunkInvalid(state, chunk) {
                    var er;
                    if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE('chunk', [
                        'string',
                        'Buffer',
                        'Uint8Array'
                    ], chunk);
                    return er;
                }
                Readable.prototype.isPaused = function() {
                    return this._readableState.flowing === false;
                };
                // backwards compatibility.
                Readable.prototype.setEncoding = function(enc) {
                    if (!StringDecoder) StringDecoder = __webpack_require__(43143)/* .StringDecoder */ .I;
                    var decoder = new StringDecoder(enc);
                    this._readableState.decoder = decoder;
                    // If setEncoding(null), decoder.encoding equals utf8
                    this._readableState.encoding = this._readableState.decoder.encoding;
                    // Iterate over current buffer to convert already stored Buffers:
                    var p = this._readableState.buffer.head;
                    var content = '';
                    while(p !== null){
                        content += decoder.write(p.data);
                        p = p.next;
                    }
                    this._readableState.buffer.clear();
                    if (content !== '') this._readableState.buffer.push(content);
                    this._readableState.length = content.length;
                    return this;
                };
                // Don't raise the hwm > 1GB
                var MAX_HWM = 0x40000000;
                function computeNewHighWaterMark(n) {
                    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
                    n = MAX_HWM;
                    else {
                        // Get the next highest power of 2 to prevent increasing hwm excessively in
                        // tiny amounts
                        n--;
                        n |= n >>> 1;
                        n |= n >>> 2;
                        n |= n >>> 4;
                        n |= n >>> 8;
                        n |= n >>> 16;
                        n++;
                    }
                    return n;
                }
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function howMuchToRead(n, state) {
                    if (n <= 0 || state.length === 0 && state.ended) return 0;
                    if (state.objectMode) return 1;
                    if (n !== n) {
                        // Only flow one buffer at a time
                        if (state.flowing && state.length) return state.buffer.head.data.length;
                        else return state.length;
                    }
                    // If we're asking for more than the current hwm, then raise the hwm.
                    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
                    if (n <= state.length) return n;
                    // Don't have enough
                    if (!state.ended) {
                        state.needReadable = true;
                        return 0;
                    }
                    return state.length;
                }
                // you can override either this method, or the async _read(n) below.
                Readable.prototype.read = function(n) {
                    debug('read', n);
                    n = parseInt(n, 10);
                    var state = this._readableState;
                    var nOrig = n;
                    if (n !== 0) state.emittedReadable = false;
                    // if we're doing read(0) to trigger a readable event, but we
                    // already have a bunch of data in the buffer, then just trigger
                    // the 'readable' event and move on.
                    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
                        debug('read: emitReadable', state.length, state.ended);
                        if (state.length === 0 && state.ended) endReadable(this);
                        else emitReadable(this);
                        return null;
                    }
                    n = howMuchToRead(n, state);
                    // if we've ended, and we're now clear, then finish it up.
                    if (n === 0 && state.ended) {
                        if (state.length === 0) endReadable(this);
                        return null;
                    }
                    // All the actual chunk generation logic needs to be
                    // *below* the call to _read.  The reason is that in certain
                    // synthetic stream cases, such as passthrough streams, _read
                    // may be a completely synchronous operation which may change
                    // the state of the read buffer, providing enough data when
                    // before there was *not* enough.
                    //
                    // So, the steps are:
                    // 1. Figure out what the state of things will be after we do
                    // a read from the buffer.
                    //
                    // 2. If that resulting state will trigger a _read, then call _read.
                    // Note that this may be asynchronous, or synchronous.  Yes, it is
                    // deeply ugly to write APIs this way, but that still doesn't mean
                    // that the Readable class should behave improperly, as streams are
                    // designed to be sync/async agnostic.
                    // Take note if the _read call is sync or async (ie, if the read call
                    // has returned yet), so that we know whether or not it's safe to emit
                    // 'readable' etc.
                    //
                    // 3. Actually pull the requested chunks out of the buffer and return.
                    // if we need a readable event, then we need to do some reading.
                    var doRead = state.needReadable;
                    debug('need readable', doRead);
                    // if we currently have less than the highWaterMark, then also read some
                    if (state.length === 0 || state.length - n < state.highWaterMark) {
                        doRead = true;
                        debug('length less than watermark', doRead);
                    }
                    // however, if we've ended, then there's no point, and if we're already
                    // reading, then it's unnecessary.
                    if (state.ended || state.reading) {
                        doRead = false;
                        debug('reading or ended', doRead);
                    } else if (doRead) {
                        debug('do read');
                        state.reading = true;
                        state.sync = true;
                        // if the length is currently zero, then we *need* a readable event.
                        if (state.length === 0) state.needReadable = true;
                        // call internal read method
                        this._read(state.highWaterMark);
                        state.sync = false;
                        // If _read pushed data synchronously, then `reading` will be false,
                        // and we need to re-evaluate how much data we can return to the user.
                        if (!state.reading) n = howMuchToRead(nOrig, state);
                    }
                    var ret;
                    if (n > 0) ret = fromList(n, state);
                    else ret = null;
                    if (ret === null) {
                        state.needReadable = state.length <= state.highWaterMark;
                        n = 0;
                    } else {
                        state.length -= n;
                        state.awaitDrain = 0;
                    }
                    if (state.length === 0) {
                        // If we have nothing in the buffer, then we want to know
                        // as soon as we *do* get something into the buffer.
                        if (!state.ended) state.needReadable = true;
                        // If we tried to read() past the EOF, then emit end on the next tick.
                        if (nOrig !== n && state.ended) endReadable(this);
                    }
                    if (ret !== null) this.emit('data', ret);
                    return ret;
                };
                function onEofChunk(stream, state) {
                    debug('onEofChunk');
                    if (state.ended) return;
                    if (state.decoder) {
                        var chunk = state.decoder.end();
                        if (chunk && chunk.length) {
                            state.buffer.push(chunk);
                            state.length += state.objectMode ? 1 : chunk.length;
                        }
                    }
                    state.ended = true;
                    if (state.sync) // if we are sync, wait until next tick to emit the data.
                    // Otherwise we risk emitting data in the flow()
                    // the readable code triggers during a read() call
                    emitReadable(stream);
                    else {
                        // emit 'readable' now to make sure it gets picked up.
                        state.needReadable = false;
                        if (!state.emittedReadable) {
                            state.emittedReadable = true;
                            emitReadable_(stream);
                        }
                    }
                }
                // Don't emit readable right away in sync mode, because this can trigger
                // another read() call => stack overflow.  This way, it might trigger
                // a nextTick recursion warning, but that's not so bad.
                function emitReadable(stream) {
                    var state = stream._readableState;
                    debug('emitReadable', state.needReadable, state.emittedReadable);
                    state.needReadable = false;
                    if (!state.emittedReadable) {
                        debug('emitReadable', state.flowing);
                        state.emittedReadable = true;
                        process.nextTick(emitReadable_, stream);
                    }
                }
                function emitReadable_(stream) {
                    var state = stream._readableState;
                    debug('emitReadable_', state.destroyed, state.length, state.ended);
                    if (!state.destroyed && (state.length || state.ended)) {
                        stream.emit('readable');
                        state.emittedReadable = false;
                    }
                    // The stream needs another readable event if
                    // 1. It is not flowing, as the flow mechanism will take
                    //    care of it.
                    // 2. It is not ended.
                    // 3. It is below the highWaterMark, so we can schedule
                    //    another readable later.
                    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
                    flow(stream);
                }
                // at this point, the user has presumably seen the 'readable' event,
                // and called read() to consume some data.  that may have triggered
                // in turn another _read(n) call, in which case reading = true if
                // it's in progress.
                // However, if we're not ended, or reading, and the length < hwm,
                // then go ahead and try to read some more preemptively.
                function maybeReadMore(stream, state) {
                    if (!state.readingMore) {
                        state.readingMore = true;
                        process.nextTick(maybeReadMore_, stream, state);
                    }
                }
                function maybeReadMore_(stream, state) {
                    // Attempt to read more data if we should.
                    //
                    // The conditions for reading more data are (one of):
                    // - Not enough data buffered (state.length < state.highWaterMark). The loop
                    //   is responsible for filling the buffer with enough data if such data
                    //   is available. If highWaterMark is 0 and we are not in the flowing mode
                    //   we should _not_ attempt to buffer any extra data. We'll get more data
                    //   when the stream consumer calls read() instead.
                    // - No data in the buffer, and the stream is in flowing mode. In this mode
                    //   the loop below is responsible for ensuring read() is called. Failing to
                    //   call read here would abort the flow and there's no other mechanism for
                    //   continuing the flow if the stream consumer has just subscribed to the
                    //   'data' event.
                    //
                    // In addition to the above conditions to keep reading data, the following
                    // conditions prevent the data from being read:
                    // - The stream has ended (state.ended).
                    // - There is already a pending 'read' operation (state.reading). This is a
                    //   case where the the stream has called the implementation defined _read()
                    //   method, but they are processing the call asynchronously and have _not_
                    //   called push() with new data. In this case we skip performing more
                    //   read()s. The execution ends in this method again after the _read() ends
                    //   up calling push() with more data.
                    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
                        var len = state.length;
                        debug('maybeReadMore read 0');
                        stream.read(0);
                        if (len === state.length) break;
                    }
                    state.readingMore = false;
                }
                // abstract method.  to be overridden in specific implementation classes.
                // call cb(er, data) where data is <= n in length.
                // for virtual (non-string, non-buffer) streams, "length" is somewhat
                // arbitrary, and perhaps not very meaningful.
                Readable.prototype._read = function(n) {
                    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
                };
                Readable.prototype.pipe = function(dest, pipeOpts) {
                    var src = this;
                    var state = this._readableState;
                    switch(state.pipesCount){
                        case 0:
                            state.pipes = dest;
                            break;
                        case 1:
                            state.pipes = [
                                state.pipes,
                                dest
                            ];
                            break;
                        default:
                            state.pipes.push(dest);
                            break;
                    }
                    state.pipesCount += 1;
                    debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
                    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
                    var endFn = doEnd ? onend : unpipe;
                    if (state.endEmitted) process.nextTick(endFn);
                    else src.once('end', endFn);
                    dest.on('unpipe', onunpipe);
                    function onunpipe(readable, unpipeInfo) {
                        debug('onunpipe');
                        if (readable === src) {
                            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                                unpipeInfo.hasUnpiped = true;
                                cleanup();
                            }
                        }
                    }
                    function onend() {
                        debug('onend');
                        dest.end();
                    }
                    // when the dest drains, it reduces the awaitDrain counter
                    // on the source.  This would be more elegant with a .once()
                    // handler in flow(), but adding and removing repeatedly is
                    // too slow.
                    var ondrain = pipeOnDrain(src);
                    dest.on('drain', ondrain);
                    var cleanedUp = false;
                    function cleanup() {
                        debug('cleanup');
                        // cleanup event handlers once the pipe is broken
                        dest.removeListener('close', onclose);
                        dest.removeListener('finish', onfinish);
                        dest.removeListener('drain', ondrain);
                        dest.removeListener('error', onerror);
                        dest.removeListener('unpipe', onunpipe);
                        src.removeListener('end', onend);
                        src.removeListener('end', unpipe);
                        src.removeListener('data', ondata);
                        cleanedUp = true;
                        // if the reader is waiting for a drain event from this
                        // specific writer, then it would cause it to never start
                        // flowing again.
                        // So, if this is awaiting a drain, then we just call it now.
                        // If we don't know, then assume that we are waiting for one.
                        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
                    }
                    src.on('data', ondata);
                    function ondata(chunk) {
                        debug('ondata');
                        var ret = dest.write(chunk);
                        debug('dest.write', ret);
                        if (ret === false) {
                            // If the user unpiped during `dest.write()`, it is possible
                            // to get stuck in a permanently paused state if that write
                            // also returned false.
                            // => Check whether `dest` is still a piping destination.
                            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                                debug('false write response, pause', state.awaitDrain);
                                state.awaitDrain++;
                            }
                            src.pause();
                        }
                    }
                    // if the dest has an error, then stop piping into it.
                    // however, don't suppress the throwing behavior for this.
                    function onerror(er) {
                        debug('onerror', er);
                        unpipe();
                        dest.removeListener('error', onerror);
                        if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
                    }
                    // Make sure our error handler is attached before userland ones.
                    prependListener(dest, 'error', onerror);
                    // Both close and finish should trigger unpipe, but only once.
                    function onclose() {
                        dest.removeListener('finish', onfinish);
                        unpipe();
                    }
                    dest.once('close', onclose);
                    function onfinish() {
                        debug('onfinish');
                        dest.removeListener('close', onclose);
                        unpipe();
                    }
                    dest.once('finish', onfinish);
                    function unpipe() {
                        debug('unpipe');
                        src.unpipe(dest);
                    }
                    // tell the dest that it's being piped to
                    dest.emit('pipe', src);
                    // start the flow if it hasn't been started already.
                    if (!state.flowing) {
                        debug('pipe resume');
                        src.resume();
                    }
                    return dest;
                };
                function pipeOnDrain(src) {
                    return function pipeOnDrainFunctionResult() {
                        var state = src._readableState;
                        debug('pipeOnDrain', state.awaitDrain);
                        if (state.awaitDrain) state.awaitDrain--;
                        if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
                            state.flowing = true;
                            flow(src);
                        }
                    };
                }
                Readable.prototype.unpipe = function(dest) {
                    var state = this._readableState;
                    var unpipeInfo = {
                        hasUnpiped: false
                    };
                    // if we're not piping anywhere, then do nothing.
                    if (state.pipesCount === 0) return this;
                    // just one destination.  most common case.
                    if (state.pipesCount === 1) {
                        // passed in one, but it's not the right one.
                        if (dest && dest !== state.pipes) return this;
                        if (!dest) dest = state.pipes;
                        // got a match.
                        state.pipes = null;
                        state.pipesCount = 0;
                        state.flowing = false;
                        if (dest) dest.emit('unpipe', this, unpipeInfo);
                        return this;
                    }
                    // slow case. multiple pipe destinations.
                    if (!dest) {
                        // remove all.
                        var dests = state.pipes;
                        var len = state.pipesCount;
                        state.pipes = null;
                        state.pipesCount = 0;
                        state.flowing = false;
                        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
                            hasUnpiped: false
                        });
                        return this;
                    }
                    // try to find the right one.
                    var index = indexOf(state.pipes, dest);
                    if (index === -1) return this;
                    state.pipes.splice(index, 1);
                    state.pipesCount -= 1;
                    if (state.pipesCount === 1) state.pipes = state.pipes[0];
                    dest.emit('unpipe', this, unpipeInfo);
                    return this;
                };
                // set up data events if they are asked for
                // Ensure readable listeners eventually get something
                Readable.prototype.on = function(ev, fn) {
                    var res = Stream.prototype.on.call(this, ev, fn);
                    var state = this._readableState;
                    if (ev === 'data') {
                        // update readableListening so that resume() may be a no-op
                        // a few lines down. This is needed to support once('readable').
                        state.readableListening = this.listenerCount('readable') > 0;
                        // Try start flowing on next tick if stream isn't explicitly paused
                        if (state.flowing !== false) this.resume();
                    } else if (ev === 'readable') {
                        if (!state.endEmitted && !state.readableListening) {
                            state.readableListening = state.needReadable = true;
                            state.flowing = false;
                            state.emittedReadable = false;
                            debug('on readable', state.length, state.reading);
                            if (state.length) emitReadable(this);
                            else if (!state.reading) process.nextTick(nReadingNextTick, this);
                        }
                    }
                    return res;
                };
                Readable.prototype.addListener = Readable.prototype.on;
                Readable.prototype.removeListener = function(ev, fn) {
                    var res = Stream.prototype.removeListener.call(this, ev, fn);
                    if (ev === 'readable') // We need to check if there is someone still listening to
                    // readable and reset the state. However this needs to happen
                    // after readable has been emitted but before I/O (nextTick) to
                    // support once('readable', fn) cycles. This means that calling
                    // resume within the same tick will have no
                    // effect.
                    process.nextTick(updateReadableListening, this);
                    return res;
                };
                Readable.prototype.removeAllListeners = function(ev) {
                    var res = Stream.prototype.removeAllListeners.apply(this, arguments);
                    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
                    // readable and reset the state. However this needs to happen
                    // after readable has been emitted but before I/O (nextTick) to
                    // support once('readable', fn) cycles. This means that calling
                    // resume within the same tick will have no
                    // effect.
                    process.nextTick(updateReadableListening, this);
                    return res;
                };
                function updateReadableListening(self1) {
                    var state = self1._readableState;
                    state.readableListening = self1.listenerCount('readable') > 0;
                    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
                    // the upcoming resume will not flow.
                    state.flowing = true;
                    else if (self1.listenerCount('data') > 0) self1.resume();
                }
                function nReadingNextTick(self1) {
                    debug('readable nexttick read 0');
                    self1.read(0);
                }
                // pause() and resume() are remnants of the legacy readable stream API
                // If the user uses them, then switch into old mode.
                Readable.prototype.resume = function() {
                    var state = this._readableState;
                    if (!state.flowing) {
                        debug('resume');
                        // we flow only if there is no one listening
                        // for readable, but we still have to call
                        // resume()
                        state.flowing = !state.readableListening;
                        resume(this, state);
                    }
                    state.paused = false;
                    return this;
                };
                function resume(stream, state) {
                    if (!state.resumeScheduled) {
                        state.resumeScheduled = true;
                        process.nextTick(resume_, stream, state);
                    }
                }
                function resume_(stream, state) {
                    debug('resume', state.reading);
                    if (!state.reading) stream.read(0);
                    state.resumeScheduled = false;
                    stream.emit('resume');
                    flow(stream);
                    if (state.flowing && !state.reading) stream.read(0);
                }
                Readable.prototype.pause = function() {
                    debug('call pause flowing=%j', this._readableState.flowing);
                    if (this._readableState.flowing !== false) {
                        debug('pause');
                        this._readableState.flowing = false;
                        this.emit('pause');
                    }
                    this._readableState.paused = true;
                    return this;
                };
                function flow(stream) {
                    var state = stream._readableState;
                    debug('flow', state.flowing);
                    while(state.flowing && stream.read() !== null);
                }
                // wrap an old-style stream as the async data source.
                // This is *not* part of the readable stream interface.
                // It is an ugly unfortunate mess of history.
                Readable.prototype.wrap = function(stream) {
                    var _this = this;
                    var state = this._readableState;
                    var paused = false;
                    stream.on('end', function() {
                        debug('wrapped end');
                        if (state.decoder && !state.ended) {
                            var chunk = state.decoder.end();
                            if (chunk && chunk.length) _this.push(chunk);
                        }
                        _this.push(null);
                    });
                    stream.on('data', function(chunk) {
                        debug('wrapped data');
                        if (state.decoder) chunk = state.decoder.write(chunk);
                        // don't skip over falsy values in objectMode
                        if (state.objectMode && (chunk === null || chunk === undefined)) return;
                        else if (!state.objectMode && (!chunk || !chunk.length)) return;
                        var ret = _this.push(chunk);
                        if (!ret) {
                            paused = true;
                            stream.pause();
                        }
                    });
                    // proxy all the other methods.
                    // important when wrapping filters and duplexes.
                    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
                        return function methodWrapReturnFunction() {
                            return stream[method].apply(stream, arguments);
                        };
                    }(i);
                    // proxy certain important events.
                    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
                    // when we try to consume some more bytes, simply unpause the
                    // underlying stream.
                    this._read = function(n) {
                        debug('wrapped _read', n);
                        if (paused) {
                            paused = false;
                            stream.resume();
                        }
                    };
                    return this;
                };
                if (typeof Symbol === 'function') Readable.prototype[Symbol.asyncIterator] = function() {
                    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = __webpack_require__(79676);
                    return createReadableStreamAsyncIterator(this);
                };
                Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._readableState.highWaterMark;
                    }
                });
                Object.defineProperty(Readable.prototype, 'readableBuffer', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._readableState && this._readableState.buffer;
                    }
                });
                Object.defineProperty(Readable.prototype, 'readableFlowing', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._readableState.flowing;
                    },
                    set: function set(state) {
                        if (this._readableState) this._readableState.flowing = state;
                    }
                });
                // exposed for testing purposes only.
                Readable._fromList = fromList;
                Object.defineProperty(Readable.prototype, 'readableLength', {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function get() {
                        return this._readableState.length;
                    }
                });
                // Pluck off n bytes from an array of buffers.
                // Length is the combined lengths of all the buffers in the list.
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function fromList(n, state) {
                    // nothing buffered
                    if (state.length === 0) return null;
                    var ret;
                    if (state.objectMode) ret = state.buffer.shift();
                    else if (!n || n >= state.length) {
                        // read it all, truncate the list
                        if (state.decoder) ret = state.buffer.join('');
                        else if (state.buffer.length === 1) ret = state.buffer.first();
                        else ret = state.buffer.concat(state.length);
                        state.buffer.clear();
                    } else // read part of list
                    ret = state.buffer.consume(n, state.decoder);
                    return ret;
                }
                function endReadable(stream) {
                    var state = stream._readableState;
                    debug('endReadable', state.endEmitted);
                    if (!state.endEmitted) {
                        state.ended = true;
                        process.nextTick(endReadableNT, state, stream);
                    }
                }
                function endReadableNT(state, stream) {
                    debug('endReadableNT', state.endEmitted, state.length);
                    // Check that we didn't get one last unshift.
                    if (!state.endEmitted && state.length === 0) {
                        state.endEmitted = true;
                        stream.readable = false;
                        stream.emit('end');
                        if (state.autoDestroy) {
                            // In case of duplex streams we need a way to detect
                            // if the writable side is ready for autoDestroy as well
                            var wState = stream._writableState;
                            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
                        }
                    }
                }
                if (typeof Symbol === 'function') Readable.from = function(iterable, opts) {
                    if (from === undefined) from = __webpack_require__(60378);
                    return from(Readable, iterable, opts);
                };
                function indexOf(xs, x) {
                    for(var i = 0, l = xs.length; i < l; i++){
                        if (xs[i] === x) return i;
                    }
                    return -1;
                }
            /***/ },
            /***/ 88997: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $find = __webpack_require__(91102).find;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.find` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
                exportTypedArrayMethod('find', function find(predicate /* , thisArg */ ) {
                    return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 89029: /***/ function(__unused_webpack_module, exports) {
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
                    var e, m;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var nBits = -7;
                    var i = isLE ? nBytes - 1 : 0;
                    var d = isLE ? -1 : 1;
                    var s = buffer[offset + i];
                    i += d;
                    e = s & (1 << -nBits) - 1;
                    s >>= -nBits;
                    nBits += eLen;
                    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
                    m = e & (1 << -nBits) - 1;
                    e >>= -nBits;
                    nBits += mLen;
                    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
                    if (e === 0) e = 1 - eBias;
                    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
                    else {
                        m = m + Math.pow(2, mLen);
                        e = e - eBias;
                    }
                    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
                };
                exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
                    var e, m, c;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
                    var i = isLE ? 0 : nBytes - 1;
                    var d = isLE ? 1 : -1;
                    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
                    value = Math.abs(value);
                    if (isNaN(value) || value === Infinity) {
                        m = isNaN(value) ? 1 : 0;
                        e = eMax;
                    } else {
                        e = Math.floor(Math.log(value) / Math.LN2);
                        if (value * (c = Math.pow(2, -e)) < 1) {
                            e--;
                            c *= 2;
                        }
                        if (e + eBias >= 1) value += rt / c;
                        else value += rt * Math.pow(2, 1 - eBias);
                        if (value * c >= 2) {
                            e++;
                            c /= 2;
                        }
                        if (e + eBias >= eMax) {
                            m = 0;
                            e = eMax;
                        } else if (e + eBias >= 1) {
                            m = (value * c - 1) * Math.pow(2, mLen);
                            e = e + eBias;
                        } else {
                            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                            e = 0;
                        }
                    }
                    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
                    e = e << mLen | m;
                    eLen += mLen;
                    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
                    buffer[offset + i - d] |= s * 128;
                };
            /***/ },
            /***/ 89295: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $defineProperty = __webpack_require__(56649);
                var $SyntaxError = __webpack_require__(57770);
                var $TypeError = __webpack_require__(96785);
                var gopd = __webpack_require__(68109);
                /** @type {import('.')} */ module1.exports = function defineDataProperty(obj, property, value) {
                    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $TypeError('`obj` must be an object or a function`');
                    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $TypeError('`property` must be a string or a symbol`');
                    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
                    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
                    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
                    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $TypeError('`loose`, if provided, must be a boolean');
                    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
                    var nonWritable = arguments.length > 4 ? arguments[4] : null;
                    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
                    var loose = arguments.length > 6 ? arguments[6] : false;
                    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!gopd && gopd(obj, property);
                    if ($defineProperty) $defineProperty(obj, property, {
                        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
                        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
                        value: value,
                        writable: nonWritable === null && desc ? desc.writable : !nonWritable
                    });
                    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
                    obj[property] = value; // eslint-disable-line no-param-reassign
                    else throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
                };
            /***/ },
            /***/ 89302: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var callBind = __webpack_require__(36688);
                var gOPD = __webpack_require__(68109);
                var hasProtoAccessor;
                try {
                    // eslint-disable-next-line no-extra-parens, no-proto
                    hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
                } catch (e) {
                    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
                }
                // eslint-disable-next-line no-extra-parens
                var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
                var $Object = Object;
                var $getPrototypeOf = $Object.getPrototypeOf;
                /** @type {import('./get')} */ module1.exports = desc && typeof desc.get === 'function' ? callBind([
                    desc.get
                ]) : typeof $getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
                    // eslint-disable-next-line eqeqeq
                    return $getPrototypeOf(value == null ? value : $Object(value));
                } : false;
            /***/ },
            /***/ 89564: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(38688);
                var Iterators = __webpack_require__(15366);
                var ITERATOR = wellKnownSymbol('iterator');
                var ArrayPrototype = Array.prototype;
                // check on default Array iterator
                module1.exports = function(it) {
                    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
                };
            /***/ },
            /***/ 89636: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var implementation = __webpack_require__(63249);
                module1.exports = function getPolyfill() {
                    return typeof Object.is === 'function' ? Object.is : implementation;
                };
            /***/ },
            /***/ 89638: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var xmldoc = __webpack_require__(74878);
                /** Strip unit postfix, parse number, but return undefined instead of NaN for bad input */ function stripUnits(textVal) {
                    var n = parseFloat(textVal);
                    if (typeof n !== 'number' || isNaN(n)) return undefined;
                    return n;
                }
                /** Make sure it's valid XML and the root tage is <svg/>, returns xmldoc DOM */ function parseSVG(svgString) {
                    var doc;
                    try {
                        doc = new xmldoc.XmlDocument(svgString);
                    } catch (err) {
                        throw new Error('SVGMeasure: ' + err);
                    }
                    if (doc.name !== "svg") throw new Error('SVGMeasure: expected <svg> document');
                    return doc;
                }
                function SVGMeasure() {}
                SVGMeasure.prototype.measureSVG = function(svgString) {
                    var doc = parseSVG(svgString);
                    var docWidth = stripUnits(doc.attr.width);
                    var docHeight = stripUnits(doc.attr.height);
                    if ((docWidth == undefined || docHeight == undefined) && typeof doc.attr.viewBox == 'string') {
                        var viewBoxParts = doc.attr.viewBox.split(/[,\s]+/);
                        if (viewBoxParts.length !== 4) throw new Error("Unexpected svg viewbox format, should have 4 entries but found: '" + doc.attr.viewBox + "'");
                        if (docWidth == undefined) docWidth = stripUnits(viewBoxParts[2]);
                        if (docHeight == undefined) docHeight = stripUnits(viewBoxParts[3]);
                    }
                    return {
                        width: docWidth,
                        height: docHeight
                    };
                };
                SVGMeasure.prototype.writeDimensions = function(svgString, dimensions) {
                    var doc = parseSVG(svgString);
                    doc.attr.width = "" + dimensions.width;
                    doc.attr.height = "" + dimensions.height;
                    return doc.toString();
                };
                module1.exports = SVGMeasure;
            /***/ },
            /***/ 89784: /***/ function(module1) {
                if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
                module1.exports = function inherits(ctor, superCtor) {
                    if (superCtor) {
                        ctor.super_ = superCtor;
                        ctor.prototype = Object.create(superCtor.prototype, {
                            constructor: {
                                value: ctor,
                                enumerable: false,
                                writable: true,
                                configurable: true
                            }
                        });
                    }
                };
                else // old school shim for old browsers
                module1.exports = function inherits(ctor, superCtor) {
                    if (superCtor) {
                        ctor.super_ = superCtor;
                        var TempCtor = function() {};
                        TempCtor.prototype = superCtor.prototype;
                        ctor.prototype = new TempCtor();
                        ctor.prototype.constructor = ctor;
                    }
                };
            /***/ },
            /***/ 89836: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ColumnCalculator = __webpack_require__(77530);
                var isFunction = __webpack_require__(91867).isFunction;
                var isNumber = __webpack_require__(91867).isNumber;
                var isPositiveInteger = __webpack_require__(91867).isPositiveInteger;
                function TableProcessor(tableNode) {
                    this.tableNode = tableNode;
                }
                TableProcessor.prototype.beginTable = function(writer) {
                    var tableNode;
                    var availableWidth;
                    var self1 = this;
                    tableNode = this.tableNode;
                    this.offsets = tableNode._offsets;
                    this.layout = tableNode._layout;
                    availableWidth = writer.context().availableWidth - this.offsets.total;
                    ColumnCalculator.buildColumnWidths(tableNode.table.widths, availableWidth, this.offsets.total, tableNode);
                    this.tableWidth = tableNode._offsets.total + getTableInnerContentWidth();
                    this.rowSpanData = prepareRowSpanData();
                    this.cleanUpRepeatables = false;
                    // headersRows and rowsWithoutPageBreak (headerRows + keepWithHeaderRows)
                    this.headerRows = 0;
                    this.rowsWithoutPageBreak = 0;
                    var headerRows = tableNode.table.headerRows;
                    if (isPositiveInteger(headerRows)) {
                        this.headerRows = headerRows;
                        if (this.headerRows > tableNode.table.body.length) throw new Error(`Too few rows in the table. Property headerRows requires at least ${this.headerRows}, contains only ${tableNode.table.body.length}`);
                        this.rowsWithoutPageBreak = this.headerRows;
                        const keepWithHeaderRows = tableNode.table.keepWithHeaderRows;
                        if (isPositiveInteger(keepWithHeaderRows)) this.rowsWithoutPageBreak += keepWithHeaderRows;
                    }
                    this.dontBreakRows = tableNode.table.dontBreakRows || false;
                    if (this.rowsWithoutPageBreak || this.dontBreakRows) {
                        writer.beginUnbreakableBlock();
                        // Draw the top border of the table
                        this.drawHorizontalLine(0, writer);
                        if (this.rowsWithoutPageBreak && this.dontBreakRows) // We just increase the value of transactionLevel
                        writer.beginUnbreakableBlock();
                    }
                    // update the border properties of all cells before drawing any lines
                    prepareCellBorders(this.tableNode.table.body);
                    function getTableInnerContentWidth() {
                        var width = 0;
                        tableNode.table.widths.forEach(function(w) {
                            width += w._calcWidth;
                        });
                        return width;
                    }
                    function prepareRowSpanData() {
                        var rsd = [];
                        var x = 0;
                        var lastWidth = 0;
                        rsd.push({
                            left: 0,
                            rowSpan: 0
                        });
                        for(var i = 0, l = self1.tableNode.table.body[0].length; i < l; i++){
                            var paddings = self1.layout.paddingLeft(i, self1.tableNode) + self1.layout.paddingRight(i, self1.tableNode);
                            var lBorder = self1.layout.vLineWidth(i, self1.tableNode);
                            lastWidth = paddings + lBorder + self1.tableNode.table.widths[i]._calcWidth;
                            rsd[rsd.length - 1].width = lastWidth;
                            x += lastWidth;
                            rsd.push({
                                left: x,
                                rowSpan: 0,
                                width: 0
                            });
                        }
                        return rsd;
                    }
                    // Iterate through all cells. If the current cell is the start of a
                    // rowSpan/colSpan, update the border property of the cells on its
                    // bottom/right accordingly. This is needed since each iteration of the
                    // line-drawing loops draws lines for a single cell, not for an entire
                    // rowSpan/colSpan.
                    function prepareCellBorders(body) {
                        for(var rowIndex = 0; rowIndex < body.length; rowIndex++){
                            var row = body[rowIndex];
                            for(var colIndex = 0; colIndex < row.length; colIndex++){
                                var cell = row[colIndex];
                                if (cell.border) {
                                    var rowSpan = cell.rowSpan || 1;
                                    var colSpan = cell.colSpan || 1;
                                    for(var rowOffset = 0; rowOffset < rowSpan; rowOffset++){
                                        // set left border
                                        if (cell.border[0] !== undefined && rowOffset > 0) setBorder(rowIndex + rowOffset, colIndex, 0, cell.border[0]);
                                        // set right border
                                        if (cell.border[2] !== undefined) setBorder(rowIndex + rowOffset, colIndex + colSpan - 1, 2, cell.border[2]);
                                    }
                                    for(var colOffset = 0; colOffset < colSpan; colOffset++){
                                        // set top border
                                        if (cell.border[1] !== undefined && colOffset > 0) setBorder(rowIndex, colIndex + colOffset, 1, cell.border[1]);
                                        // set bottom border
                                        if (cell.border[3] !== undefined) setBorder(rowIndex + rowSpan - 1, colIndex + colOffset, 3, cell.border[3]);
                                    }
                                }
                            }
                        }
                        // helper function to set the border for a given cell
                        function setBorder(rowIndex, colIndex, borderIndex, borderValue) {
                            var cell = body[rowIndex][colIndex];
                            cell.border = cell.border || {};
                            cell.border[borderIndex] = borderValue;
                        }
                    }
                };
                TableProcessor.prototype.onRowBreak = function(rowIndex, writer) {
                    var self1 = this;
                    return function() {
                        var offset = self1.rowPaddingTop + (!self1.headerRows ? self1.topLineWidth : 0);
                        writer.context().availableHeight -= self1.reservedAtBottom;
                        writer.context().moveDown(offset);
                    };
                };
                TableProcessor.prototype.beginRow = function(rowIndex, writer) {
                    this.topLineWidth = this.layout.hLineWidth(rowIndex, this.tableNode);
                    this.rowPaddingTop = this.layout.paddingTop(rowIndex, this.tableNode);
                    this.bottomLineWidth = this.layout.hLineWidth(rowIndex + 1, this.tableNode);
                    this.rowPaddingBottom = this.layout.paddingBottom(rowIndex, this.tableNode);
                    this.rowCallback = this.onRowBreak(rowIndex, writer);
                    writer.tracker.startTracking('pageChanged', this.rowCallback);
                    if (rowIndex == 0 && !this.dontBreakRows && !this.rowsWithoutPageBreak) {
                        // We store the 'y' to draw later and if necessary the top border of the table
                        this._tableTopBorderY = writer.context().y;
                        writer.context().moveDown(this.topLineWidth);
                    }
                    if (this.dontBreakRows && rowIndex > 0) writer.beginUnbreakableBlock();
                    this.rowTopY = writer.context().y;
                    this.reservedAtBottom = this.bottomLineWidth + this.rowPaddingBottom;
                    writer.context().availableHeight -= this.reservedAtBottom;
                    writer.context().moveDown(this.rowPaddingTop);
                };
                TableProcessor.prototype.drawHorizontalLine = function(lineIndex, writer, overrideY, moveDown = true, forcePage) {
                    var lineWidth = this.layout.hLineWidth(lineIndex, this.tableNode);
                    if (lineWidth) {
                        var style = this.layout.hLineStyle(lineIndex, this.tableNode);
                        var dash;
                        if (style && style.dash) dash = style.dash;
                        var offset = lineWidth / 2;
                        var currentLine = null;
                        var body = this.tableNode.table.body;
                        var cellAbove;
                        var currentCell;
                        var rowCellAbove;
                        for(var i = 0, l = this.rowSpanData.length; i < l; i++){
                            var data = this.rowSpanData[i];
                            var shouldDrawLine = !data.rowSpan;
                            var borderColor = null;
                            // draw only if the current cell requires a top border or the cell in the
                            // row above requires a bottom border
                            if (shouldDrawLine && i < l - 1) {
                                var topBorder = false, bottomBorder = false, rowBottomBorder = false;
                                // the cell in the row above
                                if (lineIndex > 0) {
                                    cellAbove = body[lineIndex - 1][i];
                                    bottomBorder = cellAbove.border ? cellAbove.border[3] : this.layout.defaultBorder;
                                    if (bottomBorder && cellAbove.borderColor) borderColor = cellAbove.borderColor[3];
                                }
                                // the current cell
                                if (lineIndex < body.length) {
                                    currentCell = body[lineIndex][i];
                                    topBorder = currentCell.border ? currentCell.border[1] : this.layout.defaultBorder;
                                    if (topBorder && borderColor == null && currentCell.borderColor) borderColor = currentCell.borderColor[1];
                                }
                                shouldDrawLine = topBorder || bottomBorder;
                            }
                            if (cellAbove && cellAbove._rowSpanCurrentOffset) {
                                rowCellAbove = body[lineIndex - 1 - cellAbove._rowSpanCurrentOffset][i];
                                rowBottomBorder = rowCellAbove && rowCellAbove.border ? rowCellAbove.border[3] : this.layout.defaultBorder;
                                if (rowBottomBorder && rowCellAbove && rowCellAbove.borderColor) borderColor = rowCellAbove.borderColor[3];
                            }
                            if (borderColor == null) borderColor = isFunction(this.layout.hLineColor) ? this.layout.hLineColor(lineIndex, this.tableNode, i) : this.layout.hLineColor;
                            if (!currentLine && shouldDrawLine) currentLine = {
                                left: data.left,
                                width: 0
                            };
                            if (shouldDrawLine) {
                                var colSpanIndex = 0;
                                if (rowCellAbove && rowCellAbove.colSpan && rowBottomBorder) {
                                    while(rowCellAbove.colSpan > colSpanIndex)currentLine.width += this.rowSpanData[i + colSpanIndex++].width || 0;
                                    i += colSpanIndex - 1;
                                } else if (cellAbove && cellAbove.colSpan && bottomBorder) {
                                    while(cellAbove.colSpan > colSpanIndex)currentLine.width += this.rowSpanData[i + colSpanIndex++].width || 0;
                                    i += colSpanIndex - 1;
                                } else if (currentCell && currentCell.colSpan && topBorder) {
                                    while(currentCell.colSpan > colSpanIndex)currentLine.width += this.rowSpanData[i + colSpanIndex++].width || 0;
                                    i += colSpanIndex - 1;
                                } else currentLine.width += this.rowSpanData[i].width || 0;
                            }
                            var y = (overrideY || 0) + offset;
                            if (shouldDrawLine) {
                                if (currentLine && currentLine.width) {
                                    writer.addVector({
                                        type: 'line',
                                        x1: currentLine.left,
                                        x2: currentLine.left + currentLine.width,
                                        y1: y,
                                        y2: y,
                                        lineWidth: lineWidth,
                                        dash: dash,
                                        lineColor: borderColor
                                    }, false, isNumber(overrideY), null, forcePage);
                                    currentLine = null;
                                    borderColor = null;
                                    cellAbove = null;
                                    currentCell = null;
                                    rowCellAbove = null;
                                }
                            }
                        }
                        if (moveDown) writer.context().moveDown(lineWidth);
                    }
                };
                TableProcessor.prototype.drawVerticalLine = function(x, y0, y1, vLineColIndex, writer, vLineRowIndex, beforeVLineColIndex) {
                    var width = this.layout.vLineWidth(vLineColIndex, this.tableNode);
                    if (width === 0) return;
                    var style = this.layout.vLineStyle(vLineColIndex, this.tableNode);
                    var dash;
                    if (style && style.dash) dash = style.dash;
                    var body = this.tableNode.table.body;
                    var cellBefore;
                    var currentCell;
                    var borderColor;
                    // the cell in the col before
                    if (vLineColIndex > 0) {
                        cellBefore = body[vLineRowIndex][beforeVLineColIndex];
                        if (cellBefore && cellBefore.borderColor) {
                            if (cellBefore.border ? cellBefore.border[2] : this.layout.defaultBorder) borderColor = cellBefore.borderColor[2];
                        }
                    }
                    // the current cell
                    if (borderColor == null && vLineColIndex < body.length) {
                        currentCell = body[vLineRowIndex][vLineColIndex];
                        if (currentCell && currentCell.borderColor) {
                            if (currentCell.border ? currentCell.border[0] : this.layout.defaultBorder) borderColor = currentCell.borderColor[0];
                        }
                    }
                    if (borderColor == null && cellBefore && cellBefore._rowSpanCurrentOffset) {
                        var rowCellBeforeAbove = body[vLineRowIndex - cellBefore._rowSpanCurrentOffset][beforeVLineColIndex];
                        if (rowCellBeforeAbove.borderColor) {
                            if (rowCellBeforeAbove.border ? rowCellBeforeAbove.border[2] : this.layout.defaultBorder) borderColor = rowCellBeforeAbove.borderColor[2];
                        }
                    }
                    if (borderColor == null && currentCell && currentCell._rowSpanCurrentOffset) {
                        var rowCurrentCellAbove = body[vLineRowIndex - currentCell._rowSpanCurrentOffset][vLineColIndex];
                        if (rowCurrentCellAbove.borderColor) {
                            if (rowCurrentCellAbove.border ? rowCurrentCellAbove.border[2] : this.layout.defaultBorder) borderColor = rowCurrentCellAbove.borderColor[2];
                        }
                    }
                    if (borderColor == null) borderColor = isFunction(this.layout.vLineColor) ? this.layout.vLineColor(vLineColIndex, this.tableNode, vLineRowIndex) : this.layout.vLineColor;
                    writer.addVector({
                        type: 'line',
                        x1: x + width / 2,
                        x2: x + width / 2,
                        y1: y0,
                        y2: y1,
                        lineWidth: width,
                        dash: dash,
                        lineColor: borderColor
                    }, false, true);
                    cellBefore = null;
                    currentCell = null;
                    borderColor = null;
                };
                TableProcessor.prototype.endTable = function(writer) {
                    if (this.cleanUpRepeatables) writer.popFromRepeatables();
                };
                TableProcessor.prototype.endRow = function(rowIndex, writer, pageBreaks) {
                    var l, i;
                    var self1 = this;
                    writer.tracker.stopTracking('pageChanged', this.rowCallback);
                    writer.context().moveDown(this.layout.paddingBottom(rowIndex, this.tableNode));
                    writer.context().availableHeight += this.reservedAtBottom;
                    var endingPage = writer.context().page;
                    var endingY = writer.context().y;
                    var xs = getLineXs();
                    var ys = [];
                    var hasBreaks = pageBreaks && pageBreaks.length > 0;
                    var body = this.tableNode.table.body;
                    ys.push({
                        y0: this.rowTopY,
                        page: hasBreaks ? pageBreaks[0].prevPage : endingPage
                    });
                    if (hasBreaks) for(i = 0, l = pageBreaks.length; i < l; i++){
                        var pageBreak = pageBreaks[i];
                        ys[ys.length - 1].y1 = pageBreak.prevY;
                        ys.push({
                            y0: pageBreak.y,
                            page: pageBreak.prevPage + 1
                        });
                    }
                    ys[ys.length - 1].y1 = endingY;
                    var skipOrphanePadding = ys[0].y1 - ys[0].y0 === this.rowPaddingTop;
                    if (rowIndex === 0 && !skipOrphanePadding && !this.rowsWithoutPageBreak && !this.dontBreakRows) {
                        // Draw the top border of the table
                        var pageTableStartedAt = null;
                        if (pageBreaks && pageBreaks.length > 0) // Get the page where table started at
                        pageTableStartedAt = pageBreaks[0].prevPage;
                        this.drawHorizontalLine(0, writer, this._tableTopBorderY, false, pageTableStartedAt);
                    }
                    for(var yi = skipOrphanePadding ? 1 : 0, yl = ys.length; yi < yl; yi++){
                        var willBreak = yi < ys.length - 1;
                        var rowBreakWithoutHeader = yi > 0 && !this.headerRows;
                        var hzLineOffset = rowBreakWithoutHeader ? 0 : this.topLineWidth;
                        var y1 = ys[yi].y0;
                        var y2 = ys[yi].y1;
                        if (willBreak) y2 = y2 + this.rowPaddingBottom;
                        if (writer.context().page != ys[yi].page) {
                            writer.context().page = ys[yi].page;
                            //TODO: buggy, availableHeight should be updated on every pageChanged event
                            // TableProcessor should be pageChanged listener, instead of processRow
                            this.reservedAtBottom = 0;
                        }
                        // Draw horizontal lines before the vertical lines so they are not overridden
                        if (willBreak && this.layout.hLineWhenBroken !== false) this.drawHorizontalLine(rowIndex + 1, writer, y2);
                        if (rowBreakWithoutHeader && this.layout.hLineWhenBroken !== false) this.drawHorizontalLine(rowIndex, writer, y1);
                        for(i = 0, l = xs.length; i < l; i++){
                            var leftCellBorder = false;
                            var rightCellBorder = false;
                            var colIndex = xs[i].index;
                            // current cell
                            if (colIndex < body[rowIndex].length) {
                                var cell = body[rowIndex][colIndex];
                                leftCellBorder = cell.border ? cell.border[0] : this.layout.defaultBorder;
                                rightCellBorder = cell.border ? cell.border[2] : this.layout.defaultBorder;
                            }
                            // before cell
                            if (colIndex > 0 && !leftCellBorder) {
                                var cell = body[rowIndex][colIndex - 1];
                                leftCellBorder = cell.border ? cell.border[2] : this.layout.defaultBorder;
                            }
                            // after cell
                            if (colIndex + 1 < body[rowIndex].length && !rightCellBorder) {
                                var cell = body[rowIndex][colIndex + 1];
                                rightCellBorder = cell.border ? cell.border[0] : this.layout.defaultBorder;
                            }
                            if (leftCellBorder) this.drawVerticalLine(xs[i].x, y1 - hzLineOffset, y2 + this.bottomLineWidth, xs[i].index, writer, rowIndex, xs[i - 1] ? xs[i - 1].index : null);
                            if (i < l - 1) {
                                var fillColor = body[rowIndex][colIndex].fillColor;
                                var fillOpacity = body[rowIndex][colIndex].fillOpacity;
                                if (!fillColor) fillColor = isFunction(this.layout.fillColor) ? this.layout.fillColor(rowIndex, this.tableNode, colIndex) : this.layout.fillColor;
                                if (!isNumber(fillOpacity)) fillOpacity = isFunction(this.layout.fillOpacity) ? this.layout.fillOpacity(rowIndex, this.tableNode, colIndex) : this.layout.fillOpacity;
                                var overlayPattern = body[rowIndex][colIndex].overlayPattern;
                                var overlayOpacity = body[rowIndex][colIndex].overlayOpacity;
                                if (fillColor || overlayPattern) {
                                    var widthLeftBorder = leftCellBorder ? this.layout.vLineWidth(colIndex, this.tableNode) : 0;
                                    var widthRightBorder;
                                    if ((colIndex === 0 || colIndex + 1 == body[rowIndex].length) && !rightCellBorder) widthRightBorder = this.layout.vLineWidth(colIndex + 1, this.tableNode);
                                    else if (rightCellBorder) widthRightBorder = this.layout.vLineWidth(colIndex + 1, this.tableNode) / 2;
                                    else widthRightBorder = 0;
                                    var x1f = this.dontBreakRows ? xs[i].x + widthLeftBorder : xs[i].x + widthLeftBorder / 2;
                                    var y1f = this.dontBreakRows ? y1 : y1 - hzLineOffset / 2;
                                    var x2f = xs[i + 1].x + widthRightBorder;
                                    var y2f = this.dontBreakRows ? y2 + this.bottomLineWidth : y2 + this.bottomLineWidth / 2;
                                    var bgWidth = x2f - x1f;
                                    var bgHeight = y2f - y1f;
                                    if (fillColor) writer.addVector({
                                        type: 'rect',
                                        x: x1f,
                                        y: y1f,
                                        w: bgWidth,
                                        h: bgHeight,
                                        lineWidth: 0,
                                        color: fillColor,
                                        fillOpacity: fillOpacity,
                                        // mark if we are in an unbreakable block
                                        _isFillColorFromUnbreakable: !!writer.transactionLevel
                                    }, false, true, writer.context().backgroundLength[writer.context().page]);
                                    if (overlayPattern) writer.addVector({
                                        type: 'rect',
                                        x: x1f,
                                        y: y1f,
                                        w: bgWidth,
                                        h: bgHeight,
                                        lineWidth: 0,
                                        color: overlayPattern,
                                        fillOpacity: overlayOpacity
                                    }, false, true);
                                }
                            }
                        }
                    }
                    writer.context().page = endingPage;
                    writer.context().y = endingY;
                    var row = this.tableNode.table.body[rowIndex];
                    for(i = 0, l = row.length; i < l; i++){
                        if (row[i].rowSpan) {
                            this.rowSpanData[i].rowSpan = row[i].rowSpan;
                            // fix colSpans
                            if (row[i].colSpan && row[i].colSpan > 1) for(var j = 1; j < row[i].rowSpan; j++)this.tableNode.table.body[rowIndex + j][i]._colSpan = row[i].colSpan;
                            // fix rowSpans
                            if (row[i].rowSpan && row[i].rowSpan > 1) for(var j = 1; j < row[i].rowSpan; j++)this.tableNode.table.body[rowIndex + j][i]._rowSpanCurrentOffset = j;
                        }
                        if (this.rowSpanData[i].rowSpan > 0) this.rowSpanData[i].rowSpan--;
                    }
                    this.drawHorizontalLine(rowIndex + 1, writer);
                    if (this.headerRows && rowIndex === this.headerRows - 1) this.headerRepeatable = writer.currentBlockToRepeatable();
                    if (this.dontBreakRows) writer.tracker.auto('pageChanged', function() {
                        if (rowIndex > 0 && !self1.headerRows && self1.layout.hLineWhenBroken !== false) // Draw the top border of the row after a page break
                        self1.drawHorizontalLine(rowIndex, writer);
                    }, function() {
                        writer.commitUnbreakableBlock();
                    });
                    if (this.headerRepeatable && (rowIndex === this.rowsWithoutPageBreak - 1 || rowIndex === this.tableNode.table.body.length - 1)) {
                        writer.commitUnbreakableBlock();
                        writer.pushToRepeatables(this.headerRepeatable);
                        this.cleanUpRepeatables = true;
                        this.headerRepeatable = null;
                    }
                    function getLineXs() {
                        var result = [];
                        var cols = 0;
                        for(var i = 0, l = self1.tableNode.table.body[rowIndex].length; i < l; i++){
                            if (!cols) {
                                result.push({
                                    x: self1.rowSpanData[i].left,
                                    index: i
                                });
                                var item = self1.tableNode.table.body[rowIndex][i];
                                cols = item._colSpan || item.colSpan || 0;
                            }
                            if (cols > 0) cols--;
                        }
                        result.push({
                            x: self1.rowSpanData[self1.rowSpanData.length - 1].left,
                            index: self1.rowSpanData.length - 1
                        });
                        return result;
                    }
                };
                module1.exports = TableProcessor;
            /***/ },
            /***/ 90481: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // Description of supported double byte encodings and aliases.
                // Tables are not require()-d until they are needed to speed up library load.
                // require()-s are direct to support Browserify.
                module1.exports = {
                    // == Japanese/ShiftJIS ====================================================
                    // All japanese encodings are based on JIS X set of standards:
                    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
                    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
                    //              Has several variations in 1978, 1983, 1990 and 1997.
                    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
                    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
                    //              2 planes, first is superset of 0208, second - revised 0212.
                    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
                    // Byte encodings are:
                    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
                    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
                    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
                    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
                    //               0x00-0x7F       - lower part of 0201
                    //               0x8E, 0xA1-0xDF - upper part of 0201
                    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
                    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
                    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
                    //               Used as-is in ISO2022 family.
                    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
                    //                0201-1976 Roman, 0208-1978, 0208-1983.
                    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
                    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
                    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
                    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
                    //
                    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
                    //
                    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
                    'shiftjis': {
                        type: '_dbcs',
                        table: function() {
                            return __webpack_require__(40679);
                        },
                        encodeAdd: {
                            '\u00a5': 0x5C,
                            '\u203E': 0x7E
                        },
                        encodeSkipVals: [
                            {
                                from: 0xED40,
                                to: 0xF940
                            }
                        ]
                    },
                    'csshiftjis': 'shiftjis',
                    'mskanji': 'shiftjis',
                    'sjis': 'shiftjis',
                    'windows31j': 'shiftjis',
                    'ms31j': 'shiftjis',
                    'xsjis': 'shiftjis',
                    'windows932': 'shiftjis',
                    'ms932': 'shiftjis',
                    '932': 'shiftjis',
                    'cp932': 'shiftjis',
                    'eucjp': {
                        type: '_dbcs',
                        table: function() {
                            return __webpack_require__(56406);
                        },
                        encodeAdd: {
                            '\u00a5': 0x5C,
                            '\u203E': 0x7E
                        }
                    },
                    // TODO: KDDI extension to Shift_JIS
                    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
                    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
                    // == Chinese/GBK ==========================================================
                    // http://en.wikipedia.org/wiki/GBK
                    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
                    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
                    'gb2312': 'cp936',
                    'gb231280': 'cp936',
                    'gb23121980': 'cp936',
                    'csgb2312': 'cp936',
                    'csiso58gb231280': 'cp936',
                    'euccn': 'cp936',
                    // Microsoft's CP936 is a subset and approximation of GBK.
                    'windows936': 'cp936',
                    'ms936': 'cp936',
                    '936': 'cp936',
                    'cp936': {
                        type: '_dbcs',
                        table: function() {
                            return __webpack_require__(74488);
                        }
                    },
                    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
                    'gbk': {
                        type: '_dbcs',
                        table: function() {
                            return __webpack_require__(74488).concat(__webpack_require__(55914));
                        }
                    },
                    'xgbk': 'gbk',
                    'isoir58': 'gbk',
                    // GB18030 is an algorithmic extension of GBK.
                    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
                    // http://icu-project.org/docs/papers/gb18030.html
                    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
                    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
                    'gb18030': {
                        type: '_dbcs',
                        table: function() {
                            return __webpack_require__(74488).concat(__webpack_require__(55914));
                        },
                        gb18030: function() {
                            return __webpack_require__(99129);
                        },
                        encodeSkipVals: [
                            0x80
                        ],
                        encodeAdd: {
                            "\u20AC": 0xA2E3
                        }
                    },
                    'chinese': 'gb18030',
                    // == Korean ===============================================================
                    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
                    'windows949': 'cp949',
                    'ms949': 'cp949',
                    '949': 'cp949',
                    'cp949': {
                        type: '_dbcs',
                        table: function() {
                            return __webpack_require__(21166);
                        }
                    },
                    'cseuckr': 'cp949',
                    'csksc56011987': 'cp949',
                    'euckr': 'cp949',
                    'isoir149': 'cp949',
                    'korean': 'cp949',
                    'ksc56011987': 'cp949',
                    'ksc56011989': 'cp949',
                    'ksc5601': 'cp949',
                    // == Big5/Taiwan/Hong Kong ================================================
                    // There are lots of tables for Big5 and cp950. Please see the following links for history:
                    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
                    // Variations, in roughly number of defined chars:
                    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
                    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
                    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
                    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
                    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
                    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
                    //    Plus, it has 4 combining sequences.
                    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
                    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
                    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
                    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
                    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
                    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
                    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
                    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
                    // 
                    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
                    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
                    'windows950': 'cp950',
                    'ms950': 'cp950',
                    '950': 'cp950',
                    'cp950': {
                        type: '_dbcs',
                        table: function() {
                            return __webpack_require__(72324);
                        }
                    },
                    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
                    'big5': 'big5hkscs',
                    'big5hkscs': {
                        type: '_dbcs',
                        table: function() {
                            return __webpack_require__(72324).concat(__webpack_require__(43267));
                        },
                        encodeSkipVals: [
                            // Although Encoding Standard says we should avoid encoding to HKSCS area (See Step 1 of
                            // https://encoding.spec.whatwg.org/#index-big5-pointer), we still do it to increase compatibility with ICU.
                            // But if a single unicode point can be encoded both as HKSCS and regular Big5, we prefer the latter.
                            0x8e69,
                            0x8e6f,
                            0x8e7e,
                            0x8eab,
                            0x8eb4,
                            0x8ecd,
                            0x8ed0,
                            0x8f57,
                            0x8f69,
                            0x8f6e,
                            0x8fcb,
                            0x8ffe,
                            0x906d,
                            0x907a,
                            0x90c4,
                            0x90dc,
                            0x90f1,
                            0x91bf,
                            0x92af,
                            0x92b0,
                            0x92b1,
                            0x92b2,
                            0x92d1,
                            0x9447,
                            0x94ca,
                            0x95d9,
                            0x96fc,
                            0x9975,
                            0x9b76,
                            0x9b78,
                            0x9b7b,
                            0x9bc6,
                            0x9bde,
                            0x9bec,
                            0x9bf6,
                            0x9c42,
                            0x9c53,
                            0x9c62,
                            0x9c68,
                            0x9c6b,
                            0x9c77,
                            0x9cbc,
                            0x9cbd,
                            0x9cd0,
                            0x9d57,
                            0x9d5a,
                            0x9dc4,
                            0x9def,
                            0x9dfb,
                            0x9ea9,
                            0x9eef,
                            0x9efd,
                            0x9f60,
                            0x9fcb,
                            0xa077,
                            0xa0dc,
                            0xa0df,
                            0x8fcc,
                            0x92c8,
                            0x9644,
                            0x96ed,
                            // Step 2 of https://encoding.spec.whatwg.org/#index-big5-pointer: Use last pointer for U+2550, U+255E, U+2561, U+256A, U+5341, or U+5345
                            0xa2a4,
                            0xa2a5,
                            0xa2a7,
                            0xa2a6,
                            0xa2cc,
                            0xa2ce
                        ]
                    },
                    'cnbig5': 'big5hkscs',
                    'csbig5': 'big5hkscs',
                    'xxbig5': 'big5hkscs'
                };
            /***/ },
            /***/ 90682: /***/ function(module1) {
                module1.exports = {};
            /***/ },
            /***/ 90760: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __dirname = "/";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                __webpack_require__(69330);
                __webpack_require__(5597);
                __webpack_require__(11765);
                __webpack_require__(7585);
                __webpack_require__(7283);
                __webpack_require__(58281);
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                __webpack_require__(65292);
                __webpack_require__(73844);
                __webpack_require__(39081);
                __webpack_require__(41584);
                __webpack_require__(49063);
                __webpack_require__(58028);
                __webpack_require__(81755);
                __webpack_require__(94845);
                __webpack_require__(80055);
                __webpack_require__(20731);
                __webpack_require__(45337);
                __webpack_require__(8953);
                __webpack_require__(24863);
                __webpack_require__(70095);
                __webpack_require__(10849);
                __webpack_require__(18756);
                __webpack_require__(37309);
                __webpack_require__(14032);
                __webpack_require__(59883);
                __webpack_require__(68067);
                __webpack_require__(61726);
                __webpack_require__(57114);
                __webpack_require__(26663);
                __webpack_require__(65578);
                __webpack_require__(6422);
                __webpack_require__(46467);
                __webpack_require__(7851);
                __webpack_require__(72095);
                __webpack_require__(62046);
                __webpack_require__(47259);
                __webpack_require__(18425);
                __webpack_require__(56912);
                __webpack_require__(73663);
                __webpack_require__(29883);
                __webpack_require__(35471);
                __webpack_require__(21012);
                __webpack_require__(88997);
                __webpack_require__(97464);
                __webpack_require__(2857);
                __webpack_require__(94715);
                __webpack_require__(13624);
                __webpack_require__(91132);
                __webpack_require__(62514);
                __webpack_require__(24597);
                __webpack_require__(88042);
                __webpack_require__(4660);
                __webpack_require__(92451);
                __webpack_require__(44206);
                __webpack_require__(66288);
                __webpack_require__(13250);
                __webpack_require__(3858);
                __webpack_require__(84538);
                __webpack_require__(64793);
                __webpack_require__(74202);
                __webpack_require__(52529);
                __webpack_require__(64654);
                __webpack_require__(42437);
                __webpack_require__(94712);
                var _stream = _interopRequireDefault(__webpack_require__(9760));
                var _zlib = _interopRequireDefault(__webpack_require__(6729));
                var _cryptoJs = _interopRequireDefault(__webpack_require__(94119));
                var _fontkit = _interopRequireDefault(__webpack_require__(10740));
                var _events = __webpack_require__(64785);
                var _linebreak = _interopRequireDefault(__webpack_require__(5417));
                var _jpegExif = _interopRequireDefault(__webpack_require__(38834));
                var _pngJs = _interopRequireDefault(__webpack_require__(84695));
                function _interopRequireDefault(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function _readOnlyError(r) {
                    throw new TypeError('"' + r + '" is read-only');
                }
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == typeof i ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != typeof t || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != typeof i) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                function _inheritsLoose(t, o) {
                    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
                }
                function _setPrototypeOf(t, e) {
                    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                        return t.__proto__ = e, t;
                    }, _setPrototypeOf(t, e);
                }
                function _createForOfIteratorHelperLoose(r, e) {
                    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                    if (t) return (t = t.call(r)).next.bind(t);
                    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
                        t && (r = t);
                        var o = 0;
                        return function() {
                            return o >= r.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: r[o++]
                            };
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(r, a) {
                    if (r) {
                        if ("string" == typeof r) return _arrayLikeToArray(r, a);
                        var t = ({}).toString.call(r).slice(8, -1);
                        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
                    }
                }
                function _arrayLikeToArray(r, a) {
                    (null == a || a > r.length) && (a = r.length);
                    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
                    return n;
                }
                var fs = __webpack_require__(48181);
                /*
PDFAbstractReference - abstract class for PDF reference
*/ var PDFAbstractReference = /*#__PURE__*/ function() {
                    function PDFAbstractReference() {}
                    var _proto = PDFAbstractReference.prototype;
                    _proto.toString = function toString() {
                        throw new Error('Must be implemented by subclasses');
                    };
                    return PDFAbstractReference;
                }();
                /*
PDFTree - abstract base class for name and number tree objects
*/ var PDFTree = /*#__PURE__*/ function() {
                    function PDFTree() {
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        this._items = {};
                        // disable /Limits output for this tree
                        this.limits = typeof options.limits === 'boolean' ? options.limits : true;
                    }
                    var _proto2 = PDFTree.prototype;
                    _proto2.add = function add(key, val) {
                        return this._items[key] = val;
                    };
                    _proto2.get = function get(key) {
                        return this._items[key];
                    };
                    _proto2.toString = function toString() {
                        var _this = this;
                        // Needs to be sorted by key
                        var sortedKeys = Object.keys(this._items).sort(function(a, b) {
                            return _this._compareKeys(a, b);
                        });
                        var out = [
                            '<<'
                        ];
                        if (this.limits && sortedKeys.length > 1) {
                            var _first = sortedKeys[0], _last = sortedKeys[sortedKeys.length - 1];
                            out.push("  /Limits " + PDFObject.convert([
                                this._dataForKey(_first),
                                this._dataForKey(_last)
                            ]));
                        }
                        out.push("  /" + this._keysName() + " [");
                        for(var _iterator = _createForOfIteratorHelperLoose(sortedKeys), _step; !(_step = _iterator()).done;){
                            var key = _step.value;
                            out.push("    " + PDFObject.convert(this._dataForKey(key)) + " " + PDFObject.convert(this._items[key]));
                        }
                        out.push(']');
                        out.push('>>');
                        return out.join('\n');
                    };
                    _proto2._compareKeys = function _compareKeys() {
                        throw new Error('Must be implemented by subclasses');
                    };
                    _proto2._keysName = function _keysName() {
                        throw new Error('Must be implemented by subclasses');
                    };
                    _proto2._dataForKey = function _dataForKey() {
                        throw new Error('Must be implemented by subclasses');
                    };
                    return PDFTree;
                }();
                var SpotColor = /*#__PURE__*/ function() {
                    function SpotColor(doc, name, C, M, Y, K) {
                        this.id = 'CS' + Object.keys(doc.spotColors).length;
                        this.name = name;
                        this.values = [
                            C,
                            M,
                            Y,
                            K
                        ];
                        this.ref = doc.ref([
                            'Separation',
                            this.name,
                            'DeviceCMYK',
                            {
                                Range: [
                                    0,
                                    1,
                                    0,
                                    1,
                                    0,
                                    1,
                                    0,
                                    1
                                ],
                                C0: [
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                C1: this.values.map(function(value) {
                                    return value / 100;
                                }),
                                FunctionType: 2,
                                Domain: [
                                    0,
                                    1
                                ],
                                N: 1
                            }
                        ]);
                        this.ref.end();
                    }
                    var _proto3 = SpotColor.prototype;
                    _proto3.toString = function toString() {
                        return this.ref.id + " 0 R";
                    };
                    return SpotColor;
                }();
                /*
PDFObject - converts JavaScript types into their corresponding PDF types.
By Devon Govett
*/ var pad = function pad(str, length) {
                    return (Array(length + 1).join('0') + str).slice(-length);
                };
                var escapableRe = /[\n\r\t\b\f()\\]/g;
                var escapable = {
                    '\n': '\\n',
                    '\r': '\\r',
                    '\t': '\\t',
                    '\b': '\\b',
                    '\f': '\\f',
                    '\\': '\\\\',
                    '(': '\\(',
                    ')': '\\)'
                };
                // Convert little endian UTF-16 to big endian
                var swapBytes = function swapBytes(buff) {
                    var l = buff.length;
                    if (l & 0x01) throw new Error('Buffer length must be even');
                    else for(var i = 0, end = l - 1; i < end; i += 2){
                        var a = buff[i];
                        buff[i] = buff[i + 1];
                        buff[i + 1] = a;
                    }
                    return buff;
                };
                var PDFObject = /*#__PURE__*/ function() {
                    function PDFObject() {}
                    PDFObject.convert = function convert(object) {
                        var encryptFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                        // String literals are converted to the PDF name type
                        if (typeof object === 'string') return "/" + object;
                        else if (object instanceof String) {
                            var string = object;
                            // Detect if this is a unicode string
                            var isUnicode = false;
                            for(var i = 0, end = string.length; i < end; i++)if (string.charCodeAt(i) > 0x7f) {
                                isUnicode = true;
                                break;
                            }
                            // If so, encode it as big endian UTF-16
                            var stringBuffer;
                            if (isUnicode) stringBuffer = swapBytes(Buffer.from("\uFEFF" + string, 'utf16le'));
                            else stringBuffer = Buffer.from(string.valueOf(), 'ascii');
                            // Encrypt the string when necessary
                            if (encryptFn) string = encryptFn(stringBuffer).toString('binary');
                            else string = stringBuffer.toString('binary');
                            // Escape characters as required by the spec
                            string = string.replace(escapableRe, function(c) {
                                return escapable[c];
                            });
                            return "(" + string + ")";
                        // Buffers are converted to PDF hex strings
                        } else if (Buffer.isBuffer(object)) return "<" + object.toString('hex') + ">";
                        else if (object instanceof PDFAbstractReference || object instanceof PDFTree || object instanceof SpotColor) return object.toString();
                        else if (object instanceof Date) {
                            var _string = "D:" + pad(object.getUTCFullYear(), 4) + pad(object.getUTCMonth() + 1, 2) + pad(object.getUTCDate(), 2) + pad(object.getUTCHours(), 2) + pad(object.getUTCMinutes(), 2) + pad(object.getUTCSeconds(), 2) + 'Z';
                            // Encrypt the string when necessary
                            if (encryptFn) {
                                _string = encryptFn(Buffer.from(_string, 'ascii')).toString('binary');
                                // Escape characters as required by the spec
                                _string = _string.replace(escapableRe, function(c) {
                                    return escapable[c];
                                });
                            }
                            return "(" + _string + ")";
                        } else if (Array.isArray(object)) {
                            var items = object.map(function(e) {
                                return PDFObject.convert(e, encryptFn);
                            }).join(' ');
                            return "[" + items + "]";
                        } else if (({}).toString.call(object) === '[object Object]') {
                            var out = [
                                '<<'
                            ];
                            for(var key in object){
                                var val = object[key];
                                out.push("/" + key + " " + PDFObject.convert(val, encryptFn));
                            }
                            out.push('>>');
                            return out.join('\n');
                        } else if (typeof object === 'number') return PDFObject.number(object);
                        else return "" + object;
                    };
                    PDFObject.number = function number(n) {
                        if (n > -1000000000000000000000 && n < 1e21) return Math.round(n * 1e6) / 1e6;
                        throw new Error("unsupported number: " + n);
                    };
                    return PDFObject;
                }();
                /*
PDFReference - represents a reference to another object in the PDF object heirarchy
By Devon Govett
*/ var PDFReference = /*#__PURE__*/ function(_PDFAbstractReference) {
                    function PDFReference(document1, id) {
                        var _this2;
                        var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        _this2 = _PDFAbstractReference.call(this) || this;
                        _this2.document = document1;
                        _this2.id = id;
                        _this2.data = data;
                        _this2.gen = 0;
                        _this2.compress = _this2.document.compress && !_this2.data.Filter;
                        _this2.uncompressedLength = 0;
                        _this2.buffer = [];
                        return _this2;
                    }
                    _inheritsLoose(PDFReference, _PDFAbstractReference);
                    var _proto4 = PDFReference.prototype;
                    _proto4.write = function write(chunk) {
                        if (!Buffer.isBuffer(chunk)) chunk = Buffer.from(chunk + '\n', 'binary');
                        this.uncompressedLength += chunk.length;
                        if (this.data.Length == null) this.data.Length = 0;
                        this.buffer.push(chunk);
                        this.data.Length += chunk.length;
                        if (this.compress) return this.data.Filter = 'FlateDecode';
                    };
                    _proto4.end = function end(chunk) {
                        if (chunk) this.write(chunk);
                        return this.finalize();
                    };
                    _proto4.finalize = function finalize() {
                        this.offset = this.document._offset;
                        var encryptFn = this.document._security ? this.document._security.getEncryptFn(this.id, this.gen) : null;
                        if (this.buffer.length) {
                            this.buffer = Buffer.concat(this.buffer);
                            if (this.compress) this.buffer = _zlib.default.deflateSync(this.buffer);
                            if (encryptFn) this.buffer = encryptFn(this.buffer);
                            this.data.Length = this.buffer.length;
                        }
                        this.document._write(this.id + " " + this.gen + " obj");
                        this.document._write(PDFObject.convert(this.data, encryptFn));
                        if (this.buffer.length) {
                            this.document._write('stream');
                            this.document._write(this.buffer);
                            this.buffer = []; // free up memory
                            this.document._write('\nendstream');
                        }
                        this.document._write('endobj');
                        this.document._refEnd(this);
                    };
                    _proto4.toString = function toString() {
                        return this.id + " " + this.gen + " R";
                    };
                    return PDFReference;
                }(PDFAbstractReference);
                /*
PDFPage - represents a single page in the PDF document
By Devon Govett
*/ var DEFAULT_MARGINS = {
                    top: 72,
                    left: 72,
                    bottom: 72,
                    right: 72
                };
                var SIZES = {
                    '4A0': [
                        4767.87,
                        6740.79
                    ],
                    '2A0': [
                        3370.39,
                        4767.87
                    ],
                    A0: [
                        2383.94,
                        3370.39
                    ],
                    A1: [
                        1683.78,
                        2383.94
                    ],
                    A2: [
                        1190.55,
                        1683.78
                    ],
                    A3: [
                        841.89,
                        1190.55
                    ],
                    A4: [
                        595.28,
                        841.89
                    ],
                    A5: [
                        419.53,
                        595.28
                    ],
                    A6: [
                        297.64,
                        419.53
                    ],
                    A7: [
                        209.76,
                        297.64
                    ],
                    A8: [
                        147.4,
                        209.76
                    ],
                    A9: [
                        104.88,
                        147.4
                    ],
                    A10: [
                        73.7,
                        104.88
                    ],
                    B0: [
                        2834.65,
                        4008.19
                    ],
                    B1: [
                        2004.09,
                        2834.65
                    ],
                    B2: [
                        1417.32,
                        2004.09
                    ],
                    B3: [
                        1000.63,
                        1417.32
                    ],
                    B4: [
                        708.66,
                        1000.63
                    ],
                    B5: [
                        498.9,
                        708.66
                    ],
                    B6: [
                        354.33,
                        498.9
                    ],
                    B7: [
                        249.45,
                        354.33
                    ],
                    B8: [
                        175.75,
                        249.45
                    ],
                    B9: [
                        124.72,
                        175.75
                    ],
                    B10: [
                        87.87,
                        124.72
                    ],
                    C0: [
                        2599.37,
                        3676.54
                    ],
                    C1: [
                        1836.85,
                        2599.37
                    ],
                    C2: [
                        1298.27,
                        1836.85
                    ],
                    C3: [
                        918.43,
                        1298.27
                    ],
                    C4: [
                        649.13,
                        918.43
                    ],
                    C5: [
                        459.21,
                        649.13
                    ],
                    C6: [
                        323.15,
                        459.21
                    ],
                    C7: [
                        229.61,
                        323.15
                    ],
                    C8: [
                        161.57,
                        229.61
                    ],
                    C9: [
                        113.39,
                        161.57
                    ],
                    C10: [
                        79.37,
                        113.39
                    ],
                    RA0: [
                        2437.8,
                        3458.27
                    ],
                    RA1: [
                        1729.13,
                        2437.8
                    ],
                    RA2: [
                        1218.9,
                        1729.13
                    ],
                    RA3: [
                        864.57,
                        1218.9
                    ],
                    RA4: [
                        609.45,
                        864.57
                    ],
                    SRA0: [
                        2551.18,
                        3628.35
                    ],
                    SRA1: [
                        1814.17,
                        2551.18
                    ],
                    SRA2: [
                        1275.59,
                        1814.17
                    ],
                    SRA3: [
                        907.09,
                        1275.59
                    ],
                    SRA4: [
                        637.8,
                        907.09
                    ],
                    EXECUTIVE: [
                        521.86,
                        756.0
                    ],
                    FOLIO: [
                        612.0,
                        936.0
                    ],
                    LEGAL: [
                        612.0,
                        1008.0
                    ],
                    LETTER: [
                        612.0,
                        792.0
                    ],
                    TABLOID: [
                        792.0,
                        1224.0
                    ]
                };
                var PDFPage = /*#__PURE__*/ function() {
                    function PDFPage(document1) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        this.document = document1;
                        this.size = options.size || 'letter';
                        this.layout = options.layout || 'portrait';
                        // process margins
                        if (typeof options.margin === 'number') this.margins = {
                            top: options.margin,
                            left: options.margin,
                            bottom: options.margin,
                            right: options.margin
                        };
                        else this.margins = options.margins || DEFAULT_MARGINS;
                        // calculate page dimensions
                        var dimensions = Array.isArray(this.size) ? this.size : SIZES[this.size.toUpperCase()];
                        this.width = dimensions[this.layout === 'portrait' ? 0 : 1];
                        this.height = dimensions[this.layout === 'portrait' ? 1 : 0];
                        this.content = this.document.ref();
                        // Initialize the Font, XObject, and ExtGState dictionaries
                        this.resources = this.document.ref({
                            ProcSet: [
                                'PDF',
                                'Text',
                                'ImageB',
                                'ImageC',
                                'ImageI'
                            ]
                        });
                        // The page dictionary
                        this.dictionary = this.document.ref({
                            Type: 'Page',
                            Parent: this.document._root.data.Pages,
                            MediaBox: [
                                0,
                                0,
                                this.width,
                                this.height
                            ],
                            Contents: this.content,
                            Resources: this.resources
                        });
                        this.markings = [];
                    }
                    // Lazily create these objects
                    var _proto5 = PDFPage.prototype;
                    _proto5.maxY = function maxY() {
                        return this.height - this.margins.bottom;
                    };
                    _proto5.write = function write(chunk) {
                        return this.content.write(chunk);
                    };
                    _proto5._setTabOrder = function _setTabOrder() {
                        if (!this.dictionary.Tabs && this.document.hasMarkInfoDictionary()) this.dictionary.data.Tabs = 'S';
                    };
                    _proto5.end = function end() {
                        this._setTabOrder();
                        this.dictionary.end();
                        this.resources.data.ColorSpace = this.resources.data.ColorSpace || {};
                        for(var _i = 0, _Object$values = Object.values(this.document.spotColors); _i < _Object$values.length; _i++){
                            var color = _Object$values[_i];
                            this.resources.data.ColorSpace[color.id] = color;
                        }
                        this.resources.end();
                        return this.content.end();
                    };
                    return _createClass(PDFPage, [
                        {
                            key: "fonts",
                            get: function get() {
                                var data = this.resources.data;
                                return data.Font != null ? data.Font : data.Font = {};
                            }
                        },
                        {
                            key: "xobjects",
                            get: function get() {
                                var data = this.resources.data;
                                return data.XObject != null ? data.XObject : data.XObject = {};
                            }
                        },
                        {
                            key: "ext_gstates",
                            get: function get() {
                                var data = this.resources.data;
                                return data.ExtGState != null ? data.ExtGState : data.ExtGState = {};
                            }
                        },
                        {
                            key: "patterns",
                            get: function get() {
                                var data = this.resources.data;
                                return data.Pattern != null ? data.Pattern : data.Pattern = {};
                            }
                        },
                        {
                            key: "colorSpaces",
                            get: function get() {
                                var data = this.resources.data;
                                return data.ColorSpace || (data.ColorSpace = {});
                            }
                        },
                        {
                            key: "annotations",
                            get: function get() {
                                var data = this.dictionary.data;
                                return data.Annots != null ? data.Annots : data.Annots = [];
                            }
                        },
                        {
                            key: "structParentTreeKey",
                            get: function get() {
                                var data = this.dictionary.data;
                                return data.StructParents != null ? data.StructParents : data.StructParents = this.document.createStructParentTreeNextKey();
                            }
                        }
                    ]);
                }();
                /*
PDFNameTree - represents a name tree object
*/ var PDFNameTree = /*#__PURE__*/ function(_PDFTree) {
                    function PDFNameTree() {
                        return _PDFTree.apply(this, arguments) || this;
                    }
                    _inheritsLoose(PDFNameTree, _PDFTree);
                    var _proto6 = PDFNameTree.prototype;
                    _proto6._compareKeys = function _compareKeys(a, b) {
                        return a.localeCompare(b);
                    };
                    _proto6._keysName = function _keysName() {
                        return "Names";
                    };
                    _proto6._dataForKey = function _dataForKey(k) {
                        return new String(k);
                    };
                    return PDFNameTree;
                }(PDFTree);
                /**
 * Check if value is in a range group.
 * @param {number} value
 * @param {number[]} rangeGroup
 * @returns {boolean}
 */ function inRange(value, rangeGroup) {
                    if (value < rangeGroup[0]) return false;
                    var startRange = 0;
                    var endRange = rangeGroup.length / 2;
                    while(startRange <= endRange){
                        var middleRange = Math.floor((startRange + endRange) / 2);
                        // actual array index
                        var arrayIndex = middleRange * 2;
                        // Check if value is in range pointed by actual index
                        if (value >= rangeGroup[arrayIndex] && value <= rangeGroup[arrayIndex + 1]) return true;
                        if (value > rangeGroup[arrayIndex + 1]) // Search Right Side Of Array
                        startRange = middleRange + 1;
                        else // Search Left Side Of Array
                        endRange = middleRange - 1;
                    }
                    return false;
                }
                // prettier-ignore-start
                /**
 * A.1 Unassigned code points in Unicode 3.2
 * @link https://tools.ietf.org/html/rfc3454#appendix-A.1
 */ var unassigned_code_points = [
                    0x0221,
                    0x0221,
                    0x0234,
                    0x024f,
                    0x02ae,
                    0x02af,
                    0x02ef,
                    0x02ff,
                    0x0350,
                    0x035f,
                    0x0370,
                    0x0373,
                    0x0376,
                    0x0379,
                    0x037b,
                    0x037d,
                    0x037f,
                    0x0383,
                    0x038b,
                    0x038b,
                    0x038d,
                    0x038d,
                    0x03a2,
                    0x03a2,
                    0x03cf,
                    0x03cf,
                    0x03f7,
                    0x03ff,
                    0x0487,
                    0x0487,
                    0x04cf,
                    0x04cf,
                    0x04f6,
                    0x04f7,
                    0x04fa,
                    0x04ff,
                    0x0510,
                    0x0530,
                    0x0557,
                    0x0558,
                    0x0560,
                    0x0560,
                    0x0588,
                    0x0588,
                    0x058b,
                    0x0590,
                    0x05a2,
                    0x05a2,
                    0x05ba,
                    0x05ba,
                    0x05c5,
                    0x05cf,
                    0x05eb,
                    0x05ef,
                    0x05f5,
                    0x060b,
                    0x060d,
                    0x061a,
                    0x061c,
                    0x061e,
                    0x0620,
                    0x0620,
                    0x063b,
                    0x063f,
                    0x0656,
                    0x065f,
                    0x06ee,
                    0x06ef,
                    0x06ff,
                    0x06ff,
                    0x070e,
                    0x070e,
                    0x072d,
                    0x072f,
                    0x074b,
                    0x077f,
                    0x07b2,
                    0x0900,
                    0x0904,
                    0x0904,
                    0x093a,
                    0x093b,
                    0x094e,
                    0x094f,
                    0x0955,
                    0x0957,
                    0x0971,
                    0x0980,
                    0x0984,
                    0x0984,
                    0x098d,
                    0x098e,
                    0x0991,
                    0x0992,
                    0x09a9,
                    0x09a9,
                    0x09b1,
                    0x09b1,
                    0x09b3,
                    0x09b5,
                    0x09ba,
                    0x09bb,
                    0x09bd,
                    0x09bd,
                    0x09c5,
                    0x09c6,
                    0x09c9,
                    0x09ca,
                    0x09ce,
                    0x09d6,
                    0x09d8,
                    0x09db,
                    0x09de,
                    0x09de,
                    0x09e4,
                    0x09e5,
                    0x09fb,
                    0x0a01,
                    0x0a03,
                    0x0a04,
                    0x0a0b,
                    0x0a0e,
                    0x0a11,
                    0x0a12,
                    0x0a29,
                    0x0a29,
                    0x0a31,
                    0x0a31,
                    0x0a34,
                    0x0a34,
                    0x0a37,
                    0x0a37,
                    0x0a3a,
                    0x0a3b,
                    0x0a3d,
                    0x0a3d,
                    0x0a43,
                    0x0a46,
                    0x0a49,
                    0x0a4a,
                    0x0a4e,
                    0x0a58,
                    0x0a5d,
                    0x0a5d,
                    0x0a5f,
                    0x0a65,
                    0x0a75,
                    0x0a80,
                    0x0a84,
                    0x0a84,
                    0x0a8c,
                    0x0a8c,
                    0x0a8e,
                    0x0a8e,
                    0x0a92,
                    0x0a92,
                    0x0aa9,
                    0x0aa9,
                    0x0ab1,
                    0x0ab1,
                    0x0ab4,
                    0x0ab4,
                    0x0aba,
                    0x0abb,
                    0x0ac6,
                    0x0ac6,
                    0x0aca,
                    0x0aca,
                    0x0ace,
                    0x0acf,
                    0x0ad1,
                    0x0adf,
                    0x0ae1,
                    0x0ae5,
                    0x0af0,
                    0x0b00,
                    0x0b04,
                    0x0b04,
                    0x0b0d,
                    0x0b0e,
                    0x0b11,
                    0x0b12,
                    0x0b29,
                    0x0b29,
                    0x0b31,
                    0x0b31,
                    0x0b34,
                    0x0b35,
                    0x0b3a,
                    0x0b3b,
                    0x0b44,
                    0x0b46,
                    0x0b49,
                    0x0b4a,
                    0x0b4e,
                    0x0b55,
                    0x0b58,
                    0x0b5b,
                    0x0b5e,
                    0x0b5e,
                    0x0b62,
                    0x0b65,
                    0x0b71,
                    0x0b81,
                    0x0b84,
                    0x0b84,
                    0x0b8b,
                    0x0b8d,
                    0x0b91,
                    0x0b91,
                    0x0b96,
                    0x0b98,
                    0x0b9b,
                    0x0b9b,
                    0x0b9d,
                    0x0b9d,
                    0x0ba0,
                    0x0ba2,
                    0x0ba5,
                    0x0ba7,
                    0x0bab,
                    0x0bad,
                    0x0bb6,
                    0x0bb6,
                    0x0bba,
                    0x0bbd,
                    0x0bc3,
                    0x0bc5,
                    0x0bc9,
                    0x0bc9,
                    0x0bce,
                    0x0bd6,
                    0x0bd8,
                    0x0be6,
                    0x0bf3,
                    0x0c00,
                    0x0c04,
                    0x0c04,
                    0x0c0d,
                    0x0c0d,
                    0x0c11,
                    0x0c11,
                    0x0c29,
                    0x0c29,
                    0x0c34,
                    0x0c34,
                    0x0c3a,
                    0x0c3d,
                    0x0c45,
                    0x0c45,
                    0x0c49,
                    0x0c49,
                    0x0c4e,
                    0x0c54,
                    0x0c57,
                    0x0c5f,
                    0x0c62,
                    0x0c65,
                    0x0c70,
                    0x0c81,
                    0x0c84,
                    0x0c84,
                    0x0c8d,
                    0x0c8d,
                    0x0c91,
                    0x0c91,
                    0x0ca9,
                    0x0ca9,
                    0x0cb4,
                    0x0cb4,
                    0x0cba,
                    0x0cbd,
                    0x0cc5,
                    0x0cc5,
                    0x0cc9,
                    0x0cc9,
                    0x0cce,
                    0x0cd4,
                    0x0cd7,
                    0x0cdd,
                    0x0cdf,
                    0x0cdf,
                    0x0ce2,
                    0x0ce5,
                    0x0cf0,
                    0x0d01,
                    0x0d04,
                    0x0d04,
                    0x0d0d,
                    0x0d0d,
                    0x0d11,
                    0x0d11,
                    0x0d29,
                    0x0d29,
                    0x0d3a,
                    0x0d3d,
                    0x0d44,
                    0x0d45,
                    0x0d49,
                    0x0d49,
                    0x0d4e,
                    0x0d56,
                    0x0d58,
                    0x0d5f,
                    0x0d62,
                    0x0d65,
                    0x0d70,
                    0x0d81,
                    0x0d84,
                    0x0d84,
                    0x0d97,
                    0x0d99,
                    0x0db2,
                    0x0db2,
                    0x0dbc,
                    0x0dbc,
                    0x0dbe,
                    0x0dbf,
                    0x0dc7,
                    0x0dc9,
                    0x0dcb,
                    0x0dce,
                    0x0dd5,
                    0x0dd5,
                    0x0dd7,
                    0x0dd7,
                    0x0de0,
                    0x0df1,
                    0x0df5,
                    0x0e00,
                    0x0e3b,
                    0x0e3e,
                    0x0e5c,
                    0x0e80,
                    0x0e83,
                    0x0e83,
                    0x0e85,
                    0x0e86,
                    0x0e89,
                    0x0e89,
                    0x0e8b,
                    0x0e8c,
                    0x0e8e,
                    0x0e93,
                    0x0e98,
                    0x0e98,
                    0x0ea0,
                    0x0ea0,
                    0x0ea4,
                    0x0ea4,
                    0x0ea6,
                    0x0ea6,
                    0x0ea8,
                    0x0ea9,
                    0x0eac,
                    0x0eac,
                    0x0eba,
                    0x0eba,
                    0x0ebe,
                    0x0ebf,
                    0x0ec5,
                    0x0ec5,
                    0x0ec7,
                    0x0ec7,
                    0x0ece,
                    0x0ecf,
                    0x0eda,
                    0x0edb,
                    0x0ede,
                    0x0eff,
                    0x0f48,
                    0x0f48,
                    0x0f6b,
                    0x0f70,
                    0x0f8c,
                    0x0f8f,
                    0x0f98,
                    0x0f98,
                    0x0fbd,
                    0x0fbd,
                    0x0fcd,
                    0x0fce,
                    0x0fd0,
                    0x0fff,
                    0x1022,
                    0x1022,
                    0x1028,
                    0x1028,
                    0x102b,
                    0x102b,
                    0x1033,
                    0x1035,
                    0x103a,
                    0x103f,
                    0x105a,
                    0x109f,
                    0x10c6,
                    0x10cf,
                    0x10f9,
                    0x10fa,
                    0x10fc,
                    0x10ff,
                    0x115a,
                    0x115e,
                    0x11a3,
                    0x11a7,
                    0x11fa,
                    0x11ff,
                    0x1207,
                    0x1207,
                    0x1247,
                    0x1247,
                    0x1249,
                    0x1249,
                    0x124e,
                    0x124f,
                    0x1257,
                    0x1257,
                    0x1259,
                    0x1259,
                    0x125e,
                    0x125f,
                    0x1287,
                    0x1287,
                    0x1289,
                    0x1289,
                    0x128e,
                    0x128f,
                    0x12af,
                    0x12af,
                    0x12b1,
                    0x12b1,
                    0x12b6,
                    0x12b7,
                    0x12bf,
                    0x12bf,
                    0x12c1,
                    0x12c1,
                    0x12c6,
                    0x12c7,
                    0x12cf,
                    0x12cf,
                    0x12d7,
                    0x12d7,
                    0x12ef,
                    0x12ef,
                    0x130f,
                    0x130f,
                    0x1311,
                    0x1311,
                    0x1316,
                    0x1317,
                    0x131f,
                    0x131f,
                    0x1347,
                    0x1347,
                    0x135b,
                    0x1360,
                    0x137d,
                    0x139f,
                    0x13f5,
                    0x1400,
                    0x1677,
                    0x167f,
                    0x169d,
                    0x169f,
                    0x16f1,
                    0x16ff,
                    0x170d,
                    0x170d,
                    0x1715,
                    0x171f,
                    0x1737,
                    0x173f,
                    0x1754,
                    0x175f,
                    0x176d,
                    0x176d,
                    0x1771,
                    0x1771,
                    0x1774,
                    0x177f,
                    0x17dd,
                    0x17df,
                    0x17ea,
                    0x17ff,
                    0x180f,
                    0x180f,
                    0x181a,
                    0x181f,
                    0x1878,
                    0x187f,
                    0x18aa,
                    0x1dff,
                    0x1e9c,
                    0x1e9f,
                    0x1efa,
                    0x1eff,
                    0x1f16,
                    0x1f17,
                    0x1f1e,
                    0x1f1f,
                    0x1f46,
                    0x1f47,
                    0x1f4e,
                    0x1f4f,
                    0x1f58,
                    0x1f58,
                    0x1f5a,
                    0x1f5a,
                    0x1f5c,
                    0x1f5c,
                    0x1f5e,
                    0x1f5e,
                    0x1f7e,
                    0x1f7f,
                    0x1fb5,
                    0x1fb5,
                    0x1fc5,
                    0x1fc5,
                    0x1fd4,
                    0x1fd5,
                    0x1fdc,
                    0x1fdc,
                    0x1ff0,
                    0x1ff1,
                    0x1ff5,
                    0x1ff5,
                    0x1fff,
                    0x1fff,
                    0x2053,
                    0x2056,
                    0x2058,
                    0x205e,
                    0x2064,
                    0x2069,
                    0x2072,
                    0x2073,
                    0x208f,
                    0x209f,
                    0x20b2,
                    0x20cf,
                    0x20eb,
                    0x20ff,
                    0x213b,
                    0x213c,
                    0x214c,
                    0x2152,
                    0x2184,
                    0x218f,
                    0x23cf,
                    0x23ff,
                    0x2427,
                    0x243f,
                    0x244b,
                    0x245f,
                    0x24ff,
                    0x24ff,
                    0x2614,
                    0x2615,
                    0x2618,
                    0x2618,
                    0x267e,
                    0x267f,
                    0x268a,
                    0x2700,
                    0x2705,
                    0x2705,
                    0x270a,
                    0x270b,
                    0x2728,
                    0x2728,
                    0x274c,
                    0x274c,
                    0x274e,
                    0x274e,
                    0x2753,
                    0x2755,
                    0x2757,
                    0x2757,
                    0x275f,
                    0x2760,
                    0x2795,
                    0x2797,
                    0x27b0,
                    0x27b0,
                    0x27bf,
                    0x27cf,
                    0x27ec,
                    0x27ef,
                    0x2b00,
                    0x2e7f,
                    0x2e9a,
                    0x2e9a,
                    0x2ef4,
                    0x2eff,
                    0x2fd6,
                    0x2fef,
                    0x2ffc,
                    0x2fff,
                    0x3040,
                    0x3040,
                    0x3097,
                    0x3098,
                    0x3100,
                    0x3104,
                    0x312d,
                    0x3130,
                    0x318f,
                    0x318f,
                    0x31b8,
                    0x31ef,
                    0x321d,
                    0x321f,
                    0x3244,
                    0x3250,
                    0x327c,
                    0x327e,
                    0x32cc,
                    0x32cf,
                    0x32ff,
                    0x32ff,
                    0x3377,
                    0x337a,
                    0x33de,
                    0x33df,
                    0x33ff,
                    0x33ff,
                    0x4db6,
                    0x4dff,
                    0x9fa6,
                    0x9fff,
                    0xa48d,
                    0xa48f,
                    0xa4c7,
                    0xabff,
                    0xd7a4,
                    0xd7ff,
                    0xfa2e,
                    0xfa2f,
                    0xfa6b,
                    0xfaff,
                    0xfb07,
                    0xfb12,
                    0xfb18,
                    0xfb1c,
                    0xfb37,
                    0xfb37,
                    0xfb3d,
                    0xfb3d,
                    0xfb3f,
                    0xfb3f,
                    0xfb42,
                    0xfb42,
                    0xfb45,
                    0xfb45,
                    0xfbb2,
                    0xfbd2,
                    0xfd40,
                    0xfd4f,
                    0xfd90,
                    0xfd91,
                    0xfdc8,
                    0xfdcf,
                    0xfdfd,
                    0xfdff,
                    0xfe10,
                    0xfe1f,
                    0xfe24,
                    0xfe2f,
                    0xfe47,
                    0xfe48,
                    0xfe53,
                    0xfe53,
                    0xfe67,
                    0xfe67,
                    0xfe6c,
                    0xfe6f,
                    0xfe75,
                    0xfe75,
                    0xfefd,
                    0xfefe,
                    0xff00,
                    0xff00,
                    0xffbf,
                    0xffc1,
                    0xffc8,
                    0xffc9,
                    0xffd0,
                    0xffd1,
                    0xffd8,
                    0xffd9,
                    0xffdd,
                    0xffdf,
                    0xffe7,
                    0xffe7,
                    0xffef,
                    0xfff8,
                    0x10000,
                    0x102ff,
                    0x1031f,
                    0x1031f,
                    0x10324,
                    0x1032f,
                    0x1034b,
                    0x103ff,
                    0x10426,
                    0x10427,
                    0x1044e,
                    0x1cfff,
                    0x1d0f6,
                    0x1d0ff,
                    0x1d127,
                    0x1d129,
                    0x1d1de,
                    0x1d3ff,
                    0x1d455,
                    0x1d455,
                    0x1d49d,
                    0x1d49d,
                    0x1d4a0,
                    0x1d4a1,
                    0x1d4a3,
                    0x1d4a4,
                    0x1d4a7,
                    0x1d4a8,
                    0x1d4ad,
                    0x1d4ad,
                    0x1d4ba,
                    0x1d4ba,
                    0x1d4bc,
                    0x1d4bc,
                    0x1d4c1,
                    0x1d4c1,
                    0x1d4c4,
                    0x1d4c4,
                    0x1d506,
                    0x1d506,
                    0x1d50b,
                    0x1d50c,
                    0x1d515,
                    0x1d515,
                    0x1d51d,
                    0x1d51d,
                    0x1d53a,
                    0x1d53a,
                    0x1d53f,
                    0x1d53f,
                    0x1d545,
                    0x1d545,
                    0x1d547,
                    0x1d549,
                    0x1d551,
                    0x1d551,
                    0x1d6a4,
                    0x1d6a7,
                    0x1d7ca,
                    0x1d7cd,
                    0x1d800,
                    0x1fffd,
                    0x2a6d7,
                    0x2f7ff,
                    0x2fa1e,
                    0x2fffd,
                    0x30000,
                    0x3fffd,
                    0x40000,
                    0x4fffd,
                    0x50000,
                    0x5fffd,
                    0x60000,
                    0x6fffd,
                    0x70000,
                    0x7fffd,
                    0x80000,
                    0x8fffd,
                    0x90000,
                    0x9fffd,
                    0xa0000,
                    0xafffd,
                    0xb0000,
                    0xbfffd,
                    0xc0000,
                    0xcfffd,
                    0xd0000,
                    0xdfffd,
                    0xe0000,
                    0xe0000,
                    0xe0002,
                    0xe001f,
                    0xe0080,
                    0xefffd
                ];
                // prettier-ignore-end
                var isUnassignedCodePoint = function isUnassignedCodePoint(character) {
                    return inRange(character, unassigned_code_points);
                };
                // prettier-ignore-start
                /**
 * B.1 Commonly mapped to nothing
 * @link https://tools.ietf.org/html/rfc3454#appendix-B.1
 */ var commonly_mapped_to_nothing = [
                    0x00ad,
                    0x00ad,
                    0x034f,
                    0x034f,
                    0x1806,
                    0x1806,
                    0x180b,
                    0x180b,
                    0x180c,
                    0x180c,
                    0x180d,
                    0x180d,
                    0x200b,
                    0x200b,
                    0x200c,
                    0x200c,
                    0x200d,
                    0x200d,
                    0x2060,
                    0x2060,
                    0xfe00,
                    0xfe00,
                    0xfe01,
                    0xfe01,
                    0xfe02,
                    0xfe02,
                    0xfe03,
                    0xfe03,
                    0xfe04,
                    0xfe04,
                    0xfe05,
                    0xfe05,
                    0xfe06,
                    0xfe06,
                    0xfe07,
                    0xfe07,
                    0xfe08,
                    0xfe08,
                    0xfe09,
                    0xfe09,
                    0xfe0a,
                    0xfe0a,
                    0xfe0b,
                    0xfe0b,
                    0xfe0c,
                    0xfe0c,
                    0xfe0d,
                    0xfe0d,
                    0xfe0e,
                    0xfe0e,
                    0xfe0f,
                    0xfe0f,
                    0xfeff,
                    0xfeff
                ];
                // prettier-ignore-end
                var isCommonlyMappedToNothing = function isCommonlyMappedToNothing(character) {
                    return inRange(character, commonly_mapped_to_nothing);
                };
                // prettier-ignore-start
                /**
 * C.1.2 Non-ASCII space characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.1.2
 */ var non_ASCII_space_characters = [
                    0x00a0,
                    0x00a0 /* NO-BREAK SPACE */ ,
                    0x1680,
                    0x1680 /* OGHAM SPACE MARK */ ,
                    0x2000,
                    0x2000 /* EN QUAD */ ,
                    0x2001,
                    0x2001 /* EM QUAD */ ,
                    0x2002,
                    0x2002 /* EN SPACE */ ,
                    0x2003,
                    0x2003 /* EM SPACE */ ,
                    0x2004,
                    0x2004 /* THREE-PER-EM SPACE */ ,
                    0x2005,
                    0x2005 /* FOUR-PER-EM SPACE */ ,
                    0x2006,
                    0x2006 /* SIX-PER-EM SPACE */ ,
                    0x2007,
                    0x2007 /* FIGURE SPACE */ ,
                    0x2008,
                    0x2008 /* PUNCTUATION SPACE */ ,
                    0x2009,
                    0x2009 /* THIN SPACE */ ,
                    0x200a,
                    0x200a /* HAIR SPACE */ ,
                    0x200b,
                    0x200b /* ZERO WIDTH SPACE */ ,
                    0x202f,
                    0x202f /* NARROW NO-BREAK SPACE */ ,
                    0x205f,
                    0x205f /* MEDIUM MATHEMATICAL SPACE */ ,
                    0x3000,
                    0x3000 /* IDEOGRAPHIC SPACE */ 
                ];
                // prettier-ignore-end
                var isNonASCIISpaceCharacter = function isNonASCIISpaceCharacter(character) {
                    return inRange(character, non_ASCII_space_characters);
                };
                // prettier-ignore-start
                var non_ASCII_controls_characters = [
                    /**
 * C.2.2 Non-ASCII control characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.2.2
 */ 0x0080,
                    0x009f /* [CONTROL CHARACTERS] */ ,
                    0x06dd,
                    0x06dd /* ARABIC END OF AYAH */ ,
                    0x070f,
                    0x070f /* SYRIAC ABBREVIATION MARK */ ,
                    0x180e,
                    0x180e /* MONGOLIAN VOWEL SEPARATOR */ ,
                    0x200c,
                    0x200c /* ZERO WIDTH NON-JOINER */ ,
                    0x200d,
                    0x200d /* ZERO WIDTH JOINER */ ,
                    0x2028,
                    0x2028 /* LINE SEPARATOR */ ,
                    0x2029,
                    0x2029 /* PARAGRAPH SEPARATOR */ ,
                    0x2060,
                    0x2060 /* WORD JOINER */ ,
                    0x2061,
                    0x2061 /* FUNCTION APPLICATION */ ,
                    0x2062,
                    0x2062 /* INVISIBLE TIMES */ ,
                    0x2063,
                    0x2063 /* INVISIBLE SEPARATOR */ ,
                    0x206a,
                    0x206f /* [CONTROL CHARACTERS] */ ,
                    0xfeff,
                    0xfeff /* ZERO WIDTH NO-BREAK SPACE */ ,
                    0xfff9,
                    0xfffc /* [CONTROL CHARACTERS] */ ,
                    0x1d173,
                    0x1d17a /* [MUSICAL CONTROL CHARACTERS] */ 
                ];
                var non_character_codepoints = [
                    /**
 * C.4 Non-character code points
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.4
 */ 0xfdd0,
                    0xfdef /* [NONCHARACTER CODE POINTS] */ ,
                    0xfffe,
                    0xffff /* [NONCHARACTER CODE POINTS] */ ,
                    0x1fffe,
                    0x1ffff /* [NONCHARACTER CODE POINTS] */ ,
                    0x2fffe,
                    0x2ffff /* [NONCHARACTER CODE POINTS] */ ,
                    0x3fffe,
                    0x3ffff /* [NONCHARACTER CODE POINTS] */ ,
                    0x4fffe,
                    0x4ffff /* [NONCHARACTER CODE POINTS] */ ,
                    0x5fffe,
                    0x5ffff /* [NONCHARACTER CODE POINTS] */ ,
                    0x6fffe,
                    0x6ffff /* [NONCHARACTER CODE POINTS] */ ,
                    0x7fffe,
                    0x7ffff /* [NONCHARACTER CODE POINTS] */ ,
                    0x8fffe,
                    0x8ffff /* [NONCHARACTER CODE POINTS] */ ,
                    0x9fffe,
                    0x9ffff /* [NONCHARACTER CODE POINTS] */ ,
                    0xafffe,
                    0xaffff /* [NONCHARACTER CODE POINTS] */ ,
                    0xbfffe,
                    0xbffff /* [NONCHARACTER CODE POINTS] */ ,
                    0xcfffe,
                    0xcffff /* [NONCHARACTER CODE POINTS] */ ,
                    0xdfffe,
                    0xdffff /* [NONCHARACTER CODE POINTS] */ ,
                    0xefffe,
                    0xeffff /* [NONCHARACTER CODE POINTS] */ ,
                    0x10fffe,
                    0x10ffff /* [NONCHARACTER CODE POINTS] */ 
                ];
                /**
 * 2.3.  Prohibited Output
 */ var prohibited_characters = [
                    /**
 * C.2.1 ASCII control characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.2.1
 */ 0,
                    0x001f /* [CONTROL CHARACTERS] */ ,
                    0x007f,
                    0x007f /* DELETE */ ,
                    /**
 * C.8 Change display properties or are deprecated
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.8
 */ 0x0340,
                    0x0340 /* COMBINING GRAVE TONE MARK */ ,
                    0x0341,
                    0x0341 /* COMBINING ACUTE TONE MARK */ ,
                    0x200e,
                    0x200e /* LEFT-TO-RIGHT MARK */ ,
                    0x200f,
                    0x200f /* RIGHT-TO-LEFT MARK */ ,
                    0x202a,
                    0x202a /* LEFT-TO-RIGHT EMBEDDING */ ,
                    0x202b,
                    0x202b /* RIGHT-TO-LEFT EMBEDDING */ ,
                    0x202c,
                    0x202c /* POP DIRECTIONAL FORMATTING */ ,
                    0x202d,
                    0x202d /* LEFT-TO-RIGHT OVERRIDE */ ,
                    0x202e,
                    0x202e /* RIGHT-TO-LEFT OVERRIDE */ ,
                    0x206a,
                    0x206a /* INHIBIT SYMMETRIC SWAPPING */ ,
                    0x206b,
                    0x206b /* ACTIVATE SYMMETRIC SWAPPING */ ,
                    0x206c,
                    0x206c /* INHIBIT ARABIC FORM SHAPING */ ,
                    0x206d,
                    0x206d /* ACTIVATE ARABIC FORM SHAPING */ ,
                    0x206e,
                    0x206e /* NATIONAL DIGIT SHAPES */ ,
                    0x206f,
                    0x206f /* NOMINAL DIGIT SHAPES */ ,
                    /**
 * C.7 Inappropriate for canonical representation
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.7
 */ 0x2ff0,
                    0x2ffb /* [IDEOGRAPHIC DESCRIPTION CHARACTERS] */ ,
                    /**
 * C.5 Surrogate codes
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.5
 */ 0xd800,
                    0xdfff,
                    /**
 * C.3 Private use
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.3
 */ 0xe000,
                    0xf8ff /* [PRIVATE USE, PLANE 0] */ ,
                    /**
 * C.6 Inappropriate for plain text
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.6
 */ 0xfff9,
                    0xfff9 /* INTERLINEAR ANNOTATION ANCHOR */ ,
                    0xfffa,
                    0xfffa /* INTERLINEAR ANNOTATION SEPARATOR */ ,
                    0xfffb,
                    0xfffb /* INTERLINEAR ANNOTATION TERMINATOR */ ,
                    0xfffc,
                    0xfffc /* OBJECT REPLACEMENT CHARACTER */ ,
                    0xfffd,
                    0xfffd /* REPLACEMENT CHARACTER */ ,
                    /**
 * C.9 Tagging characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.9
 */ 0xe0001,
                    0xe0001 /* LANGUAGE TAG */ ,
                    0xe0020,
                    0xe007f /* [TAGGING CHARACTERS] */ ,
                    /**
 * C.3 Private use
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.3
 */ 0xf0000,
                    0xffffd /* [PRIVATE USE, PLANE 15] */ ,
                    0x100000,
                    0x10fffd /* [PRIVATE USE, PLANE 16] */ 
                ];
                // prettier-ignore-end
                var isProhibitedCharacter = function isProhibitedCharacter(character) {
                    return inRange(character, non_ASCII_space_characters) || inRange(character, prohibited_characters) || inRange(character, non_ASCII_controls_characters) || inRange(character, non_character_codepoints);
                };
                // prettier-ignore-start
                /**
 * D.1 Characters with bidirectional property "R" or "AL"
 * @link https://tools.ietf.org/html/rfc3454#appendix-D.1
 */ var bidirectional_r_al = [
                    0x05be,
                    0x05be,
                    0x05c0,
                    0x05c0,
                    0x05c3,
                    0x05c3,
                    0x05d0,
                    0x05ea,
                    0x05f0,
                    0x05f4,
                    0x061b,
                    0x061b,
                    0x061f,
                    0x061f,
                    0x0621,
                    0x063a,
                    0x0640,
                    0x064a,
                    0x066d,
                    0x066f,
                    0x0671,
                    0x06d5,
                    0x06dd,
                    0x06dd,
                    0x06e5,
                    0x06e6,
                    0x06fa,
                    0x06fe,
                    0x0700,
                    0x070d,
                    0x0710,
                    0x0710,
                    0x0712,
                    0x072c,
                    0x0780,
                    0x07a5,
                    0x07b1,
                    0x07b1,
                    0x200f,
                    0x200f,
                    0xfb1d,
                    0xfb1d,
                    0xfb1f,
                    0xfb28,
                    0xfb2a,
                    0xfb36,
                    0xfb38,
                    0xfb3c,
                    0xfb3e,
                    0xfb3e,
                    0xfb40,
                    0xfb41,
                    0xfb43,
                    0xfb44,
                    0xfb46,
                    0xfbb1,
                    0xfbd3,
                    0xfd3d,
                    0xfd50,
                    0xfd8f,
                    0xfd92,
                    0xfdc7,
                    0xfdf0,
                    0xfdfc,
                    0xfe70,
                    0xfe74,
                    0xfe76,
                    0xfefc
                ];
                // prettier-ignore-end
                var isBidirectionalRAL = function isBidirectionalRAL(character) {
                    return inRange(character, bidirectional_r_al);
                };
                // prettier-ignore-start
                /**
 * D.2 Characters with bidirectional property "L"
 * @link https://tools.ietf.org/html/rfc3454#appendix-D.2
 */ var bidirectional_l = [
                    0x0041,
                    0x005a,
                    0x0061,
                    0x007a,
                    0x00aa,
                    0x00aa,
                    0x00b5,
                    0x00b5,
                    0x00ba,
                    0x00ba,
                    0x00c0,
                    0x00d6,
                    0x00d8,
                    0x00f6,
                    0x00f8,
                    0x0220,
                    0x0222,
                    0x0233,
                    0x0250,
                    0x02ad,
                    0x02b0,
                    0x02b8,
                    0x02bb,
                    0x02c1,
                    0x02d0,
                    0x02d1,
                    0x02e0,
                    0x02e4,
                    0x02ee,
                    0x02ee,
                    0x037a,
                    0x037a,
                    0x0386,
                    0x0386,
                    0x0388,
                    0x038a,
                    0x038c,
                    0x038c,
                    0x038e,
                    0x03a1,
                    0x03a3,
                    0x03ce,
                    0x03d0,
                    0x03f5,
                    0x0400,
                    0x0482,
                    0x048a,
                    0x04ce,
                    0x04d0,
                    0x04f5,
                    0x04f8,
                    0x04f9,
                    0x0500,
                    0x050f,
                    0x0531,
                    0x0556,
                    0x0559,
                    0x055f,
                    0x0561,
                    0x0587,
                    0x0589,
                    0x0589,
                    0x0903,
                    0x0903,
                    0x0905,
                    0x0939,
                    0x093d,
                    0x0940,
                    0x0949,
                    0x094c,
                    0x0950,
                    0x0950,
                    0x0958,
                    0x0961,
                    0x0964,
                    0x0970,
                    0x0982,
                    0x0983,
                    0x0985,
                    0x098c,
                    0x098f,
                    0x0990,
                    0x0993,
                    0x09a8,
                    0x09aa,
                    0x09b0,
                    0x09b2,
                    0x09b2,
                    0x09b6,
                    0x09b9,
                    0x09be,
                    0x09c0,
                    0x09c7,
                    0x09c8,
                    0x09cb,
                    0x09cc,
                    0x09d7,
                    0x09d7,
                    0x09dc,
                    0x09dd,
                    0x09df,
                    0x09e1,
                    0x09e6,
                    0x09f1,
                    0x09f4,
                    0x09fa,
                    0x0a05,
                    0x0a0a,
                    0x0a0f,
                    0x0a10,
                    0x0a13,
                    0x0a28,
                    0x0a2a,
                    0x0a30,
                    0x0a32,
                    0x0a33,
                    0x0a35,
                    0x0a36,
                    0x0a38,
                    0x0a39,
                    0x0a3e,
                    0x0a40,
                    0x0a59,
                    0x0a5c,
                    0x0a5e,
                    0x0a5e,
                    0x0a66,
                    0x0a6f,
                    0x0a72,
                    0x0a74,
                    0x0a83,
                    0x0a83,
                    0x0a85,
                    0x0a8b,
                    0x0a8d,
                    0x0a8d,
                    0x0a8f,
                    0x0a91,
                    0x0a93,
                    0x0aa8,
                    0x0aaa,
                    0x0ab0,
                    0x0ab2,
                    0x0ab3,
                    0x0ab5,
                    0x0ab9,
                    0x0abd,
                    0x0ac0,
                    0x0ac9,
                    0x0ac9,
                    0x0acb,
                    0x0acc,
                    0x0ad0,
                    0x0ad0,
                    0x0ae0,
                    0x0ae0,
                    0x0ae6,
                    0x0aef,
                    0x0b02,
                    0x0b03,
                    0x0b05,
                    0x0b0c,
                    0x0b0f,
                    0x0b10,
                    0x0b13,
                    0x0b28,
                    0x0b2a,
                    0x0b30,
                    0x0b32,
                    0x0b33,
                    0x0b36,
                    0x0b39,
                    0x0b3d,
                    0x0b3e,
                    0x0b40,
                    0x0b40,
                    0x0b47,
                    0x0b48,
                    0x0b4b,
                    0x0b4c,
                    0x0b57,
                    0x0b57,
                    0x0b5c,
                    0x0b5d,
                    0x0b5f,
                    0x0b61,
                    0x0b66,
                    0x0b70,
                    0x0b83,
                    0x0b83,
                    0x0b85,
                    0x0b8a,
                    0x0b8e,
                    0x0b90,
                    0x0b92,
                    0x0b95,
                    0x0b99,
                    0x0b9a,
                    0x0b9c,
                    0x0b9c,
                    0x0b9e,
                    0x0b9f,
                    0x0ba3,
                    0x0ba4,
                    0x0ba8,
                    0x0baa,
                    0x0bae,
                    0x0bb5,
                    0x0bb7,
                    0x0bb9,
                    0x0bbe,
                    0x0bbf,
                    0x0bc1,
                    0x0bc2,
                    0x0bc6,
                    0x0bc8,
                    0x0bca,
                    0x0bcc,
                    0x0bd7,
                    0x0bd7,
                    0x0be7,
                    0x0bf2,
                    0x0c01,
                    0x0c03,
                    0x0c05,
                    0x0c0c,
                    0x0c0e,
                    0x0c10,
                    0x0c12,
                    0x0c28,
                    0x0c2a,
                    0x0c33,
                    0x0c35,
                    0x0c39,
                    0x0c41,
                    0x0c44,
                    0x0c60,
                    0x0c61,
                    0x0c66,
                    0x0c6f,
                    0x0c82,
                    0x0c83,
                    0x0c85,
                    0x0c8c,
                    0x0c8e,
                    0x0c90,
                    0x0c92,
                    0x0ca8,
                    0x0caa,
                    0x0cb3,
                    0x0cb5,
                    0x0cb9,
                    0x0cbe,
                    0x0cbe,
                    0x0cc0,
                    0x0cc4,
                    0x0cc7,
                    0x0cc8,
                    0x0cca,
                    0x0ccb,
                    0x0cd5,
                    0x0cd6,
                    0x0cde,
                    0x0cde,
                    0x0ce0,
                    0x0ce1,
                    0x0ce6,
                    0x0cef,
                    0x0d02,
                    0x0d03,
                    0x0d05,
                    0x0d0c,
                    0x0d0e,
                    0x0d10,
                    0x0d12,
                    0x0d28,
                    0x0d2a,
                    0x0d39,
                    0x0d3e,
                    0x0d40,
                    0x0d46,
                    0x0d48,
                    0x0d4a,
                    0x0d4c,
                    0x0d57,
                    0x0d57,
                    0x0d60,
                    0x0d61,
                    0x0d66,
                    0x0d6f,
                    0x0d82,
                    0x0d83,
                    0x0d85,
                    0x0d96,
                    0x0d9a,
                    0x0db1,
                    0x0db3,
                    0x0dbb,
                    0x0dbd,
                    0x0dbd,
                    0x0dc0,
                    0x0dc6,
                    0x0dcf,
                    0x0dd1,
                    0x0dd8,
                    0x0ddf,
                    0x0df2,
                    0x0df4,
                    0x0e01,
                    0x0e30,
                    0x0e32,
                    0x0e33,
                    0x0e40,
                    0x0e46,
                    0x0e4f,
                    0x0e5b,
                    0x0e81,
                    0x0e82,
                    0x0e84,
                    0x0e84,
                    0x0e87,
                    0x0e88,
                    0x0e8a,
                    0x0e8a,
                    0x0e8d,
                    0x0e8d,
                    0x0e94,
                    0x0e97,
                    0x0e99,
                    0x0e9f,
                    0x0ea1,
                    0x0ea3,
                    0x0ea5,
                    0x0ea5,
                    0x0ea7,
                    0x0ea7,
                    0x0eaa,
                    0x0eab,
                    0x0ead,
                    0x0eb0,
                    0x0eb2,
                    0x0eb3,
                    0x0ebd,
                    0x0ebd,
                    0x0ec0,
                    0x0ec4,
                    0x0ec6,
                    0x0ec6,
                    0x0ed0,
                    0x0ed9,
                    0x0edc,
                    0x0edd,
                    0x0f00,
                    0x0f17,
                    0x0f1a,
                    0x0f34,
                    0x0f36,
                    0x0f36,
                    0x0f38,
                    0x0f38,
                    0x0f3e,
                    0x0f47,
                    0x0f49,
                    0x0f6a,
                    0x0f7f,
                    0x0f7f,
                    0x0f85,
                    0x0f85,
                    0x0f88,
                    0x0f8b,
                    0x0fbe,
                    0x0fc5,
                    0x0fc7,
                    0x0fcc,
                    0x0fcf,
                    0x0fcf,
                    0x1000,
                    0x1021,
                    0x1023,
                    0x1027,
                    0x1029,
                    0x102a,
                    0x102c,
                    0x102c,
                    0x1031,
                    0x1031,
                    0x1038,
                    0x1038,
                    0x1040,
                    0x1057,
                    0x10a0,
                    0x10c5,
                    0x10d0,
                    0x10f8,
                    0x10fb,
                    0x10fb,
                    0x1100,
                    0x1159,
                    0x115f,
                    0x11a2,
                    0x11a8,
                    0x11f9,
                    0x1200,
                    0x1206,
                    0x1208,
                    0x1246,
                    0x1248,
                    0x1248,
                    0x124a,
                    0x124d,
                    0x1250,
                    0x1256,
                    0x1258,
                    0x1258,
                    0x125a,
                    0x125d,
                    0x1260,
                    0x1286,
                    0x1288,
                    0x1288,
                    0x128a,
                    0x128d,
                    0x1290,
                    0x12ae,
                    0x12b0,
                    0x12b0,
                    0x12b2,
                    0x12b5,
                    0x12b8,
                    0x12be,
                    0x12c0,
                    0x12c0,
                    0x12c2,
                    0x12c5,
                    0x12c8,
                    0x12ce,
                    0x12d0,
                    0x12d6,
                    0x12d8,
                    0x12ee,
                    0x12f0,
                    0x130e,
                    0x1310,
                    0x1310,
                    0x1312,
                    0x1315,
                    0x1318,
                    0x131e,
                    0x1320,
                    0x1346,
                    0x1348,
                    0x135a,
                    0x1361,
                    0x137c,
                    0x13a0,
                    0x13f4,
                    0x1401,
                    0x1676,
                    0x1681,
                    0x169a,
                    0x16a0,
                    0x16f0,
                    0x1700,
                    0x170c,
                    0x170e,
                    0x1711,
                    0x1720,
                    0x1731,
                    0x1735,
                    0x1736,
                    0x1740,
                    0x1751,
                    0x1760,
                    0x176c,
                    0x176e,
                    0x1770,
                    0x1780,
                    0x17b6,
                    0x17be,
                    0x17c5,
                    0x17c7,
                    0x17c8,
                    0x17d4,
                    0x17da,
                    0x17dc,
                    0x17dc,
                    0x17e0,
                    0x17e9,
                    0x1810,
                    0x1819,
                    0x1820,
                    0x1877,
                    0x1880,
                    0x18a8,
                    0x1e00,
                    0x1e9b,
                    0x1ea0,
                    0x1ef9,
                    0x1f00,
                    0x1f15,
                    0x1f18,
                    0x1f1d,
                    0x1f20,
                    0x1f45,
                    0x1f48,
                    0x1f4d,
                    0x1f50,
                    0x1f57,
                    0x1f59,
                    0x1f59,
                    0x1f5b,
                    0x1f5b,
                    0x1f5d,
                    0x1f5d,
                    0x1f5f,
                    0x1f7d,
                    0x1f80,
                    0x1fb4,
                    0x1fb6,
                    0x1fbc,
                    0x1fbe,
                    0x1fbe,
                    0x1fc2,
                    0x1fc4,
                    0x1fc6,
                    0x1fcc,
                    0x1fd0,
                    0x1fd3,
                    0x1fd6,
                    0x1fdb,
                    0x1fe0,
                    0x1fec,
                    0x1ff2,
                    0x1ff4,
                    0x1ff6,
                    0x1ffc,
                    0x200e,
                    0x200e,
                    0x2071,
                    0x2071,
                    0x207f,
                    0x207f,
                    0x2102,
                    0x2102,
                    0x2107,
                    0x2107,
                    0x210a,
                    0x2113,
                    0x2115,
                    0x2115,
                    0x2119,
                    0x211d,
                    0x2124,
                    0x2124,
                    0x2126,
                    0x2126,
                    0x2128,
                    0x2128,
                    0x212a,
                    0x212d,
                    0x212f,
                    0x2131,
                    0x2133,
                    0x2139,
                    0x213d,
                    0x213f,
                    0x2145,
                    0x2149,
                    0x2160,
                    0x2183,
                    0x2336,
                    0x237a,
                    0x2395,
                    0x2395,
                    0x249c,
                    0x24e9,
                    0x3005,
                    0x3007,
                    0x3021,
                    0x3029,
                    0x3031,
                    0x3035,
                    0x3038,
                    0x303c,
                    0x3041,
                    0x3096,
                    0x309d,
                    0x309f,
                    0x30a1,
                    0x30fa,
                    0x30fc,
                    0x30ff,
                    0x3105,
                    0x312c,
                    0x3131,
                    0x318e,
                    0x3190,
                    0x31b7,
                    0x31f0,
                    0x321c,
                    0x3220,
                    0x3243,
                    0x3260,
                    0x327b,
                    0x327f,
                    0x32b0,
                    0x32c0,
                    0x32cb,
                    0x32d0,
                    0x32fe,
                    0x3300,
                    0x3376,
                    0x337b,
                    0x33dd,
                    0x33e0,
                    0x33fe,
                    0x3400,
                    0x4db5,
                    0x4e00,
                    0x9fa5,
                    0xa000,
                    0xa48c,
                    0xac00,
                    0xd7a3,
                    0xd800,
                    0xfa2d,
                    0xfa30,
                    0xfa6a,
                    0xfb00,
                    0xfb06,
                    0xfb13,
                    0xfb17,
                    0xff21,
                    0xff3a,
                    0xff41,
                    0xff5a,
                    0xff66,
                    0xffbe,
                    0xffc2,
                    0xffc7,
                    0xffca,
                    0xffcf,
                    0xffd2,
                    0xffd7,
                    0xffda,
                    0xffdc,
                    0x10300,
                    0x1031e,
                    0x10320,
                    0x10323,
                    0x10330,
                    0x1034a,
                    0x10400,
                    0x10425,
                    0x10428,
                    0x1044d,
                    0x1d000,
                    0x1d0f5,
                    0x1d100,
                    0x1d126,
                    0x1d12a,
                    0x1d166,
                    0x1d16a,
                    0x1d172,
                    0x1d183,
                    0x1d184,
                    0x1d18c,
                    0x1d1a9,
                    0x1d1ae,
                    0x1d1dd,
                    0x1d400,
                    0x1d454,
                    0x1d456,
                    0x1d49c,
                    0x1d49e,
                    0x1d49f,
                    0x1d4a2,
                    0x1d4a2,
                    0x1d4a5,
                    0x1d4a6,
                    0x1d4a9,
                    0x1d4ac,
                    0x1d4ae,
                    0x1d4b9,
                    0x1d4bb,
                    0x1d4bb,
                    0x1d4bd,
                    0x1d4c0,
                    0x1d4c2,
                    0x1d4c3,
                    0x1d4c5,
                    0x1d505,
                    0x1d507,
                    0x1d50a,
                    0x1d50d,
                    0x1d514,
                    0x1d516,
                    0x1d51c,
                    0x1d51e,
                    0x1d539,
                    0x1d53b,
                    0x1d53e,
                    0x1d540,
                    0x1d544,
                    0x1d546,
                    0x1d546,
                    0x1d54a,
                    0x1d550,
                    0x1d552,
                    0x1d6a3,
                    0x1d6a8,
                    0x1d7c9,
                    0x20000,
                    0x2a6d6,
                    0x2f800,
                    0x2fa1d,
                    0xf0000,
                    0xffffd,
                    0x100000,
                    0x10fffd
                ];
                // prettier-ignore-end
                var isBidirectionalL = function isBidirectionalL(character) {
                    return inRange(character, bidirectional_l);
                };
                // 2.1.  Mapping
                /**
 * non-ASCII space characters [StringPrep, C.1.2] that can be
 * mapped to SPACE (U+0020)
 */ var mapping2space = isNonASCIISpaceCharacter;
                /**
 * the "commonly mapped to nothing" characters [StringPrep, B.1]
 * that can be mapped to nothing.
 */ var mapping2nothing = isCommonlyMappedToNothing;
                // utils
                var getCodePoint = function getCodePoint(character) {
                    return character.codePointAt(0);
                };
                var first = function first(x) {
                    return x[0];
                };
                var last = function last(x) {
                    return x[x.length - 1];
                };
                /**
 * Convert provided string into an array of Unicode Code Points.
 * Based on https://stackoverflow.com/a/21409165/1556249
 * and https://www.npmjs.com/package/code-point-at.
 * @param {string} input
 * @returns {number[]}
 */ function toCodePoints(input) {
                    var codepoints = [];
                    var size = input.length;
                    for(var i = 0; i < size; i += 1){
                        var before = input.charCodeAt(i);
                        if (before >= 0xd800 && before <= 0xdbff && size > i + 1) {
                            var next = input.charCodeAt(i + 1);
                            if (next >= 0xdc00 && next <= 0xdfff) {
                                codepoints.push((before - 0xd800) * 0x400 + next - 0xdc00 + 0x10000);
                                i += 1;
                                continue;
                            }
                        }
                        codepoints.push(before);
                    }
                    return codepoints;
                }
                /**
 * SASLprep.
 * @param {string} input
 * @param {Object} opts
 * @param {boolean} opts.allowUnassigned
 * @returns {string}
 */ function saslprep(input) {
                    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (typeof input !== 'string') throw new TypeError('Expected string.');
                    if (input.length === 0) return '';
                    // 1. Map
                    var mapped_input = toCodePoints(input)// 1.1 mapping to space
                    .map(function(character) {
                        return mapping2space(character) ? 0x20 : character;
                    })// 1.2 mapping to nothing
                    .filter(function(character) {
                        return !mapping2nothing(character);
                    });
                    // 2. Normalize
                    var normalized_input = String.fromCodePoint.apply(null, mapped_input).normalize('NFKC');
                    var normalized_map = toCodePoints(normalized_input);
                    // 3. Prohibit
                    var hasProhibited = normalized_map.some(isProhibitedCharacter);
                    if (hasProhibited) throw new Error('Prohibited character, see https://tools.ietf.org/html/rfc4013#section-2.3');
                    // Unassigned Code Points
                    if (opts.allowUnassigned !== true) {
                        var hasUnassigned = normalized_map.some(isUnassignedCodePoint);
                        if (hasUnassigned) throw new Error('Unassigned code point, see https://tools.ietf.org/html/rfc4013#section-2.5');
                    }
                    // 4. check bidi
                    var hasBidiRAL = normalized_map.some(isBidirectionalRAL);
                    var hasBidiL = normalized_map.some(isBidirectionalL);
                    // 4.1 If a string contains any RandALCat character, the string MUST NOT
                    // contain any LCat character.
                    if (hasBidiRAL && hasBidiL) throw new Error("String must not contain RandALCat and LCat at the same time, see https://tools.ietf.org/html/rfc3454#section-6");
                    /**
   * 4.2 If a string contains any RandALCat character, a RandALCat
   * character MUST be the first character of the string, and a
   * RandALCat character MUST be the last character of the string.
   */ var isFirstBidiRAL = isBidirectionalRAL(getCodePoint(first(normalized_input)));
                    var isLastBidiRAL = isBidirectionalRAL(getCodePoint(last(normalized_input)));
                    if (hasBidiRAL && !(isFirstBidiRAL && isLastBidiRAL)) throw new Error("Bidirectional RandALCat character must be the first and the last character of the string, see https://tools.ietf.org/html/rfc3454#section-6");
                    return normalized_input;
                }
                /*
   PDFSecurity - represents PDF security settings
   By Yang Liu <hi@zesik.com>
 */ var PDFSecurity = /*#__PURE__*/ function() {
                    function PDFSecurity(document1) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        if (!options.ownerPassword && !options.userPassword) throw new Error('None of owner password and user password is defined.');
                        this.document = document1;
                        this._setupEncryption(options);
                    }
                    PDFSecurity.generateFileID = function generateFileID() {
                        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        var infoStr = info.CreationDate.getTime() + "\n";
                        for(var key in info){
                            // eslint-disable-next-line no-prototype-builtins
                            if (!info.hasOwnProperty(key)) continue;
                            infoStr += key + ": " + info[key].valueOf() + "\n";
                        }
                        return wordArrayToBuffer(_cryptoJs.default.MD5(infoStr));
                    };
                    PDFSecurity.generateRandomWordArray = function generateRandomWordArray(bytes) {
                        return _cryptoJs.default.lib.WordArray.random(bytes);
                    };
                    PDFSecurity.create = function create(document1) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        if (!options.ownerPassword && !options.userPassword) return null;
                        return new PDFSecurity(document1, options);
                    };
                    var _proto7 = PDFSecurity.prototype;
                    _proto7._setupEncryption = function _setupEncryption(options) {
                        switch(options.pdfVersion){
                            case '1.4':
                            case '1.5':
                                this.version = 2;
                                break;
                            case '1.6':
                            case '1.7':
                                this.version = 4;
                                break;
                            case '1.7ext3':
                                this.version = 5;
                                break;
                            default:
                                this.version = 1;
                                break;
                        }
                        var encDict = {
                            Filter: 'Standard'
                        };
                        switch(this.version){
                            case 1:
                            case 2:
                            case 4:
                                this._setupEncryptionV1V2V4(this.version, encDict, options);
                                break;
                            case 5:
                                this._setupEncryptionV5(encDict, options);
                                break;
                        }
                        this.dictionary = this.document.ref(encDict);
                    };
                    _proto7._setupEncryptionV1V2V4 = function _setupEncryptionV1V2V4(v, encDict, options) {
                        var r, permissions;
                        switch(v){
                            case 1:
                                r = 2;
                                this.keyBits = 40;
                                permissions = getPermissionsR2(options.permissions);
                                break;
                            case 2:
                                r = 3;
                                this.keyBits = 128;
                                permissions = getPermissionsR3(options.permissions);
                                break;
                            case 4:
                                r = 4;
                                this.keyBits = 128;
                                permissions = getPermissionsR3(options.permissions);
                                break;
                        }
                        var paddedUserPassword = processPasswordR2R3R4(options.userPassword);
                        var paddedOwnerPassword = options.ownerPassword ? processPasswordR2R3R4(options.ownerPassword) : paddedUserPassword;
                        var ownerPasswordEntry = getOwnerPasswordR2R3R4(r, this.keyBits, paddedUserPassword, paddedOwnerPassword);
                        this.encryptionKey = getEncryptionKeyR2R3R4(r, this.keyBits, this.document._id, paddedUserPassword, ownerPasswordEntry, permissions);
                        var userPasswordEntry;
                        if (r === 2) userPasswordEntry = getUserPasswordR2(this.encryptionKey);
                        else userPasswordEntry = getUserPasswordR3R4(this.document._id, this.encryptionKey);
                        encDict.V = v;
                        if (v >= 2) encDict.Length = this.keyBits;
                        if (v === 4) {
                            encDict.CF = {
                                StdCF: {
                                    AuthEvent: 'DocOpen',
                                    CFM: 'AESV2',
                                    Length: this.keyBits / 8
                                }
                            };
                            encDict.StmF = 'StdCF';
                            encDict.StrF = 'StdCF';
                        }
                        encDict.R = r;
                        encDict.O = wordArrayToBuffer(ownerPasswordEntry);
                        encDict.U = wordArrayToBuffer(userPasswordEntry);
                        encDict.P = permissions;
                    };
                    _proto7._setupEncryptionV5 = function _setupEncryptionV5(encDict, options) {
                        this.keyBits = 256;
                        var permissions = getPermissionsR3(options.permissions);
                        var processedUserPassword = processPasswordR5(options.userPassword);
                        var processedOwnerPassword = options.ownerPassword ? processPasswordR5(options.ownerPassword) : processedUserPassword;
                        this.encryptionKey = getEncryptionKeyR5(PDFSecurity.generateRandomWordArray);
                        var userPasswordEntry = getUserPasswordR5(processedUserPassword, PDFSecurity.generateRandomWordArray);
                        var userKeySalt = _cryptoJs.default.lib.WordArray.create(userPasswordEntry.words.slice(10, 12), 8);
                        var userEncryptionKeyEntry = getUserEncryptionKeyR5(processedUserPassword, userKeySalt, this.encryptionKey);
                        var ownerPasswordEntry = getOwnerPasswordR5(processedOwnerPassword, userPasswordEntry, PDFSecurity.generateRandomWordArray);
                        var ownerKeySalt = _cryptoJs.default.lib.WordArray.create(ownerPasswordEntry.words.slice(10, 12), 8);
                        var ownerEncryptionKeyEntry = getOwnerEncryptionKeyR5(processedOwnerPassword, ownerKeySalt, userPasswordEntry, this.encryptionKey);
                        var permsEntry = getEncryptedPermissionsR5(permissions, this.encryptionKey, PDFSecurity.generateRandomWordArray);
                        encDict.V = 5;
                        encDict.Length = this.keyBits;
                        encDict.CF = {
                            StdCF: {
                                AuthEvent: 'DocOpen',
                                CFM: 'AESV3',
                                Length: this.keyBits / 8
                            }
                        };
                        encDict.StmF = 'StdCF';
                        encDict.StrF = 'StdCF';
                        encDict.R = 5;
                        encDict.O = wordArrayToBuffer(ownerPasswordEntry);
                        encDict.OE = wordArrayToBuffer(ownerEncryptionKeyEntry);
                        encDict.U = wordArrayToBuffer(userPasswordEntry);
                        encDict.UE = wordArrayToBuffer(userEncryptionKeyEntry);
                        encDict.P = permissions;
                        encDict.Perms = wordArrayToBuffer(permsEntry);
                    };
                    _proto7.getEncryptFn = function getEncryptFn(obj, gen) {
                        var digest;
                        if (this.version < 5) digest = this.encryptionKey.clone().concat(_cryptoJs.default.lib.WordArray.create([
                            (obj & 0xff) << 24 | (obj & 0xff00) << 8 | obj >> 8 & 0xff00 | gen & 0xff,
                            (gen & 0xff00) << 16
                        ], 5));
                        if (this.version === 1 || this.version === 2) {
                            var _key2 = _cryptoJs.default.MD5(digest);
                            _key2.sigBytes = Math.min(16, this.keyBits / 8 + 5);
                            return function(buffer) {
                                return wordArrayToBuffer(_cryptoJs.default.RC4.encrypt(_cryptoJs.default.lib.WordArray.create(buffer), _key2).ciphertext);
                            };
                        }
                        var key;
                        if (this.version === 4) key = _cryptoJs.default.MD5(digest.concat(_cryptoJs.default.lib.WordArray.create([
                            0x73416c54
                        ], 4)));
                        else key = this.encryptionKey;
                        var iv = PDFSecurity.generateRandomWordArray(16);
                        var options = {
                            mode: _cryptoJs.default.mode.CBC,
                            padding: _cryptoJs.default.pad.Pkcs7,
                            iv: iv
                        };
                        return function(buffer) {
                            return wordArrayToBuffer(iv.clone().concat(_cryptoJs.default.AES.encrypt(_cryptoJs.default.lib.WordArray.create(buffer), key, options).ciphertext));
                        };
                    };
                    _proto7.end = function end() {
                        this.dictionary.end();
                    };
                    return PDFSecurity;
                }();
                function getPermissionsR2() {
                    var permissionObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var permissions = -64;
                    if (permissionObject.printing) permissions |= 4;
                    if (permissionObject.modifying) permissions |= 8;
                    if (permissionObject.copying) permissions |= 16;
                    if (permissionObject.annotating) permissions |= 32;
                    return permissions;
                }
                function getPermissionsR3() {
                    var permissionObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var permissions = -3904;
                    if (permissionObject.printing === 'lowResolution') permissions |= 4;
                    if (permissionObject.printing === 'highResolution') permissions |= 2052;
                    if (permissionObject.modifying) permissions |= 8;
                    if (permissionObject.copying) permissions |= 16;
                    if (permissionObject.annotating) permissions |= 32;
                    if (permissionObject.fillingForms) permissions |= 256;
                    if (permissionObject.contentAccessibility) permissions |= 512;
                    if (permissionObject.documentAssembly) permissions |= 1024;
                    return permissions;
                }
                function getUserPasswordR2(encryptionKey) {
                    return _cryptoJs.default.RC4.encrypt(processPasswordR2R3R4(), encryptionKey).ciphertext;
                }
                function getUserPasswordR3R4(documentId, encryptionKey) {
                    var key = encryptionKey.clone();
                    var cipher = _cryptoJs.default.MD5(processPasswordR2R3R4().concat(_cryptoJs.default.lib.WordArray.create(documentId)));
                    for(var i = 0; i < 20; i++){
                        var xorRound = Math.ceil(key.sigBytes / 4);
                        for(var j = 0; j < xorRound; j++)key.words[j] = encryptionKey.words[j] ^ (i | i << 8 | i << 16 | i << 24);
                        cipher = _cryptoJs.default.RC4.encrypt(cipher, key).ciphertext;
                    }
                    return cipher.concat(_cryptoJs.default.lib.WordArray.create(null, 16));
                }
                function getOwnerPasswordR2R3R4(r, keyBits, paddedUserPassword, paddedOwnerPassword) {
                    var digest = paddedOwnerPassword;
                    var round = r >= 3 ? 51 : 1;
                    for(var i = 0; i < round; i++)digest = _cryptoJs.default.MD5(digest);
                    var key = digest.clone();
                    key.sigBytes = keyBits / 8;
                    var cipher = paddedUserPassword;
                    round = r >= 3 ? 20 : 1;
                    for(var _i2 = 0; _i2 < round; _i2++){
                        var xorRound = Math.ceil(key.sigBytes / 4);
                        for(var j = 0; j < xorRound; j++)key.words[j] = digest.words[j] ^ (_i2 | _i2 << 8 | _i2 << 16 | _i2 << 24);
                        cipher = _cryptoJs.default.RC4.encrypt(cipher, key).ciphertext;
                    }
                    return cipher;
                }
                function getEncryptionKeyR2R3R4(r, keyBits, documentId, paddedUserPassword, ownerPasswordEntry, permissions) {
                    var key = paddedUserPassword.clone().concat(ownerPasswordEntry).concat(_cryptoJs.default.lib.WordArray.create([
                        lsbFirstWord(permissions)
                    ], 4)).concat(_cryptoJs.default.lib.WordArray.create(documentId));
                    var round = r >= 3 ? 51 : 1;
                    for(var i = 0; i < round; i++){
                        key = _cryptoJs.default.MD5(key);
                        key.sigBytes = keyBits / 8;
                    }
                    return key;
                }
                function getUserPasswordR5(processedUserPassword, generateRandomWordArray) {
                    var validationSalt = generateRandomWordArray(8);
                    var keySalt = generateRandomWordArray(8);
                    return _cryptoJs.default.SHA256(processedUserPassword.clone().concat(validationSalt)).concat(validationSalt).concat(keySalt);
                }
                function getUserEncryptionKeyR5(processedUserPassword, userKeySalt, encryptionKey) {
                    var key = _cryptoJs.default.SHA256(processedUserPassword.clone().concat(userKeySalt));
                    var options = {
                        mode: _cryptoJs.default.mode.CBC,
                        padding: _cryptoJs.default.pad.NoPadding,
                        iv: _cryptoJs.default.lib.WordArray.create(null, 16)
                    };
                    return _cryptoJs.default.AES.encrypt(encryptionKey, key, options).ciphertext;
                }
                function getOwnerPasswordR5(processedOwnerPassword, userPasswordEntry, generateRandomWordArray) {
                    var validationSalt = generateRandomWordArray(8);
                    var keySalt = generateRandomWordArray(8);
                    return _cryptoJs.default.SHA256(processedOwnerPassword.clone().concat(validationSalt).concat(userPasswordEntry)).concat(validationSalt).concat(keySalt);
                }
                function getOwnerEncryptionKeyR5(processedOwnerPassword, ownerKeySalt, userPasswordEntry, encryptionKey) {
                    var key = _cryptoJs.default.SHA256(processedOwnerPassword.clone().concat(ownerKeySalt).concat(userPasswordEntry));
                    var options = {
                        mode: _cryptoJs.default.mode.CBC,
                        padding: _cryptoJs.default.pad.NoPadding,
                        iv: _cryptoJs.default.lib.WordArray.create(null, 16)
                    };
                    return _cryptoJs.default.AES.encrypt(encryptionKey, key, options).ciphertext;
                }
                function getEncryptionKeyR5(generateRandomWordArray) {
                    return generateRandomWordArray(32);
                }
                function getEncryptedPermissionsR5(permissions, encryptionKey, generateRandomWordArray) {
                    var cipher = _cryptoJs.default.lib.WordArray.create([
                        lsbFirstWord(permissions),
                        0xffffffff,
                        0x54616462
                    ], 12).concat(generateRandomWordArray(4));
                    var options = {
                        mode: _cryptoJs.default.mode.ECB,
                        padding: _cryptoJs.default.pad.NoPadding
                    };
                    return _cryptoJs.default.AES.encrypt(cipher, encryptionKey, options).ciphertext;
                }
                function processPasswordR2R3R4() {
                    var password = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                    var out = Buffer.alloc(32);
                    var length = password.length;
                    var index = 0;
                    while(index < length && index < 32){
                        var code = password.charCodeAt(index);
                        if (code > 0xff) throw new Error('Password contains one or more invalid characters.');
                        out[index] = code;
                        index++;
                    }
                    while(index < 32){
                        out[index] = PASSWORD_PADDING[index - length];
                        index++;
                    }
                    return _cryptoJs.default.lib.WordArray.create(out);
                }
                function processPasswordR5() {
                    var password = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                    password = unescape(encodeURIComponent(saslprep(password)));
                    var length = Math.min(127, password.length);
                    var out = Buffer.alloc(length);
                    for(var i = 0; i < length; i++)out[i] = password.charCodeAt(i);
                    return _cryptoJs.default.lib.WordArray.create(out);
                }
                function lsbFirstWord(data) {
                    return (data & 0xff) << 24 | (data & 0xff00) << 8 | data >> 8 & 0xff00 | data >> 24 & 0xff;
                }
                function wordArrayToBuffer(wordArray) {
                    var byteArray = [];
                    for(var i = 0; i < wordArray.sigBytes; i++)byteArray.push(wordArray.words[Math.floor(i / 4)] >> 8 * (3 - i % 4) & 0xff);
                    return Buffer.from(byteArray);
                }
                var PASSWORD_PADDING = [
                    0x28,
                    0xbf,
                    0x4e,
                    0x5e,
                    0x4e,
                    0x75,
                    0x8a,
                    0x41,
                    0x64,
                    0x00,
                    0x4e,
                    0x56,
                    0xff,
                    0xfa,
                    0x01,
                    0x08,
                    0x2e,
                    0x2e,
                    0x00,
                    0xb6,
                    0xd0,
                    0x68,
                    0x3e,
                    0x80,
                    0x2f,
                    0x0c,
                    0xa9,
                    0xfe,
                    0x64,
                    0x53,
                    0x69,
                    0x7a
                ];
                var number = PDFObject.number;
                var PDFGradient = /*#__PURE__*/ function() {
                    function PDFGradient(doc) {
                        this.doc = doc;
                        this.stops = [];
                        this.embedded = false;
                        this.transform = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                    }
                    var _proto8 = PDFGradient.prototype;
                    _proto8.stop = function stop(pos, color, opacity) {
                        if (opacity == null) opacity = 1;
                        color = this.doc._normalizeColor(color);
                        if (this.stops.length === 0) {
                            if (color.length === 3) this._colorSpace = 'DeviceRGB';
                            else if (color.length === 4) this._colorSpace = 'DeviceCMYK';
                            else if (color.length === 1) this._colorSpace = 'DeviceGray';
                            else throw new Error('Unknown color space');
                        } else if (this._colorSpace === 'DeviceRGB' && color.length !== 3 || this._colorSpace === 'DeviceCMYK' && color.length !== 4 || this._colorSpace === 'DeviceGray' && color.length !== 1) throw new Error('All gradient stops must use the same color space');
                        opacity = Math.max(0, Math.min(1, opacity));
                        this.stops.push([
                            pos,
                            color,
                            opacity
                        ]);
                        return this;
                    };
                    _proto8.setTransform = function setTransform(m11, m12, m21, m22, dx, dy) {
                        this.transform = [
                            m11,
                            m12,
                            m21,
                            m22,
                            dx,
                            dy
                        ];
                        return this;
                    };
                    _proto8.embed = function embed(m) {
                        var fn;
                        var stopsLength = this.stops.length;
                        if (stopsLength === 0) return;
                        this.embedded = true;
                        this.matrix = m;
                        // if the last stop comes before 100%, add a copy at 100%
                        var last = this.stops[stopsLength - 1];
                        if (last[0] < 1) this.stops.push([
                            1,
                            last[1],
                            last[2]
                        ]);
                        var bounds = [];
                        var encode = [];
                        var stops = [];
                        for(var i = 0; i < stopsLength - 1; i++){
                            encode.push(0, 1);
                            if (i + 2 !== stopsLength) bounds.push(this.stops[i + 1][0]);
                            fn = this.doc.ref({
                                FunctionType: 2,
                                Domain: [
                                    0,
                                    1
                                ],
                                C0: this.stops[i + 0][1],
                                C1: this.stops[i + 1][1],
                                N: 1
                            });
                            stops.push(fn);
                            fn.end();
                        }
                        // if there are only two stops, we don't need a stitching function
                        if (stopsLength === 1) fn = stops[0];
                        else {
                            fn = this.doc.ref({
                                FunctionType: 3,
                                // stitching function
                                Domain: [
                                    0,
                                    1
                                ],
                                Functions: stops,
                                Bounds: bounds,
                                Encode: encode
                            });
                            fn.end();
                        }
                        this.id = "Sh" + ++this.doc._gradCount;
                        var shader = this.shader(fn);
                        shader.end();
                        var pattern = this.doc.ref({
                            Type: 'Pattern',
                            PatternType: 2,
                            Shading: shader,
                            Matrix: this.matrix.map(number)
                        });
                        pattern.end();
                        if (this.stops.some(function(stop) {
                            return stop[2] < 1;
                        })) {
                            var grad = this.opacityGradient();
                            grad._colorSpace = 'DeviceGray';
                            for(var _iterator2 = _createForOfIteratorHelperLoose(this.stops), _step2; !(_step2 = _iterator2()).done;){
                                var stop = _step2.value;
                                grad.stop(stop[0], [
                                    stop[2]
                                ]);
                            }
                            grad = grad.embed(this.matrix);
                            var pageBBox = [
                                0,
                                0,
                                this.doc.page.width,
                                this.doc.page.height
                            ];
                            var form = this.doc.ref({
                                Type: 'XObject',
                                Subtype: 'Form',
                                FormType: 1,
                                BBox: pageBBox,
                                Group: {
                                    Type: 'Group',
                                    S: 'Transparency',
                                    CS: 'DeviceGray'
                                },
                                Resources: {
                                    ProcSet: [
                                        'PDF',
                                        'Text',
                                        'ImageB',
                                        'ImageC',
                                        'ImageI'
                                    ],
                                    Pattern: {
                                        Sh1: grad
                                    }
                                }
                            });
                            form.write('/Pattern cs /Sh1 scn');
                            form.end(pageBBox.join(' ') + " re f");
                            var gstate = this.doc.ref({
                                Type: 'ExtGState',
                                SMask: {
                                    Type: 'Mask',
                                    S: 'Luminosity',
                                    G: form
                                }
                            });
                            gstate.end();
                            var opacityPattern = this.doc.ref({
                                Type: 'Pattern',
                                PatternType: 1,
                                PaintType: 1,
                                TilingType: 2,
                                BBox: pageBBox,
                                XStep: pageBBox[2],
                                YStep: pageBBox[3],
                                Resources: {
                                    ProcSet: [
                                        'PDF',
                                        'Text',
                                        'ImageB',
                                        'ImageC',
                                        'ImageI'
                                    ],
                                    Pattern: {
                                        Sh1: pattern
                                    },
                                    ExtGState: {
                                        Gs1: gstate
                                    }
                                }
                            });
                            opacityPattern.write('/Gs1 gs /Pattern cs /Sh1 scn');
                            opacityPattern.end(pageBBox.join(' ') + " re f");
                            this.doc.page.patterns[this.id] = opacityPattern;
                        } else this.doc.page.patterns[this.id] = pattern;
                        return pattern;
                    };
                    _proto8.apply = function apply(stroke) {
                        // apply gradient transform to existing document ctm
                        var _this$doc$_ctm = this.doc._ctm, m0 = _this$doc$_ctm[0], m1 = _this$doc$_ctm[1], m2 = _this$doc$_ctm[2], m3 = _this$doc$_ctm[3], m4 = _this$doc$_ctm[4], m5 = _this$doc$_ctm[5];
                        var _this$transform = this.transform, m11 = _this$transform[0], m12 = _this$transform[1], m21 = _this$transform[2], m22 = _this$transform[3], dx = _this$transform[4], dy = _this$transform[5];
                        var m = [
                            m0 * m11 + m2 * m12,
                            m1 * m11 + m3 * m12,
                            m0 * m21 + m2 * m22,
                            m1 * m21 + m3 * m22,
                            m0 * dx + m2 * dy + m4,
                            m1 * dx + m3 * dy + m5
                        ];
                        if (!this.embedded || m.join(' ') !== this.matrix.join(' ')) this.embed(m);
                        this.doc._setColorSpace('Pattern', stroke);
                        var op = stroke ? 'SCN' : 'scn';
                        return this.doc.addContent("/" + this.id + " " + op);
                    };
                    return PDFGradient;
                }();
                var PDFLinearGradient = /*#__PURE__*/ function(_PDFGradient) {
                    function PDFLinearGradient(doc, x1, y1, x2, y2) {
                        var _this3;
                        _this3 = _PDFGradient.call(this, doc) || this;
                        _this3.x1 = x1;
                        _this3.y1 = y1;
                        _this3.x2 = x2;
                        _this3.y2 = y2;
                        return _this3;
                    }
                    _inheritsLoose(PDFLinearGradient, _PDFGradient);
                    var _proto9 = PDFLinearGradient.prototype;
                    _proto9.shader = function shader(fn) {
                        return this.doc.ref({
                            ShadingType: 2,
                            ColorSpace: this._colorSpace,
                            Coords: [
                                this.x1,
                                this.y1,
                                this.x2,
                                this.y2
                            ],
                            Function: fn,
                            Extend: [
                                true,
                                true
                            ]
                        });
                    };
                    _proto9.opacityGradient = function opacityGradient() {
                        return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
                    };
                    return PDFLinearGradient;
                }(PDFGradient);
                var PDFRadialGradient = /*#__PURE__*/ function(_PDFGradient2) {
                    function PDFRadialGradient(doc, x1, y1, r1, x2, y2, r2) {
                        var _this4;
                        _this4 = _PDFGradient2.call(this, doc) || this;
                        _this4.doc = doc;
                        _this4.x1 = x1;
                        _this4.y1 = y1;
                        _this4.r1 = r1;
                        _this4.x2 = x2;
                        _this4.y2 = y2;
                        _this4.r2 = r2;
                        return _this4;
                    }
                    _inheritsLoose(PDFRadialGradient, _PDFGradient2);
                    var _proto0 = PDFRadialGradient.prototype;
                    _proto0.shader = function shader(fn) {
                        return this.doc.ref({
                            ShadingType: 3,
                            ColorSpace: this._colorSpace,
                            Coords: [
                                this.x1,
                                this.y1,
                                this.r1,
                                this.x2,
                                this.y2,
                                this.r2
                            ],
                            Function: fn,
                            Extend: [
                                true,
                                true
                            ]
                        });
                    };
                    _proto0.opacityGradient = function opacityGradient() {
                        return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
                    };
                    return PDFRadialGradient;
                }(PDFGradient);
                var Gradient = {
                    PDFGradient: PDFGradient,
                    PDFLinearGradient: PDFLinearGradient,
                    PDFRadialGradient: PDFRadialGradient
                };
                /*
PDF tiling pattern support. Uncolored only.
 */ var underlyingColorSpaces = [
                    'DeviceCMYK',
                    'DeviceRGB'
                ];
                var PDFTilingPattern = /*#__PURE__*/ function() {
                    function PDFTilingPattern(doc, bBox, xStep, yStep, stream) {
                        this.doc = doc;
                        this.bBox = bBox;
                        this.xStep = xStep;
                        this.yStep = yStep;
                        this.stream = stream;
                    }
                    var _proto1 = PDFTilingPattern.prototype;
                    _proto1.createPattern = function createPattern() {
                        // no resources needed for our current usage
                        // required entry
                        var resources = this.doc.ref();
                        resources.end();
                        // apply default transform matrix (flipped in the default doc._ctm)
                        // see document.js & gradient.js
                        var _this$doc$_ctm2 = this.doc._ctm, m0 = _this$doc$_ctm2[0], m1 = _this$doc$_ctm2[1], m2 = _this$doc$_ctm2[2], m3 = _this$doc$_ctm2[3], m4 = _this$doc$_ctm2[4], m5 = _this$doc$_ctm2[5];
                        var m11 = 1, m12 = 0, m21 = 0, m22 = 1, dx = 0, dy = 0;
                        var m = [
                            m0 * m11 + m2 * m12,
                            m1 * m11 + m3 * m12,
                            m0 * m21 + m2 * m22,
                            m1 * m21 + m3 * m22,
                            m0 * dx + m2 * dy + m4,
                            m1 * dx + m3 * dy + m5
                        ];
                        var pattern = this.doc.ref({
                            Type: 'Pattern',
                            PatternType: 1,
                            // tiling
                            PaintType: 2,
                            // 1-colored, 2-uncolored
                            TilingType: 2,
                            // 2-no distortion
                            BBox: this.bBox,
                            XStep: this.xStep,
                            YStep: this.yStep,
                            Matrix: m.map(function(v) {
                                return +v.toFixed(5);
                            }),
                            Resources: resources
                        });
                        pattern.end(this.stream);
                        return pattern;
                    };
                    _proto1.embedPatternColorSpaces = function embedPatternColorSpaces() {
                        var _this5 = this;
                        // map each pattern to an underlying color space
                        // and embed on each page
                        underlyingColorSpaces.forEach(function(csName) {
                            var csId = _this5.getPatternColorSpaceId(csName);
                            if (_this5.doc.page.colorSpaces[csId]) return;
                            var cs = _this5.doc.ref([
                                'Pattern',
                                csName
                            ]);
                            cs.end();
                            _this5.doc.page.colorSpaces[csId] = cs;
                        });
                    };
                    _proto1.getPatternColorSpaceId = function getPatternColorSpaceId(underlyingColorspace) {
                        return "CsP" + underlyingColorspace;
                    };
                    _proto1.embed = function embed() {
                        if (!this.id) {
                            this.doc._patternCount = this.doc._patternCount + 1;
                            this.id = 'P' + this.doc._patternCount;
                            this.pattern = this.createPattern();
                        }
                        // patterns are embedded in each page
                        if (!this.doc.page.patterns[this.id]) this.doc.page.patterns[this.id] = this.pattern;
                    };
                    _proto1.apply = function apply(stroke, patternColor) {
                        // do any embedding/creating that might be needed
                        this.embedPatternColorSpaces();
                        this.embed();
                        var normalizedColor = this.doc._normalizeColor(patternColor);
                        if (!normalizedColor) throw Error("invalid pattern color. (value: " + patternColor + ")");
                        // select one of the pattern color spaces
                        var csId = this.getPatternColorSpaceId(this.doc._getColorSpace(normalizedColor));
                        this.doc._setColorSpace(csId, stroke);
                        // stroke/fill using the pattern and color (in the above underlying color space)
                        var op = stroke ? 'SCN' : 'scn';
                        return this.doc.addContent(normalizedColor.join(' ') + " /" + this.id + " " + op);
                    };
                    return PDFTilingPattern;
                }();
                var pattern = {
                    PDFTilingPattern: PDFTilingPattern
                };
                var PDFGradient$1 = Gradient.PDFGradient, PDFLinearGradient$1 = Gradient.PDFLinearGradient, PDFRadialGradient$1 = Gradient.PDFRadialGradient;
                var PDFTilingPattern$1 = pattern.PDFTilingPattern;
                var ColorMixin = {
                    initColor: function initColor() {
                        this.spotColors = {};
                        // The opacity dictionaries
                        this._opacityRegistry = {};
                        this._opacityCount = 0;
                        this._patternCount = 0;
                        return this._gradCount = 0;
                    },
                    _normalizeColor: function _normalizeColor(color) {
                        if (typeof color === 'string') {
                            if (color.charAt(0) === '#') {
                                if (color.length === 4) color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, '#$1$1$2$2$3$3');
                                var hex = parseInt(color.slice(1), 16);
                                color = [
                                    hex >> 16,
                                    hex >> 8 & 0xff,
                                    hex & 0xff
                                ];
                            } else if (namedColors[color]) color = namedColors[color];
                            else if (this.spotColors[color]) return this.spotColors[color];
                        }
                        if (Array.isArray(color)) {
                            // RGB
                            if (color.length === 3) color = color.map(function(part) {
                                return part / 255;
                            });
                            else if (color.length === 4) color = color.map(function(part) {
                                return part / 100;
                            });
                            return color;
                        }
                        return null;
                    },
                    _setColor: function _setColor(color, stroke) {
                        if (color instanceof PDFGradient$1) {
                            color.apply(stroke);
                            return true;
                        // see if tiling pattern, decode & apply it it
                        } else if (Array.isArray(color) && color[0] instanceof PDFTilingPattern$1) {
                            color[0].apply(stroke, color[1]);
                            return true;
                        }
                        // any other case should be a normal color and not a pattern
                        return this._setColorCore(color, stroke);
                    },
                    _setColorCore: function _setColorCore(color, stroke) {
                        color = this._normalizeColor(color);
                        if (!color) return false;
                        var op = stroke ? 'SCN' : 'scn';
                        var space = this._getColorSpace(color);
                        this._setColorSpace(space, stroke);
                        if (color instanceof SpotColor) {
                            this.page.colorSpaces[color.id] = color.ref;
                            this.addContent("1 " + op);
                        } else this.addContent(color.join(' ') + " " + op);
                        return true;
                    },
                    _setColorSpace: function _setColorSpace(space, stroke) {
                        var op = stroke ? 'CS' : 'cs';
                        return this.addContent("/" + space + " " + op);
                    },
                    _getColorSpace: function _getColorSpace(color) {
                        if (color instanceof SpotColor) return color.id;
                        return color.length === 4 ? 'DeviceCMYK' : 'DeviceRGB';
                    },
                    fillColor: function fillColor(color, opacity) {
                        var set = this._setColor(color, false);
                        if (set) this.fillOpacity(opacity);
                        // save this for text wrapper, which needs to reset
                        // the fill color on new pages
                        this._fillColor = [
                            color,
                            opacity
                        ];
                        return this;
                    },
                    strokeColor: function strokeColor(color, opacity) {
                        var set = this._setColor(color, true);
                        if (set) this.strokeOpacity(opacity);
                        return this;
                    },
                    opacity: function opacity(_opacity) {
                        this._doOpacity(_opacity, _opacity);
                        return this;
                    },
                    fillOpacity: function fillOpacity(opacity) {
                        this._doOpacity(opacity, null);
                        return this;
                    },
                    strokeOpacity: function strokeOpacity(opacity) {
                        this._doOpacity(null, opacity);
                        return this;
                    },
                    _doOpacity: function _doOpacity(fillOpacity, strokeOpacity) {
                        var dictionary, name;
                        if (fillOpacity == null && strokeOpacity == null) return;
                        if (fillOpacity != null) fillOpacity = Math.max(0, Math.min(1, fillOpacity));
                        if (strokeOpacity != null) strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
                        var key = fillOpacity + "_" + strokeOpacity;
                        if (this._opacityRegistry[key]) {
                            var _this$_opacityRegistr = this._opacityRegistry[key];
                            dictionary = _this$_opacityRegistr[0];
                            name = _this$_opacityRegistr[1];
                        } else {
                            dictionary = {
                                Type: 'ExtGState'
                            };
                            if (fillOpacity != null) dictionary.ca = fillOpacity;
                            if (strokeOpacity != null) dictionary.CA = strokeOpacity;
                            dictionary = this.ref(dictionary);
                            dictionary.end();
                            var id = ++this._opacityCount;
                            name = "Gs" + id;
                            this._opacityRegistry[key] = [
                                dictionary,
                                name
                            ];
                        }
                        this.page.ext_gstates[name] = dictionary;
                        return this.addContent("/" + name + " gs");
                    },
                    linearGradient: function linearGradient(x1, y1, x2, y2) {
                        return new PDFLinearGradient$1(this, x1, y1, x2, y2);
                    },
                    radialGradient: function radialGradient(x1, y1, r1, x2, y2, r2) {
                        return new PDFRadialGradient$1(this, x1, y1, r1, x2, y2, r2);
                    },
                    pattern: function pattern(bbox, xStep, yStep, stream) {
                        return new PDFTilingPattern$1(this, bbox, xStep, yStep, stream);
                    },
                    addSpotColor: function addSpotColor(name, C, M, Y, K) {
                        var color = new SpotColor(this, name, C, M, Y, K);
                        this.spotColors[name] = color;
                        return this;
                    }
                };
                var namedColors = {
                    aliceblue: [
                        240,
                        248,
                        255
                    ],
                    antiquewhite: [
                        250,
                        235,
                        215
                    ],
                    aqua: [
                        0,
                        255,
                        255
                    ],
                    aquamarine: [
                        127,
                        255,
                        212
                    ],
                    azure: [
                        240,
                        255,
                        255
                    ],
                    beige: [
                        245,
                        245,
                        220
                    ],
                    bisque: [
                        255,
                        228,
                        196
                    ],
                    black: [
                        0,
                        0,
                        0
                    ],
                    blanchedalmond: [
                        255,
                        235,
                        205
                    ],
                    blue: [
                        0,
                        0,
                        255
                    ],
                    blueviolet: [
                        138,
                        43,
                        226
                    ],
                    brown: [
                        165,
                        42,
                        42
                    ],
                    burlywood: [
                        222,
                        184,
                        135
                    ],
                    cadetblue: [
                        95,
                        158,
                        160
                    ],
                    chartreuse: [
                        127,
                        255,
                        0
                    ],
                    chocolate: [
                        210,
                        105,
                        30
                    ],
                    coral: [
                        255,
                        127,
                        80
                    ],
                    cornflowerblue: [
                        100,
                        149,
                        237
                    ],
                    cornsilk: [
                        255,
                        248,
                        220
                    ],
                    crimson: [
                        220,
                        20,
                        60
                    ],
                    cyan: [
                        0,
                        255,
                        255
                    ],
                    darkblue: [
                        0,
                        0,
                        139
                    ],
                    darkcyan: [
                        0,
                        139,
                        139
                    ],
                    darkgoldenrod: [
                        184,
                        134,
                        11
                    ],
                    darkgray: [
                        169,
                        169,
                        169
                    ],
                    darkgreen: [
                        0,
                        100,
                        0
                    ],
                    darkgrey: [
                        169,
                        169,
                        169
                    ],
                    darkkhaki: [
                        189,
                        183,
                        107
                    ],
                    darkmagenta: [
                        139,
                        0,
                        139
                    ],
                    darkolivegreen: [
                        85,
                        107,
                        47
                    ],
                    darkorange: [
                        255,
                        140,
                        0
                    ],
                    darkorchid: [
                        153,
                        50,
                        204
                    ],
                    darkred: [
                        139,
                        0,
                        0
                    ],
                    darksalmon: [
                        233,
                        150,
                        122
                    ],
                    darkseagreen: [
                        143,
                        188,
                        143
                    ],
                    darkslateblue: [
                        72,
                        61,
                        139
                    ],
                    darkslategray: [
                        47,
                        79,
                        79
                    ],
                    darkslategrey: [
                        47,
                        79,
                        79
                    ],
                    darkturquoise: [
                        0,
                        206,
                        209
                    ],
                    darkviolet: [
                        148,
                        0,
                        211
                    ],
                    deeppink: [
                        255,
                        20,
                        147
                    ],
                    deepskyblue: [
                        0,
                        191,
                        255
                    ],
                    dimgray: [
                        105,
                        105,
                        105
                    ],
                    dimgrey: [
                        105,
                        105,
                        105
                    ],
                    dodgerblue: [
                        30,
                        144,
                        255
                    ],
                    firebrick: [
                        178,
                        34,
                        34
                    ],
                    floralwhite: [
                        255,
                        250,
                        240
                    ],
                    forestgreen: [
                        34,
                        139,
                        34
                    ],
                    fuchsia: [
                        255,
                        0,
                        255
                    ],
                    gainsboro: [
                        220,
                        220,
                        220
                    ],
                    ghostwhite: [
                        248,
                        248,
                        255
                    ],
                    gold: [
                        255,
                        215,
                        0
                    ],
                    goldenrod: [
                        218,
                        165,
                        32
                    ],
                    gray: [
                        128,
                        128,
                        128
                    ],
                    grey: [
                        128,
                        128,
                        128
                    ],
                    green: [
                        0,
                        128,
                        0
                    ],
                    greenyellow: [
                        173,
                        255,
                        47
                    ],
                    honeydew: [
                        240,
                        255,
                        240
                    ],
                    hotpink: [
                        255,
                        105,
                        180
                    ],
                    indianred: [
                        205,
                        92,
                        92
                    ],
                    indigo: [
                        75,
                        0,
                        130
                    ],
                    ivory: [
                        255,
                        255,
                        240
                    ],
                    khaki: [
                        240,
                        230,
                        140
                    ],
                    lavender: [
                        230,
                        230,
                        250
                    ],
                    lavenderblush: [
                        255,
                        240,
                        245
                    ],
                    lawngreen: [
                        124,
                        252,
                        0
                    ],
                    lemonchiffon: [
                        255,
                        250,
                        205
                    ],
                    lightblue: [
                        173,
                        216,
                        230
                    ],
                    lightcoral: [
                        240,
                        128,
                        128
                    ],
                    lightcyan: [
                        224,
                        255,
                        255
                    ],
                    lightgoldenrodyellow: [
                        250,
                        250,
                        210
                    ],
                    lightgray: [
                        211,
                        211,
                        211
                    ],
                    lightgreen: [
                        144,
                        238,
                        144
                    ],
                    lightgrey: [
                        211,
                        211,
                        211
                    ],
                    lightpink: [
                        255,
                        182,
                        193
                    ],
                    lightsalmon: [
                        255,
                        160,
                        122
                    ],
                    lightseagreen: [
                        32,
                        178,
                        170
                    ],
                    lightskyblue: [
                        135,
                        206,
                        250
                    ],
                    lightslategray: [
                        119,
                        136,
                        153
                    ],
                    lightslategrey: [
                        119,
                        136,
                        153
                    ],
                    lightsteelblue: [
                        176,
                        196,
                        222
                    ],
                    lightyellow: [
                        255,
                        255,
                        224
                    ],
                    lime: [
                        0,
                        255,
                        0
                    ],
                    limegreen: [
                        50,
                        205,
                        50
                    ],
                    linen: [
                        250,
                        240,
                        230
                    ],
                    magenta: [
                        255,
                        0,
                        255
                    ],
                    maroon: [
                        128,
                        0,
                        0
                    ],
                    mediumaquamarine: [
                        102,
                        205,
                        170
                    ],
                    mediumblue: [
                        0,
                        0,
                        205
                    ],
                    mediumorchid: [
                        186,
                        85,
                        211
                    ],
                    mediumpurple: [
                        147,
                        112,
                        219
                    ],
                    mediumseagreen: [
                        60,
                        179,
                        113
                    ],
                    mediumslateblue: [
                        123,
                        104,
                        238
                    ],
                    mediumspringgreen: [
                        0,
                        250,
                        154
                    ],
                    mediumturquoise: [
                        72,
                        209,
                        204
                    ],
                    mediumvioletred: [
                        199,
                        21,
                        133
                    ],
                    midnightblue: [
                        25,
                        25,
                        112
                    ],
                    mintcream: [
                        245,
                        255,
                        250
                    ],
                    mistyrose: [
                        255,
                        228,
                        225
                    ],
                    moccasin: [
                        255,
                        228,
                        181
                    ],
                    navajowhite: [
                        255,
                        222,
                        173
                    ],
                    navy: [
                        0,
                        0,
                        128
                    ],
                    oldlace: [
                        253,
                        245,
                        230
                    ],
                    olive: [
                        128,
                        128,
                        0
                    ],
                    olivedrab: [
                        107,
                        142,
                        35
                    ],
                    orange: [
                        255,
                        165,
                        0
                    ],
                    orangered: [
                        255,
                        69,
                        0
                    ],
                    orchid: [
                        218,
                        112,
                        214
                    ],
                    palegoldenrod: [
                        238,
                        232,
                        170
                    ],
                    palegreen: [
                        152,
                        251,
                        152
                    ],
                    paleturquoise: [
                        175,
                        238,
                        238
                    ],
                    palevioletred: [
                        219,
                        112,
                        147
                    ],
                    papayawhip: [
                        255,
                        239,
                        213
                    ],
                    peachpuff: [
                        255,
                        218,
                        185
                    ],
                    peru: [
                        205,
                        133,
                        63
                    ],
                    pink: [
                        255,
                        192,
                        203
                    ],
                    plum: [
                        221,
                        160,
                        221
                    ],
                    powderblue: [
                        176,
                        224,
                        230
                    ],
                    purple: [
                        128,
                        0,
                        128
                    ],
                    red: [
                        255,
                        0,
                        0
                    ],
                    rosybrown: [
                        188,
                        143,
                        143
                    ],
                    royalblue: [
                        65,
                        105,
                        225
                    ],
                    saddlebrown: [
                        139,
                        69,
                        19
                    ],
                    salmon: [
                        250,
                        128,
                        114
                    ],
                    sandybrown: [
                        244,
                        164,
                        96
                    ],
                    seagreen: [
                        46,
                        139,
                        87
                    ],
                    seashell: [
                        255,
                        245,
                        238
                    ],
                    sienna: [
                        160,
                        82,
                        45
                    ],
                    silver: [
                        192,
                        192,
                        192
                    ],
                    skyblue: [
                        135,
                        206,
                        235
                    ],
                    slateblue: [
                        106,
                        90,
                        205
                    ],
                    slategray: [
                        112,
                        128,
                        144
                    ],
                    slategrey: [
                        112,
                        128,
                        144
                    ],
                    snow: [
                        255,
                        250,
                        250
                    ],
                    springgreen: [
                        0,
                        255,
                        127
                    ],
                    steelblue: [
                        70,
                        130,
                        180
                    ],
                    tan: [
                        210,
                        180,
                        140
                    ],
                    teal: [
                        0,
                        128,
                        128
                    ],
                    thistle: [
                        216,
                        191,
                        216
                    ],
                    tomato: [
                        255,
                        99,
                        71
                    ],
                    turquoise: [
                        64,
                        224,
                        208
                    ],
                    violet: [
                        238,
                        130,
                        238
                    ],
                    wheat: [
                        245,
                        222,
                        179
                    ],
                    white: [
                        255,
                        255,
                        255
                    ],
                    whitesmoke: [
                        245,
                        245,
                        245
                    ],
                    yellow: [
                        255,
                        255,
                        0
                    ],
                    yellowgreen: [
                        154,
                        205,
                        50
                    ]
                };
                var cx, cy, px, py, sx, sy;
                cx = cy = px = py = sx = sy = 0;
                var parameters = {
                    A: 7,
                    a: 7,
                    C: 6,
                    c: 6,
                    H: 1,
                    h: 1,
                    L: 2,
                    l: 2,
                    M: 2,
                    m: 2,
                    Q: 4,
                    q: 4,
                    S: 4,
                    s: 4,
                    T: 2,
                    t: 2,
                    V: 1,
                    v: 1,
                    Z: 0,
                    z: 0
                };
                var parse = function parse(path) {
                    var cmd;
                    var ret = [];
                    var args = [];
                    var curArg = '';
                    var foundDecimal = false;
                    var params = 0;
                    for(var _iterator3 = _createForOfIteratorHelperLoose(path), _step3; !(_step3 = _iterator3()).done;){
                        var c = _step3.value;
                        if (parameters[c] != null) {
                            params = parameters[c];
                            if (cmd) {
                                // save existing command
                                if (curArg.length > 0) args[args.length] = +curArg;
                                ret[ret.length] = {
                                    cmd: cmd,
                                    args: args
                                };
                                args = [];
                                curArg = '';
                                foundDecimal = false;
                            }
                            cmd = c;
                        } else if ([
                            ' ',
                            ','
                        ].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
                            if (curArg.length === 0) continue;
                            if (args.length === params) {
                                // handle reused commands
                                ret[ret.length] = {
                                    cmd: cmd,
                                    args: args
                                };
                                args = [
                                    +curArg
                                ];
                                // handle assumed commands
                                if (cmd === 'M') cmd = 'L';
                                if (cmd === 'm') cmd = 'l';
                            } else args[args.length] = +curArg;
                            foundDecimal = c === '.';
                            // fix for negative numbers or repeated decimals with no delimeter between commands
                            curArg = [
                                '-',
                                '.'
                            ].includes(c) ? c : '';
                        } else {
                            curArg += c;
                            if (c === '.') foundDecimal = true;
                        }
                    }
                    // add the last command
                    if (curArg.length > 0) {
                        if (args.length === params) {
                            // handle reused commands
                            ret[ret.length] = {
                                cmd: cmd,
                                args: args
                            };
                            args = [
                                +curArg
                            ];
                            // handle assumed commands
                            if (cmd === 'M') cmd = 'L';
                            if (cmd === 'm') cmd = 'l';
                        } else args[args.length] = +curArg;
                    }
                    ret[ret.length] = {
                        cmd: cmd,
                        args: args
                    };
                    return ret;
                };
                var _apply = function apply(commands, doc) {
                    // current point, control point, and subpath starting point
                    cx = cy = px = py = sx = sy = 0;
                    // run the commands
                    for(var i = 0; i < commands.length; i++){
                        var c = commands[i];
                        if (typeof runners[c.cmd] === 'function') runners[c.cmd](doc, c.args);
                    }
                };
                var runners = {
                    M: function M(doc, a) {
                        cx = a[0];
                        cy = a[1];
                        px = py = null;
                        sx = cx;
                        sy = cy;
                        return doc.moveTo(cx, cy);
                    },
                    m: function m(doc, a) {
                        cx += a[0];
                        cy += a[1];
                        px = py = null;
                        sx = cx;
                        sy = cy;
                        return doc.moveTo(cx, cy);
                    },
                    C: function C(doc, a) {
                        cx = a[4];
                        cy = a[5];
                        px = a[2];
                        py = a[3];
                        return doc.bezierCurveTo.apply(doc, a);
                    },
                    c: function c(doc, a) {
                        doc.bezierCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
                        px = cx + a[2];
                        py = cy + a[3];
                        cx += a[4];
                        return cy += a[5];
                    },
                    S: function S(doc, a) {
                        if (px === null) {
                            px = cx;
                            py = cy;
                        }
                        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
                        px = a[0];
                        py = a[1];
                        cx = a[2];
                        return cy = a[3];
                    },
                    s: function s(doc, a) {
                        if (px === null) {
                            px = cx;
                            py = cy;
                        }
                        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
                        px = cx + a[0];
                        py = cy + a[1];
                        cx += a[2];
                        return cy += a[3];
                    },
                    Q: function Q(doc, a) {
                        px = a[0];
                        py = a[1];
                        cx = a[2];
                        cy = a[3];
                        return doc.quadraticCurveTo(a[0], a[1], cx, cy);
                    },
                    q: function q(doc, a) {
                        doc.quadraticCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
                        px = cx + a[0];
                        py = cy + a[1];
                        cx += a[2];
                        return cy += a[3];
                    },
                    T: function T(doc, a) {
                        if (px === null) {
                            px = cx;
                            py = cy;
                        } else {
                            px = cx - (px - cx);
                            py = cy - (py - cy);
                        }
                        doc.quadraticCurveTo(px, py, a[0], a[1]);
                        px = cx - (px - cx);
                        py = cy - (py - cy);
                        cx = a[0];
                        return cy = a[1];
                    },
                    t: function t(doc, a) {
                        if (px === null) {
                            px = cx;
                            py = cy;
                        } else {
                            px = cx - (px - cx);
                            py = cy - (py - cy);
                        }
                        doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
                        cx += a[0];
                        return cy += a[1];
                    },
                    A: function A(doc, a) {
                        solveArc(doc, cx, cy, a);
                        cx = a[5];
                        return cy = a[6];
                    },
                    a: function a(doc, _a) {
                        _a[5] += cx;
                        _a[6] += cy;
                        solveArc(doc, cx, cy, _a);
                        cx = _a[5];
                        return cy = _a[6];
                    },
                    L: function L(doc, a) {
                        cx = a[0];
                        cy = a[1];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    l: function l(doc, a) {
                        cx += a[0];
                        cy += a[1];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    H: function H(doc, a) {
                        cx = a[0];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    h: function h(doc, a) {
                        cx += a[0];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    V: function V(doc, a) {
                        cy = a[0];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    v: function v(doc, a) {
                        cy += a[0];
                        px = py = null;
                        return doc.lineTo(cx, cy);
                    },
                    Z: function Z(doc) {
                        doc.closePath();
                        cx = sx;
                        return cy = sy;
                    },
                    z: function z(doc) {
                        doc.closePath();
                        cx = sx;
                        return cy = sy;
                    }
                };
                var solveArc = function solveArc(doc, x, y, coords) {
                    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
                    var segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
                    for(var _iterator4 = _createForOfIteratorHelperLoose(segs), _step4; !(_step4 = _iterator4()).done;){
                        var seg = _step4.value;
                        var bez = segmentToBezier.apply(void 0, seg);
                        doc.bezierCurveTo.apply(doc, bez);
                    }
                };
                // from Inkscape svgtopdf, thanks!
                var arcToSegments = function arcToSegments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
                    var th = rotateX * (Math.PI / 180);
                    var sin_th = Math.sin(th);
                    var cos_th = Math.cos(th);
                    rx = Math.abs(rx);
                    ry = Math.abs(ry);
                    px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
                    py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
                    var pl = px * px / (rx * rx) + py * py / (ry * ry);
                    if (pl > 1) {
                        pl = Math.sqrt(pl);
                        rx *= pl;
                        ry *= pl;
                    }
                    var a00 = cos_th / rx;
                    var a01 = sin_th / rx;
                    var a10 = -sin_th / ry;
                    var a11 = cos_th / ry;
                    var x0 = a00 * ox + a01 * oy;
                    var y0 = a10 * ox + a11 * oy;
                    var x1 = a00 * x + a01 * y;
                    var y1 = a10 * x + a11 * y;
                    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
                    var sfactor_sq = 1 / d - 0.25;
                    if (sfactor_sq < 0) sfactor_sq = 0;
                    var sfactor = Math.sqrt(sfactor_sq);
                    if (sweep === large) sfactor = -sfactor;
                    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
                    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
                    var th0 = Math.atan2(y0 - yc, x0 - xc);
                    var th1 = Math.atan2(y1 - yc, x1 - xc);
                    var th_arc = th1 - th0;
                    if (th_arc < 0 && sweep === 1) th_arc += 2 * Math.PI;
                    else if (th_arc > 0 && sweep === 0) th_arc -= 2 * Math.PI;
                    var segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
                    var result = [];
                    for(var i = 0; i < segments; i++){
                        var th2 = th0 + i * th_arc / segments;
                        var th3 = th0 + (i + 1) * th_arc / segments;
                        result[i] = [
                            xc,
                            yc,
                            th2,
                            th3,
                            rx,
                            ry,
                            sin_th,
                            cos_th
                        ];
                    }
                    return result;
                };
                var segmentToBezier = function segmentToBezier(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
                    var a00 = cos_th * rx;
                    var a01 = -sin_th * ry;
                    var a10 = sin_th * rx;
                    var a11 = cos_th * ry;
                    var th_half = 0.5 * (th1 - th0);
                    var t = 8 / 3 * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
                    var x1 = cx + Math.cos(th0) - t * Math.sin(th0);
                    var y1 = cy + Math.sin(th0) + t * Math.cos(th0);
                    var x3 = cx + Math.cos(th1);
                    var y3 = cy + Math.sin(th1);
                    var x2 = x3 + t * Math.sin(th1);
                    var y2 = y3 - t * Math.cos(th1);
                    return [
                        a00 * x1 + a01 * y1,
                        a10 * x1 + a11 * y1,
                        a00 * x2 + a01 * y2,
                        a10 * x2 + a11 * y2,
                        a00 * x3 + a01 * y3,
                        a10 * x3 + a11 * y3
                    ];
                };
                var SVGPath = /*#__PURE__*/ function() {
                    function SVGPath() {}
                    SVGPath.apply = function apply(doc, path) {
                        var commands = parse(path);
                        _apply(commands, doc);
                    };
                    return SVGPath;
                }();
                var number$1 = PDFObject.number;
                // This constant is used to approximate a symmetrical arc using a cubic
                // Bezier curve.
                var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
                var VectorMixin = {
                    initVector: function initVector() {
                        this._ctm = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ]; // current transformation matrix
                        return this._ctmStack = [];
                    },
                    save: function save() {
                        this._ctmStack.push(this._ctm.slice());
                        // TODO: save/restore colorspace and styles so not setting it unnessesarily all the time?
                        return this.addContent('q');
                    },
                    restore: function restore() {
                        this._ctm = this._ctmStack.pop() || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        return this.addContent('Q');
                    },
                    closePath: function closePath() {
                        return this.addContent('h');
                    },
                    lineWidth: function lineWidth(w) {
                        return this.addContent(number$1(w) + " w");
                    },
                    _CAP_STYLES: {
                        BUTT: 0,
                        ROUND: 1,
                        SQUARE: 2
                    },
                    lineCap: function lineCap(c) {
                        if (typeof c === 'string') c = this._CAP_STYLES[c.toUpperCase()];
                        return this.addContent(c + " J");
                    },
                    _JOIN_STYLES: {
                        MITER: 0,
                        ROUND: 1,
                        BEVEL: 2
                    },
                    lineJoin: function lineJoin(j) {
                        if (typeof j === 'string') j = this._JOIN_STYLES[j.toUpperCase()];
                        return this.addContent(j + " j");
                    },
                    miterLimit: function miterLimit(m) {
                        return this.addContent(number$1(m) + " M");
                    },
                    dash: function dash(length) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var originalLength = length;
                        if (!Array.isArray(length)) length = [
                            length,
                            options.space || length
                        ];
                        var valid = length.every(function(x) {
                            return Number.isFinite(x) && x > 0;
                        });
                        if (!valid) throw new Error("dash(" + JSON.stringify(originalLength) + ", " + JSON.stringify(options) + ") invalid, lengths must be numeric and greater than zero");
                        length = length.map(number$1).join(' ');
                        return this.addContent("[" + length + "] " + number$1(options.phase || 0) + " d");
                    },
                    undash: function undash() {
                        return this.addContent('[] 0 d');
                    },
                    moveTo: function moveTo(x, y) {
                        return this.addContent(number$1(x) + " " + number$1(y) + " m");
                    },
                    lineTo: function lineTo(x, y) {
                        return this.addContent(number$1(x) + " " + number$1(y) + " l");
                    },
                    bezierCurveTo: function bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
                        return this.addContent(number$1(cp1x) + " " + number$1(cp1y) + " " + number$1(cp2x) + " " + number$1(cp2y) + " " + number$1(x) + " " + number$1(y) + " c");
                    },
                    quadraticCurveTo: function quadraticCurveTo(cpx, cpy, x, y) {
                        return this.addContent(number$1(cpx) + " " + number$1(cpy) + " " + number$1(x) + " " + number$1(y) + " v");
                    },
                    rect: function rect(x, y, w, h) {
                        return this.addContent(number$1(x) + " " + number$1(y) + " " + number$1(w) + " " + number$1(h) + " re");
                    },
                    roundedRect: function roundedRect(x, y, w, h, r) {
                        if (r == null) r = 0;
                        r = Math.min(r, 0.5 * w, 0.5 * h);
                        // amount to inset control points from corners (see `ellipse`)
                        var c = r * (1.0 - KAPPA);
                        this.moveTo(x + r, y);
                        this.lineTo(x + w - r, y);
                        this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
                        this.lineTo(x + w, y + h - r);
                        this.bezierCurveTo(x + w, y + h - c, x + w - c, y + h, x + w - r, y + h);
                        this.lineTo(x + r, y + h);
                        this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
                        this.lineTo(x, y + r);
                        this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
                        return this.closePath();
                    },
                    ellipse: function ellipse(x, y, r1, r2) {
                        // based on http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas/2173084#2173084
                        if (r2 == null) r2 = r1;
                        x -= r1;
                        y -= r2;
                        var ox = r1 * KAPPA;
                        var oy = r2 * KAPPA;
                        var xe = x + r1 * 2;
                        var ye = y + r2 * 2;
                        var xm = x + r1;
                        var ym = y + r2;
                        this.moveTo(x, ym);
                        this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
                        this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
                        this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
                        this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
                        return this.closePath();
                    },
                    circle: function circle(x, y, radius) {
                        return this.ellipse(x, y, radius);
                    },
                    arc: function arc(x, y, radius, startAngle, endAngle, anticlockwise) {
                        if (anticlockwise == null) anticlockwise = false;
                        var TWO_PI = 2.0 * Math.PI;
                        var HALF_PI = 0.5 * Math.PI;
                        var deltaAng = endAngle - startAngle;
                        if (Math.abs(deltaAng) > TWO_PI) // draw only full circle if more than that is specified
                        deltaAng = TWO_PI;
                        else if (deltaAng !== 0 && anticlockwise !== deltaAng < 0) {
                            // necessary to flip direction of rendering
                            var dir = anticlockwise ? -1 : 1;
                            deltaAng = dir * TWO_PI + deltaAng;
                        }
                        var numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
                        var segAng = deltaAng / numSegs;
                        var handleLen = segAng / HALF_PI * KAPPA * radius;
                        var curAng = startAngle;
                        // component distances between anchor point and control point
                        var deltaCx = -Math.sin(curAng) * handleLen;
                        var deltaCy = Math.cos(curAng) * handleLen;
                        // anchor point
                        var ax = x + Math.cos(curAng) * radius;
                        var ay = y + Math.sin(curAng) * radius;
                        // calculate and render segments
                        this.moveTo(ax, ay);
                        for(var segIdx = 0; segIdx < numSegs; segIdx++){
                            // starting control point
                            var cp1x = ax + deltaCx;
                            var cp1y = ay + deltaCy;
                            // step angle
                            curAng += segAng;
                            // next anchor point
                            ax = x + Math.cos(curAng) * radius;
                            ay = y + Math.sin(curAng) * radius;
                            // next control point delta
                            deltaCx = -Math.sin(curAng) * handleLen;
                            deltaCy = Math.cos(curAng) * handleLen;
                            // ending control point
                            var cp2x = ax - deltaCx;
                            var cp2y = ay - deltaCy;
                            // render segment
                            this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
                        }
                        return this;
                    },
                    polygon: function polygon() {
                        for(var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++)points[_key] = arguments[_key];
                        this.moveTo.apply(this, points.shift() || []);
                        for(var _i3 = 0, _points = points; _i3 < _points.length; _i3++){
                            var point = _points[_i3];
                            this.lineTo.apply(this, point || []);
                        }
                        return this.closePath();
                    },
                    path: function path(_path) {
                        SVGPath.apply(this, _path);
                        return this;
                    },
                    _windingRule: function _windingRule(rule) {
                        if (/even-?odd/.test(rule)) return '*';
                        return '';
                    },
                    fill: function fill(color, rule) {
                        if (/(even-?odd)|(non-?zero)/.test(color)) {
                            rule = color;
                            color = null;
                        }
                        if (color) this.fillColor(color);
                        return this.addContent("f" + this._windingRule(rule));
                    },
                    stroke: function stroke(color) {
                        if (color) this.strokeColor(color);
                        return this.addContent('S');
                    },
                    fillAndStroke: function fillAndStroke(fillColor, strokeColor, rule) {
                        if (strokeColor == null) strokeColor = fillColor;
                        var isFillRule = /(even-?odd)|(non-?zero)/;
                        if (isFillRule.test(fillColor)) {
                            rule = fillColor;
                            fillColor = null;
                        }
                        if (isFillRule.test(strokeColor)) {
                            rule = strokeColor;
                            strokeColor = fillColor;
                        }
                        if (fillColor) {
                            this.fillColor(fillColor);
                            this.strokeColor(strokeColor);
                        }
                        return this.addContent("B" + this._windingRule(rule));
                    },
                    clip: function clip(rule) {
                        return this.addContent("W" + this._windingRule(rule) + " n");
                    },
                    transform: function transform(m11, m12, m21, m22, dx, dy) {
                        // keep track of the current transformation matrix
                        if (m11 === 1 && m12 === 0 && m21 === 0 && m22 === 1 && dx === 0 && dy === 0) // Ignore identity transforms
                        return this;
                        var m = this._ctm;
                        var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], m4 = m[4], m5 = m[5];
                        m[0] = m0 * m11 + m2 * m12;
                        m[1] = m1 * m11 + m3 * m12;
                        m[2] = m0 * m21 + m2 * m22;
                        m[3] = m1 * m21 + m3 * m22;
                        m[4] = m0 * dx + m2 * dy + m4;
                        m[5] = m1 * dx + m3 * dy + m5;
                        var values = [
                            m11,
                            m12,
                            m21,
                            m22,
                            dx,
                            dy
                        ].map(function(v) {
                            return number$1(v);
                        }).join(' ');
                        return this.addContent(values + " cm");
                    },
                    translate: function translate(x, y) {
                        return this.transform(1, 0, 0, 1, x, y);
                    },
                    rotate: function rotate(angle) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var y;
                        var rad = angle * Math.PI / 180;
                        var cos = Math.cos(rad);
                        var sin = Math.sin(rad);
                        var x = y = 0;
                        if (options.origin != null) {
                            var _options$origin = options.origin;
                            x = _options$origin[0];
                            y = _options$origin[1];
                            var x1 = x * cos - y * sin;
                            var y1 = x * sin + y * cos;
                            x -= x1;
                            y -= y1;
                        }
                        return this.transform(cos, sin, -sin, cos, x, y);
                    },
                    scale: function scale(xFactor, yFactor) {
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var y;
                        if (yFactor == null) yFactor = xFactor;
                        if (typeof yFactor === 'object') {
                            options = yFactor;
                            yFactor = xFactor;
                        }
                        var x = y = 0;
                        if (options.origin != null) {
                            var _options$origin2 = options.origin;
                            x = _options$origin2[0];
                            y = _options$origin2[1];
                            x -= xFactor * x;
                            y -= yFactor * y;
                        }
                        return this.transform(xFactor, 0, 0, yFactor, x, y);
                    }
                };
                var WIN_ANSI_MAP = {
                    402: 131,
                    8211: 150,
                    8212: 151,
                    8216: 145,
                    8217: 146,
                    8218: 130,
                    8220: 147,
                    8221: 148,
                    8222: 132,
                    8224: 134,
                    8225: 135,
                    8226: 149,
                    8230: 133,
                    8364: 128,
                    8240: 137,
                    8249: 139,
                    8250: 155,
                    710: 136,
                    8482: 153,
                    338: 140,
                    339: 156,
                    732: 152,
                    352: 138,
                    353: 154,
                    376: 159,
                    381: 142,
                    382: 158
                };
                var characters = ".notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n  \nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n  \nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n  \ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n  \nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n  \nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n  \nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n  \nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis".split(/\s+/);
                var AFMFont = /*#__PURE__*/ function() {
                    function AFMFont(contents) {
                        this.contents = contents;
                        this.attributes = {};
                        this.glyphWidths = {};
                        this.boundingBoxes = {};
                        this.kernPairs = {};
                        this.parse();
                        // todo: remove charWidths since appears to not be used
                        this.charWidths = new Array(256);
                        for(var char = 0; char <= 255; char++)this.charWidths[char] = this.glyphWidths[characters[char]];
                        this.bbox = this.attributes['FontBBox'].split(/\s+/).map(function(e) {
                            return +e;
                        });
                        this.ascender = +(this.attributes['Ascender'] || 0);
                        this.descender = +(this.attributes['Descender'] || 0);
                        this.xHeight = +(this.attributes['XHeight'] || 0);
                        this.capHeight = +(this.attributes['CapHeight'] || 0);
                        this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
                    }
                    AFMFont.open = function open1(filename) {
                        return new AFMFont(fs.readFileSync(filename, 'utf8'));
                    };
                    var _proto10 = AFMFont.prototype;
                    _proto10.parse = function parse() {
                        var section = '';
                        for(var _iterator5 = _createForOfIteratorHelperLoose(this.contents.split('\n')), _step5; !(_step5 = _iterator5()).done;){
                            var line = _step5.value;
                            var match;
                            var a;
                            if (match = line.match(/^Start(\w+)/)) {
                                section = match[1];
                                continue;
                            } else if (match = line.match(/^End(\w+)/)) {
                                section = '';
                                continue;
                            }
                            switch(section){
                                case 'FontMetrics':
                                    match = line.match(/(^\w+)\s+(.*)/);
                                    var key = match[1];
                                    var value = match[2];
                                    if (a = this.attributes[key]) {
                                        if (!Array.isArray(a)) a = this.attributes[key] = [
                                            a
                                        ];
                                        a.push(value);
                                    } else this.attributes[key] = value;
                                    break;
                                case 'CharMetrics':
                                    if (!/^CH?\s/.test(line)) continue;
                                    var name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
                                    this.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
                                    break;
                                case 'KernPairs':
                                    match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);
                                    if (match) this.kernPairs[match[1] + '\0' + match[2]] = parseInt(match[3]);
                                    break;
                            }
                        }
                    };
                    _proto10.encodeText = function encodeText(text) {
                        var res = [];
                        for(var i = 0, len = text.length; i < len; i++){
                            var char = text.charCodeAt(i);
                            char = WIN_ANSI_MAP[char] || char;
                            res.push(char.toString(16));
                        }
                        return res;
                    };
                    _proto10.glyphsForString = function glyphsForString(string) {
                        var glyphs = [];
                        for(var i = 0, len = string.length; i < len; i++){
                            var charCode = string.charCodeAt(i);
                            glyphs.push(this.characterToGlyph(charCode));
                        }
                        return glyphs;
                    };
                    _proto10.characterToGlyph = function characterToGlyph(character) {
                        return characters[WIN_ANSI_MAP[character] || character] || '.notdef';
                    };
                    _proto10.widthOfGlyph = function widthOfGlyph(glyph) {
                        return this.glyphWidths[glyph] || 0;
                    };
                    _proto10.getKernPair = function getKernPair(left, right) {
                        return this.kernPairs[left + '\0' + right] || 0;
                    };
                    _proto10.advancesForGlyphs = function advancesForGlyphs(glyphs) {
                        var advances = [];
                        for(var index = 0; index < glyphs.length; index++){
                            var left = glyphs[index];
                            var right = glyphs[index + 1];
                            advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
                        }
                        return advances;
                    };
                    return AFMFont;
                }();
                var PDFFont = /*#__PURE__*/ function() {
                    function PDFFont() {}
                    var _proto11 = PDFFont.prototype;
                    _proto11.encode = function encode() {
                        throw new Error('Must be implemented by subclasses');
                    };
                    _proto11.widthOfString = function widthOfString() {
                        throw new Error('Must be implemented by subclasses');
                    };
                    _proto11.ref = function ref() {
                        return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
                    };
                    _proto11.finalize = function finalize() {
                        if (this.embedded || this.dictionary == null) return;
                        this.embed();
                        return this.embedded = true;
                    };
                    _proto11.embed = function embed() {
                        throw new Error('Must be implemented by subclasses');
                    };
                    _proto11.lineHeight = function lineHeight(size, includeGap) {
                        if (includeGap == null) includeGap = false;
                        var gap = includeGap ? this.lineGap : 0;
                        return (this.ascender + gap - this.descender) / 1000 * size;
                    };
                    return PDFFont;
                }(); // This insanity is so bundlers can inline the font files
                var STANDARD_FONTS = {
                    Courier: function Courier() {
                        return fs.readFileSync(__dirname + '/data/Courier.afm', 'utf8');
                    },
                    'Courier-Bold': function CourierBold() {
                        return fs.readFileSync(__dirname + '/data/Courier-Bold.afm', 'utf8');
                    },
                    'Courier-Oblique': function CourierOblique() {
                        return fs.readFileSync(__dirname + '/data/Courier-Oblique.afm', 'utf8');
                    },
                    'Courier-BoldOblique': function CourierBoldOblique() {
                        return fs.readFileSync(__dirname + '/data/Courier-BoldOblique.afm', 'utf8');
                    },
                    Helvetica: function Helvetica() {
                        return fs.readFileSync(__dirname + '/data/Helvetica.afm', 'utf8');
                    },
                    'Helvetica-Bold': function HelveticaBold() {
                        return fs.readFileSync(__dirname + '/data/Helvetica-Bold.afm', 'utf8');
                    },
                    'Helvetica-Oblique': function HelveticaOblique() {
                        return fs.readFileSync(__dirname + '/data/Helvetica-Oblique.afm', 'utf8');
                    },
                    'Helvetica-BoldOblique': function HelveticaBoldOblique() {
                        return fs.readFileSync(__dirname + '/data/Helvetica-BoldOblique.afm', 'utf8');
                    },
                    'Times-Roman': function TimesRoman() {
                        return fs.readFileSync(__dirname + '/data/Times-Roman.afm', 'utf8');
                    },
                    'Times-Bold': function TimesBold() {
                        return fs.readFileSync(__dirname + '/data/Times-Bold.afm', 'utf8');
                    },
                    'Times-Italic': function TimesItalic() {
                        return fs.readFileSync(__dirname + '/data/Times-Italic.afm', 'utf8');
                    },
                    'Times-BoldItalic': function TimesBoldItalic() {
                        return fs.readFileSync(__dirname + '/data/Times-BoldItalic.afm', 'utf8');
                    },
                    Symbol: function Symbol1() {
                        return fs.readFileSync(__dirname + '/data/Symbol.afm', 'utf8');
                    },
                    ZapfDingbats: function ZapfDingbats() {
                        return fs.readFileSync(__dirname + '/data/ZapfDingbats.afm', 'utf8');
                    }
                };
                var StandardFont = /*#__PURE__*/ function(_PDFFont) {
                    function StandardFont(document1, name, id) {
                        var _this6;
                        _this6 = _PDFFont.call(this) || this;
                        _this6.document = document1;
                        _this6.name = name;
                        _this6.id = id;
                        _this6.font = new AFMFont(STANDARD_FONTS[_this6.name]());
                        var _this6$font = _this6.font;
                        _this6.ascender = _this6$font.ascender;
                        _this6.descender = _this6$font.descender;
                        _this6.bbox = _this6$font.bbox;
                        _this6.lineGap = _this6$font.lineGap;
                        _this6.xHeight = _this6$font.xHeight;
                        _this6.capHeight = _this6$font.capHeight;
                        return _this6;
                    }
                    _inheritsLoose(StandardFont, _PDFFont);
                    var _proto12 = StandardFont.prototype;
                    _proto12.embed = function embed() {
                        this.dictionary.data = {
                            Type: 'Font',
                            BaseFont: this.name,
                            Subtype: 'Type1',
                            Encoding: 'WinAnsiEncoding'
                        };
                        return this.dictionary.end();
                    };
                    _proto12.encode = function encode(text) {
                        var encoded = this.font.encodeText(text);
                        var glyphs = this.font.glyphsForString("" + text);
                        var advances = this.font.advancesForGlyphs(glyphs);
                        var positions = [];
                        for(var i = 0; i < glyphs.length; i++){
                            var glyph = glyphs[i];
                            positions.push({
                                xAdvance: advances[i],
                                yAdvance: 0,
                                xOffset: 0,
                                yOffset: 0,
                                advanceWidth: this.font.widthOfGlyph(glyph)
                            });
                        }
                        return [
                            encoded,
                            positions
                        ];
                    };
                    _proto12.widthOfString = function widthOfString(string, size) {
                        var glyphs = this.font.glyphsForString("" + string);
                        var advances = this.font.advancesForGlyphs(glyphs);
                        var width = 0;
                        for(var _iterator6 = _createForOfIteratorHelperLoose(advances), _step6; !(_step6 = _iterator6()).done;){
                            var advance = _step6.value;
                            width += advance;
                        }
                        var scale = size / 1000;
                        return width * scale;
                    };
                    StandardFont.isStandardFont = function isStandardFont(name) {
                        return name in STANDARD_FONTS;
                    };
                    return StandardFont;
                }(PDFFont);
                var toHex = function toHex(num) {
                    return ("0000" + num.toString(16)).slice(-4);
                };
                var EmbeddedFont = /*#__PURE__*/ function(_PDFFont2) {
                    function EmbeddedFont(document1, font, id) {
                        var _this7;
                        _this7 = _PDFFont2.call(this) || this;
                        _this7.document = document1;
                        _this7.font = font;
                        _this7.id = id;
                        _this7.subset = _this7.font.createSubset();
                        _this7.unicode = [
                            [
                                0
                            ]
                        ];
                        _this7.widths = [
                            _this7.font.getGlyph(0).advanceWidth
                        ];
                        _this7.name = _this7.font.postscriptName;
                        _this7.scale = 1000 / _this7.font.unitsPerEm;
                        _this7.ascender = _this7.font.ascent * _this7.scale;
                        _this7.descender = _this7.font.descent * _this7.scale;
                        _this7.xHeight = _this7.font.xHeight * _this7.scale;
                        _this7.capHeight = _this7.font.capHeight * _this7.scale;
                        _this7.lineGap = _this7.font.lineGap * _this7.scale;
                        _this7.bbox = _this7.font.bbox;
                        if (document1.options.fontLayoutCache !== false) _this7.layoutCache = Object.create(null);
                        return _this7;
                    }
                    _inheritsLoose(EmbeddedFont, _PDFFont2);
                    var _proto13 = EmbeddedFont.prototype;
                    _proto13.layoutRun = function layoutRun(text, features) {
                        var run = this.font.layout(text, features);
                        // Normalize position values
                        for(var i = 0; i < run.positions.length; i++){
                            var position = run.positions[i];
                            for(var key in position)position[key] *= this.scale;
                            position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
                        }
                        return run;
                    };
                    _proto13.layoutCached = function layoutCached(text) {
                        if (!this.layoutCache) return this.layoutRun(text);
                        var cached;
                        if (cached = this.layoutCache[text]) return cached;
                        var run = this.layoutRun(text);
                        this.layoutCache[text] = run;
                        return run;
                    };
                    _proto13.layout = function layout(text, features, onlyWidth) {
                        // Skip the cache if any user defined features are applied
                        if (features) return this.layoutRun(text, features);
                        var glyphs = onlyWidth ? null : [];
                        var positions = onlyWidth ? null : [];
                        var advanceWidth = 0;
                        // Split the string by words to increase cache efficiency.
                        // For this purpose, spaces and tabs are a good enough delimeter.
                        var last = 0;
                        var index = 0;
                        while(index <= text.length){
                            var needle;
                            if (index === text.length && last < index || (needle = text.charAt(index), [
                                ' ',
                                '\t'
                            ].includes(needle))) {
                                var run = this.layoutCached(text.slice(last, ++index));
                                if (!onlyWidth) {
                                    glyphs = glyphs.concat(run.glyphs);
                                    positions = positions.concat(run.positions);
                                }
                                advanceWidth += run.advanceWidth;
                                last = index;
                            } else index++;
                        }
                        return {
                            glyphs: glyphs,
                            positions: positions,
                            advanceWidth: advanceWidth
                        };
                    };
                    _proto13.encode = function encode(text, features) {
                        var _this$layout = this.layout(text, features), glyphs = _this$layout.glyphs, positions = _this$layout.positions;
                        var res = [];
                        for(var i = 0; i < glyphs.length; i++){
                            var glyph = glyphs[i];
                            var gid = this.subset.includeGlyph(glyph.id);
                            res.push(("0000" + gid.toString(16)).slice(-4));
                            if (this.widths[gid] == null) this.widths[gid] = glyph.advanceWidth * this.scale;
                            if (this.unicode[gid] == null) this.unicode[gid] = glyph.codePoints;
                        }
                        return [
                            res,
                            positions
                        ];
                    };
                    _proto13.widthOfString = function widthOfString(string, size, features) {
                        var width = this.layout(string, features, true).advanceWidth;
                        var scale = size / 1000;
                        return width * scale;
                    };
                    _proto13.embed = function embed() {
                        var _this8 = this;
                        var isCFF = this.subset.cff != null;
                        var fontFile = this.document.ref();
                        if (isCFF) fontFile.data.Subtype = 'CIDFontType0C';
                        this.subset.encodeStream().on('data', function(data) {
                            return fontFile.write(data);
                        }).on('end', function() {
                            return fontFile.end();
                        });
                        var familyClass = ((this.font['OS/2'] != null ? this.font['OS/2'].sFamilyClass : undefined) || 0) >> 8;
                        var flags = 0;
                        if (this.font.post.isFixedPitch) flags |= 1;
                        if (1 <= familyClass && familyClass <= 7) flags |= 2;
                        flags |= 4; // assume the font uses non-latin characters
                        if (familyClass === 10) flags |= 8;
                        if (this.font.head.macStyle.italic) flags |= 64;
                        // generate a tag (6 uppercase letters. 17 is the char code offset from '0' to 'A'. 73 will map to 'Z')
                        var tag = [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6
                        ].map(function(i) {
                            return String.fromCharCode((_this8.id.charCodeAt(i) || 73) + 17);
                        }).join('');
                        var name = tag + '+' + this.font.postscriptName.replaceAll(' ', '_');
                        var bbox = this.font.bbox;
                        var descriptor = this.document.ref({
                            Type: 'FontDescriptor',
                            FontName: name,
                            Flags: flags,
                            FontBBox: [
                                bbox.minX * this.scale,
                                bbox.minY * this.scale,
                                bbox.maxX * this.scale,
                                bbox.maxY * this.scale
                            ],
                            ItalicAngle: this.font.italicAngle,
                            Ascent: this.ascender,
                            Descent: this.descender,
                            CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
                            XHeight: (this.font.xHeight || 0) * this.scale,
                            StemV: 0
                        }); // not sure how to calculate this
                        if (isCFF) descriptor.data.FontFile3 = fontFile;
                        else descriptor.data.FontFile2 = fontFile;
                        if (this.document.subset && this.document.subset === 1) {
                            var CIDSet = Buffer.from('FFFFFFFFC0', 'hex');
                            var CIDSetRef = this.document.ref();
                            CIDSetRef.write(CIDSet);
                            CIDSetRef.end();
                            descriptor.data.CIDSet = CIDSetRef;
                        }
                        descriptor.end();
                        var descendantFontData = {
                            Type: 'Font',
                            Subtype: 'CIDFontType0',
                            BaseFont: name,
                            CIDSystemInfo: {
                                Registry: new String('Adobe'),
                                Ordering: new String('Identity'),
                                Supplement: 0
                            },
                            FontDescriptor: descriptor,
                            W: [
                                0,
                                this.widths
                            ]
                        };
                        if (!isCFF) {
                            descendantFontData.Subtype = 'CIDFontType2';
                            descendantFontData.CIDToGIDMap = 'Identity';
                        }
                        var descendantFont = this.document.ref(descendantFontData);
                        descendantFont.end();
                        this.dictionary.data = {
                            Type: 'Font',
                            Subtype: 'Type0',
                            BaseFont: name,
                            Encoding: 'Identity-H',
                            DescendantFonts: [
                                descendantFont
                            ],
                            ToUnicode: this.toUnicodeCmap()
                        };
                        return this.dictionary.end();
                    };
                    _proto13.toUnicodeCmap = function toUnicodeCmap() {
                        var cmap = this.document.ref();
                        var entries = [];
                        for(var _iterator7 = _createForOfIteratorHelperLoose(this.unicode), _step7; !(_step7 = _iterator7()).done;){
                            var codePoints = _step7.value;
                            var encoded = [];
                            // encode codePoints to utf16
                            for(var _iterator8 = _createForOfIteratorHelperLoose(codePoints), _step8; !(_step8 = _iterator8()).done;){
                                var value = _step8.value;
                                if (value > 0xffff) {
                                    value -= 0x10000;
                                    encoded.push(toHex(value >>> 10 & 0x3ff | 0xd800));
                                    value = 0xdc00 | value & 0x3ff;
                                }
                                encoded.push(toHex(value));
                            }
                            entries.push("<" + encoded.join(' ') + ">");
                        }
                        var chunkSize = 256;
                        var chunks = Math.ceil(entries.length / chunkSize);
                        var ranges = [];
                        for(var i = 0; i < chunks; i++){
                            var start = i * chunkSize;
                            var end = Math.min((i + 1) * chunkSize, entries.length);
                            ranges.push("<" + toHex(start) + "> <" + toHex(end - 1) + "> [" + entries.slice(start, end).join(' ') + "]");
                        }
                        cmap.end("/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n1 beginbfrange\n" + ranges.join('\n') + "\nendbfrange\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend");
                        return cmap;
                    };
                    return EmbeddedFont;
                }(PDFFont);
                var PDFFontFactory = /*#__PURE__*/ function() {
                    function PDFFontFactory() {}
                    PDFFontFactory.open = function open1(document1, src, family, id) {
                        var font;
                        if (typeof src === 'string') {
                            if (StandardFont.isStandardFont(src)) return new StandardFont(document1, src, id);
                            src = fs.readFileSync(src);
                        }
                        if (Buffer.isBuffer(src)) font = _fontkit.default.create(src, family);
                        else if (src instanceof Uint8Array) font = _fontkit.default.create(Buffer.from(src), family);
                        else if (src instanceof ArrayBuffer) font = _fontkit.default.create(Buffer.from(new Uint8Array(src)), family);
                        if (font == null) throw new Error('Not a supported font format or standard PDF font.');
                        return new EmbeddedFont(document1, font, id);
                    };
                    return PDFFontFactory;
                }();
                var isEqualFont = function isEqualFont(font1, font2) {
                    var _font1$font$_tables, _font2$font$_tables, _font1$font$_tables2, _font2$font$_tables2;
                    // compare font checksum
                    if (((_font1$font$_tables = font1.font._tables) == null || (_font1$font$_tables = _font1$font$_tables.head) == null ? void 0 : _font1$font$_tables.checkSumAdjustment) !== ((_font2$font$_tables = font2.font._tables) == null || (_font2$font$_tables = _font2$font$_tables.head) == null ? void 0 : _font2$font$_tables.checkSumAdjustment)) return false;
                    // compare font name table
                    if (JSON.stringify((_font1$font$_tables2 = font1.font._tables) == null || (_font1$font$_tables2 = _font1$font$_tables2.name) == null ? void 0 : _font1$font$_tables2.records) !== JSON.stringify((_font2$font$_tables2 = font2.font._tables) == null || (_font2$font$_tables2 = _font2$font$_tables2.name) == null ? void 0 : _font2$font$_tables2.records)) return false;
                    return true;
                };
                var FontsMixin = {
                    initFonts: function initFonts() {
                        var defaultFont = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Helvetica';
                        // Lookup table for embedded fonts
                        this._fontFamilies = {};
                        this._fontCount = 0;
                        // Font state
                        this._fontSize = 12;
                        this._font = null;
                        this._registeredFonts = {};
                        // Set the default font
                        if (defaultFont) this.font(defaultFont);
                    },
                    font: function font(src, family, size) {
                        var cacheKey, font;
                        if (typeof family === 'number') {
                            size = family;
                            family = null;
                        }
                        // check registered fonts if src is a string
                        if (typeof src === 'string' && this._registeredFonts[src]) {
                            cacheKey = src;
                            var _this$_registeredFont = this._registeredFonts[src];
                            src = _this$_registeredFont.src;
                            family = _this$_registeredFont.family;
                        } else {
                            cacheKey = family || src;
                            if (typeof cacheKey !== 'string') cacheKey = null;
                        }
                        if (size != null) this.fontSize(size);
                        // fast path: check if the font is already in the PDF
                        if (font = this._fontFamilies[cacheKey]) {
                            this._font = font;
                            return this;
                        }
                        // load the font
                        var id = "F" + ++this._fontCount;
                        this._font = PDFFontFactory.open(this, src, family, id);
                        // check for existing font familes with the same name already in the PDF
                        // useful if the font was passed as a buffer
                        if ((font = this._fontFamilies[this._font.name]) && isEqualFont(this._font, font)) {
                            this._font = font;
                            return this;
                        }
                        // save the font for reuse later
                        if (cacheKey) this._fontFamilies[cacheKey] = this._font;
                        if (this._font.name) this._fontFamilies[this._font.name] = this._font;
                        return this;
                    },
                    fontSize: function fontSize(_fontSize) {
                        this._fontSize = _fontSize;
                        return this;
                    },
                    currentLineHeight: function currentLineHeight(includeGap) {
                        if (includeGap == null) includeGap = false;
                        return this._font.lineHeight(this._fontSize, includeGap);
                    },
                    registerFont: function registerFont(name, src, family) {
                        this._registeredFonts[name] = {
                            src: src,
                            family: family
                        };
                        return this;
                    }
                };
                var SOFT_HYPHEN = "\xAD";
                var HYPHEN = '-';
                var LineWrapper = /*#__PURE__*/ function(_EventEmitter) {
                    function LineWrapper(document1, options) {
                        var _this9;
                        _this9 = _EventEmitter.call(this) || this;
                        _this9.document = document1;
                        _this9.horizontalScaling = options.horizontalScaling || 100;
                        _this9.indent = (options.indent || 0) * _this9.horizontalScaling / 100;
                        _this9.characterSpacing = (options.characterSpacing || 0) * _this9.horizontalScaling / 100;
                        _this9.wordSpacing = (options.wordSpacing === 0) * _this9.horizontalScaling / 100;
                        _this9.columns = options.columns || 1;
                        _this9.columnGap = (options.columnGap != null ? options.columnGap : 18) * _this9.horizontalScaling / 100; // 1/4 inch
                        _this9.lineWidth = (options.width * _this9.horizontalScaling / 100 - _this9.columnGap * (_this9.columns - 1)) / _this9.columns;
                        _this9.spaceLeft = _this9.lineWidth;
                        _this9.startX = _this9.document.x;
                        _this9.startY = _this9.document.y;
                        _this9.column = 1;
                        _this9.ellipsis = options.ellipsis;
                        _this9.continuedX = 0;
                        _this9.features = options.features;
                        // calculate the maximum Y position the text can appear at
                        if (options.height != null) {
                            _this9.height = options.height;
                            _this9.maxY = _this9.startY + options.height;
                        } else _this9.maxY = _this9.document.page.maxY();
                        // handle paragraph indents
                        _this9.on('firstLine', function(options) {
                            // if this is the first line of the text segment, and
                            // we're continuing where we left off, indent that much
                            // otherwise use the user specified indent option
                            var indent = _this9.continuedX || _this9.indent;
                            _this9.document.x += indent;
                            _this9.lineWidth -= indent;
                            // if indentAllLines is set to true
                            // we're not resetting the indentation for this paragraph after the first line
                            if (options.indentAllLines) return;
                            // otherwise we start the next line without indent
                            return _this9.once('line', function() {
                                _this9.document.x -= indent;
                                _this9.lineWidth += indent;
                                if (options.continued && !_this9.continuedX) _this9.continuedX = _this9.indent;
                                if (!options.continued) return _this9.continuedX = 0;
                            });
                        });
                        // handle left aligning last lines of paragraphs
                        _this9.on('lastLine', function(options) {
                            var align = options.align;
                            if (align === 'justify') options.align = 'left';
                            _this9.lastLine = true;
                            return _this9.once('line', function() {
                                _this9.document.y += options.paragraphGap || 0;
                                options.align = align;
                                return _this9.lastLine = false;
                            });
                        });
                        return _this9;
                    }
                    _inheritsLoose(LineWrapper, _EventEmitter);
                    var _proto14 = LineWrapper.prototype;
                    _proto14.wordWidth = function wordWidth(word) {
                        return this.document.widthOfString(word, this) + this.characterSpacing + this.wordSpacing;
                    };
                    _proto14.canFit = function canFit(word, w) {
                        if (word[word.length - 1] != SOFT_HYPHEN) return w <= this.spaceLeft;
                        return w + this.wordWidth(HYPHEN) <= this.spaceLeft;
                    };
                    _proto14.eachWord = function eachWord(text, fn) {
                        // setup a unicode line breaker
                        var bk;
                        var breaker = new _linebreak.default(text);
                        var last = null;
                        var wordWidths = Object.create(null);
                        while(bk = breaker.nextBreak()){
                            var shouldContinue;
                            var word = text.slice((last != null ? last.position : undefined) || 0, bk.position);
                            var w = wordWidths[word] != null ? wordWidths[word] : wordWidths[word] = this.wordWidth(word);
                            // if the word is longer than the whole line, chop it up
                            // TODO: break by grapheme clusters, not JS string characters
                            if (w > this.lineWidth + this.continuedX) {
                                // make some fake break objects
                                var lbk = last;
                                var fbk = {};
                                while(word.length){
                                    // fit as much of the word as possible into the space we have
                                    var l, mightGrow;
                                    if (w > this.spaceLeft) {
                                        // start our check at the end of our available space - this method is faster than a loop of each character and it resolves
                                        // an issue with long loops when processing massive words, such as a huge number of spaces
                                        l = Math.ceil(this.spaceLeft / (w / word.length));
                                        w = this.wordWidth(word.slice(0, l));
                                        mightGrow = w <= this.spaceLeft && l < word.length;
                                    } else l = word.length;
                                    var mustShrink = w > this.spaceLeft && l > 0;
                                    // shrink or grow word as necessary after our near-guess above
                                    while(mustShrink || mightGrow)if (mustShrink) {
                                        w = this.wordWidth(word.slice(0, --l));
                                        mustShrink = w > this.spaceLeft && l > 0;
                                    } else {
                                        w = this.wordWidth(word.slice(0, ++l));
                                        mustShrink = w > this.spaceLeft && l > 0;
                                        mightGrow = w <= this.spaceLeft && l < word.length;
                                    }
                                    // check for the edge case where a single character cannot fit into a line.
                                    if (l === 0 && this.spaceLeft === this.lineWidth) l = 1;
                                    // send a required break unless this is the last piece and a linebreak is not specified
                                    fbk.required = bk.required || l < word.length;
                                    shouldContinue = fn(word.slice(0, l), w, fbk, lbk);
                                    lbk = {
                                        required: false
                                    };
                                    // get the remaining piece of the word
                                    word = word.slice(l);
                                    w = this.wordWidth(word);
                                    if (shouldContinue === false) break;
                                }
                            } else // otherwise just emit the break as it was given to us
                            shouldContinue = fn(word, w, bk, last);
                            if (shouldContinue === false) break;
                            last = bk;
                        }
                    };
                    _proto14.wrap = function wrap(text, options) {
                        var _this0 = this;
                        // override options from previous continued fragments
                        this.horizontalScaling = options.horizontalScaling || 100;
                        if (options.indent != null) this.indent = options.indent * this.horizontalScaling / 100;
                        if (options.characterSpacing != null) this.characterSpacing = options.characterSpacing * this.horizontalScaling / 100;
                        if (options.wordSpacing != null) this.wordSpacing = options.wordSpacing * this.horizontalScaling / 100;
                        if (options.ellipsis != null) this.ellipsis = options.ellipsis;
                        // make sure we're actually on the page
                        // and that the first line of is never by
                        // itself at the bottom of a page (orphans)
                        var nextY = this.document.y + this.document.currentLineHeight(true);
                        if (this.document.y > this.maxY || nextY > this.maxY) this.nextSection();
                        var buffer = '';
                        var textWidth = 0;
                        var wc = 0;
                        var lc = 0;
                        var y = this.document.y; // used to reset Y pos if options.continued (below)
                        var emitLine = function emitLine() {
                            options.textWidth = textWidth + _this0.wordSpacing * (wc - 1);
                            options.wordCount = wc;
                            options.lineWidth = _this0.lineWidth;
                            y = _this0.document.y;
                            _this0.emit('line', buffer, options, _this0);
                            return lc++;
                        };
                        this.emit('sectionStart', options, this);
                        this.eachWord(text, function(word, w, bk, last) {
                            if (last == null || last.required) {
                                _this0.emit('firstLine', options, _this0);
                                _this0.spaceLeft = _this0.lineWidth;
                            }
                            if (_this0.canFit(word, w)) {
                                buffer += word;
                                textWidth += w;
                                wc++;
                            }
                            if (bk.required || !_this0.canFit(word, w)) {
                                // if the user specified a max height and an ellipsis, and is about to pass the
                                // max height and max columns after the next line, append the ellipsis
                                var lh = _this0.document.currentLineHeight(true);
                                if (_this0.height != null && _this0.ellipsis && _this0.document.y + lh * 2 > _this0.maxY && _this0.column >= _this0.columns) {
                                    if (_this0.ellipsis === true) _this0.ellipsis = "\u2026";
                                     // map default ellipsis character
                                    buffer = buffer.replace(/\s+$/, '');
                                    textWidth = _this0.wordWidth(buffer + _this0.ellipsis);
                                    // remove characters from the buffer until the ellipsis fits
                                    // to avoid infinite loop need to stop while-loop if buffer is empty string
                                    while(buffer && textWidth > _this0.lineWidth){
                                        buffer = buffer.slice(0, -1).replace(/\s+$/, '');
                                        textWidth = _this0.wordWidth(buffer + _this0.ellipsis);
                                    }
                                    // need to add ellipsis only if there is enough space for it
                                    if (textWidth <= _this0.lineWidth) buffer = buffer + _this0.ellipsis;
                                    textWidth = _this0.wordWidth(buffer);
                                }
                                if (bk.required) {
                                    if (w > _this0.spaceLeft) {
                                        emitLine();
                                        buffer = word;
                                        textWidth = w;
                                        wc = 1;
                                    }
                                    _this0.emit('lastLine', options, _this0);
                                }
                                // Previous entry is a soft hyphen - add visible hyphen.
                                if (buffer[buffer.length - 1] == SOFT_HYPHEN) {
                                    buffer = buffer.slice(0, -1) + HYPHEN;
                                    _this0.spaceLeft -= _this0.wordWidth(HYPHEN);
                                }
                                emitLine();
                                // if we've reached the edge of the page,
                                // continue on a new page or column
                                if (_this0.document.y + lh > _this0.maxY) {
                                    var shouldContinue = _this0.nextSection();
                                    // stop if we reached the maximum height
                                    if (!shouldContinue) {
                                        wc = 0;
                                        buffer = '';
                                        return false;
                                    }
                                }
                                // reset the space left and buffer
                                if (bk.required) {
                                    _this0.spaceLeft = _this0.lineWidth;
                                    buffer = '';
                                    textWidth = 0;
                                    return wc = 0;
                                } else {
                                    // reset the space left and buffer
                                    _this0.spaceLeft = _this0.lineWidth - w;
                                    buffer = word;
                                    textWidth = w;
                                    return wc = 1;
                                }
                            } else return _this0.spaceLeft -= w;
                        });
                        if (wc > 0) {
                            this.emit('lastLine', options, this);
                            emitLine();
                        }
                        this.emit('sectionEnd', options, this);
                        // if the wrap is set to be continued, save the X position
                        // to start the first line of the next segment at, and reset
                        // the y position
                        if (options.continued === true) {
                            if (lc > 1) this.continuedX = 0;
                            this.continuedX += options.textWidth || 0;
                            return this.document.y = y;
                        } else return this.document.x = this.startX;
                    };
                    _proto14.nextSection = function nextSection(options) {
                        this.emit('sectionEnd', options, this);
                        if (++this.column > this.columns) {
                            // if a max height was specified by the user, we're done.
                            // otherwise, the default is to make a new page at the bottom.
                            if (this.height != null) return false;
                            this.document.continueOnNewPage();
                            this.column = 1;
                            this.startY = this.document.page.margins.top;
                            this.maxY = this.document.page.maxY();
                            this.document.x = this.startX;
                            if (this.document._fillColor) {
                                var _this$document;
                                (_this$document = this.document).fillColor.apply(_this$document, this.document._fillColor);
                            }
                            this.emit('pageBreak', options, this);
                        } else {
                            this.document.x += this.lineWidth + this.columnGap;
                            this.document.y = this.startY;
                            this.emit('columnBreak', options, this);
                        }
                        this.emit('sectionStart', options, this);
                        return true;
                    };
                    return LineWrapper;
                }(_events.EventEmitter);
                var number$2 = PDFObject.number;
                var TextMixin = {
                    initText: function initText() {
                        this._line = this._line.bind(this);
                        // Current coordinates
                        this.x = 0;
                        this.y = 0;
                        return this._lineGap = 0;
                    },
                    lineGap: function lineGap(_lineGap) {
                        this._lineGap = _lineGap;
                        return this;
                    },
                    moveDown: function moveDown(lines) {
                        if (lines == null) lines = 1;
                        this.y += this.currentLineHeight(true) * lines + this._lineGap;
                        return this;
                    },
                    moveUp: function moveUp(lines) {
                        if (lines == null) lines = 1;
                        this.y -= this.currentLineHeight(true) * lines + this._lineGap;
                        return this;
                    },
                    _text: function _text(text, x, y, options, lineCallback) {
                        var _this1 = this;
                        options = this._initOptions(x, y, options);
                        // Convert text to a string
                        text = text == null ? '' : "" + text;
                        // if the wordSpacing option is specified, remove multiple consecutive spaces
                        if (options.wordSpacing) text = text.replace(/\s{2,}/g, ' ');
                        var addStructure = function addStructure() {
                            if (options.structParent) options.structParent.add(_this1.struct(options.structType || 'P', [
                                _this1.markStructureContent(options.structType || 'P')
                            ]));
                        };
                        // word wrapping
                        if (options.width) {
                            var wrapper = this._wrapper;
                            if (!wrapper) {
                                wrapper = new LineWrapper(this, options);
                                wrapper.on('line', lineCallback);
                                wrapper.on('firstLine', addStructure);
                            }
                            this._wrapper = options.continued ? wrapper : null;
                            this._textOptions = options.continued ? options : null;
                            wrapper.wrap(text, options);
                        // render paragraphs as single lines
                        } else for(var _iterator9 = _createForOfIteratorHelperLoose(text.split('\n')), _step9; !(_step9 = _iterator9()).done;){
                            var line = _step9.value;
                            addStructure();
                            lineCallback(line, options);
                        }
                        return this;
                    },
                    text: function text(_text2, x, y, options) {
                        return this._text(_text2, x, y, options, this._line);
                    },
                    widthOfString: function widthOfString(string) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var horizontalScaling = options.horizontalScaling || 100;
                        return (this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1)) * horizontalScaling / 100;
                    },
                    heightOfString: function heightOfString(text, options) {
                        var _this10 = this;
                        var x = this.x, y = this.y;
                        options = this._initOptions(options);
                        options.height = Infinity; // don't break pages
                        var lineGap = options.lineGap || this._lineGap || 0;
                        this._text(text, this.x, this.y, options, function() {
                            return _this10.y += _this10.currentLineHeight(true) + lineGap;
                        });
                        var height = this.y - y;
                        this.x = x;
                        this.y = y;
                        return height;
                    },
                    list: function list(_list, x, y, options, wrapper) {
                        options = this._initOptions(x, y, options);
                        var listType = options.listType || 'bullet';
                        var unit = Math.round(this._font.ascender / 1000 * this._fontSize);
                        var midLine = unit / 2;
                        var r = options.bulletRadius || unit / 3;
                        var indent = options.textIndent || (listType === 'bullet' ? r * 5 : unit * 2);
                        var itemIndent = options.bulletIndent || (listType === 'bullet' ? r * 8 : unit * 2);
                        var level = 1;
                        var items = [];
                        var levels = [];
                        var numbers = [];
                        var _flatten = function flatten(list) {
                            var n = 1;
                            for(var i = 0; i < list.length; i++){
                                var item = list[i];
                                if (Array.isArray(item)) {
                                    level++;
                                    _flatten(item);
                                    level--;
                                } else {
                                    items.push(item);
                                    levels.push(level);
                                    if (listType !== 'bullet') numbers.push(n++);
                                }
                            }
                        };
                        _flatten(_list);
                        var label = function label(n) {
                            switch(listType){
                                case 'numbered':
                                    return n + ".";
                                case 'lettered':
                                    var letter = String.fromCharCode((n - 1) % 26 + 65);
                                    var times = Math.floor((n - 1) / 26 + 1);
                                    var text = Array(times + 1).join(letter);
                                    return text + ".";
                            }
                        };
                        var drawListItem = function drawListItem(listItem, i) {
                            var _this11 = this;
                            wrapper = new LineWrapper(this, options);
                            wrapper.on('line', this._line);
                            level = 1;
                            wrapper.once('firstLine', function() {
                                var item, itemType, labelType, bodyType;
                                if (options.structParent) {
                                    if (options.structTypes) {
                                        var _options$structTypes = options.structTypes;
                                        itemType = _options$structTypes[0];
                                        labelType = _options$structTypes[1];
                                        bodyType = _options$structTypes[2];
                                    } else {
                                        itemType = 'LI';
                                        labelType = 'Lbl';
                                        bodyType = 'LBody';
                                    }
                                }
                                if (itemType) {
                                    item = _this11.struct(itemType);
                                    options.structParent.add(item);
                                } else if (options.structParent) item = options.structParent;
                                var l;
                                if ((l = levels[i++]) !== level) {
                                    var diff = itemIndent * (l - level);
                                    _this11.x += diff;
                                    wrapper.lineWidth -= diff;
                                    level = l;
                                }
                                if (item && (labelType || bodyType)) item.add(_this11.struct(labelType || bodyType, [
                                    _this11.markStructureContent(labelType || bodyType)
                                ]));
                                switch(listType){
                                    case 'bullet':
                                        _this11.circle(_this11.x - indent + r, _this11.y + midLine, r);
                                        _this11.fill();
                                        break;
                                    case 'numbered':
                                    case 'lettered':
                                        var text = label(numbers[i - 1]);
                                        _this11._fragment(text, _this11.x - indent, _this11.y, options);
                                        break;
                                }
                                if (item && labelType && bodyType) item.add(_this11.struct(bodyType, [
                                    _this11.markStructureContent(bodyType)
                                ]));
                                if (item && item !== options.structParent) item.end();
                            });
                            wrapper.on('sectionStart', function() {
                                var pos = indent + itemIndent * (level - 1);
                                _this11.x += pos;
                                return wrapper.lineWidth -= pos;
                            });
                            wrapper.on('sectionEnd', function() {
                                var pos = indent + itemIndent * (level - 1);
                                _this11.x -= pos;
                                return wrapper.lineWidth += pos;
                            });
                            wrapper.wrap(listItem, options);
                        };
                        for(var i = 0; i < items.length; i++)drawListItem.call(this, items[i], i);
                        return this;
                    },
                    _initOptions: function _initOptions() {
                        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        var y = arguments.length > 1 ? arguments[1] : undefined;
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        if (typeof x === 'object') {
                            options = x;
                            x = null;
                        }
                        // clone options object
                        var result = Object.assign({}, options);
                        // extend options with previous values for continued text
                        if (this._textOptions) for(var key in this._textOptions){
                            var val = this._textOptions[key];
                            if (key !== 'continued') {
                                if (result[key] === undefined) result[key] = val;
                            }
                        }
                        // Update the current position
                        if (x != null) this.x = x;
                        if (y != null) this.y = y;
                        // wrap to margins if no x or y position passed
                        if (result.lineBreak !== false) {
                            if (result.width == null) result.width = this.page.width - this.x - this.page.margins.right;
                            result.width = Math.max(result.width, 0);
                        }
                        if (!result.columns) result.columns = 0;
                        if (result.columnGap == null) result.columnGap = 18;
                         // 1/4 inch
                        return result;
                    },
                    _line: function _line(text) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var wrapper = arguments.length > 2 ? arguments[2] : undefined;
                        this._fragment(text, this.x, this.y, options);
                        var lineGap = options.lineGap || this._lineGap || 0;
                        if (!wrapper) return this.x += this.widthOfString(text, options);
                        else return this.y += this.currentLineHeight(true) + lineGap;
                    },
                    _fragment: function _fragment(text, x, y, options) {
                        var _this12 = this;
                        var dy, encoded, i, positions, textWidth, words;
                        text = ("" + text).replace(/\n/g, '');
                        if (text.length === 0) return;
                        // handle options
                        var align = options.align || 'left';
                        var wordSpacing = options.wordSpacing || 0;
                        var characterSpacing = options.characterSpacing || 0;
                        var horizontalScaling = options.horizontalScaling || 100;
                        // text alignments
                        if (options.width) switch(align){
                            case 'right':
                                textWidth = this.widthOfString(text.replace(/\s+$/, ''), options);
                                x += options.lineWidth - textWidth;
                                break;
                            case 'center':
                                x += options.lineWidth / 2 - options.textWidth / 2;
                                break;
                            case 'justify':
                                // calculate the word spacing value
                                words = text.trim().split(/\s+/);
                                textWidth = this.widthOfString(text.replace(/\s+/g, ''), options);
                                var spaceWidth = this.widthOfString(' ') + characterSpacing;
                                wordSpacing = Math.max(0, (options.lineWidth - textWidth) / Math.max(1, words.length - 1) - spaceWidth);
                                break;
                        }
                        // text baseline alignments based on http://wiki.apache.org/xmlgraphics-fop/LineLayout/AlignmentHandling
                        if (typeof options.baseline === 'number') dy = -options.baseline;
                        else {
                            switch(options.baseline){
                                case 'svg-middle':
                                    dy = 0.5 * this._font.xHeight;
                                    break;
                                case 'middle':
                                case 'svg-central':
                                    dy = 0.5 * (this._font.descender + this._font.ascender);
                                    break;
                                case 'bottom':
                                case 'ideographic':
                                    dy = this._font.descender;
                                    break;
                                case 'alphabetic':
                                    dy = 0;
                                    break;
                                case 'mathematical':
                                    dy = 0.5 * this._font.ascender;
                                    break;
                                case 'hanging':
                                    dy = 0.8 * this._font.ascender;
                                    break;
                                case 'top':
                                    dy = this._font.ascender;
                                    break;
                                default:
                                    dy = this._font.ascender;
                            }
                            dy = dy / 1000 * this._fontSize;
                        }
                        // calculate the actual rendered width of the string after word and character spacing
                        var renderedWidth = options.textWidth + wordSpacing * (options.wordCount - 1) + characterSpacing * (text.length - 1);
                        // create link annotations if the link option is given
                        if (options.link != null) this.link(x, y, renderedWidth, this.currentLineHeight(), options.link);
                        if (options.goTo != null) this.goTo(x, y, renderedWidth, this.currentLineHeight(), options.goTo);
                        if (options.destination != null) this.addNamedDestination(options.destination, 'XYZ', x, y, null);
                        // create underline
                        if (options.underline) {
                            this.save();
                            if (!options.stroke) this.strokeColor.apply(this, this._fillColor || []);
                            var lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
                            this.lineWidth(lineWidth);
                            var lineY = y + this.currentLineHeight() - lineWidth;
                            this.moveTo(x, lineY);
                            this.lineTo(x + renderedWidth, lineY);
                            this.stroke();
                            this.restore();
                        }
                        // create strikethrough line
                        if (options.strike) {
                            this.save();
                            if (!options.stroke) this.strokeColor.apply(this, this._fillColor || []);
                            var _lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
                            this.lineWidth(_lineWidth);
                            var _lineY = y + this.currentLineHeight() / 2;
                            this.moveTo(x, _lineY);
                            this.lineTo(x + renderedWidth, _lineY);
                            this.stroke();
                            this.restore();
                        }
                        this.save();
                        // oblique (angle in degrees or boolean)
                        if (options.oblique) {
                            var skew;
                            if (typeof options.oblique === 'number') skew = -Math.tan(options.oblique * Math.PI / 180);
                            else skew = -0.25;
                            this.transform(1, 0, 0, 1, x, y);
                            this.transform(1, 0, skew, 1, -skew * dy, 0);
                            this.transform(1, 0, 0, 1, -x, -y);
                        }
                        // flip coordinate system
                        this.transform(1, 0, 0, -1, 0, this.page.height);
                        y = this.page.height - y - dy;
                        // add current font to page if necessary
                        if (this.page.fonts[this._font.id] == null) this.page.fonts[this._font.id] = this._font.ref();
                        // begin the text object
                        this.addContent('BT');
                        // text position
                        this.addContent("1 0 0 1 " + number$2(x) + " " + number$2(y) + " Tm");
                        // font and font size
                        this.addContent("/" + this._font.id + " " + number$2(this._fontSize) + " Tf");
                        // rendering mode
                        var mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
                        if (mode) this.addContent(mode + " Tr");
                        // Character spacing
                        if (characterSpacing) this.addContent(number$2(characterSpacing) + " Tc");
                        // Horizontal scaling
                        if (horizontalScaling !== 100) this.addContent(horizontalScaling + " Tz");
                        // Add the actual text
                        // If we have a word spacing value, we need to encode each word separately
                        // since the normal Tw operator only works on character code 32, which isn't
                        // used for embedded fonts.
                        if (wordSpacing) {
                            words = text.trim().split(/\s+/);
                            wordSpacing += this.widthOfString(' ') + characterSpacing;
                            wordSpacing *= 1000 / this._fontSize;
                            encoded = [];
                            positions = [];
                            for(var _iterator0 = _createForOfIteratorHelperLoose(words), _step0; !(_step0 = _iterator0()).done;){
                                var word = _step0.value;
                                var _this$_font$encode = this._font.encode(word, options.features), encodedWord = _this$_font$encode[0], positionsWord = _this$_font$encode[1];
                                encoded = encoded.concat(encodedWord);
                                positions = positions.concat(positionsWord);
                                // add the word spacing to the end of the word
                                // clone object because of cache
                                var space = {};
                                var object = positions[positions.length - 1];
                                for(var key in object){
                                    var val = object[key];
                                    space[key] = val;
                                }
                                space.xAdvance += wordSpacing;
                                positions[positions.length - 1] = space;
                            }
                        } else {
                            var _this$_font$encode2 = this._font.encode(text, options.features);
                            encoded = _this$_font$encode2[0];
                            positions = _this$_font$encode2[1];
                        }
                        var scale = this._fontSize / 1000;
                        var commands = [];
                        var last = 0;
                        var hadOffset = false;
                        // Adds a segment of text to the TJ command buffer
                        var addSegment = function addSegment(cur) {
                            if (last < cur) {
                                var hex = encoded.slice(last, cur).join('');
                                var advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
                                commands.push("<" + hex + "> " + number$2(-advance));
                            }
                            return last = cur;
                        };
                        // Flushes the current TJ commands to the output stream
                        var flush = function flush(i) {
                            addSegment(i);
                            if (commands.length > 0) {
                                _this12.addContent("[" + commands.join(' ') + "] TJ");
                                return commands.length = 0;
                            }
                        };
                        for(i = 0; i < positions.length; i++){
                            // If we have an x or y offset, we have to break out of the current TJ command
                            // so we can move the text position.
                            var pos = positions[i];
                            if (pos.xOffset || pos.yOffset) {
                                // Flush the current buffer
                                flush(i);
                                // Move the text position and flush just the current character
                                this.addContent("1 0 0 1 " + number$2(x + pos.xOffset * scale) + " " + number$2(y + pos.yOffset * scale) + " Tm");
                                flush(i + 1);
                                hadOffset = true;
                            } else {
                                // If the last character had an offset, reset the text position
                                if (hadOffset) {
                                    this.addContent("1 0 0 1 " + number$2(x) + " " + number$2(y) + " Tm");
                                    hadOffset = false;
                                }
                                // Group segments that don't have any advance adjustments
                                if (pos.xAdvance - pos.advanceWidth !== 0) addSegment(i + 1);
                            }
                            x += pos.xAdvance * scale;
                        }
                        // Flush any remaining commands
                        flush(i);
                        // end the text object
                        this.addContent('ET');
                        // restore flipped coordinate system
                        return this.restore();
                    }
                };
                var MARKERS = [
                    0xffc0,
                    0xffc1,
                    0xffc2,
                    0xffc3,
                    0xffc5,
                    0xffc6,
                    0xffc7,
                    0xffc8,
                    0xffc9,
                    0xffca,
                    0xffcb,
                    0xffcc,
                    0xffcd,
                    0xffce,
                    0xffcf
                ];
                var COLOR_SPACE_MAP = {
                    1: 'DeviceGray',
                    3: 'DeviceRGB',
                    4: 'DeviceCMYK'
                };
                var JPEG = /*#__PURE__*/ function() {
                    function JPEG(data, label) {
                        var marker;
                        this.data = data;
                        this.label = label;
                        if (this.data.readUInt16BE(0) !== 0xffd8) throw 'SOI not found in JPEG';
                        // Parse the EXIF orientation
                        this.orientation = _jpegExif.default.fromBuffer(this.data).Orientation || 1;
                        var pos = 2;
                        while(pos < this.data.length){
                            marker = this.data.readUInt16BE(pos);
                            pos += 2;
                            if (MARKERS.includes(marker)) break;
                            pos += this.data.readUInt16BE(pos);
                        }
                        if (!MARKERS.includes(marker)) throw 'Invalid JPEG.';
                        pos += 2;
                        this.bits = this.data[pos++];
                        this.height = this.data.readUInt16BE(pos);
                        pos += 2;
                        this.width = this.data.readUInt16BE(pos);
                        pos += 2;
                        var channels = this.data[pos++];
                        this.colorSpace = COLOR_SPACE_MAP[channels];
                        this.obj = null;
                    }
                    var _proto15 = JPEG.prototype;
                    _proto15.embed = function embed(document1) {
                        if (this.obj) return;
                        this.obj = document1.ref({
                            Type: 'XObject',
                            Subtype: 'Image',
                            BitsPerComponent: this.bits,
                            Width: this.width,
                            Height: this.height,
                            ColorSpace: this.colorSpace,
                            Filter: 'DCTDecode'
                        });
                        // add extra decode params for CMYK images. By swapping the
                        // min and max values from the default, we invert the colors. See
                        // section 4.8.4 of the spec.
                        if (this.colorSpace === 'DeviceCMYK') this.obj.data['Decode'] = [
                            1.0,
                            0.0,
                            1.0,
                            0.0,
                            1.0,
                            0.0,
                            1.0,
                            0.0
                        ];
                        this.obj.end(this.data);
                        // free memory
                        return this.data = null;
                    };
                    return JPEG;
                }();
                var PNGImage = /*#__PURE__*/ function() {
                    function PNGImage(data, label) {
                        this.label = label;
                        this.image = new _pngJs.default(data);
                        this.width = this.image.width;
                        this.height = this.image.height;
                        this.imgData = this.image.imgData;
                        this.obj = null;
                    }
                    var _proto16 = PNGImage.prototype;
                    _proto16.embed = function embed(document1) {
                        var dataDecoded = false;
                        this.document = document1;
                        if (this.obj) return;
                        var hasAlphaChannel = this.image.hasAlphaChannel;
                        var isInterlaced = this.image.interlaceMethod === 1;
                        this.obj = this.document.ref({
                            Type: 'XObject',
                            Subtype: 'Image',
                            BitsPerComponent: hasAlphaChannel ? 8 : this.image.bits,
                            Width: this.width,
                            Height: this.height,
                            Filter: 'FlateDecode'
                        });
                        if (!hasAlphaChannel) {
                            var params = this.document.ref({
                                Predictor: isInterlaced ? 1 : 15,
                                Colors: this.image.colors,
                                BitsPerComponent: this.image.bits,
                                Columns: this.width
                            });
                            this.obj.data['DecodeParms'] = params;
                            params.end();
                        }
                        if (this.image.palette.length === 0) this.obj.data['ColorSpace'] = this.image.colorSpace;
                        else {
                            // embed the color palette in the PDF as an object stream
                            var palette = this.document.ref();
                            palette.end(Buffer.from(this.image.palette));
                            // build the color space array for the image
                            this.obj.data['ColorSpace'] = [
                                'Indexed',
                                'DeviceRGB',
                                this.image.palette.length / 3 - 1,
                                palette
                            ];
                        }
                        // For PNG color types 0, 2 and 3, the transparency data is stored in
                        // a dedicated PNG chunk.
                        if (this.image.transparency.grayscale != null) {
                            // Use Color Key Masking (spec section 4.8.5)
                            // An array with N elements, where N is two times the number of color components.
                            var val = this.image.transparency.grayscale;
                            this.obj.data['Mask'] = [
                                val,
                                val
                            ];
                        } else if (this.image.transparency.rgb) {
                            // Use Color Key Masking (spec section 4.8.5)
                            // An array with N elements, where N is two times the number of color components.
                            var rgb = this.image.transparency.rgb;
                            var mask = [];
                            for(var _iterator1 = _createForOfIteratorHelperLoose(rgb), _step1; !(_step1 = _iterator1()).done;){
                                var x = _step1.value;
                                mask.push(x, x);
                            }
                            this.obj.data['Mask'] = mask;
                        } else if (this.image.transparency.indexed) {
                            // Create a transparency SMask for the image based on the data
                            // in the PLTE and tRNS sections. See below for details on SMasks.
                            dataDecoded = true;
                            return this.loadIndexedAlphaChannel();
                        } else if (hasAlphaChannel) {
                            // For PNG color types 4 and 6, the transparency data is stored as a alpha
                            // channel mixed in with the main image data. Separate this data out into an
                            // SMask object and store it separately in the PDF.
                            dataDecoded = true;
                            return this.splitAlphaChannel();
                        }
                        if (isInterlaced && !dataDecoded) return this.decodeData();
                        this.finalize();
                    };
                    _proto16.finalize = function finalize() {
                        if (this.alphaChannel) {
                            var sMask = this.document.ref({
                                Type: 'XObject',
                                Subtype: 'Image',
                                Height: this.height,
                                Width: this.width,
                                BitsPerComponent: 8,
                                Filter: 'FlateDecode',
                                ColorSpace: 'DeviceGray',
                                Decode: [
                                    0,
                                    1
                                ]
                            });
                            sMask.end(this.alphaChannel);
                            this.obj.data['SMask'] = sMask;
                        }
                        // add the actual image data
                        this.obj.end(this.imgData);
                        // free memory
                        this.image = null;
                        return this.imgData = null;
                    };
                    _proto16.splitAlphaChannel = function splitAlphaChannel() {
                        var _this13 = this;
                        return this.image.decodePixels(function(pixels) {
                            var a, p;
                            var colorCount = _this13.image.colors;
                            var pixelCount = _this13.width * _this13.height;
                            var imgData = Buffer.alloc(pixelCount * colorCount);
                            var alphaChannel = Buffer.alloc(pixelCount);
                            var i = p = a = 0;
                            var len = pixels.length;
                            // For 16bit images copy only most significant byte (MSB) - PNG data is always stored in network byte order (MSB first)
                            var skipByteCount = _this13.image.bits === 16 ? 1 : 0;
                            while(i < len){
                                for(var colorIndex = 0; colorIndex < colorCount; colorIndex++){
                                    imgData[p++] = pixels[i++];
                                    i += skipByteCount;
                                }
                                alphaChannel[a++] = pixels[i++];
                                i += skipByteCount;
                            }
                            _this13.imgData = _zlib.default.deflateSync(imgData);
                            _this13.alphaChannel = _zlib.default.deflateSync(alphaChannel);
                            return _this13.finalize();
                        });
                    };
                    _proto16.loadIndexedAlphaChannel = function loadIndexedAlphaChannel() {
                        var _this14 = this;
                        var transparency = this.image.transparency.indexed;
                        return this.image.decodePixels(function(pixels) {
                            var alphaChannel = Buffer.alloc(_this14.width * _this14.height);
                            var i = 0;
                            for(var j = 0, end = pixels.length; j < end; j++)alphaChannel[i++] = transparency[pixels[j]];
                            _this14.alphaChannel = _zlib.default.deflateSync(alphaChannel);
                            return _this14.finalize();
                        });
                    };
                    _proto16.decodeData = function decodeData() {
                        var _this15 = this;
                        this.image.decodePixels(function(pixels) {
                            _this15.imgData = _zlib.default.deflateSync(pixels);
                            _this15.finalize();
                        });
                    };
                    return PNGImage;
                }();
                /*
PDFImage - embeds images in PDF documents
By Devon Govett
*/ var PDFImage = /*#__PURE__*/ function() {
                    function PDFImage() {}
                    PDFImage.open = function open1(src, label) {
                        var data;
                        if (Buffer.isBuffer(src)) data = src;
                        else if (src instanceof ArrayBuffer) data = Buffer.from(new Uint8Array(src));
                        else {
                            var match;
                            if (match = /^data:.+?;base64,(.*)$/.exec(src)) data = Buffer.from(match[1], 'base64');
                            else {
                                data = fs.readFileSync(src);
                                if (!data) return;
                            }
                        }
                        if (data[0] === 0xff && data[1] === 0xd8) return new JPEG(data, label);
                        else if (data[0] === 0x89 && data.toString('ascii', 1, 4) === 'PNG') return new PNGImage(data, label);
                        else throw new Error('Unknown image format.');
                    };
                    return PDFImage;
                }();
                var ImagesMixin = {
                    initImages: function initImages() {
                        this._imageRegistry = {};
                        return this._imageCount = 0;
                    },
                    image: function image(src, x, y) {
                        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                        var bh, bp, bw, image, ip, left, left1, rotateAngle, originX, originY;
                        if (typeof x === 'object') {
                            options = x;
                            x = null;
                        }
                        // Ignore orientation based on document options or image options
                        var ignoreOrientation = options.ignoreOrientation || options.ignoreOrientation !== false && this.options.ignoreOrientation;
                        x = (left = x != null ? x : options.x) != null ? left : this.x;
                        y = (left1 = y != null ? y : options.y) != null ? left1 : this.y;
                        if (typeof src === 'string') image = this._imageRegistry[src];
                        if (!image) {
                            if (src.width && src.height) image = src;
                            else image = this.openImage(src);
                        }
                        if (!image.obj) image.embed(this);
                        if (this.page.xobjects[image.label] == null) this.page.xobjects[image.label] = image.obj;
                        var _image = image, width = _image.width, height = _image.height;
                        // If EXIF orientation calls for it, swap width and height
                        if (!ignoreOrientation && image.orientation > 4) {
                            var _ref3 = [
                                height,
                                width
                            ];
                            width = _ref3[0];
                            height = _ref3[1];
                        }
                        var w = options.width || width;
                        var h = options.height || height;
                        if (options.width && !options.height) {
                            var wp = w / width;
                            w = width * wp;
                            h = height * wp;
                        } else if (options.height && !options.width) {
                            var hp = h / height;
                            w = width * hp;
                            h = height * hp;
                        } else if (options.scale) {
                            w = width * options.scale;
                            h = height * options.scale;
                        } else if (options.fit) {
                            var _options$fit = options.fit;
                            bw = _options$fit[0];
                            bh = _options$fit[1];
                            bp = bw / bh;
                            ip = width / height;
                            if (ip > bp) {
                                w = bw;
                                h = bw / ip;
                            } else {
                                h = bh;
                                w = bh * ip;
                            }
                        } else if (options.cover) {
                            var _options$cover = options.cover;
                            bw = _options$cover[0];
                            bh = _options$cover[1];
                            bp = bw / bh;
                            ip = width / height;
                            if (ip > bp) {
                                h = bh;
                                w = bh * ip;
                            } else {
                                w = bw;
                                h = bw / ip;
                            }
                        }
                        if (options.fit || options.cover) {
                            if (options.align === 'center') x = x + bw / 2 - w / 2;
                            else if (options.align === 'right') x = x + bw - w;
                            if (options.valign === 'center') y = y + bh / 2 - h / 2;
                            else if (options.valign === 'bottom') y = y + bh - h;
                        }
                        if (!ignoreOrientation) switch(image.orientation){
                            // No orientation (need to flip image, though, because of the default transform matrix on the document)
                            default:
                            case 1:
                                h = -h;
                                y -= h;
                                rotateAngle = 0;
                                break;
                            // Flip Horizontal
                            case 2:
                                w = -w;
                                h = -h;
                                x -= w;
                                y -= h;
                                rotateAngle = 0;
                                break;
                            // Rotate 180 degrees
                            case 3:
                                originX = x;
                                originY = y;
                                h = -h;
                                x -= w;
                                rotateAngle = 180;
                                break;
                            // Flip vertical
                            case 4:
                                break;
                            // Flip horizontally and rotate 270 degrees CW
                            case 5:
                                originX = x;
                                originY = y;
                                var _ref4 = [
                                    h,
                                    w
                                ];
                                w = _ref4[0];
                                h = _ref4[1];
                                y -= h;
                                rotateAngle = 90;
                                break;
                            // Rotate 90 degrees CW
                            case 6:
                                originX = x;
                                originY = y;
                                var _ref5 = [
                                    h,
                                    w
                                ];
                                w = _ref5[0];
                                h = _ref5[1];
                                h = -h;
                                rotateAngle = 90;
                                break;
                            // Flip horizontally and rotate 90 degrees CW
                            case 7:
                                originX = x;
                                originY = y;
                                var _ref6 = [
                                    h,
                                    w
                                ];
                                w = _ref6[0];
                                h = _ref6[1];
                                h = -h;
                                w = -w;
                                x -= w;
                                rotateAngle = 90;
                                break;
                            // Rotate 270 degrees CW
                            case 8:
                                originX = x;
                                originY = y;
                                var _ref7 = [
                                    h,
                                    w
                                ];
                                w = _ref7[0];
                                h = _ref7[1];
                                h = -h;
                                x -= w;
                                y -= h;
                                rotateAngle = -90;
                                break;
                        }
                        else {
                            h = -h;
                            y -= h;
                            rotateAngle = 0;
                        }
                        // create link annotations if the link option is given
                        if (options.link != null) this.link(x, y, w, h, options.link);
                        if (options.goTo != null) this.goTo(x, y, w, h, options.goTo);
                        if (options.destination != null) this.addNamedDestination(options.destination, 'XYZ', x, y, null);
                        // Set the current y position to below the image if it is in the document flow
                        if (this.y === y) this.y += h;
                        this.save();
                        if (rotateAngle) this.rotate(rotateAngle, {
                            origin: [
                                originX,
                                originY
                            ]
                        });
                        this.transform(w, 0, 0, h, x, y);
                        this.addContent("/" + image.label + " Do");
                        this.restore();
                        return this;
                    },
                    openImage: function openImage(src) {
                        var image;
                        if (typeof src === 'string') image = this._imageRegistry[src];
                        if (!image) {
                            image = PDFImage.open(src, "I" + ++this._imageCount);
                            if (typeof src === 'string') this._imageRegistry[src] = image;
                        }
                        return image;
                    }
                };
                var AnnotationsMixin = {
                    annotate: function annotate(x, y, w, h, options) {
                        options.Type = 'Annot';
                        options.Rect = this._convertRect(x, y, w, h);
                        options.Border = [
                            0,
                            0,
                            0
                        ];
                        if (options.Subtype === 'Link' && typeof options.F === 'undefined') options.F = 4; // Print Annotation Flag
                        if (options.Subtype !== 'Link') {
                            if (options.C == null) options.C = this._normalizeColor(options.color || [
                                0,
                                0,
                                0
                            ]);
                        } // convert colors
                        delete options.color;
                        if (typeof options.Dest === 'string') options.Dest = new String(options.Dest);
                        // Capitalize keys
                        for(var key in options){
                            var val = options[key];
                            options[key[0].toUpperCase() + key.slice(1)] = val;
                        }
                        var ref = this.ref(options);
                        this.page.annotations.push(ref);
                        ref.end();
                        return this;
                    },
                    note: function note(x, y, w, h, contents) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        options.Subtype = 'Text';
                        options.Contents = new String(contents);
                        if (options.Name == null) options.Name = 'Comment';
                        if (options.color == null) options.color = [
                            243,
                            223,
                            92
                        ];
                        return this.annotate(x, y, w, h, options);
                    },
                    goTo: function goTo(x, y, w, h, name) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        options.Subtype = 'Link';
                        options.A = this.ref({
                            S: 'GoTo',
                            D: new String(name)
                        });
                        options.A.end();
                        return this.annotate(x, y, w, h, options);
                    },
                    link: function link(x, y, w, h, url) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        options.Subtype = 'Link';
                        if (typeof url === 'number') {
                            // Link to a page in the document (the page must already exist)
                            var pages = this._root.data.Pages.data;
                            if (url >= 0 && url < pages.Kids.length) {
                                options.A = this.ref({
                                    S: 'GoTo',
                                    D: [
                                        pages.Kids[url],
                                        'XYZ',
                                        null,
                                        null,
                                        null
                                    ]
                                });
                                options.A.end();
                            } else throw new Error("The document has no page " + url);
                        } else {
                            // Link to an external url
                            options.A = this.ref({
                                S: 'URI',
                                URI: new String(url)
                            });
                            options.A.end();
                        }
                        return this.annotate(x, y, w, h, options);
                    },
                    _markup: function _markup(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        var _this$_convertRect = this._convertRect(x, y, w, h), x1 = _this$_convertRect[0], y1 = _this$_convertRect[1], x2 = _this$_convertRect[2], y2 = _this$_convertRect[3];
                        options.QuadPoints = [
                            x1,
                            y2,
                            x2,
                            y2,
                            x1,
                            y1,
                            x2,
                            y1
                        ];
                        options.Contents = new String();
                        return this.annotate(x, y, w, h, options);
                    },
                    highlight: function highlight(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = 'Highlight';
                        if (options.color == null) options.color = [
                            241,
                            238,
                            148
                        ];
                        return this._markup(x, y, w, h, options);
                    },
                    underline: function underline(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = 'Underline';
                        return this._markup(x, y, w, h, options);
                    },
                    strike: function strike(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = 'StrikeOut';
                        return this._markup(x, y, w, h, options);
                    },
                    lineAnnotation: function lineAnnotation(x1, y1, x2, y2) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = 'Line';
                        options.Contents = new String();
                        options.L = [
                            x1,
                            this.page.height - y1,
                            x2,
                            this.page.height - y2
                        ];
                        return this.annotate(x1, y1, x2, y2, options);
                    },
                    rectAnnotation: function rectAnnotation(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = 'Square';
                        options.Contents = new String();
                        return this.annotate(x, y, w, h, options);
                    },
                    ellipseAnnotation: function ellipseAnnotation(x, y, w, h) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        options.Subtype = 'Circle';
                        options.Contents = new String();
                        return this.annotate(x, y, w, h, options);
                    },
                    textAnnotation: function textAnnotation(x, y, w, h, text) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        options.Subtype = 'FreeText';
                        options.Contents = new String(text);
                        options.DA = new String();
                        return this.annotate(x, y, w, h, options);
                    },
                    fileAnnotation: function fileAnnotation(x, y, w, h) {
                        var file = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        // create hidden file
                        var filespec = this.file(file.src, Object.assign({
                            hidden: true
                        }, file));
                        options.Subtype = 'FileAttachment';
                        options.FS = filespec;
                        // add description from filespec unless description (Contents) has already been set
                        if (options.Contents) options.Contents = new String(options.Contents);
                        else if (filespec.data.Desc) options.Contents = filespec.data.Desc;
                        return this.annotate(x, y, w, h, options);
                    },
                    _convertRect: function _convertRect(x1, y1, w, h) {
                        // flip y1 and y2
                        var y2 = y1;
                        y1 += h;
                        // make x2
                        var x2 = x1 + w;
                        // apply current transformation matrix to points
                        var _this$_ctm = this._ctm, m0 = _this$_ctm[0], m1 = _this$_ctm[1], m2 = _this$_ctm[2], m3 = _this$_ctm[3], m4 = _this$_ctm[4], m5 = _this$_ctm[5];
                        x1 = m0 * x1 + m2 * y1 + m4;
                        y1 = m1 * x1 + m3 * y1 + m5;
                        x2 = m0 * x2 + m2 * y2 + m4;
                        y2 = m1 * x2 + m3 * y2 + m5;
                        return [
                            x1,
                            y1,
                            x2,
                            y2
                        ];
                    }
                };
                var PDFOutline = /*#__PURE__*/ function() {
                    function PDFOutline(document1, parent, title, dest) {
                        var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                            expanded: false
                        };
                        this.document = document1;
                        this.options = options;
                        this.outlineData = {};
                        if (dest !== null) this.outlineData['Dest'] = [
                            dest.dictionary,
                            'Fit'
                        ];
                        if (parent !== null) this.outlineData['Parent'] = parent;
                        if (title !== null) this.outlineData['Title'] = new String(title);
                        this.dictionary = this.document.ref(this.outlineData);
                        this.children = [];
                    }
                    var _proto17 = PDFOutline.prototype;
                    _proto17.addItem = function addItem(title) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                            expanded: false
                        };
                        var result = new PDFOutline(this.document, this.dictionary, title, this.document.page, options);
                        this.children.push(result);
                        return result;
                    };
                    _proto17.endOutline = function endOutline() {
                        if (this.children.length > 0) {
                            if (this.options.expanded) this.outlineData.Count = this.children.length;
                            var _first2 = this.children[0], _last2 = this.children[this.children.length - 1];
                            this.outlineData.First = _first2.dictionary;
                            this.outlineData.Last = _last2.dictionary;
                            for(var i = 0, len = this.children.length; i < len; i++){
                                var child = this.children[i];
                                if (i > 0) child.outlineData.Prev = this.children[i - 1].dictionary;
                                if (i < this.children.length - 1) child.outlineData.Next = this.children[i + 1].dictionary;
                                child.endOutline();
                            }
                        }
                        return this.dictionary.end();
                    };
                    return PDFOutline;
                }();
                var OutlineMixin = {
                    initOutline: function initOutline() {
                        return this.outline = new PDFOutline(this, null, null, null);
                    },
                    endOutline: function endOutline() {
                        this.outline.endOutline();
                        if (this.outline.children.length > 0) {
                            this._root.data.Outlines = this.outline.dictionary;
                            return this._root.data.PageMode = 'UseOutlines';
                        }
                    }
                };
                /*
PDFStructureContent - a reference to a marked structure content
By Ben Schmidt
*/ var PDFStructureContent = /*#__PURE__*/ function() {
                    function PDFStructureContent(pageRef, mcid) {
                        this.refs = [
                            {
                                pageRef: pageRef,
                                mcid: mcid
                            }
                        ];
                    }
                    var _proto18 = PDFStructureContent.prototype;
                    _proto18.push = function push(structContent) {
                        var _this16 = this;
                        structContent.refs.forEach(function(ref) {
                            return _this16.refs.push(ref);
                        });
                    };
                    return PDFStructureContent;
                }();
                /*
PDFStructureElement - represents an element in the PDF logical structure tree
By Ben Schmidt
*/ var PDFStructureElement = /*#__PURE__*/ function() {
                    function PDFStructureElement(document1, type) {
                        var _this17 = this;
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                        this.document = document1;
                        this._attached = false;
                        this._ended = false;
                        this._flushed = false;
                        this.dictionary = document1.ref({
                            // Type: "StructElem",
                            S: type
                        });
                        var data = this.dictionary.data;
                        if (Array.isArray(options) || this._isValidChild(options)) {
                            children = options;
                            options = {};
                        }
                        if (typeof options.title !== 'undefined') data.T = new String(options.title);
                        if (typeof options.lang !== 'undefined') data.Lang = new String(options.lang);
                        if (typeof options.alt !== 'undefined') data.Alt = new String(options.alt);
                        if (typeof options.expanded !== 'undefined') data.E = new String(options.expanded);
                        if (typeof options.actual !== 'undefined') data.ActualText = new String(options.actual);
                        this._children = [];
                        if (children) {
                            if (!Array.isArray(children)) children = [
                                children
                            ];
                            children.forEach(function(child) {
                                return _this17.add(child);
                            });
                            this.end();
                        }
                    }
                    var _proto19 = PDFStructureElement.prototype;
                    _proto19.add = function add(child) {
                        if (this._ended) throw new Error("Cannot add child to already-ended structure element");
                        if (!this._isValidChild(child)) throw new Error("Invalid structure element child");
                        if (child instanceof PDFStructureElement) {
                            child.setParent(this.dictionary);
                            if (this._attached) child.setAttached();
                        }
                        if (child instanceof PDFStructureContent) this._addContentToParentTree(child);
                        if (typeof child === 'function' && this._attached) // _contentForClosure() adds the content to the parent tree
                        child = this._contentForClosure(child);
                        this._children.push(child);
                        return this;
                    };
                    _proto19._addContentToParentTree = function _addContentToParentTree(content) {
                        var _this18 = this;
                        content.refs.forEach(function(_ref) {
                            var pageRef = _ref.pageRef, mcid = _ref.mcid;
                            var pageStructParents = _this18.document.getStructParentTree().get(pageRef.data.StructParents);
                            pageStructParents[mcid] = _this18.dictionary;
                        });
                    };
                    _proto19.setParent = function setParent(parentRef) {
                        if (this.dictionary.data.P) throw new Error("Structure element added to more than one parent");
                        this.dictionary.data.P = parentRef;
                        this._flush();
                    };
                    _proto19.setAttached = function setAttached() {
                        var _this19 = this;
                        if (this._attached) return;
                        this._children.forEach(function(child, index) {
                            if (child instanceof PDFStructureElement) child.setAttached();
                            if (typeof child === 'function') _this19._children[index] = _this19._contentForClosure(child);
                        });
                        this._attached = true;
                        this._flush();
                    };
                    _proto19.end = function end() {
                        if (this._ended) return;
                        this._children.filter(function(child) {
                            return child instanceof PDFStructureElement;
                        }).forEach(function(child) {
                            return child.end();
                        });
                        this._ended = true;
                        this._flush();
                    };
                    _proto19._isValidChild = function _isValidChild(child) {
                        return child instanceof PDFStructureElement || child instanceof PDFStructureContent || typeof child === 'function';
                    };
                    _proto19._contentForClosure = function _contentForClosure(closure) {
                        var content = this.document.markStructureContent(this.dictionary.data.S);
                        closure();
                        this.document.endMarkedContent();
                        this._addContentToParentTree(content);
                        return content;
                    };
                    _proto19._isFlushable = function _isFlushable() {
                        if (!this.dictionary.data.P || !this._ended) return false;
                        return this._children.every(function(child) {
                            if (typeof child === 'function') return false;
                            if (child instanceof PDFStructureElement) return child._isFlushable();
                            return true;
                        });
                    };
                    _proto19._flush = function _flush() {
                        var _this20 = this;
                        if (this._flushed || !this._isFlushable()) return;
                        this.dictionary.data.K = [];
                        this._children.forEach(function(child) {
                            return _this20._flushChild(child);
                        });
                        this.dictionary.end();
                        // free memory used by children; the dictionary itself may still be
                        // referenced by a parent structure element or root, but we can
                        // at least trim the tree here
                        this._children = [];
                        this.dictionary.data.K = null;
                        this._flushed = true;
                    };
                    _proto19._flushChild = function _flushChild(child) {
                        var _this21 = this;
                        if (child instanceof PDFStructureElement) this.dictionary.data.K.push(child.dictionary);
                        if (child instanceof PDFStructureContent) child.refs.forEach(function(_ref2) {
                            var pageRef = _ref2.pageRef, mcid = _ref2.mcid;
                            if (!_this21.dictionary.data.Pg) _this21.dictionary.data.Pg = pageRef;
                            if (_this21.dictionary.data.Pg === pageRef) _this21.dictionary.data.K.push(mcid);
                            else _this21.dictionary.data.K.push({
                                Type: "MCR",
                                Pg: pageRef,
                                MCID: mcid
                            });
                        });
                    };
                    return PDFStructureElement;
                }();
                /*
PDFNumberTree - represents a number tree object
*/ var PDFNumberTree = /*#__PURE__*/ function(_PDFTree2) {
                    function PDFNumberTree() {
                        return _PDFTree2.apply(this, arguments) || this;
                    }
                    _inheritsLoose(PDFNumberTree, _PDFTree2);
                    var _proto20 = PDFNumberTree.prototype;
                    _proto20._compareKeys = function _compareKeys(a, b) {
                        return parseInt(a) - parseInt(b);
                    };
                    _proto20._keysName = function _keysName() {
                        return "Nums";
                    };
                    _proto20._dataForKey = function _dataForKey(k) {
                        return parseInt(k);
                    };
                    return PDFNumberTree;
                }(PDFTree);
                /*
Markings mixin - support marked content sequences in content streams
By Ben Schmidt
*/ var MarkingsMixin = {
                    initMarkings: function initMarkings(options) {
                        this.structChildren = [];
                        if (options.tagged) {
                            this.getMarkInfoDictionary().data.Marked = true;
                            this.getStructTreeRoot();
                        }
                    },
                    markContent: function markContent(tag) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                        if (tag === 'Artifact' || options && options.mcid) {
                            var toClose = 0;
                            this.page.markings.forEach(function(marking) {
                                if (toClose || marking.structContent || marking.tag === 'Artifact') toClose++;
                            });
                            while(toClose--)this.endMarkedContent();
                        }
                        if (!options) {
                            this.page.markings.push({
                                tag: tag
                            });
                            this.addContent("/" + tag + " BMC");
                            return this;
                        }
                        this.page.markings.push({
                            tag: tag,
                            options: options
                        });
                        var dictionary = {};
                        if (typeof options.mcid !== 'undefined') dictionary.MCID = options.mcid;
                        if (tag === 'Artifact') {
                            if (typeof options.type === 'string') dictionary.Type = options.type;
                            if (Array.isArray(options.bbox)) dictionary.BBox = [
                                options.bbox[0],
                                this.page.height - options.bbox[3],
                                options.bbox[2],
                                this.page.height - options.bbox[1]
                            ];
                            if (Array.isArray(options.attached) && options.attached.every(function(val) {
                                return typeof val === 'string';
                            })) dictionary.Attached = options.attached;
                        }
                        if (tag === 'Span') {
                            if (options.lang) dictionary.Lang = new String(options.lang);
                            if (options.alt) dictionary.Alt = new String(options.alt);
                            if (options.expanded) dictionary.E = new String(options.expanded);
                            if (options.actual) dictionary.ActualText = new String(options.actual);
                        }
                        this.addContent("/" + tag + " " + PDFObject.convert(dictionary) + " BDC");
                        return this;
                    },
                    markStructureContent: function markStructureContent(tag) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var pageStructParents = this.getStructParentTree().get(this.page.structParentTreeKey);
                        var mcid = pageStructParents.length;
                        pageStructParents.push(null);
                        this.markContent(tag, Object.assign({}, options, {
                            mcid: mcid
                        }));
                        var structContent = new PDFStructureContent(this.page.dictionary, mcid);
                        this.page.markings.slice(-1)[0].structContent = structContent;
                        return structContent;
                    },
                    endMarkedContent: function endMarkedContent() {
                        this.page.markings.pop();
                        this.addContent('EMC');
                        return this;
                    },
                    struct: function struct(type) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                        return new PDFStructureElement(this, type, options, children);
                    },
                    addStructure: function addStructure(structElem) {
                        var structTreeRoot = this.getStructTreeRoot();
                        structElem.setParent(structTreeRoot);
                        structElem.setAttached();
                        this.structChildren.push(structElem);
                        if (!structTreeRoot.data.K) structTreeRoot.data.K = [];
                        structTreeRoot.data.K.push(structElem.dictionary);
                        return this;
                    },
                    initPageMarkings: function initPageMarkings(pageMarkings) {
                        var _this22 = this;
                        pageMarkings.forEach(function(marking) {
                            if (marking.structContent) {
                                var structContent = marking.structContent;
                                var newStructContent = _this22.markStructureContent(marking.tag, marking.options);
                                structContent.push(newStructContent);
                                _this22.page.markings.slice(-1)[0].structContent = structContent;
                            } else _this22.markContent(marking.tag, marking.options);
                        });
                    },
                    endPageMarkings: function endPageMarkings(page) {
                        var pageMarkings = page.markings;
                        pageMarkings.forEach(function() {
                            return page.write('EMC');
                        });
                        page.markings = [];
                        return pageMarkings;
                    },
                    getMarkInfoDictionary: function getMarkInfoDictionary() {
                        if (!this._root.data.MarkInfo) this._root.data.MarkInfo = this.ref({});
                        return this._root.data.MarkInfo;
                    },
                    hasMarkInfoDictionary: function hasMarkInfoDictionary() {
                        return !!this._root.data.MarkInfo;
                    },
                    getStructTreeRoot: function getStructTreeRoot() {
                        if (!this._root.data.StructTreeRoot) this._root.data.StructTreeRoot = this.ref({
                            Type: 'StructTreeRoot',
                            ParentTree: new PDFNumberTree(),
                            ParentTreeNextKey: 0
                        });
                        return this._root.data.StructTreeRoot;
                    },
                    getStructParentTree: function getStructParentTree() {
                        return this.getStructTreeRoot().data.ParentTree;
                    },
                    createStructParentTreeNextKey: function createStructParentTreeNextKey() {
                        // initialise the MarkInfo dictionary
                        this.getMarkInfoDictionary();
                        var structTreeRoot = this.getStructTreeRoot();
                        var key = structTreeRoot.data.ParentTreeNextKey++;
                        structTreeRoot.data.ParentTree.add(key, []);
                        return key;
                    },
                    endMarkings: function endMarkings() {
                        var structTreeRoot = this._root.data.StructTreeRoot;
                        if (structTreeRoot) {
                            structTreeRoot.end();
                            this.structChildren.forEach(function(structElem) {
                                return structElem.end();
                            });
                        }
                        if (this._root.data.MarkInfo) this._root.data.MarkInfo.end();
                    }
                };
                var FIELD_FLAGS = {
                    readOnly: 1,
                    required: 2,
                    noExport: 4,
                    multiline: 0x1000,
                    password: 0x2000,
                    toggleToOffButton: 0x4000,
                    radioButton: 0x8000,
                    pushButton: 0x10000,
                    combo: 0x20000,
                    edit: 0x40000,
                    sort: 0x80000,
                    multiSelect: 0x200000,
                    noSpell: 0x400000
                };
                var FIELD_JUSTIFY = {
                    left: 0,
                    center: 1,
                    right: 2
                };
                var VALUE_MAP = {
                    value: 'V',
                    defaultValue: 'DV'
                };
                var FORMAT_SPECIAL = {
                    zip: '0',
                    zipPlus4: '1',
                    zip4: '1',
                    phone: '2',
                    ssn: '3'
                };
                var FORMAT_DEFAULT = {
                    number: {
                        nDec: 0,
                        sepComma: false,
                        negStyle: 'MinusBlack',
                        currency: '',
                        currencyPrepend: true
                    },
                    percent: {
                        nDec: 0,
                        sepComma: false
                    }
                };
                var AcroFormMixin = {
                    /**
   * Must call if adding AcroForms to a document. Must also call font() before
   * this method to set the default font.
   */ initForm: function initForm() {
                        if (!this._font) throw new Error('Must set a font before calling initForm method');
                        this._acroform = {
                            fonts: {},
                            defaultFont: this._font.name
                        };
                        this._acroform.fonts[this._font.id] = this._font.ref();
                        var data = {
                            Fields: [],
                            NeedAppearances: true,
                            DA: new String("/" + this._font.id + " 0 Tf 0 g"),
                            DR: {
                                Font: {}
                            }
                        };
                        data.DR.Font[this._font.id] = this._font.ref();
                        var AcroForm = this.ref(data);
                        this._root.data.AcroForm = AcroForm;
                        return this;
                    },
                    /**
   * Called automatically by document.js
   */ endAcroForm: function endAcroForm() {
                        var _this23 = this;
                        if (this._root.data.AcroForm) {
                            if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont) throw new Error('No fonts specified for PDF form');
                            var fontDict = this._root.data.AcroForm.data.DR.Font;
                            Object.keys(this._acroform.fonts).forEach(function(name) {
                                fontDict[name] = _this23._acroform.fonts[name];
                            });
                            this._root.data.AcroForm.data.Fields.forEach(function(fieldRef) {
                                _this23._endChild(fieldRef);
                            });
                            this._root.data.AcroForm.end();
                        }
                        return this;
                    },
                    _endChild: function _endChild(ref) {
                        var _this24 = this;
                        if (Array.isArray(ref.data.Kids)) {
                            ref.data.Kids.forEach(function(childRef) {
                                _this24._endChild(childRef);
                            });
                            ref.end();
                        }
                        return this;
                    },
                    /**
   * Creates and adds a form field to the document. Form fields are intermediate
   * nodes in a PDF form that are used to specify form name heirarchy and form
   * value defaults.
   * @param {string} name - field name (T attribute in field dictionary)
   * @param {object} options  - other attributes to include in field dictionary
   */ formField: function formField(name) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        var fieldDict = this._fieldDict(name, null, options);
                        var fieldRef = this.ref(fieldDict);
                        this._addToParent(fieldRef);
                        return fieldRef;
                    },
                    /**
   * Creates and adds a Form Annotation to the document. Form annotations are
   * called Widget annotations internally within a PDF file.
   * @param {string} name - form field name (T attribute of widget annotation
   * dictionary)
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   * @param {object} options
   */ formAnnotation: function formAnnotation(name, type, x, y, w, h) {
                        var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
                        var fieldDict = this._fieldDict(name, type, options);
                        fieldDict.Subtype = 'Widget';
                        if (fieldDict.F === undefined) fieldDict.F = 4; // print the annotation
                        // Add Field annot to page, and get it's ref
                        this.annotate(x, y, w, h, fieldDict);
                        var annotRef = this.page.annotations[this.page.annotations.length - 1];
                        return this._addToParent(annotRef);
                    },
                    formText: function formText(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, 'text', x, y, w, h, options);
                    },
                    formPushButton: function formPushButton(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, 'pushButton', x, y, w, h, options);
                    },
                    formCombo: function formCombo(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, 'combo', x, y, w, h, options);
                    },
                    formList: function formList(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, 'list', x, y, w, h, options);
                    },
                    formRadioButton: function formRadioButton(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, 'radioButton', x, y, w, h, options);
                    },
                    formCheckbox: function formCheckbox(name, x, y, w, h) {
                        var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                        return this.formAnnotation(name, 'checkbox', x, y, w, h, options);
                    },
                    _addToParent: function _addToParent(fieldRef) {
                        var parent = fieldRef.data.Parent;
                        if (parent) {
                            if (!parent.data.Kids) parent.data.Kids = [];
                            parent.data.Kids.push(fieldRef);
                        } else this._root.data.AcroForm.data.Fields.push(fieldRef);
                        return this;
                    },
                    _fieldDict: function _fieldDict(name, type) {
                        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        if (!this._acroform) throw new Error('Call document.initForm() method before adding form elements to document');
                        var opts = Object.assign({}, options);
                        if (type !== null) opts = this._resolveType(type, options);
                        opts = this._resolveFlags(opts);
                        opts = this._resolveJustify(opts);
                        opts = this._resolveFont(opts);
                        opts = this._resolveStrings(opts);
                        opts = this._resolveColors(opts);
                        opts = this._resolveFormat(opts);
                        opts.T = new String(name);
                        if (opts.parent) {
                            opts.Parent = opts.parent;
                            delete opts.parent;
                        }
                        return opts;
                    },
                    _resolveType: function _resolveType(type, opts) {
                        if (type === 'text') opts.FT = 'Tx';
                        else if (type === 'pushButton') {
                            opts.FT = 'Btn';
                            opts.pushButton = true;
                        } else if (type === 'radioButton') {
                            opts.FT = 'Btn';
                            opts.radioButton = true;
                        } else if (type === 'checkbox') opts.FT = 'Btn';
                        else if (type === 'combo') {
                            opts.FT = 'Ch';
                            opts.combo = true;
                        } else if (type === 'list') opts.FT = 'Ch';
                        else throw new Error("Invalid form annotation type '" + type + "'");
                        return opts;
                    },
                    _resolveFormat: function _resolveFormat(opts) {
                        var f = opts.format;
                        if (f && f.type) {
                            var fnKeystroke;
                            var fnFormat;
                            var params = '';
                            if (FORMAT_SPECIAL[f.type] !== undefined) {
                                fnKeystroke = "AFSpecial_Keystroke";
                                fnFormat = "AFSpecial_Format";
                                params = FORMAT_SPECIAL[f.type];
                            } else {
                                var format = f.type.charAt(0).toUpperCase() + f.type.slice(1);
                                fnKeystroke = "AF" + format + "_Keystroke";
                                fnFormat = "AF" + format + "_Format";
                                if (f.type === 'date') {
                                    fnKeystroke += 'Ex';
                                    params = String(f.param);
                                } else if (f.type === 'time') params = String(f.param);
                                else if (f.type === 'number') {
                                    var p = Object.assign({}, FORMAT_DEFAULT.number, f);
                                    params = String([
                                        String(p.nDec),
                                        p.sepComma ? '0' : '1',
                                        '"' + p.negStyle + '"',
                                        'null',
                                        '"' + p.currency + '"',
                                        String(p.currencyPrepend)
                                    ].join(','));
                                } else if (f.type === 'percent') {
                                    var _p = Object.assign({}, FORMAT_DEFAULT.percent, f);
                                    params = String([
                                        String(_p.nDec),
                                        _p.sepComma ? '0' : '1'
                                    ].join(','));
                                }
                            }
                            opts.AA = opts.AA ? opts.AA : {};
                            opts.AA.K = {
                                S: 'JavaScript',
                                JS: new String(fnKeystroke + "(" + params + ");")
                            };
                            opts.AA.F = {
                                S: 'JavaScript',
                                JS: new String(fnFormat + "(" + params + ");")
                            };
                        }
                        delete opts.format;
                        return opts;
                    },
                    _resolveColors: function _resolveColors(opts) {
                        var color = this._normalizeColor(opts.backgroundColor);
                        if (color) {
                            if (!opts.MK) opts.MK = {};
                            opts.MK.BG = color;
                        }
                        color = this._normalizeColor(opts.borderColor);
                        if (color) {
                            if (!opts.MK) opts.MK = {};
                            opts.MK.BC = color;
                        }
                        delete opts.backgroundColor;
                        delete opts.borderColor;
                        return opts;
                    },
                    _resolveFlags: function _resolveFlags(options) {
                        var result = 0;
                        Object.keys(options).forEach(function(key) {
                            if (FIELD_FLAGS[key]) {
                                if (options[key]) result |= FIELD_FLAGS[key];
                                delete options[key];
                            }
                        });
                        if (result !== 0) {
                            options.Ff = options.Ff ? options.Ff : 0;
                            options.Ff |= result;
                        }
                        return options;
                    },
                    _resolveJustify: function _resolveJustify(options) {
                        var result = 0;
                        if (options.align !== undefined) {
                            if (typeof FIELD_JUSTIFY[options.align] === 'number') result = FIELD_JUSTIFY[options.align];
                            delete options.align;
                        }
                        if (result !== 0) options.Q = result; // default
                        return options;
                    },
                    _resolveFont: function _resolveFont(options) {
                        // add current font to document-level AcroForm dict if necessary
                        if (this._acroform.fonts[this._font.id] == null) this._acroform.fonts[this._font.id] = this._font.ref();
                        // add current font to field's resource dict (RD) if not the default acroform font
                        if (this._acroform.defaultFont !== this._font.name) {
                            options.DR = {
                                Font: {}
                            };
                            // Get the fontSize option. If not set use auto sizing
                            var fontSize = options.fontSize || 0;
                            options.DR.Font[this._font.id] = this._font.ref();
                            options.DA = new String("/" + this._font.id + " " + fontSize + " Tf 0 g");
                        }
                        return options;
                    },
                    _resolveStrings: function _resolveStrings(options) {
                        var select = [];
                        function appendChoices(a) {
                            if (Array.isArray(a)) {
                                for(var idx = 0; idx < a.length; idx++)if (typeof a[idx] === 'string') select.push(new String(a[idx]));
                                else select.push(a[idx]);
                            }
                        }
                        appendChoices(options.Opt);
                        if (options.select) {
                            appendChoices(options.select);
                            delete options.select;
                        }
                        if (select.length) options.Opt = select;
                        Object.keys(VALUE_MAP).forEach(function(key) {
                            if (options[key] !== undefined) {
                                options[VALUE_MAP[key]] = options[key];
                                delete options[key];
                            }
                        });
                        [
                            'V',
                            'DV'
                        ].forEach(function(key) {
                            if (typeof options[key] === 'string') options[key] = new String(options[key]);
                        });
                        if (options.MK && options.MK.CA) options.MK.CA = new String(options.MK.CA);
                        if (options.label) {
                            options.MK = options.MK ? options.MK : {};
                            options.MK.CA = new String(options.label);
                            delete options.label;
                        }
                        return options;
                    }
                };
                var AttachmentsMixin = {
                    /**
   * Embed contents of `src` in PDF
   * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
   * @param {object} options
   *  * options.name: filename to be shown in PDF, will use `src` if none set
   *  * options.type: filetype to be shown in PDF
   *  * options.description: description to be shown in PDF
   *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
   *  * options.creationDate: override creation date
   *  * options.modifiedDate: override modified date
   *  * options.relationship: Relationship between the PDF document and its attached file. Can be 'Alternative', 'Data', 'Source', 'Supplement' or 'Unspecified'.
   * @returns filespec reference
   */ file: function file(src) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        options.name = options.name || src;
                        options.relationship = options.relationship || 'Unspecified';
                        var refBody = {
                            Type: 'EmbeddedFile',
                            Params: {}
                        };
                        var data;
                        if (!src) throw new Error('No src specified');
                        if (Buffer.isBuffer(src)) data = src;
                        else if (src instanceof ArrayBuffer) data = Buffer.from(new Uint8Array(src));
                        else {
                            var match;
                            if (match = /^data:(.*?);base64,(.*)$/.exec(src)) {
                                if (match[1]) refBody.Subtype = match[1].replace('/', '#2F');
                                data = Buffer.from(match[2], 'base64');
                            } else {
                                data = fs.readFileSync(src);
                                if (!data) throw new Error("Could not read contents of file at filepath " + src);
                                // update CreationDate and ModDate
                                var _fs$statSync = fs.statSync(src), birthtime = _fs$statSync.birthtime, ctime = _fs$statSync.ctime;
                                refBody.Params.CreationDate = birthtime;
                                refBody.Params.ModDate = ctime;
                            }
                        }
                        // override creation date and modified date
                        if (options.creationDate instanceof Date) refBody.Params.CreationDate = options.creationDate;
                        if (options.modifiedDate instanceof Date) refBody.Params.ModDate = options.modifiedDate;
                        // add optional subtype
                        if (options.type) refBody.Subtype = options.type.replace('/', '#2F');
                        // add checksum and size information
                        var checksum = _cryptoJs.default.MD5(_cryptoJs.default.lib.WordArray.create(new Uint8Array(data)));
                        refBody.Params.CheckSum = new String(checksum);
                        refBody.Params.Size = data.byteLength;
                        // save some space when embedding the same file again
                        // if a file with the same name and metadata exists, reuse its reference
                        var ref;
                        if (!this._fileRegistry) this._fileRegistry = {};
                        var file = this._fileRegistry[options.name];
                        if (file && isEqual(refBody, file)) ref = file.ref;
                        else {
                            ref = this.ref(refBody);
                            ref.end(data);
                            this._fileRegistry[options.name] = Object.assign({}, refBody, {
                                ref: ref
                            });
                        }
                        // add filespec for embedded file
                        var fileSpecBody = {
                            Type: 'Filespec',
                            AFRelationship: options.relationship,
                            F: new String(options.name),
                            EF: {
                                F: ref
                            },
                            UF: new String(options.name)
                        };
                        if (options.description) fileSpecBody.Desc = new String(options.description);
                        var filespec = this.ref(fileSpecBody);
                        filespec.end();
                        if (!options.hidden) this.addNamedEmbeddedFile(options.name, filespec);
                        // Add file to the catalogue to be PDF/A3 compliant
                        if (this._root.data.AF) this._root.data.AF.push(filespec);
                        else this._root.data.AF = [
                            filespec
                        ];
                        return filespec;
                    }
                };
                /** check two embedded file metadata objects for equality */ function isEqual(a, b) {
                    return a.Subtype === b.Subtype && a.Params.CheckSum.toString() === b.Params.CheckSum.toString() && a.Params.Size === b.Params.Size && a.Params.CreationDate.getTime() === b.Params.CreationDate.getTime() && (a.Params.ModDate === undefined && b.Params.ModDate === undefined || a.Params.ModDate.getTime() === b.Params.ModDate.getTime());
                }
                var PDFA = {
                    initPDFA: function initPDFA(pSubset) {
                        if (pSubset.charAt(pSubset.length - 3) === '-') {
                            this.subset_conformance = pSubset.charAt(pSubset.length - 1).toUpperCase();
                            this.subset = parseInt(pSubset.charAt(pSubset.length - 2));
                        } else {
                            // Default to Basic conformance when user doesn't specify
                            this.subset_conformance = 'B';
                            this.subset = parseInt(pSubset.charAt(pSubset.length - 1));
                        }
                    },
                    endSubset: function endSubset() {
                        this._addPdfaMetadata();
                        this._addColorOutputIntent();
                    },
                    _addColorOutputIntent: function _addColorOutputIntent() {
                        var iccProfile = Buffer("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", "base64");
                        var colorProfileRef = this.ref({
                            Length: iccProfile.length,
                            N: 3
                        });
                        colorProfileRef.write(iccProfile);
                        colorProfileRef.end();
                        var intentRef = this.ref({
                            Type: 'OutputIntent',
                            S: 'GTS_PDFA1',
                            Info: new String('sRGB IEC61966-2.1'),
                            OutputConditionIdentifier: new String('sRGB IEC61966-2.1'),
                            DestOutputProfile: colorProfileRef
                        });
                        intentRef.end();
                        this._root.data.OutputIntents = [
                            intentRef
                        ];
                    },
                    _getPdfaid: function _getPdfaid() {
                        return "\n        <rdf:Description xmlns:pdfaid=\"http://www.aiim.org/pdfa/ns/id/\" rdf:about=\"\">\n            <pdfaid:part>" + this.subset + "</pdfaid:part>\n            <pdfaid:conformance>" + this.subset_conformance + "</pdfaid:conformance>\n        </rdf:Description>\n        ";
                    },
                    _addPdfaMetadata: function _addPdfaMetadata() {
                        this.appendXML(this._getPdfaid());
                    }
                };
                var PDFUA = {
                    initPDFUA: function initPDFUA() {
                        this.subset = 1;
                    },
                    endSubset: function endSubset() {
                        this._addPdfuaMetadata();
                    },
                    _addPdfuaMetadata: function _addPdfuaMetadata() {
                        this.appendXML(this._getPdfuaid());
                    },
                    _getPdfuaid: function _getPdfuaid() {
                        return "\n        <rdf:Description xmlns:pdfuaid=\"http://www.aiim.org/pdfua/ns/id/\" rdf:about=\"\">\n            <pdfuaid:part>" + this.subset + "</pdfuaid:part>\n        </rdf:Description>\n        ";
                    }
                };
                var SubsetMixin = {
                    _importSubset: function _importSubset(subset) {
                        Object.assign(this, subset);
                    },
                    initSubset: function initSubset(options) {
                        switch(options.subset){
                            case 'PDF/A-1':
                            case 'PDF/A-1a':
                            case 'PDF/A-1b':
                            case 'PDF/A-2':
                            case 'PDF/A-2a':
                            case 'PDF/A-2b':
                            case 'PDF/A-3':
                            case 'PDF/A-3a':
                            case 'PDF/A-3b':
                                this._importSubset(PDFA);
                                this.initPDFA(options.subset);
                                break;
                            case 'PDF/UA':
                                this._importSubset(PDFUA);
                                this.initPDFUA();
                                break;
                        }
                    }
                };
                var PDFMetadata = /*#__PURE__*/ function() {
                    function PDFMetadata() {
                        this._metadata = "\n        <?xpacket begin=\"\uFEFF\" id=\"W5M0MpCehiHzreSzNTczkc9d\"?>\n            <x:xmpmeta xmlns:x=\"adobe:ns:meta/\">\n                <rdf:RDF xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\">\n        ";
                    }
                    var _proto21 = PDFMetadata.prototype;
                    _proto21._closeTags = function _closeTags() {
                        this._metadata = this._metadata.concat("\n                </rdf:RDF>\n            </x:xmpmeta>\n        <?xpacket end=\"w\"?>\n        ");
                    };
                    _proto21.append = function append(xml) {
                        var newline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                        this._metadata = this._metadata.concat(xml);
                        if (newline) this._metadata = this._metadata.concat('\n');
                    };
                    _proto21.getXML = function getXML() {
                        return this._metadata;
                    };
                    _proto21.getLength = function getLength() {
                        return this._metadata.length;
                    };
                    _proto21.end = function end() {
                        this._closeTags();
                        this._metadata = this._metadata.trim();
                    };
                    return PDFMetadata;
                }();
                var MetadataMixin = {
                    initMetadata: function initMetadata() {
                        this.metadata = new PDFMetadata();
                    },
                    appendXML: function appendXML(xml) {
                        var newline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                        this.metadata.append(xml, newline);
                    },
                    _addInfo: function _addInfo() {
                        this.appendXML("\n        <rdf:Description rdf:about=\"\" xmlns:xmp=\"http://ns.adobe.com/xap/1.0/\">\n            <xmp:CreateDate>" + (this.info.CreationDate.toISOString().split('.')[0] + "Z") + "</xmp:CreateDate>\n            <xmp:CreatorTool>" + this.info.Creator + "</xmp:CreatorTool>\n        </rdf:Description>\n        ");
                        if (this.info.Title || this.info.Author || this.info.Subject) {
                            this.appendXML("\n            <rdf:Description rdf:about=\"\" xmlns:dc=\"http://purl.org/dc/elements/1.1/\">\n            ");
                            if (this.info.Title) this.appendXML("\n                <dc:title>\n                    <rdf:Alt>\n                        <rdf:li xml:lang=\"x-default\">" + this.info.Title + "</rdf:li>\n                    </rdf:Alt>\n                </dc:title>\n                ");
                            if (this.info.Author) this.appendXML("\n                <dc:creator>\n                    <rdf:Seq>\n                        <rdf:li>" + this.info.Author + "</rdf:li>\n                    </rdf:Seq>\n                </dc:creator>\n                ");
                            if (this.info.Subject) this.appendXML("\n                <dc:description>\n                    <rdf:Alt>\n                        <rdf:li xml:lang=\"x-default\">" + this.info.Subject + "</rdf:li>\n                    </rdf:Alt>\n                </dc:description>\n                ");
                            this.appendXML("\n            </rdf:Description>\n            ");
                        }
                        this.appendXML("\n        <rdf:Description rdf:about=\"\" xmlns:pdf=\"http://ns.adobe.com/pdf/1.3/\">\n            <pdf:Producer>" + this.info.Creator + "</pdf:Producer>", false);
                        if (this.info.Keywords) this.appendXML("\n            <pdf:Keywords>" + this.info.Keywords + "</pdf:Keywords>", false);
                        this.appendXML("\n        </rdf:Description>\n        ");
                    },
                    endMetadata: function endMetadata() {
                        this._addInfo();
                        this.metadata.end();
                        /*
    Metadata was introduced in PDF 1.4, so adding it to 1.3 
    will likely only take up more space.
    */ if (this.version != 1.3) {
                            this.metadataRef = this.ref({
                                length: this.metadata.getLength(),
                                Type: 'Metadata',
                                Subtype: 'XML'
                            });
                            this.metadataRef.compress = false;
                            this.metadataRef.write(Buffer.from(this.metadata.getXML(), 'utf-8'));
                            this.metadataRef.end();
                            this._root.data.Metadata = this.metadataRef;
                        }
                    }
                };
                /*
PDFDocument - represents an entire PDF document
By Devon Govett
*/ var PDFDocument = /*#__PURE__*/ function(_stream$Readable) {
                    function PDFDocument() {
                        var _this25;
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        _this25 = _stream$Readable.call(this, options) || this;
                        _this25.options = options;
                        // PDF version
                        switch(options.pdfVersion){
                            case '1.4':
                                _this25.version = 1.4;
                                break;
                            case '1.5':
                                _this25.version = 1.5;
                                break;
                            case '1.6':
                                _this25.version = 1.6;
                                break;
                            case '1.7':
                            case '1.7ext3':
                                _this25.version = 1.7;
                                break;
                            default:
                                _this25.version = 1.3;
                                break;
                        }
                        // Whether streams should be compressed
                        _this25.compress = _this25.options.compress != null ? _this25.options.compress : true;
                        _this25._pageBuffer = [];
                        _this25._pageBufferStart = 0;
                        // The PDF object store
                        _this25._offsets = [];
                        _this25._waiting = 0;
                        _this25._ended = false;
                        _this25._offset = 0;
                        var Pages = _this25.ref({
                            Type: 'Pages',
                            Count: 0,
                            Kids: []
                        });
                        var Names = _this25.ref({
                            Dests: new PDFNameTree()
                        });
                        _this25._root = _this25.ref({
                            Type: 'Catalog',
                            Pages: Pages,
                            Names: Names
                        });
                        if (_this25.options.lang) _this25._root.data.Lang = new String(_this25.options.lang);
                        // The current page
                        _this25.page = null;
                        // Initialize mixins
                        _this25.initMetadata();
                        _this25.initColor();
                        _this25.initVector();
                        _this25.initFonts(options.font);
                        _this25.initText();
                        _this25.initImages();
                        _this25.initOutline();
                        _this25.initMarkings(options);
                        _this25.initSubset(options);
                        // Initialize the metadata
                        _this25.info = {
                            Producer: 'PDFKit',
                            Creator: 'PDFKit',
                            CreationDate: new Date()
                        };
                        if (_this25.options.info) for(var key in _this25.options.info){
                            var val = _this25.options.info[key];
                            _this25.info[key] = val;
                        }
                        if (_this25.options.displayTitle) _this25._root.data.ViewerPreferences = _this25.ref({
                            DisplayDocTitle: true
                        });
                        // Generate file ID
                        _this25._id = PDFSecurity.generateFileID(_this25.info);
                        // Initialize security settings
                        _this25._security = PDFSecurity.create(_this25, options);
                        // Write the header
                        // PDF version
                        _this25._write("%PDF-" + _this25.version);
                        // 4 binary chars, as recommended by the spec
                        _this25._write('%\xFF\xFF\xFF\xFF');
                        // Add the first page
                        if (_this25.options.autoFirstPage !== false) _this25.addPage();
                        return _this25;
                    }
                    _inheritsLoose(PDFDocument, _stream$Readable);
                    var _proto22 = PDFDocument.prototype;
                    _proto22.addPage = function addPage(options) {
                        if (options == null) options = this.options;
                        // end the current page if needed
                        if (!this.options.bufferPages) this.flushPages();
                        // create a page object
                        this.page = new PDFPage(this, options);
                        this._pageBuffer.push(this.page);
                        // add the page to the object store
                        var pages = this._root.data.Pages.data;
                        pages.Kids.push(this.page.dictionary);
                        pages.Count++;
                        // reset x and y coordinates
                        this.x = this.page.margins.left;
                        this.y = this.page.margins.top;
                        // flip PDF coordinate system so that the origin is in
                        // the top left rather than the bottom left
                        this._ctm = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.transform(1, 0, 0, -1, 0, this.page.height);
                        this.emit('pageAdded');
                        return this;
                    };
                    _proto22.continueOnNewPage = function continueOnNewPage(options) {
                        var pageMarkings = this.endPageMarkings(this.page);
                        this.addPage(options);
                        this.initPageMarkings(pageMarkings);
                        return this;
                    };
                    _proto22.bufferedPageRange = function bufferedPageRange() {
                        return {
                            start: this._pageBufferStart,
                            count: this._pageBuffer.length
                        };
                    };
                    _proto22.switchToPage = function switchToPage(n) {
                        var page;
                        if (!(page = this._pageBuffer[n - this._pageBufferStart])) throw new Error("switchToPage(" + n + ") out of bounds, current buffer covers pages " + this._pageBufferStart + " to " + (this._pageBufferStart + this._pageBuffer.length - 1));
                        return this.page = page;
                    };
                    _proto22.flushPages = function flushPages() {
                        // this local variable exists so we're future-proof against
                        // reentrant calls to flushPages.
                        var pages = this._pageBuffer;
                        this._pageBuffer = [];
                        this._pageBufferStart += pages.length;
                        for(var _iterator10 = _createForOfIteratorHelperLoose(pages), _step10; !(_step10 = _iterator10()).done;){
                            var page = _step10.value;
                            this.endPageMarkings(page);
                            page.end();
                        }
                    };
                    _proto22.addNamedDestination = function addNamedDestination(name) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        if (args.length === 0) args = [
                            'XYZ',
                            null,
                            null,
                            null
                        ];
                        if (args[0] === 'XYZ' && args[2] !== null) args[2] = this.page.height - args[2];
                        args.unshift(this.page.dictionary);
                        this._root.data.Names.data.Dests.add(name, args);
                    };
                    _proto22.addNamedEmbeddedFile = function addNamedEmbeddedFile(name, ref) {
                        if (!this._root.data.Names.data.EmbeddedFiles) // disabling /Limits for this tree fixes attachments not showing in Adobe Reader
                        this._root.data.Names.data.EmbeddedFiles = new PDFNameTree({
                            limits: false
                        });
                        // add filespec to EmbeddedFiles
                        this._root.data.Names.data.EmbeddedFiles.add(name, ref);
                    };
                    _proto22.addNamedJavaScript = function addNamedJavaScript(name, js) {
                        if (!this._root.data.Names.data.JavaScript) this._root.data.Names.data.JavaScript = new PDFNameTree();
                        var data = {
                            JS: new String(js),
                            S: 'JavaScript'
                        };
                        this._root.data.Names.data.JavaScript.add(name, data);
                    };
                    _proto22.ref = function ref(data) {
                        var ref = new PDFReference(this, this._offsets.length + 1, data);
                        this._offsets.push(null); // placeholder for this object's offset once it is finalized
                        this._waiting++;
                        return ref;
                    };
                    _proto22._read = function _read() {};
                    _proto22._write = function _write(data) {
                        if (!Buffer.isBuffer(data)) data = Buffer.from(data + '\n', 'binary');
                        this.push(data);
                        return this._offset += data.length;
                    };
                    _proto22.addContent = function addContent(data) {
                        this.page.write(data);
                        return this;
                    };
                    _proto22._refEnd = function _refEnd(ref) {
                        this._offsets[ref.id - 1] = ref.offset;
                        if (--this._waiting === 0 && this._ended) {
                            this._finalize();
                            return this._ended = false;
                        }
                    };
                    _proto22.end = function end() {
                        this.flushPages();
                        this._info = this.ref();
                        for(var key in this.info){
                            var val = this.info[key];
                            if (typeof val === 'string') val = new String(val);
                            var entry = this.ref(val);
                            entry.end();
                            this._info.data[key] = entry;
                        }
                        this._info.end();
                        for(var name in this._fontFamilies){
                            var font = this._fontFamilies[name];
                            font.finalize();
                        }
                        this.endOutline();
                        this.endMarkings();
                        if (this.subset) this.endSubset();
                        this.endMetadata();
                        this._root.end();
                        this._root.data.Pages.end();
                        this._root.data.Names.end();
                        this.endAcroForm();
                        if (this._root.data.ViewerPreferences) this._root.data.ViewerPreferences.end();
                        if (this._security) this._security.end();
                        if (this._waiting === 0) return this._finalize();
                        else return this._ended = true;
                    };
                    _proto22._finalize = function _finalize() {
                        // generate xref
                        var xRefOffset = this._offset;
                        this._write('xref');
                        this._write("0 " + (this._offsets.length + 1));
                        this._write('0000000000 65535 f ');
                        for(var _iterator11 = _createForOfIteratorHelperLoose(this._offsets), _step11; !(_step11 = _iterator11()).done;){
                            var offset = _step11.value;
                            offset = ("0000000000" + offset).slice(-10);
                            this._write(offset + ' 00000 n ');
                        }
                        // trailer
                        var trailer = {
                            Size: this._offsets.length + 1,
                            Root: this._root,
                            Info: this._info,
                            ID: [
                                this._id,
                                this._id
                            ]
                        };
                        if (this._security) trailer.Encrypt = this._security.dictionary;
                        this._write('trailer');
                        this._write(PDFObject.convert(trailer));
                        this._write('startxref');
                        this._write("" + xRefOffset);
                        this._write('%%EOF');
                        // end the stream
                        return this.push(null);
                    };
                    _proto22.toString = function toString() {
                        return '[object PDFDocument]';
                    };
                    return PDFDocument;
                }(_stream.default.Readable);
                var mixin = function mixin(methods) {
                    Object.assign(PDFDocument.prototype, methods);
                };
                mixin(MetadataMixin);
                mixin(ColorMixin);
                mixin(VectorMixin);
                mixin(FontsMixin);
                mixin(TextMixin);
                mixin(ImagesMixin);
                mixin(AnnotationsMixin);
                mixin(OutlineMixin);
                mixin(MarkingsMixin);
                mixin(AcroFormMixin);
                mixin(AttachmentsMixin);
                mixin(SubsetMixin);
                PDFDocument.LineWrapper = LineWrapper;
                var _default = exports["default"] = PDFDocument;
            /***/ },
            /***/ 90780: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var parent = __webpack_require__(42075);
                __webpack_require__(94712);
                module1.exports = parent;
            /***/ },
            /***/ 90868: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(98828);
                // `Float64Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor('Float64', function(init) {
                    return function Float64Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 91102: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var bind = __webpack_require__(25567);
                var uncurryThis = __webpack_require__(38347);
                var IndexedObject = __webpack_require__(7514);
                var toObject = __webpack_require__(43162);
                var lengthOfArrayLike = __webpack_require__(45495);
                var arraySpeciesCreate = __webpack_require__(45744);
                var push = uncurryThis([].push);
                // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
                var createMethod = function(TYPE) {
                    var IS_MAP = TYPE == 1;
                    var IS_FILTER = TYPE == 2;
                    var IS_SOME = TYPE == 3;
                    var IS_EVERY = TYPE == 4;
                    var IS_FIND_INDEX = TYPE == 6;
                    var IS_FILTER_REJECT = TYPE == 7;
                    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
                    return function($this, callbackfn, that, specificCreate) {
                        var O = toObject($this);
                        var self1 = IndexedObject(O);
                        var boundFunction = bind(callbackfn, that);
                        var length = lengthOfArrayLike(self1);
                        var index = 0;
                        var create = specificCreate || arraySpeciesCreate;
                        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
                        var value, result;
                        for(; length > index; index++)if (NO_HOLES || index in self1) {
                            value = self1[index];
                            result = boundFunction(value, index, O);
                            if (TYPE) {
                                if (IS_MAP) target[index] = result; // map
                                else if (result) switch(TYPE){
                                    case 3:
                                        return true; // some
                                    case 5:
                                        return value; // find
                                    case 6:
                                        return index; // findIndex
                                    case 2:
                                        push(target, value); // filter
                                }
                                else switch(TYPE){
                                    case 4:
                                        return false; // every
                                    case 7:
                                        push(target, value); // filterReject
                                }
                            }
                        }
                        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
                    };
                };
                module1.exports = {
                    // `Array.prototype.forEach` method
                    // https://tc39.es/ecma262/#sec-array.prototype.foreach
                    forEach: createMethod(0),
                    // `Array.prototype.map` method
                    // https://tc39.es/ecma262/#sec-array.prototype.map
                    map: createMethod(1),
                    // `Array.prototype.filter` method
                    // https://tc39.es/ecma262/#sec-array.prototype.filter
                    filter: createMethod(2),
                    // `Array.prototype.some` method
                    // https://tc39.es/ecma262/#sec-array.prototype.some
                    some: createMethod(3),
                    // `Array.prototype.every` method
                    // https://tc39.es/ecma262/#sec-array.prototype.every
                    every: createMethod(4),
                    // `Array.prototype.find` method
                    // https://tc39.es/ecma262/#sec-array.prototype.find
                    find: createMethod(5),
                    // `Array.prototype.findIndex` method
                    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
                    findIndex: createMethod(6),
                    // `Array.prototype.filterReject` method
                    // https://github.com/tc39/proposal-array-filtering
                    filterReject: createMethod(7)
                };
            /***/ },
            /***/ 91132: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(32010);
                var uncurryThis = __webpack_require__(38347);
                var PROPER_FUNCTION_NAME = __webpack_require__(7081).PROPER;
                var ArrayBufferViewCore = __webpack_require__(59754);
                var ArrayIterators = __webpack_require__(81755);
                var wellKnownSymbol = __webpack_require__(38688);
                var ITERATOR = wellKnownSymbol('iterator');
                var Uint8Array1 = global.Uint8Array;
                var arrayValues = uncurryThis(ArrayIterators.values);
                var arrayKeys = uncurryThis(ArrayIterators.keys);
                var arrayEntries = uncurryThis(ArrayIterators.entries);
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                var nativeTypedArrayIterator = Uint8Array1 && Uint8Array1.prototype[ITERATOR];
                var PROPER_ARRAY_VALUES_NAME = !!nativeTypedArrayIterator && nativeTypedArrayIterator.name === 'values';
                var typedArrayValues = function values() {
                    return arrayValues(aTypedArray(this));
                };
                // `%TypedArray%.prototype.entries` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
                exportTypedArrayMethod('entries', function entries() {
                    return arrayEntries(aTypedArray(this));
                });
                // `%TypedArray%.prototype.keys` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
                exportTypedArrayMethod('keys', function keys() {
                    return arrayKeys(aTypedArray(this));
                });
                // `%TypedArray%.prototype.values` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
                exportTypedArrayMethod('values', typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);
                // `%TypedArray%.prototype[@@iterator]` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
                exportTypedArrayMethod(ITERATOR, typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);
            /***/ },
            /***/ 91151: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__(38688);
                var MATCH = wellKnownSymbol('match');
                module1.exports = function(METHOD_NAME) {
                    var regexp = /./;
                    try {
                        '/./'[METHOD_NAME](regexp);
                    } catch (error1) {
                        try {
                            regexp[MATCH] = false;
                            return '/./'[METHOD_NAME](regexp);
                        } catch (error2) {}
                    }
                    return false;
                };
            /***/ },
            /***/ 91159: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var requireObjectCoercible = __webpack_require__(83943);
                var toString = __webpack_require__(25096);
                var quot = /"/g;
                var replace = uncurryThis(''.replace);
                // `CreateHTML` abstract operation
                // https://tc39.es/ecma262/#sec-createhtml
                module1.exports = function(string, tag, attribute, value) {
                    var S = toString(requireObjectCoercible(string));
                    var p1 = '<' + tag;
                    if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
                    return p1 + '>' + S + '</' + tag + '>';
                };
            /***/ },
            /***/ 91780: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(39081);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    /**
   * ISO 10126 padding strategy.
   */ CryptoJS.pad.Iso10126 = {
                        pad: function pad(data, blockSize) {
                            // Shortcut
                            var blockSizeBytes = blockSize * 4;
                            // Count padding bytes
                            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                            // Pad
                            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                                nPaddingBytes << 24
                            ], 1));
                        },
                        unpad: function unpad(data) {
                            // Get number of padding bytes from last byte
                            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                            // Remove padding
                            data.sigBytes -= nPaddingBytes;
                        }
                    };
                    return CryptoJS.pad.Iso10126;
                });
            /***/ },
            /***/ 91867: /***/ function(module1) {
                "use strict";
                function isString(variable) {
                    return typeof variable === 'string' || variable instanceof String;
                }
                function isNumber(variable) {
                    return typeof variable === 'number' || variable instanceof Number;
                }
                function isBoolean(variable) {
                    return typeof variable === 'boolean';
                }
                function isArray(variable) {
                    return Array.isArray(variable);
                }
                function isFunction(variable) {
                    return typeof variable === 'function';
                }
                function isObject(variable) {
                    return variable !== null && typeof variable === 'object';
                }
                function isNull(variable) {
                    return variable === null;
                }
                function isUndefined(variable) {
                    return variable === undefined;
                }
                /**
 * @param {any} variable
 * @returns {boolean}
 */ function isPositiveInteger(variable) {
                    if (!isNumber(variable) || !Number.isInteger(variable) || variable <= 0) return false;
                    return true;
                }
                function pack() {
                    var result = {};
                    for(var i = 0, l = arguments.length; i < l; i++){
                        var obj = arguments[i];
                        if (obj) {
                            for(var key in obj)if (obj.hasOwnProperty(key)) result[key] = obj[key];
                        }
                    }
                    return result;
                }
                function offsetVector(vector, x, y) {
                    switch(vector.type){
                        case 'ellipse':
                        case 'rect':
                            vector.x += x;
                            vector.y += y;
                            break;
                        case 'line':
                            vector.x1 += x;
                            vector.x2 += x;
                            vector.y1 += y;
                            vector.y2 += y;
                            break;
                        case 'polyline':
                            for(var i = 0, l = vector.points.length; i < l; i++){
                                vector.points[i].x += x;
                                vector.points[i].y += y;
                            }
                            break;
                    }
                }
                function fontStringify(key, val) {
                    if (key === 'font') return 'font';
                    return val;
                }
                function getNodeId(node) {
                    if (node.id) return node.id;
                    if (isArray(node.text)) for(var i = 0, l = node.text.length; i < l; i++){
                        var n = node.text[i];
                        var nodeId = getNodeId(n);
                        if (nodeId) return nodeId;
                    }
                    return null;
                }
                function isPattern(color) {
                    return isArray(color) && color.length === 2;
                }
                // converts from a [<pattern name>, <color>] as used by pdfmake
                // into [<pattern object>, <color>] as used by pdfkit
                // (the pattern has to be registered in the doc definition of course)
                function getPattern(color, patterns) {
                    return [
                        patterns[color[0]],
                        color[1]
                    ];
                }
                module1.exports = {
                    isString: isString,
                    isNumber: isNumber,
                    isBoolean: isBoolean,
                    isArray: isArray,
                    isFunction: isFunction,
                    isObject: isObject,
                    isNull: isNull,
                    isUndefined: isUndefined,
                    isPositiveInteger: isPositiveInteger,
                    pack: pack,
                    fontStringify: fontStringify,
                    offsetVector: offsetVector,
                    getNodeId: getNodeId,
                    isPattern: isPattern,
                    getPattern: getPattern
                };
            /***/ },
            /***/ 92451: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $reduceRight = __webpack_require__(32843).right;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.reduceRicht` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
                exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */ ) {
                    var length = arguments.length;
                    return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 92642: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var toObject = __webpack_require__(43162);
                var toAbsoluteIndex = __webpack_require__(74841);
                var lengthOfArrayLike = __webpack_require__(45495);
                var min = Math.min;
                // `Array.prototype.copyWithin` method implementation
                // https://tc39.es/ecma262/#sec-array.prototype.copywithin
                // eslint-disable-next-line es/no-array-prototype-copywithin -- safe
                module1.exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
                    var O = toObject(this);
                    var len = lengthOfArrayLike(O);
                    var to = toAbsoluteIndex(target, len);
                    var from = toAbsoluteIndex(start, len);
                    var end = arguments.length > 2 ? arguments[2] : undefined;
                    var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
                    var inc = 1;
                    if (from < to && to < from + count) {
                        inc = -1;
                        from += count - 1;
                        to += count - 1;
                    }
                    while(count-- > 0){
                        if (from in O) O[to] = O[from];
                        else delete O[to];
                        to += inc;
                        from += inc;
                    }
                    return O;
                };
            /***/ },
            /***/ 92920: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                var utils = __webpack_require__(72519);
                var MAXBITS = 15;
                var ENOUGH_LENS = 852;
                var ENOUGH_DISTS = 592;
                //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
                var CODES = 0;
                var LENS = 1;
                var DISTS = 2;
                var lbase = [
                    /* Length codes 257..285 base */ 3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ];
                var lext = [
                    /* Length codes 257..285 extra */ 16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ];
                var dbase = [
                    /* Distance codes 0..29 base */ 1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ];
                var dext = [
                    /* Distance codes 0..29 extra */ 16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                module1.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
                    var bits = opts.bits;
                    //here = opts.here; /* table entry for duplication */
                    var len = 0; /* a code's length in bits */ 
                    var sym = 0; /* index of code symbols */ 
                    var min = 0, max = 0; /* minimum and maximum code lengths */ 
                    var root = 0; /* number of index bits for root table */ 
                    var curr = 0; /* number of index bits for current table */ 
                    var drop = 0; /* code bits to drop for sub-table */ 
                    var left = 0; /* number of prefix codes available */ 
                    var used = 0; /* code entries in table used */ 
                    var huff = 0; /* Huffman code */ 
                    var incr; /* for incrementing code, index */ 
                    var fill; /* index for replicating entries */ 
                    var low; /* low bits for current root entry */ 
                    var mask; /* mask for low root bits */ 
                    var next; /* next available space in table */ 
                    var base = null; /* base value table to use */ 
                    var base_index = 0;
                    //  var shoextra;    /* extra bits table to use */
                    var end; /* use base and extra for symbol > end */ 
                    var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
                    var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
                    var extra = null;
                    var extra_index = 0;
                    var here_bits, here_op, here_val;
                    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
                    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
                    /* bound code lengths, force root to be within code lengths */ root = bits;
                    for(max = MAXBITS; max >= 1; max--){
                        if (count[max] !== 0) break;
                    }
                    if (root > max) root = max;
                    if (max === 0) {
                        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
                        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
                        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
                        table[table_index++] = 20971520;
                        //table.op[opts.table_index] = 64;
                        //table.bits[opts.table_index] = 1;
                        //table.val[opts.table_index++] = 0;
                        table[table_index++] = 20971520;
                        opts.bits = 1;
                        return 0; /* no symbols, but wait for decoding to report error */ 
                    }
                    for(min = 1; min < max; min++){
                        if (count[min] !== 0) break;
                    }
                    if (root < min) root = min;
                    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
                    for(len = 1; len <= MAXBITS; len++){
                        left <<= 1;
                        left -= count[len];
                        if (left < 0) return -1;
                         /* over-subscribed */ 
                    }
                    if (left > 0 && (type === CODES || max !== 1)) return -1; /* incomplete set */ 
                    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
                    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
                    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
                    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
                    // to avoid deopts in old v8
                    if (type === CODES) {
                        base = extra = work; /* dummy value--not used */ 
                        end = 19;
                    } else if (type === LENS) {
                        base = lbase;
                        base_index -= 257;
                        extra = lext;
                        extra_index -= 257;
                        end = 256;
                    } else {
                        base = dbase;
                        extra = dext;
                        end = -1;
                    }
                    /* initialize opts for loop */ huff = 0; /* starting code */ 
                    sym = 0; /* starting code symbol */ 
                    len = min; /* starting code length */ 
                    next = table_index; /* current table to fill in */ 
                    curr = root; /* current table index bits */ 
                    drop = 0; /* current bits to drop from code for index */ 
                    low = -1; /* trigger new sub-table when len > root */ 
                    used = 1 << root; /* use root table entries */ 
                    mask = used - 1; /* mask for comparing low */ 
                    /* check available table space */ if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
                    /* process all codes and make table entries */ for(;;){
                        /* create table entry */ here_bits = len - drop;
                        if (work[sym] < end) {
                            here_op = 0;
                            here_val = work[sym];
                        } else if (work[sym] > end) {
                            here_op = extra[extra_index + work[sym]];
                            here_val = base[base_index + work[sym]];
                        } else {
                            here_op = 96; /* end of block */ 
                            here_val = 0;
                        }
                        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
                        fill = 1 << curr;
                        min = fill; /* save offset to next table */ 
                        do {
                            fill -= incr;
                            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
                        }while (fill !== 0);
                        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
                        while(huff & incr)incr >>= 1;
                        if (incr !== 0) {
                            huff &= incr - 1;
                            huff += incr;
                        } else huff = 0;
                        /* go to next symbol, update count, len */ sym++;
                        if (--count[len] === 0) {
                            if (len === max) break;
                            len = lens[lens_index + work[sym]];
                        }
                        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
                            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
                            /* increment past last table */ next += min; /* here min is 1 << curr */ 
                            /* determine length of next table */ curr = len - drop;
                            left = 1 << curr;
                            while(curr + drop < max){
                                left -= count[curr + drop];
                                if (left <= 0) break;
                                curr++;
                                left <<= 1;
                            }
                            /* check for enough space */ used += 1 << curr;
                            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
                            /* point entry in root table to sub-table */ low = huff & mask;
                            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
                        }
                    }
                    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
                    //table.bits[next + huff] = len - drop;
                    //table.val[next + huff] = 0;
                    table[next + huff] = len - drop << 24 | 4194304;
                    /* set return parameters */ //opts.table_index += used;
                    opts.bits = root;
                    return 0;
                };
            /***/ },
            /***/ 93143: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var process = __webpack_require__(9964);
                /* eslint-disable node/no-deprecated-api */ __webpack_require__(41584);
                __webpack_require__(81755);
                __webpack_require__(8953);
                __webpack_require__(14032);
                __webpack_require__(56912);
                __webpack_require__(73663);
                __webpack_require__(29883);
                __webpack_require__(35471);
                __webpack_require__(21012);
                __webpack_require__(88997);
                __webpack_require__(97464);
                __webpack_require__(2857);
                __webpack_require__(83326);
                __webpack_require__(94715);
                __webpack_require__(13624);
                __webpack_require__(91132);
                __webpack_require__(62514);
                __webpack_require__(24597);
                __webpack_require__(88042);
                __webpack_require__(4660);
                __webpack_require__(92451);
                __webpack_require__(44206);
                __webpack_require__(66288);
                __webpack_require__(13250);
                __webpack_require__(3858);
                __webpack_require__(84538);
                __webpack_require__(64793);
                __webpack_require__(74202);
                __webpack_require__(52529);
                var buffer = __webpack_require__(14598);
                var Buffer = buffer.Buffer;
                var safer = {};
                var key;
                for(key in buffer){
                    if (!buffer.hasOwnProperty(key)) continue;
                    if (key === 'SlowBuffer' || key === 'Buffer') continue;
                    safer[key] = buffer[key];
                }
                var Safer = safer.Buffer = {};
                for(key in Buffer){
                    if (!Buffer.hasOwnProperty(key)) continue;
                    if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue;
                    Safer[key] = Buffer[key];
                }
                safer.Buffer.prototype = Buffer.prototype;
                if (!Safer.from || Safer.from === Uint8Array.from) Safer.from = function(value, encodingOrOffset, length) {
                    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
                    if (value && typeof value.length === 'undefined') throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value);
                    return Buffer(value, encodingOrOffset, length);
                };
                if (!Safer.alloc) Safer.alloc = function(size, fill, encoding) {
                    if (typeof size !== 'number') throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
                    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
                    var buf = Buffer(size);
                    if (!fill || fill.length === 0) buf.fill(0);
                    else if (typeof encoding === 'string') buf.fill(fill, encoding);
                    else buf.fill(fill);
                    return buf;
                };
                if (!safer.kStringMaxLength) try {
                    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength;
                } catch (e) {
                // we can't determine kStringMaxLength in environments where process.binding
                // is unsupported, so let's not set it
                }
                if (!safer.constants) {
                    safer.constants = {
                        MAX_LENGTH: safer.kMaxLength
                    };
                    if (safer.kStringMaxLength) safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength;
                }
                module1.exports = safer;
            /***/ },
            /***/ 93415: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                var fs = __webpack_require__(48181);
                function ImageMeasure(pdfKitDoc, imageDictionary) {
                    this.pdfKitDoc = pdfKitDoc;
                    this.imageDictionary = imageDictionary || {};
                }
                ImageMeasure.prototype.measureImage = function(src) {
                    var image;
                    var that = this;
                    if (!this.pdfKitDoc._imageRegistry[src]) {
                        try {
                            image = this.pdfKitDoc.openImage(realImageSrc(src));
                            if (!image) throw 'No image';
                        } catch (error) {
                            throw 'Invalid image: ' + error.toString() + '\nImages dictionary should contain dataURL entries (or local file paths in node.js)';
                        }
                        image.embed(this.pdfKitDoc);
                        this.pdfKitDoc._imageRegistry[src] = image;
                    } else image = this.pdfKitDoc._imageRegistry[src];
                    var imageSize = {
                        width: image.width,
                        height: image.height
                    };
                    // If EXIF orientation calls for it, swap width and height
                    if (image.orientation > 4) imageSize = {
                        width: image.height,
                        height: image.width
                    };
                    return imageSize;
                    function realImageSrc(src) {
                        var img = that.imageDictionary[src];
                        if (!img) return src;
                        if (typeof img === 'object') throw 'Not supported image definition: ' + JSON.stringify(img);
                        if (fs.existsSync(img)) return fs.readFileSync(img);
                        var index = img.indexOf('base64,');
                        if (index < 0) return that.imageDictionary[src];
                        return Buffer.from(img.substring(index + 7), 'base64');
                    }
                };
                module1.exports = ImageMeasure;
            /***/ },
            /***/ 93666: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isRegExp = __webpack_require__(28831);
                var TypeError1 = global.TypeError;
                module1.exports = function(it) {
                    if (isRegExp(it)) throw TypeError1("The method doesn't accept regular expressions");
                    return it;
                };
            /***/ },
            /***/ 93975: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var uncurryThis = __webpack_require__(38347);
                var toString = uncurryThis({}.toString);
                var stringSlice = uncurryThis(''.slice);
                module1.exports = function(it) {
                    return stringSlice(toString(it), 8, -1);
                };
            /***/ },
            /***/ 94119: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(18909), __webpack_require__(14287), __webpack_require__(2256), __webpack_require__(66947), __webpack_require__(16190), __webpack_require__(68319), __webpack_require__(37146), __webpack_require__(66664), __webpack_require__(11905), __webpack_require__(51965), __webpack_require__(27772), __webpack_require__(16720), __webpack_require__(1239), __webpack_require__(4420), __webpack_require__(44130), __webpack_require__(82747), __webpack_require__(51270), __webpack_require__(62256), __webpack_require__(48306), __webpack_require__(65881), __webpack_require__(6564), __webpack_require__(29819), __webpack_require__(28164), __webpack_require__(91780), __webpack_require__(14623), __webpack_require__(85628), __webpack_require__(61807), __webpack_require__(73948), __webpack_require__(22956), __webpack_require__(24107), __webpack_require__(95086), __webpack_require__(6819), __webpack_require__(75891), __webpack_require__(73517));
                })(void 0, function(CryptoJS) {
                    return CryptoJS;
                });
            /***/ },
            /***/ 94578: /***/ function(module1) {
                // `IsCallable` abstract operation
                // https://tc39.es/ecma262/#sec-iscallable
                module1.exports = function(argument) {
                    return typeof argument == 'function';
                };
            /***/ },
            /***/ 94712: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var DOMIterables = __webpack_require__(23327);
                var DOMTokenListPrototype = __webpack_require__(67797);
                var ArrayIteratorMethods = __webpack_require__(81755);
                var createNonEnumerableProperty = __webpack_require__(48914);
                var wellKnownSymbol = __webpack_require__(38688);
                var ITERATOR = wellKnownSymbol('iterator');
                var TO_STRING_TAG = wellKnownSymbol('toStringTag');
                var ArrayValues = ArrayIteratorMethods.values;
                var handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
                    if (CollectionPrototype) {
                        // some Chrome versions have non-configurable methods on DOMTokenList
                        if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
                            createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
                        } catch (error) {
                            CollectionPrototype[ITERATOR] = ArrayValues;
                        }
                        if (!CollectionPrototype[TO_STRING_TAG]) createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
                        if (DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in ArrayIteratorMethods){
                            // some Chrome versions have non-configurable methods on DOMTokenList
                            if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                                createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
                            } catch (error) {
                                CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
                            }
                        }
                    }
                };
                for(var COLLECTION_NAME in DOMIterables)handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
                handlePrototype(DOMTokenListPrototype, 'DOMTokenList');
            /***/ },
            /***/ 94715: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $includes = __webpack_require__(12636).includes;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.includes` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
                exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */ ) {
                    return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 94845: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var uncurryThis = __webpack_require__(38347);
                var IndexedObject = __webpack_require__(7514);
                var toIndexedObject = __webpack_require__(98086);
                var arrayMethodIsStrict = __webpack_require__(81007);
                var un$Join = uncurryThis([].join);
                var ES3_STRINGS = IndexedObject != Object;
                var STRICT_METHOD = arrayMethodIsStrict('join', ',');
                // `Array.prototype.join` method
                // https://tc39.es/ecma262/#sec-array.prototype.join
                $({
                    target: 'Array',
                    proto: true,
                    forced: ES3_STRINGS || !STRICT_METHOD
                }, {
                    join: function join(separator) {
                        return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
                    }
                });
            /***/ },
            /***/ 94910: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var isPrototypeOf = __webpack_require__(70176);
                var getPrototypeOf = __webpack_require__(69548);
                var setPrototypeOf = __webpack_require__(3840);
                var copyConstructorProperties = __webpack_require__(2675);
                var create = __webpack_require__(10819);
                var createNonEnumerableProperty = __webpack_require__(48914);
                var createPropertyDescriptor = __webpack_require__(97841);
                var clearErrorStack = __webpack_require__(34074);
                var installErrorCause = __webpack_require__(87811);
                var iterate = __webpack_require__(80383);
                var normalizeStringArgument = __webpack_require__(86392);
                var ERROR_STACK_INSTALLABLE = __webpack_require__(45144);
                var Error1 = global.Error;
                var push = [].push;
                var $AggregateError = function AggregateError1(errors, message /* , options */ ) {
                    var that = isPrototypeOf(AggregateErrorPrototype, this) ? this : create(AggregateErrorPrototype);
                    var options = arguments.length > 2 ? arguments[2] : undefined;
                    if (setPrototypeOf) that = setPrototypeOf(new Error1(undefined), getPrototypeOf(that));
                    createNonEnumerableProperty(that, 'message', normalizeStringArgument(message, ''));
                    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(that, 'stack', clearErrorStack(that.stack, 1));
                    installErrorCause(that, options);
                    var errorsArray = [];
                    iterate(errors, push, {
                        that: errorsArray
                    });
                    createNonEnumerableProperty(that, 'errors', errorsArray);
                    return that;
                };
                if (setPrototypeOf) setPrototypeOf($AggregateError, Error1);
                else copyConstructorProperties($AggregateError, Error1);
                var AggregateErrorPrototype = $AggregateError.prototype = create(Error1.prototype, {
                    constructor: createPropertyDescriptor(1, $AggregateError),
                    message: createPropertyDescriptor(1, ''),
                    name: createPropertyDescriptor(1, 'AggregateError')
                });
                // `AggregateError` constructor
                // https://tc39.es/ecma262/#sec-aggregate-error-constructor
                $({
                    global: true
                }, {
                    AggregateError: $AggregateError
                });
            /***/ },
            /***/ 95053: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var classof = __webpack_require__(93975);
                var global = __webpack_require__(32010);
                module1.exports = classof(global.process) == 'process';
            /***/ },
            /***/ 95086: /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                __webpack_require__(14032);
                __webpack_require__(68067);
                (function(root, factory, undef) {
                    // CommonJS
                    module1.exports = exports = factory(__webpack_require__(48352), __webpack_require__(66947), __webpack_require__(68319), __webpack_require__(82747), __webpack_require__(51270));
                })(void 0, function(CryptoJS) {
                    (function() {
                        // Shortcuts
                        var C = CryptoJS;
                        var C_lib = C.lib;
                        var StreamCipher = C_lib.StreamCipher;
                        var C_algo = C.algo;
                        /**
     * RC4 stream cipher algorithm.
     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
                            _doReset: function _doReset() {
                                // Shortcuts
                                var key = this._key;
                                var keyWords = key.words;
                                var keySigBytes = key.sigBytes;
                                // Init sbox
                                var S = this._S = [];
                                for(var i = 0; i < 256; i++)S[i] = i;
                                // Key setup
                                for(var i = 0, j = 0; i < 256; i++){
                                    var keyByteIndex = i % keySigBytes;
                                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                                    j = (j + S[i] + keyByte) % 256;
                                    // Swap
                                    var t = S[i];
                                    S[i] = S[j];
                                    S[j] = t;
                                }
                                // Counters
                                this._i = this._j = 0;
                            },
                            _doProcessBlock: function _doProcessBlock(M, offset) {
                                M[offset] ^= generateKeystreamWord.call(this);
                            },
                            keySize: 8,
                            ivSize: 0
                        });
                        function generateKeystreamWord() {
                            // Shortcuts
                            var S = this._S;
                            var i = this._i;
                            var j = this._j;
                            // Generate keystream word
                            var keystreamWord = 0;
                            for(var n = 0; n < 4; n++){
                                i = (i + 1) % 256;
                                j = (j + S[i]) % 256;
                                // Swap
                                var t = S[i];
                                S[i] = S[j];
                                S[j] = t;
                                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
                            }
                            // Update counters
                            this._i = i;
                            this._j = j;
                            return keystreamWord;
                        }
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
     */ C.RC4 = StreamCipher._createHelper(RC4);
                        /**
     * Modified RC4 stream cipher algorithm.
     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
                            /**
       * Configuration options.
       *
       * @property {number} drop The number of keystream words to drop. Default 192
       */ cfg: RC4.cfg.extend({
                                drop: 192
                            }),
                            _doReset: function _doReset() {
                                RC4._doReset.call(this);
                                // Drop
                                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
                            }
                        });
                        /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
                    })();
                    return CryptoJS.RC4;
                });
            /***/ },
            /***/ 95291: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                __webpack_require__(41584);
                __webpack_require__(20731);
                __webpack_require__(61726);
                __webpack_require__(46467);
                function _inheritsLoose(t, o) {
                    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
                }
                function _setPrototypeOf(t, e) {
                    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                        return t.__proto__ = e, t;
                    }, _setPrototypeOf(t, e);
                }
                var iconv;
                var stream = __webpack_require__(9760);
                var DecodeStream = __webpack_require__(69591);
                try {
                    iconv = __webpack_require__(54171);
                } catch (error) {}
                var EncodeStream = /*#__PURE__*/ function(_stream$Readable) {
                    function EncodeStream(bufferSize) {
                        var _this;
                        if (bufferSize === void 0) bufferSize = 65536;
                        _this = _stream$Readable.apply(this, arguments) || this;
                        _this.buffer = Buffer.alloc(bufferSize);
                        _this.bufferOffset = 0;
                        _this.pos = 0;
                        return _this;
                    }
                    // do nothing, required by node
                    _inheritsLoose(EncodeStream, _stream$Readable);
                    var _proto = EncodeStream.prototype;
                    _proto._read = function _read() {};
                    _proto.ensure = function ensure(bytes) {
                        if (this.bufferOffset + bytes > this.buffer.length) return this.flush();
                    };
                    _proto.flush = function flush() {
                        if (this.bufferOffset > 0) {
                            this.push(Buffer.from(this.buffer.slice(0, this.bufferOffset)));
                            return this.bufferOffset = 0;
                        }
                    };
                    _proto.writeBuffer = function writeBuffer(buffer) {
                        this.flush();
                        this.push(buffer);
                        return this.pos += buffer.length;
                    };
                    _proto.writeString = function writeString(string, encoding) {
                        if (encoding === void 0) encoding = 'ascii';
                        switch(encoding){
                            case 'utf16le':
                            case 'ucs2':
                            case 'utf8':
                            case 'ascii':
                                return this.writeBuffer(Buffer.from(string, encoding));
                            case 'utf16be':
                                var buf = Buffer.from(string, 'utf16le');
                                // swap the bytes
                                for(var i = 0, end = buf.length - 1; i < end; i += 2){
                                    var byte = buf[i];
                                    buf[i] = buf[i + 1];
                                    buf[i + 1] = byte;
                                }
                                return this.writeBuffer(buf);
                            default:
                                if (iconv) return this.writeBuffer(iconv.encode(string, encoding));
                                else throw new Error('Install iconv-lite to enable additional string encodings.');
                        }
                    };
                    _proto.writeUInt24BE = function writeUInt24BE(val) {
                        this.ensure(3);
                        this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
                        this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
                        this.buffer[this.bufferOffset++] = val & 0xff;
                        return this.pos += 3;
                    };
                    _proto.writeUInt24LE = function writeUInt24LE(val) {
                        this.ensure(3);
                        this.buffer[this.bufferOffset++] = val & 0xff;
                        this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
                        this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
                        return this.pos += 3;
                    };
                    _proto.writeInt24BE = function writeInt24BE(val) {
                        if (val >= 0) return this.writeUInt24BE(val);
                        else return this.writeUInt24BE(val + 0xffffff + 1);
                    };
                    _proto.writeInt24LE = function writeInt24LE(val) {
                        if (val >= 0) return this.writeUInt24LE(val);
                        else return this.writeUInt24LE(val + 0xffffff + 1);
                    };
                    _proto.fill = function fill(val, length) {
                        if (length < this.buffer.length) {
                            this.ensure(length);
                            this.buffer.fill(val, this.bufferOffset, this.bufferOffset + length);
                            this.bufferOffset += length;
                            return this.pos += length;
                        } else {
                            var buf = Buffer.alloc(length);
                            buf.fill(val);
                            return this.writeBuffer(buf);
                        }
                    };
                    _proto.end = function end() {
                        this.flush();
                        return this.push(null);
                    };
                    return EncodeStream;
                }(stream.Readable);
                var _loop = function _loop(key) {
                    if (key.slice(0, 5) === 'write') {
                        var bytes = +DecodeStream.TYPES[key.replace(/write|[BL]E/g, '')];
                        EncodeStream.prototype[key] = function(value) {
                            this.ensure(bytes);
                            this.buffer[key](value, this.bufferOffset);
                            this.bufferOffset += bytes;
                            return this.pos += bytes;
                        };
                    }
                };
                for(var key in Buffer.prototype)_loop(key);
                module1.exports = EncodeStream;
            /***/ },
            /***/ 95304: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var define = __webpack_require__(89295);
                var hasDescriptors = __webpack_require__(18890)();
                var functionsHaveConfigurableNames = __webpack_require__(61084).functionsHaveConfigurableNames();
                var $TypeError = __webpack_require__(96785);
                /** @type {import('.')} */ module1.exports = function setFunctionName(fn, name) {
                    if (typeof fn !== 'function') throw new $TypeError('`fn` is not a function');
                    var loose = arguments.length > 2 && !!arguments[2];
                    if (!loose || functionsHaveConfigurableNames) {
                        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, 'name', name, true, true);
                        else define(/** @type {Parameters<define>[0]} */ fn, 'name', name);
                    }
                    return fn;
                };
            /***/ },
            /***/ 95717: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var global = __webpack_require__(32010);
                var bind = __webpack_require__(25567);
                var call = __webpack_require__(2834);
                var toObject = __webpack_require__(43162);
                var callWithSafeIterationClosing = __webpack_require__(97738);
                var isArrayIteratorMethod = __webpack_require__(89564);
                var isConstructor = __webpack_require__(20884);
                var lengthOfArrayLike = __webpack_require__(45495);
                var createProperty = __webpack_require__(38639);
                var getIterator = __webpack_require__(15892);
                var getIteratorMethod = __webpack_require__(13872);
                var Array1 = global.Array;
                // `Array.from` method implementation
                // https://tc39.es/ecma262/#sec-array.from
                module1.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
                    var O = toObject(arrayLike);
                    var IS_CONSTRUCTOR = isConstructor(this);
                    var argumentsLength = arguments.length;
                    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
                    var mapping = mapfn !== undefined;
                    if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
                    var iteratorMethod = getIteratorMethod(O);
                    var index = 0;
                    var length, result, step, iterator, next, value;
                    // if the target is not iterable or it's an array with the default iterator - use a simple case
                    if (iteratorMethod && !(this == Array1 && isArrayIteratorMethod(iteratorMethod))) {
                        iterator = getIterator(O, iteratorMethod);
                        next = iterator.next;
                        result = IS_CONSTRUCTOR ? new this() : [];
                        for(; !(step = call(next, iterator)).done; index++){
                            value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                                step.value,
                                index
                            ], true) : step.value;
                            createProperty(result, index, value);
                        }
                    } else {
                        length = lengthOfArrayLike(O);
                        result = IS_CONSTRUCTOR ? new this(length) : Array1(length);
                        for(; length > index; index++){
                            value = mapping ? mapfn(O[index], index) : O[index];
                            createProperty(result, index, value);
                        }
                    }
                    result.length = index;
                    return result;
                };
            /***/ },
            /***/ 95756: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                var createTypedArrayConstructor = __webpack_require__(98828);
                // `Int32Array` constructor
                // https://tc39.es/ecma262/#sec-typedarray-objects
                createTypedArrayConstructor('Int32', function(init) {
                    return function Int32Array1(data, byteOffset, length) {
                        return init(this, data, byteOffset, length);
                    };
                });
            /***/ },
            /***/ 95892: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var DESCRIPTORS = __webpack_require__(15567);
                var IE8_DOM_DEFINE = __webpack_require__(18904);
                var anObject = __webpack_require__(34984);
                var toPropertyKey = __webpack_require__(63918);
                var TypeError1 = global.TypeError;
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                var $defineProperty = Object.defineProperty;
                // `Object.defineProperty` method
                // https://tc39.es/ecma262/#sec-object.defineproperty
                exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
                    anObject(O);
                    P = toPropertyKey(P);
                    anObject(Attributes);
                    if (IE8_DOM_DEFINE) try {
                        return $defineProperty(O, P, Attributes);
                    } catch (error) {}
                    if ('get' in Attributes || 'set' in Attributes) throw TypeError1('Accessors not supported');
                    if ('value' in Attributes) O[P] = Attributes.value;
                    return O;
                };
            /***/ },
            /***/ 96395: /***/ function(module1) {
                "use strict";
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                // See state defs from inflate.js
                var BAD = 30; /* got a data error -- remain here until reset */ 
                var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
                /*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module1.exports = function inflate_fast(strm, start) {
                    var state;
                    var _in; /* local strm.input */ 
                    var last; /* have enough input while in < last */ 
                    var _out; /* local strm.output */ 
                    var beg; /* inflate()'s initial strm.output */ 
                    var end; /* while out < end, enough space available */ 
                    //#ifdef INFLATE_STRICT
                    var dmax; /* maximum distance from zlib header */ 
                    //#endif
                    var wsize; /* window size or zero if not using window */ 
                    var whave; /* valid bytes in the window */ 
                    var wnext; /* window write index */ 
                    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
                    var s_window; /* allocated sliding window, if wsize != 0 */ 
                    var hold; /* local strm.hold */ 
                    var bits; /* local strm.bits */ 
                    var lcode; /* local strm.lencode */ 
                    var dcode; /* local strm.distcode */ 
                    var lmask; /* mask for first level of length codes */ 
                    var dmask; /* mask for first level of distance codes */ 
                    var here; /* retrieved table entry */ 
                    var op; /* code bits, operation, extra bits, or */ 
                    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
                    var dist; /* match distance */ 
                    var from; /* where to copy match from */ 
                    var from_source;
                    var input, output; // JS specific, because we have no pointers
                    /* copy state to local variables */ state = strm.state;
                    //here = state.here;
                    _in = strm.next_in;
                    input = strm.input;
                    last = _in + (strm.avail_in - 5);
                    _out = strm.next_out;
                    output = strm.output;
                    beg = _out - (start - strm.avail_out);
                    end = _out + (strm.avail_out - 257);
                    //#ifdef INFLATE_STRICT
                    dmax = state.dmax;
                    //#endif
                    wsize = state.wsize;
                    whave = state.whave;
                    wnext = state.wnext;
                    s_window = state.window;
                    hold = state.hold;
                    bits = state.bits;
                    lcode = state.lencode;
                    dcode = state.distcode;
                    lmask = (1 << state.lenbits) - 1;
                    dmask = (1 << state.distbits) - 1;
                    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
                        if (bits < 15) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            hold += input[_in++] << bits;
                            bits += 8;
                        }
                        here = lcode[hold & lmask];
                        dolen: for(;;){
                            op = here >>> 24 /*here.bits*/ ;
                            hold >>>= op;
                            bits -= op;
                            op = here >>> 16 & 0xff /*here.op*/ ;
                            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                            //        "inflate:         literal '%c'\n" :
                            //        "inflate:         literal 0x%02x\n", here.val));
                            output[_out++] = here & 0xffff /*here.val*/ ;
                            else if (op & 16) {
                                len = here & 0xffff /*here.val*/ ;
                                op &= 15; /* number of extra bits */ 
                                if (op) {
                                    if (bits < op) {
                                        hold += input[_in++] << bits;
                                        bits += 8;
                                    }
                                    len += hold & (1 << op) - 1;
                                    hold >>>= op;
                                    bits -= op;
                                }
                                //Tracevv((stderr, "inflate:         length %u\n", len));
                                if (bits < 15) {
                                    hold += input[_in++] << bits;
                                    bits += 8;
                                    hold += input[_in++] << bits;
                                    bits += 8;
                                }
                                here = dcode[hold & dmask];
                                dodist: for(;;){
                                    op = here >>> 24 /*here.bits*/ ;
                                    hold >>>= op;
                                    bits -= op;
                                    op = here >>> 16 & 0xff /*here.op*/ ;
                                    if (op & 16) {
                                        dist = here & 0xffff /*here.val*/ ;
                                        op &= 15; /* number of extra bits */ 
                                        if (bits < op) {
                                            hold += input[_in++] << bits;
                                            bits += 8;
                                            if (bits < op) {
                                                hold += input[_in++] << bits;
                                                bits += 8;
                                            }
                                        }
                                        dist += hold & (1 << op) - 1;
                                        //#ifdef INFLATE_STRICT
                                        if (dist > dmax) {
                                            strm.msg = 'invalid distance too far back';
                                            state.mode = BAD;
                                            break top;
                                        }
                                        //#endif
                                        hold >>>= op;
                                        bits -= op;
                                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                                        op = _out - beg; /* max distance in output */ 
                                        if (dist > op) {
                                            op = dist - op; /* distance back in window */ 
                                            if (op > whave) {
                                                if (state.sane) {
                                                    strm.msg = 'invalid distance too far back';
                                                    state.mode = BAD;
                                                    break top;
                                                }
                                            }
                                            from = 0; // window index
                                            from_source = s_window;
                                            if (wnext === 0) {
                                                from += wsize - op;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = s_window[from++];
                                                    while (--op);
                                                    from = _out - dist; /* rest from output */ 
                                                    from_source = output;
                                                }
                                            } else if (wnext < op) {
                                                from += wsize + wnext - op;
                                                op -= wnext;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = s_window[from++];
                                                    while (--op);
                                                    from = 0;
                                                    if (wnext < len) {
                                                        op = wnext;
                                                        len -= op;
                                                        do output[_out++] = s_window[from++];
                                                        while (--op);
                                                        from = _out - dist; /* rest from output */ 
                                                        from_source = output;
                                                    }
                                                }
                                            } else {
                                                from += wnext - op;
                                                if (op < len) {
                                                    len -= op;
                                                    do output[_out++] = s_window[from++];
                                                    while (--op);
                                                    from = _out - dist; /* rest from output */ 
                                                    from_source = output;
                                                }
                                            }
                                            while(len > 2){
                                                output[_out++] = from_source[from++];
                                                output[_out++] = from_source[from++];
                                                output[_out++] = from_source[from++];
                                                len -= 3;
                                            }
                                            if (len) {
                                                output[_out++] = from_source[from++];
                                                if (len > 1) output[_out++] = from_source[from++];
                                            }
                                        } else {
                                            from = _out - dist; /* copy direct from output */ 
                                            do {
                                                output[_out++] = output[from++];
                                                output[_out++] = output[from++];
                                                output[_out++] = output[from++];
                                                len -= 3;
                                            }while (len > 2);
                                            if (len) {
                                                output[_out++] = output[from++];
                                                if (len > 1) output[_out++] = output[from++];
                                            }
                                        }
                                    } else if ((op & 64) === 0) {
                                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                                        continue dodist;
                                    } else {
                                        strm.msg = 'invalid distance code';
                                        state.mode = BAD;
                                        break top;
                                    }
                                    break; // need to emulate goto via "continue"
                                }
                            } else if ((op & 64) === 0) {
                                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                                continue dolen;
                            } else if (op & 32) {
                                //Tracevv((stderr, "inflate:         end of block\n"));
                                state.mode = TYPE;
                                break top;
                            } else {
                                strm.msg = 'invalid literal/length code';
                                state.mode = BAD;
                                break top;
                            }
                            break; // need to emulate goto via "continue"
                        }
                    }while (_in < last && _out < end);
                    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
                    _in -= len;
                    bits -= len << 3;
                    hold &= (1 << bits) - 1;
                    /* update state and return */ strm.next_in = _in;
                    strm.next_out = _out;
                    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
                    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
                    state.hold = hold;
                    state.bits = bits;
                    return;
                };
            /***/ },
            /***/ 96785: /***/ function(module1) {
                "use strict";
                /** @type {import('./type')} */ module1.exports = TypeError;
            /***/ },
            /***/ 97001: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var call = __webpack_require__(2834);
                var IS_PURE = __webpack_require__(63432);
                var FunctionName = __webpack_require__(7081);
                var isCallable = __webpack_require__(94578);
                var createIteratorConstructor = __webpack_require__(13945);
                var getPrototypeOf = __webpack_require__(69548);
                var setPrototypeOf = __webpack_require__(3840);
                var setToStringTag = __webpack_require__(15216);
                var createNonEnumerableProperty = __webpack_require__(48914);
                var redefine = __webpack_require__(13711);
                var wellKnownSymbol = __webpack_require__(38688);
                var Iterators = __webpack_require__(15366);
                var IteratorsCore = __webpack_require__(5844);
                var PROPER_FUNCTION_NAME = FunctionName.PROPER;
                var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
                var IteratorPrototype = IteratorsCore.IteratorPrototype;
                var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
                var ITERATOR = wellKnownSymbol('iterator');
                var KEYS = 'keys';
                var VALUES = 'values';
                var ENTRIES = 'entries';
                var returnThis = function() {
                    return this;
                };
                module1.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
                    createIteratorConstructor(IteratorConstructor, NAME, next);
                    var getIterationMethod = function(KIND) {
                        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
                        if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
                        switch(KIND){
                            case KEYS:
                                return function keys() {
                                    return new IteratorConstructor(this, KIND);
                                };
                            case VALUES:
                                return function values() {
                                    return new IteratorConstructor(this, KIND);
                                };
                            case ENTRIES:
                                return function entries() {
                                    return new IteratorConstructor(this, KIND);
                                };
                        }
                        return function() {
                            return new IteratorConstructor(this);
                        };
                    };
                    var TO_STRING_TAG = NAME + ' Iterator';
                    var INCORRECT_VALUES_NAME = false;
                    var IterablePrototype = Iterable.prototype;
                    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
                    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
                    var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
                    var CurrentIteratorPrototype, methods, KEY;
                    // fix native
                    if (anyNativeIterator) {
                        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
                        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                                if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                                else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
                            }
                            // Set @@toStringTag to native iterators
                            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
                        }
                    }
                    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
                    if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
                        if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
                        else {
                            INCORRECT_VALUES_NAME = true;
                            defaultIterator = function values() {
                                return call(nativeIterator, this);
                            };
                        }
                    }
                    // export additional methods
                    if (DEFAULT) {
                        methods = {
                            values: getIterationMethod(VALUES),
                            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                            entries: getIterationMethod(ENTRIES)
                        };
                        if (FORCED) {
                            for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) redefine(IterablePrototype, KEY, methods[KEY]);
                        } else $({
                            target: NAME,
                            proto: true,
                            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
                        }, methods);
                    }
                    // define iterator
                    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) redefine(IterablePrototype, ITERATOR, defaultIterator, {
                        name: DEFAULT
                    });
                    Iterators[NAME] = defaultIterator;
                    return methods;
                };
            /***/ },
            /***/ 97464: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ArrayBufferViewCore = __webpack_require__(59754);
                var $findIndex = __webpack_require__(91102).findIndex;
                var aTypedArray = ArrayBufferViewCore.aTypedArray;
                var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
                // `%TypedArray%.prototype.findIndex` method
                // https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
                exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */ ) {
                    return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
                });
            /***/ },
            /***/ 97514: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var $find = __webpack_require__(91102).find;
                var addToUnscopables = __webpack_require__(71156);
                var FIND = 'find';
                var SKIPS_HOLES = true;
                // Shouldn't skip holes
                if (FIND in []) Array(1)[FIND](function() {
                    SKIPS_HOLES = false;
                });
                // `Array.prototype.find` method
                // https://tc39.es/ecma262/#sec-array.prototype.find
                $({
                    target: 'Array',
                    proto: true,
                    forced: SKIPS_HOLES
                }, {
                    find: function find(callbackfn /* , that = undefined */ ) {
                        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    }
                });
                // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
                addToUnscopables(FIND);
            /***/ },
            /***/ 97738: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var anObject = __webpack_require__(34984);
                var iteratorClose = __webpack_require__(50194);
                // call something on iterator step with safe closing on error
                module1.exports = function(iterator, fn, value, ENTRIES) {
                    try {
                        return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
                    } catch (error) {
                        iteratorClose(iterator, 'throw', error);
                    }
                };
            /***/ },
            /***/ 97739: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var fails = __webpack_require__(47044);
                var global = __webpack_require__(32010);
                // babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
                var $RegExp = global.RegExp;
                module1.exports = fails(function() {
                    var re = $RegExp('(?<a>b)', 'g');
                    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
                });
            /***/ },
            /***/ 97841: /***/ function(module1) {
                module1.exports = function(bitmap, value) {
                    return {
                        enumerable: !(bitmap & 1),
                        configurable: !(bitmap & 2),
                        writable: !(bitmap & 4),
                        value: value
                    };
                };
            /***/ },
            /***/ 98086: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                // toObject with fallback for non-array-like ES3 strings
                var IndexedObject = __webpack_require__(7514);
                var requireObjectCoercible = __webpack_require__(83943);
                module1.exports = function(it) {
                    return IndexedObject(requireObjectCoercible(it));
                };
            /***/ },
            /***/ 98168: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var parent = __webpack_require__(90780);
                __webpack_require__(84151);
                // TODO: Remove from `core-js@4`
                __webpack_require__(98443);
                __webpack_require__(49261);
                __webpack_require__(67858);
                module1.exports = parent;
            /***/ },
            /***/ 98197: /***/ function(__unused_webpack_module, exports) {
                function BrotliInput(buffer) {
                    this.buffer = buffer;
                    this.pos = 0;
                }
                BrotliInput.prototype.read = function(buf, i, count) {
                    if (this.pos + count > this.buffer.length) count = this.buffer.length - this.pos;
                    for(var p = 0; p < count; p++)buf[i + p] = this.buffer[this.pos + p];
                    this.pos += count;
                    return count;
                };
                exports.z = BrotliInput;
                function BrotliOutput(buf) {
                    this.buffer = buf;
                    this.pos = 0;
                }
                BrotliOutput.prototype.write = function(buf, count) {
                    if (this.pos + count > this.buffer.length) throw new Error('Output buffer is not large enough');
                    this.buffer.set(buf.subarray(0, count), this.pos);
                    this.pos += count;
                    return count;
                };
                exports.y = BrotliOutput;
            /***/ },
            /***/ 98443: /***/ function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
                // TODO: Remove from `core-js@4`
                __webpack_require__(77074);
            /***/ },
            /***/ 98527: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var define = __webpack_require__(77802);
                var callBind = __webpack_require__(26601);
                var implementation = __webpack_require__(63249);
                var getPolyfill = __webpack_require__(89636);
                var shim = __webpack_require__(3534);
                var polyfill = callBind(getPolyfill(), Object);
                define(polyfill, {
                    getPolyfill: getPolyfill,
                    implementation: implementation,
                    shim: shim
                });
                module1.exports = polyfill;
            /***/ },
            /***/ 98578: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var global = __webpack_require__(32010);
                var isArray = __webpack_require__(59113);
                var isConstructor = __webpack_require__(20884);
                var isObject = __webpack_require__(24517);
                var wellKnownSymbol = __webpack_require__(38688);
                var SPECIES = wellKnownSymbol('species');
                var Array1 = global.Array;
                // a part of `ArraySpeciesCreate` abstract operation
                // https://tc39.es/ecma262/#sec-arrayspeciescreate
                module1.exports = function(originalArray) {
                    var C;
                    if (isArray(originalArray)) {
                        C = originalArray.constructor;
                        // cross-realm fallback
                        if (isConstructor(C) && (C === Array1 || isArray(C.prototype))) C = undefined;
                        else if (isObject(C)) {
                            C = C[SPECIES];
                            if (C === null) C = undefined;
                        }
                    }
                    return C === undefined ? Array1 : C;
                };
            /***/ },
            /***/ 98828: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var $ = __webpack_require__(56475);
                var global = __webpack_require__(32010);
                var call = __webpack_require__(2834);
                var DESCRIPTORS = __webpack_require__(15567);
                var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(28834);
                var ArrayBufferViewCore = __webpack_require__(59754);
                var ArrayBufferModule = __webpack_require__(83124);
                var anInstance = __webpack_require__(2868);
                var createPropertyDescriptor = __webpack_require__(97841);
                var createNonEnumerableProperty = __webpack_require__(48914);
                var isIntegralNumber = __webpack_require__(17506);
                var toLength = __webpack_require__(23417);
                var toIndex = __webpack_require__(71265);
                var toOffset = __webpack_require__(80670);
                var toPropertyKey = __webpack_require__(63918);
                var hasOwn = __webpack_require__(20340);
                var classof = __webpack_require__(52564);
                var isObject = __webpack_require__(24517);
                var isSymbol = __webpack_require__(46290);
                var create = __webpack_require__(10819);
                var isPrototypeOf = __webpack_require__(70176);
                var setPrototypeOf = __webpack_require__(3840);
                var getOwnPropertyNames = __webpack_require__(6611).f;
                var typedArrayFrom = __webpack_require__(83590);
                var forEach = __webpack_require__(91102).forEach;
                var setSpecies = __webpack_require__(51334);
                var definePropertyModule = __webpack_require__(95892);
                var getOwnPropertyDescriptorModule = __webpack_require__(72062);
                var InternalStateModule = __webpack_require__(70172);
                var inheritIfRequired = __webpack_require__(51868);
                var getInternalState = InternalStateModule.get;
                var setInternalState = InternalStateModule.set;
                var nativeDefineProperty = definePropertyModule.f;
                var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                var round = Math.round;
                var RangeError1 = global.RangeError;
                var ArrayBuffer1 = ArrayBufferModule.ArrayBuffer;
                var ArrayBufferPrototype = ArrayBuffer1.prototype;
                var DataView1 = ArrayBufferModule.DataView;
                var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
                var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
                var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
                var TypedArray = ArrayBufferViewCore.TypedArray;
                var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
                var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
                var isTypedArray = ArrayBufferViewCore.isTypedArray;
                var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
                var WRONG_LENGTH = 'Wrong length';
                var fromList = function(C, list) {
                    aTypedArrayConstructor(C);
                    var index = 0;
                    var length = list.length;
                    var result = new C(length);
                    while(length > index)result[index] = list[index++];
                    return result;
                };
                var addGetter = function(it, key) {
                    nativeDefineProperty(it, key, {
                        get: function() {
                            return getInternalState(this)[key];
                        }
                    });
                };
                var isArrayBuffer = function(it) {
                    var klass;
                    return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
                };
                var isTypedArrayIndex = function(target, key) {
                    return isTypedArray(target) && !isSymbol(key) && key in target && isIntegralNumber(+key) && key >= 0;
                };
                var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
                    key = toPropertyKey(key);
                    return isTypedArrayIndex(target, key) ? createPropertyDescriptor(2, target[key]) : nativeGetOwnPropertyDescriptor(target, key);
                };
                var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
                    key = toPropertyKey(key);
                    if (isTypedArrayIndex(target, key) && isObject(descriptor) && hasOwn(descriptor, 'value') && !hasOwn(descriptor, 'get') && !hasOwn(descriptor, 'set') && !descriptor.configurable && (!hasOwn(descriptor, 'writable') || descriptor.writable) && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)) {
                        target[key] = descriptor.value;
                        return target;
                    }
                    return nativeDefineProperty(target, key, descriptor);
                };
                if (DESCRIPTORS) {
                    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
                        getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
                        definePropertyModule.f = wrappedDefineProperty;
                        addGetter(TypedArrayPrototype, 'buffer');
                        addGetter(TypedArrayPrototype, 'byteOffset');
                        addGetter(TypedArrayPrototype, 'byteLength');
                        addGetter(TypedArrayPrototype, 'length');
                    }
                    $({
                        target: 'Object',
                        stat: true,
                        forced: !NATIVE_ARRAY_BUFFER_VIEWS
                    }, {
                        getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
                        defineProperty: wrappedDefineProperty
                    });
                    module1.exports = function(TYPE, wrapper, CLAMPED) {
                        var BYTES = TYPE.match(/\d+$/)[0] / 8;
                        var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
                        var GETTER = 'get' + TYPE;
                        var SETTER = 'set' + TYPE;
                        var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
                        var TypedArrayConstructor = NativeTypedArrayConstructor;
                        var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
                        var exported = {};
                        var getter = function(that, index) {
                            var data = getInternalState(that);
                            return data.view[GETTER](index * BYTES + data.byteOffset, true);
                        };
                        var setter = function(that, index, value) {
                            var data = getInternalState(that);
                            if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
                            data.view[SETTER](index * BYTES + data.byteOffset, value, true);
                        };
                        var addElement = function(that, index) {
                            nativeDefineProperty(that, index, {
                                get: function() {
                                    return getter(this, index);
                                },
                                set: function(value) {
                                    return setter(this, index, value);
                                },
                                enumerable: true
                            });
                        };
                        if (!NATIVE_ARRAY_BUFFER_VIEWS) {
                            TypedArrayConstructor = wrapper(function(that, data, offset, $length) {
                                anInstance(that, TypedArrayConstructorPrototype);
                                var index = 0;
                                var byteOffset = 0;
                                var buffer, byteLength, length;
                                if (!isObject(data)) {
                                    length = toIndex(data);
                                    byteLength = length * BYTES;
                                    buffer = new ArrayBuffer1(byteLength);
                                } else if (isArrayBuffer(data)) {
                                    buffer = data;
                                    byteOffset = toOffset(offset, BYTES);
                                    var $len = data.byteLength;
                                    if ($length === undefined) {
                                        if ($len % BYTES) throw RangeError1(WRONG_LENGTH);
                                        byteLength = $len - byteOffset;
                                        if (byteLength < 0) throw RangeError1(WRONG_LENGTH);
                                    } else {
                                        byteLength = toLength($length) * BYTES;
                                        if (byteLength + byteOffset > $len) throw RangeError1(WRONG_LENGTH);
                                    }
                                    length = byteLength / BYTES;
                                } else if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
                                else return call(typedArrayFrom, TypedArrayConstructor, data);
                                setInternalState(that, {
                                    buffer: buffer,
                                    byteOffset: byteOffset,
                                    byteLength: byteLength,
                                    length: length,
                                    view: new DataView1(buffer)
                                });
                                while(index < length)addElement(that, index++);
                            });
                            if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
                            TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
                        } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
                            TypedArrayConstructor = wrapper(function(dummy, data, typedArrayOffset, $length) {
                                anInstance(dummy, TypedArrayConstructorPrototype);
                                return inheritIfRequired(function() {
                                    if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
                                    if (isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
                                    if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
                                    return call(typedArrayFrom, TypedArrayConstructor, data);
                                }(), dummy, TypedArrayConstructor);
                            });
                            if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
                            forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function(key) {
                                if (!(key in TypedArrayConstructor)) createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
                            });
                            TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
                        }
                        if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
                        createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_CONSTRUCTOR, TypedArrayConstructor);
                        if (TYPED_ARRAY_TAG) createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
                        exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
                        $({
                            global: true,
                            forced: TypedArrayConstructor != NativeTypedArrayConstructor,
                            sham: !NATIVE_ARRAY_BUFFER_VIEWS
                        }, exported);
                        if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
                        if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
                        setSpecies(CONSTRUCTOR_NAME);
                    };
                } else module1.exports = function() {};
            /***/ },
            /***/ 98883: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                /* provided dependency */ var Buffer = __webpack_require__(14598)["Buffer"];
                var isString = __webpack_require__(91867).isString;
                var isNumber = __webpack_require__(91867).isNumber;
                var isBoolean = __webpack_require__(91867).isBoolean;
                var isArray = __webpack_require__(91867).isArray;
                var isUndefined = __webpack_require__(91867).isUndefined;
                var fontStringify = __webpack_require__(91867).fontStringify;
                function DocPreprocessor() {}
                DocPreprocessor.prototype.preprocessDocument = function(docStructure) {
                    this.parentNode = null;
                    this.tocs = [];
                    this.nodeReferences = [];
                    return this.preprocessNode(docStructure);
                };
                DocPreprocessor.prototype.preprocessNode = function(node) {
                    // expand shortcuts and casting values
                    if (isArray(node)) node = {
                        stack: node
                    };
                    else if (isString(node)) node = {
                        text: node
                    };
                    else if (isNumber(node) || isBoolean(node)) node = {
                        text: node.toString()
                    };
                    else if (node === undefined || node === null) node = {
                        text: ''
                    };
                    else if (Object.keys(node).length === 0) node = {
                        text: ''
                    };
                    else if ('text' in node && (node.text === undefined || node.text === null)) node.text = '';
                    if (node.columns) return this.preprocessColumns(node);
                    else if (node.stack) return this.preprocessVerticalContainer(node);
                    else if (node.ul) return this.preprocessList(node);
                    else if (node.ol) return this.preprocessList(node);
                    else if (node.table) return this.preprocessTable(node);
                    else if (node.text !== undefined) return this.preprocessText(node);
                    else if (node.toc) return this.preprocessToc(node);
                    else if (node.image) return this.preprocessImage(node);
                    else if (node.svg) return this.preprocessSVG(node);
                    else if (node.canvas) return this.preprocessCanvas(node);
                    else if (node.qr) return this.preprocessQr(node);
                    else if (node.pageReference || node.textReference) return this.preprocessText(node);
                    else throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
                };
                DocPreprocessor.prototype.preprocessColumns = function(node) {
                    var columns = node.columns;
                    for(var i = 0, l = columns.length; i < l; i++)columns[i] = this.preprocessNode(columns[i]);
                    return node;
                };
                DocPreprocessor.prototype.preprocessVerticalContainer = function(node) {
                    var items = node.stack;
                    for(var i = 0, l = items.length; i < l; i++)items[i] = this.preprocessNode(items[i]);
                    return node;
                };
                DocPreprocessor.prototype.preprocessList = function(node) {
                    var items = node.ul || node.ol;
                    for(var i = 0, l = items.length; i < l; i++)items[i] = this.preprocessNode(items[i]);
                    return node;
                };
                DocPreprocessor.prototype.preprocessTable = function(node) {
                    var col, row, cols, rows;
                    for(col = 0, cols = node.table.body[0].length; col < cols; col++)for(row = 0, rows = node.table.body.length; row < rows; row++){
                        var rowData = node.table.body[row];
                        var data = rowData[col];
                        if (data !== undefined) {
                            if (data === null) data = '';
                            if (!data._span) rowData[col] = this.preprocessNode(data);
                        }
                    }
                    return node;
                };
                DocPreprocessor.prototype.preprocessText = function(node) {
                    if (node.tocItem) {
                        if (!isArray(node.tocItem)) node.tocItem = [
                            node.tocItem
                        ];
                        for(var i = 0, l = node.tocItem.length; i < l; i++){
                            if (!isString(node.tocItem[i])) node.tocItem[i] = '_default_';
                            var tocItemId = node.tocItem[i];
                            if (!this.tocs[tocItemId]) this.tocs[tocItemId] = {
                                toc: {
                                    _items: [],
                                    _pseudo: true
                                }
                            };
                            if (!node.id) node.id = 'toc-' + tocItemId + '-' + this.tocs[tocItemId].toc._items.length;
                            var tocItemRef = {
                                _nodeRef: this._getNodeForNodeRef(node),
                                _textNodeRef: node
                            };
                            this.tocs[tocItemId].toc._items.push(tocItemRef);
                        }
                    }
                    if (node.id) {
                        if (this.nodeReferences[node.id]) {
                            if (!this.nodeReferences[node.id]._pseudo) throw "Node id '" + node.id + "' already exists";
                            this.nodeReferences[node.id]._nodeRef = this._getNodeForNodeRef(node);
                            this.nodeReferences[node.id]._textNodeRef = node;
                            this.nodeReferences[node.id]._pseudo = false;
                        } else this.nodeReferences[node.id] = {
                            _nodeRef: this._getNodeForNodeRef(node),
                            _textNodeRef: node
                        };
                    }
                    if (node.pageReference) {
                        if (!this.nodeReferences[node.pageReference]) this.nodeReferences[node.pageReference] = {
                            _nodeRef: {},
                            _textNodeRef: {},
                            _pseudo: true
                        };
                        node.text = '00000';
                        node.linkToDestination = node.pageReference;
                        node._pageRef = this.nodeReferences[node.pageReference];
                    }
                    if (node.textReference) {
                        if (!this.nodeReferences[node.textReference]) this.nodeReferences[node.textReference] = {
                            _nodeRef: {},
                            _pseudo: true
                        };
                        node.text = '';
                        node.linkToDestination = node.textReference;
                        node._textRef = this.nodeReferences[node.textReference];
                    }
                    if (node.text && node.text.text) node.text = [
                        this.preprocessNode(node.text)
                    ];
                    else if (isArray(node.text)) {
                        var isSetParentNode = false;
                        if (this.parentNode === null) {
                            this.parentNode = node;
                            isSetParentNode = true;
                        }
                        for(var i = 0, l = node.text.length; i < l; i++)node.text[i] = this.preprocessNode(node.text[i]);
                        if (isSetParentNode) this.parentNode = null;
                    }
                    return node;
                };
                DocPreprocessor.prototype.preprocessToc = function(node) {
                    if (!node.toc.id) node.toc.id = '_default_';
                    node.toc.title = node.toc.title ? this.preprocessNode(node.toc.title) : null;
                    node.toc._items = [];
                    if (this.tocs[node.toc.id]) {
                        if (!this.tocs[node.toc.id].toc._pseudo) throw "TOC '" + node.toc.id + "' already exists";
                        node.toc._items = this.tocs[node.toc.id].toc._items;
                    }
                    this.tocs[node.toc.id] = node;
                    return node;
                };
                DocPreprocessor.prototype.preprocessImage = function(node) {
                    if (!isUndefined(node.image.type) && !isUndefined(node.image.data) && node.image.type === 'Buffer' && isArray(node.image.data)) node.image = Buffer.from(node.image.data);
                    return node;
                };
                DocPreprocessor.prototype.preprocessSVG = function(node) {
                    return node;
                };
                DocPreprocessor.prototype.preprocessCanvas = function(node) {
                    return node;
                };
                DocPreprocessor.prototype.preprocessQr = function(node) {
                    return node;
                };
                DocPreprocessor.prototype._getNodeForNodeRef = function(node) {
                    if (this.parentNode) return this.parentNode;
                    return node;
                };
                module1.exports = DocPreprocessor;
            /***/ },
            /***/ 99018: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                module1.exports = __webpack_require__(64785).EventEmitter;
            /***/ },
            /***/ 99049: /***/ function(module1) {
                "use strict";
                // Note: we can't get significant speed boost here.
                // So write code to minimize size - no pregenerated tables
                // and array tools dependencies.
                // (C) 1995-2013 Jean-loup Gailly and Mark Adler
                // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
                //
                // This software is provided 'as-is', without any express or implied
                // warranty. In no event will the authors be held liable for any damages
                // arising from the use of this software.
                //
                // Permission is granted to anyone to use this software for any purpose,
                // including commercial applications, and to alter it and redistribute it
                // freely, subject to the following restrictions:
                //
                // 1. The origin of this software must not be misrepresented; you must not
                //   claim that you wrote the original software. If you use this software
                //   in a product, an acknowledgment in the product documentation would be
                //   appreciated but is not required.
                // 2. Altered source versions must be plainly marked as such, and must not be
                //   misrepresented as being the original software.
                // 3. This notice may not be removed or altered from any source distribution.
                // Use ordinary array, since untyped makes no boost here
                function makeTable() {
                    var c, table = [];
                    for(var n = 0; n < 256; n++){
                        c = n;
                        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
                        table[n] = c;
                    }
                    return table;
                }
                // Create table on load. Just 255 signed longs. Not a problem.
                var crcTable = makeTable();
                function crc32(crc, buf, len, pos) {
                    var t = crcTable, end = pos + len;
                    crc ^= -1;
                    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
                    return crc ^ -1; // >>> 0;
                }
                module1.exports = crc32;
            /***/ },
            /***/ 99129: /***/ function(module1) {
                "use strict";
                module1.exports = /*#__PURE__*/ JSON.parse('{"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}');
            /***/ },
            /***/ 99757: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                __webpack_require__(14032);
                function _inheritsLoose(t, o) {
                    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
                }
                function _setPrototypeOf(t, e) {
                    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                        return t.__proto__ = e, t;
                    }, _setPrototypeOf(t, e);
                }
                var Struct = __webpack_require__(88152);
                var getPath = function getPath(object, pathArray) {
                    return pathArray.reduce(function(prevObj, key) {
                        return prevObj && prevObj[key];
                    }, object);
                };
                var VersionedStruct = /*#__PURE__*/ function(_Struct) {
                    function VersionedStruct(type, versions) {
                        var _this;
                        if (versions === void 0) versions = {};
                        _this = _Struct.call(this) || this;
                        _this.type = type;
                        _this.versions = versions;
                        if (typeof type === 'string') _this.versionPath = type.split('.');
                        return _this;
                    }
                    _inheritsLoose(VersionedStruct, _Struct);
                    var _proto = VersionedStruct.prototype;
                    _proto.decode = function decode(stream, parent, length) {
                        if (length === void 0) length = 0;
                        var res = this._setup(stream, parent, length);
                        if (typeof this.type === 'string') res.version = getPath(parent, this.versionPath);
                        else res.version = this.type.decode(stream);
                        if (this.versions.header) this._parseFields(stream, res, this.versions.header);
                        var fields = this.versions[res.version];
                        if (fields == null) throw new Error("Unknown version " + res.version);
                        if (fields instanceof VersionedStruct) return fields.decode(stream, parent);
                        this._parseFields(stream, res, fields);
                        if (this.process != null) this.process.call(res, stream);
                        return res;
                    };
                    _proto.size = function size(val, parent, includePointers) {
                        if (includePointers === void 0) includePointers = true;
                        var key, type;
                        if (!val) throw new Error('Not a fixed size');
                        var ctx = {
                            parent: parent,
                            val: val,
                            pointerSize: 0
                        };
                        var size = 0;
                        if (typeof this.type !== 'string') size += this.type.size(val.version, ctx);
                        if (this.versions.header) for(key in this.versions.header){
                            type = this.versions.header[key];
                            if (type.size != null) size += type.size(val[key], ctx);
                        }
                        var fields = this.versions[val.version];
                        if (fields == null) throw new Error("Unknown version " + val.version);
                        for(key in fields){
                            type = fields[key];
                            if (type.size != null) size += type.size(val[key], ctx);
                        }
                        if (includePointers) size += ctx.pointerSize;
                        return size;
                    };
                    _proto.encode = function encode(stream, val, parent) {
                        var key, type;
                        if (this.preEncode != null) this.preEncode.call(val, stream);
                        var ctx = {
                            pointers: [],
                            startOffset: stream.pos,
                            parent: parent,
                            val: val,
                            pointerSize: 0
                        };
                        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
                        if (typeof this.type !== 'string') this.type.encode(stream, val.version);
                        if (this.versions.header) for(key in this.versions.header){
                            type = this.versions.header[key];
                            if (type.encode != null) type.encode(stream, val[key], ctx);
                        }
                        var fields = this.versions[val.version];
                        for(key in fields){
                            type = fields[key];
                            if (type.encode != null) type.encode(stream, val[key], ctx);
                        }
                        var i = 0;
                        while(i < ctx.pointers.length){
                            var ptr = ctx.pointers[i++];
                            ptr.type.encode(stream, ptr.val, ptr.parent);
                        }
                    };
                    return VersionedStruct;
                }(Struct);
                module1.exports = VersionedStruct;
            /***/ },
            /***/ 99900: /***/ function(module1) {
                "use strict";
                // Manually added data to be used by sbcs codec in addition to generated one.
                module1.exports = {
                    // Not supported by iconv, not sure why.
                    "10029": "maccenteuro",
                    "maccenteuro": {
                        "type": "_sbcs",
                        "chars": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7"
                    },
                    "808": "cp808",
                    "ibm808": "cp808",
                    "cp808": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\u20AC\u25A0\xa0"
                    },
                    "mik": {
                        "type": "_sbcs",
                        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2514\u2534\u252C\u251C\u2500\u253C\u2563\u2551\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2510\u2591\u2592\u2593\u2502\u2524\u2116\xa7\u2557\u255D\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    "cp720": {
                        "type": "_sbcs",
                        "chars": "\x80\x81\xe9\xe2\x84\xe0\x86\xe7\xea\xeb\xe8\xef\xee\x8d\x8e\x8f\x90\u0651\u0652\xf4\xa4\u0640\xfb\xf9\u0621\u0622\u0623\u0624\xa3\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0636\u0637\u0638\u0639\u063A\u0641\xb5\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u2261\u064B\u064C\u064D\u064E\u064F\u0650\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
                    },
                    // Aliases of generated encodings.
                    "ascii8bit": "ascii",
                    "usascii": "ascii",
                    "ansix34": "ascii",
                    "ansix341968": "ascii",
                    "ansix341986": "ascii",
                    "csascii": "ascii",
                    "cp367": "ascii",
                    "ibm367": "ascii",
                    "isoir6": "ascii",
                    "iso646us": "ascii",
                    "iso646irv": "ascii",
                    "us": "ascii",
                    "latin1": "iso88591",
                    "latin2": "iso88592",
                    "latin3": "iso88593",
                    "latin4": "iso88594",
                    "latin5": "iso88599",
                    "latin6": "iso885910",
                    "latin7": "iso885913",
                    "latin8": "iso885914",
                    "latin9": "iso885915",
                    "latin10": "iso885916",
                    "csisolatin1": "iso88591",
                    "csisolatin2": "iso88592",
                    "csisolatin3": "iso88593",
                    "csisolatin4": "iso88594",
                    "csisolatincyrillic": "iso88595",
                    "csisolatinarabic": "iso88596",
                    "csisolatingreek": "iso88597",
                    "csisolatinhebrew": "iso88598",
                    "csisolatin5": "iso88599",
                    "csisolatin6": "iso885910",
                    "l1": "iso88591",
                    "l2": "iso88592",
                    "l3": "iso88593",
                    "l4": "iso88594",
                    "l5": "iso88599",
                    "l6": "iso885910",
                    "l7": "iso885913",
                    "l8": "iso885914",
                    "l9": "iso885915",
                    "l10": "iso885916",
                    "isoir14": "iso646jp",
                    "isoir57": "iso646cn",
                    "isoir100": "iso88591",
                    "isoir101": "iso88592",
                    "isoir109": "iso88593",
                    "isoir110": "iso88594",
                    "isoir144": "iso88595",
                    "isoir127": "iso88596",
                    "isoir126": "iso88597",
                    "isoir138": "iso88598",
                    "isoir148": "iso88599",
                    "isoir157": "iso885910",
                    "isoir166": "tis620",
                    "isoir179": "iso885913",
                    "isoir199": "iso885914",
                    "isoir203": "iso885915",
                    "isoir226": "iso885916",
                    "cp819": "iso88591",
                    "ibm819": "iso88591",
                    "cyrillic": "iso88595",
                    "arabic": "iso88596",
                    "arabic8": "iso88596",
                    "ecma114": "iso88596",
                    "asmo708": "iso88596",
                    "greek": "iso88597",
                    "greek8": "iso88597",
                    "ecma118": "iso88597",
                    "elot928": "iso88597",
                    "hebrew": "iso88598",
                    "hebrew8": "iso88598",
                    "turkish": "iso88599",
                    "turkish8": "iso88599",
                    "thai": "iso885911",
                    "thai8": "iso885911",
                    "celtic": "iso885914",
                    "celtic8": "iso885914",
                    "isoceltic": "iso885914",
                    "tis6200": "tis620",
                    "tis62025291": "tis620",
                    "tis62025330": "tis620",
                    "10000": "macroman",
                    "10006": "macgreek",
                    "10007": "maccyrillic",
                    "10079": "maciceland",
                    "10081": "macturkish",
                    "cspc8codepage437": "cp437",
                    "cspc775baltic": "cp775",
                    "cspc850multilingual": "cp850",
                    "cspcp852": "cp852",
                    "cspc862latinhebrew": "cp862",
                    "cpgr": "cp869",
                    "msee": "cp1250",
                    "mscyrl": "cp1251",
                    "msansi": "cp1252",
                    "msgreek": "cp1253",
                    "msturk": "cp1254",
                    "mshebr": "cp1255",
                    "msarab": "cp1256",
                    "winbaltrim": "cp1257",
                    "cp20866": "koi8r",
                    "20866": "koi8r",
                    "ibm878": "koi8r",
                    "cskoi8r": "koi8r",
                    "cp21866": "koi8u",
                    "21866": "koi8u",
                    "ibm1168": "koi8u",
                    "strk10482002": "rk1048",
                    "tcvn5712": "tcvn",
                    "tcvn57121": "tcvn",
                    "gb198880": "iso646cn",
                    "cn": "iso646cn",
                    "csiso14jisc6220ro": "iso646jp",
                    "jisc62201969ro": "iso646jp",
                    "jp": "iso646jp",
                    "cshproman8": "hproman8",
                    "r8": "hproman8",
                    "roman8": "hproman8",
                    "xroman8": "hproman8",
                    "ibm1051": "hproman8",
                    "mac": "macintosh",
                    "csmacintosh": "macintosh"
                };
            /***/ },
            /***/ 99948: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var Buffer = __webpack_require__(93143).Buffer;
                // Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
                // correspond to encoded bytes (if 128 - then lower half is ASCII). 
                exports._sbcs = SBCSCodec;
                function SBCSCodec(codecOptions, iconv) {
                    if (!codecOptions) throw new Error("SBCS codec is called without the data.");
                    // Prepare char buffer for decoding.
                    if (!codecOptions.chars || codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256) throw new Error("Encoding '" + codecOptions.type + "' has incorrect 'chars' (must be of len 128 or 256)");
                    if (codecOptions.chars.length === 128) {
                        var asciiString = "";
                        for(var i = 0; i < 128; i++)asciiString += String.fromCharCode(i);
                        codecOptions.chars = asciiString + codecOptions.chars;
                    }
                    this.decodeBuf = Buffer.from(codecOptions.chars, 'ucs2');
                    // Encoding buffer.
                    var encodeBuf = Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));
                    for(var i = 0; i < codecOptions.chars.length; i++)encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
                    this.encodeBuf = encodeBuf;
                }
                SBCSCodec.prototype.encoder = SBCSEncoder;
                SBCSCodec.prototype.decoder = SBCSDecoder;
                function SBCSEncoder(options, codec) {
                    this.encodeBuf = codec.encodeBuf;
                }
                SBCSEncoder.prototype.write = function(str) {
                    var buf = Buffer.alloc(str.length);
                    for(var i = 0; i < str.length; i++)buf[i] = this.encodeBuf[str.charCodeAt(i)];
                    return buf;
                };
                SBCSEncoder.prototype.end = function() {};
                function SBCSDecoder(options, codec) {
                    this.decodeBuf = codec.decodeBuf;
                }
                SBCSDecoder.prototype.write = function(buf) {
                    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
                    var decodeBuf = this.decodeBuf;
                    var newBuf = Buffer.alloc(buf.length * 2);
                    var idx1 = 0, idx2 = 0;
                    for(var i = 0; i < buf.length; i++){
                        idx1 = buf[i] * 2;
                        idx2 = i * 2;
                        newBuf[idx2] = decodeBuf[idx1];
                        newBuf[idx2 + 1] = decodeBuf[idx1 + 1];
                    }
                    return newBuf.toString('ucs2');
                };
                SBCSDecoder.prototype.end = function() {};
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ id: moduleId,
                /******/ loaded: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.loaded = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/global */ /******/ !function() {
            /******/ __webpack_require__.g = function() {
                /******/ if (typeof globalThis === 'object') return globalThis;
                /******/ try {
                    /******/ return this || new Function('return this')();
                /******/ } catch (e) {
                    /******/ if (typeof window === 'object') return window;
                /******/ }
            /******/ }();
        /******/ }();
        /******/ /******/ /* webpack/runtime/node module decorator */ /******/ !function() {
            /******/ __webpack_require__.nmd = function(module1) {
                /******/ module1.paths = [];
                /******/ if (!module1.children) module1.children = [];
                /******/ return module1;
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(73751);
        /******/ /******/ return __webpack_exports__;
    /******/ }();
});


var $215e9e6c69e16a37$exports = {};
var $215e9e6c69e16a37$var$vfs = {
    "Roboto-Italic.ttf": "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",
    "Roboto-Medium.ttf": "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",
    "Roboto-MediumItalic.ttf": "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",
    "Roboto-Regular.ttf": "AAEAAAARAQAABAAQR0RFRqcXo6wAAcMkAAACWEdQT1MB9nz6AAHFfAAAeJJHU1VCzzL7wgACPhAAABX6T1MvMpeDsYsAAAGYAAAAYGNtYXBnX+zQAAAWoAAABopjdnQgO/gmfQAAL4QAAAD+ZnBnbagFhDIAAB0sAAAPhmdhc3AACAAZAAHDGAAAAAxnbHlmpUQY8gAAOtwAAYRyaGVhZAtjdKEAAAEcAAAANmhoZWEKugrLAAABVAAAACRobXR4BSSe4QAAAfgAABSobG9jYebohTMAADCEAAAKVm1heHAI2hDGAAABeAAAACBuYW1lVOeDDwABv1AAAAOmcG9zdP9tAGQAAcL4AAAAIHByZXB5WM7TAAAstAAAAs4AAQAAAAMC0XueoplfDzz1ABsIAAAAAADE8BEuAAAAAOP3FVz6Gv3VCTEIcwAAAAkAAgAAAAAAAAABAAAHbP4MAAAJSvoa/koJMQABAAAAAAAAAAAAAAAAAAAFKgABAAAFKgCpABUAdgAHAAIAEAAvAJoAAALmD3UAAwABAAQEiQGQAAUAAAWaBTMAAAEfBZoFMwAAA9EAZgIAAAACAAAAAAAAAAAA4AAC/1AAIFsAAAAgAAAAAEdPT0cAQAAA//0GAP4AAGYHmgIAIAABnwAAAAAEOgWwAAAAIAADA4wAZAAAAAAAAAAAAfwAAAH8AAACEAChApAAiQTtAHcEfwBuBdwAaQT6AGYBZgBoAr0AhgLJACcDcgAcBIoATgGTAB0CNgAmAhwAkANNABMEfwBzBH8AqwR/AF4EfwBfBH8ANQR/AJoEfwCFBH8ATgR/AHEEfwBkAfAAhQGxACkEEQBIBGQAmAQvAIcDyABLBy8AbQU4AB0E/ACpBTUAeAVAAKkEjACpBGwAqQVzAHoFtQCpAi0AtwRqADUFBQCpBE8AqQb8AKkFtQCpBYEAdwUMAKkFgQBuBO4AqQTAAFEExgAyBTAAjAUYAB0HGQA9BQQAOgTOAA8EywBXAh8AkwNJACkCHwAKA1gAQAOcAAQCeQA5BFoAbQR+AIwEMABdBIMAXwQ+AF0CyAA9BH4AYQRoAI0B8gCOAer/vgQOAI0B8gCcBwQAiwRrAI0EkABcBH4AjASMAF8CtgCNBCEAXwKeAAkEaQCJA+AAIQYDACsD+AAqA8kAFgP4AFkCtQBAAfQAsAK1ABQFcQCDAfQAiwRhAGkEpwBbBbUAaQQ0AA8B7ACUBOgAWwNZAGUGSQBcA5QAkwPBAGUEbgB/BkoAWwOrAI8C/QCDBEcAYQLvAEIC7wA/AoIAewSJAJsD6gBEAhcAlAH8AHQC7wB7A6QAewPAAGcF3ABVBjUAUAY5AHADygBEB3r/8QRFAFkFgQB3BLoApwTCAIwGwgBPBLEAfgSSAEcEiQBcBJwAlQTIAF8FmwAeAfsAnAR0AJsETwAjAioAIwWLAKIEiQCSB6EAaQdEAGEB/AChBYcAXgK6/+MFfwBmBJMAXAWQAIwE8wCJAgT/tAQ4AGMDxACqA44AjgOrAI8DawCCAfIAjgKuAHkCKwAyA8YAewL8AF8CWgB/AAD8pwAA/W4AAPyKAAD9XQAA/CcAAP04Ag4AuAQMAHICFwCUBHMAsgWkACAFcgBnBT8AMgSSAHgFtQCyBJIARgW7AE4FiQBaBVIAcgSGAGQEvQChBAMALwSJAGEEUQBkBCUAbQSJAJIEjwB7ApgAwwRvACYD7ABmBMUAKQSJAJIETgBlBIgAYQQsAFEEXgCQBaMAWAWaAGAGlwB6BKIAegRD/9oGSABLBgAAKwVlAHsIkgAyCKUAsgaDAD4FtACwBQsAowYEADMHQwAbBMAAUAW1ALIFqgAwBQgATQYtAFQF2gCvBXoAlweHALAHwACwBhIAEQbrALIFBQCjBWUAlAcnALcFGABaBG0AYgSTAJ4DXACbBNQALgYhABYEEABYBJ4AnQRTAJ0EoAAsBe8AngSdAJ0EngCdA9kAKAXOAGQEvgCdBFoAaAZ5AJ0GnwCSBPcAHgY2AJ4EWACeBE4AZAaIAJ4EZAAvBGj/5wROAGcGyQAnBuQAnQSJ//0EngCdBwkAnAYsAIEEV//bBywAuAX5AJoE0wAoBEcADwcMAMoGDAC9BtIAkwXiAJcJBQC3B9EAnAQkAFAD2wBMBXIAZwSMAFwFCwAWBAQALwVyAGcEiQBcBwEAnAYkAH4HCQCcBiwAgQUyAHYESABkBP4AdAAA/GYAAPxwAAD9ZQAA/aQAAPoaAAD6KwYJALIE7QCdBFf/2wUbAKkEigCMBGQAogORAJIE2wCyBAYAkgeiABsGYQAWBZoAsgS4AJ0FCgCkBH4AmwaMAEUFhAA/Bf8AqQTZAJ0HzwCpBbQAkggxALAG9ACSBe8AcQTUAG4FGAA6BCoAKgctADQFXQAfBbwAlwSWAGgFcACXBGsAhAVwAIkGMAA/BL7/3QUKAKQEWgCbBf4AMATvACwFswCyBIkAkgYSAKkE7ACdB08AqQY+AJ4FhwBeBKgAaASoAGoEuAA5A6sAOgUuADoEQAAqBPcAVwaVAFoG5QBkBlcANgUsADEESgBTBAgAeQfCAEUGdgA/B/sAqgaiAJAE9wB2BB4AZgWuACQFIQBGBWUAlwYCADAE8wAsBSsAjwMhAHAEFAAACCkAAAQUAAAIKQAAArkAAAIKAAABXAAABH8AAAIwAAABogAAAQAAAADRAAAAAAAAAjQAJgI0ACYFQACiBj8AkAOmAA0BmgBhAZoAMAGYACQBmgBPAtQAaQLcADwCwgAkBGoARgSQAFcCswCLA8QAlAVaAJQBfwBSB6oARAJnAGwCZwBaA6MAPALvAFEC7wA2Au8AXALvAFYC7wA7Au8ATwLvAEoDOABQAvgAUAL4AFAB8QBUAfEAUANhAHoC7wBRAu8AewLvAEIC7wA/Au8ANgLvAFwC7wBWAu8AOwLvAE8C7wBKAzgAUAL4AFAC+ABQAfEAVAHxAFAEpwBbBlYAHwaRAKcIdgCpBesAHwYrAIwEfwBfBdoAHwQjACsEdAAhBUgAXQVPAB8F6AB7A84AaAg6AKIFAQBoBRgAmAYmAFQG1wBlBs8AZAZqAFoEkABqBY8AqQSvAEYEkwCoBMUAPwg6AGMCDf+vBIIAZQRkAJgEEQA9BC8AhAQIACwCTAC1ApAAbwIEAF0E8wA9BG8AIASLAD0G1AA9BtQAPQTuAD0GmwBfAAAAAAg0AFsINQBcAu8AQgLvAHsC7wBRBBAAVgQQAGEEEABCBA8AcgQQAIEEEAAxBBAATwQQAE8EEACZBBAAYwQjAEgEKwAOBFQAJwYVADEEaAAUBH0AdQQnACkEIABEBEoAigS8AFoEXQCLBLwAYATjAIsGAgCLA7UAiwRVAIsDzwAsAekAmATkAIsErABkA8wAiwQgAEQENAAxA6EADgOvAIsEaAAUBLwAYARoABQDiQA+BM8AiwPwAEAFZwBhBRcAYQTzAHYFcwAnBHwAYQdCACgHUACLBXQAKQTOAIsEWgCLBSUALgYLAB8EQABIBOwAiwROAIwEwQAoBCAAIwUpAIsEagA9BlEAiwasAIsFHQAJBfEAiwRPAIsEfABLBncAiwSHAFAEEgALBkgAHwR5AIwFCgCMBTcAJAXDAGAEXwAOBKgAJwZiACcEagA9BGoAiwXEAAIEywBeBEAASAS8AGAENAAxA+QAQwgiAIsEqwAoAu8APwLvADYC7wBcAu8AVgLvADsC7wBPAu8ASgOXAI8CtQCfA+YAiwQ6AB8ExABkBUwAsgUkALIEFACTBT0AsgQPAJMEgACLBHwAYQRRAIsEhgAUAf4AnwOlAIIAAPyjA/AAbwP0/10EDwBpA/UAaQOvAIsDoACCA58AggLvAFEC7wA2Au8AXALvAFYC7wA7Au8ATwLvAEoFggB+Ba8AfgWTALIF4AB+BeMAfgPVAKAEggCDBFgADwTPAD4EawBlBC4ASgOlAIQBkgBoBqQAYAS6AIIB/P+2BH8AOwR/AHMEfwAiBH8AdgR/AHYEfwA2BH8AfgR/AF4EfwBxBH8A9AIG/7QCBP+0AfsAnAH7//kB+wCcBFEAiwUAAHgEIQA7BH4AjAQzAF0EkwBbBIwAWwSfAFoEjgCMBJwAWwQ+AF0EfgBhBHAAWgN5AFcE1gBoA7UAAQY6AAkD+QCLBLwAYATjADAE4wCLAfwAAAI2ACYFXgAlBV4AJQSGAAEExgAyAp7/9AU4AB0FOAAdBTgAHQU4AB0FOAAdBTgAHQU4AB0FNQB4BIwAqQSMAKkEjACpBIwAqQIt/98CLQCxAi3/6gIt/9UFtQCpBYEAdwWBAHcFgQB3BYEAdwWBAHcFMACMBTAAjAUwAIwFMACMBM4ADwRaAG0EWgBtBFoAbQRaAG0EWgBtBFoAbQRaAG0EMABdBD4AXQQ+AF0EPgBdBD4AXQH7/8QB+wCWAfv/zwH7/7oEawCNBJAAXASQAFwEkABcBJAAXASQAFwEaQCJBGkAiQRpAIkEaQCJA8kAFgPJABYFOAAdBFoAbQU4AB0EWgBtBTgAHQRaAG0FNQB4BDAAXQU1AHgEMABdBTUAeAQwAF0FNQB4BDAAXQVAAKkFGQBfBIwAqQQ+AF0EjACpBD4AXQSMAKkEPgBdBIwAqQQ+AF0EjACpBD4AXQVzAHoEfgBhBXMAegR+AGEFcwB6BH4AYQVzAHoEfgBhBbUAqQRoAI0CLf+2Afv/mwIt/80B+/+yAi3/7AH7/9ECLQAXAfL/+gItAKoGlwC3A9wAjgRqADUCBP+0BQUAqQQOAI0ETwCiAfIAkwRPAKkB8gBWBE8AqQKIAJwETwCpAs4AnAW1AKkEawCNBbUAqQRrAI0FtQCpBGsAjQRr/7sFgQB3BJAAXAWBAHcEkABcBYEAdwSQAFwE7gCpArYAjQTuAKkCtgBTBO4AqQK2AGQEwABRBCEAXwTAAFEEIQBfBMAAUQQhAF8EwABRBCEAXwTAAFEEIQBfBMYAMgKeAAkExgAyAp4ACQTGADICxgAJBTAAjARpAIkFMACMBGkAiQUwAIwEaQCJBTAAjARpAIkFMACMBGkAiQUwAIwEaQCJBxkAPQYDACsEzgAPA8kAFgTOAA8EywBXA/gAWQTLAFcD+ABZBMsAVwP4AFkHev/xBsIATwWBAHcEiQBcBID/vQSA/70EJwApBIYAFASGABQEhgAUBIYAFASGABQEhgAUBIYAFAR8AGED5gCLA+YAiwPmAIsD5gCLAen/vAHpAI4B6f/HAen/sgTjAIsEvABgBLwAYAS8AGAEvABgBLwAYAR9AHUEfQB1BH0AdQR9AHUEKwAOBIYAFASGABQEhgAUBHwAYQR8AGEEfABhBHwAYQSAAIsD5gCLA+YAiwPmAIsD5gCLA+YAiwSsAGQErABkBKwAZASsAGQE5ACLAen/kwHp/6oB6f/JAekABQHpAIcDzwAsBFUAiwO1AIMDtQCLA7UAiwO1AIsE4wCLBOMAiwTjAIsEvABgBLwAYAS8AGAESgCKBEoAigRKAIoEIABEBCAARAQgAEQEIABEBCcAKQQnACkEJwApBH0AdQR9AHUEfQB1BH0AdQR9AHUEfQB1BhUAMQQrAA4EKwAOBCMASAQjAEgEIwBIBTgAHQTw/4wGGf+aApH/oAWV//oFMv92BWb//AKY/5sFOAAdBPwAqQSMAKkEywBXBbUAqQItALcFBQCpBvwAqQW1AKkFgQB3BQwAqQTGADIEzgAPBQQAOgIt/9UEzgAPBIYAZARRAGQEiQCSApgAwwReAJAEdACbBJAAXASJAJsD4AAhBHAAWgKY/+QEXgCQBJAAXAReAJAGlwB6BIwAqQRzALIEwABRAi0AtwIt/9UEagA1BSQAsgUFAKkFCABNBTgAHQT8AKkEcwCyBIwAqQW1ALIG/ACpBbUAqQWBAHcFtQCyBQwAqQU1AHgExgAyBQQAOgRaAG0EPgBdBJ4AnQSQAFwEfgCMBDAAXQPJABYD+AAqBD4AXQNcAJsEIQBfAfIAjgH7/7oB6v++BFMAnQPJABYHGQA9BgMAKwcZAD0GAwArBxkAPQYDACsEzgAPA8kAFgFmAGgCkACJBCAAoQIE/7QBmgAwBvwAqQcEAIsFOAAdBFoAbQSMAKkFtQCyBD4AXQSeAJ0FiQBaBZoAYAULABYEBP/7CFkAXAlKAHcEwABQBBAAWAU1AHgEMABdBM4ADwQDAC8CLQC3B0MAGwYhABYCLQC3BTgAHQRaAG0FOAAdBFoAbQd6//EGwgBPBIwAqQQ+AF0FhwBeBDgAYwQ4AGMHQwAbBiEAFgTAAFAEEABYBbUAsgSeAJ0FtQCyBJ4AnQWBAHcEkABcBXIAZwSMAFwFcgBnBIwAXAVlAJQETgBkBQgATQPJABYFCABNA8kAFgUIAE0DyQAWBXoAlwRaAGgG6wCyBjYAngSDAF8FOAAdBFoAbQU4AB0EWgBtBTgAHQRaAG0FOAAdBFr/yQU4AB0EWgBtBTgAHQRaAG0FOAAdBFoAbQU4AB0EWgBtBTgAHQRaAG0FOAAdBFoAbQU4AB0EWgBtBTgAHQRaAG0EjACpBD4AXQSMAKkEPgBdBIwAqQQ+AF0EjACpBD4AXQSM/+4EPv+4BIwAqQQ+AF0EjACpBD4AXQSMAKkEPgBdAi0AtwH7AJwCLQCkAfIAhgWBAHcEkABcBYEAdwSQAFwFgQB3BJAAXAWBAEYEkP/CBYEAdwSQAFwFgQB3BJAAXAWBAHcEkABcBX8AZgSTAFwFfwBmBJMAXAV/AGYEkwBcBX8AZgSTAFwFfwBmBJMAXAUwAIwEaQCJBTAAjARpAIkFkACMBPMAiQWQAIwE8wCJBZAAjATzAIkFkACMBPMAiQWQAIwE8wCJBM4ADwPJABYEzgAPA8kAFgTOAA8DyQAWBKEAXwTGADID2QAoBXoAlwRaAGgEcwCyA1wAmwYwAD8Evv/dBGgAjQUF/9QFBf/UBHMAAwNc//0FOAALBCj/0wTOAA8EAwAvBQQAOgP4ACoEUQBkBGwAEgY/AJAEfwBeBH8AXwR/ADUEfwCaBJMAmQSnAIUEkwBkBKcAhwVzAHoEfgBhBbUAqQRrAI0FOAAdBFoAOgSMAF8EPgApAi3/CwH7/vAFgQB3BJAAMwTuAFYCtv+MBTAAjARpACsEp/84BPwAqQR+AIwFQACpBIMAXwVAAKkEgwBfBbUAqQRoAI0FBQCpBA4AjQUFAKkEDgCNBE8AqQHyAIYG/ACpBwQAiwW1AKkEawCNBYEAdwUMAKkEfgCMBO4AqQK2AIMEwABRBCEAXwTGADICngAJBTAAjAUYAB0D4AAhBRgAHQPgACEHGQA9BgMAKwTLAFcD+ABZBcf+eASGABQEIv+fBSD/uwIl/8AExv/fBGf/VQT9//cEhgAUBFEAiwPmAIsEIwBIBOQAiwHpAJgEVQCLBgIAiwTjAIsEvABgBF0AiwQnACkEKwAOBFQAJwHp/7IEKwAOA+YAiwOvAIsEIABEAekAmAHp/7IDzwAsBFUAiwQgACMEhgAUBFEAiwOvAIsD5gCLBOwAiwYCAIsE5ACLBLwAYATPAIsEXQCLBHwAYQQnACkEVAAnBEAASATkAIsEfABhBCsADgXEAAIE7ACLBCAAIwVnAGEFuACYBjoACQS8AGAEIABEBhUAMQYVADEGFQAxBCsADgU4AB0EWgBtBIwAqQQ+AF0EhgAUA+YAiwH7AIYAAAACAAAAAwAAABQAAwABAAAAFAAEBnYAAAD2AIAABgB2AAAAAgANAH4AoACsAK0AvwDGAM8A5gDvAP4BDwERASUBJwEwAVMBXwFnAX4BfwGPAZIBoQGwAfAB/wIbAjcCWQK8AscCyQLdAvMDAQMDAwkDDwMjA4oDjAOSA6EDsAO5A8kDzgPSA9YEJQQvBEUETwRiBG8EeQSGBJ8EqQSxBLoEzgTXBOEE9QUBBRAFEx4BHj8ehR6eHvEe8x75H00gCSALIBEgFSAeICIgJyAwIDMgOiA8IEQgcCCOIKQgqiCsILEguiC9IQUhEyEWISIhJiEuIV4iAiIGIg8iEiIaIh4iKyJIImAiZSXK7gL2w/sE/v///f//AAAAAAACAA0AIACgAKEArQCuAMAAxwDQAOcA8AD/ARABEgEmASgBMQFUAWABaAF/AY8BkgGgAa8B8AH6AhgCNwJZArwCxgLJAtgC8wMAAwMDCQMPAyMDhAOMA44DkwOjA7EDugPKA9ED1gQABCYEMARGBFAEYwRwBHoEiASgBKoEsgS7BM8E2ATiBPYFAgURHgAePh6AHp4eoB7yHvQfTSAAIAogECATIBcgICAlIDAgMiA5IDwgRCBwIHQgoyCmIKsgsSC5ILwhBSETIRYhIiEmIS4hWyICIgYiDyIRIhoiHiIrIkgiYCJkJcruAfbD+wH+///8//8AAQAA//b/5AH0/8IB6P/BAAAB2wAAAdYAAAHSAAAB0AAAAc4AAAHGAAAByP8W/wf/Bf74/usCCgAAAAD+Zf5EAT/92P3X/cn9tP2o/af9ov2d/YoAAAAaABkAAAAA/QoAAP/6/P78+wAA/LoAAPyyAAD8pwAA/KEAAPyZAAD8kQAA/0QAAP9BAAD8XgAA5f7lvuVv4tPlmuUD5ZjlmeFz4XThcAAA4W3hbOFq4WLjxeFa473hUeEm4SMAAOENAADhCOEB4QDgueCs4Krgn9+U4JTgaN/F3qzfud+437Hfrt+i34bfb99s3AgT0gsSBtYC3gHiAAEAAAAAAAAAAAAAAAAAAAAAAOYAAADwAAABGgAAATQAAAE0AAABNAAAAXYAAAAAAAAAAAAAAAAAAAF2AYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABbgAAAAABdgGSAAABqgAAAAAAAAHCAAACCgAAAjIAAAJUAAACZAAAApAAAAKcAAACwAAAAtAAAALkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALSAAAAAAAAAAAAAAAAAAAAAAAAAAACwgAAAsIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmwKcAp0CngKfAqAAgQKXAqsCrAKtAq4CrwKwAIIAgwKxArICswK0ArUAhACFArYCtwK4ArkCugK7AIYAhwLGAscCyALJAsoCywCIAIkCzALNAs4CzwLQAIoClgCLAIwCmACNAv8DAAMBAwIDAwMEAI4DBQMGAwcDCAMJAwoDCwMMAI8AkAMNAw4DDwMQAxEDEgMTAJEAkgMUAxUDFgMXAxgDGQCTAJQDKAMpAywDLQMuAy8CmQKaAqECvANHA0gDSQNKAyYDJwMqAysArgCvA6IAsAOjA6QDpQCxALIDrAOtA64AswOvA7AAtAOxA7IAtQOzALYDtAC3A7UDtgC4A7cAuQC6A7gDuQO6A7sDvAO9A74DvwDEA8EDwgDFA8AAxgDHAMgAyQDKAMsAzAPDAM0AzgQAA8kA0gPKANMDywPMA80DzgDUANUA1gPQBAED0QDXA9IA2APTA9QA2QPVANoA2wDcA9YDzwDdA9cD2APZA9oD2wPcA90A3gDfA94D3wDqAOsA7ADtA+AA7gDvAPAD4QDxAPIA8wD0A+IA9QPjA+QA9gPlAPcD5gQCA+cBAgPoAQMD6QPqA+sD7AEEAQUBBgPtBAMD7gEHAQgBCQSdBAQEBQEXARgBGQEaBAYEBwQJBAgBKAEpASoBKwScASwBLQEuAS8BMASeBJ8BMQEyATMBNAQKBAsBNQE2ATcBOASgBKEEDAQNBJMElAQOBA8EogSjBJsBTAFNBJkEmgQQBBEEEgFOAU8BUAFRAVIBUwFUAVUElQSWAVYBVwFYBB0EHAQeBB8EIAQhBCIBWQFaBJcEmAQ3BDgBWwFcAV0BXgSkBKUBXwQ5BKYBbwFwAYIBgwSoBKcBsgSSAbgAAEBKmZiXloeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUVBPTk1MS0pJSEdGKB8QCgksAbELCkMjQ2UKLSwAsQoLQyNDCy0sAbAGQ7AHQ2UKLSywTysgsEBRWCFLUlhFRBshIVkbIyGwQLAEJUWwBCVFYWSKY1JYRUQbISFZWS0sALAHQ7AGQwstLEtTI0tRWlggRYpgRBshIVktLEtUWCBFimBEGyEhWS0sS1MjS1FaWDgbISFZLSxLVFg4GyEhWS0ssAJDVFiwRisbISEhIVktLLACQ1RYsEcrGyEhIVktLLACQ1RYsEgrGyEhISFZLSywAkNUWLBJKxshISFZLSwjILAAUIqKZLEAAyVUWLBAG7EBAyVUWLAFQ4tZsE8rWSOwYisjISNYZVktLLEIAAwhVGBDLSyxDAAMIVRgQy0sASBHsAJDILgQAGK4EABjVyO4AQBiuBAAY1daWLAgYGZZSC0ssQACJbACJbACJVO4ADUjeLACJbACJWCwIGMgILAGJSNiUFiKIbABYCMbICCwBiUjYlJYIyGwAWEbiiEjISBZWbj/wRxgsCBjIyEtLLECAEKxIwGIUbFAAYhTWli4EACwIIhUWLICAQJDYEJZsSQBiFFYuCAAsECIVFiyAgICQ2BCsSQBiFRYsgIgAkNgQgBLAUtSWLICCAJDYEJZG7hAALCAiFRYsgIEAkNgQlm4QACwgGO4AQCIVFiyAggCQ2BCWblAAAEAY7gCAIhUWLICEAJDYEJZsSYBiFFYuUAAAgBjuAQAiFRYsgJAAkNgQlm5QAAEAGO4CACIVFiyAoACQ2BCWbEoAYhRWLlAAAgAY7gQAIhUWLkAAgEAsAJDYEJZWVlZWVlZsQACQ1RYQAoFQAhACUAMAg0CG7EBAkNUWLIFQAi6AQAACQEAswwBDQEbsYACQ1JYsgVACLgBgLEJQBu4AQCwAkNSWLIFQAi6AYAACQFAG7gBgLACQ1JYsgVACLgCALEJQBuyBUAIugEAAAkBAFlZWbhAALCAiFW5QAACAGO4BACIVVpYswwADQEbswwADQFZWVlCQkJCQi0sRbECTisjsE8rILBAUVghS1FYsAIlRbEBTitgWRsjS1FYsAMlRSBkimOwQFNYsQJOK2AbIVkbIVlZRC0sILAAUCBYI2UbI1mxFBSKcEWwTysjsWEGJmAriliwBUOLWSNYZVkjEDotLLADJUljI0ZgsE8rI7AEJbAEJUmwAyVjViBgsGJgK7ADJSAQRopGYLAgY2E6LSywABaxAgMlsQEEJQE+AD6xAQIGDLAKI2VCsAsjQrECAyWxAQQlAT8AP7EBAgYMsAYjZUKwByNCsAEWsQACQ1RYRSNFIBhpimMjYiAgsEBQWGcbZllhsCBjsEAjYbAEI0IbsQQAQiEhWRgBLSwgRbEATitELSxLUbFATytQW1ggRbEBTisgiopEILFABCZhY2GxAU4rRCEbIyGKRbEBTisgiiNERFktLEtRsUBPK1BbWEUgirBAYWNgGyMhRVmxAU4rRC0sI0UgikUjYSBksEBRsAQlILAAUyOwQFFaWrFATytUWliKDGQjZCNTWLFAQIphIGNhGyBjWRuKWWOxAk4rYEQtLAEtLAAtLAWxCwpDI0NlCi0ssQoLQyNDCwItLLACJWNmsAIluCAAYmAjYi0ssAIlY7AgYGawAiW4IABiYCNiLSywAiVjZ7ACJbggAGJgI2ItLLACJWNmsCBgsAIluCAAYmAjYi0sI0qxAk4rLSwjSrEBTistLCOKSiNFZLACJWSwAiVhZLADQ1JYISBkWbECTisjsABQWGVZLSwjikojRWSwAiVksAIlYWSwA0NSWCEgZFmxAU4rI7AAUFhlWS0sILADJUqxAk4rihA7LSwgsAMlSrEBTiuKEDstLLADJbADJYqwZyuKEDstLLADJbADJYqwaCuKEDstLLADJUawAyVGYLAEJS6wBCWwBCWwBCYgsABQWCGwahuwbFkrsAMlRrADJUZgYbCAYiCKIBAjOiMgECM6LSywAyVHsAMlR2CwBSVHsIBjYbACJbAGJUljI7AFJUqwgGMgWGIbIVmwBCZGYIpGikZgsCBjYS0ssAQmsAQlsAQlsAQmsG4rIIogECM6IyAQIzotLCMgsAFUWCGwAiWxAk4rsIBQIGBZIGBgILABUVghIRsgsAVRWCEgZmGwQCNhsQADJVCwAyWwAyVQWlggsAMlYYpTWCGwAFkbIVkbsAdUWCBmYWUjIRshIbAAWVlZsQJOKy0ssAIlsAQlSrAAU1iwABuKiiOKsAFZsAQlRiBmYSCwBSawBiZJsAUmsAUmsHArI2FlsCBgIGZhsCBhZS0ssAIlRiCKILAAUFghsQJOKxtFIyFZYWWwAiUQOy0ssAQmILgCAGIguAIAY4ojYSCwXWArsAUlEYoSiiA5ili5AF0QALAEJmNWYCsjISAQIEYgsQJOKyNhGyMhIIogEEmxAk4rWTstLLkAXRAAsAklY1ZgK7AFJbAFJbAFJrBtK7FdByVgK7AFJbAFJbAFJbAFJbBvK7kAXRAAsAgmY1ZgKyCwAFJYsFArsAUlsAUlsAclsAclsAUlsHErsAIXOLAAUrACJbABUlpYsAQlsAYlSbADJbAFJUlgILBAUlghG7AAUlggsAJUWLAEJbAEJbAHJbAHJUmwAhc4G7AEJbAEJbAEJbAGJUmwAhc4WVlZWVkhISEhIS0suQBdEACwCyVjVmArsAclsAclsAYlsAYlsAwlsAwlsAklsAglsG4rsAQXOLAHJbAHJbAHJrBtK7AEJbAEJbAEJrBtK7BQK7AGJbAGJbADJbBxK7AFJbAFJbADJbACFzggsAYlsAYlsAUlsHErYLAGJbAGJbAEJWWwAhc4sAIlsAIlYCCwQFNYIbBAYSOwQGEjG7j/wFBYsEBgI7BAYCNZWbAIJbAIJbAEJrACFziwBSWwBSWKsAIXOCCwAFJYsAYlsAglSbADJbAFJUlgILBAUlghG7AAUliwBiWwBiWwBiWwBiWwCyWwCyVJsAQXOLAGJbAGJbAGJbAGJbAKJbAKJbAHJbBxK7AEFziwBCWwBCWwBSWwByWwBSWwcSuwAhc4G7AEJbAEJbj/wLACFzhZWVkhISEhISEhIS0ssAQlsAMlh7ADJbADJYogsABQWCGwZRuwaFkrZLAEJbAEJQawBCWwBCVJICBjsAMlIGNRsQADJVRbWCEhIyEHGyBjsAIlIGNhILBTK4pjsAUlsAUlh7AEJbAEJkqwAFBYZVmwBCYgAUYjAEawBSYgAUYjAEawABYAsAAjSAGwACNIACCwASNIsAIjSAEgsAEjSLACI0gjsgIAAQgjOLICAAEJIzixAgEHsAEWWS0sIxANDIpjI4pjYGS5QAAEAGNQWLAAOBs8WS0ssAYlsAklsAklsAcmsHYrI7AAVFgFGwRZsAQlsAYmsHcrsAUlsAUmsAUlsAUmsHYrsABUWAUbBFmwdystLLAHJbAKJbAKJbAIJrB2K4qwAFRYBRsEWbAFJbAHJrB3K7AGJbAGJrAGJbAGJrB2KwiwdystLLAHJbAKJbAKJbAIJrB2K4qKCLAEJbAGJrB3K7AFJbAFJrAFJbAFJrB2K7AAVFgFGwRZsHcrLSywCCWwCyWwCyWwCSawdiuwBCawBCYIsAUlsAcmsHcrsAYlsAYmsAYlsAYmsHYrCLB3Ky0sA7ADJbADJUqwBCWwAyVKArAFJbAFJkqwBSawBSZKsAQmY4qKY2EtLLFdDiVgK7AMJhGwBSYSsAolObAHJTmwCiWwCiWwCSWwfCuwAFCwCyWwCCWwCiWwfCuwAFBUWLAHJbALJYewBCWwBCULsAolELAJJcGwAiWwAiULsAclELAGJcEbsAclsAslsAsluP//sHYrsAQlsAQlC7AHJbAKJbB3K7AKJbAIJbAIJbj//7B2K7ACJbACJQuwCiWwByWwdytZsAolRrAKJUZgsAglRrAIJUZgsAYlsAYlC7AMJbAMJbAMJiCwAFBYIbBqG7BsWSuwBCWwBCULsAklsAklsAkmILAAUFghsGobsGxZKyOwCiVGsAolRmBhsCBjI7AIJUawCCVGYGGwIGOxAQwlVFgEGwVZsAomIBCwAyU6sAYmsAYmC7AHJiAQijqxAQcmVFgEGwVZsAUmIBCwAiU6iooLIyAQIzotLCOwAVRYuQAAQAAbuEAAsABZirABVFi5AABAABu4QACwAFmwfSstLIqKCA2KsAFUWLkAAEAAG7hAALAAWbB9Ky0sCLABVFi5AABAABu4QACwAFkNsH0rLSywBCawBCYIDbAEJrAEJggNsH0rLSwgAUYjAEawCkOwC0OKYyNiYS0ssAkrsAYlLrAFJX3FsAYlsAUlsAQlILAAUFghsGobsGxZK7AFJbAEJbADJSCwAFBYIbBqG7BsWSsYsAglsAclsAYlsAolsG8rsAYlsAUlsAQmILAAUFghsGYbsGhZK7AFJbAEJbAEJiCwAFBYIbBmG7BoWStUWH2wBCUQsAMlxbACJRCwASXFsAUmIbAFJiEbsAYmsAQlsAMlsAgmsG8rWbEAAkNUWH2wAiWwgiuwBSWwgisgIGlhsARDASNhsGBgIGlhsCBhILAIJrAIJoqwAhc4iophIGlhYbACFzgbISEhIVkYLSxLUrEBAkNTWlgjECABPAA8GyEhWS0sI7ACJbACJVNYILAEJVg8GzlZsAFguP/pHFkhISEtLLACJUewAiVHVIogIBARsAFgiiASsAFhsIUrLSywBCVHsAIlR1QjIBKwAWEjILAGJiAgEBGwAWCwBiawhSuKirCFKy0ssAJDVFgMAopLU7AEJktRWlgKOBsKISFZGyEhISFZLSywmCtYDAKKS1OwBCZLUVpYCjgbCiEhWRshISEhWS0sILACQ1SwASO4AGgjeCGxAAJDuABeI3khsAJDI7AgIFxYISEhsAC4AE0cWYqKIIogiiO4EABjVli4EABjVlghISGwAbgAMBxZGyFZsIBiIFxYISEhsAC4AB0cWSOwgGIgXFghISGwALgADBxZirABYbj/qxwjIS0sILACQ1SwASO4AIEjeCGxAAJDuAB3I3khsQACQ4qwICBcWCEhIbgAZxxZioogiiCKI7gQAGNWWLgQAGNWWLAEJrABW7AEJrAEJrAEJhshISEhuAA4sAAjHFkbIVmwBCYjsIBiIFxYilyKWiMhIyG4AB4cWYqwgGIgXFghISMhuAAOHFmwBCawAWG4/5McIyEtAABA/340fVV8Pv8fezv/H3o9/x95O0AfeDz/H3c8PR92NQcfdTr/H3Q6Zx9zOU8fcjn/H3E2/x9wOM0fbzj/H243Xh9tN80fbDf/H2s3LR9qNxgfaTT/H2gy/x9nMs0fZjP/H2Ux/x9kMP8fYzCrH2IwZx9hLv8fYC6AH18v/x9eL5MfXS3/H1ws/x9bK/8fWirNH1kq/x9YKg0fVyn/H1Yo/x9VJyQfVCctH1MlXh9SJf8fUSWrH1Am/x9PJoAfTiT/H00jKx9MI6sfSyP/H0ojVh9JIysfSCL/H0cg/x9GIHIfRSH/H0Qhch9DH/8fQh6TH0Ee/x9AHf8fPxz/Hz07k0DqHzw7NB86NQ4fOTZyHzg2Tx83NiIfNjWTHzMyQB8xMHIfLy5KHysqQB8nGQQfJiUoHyUzGxlcJBoSHyMFGhlcIhn/HyEgPR8gOBgWXB8YLR8eF/8fHRb/HxwWBx8bMxkcWxg0FhxbGjMZHFsXNBYcWxUZPhamWhMxElURMRBVElkQWQ00DFUFNARVDFkEWR8EXwQCDwR/BO8EAw9eDlULNApVBzQGVQExAFUOWQpZBll/BgEvBk8GbwYDPwZfBn8GAwBZLwABLwBvAO8AAwk0CFUDNAJVCFkCWR8CXwICDwJ/Au8CAwNAQAUBuAGQsFQrS7gH/1JLsAlQW7ABiLAlU7ABiLBAUVqwBoiwAFVaW1ixAQGOWYWNjQAdQkuwkFNYsgMAAB1CWbECAkNRWLEEA45Zc3QAKwArKytzdAArc3R1ACsAKwArKysrK3N0ACsAKysrACsAKysrASsBKwErASsBKwErKwArKwErKwErACsAKwErKysrKwErKwArKysrKysrASsrACsrKysrKysBKwArKysrKysrKysrKysrASsrACsrKysrKysrKysBKysrKysrKwArKysrKysrKysrKysrKysrKysrKysYAAAGAAAVBbAAFAWwABQEOgAUAAD/7AAA/+wAAP/s/mD/9QWwABUAAP/rAAAAvQDAAJ0AnQC6AJcAlwAnAMAAnQCGALwAqwC6AJoA0wCzAJkB4ACWALoAmgCpAQsAggCuAKAAjACVALkAqQAXAJMAmgB7AIsAoQDeAKAAjACdALYAJwDAAJ0ApACGAKIAqwC2AL8AugCCAI4AmgCiALIA0wCRAJkArQCzAL4ByQH9AJYAugBHAJgAnQCpAQsAggCZAJ8AqQCwAIEAhQCLAJQAqQC1ALoAFwBQAGMAeAB9AIMAiwCQAJgAogCuANQA3gEmAHsAiQCTAJ0ApQC0BI0AEAAAAAAAMgAyADIAMgAyAFoAeQCwASUBpgIaAi4CXgKOArsC2ALyAwMDHgMyA38DmAPXBD4EaQS2BRAFLQWcBfUGAQYNBjMGTgZ0BsUHbQekCAQISAiGCLYI3wkuCVYJagmVCcgJ5goZCjwKiAq7CxQLWQu4C9YMBAwrDG0Mmwy/DOwNBQ0ZDTINVw1nDXsN4w42DnwOzw8cD0sPsw/rEBEQShB9EJEQ7REnEW0RwRIVEkkSoBLQEwcTLRNxE50T2RQFFEsUXRSkFOMVBxVhFawWDRZUFm4XABctF6UX+xgHGCQYvRjOGQEZJhldGbsZzxoPGi4aSBpxGogaxhrSGuMa9BsFG1UbohvAHBkcUhyvHU0drh3lHjkejh7qHxsfLx9hH4ofqR/lIDIgnSEmIUwhmiHpIkoioSLgIyojUCOaI7kj1yPfJAEkHCRMJHcksyTRJP0lESUlJS4lWSV2JZAloyXeJeYl/SYsJoQmqybSJu8nIyd2J7MoEih8KN4pDCl2KdwqLSpnKsIq6Cs7K6sr5CwyLHwszyz/LTctiC3ILi8uji7kL1Uvni/uMEowkjDRMPUxODGKMdYyPTJgMpgy1TMmM08zhTOqM9s0GDRXNIw03DU+NX016zZPNmY2qzb6N143gTezN+s4GjhCOGg4hDkYOUA5dDmZOco6CDpHOnw6yjsoO2g7wzwRPGw8tTz1PRo9bz3FPgQ+XT63PvI/Kz99P8xAL0CPQQVBe0H4QnNC2UMrQ2FDmUP+RF1FAUWkRgxGdUa4RvlHKUdHR3JHh0edSDVIhkiiSL5I+kk9SaJJxEnmSiFKXEpvSoJKjkqhSt9LHEtXS5FLpEu3S+hMGUxYTKBNCU1wTYNNlk3ITftODk4hTmVOp07dTz1Pm0/kUCtQPlBRUIhQwVDUUOdQ+lENUVxRp1HyUgFSEFIcUihSWlKwUyVTmlQOVHpU5VVBVaBV7FY7VodW0VcSV1NXu1fHV9NYNFhcWFxYXFhcWFxYXFhcWFxYXFhcWFxYXFhcWFxYZFhsWH1YjlioWMJY3Vj3WRFZHVkpWVVZdFmeWbpZxlnWWfBapFrIWuha/1sIWxFbGlsjWyxbNVs+W11bbluIW7Jb3VwSXBtcJFwtXDZcP1xIXFFcWlxjXGxcdVx+XIdcrlzVXSddXl22XcJeGl5gXrJe/F9MX4tfx2ACYIBgymErYWRhrGHCYdNh6WH/YmRifmKxYsJi7WN7Y7VkFGRBZHNkpWTZZOZlAmUcZShlX2WbZfdmWma1Z1xnXGhSaJhozWjxaS5pgGnxagtqW2qfasdrKWtja3trwWvtbB5sSWyLbK9s22z3bVNtk23obhpuYG6AbrBuy277byNvNW9cb6RvzXA/cIxwyXDkcRRxZHGHca1x0HIGclJykXLwczdzg3PZdB10WXSIdMN1CnVbdb916nYcdlR2jna/dvF3H3dcd5R3oHfQeB14eHjAeOh5Q3mAeb5593peemp6onrbexp7S3uhe+p8NHySfOp9O32efdp+Ln5WfpN+3n73f11/qH+5f/KAIYDAgRqBcIGjgdWCBYI4gnOCtYMUg0SDX4OKg8aD64QShFCElYS+hOmFNoU/hUiFUYVahWOFbIV1hbyGDIZJhpWG8IcNh0yHjIezh/yIF4hniHiI6IlEiWeJb4l3iX+Jh4mPiZeJn4mnia+Jt4m/iceJz4nhiemKSYqOiquK/otEi5eL/4xFjJmM7Y02jZ2N6o3yjl6OiI7VjwiPXY+Mj8uPy4/TkByQZZClkMqRBpEZkSyRP5FSkWaRepGQkaORtpHJkdyR8JIDkhaSKZI9klCSY5J2komSnJKwksOS1pLpkv2TEJMjkzaTSJNak26TgpOYk6uTvpPRk+OT95QJlBuULpRClFSUZ5R6lIyUnpSylMWU2JTqlP6VEZUklTeVSZVclW+VxZZNlmCWc5aGlpiWq5a+ltGW45b2lwmXHJcul0GXVJdnl3qXz5g9mFCYYph1mIeYmpismL+Y0pjmmPmZDJkfmTKZRZlYmWuZfpmRmaOZtZnImdSZ4JnzmgaaGpoumkGaVJpomnyaj5qimq6auprNmuCa9JsImxubLZtAm1ObZZt4m4ubn5uzm8ab2ZvtnAGcFJwmnDmcTJxfnHGchJyXnKucv5zSnOSc+J0MnR+dMp1FnVmdbJ1+nZGdo522ncmd3Z3xngWeGZ5pnsSe157qnv2fD58jnzafSZ9cn2+fgp+Un6efup/Nn+Cf7J/4oAOgFqApoDugTaBhoHWggaCNoKCgs6DFoNig6qD8oQ+hI6E2oUmhXKFvoYKhlqGpobyhzqHiofWiB6IaomuifqKQoqOitqLIotqi7KL/o1GjY6N1o4ijm6Ovo8Kj1aPoo/ukBqQYpCukN6RJpF2kaaR1pIiklKSnpLqkzaThpPSlAKUSpSWlN6VDpVWlaaV7pYelmaWrpb6l0qXmpjWmSKZapm2mgKaTpqWmuKbMptim7KcApxOnJ6c8p0SnTKdUp1ynZKdsp3SnfKeEp4ynlKecp6SnrKfAp9Sn56f6qA2oH6gzqDuoQ6hLqFOoW6hvqIKolaioqLuoz6jiqT+pR6lbqWOpa6l+qZGpmamhqampsanEqcyp1KncqeSp7Kn0qfyqBKoMqhSqJ6ovqjeqeqqCqoqqnqqxqrmqwarVqt2q8KsCqxWrKKs7q06rYqt2q4mrnKukq6yruKvLq9Or5qv5rA6sI6w2rEmsXKxvrHesf6yTrKess6y/rNKs5az4rQutE60brSOtNq1JrVGtZK13rYutn62nra+twq3Vremt8a4FrhmuLa5BrlSuZ655ro2uoa61rsmu0a7Zru2vAa8VryivO69Nr2GvdK+Ir5yvsK/Dr9ev66/zsAewG7AusEGwVbBosHywj7CjsLawyrDdsPqxFrEqsT6xUrFmsXqxjrGisbax07HwsgSyGLIrsj6yUbJjsneyirKesrGyxbLYsuyy/7McszizS7Nes3KzhrOas66zwbPUs+iz+7QPtCK0NrRJtF20cLSNtKm0vLTPtOK09bUItRu1LrVAtVS1aLV8tZC1o7W2tcm13LXvtgK2FbYotju2TbZhtnW2ibadtrC2w7bWtui3BbcYtyu3PrdRt2S3d7eKt523pbfiuB64QLhiuKK447kRuUW5fLmxubm5zbnVud255bntufW5/boFug26Fboouju6TrphunW6ibqdurG6xbrZuu27AbsVuym7PbtRu127cbuFu5m7rbvBu9W76bv9vBC8I7w3vEu8X7xzvIe8m7yvvMO817zqvP29Eb0lvTm9Tb1hvXW9ib2cva69wr3Wveq9/r4Svia+Or5GvlK+Xr5qvna+gr6Ovpa+nr6mvq6+tr6+vsa+zr7Wvt6+5r7uvva+/r8SvyW/OL9Lv1O/W79vv3e/ir+cv6S/rL+0v7y/z7/Xv9+/57/vv/e//8AHwA/Af8CwwPzBBMEQwSPBNcE9wUnBXMFvwXvBjsGhwbXBwcHUwefB+sINwhnCJcI5AAAABgBkAAADKAWwAAMABwALAA8AEwAXAABBFSE1MxEjESERIxETFSE1AQEjAREBMwEDCf12GzYCxDYX/XYCiv2vOgJR/a86AlEFsDY2+lAFsPpQBbD6hjY2BVz6jAV0+owFdPqMAAIAof/0AXwFsAADAA8AE0AJAgIHDQtyAAJyACsr3c4vMDFBAyMDAzQ2MzIWFRQGIyImAWkNpw4GNzY1OTk1NjcFsPvrBBX6rS0+Pi0rPj4AAgCJBBMCJAYAAAUACwAMswkDCwUALzPNMjAxQRUDIxE1IRUDIxE1ARYebwGbHm8GAIj+mwFckYj+mwFjigAEAHcAAATTBbAAAwAHAAsADwAjQBEEAAUNDg4ACgkJAAICcgAScgArKxE5LzMROS8zMhEzMDFhATMBIQEzAQEhNSEDITUhARcBG5D+5AEIARyP/uQBlvvwBBBL++8EEQWw+lAFsPpQA4WL/YqKAAMAbv8wBBIGnAADAAcAPQA2QBwEBzo6CCsQIwQULzU1Bi8NcgECHx8UGhoDFAVyACvNMy8RMxI5OSvNMy8REhc5MxI5OTAxQREjERMRIxEBNCYmJy4CNTQ2NjMyHgIVIzQuAiMiBgYVFBYWFx4CFRQGBiMiLgI1MxQeAjMyNjYCopaElQFdNnxofrdjasKDZqBvO7ggQFw8VG00NH1ugbRedNKNVaaGULoxUmMxWn1CBpz+zwEx+Z/+9QELATw8YFAiJ3CmdnuyYD14rnJDcFMtOmlFQGBNJSlvoXeBsVwuaa1+VW9BGzlqAAUAaf/rBYMFxQARACMANQBHAEsAI0ARSTJLBTtEKTIXDiAFBXIyDXIAKysyxDIQxDIzETMRMzAxUzU0NjYzMhYWFRUUBgYjIiYmNxUUFhYzMjY2NTU0JiYjIgYGATU0NjYzMhYWFRUUBgYjIiYmNxUUFhYzMjY2NTU0JiYjIgYGEwEnAWlIhlxehUhHhV1dh0iLI0g2NkYiI0c2NUcjAjpIhlxehUhHhV1dhkmLI0g2NkciI0c3NUcjzf05aALHBEtNU4hSUohTTVGIUlKInk0uUjMzUi5NL1MzM1P8UE5SiFJSiFJOUohSUoigTi5TMzNSL04vUjMzUgNN+45CBHIAAAEAZv/sBPMFxABCACRAFCMSAA8iAQYaMDArERE7E3IHGgNyACsyKzIvMjIvERc5MDFBNzY2NTQmIyIGBhUUFhYXASMBLgI1NDY2MzIWFhUUBgYHBQ4CFRQWFjMyPgI1MxQGBgcGBgcGBiMiJiY1NDY2AZraP0VcVDpQKCxOMgKx3v3LS3ZDW6Rua5tUMlk7/t9IQhM+f2BUn35LpiZPPQkKCUvbbpHTck+LAyibK1dMO2E2WTUtYGg6/MYCpFiTikpynVJVi1NGb1ws1zVgShZHdkdNj8d5Y7CXPgkYCVFRarp4XIx6AAABAGgEIgD+BgAABQAIsQMFAC/GMDFTFQMjEzX+FYEBBgBu/pABX38AAQCG/ioClgZrABcACLEGEwAvLzAxUzU0EhI2NxcOAgIVFRQSFhYXByYmAgKGYpioRyc7eWU+PmV5OydHqJhiAkYK2gFhAQqvJ3otnub+0L4Ovv7P6KMwcCevAQkBYgAAAQAn/ioCNwZrABcACLETBgAvLzAxQRUUAgIGByc+AhI1NTQCJiYnNxYWEhICN2KYqEcnO3hmPkJpdzUnR6iYYgJQCtv+nv73rydwLaHrATO+Dr4BM+qhLHEnr/72/p8AAQAcAmIDVgWxAA4AFEAKDQEHBAQODAYCcgArxDIXOTAxUxMlNwUDMwMlFwUTBwMDgcn+0i8BLgmYCgEqLv7NxXy5tQLEARRalm8BWP6ib5lb/vFdASD+5wAAAgBOAJIENAS2AAMABwAQtQcHAwMGAgAvxjMQxi8wMUEVITUBESMRBDT8GgJQuQMNrq4BqfvcBCQAAAEAHf7dATUA3AAKAAixBAAAL80wMWUVFAYHJz4CNTUBNVxTaSAsF9yVW8tESSxbYTaYAAABACYCHwIOArcAAwAIsQMCAC8zMDFBFSE1Ag7+GAK3mJgAAQCQ//QBdgDSAAsACrMDCQtyACsyMDF3NDYzMhYVFAYjIiaQOzg4Ozs4ODtiL0FBLy5AQAAAAQAT/4MDEQWwAAMACbIAAgEALz8wMUEBIwEDEf2hnwJgBbD50wYtAAIAc//sBAsFxAAXAC8AE0AJKwYfEgVyBg1yACsrMhEzMDFBFRQOAiMiLgM1NTQ+AjMyHgMDETQuAyMiDgIVERQeAzMyPgIEC0B4qWpUjnFQKkF4qWlVj3BPKroXLENXNkJmRSQXLkJXNURmRSIDTN6z9pZDKl2W1o/es/KTQClZk9T+dQEbYpVqQh8xaqx7/uVilm1GITRvrwABAKsAAALZBbgABgAMtQYEcgEMcgArKzAxQREjEQU1JQLZuf6LAhEFuPpIBNGIp8gAAAEAXgAABDMFxAAfABlADBAQDBUFcgMfHwIMcgArMhEzKzIyLzAxZRUhNQE+AjU0JiYjIgYGFSM0NjYzMhYWFRQOAgcBBDP8RwHdWGEnO3JRYYFAuWzUm4rEaStLYzj+epiYhQITYoltOUh1RkuGV3vMeWGvdUCDgn49/lkAAAIAX//sA/oFxAAcADsAKkAWGxweHwQAAB0dEjMvLykNcg0NCRIFcgArMjIvKzIvMhE5LzMSFzkwMUEzMjY2NTQmJiMiBgYVIzQ2NjMyFhYVFA4CIyMVNTMyHgIVFA4CIyIuAjUzFBYWMzI2NjU0JiYjAYeEYX8/OHBWTndDuXDLhoTGbjNrqneenou2aStFfahjX6eASLlDfVVVe0NMi14DM0FxR1RyOj1wTG+2bF23iDd9bEUob0Jug0Fmnm44NmeXYUxyPzt4W1t1OQAAAgA1AAAEUQWwAAcACwAdQA4DBwcGAgIFCQxyCwUEcgArMisSOS85MxI5MDFBFSE1ATMDAQERIxEEUfvkAoyXov5RAn+5AeqYbQPx/tz9XgPG+lAFsAABAJr/7AQuBbAAKQAdQA4nCQkCHRkZEw1yBQIEcgArMisyLzIROS8zMDFBJxMhFSEDNjYzMh4CFRQOAiMiLgInMx4CMzI+AjU0LgIjIgYBY5RJAuv9siwoe1BloHE8OXKtdVide00KsAxIdU5CZkYlJktsRl1fArUmAtWr/nQXKEWAtG9psINIMWWXZlJwOS5WekxFdlgxMgAAAQCF/+wEHQWyADYAG0ANDiwYIiIsAwAEciwNcgArKzIROS8zETMwMUEzFSMiDgIVFRQeAjMyPgI1NC4CIyIGBgcnPgMzMh4CFRQOAiMiLgI1NTQSNiQDPxAQk8Z0My5QZTdAZEUkIEJjRE2FVQZiDk1zj1BtnmYxOnOob3awdDo+mQEQBbKdX5/GZtZhlWY0MVl6SUF5XzdLeUcBcJ9lL1KJq1pntIhMYaLGZleaASjwjgAAAQBOAAAEJgWwAAYAE0AJAQUFBgRyAwxyACsrMhEzMDFBFQEjASE1BCb9pcMCWvzsBbBo+rgFGJgAAAQAcf/sBA8FxAAQACAAMABAACFAEA09PSUtFRUENS0Fch0EDXIAKzIrMhI5LxI5MxI5MDFBFAYGIyImJjU0PgIzMhYWBzQmJiMiBgYVFBYWMzI2NhMUBgYjIiYmNTQ2NjMyFhYHNCYmIyIGBhUUFhYzMjY2BA970YOD0npDe6lmhtJ5ukZ+U1V7REN9VlZ8Q5hwwnt9w25vwnx9wm+5Pm5JSW09PW5JSW0+AYqFuWBguYVXkWw7Z7RwUX1GRn1RVHc/P3cC+2qqYmKqan+yXl6ygklwQT1wTUtwPj5wAAEAZP/+A/gFxAA4ABtADQA4FiEhOAwrBXI4DHIAKysyETkvMxEzMDFlMzI+AjU1NC4CIyIOAhUUHgIzMj4CNzMUDgIjIi4CNTQ+AjMyHgIVFRQOAyMjATEToMhsKC1PZDhAZUUkIEJjQz5tVTMEWEF0nFxsnmUxOnKpb32wbzQdUZr3tRObWpi/Zd9jmmg2M1x8SUF6YjkxVWw7U6GET1SMrVlototOZKjSb0Nx6dSnYf//AIX/9AFsBEUEJgAS9QAABwAS//YDc///ACn+3QFUBEUEJwAS/94DcwAGABAMAAACAEgAxAN6BEoABAAJABZADAEDBwYABAgFCAIJAgAvLxIXOTAxUwEVATUlAQc1AccCs/zOAzL9ToADMgKg/ujEAXtz1P7kDnQBegAAAgCYAY8D2gPPAAMABwAOtQYHEgMCEAA/Mz8zMDFBFSE1ARUhNQPa/L4DQvy+A8+hof5hoaEAAgCHAMUD3QRMAAQACQAVQAsFCAQABgMBBwIJAgAvLxIXOTAxQQE1ARUFATcVAQNO/TkDVvyqAsmN/KoCeAEVv/6GddkBGxV0/oUAAAIAS//0A3cFxAAgACwAG0ANAQEkJCoLchERDRYDcgArMjIvKzIRMy8wMUEjPgI3PgI1NCYmIyIGBgcjPgIzMhYWFRQGBgcGBgM0NjMyFhUUBiMiJgIfugEhTD8uTTAxX0Y6aEABuQJtunN/s15JckA3JsI4NTY4ODY1OAGaYHtmQS9TYURFZDYqV0ZxolZcq3Val4Q8M4D+eS0+Pi0rPj4AAAIAbf47Bs8FlwBBAGgAJ0ASEgUFR1ITcmFkZAtdXR0dPCkwAC8zLzMRMy8zMxEzKzIyETMwMUEOAyMiLgI3EzMDBh4CMzI+Ajc2LgMjIg4DBwYeAzMyNjcXBgYjIi4CAjc2EjY2JDMyHgISBQYeAjMyPgI3Fw4DIyIuAjc+BDMyFhcHJiYjIg4CBsgEMGCZbEVnQRkIM5MzBhMoMxg8XkEkBAcpYZzYi37VqXlFBgcuZ57QgFi1PSZG0V2Y+8GAPAcHVZTNAQGXmvq9fDn79gcOKEEsHUA+NhJCF0laZTRJbkQbCQk4U2l2Pmx8OFUdXkA3YE00AfdcuZpdMVyCUAIq/dZJXDESP2+TVJX6woZGTZDK/ZKW+8WJRyokci0sU5/jASKspAEi7KtcVJ7k/uD/Rm5MJx0+ZEZIUnxUKz90oWNpsoxiMz8rYxwwOHClAAMAHQAABR4FsAAEAAkADQApQBQEBwcKDQ0GAAsMDAIIAwJyBQIIcgArMisyETkvMzk5MxEzMhEzMDFBASMBMwEBJzMBAxUhNQLE/h7FAit/AZH+HQN/Ai3f/M4FL/rRBbD6UAUvgfpQAhuengAAAgCpAAAEiAWwABkAMAApQBQZKSYCJycBJiYODA8CchwbGw4IcgArMhEzKzIROS8zMxEzEjk5MDFBISchMjY2NTQmJiMhESMRITIeAhUUBgYHAyE3ITI2NjU0JiYjITchFx4CFRQGBgKw/o8CAU9TfEU9fWD+5MEB3XCwe0Bco21O/kxtAUdcgUQ6fGL+7QIBeClpkk132AKpmzhpSVBlL/ruBbAtX5JmWpFcDf0onUB1UFF2QJs4CWWcXoi7YQAAAQB4/+wE2AXEACcAFUAKGRUQA3IkAAUJcgArzDMrzDMwMUEzDgIjIi4CNTU0PgIzMhYWFyMuAiMiDgIVFRQeAjMyNjYEGMAPgOqvgNGWUVGZ2Iel5H8PwA5MjHFhk2MyLVyOYXuSSwHPitp/YLH5mZGZ+bJgfNuQZpNQSoi+dJNrvI5RTpIAAAIAqQAABMcFsAAaAB4AG0ANAgEBHQ4PDx4Cch0IcgArKzIRMxEzETMwMWEhNyEyNjY1NTQuAiMhNSEyHgIVFRQOAgERIxECM/7QAgEunNBpPHSnbP64AUiP7KtcXK3z/p/BnYPtn1l9w4dGnl+z/Z5Xnv2yXwWw+lAFsAAEAKkAAARGBbAAAwAHAAsADwAdQA4LCgoGDw4HAnIDAgYIcgArMjIrMjIROS8zMDFlFSE1ExEjEQEVITUBFSE1BEb8/SfBAzf9YwL5/QednZ0FE/pQBbD9jp2dAnKengADAKkAAAQvBbAAAwAHAAsAG0ANBwYGAgoLCwMCcgIIcgArKzIRMxE5LzMwMUERIxEBFSE1ARUhNQFqwQMj/XQC7/0RBbD6UAWw/XGengKPnp4AAQB6/+wE3QXEACsAG0ANKyoqBRkVEANyJAUJcgArMivMMxI5LzMwMUERDgIjIiYmAjU1NBI2NjMyFhYXIy4CIyIOAhUVFB4CMzI2NjcRITUE3Rt2z6OF36NZTZbajafhfxLBDU2OcGWUYC87bpldZ4BIE/6vAtX96yhjSV2zAQGjcaMBALNdc8qBT4JPSorEe3N+xotIIzEWAUacAAADAKkAAAUIBbAAAwAHAAsAG0ANCQYIAwICBgcCcgYIcgArKxE5LzMyETMwMUEVITUTESMRIREjEQRg/OwewQRfwAM+nZ0CcvpQBbD6UAWwAAEAtwAAAXgFsAADAAy1AAJyAQhyACsrMDFBESMRAXjBBbD6UAWwAAABADX/7APMBbAAEwATQAkQDAwHCXICAnIAKysyLzIwMUERMxEUBgYjIiYmNTMUFhYzMjY2AwzAds+GhtB2wUR5Tkx5RgGpBAf7+ZDGZ1y8j1x2OEGBAAMAqQAABQUFsAADAAkADQAcQBAGBwsFDAgGAgQDAnIKAghyACsyKzISFzkwMUERIxEhAQEnAQETATcBAWrBBDD9o/6sIAEAAeku/eVzAo4FsPpQBbD9Wf6fzgEaAiD6UALGmfyhAAIAqQAABBwFsAADAAcAFUAKAwICBgcCcgYIcgArKxEzETMwMWUVITUTESMRBBz9KCbBnZ2dBRP6UAWwAAMAqQAABlIFsAAGAAsAEAAbQA0CBw4FCwhyDAQABwJyACsyMjIrMjIROTAxUzMBATMBIwEzExEjATMRIxHmuwHdAdy8/bCS/XWlG8AFBKXABbD7XQSj+lAFsPyI/cgFsPpQAjgAAAEAqQAABQkFsAAJABdACwMIBQkHAnICBQhyACsyKzISOTkwMUERIwERIxEzAREFCcL9I8HBAuAFsPpQBGP7nQWw+5oEZgACAHf/7AUKBcQAFQArABNACScGHBEDcgYJcgArKzIRMzAxQRUUAgYGIyImJgI1NTQSNjYzMhYWEgM1NC4CIyIOAhUVFB4CMzI+AgUKUprXhYHXnVZVnNeBhdebU781ZpNdWpFnODhpkVpekmU0AwZcpP78tmBgtgEEpFykAQO3YGC3/v3/AF6CyIhGRojIgl6DyYlGRonJAAEAqQAABMEFsAAXABdACwIBAQ4MDwJyDghyACsrMhE5LzMwMUEhNSEyNjY1NCYmIyERIxEhMhYWFRQGBgLC/nsBhXGMQUGMcf6owQIZpeR2duQCO51IgFJLhFH67gWwcsmBjMZnAAMAbv8KBQYFxAADABkALwAZQAwgFQNyACsrAwoJcgIALysyMhEzKzIwMWUBBwEBFRQCBgYjIiYmAjU1NBI2NjMyFhYSAzU0LgIjIg4CFRUUHgIzMj4CA5QBcoL+lAHpUprXhYHXnVZVnNeBhdiaU781ZpJeWZFoODhpkllekmU0p/7beAEhAttcpP78tmBgtgEEpFykAQO3YGC3/v3/AF6CyIhGRojIgl6DyYlGRonJAAACAKkAAATKBbAAGAAdACNAEhsaCQMMDAsLABwZGAhyFgACcgArMisyMhI5LzMSFzkwMVMhMhYWFRQGBgcHISchMjY2NTQmJiMhESMhATcBFakB4qTjd1GXaTb+OwIBVmiKRkKNb/7fwQNT/p7JAWcFsGTDjmSlcxwVnUl8S1R+RfruApQB/XcMAAABAFH/7ARzBcQAOQAfQA8KJg82MTErCXIYFBQPA3IAKzIvMisyLzIROTkwMUE0LgInLgM1ND4CMzIWFhUjNCYmIyIGBhUUHgIXHgMVFA4CIyIuAjUzFB4CMzI2NgOxH02HZ2yufEJGg7ZwpOV4wEaObWeGQSdTgVp8tHU5SIa7c2XDn1/AOmWBRmWMSQFwM09AOh4gT2aEVVWQazx9yXJSf0k+akQuS0A2GSNWa4dVWZBmNzhwpW1La0YhOGgAAgAyAAAElwWwAAMABwAVQAoAAwMGBwJyAQhyACsrMjIRMzAxQREjESEVITUCw74CkvubBbD6UAWwnp4AAQCM/+wEqgWwABUAE0AJAREGCwJyBglyACsrETMyMDFBMxEUBgYjIiYmNREzERQWFjMyNjY1A+rAkvGNlO+Lv1SXZGWXVAWw/Cek2m1t2qQD2fwncpRISJRyAAACAB0AAAT9BbAABAAJABdACwAGCAEJAnIDCAhyACsyKzISOTkwMWUBMwEjAQEXIwECfwGt0f3llf6hAak1lf3m3QTT+lAFsPst3QWwAAAEAD0AAAbtBbAABQAKAA8AFQAbQA0QDAEKAnITEg4ECQhyACsyMjIyKzIyMjAxQQEzAwEjAxMTIwEBEzMBIwEBEyMBAwIoASGMUf7Ji8XmRYr+nwUO4cH+oIr+5wEZZov+1FIBuAP4/nX72wWw/Bz+NAWw/B0D4/pQBbD8CP5IBCUBiwABADoAAATOBbAACwAaQA4HBAoBBAkDCwJyBgkIcgArMisyEhc5MDFBAQEzAQEjAQEjAQEBJgFeAV7h/jQB1+P+mf6Z4wHX/jQFsP3SAi79L/0hAjn9xwLfAtEAAAEADwAABLwFsAAIABdADAQHAQMGAwgCcgYIcgArKzISFzkwMVMBATMBESMRAewBegF72/4Kwf4KBbD9JQLb/HD94AIgA5AAAAMAVwAABHoFsAADAAkADQAfQA8EDAwJDQJyBwMDAgIGCHIAKzIRMxEzKzIyETMwMWUVITUBASM1ATMjFSE1BHr8JgO6/HR3A4t4UvxcnZ2dBIf63JAFIJ6eAAEAk/7IAgsGgAAHAA60AwYCBwYALy8zETMwMUEVIxEzFSERAgu/v/6IBoCY+XiYB7gAAQAp/4MDOQWwAAMACbIBAgAALz8wMUUBMwECif2gsAJgfQYt+dMAAAEACv7IAYQGgAAHAA60BQQAAQQALy8zETMwMVM1IREhNTMRCgF6/obABeiY+EiYBogAAgBAAtkDFQWwAAQACQAWQAkIBwcGAAUCAwIAP80yOTkzETMwMUEDIwEzEwMnMwEBt8usAStwjsolcQEqBNr9/wLX/SkCAdb9KQABAAT/aAOZAAAAAwAIsQIDAC8zMDFhFSE1A5n8a5iYAAEAOQTaAdoGAAADAAqyA4ACAC8azTAxQRMjAQEZwZ/+/gYA/toBJgACAG3/7APqBE4AGwA6AClAFSssHiceOjoPJzELchgZCnIJBQ8HcgArMjIrMisyEjkvMxESOTkwMWURNCYmIyIGBhUjND4CMzIWFhURFBYXFSMmJhMXIyIOAhUUFhYzMjY2NxcOAyMiJiY1ND4CMwMLM2ZLRmk7uTxxn2J2tWcTE8EOECACu098VCwuXURVgk0DTwc+Z41YbqVbRIC0b7kCLUBfNDBOLTpyXTdQoXn+CDZ6LBAgawIFghkySzIzVDFIaDFZKmZdPVaRWleFWS4AAwCM/+wEIQYAAAQAGgAvABlADiEWB3IrCwtyBApyAAByACsrKzIrMjAxUzMRByMBFRQOAiMiLgInNT4DMzIeAgc1NC4CIyIOAgcVHgIzMj4CjLoQqgOVOGycZWebaj8MDD9qmmZmnms4uh5CbE9GZ0gtCxBJe1tLa0MgBgD60tICJhV2yZRSR4a+d1x4vodHT5LLkRVRj20/MFFnN/FGgVI9bI4AAAEAXf/sA+0ETgAnABlADB0ZGRQHcgQEAAkLcgArMjIvKzIvMjAxZTI2NjczDgIjIi4CNTU0PgIzMhYWFyMuAiMiDgIVFRQeAgI+QnBIBbAFd8BzerV3Ozt3tXp/vm0FsAVBb0pVc0MdHENzhDZfPWClZVaWw20qbcOWVmexcENsQUNxiUcqR4pwQwAAAwBf/+wD8QYAAAQAGgAvABlADSEEBBYLcisLB3IBAHIAKysyKzIvMjAxZREzESMBNTQ+AjMyHgIXFQ4DIyIuAjcVFB4CMzI2Njc1LgMjIg4CAze6qv0YPXGdYWaZaz4MCz9rmmdfnXE9uiFGbEtcd0gUDC1HZ0ZMbUYh0gUu+gACERV8y5JPR4e+eFx3voZHUpTJixVRjmw9ToBL8TdnUTA/bY8AAAEAXf/sA/METgArAB9AEGcTAQYTEhIAGQsHciQAC3IAKzIrMhE5LzNfXTAxRSIuAjU1ND4CMzIeAhUVITUhNS4CIyIOAhUVFB4CMzI2NxcOAgJOcbeDRk6Gqlt0qWw0/NgCbwQzbl8/akwqK1N3TGKIM3AjbJ0UTYzAciqEz5BKUI/BclOXDkiIWDVolmIqTYdmOlBDWTVgPAACAD0AAALLBhUAEQAVABVACxQVBnINBgFyAQpyACsrMisyMDFhIxE0NjYzMhYXByYmIyIGBhUXFSE1AaG5VaBuIEEfChU1GjtVLOb9tgSsdaFTCAiXBQQvWkJyjo4AAwBh/lUD8gROABMAKQA+ABtADzAlC3I6GgdyDgYPcgAGcgArKzIrMisyMDFBMxEUBgYjIiYmJzcWFjMyNjY1EQE1ND4CMzIeAhcVDgMjIi4CNxUUHgIzMjY2NzUuAyMiDgIDSqh0z4c4l5ExYUSVSViAR/0oO2+eY2aZaz4MCz9rmmdhnXA7uSFFbEtceEcUCy1HaEZMbUUhBDr73Y/KaSNTRm5SQEKBXgM+/sUVfMuST0eHvnhcd76GR1KUyYsVUY5sPU6AS/E3Z1EwP22PAAIAjQAAA+AGAAADABoAF0AMEQIWCgdyAwByAgpyACsrKzIRMzAxQREjERMnPgMzMh4CFREjETQmJiMiDgIBRrmNTQFAdKFiUIBbMLoyYEZFcVEtBgD6AAYA/EYDb72MTStelWv9OwLHVWcvOmaDAAACAI4AAAFpBcQAAwAPABC3Bw0DBnICCnIAKyvOMjAxQREjEQM0NjMyFhUUBiMiJgFWug43NjU5OTU2NwQ6+8YEOgEfLT4+LSs9PQAAAv++/ksBWgXEABEAHQATQAkNBg9yFRsABnIAK84yKzIwMVMzERQGBiMiJic3FhYzMjY2NQM0NjMyFhUUBiMiJpK6P31fGUMXARMwEik4HRM4NTY4ODY1OAQ6+0VjikcKB5UEBR5CNwXaLT4+LSs9PQAAAwCNAAAEDQYAAAMACQANAB1AEQYHCwUMCAYCCQYDAHIKAgpyACsyKz8SFzkwMUERIxEJAic3ARMBNwEBR7oDT/4o/vgPvQFQOf5+YAH8BgD6AAYA/jr+B/7uxeIBZPvGAgSl/VcAAQCcAAABVgYAAAMADLUDAHICCnIAKyswMUERIxEBVroGAPoABgAAAAMAiwAABnkETgAEABsAMgAhQBEpEgIuIiIXCwMGcgsHcgIKcgArKysRMzMRMxEzMzAxQREjETMDJz4DMzIeAhURIxE0JiYjIg4CJQc+AzMyHgIVESMRNCYmIyIOAgFFurAcVgE4bqRsTIBeNLk5aEZSbkIdAr18ATltoGdXh10wujlnRz1eQCEDY/ydBDr+DANvvYxNK1yQZv0vAshVZi86ZoMdJlmkgEsuX5Rm/TkCyVtlKSpJXgACAI0AAAPgBE4ABAAbABlADRICFwsDBnILB3ICCnIAKysrETMRMzAxQREjETMDJz4DMzIeAhURIxE0JiYjIg4CAUa5ryJNAUB0oWJQgFswujJgRkVxUS0DU/ytBDr+DANvvYxNK16Va/07AsdVZy86ZoMAAAIAXP/sBDUETgAVACsAELccEQtyJwYHcgArMisyMDFTNTQ+AjMyHgIVFRQOAiMiLgI3FRQeAjMyPgI1NTQuAiMiDgJcRIC2cXK3gUREgbVycraBRLkmTXRNTHNMJydNc01Mc00mAhEXdcmVU1OVyXUXdciVU1OVyIwXUY9uPz9uj1EXUI9vQEBvjwAAAwCM/mAEHwROAAQAGgAvABlADiEWB3IrCwtyAwZyAg5yACsrKzIrMjAxQREjETMBFRQOAiMiLgInNT4DMzIeAgc1NC4CIyIOAgcRHgIzMj4CAUa6qgLpOGucZWeebkEMDEJtnGZmnmw3uiJHbkxGZ0gtCxRIeFtLbUciA2r69gXa/ewVdsmUUkSCtnJweL6HR0+Sy5EVUY9tPzBRZzf+/UZ7Sz9ujwAAAwBf/mAD8AROAAQAGgAvABlADiEWC3IrCwdyBA5yAwZyACsrKzIrMjAxQRE3MxEBNTQ+AjMyHgIXFQ4DIyIuAjcVFB4CMzI2Njc1LgMjIg4CAzYQqvxvOnCfZmabbUAMC0BtnWdkn287uiJHbUtce0oUCy9KaUZMbkci/mAFCtD6JgOxFXzLkk9Hh754XHe+hkdSlMmLFVGPbj9Qg0vxN2hTMUBvkAAAAgCNAAACmAROAAQAFgAZQA0GCQkFFAdyAwZyAgpyACsrKzIyETMwMUERIxEzJQcmJiMiDgIHBzQ+AjMyFgFGubQBVwEXKRpAYkQnBjQnUn9YFDQDkPxwBDoGrAUDKEhjOx5irIVLCQABAF//7AO8BE4ANQAXQAsbAA4yKQtyFw4HcgArMisyETk5MDFBNCYmJy4DNTQ+AjMyFhYVIzQmJiMiBgYVFB4CFx4CFRQOAiMiJiY1Mx4CMzI2NgMDI2trWpFlNjlplFuCuGK5NWVJTV8rFTZiTIWsVDtvmV+Pxma6BFB0OUxnNgEfKEU5FRM0SmRDQHJYMlyZXS1VOC9IKB4vJyIRHlR6V0d2VS9molpMWSUoRgACAAn/7AJXBUEAAwAVABNACQoRC3IEAgMGcgArMi8rMjAxQRUhNRMzERQWFjMyNjcXBgYjIiYmNQJS/bfGuSI2HxczDQEWRzJEckMEOo6OAQf7yzc4EgkDlwcNNn9sAAACAIn/7APdBDoABAAbABVACgERBnIYAwMLC3IAKzIvMisyMDFlETMRIxM3FA4CIyIuAjURMxEUHgIzMjY2AyO6sRpNLWSidE+DXjO5ITlHJnaKPfoDQPvGAd4CbLeGSy5gmmwCuv1ESV83FlubAAIAIQAAA7sEOgAEAAkAF0ALAAYIAQkGcgMICnIAKzIrMhI5OTAxZQEzASMDARcjAQHWASi9/nt82wExFXz+eKcDk/vGBDr8aKIEOgAEACsAAAXTBDoABQAKAA8AFQAkQBQHCwARAxQGCRAMAQoGchIOBAkKcgArMjIyKzIyMhIXOTAxZQEzBwEjAxMXIwEBEzMBIwMBFyMBJwGfARZ6GP7ld6HtEX3+xgQO4rj+xnzTARAfdv7dGMADerH8dwQ6/Hy2BDr8gwN9+8YEOvyVzwOLrwAAAQAqAAADywQ6AAsAGkAOBwQKAQQJAwsGcgYJCnIAKzIrMhIXOTAxQRMTMwEBIwMDIwEBAQrt8Nn+ngFt1vr61wFs/p8EOv52AYr96v3cAZb+agIkAhYAAAIAFv5LA7AEOgATABgAGUANFxYVAwgCGAZyDwgPcgArMisyEhc5MDFlATMBDgMjIiYnJxYWMzI2NjcDARcHAQG9AS3G/k4PMUxrShZEDgEIIwc/WD0WkAEZMIX+cnADyvsfKF1UNQwElgEDIU1DBJz8uMNEBE8AAAMAWQAAA7MEOgADAAkADQAcQA0EDAwJDQZyBwMDBgISAD8zMxEzKzIyETMwMWUVITUBASM1ATMjFSE1A7P87QL2/TRxAsd2Uv0dmJiYAx/8SYgDspmZAAACAED+kgKfBj0AEQAlABlACh0JCgocHBITAQAALzIvMzkvMxI5OTAxQRcGBhUVFAYGIzUyNjU1NDY2EwcuAjU1NCYmIzUyFhYVFRQWFgJ4J3daUa+OcWNBm68niJtBLF1Ljq9RJ1sGPXIlv3vPZKNgeoBtz2m3i/jucyeKt2nOSWo7emCjZc5SjGcAAAEAsP7yAUUFsAADAAmyAAIBAC8/MDFBESMRAUWVBbD5Qga+AAIAFP6SAnMGPQATACYAG0ALHgsKCh8fARUUAAEALzMvMxI5LzMSOTkwMVM3HgIVFRQWFjMVIiYmNTU0JiYDJz4CNTU0NjYzFSIGFRUUBgYUJ4mbQCxdS42wUSZbKSdPWydRsI1wZECbBctyJou3ac9IazpxW59kz1KNZ/jgcxlnjFLOZZ5bcIFtzmm3igABAIMBkwTvAyMAHwAbQAsMAAAWBoAcBhAQBgAvMy8RMxoQzTIvMjAxQTcUDgIjIiYnJiYjIgYGFQc0PgIzMhYXFhYzMjY2BFeYL1d3R1eFTjNWMjNIJ6EvVndHWIlJN1MxNE0rAwkBTYhnO0ZELzQxWj8CToZkN0pBMjE2YAACAIv+lwFmBE0AAwAPAAyzAQcNAAAvL93OMDFTEzMTExQGIyImNTQ2MzIWnQ6nDgY3NjU5OTU2N/6XBBX76wVNLD4+LCw9PQADAGn/CwP6BSYAAwAHAC8AJUASAgElJSEDHAdyBwQICAwGEQ1yACvNzDMSOTkrzcwzEjk5MDFBESMRExEjETcyNjY3Mw4CIyIuAjU1ND4CMzIWFhcjLgIjIg4CFRUUHgICnrq6umdCcEgFsAV4v3N6tnc7O3i1en++bQWwBUFvSlVzQx0cQ3MFJv7gASD7BP7hAR9aNl89YKVlVpbDbSptw5ZWZ7FwQ2xBQ3GJRypHinBDAAADAFsAAARoBcQAAwAHACIAIUAQBgUFAR8WBXIMDQ0CAgEMcgArMhEzETMrMhE5LzMwMWEhNSEBITUhARMWBgcnPgI1AzQ2NjMyFhYVIzQmJiMiBgYEaPv3BAn+k/1gAqD+uBYBODiuIykRFnTJf4O4YsBDbD5Caz+dAdKdAQP9g16jKTUJU2wsAn6Kw2hir3RUZi5BfQAGAGn/5QVbBPEAEwAnACsALwAzADcADrUPGQUjDXIAKzIvMzAxQRQeAjMyPgI1NC4CIyIOAgc0PgIzMh4CFRQOAiMiLgIBByc3AQcnNwEnNxcBJzcXAThCdJlYWJl0QUF0mVhYmXRCrF2j2Ht72KRcXKTYe3vYo10Ez8qEyvzfyoPKA6TKhMr72MqDygJgXqZ9R0d9pl5fpH1GRn2kX4Xkql9fquSFheSrYGCr5AKNzonO+8POiM3+qs6IzQMszojOAAUADwAABCQFsAADAAcADAARABUALUAWCxAQBgcSFRUIDgMDAgIRFAxyCREEcgArMisSOS8zEjk5MhEzzjIzETMwMUEVITUBFSE1JQEzASMBAQcjAQERIxEDu/y9A0P8vQFoAW/V/k97/vABcR16/k0CZ8AC4X19/t18fNwDFvysA1T84zcDVP1W/PoDBgACAJT+8gFNBbAAAwAHAA20AQIGBwIAP93ezTAxQSMRMxERIxEBTbm5uf7yAxgDpv0KAvYAAgBb/hEEeQXFAC8AYQAeQBNTPwABBStdNTEwDyEMT0QdFBFyACsyLzMXOTAxZTUyNjY1NC4CJy4DNTQ+AjMyFhYVIzQmJiMiBgYVFB4CFx4DFRQOAgEVIgYGFRQeAhceAxUUDgIjIi4CNTcUHgIzMjY2NTQuAicuAzU0PgICu1N0PiNSimZtq3c+RYC0cJncdrlHiGNphkEfTIlpcK54Pz91pf7tU2w0H06La2+sdj5FgLNvYLqXWbk8Y3c7YIdHIlCIZW2ueEA8cJ5sdjRcOi9HOzcfHkVfhV1Th2A0ZMCLTX9LOmA6Mkg4Mx0fR1+GXUx4UywC/nk0WjoySTo0Hh9GXYRdV4heMSxkpnkCT21AHThgPC9FOTYeHkdgh11Kd1QuAAIAZQTxAu8FxgALABcADrQDCQkPFQAvMzMvMzAxUzQ2MzIWFRQGIyImJTQ2MzIWFRQGIyImZTg1Njg4NjU4Aa83NjU5OTU2NwVbLT4+LSs9PSktPj4tKz09AAMAXP/rBecFxAAfADMARwAfQA4dBAQlJUMUDQ0vLzkDcgArMhEzETMvMxEzETMwMUEzFAYjIiYmNTU0NjYzMhYVIzQmIyIGBhUVFBYWMzI2JRQeAjMyPgI1NC4CIyIOAgc0EjYkMzIEFhIVFAIGBCMiJCYCA86Ss5lqm1VVm2qZtJJfXEJaLi5aQlxe/QFcpNh7e9ejXFyj13t72KRcc27EAQGTkwEBw25uw/7/k5P+/8RuAladnWKuc3NzrmKcnWNWQnVLdEx1QlbnheasYGCs5oWG5KtfX6vkhp8BEMtxccv+8J+f/vDNcnLNARAAAAIAkwK0AxAFxQAXADEAGrUxGhoNFiq4AQCyCA0DAD8zGtzEEjkvMzAxQRE0JiYjIgYVJzQ2NjMyFhYVERQWFyMmExcjIgYGFRQWMzI2NjUXDgIjIiY1NDY2MwJTGzcqRU+hTYtdVoFIDA6lGCgBlTxPJj1AK1c6Eg8/Y0R4gUuXcQNeAVQrPB81NA1EaTw+elz+xjFYLEsBcG8gNCArMic4GXAgRC17Z0pnNv//AGUAlgNlA7IEJgGT+f0ABwGTAUT//QACAH8BeAO+AyEAAwAHABK2BgcDBgICAwAvMxEzEjkvMDFBFSE1BREjEQO+/MEDP7kDIaKiS/6iAV4ABABb/+sF5gXEAB4ALwBDAFcANUAbHxsYIAQCAgEBDykNDTU1UwwPD0lTE3I/SQNyACsyKxI5LzMRMxEzLzMSOX0vMxIXOTAxQSMnMz4CNTQmJiMjESMRITIWFhUUBgYHIgYjDgIjNzIWFRUUFhcVIyYmNTU0JiUUHgIzMj4CNTQuAiMiDgIHNBI2JDMyBBYSFRQCBgQjIiQmAgM72gLLKkktIk9EiI0BFWOQTjJgRQMHAxEJCR4Um3EICZEKA0P9TVyk2Ht716NcXKPXe3vYpFxzbsQBAZOTAQHDbm7D/v+Tk/7/xG4Cj4ABHDUnMjoa/S8DUDhxVjZWPhMNCgkCWoNkNiVDFxAaYBY0SUVKheasYGCs5oWG5KtfX6vkhp8BEMtxccv+8J+f/vDNcnLNARAAAQCPBRcDLgWlAAMACLEDAgAvMzAxQRUhNQMu/WEFpY6OAAIAgwPAAn0FxQAPABsAD7UTDMAZBAMAPzMazDIwMVM0NjYzMhYWFRQGBiMiJiY3FBYzMjY1NCYjIgaDRnRFRXJERHJFRXRGfE02NklJNjZNBMFHdkdHdkdHdUVFdUc3Sko3OExMAAMAYQABA/UE8wADAAcACwAStwsCAwMEChJyACsvOS8zMjAxQRUhNQERIxEBFSE1A/X8bAIppwHo/L0DV5iYAZz8LgPS+6WXlwAAAQBCApsCqwW7ABwAE7EcArgBALMLEwNyACsyGswyMDFBFSE1AT4CNTQmIyIGFSM0NjYzMhYWFRQGBgcHAqv9qgEgLTQXQDtLR55Ihl5agEQvVjuvAxuAbAEPKkI1FjA+TDlIdkc6aUk1XFw1kgACAD8CkAKbBbsAGQAzACxADBwYAAAaGhAsKSkkELgBALULCwgQA3IAKzIyLxoQzDIvMhE5LzMSOTkwMUEzMjY2NTQmIyIGFSM0NjYzMhYWFRQGBiMjFTUzMhYWFRQGBiMiJiY1MxQWMzI2NTQmJiMBClQxQCFARTlLnUyCUFeESkF7WG9vZIA+UItXS4lWnVBCRkknRzEEZhwxICw8MitEYzYzZEk1WTUlTjBaQEloNjFoUS09PjEqMxcAAAEAewTaAhwGAAADAAqyAYAAAC8azTAxUxMzAXvC3/70BNoBJv7aAAADAJv+YAPuBDoABAAaAB4AGUAMHQUAFgsTcgMSchwAAC8yKysyETkvMDFBMxEjJzc3FA4CIyImJicDMxQeAjMyPgIBMxEjAzW5pxIhRSlWhl5Md1UcJXQiPVAuWXNAGv1FuLgEOvvG+v0CcsCOTidVRAEhZ4JGGjdkiAKU+iYAAAEARAAAA0EFsAAMAA62AwsCcgAScgArK80wMWEjESMiJiY1NDY2MyEDQbpXn9xxcdyfARECCHnUh4bUegAAAQCUAmwBeQNJAAsACLEDCQAvMzAxUzQ2MzIWFRQGIyImlDo4ODs7ODg6AtkvQUEvLj8/AAEAdP5NAaoAAAATABG2CwqAEwIAEgA/MjIazDIwMXMzBxYWFRQOAiMnMjY2NTQmJieYhQw6XydMcUsHLkstIkc4NQpMVy9NNx5rFCwjISYTBAABAHsCmwHvBbAABgAKswYCcgEALyswMUERIxEHNSUB75zYAWIFsPzrAlk5gXQAAgB7ArMDJwXFABEAIwAQthcOIAUDcg4ALysyETMwMVM1NDY2MzIWFhUVFAYGIyImJjcVFBYWMzI2NjU1NCYmIyIGBntUmWlqmVNTmGlqmlSjJ1E9PE8nKE89PFAnBBNRZ59bW59nUWefWlqfuFE9YDg4YD1RPGA4OGAA//8AZwCZA3kDtQQmAZQNAAAHAZQBagAA//8AVQAABZIFrQQnAeH/2gKYACcBlQEYAAgABwI7AtYAAP//AFAAAAXJBa0EJwGVAOwACAAnAeH/1QKYAAcB4AMeAAD//wBwAAAF7gW7BCcBlQGXAAgAJwI7AzIAAAAHAjoAMQKbAAIARP5+A3kETgAhAC0AGEAKAAAlJSsQERENFgAvMzMvPzMvMy8wMUEzDgIHDgIVFBYWMzI2NjUzDgIjIiYmNTQ2Njc+AhMUBiMiJjU0NjMyFgGTugEhST4qTDA0ZEg7ZkG5AW25dIK3YUlwPCQnD8I4NTY4ODY1OAKoYHdkQy1UZEVJZDMsW0VxpVhaqnhbm4U6I01YAW4sPj4sLD09AAAG//EAAAdYBbAABAAIAAwAEAAUABgAMUAYABcXCAcUEwcTBxMCDQMYAnIMCwsOAghyACsyMhEzKzIyETk5Ly8RMxEzMhEzMDFBASMBMxMVITUBFSE1AxMjAwEVITUBFSE1A8r9CuMDcXeC/RkF5P0jGj26PQMi/YoCx/0kBRv65QWw/GCvr/6ImJgFGPpQBbD9kpiYAm6YmAAAAgBZAM4D3gRkAAMABwAMswQGAgAALy8zMjAxdycBFwMBNwHQdwMLd3T89XcDC857Axt8/OYDGnz85QAAAwB3/6MFHQXsAAMAGwAzABdACwEALwojFgNyCglyACsrMhEzMjMwMUEBIwETFRQCBgYjIi4DNTU0EjY2MzIeAwc1NC4DIyIOAhUVFB4DMzI+AgUd/BaPA+15UprXhWe0kWg3VZzXgWq1kGU2vyJCYHxLWpFnOCRFYXpIXpJlNAXs+bcGSf0aXKT+/LZgPner24NcpAEDt2A+d6vb315oqYJYLUaIyIJeaaqDWC1GickAAAIApwAABF0FsAADABkAHUAODw4OAxkEBAMAAnIDCHIAKysROS8zETkvMzAxUzMRIxMhMhYWFRQGBiMhNSEyNjY1NCYmIyGnubldAXKe2XBw2Z7+wQE/bIU9PYVs/ugFsPpQBItuwHt6wG6XT3xERn5QAAEAjP/sBGoGEgA5ABlADSMbNggCCnIIAXIbC3IAKysrETMRMzAxQREjETQ+AjMyFhYVFA4CFRQeAxUUBgYjIiYmJzcWFjMyNjY1NC4DNTQ+AjU0JiYjIgYGAUS4OWiQWG2pYicyJ0ZoaUZjrnA2eGMaKiOFRk5hLEZoaUYqNioyVjdFYjQEWPuoBFhupW84SJV0UGtRTjM3V1Back1ylkkVIRKbFjYwUDE5V1FadlE8XFFZOUNZLj6BAAMAT//rBn0ETwAUADIAXgA3QBxXMzMyF0ZFFCUAAykXRRdFDx8pC3JMPj4FDwdyACsyMhEzKzISOTkvLxIXOREzETMyETMwMWURNCYmIyIGBhUnND4CMzIWFhURAxUhIgYGFRQWFjMyPgI3Fw4CIyImJjU0PgIzASIuAjU1ND4CFzIeAhUVITUhNTQmJiMiDgIVFRQeAjMyNjcXDgIC7TFgRUpuPLg+cZ1gdrFji/77V3Y8LVtGNnFfOwFgG3W3f3KfUjlxqG4C4Hu8gEJFfahjbKVwOfzcAmoycF5FakkmJlB9V3eSMkEWYZq3AhlIZzc0VjQSRnZYMFaqgP4MAaKMN1k0ME0tKUFIH5AxZENQk2JPe1Ut/W9QkcZ2LHfFkE8BQ3+0cHaOH0x+TTxqjFAsUY1rPEkiiBE7LwACAH7/7AQuBi0ANAA4ABlACzYgFhYBKgwLcjgBAC8zKzISOS8zMzAxUzcWBBYSFRUUDgIjIi4CNTQ+AjMyFhYVJzQuAiMiDgIVFB4CMzI+AjU1NAImJiUBJwH/OakBFsptRX6rZmmvf0VDeaNhcbVqRSRHbEhJck4pJ0ttR0FmSSZjr+MCXf3nSQIZBY2gJqTz/sa9YnvMlFBLhrFmdLuHSGunWwEhSkEoMl2EUz53YTo9bZNWZLABCL57Hf6SZAFtAAMARwCsBC0EugADAA8AGwATtxkTAgcNAwISAD/dxjIQxjIwMUEVITUBNDYzMhYVFAYjIiYRNDYzMhYVFAYjIiYELfwaAYc6ODg7Ozg4Ojo4ODs7ODg6AxC4uAE6MEBAMC4/P/z+L0FBLy5AQAAAAwBc/3kENAS5AAMAGQAvABlADCABARULcisAAAoHcgArMi8yKzIvMjAxQQEjAQE1ND4CMzIeAhUVFA4CIyIuAjcVFB4CMzI+AjU1NC4CIyIOAgPX/Wl7Apf9AESAtnFyt4BERIC1cnK2gUS5Jk10TUxzTCcnTXNNTHNNJgS5+sAFQP1YF3XJlVNTlcl1F3XIlVNTlciMF1GPbj8/bo9RF1CPb0BAb48AAwCV/mAEKAYAAAMAGQAvABtADysKIBUHcgoLcgMAcgIOcgArKysrMhEzMDFBESMRARUUDgIjIi4CJzU+AzMyHgIHNTQuAiMiDgIHER4DMzI+AgFPugOTOGucZWeebkEMDEJtnGZmnmw3uiJHbkxGZ0gtCw8vR2VFS21HIgYA+GAHoPwmFXbJlFJEgrZycHi+h0dPksuRFVGPbT8wUWc3/v01YEssP26PAAAEAF//7AStBgAABAAaAC8AMwAdQA8hBAQWC3IzMisLB3IBAHIAKysyzjIrMi8yMDFlETMRIwE1ND4CMzIeAhcVDgMjIi4CNxUUHgIzMjY2NzUuAyMiDgIBFSE1Aze6qv0YPXGdYWaZaz4MCz9rmmdfnXE9uiFGbEtcd0gUDC1HZ0ZMbUYhA5T9g9IFLvoAAhEVfMuST0eHvnhcd76GR1KUyYsVUY5sPU6AS/E3Z1EwP22PAvKYmAAABAAeAAAFiQWwAAMABwALAA8AH0APAwKABwYGCgwLAnINCghyACsyKzIROS8zGswyMDFBFSE1ARUhNRMRIxEhESMRBYn6lQQ8/OwewARfwQSPj4/+r52dAnL6UAWw+lAFsAABAJwAAAFVBDoAAwAMtQMGcgIKcgArKzAxQREjEQFVuQQ6+8YEOgAAAwCbAAAEQAQ6AAMACQANAB9ADwwHBwsGBgIJAwZyCgIKcgArMisyETkvMzMRMzAxQREjESEBIyczARMBNwEBVLkDgf3p7xy2AYwa/lF3AiIEOvvGBDr9lKIByvvGAeqG/ZAAAAMAIwAABBwFsAADAAcACwAbQA0CCgAHBgYKCwJyCghyACsrETMRMzIRMzAxQRUFNQEVITUTESMRAnD9swP5/ScmwAOgfbt9/bidnQUT+lAFsAACACMAAAILBgAAAwAHABNACQIGAAcAcgYKcgArKzIRMzAxQRUFNQERIxECC/4YAUm5A6J6u3oDGfoABgAAAAMAov5LBPEFsAADAAcAGQAdQA4VDgYHBwMIcgkFBAACcgArMjIyKzIRMy8zMDFTMxEjEzcBBxEzERQGBiMiJic3FhYzMjY2NaLBwTqHA1SHwU+SZh82Hg4RQg8sPSAFsPpQBT5y+sJyBbD5/HKdUgcKmgYHL1c9AAIAkv5LA/EETgAEACoAGUAOHBUPciYLB3IDBnICCnIAKysrMisyMDFBESMRMwMHND4CMzIeAhURFAYGIyImJzcWFjMyNjY1ETQuAiMiDgIBS7mmJio4aplgVIhfM02RZR81Hg4QRg4sPSEfPVc5U3dMJANT/K0EOv4GAnPBjk4wZaBv/P1wnFAHCp0GBipTPQMAS2c9HDpmhgAFAGn/6wcJBcUAIwAnACsALwAzADNAGi8uLiYyKDMCciknJghyFRISFhkJBAcHAwADAD8yMhEzPzMzETMrMjIrMjIROS8zMDFBMhYXFSYmIyIOAhURFB4CMzI2NxUGBiMiLgI1ETQ+AgEVITUTESMRARUhNQEVITUClE2WQ0KVT1WJYTM0YolVTpVBQ5RNfM2UUFCTzATx/P0nwQM3/WMC+f0HBcUNCJ4MDzlwpW3+zm2mcTkPDJ4HDlef24QBMITbn1f62J2dBRP6UAWw/Y6dnQJynp4AAwBh/+sHAARPACoAQABWACdAEyQAAEc8ExISPFIZCwsxB3I8C3IAKysyETMyETkvMxEzMxEzMDFFIi4CNTU0PgIXMh4CFRUhNSE1NCYmIyIOAhUVFB4CMzI2NxcGBgE1ND4CMzIeAhUVFA4CIyIuAjcVFB4CMzI+AjU1NC4CIyIOAgVjcLWARUuBp1twpm02/OcCYDZxWT1lSigmTXJLbpUySTG6+mtCfbJxc7R9QUF9s3Jys31CuiRJcE1NcEkkJEpxTUxwSSMVUJHGdix3xZBPAUeBsGp6lxpJfU08aoxQLFGNazw/LX4wVgImF3XJlVNTlcl1F3XJlVNTlcmMF1GPbz8/b49RF1CPb0BAb48AAAEAoQAAAoMGFQARAA62DQYBcgEKcgArKzIwMWEjETQ2NjMyFhcHJiYjIgYGFQFauVKXaSVGJRgRLR07USoErHWhUwwJjgUGMl1CAAABAF7/7AUSBcQALAAbQA0PAAYJCQAaIgNyAAlyACsrMhE5LzMRMzAxRSIuAjU1IRUhFRQeAjMyPgI1NTQuAiMiBgcnPgIzMhYWEhUVFAIGBgK5lOKYTQQ+/IMrYJ1yYphpNjVwsHyCsDsvGGqnc5/1p1ZdpdoUXK71mHyVIl2ieUVUlcRwXnHElVQ4HI8QMCVnu/7/m16b/v+7ZQAB/+P+SwK9BhUAJwApQBUUAgIVJwZyHyIiHhsBcgsODgoHD3IAKzIyETMrMjIRMysyMhEzMDFBFSMRFAYGIyImJzcWFjMyNjY1ESM1MzU0NjYzMhYXByYmIyIGBhUVAmDLTZBlHzQdDg9FDis9IaurUZhpJEckFhMzHTtOJgQ6jvv7cJxQBwqUBgcvWD0EBY5ydaFTDAmSBQUvW0JyAAMAZv/sBZ0GOAAJACEAOQAdQA4FBgYpKQAAHANyNRAJcgArMisyLzIROREzMDFBMxQGBiM1MjY2ExUUAgYGIyIuAzU1NBI2NjMyHgMHNTQuAyMiDgIVFRQeAzMyPgIE9qdUqX9PXSkDUprXhWe0kWg3VZzXgWq2j2Y1vyJCYHxLWZFoOCRFYXtHXpJlNAY4gbZfh0B6/SNcpP78tmA+d6vbg1ykAQO3YD53q9vfXmipglgtRojIgl5pqoNYLUaJyQAAAwBc/+wEugSxAAkAHwA1ABVACiYbC3IxAAAQB3IAKzIvMisyMDFBMxQGBiM1MjY2ATU0PgIzMh4CFRUUDgIjIi4CNxUUHgIzMj4CNTU0LgIjIg4CBCWVPIx4S0kX/DdEgLZxcreARESAtXJytoFEuSZNdE1Mc0wnJ01zTUxzTSYEsW6fVnQ8bP2nF3XJlVNTlcl1F3XIlVNTlciMF1GPbj8/bo9RF1CPb0BAb48AAgCM/+wGHQYCAAkAHwAZQAwFCgoAABUCchsQCXIAKzIrMi8yETMwMUEzFAYGIzUyNjYlMxEUBgYjIiYmNREzERQWFjMyNjY1BX+eU7eXZnEs/mvAkvGNlO+Lv1SXZGWXVAYCjcBih0OED/wnpNptbdqkA9n8J3KUSEiUcgAAAwCJ/+wFEASRAAkADgAlAB1ADgULCwAAGwZyIg4OFQtyACsyLzIrMi8yETMwMUEzFAYGIzUyNjYBETMRIxM3FA4CIyIuAjURMxEUHgIzMjY2BIKOOY6BWk4S/qG6sRpNLWSidE+DXjO5ITlHJnaKPQSRbZRKci1g/LUDQPvGAd4CbLeGSy5gmmwCuv1ESV83FlubAAH/tP5LAWYEOgARAA62DQYPcgEGcgArKzIwMVMzERQGBiMiJic3FhYzMjY2Na25TZBlHzQdDg9FDis9IQQ6+21wnFAHCpQGBy9YPQABAGP/7APqBFAAKgAZQAwRFBQAGQsLciQAB3IAKzIrMhI5LzMwMUEyHgIVFRQOAiciLgI1NSEVIRUUFhYzMj4CNTU0LgIjIgYHJzY2AgBwtYBFS4KmW3CmbTYDGf2gNnJYPGVKKSdMckttljJJMrkEUFCRxnYsdsaQTwFHgbBqepgZSH5OPGqNUCxQjWs9Py1+MFYAAQCqBOUDBwYAAAgAFLcHBQUEAQOACAAvGs0yOTIRMzAxQRMVIycHIzUTAg/4mpaVmPUGAP7vCqmpCwEQAAABAI4E4wL4Bf8ACAAStgEGgAcEAgAALzIyMhrNOTAxQRc3MxUDIwM1ASqXl6D+cvoF/6qqCv7uARIKAP//AI8FFwMuBaUGBgBwAAAAAQCCBMwC2AXXAA4AELUBAQmADAUALzMazDIvMDFBMxQGBiMiJjUzFBYzMjYCQpZIhlyLoZZEUlBEBddOeUSVdjtaWgABAI4E7wFpBcIACwAJsgMJEAA/MzAxUzQ2MzIWFRQGIyImjjc2NTk5NTY3BVgsPj4sLD09AAACAHkEtQInBlEADQAZAA60FwSAEQsALzMazDIwMVM0NjYzMhYVFAYGIyImNxQWMzI2NTQmIyIGeTlhPVt8OWE9W3xjQTMzQUEzM0EFgTpeOHpWOl01dFgsR0UuL0dHAAABADL+TgGTADkAFQAOtAgPgAEAAC8yGswyMDFlFw4CFRQWMzI2NxcGBiMiJjU0NjYBNEorTjIjKyE0Dw4ZTTtRbzVyOTkgRU0sISgTCHoPHWFeNmpiAAEAewTaAz8F6AAZACdAEwAAAQEKEkAPGkgSBYANDQ4OFwUALzMzLzMvGhDNKzIyLzMvMDFBFxQGBiMiLgIjIgYVJzQ2NjMyHgIzMjYCwn06YT0zQjQ5Kio5fTliPCtBOj4oKjoF6AtJbjwdJR1ALwZJbz8dJR1BAAIAXwTQAywF/wADAAcADrQBBYAABAAvMxrNMjAxQRMzASETMwMBd+bP/vT+P6rG2gTQAS/+0QEv/tEAAAIAf/5qAdb/tAALABcADrQPCYAVAwAvMxrMMjAxVzQ2MzIWFRQGIyImNxQWMzI2NTQmIyIGf2dHRWRkRUdnVzMkIjExIiQz80leXklJWlpJIjEwIyUyMgAB/KcE2v5HBgAAAwAKsgOAAgAvGs0wMUETIwH9hsGe/v4GAP7aASYAAf1uBNr/DwYAAAMACrIBgAAALxrNMDFBEzMB/W7C3/70BNoBJv7a///8igTa/04F6AQHAKX8DwAAAAH9XQTa/pMGdAAUABC1FAIAgAsMAC8zGswyMjAxQSMnPgI1NC4CIzcyHgIVFAYH/fiFATNAHhouPCIHSnFNJ2A6BNqYAw8fGhUdEwhqGjJFKkxFCAAAAvwnBOT/BgXuAAMABwAOtAcDgAQAAC8yGs0yMDFBIwEzASMDM/4Bqf7P4QH+lvbPBOQBCv72AQoAAAH9OP6i/hP/dQALAAixAwkALzMwMUU0NjMyFhUUBiMiJv04NzY1OTk1Njf2LT4+LSs9PQABALgE7wGcBj8AAwAKsgCAAQAvGs0wMVMTMwO4Nq50BO8BUP6wAAMAcgTxA4MGiQADAA8AGwAZQAoTGRkNAYAAAAcNAC8zMy8azREzETMwMUETMwMFNDYzMhYVFAYjIiYlNDYzMhYVFAYjIiYBsTC8ZP45NzY1OTk1NjcCNjg1Njg4NjU4BYEBCP74Ji0+Pi0rPT0pLT4+LSs9Pf//AJQCbAF5A0kGBgB4AAAAAQCyAAAEMAWwAAUADrYCBQJyBAhyACsrMjAxQRUhESMRBDD9QsAFsJ767gWwAAMAIAAABXQFsAAEAAkADQAbQA0GAgcDAnINDAwFAhJyACsyMhEzKzISOTAxQQEjATMBATczAScVITUDAv3kxgJmeQGv/gIGegJEmPvWBSj62AWw+lAFMID6UJ2dnQADAGf/7AT6BcQAAwAbADMAG0ANLwoDAgIKIxYDcgoJcgArKzIROS8zETMwMUEVITUFFRQCBgYjIi4DNTU0EjY2MzIeAwc1NC4DIyIOAhUVFB4DMzI+AgPA/fwDPlKa14VntJFoN1Wc14Fqto9mNb8iQmB8S1mRaDgkRWF7R16SZTQDK5eXJVyk/vy2YD53q9uDXKQBA7dgPner299eaKmCWC1GiMiCXmmqg1gtRonJAAIAMgAABQMFsAAEAAkAF0ALBgACBwMCcgUCCHIAKzIrMhI5OTAxQQEjATMBATczAQLK/jfPAhN+AXL+Mwp/AhIFEfrvBbD6UAUXmfpQAAMAeAAABCIFsAADAAcACwAbQA0BAAUEBAAICQJyAAhyACsrMhE5LzMRMzAxczUhFQE1IRUBNSEVeAOq/K0C8vy7A5WdnQKinZ0CcJ6eAAEAsgAABQEFsAAHABNACQIGBAcCcgYIcgArKzIRMzAxQREjESERIxEFAcD9MsEFsPpQBRL67gWwAAADAEYAAAREBbAAAwAHABAAIUAQDgYGBwcPAnIMAwMCAgsIcgArMhEzETMrMhEzETMwMWUVITUBFSE1ARUBIzUBATUzBET8TQOD/GACf/3HdAHh/h90np6eBRKenv02GP0yjwJLAkePAAMATgAABXQFsAATACcAKwAhQBAUFRUBACkIch8eHgoLKAJyACvNMjIRMyvNMjIRMzAxZSMiLgI1NDYkMzMyHgIVFAYEJTMyNjY1NC4CIyMiBgYVFB4CAREjEQMyo4LUmVKSAQGprH/SmVSQ/vz+r6WDqlQwX49frn+qVS9gkgEVwbBPkcl5oviMT5PIeqL3i59gr3ZZj2Y3Ya93WI9mNgRh+lAFsAACAFoAAAUiBbAAGQAdABlADBQHBw0cCHIdAQ0CcgArMjIrETkRMzAxQTMRFAYEIyMiLgI1ETMRFB4CMzMyNjY1AREjEQRgwp3+7q8df9ieWMA7apJXHXu5Z/63wQWw/fK3/4VLktWJAg798mOaajZguYQCDvpQBbAAAAMAcgAABMwFxAAtADEANQAlQBIoEhIvKSk0EREzLjIScgYdA3IAKzIrMjIyETMzETMyETMwMUE1NC4CIyIOAhUVFB4CFxUuAzU1ND4CMzIeAhUVFA4CBzU+AwE1IRUhNSEVBAkyYIZUU4VeMitQb0NstYVKUJTLfH3NlFFJhLNqQm1OKv7ZAeP7sQHsAtZ0dbJ5PT15snV0gMaNUw2NDX/F8H9yjumpXFyp6Y5yfvDFfw6NDlONxv2pnZ2dnQADAGT/6wR4BE4AFgAsAEEAGkANLgY0OzsdEgtyKAYHcgArMisyMhEzPzAxUzU0PgIzMh4DFxUOAyMiLgI3FRQeAjMyPgI3NS4DIyIOAgEzERQeAjMyNjcXBgYjIi4CNRFkOGueZk59YEQqCQs8ZpRjZJ1sOLogQ2tLSWhHLxAMLUlqSUxrRCACNJ0MFx0QChEHFx88IC9KNBsB9RWA1JtVLll/omFTeL+ISE2Mv4cVTYZmOTxnhEdCSYpvQUR2mwHZ/O0uOiENBAKKFgwjS3lVAigAAAIAof6ABE4FxAAcADoAHkAONQAmJyccHDAdAxMJC3IAKzI/MzkvMxI5OS8wMUEzMhYWFRQGBiMiLgI1NxQWFjMyNjY1NCYmIyMTMhYWFRQGBiMjNTMyNjY1NCYmIyIGBhURIxE0NjYCBZOLw2h1zYROmX5LSVaZZVyAQztyU49ZgsBpasCBWVVYbDI2a1FJdkW5esoDOGm0co7HaCxbkGMpSXpJS4NURoNUAwJksXNfnV54O2hDPGxEQXJI+k8FsW+3bQADAC/+XwPgBDoAAwAIAA0AGUAOCAwDBAoFAQUNBnIBDnIAKysyEhc5MDFlESMRNwEzASMDARcjAQJkuVcBIL7+b3voASgpe/5thP3bAiV3Az/7xgQ6/MD6BDoAAAIAYf/sBCgGHQAsAEIAGUANFCg+AwQzHgtyCwQBcgArMisyEhc5MDFTNDY2MzIWFwcmJiMiBgYVFB4CFx4CFRUUDgIjIi4CNTU0NjY3Jy4CExUUHgIzMj4CNTU0LgInIg4C3Vypdk9+QwEuk1I5VC4UMlpHj7xdQX2zcXO0fUFcl1gBQV0wPiRJcU1Mb0kjKk5rQkxySiUE9VuFSBsdnxEqIT0pFC4wMRgxndeHFnHBj1BQj8FxFnfCghUFGlBo/VkWTYhpPDxpiE0WQHxqSQ09aokAAgBk/+wD7ARNAB8APwAfQA8AIT4+AwMWNSsHcgwWC3IAKzIrMhI5LzMSOTkwMUEzFSMiBgYVFB4CMzI2NjUzFA4CIyIuAjU0PgIFIyIuAjU0PgIzMh4CFSM0JiYjIgYGFRQeAjMzAg3czVNxOiNFYz9ReEO4ToKhU2KlekM5bZ4BQdxclms5PXKgYlmceUS4Q3FGVW41GzhaP80CS2wlTT0jPzAcNlcxWIFTKCxUeUxEaUglRipLYjdNdU8pLFR2SjBNLS9LKiM7KxgAAgBt/oADxAWwACgALAAVQAkVAiwsKSkAAnIAKzIvMxEzLzAxQTMVAQ4CFRQeAhcXHgIVFAYGByc+AjU0JiYnJy4DNTQ2NjcBIRUhA3BU/qFNazcSJj0qgkp1QztRJGIfKxcgQzZaV3dKITh7ZP6aAx384wWweP5WXKKoZjBGMyIMJhUnT1I1c2MdVSM8OR4XJiAOGBc+VnVPSsDedwHUlwAAAgCS/mED8QROAAQAHAAXQAwYCwMGcgIKcgsHchEALysrKxEzMDFBESMRMwMHND4CMzIeAhURIxE0LgIjIg4CAUu5phNOOm+fZFSIXzO5Hz1XOU9wRyEDU/ytBDr+BgJzwY5OKF6ddfurBFJKZDsaO2iHAAADAHv/7AQSBcQAGQAnADYAHUAQDShqMCBqMDANABpqAA0LcgArLysSOS8rKzAxQTIeAxUVFA4DIyIuAzU1ND4DFyIOAhUVITU0LgMDMj4DNTUhFRQeAwJGVY5xTykpTnCOVVSOcVAqKk9wjlRCZ0UkAiUXLENXNDZXQiwW/dsXLkNXBcQxZZvTh7mH1J5oMzNontSHuYfTm2Uxlz54rnE3N1qUck0o+1cqUHWWWicnWpZ1UCoAAAEAw//zAkwEOgARAA62Bg0LcgAGcgArKzIwMVMzERQWFjMyNjcXBgYjIiYmNcO6IjYfFzMNARZHMkRyRAQ6/No3OBMJA5YHDjd/bAACACb/7wQ7Be4ABAAmAB5AEAAbBAMEAiAFAHIPFhYCCnIAKzIvMysyEhc5MDFBASMBFwEyHgIXAR4CMzI2NxcGBiMiJiYnAQMuAiMiBgcnNjYCG/7YzQGlgv65OFI7KA4Bqw4cIhgJFQcGCysXPVdCIf7Odg8hKx4IHgkBDzwDJ/zZBE4MAawYLkAo+6ohJxEBAZgECB1XVwMYAR8mLBMBAY4FBwAAAgBm/nYDqgXEAB4ARgAZQAsfEQ8PISEzBRsDcgArMi85LzMSOTkwMUEHLgIjIgYGFRQeAjMzFSMiLgI1ND4CMzIWFgMzFSMiBgYVFBYWFxceAhUOAgcnPgI1NCYmJycuAzU0PgIDjRolS00oaYY/JU58V42Rc7qGSESAsm8vXlXMkY18r1xQgElvUnM+ATtRI2seMBwfQzg6Y6R3QVSZ0QWdlAoQCjVVMjFROh90M1p4RlJ/WC4KEv3GcEWPbll6SRIaFC5QRzVxYh1VIzY6JxojGw0OF0JlmnBqoG03AAADACn/8wSlBDoAAwAHABkAGUANDhULcgYKcgkHAgMGcgArMjIyKysyMDFBFSE1IREjESEzERQWFjMyNjcXBgYjIiYmNQRx+7gBY7oCSroiNh8XMw0BFkcyRHJEBDqZmfvGBDr82jc4EwkDlgcON39sAAABAJL+YAQgBE4ALwAXQAweKQYRC3IGB3IADnIAKysrETMyMDFTETQ+AjMyHgIVFRQOAiMiLgInHgIxHgIzMj4CNTU0LgIjIg4CFQOSRnyhW3StdTo2aptkaJ5uQQsCLCwUR3hbS2xFIR5CakxGYz4dAf5gA+OBw4RDVZvUgBVyv4xMRIG2cwElJEZ7Szllhk0VV5t2REVwgz38HwABAGX+igPiBE4ALQAOtRsJBQAHcgArzDMvMDFBMhYWFSM0JiYjIg4CFRUUFhYXHgIVDgIHJz4CNTQmJicuAjU1ND4CAj55vm2wNm1RTG1FIU+edk99SQE6USNiHyoWIEQ3ndhwP3mwBE5cr31DbUBDcYlHKlqPaCAVLVVSNHJhHVQjNjgnHiYaDCOJ0IwqbcOWVgAAAwBh/+wEfAQ6ABgALgAyABNACSoGMgZyHxQLcgArMisyMjAxUzU0PgIzHgIXHgIVFRQOAiMiLgI3FRQeAjMyPgI1NTQuAiMiDgIBFSE1YUF9s3EfMj8zXIJEQX2zcnKzfkG5JElxTU1wSCQkSXFNTHFIJANi/cYCERdxwZBQAyUtDiuLtGsWZLiQVFOVyIwXUY9uPz9uj1EXS4hqPDxqiAHHmZkAAAIAUf/sA9oEOgADABUAFUAKBQoRAgMGchELcgArKzIRMzIwMUEVITUhMxEUFhYzMjY3FwYGIyImJjUD2vx3AVy5HTAcHDARKS5YL0xtOgQ6lpb81DY6FRAKgyETPIRsAAEAkP/rA/cEOgAeABNACRAHGQAGchkLcgArKxEzMjAxUzMRFB4CMzI+AjUmAiczHgIVFA4CIyIuAjWQuR43SitKb0smAkYzwx40IDl2snpbk2c3BDr9cFBxRiBLfplNiAEFez6cvXBz06NfNW2qdQABAFj+IgVMBDoALwAZQAwrBQUZGAZyIg8LcgAALysyKzIyETMwMUERNDY2MzIeAhUUDgIjIi4CNTQ2NjcXDgIHFB4CMzI2NjUuAyMiBhURAm0/cUtjr4ZMRpn1r6vulEQ6clRkO0ojAy5mqXupyFkBKEtuSSAi/iIFNUZlOFCRxXRvy59cX6TTc3DAnTmENICKRE6Zfkx9vmJJim5BKhr6xAACAGD+JwVDBDoAHgAiABVACiEHGQtyIBAABnIAKzIyKzIvMDFTMxEUHgIzMj4CNSYCJzMeAhUUDgIjIi4CNQEzESNguUBzmlqAsGowA0c1wx81IUOU87CN5KJWAgS5uQQ6/hh/sW0yTICbToYBAno9m7tvddSlX0iW6qEB5vntAAIAev/rBhoEOgAeAD8AGUAMARcKCik2HwZyNgtyACsrETMzETMyMDFBMx4CFRQOAiMiLgI1ETMRFB4CMzI+AjUmAiUzBgIHFB4DMzI+AjURMxEUDgIjIi4DNTQ2NgTQwiQ+JitdmGxWhl0wgiE8US88VDQYA1H79sI8UQMPIDNJMDBRPCGCMF2GVleDXTobJj4EOj+cvXFz0qNeQX64dwEp/tVdgVElRHebWIgBBXx8/vuIRoBrUSwlUYFdASv+13e4fkE9bpOsXHG9nAAAAQB6/+sEegXHADgAHUANHR4XNgQEDSMXC3ItDQAvMysyETkvMxDMMjAxQRcGBiMiJCY1NTQ2NjMyHgIVERQGBiMiLgI1ETcRFBYWMzI2NjURNC4CIyIGBhUVFBYWMzI2BHIIK201uf7ulleWYE59WC5swYJlpXdAuUB2Uk5uOxMnOSYqQydhvYozZwMJlRAUiu6UEG6bUjFgi1n9YpTMaUB4qGkBTQL+sV6GR0CFZgKeOFE1GSVTRRJhpmUQAAP/2gAABG8FvQADABYAKQAeQA4QCQkfJgNyGhgWAwMCEgA/MxEzMzMrMjIRMzAxQREjETcTPgIzMhYXByYmIyIGBgcBJwMTFwcBLgIjIgYHJzY2MzIWFgKEwFvmIUVTNCM7HyUEHxAVJiAP/smGqeYrhv7KDiIlFRAgBSMfOyIyVEoCr/1RAq9KAghKUSEMD5gEBQ4jHv1aAgLi/fDSAgKmHiMOBQSXDw0eUQADAEv/6wYbBDoAAwAkAEUAIUAQJgUDHA8vPAtyPA8CAwZyDwAvKzIROSsyETMRMzMwMUEVITUhMx4CFRQOAyMiLgI1NTMVFB4CMzI+AzUmAiUzBgIHFB4DMzI+AjU1MxUUDgIjIi4DNTQ2NgYb+jAEPsMkPSYZNFV2T1aGXDCCITxQMCg8KxsNBFH8QcM8UgMNGys8KDBQPCGCMF2GVk53VDUZJj8EOpiYP5y9cVysk249QX64d/n7XYFRJSxQbIBGiAEFfHz++4hGgGtRLCVRgV37+Xe4fkE9bpOsXHG9nAAAAwAr//QFsgWwABsAHwAjACFAER8jGAUFDiIjHghyIwJyDglyACsrKxEzEjkvMxEzMDFBNT4CMzIWFhUUDgIjJzI+AjU0JiYjIgYGExEjESEVITUCPTaEgjKi6H0/fLt8AlZ2RyBKkWw/fnkWwALL+5YCiqcVIhRrzZNopXM9lypObEFfgkQSIQMO+lAFsJ6eAAACAHv/7ATdBcQAAwAsAB1ADgMCAgkdGRQDcikECQlyACvMMyvMMxI5LzMwMUEVITUBMw4CIyIuAjU1ND4CMzIWFhcjLgIjIg4CFRUUHgMzMjY2A3b9qwL6wg+B6q6B0pZRUZnZiKXjgA/BDkyMcGGTYzIdOlp5TnqSSwMunZ3+oYraf2Cx+ZmQmfqyYHzbkGaTUEqJvnSSVpuCXzRNkgAAAwAyAAAIOwWwABEAFQAuACdAEyQhIQkuFhYACgkIchQVFSMAAnIAKzIyETMrMhI5LzMRMxEzMDFBMwMOBCMjNTc+BDcBFSE1ASEyFhYVFA4CIyERMxEhMjY2NTQmJiMhAXfAIQchPGCLYTQoOFE5JBUGAu79cAMIAY2g23JAfrd4/eDBAV9rhT4+hWv+cwWw/Tea8bFzOJ0DBCtYjMuIAqqenv3MdMqBYKJ5QgWw+u1UhUlJg1MAAAMAsgAACE0FsAADAAcAIAAjQBEIICADAgIGFQcCchYTEwYIcgArMhEzKzIROS8zMy8zMDFBFSE1ExEjEQEhMhYWFRQOAiMhETMRITI2NjU0JiYjIQRb/PkfwQQhAY2g23JAfrd4/eDBAV9rhT4+hWv+cwM5nZ0Cd/pQBbD9n2u8fF2cc0AFsPr2SnlFRXZJAAMAPgAABdQFsAAVABkAHQAdQA4ZARgGEREYHB0CchgIcgArKzIROS8zETMyMDFhIxE0JiYjIg4CBzU+AzMyFhYVAREjESEVITUF1MBDhmU8cWxpMzJgZ3ZGm912/MPBAtH7lwHIcX80ChIZEJ8PGRIKWcWkA+j6UAWwnp4AAAIAsP6ZBQAFsAAHAAsAF0ALCQYBAnILAwMACHIAKzISOSsyLzAxcxEzESERMxElESMRsMICzcH+P8AFsPrtBRP6UIr+DwHxAAIAowAABLEFsAAFAB4AIUAQBh4eBAITEwUCchQREQQIcgArMhEzKzIRMxE5LzMwMUEVIREjERMhMhYWFRQOAiMhETMRITI2NjU0JiYjIQQh/ULAkwGNoNxyQH64eP3gwQFfa4U+PoVr/nMFsJ767gWw/a9rwIFgn3U/BbD67U+ASUl6SQAABgAz/poFygWwAAMABwALAA8AEwAlACdAEwsRESADAwceCHIODw8QFAJyCQUALzMrMjIRMysyMhEzMhEzMDFlFSE1MxEjAyEDIxEDFSE1IREjESEzAw4FByM1Mz4DNwUi+7IfvwEFlwK/pP2CAyTA/VrBHgYmOEhSWS1YPhpDQzMJnZ2d/f0CA/3+AgIFE56e+lAFsP22hN+4kWlDDp0caqn0pgAFABsAAAc2BbAABQAJAA0AEwAXACdAExYRCQMDAAAPDxQMCAhyDgoBAnIAKzIyKzIyMi8zETMRMzMzMDFBATMBIQcnASMBAREjESEBISchARMBNwECSv344gGDARIf6P5Z8AIdAdS/A8P99v66HgEIAYMZ/lp7AhsCmQMX/YmgD/1YA04CYvpQBbD86aACd/pQAqim/LIAAAIAUP/sBGsFxAAeAD4AI0ARACACAj4+FTQwKglyDwsVA3IAKzLMK8wzEjkvMxI5OTAxQSM1MzI2NjU0JiYjIgYGFSM0PgIzMh4CFRQOAiUzMh4CFRQOAiMiLgI1MxQWFjMyNjY1NC4CIyMCZ62mbog+RI5wVIhQwU6Is2R1vohIRoK2/uOte8CERU+QxXVet5RZwVGQYG6ZUStTe1GmArt7Pm5IRXNFP29IXZVpODVommZLhGQ5VTJgjVtmnm44MWegcEl6SUV5TENjQB8AAQCyAAAFAAWwAAkAF0ALBQAGAggCcgQGCHIAKzIrMhI5OTAxQQEzESMRASMRMwFyAs3Bwf0zwMABTgRi+lAEY/udBbAAAAMAMAAABPcFsAADAAcAGQAZQAwSBREIcgIDAwQIAnIAKzIyETMrMjIwMUEVITUhESMRITMDDgQjIzU3PgQ3BFH9ZgNAwf0/wCEHITxgi2E0KDhROSQVBgWwnp76UAWw/Tea8bFzOJ0DBCtYjMuIAAACAE3/6wTLBbAAEwAYABpADhcWABUECAIYAnIPCAlyACsyKzISFzkwMUEBMwEOAyMiJic3FhYzMjY2NwMBFwcBAmwBgd79/RY2TnNVGEIKBgtADzlCKRHyAZUwov4FAeMDzftDM19KLAUDmgIDLkclBI78dbMMBEoAAAMAVP/EBeMF7AAVACkALQAbQAwfDAwrFgAAKyoDcisALysROS8zETkvMzAxQTMyHgIVFA4CIyMiLgI1ND4CFyIGBhUUHgIzMzI2NjU0LgIjAxEjEQKi8X7XoVpaodd+8X7WoVlZodZ+g7ZeNWiYYvOCtV82Z5diHbkFH1Wc14KC2J1VVZzXgoLXnVaYbcSDY6ByPm3Fg2Kgcj4BZfnYBigAAAIAr/6hBZgFsAAFAA0AGUAMDAcCcgUEBAkGCHIBAC8rMjIRMysyMDFlAyMRIzUFETMRIREzEQWYEq2P/GXCAs3Bov3/AV+iogWw+u0FE/pQAAACAJcAAATJBbAAFQAZABdACxcGEREYAAJyGAhyACsrETkvMzIwMVMzERQWFjMyPgI3FQ4DIyImJjUBMxEjl8FChmQ8cWxpMzFhZ3VHmt12A3HBwQWw/jlxgDQKEhoPng8aEgpZxqQBx/pQAAABALAAAAbYBbAACwAZQAwFCQYCAgsAAnILCHIAKysRMxEzMjIwMVMzESERMxEhETMRIbDCAfTAAfHB+dgFsPrtBRP67QUT+lAAAAIAsP6hB2sFsAAFABEAHUAODAUICAQRCHIPCwYCcgEALysyMisyMhEzMzAxZQMjESM1ATMRIREzESERMxEhB2sSpo36isIB9MAB8cH52Jj+CQFfmAUY+u0FE/rtBRP6UAAAAgARAAAFuQWwAAMAHAAdQA4REg8EHBwPAAECcg8IcgArKzIROS8zETMyMDFTNSEVEyEyFhYVFA4CIyERMxEhMjY2NTQmJiMhEQHJZAGMoNxzQX64eP3hwAFfa4U+PoVr/nQFGJiY/kdrwIFgn3U/BbD67U+ASUl6SQACALIAAAYxBbAAGAAcAB1ADhoZDgsAGBgLDAJyCwhyACsrETkvMxEzMjMwMUEhMhYWFRQOAiMhETMRITI2NjU0JiYjIQERIxEBRQGNoNxyQH64eP3gwQFfa4U+PoVr/nME7MEDX2vAgWCfdT8FsPrtT4BJSXpJAu/6UAWwAAABAKMAAASxBbAAGAAZQAwOCwAYGAsMAnILCHIAKysROS8zETMwMUEhMhYWFRQOAiMhETMRITI2NjU0JiYjIQE2AY2g3HJAfrh4/eDBAV9rhT4+hWv+cwNfa8CBYJ91PwWw+u1PgElJekkAAgCU/+wE9AXEAAMALAAdQA4DAgIeCQUpCXIZFR4DcgArMswrzDMSOS8zMDFBFSE1ATMeAjMyPgI1NTQuAyMiBgYHIz4CMzIeAhUVFA4CIyImJgRM/av+ncAQS5J7YY5cLSBAX31NcI1LD8APgOOlh9iZUVGW0YCv6n8DJZ6e/qpnkk1Rjrxrkl2ff1owUJNmkNt8YLL6mZCZ+bFgf9oAAAQAt//sBtsFxAADAAcAHQAzACNAEy8HBgYOJBkDAnICCHIZA3IOCXIAKysrKxEzEjkvMzIwMUERIxEBFSE1BRUUAgYGIyImJgI1NTQSNjYzMhYWEgM1NC4CIyIOAhUVFB4CMzI+AgF4wQIP/qYFb1Ka14WB151WVZzXgYXXm1O/NWaTXVqRZzg4aZFaXpJlNAWw+lAFsP1lmJgPXKT+/LZgYLYBBKRcpAEDt2Bgt/79/wBegsiIRkaIyIJeg8mJRkaJyQACAFoAAARlBbAAFgAaAB9ADxcWFgAACQwMGQhyDgkCcgArMisyERI5LzMSOTAxQSEnJiY1NDY2MyERIxEhIgYVFBYWMyEFASMBA9H+Z1+eqn3nngHSwf7voKFHjGgBRf63/p7NAWwCNycyz5qNxGb6UAUSmIFUhEw6/WUCmwADAGL/6wQpBhEAFgAvAEQAGUAMOiIwFxciAAFyIgtyACsrETkvMxEzMDFBMxQOAgcOAxcVIzU0EjY2Nz4CAzIeAhUVFA4CIyIuAjU1NDY2Nz4CFyIGBhUVFB4CMzI+AjU1NC4CA0OYPGeBRVaTaTELmEeCs2xOcDvbaqZ0PUF9s3Jys35BEhsLJYG1T2aDQCRJcU1NcEgkJElxBhFicz4gDxJNjOClXFy5ARS+cBUPIzz+H0qEs2kWccGPUFCPwXEWGTAyHFqaX5dem1oWTIhpPDxpiEwWRHpeNwAAAgCeAAAEKQQ6ABsAMwAtQBYCARsrKSkoASgBKA8NEAZyHh0dDwpyACsyETMrMhE5OS8vETMSOTkRMzAxQSEnITI2NjU0LgIjIxEjESEyHgIVFA4CBwMhNyEyNjY1NCYmIyE3IRceAhUUDgICif6dAgEiVnM6IUJhQe25AaZnpXU+KE5ySkj+WlwBSk1mMzNmTf7nAgFfQ1l8QDlsmgHclCJEMic7JxP8XAQ6JElwTDFYRCsG/e2WJ0kzM0knlDgHSnFCTHRNJwABAJsAAANIBDoABQAOtgIFBnIECnIAKysyMDFBFSERIxEDSP4MuQQ6mfxfBDoAAwAu/sEElAQ6AA8AFQAdACFAEB0YCRYWGxMICnIVEBAABnIAKzIRMysyMjIRMy8zMDFBMwMOAwcjNzc+AzcTIREjESEBIREjESERIwFQuRAGOlpvO1wFJiE+NCMFPwKLuf4u/rEEZbn9DboEOv5rmuCdaiSXASdTc6d5AZX7xgOP/Qn+KQE//sEABQAWAAAGBAQ6AAUACQANABMAFwAwQBcVEBAAFhERCQMDBgAAFAcMEhMNDQIGcgArMhEzPzMzOS8zMxEzMxEzETMRMzAxQQEzATMHJwEjAQERIxEhASEnMwETATcBAdX+Zt8BGNgbtf7G6gGvAaS5AzD+Zv7mHdkBGBr+xXcBrgHXAmP+QKMT/hYCcAHK+8YEOv2dowHA+8YB6ob9kAACAFj/7AOtBE0AHQA7ACNAEQAfAgI7OxQyLikLcg8LFAdyACsyzCvMMxI5LzMSOTkwMUEjNTMyNjY1NCYmIyIGBhUjNDY2MzIeAhUUDgIlMzIeAhUUDgIjIiYmNTMUFhYzMjY2NTQmJiMjAiHHuE1aJiteT0BoPblxvXBelWg3NGKL/uLHYZRkMz1wm15pxoC5Pm9JTmg1MGNNuAIFcidGLypLLy1NMGOPTilPdU03YksqRiVIaURMeVQsSJd1MVg2MFAvPUojAAEAnQAABAIEOgAJABdACwUABgIIBnIEBgpyACsyKzISOTkwMUEBMxEjEQEjETMBVQHzurr+Dbi4ASUDFfvGAxX86wQ6AAADAJ0AAARABDoAAwAJAA0AH0APDAcHCwYGAgkDBnIKAgpyACsyKzIROS8zMxEzMDFBESMRIQEhJzMBEwE3AQFWuQN//f/+/RzUAWsa/nJ3AgIEOvvGBDr9lKIByvvGAeqG/ZAAAwAsAAAEAwQ6AAMABwAZABlADBIFEQpyAgMDBAgGcgArMjIRMysyMjAxQRUhNSERIxEhMwMOBCMjNTc+BDcDYP31Aq65/d66HAcfNU9uSDooKz0qGw8EBDqZmfvGBDr99nm5hFMnowMDIkNqkmEAAAMAngAABVMEOgAGAAoADgAbQA0ACQwGAQoGcgsDCQpyACsyMisyMjISOTAxZQEzASMBMyMRIxEBETMRAvsBcLL+HoD+ILI2uQP7uvYDRPvGBDr7xgQ6+8YEOvvGAAADAJ0AAAQBBDoAAwAHAAsAG0ANCQYIAwICBgcGcgYKcgArKxE5LzMyETMwMUEVITUTESMRIREjEQNr/cQnuQNkugJllpYB1fvGBDr7xgQ6AAMAnQAABAIEOgADAAcACwAZQAwJBggCAwMHBnIGCnIAKysyETMyETMwMUEVITUzESMRIREjEQNe/d0buQNlugQ6mZn7xgQ6+8YEOgACACgAAAOxBDoAAwAHABC3AwYHBnICCnIAKysyMjAxQREjESEVITUCRroCJfx3BDr7xgQ6lpYAAAUAZP5gBWkGAAAWACsAQgBWAFoAJ0AVJwYGSR4REVIzPgtyMwdyWAByVw5yACsrKysRMzMRMzIyETMwMUEVFA4CIyIuAicRPgMzMh4DBzU0LgMjIgYGBxEeAjMyPgIlNTQ+AzMyHgIXEQ4DIyIuAjcVFB4CMzI2NjcRLgIjIg4CAREzEQVpMmOSYE94UzEJCTFTdk9OfV8/ILkTJz5XODxPLAoMLk47RmM/Hfu0IEBffU5Nc1AwCgkwUHVOYJJjM7obO2BGPE4uDAotTj1GYjsbAWS6AgoVcr+MTStSc0gB4E16Vi43Zo+yexVGf2tQLB4xG/2NFicZOWaGTRVmso9mNy5Wek3+M0x6Vy5NjL+HFU2GZjkeMBoCYRsxHkR2m/v/B6D4YAAAAgCd/r8EggQ6AAcADQAbQA0GAQMNDAwACnIBBnIJAC8rKzIRMzIRMzAxcxEzESERMxE3AyMRIzWduQHyuoASpY0EOvxeA6L7xpj+JwFBmAACAGgAAAO9BDwAAwAXABdACw8UCQkBAAZyAQpyACsrETkvMzIwMUERIxETFQ4CIyImJjURMxEUFhYzMjY2A725ejhzf0qAvGa5NmhLSH91BDr7xgQ6/g+YFSETWbWKATz+xFpwNRMgAAEAnQAABeAEOgALABlADAUJBgICCwAGcgsKcgArKxEzETMyMjAxUzMRIREzESERMxEhnbkBjLoBi7n6vQQ6/F4DovxeA6L7xgAAAgCS/r8GbQQ6AAUAEQAdQA4MBQgIBBEKcg8LBgZyAQAvKzIyKzIyETMzMDFlAyMRIzUBMxEhETMRIREzESEGbRKljftpuQGMugGLufq9mP4nAUGYA6L8XgOi/F4DovvGAAACAB4AAATABDoAAwAcAB1ADhESDxwEBA8CAwZyDwpyACsrMhE5LzMRMzIwMUEVITUBITIWFhUUDgIjIREzESEyNjY1NCYmIyEB+f4lAckBRYO0XTRnl2L+M7oBE1BfKipfUP67BDqYmP6MW59lS4NiNwQ6/F46XDIxXj8AAgCeAAAFfwQ6ABgAHAAdQA4aGQ4LGAAACwwGcgsKcgArKxE5LzMRMzIzMDFBITIWFhUUDgIjIREzESEyNjY1NCYmIyEBESMRASUBRYO0XTRnl2L+NLkBE1BgKipgUP67BFq5AsZbn2VLg2I3BDr8XjpcMjFePwIM+8YEOgAAAQCeAAAD/gQ6ABgAGUAMDgsYAAALDAZyCwpyACsrETkvMxEzMDFBITIWFhUUDgIjIREzESEyNjY1NCYmIyEBJQFFg7RdNGeXYv40uQETUGAqKmBQ/rsCxlufZUuDYjcEOvxeOlwyMV4/AAIAZP/rA+EETgAnACsAHUAOKyoqCR0ZFAtyBAAJB3IAKzLMK8wzEjkvMzAxQSIGBhUjNDY2MzIeAhUVFA4CIyImJjUzFBYWMzI+AjU1NC4CARUhNQIIPW9HsXjAbHKweT4/ea9xeb9tsUFuRUttRiEhRW0BLf4NA7Y2Xz5hpWVWlsNtKm3Dl1ZosW9DbUBEcItGKkeKcEP+vZeXAAQAnv/sBjAETgADAAcAHQAzACNAEyQDAgIZLw4HBnIGCnIOB3IZC3IAKysrKxEzEjkvMzIwMUEVITUTESMRATU0PgIzMh4CFRUUDgIjIi4CNxUUHgIzMj4CNTU0LgIjIg4CAvX9waG5AblEgbVxc7aBRESAtnJytoFEuiZNc01Nc0wnJ010TUxyTSYCb5eXAcv7xgQ6/dcXdcmVU1OVyXUXdciVU1OVyIwXUY9uPz9uj1EXUI9vQEBvjwAAAgAvAAADxwQ6AAMAHQAdQA4BEhITEwMJBAZyBwMKcgArMisyEjkvMxI5MDFBMwEjASERIxEhIgYGFRQWFjMhFSEiLgI1ND4CAWjI/sfIAdQBxLn+9U9kLipaRwFT/q1dkGQ0N2mZAgT9/AQ6+8YDpDVULSxRNJgyWXlHR3haMQAE/+f+SwPgBgAAEQAVACwAMAAdQBAwLygcB3IVAHIUCnINBg9yACsyKysrMswyMDFBMxEUBgYjIiYnNxYWMzI2NjUBESMREyc+AzMyHgIVESMRNCYmIyIOAgEVITUDJrpNkGUfNh4PD0YPKz0g/iC5jU0BQHShYlCAWzC6MmBGRXFRLQFK/YMBxv3hcJxQBwqUBgcvWD0GWfoABgD8RgNvvYxNK16Va/07AsdVZy86ZoMCwpiYAAIAZ//sA/cETgADACsAG0ANBA0DAgINIRgHcg0LcgArKzIROS8zETMwMUEVITUBMjY2NzMOAiMiLgI1NTQ+AjMyFhYXIy4CIyIOAhUVFB4CArf91gG8QnBIBa8Fd79zerZ3Ozt4tXl/vm0FrwVBb0tVc0MdHUNzAmiYmP4cNl89YKVlVpbDbSptw5ZWZ7FwQ2xBQ3GJRypHinBDAAMAJwAABoYEOgARABUALgAlQBIWLi4AJCEhCgkKchQVFSMABnIAKzIyETMrMjIRMxE5LzMwMUEzAw4EIyM1Nz4ENwEVITUBITIWFhUUDgIjIREzESEyNjY1NCYmIyEBJLkcBx41UG1IOykqPSobEAQCLP4PAmIBRYS0XDRnlmP+NLkBE1FfKipfUf67BDr99nm5hFMnowMDIkNqkmEBz5mZ/mRWll9He100BDr8XDpYLSxSNAAAAwCdAAAGqAQ6AAMABwAgACVAEhUWExMGCAMgAwICBgcGcgYKcgArKxE5LzMzETMRMxEzMjAxQRUhNRMRIxEBITIWFhUUDgIjIREzESEyNjY1NCYmIyEDa/3EJ7kDMQFGg7RdNGeXYv4zugETUF8qKl9Q/roCoZaWAZn7xgQ6/mRWll9He100BDr8XDpYLSxSNAAD//0AAAPgBgAAAwAaAB4AGUANHh0WCgdyAwByEQIKcgArMisrMswyMDFBESMREyc+AzMyHgIVESMRNCYmIyIOAgEVITUBRrmNTQFAdKFiUIBbMLoyYEZFcVEtAWD9gwYA+gAGAPxGA2+9jE0rXpVr/TsCx1VnLzpmgwLHmJgAAAIAnf6cBAIEOgADAAsAF0ALAAYGCwpyCQQGcgIALysyKzISOTAxZTMRIwEzESERMxEhAfW6uv6ouQHyuvybmP4EBZ78XgOi+8YAAgCc/+sGdgWwABgAMAAbQA4sHwlyFAcJciYaDgACcgArMjIyKzIrMjAxQTMRFA4CIyIuAjURMxEUHgIzMjY2NQEzERQGBiMiLgI1ETMRFB4CMzI2NjUDJpw8bJJXV5RtPcIfOU0uR28/Ao/Bbr55Uo1nOpwiPVQxQmc7BbD73mmeaDQ0aJ5pBCL73kJiQiA6dFgEIvvejLtcNGieaQQi+95CYkIgOnRYAAACAIH/6wWuBDoAGAAxABtADiwfC3IUBwtyJhoOAAZyACsyMjIrMisyMDFBMxEUDgIjIi4CNREzERQeAjMyNjY1ATMRFAYGIyIuAjURMxEUHgIzMj4CNQK6ljVhg05Og2E2uhovPyY8XjcCO7liq2xKfVwzlhw0RiopRjQdBDr9KF6NXi4uXo1eAtj9KDhUNxwxY0sC2P0ofqZTLl6NXgLY/Sg4VDccHDdUOAAAAv/bAAAD/AYWABcAGwAhQBANCgAXFwoaGxsKCwFyCgpyACsrETkvMxE5LzMRMzAxQSEyFhYVFAYGIyERMxEhMjY2NTQmJiMhARUhNQEjAUWEtFxctIT+NLkBE1BgKipgUP67AXT9RALqYKZraatlBhb6gj9kNzVnRQJ/mJgAAwC4/+0GoQXFAAMALAAwACBAEQMCAi8wAnIvCB0UA3IpCQlyACsyKzI/KxI5LzMwMUEVITUBMw4CIyIuAjU1ND4CMzIWFhcjLgIjIg4CFRUUHgMzMjY2AREjEQUe/BEEscEPgeqvgNGWUVGZ2Iel5IAPwQ5MjHFgk2MyHTpZek17kkv7qcEDQZiY/o+K2n9gsfmZkZn5smB825Bmk1BKiL50k1abgl80TpIERvpQBbAAAAMAmv/sBaEETgADACsALwAkQBMDAgIuLwZyLgohHRgHcggEDQtyACsyzCvMMz8rEjkvMzAxQRUhNQEyNjY3Mw4CIyIuAjU1ND4CMzIWFhcjLgIjIg4CFRUUHgIBESMRBIL8jwLiQnBIBa8Fd79zerZ3Ozt4tXp/vW0FrwVBb0pWckMdHENz/ba5AmiYmP4cNl89YKVlVpbDbSptw5ZWZ7FwQ2xBQ3GJRypHinBDA7b7xgQ6AAQAKAAABOUFsAAEAAkADQARACRAERENDAwCAAYGBwMCcg8FBQIIAD8zETMrMjIRMxE5LzMzMDFBASMBMwEBNzMBAxUhNQURIxECsv48xgINewFv/kMFegIE//0+Aby9BRT67AWw+lAFHJT6UAJao6Mz/dkCJwAEAA8AAAQlBDoABAAJAA0AEQAeQA4RDQwMAQcDBnIQBQUBCgA/MxEzKzISOS8zMzAxQQEjATMBAQMzAQMVITUFESMRAf/+zr4Bu40BEf7HVI4BvNz9rQGCuAL9/QMEOvvGAv0BPfvGAcGYmCb+ZQGbAAAGAMoAAAb2BbAAAwAIAA0AEQAVABkANEAaCRQUBgYYFREREBADAgIYCBYCcgQKCgsHAnIAKzIyETMrPzkvMzMRMxEzETMRMxEzMDFBFSE1AQEjATMBATczAQMVITUFESMRAREjEQNb/d0Di/48xgINewFv/kMFegIE//0+Aby9/VfBAlqhoQK6+uwFsPpQBRyU+lACWqOjM/3ZAicDifpQBbAAAAYAvQAABeQEOgADAAgADQARABUAGQAuQBcVEREQEAMCAhgZBnIJFBQGBhgKCwcGcgArMj8zETMRMysSOS8zMxEzETMwMUEVITUBASMBMwEBAzMBAxUhNQURIxEBESMRAuf+LAKr/s6+AbuNARH+x1SOAbzc/a0Bgrj997kBwZiYATz9AwQ6+8YC/QE9+8YBwZiYJv5lAZsCn/vGBDoABQCTAAAGQAWwABYAGgAfACQAKAA0QBkZGhokGx8fIyMTKAYGExMBHCQCcg0nJwEIAD8zETMrMhI5LzMRMxEzETMRMxEzETMwMWEjETQ2NjMhMhYWFREjETQmJiMhIgYVARUhNQEBMwEjAQEHIwEBESMRAVTBdNmYAeKZ2XTBQIJj/h6TkQOx/OABTAG+2/3/ev6kAcEief3+ArbAAXKhwlZWwqH+jgFybnsydqUEPp6e/QADAPyyA078+UcDTv1d/PMDDQAABQCXAAAFSwQ7ABcAGwAgACUAKQAwQBcaGxslICQkEykGBhMTAR0lBnINKCgBCgA/MxEzKzISOS8zETMRMxEzETMRMzAxYSM1NDY2MyEyFhYVFSM1NCYmIyEiBgYVARUhNQEBMwEjAwEHIwEBESMRAVC5asiLATqLx2u5OXNY/sZYczkDEP1OARMBRdD+dXDzAUkdcP50Ajm5pKHBVlbBoaSkcX0zM31xA5eZmf25Akb9bQKT/bVIApP+C/27AkUABwC3AAAIcgWwAAMABwAeACIAJwAsADAAPEAeISIiJCwCcicrKxswDg4bGwMCAgUHAnIVLy8JCQUIAD8zETMRMysSOS8zMxEzETMRMxEzKzIyETMwMUEVITUTESMRASMRNDY2MyEyFhYVESMRNCYmIyEiBhUBFSE1AQEzASMBAQcjAQERIxEE8PxvGcEC0MF02ZcB45nZc8BAgmP+HZKRA7H84AFMAb7b/f55/qQBwSJ5/f4CtsEDLJeXAoT6UAWw+lABcqHCVlbCof6OAXJuezJ2pQQ+np79AAMA/LIDTvz5RwNO/V388wMNAAAHAJwAAAc7BDsAAwAHAB8AIwAoAC0AMQA+QB4lIiMjLS0HKCwsGzEODhsbAwICBgcGchUwMAkJBgoAPzMRMxEzKxI5LzMzETMRMxEzETMRMxEzETMzMDFBFSE1ExEjEQEjNTQ2NjMhMhYWFRUjNTQmJiMhIgYGFQEVITUBATMBIwMBByMBAREjEQTf/B5YuQKkuWrIiwE6i8druTlzWP7GWHM5AxD9TgETAUXQ/nVw8wFJHXD+dAI5uQJcl5cB3vvGBDr7xqShwVZWwaGkpHF9MzN9cQOXmZn9uQJG/W0Ck/21SAKT/gv9uwJFAAMAUP5GA6oHhgAXAEAASQArQBQYDQxAQAArLAlFQ0NCSEGARxcAAgA/Mt4azTI5MhEzPzMSOS8zMzMwMVMhMh4CFRQOAiMjNTMyNjY1NCYmIyETMzIeAhUUDgIjIyIGFRQWFhcHLgInNDY2MzMyPgI1NC4CIyMTFzczFQMjAzWEATJor4BHRoK2cJGNb4o/PoFl/s6RkXvAhURIga9oNVBFOEweSz14UQFRlWctRW5MKCxVfVGNdJeXoP5y+wWwNWaSXEuBYTZzPm5IQWxA/fgyYI1bZp5tOD8yNUkuDnwaWH1QWHE2KEljOkRlRCEE5qqqCv7uARIKAAADAEz+RgN3BjEAGABBAEoAJkARDRkMQUEALUNJRkRCgEgYAAYAPzLeGs0yMjI5LxI5LzMzMzAxUyEyHgIVFA4CIyM1MzI2NjU0LgIjIRMzMh4CFRQOAiMjIgYVFBYWFwcuAic0NjYzMzI+AjU0LgIjIxMXNzMVAyMDNYEBLV6fdUFAd6ZmkY1gdzYePV5A/tOMkXGweT9BdqBeMVFEOEweSz14UQFRlmYpO11BIiZKbEeNK5eXoP5y+wQ6KlBzSDpiSilzKEgwIDcpGP6hJEZmQkx4VCs/MjVJLg58Glh9UFhxNhktPSUqPioUBF+qqgv+7gETCgADAGf/7AT6BcQAFwAoADkAH0ASDClqMiBqMjIMABhqAANyDAlyACsrKxI5LysrMDFBMh4DFRUUAgYGIyIuAzU1NBI2NhciDgIHBgYVITQmJy4DAzI+Ajc2NjUhFhYXHgMCsGq2j2Y1UprXhWe0kWg3VZzXgVGIZUAJAQIDFQECCTxliVNWimM7CAEB/O0BAgEKQGaHBcQ+d6vbg1yk/vy2YD53q9uDXKQBA7dgpDpyp20QIxIRIhBup3M6+287dKtvCxULEB4Oa6RwOQADAFz/7AQ0BE4AFQAgACsAH0ASCyFqJxtqJycLABZqAAdyCwtyACsrKxI5LysrMDFBMh4CFRUUDgIjIi4CNTU0PgIXIg4CByEuAwMyPgI3IR4DAkdyt4BERIC1cnK2gUREgLZxRGpLLQgCXgcuTGtCRWtMLQb9oAYtTGwETlOVyXUXdciVU1OVyHUXdcmVU5gzWndERHdaM/zONF17R0d7XTQAAAIAFgAABN0FwwAOABMAGUANDhIIBRMCcgUDchIIcgArKysRMxEzMDFBAT4CMxcHIyIGBgcBIwEBEyMBAocBAiFQa0ouAQwiMykU/nyV/sIBXGKV/gYBdgMpaIE7AaobPjf7eAWw+8f+iQWwAAIALwAABAwETgASABcAFUALFwZyEhYKcgwFB3IAKzIrMiswMUETPgIzMhYXByYmIyIGBgcBIwMTEyMBAgydHE1dMh01GRUFFw8UKSIL/tZ60vBKe/6EATwCH1hqMQgRlAMFFikd/LMEOv0C/sQEOgAEAGf/cwT6BjUAAwAHAB8ANwAkQBACAicnAxoDcgcHMzMGDglyACvNMxEzfC8rGM0zETN9LzAxQREjERMRIxEBFRQCBgYjIi4DNTU0EjY2MzIeAwc1NC4DIyIOAhUVFB4DMzI+AgMWubm5Ap1SmteFZ7SRaDdVnNeBaraPZjW/IkJgfEtZkWg4JEVhe0dekmU0BjX+fgGC+sn+dQGLAghcpP78tmA+d6vbg1ykAQO3YD53q9vfXmipglgtRojIgl5pqoNYLUaJyQAABABc/4kENAS2AAMABwAdADMAJEAQBwckJAYZC3ICAi8vAw4HcgArzTMRM30vKxjNMxEzfC8wMUERIxETESMRATU0PgIzMh4CFRUUDgIjIi4CNxUUHgIzMj4CNTU0LgIjIg4CAqK6urr+dESAtnFyt4BERIC1cnK2gUS5Jk10TUxzTCcnTXNNTHNNJgS2/pABcPxC/pEBbwEZF3XJlVNTlcl1F3XIlVNTlciMF1GPbj8/bo9RF1CPb0BAb48AAAQAnP/rBm8HUgAVACAAQQBlADNAGVtOCXJUMTEsOAlyQkNDEQgIGxsWFiIhAnIAKzIyfC8zGC8zETMyETMrMjIvMysyMDFBMxUjIi4CIyIGFRUjNTQ2MzIeAgEnNjY1NTMVFAYGJRUiBgYVERQeAjMyNjY1ETMRFA4CIyIuAjURNDY2BTUyHgIVERQOAiMiLgI1ETMRFB4CMzI+AjURNC4CBRsoKleIbV4tMz6Af248amt9/phMISOeMEb+rT1fNx85TS5Hbz+cPGySV1eUbT1qtwMeV5RtPDxtlFdWkmw8nCRCWTUuTTkgIDlNBtR/JjEmNTcSJG5sJjIm/lg3KEcnX2YmTkBynkGDZP3GS29KJDp0WAGs/lRpnmg0OHGqcgI6mMllnp45capy/cZyqnE4NGieaQGs/lRCYkIgJEpvSwI6S29KJAAEAH7/6wWqBfEAFQAgAEIAZgAzQBlcTwtyVTIyLDkLckNERBEICBsbFhYiIQZyACsyMnwvMxgvMxEzMhEzKzIyLzMrMjAxQTMVIyIuAiMiBhUVIzU0NjMyHgIBJzY2NTUzFRQGBiUVIgYGFREUHgIzMj4CNTUzFRQOAiMiLgI1ETQ2NgU1Mh4CFREUDgIjIi4CNTUzFRQeAjMyPgI1ETQuAgTDKixXiG1dLTM/gH9vPGlrff6XSyEjnTBF/royTy0aLz8mLUw5IJU1YYNOToNhNl2jAsROhGE1NWGETk2DYTWVIDhMLSZALxoaL0AFc38mMiY1OBIkbmwmMib+TzcoSCZfZiZOQHCXOXNY/t5CYkAgHDdUOOrqXo1eLjNnm2cBIoq3WpeXM2aaaP7eZ5tnMy5ejV7q6jhUNxwgQGJCASJCYkAgAAMAnP/rBnYHBAAHACAAOAArQBU0JwlyBQIBAQcHLSEICBUCchwPCXIAKzIrMhEzMzN8LzMYLzMzKzIwMUEhNSEXIRUjBzMRFA4CIyIuAjURMxEUHgIzMjY2NQEzERQGBiMiLgI1ETMRFB4CMzI2NjUDMf7HAysB/rWoC5w8bJJXV5RtPcIfOU0uR28/Ao/Bbr55Uo1nOpwiPVQxQmc7BphsbH1r+95pnmg0NGieaQQi+95CYkIgOnRYBCL73oy7XDRonmkEIvveQmJCIDp0WAADAIH/6wWuBbEABwAgADkAK0AVNCcLcgUCAQEHBy0hCAgVBnIcDwtyACsyKzIRMzMzfC8zGC8zMysyMDFBITUhFyEVIwczERQOAiMiLgI1ETMRFB4CMzI2NjUBMxEUBgYjIi4CNREzERQeAjMyPgI1AsH+xwMrA/6zqAeWNWGDTk6DYTa6Gi8/JjxeNwI7uWKrbEp9XDOWHDRGKilGNB0FRWxsf4z9KF6NXi4uXo1eAtj9KDhUNxwxY0sC2P0ofqZTLl6NXgLY/Sg4VDccHDdUOAACAHb+hAS8BcUAIQAlABlADBYSDQNyJQAAJAEJcgArzTMRMyvMMzAxZRUiLgM1NTQ+AjMyFhYXIy4CIyIOAhUVFB4DMxEjEQKiY6uJYTRQlc18pO+EAcABUJhvVYheMiA9WHK3wIidPHCavmz6h+OpXXbblmaTUEh/qGH8Tox1VS/9/AIEAAIAZP6CA+EETgAfACMAGUAMFREMB3IgAAAiAQtyACvNMxEzK8wzMDFlFSIuAjU1ND4CMzIWFhUjNCYmIyIOAhUVFB4CMxEjEQI9cbB5Pz95sHF5vm2vQW9FTG1FISFEbrK5g5hWl8NtKm3DllZnsXBDbUBDcYlHKkeLcEP9/wIBAAABAHQAAASRBT4AEwAIsQ8FAC8vMDFBAwUHJQMjEyU3BRMlNwUTMwMFBwMozwEhRf7dtqjh/t9EASXN/t5GASO8peYBJUkDK/6UrHyq/r8Bjqt7qwFtq32rAUv+aat7AAAB/GYEpv8nBfwABwAVtwYGBAQBAgIBAC8zLxEzETN8LzAxQyEVJzchJxfZ/eWmAQIcAaUFJH4B6WwBAAAB/HAFF/9kBhUAFQAStgEUFA8GgAsALxrMMjMRMzAxQTMyPgIzMhYVFSM1NCYjIg4CIyP8cCpQfGtpPG9/gD40LV1tiFcsBZcmMiZsbiQSODQmMSYAAAH9ZQUX/lQGWAAFAAqyAIACAC8azTAxQSc1MwcX/gahtAE8BRfFfIx0AAH9pAUX/pIGWAAFAAqyAYAEAC8azTAxQQcnNycz/pKiTDoBtQXcxUF0jAAACPoa/sQBtgWvAA0AGwApADcARQBTAGEAbwAAQSM0NjMyFhUjNCYjIgYBIzQ2MzIWFSM0JiMiBhMjNDYzMhYVIzQmIyIGAyM0NjMyFhUjNCYjIgYBIzQ2MzIWFSM0JiMiBgEjNDYzMhYVIzQmIyIGAyM0NjMyFhUjNCYjIgYTIzQ2MzIWFSM0JiMiBv14cXFhYnFwLTY1LAJQcnFhYnJxLDc0LLpxcWFicXAsNzQtxXFxYWJxcCw3NC39wHFxYWJxcC02NC39v3JyYWJxcC02NSyxcXFhYnFwLDc0LadycWFicnEsNzQsBPNTaWlTKD09/sNTaWlTKD09/eFTaWlTKD09/dFTaWlTKD09/rxTaWlTKD09BPJTaWlTKD09/eFTaWlTKD09/dFTaWlTKD09AAj6K/5jAWsFxgAEAAkADgATABgAHQAiACcAAEUzFwMjEyMnEzMBNTcFFSUVByU1ASc3JRcBFwcFJwEHJwM3ATcXEwf9pYkLemCUiAx6YAHYDQFN+hoN/rMFV2ECAUFE+2xhAv7ARQFdYhGUQQPFYRGVQjwO/q0GAw4BUvwmiwx8YpeLDHxiAQRjEJlE/CljEZlFBA5iAgFGRftVYwL+u0cA//8Asv6ZBbQHGQQmANwAAAAnAKEBMQFCAQcAEAR//7wAFUAOAiMEAACYVgEPAQEBXlYAKzQrNAD//wCd/pkEtwXCBCYA8AAAACcAoQCh/+sBBwAQA4L/vAAVQA4CIwQBAJhWAQ8BAQF9VgArNCs0AAAC/9sAAAP8BnIAFwAbABpADBoLGwJyABcXDQ0KEgA/MxEzLzMrzjMwMUEhMhYWFRQGBiMhETMRITI2NjU0JiYjIQEVITUBIwFFhLRcXLSE/jS5ARNQYCoqYFD+uwF0/UQC6mCma2mrZQZy+iY/ZDc1Z0UDXZiYAAACAKkAAATYBbAAAwAbACNAEQECBQADBgYFBRIQEwJyEghyACsrMhE5LzMRMzMRMzMwMUEBBwEDITUhMjY2NTQmJiMhESMRITIWFhUUBgYDaAFwbv6ROf57AYVxjEFBjHH+p8ACGaXjdnXkA9T+a2YBlP7OnUiAUkuEUfruBbByyYGMxmcAAAQAjP5gBCMETgADAAgAHgA0ACVAFAADMAECMCUaDwtyBwZyGgdyBg5yACsrKysRMzIyMhEzMzAxQQEHAQERIxEzARUUDgIjIi4CJzU+AzMyHgIHNTQuAiMiDgIHER4DMzI+AgLZAUpt/rX+27qqAuk4a5xlZ55uQQwMQm2cZmaebDe6IkduTEZnSC0LDy9HZUVLbUciAYX+imcBdgJM+vYF2v3sFXbJlFJEgrZycHi+h0dPksuRFVGPbT8wUWc3/v01YEssP26PAAACAKIAAAQkBwAAAwAJABVACgIGBgMJAnIICHIAKyvOMxEzMDFBESMRExUhESMRBCS6t/1CwQcA/hgB6P6wnvruBbAAAAIAkgAAA0MFdwADAAkAFUAKAgYGAwkGcggKcgArK84zETMwMUERIxETFSERIxEDQ7q2/gy5BXf+KgHW/sOZ/F8EOgAAAgCy/t4EfAWwAAUAHQAZQAwGBwcTEgIFAnIECHIAKysyLzM5LzMwMUEVIREjERM1MzIeAhUUDgIjJzI+AjUuAyMEMP1CwJ/Wjd2bUDx3sXUCUW9EHgE0ZppnBbCe+u4FsPzwoU6V1oiCy4xJkzlpk1plm2o2AAIAkv7kA78EOgAUABoAG0ANAAEBCxcaBnIZCnIMCwAvMysrMhE5LzMwMVM1ITIWFhUOAwcnPgInNCYmIwEVIREjEbcBCJTnhQEpWpJrMV5tLgFUkmABgP4MuQHkonHUlzeMiGcUkhhbe0ZmjEgCVpn8XwQ6AP//ABv+mQeCBbAEJgDaAAABBwJsBmEAAAALtgUbDAAAmlYAKzQA//8AFv6ZBj0EOgQmAO4AAAEHAmwFHAAAAAu2BRsMAACaVgArNAD//wCy/pYFRAWwBCYCRwAAAAcCbAQj//3//wCd/pkEgQQ6BCYA8QAAAQcCbANgAAAAC7YDEQIBAJpWACs0AAAEAKQAAAT/BbAAAwAHAA0AEQAvQBcPDg4LDAQEDAwLBwcLCwAQAwhyCAACcgArMisyEjkvMy8RMxEzLxESOREzMDFTMxEjATMRIwEzASEnIQc3ASOkwMABKJWVAiTj/i7+Fh0BswlxAerxBbD6UAQw/WsEFfzfoIem/LIABACbAAAEgAQ6AAMABwANABEALUAWDw4OCwQEDAwLBwcLCwAQAwpyCQAGcgArMisyEjkvMy8RMxEzLxEzETMwMVMzESMBMxEjATMBISchBzcBI5u5uQEelZUBwuD+Z/5UHAF+CncBm+sEOvvGA0X9xgMv/ZSihob9kAAEAEUAAAaLBbAAAwAHAA0AEQAjQBEQDw8LCgoDDgYIcg0HAgMCcgArMjIyKzISOS8zMxEzMDFBFSE1IREjESEBISchARMBNwECWf3sApvABEL9h/6qHQEAAfwt/d1sAqMFsJiY+lAFsPzfoAKB+lACqKn8rwAABAA/AAAFfQQ6AAMABwANABEAI0AREA8PCwoKAw4GCnINBwIDBnIAKzIyMisyEjkvMzMRMzAxQRUhNSERIxEhASEnMwETATcBAjr+BQJVugN//gD+/BzUAWsa/nN2AgIEOpiY+8YEOv2UogHK+8YB6ob9kP//AKn+mQWpBbAEJgAsAAABBwJsBIgAAAALtgMPCgAAmlYAKzQA//8Anf6ZBKIEOgQmAPQAAAEHAmwDgQAAAAu2Aw8KAACaVgArNAAABACpAAAHhAWwAAMABwALAA8AH0APBwYGCgIDAwwLAnINCghyACsyKzIyETMROS8zMDFBFSEnAxUhNRMRIxEhESMRB4T9dnYl/O0ewQRfwQWwmJj9jp2dAnL6UAWw+lAFsAAEAJIAAAVqBDoAAwAHAAsADwAfQA8HBgYKAgMDDAsGcg0KCnIAKzIrMjIRMxE5LzMwMUEVITUDFSE1ExEjESERIxEFav4uN/3DJ7kDZLoEOpmZ/iuWlgHV+8YEOvvGBDoAAAIAsP7eB80FsAAHAB8AGUAMCAkJFAQHAnIGCHICAC8rKzIvOS8zMDFBESMRIREjEQE1MzIeAhUUDgIjJzI+AjUuAyME/8D9MsED8taN3ZtQPHexdQJRb0QeATRmmmcFsPpQBRL67gWw/PChTpXWiILLjEmTOWmTWmWbajYAAAQAkv7kBrAEOgAUABgAHAAgACNAER4XGBgAAQELHRwGchsKcgwLAC8zKysyETkvMzIRMy8wMUE1ITIWFhUUDgIHJz4CNTQmJiMBFSE1MxEjESERIxEDjQERmu+JKVqTajFebC5Zm2X+tf3dG7kDZboB5KJx1Jc3jIhnFJIYW3tGZoxIAlaZmfvGBDr7xgQ6AAEAcf/kBaMFxQBDAB1ADjkMDCMiA3IAAQEuFwlyACsyMhEzKzIyETMwMWUVIiQmAjU1ND4CMzIeAhUVFAYGBCMiLgI1NTQ+AjMVIg4CFRUUHgIzMj4CNTU0LgIjIg4CFRUUHgIFo7v+zd53O2yXXF2XbjtkuP8AnYzlpFhCeqlnPmJFJDtvnWN4u4FEHjhSNDNROB5UpPCFoWrCAQug43XHlVNRlMp585X/vmpqvv2TrIblq2CkRn6pY65ywpBRUpLDcvhWjGc3OWiLUuh+0JVRAAEAbv/rBJ0EUABDAB1ADjkMDCMiB3IAAQEuFwtyACsyMi8zKzIyETMwMWUVIi4CNTU0PgIzMh4CFRUUDgIjIi4CNTU0PgIzFSIOAhUVFB4CMzI+AjU1NC4CIyIOAhUVFB4CBJ2d/bJfLFJ2SUl2UyxMjsJ3brWCRzNdgU8mPSwYKlBxSFCAWi8RIjEgIDIhEUOAuZGdWZ/VfGdenHM/RHqkX2l50JxWWqHXfTlmrYBInS9VdEQ7XJ52QT9wllhsPGlPLSdIYztrXp1xPgD//wA6/pkE+AWwBCYAPAAAAQcCbAPXAAAAC7YBDwYAAJpWACs0AP//ACr+mQQGBDoEJgBcAAABBwJsAuUAAAALtgEPBgAAmlYAKzQAAAMANP6hBpQFsAADAAkAEQAdQA4JDQ0ICghyBRAMAgMCcgArMjIyLysyMhEzMDFBFSE1AQMjESM1BREzESERMxED7fxHBmASrY/8ZcICzsAFsJiY+vL9/wFfoqIFsPrtBRP6UAADAB/+vwUXBDsAAwALABEAH0APAgMDDQoFBnIIBwcQBApyACsyMhEzKzIvOS8zMDFBFSE1AREzESERMxE3AyMRIzUC4/08ARK6AfK5gRKmjQQ7mJj7xQQ6/F4DovvGmP4nAUGYAP//AJf+mQVnBbAEJgDhAAABBwJsBEYAAAALtgIdGQAAmlYAKzQA//8AaP6ZBF8EPAQmAPkAAAEHAmwDPgAAAAu2AhsCAACaVgArNAAAAwCXAAAEyQWwAAMAGQAdACNAEQMDCgoVAgIVFQQcCHIbBAJyACsyKxE5LzMvETMRMy8wMUERIxEBMxEUFhYzMj4CNxUOAyMiJiY1ATMRIwMXlf4VwUKGZDxxbGkzMWFndUea3XYDccHBA/v9QwK9AbX+OXGANAoSGg+eDxoSClnGpAHH+lAAAAMAhAAAA9kEPAADAAcAGwAjQBAAABgYDQEBDQ0FCnISBAZyACsyKzIvM30vETMRMxgvMDFBESMRAREjERMVDgIjIiYmNREzERQWFjMyNjYChpUB6Ll6OHN/SoC8Zrk2aEtIf3UDG/3KAjYBH/vGBDr+D5gVIRNZtYoBPP7EWnA1EyAAAAIAiQAABLsFsAAVABkAGUAMARcGEREXGAJyFwhyACsrETkvMxEzMDFhIxE0JiYjIg4CBzU+AzMyFhYVASMRMwS7wUKFZTxxbGkzMWFndkab3Hb8j8HBAcdyfzQKEhoPng8aEgpZxqT+OQWwAAIAP//pBb4FxAAJADYAJUASBR0BAR0dBhwcCiQVA3IvCglyACsyKzIROS8zMxEzLxEzMDFTMxQWFjMVIiYmASIuAjU1ND4CFzIeAhUVITUhNTQuAiMiDgIVFRQeAjMyNjcXDgI/mDRuVoOzWgOqleaeUVSVxXKGy4lF/DYDCSVShmFUg1ovMGehcnymNy8XZJ4EOUhtPoxerfwkXKjlifmJ5adbAV2u9phxiyFdonpFSICnYPlhqYBJOByPEC8lAAL/3f/sBGQETgAIADUAJUASBBwBARwcBRsbCSMUB3IuCQtyACsyKzISOS8zMxEzLxEzMDFDMxQWMxUiJiYBIi4CNTU0PgIzMh4CFRUhNSE1LgMjIg4CFRUUHgIzMjY3Fw4CI5VjbXWfUQLhcbeDRk6Gqlt1qG00/NcCbwMeO2FHP2pMKitTd0xiiDNxI22dA1lhd4dVnvz/TYzAciqEz5BKUI/BclOXDjZpVjM1aJZiKk2HZjpQQ1k1YDwAAwCk/tYEzQWwAAMACQAhACFAEAoGBgsIBwcXFgkDAnICCHIAKysyLzM5LzMzMxEzMDFBESMRIQEhJzMBATUzMh4CFRQOAiMnMj4CNS4DIwFkwAQp/XD+2h3wAgH9rdyM3ppRPHizdwJRbkQdATNml2QFsPpQBbD85aoCcfzlp02V14l/y49LmDppkVdlmWk1AAADAJv+/QQaBDoAAwAJAB4AIUAQFhUJBnIGCgoHCwsBAwZyAQAvKxI5LzMzETMrLzMwMUERIxEhASMnMwEBNSEyFhYVDgMHJz4CJzQmJiMBVLkDf/3i5hy2AYn9sgEVme+JASlZk2oxXmwvAVmaZQQ6+8YEOv2UogHK/ZShYseWNYaCYxOSF1VyQ2Z+OgD//wAw/pkFqQWwBCYA3QAAAQcAEAR0/7wAC7YDJAYAAJhWACs0AP//ACz+mQS4BDoEJgDyAAABBwAQA4P/vAALtgMkBgEAmFYAKzQAAAEAsv5LBP8FsAAZABlADBkIchcCAhEKBQACcgArMi8zOS8zKzAxUzMRIREzERQGBiMiJic3FhYzMjY2NREhESOywQLLwU+SZh81Hg4QQw8rPSD9NcEFsP1vApH5/HKdUgcKmgYHL1c9Atb9fgAAAQCS/ksD9gQ6ABkAHUAPGQpyFwICABEKD3IFAAZyACsyKzISOS8zKzAxUzMRIREzERQGBiMiJic3FhYzMjY2NREhESOSuQHxuk2RZR41HQ8PRQ0sPSD+D7kEOv4rAdX7bXCcUAcKlAYHL1g9Aij+MQD//wCp/pkFvQWwBCYALAAAAQcAEASI/7wAC7YDFgoBAJhWACs0AP//AJ3+mQS2BDoEJgD0AAABBwAQA4H/vAALtgMWCgEAmFYAKzQA//8Aqf6ZBvoFsAQmADEAAAEHABAFxf+8AAu2AxsPAACYVgArNAD//wCe/pkGCAQ6BCYA8wAAAQcAEATT/7wAC7YDGQsBAJhWACs0AAABAF7/6wUSBcQALAAbQA0aCxEUFAslAANyCwlyACsrMhE5LzMRMzAxQTIWFhIVFRQCBgYnIi4CNTUhFSEVFB4CMzI+AjU1NC4CIyIGByc+AgKBn/WnVl2l2n2U4phNBD78gytgnXJimGk2NXCwfIKwOy8YaqcFxGe7/v+bXpv+/rpmAVyu9Zh8lSJdonlFVJXEcF5xxJVUOByPEDAlAAIAaP/rBCwFsAAHACUAH0APBQgIBCUlABwSCXIHAAJyACsyKzIROREzMxEzMDFTIRcBIzUBIQE3MhYWFRQOAiMiLgI1MxQWFjMyNjY1NCYmIyOUA2sB/gtxAYP9dwEGlqHjeEmEtGtXp4lRwUZ9VF+GR0qRaY4FsHz9rHQBvv5BAWjHj2afbTkxZ6FwSXpJRXlMaYU+AAIAav51BCkEOgAHACUAH0AOCAUFBCUlABwYEgcABnIAKzIvzDMSOS8zMxEzMDFTIRcBIzUBIQEzMhYWFRQOAiMiLgI1MxQWFjMyNjY1NCYmIyOUA2UC/hp8AXP9iAEFkaHleUmDs2tWp4dRuUeAVWGHSEyTao0EOnb9pXQBxP43ZsWOZp5tOTFnoW9KfEpGek5qhD0A//8AOf5LBHQFsAQmALFEAAAmAkGqQAAHAm8A8QAA//8AOv5LA5cEOgQmAOxPAAAmAkGrjQAHAm8A4QAA//8AOv5LBQ8FsAQmADwAAAAHAm8DpwAA//8AKv5LBB0EOgQmAFwAAAAHAm8CtQAAAAEAVwAABGUFsAAYABK3AwAACxANAnIAKy8zOS8zMDFBIRUhIgYGFRQWFjMhETMRISImJjU0PgICRQGM/nRrhT09hWsBX8H94J/dckB+uANznk5/SUmFVAUT+lB0yYBhoHVAAAACAFoAAAZnBbAAGAAtAB9ADhsLCxAlJQMAABoQDQJyACsvMzkvMzMvETMRMzAxQSEVISIGBhUUFhYzIREzESEiJiY1ND4CASM1Nz4CNzYuAiczHgIHDgICSAGN/nNrhD09hGsBYMD94KDcckB+uALxjY1KYzQCAQgPFw+6Eh8UAgJ1vQNznk5/SUmFVAUT+lB0yYBhoHVA/I2cAQFDeVEnU1ZTJzRvcTaOvl8AAwBk/+kGbwYYABYAKwBHAB1AEDNEC3I7LQFyHRILcicGB3IAKzIrMisvKzIwMVM1ND4CMzIeAxcVDgMjIi4CNxUUHgIzMjY2NzUuAyMiDgIBETMRBhYWMz4DNzYmJzMWFgcOAyMGJiZkOGueZk59YEQqCQs8ZpRjZJ1sOLogQ2tLXHdIFAwtR2dGTGtEIAINugEqTTVGa0onAQIhHrQbKgICTYWqX2ucWAH1FYDUm1UuWH6gYFx3vodHTYy/hxVNhWM4T4BL8TdnUTBCdpn++AS/+0FAYDYBOGiSW2TLZGHLZ4vPiEQCSqMAAgA2/+kF1AWwACAARgAhQBAoJycCAQEOMkMJcjoNDgJyACsyLysyETkvMzMRMzAxQSM1MzI2NjU0LgIjITUhMh4CFRQOAwciBgYHBgYTNTU0JiYjNzIeAhUVFBYWMz4DNzYmJzMWFgcOAyMGJiYBwsOQcotAIklzUf6ZAWd4uX1BHjpVcEUDBwcDKBjpPXFPEnulYiojQy48XkAjAQIiHrsaKwICSXygWWWVUwJ5njlyVTlcQyOeNWiZZThiU0ExEA0MAQoE/rMCQU51Qm02Y4dQRTFMLAE4aJBYZMtkYctnis6JRQJCkQAAAgAx/+QE6QQ6AB0AQgAlQBI+PT0bAgEBDSoqIjMLcgwNBnIAKzIrMjIvETkvMzMzETMwMUEjJzMyNjY1NCYmIyEnITIWFhUUDgIHDgIHBgYFNQYWMz4DNzYmJzMWFgcOAyMGLgInNTQmJiM3MhYWFQF07AK8VGgxMmtV/voGAQyJv2QlSGtFAgUFAyIQAVwBKDc4VTsgAQIhILQaLAICRXWUUkNmRiUDMF5FI4udQQG6lihKMTNQL5VMkGUyUkAwEQEUFAIHA+oBJzIBKUxsRE2lTU2iUHCobzcBGjpdQUwwRCRrQ3RLAAMAU/7WA/YFsAAfADQAPwAfQA46OT8sDA0CciEgIAEBAgAvMxEzETMrMi8zLzMwMUEjNTMyNjY1NCYmIyE1ITIWFhUUDgMHIgYGBw4CBzcyFhYVFRQWFhcVIy4CNTU0JiYBFRQGByc+AjU1AYzconeOQD6Gbf7tAROf2nEdOVVvRAMIBwMaGREOEaa8Tg0eGb4eGwZAdgIZXFNpICwXAnmYPHRTUHRAmF64iDhhUkIxEAwLAQYGAwRtX6hsiClOQhkZHFxbGoRPd0L+XJVby0RJLFthNpgAAAMAef7GA9kEOgAeADMAPgAeQA44IB8fAgEBPisKDA0GcgArMj8zOS8zMxEzLzAxQSE1MzI2NjU0JiYjITchMh4CFRQOAgcGBgcOAgc3MhYWFRUUFhYXFSMuAjU1NCYmBRUUBgcnPgI1NQHM/vbUVmowMGpW/uMBARxmnm44JUhrRgQJBBYTDSglip1BChoXvxsWBTBeAeFbU2ogLBcBuZYoSjI0UC2WK1N3TDNSQTAQAScCBAYEAmtIflFhGDs1ERMSRkUQXzZNKvSVW8tESSxbYTaYAAADAEX/6wdxBbAAEQAVADIAHUAOJiYeLwlyFxQAFQJyCwgALzMrMjIyKzIyLzAxQTMDDgQjIzU3PgQ3ARUhNQERMxEUHgIzMj4CNzYmJzMWFgcOAyMiJiYBisAhByE8YIthNCg4UTkkFQYC3/2CAlnBFyw+J0RpSCcBAiEeuxsqAgJOhKtfbaJaBbD9N5rxsXM4nQMEK1iMy4gCqp6e+6sEVfurL044HjhnkFpky2Rhy2eLz4hESqIAAwA//+sGOgQ6ABEAFQAzAB9AECcnHi8LchcUABUGcgsICnIAKzIrMjIyKzIyLzAxQTMDDgQjIzU3PgQ3ARUhNQERMxEUHgIzMj4CNzYmJzcWFgcOAyMiLgIBPLkcBx42T25IOikqPSobEAQCKf4UAcy6Fy0+JzhWOyABAiEdsxorAgJFdJZTUIJeMwQ6/fZ5uYRTJ6MDAyJDapJhAc+Zmf0fAuH9HzBPOR4yXIJRX8BeAV3AYX++fj4pWIsAAAMAqv/pB3EFsAADAAcAIwAgQBEWFg4fCXIIAnIAAwMGCAQCcgArPzkvMysrMjIvMDFBIRUhAzMRIwEzERQWFjM+Azc2JiczFhYHDgMjBiYmJwFNAvj9CKPAwAN/wChMNERpSScBAiIeuhsrAgJOhKtfbJ5YBgMfngMv+lAFsPurPmA1ATdnkFpky2Rhy2eLz4hEAkqkhAAAAwCQ/+oGTQQ6AAMABwAlACJAEhkZECELcgkGcgMCAgUHBnIFCgA/KxI5LzMrKzIyLzAxQRUhNRMRIxEBETMRFB4CMz4DNzYmJzcWFgcOAyMGLgIDXf3FKLoCs7oXLD8nOFc7IAECIh2zGiwCAkR1llRQf1wzAmSWlgHW+8YEOv0fAuH9HzBPOB8BMVyCUV/AXgFdwGF/vn4+AShYjQABAHb/6wSiBcUAKwAVQAoSCwNyJSUdAAlyACsyMi8rMjAxRSIuAjURND4CMzIWFwcmJiMiDgIVERQeAjM+Ajc2JiczFhYHDgICuYHVmlNTmtWBc65CO0CRV1uPZDQ0ZI9bXoJEAgIdF7sTJwICiNwVXafhhQEGheGnXSwriyEjSH6mXv74X6d/SAFHgVlZt1hYtVuXxmIAAAEAZv/rA8cETgArABVACiEaB3IHBwAPC3IAKzIyLysyMDFlPgI3NCYnMxYWBw4CIyIuAjU1ND4CMzIWFwcmJiMiDgIVFRQeAgJRR1EjAQkLsgsRAQJip2p2t35APnivcWCNLCwueUZMbEUgI0l1gwEqSzQ4ezk6dzttj0ZXl8NsKmzDllciH5AbHkRxikUqRopxRAACACT/6QVIBbAAAwAgABdACxQUDB0JcgUCAwJyACsyMisyMi8wMUEVITUBETMRFB4CMz4DNzYmJzMWFgcOAyMGJiYEpPuAAdvBFiw+J0VpSCYCAiIeuxsrAwJNhKtgbJ1ZBbCenvurBFX7qy9NOB8BN2eQWmTLZGHLZ4vPiEQCSqQAAgBG/+oEuAQ6AAMAIAAXQAsTEwscC3IFAgMGcgArMjIrMjIvMDFBFSE1AREzERQWFjM+Azc2JiczFhYHDgMjBi4CA9H8dQFnuSlONThWPCABAiIdshosAgJFdJZTUIBcNAQ6lpb9HwLh/R9AYDYBKU1tRE+nT0+kUnGpbzcBKFiNAAIAl//rBP8FxQAgAD8AI0ARACI/PwICFzUxLANyEQ0XCXIAKzLMK8wzEjkvMxI5OTAxQTMVIyIOAhUUHgIzMjY2NTMUDgIjIi4CNTQ+AgUjIi4CNTQ+AjMyFhYVIzQmJiMiBgYVFB4CMzMCw7+5WopdMDNij1tsolrAXp/FZn7Sm1VKjs8BRL95xI1MTpLMfpHykcBbml99oEwnVIRcuQMQeR9AY0M5YUgoSXpJcKFnMTltn2ZbjWAyVTlkhEtmmmk1YrV9SG8/RXNFNllCI///ADD+SwWtBbAEJgDdAAAABwJvBEUAAP//ACz+SwS8BDoEJgDyAAAABwJvA1QAAAADAI//6wTPBcQAAwAYADIAKEAUECcnDwAECiUlCh0wCXIUCgNyAggAPysyKzIROS8SOTkzMxEzMDFBESMRFyM0PgIzMhYXASM1ASYmIyIOAhM3FhYzMjY2NTQmJiMjNTMyFhYVFAYGIyImAUi5ubk3b6pyo/Nh/lZmATQwhmVSaDkWgzUpckhhiUlKk22Ul6PleH7ekEaLA8H8PwPBAoDCgkGEXP34dwF1Jj46ZYT8FJkTIEZ7UGeDPpNmxI2IwGUYAAIAcARxAskF1wAFAA8AErYFBQ0HAgIHAC8zLxDNMi8wMUE1EzMVAyU1MxUUFhcHJiYBknTD3/6GpyoqSVZcBIQRAUIV/sL+VU9IaC06LY///wAmAh8CDgK3BAYAEQAA//8AJgIfAg4CtwQGABEAAAABAKICiwSMAyMAAwAIsQMCAC8zMDFBFSE1BIz8FgMjmJgAAQCQAosFyAMjAAMACLEDAgAvMzAxQRUhNQXI+sgDI5iYAAIADf5qA6EAAAADAAcADrQCA4AGBwAvMxrOMjAxRRUhNSUVITUDofxsA5T8bP6YmP6YmAABAGEEMQF4BhQACgAIsQUAAC/NMDFTNTQ2NjcXBgYVFWEpTjdpLjIEMXk9hXstSUKLUXwAAQAwBBYBSAYAAAoACLEFAAAvzTAxQRUUBgYHJzY2NTUBSClON2ovMQYAgDyFey5JQotRgwAAAQAk/uUBPAC2AAoACLEFAAAvzTAxZRUUBgYHJzY2NTUBPClON2ovMLZnPIV7LkhCjFFqAAEATwQWAWcGAAAKAAixBgAAL80wMVMzFRQWFwcuAjVPuDEvaTdPKQYAg1GLQkkue4U8AP//AGkEMQK7BhQEJgGFCAAABwGFAUMAAP//ADwEFgKHBgAEJgGGDAAABwGGAT8AAAACACT+0gJkAPYACgAVAAyzEAULAAAvMs0yMDFlFRQGBgcnNjY1NSEVFAYGByc2NjU1ATwpTjdqLzAB4SlON2ovMPanQIyBMElHlFaqp0CMgTBJR5RWqgAAAgBGAAAEJAWwAAMABwAVQAoGBwcCAwJyAhJyACsrETkvMzAxQREjEQEVITUCkLkCTfwiBbD6UAWw/oqZmQADAFf+YAQ0BbAAAwAHAAsAHUAOCwoGBwcBAwoScgMCcgEALysrERI5LzMRMzAxQREjEQEVITUBFSE1Ap65Ak/8IwPd/CMFsPiwB1D+ipmZ/F6YmAABAIsCGAIjA8sADQAIsQQLAC/NMDFTNTQ2MzIWFRUUBiMiJottXl9ubV9ebgLcKVZwcFYpVW9v//8AlP/0Ay8A0gQmABIEAAAHABIBuQAA//8AlP/0BM4A0gQmABIEAAAnABIBuQAAAAcAEgNYAAAAAQBSAgIBLQLWAAsACLEDCQAvzTAxUzQ2MzIWFRQGIyImUjg1Njg4NjU4AmstPj4tLD09AAcARP/rB1cFxQARACMANQBHAFkAawBvAClAE19WVjJoTU1EKSk7Mg0XDg4gBQUAPzMzLzM/MzMvMzMvMxEzLzMwMVM1NDY2MzIWFhUVFAYGIyImJjcVFBYWMzI2NjU1NCYmIyIGBgE1NDY2MzIWFhUVFAYGIyImJjcVFBYWMzI2NjU1NCYmIyIGBgU1NDY2MzIWFhUVFAYGIyImJjcVFBYWMzI2NjU1NCYmIyIGBgEBJwFESIZcXoZHR4VdXYZJiyNINjZHIiNHNzVHIwJoSIZcWH1DQ3xXXYZJiyNINjZHIiNHNzVHIwFSRH5WXoVIR4VdV39EeCRHNjZGIyNHNzVHI/7p/TlpAscES01TiFJSiFNNUYhSUoieTS5SMzNSLk0vUzMzU/xQTlKIUlKIUk5SiFJSiKBOLlMzM1IvTi9SMzNSfU5SiFJSiFJOUohSUoigTi5TMzNSL04vUjMzUgNN+45CBHIAAAIAbACZAiEDtQAEAAkAEkAJAQUDCQIIBgYAAC8vFzkwMUEBJzUBAwEjATUCIf77sAEndwEFjv7ZA7X+bgENAYT+d/5tAYUNAAIAWgCZAg8DtQAEAAkADrQCCAgFAAAvLzkvMzAxdwEXFQEDMwEVB1oBBbD+2Y6OASewmQGSAQ3+fAMc/nsNAQABADwAbwNrBSMAAwAOswADAgEAfC8zGC8zMDFBAScBA2v9OWgCxwTh+45CBHL//wBRApACngW7BgcB4gAAApv//wA2ApsCvAWwBgcCOwAAApv//wBcApACqAWwBgcCPAAAApv//wBWApACrAW6BgcCPQAAApv//wA7ApsCpgWwBgcCPgAAApv//wBPApACnwW7BgcCPwAAApv//wBKApQClQW7BgcCQAAAApsAAgBQAo8C6AVQAAMABwAVtwYGAgIDBwcDAC8zLxEzETN9LzAxQRUhNQERIxEC6P1oAY6EBDCCggEg/T8CwQABAFADsgKoBDQAAwAIsQMCAC8zMDFBFSE1Aqj9qAQ0goIAAgBQAzYCqASlAAMABwAMswIDBwYALzPOMjAxQRUhNSUVITUCqP2oAlj9qAO4goLtgoIAAAEAVAGPAaEGTQAVAAyzEBEGBQAvMy8zMDFTNTQ2NjcXDgIVFRQeAhcHLgNUX4Q3MyhPNB4yPR4zKmFXOAPlEaf1nB90JX28hBNqnHJRHm4XYpfJAAEAUAGPAZ0GTQAVAAyzEBEGBQAvMy8zMDFBFRQGBgcnPgI1NTQuAic3HgMBnV+ENzMpTjQeMj0eMylhWDgD9hGn9pofbih3u40TY5t0VBx0F2SWyQAAAgB6AosC+QW6AAQAGQATtxYLBAQLAhECAC8zPzMvETMwMUERIxEzEwc0PgIzMhYWFREjETQmJiMiBgYBJKqBEi4mSWdAT3VAqiRBLD1PJQUA/YsDIP6LAVSOaTo/iGz+BAHcSVUlQW4A//8AUf6FAp4BsAYHAeIAAP6Q//8Ae/6RAe8BpgYHAeEAAP6R//8AQv6RAqsBsQYHAeAAAP6R//8AP/6GApsBsQYHAjoAAP6R//8ANv6RArwBpgYHAjsAAP6R//8AXP6GAqgBpgYHAjwAAP6R//8AVv6GAqwBsAYHAj0AAP6R//8AO/6RAqYBpgYHAj4AAP6R//8AT/6GAp8BsQYHAj8AAP6R//8ASv6KApUBsQYHAkAAAP6R//8AUP6pAugBagYHAZ0AAPwa//8AUP/MAqgATgYHAZ4AAPwa//8AUP9QAqgAvwYHAZ8AAPwaAAEAVP3nAaECZgAUAAixBRAALy8wMXc1NDY2NxcOAhUVFBYWFwcuA1RfhDczKE80NE8oMyphVzgeEZ7pkx10InWvfBOErm8mbxZejr4AAAEAUP3pAZ0CZgAUAAixEAUALy8wMWUVFAYGByc+AjU1NCYmJzceAwGdX4Q3MylONDROKTMqYVc4OhGh7ZUdbyZxsocTeatyIXQVXIy7AAQAWwAABGgFxAADAB4AIgAmACJAECIhJSYmARsXEgVyCQICAQwAPzMRMyvMMxI5LzPOMjAxYSE1IQETFgYHJz4CNQM0NjYzMhYWFSM0JiYjIgYGARUhNQEVITUEaPv3BAn9SxYBODiuIykRFnTJf4O4YsBDbD5Caz8BY/1FArv9RZ0Dcv2DXqMpNQlTbCwCforDaGKvdFRmLkF9/vB9ff76fX0AAwAfAAAGNwWwAAMABwARACJAEAMCBgsOEAcHDREOBHIKDQwAPzMrMhI5LzkSOTPOMjAxQRUhNQEVITUBESMBESMRMwERBjf56AYY+egFOMH9I8HBAuADrZiY/tSYmAMv+lAEY/udBbD7mgRmAAADAKf/7AYDBbAAFwAbAC0AI0ASIikNHBkYBnICAQEODA8Ecg4MAD8rMhI5LzMrMsw/MzAxQSM1MzI2NjU0JiYjIxEjESEyFhYVFAYGARUhNRMzERQWFjMyNjcXBgYjIiYmNQIh6up0dyoqd3TBuQF6pcxeXswDOP24xbkiNh8XMw0BFkcxRHJEAjWYVIZKS4dV+ugFsHTJgIDKdAIFjo4BB/vLNzgSCQOXBw02f2wA//8Aqf/sCBEFsAQmADYAAAAHAFcEVQAAAAYAHwAABcwFsAADAAcADQASABcAHQAqQBQdFQoKEgYHAwICERIEchMbGwgRDAA/MzMRMysSOS8zzjIRMxEzMzAxQRUhNQEVITUBExMzAwMBExMjAQETEzMBARMTIwMDBcz6UwWt+lMBi0Oxg0O0/tO7NXv+ywPDNLbB/sr+3bFAhq4/A9SXl/6ml5f9hgHYA9j+J/wpBbD8LP4kBbD6UAHdA9P6UAWw/Cv+JQPbAdUAAgCMAAAFnwQ6ABEAIgAgQA8WExMRFAgUCBEKHA8ABnIAKzIyPzk5Ly8RMxEzMDFTITIeAhURIxE0LgIjIREjISERMxEhMjY2NREzERQOAowCL1CAWzC6HDdQNf7CugO4/dK5AT5HYDK5MFuABDorXptw/rcBS0VgOxr8XgLe/bowblwCqP1acJteKwADAF//7AQdBcQAIwAnACsAHUAOKisnJiYHGRIFcgAHDXIAKzIrMhI5LzPOMjAxZTI2NxcGBiMiLgI1ETQ+AjMyFhcHJiYjIg4CFREUHgITFSE1ARUhNQMvOm4yFDh6PnfGkE9OkMV4P3U9FDFwOlCBWzAxXIFy/Q0C8/0NiBIQoA4QSZHZkQFNktqSSREOoRATNGigbP6xbKBoNAMXfX3++3x8AAMAHwAABbwFsAADAAcAHwApQBMGBwMCAhQKFBcJCgoWFwRyFgxyACsrEjl9LzMRMxESORgvM84yMDFBFSE1BRUhNQEhNSEyNjY1NCYmIyERIxEhMhYWFRQGBgW8+mMFnfpjAt/+ewGFcYxBQYxx/qjBAhml5HZ25AS9mJj1mJj+c51IgFJLhFH67gWwcsmBjMZnAAADACsAAAP5BbAAAwAcACAALUAVHyAgEQMCBQYGGgIaAhoEEBEEcgQMAD8rMhI5OX0vLxEzETMRMxEzETMwMUEHITcBASczMjY2NTQmJiMhNzMyFhYVFAYGIwEVEwchNwP5LvxgLgIA/e8B9GqLRkKNcv74L9mu43Bd1bQB7L0u/RQuBEyenvu0Amp8R3pMVYFJnmnIjnrBbv3EDAWwnp4ABAAh/+0EGwWwAAMAFAAYABwAFUAJBAQDDwELDQMEAD8/MzMSOS8wMUERIxEBMxUUAgYGIyImJzcyPgI1AxUBNQUVATUB1cACR79TmtiFL10wvGCTZDSM/VECr/1RBbD6UAWw/VNYo/78t2ALCJFFiMmEAniy/sayErH+xrEAAgBdAAAE6wQ6ABsAHwAYQAsIFRUeHwZyDgEeCgA/MzMrEjkvMzAxYSM1NC4DIyIOAhUVIzU0EjY2MzIeAxUBESMRBOu5IkNhfUxakmg4ulWb1YFqtY9lNf4Vurxpq4FYLEWIyIS8uqQBBLZgPner24MDgPvGBDoAAgAfAAAFBAWwABcAGwAaQAwZGAMAAA4MDwRyDgwAPysyEjkvM84yMDFBITUhMjY2NTQmJiMhESMRITIWFhUUBgYHFSE1Awj9FwLpbYxDP4ty/qbAAhql4nV14rH9IwI7nUaAV0eCVPruBbBxx4GMx2mJnp4AAAQAe//rBYMFxQAhADMARQBJACVAEkInMEdHOTANch8FDklJFg4FcgArMjIvEMwyKzIyLxDMMjAxQTMUBgYjIiYmNTU0NjYzMhYWFSM0JiMiBgYVFRQWFjMyNgE1NDY2MzIWFhUVFAYGIyImJjcVFBYWMzI2NjU1NCYmIyIGBhMBJwECHotCe1dXfkVEflZXfEOLREcvPx8gQC9HQgEQSIZcXoVIR4VdXYZJiyNINjZHIiNHNzVHI8z9OWgCxwQeRXRFUohRTVOIUkZ0RjVTM1MvTS5SM1f9KE5SiFJSiFJOUohSUoigTi5TMzNSL04vUjMzUgNN+45CBHIAAAEAaP/rA2sGEwAuABS3GRgYASQMAAEALzMvMxI5LzMwMWUVIi4CNRE0PgIzMh4CFRUUDgMjNTI+AjU1NC4CIyIOAhURFB4CAsxmmGQyKExsRDtiSihCgLvylJrejUQMFx8TGycbDRYyVImeQHenZgLpWYxiNCtTdEopZ9nKoV+wdbnQWispPCYTGzhSOP0XRWxNKAAEAKIAAAfGBcAAAwAVACcAMQAlQBErMC4qAgMbEiQJCTEuBCotDAA/Mz8zMy8z3DLOMhESOTkwMUEVITUDNTQ2NjMyFhYVFRQGBiMiJiY3FRQWFjMyNjY1NTQmJiMiBgYBESMBESMRMwERB6X9mCNUmWlqmVNSmWlqmlSjJ1E9PE8nKE89PFAn/rzM/a+6zAJTAiuOjgHaY2ebVlabZ2NnmlZWmspjPVwzM1w9YzxcNDRcAQz6UARu+5IFsPuPBHEAAAIAaAOXBDgFsAAMABQAJEARCQQBAwYKBwcTFAIAAwMGBhEALzMRMxEzPzMzETMSFzkwMUERAyMDESMRMxMTMxEBFSMRIxEjNQPeizSMWnCQj3D9spRbkwOXAYv+dQGK/nYCGf5yAY795wIZUf44AchRAAIAmP/sBJMETgAdACYAF0AKIhcXBB4OBxsECwA/Mz8zEjkvMzAxZRcGBiMiLgI1ND4CMzIeAhUUFBUhERYWMzI2ASIGBxEhESYmBBQCVLxibb6QUVmWu2Jns4hN/QA3jE5du/7oS405Ahw0isZoND5YmsxzdMuaWFGSxXUDEhr+uDM7OwNpQjj+6wEeND0A//8AVP/1BbMFmwQnAeH/2QKGACcBlQDmAAABBwI/AxQAAAAHsQYEAD8wMQD//wBl//UGUwW0BCcCOgAmApQAJwGVAaUAAAAHAj8DtAAA//8AZP/1BkkFpAQnAjwACAKPACcBlQGDAAABBwI/A6oAAAAHsQIEAD8wMQD//wBa//UF/QWkBCcCPgAfAo8AJwGVASAAAAEHAj8DXgAAAAexBgQAPzAxAAACAGr/6wQzBewAKQA/ABlADCoAABI1HwtyCRIAcgArMisyETkvMzAxQTIWFy4EIyIGBgcnPgIzMh4CEhUVFA4DIyIuAjU1ND4CFyIOAhUVFB4CMzI+AjU1LgMCPVymOggwR1tpOTVeWy8QJVZyUG6whFgsKlJ2mFxys31BP3mtgE1xSSQkSHFMTnFKJAUmRm0D/k1DWJR1USsOGhKWER8VS4/L/wCWO2/FoXZAUI/BcRZptIVKmDdfekQWTIhpPEd+qGFDGUdELgAAAQCp/ysE5gWwAAcADrUEBwJyAgYALzMrMjAxQREjESERIxEE5rr9N7oFsPl7Be36EwaFAAMARv7zBKwFsAADAAcAEAAfQA4OBgYHBw8CcgwDAwoCCwAvMzMzETMrMhEzETMwMUUVITUBFSE1ARUBIzUBATUzBKz74wPQ/A4C/v09YgJg/aBidpeXBiaXl/yqGfyyjgLNAtOPAAEAqAKLA+sDIwADAAixAwIALzMwMUEVITUD6/y9AyOYmAADAD///wSZBbAABAAJAA0AFkAKCQsLCgQICAECcgArPzMvMxEzMDFlATMBIwMTFyMBBzUhFQIjAbi+/eJ7hsUpev7PfgEz9gS6+k8DD/3o9wMPmZmZAAQAY//rB8wETgAXAC8ARwBfAB1ADls2Nh4TC3JOQ0MrBgdyACsyMhEzKzIyETMwMVM1ND4CMzIeAxcVDgQjIi4CNxUUHgIzMj4DNzUuBCMiDgIFFRQOAiMiLgMnNT4EMzIeAgc1NC4CIyIOAwcVHgQzMj4CY0WAsm1so3dQMQ0NMVB2o2tus4BFuSdNcElHb1Q5IgYGIjlUcUdIcEwnBrBGgLNta6N3UDEMDTFQd6NsbLKBRbkoTG9ISHBUOiIGBiI6U3BHSHBNKAIPG23FmlhVhpWFJyonhZaGVViaxYgbUY9uPj9ibF4aKhldbGM/P26PUBttxZpYVYaWhScqJ4WVhlVYmsWIG1CPbj8/Y2xdGSoaXmxiPz5ujwAAAf+v/ksCjgYVAB8AELcbFAFyCwQPcgArMisyMDFFFAYGIyImJzcWFjMyNjY1ETQ2NjMyFhcHJiYjIgYGFQFmTZBlHzkdEw4yEDFEJVKYaSRHJBcRLR07UilrcJNHCQqSBAkmTz0FGXWgUgwJjgUGMVxCAAACAGUBGAQMA/UAGQAzABtACxcEgAoRQDEegCQrAC8zGt0yGt4yGs0yMDFTJzY2MzYWFxYWMzI2NxcGBiMiJicmJgciBgMnNjYzNhYXFhYzMjY3FwYGIyImJyYmByIGZwEvhUFQWz87VUpBfC8BL3xBSlU7P1xQQYQwAS+FQVBbPztVSkF8LwEvfEFKVTs/XFBBhALIvTM7AisgHihEPL0zOiceICsCRP4jvTM6AisgHidEPL4zOiceICwCRAAAAwCYAJwD2gTVAAMABwALAB9ADQIBAQoKCwADAwcHBgsAL84yETMRMxEzETMRMzAxQQEnARMVITUBFSE1A4/9q18CVar8vgNC/L4EmvwCOwP+/vqhof5hoaEAAwA9AAEDgARGAAQACQANACJAEAMHBgAECAYFCQkBAgINDQwALzN8EM4vMjIYLzMXOTAxUwUVATUlAQc1ARMVITXHArP8zgMy/U6AAzIG/L0Cw/6yAVhpwP7+DGkBV/xTmJgAAAMAhAAAA90EWgAEAAkADQAiQBADBwYABAgGAQICBQkJDQ0MAC8zfBDOLzIyGC8zFzkwMUElNQEVBQE3FQEFFSE1A079OQNW/KoCyY38qgNA/L0Csfyt/qlqxgEBFGr+qI6YmAACACwAAAPdBbAABwAPAB1ADgUICA4HEnIDCgoLAQJyACsyMhEzKzIyETMwMVMBMwcBARcjNwEBJzMBASMsAZB7Ef7EAUIOeiIBPP6+DXoBlP5wewLXAtmF/az9rYSEAlMCVIX9J/0p//8AtQCmAZsE9gQnABIAJQCyAAcAEgAlBCQAAgBvAnkCMwQ6AAMABwAQtgYCAgcDBnIAKzIyETMwMVMRIxEhESMR+4wBxIwEOv4/AcH+PwHBAAABAF3/XgFXAO8ACQAKsgSACQAvGs0wMWUVFAYHJzY2NTUBV0dKaSUl709Ptj1JOXhGUQD//wA9AAAE9wYVBCYASgAAAAcASgIsAAAAAwAgAAADzQYVABAAFAAYABtADxgGFwpyExQGcg0GAXIBCgA/KzIrMis/MDFhIxE0NjYzMhYXByYmIyIGFRcVITUhESMRAYS5YLJ6SIpJHy55SHdp3f2/A625BJh7qlgjGpwSIWtsXo6O+8YEOgADAD0AAAPqBhUAEgAWABoAG0APGRoGchQAcg4GAXITAQpyACsyKzIrKzIwMWEjETQ2NjMyFhYXByYmIyIGBhUBETMRARUhNQGhuVeldiyFl0hWX5g1QVktAZC5/p39tgSsdaFTEhwPhhITL1pC+1QF2PooBDqOjgAFAD0AAAYzBhUAEQAVACYAKgAuACVAFCMcAXIuKhQVBnINBgFyLRcXAQpyACsyETMrMisyMjIrMjAxYSMRNDY2MzIWFwcmJiMiBgYVFxUhNQEjETQ2NjMyFhcHJiYjIgYVFxUhNSERIxEBoblVoG4gQR8KFTUaO1Us8P2sA625X7J6SYpJIC16R3dp3f2/A625BKx1oVMICJcFBC9aQnKOjvvGBJh7qlgjGpwSIWtsXo6O+8YEOgAABQA9AAAGMwYVABEAFQAoACwAMAApQBcrAHIkHAFyLhQULRUGcg0GAXIpFwEKcgArMjIrMisyMhEzKzIrMDFhIxE0NjYzMhYXByYmIyIGBhUXFSE1ASMRNDY2MzIWFhcHJiYjIgYGFQERMxEBFSE1AaG5VaBuIEEfChU1GjtVLPH9qwOtuVeldiyFl0hWX5g1QVktAZC5/p39tgSsdaFTCAiXBQQvWkJyjo77xgSsdaFTEhwPhhITL1pC+1QF2PooBDqOjgAABAA9/+wEmwYVAAMAFwAbAC0AJUAUIikLchMKcgkcHA0NBAFyGAIDBnIAKzIyKzIRMxEzKysyMDFBFSE1ATIWFxUjNSYmIyIGBhURIxE0NjYBFSE1EzMRFBYWMzI2NxcGBiMiJiY1AYL+uwH9Wd1cuR5xLTtRKrlSlwLF/bfGuSI2HxczDQEWRzFFcUQEOo6OAds2LtF5EBQyXUL7VASsdaFT/iWOjgEH+8s3OBIJA5cHDTZ/bAAEAF//7AZVBhIAGwAfADEAZwAxQBs7MkBkYFsLcgFFSUAHciYtC3IeEB8GchQKAXIAKzIrMjIrMisyzDIrzDMSOTkwMUEjLgI1ND4CMzIeAhUjNCYmIyIGFRQeAiUVITU3MxEUFhYzMjY3FwYGIyImJjUFNCYmJy4DNTQ+AjMyFhYVIzQmJiMiBgYVFB4CFx4CFRQOAiMiJiY1Mx4CMzI2NgOyZiBSOzNfg1B3l1MguShYSFhcHiYeAp39wby5IjceFzQNARZHMkRyRP43I2trWpFlNjlplFuCuGK5NWVJTV8rFTZiTIWsVDtvmV+Pxma6BFB0OUxnNgL8YaqdTT1pTyxJdIc+RGg7WEY8aWt97o6OWPyXPkUbCASXBw0/jHMLKEU5FRM0SmRDQHJYMlyZXS1VOC9IKB4vJyIRHlR6V0d2VS9molpMWSUoRgAAFQBb/nIH7gWuAAUACwARABcAGwAfACMAJwArAC8AMwA3ADsAPwBDAEcAVwBzAIwAmgCoAABTIxEhFSMhIzUhESMBIREzFTMFITUzNTMBITUhBSE1IREhNSEBFSM1ExUjNQEhNSEBFSM1ASE1IQUhNSEBFSM1ExUjNQEVIzUHETMRFAYjIiY1MxQWMzI2JSMnMzI2NTQmIyMRIxEzMhYWFRQGBgciBgcGFAcjNzMyNjU0JiMjNzMyFBcUFjEeAhUUBgEVFAYjIiY1NTQ2MzIWBzU0JiMiBhUVFBYzMjbMcQE1xAazxwE2b/oR/stxxAZe/srHb/5R/uoBFvzg/uwBFP7sARQEz29vb/0w/usBFfwdcQRU/usBFQGQ/uoBFvqNcXFxB5Nv6FxrUFhtXTgwKTb9wpYBdjs7OztdX7xCXzMiQS8BBAIMDrkwiTQzMzR3AZcODAcrOh5p/oR/ZmeBgGZngFxKQUBKS0FASQSRAR10dP7j+eEBO8pxccr+xXFxcQZXdPt0+fkC8vr6+l5xAj/5+QQYdHR0/O78/AF4+vr+iPz88wF6/oZPXFFTLi03ckYpJyke/i8CJSBCNCI4JAQTAQQB9EssJycvRgEFARMEJjkiTE8BSHBhenphcGF6etFwRE9PRHBFTk4ABQBc/dUH1whzAAMAHgAiACYAKgAAUwkCAzM0Njc2NjU0JiMiBgczNjYzMhYVFAYHDgITNSMVEzUzFQM1MxVcA7wDv/xBd8oZKURip5V/sQLLAj4nODk1KC89HcnKfwQGBAKDA8/8MfwxAt4zPhslgVKAl32NNzBANDRNGiE6Tv67qqr9SAQECpoEBAABAEIAAAKrAyAAHAAQtQMcHAsTAgAvzDIzETMwMWUVITUBPgI1NCYjIgYVIzQ2NjMyFhYVFAYGBwcCq/2qASAtNBdAO0tHnkiGXlqARC9WO6+AgGwBDypCNRYwPkw5SHZHOmlJNVxcNZIAAQB7AAAB7wMVAAYAI0AVBAUFAwMvAH8AAg8AXwCvAP8ABAABAC/NXXEyETMRMzAxQREjEQc1JQHvnNgBYgMV/OsCWTmBdAAAAgBR//UCngMgABEAIwAMsxcOIAUALzPEMjAxQRUUBgYjIiYmNTU0NjYzMhYWAzU0JiYjIgYGFRUUFhYzMjY2Ap5JhFhZhUpJhVhZhEqeID0sLD0gID8sLDwfAdCLcpVJSZVyi3KVSUmV/vamQ1UpKVVDpkNWKipWAAABAFb/+QObBJ0AMgAXQAoUHh4mATEKDCZ+AD8zPzMSOS8zMDFlMzI+AjU1NC4CIyIGBhUUFhYzMj4CNxcOAiMiJiY1NDY2MzIeAhUVFA4CIyMBEhJ/rGYtJkJVMEloNzJmTDZcRSkDNAZTlGuAqFJguoVtn2gyO431uhOTO2qOU8pHbEklRXJEQHJGIz1MKWQ6eVFts2hwuG9JgqxjRILptGcAAAQAYf/wA64EnQASACIANABEAB1ADSgXF0EODgU5MX4fBQsAPzM/MxI5LzMzETMwMUEUDgIjIiYmNTQ+AjMyHgIHNCYmIyIGBhUUFhYzMjY2ExQOAiMiLgI1NDY2MzIWFgc0JiYjIgYGFRQWFjMyNjYDrkFzmVl3wHA+cZpcXJpzP7o8a0dIajo6a0lHajucOmqPVVaQaTplsXFxsme5NV4+PlwzM14+Pl00AT1RfVQrTJVsSHVWLi5WdT47VzExVzs8Vi4uVgJQQm5RLCxRbkJnkEtLkG40UC0rTzc2UCwsUAABAEIAAAPABI0ABgAOtQUBBn0DCgA/PzMzMDFBFQEjASE1A8D96cQCF/1GBI1p+9wD9JkAAQBy//ADuwSUADEAFUAJFh8fDicLAwB+AD8yPzM5LzMwMUEzFSMiDgIVFRQeAjMyNjY1NCYmIyIGBgcnPgIzMhYWFRQGBiMiLgI1NTQ+AgLtFBB9rWsxJ0NYMEloNzNnTUR0SAQ0CFyYY4GlUGC3hWqgbDdAkvQElJ0+cJVWqEpxTCc/bUVDbkI5XjllOndRbbFncLRqSH2kXVSG67NmAAEAgf/wA8UEjQAjABdACiEJCQIZEQsFAn0APzM/MxI5LzMwMUEnEyEVIQM2NjMyFhYVFAYGIyImJiczFhYzMjY2NTQmJiMiBgE5lEQCqP31JiFuSHqyYlq5j2q3dwqyDYFiTmc0PHNRVFYCHiUCSqL+3xAhX655bLBpSpJsWVg+bkdEajwpAAACADEAAAPlBI0ABwALABVACQABAQoEC30KEgA/PzMSOS8zMDFBFSEnATMDAQERIxED5fxOAgJCkKH+lQI+uQGemHMDFP7d/jQC7/tzBI0AAAIAT//wA6AEnQAdAD0AHUANHwAAHR4eEjQqCwkSfgA/Mz8zEjkvMzMRMzAxQTMyNjY1NCYmIyIGBhUjNDY2MzIeAhUUDgIjIxU1MzIeAhUUDgIjIi4CNTMUFhYzMjY2NTQuAiMBYHtTbTYwYUpCZTq6abl4W5VsOi5hl2idnXmiXylAdJtbVZh2RLk7a0hLazklRmI9ApwvUjU3UCwpSzNdkFIqVHtRM2ZUMyxpMFNsPFF/WC0pU3xSNVEtLVQ8M0ovFwABAE8AAAPLBJ0AHgAStwsUfgMeHgISAD8zETM/MzAxZRUhNQE+AjU0JiMiBgYVIzQ2NjMyFhYVFA4CBwEDy/yeAaxMVSNwY1hwNbpnxIx7sl8nRVw1/riYmIMBnUZoVChQazdiQmapZFSXYzdnZGY4/ukAAAEAmQAAAp4EkAAGAAqzBn0CCgA/PzAxQREjEQU1JQKeuv61AesEkPtwA69inqUAAAIAY//wA6sEnQAVACsADrUcEX4nBgsAPzM/MzAxQRUUDgIjIi4CNTU0PgIzMh4CAzU0LgIjIg4CFRUUHgIzMj4CA6s7bZtgX5tvPDtvml9gnG47uh47WDo4VzsfHzxYODpXOx0Cn66DwX8+Pn/Bg66DwH49PX7A/rXkU3xSKSlSfFPkU35UKytUfgAAAwBIAAAD4QSNAAMACQANABxADAQMDA0NCH0HAwMGAgAvMzMRMz8zLzMRMzAxZRUhNQEBIzUBMyMVITUD4fymA0H8+HgDCnZJ/NKYmJgDffvrfAQRmJgAAAMADgAABBwEjQAEAAkADQAbQBAIBwMEBgAKDQgBDApyBQF9AD8zKxEXOTAxQQEzASMBAQcjAQERIxEB3QFv0P5Ncf7mAXEeb/5MAmC4AeUCqP0AAwD9U1MDAP2S/eECHwAAAQAnAAAEMgSNAAsAFUAKBwoEAQQJBQMAfQA/Mi8zFzkwMUEBATMBASMBASMBAQELAR0BH93+dQGZ3f7W/tjcAZb+cwSN/k0Bs/2+/bUBu/5FAksCQgAEADEAAAXxBI0ABQAKAA8AFQAgQA4SBBABDgQMAQgEBgF9BAAvPzMRMxEzETMRMxEzMDFBEzMHASMDExMjAQETMwEjAxMTIwEnAcn4gS7+9H6hxyp//tYEQ8W4/tZ/4vQ+fv78LwEWA3f3/GoEjfya/tkEjfycA2T7cwSN/Ib+7QOW9wACABQAAARUBI0ABAAJAA+1BwMFAX0DAC8/MxEzMDFBATMBIwEBEyMBAk4BQMb+N47+3wE+UY7+NwEjA2r7cwSN/Jf+3ASNAAABAHX/8AQLBI0AFQAPtQwRBgB9BgAvPxEzMjAxQTMRFAYGIyImJjURMxEUFhYzMjY2NQNRun3RfoPPeLdFfFJTe0QEjfz0hLNaWrOEAwz89FZvNTVvVgAAAgApAAAD/QSNAAMABwARtgYHBwEAfQEALz8ROS8zMDFBESMRIRUhNQJuuAJH/CwEjftzBI2ZmQABAET/8APeBJ0AOQAYQAoKJg82MSsYFA9+AD/MMy/MMxI5OTAxQTQuAicuAzU0PgIzMhYWFSM0JiYjIgYGFRQeAhceAxUUDgIjIi4CNTMUHgIzMjY2AyMZPGpRYZxvOz5yoGKMx2q6OXNZU242IEZwUGGWZzU/daNjWKuLUrouUmo8U3I6ASolOzEqExg/VXBJRnVWL2GhYTtcNSxMMCI4LioUGEJYckhJdVIsLVuJXDpSMxgpSgAAAgCKAAAEJgSNABkAHgAYQAobDQ0MDBoYFwB9AD8yLzM5LzMSOTAxUyEyHgIVFAYGBwchJyEyNjY1NCYmIyMRIyEBNwEVigGqaqZyO0WBWTf+dgIBKlVwOTZzWvC6AtX+1MMBMASNL1qEVlaFWxgbmDVbOT9eNfwMAgcB/gIKAAADAFr/NgRYBJ0AAwAZAC8AHEAMAAMDKysKCgIgFX4CAC8/MxI5LzMSOREzMDFlBQclARUUDgIjIi4CNTU0PgIzMh4CBzU0LgIjIg4CFRUUHgIzMj4CAxQBRH3+xQG2SIa7dHG7iUpKh7txdLyGSbgsVHpNS3hVLS5WeEtNeVQrlfFu8AJBQoTRk01Nk9GEQoTRlE1NlNHGRGOYaDY2aJhjRGOZaTY2aZkAAAEAiwAABBsEjQAYABO3AgEBDQwPfQ0ALz8zEjkvMzAxQSE1ITI2NjU0JiYjIREjESEyFhYVFA4CAl7+tAFMXHI2NnJc/ua5AdOPx2c6cqYBtpk1XDw5Yj38DASNX6VrVIVeMQACAGD/8ARbBJ0AFQArABC2JwYcEX4GCwA/PzMRMzAxQRUUDgIjIi4CNTU0PgIzMh4CBzU0LgIjIg4CFRUUHgIzMj4CBFtIhrtzcbuJSkqHu3F0u4dItyxUek1KeFUuLlZ5Sk54VCsCZ0KE0ZNNTZPRhEKE0ZRNTZTRxkRjmGg2NmiYY0RjmWk2NmmZAAEAiwAABFkEjQAJABG2AwgFAQcAfQA/Mi8zOTkwMUERIwERIxEzAREEWbn9pLm5AlwEjftzA2z8lASN/JQDbAADAIsAAAV4BI0ABgALABAAFkAJAg4KBQwHBAB9AD8yMjIvMzM5MDFTMwEBMwEjATMTESMBMxEjEcyuAYcBhq7+D4f9zp0buARPnrkEjfxxA4/7cwSN/QX+bgSN+3MBkgACAIsAAAOLBI0AAwAHAA+1BgMCBH0CAC8/ETMzMDFlFSE1ExEjEQOL/YwtuZiYmAP1+3MEjQADAIsAAARXBI0AAwAJAA0AF0AMBgcLBQwIBgoBBAB9AD8yLzMXOTAxQREjESEBASc3ARMBNwEBRLkDq/39/uAk1wGMJP5FewIhBI37cwSN/dP+6rzsAZv7cwIshP1QAAABACz/8ANNBI0AEwANtBAMBwF9AD8vzDMwMUERMxEUBgYjIiYmNTMUFhYzMjY2ApO6Za9wdrtsujhnRDxbMwFTAzr8xm+fVUuadkVXKDFbAAEAmAAAAVEEjQADAAmyAH0BAC8/MDFBESMRAVG5BI37cwSNAAMAiwAABFkEjQADAAcACwAYQAoCAwMECQUIBH0FAC8/MxEzEjkvMzAxQRUhNRMRIxEhESMRA8D9XyW5A865AouZmQIC+3MEjftzBI0AAAEAZP/wBDYEnQAqABZACSkqKgUZEH4kBQAvMz8zEjkvMzAxQREOAiMiLgI1NTQ+AjMyFhYXIy4CIyIOAhUVFB4CMzI2NzUhNQQ2GWm1jHTBjU1Eg714lMVtD7cLQHVcUnpRJzBbf098chj+5wJQ/kYgTjhLj8+EVIPOkEtfpms9Yjk2aJVfVmGXaDY1Fu6QAAMAiwAAA5sEjQADAAcACwAaQAsHBgYBCgsLAQB9AQAvPxE5LzMROS8zMDFBESMRARUhNQEVITUBRLkCwf3MAoP9fQSN+3MEjf3/mJgCAZmZAAADAET/EwPeBXMAAwAHAEEAKUATBz4+JAgXMwYGMwsCICAXAAAXfgA/My8RMxEzPzMvERI5OTMRMzAxQREjERMRIxElNC4CJy4DNTQ+AjMyFhYVIzQmJiMiBgYVFB4CFx4DFRQOAiMiLgI1MxQeAjMyNjYCcZWVlQFHGTxqUWGcbzs+cqBijMdqujlzWVNuNiBGcFBhlmc1P3WjY1iri1K6LlJqPFNyOgVz/s8BMfrR/s8BMeYlOzEqExg/VXBJRnVWL2GhYTtcNSxMMCI4LioUGEJYckhJdVIsLVuJXDpSMxgpSgADADEAAAPvBJ0AAwAHACYAHUANBAUFASIZfg4CAg0BCgA/MzMRMz8zEjkvMzAxYSE1IQMVITUlExYGBgcnPgMnAyY+AjMyFhYVIzQmJiMiDgID7/yDA33S/RQBVQgDEi4orR0kFAcCCQQzZI5YgaxVuTdbNy5JMhmYAdZ5eXr+6lCVdyRGCENeZisBFmiicDthrnRVZi0kSGkABQAOAAADkgSNAAMABwAMABEAFQAbQAsGBwMCAhEUCgkRfQA/Mz8SOXwvMxjOMjAxQRUhNQUVITUlATMBIwMBByMBAREjEQM7/SMC3f0jAUYBK8P+knHfAS0Vb/6RAhu4Ahp6esR4eI8CqP0AAwD9U1MDAP2S/eECHwACAIsAAAOFBI0AAwAHAA61BwYDfQIKAD8/MzMwMUERIxEhFSE1AUS5Avr9kwSN+3MEjZmZAAADABQAAARUBI0AAwAIAA0AG0AMCAx9AAUFCQIDAwkKAD8zETMRMxEzPzMwMWE1IRUBATMBIwEBEyMBA7z87gGkAUDG/jeO/t8BPlGO/jeYmANq/JYEjftzA2kBJPtzAAADAGD/8ARbBJ0AAwAZAC8AF0AKAwICCiAVfisKCwA/Mz8zEjkvMzAxQRUhNQUVFA4CIyIuAjU1ND4CMzIeAgc1NC4CIyIOAhUVFB4CMzI+AgNV/iAC5kiGu3Nxu4lKSoe7cXS7h0i3LFR6TUp4VS4uVnlKTnhUKwKSmJgrQoTRk01Nk9GEQoTRlE1NlNHGRGOYaDY2aJhjRGOZaTY2aZkAAgAUAAAEVASNAAQACQAOtQEJCgQIfQA/Mz8zMDFBATMBIwEBEyMBAk4BQMb+N47+3wE+UY7+NwNq/JYEjftzA2kBJPtzAAMAPgAAA0sEjQADAAcACwAXQAoHBgYCCgt9AwIKAD8zPzMSOS8zMDFlFSE1ARUhNQEVITUDS/zzAsr9dwLM/POYmJgCFJmZAeGYmAADAIsAAAREBI0AAwAHAAsAE7cKBQsHAgADfQA/MzMzMy8zMDFBFSE1MxEjESERIxEDrv1vJ7kDuboEjZiY+3MEjftzBI0AAwBAAAEDyQSNAAMABwAQACVAEg0ICQMKBhAQDgd9CgIMAwMCCgA/MxEzETM/MzMRMxIXOTAxZRUhNQEVITUBFQEjNQEBNTMDyfzBAw380AIJ/jxsAVD+sGyZmJgD9JiY/ccZ/caPAbcBt48AAwBhAAAFBgSNABUAJwArABVACRYAACt9HgwqCgA/zTI/My8zMDFBMzIeAhUUDgIjIyIuAjU0PgIXIgYGFRQWFjMzMjY2NTQmJiMTESMRAoZZdcmVVFSVyXVZdciVU1OVyHV1o1VVo3VbdaNWVqN1MLoEGDx3rnJysHg+PXewcnKvdz2bQYtuboxBQo1ubolBARD7cwSNAAACAGEAAAS2BI0AGQAdAB9ADhUUFAYHBw0cDgAdHQ19AD8zETM/EjkRMzMRMzAxQTMRFAYGIyMiLgI1ETMRFB4CMzMyNjY1AREjEQP9uYP3rhV/x4pIuSxYg1gVfKJR/uu5BI3+yLb+hEuR1IgBOP7IZJtrN2G7hQE4+3MEjQADAHYAAAR+BJ0ALAAwADQAJ0ATLTQKLjMKKBISKRERMjIxCgYdfgA/Mz8zETMRMzMRMz8zPzMwMUE1NC4CIyIOAhUVFB4CFxUuAzU1ND4CMzIeAhUVFA4CBzU+AgE1IRUhNSEVA8InUXxWVXxRJyRGYz9tqHQ8RIPAe3vAhEQ7cqZsW3M4/voBwvv8AcECaCZSiGQ2NmSIUiZmnXFHEHoNXZjKeSRwwJBRUZDAcCR5yZhdDnoWcL3+IJiYmJgAAwAn/+wFLQSNAAMABwAjABxADRcWCyANDQMECgUCA30APzMzPxI5LzM/MzAxQRUhNQERMxEDNT4CMzIWFhUUDgIjNTI+AjU0JiYjIgYGA7D8dwFjukI4coBLicRpRHulYkJlQyI4b1VIgHQEjZiY+3MEjftzAhyZFSESWrOIapJZJ5gYNVg/WG81EiEAAAIAYf/wBDEEnQADACsAF0AKAAEBCR0UfigJCwA/Mz8zEjkvMzAxQRUhNQEzDgIjIi4CNTU0PgIzMhYWFyMuAiMiDgIVFRQeAjMyNjYC2f32Aqi6DHHNl3G2gkZGhLt0kshxDLoKPnZfT3hRKSVMdlBkeD8ClJmZ/uVxsmZNj8p9Zn3KkE1ltHVNbjs1Z5JdZ1iRajk4bQAAAwAoAAAG+wSNABEAKQAtACBADygpKRwsHQEtfR8cCgsICgA/Mz8zPzMzMxI5LzMwMUEzAw4EIyM3Nz4ENyUyFhYVFA4CIyERMxEhMjY1NCYmIyE1AxUhNQEouhQEGzNTeFM2AykrPiobDwQEN4nBZTlvoGf+MboBFYF1M21W/rhx/cMEjf3mfcmXZDKlAQEiRGyXY2VbomxRhmI2BI38C4RVN106mQG1mJgAAAMAiwAABwoEjQAXABsAHwAhQA8XFhYbGhoeCx99DQoKHgoAPzMRMz8zEjkvMzMvMzAxQTIWFhUUDgIjIREzESEyNjU0JiYjITUHFSE1ExEjEQVaicFmOm+gZ/4xugEVgnQzbFf+uGb9cyW5AthbomxRhmI2BI38C4RVN106mU2ZmQIC+3MEjQADACkAAAUuBI0AAwAHABsAGUALGA0NAxMECgUCA30APzMzPzMSOS8zMDFBFSE1AREzEQM1PgIzMhYWFREjETQmJiMiBgYDsfx4AWO5QThxgEuJxGm5OHBVSH90BI2ZmftzBI37cwIcmRUhElm0i/6bAWVacTQSIQAEAIv+mgRDBI0AAwAHAAsADwAbQAwPC30DBwcOCgICCgoAPzMvETMzETM/MzAxZREjESUVITUTESMRIREjEQLFugGj/W8nuQO4uYT+FgHqFJiYA/X7cwSN+3MEjQAAAgCLAAAECQSNABcAGwAbQAwCAQENCw4KGxoaDX0APzMRMz8zEjkvMzAxQSEVITIWFhUUBiMhESMRITI+AjU0JiYTNSEVAln+uQFHV2wzdIL+67kBzmegbzpmwbP9gwLYmTpdN1WEA/X7czZihlFsolsBH5aWAAMALv6sBOgEjQAQABYAHgAjQBAaHR0JFwoKHBQJChYREQB9AD8yETM/MzMzETMRMy8zMDFBMwMOBAcjNzM+AzcTIREjESEBIREjESERIwFStxAFJz9PWy9cBSggPzUjBTwC27n93v6xBLm6/Lu7BI3+SorTnXFPHZgmVny8jQG0+3MD9fyj/hQBVP6tAAAFAB8AAAXsBI0AAwAJAA0AEwAXADVAGRQXFxEMCwsHBxERBg4ODwoCAhUKCQMDD30APzMRMz8zETMSOS8zMxEzETMRMxEzETMwMUERIxEhASEnMwETATcJAjMBMwcnASMBA2K5Ax/+Xf7iHNEBLBr+socBsfvz/mThASvRHK7+tOsBtQSN+3MEjf1qmQH9+3MCE4b9ZwH3Apb+A5kc/e0CmQACAEj/8APVBJ0AHgA+AB1ADR8CAgE+PhU0KgsLFX4APzM/MxI5LzMzETMwMUEjNTMyNjY1NCYmIyIGBhUjND4CMzIeAhUUDgInMzIeAhUUDgIjIi4CNTMeAjMyNjY1NC4CIyMCEJKOWnAzOHRcQmxBuUFzmlpfo3pFQ3ee7JJ1q282SoOoX0iahVK5BUZxRFp+QiNFZUKOAix0K082M1AvJEo6S3dULSVNeVNFcVEsRS9Tbj9XgFMoIE2CYUJQJCxTOTNLMRgAAAMAiwAABGIEjQADAAcACwAbQAwAAwoHCwoBAgUFCH0APzMRMzM/MzMzMzAxdwEXAQEzESMBMxEjwALog/0ZAmS6uvzjublcBDFc+88EjftzBI37cwAAAwCMAAAELASNAAMACQANAB9ADgwLCwcHBgYCCQN9CgIKAD8zPzMSOS8zETMRMzAxQREjESEBIyczARMBNwEBRbkDgf3q8By+AYQQ/ltuAiYEjftzBI39apkB/ftzAhOG/WcAAAMAKAAABDcEjQADAAcAGQAYQAsTEAoHAgMDCH0GCgA/PzMRMzM/MzAxQRUhNSERIxEhMwMOBCMjNzc+BDcDk/3DAuG6/au6FgUcNFN2UDYDKSs9KhoPBASNmJj7cwSN/eZ9yZdkMqUDAyJEapVjAAACACP/7AQMBI0AEgAXABdACgEXfRUWFg4OBwsAPzMRMxEzPzMwMUEBMwEOAiMiJic3FhYzMjY2NwMTEwcBAiIBFdX+bCFLfGsZQgkGC0EQMkErEtv9cJ/+XQG4AtX8ZUp3RQQDlAEDLUUkA3T9pP7aLwOxAAQAi/6sBPIEjQAFAAkADQARAB1ADRENfQUJCRALCAICCAoAPzMvETMzMxEzPzMwMWUDIxEjNTMVITUTESMRIREjEQTyEqaQBP1vJ7kDubqY/hQBVJiYmAP1+3MEjftzBI0AAgA9AAAD4ASNAAMAFwATtxQJCQIDDn0CAC8/MxI5LzMwMUERIxETFQ4CIyImJjURMxEUFhYzMjY2A+C6Qjhyf0yIxWm6OHBUSX91BI37cwSN/eaZFSATWbWKAWP+nVpwNRMgAAQAiwAABccEjQADAAcACwAPABlACwsHBw8QCgYGAw59AD8zMxEzPzMRMzAxZRUhNQERIxEhESMRIREjEQUx+8YCjrkC+7r8N7mYmJgD9ftzBI37cwSN+3MEjQAABQCL/qwGdQSNAAUACQANABEAFQAnQBIRDQ0VfQQQAgIQEAwMExMJCAoAPzMzETMRMxEzLxEzPzMRMzAxZQMjESM1MxUhNQERIxEhESMRIREjEQZ1EqWQA/vGAo65Avy7/De5mP4UAVSYmJgD9ftzBI37cwSN+3MEjQACAAkAAATXBI0AAwAaABdACgYFBQ8SChEBAH0APzIyPzM5LzMwMVMVITUBIRUhMhYWFRQGIyERIxEhMjY2NTQmJgkBtQFp/rkBR1dtM3WC/uu5Ac6JwWZmwQSNmJj+S5k6XTdVhAP1+3Nepmtsolv//wCLAAAFZwSNBCYCIwAAAAcB/gQWAAAAAQCLAAAECQSNABYAFUAJFRYWCgwJCgp9AD8/MxI5LzMwMUEyFhYVFAYGIyERMxEhMjY1NCYmIyE1AlmJwWZmwYn+MrkBFYJ0M2xX/rkC2FuibGumXgSN/AuEVTddOpkAAgBL//AEGwSdAAMAKwAXQAoCAQEcCCcLExx+AD8zPzMSOS8zMDFBITUhAR4CMzI+AjU1NC4CIyIGBgcjPgIzMh4CFRUUDgIjIiYmJwOt/fcCCf1YDD95ZFB1TCUpUXhPXnY+C7oNcMmRdLuERkaBtnGXzXENAfuZ/uVNbTg5apFYZ12SZzU7bk11tGVNkMp9Zn3Kj01msnEAAAQAi//wBhYEnQADAAcAHQAzAB1ADiQZfi8OCwMCAgYHfQYKAD8/EjkvMz8zPzMwMUEVITUTESMRARUUDgIjIi4CNTU0PgIzMh4CBzU0LgIjIg4CFRUUHgIzMj4CAoX+b1C5BYtIhrtzcbuJSkqHu3F0u4dIuCxUeU1LeFUuLld4S015UysCl5mZAfb7cwSN/dpChNGTTU2T0YRChNGUTU2U0cZEY5hoNjZomGNEY5lpNjZpmQAAAgBQAAAD/QSNAAMAIwAZQAsjAAQEGRsWfRkBCgA/Mz8zEjkvMzMwMUEBIwEFIS4CJy4CJy4CNTQ+AjMhESMRISIGFRQWFjMhAkv+ysUBQQHl/oMPDhEUAw4OA113OThunmYBy7r+74FvMGpWAUYCRv26AkZmAgYHBAEICAEXWXpJUX9XLvtzA/VsWDhULQAAAwALAAAD6ASNAAMABwALABtADAsKCgMCBgcHA30CCgA/PzMRMxESOS8zMDFBESMRIRUhNQEVITUBprkC+/2SAQ79gwSN+3MEjZmZ/giYmAAGAB/+rAYjBI0AAwAHAA0AEQAXABsAO0AcAg4BAQ4OBhsYGBUSEhAPDAkJEwYGGQoNBwcTfQA/MxEzPzMREjkvMzMzMxEzMxEzETMRMy8RMzAxQSMRMwERIxEhASEnMwETATcJAjMBMwcnASMBBiOoqP0/uQMf/l3+4hzRASwa/rKHAbH78/5k4QEr0Ryu/rTrAbX+rAHrA/b7cwSN/WqZAf37cwIThv1nAfcClv4DmRz97QKZAAQAjP6sBE4EjQADAAcADQARACdAEhAPDwsKCgYNB30CDgEBDg4GCgA/MxEzLxEzPzMSOS8zMxEzMDFBIxEzAREjESEBIyczARMBNwEETqen/Pe5A4H96vAcvgGEEP5bbgIm/qwB6wP2+3MEjf1qmQH9+3MCE4b9ZwAABACMAAAE6ASNAAMABwANABEAKUATEA8PCgALCwoDAwoKBg0HfQ4GCgA/Mz8zEjkvMy8RMxEzETMRMzAxQTMRIwMRIxEhASEnIQETATcBAZSVlU+5BD396v5UHAF5AYUQ/ltuAiYDdf20A2T7cwSN/WqZAf37cwIThv1nAAQAJAAABRUEjQADAAcADQARACFADxAPDwsKCg4GCg0HBwMAfQA/MjIRMz8zOS8zMxEzMDFTIRUhJREjESEBIyczARMBNwEkAbX+SwIKuQOB/erwHL4BhBD+XG0CJgSNmJj7cwSN/WqZAf37cwIThv1nAAEAYP/rBVwEoABEABtADAABAS8YCyQjIzoNfgA/MzMRMz8zMy8zMDFlFSIuAzU1ND4CMzIeAhUVFA4CIyIuAjU1ND4CMxUiDgIVFRQeAjMyPgI1NTQuAiMiDgIVFRQeAgVclfzFikg0ZJFcXJBlNF+u75GL3JlRQXmnZj9kRiU1Z5ljcK14PhgxTTU0TTIYTpvpip44b6HTgSZ1t4BDQH65eDqT76tcUp/mkx+Gz45JnjBjlGUhc61zOUSAtnE9VX5TKStVfVIrgL9+PwD//wAOAAAEHASNBCYB7gAAAAcCQQBE/t0AAgAn/qwEcQSNAAMADwAiQBELDggFBAoGD30CCgEBCgoNCgA/MxEzLxEzPzMSFzkwMUEjETMJAjMBASMBASMBAQRxp6f8mgEdAR/d/nUBmd3+1v7Y3AGW/nP+rAHrA/b+TQGz/b79tQG7/kUCSwJCAAUAJ/6sBfMEjQAFAAkADQARABUAIkAQEQ0NFBV9EBIMCQQIAgIIEgA/My8RMzMzPz8zMxEzMDFlAyMRIzUzFSE1ExEjESERIxEjFSE1BfMSppAE/W4ougO5udv8d5j+FAFUmJiYA/X7cwSN+3MEjZiYAAMAPQAAA+AEjQADAAcAGwAfQA4AGBgNAwMNDQYHEn0GCgA/PzMSOS8zLxEzETMwMUEzESMBESMRExUOAiMiJiY1ETMRFBYWMzI2NgHGlJQCGrpCOHJ/TIjFabo4cFRJf3UDHP20A737cwSN/eaZFSATWbWKAWP+nVpwNRMgAAIAiwAABC0EjQADABcAFEAJDxIUCQkBfQASAD8/OS8zPzAxcxEzEQM1PgIzMhYWFREjETQmJiMiBgaLuUE4cYBLicRpuThwVUiAdASN+3MCHJkVIRJZtIv+mwFlWnE0EiEAAQAC//AFbASdADQAG0AMGBgdHRERIgt+LQALAD8yPzM5LzMRMy8wMUUiLgI1NTQ+AjMyHgIVFSEiLgI1MxQWFjMhNTQmJiMiDgIVFRQeAjMyNjcXDgIDkoPQkk1Oi7xvgMODQvwmY5ZkM5k1bVUDIUqUcUp6Vy8rWo9kaIswORldihBNjsJ2g3fEj01KisR7hjVjjFZFZjgbZpVRNmSMVoNRh2M2MRaSDykfAAEAXv/wBGoEnQArABVACREUFBkLCyQAfgA/Mj8zOS8zMDFBMh4CFRUUDgIjIi4CNTUhFSEVFBYWMzI+AjU1NC4CIyIGByc+AgJIf8qOS02MvG6Bw4NCA479LEmVcUp5Vy8rWo9kaIsvORpgkASdTY7DdoJ3xI9NSorEe4aYGmaVUTZkjFaCUYdjNzEXkhApHwAAAgBI/+wD1QSNAAcAJgAbQAwIBQUEJiYdEwsHAH0APzI/MzkvMzMRMzAxUyEXASM1ASEBMzIeAhUUDgIjIi4CNTMeAjMyNjY1NCYmIyNwAzgB/kpoASn9vAEbhXWrbzZKg6hfSJqFUrkFRnFEWn5CPnlYgQSNdv45dAEx/sA9Z31BXohXKiJNhGFCUycvXUVAWTAAAAMAYP/wBFsEnQAVACQANAAbQA4LJWotHWotLQsAFmoACwAvLysSOS8rKzAxQTIeAhUVFA4CIyIuAjU1ND4CFyIGBgcGBgchJiYnLgIDMjY2NzY0NyEWFhceAwJddLuHSEiGu3Nxu4lKSoe7cVmIVQsBAQECigEBAQtTiFteiVEKAQH9dgEBAQg1VG8EnU2U0YRChNGTTU2T0YRChNGUTZtNlWwIEQkJEwhrlE38iE6YbQgPBwgRCFF+VSwABAAxAAAD7wSdAAMABwALACoAIUAPBgcDAgIJJh1+EgoKEQkSAD8zMxEzPzMSOS8zzjIwMUEVITUFFSE1ASE1IQETFgYGByc+AycDJj4CMzIWFhUjNCYmIyIOAgMd/RQC7P0UA778gwN9/ZcIAxIuKK0dJBQHAgkEM2SOWIGsVbk3WzcuSTIZAql6eud5ef4+mAJQ/upQlXckRghDXmYrARZoonA7Ya50VWYtJEhpAAADAEP/8AOfBJ0AIwAnACsAHUANJyYmKisrBxkSfgAHCwA/Mz8zEjkvMzMvMzAxZTI2NxcGBiMiLgI1NTQ+AjMyFhcHJiYjIg4CFRUUHgITFSE1BRUhNQK6O1s0GzdwPnGyfEFAe7JxP2s9FTNkO0tuSSMkSW/B/RMC7f0Thw8OlQ8QQH+8e7x7voBCEQ6UEAstWYRXvleDWSwCbnl55nl5AAAEAIsAAAetBJ0AAwAVACcAMQApQBIrMC4tJAkJMS59Ki0KGxISAgMALzMzfC8zGD8zPzMzLzMREjk5MDFBFSE1AzU0NjYzMhYWFRUUBgYjIiYmNxUUFhYzMjY2NTU0JiYjIgYGAREjAREjETMBEQdv/dNBVJlpaplTUplpappUoydRPTxPJyhPPTxQJ/61uf2kubkCXAFLjo4BsFNil1ZWl2JTYZdWVpe0UzhZMzNZOFM3WDQ0WAEI+3MDbPyUBI38lANsAAACACgAAARnBI0AGAAcABtACxscAgEBDgwPfQ4KAD8/MxI5fC8zGM4yMDFBITUhMjY2NTQmJiMhESMRITIWFhUUDgIHFSE1Arf9cQKPV2wzM2xX/uu5Ac6JwWY6b6B5/YMBpZhAZDY5ZUD8CwSNYahrUYhkN1mXlwACAD//9QKbAyAAGQAzABlAChsAABkaGggQLCQALzPMMjkvMzMRMzAxQTMyNjY1NCYjIgYVIzQ2NjMyFhYVFAYGIyMVNTMyFhYVFAYGIyImJjUzFBYzMjY1NCYmIwEKVDFAIUBFOUudTIJQV4RKQXtYb29kgD5Qi1dLiVadUEJGSSdHMQHLHDEgLDwyK0RjNjNkSTVZNSVOMFpASWg2MWhRLT0+MSozFwACADYAAAK8AxUABwALABdACQMHBwEBBgUICgAvzDIyOS8zETMwMUEVIScBMwcDAREjEQK8/YEHAXp8ic8BfJ0BLIJmAgXl/vwB6fzrAxUAAAEAXP/1AqgDFQAhABK2HwkJBAMZEQAvM8wyOS8zMDFTJxMhFSEHNjYzMhYWFRQGBiMiJiYnMxYWMzI2NTQmIyIG7n0xAd/+oxcTSy5VeUFAgmRKhFQEmwVMOkk/Tkk3OAFkIAGRg6sIFj50UUd7SzVmSDMwUj0+ThwAAQBW//UCrAMfAC0AE7YTHBwDAAwkAC8zzDI5fS8zMDFBMxUjIgYGFRUUFhYzMjY2NTQmIyIGBgcnPgIzMhYWFRQGBiMiJiY1NTQ+AgITFgtihkMmQioqPiJHRCtGKgIqAztrSFVxOEeDWl6JSzlxpgMfgzl2WnQ4TCYmQCg+SyE0HC8rWT5GeEpNe0dNjWA3aKNyPAAAAQA7AAACpgMVAAYADLMFAQYCAC/MMjIwMUEVASMBITUCpv6ipgFe/jsDFVr9RQKUgQAEAE//9QKfAyAADwAfAC8APQAXQAoMJDsDFBQ0LBwEAC8zzDI5LxczMDFlFAYGIyImJjU0NjYzMhYWBzQmJiMiBgYVFBYWMzI2NhMUBgYjIiYmNTQ2NjMyFhYHNCYmIyIGFRQWFjMyNgKfTYZUVIZPTYZVVYZNnCQ/KSo+IiI/Kik/I4lHfFFRfUdHfVBQfUieHTUlN0AdNiU3P9hLZTMzZUtEYjY2YjgjMRsbMSMiMhsbMgGCPl0zM10+R2IzM2JRHy0aNjAeLho4AAABAEr/+QKVAyAALgATthIbGwojAS0ALzPMMjl8LzMwMXczMjY2NTU0JiYjIgYGFRQWFjMyNjY3Fw4CIyImJjU0NjYzMhYWFRUUDgIjI9EOZHw6JT4oKj0hHz4tLUIlAS8CPGZDVHQ7R4NaXYRGNGykcQ94NGxSkjdIJCpFKShAJiI0Gi0uVzhDd05Nf01NkGUzaaFvOQABAI8CiwMMAyMAAwAIsQMCAC8zMDFBFSE1Awz9gwMjmJgAAwCfBEACbwZyAAMADwAbABlACRMNDQcBAwMZBwAvMzN8LxjNETMRMzAxQTczBwc0NjMyFhUUBiMiJjcUFjMyNjU0JiMiBgEgkr3c9GVGRWNjRUZlVDQjIzExIyM0Bbu3t9hKXV1KSFtbSCMxMSMmMjIABACLAAADrwSNAAMABwALAA8AG0AMCwoKBg8OB30DAgYKAD8zMz8zMxI5LzMwMWUVITUTESMRARUhNQEVITUDr/1oLbkCzf2/ApL9bpiYmAP1+3MEjf4Zl5cB55mZAAQAH/5KBBEETgASACQAWwBfADNAGl1fBnIlJhgYD0BBQS5TUw8PBUo3D3IhBQdyACsyKzIROS85ETMzETMRMxI5OSsyMDFTNTQ2NjMyFhYVFRQOAiMiJiY3FRQWFjMyNjY1NTQmJiMiBgYTFwYGFRQWFjMzMhYWFRQOAiMiLgI1NDY2NxcOAhUUHgIzMj4CNTQmJiMjIiYmNTQ2NgEXISddbcF+gMFsPnGdX3/Cbbk9bkpJbTw9bklIbj0nXhtAIjojrIK3YkeKx4BxrXU8WoVCNypILSFFaEhVg1kuKWNW0EV1SDdNAvIC/oMLAtIWaKJcXKJoFkmCYzhho3gWNF88PF80FjhdOTld/q4yED04HyUPP4JlOXhlPixOZDdZfUsNTQc1TzEhOy0aIzlCHy1AIiZPPkNcPAJ/kpIAAAQAZP/rBFkETgAVACsALwAzABdADDAKLQYcEQtyJwYHcgArMisyPz8wMVM1ND4CMzIeAhcVDgMjIi4CNxUUHgIzMj4CNzUuAyMiDgIFEzMLAjMTZDhrnmZmmGo+DAs+a5lnZJ1sOLogQ2tLP15DLA4LKkNgQExrRCACNU6xakBVlXEB9RWA1JtVSYnBeUt4wYpJTYy/hxVNhmY5QG6MTCVKi3FCRHabRQIe/eL95AIc/eQAAAIAsgAABOQFsAAZAC4AH0APJggbGhoCAQEODA8Ccg4IAD8rMhI5LzMzETM/MDFBISchMjY2NTQmJiMhESMRITIWFhUUBgYPAjcyFhYVFRQWFhcVIy4CNTU0JiYC3/5mAgFodIw/PoRr/rbBAg2g23FUoHIYVBanvE4MHhrGHhoGP3YCdZ07clJOdD/67gWwX7iIXZJlGhsTb1+obIUoT0MZGRtdXBqBT3ZBAAADALIAAAUeBbAAAwAJAA0AIEAQCggJAgwLCwcGBgIDAnICCAA/KxI5LzMzETM/PzAxQREjESEBISchARMBNwEBc8EEQv2I/qoeAQEB/C393WwCowWw+lAFsPzfoAKB+lACqKn8rwADAJMAAAQVBgAAAwAJAA0AHEAOCwcGBgIJBnIDAHIKAgoAPzMrKxI5LzMzMDFBESMRAQEhJzMBEwE3AQFMuQNO/kP+5hbWATs0/oxiAe4GAPoABgD+Ov27mgGr+8YCAqX9WQAAAwCyAAAE+wWwAAMACQANABpADgYLBwgMBQIJAwJyCgIIAD8zKzISFzkwMUERIxEhASEnMwETATcBAXPBBCD9Uf7uC3gCZCv9NaEDGAWw+lAFsP0fWwKG+lAC6GX8swAAAwCTAAAD8gYYAAMACQANACBAEAwLCwcGBgIJBnIDAXIKAgoAPzMrKxI5LzMzETMwMUERIxEBASMnMwETATcBAUy5AzX93JoWWQGKNv45awJBBhj56AYY/iL9upkBrfvGAgCT/W0AAgCLAAAEIASNABkAHQAWQAkbGg8CAQ4PfQEALz8zETMRMzIwMWEhNyEyNjY1NTQuAiMhNSEyHgIVFRQGBgERIxEB5/74AQEHgatUMF6LW/7mARp8zZRQjf/+sLmYYLN7Ql+UZTSZTZHLfkCn+IcEjftzBI0AAAEAYf/wBDEEnQAnABG2GRUQfiQABQAvzDM/zDMwMUEzDgIjIi4CNTU0PgIzMhYWFyMuAiMiDgIVFRQeAjMyNjYDd7oMcc2XcbaCRkaEu3SSyHEMugo+dl9PeFEpJUx2UGR4PwF5cbJmTY/KfWZ9ypBNZbR1TW47NWeSXWdYkWo5OG0AAAIAiwAAA/AEjQAZADEAKEATHBspGQICARsmAQEmGwMNDA99DQAvPzMSFzkvLy8RMxI5OREzMDFBISchMjY2NTQmJiMjESMRITIeAhUUBgYHAyE3ITI2NjU0JiYjIzchFx4CFRQOAgJS/sECAR1IaDg4bVDduQGWY55xPEyOZUf+iF8BGU1pNy9lUO8BAUEoYIFCO2+cAhOMJ0s2PE0k/AwEjSZOeFJHdUkH/b2YLFI5O1gxjDUDUX9JU31UKgADABQAAARxBI0ABAAJAA0AHEAMDQAGAwwMAQcDfQUBAC8zPzMSOS8SOTkzMDFBASMBMwEBJzMBAxUhNQJe/nO9Ad95AUn+dg16AdnX/UwD6vwWBI37cwPun/tzAa+YmAABAJ8EjwGWBjwACgAKsgWAAAAvGs0wMVM1NDY2NxcGBhUVnyxBH2siGwSPgTt1YBxTPGg+eAACAIIE3wLgBosADwATABK1EhMKAA0FAC8zfNwy1hjNMDFBMxQGBiMiJiY1MxQWMzI2JyczFwJHmUmIXV6ISphEVFBFtaSZcQWwPV42Nl49LkVFQsfHAAL8owS9/swGlAAXABsAHUAMABUVBRkbGwkREQwFAC8zMxEzMy8zETMRMzAxQRcUBgYjIiYmIyIGFSc0NjYzMhYWMzI2JTczB/55UytKMTZBOiwiMFQqSzEtREIqITL+8IOrtgWVGDBSMSYmMyYVMFMzJiUzQuLiAAIAbwTiBFgGlQAGAAoAFLcIBwcFAYAEBgAvMxrNOTMvzTAxUwEzASMnByUTMwNvASOYASPFqqoBz43IyQTiAQb++p6esQEC/v4AAv9dBM8DRwaDAAYACgAXQAkHQAgIAwaAAgQALzMazTkzLxrNMDFBASMnByMBJRMjAwIjASTGqqnFASL+mo6NyQXW/vmfnwEHrf7+AQIAAgBpBOQD7QbQAAYAGgAfQA0REghAGgkICAMGgAIEAC8zGs05MxEzMxoQzDIwMUEBIycHIwEFIyc+AjU0JiYjNzIeAhUUBgcCNQESq8XEqgEQAe1zASw2GiZAJwZAYUMiUzMF6/75uroBB32EAwwZFhkdDV0XKzslQTsHAAIAaQTkA0cG1AAGAB4AJUAQCAcHEBgMQBQTExwMDAaABAAvGs0yETMzETMaEM0yMhEzMDFBBSMnByMlNxcUBgYjIiYmIyIGFSc0NjYzMhYWMzI2AhkBLqvFxKoBLflNK0gtMjw1KR80TStJLCo+PScfNAXY9J6e9PwWKEgtJCQvHBMoSS8jIy0AAAMAiwAAA4UFxAADAAcACwAbQAwCCgoLCwcDAwd9BgoAPz8zLxEzETMRMzAxQREjEQERIxEhFSE1A4W5/ni5Avr9kwXE/jAB0P7J+3MEjZmZAAACAIIE3wLgBosADwATABK1ERMACg0FAC8zfNwyGNbNMDFBMxQGBiMiJiY1MxQWMzI2JzczBwJHmUmIXV6ISphEVFBF0HGZpAWwPV42Nl49LkVFQsfHAAIAggTgAssHBAAPACUAKEARGxwcESUSEhERCQ0FAAkJBRAAPzN8LzMRMxEzGC8zETMRMy8zMDFBMxQGBiMiJiY1MxQWMzI2JyMnPgI1NC4CIzcyHgIVFAYGBwI4k0eCW1qER5JET05DSYABMT0eGSw7IQdIbkkmK0QmBbA9XjU1Xj0uRUU/fQIMFxQQFw4GUhUmNSAnMBgFAP//AFECjQKeBbgGBwHiAAACmP//ADYCmAK8Ba0GBwI7AAACmP//AFwCjQKoBa0GBwI8AAACmP//AFYCjQKsBbcGBwI9AAACmP//ADsCmAKmBa0GBwI+AAACmP//AE8CjQKfBbgGBwI/AAACmP//AEoCkQKVBbgGBwJAAAACmAABAH7/6wUeBcUAKQAVQAoaFhEDciYABQlyACvMMyvMMzAxQTMOAiMiLgM1NTQSNjYzMhYWFyMuAiMiDgIVFRQeAzMyNjYEXMEPhuyqa76ccT5apuOIpfKPD8IPWZpxYp1wOypNbIRMdZRRAc+K239CfbDegT2iAQi/ZnzckGWUUVGVzXw/ZKyKYjVOkwAAAQB+/+sFHwXFAC0AG0ANLSwsBRoWEQNyJgUJcgArMivMMxI5LzMwMUERDgIjIi4DNTU0EjY2MzIWFhcjLgIjIg4CFRUUHgMzMjY2NxEhNQUfGoLXnW/GpHdBXKjihrLsgxTBD1GYfF6ccj8tVHONT2GJVBL+sALT/ewnZElBfLPmiRusARG/ZHTKgU+DT1GX1YMdbLSNYjMjMhYBRZsAAAIAsgAABREFsAAbAB8AErccDxACcgIdAAAvMjIrMjIwMWEhNyEyPgI1NTQuAiMhNSEyFhYSFRUUAgYEAREjEQJT/rgCAUV3vYRFRoK1b/6iAV+S+bpoZ73+//6HwZ1Oksp7LYHLjUqeY7n++6Irov77uWIFsPpQBbAAAgB+/+sFXwXFABkAMQAQtyEUA3ItBwlyACsyKzIwMUEVFA4DIyIuAzU1ND4DMzIeAwc1NC4DIyIOAhUVFB4DMzI+AgVfPW+bvWtou51zPz9ynLtoa76bcD2+Kk5rhUtanXdDLFBtgkhfnnRAAu4sgN+zgEVFgLPfgCyA3rSARUWAtN6sLmStimI0UZXOfS5lropjNFGV0AADAH7/BAVfBcUAAwAdADUAG0ANJRgDcgADAzELCXIBAgAvMysyMhEzKzIwMWUBBwEBFRQOAyMiLgM1NTQ+AzMyHgMHNTQuAyMiDgIVFRQeAzMyPgIDqQF0g/6TAjI9b5u9a2i7nXM/P3Kcu2hrvptwPb4qTmuFS1qdd0MsUG2CSF+edECg/tx4ASECxyqA37OARUWAs9+AKoDftIFFRYG036osZa2LYjRRlc9+LGWui2I0UZXPAAEAoAAAAskEjQAGABVACQMEBAUFBn0CCgA/PzMvMxEzMDFBESMRBTUlAsm5/pACCgSN+3MDp4unygABAIMAAAQgBKAAIAAXQAoQEAwVfgMgIAISAD8zETM/MzMvMDFlFSE1AT4CNTQmJiMiBgYVIzQ2NjMyHgIVFA4CBwEEIPyHAepLQhAyZE1Peka5ds6EZZlpNRs1TDH+j5iYhAG4QVtKJjJXNz50UXG6cDRcekYwXVpYLP6zAAABAA/+owPeBI0AHwAaQAsGAB4eAxYPBQIDfQA/MzMvMxI5LzMzMDFBASE1IRUBHgIVFA4CIyImJzcWFjMyNjY1NCYmIyMBbwF2/XMDc/5/cLdtVJjNemrIajVMr1t8sV5Tp4A8AmMBkph1/mwPdb6Ag8qLRzM0iygwX6ZqcpVJAAIAPv62BKAEjQAHAAsAFkAJBgQLfQoDBwcCAC8zETMvPzMzMDFlFSE1ATMDAQERIxEEoPueAteQn/4SAsO5l5huBCD+0P06A/b6KQXXAAEAZf6gBAYEjAAnABZACSQJCQIaEwUCfQA/My8zEjkvMzAxQScTIRUhAzY2NzYeAhUUDgIjIiYnNxYWMzI+AjU0LgIjIgYGASCaZgMU/X83LIBYZqN0PUSFxoNqyVw6Q65kT39bMClOb0dWYzUBYxEDGKv+dRomAQFEgrVvbr+QUTc7ijQwOGSIUER2WTIjQAAAAQBK/rYD8gSNAAYAD7UBBQUGfQMALz8zETMwMUEVASMBITUD8v2huwJX/RsEjWn6kgU/mAAAAgCEBNkC0wbQAA8AJwApQBEREBAZISEVHRwcJRUVAAkNBQAvM80yMnwvMzMRMxEzGC8zMxEzMDFBMxQGBiMiJiY1MxQWMzI2ExcUBgYjIiYmIyIGFSc0NjYzMhYWMzI2Aj2WSIRcW4RIlUJQUEI5VCtKMTZBOiwiMFQqSzEtREErITEFrj5hNjZhPi5ISAFQGDBSMSYmMyYVMFMzJiUzAAEAaP6ZASEAmgADAAixAQAAL80wMWURIxEBIbma/f8CAQAFAGD/8AZtBJ0AKQAtADEANQA5ADFAGDg5OTF9Fi0tFzAKNTQ0JhsBBgYmfhEbCwA/Mz8zETMREjkvMz8zMxEzPzMRMzAxQQciLgIjIg4CFRUUHgIzMj4CMxciBgYjIi4CNTU0PgIzMhYWARUhNRMRIxEBFSE1ARUhNQPyKh5kb2AaSnhVLi5WeUobXm5kHy1RloAwcbuJSkqHu3EwgZYCyf1oLbkCzf2/ApL9bgSNmQQGBDZomGNEY5lpNgMFBJYICE2T0YRChNGUTQgI/AuYmAP1+3MEjf4Zl5cB55mZAAEAgv6pBEAEoQA7ABS3ABUfHzULKTUALy8zEjkvMzIwMUUyPgI1ETQuAiMiDgIVFB4CMzI+AjU3FAYGIyIuAjU0PgIzMh4CFRUUDgMjIiYnNxYWAeBdmnE+KU9ySTtlTCsnTGtDUndNJml0w3dsrHpAR3+mYG+2hUg6apOyZUKUQCYybMBHj9WNAQhik2MyLlyJW0V/YjkxUF0sAoi7YEqGuG59wIRERYzVj/KO5a51OxwfjhMfAAAB/7b+SwFoAJkAEQAKsg0GAAAvzDIwMXczFRQGBiMiJic3FhYzMjY2Na66TZBlHzQdDg9FDis9IJnycJxQBwqdBgYqUz3//wA7/qMECgSNBAYCZywA//8Ac/6gBBQEjAQGAmkOAP//ACL+tgSEBI0EBgJo5AD//wB2AAAEEwSgBAYCZvMA//8Adv62BB4EjQQGAmosAP//ADb/6wRHBKEEBgKAvgD//wB+/+wEFgWyBAYAGvkA//8AXv6pBBwEoQQGAm7cAP//AHH/7AQPBcQGBgAcAAD//wD0AAADHQSNBAYCZVQA////tP5LAWYEOgQGAJwAAP///7T+SwFmBDoGBgCcAAD//wCcAAABVQQ6BgYAjQAA////+f5YAVoEOgYmAI0AAAEGAKTHCgALtgEEAgAAQ1YAKzQA//8AnAAAAVUEOgYGAI0AAAADAIv/6wP6BJ0AAwAWADEAKUAUDyYmDSMjCRsvC3IEAAACEwl+AgoAPz8zEjkvMysyETkvMzMRMzAxQREjERcjNDY2MzIWFwEjNRMmJiMiBgYTNxYWMzI2NjU0JiYjIzUzMh4CFRQGBiMiJgFDuLi4V7GHg8BP/ppp7h5UP1NeJkw1H1Q3Q10yPHlaVHVhnW87ZbN0OHAC8f0PAvECj79ga0z+UGsBJxcnTX7845gTIDlkQUFQJYopUHdNeKhZGAACAHj/6wSJBKEAFQArAA61HBF+JwYLAD8zPzMwMUEVFA4CIyIuAjU1ND4CMzIeAgc1NC4CIyIOAhUVFB4CMzI+AgSJTIu+cnC/jU5OjL5wcr6MTbkwWXxLSntZMDFae0pMe1gvAlAUkt6VTEyV3pIUkt6VTEyV3rIuaaBrNzdroGkuaaBtNzdtoAABADsAAAPTBbAABgATQAkBBQUGBHIDDHIAKysyETMwMUEVASMBITUD0/2+uwJA/SUFsGj6uAUYmAAAAwCM/+wENQYAAAQAGgAvABlADiEWB3IrCwtyBApyAAByACsrKzIrMjAxUzMRByMBFRQOAiMiLgInNT4DMzIeAgc1NC4CIyIOAgcVHgIzMj4CjLoZoQOpPnSiZWebaj8MDD9qmmZmpHM+uiZMcUxGZ0gtCxBJe1tLcUsmBgD60tICJxV2yZVSR4a+d1x4vodHT5LKkRVUj2w8MFFnN/FGgVI+bI4AAAEAXf/sA+8ETgAnABlADB0ZGRQHcgQEAAkLcgArMjIvKzIvMjAxZTI2NjczDgIjIi4CNTU0PgIzMhYWFyMuAiMiDgIVFRQeAgJAQ3BIBa8Fd8BzerZ4Ozx4tXp/vm0FrwVBb0tVc0UdHURzgzdfPWClZVaWw20qbcOWVmexcENsQUNxiUcqR4twQwAAAwBb/+wEAQYAAAQAGgAvABlADSEEBBYLcisLB3IBAHIAKysyKzIvMjAxZREzESMBNTQ+AjMyHgIXFQ4DIyIuAjcVFB4CMzI2Njc1LgMjIg4CA0e6ofz7Q3mjYWaZaz4MCz9rmmdfo3lDuidOcktcd0gUDC1HZ0ZMc04n0gUu+gACERV8y5JPR4e+eFx3voZHUpTJixVRjmw9ToBL8TdnUTA8bJAAAAMAW/5VBAEETgATACkAPgAbQA8wJQtyOhoHcg4GD3IABnIAKysyKzIrMjAxQTMRFA4CIyImJzcWFjMyNjY1EQE1ND4CMzIeAhcVDgMjIi4CNxUUHgIzMjY2NzUuAyMiDgIDZJ0+ea9xT8hPOD6gTmR+Pf0UQXijY2aZaz8MDD9qm2dho3hBuidNcktcd0gUDC1HZ0ZMc00nBDr8FHm8gUMzNooqMU+ZcAMH/sUVfMuST0eHvnhcd76GR1KUyYsVUY5sPU6AS/E3Z1EwPGyQAAACAFr/7ARFBE4AFQArABC3HBELcicGB3IAKzIrMjAxUzU0PgIzMh4CFRUUDgIjIi4CNxUUHgIzMj4CNTU0LgIjIg4CWkeFuHByuYVHR4S5cXG5hUe5KlB3TEx1USkqUHZNTHVQKgIRF3XJlVNTlcl1F3XIlVNTlciMF1GPbz8/b49RF1CPb0BAb48AAAMAjP5gBDMETgAEABoALwAZQA4hFgdyKwsLcgMGcgIOcgArKysyKzIwMUERIxEzARUUDgIjIi4CJzU+AzMyHgIHNTQuAiMiDgIHER4CMzI+AgFGup8DCD5zomVnnm5BDAxCbZxmZqR0PbooT3RMRmdILQsUSHhbS3NPKANq+vYF2v3sFXbJlFJEgrZycHi+h0dPksuRFVSQbDwwUWc3/v1Ge0w/b48AAAMAW/5gBAAETgAEABoALwAZQA4hFgtyKwsHcgQOcgMGcgArKysyKzIwMUERNzMRATU0PgIzMh4CFxUOAyMiLgI3FRQeAjMyNjY3NS4DIyIOAgNGGaH8W0B3pmZmm21ADAtAbZ1nZKV3QbooT3NLXHtKFAsvSmlGTHRPKP5gBQrQ+iYDsBV8y5NPR4e+eFx3voZHUpPJixVRj24/UYNL8TdoUzE+bpEAAAEAXf/sA/METgAqABlADBMSEgAZCwdyJAALcgArMisyETkvMzAxRSIuAjU1ND4CMzIeAhUVITUhNTQmJiMiDgIVFRQeAjMyNjcXBgYCcnnEjUtOhqpbdKlsNPzYAm8zcl8/akwqMFuEVVyMMDgsqBRPkcZ2LIDIikhJhbRqeZcaSYFSM2KQXSxRjWs8NiR/J0sAAwBh/lUD8gROABIAKAA9ABtADy8kC3I5GQdyDQYPcgAGcgArKzIrMisyMDFBMxEUBgYjIiYnNxYWMzI2NjURATU0PgIzMh4CFxUOAyMiLgI3FRQeAjMyNjY3NS4DIyIOAgNWnG7Rl0a1Rzg3jEVkfj39KDtvnmNmmWs+DAs/a5pnYZ1wO7khRWxLXHhHFAstR2hGTG1FIQQ6/AKb2nIrK4siJ0qSagMZ/sQVfMuTT0eHvnhcd76GR1KTyYsVUY1sPU6AS/E3Z1EwPWyQAAACAFr+TAR1BEkAAwAlABlADA4VAQEVHwQHcgMGcgArKzIvMy8RMzAxQQEjASUyHgIXAR4CMzI2NwcGBiMiLgInAS4CIyIGByc2NgQX/SbFAuT9Z0hiQSwRAZ4UKjIfED0QMAomDTpVQDcd/m4TMUIuDCsNARE/BDr6JgXaDzVTXCf8TCtEJwIDnwcHI0RlQgOaMFM0BAGVBQn//wBXAAAChQW4BAYAFawAAAEAaP/wBJIEnQBBABdACzg4ECJ+GQozAAtyACsyPz8zOS8wMUUiLgI1NDY2NyU2NjU0JiMiBhUUFhYXASMBLgI1NDY2MzIWFhUUBgYHBQ4CFRQWFjMyPgI1MxQGBwYGBwYGAehZjmQ1LVM5AQspK0hCQEEpQycCitP9xzdaNU+PX2CMTCZBKP7VJygNMGFJY51vOqhNRwoRC0zVEC1Qaz5EZ1Uqvx5IJDRGTSwlREUp/U0CVjpgZkFOdkJJd0YyWkwd2Bw2MxYwSypEe6lmd9NUCxwKR1IAAAMAAQAAA4sEjQADAAcACwAdQA0ICQkLCgoGB30DAgYKAD8zMz8SOS8zMy8zMDFlFSE1ExEjEQEVBTUDi/2MLbkBw/2zmJiYA/X7cwSN/oJ9u30AAAYACQAABfIEjQADAAcACwAQABQAGAAzQBgKCwsYGA8HBhQTBhMGEw0PfQMCAhcXDQoAPzMRMxEzPxI5OS8vETMRMxEzETMRMzAxZRUhNQEVITUBFSE1BwEjATMTFSE1ARMjAwXy/cQB0/4SAi79xIP9xscCl3WM/aUCYii4KZaWlgIVlZUB4paWcPvjBI39N5aWAsn7cwSNAAACAIsAAAO3BI0AAwAZABdACg8QEAF9BQQEAAoAPzIvMz8zLzMwMXMRMxEnNTMyNjY1NCYmIyM1MzIWFhUUBgYji7ky6FxyNjZyXObmj8dnZ8ePBI37c+yZNF08OWI9mV+la3CiVgADAGD/xgRbBLcAFQArAC8AG0ALLy8cEX4tLScGC3IAKzIyfC8YPzMzfC8wMUEVFA4CIyIuAjU1ND4CMzIeAgc1NC4CIyIOAhUVFB4CMzI+AhMBIwEEW0iGu3Nxu4lKSoe7cXS7h0i3LFR6TUp4VS4uVnlKTnhUK6/8s5YDTgJnQoTRk01Nk9GEQoTRlE1NlNHGRGOYaDY2aJhjRGOZaTY2aZkC9fsPBPEAAAQAMAAABLMEjQADAAcACwAPABtADAIDgA4PDwsHfQoGCgA/Mz8zMy8zGswyMDFBFSE1ExEjESERIxEFFSE1A8D9XyW5A865ARP7fQKLmZkCAvtzBI37cwSNppiYAAACAIv+SwRZBI0ACQAbAB9ADxcQD3IJAwZ9CAoKAgIFCgA/MxEzETM/MzMrMjAxQREjAREjETMBEREzFRQGBiMiJic3FhYzMjY2NQRZuf2kubkCXLlNkGUfNB0OD0UOKz0hBI37cwNs/JQEjfyUA2z7qI5wnFAHCp0GBipTPf//ACYCHwIOArcGBgARAAAAAwAlAAAE5QWwABoAHgAiACNAEQIBAR0iISEdDg8PHgJyHQhyACsrMhEzETkvMxEzETMwMWEhNyEyNjY1NTQuAiMhNSEyHgIVFRQOAgERIxEBFSE1AlH+0AIBLpzQaTx0p2z+uAFIj+yrXFyt8/6fwQHb/YOdg+2fWX3Dh0aeX7P9nlee/bJfBbD6UAWw/YGYmAADACUAAATlBbAAGgAeACIAI0ARAgEBHSIhIR0ODw8eAnIdCHIAKysyETMROS8zETMRMzAxYSE3ITI2NjU1NC4CIyE1ITIeAhUVFA4CAREjEQEVITUCUf7QAgEunNBpPHSnbP64AUiP7KtcXK3z/p/BAdv9g52D7Z9ZfcOHRp5fs/2eV579sl8FsPpQBbD9gZiYAAMAAQAAA/4GAAADABoAHgAZQA0eHRYKB3IDAHIRAgpyACsyKysyxDIwMUERIxETJz4DMzIeAhURIxE0JiYjIg4CARUhNQFkuY1NAUB0oWJQgFswujJgRkVxUS0BRv2DBgD6AAYA/EYDb72MTStelWv9OwLHVWcvOmaDAtqYmAAAAwAyAAAElwWwAAMABwALABVACgMKCwYHAnIBCHIAKysyLzMyMDFBESMRIRUhNQEVITUCw74CkvubA3n9gwWw+lAFsJ6e/h6YmAAD//T/7AJxBUEAAwAVABkAHUAOChELchgZGQICBAQDBnIAKzIvMhEzLzMrMjAxQRUhNRMzERQWFjMyNjcXBgYjIiYmNQEVITUCUv23xrkiNh8XMw0BFkcyRHJDAaL9gwQ6jo4BB/vLNzgSCQOXBw02f2wB5ZiYAP//AB0AAAUeBzcGJgAlAAABBwBEAS8BNwALtgMQBwEBYVYAKzQA//8AHQAABR4HNwYmACUAAAEHAHUBvwE3AAu2Aw4DAQFhVgArNAD//wAdAAAFHgc3BiYAJQAAAQcAngDJATcAC7YDEQcBAWxWACs0AP//AB0AAAUeByMGJgAlAAABBwClAMQBOwALtgMcAwEBa1YAKzQA//8AHQAABR4G/QYmACUAAAEHAGoA+QE3AA23BAMjBwEBeFYAKzQ0AP//AB0AAAUeB5MGJgAlAAABBwCjAVABQgANtwQDGQcBAUdWACs0NAD//wAdAAAFHgeUBiYAJQAAAQcCQgFZASIAErYFBAMbBwEAuP+ysFYAKzQ0NP//AHj+QwTYBcQGJgAnAAABBwB5AdP/9gALtgEoBQAAClYAKzQA//8AqQAABEYHQgYmACkAAAEHAEQA+gFCAAu2BBIHAQFsVgArNAD//wCpAAAERgdCBiYAKQAAAQcAdQGKAUIAC7YEEAcBAWxWACs0AP//AKkAAARGB0IGJgApAAABBwCeAJQBQgALtgQTBwEBd1YAKzQA//8AqQAABEYHCAYmACkAAAEHAGoAxAFCAA23BQQlBwEBg1YAKzQ0AP///98AAAGAB0IGJgAtAAABBwBE/6YBQgALtgEGAwEBbFYAKzQA//8AsQAAAlIHQgYmAC0AAAEHAHUANgFCAAu2AQQDAQFsVgArNAD////qAAACRwdCBiYALQAAAQcAnv9AAUIAC7YBBwMBAXdWACs0AP///9UAAAJfBwgGJgAtAAABBwBq/3ABQgANtwIBGQMBAYNWACs0NAD//wCpAAAFCQcjBiYAMgAAAQcApQD6ATsAC7YBGAYBAWtWACs0AP//AHf/7AUKBzkGJgAzAAABBwBEAVIBOQALtgIuEQEBT1YAKzQA//8Ad//sBQoHOQYmADMAAAEHAHUB4gE5AAu2AiwRAQFPVgArNAD//wB3/+wFCgc5BiYAMwAAAQcAngDsATkAC7YCLxEBAVpWACs0AP//AHf/7AUKByUGJgAzAAABBwClAOcBPQALtgI6EQEBWVYAKzQA//8Ad//sBQoG/wYmADMAAAEHAGoBHAE5AA23AwJBEQEBZlYAKzQ0AP//AIz/7ASqBzcGJgA5AAABBwBEASoBNwALtgEYAAEBYVYAKzQA//8AjP/sBKoHNwYmADkAAAEHAHUBugE3AAu2ARYLAQFhVgArNAD//wCM/+wEqgc3BiYAOQAAAQcAngDEATcAC7YBGQABAWxWACs0AP//AIz/7ASqBv0GJgA5AAABBwBqAPQBNwANtwIBKwABAXhWACs0NAD//wAPAAAEvAc2BiYAPQAAAQcAdQGJATYAC7YBCQIBAWBWACs0AP//AG3/7APqBgAGJgBFAAABBwBEANUAAAALtgI9DwEBjFYAKzQA//8Abf/sA+oGAAYmAEUAAAEHAHUBZQAAAAu2AjsPAQGMVgArNAD//wBt/+wD6gYABiYARQAAAQYAnm8AAAu2Aj4PAQGXVgArNAD//wBt/+wD6gXsBiYARQAAAQYApWoEAAu2AkkPAQGWVgArNAD//wBt/+wD6gXGBiYARQAAAQcAagCfAAAADbcDAlAPAQGjVgArNDQA//8Abf/sA+oGXAYmAEUAAAEHAKMA9gALAA23AwJGDwEBclYAKzQ0AP//AG3/7APqBl0GJgBFAAABBwJCAP//6wAStgQDAkgPAAC4/92wVgArNDQ0//8AXf5DA+0ETgYmAEcAAAEHAHkBQP/2AAu2ASgJAAAKVgArNAD//wBd/+wD8wYABiYASQAAAQcARADEAAAAC7YBLgsBAYxWACs0AP//AF3/7APzBgAGJgBJAAABBwB1AVQAAAALtgEsCwEBjFYAKzQA//8AXf/sA/MGAAYmAEkAAAEGAJ5eAAALtgEvCwEBl1YAKzQA//8AXf/sA/MFxgYmAEkAAAEHAGoAjgAAAA23AgFBCwEBo1YAKzQ0AP///8QAAAFlBf4GJgCNAAABBgBEi/4AC7YBBgMBAZ5WACs0AP//AJYAAAI3Bf4GJgCNAAABBgB1G/4AC7YBBAMBAZ5WACs0AP///88AAAIsBf4GJgCNAAABBwCe/yX//gALtgEHAwEBqVYAKzQA////ugAAAkQFxAYmAI0AAAEHAGr/Vf/+AA23AgEZAwEBtVYAKzQ0AP//AI0AAAPgBewGJgBSAAABBgClYQQAC7YCKgMBAapWACs0AP//AFz/7AQ1BgAGJgBTAAABBwBEAM4AAAALtgIuBgEBjFYAKzQA//8AXP/sBDUGAAYmAFMAAAEHAHUBXgAAAAu2AiwGAQGMVgArNAD//wBc/+wENQYABiYAUwAAAQYAnmgAAAu2Ai8GAQGXVgArNAD//wBc/+wENQXsBiYAUwAAAQYApWMEAAu2AjoGAQGWVgArNAD//wBc/+wENQXGBiYAUwAAAQcAagCYAAAADbcDAkEGAQGjVgArNDQA//8Aif/sA90GAAYmAFkAAAEHAEQAxgAAAAu2Ah4RAQGgVgArNAD//wCJ/+wD3QYABiYAWQAAAQcAdQFWAAAAC7YCHBEBAaBWACs0AP//AIn/7APdBgAGJgBZAAABBgCeYAAAC7YCHxEBAatWACs0AP//AIn/7APdBcYGJgBZAAABBwBqAJAAAAANtwMCMREBAbdWACs0NAD//wAW/ksDsAYABiYAXQAAAQcAdQEbAAAAC7YCGQEBAaBWACs0AP//ABb+SwOwBcYGJgBdAAABBgBqVQAADbcDAi4BAQG3VgArNDQA//8AHQAABR4G5AYmACUAAAEHAHAAxwE/AAu2AxADAQGmVgArNAD//wBt/+wD6gWtBiYARQAAAQYAcG0IAAu2Aj0PAQHRVgArNAD//wAdAAAFHgcOBiYAJQAAAQcAoQDzATcAC7YDEwcBAVNWACs0AP//AG3/7APqBdcGJgBFAAABBwChAJkAAAALtgJADwEBflYAKzQAAAQAHf5OBR4FsAAEAAkADQAjACtAFQ0MDAMWHQYAAgcDAnIODw8FBQIIcgArMhEzETMrMhI5OS8zEjkvMzAxQQEjATMBASczAQMVITUBFw4CFRQWMzI2NxcGBiMiJjU0NjYCxP4exQIrfwGR/h0DfwIt3/zOA6FKK04yIyshNA8OGU07UW81cgUv+tEFsPpQBS+B+lACG56e/h45IEVNLCEoEwh6Dx1hXjZqYgADAG3+TgPqBE4AGwA6AFAAK0AXHjo6D0NKD3InMQtyOzw8GQpyCQUPB3IAKzIyKzIRMysyKzISOS8zMDFlETQmJiMiBgYVIzQ+AjMyFhYVERQWFxUjJiYTFyMiDgIVFBYWMzI2NjcXDgMjIiYmNTQ+AjMBFw4CFRQWMzI2NxcGBiMiJjU0NjYDCzNmS0ZpO7k8cZ9idrVnExPBDhAgArtPfFQsLl1EVYJNA08HPmeNWG6lW0SAtG8BLEorTjIjKyE0Dw4ZTTtRbzVyuQItQF80ME4tOnJdN1Chef4INnosECBrAgWCGTJLMjNUMUhoMVkqZl09VpFaV4VZLv2pOSBFTSwhKBMIeg8dYV42amIA//8AeP/sBNgHVwYmACcAAAEHAHUBxwFXAAu2ASgQAQFtVgArNAD//wBd/+wD7QYABiYARwAAAQcAdQE0AAAAC7YBKBQBAYxWACs0AP//AHj/7ATYB1cGJgAnAAABBwCeANEBVwALtgErEAEBeFYAKzQA//8AXf/sA+0GAAYmAEcAAAEGAJ4+AAALtgErFAEBl1YAKzQA//8AeP/sBNgHGQYmACcAAAEHAKIBrQFXAAu2ATEQAQGCVgArNAD//wBd/+wD7QXCBiYARwAAAQcAogEaAAAAC7YBMRQBAaFWACs0AP//AHj/7ATYB1YGJgAnAAABBwCfAOYBVwALtgEuEAEBdlYAKzQA//8AXf/sA+0F/wYmAEcAAAEGAJ9TAAALtgEuFAEBlVYAKzQA//8AqQAABMcHQQYmACgAAAEHAJ8AnwFCAAu2AiUeAQF1VgArNAD//wBf/+wFLAYCBCYASAAAAQcB1QPVBRMAC7YDOQEBAABWACs0AP//AKkAAARGBu8GJgApAAABBwBwAJIBSgALtgQSBwEBsVYAKzQA//8AXf/sA/MFrQYmAEkAAAEGAHBcCAALtgEuCwEB0VYAKzQA//8AqQAABEYHGQYmACkAAAEHAKEAvgFCAAu2BBUHAQFeVgArNAD//wBd/+wD8wXXBiYASQAAAQcAoQCIAAAAC7YBMQsBAX5WACs0AP//AKkAAARGBwQGJgApAAABBwCiAXABQgALtgQZBwEBgVYAKzQA//8AXf/sA/MFwgYmAEkAAAEHAKIBOgAAAAu2ATULAQGhVgArNAAABQCp/k4ERgWwAAMABwALAA8AJQApQBQKCwsYHw4PDwcCchAREQMCAgYIcgArMhEzMhEzKzIRMy8zOS8zMDFlFSE1ExEjEQEVITUBFSE1ARcOAhUUFjMyNjcXBgYjIiY1NDY2BEb8/SfBAzf9YwL5/QcCcUorTjIjKyE0Dw4ZTTtRbzVynZ2dBRP6UAWw/Y6dnQJynp76iTkgRU0sISgTCHoPHWFeNmpiAAACAF3+aAPzBE4AKwBBACVAExITEws0Ow5yGQsHciwtJCQAC3IAKzIROTkrMisyEjkvMzAxRSIuAjU1ND4CMzIeAhUVITUhNS4CIyIOAhUVFB4CMzI2NxcOAjcXDgIVFBYzMjY3FwYGIyImNTQ2NgJOcbeDRk6Gqlt0qWw0/NgCbwQzbl8/akwqK1N3TGKIM3AjbJ0pSitOMiMrITQPDhlNO1FvNXIUTYzAciqEz5BKUI/BclOXDkiIWDVolmIqTYdmOlBDWTVgPGc5IEVNLCEoEwh6Dx1hXjZqYgD//wCpAAAERgdBBiYAKQAAAQcAnwCpAUIAC7YEFgcBAXVWACs0AP//AF3/7APzBf8GJgBJAAABBgCfcwAAC7YBMgsBAZVWACs0AP//AHr/7ATdB1cGJgArAAABBwCeAMkBVwALtgEvEAEBeFYAKzQA//8AYf5VA/IGAAYmAEsAAAEGAJ5VAAALtgNCGgEBl1YAKzQA//8Aev/sBN0HLgYmACsAAAEHAKEA8wFXAAu2ATEQAQFfVgArNAD//wBh/lUD8gXXBiYASwAAAQYAoX8AAAu2A0QaAQF+VgArNAD//wB6/+wE3QcZBiYAKwAAAQcAogGlAVcAC7YBNRABAYJWACs0AP//AGH+VQPyBcIEJgBLAAABBwCiATEAAAALtgNIGgEBoVYAKzQA//8Aev3zBN0FxAYmACsAAAEHAdUB2v6VAA60ATUFAQG4/5iwVgArNP//AGH+VQPyBpMEJgBLAAABBwJPASsAVwALtgM/GgEBmFYAKzQA//8AqQAABQgHQgYmACwAAAEHAJ4A8QFCAAu2Aw8LAQF3VgArNAD//wCNAAAD4AdBBiYATAAAAQcAngAeAUEAC7YCHgMBASZWACs0AP///7YAAAJ6By4GJgAtAAABBwCl/zsBRgALtgESAwEBdlYAKzQA////mwAAAl8F6gYmAI0AAAEHAKX/IAACAAu2ARIDAQGoVgArNAD////NAAACbAbvBiYALQAAAQcAcP8+AUoAC7YBBgMBAbFWACs0AP///7IAAAJRBasGJgCNAAABBwBw/yMABgALtgEGAwEB41YAKzQA////7AAAAkIHGQYmAC0AAAEHAKH/agFCAAu2AQkDAQFeVgArNAD////RAAACJwXVBiYAjQAAAQcAof9P//4AC7YBCQMBAZBWACs0AP//ABf+VwF4BbAGJgAtAAABBgCk5QkAC7YBBQIAAABWACs0AP////r+TgFpBcQGJgBNAAABBgCkyAAAC7YCEQIAAABWACs0AP//AKoAAAGFBwQGJgAtAAABBwCiABwBQgALtgENAwEBgVYAKzQA//8At//sBfkFsAQmAC0AAAAHAC4CLQAA//8Ajv5LA0wFxAQmAE0AAAAHAE4B8gAA//8ANf/sBIQHNQYmAC4AAAEHAJ4BfQE1AAu2ARcBAQFqVgArNAD///+0/ksCOgXXBiYAnAAAAQcAnv8z/9cAC7YBFQABAYJWACs0AP//AKn+VgUFBbAEJgAvAAABBwHVAZT++AAOtAMXAgEAuP/nsFYAKzT//wCN/kMEDQYABiYATwAAAQcB1QER/uUADrQDFwIBAbj/1LBWACs0//8AogAABBwHMgYmADAAAAEHAHUAJwEyAAu2AggHAQFcVgArNAD//wCTAAACNAeXBiYAUAAAAQcAdQAYAZcAC7YBBAMBAXFWACs0AP//AKn+BgQcBbAEJgAwAAABBwHVAWz+qAAOtAIRAgEBuP+XsFYAKzT//wBW/gYBVgYABCYAUAAAAQcB1f/5/qgADrQBDQIBAbj/l7BWACs0//8AqQAABBwFsQYmADAAAAEHAdUB1gTCAAu2AhEHAAABVgArNAD//wCcAAACrQYCBCYAUAAAAQcB1QFWBRMAC7YBDQMAAAJWACs0AP//AKkAAAQcBbAGJgAwAAAABwCiAbz9xP//AJwAAAKiBgAEJgBQAAAABwCiATn9tf//AKkAAAUJBzcGJgAyAAABBwB1AfUBNwALtgEKBgEBYVYAKzQA//8AjQAAA+AGAAYmAFIAAAEHAHUBXAAAAAu2AhwDAQGgVgArNAD//wCp/gYFCQWwBCYAMgAAAQcB1QHQ/qgADrQBEwUBAbj/l7BWACs0//8Ajf4GA+AETgQmAFIAAAEHAdUBM/6oAA60AiUCAQG4/5ewVgArNP//AKkAAAUJBzYGJgAyAAABBwCfARQBNwALtgEQCQEBalYAKzQA//8AjQAAA+AF/wYmAFIAAAEGAJ97AAALtgIiAwEBqVYAKzQA////uwAAA+AGBQYmAFIAAAEHAdX/XgUWAAu2AiADAQE6VgArNAD//wB3/+wFCgbmBiYAMwAAAQcAcADqAUEAC7YCLhEBAZRWACs0AP//AFz/7AQ1Ba0GJgBTAAABBgBwZggAC7YCLgYBAdFWACs0AP//AHf/7AUKBxAGJgAzAAABBwChARYBOQALtgIxEQEBQVYAKzQA//8AXP/sBDUF1wYmAFMAAAEHAKEAkgAAAAu2AjEGAQF+VgArNAD//wB3/+wFCgc4BiYAMwAAAQcApgFrATkADbcDAiwRAQFFVgArNDQA//8AXP/sBDUF/wYmAFMAAAEHAKYA5wAAAA23AwIsBgEBglYAKzQ0AP//AKkAAATKBzcGJgA2AAABBwB1AYEBNwALtgIeAAEBYVYAKzQA//8AjQAAAtMGAAYmAFYAAAEHAHUAtwAAAAu2AhcDAQGgVgArNAD//wCp/gYEygWwBCYANgAAAQcB1QFj/qgADrQCJxgBAbj/l7BWACs0//8AU/4HApgETgQmAFYAAAEHAdX/9v6pAA60AiACAQG4/5iwVgArNP//AKkAAATKBzYGJgA2AAABBwCfAKABNwALtgIkAAEBalYAKzQA//8AZAAAAs4F/wYmAFYAAAEGAJ/WAAALtgIdAwEBqVYAKzQA//8AUf/sBHMHOQYmADcAAAEHAHUBjQE5AAu2AToPAQFPVgArNAD//wBf/+wDvAYABiYAVwAAAQcAdQFRAAAAC7YBNg4BAYxWACs0AP//AFH/7ARzBzkGJgA3AAABBwCeAJcBOQALtgE9DwEBWlYAKzQA//8AX//sA7wGAAYmAFcAAAEGAJ5bAAALtgE5DgEBl1YAKzQA//8AUf5MBHMFxAYmADcAAAEHAHkBn///AAu2ATorAAATVgArNAD//wBf/kMDvAROBiYAVwAAAQcAeQFd//YAC7YBNikAAApWACs0AP//AFH9+wRzBcQGJgA3AAABBwHVAXT+nQAOtAFDKwEBuP+gsFYAKzT//wBf/fIDvAROBiYAVwAAAQcB1QEy/pQADrQBPykBAbj/l7BWACs0//8AUf/sBHMHOAYmADcAAAEHAJ8ArAE5AAu2AUAPAQFYVgArNAD//wBf/+wDvAX/BiYAVwAAAQYAn3AAAAu2ATwOAQGVVgArNAD//wAy/fwElwWwBiYAOAAAAQcB1QFm/p4ADrQCEQIBAbj/jbBWACs0//8ACf38AlcFQQYmAFgAAAEHAdUAxf6eAA60Ah8RAQG4/6GwVgArNP//ADL+TQSXBbAGJgA4AAABBwB5AZEAAAALtgIIAgEAAFYAKzQA//8ACf5NApoFQQYmAFgAAAEHAHkA8AAAAAu2AhYRAAAUVgArNAD//wAyAAAElwc1BiYAOAAAAQcAnwCiATYAC7YCDgMBAWlWACs0AP//AAn/7ALsBnoEJgBYAAABBwHVAZUFiwAOtAIaBAEAuP+osFYAKzT//wCM/+wEqgcjBiYAOQAAAQcApQC/ATsAC7YBJAsBAWtWACs0AP//AIn/7APdBewGJgBZAAABBgClWwQAC7YCKhEBAapWACs0AP//AIz/7ASqBuQGJgA5AAABBwBwAMIBPwALtgEYCwEBplYAKzQA//8Aif/sA90FrQYmAFkAAAEGAHBeCAALtgIeEQEB5VYAKzQA//8AjP/sBKoHDgYmADkAAAEHAKEA7gE3AAu2ARsAAQFTVgArNAD//wCJ/+wD3QXXBiYAWQAAAQcAoQCKAAAAC7YCIREBAZJWACs0AP//AIz/7ASqB5MGJgA5AAABBwCjAUsBQgANtwIBIQABAUdWACs0NAD//wCJ/+wD3QZcBiYAWQAAAQcAowDnAAsADbcDAicRAQGGVgArNDQA//8AjP/sBKoHNgYmADkAAAEHAKYBQwE3AA23AgEWAAEBV1YAKzQ0AP//AIn/7AQLBf8GJgBZAAABBwCmAN8AAAANtwMCHBEBAZZWACs0NAAAAgCM/noEqgWwABUAKwAbQA0eJQELAnIXFhERBglyACsyEjk5KzIvMzAxQTMRFAYGIyImJjURMxEUFhYzMjY2NQMXDgIVFBYzMjY3FwYGIyImNTQ2NgPqwJLxjZTvi79Ul2Rll1SHSitOMiMrITQPDhlNO1FvNXIFsPwnpNptbdqkA9n8J3KUSEiUcv6OOSBFTSwhKBMIeg8dYV42amIAAAMAif5OA+gEOgAEABsAMQAhQBEkKw9yAREGchwdHQQEGAsLcgArMjIRMxEzKzIrMjAxZREzESMTNxQOAiMiLgI1ETMRFB4CMzI2NhMXDgIVFBYzMjY3FwYGIyImNTQ2NgMjurEaTS1konRPg14zuSE5RyZ2ij1DSitOMiMrITQPDhlNO1FvNXL6A0D7xgHeAmy3hksuYJpsArr9RElfNxZbm/66OSBFTSwhKBMIeg8dYV42amL//wA9AAAG7Qc3BiYAOwAAAQcAngHFATcAC7YEGRUBAWxWACs0AP//ACsAAAXTBgAGJgBbAAABBwCeASQAAAALtgQZFQEBq1YAKzQA//8ADwAABLwHNgYmAD0AAAEHAJ4AkwE2AAu2AQwCAQFrVgArNAD//wAW/ksDsAYABiYAXQAAAQYAniUAAAu2AhwBAQGrVgArNAD//wAPAAAEvAb8BiYAPQAAAQcAagDDATYADbcCAR4CAQF3VgArNDQA//8AVwAABHoHNwYmAD4AAAEHAHUBhwE3AAu2Aw4NAQFhVgArNAD//wBZAAADswYABiYAXgAAAQcAdQEiAAAAC7YDDg0BAaBWACs0AP//AFcAAAR6BvkGJgA+AAABBwCiAW0BNwALtgMXCAEBdlYAKzQA//8AWQAAA7MFwgYmAF4AAAEHAKIBCAAAAAu2AxcIAQG1VgArNAD//wBXAAAEegc2BiYAPgAAAQcAnwCmATcAC7YDFAgBAWpWACs0AP//AFkAAAOzBf8GJgBeAAABBgCfQQAAC7YDFAgBAalWACs0AP////EAAAdYB0IGJgCBAAABBwB1AsoBQgALtgYZAwEBbFYAKzQA//8AT//rBn0GAQYmAIYAAAEHAHUCegABAAu2A18PAQGNVgArNAD//wB3/6MFHQeABiYAgwAAAQcAdQHqAYAAC7YDNBYBAZZWACs0AP//AFz/eQQ0Bf8GJgCJAAABBwB1ATj//wALtgMwCgEBi1YAKzQA////vQAABCAEjQYmAksAAAAHAkH/Lv92////vQAABCAEjQYmAksAAAAHAkH/Lv92//8AKQAAA/0EjQYmAfMAAAAGAkFG3///ABQAAARxBh4GJgJOAAABBwBEANQAHgALtgMQBwEBa1YAKzQA//8AFAAABHEGHgYmAk4AAAEHAHUBZAAeAAu2Aw4DAQFrVgArNAD//wAUAAAEcQYeBiYCTgAAAQYAnm4eAAu2AxMDAQFrVgArNAD//wAUAAAEcQYKBiYCTgAAAQYApWkiAAu2AxsDAQFrVgArNAD//wAUAAAEcQXkBiYCTgAAAQcAagCeAB4ADbcEAxcDAQFrVgArNDQA//8AFAAABHEGegYmAk4AAAEHAKMA9QApAA23BAMZAwEBUVYAKzQ0AP//ABQAAARxBnsGJgJOAAAABwJCAP4ACf//AGH+SQQxBJ0GJgJMAAAABwB5AXX//P//AIsAAAOvBh4GJgJDAAABBwBEAKgAHgALtgQSBwEBbFYAKzQA//8AiwAAA68GHgYmAkMAAAEHAHUBOAAeAAu2BBAHAQFsVgArNAD//wCLAAADrwYeBiYCQwAAAQYAnkIeAAu2BBYHAQFsVgArNAD//wCLAAADrwXkBiYCQwAAAQYAanIeAA23BQQZBwEBhFYAKzQ0AP///7wAAAFdBh4GJgH+AAABBgBEgx4AC7YBBgMBAWtWACs0AP//AI4AAAIvBh4GJgH+AAABBgB1Ex4AC7YBBAMBAWtWACs0AP///8cAAAIkBh4GJgH+AAABBwCe/x0AHgALtgEJAwEBdlYAKzQA////sgAAAjwF5AYmAf4AAAEHAGr/TQAeAA23AgENAwEBhFYAKzQ0AP//AIsAAARZBgoGJgH5AAABBwClAJQAIgALtgEYBgEBdlYAKzQA//8AYP/wBFsGHgYmAfgAAAEHAEQA7QAeAAu2Ai4RAQFbVgArNAD//wBg//AEWwYeBiYB+AAAAQcAdQF9AB4AC7YCLBEBAVtWACs0AP//AGD/8ARbBh4GJgH4AAABBwCeAIcAHgALtgIxEQEBW1YAKzQA//8AYP/wBFsGCgYmAfgAAAEHAKUAggAiAAu2AjERAQFvVgArNAD//wBg//AEWwXkBiYB+AAAAQcAagC3AB4ADbcDAjURAQF0VgArNDQA//8Adf/wBAsGHgYmAfIAAAEHAEQAzwAeAAu2ARgLAQFrVgArNAD//wB1//AECwYeBiYB8gAAAQcAdQFfAB4AC7YBFgsBAWtWACs0AP//AHX/8AQLBh4GJgHyAAABBgCeaR4AC7YBGwsBAWtWACs0AP//AHX/8AQLBeQGJgHyAAABBwBqAJkAHgANtwIBHwsBAYRWACs0NAD//wAOAAAEHAYeBiYB7gAAAQcAdQE0AB4AC7YDDgkBAWtWACs0AP//ABQAAARxBcsGJgJOAAABBgBwbCYAC7YDEAMBAbBWACs0AP//ABQAAARxBfUGJgJOAAABBwChAJgAHgALtgMTAwEBXVYAKzQAAAQAFP5OBHEEjQAEAAkADQAjACFADw0MDAMWHQgDfQ8OBQUBEgA/MxEzMz8zLzMSOS8zMDFBASMBMwEBJzMBAxUhNQEXDgIVFBYzMjY3FwYGIyImNTQ2NgJe/nO9Ad95AUn+dg16AdnX/UwDGkorTjIjKyE0Dw4ZTTtRbzVyA+r8FgSN+3MD7p/7cwGvmJj+ijkgRU0sISgTCHoPHWFeNmpi//8AYf/wBDEGHgYmAkwAAAEHAHUBagAeAAu2ASgQAQFbVgArNAD//wBh//AEMQYeBiYCTAAAAQYAnnQeAAu2AS0QAQFbVgArNAD//wBh//AEMQXgBiYCTAAAAQcAogFQAB4AC7YBMRABAXBWACs0AP//AGH/8AQxBh0GJgJMAAABBwCfAIkAHgALtgEuEAEBZFYAKzQA//8AiwAABCAGHQYmAksAAAEGAJ8yHgALtgIkHQEBdFYAKzQA//8AiwAAA68FywYmAkMAAAEGAHBAJgALtgQSBwEBsFYAKzQA//8AiwAAA68F9QYmAkMAAAEGAKFsHgALtgQVBwEBXlYAKzQA//8AiwAAA68F4AYmAkMAAAEHAKIBHgAeAAu2BBkHAQGAVgArNAAABQCL/k4DrwSNAAMABwALAA8AJQAjQBAYHwsKCgYPDgd9ERAQBQYSAD8zMxEzPzMzEjkvMy8zMDFlFSE1ExEjEQEVITUBFSE1ARcOAhUUFjMyNjcXBgYjIiY1NDY2A6/9aC25As39vwKS/W4CEUorTjIjKyE0Dw4ZTTtRbzVymJiYA/X7cwSN/hmXlwHnmZn7rDkgRU0sISgTCHoPHWFeNmpiAP//AIsAAAOvBh0GJgJDAAABBgCfVx4AC7YEFgcBAXRWACs0AP//AGT/8AQ2Bh4GJgIAAAABBgCecR4AC7YBMBABAWZWACs0AP//AGT/8AQ2BfUGJgIAAAABBwChAJsAHgALtgEwEAEBTVYAKzQA//8AZP/wBDYF4AYmAgAAAAEHAKIBTQAeAAu2ATQQAQFwVgArNAD//wBk/fgENgSdBiYCAAAAAQcB1QFP/poADrQBNAUBAbj/mbBWACs0//8AiwAABFkGHgYmAf8AAAEHAJ4AkAAeAAu2AxEHAQF2VgArNAD///+TAAACVwYKBiYB/gAAAQcApf8YACIAC7YBCQMBAX9WACs0AP///6oAAAJJBcsGJgH+AAABBwBw/xsAJgALtgEGAwEBsFYAKzQA////yQAAAh8F9QYmAf4AAAEHAKH/RwAeAAu2AQkDAQFdVgArNAD//wAF/k4BZgSNBiYB/gAAAAYApNMA//8AhwAAAWIF4AYmAf4AAAEGAKL5HgALtgENAwEBgFYAKzQA//8ALP/wBA4GHgYmAf0AAAEHAJ4BBwAeAAu2ARkBAQF2VgArNAD//wCL/gIEVwSNBiYB/AAAAAcB1QEU/qT//wCDAAADiwYeBiYB+wAAAQYAdQgeAAu2AggHAQFrVgArNAD//wCL/gQDiwSNBiYB+wAAAQcB1QEP/qYADrQCEQYBAbj/lbBWACs0//8AiwAAA4sEjwYmAfsAAAAHAdUBfgOg//8AiwAAA4sEjQYmAfsAAAAHAKIBZv01//8AiwAABFkGHgYmAfkAAAEHAHUBjwAeAAu2AQoGAQFrVgArNAD//wCL/gAEWQSNBiYB+QAAAAcB1QFr/qL//wCLAAAEWQYdBiYB+QAAAQcAnwCuAB4AC7YBEAYBAXRWACs0AP//AGD/8ARbBcsGJgH4AAABBwBwAIUAJgALtgIuEQEBoFYAKzQA//8AYP/wBFsF9QYmAfgAAAEHAKEAsQAeAAu2AjERAQFNVgArNAD//wBg//AEWwYdBiYB+AAAAQcApgEGAB4ADbcDAjARAQFRVgArNDQA//8AigAABCYGHgYmAfUAAAEHAHUBJwAeAAu2Ah8AAQFrVgArNAD//wCK/gQEJgSNBiYB9QAAAAcB1QEN/qb//wCKAAAEJgYdBiYB9QAAAQYAn0YeAAu2AiUAAQF0VgArNAD//wBE//AD3gYeBiYB9AAAAQcAdQE+AB4AC7YBOg8BAVtWACs0AP//AET/8APeBh4GJgH0AAABBgCeSB4AC7YBPw8BAWZWACs0AP//AET+TQPeBJ0GJgH0AAAABwB5AVMAAP//AET/8APeBh0GJgH0AAABBgCfXR4AC7YBQA8BAWZWACs0AP//ACn9/wP9BI0GJgHzAAABBwHVARP+oQAOtAIRAgEBuP+QsFYAKzT//wApAAAD/QYdBiYB8wAAAQYAn1AeAAu2Ag4HAQF0VgArNAD//wAp/lAD/QSNBiYB8wAAAAcAeQE+AAP//wB1//AECwYKBiYB8gAAAQYApWQiAAu2ARsLAQF/VgArNAD//wB1//AECwXLBiYB8gAAAQYAcGcmAAu2ARgLAQGwVgArNAD//wB1//AECwX1BiYB8gAAAQcAoQCTAB4AC7YBGwsBAV1WACs0AP//AHX/8AQLBnoGJgHyAAABBwCjAPAAKQANtwIBIQsBAVFWACs0NAD//wB1//AEFAYdBiYB8gAAAQcApgDoAB4ADbcCARoLAQFhVgArNDQAAAIAdf5zBAsEjQAVACsAGkAMHiUXFhYRBgtyDAB9AD8yKzIyETMvMzAxQTMRFAYGIyImJjURMxEUFhYzMjY2NQMXDgIVFBYzMjY3FwYGIyImNTQ2NgNRun3RfoPPeLdFfFJTe0RrSitOMiMrITQPDhlNO1FvNXIEjfz0hLNaWrOEAwz89FZvNTVvVv7dOSBFTSwhKBMIeg8dYV42amL//wAxAAAF8QYeBiYB8AAAAQcAngE7AB4AC7YEGwoBAXZWACs0AP//AA4AAAQcBh4GJgHuAAABBgCePh4AC7YDEwkBAXZWACs0AP//AA4AAAQcBeQGJgHuAAABBgBqbh4ADbcEAxcJAQGEVgArNDQA//8ASAAAA+EGHgYmAe0AAAEHAHUBNAAeAAu2Aw4NAQFrVgArNAD//wBIAAAD4QXgBiYB7QAAAQcAogEaAB4AC7YDFw0BAYBWACs0AP//AEgAAAPhBh0GJgHtAAABBgCfUx4AC7YDFA0BAXRWACs0AP//AB0AAAUeBj4GJgAlAAABBgCuA/8ADrQDDgMAALj/PrBWACs0////jAAABKoGPwQmAClkAAEHAK7+1AAAAA60BBAHAAC4/z+wVgArNP///5oAAAVsBkEEJgAsZAAABwCu/uIAAv///6AAAAHcBkEEJgAtZAABBwCu/ugAAgAOtAEEAwAAuP9BsFYAKzT////6/+wFHgY+BCYAMxQAAQcArv9C//8ADrQCLBEAALj/KrBWACs0////dgAABSAGPgQmAD1kAAEHAK7+vv//AAu2AQoIAACOVgArNAD////8AAAE4AY+BCYAuhQAAQcArv9E//8ADrQDNh0AALj/KrBWACs0////m//zAqwGdAYmAMMAAAEHAK//Kf/rABBACQMCASsAAQGiVgArNDQ0//8AHQAABR4FsAYGACUAAP//AKkAAASIBbAGBgAmAAD//wCpAAAERgWwBgYAKQAA//8AVwAABHoFsAYGAD4AAP//AKkAAAUIBbAGBgAsAAD//wC3AAABeAWwBgYALQAA//8AqQAABQUFsAYGAC8AAP//AKkAAAZSBbAGBgAxAAD//wCpAAAFCQWwBgYAMgAA//8Ad//sBQoFxAYGADMAAP//AKkAAATBBbAGBgA0AAD//wAyAAAElwWwBgYAOAAA//8ADwAABLwFsAYGAD0AAP//ADoAAATOBbAGBgA8AAD////VAAACXwcIBiYALQAAAQcAav9wAUIADbcCARkDAQGDVgArNDQA//8ADwAABLwG/AYmAD0AAAEHAGoAwwE2AA23AgEeAgEBd1YAKzQ0AP//AGT/6wR4BjgGJgC7AAABBwCuAXX/+QALtgNCBgEBmlYAKzQA//8AZP/sA+wGNwYmAL8AAAEHAK4BK//4AAu2AkArAQGaVgArNAD//wCS/mED8QY4BiYAwQAAAQcArgFG//kAC7YCHQMBAa5WACs0AP//AMP/8wJMBiMGJgDDAAABBgCuKuQAC7YBEgABAZlWACs0AP//AJD/6wP3BnQGJgDLAAABBgCvIusAEEAJAwIBOA8BAaJWACs0NDT//wCbAAAEQAQ6BgYAjgAA//8AXP/sBDUETgYGAFMAAP//AJv+YAPuBDoGBgB2AAD//wAhAAADuwQ6BgYAWgAA//8AWv5MBHUESQYGAosAAP///+T/8wJuBbEGJgDDAAABBwBq/3//6wANtwIBJwABAaJWACs0NAD//wCQ/+sD9wWxBiYAywAAAQYAanjrAA23AgE0DwEBolYAKzQ0AP//AFz/7AQ1BjgGJgBTAAABBwCuAUP/+QALtgIsBgEBmlYAKzQA//8AkP/rA/cGIwYmAMsAAAEHAK4BI//kAAu2AR8PAQGZVgArNAD//wB6/+sGGgYgBiYAzgAAAQcArgJU/+EAC7YCQB8BAZZWACs0AP//AKkAAARGBwgGJgApAAABBwBqAMQBQgANtwUEJQcBAYNWACs0NAD//wCyAAAEMAdCBiYAsQAAAQcAdQGQAUIAC7YBBgUBAWxWACs0AAABAFH/7ARzBcQAOQAbQA0KJg82MSsJchgUDwNyACvMMyvMMxI5OTAxQTQuAicuAzU0PgIzMhYWFSM0JiYjIgYGFRQeAhceAxUUDgIjIi4CNTMUHgIzMjY2A7EfTYdnbK58QkaDtnCk5XjARo5tZ4ZBJ1OBWny0dTlIhrtzZcOfX8A6ZYFGZYxJAXAzT0A6HiBPZoRVVZBrPH3JclJ/ST5qRC5LQDYZI1Zrh1VZkGY3OHClbUtrRiE4aP//ALcAAAF4BbAGBgAtAAD////VAAACXwcIBiYALQAAAQcAav9wAUIADbcCARkDAQGDVgArNDQA//8ANf/sA8wFsAYGAC4AAP//ALIAAAUeBbAGBgJHAAD//wCpAAAFBQcxBiYALwAAAQcAdQF8ATEAC7YDDgMBAVtWACs0AP//AE3/6wTLBxkGJgDeAAABBwChANkBQgALtgIeAQEBXlYAKzQA//8AHQAABR4FsAYGACUAAP//AKkAAASIBbAGBgAmAAD//wCyAAAEMAWwBgYAsQAA//8AqQAABEYFsAYGACkAAP//ALIAAAUABxkGJgDcAAABBwChATABQgALtgEPAQEBXlYAKzQA//8AqQAABlIFsAYGADEAAP//AKkAAAUIBbAGBgAsAAD//wB3/+wFCgXEBgYAMwAA//8AsgAABQEFsAYGALYAAP//AKkAAATBBbAGBgA0AAD//wB4/+wE2AXEBgYAJwAA//8AMgAABJcFsAYGADgAAP//ADoAAATOBbAGBgA8AAD//wBt/+wD6gROBgYARQAA//8AXf/sA/METgYGAEkAAP//AJ0AAAQCBcIGJgDwAAABBwChAKH/6wALtgEPAQEBfVYAKzQA//8AXP/sBDUETgYGAFMAAP//AIz+YAQfBE4GBgBUAAAAAQBd/+wD7QROACcAE0AJAAkdFAdyCQtyACsrMhEzMDFlMjY2NzMOAiMiLgI1NTQ+AjMyFhYXIy4CIyIOAhUVFB4CAj5CcEgFsAV3wHN6tXc7O3e1en++bQWwBUFvSlVzQx0cQ3OENl89YKVlVpbDbSptw5ZWZ7FwQ2xBQ3GJRypHinBDAP//ABb+SwOwBDoGBgBdAAD//wAqAAADywQ6BgYAXAAA//8AXf/sA/MFxgYmAEkAAAEHAGoAjgAAAA23AgFBCwEBo1YAKzQ0AP//AJsAAANIBesGJgDsAAABBwB1AM7/6wALtgEGBQEBi1YAKzQA//8AX//sA7wETgYGAFcAAP//AI4AAAFpBcQGBgBNAAD///+6AAACRAXEBiYAjQAAAQcAav9V//4ADbcCARkDAQG1VgArNDQA////vv5LAVoFxAYGAE4AAP//AJ0AAARABeoGJgDxAAABBwB1ATz/6gALtgMOAwEBilYAKzQA//8AFv5LA7AF1wYmAF0AAAEGAKFPAAALtgIeAQEBklYAKzQA//8APQAABu0HNwYmADsAAAEHAEQCKwE3AAu2BBgVAQFhVgArNAD//wArAAAF0wYABiYAWwAAAQcARAGKAAAAC7YEGBUBAaBWACs0AP//AD0AAAbtBzcGJgA7AAABBwB1ArsBNwALtgQWAQEBYVYAKzQA//8AKwAABdMGAAYmAFsAAAEHAHUCGgAAAAu2BBYBAQGgVgArNAD//wA9AAAG7Qb9BiYAOwAAAQcAagH1ATcADbcFBCsVAQF4VgArNDQA//8AKwAABdMFxgYmAFsAAAEHAGoBVAAAAA23BQQrFQEBt1YAKzQ0AP//AA8AAAS8BzYGJgA9AAABBwBEAPkBNgALtgELAgEBYFYAKzQA//8AFv5LA7AGAAYmAF0AAAEHAEQAiwAAAAu2AhsBAQGgVgArNAD//wBoBCIA/gYABgYACwAA//8AiQQTAiQGAAYGAAYAAP//AKH/9AOMBbAEJgAFAAAABwAFAhAAAP///7T+SwJABdYGJgCcAAABBwCf/0j/1wALtgEYAAEBgFYAKzQA//8AMAQWAUgGAAYGAYYAAP//AKkAAAZSBzcGJgAxAAABBwB1ApkBNwALtgMRAAEBYVYAKzQA//8AiwAABnkGAAYmAFEAAAEHAHUCrgAAAAu2AzMDAQGgVgArNAD//wAd/msFHgWwBiYAJQAAAQcApwGAAAEAELUEAxEFAQG4/7WwVgArNDT//wBt/msD6gROBiYARQAAAQcApwDIAAEAELUDAj4xAQG4/8mwVgArNDT//wCpAAAERgdCBiYAKQAAAQcARAD6AUIAC7YEEgcBAWxWACs0AP//ALIAAAUAB0IGJgDcAAABBwBEAWwBQgALtgEMAQEBbFYAKzQA//8AXf/sA/MGAAYmAEkAAAEHAEQAxAAAAAu2AS4LAQGMVgArNAD//wCdAAAEAgXrBiYA8AAAAQcARADd/+sAC7YBDAEBAYtWACs0AP//AFoAAAUiBbAGBgC5AAD//wBg/icFQwQ6BgYAzQAA//8AFgAABN0G5wYmARkAAAEHAKwEOgD5AA23AwIVEwEBLVYAKzQ0AP////sAAAQMBb8GJgEaAAABBwCsA9T/0QANtwMCGRcBAXtWACs0NAD//wBc/ksIQAROBCYAUwAAAAcAXQSQAAD//wB3/ksJMQXEBCYAMwAAAAcAXQWBAAD//wBQ/k8EawXEBiYA2wAAAQcCbAGb/7YAC7YCQioAAGRWACs0AP//AFj+UAOtBE0GJgDvAAABBwJsAUP/twALtgI/KQAAZVYAKzQA//8AeP5PBNgFxAYmACcAAAEHAmwB5f+2AAu2ASsFAABkVgArNAD//wBd/k8D7QROBiYARwAAAQcCbAFS/7YAC7YBKwkAAGRWACs0AP//AA8AAAS8BbAGBgA9AAD//wAv/l8D4AQ6BgYAvQAA//8AtwAAAXgFsAYGAC0AAP//ABsAAAc2BxkGJgDaAAABBwChAfgBQgALtgUdDQEBXlYAKzQA//8AFgAABgQFwgYmAO4AAAEHAKEBX//rAAu2BR0NAQF9VgArNAD//wC3AAABeAWwBgYALQAA//8AHQAABR4HDgYmACUAAAEHAKEA8wE3AAu2AxMHAQFTVgArNAD//wBt/+wD6gXXBiYARQAAAQcAoQCZAAAAC7YCQA8BAX5WACs0AP//AB0AAAUeBv0GJgAlAAABBwBqAPkBNwANtwQDIwcBAXhWACs0NAD//wBt/+wD6gXGBiYARQAAAQcAagCfAAAADbcDAlAPAQGjVgArNDQA////8QAAB1gFsAYGAIEAAP//AE//6wZ9BE8GBgCGAAD//wCpAAAERgcZBiYAKQAAAQcAoQC+AUIAC7YEFQcBAV5WACs0AP//AF3/7APzBdcGJgBJAAABBwChAIgAAAALtgExCwEBflYAKzQA//8AXv/rBRIG2gYmAVgAAAEHAGoA1AEUAA23AgFCAAEBQVYAKzQ0AP//AGP/7APqBFAGBgCdAAD//wBj/+wD6gXHBiYAnQAAAQcAagCIAAEADbcCAUAAAQGiVgArNDQA//8AGwAABzYHCAYmANoAAAEHAGoB/gFCAA23BgUtDQEBg1YAKzQ0AP//ABYAAAYEBbEGJgDuAAABBwBqAWX/6wANtwYFLQ0BAaJWACs0NAD//wBQ/+wEawcdBiYA2wAAAQcAagC3AVcADbcDAlQVAQGEVgArNDQA//8AWP/sA60FxQYmAO8AAAEGAGpf/wANtwMCURQBAaNWACs0NAD//wCyAAAFAAbvBiYA3AAAAQcAcAEEAUoAC7YBDAgBAbFWACs0AP//AJ0AAAQCBZgGJgDwAAABBgBwdfMAC7YBDAgBAdBWACs0AP//ALIAAAUABwgGJgDcAAABBwBqATYBQgANtwIBHwEBAYNWACs0NAD//wCdAAAEAgWxBiYA8AAAAQcAagCn/+sADbcCAR8BAQGiVgArNDQA//8Ad//sBQoG/wYmADMAAAEHAGoBHAE5AA23AwJBEQEBZlYAKzQ0AP//AFz/7AQ1BcYGJgBTAAABBwBqAJgAAAANtwMCQQYBAaNWACs0NAD//wBn/+wE+gXEBgYBFwAA//8AXP/sBDQETgYGARgAAP//AGf/7AT6BwMGJgEXAAABBwBqASgBPQANtwQDTwABAWpWACs0NAD//wBc/+wENAXIBiYBGAAAAQcAagCIAAIADbcEA0EAAQGlVgArNDQA//8AlP/sBPQHHgYmAOcAAAEHAGoBDQFYAA23AwJCHgEBhVYAKzQ0AP//AGT/6wPhBcYGJgD/AAABBgBqfAAADbcDAkEJAQGjVgArNDQA//8ATf/rBMsG7wYmAN4AAAEHAHAArQFKAAu2AhsYAQGxVgArNAD//wAW/ksDsAWtBiYAXQAAAQYAcCMIAAu2AhsYAQHlVgArNAD//wBN/+sEywcIBiYA3gAAAQcAagDfAUIADbcDAi4BAQGDVgArNDQA//8AFv5LA7AFxgYmAF0AAAEGAGpVAAANtwMCLgEBAbdWACs0NAD//wBN/+sEywdBBiYA3gAAAQcApgEuAUIADbcDAhkBAQFiVgArNDQA//8AFv5LA9AF/wYmAF0AAAEHAKYApAAAAA23AwIZAQEBllYAKzQ0AP//AJcAAATJBwgGJgDhAAABBwBqAQkBQgANtwMCLxYBAYNWACs0NAD//wBoAAADvQWxBiYA+QAAAQYAamXrAA23AwItAwEBolYAKzQ0AP//ALIAAAYxBwgGJgDlAAABBwBqAdMBQgANtwMCMhwBAYNWACs0NAD//wCeAAAFfwWxBiYA/QAAAQcAagFt/+sADbcDAjIcAQGiVgArNDQA//8AX//sA/EGAAYGAEgAAP//AB3+ogUeBbAGJgAlAAABBwCtBQMAAAAOtAMRBQEBuP91sFYAKzT//wBt/qID6gROBiYARQAAAQcArQRLAAAADrQCPjEBAbj/ibBWACs0//8AHQAABR4HuwYmACUAAAEHAKsE7gFHAAu2Aw8HAQFxVgArNAD//wBt/+wD6gaEBiYARQAAAQcAqwSUABAAC7YCPA8BAZxWACs0AP//AB0AAAUeB8QGJgAlAAABBwJSAMIBLwANtwQDEgcBAWFWACs0NAD//wBt/+wEwAaNBiYARQAAAQYCUmj4AA23AwJBDwEBjFYAKzQ0AP//AB0AAAUeB8AGJgAlAAABBwJTAMYBPQANtwQDEAcBAVxWACs0NAD////J/+wD6gaJBiYARQAAAQYCU2wGAA23AwI9DwEBh1YAKzQ0AP//AB0AAAUeB+wGJgAlAAABBwJUAMcBHAANtwQDEwMBAVBWACs0NAD//wBt/+wEWga1BiYARQAAAQYCVG3lAA23AwJADwEBe1YAKzQ0AP//AB0AAAUeB9oGJgAlAAABBwJVAMcBBgANtwQDEAcBATpWACs0NAD//wBt/+wD6gajBiYARQAAAQYCVW3PAA23AwI9DwEBZVYAKzQ0AP//AB3+ogUeBzcGJgAlAAAAJwCeAMkBNwEHAK0FAwAAABe0BBoFAQG4/3W3VgMRBwEBbFYAKzQrNAD//wBt/qID6gYABiYARQAAACYAnm8AAQcArQRLAAAAF7QDRzEBAbj/ibdWAj4PAQGXVgArNCs0AP//AB0AAAUeB7gGJgAlAAABBwJXAOoBLQANtwQDEwcBAVxWACs0NAD//wBt/+wD6gaBBiYARQAAAQcCVwCQ//YADbcDAkAPAQGHVgArNDQA//8AHQAABR4HuAYmACUAAAEHAlAA6gEtAA23BAMTBwEBXFYAKzQ0AP//AG3/7APqBoEGJgBFAAABBwJQAJD/9gANtwMCQA8BAYdWACs0NAD//wAdAAAFHghCBiYAJQAAAQcCWADuAT4ADbcEAxMHAQFuVgArNDQA//8Abf/sA+oHCwYmAEUAAAEHAlgAlAAHAA23AwJADwEBmVYAKzQ0AP//AB0AAAUeCBYGJgAlAAABBwJrAO4BRgANtwQDEwcBAW9WACs0NAD//wBt/+wD6gbfBiYARQAAAQcCawCUAA8ADbcDAkAPAQGaVgArNDQA//8AHf6iBR4HDgYmACUAAAAnAKEA8wE3AQcArQUDAAAAF7QEIAUBAbj/dbdWAxMHAQFTVgArNCs0AP//AG3+ogPqBdcGJgBFAAAAJwChAJkAAAEHAK0ESwAAABe0A00xAQG4/4m3VgJADwEBflYAKzQrNAD//wCp/qwERgWwBiYAKQAAAQcArQTAAAoADrQEEwIBAbj/f7BWACs0//8AXf6iA/METgYmAEkAAAEHAK0EjQAAAA60AS8AAQG4/4mwVgArNP//AKkAAARGB8YGJgApAAABBwCrBLkBUgALtgQRBwEBfFYAKzQA//8AXf/sA/MGhAYmAEkAAAEHAKsEgwAQAAu2AS0LAQGcVgArNAD//wCpAAAERgcuBiYAKQAAAQcApQCPAUYAC7YEHgcBAXZWACs0AP//AF3/7APzBewGJgBJAAABBgClWQQAC7YBOgsBAZZWACs0AP//AKkAAATlB88GJgApAAABBwJSAI0BOgANtwUEFAcBAWxWACs0NAD//wBd/+wErwaNBiYASQAAAQYCUlf4AA23AgEwCwEBjFYAKzQ0AP///+4AAARGB8sGJgApAAABBwJTAJEBSAANtwUEEgcBAWdWACs0NAD///+4/+wD8waJBiYASQAAAQYCU1sGAA23AgEuCwEBh1YAKzQ0AP//AKkAAAR/B/cGJgApAAABBwJUAJIBJwANtwUEFQcBAVtWACs0NAD//wBd/+wESQa1BiYASQAAAQYCVFzlAA23AgExCwEBe1YAKzQ0AP//AKkAAARGB+UGJgApAAABBwJVAJIBEQANtwUEEgcBAUVWACs0NAD//wBd/+wD8wajBiYASQAAAQYCVVzPAA23AgEuCwEBZVYAKzQ0AP//AKn+rARGB0IGJgApAAAAJwCeAJQBQgEHAK0EwAAKABe0BRwCAQG4/3+3VgQTBwEBd1YAKzQrNAD//wBd/qID8wYABiYASQAAACYAnl4AAQcArQSNAAAAF7QCOAABAbj/ibdWAS8LAQGXVgArNCs0AP//ALcAAAH4B8YGJgAtAAABBwCrA2UBUgALtgEFAwEBfFYAKzQA//8AnAAAAd0GggYmAI0AAAEHAKsDSgAOAAu2AQUDAQGuVgArNAD//wCk/qsBfwWwBiYALQAAAQcArQNsAAkADrQBBwIBAbj/frBWACs0//8Ahv6sAWkFxAYmAE0AAAEHAK0DTgAKAA60AhMCAQG4/3+wVgArNP//AHf+ogUKBcQGJgAzAAABBwCtBRgAAAAOtAIvBgEBuP+JsFYAKzT//wBc/qEENQROBiYAUwAAAQcArQSd//8ADrQCLxEBAbj/iLBWACs0//8Ad//sBQoHvQYmADMAAAEHAKsFEQFJAAu2Ai0RAQFfVgArNAD//wBc/+wENQaEBiYAUwAAAQcAqwSNABAAC7YCLQYBAZxWACs0AP//AHf/7AU9B8YGJgAzAAABBwJSAOUBMQANtwMCMBEBAU9WACs0NAD//wBc/+wEuQaNBiYAUwAAAQYCUmH4AA23AwIwBgEBjFYAKzQ0AP//AEb/7AUKB8IGJgAzAAABBwJTAOkBPwANtwMCLhEBAUpWACs0NAD////C/+wENQaJBiYAUwAAAQYCU2UGAA23AwIuBgEBh1YAKzQ0AP//AHf/7AUKB+4GJgAzAAABBwJUAOoBHgANtwMCMREBAT5WACs0NAD//wBc/+wEUwa1BiYAUwAAAQYCVGblAA23AwIxBgEBe1YAKzQ0AP//AHf/7AUKB9wGJgAzAAABBwJVAOoBCAANtwMCLhEBAShWACs0NAD//wBc/+wENQajBiYAUwAAAQYCVWbPAA23AwIuBgEBZVYAKzQ0AP//AHf+ogUKBzkGJgAzAAAAJwCeAOwBOQEHAK0FGAAAABe0AzgGAQG4/4m3VgIvEQEBWlYAKzQrNAD//wBc/qEENQYABiYAUwAAACYAnmgAAQcArQSd//8AF7QDOBEBAbj/iLdWAi8GAQGXVgArNCs0AP//AGb/7AWdBzEGJgCYAAABBwB1Ad4BMQALtgM6HAEBR1YAKzQA//8AXP/sBLoGAAYmAJkAAAEHAHUBZQAAAAu2AzYQAQGMVgArNAD//wBm/+wFnQcxBiYAmAAAAQcARAFOATEAC7YDPBwBAUdWACs0AP//AFz/7AS6BgAGJgCZAAABBwBEANUAAAALtgM4EAEBjFYAKzQA//8AZv/sBZ0HtQYmAJgAAAEHAKsFDQFBAAu2AzscAQFXVgArNAD//wBc/+wEugaEBiYAmQAAAQcAqwSUABAAC7YDNxABAZxWACs0AP//AGb/7AWdBx0GJgCYAAABBwClAOMBNQALtgNIHAEBUVYAKzQA//8AXP/sBLoF7AYmAJkAAAEGAKVqBAALtgNEEAEBllYAKzQA//8AZv6iBZ0GOAYmAJgAAAEHAK0FCQAAAA60Az0QAQG4/4mwVgArNP//AFz+mAS6BLEGJgCZAAABBwCtBJv/9gAOtAM5GwEBuP9/sFYAKzT//wCM/qIEqgWwBiYAOQAAAQcArQTvAAAADrQBGQYBAbj/ibBWACs0//8Aif6iA90EOgYmAFkAAAEHAK0EUgAAAA60Ah8LAQG4/4mwVgArNP//AIz/7ASqB7sGJgA5AAABBwCrBOkBRwALtgEXAAEBcVYAKzQA//8Aif/sA90GhAYmAFkAAAEHAKsEhQAQAAu2Ah0RAQGwVgArNAD//wCM/+wGHQdCBiYAmgAAAQcAdQHVAUIAC7YCIAoBAWxWACs0AP//AIn/7AUQBesGJgCbAAABBwB1AWP/6wALtgMmGwEBi1YAKzQA//8AjP/sBh0HQgYmAJoAAAEHAEQBRQFCAAu2AiIKAQFsVgArNAD//wCJ/+wFEAXrBiYAmwAAAQcARADT/+sAC7YDKBsBAYtWACs0AP//AIz/7AYdB8YGJgCaAAABBwCrBQQBUgALtgIhCgEBfFYAKzQA//8Aif/sBRAGbwYmAJsAAAEHAKsEkv/7AAu2AycbAQGbVgArNAD//wCM/+wGHQcuBiYAmgAAAQcApQDaAUYAC7YCLhUBAXZWACs0AP//AIn/7AUQBdcGJgCbAAABBgClaO8AC7YDNBsBAZVWACs0AP//AIz+mQYdBgIGJgCaAAABBwCtBQn/9wAOtAIjEAEBuP+AsFYAKzT//wCJ/qIFEASRBiYAmwAAAQcArQSIAAAADrQDKRUBAbj/ibBWACs0//8AD/6jBLwFsAYmAD0AAAEHAK0EvAABAA60AQwGAQG4/3awVgArNP//ABb+BAOwBDoGJgBdAAABBwCtBR3/YgAOtAIiCAAAuP+5sFYAKzT//wAPAAAEvAe6BiYAPQAAAQcAqwS4AUYAC7YBCgIBAXBWACs0AP//ABb+SwOwBoQGJgBdAAABBwCrBEoAEAALtgIaAQEBsFYAKzQA//8ADwAABLwHIgYmAD0AAAEHAKUAjgE6AAu2ARcIAQFqVgArNAD//wAW/ksDsAXsBiYAXQAAAQYApSAEAAu2AicYAQGqVgArNAD//wBf/ssErQYABCYASAAAACcCQQGhAkYBBwBDAJ//YwAXtAQ3FgEBuP93t1YDMgsBAYNWACs0KzQA//8AMv6ZBJcFsAYmADgAAAEHAmwCQAAAAAu2AgsCAACaVgArNAD//wAo/pkDsQQ6BiYA9gAAAQcCbAHHAAAAC7YCCwIAAJpWACs0AP//AJf+mQTJBbAGJgDhAAABBwJsAv4AAAALtgIdGQEAmlYAKzQA//8AaP6ZA70EPAYmAPkAAAEHAmwB9gAAAAu2AhsCAQCaVgArNAD//wCy/pkEMAWwBiYAsQAAAQcCbADwAAAAC7YBCQQAAJpWACs0AP//AJv+mQNIBDoGJgDsAAABBwJsANUAAAALtgEJBAAAmlYAKzQA//8AP/5TBb4FxAYmAUwAAAEHAmwDBv+6AAu2AjoKAABrVgArNAD////d/lYEZAROBiYBTQAAAQcCbAIA/70AC7YCOQkAAGtWACs0AP//AI0AAAPgBgAGBgBMAAAAAv/UAAAEsQWwABgAHAAaQAwcGxgAAAsMAnIOCwgAPzMrEjkvM8wyMDFBITIWFhUUDgIjIREzESEyNjY1NCYmIyEBFSE1ATYBjaDcckB+uHj94MEBX2uFPj6Fa/5zARv9gwNfa8CBYJ91PwWw+u1PgElJekkCJpiYAAAC/9QAAASxBbAAGAAcABlACxwbGAAACwwCDgsIAD8zPxI5LzPMMjAxQSEyFhYVFA4CIyERMxEhMjY2NTQmJiMhARUhNQE2AY2g3HJAfrh4/eDBAV9rhT4+hWv+cwEb/YMDX2vAgWCfdT8FsPrtT4BJSXpJAiaYmAACAAMAAAQwBbAABQAJABZACgYHBwQCBQJyBAgAPysyEjkvMzAxQRUhESMRARUhNQQw/ULAAc79gwWwnvruBbD9k5iYAAL//QAAA0gEOgAFAAkAFkAKCQgIBAIFBnIECgA/KzISOS8zMDFBFSERIxEBFSE1A0j+DLkB3/2DBDqZ/F8EOv48mJgABAALAAAFMgWwAAMACQANABEAK0AVDAsLBwcGEBEGEQYRAgkDAnIKAghyACsyKzIROTkvLxEzETMSOREzMDFBESMRIQEhJyEBEwE3AQEVITUBh8EEQv2I/qoeAQEB/C393WwCo/1W/YMFsPpQBbD836ACgfpQAqip/K8EzpiYAAAE/9MAAAQpBgAAAwAJAA0AEQAtQBcEBnIMCwsHBwYQEQYRBhECAwByCgIKcgArMisROTkvLxEzETMSOREzKzAxQREjEQEBISczARMBNwEBFSE1AWC5A07+Q/7mFtYBOzT+jGIB7v4n/YMGAPoABgD+Ov27mgGr+8YCAqX9WQVYmJgAAgAPAAAEvAWwAAgADAAdQA8MAQQHAwsLBgMIAnIGCHIAKysyETkvFzkzMDFTAQEzAREjEQEBFSE17AF6AXvb/grB/goDmf2DBbD9JQLb/HD94AIgA5D88JiYAAAEAC/+XwPgBDoAAwAIAA0AEQAXQAsREBACBQ0GcgIOcgArKzISOS8zMDFlESMRNwEzASMDARcjAQEVITUCZLlXASC+/m976AEoKXv+bQMd/YOE/dsCJXcDP/vGBDr8wPoEOvxSmJgAAAIAOgAABM4FsAALAA8AH0APDwcFAQQKAw4OCQUDAAJyACsyLzM5Lxc5EjkzMDFBAQEzAQEjAQEjCQIVITUBJgFeAV7h/jQB1+P+mf6Z4wHX/jQDgf2DBbD90gIu/S/9IQI5/ccC3wLR/YWYmAAAAgAqAAADywQ6AAsADwAfQA8PBwUBCgQDDg4JBQMABnIAKzIvMzkvFzkSOTMwMUETEzMBASMDAyMJAhUhNQEK7fDZ/p4Bbdb6+tcBbP6fAwj9gwQ6/nYBiv3q/dwBlv5qAiQCFv4+mJgA//8AZP/sA+wETQYGAL8AAP//ABIAAAQvBbAGJgAqAAABBwJB/4P+fQAOtAMOAgIAuAEIsFYAKzT//wCQAosFyAMjBgYBgwAA//8AXgAABDMFxAYGABYAAP//AF//7AP6BcQGBgAXAAD//wA1AAAEUQWwBgYAGAAA//8Amv/sBC4FsAYGABkAAP//AJn/7AQxBbIEBgAaFAD//wCF/+wEIwXEBAYAHBQA//8AZP/+A/gFxAQGAB0AAP//AIf/7AQfBcQEBgAUFAD//wB6/+wE3QdXBiYAKwAAAQcAdQG/AVcAC7YBLBABAW1WACs0AP//AGH+VQPyBgAGJgBLAAABBwB1AUsAAAALtgM/GgEBjFYAKzQA//8AqQAABQkHNwYmADIAAAEHAEQBZQE3AAu2AQwJAQFhVgArNAD//wCNAAAD4AYABiYAUgAAAQcARADMAAAAC7YCHgMBAaBWACs0AP//AB0AAAUeByAGJgAlAAABBwCsBG0BMgANtwQDDgMBAWZWACs0NAD//wA6/+wD6gXpBiYARQAAAQcArAQT//sADbcDAjwPAQGRVgArNDQA//8AXwAABEYHKwYmACkAAAEHAKwEOAE9AA23BQQRBwEBcVYAKzQ0AP//ACn/7APzBekGJgBJAAABBwCsBAL/+wANtwIBLQsBAZFWACs0NAD///8LAAAB6gcrBiYALQAAAQcArALkAT0ADbcCAQUDAQFxVgArNDQA///+8AAAAc8F5wYmAI0AAAEHAKwCyf/5AA23AgEFAwEBo1YAKzQ0AP//AHf/7AUKByIGJgAzAAABBwCsBJABNAANtwMCLREBAVRWACs0NAD//wAz/+wENQXpBiYAUwAAAQcArAQM//sADbcDAi0GAQGRVgArNDQA//8AVgAABMoHIAYmADYAAAEHAKwELwEyAA23AwIfAAEBZlYAKzQ0AP///4wAAAKYBekGJgBWAAABBwCsA2X/+wANtwMCGAMBAaVWACs0NAD//wCM/+wEqgcgBiYAOQAAAQcArARoATIADbcCARcLAQFmVgArNDQA//8AK//sA90F6QYmAFkAAAEHAKwEBP/7AA23AwIdEQEBpVYAKzQ0AP///zgAAATTBj4EJgDQZAAABwCu/oD/////AKn+rASIBbAGJgAmAAABBwCtBLoACgAOtAI0GwEBuP9/sFYAKzT//wCM/pgEIQYABiYARgAAAQcArQSr//YADrQDMwQBAbj/a7BWACs0//8Aqf6sBMcFsAYmACgAAAEHAK0EugAKAA60AiIdAQG4/3+wVgArNP//AF/+ogPxBgAGJgBIAAABBwCtBL4AAAAOtAMzFgEBuP+JsFYAKzT//wCp/gYExwWwBiYAKAAAAQcB1QFl/qgADrQCKB0BAbj/l7BWACs0//8AX/38A/EGAAYmAEgAAAEHAdUBaf6eAA60AzkWAQG4/6GwVgArNP//AKn+rAUIBbAGJgAsAAABBwCtBR8ACgAOtAMPCgEBuP9/sFYAKzT//wCN/qwD4AYABiYATAAAAQcArQShAAoADrQCHgIBAbj/f7BWACs0//8AqQAABQUHMQYmAC8AAAEHAHUBfAExAAu2Aw4DAQFbVgArNAD//wCNAAAEDQdBBiYATwAAAQcAdQFEAUEAC7YDDgMBABtWACs0AP//AKn+/AUFBbAGJgAvAAABBwCtBOkAWgAOtAMRAgEBuP/PsFYAKzT//wCN/ukEDQYABiYATwAAAQcArQRmAEcADrQDEQIBAbj/vLBWACs0//8Aqf6sBBwFsAYmADAAAAEHAK0EwQAKAA60AgsCAQG4/3+wVgArNP//AIb+rAFhBgAGJgBQAAABBwCtA04ACgAOtAEHAgEBuP9/sFYAKzT//wCp/qwGUgWwBiYAMQAAAQcArQXSAAoADrQDFAYBAbj/f7BWACs0//8Ai/6sBnkETgYmAFEAAAEHAK0F1gAKAA60AzYCAQG4/3+wVgArNP//AKn+rAUJBbAGJgAyAAABBwCtBSUACgAOtAENAgEBuP9/sFYAKzT//wCN/qwD4AROBiYAUgAAAQcArQSIAAoADrQCHwIBAbj/f7BWACs0//8Ad//sBQoH6AYmADMAAAEHAlEFDAFUAA23AwIxEQEBWlYAKzQ0AP//AKkAAATBB0IGJgA0AAABBwB1AX0BQgALtgEYDwEBbFYAKzQA//8AjP5gBB8F9gYmAFQAAAEHAHUBlP/2AAu2AzADAQGWVgArNAD//wCp/qwEygWwBiYANgAAAQcArQS4AAoADrQCIRgBAbj/f7BWACs0//8Ag/6tApgETgYmAFYAAAEHAK0DSwALAA60AhoCAQG4/4CwVgArNP//AFH+oQRzBcQGJgA3AAABBwCtBMn//wAOtAE9KwEBuP+IsFYAKzT//wBf/pgDvAROBiYAVwAAAQcArQSH//YADrQBOSkBAbj/f7BWACs0//8AMv6iBJcFsAYmADgAAAEHAK0EuwAAAA60AgsCAQG4/3WwVgArNP//AAn+ogJXBUEGJgBYAAABBwCtBBoAAAAOtAIZEQEBuP+JsFYAKzT//wCM/+wEqgfmBiYAOQAAAQcCUQTkAVIADbcCARsAAQFsVgArNDQA//8AHQAABP0HLgYmADoAAAEHAKUAswFGAAu2AhgJAQF2VgArNAD//wAhAAADuwXiBiYAWgAAAQYApR36AAu2AhgJAQGgVgArNAD//wAd/qwE/QWwBiYAOgAAAQcArQTkAAoADrQCDQQBAbj/f7BWACs0//8AIf6sA7sEOgYmAFoAAAEHAK0ETQAKAA60Ag0EAQG4/3+wVgArNP//AD3+rAbtBbAGJgA7AAABBwCtBe8ACgAOtAQZEwEBuP9/sFYAKzT//wAr/qwF0wQ6BiYAWwAAAQcArQVTAAoADrQEGRMBAbj/f7BWACs0//8AV/6sBHoFsAYmAD4AAAEHAK0EugAKAA60AxECAQG4/3+wVgArNP//AFn+rAOzBDoGJgBeAAABBwCtBGMACgAOtAMRAgEBuP9/sFYAKzT///54/+wFUAXWBCYAM0YAAQcBcv4I//8ADbcDAi4RAAASVgArNDQA//8AFAAABHEFGwYmAk4AAAAHAK7/2/7c////nwAAA+sFHgQmAkM8AAAHAK7+5/7f////uwAABJUFGwQmAf88AAAHAK7/A/7c////wAAAAY0FHgQmAf48AAAHAK7/CP7f////3//wBGUFGwQmAfgKAAAHAK7/J/7c////VQAABFgFGwQmAe48AAAHAK7+nf7c////9wAABIgFGgQmAg4KAAAHAK7/P/7b//8AFAAABHEEjQYGAk4AAP//AIsAAAPwBI0GBgJNAAD//wCLAAADrwSNBgYCQwAA//8ASAAAA+EEjQYGAe0AAP//AIsAAARZBI0GBgH/AAD//wCYAAABUQSNBgYB/gAA//8AiwAABFcEjQYGAfwAAP//AIsAAAV4BI0GBgH6AAD//wCLAAAEWQSNBgYB+QAA//8AYP/wBFsEnQYGAfgAAP//AIsAAAQbBI0GBgH3AAD//wApAAAD/QSNBgYB8wAA//8ADgAABBwEjQYGAe4AAP//ACcAAAQyBI0GBgHvAAD///+yAAACPAXkBiYB/gAAAQcAav9NAB4ADbcCAQ0DAQGEVgArNDQA//8ADgAABBwF5AYmAe4AAAEGAGpuHgANtwQDFwkBAYNWACs0NAD//wCLAAADrwXkBiYCQwAAAQYAanIeAA23BQQZBwEBg1YAKzQ0AP//AIsAAAOFBh4GJgIFAAABBwB1ATUAHgALtgIIAwEBg1YAKzQA//8ARP/wA94EnQYGAfQAAP//AJgAAAFRBI0GBgH+AAD///+yAAACPAXkBiYB/gAAAQcAav9NAB4ADbcCAQ0DAQGEVgArNDQA//8ALP/wA00EjQYGAf0AAP//AIsAAARXBh4GJgH8AAABBwB1ASUAHgALtgMOAwEBhFYAKzQA//8AI//sBAwF9QYmAhwAAAEGAKFnHgALtgIdFwEBhFYAKzQA//8AFAAABHEEjQYGAk4AAP//AIsAAAPwBI0GBgJNAAD//wCLAAADhQSNBgYCBQAA//8AiwAAA68EjQYGAkMAAP//AIsAAARiBfUGJgIZAAABBwChAMkAHgALtgMRCAEBhFYAKzQA//8AiwAABXgEjQYGAfoAAP//AIsAAARZBI0GBgH/AAD//wBg//AEWwSdBgYB+AAA//8AiwAABEQEjQYGAgoAAP//AIsAAAQbBI0GBgH3AAD//wBh//AEMQSdBgYCTAAA//8AKQAAA/0EjQYGAfMAAP//ACcAAAQyBI0GBgHvAAAAAwBI/k8D1QSdAB4APgBCAChAEx8BAgI+PhU/NDRAMCoLcg8LFX4APzPMK8zNMxI5EjkvMxI5OTAxQSM1MzI2NjU0JiYjIgYGFSM0PgIzMh4CFRQOAiczMh4CFRQOAiMiLgI1Mx4CMzI2NjU0LgIjIxMRIxECEJKOWnAzOHRcQmxBuUFzmlpfo3pFQ3ee7JJ1q282SoOoX0iahVK5BUZxRFp+QiNFZUKO3LkCLHQrTzYzUC8kSjpLd1QtJU15U0VxUSxFL1NuP1eAUyggTYJhQlAkLFM5M0sxGP5H/f8CAQAEAIv+mQT7BI0AAwAHAAsADwAdQA0DAgIGCwd9Dw4KCgYSAD8zEM4zPzMSOS8zMDFBFSE1ExEjESERIxEBESMRA8D9XyW5A865AVu5AouZmQIC+3MEjftzBI38Df3/AgEAAAIAYf5VBDEEnQAnACsAGEALGRB+KCQkKioFC3IAKzIvMhEzPzMwMUEzDgIjIi4CNTU0PgIzMhYWFyMuAiMiDgIVFRQeAjMyNjYHESMRA3e6DHHNl3G2gkZGhLt0kshxDLoKPnZfT3hRKSVMdlBkeD/DuQF5cbJmTY/KfWZ9ypBNZbR1TW47NWeSXWdYkWo5OG3W/f8CAQD//wAOAAAEHASNBgYB7gAA//8AAv5PBWwEnQYmAjIAAAAHAmwCu/+2//8AiwAABGIFywYmAhkAAAEHAHAAnQAmAAu2Aw4IAQGwVgArNAD//wAj/+wEDAXLBiYCHAAAAQYAcDsmAAu2AhoXAQGwVgArNAD//wBhAAAFBgSNBgYCDAAA//8AmP/wBTYEjQQmAf4AAAAHAf0B6QAA//8ACQAABfIGAAYmAo8AAAEHAHUCnwAAAAu2BhkPAQFNVgArNAD//wBg/8YEWwYeBiYCkQAAAQcAdQF9AB4AC7YDMBEBAVtWACs0AP//AET9/APeBJ0GJgH0AAAABwHVASj+nv//ADEAAAXxBh4GJgHwAAABBwBEAaEAHgALtgQYCgEBa1YAKzQA//8AMQAABfEGHgYmAfAAAAEHAHUCMQAeAAu2BBYKAQFrVgArNAD//wAxAAAF8QXkBiYB8AAAAQcAagFrAB4ADbcFBB8KAQGEVgArNDQA//8ADgAABBwGHgYmAe4AAAAHAEQApAAe//8AHf5OBR4FsAYmACUAAAEHAKQBfAAAAAu2Aw4FAQE5VgArNAD//wBt/k4D6gROBiYARQAAAQcApADEAAAAC7YCOzEAAE1WACs0AP//AKn+WARGBbAGJgApAAABBwCkATkACgALtgQQAgAAQ1YAKzQA//8AXf5OA/METgYmAEkAAAEHAKQBBgAAAAu2ASwAAABNVgArNAD//wAU/k4EcQSNBiYCTgAAAAcApAEeAAD//wCL/lYDrwSNBiYCQwAAAAcApADnAAj//wCG/qwBYQQ6BiYAjQAAAQcArQNOAAoADrQBBwIBAbj/f7BWACs0AAAAAAAPALoAAwABBAkAAACyAAAAAwABBAkAAQAMALIAAwABBAkAAgAOAL4AAwABBAkAAwAMALIAAwABBAkABAAMALIAAwABBAkABQAmAMwAAwABBAkABgAcAPIAAwABBAkABwBAAQ4AAwABBAkACAAMAU4AAwABBAkACQAmAVoAAwABBAkACwAUAYAAAwABBAkADAAUAYAAAwABBAkADQEiAZQAAwABBAkADgA2ArYAAwABBAkAGQAMALIAQwBvAHAAeQByAGkAZwBoAHQAIAAyADAAMQAxACAAVABoAGUAIABSAG8AYgBvAHQAbwAgAFAAcgBvAGoAZQBjAHQAIABBAHUAdABoAG8AcgBzACAAKABoAHQAdABwAHMAOgAvAC8AZwBpAHQAaAB1AGIALgBjAG8AbQAvAGcAbwBvAGcAbABlAGYAbwBuAHQAcwAvAHIAbwBiAG8AdABvAC0AYwBsAGEAcwBzAGkAYwApAFIAbwBiAG8AdABvAFIAZQBnAHUAbABhAHIAVgBlAHIAcwBpAG8AbgAgADMALgAwADEAMQA7ACAAMgAwADIANQBSAG8AYgBvAHQAbwAtAFIAZQBnAHUAbABhAHIAUgBvAGIAbwB0AG8AIABpAHMAIABhACAAdAByAGEAZABlAG0AYQByAGsAIABvAGYAIABHAG8AbwBnAGwAZQAuAEcAbwBvAGcAbABlAEMAaAByAGkAcwB0AGkAYQBuACAAUgBvAGIAZQByAHQAcwBvAG4ARwBvAG8AZwBsAGUALgBjAG8AbQBUAGgAaQBzACAARgBvAG4AdAAgAFMAbwBmAHQAdwBhAHIAZQAgAGkAcwAgAGwAaQBjAGUAbgBzAGUAZAAgAHUAbgBkAGUAcgAgAHQAaABlACAAUwBJAEwAIABPAHAAZQBuACAARgBvAG4AdAAgAEwAaQBjAGUAbgBzAGUALAAgAFYAZQByAHMAaQBvAG4AIAAxAC4AMQAuACAAVABoAGkAcwAgAGwAaQBjAGUAbgBzAGUAIABpAHMAIABhAHYAYQBpAGwAYQBiAGwAZQAgAHcAaQB0AGgAIABhACAARgBBAFEAIABhAHQAOgAgAGgAdAB0AHAAcwA6AC8ALwBvAHAAZQBuAGYAbwBuAHQAbABpAGMAZQBuAHMAZQAuAG8AcgBnAGgAdAB0AHAAcwA6AC8ALwBvAHAAZQBuAGYAbwBuAHQAbABpAGMAZQBuAHMAZQAuAG8AcgBnAAAAAwAAAAAAAP9qAGQAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAIACAAI//8ADwABAAIADgAAAAAAAAIoAAIAWQAlAD4AAQBEAF4AAQBqAGoAAQBwAHAAAQB1AHUAAQCBAIEAAQCDAIMAAQCGAIYAAQCJAIkAAQCLAJYAAQCYAJ8AAQChAKMAAQClAKYAAQCoAK0AAwCxALEAAQC6ALsAAQC/AL8AAQDBAMEAAQDDAMQAAQDHAMcAAQDLAMsAAQDNAM4AAQDQANEAAQDTANMAAQDaAN4AAQDhAOEAAQDlAOUAAQDnAOkAAQDrAPsAAQD9AP0AAQD/AQEAAQEDAQMAAQEIAQkAAQEWARoAAQEcARwAAQEgASIAAQEkAScAAwEqASsAAQEzATQAAQE2ATYAAQE7ATwAAQFBAUQAAQFHAUgAAQFLAU0AAQFRAVEAAQFUAVgAAQFdAV4AAQFiAWIAAQFkAWQAAQFoAWgAAQFqAWwAAQFuAW4AAQFwAXAAAQHWAdwAAgHtAgEAAQIFAgUAAQIOAg4AAQIQAhAAAQIXAhkAAQIbAhwAAQIeAh4AAQIiAiIAAQIkAiYAAQIsAiwAAQIxAjMAAQI1AjUAAQJDAkMAAQJGAkYAAQJIAkgAAQJLAk4AAQJ6An4AAQKOApMAAQKWAv4AAQMBA8AAAQPCA8IAAQPEA84AAQPQA9kAAQPbA/YAAQP6A/oAAQP8BAMAAQQFBAcAAQQKBA4AAQQQBJsAAQSeBJ8AAQShBKIAAQSkBKcAAQSxBQ0AAQUPBRkAAQUcBSkAAQABAAMAAAAQAAAAFgAAACAAAQABAK0AAgABAKgArAAAAAIAAgCoAKwAAAEkAScABQABAAAAHAA2AAoACABYAGgAcgB8AIYAYACQAJoABERGTFQAkmN5cmwAlmdyZWsAmmxhdG4AngAHY3BzcACIa2VybgCaa2VybgCOa2VybgCia2VybgCqbWFyawCUbWttawCyAAEAAAABAI4ABAAAAAEAkAACAAgAAgGICF4AAgAIAAIBIgSEAAIACAACAogQUgACAAgAAgCOANYABgAQAAEAbAAAAAYAEAABAG4AAgCAAAAAigAAAJQAAACeAAAAAAABAAAAAAABAAQAAAABAAUAAAACAAQAAwAAAAIABAABAAAAAgAEAAIAAAACAAYABwABLlQABQAkAEgAARlsKuAAAhm8TvIAARkyGTIAARk4GS4AARluGTIAARl+GUgAARlYAAQAAAADGTAZwhk2AAD//wAEAAAAAgAFAAYAAP//AAQAAAADAAUABgAA//8ABAAAAAQABQAGAAD//wAEAAAAAQAFAAYAAhmkAAQAABnqHA4ABAAFAAD/lQAAAAD/iAAA/1YAAAAAAAAAAAAAAAAAAAAAAAD/iAAAAAAAAAABHIwABAAAACkaEhogGeAbbhpuGjwamhpKGoQa7BsSGZQaXBmaHTgZrB2aHDobQBmgGaYeABnqGrAamho8HOIamhn0Gf4aPBouG6Ac4hrKHOIZrBoIGlwaCBo8AAExNgAEAAAAhR7YHp4eIh4oHmYfnCCYOUQzVjd0KRIfFDRsL0QgZiWmHxQfFCGyHxQfFB8ULAwkqh8UIDwlKCO6HvIoaCL6HlInyh4uIBIkMDJEHsIhdCYoIk4fwh7CIqQf6CH8IM4fwiE6H1gegh5IIBIewiayHlIgZh4uIQQhBCEEHxQgZh4uHxQfFB6QHlIgZh4uI1gmsh8UHxQhBCEEIbIhOh40JrIfFB8UHpAedB6wJzwgZh82Hj4fWB7CHkgeLh4+HlIeSB4+HoIeSB6wH3oeSB8UIGYeLh8UITofNiE6HzYePh4+Hj4gZh4uHpAfWB9YHsIhsh5IIbIeSCGyHkgnPCayHlIeXCA8JrIhBB96AAE8SAAEAAAA9C9CKsgqyDV2L1gr8CrOK/4+oiwML24qziruN6Y0sC+0LzAvhCraNHIsKDTyGDw6RBg8OZ4YPBg8GDwsGjW8KtQvmirUNTQqzjYKLx4qyDseKsgqyCrIKsIv1i/8Krwq5Cq2K+IqtivwKs4qzirOKs4vtC9YL1gvWC9YL1gvWC9YK/Ar/iv+K/4r/irOKs4qzirOKs40chg8GDwYPBg8GDwYPBg8GDwYPBg8KtQq1C9YL1gvWCvwK/Ar8CvwKs4r/hg8K/4YPCv+GDwr/hg8K/4YPBg8LAwvbi9uL24vbhg8GDwYPBg8Ks4YPCrOGDwqzhg8LBosGiwaL7QvtC+0L4Q0cirUNHIsKCwoLCgqvCq8KsIqtiq2KrYqtiq2KrYqtiq8KrwqvCq8Krwqtiq2KrYqvCrkKuQq5CrkKrwqvCq8KsIvhC+EL4Q0cirUKsgqyCrIGDwvWC9YL1gvWC9YL1gvWC9YL1gvWC9YL1gvWCv+GDwr/hg8K/4YPCv+GDwr/hg8K/4YPCv+GDwr/hg8Ks4YPCrOGDwqzhg8Ks4YPCrOGDwqzhg8Ks4YPBg8NHIq1DRyKtQ0cirUGDwvWCv+Ks4YPCwaKs4qzhg8LAwsDC9uGDwYPCrOKu4sGi+0LzAq1C8wKtQvhCwoAAI8QgAEAAA/TkBCABgAFAAAAAAAAAAA/8UAAP+IAAAAAAAAAAD/7AAAAAD/wwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEgAA/+QAAAAAAAAAAAAAAAAAEQAAAAAAAAASAAAAAP+aAAAAAAAA/+sAAP/V/+0AAAAAAAAAAAAA/+r/6f/t//X/6wAA/4gAAAAAAAD/9QAA//X/ogAA/8QAAP/O//X/9AAAAAAAAAAAAAAAAAAA/y3/zP+//9n/ov/jABL/qwAA/9j/7P/L/78ADQAA/6v/7/+iAAAAAAAAAAAAAAAAAAAAAAAAAAD/vwAAAAD/8gAAAAAAAAAAAAAAAAAAAAAAAAAA/+3/7wAAAAAAAAAA//AAAP/mAAD/7QAAAAAAAAAAAAAAAP+YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+VAAD/8wAAAAAAAAAAAAAAAAAAAAAAAP/xAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+oAAAAAAAAAAAAAAAAAAP/sAAAAAP94AAAAAAAAAAAAAAAAAAAAAAAAAAD/8QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/S/+b/6wAA/+cAAAAAAAAAAP/h/+f/6wAAAAAAAAAAAAAAAAAA/nr+Yv9E/0v/Pv+9AAcAAAAA/zP/cgAA/0QAAAAAAAAAAP8+AAAAAAAA/8D/5v/pAAD/4QAAAAAAAP/p/9j/5//lAAAAAAAAAAAAAAAAAAD+vAAA//MAAP92AAAAAP/GAAAAAAAPAAD/8//h/+b/xgAA/3YAAAAA/yb/GP+d/6H/sf/kABD/rwAA/5P/uP+5/50AAAAA/6//7f+xAAAAAAAAAAD/6//tAA3/5gAAAA0AAAAA/+X/7P/rAAAAAAANAAAADQAAAAAAAAAAAAAAAAAAAAAAAAAA/78AAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/rAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQAAAAAAAAAAAAAAAAAAAAAAAAAA/+MAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAD/9f+iAAD/xAAA/87/9f/0AAAAAAAAAAAAAAACPaIABAAAPrJDWAAiAB4AAAAAAAAAAAAAAAAAEQAAAAAAAP/jAAAAAAARAAAAAAAS/+QAEQAA/+UAAAAAAAD/5AAAAAAAEgAAAAAAAP/s/8UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+IAAAAAP/DAAD/zgAAAAAAAAAAAAAAAAAA/7AAAAAA//MAAAAPAAAAAAAA/5UAAAAAAAAAAAAAAAAAAAAAAAD/1//xAAD/8QAAAAAAAAAAAAAAAAAAAAAAAAAA/+b/5wAA/+EAAAAAAAD/5wAA/9IAAAARAAAAAAAAAAAAEf/r/9EAAAAAAA4AAAAAAAAAAAAAAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/p/+b/4QAA/9gAAAAAAAD/5wAA/8AAAAAAAAAAAAAAAAAAAP/l/6MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/y//MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8z/0T/vQAA/3IAAP9q/noAAAAH/mIAAP+SAAAAAP8+AAD/D/9E/wz/LAAAAAcABwAAAAD/PgAA/ycAAAAAAAAAAP/AAAD/8P/JAAAAAP71AAAAAP/1/+sAAAAA/+cAAAAAAAAAAAAA/8j/rQAAAAAAAAAAAAAAAP+a/73/6QAAAAAAAAAA/m0AAAAS/4kAAP/KAAAAAP+lAAD/u/+9/+n/kQAAAAAAEgAAAAD/pQAA/9IAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/2P/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/j//UAAP/xAAAAAAAAAAAAAAAAAAAAAAAAAAD/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP95/90AAP/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9kAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+0AAAAA/+YAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAP/tAAAAAP/wAAAAAAAAAAAAAAAAAAAAAAAAAAD/9f+I/84AAAAAAAD/9f9/AAD/xwARAAAAAAAA/8kAEv/0/48AAP/E/6n/ogAAAAAAAAAAAAAAAAAAAAAAAP94//EAAP/rAAAAAAAAAAAAAAAAAAAAAAAAAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/6gAA/5oAAP/lAAAAAP/hAAD/9f/rAAAAAAAAAAAAAAAA/+r/1f/t/+3/6wAAAAAAAAAAAAAAAP+9//EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/jAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+T/53/5AAA/7gAAP+z/yb/uQAQ/xj/8f/LAAD/7f+xAAD/fv+d/3z/jwAAABAAEP+v/6//sf8Q/4wAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9T/8wAA//UAAAAA/x//2QAA/9sAAAAAAAAAAP+1AAAAAP/SAAD/0gAAAAAAAP+0/7T/tQAAAAAAAP/Y/7//4wAA/+wADf/p/y3/ywAR/8z/8wAAAAD/7/+iAAAAAP+/AAD/twAAABIAEv+r/6v/ov+g/8YAAAAAAAAAAAAAAAAAAAAAAAD/8gAAAAD/wAAAAAAAAAAAAAAAAAAAAAAAAP+/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8gAAAAD/wAAAAAAAAAAAAAAAAAAAAAAAAP+/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7gAAAAD/7AAAAAAAAAAAAAAAAP/qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/9QAA/84AAAAAAAD/9f9/AAD/xwARAAAAAAAA/8kAEv/0/48AAP/E/6n/ogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/qAAAAAAAAAAAAAAAAAAAAAP/r/+v/6gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/lAAAAAAAA//MAAAAAAAAAAAAAAAAAAAAA/+j/yQAAAAAAAAAAAAAAAAAA//MAAAAAAA//4QAA/rwAAAAAAAAAAP/JAAAAAP92AAD/2f/zAAD/9QAAAAAAAP/G/8b/dv84AAAAAAAAAAAAAP+YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjkwAAQAAExeUeoAIwAiAAAAAAAA/+sAAAAAAAAAAAAAAAAAAP/tAAAAAP/VAAAAAAAA/5r/5f/pAAAAAAAAAAD/6gAAAAAAAP/q//X/7f/rAAAAAAAAAAAAEgAAAAAAAAAAAAAAAAAAAAAAAAAA/+QAAAAAAAAAAP/jAAAAAAAAAAAAAAAAAAAAAAAAABEAAAAAABIAAAAA//UAAAAAAAD/9f/1//T/7wAA//EAAP/O/4j/ogAAAAD/uwAA/38AAAAAAAAADP/E/6kAAP/d/8cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//H/vQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+0AAAAAAAD/7//tAAAAAAAAAAD/5gAAAAAAAAAAAAAAAAAUAAAAAAAAAAD/8AAAAAD/7QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/z//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//H/eAAAAAAAAAAAAAAAAAAAAAAAAP/wAAAAAAAAAAAAAAAAAAAAAAAA/+sAAAAAAAD/6gAAAAAAAAAAAAAAAAAA/+sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/r/+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+oAAAAAAAD/7gAA/+wAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/vwAAAAD/2P/AAAAAAAAAAAAAAAAAAAD/8wAA//EAAAAA//EAAAAAAAAAAAAAAA8AAAAAAAAAAP+VAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/F/4j/zgAAAAD/wwAA/+wAAAAAAAAAAAAA/7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/j/7//ov+3/8v/2f+//6D/2AAA/6v/7AAAABL/xv/wABH/LQARAAD/zAAA/+IAAAAS/6D/8//zAA3/7/+r/6L/6QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/vwAAABMAAP/y/9QAAP/KAAD/2gAT/3sAAP8RAAAAAP9xAAD+7QAAAAAAAAAA/z//UQAA/5H/OwAAAAAAEwATAAAAAP/k/53/sf+P/7n/of+dAAD/kwAA/6//uAAAABD/jP/wAA//JgAQAAD/GP+8/8QAAAAQ/xD/8f/xAAD/7f+v/7H/swAAAAD/4f/V/9//5//t/+EAAAAAAAD/ywAAAAAAAAAAAAAAAP+FAA4AAP/EAAAAAAAAAAAAAAAAAAAAAAAA/8v/1QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/9QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+0AAP/YAAAAAP/sAAAAAAAAAAAAEgAQAAAAAAAAAAD/hQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+b/6wANAAD/7P/t/+sAAAAAAAAADf/lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0ADQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//X/4wAAAAAAAAAAAAAAAAAAAAAAAP/xAAAAAAAAAAAAAAAAAAAAAAAA//EAAAAAAAAAAAAA/+8AAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/tAAAAAD/1f+7AAAAAAAAAAAAAAAAAAD/8AAAAAAAAAAA//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/4f/mAAAAAP/n/+n/5QAA/+kAAAAA/9gAAAAAAAAAAAAAAAAAAAAA/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/z/9T/tf/S/9n/5P/SAAAAAAAA/7T/9QAAAAAAAAAAAAD/HwAAAAD/2wAAAAAAAAAAAAAAAAAAAAAAAP+0/7UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/JAAAAAAAAAAD/5QAAAAAAAAAAAAD/6AAAAAAAAAAAAAAAAAAAAAAAAAAA//P/dv/1AAAAAP/zAAAAAAAA/8YADwAAAAAAAAAAAAD+vAAA/+YAAAAAAAAAAAAA/zgAAAAA/+EAAP/G/3YAAAAAAAAAAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/5//mAAAAAP/n/+v/6wAAAAAAAAAA/+EAAAAAAAAAAAAAAAAAAAAA/9IAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/vwAAAAD/2P/AAAAAAAAAAAAAAAAAAAAAAP/rAAAAAAAAAAAAAAAAAAD/7QAAAAD/1QAAAAAAAP+a/+X/6QAAAAAAAAAA/+oAAAAAAAD/6v/1/+3/6wAAAAD/9QAAAAAAAP/1//X/9P/vAAD/8QAA/84AAP+iAAAAAP+7AAD/fwAAAAAAAAAM/8T/qQAA/93/xwAAAAAAAAAAAAAAAAAA/+wAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABTsgAAQABAK0AAQAATsQAAgABAKgArAAAAAEAE/8gAAEAI//DAAVOrk60TrpOwE7GAAIAAgCoAK0AAAEkAScABgABAAMAEwCdALIAAgACAKgArAAAASQBJwAFAAkAAE6WAABOnAAATqIAAE6oAABOrgAATrQAAE66AABOwAAATsYACgAATnAAAE52AABOfAAAToIAAE6IAAFOTAAATo4AAE6UAABOmgAATqAACgAGAAAACwAAAYUAAAGGAAABiAAAAYkAAAGKAAAD9wAAA/gAAAP7AAAAAQASAAYACwAQABIAlgCyAYUBhgGHAYgBiQGKAYsBjwGQA/cD+AP7AAEAxAAOAAEAyv/tAAEAyv/qAAEAygALAAEBhv+wAAIABwAQABAAAQASABIAAQCWAJYAAgCyALIAAwGHAYcAAQGLAYsAAQGPAZAAAQACAL0AAAPCAAAAAgC9//QDwv/0AAIAuP/LAM3/5AACALj/xQDK/7QAAgDK/+oBhv+wAAMDpwAWA7YAFgO5ABYAAwC1AAAAtwAAAMQAAAADAL7/9QDE/94Ax//lAAMAtf/zALf/8ADE/+oABACz//MAxAANA6b/8wOz//MABAC+//UAxgALAMf/6gDKAAwABQAjAAAAuP/lALn/0QDEABEAyv/IAAUAs//mALj/wgDEABADpv/mA7P/5gAFACP/wwC4/+UAuf/RAMQAEQDK/8gABgC7/8UAyP/FAMn/xQO6/8UDwP+AA8b/gAAIALj/1AC+//AAwv/tAMQAEQDK/+AAzP/nAM3/5QDO/+4ACQCy/+QAtP/kAMT/4gOi/+QDp//TA6r/5AO2/9MDt//SA7n/0wALABD/HgAS/x4Asv/NALT/zQDH//IBh/8eAYv/HgGP/x4BkP8eA6L/zQOq/80ACwAQAAAAEgAAALv/5wDEAA8AyP/nAMn/5wGHAAABiwAAAY8AAAGQAAADuv/nAAwAbf2/AHz+fQC4/2EAvv+PAL//DwDD/ugAxv8fAMf+5QDK/0YAzP7tAM3+/QDO/tkADQAE/9gAbf64AHz/KAC4/64Avv/JAL//fgDD/2cAxv+HAMf/ZQDK/54AzP9qAM3/cwDO/14AAgAQAAYABgABAAsACwABABAAEAACABEAEQADABIAEgACALIAsgAEAYIBgwADAYUBhgABAYcBhwACAYgBigABAYsBiwACAY8BkAACApUClQADA/cD+AABA/sD+wABBKgEqAADABQABv+gAAv/oAC9/8UAwv/uAMQAEADG/+wAyv8gAMv/8QGF/6ABhv+gAYj/oAGJ/6ABiv+gA77/8QPC/8UDxf/xA8f/8QP3/6AD+P+gA/v/oAABACkADACWAJ0AsQCyALMAtAC1ALcAuAC5ALsAvQC+AMAAwQDDAMQAxQDHAMkAygDOAYYDogOmA6cDqgOtA7ADswO0A7UDtgO3A7kDvAPAA8IDxgTmABUACv/iAA0AFAAO/88AQQASAGEAEwBt/64AfP/NALj/0AC8/+oAvv/uAL//xgDAAA0Awv/pAMP/1gDG/+gAx/+6AMr/6QDM/8sAzf/aAM7/xwGO/9MAGAC7/9wAvf/hAL7/7gC//+YAwf/zAML/6wDD/+kAxf/wAMb/5wDI/9wAyf/cAMr/4wDL/90AzP/OAM3/1ADO/9sDuv/cA7z/8wO+/90DwP/WA8L/4QPF/90Dxv/WA8f/3QAZAAb/2gAL/9oAu//wAL3/3ADC/+wAxAAPAMb/6gDI//AAyf/wAMr/xADL/+8AzP/nAYX/2gGG/9oBiP/aAYn/2gGK/9oDuv/wA77/7wPC/9wDxf/vA8f/7wP3/9oD+P/aA/v/2gAfAAYADAALAAwAu//oAL0ACwC+/+0AxAAAAMYACwDI/+gAyf/oAMoADAGFAAwBhgAMAYgADAGJAAwBigAMAgb/vwIH/+0CCP+/A7r/6APA/+oDwgALA8b/6gP3AAwD+AAMA/sADATn/78E6//tBOwADQTu/78E+gANBP0ADQABA87/7gABA87/7AABARz/8QACAREACwFs/+YAAgD2//UBhv+wAAIA7f/IARz/8QACAO3/yQEc/+4AAgD2/8ABhv+wAAMA2QAAAOYAAAFsAAAAAwDZ/6gA7f/KAV//4wADAA0AFABBABEAYQATAAMA2f/fAOb/4AFs/+AABAEZABQEBgAUBA4AFgSiABYABAAN/+YAQf/0AGH/7wFN/+0ABQDt/+4A9v+wAP4AAAE6/+wBbf/sAAYA0v/YANb/2AE5/9gBRf/YA93/2AST/9gACADS/+sA1v/rATn/6wFF/+sD3f/rBA7/8wST/+sEov/zAAgA2QAVAO0AFQFJ/+QBSv/lAUz/5AFi/+MBZP/iAWz/5AAIAPb/8AD+AAABCf/xASD/8wE6//EBY//zAWX/6QFt/9MACADt/7gA9v/qAQn/8AEg//EBOv/rAWP/9QFt/+wBhv+wAAgACv/iAA0AFAAO/88AQQASAGEAEwBt/64AfP/NAY7/0wAJAPYAAAEaAAAD5QAAA+4AAAQHAAAEDwAABDAAAAQyAAAENAAAAAkA9v+6AP4AAAEJ/88BIP/bATr/UAFK/50BY//wAWX/8gFt/0wACgAG/9YAC//WAYX/1gGG/9YBiP/WAYn/1gGK/9YD9//WA/j/1gP7/9YACgAG//UAC//1AYX/9QGG//UBiP/1AYn/9QGK//UD9//1A/j/9QP7//UACgDm/8MA9v/PAP4AAAE6/84BSf/nAUz/3wFi/9EBZP/sAWz/oAFt/9EADADZABIA6v/pAPb/1wE6/9cBSv/TAUz/1gFN/8UBWP/nAWIADQFkAAwBbf/WAW7/8gANANkAEwDm/8UA9v/KATr/nwFJ/1EBSv97AUz/ygFN/90BWP/yAWL/dQFk/8oBbP9PAW3/jAANAPb/ugD5/9kA/gAAAQn/zwEg/9sBOv9QAUj/2QFK/50BY//wAWX/8gFt/0wENv/ZBJb/2QANAOr/1wD2/7kA/v/pAQn/sgEc/9IBIP/IATr/oAFK/8UBWP/kAWP/zAFl/8wBbf/LAW7/7wAOACP/wwDZABMA5v/FAPb/ygE6/58BSf9RAUr/ewFM/8oBTf/dAVj/8gFi/3UBZP/KAWz/TwFt/4wADwDtABQA8gAQAPb/8AD5//AA/gAAAQEADAEEABABOv/wAUj/8AFK/+YBUQAQAW3/8AFwABAENv/wBJb/8AASANn/rgDmABIA6//gAO3/rQDv/9YA/f/fAQH/0gEH/+ABHP/OAS7/3QEw/+IBOP/gAUD/4AFK/+kBTf/aAV//vQFp/98BbAARABQA7v/1APb/ugD5/9kA/gAAAQn/zwEg/9sBNP/1ATr/UAFE//UBSP/ZAUr/nQFe//UBY//wAWX/8gFt/0wD5v/1BBL/9QQg//UENv/ZBJb/2QAVAPb/ugD5/9kA/gAAAQn/zwEa/90BIP/bATr/UAFI/9kBSv+dAWP/8AFl//IBbf9MA+X/3QPu/90EB//dBA//3QQw/90EMv/dBDT/3QQ2/9kElv/ZABUA7f/vAO7/8ADy//MA/gAAAQT/8wEa//QBNP/wAUT/8AFR//MBXv/wAXD/8wPl//QD5v/wA+7/9AQH//QED//0BBL/8AQg//AEMP/0BDL/9AQ0//QAFwAG//IAC//yAPb/9AD+AAABCf/1ARr/9QE6//UBbf/1AYX/8gGG//IBiP/yAYn/8gGK//ID5f/1A+7/9QP3//ID+P/yA/v/8gQH//UED//1BDD/9QQy//UENP/1ABgA9//FAQP/xQEY/4ABHv/FASL/xQFC/8UBYP/FAWH/xQFr/8UD4P/FA+L/gAPk/8UD5//FA+n/kAQC/8UECP/FBA3/xQQb/8UEHf/FBB7/xQQo/4AEKv/FBCz/gAQ5/8UAHQDS/+IA1P/kANb/4gDZ/+EA2v/kAN3/5ADe/+kA7f/kAPL/6wEE/+sBM//kATn/4gFD/+QBRf/iAVD/5AFR/+sBXf/kAWb/5AFv/+QBcP/rA9H/6QPd/+ID3v/kBBH/5AQf/+QEL//pBDH/6QQz/+kEk//iAB4A9//wAQP/8AEY/+sBHP/rAR7/8AEi//ABQv/wAWD/8AFh//ABa//wAhD/6wIs/+sCNf/rA+D/8APi/+sD5P/wA+f/8AQC//AECP/wBA3/8AQb//AEHf/wBB7/8AQo/+sEKv/wBCz/6wQ5//AFDf/rBRD/6wUV/+sAHwAG/8AAC//AAN7/6wDh/+cA5v/DAPb/zwD+AAABGf/IATr/zgFH/+cBSf/nAUz/3wFi/9EBZP/sAWz/oAFt/9EBhf/AAYb/wAGI/8ABif/AAYr/wAPR/+sD9//AA/j/wAP7/8AEBv/IBC//6wQx/+sEM//rBDX/5wSV/+cAHwDS/+MA1P/lANb/4wDZ/+IA2v/lAN3/5QDe/+kA8v/qAQT/6gEz/+UBOf/jAUP/5QFF/+MBUP/lAVH/6gFd/+UBZv/lAWz/5AFv/+UBcP/qA9H/6QPd/+MD3v/lBA7/5AQR/+UEH//lBC//6QQx/+kEM//pBJP/4wSi/+QAIAAb//IA0v/xANT/9QDW//EA2v/0AN3/9QDe//MA5v/xARn/9AEz//QBOf/xAUP/9AFF//EBUP/1AV3/9AFi//IBZP/yAWb/9QFs//IBb//1A9H/8wPd//ED3v/0BAb/9AQO//AEEf/0BB//9AQv//MEMf/zBDP/8wST//EEov/wACIA7QA6APIAGAD2/+MA9wAMAPn/9wD8AAAA/gAAAQMADAEEABgBHgAMASIADAE6/+IBQgAMAUj/9wFK/+MBUQAYAWAADAFhAAwBawAMAW3/4wFwABgD4AAMA+QADAPnAAwEAgAMBAgADAQNAAwEGwAMBB0ADAQeAAwEKgAMBDb/9wQ5AAwElv/3ACIAbf2/AHz+fQDZ/1IA5gAFAOr/vQDr/0kA7f7+AO//EwD2/2gA/f8OAP7/MwD//xMBAf8HAQIAAAEH/w4BCf8RARz/PAEg/6wBLv8VATD/PAE4/w4BOv9qAUD/SQFK/wwBTP8/AU3+8QFY/8ABX/7vAWP/MQFl/18Baf8KAWwABQFt/zABbv/VACMABP/YAG3+uAB8/ygA2f+lAOYADwDq/+QA6/+gAO3/dADv/4AA9v+yAP3/fQD+/5MA//+AAQH/eQECAAABB/99AQn/fwEc/5gBIP/aAS7/gQEw/5gBOP99ATr/swFA/6ABSv98AUz/mgFN/2wBWP/mAV//awFj/5IBZf+tAWn/ewFsAA8Bbf+RAW7/8gAnAOwAAADtABQA8AAAAPEAAADzAAAA9AAAAPUAAAD2/+0A+AAAAPn/7QD6AAAA+wAAAPz/4gD+AAABAAAAAQUAAAErAAABNgAAATr/7QE8AAABPgAAAUj/7QFK/+0BUwAAAVUAAAFXAAABXAAAAW3/7QPhAAAD4wAAA+gAAAPtAAAEAwAABCQAAAQmAAAENv/tBDgAAASW/+0EmAAAACoA7P/vAO3/7gDu//AA8P/vAPH/7wDz/+8A9P/vAPX/7wD2/+4A+P/vAPr/7wD7/+8A/v/vAQD/7wEF/+8BCf/0ASD/8QEr/+8BNP/wATb/7wE6/+8BPP/vAT7/7wFE//ABU//vAVX/7wFX/+8BXP/vAV7/8AFt/+8D4f/vA+P/7wPm//AD6P/vA+3/7wQD/+8EEv/wBCD/8AQk/+8EJv/vBDj/7wSY/+8AMwDS/74A1v++AOb/yQDsAAAA8AAAAPEAAADzAAAA9AAAAPUAAAD2/98A+AAAAPoAAAD7AAAA/gAAAQAAAAEFAAABCf/tARr/7wEg/+sBKwAAATYAAAE5/74BOv/fATwAAAE+AAABRf++AUz/6QFTAAABVQAAAVcAAAFcAAABY//1AW3/4APd/74D4QAAA+MAAAPl/+8D6AAAA+0AAAPu/+8EAwAABAf/7wQP/+8EJAAABCYAAAQw/+8EMv/vBDT/7wQ4AAAEk/++BJgAAAACAFEAJQA+AAAARQBeABoAgQCBADQAgwCDADUAhgCGADYAiQCJADcAiwCWADgAmACdAEQAsQCxAEoAugC7AEsAvwC/AE0AwQDBAE4AwwDEAE8AxwDHAFEAywDLAFIAzQDOAFMA0ADRAFUA0wDTAFcA2gDeAFgA4QDhAF0A5QDlAF4A5wDpAF8A6wD7AGIA/QD9AHMA/wEBAHQBAwEDAHcBCAEJAHgBFgEaAHoBHAEcAH8BIAEiAIABKgErAIMBMwE0AIUBNgE2AIcBOwE8AIgBQQFEAIoBRwFIAI4BSwFNAJABUQFRAJMBVAFYAJQBXQFeAJkBYgFiAJsBZAFkAJwBaAFoAJ0BagFsAJ4BbgFuAKEBcAFwAKIB7QIBAKMCBQIFALgCDgIOALkCEAIQALoCFwIZALsCGwIcAL4CHgIeAMACIgIiAMECJAImAMICLAIsAMUCMQIzAMYCNQI1AMkCQwJDAMoCRgJGAMsCSAJIAMwCSwJOAM0CegJ+ANECjgKTANYClgL+ANwDAQPAAUUDwgPCAgUDxAPOAgYD0APZAhED2wP2AhsD+gP6AjcD/AQDAjgEBQQHAkAECgQOAkMEEASbAkgEngSfAtQEoQSiAtYEpASnAtgEsQUNAtwFDwUZAzkFHAUpA0QAAQHx/8cAAQHx//EAAQHxAA0AAQBbAAsAAQCB/98AAQBKAA0AAgH2/+kCTP/pAAIB8f+3Afb/8AACAFgADgCB/58AOgCyAA8A0v/mANQADgDW/+YA2QATANoADgDdAA4A3gALAOH/5QDm/+YA5//0AO0AEgDyAA8A9v/nAPn/6AD+AAABBAAPAQ0ADwEZ/+YBMwAOATn/5gE6/+cBQwAOAUX/5gFH/+UBSP/oAUn/5QFK/+gBTP/kAVAADgFRAA8BXQAOAWL/5gFk/+YBZgAOAWz/5gFt/+cBbwAOAXAADwPRAAsD0gAPA93/5gPeAA4EBv/mBA7/5gQRAA4EFAAPBBYADwQfAA4ELwALBDEACwQzAAsENf/lBDb/6AST/+YElf/lBJb/6ASi/+YAAwHw//UB8f/uA5z/9QADAA3/5gBB//QAYf/vAAMASv/uAFv/6gHx//AAAwBb/8ECAP/mAkz/6AADAEoADwBYADIAWwARAAMAW//lAgD/6wJM/+0AAQD7AAgACgAUABUAFgAXABgAGQAaABsAHAAdACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBlAGcAgQCDAIQAjACPAJEAkwCxALIAswC0ALUAtgC3ALgAuQC6ANIA0wDUANUA1gDXANgA2QDaANsA3ADdAN4A3wDgAOEA4gDjAOQA5QDmAOcA6ADpAS8BMwE1ATcBOQE7AUEBQwFFAUkBSwFMAVgBWQFxAbIBuAG9AcAClgKXApkCmwKcAp0CngKfAqACoQKiAqMCpAKlAqYCpwKoAqkCqgKrAqwCrQKuAq8CsAKxArICswK0ArUC0gLUAtYC2ALaAtwC3gLgAuIC5ALmAugC6gLsAu4C8ALyAvQC9gL4AvoC/AL+Av8DAQMDAwUDBwMJAwsDDQMPAxEDFAMWAxgDGgMcAx4DIAMiAyQDJgMoAyoDLAMuAzADMgM0AzYDOAM6AzwDPgNAA0EDQwNFA0cDSQOiA6MDpAOlA6YDpwOoA6oDqwOsA60DrgOvA7ADsQOyA7MDtAO1A7YDtwO4A7kDyQPKA8sDzAPNA84DzwPQA9ED0gPTA9QD1QPWA9cD2APZA9oD2wPcA90D3gPvA/ED8wP1BAoEDAQOBCMEKQQvBJkEngSiBSMFJQA7ALIAEADS/+AA0//oANQAEADW/+AA2QAUAN0AEADh/+EA5v/gAO0AEwDyABAA+f/gAQQAEAEI/+gBDQAQARf/6AEZ/+ABG//oAR3/6AEf/+gBIf/oATn/4AFB/+gBRf/gAUf/4QFI/+ABSf/hAUr/4AFN/+EBUAAQAVEAEAFY/+kBYv/fAWT/3gFmABABav/oAWz/3wFu//IBbwAQAXAAEAPSABAD2f/oA9z/6APd/+AEBv/gBAn/6AQM/+gEDv/fBBQAEAQWABAEJ//oBCn/6AQr/+gENf/hBDb/4AST/+AElf/hBJb/4ASi/98ABABY/+8AW//fAJr/7gHx/80ABAANABQAQQARAFb/4gBhABMABQA4/9gDKv/YAyz/2AMu/9gE2//YAAUAI//DAFj/7wBb/98Amv/uAfH/zQAFAFv/pAHx/1QB9v/xAgD/8QJM//MABQANAA8AQQAMAFb/6wBhAA4CTP/pAAYAEP+EABL/hAGH/4QBi/+EAY//hAGQ/4QACAAE/9gAVv+1AFv/xwBt/rgAfP8oAIH/TQCG/44Aif+hAAkB7v/uAfD/9QHx//EB8//yA2j/7gOU//IDnP/1A53/7gOe/+4ACQHu/+UB8P/xAfH/6wHz/+kDaP/lA5T/6QOc//EDnf/lA57/5QABAIUABAAMAD8AXwCWAJ0AsgDSANQA1QDWANcA2ADZANoA2wDcAN0A3gDgAOEA4gDjAOQA5QDmAOcA6ADpAOoA6wDsAO0A7gDvAPEA9gD3APgA+wD8AP4A/wEAAQMBBAEFAQoBDQEYARkBGgEiAS4BLwEwATMBNAE1ATcBOQE7AUMBRAFUAVYBWAFcAV0BXgGGA8oDzAPNA88D0APRA9ID0wPUA9cD2APZA9sD3APdA94D3wPgA+ID4wPlA+YD5wPoA+4EAgQGBAcEDAQOBA8EEAQRBBIEEwQUBBUEFgQXBBsEHQQeBB8EIAQnBCgELAQuBC8EMAQxBDIEMwQ0BJMElwSYBJsEnQSeBKAEogBEAAYADQALAA0A7f+qAPL/rwD3/7ABA/+wAQT/rwEY/9YBGgALARz/4gEe/7ABIAAMASL/sAFC/7ABUf+vAWD/sAFh/7ABYwALAWUACwFr/7ABcP+vAYUADQGGAA0BiAANAYkADQGKAA0CBv+/Ag8ADgIQ/+0CEwAOAisADgIs/+0CLQANAi8ADgI1/+0D3//wA+D/sAPi/9YD5P+wA+UACwPn/7AD7gALA/cADQP4AA0D+wANBAL/sAQHAAsECP+wBA3/sAQPAAsEFf/wBBf/8AQb/7AEHf+wBB7/sAQo/9YEKv+wBCz/1gQwAAsEMgALBDQACwQ5/7AFBv+/BQ3/7QUQ/+0FEQAOBRX/7QUWAA0ARQDS/vUA1P/1ANb+9QDa//AA3f/1AN7/6wDh/+cA5v/DAOwAAADwAAAA8QAAAPMAAAD0AAAA9QAAAPb/zwD4AAAA+gAAAPsAAAD+AAABAAAAAQUAAAEZ/8gBKwAAATP/8AE2AAABOf71ATr/zgE8AAABPgAAAUP/8AFF/vUBR//nAUn/5wFM/98BUP/1AVMAAAFVAAABVwAAAVwAAAFd//ABYv/RAWT/7AFm//UBbP+gAW3/0QFv//UD0f/rA93+9QPe//AD4QAAA+MAAAPoAAAD7QAABAMAAAQG/8gEDv+tBBH/8AQf//AEJAAABCYAAAQv/+sEMf/rBDP/6wQ1/+cEOAAABJP+9QSV/+cEmAAABKL/rQBGANL/5gDW/+YA2v/yAN7/7gDh/+gA5v/mAOwAAADu//EA8AAAAPEAAADzAAAA9AAAAPUAAAD2/9AA+AAAAPoAAAD7AAAA/gAAAQAAAAEFAAABGf/nASsAAAEz//IBNP/xATYAAAE5/+YBOv/OATwAAAE+AAABQ//yAUT/8QFF/+YBR//oAUn/6AFTAAABVQAAAVcAAAFcAAABXf/yAV7/8QFi/+cBZP/tAWz/5gFt/9AD0f/uA93/5gPe//ID4QAAA+MAAAPm//ED6AAAA+0AAAQDAAAEBv/nBA7/5wQR//IEEv/xBB//8gQg//EEJAAABCYAAAQv/+4EMf/uBDP/7gQ1/+gEOAAABJP/5gSV/+gEmAAABKL/5wAPAAr/4gANABQADv/PAEEAEgBK/+oAVv/YAFj/6gBhABMAbf+uAHz/zQCB/6AAhv/BAIn/wAGO/9MCTP/NABAAOP+wADr/7QA9/9ACtf/QAyr/sAMs/7ADLv+wAz7/0ANA/9AD9f/QBIz/0ASO/9AEkP/QBNv/sATe/+0E4P/tABAALv/uADn/7gKx/+4Csv/uArP/7gK0/+4DAf/uAzD/7gMy/+4DNP/uAzb/7gM4/+4DOv/uBH7/7gSA/+4E3f/uABAALv/sADn/7AKx/+wCsv/sArP/7AK0/+wDAf/sAzD/7AMy/+wDNP/sAzb/7AM4/+wDOv/sBH7/7ASA/+wE3f/sABEAOgAUADsAEgA9ABYCtQAWAzwAEgM+ABYDQAAWA+8AEgPxABID8wASA/UAFgSMABYEjgAWBJAAFgTeABQE4AAUBOIAEgATAFP/7AGGAAACx//sAsj/7ALJ/+wCyv/sAsv/7AMV/+wDF//sAxn/7ARn/+wEaf/sBGv/7ARt/+wEb//sBHH/7ARz/+wEe//sBLz/7AAVAAb/8gAL//IAWv/zAF3/8wGF//IBhv/yAYj/8gGJ//IBiv/yAtD/8wLR//MDP//zA/b/8wP3//ID+P/yA/v/8gSN//MEj//zBJH/8wTf//ME4f/zAFEABv/AAAv/wADS/vUA1v71ANr/8ADe/+sA4f/nAOb/wwDsAAAA7v/JAPAAAADxAAAA8wAAAPQAAAD1AAAA9v/PAPgAAAD6AAAA+wAAAP4AAAEAAAABBQAAARn/yAErAAABM//wATT/yQE2AAABOf71ATr/zgE8AAABPgAAAUP/8AFE/8kBRf71AUf/5wFJ/+cBTP/fAVMAAAFVAAABVwAAAVwAAAFd//ABXv/JAWL/0QFk/+wBbP+gAW3/0QGF/8ABhv/AAYj/wAGJ/8ABiv/AA9H/6wPd/vUD3v/wA+EAAAPjAAAD5v/JA+gAAAPtAAAD9//AA/j/wAP7/8AEAwAABAb/yAQO/60EEf/wBBL/yQQf//AEIP/JBCQAAAQmAAAEL//rBDH/6wQz/+sENf/nBDgAAAST/vUElf/nBJgAAASi/60AIgA4/9UAOv/kADv/7AA9/90CBgAOAk4ADgK1/90DKv/VAyz/1QMu/9UDPP/sAz7/3QNA/90DTgAOA08ADgNQAA4DUQAOA1IADgNTAA4DVAAOA2kADgNqAA4DawAOA+//7APx/+wD8//sA/X/3QSM/90Ejv/dBJD/3QTb/9UE3v/kBOD/5ATi/+wAWwAG/8oAC//KANL/0gDW/9IA2v/0AN7/7QDh/+EA5v/UAOz/0QDu/+8A8P/RAPH/0QDz/9EA9P/RAPX/0QD2/8kA+P/RAPr/0QD7/9EA/v/RAQD/0QEF/9EBCf/lARn/1AEa/+YBIP/jASv/0QEz//QBNP/vATb/0QE5/9IBOv/EATz/0QE+/9EBQ//0AUT/7wFF/9IBR//hAUn/4QFT/9EBVf/RAVf/0QFc/9EBXf/0AV7/7wFi/9QBY//1AWT/5wFs/9IBbf/JAYX/ygGG/8oBiP/KAYn/ygGK/8oD0f/tA93/0gPe//QD4f/RA+P/0QPl/+YD5v/vA+j/0QPt/9ED7v/mA/f/ygP4/8oD+//KBAP/0QQG/9QEB//mBA7/0wQP/+YEEf/0BBL/7wQf//QEIP/vBCT/0QQm/9EEL//tBDD/5gQx/+0EMv/mBDP/7QQ0/+YENf/hBDj/0QST/9IElf/hBJj/0QSi/9MAKQBH/+wASP/sAEn/7ABL/+wAVf/sAJT/7ACZ/+wCvf/sAr7/7AK//+wCwP/sAsH/7ALZ/+wC2//sAt3/7ALf/+wC4f/sAuP/7ALl/+wC5//sAun/7ALr/+wC7f/sAu//7ALx/+wC8//sBFP/7ARV/+wEV//sBFn/7ARb/+wEXf/sBF//7ARh/+wEdf/sBHf/7AR5/+wEff/sBLj/7ATF/+wEx//sADYABgAQAAsAEAANABQAQQASAEf/6ABI/+gASf/oAEv/6ABV/+gAYQATAJT/6ACZ/+gBhQAQAYYAEAGIABABiQAQAYoAEAK9/+gCvv/oAr//6ALA/+gCwf/oAtn/6ALb/+gC3f/oAt//6ALh/+gC4//oAuX/6ALn/+gC6f/oAuv/6ALt/+gC7//oAvH/6ALz/+gD9wAQA/gAEAP7ABAEU//oBFX/6ARX/+gEWf/oBFv/6ARd/+gEX//oBGH/6AR1/+gEd//oBHn/6AR9/+gEuP/oBMX/6ATH/+gASgBH/8UASP/FAEn/xQBL/8UATAAgAE8AIABQACAAU/+AAFX/xQBX/5AAWwALAJT/xQCZ/8UB3P+QAr3/xQK+/8UCv//FAsD/xQLB/8UCx/+AAsj/gALJ/4ACyv+AAsv/gALZ/8UC2//FAt3/xQLf/8UC4f/FAuP/xQLl/8UC5//FAun/xQLr/8UC7f/FAu//xQLx/8UC8//FAxX/gAMX/4ADGf+AAyH/kAMj/5ADJf+QAyf/kAMp/5AEU//FBFX/xQRX/8UEWf/FBFv/xQRd/8UEX//FBGH/xQRn/4AEaf+ABGv/gARt/4AEb/+ABHH/gARz/4AEdf/FBHf/xQR5/8UEe/+ABH3/xQS4/8UEvP+ABMX/xQTH/8UEyQAgBMsAIATNACAE2v+QAAEA9AAEAAYACwAMACUAJwAoACkAKgAvADAAMwA0ADUANgA4ADoAOwA8AD0APgA/AEkASgBMAE8AUQBSAFMAVgBYAFoAWwBdAF8AlgCdALIBhQGGAYgBiQGKAfMB9QH2AfgB+wIGAksCTgJgAmICYwKWApcCmQKbApwCnQKeAp8CoAKhAqICowKkAqUCpgKsAq0CrgKvArACtQK+Ar8CwALBAsYCxwLIAskCygLLAtAC0QLSAtQC1gLYAtoC3ALeAuAC4gLjAuQC5QLmAucC6ALpAuoC6wL1AwMDBQMHAwkDCwMOAxADEgMTAxQDFQMWAxcDGAMZAxsDHQMfAyoDLAMuAzwDPgM/A0ADQQNDA0UDSwNMA00DTgNPA1ADUQNSA1MDVANfA2ADYQNiA2MDaQNqA2sDcAOCA4MDhAOFA4kDigOLA5QD7wPxA/MD9QP2A/cD+AP7A/0D/gQ6BDwEPgRABEIERARGBEgESgRMBE4EUARSBFMEVARVBFYEVwRYBFkEWgRbBFwEXQReBF8EYARhBGYEZwRoBGkEagRrBGwEbQRuBG8EcARxBHIEcwR7BIwEjQSOBI8EkASRBLQEtQS3BLsEvAS+BMQExgTJBMoEzATOBNEE0wTUBNUE2ATbBN4E3wTgBOEE4gTkAAEANQAGAAsAlgCxALIAswC0AL0AwQDHAYUBhgGIAYkBigIGAgcCCAOiA6MDpAOlA6YDpwOqA6sDrAOtA64DrwOwA7EDsgOzA7QDtQO2A7cDuAO5A7wDwAPCA8YD9wP4A/sE5gTnBOsE7gT0BPkApwAQ/xYAEv8WACX/VgAu/vgAOAAUAEX/3gBH/+sASP/rAEn/6wBL/+sAU//rAFX/6wBW/+YAWf/qAFr/6ABd/+gAlP/rAJn/6wCb/+oAsv9WAYf/FgGL/xYBj/8WAZD/FgIG/8ACTv/AApv/VgKc/1YCnf9WAp7/VgKf/1YCoP9WAqH/VgK2/94Ct//eArj/3gK5/94Cuv/eArv/3gK8/94Cvf/rAr7/6wK//+sCwP/rAsH/6wLH/+sCyP/rAsn/6wLK/+sCy//rAsz/6gLN/+oCzv/qAs//6gLQ/+gC0f/oAtL/VgLT/94C1P9WAtX/3gLW/1YC1//eAtn/6wLb/+sC3f/rAt//6wLh/+sC4//rAuX/6wLn/+sC6f/rAuv/6wLt/+sC7//rAvH/6wLz/+sDAf74AxX/6wMX/+sDGf/rAyoAFAMsABQDLgAUAzH/6gMz/+oDNf/qAzf/6gM5/+oDO//qAz//6ANO/8ADT//AA1D/wANR/8ADUv/AA1P/wANU/8ADaf/AA2r/wANr/8AD9v/oA/7/VgP//94EOv9WBDv/3gQ8/1YEPf/eBD7/VgQ//94EQP9WBEH/3gRC/1YEQ//eBET/VgRF/94ERv9WBEf/3gRI/1YESf/eBEr/VgRL/94ETP9WBE3/3gRO/1YET//eBFD/VgRR/94EU//rBFX/6wRX/+sEWf/rBFv/6wRd/+sEX//rBGH/6wRn/+sEaf/rBGv/6wRt/+sEb//rBHH/6wRz/+sEdf/rBHf/6wR5/+sEe//rBH3/6wR//+oEgf/qBIP/6gSF/+oEh//qBIn/6gSL/+oEjf/oBI//6ASR/+gEtf9WBLb/3gS4/+sEvP/rBMD/6gTF/+sEx//rBNsAFATf/+gE4f/oAAIAKACWAJYAFgCxALEADQCyALIAFwCzALMAAgC0ALQAAwC9AL0ACADBAMEABwDHAMcAFQIGAgYAEgIHAgcACQIIAggABQOiA6IAAwOjA6MABgOkA6UAAQOmA6YAAgOnA6cABAOqA6oAAwOrA6sACwOsA6wABgOtA60AEQOuA68AAQOwA7AADgOxA7IAAQOzA7MAAgO0A7QADwO1A7UAEAO2A7YABAO3A7cADAO4A7gAAQO5A7kABAO8A7wABwPAA8AACgPCA8IACAPGA8YACgTmBOYAAgTnBOcABQTrBOsACQTuBO4ABQT0BPQAEwT5BPkAFAACADIABgAGAAEACwALAAEAEAAQAAIAEQARAAMAEgASAAIAsgCyABMAswCzAAcAtAC0AAYAuwC7AAQAvQC9AAwAwQDBAAsAyADJAAQAywDLAAUBggGDAAMBhQGGAAEBhwGHAAIBiAGKAAEBiwGLAAIBjwGQAAICBgIGABECBwIHAA0CCAIIAAkClQKVAAMDogOiAAYDpgOmAAcDpwOnAAgDqgOqAAYDrQOtABADswOzAAcDtgO2AAgDtwO3AA8DuQO5AAgDugO6AAQDvAO8AAsDvgO+AAUDwAPAAA4DwgPCAAwDxQPFAAUDxgPGAA4DxwPHAAUD9wP4AAED+wP7AAEEqASoAAME5wTnAAkE6wTrAA0E7ATsAAoE7gTuAAkE+gT6AAoE+wT7ABIE/QT9AAoAAQCGAAYACwCWALIA1ADVANcA2gDcAN0A3gDgAOEA4gDjAOQA5QDmAOwA7gD3APwA/gD/AQQBBQEKAQ0BGAEZARoBLgEvATABMwE0ATUBNwE5ATsBQwFEAVQBVgFYAVwBXQFeAYUBhgGIAYkBigIGAhoCKQIqAisDyQPKA8wDzQPOA88D0APRA9ID0wPUA9UD1wPYA9kD2wPcA90D3gPfA+AD4gPjA+QD5QPmA+cD6APuA/cD+AP7BAAEAgQGBAcEDAQNBA4EDwQQBBEEEgQTBBQEFQQWBBcEGgQbBB0EHgQfBCAEJwQoBCwELgQvBDAEMQQyBDMENASTBJcEmASbBJ0EngSgBKIFBAUGBQ0FEQACAGsABgAGAAEACwALAAEAlgCWABwAsgCyAB0A1ADVAAkA2gDaAAMA3gDeAAoA5ADkAAkA5gDmAAkA7ADsAAsA7gDuAAQA9wD3AAwA/AD8AA0A/gD+AA0A/wD/AAwBBAEFAA0BCgEKAA0BDQENAA8BGAEYABABGQEZABYBGgEaAAIBLgEuAAwBLwEvAAgBMAEwAAsBMwEzAAMBNAE0AAQBNQE1AAUBNwE3AAUBOQE5AAUBQwFDAAMBRAFEAAQBWAFYABEBXAFcAAsBXQFdAAMBXgFeAAQBhQGGAAEBiAGKAAECBgIGABgCGgIaAAcCKQIrAAcDyQPJAA4DygPKAAgDzgPOAB4DzwPQAAUD0QPRAAoD0gPSAA8D0wPTAB8D1APUAAgD1QPVAA4D2QPZABED2wPbACAD3APcABMD3QPdABQD3gPeAAMD3wPfABID4APgAAYD4gPiABAD4wPjAAwD5APkABUD5QPlAAID5gPmAAQD5wPnAAYD6APoAAsD7gPuAAID9wP4AAED+wP7AAEEAAQAAA4EAgQCAAYEBgQGABYEBwQHAAIEDAQMABMEDQQNABUEDgQOABcEDwQPAAIEEQQRAAMEEgQSAAQEFAQUAA8EFQQVABIEFgQWAA8EFwQXABIEGgQaAA4EGwQbAAYEHQQeAAYEHwQfAAMEIAQgAAQEJwQnABEEKAQoABAELAQsABAELgQuAAwELwQvAAoEMAQwAAIEMQQxAAoEMgQyAAIEMwQzAAoENAQ0AAIEkwSTABQElwSXAAgEmASYAAsEmwSbACEEnQSdAAkEngSeAAgEoASgAAUEogSiABcFBAUEAAcFBgUGABkFDQUNABoFEQURABsAAgBaAAYABgAAAAsACwABACUAKQACACwANAAHADgAPgAQAEUARwAXAEkASQAaAEwATAAbAFEAVAAcAFYAVgAgAFoAWgAhAFwAXgAiAIoAigAlAJYAlgAmALIAsgAnAYUBhgAoAYgBigAqAfMB8wAtAfgB+AAuAfsB/AAvAgYCBgAxAksCSwAyAk4CTgAzAmACYAA0AmICYwA1ApYClwA3ApkCmQA5ApsCwQA6AsYCywBhAtAC4ABnAuIC6wB4AvQC9gCCAvgC+ACFAvoC+gCGAvwC/ACHAv4C/gCIAwEDAQCJAwMDAwCKAwUDBQCLAwcDBwCMAwkDCQCNAwsDCwCOAw0DGQCPAxsDGwCcAx0DHQCdAx8DHwCeAyoDKgCfAywDLACgAy4DLgChAzADMACiAzIDMgCjAzQDNACkAzYDNgClAzgDOACmAzoDOgCnAzwDPACoAz4DRgCpA0sDVACyA18DYwC8A2kDawDBA3ADcADEA4EDhQDFA4kDiwDKA5QDlADNA+8D7wDOA/ED8QDPA/MD8wDQA/UD+ADRA/sD/wDVBDoEYgDaBGQEZAEDBGYEcwEEBHsEewESBH4EfgETBIAEgAEUBIwEkQEVBLMEtwEbBLkEuQEgBLsEvAEhBL4EvgEjBMIExAEkBMYExgEnBMgEygEoBMwEzAErBM4EzgEsBNAE1gEtBNgE2AE0BNsE2wE1BN0E4gE2BOQE5QE8AAIAoAAGAAYABAALAAsABAAQABAACAARABEACwASABIACACyALIAGwDSANIACgDTANMAAwDUANQADQDWANYACgDaANoABgDdAN0ADQDeAN4ADgDhAOEAEQDsAOwAAQDuAO4ABwDwAPEAAQDyAPIAEgDzAPUAAQD3APcAAgD4APgAAQD5APkAFAD6APsAAQD+AP4AAQEAAQAAAQEDAQMAAgEEAQQAEgEFAQUAAQEIAQgAAwENAQ0AEAEXARcAAwEYARgAEwEZARkAFwEaARoABQEbARsAAwEdAR0AAwEeAR4AAgEfAR8AAwEhASEAAwEiASIAAgErASsAAQEzATMABgE0ATQABwE2ATYAAQE5ATkACgE8ATwAAQE+AT4AAQFBAUEAAwFCAUIAAgFDAUMABgFEAUQABwFFAUUACgFHAUcAEQFIAUgAFAFQAVAADQFRAVEAEgFTAVMAAQFVAVUAAQFXAVcAAQFcAVwAAQFdAV0ABgFeAV4ABwFgAWEAAgFmAWYADQFqAWoAAwFrAWsAAgFvAW8ADQFwAXAAEgGCAYMACwGFAYYABAGHAYcACAGIAYoABAGLAYsACAGPAZAACAIGAgYAGQIPAg8ADAIQAhAACQITAhMADAIXAhcADwIoAigADwIrAisADAIsAiwACQItAi0AFgIuAi4ADwIvAi8ADAI1AjUACQKVApUACwPOA84AHAPRA9EADgPSA9IAEAPZA9kAAwPcA9wAAwPdA90ACgPeA94ABgPfA98AFQPgA+AAAgPhA+EAAQPiA+IAEwPjA+MAAQPkA+QAAgPlA+UABQPmA+YABwPnA+cAAgPoA+gAAQPpA+kAHQPtA+0AAQPuA+4ABQP3A/gABAP7A/sABAQCBAIAAgQDBAMAAQQGBAYAFwQHBAcABQQIBAgAAgQJBAkAAwQMBAwAAwQNBA0AAgQOBA4AGAQPBA8ABQQRBBEABgQSBBIABwQUBBQAEAQVBBUAFQQWBBYAEAQXBBcAFQQbBBsAAgQdBB4AAgQfBB8ABgQgBCAABwQkBCQAAQQmBCYAAQQnBCcAAwQoBCgAEwQpBCkAAwQqBCoAAgQrBCsAAwQsBCwAEwQvBC8ADgQwBDAABQQxBDEADgQyBDIABQQzBDMADgQ0BDQABQQ1BDUAEQQ2BDYAFAQ4BDgAAQQ5BDkAAgSTBJMACgSVBJUAEQSWBJYAFASYBJgAAQSiBKIAGASoBKgACwUGBQYAGgUNBQ0ACQUQBRAACQURBREADAUSBRIADwUVBRUACQUWBRYAFgNSKFIlBCWIIQ4h4CHmJaAhDihqJRwoaiTIHPok1CW4IRojVCU0IPwhAiXoJdYmAB1yJhIhmCYqJOwnDicUJYgmSBn6GXAmWiVeJnIg8CaKJGgmoiaoJsYmtCbeIWgkqiSwJJ4kpCb2IQ4oXiUQJY4ZdiHsIfIlrCRiKHYlKBl8GYIdBiTgJcQkjCNgJUAhRCGMJfQl4iYMJUAmHiGkJjYk+CNyJVIhJiZUGYgZjiZmJWomfiE4JpYeMiPYJXwm0ibAJuohdCS2JLwkOCRcJwIesCIQAAAZlAAAIhYAABmaAAAl9CRiGaAZpiiaJUAguiDAGawZshm4Gb4mKiTsJjYk+BnEGcoZ0BnWGdwZ4hnoGe4jwCOuKF4juiQaJA4kJiV8G8gAACI0IkAkkgAAAAAgkCCcIKIkwgAAIKggriC0AAAAAAAAGfQAACDSAAAhwgAAINgg3iWCAAAaeAAAGfoAABoAAAAh1CJYGgYAAAAAGgwaEgAAJHQAABoYAAAaHgAAGiQAABoqAAAaMAAAJJgAABo2AAAaPAAAIdoiZBpCAAAaSAAAGk4aVBpaAAAaYAAAGmYAACRuAAAabAAAGnIAACR6AAAahAAAGngAABp+AAAbIAAAGoQAABqKAAAakAAAGpYAABqcAAAaogAAIo4AACKUAAAaqAAAGq4AABq0AAAaugAAGsAaxhrMGtIa2AAAGt4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAGuQbpCCoGuoAAAAAAAAAAAAAAAAAAAAAGvAAAAAAJIAAACSGAAAAAAAAAAAAAAAAAAAAAAAAAAAa9iIuAAAAAAAAAAAliBr8GwIbCBsOAAAbFBsaGyAbJhssIQ4bMhs4AAAAACf4KEwn+ChMJ8gnzhs+KEAbRBtKJ7Agcie8J8IoKCdEIBIgJBtQG1YnsCe2J6ooIicmJywnniekH9wf4icgJ24nXCdiJ0onVifgJ+YflB+OG1wbYieMAAAAACcaG2gAABtuAAAn1CfaG3QAAAAAG3obgAAAJ/gAABuGAAAbjAAAG5IAABuYAAAbnhukG6oAAAAAJ/4bsBu2G7wAACiOJ5Ibwh1yJfQl4h7OJ7Yn7CfyJ4AnhiiCJ3obyCGMG8gbziiaJUAomhvUKJolQB/cH+Ib2igWG+Ab5ieqKCIn4CfmJyYnLCWgIQ4loCEOJcQkjCaKJGgmlh4yG+wlBBvsJQQi9CUEG/IlBCIEJQQb+CUEKFIlBCHgG/4hqiUcIaolHCMwJRwg5CUcHAQlNBwEJTQcCiU0IPYlNBwQJOwcFicUHBYnFCN4JxQcHCcUIoInFBwiJqgcIiaoHCgmqBwuJqgheiSkI5YlECOWJRAi+iUQI7QlECIKJRAcNCUQKF4lECHsHDohtiUoIbYlKCM8JSghLCUoHEAlQBxAJUAcRiVAIT4lQBxMJPgcUiVSHFIlUiOEJVIcWCVSIoglUhxeJXwcXiV8HGQlfBxqJXwhgCRcIsQkXBxwJQQcdiUQIwAlBCMMJRAoUiUEKF4lEBx8IeYcgiHyHIgh5hyOIfIclCHmHJoh8hygIeYcpiHyHKwhDiWsJGIcsiUcHLglKCIcJRwiIiUoHL4lHBzEJSgoaiUcKHYlKBzKJRwc0CUoHNYk1BzcJOAc4iTUHOgk4BzuJNQc9CTgHPodAB0GJOAdDCEaHRIkjB0YJTQjYCVAHR4lNB0kJUAdKiU0HTAlQCNUHTYjYCVAHTwlNB1CIQIdSAAAJegdTiX0HVQdWh1yHWAlQCYAHWYmDB1sJgAdciYMJUAmAB1yJgwlQCTmJOwk8iT4JiodeCY2HX4dhCTsHYok+CY2JPgdkCcUHZYlUh2cJxQdoiVSHagnFB2uJVIdtCVeHbolaiZaHcAmZh3GHcwlXh3SJWod2CDwHd4hOB3kIPAd6iE4JnId8CZ+HfYmch38Jn4eAh4IIPAeDiE4JooeFCaWHhomih4gJpYeJh4sJGgmlh4yHjgmqB4+JXweRCaoHkolfB5QJqgeViV8HlwmqB5iJXweaCaoHm4lfCaiJqgj2CV8HnQhaB56IXQegCSkHoYkXCCWJKQejCEOHpIesB6YIQ4enh6wHqQhDh6qHrAetgAAHrwAAB7CAAAeyAAAHs4nth7OJ7YnvCfCHtQneh7UJ3oe2id6HuAneh7mJ3oe7Cd6KIIneifsHvIe+CeSHvgnkh7+J5InOCeSHwQnVh8EJ1YfCidWJ1AnVh8QJywoHCgiKBwoIh8WKCIfHCgiHyIoIh8oIHIfKCByHy4gch80IHIoRihMHzoneh9AJ3oogid6H0Yn8h9MJ/IfUifyH1gn8h9eJ7YfZCeSH2onkh9wJ5IojieSH3Ynkh98H44fgh+OH4gfjh+UH5ofoCfmH6YnVh+sJ1YfsidWJ0ofuB++J1YfxCdiJyAfyh/QH+If3B/WH9wf4h/cH+If6CcsJyYf7h/0Jywf+igiIAAoIiAGKCIgDCAkIBIgGCAeICQgKidEIDAnRCgoIDYgPCdEJ7wgQiBIJ8InvCBOIFQgciBaIHIgYCByIGYgciBsIHInsCByIHgoQCB+KEwnMihMKEYoTCCEKEwgiihMKFIlBChqJRwluCEaI1QlNCcOJxQkniSkAAAgkCC0AAAoUiUEJYghDihqJRwm9iEOJbghGiNUJTQl6CXWJhIhmCYqJOwnDicUJYgmSCaKJGgkniSkJKoksCD2JTQgliSkIJwgoiTCAAAgqCCuILQAACDSAAAguiDAI3IlUibSJsAgxgAAIMwAACNyJVIg0gAAINgg3iDkJRwg6gAAJnIg8CNUJTQg9iU0IPwhAiXQJdYhCAAAKFIlBCWIIQ4kkgAAKGolHCEUAAAmEiGYJbghGicOJxQliCZIIeAh5iaKJGgkqiSwKF4lECh2JSghIAAAI3IlUiEmJlQh7CHyJDgkXCS2JLwhLCUoITIAACZ+ITgjYCVAIT4lQCFEIYwhSgAAIVAkXCFWIWghXCF0IVYhaCFcIXQhYiFoIW4hdCF6JKQhgCRcIYYhjCGSIZghniGkKFIlBCheJRAhqiUcIbAAACG2JSghvAAAIcIAACHIAAAhzgAAIdQiWCHaImQh4CHmIewh8iSeJKQjVCU0IfgAACH+AAAjVCU0IwAlBCMMJRAiBCUEIgolECIQAAAiFgAAIhwlHCIiJSgiKCIuIjQiQCI6IkAiRgAAIkwAACJSIlgiXiJkImoAACJwAAAidgAAInwAACKCJxQiiCVSIo4AACKUAAAimgAAIqAAACKmAAAirAAAIrIAACK4JFwivgAAIsQkXCLKAAAi0CRcItYAACLcAAAi4gAAIugAACWsJGIoUiMGKF4jEiLuJQQjoiUQKFIlBCheJRAoUiUEKF4lEChSJQQoXiUQKFIlBCheJRAi9CMGIvojEihSJQQoXiUQKFIlBCheJRAoUiUEKF4lEChSJQQoXiUQIwAjBiMMIxIoaiM2KHYjQiMYJRwjHiUoIyQlHCMqJSgoaiUcKHYlKChqJRwodiUoKGolHCh2JSgoaiUcKHYlKCMwIzYjPCNCI0glNCNOJUAjVCNaI2AooCcOI34jciOKI2YnFCNsJVInDicUI3IlUicOJxQjciVSJw4nFCNyJVInDicUI3IlUiN4I34jhCOKI5AjriOWI7ojkCOuI5YjuiOcI64joiO6I6gjriO0I7ojwCPGKF4jzCaiI9Ij2CPeI+QmqCPqJXwj8CQOI/YlfCPwJA4j9iV8I/wkDiQCJXwkCCQOJBQlfCQaJCAkJiQsJJ4kMiQ4JD4kRCSkJEokXCRQJKQkViRcJawkYiaKJGgkbgAAJHQAACR6AAAkkgAAJJgAAAAAJIAAACSGJcQkjCSSAAAkmAAAJfQl4iSeJKQkqiSwJLYkvCTCAAAoaiTIJM4k1CTaJOAk5iTsJPIk+CT+JQQlCiUQJRYlHCUiJSglLiU0JTolQCVGJxQlTCVSJVglXiVkJWolcCaoJXYlfCWCAAAliCb8JY4llCWgJvwlrCWaJaAlpiWsJbIluCW+JcQlyiXQJdYl3CXiJegl7iX0JfomACYGJgwooCYSJhgmHiYkJiomMCY2JjwnDicUJkImSCZOJlQmWiZgJmYmbCZyJngmfiaEJoomkCaWJpwmoiaoJq4mtCa6JsAmxibMJtIm2CbeJuQm6ibwJvYm/CcCJwgnDicUKIIneiiOJ5In4CfmJ0onVieqKCIn+ChMAAAnGiiCJ3ongCeGKI4nkif4KEwn4CfmJ0onVicgJ24nniekJyYnLCeqKCInsCe2J7wnwif4KEwnyCfOJ1AnVicyKEwnOCeSJz4AACgoJ0QnSidWJ1AnVidcJ2InaCduJ3QAACiCJ3ongCeGJ4wAACiOJ5InmAAAJ54npCfgJ+YnqigiJ7AntifsJ/InvCfCJ8gnzifUJ9on4CfmJ+wn8if4KEwAACf+KAQAACgKAAAoECgWKBwoIigoKC4oNChAKDQoQCg6KEAoRihMKFIoWCheKGQoaihwKHYofCiCKIgojiiUKJoooAACAOwABgAGAAwACwALAAwAJQAlAAIAJgAmABsAJwAnAA4AKQApAAQALAAtAAEALgAuAAcALwAvABgAMAAwAA8AMQAyAAEANAA0ABwAOAA4ABAAOQA5AAcAOgA6ABkAOwA7ABEAPAA8AB4APQA9AA0APgA+ABQARQBFAAMARgBGABUARwBHABIASQBJAAUATABMAAgAUQBSAAgAUwBTAAYAVABUABUAVgBWABMAWgBaAAsAXABcACIAXQBdAAsAXgBeABcAigCKABUAlgCWACAAsgCyACEBhQGGAAwBiAGKAAwB8wHzABoB+AH4AAkB+wH7ABYB/AH8AB0CBgIGAB8CSwJLAAkCTgJOAAoCYAJgAA4CmQKZABACmwKhAAICogKiAA4CowKmAAQCpwKrAAECsQK0AAcCtQK1AA0CtgK8AAMCvQK9ABICvgLBAAUCxgLGAAgCxwLLAAYC0ALRAAsC0gLSAAIC0wLTAAMC1ALUAAIC1QLVAAMC1gLWAAIC1wLXAAMC2ALYAA4C2QLZABIC2gLaAA4C2wLbABIC3ALcAA4C3QLdABIC3gLeAA4C3wLfABIC4gLiAAQC4wLjAAUC5ALkAAQC5QLlAAUC5gLmAAQC5wLnAAUC6ALoAAQC6QLpAAUC6gLqAAQC6wLrAAUC9AL0AAEC9QL1AAgC9gL2AAEC+AL4AAEC+gL6AAEC/AL8AAEC/gL+AAEDAQMBAAcDAwMDABgDBQMFAA8DBwMHAA8DCQMJAA8DCwMLAA8DDQMNAAEDDgMOAAgDDwMPAAEDEAMQAAgDEQMRAAEDEgMTAAgDFQMVAAYDFwMXAAYDGQMZAAYDGwMbABMDHQMdABMDHwMfABMDKgMqABADLAMsABADLgMuABADMAMwAAcDMgMyAAcDNAM0AAcDNgM2AAcDOAM4AAcDOgM6AAcDPAM8ABEDPgM+AA0DPwM/AAsDQANAAA0DQQNBABQDQgNCABcDQwNDABQDRANEABcDRQNFABQDRgNGABcDSwNMAAkDTQNNABoDTgNUAAoDXwNjAAkDaQNrAAoDcANwAAkDgQOBAB0DggOFABYDiQOLAAkDlAOUABoD7wPvABED8QPxABED8wPzABED9QP1AA0D9gP2AAsD9wP4AAwD+wP7AAwD/AP8AAED/QP9AAgD/gP+AAID/wP/AAMEOgQ6AAIEOwQ7AAMEPAQ8AAIEPQQ9AAMEPgQ+AAIEPwQ/AAMEQARAAAIEQQRBAAMEQgRCAAIEQwRDAAMERAREAAIERQRFAAMERgRGAAIERwRHAAMESARIAAIESQRJAAMESgRKAAIESwRLAAMETARMAAIETQRNAAMETgROAAIETwRPAAMEUARQAAIEUQRRAAMEUgRSAAQEUwRTAAUEVARUAAQEVQRVAAUEVgRWAAQEVwRXAAUEWARYAAQEWQRZAAUEWgRaAAQEWwRbAAUEXARcAAQEXQRdAAUEXgReAAQEXwRfAAUEYARgAAQEYQRhAAUEYgRiAAEEZARkAAEEZwRnAAYEaQRpAAYEawRrAAYEbQRtAAYEbwRvAAYEcQRxAAYEcwRzAAYEewR7AAYEfgR+AAcEgASAAAcEjASMAA0EjQSNAAsEjgSOAA0EjwSPAAsEkASQAA0EkQSRAAsEswSzAAEEtAS0AAgEtQS1AAIEtgS2AAMEtwS3AAQEuQS5AAEEvAS8AAYEvgS+ABMEwgTCABsEwwTDABUEyATIAAEEyQTJAAgEygTKABgEzATMABgEzgTOAA8E0ATQAAEE0QTRAAgE0gTSAAEE0wTTAAgE1QTVABwE1gTWABUE2ATYABME2wTbABAE3QTdAAcE3gTeABkE3wTfAAsE4ATgABkE4QThAAsE4gTiABEE5ATkABQE5QTlABcAAgEJAAYABgANAAsACwANABAAEAASABEAEQAVABIAEgASACUAJQADACcAJwABACsAKwABAC4ALgAaADMAMwABADUANQABADcANwAQADgAOAATADkAOQAIADoAOgAZADsAOwARADwAPAAdAD0APQAOAD4APgAUAEUARQAEAEcASQACAEsASwACAFEAUgAJAFMAUwAHAFQAVAAJAFUAVQACAFcAVwAPAFkAWQAGAFoAWgAMAFwAXAAhAF0AXQAMAF4AXgAXAIMAgwABAJMAkwABAJQAlAACAJgAmAABAJkAmQACAJsAmwAGALIAsgAgAYIBgwAVAYUBhgANAYcBhwASAYgBigANAYsBiwASAY8BkAASAdwB3AAPAe4B7gAYAe8B7wAeAfAB8AAbAfIB8gAKAfMB8wAcAfQB9AAWAfYB9gAFAfgB+AAFAgACAAAFAgYCBgAfAkwCTAAFAk4CTgALAmACYQABAmMCZAABApUClQAVApsCoQADAqICogABAqwCsAABArECtAAIArUCtQAOArYCvAAEAr0CwQACAsYCxgAJAscCywAHAswCzwAGAtAC0QAMAtIC0gADAtMC0wAEAtQC1AADAtUC1QAEAtYC1gADAtcC1wAEAtgC2AABAtkC2QACAtoC2gABAtsC2wACAtwC3AABAt0C3QACAt4C3gABAt8C3wACAuEC4QACAuMC4wACAuUC5QACAucC5wACAukC6QACAusC6wACAuwC7AABAu0C7QACAu4C7gABAu8C7wACAvAC8AABAvEC8QACAvIC8gABAvMC8wACAwEDAQAaAw4DDgAJAxADEAAJAxIDEwAJAxQDFAABAxUDFQAHAxYDFgABAxcDFwAHAxgDGAABAxkDGQAHAyADIAAQAyEDIQAPAyIDIgAQAyMDIwAPAyQDJAAQAyUDJQAPAyYDJgAQAycDJwAPAygDKAAQAykDKQAPAyoDKgATAywDLAATAy4DLgATAzADMAAIAzEDMQAGAzIDMgAIAzMDMwAGAzQDNAAIAzUDNQAGAzYDNgAIAzcDNwAGAzgDOAAIAzkDOQAGAzoDOgAIAzsDOwAGAzwDPAARAz4DPgAOAz8DPwAMA0ADQAAOA0EDQQAUA0IDQgAXA0MDQwAUA0QDRAAXA0UDRQAUA0YDRgAXA0kDSQABA04DVAALA1UDVQAFA18DYwAFA2QDZwAKA2gDaAAYA2kDawALA2wDbwAFA3YDeQAFA4kDiwAFA48DkgAWA5QDlAAcA5YDmwAKA5wDnAAbA50DngAYA+8D7wARA/ED8QARA/MD8wARA/UD9QAOA/YD9gAMA/cD+AANA/sD+wANA/0D/QAJA/4D/gADA/8D/wAEBDoEOgADBDsEOwAEBDwEPAADBD0EPQAEBD4EPgADBD8EPwAEBEAEQAADBEEEQQAEBEIEQgADBEMEQwAEBEQERAADBEUERQAEBEYERgADBEcERwAEBEgESAADBEkESQAEBEoESgADBEsESwAEBEwETAADBE0ETQAEBE4ETgADBE8ETwAEBFAEUAADBFEEUQAEBFMEUwACBFUEVQACBFcEVwACBFkEWQACBFsEWwACBF0EXQACBF8EXwACBGEEYQACBGYEZgABBGcEZwAHBGgEaAABBGkEaQAHBGoEagABBGsEawAHBGwEbAABBG0EbQAHBG4EbgABBG8EbwAHBHAEcAABBHEEcQAHBHIEcgABBHMEcwAHBHQEdAABBHUEdQACBHYEdgABBHcEdwACBHgEeAABBHkEeQACBHoEegABBHsEewAHBHwEfAABBH0EfQACBH4EfgAIBH8EfwAGBIAEgAAIBIEEgQAGBIMEgwAGBIUEhQAGBIcEhwAGBIkEiQAGBIsEiwAGBIwEjAAOBI0EjQAMBI4EjgAOBI8EjwAMBJAEkAAOBJEEkQAMBKgEqAAVBLQEtAAJBLUEtQADBLYEtgAEBLgEuAACBLsEuwABBLwEvAAHBMAEwAAGBMUExQACBMcExwACBNEE0QAJBNME0wAJBNQE1AABBNkE2QAQBNoE2gAPBNsE2wATBN0E3QAIBN4E3gAZBN8E3wAMBOAE4AAZBOEE4QAMBOIE4gARBOQE5AAUBOUE5QAXAAH9q/6eAAH9qwAAAAH97gZpAAH9ygZpAAH95wY+AAH9sga5AAH+MwZAAAH97gUKAAH9ygUKAAH95wToAAH9sgT6AAH+MwUPAAH90gSmAAH+RASmAAH93AUBAAH+GgUBAAECuv/2AAECVv/2AAEB9gbaAAEBSgAKAAECGQUKAAEDlP5pAAECywaKAAECGQUJAAEC1AZMAAEC1AAKAAEBBgY8AAECagAKAAEBGAahAAEBGAAKAAEDuQZDAAEDuQAAAAEDsQUKAAEDsf//AAEBrAbaAAEA+AAKAAEClQZDAAECuAAAAAECUQUBAAECvAZAAAEDpQZMAAEC3QZMAAEC3gAKAAEChgZMAAEDegZMAAECtAZiAAEDlAZAAAECigZMAAECJQT1AAECtAT1AAEDDAT1AAECTgT1AAECHQT0AAEChAT1AAECLQAKAAEC8AT1AAECUgT1AAECWAT1AAEC5AbMAAECcwT1AAEDLAT1AAEDFAT1AAEDOwT1AAECDQT1AAECUgUIAAEDggYaAAEDBAT1AAEB0gbMAAECbQYIAAECBwTgAAECSgVQAAEDCQZAAAECnAZhAAECnP/2AAECPgUMAAECPv/2AAEC3QdjAAECTgYMAAECuwZRAAECQv/2AAECggZMAAECewYeAAECXgAKAAEBEwZMAAEBEwAKAAECxwZMAAECpgZhAAECpv/2AAECIwUKAAECI//2AAECZQZMAAECqwZhAAECq//2AAEDEgUoAAECMQUoAAECMQAKAAECVwUoAAECV//2AAECHQUoAAEB6QAKAAECVAUoAAEDBQUoAAECdgUoAAECWgAKAAECFAUoAAEC9AUoAAECIgUoAAEC5wUoAAECigUoAAECuwUoAAECu//2AAECdAUoAAECSQUoAAECUwAAAAECXwUoAAECbAZMAAEBCgThAAEBCv41AAEA+f41AAEDgAUKAAECDgUoAAEBwgAKAAECoAegAAECnwd5AAECoAffAAECqP4+AAEBFwerAAEBFwenAAEC1Qd5AAECwweiAAECwgd7AAECmwegAAECmwecAAECmwdgAAECRgaoAAECFf4+AAEA/AZnAAEA/AZjAAECPAZCAAECPwZpAAECPgZCAAECNwZpAAECNwZlAAECNwYpAAECoAdoAAECRgYxAAECqAfAAAECFQZpAAECqAe8AAECFQZlAAECpwd7AAECFAYkAAECqAeyAAECFQZbAAECYQedAAECawdzAAECNQYxAAECagdmAAECNAYkAAECawedAAECNQZbAAECoAe8AAECLAZlAAECoAedAAECLAZGAAECnwd7AAECKwYkAAECoAZhAAEC2v3zAAECLAUKAAECyAenAAEB9QemAAEBFgeEAAEBFwdzAAEA/AYvAAEBFweIAAEA/AZEAAEBF/5XAAEBFgdmAAEDVAeaAAEBCgY8AAEClP5WAAECEf5DAAEBCAebAAEA+QgAAAECbP4GAAEA+f4GAAECbAAKAAEC0P4GAAECM/4GAAEC1geSAAECPQZbAAECwwdqAAECPwYxAAECwwd/AAECPwZGAAECwweHAAECPwZOAAECYgegAAEBmAZpAAECY/4GAAEA9v4HAAECYgeSAAEBmAZbAAECbgeiAAECMgZpAAECbgeeAAECMgZlAAECdP5HAAECMv4+AAECdP37AAECMv3yAAECbgeUAAECMgZbAAECZv38AAEBxf38AAECZv5IAAEBxf5IAAECZAeRAAEBxQAAAAECmgd5AAECNgZCAAECmwdoAAECNwYxAAECmwd9AAECNwZGAAECmwffAAECNwaoAAECmweFAAECNwZOAAEDnAecAAEC+wZlAAECagebAAEB/AZlAAECaAegAAECAwZpAAECZwdbAAECAgYkAAECaAeSAAECAwZbAAECDgAKAAEDqwerAAEDWwZqAAECywfpAAECGQZoAAEB9AUoAAECRQaHAAECRQaDAAECRAZgAAECRQZHAAECRQbGAAECSv5EAAECGQaHAAECGQaDAAEA9AaHAAEA9AaDAAECbwZgAAECXgaDAAECXQZgAAECXgZHAAECQAaHAAECQAaDAAECQAZHAAECRQZPAAECRQZkAAECSwaHAAECSwaDAAECSgZCAAECSwZ5AAEB9AZ5AAECGQZPAAECGQZkAAECGAZCAAECGQZ5AAECSAaDAAECSAZkAAECRwZCAAECT//8AAECSAUoAAECT/34AAECZwaDAAEA8wZgAAEA9AZPAAEA9AZkAAEA9P5OAAEA8wZCAAEC3gaDAAECFP4CAAEA6QaHAAECD/4EAAEA6QUoAAECDwAIAAECcAaHAAECa/4AAAECcAZ5AAECXgZPAAECXgZkAAECXgZsAAECCAaHAAECCAUoAAECDf4EAAECCAZ5AAECDQAIAAECHwaHAAECHwaDAAECKP5IAAECHwZ5AAECE/3/AAECEgZ5AAECE/5LAAECPwZgAAECQAZPAAECQAZkAAECQAbGAAECQAZsAAECPgAAAAEDEgaDAAECFQaDAAECFAZCAAECFQZ5AAECpwAKAAECagdfAAECcQUKAAECJf/2AAECQgUKAAEA7wAKAAEBJgT1AAECTgUKAAECTgAKAAEBJgYUAAECHwYUAAECHwT1AAEDUATyAAEDS//2AAECawdrAAECcQerAAECdP//AAEBFwdrAAEDVAY/AAECAP/2AAEChgeIAAECZQAKAAEC3QeIAAECygAKAAECTgYxAAECdQUAAAECNQYpAAEBrwZUAAECMv/2AAEA/AYnAAEA3wZAAAECHQZTAAEB/AZGAAEDnAegAAEC+wZpAAEDnAdgAAEDmgAKAAEC+wYpAAEC/gAKAAECagefAAEB/AZpAAEBCgYyAAEAvv41AAEDegegAAEDfQAKAAEDjwZpAAEDgQAKAAECawerAAEC3QerAAECNQZpAAECTgZUAAECxwT1AAECbQc5AAECBwYRAAECXgZhAAECBgUJAAECqAZhAAECqP/2AAECFQUKAAECFf/2AAEDpQeIAAEDDAYxAAECoAdgAAECRgYpAAEDqwZMAAEDWwULAAECaweIAAECNQZGAAECewc9AAECowAAAAECLwULAAECLwYqAAECPQAAAAEDpQdrAAEDDAYUAAECXgeAAAECXv/2AAECBgYoAAECBv/3AAEC3QdzAAECTgYcAAEC3QdrAAECTgYUAAECwwdiAAECPwYpAAECzwZHAAECLwUMAAECzwdmAAECLwYrAAECtAeBAAECIwYpAAEChgdzAAEB/AYxAAEChgdrAAEB/AYpAAEChgeQAAEB/AZOAAECsAdrAAECDAYUAAEDegdrAAEDFAYUAAECoAgAAAECoAecAAECRgZlAAECoAd9AAECrv6eAAECRgZGAAEB9v6eAAECawgLAAECNQbJAAECageEAAECNAZCAAECawenAAECa/6oAAECNQZlAAECOP6eAAEBFwgLAAEA/AbHAAEBFwZMAAEBF/6nAAEA+wZAAAECwwgCAAECPwbJAAECPwUKAAECwweeAAECw/6eAAECPwZlAAECSP6dAAECvweaAAECRgZpAAECvwf6AAECRgbJAAECvgdzAAECtAAAAAECRQZCAAECRv/2AAECvwY7AAECtP6eAAECRv6UAAECmv6eAAECNwUKAAEB/f6eAAECmwgAAAECNwbJAAECtgerAAECRAZUAAECtggLAAECRAa0AAECtQeEAAECtP/3AAECQwYtAAECtgZMAAECtP6VAAECRAT1AAECM/6eAAECZ/6fAAEB/AUKAAECyP4AAAECagf/AAEB/AbJAAECaQd4AAEB+wZCAAECyP9iAAECaQAAAAECZgAAAAEB5wT1AAECsAZMAAECDAT1AAEDyf/6AAECw//9AAECTAAKAAECcQZMAAEBrwT1AAECagZAAAECZwABAAECjQZMAAEChQAKAAEB/AUAAAEB/wAKAAECJwUJAAECEwAKAAECoAfAAAEC2v/3AAECLAZpAAECKv5BAAEC1gegAAEC0AAKAAECPQZpAAECMwAKAAECoAdyAAECrgAAAAECRgY7AAEB9gAAAAECawd9AAECawAKAAECNQY7AAECOAAAAAEBFwd9AAEBFwAJAAEA/AY5AAEA+QAKAAECwwd0AAECPwY7AAECSP//AAECYgdyAAECYwAKAAEBmAY7AAEA9gALAAECmwdyAAECNwY7AAECMwAAAAECHAZMAAECXgZMAAECegZLAAECVv6UAAECaf6eAAECYQZMAAECZf4GAAECJQZMAAECaf38AAECyAZMAAECyv6oAAEB9QZLAAECTP6oAAECXQeaAAEClABaAAECJQeqAAECEQBHAAECXQY7AAEClP74AAECJQZLAAECEf7lAAEBCAY8AAECbP6oAAEA+QahAAEDegZBAAEDff6oAAEDjwUKAAEDgf6oAAEC1gZBAAEC0P6oAAECPQUKAAECM/6oAAECXgerAAECEgAKAAECdQZfAAEA5/5pAAECYgZBAAECY/6oAAEBmAUKAAEA9v6pAAECbgZDAAECdP6dAAECMgUKAAECMv6UAAECZAZAAAECZv6eAAEBOAXJAAEBxf6eAAECmwZBAAECmgAAAAECjgeEAAECjwAKAAEB+AY4AAEB+AAKAAECjwZMAAECj/6oAAEB+QUAAAEB+P6oAAEDnAZBAAEDmv6oAAEC+wUKAAEC/v6oAAECaAZBAAECZf6oAAECAwUKAAECDv6oAAECwwZDAAECwwAAAAECfQAKAAECBgUoAAECcAUoAAECawAEAAECFQZHAAECGQZHAAECFgaHAAECKAAAAAEA9AUoAAEA9AZHAAEA9AAEAAEC3gUoAAEByf/2AAECBgaHAAECFAAGAAECFAZkAAECUAAAAAECEQUoAAECGAAKAAECFgUoAAECGQAIAAECdgZkAAEC/QUoAAEC/QAKAAECXgUoAAECQAUoAAEB9AAKAAECEgUoAAECEwADAAECJgUoAAECJgAIAAECAwUoAAEB/P/2AAECZwUoAAECZwAKAAECSwUoAAECSv/8AAECFQUoAAEDfv/2AAECdgZPAAECFAZPAAEDgAZpAAEDgAAAAAECXgaHAAECdwAAAAECHwUoAAECKP38AAEDEgaHAAEDEgZHAAEDEgAKAAECFQaHAAECFQAKAAECoAZBAAECrv5OAAECRgUKAAEB9v5OAAECawZMAAECa/5YAAECNQUKAAECOP5OAAECRQUoAAECUP5OAAECGQUoAAECGf5WAAEA/AUIAAEA+f6oAAAAAQAAAAoAZAAkAARERkxUAP5jeXJsAP5ncmVrAP5sYXRuAQIAHwEWAR4BJgEuATYBPgE+AUYBTgFWAV4BZgFuAXYBfgGGAY4BlgGeAaYBrgG2Ab4BxgHOAdYB3gHWAd4B5gHuABtjMnNjAbZjY21wAkBkbGlnAbxkbm9tAcJmcmFjAlBsaWdhAchsaWdhAlpsaWdhAkhsbnVtAc5sb2NsAdRsb2NsAdpsb2NsAeBsb2NsAeZudW1yAexvbnVtAfJwbnVtAfhzbWNwAf5zczAxAgRzczAyAgpzczAzAhBzczA0AhZzczA1AhxzczA2AiJzczA3AihzdWJzAi5zdXBzAjR0bnVtAjoBwgAAA8YAB0FaRSAD9kNSVCAD9kZSQSAEJk1PTCAEWE5BViAEilJPTSAEvFRSSyAD9gABAAAAAQcOAAEAAAABBSoABgAAAAECSgABAAAAAQIMAAQAAAABBKAAAQAAAAEBlgABAAAAAQIGAAEAAAABAYwABAAAAAEBqAAEAAAAAQGoAAQAAAABAbwAAQAAAAEBcgABAAAAAQFwAAEAAAABAW4AAQAAAAEBiAABAAAAAQGKAAEAAAABAkIAAQAAAAEBkAABAAAAAQJQAAEAAAABAnYAAQAAAAECnAABAAAAAQLCAAEAAAABASwABgAAAAEBkAABAAAAAQG0AAEAAAABAcYAAQAAAAEB2AABAAAAAQEKAAAAAQAAAAAAAQALAAAAAQAbAAAAAQAKAAAAAQAWAAAAAQAIAAAAAQAFAAAAAQAHAAAAAQAGAAAAAQAcAAAAAQATAAAAAQAUAAAAAQABAAAAAQAMAAAAAQANAAAAAQAOAAAAAQAPAAAAAQAQAAAAAQARAAAAAQASAAAAAQAeAAAAAQAdAAAAAQAVAAAAAgACAAQAAAACAAkACgAAAAMAFwAYABoAAAAEAAkACgAJAAoAAP//ABQAAAABAAIAAwAEAAgADQAOAA8AEAARABIAEwAUABUAFgAXABgAGQAaAAEHagACAAEHRgABAAEHRgH5AAEHRgGKAAEHRgIQAAEHRgGCAAEHZgGPAAEOPgABB0gAAQ42AAEHRgACB1oAAgJHAkgAAgdQAAICSQJKAAEOMgADBzAHNAc4AAIHQgADAokCigKKAAIHWAAGAnwCegJ9An4CewUpAAIHNgAGBSMFJAUlBSYFJwUoAAMAAQdEAAEHAAAAAAEAAAAZAAIHIgcKB4QHSAAHAAAHDgcOBw4HDgcOBw4AAgbUAAoB4gHhAeACOgI7AjwCPQI+Aj8CQAACBroACgJZAHoAcwB0AloCWwJcAl0CXgJfAAIGoAAKAZYAegBzAHQBlwGYAZkBmgGbAZwAAgbwAAwCYAJiAmECYwJkAoICgwKEAoUChgKHAogAAgcmABQCdQJ5AnMCcAJyAnECdgJ0AngCdwJqAmUCZgJnAmgCaQAaABwCbgKAAAIGwAAUBLACjASpBKoEqwSsBK0CgQSuBK8CZwJpAmgCZgJqAoAAGgJuABwCZQACBw4AFAJ2AngCeQJzAnACcgJxAnQCdwJ1ABsAFQAWABcAGAAZABoAHAAdABQAAga4ABQErQSuAowEqQSqBKsErAKBBK8AFwAZABgAFgAbABQAGgAdABwAFQSwAAD//wAVAAAAAQACAAMABAAHAAgADQAOAA8AEAARABIAEwAUABUAFgAXABgAGQAaAAD//wAVAAAAAQACAAMABAAFAAgADQAOAA8AEAARABIAEwAUABUAFgAXABgAGQAaAAD//wAWAAAAAQACAAMABAAGAAgACQANAA4ADwAQABEAEgATABQAFQAWABcAGAAZABoAAP//ABYAAAABAAIAAwAEAAYACAAKAA0ADgAPABAAEQASABMAFAAVABYAFwAYABkAGgAA//8AFgAAAAEAAgADAAQABgAIAAsADQAOAA8AEAARABIAEwAUABUAFgAXABgAGQAaAAD//wAWAAAAAQACAAMABAAGAAgADAANAA4ADwAQABEAEgATABQAFQAWABcAGAAZABoAAQ+WADYG9AW2BboF8gcCBfgFvgcQBjQGPAX+BogHVgXCBnQGRAYEB2YGCgZMBpQGEAceBcYFygYWBywFzgXSBdYGVAZcBhwGoAc6BdoGfgZkBiIHSAYoBmwGrAYuBd4F4gXmBeoGuAbEBtAG3AboBe4AAgcEAOsCjQJOAk0CTAJLAkMCAQIAAf8B/gH9AfwB+wH6AfkB+AH3AfYB9QH0AfMB8gHxAfAB7wHuAe0CfwKPA0wCkQKQA0sB/gKOApMCbQTuBO8CBQIGBPAE8QTyAgcE8wIIAgkCCgT4AgsCCwT5BPoCDAINAg4CFQUHBQgCFgIXAhgCGQIaAhsFCwUMBQ4FEQUaAh0CHgIfAiACIQIiAiMCJAIlAiYCDwIQAhECEgITAhQCVgIoAikCKgIrBRQCLAIuAi8CMAIyAjQCkgNNA04DTwNQA1EDUgNTA1QDVQNWA1cDWANZA1oDWwNcA10DXgNfA2ADYQNiA2MDZANlA2YDZwNoA54DaQNqA2sDbANtA24DbwNwA3EDcgNzA3QDdQN2A3cDeAN5A3oDewN8A30DfgUbA4ADgQOCA4MDhAOFA4YDhwOIA4kDigOLA4wDjQOOA48DkAORBR4DkgOTA5UDlAOWA5cDmAOZA5oDmwOcA50DnwOgA6EFHAUdBOcE6ATpBOoE9AT3BPUE9gT7BPwE/QTrBOwE7QUGBQkFCgUNBQ8FEAIcBRIE/gT/BQAFAQUCBQMFBAUFBR8FIAUhBSIFEwUVBRYCMwUYAjUFGQUXAjECJwItBScFKAACBwIA+wICAo0B7AHrAeoB6QHoAecB5gHlAeQB4wJOAk0CTAJLAkMCAQIAAf8B/gH9AfwB+wH6AfkB+AH3AfYB9QH0AfMB8gHxAfAB7wHuAe0CAwIEAo8CkQKQApICjgKTAm0CBQIGAgcCCAIJAgoCCwIMAg0CDgIPAhACEQISAhMCFAIVAhYCFwIYAhkCGwIcBRoCHQIeAh8CIAIhAiICIwIkAiUCJgJWAigCKQIqAisFFAIsAi4CLwIwAjECMgIzAjQCfwI2AjcCOQI4A0sDTANNA04DTwNQA1EDUgNTA1QDVQNWA1cDWANZA1oDWwNcA10DXgNfA2ADYQNiA2MDZANlA2YDZwNoA2kDagNrA2wDbQNuA28DcANxA3IDcwN0A3UDdgN3A3gDeQN6A3sDfAN9A34DfwUbA4ADgQOCA4MDhAOFA4YDhwOIA4kDigOLA4wDjQOOA48DkAORBR4DkgOTA5UDlAOWA5cDmAOZA5oDmwOcA50DngOfA6ADoQUcBR0E5wToBOkE6gTrBOwE7QTuBO8E8ATxBPIE8wT0BPUE9gT3BPgE+QT6BPsE/AT9BP4E/wUABQEFAgUDAhoFBAUFBQYFBwUIBQkFCgULBQwFDQUOBQ8FEAURBRIFHwUgBSEFIgUTBRUFFgUYAjUFGQUXAicCLQUnBSgAAQABAXwAAQABAEsAAQABALsAAQABADYAAQABABMAAQACAyQDJQACBuYG2gACBugG2gABBvAAAQbyAAEG9AACAAEAFAAdAAAAAQACAC8ATwABAAMASQBLAoUAAgAAAAEG4AABAAYC1gLXAugC6QNrA3QAAQAGAE0ATgL9A+oD7ARlAAIAAwGVAZUAAAHgAeIAAQI6AkAABAACAAIAqACsAAEBJAEnAAEAAQAMACcAKAArADMANQBGAEcASABLAFMAVABVAAIAAgAUAB0AAAJwAnkACgACAAYATQBNAAYATgBOAAQC/QL9AAUD6gPqAAMD7APsAAIEZQRlAAEAAgAEABQAHQAAAoECgQAKAowCjAALBKkEsAAMAAIABgAaABoAAAAcABwAAQJlAmoAAgJuAm4ACAJwAnkACQKAAoAAEwABABQAGgAcAmUCZgJnAmgCaQJqAm4CgAKBAowEqQSqBKsErAStBK4ErwSwAAEF4AABBeIAAQXkAAEF5gABBegAAQXqAAEF7AABBe4AAQXwAAEF8gABBfQAAQX2AAEF+AABBfoAAQX8AAIF/gYEAAIGBAYKAAIGCgYQAAIGEAYWAAIGFgYcAAIGHAYiAAIGIgYoAAIGKAYuAAIGLgY0AAIGNAY6AAIGOgZAAAMGQAZGBkwAAwZKBlAGVgADBlQGWgZgAAMGXgZkBmoAAwZoBm4GdAADBnIGeAZ+AAMGfAaCBogAAwaGBowGkgAEBpAGlgacBqIABAaeBqQGqgawAAUGrAayBrgGvgbEAAUGvgbEBsoG0AbWAAUG0AbWBtwG4gboAAUG4gboBu4G9Ab6AAUG9Ab6BwAHBgcMAAUHBgcMBxIHGAceAAUHGAceByQHKgcwAAUHKgcwBzYHPAdCAAUHPAdCB0gHTgdUAAYHTgdUB1oHYAdmB2wABgdkB2oHcAd2B3wHggAGB3oHgAeGB4wHkgeYAAYHkAeWB5wHogeoB64ABgemB6wHsge4B74HxAAGB7wHwgfIB84H1AfaAAYH0gfYB94H5AfqB/AABwgwB+gH7gf0B/oIAAgGAAcIKAf8CAIICAgOCBQIGgABAOsACgBFAEYARwBIAEkASgBLAEwATQBOAE8AUABRAFIAUwBUAFUAVgBXAFgAWQBaAFsAXABdAF4AhQCGAIcAiQCKAIsAjQCQAJIAlAC7ALwAvQC+AL8AwADBAMIAwwDEAMUAxgDHAMgAyQDKAMsAzADNAM4A6gDrAOwA7QDuAO8A8ADxAPIA8wD0APUA9gD3APgA+QD6APsA/AD9AP4A/wEAAQEBAgEDAQQBBQEGAQcBMAE0ATYBOAE6ATwBQgFEAUYBSgFNAVoCmAKaArYCtwK4ArkCugK7ArwCvQK+Ar8CwALBAsICwwLEAsUCxgLHAsgCyQLKAssCzALNAs4CzwLQAtEC0wLVAtcC2QLbAt0C3wLhAuMC5QLnAukC6wLtAu8C8QLzAvUC9wL5AvsC/QMAAwIDBAMGAwgDCgMMAw4DEAMSAxUDFwMZAxsDHQMfAyEDIwMlAycDKQMrAy0DLwMxAzMDNQM3AzkDOwM9Az8DQgNEA0YDSANKA7oDuwO8A70DvwPAA8EDwgPDA8QDxQPGA8cDyAPfA+AD4QPiA+MD5APlA+YD5wPoA+kD6gPrA+wD7QPuA/AD8gP0A/YECwQNBA8EHQQkBCoEMASaBJsEnwSjBSQFJgABAPsACAAKABQAFQAWABcAGAAZABoAGwAcAB0AJQAmACcAKAApACoAKwAsAC0ALgAvADAAMQAyADMANAA1ADYANwA4ADkAOgA7ADwAPQA+AGUAZwCBAIMAhACMAI8AkQCTALEAsgCzALQAtQC2ALcAuAC5ALoA0gDTANQA1QDWANcA2ADZANoA2wDcAN0A3gDfAOAA4QDiAOMA5ADlAOYA5wDoAOkBLwEzATUBNwE5ATsBQQFDAUUBSQFLAUwBWAFZAXEBsgG4Ab0BwAKWApcCmQKbApwCnQKeAp8CoAKhAqICowKkAqUCpgKnAqgCqQKqAqsCrAKtAq4CrwKwArECsgKzArQCtQLSAtQC1gLYAtoC3ALeAuAC4gLkAuYC6ALqAuwC7gLwAvIC9AL2AvgC+gL8Av4C/wMBAwMDBQMHAwkDCwMNAw8DEQMUAxYDGAMaAxwDHgMgAyIDJAMmAygDKgMsAy4DMAMyAzQDNgM4AzoDPAM+A0ADQQNDA0UDRwNJA6IDowOkA6UDpgOnA6gDqgOrA6wDrQOuA68DsAOxA7IDswO0A7UDtgO3A7gDuQPJA8oDywPMA80DzgPPA9AD0QPSA9MD1APVA9YD1wPYA9kD2gPbA9wD3QPeA+8D8QPzA/UECgQMBA4EIwQpBC8EmQSeBKIFIwUlAdcAAgBNAdgAAgBQAdkAAwBKAE0B2gADAEoAUAABAAEASgHWAAIASgHcAAIAWAHbAAIAWAABAAMASgBXAJUAAAABAAEAAQABAAAAAwTCAAIArQLYAAIAqQTIAAIArQTVAAIAqQTDAAIArQLZAAIAqQSyAAIAqQTJAAIArQRlAAIArQTWAAIAqQNHAAIAqQNJAAIAqQNIAAIAqQNKAAIAqQTBAAIAqQTGAAIB1QTEAAIArQSxAAIAqQLyAAIB1QP8AAIAqQTQAAIArQMqAAIB1QTbAAIArQTgAAIArQTeAAIAqgNBAAIAqQTkAAIArQTHAAIB1QTFAAIArQP9AAIAqQTRAAIArQMrAAIB1QTcAAIArQThAAIArQTfAAIAqgNCAAIAqQTlAAIArQTKAAIAqQMDAAIB1QTMAAIArQMFAAIAqQMHAAIB1QTOAAIArQMgAAIAqQMmAAIB1QTZAAIArQPxAAIAqQTiAAIArQPvAAIAqATLAAIAqQMEAAIB1QTNAAIArQMGAAIAqQMIAAIB1QTPAAIArQMhAAIAqQMnAAIB1QTaAAIArQPyAAIAqQTjAAIArQPwAAIAqAMaAAIAqQMcAAIB1QTXAAIArQS9AAIArAMbAAIAqQMdAAIB1QTYAAIArQS+AAIArAMNAAIAqQMPAAIB1QTSAAIArQSzAAIAqAKrAAIAqgK1AAIAqQSMAAIArQP1AAIAqASOAAIAqwSQAAIAqgMOAAIAqQMQAAIB1QTTAAIArQS0AAIAqALGAAIAqgLQAAIAqQSNAAIArQP2AAIAqASPAAIAqwSRAAIAqgLDAAIAqQLCAAIAqARjAAIAqwL3AAIAqgS6AAIArAR0AAIAqQR8AAIArQR2AAIAqAR4AAIAqwR6AAIAqgR1AAIAqQR9AAIArQR3AAIAqAR5AAIAqwR7AAIAqgSCAAIAqQSKAAIArQSEAAIAqASGAAIAqwSIAAIAqgSDAAIAqQSLAAIArQSFAAIAqASHAAIAqwSJAAIAqgKcAAIAqQQ6AAIArQKbAAIAqAQ8AAIAqwKeAAIAqgS1AAIArAKkAAIAqQRSAAIArQKjAAIAqARUAAIAqwRWAAIAqgS3AAIArAKoAAIAqQRkAAIArQKnAAIAqARiAAIAqwL2AAIAqgS5AAIArAK3AAIAqQQ7AAIArQK2AAIAqAQ9AAIAqwK5AAIAqgS2AAIArAK/AAIAqQRTAAIArQK+AAIAqARVAAIAqwRXAAIAqgS4AAIArALIAAIAqQRnAAIArQLHAAIAqARpAAIAqwLKAAIAqgS8AAIArALNAAIAqQR/AAIArQLMAAIAqASBAAIAqwMxAAIAqgTAAAIArAKtAAIAqQRmAAIArQKsAAIAqARoAAIAqwKvAAIAqgS7AAIArAKyAAIAqQR+AAIArQKxAAIAqASAAAIAqwMwAAIAqgS/AAIArATUAAMAqgCpBN0AAwCqAKkAAgARACUAKQAAACsALQAFAC8ANAAIADYAOwAOAD0APgAUAEUASQAWAEsATQAbAE8AVAAeAFYAWwAkAF0AXgAqAIEAgQAsAIMAgwAtAIYAhgAuAIkAiQAvAI0AjQAwAJgAmwAxANAA0AA1AAA="
};
var $215e9e6c69e16a37$var$_global = typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : typeof self === 'object' ? self : $215e9e6c69e16a37$exports;
if (typeof $215e9e6c69e16a37$var$_global.pdfMake !== 'undefined' && typeof $215e9e6c69e16a37$var$_global.pdfMake.addVirtualFileSystem !== 'undefined') $215e9e6c69e16a37$var$_global.pdfMake.addVirtualFileSystem($215e9e6c69e16a37$var$vfs);
$215e9e6c69e16a37$exports = $215e9e6c69e16a37$var$vfs;



var $3e07879b79bee0e7$exports = {};
$3e07879b79bee0e7$exports = new URL("new_logo.d9372fce.png", import.meta.url).toString();



var $fgQ0V = parcelRequire("fgQ0V");

var $970b051e739b5a10$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
(0, (/*@__PURE__*/$parcel$interopDefault($e621d79c37897443$exports))).addVirtualFileSystem((0, (/*@__PURE__*/$parcel$interopDefault($215e9e6c69e16a37$exports))));
// Helper function to strip all citations and markdown links from text
const $970b051e739b5a10$var$stripCitationsAndMarkdown = (text)=>{
    if (!text) return text;
    let cleanText = text;
    // Remove superscript citations (¹²³⁴⁵⁶⁷⁸⁹⁰)
    cleanText = cleanText.replace(/[\u00B9\u00B2\u00B3\u2074\u2075\u2076\u2077\u2078\u2079\u2070]+/g, '');
    // Remove bracket citations [1], [2], etc.
    cleanText = cleanText.replace(/\[\d+\]/g, '');
    // Remove markdown links [Text](url) -> Text
    cleanText = cleanText.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
    // Remove standalone "Source" word at the end of sentences or text
    cleanText = cleanText.replace(/\.\s*Source\s*$/gi, '.');
    cleanText = cleanText.replace(/\s+Source\s*$/gi, '');
    return cleanText.trim();
};
const $970b051e739b5a10$export$4e0760818438ce52 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const clientStore = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
    const do_we_have_pdf = store.query.report_has_pdf;
    const enableSourcing = clientStore.enableSourcing;
    const create_pdf = ()=>$970b051e739b5a10$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            function urlToBase64(url) {
                return $970b051e739b5a10$var$__awaiter(this, void 0, void 0, function*() {
                    const response = yield fetch(url);
                    const blob = yield response.blob();
                    return new Promise((resolve, reject)=>{
                        const reader = new FileReader();
                        reader.onloadend = ()=>resolve(reader.result); // base64 string
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    });
                });
            }
            const dash_line = {
                width: 500,
                height: 5,
                canvas: [
                    {
                        type: 'line',
                        x1: 0,
                        y1: 0,
                        x2: 500,
                        y2: 0,
                        lineWidth: 1.0,
                        lineColor: '#d0d5dd',
                        //lineColor: 'black',
                        dash: {
                            length: 2,
                            space: 2
                        } // dashed pattern
                    }
                ]
            };
            // Helper to parse text with citations into pdfmake format
            const parseTextWithCitations = (data)=>{
                if (!data) return {
                    text: [],
                    sources: []
                };
                // If sourcing is disabled, strip all citations and return plain text
                if (!enableSourcing) {
                    const cleanText = typeof data === 'string' ? $970b051e739b5a10$var$stripCitationsAndMarkdown(data) : $970b051e739b5a10$var$stripCitationsAndMarkdown(data.text || '');
                    return {
                        text: [
                            {
                                text: cleanText
                            }
                        ],
                        sources: []
                    };
                }
                // If it's just a string, parse markdown links and citations
                if (typeof data === 'string') {
                    const parts = [];
                    let lastIndex = 0;
                    // Parse both citation markers [1] and markdown links [text](url)
                    const combinedRegex = /\[(\d+)\]|\[([^\]]+)\]\(([^)]+)\)/g;
                    let match;
                    while((match = combinedRegex.exec(data)) !== null){
                        // Add text before match
                        if (match.index > lastIndex) parts.push({
                            text: data.slice(lastIndex, match.index)
                        });
                        if (match[1]) // It's a citation marker [1], [2], etc.
                        parts.push({
                            text: match[1],
                            fontSize: 8,
                            color: '#4a90e2',
                            sup: true,
                            bold: true
                        });
                        else if (match[2] && match[3]) // It's a markdown link [text](url)
                        parts.push({
                            text: match[2],
                            link: match[3],
                            color: '#4a90e2',
                            decoration: 'underline',
                            fontSize: 10
                        });
                        lastIndex = match.index + match[0].length;
                    }
                    // Add remaining text
                    if (lastIndex < data.length) parts.push({
                        text: data.slice(lastIndex)
                    });
                    return {
                        text: parts.length > 0 ? parts : [
                            {
                                text: data
                            }
                        ],
                        sources: []
                    };
                }
                // If it has text and sources, parse citations
                if (data.text && data.sources) {
                    const textContent = data.text;
                    const sources = data.sources || [];
                    // Split text by citation markers [1], [2], etc.
                    const parts = [];
                    let lastIndex = 0;
                    const citationRegex = /\[(\d+)\]/g;
                    let match;
                    while((match = citationRegex.exec(textContent)) !== null){
                        // Add text before citation
                        if (match.index > lastIndex) parts.push({
                            text: textContent.slice(lastIndex, match.index)
                        });
                        // Add citation as superscript
                        const citationNum = match[1];
                        parts.push({
                            text: citationNum,
                            fontSize: 8,
                            color: '#4a90e2',
                            sup: true,
                            bold: true
                        });
                        lastIndex = match.index + match[0].length;
                    }
                    // Add remaining text
                    if (lastIndex < textContent.length) parts.push({
                        text: textContent.slice(lastIndex)
                    });
                    return {
                        text: parts.length > 0 ? parts : [
                            {
                                text: textContent
                            }
                        ],
                        sources: sources
                    };
                }
                return {
                    text: [
                        {
                            text: String(data)
                        }
                    ],
                    sources: []
                };
            };
            // Helper to parse Diligence description with special tags
            const parseDiligenceDescription = (text)=>{
                var _a, _b, _c;
                if (!text) return null;
                const detailedMatch = text.match(/\*\*\[DETAILED\]\*\*(.*?)(?=\*\*\[|$)/s);
                const relevanceMatch = text.match(/\*\*\[RELEVANCE\]\*\*(.*?)(?=\*\*\[|$)/s);
                const believesMatch = text.match(/\*\*\[BELIEVES\]\*\*(.*?)(?=\*\*\[|$)/s);
                return {
                    detailed: ((_a = detailedMatch === null || detailedMatch === void 0 ? void 0 : detailedMatch[1]) === null || _a === void 0 ? void 0 : _a.trim()) || '',
                    relevance: ((_b = relevanceMatch === null || relevanceMatch === void 0 ? void 0 : relevanceMatch[1]) === null || _b === void 0 ? void 0 : _b.trim()) || '',
                    believes: ((_c = believesMatch === null || believesMatch === void 0 ? void 0 : believesMatch[1]) === null || _c === void 0 ? void 0 : _c.trim()) || ''
                };
            };
            // Helper to create sources section for pdfmake
            const createSourcesList = (sources)=>{
                if (!enableSourcing || !sources || sources.length === 0) return [];
                const sourceItems = sources.map((source)=>{
                    const sourceId = source.id || 0;
                    const sourceName = source.name || 'Source';
                    const sourceUrl = source.url;
                    return {
                        text: [
                            {
                                text: `${sourceId}. `,
                                fontSize: 10
                            },
                            sourceUrl ? {
                                text: sourceName,
                                link: sourceUrl,
                                color: '#4a90e2',
                                decoration: 'underline',
                                fontSize: 10
                            } : {
                                text: sourceName,
                                fontSize: 10,
                                italics: true,
                                color: '#667085'
                            }
                        ],
                        margin: [
                            0,
                            2,
                            0,
                            2
                        ]
                    };
                });
                return [
                    {
                        text: '',
                        margin: [
                            0,
                            10,
                            0,
                            5
                        ]
                    },
                    {
                        text: 'Sources:',
                        fontSize: 11,
                        bold: true,
                        color: '#667085'
                    },
                    {
                        text: '',
                        margin: [
                            0,
                            3,
                            0,
                            0
                        ]
                    },
                    ...sourceItems,
                    {
                        text: '',
                        margin: [
                            0,
                            0,
                            0,
                            20
                        ]
                    } // Extra spacing after sources
                ];
            };
            const createTextSection = (title, data, breakLine = 'avoid')=>{
                const { text: text, sources: sources } = parseTextWithCitations(data);
                if (!text || Array.isArray(text) && text.length === 0) return {
                    text: '',
                    pageBreak: 'avoid'
                };
                const stackItems = [
                    {
                        text: title,
                        style: 'section_title'
                    },
                    (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep(dash_line),
                    {
                        text: text,
                        style: 'text_content'
                    }
                ];
                // Add sources if they exist
                if (sources && sources.length > 0) stackItems.push(...createSourcesList(sources));
                return {
                    stack: stackItems,
                    pageBreak: breakLine
                };
            };
            const createChartSection = (title, elm_id)=>$970b051e739b5a10$var$__awaiter(void 0, void 0, void 0, function*() {
                    const element = document.getElementById(elm_id);
                    const chart = yield (0, (/*@__PURE__*/$parcel$interopDefault($eec13e6b5a0b94b3$exports)))(element, {
                        backgroundColor: null,
                        scale: 2
                    });
                    const imgData = chart.toDataURL('image/png');
                    return {
                        stack: [
                            {
                                text: title,
                                style: 'section_title'
                            },
                            (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep(dash_line),
                            {
                                image: imgData,
                                width: 500
                            } // you can set width/height
                        ],
                        pageBreak: 'before'
                    };
                });
            const createColumnsSection = (title, entries, includeSources = false)=>{
                if (entries.length == 0) return {
                    text: ''
                };
                const columns = [];
                const LINE_SIZE = 2;
                for(var i = 0; i < entries.length; i += LINE_SIZE){
                    var gen_cols = {
                        columns: [],
                        columnGap: 20,
                        pageBreak: 'avoid'
                    };
                    for(var y = 0; y < LINE_SIZE; y++){
                        const accessAt = i + y;
                        if (entries.length > accessAt) {
                            const entry = entries[accessAt];
                            const { text: descriptionText } = parseTextWithCitations(entry.description);
                            const itemStack = [
                                {
                                    text: entry.title,
                                    style: 'text_content',
                                    margin: [
                                        5,
                                        5,
                                        5,
                                        0
                                    ]
                                },
                                {
                                    text: descriptionText,
                                    style: 'text_content_small',
                                    margin: [
                                        10,
                                        5,
                                        5,
                                        enableSourcing && includeSources && entry.sources ? 10 : 20
                                    ]
                                }
                            ];
                            // Add sources if enableSourcing and includeSources flag is true and sources exist
                            if (enableSourcing && includeSources && entry.sources && entry.sources.length > 0) {
                                const sourcesItems = entry.sources.map((source)=>{
                                    const sourceId = source.id || 0;
                                    const sourceName = source.name || 'Source';
                                    const sourceUrl = source.url;
                                    return {
                                        text: [
                                            {
                                                text: `${sourceId}. `,
                                                fontSize: 9
                                            },
                                            sourceUrl ? {
                                                text: sourceName,
                                                link: sourceUrl,
                                                color: '#4a90e2',
                                                decoration: 'underline',
                                                fontSize: 9
                                            } : {
                                                text: sourceName,
                                                fontSize: 9,
                                                italics: true,
                                                color: '#667085'
                                            }
                                        ],
                                        margin: [
                                            10,
                                            2,
                                            5,
                                            2
                                        ]
                                    };
                                });
                                itemStack.push({
                                    text: 'Sources:',
                                    fontSize: 10,
                                    bold: true,
                                    color: '#667085',
                                    margin: [
                                        10,
                                        5,
                                        5,
                                        3
                                    ]
                                }, ...sourcesItems, {
                                    text: '',
                                    margin: [
                                        0,
                                        0,
                                        0,
                                        15
                                    ]
                                });
                            }
                            gen_cols.columns.push({
                                stack: itemStack,
                                width: '*'
                            });
                        } else gen_cols.columns.push({
                            text: '',
                            style: 'text_content',
                            width: '*'
                        });
                    }
                    columns.push(gen_cols);
                }
                return {
                    stack: [
                        {
                            text: title,
                            style: 'section_title'
                        },
                        (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep(dash_line),
                        {
                            text: '',
                            margin: [
                                0,
                                20,
                                0,
                                0
                            ]
                        },
                        ...columns
                    ],
                    pageBreak: 'before'
                };
            };
            const createDiligenceSection = (title, entries)=>{
                if (entries.length == 0) return {
                    text: ''
                };
                const items = [];
                for(let i = 0; i < entries.length; i++){
                    const entry = entries[i];
                    const parsed = parseDiligenceDescription(entry.description);
                    if (!parsed) continue;
                    const itemStack = [];
                    // Title
                    itemStack.push({
                        text: entry.title,
                        style: 'text_content',
                        bold: true,
                        margin: [
                            0,
                            i === 0 ? 20 : 30,
                            0,
                            10
                        ]
                    });
                    // Diligence Objective
                    if (parsed.detailed) {
                        const { text: detailedText, sources: detailedSources } = parseTextWithCitations(parsed.detailed);
                        itemStack.push({
                            text: [
                                {
                                    text: 'Diligence Objective: ',
                                    bold: true,
                                    fontSize: 11
                                },
                                ...detailedText
                            ],
                            style: 'text_content_small',
                            margin: [
                                0,
                                0,
                                0,
                                8
                            ]
                        });
                    }
                    // Deal Relevance
                    if (parsed.relevance) {
                        const { text: relevanceText, sources: relevanceSources } = parseTextWithCitations(parsed.relevance);
                        itemStack.push({
                            text: [
                                {
                                    text: 'Deal Relevance: ',
                                    bold: true,
                                    fontSize: 11
                                },
                                ...relevanceText
                            ],
                            style: 'text_content_small',
                            margin: [
                                0,
                                0,
                                0,
                                8
                            ]
                        });
                    }
                    // Need-to-Believe
                    if (parsed.believes) {
                        const { text: believesText, sources: believesSources } = parseTextWithCitations(parsed.believes);
                        itemStack.push({
                            text: [
                                {
                                    text: 'Need-to-Believe: ',
                                    bold: true,
                                    fontSize: 11
                                },
                                ...believesText
                            ],
                            style: 'text_content_small',
                            margin: [
                                0,
                                0,
                                0,
                                8
                            ]
                        });
                    }
                    // Collect all sources from all three sections
                    const allSources = [];
                    const addSources = (text)=>{
                        const citationRegex = /\[(\d+)\]/g;
                        let match;
                        const citationNumbers = new Set();
                        while((match = citationRegex.exec(text)) !== null)citationNumbers.add(parseInt(match[1]));
                        return Array.from(citationNumbers).sort((a, b)=>a - b);
                    };
                    // Extract citation numbers from original text
                    const originalText = entry.description || '';
                    const citationNumbers = addSources(originalText);
                    // If there are sources in the item, add them
                    if (entry.sources && entry.sources.length > 0) {
                        const sourcesListItems = createSourcesList(entry.sources);
                        if (sourcesListItems.length > 0) itemStack.push(...sourcesListItems);
                    }
                    items.push({
                        stack: itemStack,
                        pageBreak: 'avoid'
                    });
                }
                return {
                    stack: [
                        {
                            text: title,
                            style: 'section_title'
                        },
                        (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep(dash_line),
                        ...items
                    ],
                    pageBreak: 'before'
                };
            };
            const flowise_data = (_a = store.report_flowise) !== null && _a !== void 0 ? _a : {
                opportunity: '',
                business_overview: '',
                market_description: '',
                market_size: '',
                core_product_services: [],
                key_customers: [],
                competitor_segments: [],
                what_we_like: [],
                key_risks: [],
                diligence: []
            };
            const q = store.query;
            const logo_base64 = yield urlToBase64((0, (/*@__PURE__*/$parcel$interopDefault($3e07879b79bee0e7$exports))));
            const stack_items = [];
            stack_items.push({
                text: store.company_name,
                style: 'company_name'
            });
            stack_items.push(createTextSection('Summary of the Opportunity', flowise_data.opportunity));
            if (do_we_have_pdf) {
                // Use business_overview with citations if available, otherwise fallback to companyOverview
                const businessOverviewData = flowise_data.business_overview || store.companyOverview;
                stack_items.push(createTextSection('Business Overview', businessOverviewData));
                stack_items.push((yield createChartSection('Financial Overview', 'revenue-chart')));
            }
            stack_items.push(createColumnsSection('Core Products / Services', (_b = flowise_data.core_product_services) !== null && _b !== void 0 ? _b : []));
            stack_items.push(createColumnsSection('Key Customers', (_c = flowise_data.key_customers) !== null && _c !== void 0 ? _c : []));
            if (do_we_have_pdf) {
                stack_items.push((yield createChartSection('Score Summary', 'score-chart')));
                stack_items.push((yield createChartSection('Benchmarking', 'benchmarking-chart')));
            }
            stack_items.push(createTextSection('Market Description', flowise_data.market_description, 'before'));
            stack_items.push(createTextSection('Market Size & Growth', flowise_data.market_size));
            stack_items.push(createColumnsSection('Competitor Segments', (_d = flowise_data.competitor_segments) !== null && _d !== void 0 ? _d : []));
            stack_items.push(createColumnsSection('What We Like', (_e = flowise_data.what_we_like) !== null && _e !== void 0 ? _e : [], true // Include sources
            ));
            stack_items.push(createColumnsSection('Key Risks', (_f = flowise_data.key_risks) !== null && _f !== void 0 ? _f : [], true // Include sources
            ));
            stack_items.push(createDiligenceSection('Focus Areas For Due Diligence', (_g = flowise_data.diligence) !== null && _g !== void 0 ? _g : []));
            var dd = {
                content: [
                    {
                        stack: stack_items
                    }
                ],
                header: function(currentPage, pageCount) {
                    return {
                        columns: [
                            {
                                text: ''
                            },
                            {
                                image: logo_base64,
                                width: 100,
                                alignment: 'right',
                                margin: [
                                    0,
                                    30,
                                    20,
                                    0
                                ]
                            }
                        ]
                    };
                },
                footer: function(currentPage, pageCount) {
                    return {
                        text: 'Page ' + currentPage + ' of ' + pageCount,
                        alignment: 'center',
                        margin: [
                            0,
                            0,
                            0,
                            20
                        ]
                    };
                },
                styles: {
                    company_name: {
                        color: '#102442',
                        fontSize: 22,
                        bold: true,
                        margin: [
                            0,
                            0,
                            0,
                            30
                        ]
                    },
                    section_title: {
                        //font: 'Lust',
                        color: '#243a5c',
                        fontSize: 18,
                        italics: true,
                        margin: [
                            0,
                            0,
                            0,
                            2
                        ]
                    },
                    text_content: {
                        margin: [
                            0,
                            15,
                            0,
                            20
                        ],
                        fontSize: 12
                    },
                    text_content_small: {
                        margin: [
                            0,
                            10,
                            0,
                            0
                        ],
                        fontSize: 10
                    }
                }
            };
            const baseUrl = (_h = document.location) === null || _h === void 0 ? void 0 : _h.origin;
            const fonts = {
                Lust: {
                    normal: baseUrl + '/fonts/Lust-Text-Medium.otf',
                    italics: baseUrl + '/fonts/Lust-Text-Italic.otf'
                }
            };
            const filename = (0, $b2432f43c421c848$export$ce5cbb93a219e469)(store.company_name) + '.pdf';
            (0, (/*@__PURE__*/$parcel$interopDefault($e621d79c37897443$exports))).createPdf(dd).download(filename);
        });
    return (0, $kSbwP.jsxs)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
        variant: "light",
        className: $96bdaab448b7fce9$export$424e99fc53fcd713,
        onClick: create_pdf,
        children: [
            (0, $kSbwP.jsx)("i", {
                className: "bi bi-download"
            }),
            "Export"
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");


var $991016ec58dcc120$export$40a9eeef55665a40;
var $991016ec58dcc120$export$93b7586d956c930e;
var $991016ec58dcc120$export$e4f6ce96d55d099a;
var $991016ec58dcc120$export$f843afa9e9b53052;
var $991016ec58dcc120$export$3304639b795b6ae;
var $991016ec58dcc120$export$ae78d338ad66ff90;
var $991016ec58dcc120$export$b8972b998723d602;
var $991016ec58dcc120$export$13925b5cf10ba292;
$991016ec58dcc120$export$40a9eeef55665a40 = `ybqAVq_defaultPadding`;
$991016ec58dcc120$export$93b7586d956c930e = `ybqAVq_dropShadow`;
$991016ec58dcc120$export$e4f6ce96d55d099a = `ybqAVq_newDealButton`;
$991016ec58dcc120$export$f843afa9e9b53052 = `ybqAVq_panelImage`;
$991016ec58dcc120$export$3304639b795b6ae = `ybqAVq_plusIcon`;
$991016ec58dcc120$export$ae78d338ad66ff90 = `ybqAVq_scaleInOut`;
$991016ec58dcc120$export$b8972b998723d602 = `ybqAVq_shadow`;
$991016ec58dcc120$export$13925b5cf10ba292 = `ybqAVq_small-shadow`;




var $kSbwP = parcelRequire("kSbwP");


var $67e3b61e1bf357ac$export$76174c80c75f9baa;
var $67e3b61e1bf357ac$export$1fd9c7aa02a3afde;
var $67e3b61e1bf357ac$export$eebe8d2968d9c14e;
var $67e3b61e1bf357ac$export$1237798dc640739a;
var $67e3b61e1bf357ac$export$7b8d31d4712adc7b;
$67e3b61e1bf357ac$export$76174c80c75f9baa = `NNPxZa_addButton`;
$67e3b61e1bf357ac$export$1fd9c7aa02a3afde = `NNPxZa_input_text`;
$67e3b61e1bf357ac$export$eebe8d2968d9c14e = `NNPxZa_input_textarea`;
$67e3b61e1bf357ac$export$1237798dc640739a = `NNPxZa_label`;
$67e3b61e1bf357ac$export$7b8d31d4712adc7b = `NNPxZa_rightImage`;



var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");
var $2a52017e881bd9f4$exports = {};
$2a52017e881bd9f4$exports = new URL("modal.ebd08c8d.png", import.meta.url).toString();



var $kSbwP = parcelRequire("kSbwP");

var $gpaur = parcelRequire("gpaur");

var $8nGP5 = parcelRequire("8nGP5");

const $c94930c253f3e81f$export$f836382419f64c98 = (props)=>{
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.toArray(props.children);
    (0, (/*@__PURE__*/$parcel$interopDefault($gpaur)))(children.length === props.layoutPercent.length, 'Children and size must have the same length');
    const cls = props.className || '';
    const style = props.style || {};
    style.position = 'relative';
    const spaceBetween = props.spaceBetween || 0;
    const display = children.map((child, index)=>{
        let size = props.layoutPercent[index];
        const childClass = props.childClass || '';
        return (0, $kSbwP.jsx)("div", {
            className: childClass,
            style: {
                width: `${size}%`,
                height: '100%',
                paddingRight: spaceBetween > 0 && index == 0 ? `${spaceBetween}px` : '0'
            },
            children: child
        }, index);
    });
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            className: cls,
            style: style,
            fillCell: true,
            children: display
        })
    });
};






var $82c62b45b50ca5b7$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $82c62b45b50ca5b7$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $82c62b45b50ca5b7$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $82c62b45b50ca5b7$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $82c62b45b50ca5b7$var$NewResearchStore = (()=>{
    var _a, _NewResearchStore_company_name_accessor_storage, _NewResearchStore_industry_accessor_storage, _NewResearchStore_website_accessor_storage;
    let _company_name_decorators;
    let _company_name_initializers = [];
    let _company_name_extraInitializers = [];
    let _industry_decorators;
    let _industry_initializers = [];
    let _industry_extraInitializers = [];
    let _website_decorators;
    let _website_initializers = [];
    let _website_extraInitializers = [];
    return _a = class NewResearchStore {
        constructor(){
            _NewResearchStore_company_name_accessor_storage.set(this, $82c62b45b50ca5b7$var$__runInitializers(this, _company_name_initializers, ''));
            _NewResearchStore_industry_accessor_storage.set(this, ($82c62b45b50ca5b7$var$__runInitializers(this, _company_name_extraInitializers), $82c62b45b50ca5b7$var$__runInitializers(this, _industry_initializers, '')));
            _NewResearchStore_website_accessor_storage.set(this, ($82c62b45b50ca5b7$var$__runInitializers(this, _industry_extraInitializers), $82c62b45b50ca5b7$var$__runInitializers(this, _website_initializers, '')));
            $82c62b45b50ca5b7$var$__runInitializers(this, _website_extraInitializers);
        }
        get company_name() {
            return $82c62b45b50ca5b7$var$__classPrivateFieldGet(this, _NewResearchStore_company_name_accessor_storage, "f");
        }
        set company_name(value) {
            $82c62b45b50ca5b7$var$__classPrivateFieldSet(this, _NewResearchStore_company_name_accessor_storage, value, "f");
        }
        get industry() {
            return $82c62b45b50ca5b7$var$__classPrivateFieldGet(this, _NewResearchStore_industry_accessor_storage, "f");
        }
        set industry(value) {
            $82c62b45b50ca5b7$var$__classPrivateFieldSet(this, _NewResearchStore_industry_accessor_storage, value, "f");
        }
        get website() {
            return $82c62b45b50ca5b7$var$__classPrivateFieldGet(this, _NewResearchStore_website_accessor_storage, "f");
        }
        set website(value) {
            $82c62b45b50ca5b7$var$__classPrivateFieldSet(this, _NewResearchStore_website_accessor_storage, value, "f");
        }
    }, _NewResearchStore_company_name_accessor_storage = new WeakMap(), _NewResearchStore_industry_accessor_storage = new WeakMap(), _NewResearchStore_website_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _company_name_decorators = [
            (0, $T5IcR.observable)
        ];
        _industry_decorators = [
            (0, $T5IcR.observable)
        ];
        _website_decorators = [
            (0, $T5IcR.observable)
        ];
        $82c62b45b50ca5b7$var$__esDecorate(_a, null, _company_name_decorators, {
            kind: "accessor",
            name: "company_name",
            static: false,
            private: false,
            access: {
                has: (obj)=>"company_name" in obj,
                get: (obj)=>obj.company_name,
                set: (obj, value)=>{
                    obj.company_name = value;
                }
            },
            metadata: _metadata
        }, _company_name_initializers, _company_name_extraInitializers);
        $82c62b45b50ca5b7$var$__esDecorate(_a, null, _industry_decorators, {
            kind: "accessor",
            name: "industry",
            static: false,
            private: false,
            access: {
                has: (obj)=>"industry" in obj,
                get: (obj)=>obj.industry,
                set: (obj, value)=>{
                    obj.industry = value;
                }
            },
            metadata: _metadata
        }, _industry_initializers, _industry_extraInitializers);
        $82c62b45b50ca5b7$var$__esDecorate(_a, null, _website_decorators, {
            kind: "accessor",
            name: "website",
            static: false,
            private: false,
            access: {
                has: (obj)=>"website" in obj,
                get: (obj)=>obj.website,
                set: (obj, value)=>{
                    obj.website = value;
                }
            },
            metadata: _metadata
        }, _website_initializers, _website_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $82c62b45b50ca5b7$export$c528a4d21713c1ae = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const [store] = (0, $8nGP5.useState)(new $82c62b45b50ca5b7$var$NewResearchStore());
    const create_textbox = (label, field)=>{
        return (0, $kSbwP.jsxs)("div", {
            children: [
                (0, $kSbwP.jsx)("label", {
                    className: $67e3b61e1bf357ac$export$1237798dc640739a,
                    children: label
                }),
                (0, $kSbwP.jsx)("input", {
                    type: "text",
                    className: $67e3b61e1bf357ac$export$1fd9c7aa02a3afde,
                    value: store[field],
                    onInput: (e)=>{
                        store[field] = e.currentTarget.value;
                    },
                    placeholder: label
                })
            ]
        });
    };
    const create_textarea = (label, field)=>{
        return (0, $kSbwP.jsxs)("div", {
            children: [
                (0, $kSbwP.jsx)("label", {
                    className: $67e3b61e1bf357ac$export$1237798dc640739a,
                    children: label
                }),
                (0, $kSbwP.jsx)("textarea", {
                    rows: 3,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($67e3b61e1bf357ac$export$1fd9c7aa02a3afde, $67e3b61e1bf357ac$export$eebe8d2968d9c14e),
                    value: store[field],
                    onInput: (e)=>{
                        store[field] = e.currentTarget.value;
                    },
                    placeholder: label
                })
            ]
        });
    };
    const onAddResarch = ()=>{
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        fb.add_research_job('Research', store.company_name, store.industry, store.website);
        const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        uiStore.modal = null;
    };
    const canAddJob = store.company_name.trim().length > 0 && store.industry.trim().length > 0 && store.website.trim().length > 0;
    const elements = [];
    elements.push(create_textbox('Company Name', 'company_name'));
    elements.push(create_textarea('Industry', 'industry'));
    elements.push(create_textbox('Website', 'website'));
    elements.push((0, $kSbwP.jsx)("div", {
        style: {
            flex: 1
        }
    }));
    elements.push((0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
        variant: "light",
        className: $67e3b61e1bf357ac$export$76174c80c75f9baa,
        onClick: onAddResarch,
        disabled: !canAddJob,
        children: "Add New Research"
    }));
    return (0, $kSbwP.jsxs)((0, $c94930c253f3e81f$export$f836382419f64c98), {
        layoutPercent: [
            50,
            50
        ],
        spaceBetween: 40,
        children: [
            (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                fillCell: true,
                direction: "column",
                children: elements
            }),
            (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                fillCell: true,
                direction: "column",
                children: (0, $kSbwP.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2a52017e881bd9f4$exports))),
                    className: $67e3b61e1bf357ac$export$7b8d31d4712adc7b
                })
            })
        ]
    });
});


const $cac561377d3f05fd$export$737f8a52a928f960 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const onClick = ()=>{
        const store = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        store.modal = {
            title: 'New Research',
            el: (0, $kSbwP.jsx)((0, $82c62b45b50ca5b7$export$c528a4d21713c1ae), {})
        };
    };
    return (0, $kSbwP.jsxs)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
        variant: "light",
        className: $991016ec58dcc120$export$e4f6ce96d55d099a,
        onClick: onClick,
        children: [
            (0, $kSbwP.jsx)("i", {
                className: `bi bi-plus-lg ${$991016ec58dcc120$export$3304639b795b6ae}`
            }),
            "New Research"
        ]
    });
});


const $77d5878715146af4$export$8b251419efc915eb = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    var _a;
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const q = store.query;
    const useShadow = (_a = p.showShadow) !== null && _a !== void 0 ? _a : true;
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($705b9354ee184fb4$export$34e0f9847d4c02dd, {
        [$705b9354ee184fb4$export$b8972b998723d602]: useShadow
    });
    const config = (0, $3d79bba9fc178656$export$b3611e87cd5ba6ce)();
    const clientName = config.clientName;
    const firmURL = store.firmInfo.logoURL;
    var showNewDeal = p.showNewDeal === true;
    const clientSettings = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
    if (clientSettings.onlyAdminsAddReports) showNewDeal = false;
    if (p.showNewDeal === true && store.isAdmin && store.showAdminConsole) showNewDeal = true;
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        className: cls,
        justify: "center",
        children: [
            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                style: {
                    paddingBottom: '5px'
                },
                children: [
                    (0, $kSbwP.jsx)((0, $bc783706f3494468$export$e6ff31bff12b7ff4), {
                        onClick: ()=>{
                            navUtils.home();
                        }
                    }),
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            width: '30px'
                        }
                    }),
                    p.showDealDbLink && (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        variant: "light",
                        className: $705b9354ee184fb4$export$ee3e77a244f87ca2,
                        onClick: ()=>{
                            navUtils.home();
                        },
                        children: "Deal Database"
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: "flex-grow-1"
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $705b9354ee184fb4$export$dac02eec6ee70897,
                        children: (0, $kSbwP.jsx)("img", {
                            height: 40,
                            width: 180,
                            src: firmURL,
                            style: {
                                objectFit: 'contain',
                                objectPosition: 'right'
                            }
                        })
                    })
                ]
            }),
            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "row",
                alignItems: "center",
                className: $705b9354ee184fb4$export$faed4863136ce212,
                justify: "between",
                style: {
                    gap: '10px'
                },
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: $705b9354ee184fb4$export$fb184b623420d9be,
                        children: storeUI.pageTitle
                    }),
                    p.showScore && q && (0, $kSbwP.jsx)((0, $33ac36ca38f3f8d0$export$5fb755babf77fa30), {
                        score: q.score(),
                        className: $705b9354ee184fb4$export$155b316d1d1ff341
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: "flex-grow-1"
                    }),
                    store.showAdminConsole && (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        variant: "light",
                        style: {
                            height: '45px'
                        },
                        onClick: ()=>{
                            navUtils.knowledgeBase();
                        },
                        children: "Knowledge Base"
                    }),
                    showNewDeal && (0, $kSbwP.jsx)((0, $cb260e4106feb219$export$3dd2d6bc8d332dfb), {}),
                    showNewDeal && storeUI.dealViewTab == 'DASHBOARD' && (0, $kSbwP.jsx)((0, $cac561377d3f05fd$export$737f8a52a928f960), {}),
                    p.showDealDbLink && storeUI.dealViewTab == 'DASHBOARD' && (0, $kSbwP.jsx)((0, $970b051e739b5a10$export$4e0760818438ce52), {})
                ]
            })
        ]
    });
});






var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");









var $kSbwP = parcelRequire("kSbwP");


var $7a2e80ea91ff7781$export$a7db06668cad9adb;
var $7a2e80ea91ff7781$export$40a9eeef55665a40;
var $7a2e80ea91ff7781$export$93b7586d956c930e;
var $7a2e80ea91ff7781$export$4c9cc8a8bb2b3fc2;
var $7a2e80ea91ff7781$export$21f42ab9b6679f44;
var $7a2e80ea91ff7781$export$f843afa9e9b53052;
var $7a2e80ea91ff7781$export$4585e12f251bfc64;
var $7a2e80ea91ff7781$export$dfb6c81bb5e546a9;
var $7a2e80ea91ff7781$export$ae78d338ad66ff90;
var $7a2e80ea91ff7781$export$b8972b998723d602;
var $7a2e80ea91ff7781$export$13925b5cf10ba292;
var $7a2e80ea91ff7781$export$fb184b623420d9be;
$7a2e80ea91ff7781$export$a7db06668cad9adb = `_63TkoG_content`;
$7a2e80ea91ff7781$export$40a9eeef55665a40 = `_63TkoG_defaultPadding`;
$7a2e80ea91ff7781$export$93b7586d956c930e = `_63TkoG_dropShadow`;
$7a2e80ea91ff7781$export$4c9cc8a8bb2b3fc2 = `_63TkoG_fillCell`;
$7a2e80ea91ff7781$export$21f42ab9b6679f44 = `_63TkoG_panel`;
$7a2e80ea91ff7781$export$f843afa9e9b53052 = `_63TkoG_panelImage`;
$7a2e80ea91ff7781$export$4585e12f251bfc64 = `_63TkoG_panel_shadow`;
$7a2e80ea91ff7781$export$dfb6c81bb5e546a9 = `_63TkoG_panel_title`;
$7a2e80ea91ff7781$export$ae78d338ad66ff90 = `_63TkoG_scaleInOut`;
$7a2e80ea91ff7781$export$b8972b998723d602 = `_63TkoG_shadow`;
$7a2e80ea91ff7781$export$13925b5cf10ba292 = `_63TkoG_small-shadow`;
$7a2e80ea91ff7781$export$fb184b623420d9be = `_63TkoG_title`;



const $a7f903e2fee2d8e0$export$2ddb90ad54e5f587 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    const className = props.className || '';
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($7a2e80ea91ff7781$export$21f42ab9b6679f44, {
        [$7a2e80ea91ff7781$export$4585e12f251bfc64]: props.shadow
    }, className, {
        [$7a2e80ea91ff7781$export$4c9cc8a8bb2b3fc2]: props.fillCell == true
    });
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        className: cls,
        direction: "column",
        style: props.style,
        children: [
            props.title && (0, $kSbwP.jsx)("div", {
                className: $7a2e80ea91ff7781$export$dfb6c81bb5e546a9,
                children: props.title
            }),
            props.children
        ]
    });
});


var $6e79939c17b2206a$exports = {};

$parcel$export($6e79939c17b2206a$exports, "defaultPadding", function () { return $6e79939c17b2206a$export$40a9eeef55665a40; }, function (v) { return $6e79939c17b2206a$export$40a9eeef55665a40 = v; });
$parcel$export($6e79939c17b2206a$exports, "dropShadow", function () { return $6e79939c17b2206a$export$93b7586d956c930e; }, function (v) { return $6e79939c17b2206a$export$93b7586d956c930e = v; });
$parcel$export($6e79939c17b2206a$exports, "panelImage", function () { return $6e79939c17b2206a$export$f843afa9e9b53052; }, function (v) { return $6e79939c17b2206a$export$f843afa9e9b53052 = v; });
$parcel$export($6e79939c17b2206a$exports, "saveForTestsButton", function () { return $6e79939c17b2206a$export$14daf45e188ffb44; }, function (v) { return $6e79939c17b2206a$export$14daf45e188ffb44 = v; });
$parcel$export($6e79939c17b2206a$exports, "saveForTestsContainer", function () { return $6e79939c17b2206a$export$866accb4383c9890; }, function (v) { return $6e79939c17b2206a$export$866accb4383c9890 = v; });
$parcel$export($6e79939c17b2206a$exports, "scaleInOut", function () { return $6e79939c17b2206a$export$ae78d338ad66ff90; }, function (v) { return $6e79939c17b2206a$export$ae78d338ad66ff90 = v; });
$parcel$export($6e79939c17b2206a$exports, "shadow", function () { return $6e79939c17b2206a$export$b8972b998723d602; }, function (v) { return $6e79939c17b2206a$export$b8972b998723d602 = v; });
$parcel$export($6e79939c17b2206a$exports, "small-shadow", function () { return $6e79939c17b2206a$export$13925b5cf10ba292; }, function (v) { return $6e79939c17b2206a$export$13925b5cf10ba292 = v; });
var $6e79939c17b2206a$export$40a9eeef55665a40;
var $6e79939c17b2206a$export$93b7586d956c930e;
var $6e79939c17b2206a$export$f843afa9e9b53052;
var $6e79939c17b2206a$export$14daf45e188ffb44;
var $6e79939c17b2206a$export$866accb4383c9890;
var $6e79939c17b2206a$export$ae78d338ad66ff90;
var $6e79939c17b2206a$export$b8972b998723d602;
var $6e79939c17b2206a$export$13925b5cf10ba292;
$6e79939c17b2206a$export$40a9eeef55665a40 = `C9pNqW_defaultPadding`;
$6e79939c17b2206a$export$93b7586d956c930e = `C9pNqW_dropShadow`;
$6e79939c17b2206a$export$f843afa9e9b53052 = `C9pNqW_panelImage`;
$6e79939c17b2206a$export$14daf45e188ffb44 = `C9pNqW_saveForTestsButton`;
$6e79939c17b2206a$export$866accb4383c9890 = `C9pNqW_saveForTestsContainer`;
$6e79939c17b2206a$export$ae78d338ad66ff90 = `C9pNqW_scaleInOut`;
$6e79939c17b2206a$export$b8972b998723d602 = `C9pNqW_shadow`;
$6e79939c17b2206a$export$13925b5cf10ba292 = `C9pNqW_small-shadow`;




var $kSbwP = parcelRequire("kSbwP");



var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");




var $kSbwP = parcelRequire("kSbwP");

var $f874c4f8ee17651e$export$fad3c8302a7540c6;
$f874c4f8ee17651e$export$fad3c8302a7540c6 = `YM63lW_scrollContainer`;



var $8nGP5 = parcelRequire("8nGP5");





const $1cd5198602b08238$export$9159ebcaf8f42267 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    var _a;
    const scrollRef = (0, $8nGP5.useRef)(null);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($f874c4f8ee17651e$export$fad3c8302a7540c6, props.className);
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const [resizeRef, bounds] = (0, $7e7ca35815405df8$export$2e2bcd8739ae039)();
    const enableHideScrollUntilMouseOver = props.enableHideScrollUntilMouseOver === true;
    const disableKeyboardScroll = props.disableKeyboardScroll === true;
    const [firstLoadScroll, setFirstLoadScroll] = (0, $8nGP5.useState)(false);
    (0, $e6c16966fa3d22d4$export$f2b96e571871cea1)(scrollRef.current, uiStore, disableKeyboardScroll ? 0 : 100);
    (0, $8nGP5.useEffect)(()=>{
        if (enableHideScrollUntilMouseOver) scrollRef.current.style.scrollbarColor = 'transparent transparent';
    }, [
        scrollRef.current
    ]);
    if (props.onLoadScrollToEnd) {
        if (!firstLoadScroll && ((_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) > 0) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            setFirstLoadScroll(true);
        }
    }
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        fillCell: true,
        style: {
            position: 'relative'
        },
        children: [
            (0, $kSbwP.jsx)("div", {
                ref: resizeRef,
                style: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%'
                }
            }),
            (0, $kSbwP.jsx)("div", {
                className: classes,
                style: Object.assign({
                    position: 'absolute',
                    width: bounds.width,
                    height: bounds.height
                }, props.style),
                id: props.id,
                ref: scrollRef,
                onMouseLeave: ()=>{
                    if (!enableHideScrollUntilMouseOver) return;
                    scrollRef.current.style.scrollbarColor = 'transparent transparent';
                },
                onMouseEnter: ()=>{
                    if (!enableHideScrollUntilMouseOver) return;
                    scrollRef.current.style.scrollbarColor = '#eaecf0 transparent';
                },
                children: props.children
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");


var $8nGP5 = parcelRequire("8nGP5");
const $d71aa867ac678319$var$Checkbox = (p)=>{
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('form-check', p.className);
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useId();
    return (0, $kSbwP.jsxs)("div", {
        className: cls,
        children: [
            (0, $kSbwP.jsx)("input", {
                id: id,
                type: "checkbox",
                className: "form-check-input",
                checked: p.checked,
                onChange: (e)=>p.onChange(e.target.checked)
            }),
            p.label && (0, $kSbwP.jsx)("label", {
                className: "form-check-label",
                htmlFor: id,
                children: p.label
            })
        ]
    });
};
var $d71aa867ac678319$export$2e2bcd8739ae039 = $d71aa867ac678319$var$Checkbox;


var $098dd04c5bd47411$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $098dd04c5bd47411$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $098dd04c5bd47411$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $098dd04c5bd47411$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $098dd04c5bd47411$var$FlowiseRerunStore = (()=>{
    var _a, _FlowiseRerunStore_selected_steps_accessor_storage, _FlowiseRerunStore_runPostProcessing_accessor_storage, _FlowiseRerunStore_createNewReport_accessor_storage;
    let _selected_steps_decorators;
    let _selected_steps_initializers = [];
    let _selected_steps_extraInitializers = [];
    let _runPostProcessing_decorators;
    let _runPostProcessing_initializers = [];
    let _runPostProcessing_extraInitializers = [];
    let _createNewReport_decorators;
    let _createNewReport_initializers = [];
    let _createNewReport_extraInitializers = [];
    return _a = class FlowiseRerunStore {
        constructor(){
            _FlowiseRerunStore_selected_steps_accessor_storage.set(this, $098dd04c5bd47411$var$__runInitializers(this, _selected_steps_initializers, {}));
            _FlowiseRerunStore_runPostProcessing_accessor_storage.set(this, ($098dd04c5bd47411$var$__runInitializers(this, _selected_steps_extraInitializers), $098dd04c5bd47411$var$__runInitializers(this, _runPostProcessing_initializers, true)));
            _FlowiseRerunStore_createNewReport_accessor_storage.set(this, ($098dd04c5bd47411$var$__runInitializers(this, _runPostProcessing_extraInitializers), $098dd04c5bd47411$var$__runInitializers(this, _createNewReport_initializers, true)));
            $098dd04c5bd47411$var$__runInitializers(this, _createNewReport_extraInitializers);
        }
        get selected_steps() {
            return $098dd04c5bd47411$var$__classPrivateFieldGet(this, _FlowiseRerunStore_selected_steps_accessor_storage, "f");
        }
        set selected_steps(value) {
            $098dd04c5bd47411$var$__classPrivateFieldSet(this, _FlowiseRerunStore_selected_steps_accessor_storage, value, "f");
        }
        get runPostProcessing() {
            return $098dd04c5bd47411$var$__classPrivateFieldGet(this, _FlowiseRerunStore_runPostProcessing_accessor_storage, "f");
        }
        set runPostProcessing(value) {
            $098dd04c5bd47411$var$__classPrivateFieldSet(this, _FlowiseRerunStore_runPostProcessing_accessor_storage, value, "f");
        }
        get createNewReport() {
            return $098dd04c5bd47411$var$__classPrivateFieldGet(this, _FlowiseRerunStore_createNewReport_accessor_storage, "f");
        }
        set createNewReport(value) {
            $098dd04c5bd47411$var$__classPrivateFieldSet(this, _FlowiseRerunStore_createNewReport_accessor_storage, value, "f");
        }
    }, _FlowiseRerunStore_selected_steps_accessor_storage = new WeakMap(), _FlowiseRerunStore_runPostProcessing_accessor_storage = new WeakMap(), _FlowiseRerunStore_createNewReport_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _selected_steps_decorators = [
            (0, $T5IcR.observable)
        ];
        _runPostProcessing_decorators = [
            (0, $T5IcR.observable)
        ];
        _createNewReport_decorators = [
            (0, $T5IcR.observable)
        ];
        $098dd04c5bd47411$var$__esDecorate(_a, null, _selected_steps_decorators, {
            kind: "accessor",
            name: "selected_steps",
            static: false,
            private: false,
            access: {
                has: (obj)=>"selected_steps" in obj,
                get: (obj)=>obj.selected_steps,
                set: (obj, value)=>{
                    obj.selected_steps = value;
                }
            },
            metadata: _metadata
        }, _selected_steps_initializers, _selected_steps_extraInitializers);
        $098dd04c5bd47411$var$__esDecorate(_a, null, _runPostProcessing_decorators, {
            kind: "accessor",
            name: "runPostProcessing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"runPostProcessing" in obj,
                get: (obj)=>obj.runPostProcessing,
                set: (obj, value)=>{
                    obj.runPostProcessing = value;
                }
            },
            metadata: _metadata
        }, _runPostProcessing_initializers, _runPostProcessing_extraInitializers);
        $098dd04c5bd47411$var$__esDecorate(_a, null, _createNewReport_decorators, {
            kind: "accessor",
            name: "createNewReport",
            static: false,
            private: false,
            access: {
                has: (obj)=>"createNewReport" in obj,
                get: (obj)=>obj.createNewReport,
                set: (obj, value)=>{
                    obj.createNewReport = value;
                }
            },
            metadata: _metadata
        }, _createNewReport_initializers, _createNewReport_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $098dd04c5bd47411$export$41532f4bfad43c7f = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const [localStore] = (0, $8nGP5.useState)(new $098dd04c5bd47411$var$FlowiseRerunStore());
    const report = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().reportDefinitions['insight_report_no_cim'];
    (0, $8nGP5.useEffect)(()=>{
        loadStepsSelection();
    }, []);
    const renderStep = (index, step)=>{
        const hasFlowId = step.flow_id && step.flow_id.length > 0;
        const flowLink = 'https://flowise-test.flightlinedata.com/v2/agentcanvas/' + step.flow_id;
        const bgColor = index % 2 == 0 ? '#b6b6cfff' : '#deddddff';
        const isSelected = localStore.selected_steps[index] === true;
        return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "row",
            wrap: 'wrap',
            fillCell: true,
            style: {
                backgroundColor: bgColor,
                gap: '10px',
                rowGap: '0px',
                marginBottom: '10px'
            },
            children: [
                (0, $kSbwP.jsx)((0, $d71aa867ac678319$export$2e2bcd8739ae039), {
                    checked: isSelected,
                    onChange: (value)=>{
                        localStore.selected_steps[index] = value;
                        storeStepsSelection();
                    }
                }),
                (0, $kSbwP.jsxs)("div", {
                    children: [
                        "#",
                        index
                    ]
                }),
                (0, $kSbwP.jsx)("div", {
                    style: {
                        flex: '1'
                    },
                    children: step.name
                }),
                (0, $kSbwP.jsxs)("div", {
                    children: [
                        "Type: ",
                        (0, $kSbwP.jsx)("b", {
                            children: step.type
                        })
                    ]
                }),
                (0, $kSbwP.jsx)("div", {
                    style: {
                        flex: '1 1 100%'
                    }
                }),
                (0, $kSbwP.jsxs)("div", {
                    style: {
                        paddingLeft: '30px'
                    },
                    children: [
                        "SaveTo: ",
                        (0, $kSbwP.jsx)("b", {
                            children: step.save_to
                        })
                    ]
                }),
                hasFlowId && (0, $kSbwP.jsx)("div", {
                    style: {
                        paddingLeft: '20px'
                    },
                    children: (0, $kSbwP.jsx)("a", {
                        href: flowLink,
                        target: "_blank",
                        rel: "noreferrer",
                        children: "View Flow"
                    })
                })
            ]
        }, 'step-' + index);
    };
    const selectedSteps = Object.keys(localStore.selected_steps).filter((key)=>localStore.selected_steps[key]);
    const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const onRunReport = ()=>{
        const selectedSteps = Object.keys(localStore.selected_steps).filter((key)=>localStore.selected_steps[key]).map((s)=>parseInt(s));
        if (selectedSteps.length == 0) {
            alert('Please select at least one step to rerun');
            return;
        }
        const reportId = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().selectedReportId;
        const modeMsg = localStore.createNewReport ? 'Create New Report' : 'Overwrite Existing';
        const postProcMsg = localStore.runPostProcessing ? ' + Post-Processing' : '';
        const msg = `Mode: ${modeMsg}\nReport: ${reportId}\nSteps: ${selectedSteps.join(', ')}${postProcMsg}\n\nProceed?`;
        if (!confirm(msg)) return;
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        fb.add_research_job(reportId, 'RERUN', 'RERUN', 'RERUN', reportId, selectedSteps, localStore.runPostProcessing, localStore.createNewReport);
        storeUI.modal = null;
        setTimeout(()=>{
            window.location.href = '/';
        }, 750);
    };
    const storeStepsSelection = ()=>{
        const selected = localStore.selected_steps;
        const s = localStorage.setItem('flowise_rerun_steps', JSON.stringify(selected));
    };
    const loadStepsSelection = ()=>{
        const s = localStorage.getItem('flowise_rerun_steps');
        if (s) try {
            const obj = JSON.parse(s);
            localStore.selected_steps = obj;
        } catch (e) {
            console.error('Failed to load steps selection:', e);
        }
    };
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        fillCell: true,
        direction: "column",
        children: [
            (0, $kSbwP.jsx)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    fillCell: true,
                    direction: "column",
                    children: [
                        (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            direction: "column",
                            fillCell: true,
                            style: {
                                backgroundColor: '#f8f9fa',
                                padding: '15px',
                                marginBottom: '20px',
                                border: '1px solid #dee2e6',
                                borderRadius: '4px'
                            },
                            children: [
                                (0, $kSbwP.jsx)("div", {
                                    style: {
                                        fontWeight: 'bold',
                                        marginBottom: '10px'
                                    },
                                    children: "Rerun Mode:"
                                }),
                                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                                    direction: "row",
                                    style: {
                                        gap: '20px'
                                    },
                                    children: [
                                        (0, $kSbwP.jsxs)("label", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                (0, $kSbwP.jsx)("input", {
                                                    type: "radio",
                                                    name: "reportMode",
                                                    checked: localStore.createNewReport,
                                                    onChange: ()=>{
                                                        localStore.createNewReport = true;
                                                    },
                                                    style: {
                                                        marginRight: '8px',
                                                        cursor: 'pointer'
                                                    }
                                                }),
                                                (0, $kSbwP.jsx)("span", {
                                                    children: "Create New Report"
                                                })
                                            ]
                                        }),
                                        (0, $kSbwP.jsxs)("label", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                (0, $kSbwP.jsx)("input", {
                                                    type: "radio",
                                                    name: "reportMode",
                                                    checked: !localStore.createNewReport,
                                                    onChange: ()=>{
                                                        localStore.createNewReport = false;
                                                    },
                                                    style: {
                                                        marginRight: '8px',
                                                        cursor: 'pointer'
                                                    }
                                                }),
                                                (0, $kSbwP.jsx)("span", {
                                                    children: "Overwrite Existing Report"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    style: {
                                        fontSize: '0.85em',
                                        color: '#666',
                                        marginTop: '8px',
                                        paddingLeft: '4px'
                                    },
                                    children: localStore.createNewReport ? 'Creates a new report based on this one with a new ID. Original report remains unchanged.' : 'Overwrites the existing report. Original data will be replaced.'
                                })
                            ]
                        }),
                        (0, $kSbwP.jsx)("div", {
                            style: {
                                fontWeight: 'bold',
                                marginBottom: '10px'
                            },
                            children: "Select Steps to Rerun:"
                        }),
                        report.steps.map((s, index)=>renderStep(index, s)),
                        (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            direction: "row",
                            wrap: 'wrap',
                            fillCell: true,
                            style: {
                                backgroundColor: '#e8f4f8',
                                gap: '10px',
                                rowGap: '0px',
                                marginTop: '20px',
                                marginBottom: '10px',
                                padding: '10px',
                                border: '2px solid #4a90e2'
                            },
                            children: [
                                (0, $kSbwP.jsx)((0, $d71aa867ac678319$export$2e2bcd8739ae039), {
                                    checked: localStore.runPostProcessing,
                                    onChange: (value)=>{
                                        localStore.runPostProcessing = value;
                                    }
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    style: {
                                        flex: '1',
                                        fontWeight: 'bold'
                                    },
                                    children: "Run Post-Processing"
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    style: {
                                        flex: '1 1 100%'
                                    }
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    style: {
                                        paddingLeft: '30px',
                                        fontSize: '0.85em',
                                        color: '#666'
                                    },
                                    children: "Includes: Customer extraction, Transform report into fields, Generate PDF export"
                                })
                            ]
                        })
                    ]
                })
            }),
            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "row",
                style: {
                    height: '60px',
                    padding: '10px'
                },
                children: [
                    (0, $kSbwP.jsxs)("div", {
                        children: [
                            "Selected Steps: ",
                            selectedSteps.join(', '),
                            localStore.runPostProcessing && ' + Post-Processing'
                        ]
                    }),
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            flex: '1'
                        }
                    }),
                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        onClick: onRunReport,
                        children: "Run"
                    })
                ]
            })
        ]
    });
});



// Component for "Save for Tests" button in the admin panel
const $c852cf41bf4911ee$var$AdminSaveForTestsButton = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const selectionStore = (0, $ffb64b99b5e6ea0e$export$4b4c417a6113a34c)();
    // Only show button to admin users and when a report is selected
    if (!store.isAdmin || !store.selectedReportId) return null;
    // Disable the button when selection mode is already active
    const isDisabled = selectionStore.isSelectionModeActive;
    return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6e79939c17b2206a$exports))).saveForTestsContainer,
        children: (0, $kSbwP.jsx)("button", {
            onClick: ()=>selectionStore.activateSelectionMode(),
            disabled: isDisabled,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6e79939c17b2206a$exports))).saveForTestsButton,
            children: "Save for Tests"
        })
    });
});
const $c852cf41bf4911ee$export$e7b94983f4222b90 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    const isRoot = location.pathname === '/';
    const nav = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const getCompanyData = (reportId)=>{
        const q = store.createDataAccess(reportId);
        const year = q.actualYear();
        const company_overview = q.value('company_overview');
        const company_overview_short = q.value('company_overview_short');
        const industry = q.value('industry');
        const subIndustry = q.value('industrySubType');
        const ebitda = q.valueByYear('ebitda_per_year', year);
        const ebitdaMargin = q.valueByYearDivideByRevenue('ebitda_per_year', year);
        const netRevenue = q.valueByYear('net_revenue_per_year', year);
        const grossProfit = q.valueByYear('gross_profit_per_year', year);
        const ebitdaMargin2YearsAgo = q.valueByYearDivideByRevenue('ebitda_per_year', year, -2);
        //const adjustedEbidta = q.valueByYear('adjusted_ebitda_per_year', year);
        const totalCapexByRev = q.valueByYearDivideByRevenue('capex_per_year', year);
        const gross_retention = q.valueByYearDivideByRevenue('gross_retention_lost_only_per_year', year);
        const netRet = q.valueByYear('net_retention_yearly', year);
        const capexPerYear = q.valueByYear('capex_per_year', year);
        const maintenanceCapexPerYear = q.valueByYear('maintenance_capex_per_year', year);
        const freeCashFlow = q.free_cash_flow(year);
        const totalAssets = q.valueByYear('total_current_assets_yearly', year);
        const totalLiabilities = q.valueByYear('total_current_liabilities_yearly', year);
        const tam = q.value('total_addressable_market');
        const historicalMarketGrowth = q.value('historical_market_growth');
        const projectedMarketGrowth = q.value('projected_market_growth');
        const contractualRevenue = q.value('recurring_revenue_summary');
        const rows = [];
        const data = {};
        const addValue = (name, value)=>{
            data[name] = value;
        //rows.push(`${name},${value}`);
        };
        addValue('company_name', q.value('company_name'));
        addValue('company_overview', company_overview);
        addValue('company_overview_short', company_overview_short);
        addValue('industry', industry);
        addValue('sub_industry', subIndustry);
        addValue('net_revenue', netRevenue);
        addValue('gross_profit', grossProfit);
        addValue('organic_cagr_2_years', q.organicCagr(2));
        addValue('projected_organic_cagr_2_years', q.projectedCagr(2));
        addValue('organic_cagr_3_years', q.organicCagr(3));
        addValue('projected_organic_cagr_3_years', q.projectedCagr(3));
        addValue('organic_cagr_4_years', q.organicCagr(4));
        addValue('projected_organic_cagr_4_years', q.projectedCagr(4));
        addValue('organic_cagr_5_years', q.organicCagr(5));
        addValue('projected_organic_cagr_5_years', q.projectedCagr(5));
        addValue('ebitda', ebitda);
        addValue('ebitda_margin', ebitdaMargin);
        addValue('ebitda_margin_2_years_ago', ebitdaMargin2YearsAgo);
        //addValue('adjusted_ebitda', adjustedEbidta);
        addValue('total_capex_by_rev', totalCapexByRev);
        addValue('gross_retention', gross_retention);
        addValue('net_retention', netRet);
        addValue('capex_per_year', capexPerYear);
        addValue('maintenance_capex_per_year', maintenanceCapexPerYear);
        addValue('free_cash_flow', freeCashFlow);
        addValue('total_assets', totalAssets);
        addValue('total_liabilities', totalLiabilities);
        addValue('tam', tam);
        addValue('historical_market_growth', historicalMarketGrowth);
        addValue('projected_market_growth', projectedMarketGrowth);
        addValue('contractual_revenue', contractualRevenue);
        return data;
    };
    function jsonToTransposedCSV(jsonData) {
        const companyIds = Object.keys(jsonData);
        const fieldSet = new Set();
        // Collect all unique fields
        companyIds.forEach((id)=>{
            Object.keys(jsonData[id]).forEach((field)=>fieldSet.add(field));
        });
        companyIds.sort();
        const fields = Array.from(fieldSet);
        // CSV Header
        let csv = `Field||${companyIds.join('||')}\n`;
        // Add rows for each field
        fields.forEach((field)=>{
            const row = [
                field
            ];
            companyIds.forEach((id)=>{
                row.push(jsonData[id][field] !== undefined ? jsonData[id][field] : '');
            });
            csv += row.join('||') + '\r\n';
        });
        return csv;
    }
    const genAllCompaniesData = ()=>{
        const companies = Object.keys(store.reportDataDB);
        const data = {};
        companies.sort();
        companies.forEach((company, i)=>{
            data[company] = getCompanyData(company);
        });
        var csv = jsonToTransposedCSV(data);
        navigator.clipboard.writeText(csv);
    };
    const getCurrentReportFilename = ()=>{
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        return store.query.value('pdf');
    };
    const getCurrentReport = ()=>{
        return store.selectedReportId;
    };
    const getAllFileame = ()=>{
        return '**ALL REPORTS**';
    };
    const getLastJobName = ()=>{
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        const sorted = Object.entries(store.jobs).sort((a, b)=>b[0] > a[0] ? 1 : -1);
        const pdfFile = sorted[0][1]['fileName'];
        return pdfFile;
    };
    if (!store.showAdminConsole) return null;
    const makeReRunButtons = (typeRerun, getFileName)=>{
        const extraSure = '*** FULL-RERUN: DOUBLE-CHECK: Are you sure?';
        const processRerun = (type, pdfFile, clearCache)=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            if (type == 'ALL') {
                var areYouSure2 = window.confirm(extraSure);
                if (!areYouSure2) return;
                const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                var reports = store.reportDataDB;
                var redoList = [];
                for(var reportId in reports){
                    var data = reports[reportId];
                    if (data['status'] == 'completed') redoList.push(data['pdf']);
                }
                redoList.forEach((pdfFile)=>{
                    fb.add_job(pdfFile, null, null, clearCache);
                });
            } else fb.add_job(pdfFile, null, null, clearCache);
            nav.home();
        };
        const variant = typeRerun === 'ALL' ? 'danger' : 'light';
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            style: {
                gap: '10px'
            },
            children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                shadow: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'lightgray',
                            borderRadius: '10px 10px 0px 0px',
                            padding: '5px'
                        },
                        children: typeRerun
                    }),
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        style: {
                            gap: '2px'
                        },
                        children: [
                            (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                variant: variant,
                                onClick: ()=>{
                                    const buildMessage = `*** RERUN:  ${typeRerun}: File: ${getFileName()} - Are you sure?`;
                                    var cacheStr = '\nUSING SAME CACHE';
                                    var areYouSure = window.confirm(buildMessage + cacheStr);
                                    if (!areYouSure) return;
                                    processRerun(typeRerun, getFileName(), false);
                                },
                                children: "Reuse"
                            }),
                            (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                variant: variant,
                                onClick: ()=>{
                                    const buildMessage = `*** RERUN:  ${typeRerun}: File: ${getFileName()} - Are you sure?`;
                                    var cacheStr = '**** CLEARING CACHE ****';
                                    var areYouSure = window.confirm(buildMessage + cacheStr);
                                    if (!areYouSure) return;
                                    processRerun(typeRerun, getFileName(), true);
                                },
                                children: "Clear"
                            })
                        ]
                    })
                ]
            })
        });
    };
    const makeFlowiseRerun = (typeRerun)=>{
        const variant = typeRerun === 'ALL' ? 'danger' : 'light';
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            style: {
                gap: '10px'
            },
            children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                shadow: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'lightgray',
                            borderRadius: '10px 10px 0px 0px',
                            padding: '5px'
                        },
                        children: typeRerun
                    }),
                    (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        style: {
                            gap: '2px'
                        },
                        children: (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                            variant: variant,
                            style: {
                                width: '150px'
                            },
                            onClick: ()=>{
                                if (store.query.report_has_pdf) {
                                    alert('This only works for no-cim for now');
                                    return;
                                }
                                storeUI.modal = {
                                    title: 'Flowise Rerun Step: ' + store.selectedReportId,
                                    el: (0, $kSbwP.jsx)((0, $098dd04c5bd47411$export$41532f4bfad43c7f), {})
                                };
                            },
                            children: "SELECT STEP(s)"
                        })
                    })
                ]
            })
        });
    };
    const makeDeleteButton = (getReportName)=>{
        const processDelete = (reportId)=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            fb.deleteReport(reportId);
            nav.home();
        };
        const variant = 'danger';
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            style: {
                gap: '10px'
            },
            children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                shadow: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'lightgray',
                            borderRadius: '10px 10px 0px 0px',
                            padding: '5px'
                        },
                        children: "CURRENT"
                    }),
                    (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        style: {
                            gap: '2px'
                        },
                        children: (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                            variant: variant,
                            onClick: ()=>{
                                const buildMessage = `*** DELETE: Report: ${getReportName()} - Are you sure?`;
                                var areYouSure = window.confirm(buildMessage);
                                if (!areYouSure) return;
                                processDelete(getReportName());
                            },
                            children: "Delete"
                        })
                    })
                ]
            })
        });
    };
    const makeClearFlowVars = (getReportName)=>{
        const processClear = (reportId)=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            const path = 'flowise_vars/' + reportId;
            (0, $e0be213f695400f3$export$cd7f480d6b8286c3)((0, $e0be213f695400f3$export$eff4d24c3ff7876e)(fb.db, path));
        };
        const variant = 'light';
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            style: {
                gap: '10px'
            },
            children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                shadow: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'lightgray',
                            borderRadius: '10px 10px 0px 0px',
                            padding: '5px',
                            width: '110px'
                        },
                        children: "CURRENT"
                    }),
                    (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        style: {
                            gap: '2px'
                        },
                        children: (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                            variant: variant,
                            onClick: ()=>{
                                const buildMessage = `*** CLEAR FLOWVARS: Report: ${getReportName()} - Are you sure?`;
                                var areYouSure = window.confirm(buildMessage);
                                if (!areYouSure) return;
                                processClear(getReportName());
                            },
                            children: "CLEAR VARS"
                        })
                    })
                ]
            })
        });
    };
    const makePauseResumeJobs = ()=>{
        const setStatusToJobs = (fromStatus, toStatus)=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            const jobs = store.jobs;
            const jobIds = Object.keys(jobs);
            jobIds.forEach((jobId)=>{
                const job = jobs[jobId];
                if (job['status'] == fromStatus) fb.setJobStatus(jobId, toStatus);
            });
        };
        const variant = 'danger';
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            style: {
                gap: '10px',
                minWidth: '160px'
            },
            children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                shadow: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'lightgray',
                            borderRadius: '10px 10px 0px 0px',
                            padding: '5px'
                        },
                        children: "PAUSE/RESUME"
                    }),
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        style: {
                            gap: '10px'
                        },
                        children: [
                            (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                variant: variant,
                                onClick: ()=>{
                                    const buildMessage = `*** This will PAUSE jobs that are in the QUEUE?`;
                                    var areYouSure = window.confirm(buildMessage);
                                    if (!areYouSure) return;
                                    setStatusToJobs('pending', 'paused');
                                },
                                children: "Pause"
                            }),
                            (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                variant: variant,
                                onClick: ()=>{
                                    const buildMessage = `*** This will RESUME jobs that were previously PAUSED?`;
                                    var areYouSure = window.confirm(buildMessage);
                                    if (!areYouSure) return;
                                    setStatusToJobs('paused', 'pending');
                                },
                                children: "Resume"
                            })
                        ]
                    })
                ]
            })
        });
    };
    const makeClearJobQueue = ()=>{
        const processClearJobQueue = ()=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            fb.clearJobQueue();
            nav.home();
        };
        const variant = 'warning';
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            style: {
                gap: '10px',
                minWidth: '100px'
            },
            children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                shadow: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'lightgray',
                            borderRadius: '10px 10px 0px 0px',
                            padding: '5px'
                        },
                        children: "JOB QUEUE"
                    }),
                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        variant: variant,
                        onClick: ()=>{
                            const buildMessage = `*** Clearing Job Queue - Are you sure?`;
                            var areYouSure = window.confirm(buildMessage);
                            if (!areYouSure) return;
                            processClearJobQueue();
                        },
                        children: "CLEAR"
                    })
                ]
            })
        });
    };
    const makeStats = ()=>{
        var _a;
        var totalReports = 0;
        var totalQueued = 0;
        if (!store.reportDataDB) return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {});
        for(var reportId in store.reportDataDB){
            const report = store.reportDataDB[reportId];
            if (report['status'] == 'completed') totalReports++;
        }
        for(var jobId in (_a = store.jobs) !== null && _a !== void 0 ? _a : {}){
            const job = store.jobs[jobId];
            if (job['status'] == 'pending') totalQueued++;
        }
        return (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
            shadow: true,
            children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                style: {
                    gap: '2px',
                    width: '150px',
                    height: '69px',
                    backgroundColor: 'white',
                    borderRadius: '10px'
                },
                direction: "column",
                alignItems: "center",
                justify: "around",
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '18px'
                        },
                        children: (0, $kSbwP.jsxs)("b", {
                            children: [
                                "Reports: ",
                                totalReports
                            ]
                        })
                    }),
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '18px'
                        },
                        children: (0, $kSbwP.jsxs)("b", {
                            children: [
                                "Queue: ",
                                totalQueued
                            ]
                        })
                    })
                ]
            })
        });
    };
    const processLogout = ()=>{
        const auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)((0, $b2432f43c421c848$export$7a667d08ed65fa47)().app);
        auth.signOut();
        store.logout();
    };
    return (0, $kSbwP.jsx)("div", {
        style: {
            transform: 'scale(0.8, 0.8)',
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '500px',
            height: '100px',
            zIndex: 50000
        },
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            alignItems: "end",
            fillCell: true,
            style: {
                gap: '20px'
            },
            children: [
                !isRoot && makeClearFlowVars(getCurrentReport),
                !isRoot && (0, $kSbwP.jsx)($c852cf41bf4911ee$var$AdminSaveForTestsButton, {}),
                makeReRunButtons('LAST JOB', getLastJobName),
                !isRoot && makeReRunButtons('CURRENT', getCurrentReportFilename),
                !isRoot && makeFlowiseRerun('FLOWISE'),
                !isRoot && makeDeleteButton(getCurrentReport),
                makeStats(),
                (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                    variant: "primary",
                    onClick: ()=>{
                        nav.navigateTo('/admin/backtesting');
                    },
                    children: "Backtesting Dashboard"
                }),
                (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                    variant: "danger",
                    onClick: ()=>{
                        const buildMessage = `*** Logout - Are you sure?`;
                        var areYouSure = window.confirm(buildMessage);
                        if (!areYouSure) return;
                        processLogout();
                    },
                    children: "Logout"
                })
            ]
        })
    });
});


function $cdf7e442067abc24$var$e(e) {
    return Object.keys(e).reduce((r, o)=>{
        var a = e[o];
        return r[o] = Object.assign({}, a), !$cdf7e442067abc24$var$t(a.value) || function(e) {
            return "[object Function]" === Object.prototype.toString.call(e);
        }(a.value) || Array.isArray(a.value) || (r[o].value = Object.assign({}, a.value)), Array.isArray(a.value) && (r[o].value = a.value.slice(0)), r;
    }, {});
}
function $cdf7e442067abc24$var$r(e) {
    if (e) try {
        return JSON.parse(e);
    } catch (r) {
        return e;
    }
}
function $cdf7e442067abc24$var$o(e, r, o) {
    if (null == o || !1 === o) return e.removeAttribute(r);
    let t = JSON.stringify(o);
    e.__updating[r] = !0, "true" === t && (t = ""), e.setAttribute(r, t), Promise.resolve().then(()=>delete e.__updating[r]);
}
function $cdf7e442067abc24$var$t(e) {
    return null != e && ("object" == typeof e || "function" == typeof e);
}
let $cdf7e442067abc24$var$a;
function $cdf7e442067abc24$var$l(t, l) {
    const i = Object.keys(l);
    return class extends t {
        static get observedAttributes() {
            return i.map((e)=>l[e].attribute);
        }
        constructor(){
            super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
        }
        connectedCallback() {
            if (!this.__initialized) {
                this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = function(t, a) {
                    const l = $cdf7e442067abc24$var$e(a);
                    return Object.keys(a).forEach((e)=>{
                        const a = l[e], i = t.getAttribute(a.attribute), n = t[e];
                        i && (a.value = a.parse ? $cdf7e442067abc24$var$r(i) : i), null != n && (a.value = Array.isArray(n) ? n.slice(0) : n), a.reflect && $cdf7e442067abc24$var$o(t, a.attribute, a.value), Object.defineProperty(t, e, {
                            get: ()=>a.value,
                            set (r) {
                                var t = a.value;
                                a.value = r, a.reflect && $cdf7e442067abc24$var$o(this, a.attribute, a.value);
                                for(let o = 0, a = this.__propertyChangedCallbacks.length; o < a; o++)this.__propertyChangedCallbacks[o](e, r, t);
                            },
                            enumerable: !0,
                            configurable: !0
                        });
                    }), l;
                }(this, l);
                var t = function(e) {
                    return Object.keys(e).reduce((r, o)=>(r[o] = e[o].value, r), {});
                }(this.props), i = this.Component, n = $cdf7e442067abc24$var$a;
                try {
                    ($cdf7e442067abc24$var$a = this).__initialized = !0, function(e) {
                        return "function" == typeof e && 0 === e.toString().indexOf("class");
                    }(i) ? new i(t, {
                        element: this
                    }) : i(t, {
                        element: this
                    });
                } finally{
                    $cdf7e442067abc24$var$a = n;
                }
            }
        }
        async disconnectedCallback() {
            if (await Promise.resolve(), !this.isConnected) {
                this.__propertyChangedCallbacks.length = 0;
                for(var e = null; e = this.__releaseCallbacks.pop();)e(this);
                delete this.__initialized, this.__released = !0;
            }
        }
        attributeChangedCallback(e, o, t) {
            !this.__initialized || this.__updating[e] || (e = this.lookupProp(e)) in l && (null == t && !this[e] || (this[e] = l[e].parse ? $cdf7e442067abc24$var$r(t) : t));
        }
        lookupProp(e) {
            if (l) return i.find((r)=>e === r || e === l[r].attribute);
        }
        get renderRoot() {
            return this.shadowRoot || this.attachShadow({
                mode: "open"
            });
        }
        addReleaseCallback(e) {
            this.__releaseCallbacks.push(e);
        }
        addPropertyChangedCallback(e) {
            this.__propertyChangedCallbacks.push(e);
        }
    };
}
function $cdf7e442067abc24$var$i(e, r = {}, o = {}) {
    const { BaseElement: a = HTMLElement, extension: i1 } = o;
    return (o)=>{
        if (!e) throw new Error("tag is required to register a Component");
        let n = customElements.get(e);
        return n ? n.prototype.Component = o : ((n = $cdf7e442067abc24$var$l(a, function(e) {
            return e ? Object.keys(e).reduce((r, o)=>{
                var a = e[o];
                return r[o] = $cdf7e442067abc24$var$t(a) && "value" in a ? a : {
                    value: a
                }, r[o].attribute || (r[o].attribute = function(e) {
                    return e.replace(/\.?([A-Z]+)/g, (e, r)=>"-" + r.toLowerCase()).replace("_", "-").replace(/^-/, "");
                }(o)), r[o].parse = "parse" in r[o] ? r[o].parse : "string" != typeof r[o].value, r;
            }, {}) : {};
        }(r))).prototype.Component = o, n.prototype.registeredTag = e, customElements.define(e, n, i1)), n;
    };
}
const $cdf7e442067abc24$var$n = Symbol("solid-proxy"), $cdf7e442067abc24$var$d = Symbol("solid-track"), $cdf7e442067abc24$var$s = Symbol("solid-dev-component"), $cdf7e442067abc24$var$m = {
    equals: (e, r)=>e === r
};
let $cdf7e442067abc24$var$g = $cdf7e442067abc24$var$X;
const $cdf7e442067abc24$var$c = 1, $cdf7e442067abc24$var$x = 2, $cdf7e442067abc24$var$u = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
var $cdf7e442067abc24$var$p = null;
let $cdf7e442067abc24$var$h = null, $cdf7e442067abc24$var$S = null, $cdf7e442067abc24$var$v = null, $cdf7e442067abc24$var$$ = null, $cdf7e442067abc24$var$b = 0;
function $cdf7e442067abc24$var$A(e, r) {
    const o = $cdf7e442067abc24$var$S, t = $cdf7e442067abc24$var$p, a = 0 === e.length, l = a ? $cdf7e442067abc24$var$u : {
        owned: null,
        cleanups: null,
        context: null,
        owner: void 0 === r ? t : r
    }, i = a ? e : ()=>e(()=>$cdf7e442067abc24$var$_(()=>$cdf7e442067abc24$var$V(l)));
    $cdf7e442067abc24$var$p = l, $cdf7e442067abc24$var$S = null;
    try {
        return $cdf7e442067abc24$var$k(i, !0);
    } finally{
        $cdf7e442067abc24$var$S = o, $cdf7e442067abc24$var$p = t;
    }
}
function $cdf7e442067abc24$var$f(e, r) {
    const o = {
        value: e,
        observers: null,
        observerSlots: null,
        comparator: (r = r ? Object.assign({}, $cdf7e442067abc24$var$m, r) : $cdf7e442067abc24$var$m).equals || void 0
    };
    return [
        $cdf7e442067abc24$var$B.bind(o),
        (e)=>("function" == typeof e && (e = e(o.value)), $cdf7e442067abc24$var$E(o, e))
    ];
}
function $cdf7e442067abc24$var$M(e, r, o) {
    $cdf7e442067abc24$var$N($cdf7e442067abc24$var$O(e, r, !1, $cdf7e442067abc24$var$c));
}
function $cdf7e442067abc24$var$P(e, r, o) {
    $cdf7e442067abc24$var$g = $cdf7e442067abc24$var$D, (e = $cdf7e442067abc24$var$O(e, r, !1, $cdf7e442067abc24$var$c)).user = !0, $cdf7e442067abc24$var$$ ? $cdf7e442067abc24$var$$.push(e) : $cdf7e442067abc24$var$N(e);
}
function $cdf7e442067abc24$var$T(e, r, o) {
    return o = o ? Object.assign({}, $cdf7e442067abc24$var$m, o) : $cdf7e442067abc24$var$m, (e = $cdf7e442067abc24$var$O(e, r, !0, 0)).observers = null, e.observerSlots = null, e.comparator = o.equals || void 0, $cdf7e442067abc24$var$N(e), $cdf7e442067abc24$var$B.bind(e);
}
function $cdf7e442067abc24$var$_(e) {
    if (null === $cdf7e442067abc24$var$S) return e();
    var r = $cdf7e442067abc24$var$S;
    $cdf7e442067abc24$var$S = null;
    try {
        return e();
    } finally{
        $cdf7e442067abc24$var$S = r;
    }
}
function $cdf7e442067abc24$var$y(e) {
    $cdf7e442067abc24$var$P(()=>$cdf7e442067abc24$var$_(e));
}
function $cdf7e442067abc24$var$w(e) {
    return null !== $cdf7e442067abc24$var$p && (null === $cdf7e442067abc24$var$p.cleanups ? $cdf7e442067abc24$var$p.cleanups = [
        e
    ] : $cdf7e442067abc24$var$p.cleanups.push(e)), e;
}
function $cdf7e442067abc24$var$G() {
    return $cdf7e442067abc24$var$S;
}
function $cdf7e442067abc24$var$L(e) {
    var r;
    return void 0 !== (r = $cdf7e442067abc24$var$U($cdf7e442067abc24$var$p, e.id)) ? r : e.defaultValue;
}
function $cdf7e442067abc24$var$C(e) {
    const r = $cdf7e442067abc24$var$T(e), o = $cdf7e442067abc24$var$T(()=>$cdf7e442067abc24$var$K(r()));
    return o.toArray = ()=>{
        var e = o();
        return Array.isArray(e) ? e : null != e ? [
            e
        ] : [];
    }, o;
}
function $cdf7e442067abc24$var$B() {
    var e;
    return this.sources && this.state && (this.state === $cdf7e442067abc24$var$c ? $cdf7e442067abc24$var$N(this) : (e = $cdf7e442067abc24$var$v, $cdf7e442067abc24$var$v = null, $cdf7e442067abc24$var$k(()=>$cdf7e442067abc24$var$R(this), !1), $cdf7e442067abc24$var$v = e)), $cdf7e442067abc24$var$S && (e = this.observers ? this.observers.length : 0, $cdf7e442067abc24$var$S.sources ? ($cdf7e442067abc24$var$S.sources.push(this), $cdf7e442067abc24$var$S.sourceSlots.push(e)) : ($cdf7e442067abc24$var$S.sources = [
        this
    ], $cdf7e442067abc24$var$S.sourceSlots = [
        e
    ]), this.observers ? (this.observers.push($cdf7e442067abc24$var$S), this.observerSlots.push($cdf7e442067abc24$var$S.sources.length - 1)) : (this.observers = [
        $cdf7e442067abc24$var$S
    ], this.observerSlots = [
        $cdf7e442067abc24$var$S.sources.length - 1
    ])), this.value;
}
function $cdf7e442067abc24$var$E(e, r, o) {
    var t = e.value;
    return e.comparator && e.comparator(t, r) || (e.value = r, e.observers && e.observers.length && $cdf7e442067abc24$var$k(()=>{
        for(let t = 0; t < e.observers.length; t += 1){
            var r = e.observers[t], o = $cdf7e442067abc24$var$h && $cdf7e442067abc24$var$h.running;
            o && $cdf7e442067abc24$var$h.disposed.has(r), (o ? r.tState : r.state) || ((r.pure ? $cdf7e442067abc24$var$v : $cdf7e442067abc24$var$$).push(r), r.observers && $cdf7e442067abc24$var$F(r)), o || (r.state = $cdf7e442067abc24$var$c);
        }
        if (1e6 < $cdf7e442067abc24$var$v.length) throw $cdf7e442067abc24$var$v = [], new Error;
    }, !1)), r;
}
function $cdf7e442067abc24$var$N(e) {
    var r, o, t;
    e.fn && ($cdf7e442067abc24$var$V(e), r = $cdf7e442067abc24$var$p, o = $cdf7e442067abc24$var$S, t = $cdf7e442067abc24$var$b, function(e, r, o) {
        let t;
        try {
            t = e.fn(r);
        } catch (r) {
            return e.pure && (e.state = $cdf7e442067abc24$var$c, e.owned && e.owned.forEach($cdf7e442067abc24$var$V), e.owned = null), e.updatedAt = o + 1, $cdf7e442067abc24$var$H(r);
        }
        (!e.updatedAt || e.updatedAt <= o) && (null != e.updatedAt && "observers" in e ? $cdf7e442067abc24$var$E(e, t) : e.value = t, e.updatedAt = o);
    }($cdf7e442067abc24$var$S = $cdf7e442067abc24$var$p = e, e.value, t), $cdf7e442067abc24$var$S = o, $cdf7e442067abc24$var$p = r);
}
function $cdf7e442067abc24$var$O(e, r, o, t = $cdf7e442067abc24$var$c, a) {
    return e = {
        fn: e,
        state: t,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: r,
        owner: $cdf7e442067abc24$var$p,
        context: null,
        pure: o
    }, null !== $cdf7e442067abc24$var$p && $cdf7e442067abc24$var$p !== $cdf7e442067abc24$var$u && ($cdf7e442067abc24$var$p.owned ? $cdf7e442067abc24$var$p.owned.push(e) : $cdf7e442067abc24$var$p.owned = [
        e
    ]), e;
}
function $cdf7e442067abc24$var$I(e) {
    if (0 !== e.state) {
        if (e.state === $cdf7e442067abc24$var$x) return $cdf7e442067abc24$var$R(e);
        if (e.suspense && $cdf7e442067abc24$var$_(e.suspense.inFallback)) return e.suspense.effects.push(e);
        const o = [
            e
        ];
        for(; (e = e.owner) && (!e.updatedAt || e.updatedAt < $cdf7e442067abc24$var$b);)e.state && o.push(e);
        for(let t = o.length - 1; 0 <= t; t--){
            var r;
            (e = o[t]).state === $cdf7e442067abc24$var$c ? $cdf7e442067abc24$var$N(e) : e.state === $cdf7e442067abc24$var$x && (r = $cdf7e442067abc24$var$v, $cdf7e442067abc24$var$v = null, $cdf7e442067abc24$var$k(()=>$cdf7e442067abc24$var$R(e, o[0]), !1), $cdf7e442067abc24$var$v = r);
        }
    }
}
function $cdf7e442067abc24$var$k(e, r) {
    if ($cdf7e442067abc24$var$v) return e();
    let o = !1;
    r || ($cdf7e442067abc24$var$v = []), $cdf7e442067abc24$var$$ ? o = !0 : $cdf7e442067abc24$var$$ = [], $cdf7e442067abc24$var$b++;
    try {
        var t = e();
        return function(e) {
            if ($cdf7e442067abc24$var$v && ($cdf7e442067abc24$var$X($cdf7e442067abc24$var$v), $cdf7e442067abc24$var$v = null), !e) {
                const e = $cdf7e442067abc24$var$$;
                $cdf7e442067abc24$var$$ = null, e.length && $cdf7e442067abc24$var$k(()=>$cdf7e442067abc24$var$g(e), !1);
            }
        }(o), t;
    } catch (e) {
        o || ($cdf7e442067abc24$var$$ = null), $cdf7e442067abc24$var$v = null, $cdf7e442067abc24$var$H(e);
    }
}
function $cdf7e442067abc24$var$X(e) {
    for(let r = 0; r < e.length; r++)$cdf7e442067abc24$var$I(e[r]);
}
function $cdf7e442067abc24$var$D(e) {
    let r, o = 0;
    for(r = 0; r < e.length; r++){
        var t = e[r];
        t.user ? e[o++] = t : $cdf7e442067abc24$var$I(t);
    }
    for(r = 0; r < o; r++)$cdf7e442067abc24$var$I(e[r]);
}
function $cdf7e442067abc24$var$R(e, r) {
    for(let a = e.state = 0; a < e.sources.length; a += 1){
        var o, t = e.sources[a];
        t.sources && ((o = t.state) === $cdf7e442067abc24$var$c ? t !== r && (!t.updatedAt || t.updatedAt < $cdf7e442067abc24$var$b) && $cdf7e442067abc24$var$I(t) : o === $cdf7e442067abc24$var$x && $cdf7e442067abc24$var$R(t, r));
    }
}
function $cdf7e442067abc24$var$F(e) {
    for(let o = 0; o < e.observers.length; o += 1){
        var r = e.observers[o];
        r.state || (r.state = $cdf7e442067abc24$var$x, (r.pure ? $cdf7e442067abc24$var$v : $cdf7e442067abc24$var$$).push(r), r.observers && $cdf7e442067abc24$var$F(r));
    }
}
function $cdf7e442067abc24$var$V(e) {
    let r;
    if (e.sources) for(; e.sources.length;){
        var o, t, a = e.sources.pop(), l = e.sourceSlots.pop(), i = a.observers;
        i && i.length && (o = i.pop(), t = a.observerSlots.pop(), l < i.length) && (i[o.sourceSlots[t] = l] = o, a.observerSlots[l] = t);
    }
    if (e.owned) {
        for(r = e.owned.length - 1; 0 <= r; r--)$cdf7e442067abc24$var$V(e.owned[r]);
        e.owned = null;
    }
    if (e.cleanups) {
        for(r = e.cleanups.length - 1; 0 <= r; r--)e.cleanups[r]();
        e.cleanups = null;
    }
    e.state = 0, e.context = null;
}
function $cdf7e442067abc24$var$H(e) {
    throw e;
}
function $cdf7e442067abc24$var$U(e, r) {
    return e ? e.context && void 0 !== e.context[r] ? e.context[r] : $cdf7e442067abc24$var$U(e.owner, r) : void 0;
}
function $cdf7e442067abc24$var$K(e) {
    if ("function" == typeof e && !e.length) return $cdf7e442067abc24$var$K(e());
    if (Array.isArray(e)) {
        var r = [];
        for(let t = 0; t < e.length; t++){
            var o = $cdf7e442067abc24$var$K(e[t]);
            Array.isArray(o) ? r.push.apply(r, o) : r.push(o);
        }
        return r;
    }
    return e;
}
function $cdf7e442067abc24$var$W(e, r) {
    return function(r) {
        let o;
        return $cdf7e442067abc24$var$M(()=>o = $cdf7e442067abc24$var$_(()=>($cdf7e442067abc24$var$p.context = {
                    [e]: r.value
                }, $cdf7e442067abc24$var$C(()=>r.children))), void 0), o;
    };
}
const $cdf7e442067abc24$var$Z = Symbol("fallback");
function $cdf7e442067abc24$var$Q(e) {
    for(let r = 0; r < e.length; r++)e[r]();
}
function $cdf7e442067abc24$var$z(e, r) {
    return $cdf7e442067abc24$var$_(()=>e(r || {}));
}
function $cdf7e442067abc24$var$Y() {
    return !0;
}
const $cdf7e442067abc24$var$J = {
    get: (e, r, o)=>r === $cdf7e442067abc24$var$n ? o : e.get(r),
    has: (e, r)=>r === $cdf7e442067abc24$var$n || e.has(r),
    set: $cdf7e442067abc24$var$Y,
    deleteProperty: $cdf7e442067abc24$var$Y,
    getOwnPropertyDescriptor: (e, r)=>({
            configurable: !0,
            enumerable: !0,
            get: ()=>e.get(r),
            set: $cdf7e442067abc24$var$Y,
            deleteProperty: $cdf7e442067abc24$var$Y
        }),
    ownKeys: (e)=>e.keys()
};
function $cdf7e442067abc24$var$j(e) {
    return (e = "function" == typeof e ? e() : e) || {};
}
function $cdf7e442067abc24$var$q(...e) {
    let r = !1;
    for(let t = 0; t < e.length; t++){
        var o = e[t];
        r = r || !!o && $cdf7e442067abc24$var$n in o, e[t] = "function" == typeof o ? (r = !0, $cdf7e442067abc24$var$T(o)) : o;
    }
    if (r) return new Proxy({
        get (r) {
            for(let t = e.length - 1; 0 <= t; t--){
                var o = $cdf7e442067abc24$var$j(e[t])[r];
                if (void 0 !== o) return o;
            }
        },
        has (r) {
            for(let o = e.length - 1; 0 <= o; o--)if (r in $cdf7e442067abc24$var$j(e[o])) return !0;
            return !1;
        },
        keys () {
            var r = [];
            for(let o = 0; o < e.length; o++)r.push(...Object.keys($cdf7e442067abc24$var$j(e[o])));
            return [
                ...new Set(r)
            ];
        }
    }, $cdf7e442067abc24$var$J);
    var t = {};
    for(let r = e.length - 1; 0 <= r; r--)if (e[r]) for(const o in Object.getOwnPropertyDescriptors(e[r]))o in t || Object.defineProperty(t, o, {
        enumerable: !0,
        get () {
            for(let t = e.length - 1; 0 <= t; t--){
                var r = (e[t] || {})[o];
                if (void 0 !== r) return r;
            }
        }
    });
    return t;
}
function $cdf7e442067abc24$var$ee(e, ...r) {
    const o = new Set(r.flat());
    var t;
    if ($cdf7e442067abc24$var$n in e) return (t = r.map((r)=>new Proxy({
            get: (o)=>r.includes(o) ? e[o] : void 0,
            has: (o)=>r.includes(o) && o in e,
            keys: ()=>r.filter((r)=>r in e)
        }, $cdf7e442067abc24$var$J))).push(new Proxy({
        get: (r)=>o.has(r) ? void 0 : e[r],
        has: (r)=>!o.has(r) && r in e,
        keys: ()=>Object.keys(e).filter((e)=>!o.has(e))
    }, $cdf7e442067abc24$var$J)), t;
    const a = Object.getOwnPropertyDescriptors(e);
    return r.push(Object.keys(a).filter((e)=>!o.has(e))), r.map((r)=>{
        var o = {};
        for(let t = 0; t < r.length; t++){
            const l = r[t];
            l in e && Object.defineProperty(o, l, a[l] || {
                get: ()=>e[l],
                set: ()=>!0,
                enumerable: !0
            });
        }
        return o;
    });
}
function $cdf7e442067abc24$var$re(e) {
    var r = "fallback" in e && {
        fallback: ()=>e.fallback
    };
    return $cdf7e442067abc24$var$T(function(e, r, o = {}) {
        let t = [], a = [], l = [], i = 0, n = 1 < r.length ? [] : null;
        return $cdf7e442067abc24$var$w(()=>$cdf7e442067abc24$var$Q(l)), ()=>{
            let s, m, g = e() || [];
            return g[$cdf7e442067abc24$var$d], $cdf7e442067abc24$var$_(()=>{
                let e, r, d, x, u, p, h, S, v, $ = g.length;
                if (0 === $) 0 !== i && ($cdf7e442067abc24$var$Q(l), l = [], t = [], a = [], i = 0, n = n && []), o.fallback && (t = [
                    $cdf7e442067abc24$var$Z
                ], a[0] = $cdf7e442067abc24$var$A((e)=>(l[0] = e, o.fallback())), i = 1);
                else if (0 === i) {
                    for(a = new Array($), m = 0; m < $; m++)t[m] = g[m], a[m] = $cdf7e442067abc24$var$A(c);
                    i = $;
                } else {
                    for(d = new Array($), x = new Array($), n && (u = new Array($)), p = 0, h = Math.min(i, $); p < h && t[p] === g[p]; p++);
                    for(h = i - 1, S = $ - 1; h >= p && S >= p && t[h] === g[S]; h--, S--)d[S] = a[h], x[S] = l[h], n && (u[S] = n[h]);
                    for(e = new Map, r = new Array(S + 1), m = S; m >= p; m--)v = g[m], s = e.get(v), r[m] = void 0 === s ? -1 : s, e.set(v, m);
                    for(s = p; s <= h; s++)v = t[s], void 0 !== (m = e.get(v)) && -1 !== m ? (d[m] = a[s], x[m] = l[s], n && (u[m] = n[s]), m = r[m], e.set(v, m)) : l[s]();
                    for(m = p; m < $; m++)m in d ? (a[m] = d[m], l[m] = x[m], n && (n[m] = u[m], n[m](m))) : a[m] = $cdf7e442067abc24$var$A(c);
                    a = a.slice(0, i = $), t = g.slice(0);
                }
                return a;
            });
            function c(e) {
                var o;
                return l[m] = e, n ? ([e, o] = $cdf7e442067abc24$var$f(m), n[m] = o, r(g[m], e)) : r(g[m]);
            }
        };
    }(()=>e.each, e.children, r || void 0));
}
function $cdf7e442067abc24$var$oe(e) {
    const r = e.keyed, o = $cdf7e442067abc24$var$T(()=>e.when, void 0, {
        equals: (e, o)=>r ? e === o : !e == !o
    });
    return $cdf7e442067abc24$var$T(()=>{
        const t = o();
        if (t) {
            const a = e.children;
            return "function" == typeof a && 0 < a.length ? $cdf7e442067abc24$var$_(()=>a(r ? t : ()=>{
                    if ($cdf7e442067abc24$var$_(o)) return e.when;
                    throw ((e)=>`Stale read from <${e}>.`)("Show");
                })) : a;
        }
        return e.fallback;
    }, void 0, void 0);
}
const $cdf7e442067abc24$var$te = new Set([
    "className",
    "value",
    "readOnly",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected"
]), $cdf7e442067abc24$var$ae = new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]), $cdf7e442067abc24$var$le = Object.assign(Object.create(null), {
    className: "class",
    htmlFor: "for"
}), $cdf7e442067abc24$var$ie = Object.assign(Object.create(null), {
    class: "className",
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    }
});
const $cdf7e442067abc24$var$ne = new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]), $cdf7e442067abc24$var$de = new Set([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "set",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
]), $cdf7e442067abc24$var$se = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
const $cdf7e442067abc24$var$me = "_$DX_DELEGATE";
function $cdf7e442067abc24$var$ge(e, r, o) {
    let t;
    const a = ()=>{
        var r = document.createElement("template");
        return r.innerHTML = e, (o ? r.content.firstChild : r.content).firstChild;
    };
    return (r = r ? ()=>(t = t || a()).cloneNode(!0) : ()=>$cdf7e442067abc24$var$_(()=>document.importNode(t = t || a(), !0))).cloneNode = r;
}
function $cdf7e442067abc24$var$ce(e, r = window.document) {
    var o = r[$cdf7e442067abc24$var$me] || (r[$cdf7e442067abc24$var$me] = new Set);
    for(let a = 0, l = e.length; a < l; a++){
        var t = e[a];
        o.has(t) || (o.add(t), r.addEventListener(t, $cdf7e442067abc24$var$fe));
    }
}
function $cdf7e442067abc24$var$xe(e, r, o) {
    null == o ? e.removeAttribute(r) : e.setAttribute(r, o);
}
function $cdf7e442067abc24$var$ue(e, r) {
    null == r ? e.removeAttribute("class") : e.className = r;
}
function $cdf7e442067abc24$var$pe(e, r, o, t) {
    if (t) Array.isArray(o) ? (e["$$" + r] = o[0], e[`$$${r}Data`] = o[1]) : e["$$" + r] = o;
    else if (Array.isArray(o)) {
        const t = o[0];
        e.addEventListener(r, o[0] = (r)=>t.call(e, o[1], r));
    } else e.addEventListener(r, o);
}
function $cdf7e442067abc24$var$he(e, r, o) {
    if (!r) return o ? $cdf7e442067abc24$var$xe(e, "style") : r;
    var t = e.style;
    if ("string" == typeof r) return t.cssText = r;
    let a, l;
    for(l in "string" == typeof o && (t.cssText = o = void 0), r = r || {}, o = o || {})null == r[l] && t.removeProperty(l), delete o[l];
    for(l in r)(a = r[l]) !== o[l] && (t.setProperty(l, a), o[l] = a);
    return o;
}
function $cdf7e442067abc24$var$Se(e, r = {}, o, t) {
    const a = {};
    return t || $cdf7e442067abc24$var$M(()=>a.children = $cdf7e442067abc24$var$Me(e, r.children, a.children)), $cdf7e442067abc24$var$M(()=>r.ref && r.ref(e)), $cdf7e442067abc24$var$M(()=>(function(e, r, o, t, a = {}, l = !1) {
            r = r || {};
            for(const t in a)t in r || "children" !== t && (a[t] = $cdf7e442067abc24$var$Ae(e, t, null, a[t], o, l));
            for(const n in r){
                var i;
                "children" === n ? t || $cdf7e442067abc24$var$Me(e, r.children) : (i = r[n], a[n] = $cdf7e442067abc24$var$Ae(e, n, i, a[n], o, l));
            }
        })(e, r, o, !0, a, !0)), a;
}
function $cdf7e442067abc24$var$ve(e, r, o) {
    return $cdf7e442067abc24$var$_(()=>e(r, o));
}
function $cdf7e442067abc24$var$$e(e, r, o, t) {
    if (void 0 !== o && (t = t || []), "function" != typeof r) return $cdf7e442067abc24$var$Me(e, r, t, o);
    $cdf7e442067abc24$var$M((t)=>$cdf7e442067abc24$var$Me(e, r(), t, o), t);
}
function $cdf7e442067abc24$var$be(e, r, o) {
    var t = r.trim().split(/\s+/);
    for(let r = 0, a = t.length; r < a; r++)e.classList.toggle(t[r], o);
}
function $cdf7e442067abc24$var$Ae(e, r, o, t, a, l) {
    let i, n, d, s, m;
    var g;
    return "style" === r ? $cdf7e442067abc24$var$he(e, o, t) : "classList" === r ? function(e, r, o = {}) {
        var t = Object.keys(r || {}), a = Object.keys(o);
        let l, i;
        for(l = 0, i = a.length; l < i; l++){
            var n = a[l];
            n && "undefined" !== n && !r[n] && ($cdf7e442067abc24$var$be(e, n, !1), delete o[n]);
        }
        for(l = 0, i = t.length; l < i; l++){
            var d = t[l], s = !!r[d];
            d && "undefined" !== d && o[d] !== s && s && ($cdf7e442067abc24$var$be(e, d, !0), o[d] = s);
        }
        return o;
    }(e, o, t) : o === t ? t : ("ref" === r ? l || o(e) : "on:" === r.slice(0, 3) ? (l = r.slice(3), t && e.removeEventListener(l, t), o && e.addEventListener(l, o)) : "oncapture:" === r.slice(0, 10) ? (l = r.slice(10), t && e.removeEventListener(l, t, !0), o && e.addEventListener(l, o, !0)) : "on" === r.slice(0, 2) ? (l = r.slice(2).toLowerCase(), !(g = $cdf7e442067abc24$var$ne.has(l)) && t && (t = Array.isArray(t) ? t[0] : t, e.removeEventListener(l, t)), (g || o) && ($cdf7e442067abc24$var$pe(e, l, o, g), g) && $cdf7e442067abc24$var$ce([
        l
    ])) : "attr:" === r.slice(0, 5) ? $cdf7e442067abc24$var$xe(e, r.slice(5), o) : (m = "prop:" === r.slice(0, 5)) || (d = $cdf7e442067abc24$var$ae.has(r)) || !a && ((s = function(e, r) {
        return "object" == typeof (e = $cdf7e442067abc24$var$ie[e]) ? e[r] ? e.$ : void 0 : e;
    }(r, e.tagName)) || (n = $cdf7e442067abc24$var$te.has(r))) || (i = e.nodeName.includes("-")) ? (m && (r = r.slice(5), n = !0), "class" === r || "className" === r ? $cdf7e442067abc24$var$ue(e, o) : !i || n || d ? e[s || r] = o : e[function(e) {
        return e.toLowerCase().replace(/-([a-z])/g, (e, r)=>r.toUpperCase());
    }(r)] = o) : (t = a && -1 < r.indexOf(":") && $cdf7e442067abc24$var$se[r.split(":")[0]]) ? function(e, r, o, t) {
        null == t ? e.removeAttributeNS(r, o) : e.setAttributeNS(r, o, t);
    }(e, t, r, o) : $cdf7e442067abc24$var$xe(e, $cdf7e442067abc24$var$le[r] || r, o), o);
}
function $cdf7e442067abc24$var$fe(e) {
    var r = "$$" + e.type;
    let o = e.composedPath && e.composedPath()[0] || e.target;
    for(e.target !== o && Object.defineProperty(e, "target", {
        configurable: !0,
        value: o
    }), Object.defineProperty(e, "currentTarget", {
        configurable: !0,
        get: ()=>o || document
    }); o;){
        var t = o[r];
        if (t && !o.disabled) {
            var a = o[r + "Data"];
            if (void 0 !== a ? t.call(o, a, e) : t.call(o, e), e.cancelBubble) return;
        }
        o = o._$host || o.parentNode || o.host;
    }
}
function $cdf7e442067abc24$var$Me(e, r, o, t, a) {
    for(; "function" == typeof o;)o = o();
    if (r !== o) {
        var l = typeof r, i = void 0 !== t;
        if (e = i && o[0] && o[0].parentNode || e, "string" == l || "number" == l) {
            if ("number" == l && (r = r.toString()), i) {
                let a = o[0];
                a && 3 === a.nodeType ? a.data = r : a = document.createTextNode(r), o = $cdf7e442067abc24$var$_e(e, o, t, a);
            } else o = "" !== o && "string" == typeof o ? e.firstChild.data = r : e.textContent = r;
        } else if (null == r || "boolean" == l) o = $cdf7e442067abc24$var$_e(e, o, t);
        else {
            if ("function" == l) return $cdf7e442067abc24$var$M(()=>{
                let a = r();
                for(; "function" == typeof a;)a = a();
                o = $cdf7e442067abc24$var$Me(e, a, o, t);
            }), ()=>o;
            if (Array.isArray(r)) {
                const n = [];
                if (l = o && Array.isArray(o), $cdf7e442067abc24$var$Pe(n, r, o, a)) return $cdf7e442067abc24$var$M(()=>o = $cdf7e442067abc24$var$Me(e, n, o, t, !0)), ()=>o;
                if (0 === n.length) {
                    if (o = $cdf7e442067abc24$var$_e(e, o, t), i) return o;
                } else l ? 0 === o.length ? $cdf7e442067abc24$var$Te(e, n, t) : function(e, r, o) {
                    let t = o.length, a = r.length, l = t, i = 0, n = 0, d = r[a - 1].nextSibling, s = null;
                    for(; i < a || n < l;)if (r[i] === o[n]) i++, n++;
                    else {
                        for(; r[a - 1] === o[l - 1];)a--, l--;
                        if (a === i) for(var m = l < t ? n ? o[n - 1].nextSibling : o[l - n] : d; n < l;)e.insertBefore(o[n++], m);
                        else if (l === n) for(; i < a;)s && s.has(r[i]) || r[i].remove(), i++;
                        else if (r[i] === o[l - 1] && o[n] === r[a - 1]) {
                            var g = r[--a].nextSibling;
                            e.insertBefore(o[n++], r[i++].nextSibling), e.insertBefore(o[--l], g), r[a] = o[l];
                        } else {
                            if (!s) {
                                s = new Map;
                                let e = n;
                                for(; e < l;)s.set(o[e], e++);
                            }
                            var c = s.get(r[i]);
                            if (null != c) {
                                if (n < c && c < l) {
                                    let t, d = i, m = 1;
                                    for(; ++d < a && d < l && null != (t = s.get(r[d])) && t === c + m;)m++;
                                    if (m > c - n) for(var x = r[i]; n < c;)e.insertBefore(o[n++], x);
                                    else e.replaceChild(o[n++], r[i++]);
                                } else i++;
                            } else r[i++].remove();
                        }
                    }
                }(e, o, n) : (o && $cdf7e442067abc24$var$_e(e), $cdf7e442067abc24$var$Te(e, n));
                o = n;
            } else if (r instanceof Node) {
                if (Array.isArray(o)) {
                    if (i) return o = $cdf7e442067abc24$var$_e(e, o, t, r);
                    $cdf7e442067abc24$var$_e(e, o, null, r);
                } else null != o && "" !== o && e.firstChild ? e.replaceChild(r, e.firstChild) : e.appendChild(r);
                o = r;
            } else console.warn("Unrecognized value. Skipped inserting", r);
        }
    }
    return o;
}
function $cdf7e442067abc24$var$Pe(e, r, o, t) {
    let a = !1;
    for(let i = 0, n = r.length; i < n; i++){
        let n = r[i], d = o && o[i];
        if (n instanceof Node) e.push(n);
        else if (null != n && !0 !== n && !1 !== n) {
            if (Array.isArray(n)) a = $cdf7e442067abc24$var$Pe(e, n, d) || a;
            else if ("function" == typeof n) {
                if (t) {
                    for(; "function" == typeof n;)n = n();
                    a = $cdf7e442067abc24$var$Pe(e, Array.isArray(n) ? n : [
                        n
                    ], Array.isArray(d) ? d : [
                        d
                    ]) || a;
                } else e.push(n), a = !0;
            } else {
                var l = String(n);
                d && 3 === d.nodeType ? (d.data = l, e.push(d)) : e.push(document.createTextNode(l));
            }
        }
    }
    return a;
}
function $cdf7e442067abc24$var$Te(e, r, o = null) {
    for(let t = 0, a = r.length; t < a; t++)e.insertBefore(r[t], o);
}
function $cdf7e442067abc24$var$_e(e, r, o, t) {
    if (void 0 === o) return e.textContent = "";
    var a = t || document.createTextNode("");
    if (r.length) {
        let t = !1;
        for(let n = r.length - 1; 0 <= n; n--){
            var l, i = r[n];
            a !== i ? (l = i.parentNode === e, t || n ? l && i.remove() : l ? e.replaceChild(a, i) : e.insertBefore(a, o)) : t = !0;
        }
    } else e.insertBefore(a, o);
    return [
        a
    ];
}
const $cdf7e442067abc24$var$ye = "http://www.w3.org/2000/svg";
function $cdf7e442067abc24$var$we(e) {
    const [r, o] = $cdf7e442067abc24$var$ee(e, [
        "component"
    ]), t = $cdf7e442067abc24$var$T(()=>r.component);
    return $cdf7e442067abc24$var$T(()=>{
        const e = t();
        switch(typeof e){
            case "function":
                return Object.assign(e, {
                    [$cdf7e442067abc24$var$s]: !0
                }), $cdf7e442067abc24$var$_(()=>e(o));
            case "string":
                var r = $cdf7e442067abc24$var$de.has(e), a = function(e, r = !1) {
                    return r ? document.createElementNS($cdf7e442067abc24$var$ye, e) : document.createElement(e);
                }(e, r);
                return $cdf7e442067abc24$var$Se(a, o, r), a;
        }
    });
}
function $cdf7e442067abc24$var$Ge(e) {
    return (r, o)=>{
        const t = o.element;
        return $cdf7e442067abc24$var$A((a)=>{
            const l = function(e) {
                var r = Object.keys(e), o = {};
                for(let t = 0; t < r.length; t++){
                    const [a, l] = $cdf7e442067abc24$var$f(e[r[t]]);
                    Object.defineProperty(o, r[t], {
                        get: a,
                        set (e) {
                            l(()=>e);
                        }
                    });
                }
                return o;
            }(r);
            t.addPropertyChangedCallback((e, r)=>l[e] = r), t.addReleaseCallback(()=>{
                t.renderRoot.textContent = "", a();
            });
            var i = e(l, o);
            return $cdf7e442067abc24$var$$e(t.renderRoot, i);
        }, function(e) {
            if (e.assignedSlot && e.assignedSlot._$owner) return e.assignedSlot._$owner;
            let r = e.parentNode;
            for(; r && !r._$owner && (!r.assignedSlot || !r.assignedSlot._$owner);)r = r.parentNode;
            return (r && r.assignedSlot ? r.assignedSlot : e)._$owner;
        }(t));
    };
}
function $cdf7e442067abc24$var$Le(e, r, o) {
    return 2 === arguments.length && (o = r, r = {}), $cdf7e442067abc24$var$i(e, r)($cdf7e442067abc24$var$Ge(o));
}
const $cdf7e442067abc24$var$Ce = {
    chatflowid: "",
    apiHost: void 0,
    onRequest: void 0,
    chatflowConfig: void 0,
    theme: void 0,
    observersConfig: void 0
};
var $cdf7e442067abc24$var$Be = '/*! tailwindcss v3.3.1 | MIT License | https://tailwindcss.com*/*,:after,:before{border:0 solid #e5e7eb;box-sizing:border-box}:after,:before{--tw-content:""}html{-webkit-text-size-adjust:100%;font-feature-settings:normal;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;font-variation-settings:normal;line-height:1.5;-moz-tab-size:4;-o-tab-size:4;tab-size:4}body{line-height:inherit;margin:0}hr{border-top-width:1px;color:inherit;height:0}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{border-collapse:collapse;border-color:inherit;text-indent:0}button,input,optgroup,select,textarea{color:inherit;font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;margin:0;padding:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset{margin:0}fieldset,legend{padding:0}menu,ol,ul{list-style:none;margin:0;padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{color:#9ca3af;opacity:1}input::placeholder,textarea::placeholder{color:#9ca3af;opacity:1}[role=button],button{cursor:pointer}:disabled{cursor:default}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}img,video{height:auto;max-width:100%}[hidden]{display:none}*,:after,:before{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.container{width:100%}@media (min-width:640px){.container{max-width:640px}}@media (min-width:768px){.container{max-width:768px}}@media (min-width:1024px){.container{max-width:1024px}}@media (min-width:1280px){.container{max-width:1280px}}@media (min-width:1536px){.container{max-width:1536px}}.prose{color:var(--tw-prose-body);max-width:65ch}.prose :where(p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em;margin-top:1.25em}.prose :where([class~=lead]):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-lead);font-size:1.25em;line-height:1.6;margin-bottom:1.2em;margin-top:1.2em}.prose :where(a):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-links);font-weight:500;text-decoration:underline}.prose :where(strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-bold);font-weight:600}.prose :where(a strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(blockquote strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(thead th strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(ol):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:decimal;margin-bottom:1.25em;margin-top:1.25em;padding-left:1.625em}.prose :where(ol[type=A]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-alpha}.prose :where(ol[type=a]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-alpha}.prose :where(ol[type=A s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-alpha}.prose :where(ol[type=a s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-alpha}.prose :where(ol[type=I]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-roman}.prose :where(ol[type=i]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-roman}.prose :where(ol[type=I s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:upper-roman}.prose :where(ol[type=i s]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:lower-roman}.prose :where(ol[type="1"]):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:decimal}.prose :where(ul):not(:where([class~=not-prose],[class~=not-prose] *)){list-style-type:disc;margin-bottom:1.25em;margin-top:1.25em;padding-left:1.625em}.prose :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{color:var(--tw-prose-counters);font-weight:400}.prose :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *))::marker{color:var(--tw-prose-bullets)}.prose :where(dt):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;margin-top:1.25em}.prose :where(hr):not(:where([class~=not-prose],[class~=not-prose] *)){border-color:var(--tw-prose-hr);border-top-width:1px;margin-bottom:3em;margin-top:3em}.prose :where(blockquote):not(:where([class~=not-prose],[class~=not-prose] *)){border-left-color:var(--tw-prose-quote-borders);border-left-width:.25rem;color:var(--tw-prose-quotes);font-style:italic;font-weight:500;margin-bottom:1.6em;margin-top:1.6em;padding-left:1em;quotes:"\\201C""\\201D""\\2018""\\2019"}.prose :where(blockquote p:first-of-type):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:open-quote}.prose :where(blockquote p:last-of-type):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:close-quote}.prose :where(h1):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-size:2.25em;font-weight:800;line-height:1.1111111;margin-bottom:.8888889em;margin-top:0}.prose :where(h1 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:900}.prose :where(h2):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-size:1.5em;font-weight:700;line-height:1.3333333;margin-bottom:1em;margin-top:2em}.prose :where(h2 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:800}.prose :where(h3):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-size:1.25em;font-weight:600;line-height:1.6;margin-bottom:.6em;margin-top:1.6em}.prose :where(h3 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:700}.prose :where(h4):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;line-height:1.5;margin-bottom:.5em;margin-top:1.5em}.prose :where(h4 strong):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-weight:700}.prose :where(img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:2em;margin-top:2em}.prose :where(picture):not(:where([class~=not-prose],[class~=not-prose] *)){display:block;margin-bottom:2em;margin-top:2em}.prose :where(kbd):not(:where([class~=not-prose],[class~=not-prose] *)){border-radius:.3125rem;box-shadow:0 0 0 1px rgb(var(--tw-prose-kbd-shadows)/10%),0 3px 0 rgb(var(--tw-prose-kbd-shadows)/10%);color:var(--tw-prose-kbd);font-family:inherit;font-size:.875em;font-weight:500;padding:.1875em .375em}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-code);font-size:.875em;font-weight:600}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:"`"}.prose :where(code):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:"`"}.prose :where(a code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(h1 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(h2 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-size:.875em}.prose :where(h3 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit;font-size:.9em}.prose :where(h4 code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(blockquote code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(thead th code):not(:where([class~=not-prose],[class~=not-prose] *)){color:inherit}.prose :where(pre):not(:where([class~=not-prose],[class~=not-prose] *)){background-color:var(--tw-prose-pre-bg);border-radius:.375rem;color:var(--tw-prose-pre-code);font-size:.875em;font-weight:400;line-height:1.7142857;margin-bottom:1.7142857em;margin-top:1.7142857em;overflow-x:auto;padding:.8571429em 1.1428571em}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)){background-color:transparent;border-radius:0;border-width:0;color:inherit;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;padding:0}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)):before{content:none}.prose :where(pre code):not(:where([class~=not-prose],[class~=not-prose] *)):after{content:none}.prose :where(table):not(:where([class~=not-prose],[class~=not-prose] *)){font-size:.875em;line-height:1.7142857;margin-bottom:2em;margin-top:2em;table-layout:auto;text-align:left;width:100%}.prose :where(thead):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-color:var(--tw-prose-th-borders);border-bottom-width:1px}.prose :where(thead th):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-headings);font-weight:600;padding-bottom:.5714286em;padding-left:.5714286em;padding-right:.5714286em;vertical-align:bottom}.prose :where(tbody tr):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-color:var(--tw-prose-td-borders);border-bottom-width:1px}.prose :where(tbody tr:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){border-bottom-width:0}.prose :where(tbody td):not(:where([class~=not-prose],[class~=not-prose] *)){vertical-align:baseline}.prose :where(tfoot):not(:where([class~=not-prose],[class~=not-prose] *)){border-top-color:var(--tw-prose-th-borders);border-top-width:1px}.prose :where(tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){vertical-align:top}.prose :where(figure>*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0;margin-top:0}.prose :where(figcaption):not(:where([class~=not-prose],[class~=not-prose] *)){color:var(--tw-prose-captions);font-size:.875em;line-height:1.4285714;margin-top:.8571429em}.prose{--tw-prose-body:#374151;--tw-prose-headings:#111827;--tw-prose-lead:#4b5563;--tw-prose-links:#111827;--tw-prose-bold:#111827;--tw-prose-counters:#6b7280;--tw-prose-bullets:#d1d5db;--tw-prose-hr:#e5e7eb;--tw-prose-quotes:#111827;--tw-prose-quote-borders:#e5e7eb;--tw-prose-captions:#6b7280;--tw-prose-kbd:#111827;--tw-prose-kbd-shadows:17 24 39;--tw-prose-code:#111827;--tw-prose-pre-code:#e5e7eb;--tw-prose-pre-bg:#1f2937;--tw-prose-th-borders:#d1d5db;--tw-prose-td-borders:#e5e7eb;--tw-prose-invert-body:#d1d5db;--tw-prose-invert-headings:#fff;--tw-prose-invert-lead:#9ca3af;--tw-prose-invert-links:#fff;--tw-prose-invert-bold:#fff;--tw-prose-invert-counters:#9ca3af;--tw-prose-invert-bullets:#4b5563;--tw-prose-invert-hr:#374151;--tw-prose-invert-quotes:#f3f4f6;--tw-prose-invert-quote-borders:#374151;--tw-prose-invert-captions:#9ca3af;--tw-prose-invert-kbd:#fff;--tw-prose-invert-kbd-shadows:255 255 255;--tw-prose-invert-code:#fff;--tw-prose-invert-pre-code:#d1d5db;--tw-prose-invert-pre-bg:rgba(0,0,0,.5);--tw-prose-invert-th-borders:#4b5563;--tw-prose-invert-td-borders:#374151;font-size:1rem;line-height:1.75}.prose :where(picture>img):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0;margin-top:0}.prose :where(video):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:2em;margin-top:2em}.prose :where(li):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:.5em;margin-top:.5em}.prose :where(ol>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:.375em}.prose :where(ul>li):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:.375em}.prose :where(.prose>ul>li p):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:.75em;margin-top:.75em}.prose :where(.prose>ul>li>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose :where(.prose>ul>li>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose :where(.prose>ol>li>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:1.25em}.prose :where(.prose>ol>li>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em}.prose :where(ul ul,ul ol,ol ul,ol ol):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:.75em;margin-top:.75em}.prose :where(dl):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:1.25em;margin-top:1.25em}.prose :where(dd):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:.5em;padding-left:1.625em}.prose :where(hr+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h2+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h3+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(h4+*):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(thead th:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:0}.prose :where(thead th:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-right:0}.prose :where(tbody td,tfoot td):not(:where([class~=not-prose],[class~=not-prose] *)){padding:.5714286em}.prose :where(tbody td:first-child,tfoot td:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-left:0}.prose :where(tbody td:last-child,tfoot td:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){padding-right:0}.prose :where(figure):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:2em;margin-top:2em}.prose :where(.prose>:first-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-top:0}.prose :where(.prose>:last-child):not(:where([class~=not-prose],[class~=not-prose] *)){margin-bottom:0}.pointer-events-none{pointer-events:none}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-0{inset:0}.bottom-0{bottom:0}.left-0{left:0}.right-0{right:0}.right-\\[-8px\\]{right:-8px}.top-0{top:0}.z-0{z-index:0}.z-10{z-index:10}.z-40{z-index:40}.z-50{z-index:50}.z-\\[1001\\]{z-index:1001}.z-\\[1002\\]{z-index:1002}.float-right{float:right}.m-0{margin:0}.m-\\[6px\\]{margin:6px}.m-auto{margin:auto}.mx-4{margin-left:16px;margin-right:16px}.my-2{margin-bottom:8px;margin-top:8px}.my-6{margin-bottom:24px;margin-top:24px}.-ml-1{margin-left:-4px}.mb-1{margin-bottom:4px}.mb-2{margin-bottom:8px}.mb-3{margin-bottom:12px}.mb-4{margin-bottom:16px}.mb-6{margin-bottom:24px}.ml-1{margin-left:4px}.ml-1\\.5{margin-left:6px}.ml-10{margin-left:40px}.ml-2{margin-left:8px}.ml-auto{margin-left:auto}.mr-1{margin-right:4px}.mr-2{margin-right:8px}.mr-3{margin-right:12px}.mr-\\[10px\\]{margin-right:10px}.mt-2{margin-top:8px}.block{display:block}.inline-block{display:inline-block}.flex{display:flex}.inline-flex{display:inline-flex}.hidden{display:none}.h-10{height:40px}.h-12{height:48px}.h-14{height:56px}.h-2{height:8px}.h-4{height:16px}.h-5{height:20px}.h-6{height:24px}.h-7{height:28px}.h-\\[50px\\]{height:50px}.h-\\[58px\\]{height:58px}.h-auto{height:auto}.h-full{height:100%}.max-h-60{max-height:240px}.max-h-\\[128px\\]{max-height:128px}.max-h-\\[192px\\]{max-height:192px}.max-h-\\[704px\\]{max-height:704px}.min-h-\\[56px\\]{min-height:56px}.min-h-full{min-height:100%}.w-10{width:40px}.w-12{width:48px}.w-2{width:8px}.w-4{width:16px}.w-5{width:20px}.w-6{width:24px}.w-64{width:256px}.w-7{width:28px}.w-\\[200px\\]{width:200px}.w-full{width:100%}.min-w-full{min-width:100%}.max-w-3xl{max-width:768px}.max-w-\\[128px\\]{max-width:128px}.max-w-full{max-width:100%}.max-w-max{max-width:-moz-max-content;max-width:max-content}.max-w-md{max-width:448px}.flex-1{flex:1 1 0%}.flex-auto{flex:1 1 auto}.flex-none{flex:none}.flex-shrink-0{flex-shrink:0}.flex-grow{flex-grow:1}.flex-grow-0{flex-grow:0}.basis-auto{flex-basis:auto}.-rotate-180{--tw-rotate:-180deg}.-rotate-180,.rotate-0{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-0{--tw-rotate:0deg}.scale-0{--tw-scale-x:0;--tw-scale-y:0}.scale-0,.scale-100{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.scale-100{--tw-scale-x:1;--tw-scale-y:1}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.animate-fade-in{animation:fade-in .3s ease-out}.animate-spin{animation:spin 1s linear infinite}.cursor-pointer{cursor:pointer}.resize{resize:both}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1{gap:4px}.gap-2{gap:8px}.gap-3{gap:12px}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(8px*(1 - var(--tw-space-x-reverse)));margin-right:calc(8px*var(--tw-space-x-reverse))}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(16px*(1 - var(--tw-space-x-reverse)));margin-right:calc(16px*var(--tw-space-x-reverse))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(8px*var(--tw-space-y-reverse));margin-top:calc(8px*(1 - var(--tw-space-y-reverse)))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(16px*var(--tw-space-y-reverse));margin-top:calc(16px*(1 - var(--tw-space-y-reverse)))}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.overflow-y-scroll{overflow-y:scroll}.scroll-smooth{scroll-behavior:smooth}.whitespace-pre-wrap{white-space:pre-wrap}.rounded{border-radius:4px}.rounded-\\[10px\\]{border-radius:10px}.rounded-\\[6px\\]{border-radius:6px}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:8px}.rounded-md{border-radius:6px}.rounded-none{border-radius:0}.rounded-xl{border-radius:12px}.rounded-b{border-bottom-left-radius:4px;border-bottom-right-radius:4px}.rounded-t{border-top-left-radius:4px;border-top-right-radius:4px}.border{border-width:1px}.border-0{border-width:0}.border-2{border-width:2px}.border-4{border-width:4px}.border-b{border-bottom-width:1px}.border-t{border-top-width:1px}.border-t-4{border-top-width:4px}.border-solid{border-style:solid}.border-dashed{border-style:dashed}.border-\\[\\#eeeeee\\]{--tw-border-opacity:1;border-color:rgb(238 238 238/var(--tw-border-opacity))}.border-current{border-color:currentColor}.border-gray-200{--tw-border-opacity:1;border-color:rgb(229 231 235/var(--tw-border-opacity))}.border-gray-300{--tw-border-opacity:1;border-color:rgb(209 213 219/var(--tw-border-opacity))}.border-green-600{--tw-border-opacity:1;border-color:rgb(22 163 74/var(--tw-border-opacity))}.border-red-300{--tw-border-opacity:1;border-color:rgb(252 165 165/var(--tw-border-opacity))}.border-red-600{--tw-border-opacity:1;border-color:rgb(220 38 38/var(--tw-border-opacity))}.border-yellow-300{--tw-border-opacity:1;border-color:rgb(253 224 71/var(--tw-border-opacity))}.border-t-transparent{border-top-color:transparent}.border-t-white{--tw-border-opacity:1;border-top-color:rgb(255 255 255/var(--tw-border-opacity))}.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\]{background-color:rgba(0,0,0,.3)}.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.4\\)\\]{background-color:rgba(0,0,0,.4)}.bg-black{--tw-bg-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity))}.bg-black\\/10{background-color:rgba(0,0,0,.1)}.bg-black\\/60{background-color:rgba(0,0,0,.6)}.bg-emerald-500{--tw-bg-opacity:1;background-color:rgb(16 185 129/var(--tw-bg-opacity))}.bg-gray-500{--tw-bg-opacity:1;background-color:rgb(107 114 128/var(--tw-bg-opacity))}.bg-red-100{--tw-bg-opacity:1;background-color:rgb(254 226 226/var(--tw-bg-opacity))}.bg-red-500{--tw-bg-opacity:1;background-color:rgb(239 68 68/var(--tw-bg-opacity))}.bg-transparent{background-color:transparent}.bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.bg-yellow-100{--tw-bg-opacity:1;background-color:rgb(254 249 195/var(--tw-bg-opacity))}.bg-opacity-50{--tw-bg-opacity:0.5}.bg-cover{background-size:cover}.bg-center{background-position:50%}.fill-transparent{fill:transparent}.stroke-2{stroke-width:2}.object-cover{-o-object-fit:cover;object-fit:cover}.p-0{padding:0}.p-1{padding:4px}.p-10{padding:40px}.p-2{padding:8px}.p-2\\.5{padding:10px}.p-3{padding:12px}.p-4{padding:16px}.p-5{padding:20px}.p-6{padding:24px}.px-1{padding-left:4px;padding-right:4px}.px-12{padding-left:48px;padding-right:48px}.px-2{padding-left:8px;padding-right:8px}.px-3{padding-left:12px;padding-right:12px}.px-4{padding-left:16px;padding-right:16px}.px-5{padding-left:20px;padding-right:20px}.px-6{padding-left:24px;padding-right:24px}.px-\\[10px\\]{padding-left:10px;padding-right:10px}.py-1{padding-bottom:4px;padding-top:4px}.py-2{padding-bottom:8px;padding-top:8px}.py-4{padding-bottom:16px;padding-top:16px}.py-8{padding-bottom:32px;padding-top:32px}.py-\\[10px\\]{padding-bottom:10px;padding-top:10px}.pb-1{padding-bottom:4px}.pb-2{padding-bottom:8px}.pb-\\[10px\\]{padding-bottom:10px}.pl-4{padding-left:16px}.pr-0{padding-right:0}.pr-3{padding-right:12px}.pt-2{padding-top:8px}.pt-4{padding-top:16px}.pt-\\[6px\\]{padding-top:6px}.pt-\\[70px\\]{padding-top:70px}.text-left{text-align:left}.text-center{text-align:center}.font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.font-sans{font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji}.text-2xl{font-size:24px;line-height:32px}.text-\\[13px\\]{font-size:13px}.text-base{font-size:16px;line-height:24px}.text-sm{font-size:14px;line-height:20px}.text-xl{font-size:20px;line-height:28px}.text-xs{font-size:12px;line-height:16px}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.italic{font-style:italic}.leading-none{line-height:1}.text-black{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity))}.text-blue-500{--tw-text-opacity:1;color:rgb(59 130 246/var(--tw-text-opacity))}.text-blue-600{--tw-text-opacity:1;color:rgb(37 99 235/var(--tw-text-opacity))}.text-gray-500{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity))}.text-gray-600{--tw-text-opacity:1;color:rgb(75 85 99/var(--tw-text-opacity))}.text-gray-700{--tw-text-opacity:1;color:rgb(55 65 81/var(--tw-text-opacity))}.text-green-600{--tw-text-opacity:1;color:rgb(22 163 74/var(--tw-text-opacity))}.text-inherit{color:inherit}.text-red-500{--tw-text-opacity:1;color:rgb(239 68 68/var(--tw-text-opacity))}.text-red-600{--tw-text-opacity:1;color:rgb(220 38 38/var(--tw-text-opacity))}.text-red-700{--tw-text-opacity:1;color:rgb(185 28 28/var(--tw-text-opacity))}.text-transparent{color:transparent}.text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.text-yellow-700{--tw-text-opacity:1;color:rgb(161 98 7/var(--tw-text-opacity))}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-25{opacity:.25}.opacity-75{opacity:.75}.shadow{--tw-shadow:0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px -1px rgba(0,0,0,.1);--tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color),0 1px 2px -1px var(--tw-shadow-color)}.shadow,.shadow-lg{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.shadow-lg{--tw-shadow:0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -4px rgba(0,0,0,.1);--tw-shadow-colored:0 10px 15px -3px var(--tw-shadow-color),0 4px 6px -4px var(--tw-shadow-color)}.shadow-md{--tw-shadow:0 4px 6px -1px rgba(0,0,0,.1),0 2px 4px -2px rgba(0,0,0,.1);--tw-shadow-colored:0 4px 6px -1px var(--tw-shadow-color),0 2px 4px -2px var(--tw-shadow-color)}.shadow-md,.shadow-sm{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.shadow-sm{--tw-shadow:0 1px 2px 0 rgba(0,0,0,.05);--tw-shadow-colored:0 1px 2px 0 var(--tw-shadow-color)}.shadow-xl{--tw-shadow:0 20px 25px -5px rgba(0,0,0,.1),0 8px 10px -6px rgba(0,0,0,.1);--tw-shadow-colored:0 20px 25px -5px var(--tw-shadow-color),0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.outline-none{outline:2px solid transparent;outline-offset:2px}.blur-\\[2px\\]{--tw-blur:blur(2px)}.blur-\\[2px\\],.blur-none{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.blur-none{--tw-blur:blur(0)}.drop-shadow{--tw-drop-shadow:drop-shadow(0 1px 2px rgba(0,0,0,.1)) drop-shadow(0 1px 1px rgba(0,0,0,.06))}.drop-shadow,.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.backdrop-blur-sm{--tw-backdrop-blur:blur(4px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.transition{transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-all{transition-duration:.15s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-colors{transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-opacity{transition-duration:.15s;transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1)}.duration-150,.transition-transform{transition-duration:.15s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.ease-linear{transition-timing-function:linear}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}:host{--chatbot-container-bg-image:none;--chatbot-container-bg-color:transparent;--chatbot-container-font-family:"Open Sans";--chatbot-button-bg-color:#0042da;--chatbot-button-color:#fff;--chatbot-host-bubble-bg-color:#f7f8ff;--chatbot-host-bubble-color:#303235;--chatbot-guest-bubble-bg-color:#3b81f6;--chatbot-guest-bubble-color:#fff;--chatbot-input-bg-color:#fff;--chatbot-input-color:#303235;--chatbot-input-placeholder-color:#9095a0;--chatbot-header-bg-color:#fff;--chatbot-header-color:#303235;--chatbot-border-radius:6px;--PhoneInputCountryFlag-borderColor:transparent;--PhoneInput-color--focus:transparent}a{color:#16bed7;font-weight:500}a:hover{text-decoration:underline}pre{word-wrap:break-word;font-size:13px;margin:5px;overflow:auto;padding:5px;white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;width:auto}.string{color:green}.number{color:#ff8c00}.boolean{color:blue}.null{color:#f0f}.key{color:#002b36}.scrollable-container::-webkit-scrollbar{display:none}.scrollable-container{-ms-overflow-style:none;scrollbar-width:none}.text-fade-in{transition:opacity .4s ease-in .2s}.bubble-typing{transition:width .4s ease-out,height .4s ease-out}.bubble1,.bubble2,.bubble3{background-color:var(--chatbot-host-bubble-color);opacity:.5}.bubble1,.bubble2{animation:chatBubbles 1s ease-in-out infinite}.bubble2{animation-delay:.3s}.bubble3{animation:chatBubbles 1s ease-in-out infinite;animation-delay:.5s}@keyframes chatBubbles{0%{transform:translateY(0)}50%{transform:translateY(-5px)}to{transform:translateY(0)}}button,input,textarea{font-weight:300}.slate-a{text-decoration:underline}.slate-html-container>div{min-height:24px}.slate-bold{font-weight:700}.slate-italic{font-style:oblique}.slate-underline{text-decoration:underline}.text-input::-moz-placeholder{color:#9095a0!important;opacity:1!important}.text-input::placeholder{color:#9095a0!important;opacity:1!important}.chatbot-container{background-color:var(--chatbot-container-bg-color);background-image:var(--chatbot-container-bg-image);font-family:Open Sans,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol}.file-annotation-button{background-color:#02a0a0c2;border:1px solid #02a0a0c2;border-radius:var(--chatbot-border-radius);color:var(--chatbot-button-color)}.chatbot-button{background-color:#0042da;border:1px solid #0042da;border-radius:var(--chatbot-border-radius);color:var(--chatbot-button-color)}.chatbot-button.selectable{border:1px solid #0042da}.chatbot-button.selectable,.chatbot-host-bubble{background-color:#f7f8ff;color:var(--chatbot-host-bubble-color)}.chatbot-host-bubble{word-wrap:break-word;overflow-wrap:break-word;white-space:normal;word-break:break-word}.chatbot-host-bubble>.bubble-typing{background-color:#f7f8ff;border:var(--chatbot-host-bubble-border);border-radius:6px}.chatbot-host-bubble iframe,.chatbot-host-bubble img,.chatbot-host-bubble video{border-radius:var(--chatbot-border-radius)}.chatbot-guest-bubble{word-wrap:break-word;background-color:#3b81f6;border-radius:6px;color:var(--chatbot-guest-bubble-color);overflow-wrap:break-word;white-space:normal;word-break:break-word}.chatbot-input,.feedback-input{background-color:#fff;border-radius:var(--chatbot-border-radius);box-shadow:0 2px 6px -1px rgba(0,0,0,.1);color:#303235}.chatbot-input-error-message{color:#303235}.chatbot-button>.send-icon{fill:var(--chatbot-button-color);stroke:var(--chatbot-button-color)}.chatbot-chat-view{max-width:800px}.ping span{background-color:#0042da}.rating-icon-container svg{stroke:#0042da;fill:#f7f8ff;height:42px;transition:fill .1s ease-out;width:42px}.rating-icon-container.selected svg{fill:#0042da}.rating-icon-container:hover svg{filter:brightness(.9)}.rating-icon-container:active svg{filter:brightness(.75)}.upload-progress-bar{background-color:#0042da;border-radius:var(--chatbot-border-radius)}.total-files-indicator{background-color:#0042da;color:var(--chatbot-button-color);font-size:10px}.chatbot-upload-input{transition:border-color .1s ease-out}.chatbot-upload-input.dragging-over{border-color:#0042da}.secondary-button{background-color:#f7f8ff;border-radius:var(--chatbot-border-radius);color:var(--chatbot-host-bubble-color)}.chatbot-country-select{color:#303235}.chatbot-country-select,.chatbot-date-input{background-color:#fff;border-radius:var(--chatbot-border-radius)}.chatbot-date-input{color:#303235;color-scheme:light}.chatbot-popup-blocked-toast{border-radius:var(--chatbot-border-radius)}.messagelist{border-radius:.5rem;height:100%;overflow-y:scroll;width:100%}.messagelistloading{display:flex;justify-content:center;margin-top:1rem;width:100%}.usermessage{padding:1rem 1.5rem}.usermessagewaiting-light{background:linear-gradient(270deg,#ede7f6,#e3f2fd,#ede7f6);background-position:-100% 0;background-size:200% 200%}.usermessagewaiting-dark,.usermessagewaiting-light{animation:loading-gradient 2s ease-in-out infinite;animation-direction:alternate;animation-name:loading-gradient;padding:1rem 1.5rem}.usermessagewaiting-dark{background:linear-gradient(270deg,#2e2352,#1d3d60,#2e2352);background-position:-100% 0;background-size:200% 200%;color:#ececf1}@keyframes loading-gradient{0%{background-position:-100% 0}to{background-position:100% 0}}.apimessage{animation:fadein .5s;padding:1rem 1.5rem}@keyframes fadein{0%{opacity:0}to{opacity:1}}.apimessage,.usermessage,.usermessagewaiting{display:flex}.markdownanswer{line-height:1.75}.markdownanswer a:hover{opacity:.8}.markdownanswer a{color:#16bed7;font-weight:500}.markdownanswer code{color:#15cb19;font-weight:500;white-space:pre-wrap!important}.markdownanswer ol,.markdownanswer ul{margin:1rem}.boticon,.usericon{border-radius:1rem;margin-right:1rem}.markdownanswer h1,.markdownanswer h2,.markdownanswer h3{font-size:inherit}.center{flex-direction:column;padding:10px;position:relative}.center,.cloud{align-items:center;display:flex;justify-content:center}.cloud{border-radius:.5rem;height:calc(100% - 50px);width:400px}input,textarea{background-color:transparent;border:none;font-family:Poppins,sans-serif;padding:10px}@media (max-width:640px){div[part=bot]{height:100%!important;left:0!important;max-height:unset!important;max-width:unset!important;overflow:auto;overflow-x:hidden;position:fixed!important;top:0!important;width:100%!important}.chatbot-container,.rounded-lg,div[class="flex flex-row items-center w-full h-[50px] absolute top-0 left-0 z-10"],div[part=button]{border-radius:0!important}button{cursor:default!important}}.tooltip{background:var(--tooltip-background-color,#000);border-radius:5px;color:var(--tooltip-text-color,#fff);font-size:var(--tooltip-font-size,12px);max-width:calc(100vw - 20px);padding:5px 10px;position:fixed;transition:opacity .3s ease-in-out;white-space:pre-wrap;word-break:break-word;z-index:42424242}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.spinner{animation:spin 1s linear infinite;border:4px solid hsla(0,0%,100%,.3);border-radius:50%;border-top-color:#fff;height:24px;width:24px}.hover\\:scale-110:hover{--tw-scale-x:1.1;--tw-scale-y:1.1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.hover\\:bg-gray-100:hover{--tw-bg-opacity:1;background-color:rgb(243 244 246/var(--tw-bg-opacity))}.hover\\:bg-green-600:hover{--tw-bg-opacity:1;background-color:rgb(22 163 74/var(--tw-bg-opacity))}.hover\\:bg-red-600:hover{--tw-bg-opacity:1;background-color:rgb(220 38 38/var(--tw-bg-opacity))}.hover\\:bg-transparent:hover{background-color:transparent}.hover\\:text-gray-700:hover{--tw-text-opacity:1;color:rgb(55 65 81/var(--tw-text-opacity))}.hover\\:text-white:hover{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.hover\\:shadow-lg:hover{--tw-shadow:0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -4px rgba(0,0,0,.1);--tw-shadow-colored:0 10px 15px -3px var(--tw-shadow-color),0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.hover\\:brightness-90:hover{--tw-brightness:brightness(.9);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.focus\\:border-blue-500:focus{--tw-border-opacity:1;border-color:rgb(59 130 246/var(--tw-border-opacity))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-blue-500:focus{--tw-ring-opacity:1;--tw-ring-color:rgb(59 130 246/var(--tw-ring-opacity))}.active\\:scale-95:active{--tw-scale-x:.95;--tw-scale-y:.95;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.active\\:bg-emerald-600:active{--tw-bg-opacity:1;background-color:rgb(5 150 105/var(--tw-bg-opacity))}.active\\:brightness-75:active{--tw-brightness:brightness(.75);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:opacity-50:disabled{opacity:.5}.disabled\\:brightness-100:disabled{--tw-brightness:brightness(1);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.group:hover .group-hover\\:flex{display:flex}@media (min-width:640px){.sm\\:right-5{right:20px}.sm\\:my-8{margin-bottom:32px;margin-top:32px}.sm\\:w-\\[400px\\]{width:400px}.sm\\:w-full{width:100%}.sm\\:max-w-lg{max-width:512px}.sm\\:p-0{padding:0}}@media (min-width:768px){.md\\:mb-0{margin-bottom:0}.md\\:flex-row{flex-direction:row}}';
const $cdf7e442067abc24$var$Ee = (e)=>null == e, $cdf7e442067abc24$var$Ne = (e)=>null != e, $cdf7e442067abc24$var$Oe = async (e)=>{
    try {
        var r = "string" == typeof e ? e : e.url, o = "string" != typeof e && $cdf7e442067abc24$var$Ne(e.body) ? {
            "Content-Type": "application/json",
            ...e.headers
        } : void 0;
        let i = "string" != typeof e && $cdf7e442067abc24$var$Ne(e.body) ? JSON.stringify(e.body) : void 0;
        "string" != typeof e && e.formData && (i = e.formData);
        var t = {
            method: "string" == typeof e ? "GET" : e.method,
            mode: "cors",
            headers: o,
            body: i,
            signal: "string" != typeof e ? e.signal : void 0
        }, a = ("string" != typeof e && e.onRequest && await e.onRequest(t), await fetch(r, t));
        let n;
        var l = a.headers.get("Content-Type");
        if (n = l && l.includes("application/json") ? await a.json() : "string" != typeof e && "blob" === e.type ? await a.blob() : await a.text(), a.ok) return {
            data: n
        };
        {
            let e;
            throw e = "object" == typeof n && "error" in n ? n.error : n || a.statusText;
        }
    } catch (e) {
        return console.error(e), {
            error: e
        };
    }
}, $cdf7e442067abc24$var$Ie = (e, r, o = {})=>{
    var t = localStorage.getItem(e + "_EXTERNAL");
    o = {
        ...o
    };
    if (r && (o.chatId = r), t) try {
        var a = JSON.parse(t);
        localStorage.setItem(e + "_EXTERNAL", JSON.stringify({
            ...a,
            ...o
        }));
    } catch (a) {
        const r = t;
        o.chatId = r, localStorage.setItem(e + "_EXTERNAL", JSON.stringify(o));
    }
    else localStorage.setItem(e + "_EXTERNAL", JSON.stringify(o));
}, $cdf7e442067abc24$var$ke = (e)=>{
    if (!(e = localStorage.getItem(e + "_EXTERNAL"))) return {};
    try {
        return JSON.parse(e);
    } catch (e) {
        return {};
    }
}, $cdf7e442067abc24$var$Xe = (e)=>e ? "number" == typeof e ? e : "small" === e ? 32 : "medium" !== e && "large" === e ? 64 : 48 : 48, $cdf7e442067abc24$var$De = $cdf7e442067abc24$var$ge('<svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z">'), $cdf7e442067abc24$var$Re = $cdf7e442067abc24$var$ge('<img alt="Bubble button icon">'), $cdf7e442067abc24$var$Fe = $cdf7e442067abc24$var$ge('<button part="button" class="fixed shadow-md rounded-full hover:scale-110 active:scale-95 transition-transform duration-200 flex justify-center items-center animate-fade-in"><svg viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.601 8.39897C18.269 8.06702 17.7309 8.06702 17.3989 8.39897L12 13.7979L6.60099 8.39897C6.26904 8.06702 5.73086 8.06702 5.39891 8.39897C5.06696 8.73091 5.06696 9.2691 5.39891 9.60105L11.3989 15.601C11.7309 15.933 12.269 15.933 12.601 15.601L18.601 9.60105C18.9329 9.2691 18.9329 8.73091 18.601 8.39897Z">'), $cdf7e442067abc24$var$Ve = (e)=>{
    const r = $cdf7e442067abc24$var$Xe(e.size), [o, t] = $cdf7e442067abc24$var$f({
        bottom: e.bottom ?? 20,
        right: e.right ?? 20
    }), [a, l] = $cdf7e442067abc24$var$f(!1), [i, n] = $cdf7e442067abc24$var$f(!1);
    let d, s;
    const m = (r)=>{
        e.dragAndDrop && (d = r.clientX, s = o().right, document.addEventListener("mousemove", g), document.addEventListener("mouseup", c));
    }, g = (a)=>{
        a = d - a.clientX, a = s + a;
        var l = window.innerWidth - r;
        a = {
            right: Math.min(Math.max(a, 20), l),
            bottom: o().bottom
        };
        t(a), e.setButtonPosition(a);
    }, c = ()=>{
        document.removeEventListener("mousemove", g), document.removeEventListener("mouseup", c);
    }, x = ()=>{
        e.toggleBot(), n(!0), window.innerWidth <= 640 && l(!0);
    };
    return $cdf7e442067abc24$var$P(()=>{
        var r;
        e.autoOpen && (e.autoOpenOnMobile || 640 < window.innerWidth) && (r = e.openDelay ?? 2, setTimeout(()=>{
            e.isBotOpened || i() || e.toggleBot();
        }, 1e3 * r));
    }), $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return !a() || !e.isBotOpened;
        },
        keyed: !0,
        get children () {
            const t = $cdf7e442067abc24$var$Fe(), a = t.firstChild;
            return t.$$mousedown = m, t.$$click = x, t.style.setProperty("z-index", "42424242"), t.style.setProperty("width", r + "px"), t.style.setProperty("height", r + "px"), $cdf7e442067abc24$var$$e(t, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                get when () {
                    return $cdf7e442067abc24$var$Ee(e.customIconSrc);
                },
                keyed: !0,
                get children () {
                    const o = $cdf7e442067abc24$var$De();
                    return $cdf7e442067abc24$var$xe(o, "width", .6 * r), $cdf7e442067abc24$var$xe(o, "height", .6 * r), $cdf7e442067abc24$var$M((r)=>{
                        var t = e.iconColor ?? "white", a = "stroke-2 fill-transparent absolute duration-200 transition " + (e.isBotOpened ? "scale-0 opacity-0" : "scale-100 opacity-100");
                        return t !== r._v$ && (null != (r._v$ = t) ? o.style.setProperty("stroke", t) : o.style.removeProperty("stroke")), a !== r._v$2 && $cdf7e442067abc24$var$xe(o, "class", r._v$2 = a), r;
                    }, {
                        _v$: void 0,
                        _v$2: void 0
                    }), o;
                }
            }), a), $cdf7e442067abc24$var$$e(t, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                get when () {
                    return e.customIconSrc;
                },
                get children () {
                    const o = $cdf7e442067abc24$var$Re();
                    return o.style.setProperty("width", .6 * r + "px"), o.style.setProperty("height", .6 * r + "px"), $cdf7e442067abc24$var$M((r)=>{
                        var t = e.customIconSrc, a = "rounded-full object-cover" + (e.isBotOpened ? "scale-0 opacity-0" : "scale-100 opacity-100");
                        return t !== r._v$3 && $cdf7e442067abc24$var$xe(o, "src", r._v$3 = t), a !== r._v$4 && $cdf7e442067abc24$var$ue(o, r._v$4 = a), r;
                    }, {
                        _v$3: void 0,
                        _v$4: void 0
                    }), o;
                }
            }), a), $cdf7e442067abc24$var$xe(a, "width", .6 * r), $cdf7e442067abc24$var$xe(a, "height", .6 * r), $cdf7e442067abc24$var$M((r)=>{
                var l = e.backgroundColor ?? "#3B81F6", i = o().right + "px", n = o().bottom + "px", d = e.dragAndDrop ? "grab" : "pointer", s = e.iconColor ?? "white", m = "absolute duration-200 transition " + (e.isBotOpened ? "scale-100 rotate-0 opacity-100" : "scale-0 -rotate-180 opacity-0");
                return l !== r._v$5 && (null != (r._v$5 = l) ? t.style.setProperty("background-color", l) : t.style.removeProperty("background-color")), i !== r._v$6 && (null != (r._v$6 = i) ? t.style.setProperty("right", i) : t.style.removeProperty("right")), n !== r._v$7 && (null != (r._v$7 = n) ? t.style.setProperty("bottom", n) : t.style.removeProperty("bottom")), d !== r._v$8 && (null != (r._v$8 = d) ? t.style.setProperty("cursor", d) : t.style.removeProperty("cursor")), s !== r._v$9 && (null != (r._v$9 = s) ? a.style.setProperty("fill", s) : a.style.removeProperty("fill")), m !== r._v$10 && $cdf7e442067abc24$var$xe(a, "class", r._v$10 = m), r;
            }, {
                _v$5: void 0,
                _v$6: void 0,
                _v$7: void 0,
                _v$8: void 0,
                _v$9: void 0,
                _v$10: void 0
            }), t;
        }
    });
};
let $cdf7e442067abc24$var$He;
$cdf7e442067abc24$var$ce([
    "click",
    "mousedown"
]);
const $cdf7e442067abc24$var$Ue = new Uint8Array(16);
function $cdf7e442067abc24$var$Ke() {
    if ($cdf7e442067abc24$var$He = $cdf7e442067abc24$var$He || "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) return $cdf7e442067abc24$var$He($cdf7e442067abc24$var$Ue);
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
}
const $cdf7e442067abc24$var$We = [];
for(let e = 0; e < 256; ++e)$cdf7e442067abc24$var$We.push((e + 256).toString(16).slice(1));
var $cdf7e442067abc24$var$Ze, $cdf7e442067abc24$var$Qe = {
    randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
};
function $cdf7e442067abc24$var$ze(e, r, o) {
    if ($cdf7e442067abc24$var$Qe.randomUUID && !r && !e) return $cdf7e442067abc24$var$Qe.randomUUID();
    var t = (e = e || {}).random || (e.rng || $cdf7e442067abc24$var$Ke)();
    if (t[6] = 15 & t[6] | 64, t[8] = 63 & t[8] | 128, r) {
        o = o || 0;
        for(let e = 0; e < 16; ++e)r[o + e] = t[e];
        return r;
    }
    return function(e, r = 0) {
        return $cdf7e442067abc24$var$We[e[r + 0]] + $cdf7e442067abc24$var$We[e[r + 1]] + $cdf7e442067abc24$var$We[e[r + 2]] + $cdf7e442067abc24$var$We[e[r + 3]] + "-" + $cdf7e442067abc24$var$We[e[r + 4]] + $cdf7e442067abc24$var$We[e[r + 5]] + "-" + $cdf7e442067abc24$var$We[e[r + 6]] + $cdf7e442067abc24$var$We[e[r + 7]] + "-" + $cdf7e442067abc24$var$We[e[r + 8]] + $cdf7e442067abc24$var$We[e[r + 9]] + "-" + $cdf7e442067abc24$var$We[e[r + 10]] + $cdf7e442067abc24$var$We[e[r + 11]] + $cdf7e442067abc24$var$We[e[r + 12]] + $cdf7e442067abc24$var$We[e[r + 13]] + $cdf7e442067abc24$var$We[e[r + 14]] + $cdf7e442067abc24$var$We[e[r + 15]];
    }(t);
}
const $cdf7e442067abc24$var$Ye = ({ chatflowid: e, apiHost: r = "http://localhost:3000", body: o, onRequest: t })=>$cdf7e442067abc24$var$Oe({
        method: "POST",
        url: r + "/api/v1/feedback/" + e,
        body: o,
        onRequest: t
    }), $cdf7e442067abc24$var$Je = ({ apiHost: e = "http://localhost:3000", body: r, onRequest: o })=>$cdf7e442067abc24$var$Oe({
        method: "POST",
        url: e + "/api/v1/openai-assistants-file/download",
        body: r,
        type: "blob",
        onRequest: o
    }), $cdf7e442067abc24$var$je = ({ apiHost: e = "http://localhost:3000", body: r, onRequest: o })=>$cdf7e442067abc24$var$Oe({
        method: "POST",
        url: e + "/api/v1/text-to-speech/abort",
        body: r,
        onRequest: o
    }), $cdf7e442067abc24$var$qe = $cdf7e442067abc24$var$ge('<textarea class="focus:outline-none bg-transparent px-4 py-4 flex-1 w-full h-full min-h-[56px] max-h-[128px] text-input disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 ">'), $cdf7e442067abc24$var$er = (e)=>{
    const [r, o] = $cdf7e442067abc24$var$ee(e, [
        "ref",
        "onInput"
    ]), [t, a] = $cdf7e442067abc24$var$f(56), l = (o)=>{
        e.ref && ("" === o.currentTarget.value ? a(56) : a(o.currentTarget.scrollHeight - 24), o.currentTarget.scrollTo(0, o.currentTarget.scrollHeight), r.onInput(o.currentTarget.value));
    };
    var i, n;
    return (i = $cdf7e442067abc24$var$qe()).$$keydown = (e)=>{
        13 == e.keyCode && e.shiftKey && (e.preventDefault(), e.stopPropagation(), e.currentTarget.value += "\n", l(e));
    }, i.$$input = l, "function" == typeof (n = e.ref) ? $cdf7e442067abc24$var$ve(n, i) : e.ref = i, $cdf7e442067abc24$var$Se(i, $cdf7e442067abc24$var$q({
        get disabled () {
            return e.disabled;
        },
        get style () {
            return {
                "font-size": e.fontSize ? e.fontSize + "px" : "16px",
                resize: "none",
                height: `${"" !== e.value ? t() : 56}px`
            };
        }
    }, o), !1, !1), i;
}, [$cdf7e442067abc24$var$rr, $cdf7e442067abc24$var$or] = ($cdf7e442067abc24$var$ce([
    "input",
    "keydown"
]), $cdf7e442067abc24$var$f()), $cdf7e442067abc24$var$tr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-refresh w-4 h-4" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2">'), $cdf7e442067abc24$var$ar = (e)=>{
    {
        const r = $cdf7e442067abc24$var$tr();
        return $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "stroke", e.color ?? "#3B81F6")), r;
    }
}, $cdf7e442067abc24$var$lr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-refresh w-4 h-4" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 14V2"></path><path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z">'), $cdf7e442067abc24$var$ir = (e)=>{
    {
        const r = $cdf7e442067abc24$var$lr();
        return $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "stroke", e.color ?? "#3B81F6")), r;
    }
}, $cdf7e442067abc24$var$nr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-refresh w-4 h-4" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 10v12"></path><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z">'), $cdf7e442067abc24$var$dr = (e)=>{
    {
        const r = $cdf7e442067abc24$var$nr();
        return $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "stroke", e.color ?? "#3B81F6")), r;
    }
}, $cdf7e442067abc24$var$sr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7"></path><line x1="16" x2="22" y1="5" y2="5"></line><line x1="19" x2="19" y1="2" y2="8"></line><circle cx="9" cy="9" r="2"></circle><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21">'), $cdf7e442067abc24$var$mr = (e)=>{
    {
        const r = $cdf7e442067abc24$var$sr();
        return $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "stroke", e.color ?? "#3B81F6")), r;
    }
}, $cdf7e442067abc24$var$gr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="1">'), $cdf7e442067abc24$var$cr = (e)=>{
    {
        const r = $cdf7e442067abc24$var$gr();
        return $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "stroke", e.color ?? "#3B81F6")), r;
    }
}, $cdf7e442067abc24$var$xr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-refresh" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"></path><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4">'), $cdf7e442067abc24$var$ur = (e)=>{
    {
        const r = $cdf7e442067abc24$var$xr();
        return $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "stroke", e.color ?? "#3B81F6")), r;
    }
}, $cdf7e442067abc24$var$pr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" x2="12" y1="19" y2="22">'), $cdf7e442067abc24$var$hr = (e)=>{
    {
        const r = $cdf7e442067abc24$var$pr();
        return $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "stroke", e.color ?? "#3B81F6")), r;
    }
}, $cdf7e442067abc24$var$Sr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="19px"><path d="M476.59 227.05l-.16-.07L49.35 49.84A23.56 23.56 0 0027.14 52 24.65 24.65 0 0016 72.59v113.29a24 24 0 0019.52 23.57l232.93 43.07a4 4 0 010 7.86L35.53 303.45A24 24 0 0016 327v113.31A23.57 23.57 0 0026.59 460a23.94 23.94 0 0013.22 4 24.55 24.55 0 009.52-1.93L476.4 285.94l.19-.09a32 32 0 000-58.8z">'), $cdf7e442067abc24$var$vr = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Sr(), $cdf7e442067abc24$var$q({
        get style () {
            return {
                fill: e.color ?? "#3B81F6"
            };
        }
    }, e), !0, !0), r;
}, $cdf7e442067abc24$var$$r = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17">'), $cdf7e442067abc24$var$br = (e)=>{
    {
        const r = $cdf7e442067abc24$var$$r();
        return $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "stroke", e.color ?? "#3B81F6")), r;
    }
}, $cdf7e442067abc24$var$Ar = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12">'), $cdf7e442067abc24$var$fr = (e)=>{
    {
        const r = $cdf7e442067abc24$var$Ar();
        return $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "stroke", e.isCurrentColor ? "currentColor" : e.color ?? "#3B81F6")), r;
    }
}, $cdf7e442067abc24$var$Mr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0"><polyline points="20 6 9 17 4 12">'), $cdf7e442067abc24$var$Pr = ()=>$cdf7e442067abc24$var$Mr(), $cdf7e442067abc24$var$Tr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9l6.5 -6.5">'), $cdf7e442067abc24$var$_r = (e)=>{
    {
        const r = $cdf7e442067abc24$var$Tr();
        return $cdf7e442067abc24$var$M((o)=>{
            var t = e.class, a = e.color ?? "#3B81F6";
            return t !== o._v$ && $cdf7e442067abc24$var$xe(r, "class", o._v$ = t), a !== o._v$2 && $cdf7e442067abc24$var$xe(r, "stroke", o._v$2 = a), o;
        }, {
            _v$: void 0,
            _v$2: void 0
        }), r;
    }
}, $cdf7e442067abc24$var$yr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z">'), $cdf7e442067abc24$var$wr = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$yr(), $cdf7e442067abc24$var$q({
        get stroke () {
            return e.color ?? "#3B81F6";
        }
    }, e), !0, !0), r;
}, $cdf7e442067abc24$var$Gr = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-volume w-4 h-4" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14">'), $cdf7e442067abc24$var$Lr = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Gr(), $cdf7e442067abc24$var$q({
        get stroke () {
            return e.color ?? "#3B81F6";
        }
    }, e), !0, !0), r;
}, $cdf7e442067abc24$var$Cr = $cdf7e442067abc24$var$ge('<button type="submit">'), $cdf7e442067abc24$var$Br = $cdf7e442067abc24$var$ge('<svg><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">'), $cdf7e442067abc24$var$Er = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Cr(), $cdf7e442067abc24$var$q({
        get disabled () {
            return e.isDisabled || e.isLoading;
        }
    }, e, {
        get class () {
            return "py-2 px-4 justify-center font-semibold text-white focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75 chatbot-button " + e.class;
        },
        style: {
            background: "transparent",
            border: "none"
        }
    }), !1, !0), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return !e.isLoading;
        },
        get fallback () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Or, {
                class: "text-white"
            });
        },
        get children () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$vr, {
                get color () {
                    return e.sendButtonColor;
                },
                get class () {
                    return "send-icon flex " + (e.disableIcon ? "hidden" : "");
                }
            });
        }
    })), r;
}, $cdf7e442067abc24$var$Nr = (e)=>{
    var r;
    const o = null !== document.querySelector("flowise-fullchatbot") ? "px-4" : "px-12";
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Cr(), $cdf7e442067abc24$var$q({
        get disabled () {
            return e.isDisabled || e.isLoading;
        }
    }, e, {
        get class () {
            return `py-2 ${o} justify-center font-semibold text-white focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75 chatbot-button ` + e.class;
        },
        style: {
            background: "transparent",
            border: "none"
        },
        title: "Reset Chat"
    }), !1, !0), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return !e.isLoading;
        },
        get fallback () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Or, {
                class: "text-white"
            });
        },
        get children () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ur, {
                get color () {
                    return e.sendButtonColor;
                },
                get class () {
                    return "send-icon flex " + (e.disableIcon ? "hidden" : "");
                }
            });
        }
    })), r;
}, $cdf7e442067abc24$var$Or = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Br(), $cdf7e442067abc24$var$q(e, {
        get class () {
            return "animate-spin -ml-1 mr-3 h-5 w-5 " + e.class;
        },
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "data-testid": "loading-spinner"
    }), !0, !0), r;
}, $cdf7e442067abc24$var$Ir = $cdf7e442067abc24$var$ge('<button type="submit">'), $cdf7e442067abc24$var$kr = $cdf7e442067abc24$var$ge('<svg><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">'), $cdf7e442067abc24$var$Xr = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Ir(), $cdf7e442067abc24$var$q({
        get disabled () {
            return e.isDisabled || e.isLoading;
        }
    }, e, {
        get class () {
            return "py-2 pl-4 pr-0 justify-center font-semibold focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75 chatbot-button " + e.class;
        },
        style: {
            background: "transparent",
            border: "none"
        }
    }), !1, !0), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return !e.isLoading;
        },
        get fallback () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Dr, {
                class: "text-white"
            });
        },
        get children () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$mr, {
                get color () {
                    return e.buttonColor;
                }
            });
        }
    })), r;
}, $cdf7e442067abc24$var$Dr = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$kr(), $cdf7e442067abc24$var$q(e, {
        get class () {
            return "animate-spin -ml-1 mr-3 h-5 w-5 " + e.class;
        },
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "data-testid": "loading-spinner"
    }), !0, !0), r;
}, $cdf7e442067abc24$var$Rr = $cdf7e442067abc24$var$ge('<button type="submit">'), $cdf7e442067abc24$var$Fr = $cdf7e442067abc24$var$ge('<svg><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">'), $cdf7e442067abc24$var$Vr = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Rr(), $cdf7e442067abc24$var$q({
        get disabled () {
            return e.isDisabled || e.isLoading;
        }
    }, e, {
        get class () {
            return "py-2 px-4 justify-center font-semibold focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75 chatbot-button " + e.class;
        },
        style: {
            background: "transparent",
            border: "none"
        }
    }), !1, !0), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return !e.isLoading;
        },
        get fallback () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Hr, {
                class: "text-white"
            });
        },
        get children () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$hr, {
                get color () {
                    return e.buttonColor;
                }
            });
        }
    })), r;
}, $cdf7e442067abc24$var$Hr = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Fr(), $cdf7e442067abc24$var$q(e, {
        get class () {
            return "animate-spin -ml-1 mr-3 h-5 w-5 " + e.class;
        },
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "data-testid": "loading-spinner"
    }), !0, !0), r;
}, $cdf7e442067abc24$var$Ur = $cdf7e442067abc24$var$ge('<button type="submit">'), $cdf7e442067abc24$var$Kr = $cdf7e442067abc24$var$ge('<svg><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">'), $cdf7e442067abc24$var$Wr = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Ur(), $cdf7e442067abc24$var$q({
        get disabled () {
            return e.isDisabled || e.isLoading;
        }
    }, e, {
        get class () {
            return "py-2 pl-4 pr-0 justify-center font-semibold focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75 chatbot-button " + e.class;
        },
        style: {
            background: "transparent",
            border: "none"
        }
    }), !1, !0), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return !e.isLoading;
        },
        get fallback () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Zr, {
                class: "text-white"
            });
        },
        get children () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$_r, {
                get color () {
                    return e.buttonColor;
                }
            });
        }
    })), r;
}, $cdf7e442067abc24$var$Zr = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Kr(), $cdf7e442067abc24$var$q(e, {
        get class () {
            return "animate-spin -ml-1 mr-3 h-5 w-5 " + e.class;
        },
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "data-testid": "loading-spinner"
    }), !0, !0), r;
};
class $cdf7e442067abc24$var$Qr {
    history = [];
    currentIndex = -1;
    tempInput = "";
    constructor(e = ()=>10, r = localStorage){
        this.getMaxHistory = e, this.storage = r, this.maxHistory = this.getMaxHistory() ?? 10, this.loadHistory();
    }
    getHistory() {
        return this.history;
    }
    getCurrentIndex() {
        return this.currentIndex;
    }
    addToHistory(e) {
        e.trim() && (this.history[0] !== e && (this.history.unshift(e), this.history.length > this.maxHistory) && this.history.pop(), this.currentIndex = -1, this.saveHistory());
    }
    getPreviousInput(e) {
        return -1 === this.currentIndex && (this.tempInput = e), this.currentIndex < this.history.length - 1 ? (this.currentIndex++, this.history[this.currentIndex]) : this.history[this.currentIndex] || this.tempInput;
    }
    getNextInput() {
        return -1 < this.currentIndex && (this.currentIndex--, -1 !== this.currentIndex) ? this.history[this.currentIndex] : this.tempInput;
    }
    saveHistory() {
        try {
            this.storage.setItem("chatInputHistory", JSON.stringify(this.history));
        } catch (e) {
            console.warn("Failed to save chat history to localStorage:", e instanceof Error ? e.message : e);
        }
    }
    loadHistory() {
        try {
            var e, r = this.storage.getItem("chatInputHistory");
            r && (e = JSON.parse(r), this.history = Array.isArray(e) ? e : []);
        } catch (e) {
            console.warn("Failed to load chat history from localStorage:", e instanceof Error ? e.message : e);
        }
    }
}
const $cdf7e442067abc24$var$zr = $cdf7e442067abc24$var$ge('<div class="w-full px-4 pt-4 pb-1 text-red-500 text-sm" data-testid="warning-message">'), $cdf7e442067abc24$var$Yr = $cdf7e442067abc24$var$ge("<span>Send"), $cdf7e442067abc24$var$Jr = $cdf7e442067abc24$var$ge('<div class="w-full h-auto max-h-[192px] min-h-[56px] flex flex-col items-end justify-between chatbot-input border border-[#eeeeee]" data-testid="input"><div class="w-full flex items-end justify-between">'), $cdf7e442067abc24$var$jr = $cdf7e442067abc24$var$ge("<span>Image Upload"), $cdf7e442067abc24$var$qr = $cdf7e442067abc24$var$ge('<input multiple type="file">'), $cdf7e442067abc24$var$eo = $cdf7e442067abc24$var$ge("<span>File Upload"), $cdf7e442067abc24$var$ro = $cdf7e442067abc24$var$ge("<span>Record Audio"), $cdf7e442067abc24$var$oo = (e)=>{
    const [r, o] = $cdf7e442067abc24$var$f(!1), [t, a] = $cdf7e442067abc24$var$f(""), [l] = $cdf7e442067abc24$var$f(new $cdf7e442067abc24$var$Qr(()=>e.maxHistorySize || 10));
    let i, n, d, s;
    const m = (r)=>{
        var t = r.length;
        e.maxChars && t > e.maxChars ? (a(e.maxCharsWarningMessage ?? `You exceeded the characters limit. Please input less than ${e.maxChars} characters.`), o(!0)) : (e.onInputChange(r), a(""), o(!1));
    }, g = ()=>{
        "" === t() && i?.reportValidity() && (e.enableInputHistory && l().addToHistory(e.inputValue), e.onSubmit(e.inputValue), e.sendMessageSound) && s && s.play();
    }, c = ()=>{
        d && d.click();
    }, x = ()=>{
        n && n.click();
    }, u = (r)=>{
        var o;
        "Enter" !== r.key || r.shiftKey ? e.enableInputHistory && ("ArrowUp" === r.key ? (r.preventDefault(), o = l().getPreviousInput(e.inputValue), e.onInputChange(o)) : "ArrowDown" === r.key && (r.preventDefault(), o = l().getNextInput(), e.onInputChange(o))) : r.isComposing || 229 === r.keyCode || (r.preventDefault(), g());
    }, p = ($cdf7e442067abc24$var$P(()=>{
        var r = void 0 !== e.autoFocus ? e.autoFocus : !$cdf7e442067abc24$var$rr() && 640 < window.innerWidth;
        !e.disabled && r && i && i.focus();
    }), $cdf7e442067abc24$var$y(()=>{
        var r = void 0 !== e.autoFocus ? e.autoFocus : !$cdf7e442067abc24$var$rr() && 640 < window.innerWidth;
        !e.disabled && r && i && i.focus(), e.sendMessageSound && (s = e.sendSoundLocation ? new Audio(e.sendSoundLocation) : new Audio("https://cdn.jsdelivr.net/gh/FlowiseAI/FlowiseChatEmbed@latest/src/assets/send_message.mp3"));
    }), (r)=>{
        e.handleFileChange(r), r.target && (r.target.value = "");
    });
    {
        const o = $cdf7e442067abc24$var$Jr(), a = o.firstChild;
        return o.$$keydown = u, o.style.setProperty("margin", "auto"), $cdf7e442067abc24$var$$e(o, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return "" !== t();
            },
            get children () {
                var e1 = $cdf7e442067abc24$var$zr();
                return $cdf7e442067abc24$var$$e(e1, t), e1;
            }
        }), a), $cdf7e442067abc24$var$$e(a, (()=>{
            const o = $cdf7e442067abc24$var$T(()=>!!e.uploadsConfig?.isImageUploadAllowed);
            return ()=>o() ? [
                    $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Xr, {
                        get buttonColor () {
                            return e.sendButtonColor;
                        },
                        type: "button",
                        class: "m-0 h-14 flex items-center justify-center",
                        get isDisabled () {
                            return e.disabled || r();
                        },
                        "on:click": c,
                        get children () {
                            var e1 = $cdf7e442067abc24$var$jr();
                            return e1.style.setProperty("font-family", "Poppins, sans-serif"), e1;
                        }
                    }),
                    (()=>{
                        const r = $cdf7e442067abc24$var$qr();
                        r.addEventListener("change", p);
                        return "function" == typeof d ? $cdf7e442067abc24$var$ve(d, r) : d = r, r.style.setProperty("display", "none"), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "accept", e.uploadsConfig?.imgUploadSizeAndTypes?.length ? e.uploadsConfig?.imgUploadSizeAndTypes.map((e)=>e.fileTypes).join(",") : "*")), r;
                    })()
                ] : null;
        })(), null), $cdf7e442067abc24$var$$e(a, (()=>{
            const o = $cdf7e442067abc24$var$T(()=>!(!e.uploadsConfig?.isRAGFileUploadAllowed && !e.isFullFileUpload));
            return ()=>o() ? [
                    $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Wr, {
                        get buttonColor () {
                            return e.sendButtonColor;
                        },
                        type: "button",
                        class: "m-0 h-14 flex items-center justify-center",
                        get isDisabled () {
                            return e.disabled || r();
                        },
                        "on:click": x,
                        get children () {
                            var e1 = $cdf7e442067abc24$var$eo();
                            return e1.style.setProperty("font-family", "Poppins, sans-serif"), e1;
                        }
                    }),
                    (()=>{
                        const r = $cdf7e442067abc24$var$qr();
                        r.addEventListener("change", p);
                        return "function" == typeof n ? $cdf7e442067abc24$var$ve(n, r) : n = r, r.style.setProperty("display", "none"), $cdf7e442067abc24$var$M(()=>{
                            var o;
                            return $cdf7e442067abc24$var$xe(r, "accept", e.isFullFileUpload ? "" === e.fullFileUploadAllowedTypes ? "*" : e.fullFileUploadAllowedTypes : !e.uploadsConfig?.fileUploadSizeAndTypes?.length || (o = e.uploadsConfig?.fileUploadSizeAndTypes.map((e)=>e.fileTypes).join(",")).includes("*") ? "*" : o);
                        }), r;
                    })()
                ] : null;
        })(), null), $cdf7e442067abc24$var$$e(a, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$er, {
            ref (e) {
                "function" == typeof i ? i(e) : i = e;
            },
            onInput: m,
            get value () {
                return e.inputValue;
            },
            get fontSize () {
                return e.fontSize;
            },
            get disabled () {
                return e.disabled;
            },
            get placeholder () {
                return e.placeholder ?? "Type your question";
            }
        }), null), $cdf7e442067abc24$var$$e(a, (()=>{
            const o = $cdf7e442067abc24$var$T(()=>!!e.uploadsConfig?.isSpeechToTextEnabled);
            return ()=>o() ? $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Vr, {
                    get buttonColor () {
                        return e.sendButtonColor;
                    },
                    type: "button",
                    class: "m-0 start-recording-button h-14 flex items-center justify-center",
                    get isDisabled () {
                        return e.disabled || r();
                    },
                    get "on:click" () {
                        return e.onMicrophoneClicked;
                    },
                    get children () {
                        var e1 = $cdf7e442067abc24$var$ro();
                        return e1.style.setProperty("font-family", "Poppins, sans-serif"), e1;
                    }
                }) : null;
        })(), null), $cdf7e442067abc24$var$$e(a, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Er, {
            get sendButtonColor () {
                return e.sendButtonColor;
            },
            type: "button",
            get isDisabled () {
                return e.disabled || r();
            },
            class: "m-0 h-14 flex items-center justify-center",
            "on:click": g,
            get children () {
                var e2 = $cdf7e442067abc24$var$Yr();
                return e2.style.setProperty("font-family", "Poppins, sans-serif"), e2;
            }
        }), null), $cdf7e442067abc24$var$M((r)=>{
            var t = e.backgroundColor ?? "#ffffff", a = e.textColor ?? "#303235";
            return t !== r._v$ && (null != (r._v$ = t) ? o.style.setProperty("background-color", t) : o.style.removeProperty("background-color")), a !== r._v$2 && (null != (r._v$2 = a) ? o.style.setProperty("color", a) : o.style.removeProperty("color")), r;
        }, {
            _v$: void 0,
            _v$2: void 0
        }), o;
    }
}, $cdf7e442067abc24$var$to = ($cdf7e442067abc24$var$ce([
    "keydown"
]), $cdf7e442067abc24$var$ge('<div class="relative inline-block"><div><span>')), $cdf7e442067abc24$var$ao = $cdf7e442067abc24$var$ge('<button class="absolute top-0 left-0 right-0 bottom-0 bg-transparent hover:bg-transparent flex items-center justify-center" title="Remove attachment">'), $cdf7e442067abc24$var$lo = $cdf7e442067abc24$var$ge('<div class="absolute inset-0 bg-[rgba(0,0,0,0.4)] flex items-center justify-center z-10 rounded-md"><div class="spinner border-4 border-gray-200 border-t-4 border-t-white rounded-full w-6 h-6 animate-spin">'), $cdf7e442067abc24$var$io = (e)=>{
    const [r, o] = $cdf7e442067abc24$var$f(!1), t = ()=>{
        e.disabled || o(!0);
    }, a = ()=>{
        e.disabled || o(!1);
    };
    {
        const o = $cdf7e442067abc24$var$to(), l = o.firstChild, i = l.firstChild;
        return o.addEventListener("mouseleave", a), o.addEventListener("mouseenter", t), $cdf7e442067abc24$var$$e(l, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$_r, {
            color: "#303235",
            get class () {
                return "transition-filter duration-300 " + (r() ? "blur-[2px]" : "blur-none");
            }
        }), i), $cdf7e442067abc24$var$$e(i, ()=>e.item.name), $cdf7e442067abc24$var$$e(o, (()=>{
            const o = $cdf7e442067abc24$var$T(()=>!(!r() || e.disabled));
            return ()=>o() && (()=>{
                    const r = $cdf7e442067abc24$var$ao();
                    return r.$$click = ()=>e.onDelete(e.item), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$br, {
                        color: "white"
                    })), $cdf7e442067abc24$var$M(()=>r.disabled = e.disabled), r;
                })();
        })(), null), $cdf7e442067abc24$var$$e(o, (()=>{
            const r = $cdf7e442067abc24$var$T(()=>!!e.disabled);
            return ()=>r() && $cdf7e442067abc24$var$lo();
        })(), null), $cdf7e442067abc24$var$M((e)=>{
            var o = `inline-flex items-center h-12 max-w-max p-2 flex-none transition-opacity duration-300 ${(r(), "opacity-100")} ${r() ? "bg-[rgba(0,0,0,0.3)]" : "bg-[transparent]"} border border-gray-300 rounded-md`, t = "ml-1.5 'text-inherit transition-filter duration-300 " + (r() ? "blur-[2px]" : "blur-none");
            return o !== e._v$ && $cdf7e442067abc24$var$ue(l, e._v$ = o), t !== e._v$2 && $cdf7e442067abc24$var$ue(i, e._v$2 = t), e;
        }, {
            _v$: void 0,
            _v$2: void 0
        }), o;
    }
}, $cdf7e442067abc24$var$no = ($cdf7e442067abc24$var$ce([
    "click"
]), $cdf7e442067abc24$var$ge('<figure data-testid="default-avatar"><svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0" x="0" y="0" mask-type="alpha"><circle cx="37.5" cy="37.5" r="37.5" fill="#0042DA"></circle></mask><g mask="url(#mask0)"><rect x="-30" y="-43" width="131" height="154" fill="#0042DA"></rect><rect x="2.50413" y="120.333" width="81.5597" height="86.4577" rx="2.5" transform="rotate(-52.6423 2.50413 120.333)" stroke="#FED23D" stroke-width="5"></rect><circle cx="76.5" cy="-1.5" r="29" stroke="#FF8E20" stroke-width="5"></circle><path d="M-49.8224 22L-15.5 -40.7879L18.8224 22H-49.8224Z" stroke="#F7F8FF" stroke-width="5">')), $cdf7e442067abc24$var$so = ()=>{
    {
        const e = $cdf7e442067abc24$var$no(), r = e.firstChild;
        return $cdf7e442067abc24$var$M((o)=>{
            var t = "flex justify-center items-center rounded-full text-white relative flex-shrink-0 " + ($cdf7e442067abc24$var$rr() ? "w-6 h-6 text-sm" : "w-10 h-10 text-xl"), a = "absolute top-0 left-0 " + ($cdf7e442067abc24$var$rr() ? " w-6 h-6 text-sm" : "w-full h-full text-xl");
            return t !== o._v$ && $cdf7e442067abc24$var$ue(e, o._v$ = t), a !== o._v$2 && $cdf7e442067abc24$var$xe(r, "class", o._v$2 = a), o;
        }, {
            _v$: void 0,
            _v$2: void 0
        }), e;
    }
}, $cdf7e442067abc24$var$mo = $cdf7e442067abc24$var$ge('<figure><img alt="Bot avatar" class="rounded-full object-cover w-full h-full">'), $cdf7e442067abc24$var$go = (e)=>{
    const [r, o] = $cdf7e442067abc24$var$f(e.initialAvatarSrc);
    return $cdf7e442067abc24$var$P(()=>{
        r()?.startsWith("{{") && e.initialAvatarSrc?.startsWith("http") && o(e.initialAvatarSrc);
    }), $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return ((e)=>null != e && "" !== e)(r());
        },
        keyed: !0,
        get fallback () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$so, {});
        },
        get children () {
            const e = $cdf7e442067abc24$var$mo(), o = e.firstChild;
            return $cdf7e442067abc24$var$M((t)=>{
                var a = "flex justify-center items-center rounded-full text-white relative flex-shrink-0 " + ($cdf7e442067abc24$var$rr() ? "w-6 h-6 text-sm" : "w-10 h-10 text-xl"), l = r();
                return a !== t._v$ && $cdf7e442067abc24$var$ue(e, t._v$ = a), l !== t._v$2 && $cdf7e442067abc24$var$xe(o, "src", t._v$2 = l), t;
            }, {
                _v$: void 0,
                _v$2: void 0
            }), e;
        }
    });
};
class $cdf7e442067abc24$var$co {
    source;
    flags;
    constructor(e, r = ""){
        this.source = e.source, this.flags = r;
    }
    setGroup(e, r) {
        let o = "string" == typeof r ? r : r.source;
        return o = o.replace(/(^|[^\[])\^/g, "$1"), this.source = this.source.replace(e, o), this;
    }
    getRegexp() {
        return new RegExp(this.source, this.flags);
    }
}
const $cdf7e442067abc24$var$xo = /[&<>"']/, $cdf7e442067abc24$var$uo = /[&<>"']/g, $cdf7e442067abc24$var$po = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
}, $cdf7e442067abc24$var$ho = /[<>"']|&(?!#?\w+;)/, $cdf7e442067abc24$var$So = /[<>"']|&(?!#?\w+;)/g;
function $cdf7e442067abc24$var$vo(e, r) {
    if (r) {
        if ($cdf7e442067abc24$var$xo.test(e)) return e.replace($cdf7e442067abc24$var$uo, (e)=>$cdf7e442067abc24$var$po[e]);
    } else if ($cdf7e442067abc24$var$ho.test(e)) return e.replace($cdf7e442067abc24$var$So, (e)=>$cdf7e442067abc24$var$po[e]);
    return e;
}
function $cdf7e442067abc24$var$$o(e) {
    return e.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi, function(e, r) {
        return "colon" === (r = r.toLowerCase()) ? ":" : "#" === r.charAt(0) ? "x" === r.charAt(1) ? String.fromCharCode(parseInt(r.substring(2), 16)) : String.fromCharCode(+r.substring(1)) : "";
    });
}
var $cdf7e442067abc24$var$bo;
($cdf7e442067abc24$var$bo = $cdf7e442067abc24$var$Ze = $cdf7e442067abc24$var$Ze || {})[$cdf7e442067abc24$var$bo.space = 1] = "space", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.text = 2] = "text", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.paragraph = 3] = "paragraph", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.heading = 4] = "heading", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.listStart = 5] = "listStart", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.listEnd = 6] = "listEnd", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.looseItemStart = 7] = "looseItemStart", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.looseItemEnd = 8] = "looseItemEnd", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.listItemStart = 9] = "listItemStart", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.listItemEnd = 10] = "listItemEnd", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.blockquoteStart = 11] = "blockquoteStart", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.blockquoteEnd = 12] = "blockquoteEnd", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.code = 13] = "code", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.table = 14] = "table", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.html = 15] = "html", $cdf7e442067abc24$var$bo[$cdf7e442067abc24$var$bo.hr = 16] = "hr";
class $cdf7e442067abc24$var$Ao {
    gfm = !0;
    tables = !0;
    breaks = !1;
    pedantic = !1;
    sanitize = !1;
    sanitizer;
    mangle = !0;
    smartLists = !1;
    silent = !1;
    highlight;
    langPrefix = "lang-";
    smartypants = !1;
    headerPrefix = "";
    renderer;
    xhtml = !1;
    escape = $cdf7e442067abc24$var$vo;
    unescape = $cdf7e442067abc24$var$$o;
    isNoP;
}
class $cdf7e442067abc24$var$fo {
    options;
    constructor(e){
        this.options = e || $cdf7e442067abc24$var$To.options;
    }
    code(e, r, o, t) {
        this.options.highlight && null != (a = this.options.highlight(e, r)) && a !== e && (o = !0, e = a);
        var a = o ? e : this.options.escape(e, !0);
        return r ? `\n<pre><code class="${this.options.langPrefix + this.options.escape(r, !0)}">${a}\n</code></pre>\n` : `\n<pre><code>${a}\n</code></pre>\n`;
    }
    blockquote(e) {
        return `<blockquote>\n${e}</blockquote>\n`;
    }
    html(e) {
        return e;
    }
    heading(e, r, o) {
        return `<h${r} id="${this.options.headerPrefix + o.toLowerCase().replace(/[^\w]+/g, "-")}">${e}</h${r}>\n`;
    }
    hr() {
        return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
    }
    list(e, r) {
        return `\n<${r = r ? "ol" : "ul"}>\n${e}</${r}>\n`;
    }
    listitem(e) {
        return "<li>" + e + "</li>\n";
    }
    paragraph(e) {
        return "<p>" + e + "</p>\n";
    }
    table(e, r) {
        return `\n<table>\n<thead>\n${e}</thead>\n<tbody>\n${r}</tbody>\n</table>\n`;
    }
    tablerow(e) {
        return "<tr>\n" + e + "</tr>\n";
    }
    tablecell(e, r) {
        var o = r.header ? "th" : "td";
        return (r.align ? "<" + o + ' style="text-align:' + r.align + '">' : "<" + o + ">") + e + "</" + o + ">\n";
    }
    strong(e) {
        return "<strong>" + e + "</strong>";
    }
    em(e) {
        return "<em>" + e + "</em>";
    }
    codespan(e) {
        return "<code>" + e + "</code>";
    }
    br() {
        return this.options.xhtml ? "<br/>" : "<br>";
    }
    del(e) {
        return "<del>" + e + "</del>";
    }
    link(e, r, o) {
        if (this.options.sanitize) {
            let t;
            try {
                t = decodeURIComponent(this.options.unescape(e)).replace(/[^\w:]/g, "").toLowerCase();
            } catch (r) {
                return o;
            }
            if (0 === t.indexOf("javascript:") || 0 === t.indexOf("vbscript:") || 0 === t.indexOf("data:")) return o;
        }
        let t = '<a href="' + e + '"';
        return r && (t += ' title="' + r + '"'), t + ">" + o + "</a>";
    }
    image(e, r, o) {
        let t = '<img src="' + e + '" alt="' + o + '"';
        return r && (t += ' title="' + r + '"'), t + (this.options.xhtml ? "/>" : ">");
    }
    text(e) {
        return e;
    }
}
class $cdf7e442067abc24$var$Mo {
    staticThis;
    links;
    options;
    static rulesBase = null;
    static rulesPedantic = null;
    static rulesGfm = null;
    static rulesBreaks = null;
    rules;
    renderer;
    inLink;
    hasRulesGfm;
    ruleCallbacks;
    constructor(e, r, o = $cdf7e442067abc24$var$To.options, t){
        if (this.staticThis = e, this.links = r, this.options = o, this.renderer = t || this.options.renderer || new $cdf7e442067abc24$var$fo(this.options), !this.links) throw new Error("InlineLexer requires 'links' parameter.");
        this.setRules();
    }
    static output(e, r, o) {
        return new this(this, r, o).output(e);
    }
    static getRulesBase() {
        var e;
        return this.rulesBase || ((e = {
            escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
            autolink: /^<([^ <>]+(@|:\/)[^ <>]+)>/,
            tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^<'">])*?>/,
            link: /^!?\[(inside)\]\(href\)/,
            reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
            nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
            strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
            em: /^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
            code: /^(`+)([\s\S]*?[^`])\1(?!`)/,
            br: /^ {2,}\n(?!\s*$)/,
            text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/,
            _inside: /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/,
            _href: /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/
        }).link = new $cdf7e442067abc24$var$co(e.link).setGroup("inside", e._inside).setGroup("href", e._href).getRegexp(), e.reflink = new $cdf7e442067abc24$var$co(e.reflink).setGroup("inside", e._inside).getRegexp(), this.rulesBase = e);
    }
    static getRulesPedantic() {
        return this.rulesPedantic || (this.rulesPedantic = {
            ...this.getRulesBase(),
            strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
        });
    }
    static getRulesGfm() {
        var e, r, o;
        return this.rulesGfm || (e = this.getRulesBase(), r = new $cdf7e442067abc24$var$co(e.escape).setGroup("])", "~|])").getRegexp(), o = new $cdf7e442067abc24$var$co(e.text).setGroup("]|", "~]|").setGroup("|", "|https?://|").getRegexp(), this.rulesGfm = {
            ...e,
            escape: r,
            url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
            del: /^~~(?=\S)([\s\S]*?\S)~~/,
            text: o
        });
    }
    static getRulesBreaks() {
        var e, r;
        return this.rulesBreaks || (e = this.getRulesGfm(), r = this.getRulesGfm(), this.rulesBreaks = {
            ...r,
            br: new $cdf7e442067abc24$var$co(e.br).setGroup("{2,}", "*").getRegexp(),
            text: new $cdf7e442067abc24$var$co(r.text).setGroup("{2,}", "*").getRegexp()
        });
    }
    setRules() {
        this.options.gfm ? this.options.breaks ? this.rules = this.staticThis.getRulesBreaks() : this.rules = this.staticThis.getRulesGfm() : this.options.pedantic ? this.rules = this.staticThis.getRulesPedantic() : this.rules = this.staticThis.getRulesBase(), this.hasRulesGfm = void 0 !== this.rules.url;
    }
    output(e) {
        let r, o = "";
        for(; e;)if (r = this.rules.escape.exec(e)) e = e.substring(r[0].length), o += r[1];
        else if (r = this.rules.autolink.exec(e)) {
            let t, a;
            e = e.substring(r[0].length), a = "@" === r[2] ? (t = this.options.escape(":" === r[1].charAt(6) ? this.mangle(r[1].substring(7)) : this.mangle(r[1])), this.mangle("mailto:") + t) : t = this.options.escape(r[1]), o += this.renderer.link(a, null, t);
        } else if (!this.inLink && this.hasRulesGfm && (r = this.rules.url.exec(e))) {
            e = e.substring(r[0].length);
            var t = this.options.escape(r[1]);
            o += this.renderer.link(t, null, t);
        } else if (r = this.rules.tag.exec(e)) !this.inLink && /^<a /i.test(r[0]) ? this.inLink = !0 : this.inLink && /^<\/a>/i.test(r[0]) && (this.inLink = !1), e = e.substring(r[0].length), o += this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(r[0]) : this.options.escape(r[0]) : r[0];
        else if (r = this.rules.link.exec(e)) e = e.substring(r[0].length), this.inLink = !0, o += this.outputLink(r, {
            href: r[2],
            title: r[3]
        }), this.inLink = !1;
        else if (r = (r = this.rules.reflink.exec(e)) || this.rules.nolink.exec(e)) {
            e = e.substring(r[0].length);
            t = (r[2] || r[1]).replace(/\s+/g, " ");
            var a = this.links[t.toLowerCase()];
            a && a.href ? (this.inLink = !0, o += this.outputLink(r, a), this.inLink = !1) : (o += r[0].charAt(0), e = r[0].substring(1) + e);
        } else if (r = this.rules.strong.exec(e)) e = e.substring(r[0].length), o += this.renderer.strong(this.output(r[2] || r[1]));
        else if (r = this.rules.em.exec(e)) e = e.substring(r[0].length), o += this.renderer.em(this.output(r[2] || r[1]));
        else if (r = this.rules.code.exec(e)) e = e.substring(r[0].length), o += this.renderer.codespan(this.options.escape(r[2].trim(), !0));
        else if (r = this.rules.br.exec(e)) e = e.substring(r[0].length), o += this.renderer.br();
        else if (this.hasRulesGfm && (r = this.rules.del.exec(e))) e = e.substring(r[0].length), o += this.renderer.del(this.output(r[1]));
        else if (r = this.rules.text.exec(e)) e = e.substring(r[0].length), o += this.renderer.text(this.options.escape(this.smartypants(r[0])));
        else if (e) throw new Error("Infinite loop on byte: " + e.charCodeAt(0));
        return o;
    }
    outputLink(e, r) {
        var o = this.options.escape(r.href);
        r = r.title ? this.options.escape(r.title) : null;
        return "!" !== e[0].charAt(0) ? this.renderer.link(o, r, this.output(e[1])) : this.renderer.image(o, r, this.options.escape(e[1]));
    }
    smartypants(e) {
        return this.options.smartypants ? e.replace(/---/g, "\u2014").replace(/--/g, "\u2013").replace(/(^|[-\u2014/([{"\s])'/g, "$1\u2018").replace(/'/g, "\u2019").replace(/(^|[-\u2014/([{\u2018\s])"/g, "$1\u201C").replace(/"/g, "\u201D").replace(/\.{3}/g, "\u2026") : e;
    }
    mangle(e) {
        if (!this.options.mangle) return e;
        let r = "";
        var o = e.length;
        for(let t = 0; t < o; t++){
            let o;
            .5 < Math.random() && (o = "x" + e.charCodeAt(t).toString(16)), r += "&#" + o + ";";
        }
        return r;
    }
}
class $cdf7e442067abc24$var$Po {
    simpleRenderers = [];
    tokens;
    token;
    inlineLexer;
    options;
    renderer;
    line = 0;
    constructor(e){
        this.tokens = [], this.token = null, this.options = e || $cdf7e442067abc24$var$To.options, this.renderer = this.options.renderer || new $cdf7e442067abc24$var$fo(this.options);
    }
    static parse(e, r, o) {
        return new this(o).parse(r, e);
    }
    parse(e, r) {
        this.inlineLexer = new $cdf7e442067abc24$var$Mo($cdf7e442067abc24$var$Mo, e, this.options, this.renderer), this.tokens = r.reverse();
        let o = "";
        for(; this.next();)o += this.tok();
        return o;
    }
    debug(e, r) {
        this.inlineLexer = new $cdf7e442067abc24$var$Mo($cdf7e442067abc24$var$Mo, e, this.options, this.renderer), this.tokens = r.reverse();
        let o = "";
        for(; this.next();){
            var t = this.tok();
            this.token.line = this.line += t.split("\n").length - 1, o += t;
        }
        return o;
    }
    next() {
        return this.token = this.tokens.pop();
    }
    getNextElement() {
        return this.tokens[this.tokens.length - 1];
    }
    parseText() {
        let e = this.token.text;
        for(var r; (r = this.getNextElement()) && r.type == $cdf7e442067abc24$var$Ze.text;)e += "\n" + this.next().text;
        return this.inlineLexer.output(e);
    }
    tok() {
        switch(this.token.type){
            case $cdf7e442067abc24$var$Ze.space:
                return "";
            case $cdf7e442067abc24$var$Ze.paragraph:
                return this.renderer.paragraph(this.inlineLexer.output(this.token.text));
            case $cdf7e442067abc24$var$Ze.text:
                return this.options.isNoP ? this.parseText() : this.renderer.paragraph(this.parseText());
            case $cdf7e442067abc24$var$Ze.heading:
                return this.renderer.heading(this.inlineLexer.output(this.token.text), this.token.depth, this.token.text);
            case $cdf7e442067abc24$var$Ze.listStart:
                {
                    let r = "";
                    for(var e = this.token.ordered; this.next().type != $cdf7e442067abc24$var$Ze.listEnd;)r += this.tok();
                    return this.renderer.list(r, e);
                }
            case $cdf7e442067abc24$var$Ze.listItemStart:
                {
                    let e = "";
                    for(; this.next().type != $cdf7e442067abc24$var$Ze.listItemEnd;)e += this.token.type == $cdf7e442067abc24$var$Ze.text ? this.parseText() : this.tok();
                    return this.renderer.listitem(e);
                }
            case $cdf7e442067abc24$var$Ze.looseItemStart:
                {
                    let e = "";
                    for(; this.next().type != $cdf7e442067abc24$var$Ze.listItemEnd;)e += this.tok();
                    return this.renderer.listitem(e);
                }
            case $cdf7e442067abc24$var$Ze.code:
                return this.renderer.code(this.token.text, this.token.lang, this.token.escaped, this.token.meta);
            case $cdf7e442067abc24$var$Ze.table:
                {
                    e = "";
                    let t, a = "";
                    t = "";
                    for(let e = 0; e < this.token.header.length; e++){
                        var r = {
                            header: !0,
                            align: this.token.align[e]
                        }, o = this.inlineLexer.output(this.token.header[e]);
                        t += this.renderer.tablecell(o, r);
                    }
                    e += this.renderer.tablerow(t);
                    for (const e of this.token.cells){
                        t = "";
                        for(let r = 0; r < e.length; r++)t += this.renderer.tablecell(this.inlineLexer.output(e[r]), {
                            header: !1,
                            align: this.token.align[r]
                        });
                        a += this.renderer.tablerow(t);
                    }
                    return this.renderer.table(e, a);
                }
            case $cdf7e442067abc24$var$Ze.blockquoteStart:
                {
                    let e = "";
                    for(; this.next().type != $cdf7e442067abc24$var$Ze.blockquoteEnd;)e += this.tok();
                    return this.renderer.blockquote(e);
                }
            case $cdf7e442067abc24$var$Ze.hr:
                return this.renderer.hr();
            case $cdf7e442067abc24$var$Ze.html:
                return e = this.token.pre || this.options.pedantic ? this.token.text : this.inlineLexer.output(this.token.text), this.renderer.html(e);
            default:
                if (this.simpleRenderers.length) {
                    for(let e = 0; e < this.simpleRenderers.length; e++)if (this.token.type == "simpleRule" + (e + 1)) return this.simpleRenderers[e].call(this.renderer, this.token.execArr);
                }
                if (e = `Token with "${this.token.type}" type was not found.`, !this.options.silent) throw new Error(e);
                console.log(e);
        }
    }
}
class $cdf7e442067abc24$var$To {
    static options = new $cdf7e442067abc24$var$Ao;
    static simpleRenderers = [];
    static setOptions(e) {
        return Object.assign(this.options, e), this;
    }
    static setBlockRule(e, r = ()=>"") {
        return $cdf7e442067abc24$var$_o.simpleRules.push(e), this.simpleRenderers.push(r), this;
    }
    static parse(e, r) {
        try {
            r = {
                ...this.options,
                ...r
            };
            var { tokens: o, links: t } = this.callBlockLexer(e, r);
            return this.callParser(o, t, r);
        } catch (e) {
            return this.callMe(e);
        }
    }
    static debug(e, r = this.options) {
        var { tokens: e, links: o } = this.callBlockLexer(e, r);
        let t = e.slice();
        return (r = new $cdf7e442067abc24$var$Po(r)).simpleRenderers = this.simpleRenderers, r = r.debug(o, e), {
            tokens: t = t.map((e)=>{
                e.type = $cdf7e442067abc24$var$Ze[e.type] || e.type;
                var r = e.line;
                return delete e.line, r ? {
                    line: r,
                    ...e
                } : e;
            }),
            links: o,
            result: r
        };
    }
    static callBlockLexer(e = "", r) {
        if ("string" != typeof e) throw new Error(`Expected that the 'src' parameter would have a 'string' type, got '${typeof e}'`);
        return e = e.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    ").replace(/\u00a0/g, " ").replace(/\u2424/g, "\n").replace(/^ +$/gm, ""), $cdf7e442067abc24$var$_o.lex(e, r, !0);
    }
    static callParser(e, r, o) {
        var t;
        return this.simpleRenderers.length ? ((t = new $cdf7e442067abc24$var$Po(o)).simpleRenderers = this.simpleRenderers, t.parse(r, e)) : $cdf7e442067abc24$var$Po.parse(e, r, o);
    }
    static callMe(e) {
        if (e.message += "\nPlease report this to https://github.com/ts-stack/markdown", this.options.silent) return "<p>An error occured:</p><pre>" + this.options.escape(e.message + "", !0) + "</pre>";
        throw e;
    }
}
class $cdf7e442067abc24$var$_o {
    staticThis;
    static simpleRules = [];
    static rulesBase = null;
    static rulesGfm = null;
    static rulesTables = null;
    rules;
    options;
    links = {};
    tokens = [];
    hasRulesGfm;
    hasRulesTables;
    constructor(e, r){
        this.staticThis = e, this.options = r || $cdf7e442067abc24$var$To.options, this.setRules();
    }
    static lex(e, r, o, t) {
        return new this(this, r).getTokens(e, o, t);
    }
    static getRulesBase() {
        var e, r;
        return this.rulesBase || ((e = {
            newline: /^\n+/,
            code: /^( {4}[^\n]+\n*)+/,
            hr: /^( *[-*_]){3,} *(?:\n+|$)/,
            heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
            lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
            blockquote: /^( *>[^\n]+(\n[^\n]+)*\n*)+/,
            list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
            html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
            def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
            paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
            text: /^[^\n]+/,
            bullet: /(?:[*+-]|\d+\.)/,
            item: /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/
        }).item = new $cdf7e442067abc24$var$co(e.item, "gm").setGroup(/bull/g, e.bullet).getRegexp(), e.list = new $cdf7e442067abc24$var$co(e.list).setGroup(/bull/g, e.bullet).setGroup("hr", "\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))").setGroup("def", "\\n+(?=" + e.def.source + ")").getRegexp(), r = "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b", e.html = new $cdf7e442067abc24$var$co(e.html).setGroup("comment", /<!--[\s\S]*?-->/).setGroup("closed", /<(tag)[\s\S]+?<\/\1>/).setGroup("closing", /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/).setGroup(/tag/g, r).getRegexp(), e.paragraph = new $cdf7e442067abc24$var$co(e.paragraph).setGroup("hr", e.hr).setGroup("heading", e.heading).setGroup("lheading", e.lheading).setGroup("blockquote", e.blockquote).setGroup("tag", "<" + r).setGroup("def", e.def).getRegexp(), this.rulesBase = e);
    }
    static getRulesGfm() {
        var e, r, o, t;
        return this.rulesGfm || (o = (r = {
            ...e = this.getRulesBase(),
            fences: /^ *(`{3,}|~{3,})[ \.]*((\S+)? *[^\n]*)\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
            paragraph: /^/,
            heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
        }).fences.source.replace("\\1", "\\2"), t = e.list.source.replace("\\1", "\\3"), r.paragraph = new $cdf7e442067abc24$var$co(e.paragraph).setGroup("(?!", `(?!${o}|${t}|`).getRegexp(), this.rulesGfm = r);
    }
    static getRulesTable() {
        return this.rulesTables || (this.rulesTables = {
            ...this.getRulesGfm(),
            nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
            table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
        });
    }
    setRules() {
        this.options.gfm ? this.options.tables ? this.rules = this.staticThis.getRulesTable() : this.rules = this.staticThis.getRulesGfm() : this.rules = this.staticThis.getRulesBase(), this.hasRulesGfm = void 0 !== this.rules.fences, this.hasRulesTables = void 0 !== this.rules.table;
    }
    getTokens(e, r, o) {
        let t, a = e;
        e: for(; a;)if ((t = this.rules.newline.exec(a)) && (a = a.substring(t[0].length), 1 < t[0].length) && this.tokens.push({
            type: $cdf7e442067abc24$var$Ze.space
        }), t = this.rules.code.exec(a)) {
            a = a.substring(t[0].length);
            var l = t[0].replace(/^ {4}/gm, "");
            this.tokens.push({
                type: $cdf7e442067abc24$var$Ze.code,
                text: this.options.pedantic ? l : l.replace(/\n+$/, "")
            });
        } else if (this.hasRulesGfm && (t = this.rules.fences.exec(a))) a = a.substring(t[0].length), this.tokens.push({
            type: $cdf7e442067abc24$var$Ze.code,
            meta: t[2],
            lang: t[3],
            text: t[4] || ""
        });
        else if (t = this.rules.heading.exec(a)) a = a.substring(t[0].length), this.tokens.push({
            type: $cdf7e442067abc24$var$Ze.heading,
            depth: t[1].length,
            text: t[2]
        });
        else if (r && this.hasRulesTables && (t = this.rules.nptable.exec(a))) {
            a = a.substring(t[0].length);
            var i = {
                type: $cdf7e442067abc24$var$Ze.table,
                header: t[1].replace(/^ *| *\| *$/g, "").split(/ *\| */),
                align: t[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                cells: []
            };
            for(let e = 0; e < i.align.length; e++)/^ *-+: *$/.test(i.align[e]) ? i.align[e] = "right" : /^ *:-+: *$/.test(i.align[e]) ? i.align[e] = "center" : /^ *:-+ *$/.test(i.align[e]) ? i.align[e] = "left" : i.align[e] = null;
            var n = t[3].replace(/\n$/, "").split("\n");
            for(let e = 0; e < n.length; e++)i.cells[e] = n[e].split(/ *\| */);
            this.tokens.push(i);
        } else if (t = this.rules.lheading.exec(a)) a = a.substring(t[0].length), this.tokens.push({
            type: $cdf7e442067abc24$var$Ze.heading,
            depth: "=" === t[2] ? 1 : 2,
            text: t[1]
        });
        else if (t = this.rules.hr.exec(a)) a = a.substring(t[0].length), this.tokens.push({
            type: $cdf7e442067abc24$var$Ze.hr
        });
        else if (t = this.rules.blockquote.exec(a)) a = a.substring(t[0].length), this.tokens.push({
            type: $cdf7e442067abc24$var$Ze.blockquoteStart
        }), l = t[0].replace(/^ *> ?/gm, ""), this.getTokens(l), this.tokens.push({
            type: $cdf7e442067abc24$var$Ze.blockquoteEnd
        });
        else if (t = this.rules.list.exec(a)) {
            a = a.substring(t[0].length);
            var d, s = t[2], m = (this.tokens.push({
                type: $cdf7e442067abc24$var$Ze.listStart,
                ordered: 1 < s.length
            }), t[0].match(this.rules.item)), g = m.length;
            let e, r = !1;
            for(let t = 0; t < g; t++){
                let l = m[t];
                d = l.length, -1 !== (l = l.replace(/^ *([*+-]|\d+\.) +/, "")).indexOf("\n ") && (d -= l.length, l = this.options.pedantic ? l.replace(/^ {1,4}/gm, "") : l.replace(new RegExp("^ {1," + d + "}", "gm"), "")), !this.options.smartLists || t === g - 1 || s === (d = this.staticThis.getRulesBase().bullet.exec(m[t + 1])[0]) || 1 < s.length && 1 < d.length || (a = m.slice(t + 1).join("\n") + a, t = g - 1), e = r || /\n\n(?!\s*$)/.test(l), t !== g - 1 && (r = "\n" === l.charAt(l.length - 1), e = e || r), this.tokens.push({
                    type: e ? $cdf7e442067abc24$var$Ze.looseItemStart : $cdf7e442067abc24$var$Ze.listItemStart
                }), this.getTokens(l, !1, o), this.tokens.push({
                    type: $cdf7e442067abc24$var$Ze.listItemEnd
                });
            }
            this.tokens.push({
                type: $cdf7e442067abc24$var$Ze.listEnd
            });
        } else if (t = this.rules.html.exec(a)) {
            a = a.substring(t[0].length);
            var c = t[1];
            this.tokens.push({
                type: this.options.sanitize ? $cdf7e442067abc24$var$Ze.paragraph : $cdf7e442067abc24$var$Ze.html,
                pre: !this.options.sanitizer && ("pre" === c || "script" === c || "style" === c),
                text: t[0]
            });
        } else if (r && (t = this.rules.def.exec(a))) a = a.substring(t[0].length), this.links[t[1].toLowerCase()] = {
            href: t[2],
            title: t[3]
        };
        else if (r && this.hasRulesTables && (t = this.rules.table.exec(a))) {
            a = a.substring(t[0].length);
            var x = {
                type: $cdf7e442067abc24$var$Ze.table,
                header: t[1].replace(/^ *| *\| *$/g, "").split(/ *\| */),
                align: t[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                cells: []
            };
            for(let e = 0; e < x.align.length; e++)/^ *-+: *$/.test(x.align[e]) ? x.align[e] = "right" : /^ *:-+: *$/.test(x.align[e]) ? x.align[e] = "center" : /^ *:-+ *$/.test(x.align[e]) ? x.align[e] = "left" : x.align[e] = null;
            var u = t[3].replace(/(?: *\| *)?\n$/, "").split("\n");
            for(let e = 0; e < u.length; e++)x.cells[e] = u[e].replace(/^ *\| *| *\| *$/g, "").split(/ *\| */);
            this.tokens.push(x);
        } else {
            if (this.staticThis.simpleRules.length) {
                var p = this.staticThis.simpleRules;
                for(let e = 0; e < p.length; e++)if (t = p[e].exec(a)) {
                    a = a.substring(t[0].length);
                    var h = "simpleRule" + (e + 1);
                    this.tokens.push({
                        type: h,
                        execArr: t
                    });
                    continue e;
                }
            }
            if (r && (t = this.rules.paragraph.exec(a))) a = a.substring(t[0].length), "\n" === t[1].slice(-1) ? this.tokens.push({
                type: $cdf7e442067abc24$var$Ze.paragraph,
                text: t[1].slice(0, -1)
            }) : this.tokens.push({
                type: 0 < this.tokens.length ? $cdf7e442067abc24$var$Ze.paragraph : $cdf7e442067abc24$var$Ze.text,
                text: t[1]
            });
            else if (t = this.rules.text.exec(a)) a = a.substring(t[0].length), this.tokens.push({
                type: $cdf7e442067abc24$var$Ze.text,
                text: t[0]
            });
            else if (a) throw new Error("Infinite loop on byte: " + a.charCodeAt(0) + `, near text '${a.slice(0, 30)}...'`);
        }
        return {
            tokens: this.tokens,
            links: this.links
        };
    }
}
const $cdf7e442067abc24$var$yo = $cdf7e442067abc24$var$ge('<div class="flex items-center justify-center max-w-[128px] mr-[10px] p-0 m-0"><img class="w-full h-full bg-cover">'), $cdf7e442067abc24$var$wo = $cdf7e442067abc24$var$ge('<audio class="w-[200px] h-10 block bg-cover bg-center rounded-none text-transparent" controls>Your browser does not support the &lt;audio&gt; tag.<source>'), $cdf7e442067abc24$var$Go = $cdf7e442067abc24$var$ge('<div class="inline-flex items-center h-12 max-w-max p-2 mr-1 flex-none bg-transparent border border-gray-300 rounded-md"><span class="ml-1.5 text-inherit">'), $cdf7e442067abc24$var$Lo = $cdf7e442067abc24$var$ge('<div class="flex justify-end mb-2 items-end guest-container"><div class="max-w-full flex flex-col justify-center items-start chatbot-guest-bubble px-4 py-2 gap-2 mr-2" data-testid="guest-bubble">'), $cdf7e442067abc24$var$Co = $cdf7e442067abc24$var$ge('<div class="flex flex-col items-start flex-wrap w-full gap-2">'), $cdf7e442067abc24$var$Bo = $cdf7e442067abc24$var$ge('<span class="mr-2 whitespace-pre-wrap">'), $cdf7e442067abc24$var$Eo = "#ffffff", $cdf7e442067abc24$var$No = (e)=>{
    $cdf7e442067abc24$var$To.setOptions({
        isNoP: !0,
        sanitize: void 0 === e.renderHTML || !e.renderHTML
    });
    const r = (r)=>{
        if (r) {
            r.innerHTML = $cdf7e442067abc24$var$To.parse(e.message.message);
            const o = e.textColor ?? $cdf7e442067abc24$var$Eo;
            r.querySelectorAll("a, h1, h2, h3, h4, h5, h6, strong, em, blockquote, li").forEach((e)=>{
                e.style.color = o;
            }), r.querySelectorAll("pre").forEach((e)=>{
                e.style.color = "#FFFFFF", e.querySelectorAll("code").forEach((e)=>{
                    e.style.color = "#FFFFFF";
                });
            }), r.querySelectorAll("code:not(pre code)").forEach((e)=>{
                e.style.color = "#4CAF50";
            }), r.querySelectorAll("a").forEach((e)=>{
                e.target = "_blank";
            });
        }
    };
    {
        const o = $cdf7e442067abc24$var$Lo(), t = o.firstChild;
        return o.style.setProperty("margin-left", "50px"), t.style.setProperty("border-radius", "6px"), $cdf7e442067abc24$var$$e(t, (()=>{
            const r = $cdf7e442067abc24$var$T(()=>!!(e.message.fileUploads && 0 < e.message.fileUploads.length));
            return ()=>{
                var o;
                return r() && ($cdf7e442067abc24$var$$e(o = $cdf7e442067abc24$var$Co(), $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                    get each () {
                        return e.message.fileUploads;
                    },
                    children: (r)=>{
                        var o, t = r;
                        if (t?.mime?.startsWith("image/")) {
                            var a = `${e.apiHost}/api/v1/get-upload-file?chatflowId=${e.chatflowid}&chatId=${e.chatId}&fileName=` + t.name;
                            const r = t.data ?? a;
                            return $cdf7e442067abc24$var$xe((a = $cdf7e442067abc24$var$yo()).firstChild, "src", r), a;
                        }
                        if (t?.mime?.startsWith("audio/")) {
                            a = `${e.apiHost}/api/v1/get-upload-file?chatflowId=${e.chatflowid}&chatId=${e.chatId}&fileName=` + t.name;
                            const r = t.data ?? a;
                            {
                                const e = $cdf7e442067abc24$var$wo(), o = e.firstChild.nextSibling;
                                return $cdf7e442067abc24$var$xe(o, "src", r), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(o, "type", t.mime)), e;
                            }
                        }
                        return o = (r = $cdf7e442067abc24$var$Go()).firstChild, $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$_r, {
                            get color () {
                                return e.textColor ?? $cdf7e442067abc24$var$Eo;
                            }
                        }), o), $cdf7e442067abc24$var$$e(o, ()=>t.name), r;
                    }
                })), o);
            };
        })(), null), $cdf7e442067abc24$var$$e(t, (()=>{
            const o = $cdf7e442067abc24$var$T(()=>!!e.message.message);
            return ()=>o() && (()=>{
                    const o = $cdf7e442067abc24$var$Bo();
                    return $cdf7e442067abc24$var$ve(r, o), $cdf7e442067abc24$var$M(()=>(e.fontSize && e.fontSize, o.style.setProperty("font-size", e.fontSize ? e.fontSize + "px" : "16px"))), o;
                })();
        })(), null), $cdf7e442067abc24$var$$e(o, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return e.showAvatar;
            },
            get children () {
                return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$go, {
                    get initialAvatarSrc () {
                        return e.avatarSrc;
                    }
                });
            }
        }), null), $cdf7e442067abc24$var$M((r)=>{
            var o = e.backgroundColor ?? "#3B81F6", a = e.textColor ?? $cdf7e442067abc24$var$Eo;
            return o !== r._v$ && (null != (r._v$ = o) ? t.style.setProperty("background-color", o) : t.style.removeProperty("background-color")), a !== r._v$2 && (null != (r._v$2 = a) ? t.style.setProperty("color", a) : t.style.removeProperty("color")), r;
        }, {
            _v$: void 0,
            _v$2: void 0
        }), o;
    }
}, $cdf7e442067abc24$var$Oo = $cdf7e442067abc24$var$ge("<button>"), $cdf7e442067abc24$var$Io = $cdf7e442067abc24$var$ge('<button type="submit">'), $cdf7e442067abc24$var$ko = "#3B81F6", $cdf7e442067abc24$var$Xo = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Oo(), $cdf7e442067abc24$var$q({
        get disabled () {
            return e.isDisabled || e.isLoading;
        }
    }, e, {
        get class () {
            return "p-2 justify-center font-semibold text-white focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75 chatbot-button " + e.class;
        },
        style: {
            background: "transparent",
            border: "none"
        },
        title: "Copy to clipboard"
    }), !1, !0), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return !e.isLoading;
        },
        get fallback () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Or, {
                class: "text-white"
            });
        },
        get children () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ar, {
                get color () {
                    return e.feedbackColor ?? $cdf7e442067abc24$var$ko;
                },
                get class () {
                    return "send-icon flex " + (e.disableIcon ? "hidden" : "");
                }
            });
        }
    })), r;
}, $cdf7e442067abc24$var$Do = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Io(), $cdf7e442067abc24$var$q({
        get disabled () {
            return e.isDisabled || e.isLoading;
        }
    }, e, {
        get class () {
            return "p-2 justify-center font-semibold text-white focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75 chatbot-button " + e.class;
        },
        style: {
            background: "transparent",
            border: "none"
        },
        title: "Thumbs Up"
    }), !1, !0), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return !e.isLoading;
        },
        get fallback () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Or, {
                class: "text-white"
            });
        },
        get children () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$dr, {
                get color () {
                    return e.feedbackColor ?? $cdf7e442067abc24$var$ko;
                },
                get class () {
                    return "send-icon flex " + (e.disableIcon ? "hidden" : "");
                }
            });
        }
    })), r;
}, $cdf7e442067abc24$var$Ro = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$Io(), $cdf7e442067abc24$var$q({
        get disabled () {
            return e.isDisabled || e.isLoading;
        }
    }, e, {
        get class () {
            return "p-2 justify-center font-semibold text-white focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75 chatbot-button " + e.class;
        },
        style: {
            background: "transparent",
            border: "none"
        },
        title: "Thumbs Down"
    }), !1, !0), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return !e.isLoading;
        },
        get fallback () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Or, {
                class: "text-white"
            });
        },
        get children () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ir, {
                get color () {
                    return e.feedbackColor ?? $cdf7e442067abc24$var$ko;
                },
                get class () {
                    return "send-icon flex " + (e.disableIcon ? "hidden" : "");
                }
            });
        }
    })), r;
}, $cdf7e442067abc24$var$Fo = $cdf7e442067abc24$var$ge('<button type="button">'), $cdf7e442067abc24$var$Vo = $cdf7e442067abc24$var$ge('<div class="animate-spin rounded-full border-2 border-current border-t-transparent">'), $cdf7e442067abc24$var$Ho = "#3B81F6", $cdf7e442067abc24$var$Uo = (e)=>{
    const r = (r)=>{
        r.preventDefault(), e.isLoading || e.onClick();
    };
    {
        const o = $cdf7e442067abc24$var$Fo();
        return o.$$click = r, $cdf7e442067abc24$var$$e(o, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return !e.isLoading;
            },
            get fallback () {
                var e1;
                return (e1 = $cdf7e442067abc24$var$Vo()).style.setProperty("width", "16px"), e1.style.setProperty("height", "16px"), e1;
            },
            get children () {
                return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                    get when () {
                        return !e.isPlaying;
                    },
                    get fallback () {
                        return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$cr, {
                            color: "red"
                        });
                    },
                    get children () {
                        return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Lr, {
                            get color () {
                                return e.isPlaying ? "white" : e.feedbackColor ?? $cdf7e442067abc24$var$Ho;
                            }
                        });
                    }
                });
            }
        })), $cdf7e442067abc24$var$M((r)=>{
            var t = "py-2 px-2 justify-center font-semibold focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed transition-all filter hover:brightness-90 active:brightness-75 " + (e.class ?? ""), a = (a = e.feedbackColor ?? $cdf7e442067abc24$var$Ho, e.isPlaying ? {
                "background-color": "transparent",
                color: a,
                border: "none",
                "border-radius": "4px"
            } : {
                "background-color": "transparent",
                border: "none",
                color: a
            }), l = e.isLoading, i = e.isLoading ? "Loading audio..." : e.isPlaying ? "Stop audio" : "Play audio";
            return t !== r._v$ && $cdf7e442067abc24$var$ue(o, r._v$ = t), r._v$2 = $cdf7e442067abc24$var$he(o, a, r._v$2), l !== r._v$3 && (o.disabled = r._v$3 = l), i !== r._v$4 && $cdf7e442067abc24$var$xe(o, "title", r._v$4 = i), r;
        }, {
            _v$: void 0,
            _v$2: void 0,
            _v$3: void 0,
            _v$4: void 0
        }), o;
    }
}, $cdf7e442067abc24$var$Ko = ($cdf7e442067abc24$var$ce([
    "click"
]), $cdf7e442067abc24$var$ge('<div class="flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[1002] outline-none focus:outline-none justify-center items-center"><div class="relative w-full my-6 max-w-3xl mx-4"><div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none"><div class="flex items-center justify-between p-5 border-b border-solid border-blueGray-200 rounded-t"><span class="whitespace-pre-wrap font-semibold max-w-full">Provide additional feedback</span><button class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none" type="button"><span class="bg-transparent block outline-none focus:outline-none"><svg xmlns="http://www.w3.org/2000/svg" class="text-black h-6 w-6" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg></span></button></div><div class="relative p-6 flex-auto"><textarea rows="4" class="block p-2.5 rounded-lg border focus:ring-blue-500 focus:border-blue-500 bg-transparent flex-1 w-full feedback-input disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 font-normal" placeholder="What do you think of the response?"></textarea></div><div class="flex items-center justify-end p-4 border-t border-solid border-blueGray-200 rounded-b"><button class="bg-emerald-500 text-white active:bg-emerald-600 font-bold text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">Submit Feedback')), $cdf7e442067abc24$var$Wo = $cdf7e442067abc24$var$ge('<div class="flex opacity-25 fixed inset-0 z-[1001] bg-black">'), $cdf7e442067abc24$var$Zo = "#303235", $cdf7e442067abc24$var$Qo = (e)=>{
    const [r, o] = $cdf7e442067abc24$var$f("");
    let t;
    const a = ()=>{
        "" !== r() && t?.reportValidity() && e.onSubmit(r()), o("");
    }, l = ()=>{
        e.onClose();
    };
    return [
        (()=>{
            const i = $cdf7e442067abc24$var$Ko(), n = i.firstChild.firstChild, d = n.firstChild, s = d.firstChild.nextSibling, m = d.nextSibling, g = m.firstChild, c = m.nextSibling.firstChild;
            d.style.setProperty("border", "1px solid #eeeeee"), s.$$click = l;
            return "function" == typeof t ? $cdf7e442067abc24$var$ve(t, g) : t = g, g.$$input = (e)=>(e = e.currentTarget.value, o(e)), g.style.setProperty("border", "1px solid #eeeeee"), c.$$click = a, $cdf7e442067abc24$var$M((r)=>{
                var o = e.backgroundColor ?? "#ffffff", t = e.textColor ?? $cdf7e442067abc24$var$Zo, a = e.textColor ?? $cdf7e442067abc24$var$Zo;
                return o !== r._v$ && (null != (r._v$ = o) ? n.style.setProperty("background-color", o) : n.style.removeProperty("background-color")), t !== r._v$2 && (null != (r._v$2 = t) ? n.style.setProperty("color", t) : n.style.removeProperty("color")), a !== r._v$3 && (null != (r._v$3 = a) ? g.style.setProperty("color", a) : g.style.removeProperty("color")), r;
            }, {
                _v$: void 0,
                _v$2: void 0,
                _v$3: void 0
            }), $cdf7e442067abc24$var$M(()=>g.value = r()), i;
        })(),
        $cdf7e442067abc24$var$Wo()
    ];
};
$cdf7e442067abc24$var$ce([
    "click",
    "input"
]);
var $cdf7e442067abc24$var$zo = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
var $cdf7e442067abc24$var$Yo, $cdf7e442067abc24$var$Jo, $cdf7e442067abc24$var$jo = {
    exports: {}
}, $cdf7e442067abc24$var$qo = ($cdf7e442067abc24$var$Yo = $cdf7e442067abc24$var$jo, $cdf7e442067abc24$var$Jo = $cdf7e442067abc24$var$jo.exports, (function() {
    var e, r, o, t, a = "Expected a function", l = "__lodash_hash_undefined__", i = "__lodash_placeholder__", n = 128, d = 9007199254740991, s = NaN, m = 4294967295, g = [
        [
            "ary",
            n
        ],
        [
            "bind",
            1
        ],
        [
            "bindKey",
            2
        ],
        [
            "curry",
            8
        ],
        [
            "curryRight",
            16
        ],
        [
            "flip",
            512
        ],
        [
            "partial",
            32
        ],
        [
            "partialRight",
            64
        ],
        [
            "rearg",
            256
        ]
    ], c = "[object Arguments]", x = "[object Array]", u = "[object Boolean]", p = "[object Date]", h = "[object Error]", S = "[object Function]", v = "[object GeneratorFunction]", $ = "[object Map]", b = "[object Number]", A = "[object Object]", f = "[object Promise]", M = "[object RegExp]", P = "[object Set]", T = "[object String]", _ = "[object Symbol]", y = "[object WeakMap]", w = "[object ArrayBuffer]", G = "[object DataView]", L = "[object Float32Array]", C = "[object Float64Array]", B = "[object Int8Array]", E = "[object Int16Array]", N = "[object Int32Array]", O = "[object Uint8Array]", I = "[object Uint8ClampedArray]", k = "[object Uint16Array]", X = "[object Uint32Array]", D = /\b__p \+= '';/g, R = /\b(__p \+=) '' \+/g, F = /(__e\(.*?\)|\b__t\)) \+\n'';/g, V = /&(?:amp|lt|gt|quot|#39);/g, H = /[&<>"']/g, U = RegExp(V.source), K = RegExp(H.source), W = /<%-([\s\S]+?)%>/g, Z = /<%([\s\S]+?)%>/g, Q = /<%=([\s\S]+?)%>/g, z = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Y = /^\w*$/, J = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, j = /[\\^$.*+?()[\]{}|]/g, q = RegExp(j.source), ee = /^\s+/, re = /\s/, oe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, te = /\{\n\/\* \[wrapped with (.+)\] \*/, ae = /,? & /, le = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ie = /[()=,{}\[\]\/\s]/, ne = /\\(\\)?/g, de = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, se = /\w*$/, me = /^[-+]0x[0-9a-f]+$/i, ge = /^0b[01]+$/i, ce = /^\[object .+?Constructor\]$/, xe = /^0o[0-7]+$/i, ue = /^(?:0|[1-9]\d*)$/, pe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, he = /($^)/, Se = /['\n\r\u2028\u2029\\]/g, ve = "\\ud800-\\udfff", $e = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", be = "\\ufe0e\\ufe0f", Ae = "[" + ve + "]", fe = "[" + (we = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000") + "]", Me = "[" + $e + "]", Pe = "[" + (r = "\\u2700-\\u27bf") + "]", Te = "[" + (We = "a-z\\xdf-\\xf6\\xf8-\\xff") + "]", _e = "\\u200d", ye = "(?:" + Te + "|" + (we = "[^" + ve + we + "\\d+" + r + We + (o = "A-Z\\xc0-\\xd6\\xd8-\\xde") + "]") + ")", we = "(?:" + (o = "[" + o + "]") + "|" + we + ")", Ge = "(?:['\u2019](?:d|ll|m|re|s|t|ve))?", Le = "(?:['\u2019](?:D|LL|M|RE|S|T|VE))?", Ce = (Ce = "[" + be + "]?") + (Be = "(?:" + Me + "|" + (r = "\\ud83c[\\udffb-\\udfff]") + ")?") + "(?:" + _e + "(?:" + [
        We = "[^" + ve + "]",
        Ze = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        t = "[\\ud800-\\udbff][\\udc00-\\udfff]"
    ].join("|") + ")" + Ce + Be + ")*", Be = "(?:" + [
        Pe,
        Ze,
        t
    ].join("|") + ")" + Ce, Ee = (Pe = "(?:" + [
        We + Me + "?",
        Me,
        Ze,
        t,
        Ae
    ].join("|") + ")", RegExp("['\u2019]", "g")), Ne = RegExp(Me, "g"), Oe = RegExp(r + "(?=" + r + ")|" + Pe + Ce, "g"), Ie = RegExp([
        o + "?" + Te + "+" + Ge + "(?=" + [
            fe,
            o,
            "$"
        ].join("|") + ")",
        we + "+" + Le + "(?=" + [
            fe,
            o + ye,
            "$"
        ].join("|") + ")",
        o + "?" + ye + "+" + Ge,
        o + "+" + Le,
        "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
        "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
        "\\d+",
        Be
    ].join("|"), "g"), ke = RegExp("[" + _e + ve + $e + be + "]"), Xe = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, De = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ], Re = -1, Fe = {}, Ve = (Fe[L] = Fe[C] = Fe[B] = Fe[E] = Fe[N] = Fe[O] = Fe[I] = Fe[k] = Fe[X] = !0, Fe[c] = Fe[x] = Fe[w] = Fe[u] = Fe[G] = Fe[p] = Fe[h] = Fe[S] = Fe[$] = Fe[b] = Fe[A] = Fe[M] = Fe[P] = Fe[T] = Fe[y] = !1, {}), He = (Ve[c] = Ve[x] = Ve[w] = Ve[G] = Ve[u] = Ve[p] = Ve[L] = Ve[C] = Ve[B] = Ve[E] = Ve[N] = Ve[$] = Ve[b] = Ve[A] = Ve[M] = Ve[P] = Ve[T] = Ve[_] = Ve[O] = Ve[I] = Ve[k] = Ve[X] = !0, Ve[h] = Ve[S] = Ve[y] = !1, {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    }), Ue = parseFloat, Ke = parseInt, We = "object" == typeof $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.Object === Object && $cdf7e442067abc24$var$zo, Ze = "object" == typeof self && self && self.Object === Object && self, Qe = We || Ze || Function("return this")(), ze = (t = $cdf7e442067abc24$var$Jo && !$cdf7e442067abc24$var$Jo.nodeType && $cdf7e442067abc24$var$Jo) && $cdf7e442067abc24$var$Yo && !$cdf7e442067abc24$var$Yo.nodeType && $cdf7e442067abc24$var$Yo, Ye = ze && ze.exports === t, Je = Ye && We.process, je = (Ae = function() {
        try {
            var e = ze && ze.require && ze.require("util").types;
            return e || Je && Je.binding && Je.binding("util");
        } catch (e) {}
    }(), Ae && Ae.isArrayBuffer), qe = Ae && Ae.isDate, er = Ae && Ae.isMap, rr = Ae && Ae.isRegExp, or = Ae && Ae.isSet, tr = Ae && Ae.isTypedArray;
    function ar(e, r, o) {
        switch(o.length){
            case 0:
                return e.call(r);
            case 1:
                return e.call(r, o[0]);
            case 2:
                return e.call(r, o[0], o[1]);
            case 3:
                return e.call(r, o[0], o[1], o[2]);
        }
        return e.apply(r, o);
    }
    function lr(e, r, o, t) {
        for(var a = -1, l = null == e ? 0 : e.length; ++a < l;){
            var i = e[a];
            r(t, i, o(i), e);
        }
        return t;
    }
    function ir(e, r) {
        for(var o = -1, t = null == e ? 0 : e.length; ++o < t && !1 !== r(e[o], o, e););
        return e;
    }
    function nr(e, r) {
        for(var o = null == e ? 0 : e.length; o-- && !1 !== r(e[o], o, e););
        return e;
    }
    function dr(e, r) {
        for(var o = -1, t = null == e ? 0 : e.length; ++o < t;)if (!r(e[o], o, e)) return !1;
        return !0;
    }
    function sr(e, r) {
        for(var o = -1, t = null == e ? 0 : e.length, a = 0, l = []; ++o < t;){
            var i = e[o];
            r(i, o, e) && (l[a++] = i);
        }
        return l;
    }
    function mr(e, r) {
        return !(null == e || !e.length) && -1 < br(e, r, 0);
    }
    function gr(e, r, o) {
        for(var t = -1, a = null == e ? 0 : e.length; ++t < a;)if (o(r, e[t])) return !0;
        return !1;
    }
    function cr(e, r) {
        for(var o = -1, t = null == e ? 0 : e.length, a = Array(t); ++o < t;)a[o] = r(e[o], o, e);
        return a;
    }
    function xr(e, r) {
        for(var o = -1, t = r.length, a = e.length; ++o < t;)e[a + o] = r[o];
        return e;
    }
    function ur(e, r, o, t) {
        var a = -1, l = null == e ? 0 : e.length;
        for(t && l && (o = e[++a]); ++a < l;)o = r(o, e[a], a, e);
        return o;
    }
    function pr(e, r, o, t) {
        var a = null == e ? 0 : e.length;
        for(t && a && (o = e[--a]); a--;)o = r(o, e[a], a, e);
        return o;
    }
    function hr(e, r) {
        for(var o = -1, t = null == e ? 0 : e.length; ++o < t;)if (r(e[o], o, e)) return !0;
        return !1;
    }
    var Sr = Pr("length");
    function vr(e, r, o) {
        var t;
        return o(e, function(e, o, a) {
            if (r(e, o, a)) return t = o, !1;
        }), t;
    }
    function $r(e, r, o, t) {
        for(var a = e.length, l = o + (t ? 1 : -1); t ? l-- : ++l < a;)if (r(e[l], l, e)) return l;
        return -1;
    }
    function br(e, r, o) {
        if (r != r) return $r(e, fr, o);
        for(var t = e, a = r, l = o - 1, i = t.length; ++l < i;)if (t[l] === a) return l;
        return -1;
    }
    function Ar(e, r, o, t) {
        for(var a = o - 1, l = e.length; ++a < l;)if (t(e[a], r)) return a;
        return -1;
    }
    function fr(e) {
        return e != e;
    }
    function Mr(e, r) {
        var o = null == e ? 0 : e.length;
        return o ? yr(e, r) / o : s;
    }
    function Pr(r) {
        return function(o) {
            return null == o ? e : o[r];
        };
    }
    function Tr(r) {
        return function(o) {
            return null == r ? e : r[o];
        };
    }
    function _r(e, r, o, t, a) {
        return a(e, function(e, a, l) {
            o = t ? (t = !1, e) : r(o, e, a, l);
        }), o;
    }
    function yr(r, o) {
        for(var t, a = -1, l = r.length; ++a < l;){
            var i = o(r[a]);
            i !== e && (t = t === e ? i : t + i);
        }
        return t;
    }
    function wr(e, r) {
        for(var o = -1, t = Array(e); ++o < e;)t[o] = r(o);
        return t;
    }
    function Gr(e) {
        return e && e.slice(0, Kr(e) + 1).replace(ee, "");
    }
    function Lr(e) {
        return function(r) {
            return e(r);
        };
    }
    function Cr(e, r) {
        return cr(r, function(r) {
            return e[r];
        });
    }
    function Br(e, r) {
        return e.has(r);
    }
    function Er(e, r) {
        for(var o = -1, t = e.length; ++o < t && -1 < br(r, e[o], 0););
        return o;
    }
    function Nr(e, r) {
        for(var o = e.length; o-- && -1 < br(r, e[o], 0););
        return o;
    }
    var Or = Tr({
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    }), Ir = Tr({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    });
    function kr(e) {
        return "\\" + He[e];
    }
    function Xr(e) {
        return ke.test(e);
    }
    function Dr(e) {
        var r = -1, o = Array(e.size);
        return e.forEach(function(e, t) {
            o[++r] = [
                t,
                e
            ];
        }), o;
    }
    function Rr(e, r) {
        return function(o) {
            return e(r(o));
        };
    }
    function Fr(e, r) {
        for(var o = -1, t = e.length, a = 0, l = []; ++o < t;){
            var n = e[o];
            n !== r && n !== i || (e[o] = i, l[a++] = o);
        }
        return l;
    }
    function Vr(e) {
        var r = -1, o = Array(e.size);
        return e.forEach(function(e) {
            o[++r] = e;
        }), o;
    }
    function Hr(e) {
        return (Xr(e) ? function(e) {
            for(var r = Oe.lastIndex = 0; Oe.test(e);)++r;
            return r;
        } : Sr)(e);
    }
    function Ur(e) {
        return Xr(e) ? e.match(Oe) || [] : e.split("");
    }
    function Kr(e) {
        for(var r = e.length; r-- && re.test(e.charAt(r)););
        return r;
    }
    var Wr = Tr({
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    }), Zr = function r(o) {
        var t = (o = null == o ? Qe : Zr.defaults(Qe.Object(), o, Zr.pick(Qe, De))).Array, re = o.Date, ve = o.Error, $e = o.Function, be = o.Math, Ae = o.Object, fe = o.RegExp, Me = o.String, Pe = o.TypeError, Te = t.prototype, _e = $e.prototype, ye = Ae.prototype, we = o["__core-js_shared__"], Ge = _e.toString, Le = ye.hasOwnProperty, Ce = 0, Be = (_e = /[^.]+$/.exec(we && we.keys && we.keys.IE_PROTO || "")) ? "Symbol(src)_1." + _e : "", Oe = ye.toString, ke = Ge.call(Ae), He = Qe._, We = fe("^" + Ge.call(Le).replace(j, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ze = (_e = Ye ? o.Buffer : e, o.Symbol), ze = o.Uint8Array, Je = _e ? _e.allocUnsafe : e, Sr = Rr(Ae.getPrototypeOf, Ae), Tr = Ae.create, Qr = ye.propertyIsEnumerable, zr = Te.splice, Yr = Ze ? Ze.isConcatSpreadable : e, Jr = Ze ? Ze.iterator : e, jr = Ze ? Ze.toStringTag : e, qr = function() {
            try {
                var e = qa(Ae, "defineProperty");
                return e({}, "", {}), e;
            } catch (e) {}
        }(), eo = o.clearTimeout !== Qe.clearTimeout && o.clearTimeout, ro = re && re.now !== Qe.Date.now && re.now, oo = o.setTimeout !== Qe.setTimeout && o.setTimeout, to = be.ceil, ao = be.floor, lo = Ae.getOwnPropertySymbols, io = (_e = _e ? _e.isBuffer : e, o.isFinite), no = Te.join, so = Rr(Ae.keys, Ae), mo = be.max, go = be.min, co = re.now, xo = o.parseInt, uo = be.random, po = Te.reverse, ho = (re = qa(o, "DataView"), qa(o, "Map")), So = qa(o, "Promise"), vo = qa(o, "Set"), $o = (o = qa(o, "WeakMap"), qa(Ae, "create")), bo = o && new o, Ao = {}, fo = _l(re), Mo = _l(ho), Po = _l(So), To = _l(vo), _o = _l(o), yo = (Ze = Ze ? Ze.prototype : e) ? Ze.valueOf : e, wo = Ze ? Ze.toString : e;
        function Go(e) {
            if (Ei(e) && !Mi(e) && !(e instanceof No)) {
                if (e instanceof Eo) return e;
                if (Le.call(e, "__wrapped__")) return yl(e);
            }
            return new Eo(e);
        }
        var Lo = function(r) {
            return Bi(r) ? Tr ? Tr(r) : (Co.prototype = r, r = new Co, Co.prototype = e, r) : {};
        };
        function Co() {}
        function Bo() {}
        function Eo(r, o) {
            this.__wrapped__ = r, this.__actions__ = [], this.__chain__ = !!o, this.__index__ = 0, this.__values__ = e;
        }
        function No(e) {
            this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = m, this.__views__ = [];
        }
        function Oo(e) {
            var r = -1, o = null == e ? 0 : e.length;
            for(this.clear(); ++r < o;){
                var t = e[r];
                this.set(t[0], t[1]);
            }
        }
        function Io(e) {
            var r = -1, o = null == e ? 0 : e.length;
            for(this.clear(); ++r < o;){
                var t = e[r];
                this.set(t[0], t[1]);
            }
        }
        function ko(e) {
            var r = -1, o = null == e ? 0 : e.length;
            for(this.clear(); ++r < o;){
                var t = e[r];
                this.set(t[0], t[1]);
            }
        }
        function Xo(e) {
            var r = -1, o = null == e ? 0 : e.length;
            for(this.__data__ = new ko; ++r < o;)this.add(e[r]);
        }
        function Do(e) {
            e = this.__data__ = new Io(e), this.size = e.size;
        }
        function Ro(e, r) {
            var o, t = Mi(e), a = !t && fi(e), l = !t && !a && yi(e), i = !t && !a && !l && Fi(e), n = t || a || l || i, d = n ? wr(e.length, Me) : [], s = d.length;
            for(o in e)!r && !Le.call(e, o) || n && ("length" == o || l && ("offset" == o || "parent" == o) || i && ("buffer" == o || "byteLength" == o || "byteOffset" == o) || il(o, s)) || d.push(o);
            return d;
        }
        function Fo(r) {
            var o = r.length;
            return o ? r[kt(0, o - 1)] : e;
        }
        function Vo(e, r) {
            return fl(Sa(e), Jo(r, 0, e.length));
        }
        function Ho(e) {
            return fl(Sa(e));
        }
        function Uo(r, o, t) {
            (t === e || $i(r[o], t)) && (t !== e || o in r) || zo(r, o, t);
        }
        function Ko(r, o, t) {
            var a = r[o];
            Le.call(r, o) && $i(a, t) && (t !== e || o in r) || zo(r, o, t);
        }
        function Wo(e, r) {
            for(var o = e.length; o--;)if ($i(e[o][0], r)) return o;
            return -1;
        }
        function Zo(e, r, o, t) {
            return ot(e, function(e, a, l) {
                r(t, e, o(e), l);
            }), t;
        }
        function Qo(e, r) {
            return e && va(r, mn(r), e);
        }
        function zo(e, r, o) {
            "__proto__" == r && qr ? qr(e, r, {
                configurable: !0,
                enumerable: !0,
                value: o,
                writable: !0
            }) : e[r] = o;
        }
        function Yo(r, o) {
            for(var a = -1, l = o.length, i = t(l), n = null == r; ++a < l;)i[a] = n ? e : an(r, o[a]);
            return i;
        }
        function Jo(r, o, t) {
            return r == r && (t !== e && (r = r <= t ? r : t), o !== e) ? o <= r ? r : o : r;
        }
        function jo(r, o, t, a, l, i) {
            var n, d = 1 & o, s = 2 & o, m = 4 & o;
            if ((n = t ? l ? t(r, a, l, i) : t(r) : n) === e) {
                if (!Bi(r)) return r;
                var g;
                if (a = Mi(r)) {
                    if (n = function(e) {
                        var r = e.length, o = new e.constructor(r);
                        return r && "string" == typeof e[0] && Le.call(e, "index") && (o.index = e.index, o.input = e.input), o;
                    }(r), !d) return Sa(r, n);
                } else {
                    var x = ol(r), h = x == S || x == v;
                    if (yi(r)) return ga(r, d);
                    if (x == A || x == c || h && !l) {
                        if (n = s || h ? {} : al(r), !d) return s ? (f = h = r, f = (g = n) && va(f, gn(f), g), va(h, rl(h), f)) : (h = Qo(n, g = r), va(g, el(g), h));
                    } else {
                        if (!Ve[x]) return l ? r : {};
                        n = function(e, r, o) {
                            var t = e.constructor;
                            switch(r){
                                case w:
                                    return ca(e);
                                case u:
                                case p:
                                    return new t(+e);
                                case G:
                                    return function(e, r) {
                                        return r = r ? ca(e.buffer) : e.buffer, new e.constructor(r, e.byteOffset, e.byteLength);
                                    }(e, o);
                                case L:
                                case C:
                                case B:
                                case E:
                                case N:
                                case O:
                                case I:
                                case k:
                                case X:
                                    return xa(e, o);
                                case $:
                                    return new t;
                                case b:
                                case T:
                                    return new t(e);
                                case M:
                                    return function(e) {
                                        var r = new e.constructor(e.source, se.exec(e));
                                        return r.lastIndex = e.lastIndex, r;
                                    }(e);
                                case P:
                                    return new t;
                                case _:
                                    return function(e) {
                                        return yo ? Ae(yo.call(e)) : {};
                                    }(e);
                            }
                        }(r, x, d);
                    }
                }
                var f = (i = i || new Do).get(r);
                if (f) return f;
                i.set(r, n), Xi(r) ? r.forEach(function(e) {
                    n.add(jo(e, o, t, e, r, i));
                }) : Ni(r) && r.forEach(function(e, a) {
                    n.set(a, jo(e, o, t, a, r, i));
                });
                var y = a ? e : (m ? s ? Wa : Ka : s ? gn : mn)(r);
                ir(y || r, function(e, a) {
                    y && (e = r[a = e]), Ko(n, a, jo(e, o, t, a, r, i));
                });
            }
            return n;
        }
        function qo(r, o, t) {
            var a = t.length;
            if (null == r) return !a;
            for(r = Ae(r); a--;){
                var l = t[a], i = o[l], n = r[l];
                if (n === e && !(l in r) || !i(n)) return !1;
            }
            return !0;
        }
        function et(r, o, t) {
            if ("function" != typeof r) throw new Pe(a);
            return vl(function() {
                r.apply(e, t);
            }, o);
        }
        function rt(e, r, o, t) {
            var a = -1, l = mr, i = !0, n = e.length, d = [], s = r.length;
            if (n) {
                o && (r = cr(r, Lr(o))), t ? (l = gr, i = !1) : 200 <= r.length && (l = Br, i = !1, r = new Xo(r));
                e: for(; ++a < n;){
                    var m = e[a], g = null == o ? m : o(m);
                    if (m = t || 0 !== m ? m : 0, i && g == g) {
                        for(var c = s; c--;)if (r[c] === g) continue e;
                        d.push(m);
                    } else l(r, g, t) || d.push(m);
                }
            }
            return d;
        }
        Go.templateSettings = {
            escape: W,
            evaluate: Z,
            interpolate: Q,
            variable: "",
            imports: {
                _: Go
            }
        }, (Go.prototype = Bo.prototype).constructor = Go, (Eo.prototype = Lo(Bo.prototype)).constructor = Eo, (No.prototype = Lo(Bo.prototype)).constructor = No, Oo.prototype.clear = function() {
            this.__data__ = $o ? $o(null) : {}, this.size = 0;
        }, Oo.prototype.delete = function(e) {
            return e = this.has(e) && delete this.__data__[e], this.size -= e ? 1 : 0, e;
        }, Oo.prototype.get = function(r) {
            var o, t = this.__data__;
            return $o ? (o = t[r]) === l ? e : o : Le.call(t, r) ? t[r] : e;
        }, Oo.prototype.has = function(r) {
            var o = this.__data__;
            return $o ? o[r] !== e : Le.call(o, r);
        }, Oo.prototype.set = function(r, o) {
            var t = this.__data__;
            return this.size += this.has(r) ? 0 : 1, t[r] = $o && o === e ? l : o, this;
        }, Io.prototype.clear = function() {
            this.__data__ = [], this.size = 0;
        }, Io.prototype.delete = function(e) {
            var r = this.__data__;
            return !((e = Wo(r, e)) < 0 || (e == r.length - 1 ? r.pop() : zr.call(r, e, 1), --this.size, 0));
        }, Io.prototype.get = function(r) {
            var o = this.__data__;
            return (r = Wo(o, r)) < 0 ? e : o[r][1];
        }, Io.prototype.has = function(e) {
            return -1 < Wo(this.__data__, e);
        }, Io.prototype.set = function(e, r) {
            var o = this.__data__, t = Wo(o, e);
            return t < 0 ? (++this.size, o.push([
                e,
                r
            ])) : o[t][1] = r, this;
        }, ko.prototype.clear = function() {
            this.size = 0, this.__data__ = {
                hash: new Oo,
                map: new (ho || Io),
                string: new Oo
            };
        }, ko.prototype.delete = function(e) {
            return e = Ja(this, e).delete(e), this.size -= e ? 1 : 0, e;
        }, ko.prototype.get = function(e) {
            return Ja(this, e).get(e);
        }, ko.prototype.has = function(e) {
            return Ja(this, e).has(e);
        }, ko.prototype.set = function(e, r) {
            var o = Ja(this, e), t = o.size;
            return o.set(e, r), this.size += o.size == t ? 0 : 1, this;
        }, Xo.prototype.add = Xo.prototype.push = function(e) {
            return this.__data__.set(e, l), this;
        }, Xo.prototype.has = function(e) {
            return this.__data__.has(e);
        }, Do.prototype.clear = function() {
            this.__data__ = new Io, this.size = 0;
        }, Do.prototype.delete = function(e) {
            var r = this.__data__;
            return e = r.delete(e), this.size = r.size, e;
        }, Do.prototype.get = function(e) {
            return this.__data__.get(e);
        }, Do.prototype.has = function(e) {
            return this.__data__.has(e);
        }, Do.prototype.set = function(e, r) {
            var o = this.__data__;
            if (o instanceof Io) {
                var t = o.__data__;
                if (!ho || t.length < 199) return t.push([
                    e,
                    r
                ]), this.size = ++o.size, this;
                o = this.__data__ = new ko(t);
            }
            return o.set(e, r), this.size = o.size, this;
        };
        var ot = Aa(mt), tt = Aa(gt, !0);
        function at(e, r) {
            var o = !0;
            return ot(e, function(e, t, a) {
                return o = !!r(e, t, a);
            }), o;
        }
        function lt(r, o, t) {
            for(var a = -1, l = r.length; ++a < l;){
                var i, n, d = r[a], s = o(d);
                null != s && (i === e ? s == s && !Ri(s) : t(s, i)) && (i = s, n = d);
            }
            return n;
        }
        function it(e, r) {
            var o = [];
            return ot(e, function(e, t, a) {
                r(e, t, a) && o.push(e);
            }), o;
        }
        function nt(e, r, o, t, a) {
            var l = -1, i = e.length;
            for(o = o || ll, a = a || []; ++l < i;){
                var n = e[l];
                0 < r && o(n) ? 1 < r ? nt(n, r - 1, o, t, a) : xr(a, n) : t || (a[a.length] = n);
            }
            return a;
        }
        var dt = fa(), st = fa(!0);
        function mt(e, r) {
            return e && dt(e, r, mn);
        }
        function gt(e, r) {
            return e && st(e, r, mn);
        }
        function ct(e, r) {
            return sr(r, function(r) {
                return Gi(e[r]);
            });
        }
        function xt(r, o) {
            for(var t = 0, a = (o = na(o, r)).length; null != r && t < a;)r = r[Tl(o[t++])];
            return t && t == a ? r : e;
        }
        function ut(e, r, o) {
            return r = r(e), Mi(e) ? r : xr(r, o(e));
        }
        function pt(r) {
            if (null == r) return r === e ? "[object Undefined]" : "[object Null]";
            if (jr && jr in Ae(r)) {
                var o = r, t = Le.call(o, jr), a = o[jr];
                try {
                    o[jr] = e;
                    var l = !0;
                } catch (r) {}
                var i = Oe.call(o);
                return l && (t ? o[jr] = a : delete o[jr]), i;
            }
            return Oe.call(r);
        }
        function ht(e, r) {
            return r < e;
        }
        function St(e, r) {
            return null != e && Le.call(e, r);
        }
        function vt(e, r) {
            return null != e && r in Ae(e);
        }
        function $t(r, o, a) {
            for(var l = a ? gr : mr, i = r[0].length, n = r.length, d = n, s = t(n), m = 1 / 0, g = []; d--;){
                var c = r[d];
                d && o && (c = cr(c, Lr(o))), m = go(c.length, m), s[d] = !a && (o || 120 <= i && 120 <= c.length) ? new Xo(d && c) : e;
            }
            c = r[0];
            var x = -1, u = s[0];
            e: for(; ++x < i && g.length < m;){
                var p = c[x], h = o ? o(p) : p;
                if (p = a || 0 !== p ? p : 0, !(u ? Br(u, h) : l(g, h, a))) {
                    for(d = n; --d;){
                        var S = s[d];
                        if (!(S ? Br(S, h) : l(r[d], h, a))) continue e;
                    }
                    u && u.push(h), g.push(p);
                }
            }
            return g;
        }
        function bt(r, o, t) {
            return null == (o = null == (r = pl(r, o = na(o, r))) ? r : r[Tl(Bl(o))]) ? e : ar(o, r, t);
        }
        function At(e) {
            return Ei(e) && pt(e) == c;
        }
        function ft(r, o, t, a, l) {
            if (r === o) return !0;
            if (null == r || null == o || !Ei(r) && !Ei(o)) return r != r && o != o;
            var i = ft, n = Mi(r), d = Mi(o), s = n ? x : ol(r), m = (d = d ? x : ol(o), (s = s == c ? A : s) == A), g = (d = d == c ? A : d) == A;
            if ((d = s == d) && yi(r)) {
                if (!yi(o)) return !1;
                m = (n = !0, false);
            }
            if (d && !m) {
                if (l = l || new Do, n || Fi(r)) return Ha(r, o, t, a, i, l);
                var S = r, v = o, f = t, y = a, L = i, C = l;
                switch(s){
                    case G:
                        if (S.byteLength != v.byteLength || S.byteOffset != v.byteOffset) return !1;
                        S = S.buffer, v = v.buffer;
                    case w:
                        return !(S.byteLength != v.byteLength || !L(new ze(S), new ze(v)));
                    case u:
                    case p:
                    case b:
                        return $i(+S, +v);
                    case h:
                        return S.name == v.name && S.message == v.message;
                    case M:
                    case T:
                        return S == v + "";
                    case $:
                        var B = Dr;
                    case P:
                        var E = 1 & f;
                        return B = B || Vr, !(S.size != v.size && !E) && ((E = C.get(S)) ? E == v : (f |= 2, C.set(S, v), E = Ha(B(S), B(v), f, y, L, C), C.delete(S), E));
                    case _:
                        if (yo) return yo.call(S) == yo.call(v);
                }
                return !1;
            }
            if (!(1 & t) && (n = m && Le.call(r, "__wrapped__"), s = g && Le.call(o, "__wrapped__"), n || s)) return i(m = n ? r.value() : r, g = s ? o.value() : o, t, a, l = l || new Do);
            if (d) {
                var N = r, O = o, I = t, k = a, X = i, D = l = l || new Do, R = 1 & I, F = Ka(N), V = F.length;
                if (V != (n = Ka(O).length) && !R) return !1;
                for(var H = V; H--;){
                    var U = F[H];
                    if (!(R ? U in O : Le.call(O, U))) return !1;
                }
                if (n = D.get(N), s = D.get(O), n && s) return n == O && s == N;
                for(var K = !0, W = (D.set(N, O), D.set(O, N), R); ++H < V;){
                    var Z, Q = N[U = F[H]], z = O[U];
                    if (!((Z = k ? R ? k(z, Q, U, O, N, D) : k(Q, z, U, N, O, D) : Z) === e ? Q === z || X(Q, z, I, k, D) : Z)) {
                        K = !1;
                        break;
                    }
                    W = W || "constructor" == U;
                }
                return K && !W && (n = N.constructor) != (s = O.constructor) && "constructor" in N && "constructor" in O && !("function" == typeof n && n instanceof n && "function" == typeof s && s instanceof s) && (K = !1), D.delete(N), D.delete(O), K;
            }
            return !1;
        }
        function Mt(r, o, t, a) {
            var l = t.length, i = l, n = !a;
            if (null == r) return !i;
            for(r = Ae(r); l--;){
                var d = t[l];
                if (n && d[2] ? d[1] !== r[d[0]] : !(d[0] in r)) return !1;
            }
            for(; ++l < i;){
                var s = (d = t[l])[0], m = r[s], g = d[1];
                if (n && d[2]) {
                    if (m === e && !(s in r)) return !1;
                } else {
                    var c, x = new Do;
                    if (!((c = a ? a(m, g, s, r, o, x) : c) === e ? ft(g, m, 3, a, x) : c)) return !1;
                }
            }
            return !0;
        }
        function Pt(e) {
            var r;
            return !(!Bi(e) || (r = e, Be && Be in r)) && (Gi(e) ? We : ce).test(_l(e));
        }
        function Tt(e) {
            return "function" == typeof e ? e : null == e ? In : "object" == typeof e ? Mi(e) ? Lt(e[0], e[1]) : Gt(e) : Kn(e);
        }
        function _t(e) {
            if (!gl(e)) return so(e);
            var r, o = [];
            for(r in Ae(e))Le.call(e, r) && "constructor" != r && o.push(r);
            return o;
        }
        function yt(e, r) {
            return e < r;
        }
        function wt(e, r) {
            var o = -1, a = Ti(e) ? t(e.length) : [];
            return ot(e, function(e, t, l) {
                a[++o] = r(e, t, l);
            }), a;
        }
        function Gt(e) {
            var r = ja(e);
            return 1 == r.length && r[0][2] ? xl(r[0][0], r[0][1]) : function(o) {
                return o === e || Mt(o, e, r);
            };
        }
        function Lt(r, o) {
            return dl(r) && cl(o) ? xl(Tl(r), o) : function(t) {
                var a = an(t, r);
                return a === e && a === o ? ln(t, r) : ft(o, a, 3);
            };
        }
        function Ct(r, o, t, a, l) {
            r !== o && dt(o, function(i, n) {
                var d, s, m, g, c, x, u, p, h, S, v, $, b;
                l = l || new Do, Bi(i) ? (s = o, g = t, c = Ct, x = a, u = l, v = hl(d = r, m = n), $ = hl(s, m), (b = u.get($)) || ((s = (b = x ? x(v, $, m + "", d, s, u) : e) === e) && (h = !(p = Mi($)) && yi($), S = !p && !h && Fi($), b = $, p || h || S ? b = Mi(v) ? v : _i(v) ? Sa(v) : h ? ga($, (s = !1, true)) : S ? xa($, (s = !1, true)) : [] : Ii($) || fi($) ? fi(b = v) ? b = zi(v) : Bi(v) && !Gi(v) || (b = al($)) : s = !1), s && (u.set($, b), c(b, $, g, x, u), u.delete($))), Uo(d, m, b)) : (p = a ? a(hl(r, n), i, n + "", r, o, l) : e, Uo(r, n, p = p === e ? i : p));
            }, gn);
        }
        function Bt(r, o) {
            var t = r.length;
            if (t) return il(o += o < 0 ? t : 0, t) ? r[o] : e;
        }
        function Et(e, r, o) {
            r = r.length ? cr(r, function(e) {
                return Mi(e) ? function(r) {
                    return xt(r, 1 === e.length ? e[0] : e);
                } : e;
            }) : [
                In
            ];
            var t = -1;
            r = cr(r, Lr(Ya()));
            var a = wt(e, function(e, o, a) {
                return {
                    criteria: cr(r, function(r) {
                        return r(e);
                    }),
                    index: ++t,
                    value: e
                };
            }), l = (e = function(e, r) {
                for(var t = o, a = -1, l = e.criteria, i = r.criteria, n = l.length, d = t.length; ++a < n;){
                    var s = ua(l[a], i[a]);
                    if (s) return d <= a ? s : s * ("desc" == t[a] ? -1 : 1);
                }
                return e.index - r.index;
            }, a.length);
            for(a.sort(e); l--;)a[l] = a[l].value;
            return a;
        }
        function Nt(e, r, o) {
            for(var t = -1, a = r.length, l = {}; ++t < a;){
                var i = r[t], n = xt(e, i);
                o(n, i) && Vt(l, na(i, e), n);
            }
            return l;
        }
        function Ot(e, r, o, t) {
            var a = t ? Ar : br, l = -1, i = r.length, n = e;
            for(e === r && (r = Sa(r)), o && (n = cr(e, Lr(o))); ++l < i;)for(var d = 0, s = r[l], m = o ? o(s) : s; -1 < (d = a(n, m, d, t));)n !== e && zr.call(n, d, 1), zr.call(e, d, 1);
            return e;
        }
        function It(e, r) {
            for(var o = e ? r.length : 0, t = o - 1; o--;){
                var a, l = r[o];
                o != t && l === a || (il(a = l) ? zr.call(e, l, 1) : qt(e, l));
            }
        }
        function kt(e, r) {
            return e + ao(uo() * (r - e + 1));
        }
        function Xt(e, r) {
            var o = "";
            if (!(!e || r < 1 || d < r)) for(; r % 2 && (o += e), (r = ao(r / 2)) && (e += e), r;);
            return o;
        }
        function Dt(e, r) {
            return $l(ul(e, r, In), e + "");
        }
        function Rt(e) {
            return Fo($n(e));
        }
        function Ft(e, r) {
            return fl(e = $n(e), Jo(r, 0, e.length));
        }
        function Vt(r, o, t, a) {
            if (Bi(r)) for(var l = -1, i = (o = na(o, r)).length, n = i - 1, d = r; null != d && ++l < i;){
                var s, m = Tl(o[l]), g = t;
                if ("__proto__" === m || "constructor" === m || "prototype" === m) return r;
                Ko(d, m, g = l != n && (s = d[m], (g = a ? a(s, m, d) : e) === e) ? Bi(s) ? s : il(o[l + 1]) ? [] : {} : g), d = d[m];
            }
            return r;
        }
        var Ht = bo ? function(e, r) {
            return bo.set(e, r), e;
        } : In;
        function Ut(e) {
            return fl($n(e));
        }
        function Kt(e, r, o) {
            for(var a = -1, l = e.length, i = ((o = l < o ? l : o) < 0 && (o += l), l = o < (r = r < 0 ? l < -r ? 0 : l + r : r) ? 0 : o - r >>> 0, r >>>= 0, t(l)); ++a < l;)i[a] = e[a + r];
            return i;
        }
        function Wt(e, r) {
            var o;
            return ot(e, function(e, t, a) {
                return !(o = r(e, t, a));
            }), !!o;
        }
        function Zt(e, r, o) {
            var t = 0, a = null == e ? t : e.length;
            if ("number" == typeof r && r == r && a <= 2147483647) {
                for(; t < a;){
                    var l = t + a >>> 1, i = e[l];
                    null !== i && !Ri(i) && (o ? i <= r : i < r) ? t = 1 + l : a = l;
                }
                return a;
            }
            return Qt(e, r, In, o);
        }
        function Qt(r, o, t, a) {
            var l = 0, i = null == r ? 0 : r.length;
            if (0 === i) return 0;
            for(var n = (o = t(o)) != o, d = null === o, s = Ri(o), m = o === e; l < i;){
                var g = ao((l + i) / 2), c = t(r[g]), x = c !== e, u = null === c, p = c == c, h = Ri(c);
                (p = n ? a || p : m ? p && (a || x) : d ? p && x && (a || !u) : s ? p && x && !u && (a || !h) : !u && !h && (a ? c <= o : c < o)) ? l = g + 1 : i = g;
            }
            return go(i, 4294967294);
        }
        function zt(e, r) {
            for(var o = -1, t = e.length, a = 0, l = []; ++o < t;){
                var i, n = e[o], d = r ? r(n) : n;
                o && $i(d, i) || (i = d, l[a++] = 0 === n ? 0 : n);
            }
            return l;
        }
        function Yt(e) {
            return "number" == typeof e ? e : Ri(e) ? s : +e;
        }
        function Jt(e) {
            var r;
            return "string" == typeof e ? e : Mi(e) ? cr(e, Jt) + "" : Ri(e) ? wo ? wo.call(e) : "" : "0" == (r = e + "") && 1 / e == -1 / 0 ? "-0" : r;
        }
        function jt(e, r, o) {
            var t = -1, a = mr, l = e.length, i = !0, n = [], d = n;
            if (o) i = !1, a = gr;
            else if (200 <= l) {
                var s = r ? null : ka(e);
                if (s) return Vr(s);
                i = !1, a = Br, d = new Xo;
            } else d = r ? [] : n;
            e: for(; ++t < l;){
                var m = e[t], g = r ? r(m) : m;
                if (m = o || 0 !== m ? m : 0, i && g == g) {
                    for(var c = d.length; c--;)if (d[c] === g) continue e;
                    r && d.push(g), n.push(m);
                } else a(d, g, o) || (d !== n && d.push(g), n.push(m));
            }
            return n;
        }
        function qt(e, r) {
            return null == (e = pl(e, r = na(r, e))) || delete e[Tl(Bl(r))];
        }
        function ea(e, r, o, t) {
            return Vt(e, r, o(xt(e, r)), t);
        }
        function ra(e, r, o, t) {
            for(var a = e.length, l = t ? a : -1; (t ? l-- : ++l < a) && r(e[l], l, e););
            return o ? Kt(e, t ? 0 : l, t ? l + 1 : a) : Kt(e, t ? l + 1 : 0, t ? a : l);
        }
        function oa(e, r) {
            var o = e;
            return ur(r, function(e, r) {
                return r.func.apply(r.thisArg, xr([
                    e
                ], r.args));
            }, o = e instanceof No ? e.value() : o);
        }
        function ta(e, r, o) {
            var a = e.length;
            if (a < 2) return a ? jt(e[0]) : [];
            for(var l = -1, i = t(a); ++l < a;)for(var n = e[l], d = -1; ++d < a;)d != l && (i[l] = rt(i[l] || n, e[d], r, o));
            return jt(nt(i, 1), r, o);
        }
        function aa(r, o, t) {
            for(var a = -1, l = r.length, i = o.length, n = {}; ++a < l;){
                var d = a < i ? o[a] : e;
                t(n, r[a], d);
            }
            return n;
        }
        function la(e) {
            return _i(e) ? e : [];
        }
        function ia(e) {
            return "function" == typeof e ? e : In;
        }
        function na(e, r) {
            return Mi(e) ? e : dl(e, r) ? [
                e
            ] : Pl(Yi(e));
        }
        Ze = qr ? function(e, r) {
            return qr(e, "toString", {
                configurable: !0,
                enumerable: !1,
                value: En(r),
                writable: !0
            });
        } : In;
        var da = Dt;
        function sa(r, o, t) {
            var a = r.length;
            return t = t === e ? a : t, !o && a <= t ? r : Kt(r, o, t);
        }
        var ma = eo || function(e) {
            return Qe.clearTimeout(e);
        };
        function ga(e, r) {
            return r ? e.slice() : (r = e.length, r = Je ? Je(r) : new e.constructor(r), e.copy(r), r);
        }
        function ca(e) {
            var r = new e.constructor(e.byteLength);
            return new ze(r).set(new ze(e)), r;
        }
        function xa(e, r) {
            return r = r ? ca(e.buffer) : e.buffer, new e.constructor(r, e.byteOffset, e.length);
        }
        function ua(r, o) {
            if (r !== o) {
                var t = r !== e, a = null === r, l = r == r, i = Ri(r), n = o !== e, d = null === o, s = o == o, m = Ri(o);
                if (!d && !m && !i && o < r || i && n && s && !d && !m || a && n && s || !t && s || !l) return 1;
                if (!a && !i && !m && r < o || m && t && l && !a && !i || d && t && l || !n && l || !s) return -1;
            }
            return 0;
        }
        function pa(e, r, o, a) {
            for(var l = -1, i = e.length, n = o.length, d = -1, s = r.length, m = mo(i - n, 0), g = t(s + m), c = !a; ++d < s;)g[d] = r[d];
            for(; ++l < n;)(c || l < i) && (g[o[l]] = e[l]);
            for(; m--;)g[d++] = e[l++];
            return g;
        }
        function ha(e, r, o, a) {
            for(var l = -1, i = e.length, n = -1, d = o.length, s = -1, m = r.length, g = mo(i - d, 0), c = t(g + m), x = !a; ++l < g;)c[l] = e[l];
            for(var u = l; ++s < m;)c[u + s] = r[s];
            for(; ++n < d;)(x || l < i) && (c[u + o[n]] = e[l++]);
            return c;
        }
        function Sa(e, r) {
            var o = -1, a = e.length;
            for(r = r || t(a); ++o < a;)r[o] = e[o];
            return r;
        }
        function va(r, o, t, a) {
            for(var l = !t, i = (t = t || {}, -1), n = o.length; ++i < n;){
                var d = o[i], s = a ? a(t[d], r[d], d, t, r) : e;
                (l ? zo : Ko)(t, d, s = s === e ? r[d] : s);
            }
            return t;
        }
        function $a(e, r) {
            return function(o, t) {
                var a = Mi(o) ? lr : Zo, l = r ? r() : {};
                return a(o, e, Ya(t, 2), l);
            };
        }
        function ba(r) {
            return Dt(function(o, t) {
                var a = -1, l = t.length, i = 1 < l ? t[l - 1] : e, n = 2 < l ? t[2] : e;
                for(i = 3 < r.length && "function" == typeof i ? (l--, i) : e, n && nl(t[0], t[1], n) && (i = l < 3 ? e : i, l = 1), o = Ae(o); ++a < l;){
                    var d = t[a];
                    d && r(o, d, a, i);
                }
                return o;
            });
        }
        function Aa(e, r) {
            return function(o, t) {
                if (null != o) {
                    if (!Ti(o)) return e(o, t);
                    for(var a = o.length, l = r ? a : -1, i = Ae(o); (r ? l-- : ++l < a) && !1 !== t(i[l], l, i););
                }
                return o;
            };
        }
        function fa(e) {
            return function(r, o, t) {
                for(var a = -1, l = Ae(r), i = t(r), n = i.length; n--;){
                    var d = i[e ? n : ++a];
                    if (!1 === o(l[d], d, l)) break;
                }
                return r;
            };
        }
        function Ma(r) {
            return function(o) {
                var t = (a = Xr(o = Yi(o)) ? Ur(o) : e) ? a[0] : o.charAt(0), a = a ? sa(a, 1).join("") : o.slice(1);
                return t[r]() + a;
            };
        }
        function Pa(e) {
            return function(r) {
                return ur(Ln(fn(r).replace(Ee, "")), e, "");
            };
        }
        function Ta(e) {
            return function() {
                var r = arguments;
                switch(r.length){
                    case 0:
                        return new e;
                    case 1:
                        return new e(r[0]);
                    case 2:
                        return new e(r[0], r[1]);
                    case 3:
                        return new e(r[0], r[1], r[2]);
                    case 4:
                        return new e(r[0], r[1], r[2], r[3]);
                    case 5:
                        return new e(r[0], r[1], r[2], r[3], r[4]);
                    case 6:
                        return new e(r[0], r[1], r[2], r[3], r[4], r[5]);
                    case 7:
                        return new e(r[0], r[1], r[2], r[3], r[4], r[5], r[6]);
                }
                var o = Lo(e.prototype), t = e.apply(o, r);
                return Bi(t) ? t : o;
            };
        }
        function _a(r) {
            return function(o, t, a) {
                var l, i = Ae(o);
                return -1 < (Ti(o) || (l = Ya(t, 3), o = mn(o), t = function(e) {
                    return l(i[e], e, i);
                }), t = r(o, t, a)) ? i[l ? o[t] : t] : e;
            };
        }
        function ya(r) {
            return Ua(function(o) {
                var t = o.length, l = t, i = Eo.prototype.thru;
                for(r && o.reverse(); l--;){
                    var n = o[l];
                    if ("function" != typeof n) throw new Pe(a);
                    i && !m && "wrapper" == Qa(n) && (m = new Eo([], !0));
                }
                for(l = m ? l : t; ++l < t;)var d = Qa(n = o[l]), s = "wrapper" == d ? Za(n) : e, m = s && sl(s[0]) && 424 == s[1] && !s[4].length && 1 == s[9] ? m[Qa(s[0])].apply(m, s[3]) : 1 == n.length && sl(n) ? m[d]() : m.thru(n);
                return function() {
                    var e = arguments, r = e[0];
                    if (m && 1 == e.length && Mi(r)) return m.plant(r).value();
                    for(var a = 0, l = t ? o[a].apply(this, e) : r; ++a < t;)l = o[a].call(this, l);
                    return l;
                };
            });
        }
        function wa(r, o, a, l, i, d, s, m, g, c) {
            var x = o & n, u = 1 & o, p = 2 & o, h = 24 & o, S = 512 & o, v = p ? e : Ta(r);
            return function n() {
                for(var $, b, A, f = t(A = arguments.length), M = A; M--;)f[M] = arguments[M];
                return h && (b = function(e, r) {
                    for(var o = e.length, t = 0; o--;)e[o] === r && ++t;
                    return t;
                }(f, $ = za(n))), l && (f = pa(f, l, i, h)), d && (f = ha(f, d, s, h)), A -= b, h && A < c ? (b = Fr(f, $), Oa(r, o, wa, n.placeholder, a, f, b, m, g, c - A)) : ($ = u ? a : this, b = p ? $[r] : r, A = f.length, m ? f = function(r, o) {
                    for(var t = r.length, a = go(o.length, t), l = Sa(r); a--;){
                        var i = o[a];
                        r[a] = il(i, t) ? l[i] : e;
                    }
                    return r;
                }(f, m) : S && 1 < A && f.reverse(), x && g < A && (f.length = g), (b = this && this !== Qe && this instanceof n ? v || Ta(b) : b).apply($, f));
            };
        }
        function Ga(e, r) {
            return function(o, t) {
                var a, l, i;
                return a = e, l = r(t), i = {}, mt(o, function(e, r, o) {
                    a(i, l(e), r, o);
                }), i;
            };
        }
        function La(r, o) {
            return function(t, a) {
                var l;
                if (t === e && a === e) return o;
                if (t !== e && (l = t), a !== e) {
                    if (l === e) return a;
                    a = ("string" == typeof t || "string" == typeof a ? (t = Jt(t), Jt) : (t = Yt(t), Yt))(a), l = r(t, a);
                }
                return l;
            };
        }
        function Ca(e) {
            return Ua(function(r) {
                return r = cr(r, Lr(Ya())), Dt(function(o) {
                    var t = this;
                    return e(r, function(e) {
                        return ar(e, t, o);
                    });
                });
            });
        }
        function Ba(r, o) {
            var t = (o = o === e ? " " : Jt(o)).length;
            return t < 2 ? t ? Xt(o, r) : o : (t = Xt(o, to(r / Hr(o))), Xr(o) ? sa(Ur(t), 0, r).join("") : t.slice(0, r));
        }
        function Ea(r) {
            return function(o, a, l) {
                l && "number" != typeof l && nl(o, a, l) && (a = l = e), o = Ki(o), a === e ? (a = o, o = 0) : a = Ki(a);
                for(var i = o, n = l = l === e ? o < a ? 1 : -1 : Ki(l), d = r, s = -1, m = mo(to((a - i) / (n || 1)), 0), g = t(m); m--;)g[d ? m : ++s] = i, i += n;
                return g;
            };
        }
        function Na(e) {
            return function(r, o) {
                return "string" == typeof r && "string" == typeof o || (r = Qi(r), o = Qi(o)), e(r, o);
            };
        }
        function Oa(r, o, t, a, l, i, n, d, s, m) {
            var g = 8 & o;
            return 4 & (o = (o | (g ? 32 : 64)) & ~(g ? 64 : 32)) || (o &= -4), l = [
                r,
                o,
                l,
                g ? i : e,
                g ? n : e,
                g ? e : i,
                g ? e : n,
                d,
                s,
                m
            ], i = t.apply(e, l), sl(r) && Sl(i, l), i.placeholder = a, bl(i, r, o);
        }
        function Ia(e) {
            var r = be[e];
            return function(e, o) {
                var t;
                return e = Qi(e), (o = null == o ? 0 : go(Wi(o), 292)) && io(e) ? (t = (Yi(e) + "e").split("e"), +((t = (Yi(r(t[0] + "e" + (+t[1] + o))) + "e").split("e"))[0] + "e" + (+t[1] - o))) : r(e);
            };
        }
        var ka = vo && 1 / Vr(new vo([
            ,
            -0
        ]))[1] == 1 / 0 ? function(e) {
            return new vo(e);
        } : Fn;
        function Xa(e) {
            return function(r) {
                var o, t, a, l = ol(r);
                return l == $ ? Dr(r) : l == P ? (l = r, o = -1, t = Array(l.size), l.forEach(function(e) {
                    t[++o] = [
                        e,
                        e
                    ];
                }), t) : cr(e(a = r), function(e) {
                    return [
                        e,
                        a[e]
                    ];
                });
            };
        }
        function Da(r, o, l, d, s, m, g, c) {
            var x, u, p, h, S, v, $, b, A, f, M, P, T, _ = 2 & o;
            if (_ || "function" == typeof r) return (x = d ? d.length : 0) || (o &= -97, d = s = e), g = g === e ? g : mo(Wi(g), 0), c = c === e ? c : Wi(c), x -= s ? s.length : 0, 64 & o && (p = d, h = s, d = s = e), p = [
                r,
                o,
                l,
                d,
                s,
                p,
                h,
                m,
                g,
                c
            ], (u = _ ? e : Za(r)) && (h = u, b = ($ = (g = (m = p)[1]) | (v = h[1])) < 131, A = v == n && 8 == g || v == n && 256 == g && m[7].length <= h[8] || 384 == v && h[7].length <= h[8] && 8 == g, b || A) && (1 & v && (m[2] = h[2], $ |= 1 & g ? 0 : 4), (b = h[3]) && (S = m[3], m[3] = S ? pa(S, b, h[4]) : b, m[4] = S ? Fr(m[3], i) : h[4]), (b = h[5]) && (S = m[5], m[5] = S ? ha(S, b, h[6]) : b, m[6] = S ? Fr(m[5], i) : h[6]), (b = h[7]) && (m[7] = b), v & n && (m[8] = null == m[8] ? h[8] : go(m[8], h[8])), null == m[9] && (m[9] = h[9]), m[0] = h[0], m[1] = $), r = p[0], o = p[1], l = p[2], d = p[3], s = p[4], !(c = p[9] = p[9] === e ? _ ? 0 : r.length : mo(p[9] - x, 0)) && 24 & o && (o &= -25), A = o && 1 != o ? 8 == o || 16 == o ? function(r, o, a) {
                var l = Ta(r);
                return function i() {
                    for(var n = arguments.length, d = t(n), s = n, m = za(i); s--;)d[s] = arguments[s];
                    return (n -= (m = n < 3 && d[0] !== m && d[n - 1] !== m ? [] : Fr(d, m)).length) < a ? Oa(r, o, wa, i.placeholder, e, d, m, e, e, a - n) : ar(this && this !== Qe && this instanceof i ? l : r, this, d);
                };
            }(r, o, c) : 32 != o && 33 != o || s.length ? wa.apply(e, p) : function(e, r, o, a) {
                var l = 1 & r, i = Ta(e);
                return function r() {
                    for(var n = -1, d = arguments.length, s = -1, m = a.length, g = t(m + d), c = this && this !== Qe && this instanceof r ? i : e; ++s < m;)g[s] = a[s];
                    for(; d--;)g[s++] = arguments[++n];
                    return ar(c, l ? o : this, g);
                };
            }(r, o, l, d) : (M = l, P = 1 & o, T = Ta(f = r), function e() {
                return (this && this !== Qe && this instanceof e ? T : f).apply(P ? M : this, arguments);
            }), bl((u ? Ht : Sl)(A, p), r, o);
            throw new Pe(a);
        }
        function Ra(r, o, t, a) {
            return r === e || $i(r, ye[t]) && !Le.call(a, t) ? o : r;
        }
        function Fa(r, o, t, a, l, i) {
            return Bi(r) && Bi(o) && (i.set(o, r), Ct(r, o, e, Fa, i), i.delete(o)), r;
        }
        function Va(r) {
            return Ii(r) ? e : r;
        }
        function Ha(r, o, t, a, l, i) {
            var n = 1 & t, d = r.length;
            if (d != (s = o.length) && !(n && d < s)) return !1;
            var s = i.get(r), m = i.get(o);
            if (s && m) return s == o && m == r;
            var g = -1, c = !0, x = 2 & t ? new Xo : e;
            for(i.set(r, o), i.set(o, r); ++g < d;){
                var u, p = r[g], h = o[g];
                if ((u = a ? n ? a(h, p, g, o, r, i) : a(p, h, g, r, o, i) : u) !== e) {
                    if (u) continue;
                    c = !1;
                    break;
                }
                if (x) {
                    if (!hr(o, function(e, r) {
                        return !Br(x, r) && (p === e || l(p, e, t, a, i)) && x.push(r);
                    })) {
                        c = !1;
                        break;
                    }
                } else if (p !== h && !l(p, h, t, a, i)) {
                    c = !1;
                    break;
                }
            }
            return i.delete(r), i.delete(o), c;
        }
        function Ua(r) {
            return $l(ul(r, e, Ll), r + "");
        }
        function Ka(e) {
            return ut(e, mn, el);
        }
        function Wa(e) {
            return ut(e, gn, rl);
        }
        var Za = bo ? function(e) {
            return bo.get(e);
        } : Fn;
        function Qa(e) {
            for(var r = e.name + "", o = Ao[r], t = Le.call(Ao, r) ? o.length : 0; t--;){
                var a = o[t], l = a.func;
                if (null == l || l == e) return a.name;
            }
            return r;
        }
        function za(e) {
            return (Le.call(Go, "placeholder") ? Go : e).placeholder;
        }
        function Ya() {
            var e = (e = Go.iteratee || kn) === kn ? Tt : e;
            return arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function Ja(e, r) {
            var o, t;
            return e = e.__data__, ("string" == (t = typeof (o = r)) || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== o : null === o) ? e["string" == typeof r ? "string" : "hash"] : e.map;
        }
        function ja(e) {
            for(var r = mn(e), o = r.length; o--;){
                var t = r[o], a = e[t];
                r[o] = [
                    t,
                    a,
                    cl(a)
                ];
            }
            return r;
        }
        function qa(r, o) {
            return Pt(r = null == r ? e : r[o]) ? r : e;
        }
        var el = lo ? function(e) {
            return null == e ? [] : (e = Ae(e), sr(lo(e), function(r) {
                return Qr.call(e, r);
            }));
        } : Qn, rl = lo ? function(e) {
            for(var r = []; e;)xr(r, el(e)), e = Sr(e);
            return r;
        } : Qn, ol = pt;
        function tl(e, r, o) {
            for(var t = -1, a = (r = na(r, e)).length, l = !1; ++t < a;){
                var i = Tl(r[t]);
                if (!(l = null != e && o(e, i))) break;
                e = e[i];
            }
            return l || ++t != a ? l : !!(a = null == e ? 0 : e.length) && Ci(a) && il(i, a) && (Mi(e) || fi(e));
        }
        function al(e) {
            return "function" != typeof e.constructor || gl(e) ? {} : Lo(Sr(e));
        }
        function ll(e) {
            return Mi(e) || fi(e) || !!(Yr && e && e[Yr]);
        }
        function il(e, r) {
            var o = typeof e;
            return !!(r = null == r ? d : r) && ("number" == o || "symbol" != o && ue.test(e)) && -1 < e && e % 1 == 0 && e < r;
        }
        function nl(e, r, o) {
            var t;
            if (Bi(o)) return ("number" == (t = typeof r) ? Ti(o) && il(r, o.length) : "string" == t && r in o) && $i(o[r], e);
        }
        function dl(e, r) {
            var o;
            if (!Mi(e)) return "number" == (o = typeof e) || "symbol" == o || "boolean" == o || null == e || Ri(e) || Y.test(e) || !z.test(e) || null != r && e in Ae(r);
        }
        function sl(e) {
            var r = Qa(e), o = Go[r];
            return "function" == typeof o && r in No.prototype && (e === o || (r = Za(o)) && e === r[0]);
        }
        (re && ol(new re(new ArrayBuffer(1))) != G || ho && ol(new ho) != $ || So && ol(So.resolve()) != f || vo && ol(new vo) != P || o && ol(new o) != y) && (ol = function(r) {
            var o = pt(r);
            if (r = (r = o == A ? r.constructor : e) ? _l(r) : "") switch(r){
                case fo:
                    return G;
                case Mo:
                    return $;
                case Po:
                    return f;
                case To:
                    return P;
                case _o:
                    return y;
            }
            return o;
        });
        var ml = we ? Gi : zn;
        function gl(e) {
            var r = e && e.constructor;
            return e === ("function" == typeof r && r.prototype || ye);
        }
        function cl(e) {
            return e == e && !Bi(e);
        }
        function xl(r, o) {
            return function(t) {
                return null != t && t[r] === o && (o !== e || r in Ae(t));
            };
        }
        function ul(r, o, a) {
            return o = mo(o === e ? r.length - 1 : o, 0), function() {
                for(var e = arguments, l = -1, i = mo(e.length - o, 0), n = t(i); ++l < i;)n[l] = e[o + l];
                l = -1;
                for(var d = t(o + 1); ++l < o;)d[l] = e[l];
                return d[o] = a(n), ar(r, this, d);
            };
        }
        function pl(e, r) {
            return r.length < 2 ? e : xt(e, Kt(r, 0, -1));
        }
        function hl(e, r) {
            if (("constructor" !== r || "function" != typeof e[r]) && "__proto__" != r) return e[r];
        }
        var Sl = Al(Ht), vl = oo || function(e, r) {
            return Qe.setTimeout(e, r);
        }, $l = Al(Ze);
        function bl(e, r, o) {
            var t, a, l;
            return $l(e, (a = (r = (r = e = r += "").match(te)) ? r[1].split(ae) : [], l = o, ir(g, function(e) {
                var r = "_." + e[0];
                l & e[1] && !mr(a, r) && a.push(r);
            }), (o = (r = a.sort()).length) ? (r[t = o - 1] = (1 < o ? "& " : "") + r[t], r = r.join(2 < o ? ", " : " "), e.replace(oe, "{\n/* [wrapped with " + r + "] */\n")) : e));
        }
        function Al(r) {
            var o = 0, t = 0;
            return function() {
                var a = co(), l = 16 - (a - t);
                if (t = a, 0 < l) {
                    if (800 <= ++o) return arguments[0];
                } else o = 0;
                return r.apply(e, arguments);
            };
        }
        function fl(r, o) {
            var t = -1, a = r.length, l = a - 1;
            for(o = o === e ? a : o; ++t < o;){
                var i = kt(t, l), n = r[i];
                r[i] = r[t], r[t] = n;
            }
            return r.length = o, r;
        }
        Ml = (eo = ui(eo = function(e) {
            var r = [];
            return 46 === e.charCodeAt(0) && r.push(""), e.replace(J, function(e, o, t, a) {
                r.push(t ? a.replace(ne, "$1") : o || e);
            }), r;
        }, function(e) {
            return 500 === Ml.size && Ml.clear(), e;
        })).cache;
        var Ml, Pl = eo;
        function Tl(e) {
            var r;
            return "string" == typeof e || Ri(e) ? e : "0" == (r = e + "") && 1 / e == -1 / 0 ? "-0" : r;
        }
        function _l(e) {
            if (null != e) {
                try {
                    return Ge.call(e);
                } catch (e) {}
                try {
                    return e + "";
                } catch (e) {}
            }
            return "";
        }
        function yl(e) {
            var r;
            return e instanceof No ? e.clone() : ((r = new Eo(e.__wrapped__, e.__chain__)).__actions__ = Sa(e.__actions__), r.__index__ = e.__index__, r.__values__ = e.__values__, r);
        }
        function wl(e, r, o) {
            var t = null == e ? 0 : e.length;
            return t ? ((o = null == o ? 0 : Wi(o)) < 0 && (o = mo(t + o, 0)), $r(e, Ya(r, 3), o)) : -1;
        }
        function Gl(r, o, t) {
            var a, l = null == r ? 0 : r.length;
            return l ? (a = l - 1, t !== e && (a = Wi(t), a = t < 0 ? mo(l + a, 0) : go(a, l - 1)), $r(r, Ya(o, 3), a, !0)) : -1;
        }
        function Ll(e) {
            return null != e && e.length ? nt(e, 1) : [];
        }
        function Cl(r) {
            return r && r.length ? r[0] : e;
        }
        function Bl(r) {
            var o = null == r ? 0 : r.length;
            return o ? r[o - 1] : e;
        }
        function El(e, r) {
            return e && e.length && r && r.length ? Ot(e, r) : e;
        }
        re = Dt(function(e, r) {
            return _i(e) ? rt(e, nt(r, 1, _i, !0)) : [];
        }), So = Dt(function(r, o) {
            var t = Bl(o);
            return _i(t) && (t = e), _i(r) ? rt(r, nt(o, 1, _i, !0), Ya(t, 2)) : [];
        }), o = Dt(function(r, o) {
            var t = Bl(o);
            return _i(t) && (t = e), _i(r) ? rt(r, nt(o, 1, _i, !0), e, t) : [];
        }), we = Dt(function(e) {
            var r = cr(e, la);
            return r.length && r[0] === e[0] ? $t(r) : [];
        }), oo = Dt(function(r) {
            var o = Bl(r), t = cr(r, la);
            return o === Bl(t) ? o = e : t.pop(), t.length && t[0] === r[0] ? $t(t, Ya(o, 2)) : [];
        }), Ze = Dt(function(r) {
            var o = Bl(r), t = cr(r, la);
            return (o = "function" == typeof o ? o : e) && t.pop(), t.length && t[0] === r[0] ? $t(t, e, o) : [];
        }), eo = Dt(El);
        var Nl = Ua(function(e, r) {
            var o = null == e ? 0 : e.length, t = Yo(e, r);
            return It(e, cr(r, function(e) {
                return il(e, o) ? +e : e;
            }).sort(ua)), t;
        });
        function Ol(e) {
            return null == e ? e : po.call(e);
        }
        var Il = Dt(function(e) {
            return jt(nt(e, 1, _i, !0));
        }), kl = Dt(function(r) {
            var o = Bl(r);
            return _i(o) && (o = e), jt(nt(r, 1, _i, !0), Ya(o, 2));
        }), Xl = Dt(function(r) {
            var o = "function" == typeof (o = Bl(r)) ? o : e;
            return jt(nt(r, 1, _i, !0), e, o);
        });
        function Dl(e) {
            var r;
            return e && e.length ? (r = 0, e = sr(e, function(e) {
                return _i(e) && (r = mo(e.length, r), 1);
            }), wr(r, function(r) {
                return cr(e, Pr(r));
            })) : [];
        }
        function Rl(r, o) {
            return r && r.length ? (r = Dl(r), null == o ? r : cr(r, function(r) {
                return ar(o, e, r);
            })) : [];
        }
        var Fl = Dt(function(e, r) {
            return _i(e) ? rt(e, r) : [];
        }), Vl = Dt(function(e) {
            return ta(sr(e, _i));
        }), Hl = Dt(function(r) {
            var o = Bl(r);
            return _i(o) && (o = e), ta(sr(r, _i), Ya(o, 2));
        }), Ul = Dt(function(r) {
            var o = "function" == typeof (o = Bl(r)) ? o : e;
            return ta(sr(r, _i), e, o);
        }), Kl = Dt(Dl), Wl = Dt(function(r) {
            var o = "function" == typeof (o = 1 < (o = r.length) ? r[o - 1] : e) ? (r.pop(), o) : e;
            return Rl(r, o);
        });
        function Zl(e) {
            return (e = Go(e)).__chain__ = !0, e;
        }
        function Ql(e, r) {
            return r(e);
        }
        var zl = Ua(function(r) {
            function o(e) {
                return Yo(e, r);
            }
            var t = r.length, a = t ? r[0] : 0, l = this.__wrapped__;
            return !(1 < t || this.__actions__.length) && l instanceof No && il(a) ? ((l = l.slice(a, +a + (t ? 1 : 0))).__actions__.push({
                func: Ql,
                args: [
                    o
                ],
                thisArg: e
            }), new Eo(l, this.__chain__).thru(function(r) {
                return t && !r.length && r.push(e), r;
            })) : this.thru(o);
        }), Yl = $a(function(e, r, o) {
            Le.call(e, o) ? ++e[o] : zo(e, o, 1);
        }), Jl = _a(wl), jl = _a(Gl);
        function ql(e, r) {
            return (Mi(e) ? ir : ot)(e, Ya(r, 3));
        }
        function ei(e, r) {
            return (Mi(e) ? nr : tt)(e, Ya(r, 3));
        }
        var ri = $a(function(e, r, o) {
            Le.call(e, o) ? e[o].push(r) : zo(e, o, [
                r
            ]);
        }), oi = Dt(function(e, r, o) {
            var a = -1, l = "function" == typeof r, i = Ti(e) ? t(e.length) : [];
            return ot(e, function(e) {
                i[++a] = l ? ar(r, e, o) : bt(e, r, o);
            }), i;
        }), ti = $a(function(e, r, o) {
            zo(e, o, r);
        });
        function ai(e, r) {
            return (Mi(e) ? cr : wt)(e, Ya(r, 3));
        }
        var li = $a(function(e, r, o) {
            e[o ? 0 : 1].push(r);
        }, function() {
            return [
                [],
                []
            ];
        }), ii = Dt(function(e, r) {
            var o;
            return null == e ? [] : (1 < (o = r.length) && nl(e, r[0], r[1]) ? r = [] : 2 < o && nl(r[0], r[1], r[2]) && (r = [
                r[0]
            ]), Et(e, nt(r, 1), []));
        }), ni = ro || function() {
            return Qe.Date.now();
        };
        function di(r, o, t) {
            return o = t ? e : o, o = r && null == o ? r.length : o, Da(r, n, e, e, e, e, o);
        }
        function si(r, o) {
            var t;
            if ("function" != typeof o) throw new Pe(a);
            return r = Wi(r), function() {
                return 0 < --r && (t = o.apply(this, arguments)), r <= 1 && (o = e), t;
            };
        }
        var mi = Dt(function(e, r, o) {
            var t, a = 1;
            return o.length && (t = Fr(o, za(mi)), a |= 32), Da(e, a, r, o, t);
        }), gi = Dt(function(e, r, o) {
            var t, a = 3;
            return o.length && (t = Fr(o, za(gi)), a |= 32), Da(r, a, e, o, t);
        });
        function ci(r, o, t) {
            var l, i, n, d, s, m, g = 0, c = !1, x = !1, u = !0;
            if ("function" != typeof r) throw new Pe(a);
            function p(o) {
                var t = l, a = i;
                return l = i = e, g = o, d = r.apply(a, t);
            }
            function h(r) {
                var t = r - m;
                return m === e || o <= t || t < 0 || x && n <= r - g;
            }
            function S() {
                var e, r = ni();
                if (h(r)) return v(r);
                s = vl(S, (e = o - (r - m), x ? go(e, n - (r - g)) : e));
            }
            function v(r) {
                return s = e, u && l ? p(r) : (l = i = e, d);
            }
            function $() {
                var r = ni(), t = h(r);
                if (l = arguments, i = this, m = r, t) {
                    if (s === e) return g = r = m, s = vl(S, o), c ? p(r) : d;
                    if (x) return ma(s), s = vl(S, o), p(m);
                }
                return s === e && (s = vl(S, o)), d;
            }
            return o = Qi(o) || 0, Bi(t) && (c = !!t.leading, n = (x = "maxWait" in t) ? mo(Qi(t.maxWait) || 0, o) : n, u = "trailing" in t ? !!t.trailing : u), $.cancel = function() {
                s !== e && ma(s), g = 0, l = m = i = s = e;
            }, $.flush = function() {
                return s === e ? d : v(ni());
            }, $;
        }
        ro = Dt(function(e, r) {
            return et(e, 1, r);
        });
        var xi = Dt(function(e, r, o) {
            return et(e, Qi(r) || 0, o);
        });
        function ui(e, r) {
            if ("function" != typeof e || null != r && "function" != typeof r) throw new Pe(a);
            function o() {
                var t = arguments, a = r ? r.apply(this, t) : t[0], l = o.cache;
                return l.has(a) ? l.get(a) : (t = e.apply(this, t), o.cache = l.set(a, t) || l, t);
            }
            return o.cache = new (ui.Cache || ko), o;
        }
        function pi(e) {
            if ("function" != typeof e) throw new Pe(a);
            return function() {
                var r = arguments;
                switch(r.length){
                    case 0:
                        return !e.call(this);
                    case 1:
                        return !e.call(this, r[0]);
                    case 2:
                        return !e.call(this, r[0], r[1]);
                    case 3:
                        return !e.call(this, r[0], r[1], r[2]);
                }
                return !e.apply(this, r);
            };
        }
        ui.Cache = ko, da = da(function(e, r) {
            var o = (r = 1 == r.length && Mi(r[0]) ? cr(r[0], Lr(Ya())) : cr(nt(r, 1), Lr(Ya()))).length;
            return Dt(function(t) {
                for(var a = -1, l = go(t.length, o); ++a < l;)t[a] = r[a].call(this, t[a]);
                return ar(e, this, t);
            });
        });
        var hi = Dt(function(r, o) {
            var t = Fr(o, za(hi));
            return Da(r, 32, e, o, t);
        }), Si = Dt(function(r, o) {
            var t = Fr(o, za(Si));
            return Da(r, 64, e, o, t);
        }), vi = Ua(function(r, o) {
            return Da(r, 256, e, e, e, o);
        });
        function $i(e, r) {
            return e === r || e != e && r != r;
        }
        var bi = Na(ht), Ai = Na(function(e, r) {
            return r <= e;
        }), fi = At(function() {
            return arguments;
        }()) ? At : function(e) {
            return Ei(e) && Le.call(e, "callee") && !Qr.call(e, "callee");
        }, Mi = t.isArray, Pi = je ? Lr(je) : function(e) {
            return Ei(e) && pt(e) == w;
        };
        function Ti(e) {
            return null != e && Ci(e.length) && !Gi(e);
        }
        function _i(e) {
            return Ei(e) && Ti(e);
        }
        var yi = _e || zn;
        function wi(e) {
            var r;
            return !!Ei(e) && ((r = pt(e)) == h || "[object DOMException]" == r || "string" == typeof e.message && "string" == typeof e.name && !Ii(e));
        }
        function Gi(e) {
            return !!Bi(e) && ((e = pt(e)) == S || e == v || "[object AsyncFunction]" == e || "[object Proxy]" == e);
        }
        function Li(e) {
            return "number" == typeof e && e == Wi(e);
        }
        function Ci(e) {
            return "number" == typeof e && -1 < e && e % 1 == 0 && e <= d;
        }
        function Bi(e) {
            var r = typeof e;
            return null != e && ("object" == r || "function" == r);
        }
        function Ei(e) {
            return null != e && "object" == typeof e;
        }
        _e = qe ? Lr(qe) : function(e) {
            return Ei(e) && pt(e) == p;
        };
        var Ni = er ? Lr(er) : function(e) {
            return Ei(e) && ol(e) == $;
        };
        function Oi(e) {
            return "number" == typeof e || Ei(e) && pt(e) == b;
        }
        function Ii(e) {
            return !(!Ei(e) || pt(e) != A) && (null === (e = Sr(e)) || "function" == typeof (e = Le.call(e, "constructor") && e.constructor) && e instanceof e && Ge.call(e) == ke);
        }
        var ki = rr ? Lr(rr) : function(e) {
            return Ei(e) && pt(e) == M;
        }, Xi = or ? Lr(or) : function(e) {
            return Ei(e) && ol(e) == P;
        };
        function Di(e) {
            return "string" == typeof e || !Mi(e) && Ei(e) && pt(e) == T;
        }
        function Ri(e) {
            return "symbol" == typeof e || Ei(e) && pt(e) == _;
        }
        var Fi = tr ? Lr(tr) : function(e) {
            return Ei(e) && Ci(e.length) && !!Fe[pt(e)];
        }, Vi = Na(yt), Hi = Na(function(e, r) {
            return e <= r;
        });
        function Ui(e) {
            if (!e) return [];
            if (Ti(e)) return (Di(e) ? Ur : Sa)(e);
            if (Jr && e[Jr]) {
                for(var r, o = e[Jr](), t = []; !(r = o.next()).done;)t.push(r.value);
                return t;
            }
            var a = ol(e);
            return (a == $ ? Dr : a == P ? Vr : $n)(e);
        }
        function Ki(e) {
            return e ? (e = Qi(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
        }
        function Wi(e) {
            var r = (e = Ki(e)) % 1;
            return e == e ? r ? e - r : e : 0;
        }
        function Zi(e) {
            return e ? Jo(Wi(e), 0, m) : 0;
        }
        function Qi(e) {
            if ("number" == typeof e) return e;
            if (Ri(e)) return s;
            if ("string" != typeof (e = Bi(e) ? Bi(r = "function" == typeof e.valueOf ? e.valueOf() : e) ? r + "" : r : e)) return 0 === e ? e : +e;
            e = Gr(e);
            var r = ge.test(e);
            return r || xe.test(e) ? Ke(e.slice(2), r ? 2 : 8) : me.test(e) ? s : +e;
        }
        function zi(e) {
            return va(e, gn(e));
        }
        function Yi(e) {
            return null == e ? "" : Jt(e);
        }
        var Ji = ba(function(e, r) {
            if (gl(r) || Ti(r)) va(r, mn(r), e);
            else for(var o in r)Le.call(r, o) && Ko(e, o, r[o]);
        }), ji = ba(function(e, r) {
            va(r, gn(r), e);
        }), qi = ba(function(e, r, o, t) {
            va(r, gn(r), e, t);
        }), en = ba(function(e, r, o, t) {
            va(r, mn(r), e, t);
        }), rn = Ua(Yo), on = Dt(function(r, o) {
            r = Ae(r);
            var t = -1, a = o.length, l = 2 < a ? o[2] : e;
            for(l && nl(o[0], o[1], l) && (a = 1); ++t < a;)for(var i = o[t], n = gn(i), d = -1, s = n.length; ++d < s;){
                var m = n[d], g = r[m];
                (g === e || $i(g, ye[m]) && !Le.call(r, m)) && (r[m] = i[m]);
            }
            return r;
        }), tn = Dt(function(r) {
            return r.push(e, Fa), ar(xn, e, r);
        });
        function an(r, o, t) {
            return (r = null == r ? e : xt(r, o)) === e ? t : r;
        }
        function ln(e, r) {
            return null != e && tl(e, r, vt);
        }
        var nn = Ga(function(e, r, o) {
            e[r = null != r && "function" != typeof r.toString ? Oe.call(r) : r] = o;
        }, En(In)), dn = Ga(function(e, r, o) {
            null != r && "function" != typeof r.toString && (r = Oe.call(r)), Le.call(e, r) ? e[r].push(o) : e[r] = [
                o
            ];
        }, Ya), sn = Dt(bt);
        function mn(e) {
            return (Ti(e) ? Ro : _t)(e);
        }
        function gn(e) {
            return Ti(e) ? Ro(e, !0) : function(e) {
                if (!Bi(e)) {
                    var r = e, o = [];
                    if (null != r) for(var t in Ae(r))o.push(t);
                    return o;
                }
                var a, l = gl(e), i = [];
                for(a in e)("constructor" != a || !l && Le.call(e, a)) && i.push(a);
                return i;
            }(e);
        }
        var cn = ba(function(e, r, o) {
            Ct(e, r, o);
        }), xn = ba(function(e, r, o, t) {
            Ct(e, r, o, t);
        }), un = Ua(function(e, r) {
            var o = {};
            if (null != e) for(var t = !1, a = (r = cr(r, function(r) {
                return r = na(r, e), t = t || 1 < r.length, r;
            }), va(e, Wa(e), o), t && (o = jo(o, 7, Va)), r.length); a--;)qt(o, r[a]);
            return o;
        }), pn = Ua(function(e, r) {
            var o;
            return null == e ? {} : Nt(o = e, r, function(e, r) {
                return ln(o, r);
            });
        });
        function hn(e, r) {
            var o;
            return null == e ? {} : (o = cr(Wa(e), function(e) {
                return [
                    e
                ];
            }), r = Ya(r), Nt(e, o, function(e, o) {
                return r(e, o[0]);
            }));
        }
        var Sn = Xa(mn), vn = Xa(gn);
        function $n(e) {
            return null == e ? [] : Cr(e, mn(e));
        }
        var bn = Pa(function(e, r, o) {
            return r = r.toLowerCase(), e + (o ? An(r) : r);
        });
        function An(e) {
            return Gn(Yi(e).toLowerCase());
        }
        function fn(e) {
            return (e = Yi(e)) && e.replace(pe, Or).replace(Ne, "");
        }
        var Mn = Pa(function(e, r, o) {
            return e + (o ? "-" : "") + r.toLowerCase();
        }), Pn = Pa(function(e, r, o) {
            return e + (o ? " " : "") + r.toLowerCase();
        }), Tn = Ma("toLowerCase"), _n = Pa(function(e, r, o) {
            return e + (o ? "_" : "") + r.toLowerCase();
        }), yn = Pa(function(e, r, o) {
            return e + (o ? " " : "") + Gn(r);
        }), wn = Pa(function(e, r, o) {
            return e + (o ? " " : "") + r.toUpperCase();
        }), Gn = Ma("toUpperCase");
        function Ln(r, o, t) {
            return r = Yi(r), (o = t ? e : o) === e ? (t = r, Xe.test(t) ? r.match(Ie) || [] : r.match(le) || []) : r.match(o) || [];
        }
        var Cn = Dt(function(r, o) {
            try {
                return ar(r, e, o);
            } catch (r) {
                return wi(r) ? r : new ve(r);
            }
        }), Bn = Ua(function(e, r) {
            return ir(r, function(r) {
                r = Tl(r), zo(e, r, mi(e[r], e));
            }), e;
        });
        function En(e) {
            return function() {
                return e;
            };
        }
        var Nn = ya(), On = ya(!0);
        function In(e) {
            return e;
        }
        function kn(e) {
            return Tt("function" == typeof e ? e : jo(e, 1));
        }
        var Xn = Dt(function(e, r) {
            return function(o) {
                return bt(o, e, r);
            };
        }), Dn = Dt(function(e, r) {
            return function(o) {
                return bt(e, o, r);
            };
        });
        function Rn(e, r, o) {
            var t = mn(r), a = ct(r, t), l = (null != o || Bi(r) && (a.length || !t.length) || (o = r, r = e, e = this, a = ct(r, mn(r))), !(Bi(o) && "chain" in o && !o.chain)), i = Gi(e);
            return ir(a, function(o) {
                var t = r[o];
                e[o] = t, i && (e.prototype[o] = function() {
                    var r, o = this.__chain__;
                    return l || o ? (((r = e(this.__wrapped__)).__actions__ = Sa(this.__actions__)).push({
                        func: t,
                        args: arguments,
                        thisArg: e
                    }), r.__chain__ = o, r) : t.apply(e, xr([
                        this.value()
                    ], arguments));
                });
            }), e;
        }
        function Fn() {}
        var Vn = Ca(cr), Hn = Ca(dr), Un = Ca(hr);
        function Kn(e) {
            var r;
            return dl(e) ? Pr(Tl(e)) : (r = e, function(e) {
                return xt(e, r);
            });
        }
        var Wn = Ea(), Zn = Ea(!0);
        function Qn() {
            return [];
        }
        function zn() {
            return !1;
        }
        var Yn, Jn = La(function(e, r) {
            return e + r;
        }, 0), jn = Ia("ceil"), qn = La(function(e, r) {
            return e / r;
        }, 1), ed = Ia("floor"), rd = La(function(e, r) {
            return e * r;
        }, 1), od = Ia("round"), td = La(function(e, r) {
            return e - r;
        }, 0);
        return Go.after = function(e, r) {
            if ("function" != typeof r) throw new Pe(a);
            return e = Wi(e), function() {
                if (--e < 1) return r.apply(this, arguments);
            };
        }, Go.ary = di, Go.assign = Ji, Go.assignIn = ji, Go.assignInWith = qi, Go.assignWith = en, Go.at = rn, Go.before = si, Go.bind = mi, Go.bindAll = Bn, Go.bindKey = gi, Go.castArray = function() {
            var e;
            return arguments.length ? Mi(e = arguments[0]) ? e : [
                e
            ] : [];
        }, Go.chain = Zl, Go.chunk = function(r, o, a) {
            o = (a ? nl(r, o, a) : o === e) ? 1 : mo(Wi(o), 0);
            var l = null == r ? 0 : r.length;
            if (!l || o < 1) return [];
            for(var i = 0, n = 0, d = t(to(l / o)); i < l;)d[n++] = Kt(r, i, i += o);
            return d;
        }, Go.compact = function(e) {
            for(var r = -1, o = null == e ? 0 : e.length, t = 0, a = []; ++r < o;){
                var l = e[r];
                l && (a[t++] = l);
            }
            return a;
        }, Go.concat = function() {
            var e = arguments.length;
            if (!e) return [];
            for(var r = t(e - 1), o = arguments[0], a = e; a--;)r[a - 1] = arguments[a];
            return xr(Mi(o) ? Sa(o) : [
                o
            ], nt(r, 1));
        }, Go.cond = function(e) {
            var r = null == e ? 0 : e.length, o = Ya();
            return e = r ? cr(e, function(e) {
                if ("function" != typeof e[1]) throw new Pe(a);
                return [
                    o(e[0]),
                    e[1]
                ];
            }) : [], Dt(function(o) {
                for(var t = -1; ++t < r;){
                    var a = e[t];
                    if (ar(a[0], this, o)) return ar(a[1], this, o);
                }
            });
        }, Go.conforms = function(e) {
            var r, o;
            return r = jo(e, 1), o = mn(r), function(e) {
                return qo(e, r, o);
            };
        }, Go.constant = En, Go.countBy = Yl, Go.create = function(e, r) {
            return e = Lo(e), null == r ? e : Qo(e, r);
        }, Go.curry = function r(o, t, a) {
            return (o = Da(o, 8, e, e, e, e, e, t = a ? e : t)).placeholder = r.placeholder, o;
        }, Go.curryRight = function r(o, t, a) {
            return (o = Da(o, 16, e, e, e, e, e, t = a ? e : t)).placeholder = r.placeholder, o;
        }, Go.debounce = ci, Go.defaults = on, Go.defaultsDeep = tn, Go.defer = ro, Go.delay = xi, Go.difference = re, Go.differenceBy = So, Go.differenceWith = o, Go.drop = function(r, o, t) {
            var a = null == r ? 0 : r.length;
            return a ? Kt(r, (o = t || o === e ? 1 : Wi(o)) < 0 ? 0 : o, a) : [];
        }, Go.dropRight = function(r, o, t) {
            var a = null == r ? 0 : r.length;
            return a ? Kt(r, 0, (o = a - (o = t || o === e ? 1 : Wi(o))) < 0 ? 0 : o) : [];
        }, Go.dropRightWhile = function(e, r) {
            return e && e.length ? ra(e, Ya(r, 3), !0, !0) : [];
        }, Go.dropWhile = function(e, r) {
            return e && e.length ? ra(e, Ya(r, 3), !0) : [];
        }, Go.fill = function(r, o, t, a) {
            if (!(s = null == r ? 0 : r.length)) return [];
            t && "number" != typeof t && nl(r, o, t) && (t = 0, a = s);
            var l = r, i = o, n = t, d = a, s = l.length;
            for((n = Wi(n)) < 0 && (n = s < -n ? 0 : s + n), (d = d === e || s < d ? s : Wi(d)) < 0 && (d += s), d = d < n ? 0 : Zi(d); n < d;)l[n++] = i;
            return l;
        }, Go.filter = function(e, r) {
            return (Mi(e) ? sr : it)(e, Ya(r, 3));
        }, Go.flatMap = function(e, r) {
            return nt(ai(e, r), 1);
        }, Go.flatMapDeep = function(e, r) {
            return nt(ai(e, r), 1 / 0);
        }, Go.flatMapDepth = function(r, o, t) {
            return t = t === e ? 1 : Wi(t), nt(ai(r, o), t);
        }, Go.flatten = Ll, Go.flattenDeep = function(e) {
            return null != e && e.length ? nt(e, 1 / 0) : [];
        }, Go.flattenDepth = function(r, o) {
            return null != r && r.length ? nt(r, o = o === e ? 1 : Wi(o)) : [];
        }, Go.flip = function(e) {
            return Da(e, 512);
        }, Go.flow = Nn, Go.flowRight = On, Go.fromPairs = function(e) {
            for(var r = -1, o = null == e ? 0 : e.length, t = {}; ++r < o;){
                var a = e[r];
                t[a[0]] = a[1];
            }
            return t;
        }, Go.functions = function(e) {
            return null == e ? [] : ct(e, mn(e));
        }, Go.functionsIn = function(e) {
            return null == e ? [] : ct(e, gn(e));
        }, Go.groupBy = ri, Go.initial = function(e) {
            return null != e && e.length ? Kt(e, 0, -1) : [];
        }, Go.intersection = we, Go.intersectionBy = oo, Go.intersectionWith = Ze, Go.invert = nn, Go.invertBy = dn, Go.invokeMap = oi, Go.iteratee = kn, Go.keyBy = ti, Go.keys = mn, Go.keysIn = gn, Go.map = ai, Go.mapKeys = function(e, r) {
            var o = {};
            return r = Ya(r, 3), mt(e, function(e, t, a) {
                zo(o, r(e, t, a), e);
            }), o;
        }, Go.mapValues = function(e, r) {
            var o = {};
            return r = Ya(r, 3), mt(e, function(e, t, a) {
                zo(o, t, r(e, t, a));
            }), o;
        }, Go.matches = function(e) {
            return Gt(jo(e, 1));
        }, Go.matchesProperty = function(e, r) {
            return Lt(e, jo(r, 1));
        }, Go.memoize = ui, Go.merge = cn, Go.mergeWith = xn, Go.method = Xn, Go.methodOf = Dn, Go.mixin = Rn, Go.negate = pi, Go.nthArg = function(e) {
            return e = Wi(e), Dt(function(r) {
                return Bt(r, e);
            });
        }, Go.omit = un, Go.omitBy = function(e, r) {
            return hn(e, pi(Ya(r)));
        }, Go.once = function(e) {
            return si(2, e);
        }, Go.orderBy = function(r, o, t, a) {
            return null == r ? [] : Et(r, o = Mi(o) ? o : null == o ? [] : [
                o
            ], t = Mi(t = a ? e : t) ? t : null == t ? [] : [
                t
            ]);
        }, Go.over = Vn, Go.overArgs = da, Go.overEvery = Hn, Go.overSome = Un, Go.partial = hi, Go.partialRight = Si, Go.partition = li, Go.pick = pn, Go.pickBy = hn, Go.property = Kn, Go.propertyOf = function(r) {
            return function(o) {
                return null == r ? e : xt(r, o);
            };
        }, Go.pull = eo, Go.pullAll = El, Go.pullAllBy = function(e, r, o) {
            return e && e.length && r && r.length ? Ot(e, r, Ya(o, 2)) : e;
        }, Go.pullAllWith = function(r, o, t) {
            return r && r.length && o && o.length ? Ot(r, o, e, t) : r;
        }, Go.pullAt = Nl, Go.range = Wn, Go.rangeRight = Zn, Go.rearg = vi, Go.reject = function(e, r) {
            return (Mi(e) ? sr : it)(e, pi(Ya(r, 3)));
        }, Go.remove = function(e, r) {
            var o = [];
            if (e && e.length) {
                var t = -1, a = [], l = e.length;
                for(r = Ya(r, 3); ++t < l;){
                    var i = e[t];
                    r(i, t, e) && (o.push(i), a.push(t));
                }
                It(e, a);
            }
            return o;
        }, Go.rest = function(r, o) {
            if ("function" != typeof r) throw new Pe(a);
            return Dt(r, o = o === e ? o : Wi(o));
        }, Go.reverse = Ol, Go.sampleSize = function(r, o, t) {
            return o = (t ? nl(r, o, t) : o === e) ? 1 : Wi(o), (Mi(r) ? Vo : Ft)(r, o);
        }, Go.set = function(e, r, o) {
            return null == e ? e : Vt(e, r, o);
        }, Go.setWith = function(r, o, t, a) {
            return a = "function" == typeof a ? a : e, null == r ? r : Vt(r, o, t, a);
        }, Go.shuffle = function(e) {
            return (Mi(e) ? Ho : Ut)(e);
        }, Go.slice = function(r, o, t) {
            var a = null == r ? 0 : r.length;
            return a ? (t = t && "number" != typeof t && nl(r, o, t) ? (o = 0, a) : (o = null == o ? 0 : Wi(o), t === e ? a : Wi(t)), Kt(r, o, t)) : [];
        }, Go.sortBy = ii, Go.sortedUniq = function(e) {
            return e && e.length ? zt(e) : [];
        }, Go.sortedUniqBy = function(e, r) {
            return e && e.length ? zt(e, Ya(r, 2)) : [];
        }, Go.split = function(r, o, t) {
            return t && "number" != typeof t && nl(r, o, t) && (o = t = e), (t = t === e ? m : t >>> 0) ? (r = Yi(r)) && ("string" == typeof o || null != o && !ki(o)) && !(o = Jt(o)) && Xr(r) ? sa(Ur(r), 0, t) : r.split(o, t) : [];
        }, Go.spread = function(e, r) {
            if ("function" != typeof e) throw new Pe(a);
            return r = null == r ? 0 : mo(Wi(r), 0), Dt(function(o) {
                var t = o[r];
                return o = sa(o, 0, r), t && xr(o, t), ar(e, this, o);
            });
        }, Go.tail = function(e) {
            var r = null == e ? 0 : e.length;
            return r ? Kt(e, 1, r) : [];
        }, Go.take = function(r, o, t) {
            return r && r.length ? Kt(r, 0, (o = t || o === e ? 1 : Wi(o)) < 0 ? 0 : o) : [];
        }, Go.takeRight = function(r, o, t) {
            var a = null == r ? 0 : r.length;
            return a ? Kt(r, (o = a - (o = t || o === e ? 1 : Wi(o))) < 0 ? 0 : o, a) : [];
        }, Go.takeRightWhile = function(e, r) {
            return e && e.length ? ra(e, Ya(r, 3), !1, !0) : [];
        }, Go.takeWhile = function(e, r) {
            return e && e.length ? ra(e, Ya(r, 3)) : [];
        }, Go.tap = function(e, r) {
            return r(e), e;
        }, Go.throttle = function(e, r, o) {
            var t = !0, l = !0;
            if ("function" != typeof e) throw new Pe(a);
            return Bi(o) && (t = "leading" in o ? !!o.leading : t, l = "trailing" in o ? !!o.trailing : l), ci(e, r, {
                leading: t,
                maxWait: r,
                trailing: l
            });
        }, Go.thru = Ql, Go.toArray = Ui, Go.toPairs = Sn, Go.toPairsIn = vn, Go.toPath = function(e) {
            return Mi(e) ? cr(e, Tl) : Ri(e) ? [
                e
            ] : Sa(Pl(Yi(e)));
        }, Go.toPlainObject = zi, Go.transform = function(e, r, o) {
            var t, a = Mi(e), l = a || yi(e) || Fi(e);
            return r = Ya(r, 4), null == o && (t = e && e.constructor, o = l ? a ? new t : [] : Bi(e) && Gi(t) ? Lo(Sr(e)) : {}), (l ? ir : mt)(e, function(e, t, a) {
                return r(o, e, t, a);
            }), o;
        }, Go.unary = function(e) {
            return di(e, 1);
        }, Go.union = Il, Go.unionBy = kl, Go.unionWith = Xl, Go.uniq = function(e) {
            return e && e.length ? jt(e) : [];
        }, Go.uniqBy = function(e, r) {
            return e && e.length ? jt(e, Ya(r, 2)) : [];
        }, Go.uniqWith = function(r, o) {
            return o = "function" == typeof o ? o : e, r && r.length ? jt(r, e, o) : [];
        }, Go.unset = function(e, r) {
            return null == e || qt(e, r);
        }, Go.unzip = Dl, Go.unzipWith = Rl, Go.update = function(e, r, o) {
            return null == e ? e : ea(e, r, ia(o));
        }, Go.updateWith = function(r, o, t, a) {
            return a = "function" == typeof a ? a : e, null == r ? r : ea(r, o, ia(t), a);
        }, Go.values = $n, Go.valuesIn = function(e) {
            return null == e ? [] : Cr(e, gn(e));
        }, Go.without = Fl, Go.words = Ln, Go.wrap = function(e, r) {
            return hi(ia(r), e);
        }, Go.xor = Vl, Go.xorBy = Hl, Go.xorWith = Ul, Go.zip = Kl, Go.zipObject = function(e, r) {
            return aa(e || [], r || [], Ko);
        }, Go.zipObjectDeep = function(e, r) {
            return aa(e || [], r || [], Vt);
        }, Go.zipWith = Wl, Go.entries = Sn, Go.entriesIn = vn, Go.extend = ji, Go.extendWith = qi, Rn(Go, Go), Go.add = Jn, Go.attempt = Cn, Go.camelCase = bn, Go.capitalize = An, Go.ceil = jn, Go.clamp = function(r, o, t) {
            return t === e && (t = o, o = e), t !== e && (t = (t = Qi(t)) == t ? t : 0), o !== e && (o = (o = Qi(o)) == o ? o : 0), Jo(Qi(r), o, t);
        }, Go.clone = function(e) {
            return jo(e, 4);
        }, Go.cloneDeep = function(e) {
            return jo(e, 5);
        }, Go.cloneDeepWith = function(r, o) {
            return jo(r, 5, o = "function" == typeof o ? o : e);
        }, Go.cloneWith = function(r, o) {
            return jo(r, 4, o = "function" == typeof o ? o : e);
        }, Go.conformsTo = function(e, r) {
            return null == r || qo(e, r, mn(r));
        }, Go.deburr = fn, Go.defaultTo = function(e, r) {
            return null == e || e != e ? r : e;
        }, Go.divide = qn, Go.endsWith = function(r, o, t) {
            r = Yi(r), o = Jt(o);
            var a = r.length;
            return a = t = t === e ? a : Jo(Wi(t), 0, a), 0 <= (t -= o.length) && r.slice(t, a) == o;
        }, Go.eq = $i, Go.escape = function(e) {
            return (e = Yi(e)) && K.test(e) ? e.replace(H, Ir) : e;
        }, Go.escapeRegExp = function(e) {
            return (e = Yi(e)) && q.test(e) ? e.replace(j, "\\$&") : e;
        }, Go.every = function(r, o, t) {
            return (Mi(r) ? dr : at)(r, Ya(o = t && nl(r, o, t) ? e : o, 3));
        }, Go.find = Jl, Go.findIndex = wl, Go.findKey = function(e, r) {
            return vr(e, Ya(r, 3), mt);
        }, Go.findLast = jl, Go.findLastIndex = Gl, Go.findLastKey = function(e, r) {
            return vr(e, Ya(r, 3), gt);
        }, Go.floor = ed, Go.forEach = ql, Go.forEachRight = ei, Go.forIn = function(e, r) {
            return null == e ? e : dt(e, Ya(r, 3), gn);
        }, Go.forInRight = function(e, r) {
            return null == e ? e : st(e, Ya(r, 3), gn);
        }, Go.forOwn = function(e, r) {
            return e && mt(e, Ya(r, 3));
        }, Go.forOwnRight = function(e, r) {
            return e && gt(e, Ya(r, 3));
        }, Go.get = an, Go.gt = bi, Go.gte = Ai, Go.has = function(e, r) {
            return null != e && tl(e, r, St);
        }, Go.hasIn = ln, Go.head = Cl, Go.identity = In, Go.includes = function(e, r, o, t) {
            return e = Ti(e) ? e : $n(e), o = o && !t ? Wi(o) : 0, t = e.length, o < 0 && (o = mo(t + o, 0)), Di(e) ? o <= t && -1 < e.indexOf(r, o) : !!t && -1 < br(e, r, o);
        }, Go.indexOf = function(e, r, o) {
            var t = null == e ? 0 : e.length;
            return t ? br(e, r, e = (e = null == o ? 0 : Wi(o)) < 0 ? mo(t + e, 0) : e) : -1;
        }, Go.inRange = function(r, o, t) {
            return o = Ki(o), t === e ? (t = o, o = 0) : t = Ki(t), (r = r = Qi(r)) >= go(o, t) && r < mo(o, t);
        }, Go.invoke = sn, Go.isArguments = fi, Go.isArray = Mi, Go.isArrayBuffer = Pi, Go.isArrayLike = Ti, Go.isArrayLikeObject = _i, Go.isBoolean = function(e) {
            return !0 === e || !1 === e || Ei(e) && pt(e) == u;
        }, Go.isBuffer = yi, Go.isDate = _e, Go.isElement = function(e) {
            return Ei(e) && 1 === e.nodeType && !Ii(e);
        }, Go.isEmpty = function(e) {
            if (null != e) {
                if (Ti(e) && (Mi(e) || "string" == typeof e || "function" == typeof e.splice || yi(e) || Fi(e) || fi(e))) return !e.length;
                var r, o = ol(e);
                if (o == $ || o == P) return !e.size;
                if (gl(e)) return !_t(e).length;
                for(r in e)if (Le.call(e, r)) return !1;
            }
            return !0;
        }, Go.isEqual = function(e, r) {
            return ft(e, r);
        }, Go.isEqualWith = function(r, o, t) {
            var a = (t = "function" == typeof t ? t : e) ? t(r, o) : e;
            return a === e ? ft(r, o, e, t) : !!a;
        }, Go.isError = wi, Go.isFinite = function(e) {
            return "number" == typeof e && io(e);
        }, Go.isFunction = Gi, Go.isInteger = Li, Go.isLength = Ci, Go.isMap = Ni, Go.isMatch = function(e, r) {
            return e === r || Mt(e, r, ja(r));
        }, Go.isMatchWith = function(r, o, t) {
            return t = "function" == typeof t ? t : e, Mt(r, o, ja(o), t);
        }, Go.isNaN = function(e) {
            return Oi(e) && e != +e;
        }, Go.isNative = function(e) {
            if (ml(e)) throw new ve("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
            return Pt(e);
        }, Go.isNil = function(e) {
            return null == e;
        }, Go.isNull = function(e) {
            return null === e;
        }, Go.isNumber = Oi, Go.isObject = Bi, Go.isObjectLike = Ei, Go.isPlainObject = Ii, Go.isRegExp = ki, Go.isSafeInteger = function(e) {
            return Li(e) && -d <= e && e <= d;
        }, Go.isSet = Xi, Go.isString = Di, Go.isSymbol = Ri, Go.isTypedArray = Fi, Go.isUndefined = function(r) {
            return r === e;
        }, Go.isWeakMap = function(e) {
            return Ei(e) && ol(e) == y;
        }, Go.isWeakSet = function(e) {
            return Ei(e) && "[object WeakSet]" == pt(e);
        }, Go.join = function(e, r) {
            return null == e ? "" : no.call(e, r);
        }, Go.kebabCase = Mn, Go.last = Bl, Go.lastIndexOf = function(r, o, t) {
            var a = null == r ? 0 : r.length;
            if (!a) return -1;
            var l = a;
            if (t !== e && (l = (l = Wi(t)) < 0 ? mo(a + l, 0) : go(l, a - 1)), o != o) return $r(r, fr, l, !0);
            for(var i = r, n = o, d = l + 1; d--;)if (i[d] === n) return d;
            return d;
        }, Go.lowerCase = Pn, Go.lowerFirst = Tn, Go.lt = Vi, Go.lte = Hi, Go.max = function(r) {
            return r && r.length ? lt(r, In, ht) : e;
        }, Go.maxBy = function(r, o) {
            return r && r.length ? lt(r, Ya(o, 2), ht) : e;
        }, Go.mean = function(e) {
            return Mr(e, In);
        }, Go.meanBy = function(e, r) {
            return Mr(e, Ya(r, 2));
        }, Go.min = function(r) {
            return r && r.length ? lt(r, In, yt) : e;
        }, Go.minBy = function(r, o) {
            return r && r.length ? lt(r, Ya(o, 2), yt) : e;
        }, Go.stubArray = Qn, Go.stubFalse = zn, Go.stubObject = function() {
            return {};
        }, Go.stubString = function() {
            return "";
        }, Go.stubTrue = function() {
            return !0;
        }, Go.multiply = rd, Go.nth = function(r, o) {
            return r && r.length ? Bt(r, Wi(o)) : e;
        }, Go.noConflict = function() {
            return Qe._ === this && (Qe._ = He), this;
        }, Go.noop = Fn, Go.now = ni, Go.pad = function(e, r, o) {
            e = Yi(e);
            var t = (r = Wi(r)) ? Hr(e) : 0;
            return !r || r <= t ? e : Ba(ao(r = (r - t) / 2), o) + e + Ba(to(r), o);
        }, Go.padEnd = function(e, r, o) {
            e = Yi(e);
            var t = (r = Wi(r)) ? Hr(e) : 0;
            return r && t < r ? e + Ba(r - t, o) : e;
        }, Go.padStart = function(e, r, o) {
            e = Yi(e);
            var t = (r = Wi(r)) ? Hr(e) : 0;
            return r && t < r ? Ba(r - t, o) + e : e;
        }, Go.parseInt = function(e, r, o) {
            return r = o || null == r ? 0 : r && +r, xo(Yi(e).replace(ee, ""), r || 0);
        }, Go.random = function(r, o, t) {
            var a;
            return t && "boolean" != typeof t && nl(r, o, t) && (o = t = e), t === e && ("boolean" == typeof o ? (t = o, o = e) : "boolean" == typeof r && (t = r, r = e)), r === e && o === e ? (r = 0, o = 1) : (r = Ki(r), o === e ? (o = r, r = 0) : o = Ki(o)), o < r && (a = r, r = o, o = a), t || r % 1 || o % 1 ? (a = uo(), go(r + a * (o - r + Ue("1e-" + ((a + "").length - 1))), o)) : kt(r, o);
        }, Go.reduce = function(e, r, o) {
            var t = Mi(e) ? ur : _r, a = arguments.length < 3;
            return t(e, Ya(r, 4), o, a, ot);
        }, Go.reduceRight = function(e, r, o) {
            var t = Mi(e) ? pr : _r, a = arguments.length < 3;
            return t(e, Ya(r, 4), o, a, tt);
        }, Go.repeat = function(r, o, t) {
            return o = (t ? nl(r, o, t) : o === e) ? 1 : Wi(o), Xt(Yi(r), o);
        }, Go.replace = function() {
            var e = arguments, r = Yi(e[0]);
            return e.length < 3 ? r : r.replace(e[1], e[2]);
        }, Go.result = function(r, o, t) {
            var a = -1, l = (o = na(o, r)).length;
            for(l || (l = 1, r = e); ++a < l;){
                var i = null == r ? e : r[Tl(o[a])];
                i === e && (a = l, i = t), r = Gi(i) ? i.call(r) : i;
            }
            return r;
        }, Go.round = od, Go.runInContext = r, Go.sample = function(e) {
            return (Mi(e) ? Fo : Rt)(e);
        }, Go.size = function(e) {
            var r;
            return null == e ? 0 : Ti(e) ? Di(e) ? Hr(e) : e.length : (r = ol(e)) == $ || r == P ? e.size : _t(e).length;
        }, Go.snakeCase = _n, Go.some = function(r, o, t) {
            return (Mi(r) ? hr : Wt)(r, Ya(o = t && nl(r, o, t) ? e : o, 3));
        }, Go.sortedIndex = function(e, r) {
            return Zt(e, r);
        }, Go.sortedIndexBy = function(e, r, o) {
            return Qt(e, r, Ya(o, 2));
        }, Go.sortedIndexOf = function(e, r) {
            var o = null == e ? 0 : e.length;
            if (o) {
                var t = Zt(e, r);
                if (t < o && $i(e[t], r)) return t;
            }
            return -1;
        }, Go.sortedLastIndex = function(e, r) {
            return Zt(e, r, !0);
        }, Go.sortedLastIndexBy = function(e, r, o) {
            return Qt(e, r, Ya(o, 2), !0);
        }, Go.sortedLastIndexOf = function(e, r) {
            if (null != e && e.length) {
                var o = Zt(e, r, !0) - 1;
                if ($i(e[o], r)) return o;
            }
            return -1;
        }, Go.startCase = yn, Go.startsWith = function(e, r, o) {
            return e = Yi(e), o = null == o ? 0 : Jo(Wi(o), 0, e.length), r = Jt(r), e.slice(o, o + r.length) == r;
        }, Go.subtract = td, Go.sum = function(e) {
            return e && e.length ? yr(e, In) : 0;
        }, Go.sumBy = function(e, r) {
            return e && e.length ? yr(e, Ya(r, 2)) : 0;
        }, Go.template = function(r, o, t) {
            var a, l, i = Go.templateSettings;
            t && nl(r, o, t) && (o = e), r = Yi(r), o = qi({}, o, i, Ra);
            var n = mn(t = qi({}, o.imports, i.imports, Ra)), d = Cr(t, n), s = 0, m = (i = o.interpolate || he, "__p += '"), g = (t = fe((o.escape || he).source + "|" + i.source + "|" + (i === Q ? de : he).source + "|" + (o.evaluate || he).source + "|$", "g"), "//# sourceURL=" + (Le.call(o, "sourceURL") ? (o.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Re + "]") + "\n");
            if (r.replace(t, function(e, o, t, i, n, d) {
                return t = t || i, m += r.slice(s, d).replace(Se, kr), o && (a = !0, m += "' +\n__e(" + o + ") +\n'"), n && (l = !0, m += "';\n" + n + ";\n__p += '"), t && (m += "' +\n((__t = (" + t + ")) == null ? '' : __t) +\n'"), s = d + e.length, e;
            }), m += "';\n", i = Le.call(o, "variable") && o.variable) {
                if (ie.test(i)) throw new ve("Invalid `variable` option passed into `_.template`");
            } else m = "with (obj) {\n" + m + "\n}\n";
            if (m = (l ? m.replace(D, "") : m).replace(R, "$1").replace(F, "$1;"), m = "function(" + (i || "obj") + ") {\n" + (i ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (a ? ", __e = _.escape" : "") + (l ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + m + "return __p\n}", (t = Cn(function() {
                return $e(n, g + "return " + m).apply(e, d);
            })).source = m, wi(t)) throw t;
            return t;
        }, Go.times = function(e, r) {
            if ((e = Wi(e)) < 1 || d < e) return [];
            var o = m, t = go(e, m);
            for(r = Ya(r), e -= m, t = wr(t, r); ++o < e;)r(o);
            return t;
        }, Go.toFinite = Ki, Go.toInteger = Wi, Go.toLength = Zi, Go.toLower = function(e) {
            return Yi(e).toLowerCase();
        }, Go.toNumber = Qi, Go.toSafeInteger = function(e) {
            return e ? Jo(Wi(e), -d, d) : 0 === e ? e : 0;
        }, Go.toString = Yi, Go.toUpper = function(e) {
            return Yi(e).toUpperCase();
        }, Go.trim = function(r, o, t) {
            return (r = Yi(r)) && (t || o === e) ? Gr(r) : r && (o = Jt(o)) ? sa(t = Ur(r), Er(t, o = Ur(o)), Nr(t, o) + 1).join("") : r;
        }, Go.trimEnd = function(r, o, t) {
            return (r = Yi(r)) && (t || o === e) ? r.slice(0, Kr(r) + 1) : r && (o = Jt(o)) ? sa(t = Ur(r), 0, Nr(t, Ur(o)) + 1).join("") : r;
        }, Go.trimStart = function(r, o, t) {
            return (r = Yi(r)) && (t || o === e) ? r.replace(ee, "") : r && (o = Jt(o)) ? sa(t = Ur(r), Er(t, Ur(o))).join("") : r;
        }, Go.truncate = function(r, o) {
            var t, a, l = 30, i = "...";
            if (Bi(o) && (t = "separator" in o ? o.separator : t, l = "length" in o ? Wi(o.length) : l, i = "omission" in o ? Jt(o.omission) : i), o = (r = Yi(r)).length, (o = Xr(r) ? (a = Ur(r)).length : o) <= l) return r;
            if ((o = l - Hr(i)) < 1) return i;
            if (l = a ? sa(a, 0, o).join("") : r.slice(0, o), t !== e) {
                if (a && (o += l.length - o), ki(t)) {
                    if (r.slice(o).search(t)) {
                        var n, d = l;
                        for((t = t.global ? t : fe(t.source, Yi(se.exec(t)) + "g")).lastIndex = 0; n = t.exec(d);)var s = n.index;
                        l = l.slice(0, s === e ? o : s);
                    }
                } else r.indexOf(Jt(t), o) != o && -1 < (a = l.lastIndexOf(t)) && (l = l.slice(0, a));
            }
            return l + i;
        }, Go.unescape = function(e) {
            return (e = Yi(e)) && U.test(e) ? e.replace(V, Wr) : e;
        }, Go.uniqueId = function(e) {
            var r = ++Ce;
            return Yi(e) + r;
        }, Go.upperCase = wn, Go.upperFirst = Gn, Go.each = ql, Go.eachRight = ei, Go.first = Cl, Rn(Go, (Yn = {}, mt(Go, function(e, r) {
            Le.call(Go.prototype, r) || (Yn[r] = e);
        }), Yn), {
            chain: !1
        }), Go.VERSION = "4.17.21", ir([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(e) {
            Go[e].placeholder = Go;
        }), ir([
            "drop",
            "take"
        ], function(r, o) {
            No.prototype[r] = function(t) {
                t = t === e ? 1 : mo(Wi(t), 0);
                var a = this.__filtered__ && !o ? new No(this) : this.clone();
                return a.__filtered__ ? a.__takeCount__ = go(t, a.__takeCount__) : a.__views__.push({
                    size: go(t, m),
                    type: r + (a.__dir__ < 0 ? "Right" : "")
                }), a;
            }, No.prototype[r + "Right"] = function(e) {
                return this.reverse()[r](e).reverse();
            };
        }), ir([
            "filter",
            "map",
            "takeWhile"
        ], function(e, r) {
            var o = r + 1, t = 1 == o || 3 == o;
            No.prototype[e] = function(e) {
                var r = this.clone();
                return r.__iteratees__.push({
                    iteratee: Ya(e, 3),
                    type: o
                }), r.__filtered__ = r.__filtered__ || t, r;
            };
        }), ir([
            "head",
            "last"
        ], function(e, r) {
            var o = "take" + (r ? "Right" : "");
            No.prototype[e] = function() {
                return this[o](1).value()[0];
            };
        }), ir([
            "initial",
            "tail"
        ], function(e, r) {
            var o = "drop" + (r ? "" : "Right");
            No.prototype[e] = function() {
                return this.__filtered__ ? new No(this) : this[o](1);
            };
        }), No.prototype.compact = function() {
            return this.filter(In);
        }, No.prototype.find = function(e) {
            return this.filter(e).head();
        }, No.prototype.findLast = function(e) {
            return this.reverse().find(e);
        }, No.prototype.invokeMap = Dt(function(e, r) {
            return "function" == typeof e ? new No(this) : this.map(function(o) {
                return bt(o, e, r);
            });
        }), No.prototype.reject = function(e) {
            return this.filter(pi(Ya(e)));
        }, No.prototype.slice = function(r, o) {
            r = Wi(r);
            var t = this;
            return t.__filtered__ && (0 < r || o < 0) ? new No(t) : (r < 0 ? t = t.takeRight(-r) : r && (t = t.drop(r)), o !== e ? (o = Wi(o)) < 0 ? t.dropRight(-o) : t.take(o - r) : t);
        }, No.prototype.takeRightWhile = function(e) {
            return this.reverse().takeWhile(e).reverse();
        }, No.prototype.toArray = function() {
            return this.take(m);
        }, mt(No.prototype, function(r, o) {
            var t = /^(?:filter|find|map|reject)|While$/.test(o), a = /^(?:head|last)$/.test(o), l = Go[a ? "take" + ("last" == o ? "Right" : "") : o], i = a || /^find/.test(o);
            l && (Go.prototype[o] = function() {
                function o(e) {
                    return e = l.apply(Go, xr([
                        e
                    ], s)), a && x ? e[0] : e;
                }
                var n, d = this.__wrapped__, s = a ? [
                    1
                ] : arguments, m = d instanceof No, g = s[0], c = m || Mi(d), x = (c && t && "function" == typeof g && 1 != g.length && (m = c = !1), this.__chain__), u = (g = !!this.__actions__.length, i && !x);
                return m = m && !g, !i && c ? (d = m ? d : new No(this), (n = r.apply(d, s)).__actions__.push({
                    func: Ql,
                    args: [
                        o
                    ],
                    thisArg: e
                }), new Eo(n, x)) : u && m ? r.apply(this, s) : (n = this.thru(o), u ? a ? n.value()[0] : n.value() : n);
            });
        }), ir([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(e) {
            var r = Te[e], o = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", t = /^(?:pop|shift)$/.test(e);
            Go.prototype[e] = function() {
                var e, a = arguments;
                return t && !this.__chain__ ? (e = this.value(), r.apply(Mi(e) ? e : [], a)) : this[o](function(e) {
                    return r.apply(Mi(e) ? e : [], a);
                });
            };
        }), mt(No.prototype, function(e, r) {
            var o, t = Go[r];
            t && (o = t.name + "", Le.call(Ao, o) || (Ao[o] = []), Ao[o].push({
                name: r,
                func: t
            }));
        }), Ao[wa(e, 2).name] = [
            {
                name: "wrapper",
                func: e
            }
        ], No.prototype.clone = function() {
            var e = new No(this.__wrapped__);
            return e.__actions__ = Sa(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Sa(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Sa(this.__views__), e;
        }, No.prototype.reverse = function() {
            var e;
            return this.__filtered__ ? ((e = new No(this)).__dir__ = -1, e.__filtered__ = !0) : (e = this.clone()).__dir__ *= -1, e;
        }, No.prototype.value = function() {
            var e = this.__wrapped__.value(), r = this.__dir__, o = Mi(e), t = r < 0, a = o ? e.length : 0, l = function(e, r, o) {
                for(var t = -1, a = o.length; ++t < a;){
                    var l = o[t], i = l.size;
                    switch(l.type){
                        case "drop":
                            e += i;
                            break;
                        case "dropRight":
                            r -= i;
                            break;
                        case "take":
                            r = go(r, e + i);
                            break;
                        case "takeRight":
                            e = mo(e, r - i);
                    }
                }
                return {
                    start: e,
                    end: r
                };
            }(0, a, this.__views__), i = l.start, n = (l = l.end) - i, d = t ? l : i - 1, s = this.__iteratees__, m = s.length, g = 0, c = go(n, this.__takeCount__);
            if (!o || !t && a == n && c == n) return oa(e, this.__actions__);
            var x = [];
            e: for(; n-- && g < c;){
                for(var u = -1, p = e[d += r]; ++u < m;){
                    var h = (S = s[u]).iteratee, S = S.type;
                    if (h = h(p), 2 == S) p = h;
                    else if (!h) {
                        if (1 == S) continue e;
                        break e;
                    }
                }
                x[g++] = p;
            }
            return x;
        }, Go.prototype.at = zl, Go.prototype.chain = function() {
            return Zl(this);
        }, Go.prototype.commit = function() {
            return new Eo(this.value(), this.__chain__);
        }, Go.prototype.next = function() {
            this.__values__ === e && (this.__values__ = Ui(this.value()));
            var r = this.__index__ >= this.__values__.length;
            return {
                done: r,
                value: r ? e : this.__values__[this.__index__++]
            };
        }, Go.prototype.plant = function(_r1) {
            for(var o, t = this; t instanceof Bo;){
                var a = yl(t), l = (a.__index__ = 0, a.__values__ = e, o ? l.__wrapped__ = a : o = a, a);
                t = t.__wrapped__;
            }
            return l.__wrapped__ = _r1, o;
        }, Go.prototype.reverse = function() {
            var r = this.__wrapped__;
            return r instanceof No ? ((r = (r = this.__actions__.length ? new No(this) : r).reverse()).__actions__.push({
                func: Ql,
                args: [
                    Ol
                ],
                thisArg: e
            }), new Eo(r, this.__chain__)) : this.thru(Ol);
        }, Go.prototype.toJSON = Go.prototype.valueOf = Go.prototype.value = function() {
            return oa(this.__wrapped__, this.__actions__);
        }, Go.prototype.first = Go.prototype.head, Jr && (Go.prototype[Jr] = function() {
            return this;
        }), Go;
    }();
    ze ? ((ze.exports = Zr)._ = Zr, t._ = Zr) : Qe._ = Zr;
}).call($cdf7e442067abc24$var$zo), $cdf7e442067abc24$var$jo.exports);
const $cdf7e442067abc24$var$et = $cdf7e442067abc24$var$ge('<div class="flex items-center justify-center max-w-[128px] mr-[10px] p-0 m-0"><img class="w-full h-full bg-cover">'), $cdf7e442067abc24$var$rt = $cdf7e442067abc24$var$ge('<div class="mt-2"><div>'), $cdf7e442067abc24$var$ot = $cdf7e442067abc24$var$ge('<span class="prose">'), $cdf7e442067abc24$var$tt = $cdf7e442067abc24$var$ge('<div class="mb-6">'), $cdf7e442067abc24$var$at = $cdf7e442067abc24$var$ge('<div class="flex flex-row items-start flex-wrap w-full gap-2">'), $cdf7e442067abc24$var$lt = "#f7f8ff", $cdf7e442067abc24$var$it = "#303235", $cdf7e442067abc24$var$nt = (e)=>{
    let r;
    var o;
    return $cdf7e442067abc24$var$To.setOptions({
        isNoP: !0,
        sanitize: void 0 === e.renderHTML || !e.renderHTML
    }), $cdf7e442067abc24$var$y(()=>{
        r && (r.innerHTML = $cdf7e442067abc24$var$To.parse(`**\u{2705} ${e.agentName}** \n\n` + e.agentMessage), r.querySelectorAll("a").forEach((e)=>{
            e.target = "_blank";
        }));
    }), $cdf7e442067abc24$var$$e(o = $cdf7e442067abc24$var$tt(), (()=>{
        const r = $cdf7e442067abc24$var$T(()=>!!e.agentArtifacts);
        return ()=>{
            var o;
            return r() && ($cdf7e442067abc24$var$$e(o = $cdf7e442067abc24$var$at(), $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                get each () {
                    var r1 = e.agentArtifacts, o1 = $cdf7e442067abc24$var$qo.cloneDeep(r1);
                    for(let r = 0; r < o1.length; r++){
                        var t = o1[r];
                        !t || "png" !== t.type && "jpeg" !== t.type || (t = t.data, o1[r].data = `${e.apiHost}/api/v1/get-upload-file?chatflowId=${e.chatflowid}&chatId=${e.chatId}&fileName=` + t.replace("FILE-STORAGE::", ""));
                    }
                    return o1;
                },
                children: (r)=>null !== r ? $cdf7e442067abc24$var$T(()=>{
                        var o, t = r;
                        if ("png" === t.type || "jpeg" === t.type) {
                            const e = t.data;
                            return $cdf7e442067abc24$var$xe((o = $cdf7e442067abc24$var$et()).firstChild, "src", e), o;
                        }
                        if ("html" === t.type) {
                            const e = t.data;
                            return (o = $cdf7e442067abc24$var$rt()).firstChild.innerHTML = e, o;
                        }
                        {
                            const r = t.data;
                            {
                                const o = $cdf7e442067abc24$var$ot();
                                return o.style.setProperty("border-radius", "6px"), $cdf7e442067abc24$var$M((t)=>{
                                    var a = $cdf7e442067abc24$var$To.parse(r), l = e.backgroundColor ?? $cdf7e442067abc24$var$lt, i = e.textColor ?? $cdf7e442067abc24$var$it, n = e.fontSize ? e.fontSize + "px" : "16px";
                                    return a !== t._v$ && (o.innerHTML = t._v$ = a), l !== t._v$2 && (null != (t._v$2 = l) ? o.style.setProperty("background-color", l) : o.style.removeProperty("background-color")), i !== t._v$3 && (null != (t._v$3 = i) ? o.style.setProperty("color", i) : o.style.removeProperty("color")), n !== t._v$4 && (null != (t._v$4 = n) ? o.style.setProperty("font-size", n) : o.style.removeProperty("font-size")), t;
                                }, {
                                    _v$: void 0,
                                    _v$2: void 0,
                                    _v$3: void 0,
                                    _v$4: void 0
                                }), o;
                            }
                        }
                    }) : null
            })), o);
        };
    })(), null), $cdf7e442067abc24$var$$e(o, (()=>{
        const o = $cdf7e442067abc24$var$T(()=>!!e.agentMessage);
        return ()=>o() && (()=>{
                const o = $cdf7e442067abc24$var$ot();
                return "function" == typeof r ? $cdf7e442067abc24$var$ve(r, o) : r = o, $cdf7e442067abc24$var$M((r)=>{
                    var t = e.backgroundColor ?? $cdf7e442067abc24$var$lt, a = e.textColor ?? $cdf7e442067abc24$var$it, l = e.fontSize ? e.fontSize + "px" : "16px";
                    return t !== r._v$5 && (null != (r._v$5 = t) ? o.style.setProperty("background-color", t) : o.style.removeProperty("background-color")), a !== r._v$6 && (null != (r._v$6 = a) ? o.style.setProperty("color", a) : o.style.removeProperty("color")), l !== r._v$7 && (null != (r._v$7 = l) ? o.style.setProperty("font-size", l) : o.style.removeProperty("font-size")), r;
                }, {
                    _v$5: void 0,
                    _v$6: void 0,
                    _v$7: void 0
                }), o;
            })();
    })(), null), o;
}, $cdf7e442067abc24$var$dt = $cdf7e442067abc24$var$ge('<div data-modal-target="defaultModal" data-modal-toggle="defaultModal" class="flex justify-start mb-2 items-start animate-fade-in host-container hover:brightness-90 active:brightness-75"><span class="px-2 py-1 ml-1 whitespace-pre-wrap max-w-full chatbot-host-bubble" data-testid="host-bubble">'), $cdf7e442067abc24$var$st = (e)=>{
    var r, o;
    return o = (r = $cdf7e442067abc24$var$dt()).firstChild, r.$$click = ()=>e.onSourceClick?.(), o.style.setProperty("width", "max-content"), o.style.setProperty("max-width", "80px"), o.style.setProperty("font-size", "13px"), o.style.setProperty("border-radius", "15px"), o.style.setProperty("cursor", "pointer"), o.style.setProperty("text-overflow", "ellipsis"), o.style.setProperty("overflow", "hidden"), o.style.setProperty("white-space", "nowrap"), $cdf7e442067abc24$var$$e(o, ()=>e.pageContent), r;
}, $cdf7e442067abc24$var$mt = ($cdf7e442067abc24$var$ce([
    "click"
]), Symbol("store-raw")), $cdf7e442067abc24$var$gt = Symbol("store-node");
function $cdf7e442067abc24$var$ct(e) {
    let r = e[$cdf7e442067abc24$var$n];
    if (!r && (Object.defineProperty(e, $cdf7e442067abc24$var$n, {
        value: r = new Proxy(e, $cdf7e442067abc24$var$$t)
    }), !Array.isArray(e))) {
        var o = Object.keys(e), t = Object.getOwnPropertyDescriptors(e);
        for(let l = 0, i = o.length; l < i; l++){
            var a = o[l];
            t[a].get && Object.defineProperty(e, a, {
                enumerable: t[a].enumerable,
                get: t[a].get.bind(r)
            });
        }
    }
    return r;
}
function $cdf7e442067abc24$var$xt(e) {
    let r;
    return null != e && "object" == typeof e && (e[$cdf7e442067abc24$var$n] || !(r = Object.getPrototypeOf(e)) || r === Object.prototype || Array.isArray(e));
}
function $cdf7e442067abc24$var$ut(e, r = new Set) {
    let o, t, a, l;
    if (o = null != e && e[$cdf7e442067abc24$var$mt]) return o;
    if ($cdf7e442067abc24$var$xt(e) && !r.has(e)) {
        if (Array.isArray(e)) {
            Object.isFrozen(e) ? e = e.slice(0) : r.add(e);
            for(let o = 0, l = e.length; o < l; o++)a = e[o], (t = $cdf7e442067abc24$var$ut(a, r)) !== a && (e[o] = t);
        } else {
            Object.isFrozen(e) ? e = Object.assign({}, e) : r.add(e);
            var i = Object.keys(e), n = Object.getOwnPropertyDescriptors(e);
            for(let o = 0, d = i.length; o < d; o++)n[l = i[o]].get || (a = e[l], (t = $cdf7e442067abc24$var$ut(a, r)) !== a && (e[l] = t));
        }
    }
    return e;
}
function $cdf7e442067abc24$var$pt(e) {
    let r = e[$cdf7e442067abc24$var$gt];
    return r || Object.defineProperty(e, $cdf7e442067abc24$var$gt, {
        value: r = {}
    }), r;
}
function $cdf7e442067abc24$var$ht(e, r, o) {
    return e[r] || (e[r] = $cdf7e442067abc24$var$vt(o));
}
function $cdf7e442067abc24$var$St(e) {
    $cdf7e442067abc24$var$G() && ((e = $cdf7e442067abc24$var$pt(e))._ || (e._ = $cdf7e442067abc24$var$vt()))();
}
function $cdf7e442067abc24$var$vt(e) {
    var [e, r] = $cdf7e442067abc24$var$f(e, {
        equals: !1,
        internal: !0
    });
    return e.$ = r, e;
}
const $cdf7e442067abc24$var$$t = {
    get (e, r, o) {
        if (r === $cdf7e442067abc24$var$mt) return e;
        if (r === $cdf7e442067abc24$var$n) return o;
        if (r === $cdf7e442067abc24$var$d) return $cdf7e442067abc24$var$St(e), o;
        var t = (o = $cdf7e442067abc24$var$pt(e)).hasOwnProperty(r);
        let a = t ? o[r]() : e[r];
        return r !== $cdf7e442067abc24$var$gt && "__proto__" !== r && $cdf7e442067abc24$var$xt(a = t || (t = Object.getOwnPropertyDescriptor(e, r), !$cdf7e442067abc24$var$G()) || "function" == typeof a && !e.hasOwnProperty(r) || t && t.get ? a : $cdf7e442067abc24$var$ht(o, r, a)()) ? $cdf7e442067abc24$var$ct(a) : a;
    },
    has (e, r) {
        return r === $cdf7e442067abc24$var$mt || r === $cdf7e442067abc24$var$n || r === $cdf7e442067abc24$var$d || r === $cdf7e442067abc24$var$gt || "__proto__" === r || (this.get(e, r, e), r in e);
    },
    set: ()=>!0,
    deleteProperty: ()=>!0,
    ownKeys: function(e) {
        return $cdf7e442067abc24$var$St(e), Reflect.ownKeys(e);
    },
    getOwnPropertyDescriptor: function(e, r) {
        var o = Reflect.getOwnPropertyDescriptor(e, r);
        return o && !o.get && o.configurable && r !== $cdf7e442067abc24$var$n && r !== $cdf7e442067abc24$var$gt && (delete o.value, delete o.writable, o.get = ()=>e[$cdf7e442067abc24$var$n][r]), o;
    }
};
function $cdf7e442067abc24$var$bt(e, r, o, t = !1) {
    if (t || e[r] !== o) {
        t = e[r];
        var a = e.length;
        void 0 === o ? delete e[r] : e[r] = o;
        let l, i = $cdf7e442067abc24$var$pt(e);
        (l = $cdf7e442067abc24$var$ht(i, r, t)) && l.$(()=>o), Array.isArray(e) && e.length !== a && (l = $cdf7e442067abc24$var$ht(i, "length", a)) && l.$(e.length), (l = i._) && l.$();
    }
}
function $cdf7e442067abc24$var$At(e, r) {
    var o = Object.keys(r);
    for(let a = 0; a < o.length; a += 1){
        var t = o[a];
        $cdf7e442067abc24$var$bt(e, t, r[t]);
    }
}
function $cdf7e442067abc24$var$ft(e, r, o = []) {
    let t, a = e;
    if (1 < r.length) {
        var l = typeof (t = r.shift()), i = Array.isArray(e);
        if (Array.isArray(t)) {
            for(let a = 0; a < t.length; a++)$cdf7e442067abc24$var$ft(e, [
                t[a]
            ].concat(r), o);
            return;
        }
        if (i && "function" == l) {
            for(let a = 0; a < e.length; a++)t(e[a], a) && $cdf7e442067abc24$var$ft(e, [
                a
            ].concat(r), o);
            return;
        }
        if (i && "object" == l) {
            var { from: i = 0, to: n = e.length - 1, by: d = 1 } = t;
            for(let t = i; t <= n; t += d)$cdf7e442067abc24$var$ft(e, [
                t
            ].concat(r), o);
            return;
        }
        if (1 < r.length) return void $cdf7e442067abc24$var$ft(e[t], r, [
            t
        ].concat(o));
        a = e[t], o = [
            t
        ].concat(o);
    }
    let s = r[0];
    "function" == typeof s && (s = s(a, o)) === a || void 0 === t && null == s || (s = $cdf7e442067abc24$var$ut(s), void 0 === t || $cdf7e442067abc24$var$xt(a) && $cdf7e442067abc24$var$xt(s) && !Array.isArray(s) ? $cdf7e442067abc24$var$At(a, s) : $cdf7e442067abc24$var$bt(e, t, s));
}
function $cdf7e442067abc24$var$Mt(...[e]) {
    const r = $cdf7e442067abc24$var$ut(e || {}), o = Array.isArray(r);
    return [
        $cdf7e442067abc24$var$ct(r),
        function(...e) {
            !function(e) {
                $cdf7e442067abc24$var$k(e, !1);
            }(()=>{
                o && 1 === e.length ? function(e, r) {
                    if (r = $cdf7e442067abc24$var$ut(r = "function" == typeof r ? r(e) : r), Array.isArray(r)) {
                        if (e !== r) {
                            let t = 0, a = r.length;
                            for(; t < a; t++){
                                var o = r[t];
                                e[t] !== o && $cdf7e442067abc24$var$bt(e, t, o);
                            }
                            $cdf7e442067abc24$var$bt(e, "length", a);
                        }
                    } else $cdf7e442067abc24$var$At(e, r);
                }(r, e[0]) : $cdf7e442067abc24$var$ft(r, e);
            });
        }
    ];
}
const $cdf7e442067abc24$var$Pt = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="transition-transform duration-200"><path d="m9 18 6-6-6-6">'), $cdf7e442067abc24$var$Tt = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="transition-transform duration-200"><path d="m6 9 6 6 6-6">'), $cdf7e442067abc24$var$_t = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z">'), $cdf7e442067abc24$var$yt = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2">'), $cdf7e442067abc24$var$wt = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path><polyline points="14 2 14 8 20 8">'), $cdf7e442067abc24$var$Gt = $cdf7e442067abc24$var$ge("<style>"), $cdf7e442067abc24$var$Lt = $cdf7e442067abc24$var$ge("<div>"), $cdf7e442067abc24$var$Ct = $cdf7e442067abc24$var$ge('<div class="tree-item-end-icon">'), $cdf7e442067abc24$var$Bt = $cdf7e442067abc24$var$ge('<div class="tree-item-children">'), $cdf7e442067abc24$var$Et = $cdf7e442067abc24$var$ge('<div class="tree-item-root"><div><div class="tree-item-icon-container mr-1"></div><div class="tree-item-icon mr-2"></div><div class="tree-item-label flex-grow">'), $cdf7e442067abc24$var$Nt = function(e, r) {
    var o = Symbol("context");
    return {
        id: o,
        Provider: $cdf7e442067abc24$var$W(o),
        defaultValue: e
    };
}({
    expandedItems: [],
    selectedItem: null,
    highlightedItems: [],
    toggleItem: ()=>{},
    selectItem: ()=>{},
    isExpanded: ()=>!1,
    isSelected: ()=>!1,
    isHighlighted: ()=>!1
}), $cdf7e442067abc24$var$Ot = ()=>$cdf7e442067abc24$var$Pt(), $cdf7e442067abc24$var$It = ()=>$cdf7e442067abc24$var$Tt(), $cdf7e442067abc24$var$kt = ()=>$cdf7e442067abc24$var$_t(), $cdf7e442067abc24$var$Xt = ()=>$cdf7e442067abc24$var$yt(), $cdf7e442067abc24$var$Dt = ()=>$cdf7e442067abc24$var$wt(), $cdf7e442067abc24$var$Rt = (e)=>{
    var r = $cdf7e442067abc24$var$q({
        defaultExpanded: [],
        indentationLevel: 16
    }, e);
    const [o, t] = $cdf7e442067abc24$var$Mt({
        expandedItems: r.defaultExpanded,
        selectedItem: null,
        highlightedItems: e.highlightItems || []
    });
    $cdf7e442067abc24$var$P(()=>{
        e.highlightItems && t("highlightedItems", [
            ...e.highlightItems
        ]);
    });
    var a = {
        expandedItems: o.expandedItems,
        selectedItem: o.selectedItem,
        highlightedItems: o.highlightedItems,
        toggleItem: (e)=>{
            t("expandedItems", (r)=>r.includes(e) ? r.filter((r)=>r !== e) : [
                    ...r,
                    e
                ]);
        },
        selectItem: (r)=>{
            t("selectedItem", r), e.onNodeSelect && e.onNodeSelect(r);
        },
        isExpanded: (e)=>o.expandedItems.includes(e),
        isSelected: (e)=>o.selectedItem === e,
        isHighlighted: (e)=>o.highlightedItems.includes(e)
    };
    const l = `\n    .tree-item-children {\n      padding-left: ${r.indentationLevel}px !important;\n    }\n  `;
    return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Nt.Provider, {
        value: a,
        get children () {
            var r1;
            return [
                ($cdf7e442067abc24$var$$e(r1 = $cdf7e442067abc24$var$Gt(), l), r1),
                (()=>{
                    const r = $cdf7e442067abc24$var$Lt();
                    return $cdf7e442067abc24$var$$e(r, ()=>e.children), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$ue(r, "tree-view " + (e.class || ""))), r;
                })()
            ];
        }
    });
}, $cdf7e442067abc24$var$Ft = (e)=>{
    const r = $cdf7e442067abc24$var$L($cdf7e442067abc24$var$Nt), o = !!e.children, t = void 0 !== e.isLeaf ? e.isLeaf : !o, a = (t)=>{
        t.stopPropagation(), r.selectItem(e.itemId), o && r.toggleItem(e.itemId);
    };
    {
        const l = $cdf7e442067abc24$var$Et(), i = l.firstChild, n = i.firstChild, d = n.nextSibling, s = d.nextSibling;
        return i.$$click = a, $cdf7e442067abc24$var$$e(n, !t && $cdf7e442067abc24$var$z($cdf7e442067abc24$var$we, {
            get component () {
                return r.isExpanded(e.itemId) ? $cdf7e442067abc24$var$It : $cdf7e442067abc24$var$Ot;
            }
        })), $cdf7e442067abc24$var$$e(d, (()=>{
            const o = $cdf7e442067abc24$var$T(()=>!!e.icon);
            return ()=>{
                if (o()) return e.icon;
                {
                    const o = $cdf7e442067abc24$var$T(()=>!(!e.expandedIcon || !r.isExpanded(e.itemId)));
                    return ()=>o() ? e.expandedIcon : t ? $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Dt, {}) : $cdf7e442067abc24$var$T((()=>{
                            const o = $cdf7e442067abc24$var$T(()=>!!r.isExpanded(e.itemId));
                            return ()=>o() ? $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Xt, {}) : $cdf7e442067abc24$var$z($cdf7e442067abc24$var$kt, {});
                        })());
                }
            };
        })()), $cdf7e442067abc24$var$$e(s, ()=>e.label), $cdf7e442067abc24$var$$e(i, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return e.endIcon;
            },
            get children () {
                var r1 = $cdf7e442067abc24$var$Ct();
                return $cdf7e442067abc24$var$$e(r1, ()=>e.endIcon), r1;
            }
        }), null), $cdf7e442067abc24$var$$e(l, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return o && r.isExpanded(e.itemId);
            },
            get children () {
                var r2 = $cdf7e442067abc24$var$Bt();
                return $cdf7e442067abc24$var$$e(r2, ()=>e.children), r2;
            }
        }), null), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$ue(i, `tree-item-content flex items-center py-2 px-1 rounded cursor-pointer ${r.isSelected(e.itemId) ? "selected" : ""} ` + (r.isHighlighted(e.itemId) ? "highlighted" : ""))), l;
    }
}, $cdf7e442067abc24$var$Vt = ($cdf7e442067abc24$var$ce([
    "click"
]), $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1">')), $cdf7e442067abc24$var$Ht = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12">'), $cdf7e442067abc24$var$Ut = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01">'), $cdf7e442067abc24$var$Kt = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFC107" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14">'), $cdf7e442067abc24$var$Wt = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2196F3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 16l4-4-4-4"></path><path d="M8 12h8">'), $cdf7e442067abc24$var$Zt = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F44336" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16">'), $cdf7e442067abc24$var$Qt = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="transition-transform duration-200"><path d="m6 9 6 6 6-6">'), $cdf7e442067abc24$var$zt = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="transition-transform duration-200"><path d="m9 18 6-6-6-6">'), $cdf7e442067abc24$var$Yt = $cdf7e442067abc24$var$ge('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF9800" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><rect x="9" y="9" width="6" height="6">'), $cdf7e442067abc24$var$Jt = $cdf7e442067abc24$var$ge('<div class="flex items-center"><span>'), $cdf7e442067abc24$var$jt = $cdf7e442067abc24$var$ge('<div class="mr-1 text-blue-500"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1"><path d="M17 2.1l4 4-4 4"></path><path d="M3 12.2v-2a4 4 0 0 1 4-4h12.8M7 21.9l-4-4 4-4"></path><path d="M21 11.8v2a4 4 0 0 1-4 4H4.2">'), $cdf7e442067abc24$var$qt = $cdf7e442067abc24$var$ge('<div class="status-icon">'), $cdf7e442067abc24$var$ea = $cdf7e442067abc24$var$ge('<div class="border-t"><div class="p-4 mb-2">'), $cdf7e442067abc24$var$ra = $cdf7e442067abc24$var$ge('<div><div class="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-100 transition-colors duration-150"><div class="flex items-center space-x-2"><div class="flex-shrink-0"></div><h2 class="font-semibold flex items-center"></h2></div></div><style>\n        .json-viewer .string { color: #7ac35c; }\n        .json-viewer .number { color: #e08331; }\n        .json-viewer .boolean { color: #326dc3; }\n        .json-viewer .null { color: #a951ad; }\n        .json-viewer .key { color: #d73e3e; font-weight: bold; }\n\n        /* Custom tree view styles */\n        .tree-item-content.selected {\n          background-color: rgba(25, 118, 210, 0.15);\n          font-weight: 500;\n          border-left: 3px solid #1976d2;\n          padding-left: calc(0.25rem - 3px) !important;\n          box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.05);\n          transform: translateX(2px);\n        }\n        .tree-item-content.selected:hover {\n          background-color: rgba(25, 118, 210, 0.25);\n        }\n        .tree-item-content {\n          border-left: 3px solid transparent;\n          transition: background-color 0.2s ease, \n                      border-color 0.2s ease, \n                      transform 0.2s ease,\n                      box-shadow 0.2s ease;\n        }\n        \n        /* Animation for node details panel */\n        .node-details-panel {\n          transition: opacity 0.2s ease, transform 0.2s ease;\n        }\n        \n        /* Enhanced status icons */\n        .status-icon {\n          filter: drop-shadow(0 1px 1px rgba(0,0,0,0.1));\n        }\n      '), $cdf7e442067abc24$var$oa = $cdf7e442067abc24$var$ge('<span class="ml-2 status-icon">'), $cdf7e442067abc24$var$ta = $cdf7e442067abc24$var$ge('<div class="mx-4 mb-4 p-4 rounded border node-details-panel"><div class="flex flex-col md:flex-row justify-between items-start mb-3"><div class="flex items-center mb-2 md:mb-0"><span class="mr-2 status-icon"></span><h3 class="font-medium"><span class="font-bold"></span></h3></div><button class="text-gray-500 hover:text-gray-700 transition-colors p-1 rounded hover:bg-gray-100" title="Copy to clipboard"></button></div><div class="json-viewer text-xs overflow-auto max-h-60 p-2 rounded font-mono">'), $cdf7e442067abc24$var$aa = "FLOWISE_CREDENTIAL_ID", $cdf7e442067abc24$var$la = (e)=>{
    if (!e || "object" != typeof e) return e;
    if (Array.isArray(e)) return e.map((e)=>$cdf7e442067abc24$var$la(e));
    var r = {
        ...e
    };
    for(const e in r)e === $cdf7e442067abc24$var$aa ? delete r[e] : "object" == typeof r[e] && null !== r[e] && (r[e] = $cdf7e442067abc24$var$la(r[e]));
    return r;
};
const $cdf7e442067abc24$var$ia = ()=>$cdf7e442067abc24$var$Vt(), $cdf7e442067abc24$var$na = ()=>$cdf7e442067abc24$var$Ht(), $cdf7e442067abc24$var$da = ()=>$cdf7e442067abc24$var$Ut(), $cdf7e442067abc24$var$sa = ()=>$cdf7e442067abc24$var$Kt(), $cdf7e442067abc24$var$ma = ()=>$cdf7e442067abc24$var$Wt(), $cdf7e442067abc24$var$ga = ()=>$cdf7e442067abc24$var$Zt(), $cdf7e442067abc24$var$ca = ()=>$cdf7e442067abc24$var$Qt(), $cdf7e442067abc24$var$xa = ()=>$cdf7e442067abc24$var$zt(), $cdf7e442067abc24$var$ua = (e)=>{
    let r;
    switch(e){
        case "FINISHED":
            r = $cdf7e442067abc24$var$z($cdf7e442067abc24$var$da, {});
            break;
        case "PENDING":
        default:
            r = $cdf7e442067abc24$var$z($cdf7e442067abc24$var$sa, {});
            break;
        case "RUNNING":
        case "INPROGRESS":
            r = $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ma, {});
            break;
        case "ERROR":
            r = $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ga, {});
            break;
        case "STOPPED":
            r = $cdf7e442067abc24$var$z($cdf7e442067abc24$var$pa, {});
    }
    return r;
}, $cdf7e442067abc24$var$pa = ()=>$cdf7e442067abc24$var$Yt(), $cdf7e442067abc24$var$ha = (e)=>{
    const [r, o] = $cdf7e442067abc24$var$f([]), [t, a] = $cdf7e442067abc24$var$f(null), [l, i] = $cdf7e442067abc24$var$f(!1 !== e.initiallyExpanded), [n, d] = $cdf7e442067abc24$var$f(!1), [s, m] = $cdf7e442067abc24$var$f([]), [g, c] = $cdf7e442067abc24$var$f(null), x = ($cdf7e442067abc24$var$y(()=>{
        var r = ((e)=>{
            e.forEach((e)=>{
                const r = (e)=>{
                    for(const o in e)o === $cdf7e442067abc24$var$aa && delete e[o], "object" == typeof e[o] && null !== e[o] && r(e[o]);
                };
                e.data && r(e.data);
            });
            const r = new Map, o = (e.forEach((e, o)=>{
                var t = e.nodeId + "_" + o;
                r.set(t, {
                    ...e,
                    uniqueNodeId: t,
                    children: [],
                    executionIndex: o
                });
            }), new Map), t = (e.forEach((e, r)=>{
                var t, a;
                e.data?.parentNodeId && void 0 !== e.data?.iterationIndex && (a = e.data.parentNodeId, t = e.data.iterationIndex, o.has(a) || o.set(a, new Map), (a = o.get(a)).has(t) || a.set(t, []), a.get(t).push(e.nodeId + "_" + r));
            }), o.forEach((o, t)=>{
                o.forEach((o, a)=>{
                    let l = null;
                    for(let r = 0; r < e.length; r++)if (e[r].nodeId === t) {
                        l = e[r];
                        break;
                    }
                    if (l) {
                        var i = o[0];
                        i = r.get(i)?.data?.iterationContext || {
                            index: a
                        };
                        const e = t + "_" + a;
                        var n = "Iteration #" + a, d = (d = o.map((e)=>r.get(e))).some((e)=>"ERROR" === e.status) ? "ERROR" : d.some((e)=>"INPROGRESS" === e.status || "RUNNING" === e.status) ? "INPROGRESS" : d.every((e)=>"FINISHED" === e.status) ? "FINISHED" : "PENDING";
                        n = {
                            nodeId: e,
                            nodeLabel: n,
                            data: {
                                name: "iterationAgentflow",
                                iterationIndex: a,
                                iterationContext: i,
                                isVirtualNode: !0,
                                parentIterationId: t
                            },
                            previousNodeIds: [],
                            status: d,
                            uniqueNodeId: e,
                            children: [],
                            executionIndex: -1
                        };
                        r.set(e, n), o.forEach((o)=>{
                            (o = r.get(o)) && (o.virtualParentId = e);
                        });
                    }
                });
            }), []), a = new Set, l = (e.forEach((o, l)=>{
                var i = o.nodeId + "_" + l, n = r.get(i);
                if (!o.data?.parentNodeId || void 0 === o.data?.iterationIndex) {
                    if (0 === o.previousNodeIds.length) t.push(n);
                    else {
                        let t = -1, d = null;
                        o.previousNodeIds.forEach((r)=>{
                            for(let o = 0; o < l; o++)e[o].nodeId === r && o > t && (t = o, d = r);
                        }), -1 !== t && d && (o = d + "_" + t, o = r.get(o)) && (o.children.push(n), a.add(i));
                    }
                }
            }), o.forEach((o, t)=>{
                const a = [];
                e.forEach((e, r)=>{
                    e.nodeId === t && a.push(e.nodeId + "_" + r);
                });
                let l = null;
                for(let e = a.length - 1; 0 <= e; e--){
                    const o = a[e];
                    var i = r.get(o);
                    if (i) {
                        l = i;
                        break;
                    }
                }
                l && o.forEach((e, o)=>{
                    o = t + "_" + o, (o = r.get(o)) && l.children.push(o);
                });
            }), r.forEach((e)=>{
                if (e.virtualParentId) {
                    var o = r.get(e.virtualParentId);
                    if (o) {
                        if (0 === e.previousNodeIds.length) o.children.push(e);
                        else {
                            let t = !1;
                            for (const o of e.previousNodeIds)r.forEach((r)=>{
                                r.nodeId !== o || r.data?.iterationIndex !== e.data?.iterationIndex || r.data?.parentNodeId !== e.data?.parentNodeId || t || (r.children.push(e), t = !0);
                            });
                            t || o.children.push(e);
                        }
                    }
                }
            }), (e)=>{
                e.children && 0 < e.children.length && (e.children.sort((e, r)=>{
                    var o = "iterationAgentflow" === e.data?.name || e.data?.isVirtualNode;
                    return o === ("iterationAgentflow" === r.data?.name || r.data?.isVirtualNode) ? e.executionIndex - r.executionIndex : o ? -1 : 1;
                }), e.children.forEach(l));
            }), i = (t.forEach(l), (e)=>({
                    id: e.uniqueNodeId,
                    label: e.nodeLabel,
                    name: e.data?.name,
                    status: e.status,
                    data: e.data,
                    children: e.children.map(i)
                }));
            var n = t.map(i), d = ((e)=>{
                const r = (e)=>{
                    let o = [];
                    return e.forEach((e)=>{
                        e.status && o.push(e.status), e.children && 0 < e.children.length && (o = [
                            ...o,
                            ...r(e.children)
                        ]);
                    }), o;
                };
                return (e = r(e)).includes("ERROR") ? "ERROR" : e.includes("RUNNING") || e.includes("INPROGRESS") ? "INPROGRESS" : e.includes("STOPPED") ? "STOPPED" : e.every((e)=>"FINISHED" === e) ? "FINISHED" : null;
            })(n);
            return c(d), n;
        })(e.workflowData);
        m(r), 0 < r.length && o(r.map((e)=>e.id));
    }), (e)=>{
        a(e);
    }), u = ()=>{
        i(!l());
    }, p = async ()=>{
        var e = S();
        if (e) try {
            await navigator.clipboard.writeText(JSON.stringify(e.data || {}, null, 2)), d(!0), setTimeout(()=>d(!1), 2e3);
        } catch (e) {
            console.error("Failed to copy text: ", e);
        }
    }, h = (e)=>{
        const r = "iterationAgentflow" === e.name || e.data?.isVirtualNode;
        t = (o = $cdf7e442067abc24$var$Jt()).firstChild, $cdf7e442067abc24$var$$e(o, r && $cdf7e442067abc24$var$jt(), t), $cdf7e442067abc24$var$ue(t, r ? "iteration-node-label" : ""), $cdf7e442067abc24$var$$e(t, ()=>e.label);
        var o, t = o;
        return $cdf7e442067abc24$var$$e(o = $cdf7e442067abc24$var$qt(), ()=>$cdf7e442067abc24$var$ua(e.status)), $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Ft, {
            get itemId () {
                return e.id;
            },
            label: t,
            icon: o,
            get children () {
                return $cdf7e442067abc24$var$T(()=>!!(e.children && 0 < e.children.length))() && e.children.map((e)=>h(e));
            }
        });
    }, S = ()=>{
        if (!t()) return null;
        const e = (r, o)=>{
            for (const a of r){
                if (a.id === o) return a;
                if (a.children && a.children.length) {
                    var t = e(a.children, o);
                    if (t) return t;
                }
            }
            return null;
        };
        var r = t();
        return (r = r && e(s(), r)) ? {
            nodeLabel: r.label,
            data: $cdf7e442067abc24$var$la(r.data),
            status: r.status
        } : null;
    };
    {
        const o = $cdf7e442067abc24$var$ra(), a = o.firstChild, i = a.firstChild.firstChild, d = i.nextSibling;
        return a.nextSibling, a.$$click = u, a.style.setProperty("background-color", "rgba(0,0,0,0.03)"), $cdf7e442067abc24$var$$e(i, (()=>{
            const e = $cdf7e442067abc24$var$T(()=>!!l());
            return ()=>e() ? $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ca, {}) : $cdf7e442067abc24$var$z($cdf7e442067abc24$var$xa, {});
        })()), $cdf7e442067abc24$var$$e(d, ()=>e.title || "Process Flow", null), $cdf7e442067abc24$var$$e(d, (()=>{
            const e = $cdf7e442067abc24$var$T(()=>!!g());
            return ()=>e() && (()=>{
                    const e = $cdf7e442067abc24$var$oa();
                    return $cdf7e442067abc24$var$$e(e, ()=>$cdf7e442067abc24$var$ua(g() || "PENDING")), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(e, "title", "Execution Status: " + g())), e;
                })();
        })(), null), $cdf7e442067abc24$var$$e(o, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return l();
            },
            get children () {
                var o1 = $cdf7e442067abc24$var$ea();
                return $cdf7e442067abc24$var$$e(o1.firstChild, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Rt, {
                    get defaultExpanded () {
                        return r();
                    },
                    onNodeSelect: x,
                    get indentationLevel () {
                        return e.indentationLevel || 24;
                    },
                    get children () {
                        return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                            get each () {
                                return s();
                            },
                            children: (e)=>h(e)
                        });
                    }
                })), $cdf7e442067abc24$var$$e(o1, (()=>{
                    const e = $cdf7e442067abc24$var$T(()=>!!t());
                    return ()=>e() && (()=>{
                            const e = $cdf7e442067abc24$var$ta(), r = e.firstChild, o = r.firstChild, t = o.firstChild, a = t.nextSibling.firstChild, l = o.nextSibling, i = r.nextSibling;
                            return e.style.setProperty("background-color", "rgba(0,0,0,0.03)"), $cdf7e442067abc24$var$$e(t, ()=>$cdf7e442067abc24$var$ua(S()?.status || "PENDING")), $cdf7e442067abc24$var$$e(a, ()=>S()?.nodeLabel), l.$$click = p, $cdf7e442067abc24$var$$e(l, (()=>{
                                const e = $cdf7e442067abc24$var$T(()=>!!n());
                                return ()=>e() ? $cdf7e442067abc24$var$z($cdf7e442067abc24$var$na, {}) : $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ia, {});
                            })()), i.style.setProperty("background-color", "rgba(0,0,0,0.05)"), i.style.setProperty("white-space", "pre-wrap"), i.style.setProperty("word-break", "break-word"), $cdf7e442067abc24$var$M(()=>{
                                var e;
                                return i.innerHTML = (e = S()) ? function(e) {
                                    return e ? (e = e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")).replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function(e) {
                                        let r = "number";
                                        return /^"/.test(e) ? r = /:$/.test(e) ? "key" : "string" : /true|false/.test(e) ? r = "boolean" : /null/.test(e) && (r = "null"), '<span class="' + r + '">' + e + "</span>";
                                    }) : "";
                                }(JSON.stringify(e.data || {}, null, 2)) : "";
                            }), e;
                        })();
                })(), null), o1;
            }
        }), null), $cdf7e442067abc24$var$M((r)=>{
            var t = "mb-2 ml-2 border rounded-lg shadow-sm overflow-hidden " + (e.class || ""), a = e.backgroundColor ?? "#f7f8ff", l = e.textColor ?? "#303235", i = e.fontSize ? e.fontSize + "px" : "16px";
            return t !== r._v$ && $cdf7e442067abc24$var$ue(o, r._v$ = t), a !== r._v$2 && (null != (r._v$2 = a) ? o.style.setProperty("background-color", a) : o.style.removeProperty("background-color")), l !== r._v$3 && (null != (r._v$3 = l) ? o.style.setProperty("color", l) : o.style.removeProperty("color")), i !== r._v$4 && (null != (r._v$4 = i) ? o.style.setProperty("font-size", i) : o.style.removeProperty("font-size")), r;
        }, {
            _v$: void 0,
            _v$2: void 0,
            _v$3: void 0,
            _v$4: void 0
        }), o;
    }
}, $cdf7e442067abc24$var$Sa = ($cdf7e442067abc24$var$ce([
    "click"
]), $cdf7e442067abc24$var$ge('<div class="flex items-center justify-center p-0 m-0"><img class="w-full h-full bg-cover">')), $cdf7e442067abc24$var$va = $cdf7e442067abc24$var$ge('<div class="mt-2"><div>'), $cdf7e442067abc24$var$$a = $cdf7e442067abc24$var$ge('<span class="prose">'), $cdf7e442067abc24$var$ba = $cdf7e442067abc24$var$ge('<div><div class="flex flex-row justify-start mb-2 items-start host-container"><div class="flex flex-col justify-start"></div></div><div></div><div><div>'), $cdf7e442067abc24$var$Aa = $cdf7e442067abc24$var$ge("<div>"), $cdf7e442067abc24$var$fa = $cdf7e442067abc24$var$ge('<details class="mb-2 px-4 py-2 ml-2 chatbot-host-bubble rounded-[6px]"><summary class="cursor-pointer"><span class="italic">Agent Messages</span></summary><br>'), $cdf7e442067abc24$var$Ma = $cdf7e442067abc24$var$ge('<div class="flex flex-row items-start flex-wrap w-full gap-2">'), $cdf7e442067abc24$var$Pa = $cdf7e442067abc24$var$ge('<span class="px-4 py-2 ml-2 max-w-full chatbot-host-bubble prose" data-testid="host-bubble">'), $cdf7e442067abc24$var$Ta = $cdf7e442067abc24$var$ge('<div class="px-4 py-2 flex flex-row justify-start space-x-2">'), $cdf7e442067abc24$var$_a = $cdf7e442067abc24$var$ge('<button type="button" class="px-4 py-2 font-medium text-green-600 border border-green-600 rounded-full hover:bg-green-600 hover:text-white transition-colors duration-300 flex items-center space-x-2">&nbsp;'), $cdf7e442067abc24$var$ya = $cdf7e442067abc24$var$ge('<button type="button" class="px-4 py-2 font-medium text-red-600 border border-red-600 rounded-full hover:bg-red-600 hover:text-white transition-colors duration-300 flex items-center space-x-2">&nbsp;'), $cdf7e442067abc24$var$wa = $cdf7e442067abc24$var$ge('<button type="button">'), $cdf7e442067abc24$var$Ga = $cdf7e442067abc24$var$ge('<span class="px-2 py-[10px] font-semibold">'), $cdf7e442067abc24$var$La = $cdf7e442067abc24$var$ge('<div class="copied-message">Copied!'), $cdf7e442067abc24$var$Ca = $cdf7e442067abc24$var$ge('<div class="text-sm text-gray-500 ml-2">'), $cdf7e442067abc24$var$Ba = "#f7f8ff", $cdf7e442067abc24$var$Ea = "#303235", $cdf7e442067abc24$var$Na = "#3B81F6", $cdf7e442067abc24$var$Oa = (e)=>{
    let r;
    $cdf7e442067abc24$var$To.setOptions({
        isNoP: !0,
        sanitize: void 0 === e.renderHTML || !e.renderHTML
    });
    const [o, t] = $cdf7e442067abc24$var$f(""), [a, l] = $cdf7e442067abc24$var$f(""), [i, n] = $cdf7e442067abc24$var$f(!1), [d, s] = $cdf7e442067abc24$var$f(!1), [m, g] = $cdf7e442067abc24$var$f(e.feedbackColor ?? $cdf7e442067abc24$var$Na), [c, x] = $cdf7e442067abc24$var$f(e.feedbackColor ?? $cdf7e442067abc24$var$Na), [u, p] = $cdf7e442067abc24$var$f(null), h = (r)=>{
        if (r) {
            r.innerHTML = $cdf7e442067abc24$var$To.parse(e.message.message);
            const l = e.textColor ?? $cdf7e442067abc24$var$Ea;
            if (r.querySelectorAll("a, h1, h2, h3, h4, h5, h6, strong, em, blockquote, li").forEach((e)=>{
                e.style.color = l;
            }), r.querySelectorAll("pre").forEach((e)=>{
                e.style.color = "#FFFFFF", e.querySelectorAll("code").forEach((e)=>{
                    e.style.color = "#FFFFFF";
                });
            }), r.querySelectorAll("code:not(pre code)").forEach((e)=>{
                e.style.color = "#4CAF50";
            }), r.querySelectorAll("a").forEach((e)=>{
                e.target = "_blank";
            }), p(r), e.message.rating && (t(e.message.rating), "THUMBS_UP" === e.message.rating ? g("#006400") : "THUMBS_DOWN" === e.message.rating && x("#8B0000")), e.fileAnnotations && e.fileAnnotations.length) for (const t of e.fileAnnotations){
                var o = document.createElement("button"), a = (o.textContent = t.fileName, o.className = "py-2 px-4 mb-2 justify-center font-semibold text-white focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75 file-annotation-button", o.addEventListener("click", function() {
                    (async (r)=>{
                        try {
                            const o = await $cdf7e442067abc24$var$Je({
                                apiHost: e.apiHost,
                                body: {
                                    fileName: r.fileName,
                                    chatflowId: e.chatflowid,
                                    chatId: e.chatId
                                },
                                onRequest: e.onRequest
                            }), t = new Blob([
                                o.data
                            ]), a = window.URL.createObjectURL(t), l = document.createElement("a");
                            l.href = a, l.download = r.fileName, document.body.appendChild(l), l.click(), l.remove();
                        } catch (r) {
                            console.error("Download failed:", r);
                        }
                    })(t);
                }), document.createElement("div"));
                a.className = "ml-2", a.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-download" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#ffffff" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" /><path d="M7 11l5 5l5 -5" /><path d="M12 4l0 12" /></svg>', o.appendChild(a), r.appendChild(o);
            }
        }
    }, S = (r)=>{
        var o = localStorage.getItem(e.chatflowid + "_EXTERNAL");
        if (o) try {
            var t = JSON.parse(o), a = t.chatHistory || [], l = a.find((r)=>r.messageId === e.message.messageId);
            l && (l.rating = r, localStorage.setItem(e.chatflowid + "_EXTERNAL", JSON.stringify({
                ...t,
                chatHistory: a
            })));
        } catch (r) {}
    }, v = (e)=>{
        try {
            return new URL(e);
        } catch (e) {}
    }, $ = async ()=>{
        if ("" === o()) {
            var r = {
                chatflowid: e.chatflowid,
                chatId: e.chatId,
                messageId: e.message?.messageId,
                rating: "THUMBS_UP",
                content: ""
            };
            if ((r = await $cdf7e442067abc24$var$Ye({
                chatflowid: e.chatflowid,
                apiHost: e.apiHost,
                body: r,
                onRequest: e.onRequest
            })).data) {
                let e = "";
                (r = r.data) && r.id && (e = r.id), t("THUMBS_UP"), l(e), n(!0), g("#006400"), S("THUMBS_UP");
            }
        }
    }, b = async ()=>{
        if ("" === o()) {
            var r = {
                chatflowid: e.chatflowid,
                chatId: e.chatId,
                messageId: e.message?.messageId,
                rating: "THUMBS_DOWN",
                content: ""
            };
            if ((r = await $cdf7e442067abc24$var$Ye({
                chatflowid: e.chatflowid,
                apiHost: e.apiHost,
                body: r,
                onRequest: e.onRequest
            })).data) {
                let e = "";
                (r = r.data) && r.id && (e = r.id), t("THUMBS_DOWN"), l(e), n(!0), x("#8B0000"), S("THUMBS_DOWN");
            }
        }
    }, A = async (r)=>{
        r = {
            content: r
        }, (await (({ id: e, apiHost: r = "http://localhost:3000", body: o, onRequest: t })=>$cdf7e442067abc24$var$Oe({
                method: "PUT",
                url: r + "/api/v1/feedback/" + e,
                body: o,
                onRequest: t
            }))({
            id: a(),
            apiHost: e.apiHost,
            body: r,
            onRequest: e.onRequest
        })).data && (l(""), n(!1));
    };
    $cdf7e442067abc24$var$y(()=>{
        r && e.isLoading && (r.open = !0);
    }), $cdf7e442067abc24$var$P(()=>{
        r && e.isLoading ? r.open = !0 : r && !e.isLoading && (r.open = !1);
    });
    {
        const t = $cdf7e442067abc24$var$ba(), a = t.firstChild, l = a.firstChild, g = a.nextSibling, x = g.nextSibling, p = x.firstChild;
        return a.style.setProperty("margin-right", "50px"), $cdf7e442067abc24$var$$e(a, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return e.showAvatar;
            },
            get children () {
                return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$go, {
                    get initialAvatarSrc () {
                        return e.avatarSrc;
                    }
                });
            }
        }), l), $cdf7e442067abc24$var$$e(l, (()=>{
            const r = $cdf7e442067abc24$var$T(()=>!!(e.showAgentMessages && e.message.agentFlowExecutedData && Array.isArray(e.message.agentFlowExecutedData) && 0 < e.message.agentFlowExecutedData.length));
            return ()=>{
                var o;
                return r() && ($cdf7e442067abc24$var$$e(o = $cdf7e442067abc24$var$Aa(), $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ha, {
                    get workflowData () {
                        return e.message.agentFlowExecutedData;
                    },
                    indentationLevel: 24
                })), o);
            };
        })(), null), $cdf7e442067abc24$var$$e(l, (()=>{
            const o = $cdf7e442067abc24$var$T(()=>!(!e.showAgentMessages || !e.message.agentReasoning));
            return ()=>{
                var t, a;
                return o() && ((t = $cdf7e442067abc24$var$fa()).firstChild.nextSibling, "function" == typeof (a = r) ? $cdf7e442067abc24$var$ve(a, t) : r = t, $cdf7e442067abc24$var$$e(t, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                    get each () {
                        return e.message.agentReasoning;
                    },
                    children: (r)=>{
                        var o = r.messages ?? [];
                        let t = r.instructions || (1 < o.length ? o.join("\\n") : o[0]);
                        return 0 !== o.length || r.instructions || (t = "<p>Finished</p>"), $cdf7e442067abc24$var$z($cdf7e442067abc24$var$nt, {
                            get agentName () {
                                return r.agentName ?? "";
                            },
                            agentMessage: t,
                            get agentArtifacts () {
                                return r.artifacts;
                            },
                            get backgroundColor () {
                                return e.backgroundColor;
                            },
                            get textColor () {
                                return e.textColor;
                            },
                            get fontSize () {
                                return e.fontSize;
                            },
                            get apiHost () {
                                return e.apiHost;
                            },
                            get chatflowid () {
                                return e.chatflowid;
                            },
                            get chatId () {
                                return e.chatId;
                            },
                            get renderHTML () {
                                return e.renderHTML;
                            }
                        });
                    }
                }), null), t);
            };
        })(), null), $cdf7e442067abc24$var$$e(l, (()=>{
            const r = $cdf7e442067abc24$var$T(()=>!!(e.message.artifacts && 0 < e.message.artifacts.length));
            return ()=>{
                var o;
                return r() && ($cdf7e442067abc24$var$$e(o = $cdf7e442067abc24$var$Ma(), $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                    get each () {
                        return e.message.artifacts;
                    },
                    children: (r)=>null !== r ? $cdf7e442067abc24$var$T(()=>{
                            {
                                var o = r;
                                const t = (r)=>{
                                    if (r) {
                                        const o = e.textColor ?? $cdf7e442067abc24$var$Ea;
                                        r.querySelectorAll("a, h1, h2, h3, h4, h5, h6, strong, em, blockquote, li").forEach((e)=>{
                                            e.style.color = o;
                                        }), r.querySelectorAll("pre").forEach((e)=>{
                                            e.style.color = "#FFFFFF", e.querySelectorAll("code").forEach((e)=>{
                                                e.style.color = "#FFFFFF";
                                            });
                                        }), r.querySelectorAll("code:not(pre code)").forEach((e)=>{
                                            e.style.color = "#4CAF50";
                                        }), r.querySelectorAll("a").forEach((e)=>{
                                            e.target = "_blank";
                                        });
                                    }
                                };
                                return [
                                    $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                                        get when () {
                                            return "png" === o.type || "jpeg" === o.type;
                                        },
                                        get children () {
                                            const r = $cdf7e442067abc24$var$Sa(), t = r.firstChild;
                                            return $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(t, "src", "string" == typeof o.data && o.data.startsWith("FILE-STORAGE::") ? `${e.apiHost}/api/v1/get-upload-file?chatflowId=${e.chatflowid}&chatId=${e.chatId}&fileName=` + o.data.replace("FILE-STORAGE::", "") : o.data)), r;
                                        }
                                    }),
                                    $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                                        get when () {
                                            return "html" === o.type;
                                        },
                                        get children () {
                                            const e = $cdf7e442067abc24$var$va(), r = e.firstChild;
                                            return $cdf7e442067abc24$var$M(()=>r.innerHTML = o.data), e;
                                        }
                                    }),
                                    $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                                        get when () {
                                            return "png" !== o.type && "jpeg" !== o.type && "html" !== o.type;
                                        },
                                        get children () {
                                            const r = $cdf7e442067abc24$var$$a();
                                            return $cdf7e442067abc24$var$ve(t, r), r.style.setProperty("border-radius", "6px"), $cdf7e442067abc24$var$M((t)=>{
                                                var a = $cdf7e442067abc24$var$To.parse(o.data), l = e.backgroundColor ?? $cdf7e442067abc24$var$Ba, i = e.textColor ?? $cdf7e442067abc24$var$Ea, n = e.fontSize ? e.fontSize + "px" : "16px";
                                                return a !== t._v$ && (r.innerHTML = t._v$ = a), l !== t._v$2 && (null != (t._v$2 = l) ? r.style.setProperty("background-color", l) : r.style.removeProperty("background-color")), i !== t._v$3 && (null != (t._v$3 = i) ? r.style.setProperty("color", i) : r.style.removeProperty("color")), n !== t._v$4 && (null != (t._v$4 = n) ? r.style.setProperty("font-size", n) : r.style.removeProperty("font-size")), t;
                                            }, {
                                                _v$: void 0,
                                                _v$2: void 0,
                                                _v$3: void 0,
                                                _v$4: void 0
                                            }), r;
                                        }
                                    })
                                ];
                            }
                        }) : null
                })), o);
            };
        })(), null), $cdf7e442067abc24$var$$e(l, (()=>{
            const r = $cdf7e442067abc24$var$T(()=>!!e.message.message);
            return ()=>r() && (()=>{
                    const r = $cdf7e442067abc24$var$Pa();
                    return $cdf7e442067abc24$var$ve(h, r), r.style.setProperty("border-radius", "6px"), $cdf7e442067abc24$var$M((o)=>{
                        var t = e.backgroundColor ?? $cdf7e442067abc24$var$Ba, a = e.textColor ?? $cdf7e442067abc24$var$Ea, l = e.fontSize ? e.fontSize + "px" : "16px";
                        return t !== o._v$5 && (null != (o._v$5 = t) ? r.style.setProperty("background-color", t) : r.style.removeProperty("background-color")), a !== o._v$6 && (null != (o._v$6 = a) ? r.style.setProperty("color", a) : r.style.removeProperty("color")), l !== o._v$7 && (null != (o._v$7 = l) ? r.style.setProperty("font-size", l) : r.style.removeProperty("font-size")), o;
                    }, {
                        _v$5: void 0,
                        _v$6: void 0,
                        _v$7: void 0
                    }), r;
                })();
        })(), null), $cdf7e442067abc24$var$$e(l, (()=>{
            const r = $cdf7e442067abc24$var$T(()=>!!e.message.action);
            return ()=>{
                var o;
                return r() && ($cdf7e442067abc24$var$$e(o = $cdf7e442067abc24$var$Ta(), $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                    get each () {
                        return e.message.action.elements || [];
                    },
                    children: (r)=>$cdf7e442067abc24$var$T((()=>{
                            const o = $cdf7e442067abc24$var$T(()=>!(("approve-button" !== r.type || "Yes" !== r.label) && "agentflowv2-approve-button" !== r.type));
                            return ()=>{
                                if (o()) return a = (t = $cdf7e442067abc24$var$_a()).firstChild, t.$$click = ()=>e.handleActionClick(r, e.message.action), $cdf7e442067abc24$var$$e(t, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Pr, {}), a), $cdf7e442067abc24$var$$e(t, ()=>r.label, null), t;
                                {
                                    const o = $cdf7e442067abc24$var$T(()=>!(("reject-button" !== r.type || "No" !== r.label) && "agentflowv2-reject-button" !== r.type));
                                    return ()=>{
                                        var t, a;
                                        return o() ? (a = (t = $cdf7e442067abc24$var$ya()).firstChild, t.$$click = ()=>e.handleActionClick(r, e.message.action), $cdf7e442067abc24$var$$e(t, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$fr, {
                                            isCurrentColor: !0
                                        }), a), $cdf7e442067abc24$var$$e(t, ()=>r.label, null), t) : ($cdf7e442067abc24$var$$e(a = $cdf7e442067abc24$var$wa(), ()=>r.label), a);
                                    };
                                }
                                var t, a;
                            };
                        })())
                })), o);
            };
        })(), null), $cdf7e442067abc24$var$$e(g, (()=>{
            const r = $cdf7e442067abc24$var$T(()=>!(!e.message.sourceDocuments || !e.message.sourceDocuments.length));
            return ()=>{
                var o;
                return r() && [
                    $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                        get when () {
                            return e.sourceDocsTitle;
                        },
                        get children () {
                            var r1 = $cdf7e442067abc24$var$Ga();
                            return $cdf7e442067abc24$var$$e(r1, ()=>e.sourceDocsTitle), r1;
                        }
                    }),
                    ((o = $cdf7e442067abc24$var$Aa()).style.setProperty("display", "flex"), o.style.setProperty("flex-direction", "row"), o.style.setProperty("width", "100%"), o.style.setProperty("flex-wrap", "wrap"), $cdf7e442067abc24$var$$e(o, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                        get each () {
                            return [
                                ...((e)=>{
                                    const r = [], o = [];
                                    return e.sourceDocuments.forEach((e)=>{
                                        v(e.metadata.source) && !r.includes(e.metadata.source) ? (r.push(e.metadata.source), o.push(e)) : v(e.metadata.source) || o.push(e);
                                    }), o;
                                })(e.message)
                            ];
                        },
                        children: (r)=>{
                            const o = v(r.metadata.source);
                            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$st, {
                                get pageContent () {
                                    return o ? o.pathname : r.pageContent;
                                },
                                get metadata () {
                                    return r.metadata;
                                },
                                onSourceClick: ()=>{
                                    o ? window.open(r.metadata.source, "_blank") : e.handleSourceDocumentsClick(r);
                                }
                            });
                        }
                    })), o)
                ];
            };
        })()), $cdf7e442067abc24$var$$e(p, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return e.isTTSEnabled && (e.message.id || e.message.messageId);
            },
            get children () {
                return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Uo, {
                    get feedbackColor () {
                        return e.feedbackColor;
                    },
                    get isLoading () {
                        var r1 = e.message.id || e.message.messageId;
                        return !(!r1 || !e.isTTSLoading?.[r1]);
                    },
                    get isPlaying () {
                        var r2 = e.message.id || e.message.messageId;
                        return !(!r2 || !e.isTTSPlaying?.[r2]);
                    },
                    onClick: ()=>{
                        var r, o = e.message.id || e.message.messageId;
                        o && (r = e.message.message || "", e.isTTSLoading?.[o] || (e.isTTSPlaying?.[o] ? e.handleTTSStop?.(o) : e.handleTTSClick?.(o, r)));
                    }
                });
            }
        }), null), $cdf7e442067abc24$var$$e(p, (()=>{
            const r = $cdf7e442067abc24$var$T(()=>!(!e.chatFeedbackStatus || !e.message.messageId));
            return ()=>r() && [
                    $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Xo, {
                        get feedbackColor () {
                            return e.feedbackColor;
                        },
                        onClick: ()=>(async ()=>{
                                try {
                                    var e = u() ? u()?.textContent : "";
                                    await navigator.clipboard.writeText(e || ""), s(!0), setTimeout(()=>{
                                        s(!1);
                                    }, 2e3);
                                } catch (e) {
                                    console.error("Error copying to clipboard:", e);
                                }
                            })()
                    }),
                    $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                        get when () {
                            return d();
                        },
                        get children () {
                            const r = $cdf7e442067abc24$var$La();
                            return $cdf7e442067abc24$var$M(()=>null != (e.feedbackColor ?? $cdf7e442067abc24$var$Na) ? r.style.setProperty("color", e.feedbackColor ?? $cdf7e442067abc24$var$Na) : r.style.removeProperty("color")), r;
                        }
                    }),
                    $cdf7e442067abc24$var$T((()=>{
                        const e = $cdf7e442067abc24$var$T(()=>!("" !== o() && "THUMBS_UP" !== o()));
                        return ()=>e() ? $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Do, {
                                get feedbackColor () {
                                    return m();
                                },
                                get isDisabled () {
                                    return "THUMBS_UP" === o();
                                },
                                get rating () {
                                    return o();
                                },
                                onClick: $
                            }) : null;
                    })()),
                    $cdf7e442067abc24$var$T((()=>{
                        const e = $cdf7e442067abc24$var$T(()=>!("" !== o() && "THUMBS_DOWN" !== o()));
                        return ()=>e() ? $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Ro, {
                                get feedbackColor () {
                                    return c();
                                },
                                get isDisabled () {
                                    return "THUMBS_DOWN" === o();
                                },
                                get rating () {
                                    return o();
                                },
                                onClick: b
                            }) : null;
                    })()),
                    $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                        get when () {
                            return e.message.dateTime;
                        },
                        get children () {
                            var r1 = $cdf7e442067abc24$var$Ca();
                            return $cdf7e442067abc24$var$$e(r1, ()=>{
                                var r = e.message.dateTime, o = e?.dateTimeToggle?.date, t = e?.dateTimeToggle?.time;
                                if (!r) return "";
                                try {
                                    var a, l, i, n, d = new Date(r);
                                    if (isNaN(d.getTime())) return console.error("Invalid ISO date string:", r), "";
                                    let e = "";
                                    return o && ([{ value: a }, , { value: l }, , { value: i }] = new Intl.DateTimeFormat("en-US", {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                                    }).formatToParts(d), e = a.charAt(0).toUpperCase() + a.slice(1) + ` ${l}, ` + i), t && (n = new Intl.DateTimeFormat("en-US", {
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: !0,
                                        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                                    }).format(d).toLowerCase(), e = e ? e + ", " + n : n), e;
                                } catch (e) {
                                    return console.error("Error formatting date:", e), "";
                                }
                            }), r1;
                        }
                    })
                ];
        })(), null), $cdf7e442067abc24$var$$e(x, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return i();
            },
            get children () {
                return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Qo, {
                    get isOpen () {
                        return i();
                    },
                    onClose: ()=>n(!1),
                    onSubmit: A,
                    get backgroundColor () {
                        return e.backgroundColor;
                    },
                    get textColor () {
                        return e.textColor;
                    }
                });
            }
        }), null), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$ue(p, "flex items-center px-2 pb-2 " + (e.showAvatar ? "ml-10" : ""))), t;
    }
}, $cdf7e442067abc24$var$Ia = ($cdf7e442067abc24$var$ce([
    "click"
]), $cdf7e442067abc24$var$ge('<div class="flex items-center"><div class="w-2 h-2 mr-1 rounded-full bubble1"></div><div class="w-2 h-2 mr-1 rounded-full bubble2"></div><div class="w-2 h-2 rounded-full bubble3">')), $cdf7e442067abc24$var$ka = ()=>$cdf7e442067abc24$var$Ia(), $cdf7e442067abc24$var$Xa = $cdf7e442067abc24$var$ge('<div class="flex justify-start mb-2 items-start animate-fade-in host-container"><span class="px-4 py-4 ml-2 whitespace-pre-wrap max-w-full chatbot-host-bubble" data-testid="host-bubble">'), $cdf7e442067abc24$var$Da = ()=>{
    var e;
    return $cdf7e442067abc24$var$$e((e = $cdf7e442067abc24$var$Xa()).firstChild, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ka, {})), e;
}, $cdf7e442067abc24$var$Ra = $cdf7e442067abc24$var$ge('<div data-modal-target="defaultModal" data-modal-toggle="defaultModal" class="flex justify-start items-start animate-fade-in host-container hover:brightness-90 active:brightness-75"><span class="px-2 py-1 ml-1 whitespace-pre-wrap max-w-full chatbot-host-bubble" data-testid="host-bubble">'), $cdf7e442067abc24$var$Fa = (e)=>{
    {
        const r = $cdf7e442067abc24$var$Ra(), o = r.firstChild;
        return r.$$click = ()=>e.onPromptClick?.(), o.style.setProperty("width", "max-content"), o.style.setProperty("border-radius", "15px"), o.style.setProperty("cursor", "pointer"), $cdf7e442067abc24$var$$e(o, ()=>e.prompt), $cdf7e442067abc24$var$M(()=>(e.starterPromptFontSize && e.starterPromptFontSize, o.style.setProperty("font-size", e.starterPromptFontSize ? e.starterPromptFontSize + "px" : "15px"))), r;
    }
}, $cdf7e442067abc24$var$Va = ($cdf7e442067abc24$var$ce([
    "click"
]), $cdf7e442067abc24$var$ge('<span class="w-full text-center px-[10px] pt-[6px] pb-[10px] m-auto text-[13px]"><a target="_blank" rel="noopener noreferrer" class="lite-badge" id="lite-badge"><span>&nbsp;')), $cdf7e442067abc24$var$Ha = $cdf7e442067abc24$var$ge('<span class="w-full text-center px-[10px] pt-[6px] pb-[10px] m-auto text-[13px]">'), $cdf7e442067abc24$var$Ua = "#303235", $cdf7e442067abc24$var$Ka = (e)=>{
    let r, o;
    const t = (o)=>{
        o.forEach((o)=>{
            o.removedNodes.forEach((o)=>{
                "id" in o && r && "lite-badge" == o.id && (console.log("Sorry, you can't remove the brand \uD83D\uDE05"), e.botContainer?.append(r));
            });
        });
    };
    return $cdf7e442067abc24$var$y(()=>{
        document && e.botContainer && (o = new MutationObserver(t)).observe(e.botContainer, {
            subtree: !1,
            childList: !0
        });
    }), $cdf7e442067abc24$var$w(()=>{
        o && o.disconnect();
    }), [
        $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return void 0 === e.footer?.showFooter || null === e.footer?.showFooter || !0 === e.footer?.showFooter;
            },
            get children () {
                const o = $cdf7e442067abc24$var$Va(), t = o.firstChild, a = t.firstChild;
                a.firstChild, $cdf7e442067abc24$var$$e(o, ()=>e.footer?.text ?? "Powered by", t);
                return "function" == typeof r ? $cdf7e442067abc24$var$ve(r, t) : r = t, t.style.setProperty("font-weight", "bold"), $cdf7e442067abc24$var$$e(a, ()=>e.footer?.company ?? "Flowise", null), $cdf7e442067abc24$var$M((r)=>{
                    var a = e.footer?.textColor ?? e.poweredByTextColor ?? $cdf7e442067abc24$var$Ua, l = e.badgeBackgroundColor ?? "#ffffff", i = e.footer?.companyLink ?? "https://flowiseai.com", n = e.footer?.textColor ?? e.poweredByTextColor ?? $cdf7e442067abc24$var$Ua;
                    return a !== r._v$ && (null != (r._v$ = a) ? o.style.setProperty("color", a) : o.style.removeProperty("color")), l !== r._v$2 && (null != (r._v$2 = l) ? o.style.setProperty("background-color", l) : o.style.removeProperty("background-color")), i !== r._v$3 && $cdf7e442067abc24$var$xe(t, "href", r._v$3 = i), n !== r._v$4 && (null != (r._v$4 = n) ? t.style.setProperty("color", n) : t.style.removeProperty("color")), r;
                }, {
                    _v$: void 0,
                    _v$2: void 0,
                    _v$3: void 0,
                    _v$4: void 0
                }), o;
            }
        }),
        $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return !1 === e.footer?.showFooter;
            },
            get children () {
                const r = $cdf7e442067abc24$var$Ha();
                return $cdf7e442067abc24$var$M((o)=>{
                    var t = e.footer?.textColor ?? e.poweredByTextColor ?? $cdf7e442067abc24$var$Ua, a = e.badgeBackgroundColor ?? "#ffffff";
                    return t !== o._v$5 && (null != (o._v$5 = t) ? r.style.setProperty("color", t) : r.style.removeProperty("color")), a !== o._v$6 && (null != (o._v$6 = a) ? r.style.setProperty("background-color", a) : r.style.removeProperty("background-color")), o;
                }, {
                    _v$5: void 0,
                    _v$6: void 0
                }), r;
            }
        })
    ];
}, $cdf7e442067abc24$var$Wa = $cdf7e442067abc24$var$ge("<style>"), $cdf7e442067abc24$var$Za = $cdf7e442067abc24$var$ge('<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true"><style></style><div class="fixed inset-0 bg-black bg-opacity-50 transition-opacity animate-fade-in"></div><div class="fixed inset-0 z-10 overflow-y-auto"><div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0"><div class="relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">'), $cdf7e442067abc24$var$Qa = $cdf7e442067abc24$var$ge("<div><pre>");
const $cdf7e442067abc24$var$za = (e)=>{
    let r;
    const [o] = $cdf7e442067abc24$var$ee(e, [
        "onOpen",
        "onClose",
        "isOpen",
        "value"
    ]), [t, a] = ($cdf7e442067abc24$var$y(()=>{
        r && (r.innerHTML = function(e) {
            return (e = (e = "string" != typeof e ? JSON.stringify(e, void 0, 2) : e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")).replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, function(e) {
                let r = "number";
                return /^"/.test(e) ? r = /:$/.test(e) ? "key" : "string" : /true|false/.test(e) ? r = "boolean" : /null/.test(e) && (r = "null"), '<span class="' + r + '">' + e + "</span>";
            });
        }(JSON.stringify(e?.value, void 0, 2)));
    }), $cdf7e442067abc24$var$f(o.isOpen ?? !1)), l = ($cdf7e442067abc24$var$P(()=>{
        $cdf7e442067abc24$var$Ee(e.isOpen) || e.isOpen === t() || n();
    }), (e)=>{
        e.stopPropagation();
    }), i = ()=>{
        a(!1), o.onClose?.(), document.body.style.overflow = "auto";
    }, n = ()=>{
        t() ? i() : (a(!0), o.onOpen?.(), document.body.style.overflow = "hidden");
    };
    return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return t();
        },
        get children () {
            var o1, t1, a1;
            return [
                ($cdf7e442067abc24$var$$e(a1 = $cdf7e442067abc24$var$Wa(), $cdf7e442067abc24$var$Be), a1),
                (a1 = $cdf7e442067abc24$var$Za(), o1 = a1.firstChild, t1 = o1.nextSibling.nextSibling.firstChild.firstChild, a1.style.setProperty("z-index", "1100"), a1.addEventListener("click", i), $cdf7e442067abc24$var$$e(o1, $cdf7e442067abc24$var$Be), t1.style.setProperty("background-color", "transparent"), t1.style.setProperty("margin-left", "20px"), t1.style.setProperty("margin-right", "20px"), t1.addEventListener("click", l), t1.addEventListener("pointerdown", l), $cdf7e442067abc24$var$$e(t1, (()=>{
                    const o = $cdf7e442067abc24$var$T(()=>!!e.value);
                    return ()=>{
                        var e, t, a;
                        return o() && (t = (e = $cdf7e442067abc24$var$Qa()).firstChild, e.style.setProperty("background", "white"), e.style.setProperty("margin", "auto"), e.style.setProperty("padding", "7px"), "function" == typeof (a = r) ? $cdf7e442067abc24$var$ve(a, t) : r = t, e);
                    };
                })()), a1)
            ];
        }
    });
}, $cdf7e442067abc24$var$Ya = $cdf7e442067abc24$var$ge('<button class="font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline">'), $cdf7e442067abc24$var$Ja = $cdf7e442067abc24$var$ge('<div class="fixed inset-0 rounded-lg flex items-center justify-center backdrop-blur-sm z-50"><div class="p-10 rounded-lg shadow-lg max-w-md w-full text-center mx-4 font-sans"><h2 class="text-2xl font-semibold mb-4 flex justify-center items-center"></h2><p class="text-gray-700 text-base mb-6"></p><div class="flex justify-center space-x-4"><button class="font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline">'), $cdf7e442067abc24$var$ja = (e)=>{
    const [r] = $cdf7e442067abc24$var$ee(e, [
        "onAccept",
        "onDeny",
        "isOpen",
        "isFullPage",
        "title",
        "message",
        "textColor",
        "buttonColor",
        "buttonText",
        "denyButtonText",
        "buttonTextColor",
        "denyButtonBgColor",
        "blurredBackgroundColor",
        "backgroundColor"
    ]), o = ()=>{
        r.onAccept?.();
    }, t = ()=>{
        r.onDeny?.();
    };
    return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return r.isOpen;
        },
        get children () {
            const e = $cdf7e442067abc24$var$Ja(), a = e.firstChild, l = a.firstChild, i = l.nextSibling, n = i.nextSibling, d = n.firstChild;
            return $cdf7e442067abc24$var$$e(l, ()=>r.title ?? "Disclaimer"), d.$$click = o, $cdf7e442067abc24$var$$e(d, ()=>r.buttonText ?? "Start Chatting"), $cdf7e442067abc24$var$$e(n, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                get when () {
                    return !r.isFullPage;
                },
                get children () {
                    const e = $cdf7e442067abc24$var$Ya();
                    return e.$$click = t, $cdf7e442067abc24$var$$e(e, ()=>r.denyButtonText ?? "Cancel"), $cdf7e442067abc24$var$M((o)=>{
                        var t = r.denyButtonBgColor || "#ef4444", a = r.buttonTextColor || "white";
                        return t !== o._v$ && (null != (o._v$ = t) ? e.style.setProperty("background", t) : e.style.removeProperty("background")), a !== o._v$2 && (null != (o._v$2 = a) ? e.style.setProperty("color", a) : e.style.removeProperty("color")), o;
                    }, {
                        _v$: void 0,
                        _v$2: void 0
                    }), e;
                }
            }), null), $cdf7e442067abc24$var$M((o)=>{
                var t = r.blurredBackgroundColor || "rgba(0, 0, 0, 0.4)", l = r.backgroundColor || "white", n = r.textColor || "black", s = r.textColor || "black", m = r.message ?? 'By using this chatbot, you agree to the <a target="_blank" href="https://flowiseai.com/terms">Terms & Condition</a>.', g = r.buttonColor || "#3b82f6", c = r.buttonTextColor || "white";
                return t !== o._v$3 && (null != (o._v$3 = t) ? e.style.setProperty("background", t) : e.style.removeProperty("background")), l !== o._v$4 && (null != (o._v$4 = l) ? a.style.setProperty("background", l) : a.style.removeProperty("background")), n !== o._v$5 && (null != (o._v$5 = n) ? a.style.setProperty("color", n) : a.style.removeProperty("color")), s !== o._v$6 && (null != (o._v$6 = s) ? i.style.setProperty("color", s) : i.style.removeProperty("color")), m !== o._v$7 && (i.innerHTML = o._v$7 = m), g !== o._v$8 && (null != (o._v$8 = g) ? d.style.setProperty("background", g) : d.style.removeProperty("background")), c !== o._v$9 && (null != (o._v$9 = c) ? d.style.setProperty("color", c) : d.style.removeProperty("color")), o;
            }, {
                _v$3: void 0,
                _v$4: void 0,
                _v$5: void 0,
                _v$6: void 0,
                _v$7: void 0,
                _v$8: void 0,
                _v$9: void 0
            }), e;
        }
    });
}, $cdf7e442067abc24$var$qa = ($cdf7e442067abc24$var$ce([
    "click"
]), $cdf7e442067abc24$var$ge('<button type="submit">')), $cdf7e442067abc24$var$el = (e)=>{
    var r;
    return $cdf7e442067abc24$var$Se(r = $cdf7e442067abc24$var$qa(), $cdf7e442067abc24$var$q({
        get disabled () {
            return e.isDisabled || e.isLoading;
        }
    }, e, {
        get class () {
            return "py-2 px-4 justify-center font-semibold focus:outline-none flex items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75 chatbot-button " + e.class;
        },
        style: {
            background: "transparent",
            border: "none"
        }
    }), !1, !0), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$fr, {
        get color () {
            return e.buttonColor;
        }
    })), r;
};
var $cdf7e442067abc24$var$rl = {}, $cdf7e442067abc24$var$ol = {}, $cdf7e442067abc24$var$tl = {}, $cdf7e442067abc24$var$al = {};
Object.defineProperty($cdf7e442067abc24$var$al, "__esModule", {
    value: !0
}), $cdf7e442067abc24$var$al.trim = (e, r)=>e.replace(new RegExp("^[" + r + "]+|[" + r + "]+$", "g"), ""), Object.defineProperty($cdf7e442067abc24$var$tl, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$ll = $cdf7e442067abc24$var$al;
$cdf7e442067abc24$var$tl.formatVersion = (e, r)=>{
    var o;
    return void 0 === e ? "" : (o = (e = $cdf7e442067abc24$var$ll.trim(e, ". ").replace(new RegExp("_", "g"), ".")).split("."), /^\d+$/.test(o.join("")) ? 0 !== r && Number.isInteger(parseFloat(e)) ? parseInt(e, 10).toFixed(1) : 1 < o.length && null !== r ? o.slice(0, r + 1).join(".") : e : e);
}, $cdf7e442067abc24$var$tl.parseBrowserEngineVersion = (e, r)=>{
    if (!r) return "";
    if ("Gecko" === r) {
        const r = e.match(/[ ](?:rv[: ]([0-9\.]+)).*gecko\/[0-9]{8,10}/i);
        if (r) return r.pop();
    }
    r = new RegExp(r + "\\s*\\/?\\s*((?:(?=\\d+\\.\\d)\\d+[.\\d]*|\\d{1,7}(?=(?:\\D|$))))", "i");
    const o = e.match(r);
    return o ? o.pop() : "";
};
var $cdf7e442067abc24$var$il = {}, $cdf7e442067abc24$var$nl = (Object.defineProperty($cdf7e442067abc24$var$il, "__esModule", {
    value: !0
}), $cdf7e442067abc24$var$il.variableReplacement = (e, r)=>{
    var o = new RegExp("\\$\\d", "g");
    return null == e ? "" : e.replace(o, (e)=>(e = parseInt(e.substr(1), 10), r[e - 1] || ""));
}, {}), $cdf7e442067abc24$var$dl = {};
Object.defineProperty($cdf7e442067abc24$var$dl, "__esModule", {
    value: !0
}), $cdf7e442067abc24$var$dl.memoryCache = ()=>{
    const e = {};
    return {
        set: (r, o)=>{
            e[r] = o;
        },
        get: (r)=>{
            if (e.hasOwnProperty(r)) return e[r];
        }
    };
}, Object.defineProperty($cdf7e442067abc24$var$nl, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$sl = $cdf7e442067abc24$var$dl.memoryCache();
$cdf7e442067abc24$var$nl.userAgentParser = (e, r)=>{
    try {
        var o = ((e)=>{
            var r = $cdf7e442067abc24$var$sl.get(e);
            return r ? r.value : (r = RegExp(`(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(?:${e})`, "i"), $cdf7e442067abc24$var$sl.set(e, {
                value: r
            }), r);
        })(e).exec(r);
        return o ? o.slice(1) : null;
    } catch (e) {
        return null;
    }
};
var $cdf7e442067abc24$var$ml = {
    36: "360 Phone Browser",
    "1B": "115 Browser",
    "2B": "2345 Browser",
    "3B": "360 Browser",
    "7B": "7654 Browser",
    AA: "Avant Browser",
    AB: "ABrowse",
    AF: "ANT Fresco",
    AG: "ANTGalio",
    AL: "Aloha Browser",
    AH: "Aloha Browser Lite",
    AM: "Amaya",
    AO: "Amigo",
    AN: "Android Browser",
    AE: "AOL Desktop",
    AD: "AOL Shield",
    AR: "Arora",
    AX: "Arctic Fox",
    AV: "Amiga Voyager",
    AW: "Amiga Aweb",
    A0: "Atom",
    AT: "Atomic Web Browser",
    AS: "Avast Secure Browser",
    VG: "AVG Secure Browser",
    AC: "Avira Scout",
    A1: "AwoX",
    BA: "Beaker Browser",
    BM: "Beamrise",
    BB: "BlackBerry Browser",
    BD: "Baidu Browser",
    BS: "Baidu Spark",
    BI: "Basilisk",
    BE: "Beonex",
    BH: "BlackHawk",
    BJ: "Bunjalloo",
    BL: "B-Line",
    BU: "Blue Browser",
    BN: "Borealis Navigator",
    BR: "Brave",
    BK: "BriskBard",
    BX: "BrowseX",
    BZ: "Browzar",
    BY: "Biyubi",
    BF: "Byffox",
    CA: "Camino",
    CL: "CCleaner",
    C6: "Chedot",
    C0: "Centaury",
    CC: "Coc Coc",
    C4: "CoolBrowser",
    C2: "Colibri",
    CD: "Comodo Dragon",
    C1: "Coast",
    CX: "Charon",
    CE: "CM Browser",
    CF: "Chrome Frame",
    HC: "Headless Chrome",
    CH: "Chrome",
    CI: "Chrome Mobile iOS",
    CK: "Conkeror",
    CM: "Chrome Mobile",
    CN: "CoolNovo",
    CO: "CometBird",
    CB: "COS Browser",
    CW: "Cornowser",
    C3: "Chim Lac",
    CP: "ChromePlus",
    CR: "Chromium",
    C5: "Chromium GOST",
    CY: "Cyberfox",
    CS: "Cheshire",
    CT: "Crusta",
    CG: "Craving Explorer",
    CZ: "Crazy Browser",
    CU: "Cunaguaro",
    CV: "Chrome Webview",
    DB: "dbrowser",
    DE: "Deepnet Explorer",
    DG: "deg-degan",
    DA: "Deledao",
    DT: "Delta Browser",
    DS: "DeskBrowse",
    DF: "Dolphin",
    DO: "Dorado",
    DR: "Dot Browser",
    DL: "Dooble",
    DI: "Dillo",
    DD: "DuckDuckGo Privacy Browser",
    EC: "Ecosia",
    EI: "Epic",
    EL: "Elinks",
    EB: "Element Browser",
    EE: "Elements Browser",
    EZ: "eZ Browser",
    EU: "EUI Browser",
    EP: "GNOME Web",
    ES: "Espial TV Browser",
    FA: "Falkon",
    FX: "Faux Browser",
    F1: "Firefox Mobile iOS",
    FB: "Firebird",
    FD: "Fluid",
    FE: "Fennec",
    FF: "Firefox",
    FK: "Firefox Focus",
    FY: "Firefox Reality",
    FR: "Firefox Rocket",
    FL: "Flock",
    FO: "Flow",
    FM: "Firefox Mobile",
    FW: "Fireweb",
    FN: "Fireweb Navigator",
    FS: "Flast",
    FU: "FreeU",
    GA: "Galeon",
    GH: "Ghostery Privacy Browser",
    GI: "GinxDroid Browser",
    GB: "Glass Browser",
    GE: "Google Earth",
    GO: "GOG Galaxy",
    HS: "HasBrowser",
    HA: "Hawk Turbo Browser",
    HE: "Helio",
    HO: "hola! Browser",
    HJ: "HotJava",
    HU: "Huawei Browser",
    IB: "IBrowse",
    IC: "iCab",
    I2: "iCab Mobile",
    I1: "Iridium",
    I3: "Iron Mobile",
    I4: "IceCat",
    ID: "IceDragon",
    IV: "Isivioo",
    IW: "Iceweasel",
    IE: "Internet Explorer",
    IM: "IE Mobile",
    IR: "Iron",
    JB: "Japan Browser",
    JS: "Jasmine",
    JA: "JavaFX",
    JI: "Jig Browser",
    JP: "Jig Browser Plus",
    JO: "Jio Browser",
    KB: "K.Browser",
    KI: "Kindle Browser",
    KM: "K-meleon",
    KO: "Konqueror",
    KP: "Kapiko",
    KN: "Kinza",
    KW: "Kiwi",
    KD: "Kode Browser",
    KY: "Kylo",
    KZ: "Kazehakase",
    LB: "Cheetah Browser",
    LF: "LieBaoFast",
    LG: "LG Browser",
    LH: "Light",
    LI: "Links",
    IF: "Lolifox",
    LO: "Lovense Browser",
    LU: "LuaKit",
    LL: "Lulumi",
    LS: "Lunascape",
    LN: "Lunascape Lite",
    LX: "Lynx",
    M1: "mCent",
    MB: "MicroB",
    MC: "NCSA Mosaic",
    MZ: "Meizu Browser",
    ME: "Mercury",
    MF: "Mobile Safari",
    MI: "Midori",
    MO: "Mobicip",
    MU: "MIUI Browser",
    MS: "Mobile Silk",
    MN: "Minimo",
    MT: "Mint Browser",
    MX: "Maxthon",
    NM: "MxNitro",
    MY: "Mypal",
    MR: "Monument Browser",
    MW: "MAUI WAP Browser",
    NW: "Navigateur Web",
    NR: "NFS Browser",
    NB: "Nokia Browser",
    NO: "Nokia OSS Browser",
    NV: "Nokia Ovi Browser",
    NX: "Nox Browser",
    NE: "NetSurf",
    NF: "NetFront",
    NL: "NetFront Life",
    NP: "NetPositive",
    NS: "Netscape",
    NT: "NTENT Browser",
    OC: "Oculus Browser",
    O1: "Opera Mini iOS",
    OB: "Obigo",
    O2: "Odin",
    H2: "OceanHero",
    OD: "Odyssey Web Browser",
    OF: "Off By One",
    HH: "OhHai Browser",
    OE: "ONE Browser",
    OX: "Opera GX",
    OG: "Opera Neon",
    OH: "Opera Devices",
    OI: "Opera Mini",
    OM: "Opera Mobile",
    OP: "Opera",
    ON: "Opera Next",
    OO: "Opera Touch",
    OA: "Orca",
    OS: "Ordissimo",
    OR: "Oregano",
    O0: "Origin In-Game Overlay",
    OY: "Origyn Web Browser",
    OV: "Openwave Mobile Browser",
    OW: "OmniWeb",
    OT: "Otter Browser",
    PL: "Palm Blazer",
    PM: "Pale Moon",
    PY: "Polypane",
    PP: "Oppo Browser",
    PR: "Palm Pre",
    PU: "Puffin",
    PW: "Palm WebPro",
    PA: "Palmscape",
    PE: "Perfect Browser",
    PH: "Phantom Browser",
    PX: "Phoenix",
    PB: "Phoenix Browser",
    PF: "PlayFree Browser",
    PO: "Polaris",
    PT: "Polarity",
    LY: "PolyBrowser",
    PI: "PrivacyWall",
    PS: "Microsoft Edge",
    QA: "Qazweb",
    Q2: "QQ Browser Lite",
    Q1: "QQ Browser Mini",
    QQ: "QQ Browser",
    QT: "Qutebrowser",
    QU: "Quark",
    QZ: "QupZilla",
    QM: "Qwant Mobile",
    QW: "QtWebEngine",
    RE: "Realme Browser",
    RK: "Rekonq",
    RM: "RockMelt",
    SB: "Samsung Browser",
    SA: "Sailfish Browser",
    S8: "Seewo Browser",
    SC: "SEMC-Browser",
    SE: "Sogou Explorer",
    SF: "Safari",
    S5: "Safe Exam Browser",
    SW: "SalamWeb",
    SV: "SFive",
    SH: "Shiira",
    S1: "SimpleBrowser",
    SY: "Sizzy",
    SK: "Skyfire",
    SS: "Seraphic Sraf",
    SL: "Sleipnir",
    S6: "Slimjet",
    S7: "SP Browser",
    "7S": "7Star",
    LE: "Smart Lenovo Browser",
    OZ: "Smooz",
    SN: "Snowshoe",
    SO: "Sogou Mobile Browser",
    S2: "Splash",
    SI: "Sputnik Browser",
    SR: "Sunrise",
    SP: "SuperBird",
    SU: "Super Fast Browser",
    S3: "surf",
    SG: "Stargon",
    S0: "START Internet Browser",
    S4: "Steam In-Game Overlay",
    ST: "Streamy",
    SX: "Swiftfox",
    SZ: "Seznam Browser",
    TR: "T-Browser",
    TO: "t-online.de Browser",
    TA: "Tao Browser",
    TF: "TenFourFox",
    TB: "Tenta Browser",
    TZ: "Tizen Browser",
    TU: "Tungsten",
    TG: "ToGate",
    TS: "TweakStyle",
    TV: "TV Bro",
    UB: "UBrowser",
    UC: "UC Browser",
    UH: "UC Browser HD",
    UM: "UC Browser Mini",
    UT: "UC Browser Turbo",
    UR: "UR Browser",
    UZ: "Uzbl",
    VE: "Venus Browser",
    VI: "Vivaldi",
    VV: "vivo Browser",
    VB: "Vision Mobile Browser",
    VM: "VMware AirWatch",
    WI: "Wear Internet Browser",
    WP: "Web Explorer",
    WE: "WebPositive",
    WF: "Waterfox",
    WH: "Whale Browser",
    WO: "wOSBrowser",
    WT: "WeTab Browser",
    YJ: "Yahoo! Japan Browser",
    YA: "Yandex Browser",
    YL: "Yandex Browser Lite",
    YN: "Yaani Browser",
    YB: "Yolo Browser",
    XS: "xStand",
    XI: "Xiino",
    XV: "Xvast",
    ZE: "Zetakey",
    ZV: "Zvu"
}, $cdf7e442067abc24$var$gl = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$ol, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$cl = $cdf7e442067abc24$var$tl, $cdf7e442067abc24$var$xl = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$ul = $cdf7e442067abc24$var$nl, $cdf7e442067abc24$var$pl = $cdf7e442067abc24$var$gl([
    {
        regex: "Helio/(\\d+[\\.\\d]+)",
        name: "Helio",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "7654Browser/(\\d+[\\.\\d]+)",
        name: "7654 Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Qazweb/(\\d+[\\.\\d]+)",
        name: "Qazweb",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Degdegan/(\\d+[\\.\\d]+)",
        name: "deg-degan",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "JavaFX/(\\d+[\\.\\d]+)",
        name: "JavaFX",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Chedot/(\\d+[\\.\\d]+)",
        name: "Chedot",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Chrome/(\\d+[\\.\\d]+) \\(Chromium GOST\\)",
        name: "Chromium GOST",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "(?:DeledaoPersonal|DeledaoFamily)/(\\d+[\\.\\d]+)",
        name: "Deledao",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "HasBrowser/(\\d+[\\.\\d]+)",
        name: "HasBrowser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Byffox/(\\d+[\\.\\d]+)",
        name: "Byffox",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Chrome/(\\d+[\\.\\d]+).+AgentWeb.+UCBrowser",
        name: "CoolBrowser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "DotBrowser/(\\d+[\\.\\d]+)",
        name: "Dot Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "CravingExplorer/(\\d+[\\.\\d]+)",
        name: "Craving Explorer",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "DeskBrowse/(\\d+[\\.\\d]+)",
        name: "DeskBrowse",
        version: "$1"
    },
    {
        regex: "Lolifox/(\\d+[\\.\\d]+)",
        name: "Lolifox",
        version: "$1"
    },
    {
        regex: "qutebrowser/(\\d+[\\.\\d]+).+Chrome",
        name: "Qutebrowser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "qutebrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Qutebrowser",
        version: "$1"
    },
    {
        regex: "flast/(\\d+[\\.\\d]+)",
        name: "Flast",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "PolyBrowser/(\\d+[\\.\\d]+)",
        name: "PolyBrowser",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Chrome.+BriskBard/(\\d+[\\.\\d]+)",
        name: "BriskBard",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "BriskBard(?:/(\\d+[\\.\\d]+))?",
        name: "BriskBard",
        version: "$1"
    },
    {
        regex: "GinxDroidBrowser/(\\d+[\\.\\d]+)",
        name: "GinxDroid Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "AviraScout/(\\d+[\\.\\d]+)",
        name: "Avira Scout",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "VenusBrowser/(\\d+[\\.\\d]+)",
        name: "Venus Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Chrome.+Otter(?:[ /](\\d+[\\.\\d]+))?",
        name: "Otter Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Otter(?:[ /](\\d+[\\.\\d]+))?",
        name: "Otter Browser",
        version: "$1"
    },
    {
        regex: "Chrome.+Smooz/(\\d+[\\.\\d]+)",
        name: "Smooz",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Smooz/(\\d+[\\.\\d]+)",
        name: "Smooz",
        version: "$1"
    },
    {
        regex: "Cornowser/(\\d+[\\.\\d]+)",
        name: "Cornowser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Orca/(\\d+[\\.\\d]+)",
        name: "Orca",
        version: "$1"
    },
    {
        regex: "Flow/(?:(\\d+[\\.\\d]+))",
        name: "Flow",
        version: "$1",
        engine: {
            default: "EkiohFlow"
        }
    },
    {
        regex: "Ekioh/(?:(\\d+[\\.\\d]+))",
        name: "Flow",
        version: "$1",
        engine: {
            default: "EkiohFlow"
        }
    },
    {
        regex: "xStand/(\\d+[\\.\\d]+)",
        name: "xStand",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Biyubi/(\\d+[\\.\\d]+)",
        name: "Biyubi",
        version: "$1"
    },
    {
        regex: "(?:Perfect%20Browser(?:-iPad)?|Perfect(?:BrowserPro)?)/(\\d+[\\.\\d]+)",
        name: "Perfect Browser",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Browser/Phantom/V(\\d+[\\.\\d]+)",
        name: "Phantom Browser",
        version: "$1"
    },
    {
        regex: "AwoX(?:/(\\d+[\\.\\d]+))? Browser",
        name: "AwoX",
        version: "$1"
    },
    {
        regex: "Zetakey/(\\d+[\\.\\d]+)",
        name: "Zetakey",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "PlayFreeBrowser/(?:(\\d+[\\.\\d]+))?",
        name: "PlayFree Browser",
        version: "$1"
    },
    {
        regex: "(?:chimlac_browser|chimlac)/(?:(\\d+[\\.\\d]+))",
        name: "Chim Lac",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Odin/(?:(\\d+[\\.\\d]+))",
        name: "Odin",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Tbrowser/(\\d+[\\.\\d]+)",
        name: "T-Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "SFive(?:_Android)?/.+ Chrome/(\\d+[\\.\\d]+)",
        name: "SFive",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "SFive_IOS/(\\d+[\\.\\d]+)",
        name: "SFive",
        version: "$1"
    },
    {
        regex: "Navigateur web/(?:(\\d+[\\.\\d]+))?",
        name: "Navigateur Web",
        version: "$1"
    },
    {
        regex: "Sraf(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Seraphic Sraf",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "SeewoBrowser/(?:(\\d+[\\.\\d]+))?",
        name: "Seewo Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "(?:Kode(?:iOS)?/(?:(\\d+[\\.\\d]+))?|TansoDL)",
        name: "Kode Browser",
        version: "$1"
    },
    {
        regex: "UR/(?:(\\d+[\\.\\d]+))",
        name: "UR Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "OceanHero/([\\.\\d]+)",
        name: "OceanHero",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Chrome/.+ SLBrowser/(?:(\\d+[\\.\\d]+))?",
        name: "Smart Lenovo Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "SLBrowser/(?:(\\d+[\\.\\d]+))?",
        name: "Smart Lenovo Browser",
        version: "$1"
    },
    {
        regex: "Browzar",
        name: "Browzar",
        version: ""
    },
    {
        regex: "Stargon/(?:(\\d+[\\.\\d]+))?",
        name: "Stargon",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "NFSBrowser/(?:(\\d+[\\.\\d]+))?",
        name: "NFS Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Borealis/(\\d+[\\.\\d]+)",
        name: "Borealis Navigator",
        version: "$1"
    },
    {
        regex: "YoloBrowser/(?:(\\d+[\\.\\d]+))?",
        name: "Yolo Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "PHX/(?:(\\d+[\\.\\d]+))?",
        name: "Phoenix Browser",
        version: "$1"
    },
    {
        regex: "PrivacyWall/(?:(\\d+[\\.\\d]+))?",
        name: "PrivacyWall",
        version: "$1"
    },
    {
        regex: "Ghostery:?(\\d+[\\.\\d]+)?",
        name: "Ghostery Privacy Browser",
        version: "$1"
    },
    {
        regex: "Firefox/.*(?:Turkcell-)?YaaniBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Yaani Browser",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "(?:Turkcell-)?YaaniBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Yaani Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "SEB/(?:(\\d+[\\.\\d]+))?",
        name: "Safe Exam Browser",
        version: "$1"
    },
    {
        regex: "Colibri/(?:(\\d+[\\.\\d]+))?",
        name: "Colibri",
        version: "$1"
    },
    {
        regex: "Xvast/(?:(\\d+[\\.\\d]+))?",
        name: "Xvast",
        version: "$1"
    },
    {
        regex: "TungstenBrowser/(?:(\\d+[\\.\\d]+))?",
        name: "Tungsten",
        version: "$1"
    },
    {
        regex: "Lulumi-browser/(?:(\\d+[\\.\\d]+))?",
        name: "Lulumi",
        version: "$1"
    },
    {
        regex: "ybrowser/(?:(\\d+[\\.\\d]+))?",
        name: "Yahoo! Japan Browser",
        version: "$1"
    },
    {
        regex: "iLunascapeLite/(?:(\\d+[\\.\\d]+))?",
        name: "Lunascape Lite",
        version: "$1"
    },
    {
        regex: "Polypane/(?:(\\d+[\\.\\d]+))?",
        name: "Polypane",
        version: "$1"
    },
    {
        regex: "OhHaiBrowser/(?:(\\d+[\\.\\d]+))?",
        name: "OhHai Browser",
        version: "$1"
    },
    {
        regex: "Sizzy/(?:(\\d+[\\.\\d]+))?",
        name: "Sizzy",
        version: "$1"
    },
    {
        regex: "GlassBrowser/(?:(\\d+[\\.\\d]+))?",
        name: "Glass Browser",
        version: "$1"
    },
    {
        regex: "ToGate/(?:(\\d+[\\.\\d]+))?",
        name: "ToGate",
        version: "$1"
    },
    {
        regex: "AirWatch Browser v(?:(\\d+[\\.\\d]+))?",
        name: "VMware AirWatch",
        version: "$1"
    },
    {
        regex: "ADG/(?:(\\d+[\\.\\d]+))?",
        name: "AOL Desktop",
        version: "$1"
    },
    {
        regex: "Elements Browser/(?:(\\d+[\\.\\d]+))?",
        name: "Elements Browser",
        version: "$1"
    },
    {
        regex: "Light/(\\d+[\\.\\d]+)",
        name: "Light",
        version: "$1"
    },
    {
        regex: "Valve Steam GameOverlay/(?:(\\d+[\\.\\d]+))?",
        name: "Steam In-Game Overlay",
        version: "$1"
    },
    {
        regex: "115Browser/(?:(\\d+[\\.\\d]+))?",
        name: "115 Browser",
        version: "$1"
    },
    {
        regex: "Atom/(?:(\\d+[\\.\\d]+))?",
        name: "Atom",
        version: "$1"
    },
    {
        regex: "Mobile VR.+Firefox",
        name: "Firefox Reality",
        version: ""
    },
    {
        regex: "AVG(?:/(\\d+[\\.\\d]+))?",
        name: "AVG Secure Browser",
        version: "$1"
    },
    {
        regex: "Start/(?:(\\d+[\\.\\d]+))?",
        name: "START Internet Browser",
        version: "$1"
    },
    {
        regex: "Lovense(?:/(\\d+[\\.\\d]+))?",
        name: "Lovense Browser",
        version: "$1"
    },
    {
        regex: "com.airfind.deltabrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Delta Browser",
        version: "$1"
    },
    {
        regex: "(?:Ordissimo|webissimo3)(?:/(\\d+[\\.\\d]+))?",
        name: "Ordissimo",
        version: "$1"
    },
    {
        regex: "CCleaner(?:/(\\d+[\\.\\d]+))?",
        name: "CCleaner",
        version: "$1"
    },
    {
        regex: "AlohaLite(?:/(\\d+[\\.\\d]+))?",
        name: "Aloha Browser Lite",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "TaoBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Tao Browser",
        version: "$1"
    },
    {
        regex: "Falkon(?:/(\\d+[\\.\\d]+))?",
        name: "Falkon",
        version: "$1"
    },
    {
        regex: "mCent(?:/(\\d+[\\.\\d]+))?",
        name: "mCent",
        version: "$1"
    },
    {
        regex: "SalamWeb(?:/(\\d+[\\.\\d]+))?",
        name: "SalamWeb",
        version: "$1"
    },
    {
        regex: "BlackHawk(?:/(\\d+[\\.\\d]+))?",
        name: "BlackHawk",
        version: "$1"
    },
    {
        regex: "Minimo(?:/(\\d+[\\.\\d]+))?",
        name: "Minimo",
        version: "$1"
    },
    {
        regex: "WIB(?:/(\\d+[\\.\\d]+))?",
        name: "Wear Internet Browser",
        version: "$1"
    },
    {
        regex: "Origyn Web Browser",
        name: "Origyn Web Browser",
        version: ""
    },
    {
        regex: "Kinza(?:/(\\d+[\\.\\d]+))?",
        name: "Kinza",
        version: "$1"
    },
    {
        regex: "Beamrise(?:/(\\d+[\\.\\d]+))?",
        name: "Beamrise",
        version: "$1"
    },
    {
        regex: "Faux(?:/(\\d+[\\.\\d]+))?",
        name: "Faux Browser",
        version: "$1"
    },
    {
        regex: "splash Version(?:/(\\d+[\\.\\d]+))?",
        name: "Splash",
        version: "$1"
    },
    {
        regex: "MZBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Meizu Browser",
        version: "$1"
    },
    {
        regex: "COSBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "COS Browser",
        version: "$1"
    },
    {
        regex: "Crusta(?:/(\\d+[\\.\\d]+))?",
        name: "Crusta",
        version: "$1"
    },
    {
        regex: "Hawk/TurboBrowser(?:/v?(\\d+[\\.\\d]+))?",
        name: "Hawk Turbo Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "FreeU(?:/(\\d+[\\.\\d]+))?",
        name: "FreeU",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "NoxBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Nox Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Basilisk(?:/(\\d+[\\.\\d]+))?",
        name: "Basilisk",
        version: "$1",
        engine: {
            default: "Goanna"
        }
    },
    {
        regex: "SputnikBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Sputnik Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "TNSBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "K.Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "OculusBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Oculus Browser",
        version: "$1"
    },
    {
        regex: "Jio(?:Browser|Pages)(?:/(\\d+[\\.\\d]+))?",
        name: "Jio Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Chrome/.+ Hola(?:/(\\d+[\\.\\d]+))?",
        name: "hola! Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Slimjet/(?:(\\d+[\\.\\d]+))",
        name: "Slimjet",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "7Star/(?:(\\d+[\\.\\d]+))",
        name: "7Star",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "MxNitro/(?:(\\d+[\\.\\d]+))",
        name: "MxNitro",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "HuaweiBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Huawei Browser",
        version: "$1"
    },
    {
        regex: "VivoBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "vivo Browser",
        version: "$1"
    },
    {
        regex: "RealmeBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Realme Browser",
        version: "$1"
    },
    {
        regex: "Beaker ?Browser(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Beaker Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "QwantiOS/(\\d+[\\.\\d]+)",
        name: "Qwant Mobile",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "QwantMobile(?:/(\\d+[\\.\\d]+))?",
        name: "Qwant Mobile",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Qwant/(\\d+[\\.\\d]+)",
        name: "Qwant Mobile",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "TenFourFox(?:/(\\d+[\\.\\d]+))?",
        name: "TenFourFox",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "AOLShield(?:/(\\d+[\\.\\d]+))?",
        name: "AOL Shield",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Edge[ /](\\d+[\\.\\d]+)",
        name: "Microsoft Edge",
        version: "$1",
        engine: {
            default: "Edge"
        }
    },
    {
        regex: "EdgiOS[ /](\\d+[\\.\\d]+)",
        name: "Microsoft Edge",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "EdgA[ /](\\d+[\\.\\d]+)",
        name: "Microsoft Edge",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Edg[ /](\\d+[\\.\\d]+)",
        name: "Microsoft Edge",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "QIHU 360[ES]E",
        name: "360 Browser",
        version: ""
    },
    {
        regex: "360 Aphone Browser(?: \\((\\d+[\\.\\d]+)(?:beta)?\\))?",
        name: "360 Phone Browser",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "SailfishBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Sailfish Browser",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "IceCat(?:/(\\d+[\\.\\d]+))?",
        name: "IceCat",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Mobicip",
        name: "Mobicip",
        version: "",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Camino(?:/(\\d+[\\.\\d]+))?",
        name: "Camino",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Waterfox(?:/(\\d+[\\.\\d]+))?",
        name: "Waterfox",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Chrome/.+ AlohaBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Aloha Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "AlohaBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Aloha Browser",
        version: "$1"
    },
    {
        regex: "(?:Avast|ASW|Safer)(?:/(\\d+[\\.\\d]+))?",
        name: "Avast Secure Browser",
        version: "$1"
    },
    {
        regex: "Epic(?:/(\\d+[\\.\\d]+))",
        name: "Epic",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Fennec(?:/(\\d+[\\.\\d]+))?",
        name: "Fennec",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Firefox.*Tablet browser (\\d+[\\.\\d]+)",
        name: "MicroB",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Maemo Browser(?: (\\d+[\\.\\d]+))?",
        name: "MicroB",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Deepnet Explorer (\\d+[\\.\\d]+)?",
        name: "Deepnet Explorer",
        version: "$1"
    },
    {
        regex: "Avant ?Browser",
        name: "Avant Browser",
        version: "",
        engine: {
            default: ""
        }
    },
    {
        regex: "OppoBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Oppo Browser",
        version: "$1"
    },
    {
        regex: "Chrome/(\\d+[\\.\\d]+).*MRCHROME",
        name: "Amigo",
        version: "$1",
        engine: {
            default: "WebKit",
            versions: {
                28: "Blink"
            }
        }
    },
    {
        regex: "AtomicBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Atomic Web Browser",
        version: "$1"
    },
    {
        regex: "Bunjalloo(?:/(\\d+[\\.\\d]+))?",
        name: "Bunjalloo",
        version: "$1"
    },
    {
        regex: "Brave(?:/(\\d+[\\.\\d]+))?",
        name: "Brave",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Iridium(?:/(\\d+[\\.\\d]+))?",
        name: "Iridium",
        version: "$1"
    },
    {
        regex: "Iceweasel(?:/(\\d+[\\.\\d]+))?",
        name: "Iceweasel",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "WebPositive",
        name: "WebPositive",
        version: "",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: ".*Goanna.*PaleMoon(?:/(\\d+[\\.\\d]+))?",
        name: "Pale Moon",
        version: "$1",
        engine: {
            default: "Goanna"
        }
    },
    {
        regex: "PaleMoon(?:/(\\d+[\\.\\d]+))?",
        name: "Pale Moon",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "CometBird(?:/(\\d+[\\.\\d]+))?",
        name: "CometBird",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "IceDragon(?:/(\\d+[\\.\\d]+))?",
        name: "IceDragon",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Flock(?:/(\\d+[\\.\\d]+))?",
        name: "Flock",
        version: "$1",
        engine: {
            default: "Gecko",
            versions: {
                3: "WebKit"
            }
        }
    },
    {
        regex: "JigBrowserPlus/(?:(\\d+[\\.\\d]+))?",
        name: "Jig Browser Plus",
        version: "$1"
    },
    {
        regex: "jig browser(?: web;|9i?)?(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Jig Browser",
        version: "$1"
    },
    {
        regex: "Kapiko(?:/(\\d+[\\.\\d]+))?",
        name: "Kapiko",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Kylo(?:/(\\d+[\\.\\d]+))?",
        name: "Kylo",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Origin/(?:(\\d+[\\.\\d]+))?",
        name: "Origin In-Game Overlay",
        version: "$1"
    },
    {
        regex: "Cunaguaro(?:/(\\d+[\\.\\d]+))?",
        name: "Cunaguaro",
        version: "$1"
    },
    {
        regex: "(?:TO-Browser/TOB|DT-Browser/DTB)(\\d+[\\.\\d]+)",
        name: "t-online.de Browser",
        version: "$1"
    },
    {
        regex: "Kazehakase(?:/(\\d+[\\.\\d]+))?",
        name: "Kazehakase",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "ArcticFox(?:/(\\d+[\\.\\d]+))?",
        name: "Arctic Fox",
        version: "$1",
        engine: {
            default: "Goanna"
        }
    },
    {
        regex: "Mypal(?:/(\\d+[\\.\\d]+))?",
        name: "Mypal",
        version: "$1",
        engine: {
            default: "Goanna"
        }
    },
    {
        regex: "Centaury(?:/(\\d+[\\.\\d]+))?",
        name: "Centaury",
        version: "$1",
        engine: {
            default: "Goanna"
        }
    },
    {
        regex: "(?:Focus|Klar)(?:/(\\d+[\\.\\d]+))?",
        name: "Firefox Focus",
        version: "$1"
    },
    {
        regex: "Cyberfox(?:/(\\d+[\\.\\d]+))?",
        name: "Cyberfox",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Firefox/(\\d+[\\.\\d]+).*\\(Swiftfox\\)",
        name: "Swiftfox",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "(?:Mobile|Tablet).*Servo.*Firefox(?:/(\\d+[\\.\\d]+))?",
        name: "Firefox Mobile",
        version: "$1",
        engine: {
            default: "Servo"
        }
    },
    {
        regex: "(?:Mobile|Tablet).*Firefox(?:/(\\d+[\\.\\d]+))?",
        name: "Firefox Mobile",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "FxiOS/(\\d+[\\.\\d]+)",
        name: "Firefox Mobile iOS",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: ".*Servo.*Firefox(?:/(\\d+[\\.\\d]+))?",
        name: "Firefox",
        version: "$1",
        engine: {
            default: "Servo"
        }
    },
    {
        regex: "(?!.*Opera[ /])Firefox(?:/(\\d+[\\.\\d]+))?",
        name: "Firefox",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "(?:BonEcho|GranParadiso|Lorentz|Minefield|Namoroka|Shiretoko)/(\\d+[\\.\\d]+)",
        name: "Firefox",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "ANTFresco(?:[/ ](\\d+[\\.\\d]+))?",
        name: "ANT Fresco",
        version: "$1"
    },
    {
        regex: "ANTGalio(?:/(\\d+[\\.\\d]+))?",
        name: "ANTGalio",
        version: "$1"
    },
    {
        regex: "(?:Espial|Escape)(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Espial TV Browser",
        version: "$1"
    },
    {
        regex: "RockMelt(?:/(\\d+[\\.\\d]+))?",
        name: "RockMelt",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Fireweb Navigator(?:/(\\d+[\\.\\d]+))?",
        name: "Fireweb Navigator",
        version: "$1"
    },
    {
        regex: "Fireweb(?:/(\\d+[\\.\\d]+))?",
        name: "Fireweb",
        version: "$1"
    },
    {
        regex: "(?:Navigator|Netscape6?)(?:/(\\d+[\\.\\d]+))?",
        name: "Netscape",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "(?:Polarity)(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Polarity",
        version: "$1"
    },
    {
        regex: "(?:QupZilla)(?:[/ ](\\d+[\\.\\d]+))?",
        name: "QupZilla",
        version: "$1"
    },
    {
        regex: "(?:Dooble)(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Dooble",
        version: "$1"
    },
    {
        regex: "Whale/(\\d+[\\.\\d]+)",
        name: "Whale Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Obigo[ ]?(?:InternetBrowser|Browser)?(?:[ /]([a-z0-9]*))?",
        name: "Obigo",
        version: "$1"
    },
    {
        regex: "Obigo|Teleca",
        name: "Obigo",
        version: ""
    },
    {
        regex: "UCBrowserHD/(\\d[\\d\\.]+)",
        name: "UC Browser HD",
        version: "$1"
    },
    {
        regex: "UCMini(?:[ /]?(\\d+[\\.\\d]+))?",
        name: "UC Browser Mini",
        version: "$1"
    },
    {
        regex: "UC[ ]?Browser.* \\(UCMini\\)",
        name: "UC Browser Mini",
        version: ""
    },
    {
        regex: "UCTurbo(?:[ /]?(\\d+[\\.\\d]+))?",
        name: "UC Browser Turbo",
        version: "$1"
    },
    {
        regex: "UC[ ]?Browser.* \\(UCTurbo\\)",
        name: "UC Browser Turbo",
        version: ""
    },
    {
        regex: "OPRGX(?:/(\\d+[\\.\\d]+))?",
        name: "Opera GX",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "(?:Opera Tablet.*Version|Opera/.+Opera Mobi.+Version|Mobile.+OPR)/(\\d+[\\.\\d]+)",
        name: "Opera Mobile",
        version: "$1",
        engine: {
            default: "Presto",
            versions: {
                15: "Blink"
            }
        }
    },
    {
        regex: "MMS/(\\d+[\\.\\d]+)",
        name: "Opera Neon",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "OMI/(\\d+[\\.\\d]+)",
        name: "Opera Devices",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Opera%20Touch/(\\d+[\\.\\d]+)? CFNetwork/.+Darwin/.+(?!.*x86_64)",
        name: "Opera Touch",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "OPT/(\\d+[\\.\\d]+)",
        name: "Opera Touch",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Opera/(\\d+[\\.\\d]+).+Opera Mobi",
        name: "Opera Mobile",
        version: "$1",
        engine: {
            default: "Presto",
            versions: {
                15: "Blink"
            }
        }
    },
    {
        regex: "Opera ?Mini/(?:att/)?(\\d+[\\.\\d]+)",
        name: "Opera Mini",
        version: "$1",
        engine: {
            default: "Presto"
        }
    },
    {
        regex: "Opera ?Mini.+Version/(\\d+[\\.\\d]+)",
        name: "Opera Mini",
        version: "$1",
        engine: {
            default: "Presto"
        }
    },
    {
        regex: "OPiOS/(\\d+[\\.\\d]+)",
        name: "Opera Mini iOS",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Opera%20Mini/(\\d+[\\.\\d]+) CFNetwork",
        name: "Opera Mini iOS",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Opera.+Edition Next.+Version/(\\d+[\\.\\d]+)",
        name: "Opera Next",
        version: "$1",
        engine: {
            default: "Presto",
            versions: {
                15: "Blink"
            }
        }
    },
    {
        regex: "(?:Opera|OPR)[/ ](?:9.80.*Version/)?(\\d+[\\.\\d]+).+Edition Next",
        name: "Opera Next",
        version: "$1",
        engine: {
            default: "Presto",
            versions: {
                15: "Blink"
            }
        }
    },
    {
        regex: "(?:Opera[/ ]?|OPR[/ ])(?:9.80.*Version/)?(\\d+[\\.\\d]+)",
        name: "Opera",
        version: "$1",
        engine: {
            default: "",
            versions: {
                7: "Presto",
                15: "Blink",
                3.5: "Elektra"
            }
        }
    },
    {
        regex: "rekonq(?:/(\\d+[\\.\\d]+))?",
        name: "Rekonq",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "CoolNovo(?:/(\\d+[\\.\\d]+))?",
        name: "CoolNovo",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "(?:Comodo[ _])?Dragon(?!fruit)(?:/(\\d+[\\.\\d]+))?",
        name: "Comodo Dragon",
        version: "$1",
        engine: {
            default: "WebKit",
            versions: {
                28: "Blink"
            }
        }
    },
    {
        regex: "ChromePlus(?:/(\\d+[\\.\\d]+))?",
        name: "ChromePlus",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "Conkeror(?:/(\\d+[\\.\\d]+))?",
        name: "Conkeror",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Konqueror(?:/(\\d+[\\.\\d]+))?",
        name: "Konqueror",
        version: "$1",
        engine: {
            default: "KHTML",
            versions: {
                4: ""
            }
        }
    },
    {
        regex: "(?:baidubrowser|bdbrowser(?:(?:hd)?_i18n)?|FlyFlow|BaiduHD)(?:[/ ](\\d+[\\.\\d]*))?",
        name: "Baidu Browser",
        version: "$1"
    },
    {
        regex: "(?:(?:BD)?Spark(?:Safe)?|BIDUBrowser)[/ ](\\d+[\\.\\d]*)",
        name: "Baidu Spark",
        version: "$1"
    },
    {
        regex: "YaBrowser(?:/(\\d+[\\.\\d]*)) \\(lite\\)?",
        name: "Yandex Browser Lite",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "YaBrowser(?:/(\\d+[\\.\\d]*))(?: \\((alpha|beta)\\))?",
        name: "Yandex Browser",
        version: "$1 $2",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Ya(?:ndex)?SearchBrowser(?:/(\\d+[\\.\\d]*))",
        name: "Yandex Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Vivaldi(?:/(\\d+[\\.\\d]+))?",
        name: "Vivaldi",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "TweakStyle(?:/(\\d+[\\.\\d]+))?",
        name: "TweakStyle",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Chrome.+Midori Browser/(\\d+[\\.\\d]+)",
        name: "Midori",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Midori(?:/(\\d+[\\.\\d]+))?",
        name: "Midori",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Mercury(?:/(\\d+[\\.\\d]+))?",
        name: "Mercury",
        version: "$1"
    },
    {
        regex: "Chrome.+Maxthon(?:.+\\(portable\\))?/(\\d+[\\.\\d]+)",
        name: "Maxthon",
        version: "$1",
        engine: {
            default: "WebKit",
            versions: {
                5.2: "Blink"
            }
        }
    },
    {
        regex: "(?:Maxthon(?:%20Browser)?|MxBrowser(?:-inhouse|-iPhone)?)[ /](\\d+[\\.\\d]+)",
        name: "Maxthon",
        version: "$1",
        engine: {
            default: "",
            versions: {
                3: "WebKit"
            }
        }
    },
    {
        regex: "(?:Maxthon|MyIE2)",
        name: "Maxthon",
        version: "",
        engine: {
            default: ""
        }
    },
    {
        regex: "Puffin(?:/(\\d+[\\.\\d]+))?",
        name: "Puffin",
        version: "$1"
    },
    {
        regex: "MobileIron(?:/(\\d+[\\.\\d]+))?",
        name: "Iron Mobile",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Chrome(?:/(\\d+[\\.\\d]+))?.*Iron",
        name: "Iron",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Iron(?:/(\\d+[\\.\\d]+))?",
        name: "Iron",
        version: "$1",
        engine: {
            default: "WebKit",
            versions: {
                28: "Blink"
            }
        }
    },
    {
        regex: "Epiphany(?:/(\\d+[\\.\\d]+))?",
        name: "GNOME Web",
        version: "$1",
        engine: {
            default: "Gecko",
            versions: {
                "2.9.16": "",
                2.28: "WebKit"
            }
        }
    },
    {
        regex: "LieBaoFast(?:[ /](\\d+[\\.\\d]+))?",
        name: "LieBaoFast",
        version: "$1"
    },
    {
        regex: "LBBrowser(?:[ /](\\d+[\\.\\d]+))?",
        name: "Cheetah Browser",
        version: "$1"
    },
    {
        regex: "SE (\\d+[\\.\\d]+)",
        name: "Sogou Explorer",
        version: "$1"
    },
    {
        regex: "QQBrowserLite/([\\d\\.]+)",
        name: "QQ Browser Lite",
        version: "$1"
    },
    {
        regex: "M?QQBrowser/Mini([\\.\\d]+)?",
        name: "QQ Browser Mini",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "M?QQBrowser(?:/([\\.\\d]+))?",
        name: "QQ Browser",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "(?:MIUIBrowser|MiuiBrowser)(?:/(\\d+[\\.\\d]+))?",
        name: "MIUI Browser",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "(?:coc_coc_browser|coccocbrowser|CocCoc)(?:/(\\d+[\\.\\d]+))?",
        name: "Coc Coc",
        version: "$1",
        engine: {
            default: "WebKit",
            versions: {
                28: "Blink"
            }
        }
    },
    {
        regex: "DuckDuckGo/(\\d+[\\.\\d]*)",
        name: "DuckDuckGo Privacy Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Samsung ?Browser(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Samsung Browser",
        version: "$1"
    },
    {
        regex: "(?:SFB(?:rowser)?)/(\\d+[\\.\\d]+)",
        name: "Super Fast Browser",
        version: "$1"
    },
    {
        regex: "com.browser.tssomas(?:/(\\d+[\\.\\d]+))?",
        name: "Super Fast Browser",
        version: "$1"
    },
    {
        regex: "EUI Browser(?:/(\\d+[\\.\\d]+))?",
        name: "EUI Browser",
        version: "$1"
    },
    {
        regex: "UBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "UBrowser",
        version: "$1"
    },
    {
        regex: "Streamy(?:/(\\d+[\\.\\d]+))?",
        name: "Streamy",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "isivioo",
        name: "Isivioo",
        version: "",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "UC[ ]?Browser(?:[ /]?(\\d+[\\.\\d]+))?",
        name: "UC Browser",
        version: "$1"
    },
    {
        regex: "UCWEB(?:[ /]?(\\d+[\\.\\d]+))?",
        name: "UC Browser",
        version: "$1"
    },
    {
        regex: "UC AppleWebKit",
        name: "UC Browser",
        version: ""
    },
    {
        regex: "Tenta/(\\d+[\\.\\d]+)",
        name: "Tenta Browser",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Rocket/(\\d+[\\.\\d]+)",
        name: "Firefox Rocket",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Web Explorer/(\\d+[\\.\\d]+).*Chrome",
        name: "Web Explorer",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "SznProhlizec/(\\d+[\\.\\d]+)",
        name: "Seznam Browser",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "SogouMobileBrowser/(\\d+[\\.\\d]+)",
        name: "Sogou Mobile Browser",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "Mint Browser/(\\d+[\\.\\d]+)",
        name: "Mint Browser",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "Ecosia (?:android|ios)@(\\d+[\\.\\d]+)",
        name: "Ecosia",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "ACHEETAHI",
        name: "CM Browser",
        version: "",
        engine: {
            default: ""
        }
    },
    {
        regex: "Kiwi Chrome",
        name: "Kiwi",
        version: "",
        engine: {
            default: ""
        }
    },
    {
        regex: "Mb2345Browser/(\\d+[\\.\\d]+)",
        name: "2345 Browser",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "QtWebEngine/(\\d+[\\.\\d]+)",
        name: "QtWebEngine",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "Silk/(\\d+[\\.\\d]+) like Chrome",
        name: "Mobile Silk",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Silk(?:/(\\d+[\\.\\d]+))?",
        name: "Mobile Silk",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "IBrowse(?:[ /](\\d+[\\.\\d]+))?",
        name: "IBrowse",
        version: "$1"
    },
    {
        regex: "UP.Browser(?:/(\\d+[\\.\\d]+))?",
        name: "Openwave Mobile Browser",
        version: "$1"
    },
    {
        regex: "Openwave(?:/(\\d+[\\.\\d]+))?",
        name: "Openwave Mobile Browser",
        version: "$1"
    },
    {
        regex: "OneBrowser(?:[ /](\\d+[\\.\\d]+))?",
        name: "ONE Browser",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "(?:NokiaBrowser|BrowserNG)(?:/(\\d+[\\.\\d]+))?",
        name: "Nokia Browser",
        version: "$1"
    },
    {
        regex: "Series60/5\\.0",
        name: "Nokia Browser",
        version: "7.0"
    },
    {
        regex: "Series60/(\\d+[\\.\\d]+)",
        name: "Nokia OSS Browser",
        version: "$1"
    },
    {
        regex: "S40OviBrowser/(\\d+[\\.\\d]+)",
        name: "Nokia Ovi Browser",
        version: "$1"
    },
    {
        regex: "^Nokia|Nokia[EN]?\\d+",
        name: "Nokia Browser",
        version: ""
    },
    {
        regex: "Sleipnir(?:(?:%20Browser)?[ /](\\d+[\\.\\d]+))?",
        name: "Sleipnir",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "NTENTBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "NTENT Browser",
        version: "$1"
    },
    {
        regex: "TV Bro/(\\d+[\\.\\d]+)",
        name: "TV Bro",
        version: "$1"
    },
    {
        regex: "Chrome/.+ Quark(?:/(\\d+[\\.\\d]+))?",
        name: "Quark",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "MonumentBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Monument Browser",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "BlueBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "Blue Browser",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "JAPAN Browser(?:/(\\d+[\\.\\d]+))?",
        name: "Japan Browser",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Version/.* Chrome(?:/(\\d+[\\.\\d]+))?",
        name: "Chrome Webview",
        version: "$1",
        engine: {
            default: "WebKit",
            versions: {
                28: "Blink"
            }
        }
    },
    {
        regex: "CrMo(?:/(\\d+[\\.\\d]+))?",
        name: "Chrome Mobile",
        version: "$1",
        engine: {
            default: "WebKit",
            versions: {
                28: "Blink"
            }
        }
    },
    {
        regex: "CriOS(?:/(\\d+[\\.\\d]+))?",
        name: "Chrome Mobile iOS",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Chrome(?:/(\\d+[\\.\\d]+))? Mobile",
        name: "Chrome Mobile",
        version: "$1",
        engine: {
            default: "WebKit",
            versions: {
                28: "Blink"
            }
        }
    },
    {
        regex: "chromeframe(?:/(\\d+[\\.\\d]+))?",
        name: "Chrome Frame",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Chromium(?:/(\\d+[\\.\\d]+))?",
        name: "Chromium",
        version: "$1",
        engine: {
            default: "WebKit",
            versions: {
                28: "Blink"
            }
        }
    },
    {
        regex: "HeadlessChrome(?:/(\\d+[\\.\\d]+))?",
        name: "Headless Chrome",
        version: "$1",
        engine: {
            default: "Blink"
        }
    },
    {
        regex: "Chrome(?!book)(?:/(\\d+[\\.\\d]+))?",
        name: "Chrome",
        version: "$1",
        engine: {
            default: "WebKit",
            versions: {
                28: "Blink"
            }
        }
    },
    {
        regex: "(?:Tizen|SLP) Browser(?:/(\\d+[\\.\\d]+))?",
        name: "Tizen Browser",
        version: "$1"
    },
    {
        regex: "Blazer(?:/(\\d+[\\.\\d]+))?",
        name: "Palm Blazer",
        version: "$1"
    },
    {
        regex: "Pre/(\\d+[\\.\\d]+)",
        name: "Palm Pre",
        version: "$1"
    },
    {
        regex: "(?:hpw|web)OS/(\\d+[\\.\\d]+)",
        name: "wOSBrowser",
        version: "$1"
    },
    {
        regex: "WebPro(?:[ /](\\d+[\\.\\d]+))?",
        name: "Palm WebPro",
        version: "$1"
    },
    {
        regex: "Palmscape(?:[ /](\\d+[\\.\\d]+))?",
        name: "Palmscape",
        version: "$1"
    },
    {
        regex: "Jasmine(?:[ /](\\d+[\\.\\d]+))?",
        name: "Jasmine",
        version: "$1"
    },
    {
        regex: "Lynx(?:/(\\d+[\\.\\d]+))?",
        name: "Lynx",
        version: "$1",
        engine: {
            default: "Text-based"
        }
    },
    {
        regex: "NCSA_Mosaic(?:/(\\d+[\\.\\d]+))?",
        name: "NCSA Mosaic",
        version: "$1"
    },
    {
        regex: "ABrowse(?: (\\d+[\\.\\d]+))?",
        name: "ABrowse",
        version: "$1"
    },
    {
        regex: "amaya(?:/(\\d+[\\.\\d]+))?",
        name: "Amaya",
        version: "$1"
    },
    {
        regex: "AmigaVoyager(?:/(\\d+[\\.\\d]+))?",
        name: "Amiga Voyager",
        version: "$1"
    },
    {
        regex: "Amiga-Aweb(?:/(\\d+[\\.\\d]+))?",
        name: "Amiga Aweb",
        version: "$1"
    },
    {
        regex: "Arora(?:/(\\d+[\\.\\d]+))?",
        name: "Arora",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Beonex(?:/(\\d+[\\.\\d]+))?",
        name: "Beonex",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "bline(?:/(\\d+[\\.\\d]+))?",
        name: "B-Line",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "BrowseX \\((\\d+[\\.\\d]+)",
        name: "BrowseX",
        version: "$1"
    },
    {
        regex: "Charon(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Charon",
        version: "$1"
    },
    {
        regex: "Cheshire(?:/(\\d+[\\.\\d]+))?",
        name: "Cheshire",
        version: "$1"
    },
    {
        regex: "dbrowser",
        name: "dbrowser",
        version: "",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Dillo(?:/(\\d+[\\.\\d]+))?",
        name: "Dillo",
        version: "$1",
        engine: {
            default: "Dillo"
        }
    },
    {
        regex: "Dolfin(?:/(\\d+[\\.\\d]+))?|dolphin",
        name: "Dolphin",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Elinks(?:/(\\d+[\\.\\d]+))?",
        name: "Elinks",
        version: "$1",
        engine: {
            default: "Text-based"
        }
    },
    {
        regex: "Element Browser(?:[ /](\\d+[\\.\\d]+))?",
        name: "Element Browser",
        version: "$1"
    },
    {
        regex: "eZBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "eZ Browser",
        version: "$1"
    },
    {
        regex: "Firebird(?! Build)(?:/(\\d+[\\.\\d]+))?",
        name: "Firebird",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Fluid(?:/(\\d+[\\.\\d]+))?",
        name: "Fluid",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Galeon(?:/(\\d+[\\.\\d]+))?",
        name: "Galeon",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Google Earth(?:/(\\d+[\\.\\d]+))?",
        name: "Google Earth",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "HotJava(?:/(\\d+[\\.\\d]+))?",
        name: "HotJava",
        version: "$1"
    },
    {
        regex: "iCabMobile(?:[ /](\\d+[\\.\\d]+))?",
        name: "iCab Mobile",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "iCab(?:[ /](\\d+[\\.\\d]+))?",
        name: "iCab",
        version: "$1",
        engine: {
            default: "iCab",
            versions: {
                4: "WebKit"
            }
        }
    },
    {
        regex: "i?Lunascape(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Lunascape",
        version: "$1",
        engine: {
            default: ""
        }
    },
    {
        regex: "Crazy Browser (\\d+[\\.\\d]+)",
        name: "Crazy Browser",
        version: "$1",
        engine: {
            default: "Trident"
        }
    },
    {
        regex: "IEMobile[ /](\\d+[\\.\\d]+)",
        name: "IE Mobile",
        version: "$1",
        engine: {
            default: "Trident"
        }
    },
    {
        regex: "MSIE (\\d+[\\.\\d]+).*XBLWP7",
        name: "IE Mobile",
        version: "$1",
        engine: {
            default: "Trident"
        }
    },
    {
        regex: "MSIE.*Trident/4.0",
        name: "Internet Explorer",
        version: "8.0",
        engine: {
            default: "Trident"
        }
    },
    {
        regex: "MSIE.*Trident/5.0",
        name: "Internet Explorer",
        version: "9.0",
        engine: {
            default: "Trident"
        }
    },
    {
        regex: "MSIE.*Trident/6.0",
        name: "Internet Explorer",
        version: "10.0",
        engine: {
            default: "Trident"
        }
    },
    {
        regex: "Trident/[78].0",
        name: "Internet Explorer",
        version: "11.0",
        engine: {
            default: "Trident"
        }
    },
    {
        regex: "MSIE (\\d+[\\.\\d]+)",
        name: "Internet Explorer",
        version: "$1",
        engine: {
            default: "Trident"
        }
    },
    {
        regex: "IE[ /](\\d+[\\.\\d]+)",
        name: "Internet Explorer",
        version: "$1",
        engine: {
            default: "Trident"
        }
    },
    {
        regex: "Kindle/(\\d+[\\.\\d]+)",
        name: "Kindle Browser",
        version: "$1"
    },
    {
        regex: "K-meleon(?:/(\\d+[\\.\\d]+))?",
        name: "K-meleon",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "Links(?: \\((\\d+[\\.\\d]+))?",
        name: "Links",
        version: "$1",
        engine: {
            default: "Text-based"
        }
    },
    {
        regex: "LG Browser(?:/(\\d+[\\.\\d]+))",
        name: "LG Browser",
        version: "$1"
    },
    {
        regex: "LuaKit(?:/(\\d+[\\.\\d]+))?",
        name: "LuaKit",
        version: "$1"
    },
    {
        regex: "OmniWeb(?:/[v]?(\\d+[\\.\\d]+))?",
        name: "OmniWeb",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Phoenix(?:/(\\d+[\\.\\d]+))?",
        name: "Phoenix",
        version: "$1"
    },
    {
        regex: "NetFrontLifeBrowser(?:/(\\d+[\\.\\d]+))?",
        name: "NetFront Life",
        version: "$1",
        engine: {
            default: "NetFront"
        }
    },
    {
        regex: "NetFront(?:/(\\d+[\\.\\d]+))?",
        name: "NetFront",
        version: "$1",
        engine: {
            default: "NetFront"
        }
    },
    {
        regex: "PLAYSTATION|NINTENDO 3|AppleWebKit.+ N[XF]/\\d+\\.\\d+\\.\\d+",
        name: "NetFront",
        version: ""
    },
    {
        regex: "NetPositive(?:/(\\d+[\\.\\d]+))?",
        name: "NetPositive",
        version: "$1"
    },
    {
        regex: "Odyssey Web Browser(?:.*OWB/(\\d+[\\.\\d]+))?",
        name: "Odyssey Web Browser",
        version: "$1"
    },
    {
        regex: "OffByOne",
        name: "Off By One",
        version: ""
    },
    {
        regex: "(?:Oregano|OreganMediaBrowser)(?:[ /](\\d+[\\.\\d]+))?",
        name: "Oregano",
        version: "$1"
    },
    {
        regex: "(?:Polaris|Embider)(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Polaris",
        version: "$1"
    },
    {
        regex: "SEMC-Browser(?:[/ ](\\d+[\\.\\d]+))?",
        name: "SEMC-Browser",
        version: "$1"
    },
    {
        regex: "Shiira(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Shiira",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Skyfire(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Skyfire",
        version: "$1"
    },
    {
        regex: "Snowshoe(?:/(\\d+[\\.\\d]+))?",
        name: "Snowshoe",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Sunrise(?:Browser)?(?:/(\\d+[\\.\\d]+))?",
        name: "Sunrise",
        version: "$1"
    },
    {
        regex: "SuperBird(?:/(\\d+[\\.\\d]+))?",
        name: "SuperBird",
        version: "$1"
    },
    {
        regex: "Vision-Browser(?:/(\\d+[\\.\\d]+))",
        name: "Vision Mobile Browser",
        version: "$1"
    },
    {
        regex: "WeTab-Browser",
        name: "WeTab Browser",
        version: ""
    },
    {
        regex: "Xiino(?:/(\\d+[\\.\\d]+))?",
        name: "Xiino",
        version: "$1"
    },
    {
        regex: "BlackBerry|PlayBook|BB10",
        name: "BlackBerry Browser",
        version: ""
    },
    {
        regex: "Android",
        name: "Android Browser",
        version: "",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Coast(?:/(\\d+[\\.\\d]+))?",
        name: "Coast",
        version: "$1"
    },
    {
        regex: "Surf(?:/(\\d+[\\.\\d]+))?",
        name: "surf",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "(?:(?:iPod|iPad|iPhone).+Version|MobileSafari)/(\\d+[\\.\\d]+)",
        name: "Mobile Safari",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "(?:Version/(\\d+[\\.\\d]+).*)?Mobile.*Safari/",
        name: "Mobile Safari",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "(?:iPod|iPhone|iPad)",
        name: "Mobile Safari",
        version: "",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Version/(\\d+[\\.\\d]+).*Safari/|Safari/?\\d+",
        name: "Safari",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    },
    {
        regex: "Dorado WAP-Browser[/ ](\\d+[\\.\\d]+)",
        name: "Dorado",
        version: "$1"
    },
    {
        regex: "NetSurf(?:/(\\d+[\\.\\d]+))?",
        name: "NetSurf",
        version: "$1",
        engine: {
            default: "NetSurf"
        }
    },
    {
        regex: "Uzbl",
        name: "Uzbl",
        version: ""
    },
    {
        regex: "SimpleBrowser",
        name: "SimpleBrowser",
        version: ""
    },
    {
        regex: "Zvu(?:/(\\d+[\\.\\d]+))?",
        name: "Zvu",
        version: "$1",
        engine: {
            default: "Gecko"
        }
    },
    {
        regex: "GOGGalaxyClient/(\\d+[\\.\\d]+)?",
        name: "GOG Galaxy",
        version: "$1"
    },
    {
        regex: "WAP Browser/MAUI|(?:\\w+)?Maui Wap Browser|MAUI[- ]Browser",
        name: "MAUI WAP Browser",
        version: ""
    },
    {
        regex: "SP%20Browser/(\\d+[\\.\\d]+)",
        name: "SP Browser",
        version: "$1",
        engine: {
            default: "WebKit"
        }
    }
]), $cdf7e442067abc24$var$hl = $cdf7e442067abc24$var$gl([
    {
        regex: "NetFront",
        name: "NetFront"
    },
    {
        regex: "Edge",
        name: "Edge"
    },
    {
        regex: "Trident",
        name: "Trident"
    },
    {
        regex: "(?<!SmartHu)Blink",
        name: "Blink"
    },
    {
        regex: "(?:Apple)?WebKit",
        name: "WebKit"
    },
    {
        regex: "Presto",
        name: "Presto"
    },
    {
        regex: "Goanna",
        name: "Goanna"
    },
    {
        regex: "(?<!like )Gecko",
        name: "Gecko"
    },
    {
        regex: "KHTML",
        name: "KHTML"
    },
    {
        regex: "NetSurf",
        name: "NetSurf"
    },
    {
        regex: "Servo",
        name: "Servo"
    },
    {
        regex: "Goanna",
        name: "Goanna"
    },
    {
        regex: "Ekioh(?:Flow)?",
        name: "EkiohFlow"
    }
]), $cdf7e442067abc24$var$Sl = $cdf7e442067abc24$var$gl($cdf7e442067abc24$var$ml), $cdf7e442067abc24$var$vl = $cdf7e442067abc24$var$gl([
    "36",
    "OC",
    "PU",
    "SK",
    "MF",
    "OI",
    "OM",
    "DD",
    "DB",
    "ST",
    "BL",
    "IV",
    "FM",
    "C1",
    "C4",
    "SA",
    "SB",
    "FR",
    "WP",
    "HA",
    "NX",
    "HU",
    "VV",
    "RE",
    "CB",
    "MZ",
    "UM",
    "FK",
    "FX",
    "WI",
    "MN",
    "M1",
    "AH",
    "SU",
    "EU",
    "EZ",
    "UT",
    "DT",
    "S0",
    "QU",
    "YN",
    "JB",
    "GH",
    "PI",
    "SG",
    "KD",
    "PE",
    "UH",
    "S7",
    "CW",
    "OZ",
    "GI",
    "VE"
]);
class $cdf7e442067abc24$var$$l {
    constructor(e){
        this.options = {
            versionTruncation: 1
        }, this.parse = (e)=>{
            var r = {
                type: "",
                name: "",
                version: "",
                engine: "",
                engineVersion: ""
            };
            for (const d of $cdf7e442067abc24$var$pl.default){
                var o = $cdf7e442067abc24$var$ul.userAgentParser(d.regex, e);
                if (o) {
                    var t, a, l = $cdf7e442067abc24$var$xl.variableReplacement(d.version, o), i = $cdf7e442067abc24$var$cl.formatVersion(l, this.options.versionTruncation), n = i && parseFloat($cdf7e442067abc24$var$cl.formatVersion(l, 1)) || "";
                    if (d.engine && (r.engine = d.engine.default, d.engine && d.engine.versions && n)) for ([t, a] of Object.entries(d.engine.versions).sort((e, r)=>parseFloat(e[0]) > parseFloat(r[0]) ? 1 : -1))parseFloat(t) <= n && (r.engine = a || "");
                    r.type = "browser", r.name = $cdf7e442067abc24$var$xl.variableReplacement(d.name, o), r.version = i;
                    break;
                }
            }
            if (!r.engine) for (const t of $cdf7e442067abc24$var$hl.default){
                let a = null;
                try {
                    a = RegExp(t.regex, "i").exec(e);
                } catch (o) {}
                if (a) {
                    r.engine = t.name;
                    break;
                }
            }
            return r.engineVersion = $cdf7e442067abc24$var$cl.formatVersion($cdf7e442067abc24$var$cl.parseBrowserEngineVersion(e, r.engine), this.options.versionTruncation), r;
        }, this.options = Object.assign(Object.assign({}, this.options), e);
    }
}
($cdf7e442067abc24$var$ol.default = $cdf7e442067abc24$var$$l).getBrowserShortName = (e)=>{
    for (var [r, o] of Object.entries($cdf7e442067abc24$var$Sl.default))if (o === e) return r;
    return "";
}, $cdf7e442067abc24$var$$l.isMobileOnlyBrowser = (e)=>$cdf7e442067abc24$var$vl.default.includes($cdf7e442067abc24$var$$l.getBrowserShortName(e));
var $cdf7e442067abc24$var$bl = {}, $cdf7e442067abc24$var$Al = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$bl, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$fl = $cdf7e442067abc24$var$Al([
    {
        regex: "AndroidDownloadManager(?:[ /]([\\d\\.]+))?",
        name: "AndroidDownloadManager",
        version: "$1"
    },
    {
        regex: "(?:Apple)?News(?:[ /][\\d\\.]+)? Version(?:[ /]([\\d\\.]+))?",
        name: "Apple News",
        version: "$1"
    },
    {
        regex: "bPod",
        name: "bPod",
        version: ""
    },
    {
        regex: "MessengerLiteForiOS.(?:FBAV)(?:[ /]([\\d\\.]+))?",
        name: "Facebook Messenger Lite",
        version: "$1"
    },
    {
        regex: "(?:MessengerForiOS|MESSENGER).(?:FBAV)(?:[ /]([\\d\\.]+))?",
        name: "Facebook Messenger",
        version: "$1"
    },
    {
        regex: "(?:FBAV|com.facebook.katana)(?:[ /]([\\d\\.]+))?",
        name: "Facebook",
        version: "$1"
    },
    {
        regex: "(?:FBAN|FBSV|FBID|FBBV)/",
        name: "Facebook",
        version: ""
    },
    {
        regex: "FeedR(?:/([\\d\\.]+))?",
        name: "FeedR",
        version: "$1"
    },
    {
        regex: "com.google.android.apps.searchlite",
        name: "Google Go",
        version: ""
    },
    {
        regex: "com.google.android.apps.magazines",
        name: "Google Play Newsstand",
        version: ""
    },
    {
        regex: "com.google.GooglePlus",
        name: "Google Plus",
        version: ""
    },
    {
        regex: "MicroMessenger/([^; ]+)",
        name: "WeChat",
        version: "$1"
    },
    {
        regex: "WeChatShareExtensionNew/([\\d\\.]+)",
        name: "WeChat Share Extension",
        version: "$1"
    },
    {
        regex: "DingTalk/([0-9\\.]+)",
        name: "DingTalk",
        version: "$1"
    },
    {
        regex: ".*__weibo__([0-9\\.]+)__",
        name: "Sina Weibo",
        version: "$1"
    },
    {
        regex: "Pinterest(?: for (?:Android|iOS))?(?:/([\\d\\.]+))?",
        name: "Pinterest",
        version: "$1"
    },
    {
        regex: "Podcatcher Deluxe",
        name: "Podcatcher Deluxe",
        version: ""
    },
    {
        regex: "com.google.android.youtube(?:/([\\d\\.]+))?",
        name: "YouTube",
        version: "$1"
    },
    {
        regex: "([^/]+)/(\\d+(?:\\.\\d+)+) \\((?:iPhone|iPad); iOS [0-9\\.]+; Scale/[0-9\\.]+\\)",
        name: "$1",
        version: "$2"
    },
    {
        regex: "WhatsApp(?:[ /]([\\d\\.]+))?",
        name: "WhatsApp",
        version: "$1"
    },
    {
        regex: "Line(?:[ /]([\\d\\.]+))",
        name: "Line",
        version: "$1"
    },
    {
        regex: "Instacast(?:HD)?/(\\d\\.[\\d\\.abc]+) CFNetwork/([\\d\\.]+) Darwin/([\\d\\.]+)",
        name: "Instacast",
        version: "$1"
    },
    {
        regex: "Podcasts/([\\d\\.]+)",
        name: "Podcasts",
        version: "$1"
    },
    {
        regex: "Pocket Casts(?:, (?:Android|iOS) v([\\d\\.]+))?",
        name: "Pocket Casts",
        version: "$1"
    },
    {
        regex: "Podcat/([\\d\\.]+)",
        name: "Podcat",
        version: "$1"
    },
    {
        regex: "BeyondPod",
        name: "BeyondPod",
        version: null
    },
    {
        regex: "AntennaPod/?([\\d\\.]+)?",
        name: "AntennaPod",
        version: "$1"
    },
    {
        regex: "Overcast/([\\d\\.]+)",
        name: "Overcast",
        version: "$1"
    },
    {
        regex: "(?:CastBox|fm.castbox.audiobook.radio.podcast)/?([\\d\\.]+)?",
        name: "CastBox",
        version: "$1"
    },
    {
        regex: "Player FM",
        name: "Player FM",
        version: ""
    },
    {
        regex: "Podkicker(?: Pro)?/([\\d\\.]+)",
        name: "Podkicker",
        version: "$1"
    },
    {
        regex: "PodcastRepublic/([\\d\\.]+)",
        name: "Podcast Republic",
        version: "$1"
    },
    {
        regex: "Castro/(\\d+)",
        name: "Castro",
        version: "$1"
    },
    {
        regex: "Castro 2 ([\\d\\.]+)/[\\d]+ Like iTunes",
        name: "Castro 2",
        version: "$1"
    },
    {
        regex: "Castro 2",
        name: "Castro 2",
        version: ""
    },
    {
        regex: "DoggCatcher",
        name: "DoggCatcher",
        version: null
    },
    {
        regex: "PodcastAddict/v([\\d]+)",
        name: "Podcast & Radio Addict",
        version: "$1"
    },
    {
        regex: "Podcat(?:%202)?/([\\d]+) CFNetwork",
        name: "Podcat",
        version: "$1"
    },
    {
        regex: "iCatcher[^\\d]+([\\d\\.]+)",
        name: "iCatcher",
        version: "$1"
    },
    {
        regex: "YelpApp/([\\d\\.]+)",
        name: "Yelp Mobile",
        version: "$1"
    },
    {
        regex: "jp.co.yahoo.android.yjtop/([\\d\\.]+)",
        name: "Yahoo! Japan",
        version: "$1"
    },
    {
        regex: "RSSRadio/([\\d]+)?",
        name: "RSSRadio",
        version: "$1"
    },
    {
        regex: "SogouSearch Android[\\d\\.]+ version([\\d\\.]+)?",
        name: "SogouSearch App",
        version: "$1"
    },
    {
        regex: "NewsArticle/([\\d\\.]+)?",
        name: "NewsArticle App",
        version: "$1"
    },
    {
        regex: "tieba/([\\d\\.]+)?",
        name: "tieba",
        version: "$1"
    },
    {
        regex: "com\\.douban\\.group/([\\d\\.]+)?",
        name: "douban App",
        version: "$1"
    },
    {
        regex: "BingWeb/([\\d\\.]+)?",
        name: "BingWebApp",
        version: "$1"
    },
    {
        regex: "(?:com.google.GoogleMobile|GSA)/([\\d\\.]+)?",
        name: "Google Search App",
        version: "$1"
    },
    {
        regex: "Flipboard/([\\d\\.]+)?",
        name: "Flipboard App",
        version: "$1"
    },
    {
        regex: "Instagram[ /]([\\d\\.]+)?",
        name: "Instagram App",
        version: "$1"
    },
    {
        regex: "baiduboxapp/([\\d\\.]+)?",
        name: "Baidu Box App",
        version: "$1"
    },
    {
        regex: "Crosswalk(?!.*(?:Streamy|QwantMobile))/([\\d\\.]+)?",
        name: "CrosswalkApp",
        version: "$1"
    },
    {
        regex: "Twitter for iPhone[/]?([\\d\\.]+)?",
        name: "Twitter",
        version: "$1"
    },
    {
        regex: "Twitter/([\\d\\.]+)",
        name: "Twitter",
        version: "$1"
    },
    {
        regex: "TwitterAndroid[/]?([\\d\\.]+)?",
        name: "Twitter",
        version: "$1"
    },
    {
        regex: "TopBuzz/([\\d\\.]+)",
        name: "TopBuzz",
        version: "$1"
    },
    {
        regex: "Snapchat/([\\d\\.]+)",
        name: "Snapchat",
        version: "$1"
    },
    {
        regex: "UnityPlayer/([\\d\\.]+)",
        name: "UnityPlayer",
        version: "$1"
    },
    {
        regex: "UCURSOS/v([\\d\\.]+)",
        name: "U-Cursos",
        version: "$1"
    },
    {
        regex: "HeyTapBrowser/([\\d\\.]+)",
        name: "HeyTapBrowser",
        version: "$1"
    },
    {
        regex: "RobloxApp/([\\d\\.]+)",
        name: "Roblox",
        version: "$1"
    },
    {
        regex: "Viber/([\\d\\.]+)",
        name: "Viber",
        version: "$1"
    },
    {
        regex: "Siri/1",
        name: "Siri",
        version: "1.0"
    },
    {
        regex: "LinkedIn/([\\d\\.]+)",
        name: "LinkedIn",
        version: "$1"
    },
    {
        regex: "Instapaper/([\\d\\.]+)",
        name: "Instapaper",
        version: "$1"
    },
    {
        regex: "Keeper/([\\d\\.]+)",
        name: "Keeper Password Manager",
        version: "$1"
    },
    {
        regex: "Skyeng Teachers/([\\d\\.]+)",
        name: "Skyeng Teachers",
        version: "$1"
    },
    {
        regex: "Kik/([\\d\\.]+) \\(Android",
        name: "Kik",
        version: "$1"
    },
    {
        regex: "Procast/?([\\d\\.]+)?",
        name: "Procast",
        version: "$1"
    },
    {
        regex: "DeviantArt/([\\d\\.]+)",
        name: "DeviantArt",
        version: ""
    },
    {
        regex: "Discord/([\\d\\.]+)",
        name: "Discord",
        version: ""
    },
    {
        regex: "Covenant%20Eyes/([\\d\\.]+)",
        name: "Covenant Eyes",
        version: "$1"
    },
    {
        regex: "HP%20Smart/([\\d\\.]+)",
        name: "HP Smart",
        version: ""
    },
    {
        regex: "Bitsboard/([\\d\\.]+)",
        name: "Bitsboard",
        version: "$1"
    },
    {
        regex: "Betbull/([\\d\\.]+)",
        name: "BetBull",
        version: ""
    },
    {
        regex: "U-Cursos/([\\d\\.]+)",
        name: "U-Cursos",
        version: ""
    },
    {
        regex: "1PasswordThumbs/([\\d\\.]+)",
        name: "1Password",
        version: "$1"
    },
    {
        regex: "(?:Microsoft Office )?(Access|Excel|OneDrive for Business|OneNote|PowerPoint|Project|Publisher|Visio|Word)[ /]([\\d\\.]+)",
        name: "Microsoft Office $1",
        version: "$2"
    },
    {
        regex: "OneDriveiOSApp/([\\d\\.]+)",
        name: "Microsoft OneDrive",
        version: "$1"
    },
    {
        regex: "Microsoft Office Mobile/([\\d\\.]+)",
        name: "Microsoft Office Mobile",
        version: "$1"
    },
    {
        regex: "OC/([\\d\\.]+) \\(Skype for Business\\)",
        name: "Skype for Business",
        version: "$1"
    },
    {
        regex: "TikTok[/ ](\\d+\\.(?:[\\.\\d]+))?",
        name: "TikTok",
        version: "$1"
    },
    {
        regex: "NAVER/(\\d+[\\.\\d]+) CFNetwork",
        name: "Naver",
        version: "$1"
    },
    {
        regex: "Copied/(\\d+[\\.\\d]+) CFNetwork",
        name: "Copied",
        version: ""
    },
    {
        regex: "Pic%20Collage/(\\d+[\\.\\d]+) CFNetwork",
        name: "Pic Collage",
        version: "$1"
    },
    {
        regex: "Papers/(\\d+[\\.\\d]+) CFNetwork",
        name: "Papers",
        version: "$1"
    },
    {
        regex: "RoboForm/(\\d+[\\.\\d]+) CFNetwork",
        name: "RoboForm",
        version: ""
    },
    {
        regex: "Slack/(\\d+[\\.\\d]+) CFNetwork",
        name: "Slack",
        version: ""
    },
    {
        regex: "KAKAOTALK (\\d+\\.(?:[\\.\\d]+))?",
        name: "KakaoTalk",
        version: "$1"
    },
    {
        regex: "ShopeeVN/([\\d\\.]+)",
        name: "Shopee",
        version: "$1"
    },
    {
        regex: "SPORT1/([\\d\\.]+)",
        name: "SPORT1",
        version: ""
    },
    {
        regex: "Clovia/([\\d\\.]+)",
        name: "Clovia",
        version: "$1"
    },
    {
        regex: "ShowMe/([\\d\\.]+)",
        name: "ShowMe",
        version: "$1"
    },
    {
        regex: "Wattpad/([\\d\\.]+)",
        name: "Wattpad",
        version: "$1"
    },
    {
        regex: "WSJ/([\\d\\.]+)",
        name: "The Wall Street Journal",
        version: ""
    },
    {
        regex: "WH%20Questions/([\\d\\.]+)",
        name: "WH Questions",
        version: "$1"
    },
    {
        regex: "whisper/([\\d\\.]+)",
        name: "Whisper",
        version: ""
    },
    {
        regex: "Opal/([\\d\\.]+)",
        name: "Opal Travel",
        version: "$1"
    },
    {
        regex: "Zalo/([\\d\\.]+)",
        name: "Zalo",
        version: "$1"
    },
    {
        regex: "Yandex/([\\d\\.]+)",
        name: "Yandex",
        version: ""
    },
    {
        regex: "Zoho%20Chat/([\\d\\.]+)",
        name: "Zoho Chat",
        version: "$1"
    },
    {
        regex: "Thunder/(\\d+[\\.\\d]+)",
        name: "Thunder",
        version: "$1"
    },
    {
        regex: "CGNBrowser/(\\d+[\\.\\d]+)",
        name: "CGN",
        version: "$1"
    },
    {
        regex: "Podbean/.+App (\\d+[\\.\\d]+)",
        name: "Podbean",
        version: "$1"
    },
    {
        regex: "AlexaMediaPlayer/(\\d+[\\.\\d]+)",
        name: "Alexa Media Player",
        version: "$1"
    },
    {
        regex: "TuneIn Radio Pro(?:[^/]+)?/(\\d+[\\.\\d]+)",
        name: "TuneIn Radio Pro",
        version: "$1"
    },
    {
        regex: "TuneIn Radio(?:[^/]+)?/(\\d+[\\.\\d]+)",
        name: "TuneIn Radio",
        version: "$1"
    },
    {
        regex: "Podcaster/(\\d+[\\.\\d]+)",
        name: "Podcaster",
        version: "$1"
    },
    {
        regex: "Swoot/(\\d+[\\.\\d]+)",
        name: "Swoot",
        version: "$1"
    },
    {
        regex: "RadioPublic/android-(\\d+[\\.\\d]+)",
        name: "RadioPublic",
        version: "$1"
    },
    {
        regex: "Podimo/(\\d+[\\.\\d]+)",
        name: "Podimo",
        version: "$1"
    },
    {
        regex: "com.evolve.podcast/(\\d+[\\.\\d]+)",
        name: "Evolve Podcast",
        version: "$1"
    },
    {
        regex: " Rocket.Chat\\+?/(\\d+[\\.\\d]+)",
        name: "Rocket Chat",
        version: "$1"
    },
    {
        regex: "^Pandora Audio.+Android",
        name: "Pandora",
        version: ""
    },
    {
        regex: "^NPROneAndroid",
        name: "NPR One",
        version: ""
    },
    {
        regex: "^WirtschaftsWoche-iOS-(\\d+[\\.\\d]+)",
        name: "Wirtschafts Woche",
        version: "$1"
    },
    {
        regex: "^Outlook-iOS/.+\\((\\d+[\\.\\d]+)\\)$",
        name: "Microsoft Outlook",
        version: "$1"
    },
    {
        regex: "^TVirl/(\\d+[\\.\\d]+)",
        name: "TVirl",
        version: "$1"
    },
    {
        regex: "2?chMate/(\\d+[\\.\\d]+)",
        name: "ChMate",
        version: "$1"
    },
    {
        regex: "2tch/(\\d+[\\.\\d]+)",
        name: "2tch",
        version: "$1"
    },
    {
        regex: "Ciisaa/(\\d+[\\.\\d]+)",
        name: "Ciisaa",
        version: "$1"
    },
    {
        regex: "BB2C (\\d+[\\.\\d]+)",
        name: "BB2C",
        version: "$1"
    },
    {
        regex: "twinkle/(\\d+[\\.\\d]+)",
        name: "twinkle",
        version: "$1"
    },
    {
        regex: "JaneStyle_iOS/(\\d+[\\.\\d]+)",
        name: "JaneStyle",
        version: "$1"
    }
]), $cdf7e442067abc24$var$Ml = $cdf7e442067abc24$var$tl, $cdf7e442067abc24$var$Pl = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$Tl = $cdf7e442067abc24$var$nl;
$cdf7e442067abc24$var$bl.default = class {
    constructor(e){
        this.options = {
            versionTruncation: 1
        }, this.parse = (e)=>{
            var r = {
                type: "",
                name: "",
                version: ""
            };
            for (const t of $cdf7e442067abc24$var$fl.default){
                var o = $cdf7e442067abc24$var$Tl.userAgentParser(t.regex, e);
                if (o) {
                    r.type = "mobile app", r.name = $cdf7e442067abc24$var$Pl.variableReplacement(t.name, o), r.version = $cdf7e442067abc24$var$Ml.formatVersion($cdf7e442067abc24$var$Pl.variableReplacement(t.version, o), this.options.versionTruncation);
                    break;
                }
            }
            return r;
        }, this.options = Object.assign(Object.assign({}, this.options), e);
    }
};
var $cdf7e442067abc24$var$_l = {}, $cdf7e442067abc24$var$yl = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$_l, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$wl = $cdf7e442067abc24$var$yl([
    {
        regex: "Akregator(?:/(\\d+[\\.\\d]+))?",
        name: "Akregator",
        version: "$1",
        url: "http://userbase.kde.org/Akregator",
        type: "Feed Reader"
    },
    {
        regex: "Apple-PubSub(?:/(\\d+[\\.\\d]+))?",
        name: "Apple PubSub",
        version: "$1",
        url: "https://developer.apple.com/library/mac/documentation/Darwin/Reference/ManPages/man1/pubsub.1.html",
        type: "Feed Reader"
    },
    {
        regex: "BashPodder",
        name: "BashPodder",
        version: "",
        url: "http://lincgeek.org/bashpodder/",
        type: "Feed Reader"
    },
    {
        regex: "Breaker/v([\\d\\.]+)",
        name: "Breaker",
        version: "$1",
        url: "https://www.breaker.audio/",
        type: "Feed Reader App"
    },
    {
        regex: "Downcast/([\\d\\.]+)",
        name: "Downcast",
        version: "$1",
        url: "http://downcastapp.com/",
        type: "Feed Reader App"
    },
    {
        regex: "FeedDemon(?:/(\\d+[\\.\\d]+))?",
        name: "FeedDemon",
        version: "$1",
        url: "http://www.feeddemon.com/",
        type: "Feed Reader"
    },
    {
        regex: "Feeddler(?:RSS|PRO)(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Feeddler RSS Reader",
        version: "$1",
        url: "http://www.chebinliu.com/projects/iphone/feeddler-rss-reader/",
        type: "Feed Reader App"
    },
    {
        regex: "QuiteRSS(?:[/ ](\\d+[\\.\\d]+))?",
        name: "QuiteRSS",
        version: "$1",
        url: "https://quiterss.org",
        type: "Feed Reader App"
    },
    {
        regex: "gPodder/([\\d\\.]+)",
        name: "gPodder",
        version: "$1",
        url: "http://gpodder.org/",
        type: "Feed Reader App"
    },
    {
        regex: "JetBrains Omea Reader(?:[/ ](\\d+[\\.\\d]+))?",
        name: "JetBrains Omea Reader",
        version: "$1",
        url: "http://www.jetbrains.com/omea/reader/",
        type: "Feed Reader"
    },
    {
        regex: "Liferea(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Liferea",
        version: "$1",
        url: "http://liferea.sf.net/",
        type: "Feed Reader"
    },
    {
        regex: "(?:NetNewsWire|Evergreen.+MacOS)(?:[/ ](\\d+[\\.\\d]+))?",
        name: "NetNewsWire",
        version: "$1",
        url: "http://netnewswireapp.com/",
        type: "Feed Reader"
    },
    {
        regex: "NewsBlur (?:iPhone|iPad) App(?: v(\\d+[\\.\\d]+))?",
        name: "NewsBlur Mobile App",
        version: "$1",
        url: "http://www.newsblur.com",
        type: "Feed Reader App"
    },
    {
        regex: "NewsBlur(?:/(\\d+[\\.\\d]+))",
        name: "NewsBlur",
        version: "$1",
        url: "http://www.newsblur.com",
        type: "Feed Reader"
    },
    {
        regex: "newsbeuter(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Newsbeuter",
        version: "$1",
        url: "http://www.newsbeuter.org/",
        type: "Feed Reader"
    },
    {
        regex: "PritTorrent/([\\d\\.]+)",
        name: "PritTorrent",
        version: "$1",
        url: "http://bitlove.org",
        type: "Feed Reader"
    },
    {
        regex: "Pulp[/ ](\\d+[\\.\\d]+)",
        name: "Pulp",
        version: "$1",
        url: "http://www.acrylicapps.com/pulp/",
        type: "Feed Reader App"
    },
    {
        regex: "ReadKit(?:[/ ](\\d+[\\.\\d]+))?",
        name: "ReadKit",
        version: "$1",
        url: "http://readkitapp.com/",
        type: "Feed Reader App"
    },
    {
        regex: "Reeder[/ ](\\d+[\\.\\d]+)",
        name: "Reeder",
        version: "$1",
        url: "http://reederapp.com/",
        type: "Feed Reader App"
    },
    {
        regex: "RSSBandit(?:[/ ](\\d+[\\.\\d]+))?",
        name: "RSS Bandit",
        version: "$1",
        url: "http://www.rssbandit.org)",
        type: "Feed Reader"
    },
    {
        regex: "RSS Junkie(?:[/ ](\\d+[\\.\\d]+))?",
        name: "RSS Junkie",
        version: "$1",
        url: "https://play.google.com/store/apps/details?id=com.bitpowder.rssjunkie",
        type: "Feed Reader App"
    },
    {
        regex: "RSSOwl(?:[/ ](\\d+[\\.\\d]+))?",
        name: "RSSOwl",
        version: "$1",
        url: "http://www.rssowl.org/",
        type: "Feed Reader"
    },
    {
        regex: "Stringer",
        name: "Stringer",
        version: "",
        url: "https://github.com/swanson/stringer",
        type: "Feed Reader"
    }
]), $cdf7e442067abc24$var$Gl = $cdf7e442067abc24$var$tl, $cdf7e442067abc24$var$Ll = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$Cl = $cdf7e442067abc24$var$nl;
$cdf7e442067abc24$var$_l.default = class {
    constructor(e){
        this.options = {
            versionTruncation: 1
        }, this.parse = (e)=>{
            var r = {
                type: "",
                name: "",
                version: "",
                url: ""
            };
            for (const t of $cdf7e442067abc24$var$wl.default){
                var o = $cdf7e442067abc24$var$Cl.userAgentParser(t.regex, e);
                if (o) {
                    r.type = "feed reader", r.name = $cdf7e442067abc24$var$Ll.variableReplacement(t.name, o), r.version = $cdf7e442067abc24$var$Gl.formatVersion($cdf7e442067abc24$var$Ll.variableReplacement(t.version, o), this.options.versionTruncation), r.url = t.url;
                    break;
                }
            }
            return r;
        }, this.options = Object.assign(Object.assign({}, this.options), e);
    }
};
var $cdf7e442067abc24$var$Bl = {}, $cdf7e442067abc24$var$El = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$Bl, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$Nl = $cdf7e442067abc24$var$El([
    {
        regex: "Wget(?:/(\\d+[\\.\\d]+))?",
        name: "Wget",
        version: "$1"
    },
    {
        regex: "Guzzle(?:/(\\d+[\\.\\d]+))?",
        name: "Guzzle (PHP HTTP Client)",
        version: "$1"
    },
    {
        regex: "(?:lib)?curl(?:/(\\d+[\\.\\d]+))?",
        name: "curl",
        version: "$1"
    },
    {
        regex: "python-requests(?:/(\\d+[\\.\\d]+))?",
        name: "Python Requests",
        version: "$1"
    },
    {
        regex: "Python-urllib(?:/?(\\d+[\\.\\d]+))?",
        name: "Python urllib",
        version: "$1"
    },
    {
        regex: "Java(?:/?(\\d+[\\.\\d]+))?",
        name: "Java",
        version: "$1"
    },
    {
        regex: "(?:perlclient|libwww-perl)(?:/?(\\d+[\\.\\d]+))?",
        name: "Perl",
        version: "$1"
    },
    {
        regex: "okhttp/([\\d\\.]+)",
        name: "OkHttp",
        version: "$1"
    },
    {
        regex: "HTTP_Request2(?:/(\\d+[\\.\\d]+))?",
        name: "HTTP_Request2",
        version: "$1"
    },
    {
        regex: "HTTP_Request2(?:/(\\d+[\\.\\d]+))?",
        name: "HTTP_Request2",
        version: "$1",
        url: "http://pear.php.net/package/http_request2"
    },
    {
        regex: "Mechanize(?:/(\\d+[\\.\\d]+))?",
        name: "Mechanize",
        version: "$1",
        url: "http://github.com/sparklemotion/mechanize/"
    },
    {
        regex: "aiohttp(?:/(\\d+[\\.\\d]+))?",
        name: "aiohttp",
        version: "$1"
    },
    {
        regex: "Google-HTTP-Java-Client(?:/(\\d+[\\.\\d\\w-]+))?",
        name: "Google HTTP Java Client",
        version: "$1"
    },
    {
        regex: "WWW-Mechanize(?:/(\\d+[\\.\\d]+))?",
        name: "WWW-Mechanize",
        version: "$1"
    },
    {
        regex: "Faraday(?: v(\\d+[\\.\\d]+))?",
        name: "Faraday",
        version: "$1"
    },
    {
        regex: "(?:Go-http-client|Go )/?(?:(\\d+[\\.\\d]+))?(?: package http)?",
        name: "Go-http-client",
        version: "$1"
    },
    {
        regex: "urlgrabber(?:/(\\d+[\\.\\d]+))?",
        name: "urlgrabber (yum)",
        version: "$1"
    },
    {
        regex: "libdnf(?:/(\\d+[\\.\\d]+))?",
        name: "libdnf",
        version: "$1"
    },
    {
        regex: "HTTPie(?:/(\\d+[\\.\\d]+))?",
        name: "HTTPie",
        version: "$1"
    },
    {
        regex: "rest-client/(\\d+[\\.\\d]+).*ruby",
        name: "REST Client for Ruby",
        version: "$1"
    },
    {
        regex: "RestSharp/(\\d+[\\.\\d]+)",
        name: "RestSharp",
        version: "$1",
        url: "http://restsharp.org/"
    },
    {
        regex: "scalaj-http/(\\d+[\\.\\d]+)",
        name: "ScalaJ HTTP",
        version: "$1",
        url: "https://github.com/scalaj/scalaj-http"
    },
    {
        regex: "REST::Client/(\\d+)",
        name: "Perl REST::Client",
        version: "$1",
        url: "https://metacpan.org/pod/REST::Client"
    },
    {
        regex: "node-fetch/(\\d+[\\.\\d]+)",
        name: "Node Fetch",
        version: "$1",
        url: "https://github.com/node-fetch/node-fetch"
    },
    {
        regex: "ReactorNetty/(\\d+[\\.\\d]+)",
        name: "ReactorNetty",
        version: "$1",
        url: "https://github.com/reactor/reactor-netty"
    },
    {
        regex: "PostmanRuntime(?:/(\\d+[\\.\\d]+))?",
        name: "Postman Desktop",
        version: "$1",
        url: "https://github.com/postmanlabs/postman-runtime"
    },
    {
        regex: "Jakarta Commons-HttpClient/([\\.\\d]+)",
        name: "Jakarta Commons HttpClient",
        version: "$1",
        url: "https://hc.apache.org/httpclient-3.x"
    },
    {
        regex: "WinHttp.WinHttpRequest.+([\\.\\d]+)",
        name: "WinHttp WinHttpRequest",
        version: "$1"
    },
    {
        regex: "Embarcadero URI Client/([\\.\\d]+)",
        name: "Embarcadero URI Client",
        version: "$1"
    },
    {
        regex: "Mikrotik/([\\.\\d]+)",
        name: "Mikrotik Fetch",
        version: "$1"
    },
    {
        regex: "GRequests(?:/(\\d+[\\.\\d]+))?",
        name: "GRequests",
        version: "$1"
    },
    {
        regex: "akka-http/([\\.\\d]+)",
        name: "Akka HTTP",
        version: "$1"
    }
]), $cdf7e442067abc24$var$Ol = $cdf7e442067abc24$var$tl, $cdf7e442067abc24$var$Il = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$kl = $cdf7e442067abc24$var$nl;
$cdf7e442067abc24$var$Bl.default = class {
    constructor(e){
        this.options = {
            versionTruncation: 1
        }, this.parse = (e)=>{
            var r = {
                type: "",
                name: "",
                version: "",
                url: ""
            };
            for (const t of $cdf7e442067abc24$var$Nl.default){
                var o = $cdf7e442067abc24$var$kl.userAgentParser(t.regex, e);
                if (o) {
                    r.type = "library", r.name = $cdf7e442067abc24$var$Il.variableReplacement(t.name, o), r.version = $cdf7e442067abc24$var$Ol.formatVersion($cdf7e442067abc24$var$Il.variableReplacement(t.version, o), this.options.versionTruncation), r.url = t.url || "";
                    break;
                }
            }
            return r;
        }, this.options = Object.assign(Object.assign({}, this.options), e);
    }
};
var $cdf7e442067abc24$var$Xl = {}, $cdf7e442067abc24$var$Dl = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$Xl, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$Rl = $cdf7e442067abc24$var$Dl([
    {
        regex: "Audacious(?:[ /]([\\d\\.]+))?",
        name: "Audacious",
        version: "$1"
    },
    {
        regex: "Banshee(?:[ /]([\\d\\.]+))?",
        name: "Banshee",
        version: "$1"
    },
    {
        regex: "Boxee(?:[ /]([\\d\\.]+))?",
        name: "Boxee",
        version: "$1"
    },
    {
        regex: "Clementine(?:[ /]([\\d\\.]+))?",
        name: "Clementine",
        version: "$1"
    },
    {
        regex: "Deezer(?:/([\\d\\.]+))?",
        name: "Deezer",
        version: "$1"
    },
    {
        regex: "iTunes(?:-iPhone|-iPad)?(?:/([\\d\\.]+))?",
        name: "iTunes",
        version: "$1"
    },
    {
        regex: "FlyCast(?:/([\\d\\.]+))?",
        name: "FlyCast",
        version: "$1"
    },
    {
        regex: "foobar2000(?:/([\\d\\.]+))?",
        name: "Foobar2000",
        version: "$1"
    },
    {
        regex: "MediaMonkey(?:[ /](\\d+[\\.\\d]+))?",
        name: "MediaMonkey",
        version: "$1"
    },
    {
        regex: "Miro(?:/(\\d+[\\.\\d]+))?",
        name: "Miro",
        version: "$1"
    },
    {
        regex: "NexPlayer(?:/(\\d+[\\.\\d]+))?",
        name: "NexPlayer",
        version: "$1"
    },
    {
        regex: "Nightingale(?:/([\\d\\.]+))?",
        name: "Nightingale",
        version: "$1"
    },
    {
        regex: "QuickTime(?:(?:(?:.+qtver=)|(?:(?: E-)?[\\./]))([\\d\\.]+))?",
        name: "QuickTime",
        version: "$1"
    },
    {
        regex: "Songbird(?:/([\\d\\.]+))?",
        name: "Songbird",
        version: "$1"
    },
    {
        regex: "SubStream(?:/([\\d\\.]+))?",
        name: "SubStream",
        version: "$1"
    },
    {
        regex: "Sonos/([\\d\\.]+)?",
        name: "SONOS",
        version: "$1"
    },
    {
        regex: "(?:Lib)?VLC(?:/([\\d\\.]+))?",
        name: "VLC",
        version: "$1"
    },
    {
        regex: "Winamp(?:MPEG)?(?:/(\\d+[\\.\\d]+))?",
        name: "Winamp",
        version: "$1"
    },
    {
        regex: "(?:Windows-Media-Player|NSPlayer)(?:/(\\d+[\\.\\d]+))?",
        name: "Windows Media Player",
        version: "$1"
    },
    {
        regex: "XBMC(?:/([\\d\\.]+))?",
        name: "XBMC",
        version: "$1"
    },
    {
        regex: "Kodi(?:/([\\d\\.]+))?",
        name: "Kodi",
        version: "$1"
    },
    {
        regex: "stagefright(?:/([\\d\\.]+))?",
        name: "Stagefright",
        version: "$1"
    },
    {
        regex: "GoogleChirp(?:/(\\d+[\\.\\d]+))?",
        name: "Google Podcasts",
        version: "$1"
    },
    {
        regex: "Music Player Daemon (?:(\\d+[\\.\\d]+))?",
        name: "Music Player Daemon",
        version: "$1"
    },
    {
        regex: "mpv (?:(\\d+[\\.\\d]+))?",
        name: "mpv",
        version: "$1"
    }
]), $cdf7e442067abc24$var$Fl = $cdf7e442067abc24$var$tl, $cdf7e442067abc24$var$Vl = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$Hl = $cdf7e442067abc24$var$nl;
$cdf7e442067abc24$var$Xl.default = class {
    constructor(e){
        this.options = {
            versionTruncation: 1
        }, this.parse = (e)=>{
            var r = {
                type: "",
                name: "",
                version: ""
            };
            for (const t of $cdf7e442067abc24$var$Rl.default){
                var o = $cdf7e442067abc24$var$Hl.userAgentParser(t.regex, e);
                if (o) {
                    r.type = "media player", r.name = $cdf7e442067abc24$var$Vl.variableReplacement(t.name, o), r.version = $cdf7e442067abc24$var$Fl.formatVersion($cdf7e442067abc24$var$Vl.variableReplacement(t.version, o), this.options.versionTruncation);
                    break;
                }
            }
            return r;
        }, this.options = Object.assign(Object.assign({}, this.options), e);
    }
};
var $cdf7e442067abc24$var$Ul = {}, $cdf7e442067abc24$var$Kl = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$Ul, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$Wl = $cdf7e442067abc24$var$Kl([
    {
        regex: "Outlook-Express(?:/(\\d+[\\.\\d]+))?",
        name: "Outlook Express",
        version: "$1"
    },
    {
        regex: "Microsoft Outlook(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Microsoft Outlook",
        version: "$1"
    },
    {
        regex: "(?:Thunderbird|Icedove|Shredder)(?:/(\\d+[\\.\\d]+))?",
        name: "Thunderbird",
        version: "$1"
    },
    {
        regex: "Airmail(?: (\\d+[\\.\\d]+))?",
        name: "Airmail",
        version: "$1"
    },
    {
        regex: "Lotus-Notes(?:/(\\d+[\\.\\d]+))?",
        name: "Lotus Notes",
        version: "$1"
    },
    {
        regex: "Barca(?:Pro)?(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Barca",
        version: "$1"
    },
    {
        regex: "Postbox(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Postbox",
        version: "$1"
    },
    {
        regex: "MailBar(?:[/ ](\\d+[\\.\\d]+))?",
        name: "MailBar",
        version: "$1"
    },
    {
        regex: "The Bat!(?: Voyager)?(?:[/ ](\\d+[\\.\\d]+))?",
        name: "The Bat!",
        version: "$1"
    },
    {
        regex: "DAVdroid(?:/(\\d+[\\.\\d]+))?",
        name: "DAVdroid",
        version: "$1"
    },
    {
        regex: "(?:SeaMonkey|Iceape)(?:/(\\d+[\\.\\d]+))?",
        name: "SeaMonkey",
        version: "$1"
    },
    {
        regex: "Live5ch/(\\d+[\\.\\d]+)",
        name: "Live5ch",
        version: "$1"
    },
    {
        regex: "JaneView/",
        name: "JaneView",
        version: ""
    },
    {
        regex: "BathyScaphe/",
        name: "BathyScaphe",
        version: ""
    }
]), $cdf7e442067abc24$var$Zl = $cdf7e442067abc24$var$tl, $cdf7e442067abc24$var$Ql = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$zl = $cdf7e442067abc24$var$nl;
$cdf7e442067abc24$var$Ul.default = class {
    constructor(e){
        this.options = {
            versionTruncation: 1
        }, this.parse = (e)=>{
            var r = {
                type: "",
                name: "",
                version: ""
            };
            for (const t of $cdf7e442067abc24$var$Wl.default){
                var o = $cdf7e442067abc24$var$zl.userAgentParser(t.regex, e);
                if (o) {
                    r.type = "personal information manager", r.name = $cdf7e442067abc24$var$Ql.variableReplacement(t.name, o), r.version = $cdf7e442067abc24$var$Zl.formatVersion($cdf7e442067abc24$var$Ql.variableReplacement(t.version, o), this.options.versionTruncation);
                    break;
                }
            }
            return r;
        }, this.options = Object.assign(Object.assign({}, this.options), e);
    }
};
var $cdf7e442067abc24$var$Yl = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$rl, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$Jl = $cdf7e442067abc24$var$Yl($cdf7e442067abc24$var$ol), $cdf7e442067abc24$var$jl = $cdf7e442067abc24$var$Yl($cdf7e442067abc24$var$bl), $cdf7e442067abc24$var$ql = $cdf7e442067abc24$var$Yl($cdf7e442067abc24$var$_l), $cdf7e442067abc24$var$ei = $cdf7e442067abc24$var$Yl($cdf7e442067abc24$var$Bl), $cdf7e442067abc24$var$ri = $cdf7e442067abc24$var$Yl($cdf7e442067abc24$var$Xl), $cdf7e442067abc24$var$oi = $cdf7e442067abc24$var$Yl($cdf7e442067abc24$var$Ul), $cdf7e442067abc24$var$ti = [
    $cdf7e442067abc24$var$ql.default,
    $cdf7e442067abc24$var$jl.default,
    $cdf7e442067abc24$var$ri.default,
    $cdf7e442067abc24$var$oi.default,
    $cdf7e442067abc24$var$Jl.default,
    $cdf7e442067abc24$var$ei.default
];
$cdf7e442067abc24$var$rl.default = class {
    constructor(e){
        this.options = {
            versionTruncation: 1
        }, this.parse = (e)=>{
            for (const o of $cdf7e442067abc24$var$ti){
                var r = new o(this.options).parse(e);
                if ("" !== r.type) return r;
            }
            return null;
        }, this.options = Object.assign(Object.assign({}, this.options), e);
    }
};
var $cdf7e442067abc24$var$ai = {}, $cdf7e442067abc24$var$li = {}, $cdf7e442067abc24$var$ii = {
    Nikon: {
        regex: "Coolpix S800c",
        device: "camera",
        model: "Coolpix S800c"
    },
    Samsung: {
        regex: "EK-G[CN][0-9]{3}",
        device: "camera",
        models: [
            {
                regex: "EK-GN120",
                model: "Galaxy NX"
            },
            {
                regex: "EK-GC100",
                model: "Galaxy Camera"
            },
            {
                regex: "EK-GC110",
                model: "Galaxy Camera WiFi only"
            },
            {
                regex: "EK-GC200",
                model: "Galaxy Camera 2"
            },
            {
                regex: "EK-GC([0-9]{3})",
                model: "Galaxy Camera $1"
            }
        ]
    }
}, $cdf7e442067abc24$var$ni = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$li, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$di = $cdf7e442067abc24$var$ni($cdf7e442067abc24$var$ii), $cdf7e442067abc24$var$si = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$mi = $cdf7e442067abc24$var$nl;
$cdf7e442067abc24$var$li.default = class {
    constructor(){
        this.parse = (e)=>{
            var r, o, t = {
                type: "",
                brand: "",
                model: ""
            };
            for ([r, o] of Object.entries($cdf7e442067abc24$var$di.default)){
                var a = $cdf7e442067abc24$var$mi.userAgentParser(o.regex, e);
                if (a) {
                    if (t.type = "camera", t.brand = r, "model" in o && o.model) t.model = $cdf7e442067abc24$var$si.variableReplacement(o.model, a).trim();
                    else if ("models" in o && o.models) for (const r of o.models){
                        var l = $cdf7e442067abc24$var$mi.userAgentParser(r.regex, e);
                        if (l) {
                            t.model = $cdf7e442067abc24$var$si.variableReplacement(r.model, l).trim();
                            break;
                        }
                    }
                    break;
                }
            }
            return t;
        };
    }
};
var $cdf7e442067abc24$var$gi = {}, $cdf7e442067abc24$var$ci = {
    360: {
        regex: "(?:180[1379]-A01|1713-A01|1707-A01|1509-A00|1603-A03|1607-A01|1503-A01)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "1807-A01(?:[);/ ]|$)",
                model: "N7"
            },
            {
                regex: "1803-A01(?:[);/ ]|$)",
                model: "N7 Lite"
            },
            {
                regex: "1809-A01(?:[);/ ]|$)",
                model: "N7 Pro"
            },
            {
                regex: "1713-A01(?:[);/ ]|$)",
                model: "N6 Lite"
            },
            {
                regex: "1707-A01(?:[);/ ]|$)",
                model: "N6"
            },
            {
                regex: "1801-A01(?:[);/ ]|$)",
                model: "N6 Pro"
            },
            {
                regex: "1509-A00(?:[);/ ]|$)",
                model: "Q5 Plus"
            },
            {
                regex: "1503-A01(?:[);/ ]|$)",
                model: "N4"
            },
            {
                regex: "1603-A03(?:[);/ ]|$)",
                model: "N4A"
            },
            {
                regex: "1607-A01(?:[);/ ]|$)",
                model: "N5S"
            }
        ]
    },
    8848: {
        regex: "8848 (M[3-6])(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Ace: {
        regex: "(?:BUZZ [12]|BUZZ 2|CLEVER 1|URBAN 1(?: Pro)?)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "BUZZ ([12]) Lite",
                model: "Buzz $1 Lite"
            },
            {
                regex: "BUZZ ([12]) Plus",
                model: "Buzz $1 Plus"
            },
            {
                regex: "BUZZ ([12])",
                model: "Buzz $1"
            },
            {
                regex: "CLEVER 1",
                model: "Clever 1"
            },
            {
                regex: "URBAN 1 Pro",
                model: "Urban 1 Pro"
            },
            {
                regex: "URBAN 1",
                model: "Urban 1"
            }
        ]
    },
    "Tunisie Telecom": {
        regex: "StarTrail TT(?:[);/ ]|$)",
        device: "smartphone",
        model: "StarTrail by TT"
    },
    SFR: {
        regex: "StarShine|StarTrail|STARADDICT|StarText|StarNaute|StarXtrem|StarTab",
        device: "smartphone",
        models: [
            {
                regex: "StarXtrem II(?:[);/ ]|$)",
                model: "StarXtrem 2"
            },
            {
                regex: "StarXtrem ?([3-6])(?:[);/ ]|$)",
                model: "StarXtrem $1"
            },
            {
                regex: "StarXtrem(?:[);/ ]|$)",
                model: "StarXtrem"
            },
            {
                regex: "StarTrail III(?:[);/ ]|$)",
                model: "StarTrail 3"
            },
            {
                regex: "StarTrail II(?:[);/ ]|$)",
                model: "StarTrail 2"
            },
            {
                regex: "StarTrail[ _]?([1-9])[ _]([34])G(?:[);/ ]|$)",
                model: "StarTrail $1 $2G"
            },
            {
                regex: "StarTrail[ _]?([1-9])(?:[);/ ]|$)",
                model: "StarTrail $1"
            },
            {
                regex: "StarTrail(?:[);/ ]|$)",
                model: "StarTrail"
            },
            {
                regex: "StarShine II(?:[);/ ]|$)",
                model: "StarShine 2"
            },
            {
                regex: "StarShine(?:[);/ ]|$)",
                model: "StarShine"
            },
            {
                regex: "STARADDICT 4(?:[);/ ]|$)",
                model: "Staraddict 4"
            },
            {
                regex: "STARADDICT III(?:[);/ ]|$)",
                model: "Staraddict 3"
            },
            {
                regex: "STARADDICT II Plus(?:[);/ ]|$)",
                model: "Staraddict 2 Plus"
            },
            {
                regex: "STARADDICT II(?:[);/ ]|$)",
                model: "Staraddict 2"
            },
            {
                regex: "STARADDICT(?:[);/ ]|$)",
                model: "Staraddict"
            },
            {
                regex: "StarText II(?:[);/ ]|$)",
                model: "StarText 2"
            },
            {
                regex: "StarText(?:[);/ ]|$)",
                model: "StarText"
            },
            {
                regex: "StarNaute II(?:[);/ ]|$)",
                model: "StarNaute 2"
            },
            {
                regex: "StarNaute(?:[);/ ]|$)",
                model: "StarNaute"
            },
            {
                regex: "StarTab",
                model: "StarTab",
                device: "tablet"
            },
            {
                regex: "((?:StarShine|StarTrail|STARADDICT|StarText|StarNaute|StarXtrem)[^;/]*) Build",
                model: "$1"
            }
        ]
    },
    HTC: {
        regex: "HTC|Sprint (?:APA|ATP)|ADR(?!910L)[a-z0-9]+|NexusHD2|Amaze[ _]4G(?:[);/ ]|$)|(Desire|Sensation|Evo ?3D|IncredibleS|Wildfire|Butterfly)[ _]?([^;/)]+)(?: Build|\\))|(Amaze[ _]4G|(?<!BLU LIFE )One ?[XELSV\\+]+)(?:[);/ ]|$)|SPV E6[05]0|(One M8|One Mini 2|X525a|PG86100|PC36100|XV6975|PJ83100|2PYB2|2PS64|2PZC5|0PJA10|0PJA2|HTV33|0PM92|0PCV1|601HT|0PAJ5|HTL2[23]|HTV3[12]|2PQ93|X2-HT|EXODUS 1|ISW13HT)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "2PZC5(?:[);/ ]|$)",
                model: "U11"
            },
            {
                regex: "XV6975(?:[);/ ]|$)",
                model: "Imagio"
            },
            {
                regex: "PG86100(?:[);/ ]|$)",
                model: "Evo 3G"
            },
            {
                regex: "PC36100(?:[);/ ]|$)",
                model: "Evo 4G"
            },
            {
                regex: "(?:HTV33|601HT)(?:[);/ ]|$)",
                model: "U11"
            },
            {
                regex: "(?:801e|802[wdt])",
                model: "One"
            },
            {
                regex: "PJ83100(?:[);/ ]|$)",
                model: "One X"
            },
            {
                regex: "One Mini 2(?:[);/ ]|$)",
                model: "One Mini 2"
            },
            {
                regex: "X2-HT(?:[);/ ]|$)",
                model: "One X2"
            },
            {
                regex: "ISW13HT(?:[);/ ]|$)",
                model: "J"
            },
            {
                regex: "HTL22(?:[);/ ]|$)",
                model: "J One"
            },
            {
                regex: "HTL23(?:[);/ ]|$)",
                model: "J Butterfly"
            },
            {
                regex: "(?:0PJA2|0PJA10)(?:[);/ ]|$)",
                model: "One M9"
            },
            {
                regex: "X525a(?:[);/ ]|$)",
                model: "One X+"
            },
            {
                regex: "2PQ93(?:[);/ ]|$)",
                model: "One A9"
            },
            {
                regex: "ADR6300",
                model: "Droid Incredible"
            },
            {
                regex: "ADR6400L",
                model: "ThunderBolt"
            },
            {
                regex: "ADR6410LRA",
                model: "Droid Incredible 3"
            },
            {
                regex: "SPV E600",
                model: "Excalibur"
            },
            {
                regex: "SPV E650",
                model: "Vox"
            },
            {
                regex: "2PYB2",
                model: "Bolt"
            },
            {
                regex: "2PS64",
                model: "10"
            },
            {
                regex: "0PM92(?:[);/ ]|$)",
                model: "Desire 626S"
            },
            {
                regex: "0PCV1(?:[);/ ]|$)",
                model: "Desire 510"
            },
            {
                regex: "608t(?:[);/ ]|$)",
                model: "Desire 608t"
            },
            {
                regex: "EXODUS 1(?:[);/ ]|$)",
                model: "Exodus 1"
            },
            {
                regex: "NexusHD2",
                model: "HD2"
            },
            {
                regex: "HTC[ _\\-]P715a",
                device: "tablet",
                model: "P715a"
            },
            {
                regex: "HTC[ _\\-]Flyer Build",
                device: "tablet",
                model: "Flyer"
            },
            {
                regex: "HTC[ _\\-]Flyer[ _\\-]([\\w]{1,5})",
                device: "tablet",
                model: "Flyer $1"
            },
            {
                regex: "HTC[ _\\-]One[ _\\-]max(?:[);/ ]|$)",
                device: "phablet",
                model: "One max"
            },
            {
                regex: "HTC[ _]([^/;]+) [0-9]+(?:\\.[0-9]+)+ Build",
                model: "$1"
            },
            {
                regex: "HTC[ _]([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "HTC[ _]([a-z0-9]+[ _\\-]?(?:[a-z0-9_+\\-])*)",
                model: "$1"
            },
            {
                regex: "USCCHTC(\\d+)",
                model: "$1"
            },
            {
                regex: "Sprint (ATP.*) Build",
                device: "tablet",
                model: "$1 (Sprint)"
            },
            {
                regex: "Sprint (APA.*) Build",
                model: "$1 (Sprint)"
            },
            {
                regex: "(?:HTC-)?HTC(?:[\\-/ ])?([a-z0-9\\-_]+)",
                model: "$1"
            },
            {
                regex: "HTC;(?: )?([a-z0-9 ]+)",
                model: "$1"
            },
            {
                regex: "(Desire|Sensation|Evo ?3D|IncredibleS|Wildfire|Butterfly)[ _]?([^;/)]+)(?: Build|\\))",
                model: "$1 $2"
            },
            {
                regex: "(Amaze[ _]4G|One ?[XELSV\\+]*) Build",
                model: "$1"
            },
            {
                regex: "(ADR[^;/]+) Build",
                model: "$1"
            },
            {
                regex: "(ADR[a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(One M8)",
                model: "$1"
            },
            {
                regex: "0PAJ5(?:[);/ ]|$)",
                model: "One E8"
            },
            {
                regex: "HTV32(?:[);/ ]|$)",
                model: "10"
            },
            {
                regex: "HTV31(?:[);/ ]|$)",
                model: "J Butterfly"
            }
        ]
    },
    Microsoft: {
        regex: "KIN\\.(One|Two)|RM-(?:1010|1031|106[57]|107[23467]|1089|109[02]|1096|1099|1109|111[348]|1127|1141|115[24]|994)|Microsoft; Lumia|Lumia (?:1530|1320|950|850|650|640|550|535|435)|Corporation/Surface",
        device: "smartphone",
        models: [
            {
                regex: "KIN\\.(One|Two)",
                device: "feature phone",
                model: "Kin $1"
            },
            {
                regex: "RM-1099|Lumia 430",
                model: "Lumia 430"
            },
            {
                regex: "RM-1114|Lumia 435",
                model: "Lumia 435"
            },
            {
                regex: "RM-1031|Lumia 532",
                model: "Lumia 532"
            },
            {
                regex: "Lumia 535 Dual SIM",
                model: "Lumia 535 Dual SIM"
            },
            {
                regex: "RM-109[02]|RM-1089|Lumia 535",
                model: "Lumia 535"
            },
            {
                regex: "RM-1141|Lumia 540",
                model: "Lumia 540"
            },
            {
                regex: "RM-1127|Lumia 550",
                model: "Lumia 550"
            },
            {
                regex: "RM-1010",
                model: "Lumia 638"
            },
            {
                regex: "Lumia 640 XL LTE",
                model: "Lumia 640 XL LTE",
                device: "phablet"
            },
            {
                regex: "RM-106[57]|RM-1096|Lumia 640 XL",
                model: "Lumia 640 XL",
                device: "phablet"
            },
            {
                regex: "Lumia 640 LTE Dual SIM",
                model: "Lumia 640 LTE Dual SIM"
            },
            {
                regex: "Lumia 640 LTE",
                model: "Lumia 640 LTE"
            },
            {
                regex: "Lumia 640 Dual SIM",
                model: "Lumia 640 Dual SIM"
            },
            {
                regex: "RM-1109|RM-1113|RM-107[23467]|Lumia 640",
                model: "Lumia 640"
            },
            {
                regex: "RM-1154|Lumia 650",
                model: "Lumia 650"
            },
            {
                regex: "RM-1152",
                model: "Lumia 650 SS"
            },
            {
                regex: "Lumia 850",
                model: "Lumia 850"
            },
            {
                regex: "Lumia 950 XL Dual SIM",
                model: "Lumia 950 XL Dual SIM",
                device: "phablet"
            },
            {
                regex: "Lumia 950 XL",
                model: "Lumia 950 XL",
                device: "phablet"
            },
            {
                regex: "Lumia 950 Dual SIM",
                model: "Lumia 950 Dual SIM"
            },
            {
                regex: "Lumia 950|RM-1118",
                model: "Lumia 950"
            },
            {
                regex: "RM-994|Lumia 1320",
                model: "Lumia 1320"
            },
            {
                regex: "Lumia 1530",
                model: "Lumia 1530"
            },
            {
                regex: "Surface Book 3",
                device: "desktop",
                model: "Surface Book 3"
            },
            {
                regex: "Surface Pro( [34])?",
                device: "desktop",
                model: "Surface Pro$1"
            },
            {
                regex: "Microsoft; Lumia ([^;/)]+)(?:[;/)]|$)",
                model: "Lumia $1"
            }
        ]
    },
    Nokia: {
        regex: "Nokia(?!Browser|Webview|; GT-I8750)|Lumia|Maemo RX|portalmmm/2\\.0 N7|portalmmm/2\\.0 NK|nok[0-9]+|Symbian.*\\s([a-z0-9]+)$|RX-51 N900|TA-[0-9]{4}|ARM; 909",
        device: "smartphone",
        models: [
            {
                regex: "TA-10(07|23|29|35)",
                model: "2"
            },
            {
                regex: "TA-10(20|28|32|38)",
                model: "3"
            },
            {
                regex: "TA-10(24|27|44|53)",
                model: "5"
            },
            {
                regex: "TA-10(00|03|21|25|33|39|54)",
                model: "6"
            },
            {
                regex: "TA-1041",
                model: "7"
            },
            {
                regex: "TA-10(04|12|52)",
                model: "8"
            },
            {
                regex: "Nokia 8\\.1",
                model: "8.1"
            },
            {
                regex: "Nokia 8 Sirocco",
                model: "8 Sirocco"
            },
            {
                regex: "Nokia 7\\.1",
                model: "7.1"
            },
            {
                regex: "Nokia 7 plus",
                model: "7 plus"
            },
            {
                regex: "Nokia 6\\.1 Plus",
                model: "6.1 Plus"
            },
            {
                regex: "Nokia 6\\.1",
                model: "6.1"
            },
            {
                regex: "Nokia 5\\.1 Plus",
                model: "5.1 Plus"
            },
            {
                regex: "Nokia 5\\.1",
                model: "5.1"
            },
            {
                regex: "Nokia 3\\.1 Plus",
                model: "3.1 Plus"
            },
            {
                regex: "Nokia 3\\.1",
                model: "3.1"
            },
            {
                regex: "Nokia 2\\.1",
                model: "2.1"
            },
            {
                regex: "Nokia 1 Plus",
                model: "1 Plus"
            },
            {
                regex: "Nokia 1",
                model: "1"
            },
            {
                regex: "RX-51 N900",
                model: "N900"
            },
            {
                regex: "(?: )?(Nokia500|nokiaasha500(?:dualsim)?)(?: Build|[_);/])",
                model: "Asha 500"
            },
            {
                regex: "Nokia5130c(?:-2)?",
                model: "5130 XpressMusic"
            },
            {
                regex: "Nokia5230",
                model: "Nuron"
            },
            {
                regex: "Nokia5233",
                model: "5233"
            },
            {
                regex: "Nokia5800d-1",
                model: "5800 XpressMusic"
            },
            {
                regex: "Nokia6210Navigator",
                model: "Navigator"
            },
            {
                regex: "Nokia8800e?",
                model: "Sapphire Arte"
            },
            {
                regex: "NOKIA-RH-17",
                model: "2280"
            },
            {
                regex: "NOKIA-RH-27",
                model: "6225"
            },
            {
                regex: "NOKIA-RH-34",
                model: "6585"
            },
            {
                regex: "NOKIA-RH-48",
                model: "3105"
            },
            {
                regex: "NOKIA-RM-11",
                model: "3205"
            },
            {
                regex: "Nokia808 PureView",
                model: "808 PureView"
            },
            {
                regex: "Nokia ?([0-9]{4})c(?:-)?",
                model: "$1 Classic"
            },
            {
                regex: "Nokia ?([0-9]{4})s(?:-)?",
                model: "$1 Slide"
            },
            {
                regex: "Nokia ?([0-9]{4})",
                model: "$1"
            },
            {
                regex: "(?: )?Nokia([235][0-9]{2})(?: Build|[_);/])",
                model: "Asha $1"
            },
            {
                regex: "Nokia([CEX]-?[0-9]{1,2}i?)-[0-9]{1,2}u?(?: Build|[_);/])",
                model: "$1"
            },
            {
                regex: "Nokia;? 520T",
                model: "Lumia 520T"
            },
            {
                regex: "RM-91[45]",
                model: "Lumia 520"
            },
            {
                regex: "RM-997|Nokia 526",
                model: "Lumia 526"
            },
            {
                regex: "RM-846",
                model: "Lumia 620"
            },
            {
                regex: "RM-97[68]",
                model: "Lumia 630"
            },
            {
                regex: "RM-97[45]",
                model: "Lumia 635"
            },
            {
                regex: "RM-1027",
                model: "Lumia 636"
            },
            {
                regex: "NOKIA;? 710",
                model: "Lumia 710"
            },
            {
                regex: "Nokia;? 720T",
                model: "Lumia 720T"
            },
            {
                regex: "RM-885",
                model: "Lumia 720"
            },
            {
                regex: "Lumia 730",
                model: "Lumia 730"
            },
            {
                regex: "RM-103[89]",
                model: "Lumia 735"
            },
            {
                regex: "Nokia;? 800C",
                model: "Lumia 800C"
            },
            {
                regex: "Nokia;? 800",
                model: "Lumia 800"
            },
            {
                regex: "Nokia 820",
                model: "Lumia 820"
            },
            {
                regex: "RM-984",
                model: "Lumia 830"
            },
            {
                regex: "Nokia;? 900",
                model: "Lumia 900"
            },
            {
                regex: "(RM-82[12]|Nokia;? 920)(?: Build|[_);/])",
                model: "Lumia 920"
            },
            {
                regex: "(RM-89[23]|RM-910|Nokia;? 925)(?: Build|[a_);/])",
                model: "Lumia 925"
            },
            {
                regex: "Lumia 929",
                model: "Lumia Icon"
            },
            {
                regex: "RM-1045",
                model: "Lumia 930"
            },
            {
                regex: "(ARM; 909|NOKIA;? 909|NOKIA; id300)(?: Build|[_);/])",
                model: "Lumia 1020"
            },
            {
                regex: "NOKIA;? 1520\\.1",
                model: "Lumia 1520.1"
            },
            {
                regex: "Nokia ([A-Za-z0-9\\. ]+)(?: Build|\\))",
                model: "$1"
            },
            {
                regex: "Nokia(N[0-9]+)",
                model: "$1"
            },
            {
                regex: "Nokia-([a-z0-9]+)",
                model: "N$1"
            },
            {
                regex: "NOKIA; (?!Qt;)([a-z0-9\\- ]+)",
                model: "$1"
            },
            {
                regex: "NOKIA[ _]?([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "NOKIA/([a-z0-9 ]+)",
                model: "$1"
            },
            {
                regex: "(Lumia [a-z0-9\\-]+ XL)",
                device: "phablet",
                model: "$1"
            },
            {
                regex: "(Lumia [a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "Maemo RX-51 ([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "Maemo RX-34",
                model: "N800"
            },
            {
                regex: "NokiaInternal|Nokia-WAP-Toolkit|Nokia-MIT-Browser|Nokia Mobile|Nokia Browser|Nokia/Series",
                model: ""
            },
            {
                regex: "portalmmm/2\\.0 (N7[37]|NK[a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "nok([0-9]+)",
                model: "$1"
            },
            {
                regex: "Symbian.*\\s([a-z0-9]+)$",
                device: "feature phone",
                model: "$1"
            }
        ]
    },
    CnM: {
        regex: "CnM",
        device: "tablet",
        models: [
            {
                regex: "CnM[ \\-](?:Touchpad|TP)[ \\-]([0-9\\.]+)",
                model: "Touchpad $1"
            }
        ]
    },
    RIM: {
        regex: "BB10;|BlackBerry|rim[0-9]+|PlayBook|STV100-[1234]|STH100-[12]|BBA100-[12]|BBB100-[1234567]|BBD100-[126]|BB[EF]100-[123456789]|BB[CGH]100-1",
        device: "smartphone",
        models: [
            {
                regex: "BBA100-[12]",
                model: "BlackBerry DTEK60"
            },
            {
                regex: "BBB100-[1234567]",
                model: "KEYone"
            },
            {
                regex: "BBC100-1",
                model: "Aurora"
            },
            {
                regex: "BBD100-[126]",
                model: "Motion"
            },
            {
                regex: "BBE100-[123456789]",
                model: "KEY2 LE"
            },
            {
                regex: "BBF100-[1234567]",
                model: "KEY2"
            },
            {
                regex: "BBF100-8",
                model: "KEY2 Silver"
            },
            {
                regex: "BBF100-9",
                model: "KEY2 Black"
            },
            {
                regex: "BBG100-1",
                model: "Evolve"
            },
            {
                regex: "BBH100-1",
                model: "Evolve X"
            },
            {
                regex: "STV100-[1234]",
                model: "BlackBerry Priv"
            },
            {
                regex: "STH100-[12]",
                model: "BlackBerry DTEK50"
            },
            {
                regex: "BB10; ([a-z0-9\\- ]+)\\)",
                model: "BlackBerry $1"
            },
            {
                regex: "PlayBook.+RIM Tablet OS",
                model: "BlackBerry Playbook",
                device: "tablet"
            },
            {
                regex: "BlackBerry(?: )?([a-z0-9]+)",
                model: "BlackBerry $1"
            },
            {
                regex: "rim([0-9]+)",
                model: "BlackBerry $1"
            },
            {
                regex: "9000",
                model: "Bold 9000"
            },
            {
                regex: "9300",
                model: "Curve 3G 9300"
            },
            {
                regex: "(8520|8530|9220|9320|9360)",
                model: "Curve $1"
            },
            {
                regex: "9630",
                model: "Tour 9630"
            },
            {
                regex: "9720",
                model: "9720"
            },
            {
                regex: "(9800|9860)",
                model: "Torch $1"
            },
            {
                regex: "BlackBerry",
                model: "BlackBerry"
            }
        ]
    },
    CHIA: {
        regex: "(SVEGLIO[ _][QH]1|TREO_TAB8G|GTA7WF)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "SVEGLIO[ _]([QH]1)",
                model: "Sveglio $1"
            },
            {
                regex: "TREO_TAB8G",
                device: "tablet",
                model: "TREO TAB8G"
            },
            {
                regex: "GTA7WF",
                device: "tablet",
                model: "GTA7WF"
            }
        ]
    },
    Palm: {
        regex: "(?:Pre|Pixi)/(\\d+)\\.(\\d+)|Palm|Treo|Xiino",
        device: "smartphone",
        models: [
            {
                regex: "((?:Pre|Pixi))/(\\d+\\.\\d+)",
                model: "$1 $2"
            },
            {
                regex: "Palm(?:[ \\-])?((?!OS|Source|scape)[a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "Treo([a-z0-9]+)",
                model: "Treo $1"
            },
            {
                regex: "Tungsten",
                model: "Tungsten"
            },
            {
                regex: "Xiino|Palmscape",
                model: ""
            }
        ]
    },
    HP: {
        regex: "Hewlett-Packard|HP/HP|HP EliteBook 820|TouchPad/\\d+\\.\\d+|hp-tablet|HP ?iPAQ|webOS.*P160U|HP (?:Pro )?Slate|HP [78]|HP 10 Plus|Compaq [7|8]|HP; [^;/)]+",
        device: "smartphone",
        models: [
            {
                regex: "HP Slate 6 Voice Tab",
                model: "Slate 6 VoiceTab",
                device: "phablet"
            },
            {
                regex: "HP 10 Plus",
                model: "10 Plus",
                device: "tablet"
            },
            {
                regex: "HP ([78][^)/;]*)(?: Build|\\))",
                model: "Slate $1",
                device: "tablet"
            },
            {
                regex: "Compaq ([78][^/;]*) Build",
                model: "Compaq $1",
                device: "tablet"
            },
            {
                regex: "HP Pro Slate 8",
                model: "Pro Slate 8",
                device: "tablet"
            },
            {
                regex: "HP Slate ?(.+) Build",
                model: "Slate $1",
                device: "tablet"
            },
            {
                regex: "HP Slate ?([0-9]+)",
                model: "Slate $1",
                device: "tablet"
            },
            {
                regex: "TouchPad/(\\d+\\.\\d+)|hp-tablet",
                model: "TouchPad",
                device: "tablet"
            },
            {
                regex: "HP; ([^;/)]+)",
                model: "$1"
            },
            {
                regex: "HP ?iPAQ ?([a-z0-9]+)",
                model: "iPAQ $1"
            },
            {
                regex: "webOS.*(P160U)",
                model: "Veer"
            },
            {
                regex: "HP ProBook (6560b)",
                device: "desktop",
                model: "ProBook $1"
            },
            {
                regex: "HP EliteBook 820 G2",
                device: "desktop",
                model: "EliteBook 820 G2"
            },
            {
                regex: "Z240 Tower Workstation",
                device: "desktop",
                model: "Z240 Tower Workstation"
            }
        ]
    },
    TiPhone: {
        regex: "TiPhone ?([a-z0-9]+)",
        device: "smartphone",
        model: "$1"
    },
    Apple: {
        regex: "(?:iTunes-)?Apple[ _]?TV|Apple/|(?:Apple-|iTunes-)?(?<!like )(?:iPad|iPhone)|iPh[0-9],[0-9]|CFNetwork|HomePod|Watch ?OS|Watch1,[12]|MDCR_Mac|ICRU_iP(?:ad|hone)",
        models: [
            {
                regex: "HomePod",
                device: "smart speaker",
                model: "HomePod"
            },
            {
                regex: "Watch1,1",
                device: "wearable",
                model: "Watch 38mm"
            },
            {
                regex: "Watch1,2",
                device: "wearable",
                model: "Watch 42mm"
            },
            {
                regex: "Watch2,6",
                device: "wearable",
                model: "Watch Series 1 38mm"
            },
            {
                regex: "Watch2,7",
                device: "wearable",
                model: "Watch Series 1 42mm"
            },
            {
                regex: "Watch2,3",
                device: "wearable",
                model: "Watch Series 2 38mm"
            },
            {
                regex: "Watch2,4",
                device: "wearable",
                model: "Watch Series 2 42mm"
            },
            {
                regex: "Watch3,[13]",
                device: "wearable",
                model: "Watch Series 3 38mm"
            },
            {
                regex: "Watch3,[24]",
                device: "wearable",
                model: "Watch Series 3 42mm"
            },
            {
                regex: "Watch5,(?:9|11)",
                device: "wearable",
                model: "Watch SE 40mm"
            },
            {
                regex: "Watch5,1[02]",
                device: "wearable",
                model: "Watch SE 44mm"
            },
            {
                regex: "Watch([456]),[13]",
                device: "wearable",
                model: "Watch Series $1 40mm"
            },
            {
                regex: "Watch([456]),[24]",
                device: "wearable",
                model: "Watch Series $1 44mm"
            },
            {
                regex: "(?:.+_)?MacBook7(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook 13" (2010)'
            },
            {
                regex: "(?:.+_)?MacPro5(?:%2C|,)1",
                device: "desktop",
                model: "Mac Pro (2010-2012)"
            },
            {
                regex: "(?:.+_)?iMac12(?:%2C|,)1",
                device: "desktop",
                model: 'iMac 21.5" (2011)'
            },
            {
                regex: "(?:.+_)?iMac17(?:%2C|,)1",
                device: "desktop",
                model: 'iMac 27" (2015)'
            },
            {
                regex: "(?:.+_)?iMac19(?:%2C|,)2",
                device: "desktop",
                model: 'iMac 21.5" (2019)'
            },
            {
                regex: "(?:.+_)?iMac19(?:%2C|,)1",
                device: "desktop",
                model: 'iMac 27" (2019)'
            },
            {
                regex: "(?:.+_)?iMac20(?:%2C|,)[12]",
                device: "desktop",
                model: 'iMac 27" (2020)'
            },
            {
                regex: "(?:.+_)?iMac14(?:%2C|,)2",
                device: "desktop",
                model: 'iMac 27" (2013)'
            },
            {
                regex: "(?:.+_)?iMac14(?:%2C|,)4",
                device: "desktop",
                model: 'iMac 21.5" (2014)'
            },
            {
                regex: "(?:.+_)?iMac14(?:%2C|,)1",
                device: "desktop",
                model: 'iMac 21.5" (2013)'
            },
            {
                regex: "(?:.+_)?MacBook6(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook 13" (2009)'
            },
            {
                regex: "(?:.+_)?MacBook8(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook 12" (2015)'
            },
            {
                regex: "(?:.+_)?MacBook9(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook 12" (2016)'
            },
            {
                regex: "(?:.+_)?iMac10(?:%2C|,)1",
                device: "desktop",
                model: "iMac (2009)"
            },
            {
                regex: "(?:.+_)?MacBookAir2(?:%2C|,)1",
                device: "desktop",
                model: "MacBook Air (2009)"
            },
            {
                regex: "(?:.+_)?MacBookAir3(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Air 11" (2010)'
            },
            {
                regex: "(?:.+_)?MacBookAir3(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Air 13" (2010)'
            },
            {
                regex: "(?:.+_)?MacBookAir4(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Air 11" (2011)'
            },
            {
                regex: "(?:.+_)?MacBookAir4(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Air 13" (2011)'
            },
            {
                regex: "(?:.+_)?MacBookAir5(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Air 11" (2012)'
            },
            {
                regex: "(?:.+_)?MacBookAir5(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Air 13" (2012)'
            },
            {
                regex: "(?:.+_)?MacBookAir6(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Air 11" (2013-2014)'
            },
            {
                regex: "(?:.+_)?MacBookAir6(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Air 13" (2013-2014)'
            },
            {
                regex: "(?:.+_)?MacBookAir7(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Air 11" (2015)'
            },
            {
                regex: "(?:.+_)?MacBookAir7(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Air 13" (2015-2017)'
            },
            {
                regex: "(?:.+_)?MacBookAir8(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Air 13" (2018)'
            },
            {
                regex: "(?:.+_)?MacBookAir8(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Air 13" (2019)'
            },
            {
                regex: "(?:.+_)?MacBookAir9(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Air 13" (2020)'
            },
            {
                regex: "(?:.+_)?MacBookAir10(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Air 13" (2020)'
            },
            {
                regex: "(?:.+_)?MacBookPro1(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 15" (2006)'
            },
            {
                regex: "(?:.+_)?MacBookPro1(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Pro 17" (2006)'
            },
            {
                regex: "(?:.+_)?MacBookPro2(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 17" (2007)'
            },
            {
                regex: "(?:.+_)?MacBookPro2(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Pro 15" (2007)'
            },
            {
                regex: "(?:.+_)?MacBookPro[34](?:%2C|,)1",
                device: "desktop",
                model: "MacBook Pro (2008)"
            },
            {
                regex: "(?:.+_)?MacBookPro5(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 15" (2008)'
            },
            {
                regex: "(?:.+_)?MacBookPro5(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Pro 17" (2009)'
            },
            {
                regex: "(?:.+_)?MacBookPro5(?:%2C|,)[34]",
                device: "desktop",
                model: 'MacBook Pro 15" (2009)'
            },
            {
                regex: "(?:.+_)?MacBookPro5(?:%2C|,)5",
                device: "desktop",
                model: 'MacBook Pro 13" (2009)'
            },
            {
                regex: "(?:.+_)?MacBookPro6(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 17" (2010)'
            },
            {
                regex: "(?:.+_)?MacBookPro6(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Pro 15" (2010)'
            },
            {
                regex: "(?:.+_)?MacBookPro7(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 13" (2010)'
            },
            {
                regex: "(?:.+_)?MacBookPro8(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 13" (2011)'
            },
            {
                regex: "(?:.+_)?MacBookPro8(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Pro 15" (2011)'
            },
            {
                regex: "(?:.+_)?MacBookPro8(?:%2C|,)3",
                device: "desktop",
                model: 'MacBook Pro 17" (2011)'
            },
            {
                regex: "(?:.+_)?MacBookPro9(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 15" (2012)'
            },
            {
                regex: "(?:.+_)?MacBookPro9(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Pro 13" (2012)'
            },
            {
                regex: "(?:.+_)?MacBookPro10(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 15" (2012-2013)'
            },
            {
                regex: "(?:.+_)?MacBookPro10(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Pro 13" (2012-2013)'
            },
            {
                regex: "(?:.+_)?MacBookPro11(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 13" (2013-2014)'
            },
            {
                regex: "(?:.+_)?MacBookPro11(?:%2C|,)[23]",
                device: "desktop",
                model: 'MacBook Pro 15" (2013-2014)'
            },
            {
                regex: "(?:.+_)?MacBookPro11(?:%2C|,)[45]",
                device: "desktop",
                model: 'MacBook Pro 15" (2015)'
            },
            {
                regex: "(?:.+_)?MacBookPro12(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 13" (2015)'
            },
            {
                regex: "(?:.+_)?MacBookPro13(?:%2C|,)[12]",
                device: "desktop",
                model: 'MacBook Pro 13" (2016)'
            },
            {
                regex: "(?:.+_)?MacBookPro13(?:%2C|,)3",
                device: "desktop",
                model: 'MacBook Pro 15" (2016)'
            },
            {
                regex: "(?:.+_)?MacBookPro14(?:%2C|,)[12]",
                device: "desktop",
                model: 'MacBook Pro 13" (2017)'
            },
            {
                regex: "(?:.+_)?MacBookPro14(?:%2C|,)3",
                device: "desktop",
                model: 'MacBook Pro 15" (2017)'
            },
            {
                regex: "(?:.+_)?MacBookPro15(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 15" (2018-2019)'
            },
            {
                regex: "(?:.+_)?MacBookPro15(?:%2C|,)2",
                device: "desktop",
                model: 'MacBook Pro 13" (2018-2019)'
            },
            {
                regex: "(?:.+_)?MacBookPro15(?:%2C|,)3",
                device: "desktop",
                model: 'MacBook Pro 15" (2019)'
            },
            {
                regex: "(?:.+_)?MacBookPro15(?:%2C|,)4",
                device: "desktop",
                model: 'MacBook Pro 13" (2019)'
            },
            {
                regex: "(?:.+_)?MacBookPro16(?:%2C|,)[14]",
                device: "desktop",
                model: 'MacBook Pro 16" (2019)'
            },
            {
                regex: "(?:.+_)?MacBookPro16(?:%2C|,)[23]",
                device: "desktop",
                model: 'MacBook Pro 13" (2020)'
            },
            {
                regex: "(?:.+_)?MacBookPro17(?:%2C|,)1",
                device: "desktop",
                model: 'MacBook Pro 13" (2020)'
            },
            {
                regex: "(?:.+_)?Macmini8(?:%2C|,)1",
                device: "desktop",
                model: "Mac Mini (2018)"
            },
            {
                regex: "(?:.+_)?Macmini9(?:%2C|,)1",
                device: "desktop",
                model: "Mac Mini (2020)"
            },
            {
                regex: "(?:.+_)?Macmini7(?:%2C|,)1",
                device: "desktop",
                model: "Mac Mini (2014)"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?1[C,_]1",
                model: "iPhone",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?1[C,_]2",
                model: "iPhone 3G",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?2[C,_]1| 3GS\\)$",
                model: "iPhone 3GS",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?3[C,_][123]",
                model: "iPhone 4",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?4[C,_]1|1C2%254enohPi| 4S\\)$",
                model: "iPhone 4S",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?5[C,_][12]| 5\\)$",
                model: "iPhone 5",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?5[C,_][34]",
                model: "iPhone 5C",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?6[C,_][12]| 5S\\)$",
                model: "iPhone 5S",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?7[C,_]1|1C2%257enohPi| 6PLUS\\)$",
                model: "iPhone 6 Plus",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?7[C,_]2| 6\\)$",
                model: "iPhone 6",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?8[C,_]2| 6SPLUS\\)$",
                model: "iPhone 6s Plus",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?8[C,_]1|iPhone 6s| 6S\\)$",
                model: "iPhone 6s",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?8[C,_]4| SE\\)$",
                model: "iPhone SE",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?9[C,_][13]| 7\\)$",
                model: "iPhone 7",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?9[C,_][24]| 7PLUS\\)$",
                model: "iPhone 7 Plus",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?10[C,_][14]| 8\\)$",
                model: "iPhone 8",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?10[C,_][25]| 8PLUS\\)$",
                model: "iPhone 8 Plus",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?10[C,_][36]|iPhone X| X\\)$",
                model: "iPhone X",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?11[C,_][2]| XS\\)$",
                model: "iPhone XS",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?11[C,_][46]| XSMAX\\)$",
                model: "iPhone XS Max",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?11[C,_][8]| XR\\)$",
                model: "iPhone XR",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?12[C,_][1]| 11\\)$",
                model: "iPhone 11",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?12[C,_][3]| 11PRO\\)$",
                model: "iPhone 11 Pro",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?12[C,_][5]| 11PROMAX\\)$",
                model: "iPhone 11 Pro Max",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?12[C,_][8]",
                model: "iPhone SE (2020)",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?13[C,_][1]",
                model: "iPhone 12 Mini",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?13[C,_][2]",
                model: "iPhone 12",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?13[C,_][3]",
                model: "iPhone 12 Pro",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPh(?:one)?13[C,_][4]",
                model: "iPhone 12 Pro Max",
                device: "phablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad1[C,_]1",
                model: "iPad",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad2[C,_][1234]",
                model: "iPad 2",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad2[C,_][567]",
                model: "iPad Mini",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad3[C,_][123]",
                model: "iPad 3",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad3[C,_][456]",
                model: "iPad 4",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad4[C,_][123]",
                model: "iPad Air",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad4[C,_][456]",
                model: "iPad Mini 2",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad4[C,_][789]",
                model: "iPad Mini 3",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad5[C,_][12]",
                model: "iPad Mini 4",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad5[C,_][34]",
                model: "iPad Air 2",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad6[C,_][34]",
                model: "iPad Pro 9.7",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad6[C,_][78]",
                model: "iPad Pro 12.9",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad6[C,_](?:11|12)",
                model: "iPad 5 9.7",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad7[C,_][12]",
                model: "iPad Pro 2 12.9",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad7[C,_][34]",
                model: "iPad Pro 10.5",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad7[C,_][56]",
                model: "iPad 6 9.7",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad7[C,_](?:11|12)",
                model: "iPad 7 10.2",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad8[C,_](?:9|10)",
                model: 'iPad Pro 2 11"',
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad8[C,_]1[12]",
                model: 'iPad Pro 4 12.9"',
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad8[C,_][1-4]",
                model: "iPad Pro 3 11.0",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad8[C,_][5-8]",
                model: "iPad Pro 3 12.9",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad11[C,_][12]",
                model: "iPad Mini 5",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad11[C,_][34]",
                model: "iPad Air 3",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad11[C,_][67]",
                model: 'iPad 8 10.2"',
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad13[C,_][12]",
                model: "iPad Air 4",
                device: "tablet"
            },
            {
                regex: "Apple-?TV2[C,_]1",
                model: "Apple TV 2",
                device: "tv"
            },
            {
                regex: "Apple-?TV3[C,_][12]",
                model: "Apple TV 3",
                device: "tv"
            },
            {
                regex: "Apple-?TV5[C,_]3",
                model: "Apple TV 4",
                device: "tv"
            },
            {
                regex: "Apple-?TV6[C,_]2",
                model: "Apple TV 4K",
                device: "tv"
            },
            {
                regex: "(?:iTunes-)?Apple[ _]?TV",
                model: "Apple TV",
                device: "tv"
            },
            {
                regex: "HomePod",
                model: "HomePod",
                device: "smart speaker"
            },
            {
                regex: "iTunes-iPad/[0-9]+(?:\\.[0-9]+)* \\(([^;]+);",
                model: "iPad $1",
                device: "tablet"
            },
            {
                regex: "(?:Apple-|.+_)?iPad",
                model: "iPad",
                device: "tablet"
            },
            {
                regex: "iTunes-iPhone/[0-9]+(?:\\.[0-9]+)* \\(([^;]+);",
                model: "iPhone $1",
                device: "smartphone"
            },
            {
                regex: "(?:Apple-)?iPhone ?(3GS?|4S?|5[CS]?|6(:? Plus)?)?",
                model: "iPhone $1",
                device: "smartphone"
            }
        ]
    },
    MicroMax: {
        regex: "(?:MicroMax[ \\-\\_]?[a-z0-9]+|Q327)|4560MMX|P70221|(?:YU(?:5040|5530)|AQ5001(?: Canvas Power)?|N8216|N8301)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "AQ5001 Canvas Power",
                model: "Canvas Power"
            },
            {
                regex: "AQ5001",
                model: "Canvas Juice 2"
            },
            {
                regex: "4560MMX(?:[);/ ]|$)",
                model: "4560MMX"
            },
            {
                regex: "E481",
                model: "Canvas 5"
            },
            {
                regex: "P70221(?:[);/ ]|$)",
                model: "Canvas Tab",
                device: "tablet"
            },
            {
                regex: "Q327",
                model: "Bolt"
            },
            {
                regex: "Q417",
                model: "Canvas Mega"
            },
            {
                regex: "Q402\\+",
                model: "Bolt Pace"
            },
            {
                regex: "YU5040(?:[);/ ]|$)",
                model: "YU Yureka YU5040"
            },
            {
                regex: "YU5530(?:[);/ ]|$)",
                model: "YU Yureka S YU5530"
            },
            {
                regex: "Q424",
                model: "Bolt Selfie"
            },
            {
                regex: "Q426",
                model: "Canvas Mega 2"
            },
            {
                regex: "N8216",
                model: "Infinity N11"
            },
            {
                regex: "N8301",
                model: "Infinity N12"
            },
            {
                regex: "MicroMax(?:[ \\-\\_])?(X291|X246|X252|X458|X312)",
                model: "$1",
                device: "feature phone"
            },
            {
                regex: "MicroMax(?:[ \\-\\_])?(P[a-z0-9]+)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "MicroMax(?:[ \\-\\_])?([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    "3Q": {
        regex: "AC0731B|AC1024C|AC7803C|BC9710AM|EL72B|LC0720C|LC0723B|LC0725B|LC0804B|LC0808B|LC0809B|LC0810C|LC0816C|LC0901D|LC1016C|MT0724B|MT0729[BD]|MT0811B|OC1020A|RC0709B|RC0710B|RC0718C|RC0719H|RC0721B|RC0722C|RC0726B|RC0734H|RC0743H|RC0817C|RC1018C|RC1019G|RC1025F|RC1301C|RC780[24]F|RC9711B|RC9712C|RC9716B|RC9717B|RC9724C|RC9726C|RC9727F|RC9730C|RC9731C|TS0807B|TS1013B|VM0711A|VM1017A|RC0813C|QS9719D|QS9718C|QS9715F|QS1023H|QS0815C|QS0730C|QS0728C|QS0717D|QS0716D|QS0715C|MT7801C|TS9708B|AC0732C|MT0739D|MT0812E|(?:3Q_)?ER71B",
        device: "tablet",
        models: [
            {
                regex: "MT0724B|LC0901D|LC0816C|LC0810C|LC0809B|LC0808B|LC0804B|LC0725B|LC0723B",
                model: "Qoo! P-Pad"
            },
            {
                regex: "VM1017A|TS1013B|TS0807B|RC9731C|RC9730C|RC9727F|RC9726C|RC9724C|RC9717B|RC9716B|RC9712C|RC9711B|RC1301C|RC1025F|RC1019G|RC1018C|RC0817C|RC0813C|RC0743H|RC0734H|RC0726B|RC0722C|RC0721B|RC0719H|RC0718C|RC0710B|RC0709B|QS9715F|QS1023H|QS0815C|QS0730C|QS0728C|QS0717D|QS0716D|QS0715C|MT0811B|MT0739D|MT0729[BD]|LC1016C|LC0720C|BC9710AM|AC1024C|AC0731B",
                model: "Qoo! Q-Pad"
            },
            {
                regex: "MT7801C|QS9718C|QS9719D|VM0711A|OC1020A",
                model: "Qoo! Surf"
            },
            {
                regex: "TS9708B",
                model: "Surf TS1009B"
            },
            {
                regex: "AC7803C|AC0732C",
                model: "Qoo! Lite"
            },
            {
                regex: "MT0812E|RC7802F",
                model: "Qoo! Meta"
            },
            {
                regex: "EL72B|(?:3Q_)?ER71B",
                model: "Qoo! Q-Book"
            },
            {
                regex: "(RC7804F)",
                model: "Qoo! Glaze"
            }
        ]
    },
    "4Good": {
        regex: "4Good[ _]|S450m [43]G|S555m 4G|S501m 3G|T700i_3G|People (?:G503|G410|GT300)|Light (?:A103|B100)",
        device: "smartphone",
        models: [
            {
                regex: "T700i_3G",
                model: "T700i 3G",
                device: "tablet"
            },
            {
                regex: "People GT300",
                model: "People GT300",
                device: "tablet"
            },
            {
                regex: "S555m[_ ]4G",
                model: "People"
            },
            {
                regex: "(S(?:450m|501m)[_ ][43]G|Light (?:A103|B100)|People (?:G503|G410))",
                model: "$1"
            },
            {
                regex: "4Good[ _]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "4Good[ _]([^);/ ]+)",
                model: "$1"
            }
        ]
    },
    Acteck: {
        regex: "BLECK",
        device: "tablet",
        model: "Bleck"
    },
    Alba: {
        regex: "Alba ?(?:57|4|10 TABLET|(?:7|10)(?:Nou|Pie))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Alba 57",
                model: "5.7"
            },
            {
                regex: "Alba (4)",
                model: "$1"
            },
            {
                regex: "10 TABLET",
                device: "tablet",
                model: "10 Tablet"
            },
            {
                regex: "Alba((?:7|10)(?:Nou|Pie))",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    AllCall: {
        regex: "AllCall_|Heat[34]|Rio_X(?:[);/ ]|$)|Hot ?[125][^;/]+ Build",
        device: "smartphone",
        models: [
            {
                regex: "AllCall_(Alpha|Atom|Bro|Madrid)",
                model: "$1"
            },
            {
                regex: "AllCall_S1_X",
                model: "S1 X"
            },
            {
                regex: "AllCall_S1",
                model: "S1"
            },
            {
                regex: "AllCall_RIO_S",
                model: "Rio S"
            },
            {
                regex: "AllCall_RIO_PRO",
                model: "Rio Pro"
            },
            {
                regex: "AllCall_RIO",
                model: "Rio"
            },
            {
                regex: "Heat([34])",
                model: "Heat $1"
            },
            {
                regex: "Rio_X(?:[);/ ]|$)",
                model: "Rio X"
            },
            {
                regex: "Hot ?([125][^;/]+) Build",
                model: "Hot $1"
            }
        ]
    },
    Bravis: {
        regex: "Bravis[ _]|A501 Bright|A552 JOY Max|A504 Trace|A505 JOY Plus|A503 Joy|NB(?:106M|10[1-8]|751|7[145]|8[57]1|76)|NP101|NB961|NP 104 3G|B501|N1-570 Space|Atlas A551|A512 Harmony Pro|A510_Jeans_4G|A509_Jeans|N1_550_Cruiser",
        device: "smartphone",
        models: [
            {
                regex: "A501 BRIGHT",
                model: "A501 Bright"
            },
            {
                regex: "Bravis[_ ]X500",
                model: "Trace Pro"
            },
            {
                regex: "Bravis[_ ]A506",
                model: "Crystal"
            },
            {
                regex: "Bravis[_ ]A553",
                model: "Discovery"
            },
            {
                regex: "BRAVIS[ _]TAU",
                model: "Tau"
            },
            {
                regex: "BRAVIS[ _]DELTA",
                model: "Delta"
            },
            {
                regex: "BRAVIS[ _]TREND",
                model: "Trend"
            },
            {
                regex: "B501",
                model: "Easy"
            },
            {
                regex: "N1-570",
                model: "Space"
            },
            {
                regex: "BRAVIS[ ]A554",
                model: "A554 Grand"
            },
            {
                regex: "BRAVIS[ ]S500",
                model: "S500 Diamond"
            },
            {
                regex: "A505 JOY Plus",
                model: "A505 Joy Plus"
            },
            {
                regex: "A552 JOY Max",
                model: "A552 Joy Max"
            },
            {
                regex: "Atlas A551",
                model: "A551 Atlas"
            },
            {
                regex: "A503 Joy",
                model: "A503 Joy"
            },
            {
                regex: "A504 Trace",
                model: "A504 Trace"
            },
            {
                regex: "A512 Harmony Pro",
                model: "A512 Harmony Pro"
            },
            {
                regex: "A510_Jeans_4G",
                model: "A510 Jeans 4G"
            },
            {
                regex: "A509_Jeans",
                model: "A509 Jeans"
            },
            {
                regex: "BRAVIS NEO",
                model: "A401 Neo"
            },
            {
                regex: "N1_550_Cruiser",
                model: "N1-550 Cruiser"
            },
            {
                regex: "BRAVIS OMEGA",
                model: "Omega"
            },
            {
                regex: "BRAVIS BIZ",
                model: "Biz"
            },
            {
                regex: "BRAVIS POWER",
                model: "Power"
            },
            {
                regex: "BRAVIS[ _]SPARK",
                model: "Spark"
            },
            {
                regex: "BRAVIS[ _]SLIM[ _]3G",
                model: "Slim 3G",
                device: "tablet"
            },
            {
                regex: "NP 104 3G",
                model: "NP104 3G",
                device: "tablet"
            },
            {
                regex: "BRAVIS NP 103",
                model: "NP103",
                device: "tablet"
            },
            {
                regex: "BRAVIS NP 844",
                model: "NP844",
                device: "tablet"
            },
            {
                regex: "Bravis[_ ]([^;\\)]+) Build",
                model: "$1"
            },
            {
                regex: "(NB(?:106M|10[1-8]|751|7[145]|8[57]1|76)|NP101|NB961)",
                model: "$1",
                device: "tablet"
            }
        ]
    },
    Acer: {
        regex: "acer|(?<!Satellite |ZTE BLADE |ImSmart |ERGO |X-Style Tab )a(?:101|110|2[10]0|211|50[10]|51[10]|70[10])(?:[);/ ]|$)|Android.*V3[67]0(?:[);/ ]|$)|Android.*Z1[23456]0 Build|Android.*Z5\\d{2} Build|Android.*T0[234678] Build|Android.*S55(?:[);/ ]|$)|(?:A1-(713(HD)?|7[23]4|830|841|840FHD|81[01])|A3-A[1234][01]|B1-(7[1235-8][01](HD)?|7[23]3|7A0|8[1235]0|A71|860A)|TPA60W|B3-(A[125]0|A3[02]|A40FHD)|E39)(?:[);/ ]|$)|S5[12]0 Build|(DA[0-9]+HQ?L|Aspire (?:V5-121|XC-704G|V5-573G)|Chromebook 14 \\(CB3-431\\)|Predator G9-793|GT-810|B1-870|B3-A4[02]|B3-A50FHD)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "DA220HQL(?:[);/ ]|$)",
                model: "DA220HQL",
                device: "smart display"
            },
            {
                regex: "DA241HL(?:[);/ ]|$)",
                model: "DA241HL",
                device: "smart display"
            },
            {
                regex: "(DA[0-9]+HQ?L)(?:[);/ ]|$)",
                model: "$1",
                device: "smart display"
            },
            {
                regex: "A1-81[01]",
                model: "Iconia A",
                device: "tablet"
            },
            {
                regex: "TPA60W",
                model: "TPA60W",
                device: "tablet"
            },
            {
                regex: "A1-84(1|0FHD)",
                model: "Iconia Tab 8",
                device: "tablet"
            },
            {
                regex: "A1-713(HD)?",
                model: "Iconia Tab 7",
                device: "tablet"
            },
            {
                regex: "A1-830",
                model: "Iconia A1",
                device: "tablet"
            },
            {
                regex: "A1-7[23]4",
                model: "Iconia Talk S",
                device: "tablet"
            },
            {
                regex: "A3-A[12][01]",
                model: "Iconia A3",
                device: "tablet"
            },
            {
                regex: "A3-A[34]0",
                model: "Iconia Tab 10",
                device: "tablet"
            },
            {
                regex: "B1-7(?:[5678]0|30HD|A0)",
                model: "Iconia One 7",
                device: "tablet"
            },
            {
                regex: "B1-7[123][01]|B1-A71",
                model: "Iconia B1",
                device: "tablet"
            },
            {
                regex: "B1-7[23]3",
                model: "Iconia Talk 7",
                device: "tablet"
            },
            {
                regex: "B1-8[123567]0",
                model: "Iconia One 8",
                device: "tablet"
            },
            {
                regex: "B3-A([125]0|3[02]|[45]0FHD|4[02])",
                model: "Iconia One 10",
                device: "tablet"
            },
            {
                regex: "A101",
                model: "Vangogh",
                device: "tablet"
            },
            {
                regex: "A200",
                model: "Picasso E",
                device: "tablet"
            },
            {
                regex: "A50[01]",
                model: "Picasso",
                device: "tablet"
            },
            {
                regex: "Acer One 7",
                model: "One 7",
                device: "tablet"
            },
            {
                regex: "GT-810",
                model: "Predator 8",
                device: "tablet"
            },
            {
                regex: "E39(?:[);/ ]|$)",
                model: "Liquid E700"
            },
            {
                regex: "E310(?:[);/ ]|$)",
                model: "Liquid Mini"
            },
            {
                regex: "E320(?:-orange)?(?:[);/ ]|$)",
                model: "Liquid Express"
            },
            {
                regex: "E310(?:[);/ ]|$)",
                model: "beTouch E210"
            },
            {
                regex: "Android.*V360(?:[);/ ]|$)",
                model: "Liquid E1 Duo"
            },
            {
                regex: "Android.*V370(?:[);/ ]|$)",
                model: "Liquid E2 Duo"
            },
            {
                regex: "S510(?:[);/ ]|$)",
                model: "Liquid S1"
            },
            {
                regex: "S520(?:[);/ ]|$)",
                model: "Liquid S2"
            },
            {
                regex: "(?:Acer_)?P400(?:[);/ ]|$)",
                model: "neoTouch P400"
            },
            {
                regex: "(?:Acer_)?P300(?:[);/ ]|$)",
                model: "neoTouch P300"
            },
            {
                regex: "(?:Acer_)?S200(?:[);/ ]|$)",
                model: "neoTouch S200"
            },
            {
                regex: "(?:Acer_)?E100(?:[);/ ]|$)",
                model: "beTouch E100"
            },
            {
                regex: "Android.*Z1([234])0(?:[);/ ]|$)",
                model: "Liquid Z$1"
            },
            {
                regex: "Android.*Z110(?:[);/ ]|$)",
                model: "Liquid Z110"
            },
            {
                regex: "Android.*Z150(?:[);/ ]|$)",
                model: "Liquid Z5 Duo"
            },
            {
                regex: "Android.*Z160(?:[);/ ]|$)",
                model: "Liquid Z4 Duo"
            },
            {
                regex: "Android.*Z(5\\d{2})(?:[);/ ]|$)",
                model: "Liquid Z$1"
            },
            {
                regex: "Android.*S57(?:[);/ ]|$)",
                model: "Liquid Jade Z"
            },
            {
                regex: "Android.*T02(?:[);/ ]|$)",
                model: "Liquid Z530"
            },
            {
                regex: "Android.*T03(?:[);/ ]|$)",
                model: "Liquid Z630"
            },
            {
                regex: "Android.*T04(?:[);/ ]|$)",
                model: "Liquid Z630S"
            },
            {
                regex: "Android.*T06(?:[);/ ]|$)",
                model: "Liquid Zest"
            },
            {
                regex: "Android.*T07(?:[);/ ]|$)",
                model: "Liquid Zest 4G"
            },
            {
                regex: "Android.*T08(?:[);/ ]|$)",
                model: "Liquid Zest Plus"
            },
            {
                regex: "TM01(?:[);/ ]|$)",
                model: "Liquid M330"
            },
            {
                regex: "M220(?:[);/ ]|$)",
                model: "Liquid M220"
            },
            {
                regex: "AcerTD600",
                model: "TD600"
            },
            {
                regex: "Android.*S55(?:[);/ ]|$)",
                model: "Liquid Jade"
            },
            {
                regex: "(?:Acer )?(Chromebook R1[13])",
                model: "$1",
                device: "desktop"
            },
            {
                regex: "(?:Acer )?(Chromebook 14)",
                model: "$1",
                device: "desktop"
            },
            {
                regex: "(Aspire (?:V5-121|XC-704G|V5-573G|A515-51G))",
                model: "$1",
                device: "desktop"
            },
            {
                regex: "(Predator G9-793|Aspire E5-511)",
                model: "$1",
                device: "desktop"
            },
            {
                regex: "Acer; ?([^;\\(\\)/]+)",
                model: "$1"
            },
            {
                regex: "Acer(?! ?inc)[ _\\-]?([^;\\(\\)/]+)[();/ ]",
                model: "$1"
            },
            {
                regex: "acer[\\-_]([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "a(101|110|2[10]0|211|50[10]|51[10]|70[10])(?:[);/ ]|$)",
                model: "Iconia Tab A$1",
                device: "tablet"
            }
        ]
    },
    Advan: {
        regex: "(?:ADVAN (?:M4|S40)|i7U|S45E|S50H|I7D|i55[KD]|i4U|S7D|S4Z|i5[KE]|S5E[ _]NXT|S5J\\+|S4\\+)(?:[);/ ]|$)|[ ](?:50(?:[46]1|59)|600[24])(?: Build|\\) AppleWebKit)|(?:E1C_3G)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ADVAN M4",
                model: "M4"
            },
            {
                regex: "ADVAN S40",
                model: "S40"
            },
            {
                regex: "i7U",
                model: "I Lite i7U"
            },
            {
                regex: "S5E[ _]NXT",
                model: "S5E NXT"
            },
            {
                regex: "i(55[KD]|5[KE])",
                model: "I$1"
            },
            {
                regex: "i4U",
                model: "I4U"
            },
            {
                regex: " 6004(?: Build|\\) AppleWebKit)",
                model: "G2 Pro"
            },
            {
                regex: " 6002(?: Build|\\) AppleWebKit)",
                model: "G3 Pro"
            },
            {
                regex: "(S45E|50[46]1|5059|S50H|I7D|S7D|S4Z|S5J\\+|S4\\+)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "E1C_3G",
                device: "tablet",
                model: "E1C 3G"
            }
        ]
    },
    Advance: {
        regex: "Hollogram|(?:HL(?:4936|6246|[56]575|5[67]67)|IntroTr3544|Pr(?:61(?:4[56]|50)|60[27]0|5[69]50)|Tr3845)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "IntroTr3544|Tr3845",
                model: "Intro",
                device: "tablet"
            },
            {
                regex: "Pr(61(?:4[56]|50)|60[27]0|5[69]50)",
                model: "Prime PR$1",
                device: "tablet"
            },
            {
                regex: "HL(4936|6246|[56]575|5[67]67)",
                model: "Hollogram HL$1"
            },
            {
                regex: "Hollogram ([^;/)]+)(?: Build|[;)])",
                model: "Hollogram $1"
            }
        ]
    },
    AGM: {
        regex: "AGM ([^/;)]+)(?: Build|[;)])",
        device: "smartphone",
        model: "$1"
    },
    Airness: {
        regex: "AIRNESS-([\\w]+)",
        device: "feature phone",
        model: "$1"
    },
    Aiwa: {
        regex: "(?:AW790|M300|AWM(?:533|50[19]|561)|AW500)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "AW790(?:[);/ ]|$)",
                model: "AW790"
            },
            {
                regex: "AW500(?:[);/ ]|$)",
                model: "AW500"
            },
            {
                regex: "AWM(533|50[19]|561)(?:[);/ ]|$)",
                model: "AWM$1"
            },
            {
                regex: "M300(?:[);/ ]|$)",
                model: "M300",
                device: "phablet"
            }
        ]
    },
    Akai: {
        regex: "AKAI,|Akai[ _-]|Eco[ _]E2|Glory[ _](?:G[1235]|L[123]|O[125])|TAB-[79]8[03]0Q?|X6 METAL|AKTB-703MZ",
        device: "smartphone",
        models: [
            {
                regex: "TAB-([79]8[03]0Q?)",
                device: "tablet",
                model: "TAB $1"
            },
            {
                regex: "AKTB-703MZ",
                device: "tablet",
                model: "AKTB-703MZ"
            },
            {
                regex: "X6 METAL",
                model: "iLike"
            },
            {
                regex: "Glory[ _](G[1235]|L[123]|O[125])",
                model: "Glory $1"
            },
            {
                regex: "Eco[ _]E2",
                model: "Eco E2"
            },
            {
                regex: "Akai[ _-]([^;/)]+)(?: Build|[;)])",
                model: "$1"
            },
            {
                regex: "AKAI,(AK3219NF)",
                device: "tv",
                model: "$1"
            },
            {
                regex: "Si2157LG32",
                device: "tv",
                model: "Si2157LG32"
            }
        ]
    },
    "Arian Space": {
        regex: "Arian Space",
        device: "tablet",
        models: [
            {
                regex: "100 ST1004PG",
                model: "100"
            },
            {
                regex: "80 SS8003PG",
                model: "80"
            },
            {
                regex: "71 ST7002PG",
                model: "71"
            },
            {
                regex: "70 ST7001RW",
                model: "70"
            }
        ]
    },
    Alcatel: {
        regex: "Alcatel|Alc(?!or )[a-z0-9]+|One[ _]?Touch|idol3|TIMXL|(?:(?:4003[AJ]|4009[ADEFIKMSX]|4013[DEJKMX]|4014[ADEKMX]|4015[ADNTX]|4016[ADX]|4017[ADEFSX]|4018[ADEFMX]|4024[EDX]|4027[ADNX]|4028[AEJS]|4032[ADEX]|4034[ADEFGXTL]|4035[ADXY]|4045[ADEX]|4047[ADFGNX]|4049[DEGMX]|4060[SW]|A466BG|A621BL|4114E|4087U|5001[ADJTU]|5002[ADFH]|5003[ADGU]|5006D|5007[AU]|5008[ADUYT]|5009[AD]|5010[DEGSUX]|5011A|5012[DFG]|5015[ADEX]|5016[AXJ]|5017[ABDEOX]|5019D|5022[EDX]|5023[EF]|5024[ADJF]|5025[DEG]|5026[ADJ]|5027B|5028[AYD]|5029[EYD]|5030[DE]|5032W|5033[AEFXDJGMOTXYQS]|5034D|5036D|5038[ADEX]|5039[DY]|5041[CD]|5042[ADEFGWXT]|5044[ADGIKOPSTY]|5045[ADFGIJTXY]|5046[ADGIJSTUY]|5047[DIUY]|5048[AYUI]|5049[EGSWZ]|5050[ASXY]|5051[ADEJMTWX]|5052[ADY]|5053[ADKY]|5054[ADNSTWX]|5056[ADEGIJMNTUWX]|5057M|5058[AIY]|5059[ADJXYZIST]|5060[ADJ]|5061[KU]|5065[ADNWX]|5070D|5080[ADFQUX]|5085[ABCDGHIJNOQY]|5086[ADY]|5090[AIY]|5095[IKY]|5098[OS]|5099[ADYUI]|5116J|5145A|6016[ADEX]|6036[AXY]|6037[BKY]|6039[AHJKY]|6042D|6043[AD]|6044D|6045[BFIKOYX]|6050[AFY]|6055[ABDHIKPUYZ]|6058[ADX]|6060[SX]|6062W|6070K|7040[ADEFKRT]|7041[DX]|7042A|7043[AEKY]|7044[AX]|7045Y|7048[ASWX]|7053D|7055A|7070X|7071[ADX]|8030Y|8050[DEGX]|8063|8088[XQM]|9001[DIX]|9002X|9003[AX]|9024O|9005X|9026X|9007[ATX]|9008[ADIJNTUX]|9009G|9010X|9020A|9022X|9027[FTWX]|9029Z|9203A|A(?:464BG|570BL|50[13]DL|57[17]VL|574BL)|I213|I216X|(?<!\\.)80(?:82|6[78])|A576CC)(?:_(?:EEA|RU))?|P360X)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "4087U",
                model: "1SE Light"
            },
            {
                regex: "5022[EDX]|5070D",
                model: "One Touch Pop Star"
            },
            {
                regex: "6044D",
                model: "One Touch Pop Up"
            },
            {
                regex: "4015[ATX]|4016A",
                model: "One Touch Pop C1"
            },
            {
                regex: "4015[DN]|4016[DX]",
                model: "One Touch Pop C1 Dual SIM"
            },
            {
                regex: "4032[AX]",
                model: "One Touch Pop C2"
            },
            {
                regex: "4032[DE]",
                model: "One Touch Pop C2 Dual SIM"
            },
            {
                regex: "5036D",
                model: "One Touch Pop C5 Dual SIM"
            },
            {
                regex: "7040[AFK]|7041X|7042A",
                model: "One Touch Pop C7"
            },
            {
                regex: "7040[DE]|7041D",
                model: "One Touch Pop C7 Dual SIM"
            },
            {
                regex: "4018[ADEFMX]",
                model: "One Touch Pop D1"
            },
            {
                regex: "4035[ADXY]",
                model: "One Touch Pop D3"
            },
            {
                regex: "5038[ADEX]",
                model: "One Touch Pop D5"
            },
            {
                regex: "4045[AX]",
                model: 'One Touch Pop 2 4"'
            },
            {
                regex: "4045[DE]",
                model: 'One Touch Pop 2 4" Dual SIM'
            },
            {
                regex: "5042[AFGWX]",
                model: 'One Touch Pop 2 4.5"'
            },
            {
                regex: "5042[DE]",
                model: 'One Touch Pop 2 4.5" Dual SIM'
            },
            {
                regex: "7043[AY]|7044[AX]",
                model: 'One Touch Pop 2 5"'
            },
            {
                regex: "7043[EK]",
                model: 'One Touch Pop 2 5" Dual SIM'
            },
            {
                regex: "50[16]5X",
                model: "One Touch Pop 3"
            },
            {
                regex: "5015[AE]|5016[AJ]|5065[ADWX]|5116J",
                model: 'One Touch Pop 3 5"'
            },
            {
                regex: "5025[DEG]|5054[ADSTX]",
                model: 'One Touch Pop 3 5.5"'
            },
            {
                regex: "5015D",
                model: "One Touch Pop 3 Dual SIM"
            },
            {
                regex: "5051[AEJMTWX]",
                model: "One Touch Pop 4"
            },
            {
                regex: "5051D",
                model: "One Touch Pop 4 Dual SIM"
            },
            {
                regex: "5095[IKY]",
                model: "One Touch Pop 4S"
            },
            {
                regex: "5056[ADEGJMTUX]",
                model: "One Touch Pop 4+"
            },
            {
                regex: "7070X",
                model: 'One Touch Pop 4 6"'
            },
            {
                regex: "5057M",
                model: "One Touch Pop Mirage"
            },
            {
                regex: "5050[ASXY]",
                model: "One Touch Pop S3"
            },
            {
                regex: "7045Y",
                model: "One Touch Pop S7"
            },
            {
                regex: "6037[BKY]",
                model: "One Touch Idol 2"
            },
            {
                regex: "5042T",
                model: "One Touch Astro"
            },
            {
                regex: "5027B",
                model: "One Touch Dawn"
            },
            {
                regex: "5024[ADF]|5028Y",
                model: "1S"
            },
            {
                regex: "7071[ADX]",
                model: "A7 XL"
            },
            {
                regex: "5002[ADH]",
                model: "1B (2020)"
            },
            {
                regex: "4034T",
                model: "1E"
            },
            {
                regex: "5002F",
                model: "1A (2020)"
            },
            {
                regex: "5034D",
                model: "3L"
            },
            {
                regex: "A576CC",
                model: "Kora A576CC"
            },
            {
                regex: "7040[RT]",
                model: "One Touch Fierce 2"
            },
            {
                regex: "5056[NW]",
                model: "One Touch Fierce 4"
            },
            {
                regex: "5054N",
                model: "One Touch Fierce XL"
            },
            {
                regex: "6042D",
                model: "One Touch Flash"
            },
            {
                regex: "6016[AX]",
                model: "One Touch Idol 2 mini"
            },
            {
                regex: "6016[DE]",
                model: "One Touch Idol 2 mini Dual SIM"
            },
            {
                regex: "6036[AXY]",
                model: "One Touch Idol 2 mini S"
            },
            {
                regex: "6050[AFY]",
                model: "One Touch Idol 2S"
            },
            {
                regex: "6039[AHJKY]|idol3",
                model: "One Touch Idol 3"
            },
            {
                regex: "6045[BFIKOYX]",
                model: 'One Touch Idol 3 5.5"'
            },
            {
                regex: "6055[ABDHIKPUYZ]",
                model: "One Touch Idol 4"
            },
            {
                regex: "6070K",
                model: "One Touch Idol 4S"
            },
            {
                regex: "6058[ADX]",
                model: "One Touch Idol 5"
            },
            {
                regex: "6060[SX]",
                model: "One Touch Idol 5S"
            },
            {
                regex: "6043[AD]",
                model: "One Touch Idol X+"
            },
            {
                regex: "8030Y",
                model: "One Touch Hero 2"
            },
            {
                regex: "7055A",
                model: "One Touch Hero 2C"
            },
            {
                regex: "7053D",
                model: "One Touch X1"
            },
            {
                regex: "5065N",
                model: "TRU"
            },
            {
                regex: "A574BL",
                model: "Raven"
            },
            {
                regex: "A577VL",
                model: "Zip"
            },
            {
                regex: "A466BG",
                model: "Pixi Unite"
            },
            {
                regex: "5056I",
                model: "One Touch Optus X Smart"
            },
            {
                regex: "A570BL",
                model: "One Touch Pixi Avion LTE"
            },
            {
                regex: "A571VL",
                model: "One Touch Pixi Avion 4G LTE"
            },
            {
                regex: "4024[DEX]",
                model: "One Touch Pixi First"
            },
            {
                regex: "A464BG",
                model: "One Touch Pixi Glitz"
            },
            {
                regex: "A621BL",
                model: "One Touch Pixi Glory"
            },
            {
                regex: "4014D",
                model: "One Touch Pixi 2"
            },
            {
                regex: "4009[AFIKMSX]",
                model: 'One Touch Pixi 3 3.5"'
            },
            {
                regex: "4009[DE]",
                model: 'One Touch Pixi 3 3.5" Dual SIM'
            },
            {
                regex: "4003[AJ]|4013[DEJKMX]|4014[AEKMX]|4114E",
                model: 'One Touch Pixi 3 4"'
            },
            {
                regex: "4027[ADNX]|4028[AEJS]|5019D",
                model: 'One Touch Pixi 3 4.5"'
            },
            {
                regex: "5017[ABDEOX]",
                model: 'One Touch Pixi 3 4.5" 4G'
            },
            {
                regex: "9002X",
                model: 'One Touch Pixi 3 7"',
                device: "phablet"
            },
            {
                regex: "9007A",
                model: 'One Touch Pixi 3 7"',
                device: "tablet"
            },
            {
                regex: "9007[TX]",
                model: 'One Touch Pixi 3 7" 4G',
                device: "tablet"
            },
            {
                regex: "9009G",
                model: "1T",
                device: "tablet"
            },
            {
                regex: "(?!<\\.)8082(?:_(?:EEA|RU))?(?:[);/ ]|$)",
                model: "1T 10",
                device: "tablet"
            },
            {
                regex: "(?!<\\.)806[78](?:_(?:EEA|RU))?(?:[);/ ]|$)",
                model: "1T 7",
                device: "tablet"
            },
            {
                regex: "9022X",
                model: 'One Touch Pixi 3 8"',
                device: "phablet"
            },
            {
                regex: "9010X",
                model: 'One Touch Pixi 3 10"',
                device: "tablet"
            },
            {
                regex: "4017[ADEFSX]",
                model: 'One Touch Pixi 4 3.5"'
            },
            {
                regex: "4034[ADEFGXL]",
                model: 'One Touch Pixi 4 4"'
            },
            {
                regex: "4060[SW]",
                model: 'One Touch Pixi 4 4.5"'
            },
            {
                regex: "5023[EF]",
                model: "One Touch Pixi 4 Plus Power"
            },
            {
                regex: "5010[DEGSUX]",
                model: 'One Touch Pixi 4 5" 3G'
            },
            {
                regex: "5041D",
                model: 'One Touch Pixi 4 5.0"'
            },
            {
                regex: "5012[DFG]",
                model: 'One Touch Pixi 4 5.5" 3G'
            },
            {
                regex: "5045[ADFGIJTXY]|5145A",
                model: 'One Touch Pixi 4 5" 4G'
            },
            {
                regex: "5098O",
                model: "One Touch Pixi Theatre"
            },
            {
                regex: "A501DL",
                model: "A1"
            },
            {
                regex: "A503DL",
                model: "A1X"
            },
            {
                regex: "5046[ADIJTUY]",
                model: "A3"
            },
            {
                regex: "5011A|5049[EG]",
                model: "A3 Plus"
            },
            {
                regex: "9008[ADIJNTUX]",
                model: "A3 XL"
            },
            {
                regex: "9203A",
                model: 'A3 7" 3G',
                device: "tablet"
            },
            {
                regex: "9027[FTWX]",
                model: '3T 8.0"',
                device: "tablet"
            },
            {
                regex: "9026X",
                model: 'A3 10"',
                device: "tablet"
            },
            {
                regex: "5085[BQ]",
                model: "A5"
            },
            {
                regex: "5085[ADHIJY]",
                model: "A5 LED"
            },
            {
                regex: "5085N",
                model: "A5 Max LED"
            },
            {
                regex: "5090[AIY]",
                model: "A7"
            },
            {
                regex: "5046[GS]",
                model: "A30"
            },
            {
                regex: "5049S",
                model: "A30 Plus"
            },
            {
                regex: "5049Z",
                model: "A30 Fierce"
            },
            {
                regex: "5085[GO]",
                model: "A50"
            },
            {
                regex: "5048[AYUI]",
                model: "3X (2019)"
            },
            {
                regex: "5049W",
                model: "Revvl"
            },
            {
                regex: "8050[GX]",
                model: 'One Touch Pixi 4 6" 3G'
            },
            {
                regex: "8050[ED]",
                model: 'One Touch Pixi 4 6" 3G Dual SIM'
            },
            {
                regex: "5098S|9001[DIX]",
                model: 'One Touch Pixi 4 6" 4G'
            },
            {
                regex: "9003[AX]",
                model: 'One Touch Pixi 4 7" 3G',
                device: "tablet"
            },
            {
                regex: "8063",
                model: 'One Touch Pixi 4 7" WiFi',
                device: "tablet"
            },
            {
                regex: "9024O",
                model: "One Touch Pixi 5",
                device: "tablet"
            },
            {
                regex: "I216X",
                model: "One Touch Pixi 7",
                device: "tablet"
            },
            {
                regex: "I213",
                model: "One Touch Pixi 7",
                device: "tablet"
            },
            {
                regex: "9005X",
                model: "One Touch Pixi 8",
                device: "tablet"
            },
            {
                regex: "P320X",
                model: "One Touch POP 8",
                device: "tablet"
            },
            {
                regex: "P310X",
                model: "One Touch POP 7",
                device: "tablet"
            },
            {
                regex: "9020A",
                model: "One Touch Trek HD",
                device: "tablet"
            },
            {
                regex: "7048[ASWX]",
                model: "One Touch Go Play"
            },
            {
                regex: "(?:Alcatel-)?OT-802",
                model: "Wave"
            },
            {
                regex: "ALCATEL_ONE_TOUCH_768T",
                model: "Island"
            },
            {
                regex: "(?:TRIBE_)?3075A",
                model: "One Touch Tribe"
            },
            {
                regex: "ALCATEL_one_touch_585",
                model: "One Touch 585"
            },
            {
                regex: "ALCATEL_ONE_TOUCH_838",
                model: "One Touch 838"
            },
            {
                regex: "ALCATEL_one_touch_813d",
                model: "One Touch 813D"
            },
            {
                regex: "ALCATEL_one_touch_813",
                model: "One Touch 813"
            },
            {
                regex: "OT871A",
                model: "One Touch 871A"
            },
            {
                regex: "P360X",
                model: "One Touch Pop 10"
            },
            {
                regex: "(?:Alcatel[ _])?One[ _]?Touch[ _]((?:T[0-9]+|TAB[^/;]+|EVO[78](?:HD)?)) Build",
                device: "tablet",
                model: "One Touch $1"
            },
            {
                regex: "(?:Alcatel[ _])?One[ _]?Touch([^/;]*) Build",
                model: "One Touch$1"
            },
            {
                regex: "(?:Alcatel[ _])?One[ _]?Touch([^/;\\)]*)\\)",
                model: "One Touch$1"
            },
            {
                regex: "5080[ADFQUX]",
                model: "Shine Lite"
            },
            {
                regex: "TIMXL",
                model: "TIM XL"
            },
            {
                regex: "5085C",
                model: "PulseMix"
            },
            {
                regex: "4049[DEGMX]",
                model: "U3"
            },
            {
                regex: "5044[ADIKOPTY]",
                model: "U5"
            },
            {
                regex: "4047[DFXN]",
                model: "U5 3G"
            },
            {
                regex: "5047[DIUY]",
                model: "U5 HD"
            },
            {
                regex: "4047G",
                model: "U5 Lite"
            },
            {
                regex: "4047A",
                model: "U5 Plus"
            },
            {
                regex: "4044[CV]",
                model: "Quick Flip"
            },
            {
                regex: "4044O",
                model: "Cingular Flip 2"
            },
            {
                regex: "(?:Alcatel)?4044[MNT]",
                model: "Go Flip"
            },
            {
                regex: "5044[GS]",
                model: "U50"
            },
            {
                regex: "5033[ADXJEFGMOTXYQS]",
                model: "1"
            },
            {
                regex: "5009[AD]",
                model: "1C"
            },
            {
                regex: "5008[ADUYT]",
                model: "1X (2019)"
            },
            {
                regex: "5007[AU]",
                model: "1V (2020)"
            },
            {
                regex: "5003[ADGU]",
                model: "1C (2019)"
            },
            {
                regex: "5006D",
                model: "3C (2019)"
            },
            {
                regex: "5024J",
                model: "1S"
            },
            {
                regex: "5028[AD]",
                model: "1S (2020)"
            },
            {
                regex: "5030[DE]",
                model: "1SE (2020)"
            },
            {
                regex: "5001[ADJTU]",
                model: "1V"
            },
            {
                regex: "5059[ADJXYZIT]",
                model: "1X"
            },
            {
                regex: "5059S",
                model: "Avalon V"
            },
            {
                regex: "5060[ADJ]",
                model: "5V",
                device: "phablet"
            },
            {
                regex: "5052[ADY]|5053[ADKY]",
                model: "3"
            },
            {
                regex: "5029E",
                model: "3 (2020)"
            },
            {
                regex: "5029[DY]",
                model: "3L (2020)"
            },
            {
                regex: "5032W|5099[ADYUI]",
                model: "3V"
            },
            {
                regex: "5026[ADJ]",
                model: "3C"
            },
            {
                regex: "5039[DY]",
                model: "3L",
                device: "phablet"
            },
            {
                regex: "5058[AIY]",
                model: "3X"
            },
            {
                regex: "5061[KU]",
                model: "3X (2020)"
            },
            {
                regex: "5086[ADY]",
                model: "5"
            },
            {
                regex: "6062W",
                model: "7"
            },
            {
                regex: "8088[XQM]",
                model: "3T 10",
                device: "tablet"
            },
            {
                regex: "9029Z",
                model: "Joy Tab",
                device: "tablet"
            },
            {
                regex: "9029Z",
                model: "Joy Tab",
                device: "tablet"
            },
            {
                regex: "Alcatel UP",
                model: ""
            },
            {
                regex: "(?:ALCATEL_)?A383G",
                model: "Big Easy Plus"
            },
            {
                regex: "5041C",
                model: "TETRA"
            },
            {
                regex: "ALCATEL([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "ALCATEL[ \\-]?([^/;\\)]+)",
                model: "$1"
            },
            {
                regex: "ALCATEL_([^/;\\)]+)",
                model: "$1"
            },
            {
                regex: "Alc([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Allview: {
        regex: "Allview|A4You|H1003_LTE_PRO|A5_(?:Easy(?:_TM)?|Ready(?:_TM)?|Quad|Quad_Plus_TM)|A[5-9]_Lite|A5Smiley|A6_Duo|A10_Lite_2019|A10_(?:Plus|Max)|AX2_Frenzy|AX4Nano|AX5NanoQ|C6_Duo|E[23]_Living|E3_(?:Jump|Sign)|E4_Lite|M9_Connect|P(?:43_Easy|[5689]_Energy|6_Energy_Lite|[68]_Energy_Mini(?:_TM)?|(41|[458])_eMagic(?:_TM)?|[589](?:_)?Life(?:_TM)?|[567]_Lite(?:_TM)?|6_plus|[45678]_Pro|7_Seon|10_Life|10_Max|10_Style|7_Xtreme|6_Qmax|4_Quad)|V(?:[134]_Viper|1_Viper_I|2_Viper_(?:E|I|S|X|X_plus|Xe))|X4_Soul_Vision|X(?:[1-46]_Soul_Xtreme|[1-5]_Soul|3_Soul_Lite|[2-6]_Soul_Mini(?:_TM)?|4_Soul_Mini_S(?:_TM)?|[2-5]_Soul_Style(?:_TM)?|2_Soul_Style_Plus|2_Twin)|Viva_(?:H801|100[13]G|(?:H100[12]|H701|H802)_LTE|C701|i701G)",
        device: "smartphone",
        models: [
            {
                regex: "A4You",
                model: "A4 You"
            },
            {
                regex: "AX2_Frenzy",
                model: "AX2 Frenzy",
                device: "tablet"
            },
            {
                regex: "AX4Nano",
                model: "AX4 Nano"
            },
            {
                regex: "AX5NanoQ",
                model: "AX5 Nano Q",
                device: "tablet"
            },
            {
                regex: "C6_Duo",
                model: "C6 Duo"
            },
            {
                regex: "E([23])_Living",
                model: "E$1 Living"
            },
            {
                regex: "E3_Jump",
                model: "E3 Jump"
            },
            {
                regex: "E3_Sign",
                model: "E3 Sign"
            },
            {
                regex: "E4_Lite",
                model: "E4 Lite"
            },
            {
                regex: "M9_Connect",
                model: "M9 Connect"
            },
            {
                regex: "P43_Easy",
                model: "P43 Easy"
            },
            {
                regex: "P(41|[458])_eMagic(?:_TM)?",
                model: "P$1 eMagic"
            },
            {
                regex: "P([567])_Lite(?:_TM)?",
                model: "P$1 Lite"
            },
            {
                regex: "P6_plus",
                model: "P6 Plus"
            },
            {
                regex: "P6_Qmax",
                model: "P6 Qmax"
            },
            {
                regex: "P([45678])_Pro",
                model: "P$1 Pro"
            },
            {
                regex: "P4_Quad",
                model: "P4 Quad"
            },
            {
                regex: "P9_Energy_Lite_2017",
                model: "P9 Energy Lite (2017)"
            },
            {
                regex: "P9_Energy_S",
                model: "P9 Energy S"
            },
            {
                regex: "P([69])_Energy_Lite",
                model: "P$1 Energy Lite"
            },
            {
                regex: "P8_Energy_PRO",
                model: "P8 Energy Pro"
            },
            {
                regex: "P([689])_Energy_mini(?:_TM)?",
                model: "P$1 Energy Mini"
            },
            {
                regex: "P([5689])_Energy",
                model: "P$1 Energy"
            },
            {
                regex: "P7_Seon",
                model: "P7 Seon"
            },
            {
                regex: "P7_Xtreme",
                model: "P7 Xtreme"
            },
            {
                regex: "P([589])(?:_)?Life(?:_TM)?",
                model: "P$1 Life"
            },
            {
                regex: "P10_Life",
                model: "P10 Life"
            },
            {
                regex: "P10_Max",
                model: "P10 Max"
            },
            {
                regex: "P10_Style",
                model: "P10 Style"
            },
            {
                regex: "V([12])_Viper_I4G(?:_TM)?",
                model: "V$1 Viper I 4G"
            },
            {
                regex: "V1_Viper_I",
                model: "V1 Viper I"
            },
            {
                regex: "V([134])_Viper",
                model: "V$1 Viper"
            },
            {
                regex: "V2_Viper_X_plus",
                model: "V2 Viper X Plus"
            },
            {
                regex: "V2_Viper_(E|I|S|X(?:e)?)",
                model: "V2 Viper $1"
            },
            {
                regex: "X4_Soul_Vision",
                model: "X4 Soul Vision"
            },
            {
                regex: "X([1246])_Soul_Xtreme",
                model: "X$1 Soul Xtreme"
            },
            {
                regex: "X4_Soul_Infinity_(L|N|S|Z)",
                model: "X4 Soul Infinity $1"
            },
            {
                regex: "X([34])_Soul_Lite",
                model: "X$1 Soul Lite"
            },
            {
                regex: "X4_Soul_Mini_S(?:_TM)?",
                model: "X4 Soul Mini S"
            },
            {
                regex: "X([23456])_Soul_Mini(?:_TM)?",
                model: "X$1 Soul Mini"
            },
            {
                regex: "X3_Soul_PLUS",
                model: "X3 Soul Plus"
            },
            {
                regex: "X([35])_Soul_Pro",
                model: "X$1 Soul Pro"
            },
            {
                regex: "X2_Soul_Style_Plus",
                model: "X2 Soul Style Plus"
            },
            {
                regex: "X([2345])_Soul_Style(?:_TM)?",
                model: "X$1 Soul Style"
            },
            {
                regex: "X([12345])_Soul",
                model: "X$1 Soul"
            },
            {
                regex: "X2_Twin",
                model: "X2 Twin"
            },
            {
                regex: "A5_Easy(?:_TM)?",
                model: "A5 Easy"
            },
            {
                regex: "A([56789])_Lite",
                model: "A$1 Lite"
            },
            {
                regex: "A5_Ready(?:_TM)?",
                model: "A5 Ready"
            },
            {
                regex: "A5Smiley",
                model: "A5 Smiley"
            },
            {
                regex: "A5_Quad_Plus_TM",
                model: "A5 Quad Plus"
            },
            {
                regex: "A5_Quad",
                model: "A5 Quad"
            },
            {
                regex: "A6_Duo",
                model: "A6 Duo"
            },
            {
                regex: "A10_Lite_2019",
                model: "A10 Lite (2019)"
            },
            {
                regex: "A10_Plus",
                model: "A10 Plus"
            },
            {
                regex: "A10_Max",
                model: "A10 Max"
            },
            {
                regex: "Impera S",
                model: "Impera S"
            },
            {
                regex: "ALLVIEW P4i",
                model: "AllDro P4"
            },
            {
                regex: "Allview_P2",
                model: "AllDro"
            },
            {
                regex: "AllviewCityPlus",
                device: "tablet",
                model: "City Plus"
            },
            {
                regex: "AllviewCity",
                device: "tablet",
                model: "City"
            },
            {
                regex: "AllviewAX2Frenzy",
                device: "tablet",
                model: "AX2 Frenzy"
            },
            {
                regex: "Allview2SpeedDuo",
                device: "tablet",
                model: "Alldro 2 Speed Duo"
            },
            {
                regex: "Allview3SpeedQuad",
                device: "tablet",
                model: "Alldro 3 Speed Quad"
            },
            {
                regex: "H1003_LTE_PRO",
                device: "tablet",
                model: "Viva H1003 LTE Pro"
            },
            {
                regex: "Viva_(H801|100[13]G|(?:H802|H100[12]|H701)_LTE|C701|i701G)",
                device: "tablet",
                model: "Viva $1"
            },
            {
                regex: "ALLVIEW ?SPEEDI",
                device: "tablet",
                model: "Speed I"
            },
            {
                regex: "ALLVIEW ?SPEED",
                device: "tablet",
                model: "Speed"
            },
            {
                regex: "ALLVIEWSPEED",
                device: "tablet",
                model: "Speed"
            },
            {
                regex: "AX4Nano",
                device: "tablet",
                model: "AX4 Nano"
            },
            {
                regex: "ALLVIEW_TX1_Quasar",
                device: "tablet",
                model: "TX1 Quasar"
            },
            {
                regex: "Allview[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Allview[ _-]([^;/]+)(?:[;/)]|$)",
                model: "$1"
            }
        ]
    },
    Allwinner: {
        regex: "(?:QUAD-CORE (?:A64 p3|A33 y3|T3 K2001M)|ZY-07B|UltraOcta-T8|OCTA-CORE T8)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "QUAD-CORE A64 p3",
                model: "A64 QUAD-CORE p3"
            },
            {
                regex: "QUAD-CORE A33 y3",
                model: "A33 QUAD-CORE y3"
            },
            {
                regex: "ZY-07B",
                model: "ZY-07B"
            },
            {
                regex: "UltraOcta-T8",
                device: "car browser",
                model: "Ultra Octa T8"
            },
            {
                regex: "QUAD-CORE T3 K2001M",
                device: "car browser",
                model: "QUAD-CORE T3 K2001M"
            },
            {
                regex: "OCTA-CORE T8",
                device: "car browser",
                model: "OCTA-CORE T8"
            }
        ]
    },
    altron: {
        regex: "(AL-555|GI-626|OB[_-](?:421|728|627))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "AL-555",
                model: "AL-555"
            },
            {
                regex: "OB[_-](421|728|627)",
                model: "OB-$1"
            },
            {
                regex: "GI-626",
                device: "phablet",
                model: "GI-626"
            }
        ]
    },
    AMGOO: {
        regex: "AM(350|355|40[257]|41[025]|450|50[89]|52[037]|51[58]|53[05])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "AM350",
                model: "Jack Pro"
            },
            {
                regex: "AM(355|407)",
                model: "Tigo"
            },
            {
                regex: "AM402",
                model: "Pronto"
            },
            {
                regex: "AM410",
                model: "Unico"
            },
            {
                regex: "AM450",
                model: "Swift"
            },
            {
                regex: "AM508",
                model: "Fuego"
            },
            {
                regex: "AM509",
                model: "Uno"
            },
            {
                regex: "AM515",
                model: "D1"
            },
            {
                regex: "AM518",
                model: "C1"
            },
            {
                regex: "AM520",
                model: "Pro"
            },
            {
                regex: "AM523",
                model: "Plus"
            },
            {
                regex: "AM527",
                model: "Geo"
            },
            {
                regex: "AM530",
                model: "A1"
            },
            {
                regex: "AM535",
                model: "P1"
            },
            {
                regex: "AM([0-9]{3})",
                model: "AM$1"
            }
        ]
    },
    Amoi: {
        regex: "Amoi|(?:A862W|Clever[ -]?(?:Gem S52|Gleam S45|Pad P7|Wave S50|Touch S46|JOY S40|Lite S41))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Clever Pad P7",
                model: "Clever Pad P7"
            },
            {
                regex: "A862W",
                model: "A862W"
            },
            {
                regex: "CLEVER JOY S40",
                model: "Clever Joy S40"
            },
            {
                regex: "Clever[ -]?(Gleam S45|Gem S52|Wave S50|Touch S46|Lite S41)",
                model: "Clever $1"
            },
            {
                regex: "Amoi[\\- /]([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "Amoisonic-([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Ainol: {
        regex: "Numy|novo[0-9]|Novo 10 Hero|AX10PRO|NUMY3GAX9|NOVO10 Spark|Aurora-II",
        device: "tablet",
        models: [
            {
                regex: "Numy 3G AX1",
                model: "Novo 7 Numy AX1 3G"
            },
            {
                regex: "Numy[_ ]?3G[_ ]?Sword",
                model: "Numy 3G Sword"
            },
            {
                regex: "NOVO10 Spark",
                model: "Novo 10 Spark"
            },
            {
                regex: "AX10PRO",
                model: "Numy AX10 Pro"
            },
            {
                regex: "Numy_3G_AX3",
                model: "Numy AX3 Sword"
            },
            {
                regex: "Numy3GTalos",
                model: "Numy 3G Talos"
            },
            {
                regex: "Numy_3G_BW1",
                model: "Numy 3G Talos 2"
            },
            {
                regex: "NUMY3GAX9(?:[);/ ]|$)",
                model: "Numy 3G AX9"
            },
            {
                regex: "Numy3G_AX10(?:[);/ ]|$)",
                model: "Numy 3G AX10"
            },
            {
                regex: "(Novo 10 Hero QuadCore)",
                model: "$1"
            },
            {
                regex: "Aurora-II",
                model: "Novo 7 Aurora II"
            },
            {
                regex: "Novo7 Flame(?:[);/ ]|$)",
                model: "Novo 7 Flame"
            },
            {
                regex: "NOVO7(?:[);/ ]|$)",
                model: "Novo 7"
            },
            {
                regex: "Numy[ _]([^;/]+) Build",
                model: "Numy $1"
            },
            {
                regex: "Novo([0-9]+)[ \\-]([^;/]+) Build",
                model: "Novo $1 $2"
            }
        ]
    },
    Archos: {
        regex: "(?:YL-)?Archos|(?:A50TI|AC101BHE)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Archos (Oxygen (?:63|57|68XL))(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "A50TI(?:[);/ ]|$)",
                model: "50 Titanium 4G"
            },
            {
                regex: "Archos ?5(?:[);/ ]|$)",
                device: "tablet",
                model: "5"
            },
            {
                regex: "AC101BHE(?:[);/ ]|$)",
                device: "tablet",
                model: "101B Helium 4G"
            },
            {
                regex: "(?:YL-)?Archos ([^/;]*(?:PAD)[^/;]*) Build",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "Archos ((?:[789]|10)[0-9]?[a-z]* ?(?:G9|G10|Helium|Titanium|Cobalt|Platinum|Xenon|Carbon|Neon|XS|IT)[^/;]*) Build",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "(?:YL-)?Archos ([a-z0-9 ]+) Build",
                model: "$1"
            },
            {
                regex: "(?:YL-)?Archos ([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Axxion: {
        regex: "Axxion ATAB-[0-9]+(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "Axxion ATAB-([0-9]+)(?:[);/ ]|$)",
                model: "ATAB-$1"
            }
        ]
    },
    MEU: {
        regex: "MEU ([a-z0-9]+) Build",
        device: "smartphone",
        model: "$1"
    },
    Arnova: {
        regex: "arnova|ARCHM901|AN7CG2|AN7G2(DTE|I)?|AN7[BCDFH]?G3|A80KSC|AN8G2|AN8[BC]?G3|AN9G2I?|AN9G3|A101[BC]|AN10G2|AN10BG2(DT|I)?|AN10BG3(DT)?|AN10[CD]G3",
        device: "tablet",
        models: [
            {
                regex: "ARCHM901",
                model: "M901"
            },
            {
                regex: "AN7CG2",
                model: "7c G2"
            },
            {
                regex: "AN7G2I|AN7G2|AN7G2DTE",
                model: "7 G2"
            },
            {
                regex: "AN7G3",
                model: "7 G3"
            },
            {
                regex: "AN7BG3",
                model: "7b G3"
            },
            {
                regex: "AN7CG3",
                model: "7c G3"
            },
            {
                regex: "AN7DG3-CP",
                model: "Childpad"
            },
            {
                regex: "AN7DG3",
                model: "7d G3"
            },
            {
                regex: "AN7FG3",
                model: "7f G3"
            },
            {
                regex: "AN7HG3",
                model: "7h G3"
            },
            {
                regex: "A80KSC",
                model: "8"
            },
            {
                regex: "AN8G2",
                model: "8 G2"
            },
            {
                regex: "AN8G3",
                model: "8 G3"
            },
            {
                regex: "AN8BG3",
                model: "8b G3"
            },
            {
                regex: "AN8CG3",
                model: "8c G3"
            },
            {
                regex: "AN9G2I",
                model: "9i G2"
            },
            {
                regex: "AN9G2",
                model: "9 G2"
            },
            {
                regex: "AN9G3",
                model: "9 G3"
            },
            {
                regex: "A101B2|A101C|AN10G2",
                model: "10 G2"
            },
            {
                regex: "A101B",
                model: "10"
            },
            {
                regex: "AN10BG2|AN10BG2DT|AN10BG2I",
                model: "10b G2"
            },
            {
                regex: "AN10BG3|AN10BG3DT|AN10BG3-LZ",
                model: "10b G3"
            },
            {
                regex: "AN10CG3",
                model: "10c G3"
            },
            {
                regex: "AN10DG3",
                model: "10d G3"
            },
            {
                regex: "ARNOVA 90G3",
                model: "90 G3"
            },
            {
                regex: "ARNOVA 90 G4",
                model: "90 G4"
            },
            {
                regex: "ARNOVA 97G4",
                model: "97 G4"
            },
            {
                regex: "ARNOVA 101 G4",
                model: "101 G4"
            },
            {
                regex: "Arnova ([^/;]*) Build",
                model: "$1"
            }
        ]
    },
    ARRIS: {
        regex: "ARRIS",
        device: "tv",
        models: [
            {
                regex: "ARRIS[,;] ([^),;/]+)",
                model: "$1"
            }
        ]
    },
    Ask: {
        regex: "ASK[ _]",
        device: "smartphone",
        models: [
            {
                regex: "ASK[ _]791SP[ _]3G",
                model: "791SP 3G",
                device: "tablet"
            },
            {
                regex: "ASK[_ ]([^/;]*) Build",
                model: "$1"
            }
        ]
    },
    ANS: {
        regex: "UL40 Build",
        device: "smartphone",
        model: "UL40"
    },
    AOC: {
        regex: "AOC,",
        device: "tv",
        models: [
            {
                regex: "(LE(?:32|43)S5970(?:s)?-20|LE55U7970-30|LE43S5977-20|U60856)",
                model: "$1"
            }
        ]
    },
    Assistant: {
        regex: "(AS[-_](?:50[123]|543[1-6]|44[12]1|541[12]|54[23]1|6431|[46]01L)|AP-(?:109|115G|721N|753G|7[25]7G|10[68]|107G|110N|941|719))[;/)_ ]",
        device: "smartphone",
        models: [
            {
                regex: "AS[-_]401L(?:[);/ ]|$)",
                model: "Asper"
            },
            {
                regex: "AS-5432(?:[);/ ]|$)",
                model: "Agio"
            },
            {
                regex: "AS[-_](?:5434|501)(?:[);/ ]|$)",
                model: "Club"
            },
            {
                regex: "AS_601L(?:[);/ ]|$)",
                model: "AS-601L"
            },
            {
                regex: "AS-5433 Secret(?:[);/ ]|$)",
                model: "Secret"
            },
            {
                regex: "AS-5433(?:[);/ ]|$)",
                model: "Max Secret"
            },
            {
                regex: "AS-5421(?:[);/ ]|$)",
                model: "Surf"
            },
            {
                regex: "AS-44[12]1(?:[);/ ]|$)",
                model: "Unami"
            },
            {
                regex: "AS-5431(?:[);/ ]|$)",
                model: "Prima"
            },
            {
                regex: "AS-502(?:[);/ ]|$)",
                model: "Shot"
            },
            {
                regex: "AS-503(?:[);/ ]|$)",
                model: "Target"
            },
            {
                regex: "AS-5435(?:[);/ ]|$)",
                model: "Shine"
            },
            {
                regex: "AS-5436[ _]",
                model: "Grid"
            },
            {
                regex: "AS-6431(?:[);/ ]|$)",
                model: "Rider"
            },
            {
                regex: "AS-5411[_ ]",
                model: "Max Ritm"
            },
            {
                regex: "AS-5412 Max(?:[);/ ]|$)",
                model: "AS-5412 Max"
            },
            {
                regex: "AP-721N(?:[);/ ]|$)",
                model: "AP-721N Force",
                device: "tablet"
            },
            {
                regex: "AP-941(?:[);/ ]|$)",
                model: "AP-941",
                device: "tablet"
            },
            {
                regex: "AP-108(?:[);/ ]|$)",
                model: "Cetus",
                device: "tablet"
            },
            {
                regex: "AP-106(?:[);/ ]|$)",
                model: "AP-106 Force",
                device: "tablet"
            },
            {
                regex: "(AP-(?:109|115G|7[25]7G|753G|107G|110N|719))(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    Ark: {
        regex: "(ARK[_ -])?Benefit[_ -]([^/;]*)(?: Build|\\))|EDGE A5HD|Elf_S8|ICON (R40\\+|R45)|Impulse[ _](P[12])|Wizard_[12](?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:ARK[_ -])?Benefit[_ -]([^/;]*)(?: Build|\\))",
                model: "Benefit $1"
            },
            {
                regex: "Impulse[ _]P1\\+",
                model: "Impulse P1 Plus"
            },
            {
                regex: "Impulse[ _](P[12])",
                model: "Impulse $1"
            },
            {
                regex: "EDGE (A5HD)",
                model: "Edge $1"
            },
            {
                regex: "ICON (R40\\+|R45)",
                model: "Icon $1"
            },
            {
                regex: "Wizard_([12])",
                model: "Wizard $1"
            },
            {
                regex: "Elf_S8(?:[);/ ]|$)",
                model: "Elf S8"
            }
        ]
    },
    "Garmin-Asus": {
        regex: "Garmin-Asus|Garminfone",
        device: "smartphone",
        models: [
            {
                regex: "Garminfone[ \\-_]([^;/]*)Build",
                model: "Garminfone $1"
            },
            {
                regex: "Garmin-Asus[ \\-_]([^;/]+)Build",
                model: "$1"
            },
            {
                regex: "Garmin-Asus[ \\-_]([^;/]+)[\\)/]",
                model: "$1"
            }
        ]
    },
    Asus: {
        regex: "Asus|Transformer|ZenFone Max|TF300T|Slider SL101|PadFone|ME302(?:C|KL)|ME301T|ME371MG|ME17(?:1|2V|3X)|(?:K0[01][0-9a-z]|P(?:00[18ACIL]|01[MTVWYZ]|01MA|01T_1|02[13478])(?: Build|\\))|X015D|X018D|X003|X00[7ABT]D|Z00D|Z00[MTY]D|Z01[7FGHKMR]D)(?:[);/ ]|$)|G55[023]KL|ZB(631|602|633|55[135]|50[01])KL|ZC(55[134]|520|600)KL|ZA550KL|ZE(5[02]0|620|55[2345])KL|ZD55[23]KL|ZS6(?:61|7[01])KS|ZS(6[0236]0|55[10])KL|ZB(500KG|601KL)|MeMo Pad FHD 10 LTE|Z00[SV]D",
        device: "smartphone",
        models: [
            {
                regex: "ME171(?:[);/ ]|$)",
                model: "Eee Pad MeMO 171",
                device: "tablet"
            },
            {
                regex: "ASUS Z906(?:[);/ ]|$)",
                model: 'Z906 10.1"',
                device: "tablet"
            },
            {
                regex: "ME172V",
                model: "MeMO Pad",
                device: "tablet"
            },
            {
                regex: "ME302C(?:[);/ ]|$)",
                model: "MeMO Pad FHD 10",
                device: "tablet"
            },
            {
                regex: "(ME302KL|MeMo Pad FHD 10 LTE)(?:[);/ ]|$)",
                model: "MeMO Pad FHD 10 LTE",
                device: "tablet"
            },
            {
                regex: "ME301T(?:[);/ ]|$)",
                model: "MeMO Pad Smart 10",
                device: "tablet"
            },
            {
                regex: "Z101(?:[);/ ]|$)",
                model: "Z101",
                device: "tablet"
            },
            {
                regex: "X Pad 10 LTE(?:[);/ ]|$)",
                model: "X Pad 10 LTE",
                device: "tablet"
            },
            {
                regex: "(?:K01[3A]|K007|K00R)(?:[);/ ]|$)|MeMO Pad 7",
                model: "MeMO Pad 7",
                device: "tablet"
            },
            {
                regex: "K01E(?:[);/ ]|$)",
                model: "MeMO Pad 10 ME103K",
                device: "tablet"
            },
            {
                regex: "K00U|ME173X(?:[);/ ]|$)",
                model: "MeMO Pad HD 7",
                device: "tablet"
            },
            {
                regex: "(?:K011|K00L)(?:[);/ ]|$)",
                model: "MeMO Pad 8",
                device: "tablet"
            },
            {
                regex: "K014(?:[);/ ]|$)",
                model: "MeMO Pad 8.9",
                device: "tablet"
            },
            {
                regex: "K00S(?:[);/ ]|$)",
                model: "MeMO Pad HD 7 Dual SIM",
                device: "tablet"
            },
            {
                regex: "K00F(?:[);/ ]|$)",
                model: "MeMO Pad 10",
                device: "tablet"
            },
            {
                regex: "K00C(?:[);/ ]|$)",
                model: "Transformer Pad TF701T",
                device: "tablet"
            },
            {
                regex: "K010(?:[);/ ]|$)",
                model: "Transformer Pad TF103C",
                device: "tablet"
            },
            {
                regex: "K018(?:[);/ ]|$)",
                model: "Transformer Pad TF103CG",
                device: "tablet"
            },
            {
                regex: "TF300T(?:[);/ ]|$)",
                model: "Transformer Pad TF300T",
                device: "tablet"
            },
            {
                regex: "K01B(?:[);/ ]|$)",
                model: "Transformer Pad TF303K",
                device: "tablet"
            },
            {
                regex: "Slider SL101",
                model: "Eee Pad Slider SL101",
                device: "tablet"
            },
            {
                regex: "P01[YZ]",
                model: "ZenPad C 7.0",
                device: "tablet"
            },
            {
                regex: "P008 Build",
                model: "ZenPad Z8",
                device: "tablet"
            },
            {
                regex: "P001",
                model: "ZenPad Z10",
                device: "tablet"
            },
            {
                regex: "(?:ASUS_)?P00J",
                model: "ZenPad Z8s",
                device: "tablet"
            },
            {
                regex: "P01[VW]",
                model: "ZenPad 7.0",
                device: "tablet"
            },
            {
                regex: "(?:P024|P00A)(?:[);/ ]|$)",
                model: "ZenPad 8.0",
                device: "tablet"
            },
            {
                regex: "P01MA(?: Build|\\))|P01M(?: Build|\\))",
                model: "ZenPad S 8.0",
                device: "tablet"
            },
            {
                regex: "P027",
                model: "ZenPad 3S 10",
                device: "tablet"
            },
            {
                regex: "(?:ASUS_)?P00I",
                model: "ZenPad 3S 10 LTE",
                device: "tablet"
            },
            {
                regex: "(?:ASUS_)?P00C|P02[138]|P00L|P01T_1",
                model: "ZenPad 10",
                device: "tablet"
            },
            {
                regex: "ASUS Tablet P1801-T",
                model: 'Transformer AiO P1801 18.4"',
                device: "tablet"
            },
            {
                regex: "ASUS TAB A8",
                model: "TAB A8",
                device: "tablet"
            },
            {
                regex: "ME371MG(?:[);/ ]|$)",
                model: "Fonepad",
                device: "phablet"
            },
            {
                regex: "K00G(?:[);/ ]|$)",
                model: "Fonepad Note 6",
                device: "phablet"
            },
            {
                regex: "(?:K012|K00E)(?:[);/ ]|$)",
                model: "Fonepad 7",
                device: "phablet"
            },
            {
                regex: "K00Z(?:[);/ ]|$)",
                model: "Fonepad 7 Dual SIM",
                device: "phablet"
            },
            {
                regex: "K016(?:[);/ ]|$)",
                model: "Fonepad 8",
                device: "phablet"
            },
            {
                regex: "(?:ASUS_)?T00N",
                model: "PadFone S"
            },
            {
                regex: "(?:ASUS_)?T00[CE]",
                model: "PadFone Mini"
            },
            {
                regex: "(?:ASUS[-_])?T00T",
                model: "PadFone X Mini"
            },
            {
                regex: "PadFone T008",
                model: "PadFone E"
            },
            {
                regex: "PadFone T004",
                model: "PadFone Infinity"
            },
            {
                regex: "(?:ASUS_)?A002(A)?",
                model: "ZenFone AR"
            },
            {
                regex: "(?:ASUS_)?A006",
                model: "ZenFone V"
            },
            {
                regex: "(?:ASUS_)?A009",
                model: "ZenFone V Live"
            },
            {
                regex: "(?:ASUS_)?Z007",
                model: "ZenFone C"
            },
            {
                regex: "(?:ASUS_)?(X00P[SD]|ZB555KL)",
                model: "ZenFone Max M1"
            },
            {
                regex: "(?:ASUS_)?(?:ZB60[12]KL)|ZenFone Max Pro M1",
                model: "ZenFone Max Pro M1"
            },
            {
                regex: "(?:ASUS_)?(X01([AB]D)|ZB633KL)(?:[);/ ]|$)",
                model: "ZenFone Max M2"
            },
            {
                regex: "(?:ASUS_)?(?:Z00[AD]|Z008D|Z008|Z00AD[AB]?|ZE551ML)",
                model: "ZenFone 2"
            },
            {
                regex: "(?:ASUS_)?(?:ZenFone 2E)",
                model: "ZenFone 2E"
            },
            {
                regex: "(?:ASUS_)?(?:A007|Z00YD|ZA550KL|ZB553KL|ZB501KL)(?:[);/ ]|$)",
                model: "ZenFone Live"
            },
            {
                regex: "(?:ASUS_)?(?:X00RD|G552KL)",
                model: "ZenFone Live L1"
            },
            {
                regex: "G553KL",
                model: "ZenFone Lite L1"
            },
            {
                regex: "(?:ASUS_)?(?:Z00[ERLMTW]D|Z011D|ZE500KL)",
                model: "ZenFone 2 Laser"
            },
            {
                regex: "(?:ASUS_)?(?:T00[IQ1]|Z01KD)",
                model: "ZenFone 4"
            },
            {
                regex: "(?:ASUS_)?(?:T00[JF]|X00QD|X00QSA|ZE620KL)",
                model: "ZenFone 5"
            },
            {
                regex: "(?:ASUS_)?T00P",
                model: "ZenFone 5 LTE"
            },
            {
                regex: "(?:ASUS_)?(?:T00K|X017DA|X017D|ZC600KL)",
                model: "ZenFone 5 Lite"
            },
            {
                regex: "(?:ASUS_)?(?:Z01RD|ZS620KL)",
                model: "ZenFone 5Z"
            },
            {
                regex: "(?:ASUS_)?(?:T00G|Z002|ZS630KL|I01WD[X]?)",
                model: "ZenFone 6"
            },
            {
                regex: "(?:ASUS_)?ZS671KS",
                model: "ZenFone 7 Pro"
            },
            {
                regex: "(?:ASUS_)?(?:ZS670KS|I002D)(?:[);/ ]|$)",
                model: "ZenFone 7"
            },
            {
                regex: "(?:ASUS_)?Z010D",
                model: "ZenFone Max"
            },
            {
                regex: "(?:ASUS_)?X018D",
                model: "ZenFone Max Plus M1"
            },
            {
                regex: "(?:ASUS_)?X00TD?",
                model: "ZenFone Max Pro M1"
            },
            {
                regex: "(?:ASUS_)?(?:X01BDA|ZB631KL|Zenfone Max Pro M2)",
                model: "ZenFone Max Pro M2"
            },
            {
                regex: "(?:ASUS_)?X014D",
                model: "ZenFone Go Plus"
            },
            {
                regex: "(?:ASUS_)?(L001|X00[7AB]D|X009[DB][DA]|X009D|Z00[SV]D|ZB500K[LG]|ZB551KL)",
                model: "ZenFone Go"
            },
            {
                regex: "(?:ASUS_)?X013D",
                model: "ZenFone Go Life"
            },
            {
                regex: "(?:ASUS_)?G550KL",
                model: "ZenFone Go TV"
            },
            {
                regex: "(?:ASUS_)?Z00[SV]D",
                model: "ZenFone Go"
            },
            {
                regex: "(?:ASUS_)?(X00[23])",
                model: "ZenFone Pegasus"
            },
            {
                regex: "(?:ASUS_)?X005",
                model: "ZenFone Pegasus 5000"
            },
            {
                regex: "(?:ASUS_)?X550",
                model: "ZenFone Pegasus 2 Plus"
            },
            {
                regex: "(?:ASUS_)?(X00GD)",
                model: "ZenFone Pegasus 3S Max"
            },
            {
                regex: "(?:ASUS_)?(?:X00D[DS]|X008D)|ZC553KL",
                model: "ZenFone 3 Max"
            },
            {
                regex: "(?:ASUS_)?(X008)",
                model: "ZenFone 3 Pegasus"
            },
            {
                regex: "(?:ASUS_)?(ZE553KL|Z01HD)",
                model: "ZenFone 3 Zoom"
            },
            {
                regex: "(?:ASUS_)?ZS550KL",
                model: "ZenFone 3 Deluxe"
            },
            {
                regex: "(?:ASUS_)?Z00UD",
                model: "ZenFone Selfie"
            },
            {
                regex: "(?:ASUS_)?(Z016[DS]|Z01FD)",
                model: "ZenFone 3 Deluxe"
            },
            {
                regex: "(?:ASUS_)?(Z017DA|ZE520KL|ZE552KL|Z017D|Z012(D|S))",
                model: "ZenFone 3"
            },
            {
                regex: "(?:ASUS_)?Z01B[DS]|ZC551KL",
                model: "ZenFone 3 Laser"
            },
            {
                regex: "(?:ASUS_)?A001",
                model: "ZenFone 3 Ultra"
            },
            {
                regex: "(?:ASUS_)?(?:ZD552KL|Z01MDA?)(?:[);/ ]|$)",
                model: "ZenFone 4 Selfie Pro"
            },
            {
                regex: "(?:ASUS_)?(?:X00LDA|ZD553KL)",
                model: "ZenFone 4 Selfie"
            },
            {
                regex: "(?:ASUS_)?(?:X00LD|Z01KS|Z01KDA|ZE554KL)",
                model: "ZenFone 4"
            },
            {
                regex: "(?:ASUS_)?X00(?:[HIK]D|IS)|ZC554KL|ZC520KL",
                model: "ZenFone 4 Max"
            },
            {
                regex: "(?:ASUS_)?X015D",
                model: "ZenFone 4 Max Plus"
            },
            {
                regex: "(?:ASUS_)?(:?Z01G[DS]|ZS551KL)",
                model: "ZenFone 4 Pro"
            },
            {
                regex: "(?:ASUS_)?Z00XS",
                model: "ZenFone Zoom"
            },
            {
                regex: "(?:ASUS_)?(?:Z01QD|ZS600KL)",
                model: "ROG Phone"
            },
            {
                regex: "(?:ASUS_)?(?:I001D[ABCE]?|ZS660KL)",
                model: "ROG Phone 2"
            },
            {
                regex: "(?:ASUS_)?(?:I003DD?|ZS661KS)",
                model: "ROG Phone 3"
            },
            {
                regex: "(?:ASUS_)?(?:I005DA)",
                model: "ROG Phone 5"
            },
            {
                regex: "ZN220IC",
                device: "desktop",
                model: "Zen AiO ZN220IC"
            },
            {
                regex: "(?:ASUS_)?ZenWatch( 2)?",
                device: "wearable",
                model: "ZenWatch$1"
            },
            {
                regex: "Asus(?:-|;)?([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(PadFone(?: [^;/]+)?) Build",
                model: "$1"
            },
            {
                regex: "(PadFone(?: [a-z0-9]+)?)",
                model: "$1"
            },
            {
                regex: "(?:Asus|Transformer) ((?:Pad |Prime )?TF[0-9a-z]+)",
                device: "tablet",
                model: "Transformer $1"
            },
            {
                regex: "Chromebook Flip (C10[01]PA|C302)",
                device: "desktop",
                model: "Chromebook Flip $1"
            }
        ]
    },
    Audiovox: {
        regex: "Audiovox|CDM|UTS(?:TARCOM)?\\-|audio(?!book)[a-z0-9\\-]+",
        device: "smartphone",
        models: [
            {
                regex: "Audiovox[_\\-]([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "CDM(?:-)?([a-z0-9]+)",
                model: "CDM-$1"
            },
            {
                regex: "UTS(?:TARCOM)?-([a-z0-9\\-]+)",
                model: "CDM-$1"
            },
            {
                regex: "audio([a-z0-9\\-]+)",
                model: "CDM-$1"
            }
        ]
    },
    AVH: {
        regex: "Excer[ _]",
        device: "tablet",
        models: [
            {
                regex: "Excer[ _]G5.3",
                model: "Excer G5.3"
            },
            {
                regex: "Excer[ _]G5",
                model: "Excer G5"
            },
            {
                regex: "Excer[ _]10[ _]PRO",
                model: "Excer 10 Pro"
            },
            {
                regex: "Excer[ _]8",
                model: "Excer 8"
            }
        ]
    },
    Avvio: {
        regex: "Avvio[ _]?([a-z0-9\\-]+)|(?:CHIVAS_55|Colombia_2018|Mint_M353)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "CHIVAS_55",
                model: "Chivas 55"
            },
            {
                regex: "Mint_M353",
                model: "Mint M353"
            },
            {
                regex: "Colombia_2018",
                model: "Colombia (2018)"
            },
            {
                regex: "Avvio[ _]PAD",
                model: "PAD",
                device: "tablet"
            },
            {
                regex: "Avvio[ _]?([a-z0-9\\-]+)",
                model: "$1"
            }
        ]
    },
    "Azumi Mobile": {
        regex: "Azumi[_ -]|(?:SPEED55|A50_Style_Plus)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Azumi[_ -]([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "Azumi[_ -]([a-z0-9_]+)",
                model: "$1"
            },
            {
                regex: "SPEED55",
                model: 'Speed 5.5"'
            },
            {
                regex: "A50_Style_Plus",
                model: "A50 Style Plus"
            }
        ]
    },
    "Barnes & Noble": {
        regex: "Nook|BN[TR]V[0-9]+",
        device: "tablet",
        models: [
            {
                regex: "Nook([a-z0-9]+)",
                model: "Nook $1"
            },
            {
                regex: "Nook[ _]([^/;]+)[ _]Build",
                model: "Nook $1"
            },
            {
                regex: "(BN[TR]V[0-9]+)",
                model: "Nook $1"
            }
        ]
    },
    BGH: {
        regex: "(?!Positivo )BGH ([^/;\\)]+)(?: Build|\\))",
        device: "smartphone",
        models: [
            {
                regex: "Y([17]00|2[01]0|1010)",
                device: "tablet",
                model: "Y$1"
            },
            {
                regex: "BGH (\\+Simple|Mini)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "Y710 KIDS",
                device: "tablet",
                model: "Y710 Kids"
            },
            {
                regex: "JOY X2",
                model: "Joy X2"
            },
            {
                regex: "BGH ([^/;\\)]+)(?: Build|\\))",
                model: "$1"
            }
        ]
    },
    Bitel: {
        regex: "Bitel[ _-]([^/;]+) Build|(?:B(?:840[5-9]|841[0456]|850[2346]|860[146]|9401|950[1-5])|S8402L?|S8501L?)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(B(?:840[5789]|841[0456]|850[2346]|860[146]|9401|950[12345])|S8402L?|S8501L?)",
                model: "$1"
            },
            {
                regex: "Bitel[ _-]([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    Blu: {
        regex: "BLU[ _]|(?:blu|Dash)[ _]([^/;)]+)(?: Build|[;)])|(?:Studio[ _](5.0K|5.5|View XL|Mega|C 8\\+8|[CGM][ _]HD|[CGX]|SELFIE|Selfie LTE|Touch|M5 Plus|J[1258]|X8 HD)|Advance (4.0 ?[LM]|5.[02](?: HD)?|A4|L[45])|ENERGY (DIAMOND|XL)|Energy X 2|LIFE XL|B110DL|Dash (?:X[2L]|L3)|PURE (?:X[LR]|MINI)|Life One X2|G90(?: PRO)?|Grand M3|GRAND (?:5.5 HD|XL LTE)|R1 (?:HD|PLUS)|Tank Xtreme [45].0|Tank Xtreme Pro|Touchbook M7 Pro|DASH X PLUS|C[456] 2019|BOLD N1|B130DL|Vivo 5 Mini)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Advance (4.0 ?[LM]|4.0|5.[02](?: HD)?|A4|L[54])",
                model: "Advance $1"
            },
            {
                regex: "(?:BLU[_ ])?Studio[ _](5.0 C|5.5|View XL|Mega|C 8\\+8|[CG][ _]HD|C|G|Touch|M HD|M5 Plus|J[1258]|X8 HD|X5|XL|X)(?:[);/ ]|$)",
                model: "Studio $1"
            },
            {
                regex: "(?:BLU[_ ])?Studio[ _]5.0 ?K(?:[);/ ]|$)",
                model: "Studio 5.0 K"
            },
            {
                regex: "STUDIO SELFIE LTE",
                model: "Studio Selfie LTE"
            },
            {
                regex: "STUDIO ONE",
                model: "Studio One"
            },
            {
                regex: "STUDIO SELFIE ([23]|LTE)",
                model: "Studio Selfie $1"
            },
            {
                regex: "STUDIO SELFIE",
                model: "Studio Selfie"
            },
            {
                regex: "(?:BLU[_ ])?NEO_ENERGY_MINI",
                model: "Neo Energy Mini"
            },
            {
                regex: "ENERGY DIAMOND",
                model: "Energy Diamond"
            },
            {
                regex: "ENERGY XL",
                model: "Energy XL"
            },
            {
                regex: "Energy X 2",
                model: "Energy X 2"
            },
            {
                regex: "ENERGY X PLUS 2",
                model: "Energy X Plus 2"
            },
            {
                regex: "ENERGY X PLUS",
                model: "Energy X Plus"
            },
            {
                regex: "LIFE XL",
                model: "Life XL"
            },
            {
                regex: "DASH[ _]X[ _]PLUS[ _]LTE",
                model: "Dash X Plus LTE"
            },
            {
                regex: "DASH X PLUS",
                model: "Dash X Plus"
            },
            {
                regex: "DASH 4.5",
                model: "Dash 4.5"
            },
            {
                regex: "Dash XL",
                model: "Dash XL"
            },
            {
                regex: "PURE (X[LR])",
                model: "Pure $1"
            },
            {
                regex: "PURE MINI",
                model: "Pure Mini"
            },
            {
                regex: "BOLD N1",
                model: "Bold N1"
            },
            {
                regex: "Life One X2",
                model: "Life One X2"
            },
            {
                regex: "LIFE ONE X",
                model: "Life One X"
            },
            {
                regex: "LIFE ONE",
                model: "Life One"
            },
            {
                regex: "LIFE MARK",
                model: "Life Mark"
            },
            {
                regex: "NEO X PLUS",
                model: "Neo X Plus"
            },
            {
                regex: "NEO (XL|X)",
                model: "Neo $1"
            },
            {
                regex: "G90 PRO",
                model: "G90 Pro"
            },
            {
                regex: "G90",
                model: "G90"
            },
            {
                regex: "GRAND 5.5 HD",
                model: "Grand 5.5 HD"
            },
            {
                regex: "Grand X LTE",
                model: "Grand X LTE"
            },
            {
                regex: "Grand XL LTE",
                model: "Grand XL LTE"
            },
            {
                regex: "Grand M3",
                model: "Grand M3"
            },
            {
                regex: "B110DL",
                model: "View Mega"
            },
            {
                regex: "B130DL",
                model: "View 2"
            },
            {
                regex: "R1 HD",
                model: "R1 HD"
            },
            {
                regex: "R1 PLUS",
                model: "R1 Plus"
            },
            {
                regex: "C([456]) (2019)",
                model: "C$1 ($2)"
            },
            {
                regex: "Tank Xtreme ([45]).0",
                model: 'Tank Xtreme $1.0"'
            },
            {
                regex: "Tank Xtreme Pro",
                model: "Tank Xtreme Pro"
            },
            {
                regex: "VIVO AIR LTE",
                model: "Vivo Air LTE"
            },
            {
                regex: "Touchbook G7",
                model: "Touchbook G7"
            },
            {
                regex: "(?:BLU[_ ])?VIVO[ _]SELFIE",
                model: "Vivo Selfie"
            },
            {
                regex: "(?:BLU[_ ])?Vivo 5 Mini",
                model: "Vivo 5 Mini"
            },
            {
                regex: "Touchbook M7 Pro",
                model: "Touchbook M7 Pro",
                device: "tablet"
            },
            {
                regex: "STUDIO 7.0 II",
                model: 'Studio 7.0" II',
                device: "tablet"
            },
            {
                regex: "DASH (L[45] LTE|5.0|L[45]X|L3|X2|[LMX])(?:[);/ ]|$)",
                model: "Dash $1"
            },
            {
                regex: "DASH[ _]([^)/;]+)(?: Build|\\))",
                model: "Dash $1"
            },
            {
                regex: "blu[ _]([^/;]+)( Build|[);])",
                model: "$1"
            }
        ]
    },
    Bluegood: {
        regex: "BLUEGOOD",
        device: "smartphone",
        models: [
            {
                regex: "V6",
                model: "V6"
            }
        ]
    },
    Blackview: {
        regex: "Blackview|(BV([24-9]000|[46]900|(5[1589]|9[15689])00|6[138]00)(?:[ _](?:PRO))?|(P10000(?:[ _](?:PRO))?)|omega[ _]pro|Alife[ _][PS]1|Heatwave|DM550|BV9700Pro|(?<!Lenovo[_ ])A[68]0(?:Pro)?\\))|A[86]0Plus|BL6000Pro",
        device: "smartphone",
        models: [
            {
                regex: "A60Pro\\)",
                model: "A60 Pro"
            },
            {
                regex: "A60\\)",
                model: "A60"
            },
            {
                regex: "A80Pro(?:[);/ ]|$)",
                model: "A80 Pro"
            },
            {
                regex: "A([86]0)Plus(?:[);/ ]|$)",
                model: "A$1 Plus"
            },
            {
                regex: "(BV6000S)",
                model: "$1"
            },
            {
                regex: "(BV9700|BL6000)Pro",
                model: "$1 Pro"
            },
            {
                regex: "Blackview (A[78]|E7S)",
                model: "$1"
            },
            {
                regex: "BV9000Pro-F",
                model: "BV9000 Pro F"
            },
            {
                regex: "(BV([48]000|9[56]00|6[83]00))Pro",
                model: "$1 Pro"
            },
            {
                regex: "(BV6[13]00)(?:[);/ ]|$)",
                model: "$1",
                device: "phablet"
            },
            {
                regex: "(BV([24-9]000|6900|4900|(5[1589]|9[15689])00)(?:[ _](?:PRO))?)",
                model: "$1"
            },
            {
                regex: "(P10000(?:[ _](?:PRO))?)",
                model: "$1"
            },
            {
                regex: "omega[ _]pro",
                model: "Omega Pro"
            },
            {
                regex: "(Alife[ _][PS]1|DM550|Heatwave)",
                model: "$1"
            }
        ]
    },
    Bluboo: {
        regex: "Bluboo|Xfire|Picasso 4G|Maya Build",
        device: "smartphone",
        models: [
            {
                regex: "Maya Build",
                model: "Maya"
            },
            {
                regex: "Xfire2",
                model: "Xfire 2"
            },
            {
                regex: "Picasso 4G",
                model: "Picasso 4G"
            },
            {
                regex: "Xfire",
                model: "Xfire"
            },
            {
                regex: "Bluboo[ _-]?([^;/)]+) Build",
                model: "$1"
            },
            {
                regex: "Bluboo[ _-]?([^;/)]+)",
                model: "$1"
            }
        ]
    },
    "Black Fox": {
        regex: "BMM[ _-]?(?:44[123]D|441[WB]|44[12]S|431D|533D|54[12]S|541[ABW]|54[123]D|543S|531[ABD]|532 S)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "BMM443D",
                model: "B7 Fox+"
            },
            {
                regex: "BMM441S",
                model: "B8 Fox"
            },
            {
                regex: "BMM442S|BMM441B",
                model: "B8 Fox+"
            },
            {
                regex: "BMM441W",
                model: "B8M"
            },
            {
                regex: "BMM442D",
                model: "B7"
            },
            {
                regex: "BMM531D",
                model: "B6"
            },
            {
                regex: "BMM531A",
                model: "B5"
            },
            {
                regex: "BMM541A",
                model: "B5+"
            },
            {
                regex: "BMM543[DS]",
                model: "B4"
            },
            {
                regex: "BMM441D",
                model: "B4 Mini"
            },
            {
                regex: "BMM541B",
                model: "B4 Mini NFC"
            },
            {
                regex: "BMM531B",
                model: "B4 Mini (2019)"
            },
            {
                regex: "BMM542D",
                model: "B3+"
            },
            {
                regex: "BMM541D",
                model: "B3"
            },
            {
                regex: "BMM541W",
                model: "B7R Fox"
            },
            {
                regex: "BMM 532 S",
                model: "BMM 532S"
            },
            {
                regex: "BMM[ _-]?(533D|431D|54[12]S)(?:[);/ ]|$)",
                model: "BMM $1"
            }
        ]
    },
    bogo: {
        regex: "BO-(FRSP4|LFSPBS5|LFSP4|LFSPSL4|LFSPBS5|LFSPSL6QCI)",
        device: "smartphone",
        models: [
            {
                regex: "BO-LFSP4",
                model: "LifeStyle 4DC"
            },
            {
                regex: "BO-LFSPSL4",
                model: "LifeStyle 4SL"
            },
            {
                regex: "BO-LFSPBS5",
                model: "LifeStyle 5BS"
            },
            {
                regex: "BO-LFSPSL6QCI",
                model: "LifeStyle 6QC"
            },
            {
                regex: "BO-(FRSP4)",
                model: "$1"
            }
        ]
    },
    Boway: {
        regex: "(?:sprd-)?(BOWAY)",
        device: "smartphone",
        models: [
            {
                regex: "BOWAY[ _-]([^/;]+)[ _]Build",
                model: "$1"
            },
            {
                regex: "([^/;]+) Build/BOWAY",
                model: "$1"
            },
            {
                regex: ".*BOWAY[ _-]([^/;]+)/",
                model: "$1"
            }
        ]
    },
    Brondi: {
        regex: "Brondi[ _]|(?:CENTURION|GLADIATOR| GLORY|LUXURY|SENSUELLE|VICTORY)(?:[ _-]?[2-6])?(?:[);/ ]|$)|Surfing Tab|501 SZ",
        device: "smartphone",
        models: [
            {
                regex: "(?:Brondi[ _])?(620 SZ|730_4G_HD|501 SZ)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "CENTURION(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                model: "CENTURION $1"
            },
            {
                regex: "GLADIATOR(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                model: "GLADIATOR $1"
            },
            {
                regex: "GLORY(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                model: "GLORY $1"
            },
            {
                regex: "LUXURY(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                model: "LUXURY $1"
            },
            {
                regex: "SENSUELLE(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                model: "SENSUELLE $1"
            },
            {
                regex: "VICTORY(?:[ _-]?([2-6]))?(?:[);/ ]|$)",
                model: "VICTORY $1"
            },
            {
                regex: "Surfing Tab ([^;/]+) Build",
                model: "SURFING TAB $1",
                device: "tablet"
            },
            {
                regex: "Surfing Tab ([^;/)]+)[;/)]",
                model: "SURFING TAB $1",
                device: "tablet"
            }
        ]
    },
    "VGO TEL": {
        regex: "(?:Venture V(?:[278]|12)|Ocean[_ ][689]|Ocean9L)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Venture V([278]|12)(?:[);/ ]|$)",
                model: "Venture V$1"
            },
            {
                regex: "Ocean[_ ]?([689]|9L)(?:[);/ ]|$)",
                model: "Ocean $1"
            }
        ]
    },
    Vivo: {
        regex: "((?:VIV-|BBG-)?(?<!FBCR/)vivo(?!(?:Browser)))|(?:V1730(D[AT]|GA)|V18(18CA|01A0|13B[AT]|18T|09[AT]|1[346][AT]|[13]8[AT]|14A|24[B]?A|2[19][AT]|3[12][AT]|36[AT])|V1731CA|V1732[AT]|V1818CT|V19[01]1[AT]|V1932[AT]|V191[3469][AT]|V192[1348]A|V193[04]A|V194[15]A|V1938CT|V1955A|V1938T|V1730EA|V19[26]2A|V196[35]A|V198[16]A|V1936A[L]?|V19[59]0A|V200[125]A|1819|V201[12]A|V202[0345]C?A|V202[235-9]|V2054A|V203[026]|V204[03]|V2049A|X50 Pro\\+|I1927)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "V1824[B]?A(?:[);/ ]|$)",
                model: "iQOO"
            },
            {
                regex: "V1955A(?:[);/ ]|$)",
                model: "iQOO 3"
            },
            {
                regex: "I1927(?:[);/ ]|$)",
                model: "iQOO 3 5G"
            },
            {
                regex: "V2049A(?:[);/ ]|$)",
                model: "iQOO 7"
            },
            {
                regex: "V1922A(?:[);/ ]|$)",
                model: "iQOO Pro"
            },
            {
                regex: "V1916A(?:[);/ ]|$)",
                model: "iQOO Pro 5G"
            },
            {
                regex: "V1914A(?:[);/ ]|$)",
                model: "iQOO Neo"
            },
            {
                regex: "V1981A(?:[);/ ]|$)",
                model: "iQOO Neo 3"
            },
            {
                regex: "V1936A[L]?(?:[);/ ]|$)",
                model: "iQOO Neo 855"
            },
            {
                regex: "V1986A(?:[);/ ]|$)",
                model: "iQOO Z1"
            },
            {
                regex: "V2012A(?:[);/ ]|$)",
                model: "iQOO Z1x"
            },
            {
                regex: "V1919A(?:[);/ ]|$)",
                model: "iQOO Z5x"
            },
            {
                regex: "V2023A(?:[);/ ]|$)",
                model: "iQOO U1"
            },
            {
                regex: "V2024A(?:[);/ ]|$)",
                model: "iQOO 5"
            },
            {
                regex: "V2025A(?:[);/ ]|$)",
                model: "iQOO 5 Pro"
            },
            {
                regex: "V2025(?:[);/ ]|$)",
                model: "V20"
            },
            {
                regex: "V2040(?:[);/ ]|$)",
                model: "V20 (2021)"
            },
            {
                regex: "vivo 1805(?:[);/ ]|$)",
                model: "Nex"
            },
            {
                regex: "V1923A(?:[);/ ]|$)",
                model: "Nex 3"
            },
            {
                regex: "V1924A(?:[);/ ]|$)",
                model: "Nex 3 5G"
            },
            {
                regex: "V1950A(?:[);/ ]|$)",
                model: "Nex 3S"
            },
            {
                regex: "V1821[AT](?:[);/ ]|$)",
                model: "Nex Dual Display"
            },
            {
                regex: "Vivo ONE(?:[);/ ]|$)",
                model: "One"
            },
            {
                regex: "V1831[AT](?:[);/ ]|$)",
                model: "S1"
            },
            {
                regex: "V1832[AT](?:[);/ ]|$)",
                model: "S1 Pro"
            },
            {
                regex: "V1932[AT](?:[);/ ]|$)",
                model: "S5"
            },
            {
                regex: "V1962A(?:[);/ ]|$)",
                model: "S6 5G"
            },
            {
                regex: "V2020C?A(?:[);/ ]|$)",
                model: "S7"
            },
            {
                regex: "V1941A(?:[);/ ]|$)",
                model: "U3"
            },
            {
                regex: "V1928A(?:[);/ ]|$)",
                model: "U3X"
            },
            {
                regex: "vivo 1804(?:[);/ ]|$)",
                model: "V11 Pro"
            },
            {
                regex: "vivo 1806(?:[);/ ]|$)",
                model: "V11i"
            },
            {
                regex: "1819(?:[);/ ]|$)",
                model: "V15"
            },
            {
                regex: "vivo 1818(?:[);/ ]|$)",
                model: "V15 Pro"
            },
            {
                regex: "vivo 1909(?:[);/ ]|$)",
                model: "V17 Pro"
            },
            {
                regex: "V2022(?:[);/ ]|$)",
                model: "V20 SE"
            },
            {
                regex: "(?:VIV-|BBG-)?vivo[ _]1601(?:[);/ ]|$)",
                model: "V5"
            },
            {
                regex: "vivo 1609(?:[);/ ]|$)",
                model: "V5 Lite"
            },
            {
                regex: "vivo 1611(?:[);/ ]|$)",
                model: "V5 Plus"
            },
            {
                regex: "vivo (1713|1612)(?:[);/ ]|$)",
                model: "V5s"
            },
            {
                regex: "vivo 1718(?:[);/ ]|$)",
                model: "V7"
            },
            {
                regex: "vivo 1716(?:[);/ ]|$)",
                model: "V7 Plus"
            },
            {
                regex: "vivo 1723(?:[);/ ]|$)",
                model: "V9"
            },
            {
                regex: "vivo 1727(?:[);/ ]|$)",
                model: "V9 Youth"
            },
            {
                regex: "vivo 1721(?:[);/ ]|$)",
                model: "X20"
            },
            {
                regex: "X20Plus(?:[);/ ]|$)",
                model: "X20 Plus"
            },
            {
                regex: "vivo 1725(?:[);/ ]|$)",
                model: "X21"
            },
            {
                regex: "V1814[AT](?:[);/ ]|$)",
                model: "X21S"
            },
            {
                regex: "V1809[AT](?:[);/ ]|$)",
                model: "X23"
            },
            {
                regex: "V1816[AT](?:[);/ ]|$)",
                model: "X23"
            },
            {
                regex: "V18(38|29)[AT](?:[);/ ]|$)",
                model: "X27"
            },
            {
                regex: "V1836[AT](?:[);/ ]|$)",
                model: "X27 Pro"
            },
            {
                regex: "V1938CT(?:[);/ ]|$)",
                model: "X30"
            },
            {
                regex: "V1938T(?:[);/ ]|$)",
                model: "X30 Pro"
            },
            {
                regex: "V2001A(?:[);/ ]|$)",
                model: "X50"
            },
            {
                regex: "V2005A(?:[);/ ]|$)",
                model: "X50 Pro"
            },
            {
                regex: "(?:V2011A|X50 Pro\\+)(?:[);/ ]|$)",
                model: "X50 Pro Plus"
            },
            {
                regex: "X9Plus(?:[);/ ]|$)",
                model: "X9 Plus"
            },
            {
                regex: "vivo 1902(?:[);/ ]|$)",
                model: "Y17"
            },
            {
                regex: "vivo 1915(?:[);/ ]|$)",
                model: "Y19"
            },
            {
                regex: "V202[79](?:[);/ ]|$)",
                model: "Y20"
            },
            {
                regex: "V2028(?:[);/ ]|$)",
                model: "Y11s"
            },
            {
                regex: "V2043(?:[);/ ]|$)",
                model: "Y20 (2021)"
            },
            {
                regex: "V2032(?:[);/ ]|$)",
                model: "Y20i"
            },
            {
                regex: "V2023(?:[);/ ]|$)",
                model: "V20 SE"
            },
            {
                regex: "V1901[AT](?:[);/ ]|$)",
                model: "Y3"
            },
            {
                regex: "V1930A(?:[);/ ]|$)",
                model: "Y3 Standard"
            },
            {
                regex: "V2036(?:[);/ ]|$)",
                model: "Y31"
            },
            {
                regex: "V1934A(?:[);/ ]|$)",
                model: "Y5s"
            },
            {
                regex: "V1965A(?:[);/ ]|$)",
                model: "Y50"
            },
            {
                regex: "V2030(?:[);/ ]|$)",
                model: "Y51"
            },
            {
                regex: "V2054A(?:[);/ ]|$)",
                model: "Y31s"
            },
            {
                regex: "vivo 1606(?:[);/ ]|$)",
                model: "Y53i"
            },
            {
                regex: "vivo 1603(?:[);/ ]|$)",
                model: "Y55l"
            },
            {
                regex: "vivo 1610(?:[);/ ]|$)",
                model: "Y55s"
            },
            {
                regex: "vivo 1719(?:[);/ ]|$)",
                model: "Y65"
            },
            {
                regex: "vivo 1714(?:[);/ ]|$)",
                model: "Y69"
            },
            {
                regex: "V2002A(?:[);/ ]|$)",
                model: "Y70s"
            },
            {
                regex: "vivo 1724(?:[);/ ]|$)",
                model: "Y71"
            },
            {
                regex: "vivo 1801(?:[);/ ]|$)",
                model: "Y71i"
            },
            {
                regex: "V1731CA(?:[);/ ]|$)",
                model: "Y73"
            },
            {
                regex: "V1913[AT](?:[);/ ]|$)",
                model: "Y7s"
            },
            {
                regex: "vivo 180([38]|8i)(?:[);/ ]|$)",
                model: "Y81"
            },
            {
                regex: "vivo 1812(?:[);/ ]|$)",
                model: "Y81i"
            },
            {
                regex: "V1732[AT](?:[);/ ]|$)",
                model: "Y81s"
            },
            {
                regex: "vivo 1726(?:[);/ ]|$)",
                model: "Y83 Pro"
            },
            {
                regex: "V1730EA(?:[);/ ]|$)",
                model: "Y89"
            },
            {
                regex: "vivo 181[17](?:[);/ ]|$)",
                model: "Y91"
            },
            {
                regex: "V1945A(?:[);/ ]|$)",
                model: "Y9s"
            },
            {
                regex: "V2026(?:[);/ ]|$)",
                model: "Y12s"
            },
            {
                regex: "vivo 18(16|20)(?:[);/ ]|$)",
                model: "Y91i"
            },
            {
                regex: "(V1818[AT]|vivo 181[45])(?:[);/ ]|$)",
                model: "Y93"
            },
            {
                regex: "V1818C[AT](?:[);/ ]|$)",
                model: "Y93s"
            },
            {
                regex: "vivo 1807(?:[);/ ]|$)",
                model: "Y95"
            },
            {
                regex: "V1813[AT](?:[);/ ]|$)",
                model: "Y97"
            },
            {
                regex: "V1801A0(?:[);/ ]|$)",
                model: "Z1"
            },
            {
                regex: "V1730D[AT](?:[);/ ]|$)",
                model: "Z1i"
            },
            {
                regex: "vivo 1917(?:[);/ ]|$)",
                model: "Z1x"
            },
            {
                regex: "V1813B[AT](?:[);/ ]|$)",
                model: "Z3"
            },
            {
                regex: "V1730GA(?:[);/ ]|$)",
                model: "Z3x"
            },
            {
                regex: "V1921A(?:[);/ ]|$)",
                model: "Z5"
            },
            {
                regex: "V1911A(?:[);/ ]|$)",
                model: "Z5x"
            },
            {
                regex: "V1990A(?:[);/ ]|$)",
                model: "Z5x (2020)"
            },
            {
                regex: "V1963A(?:[);/ ]|$)",
                model: "Z6"
            },
            {
                regex: "(?:VIV-|BBG-)?vivo[ _]([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "(?:VIV-|BBG-)?vivo[ _]([^);/]+)(?:[);/]|$)",
                model: "$1"
            }
        ]
    },
    Vinsoc: {
        regex: "(XA Pro) Build",
        device: "smartphone",
        model: "$1"
    },
    Bird: {
        regex: "BIRD[\\-. _]([^;/]+)",
        device: "feature phone",
        models: [
            {
                regex: "BIRD[\\-. _]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "BIRD[\\-. _]([^;/]+)",
                model: "$1"
            }
        ]
    },
    Becker: {
        regex: "Becker-([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Beeline: {
        regex: "Beeline",
        device: "smartphone",
        models: [
            {
                regex: "Beeline[_ ]Pro[_ ]([2436])",
                model: "Pro $1"
            },
            {
                regex: "Tab (Fast|Pro)",
                model: "Tab $1",
                device: "tablet"
            },
            {
                regex: "Tab ([0-9])",
                model: "Tab $1",
                device: "tablet"
            },
            {
                regex: "Tab",
                model: "Tab",
                device: "tablet"
            },
            {
                regex: "E700",
                model: "E700"
            },
            {
                regex: "Smart2",
                model: "Smart 2"
            },
            {
                regex: "Smart ([0-9])",
                model: "Smart $1"
            },
            {
                regex: "Smart Dual",
                model: "Smart Dual"
            },
            {
                regex: "(?:Beeline[_ ])?Fast[_ ]2(?:[);/ ]|$)",
                model: "Fast 2"
            },
            {
                regex: "Fast(?:[);/ ]|$)",
                model: "Fast"
            }
        ]
    },
    Beetel: {
        regex: "Beetel ([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    "BenQ-Siemens": {
        regex: "BENQ-SIEMENS - ([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    BenQ: {
        regex: "BENQ(?:[ \\-])?([a-z0-9]+)|F52_09(?:[);/ ]|$)",
        device: "feature phone",
        models: [
            {
                regex: "F52_09(?:[);/ ]|$)",
                model: "F52"
            },
            {
                regex: "BENQ(?:[ \\-])?([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Blaupunkt: {
        regex: "Blaupunkt|Soundphone S2|Atlantis[_ ](?:1001A|1010A|A10\\.G40[23])|SLplus02|Discovery[_ ](?:A10_302|111C|1000C|1001A?)|Endeavour[_ ](?:785|101[GLM]|1000|1001|101[03]|1100)|Polaris[_ ]803|BP_6010",
        device: "tablet",
        models: [
            {
                regex: "Discovery[_ ]111C",
                model: "Discovery 111C"
            },
            {
                regex: "Discovery[_ ]A10_302",
                model: "Discovery A10.302"
            },
            {
                regex: "Discovery[_ ]1000C",
                model: "Discovery 1000C"
            },
            {
                regex: "Discovery[_ ]1001A",
                model: "Discovery 1001A"
            },
            {
                regex: "Discovery[_ ]1001",
                model: "Discovery 1001"
            },
            {
                regex: "Soundphone S2",
                model: "Soundphone S2"
            },
            {
                regex: "Endeavour[_ ](101[GLM]|785|100[01]|101[03]|1100)",
                model: "Endeavour $1"
            },
            {
                regex: "Polaris[_ ](803)",
                model: "Polaris $1"
            },
            {
                regex: "Atlantis[_ ](1001A|1010A|A10\\.G40[23])",
                model: "Atlantis $1"
            },
            {
                regex: "SLplus02",
                model: "SL Plus 02"
            },
            {
                regex: "(BP_6010)",
                model: "$1"
            },
            {
                regex: "Blaupunkt[_ ](SL[_ ]0[124]|SM[_ ]0[12])",
                device: "smartphone",
                model: "$1"
            },
            {
                regex: "(4K Android TV)",
                device: "tv",
                model: "$1"
            }
        ]
    },
    Bmobile: {
        regex: "Bmobile[_ ]|AX-?(?:[1-9][0-9]{2,3}[eEO+]?|7OO)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "AX-?([1-9][0-9]{2,3}[eEO+]?)",
                model: "AX$1"
            },
            {
                regex: "AX7OO",
                model: "AX700"
            },
            {
                regex: "Bmobile[_ ]([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "Bmobile[_ ]([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    bq: {
        regex: "Aquaris|bq [^/;]+ Build|BQS[-_]([0-9]{4})|(BQ(ru)?[_ -][0-9]{3,4})|BQ5059|BQ1008G|BQru_BQru-",
        device: "smartphone",
        models: [
            {
                regex: "BQ(?:ru)?-(?:5209L|5044)(?:[);/ ]|$)",
                model: "Strike LTE"
            },
            {
                regex: "BQ(?:ru)?-(?:6035L)(?:[);/ ]|$)",
                model: "Strike Power Max"
            },
            {
                regex: "BQ(?:ru)?-(?:5535L)(?:[);/ ]|$)",
                model: "Strike Power Plus"
            },
            {
                regex: "BQ(S|ru)?-(?:5070|6040L)(?:[);/ ]|$)",
                model: "Magic"
            },
            {
                regex: "BQ(S|ru)?-(?:6424L)(?:[);/ ]|$)",
                model: "Magic O"
            },
            {
                regex: "BQ(?:S|ru)?-(?:5730L)(?:[);/ ]|$)",
                model: "Magic C"
            },
            {
                regex: "BQ(?:S|ru)?-(?:5731L)(?:[);/ ]|$)",
                model: "Magic S"
            },
            {
                regex: "BQ(?:S|ru)?-5745L(?:[);/ ]|$)",
                model: "Clever"
            },
            {
                regex: "BQ(?:S|ru)?-5533G(?:[);/ ]|$)",
                model: "Fresh"
            },
            {
                regex: "BQ(?:S|ru)?-5031G(?:[);/ ]|$)",
                model: "Fun"
            },
            {
                regex: "BQ(?:S|ru)?-(?:5732L)(?:[);/ ]|$)",
                model: "Aurora SE"
            },
            {
                regex: "BQ(?:S|ru)?-6430L(?:[);/ ]|$)",
                model: "Aurora"
            },
            {
                regex: "BQ(?:S|ru)?-6630L(?:[);/ ]|$)",
                model: "Magic L"
            },
            {
                regex: "BQ-9011[G]?(?:[);/ ]|$)",
                model: "Vision",
                device: "tablet"
            },
            {
                regex: "BQ-8068L(?:[);/ ]|$)",
                model: "Hornet Plus Pro"
            },
            {
                regex: "BQ-8067L",
                model: "Hornet Plus",
                device: "tablet"
            },
            {
                regex: "BQ-8052G",
                model: "BQ-8052G",
                device: "tablet"
            },
            {
                regex: "BQ-8041L",
                model: "Art",
                device: "tablet"
            },
            {
                regex: "BQ-7084G",
                model: "Simple",
                device: "tablet"
            },
            {
                regex: "BQ-7061G",
                model: "Andros",
                device: "tablet"
            },
            {
                regex: "BQ(ru)?-(7082)",
                model: "Armor",
                device: "tablet"
            },
            {
                regex: "BQ-7051G",
                model: "Elba",
                device: "tablet"
            },
            {
                regex: "BQ-7036L",
                model: "Hornet",
                device: "tablet"
            },
            {
                regex: "BQ-7022(G)?",
                model: "Canion",
                device: "tablet"
            },
            {
                regex: "BQ-7021G",
                model: "Hit",
                device: "tablet"
            },
            {
                regex: "BQ-7010G",
                model: "Max",
                device: "tablet"
            },
            {
                regex: "BQ-7006G",
                model: "Union",
                device: "tablet"
            },
            {
                regex: "BQ-7003",
                model: "Jamaica",
                device: "tablet"
            },
            {
                regex: "BQ-6200L|BQ-6000L",
                model: "Aurora"
            },
            {
                regex: "BQ-6631G",
                model: "Surf"
            },
            {
                regex: "BQ-6022G",
                model: "Aura"
            },
            {
                regex: "BQ(ru)?[ -]6015L",
                model: "Universe"
            },
            {
                regex: "BQ(?:S|ru)?-(?:5525|6030G|6010G)",
                model: "Practic"
            },
            {
                regex: "BQ-6001L|BQ-6050",
                model: "Jumbo"
            },
            {
                regex: "BQ-5707G(?:[);/ ]|$)",
                model: "Next Music"
            },
            {
                regex: "BQ-5702(?:[);/ ]|$)",
                model: "Spring"
            },
            {
                regex: "BQ-5700L(?:[);/ ]|$)",
                model: "Space X"
            },
            {
                regex: "BQ-(?:5591|551[89]G)(?:[);/ ]|$)",
                model: "Jeans"
            },
            {
                regex: "BQ-5522",
                model: "Next"
            },
            {
                regex: "BQ-5520L(?:[);/ ]|$)",
                model: "Silk"
            },
            {
                regex: "BQ-5519L(?:[);/ ]|$)",
                model: "Fast Plus"
            },
            {
                regex: "BQ-5540L(?:[);/ ]|$)",
                model: "Fast Pro"
            },
            {
                regex: "BQ-5517L(?:[);/ ]|$)",
                model: "Twin Pro"
            },
            {
                regex: "BQ-5516L(?:[);/ ]|$)",
                model: "Twin"
            },
            {
                regex: "BQS-5515(?:[);/ ]|$)",
                model: "Wide"
            },
            {
                regex: "BQ-5515[L]?(?:[);/ ]|$)",
                model: "Fast"
            },
            {
                regex: "BQ-(?:5512L|5528L)(?:[);/ ]|$)",
                model: "Strike Forward"
            },
            {
                regex: "BQ-5511L(?:[);/ ]|$)",
                model: "Bliss"
            },
            {
                regex: "BQS[_ ]5505(?:[);/ ]|$)",
                model: "Amsterdam"
            },
            {
                regex: "BQ(?:ru)?-5510(?:[);/ ]|$)",
                model: "Strike Power Max 4G"
            },
            {
                regex: "BQ(?:ru)?-(?:5521|5594)(?:[);/ ]|$)",
                model: "Strike Power Max"
            },
            {
                regex: "BQ-5508L(?:[);/ ]|$)",
                model: "Next LTE"
            },
            {
                regex: "BQ-5507L(?:[);/ ]|$)",
                model: "Iron Max"
            },
            {
                regex: "BQ(?:ru)?-5504(?:[);/ ]|$)",
                model: "Strike Selfie Max"
            },
            {
                regex: "BQ(?:ru)?-5503(?:[);/ ]|$)",
                model: "Nice 2"
            },
            {
                regex: "BQ(?:ru)?-6045L(?:[);/ ]|$)",
                model: "Nice"
            },
            {
                regex: "BQ(?:ru)?-4030G(?:[);/ ]|$)",
                model: "Nice Mini"
            },
            {
                regex: "BQS-5502(?:[);/ ]|$)",
                model: "Hammer"
            },
            {
                regex: "BQS-5501(?:[);/ ]|$)",
                model: "Kawasaki"
            },
            {
                regex: "BQS-5500(?:[);/ ]|$)",
                model: "Vancouver"
            },
            {
                regex: "BQ-5500L(?:[);/ ]|$)",
                model: "Advance"
            },
            {
                regex: "BQ-5302G(?:[);/ ]|$)",
                model: "Velvet 2"
            },
            {
                regex: "BQ-5301(?:[);/ ]|$)",
                model: "Strike View"
            },
            {
                regex: "BQ-5300G(?:[);/ ]|$)",
                model: "Velvet View"
            },
            {
                regex: "BQ(ru|S)?-(?:5211|5020)(?:[);/ ]|$)",
                model: "Strike"
            },
            {
                regex: "BQ-5206L(?:[);/ ]|$)",
                model: "Balance"
            },
            {
                regex: "BQ(?:ru|S)?-(?:5204|5050)(?:[);/ ]|$)",
                model: "Strike Selfie"
            },
            {
                regex: "BQ(?:ru)?-5203(?:[);/ ]|$)",
                model: "Vision"
            },
            {
                regex: "BQ(?:ru)?-5202(?:[);/ ]|$)",
                model: "Space Lite"
            },
            {
                regex: "BQ(?:ru)?-5201(?:[);/ ]|$)",
                model: "Space"
            },
            {
                regex: "BQ-5082(?:[);/ ]|$)",
                model: "Sense 2"
            },
            {
                regex: "BQ-5045L(?:[);/ ]|$)",
                model: "Wallet"
            },
            {
                regex: "BQ-5047L(?:[);/ ]|$)",
                model: "Like"
            },
            {
                regex: "BQ-5071(?:[);/ ]|$)",
                model: "Belief"
            },
            {
                regex: "BQ[S]?-(?:5065|5340)(?:[);/ ]|$)",
                model: "Choice"
            },
            {
                regex: "BQ(?:S|ru)?-5046L(?:[);/ ]|$)",
                model: "Choice LTE"
            },
            {
                regex: "BQ(?:ru)?-?(?:5059|5514G)(?:[);/ ]|$)",
                model: "Strike Power"
            },
            {
                regex: "(?:BQru_)?BQ(?:ru)?-5058(?:[);/ ]|$)",
                model: "Strike Power Easy"
            },
            {
                regex: "BQ(?:ru)?-5057(?:[);/ ]|$)",
                model: "Strike 2"
            },
            {
                regex: "BQ[S]?-(?:5056|5030)(?:[);/ ]|$)",
                model: "Fresh"
            },
            {
                regex: "BQ-6042l(?:[);/ ]|$)",
                model: "Magic E"
            },
            {
                regex: "BQS-5055(?:[);/ ]|$)",
                model: "Turbo Plus"
            },
            {
                regex: "BQ(?:ru)?-5054(?:[);/ ]|$)",
                model: "Crystal"
            },
            {
                regex: "BQ-5052(?:[);/ ]|$)",
                model: "Sense"
            },
            {
                regex: "BQ[S]?-5045(?:[);/ ]|$)",
                model: "Fast"
            },
            {
                regex: "BQ(?:ru)?-(?:5037|5514L)(?:[);/ ]|$)",
                model: "Strike Power 4G"
            },
            {
                regex: "BQ(?:ru)?-5035(?:[);/ ]|$)",
                model: "Velvet"
            },
            {
                regex: "BQ(?:ru)?-5033(?:[);/ ]|$)",
                model: "Shark"
            },
            {
                regex: "BQ-5541L(?:[);/ ]|$)",
                model: "Shark Rush"
            },
            {
                regex: "BQ-5032(?:[);/ ]|$)",
                model: "Element"
            },
            {
                regex: "BQS-5025(?:[);/ ]|$)",
                model: "High Way"
            },
            {
                regex: "BQ(?:ru)?-5022(?:[);/ ]|$)",
                model: "Bond"
            },
            {
                regex: "BQ-5015L(?:[);/ ]|$)",
                model: "First"
            },
            {
                regex: "BQ-5016G(?:[);/ ]|$)",
                model: "Choice"
            },
            {
                regex: "BQ-5012L(?:[);/ ]|$)",
                model: "Rich"
            },
            {
                regex: "BQ-5521L(?:[);/ ]|$)",
                model: "Rich Max"
            },
            {
                regex: "BQS-5011(?:[);/ ]|$)",
                model: "Monte Carlo"
            },
            {
                regex: "BQ-5010G(?:[);/ ]|$)",
                model: "Spot"
            },
            {
                regex: "BQ-5000G(?:[);/ ]|$)",
                model: "Velvet Easy"
            },
            {
                regex: "BQS-5010(?:[);/ ]|$)",
                model: "Prague"
            },
            {
                regex: "BQ-5009L(?:[);/ ]|$)",
                model: "Trend"
            },
            {
                regex: "BQS-500[59](?:[);/ ]|$)",
                model: "Sydney"
            },
            {
                regex: "BQ-5008L(?:[);/ ]|$)",
                model: "Brave"
            },
            {
                regex: "BQ-5007L(?:[);/ ]|$)",
                model: "Iron"
            },
            {
                regex: "BQS-5006(?:[);/ ]|$)",
                model: "Los Angeles"
            },
            {
                regex: "BQ-(?:5005L|5530L)(?:[);/ ]|$)",
                model: "Intense"
            },
            {
                regex: "BQS-5004(?:[);/ ]|$)",
                model: "Paris"
            },
            {
                regex: "BQ-5003L(?:[);/ ]|$)",
                model: "Shark Pro"
            },
            {
                regex: "BQ-5002G(?:[);/ ]|$)",
                model: "Fun"
            },
            {
                regex: "BQS-5002(?:[);/ ]|$)",
                model: "Colombo"
            },
            {
                regex: "BQS-5003(?:[);/ ]|$)",
                model: "Colombo II"
            },
            {
                regex: "BQ-5001L(?:[);/ ]|$)",
                model: "Contact"
            },
            {
                regex: "BQS-5001(?:[);/ ]|$)",
                model: "Milan"
            },
            {
                regex: "BQ(?:ru|S)?-5000(?:[);/ ]|$)",
                model: "Tokyo"
            },
            {
                regex: "BQS-4800(?:[);/ ]|$)",
                model: "Blade"
            },
            {
                regex: "BQS-4707(?:[);/ ]|$)",
                model: "Montreal"
            },
            {
                regex: "BQS-4702(?:[);/ ]|$)",
                model: "\u041Esaka"
            },
            {
                regex: "BQS-4701(?:[);/ ]|$)",
                model: "Venice"
            },
            {
                regex: "BQ-(?:4585|5011G)(?:[);/ ]|$)",
                model: "Fox View"
            },
            {
                regex: "BQ(?:ru)?-4583(?:[);/ ]|$)",
                model: "Fox Power"
            },
            {
                regex: "BQS-4570(?:[);/ ]|$)",
                model: "Drive"
            },
            {
                regex: "BQS-4560(?:[);/ ]|$)",
                model: "Golf"
            },
            {
                regex: "BQS-4555(?:[);/ ]|$)",
                model: "Turbo"
            },
            {
                regex: "BQS-4550(?:[);/ ]|$)",
                model: "Richmond"
            },
            {
                regex: "BQ(?:ru)?-(?:4526|5004G)(?:[);/ ]|$)",
                model: "Fox"
            },
            {
                regex: "BQS-4525(?:[);/ ]|$)",
                model: "Vienna"
            },
            {
                regex: "BQS-4516(?:[);/ ]|$)",
                model: "Singapore"
            },
            {
                regex: "BQS-4515(?:[);/ ]|$)",
                model: "Moscow"
            },
            {
                regex: "BQS-4510(?:[);/ ]|$)",
                model: "Florence"
            },
            {
                regex: "BQS-4505(?:[);/ ]|$)",
                model: "Santiago"
            },
            {
                regex: "BQS-4503(?:[);/ ]|$)",
                model: "Dubai"
            },
            {
                regex: "BQS-4502(?:[);/ ]|$)",
                model: "Kingston"
            },
            {
                regex: "BQS-4501 Bristol",
                model: "Bristol"
            },
            {
                regex: "BQ-4501G(?:[);/ ]|$)",
                model: "Fox Easy"
            },
            {
                regex: "BQ(?:ru)?-4500(?:[);/ ]|$)",
                model: "Fox LTE"
            },
            {
                regex: "BQ-4077(?:[);/ ]|$)",
                model: "Shark Mini"
            },
            {
                regex: "BQ(?:ru)?-4072(?:[);/ ]|$)",
                model: "Strike Mini"
            },
            {
                regex: "BQ(?:ru)?[- ]402[68](?:[);/ ]|$)",
                model: "Up!"
            },
            {
                regex: "BQS-4010(?:[);/ ]|$)",
                model: "Aspen"
            },
            {
                regex: "BQS-4009(?:[);/ ]|$)",
                model: "Orleans"
            },
            {
                regex: "BQS-4008(?:[);/ ]|$)",
                model: "Shanghai"
            },
            {
                regex: "BQS-4007(?:[);/ ]|$)",
                model: "Valencia"
            },
            {
                regex: "BQS-4005(?:[);/ ]|$)",
                model: "Seoul"
            },
            {
                regex: "BQS-4004(?:[);/ ]|$)",
                model: "Dusseldorf"
            },
            {
                regex: "BQS-4003(?:[);/ ]|$)",
                model: "Verona"
            },
            {
                regex: "BQ-4001G(?:[);/ ]|$)",
                model: "Cool"
            },
            {
                regex: "BQS-4001(?:[);/ ]|$)",
                model: "Oxford"
            },
            {
                regex: "BQS-3510(?:[);/ ]|$)",
                model: "Aspen Mini"
            },
            {
                regex: "BQS-3503(?:[);/ ]|$)",
                model: "Bombay"
            },
            {
                regex: "BQ-1085L(?:[);/ ]|$)",
                model: "Hornet Max Pro",
                device: "tablet"
            },
            {
                regex: "BQ-1084L(?:[);/ ]|$)",
                model: "Hornet Max",
                device: "tablet"
            },
            {
                regex: "BQ-1083G(?:[);/ ]|$)",
                model: "Armor Pro Plus",
                device: "tablet"
            },
            {
                regex: "BQ-1082G(?:[);/ ]|$)",
                model: "Armor Pro",
                device: "tablet"
            },
            {
                regex: "BQ-1077L(?:[);/ ]|$)",
                model: "Armor Pro LTE",
                device: "tablet"
            },
            {
                regex: "BQ(?:ru)?-1057L(?:[);/ ]|$)",
                model: "Passion",
                device: "tablet"
            },
            {
                regex: "BQ-1051G(?:[);/ ]|$)",
                model: "Corsika",
                device: "tablet"
            },
            {
                regex: "BQ-1050G(?:[);/ ]|$)",
                model: "Hawaii",
                device: "tablet"
            },
            {
                regex: "BQ[-]?1008G(?:[);/ ]|$)",
                model: "Grace",
                device: "tablet"
            },
            {
                regex: "Aquaris M8",
                model: "Aquaris M8",
                device: "tablet"
            },
            {
                regex: "Aquaris_([AM])4.5",
                model: "Aquaris $14.5"
            },
            {
                regex: "BQ(?:ru)?[_ -](?:5590|5740G)(?:[);/ ]|$)",
                model: "Spring"
            },
            {
                regex: "BQ[S]?-(?:6016L|5520)(?:[);/ ]|$)",
                model: "Mercury"
            },
            {
                regex: "BQ(?:S|ru)?-(?:5701L|5060)(?:[);/ ]|$)",
                model: "Slim"
            },
            {
                regex: "(BQ-7850|BQ-700[12]G|BQ-8002G|BQ-905[12]G|BQ-9702G|BQ-7056G)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "BQ-8006G(?:[);/ ]|$)",
                model: "Java",
                device: "tablet"
            },
            {
                regex: "BQ-7062G(?:[);/ ]|$)",
                model: "Fiji",
                device: "tablet"
            },
            {
                regex: "BQ(?:ru)?-1081G(?:[);/ ]|$)",
                model: "Grace 3G",
                device: "tablet"
            },
            {
                regex: "BQ-7802G(?:[);/ ]|$)",
                model: "Luzon",
                device: "tablet"
            },
            {
                regex: "BQ-7008G(?:[);/ ]|$)",
                model: "Clarion",
                device: "tablet"
            },
            {
                regex: "BQ-7064G(?:[);/ ]|$)",
                model: "Fusion",
                device: "tablet"
            },
            {
                regex: "BQ-7050G(?:[);/ ]|$)",
                model: "Malta",
                device: "tablet"
            },
            {
                regex: "BQ-7000G(?:[);/ ]|$)",
                model: "\u0421harm",
                device: "tablet"
            },
            {
                regex: "BQ-7040G(?:[);/ ]|$)",
                model: "\u0421harm Plus",
                device: "tablet"
            },
            {
                regex: "BQ-7038G(?:[);/ ]|$)",
                model: "Light Plus",
                device: "tablet"
            },
            {
                regex: "BQ-7005G(?:[);/ ]|$)",
                model: "Maui",
                device: "tablet"
            },
            {
                regex: "BQ-7098G(?:[);/ ]|$)",
                model: "Armor Power",
                device: "tablet"
            },
            {
                regex: "BQ-1007(?:[);/ ]|$)",
                model: "Necker",
                device: "tablet"
            },
            {
                regex: "BQ-1045[G]?(?:[);/ ]|$)",
                model: "Orion",
                device: "tablet"
            },
            {
                regex: "BQ-(?:1054L|1020L)(?:[);/ ]|$)",
                model: "Nexion",
                device: "tablet"
            },
            {
                regex: "BQ-7083G(?:[);/ ]|$)",
                model: "Light",
                device: "tablet"
            },
            {
                regex: "BQ-8077L(?:[);/ ]|$)",
                model: "Exion Plus",
                device: "tablet"
            },
            {
                regex: "BQ(?:ru)?-7083(?:[);/ ]|$)",
                model: "7083",
                device: "tablet"
            },
            {
                regex: "BQ(?:ru)?-1056L(?:[);/ ]|$)",
                model: "1056L",
                device: "tablet"
            },
            {
                regex: "BQ(?:ru)?-1022l(?:[);/ ]|$)",
                model: "Armor Pro LTE+",
                device: "tablet"
            },
            {
                regex: "BQ(?:ru)?-1024L(?:[);/ ]|$)",
                model: "Exion Pro",
                device: "tablet"
            },
            {
                regex: "BQ(?:ru)?-7081(?:[);/ ]|$)",
                model: "Charm",
                device: "tablet"
            },
            {
                regex: "(?:bq )?(Aquaris[^/;]*) Build",
                model: "$1"
            },
            {
                regex: "Aquaris (E(4.5|[56])|M(5|10)|U2 Lite|U2|U (Lite|Plus)|V Plus|X5 Plus|X2? Pro|X[25]|[CMUVX])",
                model: "Aquaris $1"
            },
            {
                regex: "bq ([^/;]+) Build",
                model: "$1",
                device: "tablet"
            }
        ]
    },
    Bush: {
        regex: "Bush[ _-]|Bush10Nou",
        device: "smartphone",
        models: [
            {
                regex: "Bush10Nou",
                device: "tablet",
                model: "10Nou"
            },
            {
                regex: "BUSH ([^;/)]+)Tablet(?: Build|[);])",
                model: "$1Tablet",
                device: "tablet"
            },
            {
                regex: "BUSH ([^;/)]+)(?: Build|[);])",
                model: "$1"
            }
        ]
    },
    CAGI: {
        regex: "CAGI-",
        device: "smartphone",
        models: [
            {
                regex: "CAGI-OMEGA",
                model: "Omega"
            },
            {
                regex: "CAGI-([a-z0-9_\\-]+)",
                model: "$1"
            }
        ]
    },
    Capitel: {
        regex: "Capitel-([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Captiva: {
        regex: "Captiva[ _-]([^;/)]+)(?: Build|\\))",
        device: "tablet",
        model: "Pad $1"
    },
    Casio: {
        regex: "(C811|C7[57]1)(?: 4G)?(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "C751(?:[);/ ]|$)",
                model: "G'zOne Ravine"
            },
            {
                regex: "C771(?:[);/ ]|$)",
                model: "G'zOne Commando"
            },
            {
                regex: "C811 4G(?:[);/ ]|$)",
                model: "G'zOne Commando 4G LTE"
            }
        ]
    },
    Casper: {
        regex: "CASPER[_ ]|VIA[- _](T7D|A[34]|E3|F[123]|G4|M4|[LS]8|S7|P2|V8C|A1_Plus(?:_64)?|A1(?:_1)?|S[13]0|S|T17_M|T1[07]|T7|T7-3G|T8B|T8D-3G|S1[78])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:CASPER[_ ])?VIA_A1_Plus(?:_64)?",
                model: "VIA A1 Plus"
            },
            {
                regex: "(?:CASPER[_ ])?VIA[_ ](G1_Plus|G1|E1|[AE]2|M[123]|V[35689]|V10|G3|V6X|A[34]|E3|F[123]|G4|M4|P2|S|V8C|A1(?:_1)?)(?:[);/ ]|$)",
                model: "VIA $1"
            },
            {
                regex: "CASPER_VIA_E1c",
                model: "VIA E1C"
            },
            {
                regex: "CASPER_L10_4.5G",
                model: "L10 4.5G",
                device: "tablet"
            },
            {
                regex: "CASPER_(S[23]8)(?:[);/ ]|$)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "VIA[- _](T7|T8D)-3G",
                model: "VIA $1 3G",
                device: "tablet"
            },
            {
                regex: "VIA[- _](T7D|S[13]0|[LS]8|S7|T17_M|T1[07]|T7|T8B|S1[78])(?:[);/ ]|$)",
                model: "VIA $1",
                device: "tablet"
            }
        ]
    },
    Cat: {
        regex: "Cat ?(tablet|stargate|nova)|B15Q|CAT B35|CAT-B100",
        device: "tablet",
        models: [
            {
                regex: "B15Q",
                model: "B15Q",
                device: "smartphone"
            },
            {
                regex: "CAT B35",
                model: "B35",
                device: "smartphone"
            },
            {
                regex: "Cat ?(?:tablet)? ?((?:Galactica|Nova|StarGate|PHOENIX)[^/;]*) Build",
                model: "$1"
            },
            {
                regex: "Cat ?tablet",
                model: "Nova"
            },
            {
                regex: "CAT-(B100)",
                device: "feature phone",
                model: "$1"
            }
        ]
    },
    Carrefour: {
        regex: "CT(?:10[0123]0|7[12]0|820)(?:W|FR)?(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "CT820",
                model: "Touch Tablet Neo2"
            },
            {
                regex: "CT(10[0123]0(?:W|FR)?)",
                model: "CT$1"
            },
            {
                regex: "CT(7[12]0(?:W|FR)?)",
                model: "CT$1"
            }
        ]
    },
    Celkon: {
        regex: "Celkon|Millennia Hero",
        device: "smartphone",
        models: [
            {
                regex: "Celkon[ _*](C[78]20)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Millennia Hero",
                model: "Millennia Hero"
            },
            {
                regex: "Celkon[ _*](CT[^;/]+) Build",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Celkon[ _*]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Celkon[\\. _*]([^;/\\)]+)[\\)/]",
                model: "$1"
            }
        ]
    },
    Changhong: {
        regex: "Changhong",
        device: "smartphone",
        models: [
            {
                regex: "Changhong[ ]?(X1-K|X6|R8|Z9S?|Z1S|S18)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "ChangHong Android TV",
                device: "tv",
                model: ""
            },
            {
                regex: "(?:Opera TV.+)Changhong-([^);/]+)",
                device: "tv",
                model: "$1"
            }
        ]
    },
    "Cherry Mobile": {
        regex: "Cherry|Superion S1 DTV|Flare([ _])?(2X|4|A[123]|J[123568]|P[13]|S[4-8]|X2|Y[367]|S Play|HD|LITE|XL|X_V2|Y3s|Tab)(?:[ _](?:Pro|Plus|Max|LTE))?|Fusion Bolt|Omega[_ ](?:Icon 2|Icon Lite 2|lite[_ ][43][Cs]?|HD [45]|HD_Duo)|Spin Max 2|Selfie_Two",
        device: "smartphone",
        models: [
            {
                regex: "(Flare2X)",
                model: "$1"
            },
            {
                regex: "Flare[_ ]HD[_ ]([345])",
                model: "Flare HD $1"
            },
            {
                regex: "Flare_HD_MAX",
                model: "Flare HD Max"
            },
            {
                regex: "FLARE LITE",
                model: "Flare Lite"
            },
            {
                regex: "Flare S Play",
                model: "Flare S Play"
            },
            {
                regex: "Flare[_ ]J([26])S",
                model: "Flare J$1s"
            },
            {
                regex: "Flare_(J2|S7)_Prime",
                model: "Flare $1 Prime"
            },
            {
                regex: "Flare_S7_Deluxe",
                model: "Flare S7 Deluxe"
            },
            {
                regex: "Flare_S7_Power",
                model: "Flare S7 Power"
            },
            {
                regex: "Flare[_ ]Y([367])[_ ]Pro",
                model: "Flare Y$1 Pro"
            },
            {
                regex: "Flare XL Plus",
                model: "Flare XL Plus"
            },
            {
                regex: "Flare[ _]X[_ ]V2",
                model: "Flare X V2"
            },
            {
                regex: "Flare[ _](A2|J3|P1|S[467])[ _]Lite",
                model: "Flare $1 Lite"
            },
            {
                regex: "Flare[ _](J[12]|S[57]|Y3|J6)[ _]mini",
                model: "Flare $1 Mini"
            },
            {
                regex: "Flare_J2_2018",
                model: "Flare J2 (2018)"
            },
            {
                regex: "Flare S4 Max LTE",
                model: "Flare S4 Max LTE"
            },
            {
                regex: "Flare[_ ](S[47]|J2)[_ ]Max",
                model: "Flare $1 Max"
            },
            {
                regex: "FlareS5LiteDTV",
                model: "Flare S5 Lite DTV"
            },
            {
                regex: "Flare[_ ](S[567]|J6)[_ ]Plus",
                model: "Flare $1 Plus"
            },
            {
                regex: "FLARE S6 POWER",
                model: "Flare S6 Power"
            },
            {
                regex: "Flare(?:[ _])?(4|A[123]|J8 LTE|J[13568]|P[13]|S[4-8]|X2|Y3s|Y7_LTE|Y[673])",
                model: "Flare $1"
            },
            {
                regex: "OMEGA HD ([45])",
                model: "Omega HD $1"
            },
            {
                regex: "Omega_HD_Duo",
                model: "Omega HD Duo"
            },
            {
                regex: "Omega Icon Lite 2",
                model: "Omega Icon Lite 2"
            },
            {
                regex: "Omega Icon 2",
                model: "Omega Icon 2"
            },
            {
                regex: "Omega[_ ]Lite[_ ](3[Cs]|4)",
                model: "Omega Lite $1"
            },
            {
                regex: "Spin Max 2",
                model: "Spin Max 2"
            },
            {
                regex: "Selfie_Two",
                model: "Selfie Two"
            },
            {
                regex: "(Fusion Bolt|Flare Tab Pro|Flare Tab|Superion S1 DTV)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Cherry(?:[ _]?Mobile)?[ _]?([^/;]+)(?: Build|[);])",
                model: "$1"
            }
        ]
    },
    "China Mobile": {
        regex: "(M812C|1501_M02|9930i|A1303|A309W|M651CY) Build",
        device: "smartphone",
        models: [
            {
                regex: "M651CY",
                model: "A3"
            },
            {
                regex: "(M812C|1501_M02|9930i|A1303|A309W)",
                model: "$1"
            }
        ]
    },
    Comio: {
        regex: "Comio|CT701G PLUS|CT701W|GT100",
        device: "smartphone",
        models: [
            {
                regex: "GT100",
                model: "GT100",
                device: "tablet"
            },
            {
                regex: "CT701W",
                model: "CT701W",
                device: "tablet"
            },
            {
                regex: "CT701G PLUS",
                model: "CT701G Plus",
                device: "tablet"
            },
            {
                regex: "Comio[ _-]?([^;/)]+)(?: Build|[);])",
                model: "$1"
            }
        ]
    },
    Compal: {
        regex: "Compal-[a-z0-9]+",
        device: "feature phone",
        model: "$1"
    },
    Artel: {
        regex: "Artel[_ ]|\\w+_ARTEL_\\w+|GAP YOQ(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "GAP YOQ(?:[);/ ]|$)",
                model: "Gap Yo Q"
            },
            {
                regex: "Artel[_ ](Quadro(?: Pro)?|Tesla|Air|Tomchi|Premium|U3_4G|Z5|Sentinel (?:X 8G|X D5|X)|T10)",
                model: "$1"
            },
            {
                regex: "Artel[_ ]Komi3",
                model: "Komi 3"
            },
            {
                regex: "Artel[_ ](Star|Nova|Connect|Choice|Style)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "(?:\\w+_)?ARTEL_([FVM]5|X[45])_\\w+",
                device: "feature phone",
                model: "$1"
            }
        ]
    },
    "ComTrade Tesla": {
        regex: "Tesla|Impulse 7.85 3G|Impulse 10.1 OCTA|Smartphone_6.1|SP(?:6.2|6.2_Lite)|TTL(?:713G|8)",
        device: "smartphone",
        models: [
            {
                regex: "TeslaEvo5.0",
                model: "Evo 5.0"
            },
            {
                regex: "(Gravity 9.7 SHD)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "(Impulse 7.85 3G)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Impulse 10.1 OCTA",
                model: 'Impulse 10.1" OCTA',
                device: "tablet"
            },
            {
                regex: "Tesla_SP([^/;]+)L Build",
                model: "Smartphone $1 Lite"
            },
            {
                regex: "Smartphone_6.1",
                model: "Smartphone 6.1"
            },
            {
                regex: "SP6.2_Lite",
                model: "Smartphone 6.2 Lite"
            },
            {
                regex: "Tesla_SP([^/;]+) Build",
                model: "Smartphone $1"
            },
            {
                regex: "SP([^/;]+) Build",
                model: "Smartphone $1"
            },
            {
                regex: "Smartphone ([36])",
                model: "Smartphone $1"
            },
            {
                regex: "Tesla_Tablet_785",
                model: '7.85"',
                device: "tablet"
            },
            {
                regex: "TTH7",
                model: "H7",
                device: "tablet"
            },
            {
                regex: "TTL7 Build",
                model: "L7",
                device: "tablet"
            },
            {
                regex: "Tesla_Tablet_L7_3G",
                model: "L7 3G",
                device: "tablet"
            },
            {
                regex: "(L7.1)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "TTL713G",
                model: "L7.1 3G",
                device: "tablet"
            },
            {
                regex: "(L7 Quad) Build",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "(L7 Quad Lite)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "TTL8 Build",
                model: "L8",
                device: "tablet"
            },
            {
                regex: "(L8.1)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "TESLA_TABLET_M7",
                model: "M7",
                device: "tablet"
            },
            {
                regex: "Tesla_Tablet_M8",
                model: "M8",
                device: "tablet"
            }
        ]
    },
    ConCorde: {
        regex: "ConCorde ([^/;]+) Build|Concorde_Raptor_Z55(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Concorde_(Raptor_Z55)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "ConCorde Tab ?([^/;]+) Build",
                model: "Tab $1",
                device: "tablet"
            },
            {
                regex: "ConCorde ReadMan ?([^/;]+) Build",
                model: "ReadMan $1",
                device: "tablet"
            },
            {
                regex: "ConCorde ([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    Condor: {
        regex: "Allure (?:M[13]|X)|Griffe T[2356789]|TFX712G|TRA-901G|TGW[-]?(710G|709)|(?:PGN\\-?[456][012][0-9]|PHS\\-601|PHQ519|PHQ52[056]|TB105L|TB717G|PKT\\-301|Plume (?:H1|L[1-468]|P8|P6 PRO LTE))(?:[);/ ]|$)|CTAB[^/;]+ Build",
        device: "smartphone",
        models: [
            {
                regex: "CTAB([^/;]+) Build",
                device: "tablet",
                model: "CTAB $1"
            },
            {
                regex: "(TGW)-?(710G|709)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1 $2"
            },
            {
                regex: "(TFX712G|TB105L|TB717G)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "(TRA)-(901G)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1 $2"
            },
            {
                regex: "PHS\\-601",
                model: "C8"
            },
            {
                regex: "PGN\\-?403",
                model: "C4+ Noir"
            },
            {
                regex: "PGN\\-?404",
                model: "C7 Mini"
            },
            {
                regex: "PGN\\-?409",
                model: "Plume P4"
            },
            {
                regex: "PKT\\-?301",
                model: "C2"
            },
            {
                regex: "PGN\\-?504",
                model: "C5"
            },
            {
                regex: "PGN\\-?505",
                model: "C8S"
            },
            {
                regex: "PGN\\-?506",
                model: "C7"
            },
            {
                regex: "(Allure (?:M[13]|X))",
                model: "$1"
            },
            {
                regex: "PGN\\-?507",
                model: "Allure A9"
            },
            {
                regex: "PGN\\-?508",
                model: "C6+"
            },
            {
                regex: "PGN\\-?509",
                model: "C6 Pro"
            },
            {
                regex: "PGN\\-?511",
                model: "Allure A9 Plus"
            },
            {
                regex: "PGN\\-?513",
                model: "Griffe G4"
            },
            {
                regex: "PHQ519",
                model: "Griffe G4S"
            },
            {
                regex: "PHQ520",
                model: "Griffe G5"
            },
            {
                regex: "PHQ525",
                model: "Griffe G6"
            },
            {
                regex: "PHQ526",
                model: "Griffe G6 Pro"
            },
            {
                regex: "PGN\\-?514",
                model: "Plume P7"
            },
            {
                regex: "PGN\\-?515",
                model: "Plume P4 Pro"
            },
            {
                regex: "PGN\\-?516",
                model: "Plume P5"
            },
            {
                regex: "PGN\\-?51[78]",
                model: "Plume P6"
            },
            {
                regex: "PGN\\-?521",
                model: "Griffe G4 Plus"
            },
            {
                regex: "Griffe T3 ?pro",
                model: "Griffe T3 Pro"
            },
            {
                regex: "Griffe T([0-9]) Plus",
                model: "Griffe T$1 Plus"
            },
            {
                regex: "Griffe T([0-9])",
                model: "Griffe T$1"
            },
            {
                regex: "PGN\\-?522",
                model: "P6 Plus"
            },
            {
                regex: "PGN\\-?523",
                model: "P7 Plus"
            },
            {
                regex: "PGN\\-?527",
                model: "Plume P4 Plus"
            },
            {
                regex: "PGN\\-?528|PLUME P6 PRO LTE",
                model: "Plume P6 Pro LTE"
            },
            {
                regex: "PGN\\-?605",
                model: "Plume P8"
            },
            {
                regex: "PGN\\-?606",
                model: "Allure A55"
            },
            {
                regex: "PGN\\-?607",
                model: "Allure A100"
            },
            {
                regex: "PGN\\-?608",
                model: "Allure A55 Slim"
            },
            {
                regex: "PGN\\-?609",
                model: "Allure A100 Lite"
            },
            {
                regex: "PGN\\-?610",
                model: "Plume P8 Lite"
            },
            {
                regex: "PGN\\-?611",
                model: "Allure A8"
            },
            {
                regex: "PGN\\-?612",
                model: "Allure A8 Plus"
            },
            {
                regex: "PGN\\-?613",
                model: "Allure A55 Plus"
            },
            {
                regex: "Plume H1",
                model: "Plume H1"
            },
            {
                regex: "Plume L([2468]) Pro",
                model: "Plume L$1 Pro"
            },
            {
                regex: "Plume L3 Plus",
                model: "Plume L3 Plus"
            },
            {
                regex: "Plume L3 Smart",
                model: "Plume L3 Smart"
            },
            {
                regex: "Plume L([1-4])",
                model: "Plume L$1"
            },
            {
                regex: "Plume P8 Pro",
                model: "Plume P8 Pro"
            },
            {
                regex: "PGN\\-?([0-9]{3})",
                model: "PGN-$1"
            }
        ]
    },
    Coolpad: {
        regex: "(?:YL-)?Coolpad|(?:Cool_9S|1824-S0|8190Q|1831-A0|8676-[AM]01|CP8298_I00|CP3648A|CP8676_I0[23]|REVVLPLUS C3701A|VCR-[AI]0|C105-E0|C106-[79]| C106|MTS-T0|cp3705A[S]?|ORL-C0|DLS-E0|8298-M02|5560S)(?:[);/ ]|$)|(8295|5860S) Build",
        device: "smartphone",
        models: [
            {
                regex: "VCR-[AI]0",
                model: "Cool Play 6"
            },
            {
                regex: "1831-A0(?:[);/ ]|$)",
                model: "Cool Play C7"
            },
            {
                regex: "REVVLPLUS C3701A",
                model: "REVVL Plus",
                device: "phablet"
            },
            {
                regex: "8190Q(?:[);/ ]|$)",
                model: "8190Q"
            },
            {
                regex: "DLS-E0(?:[);/ ]|$)",
                model: "N5"
            },
            {
                regex: "1824-S0(?:[);/ ]|$)",
                model: "N5C"
            },
            {
                regex: "CP3705A[S]?(?:[);/ ]|$)",
                model: "Legacy"
            },
            {
                regex: "CP3648A(?:[);/ ]|$)",
                model: "Legacy S"
            },
            {
                regex: "MTS-T0(?:[);/ ]|$)",
                model: "N2M"
            },
            {
                regex: "C106-[79](?:[);/ ]|$)",
                model: "Cool 1"
            },
            {
                regex: "C105-E0(?:[);/ ]|$)",
                model: "Cool S1"
            },
            {
                regex: "ORL-C0(?:[);/ ]|$)",
                model: "Cool 9"
            },
            {
                regex: "Cool_9S(?:[);/ ]|$)",
                model: "Cool 9S"
            },
            {
                regex: "5560S(?:[);/ ]|$)",
                model: "Arise"
            },
            {
                regex: "(5860S|8295) Build",
                model: "$1"
            },
            {
                regex: "CP8676_I02(?:[);/ ]|$)",
                model: "Note 3"
            },
            {
                regex: "CP8676_I03(?:[);/ ]|$)",
                model: "Note 3 Plus"
            },
            {
                regex: "CP8298_I00(?:[);/ ]|$)",
                model: "Note 3 Lite"
            },
            {
                regex: "(8676-[AM]01|8298-M02)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(?:YL-)?Coolpad[ _\\-]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "(?:YL-)?Coolpad[ _\\-]?([a-z0-9\\-]+)",
                model: "$1"
            }
        ]
    },
    Clarmin: {
        regex: "Clarmin",
        device: "smartphone",
        models: [
            {
                regex: "Clarmin[_ ](B[65]|C1)",
                model: "$1"
            }
        ]
    },
    CORN: {
        regex: "CORN ",
        device: "smartphone",
        models: [
            {
                regex: "CORN R20",
                model: "R20"
            }
        ]
    },
    Cosmote: {
        regex: "Cosmote",
        device: "smartphone",
        models: [
            {
                regex: "Cosmote_My_mini_Tab",
                device: "tablet",
                model: "My Mini Tab"
            }
        ]
    },
    Cricket: {
        regex: "Cricket-([a-z0-9]+)|U705AC(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "U705AC",
                model: "Ovation"
            },
            {
                regex: "Cricket-([a-z0-9]+)",
                device: "feature phone",
                model: "$1"
            }
        ]
    },
    "Crius Mea": {
        regex: "(Q7A\\+?)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Crosscall: {
        regex: "Crosscall|ODYSSEY_Plus|Odyssey S1|Trekker-[MSX][1234]|Action-X3|Core-X3",
        device: "smartphone",
        models: [
            {
                regex: "Action-X3",
                model: "Action-X3"
            },
            {
                regex: "Core-X3",
                model: "Core-X3"
            },
            {
                regex: "Crosscall ([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "ODYSSEY_Plus",
                model: "ODYSSEY+"
            },
            {
                regex: "Odyssey S1",
                model: "ODYSSEY S1"
            },
            {
                regex: "Trekker-([MSX][1234](?: Core)?)",
                model: "Trekker-$1"
            }
        ]
    },
    AllDocube: {
        regex: "(?:T1001XS?|T1006S?|iPlay_[24]0|U1006H?)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "T1001XS(?:[);/ ]|$)",
                model: "M5XS"
            },
            {
                regex: "T1006S(?:[);/ ]|$)",
                model: "M5S"
            },
            {
                regex: "T1006(?:[);/ ]|$)",
                model: "M5"
            },
            {
                regex: "T1001X(?:[);/ ]|$)",
                model: "M5X"
            },
            {
                regex: "U1006H?(?:[);/ ]|$)",
                model: 'iPlay 10 Pro 10.1"'
            },
            {
                regex: "iPlay_([24]0)(?:[);/ ]|$)",
                model: "iPlay $1"
            }
        ]
    },
    Cube: {
        regex: "(<!myPhone ?)Cube|(U[0-9]+GT|K8GT)|(?:T8-PLUSM?S?|T8PLUSML|I1-TF[BD]?|I1-TC|i1002S|Iwork10 Flagship|iwork10 Pro)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "U27GT",
                model: "Talk 8"
            },
            {
                regex: "(?:T8-PLUSM?S?|T8PLUSML)(?:[);/ ]|$)",
                model: "T8 Ultimate"
            },
            {
                regex: "U55GT",
                model: "Talk 79"
            },
            {
                regex: "U65GT",
                model: "Talk 9X"
            },
            {
                regex: "I1-TF[BD]?(?:[);/ ]|$)",
                model: "iWork 8 Air"
            },
            {
                regex: "I1-TC(?:[);/ ]|$)",
                model: "iWork 8 Ultimate"
            },
            {
                regex: "(?:i1002S|iwork10 Pro)(?:[);/ ]|$)",
                model: "iWork 10 Pro"
            },
            {
                regex: "Iwork10 Flagship(?:[);/ ]|$)",
                model: "iWork 10 Flagship"
            },
            {
                regex: "(U[0-9]+GT[^;/]*) Build",
                model: "$1"
            },
            {
                regex: "(U[0-9]+GT(?:[0-9]|[\\-_][a-z]+)?)",
                model: "$1"
            },
            {
                regex: "(K8GT)",
                model: "$1"
            }
        ]
    },
    CUBOT: {
        regex: "CUBOT|RAINBOW 2|KING_KONG_3|ZORRO 001|KINGKONG[_ ]MINI2?|KING KONG CS|(?<!QUMO )QUEST(?!(?:[0-9]|\\s[0-9]))(?: LITE)?|NOTE 20 PRO",
        device: "smartphone",
        models: [
            {
                regex: "CHEETAH 2",
                model: "Cheetah 2"
            },
            {
                regex: "RAINBOW 2",
                model: "Rainbow 2"
            },
            {
                regex: "RAINBOW",
                model: "Rainbow"
            },
            {
                regex: "DINOSAUR",
                model: "Dinosaur"
            },
            {
                regex: "KINGKONG MINI2",
                model: "King Kong Mini 2"
            },
            {
                regex: "KINGKONG_MINI",
                model: "King Kong Mini"
            },
            {
                regex: "KING_KONG_3",
                model: "King Kong 3"
            },
            {
                regex: "KING KONG CS",
                model: "King Kong CS"
            },
            {
                regex: "KING KONG",
                model: "King Kong"
            },
            {
                regex: "QUEST LITE",
                model: "Quest Lite"
            },
            {
                regex: "QUEST",
                model: "Quest"
            },
            {
                regex: "ZORRO 001",
                model: "Zorro 001"
            },
            {
                regex: "CUBOT[ _]Echo",
                model: "Echo"
            },
            {
                regex: "CUBOT[ _]MANITO",
                model: "Manito"
            },
            {
                regex: "CUBOT[ _]MAGIC",
                model: "Magic"
            },
            {
                regex: "CUBOT[ _]MAX",
                model: "Max"
            },
            {
                regex: "NOTE Plus",
                model: "Note Plus"
            },
            {
                regex: "NOTE 20 PRO",
                model: "Note 20 Pro"
            },
            {
                regex: "CUBOT[_ ]NOTE[_ ]S",
                model: "Note S"
            },
            {
                regex: "CUBOT_NOVA",
                model: "Nova"
            },
            {
                regex: "CUBOT_POWER",
                model: "Power"
            },
            {
                regex: "CUBOT_X18_Plus",
                model: "X18 Plus"
            },
            {
                regex: "CUBOT[ _](A5|C6W|H3|J3|P7|P20|[RXJ]9|R11|X18)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "CUBOT ([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "([^;/]+) Build/CUBOT",
                model: "$1"
            }
        ]
    },
    Clout: {
        regex: "Hind[ _]5\\.1|X417[ _]Amaze|X418[ _]Zest|X421[ _]Nova|X422[ ]Exotic|X425[ _]Shavit|X428[ _]Astute",
        device: "smartphone",
        models: [
            {
                regex: "Hind[ _]5\\.1",
                model: "Hind 5.1"
            },
            {
                regex: "X417[ _]Amaze",
                model: "X417 Amaze"
            },
            {
                regex: "X418[ _]Zest",
                model: "X418 Zest"
            },
            {
                regex: "X421[ _]Nova",
                model: "X421 Nova"
            },
            {
                regex: "X422[ _]Exotic",
                model: "X422 Exotic"
            },
            {
                regex: "X425[ _]Shavit",
                model: "X425 Shavit"
            },
            {
                regex: "X428[ _]Astute",
                model: "X428 Astute"
            }
        ]
    },
    Concord: {
        regex: "Concord[ _-]|(?:Flyfix 6|C-721|Plus-7_C777|Plus_M19_C779|Plus-9_C778)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "M10",
                model: "M10"
            },
            {
                regex: "Flyfix 6",
                model: "Flyfix 6"
            },
            {
                regex: "C-721",
                model: "Flyfix Q",
                device: "tablet"
            },
            {
                regex: "Plus[-_]([79]|M19)_(C77[789])(?:[);/ ]|$)",
                model: "Plus-$1 $2",
                device: "tablet"
            }
        ]
    },
    Crescent: {
        regex: "WING 5|WING9|Venus[ _][14]",
        device: "smartphone",
        models: [
            {
                regex: "WING 5",
                model: "Wing 5"
            },
            {
                regex: "WING9",
                model: "Wing 9"
            },
            {
                regex: "Venus[ _]([14])",
                model: "Venus $1"
            }
        ]
    },
    Cyrus: {
        regex: "Cyrus[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "Cyrus[ _-]?([^;/)]+) Build",
                model: "$1"
            },
            {
                regex: "Cyrus[ _-]?([^;/)]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Datang: {
        regex: "DATANG",
        device: "smartphone",
        models: [
            {
                regex: "(?:DATANG[ _-])+([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "(?:DATANG[ _-])+([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            }
        ]
    },
    Datsun: {
        regex: "DATSUN",
        device: "smartphone",
        models: [
            {
                regex: "DATSUN_D5500",
                model: "D5500"
            },
            {
                regex: "Datsun_D5001",
                model: "D5001"
            }
        ]
    },
    Danew: {
        regex: "Dslide ?([^;/]+) Build|Konnect_?(?:402|50[246]|60[127])|GEODROID_A5",
        device: "smartphone",
        models: [
            {
                regex: "Konnect_?(402|50[246]|60[127])",
                model: "Konnect $1"
            },
            {
                regex: "Dslide ?([^;/]+) Build",
                device: "tablet",
                model: "DSlide $1"
            },
            {
                regex: "GEODROID_A5",
                device: "tablet",
                model: "Geodroid A5"
            }
        ]
    },
    Denver: {
        regex: "(?:TA[CDQ]-[0-9]+)|P(?:.+)TAQ-(?:[0-9]+)|SDQ[_-](?:550[24]4L|52001G|50002G|57004L)",
        device: "tablet",
        models: [
            {
                regex: "P(?:.+)TAQ-(10213GMK2|10172MK3|10242MK2|70242MK2|[0-9]+)(?:[);/ ]|$)",
                model: "TAQ-$1"
            },
            {
                regex: "(TA[CDQ]-[0-9]+)",
                model: "$1"
            },
            {
                regex: "SDQ[_-](550[24]4L|52001G|50002G|57004L)",
                device: "smartphone",
                model: "SDQ-$1"
            }
        ]
    },
    Dell: {
        regex: "Dell[^a-z]|Venue|XCD35",
        device: "smartphone",
        models: [
            {
                regex: "XCD35",
                model: "XCD35"
            },
            {
                regex: "Venue (8 7840|10 7040|8 3830)",
                model: "Venue $1",
                device: "tablet"
            },
            {
                regex: "(?:Dell )?Venue Build",
                model: "Venue"
            },
            {
                regex: "Dell; Venue Pro",
                model: "Venue Pro"
            },
            {
                regex: "(OptiPlex (?:3050|7010))",
                device: "desktop",
                model: "$1"
            },
            {
                regex: "(?:Dell )?(Streak|Venue) ?([^/;]*) Build",
                model: "$1 $2",
                device: "tablet"
            },
            {
                regex: "(?:Dell Inc./)?(XPS 13 9360|Latitude 7480)(?:[);/ ]|$)",
                device: "desktop",
                model: "$1"
            },
            {
                regex: "Dell; ((?:Streak|Venue)[^;/\\)]*)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Dell; ([^;/\\)]+)",
                model: "$1"
            },
            {
                regex: "Dell[ _\\-]([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    Desay: {
        regex: "Desay",
        device: "smartphone",
        models: [
            {
                regex: "Desay[ _-]?([^;/)]+) Build",
                model: "$1"
            },
            {
                regex: "Desay[ _-]?([^;/)]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    DEXP: {
        regex: "DEXP|(?:Ursus|Ixion)[ _]([^;/)]+)|H135[ _]Build|Larus_TV1|Ixion(?:ML4.7|ES250)|M150Storm|(?:SENIOR|F4[38]D8000K|VA[12]10|VA170|ML450|MS[56]50|BL[123]50|BS155|BS160|BS[1256]50|AL[12]40|AL[23]50|AS155|AS260|GS15[035]| (?:N280i|P380i|R110|BL160|B450|B340|A1[45]0|A340|AS160|GL[23]55|ES750))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Ixion[_ ]([^;/]+)(?: Build|\\))",
                model: "Ixion $1"
            },
            {
                regex: "(ML450|MS[56]50|ES750)(?:[);/ ]|$)",
                model: "Ixion $1"
            },
            {
                regex: "IxionES250(?:[);/ ]|$)",
                model: "Ixion ES250 Rage"
            },
            {
                regex: "IxionML4.7(?:[);/ ]|$)",
                model: 'Ixion ML 4.7"'
            },
            {
                regex: "M150Storm(?:[);/ ]|$)",
                model: "Ixion M150 Storm"
            },
            {
                regex: "AL250(?:[);/ ]|$)",
                model: '4.5" AL250'
            },
            {
                regex: "AL350(?:[);/ ]|$)",
                model: '5.0" AL350'
            },
            {
                regex: "AS155(?:[);/ ]|$)",
                model: '5.45" AS155'
            },
            {
                regex: "AS260(?:[);/ ]|$)",
                model: '5.85" AS260',
                device: "phablet"
            },
            {
                regex: "Ursus ([^;/)]+)(?: Build|\\))",
                model: "Ursus $1",
                device: "tablet"
            },
            {
                regex: "(VA[21]10|VA170|R110|N280i|P380i)(?:[);/ ]|$)",
                model: "Ursus $1",
                device: "tablet"
            },
            {
                regex: " (B450|B340|BL160|A340)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "SENIOR(?:[);/ ]|$)",
                model: "Senior"
            },
            {
                regex: "Larus_TV1",
                device: "feature phone",
                model: "Larus_TV1"
            },
            {
                regex: "H135[ _]Build",
                model: "Atlas",
                device: "desktop"
            },
            {
                regex: "(BL[123]50|BS155|BS160|BS[1256]50|AL[12]40|A1[45]0|GS15[035]|AS160|GL[23]55)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "DEXP[ _]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "DEXP[ _]([^);/]+)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(F4[38]D8000K)(?:[);/ ]|$)",
                device: "tv",
                model: "$1"
            }
        ]
    },
    Dbtel: {
        regex: "DBTEL(?:[\\-/])?([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Dialog: {
        regex: "Dialog ?([^;/]+) Build",
        device: "smartphone",
        model: "$1"
    },
    Dicam: {
        regex: "DICAM-([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Digi: {
        regex: "(?<!FBCR/)Digi[ _]([^);/]+)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Digicel: {
        regex: "DIGICEL",
        device: "smartphone",
        models: [
            {
                regex: "DL810",
                model: "DL810"
            },
            {
                regex: "DIGICEL ([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    Digiland: {
        regex: "(?:DL1008M|DL(?:1023|9002|[78]006))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "DL1008M",
                model: "DL1008M"
            },
            {
                regex: "DL(1023|9002|[78]006)",
                model: "DL$1"
            }
        ]
    },
    Digma: {
        regex: "Digma[_ ]([^;/]+) Build|HIT HT707[10]MG|CITI (?:7 E401 4G|8 E400 4G|ATL 4G|Kids|Octa [178]0|1902 3G|10 E402|Z530 3G)|(CITI[_ ](?:[A-Z0-9]+)[_ ][34]G)[ _][TC][ST](606[32]ML|111[46]ML|11[459]4MG|1117PG|1207MG|1210MG|1195MG|1196ML|3001ML|4024PG|5009PL|5021ML|5026PL|500[67]PG|7052PG|706[56]MG|709[68]PL|7097MG|720[48]MG|7140ML|7141MG|7113PL|7193MG|820[69]MG|7153MG|8139ML|8143MG|8152ML|1050PL|8205PG|7203MG|106[24]ML|1115MG)|HIT 4G|HT7074ML|IDX5|(iDx10|iDx7)|MVM900H(?:WZ|C)|MVM908HCZ|(iDxD8 3G|iDxD10 3G|iDrQ10 3G|iDxD[45]|iDxQ5|iD[nx]D7(?:[_ ]3G)?)|PS604M|PT452E|LINX B510 3G LT5037MG|LINX A452 3G LT4030PG|LINX A453 3G LT4038PG|LINX A420 3G LS4019PG|LINX A450 3G LT4028PG|Linx A400 3G LT4001PG|Linx C500 3G LT5001PG|Linx PS474S|LS504[01]PL|LT40(47|54)MG|PS1043MG|LS405[01]MG|LS5053ML|LT5048MG|HT7071MG|LT5052ML|HT5035PG|HT4039PG|LT4049PG|NS6902QL|NS9797MG|TS7854M|TS1012E 3G|TT1004PG|TT702[045]MG|TT1002MG|TT7026MW|((?:Optima|Platina|Plane)[ _](?:[EM])?(?:[0-9\\.ST]+|Prime)(?:[ _][43]G)?)|(VOX[ _](?:[0-9\\.A-Z]+)[_ ][43]G)",
        device: "smartphone",
        models: [
            {
                regex: "HIT(?: 3G)? HT707[10]MG",
                model: "HIT 3G",
                device: "tablet"
            },
            {
                regex: "iDx5",
                model: "iDx5"
            },
            {
                regex: "HT5035PG",
                model: "HIT Q500 3G"
            },
            {
                regex: "HT4039PG",
                model: "HIT Q401 3G"
            },
            {
                regex: "(VOX[ _](?:[0-9\\.A-Z]+)[_ ][43]G)",
                model: "$1"
            },
            {
                regex: "PS604M",
                model: "Linx 6.0"
            },
            {
                regex: "LT4049PG",
                model: "Linx Atom 3G"
            },
            {
                regex: "LT5048MG",
                model: "Linx Joy 3G"
            },
            {
                regex: "LT5052ML",
                model: "Linx Base 4G"
            },
            {
                regex: "LT4047MG",
                model: "Linx Alfa 3G"
            },
            {
                regex: "LS4050MG",
                model: "Linx X1 3G"
            },
            {
                regex: "LS4051MG",
                model: "Linx X1 Pro 3G"
            },
            {
                regex: "LT4054MG",
                model: "Linx Argo 3G"
            },
            {
                regex: "LS5041PL",
                model: "Linx Trix 4G"
            },
            {
                regex: "LS5040PL",
                model: "Linx Rage 4G"
            },
            {
                regex: "LS5053ML",
                model: "Linx Pay 4G"
            },
            {
                regex: "Linx ([A-Z][0-9]{3}) 3G (?:LT4028PG|LS4019PG|LT4001PG|LT5001PG|LT4038PG|LT5037MG|LT4030PG)",
                model: "Linx $1 3G"
            },
            {
                regex: "(Linx PS474S)",
                model: "$1"
            },
            {
                regex: "PT452E",
                model: "Linx 4.5"
            },
            {
                regex: "CITI ATL 4G CS5029ML",
                model: "CITI ATL 4G"
            },
            {
                regex: "(CITI Z530 3G)",
                model: "$1"
            },
            {
                regex: "(CITI [A-Z0-9]+ [34]G) C[ST](?:606[32]ML|4024PG|5009PL|5021ML|5026PL)",
                model: "$1"
            },
            {
                regex: "TS7854M",
                model: 'Plane 8.1" 3G',
                device: "tablet"
            },
            {
                regex: "PS1043MG",
                model: 'Plane 10.3" 3G',
                device: "tablet"
            },
            {
                regex: "TS1012E 3G",
                model: 'Plane 10.1" 3G',
                device: "tablet"
            },
            {
                regex: "MVM900H(?:WZ|C)",
                model: "iDx8",
                device: "tablet"
            },
            {
                regex: "MVM908HCZ",
                model: "iDx9",
                device: "tablet"
            },
            {
                regex: "(iD(?:xD10|rQ10|xD7)[_ ]3G)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "(iDx10|iDx7)",
                model: "$1"
            },
            {
                regex: "(iDxD[45]|iDxQ5)",
                model: "$1"
            },
            {
                regex: "HIT 4G HT7074ML",
                model: "HIT 4G",
                device: "tablet"
            },
            {
                regex: "CITI[_ ](1902 3G|Kids|8527_4G|Octa [178]0|10 E402 4G|8 E400 4G|7 E401 4G)",
                model: "CITI $1",
                device: "tablet"
            },
            {
                regex: "(CITI[ _](?:[A-Z0-9]+)[ _][34]G)[ _][TC][ST](?:106[24]ML|111[46]ML|1115MG|1117PG|1207MG|1210MG|3001ML|500[67]PG|7052PG|706[567]MG|7097MG|720[48]MG|820[69]MG|11[459]4MG|1195MG|1196ML|3001ML|8152ML|1050PL|709[68]PL|7113PL|7193MG|7216MG|8205PG|7203MG|8143MG|7153MG|7141MG|7140ML)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "iDxD8 3G",
                model: "D-Plane2 8",
                device: "tablet"
            },
            {
                regex: "(iDnD7)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "NS6902QL",
                model: "Platina 7.2 4G",
                device: "tablet"
            },
            {
                regex: "NS9797MG",
                model: "Platina 7.2 3G",
                device: "tablet"
            },
            {
                regex: "TT1004PG",
                model: 'Optima 10.4" 3G',
                device: "tablet"
            },
            {
                regex: "TT1002MG",
                model: 'Optima D 10.4" 3G',
                device: "tablet"
            },
            {
                regex: "TT7025MG",
                model: 'Optima 7.5" 3G',
                device: "tablet"
            },
            {
                regex: "TT7026MW",
                model: 'Optima 7.6" 3G',
                device: "tablet"
            },
            {
                regex: "TT7020MG",
                model: 'Optima 7.3" 3G',
                device: "tablet"
            },
            {
                regex: "TT7024MG",
                model: 'Optima 7.4" 3G',
                device: "tablet"
            },
            {
                regex: "((?:Optima|Platina|Plane)[ _](?:[EM])?(?:[0-9\\.STNM]+|Prime)(?:[ _][43]G)?)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Digma[_ ]([^;/]+) Build",
                model: "$1",
                device: "tablet"
            }
        ]
    },
    DoCoMo: {
        regex: "DoCoMo|\\;FOMA|KGT/1\\.0",
        device: "feature phone",
        models: [
            {
                regex: "DoCoMo/.+MST.+(SH2101V)",
                model: "$1"
            },
            {
                regex: "DoCoMo/[12]\\.0[/ ]([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "([a-z0-9]+)(?:_W)?\\;FOMA",
                model: "$1"
            },
            {
                regex: "KGT/1\\.0 ([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Doogee: {
        regex: "DOOGEE[ _-]|Valencia2_Y100_?(?:pro|plus)|Y100_Plus|X5max(?:[_ ]PRO)?|Shoot_[12]|x5_doogee|(KISSME|BIGBOY|COLLO[23]?|DAGGER|DISCOVERY2?|FIND|HOTWIND|LATTE|MAX|MINT|MOON|PIXELS|RAINBOX|TURBO|VALENCIA|VOYAGER2?|TITANS2?)[ -_](DG[0-9]+C?)(?:[);/ ]|$)|(?:BL12000|BL5500[_ ]Lite|X9 Mini|LEO_DG280|Y9Plus|Hitman_DG850|S(?:[568]8|9[056]|59|40)Pro|X95Pro|S40Lite|BL[579]000|N20Pro|(?<!Lenovo )S90C|Ibiza_F2)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:Valencia2_)?Y100_Plus(?:[);/ ]|$)",
                model: "Valencia2 Y100 Plus"
            },
            {
                regex: "Valencia2_Y100pro",
                model: "Valencia2 Y100 Pro"
            },
            {
                regex: "LEO_(DG280)",
                model: "Leo $1"
            },
            {
                regex: "(BL[579]000|S90C)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "X95Pro(?:[);/ ]|$)",
                model: "X95 Pro"
            },
            {
                regex: "N20Pro(?:[);/ ]|$)",
                model: "N20 Pro"
            },
            {
                regex: "BL12000 PRO",
                model: "BL12000 Pro"
            },
            {
                regex: "BL5500[_ ]Lite",
                model: "BL5500 Lite"
            },
            {
                regex: "BL12000",
                model: "BL12000"
            },
            {
                regex: "S([568]8|9[056]|59|40)Pro",
                model: "S$1 Pro"
            },
            {
                regex: "S40Lite",
                model: "S40 Lite"
            },
            {
                regex: "KISSME-DG580",
                model: "Kissme DG580"
            },
            {
                regex: "Hitman_DG850",
                model: "Hitman DG580"
            },
            {
                regex: "X9 Mini",
                model: "X9 Mini"
            },
            {
                regex: "x5_doogee",
                model: "X5"
            },
            {
                regex: "Shoot_([12])",
                model: "Shoot $1"
            },
            {
                regex: "Ibiza_F2",
                model: "Ibiza F2"
            },
            {
                regex: "(X5max(?:[_ ]PRO)?)",
                model: "$1"
            },
            {
                regex: "(?:DOOGEE[ _-])?(BIGBOY|COLLO[23]?|DAGGER|DISCOVERY2?|FIND|HOTWIND|LATTE|MAX|MINT|MOON|PIXELS|RAINBOX|TURBO|VALENCIA|Valencia2_Y100pro|VOYAGER2?|TITANS2?)[ -_](DG[0-9]+C?)(?:[);/ ]|$)",
                model: "$1 $2"
            },
            {
                regex: "DOOGEE[ _-]([^);/]+) Build",
                model: "$1"
            },
            {
                regex: "DOOGEE[ _-]([^);/]+)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Y9Plus(?:[);/ ]|$)",
                model: "Y9 Plus"
            }
        ]
    },
    Doov: {
        regex: "(?:Doov-)?Doov[ _]",
        device: "smartphone",
        models: [
            {
                regex: "(?:Doov-)?Doov[ _]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "(?:Doov-)?Doov[ _]([^);/]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Dopod: {
        regex: "Dopod(?: )?([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Doro: {
        regex: "Doro",
        device: "smartphone",
        models: [
            {
                regex: "Doro[ _-]?([^;/)]+) Build",
                model: "$1"
            },
            {
                regex: "Doro[ _-]([0-9a-z]+)",
                model: "$1"
            }
        ]
    },
    "Dune HD": {
        regex: "DuneHD|SOLO 4K(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "SOLO 4K(?:[);/ ]|$)",
                model: "Solo 4k"
            },
            {
                regex: "DuneHD/\\d.\\d \\([a-z]+__([a-z0-9_-]+);",
                model: "$1"
            },
            {
                regex: "DuneHD/\\d.\\d \\(([a-z0-9_-]+);",
                model: "$1"
            }
        ]
    },
    DNS: {
        regex: "(?:DNS|AirTab)[ _\\-]([^;/)]+)|(?:S4505M|S4004M|SD01M)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:DNS[_ ])?(S4505M|S4004M|SD01M|S4502|S4003|S4003)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "AirTab[ _\\-]([^;/]+)(?: Build|[);])",
                model: "AirTab $1",
                device: "tablet"
            },
            {
                regex: "DNS[ _\\-]([^;/]+)(?: Build|[);])",
                model: "$1"
            }
        ]
    },
    "E-Boda": {
        regex: "E-Boda|Eclipse_(?:G400M|G500)",
        device: "smartphone",
        models: [
            {
                regex: "E-Boda ((?:Revo|Izzycomm|Essential|Intelligence|Supreme)[^/;]+) Build",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "Eclipse_(G400M|G500)",
                model: "Eclipse $1"
            },
            {
                regex: "E-Boda ([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    Easypix: {
        regex: "EasyPad|EasyPhone",
        device: "smartphone",
        models: [
            {
                regex: "(EasyPhone[^/;]+) Build",
                model: "$1"
            },
            {
                regex: "EasyPad ([^/;)]+)(?: Build|[;)])",
                model: "EasyPad $1",
                device: "tablet"
            }
        ]
    },
    EBEST: {
        regex: "EBEST",
        device: "smartphone",
        models: [
            {
                regex: "EBEST[ _-]?([^;/)]+) Build",
                model: "$1"
            },
            {
                regex: "EBEST[ _-]?([^;/)]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    "Echo Mobiles": {
        regex: "ECHO[ _](HOLI|HORIZON|MAX|MOSS|NOTE|POWER|SMART|DUNE|JAVA|FUSION)|HORIZON_M|Stellar 3G|FEELING",
        device: "smartphone",
        models: [
            {
                regex: "ECHO_HORIZON_LITE",
                model: "HORIZON Lite"
            },
            {
                regex: "(HORIZON_M|FEELING)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "STELLAR 3G",
                model: "STELLAR 3G"
            },
            {
                regex: "ECHO_SMART_4G",
                model: "SMART 4G"
            },
            {
                regex: "ECHO[ _](HOLI|MAX|MOSS|NOTE|POWER|SMART|DUNE|JAVA|FUSION)",
                model: "$1"
            }
        ]
    },
    ECS: {
        regex: "(?:TA10CA3|TM105A?|TR10[CR]S1)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "TA10CA3(?:[);/ ]|$)",
                model: "TA10CA3"
            },
            {
                regex: "(TR10[CR]S1)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "TM105A(?:[);/ ]|$)",
                model: "TM105A"
            },
            {
                regex: "TM105(?:[);/ ]|$)",
                model: "TM105"
            }
        ]
    },
    EE: {
        regex: "Hawk_from_EE",
        device: "smartphone",
        models: [
            {
                regex: "Hawk_from_EE",
                model: "Hawk"
            }
        ]
    },
    EKT: {
        regex: "EK-(?:5040|5336|5540|5937|6020|8680|MII|T7020)",
        device: "tablet",
        models: [
            {
                regex: "EK-(MII|T7020)",
                model: "EK-$1"
            },
            {
                regex: "EK-(5040|5336|5540|5937|6020|8680)",
                device: "smartphone",
                model: "EK-$1"
            }
        ]
    },
    "Eks Mobility": {
        regex: "S5LS|X4UPlus",
        device: "smartphone",
        models: [
            {
                regex: "S5LS",
                model: "S5LS"
            },
            {
                regex: "X4UPlus",
                model: "X4U Plus"
            }
        ]
    },
    Elephone: {
        regex: "Elephone|P6000( ?Pro| ?Plus|\\+| ?02| 5.0 01)?",
        device: "smartphone",
        models: [
            {
                regex: "Elephone Trunk(?:[);/ ]|$)",
                model: "Trunk"
            },
            {
                regex: "P6000(\\+| ?Plus)(?:[);/ ]|$)",
                model: "P6000 Plus"
            },
            {
                regex: "P6000 02(?:[);/ ]|$)",
                model: "P6000 02"
            },
            {
                regex: "P6000 5.0 01(?:[);/ ]|$)",
                model: "P6000 01"
            },
            {
                regex: "P6000 ?Pro(?:[);/ ]|$)",
                model: "P6000 Pro"
            },
            {
                regex: "(?:Elephone[ _])?(P[768]000|S2)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Elephone[ _\\-]([^/;]+)(?: Build|[;)])",
                model: "$1"
            }
        ]
    },
    Element: {
        regex: "AFTRS",
        model: "Element 4K (2017)",
        device: "tv"
    },
    Elenberg: {
        regex: "(TAB(?:101|728)[ _]3G|TAB7(?:[03]8|16|40|3[30]))(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Ericy: {
        regex: "Ericy-([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Essential: {
        regex: "PH-1[ )]",
        device: "smartphone",
        models: [
            {
                regex: "PH-1[ )]",
                model: "PH-1"
            }
        ]
    },
    "E-tel": {
        regex: "E-tel_i250",
        device: "smartphone",
        models: [
            {
                regex: "E-tel[_ ]i250",
                model: "i250"
            }
        ]
    },
    Evercoss: {
        regex: "EVERCOSS[ _]|(A75A\\*|U50A_PLUS|M50 STAR|A75 MAX)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "A75A\\*(?:[);/ ]|$)",
                model: "A75A Star"
            },
            {
                regex: "A75 MAX*(?:[);/ ]|$)",
                model: "A75 Max"
            },
            {
                regex: "U50A_PLUS(?:[);/ ]|$)",
                model: "U50A Plus"
            },
            {
                regex: "M50 STAR(?:[);/ ]|$)",
                model: "M50 Star"
            },
            {
                regex: "EVERCOSS[ _](A7[BRLZ]|A65|A74A|A5Z)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Eurostar: {
        regex: "(ET7002C-H12|Onyx-[13]S)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Onyx-([13]S)(?:[);/ ]|$)",
                model: "Onyx $1"
            },
            {
                regex: "ET7002C-H12(?:[);/ ]|$)",
                model: "ePad 4S",
                device: "tablet"
            }
        ]
    },
    Eton: {
        regex: "Eton",
        device: "smartphone",
        models: [
            {
                regex: "Eton[ _-]?([^;/)]+) Build",
                model: "$1"
            },
            {
                regex: "Eton[ _-]?([^;/)]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Essentielb: {
        regex: "(?:Wooze[_ ]?(?:I55?|I45|X?L)|HEYOU(?:[135]|30))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "HEYOU([135]|30)(?:[);/ ]|$)",
                model: "HEYou $1"
            },
            {
                regex: "Wooze[_ ]?((?:I55?|I45|X?L))(?:[);/ ]|$)",
                model: "Wooze $1"
            }
        ]
    },
    Facebook: {
        regex: "PortalTV",
        device: "tv",
        model: "Portal TV"
    },
    Rikomagic: {
        regex: "MK(80[28][^/;]*) Build",
        device: "tv",
        model: "MK$1"
    },
    Rinno: {
        regex: "Rinno (R(?:400|505))",
        device: "smartphone",
        model: "$1"
    },
    Riviera: {
        regex: "RIVIERA ",
        device: "smartphone",
        models: [
            {
                regex: "F23",
                model: "F23"
            }
        ]
    },
    Senseit: {
        regex: "SENSEIT[ _]?([^;/)]+)( Build|\\))",
        device: "smartphone",
        model: "$1"
    },
    Sony: {
        regex: "Sony(?: ?Ericsson)?|SGP|Xperia|(?:[4-9]0[12])SO|C1[569]0[45]|C2[01]0[45]|C230[45]|C530[236]|C550[23]|C6[56]0[236]|C6616|C68(?:0[26]|[34]3)|C69(?:0[236]|16|43)|D200[45]|D21(?:0[45]|14)|D22(?:0[236]|12|43)|D230[2356]|D240[36]|D25(?:02|33)|D510[236]|D530[36]|D5316|D5322|D5503|D58[03]3|D65(?:0[23]|43|63)|D66[03458]3|D66[14]6|D6708|E(?:20[0345]3|2006|210[45]|2115|2124|230[36]|2312|23[356]3|530[36]|53[3456]3|5506|55[356]3|56[46305][36]|58[02]3|65[35]3|66[0358]3|68[358]3)|I[34]312|I4332|F311[12356]|F331[13]|F321[12356]|F5[13]21|F5122|F813[12]|F833[12]|G312[135]|G311[26]|G322[136]|G3212|G331[123]|G3412|G3416|G342[136]|G823[12]|G834[123]|G8[14]4[12]|H(?:3113|3123|3133|3213|3223|3311|3321|4113|4133|4213|4233|4311|4331|4413|4433|82[167]6|83[12]4|8416|9436)|(?:WT|LT|SO|ST|SK|MK)[0-9]+[a-z]+[0-9]*(?: Build|\\))|X?L39H|XM50[ht]|W960|portalmmm/2\\.0 K|S3[69]h|SOG01|SOL2[2346]|SOV3[1-9]|SOV4[0-3]|X10[ia]v?|E1[05][ai]v?|MT[0-9]{2}[a-z]? Build|SO-0(?:[12]C|[345]D|[234]E|[1-5]F|[1-5]G|[1-4]H|[1-4]J|[1-5]K|1M|[1-3]L)|R800[aix]|J3173|J82[17]0|J9110|J92[16]0|J81[17]0|I[34]113|I3[12]23|I42[19]3|H9493|H8296|H8166|H4493|G2299|LiveWithWalkman|BRAVIA|SGP771|E3 Dual|A001SO|I4193|E6508|SOT31|SO-[45]1A|SO-52A|XQ-A[DT]51|XQ-A[TU]42|XQ-AS[67]2|XQ-A[TSU]52|SOL25|SOG02|A002SO|NW-(A100|Z1000)Series|J3273",
        device: "smartphone",
        models: [
            {
                regex: "(?:Sony(?:Ericsson)?)?E10[ai]v?",
                model: "Xperia X10 mini",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?U20",
                model: "Xperia X10 mini pro",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E15[ai]v?",
                model: "Xperia X8",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(LT15[ai]?v?|SO-01C)",
                model: "Xperia arc",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?LT18[ai]v?",
                model: "Xperia arc S",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?MT11",
                model: "Xperia neo V",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?MT15",
                model: "Xperia neo",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?MT27",
                model: "Xperia Sola",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?MK16[ai]",
                model: "Xperia pro",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?ST15[ai]",
                model: "Xperia mini",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?ST17[ai]",
                model: "Xperia active",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?SO-02L",
                model: "Xperia Ace",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?ST18[ai]",
                model: "Xperia ray",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?SK17[ai]?",
                model: "Xperia mini pro",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?X10[ai]v?",
                model: "Xperia X10",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)M1",
                model: "Aspen",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?R800",
                model: "Xperia PLAY",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?WT19|LiveWithWalkman",
                model: "Live with Walkman",
                brand: "Sony Ericsson"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?CK13i",
                model: "txt",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?CK15[ai]",
                model: "txt pro",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F100i",
                model: "Jalou",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?J105",
                model: "Naite",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?J108",
                model: "Cedar",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?J10",
                model: "Elm",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?J20",
                model: "Hazel",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?U10",
                model: "Aino",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?U100",
                model: "Yari",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?U1",
                model: "Satio",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?U5",
                model: "Vivaz",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?U8",
                model: "Vivaz pro",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?W20",
                model: "Zylo",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?W100",
                model: "Spiro",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?W150",
                model: "Yendo",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?W960",
                model: "W960",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?WT13",
                model: "Mix Walkman",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "SO-04F",
                model: "Xperia A2"
            },
            {
                regex: "G2299",
                model: "Xperia R1 Plus"
            },
            {
                regex: "SO-04G",
                model: "Xperia A4"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?I(?:4113|31[12]3)",
                model: "Xperia 10"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?J3173(?:[);/ ]|$)",
                model: "Xperia Ace"
            },
            {
                regex: "(?:A001SO|XQ-A[TU]52|XQ-AU42|SO-41A|SOV43)(?:[);/ ]|$)",
                model: "Xperia 10 II"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?I(?:42[19]3|3223)",
                model: "Xperia 10 Plus"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?I4193",
                model: "Xperia 10 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:J(?:9110|81[17]0)|SOV40|SO-03L|802SO)",
                model: "Xperia 1"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:SOG01|SO-51A|XQ-AT42|XQ-AT51)(?:[);/ ]|$)",
                model: "Xperia 1 II"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?LT22i|Xperia P",
                model: "Xperia P"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?LT25i|Xperia V",
                model: "Xperia V"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?J92[16]0",
                model: "Xperia 5 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:J82[17]0|SO-01M|SOV41|901SO)",
                model: "Xperia 5"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:SOG02|A002SO|XQ-AS[567]2|SO-52A)",
                model: "Xperia 5 II"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:SOV42|902SO)",
                model: "Xperia 8"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?J3273",
                model: "Xperia 8 Lite"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?LT26ii",
                model: "Xperia SL"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?LT26i|Xperia S(?:[);/ ]|$)",
                model: "Xperia S"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?SO-02C",
                model: "Xperia arco"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?SO-03D",
                model: "Xperia arco HD"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?LT26w",
                model: "Xperia arco S"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?LT28[aih]",
                model: "Xperia ion"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?LT29i|Xperia TX(?:[);/ ]|$)",
                model: "Xperia TX"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?LT30a",
                model: "Xperia T LTE"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?LT30p",
                model: "Xperia T"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?ST21[ia]2",
                model: "Xperia tipo dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?ST21[ia]",
                model: "Xperia tipo"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?ST23[ia]",
                model: "Xperia miro"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?ST25[ia]",
                model: "Xperia U"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?SOL22",
                model: "Xperia UL"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?ST26[ia]",
                model: "Xperia J"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?ST27[ia]",
                model: "Xperia go"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?C150[45]",
                model: "Xperia E"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?C160[45]",
                model: "Xperia E Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:E210[45]|E2115|E2124)",
                model: "Xperia E4"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E20[05]3|E2006",
                model: "Xperia E4G"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?C190[45]",
                model: "Xperia M"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?C200[45]",
                model: "Xperia M Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?C210[45]|S36h",
                model: "Xperia L"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?C230[45]|S39h",
                model: "Xperia C"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?C530[236]|Xperia SP(?:[);/ ]|$)",
                model: "Xperia SP"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?C550[23]",
                model: "Xperia ZR"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?C650[236]|Xperia ZL(?:[);/ ]|$)",
                model: "Xperia ZL"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?SOL25(?:[);/ ]|$)",
                model: "Xperia ZL2"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:C66(?:0[236]|16)|SO-02E)",
                model: "Xperia Z"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:C68(?:0[26]|[34]3)|XL39H|SOL24)|Xperia Z Ultra(?:[);/ ]|$)",
                device: "phablet",
                model: "Xperia Z Ultra"
            },
            {
                regex: "Xperia Z(?:[);/ ]|$)",
                model: "Xperia Z"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D200[45]",
                model: "Xperia E1"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D21(?:0[45]|14)",
                model: "Xperia E1 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D22(?:0[236]|43)",
                model: "Xperia E3"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D2212|E3 Dual",
                model: "Xperia E3 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E20[34]3",
                model: "Xperia E4g Dual"
            },
            {
                regex: "H33[12]1",
                model: "Xperia L2"
            },
            {
                regex: "H43[13]1",
                model: "Xperia L2 Dual"
            },
            {
                regex: "I3312",
                model: "Xperia L3"
            },
            {
                regex: "I43[13]2",
                model: "Xperia L3 Dual"
            },
            {
                regex: "XQ-AD51",
                model: "Xperia L4"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D2302",
                model: "Xperia M2 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D230[356]",
                model: "Xperia M2"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D240[36]",
                model: "Xperia M2 Aqua"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:E230[36]|E23[35]3)",
                model: "Xperia M4 Aqua"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:E2312|E2363)",
                model: "Xperia M4 Aqua Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E56[05][36]",
                model: "Xperia M5"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E56[436]3",
                model: "Xperia M5 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D2502",
                model: "Xperia C3 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D2533",
                model: "Xperia C3"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E53[05]3|E5306",
                model: "Xperia C4"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E53[0346]3",
                model: "Xperia C4 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E5506|E5553",
                model: "Xperia C5 Ultra"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E55[36]3",
                model: "Xperia C5 Ultra Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D510[236]",
                model: "Xperia T3"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:D530[36]|D5316|XM50[ht])",
                model: "Xperia T2 Ultra",
                device: "phablet"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D5322",
                model: "Xperia T2 Ultra Dual",
                device: "phablet"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?D5503|Xperia Z1 Compact",
                model: "Xperia Z1 Compact"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:C69(?:0[236]|16|43)|SOL23|L39H|SO-0[12]F)|Xperia Z1(?:[);/ ]|$)",
                model: "Xperia Z1"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:D58[03]3|SO-02G)|Xperia Z3 Compact(?:[);/ ]|$)",
                model: "Xperia Z3 Compact"
            },
            {
                regex: "Xperia Z2 Tablet Wifi",
                model: "Xperia Z2 Tablet WiFi",
                device: "tablet"
            },
            {
                regex: "SGP561",
                model: "Xperia Z2 Tablet",
                device: "tablet"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:D65(?:0[23]|43)|SO-03F)|Xperia Z2(?:[);/ ]|$)",
                model: "Xperia Z2"
            },
            {
                regex: "D6563",
                model: "Xperia Z2a"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:D66[045]3|D66[14]6|SO-01G|SOL26|401SO)|Xperia Z3(?:[);/ ]|$)",
                model: "Xperia Z3"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:D6633|D6683)",
                model: "Xperia Z3 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:E65[35]3)",
                model: "Xperia Z3+"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:D6708)",
                model: "Xperia Z3v"
            },
            {
                regex: "SOV31|402SO|SO-03G",
                model: "Xperia Z4"
            },
            {
                regex: "E6508",
                model: "Xperia Z4v"
            },
            {
                regex: "SGP771|SOT31|SO-05G",
                model: "Xperia Z4",
                device: "tablet"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:E58[02]3|SO-02H)",
                model: "Xperia Z5 Compact"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:E66[05]3|SOV32|501SO|SO-01H)",
                model: "Xperia Z5"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E66[38]3",
                model: "Xperia Z5 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:E68[58]3|SO-03H)",
                model: "Xperia Z5 Premium"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?E6833",
                model: "Xperia Z5 Premium Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F311[135]",
                model: "Xperia XA"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F311[26]",
                model: "Xperia XA Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F321[135]",
                model: "Xperia XA Ultra"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F321[26]",
                model: "Xperia XA Ultra Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F833[12]|SOV34|601SO|SO-01J",
                model: "Xperia XZ"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:701SO|SOV36|G834[123]|SO-01K)",
                model: "Xperia XZ1"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?G8441|SO-02K",
                model: "Xperia XZ1 Compact"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F331[13]",
                model: "Xperia E5"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?G312[135]|G311[26]",
                model: "Xperia XA1"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?G341[26]|G342[13]",
                model: "Xperia XA1 Plus"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?G3426",
                model: "Xperia XA1 Plus Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?G322[136]|G3212",
                model: "Xperia XA1 Ultra"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?H31[123]3",
                model: "Xperia XA2"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?H41[13]3",
                model: "Xperia XA2 Dual"
            },
            {
                regex: "H44[19]3",
                model: "Xperia XA2 Plus Dual"
            },
            {
                regex: "H4433",
                model: "H4433"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?H(?:3213|3223|4213|4233)",
                model: "Xperia XA2 Ultra"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?G823[12]|SOV35|602SO|SO-03J",
                model: "Xperia XZs"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?G814[12]|SO-04[JK]",
                model: "Xperia XZ Premium"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:H83[12]4|H82[17]6|SOV37|SO-03K|H8296|702SO)",
                model: "Xperia XZ2"
            },
            {
                regex: "H8266",
                model: "Xperia XZ2 Dual"
            },
            {
                regex: "SO-05K",
                model: "Xperia XZ2 Compact"
            },
            {
                regex: "(?:H8166|SOV38)(?:[);/ ]|$)",
                model: "Xperia XZ2 Premium Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:H(8416|9436|9493)|SO-01L|SOV39|801SO)",
                model: "Xperia XZ3"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?G331[13]",
                model: "Xperia L1"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?G3312",
                model: "Xperia L1 Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?SO-04E",
                model: "Xperia A"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?SO-04D",
                model: "Xperia GX"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?SO-05D",
                model: "Xperia SX"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F5121",
                model: "Xperia X"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F5122",
                model: "Xperia X Dual"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F5321|SO-02J",
                model: "Xperia X Compact"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?(?:F8131|502SO|SOV33|SO-04H)",
                model: "Xperia X Performance"
            },
            {
                regex: "(?:Sony(?:Ericsson)?)?F8132",
                model: "Xperia X Performance Dual"
            },
            {
                regex: "SGP(?:311|312|321)(?:[);/ ]|$)|SO-03E",
                model: "Xperia Tablet Z",
                device: "tablet"
            },
            {
                regex: "SGP712(?:[);/ ]|$)",
                model: "Xperia Tablet Z4",
                device: "tablet"
            },
            {
                regex: "SGP(?:511|512|521)(?:[);/ ]|$)|SO-05F",
                model: "Xperia Tablet Z2",
                device: "tablet"
            },
            {
                regex: "SGP(?:6[124]1|612)(?:[);/ ]|$)",
                model: "Xperia Tablet Z3 Compact",
                device: "tablet"
            },
            {
                regex: "SGPT(?:12|121|122|123|13|131|132|133)(?:[);/ ]|$)",
                model: "Xperia Tablet S",
                device: "tablet"
            },
            {
                regex: "(?:BRAVIA )(2K GB ATV3|4K UR2|4K GB ATV3|4K GB|4K 2015|2015)(?:[);/ ]|$)",
                model: "Bravia $1",
                device: "tv"
            },
            {
                regex: "NW-A100Series",
                model: "Walkman A100",
                device: "portable media player"
            },
            {
                regex: "NW-Z1000Series",
                model: "Walkman Z1000",
                device: "portable media player"
            },
            {
                regex: "SonyBDP|SonyDBV",
                model: "Blu-ray Player",
                device: "tv"
            },
            {
                regex: "(?:Sony-)?(KDL?-?[0-9a-z]+)",
                model: "$1",
                device: "tv"
            },
            {
                regex: "Opera TV Store.*(?:Sony-)([0-9a-z\\-_]+)",
                model: "$1",
                device: "tv"
            },
            {
                regex: "((?:WT|SO|ST|SK|MK)[0-9]+[a-z]*[0-9]*)(?: Build|\\))",
                model: "$1",
                brand: "Sony Ericsson"
            },
            {
                regex: "(MT[0-9]{2}[a-z]?)(?:[);/ ]|$)",
                model: "$1",
                brand: "Sony Ericsson"
            },
            {
                regex: "portalmmm/2.0 K([a-z0-9]+)",
                model: "K$1",
                brand: "Sony Ericsson"
            },
            {
                regex: "Sony ?Ericsson?([^/;]*) Build",
                model: "$1",
                brand: "Sony Ericsson"
            },
            {
                regex: "SonyEricsson([CGJKPTWZ][0-9]+[a-z]+)/",
                model: "$1",
                brand: "Sony Ericsson",
                device: "feature phone"
            },
            {
                regex: "Sony ?Ericsson ?([a-z0-9\\-]+)",
                model: "$1",
                brand: "Sony Ericsson"
            },
            {
                regex: "Sony (Tablet[^/;]*) Build",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "(SGP[^/;]*) Build",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Xperia ([^/;]*Tablet[^/;]*) Build",
                model: "Xperia $1",
                device: "tablet"
            },
            {
                regex: "Xperia ([^;/]+) Build",
                model: "Xperia $1"
            },
            {
                regex: "Sony[ -]?([^/;]*) Build",
                model: "$1"
            },
            {
                regex: "Sony[ -]?([a-z0-9\\-]+)",
                model: "$1"
            }
        ]
    },
    Ergo: {
        regex: "ERGO|(V550[_ ]Vision|B502 Basic|B504[_ ]Unit|A502[_ ]Aurum|A503[ _]Optima|Prime B400|A551 Sky 4G|A553 Power|A555 Universe|Force F500|GoTab GBT9|GoTab Gti8|F501_Magic|V551[ _]Aura|V540_Level|V570_BIG_BEN|B506[_ ]INTRO|A503-Optima|B505_Unit_4G)",
        device: "smartphone",
        models: [
            {
                regex: "F501_Magic",
                model: "F501 Magic"
            },
            {
                regex: "B502 Basic",
                model: "B502 Basic"
            },
            {
                regex: "A503-Optima",
                model: "A503 Optima"
            },
            {
                regex: "B506[_ ]INTRO",
                model: "B506 Intro"
            },
            {
                regex: "V550[_ ]Vision",
                model: "V550 Vision"
            },
            {
                regex: "B504[_ ]Unit",
                model: "B504 Unit"
            },
            {
                regex: "B505_Unit_4G",
                model: "B505 Unit 4G"
            },
            {
                regex: "V551[ _]Aura",
                model: "V551 Aura"
            },
            {
                regex: "V540_Level",
                model: "V540 Level"
            },
            {
                regex: "V570_BIG_BEN",
                model: "V570 Big Ben"
            },
            {
                regex: "Ergo F502",
                model: "F502 Platinum"
            },
            {
                regex: "(ERGO_)?A500[ _]Best",
                model: "A500 Best"
            },
            {
                regex: "(ERGO_)?A550[ _]Maxx",
                model: "A550 Maxx"
            },
            {
                regex: "Prime B400",
                model: "Prime B400"
            },
            {
                regex: "A502[_ ]Aurum",
                model: "A502 Aurum"
            },
            {
                regex: "A503[ _]Optima",
                model: "A503 Optima"
            },
            {
                regex: "A551 Sky 4G",
                model: "A551 Sky 4G"
            },
            {
                regex: "A553 Power",
                model: "A553 Power"
            },
            {
                regex: "A555 Universe",
                model: "A555 Universe"
            },
            {
                regex: "ERGO[_ ]A556",
                model: "A556"
            },
            {
                regex: "ERGO[_ ]F500",
                model: "F500"
            },
            {
                regex: "ERGO[_ ]F501",
                model: "F501"
            },
            {
                regex: "B500 First",
                model: "B500 First"
            },
            {
                regex: "Force F500",
                model: "Force F500"
            },
            {
                regex: "GoTab GBT9",
                model: "GoTab GBT9",
                device: "tablet"
            },
            {
                regex: "GoTab Gti8",
                model: "GoTab GTi8",
                device: "tablet"
            },
            {
                regex: "ERGO[_ ]Tab[ _]Crystal[ _]Lite",
                model: "Tab Crystal Lite",
                device: "tablet"
            },
            {
                regex: "ERGO[_ ]Tab[ _]Hero[ _]II",
                model: "Tab Hero II",
                device: "tablet"
            },
            {
                regex: "ERGO[_ ](B700)",
                model: "Tab $1",
                device: "tablet"
            },
            {
                regex: "ERGO SmartBox SX",
                model: "SmartBox SX",
                device: "tv"
            }
        ]
    },
    Ericsson: {
        regex: "(?:Ericsson(?:/ )?[a-z0-9]+)|(?:R380 2.0 WAP1.1)",
        device: "feature phone",
        models: [
            {
                regex: "Ericsson(?:/ )?([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "R380 2.0 WAP1.1",
                model: "R380"
            }
        ]
    },
    Energizer: {
        regex: "PowerMax|ENERGY[_ ]?(?:[45]00|400S|S[56]00|E12|E5[02]0S?)(?:[_ ](?:LTE|EU))?",
        device: "smartphone",
        models: [
            {
                regex: "PowerMax(P[0-9]+S?)",
                model: "Power Max $1"
            },
            {
                regex: "ENERGY[_ ]([45]00|E520)[_ ]LTE",
                model: "Energy $1 LTE"
            },
            {
                regex: "ENERGY[_ ]400S",
                model: "Energy 400S"
            },
            {
                regex: "ENERGY400",
                model: "Energy 400"
            },
            {
                regex: "ENERGY[_ ]S([56]00)",
                model: "Energy S$1"
            },
            {
                regex: "ENERGY[_ ]?(E500S|E500|E12)",
                model: "Energy $1"
            }
        ]
    },
    "Energy Sistem": {
        regex: "ENERGY[ _-]?([^;/]+) Build|Energy Phone Pro 3",
        device: "smartphone",
        models: [
            {
                regex: "Energy Phone Pro 3",
                model: "Energy Phone Pro 3"
            },
            {
                regex: "ENERGY[ _-]?([^;/]+) Build",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    eTouch: {
        regex: "eTouch ?([a-z0-9]+)",
        device: "smartphone",
        model: "$1"
    },
    Etuline: {
        regex: "(ETL-S(?:3520|4521|5042|5084|6022)|ETL-T(?:752G|882G|9[78]0))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(ETL-S(?:[^/); ]+))",
                model: "$1"
            },
            {
                regex: "(ETL-T(?:[^/); ]+))",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    Storex: {
        regex: "eZee[^a-z]*Tab ?([^;/]*) Build|STOREX LinkBox",
        device: "tablet",
        models: [
            {
                regex: "eZee[^a-z]*Tab ?([^;/]*) Build",
                model: "eZee'Tab$1"
            },
            {
                regex: "STOREX LinkBox",
                model: "LinkBox",
                device: "tv"
            }
        ]
    },
    Evertek: {
        regex: "(Ever(?:Glory|Shine|Miracle|Mellow|Classic|Trendy|Fancy|Vivid|Slim|Glow|Magic|Smart|Star)[^/;]*) Build|E70[25]0HD|E805[01]HD|E9054HD|E8050HG|E7914HG",
        device: "smartphone",
        models: [
            {
                regex: "(E70[25]0HD|E805[01]HD|E9054HD|E8050HG|E7914HG)",
                device: "tablet",
                model: "Everpad $1"
            },
            {
                regex: "(Ever(?:Glory|Shine|Miracle|Mellow|Classic|Trendy|Fancy|Vivid|Slim|Glow|Magic|Smart|Star)[^/;]*) Build",
                model: "$1"
            }
        ]
    },
    Evolio: {
        regex: "Evolio|M4MAGIC",
        device: "smartphone",
        models: [
            {
                regex: "M4MAGIC",
                model: "M4 Magic"
            },
            {
                regex: "Evolio_M5Pro",
                model: "M5 Pro"
            },
            {
                regex: "Evolio[ _](M6|S4 Cobalt|S5|X10|Yuppi)",
                model: "$1"
            }
        ]
    },
    Evolveo: {
        regex: "EVOLVEO|StrongPhone",
        device: "smartphone",
        models: [
            {
                regex: "EVOLVEO MultiMedia Box M4",
                device: "tv",
                model: "MultiMedia Box M4"
            },
            {
                regex: "Smart TV ([^;/]*) Build",
                device: "tv",
                model: "Smart TV $1"
            },
            {
                regex: "EVOLVEO StrongPhone G([248])",
                model: "StrongPhone G$1"
            },
            {
                regex: "(?:EVOLVEO[ _])?StrongPhone[ _]?Q([679])(_LTE)?",
                model: "StrongPhone Q$1$2"
            },
            {
                regex: "EVOLVEO[ _]([^;/]*) Build",
                model: "$1"
            }
        ]
    },
    Explay: {
        regex: "Explay|[\\w]+-EXPLAY-FIN|ActiveD[ _]|Atlant |Informer[ _][0-9]+|CinemaTV 3G|Surfer[ _][0-9\\.]|sQuad[ _][0-9\\.]|Onliner[1-3]|RioPlay|Leader|Pulsar|Infinityll|Imperium[78]|Indigo|Lagoon",
        device: "tablet",
        models: [
            {
                regex: "ActiveD[ _]7.4[ _]3G",
                model: "ActiveD 7.4 3G"
            },
            {
                regex: "Imperium([78])(?:[);/ ]|$)",
                model: "Imperium $1 3G"
            },
            {
                regex: "ActiveD[ _]8.2[ _]3G",
                model: "ActiveD 8.2 3G"
            },
            {
                regex: "CinemaTV[ _]3G",
                model: "CinemaTV 3G"
            },
            {
                regex: "Infinityll",
                model: "Infinity II"
            },
            {
                regex: "Informer[ _]([0-9]+(?:[ _]3G)?)",
                model: "Informer $1"
            },
            {
                regex: "Surfer[ _]([0-9\\.]+(?:[ _]3G)?)",
                model: "Surfer $1"
            },
            {
                regex: "sQuad[ _]([0-9\\.]+(?:[ _]3G)?)",
                model: "sQuad $1"
            },
            {
                regex: "Onliner([1-3])",
                model: "Onliner $1"
            },
            {
                regex: "Atlant(?:[);/ ]|$)",
                device: "smartphone",
                model: "Atlant"
            },
            {
                regex: "Indigo(?:[);/ ]|$)",
                device: "smartphone",
                model: "Indigo"
            },
            {
                regex: "Pulsar(?:[);/ ]|$)",
                device: "smartphone",
                model: "Pulsar"
            },
            {
                regex: "[\\w]+-EXPLAY-FIN",
                device: "feature phone",
                model: "Fin"
            },
            {
                regex: "Lagoon(?:[);/ ]|$)",
                model: "Lagoon"
            },
            {
                regex: "Explay[ _-]([^;/]+)(?: Build|[;)])",
                model: "$1"
            },
            {
                regex: "RioPlay(?:[);/ ]|$)",
                device: "smartphone",
                model: "Rio Play"
            },
            {
                regex: "Leader",
                model: "Leader"
            }
        ]
    },
    EvroMedia: {
        regex: "EVROMEDIA|Playpad[ _]|PLAY_PAD_PRO_XL",
        device: "tablet",
        models: [
            {
                regex: "Playpad 3G GOO",
                model: "Play Pad 3G Goo"
            },
            {
                regex: "Play Pad 3G 2Goo",
                model: "Play Pad 3G 2Goo"
            },
            {
                regex: "Play Pad PRO",
                model: "Play Pad Pro"
            },
            {
                regex: "PLAY_PAD_PRO_XL",
                model: "Play Pad Pro XL"
            },
            {
                regex: "PlayPad 3GTab XL",
                model: "Play Pad 3G Tab XL"
            }
        ]
    },
    EKO: {
        regex: "EKO",
        device: "smartphone",
        models: [
            {
                regex: "EKO[ _-]?([^;/)]+) Build",
                model: "$1"
            },
            {
                regex: "EKO[ _-]?([^;/)]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Extrem: {
        regex: "Rock X9+|ROCK_X11",
        device: "smartphone",
        models: [
            {
                regex: "Rock X9+",
                model: "Rock X9+"
            },
            {
                regex: "ROCK_X11",
                model: "Rock X11"
            }
        ]
    },
    Ezze: {
        regex: "EZZE-|EZ(?!Browser)[a-z0-9]+",
        device: "feature phone",
        models: [
            {
                regex: "EZZE-([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "EZ([a-z0-9]+)",
                model: "EZ$1"
            }
        ]
    },
    Ezio: {
        regex: "EZIO-([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Forstar: {
        regex: "Amosta ?3G5",
        device: "smartphone",
        models: [
            {
                regex: "Amosta ?3G5",
                model: "Amosta 3G5"
            }
        ]
    },
    Foxconn: {
        regex: "InFocus M[0-9]+[a-z]?",
        device: "smartphone",
        models: [
            {
                regex: "InFocus M([0-9]+[a-z]?)",
                model: "InFocus M$1"
            }
        ]
    },
    Fondi: {
        regex: "Fondi[- _]([^;/)]+)|(T702|Q008B|Q010B|Q718B|Q902|T602B|T707G|T708B|T725B|T725B1|T907B)(?:\\)| Build)",
        device: "smartphone",
        models: [
            {
                regex: "(T702|T602B)",
                model: "$1"
            },
            {
                regex: "(Q008B|Q010B|Q718B|Q902|T707G|T708B|T725B|T725B1|T907B)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "Fondi[- _]([^;/)]+)",
                model: "$1"
            }
        ]
    },
    Fairphone: {
        regex: "(FP(?:1U?|2))(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Famoco: {
        regex: "(FX[123]00)",
        device: "smartphone",
        model: "$1"
    },
    FiGO: {
        regex: "ATRIUM II F55L2|TRIO F40LT|CENTRIC S50G|EPIC F50G|Gravity X55L|Orion M50L|ULTRA M50G|M405B|VIRTUE3|F55L Build",
        device: "smartphone",
        models: [
            {
                regex: "ATRIUM II F55L2",
                model: "Atrium II"
            },
            {
                regex: "(F55L)",
                model: "$1"
            },
            {
                regex: "TRIO F40LT",
                model: "Trio F40LT"
            },
            {
                regex: "EPIC F50G",
                model: "Epic F50G"
            },
            {
                regex: "(Gravity X55L|Orion M50L)",
                model: "$1"
            },
            {
                regex: "ULTRA M50G",
                model: "Prime"
            },
            {
                regex: "M405B_8GB",
                model: "Virtue II 8GB"
            },
            {
                regex: "M405B",
                model: "Virtue II"
            },
            {
                regex: "VIRTUE3",
                model: "Virtue III"
            },
            {
                regex: "CENTRIC S50G",
                model: "Centric S50G"
            }
        ]
    },
    FNB: {
        regex: "ConeXis (A[12]|X[12])|SP5045V",
        device: "smartphone",
        models: [
            {
                regex: "SP5045V",
                model: "SP5045V"
            },
            {
                regex: "ConeXis A1",
                model: "ConeXis A1"
            },
            {
                regex: "ConeXis A2",
                model: "ConeXis A2"
            },
            {
                regex: "ConeXis X1",
                model: "ConeXis X1"
            },
            {
                regex: "ConeXis X2",
                model: "ConeXis X2"
            }
        ]
    },
    Fujitsu: {
        regex: "(?:F-01[FHJKLM]|F-02[EFGHLK]|F-03[DEFGKHL]|F-04[EGFHKJ]|F-05[DEFJG]|F-06[EF]|F-07[DE]|F-08D|F-09[DE]|F-10D|F-[45]1A|F-[45]2A|F-11D|F-12C|M532|FARTM933KZ|901FJ|arrows(?:RX|M03|M0[45](?:-PREMIUM)?)|801FJ|FJL2[12])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "F-51A(?:[);/ ]|$)",
                model: "Arrows 5G F-51A"
            },
            {
                regex: "F-01F(?:[);/ ]|$)",
                model: "Arrows NX F-01F"
            },
            {
                regex: "(F-01[LM]|F-06F|F-03K|F-42A)(?:[);/ ]|$)",
                model: "Easy Phone $1"
            },
            {
                regex: "F-03L(?:[);/ ]|$)",
                model: "Arrows Phone F-03L"
            },
            {
                regex: "F-01J(?:[);/ ]|$)",
                model: "Arrows NX F-01J"
            },
            {
                regex: "F-01K(?:[);/ ]|$)",
                model: "Arrows NX F-01K"
            },
            {
                regex: "F-01H(?:[);/ ]|$)",
                model: "Arrows Fit F-01H"
            },
            {
                regex: "F-02E(?:[);/ ]|$)",
                model: "Arrows X F-02E"
            },
            {
                regex: "F-02G(?:[);/ ]|$)",
                model: "Arrows NX F-02G"
            },
            {
                regex: "FJL21(?:[);/ ]|$)",
                model: "Arrows EF FJL21"
            },
            {
                regex: "FJL22(?:[);/ ]|$)",
                model: "Arrows Z FJL22"
            },
            {
                regex: "F-02H(?:[);/ ]|$)",
                model: "Arrows NX F-02H"
            },
            {
                regex: "F-52A(?:[);/ ]|$)",
                model: "Arrows NX9 F-52A"
            },
            {
                regex: "F-03D(?:[);/ ]|$)",
                model: "Arrows Kiss F-03D"
            },
            {
                regex: "F-03E(?:[);/ ]|$)",
                model: "Arrows Kiss F-03E"
            },
            {
                regex: "F-03F(?:[);/ ]|$)",
                model: "Disney Mobile F-03F"
            },
            {
                regex: "F-03H(?:[);/ ]|$)",
                model: "Arrows SV F-03H"
            },
            {
                regex: "901FJ(?:[);/ ]|$)",
                model: "Arrows J 901FJ"
            },
            {
                regex: "F-04E(?:[);/ ]|$)",
                model: "Arrows V F-04E"
            },
            {
                regex: "F-04G(?:[);/ ]|$)",
                model: "Arrows NX F-04G"
            },
            {
                regex: "F-05D(?:[);/ ]|$)",
                model: "Arrows X LTE F-05D"
            },
            {
                regex: "F-05F(?:[);/ ]|$)",
                model: "Arrows NX F-05F"
            },
            {
                regex: "F-05J(?:[);/ ]|$)",
                model: "Arrows Be F-05J"
            },
            {
                regex: "F-05G(?:[);/ ]|$)",
                model: "Arrows K-tai"
            },
            {
                regex: "F-04K(?:[);/ ]|$)",
                model: "Arrows Be F-04K"
            },
            {
                regex: "F-02L(?:[);/ ]|$)",
                model: "Arrows Be 3 F-02L"
            },
            {
                regex: "F-41A(?:[);/ ]|$)",
                model: "Arrows Be 4 F-41A"
            },
            {
                regex: "F-06E(?:[);/ ]|$)",
                model: "Arrows NX F-06E"
            },
            {
                regex: "F-07D(?:[);/ ]|$)",
                model: "Arrows \u03BC F-07D"
            },
            {
                regex: "801FJ(?:[);/ ]|$)",
                model: "Arrows U 801FJ"
            },
            {
                regex: "F-07E(?:[);/ ]|$)",
                model: "Disney Mobile F-07E"
            },
            {
                regex: "F-08D(?:[);/ ]|$)",
                model: "Disney Mobile F-08D"
            },
            {
                regex: "F-09D(?:[);/ ]|$)",
                model: "ANTEPRIMA F-09D"
            },
            {
                regex: "F-09E(?:[);/ ]|$)",
                model: "Raku-Raku Smartphone Premium F-09E"
            },
            {
                regex: "F-10D(?:[);/ ]|$)",
                model: "Arrows X F-10D"
            },
            {
                regex: "F-11D(?:[);/ ]|$)",
                model: "Arrows Me F-11D"
            },
            {
                regex: "F-12C(?:[);/ ]|$)",
                model: "F-12C"
            },
            {
                regex: "(F-04[JF])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "arrowsM03(?:[);/ ]|$)",
                model: "Arrows M03"
            },
            {
                regex: "arrowsRX(?:[);/ ]|$)",
                model: "Arrows RX"
            },
            {
                regex: "arrowsM04-PREMIUM(?:[);/ ]|$)",
                model: "Arrows M04 Premium"
            },
            {
                regex: "arrowsM(0[45])(?:[);/ ]|$)",
                model: "Arrows M$1"
            },
            {
                regex: "(F-0[32]F|F-03G|F-04H|F-05E|F-02K)(?:[);/ ]|$)",
                model: "Arrows Tab $1",
                device: "tablet"
            },
            {
                regex: "FARTM933KZ",
                model: "Arrows Tab M504/HA4",
                device: "tablet"
            },
            {
                regex: "M532(?:[);/ ]|$)",
                model: "Stylistic",
                device: "tablet"
            }
        ]
    },
    "G-TiDE": {
        regex: "G-TiDE",
        device: "smartphone",
        models: [
            {
                regex: "Shining7",
                model: "Shining 7"
            },
            {
                regex: "G-TiDE_(A1|S[34])",
                model: "$1"
            },
            {
                regex: "G-TiDE V6",
                model: "V6"
            },
            {
                regex: "E(57|60|66|72|77)",
                model: "$1"
            }
        ]
    },
    Gemini: {
        regex: "(GEM[0-9]+[a-z]*)",
        device: "tablet",
        model: "$1"
    },
    "General Mobile": {
        regex: "GM 5 Plus|GM8 go|GM [68] d|GM 8|General Mobile 4G|GM 9 (?:Pro|Plus)|e-tab 20(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "GM 5 Plus",
                model: "GM 5 Plus"
            },
            {
                regex: "GM ([68]) d",
                model: "GM $1D"
            },
            {
                regex: "GM 8",
                model: "GM 8"
            },
            {
                regex: "GM8 go",
                model: "GM 8 Go"
            },
            {
                regex: "GM 9 Pro",
                model: "GM 9 Pro"
            },
            {
                regex: "GM 9 Plus",
                model: "GM 9 Plus"
            },
            {
                regex: "General Mobile 4G Dual",
                model: "4G Dual"
            },
            {
                regex: "General Mobile 4G",
                model: "4G"
            },
            {
                regex: "e-tab 20(?:[);/ ]|$)",
                device: "tablet",
                model: "E-Tab 20"
            }
        ]
    },
    Geotel: {
        regex: "GEOTEL[ _]?",
        device: "smartphone",
        models: [
            {
                regex: "G1",
                model: "G1"
            },
            {
                regex: "GEOTEL[ _]?Note",
                model: "Note"
            },
            {
                regex: "GEOTEL[ _]AMIGO",
                model: "Amigo"
            }
        ]
    },
    Ghia: {
        regex: "GHIA|QS702|VECTOR10\\.1",
        device: "smartphone",
        models: [
            {
                regex: "QS702",
                model: "QS702"
            },
            {
                regex: "GHIA_ZEUS_3G",
                model: "Zeus 3G"
            },
            {
                regex: "GHIA_AXIS7",
                model: "Axis 7",
                device: "tablet"
            },
            {
                regex: "VECTOR10\\.1",
                model: 'Vector 10.1"',
                device: "tablet"
            }
        ]
    },
    Gigabyte: {
        regex: "GSmart[ _][a-z0-9 ]+(?: Build|\\))|Gigabyte-[a-z0-9]+|Simba SX1|GSmart_Classic_Lite|(?<!Eagle )Classic[_ ](?:Joy|Pro)",
        device: "smartphone",
        models: [
            {
                regex: "(GSmart[ _][a-z0-9 ]+)(?: Build|[);])",
                model: "$1"
            },
            {
                regex: "Gigabyte-([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(Classic[ _](?:Joy|Pro)|GSmart_Classic_Lite)",
                model: "$1"
            },
            {
                regex: "Simba SX1",
                model: "GSmart Simba SX1"
            }
        ]
    },
    Gigaset: {
        regex: "Gigaset|(?: GS80|GS1[0189]0|GS1[89]5|GS2[89]0|GS5[357]-6|GS[23]70(?:_Plus)?)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Gigaset QV(1030|830)",
                model: "Gigaset QV$1",
                device: "tablet"
            },
            {
                regex: "G(S[23]70)[_ ]Plus(?:[);/ ]|$)",
                model: "G$1 Plus"
            },
            {
                regex: "GS([23]70|1[0189]0|1[89]5|2[89]0|80)(?:[);/ ]|$)",
                model: "GS$1"
            },
            {
                regex: "GS57-6",
                model: "ME Pro"
            },
            {
                regex: "GS55-6",
                model: "ME"
            },
            {
                regex: "GS53-6",
                model: "ME Pure"
            },
            {
                regex: "Gigaset ([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Gigaset ([^;/)]+)(?:[);/]|$)",
                model: "$1"
            }
        ]
    },
    Ginzzu: {
        regex: "GINZZU[_ ]|((?:RS(?:7[14]|81|9[67])D)|S5002|(?<!Wave Pro )S5021|S5230|S50[45]0|S5120|RS(6[12]|9[45])D|S40[23]0|RS850[12]|RS9602)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "GINZZU[_ ]?(S40[17]0|S4710|ST60[14]0|ST6120)",
                model: "$1"
            },
            {
                regex: "GINZZU[_ ]?(GT-(?:1050|7105|70[1-4]0|7115|7210|[WX]831|X[78]70|7810|8[01]10|X853))",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "(RS6[12]D) ULTIMATE",
                model: "$1 Ultimate"
            },
            {
                regex: "(?:GINZZU[ _])?((?:RS(?:7[14]|81|9[4-7])D)|S50[45]0|S5002|S5021|S5230|S5120|S40[23]0|RS850[12]|RS9602|RS94D)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Gionee: {
        regex: "(?:GIO-)?GIONEE[ _-]?[a-z0-9]+|(?:Dream_D1|V188S?|GN[0-9]{3,4}[a-z]?)(?:[);/ ]|$)|F103(?: Pro)?(?: Build|\\))|P5 mini Build|P7 Max Build|(M7 Power|F106L|F100A|F103S|F103 Pro)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "GN810(?:[);/ ]|$)",
                model: "GN810",
                device: "phablet"
            },
            {
                regex: "GN([0-9]{3,4}[a-z]?)(?:[);/ ]|$)",
                model: "GN$1"
            },
            {
                regex: "(F106L|F100A|V188S|V188|F103S)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "M7 Power(?:[);/ ]|$)",
                model: "M7 Power"
            },
            {
                regex: "P5 mini Build",
                model: "P5 mini"
            },
            {
                regex: "P7 Max Build",
                model: "P7 Max"
            },
            {
                regex: "(S11) Lite(?:[);/ ]|$)",
                model: "$1 Lite"
            },
            {
                regex: "F103( Pro)?( BUILD|\\))",
                model: "F103$1"
            },
            {
                regex: "(?:(?:GIO-)?GIONEE[ _-])?Dream_D1(?:[);/ ]|$)",
                model: "Dream D1"
            },
            {
                regex: "(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+).*Android",
                model: "$1"
            },
            {
                regex: "Android.*(?:GIO-)?GIONEE[ _-]([a-z0-9_-]+)",
                model: "$1"
            },
            {
                regex: "(?:GIO-)?GIONEE[ _-]?([a-z0-9]+)",
                model: "$1",
                device: "feature phone"
            }
        ]
    },
    Grape: {
        regex: "(?:Grape[ _])?GTM-5([^;/]+) Build",
        device: "smartphone",
        model: "GTM-5$1"
    },
    Vizio: {
        regex: "Vizio|VAP430|VTAB1008",
        device: "tv",
        models: [
            {
                regex: "VAP430",
                model: "VAP430"
            },
            {
                regex: "VTAB1008",
                device: "tablet",
                model: "VTAB1008"
            }
        ]
    },
    GOCLEVER: {
        regex: "GOCLEVER|QUANTUM_[0-9]{3}|QUANTUM [0-9]{1}|QUANTUM 700N|Quantum2 500|QUANTUM_(1010N|1010M|900)|ARIES|INSIGNIA|ORION_|ELIPSO|LIBRA[ _]97",
        device: "smartphone",
        models: [
            {
                regex: "QUANTUM_(1010N|1010M|900)",
                model: "QUANTUM $1",
                device: "tablet"
            },
            {
                regex: "INSIGNIA_(785_PRO|1010M|800M)",
                model: "INSIGNIA $1",
                device: "tablet"
            },
            {
                regex: "(ORION|ARIES|ELIPSO)[_ ](71|101|102)",
                model: "$1 $2",
                device: "tablet"
            },
            {
                regex: "TQ700N",
                model: "QUANTUM 700N",
                device: "tablet"
            },
            {
                regex: "Quantum2 500",
                model: "Quantum 2 500"
            },
            {
                regex: "((?:QUANTUM|ARIES|INSIGNIA|ORION|ELIPSO)[ _-]?[^;/]+)(?: Build|\\))",
                model: "$1"
            },
            {
                regex: "GOCLEVER[ _-]TAB[ _-]?([^;/]+) Build",
                model: "TAB $1",
                device: "tablet"
            },
            {
                regex: "GOCLEVER[ _-]?([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "TAB ([^;/)]+) Build/GOCLEVER",
                model: "TAB $1",
                device: "tablet"
            },
            {
                regex: "([^;/)]+) Build/GOCLEVER",
                model: "$1"
            },
            {
                regex: "GOCLEVER[ _-]?TAB[ _-]([^;/)]+)(?:[;/)]|$)",
                model: "TAB $1",
                device: "tablet"
            },
            {
                regex: "GOCLEVER[ _-]?([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            },
            {
                regex: "LIBRA[ _]97",
                model: "Libra 97",
                device: "tablet"
            }
        ]
    },
    GoMobile: {
        regex: "GO Onyx|GO[0-9]{3,4}",
        device: "smartphone",
        models: [
            {
                regex: "GO Onyx",
                model: "Go Onyx"
            },
            {
                regex: "GO([0-9]{3,4})",
                model: "Go$1"
            }
        ]
    },
    "Gol Mobile": {
        regex: "F10_PRIME",
        device: "smartphone",
        models: [
            {
                regex: "F10_PRIME",
                model: "F10 Prime"
            }
        ]
    },
    Goly: {
        regex: "Goly[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "Goly[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Goly[ _-]([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            }
        ]
    },
    Google: {
        regex: "Nexus|GoogleTV|Glass(?<!Browser)|CrKey[^a-z0-9]|Pixel(?: Build|\\))|Pixel (?:XL|C|[2-5]|[2-4] XL)|Google 2XL|G011A",
        device: "smartphone",
        models: [
            {
                regex: "Glass",
                model: "Glass"
            },
            {
                regex: "Galaxy Nexus",
                model: "Galaxy Nexus"
            },
            {
                regex: "(Nexus (?:S|4|5X?|One))",
                model: "$1"
            },
            {
                regex: "(Nexus (?:6P?))",
                device: "phablet",
                model: "$1"
            },
            {
                regex: "(Nexus (?:7|9|10))",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "CrKey[^a-z0-9]",
                model: "Chromecast",
                device: "tv"
            },
            {
                regex: "GoogleTV",
                device: "tv",
                model: "GoogleTV"
            },
            {
                regex: "Pixel(?: Build|\\))",
                model: "Pixel"
            },
            {
                regex: "Pixel XL",
                model: "Pixel XL"
            },
            {
                regex: "Pixel 3 XL",
                model: "Pixel 3 XL"
            },
            {
                regex: "Pixel 2 XL",
                model: "Pixel 2 XL"
            },
            {
                regex: "Pixel 3a XL",
                model: "Pixel 3a XL"
            },
            {
                regex: "Pixel 3a",
                model: "Pixel 3a"
            },
            {
                regex: "Pixel 4 XL",
                model: "Pixel 4 XL"
            },
            {
                regex: "Pixel 4a \\(5G\\)",
                model: "Pixel 4a (5G)"
            },
            {
                regex: "pixel 4a",
                model: "Pixel 4a"
            },
            {
                regex: "G011A",
                model: "Pixel 2"
            },
            {
                regex: "Google 2XL",
                model: "Pixel 2 XL"
            },
            {
                regex: "pixel ([2-5])",
                model: "Pixel $1"
            },
            {
                regex: "Pixel C",
                device: "tablet",
                model: "Pixel C"
            }
        ]
    },
    Gradiente: {
        regex: "GRADIENTE",
        device: "feature phone",
        models: [
            {
                regex: "GRADIENTE-([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "GRADIENTE ([a-z0-9\\-]+)",
                model: "$1"
            }
        ]
    },
    Grundig: {
        regex: "GR?-TB[0-9]+[a-z]*|GRUNDIG|portalmmm/2\\.0 G|AFTEU(?:011|014|FF014)",
        device: "tv",
        models: [
            {
                regex: "(GR?-TB[0-9]+[a-z]*)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "GRUNDIG ([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "portalmmm/2\\.0 G([a-z0-9]+)",
                model: "G$1"
            },
            {
                regex: "AFTEU014",
                model: "Vision 7 4K (2019)"
            },
            {
                regex: "AFTEUFF014",
                model: "OLED 4K (2019)"
            },
            {
                regex: "AFTEU011",
                model: "Vision 6 HD (2019)"
            }
        ]
    },
    Hafury: {
        regex: "HAFURY",
        device: "smartphone",
        models: [
            {
                regex: "(MIX|UMAX)",
                model: "$1"
            }
        ]
    },
    Haier: {
        regex: "Haier|I6_Infinity|Titan[ _]T[135]|(?:HW-)?W(?:71[67]|757|860|970)(?:[);/ ]|$)|S5 Silk|(?:HM-)?(N505|N700|G(?:152|303|353|552|70[01])?-FL|HM-N501-FL|G(?:303)?-W|I(?:557)?-FL)|(?:PAD[ _](?:D71|G781|d85))|A2_Lite_NFC",
        device: "smartphone",
        models: [
            {
                regex: "A2_Lite_NFC",
                model: "Alpha A2 Lite NFC"
            },
            {
                regex: "HM-N505-FL",
                model: "I8"
            },
            {
                regex: "S5 Silk",
                model: "S5 Silk"
            },
            {
                regex: "HM-N700-FL",
                model: "L7"
            },
            {
                regex: "HM-N501-FL",
                model: "L56"
            },
            {
                regex: "(?:HM-)?(G(?:152|353|552|70[01])|G(?:303)|I(?:557))",
                model: "$1"
            },
            {
                regex: "(Titan[_ ]T[135]|I6_Infinity)",
                model: "$1"
            },
            {
                regex: "(?:HW-)?W(71[67]|757|860|970)(?:[);/ ]|$)",
                model: "W$1"
            },
            {
                regex: "PAD[ -_](D71|G781|d85)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "Haier[ _\\-](H[WT]-[^/;]+) Build",
                model: "$1"
            },
            {
                regex: "Haier[ _\\-](H[WT]-[a-z0-9_\\-]+)",
                model: "$1"
            },
            {
                regex: "Haier[ _\\-](sy[0-9]+)",
                model: "$1"
            },
            {
                regex: "Haier[ _\\-]([a-z0-9\\-]+)",
                model: "$1",
                device: "feature phone"
            }
        ]
    },
    HannSpree: {
        regex: "(HSG[0-9]{4})|SN97T41W|SN1AT71W\\(B\\)|SN70T51A|SN70T31?|T7-QC",
        device: "tablet",
        models: [
            {
                regex: "(HSG[0-9]{4})",
                model: "$1"
            },
            {
                regex: "SN1AT71W\\(B\\)",
                model: "SN1AT71W(B)"
            },
            {
                regex: "SN70T31",
                model: "SN70T31"
            },
            {
                regex: "SN70T3",
                model: "SN70T3"
            },
            {
                regex: "SN70T51A",
                model: "SN70T51A"
            },
            {
                regex: "SN97T41W",
                model: "SN97T41W"
            },
            {
                regex: "T7-QC",
                model: "SNAT71BUE"
            }
        ]
    },
    Hasee: {
        regex: "Hasee",
        device: "smartphone",
        models: [
            {
                regex: "Hasee ([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Hasee ([^;/)]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Hisense: {
        regex: "(?:HS-)?Hisense ([^;/]+) Build|Hisense [^);/]+|HISENSE; |HS-(?:G|U|EG?|I|L|T|X)[0-9]+[a-z0-9\\-]*|E270BSA|HWCD100E|HITV300C|M470BS[AE]|EG98|E2281|EG680|I46D1G|HAT4KDTV|HLTE([237]00T|200M|203T|202N|21[023567]T|22[67]T|22[13]E|230E|310[TM]|31[16]T|500T|501N|510[TM]|7[23]0T)",
        device: "smartphone",
        models: [
            {
                regex: "E270BSA",
                device: "tablet",
                model: "Sero 7"
            },
            {
                regex: "M470BS[AE]",
                device: "tablet",
                model: "Sero 7 Pro"
            },
            {
                regex: "E2281",
                device: "tablet",
                model: "Sero 8"
            },
            {
                regex: "HLTE202N",
                model: "A5"
            },
            {
                regex: "HLTE203T",
                model: "A5 Pro CC"
            },
            {
                regex: "HLTE700T",
                model: "A6"
            },
            {
                regex: "HLTE730T",
                model: "A6L"
            },
            {
                regex: "HLTE221E",
                model: "E Max"
            },
            {
                regex: "HLTE501N",
                model: "V Plus"
            },
            {
                regex: "HLTE223E",
                model: "H30"
            },
            {
                regex: "I46D1G",
                model: "Smartfren Andromax R"
            },
            {
                regex: "EG680",
                model: "Smartfren Andromax Z"
            },
            {
                regex: "EG98",
                model: "Smartfren Andromax U2"
            },
            {
                regex: "HLTE200T(?:[);/ ]|$)",
                model: "F26"
            },
            {
                regex: "HLTE210T(?:[);/ ]|$)",
                model: "F28"
            },
            {
                regex: "HLTE215T(?:[);/ ]|$)",
                model: "F29"
            },
            {
                regex: "HLTE213T(?:[);/ ]|$)",
                model: "King Kong 4"
            },
            {
                regex: "HLTE311T(?:[);/ ]|$)",
                model: "King Kong 4 Pro"
            },
            {
                regex: "HLTE216T(?:[);/ ]|$)",
                model: "King Kong 5"
            },
            {
                regex: "HLTE316T(?:[);/ ]|$)",
                model: "King Kong 5 Pro"
            },
            {
                regex: "HLTE226T(?:[);/ ]|$)",
                model: "King Kong 6"
            },
            {
                regex: "HLTE217T(?:[);/ ]|$)",
                model: "F30S"
            },
            {
                regex: "HLTE227T(?:[);/ ]|$)",
                model: "F40"
            },
            {
                regex: "HLTE310[TM](?:[);/ ]|$)",
                model: "H18"
            },
            {
                regex: "HLTE510[TM](?:[);/ ]|$)",
                model: "H20"
            },
            {
                regex: "HLTE500T(?:[);/ ]|$)",
                model: "H11"
            },
            {
                regex: "HLTE230E(?:[);/ ]|$)",
                model: "H40 Lite"
            },
            {
                regex: "HLTE720T(?:[);/ ]|$)",
                model: "U30",
                device: "phablet"
            },
            {
                regex: "HWCD100E(?:[);/ ]|$)",
                model: "U40 Lite"
            },
            {
                regex: "(HLTE300T|HLTE200M|HLTE212T)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "HITV300C(?:[);/ ]|$)",
                model: "E9"
            },
            {
                regex: "E260T\\+(?:[);/ ]|$)",
                model: "Nana"
            },
            {
                regex: "(HS-(?:G|U|EG?|I|L|T|X)[0-9]+[a-z0-9\\-]*)",
                model: "$1"
            },
            {
                regex: "(HAT4KDTV)(?:[);/ ]|$)",
                device: "tv",
                model: "$1"
            },
            {
                regex: "(?:HS-)?Hisense ([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Hisense ([^);/]+)",
                model: "$1"
            }
        ]
    },
    "Hi-Level": {
        regex: "HLV-T([a-z0-9]+)",
        device: "tablet",
        model: "HLV-T$1"
    },
    Hoffmann: {
        regex: "(HOFFMANN|Neo[_ ]A[1379]00)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Neo[_ ](A[1379]00)",
                model: "Neo $1"
            },
            {
                regex: "HOFFMANN[ _]X[-_ ](Prime|Twist|Max)",
                model: "X $1"
            }
        ]
    },
    Homtom: {
        regex: "Homtom|(?:HT[0-9]{1,2})(?: ?Pro)?(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:Homtom[_ ])?HT ?([0-9]{1,2}(?: ?Pro)?)(?:[);/ ]|$)",
                model: "HT$1"
            },
            {
                regex: "Homtom ([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    Hosin: {
        regex: "HOSIN[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "HOSIN[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "HOSIN[ _-]([^;/]+)(?:[;/)]|$)",
                model: "$1"
            }
        ]
    },
    Hoozo: {
        regex: "(?:HOOZO[_ ](MT232|MT116|MT Pad 116 LTE|X1001)|HZ0010)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "HOOZO[_ ](MT232|MT116|MT Pad 116 LTE|X1001)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(HZ0010)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Minix: {
        regex: "NEO-(?:X8-H|U9-H|X[57]-mini|X8H-PLUS|X88-?I|X7-216A|X5-116A|X[68]|U1|Z64)(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "NEO-X8-H(?:[);/ ]|$)",
                model: "NEO X8H"
            },
            {
                regex: "NEO-X([57])-mini(?:[);/ ]|$)",
                model: "NEO X$1 Mini"
            },
            {
                regex: "NEO-X8H-PLUS(?:[);/ ]|$)",
                model: "NEO X8H Plus"
            },
            {
                regex: "NEO-X88-?I(?:[);/ ]|$)",
                model: "NEO X88i"
            },
            {
                regex: "NEO-X7-216A(?:[);/ ]|$)",
                model: "NEO X7"
            },
            {
                regex: "NEO-X5-116A(?:[);/ ]|$)",
                model: "NEO X5"
            },
            {
                regex: "NEO-X([68])(?:[);/ ]|$)",
                model: "NEO X$1"
            },
            {
                regex: "NEO-U1(?:[);/ ]|$)",
                model: "NEO U1"
            },
            {
                regex: "NEO-Z64(?:[);/ ]|$)",
                model: "NEO Z64"
            },
            {
                regex: "NEO-U9-H(?:[);/ ]|$)",
                model: "NEO U9H"
            }
        ]
    },
    Huawei: {
        regex: "(HW-)?(?:Huawei|MediaPad T1|Ideos|Honor[ _]?|(?:(?:AGS|AGS2|ALE|ALP|AMN|ANA|ANE|ARE|ARS|ASK|ATH|ATU|AUM|BAC|BAH[23]?|BG2|BGO|B[ZK]K|BKL|BL[ALN]|BND|BTV|CA[GMNZ]|CH[CM]|CHE[12]?|CLT|CMR|COL|COR|CPN|CRO|CRR|CUN|DIG|DLI|DRA|DUA|DUB|DUK|EDI|ELE|EML|EVA|EVR|FDR|FIG|FLA|FRD|FRL|GEM|GRA|HDN|HLK|HMA|Hol|HRY|HWI|H[36]0|INE|JAT|JEF|JDN|JDN2|JKM|JMM|JSN|KII|KIW|KNT|KOB|KSA|LDN|LEO|LIO|LLD|LND|LON|LRA|LUA|LY[AO]|MAR|MHA|MRD|MYA|NCE|NEM|NEO|NXT|PAR|PCT|PIC|PLE|PLK|POT|PPA|PRA|RIO|RNE|RVL|SCC|SCL|SCM|SEA|SHT|SLA|SNE|SPN|STF|STK|TAG|TIT|TNY|TRT|VCE|VEN|VIE|VKY|VNS|VOG|VRD|VTR|WAS|YAL|G(?:527|620S|621|630|735)|Y(?:221|330|550|6[23]5))-(?:[A-Z]{0,2}[0-9]{1,4}[A-Z]{0,3}?)|H1711|U(?:8230|8500|8661|8665|8667|8800|8818|8860|9200|9508))(?:[);/ ]|$))|hi6210sft|PE-(UL00|TL[12]0|TL00M)|T1-(A21[Lw]|A23L|701u|823L)|G7-(?:L01|TL00)|HW-01K|JNY-(LX[12]|AL10)|OXF-AN[01]0|TAS-(A[LN]00|L29|TL00)|WLZ-(AL10|AN00)|NIC-LX1A|MRX-(AL09|W09)|CDY-(?:[AT]N00|AN90|NX9A)|GLK-(?:[AT]L00|LX1U)|JER-[AT]N10|ELS-(?:[AT]N[10]0|NX9|N39|N04)|AKA-(AL10|L29)|MON-(W|AL)19|BMH-AN[12]0|AQM-([AT]L[01]0|LX1)|MOA-(AL[02]0|LX9N)|NTS-AL00|ART-(?:[AT]L00[xm]|L29N?|L28)|MED-(?:[AT]L00|LX9N?)|EBG-(?:AN[01]0|TN00)|ANA-(?:[AT]N00|NX9)|BZ[AK]-W00|BZT-(W09|AL[01]0)|HDL-(AL09|W09)|HWV3[123]|HW-02L|TEL-[AT]N(?:00a?|10)|KKG-AN00|MXW-AN00|JKM-AL00[ab]|TAH-(?:N29|AN00)m|C8817D|T1-821W|d-01[JK]|d-02[HK]|KRJ-W09|HWT31|Y320-U10|Y541-U02|VAT-L19|70[14]HW|60[58]HW|NOH-(?:NX9|AN00)|TNNH-AN00|LIO-(?:[TA]L00|[LN]29|AN00)|KOB2-[LW]09|AGS3-[WL]09|DNN-LX9|NEY-NX9|LON-AL00|HLK-L41|503HW|AGR-[LW]09|PPA-LX[12]|ANG-AN00|NOP-AN00",
        device: "smartphone",
        models: [
            {
                regex: "POT-[TA]L00a(?:[);/ ]|$)",
                model: "9S"
            },
            {
                regex: "U9500(?:[);/ ]|$)",
                model: "Ascend D1"
            },
            {
                regex: "Z100-UL00(?:[);/ ]|$)",
                model: "Ascend D3"
            },
            {
                regex: "Y320-(?:U10|T00|U05)(?:[);/ ]|$)",
                model: "Ascend Y320"
            },
            {
                regex: "Y330-U05(?:[);/ ]|$)",
                model: "Ascend Y330"
            },
            {
                regex: "Y541-U02(?:[);/ ]|$)",
                model: "Ascend Y5C"
            },
            {
                regex: "U8818(?:[);/ ]|$)",
                model: "Ascend G300"
            },
            {
                regex: "G527-U081(?:[);/ ]|$)",
                model: "Ascend G527"
            },
            {
                regex: "(G620S-L0[13]|C8817D)(?:[);/ ]|$)",
                model: "Ascend G620S"
            },
            {
                regex: "G630-U251(?:[);/ ]|$)",
                model: "Ascend G630"
            },
            {
                regex: "G7-(?:L01|TL00)(?:[);/ ]|$)",
                model: "Ascend G7"
            },
            {
                regex: "P7-L10(?:[);/ ]|$)",
                model: "Ascend P7"
            },
            {
                regex: "G730-C00(?:[);/ ]|$)",
                model: "Ascend G730"
            },
            {
                regex: "U9200(?:[);/ ]|$)",
                model: "Ascend P1"
            },
            {
                regex: "H1711(?:[);/ ]|$)",
                model: "Ascend XT2"
            },
            {
                regex: "Y221-U(?:[12]2|[0345]3)(?:[);/ ]|$)",
                model: "Ascend Y221"
            },
            {
                regex: "Y550-L03(?:[);/ ]|$)",
                model: "Ascend Y550"
            },
            {
                regex: "ART-[AT]L00[xm](?:[);/ ]|$)",
                model: "Enjoy 10"
            },
            {
                regex: "STK-[AT]L00(?:[);/ ]|$)",
                model: "Enjoy 10 Plus"
            },
            {
                regex: "MED-[AT]L00(?:[);/ ]|$)",
                model: "Enjoy 10E"
            },
            {
                regex: "AQM-[AT]L00(?:[);/ ]|$)",
                model: "Enjoy 10S"
            },
            {
                regex: "TAG-[ACT]L00(?:[);/ ]|$)",
                model: "Enjoy 5S"
            },
            {
                regex: "NCE-(AL[10]0|TL10)(?:[);/ ]|$)",
                model: "Enjoy 6"
            },
            {
                regex: "DIG-(?:TL10|AL00)(?:[);/ ]|$)",
                model: "Enjoy 6S"
            },
            {
                regex: "SLA-(?:AL00|TL10)(?:[);/ ]|$)",
                model: "Enjoy 7"
            },
            {
                regex: "FIG-(?:[AT]L[10]0)(?:[);/ ]|$)",
                model: "Enjoy 7S"
            },
            {
                regex: "(?:TRT-AL00[A]?|TRT-TL10A)(?:[);/ ]|$)",
                model: "Enjoy 7 Plus"
            },
            {
                regex: "LDN-(?:AL[12]0|TL[02]0)(?:[);/ ]|$)",
                model: "Enjoy 8"
            },
            {
                regex: "FLA-AL10(?:[);/ ]|$)",
                model: "Enjoy 8 Plus"
            },
            {
                regex: "ATU-[AT]L10(?:[);/ ]|$)",
                model: "Enjoy 8e"
            },
            {
                regex: "MRD-[TA]L00(?:[);/ ]|$)",
                model: "Enjoy 9e"
            },
            {
                regex: "DVC-TN20(?:[);/ ]|$)",
                model: "Enjoy 20 Pro"
            },
            {
                regex: "U8665(?:[);/ ]|$)",
                model: "Fusion 2"
            },
            {
                regex: "MED-LX9N?(?:[);/ ]|$)",
                model: "Y6p"
            },
            {
                regex: "G735-L(?:03|12|23)(?:[);/ ]|$)",
                model: "G Play"
            },
            {
                regex: "CHC-U(?:0[13]|23)(?:[);/ ]|$)",
                model: "G Play Mini"
            },
            {
                regex: "(?:Honor_|HW-)?G621-TL00M?(?:[);/ ]|$)",
                model: "G621"
            },
            {
                regex: "DIG-L2[12](?:[);/ ]|$)",
                model: "GR3 (2017)"
            },
            {
                regex: "KII-L21(?:[);/ ]|$)",
                model: "GR5"
            },
            {
                regex: "BLL-L2[12](?:[);/ ]|$)",
                model: "GR5 (2017)"
            },
            {
                regex: "RIO-L03(?:[);/ ]|$)",
                model: "GX8"
            },
            {
                regex: "U8860(?:[);/ ]|$)",
                model: "Honor"
            },
            {
                regex: "COL-(?:AL[01]0|TL[01]0|L29)(?:[);/ ]|$)",
                model: "Honor 10"
            },
            {
                regex: "HRY-(?:[AT]L00[A]?|LX[12]|LX1MEB)(?:[);/ ]|$)",
                model: "Honor 10 Lite"
            },
            {
                regex: "HRY-LX1T(?:[);/ ]|$)",
                model: "Honor 10I"
            },
            {
                regex: "U9508(?:[);/ ]|$)",
                model: "Honor 2"
            },
            {
                regex: "YAL-(?:L21|[AT]L00)(?:[);/ ]|$)",
                model: "Honor 20"
            },
            {
                regex: "LRA-AL00(?:[);/ ]|$)",
                model: "Honor 20 Lite"
            },
            {
                regex: "(HRY-AL00T[a]?)(?:[);/ ]|$)",
                model: "Honor 20I"
            },
            {
                regex: "YAL-(L41|AL10)(?:[);/ ]|$)",
                model: "Honor 20 Pro"
            },
            {
                regex: "(MAR-LX1H|YAL-AL50)(?:[);/ ]|$)",
                model: "Honor 20S"
            },
            {
                regex: "(?:BMH-AN[12]0|MXW-AN00)(?:[);/ ]|$)",
                model: "Honor 30"
            },
            {
                regex: "EBG-[AT]N00(?:[);/ ]|$)",
                model: "Honor 30 Pro"
            },
            {
                regex: "EBG-AN10(?:[);/ ]|$)",
                model: "Honor 30 Pro Plus"
            },
            {
                regex: "CDY-(?:AN90|NX9A)(?:[);/ ]|$)",
                model: "Honor 30S"
            },
            {
                regex: "LRA-LX1(?:[);/ ]|$)",
                model: "Honor 30I"
            },
            {
                regex: "(?:Honor_|HW-)?H30-(?:C00|L01M?|L02|U10|T00|T10)(?:_TD)?(?:[);/ ]|$)",
                model: "Honor 3C"
            },
            {
                regex: "Hol-U19(?:[);/ ]|$)",
                model: "Honor 3C Lite"
            },
            {
                regex: "G750-T01(?:[);/ ]|$)",
                model: "Honor 3X"
            },
            {
                regex: "(?:Honor_|HW-)?SCL-(?:AL00|CL00|TL00H?)(?:_TD)?(?:[);/ ]|$)",
                model: "Honor 4A"
            },
            {
                regex: "(?:Honor_|HW-)?CHM-U01(?:_TD)?(?:[);/ ]|$)",
                model: "Honor 4C"
            },
            {
                regex: "Honor 4c Pro(?:[);/ ]|$)",
                model: "Honor 4C Pro"
            },
            {
                regex: "AQM-AL10(?:[);/ ]|$)",
                model: "Honor 4T Pro"
            },
            {
                regex: "(CHE2?-[UT]L00[HM]?|CHE1-CL[12]0|CHE2-L(?:1[12]|23)|Che1-L04|CHE-TL00)(?:[);/ ]|$)",
                model: "Honor 4X"
            },
            {
                regex: "(?:Honor_|HW-)?CUN-[AT]L00(?:[);/ ]|$)",
                model: "Honor 5 Play"
            },
            {
                regex: "(?:Honor_|HW-)?CAM-(?:AL00|TL00H|TL00)(?:_TD)?(?:[);/ ]|$)",
                model: "Honor 5A"
            },
            {
                regex: "(?:Honor_|HW-)?NEM-(?:AL10|L51|UL10|TL00)(?:[);/ ]|$)",
                model: "Honor 5C"
            },
            {
                regex: "(?:Honor_|HW-)?NEM-(?:L22|TL00H)(?:[);/ ]|$)",
                model: "Honor 5C Dual SIM"
            },
            {
                regex: "(?:Honor_|HW-)?KIW-(?:AL10|TL00H|[TC]L00|L2[1-4]|UL00)(?:_TD)?(?:[);/ ]|$)",
                model: "Honor 5X"
            },
            {
                regex: "((?:Honor_|HW-)?H60-L(?:01|02|03|04|11|12)(?:_TD)?|HW-H60-J1)(?:[);/ ]|$)",
                model: "Honor 6"
            },
            {
                regex: "MYA-TL10(?:[);/ ]|$)",
                model: "Honor 6 Play"
            },
            {
                regex: "PE-(UL00|TL[12]0|TL00M)(?:[);/ ]|$)",
                model: "Honor 6 Plus"
            },
            {
                regex: "(?:HONOR[ _]?)?DLI-(?:AL10|L[24]2|TL20)(?:[);/ ]|$)",
                model: "Honor 6A"
            },
            {
                regex: "DIG-L21HN(?:[);/ ]|$)",
                model: "Honor 6C"
            },
            {
                regex: "JMM-L22(?:[);/ ]|$)",
                model: "Honor 6C Pro"
            },
            {
                regex: "(?:HONOR[ _]?)?BLN-(?:L2[124]|AL[1234]0|TL[01]0(?:[);/ ]|$))",
                model: "Honor 6X"
            },
            {
                regex: "(?:Honor[_]?|HW-)?PLK-(?:AL10|CL00|TL00|TL01H?|UL00|L01)(?:[);/ ]|$)",
                model: "Honor 7"
            },
            {
                regex: "(?:Honor_|HW-)?NEM-L21(?:[);/ ]|$)",
                model: "Honor 7 Lite"
            },
            {
                regex: "AUM-(?:AL[20]0|L33[A]?|TL20)(?:[);/ ]|$)",
                model: "Honor 7A"
            },
            {
                regex: "AUM-L29(?:[);/ ]|$)",
                model: "Honor 7A Pro"
            },
            {
                regex: "(?:Honor_|HW-)?(?:LND-(?:AL[34]0|L29|TL40)|AUM-L41)(?:[);/ ]|$)",
                model: "Honor 7C"
            },
            {
                regex: "ATH-(?:[CAU]L00|TL00H)(?:[);/ ]|$)",
                model: "Honor 7i"
            },
            {
                regex: "(?:Honor_|HW-)?DUA-(?:L22|LX3)(?:[);/ ]|$)",
                model: "Honor 7S"
            },
            {
                regex: "(?:HONOR[ _]?)?BND-(?:AL[01]0|TL10|L2[14]|L31)(?:[);/ ]|$)",
                model: "Honor 7X"
            },
            {
                regex: "(?:FRD-(?:AL[01]0|L0[249]|L1[49]|DL00)|VAT-L19)(?:[);/ ]|$)",
                model: "Honor 8"
            },
            {
                regex: "PRA-(?:AL00X|AL00|TL10)(?:[);/ ]|$)",
                model: "Honor 8 Lite"
            },
            {
                regex: "DUK-(?:L09|TL30)(?:[);/ ]|$)",
                model: "Honor 8 Pro"
            },
            {
                regex: "VEN-L22(?:[);/ ]|$)",
                model: "Honor 8 Smart"
            },
            {
                regex: "JAT-L(29|X[13])(?:[);/ ]|$)",
                model: "Honor 8A"
            },
            {
                regex: "JAT-L41(?:[);/ ]|$)",
                model: "Honor 8A Pro"
            },
            {
                regex: "BKK-(?:AL[10]0|L21|L22|LX2|TL00)(?:[);/ ]|$)",
                model: "Honor 8C"
            },
            {
                regex: "KSA-(LX[239]|AL00)(?:[);/ ]|$)",
                model: "Honor 8S"
            },
            {
                regex: "JSN-L(?:2[123]|42)|JSN-[TA]L00[a]?(?:[);/ ]|$)",
                model: "Honor 8X"
            },
            {
                regex: "ARE-(?:AL[10]0|L22(?:HN)?|TL00)(?:[);/ ]|$)",
                model: "Honor 8X Max"
            },
            {
                regex: "STF-(?:AL[10]0|L09S?|TL10)(?:[);/ ]|$)",
                model: "Honor 9"
            },
            {
                regex: "MOA-LX9N(?:[);/ ]|$)",
                model: "Honor 9A"
            },
            {
                regex: "AKA-L29(?:[);/ ]|$)",
                model: "Honor 9C"
            },
            {
                regex: "LLD-(?:AL[01]0|L[23]1|TL10)(?:[);/ ]|$)",
                model: "Honor 9 Lite"
            },
            {
                regex: "LLD-AL[23]0(?:[);/ ]|$)",
                model: "Honor 9i"
            },
            {
                regex: "DUA-LX9(?:[);/ ]|$)",
                model: "Honor 9S"
            },
            {
                regex: "HLK-AL00a?(?:[);/ ]|$)",
                model: "Honor 9X"
            },
            {
                regex: "HLK-(?:AL10|L4[12])(?:[);/ ]|$)",
                model: "Honor 9X Pro"
            },
            {
                regex: "CAM-UL00(?:[);/ ]|$)",
                model: "Honor Holly 3"
            },
            {
                regex: "NTS-AL00(?:[);/ ]|$)",
                model: "Honor Magic"
            },
            {
                regex: "TNY-[AT]L00(?:[);/ ]|$)",
                model: "Honor Magic 2"
            },
            {
                regex: "RVL-AL09(?:[);/ ]|$)",
                model: "Honor Note 10"
            },
            {
                regex: "EDI-AL10(?:[);/ ]|$)",
                model: "Honor Note 8"
            },
            {
                regex: "VKY-TL00(?:[);/ ]|$)",
                model: "Honor P10 Plus"
            },
            {
                regex: "VOG-AL00(?:[);/ ]|$)",
                model: "Honor P30 Pro"
            },
            {
                regex: "ANA-(?:[AT]N00|NX9)(?:[);/ ]|$)",
                model: "Honor P40"
            },
            {
                regex: "COR-(?:AL[01]0|L29|TL10)(?:[);/ ]|$)",
                model: "Honor Play"
            },
            {
                regex: "ASK-AL00x(?:[);/ ]|$)",
                model: "Honor Play 3"
            },
            {
                regex: "KSA-AL10(?:[);/ ]|$)",
                model: "Honor Play 3E"
            },
            {
                regex: "TNNH-AN00(?:[);/ ]|$)",
                model: "Honor Play 4"
            },
            {
                regex: "CHM-[CUT]L00[HM]?(?:[);/ ]|$)",
                model: "Honor Play 4C"
            },
            {
                regex: "AKA-AL10(?:[);/ ]|$)",
                model: "Honor Play 4T"
            },
            {
                regex: "DUA-[TA]L00(?:[);/ ]|$)",
                model: "Honor Play 7"
            },
            {
                regex: "JAT-[AT]L00(?:[);/ ]|$)",
                model: "Honor Play 8A"
            },
            {
                regex: "MOA-AL[02]0(?:[);/ ]|$)",
                model: "Honor Play 9A"
            },
            {
                regex: "BKL-(?:AL00|AL20|AL30|L09|TL10)(?:[);/ ]|$)",
                model: "Honor V10"
            },
            {
                regex: "PCT-[TA]L10(?:[);/ ]|$)",
                model: "Honor V20"
            },
            {
                regex: "KNT-(?:AL[12]0|[TU]L10)(?:[);/ ]|$)",
                model: "Honor V8"
            },
            {
                regex: "DUK-AL20(?:[);/ ]|$)",
                model: "Honor V9"
            },
            {
                regex: "JMM-[AT]L[01]0(?:[);/ ]|$)",
                model: "Honor V9 Play"
            },
            {
                regex: "BKL-L04(?:[);/ ]|$)",
                model: "Honor View 10"
            },
            {
                regex: "PCT-L29(?:[);/ ]|$)",
                model: "Honor View 20"
            },
            {
                regex: "OXF-AN00(?:[);/ ]|$)",
                model: "Honor View 30"
            },
            {
                regex: "OXF-AN10(?:[);/ ]|$)",
                model: "Honor View 30 Pro"
            },
            {
                regex: "(?:Honor_|HW-)?SCL-L(01|32)(?:_TD)?(?:[);/ ]|$)",
                model: "Honor Y6"
            },
            {
                regex: "(?:Honor_|HW-)?LYO-L21(?:[);/ ]|$)",
                model: "Honor Y6 II Compact"
            },
            {
                regex: "TEL-(?:AN(?:00a?|10)|TN00)(?:[);/ ]|$)",
                model: "Honor X10"
            },
            {
                regex: "KKG-AN00(?:[);/ ]|$)",
                model: "Honor X10 Max"
            },
            {
                regex: "DNN-LX9(?:[);/ ]|$)",
                model: "Honor X10 Lite"
            },
            {
                regex: "U8500(?:[);/ ]|$)",
                model: "Ideos X2"
            },
            {
                regex: "U8510(?:[);/ ]|$)",
                model: "Ideos X3"
            },
            {
                regex: "U8800(?:[);/ ]|$)",
                model: "Ideos X5"
            },
            {
                regex: "MLA-AL10(?:[);/ ]|$)",
                model: "Maimang 5"
            },
            {
                regex: "POT-AL10(?:[);/ ]|$)",
                model: "Maimang 8"
            },
            {
                regex: "TAH-(?:N29|AN00)m(?:[);/ ]|$)",
                model: "Mate XS"
            },
            {
                regex: "ALP-(?:[TA]L00|L[02]9)(?:[);/ ]|$)",
                model: "Mate 10"
            },
            {
                regex: "RNE-(?:AL00|L(?:01|03|21|23))(?:[);/ ]|$)",
                model: "Mate 10 Lite"
            },
            {
                regex: "BLA-(?:A09|L[02]9|[TA]L00)(?:[);/ ]|$)",
                model: "Mate 10 Pro"
            },
            {
                regex: "HMA-(?:[AT]L00|L[02]9)(?:[);/ ]|$)",
                model: "Mate 20"
            },
            {
                regex: "SNE-(?:AL00|LX[0-3])(?:[);/ ]|$)",
                model: "Mate 20 Lite"
            },
            {
                regex: "LYA-(?:AL[01]0|L[02]9|L0C|TL00)(?:[);/ ]|$)",
                model: "Mate 20 Pro"
            },
            {
                regex: "LYA-AL00P(?:[);/ ]|$)",
                model: "Mate 20 RS"
            },
            {
                regex: "EVR-(?:[TA]L00|L29|N29|AN00)(?:[);/ ]|$)",
                model: "Mate 20 X"
            },
            {
                regex: "TAS-([AT]L00|L29)(?:[);/ ]|$)",
                model: "Mate 30"
            },
            {
                regex: "TAS-AN00(?:[);/ ]|$)",
                model: "Mate 30 5G"
            },
            {
                regex: "SPN-AL00(?:[);/ ]|$)",
                model: "Mate 30 Lite"
            },
            {
                regex: "LIO-(?:[TA]L00|L29|AN00)(?:[);/ ]|$)",
                model: "Mate 30 Pro"
            },
            {
                regex: "LIO-N29(?:[);/ ]|$)",
                model: "Mate 30 Pro 5G"
            },
            {
                regex: "NOH-(?:NX9|AN00)(?:[);/ ]|$)",
                model: "Mate 40 Pro"
            },
            {
                regex: "NOP-AN00(?:[);/ ]|$)",
                model: "Mate 40 Pro+"
            },
            {
                regex: "NXT-(?:AL10|L29)(?:[);/ ]|$)",
                model: "Mate 8"
            },
            {
                regex: "MHA-(?:L[02]9|[AT]L00)(?:[);/ ]|$)",
                model: "Mate 9"
            },
            {
                regex: "BLL-L23(?:[);/ ]|$)",
                model: "Mate 9 Lite"
            },
            {
                regex: "LON-(?:AL00(?:-PD)?|L29)(?:[);/ ]|$)",
                model: "Mate 9 Pro"
            },
            {
                regex: "NEO-AL00(?:[);/ ]|$)",
                model: "Mate RS"
            },
            {
                regex: "NEO-L29(?:[);/ ]|$)",
                model: "Mate RS Porsche Design"
            },
            {
                regex: "CRR-(?:L09|UL00)(?:[);/ ]|$)",
                model: "Mate S"
            },
            {
                regex: "BND-L34(?:[);/ ]|$)",
                model: "Mate SE"
            },
            {
                regex: "(CAZ-(?:AL[01]0|TL[12]0)|CAN-L[01][1-3])(?:[);/ ]|$)",
                model: "Nova"
            },
            {
                regex: "608HW(?:[);/ ]|$)",
                model: "Nova Lite"
            },
            {
                regex: "(?:PIC-(?:[AT]L00|LX9)|HWV31)(?:[);/ ]|$)",
                model: "Nova 2"
            },
            {
                regex: "704HW(?:[);/ ]|$)",
                model: "Nova 2 Lite"
            },
            {
                regex: "BAC-(?:L01|TL00)(?:[);/ ]|$)",
                model: "Nova 2 Plus"
            },
            {
                regex: "BAC-(?:AL00|L2[12])(?:[);/ ]|$)",
                model: "Nova 2 Plus Dual SIM"
            },
            {
                regex: "RNE-L[02]2(?:[);/ ]|$)",
                model: "Nova 2I"
            },
            {
                regex: "HWI-[AT]L00(?:[);/ ]|$)",
                model: "Nova 2S"
            },
            {
                regex: "PAR-(?:[AT]L00|LX[19]|LX1M|TL20)(?:[);/ ]|$)",
                model: "Nova 3"
            },
            {
                regex: "ANE-AL00(?:[);/ ]|$)",
                model: "Nova 3e"
            },
            {
                regex: "INE-(?:AL00|LX[12]r|LX[12]|TL00)(?:[);/ ]|$)",
                model: "Nova 3i"
            },
            {
                regex: "VCE-(L22|[AT]L00)(?:[);/ ]|$)",
                model: "Nova 4"
            },
            {
                regex: "MAR-AL00(?:[);/ ]|$)",
                model: "Nova 4e"
            },
            {
                regex: "SEA-AL00(?:[);/ ]|$)",
                model: "Nova 5"
            },
            {
                regex: "SEA-AL10(?:[);/ ]|$)",
                model: "Nova 5 Pro"
            },
            {
                regex: "GLK-(?:[AT]L00|LX1U)(?:[);/ ]|$)",
                model: "Nova 5i"
            },
            {
                regex: "SPN-TL00(?:[);/ ]|$)",
                model: "Nova 5i Pro"
            },
            {
                regex: "WLZ-AL10(?:[);/ ]|$)",
                model: "Nova 6"
            },
            {
                regex: "WLZ-AN00(?:[);/ ]|$)",
                model: "Nova 6 5G"
            },
            {
                regex: "JNY-AL10(?:[);/ ]|$)",
                model: "Nova 6 SE"
            },
            {
                regex: "JEF-(?:[AT]N00|AN20|NX9)(?:[);/ ]|$)",
                model: "Nova 7 5G"
            },
            {
                regex: "JER-[AT]N10(?:[);/ ]|$)",
                model: "Nova 7 Pro 5G"
            },
            {
                regex: "CDY-(?:[AT]N00|NX9B)(?:[);/ ]|$)",
                model: "Nova 7 SE 5G"
            },
            {
                regex: "JNY-LX2(?:[);/ ]|$)",
                model: "Nova 7i"
            },
            {
                regex: "ANG-AN00(?:[);/ ]|$)",
                model: "Nova 8 5G"
            },
            {
                regex: "DIG-L01(?:[);/ ]|$)",
                model: "Nova Smart"
            },
            {
                regex: "WAS-AL00(?:[);/ ]|$)",
                model: "Nova Youth"
            },
            {
                regex: "FIG-L(?:A1|X[123])(?:[);/ ]|$)",
                model: "P smart"
            },
            {
                regex: "POT-(?:LX(?:[13]|1T|2J|1AF)|AL00)(?:[);/ ]|$)",
                model: "P smart (2019)"
            },
            {
                regex: "POT-LX1A(?:[);/ ]|$)",
                model: "P smart (2020)"
            },
            {
                regex: "PPA-LX[12](?:[);/ ]|$)",
                model: "P smart (2021)"
            },
            {
                regex: "STK-LX1(?:[);/ ]|$)",
                model: "P smart Z"
            },
            {
                regex: "VTR-(?:L[02]9|AL00|TL00)(?:[);/ ]|$)",
                model: "P10"
            },
            {
                regex: "WAS-(?:L(?:X1|X1A|X2|X2J|X3|03T)|TL10)(?:[);/ ]|$)",
                model: "P10 Lite"
            },
            {
                regex: "VKY-(?:AL00|L09|L29)(?:[);/ ]|$)",
                model: "P10 Plus"
            },
            {
                regex: "BAC-L[02]3(?:[);/ ]|$)",
                model: "P10 Selfie"
            },
            {
                regex: "EML-(?:[TA]L00|L[02]9)(?:[);/ ]|$)",
                model: "P20"
            },
            {
                regex: "(?:ANE-(?:LX[123]|LX2J|TL00)|HWV32)(?:[);/ ]|$)",
                model: "P20 Lite"
            },
            {
                regex: "(?:CLT-(?:AL0[01]|TL0[01]|L(?:04|[02]9))|HW-01K)(?:[);/ ]|$)",
                model: "P20 Pro"
            },
            {
                regex: "(ELE-L(?:04|09|29)|ELE-[AT]L00)(?:[);/ ]|$)",
                model: "P30"
            },
            {
                regex: "(?:MAR-(?:LX(?:1[BM]|2J?|3BM)|TL00)|NIC-LX1A|HWV33)(?:[);/ ]|$)",
                model: "P30 Lite"
            },
            {
                regex: "MAR-LX[13]Am?(?:[);/ ]|$)",
                model: "P30 Lite Dual SIM"
            },
            {
                regex: "(?:VOG-(?:L(?:04|09|29)|TL00|AL10)|HW-02L)(?:[);/ ]|$)",
                model: "P30 Pro"
            },
            {
                regex: "ANA-LX4(?:[);/ ]|$)",
                model: "P40"
            },
            {
                regex: "JNY-LX1(?:[);/ ]|$)",
                model: "P40 Lite"
            },
            {
                regex: "ART-L29(?:[);/ ]|$)",
                model: "P40 Lite E"
            },
            {
                regex: "ART-L29N(?:[);/ ]|$)",
                model: "P40 Lite E NFC"
            },
            {
                regex: "(?:ELS-(?:[AT]N00|NX9|N04)|NEY-NX9)(?:[);/ ]|$)",
                model: "P40 Pro"
            },
            {
                regex: "ELS-(?:AN10|N39)(?:[);/ ]|$)",
                model: "P40 Pro Plus"
            },
            {
                regex: "GRA-(?:L09|UL00)(?:[);/ ]|$)",
                model: "P8"
            },
            {
                regex: "(?:ALE-L(?:02|21|23)|ALE-UL00|ALE-TL00|503HW)(?:[);/ ]|$)",
                model: "P8 Lite (2015)"
            },
            {
                regex: "(?:PRA-L(?:A1|X2|X1|X3)|hi6210sft)(?:[);/ ]|$)",
                model: "P8 Lite (2017)"
            },
            {
                regex: "EVA-(?:AL[10]0|L[012]9|[TCD]L00)(?:[);/ ]|$)",
                model: "P9"
            },
            {
                regex: "VNS-L(?:[23]1|[26]2)(?:[);/ ]|$)",
                model: "P9 Lite"
            },
            {
                regex: "SLA-L(?:02|03|22|23)(?:[);/ ]|$)",
                model: "P9 Lite Mini"
            },
            {
                regex: "DIG-L(?:03|23)(?:[);/ ]|$)",
                model: "P9 Lite Smart"
            },
            {
                regex: "VIE-(?:AL10|L[02]9)(?:[);/ ]|$)",
                model: "P9 Plus"
            },
            {
                regex: "ATH-UL0[16](?:[);/ ]|$)",
                model: "ShotX"
            },
            {
                regex: "U(8230|8661|8667)(?:[);/ ]|$)",
                model: "U$1"
            },
            {
                regex: "ARS-([AT]L00|L22)(?:[);/ ]|$)",
                model: "Y Max"
            },
            {
                regex: "CRO-(?:L[02]2|U00)(?:[);/ ]|$)",
                model: "Y3 (2017)"
            },
            {
                regex: "CAG-L[02]2(?:[);/ ]|$)",
                model: "Y3 (2018)"
            },
            {
                regex: "LUA-(U22|L2[12]|U03)(?:[);/ ]|$)",
                model: "Y3II"
            },
            {
                regex: "MYA-(?:L(?:02|03|2[23])|U29)(?:[);/ ]|$)",
                model: "Y5 (2017)"
            },
            {
                regex: "DRA-L(?:01|03|21|23|X3)(?:[);/ ]|$)",
                model: "Y5 (2018)"
            },
            {
                regex: "AMN-LX[1239](?:[);/ ]|$)",
                model: "Y5 (2019)"
            },
            {
                regex: "DRA-LX5(?:[);/ ]|$)",
                model: "Y5 lite"
            },
            {
                regex: "DRA-LX9(?:[);/ ]|$)",
                model: "Y5p"
            },
            {
                regex: "CRO-L[02]3(?:[);/ ]|$)",
                model: "Y5 Lite (2017)"
            },
            {
                regex: "CAG-L[02]3(?:[);/ ]|$)",
                model: "Y5 Lite (2018)"
            },
            {
                regex: "DRA-(?:LX2|[AT]L00)(?:[);/ ]|$)",
                model: "Y5 Prime (2018)"
            },
            {
                regex: "MYA-L13(?:[);/ ]|$)",
                model: "Y5 Pro (2017)"
            },
            {
                regex: "CUN-(?:L(?:0[123]|2[123]|33)|U29)(?:[);/ ]|$)",
                model: "Y5II"
            },
            {
                regex: "(?:SCC-U21|SCL-U31)(?:[);/ ]|$)",
                model: "Y6"
            },
            {
                regex: "MYA-L11(?:[);/ ]|$)",
                model: "Y6 (2016)"
            },
            {
                regex: "MYA-(L41|AL10)(?:[);/ ]|$)",
                model: "Y6 (2017)"
            },
            {
                regex: "ATU-L(?:11|21|22|X3)(?:[);/ ]|$)",
                model: "Y6 (2018)"
            },
            {
                regex: "MRD-L(?:X1[NF]?|X3)(?:[);/ ]|$)",
                model: "Y6 (2019)"
            },
            {
                regex: "ATU-L(?:31|42)(?:[);/ ]|$)",
                model: "Y6 Prime (2018)"
            },
            {
                regex: "TIT-(?:AL00|L01|U02)(?:[);/ ]|$)",
                model: "Y6 Pro"
            },
            {
                regex: "MRD-LX2(?:[);/ ]|$)",
                model: "Y6 Pro (2019)"
            },
            {
                regex: "Y625-U03(?:[);/ ]|$)",
                model: "Y625"
            },
            {
                regex: "Y635-L0[123](?:[);/ ]|$)",
                model: "Y635"
            },
            {
                regex: "Y635-L21(?:[);/ ]|$)",
                model: "Y635 Dual SIM"
            },
            {
                regex: "CAM-L(?:03|21|23|32)(?:[);/ ]|$)",
                model: "Y6II"
            },
            {
                regex: "TRT-LX[123](?:[);/ ]|$)",
                model: "Y7 (2017)"
            },
            {
                regex: "LDN-L(?:01|X3)(?:[);/ ]|$)",
                model: "Y7 (2018)"
            },
            {
                regex: "(?:HUAWEI[ _]?)?DUB-(?:LX[13]|TL00)(?:[);/ ]|$)",
                model: "Y7 (2019)"
            },
            {
                regex: "(LDN-(?:AL00|L21)|TRT-TL10)(?:[);/ ]|$)",
                model: "Y7 Prime"
            },
            {
                regex: "(LDN-(?:LX2|TL10)|TRT-(?:L21A|L53))(?:[);/ ]|$)",
                model: "Y7 Prime (2018)"
            },
            {
                regex: "DUB-(?:LX2|AL00)(?:[);/ ]|$)",
                model: "Y7 Pro (2019)"
            },
            {
                regex: "DUB-AL00a(?:[);/ ]|$)",
                model: "Enjoy 9"
            },
            {
                regex: "DUB-AL20(?:[);/ ]|$)",
                model: "Y7 Pro (2019)"
            },
            {
                regex: "PPA-LX3(?:[);/ ]|$)",
                model: "Y7a"
            },
            {
                regex: "ART-L28(?:[);/ ]|$)",
                model: "Y7p"
            },
            {
                regex: "AQM-LX1(?:[);/ ]|$)",
                model: "Y8p"
            },
            {
                regex: "FLA-(LX[123]|AL20|TL10)(?:[);/ ]|$)",
                model: "Y9 (2018)"
            },
            {
                regex: "JKM-(?:[TA]L00[ab]?|LX[123])(?:[);/ ]|$)",
                model: "Y9 (2019)"
            },
            {
                regex: "STK-(L2[12]|LX3)(?:[);/ ]|$)",
                model: "Y9 Prime (2019)"
            },
            {
                regex: "FRL-L2[23](?:[);/ ]|$)",
                model: "Y9a"
            },
            {
                regex: "HWT31(?:[);/ ]|$)",
                model: 'Qua Tab 02 10.1"',
                device: "tablet"
            },
            {
                regex: "HDN-[LW]09(?:[);/ ]|$)",
                model: "Honor Water Play 10.1",
                device: "tablet"
            },
            {
                regex: "BAH3-(?:AL00|[LW]09)(?:[);/ ]|$)",
                model: 'MatePad 10.4"',
                device: "tablet"
            },
            {
                regex: "BAH3-W59(?:[);/ ]|$)",
                model: 'MatePad 10.4" WiFi',
                device: "tablet"
            },
            {
                regex: "AGS3-[WL]09(?:[);/ ]|$)",
                model: "MatePad T10s",
                device: "tablet"
            },
            {
                regex: "HDL-(?:W09|AL09)(?:[);/ ]|$)",
                model: "Honor Water Play 8.0",
                device: "tablet"
            },
            {
                regex: "JDN-(?:AL00|W09)(?:[);/ ]|$)",
                model: "Honor Pad 2",
                device: "tablet"
            },
            {
                regex: "KRJ-W09(?:[);/ ]|$)",
                model: "Honor Pad V6",
                device: "tablet"
            },
            {
                regex: "MON-(W|AL)19(?:[);/ ]|$)",
                device: "tablet",
                model: "MatePad C5 8"
            },
            {
                regex: "BZA-W00(?:[);/ ]|$)",
                device: "tablet",
                model: "C3 9.6"
            },
            {
                regex: "M2-801L(?:[);/ ]|$)",
                device: "tablet",
                model: 'MediaPad M2 8.0"'
            },
            {
                regex: "MRX-(AL09|W09)(?:[);/ ]|$)",
                device: "tablet",
                model: "MatePad Pro"
            },
            {
                regex: "CMR-(?:AL[01]9|W09)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad M5 10.8"
            },
            {
                regex: "CMR-W19(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad M5 Pro 10.8"
            },
            {
                regex: "SCM-AL09(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad M5 Pro"
            },
            {
                regex: "GEM-70[1-3]L(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad X2"
            },
            {
                regex: "(?:JDN2-(:?[WL]09|AL[50]0)|BAH2-(?:AL[01]0|L09|W[01]9))(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad M5 Lite"
            },
            {
                regex: "SHT-(?:AL|W)09(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad M5 8.4"
            },
            {
                regex: "VRD-(?:(AL|W)09|AL10|W10)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad M6 8.4"
            },
            {
                regex: "SCM-W09(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad M6 10"
            },
            {
                regex: "BTV-W09(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad M3 8"
            },
            {
                regex: "(BAH-W09|CPN-(?:L|W)09|CPN-AL00|701HW)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad M3 Lite"
            },
            {
                regex: "BAH-(?:L09|AL00)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad M3 Lite 10"
            },
            {
                regex: "BTV-DL09",
                device: "tablet",
                model: "MediaPad M3"
            },
            {
                regex: "(AGS2-AL00|JDN2-W09)HN(?:[);/ ]|$)",
                device: "tablet",
                model: "Honor Tab 5"
            },
            {
                regex: "AGS2-(?:[LW]09|W19|L03)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T5 10"
            },
            {
                regex: "KOB2-[LW]09(?:[);/ ]|$)",
                device: "tablet",
                model: 'MediaPad T 8.0"'
            },
            {
                regex: "AGR-[LW]09(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T 10"
            },
            {
                regex: "AGS-(?:L0[39]|W09)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T3 10"
            },
            {
                regex: "(KOB-(?:L|W)09|BZK-[LW]00)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T3 8"
            },
            {
                regex: "BG2-(?:U0[13]|W09)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T3 7"
            },
            {
                regex: "BGO-L03(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T2 7.0"
            },
            {
                regex: "(?:BGO-DL09|PLE-70[13]L)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T2 7.0 Pro"
            },
            {
                regex: "JDN-L01(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T2 8.0 Pro"
            },
            {
                regex: "(?:FDR-(A01[LW]|A03L)|605HW)(?:[);/ ]|$)",
                device: "tablet",
                model: 'MediaPad T2 10.0" Pro'
            },
            {
                regex: "T1-(?:A21[LW]|A23L)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T1 10"
            },
            {
                regex: "T1-701u(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T1 7"
            },
            {
                regex: "(?:T1-82(?:3L|1W)|MediaPad T1 8.0)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad T1 8"
            },
            {
                regex: "AGS2-AL00(?:[);/ ]|$)",
                device: "tablet",
                model: "Enjoy Tablet 10.1"
            },
            {
                regex: "BZT-(W09|AL[01]0)(?:[);/ ]|$)",
                device: "tablet",
                model: "MediaPad C5 10.1"
            },
            {
                regex: "(?:d-01J|d-02[HK])(?:[);/ ]|$)",
                device: "tablet",
                model: "D Tab Compact"
            },
            {
                regex: "(d-01K)(?:[);/ ]|$)",
                device: "tablet",
                model: "dtab d-01K"
            },
            {
                regex: "LEO-BX9(?:[);/ ]|$)",
                device: "wearable",
                model: "Smart Watch 2"
            },
            {
                regex: "(MediaPad[^/;]*) Build",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "Ideos([^;/]*) Build",
                model: "Ideos$1"
            },
            {
                regex: "(?:HUAWEI )?MT([0-9]+)",
                device: "phablet",
                model: "Ascend Mate $1"
            },
            {
                regex: "Huawei[ _\\-]?([^/;]*) Build",
                model: "$1"
            },
            {
                regex: "(?:HW-)?Huawei(?!Browser)(?:/1\\.0/0?(?:Huawei))?[_\\- /]?([a-z0-9\\-_]+)",
                model: "$1"
            },
            {
                regex: "Huawei; ([a-z0-9 \\-]+)",
                model: "$1"
            }
        ]
    },
    Hyundai: {
        regex: "Hyundai|Ultra (?:Active|Air|Charm|Dream|Energy|Latitude|Link|Live|Shadow|Shine|Storm|Style|Sync|Trend|Vision|Wave)|G(24027|2552[34])K|W25042L|HP554O|Seoul S8|L503F Plus|HT0701L16|HT0704K08|HT1004L16|HT1004LI16|Koral_8W2|Eternity[_ ]G25",
        device: "smartphone",
        models: [
            {
                regex: "Ultra (Active|Air|Charm|Dream|Energy Lite|Energy Plus|Energy|Latitude|Link|Live II|Live|Shadow|Shine|Storm|Style|Sync|Trend|Vision|Wave)",
                model: "Ultra $1"
            },
            {
                regex: "Seoul S8",
                model: "Seoul S8"
            },
            {
                regex: "G25523K",
                model: "Eternity G23"
            },
            {
                regex: "Eternity[_ ]G25",
                model: "Eternity G25"
            },
            {
                regex: "G25524K",
                model: "Eternity G24"
            },
            {
                regex: "G24027K",
                model: "Eternity G27"
            },
            {
                regex: "W25042L",
                model: "Eternity W42"
            },
            {
                regex: "HP554O",
                model: "HP554O"
            },
            {
                regex: "L503F Plus",
                model: "L503F Plus"
            },
            {
                regex: "L503F Plus",
                model: "L503F Plus"
            },
            {
                regex: "(?:Hyundai_)?(Eternity_G57L)",
                model: "$1"
            },
            {
                regex: "HT0701L16",
                model: "Koral 7XL",
                device: "tablet"
            },
            {
                regex: "HT1004LI16",
                model: "Koral 10XL",
                device: "tablet"
            },
            {
                regex: "Koral_8W2",
                model: "Koral 8W2",
                device: "tablet"
            },
            {
                regex: "HT1004L16",
                model: "Koral 10XL",
                device: "tablet"
            },
            {
                regex: "HT0704K08",
                model: "Koral 7M4",
                device: "tablet"
            },
            {
                regex: "Hyundai ([^;/]+) Build",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Hyundai[ _\\-]?([a-z0-9_-]+)",
                model: "$1",
                device: "tablet"
            }
        ]
    },
    "i-Joy": {
        regex: "i-Joy|i-Call|(?:Neon[79]|Sygnus|Deox|Elektra (?:M|L|XL|XXL))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Elektra M(?:[);/ ]|$)",
                model: "Elektra M"
            },
            {
                regex: "Elektra L(?:[);/ ]|$)",
                model: "Elektra L"
            },
            {
                regex: "Elektra XL(?:[);/ ]|$)",
                model: "Elektra XL"
            },
            {
                regex: "Elektra XXL(?:[);/ ]|$)",
                model: "Elektra XXL",
                device: "phablet"
            },
            {
                regex: "Neon([79])(?:[);/ ]|$)",
                model: "Neon $1",
                device: "tablet"
            },
            {
                regex: "Sygnus(?:[);/ ]|$)",
                model: "Sygnus",
                device: "tablet"
            },
            {
                regex: "Deox(?:[);/ ]|$)",
                model: "Deox",
                device: "tablet"
            },
            {
                regex: "i-Call ([^;/]+) Build",
                model: "i-Call $1"
            },
            {
                regex: "i-Joy ([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    iBall: {
        regex: "iBall[ _]([^;/)]+)[ _]Build|iBall_Slide|(?:Snap[_ ]4G2|6351-Q400i|iT-KSA0003|iT-KSA0012|iT-KSA0066|Avid|Twinkle_i5|Gorgeo[_ ]4GL|Brisk 4G2|Blaze_V4|Wondro 10|Q27 4G|Andi (?:Wink|5G Blink) 4G)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "Andi Wink 4G",
                device: "smartphone",
                model: "Andi Wink 4G"
            },
            {
                regex: "Andi 5G Blink 4G",
                device: "smartphone",
                model: "Andi 5G Blink 4G"
            },
            {
                regex: "(Snap[_ ]4G2|Avid|Twinkle_i5|Gorgeo[_ ]4GL|Blaze_V4|Wondro 10|Q27 4G|Brisk 4G2)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "6351-Q400i(?:[);/ ]|$)",
                model: "Slide"
            },
            {
                regex: "iT-KSA0003(?:[);/ ]|$)",
                model: "iTAB BizniZ"
            },
            {
                regex: "iT-KSA0066(?:[);/ ]|$)",
                model: "iTAB BizniZ Mini"
            },
            {
                regex: "iT-KSA0012(?:[);/ ]|$)",
                model: "iTAB Moviez Pro"
            },
            {
                regex: "iBall[ _]([^;/)]+)(?:[ _]Build|\\))",
                model: "$1"
            }
        ]
    },
    iRola: {
        regex: "iRola ([^/;]+) Build|(DX758|DX752|DX752|DX758[ _]?Pro) Build",
        device: "tablet",
        models: [
            {
                regex: "DX758[ _]?Pro",
                model: "DX758 Pro"
            },
            {
                regex: "(DX758|DX752)",
                model: "$1"
            },
            {
                regex: "iRola ([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    iRulu: {
        regex: "iRULU[ _-](X11|V[34]|U2|AL101)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "iRULU[ _-](X11|V[34]|AL101)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "iRULU[ _](U2)(?:[);/ ]|$)",
                device: "smartphone",
                model: "$1"
            }
        ]
    },
    Irbis: {
        regex: "IRBIS|TZ(1(?:0[04]|42|5[01]|84|65|7[01345-89]|8[356]|9[12578])|49|55|72|22|7(?:1[124679]|2[021567]|37|4[257]|5[23457]|6[12]|72|7[17]|8[1]|9[147])|8(?:[34]1|5[3-8]|6[45]|7[2478]|8[1-5]|9[0127])|96[0-9])|TZ85|TZ13|TZ(?:one|art|HIT|81L)|(SP(?:0[56]|2[01]|4[1-36]|40[12]|45[345]|49[34]|50|51[0147]|531|54[12]|55[0124]|571))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(TZ(?:[0-9]+)|TZ(?:one|art|HIT|81L))(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(SP[0-9]+)(?:[);/ ]|$)",
                device: "smartphone",
                model: "$1"
            }
        ]
    },
    iBerry: {
        regex: "AUXUS ([^/;]+) Build",
        device: "smartphone",
        models: [
            {
                regex: "AUXUS (Core[^/;]+) Build",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "AUXUS ([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    iHunt: {
        regex: "iHunt|One_ Love_|TITAN_P11000_PRO|Like_(3|4U|3_Pro)|X300 Elite|S10_Tank_2019|S60_Discovery_2019|AlienXLite2020|Alien X Lite|Alien_X|S20 Ultra ApeX 2021",
        device: "smartphone",
        models: [
            {
                regex: "iHunt_Like",
                model: "Like"
            },
            {
                regex: "S10_Tank_2019",
                model: "S10 Tank (2019)"
            },
            {
                regex: "One_ Love_",
                model: "One Love"
            },
            {
                regex: "TITAN_P11000_PRO",
                model: "Titan P11000 Pro"
            },
            {
                regex: "Like_3_Pro",
                model: "Like 3 Pro"
            },
            {
                regex: "Like_3",
                model: "Like 3"
            },
            {
                regex: "Like_4U",
                model: "Like 4U"
            },
            {
                regex: "X300 Elite",
                model: "X300 Elite"
            },
            {
                regex: "S60_Discovery_2019",
                model: "S60 Discovery (2019)"
            },
            {
                regex: "AlienXLite2020",
                model: "Alien X Lite (2020)"
            },
            {
                regex: "Alien X Lite PRO",
                model: "Alien X Lite Pro"
            },
            {
                regex: "Alien X Lite",
                model: "Alien X Lite"
            },
            {
                regex: "Alien_X_ApeX",
                model: "Alien X ApeX"
            },
            {
                regex: "Alien_X",
                model: "Alien X"
            },
            {
                regex: "S20 Ultra ApeX 2021",
                model: "S20 Ultra ApeX (2021)"
            }
        ]
    },
    IconBIT: {
        regex: "IconBIT|NT-(3506M|0704S|0909T|1009T|10[01]1T|1017T|3601P/3602P|3603P|3702S|3805C|3905T|3701S|0701S|0805C|0902S|370[23]M)|XDS[789]4K|Omnicast UHD|Movie Smart 4K|Movie IPTV Quad",
        device: "tablet",
        models: [
            {
                regex: "NT-3506M",
                device: "smartphone",
                model: "NetTAB Mercury Quad FHD"
            },
            {
                regex: "NT-0704S",
                model: "NetTAB Sky LE"
            },
            {
                regex: "NT-0909T",
                model: "NetTAB Thor IZ"
            },
            {
                regex: "NT-1009T",
                model: "NetTAB Thor quad II"
            },
            {
                regex: "NT-10[01]1T",
                model: "NetTAB Thor LE"
            },
            {
                regex: "NT-1017T",
                model: "NetTAB Thor 3G quad"
            },
            {
                regex: "NT-3601P/3602P",
                model: "NetTAB Pocket 3G"
            },
            {
                regex: "NT-3603P",
                model: "NetTAB Pocket 3G Slim"
            },
            {
                regex: "NT-3702S",
                model: "NetTAB Sky HD 3G"
            },
            {
                regex: "NT-3805C",
                model: "NetTAB Skat 3G quad"
            },
            {
                regex: "NT-3701S",
                model: "NetTAB Sky 3G duo"
            },
            {
                regex: "NT-3905T",
                model: "NetTAB Thor ZX 3G"
            },
            {
                regex: "NT-0701S",
                model: "NetTAB Sky net"
            },
            {
                regex: "NT-0805C",
                model: "NetTAB Skat MX"
            },
            {
                regex: "NT-0902S",
                model: "NetTAB Space quad RX"
            },
            {
                regex: "NT-3702M",
                model: "NetTAB Matrix 3G duo"
            },
            {
                regex: "NT-3703M",
                model: "NetTAB Matrix 3GT"
            },
            {
                regex: "(?:iconBIT )?(Movie Smart 4K|Movie IPTV Quad|Movie Ultra HD 4K|XDS[789]4K|Omnicast UHD)",
                model: "$1",
                device: "tv"
            }
        ]
    },
    LYF: {
        regex: "(LYF[ _])?LS-[456][0-9]{3}|LYF/[^/]+/",
        device: "smartphone",
        models: [
            {
                regex: "LS-4004",
                model: "Flame 2"
            },
            {
                regex: "LS-5501",
                model: "Earth 1"
            },
            {
                regex: "LS-5021",
                model: "Earth 2"
            },
            {
                regex: "LS-5505",
                model: "Water F1"
            },
            {
                regex: "LS-4503",
                model: "Flame LS-4503"
            },
            {
                regex: "LS-4001",
                model: "Flame 3"
            },
            {
                regex: "LS-4003",
                model: "Flame 4"
            },
            {
                regex: "LS-4002",
                model: "Flame 5"
            },
            {
                regex: "LS-4005",
                model: "Flame 6"
            },
            {
                regex: "(LYF[ _])?LS-4006",
                model: "Flame 7"
            },
            {
                regex: "LS-4008",
                model: "Flame 7S"
            },
            {
                regex: "LS-450[58]",
                model: "Flame 8"
            },
            {
                regex: "LS-5002",
                model: "Water 1"
            },
            {
                regex: "LS-5005",
                model: "Water 4"
            },
            {
                regex: "LS-5006",
                model: "Water 6"
            },
            {
                regex: "LS-5008",
                model: "Water 2"
            },
            {
                regex: "LS-5009",
                model: "Wind 6"
            },
            {
                regex: "LS-5013",
                model: "Wind 5"
            },
            {
                regex: "LS-5014",
                model: "Wind 4"
            },
            {
                regex: "LS-5010",
                model: "Wind 1"
            },
            {
                regex: "LS-5015",
                model: "Water 8"
            },
            {
                regex: "LS-5016",
                model: "Wind 7"
            },
            {
                regex: "LS-5504",
                model: "Water 7"
            },
            {
                regex: "LS-5507",
                model: "Water 7S"
            },
            {
                regex: "LS-5017",
                model: "Water 11"
            },
            {
                regex: "LS-5018",
                model: "Wind 4S"
            },
            {
                regex: "LS-5020",
                model: "Water 10"
            },
            {
                regex: "LS-5201",
                model: "Water F1S"
            },
            {
                regex: "LS-5502",
                model: "Wind 3"
            },
            {
                regex: "LS-5503",
                model: "Water 3"
            },
            {
                regex: "LS-5506",
                model: "Water 9"
            },
            {
                regex: "LS-6001",
                model: "Wind 2"
            },
            {
                regex: "LYF/([^/]+)/",
                model: "$1"
            }
        ]
    },
    Lumus: {
        regex: "LUMUS Shell|(?:NEO(SR620|SC600)|INNOSR545|Lumus[_ ]Ion)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "NEO(SR620|SC600)(?:[);/ ]|$)",
                model: "Neo $1"
            },
            {
                regex: "INNO(SR545)(?:[);/ ]|$)",
                model: "INNO $1"
            },
            {
                regex: "Lumus[_ ]Ion(?:[);/ ]|$)",
                model: "Ion"
            },
            {
                regex: "LUMUS Shell [0-9A-Z]+",
                device: "tv",
                model: ""
            }
        ]
    },
    M4tel: {
        regex: "M4 SS[0-9]{4}(?:-R)?|M4_B[23]",
        device: "smartphone",
        models: [
            {
                regex: "SS1050",
                model: "Joy"
            },
            {
                regex: "SS1060",
                model: "Live"
            },
            {
                regex: "SS1070",
                model: "Sense"
            },
            {
                regex: "SS1080",
                model: "Max One"
            },
            {
                regex: "SS1090",
                model: "Max Ultra"
            },
            {
                regex: "SS4020",
                model: "Play"
            },
            {
                regex: "SS4040",
                model: "In Touch"
            },
            {
                regex: "SS4045",
                model: "Style"
            },
            {
                regex: "SS4345",
                model: "Soul Mini"
            },
            {
                regex: "SS4350",
                model: "Soul"
            },
            {
                regex: "SS4445",
                model: "Style Access"
            },
            {
                regex: "SS4450",
                model: "Share"
            },
            {
                regex: "SS4451",
                model: "Believe"
            },
            {
                regex: "SS4452",
                model: "Dream"
            },
            {
                regex: "SS4453",
                model: "Inspiration"
            },
            {
                regex: "SS4455",
                model: "Excite"
            },
            {
                regex: "SS4456",
                model: "Evolution"
            },
            {
                regex: "SS4457-R",
                model: "Ever"
            },
            {
                regex: "SS4457",
                model: "Elegance"
            },
            {
                regex: "SS4458-R",
                model: "Feel Plus"
            },
            {
                regex: "SS4458",
                model: "Attitude"
            },
            {
                regex: "M4_B([23])",
                model: "B$1"
            }
        ]
    },
    "IMO Mobile": {
        regex: "IMO[ _]\\w",
        device: "smartphone",
        models: [
            {
                regex: "IMO[ _]Q([23]) Plus(?:[);/ ]|$)",
                model: "Q$1 Plus"
            },
            {
                regex: "IMO[ _]Q2(?:[);/ ]|$)",
                model: "Q2"
            },
            {
                regex: "IMO[ _]S2(?:[);/ ]|$)",
                model: "S2"
            },
            {
                regex: "IMO[ _]FEEL A2(?:[);/ ]|$)",
                model: "Feel A2"
            },
            {
                regex: "IMO[ _]S50(?:[);/ ]|$)",
                model: "S50 Light"
            },
            {
                regex: "IMO[ _]S80(?:[);/ ]|$)",
                model: "S80 Hero"
            },
            {
                regex: "IMO[ _]S89(?:[);/ ]|$)",
                model: "S89 Miracle"
            },
            {
                regex: "IMO[ _]S88(?:[);/ ]|$)",
                model: "S88 Discovery"
            },
            {
                regex: "IMO[ _]S99(?:[);/ ]|$)",
                model: "S99 Ocean"
            },
            {
                regex: "IMO[ _]S98(?:[);/ ]|$)",
                model: "S98 Champion"
            },
            {
                regex: "IMO[ _]S87(?:[);/ ]|$)",
                model: "S87 Raptor"
            },
            {
                regex: "IMO[ _]S67(?:[);/ ]|$)",
                model: "S67 Blast"
            },
            {
                regex: "IMO[ _]S78(?:[);/ ]|$)",
                model: "S78 Glory"
            },
            {
                regex: "IMO[ _]Q8(?:[);/ ]|$)",
                model: "Q8 Clarity"
            },
            {
                regex: "IMO[ _]Discovery II(?:[);/ ]|$)",
                model: "Discovery II"
            },
            {
                regex: "IMO[ _]Q(?:[);/ ]|$)",
                model: "Q"
            },
            {
                regex: "IMO[ _](Y5|Z[67])(?:[);/ ]|$)",
                model: "Tab $1",
                device: "tablet"
            },
            {
                regex: "IMO TAB X9(?:[);/ ]|$)",
                model: "Tab X9",
                device: "tablet"
            }
        ]
    },
    iLA: {
        regex: "iLA[-_ ](Silk|X)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    iNew: {
        regex: "iNew|(?:V7A|V3 Plus|V3-?E|V3C|FIRE_Tab_6)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "V3C(?:[);/ ]|$)",
                model: "V3C"
            },
            {
                regex: "V3-?E(?:[);/ ]|$)",
                model: "V3-E"
            },
            {
                regex: "V3 Plus(?:[);/ ]|$)",
                model: "V3 Plus"
            },
            {
                regex: "V7A(?:[);/ ]|$)",
                model: "V7A"
            },
            {
                regex: "FIRE_Tab_6(?:[);/ ]|$)",
                device: "tablet",
                model: "Fire Tab 6"
            },
            {
                regex: "iNew[ -_]([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    iPro: {
        regex: "(?:Kylin[ _]5.[05]S?|KYLIN40|Jade[78]s|Amber[67]S?|Amber5S_Pro|Phonenix50S|Zafiro)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Kylin_5.0S",
                model: "Kylin 5.0S"
            },
            {
                regex: "Kylin (5.[05])",
                model: "Kylin $1"
            },
            {
                regex: "KYLIN40",
                model: "Kylin 40"
            },
            {
                regex: "Jade([78])s",
                model: "Jade $1s"
            },
            {
                regex: "Amber7S",
                model: "Amber 7S"
            },
            {
                regex: "Amber5S_Pro",
                model: "Amber 5S Pro"
            },
            {
                regex: "Amber6",
                model: "Amber 6"
            },
            {
                regex: "Phonenix50S",
                model: "Phonenix 50S"
            },
            {
                regex: "Zafiro",
                model: "Zafiro"
            }
        ]
    },
    Infinix: {
        regex: "Infinix",
        device: "smartphone",
        models: [
            {
                regex: "Infinix[ _-]X260",
                model: "Buzz"
            },
            {
                regex: "Infinix[ _-]X502",
                model: "Alpha Marvel"
            },
            {
                regex: "Infinix[ _-]X570",
                model: "Alpha"
            },
            {
                regex: "Infinix[ _-]X350",
                model: "Surf Smart"
            },
            {
                regex: "Infinix[ _-]X351",
                model: "Surf Smart 3G"
            },
            {
                regex: "Infinix[ _-]X352",
                model: "Surf Smart 2"
            },
            {
                regex: "Infinix[ _-]X403",
                model: "Surf Spice"
            },
            {
                regex: "Infinix[ _-]X503",
                model: "Surf Bravo"
            },
            {
                regex: "Infinix[ _-]X511",
                model: "Surf Noir"
            },
            {
                regex: "Infinix[ _-]X400",
                model: "Race"
            },
            {
                regex: "Infinix[ _-]X401",
                model: "Race Lite"
            },
            {
                regex: "Infinix[ _-]X450",
                model: "Race Bolt"
            },
            {
                regex: "Infinix[ _-]X451",
                model: "Race Bolt Q"
            },
            {
                regex: "Infinix[ _-]X454",
                model: "Race Bolt 2"
            },
            {
                regex: "Infinix[ _-]X500",
                model: "Race Eagle"
            },
            {
                regex: "Infinix[ _-]X501",
                model: "Race Jet"
            },
            {
                regex: "Infinix[ _-]X506",
                model: "Zero"
            },
            {
                regex: "Infinix[ _-]X509",
                model: "Zero 2"
            },
            {
                regex: "Infinix[ _-]X552",
                model: "Zero 3"
            },
            {
                regex: "Infinix[ _-]X555",
                model: "Zero 4"
            },
            {
                regex: "Infinix[ _-]X(?:574|602)",
                model: "Zero 4 Plus"
            },
            {
                regex: "Infinix[ _-]X603",
                model: "Zero 5"
            },
            {
                regex: "Infinix[ _-]X603B",
                model: "Zero 5 Pro"
            },
            {
                regex: "Infinix[ _-]X620",
                model: "Zero 6"
            },
            {
                regex: "Infinix[ _-]X507",
                model: "Hot"
            },
            {
                regex: "Infinix[ _-]X510",
                model: "Hot 2"
            },
            {
                regex: "Infinix[ _-]X55[34]",
                model: "Hot 3"
            },
            {
                regex: "Infinix[ _-]X521",
                model: "Hot S"
            },
            {
                regex: "Infinix[ _-]X522",
                model: "Hot S2"
            },
            {
                regex: "Infinix[ _-]X557",
                model: "Hot 4"
            },
            {
                regex: "Infinix[ _-]X556",
                model: "Hot 4 Pro"
            },
            {
                regex: "Infinix[ _-]X559c",
                model: "Hot 5"
            },
            {
                regex: "Infinix[ _-]X559",
                model: "Hot 5 Lite"
            },
            {
                regex: "Infinix[ _-]X606[BC]?",
                model: "Hot 6"
            },
            {
                regex: "Infinix[ _-]X608",
                model: "Hot 6 Pro"
            },
            {
                regex: "Infinix[ _-]X624",
                model: "Hot 7"
            },
            {
                regex: "Infinix[ _-]X650",
                model: "Hot 8"
            },
            {
                regex: "Infinix[ _-]X680",
                model: "Hot 9 Play"
            },
            {
                regex: "Infinix[ _-]X573B?",
                model: "Hot S3"
            },
            {
                regex: "Infinix[ _-]X5010",
                model: "Smart"
            },
            {
                regex: "Infinix[ _-]X5515F",
                model: "Smart 2"
            },
            {
                regex: "Infinix[ _-]X5514D",
                model: "Smart 2 Pro"
            },
            {
                regex: "Infinix[ _-]X653",
                model: "Smart 4"
            },
            {
                regex: "Infinix[ _-]X626",
                model: "S4"
            },
            {
                regex: "Infinix[ _-]X652",
                model: "S5"
            },
            {
                regex: "Infinix[ _-]X660",
                model: "S5 Pro"
            },
            {
                regex: "Infinix[ _-]X551",
                model: "Hot Note",
                device: "phablet"
            },
            {
                regex: "Infinix[ _-]X600",
                model: "Note 2",
                device: "phablet"
            },
            {
                regex: "Infinix[ _-]X601",
                model: "Note 3",
                device: "phablet"
            },
            {
                regex: "Infinix[ _-]X572",
                model: "Note 4",
                device: "phablet"
            },
            {
                regex: "Infinix[ _-]X571",
                model: "Note 4 Pro",
                device: "phablet"
            },
            {
                regex: "Infinix[ _-]X604",
                model: "Note 5",
                device: "phablet"
            },
            {
                regex: "Infinix[ _-]X610",
                model: "Note 6",
                device: "phablet"
            },
            {
                regex: "Infinix[ _-]X690",
                model: "Note 7",
                device: "phablet"
            },
            {
                regex: "Infinix[ _-]X656",
                model: "Note 7 Lite",
                device: "phablet"
            },
            {
                regex: "Infinix HOT ([a-z]?[1-6])( (?:Lite|Plus|Pro))?",
                model: "Hot $1$2"
            },
            {
                regex: "Infinix[ _-](X[78]00)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "Infinix[ _-](X\\d+)",
                model: "$1"
            },
            {
                regex: "Infinix[ _-]([a-z0-9_\\-]+)",
                model: "$1"
            }
        ]
    },
    InFocus: {
        regex: "IF(900[1237]|902[19]|903[15])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "IF9001",
                model: "Turbo 5"
            },
            {
                regex: "IF9007",
                model: "A3"
            },
            {
                regex: "IF9021",
                model: "Turbo 5 Plus"
            },
            {
                regex: "IF9035",
                model: "A2"
            },
            {
                regex: "IF9002",
                model: "M5s"
            },
            {
                regex: "IF9003",
                model: "M6s"
            },
            {
                regex: "IF9031",
                model: "Vision 3"
            },
            {
                regex: "IF9029",
                model: "Vision 3 Pro"
            }
        ]
    },
    InnJoo: {
        regex: "InnJoo|(?:Halo Plus|Halo X|Halo[ _]4(?:[ _]mini[ _]LTE)?|Halo2 3G|Fire2 Plus LTE)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "InnJoo[ _]X3(?:[);/ ]|$)",
                model: "X3"
            },
            {
                regex: "Halo[ _]X[ _]LTE(?:[);/ ]|$)",
                model: "Halo X LTE"
            },
            {
                regex: "InnJoo[ _]X(?:[);/ ]|$)",
                model: "X"
            },
            {
                regex: "Halo Plus(?:[);/ ]|$)",
                model: "Halo Plus"
            },
            {
                regex: "Halo[ _]4[ _]mini[ _]LTE(?:[);/ ]|$)",
                model: "Halo 4 Mini LTE"
            },
            {
                regex: "Halo 4(?:[);/ ]|$)",
                model: "Halo 4"
            },
            {
                regex: "Halo2 3G(?:[);/ ]|$)",
                model: "Halo 2 3G"
            },
            {
                regex: "InnJoo[ _]Pro2(?:[);/ ]|$)",
                model: "Pro 2"
            },
            {
                regex: "Innjoo ONE 3G(?:[);/ ]|$)",
                model: "One 3G"
            },
            {
                regex: "Innjoo[ _]2[ _]LTE(?:[);/ ]|$)",
                model: "2 LTE"
            },
            {
                regex: "InnJoo[ _]([2-4])",
                model: "$1"
            },
            {
                regex: "Fire2 Plus LTE",
                model: "Fire 2 Plus LTE"
            }
        ]
    },
    Inkti: {
        regex: "intki[ _]([^/;]*)[ _]Build",
        device: "smartphone",
        model: "$1"
    },
    Innos: {
        regex: "Innos_?(D6000)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Innostream: {
        regex: "INNO([a-z0-9]+)",
        device: "feature phone",
        model: "INNO$1"
    },
    Insignia: {
        regex: "NS-(P11A8100|P10A8100|P10A6100|P16AT08|P16AT10|P16AT785HD|P08A7100|P10A7100)(?:[);/ ]|$)|AFTEAMR311|AFTJMST12",
        device: "tablet",
        models: [
            {
                regex: "NS-P11A8100",
                model: '11.6"'
            },
            {
                regex: "NS-(P10A6100|P16AT10)",
                model: 'Flex 10.1"'
            },
            {
                regex: "NS-P16AT08",
                model: 'Flex 8"'
            },
            {
                regex: "NS-P08A7100",
                model: '8"'
            },
            {
                regex: "NS-(P10A8100|P10A7100)",
                model: '10.1"'
            },
            {
                regex: "NS-P16AT785HD",
                model: 'Flex Elite 7.85"'
            },
            {
                regex: "AFTEAMR311",
                model: "HD (2018)",
                device: "tv"
            },
            {
                regex: "AFTJMST12",
                model: "4K (2018)",
                device: "tv"
            }
        ]
    },
    INQ: {
        regex: "INQ[/ ]",
        device: "feature phone",
        models: [
            {
                regex: "INQ/([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "INQ ([^;/]+) Build",
                model: "$1",
                device: "smartphone"
            }
        ]
    },
    Intex: {
        regex: "Intex|(Aqua|Cloud[ _][XY][0-9]{1}|Cloud (?:Fame|Glory) 4G)|IM0318ND(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "IM0318ND",
                model: "Aqua Lions 3"
            },
            {
                regex: "Intex[ _]([^/;]*)[ _]Build",
                model: "$1"
            },
            {
                regex: "(Cloud (?:Fame|Glory) 4G)",
                model: "$1"
            },
            {
                regex: "(Aqua|Cloud)[ _\\.]([^/;\\)]+)(?:[ _]Build|(?<!Build)/|\\))",
                model: "$1 $2"
            },
            {
                regex: "Intex[ _]([a-z0-9_+\\-]+)",
                model: "$1"
            }
        ]
    },
    "i-mate": {
        regex: "i-mate ([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    "i-mobile": {
        regex: "i-mobile ?[a-z0-9]+|i-Style|IQ ?(9\\.1|5\\.5|5\\.6A?)",
        device: "feature phone",
        models: [
            {
                regex: "i-mobile (i-note[^/;]*) Build",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "i-Style ?([^;/]+) Build",
                model: "i-Style $1",
                device: "smartphone"
            },
            {
                regex: "IQ ?(9\\.1|5\\.5|5\\.6A?)",
                model: "IQ $1",
                device: "smartphone"
            },
            {
                regex: "i-mobile (IQ[^/;]*) Build",
                model: "$1",
                device: "smartphone"
            },
            {
                regex: "i-mobile(?: )?([a-z0-9\\- ]+) Build",
                model: "$1"
            },
            {
                regex: "i-mobile(?: )?([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    iKoMo: {
        regex: "iKoMo ([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    iOcean: {
        regex: "iOCEAN|M6752|W180|X7[ _]?S|X8 mini",
        device: "smartphone",
        models: [
            {
                regex: "X7S-T",
                model: "X7S-T"
            },
            {
                regex: "X8 mini pro",
                model: "X8 Mini Pro"
            },
            {
                regex: "X8 mini",
                model: "X8 Mini"
            },
            {
                regex: "X7[ _]?S",
                model: "X7S Elite"
            },
            {
                regex: "(M6752|W180) Build",
                model: "$1"
            },
            {
                regex: "iOCEAN[ _\\-]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "iOCEAN[ _\\-]?([^);/ ]+)",
                model: "$1"
            }
        ]
    },
    iView: {
        regex: "(733TPC|730TPC|769TPCII|930TPC)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Impression: {
        regex: "(?:Impression[ _\\-]?([^/;]+)|A502|I10\\-LE|ImPad[ _]?(.*)|ImSmart[ _]?(.*))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(A502)",
                model: "$1",
                device: "smartphone"
            },
            {
                regex: "ImSmart[ _]?([^/;)]+)(?: Build|\\))",
                model: "ImSmart $1",
                device: "smartphone"
            },
            {
                regex: "ImPad[ _]?([^/;)]+)(?: Build|\\))",
                model: "ImPad $1"
            },
            {
                regex: "(I10\\-LE)",
                model: "$1",
                device: "smartphone"
            },
            {
                regex: "Impression[ _\\-]?([^/;)]+)(?: Build|\\))",
                model: "$1"
            }
        ]
    },
    iLife: {
        regex: "(ITELL[_ ](?:K3300|K3500N?|K4700))(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    iTel: {
        regex: "itel|iNote|GP10X2019(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "W6502",
                device: "phablet",
                model: "S16"
            },
            {
                regex: "W5505",
                model: "A36"
            },
            {
                regex: "W6002E?",
                model: "S15"
            },
            {
                regex: "L5502",
                model: "A44 Air"
            },
            {
                regex: "L5505",
                model: "A47"
            },
            {
                regex: "L6006",
                model: "A48"
            },
            {
                regex: "L6003P",
                model: "A55 LTE"
            },
            {
                regex: "L6002P",
                model: "S15 Pro"
            },
            {
                regex: "L5002",
                model: "A22"
            },
            {
                regex: "L5503",
                model: "A46"
            },
            {
                regex: "L6004",
                model: "A56 LTE"
            },
            {
                regex: "W6004P",
                model: "A56 Pro"
            },
            {
                regex: "W6001",
                model: "P33 Plus"
            },
            {
                regex: "W6003",
                model: "A55"
            },
            {
                regex: "L6005",
                model: "Vision 1"
            },
            {
                regex: "L6501",
                model: "Vision 1 Plus"
            },
            {
                regex: "L6502",
                model: "Vision 1 Pro"
            },
            {
                regex: "GP10X2019",
                model: "GP10X2019"
            },
            {
                regex: "iNote ([^/;]*)Build",
                model: "iNote $1"
            },
            {
                regex: "iNote_([a-z0-9\\-_]+)",
                model: "iNote $1"
            },
            {
                regex: "itel-it(1410|1512|1520)(?:[);/ ]|$)",
                model: "it$1"
            },
            {
                regex: "itel-it1553(?:[);/ ]|$)",
                model: "Power Pro"
            },
            {
                regex: "itel[- ](A14|A16 Plus|A44 Power|A23S|A52 Lite)",
                model: "$1"
            },
            {
                regex: "itel it1701",
                device: "tablet",
                model: "iNote Prime"
            },
            {
                regex: "itel it170([23])",
                device: "tablet",
                model: "iNote Prime $1"
            },
            {
                regex: "iTel ([^/;]*)Build",
                model: "$1"
            },
            {
                regex: "iTel[_ ]([a-z0-9\\-_]*)",
                model: "$1"
            }
        ]
    },
    iZotron: {
        regex: "(Mi7_HERO_(?:BETA|TAB))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "Mi7[_ ]HERO[_ ]BETA(?:[);/ ]|$)",
                model: "MI7 Hero Beta"
            },
            {
                regex: "Mi7[_ ]HERO[_ ]TAB(?:[);/ ]|$)",
                model: "MI7 Hero Tab"
            }
        ]
    },
    "JAY-Tech": {
        regex: "TPC-[A-Z0-9]+|TPCY-TX[TE][^);/ ]+",
        device: "tablet",
        models: [
            {
                regex: "TPC-([A-Z0-9]+)",
                model: "Tablet PC $1"
            },
            {
                regex: "(TPCY-TX[TE][^);/ ]+)",
                model: "$1"
            }
        ]
    },
    Jiayu: {
        regex: "JIAYU[ _-]|(?:JY-G4[\\\\_]G5|(?:JY-[a-z0-9]+)|JY_G4C)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:JIAYU G4_G5|JY-G4[\\\\_]G5)(?:[);/ ]|$)",
                model: "G4/G5"
            },
            {
                regex: "JIAYU[ _-](G4[S]?|G2F|G3[S]?|S[23])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "JY[-_]([a-z0-9]+|G4C)(?:[);/ ]|$)",
                model: "JY-$1"
            }
        ]
    },
    Jolla: {
        regex: "Jolla",
        device: "smartphone",
        model: ""
    },
    Just5: {
        regex: "JUST5(-)?SPACER(s)?|COSMO[_ ](L707|L808)|BLASTER|FREEDOM[ _](C100|M303|X1)|Freedom",
        device: "smartphone",
        models: [
            {
                regex: "COSMO[_ ](L707|L808)",
                model: "Cosmo $1"
            },
            {
                regex: "FREEDOM[ _](C100|M303|X1)",
                model: "Freedom $1"
            },
            {
                regex: "Freedom",
                model: "Freedom"
            },
            {
                regex: "JUST5(-)?SPACER2s",
                model: "Spacer 2S"
            },
            {
                regex: "JUST5(-)?SPACER2",
                model: "Spacer 2"
            },
            {
                regex: "JUST5SPACER",
                model: "Spacer"
            },
            {
                regex: "BLASTER 2",
                model: "Blaster 2"
            },
            {
                regex: "BLASTER",
                model: "Blaster"
            }
        ]
    },
    Kalley: {
        regex: "KALLEY|(?:ELEMENT (?:MAX|Q)|ELEMENT_PRO_2|K-BOOK(?:8MG|73G))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ELEMENT MAX",
                model: "Element Max"
            },
            {
                regex: "ELEMENT Q",
                model: "Element Q"
            },
            {
                regex: "ELEMENT_PRO_2",
                model: "Element Pro 2"
            },
            {
                regex: "K-BOOK(8MG|73G)",
                device: "tablet",
                model: "K-BOOK$1"
            },
            {
                regex: "KALLEY,(55D1240)",
                device: "tv",
                model: "$1"
            }
        ]
    },
    Kaan: {
        regex: "KAAN[ _](N[12]|A1)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Kazam: {
        regex: "Kazam|Trooper_X[0-9][0-9](?:[);/ ]|$)|Tornado 348|TROOPER 4\\.0",
        device: "smartphone",
        models: [
            {
                regex: "Tornado 348",
                model: "Tornado 348"
            },
            {
                regex: "Thunder 450W",
                model: "Thunder 450W"
            },
            {
                regex: "TROOPER 4\\.0",
                model: "Trooper X4.0"
            },
            {
                regex: "Trooper_X([0-9])([0-9])(?:[);/ ]|$)",
                model: "Trooper X$1.$2"
            },
            {
                regex: "Kazam[; _]([^;/)]+)(?: Build|\\))",
                model: "$1"
            }
        ]
    },
    Keneksi: {
        regex: "KENEKSI|(?:Hemera|Teta Dual|Helios)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(Hemera|Teta Dual|Helios)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "KENEKSI[ _-]liberty",
                model: "Liberty"
            },
            {
                regex: "KENEKSI[ _-]FLASH",
                model: "Flash"
            },
            {
                regex: "KENEKSI[ _-]SUN",
                model: "Sun"
            },
            {
                regex: "KENEKSI[ _-]ZETA",
                model: "Zeta"
            },
            {
                regex: "KENEKSI[ _-]SIGMA",
                model: "Sigma"
            },
            {
                regex: "KENEKSI[ _-](Moon|Libra_Dual|Glass|Amber|Chance|Amulet|Choice|Crystal|Dream|Delta[_ ]Dual|Norma 2|Norma|Sky|Fire 2|Fire|Flame|Flora|Rock|Solo|Soul|Step|Smart|Star|Storm|Wind)",
                model: "$1"
            }
        ]
    },
    "Kempler & Strauss": {
        regex: "Alumini_?3_?Plus|Alumini ?[23]|KEMPLER_(?:P1|TV|X|8_PLUS)",
        device: "smartphone",
        models: [
            {
                regex: "Alumini ?2",
                model: "Alumini 2"
            },
            {
                regex: "Alumini_?3_?Plus",
                model: "Alumini 3 Plus"
            },
            {
                regex: "Alumini3",
                model: "Alumini 3"
            },
            {
                regex: "KEMPLER_P1",
                model: "P1"
            },
            {
                regex: "KEMPLER_TV",
                model: "TV"
            },
            {
                regex: "KEMPLER_X",
                model: "X"
            },
            {
                regex: "KEMPLER_8_PLUS",
                model: "8 Plus"
            }
        ]
    },
    Kiano: {
        regex: "Kiano|Elegance_[45]_[015](?:_PRO)?|Elegance 6|CORE 10.1 DUAL 3G|Intelect ?(7|8|10)|Slim ?Tab ?\\d+(?:[_ ]3GR?)?(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Slim ?Tab ?(\\d+)(?:[_ ]3GR?)?",
                model: "Slim Tab $1",
                device: "tablet"
            },
            {
                regex: "CORE 10.1 DUAL 3G",
                model: "CORE 10.1 DUAL 3G",
                device: "tablet"
            },
            {
                regex: "Elegance_(5)_([51])_Pro",
                model: 'Elegance $1.$2" Pro'
            },
            {
                regex: "Elegance_([45])_([015])",
                model: 'Elegance $1.$2"'
            },
            {
                regex: "Elegance 6",
                model: 'Elegance 6 5.85"'
            },
            {
                regex: "(Kiano)?(Intelect|Elegance) ?(7|8|10)?",
                model: "$2 $3",
                device: "tablet"
            },
            {
                regex: "Kiano[ _]([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    Kingsun: {
        regex: "Kingsun[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "Kingsun[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Kingsun[ -]((?!Build)[a-z0-9_-]+)",
                model: "$1"
            }
        ]
    },
    Kocaso: {
        regex: "Kocaso|M(?:729|7[357][026][hw]?|76[01236][bw]?|83[016]|8[567]0|1050s|106[012368]w?|1070|X736(?:-kit)?|X780)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "M729(?:[);/ ]|$)",
                model: "M729"
            },
            {
                regex: "M(7[357][026])[hw]?(?:[);/ ]|$)",
                model: "M$1"
            },
            {
                regex: "M(76[01236])[bw]?(?:[);/ ]|$)",
                model: "M$1"
            },
            {
                regex: "MX780(?:[);/ ]|$)",
                model: "MX780"
            },
            {
                regex: "M(83[016])(?:[);/ ]|$)",
                model: "M$1"
            },
            {
                regex: "M(8[567]0)(?:[);/ ]|$)",
                model: "M$1"
            },
            {
                regex: "M851(?:[);/ ]|$)",
                model: "M851"
            },
            {
                regex: "M1050S(?:[);/ ]|$)",
                model: "M1050s"
            },
            {
                regex: "M(106[012368])W?(?:[);/ ]|$)",
                model: "M$1"
            },
            {
                regex: "M1070(?:[);/ ]|$)",
                model: "M1070"
            },
            {
                regex: "MX736(?:-kit)?(?:[);/ ]|$)",
                model: "MX736"
            },
            {
                regex: "MX780(?:[);/ ]|$)",
                model: "MX780"
            },
            {
                regex: "Kocaso[ _\\-]?([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Kocaso[ _\\-]?([a-z0-9_-]+)",
                model: "$1"
            }
        ]
    },
    Kogan: {
        regex: "Kogan",
        device: "smartphone",
        models: [
            {
                regex: "Kogan[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Kogan[ _-]([a-z0-9_-]+)",
                model: "$1"
            }
        ]
    },
    Komu: {
        regex: "Komu[ -]",
        device: "smartphone",
        models: [
            {
                regex: "Komu[ -]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Komu[ -]([a-z0-9_-]+)",
                model: "$1"
            }
        ]
    },
    Koobee: {
        regex: "Koobee",
        device: "smartphone",
        models: [
            {
                regex: "Koobee[ _\\-]?([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Koobee[ _\\-]?([a-z0-9_-]+)",
                model: "$1"
            }
        ]
    },
    Kumai: {
        regex: "(?:KM-)?Kumai",
        device: "smartphone",
        models: [
            {
                regex: "(?:KM-)?Kumai[ _\\-]?([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "(?:KM-)?Kumai[ _\\-]?([a-z0-9_-]+)",
                model: "$1"
            }
        ]
    },
    "KT-Tech": {
        regex: "(KM-[a-z0-9]+|EV-[a-z0-9]+)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    KDDI: {
        regex: "kddi-([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Kodak: {
        regex: "KODAK|(?:IM5|Ektra|Smartway_T1)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "IM5",
                model: "IM5"
            },
            {
                regex: "Ektra(?:[);/ ]|$)",
                model: "Ektra"
            },
            {
                regex: "(?:KODAK[_ ])?SMARTWAY[_ ]([MTX]1)",
                model: "Smartway $1"
            },
            {
                regex: "Tablet (7|10)",
                device: "tablet",
                model: "Tablet $1"
            }
        ]
    },
    KOPO: {
        regex: "KOPO[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "KOPO[ _\\-]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "KOPO[ _\\-]?([^);/ ]+)",
                model: "$1"
            }
        ]
    },
    Koridy: {
        regex: "KORIDY[ _-]([^/;]+) Build",
        device: "smartphone",
        model: "$1"
    },
    KRONO: {
        regex: "NET1100|NET_(?:TITAN|VOLT)",
        device: "smartphone",
        models: [
            {
                regex: "NET1100",
                model: "NET 1100"
            },
            {
                regex: "NET_(TITAN|VOLT)",
                model: "NET $1"
            }
        ]
    },
    "K-Touch": {
        regex: "K-?Touch[ _][a-z0-9]+",
        device: "smartphone",
        models: [
            {
                regex: "K-?Touch[ _]([^/;]*)[ _]Build",
                model: "$1"
            },
            {
                regex: "K-?Touch[ _]([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Diva: {
        regex: "(QC-(?:703GN|704GA|803GN|1013G|7BHD))(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Kyocera: {
        regex: "Kyocera|KWC-|QC-[0-9]{4}|(?:QC6035|NP501KC|302KC|503KC|602KC|705KC|901KC|C51[27]0|C5155|C5215|C67[35]0|C6522N?|C6530N|C6740N?|C6743|E6[89]10|KYL2[13]|KYV3[13-9]|KYT3[123]|KYF3[123579]|KYF40|KYX31|KYG01|KYY2[1-4]|S2151|KC-S701|S[468]-KC|KYV40U?|KYV4[1-8]|KYV4[47]|KC-S301AE|X3-KC|E6560[CT]|E6782[L]?|E6790(?:TM)?|[47]04KC|A001KC|WX10K|URBANO PROGRESSO|E7110)(?:[-_]u2?)?(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "C5120(?:[);/ ]|$)",
                model: "Milano"
            },
            {
                regex: "S4-KC(?:[);/ ]|$)",
                model: "One S4"
            },
            {
                regex: "S6-KC(?:[);/ ]|$)",
                model: "One S6"
            },
            {
                regex: "S8-KC(?:[);/ ]|$)",
                model: "One S8"
            },
            {
                regex: "C5155(?:[);/ ]|$)",
                model: "Rise"
            },
            {
                regex: "602KC(?:[);/ ]|$)",
                model: "Digno G"
            },
            {
                regex: "503KC(?:[);/ ]|$)",
                model: "Digno E"
            },
            {
                regex: "404KC(?:[);/ ]|$)",
                model: "Digno C"
            },
            {
                regex: "704KC(?:[);/ ]|$)",
                model: "Digno J"
            },
            {
                regex: "302KC(?:[);/ ]|$)",
                model: "Digno T"
            },
            {
                regex: "NP501KC(?:[);/ ]|$)",
                model: "Digno"
            },
            {
                regex: "WX10K(?:[);/ ]|$)",
                model: "Digno Dual 2"
            },
            {
                regex: "KYV36(?:[);/ ]|$)",
                model: "Digno Rafre"
            },
            {
                regex: "901KC(?:[);/ ]|$)",
                model: "Digno BX"
            },
            {
                regex: "KYV39(?:[);/ ]|$)",
                model: "Miraie F"
            },
            {
                regex: "KYX31(?:[);/ ]|$)",
                model: "Infobar XV"
            },
            {
                regex: "C5170(?:[);/ ]|$)",
                model: "Hydro"
            },
            {
                regex: "C5215(?:[);/ ]|$)",
                model: "Hydro EDGE"
            },
            {
                regex: "C6522N?",
                model: "Hydro XTRM"
            },
            {
                regex: "C6730",
                model: "Hydro ICON"
            },
            {
                regex: "C6750",
                model: "Hydro ELITE"
            },
            {
                regex: "C6530N",
                model: "Hydro LIFE"
            },
            {
                regex: "C6740(N)?",
                model: "Hydro WAVE"
            },
            {
                regex: "C6743",
                model: "Hydro Reach"
            },
            {
                regex: "E6560[CT]",
                model: "DuraForce"
            },
            {
                regex: "E6810",
                model: "DuraForce Pro"
            },
            {
                regex: "E6910",
                model: "DuraForce Pro 2"
            },
            {
                regex: "E7110",
                model: "DuraForce Ultra 5G"
            },
            {
                regex: "KC-S701",
                model: "Torque"
            },
            {
                regex: "KYG01",
                model: "Torque 5G"
            },
            {
                regex: "KYL21(?:[);/ ]|$)",
                model: "Digno S"
            },
            {
                regex: "KYL23(?:[);/ ]|$)",
                model: "Miraie"
            },
            {
                regex: "KYY24(?:[);/ ]|$)",
                model: "Torque G01"
            },
            {
                regex: "KYF32(?:[);/ ]|$)",
                model: "Easy Mobile Phone"
            },
            {
                regex: "KYF35(?:[);/ ]|$)",
                model: "Marvera"
            },
            {
                regex: "KYF40(?:[);/ ]|$)",
                model: "Mamorino 5"
            },
            {
                regex: "KYF3[179](?:[);/ ]|$)",
                model: "Gratina 4G"
            },
            {
                regex: "KYV48(?:[);/ ]|$)",
                model: "Gratina KYV48"
            },
            {
                regex: "KYF33(?:[);/ ]|$)",
                model: "Torque X01"
            },
            {
                regex: "KYV35(?:[);/ ]|$)",
                model: "Torque G02"
            },
            {
                regex: "KYV41(?:[);/ ]|$)",
                model: "Torque G03"
            },
            {
                regex: "KYV46(?:[);/ ]|$)",
                model: "Torque G04"
            },
            {
                regex: "KYV47(?:-u)?(?:[);/ ]|$)",
                model: "Basio 4"
            },
            {
                regex: "KYV43(?:[);/ ]|$)",
                model: "Basio 3"
            },
            {
                regex: "705KC(?:[);/ ]|$)",
                model: "Kantan Sumaho"
            },
            {
                regex: "KYV37(?:[);/ ]|$)",
                model: "Qua Phone"
            },
            {
                regex: "KYV42(?:_u)?(?:[);/ ]|$)",
                model: "Qua Phone QX"
            },
            {
                regex: "KYV44(?:_u2?)?(?:[);/ ]|$)",
                model: "Qua Phone QZ"
            },
            {
                regex: "KYT33(?:[);/ ]|$)",
                model: "Qua Tab QZ10",
                device: "tablet"
            },
            {
                regex: "KYT32(?:[);/ ]|$)",
                model: "Qua Tab QZ8",
                device: "tablet"
            },
            {
                regex: "KYT31(?:[);/ ]|$)",
                model: "Qua Tab 01",
                device: "tablet"
            },
            {
                regex: "KYV40U?(?:[);/ ]|$)",
                model: "Rafre"
            },
            {
                regex: "KYV33(?:[);/ ]|$)",
                model: "Infobar A03"
            },
            {
                regex: "KYY21(?:[);/ ]|$)",
                model: "Urbano L01"
            },
            {
                regex: "KYY22(?:[);/ ]|$)",
                model: "Urbano L02"
            },
            {
                regex: "KYY23(?:[);/ ]|$)",
                model: "Urbano L03"
            },
            {
                regex: "KYV31(?:[);/ ]|$)",
                model: "Urbano V01"
            },
            {
                regex: "KYV34(?:[);/ ]|$)",
                model: "Urbano V02"
            },
            {
                regex: "KYV(?:45|38)(?:[);/ ]|$)",
                model: "Urbano V03"
            },
            {
                regex: "(?:Kyocera-)?E6790(?:TM)?",
                model: "DuraForce XD"
            },
            {
                regex: "X3-KC(?:[);/ ]|$)",
                model: "One X3"
            },
            {
                regex: "E6782(?:[);/ ]|$)",
                model: "Brigadier"
            },
            {
                regex: "E6782L(?:[);/ ]|$)",
                model: "DuraScout"
            },
            {
                regex: "(KC-S301AE)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "A001KC(?:[);/ ]|$)",
                model: "Katan Sumaho 2"
            },
            {
                regex: "URBANO PROGRESSO(?:[);/ ]|$)",
                model: "Urbano Progresso"
            },
            {
                regex: "S2151",
                model: "Coast",
                device: "feature phone"
            },
            {
                regex: "Kyocera-KZ-([a-z0-9]+)",
                model: "KZ $1"
            },
            {
                regex: "Kyocera(?:[\\-/])?([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(KWC|QC)-?([a-z0-9]+)",
                model: "$1-$2"
            }
        ]
    },
    "Kr\xfcger&Matz": {
        regex: "Kruger[ _&]Matz|KrugerMatz[ _]|FLOW ?5PLUS|FLOW_5|FLOW7|FLOW6(?:S|Lite)|DRIVE[_ ]6S?|MOVE8mini|MOVE_|LIVE_6plus|LIVE 5 PLUS|LIVE4_KM043[89]|LIVE 7S|KM(?:106[67]|1065G|0701_1|0702|0805_1)",
        device: "smartphone",
        models: [
            {
                regex: "MOVE8mini",
                model: "MOVE 8 Mini"
            },
            {
                regex: "MOVE_6_mini",
                model: "MOVE 6 Mini"
            },
            {
                regex: "MOVE[_ ]([78]|6S)",
                model: "MOVE $1"
            },
            {
                regex: "DRIVE 4 mini LTE",
                model: "DRIVE 4 mini LTE"
            },
            {
                regex: "DRIVE[ _]([456][S]?)(?:[);/ ]|$)",
                model: "DRIVE $1"
            },
            {
                regex: "FLOW ?5PLUS(?:[);/ ]|$)",
                model: "FLOW 5 Plus"
            },
            {
                regex: "FLOW6Lite(?:[);/ ]|$)",
                model: "FLOW 6 Lite"
            },
            {
                regex: "FLOW[ _]?([4-7][S]?)(?:[);/ ]|$)",
                model: "FLOW $1"
            },
            {
                regex: "LIVE4_(KM043[89])(?:[);/ ]|$)",
                model: "LIVE 4 $1"
            },
            {
                regex: "KrugerMatz_LIVE4(?:[);/ ]|$)",
                model: "LIVE 4"
            },
            {
                regex: "_LIVE5_(KM0450)(?:[);/ ]|$)",
                model: "LIVE 5 $1"
            },
            {
                regex: "LIVE 5 PLUS(?:[);/ ]|$)",
                model: "LIVE 5 Plus"
            },
            {
                regex: "LIVE_6plus(?:[);/ ]|$)",
                model: "LIVE 6 Plus"
            },
            {
                regex: "LIVE 7S(?:[);/ ]|$)",
                model: "LIVE 7S"
            },
            {
                regex: "KM(106[67])(?:[);/ ]|$)",
                device: "tablet",
                model: 'EAGLE $1 10.1"'
            },
            {
                regex: "KM(1065G)(?:[);/ ]|$)",
                device: "tablet",
                model: 'EAGLE $1 10.1"'
            },
            {
                regex: "KM0(701)_1(?:[);/ ]|$)",
                device: "tablet",
                model: 'EAGLE $1 7.1"'
            },
            {
                regex: "KM0(805)_1(?:[);/ ]|$)",
                device: "tablet",
                model: 'EAGLE $1 8.0"'
            },
            {
                regex: "KM0(702)(?:[);/ ]|$)",
                device: "tablet",
                model: 'EAGLE $1 7.0"'
            }
        ]
    },
    LAIQ: {
        regex: "LAIQ",
        device: "smartphone",
        models: [
            {
                regex: "(Glam|New York|Dubai)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    AIS: {
        regex: "iris708|Kingcomm C500",
        device: "smartphone",
        models: [
            {
                regex: "iris708",
                model: "LAVA PRO 4.5"
            },
            {
                regex: "Kingcomm C500",
                model: "Super Smart Plus X3"
            }
        ]
    },
    Lava: {
        regex: "Lava[ _]|LAVAA1|(?:DISCOVER136|KKT QUADRA)|iris[ _]?([^/;]+)(?:\\)| Build)|A(?:67|76) Build|X1 Selfie Build|X41 Plus Build|(?:Flair Z1|PixelV1|Pixel V2|Z61_2GB|A97 IPS|A97 2GB PLUS|L[EH]9920(?:[_ ]P)?|L[NEH]9910|LH9810|Ivory(?:S1|S4G)?|A76Plus)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Flair Z1(?:[);/ ]|$)",
                model: "Flair Z1"
            },
            {
                regex: "A97 IPS(?:[);/ ]|$)",
                model: "A97 IPS"
            },
            {
                regex: "A97 2GB PLUS(?:[);/ ]|$)",
                model: "A97 2GB Plus"
            },
            {
                regex: "A76Plus(?:[);/ ]|$)",
                model: "A76 Plus"
            },
            {
                regex: "Pixel ?V([12])(?:[);/ ]|$)",
                model: "Pixel V$1"
            },
            {
                regex: "X1 Selfie(?:[);/ ]|$)",
                model: "Iris X1 Selfie"
            },
            {
                regex: "X41 Plus(?:[);/ ]|$)",
                model: "X41 Plus"
            },
            {
                regex: "(?:LAVA[_ ]?)?A([13]|67|76)(?:[);/ ]|$)",
                model: "A$1"
            },
            {
                regex: "LAVA_R1",
                model: "R1"
            },
            {
                regex: "Z61_2GB(?:[);/ ]|$)",
                model: "Z61"
            },
            {
                regex: "LE9920[ _]P(?:[);/ ]|$)",
                model: "V7"
            },
            {
                regex: "LE9920(?:[);/ ]|$)",
                model: "Z53"
            },
            {
                regex: "LH9910(?:[);/ ]|$)",
                model: "Z52"
            },
            {
                regex: "LH9810(?:[);/ ]|$)",
                model: "Iris 52"
            },
            {
                regex: "LN9910(?:[);/ ]|$)",
                model: "Z41"
            },
            {
                regex: "LE9910(?:[);/ ]|$)",
                model: "V8"
            },
            {
                regex: "LH9920(?:[);/ ]|$)",
                model: "V+6"
            },
            {
                regex: "DISCOVER136",
                device: "feature phone",
                model: "Discover 136"
            },
            {
                regex: "KKT QUADRA",
                device: "feature phone",
                model: "KKT Quadra"
            },
            {
                regex: "KKT40[ ]?Power[P\\+]",
                device: "feature phone",
                model: "KKT40 Power Plus"
            },
            {
                regex: "Ivory(S1|S4G)?(?:[);/ ]|$)",
                device: "tablet",
                model: "Ivory $1"
            },
            {
                regex: "iris[ _]?([^/;]+)(?:\\)| Build)",
                model: "Iris $1"
            },
            {
                regex: "Lava[ _]?([^/;]+)(?:/| Build)",
                model: "$1"
            }
        ]
    },
    SKG: {
        regex: "(Modern[ _](?:S10?|S[3679]))(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Landvo: {
        regex: "XM[123]00|(?<!Blade )S6 Build",
        device: "smartphone",
        models: [
            {
                regex: "S6 Build",
                model: "S6"
            },
            {
                regex: "XM([123])00([^/;]*) Build",
                model: "XM$100$2"
            }
        ]
    },
    "Land Rover": {
        regex: "Land[ ]?Rover[d]?[ _-](?:X1[0-9]|Explore|T878|L15\\+|V18|V[168]|X)(?:[);/ ]|$)|Polar3",
        device: "smartphone",
        models: [
            {
                regex: "Land[ ]?Rover[d]?[ _-](X1[0-9]|Explore|T878|L15\\+|V18|V[168]|X)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Polar3",
                model: "Ioutdoor Polar 3"
            }
        ]
    },
    Lanix: {
        regex: "LANIX-([a-z0-9]+)|Ilium[ _]|IliumPad|X120C|Alpha 950",
        device: "smartphone",
        models: [
            {
                regex: "ILIUM[ _]?PAD[ _]?([^;/]+)(?: Build|[;)])",
                model: "Ilium Pad $1",
                device: "tablet"
            },
            {
                regex: "X120C",
                model: "Ilium X120C"
            },
            {
                regex: "Ilium[ _](Alpha [15]s|Alpha [379]|L(?:200|6[12]0|9[0125]0|1[0124]00|1050|1120)|LT5[012]0|M[13579]|S(?:106|520|6[27]0)|X(?:1[12]0|2[0126]0|5[12]0|500B|710)|M[579]s)(?:[);/ ]|$)",
                model: "Ilium $1"
            },
            {
                regex: "ILIUM[ _]([^;/]+) Build",
                model: "Ilium $1"
            },
            {
                regex: "Alpha 950",
                model: "Ilium Alpha 950"
            },
            {
                regex: "LANIX-([a-z0-9]+)",
                device: "feature phone",
                model: "$1"
            }
        ]
    },
    Lark: {
        regex: "(Lark|Cumulus|Evolution|FreeMe|Ultimate (?:X4|7i))[ _-]|Build/Lark|Bjorn[_ ]SP-500|FreeBird 5WiFi",
        device: "tablet",
        models: [
            {
                regex: "Cumulus[ _](5\\.5|[56])[ _]HD",
                model: "Cumulus $1 HD",
                device: "smartphone"
            },
            {
                regex: "FreeMe X2 ([79]) (?:ver|v)?\\.([23])",
                model: "FreeMe X2 $1 Version $2"
            },
            {
                regex: "FreeMe X4 7 3G HD",
                model: "FreeMe X4 7HD 3G"
            },
            {
                regex: "FreeMe[ _]X2[ _]([7-9])",
                model: "FreeMe X2 $1"
            },
            {
                regex: "FreeMe X4[ _]7[_ ]HD",
                model: "FreeMe X4 7HD"
            },
            {
                regex: "FreeMe X4[ _]9",
                model: "FreeMe X4 9"
            },
            {
                regex: "FreeBird 5WiFi",
                model: "FreeBird 5 WiFi"
            },
            {
                regex: "(?:Lark[ _-])?Evolution[ _](X2 7 3G-GPS|X4[_ ]10\\.1|10|X4[_ ]7[ _]IPS)",
                model: "Evolution $1"
            },
            {
                regex: "Ul(?:ti|it)mate (X4 10\\.1 3G IPS|X4 8s 3G|7i)",
                model: "Ultimate $1"
            },
            {
                regex: "PHABLET 7",
                model: "Phablet 7"
            },
            {
                regex: "Phablet 6\\.0",
                model: "Phablet 6.0",
                device: "smartphone"
            },
            {
                regex: "Bjorn[_ ]SP-500",
                model: "Bjorn SP-500",
                device: "smartphone"
            },
            {
                regex: "Cirrus[ _](4\\.5|[45])",
                model: "Cirrus $1",
                device: "smartphone"
            },
            {
                regex: "Lark[ _](Stratus[_ ]5)",
                model: "$1",
                device: "smartphone"
            }
        ]
    },
    LCT: {
        regex: "LCT_([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    "Le Pan": {
        regex: "Le ?Pan|TC970 ([^;/]+)Build",
        device: "tablet",
        models: [
            {
                regex: "TC802A",
                model: "Le Pan Mini"
            },
            {
                regex: "TC970 ([^;/]+)Build",
                model: "TC970 $1"
            },
            {
                regex: "Le ?Pan ?(II|S)(?:[);/ ]|$)",
                model: "Le Pan $1"
            },
            {
                regex: "Le ?Pan ?([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    Leagoo: {
        regex: "(?:MY)?LEAGOO[ _-]?|(?:M5 EDGE|KIICAA (POWER|MIX)|Leapad[ _](?:X|7s)|Elite [15]|Venture 1|Z10-E)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "LEAGOO[- _]M8[_-]?Pro(?:[);/ ]|$)",
                model: "M8 Pro"
            },
            {
                regex: "LEAGOO[- _](Z[156]|M[58]|T1)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "M5 EDGE",
                model: "M5 Edge"
            },
            {
                regex: "LEAGOO[_ ]Lead([57])",
                model: "Lead $1"
            },
            {
                regex: "KIICAA POWER",
                model: "KICCAA Power"
            },
            {
                regex: "KIICAA MIX",
                model: "KICCAA Mix"
            },
            {
                regex: "Elite ([15])(?:[);/ ]|$)",
                model: "Elite $1"
            },
            {
                regex: "Venture 1(?:[);/ ]|$)",
                model: "Venture 1"
            },
            {
                regex: "(?:LEAGOO[- _])?(Z10-E|M6)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(?:My)?Leagoo[- _](E4)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(?:Leapad[ _])(7s|10|X)",
                model: "LeaPad $1",
                device: "tablet"
            }
        ]
    },
    Ledstar: {
        regex: "(?:Ledstar[_ ])?(?:Trendy 5.0|Novus_Premium_6.0)",
        device: "smartphone",
        models: [
            {
                regex: "Trendy 5.0",
                model: "Trendy 5.0"
            },
            {
                regex: "Ledstar_Novus_Premium_6.0(?:[);/ ]|$)",
                model: 'Novus Premium 6.0"'
            }
        ]
    },
    LeEco: {
        regex: "Letv|LeEco|Le ?X[0-9][^;/]+|Le Max|Le [12]|Le2[_ ]x527|X900 Build|(?:X[89]00\\+|X52[67])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "X800\\+",
                model: "Le 1 Pro"
            },
            {
                regex: "X900\\+",
                model: "Max X900+"
            },
            {
                regex: "X50[10]",
                model: "Le 1S"
            },
            {
                regex: "(X910)",
                model: "$1"
            },
            {
                regex: "X900 Build",
                model: "Le X900"
            },
            {
                regex: "(?:Le ?X526|Le2[_ ]x527|Le 2|X52[67])(?:[);/ ]|$)",
                model: "Le 2"
            },
            {
                regex: "Le ?X([^;/]+) Build",
                model: "Le X$1"
            },
            {
                regex: "Le ?X([^) ;/]+)",
                model: "Le X$1"
            },
            {
                regex: "Le ?([12][^;/]+) Build",
                model: "Le $1"
            },
            {
                regex: "Le Max([^;/]*) Build",
                model: "Le Max$1"
            },
            {
                regex: "Le Max([^ ;/]*)",
                model: "Le Max$1"
            },
            {
                regex: "LeEco ([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    Leotec: {
        regex: "LESPH501[14]|LESPH5003B|SUPERNOVA (Qi16|Qi32|i3G96[X]?)",
        device: "smartphone",
        models: [
            {
                regex: "LESPH5011",
                model: "Argon e250"
            },
            {
                regex: "LESPH5003B",
                model: "Argon A250B"
            },
            {
                regex: "LESPH5014",
                model: "Krypton K150"
            },
            {
                regex: "SUPERNOVA (Qi16|Qi32|i3G96[X]?)",
                device: "tablet",
                model: "Supernova $1"
            }
        ]
    },
    Lephone: {
        regex: "lephone[ _]|lephoneP1",
        device: "smartphone",
        models: [
            {
                regex: "lephone[ _](K7|K10)",
                device: "feature phone",
                model: "$1"
            },
            {
                regex: "lephone(?:[ _])?(W(1[0125]|[279])|T2|P1)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "lephone_W7_plus",
                model: "W7 Plus"
            }
        ]
    },
    Lenco: {
        regex: "Lenco ([^/;]*) Build",
        device: "tablet",
        model: "$1"
    },
    Lenovo: {
        regex: "(?:LNV-)?Lenovo|IdeaTab|IdeaPad|Thinkpad|Yoga Tablet|Tab2A[0-9]-[0-9]{2}[a-z]?|ZUK[ -_]|(?:TB2-X30L|TB3-710I|YT3-X50[ML]|K50a40|TB-(?:X103F|8504F|X304F|X704V|X704A)|A5500-H|A2107A-H|A3500-HV|A2109A|S6000|Z2 Plus|Vibe[ _](?:P1|S6i Plus|S[23567]i|C|[ZX]2|K5(?: Plus)?|V7)|P2A42|L38011|L18011|[5-8]01LV|[67]02LV|Z2131|K350t|K31-t3|TAB 2 A8-50LC|S90-A|P70-A|VR-1541F)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Lenovo ?G780",
                model: "G780",
                device: "desktop"
            },
            {
                regex: "Lenovo ?A3500-FL",
                model: "IdeaTab A7-40",
                device: "tablet"
            },
            {
                regex: "(?:Lenovo ?)?A3500-(?:H|HV|F)",
                model: "IdeaTab A7-50",
                device: "tablet"
            },
            {
                regex: "(?:Lenovo[ _])?A5500-[HF]",
                model: "IdeaTab A8-50",
                device: "tablet"
            },
            {
                regex: "Lenovo ?A7600-[HF]",
                model: "IdeaTab A10-70",
                device: "tablet"
            },
            {
                regex: "A2107A-H",
                model: "A2107",
                device: "tablet"
            },
            {
                regex: "A2109A",
                model: "IdeaTab A2109A",
                device: "tablet"
            },
            {
                regex: "TB2-X30[FL]",
                model: "Tab 2 A10-30",
                device: "tablet"
            },
            {
                regex: "YT3-X50[FLM]",
                model: "Yoga Tab 3",
                device: "tablet"
            },
            {
                regex: "TB3-730X",
                model: "TAB3 7",
                device: "tablet"
            },
            {
                regex: "TB3-710[IF]",
                model: "TAB3 7 Essential",
                device: "tablet"
            },
            {
                regex: "TB-7703X",
                model: "TAB3 7 Plus",
                device: "tablet"
            },
            {
                regex: "TB3-X70L",
                model: "TAB3 10 Plus",
                device: "tablet"
            },
            {
                regex: "TB-8703X",
                model: "TAB3 8 Plus",
                device: "tablet"
            },
            {
                regex: "TAB 2 A8-50LC",
                model: "TAB2 A8-50LC",
                device: "tablet"
            },
            {
                regex: "501LV(?:[);/ ]|$)",
                model: 'TAB2 8.0"',
                device: "tablet"
            },
            {
                regex: "TAB 2 A10-70L(?:[);/ ]|$)",
                model: "TAB 2 A10",
                device: "tablet"
            },
            {
                regex: "(?:TB3-850[FM]|601LV)(?:[);/ ]|$)",
                model: "TAB3 8",
                device: "tablet"
            },
            {
                regex: "602LV(?:[);/ ]|$)",
                model: "TAB3 8 Dual",
                device: "tablet"
            },
            {
                regex: "TB-X304[FL]",
                model: "TAB4 10",
                device: "tablet"
            },
            {
                regex: "TB-8504X",
                model: "TAB4 8",
                device: "tablet"
            },
            {
                regex: "TB-8704X",
                model: "TAB4 8 Plus",
                device: "tablet"
            },
            {
                regex: "(?:TB-X704[FVL]|70[12]LV)(?:[);/ ]|$)",
                model: "TAB4 10 Plus",
                device: "tablet"
            },
            {
                regex: "801LV(?:[);/ ]|$)",
                model: 'TAB5 10.1"',
                device: "tablet"
            },
            {
                regex: "TB-X103F(?:[);/ ]|$)",
                model: 'TAB10 10.1"',
                device: "tablet"
            },
            {
                regex: "TB-X704A(?:[);/ ]|$)",
                model: "Moto Tab",
                device: "tablet"
            },
            {
                regex: "TB-X605F(?:[);/ ]|$)",
                model: "Tab M10",
                device: "tablet"
            },
            {
                regex: "TB-X705F(?:[);/ ]|$)",
                model: "Tab P10",
                device: "tablet"
            },
            {
                regex: "TB-X705F(?:[);/ ]|$)",
                model: "Tab P10",
                device: "tablet"
            },
            {
                regex: "TB-7104I(?:[);/ ]|$)",
                model: "Tab E7",
                device: "tablet"
            },
            {
                regex: "TB-8304F1(?:[);/ ]|$)",
                model: "Tab E8",
                device: "tablet"
            },
            {
                regex: "TB-7304X(?:[);/ ]|$)",
                model: "Tab 7 Essential",
                device: "tablet"
            },
            {
                regex: "TB-7504X(?:[);/ ]|$)",
                model: "Tab 7",
                device: "tablet"
            },
            {
                regex: "TB-X606[FXV](?:[);/ ]|$)",
                model: "Tab M10 FHD Plus",
                device: "tablet"
            },
            {
                regex: "Lenovo ?B8000(-[FH])?",
                model: "Yoga Tablet 10",
                device: "tablet"
            },
            {
                regex: "YOGA Tablet 2 Pro-1380[FL]",
                model: 'Yoga Tablet 2 Pro 13.3"',
                device: "tablet"
            },
            {
                regex: "YOGA Tablet 2-1050[FL]",
                model: 'Yoga Tablet 2 10.1"',
                device: "tablet"
            },
            {
                regex: "YOGA Tablet 2-830(?:[FL]|LC)",
                model: 'Yoga Tablet 2 8.0"',
                device: "tablet"
            },
            {
                regex: "Lenovo ?B6000(-[FH])?",
                model: "Yoga Tablet 8",
                device: "tablet"
            },
            {
                regex: "YT3-X90(L|F|X)",
                model: "Yoga 3 Pro",
                device: "tablet"
            },
            {
                regex: "YT3-850[FL]",
                model: "Yoga Tab 3 8",
                device: "tablet"
            },
            {
                regex: "YT3-850M",
                model: "Yoga Tab 3 10",
                device: "tablet"
            },
            {
                regex: "YT-X703L",
                model: "Yoga Tab 3 Plus",
                device: "tablet"
            },
            {
                regex: "S6000(?:[);/ ]|$)",
                model: "IdeaTab S6000",
                device: "tablet"
            },
            {
                regex: "Lenovo ([ASB][0-9]{4})[A-Z]?\\-[EHF]",
                model: "IdeaTab $1",
                device: "tablet"
            },
            {
                regex: "ThinkPadTablet_(A[0-9]{3})_",
                model: "ThinkPad Tablet $1",
                device: "tablet"
            },
            {
                regex: "ThinkPad ?Tablet([^;/]*) Build",
                model: "ThinkPad Tablet$1",
                device: "tablet"
            },
            {
                regex: "Lenovo ?A3300-(?:GV|H)",
                model: "TAB 2 A7-30",
                device: "tablet"
            },
            {
                regex: "TAB 2 A7-30[HGD]C",
                model: "TAB 2 A7",
                device: "tablet"
            },
            {
                regex: "TB-8504F",
                model: "TAB 4 8",
                device: "tablet"
            },
            {
                regex: "TB-X304X",
                model: 'Tab 4 10.1"',
                device: "tablet"
            },
            {
                regex: "TB-X304X",
                model: 'Tab 4 10.1"',
                device: "tablet"
            },
            {
                regex: "TB-X304F",
                model: "TAB4 10",
                device: "tablet"
            },
            {
                regex: "TB-X505[FX]",
                model: "M10",
                device: "tablet"
            },
            {
                regex: "TB-X104[FXL]",
                model: "E10",
                device: "tablet"
            },
            {
                regex: "Tab2A([0-9]-[0-9]{2}[a-z]?)",
                model: "TAB 2 A$1",
                device: "tablet"
            },
            {
                regex: "IdeaTab[ \\-_]?([a-z0-9]+)",
                model: "IdeaTab $1",
                device: "tablet"
            },
            {
                regex: "Yoga Tablet([^;/]+) Build",
                model: "Yoga Tablet$1",
                device: "tablet"
            },
            {
                regex: "TB-8505F",
                model: "Tab M8",
                device: "tablet"
            },
            {
                regex: "TB-8705F",
                model: "Tab M8 FHD",
                device: "tablet"
            },
            {
                regex: "TB-8705F",
                model: "Tab M8 FHD",
                device: "tablet"
            },
            {
                regex: "Lenovo (TB[0-9]?\\-[a-z0-9\\-]+) Build",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "L18011(?:[);/ ]|$)",
                model: "A5"
            },
            {
                regex: "Z2 Plus",
                model: "Z2 Plus"
            },
            {
                regex: "Z2151",
                model: "ZUK Edge"
            },
            {
                regex: "Z213[12]",
                model: "ZUK Z2"
            },
            {
                regex: "Z2121",
                model: "ZUK Z2 Pro"
            },
            {
                regex: "ZUK[ -_]([^/;]*)(?: Build|\\))",
                model: "ZUK $1"
            },
            {
                regex: "K10a40(?:[);/ ]|$)",
                model: "C2"
            },
            {
                regex: "k50a40(?:[);/ ]|$)",
                model: "K3 Note"
            },
            {
                regex: "A7010a48(?:[);/ ]|$)",
                model: "K4 Note"
            },
            {
                regex: "K350t(?:[);/ ]|$)",
                model: "K5"
            },
            {
                regex: "L38011(?:[);/ ]|$)",
                model: "K5 Play"
            },
            {
                regex: "A7020a4[08](?:[);/ ]|$)",
                model: "K5 Note"
            },
            {
                regex: "K31-t3(?:[);/ ]|$)",
                model: "K31"
            },
            {
                regex: "(?:A6020a46|Vibe K5 Plus)(?:[);/ ]|$)",
                model: "Vibe K5 Plus"
            },
            {
                regex: "(?:Lenovo-)?(?:A6020(?:a40|l36)|Vibe K5)(?:[);/ ]|$)",
                model: "Vibe K5"
            },
            {
                regex: "VIBE Z2(?:[);/ ]|$)",
                model: "Vibe Z2"
            },
            {
                regex: "VIBE C(?:[);/ ]|$)",
                model: "Vibe C"
            },
            {
                regex: "VIBE X2(?:[);/ ]|$)",
                model: "Vibe X2"
            },
            {
                regex: "VIBE V7(?:[);/ ]|$)",
                model: "Vibe V7"
            },
            {
                regex: "VIBE S6i Plus(?:[);/ ]|$)",
                model: "Vibe S6i Plus"
            },
            {
                regex: "VIBE[ _]S([23567])i(?:[);/ ]|$)",
                model: "Vibe S$1i"
            },
            {
                regex: "k33a48(?:[);/ ]|$)",
                model: "K6"
            },
            {
                regex: "P2A42(?:[);/ ]|$)",
                model: "P2"
            },
            {
                regex: "k53a48(?:[);/ ]|$)",
                model: "K6 Note"
            },
            {
                regex: "K33a42(?:[);/ ]|$)",
                model: "K6 Power"
            },
            {
                regex: "P1ma40(?:[);/ ]|$)",
                model: "Vibe P1m"
            },
            {
                regex: "Vibe P1 Turbo(?:[);/ ]|$)",
                model: "Vibe P1 Turbo"
            },
            {
                regex: "(?:P1(?:a42|c72)|Vibe P1)(?:[);/ ]|$)",
                model: "Vibe P1"
            },
            {
                regex: "A2016a40(?:[);/ ]|$)",
                model: "Vibe B"
            },
            {
                regex: "A1010a20(?:[);/ ]|$)",
                model: "A Plus"
            },
            {
                regex: "Z90a40(?:[);/ ]|$)",
                model: "Vibe Shot"
            },
            {
                regex: "S1a40(?:[);/ ]|$)",
                model: "Vibe S1"
            },
            {
                regex: "L78071(?:[);/ ]|$)",
                model: "Z5s"
            },
            {
                regex: "L58041(?:[);/ ]|$)",
                model: "S5 Pro"
            },
            {
                regex: "L18021(?:[);/ ]|$)",
                model: "A3"
            },
            {
                regex: "PB2-670M(?:[);/ ]|$)",
                model: "Phab 2"
            },
            {
                regex: "(S90-A|P70-A)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "IdeaPad ?([^;/]*) Build",
                model: "IdeaPad $1",
                device: "tablet"
            },
            {
                regex: "VR-1541F",
                device: "wearable",
                model: "Mirage Solo"
            },
            {
                regex: "LENOVO/81W8(?:[);/ ]|$)",
                device: "desktop",
                model: "IdeaPad S145-15IIL"
            },
            {
                regex: "LENOVO/81MV(?:[);/ ]|$)",
                device: "desktop",
                model: "IdeaPad S145-15IWL"
            },
            {
                regex: "LENOVO/81SS(?:[);/ ]|$)",
                device: "desktop",
                model: "Flex 14API 81SS"
            },
            {
                regex: "Lenovo TAB ?([^/;]*) Build",
                model: "TAB $1",
                device: "tablet"
            },
            {
                regex: "Lenovo ([^/;]*) Build",
                model: "$1"
            },
            {
                regex: "(?:LNV-|Lenovo-)?Lenovo[ \\-_]?([a-z0-9_+\\-]+)",
                model: "$1"
            }
        ]
    },
    Lexand: {
        regex: "(?:SC7 PRO HD|S5A[1-4]|S4A[1-5]|S6A1|A811|A802)(?:[);/ ]|$)|Lexand ([^;/]+) Build",
        device: "smartphone",
        models: [
            {
                regex: "A(811|802)",
                device: "tablet",
                model: "A$1"
            },
            {
                regex: "S4A1",
                model: "Vega"
            },
            {
                regex: "S4A2",
                model: "Irida"
            },
            {
                regex: "S4A3",
                model: "Pallada"
            },
            {
                regex: "S4A5",
                model: "Oxygen"
            },
            {
                regex: "S4A4 NEON",
                model: "S4A4 Neon"
            },
            {
                regex: "S5A1",
                model: "Callisto"
            },
            {
                regex: "S5A2",
                model: "Overon"
            },
            {
                regex: "S5A3",
                model: "Capella"
            },
            {
                regex: "S5A4",
                model: "Argon"
            },
            {
                regex: "S6A1",
                model: "Antares"
            },
            {
                regex: "SC7 PRO HD",
                model: "SC7 PRO HD"
            },
            {
                regex: "Lexand ([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    Lexibook: {
        regex: "(MFC[0-9]{3}[a-z]{2,})",
        device: "tablet",
        models: [
            {
                regex: "MFC191FR",
                model: "Tablet Ultra 3 XL"
            },
            {
                regex: "MFC045FR",
                model: "TabTab"
            },
            {
                regex: "MFC163FR",
                model: "Tablet Master 3"
            },
            {
                regex: "MFC142FR",
                model: "Tablet Kids"
            },
            {
                regex: "MFC250FR",
                model: "Tablet Junior"
            },
            {
                regex: "MFC270FR",
                model: "Tablet Junior Power Touch"
            },
            {
                regex: "MFC280FR",
                model: "Tablet Junior 2"
            },
            {
                regex: "MFC156FR",
                model: "Tablet One"
            },
            {
                regex: "MFC155FR",
                model: "Tablet Master"
            },
            {
                regex: "MFC157FR",
                model: "Tablet Master 2"
            },
            {
                regex: "MFC17[05]FR",
                model: "Tablet Ultra"
            },
            {
                regex: "MFC375FR",
                model: "Tablet Ultra 2"
            },
            {
                regex: "MFC162FR",
                model: "Power Tablet"
            },
            {
                regex: "MFC180FR",
                model: "Tablet Advanced"
            },
            {
                regex: "MFC181FR",
                model: "Tablet Advanced 2"
            },
            {
                regex: "MFC500FR",
                model: "Tablet XL"
            },
            {
                regex: "MFC190BBFR",
                model: "Barbie Tablet"
            },
            {
                regex: "MFC195DCFR",
                model: "Tablet Disney Cars HD"
            },
            {
                regex: "MFC195FUFR",
                model: "Furby Tablet"
            },
            {
                regex: "MFC195DPFR",
                model: "Tablet Disney Princesse HD"
            },
            {
                regex: "MFC140FR",
                model: "LapTab"
            },
            {
                regex: "MFC141FR",
                model: "LapTab 2"
            },
            {
                regex: "(MFC[0-9]{3}[a-z]{2,})",
                model: "$1"
            }
        ]
    },
    LG: {
        regex: "LG|Web0S; Linux/SmartTV|portalmmm/2\\.0 (?:KE|KG|KP|L3)|(?:VX[0-9]+|L-0[12]D|L-07C|P713|(LM-[A-Z][0-9]{3}[A-Z]{0,3}(?:\\(FGN?\\)|\\(G\\)|\\.FN|\\.F(?:GN?)?)?)|LM-(X625N1|G820QM[0127]))(?:[);/ ]|$)|NetCast|RS98[78]|RS500|VS(?:50[01]|835|876|880|98[0578]|99[056]|(410|415|425|500|880)PP)|VS820|VS870 4G|Nexsus 5|LML(41[34]D|211B|713D|212V)L|VK810 4G|VK815|X5-LG|L-05[DE]|L-03K|L-01[LJK]|L-52A|L-[45]1A|901LG|A001LG|80[12]LG|402LG|LGT32|L-02K|L-01F|LM-V40|DM-01K|LMX130IM",
        device: "smartphone",
        models: [
            {
                regex: "DM-01K",
                model: "Disney Mobile DM-01K"
            },
            {
                regex: "LG-D325",
                model: "L70"
            },
            {
                regex: "LG-D340F8",
                model: "L70 Tri"
            },
            {
                regex: "LM-X210APM",
                model: "Phoenix 4"
            },
            {
                regex: "LG-P505R",
                model: "Phoenix"
            },
            {
                regex: "LM-X210VPP",
                model: "Zone 4"
            },
            {
                regex: "LM-X220PM",
                model: "Tribute Empire"
            },
            {
                regex: "VS980|L-01F",
                model: "G2"
            },
            {
                regex: "LG-D6(?:18|20)",
                model: "G2 Mini"
            },
            {
                regex: "LG-D85[01258]|VS985",
                model: "G3"
            },
            {
                regex: "LG-D72[2458]",
                model: "G3 Beat"
            },
            {
                regex: "LG-H81[158]",
                model: "G4"
            },
            {
                regex: "LG-H525n?",
                model: "G4c"
            },
            {
                regex: "LG-(?:H540|H542|H630)",
                model: "G4 Stylus"
            },
            {
                regex: "LG-H736",
                model: "G4s"
            },
            {
                regex: "LG-H735",
                model: "G4 Beat"
            },
            {
                regex: "LG-H8(?:20|3[01]|5[08]|6[08])|VS987|RS988",
                model: "G5"
            },
            {
                regex: "LG-H84[05]",
                model: "G5 SE"
            },
            {
                regex: "VS988|LG-H87(?:0DS|3)",
                model: "G6"
            },
            {
                regex: "LM-Q850",
                model: "G7 Fit"
            },
            {
                regex: "LM-Q910",
                model: "G7 One"
            },
            {
                regex: "LM-G820(N|QM[0127]|UMB)?",
                model: "G8"
            },
            {
                regex: "LM-G850",
                model: "G8X ThinQ"
            },
            {
                regex: "LM-G810",
                model: "G8S ThinQ"
            },
            {
                regex: "901LG(?:[);/ ]|$)",
                model: "G8X ThinQ"
            },
            {
                regex: "VS501|LM-X120",
                model: "K20"
            },
            {
                regex: "(?:LG-)?H502",
                model: "Magna"
            },
            {
                regex: "(?:LG-)?H343",
                model: "Risio"
            },
            {
                regex: "(?:LG-)?H650",
                model: "Zero"
            },
            {
                regex: "(?:LG-)?M154",
                model: "Risio 2"
            },
            {
                regex: "(?:LG-)?P500H",
                model: "Optimus One"
            },
            {
                regex: "(L-05[DE])(?:[);/ ]|$)",
                model: "Optimus it $1"
            },
            {
                regex: "LG-L160L(?:[);/ ]|$)",
                model: "Optimus LTE 2"
            },
            {
                regex: "P713(?:[);/ ]|$)",
                model: "Optimus L7II"
            },
            {
                regex: "L-01D(?:[);/ ]|$)",
                model: "Optimus LTE L-01D"
            },
            {
                regex: "L-02D(?:[);/ ]|$)",
                model: "PRADA phone L-02D"
            },
            {
                regex: "L-07C",
                model: "Optimus Bright L-07C"
            },
            {
                regex: "(?:LG-)?F800(?:S|K|L)?",
                model: "V20"
            },
            {
                regex: "LM-Q710(?:\\(FGN\\)|[\\.]?FGN)",
                model: "Q Stylus Plus"
            },
            {
                regex: "801LG",
                model: "Q Stylus"
            },
            {
                regex: "LM-Q[67]10\\.FG(?:[);/ ]|$)",
                model: "Q7"
            },
            {
                regex: "LM-(Q725[KL]|Q610.FGN)(?:[);/ ]|$)",
                model: "Q7+"
            },
            {
                regex: "LM-Q815[SL](?:[);/ ]|$)",
                model: "Q8+"
            },
            {
                regex: "LM-Q925L(?:[);/ ]|$)",
                model: "Q9"
            },
            {
                regex: "LM-Q730N(?:[);/ ]|$)",
                model: "Q70"
            },
            {
                regex: "LGV33(?:[);/ ]|$)",
                model: "Qua Phone PX"
            },
            {
                regex: "L-03K(?:[);/ ]|$)",
                model: "Style"
            },
            {
                regex: "L-01L(?:[);/ ]|$)",
                model: "Style 2"
            },
            {
                regex: "VS835(?:[);/ ]|$)",
                model: "Stylo 2 V"
            },
            {
                regex: "L-41A(?:[);/ ]|$)",
                model: "Style 3"
            },
            {
                regex: "LM-Q710|LML713DL",
                model: "Stylo 4"
            },
            {
                regex: "(?:LM-Q720|LGL722DL)(?:[);/ ]|$)",
                model: "Stylo 5"
            },
            {
                regex: "LM-Q730(?:[);/ ]|$)",
                model: "Stylo 6"
            },
            {
                regex: "LM-G710(N|VM)?",
                model: "G7 ThinQ"
            },
            {
                regex: "LM-X210CM",
                model: "Fortune 2"
            },
            {
                regex: "LM-X410\\.F(?:[);/ ]|$)",
                model: "Premier Pro"
            },
            {
                regex: "LML41[34]DL(?:[);/ ]|$)",
                model: "Premier Pro LTE"
            },
            {
                regex: "LM-X525",
                model: "Q60"
            },
            {
                regex: "LM-X210K",
                model: "X2"
            },
            {
                regex: "LG-K580",
                model: "X Cam"
            },
            {
                regex: "LM-X510WM",
                model: "X Power 3"
            },
            {
                regex: "LM-X(?:41[05]K|410S)",
                model: "X4"
            },
            {
                regex: "LM-X(415[LS]|410L)",
                model: "X4+"
            },
            {
                regex: "LM-X410(?:\\.FN|\\(FG\\))",
                model: "K11"
            },
            {
                regex: "LM-X(?:320|410[UP]M)",
                model: "K30"
            },
            {
                regex: "LMX130IM",
                model: "W10"
            },
            {
                regex: "LM-X410",
                model: "LM-X410"
            },
            {
                regex: "LM-X420N",
                model: "X4 (2019)"
            },
            {
                regex: "LG-X230",
                model: "K4"
            },
            {
                regex: "LM-X420",
                model: "K40"
            },
            {
                regex: "LM-X430(?:[);/ ]|$)",
                model: "K40S"
            },
            {
                regex: "LG-X220",
                model: "K5"
            },
            {
                regex: "LM-X540",
                model: "K50S"
            },
            {
                regex: "(?:802LG|LM-X520)(?:[);/ ]|$)",
                model: "K50"
            },
            {
                regex: "402LG",
                model: "Spray"
            },
            {
                regex: "L-02K",
                model: "JoJo"
            },
            {
                regex: "(?:LM-X510[KLS]|X5-LG)",
                model: "X5"
            },
            {
                regex: "LM-X625N1",
                model: "X6"
            },
            {
                regex: "LM-X625N",
                model: "X6 (2019)"
            },
            {
                regex: "LGMS210",
                model: "Aristo"
            },
            {
                regex: "LM-X210[G]?",
                model: "Aristo 2"
            },
            {
                regex: "LM-X220",
                model: "Aristo 3"
            },
            {
                regex: "LM-V40(?:5|9N)?(?:[);/ ]|$)",
                model: "V40 ThinQ"
            },
            {
                regex: "LM-(?:V500N|V450)(?:[);/ ]|$)",
                model: "V50 ThinQ"
            },
            {
                regex: "LM-V510N",
                model: "V50S ThinQ"
            },
            {
                regex: "LM-Q920N",
                model: "Q92"
            },
            {
                regex: "LM-Q927L",
                model: "Q9 One"
            },
            {
                regex: "(?:LG-)?(?:RS987|H901|H96[0128]|VS990)",
                model: "V10"
            },
            {
                regex: "LG-X240",
                model: "K8 (2017)"
            },
            {
                regex: "(?:LG-)?RS500",
                model: "K8 4G"
            },
            {
                regex: "(?:LG-)?VS500",
                model: "K8 V"
            },
            {
                regex: "LM-X212\\(G\\)",
                model: "K8 (2018)"
            },
            {
                regex: "(?:LG-)?H91[058]",
                model: "V20"
            },
            {
                regex: "(?:LG-)?H990(?:DS|N|T)?",
                model: "V20"
            },
            {
                regex: "(?:LG-)?LS997",
                model: "V20"
            },
            {
                regex: "(?:LG-)?VS995",
                model: "V20"
            },
            {
                regex: "(?:LG-)?US999",
                model: "V20"
            },
            {
                regex: "(?:VS996|LG-(?:H933|H93[012]|H932PR|[LU]S998|AS998)|LGM-V300[KLS])(?:[);/ ]|$)",
                model: "V30"
            },
            {
                regex: "L-01J(?:[);/ ]|$)",
                model: "V20 Pro"
            },
            {
                regex: "(?:L-01K|LGV35)(?:[);/ ]|$)",
                model: "V30 Plus"
            },
            {
                regex: "L-51A(?:[);/ ]|$)",
                model: "V60"
            },
            {
                regex: "(?:L-52A|LM-G900N?)(?:[);/ ]|$)",
                model: "Velvet 5G"
            },
            {
                regex: "(?:LM-G910)(?:[);/ ]|$)",
                model: "Velvet 4G"
            },
            {
                regex: "(?:A001LG|LM-V600)(?:[);/ ]|$)",
                model: "V60 ThinQ 5G"
            },
            {
                regex: "(?:LG-)?VS410PP",
                model: "Optimus Zone"
            },
            {
                regex: "LM-V350[N]?",
                model: "V35"
            },
            {
                regex: "(?:LG-)?VS415PP",
                model: "Optimus Zone 2"
            },
            {
                regex: "(?:LG-)?VS425PP",
                model: "Optimus Zone 3"
            },
            {
                regex: "(?:LG-)?K100",
                model: "K3"
            },
            {
                regex: "(?:LG-?)?(?:K|MS)33[02]",
                model: "K7"
            },
            {
                regex: "(?:LG-?)?(?:K|MS)350",
                model: "K8"
            },
            {
                regex: "VS500PP",
                model: "K8 V"
            },
            {
                regex: "(?:LG-)?K420(?:N)?",
                model: "K10"
            },
            {
                regex: "(?:LG-)?K430(?:DS|DSF|DSY)?",
                model: "K10"
            },
            {
                regex: "(?:LG-)?M250N?",
                model: "K10 (2017)"
            },
            {
                regex: "(?:LG-)?F670[KLS]?",
                model: "K10"
            },
            {
                regex: "(?:LG-)?M255",
                model: "K20"
            },
            {
                regex: "(?:LG-?)?[MT]P260",
                model: "K20 Plus"
            },
            {
                regex: "LM-K200(?:[);/ ]|$)",
                model: "K22"
            },
            {
                regex: "LM-K300(?:[);/ ]|$)",
                model: "K31"
            },
            {
                regex: "LM-K420(?:[);/ ]|$)",
                model: "K42"
            },
            {
                regex: "LM-K500(?:[);/ ]|$)",
                model: "K51"
            },
            {
                regex: "LM-K520(?:[);/ ]|$)",
                model: "K52"
            },
            {
                regex: "LM-Q510N(?:[);/ ]|$)",
                model: "Q51"
            },
            {
                regex: "LM-Q630N?(?:[);/ ]|$)",
                model: "Q61"
            },
            {
                regex: "(?:LG-)?M700(?:N|A|DSK|AN)?",
                model: "Q6"
            },
            {
                regex: "LM-X440IM",
                model: "W30"
            },
            {
                regex: "(?:LG-?)?K220",
                model: "X Power"
            },
            {
                regex: "(?:LG-?)?M320",
                model: "X Power 2"
            },
            {
                regex: "(?:LG-)?K371",
                model: "Phoenix 2"
            },
            {
                regex: "(?:LG-)?M150",
                model: "Phoenix 3"
            },
            {
                regex: "(?:LG-)?F100[SL]",
                model: "Optimus Vu"
            },
            {
                regex: "(?:LG-)?P880",
                model: "Optimus 4X HD"
            },
            {
                regex: "(?:LG-)?(H340n?|H324)",
                model: "Leon"
            },
            {
                regex: "(?:LG-)?H342",
                model: "Leon 4G LTE"
            },
            {
                regex: "(?:LG-)?H422",
                model: "Spirit"
            },
            {
                regex: "(?:LG)?C660",
                model: "Optimus Pro"
            },
            {
                regex: "LML21(?:1B|2V)L",
                model: "Rebel 4"
            },
            {
                regex: "VS876",
                model: "Lucid 3"
            },
            {
                regex: "VS880(PP)?",
                model: "G Vista"
            },
            {
                regex: "VS820",
                model: "Lancet"
            },
            {
                regex: "VS870 4G",
                model: "Lucid 2"
            },
            {
                regex: "LM-F100N?(?:[);/ ]|$)",
                device: "phablet",
                model: "WING"
            },
            {
                regex: "LGUK410",
                model: 'G Pad 7.0" LTE',
                device: "tablet"
            },
            {
                regex: "LGLK430",
                model: 'G Pad F 7.0"',
                device: "tablet"
            },
            {
                regex: "LGLK430",
                model: 'G Pad F 7.0"',
                device: "tablet"
            },
            {
                regex: "LG-V490",
                model: "G Pad 8.0",
                device: "tablet"
            },
            {
                regex: "LGT01",
                model: 'G Pad 8.0" LTE',
                device: "tablet"
            },
            {
                regex: "LG-V500",
                model: "G Pad 8.3",
                device: "tablet"
            },
            {
                regex: "LG-V700",
                model: "G Pad 10.1",
                device: "tablet"
            },
            {
                regex: "LG-V935",
                model: "G Pad II 10.1",
                device: "tablet"
            },
            {
                regex: "LG-V521",
                model: "G Pad X 8.0",
                device: "tablet"
            },
            {
                regex: "VK810",
                model: "G Pad 8.3 LTE",
                device: "tablet"
            },
            {
                regex: "VK815",
                model: "G Pad X 8.3",
                device: "tablet"
            },
            {
                regex: "LGT32",
                model: "Qua Tad PZ",
                device: "tablet"
            },
            {
                regex: "LGT31",
                model: "Qua Tad PX",
                device: "tablet"
            },
            {
                regex: "webOS.TV",
                device: "tv",
                model: "WebOS TV"
            },
            {
                regex: "LGE_DLNA_SDK|NetCast",
                device: "tv",
                model: "NetCast"
            },
            {
                regex: "LG Watch Urbane",
                device: "wearable",
                model: "Watch Urbane"
            },
            {
                regex: "(LM-[A-Z]{1}[0-9]{3}([A-Z]{1,3})?)",
                model: "$1"
            },
            {
                regex: "LGE(?: |-LG| LG-AX|-)([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "FBDV/LG-([a-z0-9]+);FBSV",
                model: "$1"
            },
            {
                regex: "LGE;([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "LG[ _\\-](V90.*|Optimus[ _\\-]Pad.*) Build",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "LG(?:/|-LG| |-)?([^/;]*) Build",
                model: "$1"
            },
            {
                regex: "LG(?:/|-LG| |-)?([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "LG; ([a-z0-9 ]+)",
                model: "$1"
            },
            {
                regex: "portalmmm/2.0 ((?:KE|KG|KP|L3)[a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(VX[0-9]+)",
                model: "$1"
            },
            {
                regex: "Web0S; Linux/SmartTV",
                device: "tv",
                model: ""
            }
        ]
    },
    Lingwin: {
        regex: "Lingwin[ _\\-]",
        device: "smartphone",
        models: [
            {
                regex: "Lingwin[ _\\-]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "Lingwin[ _\\-]?([^);/ ]+)",
                model: "$1"
            }
        ]
    },
    Logicom: {
        regex: "LOGICOM[_ ]|(TAB950|TAB1062|E731|E812|E912|E1031|POWER BOT|La[ _]Tab[ _](?:7[24]|10[57]|114)|(?:B|C|M|ID|VR)[ _]?BOT[ _]?(?:TAB[ _])?([0-9]+\\+?)(?:PLUS)?|KT712A_4\\.4|L-?IXIR[0-9]*|L-ITE|L-EGANTONE(?:-R)?|L-?EMENT.+|Le[ _]?(?:Hop|Hello|Lift|Hola|Moov[2]?|Must(?: 2)?|Starter L|Fit FR|Spark|Prime|Smooth(?: FR)?))[_);/ ]",
        device: "tablet",
        models: [
            {
                regex: "La[ _]Tab[ _](7[24]|10[57]|114)(?:[);/ ]|$)",
                model: "La Tab $1"
            },
            {
                regex: "LOGICOM_LA_TAB_LINK_71",
                model: "La Tab Link 71"
            },
            {
                regex: "KT712A_4.4|L-IXIR TAB 701 3G",
                model: "L-ixir Tab 701 3G"
            },
            {
                regex: "LIXIR1041",
                model: "L-ixir Tab 1041"
            },
            {
                regex: "L-?IXIR[ _]TAB[ _]([^);/]+)( Build|[);])",
                model: "L-ixir Tab $1"
            },
            {
                regex: "L-ITE[ _](400M|452|50[46] HD|506R HD|552 HD)(?:[);/ ]|$)",
                device: "smartphone",
                model: "L-ite $1"
            },
            {
                regex: "L-ITE[ _]([^;/]+) Build",
                model: "L-ite Tab $1"
            },
            {
                regex: "L-?EMENT[ _]?(350|451|40[103]|55[013]|50[15]|500L?)(?:[);/ ]|$)",
                model: "L-ement $1",
                device: "smartphone"
            },
            {
                regex: "L-?EMENT[ _](?:TAB)[ )]?([^);/]+)(?: Build|[);])",
                model: "L-ement Tab $1"
            },
            {
                regex: "L-?EMENT[ _]?(74[01])(?:[);/ ]|$)",
                model: "L-ement Tab $1"
            },
            {
                regex: "(TAB950|TAB1062|E731|E812|E912|E1031)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "POWER BOT",
                model: "POWER BOT"
            },
            {
                regex: "((?:B|C|M|ID|VR))[ _]?BOT[ _]?((?:TAB[ _])?([0-9]+\\+?)(?:PLUS)?)",
                model: "$1 BOT $2"
            },
            {
                regex: "Le Lift",
                model: "Le Lift",
                device: "smartphone"
            },
            {
                regex: "Le Hola FR(?:[);/ ]|$)",
                model: "Le Hola FR",
                device: "smartphone"
            },
            {
                regex: "Le[ _]Hola(?:[);/ ]|$)",
                model: "Le Hola",
                device: "smartphone"
            },
            {
                regex: "LeMoov2(?:[);/ ]|$)",
                model: "Le Moov 2",
                device: "smartphone"
            },
            {
                regex: "LeMoov(?:[);/ ]|$)",
                model: "Le Moov",
                device: "smartphone"
            },
            {
                regex: "Le Fit FR(?:[);/ ]|$)",
                model: "Le Fit FR",
                device: "smartphone"
            },
            {
                regex: "Le Hop(?:[);/ ]|$)",
                model: "Le Hop",
                device: "smartphone"
            },
            {
                regex: "Le[ _]Hello(?:[);/ ]|$)",
                model: "Le Hello",
                device: "smartphone"
            },
            {
                regex: "Le Smooth FR(?:[);/ ]|$)",
                model: "Le Smooth FR",
                device: "smartphone"
            },
            {
                regex: "Le Smooth(?:[);/ ]|$)",
                model: "Le Smooth",
                device: "smartphone"
            },
            {
                regex: "Le Must 2(?:[);/ ]|$)",
                device: "smartphone",
                model: "Le Must 2"
            },
            {
                regex: "Le Must(?:[);/ ]|$)",
                model: "Le Must",
                device: "smartphone"
            },
            {
                regex: "Le Starter L(?:[);/ ]|$)",
                model: "Le Starter L",
                device: "smartphone"
            },
            {
                regex: "Le[ _]Spark(?:[);/ ]|$)",
                model: "Le Spark",
                device: "smartphone"
            },
            {
                regex: "Le[ _]Prime(?:[);/ ]|$)",
                model: "Le Prime",
                device: "smartphone"
            },
            {
                regex: "L-EGANTONE-R",
                model: "L-Egant One R",
                device: "smartphone"
            },
            {
                regex: "L-EGANTONE",
                model: "L-Egant One",
                device: "smartphone"
            }
        ]
    },
    Konka: {
        regex: "KONKA[_ ]([a-z0-9]+)",
        device: "smartphone",
        models: [
            {
                regex: "E5660S",
                model: "Viva 5660s"
            },
            {
                regex: "W830",
                model: "Tango 830"
            },
            {
                regex: "W(9[67]0)",
                model: "Expose $1"
            },
            {
                regex: "W990",
                model: "Tuxedo 990"
            },
            {
                regex: "KONKA[_ ]([a-z0-9]+)",
                device: "feature phone",
                model: "$1"
            }
        ]
    },
    Konrow: {
        regex: "(?:BIGCOOL|COOLFIVE|COOL-K|Just5|Link5|EASY(?:5|62)|CITY55|Cool55)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "BIGCOOL(?:[);/ ]|$)",
                model: "BigCool"
            },
            {
                regex: "COOL-K(?:[);/ ]|$)",
                model: "Cool-K"
            },
            {
                regex: "Cool55(?:[);/ ]|$)",
                model: "Cool 55"
            },
            {
                regex: "COOLFIVE(?:[);/ ]|$)",
                model: "Cool Five"
            },
            {
                regex: "Just5(?:[);/ ]|$)",
                model: "Just 5"
            },
            {
                regex: "Link5(?:[);/ ]|$)",
                model: "Link 5"
            },
            {
                regex: "EASY(5|62)(?:[);/ ]|$)",
                model: "Easy $1"
            },
            {
                regex: "CITY55(?:[);/ ]|$)",
                model: "City 55"
            }
        ]
    },
    Karbonn: {
        regex: "(?:Browser-)?Karbonn|K9 Kavach 4G|K9[_ ]Viraat[_ ]Plus|K9 Music 4G|K9 Smart|K9 VIRAAT 4G|Aura (?:Sleek Plus|Power 4G Plus|Note Play)|Titanium[ _](?:3D-Plex|Octane Plus|Vista 4G|Jumbo|S360|S1[059]|S35|S20[13]|S22|S[15]|S200 HD|Frames S7|MOGHUL|S9)|K-lite F3|Sparkle V|Alfa A114 Quad|Quattro L55 HD",
        device: "smartphone",
        models: [
            {
                regex: "K9 Kavach 4G",
                model: "K9 Kavach 4G"
            },
            {
                regex: "K9 Music 4G",
                model: "K9 Music 4G"
            },
            {
                regex: "K9 Smart 1GB",
                model: "K9 Smart"
            },
            {
                regex: "K9 Smart 4G",
                model: "K9 Smart 4G"
            },
            {
                regex: "K9 Smart Grand",
                model: "K9 Smart Grand"
            },
            {
                regex: "K9 Smart Yuva",
                model: "K9 Smart Yuva"
            },
            {
                regex: "K9 Smart",
                model: "K9 Smart"
            },
            {
                regex: "K9[_ ]Viraat[_ ]Plus",
                model: "K9 Viraat Plus"
            },
            {
                regex: "Aura Sleek Plus",
                model: "Aura Sleek Plus"
            },
            {
                regex: "Aura Power 4G Plus",
                model: "Aura Power 4G Plus"
            },
            {
                regex: "Aura Note Play",
                model: "Aura Note Play"
            },
            {
                regex: "Alfa A114 Quad",
                model: "Alfa A114 Quad"
            },
            {
                regex: "karbonnK9 Viraat 4G|K9 VIRAAT 4G",
                model: "K9 Viraat 4G"
            },
            {
                regex: "Titanium[ _]S2[ _]Plus",
                model: "Titanium S2 Plus"
            },
            {
                regex: "Titanium_S9Plus",
                model: "Titanium S9 Plus"
            },
            {
                regex: "Titanium[_ ]S(99|360|1[059]|109|35|200 HD|20[13]|22|[15])(?:[);/ ]|$)",
                model: "Titanium S$1"
            },
            {
                regex: "Titanium Vista 4G",
                model: "Titanium Vista 4G"
            },
            {
                regex: "Titanium Jumbo 2",
                model: "Titanium Jumbo 2"
            },
            {
                regex: "Titanium Jumbo",
                model: "Titanium Jumbo"
            },
            {
                regex: "Titanium[ _]MOGHUL",
                model: "Titanium Moghul"
            },
            {
                regex: "Titanium Frames S7",
                model: "Titanium Frames S7"
            },
            {
                regex: "Titanium Octane Plus",
                model: "Titanium Octane Plus"
            },
            {
                regex: "Titanium[ _]3D-Plex",
                model: "Titanium 3D Plex"
            },
            {
                regex: "K-lite F3",
                model: "K-Lite F3"
            },
            {
                regex: "Sparkle V",
                model: "Sparkle V"
            },
            {
                regex: "Quattro L55 HD",
                model: "Quattro L55 HD"
            },
            {
                regex: "Karbonn ([a-z0-9]+) WAP-Browser",
                model: "$1",
                device: "feature phone"
            },
            {
                regex: "WAP Browser-Karbonn ([a-z0-9]+)/",
                model: "$1",
                device: "feature phone"
            },
            {
                regex: "Karbonn_([^;/)]+)",
                model: "$1"
            },
            {
                regex: "Karbonn ([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Karbonn ([^;/]+)/",
                model: "$1"
            }
        ]
    },
    Sagem: {
        regex: "SAGEM|portalmmm/2.0 (?:SG|my)",
        device: "smartphone",
        models: [
            {
                regex: "SAGEM-(my[a-z0-9\\-]+)",
                model: "$1",
                device: "feature phone"
            },
            {
                regex: "SAGEM ([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "SAGEM-([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "portalmmm/2.0 ((?:SG|my)[a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    "Coby Kyros": {
        regex: "(MID(?:1024|1125|1126|1045|1048|1060|1065|4331|7012|7015A?|7016|7022|7032|7035|7036|7042|7047|7048|7052|7065|7120|8024|8042|8048|8065|8125|8127|8128|9724|9740|9742))(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Mpman: {
        regex: "(?:MPQC|MPDC)[0-9]+|PH(?:150|340|350|360|451|500|520|544|604)|(?:MID(?:7C|74C|82C|84C|801|811|701|711|170|77C|43C|102C|103C|104C|114C)|MP100i OCTA|MP(?:843|717|718|1010|7007|7008|843|888|959|969)|MGP7)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "((?:MPQC|MPDC)[0-9]+[^/;)]+)(?: Build|\\))",
                model: "$1"
            },
            {
                regex: "MP100i OCTA(?:[);/ ]|$)",
                model: "MP100i OCTA"
            },
            {
                regex: "(MID(?:7C|74C|82C|84C|801|811|701|711|170|77C|43C|102C|103C|104C|114C)|MP(?:843|717|718|1010|7007|7008|843|888|959|969)|MGP7)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(PH(?:150|340|350|360|451|500|520|544|604))",
                model: "$1",
                device: "smartphone"
            }
        ]
    },
    Majestic: {
        regex: "MAJESTIC[ _-]|CRONO ?[0-9]+|TAB (?:647|411) 3G|URANO 77LTE",
        device: "smartphone",
        models: [
            {
                regex: "URANO 77LTE(?:[);/ ]|$)",
                model: "Urano 77 LTE"
            },
            {
                regex: "TAB (647|411) 3G",
                model: "Tab $1 3G",
                device: "tablet"
            },
            {
                regex: "MAJESTIC[ _]Tab([^;/]+)Build",
                model: "Tab$1",
                device: "tablet"
            },
            {
                regex: "MAJESTIC[ _]Tab([^);/]+)(?:[);/]|$)",
                model: "Tab$1",
                device: "tablet"
            },
            {
                regex: "MAJESTIC[ _]([^;/]+)Build",
                model: "$1"
            },
            {
                regex: "MAJESTIC[ _]([^);/]+)(?:(?:[);/ ]|$)|$)",
                model: "$1"
            },
            {
                regex: "CRONO ?([0-9]+) Build",
                model: "Crono $1"
            },
            {
                regex: "CRONO ?([0-9]+)(?:[);/]|$)",
                model: "Crono $1"
            }
        ]
    },
    "Manta Multimedia": {
        regex: "MSP950(1[245]|2[01])|MSP96017|((?<!/)MID713|MID(?:06[SN]|08[S]?|12|13|14|15|701|702|703|704|705(?:DC)?|706[AS]?|707|708|709|711|712|714|717|781|801|802|901|1001|1002|1003|1004(?: 3G)?|1005|1009|1010|7802|9701|9702))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "((?<!/)MID713|MID(?:06[SN]|08[S]?|12|13|14|15|701|702|703|704|705(?:DC)?|706[AS]?|707|708|709|711|712|714|717|781|801|802|901|1001|1002|1003|1004(?: 3G)?|1005|1009|1010|7802|9701|9702))(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "MSP95012",
                model: "Titano 1"
            },
            {
                regex: "MSP95014",
                model: "Titano 3"
            },
            {
                regex: "MSP95015",
                model: "Mezo 2"
            },
            {
                regex: "MSP95020",
                model: "Rocky 2"
            },
            {
                regex: "MSP95021",
                model: "Rocky 3 Pro"
            },
            {
                regex: "MSP96017",
                model: "Forto 2"
            }
        ]
    },
    Masstel: {
        regex: "Masstel",
        device: "smartphone",
        models: [
            {
                regex: "Masstel[_ ](Juno[_ ]Q3|X9|N4[56]0|N5[2458]0|N536|M05|M1[29]0|M1[125]|M250|M25)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Masstel[_ ]\\((M18)\\)",
                model: "$1"
            },
            {
                regex: "Masstel_Tab7LTE(?:[);/ ]|$)",
                model: "Tab 7 LTE",
                device: "tablet"
            },
            {
                regex: "Masstel Tab (840|700i)(?:[);/ ]|$)",
                model: "Tab $1",
                device: "tablet"
            }
        ]
    },
    Maxwest: {
        regex: "(?:Astro[_ ](?:5N_LTE|X4|5_GO_LTE|X55s)|Virtue Z5|Nitro[_ ](?:4S?|55R|5[XR]|[45] GO|4s LTE)|Gravity_55?_GO|Nitro_Phablet_9s)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Astro_5N_LTE",
                model: "Astro 5N LTE"
            },
            {
                regex: "Astro_5_GO_LTE",
                model: "Astro 5 Go LTE"
            },
            {
                regex: "Virtue Z5",
                model: "Virtue Z5"
            },
            {
                regex: "Astro X55s",
                model: "Astro X55s"
            },
            {
                regex: "Astro[_ ]X4",
                model: "Astro X4"
            },
            {
                regex: "Nitro ([45]) GO",
                model: "Nitro $1 GO"
            },
            {
                regex: "Nitro 4s LTE",
                model: "Nitro 4s LTE"
            },
            {
                regex: "Nitro[ _]4s",
                model: "Nitro 4s"
            },
            {
                regex: "Nitro_(4|55R|5[XR])",
                model: "Nitro $1"
            },
            {
                regex: "Gravity_(55?)_GO",
                model: "Gravity $1 GO"
            },
            {
                regex: "Nitro_Phablet_9s",
                device: "tablet",
                model: "Nitro Phablet 9s"
            }
        ]
    },
    "True Slim": {
        regex: "(SSB-508[ED])(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    "Maze Speed": {
        regex: "(SSB-(?:500|508)|SSB408D|SSB504R)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "SSB-?(500|508|408D|504R)(?:[);/ ]|$)",
                model: "SSB-$1"
            }
        ]
    },
    Maze: {
        regex: "(?:Alpha[_ ]X|Maze Alpha)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Alpha[_ ]X(?:[);/ ]|$)",
                model: "Alpha X"
            },
            {
                regex: "Maze Alpha(?:[);/ ]|$)",
                model: "Alpha"
            }
        ]
    },
    Mediacom: {
        regex: "(?:SmartPad7503G|M-SP10MXA|M-PPAB500|SmartPad970s2(?:3G)?|M[_-][MPS]P[0-9a-z]+|M-IPRO[0-9a-z]+|1AEC)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "SmartPad7503G(?:[);/ ]|$)",
                model: "SmartPad 750 3G"
            },
            {
                regex: "SmartPad970s23G(?:[);/ ]|$)",
                model: "SmartPad 970 S2 3G"
            },
            {
                regex: "SmartPad970s2(?:[);/ ]|$)",
                model: "SmartPad 970 S2"
            },
            {
                regex: "M-MP84[02]M(?:[);/ ]|$)",
                model: 'SmartPad 8.0" Mobile'
            },
            {
                regex: "M-MP940M(?:[);/ ]|$)",
                model: 'SmartPad 9.7" Mobile'
            },
            {
                regex: "M-SP10MXA(?:[);/ ]|$)",
                model: 'SmartPad MX 10.1"'
            },
            {
                regex: "M-SP8MXA(?:[);/ ]|$)",
                model: 'SmartPad MX 8.0"'
            },
            {
                regex: "M-SP7HXAH(?:[);/ ]|$)",
                model: 'SmartPad HX 7.0"'
            },
            {
                regex: "M-SP8HXAH(?:[);/ ]|$)",
                model: 'SmartPad HX 8.0" HD'
            },
            {
                regex: "M-MP(?:710|720|725|726|740)GOx?(?:[);/ ]|$)",
                model: 'SmartPad 7.0" Go'
            },
            {
                regex: "M-MP876S2(?:[);/ ]|$)",
                model: 'SmartPad 8.0" S2'
            },
            {
                regex: "M-MP8S2[AB]?3G(?:[);/ ]|$)",
                model: 'SmartPad 8.0" S2 3G'
            },
            {
                regex: "M-MP(101|102|860|875)S2[BW]?(?:[);/ ]|$)",
                model: "SmartPad $1 S2"
            },
            {
                regex: "M-MP85S23G(?:[);/ ]|$)",
                model: "SmartPad 875 S2 3G"
            },
            {
                regex: "M-SP1AGO3G",
                model: "SmartPad 10 Go 3G"
            },
            {
                regex: "M-SP7xGO3G",
                model: 'SmartPad 10.1" iPro 3G'
            },
            {
                regex: "1AEC",
                model: "SmartPad 10 Eclipse"
            },
            {
                regex: "M-MP10[45][01]S2(?:[);/ ]|$)",
                model: 'SmartPad 10.1" S2'
            },
            {
                regex: "M-MP1S2[AB]3G(?:[);/ ]|$)",
                model: 'SmartPad 10.1" S2 3G'
            },
            {
                regex: "M-MP8[24]S4(?:[);/ ]|$)",
                model: 'SmartPad 8.0" S4'
            },
            {
                regex: "M-MP8S4[AB]3G(?:[);/ ]|$)",
                model: 'SmartPad 8.0" S4 3G'
            },
            {
                regex: "M-MP9S4A3G(?:[);/ ]|$)",
                model: 'SmartPad 9.7" S4 3G'
            },
            {
                regex: "M-MP1[02]S4(?:[);/ ]|$)",
                model: 'SmartPad 10.1" S4'
            },
            {
                regex: "M-MP1040MC?(?:[);/ ]|$)",
                model: 'SmartPad 10.1" HD S4 3G'
            },
            {
                regex: "M-MP1S4[AB]3G(?:[);/ ]|$)",
                model: 'SmartPad 10.1" S4 3G'
            },
            {
                regex: "M-SP10HXxH(?:[);/ ]|$)",
                model: 'SmartPad 10.1" HX HD'
            },
            {
                regex: "M-SP10MXHA(?:[);/ ]|$)",
                model: 'SmartPad 10.1" MX'
            },
            {
                regex: "M-SP10MXHL(?:[);/ ]|$)",
                model: 'SmartPad 10.1" MX Lite'
            },
            {
                regex: "M-MP8PA3G(?:[);/ ]|$)",
                model: 'SmartPad 8.0" HD Pro 3G'
            },
            {
                regex: "M-MP10PA(?:[);/ ]|$)",
                model: 'SmartPad 10.1" HD Pro'
            },
            {
                regex: "M-MP10PA3G(?:[);/ ]|$)",
                model: 'SmartPad 10.1" HD Pro 3G'
            },
            {
                regex: "M-IPRO([18][01]0)[BW](?:[);/ ]|$)",
                model: 'SmartPad 8.0" HD iPro$1 3G'
            },
            {
                regex: "(?:M-MP75S23G|M-MP72[01]M)(?:[);/ ]|$)",
                model: 'SmartPad 7.0" Mobile',
                device: "phablet"
            },
            {
                regex: "M-MP7S2[ABDK]3G(?:[);/ ]|$)",
                model: 'SmartPad 7.0" S2 3G',
                device: "phablet"
            },
            {
                regex: "M-MP5303G(?:[);/ ]|$)",
                model: "SmartPad Mini Mobile",
                device: "phablet"
            },
            {
                regex: "M-PPxB400(?:[);/ ]|$)",
                model: "PhonePad Duo B400",
                device: "phablet"
            },
            {
                regex: "M-PPAG550(?:[);/ ]|$)",
                model: "PhonePad Duo G550",
                device: "phablet"
            },
            {
                regex: "M-PPAB500(?:[);/ ]|$)",
                model: "PhonePad Duo B500",
                device: "phablet"
            },
            {
                regex: "M-PP2G530(?:[);/ ]|$)",
                model: "PhonePad Duo G530",
                device: "phablet"
            },
            {
                regex: "M-PPG700(?:[);/ ]|$)",
                model: "PhonePad Duo G700",
                device: "phablet"
            },
            {
                regex: "M-PPxS531(?:[);/ ]|$)",
                model: "PhonePad Duo S531",
                device: "phablet"
            },
            {
                regex: "M-PP2S550(?:[);/ ]|$)",
                model: "PhonePad Duo S550",
                device: "phablet"
            },
            {
                regex: "M-PP2S650C?(?:[);/ ]|$)",
                model: "PhonePad Duo S650",
                device: "phablet"
            },
            {
                regex: "M-PPxS551U(?:[);/ ]|$)",
                model: "PhonePad Duo S551U",
                device: "phablet"
            },
            {
                regex: "M-PPAG4(?:[);/ ]|$)",
                model: "PhonePad Duo G4",
                device: "smartphone"
            },
            {
                regex: "M-PP[ABC]G500(?:[);/ ]|$)",
                model: "PhonePad Duo G500",
                device: "smartphone"
            },
            {
                regex: "M-PP2S500[BC]?(?:[);/ ]|$)",
                model: "PhonePad Duo S500",
                device: "smartphone"
            },
            {
                regex: "M[_-]PP[Ax]X(470|510|520)U(?:[);/ ]|$)",
                model: "PhonePad Duo X$1U",
                device: "smartphone"
            },
            {
                regex: "M-PPxG(400|501|[457][PM]?)(?:[);/ ]|$)",
                model: "PhonePad Duo G$1",
                device: "smartphone"
            },
            {
                regex: "M-PPxS(532[LU]|470|501|5P?|7P?)(?:[);/ ]|$)",
                model: "PhonePad Duo S$1",
                device: "smartphone"
            },
            {
                regex: "M-PPxG(450)(?:[);/ ]|$)",
                model: "PhonePad Duo G$1",
                device: "smartphone"
            },
            {
                regex: "M-MP([0-9a-z]+)",
                model: "SmartPad $1"
            }
        ]
    },
    Medion: {
        regex: "Medion|(?:MD_)?LIFETAB|([SPX]10[0-9]{2}X|E10[45]1X|X5001|P851X|P850X|E691X|E1050X)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:MD_)?LIFETAB_([a-z0-9]+)",
                device: "tablet",
                model: "Lifetab $1"
            },
            {
                regex: "(E450[46]|E5004|S5004|X5001|E5020|P5015)(?:[);/ ]|$)",
                model: "Life $1"
            },
            {
                regex: "(B5530)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(E10[45]1X)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "([SPX]10[0-9]{2}X|P851X|P850X|E691X|E1050X)(?:[);/ ]|$)",
                model: "Lifetab $1",
                device: "tablet"
            },
            {
                regex: "Medion(?: Smartphone)? ([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    MEEG: {
        regex: "MEEG[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "MEEG[ _\\-]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "MEEG[ _\\-]?([^);/ ]+)",
                model: "$1"
            }
        ]
    },
    Fourel: {
        regex: "(?:EASYSMARTM3|EasySmart M2)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "EASY ?SMART ?M([32])",
                model: "Easy Smart M$1"
            }
        ]
    },
    Meizu: {
        regex: "Meizu|MZ-[a-z]|(?<!POCO )(M04[05]|MZ-16th(?: Plus)?|MZ-16[st]|M7[12]1C|M35[1356]|M612C|M578CA|M181[36]|M1822|M681C|M6T|MX[ -]?[2345](?: Pro)?|(?:MZ-)?m[1-6] note|M621C|M1852|M57[18]C|M3[ESX]|M031|m1 metal|M1 E|M2|M2 E|M5s Build|PRO [67]|PRO 7-[HS]| 15 Lite| 16th|MZ-15 (?:Lite|Plus)|MZ-16 X)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:MZ-)?M571C",
                device: "phablet",
                model: "M2 Note"
            },
            {
                regex: "(?:MZ-|Meizu-)?m([1-6])[_ ]note(?:[);/ ]|$)",
                device: "phablet",
                model: "M$1 Note"
            },
            {
                regex: "M1 E(?:[);/ ]|$)",
                model: "M1E"
            },
            {
                regex: "M2 E(?:[);/ ]|$)",
                model: "M2E"
            },
            {
                regex: "(?:MZ-)?M578C[A]?|M2(?:[);/ ]|$)",
                model: "M2"
            },
            {
                regex: "M681C(?:[);/ ]|$)",
                model: "M3 Note",
                device: "phablet"
            },
            {
                regex: "M621C(?:[);/ ]|$)",
                model: "M5 Note",
                device: "phablet"
            },
            {
                regex: "M711C(?:[);/ ]|$)",
                model: "M6"
            },
            {
                regex: "M721C(?:[);/ ]|$)",
                model: "M6 Note",
                device: "phablet"
            },
            {
                regex: "M6T",
                model: "M6T"
            },
            {
                regex: "M3E",
                model: "M3E"
            },
            {
                regex: "M3S",
                model: "M3S"
            },
            {
                regex: "M3X",
                model: "M3X"
            },
            {
                regex: "M5S|M612C",
                model: "M5S"
            },
            {
                regex: "(M04[05]|MX[ -]?2)(?:[);/ ]|$)",
                model: "MX2"
            },
            {
                regex: "(M35[1356]|MX[ -]?3)(?:[);/ ]|$)",
                model: "MX3"
            },
            {
                regex: "MX[ -]?4 Pro(?:[);/ ]|$)",
                model: "MX4 Pro"
            },
            {
                regex: "MX[ -]?4(?:[);/ ]|$)",
                model: "MX4"
            },
            {
                regex: "(Meizu[- _])?MX[ -]?5(?:[);/ ]|$)",
                model: "MX5"
            },
            {
                regex: "m1 metal",
                model: "M1 Metal"
            },
            {
                regex: "M1813(?:[);/ ]|$)",
                model: "M8"
            },
            {
                regex: "M1816(?:[);/ ]|$)",
                model: "M8 Lite"
            },
            {
                regex: "PRO 7-[HS](?:[);/ ]|$)",
                model: "PRO 7"
            },
            {
                regex: "PRO 7 Plus(?:[);/ ]|$)",
                model: "Pro 7 Plus"
            },
            {
                regex: "PRO ([67])",
                model: "PRO $1"
            },
            {
                regex: "M031(?:[);/ ]|$)",
                model: "MX Dual Core"
            },
            {
                regex: "M1852(?:[);/ ]|$)",
                model: "X8"
            },
            {
                regex: "M1822(?:[);/ ]|$)",
                model: "Note 8"
            },
            {
                regex: "MZ-16T(?:[);/ ]|$)",
                model: "16T"
            },
            {
                regex: "(?:MZ-)?16th Plus(?:[);/ ]|$)",
                model: "16th Plus"
            },
            {
                regex: "MZ-15 Plus(?:[);/ ]|$)",
                model: "15 Plus"
            },
            {
                regex: "(?:MZ-15 Lite| 15 Lite)(?:[);/ ]|$)",
                model: "15 Lite"
            },
            {
                regex: "MZ-16th| 16th(?:[);/ ]|$)",
                model: "16th"
            },
            {
                regex: "MZ-16 X(?:[);/ ]|$)",
                model: "16X"
            },
            {
                regex: "Meizu[_ ]note([89])(?:[);/ ]|$)",
                device: "phablet",
                model: "Note $1"
            },
            {
                regex: "(?:MZ-)?Meizu[_ ]([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "(?:MZ-)?Meizu[_ ]([a-z0-9_]+)",
                model: "$1"
            },
            {
                regex: "MZ-([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    Meitu: {
        regex: "(?:(?<!MI CC 9 )Meitu[2]?|MP1503|MP1512|MP160[235]|MP170[19]|MP171[138])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "MP1503(?:[);/ ]|$)",
                model: "M6"
            },
            {
                regex: "MP1512(?:[);/ ]|$)",
                model: "M6s"
            },
            {
                regex: "MP1602(?:[);/ ]|$)",
                model: "T8"
            },
            {
                regex: "MP1605(?:[);/ ]|$)",
                model: "V6"
            },
            {
                regex: "MP17(?:01|13)(?:[);/ ]|$)",
                model: "T8s"
            },
            {
                regex: "MP1718(?:[);/ ]|$)",
                model: "T9"
            },
            {
                regex: "MP1603(?:[);/ ]|$)",
                model: "M8"
            },
            {
                regex: "MP17(?:09|11)(?:[);/ ]|$)",
                model: "M8s"
            },
            {
                regex: "Meitu2(?:[);/ ]|$)",
                model: "2"
            },
            {
                regex: "Meitu (Kiss|[MV]4)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Memup: {
        regex: "SlidePad ?([^;/]*) Build|SPNG?[0-9]{2,4}[a-z]{0,2}(?:[);/ ]|$)|SP704CE?|SP-NG708-3G",
        device: "tablet",
        models: [
            {
                regex: "SlidePad ?([^;/]*) Build",
                model: "SlidePad $1"
            },
            {
                regex: "SPNG([0-9]{2,4}[a-z]{0,2})(?:[);/ ]|$)",
                model: "SlidePad NG$1"
            },
            {
                regex: "SP-NG(708)-3G(?:[);/ ]|$)",
                model: "SlidePad NG$1 3G"
            },
            {
                regex: "SP704(CE?)",
                model: "SlidePad 704$1"
            }
        ]
    },
    Mecer: {
        regex: "(M785|800P3[12]C|101P51C|X1010)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "M785(?:[);/ ]|$)",
                model: "Xpress Smartlife M785"
            },
            {
                regex: "X1010(?:[);/ ]|$)",
                model: "X1010"
            },
            {
                regex: "800P31C(?:[);/ ]|$)",
                model: "Xpress Smartlife 800P31C"
            },
            {
                regex: "800P32C(?:[);/ ]|$)",
                model: "Xpress Smartlife 800P32C"
            },
            {
                regex: "101P51C(?:[);/ ]|$)",
                model: "Xpress Smartlife 101P51C"
            }
        ]
    },
    Mio: {
        regex: "MIO(?:/)?([a-z0-9]+)|(?:MOBIX M6|Mio TouchPad 7 Quad Core)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "MOBIX M6(?:[);/ ]|$)",
                model: "Mobix M6"
            },
            {
                regex: "MIO(?:/)?([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "Mio TouchPad 7 Quad Core",
                device: "tablet",
                model: "TouchPad 7 Quad Core"
            }
        ]
    },
    Miray: {
        regex: "MIDM[_-]|MPM[_-]",
        device: "smartphone",
        models: [
            {
                regex: "MIDM[_-]([a-z0-9]+)",
                model: "MIDM $1",
                device: "tablet"
            },
            {
                regex: "MPM[_-]([a-z0-9]+)",
                model: "MPM $1"
            }
        ]
    },
    Mitsubishi: {
        regex: "MITSU|portalmmm/[12]\\.0 M",
        device: "feature phone",
        models: [
            {
                regex: "MITSU/[a-z0-9.]+ \\(([a-z0-9]+)\\)",
                model: "$1"
            },
            {
                regex: "MITSU[ \\-]?([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "portalmmm/[12]\\.0 (M[a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    MIXC: {
        regex: "(M35|M20|G7106|G7108)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(M[0-9]{1,2})(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(G[0-9]{4})(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Mobiola: {
        regex: "(MS5[50]X6|MS55X5|MS55L1|MS50L1|MS43A3000|MS45A4000|MS50A4000|MS50A4500|MS50A5000|MS50A6000|MS50B11000|MB-2900 QUATTRO|POLYS[_ ]MS45L1|Wave5)",
        device: "smartphone",
        models: [
            {
                regex: "MS50X6",
                model: "Atmos II"
            },
            {
                regex: "POLYS[_ ]MS45L1",
                model: "Polys MS45L1"
            },
            {
                regex: "MS55X6",
                model: "Atmos Pro II"
            },
            {
                regex: "MS55X5",
                model: "Atmos Pro"
            },
            {
                regex: "MS55L1",
                model: "GAIA"
            },
            {
                regex: "MS50L1",
                model: "Inti"
            },
            {
                regex: "MB-2900 QUATTRO",
                model: "MB-2900 Quattro"
            },
            {
                regex: "MS43A3000",
                model: "MS43A3000"
            },
            {
                regex: "MS45A4000",
                model: "eOn 45"
            },
            {
                regex: "MS50A4000",
                model: "eOn 50"
            },
            {
                regex: "MS50A4500",
                model: "eOn 50 Elegance"
            },
            {
                regex: "MS50A5000",
                model: "eOn 50 Quad 8"
            },
            {
                regex: "MS50A6000",
                model: "eOn 50 Quad 16"
            },
            {
                regex: "MS50B11000",
                model: "MS50B11000"
            },
            {
                regex: "Wave5",
                model: "Wave 5"
            }
        ]
    },
    Mobicel: {
        regex: "Mobicel_(R1)|(?:HYPE|DANDY(?:_ZAM)?|(?<!SMADL )Matrix|TRENDY PLUS|FENDY_DS|TANGO_LITE|BLINK|BERRY[_ ]?(?:[12]|PLUS))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Matrix",
                model: "Matrix"
            },
            {
                regex: "BLINK",
                model: "Blink"
            },
            {
                regex: "BERRY1",
                model: "Berry 1"
            },
            {
                regex: "BERRY 2",
                model: "Berry 2"
            },
            {
                regex: "BERRY[_ ]PLUS",
                model: "Berry Plus"
            },
            {
                regex: "TRENDY PLUS",
                model: "Trendy Plus"
            },
            {
                regex: "HYPE",
                model: "Hype"
            },
            {
                regex: "DANDY_ZAM",
                model: "Dandy Zam"
            },
            {
                regex: "DANDY",
                model: "Dandy"
            },
            {
                regex: "TANGO_LITE",
                model: "Tango Lite"
            },
            {
                regex: "FENDY_DS",
                model: "Fendy DS"
            },
            {
                regex: "Mobicel_(R1)",
                model: "$1"
            }
        ]
    },
    Mobiistar: {
        regex: "Mobiistar|Zumbo[ _]S|PRIME X MAX|X1 Notch|E1 Selfie",
        device: "smartphone",
        models: [
            {
                regex: "X1 Notch(?:[);/ ]|$)",
                model: "X1 Notch"
            },
            {
                regex: "E1 Selfie(?:[);/ ]|$)",
                model: "E1 Selfie"
            },
            {
                regex: "mobiistar_LAI_Zumbo(?:[);/ ]|$)",
                model: "Zumbo"
            },
            {
                regex: "Zumbo[_ ]S[_ ]2017[_ ]Lite(?:[);/ ]|$)",
                model: "Lai Zumbo S Lite (2017)"
            },
            {
                regex: "Zumbo[_ ]S[_ ]2017(?:[);/ ]|$)",
                model: "Lai Zumbo S (2017)"
            },
            {
                regex: "mobiistar ZUMBO S2( Dual)",
                model: "Zumbo S2"
            },
            {
                regex: "Mobiistar_LAI_Zumbo_J_2017(?:[);/ ]|$)",
                model: "Lai Zumbo J (2017)"
            },
            {
                regex: "Mobiistar_LAI_Zumbo_J(?:[);/ ]|$)",
                model: "Lai Zumbo J"
            },
            {
                regex: "Mobiistar_Zumbo_J2",
                model: "Lai Zumbo J2"
            },
            {
                regex: "Mobiistar[_ ]Zumbo[_ ]S2",
                model: "Zumbo S2"
            },
            {
                regex: "mobiistar ZUMBO Power",
                model: "Zumbo Power"
            },
            {
                regex: "mobiistar[ _]LAI[ _]YUNA[ _]([1XCS])",
                model: "Lai Yuna $1"
            },
            {
                regex: "mobiistar LAI Yuki",
                model: "Lai Yuki"
            },
            {
                regex: "mobiistar[ _]LAI[ _]ZORO[ _]([23])",
                model: "Lai Zoro $1"
            },
            {
                regex: "mobiistar[ _]LAI[ _]Zena",
                model: "Lai Zena"
            },
            {
                regex: "mobiistar[ _]LAI[ _]Z([12])?",
                model: "Lai Z$1"
            },
            {
                regex: "mobiistar_ZORO_4G",
                model: "Zoro 4G"
            },
            {
                regex: "mobiistar touch LAI 512",
                model: "Touch Lai 512"
            },
            {
                regex: "mobiistar LAI 504([KC])",
                model: "Lai 504$1"
            },
            {
                regex: "mobiistar LAI Y",
                model: "Lai Y"
            },
            {
                regex: "mobiistar PRIME X 2017",
                model: "Prime X"
            },
            {
                regex: "mobiistar[ _]PRIME[ _](X1|558|X[ _]Plus|X[ _]Grand) Build",
                model: "Prime $1"
            },
            {
                regex: "PRIME X MAX 2018",
                model: "Prime X Max"
            },
            {
                regex: "mobiistar[ _]KOOL([ _]Lite)?",
                model: "Kool$1"
            },
            {
                regex: "mobiistar KAT 452 Build",
                model: "Kat 452"
            },
            {
                regex: "mobiistar_LAI_YOLLO Build",
                model: "Lai Yollo"
            },
            {
                regex: "Mobiistar[ _]([^;/)]+)(?: Build|[;)])",
                model: "$1"
            }
        ]
    },
    MSI: {
        regex: "Primo ?(?:9[13]|81|76)|Enjoy 7 Plus",
        device: "tablet",
        models: [
            {
                regex: "Primo ?(9[13]|76|81)",
                model: "Primo $1"
            },
            {
                regex: "Enjoy 7 Plus",
                model: "Enjoy 7 Plus"
            }
        ]
    },
    MLLED: {
        regex: "MLLED[ _]",
        device: "smartphone",
        models: [
            {
                regex: "MLLED[ _]([^;/]+)Build",
                model: "$1"
            },
            {
                regex: "MLLED[ _]([^);/]+)(?:[);/]|$)",
                model: "$1"
            }
        ]
    },
    Mobistel: {
        regex: "(Cynus[ _][^/;)]+)( Build|\\))",
        device: "smartphone",
        model: "$1"
    },
    Mecool: {
        regex: "(?:KM9PRO|BB2 PRO|K[I]{1,3} PRO|KI PLUS|KM9_TV_BOX|M8SPROW|M8S (?:PLUS|PRO) (?:DVB|[LW]|PLUS)|M8S (?:MAX|PRO))(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "KM9PRO(?:[);/ ]|$)",
                model: "KM9 Pro"
            },
            {
                regex: "KM9_TV_BOX(?:[);/ ]|$)",
                model: "KM9 TV Box"
            },
            {
                regex: "BB2 PRO(?:[);/ ]|$)",
                model: "BB2 Pro"
            },
            {
                regex: "(K[I]{1,3}) PRO(?:[);/ ]|$)",
                model: "$1 Pro"
            },
            {
                regex: "KI PLUS(?:[);/ ]|$)",
                model: "KI Plus"
            },
            {
                regex: "M8SPROW(?:[);/ ]|$)",
                model: "M8S Pro W"
            },
            {
                regex: "M8S PLUS DVB(?:[);/ ]|$)",
                model: "M8S Plus DVB"
            },
            {
                regex: "M8S PLUS ([LW])(?:[);/ ]|$)",
                model: "M8S Plus $1"
            },
            {
                regex: "M8S PRO ([LW])(?:[);/ ]|$)",
                model: "M8S Pro $1"
            },
            {
                regex: "M8S PRO PLUS(?:[);/ ]|$)",
                model: "M8S Pro Plus"
            },
            {
                regex: "M8S PRO(?:[);/ ]|$)",
                model: "M8S Pro"
            },
            {
                regex: "M8S MAX(?:[);/ ]|$)",
                model: "M8S Max"
            }
        ]
    },
    Modecom: {
        regex: "Modecom|Free(?:Way )?Tab|xino z[\\d]+ x[\\d]+",
        device: "tablet",
        models: [
            {
                regex: "xino Z([\\d]+) X([\\d]+)",
                model: "Xino Z$1 X$2",
                device: "smartphone"
            },
            {
                regex: "FreeTab[ _\\-]?([^/;]+)? Build",
                model: "FreeTab $1"
            },
            {
                regex: "FreeTab[ _\\-]?((?!Build)[^);/ ]+)?",
                model: "FreeTab $1"
            },
            {
                regex: "FreeWay Tab[ _\\-]?([^/;]+) Build",
                model: "FreeWay Tab $1"
            },
            {
                regex: "FreeWay Tab[ _\\-]?((?!Build)[^);/ ]+)",
                model: "FreeWay Tab $1"
            }
        ]
    },
    Mofut: {
        regex: "Mofut",
        device: "smartphone",
        models: [
            {
                regex: "Mofut[ _\\-]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "Mofut[ _\\-]?((?!Build)[^);/ ]+)",
                model: "$1"
            }
        ]
    },
    BrightSign: {
        regex: "BrightSign",
        device: "tv",
        models: [
            {
                regex: "(HD1023|XD233|XD230|XD1030|XT114[34]|4K1142|LS424)",
                model: "$1"
            }
        ]
    },
    Motorola: {
        regex: "MOT(?!TO)|(?<!AN)DROID ?(?:Build|[a-z0-9]+)|portalmmm/2.0 (?:E378i|L6|L7|v3)|XOOM [^;/]*Build|XT1941-2|XT1924-9|XT1925-10|XT1965-6|XT1970-5|XT1799-2|XT1021|XT1710-08|XT180[3-5]|XT194[23]-1|XT1929-15|(?:XT|MZ|MB|ME)[0-9]{3,4}[a-z]?(?:\\(Defy\\)|-0[1-5])?(?:[;]? Build|\\))",
        device: "smartphone",
        models: [
            {
                regex: "MOT-V360",
                model: "V360",
                device: "feature phone"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT300",
                model: "Spice"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT30[35]",
                model: "Motosmart ME"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT31[16]",
                model: "Fire"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT32[01]",
                model: "Defy Mini"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT3(?:89|90)",
                model: "Motosmart"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT502",
                model: "Quench"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT531",
                model: "Fire XT"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT535",
                model: "Defy"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT55[567]C?",
                model: "Defy XT"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT603",
                model: "Admiral"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT610",
                model: "Droid Pro"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT615",
                model: "Motoluxe"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT621",
                model: "Primus"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT626",
                model: "IronRock"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT682",
                model: "Atrix"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT685",
                model: "Motoluxe Dual-SIM"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT687",
                model: "Atrix TV"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT720",
                model: "Milestone"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT800W",
                model: "Glam"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT860",
                model: "Milestone 3"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT881",
                model: "Electrify 2"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT882",
                model: "Moto XT882"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT88[56]",
                model: "Droid RAZR V"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT890",
                model: "Droid RAZR i"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT894",
                model: "Droid 4"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT897",
                model: "Photon Q"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT901",
                model: "Electrify M"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT90[567]",
                model: "Droid RAZR M"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT910S?",
                model: "Droid RAZR"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT91[4568]",
                model: "Droid RAZR D1"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT9(?:19|20)",
                model: "Droid RAZR D3"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT925",
                model: "Droid RAZR HD"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT102[12]",
                model: "Moto E"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1706",
                model: "Moto E3 Power"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1924-9|moto e5 plus",
                model: "Moto E5 Plus"
            },
            {
                regex: "Moto E5 Play",
                model: "Moto E5 Play"
            },
            {
                regex: "Moto E5 go(?:[);/ ]|$)",
                model: "Moto E5 Go"
            },
            {
                regex: "Moto E6(?:[);/ ]|$)",
                model: "Moto E6"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1030",
                model: "Droid Mini"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1096",
                model: "Moto X2"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1254",
                model: "Droid Turbo"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT10(?:28|3[1234]|68|69)",
                model: "Moto G"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1799-2",
                model: "Moto G5s"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT180[3-5]",
                model: "Moto G5s Plus"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT168[57]",
                model: "Moto G5 Plus"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1670",
                model: "Moto G5"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1925-10",
                model: "Moto G6"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1965-6",
                model: "Moto G7 Plus"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT10(?:49|5[23568]|60|9[23457])",
                model: "Moto X"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1562",
                model: "Moto X Play"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1572",
                model: "Moto X Style"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1080",
                model: "Droid Ultra"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1650-05",
                model: "Moto Z"
            },
            {
                regex: "moto z4(?:[);/ ]|$)",
                model: "Moto Z4"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1635(?:-0[1-3])?",
                model: "Moto Z Play"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1710-(?:-0[28])?",
                model: "Moto Z2 Play"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1789-05",
                model: "Moto Z2 Force"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1929-15",
                model: "Moto Z3"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1663",
                model: "Moto M"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1943-1",
                model: "P30"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1941-2",
                model: "P30 Play"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1942-1",
                model: "P30 Note"
            },
            {
                regex: "(?:MOT-|Motorola-)?XT1970-5",
                model: "One Vision"
            },
            {
                regex: "(?:MOT-|Motorola-)?one zoom",
                model: "One Zoom"
            },
            {
                regex: "motorola one action",
                model: "One Action"
            },
            {
                regex: "motorola one macro",
                model: "One Macro"
            },
            {
                regex: "motorola one 5G UW",
                model: "One 5G UW"
            },
            {
                regex: "moto g power",
                model: "Moto G Power"
            },
            {
                regex: "moto g\\(([0-9])\\) power lite",
                model: "Moto G$1 Power Lite"
            },
            {
                regex: "moto g\\(([0-9])\\) power",
                model: "Moto G$1 Power"
            },
            {
                regex: "moto g\\(([0-9])\\) supra",
                model: "Moto G$1 Supra"
            },
            {
                regex: "moto g\\(([0-9])\\) plus",
                model: "Moto G$1 Plus"
            },
            {
                regex: "moto g\\(([0-9]+)\\) play",
                model: "Moto G$1 Play"
            },
            {
                regex: "moto g\\(([0-9]+)\\)",
                model: "Moto G$1"
            },
            {
                regex: "Moto ([CGEXZ]) ?\\(([a-z0-9]+)\\)( Plus| Play)?",
                model: "Moto $1$2$3"
            },
            {
                regex: "Moto ?([CGEXZ])([0-9]+)( Plus| Play)?",
                model: "Moto $1$2$3"
            },
            {
                regex: "(?:Motorola-)?Moto[ _]?([CGEXZ])([ _](?:Plus|Play))?",
                model: "Moto $1$2"
            },
            {
                regex: "MotoroiX",
                model: "MotoroiX"
            },
            {
                regex: "Motorola[ _\\-]([^/;]+)(?: Build|[);])",
                model: "$1"
            },
            {
                regex: "MOTORAZR[ _\\-]([a-z0-9]+)",
                model: "RAZR $1"
            },
            {
                regex: "MOTORIZR[ _\\-]([a-z0-9]+)",
                model: "RIZR $1"
            },
            {
                regex: "MOT(?!OROLA)[O]?[_\\-]?([a-z0-9.]+)",
                model: "$1"
            },
            {
                regex: "(?<!AN)DROID ?([a-z0-9 ]*) Build",
                model: "DROID $1"
            },
            {
                regex: "(?<!AN)DROID ?([a-z0-9]+)",
                model: "DROID $1"
            },
            {
                regex: "portalmmm/2.0 ((?:E378i|L6|L7|V3)[a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(XOOM [^;/]*)Build",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "(MZ[0-9]{3})(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "((?:ME|MB|XT)[0-9]{3,4}(?:\\(Defy\\))?)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Movic: {
        regex: "MOVIC",
        device: "smartphone",
        models: [
            {
                regex: "MOVIC[ -]W([2345])",
                model: "W$1"
            }
        ]
    },
    MTN: {
        regex: "MTN-",
        device: "smartphone",
        models: [
            {
                regex: "MTN-(L860|S620)",
                model: "Sm@rt Mini $1"
            },
            {
                regex: "MTN-8978P",
                device: "tablet",
                model: "Steppa"
            },
            {
                regex: "MTN-([a-z0-9_\\-]+)",
                model: "MTN-$1"
            }
        ]
    },
    MyTab: {
        regex: "MyTAB[ _-](?:8 MINI Dual Core|U55GT)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "MyTAB[ _-]8 MINI Dual Core(?:[);/ ]|$)",
                model: "8 Mini Dual Core"
            },
            {
                regex: "MyTAB-U55GT(?:[);/ ]|$)",
                model: "U55GT"
            }
        ]
    },
    MyPhone: {
        regex: "(?:MyPhone|MyPad|MyTab)[ _][^;/)]+( Build|\\))|Cube_LTE|myTab10II|HAMMER[ _](Blade2_PRO|IRON_3|Explorer|ENERGY|Titan 2|AXE[_ ](?:M[_ ]LTE|Pro)|Iron 2|Active[2]?(_LTE)?)|C-Smart_pix|myPhone_Fun_8|FUN_18x9|MyPhoneMY27|Prime_4_Lite|myA17|myX12|Pocket_2|Prime_18x9|Prime3Lite|myT6 DTV|myXI1 (?:Plus|Pro)|myXI3|Q_Smart_BE",
        device: "smartphone",
        models: [
            {
                regex: "MyPad[ _]([^;/]+) Build",
                model: "MyPad $1",
                device: "tablet"
            },
            {
                regex: "MyTab[ _]([^;/]+) Build",
                model: "MyTab $1",
                device: "tablet"
            },
            {
                regex: "myTab_10III",
                model: "MyTab 10 III",
                device: "tablet"
            },
            {
                regex: "myTab10II",
                model: "MyTab 10 II",
                device: "tablet"
            },
            {
                regex: "myT6 DTV",
                model: "myT6 DTV",
                device: "tablet"
            },
            {
                regex: "Cube_LTE",
                model: "Cube LTE"
            },
            {
                regex: "Prime_4_Lite",
                model: "Prime 4 Lite"
            },
            {
                regex: "HAMMER[ _]ENERGY",
                model: "Hammer Energy"
            },
            {
                regex: "HAMMER_AXE[_ ]M[_ ]LTE",
                model: "Hammer Axe M LTE"
            },
            {
                regex: "Hammer Titan 2",
                model: "Hammer Titan 2"
            },
            {
                regex: "Hammer[ _]Iron[ _](2|3)",
                model: "Hammer Iron $1"
            },
            {
                regex: "Hammer[ _]Explorer",
                model: "Hammer Explorer"
            },
            {
                regex: "Hammer Active(?:[);/ ]|$)",
                model: "Hammer Active"
            },
            {
                regex: "Hammer_Active2(?:[);/ ]|$)",
                model: "Hammer Active 2"
            },
            {
                regex: "Hammer_Active2_LTE(?:[);/ ]|$)",
                model: "Hammer Active 2 LTE"
            },
            {
                regex: "Hammer AXE Pro",
                model: "Hammer Axe Pro"
            },
            {
                regex: "Hammer_Blade2_PRO",
                model: "Hammer Blade 2 Pro"
            },
            {
                regex: "C-Smart_pix",
                model: "C-Smart Pix"
            },
            {
                regex: "Pocket_2(?:[);/ ]|$)",
                model: "Pocket 2"
            },
            {
                regex: "myA17(?:[);/ ]|$)",
                model: "myA17"
            },
            {
                regex: "(?:myPhone_)?Fun_(8|18x9)",
                model: "FUN $1"
            },
            {
                regex: "MyPhoneMY27",
                model: "my27"
            },
            {
                regex: "myX12(?:[);/ ]|$)",
                model: "myX12"
            },
            {
                regex: "myXI1 Plus(?:[);/ ]|$)",
                model: "myXI1 Plus"
            },
            {
                regex: "myXI1 Pro(?:[);/ ]|$)",
                model: "myXI1 Pro"
            },
            {
                regex: "myXI3(?:[);/ ]|$)",
                model: "myXI3"
            },
            {
                regex: "Q_Smart_BE(?:[);/ ]|$)",
                model: "Q-Smart BE"
            },
            {
                regex: "Prime_18x9(_LTE)?(?:[);/ ]|$)",
                model: "Prime 18x9$1"
            },
            {
                regex: "Prime3Lite(?:[);/ ]|$)",
                model: "Prime 3 Lite"
            },
            {
                regex: "MyPhone[ _]([^;/)]+)( Build|\\))",
                model: "$1"
            }
        ]
    },
    MyWigo: {
        regex: "MyWigo ",
        device: "smartphone",
        models: [
            {
                regex: "City3",
                model: "City 3"
            }
        ]
    },
    Myros: {
        regex: "(E70 Ultra)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Myria: {
        regex: " (Myria_[^/;]+|502M|Cozy|Easy tab 9|Grand) Build|Myria_FIVE|Myria_Grand_4G|Myria_Wide_2|Myria_Wide_4G",
        device: "smartphone",
        models: [
            {
                regex: "Myria_([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "Myria_FIVE",
                model: "Five"
            },
            {
                regex: "(502M|Grand)",
                model: "$1"
            },
            {
                regex: "Myria_Grand_4G",
                model: "Grand 4G"
            },
            {
                regex: "Myria_Wide_4G",
                model: "Wide 4G"
            },
            {
                regex: "Myria_Wide_2",
                model: "Wide 2"
            },
            {
                regex: "(Cozy|Easy tab 9)",
                model: "$1",
                device: "tablet"
            }
        ]
    },
    "M.T.T.": {
        regex: "M.T.T.",
        device: "smartphone",
        models: [
            {
                regex: "M.T.T. ?Tablet([^;/]+)? Build",
                device: "tablet",
                model: "Tablet$1"
            },
            {
                regex: "M.T.T. ?([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    Navon: {
        regex: "Navon[_ ]|(?:Vision_Tab_(?:7|10)|Superme_Max|Predator (?:10|3G)|Platinum[_ ]10[_ ]3G(?:_V2)?|Supreme[_ ](?:Fine(?:[_ ]Micro)?|Chief|Pure|Pro)(?:[_ ](?:Mini|Plus))?)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "M505 LTE(?:[);/ ]|$)",
                model: "Mizu M505 LTE"
            },
            {
                regex: "(F552|D504)(?:[);/ ]|$)",
                model: "Mizu $1"
            },
            {
                regex: "Superme_Max(?:[);/ ]|$)",
                model: "Supreme Max"
            },
            {
                regex: "Supreme_Fine_Mini(?:[);/ ]|$)",
                model: "Supreme Fine Mini"
            },
            {
                regex: "Supreme_Fine_Micro(?:[);/ ]|$)",
                model: "Supreme Fine Micro"
            },
            {
                regex: "Supreme[_ ]Fine[_ ]Plus(?:[);/ ]|$)",
                model: "Supreme Fine Plus"
            },
            {
                regex: "Supreme_Fine(?:[);/ ]|$)",
                model: "Supreme Fine"
            },
            {
                regex: "Supreme[_ ]Chief(?:[);/ ]|$)",
                model: "Supreme Chief"
            },
            {
                regex: "Supreme[_ ]Pure[ _]Plus(?:[);/ ]|$)",
                model: "Supreme Pure Plus"
            },
            {
                regex: "Supreme Pure(?:[);/ ]|$)",
                model: "Supreme Pure"
            },
            {
                regex: "Supreme[_ ]Pro(?:[);/ ]|$)",
                model: "Supreme Pro"
            },
            {
                regex: "Navon[_ ]Infinity(?:[);/ ]|$)",
                model: "Infinity"
            },
            {
                regex: "(?:Navon[_ ])?Platinum[ _]10[ _]3G(_V2)?(?:[);/ ]|$)",
                device: "tablet",
                model: 'Platinum 10.1" 3G$1'
            },
            {
                regex: "(?:Navon[_ ])?Orpheus[ _]3G(?:[);/ ]|$)",
                device: "tablet",
                model: "Orpheus 3G"
            },
            {
                regex: "Predator (3G|10)(?:[);/ ]|$)",
                device: "tablet",
                model: "Predator $1"
            },
            {
                regex: "Vision_Tab_(7|10)(?:[);/ ]|$)",
                device: "tablet",
                model: "Vision Tab $1"
            }
        ]
    },
    NOA: {
        regex: "(?:NOA-)?NOA[ _]|Hummer(?:_2019_R|LE)|NextSE",
        device: "smartphone",
        models: [
            {
                regex: "NOA[_ ]CORE[_ ]FORTE",
                model: "Core Forte"
            },
            {
                regex: "HummerLE",
                model: "Hummer LE"
            },
            {
                regex: "Hummer_2019_R",
                model: "Hummer R (2019)"
            },
            {
                regex: "NOA[_ ]Hummer[_ ]Lite",
                model: "Hummer Lite"
            },
            {
                regex: "NOA[_ ]MOVEse",
                model: "Move SE"
            },
            {
                regex: "NextSE",
                model: "Next SE"
            },
            {
                regex: "NOA[_ ]NEXT",
                model: "Next"
            },
            {
                regex: "NOA[_ ]VISION[_ ]H3SE",
                model: "Vision H3SE"
            },
            {
                regex: "NOA[_ ]VISION[_ ]H3",
                model: "Vision H3"
            },
            {
                regex: "NOA[_ ]LOOP",
                model: "Loop"
            },
            {
                regex: "(?:NOA-)?NOA[_ ]H4se",
                model: "H4SE"
            },
            {
                regex: "NOA[_ ]Mg12",
                model: "MG12"
            },
            {
                regex: "NOA[_ ]H44SE",
                model: "H44SE"
            },
            {
                regex: "NOA[_ ]H10LE",
                model: "H10LE"
            },
            {
                regex: "NOA[_ ]([^;)/ ]+)",
                model: "$1"
            }
        ]
    },
    Nobby: {
        regex: "Nobby[ ](S500|X800|S300(?: Pro)?)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    NEC: {
        regex: "NEC[ _\\-]|KGT/2\\.0|PC-TE508(?:S1|[BH]AW)|PC-TE510(?:HAW|BAL|S1)|PC-TS708T1W|PC-TS507N1S|PC-TE507JAW|portalmmm/1\\.0 (?:DB|N)|(?:portalmmm|o2imode)/2.0[ ,]N|(?:N-06C|N-02E|LAVIE Tab E (?:10|8)FHD1)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "N-06C(?:[);/ ]|$)",
                model: "Medias Amadana"
            },
            {
                regex: "N-02E(?:[);/ ]|$)",
                model: "Medias U"
            },
            {
                regex: "(?:NEC[ _\\-]|KGT/2\\.0 )([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "portalmmm/1\\.0 ((?:DB|N)[a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(?:portalmmm|o2imode)/2\\.0[ ,](N[a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "PC-TE508[BH]AW(?:[);/ ]|$)",
                device: "tablet",
                model: "LAVIE Tab E TE508"
            },
            {
                regex: "PC-TE510(?:BAL|HAW|S1)(?:[);/ ]|$)",
                device: "tablet",
                model: "LAVIE Tab E TE510"
            },
            {
                regex: "PC-TS507N1S(?:[);/ ]|$)",
                device: "tablet",
                model: "LAVIE Tab S TS507"
            },
            {
                regex: "PC-TS708T1W(?:[);/ ]|$)",
                device: "tablet",
                model: "LAVIE Tab S TS708"
            },
            {
                regex: "PC-TE507JAW(?:[);/ ]|$)",
                device: "tablet",
                model: "LAVIE Tab E TS507"
            },
            {
                regex: "PC-TE508S1(?:[);/ ]|$)",
                device: "tablet",
                model: "LAVIE Tab E TE508"
            },
            {
                regex: "(LAVIE Tab E (?:10|8)FHD1)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    Neffos: {
        regex: "Neffos|(TP601A)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "TP601A(?:[);/ ]|$)",
                model: "C5L"
            },
            {
                regex: "Neffos[_ ]Y50",
                model: "Y50"
            },
            {
                regex: "Neffos X20 Pro",
                model: "X20 Pro"
            },
            {
                regex: "Neffos[_ ]((?:[YNCXA])[0-9][A-Z]?(?: Max| Lite)?)",
                model: "$1"
            }
        ]
    },
    Nextbit: {
        regex: "Nextbit|(?:Robin)(?: Build|\\))",
        device: "smartphone",
        models: [
            {
                regex: "(Robin)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Newgen: {
        regex: "NEWGEN\\-([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Netgear: {
        regex: "GTV100",
        device: "tv",
        models: [
            {
                regex: "GTV100",
                model: "NeoTV Prime"
            }
        ]
    },
    NeuImage: {
        regex: "NIM-",
        device: "smartphone",
        models: [
            {
                regex: "NIM-(450D|550O|600Q)",
                model: "$1"
            }
        ]
    },
    NextBook: {
        regex: "Next[0-9]|NX(?:785QC8G|M900MC|008HD8G|010HI8G|M908HC|M726|16A8116K|A8QC116|16A10132S|16A11264)",
        device: "tablet",
        models: [
            {
                regex: "NX008HD8G",
                model: "Premium 8 HD"
            },
            {
                regex: "NXA8QC116",
                model: "Ares 8"
            },
            {
                regex: "NX16A8116K",
                model: "Ares A8"
            },
            {
                regex: "NX16A10132S",
                model: "Ares A10"
            },
            {
                regex: "NX16A11264",
                model: "Ares A11"
            },
            {
                regex: "NXM908HC",
                model: "Premium 9"
            },
            {
                regex: "NX010HI8G",
                model: "Premium 10 Hi"
            },
            {
                regex: "NX785QC8G",
                model: "8"
            },
            {
                regex: "NXM900MC",
                model: "8 HD"
            },
            {
                regex: "NXM726",
                model: "Premium 7"
            },
            {
                regex: "Next([0-9]+[^;/]+) Build",
                model: "Next $1"
            }
        ]
    },
    NGM: {
        regex: "NGM[_ ][a-z0-9]+|(Forward|Dynamic)[ _]?[^/;]+(?:Build|/)",
        device: "smartphone",
        models: [
            {
                regex: "(Forward|Dynamic)[ _]?([^/;]+) Build",
                model: "$1 $2"
            },
            {
                regex: "(Forward|Dynamic)[ _]?([^/;]+)/",
                model: "$1 $2"
            },
            {
                regex: "NGM ([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "NGM_([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Nexian: {
        regex: "S?Nexian",
        device: "smartphone",
        models: [
            {
                regex: "S?Nexian[ ]?([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "S?Nexian-([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Noain: {
        regex: "NOAIN",
        device: "smartphone",
        models: [
            {
                regex: "NOAIN[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "NOAIN[ _-]([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            }
        ]
    },
    Noblex: {
        regex: "Noblex|NBX-",
        device: "smartphone",
        models: [
            {
                regex: "(?:Noblex|NBX)[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "(?:Noblex|NBX)[ _-]([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            }
        ]
    },
    Nomu: {
        regex: "Nomu[ _-](?:T18|S30mini|S10)(?:[);/ ]|$)|V1600S(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Nomu[ _-]T18(?:[);/ ]|$)",
                model: "T18"
            },
            {
                regex: "Nomu[ _-]s10(?:[);/ ]|$)",
                model: "S10"
            },
            {
                regex: "Nomu[ _-]S30mini(?:[);/ ]|$)",
                model: "S30 Mini"
            },
            {
                regex: "(V1600S)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Nomi: {
        regex: "Nomi[ _-]|(C101010 Ultra2|i501[234]|i5032|i50[57]0|i5510|i5532|C0(700(?:[02358]|2HD)|7850)|C1010[0-3])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "i501[23](?:[);/ ]|$)",
                model: "Evo M2"
            },
            {
                regex: "I5070(?:[);/ ]|$)",
                model: "Iron-X"
            },
            {
                regex: "i5014(?:[);/ ]|$)",
                model: "Evo M4"
            },
            {
                regex: "i5032(?:[);/ ]|$)",
                model: "Evo X2"
            },
            {
                regex: "i5050(?:[);/ ]|$)",
                model: "Evo Z"
            },
            {
                regex: "Nomi_i4510(?:[);/ ]|$)",
                model: "Beat M"
            },
            {
                regex: "i5532(?:[);/ ]|$)",
                model: "Space X2"
            },
            {
                regex: "i5510(?:[);/ ]|$)",
                model: "Space M"
            },
            {
                regex: "C101010 Ultra2",
                model: "Ultra 2",
                device: "tablet"
            },
            {
                regex: "(C0(?:700(?:[02358]|2HD)|7850)|C1010[0-3])(?:[);/ ]|$)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Nomi[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Nomi[ _-]([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            }
        ]
    },
    "NUU Mobile": {
        regex: "NUU_|(?:(?:N(5702|5001)L|S6001L)|A6L-[CG])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "NUU_A([13])",
                model: "A$1"
            },
            {
                regex: "NUU_M([32])(?:[);/ ]|$)",
                model: "M$1"
            },
            {
                regex: "NUU_X5(?:[);/ ]|$)",
                model: "X5"
            },
            {
                regex: "S6001L",
                model: "G2"
            },
            {
                regex: "N5702L",
                model: "G3"
            },
            {
                regex: "(N5001L|A6L-[CG])(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    "NYX Mobile": {
        regex: "NYX[ _]",
        device: "smartphone",
        models: [
            {
                regex: "NYX_A1",
                model: "A1"
            },
            {
                regex: "NYX_Blink",
                model: "Blink"
            },
            {
                regex: "NYX_EGO",
                model: "Ego"
            },
            {
                regex: "NYX_FENIX",
                model: "Fenix"
            },
            {
                regex: "NYX_FLY_II",
                model: "Fly II"
            },
            {
                regex: "NYX_FLY_MINI",
                model: "Fly Mini"
            },
            {
                regex: "NYX_FLY",
                model: "Fly"
            },
            {
                regex: "NYX_HIT",
                model: "Hit"
            },
            {
                regex: "NYX_JAK",
                model: "Jak"
            },
            {
                regex: "NYX_JOIN",
                model: "Join"
            },
            {
                regex: "NYX_NOBA_II",
                model: "Noba II"
            },
            {
                regex: "NYX_NOBA",
                model: "Noba"
            },
            {
                regex: "NYX_ORBIS",
                model: "Orbis"
            },
            {
                regex: "NYX[ _]REX",
                model: "Rex"
            },
            {
                regex: "NYX_SHADE",
                model: "Shade"
            },
            {
                regex: "NYX_SKY",
                model: "Sky"
            },
            {
                regex: "NYX_SPARK",
                model: "Spark"
            },
            {
                regex: "NYX_VOX",
                model: "Vox"
            },
            {
                regex: "NYX_ZEUZ_HD",
                model: "Zeus HD"
            }
        ]
    },
    Nous: {
        regex: "(?:NS(?:[356]|500[2-68]|5511|5502)|NS 5511)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "NS 5511(?:[);/ ]|$)",
                model: "NS5511"
            },
            {
                regex: "(NS[0-9]{1,4})(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Nvidia: {
        regex: "NVIDIA|SHIELD Tablet K1|SHIELD Android TV|Tegra(Note-P1640| Note 7)",
        device: "tablet",
        models: [
            {
                regex: "TegraNote-P1640",
                model: "Tegra Note P1640"
            },
            {
                regex: "(SHIELD Tablet K1|Tegra Note 7)(?: Build|[;)])",
                model: "$1"
            },
            {
                regex: "SHIELD Android TV",
                model: "SHIELD Android TV",
                device: "tv"
            },
            {
                regex: "NVIDIA_SHIELD_PRO_2019",
                model: "SHIELD TV Pro",
                device: "tv"
            },
            {
                regex: "NVIDIA Shield",
                model: "SHIELD TV",
                device: "tv"
            }
        ]
    },
    "O+": {
        regex: "O\\+[ _](Air|Crunch|Ultra|Upsized|Venti|360 ALPHA PLUS 2.0)",
        device: "smartphone",
        models: [
            {
                regex: "O\\+[ _](Crunch|Ultra 2.0|Ultra|Upsized|Venti 4G)",
                model: "$1"
            },
            {
                regex: "O\\+_AIR",
                model: "Air"
            },
            {
                regex: "O\\+ 360 ALPHA PLUS 2.0",
                model: "360 Alpha Plus 2.0"
            }
        ]
    },
    O2: {
        regex: "Xda|(?<!FBCR/)O2[ \\-]|COCOON",
        device: "smartphone",
        models: [
            {
                regex: "(Xda[ _][a-z0-9_]+)",
                model: "$1"
            },
            {
                regex: "(COCOON)",
                model: "$1"
            },
            {
                regex: "O2 ([a-z0-9 ]+)",
                model: "$1"
            },
            {
                regex: "O2-([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Odys: {
        regex: "ODYS[ _-]|IEOS[_ ]([^/;]+)|NOON(?:_PRO)? Build|SPACE10_(?:PLUS|PRO)_3G|THOR_?10|TAO_X10|RAPID_?(?:10|7)_?LTE|MAVEN_?10_|CONNECT[78]|ELEMENT10_PLUS_3G|XELIO[_0-9P]|ADM816HC|ADM8000KP|NEO6_LTE|EOS10|AEON|FALCON_10_PLUS_3G|FUSION|THANOS_10|MAVEN_X10_HD(?:_LTE)?|JUNIOR_8_PRO|JuniorT8Pro|(?:NOVA|PYRO)_X?7_PLUS_3G|UNO_X8|SLADE_X55|XELIO_PRO_10_LTE|NOTOSplus3G",
        device: "tablet",
        models: [
            {
                regex: "XELIO[_ ]A10",
                model: "Xelio A10"
            },
            {
                regex: "XELIOPHONETAB3",
                model: "Xelio Phonetab 3"
            },
            {
                regex: "THANOS_10",
                model: "Thanos 10"
            },
            {
                regex: "XELIO_NEXT_10_PLUS_3G",
                model: "Xelio Next 10 Plus 3G"
            },
            {
                regex: "XELIO_PHONE_TAB7_3G",
                model: "Xelio Phonetab 7 3G"
            },
            {
                regex: "XELIO10EXTREME",
                model: "Xelio 10 Xtreme"
            },
            {
                regex: "XELIO10_PLUS_3G",
                model: "Xelio 10 Plus 3G"
            },
            {
                regex: "XELIO10_HD_PLUS_3G",
                model: "Xelio 10 HD Plus 3G"
            },
            {
                regex: "XELIO_10_HD",
                model: "Xelio 10 HD"
            },
            {
                regex: "XELIO_PRO_10_LTE",
                model: "Xelio Pro 10 LTE"
            },
            {
                regex: "ELEMENT10_PLUS_3G",
                model: "Element 10 Plus 3G"
            },
            {
                regex: "CONNECT8PLUS",
                model: "Connect 8 Plus"
            },
            {
                regex: "CONNECT7PRO",
                model: "Connect 7 Pro"
            },
            {
                regex: "MAVEN_X10_HD_LTE",
                model: "Maven X10 HD LTE"
            },
            {
                regex: "MAVEN_X10_HD",
                model: "Maven X10 HD"
            },
            {
                regex: "MAVEN_?10_PRO_PLUS_3G",
                model: "Maven 10 Pro Plus 3G"
            },
            {
                regex: "MAVEN_?10_?PLUS",
                model: "Maven 10 Plus"
            },
            {
                regex: "MAVEN_?10_?PRO",
                model: "Maven 10 Pro"
            },
            {
                regex: "MAVEN_?10_?HD",
                model: "Maven 10 HD"
            },
            {
                regex: "RAPID_?7_?LTE",
                model: "Rapid 7 LTE"
            },
            {
                regex: "RAPID_?10_?LTE",
                model: "Rapid 10 LTE"
            },
            {
                regex: "TAO_X10",
                model: "Tao X10"
            },
            {
                regex: "SPACE10_PLUS_3G",
                model: "Space 10 Plus 3G"
            },
            {
                regex: "SPACE10_PRO_3G",
                model: "Space 10 Pro 3G"
            },
            {
                regex: "THOR_?10 Build",
                model: "Thor 10"
            },
            {
                regex: "JuniorT8Pro",
                model: "Junior T8 Pro"
            },
            {
                regex: "JUNIOR_8_PRO",
                model: "Junior 8 Pro"
            },
            {
                regex: "ADM816HC",
                model: "Neo X"
            },
            {
                regex: "EOS10",
                model: "EOS 10"
            },
            {
                regex: "AEON",
                model: "Aeon"
            },
            {
                regex: "FALCON_10_PLUS_3G",
                model: "Falcon 10 Plus 3G"
            },
            {
                regex: "FUSION",
                model: "Fusion 7"
            },
            {
                regex: "UNO_X8",
                model: "Uno X8"
            },
            {
                regex: "ADM8000KP",
                model: "Titan"
            },
            {
                regex: "PYRO_7_PLUS_3G",
                model: "Pyro 7 Plus 3G"
            },
            {
                regex: "NOVA_X7_PLUS_3G",
                model: "Nova X7 Plus 3G"
            },
            {
                regex: "ODYS_NOVA_X7",
                model: "Nova X7"
            },
            {
                regex: "THOR_?10_PLUS_3G",
                model: "Thor 10 Plus 3G"
            },
            {
                regex: "NOTOSplus3G",
                model: "Notos Plus 3G"
            },
            {
                regex: "NEO6[_ ]LTE",
                model: "Neo 6 LTE",
                device: "smartphone"
            },
            {
                regex: "SLADE_X55",
                model: "Slade X55",
                device: "smartphone"
            },
            {
                regex: "IEOS[ _]([^/;]+) Build",
                model: "Ieos $1"
            },
            {
                regex: "(?:ODYS[ _-])?NOON Build",
                model: "Noon"
            },
            {
                regex: "(?:ODYS[ _-])?NOON_PRO Build",
                model: "Noon Pro"
            },
            {
                regex: "Odys[ _-]([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    Obi: {
        regex: "Obi[ _-]|(SJ1\\.5|SJ2\\.6|S400|S452\\+|S451|S453|S501|S502|S503\\+?|S507|S520|S550|S551|falcon)[ _]",
        device: "smartphone",
        models: [
            {
                regex: "SJ2\\.6",
                model: "SJ2.6"
            },
            {
                regex: "SJ1\\.5",
                model: "SJ1.5"
            },
            {
                regex: "(?:Obi_)?S400",
                model: "Skipper"
            },
            {
                regex: "(?:Obi_)?S451|falcon",
                model: "Flacon"
            },
            {
                regex: "(?:Obi_)?S452\\+",
                model: "Python"
            },
            {
                regex: "(?:Obi_)?S453",
                model: "Fox"
            },
            {
                regex: "(?:Obi_)?S501",
                model: "Wolverine"
            },
            {
                regex: "(?:Obi_)?S502",
                model: "Leopard"
            },
            {
                regex: "(?:Obi_)?S503\\+",
                model: "Boa Plus"
            },
            {
                regex: "(?:Obi_)?S503",
                model: "Boa"
            },
            {
                regex: "(?:Obi_)?S507",
                model: "Pelican"
            },
            {
                regex: "(?:Obi_)?S520",
                model: "Octopus"
            },
            {
                regex: "(?:Obi_)?S550",
                model: "Crane"
            },
            {
                regex: "(?:Obi_)?S551",
                model: "Hornbill"
            },
            {
                regex: "(?:Obi_)?S454",
                model: "Alligator"
            },
            {
                regex: "Obi[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Obi[ _-]([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            }
        ]
    },
    Okapia: {
        regex: "Signature (?:L|Pro|Touch)",
        device: "smartphone",
        models: [
            {
                regex: "Signature (L|Pro|Touch)",
                model: "Signature $1"
            }
        ]
    },
    Onda: {
        regex: "Onda|(?:(?:V820w|V891[w]?|V919(?: 3G)? Air)[ _-]DualOS|(?:V919 4G Air|V989 Air|V972) Core[48]|T2101L2B1C| V10 4G|OBOOK (?:20 SE|20 PLUS DUALOS)|OBOOK10 SE|V919 Air CH DualOS)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ONDA[ _]MID",
                model: "MID",
                device: "tablet"
            },
            {
                regex: "V820w[ _-]DualOS",
                model: "V820W Dual OS",
                device: "tablet"
            },
            {
                regex: "V891W[ _-]DualOS",
                model: "V891W Dual OS",
                device: "tablet"
            },
            {
                regex: "V891[ _-]DualOS",
                model: "V891 Dual OS",
                device: "tablet"
            },
            {
                regex: "V919 3G Air[ _-]DualOS",
                model: "V919 3G Air Dual OS",
                device: "tablet"
            },
            {
                regex: "V919 Air[ _-]DualOS",
                model: "V919 Air Dual OS",
                device: "tablet"
            },
            {
                regex: "V919 Air CH DualOS",
                model: "V919 Air CH Dual OS",
                device: "tablet"
            },
            {
                regex: "V919 4G Air Core8",
                model: "V919 4G Air Core 8",
                device: "tablet"
            },
            {
                regex: "V972 Core4",
                model: "V919 Core 4",
                device: "tablet"
            },
            {
                regex: "V989 Air Core8",
                model: "V989 Air Core 8",
                device: "tablet"
            },
            {
                regex: "T2101L2B1C|OBOOK 20 PLUS DUALOS",
                model: "oBook 20 Plus Dual OS",
                device: "tablet"
            },
            {
                regex: " V10 4G(?:[);/ ]|$)",
                model: 'V10 10.1" 4G',
                device: "tablet"
            },
            {
                regex: "OBOOK 20 SE(?:[);/ ]|$)",
                model: "oBook 20 SE",
                device: "tablet"
            },
            {
                regex: "OBOOK10 SE(?:[);/ ]|$)",
                model: "oBook 10 SE",
                device: "tablet"
            },
            {
                regex: "([a-z0-9]+)[ _]Onda",
                model: "$1"
            },
            {
                regex: "Onda ([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    OnePlus: {
        regex: "(?:du_)?ONEPLUS|(?:A0001|A200[135]|AC200[13]|A300[03]|A3010|A5000|A600[03]|A601[03]|BE201[1235]|BE2025|BE202[89]|E100[135]|GM191[03517]|GM190[0135]|GM192[05]|HD191[013]|HD190[01357]|HD1925|IN201[013579]|IN202[0135]|KB200[01357]|LE2117|LE212[03])(?: Build|\\))",
        device: "smartphone",
        models: [
            {
                regex: "AC200[13](?:[);/ ]|$)",
                model: "Nord 5G"
            },
            {
                regex: "BE2012(?:[);/ ]|$)",
                model: "Clover"
            },
            {
                regex: "BE201[135](?:[);/ ]|$)",
                model: "Nord N100"
            },
            {
                regex: "BE2025(?:[);/ ]|$)",
                model: "Nord N10"
            },
            {
                regex: "BE2029(?:[);/ ]|$)",
                model: "Nord N10 5G"
            },
            {
                regex: "BE2028(?:[);/ ]|$)",
                model: "Nord N10 Lite"
            },
            {
                regex: "IN202[0135](?:[);/ ]|$)",
                model: "8 Pro"
            },
            {
                regex: "KB2000(?:[);/ ]|$)",
                model: "8T"
            },
            {
                regex: "IN201[01357](?:[);/ ]|$)",
                model: "8"
            },
            {
                regex: "IN2019(?:[);/ ]|$)",
                model: "8 5G UW"
            },
            {
                regex: "LE2117(?:[);/ ]|$)",
                model: "9"
            },
            {
                regex: "LE212[03](?:[);/ ]|$)",
                model: "9 Pro"
            },
            {
                regex: "(?:GM191[01357]|OnePlus 7 Pro)(?:[);/ ]|$)",
                model: "7 Pro"
            },
            {
                regex: "GM190[0135](?:[);/ ]|$)",
                model: "7"
            },
            {
                regex: "HD190[01357](?:[);/ ]|$)",
                model: "7T"
            },
            {
                regex: "(?:HD191[013]|OnePlus 7T Pro)(?:[);/ ]|$)",
                model: "7T Pro"
            },
            {
                regex: "(?:HD1925|GM192[05])(?:[);/ ]|$)",
                model: "7T Pro 5G"
            },
            {
                regex: "KB200[1357](?:[);/ ]|$)",
                model: "8T"
            },
            {
                regex: "A0001(?:[);/ ]|$)",
                model: "One"
            },
            {
                regex: "A200[135]|OnePlus2",
                model: "2"
            },
            {
                regex: "E100[135](?:[);/ ]|$)",
                model: "X"
            },
            {
                regex: "A3010|OnePlus3T",
                model: "3T"
            },
            {
                regex: "A300[03]|OnePlus3",
                model: "3"
            },
            {
                regex: "A5010|OnePlus[ ]?5T",
                model: "5T"
            },
            {
                regex: "A5000|OnePlus5",
                model: "5"
            },
            {
                regex: "A600[03]|OnePlus6",
                model: "6"
            },
            {
                regex: "A601[03](?:[);/ ]|$)",
                model: "6T"
            },
            {
                regex: "(?:du_)?ONEPLUS ?([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    Realme: {
        regex: "Realme[ _]|(?:RMX(?:19(03|4[1235]|19|9[23]|2[157]|[01379]1|73)|20(?:[025-7]1|[037]2|2[57]|63|7[56]|8[156]|[2-5]0)|21(?:0[13]|17|[12]1|4[24]|5[15]|6[13]|7[60]|8[059]|9[35])|2200|18(0[1579]|11|3[13]|2[157]|[45]1|45)|3201|30[38]1|3063)|(?:OPPO[ _]?)?CPH1861)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:OPPO[ _]?)?CPH1861(?:[);/ ]|$)",
                model: "1"
            },
            {
                regex: "RMX180[59]",
                model: "2"
            },
            {
                regex: "RMX180[17]",
                model: "2 Pro"
            },
            {
                regex: "RMX(1833|182[15])",
                model: "3"
            },
            {
                regex: "RMX1827",
                model: "3i"
            },
            {
                regex: "RMX1851",
                model: "3 Pro"
            },
            {
                regex: "RMX190[13]|Realme X(?:[);/ ]|$)",
                model: "X"
            },
            {
                regex: "RMX199[12]",
                model: "X2"
            },
            {
                regex: "RMX1993",
                model: "X2 Dual"
            },
            {
                regex: "RMX1931|Realme X2 Pro(?:[);/ ]|$)",
                model: "X2 Pro"
            },
            {
                regex: "RMX2117",
                model: "Q2 5G"
            },
            {
                regex: "RMX2176(?:[);/ ]|$)",
                model: "X7 5G"
            },
            {
                regex: "RMX2121(?:[);/ ]|$)",
                model: "X7 Pro 5G"
            },
            {
                regex: "RMX1921|Realme XT(?:[);/ ]|$)",
                model: "XT"
            },
            {
                regex: "RMX19(1[19]|27)",
                model: "5"
            },
            {
                regex: "RMX197[13]",
                model: "5 Pro"
            },
            {
                regex: "RMX203[02]",
                model: "5i"
            },
            {
                regex: "RMX2001",
                model: "6"
            },
            {
                regex: "RMX2040",
                model: "6I"
            },
            {
                regex: "RMX2002",
                model: "6S"
            },
            {
                regex: "RMX206[13](?:[);/ ]|$)",
                model: "6 Pro"
            },
            {
                regex: "RMX215[15]",
                model: "7"
            },
            {
                regex: "RMX2103",
                model: "7I"
            },
            {
                regex: "RMX2170",
                model: "7 Pro"
            },
            {
                regex: "RMX3081",
                model: "8 Pro"
            },
            {
                regex: "RMX1925(?:[);/ ]|$)",
                model: "5S"
            },
            {
                regex: "RMX1811(?:[);/ ]|$)",
                model: "C1"
            },
            {
                regex: "RMX194[1235](?:[);/ ]|$)",
                model: "C2"
            },
            {
                regex: "RMX202[107](?:[);/ ]|$)",
                model: "C3"
            },
            {
                regex: "RMX2185(?:[);/ ]|$)",
                model: "C11"
            },
            {
                regex: "RMX2189(?:[);/ ]|$)",
                model: "C12"
            },
            {
                regex: "RMX2180(?:[);/ ]|$)",
                model: "C15"
            },
            {
                regex: "RMX2195(?:[);/ ]|$)",
                model: "C15 Qualcomm Edition"
            },
            {
                regex: "RMX2101(?:[);/ ]|$)",
                model: "C17"
            },
            {
                regex: "RMX3063(?:[);/ ]|$)",
                model: "C20"
            },
            {
                regex: "RMX3031(?:[);/ ]|$)",
                model: "GT Neo"
            },
            {
                regex: "RMX216[13](?:[);/ ]|$)",
                model: "Narzo 20 Pro"
            },
            {
                regex: "RMX2193(?:[);/ ]|$)",
                model: "Narzo 20"
            },
            {
                regex: "RMX2050(?:[);/ ]|$)",
                model: "Narzo 20A"
            },
            {
                regex: "RMX1831(?:[);/ ]|$)",
                model: "U1"
            },
            {
                regex: "RMX(?:20(?:51|[2]5)|2144)(?:[);/ ]|$)",
                model: "X50 5G"
            },
            {
                regex: "RMX2071(?:[);/ ]|$)",
                model: "X50 Pro"
            },
            {
                regex: "RMX207[56](?:[);/ ]|$)",
                model: "X50 Pro 5G"
            },
            {
                regex: "RMX2072(?:[);/ ]|$)",
                model: "X50 Pro Player"
            },
            {
                regex: "RMX(2142|2081)(?:[);/ ]|$)",
                model: "X3"
            },
            {
                regex: "RMX208[56](?:[);/ ]|$)",
                model: "X3 Super Zoom"
            },
            {
                regex: "RMX2111",
                model: "V5 5G"
            },
            {
                regex: "RMX2200",
                model: "V3 5G"
            },
            {
                regex: "RMX3201",
                model: "C21"
            },
            {
                regex: "Realme[ _]([1-9])[ _]Pro(?:[);/ ]|$)",
                model: "$1 Pro"
            }
        ]
    },
    OPPO: {
        regex: "(?:OB-)?OPPO[ _]?([a-z0-9]+)|N1T|R8001|OPG01|A00[12]OP|(?:X90[07][0679]|U70[57]T?|X909T?|R(?:10[01]1|2001|201[07]|6007|7005|7007|80[13579]|81[13579]|82[01379]|83[013]|800[067]|8015|810[679]|811[13]|820[057])[KLSTW]?|N520[79]|N5117|A33f|A33fw|A37fw?|PAAM00|PAAT00|PAC[TM]00)(?:[);/ ]|$)|R7kf|R7plusf|R7Plusm|A1601|CPH[0-9]{4}|CPH19(69|79|23|1[179])|PB(A[TM]00|CT10|BT30|CM[13]0|[FD]M00)|P(DAM10|ADM00|AF[TM]00|ADT00|AHM00|BBM[03]0|BBT00|BDT00|BFT00|[CB]E[MT]00|CA[MT]00|C[CDG]M00|CA[MT]10|[CD]PM00|CRM00|CDT00|CD[TM]10|CHM[013]0|CKM[08]0|CLM[15]0|DEM[13]0|DHM00|DK[TM]00|DPT00|DB[TM]00|DCM00|[CD]NM00|DVM00|DY[TM]20|DNT00|EA[TM]00)|PDSM00",
        device: "smartphone",
        models: [
            {
                regex: "PCHM10(?:[);/ ]|$)",
                model: "A11"
            },
            {
                regex: "(?:CPH2083|CPH2077)(?:[);/ ]|$)",
                model: "A12"
            },
            {
                regex: "PCHM00(?:[);/ ]|$)",
                model: "A11x"
            },
            {
                regex: "CPH1923(?:[);/ ]|$)",
                model: "A1K"
            },
            {
                regex: "(?:OPPO[ _]?)?(CPH1837|PAD[TM]00)(?:[);/ ]|$)",
                model: "A3"
            },
            {
                regex: "(?:OPPO[ _]?)?A37f(w)(?:[);/ ]|$)",
                model: "A37f$1"
            },
            {
                regex: "A37f(?:[);/ ]|$)",
                model: "A37f"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1605(?:[);/ ]|$)",
                model: "A39"
            },
            {
                regex: "CPH20(?:81|73|31|15)(?:[);/ ]|$)",
                model: "A31"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH18(?:0[35]|53)|PBBM30)(?:[);/ ]|$)",
                model: "A3s"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH1809|PBA[TM]00|PBBT30)(?:[);/ ]|$)",
                model: "A5"
            },
            {
                regex: "CPH19(?:3[13]|43)(?:[);/ ]|$)",
                model: "A5 (2020)"
            },
            {
                regex: "PDVM00(?:[);/ ]|$)",
                model: "A32"
            },
            {
                regex: "(?:PDAM10|CPH2069|CPH2061)(?:[);/ ]|$)",
                model: "A52"
            },
            {
                regex: "CPH2127(?:[);/ ]|$)",
                model: "A53"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH170[15](?:[);/ ]|$)",
                model: "A57"
            },
            {
                regex: "CPH19(?:09|1[02])(?:[);/ ]|$)",
                model: "A5S"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH190[15]|PBF[TM]00)(?:[);/ ]|$)",
                model: "A7"
            },
            {
                regex: "(?:OPPO[ _]?)?(CPH1801|CPH1717)(?:[);/ ]|$)",
                model: "A71"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:PDY[TM]20|CPH2067)(?:[);/ ]|$)",
                model: "A72"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1715(?:[);/ ]|$)",
                model: "A77"
            },
            {
                regex: "PCD[TM]00(?:[);/ ]|$)",
                model: "A7n"
            },
            {
                regex: "(PBBT00|PBBM00)(?:[);/ ]|$)",
                model: "A7x"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:PDBM00)(?:[);/ ]|$)",
                model: "A8"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1729(?:[);/ ]|$)",
                model: "A83"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1827(?:[);/ ]|$)",
                model: "A83 (2018)"
            },
            {
                regex: "PCA[TM]10(?:[);/ ]|$)",
                model: "A9"
            },
            {
                regex: "(CPH1937|CPH1941|PCHM30)(?:[);/ ]|$)",
                model: "A9 (2020)"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1938(?:[);/ ]|$)",
                model: "A9 (EN)"
            },
            {
                regex: "(?:PCPM00|CPH20[02]1)(?:[);/ ]|$)",
                model: "A91"
            },
            {
                regex: "CPH2059(?:[);/ ]|$)",
                model: "A92"
            },
            {
                regex: "PDKT00(?:[);/ ]|$)",
                model: "A92s"
            },
            {
                regex: "PDKM00(?:[);/ ]|$)",
                model: "A93s"
            },
            {
                regex: "PCE[TM]00(?:[);/ ]|$)",
                model: "A9x"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1851(?:[);/ ]|$)",
                model: "AX5"
            },
            {
                regex: "CPH1920(?:[);/ ]|$)",
                model: "AX5s"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1903(?:[);/ ]|$)",
                model: "AX7"
            },
            {
                regex: "(?:OPPO[ _]?)?X9009(?:[);/ ]|$)",
                model: "F1 Plus"
            },
            {
                regex: "CPH191[135](?:[);/ ]|$)",
                model: "F11"
            },
            {
                regex: "CPH19(?:69|87)(?:[);/ ]|$)",
                model: "F11 Pro"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH2119)(?:[);/ ]|$)",
                model: "F17 Pro"
            },
            {
                regex: "(?:OPPO[ _]?)?A1601(?:[);/ ]|$)",
                model: "F1s"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1609(?:[);/ ]|$)",
                model: "F3"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1613(?:[);/ ]|$)",
                model: "F3 Plus"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH172[37](?:[);/ ]|$)",
                model: "F5"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1725(?:[);/ ]|$)",
                model: "F5 Youth"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH(1859|18(?:19|21))(?:[);/ ]|$)",
                model: "F7"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH1825|CPH1881)(?:[);/ ]|$)",
                model: "F9"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1823(?:[);/ ]|$)",
                model: "F9 Pro"
            },
            {
                regex: "(?:OPPO[ _]?)?X909T?(?:[);/ ]|$)",
                model: "Find 5"
            },
            {
                regex: "(?:OPPO[ _]?)?R827T?(?:[);/ ]|$)",
                model: "Find 5 Mini"
            },
            {
                regex: "(?:OPPO[ _]?)?X907[067](?:[);/ ]|$)",
                model: "Find 7"
            },
            {
                regex: "(?:OPPO[ _]?)?X900[067](?:[);/ ]|$)",
                model: "Find 7a"
            },
            {
                regex: "(?:OPPO[ _]?)?R815[TW]?(?:[);/ ]|$)",
                model: "Find Clover"
            },
            {
                regex: "(?:OPPO[ _]?)?R8015(?:[);/ ]|$)",
                model: "Find Guitar"
            },
            {
                regex: "(?:OPPO[ _]?)?R8111(?:[);/ ]|$)",
                model: "Find Melody"
            },
            {
                regex: "(?:OPPO[ _]?)?R821T?(?:[);/ ]|$)",
                model: "Find Muse"
            },
            {
                regex: "(?:OPPO[ _]?)?U707T?(?:[);/ ]|$)",
                model: "Find Way S"
            },
            {
                regex: "(?:OPPO[ _]?)?U705T(?:[);/ ]|$)",
                model: "Ulike 2"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH187[15]|PAF[MT]00)(?:[);/ ]|$)",
                model: "Find X"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:PAHM00)(?:[);/ ]|$)",
                model: "Find X Lamborghini"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:PDEM10|CPH2023)(?:[);/ ]|$)",
                model: "Find X2"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH2005(?:[);/ ]|$)",
                model: "Find X2 Lite"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:PDEM30|OPG01|CPH2025)(?:[);/ ]|$)",
                model: "Find X2 Pro"
            },
            {
                regex: "(?:OPPO[ _]?)?R1011 Build",
                model: "Joy Plus"
            },
            {
                regex: "(?:OPPO[ _]?)?(PBC(?:M30|T10))(?:[);/ ]|$)",
                model: "K1"
            },
            {
                regex: "CPH1955(?:[);/ ]|$)",
                model: "K3"
            },
            {
                regex: "(?:OPPO[ _]?)?(PCNM00)(?:[);/ ]|$)",
                model: "K5"
            },
            {
                regex: "(?:OPPO[ _]?)?(PCLM50)(?:[);/ ]|$)",
                model: "K7"
            },
            {
                regex: "(?:OPPO[ _]?)?N5117(?:[);/ ]|$)",
                model: "N1 Mini"
            },
            {
                regex: "(?:OPPO[ _]?)?N520[79](?:[);/ ]|$)",
                model: "N3"
            },
            {
                regex: "(?:OPPO[ _]?)?R831T?(?:[);/ ]|$)",
                model: "Neo"
            },
            {
                regex: "(?:OPPO[ _]?)?R831K(?:[);/ ]|$)",
                model: "Neo 3"
            },
            {
                regex: "(?:OPPO[ _]?)?R831[SL](?:[);/ ]|$)",
                model: "Neo 5"
            },
            {
                regex: "(?:OPPO[ _]?)?A33f(?:[);/ ]|$)",
                model: "Neo 7"
            },
            {
                regex: "(?:OPPO[ _]?)?A33fw(?:[);/ ]|$)",
                model: "Neo 7s"
            },
            {
                regex: "(?:OPPO[ _]?)?R8113(?:[);/ ]|$)",
                model: "Piano"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1707(?:[);/ ]|$)",
                model: "R11"
            },
            {
                regex: "R8001(?:[);/ ]|$)",
                model: "R1K"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1719(?:[);/ ]|$)",
                model: "R11s"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1721(?:[);/ ]|$)",
                model: "R11s Plus"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH1835|PAC[TM]00|PAAM00)(?:[);/ ]|$)",
                model: "R15"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH183[13]|PAAT00)(?:[);/ ]|$)",
                model: "R15 Pro"
            },
            {
                regex: "PBCM10(?:[);/ ]|$)",
                model: "R15x"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH1879|PBE[MT]00)(?:[);/ ]|$)",
                model: "R17"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH1893)(?:[);/ ]|$)",
                model: "R17 Neo"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH1877|PBD[MT]00)(?:[);/ ]|$)",
                model: "R17 Pro"
            },
            {
                regex: "(?:OPPO[ _]?)?R8006(?:[);/ ]|$)",
                model: "R1L"
            },
            {
                regex: "(?:OPPO[ _]?)?R800[07](?:[);/ ]|$)",
                model: "R1S"
            },
            {
                regex: "(?:OPPO[ _]?)?R810[679](?:[);/ ]|$)",
                model: "R5"
            },
            {
                regex: "(?:OPPO[ _]?)?R7kf(?:[);/ ]|$)",
                model: "R7 Lite"
            },
            {
                regex: "(?:OPPO[ _]?)?R7Plusm(?:[);/ ]|$)",
                model: "R7 Plus"
            },
            {
                regex: "(?:OPPO[ _]?)?R7Plusf(?:[);/ ]|$)",
                model: "R7 Plus F"
            },
            {
                regex: "(?:OPPO[ _]?)?X9079(?:[);/ ]|$)",
                model: "R9 Plus"
            },
            {
                regex: "(?:OPPO[ _]?)?CPH1607(?:[);/ ]|$)",
                model: "R9s"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH1611|R9s Plus)(?:[);/ ]|$)",
                model: "R9s Plus"
            },
            {
                regex: "(?:CPH1917|PCA[MT]00)(?:[);/ ]|$)",
                model: "Reno"
            },
            {
                regex: "CPH1983(?:[);/ ]|$)",
                model: "Reno A"
            },
            {
                regex: "PCCM00(?:[);/ ]|$)",
                model: "Reno 10X"
            },
            {
                regex: "CPH1919(?:[);/ ]|$)",
                model: "Reno 10X Zoom"
            },
            {
                regex: "(?:PCKM00|CPH1907)(?:[);/ ]|$)",
                model: "Reno 2"
            },
            {
                regex: "CPH1989(?:[);/ ]|$)",
                model: "Reno 2F"
            },
            {
                regex: "(?:PCKM80|CPH1945|CPH1951)(?:[);/ ]|$)",
                model: "Reno 2Z"
            },
            {
                regex: "CPH2043(?:[);/ ]|$)",
                model: "Reno 3"
            },
            {
                regex: "(?:CPH2013|A002OP)(?:[);/ ]|$)",
                model: "Reno 3A"
            },
            {
                regex: "(?:PDCM00|A001OP)(?:[);/ ]|$)",
                model: "Reno 3 5G"
            },
            {
                regex: "(?:PCRM00|CPH203[57]|CPH2009)",
                model: "Reno 3 Pro"
            },
            {
                regex: "CPH2113(?:[);/ ]|$)",
                model: "Reno 4 4G"
            },
            {
                regex: "CPH2125(?:[);/ ]|$)",
                model: "Reno 4 Lite"
            },
            {
                regex: "CPH2109(?:[);/ ]|$)",
                model: "Reno 4 Pro 4G"
            },
            {
                regex: "PDP[TM]00(?:[);/ ]|$)",
                model: "Reno 4 5G"
            },
            {
                regex: "PEA[TM]00(?:[);/ ]|$)",
                model: "Reno 4 SE 5G "
            },
            {
                regex: "PDN[TM]00(?:[);/ ]|$)",
                model: "Reno 4 Pro 5G"
            },
            {
                regex: "PDSM00(?:[);/ ]|$)",
                model: "Reno 5 Pro 5G"
            },
            {
                regex: "CPH192[15]",
                model: "Reno 5G"
            },
            {
                regex: "PCLM10(?:[);/ ]|$)",
                model: "Reno Ace"
            },
            {
                regex: "PDHM00(?:[);/ ]|$)",
                model: "Reno Ace 2"
            },
            {
                regex: "PCGM00(?:[);/ ]|$)",
                model: "Reno K3"
            },
            {
                regex: "(?:OPPO[ _]?)?(?:CPH1979|PCD[TM]10)(?:[);/ ]|$)",
                model: "Reno Z"
            },
            {
                regex: "N1T?(?:[);/ ]|$)",
                model: "N1T",
                device: "phablet"
            },
            {
                regex: "R([0-9]{3,4}[KSTW]?)(?:[);/ ]|$)",
                model: "R$1"
            },
            {
                regex: "(CPH[0-9]{4})",
                model: "$1"
            },
            {
                regex: "(?:OB-)?OPPO[ _]?((?!Browser)[a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Opsson: {
        regex: "Opsson|IUSAI",
        device: "smartphone",
        models: [
            {
                regex: "IUSAI[ _]([^/;]+) Build",
                model: "Iusai $1"
            },
            {
                regex: "IUSAI[ _]([^/;\\)]+)[/;\\)]",
                model: "Iusai $1"
            },
            {
                regex: "Opsson[ _]([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "(?:Opsson-)?Opsson[ -_]([^/;]+)/",
                model: "$1"
            }
        ]
    },
    Orange: {
        regex: "SPV[ \\-]?([a-z0-9]+)|(?<!FBCR/)Orange[ _-](?!Tahiti-LS\\))([^/;]+)( Build|\\))(?<!Tahiti-LS\\))|SC/IHD92|Nura 2|FunTab ([^/;]+) Build|Orange Mahpee",
        device: "smartphone",
        models: [
            {
                regex: "SC/IHD92",
                model: "Livebox Play",
                device: "tv"
            },
            {
                regex: "Nura 2",
                model: "Nura 2"
            },
            {
                regex: "Sego",
                model: "Sego",
                device: "tablet"
            },
            {
                regex: "FunTab ([^/;]+) Build",
                model: "FunTab $1",
                device: "tablet"
            },
            {
                regex: "Orange[ _-](Rise)(3[12]|5[12])(?:[);/ ]|$)",
                model: "$1 $2"
            },
            {
                regex: "Orange[ _-](Dive)72(?:[);/ ]|$)",
                model: "$1 72"
            },
            {
                regex: "Orange[ _-](Daytona|Dive (30|7[13])|Dublin|Fova|Gova|Hi 4G|Hiro|Kivo|Monte Carlo|Neva 80|Neva play|Nura|Reyo|Rise[_ ](3[034]|40|5[345])|Rono|Roya|San Francisco|Tactile internet 2|Tado|Yomi|Yumo|Zali|Mahpee)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "SPV[ \\-]?([a-z0-9]+)",
                model: "SPV $1"
            }
        ]
    },
    Oukitel: {
        regex: "OUKITEL|(?:(?:C15|C16|K10000|K[46]000)(?:[ _]Pro)|K4000Pro|U16 Max|U7 Max|U7 Plus|U11[_ ]Plus|U20_Plus|OK6000 Plus|WP5000|WP[58] Pro|K[46]000[ _](?:Plus|Lite)|Y4800|K10000|K[4-8]000| WP[5-7])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(C15|C16|K10000|K[46]000|WP[258]|U15)[ _]?Pro(?:[);/ ]|$)",
                model: "$1 Pro"
            },
            {
                regex: "OUKITEL K([37])(?:[);/ ]|$)",
                model: "K$1"
            },
            {
                regex: "(K10000|U16|U7)[ _]Max(?:[);/ ]|$)",
                model: "$1 Max"
            },
            {
                regex: "(U20|K[46]000|U7|U11|OK6000)[_ ]?Plus(?:[);/ ]|$)",
                model: "$1 Plus"
            },
            {
                regex: "(K4000)[_ ]Lite(?:[);/ ]|$)",
                model: "$1 Lite"
            },
            {
                regex: "(Y4800|K10000|K[4-8]000|WP2|WP5000|[CU]2|U10)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: " (WP[5-7])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "OUKITEL; ([^;]+);",
                model: "$1"
            }
        ]
    },
    OKWU: {
        regex: "OKWU SIGMA(?:[);/ ]|$)",
        device: "smartphone",
        model: "Sigma"
    },
    Ouki: {
        regex: "OUKI|OK[AU][0-9]+[a-z]* Build",
        device: "smartphone",
        models: [
            {
                regex: "OUKI[ _-]?([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "([^;/)]+) Build/OUKI",
                model: "$1"
            },
            {
                regex: "OUKI[ _-]?([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            },
            {
                regex: "(OK[AU][0-9]+[a-z]*) Build",
                model: "$1"
            }
        ]
    },
    Overmax: {
        regex: "OV-[a-z]+(?:[^;(/]*)[();/ ]|Qualcore 10(?:10|27)|Vertis 5021 Aim|OV1027[34]G",
        device: "tablet",
        models: [
            {
                regex: "OV-V10",
                model: "Vertis Yard",
                device: "smartphone"
            },
            {
                regex: "Vertis 5021 Aim",
                model: "Vertis 5021 Aim",
                device: "smartphone"
            },
            {
                regex: "OV-Vertis[ _-]([^;/]+) Build",
                model: "Vertis $1",
                device: "smartphone"
            },
            {
                regex: "Qualcore 1010",
                model: "Qualcore 1010",
                device: "tablet"
            },
            {
                regex: "Qualcore 1027 4G",
                model: "Qualcore 1027 4G",
                device: "tablet"
            },
            {
                regex: "OV1027([34])G",
                model: "Qualcore 1027 $1G",
                device: "tablet"
            },
            {
                regex: "(OV-[a-z]+(?:[^;(/]*))(?<!Build)[();/ ]",
                model: "$1"
            }
        ]
    },
    Oysters: {
        regex: "Oysters|T84ERI[ _]3G|T72HM(s_)?3G|T102MS_3G|T102ER3G|(T74HMi|T84Bi)[_ ]4G|T74MR4G|T84Ni[_ ][34]G|Pacific[ ]?800i|T104B_[34]G|IndianV|T72HA_3G|T74D_3G|T74N_3G|T74SC_3G|T74Mai_3G|T104MBi_3G|T104SCi_3G|T104ER4G|Atlantic4G|AntarcticE|T7V 3G",
        device: "tablet",
        models: [
            {
                regex: "Pacific[ ]?800i",
                device: "smartphone",
                model: "Pacific 800i"
            },
            {
                regex: "Atlantic4G",
                device: "smartphone",
                model: "Atlantic 4G"
            },
            {
                regex: "AntarcticE",
                device: "smartphone",
                model: "Antarctic E"
            },
            {
                regex: "IndianV",
                device: "smartphone",
                model: "Indian V"
            },
            {
                regex: "Oysters[_ ]PacificV",
                device: "smartphone",
                model: "Pacific V"
            },
            {
                regex: "Oysters ((?:Arctic|Indian|Atlantic|Pacific)[^/;]+) Build",
                device: "smartphone",
                model: "$1"
            },
            {
                regex: "(T84ERI[ _]3G|T72HM(s_)?3G|(?:(T74HMi|T84Bi)[_ ]4G)|T84Ni[_ ][34]G)",
                model: "$1"
            },
            {
                regex: "(T74MR|T102MS|T104B|T74SC|T74[DN]|T72HA|T102ER|T104SCi|T104MBi|T104ER|T7V)[ _]?([34]G)",
                model: "$1 $2"
            },
            {
                regex: "T74Mai_3G",
                model: "T74MAi 3G"
            },
            {
                regex: "Oysters ([^/;]+)( Build|\\))",
                model: "$1"
            }
        ]
    },
    "\xf6wn": {
        regex: "OWN[ _]|(?:S4035[ _][34]G|Smart8|SMART PLUS LTE)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "FUN ([67])",
                model: "Fun $1"
            },
            {
                regex: "FUN 5\\(4G\\)",
                model: "Fun 5 4G"
            },
            {
                regex: "(?:OWN[ _])?(S3000D|S3010|S3020D|S4010|S4025|S4035[ _][34]G)",
                model: "$1"
            },
            {
                regex: "One Plus",
                model: "One Plus"
            },
            {
                regex: "One",
                model: "One"
            },
            {
                regex: "SMART 9",
                model: "Smart 9"
            },
            {
                regex: "Smart8(?:[);/ ]|$)",
                model: "Smart 8"
            },
            {
                regex: "SMART PLUS LTE(?:[);/ ]|$)",
                model: "Smart Plus LTE"
            }
        ]
    },
    Panacom: {
        regex: "T-i708D",
        device: "smartphone",
        models: [
            {
                regex: "T-i708D",
                device: "tablet",
                model: "T-i708D"
            }
        ]
    },
    Panasonic: {
        regex: "Panasonic|PANATV[0-9]+|Viera/|(?:P902i|P-0[28]D|FZ-B2D|FZ-[NX]1|DMC-CM1|P-01J|P-03E)(?:[);/ ]|$)|Eluga[ _]|P55 Novo 4G",
        device: "smartphone",
        models: [
            {
                regex: "P-01J(?:[);/ ]|$)",
                model: "P-smart Keitai"
            },
            {
                regex: "P-03E(?:[);/ ]|$)",
                model: "Eluga P"
            },
            {
                regex: "Eluga[ _-]([^;/]+) Build",
                model: "Eluga $1"
            },
            {
                regex: "Eluga[ _-]([^);/]+)[;/)]",
                model: "Eluga $1"
            },
            {
                regex: "(DMC-CM1)",
                model: "Lumix $1",
                device: "camera"
            },
            {
                regex: "P-02D(?:[);/ ]|$)",
                model: "Lumix Phone P-02D"
            },
            {
                regex: "(FZ-[XN]1)(?:[);/ ]|$)",
                model: "Toughpad $1"
            },
            {
                regex: "FZ-B2D(?:[);/ ]|$)",
                model: "Toughpad FZ-B2D",
                device: "tablet"
            },
            {
                regex: "P55 Novo 4G",
                model: "P55 Novo 4G"
            },
            {
                regex: "P902i(?:[);/ ]|$)",
                device: "feature phone",
                model: "P902i"
            },
            {
                regex: "Panasonic MIL DLNA",
                device: "tv",
                model: "Viera Cast"
            },
            {
                regex: "PANATV[0-9]+|Viera/",
                device: "tv",
                model: "Smart TV"
            },
            {
                regex: "(43D1200|(?:32|43)D1270|32D1280)",
                device: "tv",
                model: "$1"
            },
            {
                regex: "Panasonic[ _\\-]?([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "portalmmm/2.0 (P[a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "P-08D(?:[);/ ]|$)",
                model: 'Eluga Live 10.1"',
                device: "tablet"
            }
        ]
    },
    PCBOX: {
        regex: "Art-PCB-V116|Bee-PCB-V216|Clap-PCB-I316|PCB-T(103|715)",
        device: "smartphone",
        models: [
            {
                regex: "Art-PCB-V116",
                model: "Art"
            },
            {
                regex: "Bee-PCB-V216",
                model: "Bee"
            },
            {
                regex: "Clap-PCB-I316",
                model: "Clap"
            },
            {
                regex: "PCB-T103",
                device: "tablet",
                model: "Curi Lite"
            },
            {
                regex: "PCB-T715",
                device: "tablet",
                model: "T715"
            }
        ]
    },
    PCD: {
        regex: "PH4001",
        device: "smartphone",
        models: [
            {
                regex: "PH4001",
                model: "PH4001"
            }
        ]
    },
    "PCD Argentina": {
        regex: "PCD[ ]?50[689]",
        device: "smartphone",
        models: [
            {
                regex: "PCD[ ]?(50[689])",
                model: "$1"
            }
        ]
    },
    ArmPhone: {
        regex: "(TSD Octa A0520P|TSD Quadra A050[59]P)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Pentagram: {
        regex: "Pentagram|Quadra|Monster X5",
        device: "tablet",
        models: [
            {
                regex: "(?:PENTAGRAM[_ ])?EON[_ ]PRIX",
                model: "Eon Prix"
            },
            {
                regex: "Quadra 7(?: UltraSlim)?",
                model: "Quadra 7 UltraSlim"
            },
            {
                regex: "Monster X5?",
                model: "Monster X5",
                device: "smartphone"
            },
            {
                regex: "Quadra ?([^);/]*) Build",
                model: "Quadra $1"
            },
            {
                regex: "Pentagram ?TAB ?([^);/]*) Build",
                model: "Tab $1"
            },
            {
                regex: "Pentagram ?([^);/]*) Build",
                model: "$1",
                device: "smartphone"
            }
        ]
    },
    TCL: {
        regex: "TCL,|TCL[_ -][a-z0-9]+|(?:TCL[_ -][^;/]+ Build)|(?:TCLGalaG60(?:\\(9108A\\))?|A502DL|T78[02]H|5199I|7040N|5133A|5159[AJ]|5152D|T770H|T671H|T790Y|T766H_EEA|T766A|T799[BH]|Percee TV)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "TCLGalaG60(?:\\(9108A\\))?(?:[);/ ]|$)",
                model: "Gala G60"
            },
            {
                regex: "5199I(?:[);/ ]|$)",
                model: "C9"
            },
            {
                regex: "5152D(?:[);/ ]|$)",
                model: "C5"
            },
            {
                regex: "5133A(?:[);/ ]|$)",
                model: "L5"
            },
            {
                regex: "T780H(?:[);/ ]|$)",
                model: "Plex"
            },
            {
                regex: "T782H(?:[);/ ]|$)",
                model: "10 Plus"
            },
            {
                regex: "T790Y(?:[);/ ]|$)",
                model: "10 5G"
            },
            {
                regex: "TCL[_ -]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "TCL[_ -]([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(7040N)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "A502DL(?:[);/ ]|$)",
                model: "LX"
            },
            {
                regex: "5159[AJ](?:[);/ ]|$)",
                model: "L9"
            },
            {
                regex: "T770H(?:[);/ ]|$)",
                model: "10L"
            },
            {
                regex: "T766[HA](?:_EEA)?(?:[);/ ]|$)",
                model: "10 SE"
            },
            {
                regex: "T671H(?:_EEA)?(?:[);/ ]|$)",
                model: "20 SE"
            },
            {
                regex: "T799[BH](?:[);/ ]|$)",
                model: "10 Pro"
            },
            {
                regex: "(Percee TV)(?:[);/ ]|$)",
                device: "tv",
                model: "$1"
            },
            {
                regex: "((?:43|55)S62FS|(?:43|50)P65US|U(?:43|60)P60|65P4USM|(?:40|49)S62|L32S6|55P610|50P8S|55S62|(?:43|50)P6US|55DP60)",
                device: "tv",
                model: "$1"
            }
        ]
    },
    JVC: {
        regex: "JVC[;,]|JVC Shell",
        device: "tv",
        models: [
            {
                regex: "JVC Shell [0-9A-Z]+",
                model: ""
            },
            {
                regex: "JVC[;,](32D1290)",
                model: "$1"
            }
        ]
    },
    phoneOne: {
        regex: "phoneOne[ \\-]?([a-z0-9]+)",
        device: "smartphone",
        model: "$1"
    },
    Primepad: {
        regex: "PD\\-(3127NC|3127) Build",
        device: "tablet",
        models: [
            {
                regex: "PD\\-3127NC Build",
                model: "PD-3127NC"
            },
            {
                regex: "PD\\-3127 Build",
                model: "PD-3127"
            }
        ]
    },
    Pioneer: {
        regex: "Pioneer|.*; R1 Build|dvr700pi|XDP-300R",
        device: "smartphone",
        models: [
            {
                regex: ".*; R1 Build",
                model: "R1",
                device: "tablet"
            },
            {
                regex: "Pioneer[ _-]?([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Pioneer[ _-]?([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            },
            {
                regex: "dvr700pi",
                model: 'DVR700PI 7.0"',
                device: "tablet"
            },
            {
                regex: "(XDP-300R)",
                device: "portable media player",
                model: "$1"
            }
        ]
    },
    Pixus: {
        regex: "Pixus|(hiPower|Ride[_ ][34]G|Play[ _]Three[ _]v(?:[24].0|3.1))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "Ride[_ ]([34])G",
                model: "Ride $1G"
            },
            {
                regex: "Play[ _]Three[ _]v([24].0|3.1)",
                model: "Play Three v$1"
            },
            {
                regex: "Play Two",
                model: "Play Two"
            },
            {
                regex: "Play Five",
                model: "Play Five"
            },
            {
                regex: "hiPower",
                model: "hiPower"
            },
            {
                regex: "Pixus[ _]Sprint",
                model: "Sprint"
            },
            {
                regex: "Touch 7 3G",
                model: "Touch 7 3G"
            },
            {
                regex: "Pixus[ _]hiMax",
                model: 'HiMax 9.6"'
            },
            {
                regex: "Pixus[ _]Blast",
                model: 'Blast 10.1"'
            },
            {
                regex: "Pixus[ _]Joker",
                model: 'Joker 10.1"'
            },
            {
                regex: "Pixus Blaze 10.1 3G",
                model: 'Blaze 10.1" 3G'
            },
            {
                regex: "Raze",
                model: "Raze",
                device: "smartphone"
            },
            {
                regex: "Pixus_Jet",
                model: "Jet",
                device: "smartphone"
            },
            {
                regex: "pixus hit 2",
                model: "Hit 2",
                device: "smartphone"
            }
        ]
    },
    PULID: {
        regex: "PULID[ _]|F1[01357]\\+? Build",
        device: "smartphone",
        models: [
            {
                regex: "F(1[01357]\\+?) Build",
                model: "F$1"
            },
            {
                regex: "PULID[ _]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "PULID[ _]([a-z0-9_]+)\\)",
                model: "$1"
            }
        ]
    },
    "Point of View": {
        regex: "POV_TV|POV_TAB|MOB-5045",
        device: "tablet",
        models: [
            {
                regex: "POV_TV-HDMI-KB-01",
                model: "HDMI Smart TV Dongle",
                device: "tv"
            },
            {
                regex: "POV_TV-HDMI-200BT",
                model: "Mini PC HDMI Dongle",
                device: "tv"
            },
            {
                regex: "MOB-5045",
                model: "Mobii Phone 5045",
                device: "smartphone"
            },
            {
                regex: "POV_TAB-P506",
                model: "ONYX 506 Navi"
            },
            {
                regex: "POV_TAB[_-]NAVI7[_-]3G[_-]M",
                model: "ONYX 507 Navi"
            },
            {
                regex: "POV_TAB-P527S",
                model: "ONYX 527S"
            },
            {
                regex: "POV_TAB-P547",
                model: "ONYX 547 Navi"
            },
            {
                regex: "POV_TAB-PROTAB26",
                model: "ProTab 26 XXL IPS"
            },
            {
                regex: "POV_TAB-PROTAB25XXL8?",
                model: "ProTab 25XXL"
            },
            {
                regex: "POV_TAB-PL1015",
                model: "Mobii 1015"
            },
            {
                regex: "POV_TAB-PROTAB([a-z0-9]+)",
                model: "ProTab $1"
            },
            {
                regex: "POV_TAB-P?([a-z0-9]+)",
                model: "Mobii $1"
            }
        ]
    },
    Pomp: {
        regex: "POMP[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "POMP[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "POMP[ _-]([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            }
        ]
    },
    PPTV: {
        regex: "(KING 7S?)",
        device: "smartphone",
        model: "$1"
    },
    ProScan: {
        regex: "PLT([^;/]+) Build|PLT(?:777[45]|9774|1074)G(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "PLT([^;/]+) Build",
                model: "PLT$1"
            },
            {
                regex: "PLT(777[45]|9774|1074)G",
                model: "PLT$1G"
            }
        ]
    },
    "RCA Tablets": {
        regex: "RCT([^;/]+) Build|RCA RLTP4028|RCT6513W87|RCT6973W43(?:MD)?|RCT6703W12|RCT(?:6A06P22|6603W47M7|6303W87(?:DK|M)|6773W22B|6203W46L|6873W42M|6K03W13)",
        device: "smartphone",
        models: [
            {
                regex: "RCA RLTP4028",
                model: "RLTP4028"
            },
            {
                regex: "RCT6513W87",
                device: "tablet",
                model: 'Galileo Pro 11.5"'
            },
            {
                regex: "RCT6873W42M",
                device: "tablet",
                model: 'Voyager 7.0"'
            },
            {
                regex: "RCT6973W43(?:MD)?",
                device: "tablet",
                model: 'Voyager III 7.0"'
            },
            {
                regex: "RCT6773W22B",
                device: "tablet",
                model: 'Voyager II 7.0"'
            },
            {
                regex: "RCT6703W12",
                device: "tablet",
                model: 'Atlas 10.0"'
            },
            {
                regex: "RCT6203W46L",
                device: "tablet",
                model: "Pro 10 Edition II"
            },
            {
                regex: "RCT6A06P22",
                device: "tablet",
                model: 'Endeavor 10.0" HD'
            },
            {
                regex: "RCT(?:6303W87(?:DK|M)|6K03W13)",
                device: "tablet",
                model: 'Viking Pro 10.0"'
            },
            {
                regex: "RCT6603W47M7",
                device: "tablet",
                model: 'Viking II 10.0"'
            },
            {
                regex: "RCT([^;/)]+)(?: Build|[;)])",
                device: "tablet",
                model: "RCT$1"
            }
        ]
    },
    Readboy: {
        regex: "Readboy[ _-]",
        device: "tablet",
        models: [
            {
                regex: "Readboy[ _-]([^;/)]+)(?: Build|[;)])",
                model: "$1"
            }
        ]
    },
    Roku: {
        regex: "Roku/DVP",
        device: "tv",
        model: "Digital Video Player"
    },
    Rokit: {
        regex: "IO Pro",
        device: "smartphone",
        models: [
            {
                regex: "IO Pro",
                model: "IO Pro"
            }
        ]
    },
    Rombica: {
        regex: "(Rombica|SSQ-A0500|Smart Box v[0-9]+)(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "SSQ-A0500(?:[);/ ]|$)",
                model: "Smart Stick 4K"
            },
            {
                regex: "(Infinity K8|Smart Box (?:v00[345789]|Quad|Ultra HD v002|4K V001))(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Rover: {
        regex: "Rover ([0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    RoverPad: {
        regex: "(?:Rover[ ]?Pad|RoverPhone|Sky 7.85 3G)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "RoverPhone(?:[);/ ]|$)",
                model: "",
                device: "smartphone"
            },
            {
                regex: "(?:Rover[ ]?Pad)?sky 7.85(?: 3G)?(?:[);/ ]|$)",
                model: 'Sky 7.85" 3G'
            },
            {
                regex: "RoverPad (10.4|Air S70|9.7 3G|Sky 9.7|3W A73|3W7|3WT70|3W9.4)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Roadrover: {
        regex: "Roadrover ChangAn S",
        device: "tablet",
        model: "ChangAn S"
    },
    "RT Project": {
        regex: "Shock 5",
        device: "smartphone",
        models: [
            {
                regex: "Shock 5",
                model: "Shock 5"
            }
        ]
    },
    "S-TELL": {
        regex: "S-TELL",
        device: "smartphone",
        models: [
            {
                regex: "(?:S-TELL[ _])?M4(61|77|80)",
                model: "M4$1"
            }
        ]
    },
    Safaricom: {
        regex: "NEON_RAY",
        device: "smartphone",
        models: [
            {
                regex: "NEON_RAY",
                model: "Neon Ray"
            }
        ]
    },
    Santin: {
        regex: "(?:SANTIN|BiTBiZ_V58|ACTOMA ACE|DREAMPLUS03A|Candy U7 Pro)[);/_ ]",
        device: "smartphone",
        models: [
            {
                regex: "BiTBiZ_V58(?:[);/ ]|$)",
                model: "BiTBiZ V58"
            },
            {
                regex: "Candy U7 Pro(?:[);/ ]|$)",
                model: "Candy U7 Pro"
            },
            {
                regex: "DREAMPLUS03A(?:[);/ ]|$)",
                model: "Dream Plus 03A"
            },
            {
                regex: "GreenOrange(?:[);/ ]|$)",
                model: "Green Orange"
            },
            {
                regex: "halove(?:[);/ ]|$)",
                model: "Halove"
            },
            {
                regex: "ACTOMA ACE(?:[);/ ]|$)",
                model: "Actoma Ace"
            },
            {
                regex: "monica(?:[);/ ]|$)",
                model: "Monica"
            },
            {
                regex: "POWER(?:[);/ ]|$)",
                model: "Power"
            },
            {
                regex: "GALAZ(?:[);/ ]|$)",
                model: "Galaz"
            },
            {
                regex: "NEWDUN(?:[);/ ]|$)",
                model: "Newdun"
            },
            {
                regex: "SANTIN[ _][#]?(Dante|Candy U7|Armor|YSL-Y7|ANT.W|N[13]|JS|S6|V9|Life Shine)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Siemens: {
        regex: "SIEMENS|SIE-|portalmmm/2\\.0 SI|(?:S55|SL45i)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:SIE-)?(S[56]5|S40|C45|ME45|SLIK)(?:[);/ ]|$)",
                device: "feature phone",
                model: "$1"
            },
            {
                regex: "SIEMENS[ \\-]([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "SIE(?:MENS )?[\\-]?([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(?:SIE-)?(SL45i)",
                model: "$1"
            },
            {
                regex: "portalmmm/2.0 (SI[a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Soundmax: {
        regex: "((?:SM-LED32M(?:11|04)S)(?:_-Ver01)?|SM-LED40M04S)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Samsung: {
        regex: "SAMSUNG(?! ?Browser)|Maple (?!III)|SC-(?:01[FGHKLM]|02[CGHJKLM]|03[JKL]|04[EJL]|05[GL]|(?:4[12]|5[1234])A)|N[57]100|N5110|N9100|S(?:CH|GH|PH|EC|AM|HV|HW|M)-|SMART-TV|GT-|(?<!GOG|GOG )Galaxy|(?:portalmmm|o2imode)/2\\.0 [SZ]|sam[rua]|vollo Vi86(?:[);/ ]|$)|(?:OTV-)?SMT-E5015|ISW11SC|SCV4[0-9]|SCV3[1-9]|40[34]SC|SCL2[234]|SCG0[1-7]|SCT21",
        device: "smartphone",
        models: [
            {
                regex: "GT-B9150",
                device: "tv",
                model: "Home Sync"
            },
            {
                regex: "(?:OTV-)?SMT-E5015",
                device: "tv",
                model: "SMT-E5015"
            },
            {
                regex: "Maple ",
                device: "tv",
                model: ""
            },
            {
                regex: "(?:SAMSUNG-)?(?:GT-)?N5100",
                device: "tablet",
                model: 'Galaxy Note 8.0"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T677(?:[ATV]|N[KL])?(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy View 18.4" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T670(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy View 18.4" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?(?:GT-)?N5110",
                device: "tablet",
                model: 'Galaxy Note 8.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?GT-N5120",
                device: "tablet",
                model: 'Galaxy Note 8.0" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?(?:GT|SM)-N8000",
                device: "tablet",
                model: 'Galaxy Note 10.1"'
            },
            {
                regex: "(?:SAMSUNG-)?GT-N8010",
                device: "tablet",
                model: 'Galaxy Note 10.1" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?GT-N8020",
                device: "tablet",
                model: 'Galaxy Note 10.1" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P1000M?|SCH-I800",
                device: "tablet",
                model: "Galaxy Tab"
            },
            {
                regex: "(?:SAMSUNG-)?GT-P3100B?",
                device: "tablet",
                model: 'Galaxy Tab 2 7"'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P311[03]",
                device: "tablet",
                model: 'Galaxy Tab 2 7" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P5100|SCH-I915",
                device: "tablet",
                model: 'Galaxy Tab 2 10.1"'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P511[03]",
                device: "tablet",
                model: 'Galaxy Tab 2 10.1" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T217T",
                device: "tablet",
                model: 'Galaxy Tab 3 7.0" 4G'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P5200",
                device: "tablet",
                model: 'Galaxy Tab 3 10.1"'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P5210",
                device: "tablet",
                model: 'Galaxy Tab 3 10.1" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P5220",
                device: "tablet",
                model: 'Galaxy Tab 3 10.1" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P6200",
                device: "tablet",
                model: 'Galaxy Tab 7" Plus'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P6201",
                device: "tablet",
                model: 'Galaxy Tab 7" Plus N'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P6810",
                device: "tablet",
                model: 'Galaxy Tab 7.7"'
            },
            {
                regex: "(?:SAMSUNG-)?GT-P7100",
                device: "tablet",
                model: "Galaxy Tab 10.1v"
            },
            {
                regex: "(?:SAMSUNG-)?GT-P75[01]0",
                device: "tablet",
                model: 'Galaxy Tab 10.1"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-P600",
                device: "tablet",
                model: 'Galaxy Note 10.1" 2014 Edition WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-P60[12]",
                device: "tablet",
                model: 'Galaxy Note 10.1" 2014 Edition'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:P605|P607T)",
                device: "tablet",
                model: 'Galaxy Note 10.1" 2014 Edition LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-P900",
                device: "tablet",
                model: 'Galaxy NotePRO 12.2" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-P901",
                device: "tablet",
                model: 'Galaxy NotePRO 12.2"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-P905",
                device: "tablet",
                model: 'Galaxy NotePRO 12.2" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:P587|P588C)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab A 10.1" with S Pen (2016) LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-P583(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab A 10.1" with S Pen (2016) WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-P205(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab A 8.0" with S Pen (2019) LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-P200(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab A 8.0" with S Pen (2019) WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T307U(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab A 8.4" (2020) LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T505[CN]?|T507)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab A7 10.4" (2020) LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T500(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab A7 10.4" (2020) WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T11[03]",
                device: "tablet",
                model: 'Galaxy Tab 3 Lite 7.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T830[X]?|T837R4)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S4 10.5" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T837P(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S4 10.5" with S Pen'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T835[CN]?|T837[VTA]?)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S4 10.5"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T725[CN]?|T720X|T727(?:R4|[AUV])?)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S5e 10.5"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T720(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S5e 10.5" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T865N?(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S6 10.5"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T867(?:R4|[VU])?(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S6 10.5" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:P615[CN]?|P617)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S6 Lite 10.4"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-P610X?(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S6 Lite 10.4" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T860(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S6 10.5" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T866N(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S6 10.5" 5G'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T111[M]?(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab 3 Lite 7.0"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T116(?:BU|NU|NY)?",
                device: "tablet",
                model: "Galaxy Tab 3 V"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T2105|T212)",
                device: "tablet",
                model: 'Galaxy Tab 3 7.0" Kids'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T210R?",
                device: "tablet",
                model: 'Galaxy Tab 3 7.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T21(?:[15]|7[AS])",
                device: "tablet",
                model: 'Galaxy Tab 3 7.0"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T230(?:NU)?",
                device: "tablet",
                model: 'Galaxy Tab 4 7.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T23[15]|403SC",
                device: "tablet",
                model: 'Galaxy Tab 4 7.0" 3G'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T239|T237[PV])",
                device: "tablet",
                model: 'Galaxy Tab 4 7.0" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T232(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab 4 7.0" WiFi + 3G'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T310",
                device: "tablet",
                model: 'Galaxy Tab 3 8.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T311",
                device: "tablet",
                model: 'Galaxy Tab 3 8.0"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T315",
                device: "tablet",
                model: 'Galaxy Tab 3 8.0" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T330",
                device: "tablet",
                model: 'Galaxy Tab 4 8.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T33[215]|T337[AVT])",
                device: "tablet",
                model: 'Galaxy Tab 4 8.0" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T520",
                device: "tablet",
                model: 'Galaxy TabPRO 10.1" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T53[15]|T537[AV])",
                device: "tablet",
                model: 'Galaxy Tab 4 10.1" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T536(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab 4 10.1" Advanced'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T532(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab 4 10.1"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T320",
                device: "tablet",
                model: 'Galaxy TabPRO 8.4" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T325",
                device: "tablet",
                model: 'Galaxy TabPRO 8.4" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T525",
                device: "tablet",
                model: 'Galaxy TabPRO 10.1" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T530(?:NU)?|T533)",
                device: "tablet",
                model: 'Galaxy Tab 4 10.1" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T700",
                device: "tablet",
                model: 'Galaxy Tab S 8.4" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T705|T707[AV])",
                device: "tablet",
                model: 'Galaxy Tab S 8.4" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T800",
                device: "tablet",
                model: 'Galaxy Tab S 10.5" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-(?:T805|T807[PV]?)|SCT21)",
                device: "tablet",
                model: 'Galaxy Tab S 10.5" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T813|T810)",
                device: "tablet",
                model: 'Galaxy Tab S2 9.7" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T719[CY]?|T715(?:N0|[CY])?)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S2 8.0" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T71[03]|T710X)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S2 8.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T815|T817[ATW]?|T818[ATVW]?|T819[Y]?)",
                device: "tablet",
                model: 'Galaxy Tab S2 9.7" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T820",
                device: "tablet",
                model: 'Galaxy Tab S3 9.7" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T82[57]",
                device: "tablet",
                model: 'Galaxy Tab S3 9.7" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T975N?(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S7+ 12.4" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T970(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S7+ 12.4" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T976[BN]|T978U)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S7+ 12.4" 5G'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T870(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S7 11.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T875N?(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S7 11.0" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T878U(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab S7 11.0" 5G'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T900",
                device: "tablet",
                model: 'Galaxy TabPRO 12.2" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T280",
                device: "tablet",
                model: 'Galaxy Tab A 7.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T285",
                device: "tablet",
                model: 'Galaxy Tab A 7.0" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T3[58]0",
                device: "tablet",
                model: 'Galaxy Tab A 8.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:P350|T3[58]5|T357[TW])",
                device: "tablet",
                model: 'Galaxy Tab A 8.0" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T387(?:AA|R4|VK|[TVW])",
                device: "tablet",
                model: 'Galaxy Tab A 8.0" LTE (2018)'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T295",
                device: "tablet",
                model: 'Galaxy Tab A 8.0" LTE (2019)'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T290",
                device: "tablet",
                model: 'Galaxy Tab A 8.0" WiFi (2019)'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:P355([MY])?|T550)",
                device: "tablet",
                model: 'Galaxy Tab A 9.7" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:P550|P555(M)?|T555)",
                device: "tablet",
                model: 'Galaxy Tab A 9.7" LTE'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T58[05]|P58[05])",
                device: "tablet",
                model: 'Galaxy Tab A 10.1" WiFi (2016)'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T587[P]?",
                device: "tablet",
                model: 'Galaxy Tab A 10.1" LTE (2016)'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T59[057]",
                device: "tablet",
                model: 'Galaxy Tab A 10.5" LTE (2018)'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T51(?:7P|[057])",
                device: "tablet",
                model: 'Galaxy Tab A 10.1" (2019)'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T37[57]|T378[KLSV])",
                device: "tablet",
                model: 'Galaxy Tab E 8.0"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T56[02]",
                device: "tablet",
                model: 'Galaxy Tab E 9.6" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T561",
                device: "tablet",
                model: 'Galaxy Tab E 9.6" 3G'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T567V",
                device: "tablet",
                model: 'Galaxy Tab E 9.6" 4G'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T365(?:F0|[MY])?(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab Active 8.0"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T360(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab Active 8.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T395[CN]?|T397U)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab Active 2 8.0"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T390(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab Active 2 8.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T575N?|T577U?)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab Active 3 8.0"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T570(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab Active 3 8.0" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:T545|T547U?)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab Active Pro 10.1"'
            },
            {
                regex: "(?:SAMSUNG-)?SM-T540(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Tab Active Pro 10.1" WiFi'
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:P902|P907A)(?:[);/ ]|$)",
                device: "tablet",
                model: 'Galaxy Note Pro 12.2"'
            },
            {
                regex: "(?:SAMSUNG[- ])?SM-T2519",
                model: "Galaxy Tab Q",
                device: "tablet"
            },
            {
                regex: "(?:SAMSUNG )?SM-R820",
                device: "wearable",
                model: "Galaxy Watch Active 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G850(?:8S|[AFKLMSWXY])",
                model: "Galaxy Alpha"
            },
            {
                regex: "(?:SAMSUNG-)?GT-B5330",
                model: "Galaxy Chat"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A605K",
                model: "Galaxy Jean"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A202K",
                model: "Galaxy Jean 2"
            },
            {
                regex: "(?:SAMSUNG-)?GT-B5510",
                model: "Galaxy Y Pro"
            },
            {
                regex: "(?:SAMSUNG-)?GT-B5512",
                model: "Galaxy Y Pro Duos"
            },
            {
                regex: "(?:SAMSUNG-)?GT-B7510",
                model: "Galaxy Pro"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I5700",
                model: "Galaxy Spica"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I5801",
                model: "Galaxy Apollo"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I5800",
                model: "Galaxy 3"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I8000",
                model: "Omnia II"
            },
            {
                regex: "(?:SAMSUNG-)?(?:GT-I8150|SM-T255S)",
                model: "Galaxy W"
            },
            {
                regex: "SC-01H(?:[);/ ]|$)",
                model: "Galaxy Active Neo"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S5830",
                model: "Galaxy Ace"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:G357(?:FZ|M)|G310HN)",
                model: "Galaxy Ace Style"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I8160",
                model: "Galaxy Ace 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G313(?:HY|M[LUY]|[FM])",
                model: "Galaxy Ace 4"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G316M",
                model: "Galaxy Ace 4 Duos"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G313[HU]",
                model: "Galaxy Ace 4 Lite"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:G316U|G318(?:H|ML))(?:[);/ ]|$)",
                model: "Galaxy Ace 4 Neo"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G9100(?:[);/ ]|$)",
                model: "Galaxy S II"
            },
            {
                regex: "(?:SAMSUNG-)?SHV-E120S(?:[);/ ]|$)",
                model: "Galaxy S II HD LTE"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I8190",
                model: "Galaxy S III mini"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I8200",
                model: "Galaxy S III mini Value Edition"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I826[02]",
                model: "Galaxy Core"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G386W",
                model: "Galaxy Core LTE"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G3589W",
                model: "Galaxy Core Lite LTE"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I8320",
                model: "H1"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I85[23]0",
                model: "Galaxy Beam"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G3858",
                model: "Galaxy Beam 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G600S",
                model: "Galaxy Wide"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I855[028]",
                model: "Galaxy Win"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G381[28]",
                model: "Galaxy Win Pro"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I8580",
                model: "Galaxy Core Advance"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I8730",
                model: "Galaxy Express"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:E500(?:HQ|YZ|[0FHM])|S978L)",
                model: "Galaxy E5"
            },
            {
                regex: "(?:SAMSUNG-)?SM-E700[09FHM]",
                model: "Galaxy E7"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I90(?:00|08|18|88)",
                model: "Galaxy S"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9001",
                model: "Galaxy S Plus"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9003",
                model: "Galaxy SL"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9010",
                model: "Galaxy S Giorgio Armani"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9070",
                model: "Galaxy S Advance"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I910[08]",
                model: "Galaxy S II"
            },
            {
                regex: "(?:SAMSUNG-)?ISW11SC",
                model: "Galaxy S II WiMAX"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9103",
                model: "Galaxy R"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9105",
                model: "Galaxy S II Plus"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G730(?:W8|[AV])",
                model: "Galaxy S3 mini"
            },
            {
                regex: "(?:SAMSUNG-)?(?:GT-I919[025]|SCH-I435)",
                model: "Galaxy S4 mini"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9515",
                model: "Galaxy S4 Value Edition"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9295",
                model: "Galaxy S4 ACTIVE"
            },
            {
                regex: "(?:SAMSUNG-)?(?:GT-I9300|SCH-(?:I535|I939|L710))",
                model: "Galaxy S III"
            },
            {
                regex: "(?:SAMSUNG-)?(?:GT-I9305|SCH-R530)",
                model: "Galaxy S III LTE"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-S975L|GT-I950[025]|SC-04E|SCH-(?:I545|I959|R970)|SGH-M919N?|Galaxy-S4)",
                model: "Galaxy S4"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9506",
                model: "Galaxy S4 with LTE+"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S5280",
                model: "Galaxy STAR"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S5301",
                model: "Galaxy POCKET Plus"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S5310",
                model: "Galaxy POCKET Neo"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G110[BHM]",
                model: "Galaxy POCKET 2"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S5360",
                model: "Galaxy Y Hello Kitty"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S6310",
                model: "Galaxy Young"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S6312",
                model: "Galaxy Young DUOS"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G130(?:BT|HN|[EHMU])",
                model: "Galaxy Young 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G130BU",
                model: "Galaxy Young 2 Pro"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S6790",
                model: "Galaxy FAME Lite with NFC"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S6810",
                model: "Galaxy FAME"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S6812",
                model: "Galaxy FAME Duos"
            },
            {
                regex: "SC-04J(?:[);/ ]|$)",
                model: "Galaxy Feel"
            },
            {
                regex: "SC-02L(?:[);/ ]|$)",
                model: "Galaxy Feel 2"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S7275",
                model: "Galaxy ACE 3"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S7500",
                model: "Galaxy ACE Plus"
            },
            {
                regex: "(?:SAMSUNG-)?(?:GT-S7560|SCH-I699)",
                model: "Galaxy Trend"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S7390",
                model: "Galaxy Trend Lite"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S7580",
                model: "Galaxy Trend Plus"
            },
            {
                regex: "(?:SAMSUNG-)?SCH-I739",
                model: "Galaxy Trend 2"
            },
            {
                regex: "(?:SAMSUNG-)?(?:GT-S7562|SCH-I919)",
                model: "Galaxy S DUOS"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S7582",
                model: "Galaxy S DUOS 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:G31[36]HU|G313HZ)",
                model: "Galaxy S DUOS 3"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S7710",
                model: "Galaxy Xcover 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G388F",
                model: "Galaxy Xcover 3"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G389F",
                model: "Galaxy Xcover 3 VE"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G390[FWY]",
                model: "Galaxy Xcover 4"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G398FN",
                model: "Galaxy Xcover 4s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G715(?:FN|U1|[AUW])",
                model: "Galaxy Xcover Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G889(?:YB|[AFG])",
                model: "Galaxy Xcover FieldPro"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S8500",
                model: "Wave"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S8530",
                model: "Wave II"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S8600",
                model: "Wave 3"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S5380",
                model: "Wave Y"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S7250",
                model: "Wave M"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S5250",
                model: "Wave 525"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S5330",
                model: "Wave 533"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S5780",
                model: "Wave 578"
            },
            {
                regex: "(?:SAMSUNG-)?GT-S7230",
                model: "Wave 723"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:C101|C105([AL])?)",
                model: "Galaxy S4 zoom"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:C111(M)?|C115)",
                model: "Galaxy K zoom"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G318[HM]Z",
                model: "Galaxy V Plus"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G355(?:6D|[89HM])",
                model: "Galaxy Core 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G350",
                model: "Galaxy Core Plus"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:G360[FH]?|S820L)",
                model: "Galaxy Core Prime"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G361[FH]?",
                model: "Galaxy Core Prime Value Edition"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:G386F|G3518(?:_TD)?|G3586V)",
                model: "Galaxy Core LTE"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G3568V",
                model: "Galaxy Core Mini 4G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G5108Q?",
                model: "Galaxy Core Max"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G3815",
                model: "Galaxy EXPRESS II"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G800",
                model: "Galaxy S5 mini"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G9009D",
                model: "Galaxy S5 Dual-SIM"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:G900|G906[KLS]|S902L|S903VL)|Galaxy-S5|SCL23",
                model: "Galaxy S5"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G901F",
                model: "Galaxy S5 LTE+"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G870[AFW]|SC-02G",
                model: "Galaxy S5 Active"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G903[FMW]",
                model: "Galaxy S5 Neo"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G860P",
                model: "Galaxy S5 K Sport"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-G920(?:F[DQ]|W8|[089AFIKLPRSTVX])?|SM-S906L|SM-S907VL)|SC-05G",
                model: "Galaxy S6"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G890A",
                model: "Galaxy S5 Active"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G925[0ADFIKLPRSTVWX]|SCV31|404SC",
                model: "Galaxy S6 Edge"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G928(?:7C|N0|R4|W8|[07ACFGIKLPSTVX])",
                model: "Galaxy S6 Edge+"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G930(?:AZ|FD|R[467]|T1|V[CL]|W8|[0AFKLPRSTUVX8])?(?:[);/ ]|$)",
                model: "Galaxy S7"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G935(?:R4|W8|[0AFKLPSTUVX])|SC-02H|SCV33",
                model: "Galaxy S7 Edge"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G891A",
                model: "Galaxy S7 Active"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G950[08FNUW]?|SCV36|SC-02J",
                model: "Galaxy S8"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G8750",
                model: "Galaxy S8 Lite"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G892[AU]",
                model: "Galaxy S8 Active"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G955[0AFKLNPRTUVWX]?|SCV35|SC-03J",
                model: "Galaxy S8+"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G960[0FNUWX]?|SCV38|SC-02K",
                model: "Galaxy S9"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G965[0FNUWX]|SCV39|SC-03K",
                model: "Galaxy S9+"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-(?:G973|G977[BNPTU])|SCV41|SC-03L)",
                model: "Galaxy S10"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:S10 Lite|G770(?:U1|F))",
                model: "Galaxy S10 Lite"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-G975[08FUNWX]|SCV42|SC-04L)",
                model: "Galaxy S10+"
            },
            {
                regex: "SC-05L",
                model: "Galaxy S10+ Olympic Games Edition"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G970(?:U1|[08FUNWX])(?:[);/ ]|$)",
                model: "Galaxy S10e"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G980F",
                model: "Galaxy S20"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G981(?:U1|[0BNUVW])|SCG01|SC-51A",
                model: "Galaxy S20 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G780F",
                model: "Galaxy S20 FE"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G781(?:U1|[0BNUVW])",
                model: "Galaxy S20 FE 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G988(?:U1|[0BNQUW])|SCG03",
                model: "Galaxy S20 Ultra 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G985F|SCG02",
                model: "Galaxy S20+"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G986(?:U1|[0BNUW])|SC-52A",
                model: "Galaxy S20+ 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G991(?:U1|[0BNW])",
                model: "Galaxy S21 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G998(?:U1|[0BNUW])",
                model: "Galaxy S21 Ultra 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G996(?:U1|[0BNWU])",
                model: "Galaxy S21+ 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-F700(?:U1|[0FNUW])|SCV47",
                model: "Galaxy Z Flip"
            },
            {
                regex: "(?:SAMSUNG-)?SM-F707(?:U1|[0BNUW])|SCG04",
                model: "Galaxy Z Flip 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SCH-I200",
                model: "Galaxy Stellar"
            },
            {
                regex: "(?:SAMSUNG-)?SCH-I829",
                model: "Galaxy Style Duos"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SCH-R740|SGH-S730)",
                model: "Galaxy Discover"
            },
            {
                regex: "(?:SAMSUNG-)?SCH-S738",
                model: "Galaxy Centura"
            },
            {
                regex: "vollo Vi86(?:[);/ ]|$)",
                model: "Vollo Vi86"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G386(?:T1|T)",
                model: "Galaxy Avant"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A716S",
                model: "Galaxy A Quantum"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:A015(?:DL|[TU]1|[AFGMUV])|S111DL)",
                model: "Galaxy A01"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A013[FGM]",
                model: "Galaxy A01 Core"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A025[FGM]",
                model: "Galaxy A02s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A022G",
                model: "Galaxy A02"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A260[FG]",
                model: "Galaxy A2 Core"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A300(?:FU|YZ|XU|XZ|[09FGHMXY])",
                model: "Galaxy A3 (2015)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A310(?:N0|[FMXY])",
                model: "Galaxy A3 (2016)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A320(?:FL|[FXY])",
                model: "Galaxy A3 (2017)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A430F",
                model: "Galaxy A4"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A500(?:YZ|[9LSWY])?(?:[);/ ]|$)",
                model: "Galaxy A5"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A500[0FGHKM]",
                model: "Galaxy A5 Duos"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A500(?:FU|X)",
                model: "Galaxy A5 (2015)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A510[08FKLMSXY]",
                model: "Galaxy A5 (2016)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A520[FKLSWX]",
                model: "Galaxy A5 (2017)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A525F",
                model: "Galaxy A52"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A600(?:AZ|FN|GN|T1|[AFGNPTUX])",
                model: "Galaxy A6"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A605(?:[FG]N|[08FGX])",
                model: "Galaxy A6+"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G6200",
                model: "Galaxy A6s (2018)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A606[0Y]",
                model: "Galaxy A60"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A700(?:YD|[09FHKLSX])",
                model: "Galaxy A7"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A710[08FKLMSXY]",
                model: "Galaxy A7 (2016)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A720[FMSX]",
                model: "Galaxy A7 (2017)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A750(?:GN|[CFGNX])",
                model: "Galaxy A7 (2018)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A71(?:5[FW])?(?:[);/ ]|$)",
                model: "Galaxy A71"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A725F(?:[);/ ]|$)",
                model: "Galaxy A72"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A716(?:U1|[0BUV])(?:[);/ ]|$)",
                model: "Galaxy A71 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A(?:530F|800[0FISXY])|SCV32",
                model: "Galaxy A8"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G885[FSY]",
                model: "Galaxy A8 Star"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A810(?:YZ|[FS])",
                model: "Galaxy A8 (2016)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:A8s|G887[0F])",
                model: "Galaxy A8s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A530[MNWX]",
                model: "Galaxy A8 (2018)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A730[FX]",
                model: "Galaxy A8+ (2018)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A900[0F]",
                model: "Galaxy A9"
            },
            {
                regex: "SM-A9\\[7\\]",
                model: "Galaxy A9 7"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A920[0FXN]",
                model: "Galaxy A9 (2018)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G885[08]",
                model: "Galaxy A9 Star"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:A9 Pro|A910[0F]|G887N)",
                model: "Galaxy A9 Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A105[FGMN]",
                model: "Galaxy A10"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A107[FM]",
                model: "Galaxy A10s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:S102DL|A102[NUW])",
                model: "Galaxy A10e"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A115(?:A[PZ]|U1|[AFMUW])",
                model: "Galaxy A11"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A125[FM]",
                model: "Galaxy A12"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:A205(?:U1|YN|[FGSWU])|S205DL)|SC-02M|SCV46",
                model: "Galaxy A20"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-A215(?:DL|U1|[UW])|SC-42A|SCV49)(?:[);/ ]|$)",
                model: "Galaxy A21"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A217[FMN](?:[);/ ]|$)",
                model: "Galaxy A21s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A202[FG]",
                model: "Galaxy A20e"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A207[0FM]",
                model: "Galaxy A20s"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-A305(?:[FGY]N|GT|[FGN])|SCV43)",
                model: "Galaxy A30"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A307(?:FN|GN|GT|[FG])",
                model: "Galaxy A30s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A315[FGN](?:[);/ ]|$)",
                model: "Galaxy A31"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A325F(?:[);/ ]|$)",
                model: "Galaxy A32"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A326(?:BR|B)",
                model: "Galaxy A32 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A405(?:F[NM]|S)",
                model: "Galaxy A40"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A305[018](?:[);/ ]|$)",
                model: "Galaxy A40s"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-A415F|SC-41A|SCV48)(?:[);/ ]|$)",
                model: "Galaxy A41"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A426[0BN](?:[);/ ]|$)",
                model: "Galaxy A42 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:A505(?:F[GN]|U1|YN|[FGNUWX])|S506DL|505FN)",
                model: "Galaxy A50"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A5070(?:[);/ ]|$)",
                model: "Galaxy A50s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A507FN",
                model: "Galaxy A50s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:A515[FUW]|S515DL)",
                model: "Galaxy A51"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-A516(?:U1|[0BNUV])|SC-54A|SCG07)",
                model: "Galaxy A51 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A705(?:GM|[MYF]N|[0FUWX])",
                model: "Galaxy A70"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A707[0F]",
                model: "Galaxy A70s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A805[0FNX]",
                model: "Galaxy A80"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A908[BN]",
                model: "Galaxy A90"
            },
            {
                regex: "(?:SAMSUNG-)?SM-A9080",
                model: "Galaxy A90 5G"
            },
            {
                regex: "(?:SAMSUNG-)?SM-F127G(?:[);/ ]|$)",
                model: "Galaxy F12"
            },
            {
                regex: "(?:SAMSUNG-)?SM-F415F(?:[);/ ]|$)",
                model: "Galaxy F41"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9301I",
                model: "Galaxy S III Neo"
            },
            {
                regex: "(?:SAMSUNG-)?SM-S120VL(?:[);/ ]|$)",
                model: "Galaxy Luna"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:J100(?:FN|VPP|MU|[FGHMY])|S777C)",
                model: "Galaxy J1"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J105[BFHYM]",
                model: "Galaxy J1 Mini"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J106[BFHM]",
                model: "Galaxy J1 mini Prime"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:J120(?:ZN|[AFGHMPTW])|J05H)",
                model: "Galaxy J1 (2016)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:J110[FGHLM]|J111[FM])",
                model: "Galaxy J1 Ace"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J200[FGHMY]",
                model: "Galaxy J2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J200BT",
                model: "Galaxy J2 Duos"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J260AZ",
                model: "Galaxy J2 Pure"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:J260([AFGMY]|T1)|S260DL)",
                model: "Galaxy J2 Core"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J(?:210F|250[FGMNY])",
                model: "Galaxy J2 Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:S367VL|S357BL)",
                model: "Galaxy J3 Orbit"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J311(?:[09]|9S)",
                model: "Galaxy J3 Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-S320VL(?:[);/ ]|$)",
                model: "Galaxy J3 Sky"
            },
            {
                regex: "(?:SAMSUNG-)?SM-S327VL(?:[);/ ]|$)",
                model: "Galaxy J3 Luna Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J327(?:T1|[ATW])(?:[);/ ]|$)",
                model: "Galaxy J3 Prime"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J327(?:[FP]|R4)",
                model: "Galaxy J3 Emerge"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J337R4(?:[);/ ]|$)",
                model: "Galaxy J3 Aura"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J337T(?:[);/ ]|$)",
                model: "Galaxy J3 Star"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J327V",
                model: "Galaxy J3 Eclipse"
            },
            {
                regex: "(?:SAMSUNG-)?SM-S337TL",
                model: "Galaxy J3 Luna Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J3109",
                model: "Galaxy J3 (2015)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:J300H|J320(?:[ZF]N|R4|W8|YZ|[AFGHMNPVY]))",
                model: "Galaxy J3 (2016)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:J330(?:FN|[08FGLN])|J327(?:R7|U))(?:[);/ ]|$)",
                model: "Galaxy J3 (2017)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J337(?:VPP|[AWPUV])(?:[);/ ]|$)",
                model: "Galaxy J3 (2018)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:G400[FG]|J400[FGM])",
                model: "Galaxy J4"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J500(?:FN|N0|[78FGHMY])(?:[);/ ]|$)",
                model: "Galaxy J5 (2015)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:J510(?:[FGMU]N|FQ|[8FGHKLSY])|5108|G510H)(?:[);/ ]|$)",
                model: "Galaxy J5 (2016)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J530",
                model: "Galaxy J5 (2017)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G570[0FMY]",
                model: "Galaxy J5 Prime"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J600[FGLN]",
                model: "Galaxy J6"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J610[FG]",
                model: "Galaxy J6+"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J410[FG]",
                model: "Galaxy J4 Core"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J415(?:[FG]N|[FGN])",
                model: "Galaxy J4+"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J7[01]0(?:FN|MN|[8FHKM])",
                model: "Galaxy J7"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J700P",
                model: "Galaxy J7 (2015)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:J700(?:T1|T)|J710GN|J7109)",
                model: "Galaxy J7 (2016)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:J730[K]|J727(?:R4|[AFSU]))(?:[);/ ]|$)",
                model: "Galaxy J7 (2017)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J737(?:R4|T1|VPP|[APSTUV])(?:[);/ ]|$)",
                model: "Galaxy J7 (2018)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-C710F",
                model: "Galaxy J7+ (C7)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G610[FMY]",
                model: "Galaxy J7 Prime"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G611(?:FF|MT|M)",
                model: "Galaxy J7 Prime 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G615F",
                model: "Galaxy J7 Max"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:S727VL|S737TL)",
                model: "Galaxy J7 Sky Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:J7 Pro|J730(?:GM|[FG]))",
                model: "Galaxy J7 Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J701[FM]",
                model: "Galaxy J7 Core"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J720[FM]",
                model: "Galaxy J7 Duo"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:S767VL|S757BL)",
                model: "Galaxy J7 Crown"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J727[PTV]",
                model: "Galaxy J7 V"
            },
            {
                regex: "SM-J7\\[7\\]",
                model: "Galaxy J7 7"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J810",
                model: "Galaxy J8"
            },
            {
                regex: "SM-J8 Plus",
                model: "Galaxy J8 Plus"
            },
            {
                regex: "SM-J8 Pro",
                model: "Galaxy J8 Pro"
            },
            {
                regex: "SM-J9\\[7\\] Prime",
                model: "Galaxy J9 7 Prime"
            },
            {
                regex: "SM-J9\\[8\\] Pro",
                model: "Galaxy J9 8 Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M015[FG]",
                model: "Galaxy M01"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M013F",
                model: "Galaxy M01 Core"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M017F",
                model: "Galaxy M01s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M025F",
                model: "Galaxy M02s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M105[FGMY]",
                model: "Galaxy M10"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M107F",
                model: "Galaxy M10s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M115[FM]",
                model: "Galaxy M11"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M127[FG]",
                model: "Galaxy M12"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:M205(?:[FGMN]|FN)|M20)(?:[);/ ]|$)",
                model: "Galaxy M20"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M215F",
                model: "Galaxy M21"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:M307(?:FN|[0F])|M30s)",
                model: "Galaxy M30s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M305?",
                model: "Galaxy M30"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M315F",
                model: "Galaxy M31"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M317F",
                model: "Galaxy M31s"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M405",
                model: "Galaxy M40"
            },
            {
                regex: "(?:SAMSUNG-)?SM-M515F",
                model: "Galaxy M51"
            },
            {
                regex: "(?:SAMSUNG-)?SM-W201([689])",
                model: "Galaxy W201$1"
            },
            {
                regex: "(?:SAMSUNG-)?SM-W2015",
                model: "Galaxy Golden 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G910S",
                model: "Galaxy Round"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:G550(?:FY|T[12]?)|S550TL|G55[01]0|G5520)",
                model: "Galaxy On5"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G5528",
                model: "Galaxy On5 (2016)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G600(?:FY|[0F])",
                model: "Galaxy On7"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G610[0KLS]",
                model: "Galaxy On7 (2016)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G611[FKLS]",
                model: "Galaxy On7 Prime"
            },
            {
                regex: "(?:SAMSUNG-)?SM-C500[0X]",
                model: "Galaxy C5"
            },
            {
                regex: "(?:SAMSUNG-)?SM-C501[08]",
                model: "Galaxy C5 Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-C700[0X]",
                model: "Galaxy C7"
            },
            {
                regex: "(?:SAMSUNG-)?SM-C701[08FX]",
                model: "Galaxy C7 Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-C710[08]",
                model: "Galaxy C8"
            },
            {
                regex: "(?:SAMSUNG-)?SM-C900[08FY]",
                model: "Galaxy C9 Pro"
            },
            {
                regex: "(?:SAMSUNG-)?SM-Z130H",
                model: "Galaxy Z1"
            },
            {
                regex: "(?:SAMSUNG-)?SM-Z200[FMY]",
                model: "Galaxy Z2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-Z300H",
                model: "Galaxy Z3"
            },
            {
                regex: "(?:SAMSUNG-)?SM-Z400[FY]",
                model: "Galaxy Z4"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:G150(?:N[0KLS])?|G155S)(?:[);/ ]|$)",
                model: "Galaxy Folder"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-G16(?:0N|[05]0?|5N))(?:[);/ ]|$)",
                model: "Galaxy Folder 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J321AZ(?:[);/ ]|$)",
                model: "Galaxy Sol"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J326AZ(?:[);/ ]|$)",
                model: "Galaxy Sol 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J336AZ(?:[);/ ]|$)",
                model: "Galaxy Sol 3"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J727AZ(?:[);/ ]|$)",
                model: "Galaxy Halo"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J327AZ",
                model: "Galaxy Amp Prime 2"
            },
            {
                regex: "(?:SAMSUNG-)?SM-J337AZ",
                model: "Galaxy Amp Prime 3 (2018)"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:F900[0FUW]|F907[BN])|SCV44",
                model: "Galaxy Fold",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-F916(?:U1|[0BNQUW])|SCG05",
                model: "Galaxy Z Fold 2 5G",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9060(?:[);/ ]|$)",
                model: "Galaxy Grand Neo",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9063",
                model: "Galaxy Grand Neo Duos",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9(?:080|128)",
                model: "Galaxy Grand",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9168",
                model: "Galaxy Grand Neo+",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I9082",
                model: "Galaxy Grand Duos",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?GT-N7000",
                model: "Galaxy Note",
                device: "phablet"
            },
            {
                regex: "(?:SC-01G|SCL24)(?:[);/ ]|$)",
                model: "Galaxy Note Edge",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-N935[FSLK](?:[);/ ]|$)",
                model: "Galaxy Note Fan Edition",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?(?:(?:GT-)?N7100|SCH-(?:I605|N719|R950)|SPH-L900)(?:[);/ ]|$)",
                model: "Galaxy Note II",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?GT-N7105",
                model: "Galaxy Note II LTE",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G710(?:2T|5[HL]|[25689KLS])?(?:[);/ ]|$)",
                model: "Galaxy Grand 2",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G720(?:AX|N0|[02])(?:[);/ ]|$)",
                model: "Galaxy Grand Max"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:G530(?:[689]W|[AF]Z|BT|MU|R[47]|[AFHMPTWY])|G531[FH]|S920L)(?:[);/ ]|$)",
                model: "Galaxy Grand Prime",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G531(?:BT|[MY])(?:[);/ ]|$)",
                model: "Galaxy Grand Prime VE Duos",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G532F(?:[);/ ]|$)",
                model: "Galaxy Grand Prime Plus",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G532MT(?:[);/ ]|$)",
                model: "Galaxy J2 Prime (TV)",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G532[MG](?:[);/ ]|$)",
                model: "Galaxy J2 Prime",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-N7502(?:[);/ ]|$)",
                model: "Galaxy Note 3 Neo Duos",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-N750[05LQ]?",
                model: "Galaxy Note 3 Neo",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-N9002(?:[);/ ]|$)",
                model: "Galaxy Note 3 Duos",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-9005(?:[);/ ]|$)",
                model: "Galaxy Note 3 LTE",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-N900(?:W8|[05689][VQ]?|[AKLPSTV])?|SCL22|SC-01F(?:[);/ ]|$))",
                model: "Galaxy Note 3",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-(?:N910|910U)|N9100(?:[);/ ]|$)",
                model: "Galaxy Note 4",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-N916[KLS]",
                model: "Galaxy Note 4 LTE",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-N915",
                model: "Galaxy Note 4 Edge",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-N920(?:R[467]|W8|[0ACFGIKLPSTVX])",
                model: "Galaxy Note 5",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-N9208",
                model: "Galaxy Note 5 Duos",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G750(?:8Q|[9AFH])",
                model: "Galaxy Mega 2",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I915[028]",
                model: "Galaxy Mega 5.8",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?GT-I920[05]",
                model: "Galaxy Mega 6.3",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?(?:SM-N930(?:R[467]|W8|[0AFKLPSTUVX])|SCV34)",
                model: "Galaxy Note 7",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG[- ])?SM-N950|SCV37|SC-01K",
                model: "Galaxy Note 8",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG[- ])?(?:SM-N960|SCV40|SC-01L)",
                model: "Galaxy Note 9",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG[- ])?SM-(?:N970(?:U1|W8|[089DFJKLSUWX])|N971N)",
                model: "Galaxy Note 10",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG[- ])?SM-N770[FX]",
                model: "Galaxy Note 10 Lite",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG[- ])?(?:SM-N975(?:U1|XU|[0CFUWX])|SM-N976[0BVNQU]|SC-01M|SCV45)",
                model: "Galaxy Note 10+",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG[- ])?(?:SM-N980(?:F/DS|F))",
                model: "Galaxy Note 20",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG[- ])?(?:SM-N981(?:B/DS|U1|[0BNUW]))",
                model: "Galaxy Note 20 5G",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG[- ])?(?:SM-N985(?:F/DS|F))",
                model: "Galaxy Note 20 Ultra",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG[- ])?(?:SM-N986(?:B/DS|U1|[0BNUW])|SC-53A|SCG06)",
                model: "Galaxy Note 20 Ultra 5G",
                device: "phablet"
            },
            {
                regex: "(?:SAMSUNG-)?SM-W750V",
                model: "Ativ SE"
            },
            {
                regex: "(?:SAMSUNG-)?SM-G310R5",
                model: "GreatCall Touch 3"
            },
            {
                regex: "(?:SAMSUNG-)?GT-E2152",
                model: "E2152",
                device: "feature phone"
            },
            {
                regex: "(?:SAMSUNG-)?(GT-(P|N8|N5)[0-9]+[a-z]?)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "SC-02C",
                model: "Galaxy S II"
            },
            {
                regex: "(?:SAMSUNG-)?((?:SM-[TNP]|GT-P)[a-z0-9_\\-]+)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "((?:SCH|SGH|SPH|SHV|SHW|GT|SM)-[a-z0-9_\\-]+)",
                model: "$1"
            },
            {
                regex: "SMART-TV",
                device: "tv",
                model: "Smart TV"
            },
            {
                regex: "Galaxy ([^/;]+) Build",
                model: "Galaxy $1"
            },
            {
                regex: "Galaxy ([a-z0-9]+)",
                model: "Galaxy $1"
            },
            {
                regex: "SAMSUNG[\\-][ ]?([a-z0-9]+[\\-_][a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "SAMSUNG;[ ]?([a-z0-9]+[\\-_][a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "SAMSUNG[ _/\\-]?([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "SAMSUNG;[ ]?([a-z0-9 ]+)",
                model: "$1"
            },
            {
                regex: "SEC-([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "SAM-([a-z0-9]+)",
                model: "SCH-$1"
            },
            {
                regex: "(?:portalmmm|o2imode)/2\\.0 ([SZ][a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "sam([rua][0-9]+)",
                model: "SCH-$1"
            }
        ]
    },
    Sanei: {
        regex: "(?:8312D|G(60[25]|70[3568]G?|785|803)|N83(?:-2cpu)?|N91) Build",
        device: "smartphone",
        models: [
            {
                regex: "N83",
                model: "N83"
            },
            {
                regex: "N91",
                model: "N91"
            },
            {
                regex: "8312D",
                model: "G101"
            },
            {
                regex: "G(60[25]|70[3568]G?|785|803)",
                model: "G$1"
            }
        ]
    },
    Selfix: {
        regex: "SELFIX",
        device: "smartphone",
        models: [
            {
                regex: "SELFIX_SLASH6",
                model: "Slash 6"
            },
            {
                regex: "VOYAGER-V45",
                model: "Voyager V45"
            }
        ]
    },
    Sencor: {
        regex: "Sencor|ELEMENT[ _]?(?:7|8|9\\.7|10[ _]1)(?:[ _]?V[23])?(?:[);/ ]|$)|ELEMENT[ _]?(?:P[0-9]+|10.1 Q001)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(?:SENCOR[ _])?Element (10\\.1) (Q001)",
                model: 'Element $1" $2'
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V3",
                model: "Element 7 V3"
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V2[ _]BASIC",
                model: "Element 7 V2 Basic"
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT[ _]?7[ _]?V2",
                model: "Element 7 V2"
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT[ _]8[ _]?V3",
                model: "Element 8 V3"
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT[ _]8[ _]?V2",
                model: "Element 8 V2"
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT8",
                model: "Element 8"
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT[ _]9\\.7[ _]?V3",
                model: "Element 9.7 V3"
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT[ _]9\\.7[ _]?V2",
                model: "Element 9.7 V2"
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT[ _]9\\.7",
                model: "Element 9.7"
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT10[ _]1",
                model: "Element 10.1"
            },
            {
                regex: "(?:SENCOR[ _])?(7Q105)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(?:SENCOR[ _])?ELEMENT[ _]?P([0-9]+)",
                model: "Element P$1",
                device: "smartphone"
            },
            {
                regex: "Sencor[ _]([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    Senwa: {
        regex: "Senwa|(?:S\\-?(?:471|7[12]5|6[01]5|915|905TL|1000|5018)|V705B|LS50F| LS50?|LS5518H|LS5718)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "S-?471(?:[);/ ]|$)",
                model: "Jazz"
            },
            {
                regex: "S-?605(?:[);/ ]|$)",
                model: "City"
            },
            {
                regex: "S-?905TL(?:[);/ ]|$)",
                model: "Odin"
            },
            {
                regex: "S-?1000(?:[);/ ]|$)",
                model: "Odin"
            },
            {
                regex: "S-?5018(?:[);/ ]|$)",
                model: "Inizio"
            },
            {
                regex: "S-?(615|7[12]5|915)(?:[);/ ]|$)",
                model: "S$1"
            },
            {
                regex: "V705B(?:[);/ ]|$)",
                model: "V705B"
            },
            {
                regex: "LS50F(?:[);/ ]|$)",
                model: "Evolution"
            },
            {
                regex: " LS50(?:[);/ ]|$)",
                model: "Pegasus"
            },
            {
                regex: " LS5(?:[);/ ]|$)",
                model: "Thor"
            },
            {
                regex: "LS5518H(?:[);/ ]|$)",
                model: "Sparkly"
            },
            {
                regex: "LS5718(?:[);/ ]|$)",
                model: "Diamond"
            },
            {
                regex: "Senwa[ _-]*([^;/]+)(?: Build|[;)])",
                model: "$1"
            }
        ]
    },
    Sky: {
        regex: "(?:SKY|Elite|Fuego)[_ ][3-7]\\.[05](?:[A-Z]{1,2})?|Elite[ _](?:5_0T|M45|[45]T|45T|GO|M5Plus|T55|T[46]|[AB]5|5_5_Octa)|Platinum[_ ](?:5.0M|5\\.5C|5\\.0+|M5|[ABCM]4|[ACG]55|[ABDEFG]5|A57|P9|X|UNO|VIEW2|O|4\\.0|4_0Plus)|PLATINUMVIEW|SKY[ _](?:55M|Pro_III)",
        device: "smartphone",
        models: [
            {
                regex: "Platinum[_ ](?:5\\.0M|M5)",
                model: "Platinum 5.0M"
            },
            {
                regex: "Platinum[_ ]5\\.5C",
                model: "Platinum 5.5C"
            },
            {
                regex: "Platinum[_ ]5\\.0\\+",
                model: "Platinum 5.0 Plus"
            },
            {
                regex: "Platinum_4_0Plus",
                model: "Platinum 4.0 Plus"
            },
            {
                regex: "Platinum[ _]4\\.0",
                model: "Platinum 4.0"
            },
            {
                regex: "Platinum[_ ](P9) Pro(?:[);/ ]|$)",
                model: "Platinum $1 Pro"
            },
            {
                regex: "Platinum[_ ]([ABCM]4|[ACG]55|[ABDEFG]5|A57|P9|X|UNO|O)(?:[);/ ]|$)",
                model: "Platinum $1"
            },
            {
                regex: "Platinum[_ ]?VIEW(2)?(?:[);/ ]|$)",
                device: "tablet",
                model: "Platinum View$1"
            },
            {
                regex: "Elite_5_5_Octa",
                model: "Elite 5.5 Octa"
            },
            {
                regex: "Elite M5Plus",
                model: "Elite M5 Plus"
            },
            {
                regex: "Elite[ _](M45|Go|[45]T|T[46]|T55|[AB]5|A55|45T)(?:[);/ ]|$)",
                model: "Elite $1"
            },
            {
                regex: "Elite[_ ]([3-7])[\\._]([05](?:[A-Z]{1,2})?\\+?)",
                model: "Elite $1.$2"
            },
            {
                regex: "Fuego[_ ]([3-7]\\.[05](?:[A-Z]{1,2})?\\+?)",
                model: "Fuego $1"
            },
            {
                regex: "SKY_Pro_III",
                model: "Pro III"
            },
            {
                regex: "SKY 55M",
                model: "55M"
            },
            {
                regex: "SKY[_ ]([3-7]\\.[05](?:[A-Z]{1,2})?)",
                model: "$1"
            }
        ]
    },
    Skyworth: {
        regex: "Sky_?worth",
        device: "tv",
        models: [
            {
                regex: "Sky_?worth ([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    Smartfren: {
        regex: "Smartfren|Androtab|Andromax|PD6D1J|AD682J|AD68[89]G|AD6B1H|AD9A1H|AD682H|AD683G",
        device: "smartphone",
        models: [
            {
                regex: "S7 Build",
                model: "Andromax Tab 7.0",
                device: "tablet"
            },
            {
                regex: "PD6D1J",
                model: "Andromax V3s"
            },
            {
                regex: "AD682J",
                model: "Andromax T"
            },
            {
                regex: "AD688G",
                model: "Andromax C2"
            },
            {
                regex: "AD689G",
                model: "Andromax i3"
            },
            {
                regex: "AD682H",
                model: "Andromax i3s"
            },
            {
                regex: "AD6B1H",
                model: "Andromax G2 Hot"
            },
            {
                regex: "AD9A1H",
                model: "Andromax G2"
            },
            {
                regex: "AD683G",
                model: "Andromax I"
            },
            {
                regex: "New Andromax-i",
                model: "New Andromax I"
            },
            {
                regex: "Andromax[ _\\-]([^/;]+) Build",
                model: "Andromax $1"
            },
            {
                regex: "Andromax[ _\\-]([a-z0-9]+)",
                model: "Andromax $1"
            },
            {
                regex: "Smartfren[ _\\-]([^/;\\)]+)(?: Build|[/;\\)])",
                model: "$1"
            },
            {
                regex: "(Androtab[^/;]+) Build",
                model: "$1",
                device: "tablet"
            }
        ]
    },
    Smartisan: {
        regex: "(SM(?:70[15]|[89]01|919)|OD10[35]|YQ60[1357]|DE106|DT1901A|O[CE]106|OS103|O[CS]105)[ /;\\)]",
        device: "smartphone",
        models: [
            {
                regex: "SM70[15]",
                model: "T1"
            },
            {
                regex: "SM801",
                model: "T2"
            },
            {
                regex: "SM901",
                model: "M1"
            },
            {
                regex: "SM919",
                model: "M1L"
            },
            {
                regex: "YQ60[1357]",
                model: "U1"
            },
            {
                regex: "OD10[35]",
                model: "Pro"
            },
            {
                regex: "OS105[ /;\\)]",
                model: "Pro 2"
            },
            {
                regex: "DE106[ /;\\)]",
                model: "R1"
            },
            {
                regex: "OE106[ /;\\)]",
                model: "Nut Pro 2s"
            },
            {
                regex: "OC10[56][ /;\\)]",
                model: "Nut 3"
            },
            {
                regex: "DT1901A[ /;\\)]",
                model: "Nut Pro 3"
            },
            {
                regex: "OS103[ /;\\)]",
                model: "JianGuo Pro 2"
            }
        ]
    },
    "STF Mobile": {
        regex: "(?:Fractal|AERIAL PLUS|Origins Pro|BLOCK_MINI|BLOCK GO|BLOCK 3|SLAY II)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Fractal",
                model: "Fractal"
            },
            {
                regex: "Origins Pro",
                model: "Origins Pro"
            },
            {
                regex: "AERIAL PLUS",
                model: "Aerial Plus"
            },
            {
                regex: "BLOCK_MINI",
                model: "Block Mini"
            },
            {
                regex: "BLOCK 3 mini",
                model: "Block 3 Mini"
            },
            {
                regex: "BLOCK 3",
                model: "Block 3"
            },
            {
                regex: "BLOCK GO",
                model: "Block Go"
            },
            {
                regex: "SLAY II",
                model: "Slay II"
            }
        ]
    },
    STK: {
        regex: "STK[_ ]",
        device: "smartphone",
        models: [
            {
                regex: "STK[_ ]([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "STK[_ ]([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Stonex: {
        regex: "STX[ -]([^;/]+)|STONE EVO",
        device: "smartphone",
        models: [
            {
                regex: "STX[ -]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "STX[ -]([a-z0-9_-]+)",
                model: "$1"
            }
        ]
    },
    SuperSonic: {
        regex: "(SC-[0-9]+[a-z]+)",
        device: "tablet",
        model: "$1"
    },
    Supra: {
        regex: "SUPRA|NVTAB 7.0 3G",
        device: "smartphone",
        models: [
            {
                regex: "SUPRA[ _]([^;/)]+)(?: Build|[;)])",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "(NVTAB 7.0 3G)",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    Sumvision: {
        regex: "(Cyclone [^/;]+) Build",
        device: "tablet",
        model: "$1"
    },
    SunVan: {
        regex: "SUNVAN[ _\\-]",
        device: "smartphone",
        models: [
            {
                regex: "SUNVAN[ _\\-]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "SUNVAN[ _\\-]?([^);/ ]+)",
                model: "$1"
            }
        ]
    },
    SWISSMOBILITY: {
        regex: "(?:SCHR9GR|PRA(?:U8|100)|ZUR(?:722M|70016W?|700[RW]|805A))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "SCHR9GR",
                model: "SCHON R9"
            },
            {
                regex: "PRA(U8|100)",
                model: "PRA$1"
            },
            {
                regex: "ZUR722M",
                device: "phablet",
                model: "Z72 go"
            },
            {
                regex: "ZUR(70016W?|700[RW]|805A)(?:[);/ ]|$)",
                device: "tablet",
                model: "ZUR$1"
            }
        ]
    },
    Thomson: {
        regex: "(?:Primo(7|8)|QM73[45]-8G|QM734-2|QM736-8G\\(HD\\)|(?<!\\.)8950|MID1002|5014G|TEO7RK|Friendly_TH101|Delight TH201)(?:[);/ ]|$)|(?:Tlink|Every)[0-9]+|THOMSON,",
        device: "tablet",
        models: [
            {
                regex: "Primo(7|8)",
                model: "Primo $1"
            },
            {
                regex: "QM734-2",
                model: "QM734-2"
            },
            {
                regex: "QM734-8G",
                model: "QM734-8G"
            },
            {
                regex: "QM735-8G",
                model: "QM735-8G"
            },
            {
                regex: "QM736-8G\\(HD\\)",
                model: "QM736-8G (HD)"
            },
            {
                regex: "(?<!\\.)8950(?:[);/ ]|$)",
                model: "3G 8950"
            },
            {
                regex: "TEO7RK(?:[);/ ]|$)",
                model: "TEO7RK"
            },
            {
                regex: "5014G(?:[);/ ]|$)",
                device: "smartphone",
                model: "5014G"
            },
            {
                regex: "Tlink([0-9]+)",
                device: "smartphone",
                model: "Tlink$1"
            },
            {
                regex: "Every([0-9]+)",
                device: "smartphone",
                model: "Every$1"
            },
            {
                regex: "Delight TH201",
                device: "smartphone",
                model: "Delight TH201"
            },
            {
                regex: "Friendly_TH101",
                device: "smartphone",
                model: "Friendly TH101"
            },
            {
                regex: "((?:49|55)UC6306|55UC63|32HD55|40FD54|55UD63)",
                device: "tv",
                model: "$1"
            }
        ]
    },
    Tanix: {
        regex: "TX5 MAX(?:[);/ ]|$)",
        device: "tv",
        model: "TX5 Max"
    },
    Pantech: {
        regex: "Pantech|P[GN]-|PT-[a-z0-9]{3,}|(?<!Winmax )TX[T]?[0-9]+|IM-[a-z0-9]+(?:[);/ ]|$)|ADR910L",
        device: "smartphone",
        models: [
            {
                regex: "ADR910L",
                model: "Star Q"
            },
            {
                regex: "IM-A870K",
                model: "Vega Iron"
            },
            {
                regex: "Pantech[ \\-]?([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "Pantech_([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "(P[GTN]-[a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(TX[T]?[0-9]+)",
                model: "$1"
            },
            {
                regex: "(IM-[a-z0-9]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Ployer: {
        regex: "MOMO([0-9]|[ ]?mini[ ]?(?:S|3GS)?)",
        device: "tablet",
        models: [
            {
                regex: "MOMOminiS",
                model: "MOMO mini S"
            },
            {
                regex: "momo mini 3GS",
                model: "MOMO Mini 3GS"
            },
            {
                regex: "MOMO([0-9][^);/]*) Build",
                model: "MOMO $1"
            },
            {
                regex: "MOMO([0-9][^);/]*)(?:[);/]|$)",
                model: "MOMO $1"
            }
        ]
    },
    Plum: {
        regex: "PLUM[ _]",
        device: "smartphone",
        models: [
            {
                regex: "Z405",
                model: "Gator 3"
            },
            {
                regex: "Z407",
                model: "Axe 4"
            },
            {
                regex: "Z516",
                model: "Compass"
            },
            {
                regex: "Z811",
                device: "tablet",
                model: "Optimax 11"
            },
            {
                regex: "Z709",
                device: "tablet",
                model: "Optimax 7"
            },
            {
                regex: "Z712",
                device: "tablet",
                model: "Optimax 12"
            }
        ]
    },
    Polaroid: {
        regex: "Polaroid|(?:PMID|MIDC)[0-9a-z]+(?:[);/ ]|$)|MID(?:1014|0714)|PRO[VG]?(?:[0-9]{3,}[a-z]*|[0-9]{2}[a-z])|(?:P(?:400[56]|4526|500[56]|502[56]|504[67]|552[56])A|P902/A900|PSPC(?:505|550|[MZL]20A0|K2[01]NA)|SIGMA 5|MIDS145PXE|MIDS747PX|MID4004JBL|MIDS185PR|PSPTD21NA)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "P4005A",
                model: "Turbo C4"
            },
            {
                regex: "P5005A",
                model: "Turbo C5"
            },
            {
                regex: "P4006A",
                model: "Turbo D4"
            },
            {
                regex: "PSPTD21NA",
                model: "Turbo D2 Plus"
            },
            {
                regex: "P4526A",
                model: "Turbo E"
            },
            {
                regex: "PSPC(505|550)",
                model: "Cosmo $1"
            },
            {
                regex: "P5006A",
                model: "Cosmo K"
            },
            {
                regex: "P5526A",
                model: "Cosmo K Plus"
            },
            {
                regex: "PSPCK20NA",
                model: "Cosmo K2"
            },
            {
                regex: "PSPCK21NA",
                model: "Cosmo K2 Plus"
            },
            {
                regex: "P5026A",
                model: "Cosmo L"
            },
            {
                regex: "PSPCL20A0",
                model: "Cosmo L2"
            },
            {
                regex: "PSPCM20A0",
                model: "Cosmo M2"
            },
            {
                regex: "P5046A",
                model: "Cosmo P5s"
            },
            {
                regex: "P5525A",
                model: "Cosmo Q5s"
            },
            {
                regex: "P5047A",
                model: "Cosmo Z"
            },
            {
                regex: "PSPCZ20A0",
                model: "Cosmo Z2"
            },
            {
                regex: "P5025A",
                model: "L5s"
            },
            {
                regex: "PRO4611(?:PR201)?",
                model: "Pro4611"
            },
            {
                regex: "PROV400",
                model: "Agate"
            },
            {
                regex: "PROV350",
                model: "ProV350"
            },
            {
                regex: "SIGMA 5(?:[);/ ]|$)",
                model: "Sigma 5"
            },
            {
                regex: "PRO([VG]?(?:[0-9]{3,}[a-z]*|[0-9]{2}[a-z]))",
                model: "Pro$1"
            },
            {
                regex: "PSPT350",
                model: "Turbo 350 Gris"
            },
            {
                regex: "MIDS185PR",
                model: 'Pure 10.1"'
            },
            {
                regex: "(MID(?:1014|0714|S145PXE|S747PX|4004JBL))",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "((?:PMID|MIDC)[0-9a-z]+)(?:[);/ ]|$)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "(P902/A900)(?:[);/ ]|$)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Polaroid",
                model: "",
                device: "tablet"
            }
        ]
    },
    PolyPad: {
        regex: "POLY ?PAD",
        device: "tablet",
        models: [
            {
                regex: "POLY ?PAD[_ \\.]([a-z0-9]+)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "POLY ?PAD[_\\.]([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Polytron: {
        regex: "POLYTRON|W8480|W7430|PW1100S|W7550|W7531|W8570|R2401",
        device: "smartphone",
        models: [
            {
                regex: "R2508",
                model: "Rocket"
            },
            {
                regex: "POLYTRON[ _]R1500",
                model: "Rocket Q-Five"
            },
            {
                regex: "R2401",
                model: "Rocket 2X"
            },
            {
                regex: "POLYTRON[ _-]R2402",
                model: "Rocket R2402"
            },
            {
                regex: "POLYTRON[ _-]R2403",
                model: "Rocket R1"
            },
            {
                regex: "POLYTRON[ _-]R2406",
                model: "Rocket R2"
            },
            {
                regex: "POLYTRON[ _-]R2407",
                model: "Rocket R3"
            },
            {
                regex: "POLYTRON[ _-]R2452",
                model: "Rocket S1"
            },
            {
                regex: "POLYTRON[ _-]R2457",
                model: "Rocket S2"
            },
            {
                regex: "POLYTRON[ _-]R2501",
                model: "Rocket T1"
            },
            {
                regex: "POLYTRON[ _-]R2507",
                model: "Rocket T3"
            },
            {
                regex: "POLYTRON[ _-]R2509SE",
                model: "Rocket T6 SE"
            },
            {
                regex: "POLYTRON[ _-]R2509",
                model: "Rocket T6"
            },
            {
                regex: "POLYTRON[ _-]R250A",
                model: "Rocket T7"
            },
            {
                regex: "POLYTRON[ _-]R2506",
                model: "Rocket T4"
            },
            {
                regex: "POLYTRON[ _-](?:R3450|W1400)",
                model: "Rocket Jetz"
            },
            {
                regex: "POLYTRON[ _-]R3500",
                model: "Rocket Jetz 5.0"
            },
            {
                regex: "4G450",
                model: "Zap 5"
            },
            {
                regex: "W6500",
                model: "Quadra Rocket"
            },
            {
                regex: "W7452",
                model: "Quadra S2"
            },
            {
                regex: "W7550",
                model: "Quadra V5"
            },
            {
                regex: "W8570",
                model: "Quadra V7"
            },
            {
                regex: "POLYTRON[ _]L501",
                model: "Rocket L501"
            },
            {
                regex: "POLYTRON[ _]P520",
                model: "Prime 7S"
            },
            {
                regex: "POLYTRON[ _]P552",
                model: "Prime 7 Pro"
            },
            {
                regex: "4G500",
                model: "Zap 6 Cleo"
            },
            {
                regex: "W8480",
                model: "Crystal 4 W8480"
            },
            {
                regex: "W7531",
                model: "Wizard V"
            },
            {
                regex: "W7430",
                model: "Quadra Mini W7430"
            },
            {
                regex: "POLYTRON[ _]4G501",
                model: "Zap 6 Posh"
            },
            {
                regex: "POLYTRON[ _]4G502",
                model: "Zap 6 Power"
            },
            {
                regex: "POLYTRON[ _]4G503",
                model: "Zap 6 Flaz"
            },
            {
                regex: "POLYTRON[_ ]?[ _]4G550",
                model: "Zap 6 Note"
            },
            {
                regex: "POLYTRON[ _]4G551",
                model: "Zap 6 Posh Note"
            },
            {
                regex: "PW1100S",
                model: "PW1100S"
            },
            {
                regex: "Q2352",
                model: "Q2352"
            },
            {
                regex: "POLYTRON[ _]T7800",
                model: "Cosmica T7800",
                device: "tablet"
            },
            {
                regex: "POLYTRON[ _]T7700",
                model: "Rocket Pad",
                device: "tablet"
            }
        ]
    },
    Positivo: {
        regex: "YPY_S450",
        device: "smartphone",
        models: [
            {
                regex: "YPY_S450",
                model: "YPY S450"
            }
        ]
    },
    Prestigio: {
        regex: "Prestigio 5500 DUO|(?:PMP|PAP|PMT|PSP|PGPS)[0-9]+[a-z0-9_]+(?:[);/ ]|$)|Muze C3",
        device: "tablet",
        models: [
            {
                regex: "PMT3277_3G",
                model: "MultiPad Ranger 7.0 3G"
            },
            {
                regex: "PGPS7799CIS08GBPG(?:[);/ ]|$)",
                model: "Geo Vision Tour 3"
            },
            {
                regex: "PGPS7797(?:[);/ ]|$)",
                model: "Geo Vision Tour 2"
            },
            {
                regex: "PMT3201_4G",
                model: "Grace 4G"
            },
            {
                regex: "PSP5551DUO",
                model: "Grace S5"
            },
            {
                regex: "PMT3287_3G",
                model: "MultiPad Ranger 8.0 3G"
            },
            {
                regex: "Prestigio 5500 DUO",
                model: "MultiPhone 5500 Duo",
                device: "smartphone"
            },
            {
                regex: "PMT3208[_ ]3G",
                model: "MultiPad Wize 8.0 3G"
            },
            {
                regex: "PSP7546DUO([ _][A-Z]{2})?",
                model: "X Pro"
            },
            {
                regex: "PSP7610DUO([ _][A-Z]{2})?",
                model: "S Max"
            },
            {
                regex: "(PM[PT][0-9]+[a-z0-9_]+)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "((?:PAP|PSP)[0-9]+[a-z0-9_]+(?: DUO)?)(?:[);/ ]|$)",
                model: "$1",
                device: "smartphone"
            },
            {
                regex: "Muze C3(?:[);/ ]|$)",
                model: "Muze C3",
                device: "smartphone"
            }
        ]
    },
    Sanyo: {
        regex: "Sanyo|MobilePhone[ ;]",
        device: "feature phone",
        models: [
            {
                regex: "SCP-?6750",
                model: "Katana Eclipse X"
            },
            {
                regex: "SCP-?6760",
                model: "Incognito"
            },
            {
                regex: "SCP-?6780",
                model: "Innuendo"
            },
            {
                regex: "SANYO[ /_-]([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "MobilePhone ([a-z0-9\\-]+)",
                model: "$1"
            }
        ]
    },
    Qilive: {
        regex: "Qilive [0-9][^;/]*|Q(7S5[5]?IN4G|7T10INP|8T10IN|8S55IN4G2|8S[56]IN4G|9T9IN|9T(?:7|10)IN4G|9S55IN4G|10S5[37]IN4G|10S[56]IN4G|10S[56]IN4GR|9S5IN4G|6T7IN)",
        device: "smartphone",
        models: [
            {
                regex: "Q7S5IN4G",
                model: 'Q7 5.0" 4G'
            },
            {
                regex: "Q7S55IN4G",
                model: 'Q7 5.5" 4G'
            },
            {
                regex: "Q8S55IN4G2",
                model: 'Q8 5.5" 4G'
            },
            {
                regex: "Q8S6IN4G",
                model: 'Q8 6.0" 4G'
            },
            {
                regex: "Q8S5IN4GP",
                model: 'Q8 5.1" 4G'
            },
            {
                regex: "Q9S5IN4G",
                model: 'Q9 5.0" 4G'
            },
            {
                regex: "Q9S55IN4G",
                model: 'Q9 5.5" 4G'
            },
            {
                regex: "Q10S53IN4G",
                model: 'Q10 5.3" 4G'
            },
            {
                regex: "Q10S57IN4G",
                model: 'Q10 5.7" 4G'
            },
            {
                regex: "Q10S5IN4G[R]?",
                model: 'Q10 5.0" 4G'
            },
            {
                regex: "Q10S6IN4G",
                model: 'Q10 6.0" 4G'
            },
            {
                regex: "Q6T7IN",
                model: "Q6",
                device: "tablet"
            },
            {
                regex: "Q7T10INP",
                model: 'Q7 10.1"',
                device: "tablet"
            },
            {
                regex: "Q8T10IN",
                model: 'Q8 10.1"',
                device: "tablet"
            },
            {
                regex: "Q9T7IN4G",
                model: 'Q9 7.0" 4G',
                device: "tablet"
            },
            {
                regex: "Q9T9IN",
                model: 'Q9 9.0"',
                device: "tablet"
            },
            {
                regex: "Q9T10IN4G",
                model: 'Q9 10.1" 4G',
                device: "tablet"
            },
            {
                regex: "Qilive ([0-5][^;/]*) Build",
                model: "$1"
            },
            {
                regex: "Qilive ([0-5][^;/]*)/",
                model: "$1"
            },
            {
                regex: "Qilive ([6-9][^;/]*) Build",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Qilive ([6-9][^;/]*)/",
                model: "$1",
                device: "tablet"
            }
        ]
    },
    QMobile: {
        regex: "QMobile|QTab(?!10EW)|Q-Smart|(?:E2 Noir|Noir X1S|LUNA PRO|NICE S|JazzX JS(?:[27]|10)(?: PRO)?|LT[57]00 PRO|LT950|Q Infinity|Hot Pro 2)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "JazzX JS7 PRO",
                model: "Jazz X JS7 Pro"
            },
            {
                regex: "JazzX JS(2|10)",
                model: "Jazz X JS$1"
            },
            {
                regex: "Noir X1S",
                model: "Noir X1S"
            },
            {
                regex: "E2 Noir",
                model: "E2 Noir"
            },
            {
                regex: "Hot Pro 2",
                model: "Hot Pro 2"
            },
            {
                regex: "LT([57]00) PRO",
                model: "Noir LT$1 Pro"
            },
            {
                regex: "LUNA PRO",
                model: "Luna Pro"
            },
            {
                regex: "NICE S",
                model: "Nice S"
            },
            {
                regex: "Q Infinity PRO",
                model: "Q Infinity Pro"
            },
            {
                regex: "Q Infinity E Lite",
                model: "Q Infinity E Lite"
            },
            {
                regex: "Q Infinity ([FCB])",
                model: "Q Infinity $1"
            },
            {
                regex: "(LT950)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "QTab[ _-]([^;/]+) Build",
                model: "$1 Tab",
                device: "tablet"
            },
            {
                regex: "QTab[ _-]([^;/)]+)(?:[;/)]|$)",
                model: "$1 Tab",
                device: "tablet"
            },
            {
                regex: "(?:QMobile|Q-Smart)[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "(?:QMobile|Q-Smart)[ _-]([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            },
            {
                regex: "Q Infinity",
                model: "Q Infinity"
            }
        ]
    },
    Maximus: {
        regex: "Maximus[ _]|(Noir X)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:Maximus[ _])?(Noir X|D1)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Maximus_(T2)",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    Quantum: {
        regex: "Quantum (?:Fit|MUV (?:PRO|UP)|Go|Mini|V|You [2E])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Quantum (Fit|Go|Mini|V|You [2E])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Quantum MUV PRO(?:[);/ ]|$)",
                model: "MUV Pro"
            },
            {
                regex: "Quantum MUV UP(?:[);/ ]|$)",
                model: "MUV Up"
            }
        ]
    },
    Quechua: {
        regex: "Quechua Phone 5",
        device: "smartphone",
        model: "Quechua Phone 5"
    },
    Ramos: {
        regex: "Ramos ?([^/;]+) Build|MOS1(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(MOS1)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Ramos ?([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    Razer: {
        regex: "Phone 2",
        device: "smartphone",
        model: "Phone 2"
    },
    Sendo: {
        regex: "Sendo([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    "Turbo-X": {
        regex: "Turbo-X|Hive V 3G|Turbox_S3",
        device: "smartphone",
        models: [
            {
                regex: "Turbox_S3",
                model: "S3"
            },
            {
                regex: "Turbo-X_A2(?:[);/ ]|$)",
                model: "A2"
            },
            {
                regex: "Turbo-X_e3(?:[);/ ]|$)",
                model: "E3"
            },
            {
                regex: "Turbo-X Ice(?:[);/ ]|$)",
                device: "tablet",
                model: "Ice"
            },
            {
                regex: "Hive V 3G(?:[);/ ]|$)",
                device: "tablet",
                model: "Hive V 3G"
            },
            {
                regex: "Turbo-X Tablet([^;/]+) Build",
                device: "tablet",
                model: "Tablet$1"
            },
            {
                regex: "Turbo-X ([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    Turbo: {
        regex: "Turbo[_ ]?(?:X5[_ ]?(?:Max|Black|Space|Hero)|X8|X6[ _]Z|X[ _]Ray)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "TurboX5Space(?:[);/ ]|$)",
                model: "X5 Space"
            },
            {
                regex: "TurboX5Hero(?:[);/ ]|$)",
                model: "X5 Hero"
            },
            {
                regex: "TurboX[ _]Ray(?:[);/ ]|$)",
                model: "X Ray"
            },
            {
                regex: "Turbo[ _]?X5[ _]?Black(?:[);/ ]|$)",
                model: "X5 Black"
            },
            {
                regex: "Turbo[ _]X5[ _]Max(?:[);/ ]|$)",
                model: "X5 Max"
            },
            {
                regex: "Turbo[ _]X6[ _]Z(?:[);/ ]|$)",
                model: "X6 Z"
            },
            {
                regex: "Turbo[ _]X8(?:[);/ ]|$)",
                model: "X8"
            }
        ]
    },
    "Silent Circle": {
        regex: "Blackphone 2",
        device: "smartphone",
        model: "Blackphone 2"
    },
    Sigma: {
        regex: "Sigma(?!Designs)|(X[_-]Style[ _]?Tab[_ ]A([0-9]{2,3})|X[-_ ]?treme[-_ ]?PQ[0-9]{2}|X-Style_S5501)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:Sigma[ _])?X[-_ ]?treme[-_ ]?PQ([0-9]{2})(?:[);/ ]|$)",
                model: "X-Treme PQ$1"
            },
            {
                regex: "X[_-]Style[ _]?Tab[_ ]A([0-9]{2,3})(?:[);/ ]|$)",
                model: "X-Style Tab A$1",
                device: "tablet"
            },
            {
                regex: "(?:Sigma[ _])?X[-_ ]?Style[-_ ]S([0-9]+)(?:[);/ ]|$)",
                model: "X-Style S$1"
            }
        ]
    },
    Spice: {
        regex: "(?<![\\d];)Spice",
        device: "smartphone",
        models: [
            {
                regex: "Spice[ _\\-]?([^/;]+)(?:[\\)]| Build)",
                model: "$1"
            },
            {
                regex: "Spice[ _\\-]?([^/;]+)(?:/|$)",
                model: "$1"
            }
        ]
    },
    Sharp: {
        regex: "SHARP|SBM|SH-?[0-9]+[a-z]?(?:[);/ ]|$)|AQUOS|(?:SH-M0[14-9]|SH-M1[1-6](?:-y)?|S[357]-SH|SH-[MZ](10|01)|SH-[CL]02|SH-RM(?:1[125]|02)|[34]04SH|401SH|[45]02SH|306SH|[36]05SH|70[1246]SH|80[138]SH|90[1678]SH|50[3679]SH|SHL2[25]|SHV4[0-8]|SHV3[1-9](?:[-_]u)?|FS80(?:1[08]|32|28|0[29])|TG-L900S|NP601SH|403SH|603SH|SHF3[134]|SHV4[035][-_]u|SW001SH|SHG0[123]|X4-SH|A002SH|SH-A01|DM-01J|SH-D01|A001SH|606SH|FS801[56]|d-41A|NP80[567]SH|NP501SH)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "506SH(?:[);/ ]|$)",
                model: "Aquos Xx3"
            },
            {
                regex: "603SH(?:[);/ ]|$)",
                model: "Aquos Xx3 Mini"
            },
            {
                regex: "50[23]SH(?:[);/ ]|$)",
                model: "Aquos Xx2"
            },
            {
                regex: "[34]04SH(?:[);/ ]|$)",
                model: "Aquos Xx"
            },
            {
                regex: "606SH(?:[);/ ]|$)",
                model: "Aquos ea"
            },
            {
                regex: "507SH(?:[);/ ]|$)",
                model: "Android One"
            },
            {
                regex: "S3-SH(?:[);/ ]|$)",
                model: "Android One S3"
            },
            {
                regex: "S5-SH(?:[);/ ]|$)",
                model: "Android One S5"
            },
            {
                regex: "S7-SH(?:[);/ ]|$)",
                model: "Android One S7"
            },
            {
                regex: "X4-SH(?:[);/ ]|$)",
                model: "Android One X4"
            },
            {
                regex: "SH-M04(?:[);/ ]|$)",
                model: "Aquos SH-M04"
            },
            {
                regex: "SH-M05(?:[);/ ]|$)",
                model: "Aquos Sense Lite"
            },
            {
                regex: "SH-M07(?:[);/ ]|$)",
                model: "Aquos Sense Plus"
            },
            {
                regex: "SHG03(?:[);/ ]|$)",
                model: "Aquos Sense 5G"
            },
            {
                regex: "SH-D01(?:[);/ ]|$)",
                model: "Aquos D10"
            },
            {
                regex: "SH-M12(?:-y)?(?:[);/ ]|$)",
                model: "Aquos S3 Dual SIM"
            },
            {
                regex: "(?:SH-[MZ]10|801SH)(?:[);/ ]|$)",
                model: "Aquos Zero"
            },
            {
                regex: "(?:SH-M13|906SH)(?:[);/ ]|$)",
                model: "Aquos Zero 2"
            },
            {
                regex: "(?:SHG02|A002SH)(?:[);/ ]|$)",
                model: "Aquos Zero 5G Basic"
            },
            {
                regex: "SH-Z01(?:[);/ ]|$)",
                model: "Aquos S2 (C10)"
            },
            {
                regex: "(?:SH-02E|SH-01[GH]|SH-04H)(?:[);/ ]|$)",
                model: "Aquos Phone Zeta"
            },
            {
                regex: "SH-?06D(?:[);/ ]|$)",
                model: "Aquos Phone SH-06D"
            },
            {
                regex: "(SHL2[25]|SH-M01)(?:[);/ ]|$)",
                model: "Aquos Phone $1"
            },
            {
                regex: "SH-L02(?:[);/ ]|$)",
                model: "Aquos L2"
            },
            {
                regex: "(?:605SH|SH-03J|SHV39)(?:[);/ ]|$)",
                model: "Aquos R"
            },
            {
                regex: "(?:605SH|SH-03J|SHV39)(?:[);/ ]|$)",
                model: "Aquos R"
            },
            {
                regex: "(?:701SH|SHV41|SH-M06)(?:[);/ ]|$)",
                model: "Aquos R Compact"
            },
            {
                regex: "(?:SH-M09|SHV42|706SH|SH-03K)(?:[);/ ]|$)",
                model: "Aquos R2"
            },
            {
                regex: "803SH(?:[);/ ]|$)",
                model: "Aquos R2 Compact"
            },
            {
                regex: "(?:908SH|SHG01|SH-M14)(?:[);/ ]|$)",
                model: "Aquos R5G"
            },
            {
                regex: "SH-M16(?:[);/ ]|$)",
                model: "Aquos S4 Plus"
            },
            {
                regex: "SH-M15(?:[);/ ]|$)",
                model: "Aquos S4 SIM"
            },
            {
                regex: "SH-C02(?:[);/ ]|$)",
                model: "Aquos V"
            },
            {
                regex: "(SHF3[134])(?:[);/ ]|$)",
                model: "Aquos K $1"
            },
            {
                regex: "704SH(?:[);/ ]|$)",
                model: "Simple Smartphone 4"
            },
            {
                regex: "(?:SH-02J|SH-04G)(?:[);/ ]|$)",
                model: "Aquos Ever"
            },
            {
                regex: "SH-02H(?:[);/ ]|$)",
                model: "Aquos Compact"
            },
            {
                regex: "30[56]SH(?:[);/ ]|$)",
                model: "Aquos Crystal"
            },
            {
                regex: "402SH(?:[);/ ]|$)",
                model: "Aquos Crystal X"
            },
            {
                regex: "403SH(?:[);/ ]|$)",
                model: "Aquos Crystal 2"
            },
            {
                regex: "509SH(?:[);/ ]|$)",
                model: "Aquos 3"
            },
            {
                regex: "NP601SH(?:[);/ ]|$)",
                model: "Aquos 2"
            },
            {
                regex: "(?:SHV40|SHV3[24])(?:_u)?(?:[);/ ]|$)",
                model: "Aquos S"
            },
            {
                regex: "702SH(?:[);/ ]|$)",
                model: "Aquos S Basic"
            },
            {
                regex: "SHV3[183](?:[);/ ]|$)",
                model: "Aquos S Mini"
            },
            {
                regex: "(?:FS8010|SH-M08|SHV43(?:-u)?|SH-01[KL])(?:[);/ ]|$)",
                model: "Aquos S2"
            },
            {
                regex: "FS8016(?:[);/ ]|$)",
                model: "Aquos S2 Plus"
            },
            {
                regex: "(?:SHV46|SH-R?M11|901SH)(?:[);/ ]|$)",
                model: "Aquos S3 Plus"
            },
            {
                regex: "(?:SHV44|808SH|SH-04L|SH-03G)(?:[);/ ]|$)",
                model: "Aquos R3"
            },
            {
                regex: "(?:FS8032|FS8015|SH-02M|SHV45(?:-U)?)(?:[);/ ]|$)",
                model: "Aquos S3"
            },
            {
                regex: "FS8018(?:[);/ ]|$)",
                model: "Aquos S3 Mini"
            },
            {
                regex: "(?:SHV48|907SH)(?:[);/ ]|$)",
                model: "Aquos S3 Basic"
            },
            {
                regex: "SH-RM12(?:[);/ ]|$)",
                model: "Aquos S3 Lite"
            },
            {
                regex: "SH-RM15(?:[);/ ]|$)",
                model: "Aquos S4 Lite"
            },
            {
                regex: "SH-51A(?:[);/ ]|$)",
                model: "Aquos R5G"
            },
            {
                regex: "SHV3[57](?:_u)?(?:[);/ ]|$)",
                model: "Aquos U"
            },
            {
                regex: "TG-L900S(?:[);/ ]|$)",
                model: "Luna S"
            },
            {
                regex: "SH-A01(?:[);/ ]|$)",
                model: "B10"
            },
            {
                regex: "(?:FS8002|SHV47)(?:[);/ ]|$)",
                model: "Z2"
            },
            {
                regex: "FS8009(?:[);/ ]|$)",
                model: "Z3"
            },
            {
                regex: "FS8028(?:[);/ ]|$)",
                model: "R1S"
            },
            {
                regex: "SHV36(?:[);/ ]|$)",
                model: "Basio 2"
            },
            {
                regex: "SW001SH(?:[);/ ]|$)",
                model: "Star Wars"
            },
            {
                regex: "SH-RM02",
                model: "Aquos SH-RM02"
            },
            {
                regex: "401SH",
                model: "Aquos 401SH"
            },
            {
                regex: "DM-01J",
                model: "Disney Mobile DM-01J"
            },
            {
                regex: "A001SH",
                model: "Simple Sumaho 5"
            },
            {
                regex: "NP80[56]SH",
                model: "Aquos Keitai 3"
            },
            {
                regex: "NP807SH",
                model: "Aquos Keitai 10"
            },
            {
                regex: "NP501SH",
                model: "Aquos Keitai"
            },
            {
                regex: "SH-08E(?:[);/ ]|$)",
                device: "tablet",
                model: "Sharp Aquos Pad"
            },
            {
                regex: "d-41A(?:[);/ ]|$)",
                device: "tablet",
                model: "dtab d-41A"
            },
            {
                regex: "(LC-(?:[0-9]{2})[a-z0-9]+)(?:[);/ ]|$)",
                device: "tv",
                model: "$1"
            },
            {
                regex: "SHARP-AQUOS|AQUOSBrowser",
                device: "tv",
                model: "Aquos Net Plus"
            },
            {
                regex: "SHARP[ \\-]([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "(?:SHARP|SBM)([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "(SH-?[0-9]+[a-z]?)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Simply: {
        regex: "(NP602SI)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Softbank: {
        regex: "Softbank|J-PHONE",
        device: "smartphone",
        models: [
            {
                regex: "Softbank/[12]\\.0/([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "([a-z0-9]+);Softbank;",
                model: "$1"
            },
            {
                regex: "J-PHONE/[0-9]\\.[0-9]/([a-z0-9\\-]+)",
                model: "$1"
            }
        ]
    },
    Sonim: {
        regex: "Sonim[ -]|XP(?:[67]7|88)00(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Sonim-XP3400",
                model: "XP3400",
                device: "feature phone"
            },
            {
                regex: "XP6700(?:[);/ ]|$)",
                model: "XP6700"
            },
            {
                regex: "XP7700(?:[);/ ]|$)",
                model: "XP7700"
            },
            {
                regex: "XP8800(?:[);/ ]|$)",
                model: "XP8"
            }
        ]
    },
    Star: {
        regex: "N(9[5678]00|8800|9000|9977)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "N9000",
                model: "Note 3"
            },
            {
                regex: "N(9[5678]00|8800|9977)(?:[);/ ]|$)",
                model: "N$1"
            }
        ]
    },
    Starmobile: {
        regex: "(?:Starmobile (?:Play (?:Neo|Spark|GO|Click))|UP[_ ](?:Sense|Rave|Groove|Prime|Selfie|Xtreme|XL))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Starmobile PLAY GO(?:[);/ ]|$)",
                model: "Play Go"
            },
            {
                regex: "Starmobile Play (Neo|Spark|Click)(?:[);/ ]|$)",
                model: "Play $1"
            },
            {
                regex: "UP[_ ](Sense|Rave|Groove|Prime|Selfie|Xtreme|XL)(?:[);/ ]|$)",
                model: "UP $1"
            }
        ]
    },
    Amazon: {
        regex: "KF(?:OT|ONWI|TT|JWI|JWA|[DFS]OWI|A[PRSU]WI|T[BH]WI|SAW[IA]|GIWI|KAWI|MAWI|MEWI|MUWI|SUWI)(?:[);/ ]|$)|Kindle|Silk/\\d+\\.\\d+|AlexaMediaPlayer|Amazon (?:Tate|Jem)|AFT[ABMNRST]|SD4930UR|AEO(BC|KN)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "AFTA",
                model: "Fire TV Cube (Gen 1)",
                device: "tv"
            },
            {
                regex: "AFTR",
                model: "Fire TV Cube (Gen 2)",
                device: "tv"
            },
            {
                regex: "AFTN",
                model: "Fire TV (Gen 3)",
                device: "tv"
            },
            {
                regex: "AFTB",
                model: "Fire TV",
                device: "tv"
            },
            {
                regex: "AFT[MST]",
                model: "Fire TV stick",
                device: "tv"
            },
            {
                regex: "KFFOWI(?:[);/ ]|$)",
                model: 'Fire 7"'
            },
            {
                regex: "KFMUWI(?:[);/ ]|$)",
                model: 'Fire 7" (2019)'
            },
            {
                regex: "KFTT(?:[);/ ]|$)",
                model: "Kindle Fire HD"
            },
            {
                regex: "KFJWI(?:[);/ ]|$)|Amazon Jem",
                model: 'Kindle Fire HD 8.9" WiFi'
            },
            {
                regex: "KFJWA(?:[);/ ]|$)",
                model: 'Kindle Fire HD 8.9" 4G'
            },
            {
                regex: "KFSOWI(?:[);/ ]|$)|Amazon Tate",
                model: 'Kindle Fire HD 7" WiFi'
            },
            {
                regex: "KFTHWI(?:[);/ ]|$)",
                model: 'Kindle Fire HDX 7" WiFi'
            },
            {
                regex: "KFTHWA(?:[);/ ]|$)",
                model: 'Kindle Fire HDX 7" 4G'
            },
            {
                regex: "KFAPWI(?:[);/ ]|$)",
                model: 'Kindle Fire HDX 8.9" WiFi'
            },
            {
                regex: "KFAPWA(?:[);/ ]|$)",
                model: 'Kindle Fire HDX 8.9" 4G'
            },
            {
                regex: "KFARWI(?:[);/ ]|$)",
                model: "Fire HD 6"
            },
            {
                regex: "KFASWI(?:[);/ ]|$)",
                model: "Fire HD 7"
            },
            {
                regex: "KFAUWI(?:[);/ ]|$)",
                model: "Fire HD 7 (2017)"
            },
            {
                regex: "KFMEWI(?:[);/ ]|$)",
                model: "Fire HD 8 (2015)"
            },
            {
                regex: "KFGIWI(?:[);/ ]|$)",
                model: "Fire HD 8 (2016)"
            },
            {
                regex: "KFDOWI(?:[);/ ]|$)",
                model: "Fire HD 8 (2017)"
            },
            {
                regex: "KFKAWI(?:[);/ ]|$)",
                model: "Fire HD 8 (2018)"
            },
            {
                regex: "KFONWI(?:[);/ ]|$)",
                model: "Fire HD 8 (2020)"
            },
            {
                regex: "KFSAWI(?:[);/ ]|$)",
                model: "Fire HDX 8.9"
            },
            {
                regex: "KFSAWA(?:[);/ ]|$)",
                model: "Fire HDX 8.9 4G"
            },
            {
                regex: "KFTBWI(?:[);/ ]|$)",
                model: "Fire HD 10"
            },
            {
                regex: "KFSUWI(?:[);/ ]|$)",
                model: "Fire HD 10 (2017)"
            },
            {
                regex: "KFMAWI(?:[);/ ]|$)",
                model: "Fire HD 10 (2019)"
            },
            {
                regex: "SD4930UR",
                model: "Fire Phone",
                device: "smartphone"
            },
            {
                regex: "KFOT|Kindle Fire|Silk/\\d+\\.\\d+",
                model: "Kindle Fire"
            },
            {
                regex: "Kindle",
                model: "Kindle"
            },
            {
                regex: "AEO(BC|KN)(?:[);/ ]|$)",
                model: "Echo",
                device: "smart speaker"
            },
            {
                regex: "AlexaMediaPlayer",
                model: "Alexa",
                device: "smart speaker"
            }
        ]
    },
    Symphony: {
        regex: "SYMPHONY[ \\_]([a-z0-9]+)|(?:roar[ _](?:V20|V78|E80|V150))|roarV95|ZVIII(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ZVIII",
                model: "ZVIII"
            },
            {
                regex: "roar[ _]?(V20|E80|V78|V95|V150)(?:[);/ ]|$)",
                model: "Roar $1"
            },
            {
                regex: "SYMPHONY[ \\_]([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Helio: {
        regex: "Helio (S60|S5)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Syrox: {
        regex: "(SYX-(?:T70[04]|T10[12]))(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Qtek: {
        regex: "Qtek[ _]?([a-z0-9]+)",
        device: "smartphone",
        model: "$1"
    },
    "Q-Touch": {
        regex: "( Q09|QS701|Q05A)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    "G-Touch": {
        regex: "GTouch[_ ]|(?:Stella (?:XS?|Omega))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Stella (XS?|Omega)",
                model: "Stella $1"
            },
            {
                regex: "GTouch[_ ]STELLA",
                model: "Stella"
            }
        ]
    },
    "T-Mobile": {
        regex: "T-Mobile[ _][a-z0-9 ]+|(?:REVVLRY|REVVL 2(?: PLUS)?|5062[ZW]|5007[ZW])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "5062[ZW]",
                model: "REVVL 4 Plus"
            },
            {
                regex: "5007[ZW]",
                model: "REVVL 4"
            },
            {
                regex: "REVVL 2 PLUS",
                model: "REVVL 2 Plus"
            },
            {
                regex: "REVVLRY",
                model: "REVVL Plus"
            },
            {
                regex: "REVVL 2(?:[);/ ]|$)",
                model: "REVVL 2"
            },
            {
                regex: "T-Mobile[ _]([a-z0-9_ ]+) Build",
                model: "$1"
            },
            {
                regex: "T-Mobile[ _]([a-z0-9_ ]+)",
                model: "$1"
            }
        ]
    },
    "TB Touch": {
        regex: "Ignis [89]",
        device: "tablet",
        models: [
            {
                regex: "Ignis ([89])",
                model: "Ignis $1"
            }
        ]
    },
    Teclast: {
        regex: "Teclast|TLA002|TLA016|X98 Air III|M20_4G|X98 Air II\\(HG5N\\)|Tbook|X80 Power\\(B2N4\\)|(?:T30|P80X|P20HD|P10_HD|M40)_(?:ROW|EEA)|T10\\(E3C6\\)|P10S\\(N4H5\\)|98\\(M1E[45789]\\)|98\\(M3E3\\)",
        device: "tablet",
        models: [
            {
                regex: "Tbook[_ -]([^;/]+) Build",
                model: "Tbook $1"
            },
            {
                regex: "T10\\(E3C6\\)",
                model: "T10"
            },
            {
                regex: "T30_(ROW|EEA)",
                model: "T30 $1"
            },
            {
                regex: "P80X_(ROW|EEA)",
                model: "P80X $1"
            },
            {
                regex: "P10S\\(N4H5\\)",
                model: "P10S"
            },
            {
                regex: "P20HD_(?:ROW|EEA)",
                model: "P20HD"
            },
            {
                regex: "M40_(?:ROW|EEA)",
                model: "M40"
            },
            {
                regex: "P10_HD_(?:ROW|EEA)",
                model: "P10HD"
            },
            {
                regex: "M20_4G",
                model: "M20 4G"
            },
            {
                regex: "TLA002",
                model: "M30 4G"
            },
            {
                regex: "TLA016",
                model: "M16"
            },
            {
                regex: "98\\(M1E[45789]\\)|98\\(M3E3\\)",
                model: 'TPad 98 10.1" 4G'
            },
            {
                regex: "X80 Power\\(B2N4\\)(?:[);/ ]|$)",
                model: "X98 Power"
            },
            {
                regex: "X98 Air III(?:[);/ ]|$)",
                model: "X98 Air III"
            },
            {
                regex: "X98 Air II\\(HG5N\\)(?:[);/ ]|$)",
                model: "X98 Air II"
            },
            {
                regex: "Teclast[_ -]([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    "Tecno Mobile": {
        regex: "Tecno|Phantom6|Phantom6-Plus|DP7C Pro-SGA1",
        device: "smartphone",
        models: [
            {
                regex: "Phantom6-Plus",
                model: "Phantom 6 Plus"
            },
            {
                regex: "Phantom6",
                model: "Phantom 6"
            },
            {
                regex: "TECNO-W3",
                model: "W3"
            },
            {
                regex: "TECNO[ _]F4 Pro(?:[);/ ]|$)",
                model: "F4 Pro"
            },
            {
                regex: "TECNO[ _]KE5j(?:[);/ ]|$)",
                model: "Spark 6 Go"
            },
            {
                regex: "TECNO[ _]ID6(?:[);/ ]|$)",
                model: "Camon iClick 2"
            },
            {
                regex: "Tecno[ _]7C(?:[);/ ]|$)",
                model: "DroidPad 7C",
                device: "tablet"
            },
            {
                regex: "DP7C Pro-SGA1(?:[);/ ]|$)",
                model: "DroidPad 7C Pro",
                device: "tablet"
            },
            {
                regex: "TECNO[ _]DP10A Pro(?:[);/ ]|$)",
                model: "DroidPad 10A Pro",
                device: "tablet"
            },
            {
                regex: "TECNO[ _]P904(?:[);/ ]|$)",
                model: "DroidPad 10D 4G",
                device: "tablet"
            },
            {
                regex: "Tecno[ _]CB7[j]?",
                model: "Camon i4"
            },
            {
                regex: "Tecno[ _]CF7(?:[);/ ]|$)",
                model: "Camon 11"
            },
            {
                regex: "Tecno[ _]CC6(?:[);/ ]|$)",
                model: "Camon 12 Air"
            },
            {
                regex: "Tecno[ _]CC7(?:[);/ ]|$)",
                model: "Camon 12"
            },
            {
                regex: "Tecno[ _]KC8(?:[);/ ]|$)",
                model: "Spark 4"
            },
            {
                regex: "Tecno[ _]BB4k(?:[);/ ]|$)",
                model: "Spark 4 Lite"
            },
            {
                regex: "Tecno[ _]KD7(?:[);/ ]|$)",
                model: "Spark 5 Pro"
            },
            {
                regex: "Tecno[ _]DP8D(?:[);/ ]|$)",
                model: "DroidPad 8D",
                device: "tablet"
            },
            {
                regex: "Tecno[ _]LB8",
                model: "Pouvoir 3 Plus"
            },
            {
                regex: "TECNO S9",
                device: "phablet",
                model: "S9"
            },
            {
                regex: "Tecno ([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Tecno[ _]?([a-z0-9_\\-]+)",
                model: "$1"
            }
        ]
    },
    TechPad: {
        regex: "Tech ?pad|XTAB[ _-]|Dual C1081HD|S813G",
        device: "tablet",
        models: [
            {
                regex: "S813G",
                model: "S813G"
            },
            {
                regex: "TechPad10QC",
                model: "10QC"
            },
            {
                regex: "TechPad_10xx",
                model: "10XX"
            },
            {
                regex: "TechPad703",
                model: "703"
            },
            {
                regex: "TechPad[_ ](10Y|9x|i700)",
                model: "$1"
            },
            {
                regex: "TechPad[_ ]3Gx",
                model: "3Gx"
            },
            {
                regex: "Dual C1081HD",
                model: "XTAB C1081HD"
            },
            {
                regex: "XTAB[ _-]([^/;]+) Build",
                model: "XTAB $1"
            },
            {
                regex: "Tech ?pad[ _-]([^/;)]+)(?: Build|[;)])",
                model: "$1",
                device: "smartphone"
            }
        ]
    },
    Tesco: {
        regex: "Hudl (?:[^/;]+)(?: Build|[;)])|W032i-C3(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "Hudl ([^/;]+)(?: Build|[;)])",
                model: "Hudl $1"
            },
            {
                regex: "W032i-C3(?:[);/ ]|$)",
                model: "Op3n Dott"
            }
        ]
    },
    teXet: {
        regex: "Texet|(NaviPad [^/;]*) Build|TM-(?:1046|1058|1057|1067|3000|3200R|3500|4003|4071|450[34]|451[30]|4377|4082R|508[34]|550[358]|5010|5017|507[4-7]|5[23]77|6003|6906|702[13]|7055HD|709[69]|9747BT|9758|9751HD|9767|5513|520[410]|507[13]|558[134]|570[23]|7859|8044|9748[ _]3G|9720|7047HD[ _]3G|9757|9740|4982|4515|4083|500[3567]|5571|3204R|5016|8043|7047HD[ _]3G|8041HD|8066|705[23]|7041|8041HD|8051|8048|974[96]|973[78]W|974[170]|9743W|9750HD|7043XD|7049|7887|7037W|702[46])|TB-(771A|711A)|X-Force[\\(-]?TM-5009\\)?|X-Plus[\\(-]?TM-5577\\)?|TM_5011|X-pad (?:AIR 8|iX 7|NAVI 7.[35]|NAVI 10|SKY 8.1|STYLE 8|STYLE 10.1|HIT|LITE 7.[12]|QUAD (?:7.2|10|7)|SHINE 8.1)(?: 3G)?",
        device: "tablet",
        models: [
            {
                regex: "TM-9749",
                model: "X-pad Plus 7.1 3G"
            },
            {
                regex: "TM-9746",
                model: "X-pad Plus 7 3G"
            },
            {
                regex: "TM-8051",
                model: "X-pad Force 8i 3G"
            },
            {
                regex: "TM-1058",
                model: "X-Force 10 3G"
            },
            {
                regex: "TM-8048",
                model: "X-pad Force 8 3G"
            },
            {
                regex: "(NaviPad [^/;]*) Build",
                model: "$1"
            },
            {
                regex: "TM-7055HD",
                model: "NaviPad 3G"
            },
            {
                regex: "TM-9758",
                model: 'X-pad Style 10.0"'
            },
            {
                regex: "X-pad SHINE 8.1 3G",
                model: 'X-pad Shine 8.1" 3G'
            },
            {
                regex: "X-pad QUAD 10 3G",
                model: 'X-pad Quad 10.0" 3G'
            },
            {
                regex: "X-pad QUAD 7 3G",
                model: 'X-pad Quad 7.0" 3G'
            },
            {
                regex: "X-pad QUAD 7.2 3G",
                model: 'X-pad Quad 7.2" 3G'
            },
            {
                regex: "X-pad STYLE 8 3G",
                model: 'X-pad Style 8.0" 3G'
            },
            {
                regex: "X-pad HIT 3G",
                model: "X-pad Hit 3G"
            },
            {
                regex: "X-pad LITE (7.[12])",
                model: 'X-pad Lite $1"'
            },
            {
                regex: "TM-9767",
                model: 'X-pad Style 10.0" 3G'
            },
            {
                regex: "X-pad STYLE 10.1 3G",
                model: 'X-pad Style 10.1" 3G'
            },
            {
                regex: "(X-pad (?:AIR 8|iX 7) 3G)",
                model: "$1"
            },
            {
                regex: "TM-7096|X-pad NAVI 7.3 3G",
                model: 'X-pad NAVI 7.3" 3G'
            },
            {
                regex: "TM-7099",
                model: 'X-pad NAVI 7.4" 3G'
            },
            {
                regex: "X-pad NAVI 7.5 3G",
                model: 'X-pad NAVI 7.5" 3G'
            },
            {
                regex: "X-pad SKY 8.1 3G",
                model: 'X-pad Sky 8.1" 3G'
            },
            {
                regex: "TM-1046|X-pad NAVI 10 3G",
                model: 'X-pad NAVI 10.0" 3G'
            },
            {
                regex: "TM-7859",
                model: 'X-pad NAVI 8.2" 3G'
            },
            {
                regex: "TM-7049",
                model: "NaviPad TM-7049 3G"
            },
            {
                regex: "TM-7887",
                model: "NaviPad TM-7887 3G"
            },
            {
                regex: "TM-8066",
                model: 'X-pad Rapid 8.2" 4G'
            },
            {
                regex: "(TM-(?:1057|1067|6906|8043|9748[_ ]3G|9740|9757(?:[_ ]3G)?|7047HD[ _]3G|9747BT|9751HD|702[13]|705[23]|7041|9720|7047HD[_ ]3G|8044|8041HD|973[78]W|9743W|974[710]|9750HD|7043XD|7037W|702[46])|TB-(?:771A|711A|8041HD))",
                model: "$1"
            },
            {
                regex: "TM-4503",
                device: "smartphone",
                model: "X-Quad"
            },
            {
                regex: "(TM-(?:3000|3200R|4003|4083|4377|4504|451[30]|500[35]|5[23]77|5571|3204R|520[04]|5581|5505|5017|507[13-7]|5081|6003|5513))",
                device: "smartphone",
                model: "$1"
            },
            {
                regex: "TM-5006",
                device: "smartphone",
                model: "X-Line"
            },
            {
                regex: "TM-5007",
                device: "smartphone",
                model: "X-Shine"
            },
            {
                regex: "TM_5011",
                device: "smartphone",
                model: "X-Omega"
            },
            {
                regex: "TM-508(3|4)",
                device: "smartphone",
                model: "Pay $1G"
            },
            {
                regex: "TM-558(3|4)",
                device: "smartphone",
                model: 'Pay 5.5" $1G'
            },
            {
                regex: "TM-5702",
                device: "smartphone",
                model: 'Pay 5.7" 3G'
            },
            {
                regex: "TM-5703",
                device: "smartphone",
                model: 'Pay 5.7" Pro'
            },
            {
                regex: "TM-5201",
                device: "smartphone",
                model: "Rock"
            },
            {
                regex: "TM-4515",
                device: "smartphone",
                model: "X-Style"
            },
            {
                regex: "TM-(5016|3500)",
                device: "smartphone",
                model: "X-Maxi 2"
            },
            {
                regex: "TM-4071",
                device: "smartphone",
                model: "X-Smart"
            },
            {
                regex: "TM-4982",
                device: "smartphone",
                model: "iX-Maxi"
            },
            {
                regex: "TEXET[_ ]IX-MINI",
                device: "smartphone",
                model: "iX-Mini"
            },
            {
                regex: "TM-5010",
                device: "smartphone",
                model: "X-Selfie"
            },
            {
                regex: "TM-4082R",
                device: "smartphone",
                model: "X-Driver Quad"
            },
            {
                regex: "TM-5503",
                device: "smartphone",
                model: "X-Mage"
            },
            {
                regex: "TM-5508",
                device: "smartphone",
                model: "X-Cosmo"
            },
            {
                regex: "X-Force[\\(-]?TM-5009\\)?",
                device: "smartphone",
                model: "X-Force"
            },
            {
                regex: "X-Plus[\\(-]?TM-5577\\)?",
                device: "smartphone",
                model: "X-Plus"
            },
            {
                regex: "teXet[_ ]X-medium[_ ]plus",
                device: "smartphone",
                model: "X-Medium Plus"
            }
        ]
    },
    Telefunken: {
        regex: "TELEFUNKEN|Foxtrot|TEL-1013GIQA|TF-SP(?:500[12]|4002)|(TF-MID(?:[78]02G|70[78]G|80[46]G|9705RG|9707G|7805G|100[57]G|1010G))|(TF-LED(?:65S75T2SU|32S39T2S|32S5[289]T2S|32S70T2S|40S63T2S))",
        device: "tablet",
        models: [
            {
                regex: "TEL-1013GIQA",
                model: "Giqa 10.1 3G"
            },
            {
                regex: "Foxtrot2",
                model: "Foxtrot 2",
                device: "smartphone"
            },
            {
                regex: "(?:TELEFUNKEN)?(TF-SP(?:500[12]|4002)|Outdoor LTE|Foxtrot)",
                model: "$1",
                device: "smartphone"
            },
            {
                regex: "(TF-MID(?:[78]02G|70[78]G|80[46]G|9705RG|9707G|7805G|100[57]G|1010G))",
                model: "$1"
            },
            {
                regex: "(TF-LED(?:65S75T2SU|32S39T2S|32S5[289]T2S|32S70T2S|40S63T2S))",
                model: "$1",
                device: "tv"
            }
        ]
    },
    Telego: {
        regex: "TELEGO",
        device: "smartphone",
        models: [
            {
                regex: "TELEGO-W503",
                model: "W503"
            },
            {
                regex: "Telego_JOY2",
                model: "Joy 2"
            },
            {
                regex: "Telego[ _]Mate",
                model: "Mate"
            }
        ]
    },
    Telenor: {
        regex: "(?<!FBCR/)Telenor|Infinity E5",
        device: "smartphone",
        models: [
            {
                regex: "Telenor[ _]([^;/]+)(?: Build|[;)])",
                model: "$1"
            },
            {
                regex: "Infinity E5",
                model: "Infinity E5"
            }
        ]
    },
    Telit: {
        regex: "Telit",
        device: "feature phone",
        models: [
            {
                regex: "Telit_Mobile_Terminals-([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "Telit[\\-_]?([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    ThL: {
        regex: "ThL[ _-]|Knight 2",
        device: "smartphone",
        models: [
            {
                regex: "Knight 2",
                model: "Knight 2"
            },
            {
                regex: "ThL[ _-]*([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "ThL[ _-]*([^ ;/)]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    TIANYU: {
        regex: "TIANYU",
        device: "feature phone",
        models: [
            {
                regex: "TIANYU ([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "TIANYU-KTOUCH/([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Timovi: {
        regex: "Tmovi[ _]|(?:Infinit_Lite_2|Vision_PRO|VISION ULTRA|Epix)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Tmovi[ _]Prime",
                model: "Prime"
            },
            {
                regex: "TMOVI_YEAH_BEAT",
                model: "Yeah Beat"
            },
            {
                regex: "YeahLIVE",
                model: "Yeah LIVE"
            },
            {
                regex: "Infinit Lite",
                model: "Infinit Lite"
            },
            {
                regex: "Infinit_Lite_2",
                model: "Infinit Lite 2"
            },
            {
                regex: "Vision_PRO",
                model: "Vision Pro"
            },
            {
                regex: "VISION ULTRA",
                model: "Vision Ultra"
            },
            {
                regex: "Epix",
                model: "Epix"
            }
        ]
    },
    Tooky: {
        regex: "TOOKY",
        device: "smartphone",
        models: [
            {
                regex: "TOOKY (A19|W1|T8[368]|T1982)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "TOOKY A9PLUS(?:[);/ ]|$)",
                model: "A9 Plus"
            }
        ]
    },
    Tolino: {
        regex: "Tolino Tab ([^/;]+) Build",
        device: "tablet",
        model: "Tolino Tab $1"
    },
    "Top House": {
        regex: "Coto[_ ]|X1013",
        device: "smartphone",
        models: [
            {
                regex: "Coto W418",
                model: "Coto W418"
            },
            {
                regex: "COTO_T117",
                model: "Coto T117",
                device: "tablet"
            },
            {
                regex: "X1013",
                model: "X1013",
                device: "tablet"
            },
            {
                regex: "COTO_T40017",
                model: "T40017"
            }
        ]
    },
    Toplux: {
        regex: "Toplux ([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Touchmate: {
        regex: "TOUCHMATE|(TM-(?:MID1050WKD|MID1020A|MID794C|MID795|MID710|MID798|MID792|MID788D|SM500N|SM410|MID1010))",
        device: "smartphone",
        models: [
            {
                regex: "(TM-(?:MID1020A|MID794C|MID795|MID710|MID798|MID792|MID788D|MID1010))",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "TM-MID1050WKD",
                device: "tablet",
                model: 'Mega Matrix 10.1" 3G'
            },
            {
                regex: "(TM-(?:SM500N|SM410))",
                model: "$1"
            },
            {
                regex: "Touchmate ([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    TrekStor: {
        regex: "(?:TrekStor|Surftab) ([^/;]+)(?: Build|\\))|Surftab[^;\\)]*(?:[;\\)]|$)|ST10216-2A|ST13416-1|VT10416-[12]|TFMTKAW01232",
        device: "tablet",
        models: [
            {
                regex: "ST10216-2A|VT10416-[12]",
                model: "SurfTab 10.1"
            },
            {
                regex: "ST13416-1",
                model: 'SurfTab Theatre 13.4"'
            },
            {
                regex: "PrimeTab P10",
                model: "PrimeTab P10"
            },
            {
                regex: "TrekStor ([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "Surftab ([^/;]+) Build",
                model: "SurfTab $1"
            },
            {
                regex: "Surftab[ _]([^;\\)]*)(?:[;\\)]|$)",
                model: "SurfTab $1"
            },
            {
                regex: "TFMTKAW01232",
                model: "SurfTab L15"
            }
        ]
    },
    Trevi: {
        regex: "Trevi[ _]|TAB[ _]10[ _]3G[ _]V16|TAB[ _](7|8)[ _]3G[ _]V8|TAB9 3G|MINITAB 3GV|Phablet[ _](?:4|4\\.5|5|5\\,3|6)[ _]?[CSQ]|REVERSE[ _]5\\.5[ _]?Q",
        device: "tablet",
        models: [
            {
                regex: "TAB[ _]?(7|8)[ _]3G[ _]V8",
                model: "TAB $1 3G V8"
            },
            {
                regex: "TAB[ _]?9[ _]3G[ _]V8",
                model: "TAB 9 3G V8"
            },
            {
                regex: "TAB[ _]?9[ _]3G",
                model: "TAB 9 3G"
            },
            {
                regex: "TAB[ _]10[ _]3G[ _]V16",
                model: "TAB 10 3G V16"
            },
            {
                regex: "MINITAB 3GV",
                model: "MINITAB 3G V"
            },
            {
                regex: "(?:Trevi_)?Phablet[ _]4[ _]?C",
                model: "Phablet 4 C",
                device: "smartphone"
            },
            {
                regex: "(?:Trevi_)?Phablet[ _]4[ _]?S",
                model: "Phablet 4 S",
                device: "smartphone"
            },
            {
                regex: "(?:Trevi_)?Phablet[ _]4.5[ _]?Q",
                model: "Phablet 4.5Q",
                device: "smartphone"
            },
            {
                regex: "(?:Trevi_)?PHABLET[ _]5[ _]?S",
                model: "Phablet 5 S",
                device: "smartphone"
            },
            {
                regex: "(?:Trevi_)?PHABLET[ _]5,3[ _]?Q",
                model: "Phablet 5.3 Q",
                device: "phablet"
            },
            {
                regex: "(?:Trevi_)?REVERSE[ _]5.5[ _]?Q",
                model: "Phablet 5.5 Q REVERSE",
                device: "phablet"
            },
            {
                regex: "(?:Trevi_)?PHABLET[ _]6[ _]?S",
                model: "Phablet 6 S",
                device: "phablet"
            },
            {
                regex: "Trevi[_]([^;/]+) Build",
                model: "$1"
            }
        ]
    },
    TVC: {
        regex: "(NuclearSX-SP5)",
        device: "smartphone",
        model: "Nuclear SX-SP5"
    },
    "U.S. Cellular": {
        regex: "USCC-",
        device: "smartphone",
        models: [
            {
                regex: "USCC-E6762",
                model: "Kyocera DuraForce"
            },
            {
                regex: "(USCC-[a-z0-9_\\-]+)",
                model: "$1"
            }
        ]
    },
    Uhappy: {
        regex: "Uhappy|UP?580|UP350|UP[35679]20",
        device: "smartphone",
        models: [
            {
                regex: "UP([35679]20)",
                model: "UP$1"
            },
            {
                regex: "UP350",
                model: "UP350"
            },
            {
                regex: "UP580",
                model: "UP580"
            },
            {
                regex: "U580",
                model: "U580"
            },
            {
                regex: "Uhappy[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Uhappy[ _-]?([^;/)]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Unimax: {
        regex: "U((?:67[013]|680)C|(?:452|504)TL|683CL|693CL)(?:[);/ ]|$)",
        device: "smartphone",
        model: "U$1"
    },
    Unowhy: {
        regex: "QOOQ ",
        device: "tablet",
        model: "QOOQ"
    },
    UTStarcom: {
        regex: "utstar[ _-]?([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Ulefone: {
        regex: "Ulefone|Gemini Pro|Power_[356]|S10_Pro|(?:Note [89]P|Armor(?:[ _](?:[2367]|2S|X[236]|6[SE]|3WT|3W|X))?|U00[78][ _]Pro|Be[ _]X|Be[ _]Touch(?:[ _][23])?|Be[ _](?:One|Pure)(?:[ _]Lite)?)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "S10_Pro",
                model: "S10 Pro"
            },
            {
                regex: "Be[ _]Touch([ _][23])?",
                model: "Be Touch$1"
            },
            {
                regex: "Be[ _]Pure[ _]Lite",
                model: "Be Pure Lite"
            },
            {
                regex: "Be[ _]Pure",
                model: "Be Pure"
            },
            {
                regex: "Be[ _]One[ _]Lite",
                model: "Be One Lite"
            },
            {
                regex: "Be[ _]One",
                model: "Be One"
            },
            {
                regex: "Be[ _]X",
                model: "Be X"
            },
            {
                regex: "U007 Pro",
                model: "U007 Pro"
            },
            {
                regex: "U008 Pro",
                model: "U008 Pro"
            },
            {
                regex: "Armor[ _]X([236])(?:[);/ ]|$)",
                model: "Armor X$1"
            },
            {
                regex: "Armor[ _]6S(?:[);/ ]|$)",
                model: "Armor 6S"
            },
            {
                regex: "Armor[ _]([679])E(?:[);/ ]|$)",
                model: "Armor $1E"
            },
            {
                regex: "Armor[ _]X([57]) Pro(?:[);/ ]|$)",
                model: "Armor X$1 Pro"
            },
            {
                regex: "Armor[ _]X([578])(?:[);/ ]|$)",
                model: "Armor X$1"
            },
            {
                regex: "Armor[ _]([25])S(?:[);/ ]|$)",
                model: "Armor $1S"
            },
            {
                regex: "Armor[ _]X(?:[);/ ]|$)",
                model: "Armor X"
            },
            {
                regex: "Armor[ _]3W(?:[);/ ]|$)",
                model: "Armor 3W"
            },
            {
                regex: "Armor[ _]3WT(?:[);/ ]|$)",
                model: "Armor 3WT"
            },
            {
                regex: "Armor[ _]([236789])(?:[);/ ]|$)",
                model: "Armor $1"
            },
            {
                regex: "Armor(?:[);/ ]|$)",
                model: "Armor"
            },
            {
                regex: "Gemini Pro(?:[);/ ]|$)",
                model: "Gemini Pro"
            },
            {
                regex: "Power[_ ]([356])",
                model: "Power $1"
            },
            {
                regex: "Note 8P(?:[);/ ]|$)",
                model: "Note 8P"
            },
            {
                regex: "Note 9P(?:[);/ ]|$)",
                device: "phablet",
                model: "Note 9P"
            },
            {
                regex: "Ulefone[_ ](X|S1[ _]Pro|S[17])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Ulefone[ _-]?([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Ulefone[ _-]?([^;/)]+)(?:[;/)]|$)",
                model: "$1"
            }
        ]
    },
    UMIDIGI: {
        regex: "UMI(?:DIGI)?[ _]|(?:A5_Pro|ROME[_ ]X|BISON|hammer_S)(?:[;/) ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "A5_Pro",
                model: "A5 Pro"
            },
            {
                regex: "UMI TOUCH X",
                model: "Touch X"
            },
            {
                regex: "UMI TOUCH",
                model: "Touch"
            },
            {
                regex: "ROME[_ ]X",
                model: "Rome X"
            },
            {
                regex: "BISON",
                model: "Bison"
            },
            {
                regex: "hammer_S",
                model: "Hammer S"
            },
            {
                regex: "UMI_(London|Diamond(?:_X)?)",
                model: "$1"
            },
            {
                regex: "UMI(?:DIGI)?[ _]([^/;)]+)(?: Build|[;)])",
                model: "$1"
            }
        ]
    },
    Uniscope: {
        regex: "Uniscope",
        device: "smartphone",
        models: [
            {
                regex: "Uniscope[ _\\-]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "Uniscope[ _\\-]?([^);/ ]+)",
                model: "$1"
            }
        ]
    },
    Unnecto: {
        regex: "Unnecto|(?:U513|U5151|U61[1356]|U7[12]0|U-830|U90[35])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "U513",
                model: "Drone XT"
            },
            {
                regex: "U5151",
                model: "Bolt"
            },
            {
                regex: "U611",
                model: "Quattro X"
            },
            {
                regex: "U613",
                model: "Quattro S"
            },
            {
                regex: "U615",
                model: "Quattro M"
            },
            {
                regex: "U616",
                model: "U616"
            },
            {
                regex: "U710",
                model: "Quattro U710"
            },
            {
                regex: "U720",
                model: "Quattro Z"
            },
            {
                regex: "U-830",
                model: "Rush"
            },
            {
                regex: "U903",
                model: "Air"
            },
            {
                regex: "U905",
                model: "Air 5.5"
            }
        ]
    },
    Unonu: {
        regex: "Unonu[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "Unonu[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Unonu[ _-]?([^;/)]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    UTOK: {
        regex: "UTOK (45[01]D)",
        device: "smartphone",
        model: "$1"
    },
    Vastking: {
        regex: "(M910A|M783K|M783K-16G|M1072R-3G)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    ViewSonic: {
        regex: "ViewSonic|VSD[0-9]+(?:[);/ ]|$)|ViewPad|ViewPhone",
        device: "smart display",
        models: [
            {
                regex: "(?:ViewSonic-)?V500(?:[);/ ]|$)",
                model: "V500",
                device: "smartphone"
            },
            {
                regex: "ViewSonic A8\\+(?:[);/ ]|$)",
                model: "A8 Plus",
                device: "smartphone"
            },
            {
                regex: "(?:ViewSonic-)?ViewPhone ?([^;/]+) Build",
                model: "ViewPhone $1",
                device: "smartphone"
            },
            {
                regex: "(?:ViewSonic-)?ViewPad ?([^;/]+) Build",
                model: "ViewPad $1",
                device: "tablet"
            },
            {
                regex: "(VSD[0-9]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Vitelcom: {
        regex: "Vitelcom|portalmmm/[12].0 TSM",
        device: "feature phone",
        models: [
            {
                regex: "TSM-([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "TSM([a-z0-9\\-]+)",
                model: "$1"
            },
            {
                regex: "portalmmm/[12].0 (TSM[a-z0-9 ]+)",
                model: "$1"
            }
        ]
    },
    Fengxiang: {
        regex: "(vKB011B|vKB004L)",
        device: "tablet",
        model: "$1"
    },
    "VK Mobile": {
        regex: "VK-VK([79]00)(?:[);/ ]|$)",
        device: "feature phone",
        model: "VK$1"
    },
    Vernee: {
        regex: "Vernee|Mars Pro|Apollo[ _](?:Lite|X)|Thor (?:E|Plus)|X2_euro",
        device: "smartphone",
        models: [
            {
                regex: "Apollo[ _]Lite",
                model: "Apollo Lite"
            },
            {
                regex: "Apollo[ _]X",
                model: "Apollo X"
            },
            {
                regex: "Mars Pro",
                model: "Mars Pro"
            },
            {
                regex: "Thor E",
                model: "Thor E"
            },
            {
                regex: "Thor Plus",
                model: "Thor Plus"
            },
            {
                regex: "Vernee_M5",
                model: "M5"
            },
            {
                regex: "X2_euro",
                model: "X2"
            },
            {
                regex: "Vernee[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Vernee[ _-]([a-z0-9_-]+)",
                model: "$1"
            }
        ]
    },
    Vertu: {
        regex: "Vertu[ ]?([a-z0-9]+)|(?:ASTER P|CONSTELLATION X)(?:[);/ ]|$)",
        device: "feature phone",
        models: [
            {
                regex: "ASTER P(?:[);/ ]|$)",
                device: "smartphone",
                model: "Aster P"
            },
            {
                regex: "CONSTELLATION X(?:[);/ ]|$)",
                device: "smartphone",
                model: "Constellation X"
            },
            {
                regex: "Vertu[ ]?([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Venso: {
        regex: "(?:CX-508|CX-551|Reiv 500|Creon F5|Isprit U50|Isprit-U50-LTE)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Isprit U50|Isprit-U50-LTE",
                model: "Isprit U50"
            },
            {
                regex: "(CX-508|CX-551|Reiv 500|Creon F5)",
                model: "$1"
            }
        ]
    },
    Verizon: {
        regex: "QTA(SUN[12]|XIA1|QZ3|QZ3KID|IR7)|QMV7B",
        device: "tablet",
        models: [
            {
                regex: "QTAXIA1|QTAIR7",
                model: "Ellipsis 10"
            },
            {
                regex: "QTASUN1",
                model: "Ellipsis 8 HD"
            },
            {
                regex: "QTASUN2",
                model: "Ellipsis 8 HD 4G LTE"
            },
            {
                regex: "QTAQZ3KID",
                model: "Ellipsis Kids LTE"
            },
            {
                regex: "QTAQZ3",
                model: "Ellipsis 8"
            },
            {
                regex: "QMV7B",
                model: "Ellipsis 7"
            }
        ]
    },
    Verykool: {
        regex: "verykool",
        device: "smartphone",
        models: [
            {
                regex: "verykoolS5004",
                model: "Lotus JR."
            },
            {
                regex: "verykoolS5005",
                model: "Lotus II"
            },
            {
                regex: "verykool[ _]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "verykool[ _]?([^/;]+);",
                model: "$1"
            }
        ]
    },
    Vestel: {
        regex: "Vestel[ _]|Venus[ _](GO|E[2-5]|V[1-9]|Z[1-9]0)|(?<!Winnovo )V_?TAB|VP74|VT97PRO|VSP145M|VSP250[GS]|VSP355[GS]|V3_5580_Dual",
        device: "smartphone",
        models: [
            {
                regex: "VT97PRO",
                model: "VTab 9.7 Pro",
                device: "tablet"
            },
            {
                regex: "VP74",
                model: "VTab Lite II",
                device: "tablet"
            },
            {
                regex: "VTAB10",
                model: "VTab 10",
                device: "tablet"
            },
            {
                regex: "V_TAB_7_ECO_III ",
                model: "VTab 7 Eco 3",
                device: "tablet"
            },
            {
                regex: "V_TAB_([0-9]{4}[A-Z]?)",
                model: "VTab $1",
                device: "tablet"
            },
            {
                regex: "V3_5580_Dual",
                model: "Venus V3 5580 Dual"
            },
            {
                regex: "VSP145M",
                model: "Venus 4.5"
            },
            {
                regex: "VSP250G",
                model: "Venus 5.0V"
            },
            {
                regex: "VSP250S",
                model: "Venus 5.0X"
            },
            {
                regex: "VSP355G",
                model: "Venus 5.5V"
            },
            {
                regex: "VSP355S",
                model: "Venus 5.5X"
            },
            {
                regex: "Venus[ _]V([1-9])",
                model: "Venus V$1"
            },
            {
                regex: "Venus[ _]Z([1-9]0)",
                model: "Venus Z$1"
            },
            {
                regex: "Venus[ _]GO",
                model: "Venus Go"
            },
            {
                regex: "Venus E2 Plus Dual",
                model: "Venus E2 Plus Dual"
            },
            {
                regex: "Venus[ _]E2 Plus",
                model: "Venus E2 Plus"
            },
            {
                regex: "Venus[ _]E([345])",
                model: "Venus E$1"
            },
            {
                regex: "Vestel_5000_Dual",
                model: "5000 Dual"
            },
            {
                regex: "Vestel_5000_2gb",
                model: "5000 2GB"
            },
            {
                regex: "Vestel[ _](5000|5530)",
                model: "$1"
            }
        ]
    },
    Videocon: {
        regex: "Videocon[_ \\-]|(?:VT75C|V406018|V512930|V50(?:2430|3630|5024|5430|4630|5[98]20)|Z45_(?:Dazzle|Amaze)|Z45Q Star|Z50 Nova)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Videocon_V1585",
                device: "feature phone",
                model: "V1585"
            },
            {
                regex: "Videocon[_ \\-]([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "VT75C(?:[);/ ]|$)",
                model: "VT75C",
                device: "tablet"
            },
            {
                regex: "V502430(?:[);/ ]|$)",
                model: "Kryton 3"
            },
            {
                regex: "V505024(?:[);/ ]|$)",
                model: "Kryton 22 Plus"
            },
            {
                regex: "V503630(?:[);/ ]|$)",
                model: "Delite 11"
            },
            {
                regex: "V505920(?:[);/ ]|$)",
                model: "Metal Pro 2"
            },
            {
                regex: "V505820(?:[);/ ]|$)",
                model: "Metal Pro 1"
            },
            {
                regex: "V406018(?:[);/ ]|$)",
                model: "Starr 100"
            },
            {
                regex: "V512930(?:[);/ ]|$)",
                model: "Ultra 50"
            },
            {
                regex: "(V505430|V504630)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Z45_(Dazzle|Amaze)(?:[);/ ]|$)",
                model: "Infinium Z45 $1"
            },
            {
                regex: "Z45Q Star(?:[);/ ]|$)",
                model: "Infinium Z45Q Star"
            },
            {
                regex: "Z50 Nova(?:[);/ ]|$)",
                model: "Infinium Z50 Nova"
            }
        ]
    },
    Vodafone: {
        regex: "(?<!FBCR/)Vodafone[ _-]|Smart ?Tab ?(?:III? ?)?(?:|4G|7|10)[);/ -]|VodafoneSmartChat|VFD[ _][0-9]+(?:[);/ ]|$)|VFD320|VF6[89]5|VF-(696|1397|795|895N|1497)",
        device: "smartphone",
        models: [
            {
                regex: "VFD 100",
                model: "Smart Mini"
            },
            {
                regex: "VF685",
                model: "Smart Kicka"
            },
            {
                regex: "VF695",
                model: "Smart First 6"
            },
            {
                regex: "VFD 200",
                model: "Smart First 7"
            },
            {
                regex: "VFD 300",
                model: "Smart Mini 7"
            },
            {
                regex: "VFD 50[02]",
                model: "Smart Turbo 7"
            },
            {
                regex: "VFD 51[013]",
                model: "Smart E8"
            },
            {
                regex: "VFD 600",
                model: "Smart Prime 7"
            },
            {
                regex: "VFD320",
                model: "Smart C9"
            },
            {
                regex: "VFD 820",
                model: "Smart X9"
            },
            {
                regex: "VFD 610",
                model: "Smart N8"
            },
            {
                regex: "Smart ultra 6",
                model: "Smart Ultra 6"
            },
            {
                regex: "VFD 700",
                model: "Smart Ultra 7"
            },
            {
                regex: "VFD 720",
                model: "Smart N9"
            },
            {
                regex: "VFD 900",
                model: "Smart Platinum 7"
            },
            {
                regex: "Vodafone[ _]875(?:[);/ ]|$)",
                model: "Smart Mini"
            },
            {
                regex: "Vodafone[ _]975N?(?:[);/ ]|$)",
                model: "Smart 3"
            },
            {
                regex: "Vodafone[ _]785(?:[);/ ]|$)",
                model: "Smart 4 Mini"
            },
            {
                regex: "Vodafone[ _]890N(?:[);/ ]|$)",
                model: "Smart 4 Turbo"
            },
            {
                regex: "Vodafone[ _]985N(?:[);/ ]|$)",
                model: "Smart 4 Power"
            },
            {
                regex: "VodafoneSmartChat",
                model: "Smart Chat"
            },
            {
                regex: "VF-696",
                model: "Smart Grand 6"
            },
            {
                regex: "VF-795",
                model: "Smart Speed 6"
            },
            {
                regex: "VF-895N",
                model: "Smart Prime 6"
            },
            {
                regex: "VF-1397",
                model: "Tab Speed 6",
                device: "tablet"
            },
            {
                regex: "VF-1497",
                model: "Tab Prime 6",
                device: "tablet"
            },
            {
                regex: "VFD 1100",
                device: "tablet",
                model: "Tab Mini 7"
            },
            {
                regex: "VFD 1300",
                device: "tablet",
                model: "Smart Tab N8"
            },
            {
                regex: "VFD 1400",
                device: "tablet",
                model: "Tab Prime 7"
            },
            {
                regex: "Smart ?Tab ?3G",
                device: "tablet",
                model: "Smart Tab 3G"
            },
            {
                regex: "Smart ?Tab ?4G",
                device: "tablet",
                model: "Smart Tab 4G"
            },
            {
                regex: "Smart ?Tab ?4",
                model: "Smart Tab 4",
                device: "tablet"
            },
            {
                regex: "SmartTab7[);/ -]",
                model: "Smart Tab 7",
                device: "tablet"
            },
            {
                regex: "SmartTab10[);/ -]",
                model: "Smart Tab 10",
                device: "tablet"
            },
            {
                regex: "Smart ?Tab ?II ?7",
                model: "Smart Tab II 7",
                device: "tablet"
            },
            {
                regex: "Smart ?Tab ?II ?10",
                model: "Smart Tab II 10",
                device: "tablet"
            },
            {
                regex: "Smart ?Tab ?III ?7",
                model: "Smart Tab III 7",
                device: "tablet"
            },
            {
                regex: "Smart ?Tab ?III ?10",
                model: "Smart Tab III 10",
                device: "tablet"
            },
            {
                regex: "VFD[ _]([0-9]+)(?:[);/ ]|$)",
                model: "VFD $1"
            },
            {
                regex: "Vodafone[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Vodafone[ _-]([a-z0-9_-]+)",
                model: "$1"
            }
        ]
    },
    Vonino: {
        regex: "Vonino|Epic (?:E8|P7)|Gyga[ _](?:X|S|QS|XS)|Jax[ _](?:QS|[SXQN]|Mini)|Magnet[ _]M[19]|Navo_QS|Onyx_(QS|Z)|Orin_QS|Pluri[ _](?:[BCMQ]7|[CQM]8)|Sirius_QS|Volt[ _][XS]|Xavy_(T7|L8)|Xylo[ _][XSPQT]|Zun[ _]X[OS]?|JAX_N",
        device: "smartphone",
        models: [
            {
                regex: "Zun[ _]XO",
                model: "Zun XO"
            },
            {
                regex: "Zun[ _]XS",
                model: "Zun XS"
            },
            {
                regex: "Zun[ _]X",
                model: "Zun X"
            },
            {
                regex: "Xylo[ _]([PSXQT])",
                model: "Xylo $1"
            },
            {
                regex: "Volt[ _]S_A7",
                model: "Volt S A7"
            },
            {
                regex: "Volt[ _]S",
                model: "Volt S"
            },
            {
                regex: "Volt[ _]X",
                model: "Volt X"
            },
            {
                regex: "Gyga[ _]QS",
                model: "Gyga QS"
            },
            {
                regex: "Gyga[ _]XS",
                model: "Gyga XS"
            },
            {
                regex: "Gyga[ _](S|X)",
                model: "Gyga $1"
            },
            {
                regex: "Jax[ _]QS",
                model: "Jax QS"
            },
            {
                regex: "Jax[ _]S_A7",
                model: "Jax S A7"
            },
            {
                regex: "Jax[ _]([SQXN])",
                model: "Jax $1"
            },
            {
                regex: "Jax[ _]Mini",
                model: "Jax Mini"
            },
            {
                regex: "Epic (E8|P7)",
                model: "Epic $1",
                device: "tablet"
            },
            {
                regex: "Pluri[ _](B|C|M|Q)7",
                model: "Pluri $17",
                device: "tablet"
            },
            {
                regex: "Pluri[ _]([CQM])8",
                model: "Pluri $18",
                device: "tablet"
            },
            {
                regex: "Magnet[ _]M([19])",
                model: "Magnet M$1",
                device: "tablet"
            },
            {
                regex: "Navo_QS",
                model: "Navo QS",
                device: "tablet"
            },
            {
                regex: "Onyx_(QS|Z)",
                model: "Onyx $1",
                device: "tablet"
            },
            {
                regex: "Orin_QS",
                model: "Orin QS",
                device: "tablet"
            },
            {
                regex: "Sirius_QS",
                model: "Sirius QS",
                device: "tablet"
            },
            {
                regex: "Xavy_T7",
                model: "Xavy T7",
                device: "tablet"
            },
            {
                regex: "Xavy_L8",
                model: "Xavy L8",
                device: "tablet"
            }
        ]
    },
    Vorago: {
        regex: "VORAGO",
        device: "smartphone",
        models: [
            {
                regex: "CELL-500",
                model: "CELL-500"
            }
        ]
    },
    Voto: {
        regex: "VOTO[ _\\-]|VT8[89]8(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "VOTO[ _\\-]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "VOTO[ _\\-]?([^);/ ]+)",
                model: "$1"
            },
            {
                regex: "(VT8[89]8)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Voxtel: {
        regex: "Voxtel_([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Vulcan: {
        regex: "(?:VP5004A|HT0704W08|VS5513|VS4011|VR6031)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(VP5004A|VR6031)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "VS5513(?:[);/ ]|$)",
                model: "Tempo S13"
            },
            {
                regex: "VS4011(?:[);/ ]|$)",
                model: "Tempo S11"
            },
            {
                regex: "HT0704W08",
                model: "Koral 7W4",
                device: "tablet"
            }
        ]
    },
    Walton: {
        regex: "Walton|Walpad|Primo[ _](C[1234]?|D[1-689]|E[1-589]|F8s|S7|EF[23]?|EM|F[1-79]i?|G[1-9]|GF[234]?|GH[23]?|GM|H[2-689M]|H7s|N[F1]?|NX2?|R[1-46]|R[HM]2?|RX[23]?|S[1-6]|V1|X[1-4]|Z|ZX)",
        device: "smartphone",
        models: [
            {
                regex: "Walpad ([^;/]+) Build",
                device: "tablet",
                model: "Primo Walpad $1"
            },
            {
                regex: "Primo S6 infinity",
                model: "Primo S6 Infinity"
            },
            {
                regex: "Primo H8 Pro(?:[);/ ]|$)",
                model: "Primo H8 Pro"
            },
            {
                regex: "Primo H8(?:[);/ ]|$)",
                model: "Primo H8 Turbo"
            },
            {
                regex: "Primo[ _]([^;/)]+)(?: Build|[;)])",
                model: "Primo $1"
            },
            {
                regex: "Walton[ _]([^;/)]+)(?: Build|[;)])",
                model: "$1"
            }
        ]
    },
    WellcoM: {
        regex: "WELLCOM[ _\\-/]([a-z0-9]+)",
        device: "smartphone",
        model: "$1"
    },
    Wexler: {
        regex: "Wexler|(?:ULTIMA 7 TWIST PLUS|TAB10iQ3G|TAB[ _]10Q)(?:[);/ ]|$)|ZEN[ _](?:4\\.[57]|5)",
        device: "tablet",
        models: [
            {
                regex: "(?:Wexler[ _\\-\\.])?ZEN[ _]4\\.5(?:[);/ ]|$)",
                model: "ZEN 4.5",
                device: "smartphone"
            },
            {
                regex: "(?:Wexler[ _\\-\\.])?ZEN[ _]4\\.7(?:[);/ ]|$)",
                model: "ZEN 4.7",
                device: "smartphone"
            },
            {
                regex: "(?:Wexler[ _\\-\\.])?ZEN[ _]5(?:[);/ ]|$)",
                model: "ZEN 5",
                device: "smartphone"
            },
            {
                regex: "(?:Wexler[ _\\-\\.])?TAB[ _]10Q(?:[);/ ]|$)",
                model: "TAB 10Q"
            },
            {
                regex: "TAB10iQ3G(?:[);/ ]|$)",
                model: "TAB 10iQ 3G"
            },
            {
                regex: "Wexler[ _\\-\\.]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Wexler[ _\\-\\.]([^);/]+)(?:[);/]|$)",
                model: "$1"
            },
            {
                regex: "(ULTIMA 7 TWIST PLUS)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Inco: {
        regex: "(?:Inco[ _](Aurora II|Sphere|Plain[_ ]2S?|Plain2 S|Flex 2S|S4|Bloom 2)|(Horizon_S|Horizon \\+))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:Inco[ _])?(Plain[_ ]2S?|Horizon_S|Horizon \\+|Aurora II|Flex 2S|S4|Bloom 2)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Plain2 S",
                model: "Plain 2S"
            },
            {
                regex: "Inco Sphere(?:[);/ ]|$)",
                device: "tablet",
                model: "Sphere"
            }
        ]
    },
    Wink: {
        regex: "(?<!mismart )Wink[_ ]",
        device: "smartphone",
        models: [
            {
                regex: "Wink[_ ]((?:Glory|World|Share|City)(?:[_ ](?:SE|S))?)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Wink[ _](Primo|Highway)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    Wiko: {
        regex: "(?:WIKO[_ -])|(?:WIKO-)?CINK_[a-z0-9_]+|(?:WIKO-)?HIGHWAY_[a-z0-9_]+|(?:WIKO-)?(?:Cink([^/;]*)|Highway([^/;]*)|Iggy|Stairway|Rainbow ?(Jam|Lite|Up)?|Darkside|Darkmoon|Darkfull|Darknight|Freddy|FEVER|Jerry[2]?|Sublim|Ozzy|JIMMY|Barry|Birdy|Bloom|Getaway|Goa(?!nna)|Kite|Robby|Lenny[2-9]?|Slide|Sunset[2-9]?|Sunny[2-9]?|Tommy[2-9]?|PULP(?: Fab)?|Wax|HARRY|Ridge(?: Fab)?|U FEEL(?: Prime| Lite)?|U PULSE(?: LITE)?|View2 Go|View XL|View Prime)(?: Plus)?(?: 4G)?(?: Build|$)?|W_(?:C8[06]0|K[346]00|P130|P200|C200SN)|WC300|W-(?:V7[23]0|V8[30]0|P[36]11|K420|K510S?|K130)-(?:TMV|TIM|TVM|EEA|SUN|SWI|OPE|BYT|DU|TH)|WIM Lite|W-K360-TV|W-V600|W-K200|W-U300|U307AS|CINK PEAX 2|HIGHWAY PURE|C210AE|v3913",
        device: "smartphone",
        models: [
            {
                regex: "(?:WIKO-)?Cink Peax 2",
                model: "Cink Peax 2"
            },
            {
                regex: "(?:Wiko-)?Cink([^/;]*) Build",
                model: "Cink$1"
            },
            {
                regex: "(?:WIKO-)?CINK_([a-z0-9_]+)",
                model: "Cink $1"
            },
            {
                regex: "(?:WIKO-)?HIGHWAY PURE",
                model: "Highway Pure"
            },
            {
                regex: "(?:WIKO-)?HIGHWAY STAR",
                model: "Highway Star"
            },
            {
                regex: "(?:Wiko-)?Highway([^/;]*) Build",
                model: "Highway$1"
            },
            {
                regex: "(?:WIKO-)?HIGHWAY_([a-z0-9_]+)",
                model: "Highway $1"
            },
            {
                regex: "(?:WIKO-)?Iggy",
                model: "Iggy"
            },
            {
                regex: "(?:WIKO-)?FEVER",
                model: "Fever"
            },
            {
                regex: "(?:WIKO-)?Stairway",
                model: "Stairway"
            },
            {
                regex: "(?:WIKO-)?Ridge Fab 4G",
                model: "Ridge Fab 4G"
            },
            {
                regex: "(?:WIKO-)?Ridge 4G",
                model: "Ridge 4G"
            },
            {
                regex: "(?:WIKO-)?Ridge",
                model: "Ridge"
            },
            {
                regex: "(?:WIKO-)?Rainbow ([^/;]+) Build",
                model: "Rainbow $1"
            },
            {
                regex: "(?:WIKO-)?Rainbow",
                model: "Rainbow"
            },
            {
                regex: "(?:WIKO-)?Darkside",
                model: "Darkside"
            },
            {
                regex: "(?:WIKO-)?Darkmoon",
                model: "Darkmoon"
            },
            {
                regex: "(?:WIKO-)?Darkfull",
                model: "Darkfull"
            },
            {
                regex: "(?:WIKO-)?Darknight",
                model: "Darknight"
            },
            {
                regex: "(?:WIKO-)?Sublim",
                model: "Sublim"
            },
            {
                regex: "(?:WIKO-)?Ozzy",
                model: "Ozzy"
            },
            {
                regex: "(?:WIKO-)?Barry",
                model: "Barry"
            },
            {
                regex: "(?:WIKO-)?Birdy",
                model: "Birdy"
            },
            {
                regex: "(?:WIKO-)?Bloom",
                model: "Bloom"
            },
            {
                regex: "(?:WIKO-)?JIMMY",
                model: "Jimmy"
            },
            {
                regex: "JERRY MAX",
                model: "Jerry Max"
            },
            {
                regex: "W_K300",
                model: "Jerry 3"
            },
            {
                regex: "W-K420-TVM",
                model: "Jerry 4"
            },
            {
                regex: "(?:WIKO-)?Jerry2",
                model: "Jerry 2"
            },
            {
                regex: "(?:WIKO-)?Jerry",
                model: "Jerry"
            },
            {
                regex: "(?:WIKO-)?Getaway",
                model: "Getaway"
            },
            {
                regex: "(?:WIKO-)?Goa(?!nna)",
                model: "Goa"
            },
            {
                regex: "(?:WIKO-)?Freddy",
                model: "Freddy"
            },
            {
                regex: "(?:WIKO-)?Kite",
                model: "Kite"
            },
            {
                regex: "W_K400",
                model: "Lenny 5"
            },
            {
                regex: "C210AE(?:[);/ ]|$)",
                model: "Life"
            },
            {
                regex: "U307AS(?:[);/ ]|$)",
                model: "Life 2"
            },
            {
                regex: "v3913(?:[);/ ]|$)",
                model: "Kenny"
            },
            {
                regex: "(?:WIKO-)?Lenny[ -_]?3 Max",
                model: "Lenny 3 Max"
            },
            {
                regex: "(?:WIKO-)?Lenny[ -_]?4 Plus",
                model: "Lenny 4 Plus"
            },
            {
                regex: "(?:WIKO-)?Lenny[ -_]?([2-9])",
                model: "Lenny $1"
            },
            {
                regex: "(?:WIKO-)?Lenny",
                model: "Lenny"
            },
            {
                regex: "(?:WIKO-)?Slide",
                model: "Slide"
            },
            {
                regex: "(?:WIKO-)?Sunset2",
                model: "Sunset 2"
            },
            {
                regex: "(?:WIKO-)?Sunset",
                model: "Sunset"
            },
            {
                regex: "(?:WIKO-)?Sunny3",
                model: "Sunny 3"
            },
            {
                regex: "W-K200",
                model: "Sunny 3 Plus"
            },
            {
                regex: "(?:WIKO-)?Sunny2 Plus",
                model: "Sunny 2 Plus"
            },
            {
                regex: "(?:WIKO-)?Sunny2",
                model: "Sunny 2"
            },
            {
                regex: "W-K360-TV",
                model: "Sunny 4 Plus"
            },
            {
                regex: "W-K130-TMV",
                model: "Sunny 4"
            },
            {
                regex: "(?:WIKO-)?Sunny",
                model: "Sunny"
            },
            {
                regex: "(?:W_K600|Tommy3|W_C200SN)",
                model: "Tommy 3"
            },
            {
                regex: "(?:WIKO-)?Tommy2 Plus",
                model: "Tommy 2 Plus"
            },
            {
                regex: "(?:WIKO-)?Tommy2",
                model: "Tommy 2"
            },
            {
                regex: "(?:WIKO-)?Tommy",
                model: "Tommy"
            },
            {
                regex: "(?:WIKO-)?Wax",
                model: "Wax"
            },
            {
                regex: "(?:WIKO-)?HARRY",
                model: "Harry"
            },
            {
                regex: "W-V600",
                model: "Harry 2"
            },
            {
                regex: "(?:WIKO-)?WIM Lite",
                model: "WIM Lite"
            },
            {
                regex: "(?:WIKO-)?Pulp Fab 4G",
                model: "Pulp Fab 4G"
            },
            {
                regex: "(?:WIKO-)?Pulp Fab",
                model: "Pulp Fab"
            },
            {
                regex: "(?:WIKO-)?Pulp 4G",
                model: "Pulp 4G"
            },
            {
                regex: "(?:WIKO-)?Pulp",
                model: "Pulp"
            },
            {
                regex: "(?:WIKO-)?Robby",
                model: "Robby"
            },
            {
                regex: "(?:WIKO-)?U PULSE LITE",
                model: "U Pulse Lite"
            },
            {
                regex: "(?:WIKO-)?U PULSE",
                model: "U Pulse"
            },
            {
                regex: "(?:WIKO-)?U FEEL LITE",
                model: "U Feel Lite"
            },
            {
                regex: "(?:WIKO-)?U FEEL PRIME",
                model: "U Feel Prime"
            },
            {
                regex: "(?:WIKO-)?U FEEL",
                model: "U Feel"
            },
            {
                regex: "(?:WIKO-)?View2 Go",
                model: "View 2 Go"
            },
            {
                regex: "(?:WIKO-)?View XL",
                model: "View XL"
            },
            {
                regex: "(?:WIKO-)?View Prime",
                model: "View Prime"
            },
            {
                regex: "WC300",
                model: "View Lite"
            },
            {
                regex: "W_C800",
                model: "View 2"
            },
            {
                regex: "W_C860",
                model: "View 2 Pro"
            },
            {
                regex: "W_P200",
                model: "View Max"
            },
            {
                regex: "W_P130",
                model: "View Go"
            },
            {
                regex: "W-V800-(TVM|TIM|EEA|OPE|DU)",
                model: "View 3 Lite"
            },
            {
                regex: "W-K130-(?:OPE|EEA)",
                model: "Y50"
            },
            {
                regex: "W-K420-EEA",
                model: "Y50"
            },
            {
                regex: "W-K510-(?:TVM|EEA|OPE|SUN|BYT|TH)|W-K510S-SWI",
                model: "Y60"
            },
            {
                regex: "W-V720-(?:EEA|OPE|SUN)",
                model: "Y80"
            },
            {
                regex: "W-P311-(?:EEA|OPE|TVM)",
                model: "View 3"
            },
            {
                regex: "W-P611-(?:EEA|OPE)",
                model: "View 3 Pro"
            },
            {
                regex: "W-V830-EEA",
                model: "View 4"
            },
            {
                regex: "W-V730-EEA",
                model: "View 4 Lite"
            },
            {
                regex: "W-U300(?:[);/ ]|$)",
                model: "Ride"
            },
            {
                regex: "Wiko ([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "Wiko ([^/; ]+)",
                model: "$1"
            }
        ]
    },
    Wieppo: {
        regex: "Wieppo (S6 Lite|S[658]|E1)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Weimei: {
        regex: "weplus_3",
        device: "smartphone",
        models: [
            {
                regex: "weplus_3",
                model: "WePlus 3"
            }
        ]
    },
    Wileyfox: {
        regex: "(?:Wileyfox [^/]+)|Swift 2(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Wileyfox Spark \\+",
                model: "Spark +"
            },
            {
                regex: "Wileyfox Spark X",
                model: "Spark X"
            },
            {
                regex: "Wileyfox (Spark|Swift)",
                model: "$1"
            },
            {
                regex: "Wileyfox ([^/)]+)(?: Build|\\))",
                model: "$1"
            },
            {
                regex: "Swift 2 (X|Plus)(?:[);/ ]|$)",
                model: "Swift 2 $1"
            },
            {
                regex: "Swift 2(?:[);/ ]|$)",
                model: "Swift 2"
            }
        ]
    },
    Wolder: {
        regex: "miSmart|miTab|WIAM \\#24|WOLDER",
        device: "smartphone",
        models: [
            {
                regex: "WIAM \\#24",
                model: "Wiam #24"
            },
            {
                regex: "WOLDER_WIAM_65",
                model: "Wiam #65"
            },
            {
                regex: "miSmart[ \\-_]?([^/]+) Build",
                model: "miSmart $1"
            },
            {
                regex: "miTab[ \\-_]?([^/)]+)(?: Build|\\))",
                device: "tablet",
                model: "miTab $1"
            }
        ]
    },
    Wolfgang: {
        regex: "AT[ _-]AS([0-9A-Z]+)(?:[);/ ]|$)",
        device: "smartphone",
        model: "AT-AS$1"
    },
    Wonu: {
        regex: "Wonu ([a-z0-9]+)",
        device: "feature phone",
        model: "$1"
    },
    Woo: {
        regex: "SP5026i-Scorpio",
        device: "smartphone",
        models: [
            {
                regex: "SP5026i-Scorpio",
                model: "Scorpio"
            }
        ]
    },
    Woxter: {
        regex: "Woxter[ _]([^/;)]+)(?: Build|\\))|Nimbus 101Q",
        device: "tablet",
        models: [
            {
                regex: "Nimbus 101Q",
                model: "Nimbus 101Q"
            },
            {
                regex: "Woxter[ _]([^/;)]+)(?: Build|\\))",
                model: "$1"
            }
        ]
    },
    "X-View": {
        regex: "ZEN_U5\\+|AMBER_KIDS|Proton_Amber_HD|PROTON_JADE_2_PRO",
        device: "smartphone",
        models: [
            {
                regex: "ZEN_U5\\+",
                model: "ZEN U5+"
            },
            {
                regex: "AMBER_KIDS",
                device: "tablet",
                model: "Amber Kids"
            },
            {
                regex: "Proton_Amber_HD",
                device: "tablet",
                model: "Proton Amber HD"
            },
            {
                regex: "PROTON_JADE_2_PRO",
                device: "tablet",
                model: "Proton Jade 2 Pro"
            }
        ]
    },
    POCO: {
        regex: "(?:POCO[ _](?:X[23]|F2 PRO|M[32])|M2010J19C[GI]|M2007J20C[ITG]|M2012K11AG|M2006C3MI|M2004J19PI|M2102J20SG)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "POCO X2(?:[);/ ]|$)",
                model: "X2"
            },
            {
                regex: "(?:M2010J19C[GI]|POCO M3)(?:[);/ ]|$)",
                model: "M3"
            },
            {
                regex: "M2012K11AG(?:[);/ ]|$)",
                model: "F3"
            },
            {
                regex: "M2004J19PI(?:[);/ ]|$)",
                model: "M2"
            },
            {
                regex: "POCO M2 Pro(?:[);/ ]|$)",
                model: "M2 Pro"
            },
            {
                regex: "(?:M2007J20C[GT]|POCO X3 NFC)(?:[);/ ]|$)",
                model: "X3 NFC"
            },
            {
                regex: "(?:M2007J20CI|POCO X3)(?:[);/ ]|$)",
                model: "X3"
            },
            {
                regex: "M2102J20SG(?:[);/ ]|$)",
                model: "X3 Pro"
            },
            {
                regex: "M2006C3MI(?:[);/ ]|$)",
                model: "C3"
            },
            {
                regex: "POCO F2 PRO(?:[);/ ]|$)",
                model: "F2 Pro"
            }
        ]
    },
    Xiaomi: {
        regex: "Xiaomi(?!/(?:Miui|Mint[ ])Browser)|Mi9 Pro 5G|(?:MI [a-z0-9]+|Mi-4c|MI-One[ _]?[a-z0-9]+|MIX(?: 2S?)?)(?:[);/ ]|$)|HM (?:[^/;]+) (?:Build|MIUI)|(?:2014501|2014011|201481[12378]|201302[23]|2013061) Build|Redmi|POCOPHONE|(?:SHARK )?(KLE|MBU)-[AH]0|SKR-[AH]0|SKW-[AH]0|POCO F1|DLT-[AH]0|MIBOX[234]([_ ]PRO)?|MiTV4[CSX]?|MiTV-(MSSP[01]|AXSO0)|AWM-A0|MI CC 9 Meitu Edition|MiBOX1S|MiTV4A|M2006J10C|M2006C3(?:L[IGC]|LVG|MN?G)|M2007J1(?:7[CGI]|SC)|M2002J9[EG]|HM2014819|WT88047|M2004J(?:7[AB]|19)C|M2012K11C|M2011K2[CG]|M2006C3[ML]II|M2003J15SC|M2007J3S[ICYGP]|M2007J22[CG]|M2101K6[GI]|M2101K(?:[79]AG|7AI)|M2010J19S[CGYI]|HM NOTE 1(?:LTE|W)|MI[_ ]PLAY|XIG01|MI_(NOTE_Pro|5X|4i|(?:A2|8)_Lite)",
        device: "smartphone",
        models: [
            {
                regex: "SKR-[AH]0",
                model: "Black Shark"
            },
            {
                regex: "AWM-A0",
                model: "Black Shark Helo"
            },
            {
                regex: "SKW-[AH]0",
                model: "Black Shark 2"
            },
            {
                regex: "DLT-[AH]0",
                model: "Black Shark 2 Pro"
            },
            {
                regex: "(?:SHARK )?KLE-A0",
                model: "Black Shark 3"
            },
            {
                regex: "(?:SHARK )?KLE-H0",
                model: "Black Shark 3 5G"
            },
            {
                regex: "(?:SHARK )?MBU-H0",
                model: "Black Shark 3 Pro 5G"
            },
            {
                regex: "(?:SHARK )?MBU-A0",
                model: "Black Shark 3 Pro"
            },
            {
                regex: "Xiaomi_2014501|2014501 Build",
                model: "Hongmi 4G"
            },
            {
                regex: "Xiaomi_2014011|2014011 Build",
                model: "Hongmi 1S"
            },
            {
                regex: "Xiaomi_201302[23]|201302[23] Build",
                model: "Hongmi"
            },
            {
                regex: "Xiaomi[_-]2014818|2014818 Build",
                model: "Hongmi 2 3G"
            },
            {
                regex: "Xiaomi_2014817|2014817 Build",
                model: "Hongmi 2"
            },
            {
                regex: "Xiaomi[_-]201481[123]|201481[123] Build",
                model: "Hongmi 2 4G"
            },
            {
                regex: "MI[_ ]PLAY(?:[);/ ]|$)",
                model: "MI Play"
            },
            {
                regex: "Mi 9 SE(?:[);/ ]|$)",
                model: "MI 9 SE"
            },
            {
                regex: "MI CC 9 Meitu Edition(?:[);/ ]|$)",
                model: "MI CC 9"
            },
            {
                regex: "Xiaomi_M2001J2E_TD-LTE(?:[);/ ]|$)",
                model: "MI 10"
            },
            {
                regex: "M2011K2[CG](?:[);/ ]|$)",
                model: "MI 11"
            },
            {
                regex: "M2007J3S[CYP](?:[);/ ]|$)",
                model: "MI 10T 5G"
            },
            {
                regex: "M2007J3S[GI](?:[);/ ]|$)",
                model: "MI 10T Pro 5G"
            },
            {
                regex: "M2007J17G(?:[);/ ]|$)",
                model: "MI 10T Lite 5G"
            },
            {
                regex: "M2007J1SC(?:[);/ ]|$)",
                model: "MI 10 Ultra 5G"
            },
            {
                regex: "(?:M2002J9[EG]|XIG01)(?:[);/ ]|$)",
                model: "MI 10 Lite 5G"
            },
            {
                regex: "M2007J17I(?:[);/ ]|$)",
                model: "MI 10i"
            },
            {
                regex: "M2101K9AG(?:[);/ ]|$)",
                model: "MI 11 Lite"
            },
            {
                regex: "MI[ _]8[ _]Lite(?:[);/ ]|$)",
                model: "MI 8 Lite"
            },
            {
                regex: "Mi 9T Pro(?:[);/ ]|$)",
                model: "MI 9T Pro"
            },
            {
                regex: "Mi9 Pro 5G(?:[);/ ]|$)",
                model: "MI 9 Pro 5G"
            },
            {
                regex: "MI ([89]) Lite(?:[);/ ]|$)",
                model: "MI $1 Lite"
            },
            {
                regex: "MI 5s Plus(?:[);/ ]|$)",
                model: "MI 5s Plus"
            },
            {
                regex: "Xiaomi_2013061|2013061 Build",
                model: "MI 3"
            },
            {
                regex: "Mi-4c(?:[);/ ]|$)",
                model: "MI 4C"
            },
            {
                regex: "MI 4W(?:[);/ ]|$)",
                model: "MI 4W"
            },
            {
                regex: "Mi_4i(?:[);/ ]|$)",
                model: "MI 4i"
            },
            {
                regex: "MI MAX 3(?:[);/ ]|$)",
                model: "MI MAX 3"
            },
            {
                regex: "MI MAX 2(?:[);/ ]|$)",
                model: "MI MAX 2"
            },
            {
                regex: "Mi[ _]A2[ _]Lite(?:[);/ ]|$)",
                model: "MI A2 Lite"
            },
            {
                regex: "MIX 3(?:[);/ ]|$)",
                model: "MI MIX 3"
            },
            {
                regex: "MIX 2S(?:[);/ ]|$)",
                model: "MI MIX 2S"
            },
            {
                regex: "MIX 2(?:[);/ ]|$)",
                model: "MI MIX 2"
            },
            {
                regex: "MIX(?:[);/ ]|$)",
                model: "MI MIX"
            },
            {
                regex: "POCOPHONE[ _]F1|POCO F1",
                model: "Pocophone F1"
            },
            {
                regex: "Redmi 5 Plus",
                model: "Redmi 5 Plus"
            },
            {
                regex: "WT88047(?:[);/ ]|$)",
                model: "Redmi 2"
            },
            {
                regex: "HM2014819(?:[);/ ]|$)",
                model: "Redmi 2 Pro"
            },
            {
                regex: "HM 2A(?:[);/ ]|$)",
                model: "Redmi 2A"
            },
            {
                regex: "HM 1S[CW]?(?:[);/ ]|$)",
                model: "Redmi 1S"
            },
            {
                regex: "HM 1(?:[);/ ]|$)",
                model: "Redmi 1"
            },
            {
                regex: "M2004J7AC(?:[);/ ]|$)",
                model: "Redmi 10X"
            },
            {
                regex: "(?:M2004J19C|M2006C3MII)(?:[);/ ]|$)",
                model: "Redmi 9"
            },
            {
                regex: "M2010J19SI(?:[);/ ]|$)",
                model: "Redmi 9 Power"
            },
            {
                regex: "M2006C3L[GCI](?:[);/ ]|$)",
                model: "Redmi 9A"
            },
            {
                regex: "M2006C3LII(?:[);/ ]|$)",
                model: "Redmi 9i"
            },
            {
                regex: "M2006C3MG(?:[);/ ]|$)",
                model: "Redmi 9C"
            },
            {
                regex: "M2006C3LVG(?:[);/ ]|$)",
                model: "Redmi 9AT"
            },
            {
                regex: "M2010J19S[GY](?:[);/ ]|$)",
                model: "Redmi 9T"
            },
            {
                regex: "M2006C3MNG(?:[);/ ]|$)",
                model: "Redmi 9C NFC"
            },
            {
                regex: "M2004J7BC(?:[);/ ]|$)",
                model: "Redmi 10X Pro"
            },
            {
                regex: "Redmi K20 Pro(?:[);/ ]|$)",
                model: "Redmi K20 Pro"
            },
            {
                regex: "Redmi K30 5G(?:[);/ ]|$)",
                model: "Redmi K30 5G"
            },
            {
                regex: "M2012K11C(?:[);/ ]|$)",
                model: "Redmi K40 Pro"
            },
            {
                regex: "M2006J10C(?:[);/ ]|$)",
                model: "Redmi K30 Ultra"
            },
            {
                regex: "Redmi Y1 Lite(?:[);/ ]|$)",
                model: "Redmi Y1 Lite"
            },
            {
                regex: "MI PAD 4 PLUS(?:[);/ ]|$)",
                model: "Mi Pad 4 Plus",
                device: "tablet"
            },
            {
                regex: "MI PAD 4(?:[);/ ]|$)",
                model: "Mi Pad 4",
                device: "tablet"
            },
            {
                regex: "MI PAD 3(?:[);/ ]|$)",
                model: "Mi Pad 3",
                device: "tablet"
            },
            {
                regex: "MI PAD 2(?:[);/ ]|$)",
                model: "Mi Pad 2",
                device: "tablet"
            },
            {
                regex: "MI PAD(?:[);/ ]|$)",
                model: "Mi Pad",
                device: "tablet"
            },
            {
                regex: "MIBOX3[ _]Pro(?:[);/ ]|$)",
                model: "Mi Box 3 Pro",
                device: "tv"
            },
            {
                regex: "MIBOX([234])(?:[);/ ]|$)",
                model: "Mi Box $1",
                device: "tv"
            },
            {
                regex: "MiBOX1S(?:[);/ ]|$)",
                model: "Mi Box 1S",
                device: "tv"
            },
            {
                regex: "MiTV-MSSP1(?:[);/ ]|$)",
                model: "MiTV 4S",
                device: "tv"
            },
            {
                regex: "(?:MiTV-AXSO0|MiTV4(?:A|-ANSM0)|MiTV-MSSP0)(?:[);/ ]|$)",
                model: "MiTV 4A",
                device: "tv"
            },
            {
                regex: "(MiTV)(4[CSX]|4)(?:[);/ ]|$)",
                model: "$1 $2",
                device: "tv"
            },
            {
                regex: "HM NOTE 1W(?:[);/ ]|$)",
                device: "phablet",
                model: "Redmi Note"
            },
            {
                regex: "HM NOTE 1TD (?:Build|MIUI)",
                device: "phablet",
                model: "Hongmi Note 1TD"
            },
            {
                regex: "HM NOTE 1(?:LTE|S)(?:W|GLOBAL|TD)? (?:Build|MIUI)|HM NOTE 1LTE",
                device: "phablet",
                model: "Redmi Note 4G"
            },
            {
                regex: "Redmi Note 5A Prime",
                model: "Redmi Note 5A Prime",
                device: "phablet"
            },
            {
                regex: "M2010J19SC(?:[);/ ]|$)",
                model: "Redmi Note 9",
                device: "phablet"
            },
            {
                regex: "M2003J15SC(?:[);/ ]|$)",
                model: "Redmi Note 10X",
                device: "phablet"
            },
            {
                regex: "M2007J22G(?:[);/ ]|$)",
                model: "Redmi Note 9T 5G",
                device: "phablet"
            },
            {
                regex: "M2007J22C(?:[);/ ]|$)",
                model: "Redmi Note 9 5G",
                device: "phablet"
            },
            {
                regex: "M2007J17C(?:[);/ ]|$)",
                model: "Redmi Note 9 Pro 5G",
                device: "phablet"
            },
            {
                regex: "M2101K7A[GI]",
                model: "Redmi Note 10",
                device: "phablet"
            },
            {
                regex: "M2101K6[GI]",
                model: "Redmi Note 10 Pro",
                device: "phablet"
            },
            {
                regex: "Redmi Note ([5-9]) Pro(?:[);/ ]|$)",
                model: "Redmi Note $1 Pro",
                device: "phablet"
            },
            {
                regex: "Redmi[ _]Note[ _]([^;/) ]+)?",
                model: "Redmi Note $1",
                device: "phablet"
            },
            {
                regex: "Redmi[ _]([^;/) ]+)?",
                model: "Redmi $1"
            },
            {
                regex: "MI_NOTE_Pro",
                model: "MI Note Pro",
                device: "phablet"
            },
            {
                regex: "Mi Note 10 Pro",
                model: "Mi Note 10 Pro",
                device: "phablet"
            },
            {
                regex: "MI[ _]Note[ _]([^;/) ]+)?",
                model: "MI Note $1",
                device: "phablet"
            },
            {
                regex: "(MI(?:-One)?[ _](?:[^;/]*))Build",
                model: "$1"
            },
            {
                regex: "(MI[ _][a-z0-9]+|MI-One[ _]?[a-z0-9]+)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "HM Note ([^/;]+) (?:Build|MIUI)",
                device: "phablet",
                model: "Note"
            },
            {
                regex: "HM ([^/;]+) (?:Build|MIUI)",
                model: "HM $1"
            },
            {
                regex: "Xiaomi[ _-]([^/;]+)(?: Build|$)",
                model: "$1"
            }
        ]
    },
    Xion: {
        regex: "XI-CE(?:655|U[48])",
        device: "smartphone",
        models: [
            {
                regex: "XI-CE(655|U[48])",
                model: "CE$1"
            }
        ]
    },
    Xolo: {
        regex: "Xolo|(?:Q600|Q700s?|Q800|Q1000s|Q1000[ _]Opus|Q1010i|Q2000|Omega[ _]5.[05]|Era5X|Era[ _]2V|Era_4X(?:_2GB)?)(?:[);/ ]|$)|BLACK-1XM",
        device: "smartphone",
        models: [
            {
                regex: "BLACK-1XM",
                model: "Black 1X"
            },
            {
                regex: "Era_?([45])X(?:[);/ ]|$)",
                model: "Era $1X"
            },
            {
                regex: "Era_4X_2GB(?:[);/ ]|$)",
                model: "Era 4X 2GB"
            },
            {
                regex: "Era[ _]2V(?:[);/ ]|$)",
                model: "Era 2V"
            },
            {
                regex: "(Q600 Club|Q600|Q700s?|Q800|Q1000s Plus|Q1000s|Q1000[ _]Opus|Q1010i|Q2000|Omega[ _]5.[05])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Xolo[ _]?([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Xolo[ _]?([a-z0-9_-]+)",
                model: "$1"
            }
        ]
    },
    Yarvik: {
        regex: "Xenta[ \\-]Tab|Luna TAB|TAB09-410|TAB10-410|TAB07-485|TAB0[78]-200|TAB08-201-3G|TAB9-200|TAB09-211|TAB10-2[01]1|TAB13-201",
        device: "tablet",
        models: [
            {
                regex: "Luna TAB07-920N",
                model: "Luna 7"
            },
            {
                regex: "Luna TAB07-10[01]",
                model: "Luna 7c"
            },
            {
                regex: "Luna TAB274",
                model: "Luna 7c"
            },
            {
                regex: "Luna TAB474",
                model: "Luna 10"
            },
            {
                regex: "Luna TAB10-150",
                model: "Luna 10c"
            },
            {
                regex: "TAB09-410",
                model: "Noble 9.7"
            },
            {
                regex: "TAB10-410",
                model: "Noble 10.1"
            },
            {
                regex: "TAB07-485",
                model: "Noble Mini"
            },
            {
                regex: "Xenta-TAB07-21[01]",
                model: "Xenta 7c"
            },
            {
                regex: "TAB07-200",
                model: "Xenta 7ic"
            },
            {
                regex: "TAB08-200",
                model: "Xenta 8ic"
            },
            {
                regex: "TAB08-201-3G",
                model: "Xenta 8c"
            },
            {
                regex: "TAB9-200",
                model: "Xenta 9.7ic"
            },
            {
                regex: "TAB09-211",
                model: "Xenta 9.7ic+"
            },
            {
                regex: "TAB10-2[01]1",
                model: "Xenta 10ic"
            },
            {
                regex: "TAB13-201",
                model: "Xenta 13c"
            }
        ]
    },
    Yes: {
        regex: "M631Y|M685Y4|M651G_MY|YES (MPY(?:48|54))",
        device: "smartphone",
        models: [
            {
                regex: "M631Y",
                model: "Altitude"
            },
            {
                regex: "M651G_MY",
                model: "Altitude 2"
            },
            {
                regex: "M685Y4",
                model: "Altitude 3"
            },
            {
                regex: "YES (MPY(?:48|54))",
                model: "$1"
            }
        ]
    },
    Yezz: {
        regex: "Yezz|ANDY[ _]|(?:4E4|A5EI|LIV1)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "4E4",
                model: "Andy 4E4"
            },
            {
                regex: "Yezz-AC4EI",
                model: "Andy 4EI"
            },
            {
                regex: "YEZZ-A4M",
                model: "Andy A4M"
            },
            {
                regex: "A5EI",
                model: "Andy A5EI"
            },
            {
                regex: "LIV1",
                model: "LIV1"
            },
            {
                regex: "Andy[ _]([A-Z]*[0-9]\\.[0-9][A-Z0-9]*)(?:[ _](LTE))?",
                model: "Andy $1 $2"
            },
            {
                regex: "Andy[ _]([A-Z]*[0-9])([0-9][A-Z0-9]*)(?:[ _](LTE))?",
                model: "Andy $1.$2 $3"
            },
            {
                regex: "Andy[ _]([A-Z]*[0-9][A-Z0-9]+)(?:[ _](LTE))?",
                model: "Andy $1 $2"
            }
        ]
    },
    Yu: {
        regex: "(?:YU5[05]10[A]?|YU4711|AO5510|YU5050|YU501[14]|YU5551)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "YU5010[A]?(?:[);/ ]|$)",
                model: "Yuphoria"
            },
            {
                regex: "YU5011(?:[);/ ]|$)",
                model: "Yunique 2"
            },
            {
                regex: "YU5050(?:[);/ ]|$)",
                model: "Yutopia"
            },
            {
                regex: "AO5510(?:[);/ ]|$)",
                model: "Yureka"
            },
            {
                regex: "YU5551(?:[);/ ]|$)",
                model: "Yureka 2"
            },
            {
                regex: "YU5510[A]?(?:[);/ ]|$)",
                model: "Yureka Plus"
            },
            {
                regex: "YU4711(?:[);/ ]|$)",
                model: "Yunique"
            },
            {
                regex: "YU5014(?:[);/ ]|$)",
                model: "Ace"
            }
        ]
    },
    Yuandao: {
        regex: "N101[ _]DUAL(?:[ _]CORE)?(?:[ _]?2|\\|\\|)?(?:[ _]V11)?(?:[);/ ]|$)",
        device: "tablet",
        model: "N101"
    },
    Yusun: {
        regex: "Yusun|LA2-T",
        device: "smartphone",
        models: [
            {
                regex: "LA2-T",
                model: "LA2-T"
            },
            {
                regex: "Yusun ([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Yusun ([a-z0-9_\\-\\+]+)",
                model: "$1"
            }
        ]
    },
    Ytone: {
        regex: "YTONE[ _\\-]",
        device: "smartphone",
        models: [
            {
                regex: "YTONE[ _\\-]?([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "YTONE[ _\\-]?([^);/ ]+)",
                model: "$1"
            }
        ]
    },
    Zonda: {
        regex: "(ZM(?:CK|EM|TFTV|TN)[a-z0-9]+)|ZA409",
        device: "feature phone",
        models: [
            {
                regex: "ZA409",
                device: "smartphone",
                model: "Muzic"
            },
            {
                regex: "(ZM(?:CK|EM|TFTV|TN)[a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    ZYQ: {
        regex: "ZYQ-Q88|(Q(?:2602|262[436]|638|2688|272[89]|3022|3623|TAB Tab4|328 m9|328|668)|J77|Q[._](?:Up|Boss P99|Dee R09|Good M9|Hi|Hot|Me|Mate R99|Next|TOP-X8|You))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Q638",
                model: "I7"
            },
            {
                regex: "Q2624",
                model: "Cheer 3G"
            },
            {
                regex: "Q2602",
                model: "TV Next"
            },
            {
                regex: "Q2728",
                model: "Zone 3G"
            },
            {
                regex: "Q2729",
                model: "Q2729"
            },
            {
                regex: "Q2688",
                model: "Q2688"
            },
            {
                regex: "Q2623",
                model: "Win 3G"
            },
            {
                regex: "Q2626",
                model: "Care 3G"
            },
            {
                regex: "Q3623",
                model: "Braw 3G"
            },
            {
                regex: "Q3022",
                model: "Q3022"
            },
            {
                regex: "Q328 m9",
                model: "Q328 M9"
            },
            {
                regex: "Q328",
                model: "Speed 3G"
            },
            {
                regex: "Q668",
                model: "TV I4"
            },
            {
                regex: "J77",
                model: "Q.Dee"
            },
            {
                regex: "Q\\.Up C5",
                model: "Q.Up C5"
            },
            {
                regex: "Q\\.Up",
                model: "Q.Up"
            },
            {
                regex: "Q\\.Boss P99",
                model: "Q.Boss P99"
            },
            {
                regex: "Q[._]Dee R09",
                model: "Q.Dee R09"
            },
            {
                regex: "Q\\.Good M9",
                model: "Q.Good M9"
            },
            {
                regex: "Q[._]Hi S1",
                model: "Q.Hi S1"
            },
            {
                regex: "Q[._]Hi",
                model: "Q.Hi"
            },
            {
                regex: "Q[._]Hot P7 3G",
                model: "Q.Hot P7 3G"
            },
            {
                regex: "Q[._]Hot",
                model: "Q.Hot"
            },
            {
                regex: "Q[._]Me Phone7 3G",
                model: "Q.Me Phone 7 3G"
            },
            {
                regex: "Q[._]Me Plus7",
                model: "Q.Me Plus 7"
            },
            {
                regex: "Q[._]Me",
                model: "Q.Me"
            },
            {
                regex: "Q[._]Mate R99",
                model: "Q.Mate R99"
            },
            {
                regex: "Q[._]Next B7",
                model: "Q.Next B7"
            },
            {
                regex: "Q[._]Next J2",
                model: "Q.Next J2"
            },
            {
                regex: "Q[._]TOP-X8",
                model: "Q.Top X8"
            },
            {
                regex: "Q[._]You",
                model: "Q.You"
            },
            {
                regex: "QTAB Tab4",
                model: "QTab Tab4",
                device: "tablet"
            },
            {
                regex: "ZYQ-Q88",
                model: "Q88",
                device: "tablet"
            }
        ]
    },
    Toshiba: {
        regex: "Toshiba|TSBNetTV/|portalmmm/[12].0 TS|T-01C|T-0[12]D|IS04|IS11T|AT1S0|AT300SE|AT(7-C|10-A|10[PL]E-A|100|200|270|300|330|374|400|470|500|503|570|703|830)",
        device: "smartphone",
        models: [
            {
                regex: "T-01C",
                model: "Regza T-01C"
            },
            {
                regex: "T-01D",
                model: "Regza T-01D"
            },
            {
                regex: "T-02D",
                model: "Regza T-02D"
            },
            {
                regex: "IS04",
                model: "Regza IS04"
            },
            {
                regex: "IS11T",
                model: "Regza IS11T"
            },
            {
                regex: "AT7-C",
                model: "Excite",
                device: "tablet"
            },
            {
                regex: "AT1S0",
                model: "Regza AT1S0",
                device: "tablet"
            },
            {
                regex: "AT300SE",
                model: "Regza AT300SE",
                device: "tablet"
            },
            {
                regex: "AT500a",
                model: "Regza AT500a",
                device: "tablet"
            },
            {
                regex: "AT(100|200|270|300|330|374|400|470|500|503|570|703|830)",
                model: "Regza AT$1",
                device: "tablet"
            },
            {
                regex: "AT10([PL])E-A",
                model: "Excite AT10$1-A",
                device: "tablet"
            },
            {
                regex: "AT10-A",
                model: "Excite AT10-A",
                device: "tablet"
            },
            {
                regex: "TSBNetTV/",
                device: "tv",
                model: ""
            },
            {
                regex: "Toshiba[ /_\\-]?([a-z0-9_ \\-]+) Build",
                model: "$1"
            },
            {
                regex: "Toshiba[ /_\\-]?([a-z0-9_\\-]+)",
                model: "$1"
            },
            {
                regex: "portalmmm/[12].0 (TS[a-z0-9 ]+)",
                model: "$1"
            }
        ]
    },
    Vivax: {
        regex: "VIVAX|(?:Fly5[_ ]Lite|Fun[_ ]S500|Point_(?:X[12]|X501)|PRO3|32LE77SM|40LE77SM|FUN S1|FUN_S20)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Fly5[_ ]Lite(?:[);/ ]|$)",
                model: "Fly 5 Lite"
            },
            {
                regex: "Point_X([12])(?:[);/ ]|$)",
                model: "Point X$1"
            },
            {
                regex: "Fun[_ ]S500(?:[);/ ]|$)",
                model: "Fun S500"
            },
            {
                regex: "FUN[ _]S(1|20)(?:[);/ ]|$)",
                model: "Fun S$1"
            },
            {
                regex: "VIVAX[ _]Fly3(?:[);/ ]|$)",
                model: "Fly 3"
            },
            {
                regex: "VIVAX[ _]Fly[ _]V1(?:[);/ ]|$)",
                model: "Fly V1"
            },
            {
                regex: "(?:VIVAX )?(Point[ _](?:X551|X501))(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "SMART Point X5010(?:[);/ ]|$)",
                model: "Smart Point X5010"
            },
            {
                regex: "VIVAX[_ ]PRO3",
                model: "Pro 3"
            },
            {
                regex: "VIVAX TABLET TPC 802 3G(?:[);/ ]|$)",
                model: "TPC-802 3G"
            },
            {
                regex: "(32LE77SM|40LE77SM)",
                device: "tv",
                model: "$1"
            }
        ]
    },
    MLS: {
        regex: "IQ(?:0705|L550|1010w?|1012N?|1019N|1025|1380|1401|1436|1452a|1453|1470|1502a|1511|1552|1553|1568|1570|1805N|1806|1808|1810B_M|1832|1850|1890|5017|9610|181011N|E[12]00|EL41|G550|GW516|L30|L5[01]|M801|M1001|N700|P50|R300|S300|S1001|W503|W511T|W553N?|W60[38]|W626|M960|D700|9013_4N)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "IQ0705(?:[);/ ]|$)",
                model: "iQTalk Twist"
            },
            {
                regex: "IQL550(?:[);/ ]|$)",
                model: "Notch Lite"
            },
            {
                regex: "IQ1010W?(?:[);/ ]|$)",
                model: "iQTab 10",
                device: "tablet"
            },
            {
                regex: "IQ1012N?(?:[);/ ]|$)",
                model: "iQTab Brave 3G",
                device: "tablet"
            },
            {
                regex: "IQ1025(?:[);/ ]|$)",
                model: "iQTab Action 4G",
                device: "tablet"
            },
            {
                regex: "iQ9013_4N(?:[);/ ]|$)",
                model: 'Life 10.1"',
                device: "tablet"
            },
            {
                regex: "IQ1019N(?:[);/ ]|$)",
                model: 'Alu Plus 4G 10.1"',
                device: "tablet"
            },
            {
                regex: "iQ1805N(?:[);/ ]|$)",
                model: 'iQTab Ideal 8.0"',
                device: "tablet"
            },
            {
                regex: "iQ181011N(?:[);/ ]|$)",
                model: 'iQTab Care 8.0"',
                device: "tablet"
            },
            {
                regex: "IQ1380(?:[);/ ]|$)",
                model: "Brain 3G"
            },
            {
                regex: "IQ1401(?:[);/ ]|$)",
                model: "iQTalk Verse 4G"
            },
            {
                regex: "IQ1436(?:[);/ ]|$)",
                model: "Color mini 4G"
            },
            {
                regex: "IQ1452a(?:[);/ ]|$)",
                model: "TOP-S 4G"
            },
            {
                regex: "IQ1453(?:[);/ ]|$)",
                model: "Trend 4G"
            },
            {
                regex: "IQ1470(?:[);/ ]|$)",
                model: "iQTalk Onyx"
            },
            {
                regex: "IQ1502a(?:[);/ ]|$)",
                model: "iQTalk Flame"
            },
            {
                regex: "IQ1511(?:[);/ ]|$)",
                model: "iQTalk Spicy"
            },
            {
                regex: "IQ1552(?:[);/ ]|$)",
                model: "iQTalk Titan 4G"
            },
            {
                regex: "IQ1553(?:[);/ ]|$)",
                model: "Color 3 4G"
            },
            {
                regex: "IQ1568(?:[);/ ]|$)",
                model: "Range 4G"
            },
            {
                regex: "IQ1570(?:[);/ ]|$)",
                model: "iQTalk Color 5.5 4G"
            },
            {
                regex: "IQ1806(?:[);/ ]|$)",
                model: "iQTab Rose",
                device: "tablet"
            },
            {
                regex: "IQ1808(?:[);/ ]|$)",
                model: "iQTab Master",
                device: "tablet"
            },
            {
                regex: "IQ1810B_M(?:[);/ ]|$)",
                model: "iQTab Novel 3G",
                device: "tablet"
            },
            {
                regex: "IQ1832(?:[);/ ]|$)",
                model: "Jet 3G",
                device: "tablet"
            },
            {
                regex: "IQ1850(?:[);/ ]|$)",
                model: "Diamond 5.2 4G"
            },
            {
                regex: "IQ1890(?:[);/ ]|$)",
                model: "iQTalk Aura"
            },
            {
                regex: "IQ5017(?:[);/ ]|$)",
                model: "Slice 4G"
            },
            {
                regex: "IQ9610(?:[);/ ]|$)",
                model: "Angel 3G",
                device: "tablet"
            },
            {
                regex: "iQM960(?:[);/ ]|$)",
                model: "Angel 3G (2018)",
                device: "tablet"
            },
            {
                regex: "IQG550(?:[);/ ]|$)",
                model: "Style 4G"
            },
            {
                regex: "IQGW516(?:[);/ ]|$)",
                model: "F5"
            },
            {
                regex: "IQE100(?:[);/ ]|$)",
                model: "Energy 4G"
            },
            {
                regex: "iQE200(?:[);/ ]|$)",
                model: "MX 4G"
            },
            {
                regex: "IQEL41(?:[);/ ]|$)",
                model: "Fab 4G"
            },
            {
                regex: "IQL30(?:[);/ ]|$)",
                model: "Status 4G"
            },
            {
                regex: "IQL50(?:[);/ ]|$)",
                model: "More 4G"
            },
            {
                regex: "IQL51(?:[);/ ]|$)",
                model: "Wave 4G"
            },
            {
                regex: "IQM801(?:[);/ ]|$)",
                model: "Brace 2018 4G",
                device: "tablet"
            },
            {
                regex: "IQM1001(?:[);/ ]|$)",
                model: "Level 4G",
                device: "tablet"
            },
            {
                regex: "IQN700(?:[);/ ]|$)",
                model: "Inspire 4G"
            },
            {
                regex: "IQP50(?:[);/ ]|$)",
                model: "Ruby 4G"
            },
            {
                regex: "IQS300(?:[);/ ]|$)",
                model: "DX 4G"
            },
            {
                regex: "IQS1001(?:[);/ ]|$)",
                model: "Vista 4G",
                device: "tablet"
            },
            {
                regex: "IQR300(?:[);/ ]|$)",
                model: "R3 4G"
            },
            {
                regex: "IQW608(?:[);/ ]|$)",
                model: "Regal"
            },
            {
                regex: "iQW603(?:[);/ ]|$)",
                model: 'Phab 6.0"',
                device: "phablet"
            },
            {
                regex: "IQW626(?:[);/ ]|$)",
                model: "D6 4G"
            },
            {
                regex: "IQW511T(?:[);/ ]|$)",
                model: "Liberal"
            },
            {
                regex: "IQW553N?(?:[);/ ]|$)",
                model: 'Alu 5.5"'
            },
            {
                regex: "IQW503(?:[);/ ]|$)",
                model: "Flame 4G (2018)"
            },
            {
                regex: "iQD700(?:[);/ ]|$)",
                model: "Color Fingerprint 4G"
            }
        ]
    },
    Fly: {
        regex: "Fly(?!Flow|touch)|Power Plus 5000|Photo Pro|Slimline|Life (?:Ace|Jet|Sky|Compact 4G|Geo)|FS50[1-9]|FS51[0-8]|FS52[0-9]|FS530|FS55[134]|FS40[1-9]|FS45[1-9]|4FS06|MERIDIAN-|(?:IQ(?!10[134]0)[0-9]{3,}[i]?)[ _]?(?:Quad|Firebird|Quattro|Turbo|Magic)?(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:Fly_)?IQ310(?:[);/ ]|$)",
                model: "Panorama",
                device: "tablet"
            },
            {
                regex: "(?:Fly_)?IQ236(?:[);/ ]|$)",
                model: "Victory"
            },
            {
                regex: "Slimline(?:[);/ ]|$)",
                model: "Slimline"
            },
            {
                regex: "Power Plus 5000(?:[);/ ]|$)",
                model: "Power Plus 5000"
            },
            {
                regex: "Photo Pro(?:[);/ ]|$)",
                model: "Photo Pro"
            },
            {
                regex: "Life Ace(?:[);/ ]|$)",
                model: "Life Ace"
            },
            {
                regex: "Life Jet(?:[);/ ]|$)",
                model: "Life Jet"
            },
            {
                regex: "Life Sky(?:[);/ ]|$)",
                model: "Life Sky"
            },
            {
                regex: "Life Geo(?:[);/ ]|$)",
                model: "Life Geo"
            },
            {
                regex: "Life Compact 4G(?:[);/ ]|$)",
                model: "Life Compact 4G"
            },
            {
                regex: "FS506",
                model: "Cirrus 3"
            },
            {
                regex: "FS403",
                model: "Cumulus 1"
            },
            {
                regex: "FS508",
                model: "Cirrus 6"
            },
            {
                regex: "FS511",
                model: "Cirrus 7"
            },
            {
                regex: "FS509",
                model: "Nimbus 9"
            },
            {
                regex: "FS406",
                model: "Stratus 5"
            },
            {
                regex: "FS404",
                model: "Stratus 3"
            },
            {
                regex: "FS504",
                model: "Cirrus 2"
            },
            {
                regex: "FS407",
                model: "Stratus 6"
            },
            {
                regex: "FS401",
                model: "Stratus 1"
            },
            {
                regex: "FS402",
                model: "Stratus 2"
            },
            {
                regex: "FS501",
                model: "Nimbus 3"
            },
            {
                regex: "FS502",
                model: "Cirrus 1"
            },
            {
                regex: "FS507",
                model: "Cirrus 4"
            },
            {
                regex: "FS505",
                model: "Nimbus 7"
            },
            {
                regex: "FS551",
                model: "Nimbus 4"
            },
            {
                regex: "FS514",
                model: "Cirrus 8"
            },
            {
                regex: "FS553",
                model: "Cirrus 9"
            },
            {
                regex: "FS554",
                model: "Power Plus FHD"
            },
            {
                regex: "FS517",
                model: "Cirrus 11"
            },
            {
                regex: "FS516",
                model: "Cirrus 12"
            },
            {
                regex: "FS518",
                model: "Cirrus 13"
            },
            {
                regex: "FS520",
                model: "Selfie 1"
            },
            {
                regex: "FS521",
                model: "Power Plus 1"
            },
            {
                regex: "FS522",
                model: "Cirrus 14"
            },
            {
                regex: "FS523",
                model: "Cirrus 16"
            },
            {
                regex: "FS524",
                model: "Knockout"
            },
            {
                regex: "FS526",
                model: "Power Plus 2"
            },
            {
                regex: "FS527",
                model: "Nimbus 17"
            },
            {
                regex: "FS528",
                model: "Memory Plus"
            },
            {
                regex: "FS529",
                model: "\u0421hamp"
            },
            {
                regex: "FS530",
                model: "Power Plus XXL"
            },
            {
                regex: "FS454",
                model: "Nimbus 8"
            },
            {
                regex: "FS452",
                model: "Nimbus 2"
            },
            {
                regex: "FS512",
                model: "Nimbus 10"
            },
            {
                regex: "FS510",
                model: "Nimbus 12"
            },
            {
                regex: "FS451",
                model: "Nimbus 1"
            },
            {
                regex: "FS405",
                model: "Stratus 4"
            },
            {
                regex: "FS408",
                model: "Stratus 8"
            },
            {
                regex: "FS409",
                model: "Stratus 9"
            },
            {
                regex: "FS455",
                model: "Nimbus 11"
            },
            {
                regex: "FS456",
                model: "Nimbus 14"
            },
            {
                regex: "FS457",
                model: "Nimbus 15"
            },
            {
                regex: "FS459",
                model: "Nimbus 16"
            },
            {
                regex: "FS458",
                model: "Stratus 7"
            },
            {
                regex: "(?:Fly_)?IQ237(?:[);/ ]|$)",
                model: "Dynamic"
            },
            {
                regex: "(?:Fly_)?IQ238(?:[);/ ]|$)",
                model: "Jazz"
            },
            {
                regex: "(?:Fly_)?IQ240(?:[);/ ]|$)",
                model: "Whizz"
            },
            {
                regex: "(?:Fly_)?IQ255(?:[);/ ]|$)",
                model: "Pride"
            },
            {
                regex: "(?:Fly_)?IQ270(?: Firebird)?(?:[);/ ]|$)",
                model: "Firebird"
            },
            {
                regex: "(?:Fly_)?IQ275(?:[);/ ]|$)",
                model: "Marathon"
            },
            {
                regex: "(?:Fly_)?IQ285(?: Turbo)?(?:[);/ ]|$)",
                model: "Turbo"
            },
            {
                regex: "(?:Fly_)?IQ430(?:[);/ ]|$)",
                model: "Evoke"
            },
            {
                regex: "(?:Fly_)?IQ431(?:[);/ ]|$)",
                model: "Glory"
            },
            {
                regex: "(?:Fly_)?IQ432(?:[);/ ]|$)",
                model: "Era Nano 1"
            },
            {
                regex: "(?:Fly_)?IQ436(?:[);/ ]|$)",
                model: "Era Nano 3"
            },
            {
                regex: "(?:Fly_)?IQ4490(?:[);/ ]|$)",
                model: "Era Nano 4"
            },
            {
                regex: "(?:Fly_)?IQ434(?:[);/ ]|$)",
                model: "Era Nano 5"
            },
            {
                regex: "(?:Fly_)?IQ4406(?:[);/ ]|$)",
                model: "Era Nano 6"
            },
            {
                regex: "(?:Fly_)?IQ436i(?:[);/ ]|$)",
                model: "Era Nano 9"
            },
            {
                regex: "(?:Fly_)?IQ440(?:[);/ ]|$)",
                model: "Energy"
            },
            {
                regex: "(?:Fly_)?IQ4401(?:[);/ ]|$)",
                model: "Era Energy 2"
            },
            {
                regex: "(?:Fly_)?IQ441(?:[);/ ]|$)",
                model: "Radiance"
            },
            {
                regex: "(?:Fly_)?IQ442 Quad(?:[);/ ]|$)",
                model: "Miracle 2"
            },
            {
                regex: "(?:Fly_)?IQ442(?:[);/ ]|$)",
                model: "Miracle"
            },
            {
                regex: "(?:Fly_)?IQ443(?:[);/ ]|$)",
                model: "Trend"
            },
            {
                regex: "(?:Fly_)?IQ444(?: Quattro)?(?:[);/ ]|$)",
                model: "Diamond 2"
            },
            {
                regex: "(?:Fly_)?IQ445(?:[);/ ]|$)",
                model: "Genius"
            },
            {
                regex: "(?:Fly_)?IQ446(?: Magic)?(?:[);/ ]|$)",
                model: "Magic"
            },
            {
                regex: "(?:Fly_)?IQ447(?:[);/ ]|$)",
                model: "Era Life 1"
            },
            {
                regex: "(?:Fly_)?IQ456(?:[);/ ]|$)",
                model: "Era Life 2"
            },
            {
                regex: "(?:Fly_)?IQ4409 Quad(?:[);/ ]|$)",
                model: "Era Life 4"
            },
            {
                regex: "(?:Fly_)?IQ448(?:[);/ ]|$)",
                model: "Chic"
            },
            {
                regex: "(?:Fly_)?IQ449(?:[);/ ]|$)",
                model: "Pronto"
            },
            {
                regex: "(?:Fly_)?IQ450(?:[);/ ]|$)",
                model: "Horizon"
            },
            {
                regex: "(?:Fly_)?IQ450[ _]Quattro(?:[);/ ]|$)",
                model: "Horizon 2"
            },
            {
                regex: "(?:Fly_)?IQ451(?:[);/ ]|$)",
                model: "Vista"
            },
            {
                regex: "(?:Fly_)?IQ452 Quad(?:[);/ ]|$)",
                model: "Ego Vision 1"
            },
            {
                regex: "(?:Fly_)?IQ454(?:[);/ ]|$)",
                model: "Evo Tech 1"
            },
            {
                regex: "(?:Fly_)?IQ4403(?:[);/ ]|$)",
                model: "Energy 3"
            },
            {
                regex: "(?:Fly_)?IQ4404(?:[);/ ]|$)",
                model: "Spark"
            },
            {
                regex: "(?:Fly_)?IQ4410 Quad(?:[);/ ]|$)",
                model: "Phoenix"
            },
            {
                regex: "(?:Fly_)?IQ4411(?:[);/ ]|$)",
                model: "Energy 2"
            },
            {
                regex: "(?:Fly_)?IQ4412 Quad(?:[);/ ]|$)",
                model: "Coral"
            },
            {
                regex: "(?:Fly_)?IQ4413[ _]Quad(?:[);/ ]|$)",
                model: "Evo Chic 3"
            },
            {
                regex: "(?:Fly_)?IQ4414 Quad(?:[);/ ]|$)",
                model: "Evo Tech 3"
            },
            {
                regex: "(?:Fly_)?IQ4415 Quad(?:[);/ ]|$)",
                model: "Era Style 3"
            },
            {
                regex: "(?:Fly_)?IQ4504 Quad(?:[);/ ]|$)",
                model: "Evo Energy 5"
            },
            {
                regex: "(?:Fly_)?IQ([0-9]+[i]? ?(?:Quad|Firebird|Quattro)?)(?:[);/ ]|$)",
                model: "IQ$1"
            },
            {
                regex: "Fly[ _\\-]?([a-z0-9_]+)/",
                model: "$1",
                device: "feature phone"
            },
            {
                regex: "Flylife[ _\\-]?([^/;]+) Build",
                model: "Flylife $1",
                device: "tablet"
            },
            {
                regex: "Fly[ _\\-]?([a-z0-9]+)",
                model: "$1"
            },
            {
                regex: "MERIDIAN-([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    FinePower: {
        regex: "FinePower[_ ]?([AB][1-9]|[CD][1-9])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "FinePower[_ ]?([AB][1-9])(?:[);/ ]|$)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "FinePower[_ ]?([CD][1-9])(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Freetel: {
        regex: "(?:FTJ17[AC]00|FTJ152[ABCD]|FTU18A00|FT141B|FT142D(?:_LTEXM)?|FT142A?|FTJ161[AB]|FTJ1[56]2E|FTJ162[BD]|FTE161[GE])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "FTJ152C",
                model: "Samurai Miyabi"
            },
            {
                regex: "FTJ17A00(?:[);/ ]|$)",
                model: "Rei 2 Dual"
            },
            {
                regex: "FTJ17C00(?:[);/ ]|$)",
                model: "Priori 5"
            },
            {
                regex: "FTU18A00(?:[);/ ]|$)",
                model: "Cricket Wave"
            },
            {
                regex: "FTJ161A",
                model: "Musashi"
            },
            {
                regex: "FTE161E",
                model: "Ice 2"
            },
            {
                regex: "FTE161G",
                model: "Ice 2 Plus"
            },
            {
                regex: "FTJ162E",
                model: "Raijin"
            },
            {
                regex: "FT141B",
                model: "Nico"
            },
            {
                regex: "FT142D(?:_LTEXM)?(?:[);/ ]|$)",
                model: "XM"
            },
            {
                regex: "FT142A?",
                model: "Priori 2"
            },
            {
                regex: "FTJ152A",
                model: "Priori 3"
            },
            {
                regex: "FTJ162D",
                model: "Priori 4"
            },
            {
                regex: "FTJ152B",
                model: "Priori 3S LTE"
            },
            {
                regex: "FTJ152D",
                model: "Samurai Kiwami"
            },
            {
                regex: "FTJ162B",
                model: "Samurai Kiwami 2"
            },
            {
                regex: "FTJ161B",
                model: "Samurai Rei"
            },
            {
                regex: "FTJ152E",
                model: "Katana 1"
            }
        ]
    },
    "Western Digital": {
        regex: "Westerndigital|WDSimpleBrowser",
        device: "tv",
        models: [
            {
                regex: "Streamer2010",
                model: "Streamer (2010)"
            }
        ]
    },
    Zeemi: {
        regex: "ZEEMI[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "ZEEMI[ _-]([^/;]+) Build",
                model: "$1"
            },
            {
                regex: "ZEEMI[ _-]([^/;)]+)(?:[);/]|$)",
                model: "$1"
            }
        ]
    },
    Zenek: {
        regex: "Z5007|Z551[679]|Z6001",
        device: "smartphone",
        models: [
            {
                regex: "Z5517",
                model: "Leopardo"
            },
            {
                regex: "Z6001",
                model: "Libelula"
            },
            {
                regex: "Z5007",
                model: "Oso"
            },
            {
                regex: "Z5519",
                model: "Ping\xfbino"
            },
            {
                regex: "Z5516",
                model: "Zebra"
            }
        ]
    },
    Zopo: {
        regex: "ZOPO|(?:ZOPO[_ ])?(Flash X3|ZP[0-9]{2,}[^/;]+)(?:\\)| Build)",
        device: "smartphone",
        models: [
            {
                regex: "(?:ZOPO_C2_MOD|ZP998)(?:[);/ ]|$)",
                model: "C2 II"
            },
            {
                regex: "ZOPO 9xxQuad(?:[);/ ]|$)",
                model: "9XX Quad"
            },
            {
                regex: "(?:ZOPO_)?ZP980[+](?:[);/ ]|$)",
                model: "ZP980+"
            },
            {
                regex: "(?:ZOPO_)?ZP980(?:[);/ ]|$)",
                model: "Scorpio"
            },
            {
                regex: "ZP952(?:[);/ ]|$)",
                model: "Speed 7 Plus"
            },
            {
                regex: "ZP951(?:[);/ ]|$)",
                model: "Speed 7"
            },
            {
                regex: "ZP955(?:[);/ ]|$)",
                model: "Speed 8"
            },
            {
                regex: "ZP950[+h]?(?:[);/ ]|$)",
                model: "Leader Max"
            },
            {
                regex: "ZP(?:900H?|910)(?:[);/ ]|$)",
                model: "Leader"
            },
            {
                regex: "ZP(?:800H|810)(?:[);/ ]|$)",
                model: "Libero HD"
            },
            {
                regex: "ZP500[+]?(?:[);/ ]|$)",
                model: "Libero"
            },
            {
                regex: "ZP330(?:[);/ ]|$)",
                model: "Color C"
            },
            {
                regex: "ZP370(?:[);/ ]|$)",
                model: "Color S"
            },
            {
                regex: "ZP5(63|86)(?:[);/ ]|$)",
                model: "Color X"
            },
            {
                regex: "ZP567(?:[);/ ]|$)",
                model: "Color C5i"
            },
            {
                regex: "ZP300[S+]?(?:[);/ ]|$)",
                model: "Field"
            },
            {
                regex: "ZP200[+]?(?:[);/ ]|$)",
                model: "Shining"
            },
            {
                regex: "ZP100(?:[);/ ]|$)",
                model: "Pilot"
            },
            {
                regex: "ZP1790(?:[);/ ]|$)",
                model: "Flash X2"
            },
            {
                regex: "ZP781(?:[);/ ]|$)",
                model: "Flash G5 Plus"
            },
            {
                regex: "(?:ZOPO_)?(Flash X3|X1i|ZP[0-9]{2,}[^/;)]+)(?: Build|\\))",
                model: "$1"
            }
        ]
    },
    ZTE: {
        regex: "ZTE|AxonPhone|([a-z0-9]+)_USA_Cricket|(?:Blade (?:V0820|L110|L[2357]|L7A|S6|V[6789]|V8Q|V8 SE|V9 VITA|X7|A(310|460|465|475|520|530|602)|V580|V Ultra|Q Lux)|N9[15]8St|NX(?:403A|404H|406E|40[X2]|507J|503A|505J|506J|508J|510J|512J|511J|513J|521J|523J_V1|529J|531J|541J|5[48]9J|551J|563J|569[HJ]|573J|575J|59[157]J|60[1689]J|61[12679]J|62[79]J|65[19]J|907J)|N818S|N951[0579]|N91[38]0|N9101|N913[267]|N952[01]|N9560|N9810|N799D|[UV]9180|[UV]9815|Z(?:233V|331|5031O|559DL|6621O|667T|768G|792|81[25]|818L|82[08]|83[12359]|85[125]|851M|992|(557|71[67]|798|836|861|916)BL|986DL|(232|718|828)TL|(?:233|353|558|717|799|837|862|899|917|963)VL|955A|95[678]|965|97[018]|98[1237]|986U|999|936L)|V769M|Apex2|G (LTE|Lux)|Vec|Z959|V865M|Z3001S|902ZT|KIS II Max|Kis 3|K3DX-V5G|Z930L|Optus X|Blade[ _](A510|A[357] 2019-T|A6 MAX|A0622|X9)|Z3153V|Z836F|Nubia Z(?:9|11)|Ctyon-A9|602ZT|MO-01[JK]|Z963U|402ZT|P545|P609|dandelion|901ZT|A001ZT|Z-01K|UZTE V808|ZR01|ZTG01|K8[37]CA)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "602ZT(?:[);/ ]|$)",
                model: "Libero 2"
            },
            {
                regex: "A001ZT(?:[);/ ]|$)",
                model: "Libero 3"
            },
            {
                regex: "901ZT(?:[);/ ]|$)",
                model: "Libero S10"
            },
            {
                regex: "ZR01(?:[);/ ]|$)",
                model: "Rakuten Big"
            },
            {
                regex: "ZTG01(?:[);/ ]|$)",
                model: "A1"
            },
            {
                regex: "A7020(?:[);/ ]|$)",
                model: "Blade A7s (2020)"
            },
            {
                regex: "ZTE 2050(?:RU)?",
                model: "Blade 20 Smart"
            },
            {
                regex: "902ZT(?:[);/ ]|$)",
                model: "Axon 10 Pro 5G"
            },
            {
                regex: "N799D(?:[);/ ]|$)",
                model: "Blade Eg"
            },
            {
                regex: "Z818L(?:[);/ ]|$)",
                model: "Allstar"
            },
            {
                regex: "Z3001S(?:[);/ ]|$)",
                model: "Quest Plus"
            },
            {
                regex: "Ctyon-A9(?:[);/ ]|$)",
                model: "Ctyon A9"
            },
            {
                regex: "K3DX-V5G(?:[);/ ]|$)",
                model: "V5G"
            },
            {
                regex: "N918St(?:[);/ ]|$)",
                model: "V5S"
            },
            {
                regex: "N958St(?:[);/ ]|$)",
                model: "V5 Max"
            },
            {
                regex: "N9101(?:[);/ ]|$)",
                model: "Imperial"
            },
            {
                regex: "Z963U(?:[);/ ]|$)",
                model: "Imperial Max"
            },
            {
                regex: "N9120(?:[);/ ]|$)",
                model: "Avid"
            },
            {
                regex: "N9130(?:[);/ ]|$)",
                model: "Speed"
            },
            {
                regex: "N9132(?:[);/ ]|$)",
                model: "Prestige"
            },
            {
                regex: "N9136(?:[);/ ]|$)",
                model: "Prestige 2"
            },
            {
                regex: "N9137(?:[);/ ]|$)",
                model: "Tempo X"
            },
            {
                regex: "N9180(?:[);/ ]|$)",
                model: "V5"
            },
            {
                regex: "N9510(?:[);/ ]|$)",
                model: "Warp 4G"
            },
            {
                regex: "N9517(?:[);/ ]|$)",
                model: "Blade Force"
            },
            {
                regex: "Z559DL(?:[);/ ]|$)",
                model: "Blade T2"
            },
            {
                regex: "402ZT(?:[);/ ]|$)",
                model: "Blade Q+"
            },
            {
                regex: "Blade Q Lux(?:[);/ ]|$)",
                model: "Blade Q Lux"
            },
            {
                regex: "N9515(?:[);/ ]|$)",
                model: "Warp Sync"
            },
            {
                regex: "N9519(?:[);/ ]|$)",
                model: "Warp 7"
            },
            {
                regex: "N9520(?:[);/ ]|$)",
                model: "Boost Max"
            },
            {
                regex: "N9521(?:[);/ ]|$)",
                model: "Boost Max+"
            },
            {
                regex: "N9560(?:[);/ ]|$)",
                model: "Max XL"
            },
            {
                regex: "N9810(?:[);/ ]|$)",
                model: "Vital"
            },
            {
                regex: "NX40[X2](?:[);/ ]|$)",
                model: "Nubia Z5 Mini"
            },
            {
                regex: "NX(403[AE]|406E|404H)(?:[);/ ]|$)",
                model: "Nubia Z5S Mini"
            },
            {
                regex: "NX503A(?:[);/ ]|$)",
                model: "Nubia Z5S"
            },
            {
                regex: "NX506J(?:[);/ ]|$)",
                model: "Nubia Z7"
            },
            {
                regex: "NX507J(?:[);/ ]|$)",
                model: "Nubia Z7 Mini"
            },
            {
                regex: "NX505J(?:[);/ ]|$)",
                model: "Nubia Z7 Max"
            },
            {
                regex: "NX508J(?:[);/ ]|$)",
                model: "Nubia Z9"
            },
            {
                regex: "(NX5[12]1J|Nubia Z9 mini)(?:[);/ ]|$)",
                model: "Nubia Z9 Mini"
            },
            {
                regex: "(NX510J|Nubia Z9 Max)(?:[);/ ]|$)",
                model: "Nubia Z9 Max"
            },
            {
                regex: "NX512J(?:[);/ ]|$)",
                model: "Nubia Z9 Max Dual"
            },
            {
                regex: "NX531J(?:[);/ ]|$)",
                model: "Nubia Z11"
            },
            {
                regex: "NX523J_V1",
                model: "Nubia Z11 Max"
            },
            {
                regex: "(?:NX549J|Nubia Z11 mini S)(?:[);/ ]|$)",
                model: "Nubia Z11 Mini S"
            },
            {
                regex: "(?:NX529J|Nubia Z11 mini)(?:[);/ ]|$)",
                model: "Nubia Z11 Mini"
            },
            {
                regex: "NX606J(?:[);/ ]|$)",
                model: "Nubia Z18"
            },
            {
                regex: "NX616J(?:[);/ ]|$)",
                model: "Nubia Z18S"
            },
            {
                regex: "NX611J(?:[);/ ]|$)",
                model: "Nubia Z18 Mini"
            },
            {
                regex: "NX551J(?:[);/ ]|$)",
                model: "Nubia M2"
            },
            {
                regex: "NX563J(?:[);/ ]|$)",
                model: "Nubia Z17"
            },
            {
                regex: "NX569[HJ](?:[);/ ]|$)",
                model: "Nubia Z17 Mini"
            },
            {
                regex: "NX589J(?:[);/ ]|$)",
                model: "Nubia Z17 Mini S"
            },
            {
                regex: "NX591J(?:[);/ ]|$)",
                model: "Nubia Z17 Lite"
            },
            {
                regex: "NX595J(?:[);/ ]|$)",
                model: "Nubia Z17S"
            },
            {
                regex: "NX612J(?:[);/ ]|$)",
                model: "Nubia V18"
            },
            {
                regex: "NX627J",
                model: "Nubia Z20"
            },
            {
                regex: "NX513J(?:[);/ ]|$)",
                model: "Nubia My Prague"
            },
            {
                regex: "NX601J(?:[);/ ]|$)",
                model: "Nubia X6"
            },
            {
                regex: "NX609J(?:[);/ ]|$)",
                model: "Nubia Red Magic"
            },
            {
                regex: "NX659J(?:[);/ ]|$)",
                model: "Nubia Red Magic 5G"
            },
            {
                regex: "NX651J(?:[);/ ]|$)",
                model: "Nubia Play"
            },
            {
                regex: "NX619J(?:[);/ ]|$)",
                model: "Nubia Red Magic Mars"
            },
            {
                regex: "NX629J(?:[);/ ]|$)",
                model: "Nubia Red Magic 3"
            },
            {
                regex: "NX573J",
                model: "Nubia M2 Lite"
            },
            {
                regex: "NX907J(?:[);/ ]|$)",
                model: "Nubia M2 Play"
            },
            {
                regex: "NX541J",
                model: "Nubia N1"
            },
            {
                regex: "NX597J",
                model: "Nubia N1 Lite"
            },
            {
                regex: "NX575J",
                model: "Nubia N2"
            },
            {
                regex: "NX6(08|17)J(?:[);/ ]|$)",
                model: "Nubia N3"
            },
            {
                regex: "[UV]9180(?:[);/ ]|$)",
                model: "V5 Red Bull"
            },
            {
                regex: "[UV]9815(?:[);/ ]|$)",
                model: "Grand Memo LTE"
            },
            {
                regex: "V779M",
                model: "Joey Jump 2"
            },
            {
                regex: "V807",
                model: "Blade C"
            },
            {
                regex: "V809",
                model: "Blade C2"
            },
            {
                regex: "ZTE_Blade_C2_Plus",
                model: "Blade C2 Plus"
            },
            {
                regex: "Blade G Plus",
                model: "Blade G Plus"
            },
            {
                regex: "ZTE_Blade_III",
                model: "Blade III"
            },
            {
                regex: "(?:ZTE_)?V829",
                model: "Blade G Pro"
            },
            {
                regex: "V882",
                model: "Lord"
            },
            {
                regex: "V967S",
                model: "Grand X2"
            },
            {
                regex: "V970M?|V987",
                model: "Grand X"
            },
            {
                regex: "Z959(?:[);/ ]|$)",
                model: "Grand X3"
            },
            {
                regex: "V8000",
                model: "Nova 4"
            },
            {
                regex: "Z95[67]",
                model: "Grand X4"
            },
            {
                regex: "Z987",
                model: "Grand X Max+"
            },
            {
                regex: "(?:ZTE_)?Grand[ _]Era",
                model: "Grand Era"
            },
            {
                regex: "V788D",
                model: "Kis Plus"
            },
            {
                regex: "Z331(?:[);/ ]|$)",
                model: "Z331"
            },
            {
                regex: "N818S(?:[);/ ]|$)",
                model: "N818S"
            },
            {
                regex: "Z5031O(?:[);/ ]|$)",
                model: "Optus X Spirit 2"
            },
            {
                regex: "P545(?:[);/ ]|$)",
                model: "Optus X Power 2"
            },
            {
                regex: "P609(?:[);/ ]|$)",
                model: "Optus X Wave"
            },
            {
                regex: "Optus X Start(?:[);/ ]|$)",
                model: "Optus X Start"
            },
            {
                regex: "BA520(?:[);/ ]|$)",
                model: "Blade A520"
            },
            {
                regex: "Blade (A(0620|310|321|452|460|462|465|475|510|512|52[012]|530|531|602|612|910)|L[12]10|L130|V0730|V0800|V580|V1000)(?:[);/ ]|$)",
                model: "Blade $1"
            },
            {
                regex: "Blade L2 Plus(?:[);/ ]|$)",
                model: "Blade L2 Plus"
            },
            {
                regex: "(?:ZTE_)?Blade[ _]L2(?:[);/ ]|$)",
                model: "Blade L2"
            },
            {
                regex: "Blade L3 Plus(?:[);/ ]|$)",
                model: "Blade L3 Plus"
            },
            {
                regex: "Blade L3 Apex(?:[);/ ]|$)",
                model: "Blade L3 Apex"
            },
            {
                regex: "Blade L3(?:[);/ ]|$)",
                model: "Blade L3"
            },
            {
                regex: "Blade L5 Plus(?:[);/ ]|$)",
                model: "Blade L5 Plus"
            },
            {
                regex: "Blade L5(?:[);/ ]|$)",
                model: "Blade L5"
            },
            {
                regex: "Blade L6(?:[);/ ]|$)",
                model: "Blade L6"
            },
            {
                regex: "Blade L7A(?:[);/ ]|$)",
                model: "Blade L7A"
            },
            {
                regex: "Blade L7(?:[);/ ]|$)",
                model: "Blade L7"
            },
            {
                regex: "Blade L8(?:RU)?(?:[);/ ]|$)",
                model: "Blade L8"
            },
            {
                regex: "Blade A([357]) (20(?:19|20))",
                model: "Blade A$1 ($2)"
            },
            {
                regex: "Blade A3 Lite(?:[);/ ]|$)",
                model: "Blade A3 Lite"
            },
            {
                regex: "BLADE A0622(?:[);/ ]|$)",
                model: "Blade A6"
            },
            {
                regex: "BLADE A6 MAX(?:[);/ ]|$)",
                model: "Blade A6 Max"
            },
            {
                regex: "Blade S6 Plus(?:[);/ ]|$)",
                model: "Blade S6 Plus"
            },
            {
                regex: "Blade S6(?:[);/ ]|$)",
                model: "Blade S6"
            },
            {
                regex: "T920(?:[);/ ]|$)",
                model: "Blade S7"
            },
            {
                regex: "BLADE V Ultra(?:[);/ ]|$)",
                model: "Blade V Ultra"
            },
            {
                regex: "Blade V6 MAX(?:[);/ ]|$)",
                model: "Blade V6 Max"
            },
            {
                regex: "Blade V6 Plus(?:[);/ ]|$)",
                model: "Blade V6 Plus"
            },
            {
                regex: "Blade (?:V7 Lite|V0720)(?:[);/ ]|$)",
                model: "Blade V7 Lite"
            },
            {
                regex: "Blade V([67])(?:[);/ ]|$)",
                model: "Blade V$1"
            },
            {
                regex: "Blade X([79])(?:[);/ ]|$)",
                model: "Blade X$1"
            },
            {
                regex: "Blade V8Q(?:[);/ ]|$)",
                model: "Blade V8Q"
            },
            {
                regex: "Blade V8 SE(?:[);/ ]|$)",
                model: "Blade V8 SE"
            },
            {
                regex: "Blade V(9|10) Vita(?:[);/ ]|$)",
                model: "Blade V$1 Vita"
            },
            {
                regex: "Blade V([89]|10)(?:[);/ ]|$)",
                model: "Blade V$1"
            },
            {
                regex: "BLADE V0820(?:[);/ ]|$)",
                model: "Blade V8 Lite"
            },
            {
                regex: "BLADE V0850(?:[);/ ]|$)",
                model: "Blade V8 Mini"
            },
            {
                regex: "(?:Blade[ _])?(Apex2|G (LTE|Lux)|Vec|A510)",
                model: "Blade $1"
            },
            {
                regex: "Z768G(?:[);/ ]|$)",
                model: "Midnight"
            },
            {
                regex: "Z820",
                model: "Obsidian"
            },
            {
                regex: "Z986U",
                model: "Blade Max 3"
            },
            {
                regex: "Z971",
                model: "Blade Spark"
            },
            {
                regex: "Z978",
                model: "Blade V8 Pro"
            },
            {
                regex: "Z839",
                model: "Blade Vantage"
            },
            {
                regex: "Z3153V",
                model: "Blade Vantage 2"
            },
            {
                regex: "Z930L",
                model: "Unico LTE"
            },
            {
                regex: "Z965",
                model: "Blade X"
            },
            {
                regex: "Z981",
                model: "Blade Z Max Pro"
            },
            {
                regex: "Z982",
                model: "Blade Z Max"
            },
            {
                regex: "Z983",
                model: "Blade X Max"
            },
            {
                regex: "Z717[BV]L(?:[);/ ]|$)",
                model: "Citrine LTE"
            },
            {
                regex: "Z233VL(?:[);/ ]|$)",
                model: "Cymbal-C LTE"
            },
            {
                regex: "Z233V",
                model: "Cymbal LTE"
            },
            {
                regex: "Z232TL",
                model: "Cymbal-G LTE"
            },
            {
                regex: "Z353VL",
                model: "Cymbal-T LTE"
            },
            {
                regex: "Z718TL",
                model: "Jasper LTE"
            },
            {
                regex: "KIS II Max",
                model: "Kis II Max"
            },
            {
                regex: "Kis 3",
                model: "Kis 3"
            },
            {
                regex: "(?:Z798BL|Z799VL)(?:[);/ ]|$)",
                model: "Majesty Pro LTE"
            },
            {
                regex: "Z899VL",
                model: "Majesty Pro Plus LTE"
            },
            {
                regex: "Z828TL",
                model: "Midnight Pro LTE"
            },
            {
                regex: "(?:ZTE-)?Z792",
                model: "Fanfare"
            },
            {
                regex: "(?:ZTE-)?Z812",
                model: "Maven"
            },
            {
                regex: "Z815",
                model: "Fanfare 2"
            },
            {
                regex: "Z831",
                model: "Maven 2"
            },
            {
                regex: "Z832",
                model: "Sonata 3"
            },
            {
                regex: "Z835",
                model: "Maven 3"
            },
            {
                regex: "Z851(?:[);/ ]|$)",
                model: "Prelude Plus"
            },
            {
                regex: "Z851M",
                model: "Overture 3"
            },
            {
                regex: "Z852",
                model: "Fanfare 3"
            },
            {
                regex: "Z828",
                model: "Avid Plus"
            },
            {
                regex: "Z855",
                model: "Avid 4"
            },
            {
                regex: "Z833",
                model: "Avid TRIO"
            },
            {
                regex: "(?:Z836BL|Z837VL|Z836F)(?:[);/ ]|$)",
                model: "ZFive 2 LTE"
            },
            {
                regex: "Z558VL",
                model: "ZFive C LTE"
            },
            {
                regex: "Z557BL",
                model: "ZFive G LTE"
            },
            {
                regex: "(?:Z861BL|Z862VL)(?:[);/ ]|$)",
                model: "ZFive L LTE"
            },
            {
                regex: "Z916BL",
                model: "ZMax Grand LTE"
            },
            {
                regex: "Z917VL",
                model: "ZMax Champ LTE"
            },
            {
                regex: "(?:Z958|Z955A)(?:[);/ ]|$)",
                model: "ZMax 2"
            },
            {
                regex: "dandelion(?:[);/ ]|$)",
                model: "ZMax 3"
            },
            {
                regex: "Z963VL",
                model: "Max Duo LTE"
            },
            {
                regex: "Z970",
                model: "ZMax Z970"
            },
            {
                regex: "Z986DL",
                model: "MAX Blue LTE"
            },
            {
                regex: "(?:ZTE[-_])?Z992",
                model: "Avail 2"
            },
            {
                regex: "(?:Z999|Z-01K)(?:[);/ ]|$)",
                model: "Axon M"
            },
            {
                regex: "B2016",
                model: "Axon Mini"
            },
            {
                regex: "A2015",
                model: "Axon Tianji"
            },
            {
                regex: "A2017[GU]?",
                model: "Axon 7"
            },
            {
                regex: "A2018",
                model: "Axon 7s"
            },
            {
                regex: "A2019G Pro",
                model: "Axon Pro"
            },
            {
                regex: "B2017G",
                model: "Axon 7 Mini"
            },
            {
                regex: "A2020G? Pro(?:[);/ ]|$)",
                model: "Axon 10 Pro"
            },
            {
                regex: "Z667T",
                model: "Zinger"
            },
            {
                regex: "V?975|geek",
                model: "Geek"
            },
            {
                regex: "Z716BL",
                model: "Citrine LTE"
            },
            {
                regex: "X500",
                model: "Score"
            },
            {
                regex: "X501",
                model: "Groove"
            },
            {
                regex: "(?:ZTE-)?G-X991",
                model: "Rio"
            },
            {
                regex: "F-450",
                model: "Adamant"
            },
            {
                regex: "Z936L(?:[);/ ]|$)",
                model: "Lever"
            },
            {
                regex: "MO-01[JK](?:[);/ ]|$)",
                model: "Mono"
            },
            {
                regex: "V865M(?:[);/ ]|$)",
                model: "V865M"
            },
            {
                regex: "Z6621O(?:[);/ ]|$)",
                model: "Optus X Vista"
            },
            {
                regex: "V769M(?:[);/ ]|$)",
                model: "Leo Q2"
            },
            {
                regex: "K83CA(?:[);/ ]|$)",
                device: "tablet",
                model: "Grand X View 3"
            },
            {
                regex: "K87CA(?:[);/ ]|$)",
                device: "tablet",
                model: "Grand X View 4"
            },
            {
                regex: "AxonPhone ([^;/]+) Build",
                model: "AxonPhone $1"
            },
            {
                regex: "([a-z0-9]+)_USA_Cricket",
                model: "$1"
            },
            {
                regex: "ZTE[- ](V98|V96A|V81|V70)(?:[);/ ]|$)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "ZTE[- ]([a-z0-9\\-_ ]+) Build",
                model: "$1"
            },
            {
                regex: "ZTE-(?:G |G-)?([a-z0-9 _]+)",
                model: "$1"
            },
            {
                regex: "U?ZTE[ _]([a-z0-9]+)",
                model: "$1"
            }
        ]
    },
    Zuum: {
        regex: "Zuum[ _-]|(?:Akus Z|COVET|MAGNO|ONIX S|STEDI|STELLAR(?:[ _](?:Z|PRO|[MP]1))?|GRAVITY Z|AURA X|COVET_PRO_LITE|RONI)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Akus Z",
                model: "Akus Z"
            },
            {
                regex: "COVET_PRO_LITE",
                model: "Covet Pro Lite"
            },
            {
                regex: "COVET PRO",
                model: "Covet Pro"
            },
            {
                regex: "COVET( Z)?",
                model: "Covet$1"
            },
            {
                regex: "MAGNO PLUS",
                model: "Magno Plus"
            },
            {
                regex: "MAGNO( C)?",
                model: "Magno$1"
            },
            {
                regex: "ONIX S",
                model: "Onix S"
            },
            {
                regex: "STEDI",
                model: "Stedi"
            },
            {
                regex: "STELLAR PRO",
                model: "Stellar Pro"
            },
            {
                regex: "STELLAR PLUS",
                model: "Stellar Plus"
            },
            {
                regex: "STELLAR ([MP]1|Z)",
                model: "Stellar $1"
            },
            {
                regex: "STELLAR MINI",
                model: "Stellar Mini"
            },
            {
                regex: "STELLAR MINI",
                model: "Stellar Mini"
            },
            {
                regex: "STELLAR",
                model: "Stellar"
            },
            {
                regex: "GRAVITY Z",
                model: "Gravity Z"
            },
            {
                regex: "AURA X",
                model: "Aura X"
            },
            {
                regex: "RONI",
                model: "Roni"
            },
            {
                regex: "Zuum[ _-]([^;/]+) Build",
                model: "$1"
            },
            {
                regex: "Zuum[ _-]?([^;/)]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Zen: {
        regex: "(Admire[_ ][^/;]+|Cinemax[^/;)]+)(?:Build|\\))|AdmireGlam",
        device: "smartphone",
        models: [
            {
                regex: "AdmireGlam(?:[);/ ]|$)",
                model: "Admire Glam"
            },
            {
                regex: "(Admire[_ ][^/;]+|Cinemax[^/;)]+)(?:Build|\\))",
                model: "$1"
            }
        ]
    },
    Zync: {
        regex: "ZYNC|(Cloud Z5|Z1000|Z18|Z99|Z99[_ ][23]G|Z99|Z900[_ ]Plus|Z909|Z930[+]|Z930)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(Z18| DuZ99al Core|Z99[_ ][23]G|Z99 Dual Core|Z99|Z900[_ ]Plus|Z909|Z930[+]|Z930)",
                model: "$1"
            },
            {
                regex: "(Z1000[^/;]+)Build",
                model: "$1"
            },
            {
                regex: "Cloud (Z5)",
                model: "Cloud $1"
            },
            {
                regex: "ZYNC Cloud[ _]([^;]+)Build",
                model: "Cloud $1"
            },
            {
                regex: "ZYNC[ _]([^;]+)Build",
                model: "$1"
            }
        ]
    },
    Lemhoov: {
        regex: "Lemhoov",
        device: "smartphone",
        models: [
            {
                regex: "Lemhoov[ _-]([^/;]+) Build",
                model: "$1"
            }
        ]
    },
    MTC: {
        regex: "MTC[ _](968|97[82]|970|982[OT]?|1078)|(?:MTC[_ ])?SMART[ _]?(?:Race[2]?|Sprint|Run|Surf[2]?)[ _]4G|MTC975|Smart_(?:LINE|Light)|MTC[ _]SMART[ _](?:Run|Start_2)|Redbox Mini 5\\(MTS\\)",
        device: "smartphone",
        models: [
            {
                regex: "MTC[ _]?(97[258]|970[H]?|982[OT]?|968)",
                model: "$1"
            },
            {
                regex: "MTC[ _](1078)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "SMART[ _]Race[ _]4G",
                model: "Smart Race 4G"
            },
            {
                regex: "SMART[ _]Race2[ _]4G",
                model: "Smart Race 2 4G"
            },
            {
                regex: "(?:MTC_)?SMART[ _]Sprint[ _]4G",
                model: "Smart Sprint 4G"
            },
            {
                regex: "(?:MTC_)?SMART[ _]Start_2",
                model: "Smart Start 2"
            },
            {
                regex: "Smart_LINE",
                model: "Smart Line"
            },
            {
                regex: "Smart_Light",
                model: "Smart Light"
            },
            {
                regex: "SMART[ _]?Run(?:[ _]4G)?",
                model: "Smart Run 4G"
            },
            {
                regex: "SMART[ _]Surf2[ _]4G",
                model: "Smart Surf 2 4G"
            },
            {
                regex: "SMART[ _]Surf[ _]4G",
                model: "Smart Surf 4G"
            },
            {
                regex: "Redbox Mini 5\\(MTS\\)",
                device: "tv",
                model: "Redbox Mini 5"
            }
        ]
    },
    MegaFon: {
        regex: "MegaFon|MFLoginPh|MegLogPh|(MFLogin[34]T?|MS3B|SP-A5|SP-A20i)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "MFLoginPh|MegLogPh",
                model: "Login+"
            },
            {
                regex: "MFLogin4",
                model: "Login 4 LTE"
            },
            {
                regex: "MFLogin3T|MegaFon Login 3",
                model: "Login 3",
                device: "tablet"
            },
            {
                regex: "MS3B|Megafon Optima",
                model: "Optima"
            },
            {
                regex: "SP-A20i",
                model: "Mint"
            },
            {
                regex: "(SP-A5)",
                model: "$1"
            }
        ]
    },
    Inoi: {
        regex: "INOI",
        device: "smartphone",
        models: [
            {
                regex: "INOI 2 Lite 2019",
                model: "2 Lite (2019)"
            },
            {
                regex: "INOI ([257]) (2019|202[01])(?:[);/ ]|$)",
                model: "$1 ($2)"
            },
            {
                regex: "INOI[_ ]([^);/]+)(?: Build|[;)])",
                model: "$1"
            }
        ]
    },
    Vertex: {
        regex: "(?:Luck|Lion_Dual|V709X|Tab [43]G (?:7-2|8-1|10-1)|Pro_P3[01]0_4G|Lion_DC|Baccara|Eagle[ _]4G|ImpressMAX)(?:[);/ ]|$)|Impress[ _]([^;/]+)(?:Build|\\))",
        device: "smartphone",
        models: [
            {
                regex: "(Lion_Dual|Lion_DC|Baccara|Eagle[ _]4G|Luck)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "ImpressMAX(?:[);/ ]|$)",
                model: "Impress Max"
            },
            {
                regex: "Pro_P(3[01]0)_4G(?:[);/ ]|$)",
                model: "Pro P$1 4G"
            },
            {
                regex: "(Impress[ _]([^;/]+))(?:Build|\\))",
                model: "$1"
            },
            {
                regex: "(V709X)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "Tab ([43])G ([78]|10)-([21])",
                device: "tablet",
                model: 'Tab $1G $2.$3"'
            }
        ]
    },
    Unknown: {
        regex: "WebTV/(\\d+\\.\\d+)",
        device: "tv",
        model: "Web TV"
    },
    Starway: {
        regex: "Andromeda[ _]S(707|84[05]|850|8)(?:[);/ ]|$)",
        device: "tablet",
        model: "Andromeda S$1"
    },
    Savio: {
        regex: " (TB-PO1|TB-B01|TB-G01)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Simbans: {
        regex: "TangoTab|Presto[ )]|Ultimax|Valumax|S72-B|SX2W",
        device: "tablet",
        models: [
            {
                regex: "TangoTab",
                model: "TangoTab"
            },
            {
                regex: "Ultimax",
                model: "Ultimax"
            },
            {
                regex: "Valumax",
                model: "Valumax"
            },
            {
                regex: "Presto",
                model: "Presto"
            },
            {
                regex: "S72-B",
                model: "S72-B"
            },
            {
                regex: "SX2W",
                model: "SX2W"
            }
        ]
    },
    MYFON: {
        regex: "MYPAD7s",
        device: "tablet",
        model: "My Pad 7s"
    },
    "X-TIGI": {
        regex: "X[-_]TIGI|Hope7[_ ]Mate|Photo_P15_Lite",
        device: "smartphone",
        models: [
            {
                regex: "X-TIGI_JOY10_PRO",
                model: "Joy 10 Pro",
                device: "tablet"
            },
            {
                regex: "Hope7[_ ]Mate",
                model: "Hope 7 Mate",
                device: "tablet"
            },
            {
                regex: "X-TIGI_JOY7_MAX",
                model: "Joy 7 Max",
                device: "tablet"
            },
            {
                regex: "X-TIGI[_ ]V28[_ ]LTE",
                model: "V28 LTE"
            },
            {
                regex: "X[-_]TIGI[_ ]V19",
                model: "V19"
            },
            {
                regex: "X-TIGI[_ ]Photo[_ ]P11",
                model: "Photo P11"
            },
            {
                regex: "Photo_P15_Lite",
                model: "Photo P15 Lite"
            },
            {
                regex: "X[-_]TIGI[ _-]([^/;)]+) Build",
                model: "$1"
            }
        ]
    },
    Xiaolajiao: {
        regex: "(LA2-(?:L|S[N]?)|HLA Note3|20190416Q|20170608S|20180322D)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "HLA Note3(?:[);/ ]|$)",
                model: "Red Pepper Note 3"
            },
            {
                regex: "(LA2-(?:L|S[N]?))(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(20190416Q)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "20170608S(?:[);/ ]|$)",
                model: "Red Pepper Plus"
            },
            {
                regex: "20180322D(?:[);/ ]|$)",
                model: "E Sports"
            }
        ]
    },
    Ritmix: {
        regex: "(RMD[-_](?:10(?:2[689]|30|5[089])|1121|75[017]|726|85[57]|870)|RMP-(?:450|50[56]|530|600))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "RMD[-_](10(?:2[689]|30|5[089])|1121|75[017]|726|85[57]|870)(?:[);/ ]|$)",
                model: "RMD-$1"
            },
            {
                regex: "RMP[-_](450|50[56]|530|600)(?:[);/ ]|$)",
                model: "RMP-$1",
                device: "smartphone"
            }
        ]
    },
    "Ross&Moor": {
        regex: "RMD[-_](974R|600)(?:[);/ ]|$)",
        device: "tablet",
        model: "RMD-$1"
    },
    "R-TV": {
        regex: "R-TV BOX[ _]?(MINI\\+|X99|X10 PRO|[RXS]10)",
        device: "tv",
        model: "Box $1"
    },
    NEXBOX: {
        regex: "(MXQ|MXQ-Pro)-NEXBOX|NEXBOX-([^) ]+)",
        device: "tv",
        models: [
            {
                regex: "MXQ-Pro-NEXBOX",
                model: "MXQ Pro"
            },
            {
                regex: "MXQ-NEXBOX",
                model: "MXQ"
            },
            {
                regex: "NEXBOX-([^) ]+)",
                model: "$1"
            }
        ]
    },
    True: {
        regex: " TRUE BEYOND TAB 3G|SMART[ _](MAX 4.0 PLUS|4G[ _](?:GEN C [45].[05]|Champion|Speedy 5.0 Plus|Speedy[_ ]5inch|P1))",
        device: "smartphone",
        models: [
            {
                regex: "SMART MAX 4.0 PLUS",
                model: "Smart Max 4.0 Plus"
            },
            {
                regex: "SMART 4G Gen C ([45].[05])",
                model: 'Smart 4G Gen C $1"'
            },
            {
                regex: "SMART 4G Speedy 5.0 Plus",
                model: "Smart 4G Speedy 5.0 Plus"
            },
            {
                regex: "SMART[ _]4G[_ ]Speedy[_ ]5inch",
                model: "Smart 4G Speedy 5"
            },
            {
                regex: "SMART[ _]4G[_ ]Champion",
                model: "Smart 4G Champion"
            },
            {
                regex: "SMART[ _]4G[_ ]P1 Prime",
                model: "Smart 4G P1 Prime"
            },
            {
                regex: "SMART[ _]4G[_ ]P1",
                model: "Smart 4G P1"
            },
            {
                regex: "TRUE BEYOND TAB 3G",
                model: "Beyond Tab 3G"
            }
        ]
    },
    Yandex: {
        regex: "(YNDX-?000SB)(?:[);/ ]|$)",
        device: "smartphone",
        model: "YNDX-000SB"
    },
    FORME: {
        regex: "FORME[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "FORME[ _-]F520(?:[);/ ]|$)",
                model: "Forever"
            },
            {
                regex: "FORME[ _-](A[35]7|R7S?|P6)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Shuttle: {
        regex: "(PNT-704[025])(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    BDF: {
        regex: "(BDF[- ](?:819|P10|K107H|KT107|MT6753|X20)|K960N_MT(?:6580|6753)(?:_32_N)?)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "BDF[- ](819|P10|K107H|KT107|MT6753|X20)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "K960N_MT(6580|6753)(_32_N)?(?:[);/ ]|$)",
                model: "BK960N MT$1"
            }
        ]
    },
    Highscreen: {
        regex: "HIGHSCREEN|(Easy[- ]Power(?:[- ]Pro)?|Pure[_ ](?:Power|F)|Power Ice(?: Max)?|Easy[_ ]([SFL]|XL)(?:_Pro)?|Razar_Pro|Power Rage(?: Evo)?|Zera-S-Power|Zera[ _][UFS]|Power[ _]?Five[ matrixstyle _]?(?:Pro|Evo|Max|Max(?:Lite|2))|PowerFour|BOOST II(?:se)?|Fest(?:XL)?(?:-Pro)?|Tasty|Boost3|Boost 3(?: Pro)? SE|Expanse|Hercules|Alpha Rage|VergeM)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(Power Ice(?:[ ](?:Max|Evo))?|Power Rage(?: Evo)?|Zera[ _][UFS])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "PowerFivePro(?:[);/ ]|$)",
                model: "Power Five Pro"
            },
            {
                regex: "PowerFiveMaxLite(?:[);/ ]|$)",
                model: "Power Five Max Lite"
            },
            {
                regex: "PowerFiveMax2(?:[);/ ]|$)",
                model: "Power Five Max 2"
            },
            {
                regex: "Power Five Evo(?:[);/ ]|$)",
                model: "Power Five Evo"
            },
            {
                regex: "Power Five Max(?:[);/ ]|$)",
                model: "Power Five Max"
            },
            {
                regex: "FestXL-Pro(?:[);/ ]|$)",
                model: "Fest XL Pro"
            },
            {
                regex: "FestXL(?:[);/ ]|$)",
                model: "Fest XL"
            },
            {
                regex: "Fest-Pro(?:[);/ ]|$)",
                model: "Fest Pro"
            },
            {
                regex: "Fest(?:[);/ ]|$)",
                model: "Fest"
            },
            {
                regex: "PowerFour(?:[);/ ]|$)",
                model: "Power Four"
            },
            {
                regex: "Pure[_ ]Power(?:[);/ ]|$)",
                model: "Pure Power"
            },
            {
                regex: "Pure[ _]F(?:[);/ ]|$)",
                model: "Pure F"
            },
            {
                regex: "Razar_Pro(?:[);/ ]|$)",
                model: "Razar Pro"
            },
            {
                regex: "Easy[_ ]([SLF]|XL)[_ ]Pro(?:[);/ ]|$)",
                model: "Easy $1 Pro"
            },
            {
                regex: "Easy[_ ]([SFL]|XL)(?:[);/ ]|$)",
                model: "Easy $1"
            },
            {
                regex: "(?:HIGHSCREEN )?Easy[- ]Power[- ]Pro(?:[);/ ]|$)",
                model: "Easy Power Pro"
            },
            {
                regex: "(?:HIGHSCREEN )?Easy-Power(?:[);/ ]|$)",
                model: "Easy Power"
            },
            {
                regex: "BOOST II(?:[);/ ]|$)",
                model: "Boost 2"
            },
            {
                regex: "BOOST IIse(?:[);/ ]|$)",
                model: "Boost 2 SE"
            },
            {
                regex: "Boost 3 SE(?:[);/ ]|$)",
                model: "Boost 3 SE"
            },
            {
                regex: "Boost 3 Pro SE(?:[);/ ]|$)",
                model: "Boost 3 Pro SE"
            },
            {
                regex: "BOOST3(?:[);/ ]|$)",
                model: "Boost 3"
            },
            {
                regex: "Zera-S-Power(?:[);/ ]|$)",
                model: "Zera S Power"
            },
            {
                regex: "Tasty(?:[);/ ]|$)",
                model: "Tasty"
            },
            {
                regex: "VergeM(?:[);/ ]|$)",
                model: "Verge M"
            },
            {
                regex: "WinWin(?:[);/ ]|$)",
                model: "WinWin"
            },
            {
                regex: "Expanse(?:[);/ ]|$)",
                model: "Expanse"
            },
            {
                regex: "Hercules(?:[);/ ]|$)",
                model: "Hercules"
            },
            {
                regex: "Alpha Rage(?:[);/ ]|$)",
                model: "Alpha Rage"
            }
        ]
    },
    CVTE: {
        regex: "CVTE[_ ](MSD338_(:?1G|512M))(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Globex: {
        regex: "(GU1011C|GU8012C|GU7013C|GU730C|GU-6012B)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "GU8012C(?:[);/ ]|$)",
                model: "X8"
            },
            {
                regex: "GU-6012B(?:[);/ ]|$)",
                model: "GU6012B"
            },
            {
                regex: "(GU1011C|GU7013C|GU730C)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Atom: {
        regex: "ATOM-(108AM|216RK|216AM)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Qumo: {
        regex: "QUMO[ _]?|(?:Quest[ _]?(?:408|410|45[56]|50[679])|Vega[ _]?78[23]|Sirius[ _]?(?:1001|890))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(?:QUMO[ _]?)?Vega[ _]?(78[23]|8002)(?:[);/ ]|$)",
                model: "Vega $1"
            },
            {
                regex: "Yooda(?:[);/ ]|$)",
                model: "Yooda"
            },
            {
                regex: "Sirius[ _]?(1001|890)(?:[);/ ]|$)",
                model: "Sirius $1"
            },
            {
                regex: "(?:QUMO)?(Sirius 101-4G 8GB Black|Altair 701 8GB Black|Altair 71 4GB Black|Altair 700[24]|Altair 706)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(?:QUMO[ _])?Quest[ _]?(35[34]|40[268]|410|45[2568]|47[46]|50[679]|5[17]0|600)(?:[);/ ]|$)",
                device: "smartphone",
                model: "Quest $1"
            }
        ]
    },
    Umax: {
        regex: "VisionBook[ _]|[78]Qa_3G(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(VisionBook[ _](?:10Qi|7Q[i]?|8Q[ei]?|P70|8Qi_3G)(?:[ _](?:[34]G|Plus|LTE))?)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "([78])Qa_3G(?:[);/ ]|$)",
                model: "VisionBook $1Qa 3G"
            },
            {
                regex: "VisionBook_10Q_LTE(?:[);/ ]|$)",
                model: "VisionBook 10Q LTE"
            },
            {
                regex: "VisionBook_P50Plus_LTE(?:[);/ ]|$)",
                device: "smartphone",
                model: "VisionBook P50 Plus LTE"
            },
            {
                regex: "(VisionBook[ _](?:P50 LTE|P55 X2 LTE|P55 LTE(?: Pro)?))(?:[);/ ]|$)",
                device: "smartphone",
                model: "$1"
            }
        ]
    },
    Mann: {
        regex: "(ZUG 3|ZUG 5S(?: Q)?)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Unihertz: {
        regex: "(Titan|Jelly-Pro|Atom_X?L)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(Jelly)-(Pro)(?:[);/ ]|$)",
                model: "$1 $2"
            },
            {
                regex: "(Titan|Atom_X?L)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Chuwi: {
        regex: "(?:CW-(Hi8-super|Hi12|V99i?|V17HD3G|VX8-3G|V88-QUAD|V9-DUAL|V88S|Vi[78]|[HV]i10 (?:pro|plus))|Hi10 (?:Pro|plus)|HiPad X|HiBox-hero|HiBook(?: pro)?|Hi[89] ?(?:Air|Pro)|Hi8SE|Vi10(?: ?Pro)?)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(CW-Hi8-super)(?:[);/ ]|$)",
                model: "Hi8"
            },
            {
                regex: "(?:CW-)?(Vi10|Hi10) plus(?:[);/ ]|$)",
                model: "$1 Plus"
            },
            {
                regex: "CW-(V88)-QUAD(?:[);/ ]|$)",
                model: "$1 Quad"
            },
            {
                regex: "CW-(V9)-DUAL(?:[);/ ]|$)",
                model: "$1 Dual"
            },
            {
                regex: "CW-(V17HD|VX8)-?(3G)(?:[);/ ]|$)",
                model: "$1 $2"
            },
            {
                regex: "(?:CW-)?(Hi10) pro(?:[);/ ]|$)",
                model: "$1 Pro"
            },
            {
                regex: "HiBook pro(?:[);/ ]|$)",
                model: "HiBook Pro"
            },
            {
                regex: "HiBook(?:[);/ ]|$)",
                model: "HiBook"
            },
            {
                regex: "HiPad X(?:[);/ ]|$)",
                model: "HiPad X"
            },
            {
                regex: "Hi([89]) ?Air(?:[);/ ]|$)",
                model: "Hi$1 Air"
            },
            {
                regex: "Hi8SE(?:[);/ ]|$)",
                model: "Hi8 SE"
            },
            {
                regex: "Hi([89]) ?pro(?:[);/ ]|$)",
                model: "Hi$1 Pro"
            },
            {
                regex: "Vi10 Plus(?:[);/ ]|$)",
                model: "Vi10 Plus"
            },
            {
                regex: "Vi10 ?Pro(?:[);/ ]|$)",
                model: "Vi10 Pro"
            },
            {
                regex: "Vi10(?:[);/ ]|$)",
                model: "Vi10"
            },
            {
                regex: "HiBox-hero(?:[);/ ]|$)",
                model: "HiBox Hero",
                device: "desktop"
            },
            {
                regex: "CW-(Vi[78]|Hi12|V99i?|V88S)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Bezkam: {
        regex: "BEZKAM (BK-RAM2)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    "NG Optics": {
        regex: "(NG3128HD)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    KATV1: {
        regex: "(KATV-01) PRO(?:[);/ ]|$)",
        device: "tv",
        model: "$1 Pro"
    },
    Ghong: {
        regex: "GHONG(V10)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Xoro: {
        regex: "(?:TelePAD(?:795|731|1032|10A3|7A3)|Era 2X|HMT(?:390Q?|400)|HST 260)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "TelePAD(7|10)A3 4G(?:[);/ ]|$)",
                model: "TelePad $1 A3 4G"
            },
            {
                regex: "TelePAD(795|731|1032)(?:[);/ ]|$)",
                model: "TelePad $1"
            },
            {
                regex: "HMT(390Q?|400)(?:[);/ ]|$)",
                model: "HMT $1",
                device: "portable media player"
            },
            {
                regex: "HST 260(?:[);/ ]|$)",
                model: "HST 260",
                device: "tv"
            },
            {
                regex: "(Era 2X)(?:[);/ ]|$)",
                model: "$1",
                device: "smartphone"
            }
        ]
    },
    Vinga: {
        regex: "VMP-(015-162|021-82|041-162|011-81|025-324|045-664)(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "VMP-021-82",
                model: "021"
            },
            {
                regex: "VMP-025-324",
                model: "025"
            },
            {
                regex: "VMP-015-162",
                model: "015"
            },
            {
                regex: "VMP-041-162",
                model: "041"
            },
            {
                regex: "VMP-045-664",
                model: "045"
            },
            {
                regex: "VMP-011-81",
                model: "011"
            }
        ]
    },
    Viumee: {
        regex: "SMART[_ ](EV[56])(?:[);/ ]|$)",
        device: "smartphone",
        model: "Smart $1"
    },
    Nuvo: {
        regex: "Nuvo[_ ](NS35|Blue ND40|Green[_ ]ND[_ ]45)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Nuvo[_ ](NS35)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Blue (ND40)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Green[_ ]ND[_ ]45(?:[);/ ]|$)",
                model: "ND45"
            }
        ]
    },
    Sunvell: {
        regex: "(?:T95ZPLUS|T95[KU]PRO)(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "T95ZPLUS",
                model: "T95Z Plus"
            },
            {
                regex: "(T95[KU])PRO",
                model: "$1 Pro"
            }
        ]
    },
    Ugoos: {
        regex: "UGOOS-AM6(?:[);/ ]|$)",
        device: "tv",
        model: "AM6"
    },
    Yxtel: {
        regex: "YXTEL_([HU]1|U3)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Proline: {
        regex: "(H10882M-TN)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Yota: {
        regex: "(YD20[16]|YOTA 3[+])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "YD20[16](?:[);/ ]|$)",
                model: "Phone 2"
            },
            {
                regex: "YOTA 3[+](?:[);/ ]|$)",
                model: "Phone 3 Plus"
            }
        ]
    },
    Mystery: {
        regex: "MYSTERY|(MID-(?:123G|72[12]|7[01348]3G|753G|8[23]3G))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "MID-(123G|72[12]|7[01348]3G|753G|8[23]3G)(?:[);/ ]|$)",
                model: "MID-$1"
            },
            {
                regex: "MYSTERY_TV_(D3155CH31)",
                device: "tv",
                model: "$1"
            }
        ]
    },
    Ritzviva: {
        regex: "(RITZVIVA[_ ]S500C)(?:[);/ ]|$)",
        device: "smartphone",
        model: "S500C"
    },
    DeWalt: {
        regex: "DeWalt (MD501)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Runbo: {
        regex: "Runbo|F1-TT(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Runbo[ _-]?(X5-W|F1 Plus|F1-TT|F1-EN|F1|TT|Q5-S|X5-King|X6|Q5)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "F1-TT",
                model: "F1-TT"
            }
        ]
    },
    NewsMy: {
        regex: "(CarPad-(?:II|III)-P)(?:[);/ ]|$)",
        device: "car browser",
        model: "$1"
    },
    Newsday: {
        regex: "Newsday[_ ](E1|A[12])(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Daewoo: {
        regex: "Daewoo|(DTA-07IDRF)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(DTA-07IDRF)(?:[);/ ]|$)",
                model: "Archive 7P"
            },
            {
                regex: "Daewoo (Android TV 638)(?:[);/ ]|$)",
                model: "$1",
                device: "tv"
            }
        ]
    },
    Vesta: {
        regex: "VESTA32LD86(?:[);/ ]|$)",
        device: "tv",
        model: "SmartT V2.0 32LD86S"
    },
    Spectrum: {
        regex: "(CARBONO_5|CUARZO_6|DIAMANTE_5|VULCANO_55)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "VULCANO_55(?:[);/ ]|$)",
                model: 'Vulcano 5.5"'
            },
            {
                regex: "CARBONO_5(?:[);/ ]|$)",
                model: 'Carbono 5.0"'
            },
            {
                regex: "CUARZO_6(?:[);/ ]|$)",
                model: 'Cuarzo 6.0"'
            },
            {
                regex: "DIAMANTE_5(?:[);/ ]|$)",
                model: 'Diamante 5.0"'
            }
        ]
    },
    Kivi: {
        regex: "(?:24H600G[RU]|24FR50WU|24HK30B|32HR55GU|4[39]UP50GU|40UR50G[RU]|40U600G[RU]|55U600G[RU]|65UP50GU|55U[PC]50G[RU]|50U600G[RU]|50UX10S|55UR50G[RU]|40FK30G|40FR50BR|43UK35G|50FK30G|50UK35G|32HR50GR|55UC30G|32HK30G|40FK30G|32HR50GU|43UK30G|32FR50(?:WR|BU)|32FK3[02]G)(?:_-Ver0[0-9])?(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "(24H600G[RU]|24FR50WU|24HK30B|32HR55GU|4[39]UP50GU|40UR50G[RU]|40U600G[RU]|55U600G[RU]|65UP50GU|55U[PC]50G[RU]|50UX10S|50U600G[RU]|55UR50G[RU]|40FK30G|40FR50BR|43UK35G|50FK30G|50UK35G|32HR50GR|32FR50(?:WR|BU)|32FK3[02]G)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(55UC30G|40FK30G|43UK30G|32HR50G[RU]|32HK30G|32FK32G)_-Ver0([0-9])(?:[);/ ]|$)",
                model: "$1 v$2"
            }
        ]
    },
    Divisat: {
        regex: "(Divisat)(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "(J-Link)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Kanji: {
        regex: "KJ-(OB03|YUBI)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "KJ-OB03(?:[);/ ]|$)",
                model: "Cata 7"
            },
            {
                regex: "KJ-YUBI(?:[);/ ]|$)",
                model: "Yubi 3G"
            }
        ]
    },
    Kaiomy: {
        regex: "KaiCloud[ ]?(7[48]4|942)(?:[);/ ]|$)",
        device: "tablet",
        model: "KaiCloud $1"
    },
    National: {
        regex: "(NX-32THS100)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Vsun: {
        regex: "(?:VSUN (?:ILLUSION|RACE|V9)|MARS TOUCH|MARS NOTE|MARS NOCAM|SATURN SELFIE)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ILLUSION(?:[);/ ]|$)",
                model: "Illusion"
            },
            {
                regex: "MARS TOUCH(?:[);/ ]|$)",
                model: "Mars Touch"
            },
            {
                regex: "MARS NOTE(?:[);/ ]|$)",
                model: "Mars Note"
            },
            {
                regex: "MARS NOCAM(?:[);/ ]|$)",
                model: "Mars Nocam"
            },
            {
                regex: "SATURN SELFIE(?:[);/ ]|$)",
                model: "Saturn Selfie"
            },
            {
                regex: "RACE(?:[);/ ]|$)",
                model: "Race"
            },
            {
                regex: "(V9)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    "Shift Phones": {
        regex: "(SHIFT6m)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    RugGear: {
        regex: "(RugGear|RG(?:310|500|65[05]|702|7[13]0|850))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(RG[0-9]+)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Aligator: {
        regex: "ALIGATOR[_ ]",
        device: "smartphone",
        models: [
            {
                regex: "ALIGATOR[ _](S4080|S50(?:6[56]|[678]0)|S5540|RX510|S6500|RX710|RX800|S5520)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Maxcom: {
        regex: "(MS(?:45[036]|505|514)|MS457(?:PLUS)?)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(MS457)PLUS(?:[);/ ]|$)",
                model: "$1 Plus"
            },
            {
                regex: "MS(45[0367]|505|514)(?:[);/ ]|$)",
                model: "MS$1"
            }
        ]
    },
    Luna: {
        regex: "(?:LUNA[ _](?:V55|G[56]0)|TG-L800S)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "LUNA[ _](V55|G[56]0)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(TG-L800S)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Protruly: {
        regex: "PROTRULY[ _](D[78]|V10S)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    JFone: {
        regex: "JFone[ _](JS501)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Uhans: {
        regex: "(A101S)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Soyes: {
        regex: "SOYES[ _]([67]S|XS)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Zidoo: {
        regex: "ZIDOO[ _](H6 Pro|X6 Pro|X9S|Z10|X[158]|X20 Pro|Z9S)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Zfiner: {
        regex: "ZFINERY900(?:[);/ ]|$)",
        device: "tablet",
        model: "Y900"
    },
    iGet: {
        regex: "SMART[_ ](G10[12]|S7[02]|G71|G81[H]?)(?:[);/ ]|$)",
        device: "tablet",
        model: "Smart $1"
    },
    iVA: {
        regex: "(LAMCY (?:L3[05]0|C100|L400)|IVA S6)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "LAMCY (L3[05]0|C100|L400)(?:[);/ ]|$)",
                model: "Lamcy $1"
            },
            {
                regex: "IVA S6(?:[);/ ]|$)",
                model: "S6"
            }
        ]
    },
    Phicomm: {
        regex: "(PHICOMM)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "C630 \\(CLUE L\\)(?:[);/ ]|$)",
                model: "Clue L"
            },
            {
                regex: "E653\\(ENERGY L\\)(?:[);/ ]|$)",
                model: "Energy L"
            },
            {
                regex: "PHICOMM ENERGY 3\\+(?:[);/ ]|$)",
                model: "Energy 3+"
            },
            {
                regex: "CLUE (2S|M)(?:[);/ ]|$)",
                model: "Clue $1"
            }
        ]
    },
    Huadoo: {
        regex: "Huadoo[ _](HG0[46]|HG11|V[34])(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Gome: {
        regex: "(?:GOME[_ ](?:201[678].+|C7_Note(?:_Plus)?|U9|S[17])|Fenmmy_Note)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "GOME[_ ](?:2018X38A)(?:[);/ ]|$)",
                model: "C72"
            },
            {
                regex: "GOME[_ ](?:2018X07A)(?:[);/ ]|$)",
                model: "C7"
            },
            {
                regex: "GOME[_ ](?:2017X05A)(?:[);/ ]|$)",
                model: "C71"
            },
            {
                regex: "GOME[_ ](?:2016G68A)(?:[);/ ]|$)",
                model: "K1"
            },
            {
                regex: "GOME[_ ](?:2016M25A)(?:[);/ ]|$)",
                model: "U1"
            },
            {
                regex: "GOME[_ ](?:2017M27A)(?:[);/ ]|$)",
                model: "U7"
            },
            {
                regex: "GOME[_ ](C7_Note(?:_Plus)?|U9|S[17])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(?:GOME[_ ])?(Fenmmy_Note)(?:[);/ ]|$)",
                device: "phablet",
                model: "$1"
            }
        ]
    },
    Voyo: {
        regex: "(?:VOYO[_ ](?:A15)|i8-Max|Q101-4G)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "i8-Max(?:[);/ ]|$)",
                model: "i8 Max"
            },
            {
                regex: "(Q101)-4G(?:[);/ ]|$)",
                model: "$1 4G"
            },
            {
                regex: "VOYO[_ ](A15)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Ryte: {
        regex: "RYTE (U55 LTE)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Vontar: {
        regex: "(HK1 (?:Max|MINI|PLUS|PRO)|VONTAR[ -](?:Z[58]|V1|KIII|MX-4K|X3))(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "VONTAR[ -](Z[58]|V1|KIII|MX-4K|X3)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "HK1 Max(?:[);/ ]|$)",
                model: "HK1 Max"
            },
            {
                regex: "HK1 MINI(?:[);/ ]|$)",
                model: "HK1 Mini"
            },
            {
                regex: "HK1 PLUS(?:[);/ ]|$)",
                model: "HK1 Plus"
            },
            {
                regex: "HK1 PRO(?:[);/ ]|$)",
                model: "HK1 Pro"
            }
        ]
    },
    Vorke: {
        regex: "VORKE (Z[157]|Z6(?: Plus)?)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Wigor: {
        regex: "Wigor (V4)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    NEXON: {
        regex: "NEXON (X[1589])(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    ONN: {
        regex: "(ONA19TB00[327]|10000520[6-9]|O8HD)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    EXO: {
        regex: "(Wave_i101G|Wave i101[Hb])(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    "Q.Bell": {
        regex: "(QPHONE[_ ](?:10.1|9.[12]|7.1|5.[46])|QTAB10EW)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(QPHONE[_ ](?:10.1|9.[12]|7.1|5.[46]))(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "QTAB10EW",
                device: "tablet",
                model: "QTAB10EW"
            }
        ]
    },
    Datawind: {
        regex: "DW-[A-Z0-9]{5}(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(DW-PS3G5)(?:[);/ ]|$)",
                model: "Pocket Surfer 3G5"
            },
            {
                regex: "DW-UBT7W",
                device: "tablet",
                model: "Ubislate 7W"
            }
        ]
    },
    Droxio: {
        regex: "DROXIO (C40|B45)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Goophone: {
        regex: "Goophone[ _]|(?:M(G492|L7[JK]2)CH|MN(4A2|8J2)ZP|MGA92ZP|MKU82ZP|MNGW2CH|MNH02CH|MNRM2CH)[/]A(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:MG492CH|MGA92ZP)[/]A(?:[);/ ]|$)",
                model: "I6 Plus"
            },
            {
                regex: "ML7[JK]2CH[/]A(?:[);/ ]|$)",
                model: "I6"
            },
            {
                regex: "MKU82ZP[/]A(?:[);/ ]|$)",
                model: "I6S"
            },
            {
                regex: "MNGW2CH[/]A(?:[);/ ]|$)",
                model: "I6S Plus"
            },
            {
                regex: "(?:MN4A2ZP|MNH02CH)[/]A(?:[);/ ]|$)",
                model: "I7"
            },
            {
                regex: "(?:MN8J2ZP|MNRM2CH)[/]A(?:[);/ ]|$)",
                model: "I7 Plus"
            },
            {
                regex: "S4 MEGA(?:[);/ ]|$)",
                model: "S4 Mega"
            },
            {
                regex: "Goophone i([69])(?:[);/ ]|$)",
                model: "I$1"
            }
        ]
    },
    PocketBook: {
        regex: "PocketBook[ _/]",
        device: "tablet",
        models: [
            {
                regex: 'PocketBook SURFpad 3 \\(([\\d]+).([\\d]+)["]?\\)(?:[);/ ]|$)',
                model: 'Surfpad 3 $1.$2"'
            },
            {
                regex: "PocketBook/(62[67]|63[12]|740|840)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Bitmore: {
        regex: "(?:Mobitab10c-3G|Tab1011Q_II)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(Mobitab)(10)c-3G(?:[);/ ]|$)",
                model: "$1 $2C 3G"
            },
            {
                regex: "Tab1011Q_II(?:[);/ ]|$)",
                model: "Tab1011Q II"
            }
        ]
    },
    Kuliao: {
        regex: "KULIAO (K10)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Sugar: {
        regex: "SUGAR[ _]",
        device: "smartphone",
        models: [
            {
                regex: "SUGAR Y([78]) MAX(?:[);/ ]|$)",
                model: "Y$1 Max"
            },
            {
                regex: "SUGAR F7 Mini(?:[);/ ]|$)",
                model: "F7 Mini"
            },
            {
                regex: "SUGAR (C[12]1|C1[23]|S11|C11s|[SF]20s?|[YF]11|[YFS]9|C[679]|[FY]7|Y12s|Y1[256]|P1)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Subor: {
        regex: "SUBOR[ _]",
        device: "smartphone",
        models: [
            {
                regex: "SUBOR[ _](S5|2019)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "SUBOR[_ ]K10PLUS(?:[);/ ]|$)",
                model: "K10 Plus"
            }
        ]
    },
    Xshitou: {
        regex: "Xshitou[_ ](P7)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    JKL: {
        regex: "JKL[_ ](A28)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Gree: {
        regex: "(G0215D|G0245D|G0335D)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Vodacom: {
        regex: "(?:Vodacom)[ _](Power Tab 10)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    VKworld: {
        regex: "(?:(?:VK700)-MAX|VK700 Pro|T5SE|VK700X|vk6050|vk6735|vk700)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(VK700)-MAX(?:[);/ ]|$)",
                model: "$1 Max"
            },
            {
                regex: "(VK700) Pro(?:[);/ ]|$)",
                model: "$1 Pro"
            },
            {
                regex: "T5SE(?:[);/ ]|$)",
                model: "T5 SE"
            },
            {
                regex: "VK(700X|6050|6735|700)(?:[);/ ]|$)",
                model: "VK$1"
            }
        ]
    },
    Mito: {
        regex: "MITO[- _](A(?:1[0678]|19_[12]GB|21|3[59]|55|180|2[36]0|313|322|33|3[136]0|[35]50|6[89]|7[235]|82|[356]0|810|950)|T(?:8|10|35|3[03]0|510|888)|311)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "MITO[- _](A(?:1[0678]|19_[12]GB|21|3[59]|55|180|2[36]0|33|322|313|3[136]0|[35]50|6[89]|7[235]|82|[356]0|810|950)|311)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "MITO[ _](T(?:8|10|35|3[03]0|510|888))(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    TWM: {
        regex: "Amazing[ _](X[35]s|X[123567]|A5S|A3[025]|A[468]|A4S|A5[057]|P6)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Amazing[ _](X[35])s(?:[);/ ]|$)",
                model: "Amazing $1S"
            },
            {
                regex: "Amazing[ _](A5S|X[123567]|A[468]|A4S|A5[057]|A3[025])(?:[);/ ]|$)",
                model: "Amazing $1"
            },
            {
                regex: "Amazing[ _](P6)(?:[);/ ]|$)",
                device: "tablet",
                model: "Amazing $1"
            }
        ]
    },
    TWZ: {
        regex: "TWZ[-_ ](?:TabPlay|Y6[08]|Y52|A49|A[59]5|A567|AA8|QQ[12])|TWZQQ1",
        device: "smartphone",
        models: [
            {
                regex: "TWZ[_ ]TabPlay[_ ](12[56])",
                device: "tablet",
                model: "TabPlay $1"
            },
            {
                regex: "TWZ[-_ ]?(Y6[08]|Y52|A49|A[59]5|A567|AA8|QQ[12])",
                model: "$1"
            }
        ]
    },
    Onix: {
        regex: "(?:ONIX S405|AT101-1116)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(AT101-1116)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(S405)(?:[);/ ]|$)",
                device: "smartphone",
                model: "$1"
            }
        ]
    },
    Oale: {
        regex: "Apex([13])(?:[);/ ]|$)",
        device: "smartphone",
        model: "Apex $1"
    },
    Mobo: {
        regex: "(?:(?:MOBO[_ ]MB7005|MT7-421HD)|(?:MT7-442D|MT7-411D))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(?:MOBO[_ ])?(MB7005|MT7-421HD|MT7-442D|MT7-411D)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Macoox: {
        regex: "(MC-X7MINI)(?:[);/ ]|$)",
        device: "smartphone",
        model: "MC-X7 Mini"
    },
    Prixton: {
        regex: "PRIXTON |(T7012Q)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "PRIXTON (C18)",
                device: "smartphone",
                model: "$1"
            },
            {
                regex: "(T7012Q)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Magnus: {
        regex: "Magnus[ _](?:bravoZ[23]0|Infinity_?(?:G8|G11))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "bravo(Z[23]0)",
                model: "Bravo $1"
            },
            {
                regex: "(?:Magnus[ _])?Infinity_?(G8|G11)",
                model: "Infinity $1"
            }
        ]
    },
    Newland: {
        regex: "(?:NLS-MT90)(?:[);/ ]|$)",
        device: "smartphone",
        model: "MT90 Orca"
    },
    Orbic: {
        regex: "(?:RC555L|RC501L)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "RC555L(?:[);/ ]|$)",
                model: "Wonder"
            },
            {
                regex: "RC501L(?:[);/ ]|$)",
                model: "Slim"
            }
        ]
    },
    RED: {
        regex: "(?:H1A1000)(?:[);/ ]|$)",
        device: "smartphone",
        model: "Hydrogen One"
    },
    Contixo: {
        regex: "Contixo|(?:CX-1045 3G|KT995 3G|CX1045)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "CX-?1045(?: 3G)?(?:[);/ ]|$)",
                model: "CX-1045 3G"
            },
            {
                regex: "CONTIXO GX 1035(?:[);/ ]|$)",
                model: 'GX-1035 4G 10.1"'
            },
            {
                regex: "Contixo GT1160 4G(?:[);/ ]|$)",
                model: 'GT1160 4G 10.1"'
            },
            {
                regex: "B105(?:[);/ ]|$)",
                model: 'B105 3G 10.1"'
            },
            {
                regex: "B108(?:[);/ ]|$)",
                model: 'B108 4G 10.1"'
            },
            {
                regex: "KT107(?: 3G)?(?:[);/ ]|$)",
                model: 'KT107 3G 10.1"'
            },
            {
                regex: "K109(?:[);/ ]|$)",
                model: 'KT109 4G 10.1"'
            },
            {
                regex: "KT715 3G(?:[);/ ]|$)",
                model: 'KT715 3G 7.0"'
            },
            {
                regex: "KT995(?:[);/ ]|$)",
                model: 'KT995 3G 10.1"'
            },
            {
                regex: "KT1100GT(?:[);/ ]|$)",
                model: "KT1100GT"
            }
        ]
    },
    "E-Ceros": {
        regex: "(?:CT9716(?:-B)?)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "CT9716(?:[);/ ]|$)",
                model: "Revolution"
            },
            {
                regex: "CT9716-B(?:[);/ ]|$)",
                model: "Revolution HD"
            }
        ]
    },
    How: {
        regex: "(?:HT-705XS|705-G Go|1001-G Go)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(HT-705XS)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(1001-G Go)(?:[);/ ]|$)",
                model: "HT-1001G Go Kids"
            },
            {
                regex: "(705-G Go)(?:[);/ ]|$)",
                model: "HT-$1"
            }
        ]
    },
    Multilaser: {
        regex: "(?:Multilaser[ _](?:[FEGH])(?:[_ ](?:Pro|Max|Lite))?|MS50[LGX]|M7[_-]3G[_-]PLUS|MS5\\.V2|MS45S_A6|ML([02]1|12)-M7s[- ]?Quad-?Core| ML01-M7-SD|MS45S|MS50S|MS60[XZ]|M7SQC_Plus|MS80X|MS40[GS]|MS55M|MS70|M7-3G QUAD CORE|M7sLite|MS50L_4G|MS60F(?:_PLUS)?)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Multilaser[ _]G[_ ]Pro(?:[);/ ]|$)",
                model: "G Pro"
            },
            {
                regex: "Multilaser[ _]F[_ ]Pro(?:[);/ ]|$)",
                model: "F Pro"
            },
            {
                regex: "Multilaser[ _]G[_ ]Max(?:[);/ ]|$)",
                model: "G Max"
            },
            {
                regex: "Multilaser[ _]G(?:[);/ ]|$)",
                model: "G"
            },
            {
                regex: "Multilaser[ _]E[_ ]Lite(?:[);/ ]|$)",
                model: "E Lite"
            },
            {
                regex: "Multilaser[ _]([FEH])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "MS60F_PLUS(?:[);/ ]|$)",
                model: "MS60F Plus"
            },
            {
                regex: "(MS50[LGX]|MS45S_A6|MS40[GS]|MS55M|MS60F|MS70|MS60[XZ]|MS45S|MS80X|MS50L_4G|MS50S|MS5\\.V2)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "M7[_-]3G[_-]PLUS(?:[);/ ]|$)",
                device: "tablet",
                model: "M7 3G Plus"
            },
            {
                regex: "M7SQC_PLUS(?:[);/ ]|$)",
                device: "tablet",
                model: "M7SQC Plus"
            },
            {
                regex: "M7-3G QUAD CORE(?:[);/ ]|$)",
                device: "tablet",
                model: "M7 3G Quad Core"
            },
            {
                regex: "ML([02]1|12)-M7s[- ]?Quad-?Core(?:[);/ ]|$)",
                device: "tablet",
                model: "ML$1-M7s Quad Core"
            },
            {
                regex: "M7sLite(?:[);/ ]|$)",
                device: "tablet",
                model: "M7s Lite"
            },
            {
                regex: "ML01-M7-SD(?:[);/ ]|$)",
                device: "tablet",
                model: "ML01-M7 SD"
            }
        ]
    },
    "Positivo BGH": {
        regex: "(?:T1060B|S455|Positivo (?:Twist|Ypy|Mini I)|Twist[ _](?:\\(2018\\)|2 (?:Fit|Pro)|Mini|Tab|Metal(?: 32GB)?|Max|XL|SE|[23SM]))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "S455(?:[);/ ]|$)",
                model: "Selfie"
            },
            {
                regex: "Twist \\(2018\\)(?:[);/ ]|$)",
                model: "Twist (2018)"
            },
            {
                regex: "Twist Metal 32GB(?:[);/ ]|$)",
                model: "Twist Metal 32GB"
            },
            {
                regex: "Twist Metal(?:[);/ ]|$)",
                model: "Twist Metal"
            },
            {
                regex: "Twist Max(?:[);/ ]|$)",
                model: "Twist Max"
            },
            {
                regex: "Twist[ _]Mini(?:[);/ ]|$)",
                model: "Twist Mini"
            },
            {
                regex: "Twist 2 Fit(?:[);/ ]|$)",
                model: "Twist 2 Fit"
            },
            {
                regex: "Twist 2 Pro(?:[);/ ]|$)",
                model: "Twist 2 Pro"
            },
            {
                regex: "Twist XL(?:[);/ ]|$)",
                model: "Twist XL"
            },
            {
                regex: "Twist SE(?:[);/ ]|$)",
                model: "Twist SE"
            },
            {
                regex: "(?:Positivo )?Twist ([23SM])(?:[);/ ]|$)",
                model: "Twist $1"
            },
            {
                regex: "(?:Positivo )Mini I(?:[);/ ]|$)",
                model: "Mini I"
            },
            {
                regex: "T1060B(?:[);/ ]|$)",
                device: "tablet",
                model: "T1060B"
            },
            {
                regex: "Positivo Ypy (AB7F|AB10H|L1050E)(?:[);/ ]|$)",
                device: "tablet",
                model: "Ypy $1"
            },
            {
                regex: "Twist Tab(?:[);/ ]|$)",
                device: "tablet",
                model: "Twist Tab"
            }
        ]
    },
    Maxtron: {
        regex: "Maxtron[ _-](V[327]|S[89]|T1)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Maxtron[ _-](V[327]|S[89])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Maxtron[ _-](T1)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    Philco: {
        regex: "PHILCO |(PCS01|PH350B|PTB7R|PTB7PAP_PTB7PAB_PTB7PAR)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(PCS01|PH350B)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(PTB7R)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "PHILCO Android TV(?:[);/ ]|$)",
                device: "tv",
                model: ""
            },
            {
                regex: "PTB7PAP_PTB7PAB_PTB7PAR(?:[);/ ]|$)",
                device: "tablet",
                model: "PTB7PA"
            }
        ]
    },
    "SEMP TCL": {
        regex: "(?:GO[35]E|5101J|GO3C(?: Plus)?)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "5101J(?:[);/ ]|$)",
                model: "L9 Plus"
            },
            {
                regex: "GO3C Plus(?:[);/ ]|$)",
                model: "GO! 3C Plus"
            },
            {
                regex: "GO3C(?:[);/ ]|$)",
                model: "GO! 3C"
            },
            {
                regex: "(GO[35]E)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Newman: {
        regex: "Newman[ _](P308|K1)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Swipe: {
        regex: "(Elite Sense|Elite_VR)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Owwo: {
        regex: "(?:OWWO[ _]?(?:[1457]S|Q[78])|CARNIVAL B5)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "OWWO[ _]?([1457]S|Q[78])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "CARNIVAL B5(?:[);/ ]|$)",
                model: "Carnival B5"
            }
        ]
    },
    "TD Systems": {
        regex: "(K32DLX9HS|K40DLM8FS|K40DLX9FS)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Ravoz: {
        regex: "RAVOZ[ _](Z5 (?:Lite|Pro)|Z[3-7]|R[478])(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Tone: {
        regex: "TONE (e19|m15|e20)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    "AT&T": {
        regex: "(?:U304AA|QS5509A|U705AA)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "U304AA(?:[);/ ]|$)",
                model: "Radiant Core"
            },
            {
                regex: "U705AA(?:[);/ ]|$)",
                model: "Radiant Max"
            },
            {
                regex: "QS5509A(?:[);/ ]|$)",
                model: "Axia"
            }
        ]
    },
    BIHEE: {
        regex: "(ZBH-)?BIHEE",
        device: "smartphone",
        models: [
            {
                regex: "(A1[12]|A[78]\\+|A[56])(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Enot: {
        regex: "Enot[ _-](E102|J101)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Kooper: {
        regex: "Kooper-mobile-W502(?:[);/ ]|$)",
        device: "smartphone",
        model: "Mobile W502"
    },
    Lesia: {
        regex: "ANOVA A5(?:[);/ ]|$)",
        device: "smartphone",
        model: "Anova A5"
    },
    Anry: {
        regex: "ANRY-(RS10|[SX]20)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Tinai: {
        regex: "Tinai (K[12])(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Winds: {
        regex: "NOTE GRACE V(?:[);/ ]|$)",
        device: "smartphone",
        model: "Note Grace V"
    },
    Asano: {
        regex: "32LF7130S(?:[);/ ]|$)",
        device: "tv",
        model: '32LF7130S 32.0"'
    },
    Phonemax: {
        regex: "PHONEMAX[_ ](Saturn(?:[_ ]X)?|Mars|Venus X)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "PHONEMAX[_ ]Saturn[_ ]X(?:[);/ ]|$)",
                model: "Saturn X"
            },
            {
                regex: "PHONEMAX[_ ]Saturn(?:[);/ ]|$)",
                model: "Saturn"
            },
            {
                regex: "PHONEMAX[_ ]Mars(?:[);/ ]|$)",
                model: "Mars"
            },
            {
                regex: "PHONEMAX[_ ]Venus X(?:[);/ ]|$)",
                model: "Venus X"
            }
        ]
    },
    Vipro: {
        regex: "VIPRO(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "VIPRO PRO2X(?:[);/ ]|$)",
                model: "Pro 2X"
            },
            {
                regex: "VIPRO PRO[ _-]?([0-9])(?:[);/ ]|$)",
                model: "Pro $1"
            }
        ]
    },
    OzoneHD: {
        regex: "Ozone HD|OzoneHD[ _](T2 WiFi|4K(?: TV)?|Fun)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Kzen: {
        regex: "(?:Ureki_U1|Victor V1|DART KZ07)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Ureki_U1",
                model: "Ureki U1"
            },
            {
                regex: "Victor V1",
                model: "Victor V1"
            },
            {
                regex: "DART KZ07",
                device: "tablet",
                model: "Dart KZ07"
            }
        ]
    },
    Melrose: {
        regex: "MELROSE_(?:S9|2019)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "MELROSE_S9(?:[);/ ]|$)",
                model: "S9"
            },
            {
                regex: "MELROSE_2019(?:[);/ ]|$)",
                model: '2019 Ultra Slim 3.4"'
            }
        ]
    },
    Crony: {
        regex: "CRONY-7021(?:[);/ ]|$)",
        device: "tablet",
        model: "7021"
    },
    Takara: {
        regex: "(MID211H)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Tronsmart: {
        regex: "(Orion R68G|Draco AW80|Draco H3|Vega S95_(?:Meta|Pro|Telos))(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Amigoo: {
        regex: "AMIGOO (R300|R9 Max|M1 Max|X15)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Lumigon: {
        regex: "Lumigon[ _](T3)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Neomi: {
        regex: "NEO[ ]?(90[689])(?:[);/ ]|$)",
        device: "smartphone",
        model: "Neo $1"
    },
    Eltex: {
        regex: "(?:NV5(?:01|10)WAC|NV501|NV510WB)(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "NV5(01|10)WAC(?:[);/ ]|$)",
                model: "NV-5$1-Wac"
            },
            {
                regex: "NV501(?:[);/ ]|$)",
                model: "NV-501"
            },
            {
                regex: "NV510WB(?:[);/ ]|$)",
                model: "NV-510-WB"
            }
        ]
    },
    Senkatel: {
        regex: "Senkatel[ _](T1009|T8002|T701[12]|T9702)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Bobarry: {
        regex: "(?:K10[ ]?SE)(?:[);/ ]|$)",
        device: "tablet",
        model: "K10 SE"
    },
    Wortmann: {
        regex: "TERRA[ _]PAD[ _](100[45])(?:[);/ ]|$)",
        device: "tablet",
        model: "Terra Pad $1"
    },
    "BB Mobile": {
        regex: "Techno[-_ ](8\\.0|9\\.7|TQ863Q|X595BT|S700BF|I700AJ|10.1 LTE TQ060X|7.0 LTE TQ763I|I785AP|I101BI)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "Techno[_ ]S700BF(?:[);/ ]|$)",
                model: 'Techno 7.0" Pioneer LTE S700BF'
            },
            {
                regex: "Techno[_ ]10.1 LTE TQ060X(?:[);/ ]|$)",
                model: 'Techno 10.0" LTE TQ060X'
            },
            {
                regex: "Techno[_ ]TQ863Q(?:[);/ ]|$)",
                model: 'Techno 8.0" Poplar LTE TQ863Q'
            },
            {
                regex: "Techno[_ ]I700AJ(?:[);/ ]|$)",
                model: 'Techno 7.0" Mozg LTE I700AJ'
            },
            {
                regex: "Techno[-_ ]I785AP(?:[);/ ]|$)",
                model: 'Techno 7.85" Mozg I785AP'
            },
            {
                regex: "Techno[-_ ]I101BI(?:[);/ ]|$)",
                model: 'Techno 10.1" Mozg I101BI'
            },
            {
                regex: "Techno[_ ]7.0 LTE TQ763I(?:[);/ ]|$)",
                model: 'Techno 7.0" Kalash LTE TQ763I'
            },
            {
                regex: "Techno[_ ](9\\.7|8\\.0) 3G(?:[);/ ]|$)",
                model: 'Techno $1" 3G'
            },
            {
                regex: "Techno[_ ](?:X595BT)(?:[);/ ]|$)",
                device: "smartphone",
                model: "Techno Spark 3G X595BT"
            }
        ]
    },
    "2E": {
        regex: "(?:E500A_2019|2E E450 2018)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "E500A_2019(?:[);/ ]|$)",
                model: "E500A (2019)"
            },
            {
                regex: "2E E450 2018(?:[);/ ]|$)",
                model: "E450 (2018)"
            }
        ]
    },
    Billion: {
        regex: "Capture\\+(?:[);/ ]|$)",
        device: "smartphone",
        model: "Capture Plus"
    },
    Tele2: {
        regex: "Tele2[ _]",
        device: "smartphone",
        models: [
            {
                regex: "Tele2[ _](Mi[dn]i)[ _]1.1(?:[);/ ]|$)",
                model: "$1 1.1"
            },
            {
                regex: "Tele2[ _]Midi[ _]2.0(?:[);/ ]|$)",
                model: "Midi 2.0"
            },
            {
                regex: "Tele2[ _]((?:Maxi|Midi)(?:[_ ](?:Plus|LTE))?)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Tele2[ _](Mi[dn]i)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Alfawise: {
        regex: "(?:Alfawise (?:A9)|(?:A95X_R1))(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "(A95X_R1)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Alfawise (A9)",
                model: "$1"
            }
        ]
    },
    Klipad: {
        regex: "KLIPAD_|(?:KL-V905|KL4889|KL9878|7589AN)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:KLIPAD_)?(V355B?|KL600|KL-V905)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(KL4889|7589AN|KL9878)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    SQOOL: {
        regex: "SQOOL-V(41?)(?:[);/ ]|$)",
        device: "tablet",
        model: "V$1"
    },
    TurboKids: {
        regex: "Turbokids[-_ ]?(TMNT|3G|S4)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Jinga: {
        regex: "Jinga[-_ ]|(?:(?:Fresh|Optim)4G|Pass(?:Plus|3G)|PicassoNote|Hotz[_ ]M1|WinPRO|Touch4G|Start3G|IGO[ _]L[41]|Basco (?:L3|L[45]00|XS1|S2))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Optim4G(?:[);/ ]|$)",
                model: "Optim 4G"
            },
            {
                regex: "Fresh4G(?:[);/ ]|$)",
                model: "Fresh 4G"
            },
            {
                regex: "Hotz[_ ]M1(?:[);/ ]|$)",
                model: "Hotz M1"
            },
            {
                regex: "PassPlus(?:[);/ ]|$)",
                model: "Pass Plus"
            },
            {
                regex: "Pass3G(?:[);/ ]|$)",
                model: "Pass 3G"
            },
            {
                regex: "WinPRO(?:[);/ ]|$)",
                model: "Win Pro"
            },
            {
                regex: "Touch4G(?:[);/ ]|$)",
                model: "Touch 4G"
            },
            {
                regex: "Start3G(?:[);/ ]|$)",
                model: "Start 4G"
            },
            {
                regex: "PicassoNote(?:[);/ ]|$)",
                model: "Picasso Note"
            },
            {
                regex: "Jinga Iron(?:[);/ ]|$)",
                model: "Iron"
            },
            {
                regex: "Jinga Basco neo(?:[);/ ]|$)",
                model: "Basco Neo"
            },
            {
                regex: "(?:Jinga )?Basco (L3|L[45]00|XS1|S2)(?:[);/ ]|$)",
                model: "Basco $1"
            },
            {
                regex: "Jinga Trezor S1 Plus(?:[);/ ]|$)",
                model: "Trezor S1 Plus"
            },
            {
                regex: "JINGA_IGO_L2(?:[);/ ]|$)",
                model: "IGO L2"
            },
            {
                regex: "(?:JINGA[_ ])?IGO[_ ]([ML]1|L4)(?:[);/ ]|$)",
                model: "IGO $1"
            },
            {
                regex: "Jinga Trezor S1 Plus(?:[);/ ]|$)",
                model: "Trezor S1 Plus"
            }
        ]
    },
    Twoe: {
        regex: "(?:TWOE[-_ ]E450R|F534L|F572L|E500A)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "TWOE[-_ ](E450R)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "(F534L|F572L|E500A)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    iTruck: {
        regex: "iTRUCK 7 3G(?:[);/ ]|$)",
        device: "smartphone",
        model: '7.0" 3G'
    },
    Torex: {
        regex: "TOREX[- ](?:PS12|S18|S27)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "TOREX-(PS12)",
                model: "$1"
            },
            {
                regex: "TOREX[- ](S18|S27)",
                device: "smartphone",
                model: "$1"
            }
        ]
    },
    Doffler: {
        regex: "(24DHS54)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Oyyu: {
        regex: "OYYUT11(?:[);/ ]|$)",
        device: "tablet",
        model: "T11 3G"
    },
    Primux: {
        regex: "Primux",
        device: "smartphone",
        models: [
            {
                regex: "Primux_ioxphone(?:[);/ ]|$)",
                model: "IOX Phone"
            },
            {
                regex: "PrimuxDelta6(?:[);/ ]|$)",
                model: "Delta 6"
            },
            {
                regex: "PrimuxKappa(P50[01])(?:[);/ ]|$)",
                model: "Kappa $1"
            },
            {
                regex: "PrimuxKappa(?:[);/ ]|$)",
                model: "Kappa"
            },
            {
                regex: "Primux_Beta2(?:[);/ ]|$)",
                model: "Beta 2"
            },
            {
                regex: "Primux_?Omega([57])(?:[);/ ]|$)",
                model: "Omega $1"
            },
            {
                regex: "PrimuxUP(?:[);/ ]|$)",
                device: "tablet",
                model: "UP"
            },
            {
                regex: " PrimuxZonda4(?:[);/ ]|$)",
                device: "tablet",
                model: "Zonda 4"
            },
            {
                regex: "Primux_Siroco6(?:[);/ ]|$)",
                device: "tablet",
                model: "Siroco 6"
            }
        ]
    },
    iMars: {
        regex: "(?:IMARS VEGA X7|VIVI_8)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "IMARS VEGA X7",
                model: "Vega X7"
            },
            {
                regex: "VIVI_8",
                model: "VIVI 8"
            }
        ]
    },
    Logic: {
        regex: "LOGIC[_ ](X[135]|X4M|L5D|X5[AFT]|X60G|L61|X60_PLUS)(:?[_ ]LITE2?)?(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "LOGIC[_ ]X60_PLUS(?:[);/ ]|$)",
                model: "X60 Plus"
            },
            {
                regex: "LOGIC[_ ](X5|X4M)[_ ]LITE(?:[);/ ]|$)",
                model: "$1 Lite"
            },
            {
                regex: "LOGIC[_ ](X5)[_ ]LITE2(?:[);/ ]|$)",
                model: "$1 Lite 2"
            },
            {
                regex: "LOGIC[_ ](X[13]|X4M|L5D|X5[AFT]|X60G|L61)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Cloudpad: {
        regex: "\\+VT(?:107C|Q007C)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "\\+VT(107C)",
                model: "+VT$1"
            },
            {
                regex: "\\+VTQ(007C)",
                model: "+VTQ$1"
            }
        ]
    },
    Cloudfone: {
        regex: "(?:Thrill (?:Boost[ ]?(2|3)?|Snap|Access)|Excite Prime 2 Pro|NBA Edition)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Thrill Boost (2|3)(?:[);/ ]|$)",
                model: "Thrill Boost $1"
            },
            {
                regex: "Thrill Boost(?:[);/ ]|$)",
                model: "Thrill Boost"
            },
            {
                regex: "Thrill Snap(?:[);/ ]|$)",
                model: "Thrill Snap"
            },
            {
                regex: "Thrill Access(?:[);/ ]|$)",
                model: "Thrill Access"
            },
            {
                regex: "Excite Prime 2 Pro(?:[);/ ]|$)",
                model: "Excite Prime 2 Pro"
            },
            {
                regex: "NBA Edition(?:[);/ ]|$)",
                model: "NBA Edition"
            }
        ]
    },
    Vsmart: {
        regex: "(?:Joy 1\\+|Active 1\\+|Bee 3|Active 3)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Joy 1\\+(?:[);/ ]|$)",
                model: "Joy 1 Plus"
            },
            {
                regex: "Active 1\\+(?:[);/ ]|$)",
                model: "Active 1 Plus"
            },
            {
                regex: "Bee 3(?:[);/ ]|$)",
                model: "Bee 3"
            },
            {
                regex: "Active 3(?:[);/ ]|$)",
                model: "Active 3"
            }
        ]
    },
    MiXzo: {
        regex: "(?:MiXzo[ _])?(?:ME1023|ME1030|MX1037|MX1024|MX10[24]1|MX1397)([ _][34]G)?(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "MiXzo[_ ]ME(1023|1030)(?:[_ ]3G)(?:[);/ ]|$)",
                model: "ME$1 3G"
            },
            {
                regex: "MiXzo[_ ]MX1021(?:[_ ]3G)?(?:[);/ ]|$)",
                model: "MX1021 3G"
            },
            {
                regex: "(?:MiXzo[ _])?MX(1037|1041|1024|1397)[ _]4G(?:[);/ ]|$)",
                model: "MX$1 4G"
            }
        ]
    },
    Openbox: {
        regex: "Openbox (A[34](?: (?:Pro|Lite))?)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Ziox: {
        regex: "ZIOX[_ ]|(?:Astra Viva 4G|Astra NXT Pro|Duopix F9)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ZIOX[_ ]F9[_ ]PRO(?:[);/ ]|$)",
                model: "F9 Pro"
            },
            {
                regex: "Astra Viva 4G(?:[);/ ]|$)",
                model: "Astra Viva 4G"
            },
            {
                regex: "Astra NXT Pro(?:[);/ ]|$)",
                model: "Astra NXT Pro"
            },
            {
                regex: "Duopix F9(?:[);/ ]|$)",
                model: "Duopix F9"
            }
        ]
    },
    iDroid: {
        regex: "APACHE G6(?:[);/ ]|$)",
        device: "smartphone",
        model: "Apache G6"
    },
    Aoson: {
        regex: "aoson(?:R10[1-3]|S[78]|M707TG)(?:[_ ]?Pro)?(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "aosonR10([1-3])(?:[);/ ]|$)",
                model: 'R10$1 10.1"'
            },
            {
                regex: "aosonS7_Pro(?:[);/ ]|$)",
                model: 'S7 Pro 7.0"'
            },
            {
                regex: "aosonS7(?:[);/ ]|$)",
                model: 'S7 7.0"'
            },
            {
                regex: "aosonS8Pro(?:[);/ ]|$)",
                model: 'S8 Pro 8.0"'
            },
            {
                regex: "aoson(M707TG)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    "FireFly Mobile": {
        regex: "(?:AURII[ _](?:Passion|Virtuoso|ULTRA|Secret Lite|AMUSE[_ ]3G|FORCE|FUSION|F8[_ ]Premium|XCITE|DELIGHT|DREAM[_ ](?:MINI|One))|SECRET_XR|INTENSE[ _](?:POWER|METAL_2|XT)|SUPER SWEET|SWEET MINI)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "AURII[ _]FORCE(?:[);/ ]|$)",
                model: "Aurii Force"
            },
            {
                regex: "AURII[ _]DELIGHT(?:[);/ ]|$)",
                model: "Aurii Delight"
            },
            {
                regex: "AURII[ _]DREAM[_ ]MINI(?:[);/ ]|$)",
                model: "Aurii Dream Mini"
            },
            {
                regex: "AURII[ _]DREAM[_ ]One(?:[);/ ]|$)",
                model: "Aurii Dream One"
            },
            {
                regex: "AURII[ _]ULTRA(?:[);/ ]|$)",
                model: "Aurii Ultra"
            },
            {
                regex: "AURII[ _]AMUSE[_ ]3G(?:[);/ ]|$)",
                model: "Aurii Amuse 3G"
            },
            {
                regex: "AURII[ _]FUSION(?:[);/ ]|$)",
                model: "Aurii Fusion"
            },
            {
                regex: "AURII[ _]XCITE(?:[);/ ]|$)",
                model: "Aurii xCite"
            },
            {
                regex: "SECRET_XR(?:[);/ ]|$)",
                model: "Aurii Secret XR"
            },
            {
                regex: "AURII[ _]((?:Passion|Virtuoso|Secret Lite|F8[_ ]Premium))(?:[);/ ]|$)",
                model: "Aurii $1"
            },
            {
                regex: "INTENSE POWER(?:[);/ ]|$)",
                model: "Intense Power"
            },
            {
                regex: "INTENSE_XT(?:[);/ ]|$)",
                model: "Intense XT"
            },
            {
                regex: "INTENSE_METAL_2(?:[);/ ]|$)",
                model: "Intense Metal 2"
            },
            {
                regex: "SUPER SWEET(?:[);/ ]|$)",
                model: "Super Sweet"
            },
            {
                regex: "SWEET MINI(?:[);/ ]|$)",
                model: "Sweet Mini"
            }
        ]
    },
    "i-Cherry": {
        regex: "iCherry_?",
        device: "smartphone",
        models: [
            {
                regex: "iCherry[ _](C(?:25[1258]|21[16]|110|121|22[0379]|23[03])|X1)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "iCherry-C256",
                device: "tablet",
                model: "C256 Nano 3G"
            }
        ]
    },
    NextTab: {
        regex: "TAB (A40[13]0)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Time2: {
        regex: "(TC1050G)(?:[);/ ]|$)",
        device: "tablet",
        model: '$1 10.1"'
    },
    Sunstech: {
        regex: "(TAB2323GMQC)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Hotwav: {
        regex: "(?:Venus[_ ]X1[024569]|Cosmos[ _](?:V8_lite|V19_Plus|V2[0-3]|U2|V19|V[569])|Pearl K2|Magic Q8|Magic 5 Plus|Magic (?:[89]|1[13])|Hot[_ ]6)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Cosmos[ _]V8_lite(?:[);/ ]|$)",
                model: "Cosmos V8 Lite"
            },
            {
                regex: "Hot[_ ]6?(?:[);/ ]|$)",
                model: "Hot 6"
            },
            {
                regex: "(Venus[_ ]X1[024569]|Cosmos[ _](?:V19_Plus|V2[0-3]|U2|V19|V[569])|Pearl K2|Magic Q8|Magic 5 Plus|Magic (?:[89]|1[13]))(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Tetratab: {
        regex: "CASEBOOK_3(?:[);/ ]|$)",
        device: "tablet",
        model: "Casebook 3"
    },
    Dolamee: {
        regex: "Dolamee[_ -](D[56])(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Invin: {
        regex: "INVIN[ _-]|KM5PRO(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "INVIN[ _-](X[24]|KM[678])",
                model: "$1"
            },
            {
                regex: "KM5PRO",
                model: "KM5 Pro"
            }
        ]
    },
    Doopro: {
        regex: "Doopro P3(?:[);/ ]|$)",
        device: "smartphone",
        model: "P3"
    },
    IQM: {
        regex: "IQM (?:picasso|vivaldi|newton)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "IQM picasso(?:[);/ ]|$)",
                model: "Picasso"
            },
            {
                regex: "IQM vivaldi(?:[);/ ]|$)",
                model: "Vivaldi"
            },
            {
                regex: "IQM newton(?:[);/ ]|$)",
                model: "Newton"
            }
        ]
    },
    Nos: {
        regex: "Nos (?:FIVE|NOVU|NEVA|Roya)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "NOS FIVE(?:[);/ ]|$)",
                model: "Five"
            },
            {
                regex: "NOS NOVU III(?:[);/ ]|$)",
                model: "Novu III"
            },
            {
                regex: "NOS NOVU II(?:[);/ ]|$)",
                model: "Novu II"
            },
            {
                regex: "NOS NOVU(?:[);/ ]|$)",
                model: "Novu"
            },
            {
                regex: "NOS NEVA 80(?:[);/ ]|$)",
                model: "Neva 80"
            },
            {
                regex: "NOS Roya(?:[);/ ]|$)",
                model: "Roya"
            }
        ]
    },
    Accent: {
        regex: "(?:ACCENT[_ ]NEON|FAST73G|PEARL[_ ]A[24567]|TANK_P55|CAMELEON[_ ](?:C[456]|A1)(?:[_ ]PLUS)?|Speed[- ](?:[AXYM]2|X2\\+))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ACCENT[_ ]NEON(?:[);/ ]|$)",
                model: "Neon"
            },
            {
                regex: "CAMELEON[_ ]C6[_ ]PLUS(?:[);/ ]|$)",
                model: "Cameleon C6 Plus"
            },
            {
                regex: "Speed[- ]([AXYM]2)(?:[);/ ]|$)",
                model: "Speed $1"
            },
            {
                regex: "Speed-X2\\+(?:[);/ ]|$)",
                model: "Speed X2 Plus"
            },
            {
                regex: "CAMELEON[_ ](C[456]|A1)(?:[);/ ]|$)",
                model: "Cameleon $1"
            },
            {
                regex: "PEARL A4 Lite(?:[);/ ]|$)",
                model: "Pearl A4 Lite"
            },
            {
                regex: "PEARL[_ ]A([2567])(?:[);/ ]|$)",
                model: "Pearl A$1"
            },
            {
                regex: "TANK_P55(?:[);/ ]|$)",
                model: "Tank P55"
            },
            {
                regex: "FAST73G(?:[);/ ]|$)",
                device: "phablet",
                model: "FAST7 3G"
            }
        ]
    },
    Avenzo: {
        regex: "Avenzo(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "MOB4 4G(?:[);/ ]|$)",
                model: "Mob 4 4G"
            },
            {
                regex: "MOB4PRO 4G(?:[);/ ]|$)",
                model: "Mob 4 Pro 4G"
            }
        ]
    },
    Beelink: {
        regex: "(?:Beelink (?:G[ST]1|LAKE I|SEA I|A1)|GTKing|GT1mini-2|GT1-mini(?:-AT)?)(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "Beelink (G[ST]1|LAKE I|SEA I|A1)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "GT1-mini(?:-AT)?(?:[);/ ]|$)",
                model: "GT1 Mini"
            },
            {
                regex: "GT1mini-2(?:[);/ ]|$)",
                model: "GT1 Mini 2"
            },
            {
                regex: "GTKing(?:[);/ ]|$)",
                model: "GT King"
            }
        ]
    },
    MAXVI: {
        regex: "MAXVI[ _](?:MS401)(?:[);/ ]|$)|(?:\\w+)?_MAXVI_\\w+|MS502[_ ]Orion|MS531",
        device: "smartphone",
        models: [
            {
                regex: "MAXVI[ _](MS401)",
                model: "$1"
            },
            {
                regex: "MS531",
                model: "MS531 Vega"
            },
            {
                regex: "MS502[_ ]Orion",
                model: "MS502 Orion"
            },
            {
                regex: "(?:\\w+)?MAXVI_(P11|K10|X[358]00)_\\w+",
                device: "feature phone",
                model: "$1"
            }
        ]
    },
    "MDC Store": {
        regex: "Prime_S(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Prime_S(?:[);/ ]|$)",
                model: "Prime S"
            }
        ]
    },
    meanIT: {
        regex: "meanIT[ _](?:C[12]|X10|X[126]|MG430|Q[145])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "meanIT[ _]Q1 plus(?:[);/ ]|$)",
                model: "Q1 Plus"
            },
            {
                regex: "meanIT[ _](C[12]|X[126]|MG430|Q[145])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "meanIT[ _]X10(?:[);/ ]|$)",
                device: "tablet",
                model: "X10"
            }
        ]
    },
    Kenxinda: {
        regex: "Three[_ ]Proofings[_ ]W([5-9])(?:[);/ ]|$)",
        device: "smartphone",
        model: "Three Proofings W$1"
    },
    "X-BO": {
        regex: "X[-]?BO (V[78]|V1[01]|V[89]\\+)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Xgody: {
        regex: "XGODY",
        device: "smartphone",
        models: [
            {
                regex: "XGODY Y17(?:[);/ ]|$)",
                model: "Y17"
            },
            {
                regex: "XGODY_X96(?:[);/ ]|$)",
                model: "X96",
                device: "tv"
            }
        ]
    },
    Alcor: {
        regex: "(Access_Q784C)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    iBrit: {
        regex: "IBRIT_|(?:SI5[12])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "IBRIT_I([57])(?:[);/ ]|$)",
                model: "I$1"
            },
            {
                regex: "iBRIT_POWER6(?:[);/ ]|$)",
                model: "Power 6"
            },
            {
                regex: "iBRIT_Speed Pro(?:[);/ ]|$)",
                model: "Speed Pro"
            },
            {
                regex: "SI51(?:[);/ ]|$)",
                model: "Speed"
            },
            {
                regex: "SI52(?:[);/ ]|$)",
                model: "Speed Plus"
            }
        ]
    },
    Ovvi: {
        regex: "Jumbo X1",
        device: "smartphone",
        model: "Jumbo X1"
    },
    Fero: {
        regex: "Fero[_ ]|Royale[_ ](?:[YX]2|A1)",
        device: "smartphone",
        models: [
            {
                regex: "Fero_Y1",
                model: "Y1"
            },
            {
                regex: "Royale Y2 Lite",
                model: "Royale Y2 Lite"
            },
            {
                regex: "Royale[_ ]([YX]2|A1)",
                model: "Royale $1"
            },
            {
                regex: "FERO PACE",
                model: "Pace"
            },
            {
                regex: "Fero[ _](A4001|A450[23]|A5001|L100|Iris|Power|Mega LTE|Vibe)",
                model: "$1"
            }
        ]
    },
    Ruio: {
        regex: "Ruio[ _]",
        device: "smartphone",
        models: [
            {
                regex: "Ruio[ _](S4)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Ruio[ _](S5)Plus(?:[);/ ]|$)",
                model: "$1 Plus"
            }
        ]
    },
    Transpeed: {
        regex: "Transpeed_|(?:TR99 MINI\\+|TR99)(?:[);/ ]|$)",
        device: "tv",
        models: [
            {
                regex: "TR99 MINI\\+",
                model: "TR99 Mini Plus"
            },
            {
                regex: "(?:Transpeed_)?(TR99|H616|6K)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    VVETIME: {
        regex: "ZYVV1(?:[);/ ]|$)",
        device: "smartphone",
        model: "V1"
    },
    A1: {
        regex: "A1 (?:Alpha|Alpha 20\\+)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "A1 Alpha 20\\+",
                model: "Alpha 20 Plus"
            },
            {
                regex: "A1 Alpha",
                model: "Alpha"
            }
        ]
    },
    Swisstone: {
        regex: "swisstone (SD 5[13]0)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    "P-UP": {
        regex: "MD-04P(?:[);/ ]|$)",
        device: "phablet",
        model: "Mode 1 RR"
    },
    iVooMi: {
        regex: "(?:Innelo_1|iV 505)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Innelo_1",
                model: "Innelo 1"
            },
            {
                regex: "iV 505",
                model: "Me 1"
            }
        ]
    },
    Pixelphone: {
        regex: "Pixelphone S1(?:[);/ ]|$)",
        device: "smartphone",
        model: "S1"
    },
    Pixela: {
        regex: "Infineum[_ ](Z4?5)(?:[);/ ]|$)",
        device: "smartphone",
        model: "Infineum $1"
    },
    Iris: {
        regex: "(?:Vox[_ ](?:[45]S|Alpha|POP|STEEL Plus|Energy)|IS2_?Plus|IS2S|Next_P_PRO|IRS002-16)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Vox[_ ]([45])S",
                model: "Vox $1S"
            },
            {
                regex: "VOX Alpha Plus",
                model: "Vox Alpha Plus"
            },
            {
                regex: "VOX STEEL Plus",
                model: "Vox Steel Plus"
            },
            {
                regex: "VOX Alpha",
                model: "Vox Alpha"
            },
            {
                regex: "VOX Energy",
                model: "Vox Energy"
            },
            {
                regex: "VOX POP plus",
                model: "Vox Pop Plus"
            },
            {
                regex: "VOX POP Pro",
                model: "Vox Pop Pro"
            },
            {
                regex: "Next_P_PRO",
                model: "Next P Pro"
            },
            {
                regex: "IS2_?Plus",
                model: "IS2 Plus"
            },
            {
                regex: "IRS002-16",
                model: "I-S6"
            },
            {
                regex: "IS2S",
                model: "IS2S"
            }
        ]
    },
    Fonos: {
        regex: "Fonos-(O1)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Xtouch: {
        regex: "Xtouch[ _](X10|A5)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Conquest: {
        regex: "Conquest[-_](?:S(?:[68]|1[0126])|F2)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Conquest[-_]S([68]|1[0126])",
                model: "S$1"
            },
            {
                regex: "Conquest-F2",
                model: "F2"
            }
        ]
    },
    Zatec: {
        regex: "ZATEC[_ ]|(?:[ ]WIND|ZPLAY1_2018|Zpower_(?:Plus|2018))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ZATEC[_ ]GRAVITY(?:[);/ ]|$)",
                model: "Gravity"
            },
            {
                regex: "[ ]WIND(?:[);/ ]|$)",
                model: "Wind"
            },
            {
                regex: "ZPLAY1_2018",
                model: "Zplay (2018)"
            },
            {
                regex: "Zpower_2018",
                model: "Zpower (2018)"
            },
            {
                regex: "Zpower_Plus",
                model: "Zpower Plus"
            }
        ]
    },
    Selenga: {
        regex: "Selenga[ _](A[134])(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Starlight: {
        regex: "Starlight|(?:My_Star_X|RIO STAR|C_Note_Pro|Star_Mix_2)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "My_Star_X",
                model: "My Star X"
            },
            {
                regex: "RIO STAR",
                model: "Rio Star"
            },
            {
                regex: "C_Note_Pro",
                model: "C Note Pro"
            },
            {
                regex: "Star_Mix_2",
                model: "Star Mix 2"
            },
            {
                regex: "Starlight_ROME_X",
                model: "Rome X"
            }
        ]
    },
    GEOFOX: {
        regex: "GEOFOX[_](MID743)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Tinmo: {
        regex: "TiNMO[- _](A11|K3)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Matrix: {
        regex: "(7116-A5)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Verico: {
        regex: "(RP-UDM0[12]A|RP-UDP05A)(?:[);/ ]|$)",
        device: "tablet",
        model: "Uni Pad $1"
    },
    TTEC: {
        regex: "(Magictab (?:9GX|7GE|718))(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    eSTAR: {
        regex: "eSTAR[_ ](?:Grand|GO\\!?|Zoom Quad|Gemini|MINI[_ ]3G|BEAUTY|MOON)",
        device: "tablet",
        models: [
            {
                regex: "eSTAR (Grand|GO\\!?) (HD Intel|IPS Intel|IPS|HD|Intel) Quad Core 3G",
                model: "$1 $2 Quad Core 3G"
            },
            {
                regex: "eSTAR (Zoom Quad|Gemini|GO)",
                model: "$1"
            },
            {
                regex: "eSTAR GRAND HD quad core( [34]G)?",
                model: "Grand HD Quad Core$1"
            },
            {
                regex: "eSTAR GRAND",
                model: "Grand"
            },
            {
                regex: "eSTAR BEAUTY HD Quad core",
                model: "Beauty HD Quad Core"
            },
            {
                regex: "eSTAR MOON HD Quad core",
                model: "Moon HD Quad Core 3G"
            },
            {
                regex: "eSTAR BEAUTY 2 HD Quad core",
                model: "Beauty 2 HD Quad Core"
            },
            {
                regex: "eSTAR[_ ]MINI[_ ]3G",
                model: "Mini 3G"
            }
        ]
    },
    Hometech: {
        regex: "(?:Ideal (?:10S|Tab [79])|ALFA10TB|ALFA[_ ](?:10RC|10TM?|7RS|[78]RC|7M)|HT[ _](?:7RT|8MZ))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(Ideal (?:10S|Tab 9))(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "ALFA[_ ]?(10RC|10T[BM]?|7RS|[78]RC|7M)(?:[);/ ]|$)",
                model: "ALFA $1"
            },
            {
                regex: "Ideal Tab 7 Ips( 3G)?",
                model: "Ideal Tab 7 IPS$1"
            },
            {
                regex: "HT[ _](7RT|8MZ)(?:[);/ ]|$)",
                model: "HT $1"
            }
        ]
    },
    ExMobile: {
        regex: "EX(29|45)i(?:[);/ ]|$)",
        device: "smartphone",
        model: "EX $1i"
    },
    Hipstreet: {
        regex: "10DTB12(?:[);/ ]|$)",
        device: "tablet",
        model: "Phoenix"
    },
    Navitech: {
        regex: "(NeoTab)[ _-]((?:S1[23]0|S125|H85|H11[05]|KID741|S9700))(?:[);/ ]|$)",
        device: "tablet",
        model: "$1 $2"
    },
    NorthTech: {
        regex: "(NT-TP10)(?:[);/ ]|$)",
        device: "tablet",
        model: 'TouchPad 10.0"'
    },
    UNIWA: {
        regex: "UNIWA[ _](X5)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Andowl: {
        regex: "ANDOWL-(Q[45])(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Silelis: {
        regex: "Silelis[ _](T-1)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Bluedot: {
        regex: "BLUEDOT[_ ]|(?:BNT-71)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "(?:BLUEDOT[_ ])?(BNP-500)(?:[);/ ]|$)",
                device: "smartphone",
                model: "$1"
            },
            {
                regex: "(BNT-71)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    "Planet Computers": {
        regex: "(Cosmo_Communicator)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Reach: {
        regex: "(Allure[_ ](?:Ultra(?:[_]Curve)?|Secure|Admire|Rise))(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    MobiWire: {
        regex: "(?:Kiona|KANUNA|Halona|Kicka[_ ][45][ _]Plus|Kohana|Kosumi|KWANITA|Lonan|Hotah|Kicka 5|Kiona)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "KANUNA",
                model: "Kanuna"
            },
            {
                regex: "KWANITA",
                model: "Kwanita"
            },
            {
                regex: "(Kiona|Kicka[_ ][45][ _]Plus|Kohana|Kosumi|Lonan|Halona|Hotah|Kicka 5|Kiona)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Hezire: {
        regex: "(HTB801)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Hurricane: {
        regex: "Hurricane[ _]|(?:Flame_Plus)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Hurricane[ _]IGNITE",
                model: "Ignite"
            },
            {
                regex: "Hurricane[ _]Bolt",
                model: "Bolt"
            },
            {
                regex: "Hurricane[ _]VORTEX",
                model: "Vortex"
            },
            {
                regex: "Hurricane[ _]GIGA",
                model: "Giga"
            },
            {
                regex: "Flame_Plus",
                model: "Flame Plus"
            }
        ]
    },
    iSWAG: {
        regex: "ISWAG[ _]",
        device: "smartphone",
        models: [
            {
                regex: "ISWAG[_ ]VIPER",
                model: "Viper"
            },
            {
                regex: "iSWAG[_ ]Lynx",
                model: "Lynx"
            },
            {
                regex: "iSWAG[_ ]MANTRA",
                model: "Mantra"
            },
            {
                regex: "iSWAG[_ ]MEGA",
                model: "Mega"
            },
            {
                regex: "iSWAG[_ ]NEMESIS",
                model: "Nemesis"
            }
        ]
    },
    Reeder: {
        regex: "(?:reeder[_ ](?:3G_Tablet|A7iC|A[78]i[_ ]Quad|A8i Q2|M8 Plus|[TM]8|M10 Plus|P11SE)|P12Curve)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "reeder[_ ](3G_Tablet|A7iC|A[78]i[_ ]Quad|A8i Q2|M8 Plus|[TM]8|M10 Plus|P11SE)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "P12Curve",
                device: "smartphone",
                model: "P12 Curve"
            }
        ]
    },
    ELARI: {
        regex: "KidPhone4G(?:[);/ ]|$)",
        device: "wearable",
        model: "KidPhone 4G"
    },
    "Epik One": {
        regex: "(K501 Plus|[ ]K5(?:0[0-4]|1[01]|03T|3[456]|4[05]|73)|[ ]K60[01]|[ ]X507T|[ ]K40[56]|[ ]T700)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "K501 Plus",
                model: "Leo Plus"
            },
            {
                regex: "K501",
                model: "Leo"
            },
            {
                regex: "K500",
                model: "Omega Lite"
            },
            {
                regex: "K502",
                model: "Omega"
            },
            {
                regex: "K503T",
                model: "Leo Turbo"
            },
            {
                regex: "K503",
                model: "Leo Max"
            },
            {
                regex: "K504",
                model: "Titan 3G"
            },
            {
                regex: "X507T",
                model: "Titan II"
            },
            {
                regex: "K510",
                model: "Bolt"
            },
            {
                regex: "K511",
                model: "Bolt Pro"
            },
            {
                regex: "K534",
                model: "Hada"
            },
            {
                regex: "K535",
                model: "Hada Turbo"
            },
            {
                regex: "K545",
                model: "Rocket"
            },
            {
                regex: "K536",
                model: "Royal"
            },
            {
                regex: "K540",
                model: "Excalibur"
            },
            {
                regex: "K573",
                model: "Panther"
            },
            {
                regex: "K600",
                model: "Jupiter"
            },
            {
                regex: "K601",
                model: "Jupiter One"
            },
            {
                regex: "K406",
                model: "Pebble Plus"
            },
            {
                regex: "K405",
                model: "Pebble II"
            },
            {
                regex: "T700",
                model: "Palette",
                device: "tablet"
            }
        ]
    },
    Altice: {
        regex: "Altice[ _](S62|S31|S43)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Kult: {
        regex: "(Ambition|Beyond)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Beyond: {
        regex: "SURVE(10|[26-8]|[12] PRO)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "SURVE([12]) PRO",
                model: "Surve $1 Pro"
            },
            {
                regex: "SURVE(10|[26-8])",
                model: "Surve $1"
            }
        ]
    },
    BioRugged: {
        regex: "(?:BioWolf 8-F30|BIOWOLF8F30|Ruggbo 20 Lite)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "BioWolf 8-F30|BIOWOLF8F30",
                model: "BioWolf 8-F30"
            },
            {
                regex: "Ruggbo 20 Lite",
                model: "Ruggbo 20 Lite"
            }
        ]
    },
    VAIO: {
        regex: "(?:VPA051|VA-10J)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "VPA051",
                model: "Phone A"
            },
            {
                regex: "(VA-10J)",
                model: "$1"
            }
        ]
    },
    Spark: {
        regex: "Spark Plus 3(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Plus 3",
                model: "Plus 3"
            }
        ]
    },
    SPC: {
        regex: "(?:Gravity Max|GRAVITY_OCTACORE|SPC SMART LITE|SPC_ALIEN(?:_STICK)?|SPC Glow9.7)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "GRAVITY_OCTACORE",
                model: "Gravity OctaCore"
            },
            {
                regex: "Gravity Max",
                model: "Gravity Max"
            },
            {
                regex: "SPC Glow9.7",
                model: 'Glow 9.7"'
            },
            {
                regex: "SPC SMART LITE",
                device: "smartphone",
                model: "Smart Lite"
            },
            {
                regex: "SPC_ALIEN_STICK",
                device: "tv",
                model: "Alien Stick"
            },
            {
                regex: "SPC_ALIEN",
                device: "tv",
                model: "Alien"
            }
        ]
    },
    Winmax: {
        regex: "Winmax[ _](?:XC14|XC[46]|TX30)(?:[);/ ]|$)|MAUI.+Winmax_BD45",
        device: "smartphone",
        models: [
            {
                regex: "Winmax[ _](XC14|XC[46])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Winmax[ _](TX30)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "MAUI.+Winmax_(BD45)",
                device: "feature phone",
                model: "$1"
            }
        ]
    },
    Zebra: {
        regex: " (TC5[16]|TC2[05]|TC75|TC7[05]x|TC700H)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Thuraya: {
        regex: "Thuraya[ _](X5-Touch)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Bkav: {
        regex: "Bphone[ _](B111[45]|B2017)(?:[);/ ]|$)",
        device: "smartphone",
        model: "Bphone $1"
    },
    Brandt: {
        regex: "(BPRIME|BSTAR\\+?|BPRIMES|B-ONE)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Bigben: {
        regex: "GAMETAB-ONE(?:[);/ ]|$)",
        device: "tablet",
        model: "GameTab-One"
    },
    SMARTEC: {
        regex: "(Atractivo)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Asanzo: {
        regex: "ASANZO[ _](?:A2|S[23]|[SZ]5|S3_PLUS)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ASANZO[ _]S3[ _]PLUS",
                model: "S3 Plus"
            },
            {
                regex: "ASANZO[ _](A2|S[23]|[SZ]5)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Artizlee: {
        regex: "Artizlee[ _]S9|ATL-(?:16|21(?:PLUS|[XT])?|31|26)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "ATL-21PLUS(?:[);/ ]|$)",
                model: "ATL-21 Plus"
            },
            {
                regex: "(ATL-(?:16|21[XT]?|31|26))(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Artizlee[ _]S9",
                device: "smartphone",
                model: "S9"
            }
        ]
    },
    Mintt: {
        regex: "(?:Coolmintt(?:A3|M2)?|Ultramintt(?:S2)?|FRESHMINTT(?:A7|A10)?)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Coolmintt ?([PM]1|P3|A3|M2)(?:[);/ ]|$)",
                model: "CoolMintt $1"
            },
            {
                regex: "Ultramintt ?([SR]1|S2)(?:[);/ ]|$)",
                model: "UltraMintt $1"
            },
            {
                regex: "FRESHMINTT ?(A7|A10)(?:[);/ ]|$)",
                device: "tablet",
                model: "FreshMintt $1"
            }
        ]
    },
    Premio: {
        regex: "(?:186HS2080531|186HS1050531|186HS1050232|186FT1080231|185FT5050231|PREMIO[ _](?:S50|P420|P451))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "186HS2080531",
                model: "X1"
            },
            {
                regex: "186HS1050531",
                model: "P541"
            },
            {
                regex: "185FT5050231",
                model: "P511"
            },
            {
                regex: "186FT1080231",
                model: "P571"
            },
            {
                regex: "186HS1050232",
                model: "P630"
            },
            {
                regex: "PREMIO[ _](S50|P420|P451)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Trifone: {
        regex: "Passion[-_](?:1S|PRO|PLUS)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Passion-1S",
                model: "Passion 1S"
            },
            {
                regex: "Passion-Plus",
                model: "Passion Plus"
            },
            {
                regex: "Passion_Pro",
                model: "Passion Pro"
            }
        ]
    },
    Bluewave: {
        regex: "(?:33GT HD|WV8R-M|WV8R[_-]N)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "33GT HD",
                model: "Wave 8 HD+"
            },
            {
                regex: "WV8R-M",
                model: "Wave 8 Red Marshmallow"
            },
            {
                regex: "WV8R[_-]N",
                model: "Wave 8 Red Nougat"
            }
        ]
    },
    Siragon: {
        regex: "Siragon|(?:SP-(?:5250|5400|5050))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:Siragon[_ ])?(SP-(?:5[12]50|5400|5050))",
                model: "$1"
            }
        ]
    },
    Poppox: {
        regex: "Poppox P3",
        device: "smartphone",
        model: "P3"
    },
    Zentality: {
        regex: "C-723ULTRA(?:[);/ ]|$)",
        device: "tablet",
        model: "C-723 Ultra"
    },
    "Black Bear": {
        regex: "(B6 Master|B6 Note X)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Fortis: {
        regex: "(Apollo 5 Neo)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    OpelMobile: {
        regex: " OpelMobile_(SmartJX)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    NuAns: {
        regex: "NEO \\[Reloaded\\](?:[);/ ]|$)",
        device: "smartphone",
        model: "NEO Reloaded"
    },
    Koolnee: {
        regex: "(K1 Trio)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Sansui: {
        regex: "Sansui[_ ]",
        device: "smartphone",
        models: [
            {
                regex: "Sansui[_ ](Switch|Play|Fun|SA4[01]|U4[56]|U3[02]|Nova)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Sico: {
        regex: "SICO[_ ](?:PLUS|e1002)|Express3-Max|SSR3-1-51-5M|SSD-1-53-13M",
        device: "smartphone",
        models: [
            {
                regex: "SICO[_ ]PLUS2",
                model: "Plus 2"
            },
            {
                regex: "SICO[_ ]PLUS",
                model: "Plus"
            },
            {
                regex: "SSR3-1-51-5M",
                model: "Pro 3"
            },
            {
                regex: "SSD-1-53-13M",
                model: "Diamond"
            },
            {
                regex: "SICO[_ ]e1002",
                device: "tablet",
                model: "E1002"
            },
            {
                regex: "Express3-Max",
                device: "tablet",
                model: "Express 3 Max"
            }
        ]
    },
    Smadl: {
        regex: "Android.+(?:Safari)(?!/[\\d.]+)(?: Build|\\) AppleWebKit)|SMADL[ _]",
        device: "smartphone",
        models: [
            {
                regex: "Android.+(?:Safari)(?!/[\\d.]+)(?: Build|\\) AppleWebKit)",
                model: "Safari"
            },
            {
                regex: "SMADL[ _]Matri([2X])",
                model: "Matri $1"
            }
        ]
    },
    EXCEED: {
        regex: "(EX7SL?4|EX10S4)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Tymes: {
        regex: "Tymes[ _](V5)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Solone: {
        regex: "SOLONE|(?:E1457|W145[02])(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "E1457",
                model: "Earth Iron E1457"
            },
            {
                regex: "W1450",
                model: "Wind Breeze W1450"
            },
            {
                regex: "W1452",
                model: "Wind Air W1452"
            },
            {
                regex: "SOLONE A47",
                model: "SL-A47"
            },
            {
                regex: "SOLONE[ _]Elite[ _]L5501",
                model: "Elite L5501"
            },
            {
                regex: "SOLONE[ _]SUMO[_ ]S5001",
                model: "Sumo S5001"
            },
            {
                regex: "SOLONE[ _](SL-K40|S5002)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    FarEasTone: {
        regex: "Smart ?(601|550|50[59])(?:[);/ ]|$)",
        device: "smartphone",
        model: "Smart $1"
    },
    Smailo: {
        regex: "Smailo_(2GO)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Colors: {
        regex: "(?:Colors[ _](S(?:[19]|11)|P70|P[456]5|P32|E15|P50 Plus)|Pride_1A|P52_Pride5C|P90_Pride5X)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Pride_1A(?:[);/ ]|$)",
                model: "Pride 1A"
            },
            {
                regex: "P52_Pride5C(?:[);/ ]|$)",
                model: "Pride 5C"
            },
            {
                regex: "P90_Pride5X(?:[);/ ]|$)",
                model: "Pride 5X"
            },
            {
                regex: "Colors[ _](S(?:[19]|11)|P70|E15|P[456]5|P32|P50 Plus)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Honeywell: {
        regex: "(EDA50K?|EDA70|EDA51)(?:[);/ ]|$)",
        device: "smartphone",
        model: "ScanPal $1"
    },
    Electroneum: {
        regex: "electroneum(M1)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    "High Q": {
        regex: "(ELT070[46]H|ELT0802H)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Pluzz: {
        regex: "Pluzz[_-](Z552|PL5[05]10|PL4010|PL501[46]|Elite_Dual)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    "IKU Mobile": {
        regex: "(Powerful_K55i|Curvy C50L)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    "IKI Mobile": {
        regex: "(?:GO5_55|BLESS_GO55|BLESSPLUS|KF4Go|KF5bless)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "GO5_55",
                model: 'Go 5.5"'
            },
            {
                regex: "BLESS_GO55",
                model: 'Bless Go 5.5"'
            },
            {
                regex: "BLESSPLUS",
                model: "Bless Plus"
            },
            {
                regex: "(KF4Go|KF5bless)",
                model: "$1"
            }
        ]
    },
    "CG Mobile": {
        regex: "(?:CG_OMEGA6|Omega (?:[38])|CG_EON_Blaze_Pro|CG\\|EON Blaze GOLD)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Omega ([38])(?:[);/ ]|$)",
                model: "Omega $1"
            },
            {
                regex: "CG_OMEGA6(?:[);/ ]|$)",
                model: "Omega 6"
            },
            {
                regex: "CG_EON_Blaze_Pro(?:[);/ ]|$)",
                model: "EON Blaze Pro"
            },
            {
                regex: "CG\\|EON Blaze GOLD(?:[);/ ]|$)",
                model: "EON Blaze Gold"
            }
        ]
    },
    IUNI: {
        regex: "IUNI[ _]",
        device: "smartphone",
        models: [
            {
                regex: "IUNI[ _](U3|i1|N1)",
                model: "$1"
            }
        ]
    },
    "ZH&K": {
        regex: "(?:ODYSSEY O2|ODYSSEY RANGE)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ODYSSEY O2",
                model: "Odyssey O2"
            },
            {
                regex: "ODYSSEY RANGE",
                model: "Odyssey Range"
            }
        ]
    },
    Ordissimo: {
        regex: "(LeNumero1)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Necnot: {
        regex: "(M002[DGQK]-2|M002N|M002N-3T|M002W-2T|6M-3T)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Einstein: {
        regex: "Einstein(T3)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    AfriOne: {
        regex: "(CYGNUSX?|Gravity Z2|ChampionPro)(?:[);/ ]|$)",
        device: "phablet",
        models: [
            {
                regex: "CYGNUSX(?:[);/ ]|$)",
                model: "Cygnus X"
            },
            {
                regex: "CYGNUS(?:[);/ ]|$)",
                model: "Cygnus"
            },
            {
                regex: "Gravity Z2(?:[);/ ]|$)",
                device: "smartphone",
                model: "Gravity Z2"
            },
            {
                regex: "ChampionPro(?:[);/ ]|$)",
                device: "smartphone",
                model: "Champion Pro"
            }
        ]
    },
    Connex: {
        regex: "(CTAB1044hn|CTAB-1044)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Connectce: {
        regex: "(?:CP6001A)(?:[);/ ]|$)",
        device: "smartphone",
        model: "Connect Core 6"
    },
    Clementoni: {
        regex: "(?:CLEMPAD[_ ](?:6_XL|HR_Plus|HR|[68]|7_S|201[89])|ClemPhone_7|MFC_(?:2018|8))(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "CLEMPAD_(201[89])",
                model: "Clempad ($1)"
            },
            {
                regex: "MFC_2018",
                model: "Clempad (2018)"
            },
            {
                regex: "MFC_8",
                model: "Clempad 8"
            },
            {
                regex: "CLEMPAD_7_S",
                model: "Clempad 7S"
            },
            {
                regex: "Clempad[_ ](6_XL|HR_Plus|HR|[68])",
                model: "Clempad $1"
            },
            {
                regex: "ClemPhone[ _](7)",
                device: "smartphone",
                model: "Clemphone $1"
            }
        ]
    },
    "Cell-C": {
        regex: "Cell_?C_",
        device: "smartphone",
        models: [
            {
                regex: "Cell_C_(Summit_Plus|Fame|Evolve)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "CELLC_Evolve",
                device: "tablet",
                model: "Evolve"
            }
        ]
    },
    VC: {
        regex: "(?:Camellia_II|Cactus II|Maple III|Maple-II|Cactus-Pro|LavenderII|Jasmine-II)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(Camellia_II|Cactus II|Maple III)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Cactus-Pro",
                model: "Cactus Pro"
            },
            {
                regex: "(Maple|Jasmine|Lavender)-?II(?:[);/ ]|$)",
                model: "$1 II"
            }
        ]
    },
    CellAllure: {
        regex: "(?:Cool_Extreme_2|Earn|Fashion2Plus|Fashion[ _]C|Cool Duo|CHIC_X1)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(Cool_Extreme_2|Earn|Fashion[ _]C|Cool Duo)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Fashion2Plus",
                model: "Fashion 2 Plus"
            },
            {
                regex: "CHIC_X1",
                model: "Chic X1"
            }
        ]
    },
    Eagle: {
        regex: "Eagle[ _](Classic Pro|Elite|Gold)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Invens: {
        regex: "(Fighter|Eager)(?: Build|[;)])",
        device: "smartphone",
        model: "$1"
    },
    "Chico Mobile": {
        regex: "(?:ALTO (?:Bombo|classic|Estrella|JUEGO|SUBIR|[235])|FUEGO MAX|OJOS[ _](?:CAMBIO|NUBE|[68i]|ORO))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ALTO Bombo",
                model: "Alto Bombo"
            },
            {
                regex: "ALTO classic",
                model: "Alto Classic"
            },
            {
                regex: "ALTO Estrella",
                model: "Alto Estrella"
            },
            {
                regex: "ALTO JUEGO",
                model: "Alto Juego"
            },
            {
                regex: "ALTO SUBIR",
                model: "Alto Subir"
            },
            {
                regex: "ALTO ([235])",
                model: "Alto $1"
            },
            {
                regex: "OJOS[ _]([68i])",
                model: "Ojos $1"
            },
            {
                regex: "OJOS NUBE",
                model: "Ojos Nube"
            },
            {
                regex: "OJOS CAMBIO",
                model: "Ojos Cambio"
            },
            {
                regex: "OJOS ORO",
                model: "Ojos Oro"
            },
            {
                regex: "FUEGO MAX",
                device: "tablet",
                model: "Fuego Max"
            }
        ]
    },
    Claresta: {
        regex: "Claresta[ _]|(?:AirPhoneS[56]|AirPhone K6)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "AirPhone ?(S[56]|K6)",
                model: "AirPhone $1"
            },
            {
                regex: "Claresta (F3) PRO",
                model: "$1 Pro"
            },
            {
                regex: "Claresta[ _](F4)",
                model: "$1"
            }
        ]
    },
    Camfone: {
        regex: "(?:Camfone (?:SE)|Hero[_ ](?:H5\\+|SE2|H9|(?:H7|XR)_Plus|SX|1[123]|SE3[ _]Max)|Honey (?:Y1|Y2s))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(Hero[_ ](?:H5\\+|SE2|H9|(?:H7|XR)_Plus|SX|1[123]|SE3[ _]Max)|Honey (?:Y1|Y2s))(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Camfone (SE)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Bellphone: {
        regex: "Bp100 X-Plus(?:[);/ ]|$)",
        device: "smartphone",
        model: "BP 100 X-Plus"
    },
    Gini: {
        regex: "Gini[ _]",
        device: "smartphone",
        models: [
            {
                regex: "Gini[ _]W(7)",
                model: "W$1"
            },
            {
                regex: "Gini[ _]n(8)",
                model: "N$1"
            },
            {
                regex: "Gini[ _]s5Pro",
                model: "S5 Pro"
            },
            {
                regex: "Gini[ _]Tab[ _](V[78])",
                device: "tablet",
                model: "Tab $1"
            }
        ]
    },
    MIVO: {
        regex: "(Caryota [1245789]|Jazz J[13] 2018)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(Caryota [1245789])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Jazz (J[13]) 2018",
                model: "Jazz $1 (2018)"
            }
        ]
    },
    Jesy: {
        regex: "Jesy_(J7)",
        device: "smartphone",
        model: "$1"
    },
    Teknosa: {
        regex: "Preo[ _]",
        device: "smartphone",
        models: [
            {
                regex: "Preo Teknosa P1",
                model: "Preo P1"
            },
            {
                regex: "Preo[ _]P([23])",
                model: "Preo P$1"
            }
        ]
    },
    Hyve: {
        regex: "(?:Pryme 01|ST01)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Pryme 01",
                model: "Pryme 01"
            },
            {
                regex: "ST01",
                model: "Storm ST01"
            }
        ]
    },
    EWIS: {
        regex: "OCTA T720Q(?:[);/ ]|$)",
        device: "tablet",
        model: "Octa T720Q"
    },
    "Leader Phone": {
        regex: "(Vyper|N-5[07]|N-45)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "N-45 light",
                model: "N-45 Light"
            },
            {
                regex: "(Vyper|N-5[07]|N-45)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Cavion: {
        regex: "(?:Cavion[_ ](?:Solid[_ ]4[\\._]5|Base[ _](?:7|7_3G_Silver|5\\.0|10|7.2 Quad)|10_3GRQ)|Cavion7.1quad)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Cavion[_ ]Solid[_ ]4[\\._]5",
                model: 'Solid 4.5"'
            },
            {
                regex: "Cavion BASE 5.0",
                model: 'Base 5.0"'
            },
            {
                regex: "CAVION_10_3GRQ",
                device: "tablet",
                model: "Base 10 3GR Quad"
            },
            {
                regex: "Cavion(?:7.1quad)",
                device: "tablet",
                model: 'Base 7.1" Quad'
            },
            {
                regex: "Cavion Base 7.2 Quad",
                device: "tablet",
                model: 'Base 7.2" Quad'
            },
            {
                regex: "Cavion Base 10",
                device: "tablet",
                model: "Base 10"
            },
            {
                regex: "Cavion Base 7 Dual",
                device: "tablet",
                model: 'Base 7.0" Dual'
            },
            {
                regex: "Cavion Base 7 Quad",
                device: "tablet",
                model: 'Base 7.0" Quad'
            },
            {
                regex: "Cavion_Base_7_3G_Silver",
                device: "tablet",
                model: 'Base 7.0" 3G Silver'
            }
        ]
    },
    GLX: {
        regex: "GLX (?:Aria|Dorna|Taban|Shine|Spark|ASA)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "GLX ASA",
                model: "Asa"
            },
            {
                regex: "GLX (Aria|Taban|Shine|Spark)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "GLX (Dorna)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    Seeken: {
        regex: "Seeken[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "Seeken[_ -](SG1|SJ1)",
                model: "$1"
            },
            {
                regex: "Seeken[_ -](ST-101)",
                device: "tablet",
                model: "$1"
            }
        ]
    },
    Jivi: {
        regex: "(?:Revolution TnT3|Xtreme_(?:[37]|3x)|Xtreme (?:XT84|XT309 Plus|1))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Revolution (TnT3)",
                model: "Revolution $1"
            },
            {
                regex: "Xtreme (XT84)",
                model: "Xtreme Klick $1"
            },
            {
                regex: "Xtreme (XT309) Plus",
                model: "Xtreme View Pro $1Plus"
            },
            {
                regex: "Xtreme[ _]([137]|3x)(?:[);/ ]|$)",
                model: "Xtreme $1"
            }
        ]
    },
    Winnovo: {
        regex: "Winnovo[ _]",
        device: "tablet",
        models: [
            {
                regex: "Winnovo[ _](M866|M798|VTab|750[PK])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Winnovo[ _](K5[46]|K43)[a-z]{2}",
                device: "smartphone",
                model: "$1"
            }
        ]
    },
    WE: {
        regex: "WE (A[15]0|B3|F[12]0|E[12]|L[3469]|R[34]|V[34]|S1|X[13]|T1)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Trio: {
        regex: "Trio V51 DT(?:[);/ ]|$)",
        device: "smartphone",
        model: "V51DT"
    },
    Seuic: {
        regex: "(AUTOID9N)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Centric: {
        regex: "(?:Centric[- ]CM(?:5001|33[23]1|3321Plus)|CM4331)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "(?:Centric[- ])?CM5001",
                model: "A1"
            },
            {
                regex: "(?:Centric[- ])?CM3321Plus",
                model: "P1 Plus"
            },
            {
                regex: "(?:Centric[- ])?CM3321",
                model: "P1"
            },
            {
                regex: "(?:Centric[- ])?CM3331",
                model: "L3"
            },
            {
                regex: "(?:Centric[- ])?CM4331",
                model: "G1"
            }
        ]
    },
    Kata: {
        regex: "Kata[ _-]",
        device: "smartphone",
        models: [
            {
                regex: "Kata[ _-](C3|L1|M3s|M4|V[56])(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Kata[ _-]i5-\\w",
                model: "I5"
            },
            {
                regex: "Kata-(T5)(?:[);/ ]|$)",
                device: "tablet",
                model: "$1"
            },
            {
                regex: "Kata-Tmini4(?:[);/ ]|$)",
                device: "tablet",
                model: "T Mini 4"
            },
            {
                regex: "Kata Box 2(?:[);/ ]|$)",
                device: "tv",
                model: "Box 2"
            }
        ]
    },
    Leff: {
        regex: "Leff Shell (?:HV320WHB-N55|LC390TA2A)(?:[);/ ]|$)",
        device: "tv",
        model: ""
    },
    Hardkernel: {
        regex: "ODROID[-]?(C2|U2|XU[34])(?:[);/ ]|$)",
        device: "peripheral",
        model: "ODROID $1"
    },
    Wiseasy: {
        regex: "WISENET5(?:[);/ ]|$)",
        device: "peripheral",
        model: "WISENET5"
    },
    "Shtrikh-M": {
        regex: "SHTRIH-SMARTPOS-F2(?:[);/ ]|$)",
        device: "peripheral",
        model: "Smartpos F2"
    },
    BBK: {
        regex: "([65]5|4[03]|3[29]|28)LEX[-_](81(?:27|39|45|58|61)|71(?:[23]7|4[345]|5[45]|6[368]|[57]8))[_/]([FU]?TS2C)(?:[);/ ]|$)",
        device: "tv",
        model: "$1LEX-$2/$3"
    },
    "4ife": {
        regex: "4ife (4K Smart TV Box)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Westpoint: {
        regex: "WESTPOINT[;,]",
        device: "tv",
        models: [
            {
                regex: "(TETS-4919SM)",
                model: "$1"
            }
        ]
    },
    Wintouch: {
        regex: "Q93S",
        device: "tablet",
        model: "Q93S"
    },
    Aiuto: {
        regex: "(AT702)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Seatel: {
        regex: "Seatel",
        device: "smartphone",
        models: [
            {
                regex: "Seatel[ _](L2|V8[AE]|T[5-8]|R6|V[89])(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Ditecma: {
        regex: "(M1092R(?:-[12]|V[45])?)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Datamini: {
        regex: "(K908H4G)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    "3GNET": {
        regex: "(?<!NetType/)3GNET[ _]",
        device: "smartphone",
        models: [
            {
                regex: "3GNET[ _](U8|T800|U6s)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "3GNET[ _]T ?900",
                model: "T900"
            }
        ]
    },
    "Yoka TV": {
        regex: "KB2 PRO(?:[);/ ]|$)",
        device: "tv",
        model: "KB2 Pro"
    },
    Formuler: {
        regex: "Formuler[ _]",
        device: "tv",
        models: [
            {
                regex: "Formuler[ _](Z8(?: Pro)?)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Malata: {
        regex: "(?:Build/)?Malata[ _]?([a-z0-9]+)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    IT: {
        regex: "IT-(?:1101S?|1101-QUAD)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "IT-1101-QUAD",
                model: "1101 Quad"
            },
            {
                regex: "IT-(1101S?)",
                model: "$1"
            }
        ]
    },
    Navcity: {
        regex: "NP-752Go(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "NP-752Go",
                model: "NP-752 Go"
            }
        ]
    },
    Jiake: {
        regex: "(?:JK(?:960|103) 3G|JK-?760)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "JK-?(760)(?:[);/ ]|$)",
                model: "JK-$1"
            },
            {
                regex: "JK(960|103) 3G(?:[);/ ]|$)",
                device: "tablet",
                model: "JK-$1 3G"
            }
        ]
    },
    "iQ&T": {
        regex: "(IFoo (?:U200|H55))(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Mantra: {
        regex: "(MFSTAB(?:_74G)?)(?:[);/ ]|$)",
        device: "peripheral",
        model: "$1"
    },
    Datalogic: {
        regex: "(?:MEMOR 10)(?:[);/ ]|$)",
        device: "smartphone",
        model: "Memor 10"
    },
    "Naomi Phone": {
        regex: "NAOMIPHONE Ambar(?:[);/ ]|$)",
        device: "smartphone",
        model: "Ambar"
    },
    Navitel: {
        regex: "NAVITEL[ _]",
        device: "tablet",
        models: [
            {
                regex: "NAVITEL[ _](T70[07]) 3G(?:[);/ ]|$)",
                model: "$1 3G"
            },
            {
                regex: "NAVITEL[ _](T757)LTE(?:[);/ ]|$)",
                model: "$1 LTE"
            },
            {
                regex: "NAVITEL[ _](A73[0157]|A650)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "RE900 Full HD(?:[);/ ]|$)",
                model: "RE900 Full HD"
            }
        ]
    },
    Linnex: {
        regex: "LI(22)(?:[);/ ]|$)",
        device: "smartphone",
        model: "Li $1"
    },
    Smartab: {
        regex: "(ST1009)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    SuperTab: {
        regex: "SuperTab(A10|K7|S7G)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Suzuki: {
        regex: "SUZUKI[ _]|(?:ECOPAD7|SUMOPad10)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "SUMOPAD(8100|10)(?:[);/ ]|$)",
                model: "SumoPad $1"
            },
            {
                regex: "ECOPAD7",
                model: "ECOPad 7"
            }
        ]
    },
    Philips: {
        regex: "Philips|AND1E(?:[);/ ]|$)|NETTV/|PI3210G|TLE(821L|722G)|TPM1[79]1E|70PUH6774_96|QM16[134]E|Xenium S[25]66|S397|W5510",
        device: "smartphone",
        models: [
            {
                regex: "(?:Philips[_ ])?Xenium[ _](S[25]66|V787)(?:[);/ ]|$)",
                model: "Xenium $1"
            },
            {
                regex: "(?:Philips[_ ])?(S397|W5510)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "AND1E(?: TV)?(?:[);/ ]|$)",
                model: "Android TV",
                device: "tv"
            },
            {
                regex: "(PI3210G)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "(TPM1[79]1E)",
                model: "$1",
                device: "tv"
            },
            {
                regex: "(QM16[134]E)",
                model: "$1",
                device: "tv"
            },
            {
                regex: "(70PUH6774)_96",
                model: "$1/96 4K UHD",
                device: "tv"
            },
            {
                regex: "(TLE821L)(?:[);/ ]|$)",
                model: "$1 4G LTE",
                device: "tablet"
            },
            {
                regex: "(TLE722G)(?:[);/ ]|$)",
                model: "$1",
                device: "tablet"
            },
            {
                regex: "Philips, BDP([0-9]{4})",
                model: "Blu-ray Player (BDP$1)",
                device: "tv"
            },
            {
                regex: "Philips, ([a-z0-9-]+)",
                model: "$1",
                device: "tv"
            },
            {
                regex: "(NETTV/[0-9\\.]{5})",
                model: "NetTV Series",
                device: "tv"
            },
            {
                regex: "Philips-FISIO ([a-z0-9]+)",
                model: "Fisio $1"
            },
            {
                regex: "Philips[ _-]?([a-z0-9\\-@]+)",
                model: "$1"
            }
        ]
    },
    INCAR: {
        regex: "(KZCAR)(?:[);/ ]|$)",
        device: "car browser",
        model: "$1"
    },
    "FaRao Pro": {
        regex: "(FTRW100)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    Nabi: {
        regex: "(?:DMTAB-(?:IN08A|NV08B|NV2[04]A)|NBTY07SMKG|NBFP07PMKG|SNB02-NV7A|NABI2-NV7A)(?:[);/ ]|$)",
        device: "tablet",
        models: [
            {
                regex: "DMTAB-(?:IN08A|NV08B)",
                model: 'Dream Tab HD 8.0"'
            },
            {
                regex: "DMTAB-NV(2[04])A",
                model: 'Big Tab HD $1.0"'
            },
            {
                regex: "NBTY07SMKG",
                model: 'Barbie Tab 7.0"'
            },
            {
                regex: "NBFP07PMKG",
                model: 'Fisher Price Learning Tab 7.0"'
            },
            {
                regex: "SNB02-NV7A",
                model: "2S Tab"
            },
            {
                regex: "NABI2-NV7A",
                model: "2 Tab"
            }
        ]
    },
    StrawBerry: {
        regex: "StrawBerry[ _]",
        device: "smartphone",
        models: [
            {
                regex: "StrawBerry[ _](SX|QX15)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Gresso: {
        regex: "Gresso[ _]",
        device: "smartphone",
        models: [
            {
                regex: "Gresso[ _]Regal(?:[);/ ]|$)",
                model: "Regal"
            }
        ]
    },
    Pendoo: {
        regex: "Pendoo|A5X MAX(?:[\\.-]\\w+)?\\.01\\.d4",
        device: "tv",
        models: [
            {
                regex: "Pendoo ?(T95Z|X10) PLUS",
                model: "$1 Plus"
            },
            {
                regex: "Pendoo ?X8PRO+",
                model: "X8 Pro+"
            },
            {
                regex: "Pendoo[ \\.]?(X9[29])",
                model: "$1"
            },
            {
                regex: "pendoo mini",
                model: "Mini"
            },
            {
                regex: "A5X MAX(?:[\\.-]\\w+)?\\.01\\.d4",
                model: "A5X Max"
            }
        ]
    },
    PiPO: {
        regex: "Pipo[_ ]|PipoM9Pro",
        device: "tablet",
        models: [
            {
                regex: "Pipo[_ ]([TP]9)",
                model: "$1"
            },
            {
                regex: "PipoM9Pro",
                model: "M9 Pro"
            },
            {
                regex: "PIPO[_ ](X10|X9S)",
                device: "tv",
                model: "$1"
            }
        ]
    },
    Engel: {
        regex: "(EN1007Q)plus(?:[);/ ]|$)",
        device: "tv",
        model: "$1 Plus"
    },
    Genesis: {
        regex: "(SK-Mtek GT730[15])(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    InfoKit: {
        regex: "(TVB-906X)(?:[);/ ]|$)",
        device: "tv",
        model: "$1"
    },
    Blloc: {
        regex: "(Zero18)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Huskee: {
        regex: "VULKANO(?:[);/ ]|$)",
        device: "smartphone",
        model: "Vulkano"
    },
    SOLE: {
        regex: "SOLE[_ ]POP[_ ]S([45]0)(?:[);/ ]|$)",
        device: "smartphone",
        model: "Pop S$1"
    },
    SOLO: {
        regex: "SOLO[_ ](Aspire(?: M)?)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    OINOM: {
        regex: "OINOM[_ ](V9D|V7H|V[679])(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    Singtech: {
        regex: "Singtech|(?:Sapphire[_ ](?:H50S|H7S?|H90))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Sapphire[_ ](H50S|H7S?|H90)(?:[);/ ]|$)",
                model: "Sapphire $1"
            },
            {
                regex: "Singtech[ _](Q2|S1)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    Sunny: {
        regex: "(SS4G9 Mira|SS4G7 Sole|SS4G1 Luna|SS4G8 Nora|SS4G6 Lola)(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    TEENO: {
        regex: "TEENO",
        device: "smartphone",
        models: [
            {
                regex: "TEENO[_ ](S9|A1|S11)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    "v-mobile": {
        regex: "Vmobile[ _]",
        device: "smartphone",
        models: [
            {
                regex: "Vmobile[ _](J7)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Vmobile XS Pro(?:[);/ ]|$)",
                model: "XS Pro"
            }
        ]
    },
    OASYS: {
        regex: "(TEG9300)(?:[);/ ]|$)",
        device: "peripheral",
        model: "$1"
    },
    Aspera: {
        regex: "ASPERA|(?:Wren)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "ASPERA[ _](R5h|RT3|A4[02]|A50)(?:[);/ ]|$)",
                model: "$1"
            },
            {
                regex: "Wren(?:[);/ ]|$)",
                model: "Wren"
            }
        ]
    },
    "Vision Touch": {
        regex: "Vision ?Touch",
        device: "smartphone",
        models: [
            {
                regex: "VisionTouchLife",
                model: "Life"
            },
            {
                regex: "Inspire",
                model: "Inspire"
            }
        ]
    },
    NOBUX: {
        regex: "SMART_VOLT_NX5(?:[);/ ]|$)",
        device: "smartphone",
        model: "Smart Volt NX5"
    },
    Hitech: {
        regex: "(Amaze[ _](?:S2_4G|S[56] 4G|S1|S[56](?: Plus)?))(?:[);/ ]|$)",
        device: "smartphone",
        model: "$1"
    },
    F150: {
        regex: "Bison2021(?:[);/ ]|$)",
        device: "smartphone",
        model: "B2021"
    },
    BilimLand: {
        regex: "BilimBook mini(?:[);/ ]|$)",
        device: "desktop",
        model: "BilimBook Mini"
    },
    Greentel: {
        regex: "X1_Light_Lte(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "X1_Light_Lte",
                model: "X1 Light LTE"
            }
        ]
    },
    Kyowon: {
        regex: "(KA-E410W)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    "LT Mobile": {
        regex: "(?:LT-NOTE 10S)",
        device: "smartphone",
        models: [
            {
                regex: "LT-NOTE 10S",
                model: "Note 10S"
            }
        ]
    },
    "ONYX BOOX": {
        regex: "KON_TIKI(?:[);/ ]|$)",
        device: "tablet",
        model: "Kon Tiki"
    },
    GFive: {
        regex: "(?:PRESIDENT_GOLD_(9|10))(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "PRESIDENT_GOLD_(9|10)",
                model: "President Gold $1"
            }
        ]
    },
    KINGZONE: {
        regex: "KINGZONE_",
        device: "smartphone",
        models: [
            {
                regex: "KINGZONE_(N5)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    "M-Tech": {
        regex: "EROS 4G(?:[);/ ]|$)",
        device: "smartphone",
        model: "Eros 4G"
    },
    Fantec: {
        regex: "FAN-M300H(?:[);/ ]|$)",
        device: "smartphone",
        model: "M300H"
    },
    AURIS: {
        regex: "(TB-703G)(?:[);/ ]|$)",
        device: "tablet",
        model: "$1"
    },
    YUHO: {
        regex: "YUHO_",
        device: "smartphone",
        models: [
            {
                regex: "YUHO_(O2|H2|Y[123])_PRO",
                model: "$1 Pro"
            },
            {
                regex: "YUHO_Vast_Plus",
                model: "Vast Plus"
            },
            {
                regex: "YUHO_Y1_ACE",
                model: "Y1 Ace"
            },
            {
                regex: "YUHO_Y1_STAR",
                model: "Y1 Star"
            },
            {
                regex: "YUHO_O1_LITE",
                model: "O1 Lite"
            },
            {
                regex: "YUHO_(Vast2?|O[12]|Y2)(?:[);/ ]|$)",
                model: "$1"
            }
        ]
    },
    "2F Mobile": {
        regex: "(Z8PLUS|Z8POCKET)(?:[);/ ]|$)",
        device: "smartphone",
        models: [
            {
                regex: "Z8PLUS",
                model: "Z8 Plus"
            },
            {
                regex: "Z8POCKET",
                model: "Z8 Pocket"
            }
        ]
    }
}, $cdf7e442067abc24$var$xi = {}, $cdf7e442067abc24$var$ui = (Object.defineProperty($cdf7e442067abc24$var$xi, "__esModule", {
    value: !0
}), $cdf7e442067abc24$var$xi.buildModel = (e)=>"Build" === (e = (e = e.replace(/_/g, " ")).replace(RegExp(" TD$", "i"), "")) ? "" : e, $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
});
Object.defineProperty($cdf7e442067abc24$var$gi, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$pi = $cdf7e442067abc24$var$ui($cdf7e442067abc24$var$ci), $cdf7e442067abc24$var$hi = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$Si = $cdf7e442067abc24$var$nl, $cdf7e442067abc24$var$vi = $cdf7e442067abc24$var$xi;
$cdf7e442067abc24$var$gi.default = class {
    constructor(){
        this.parse = (e)=>{
            var r, o, t = {
                type: "",
                brand: "",
                model: ""
            };
            let a = "";
            for ([r, o] of Object.entries($cdf7e442067abc24$var$pi.default)){
                var l = $cdf7e442067abc24$var$Si.userAgentParser(o.regex, e);
                if (l) {
                    if (a = "device" in o && o.device || "", t.brand = r, "model" in o && o.model) t.model = $cdf7e442067abc24$var$vi.buildModel($cdf7e442067abc24$var$hi.variableReplacement(o.model, l)).trim();
                    else if ("models" in o && o.models) for (const r of o.models){
                        var i = $cdf7e442067abc24$var$Si.userAgentParser(r.regex, e);
                        if (i) {
                            t.model = $cdf7e442067abc24$var$vi.buildModel($cdf7e442067abc24$var$hi.variableReplacement(r.model, i)).trim(), "device" in r && r.device && (a = r.device), "brand" in r && (t.brand = r.brand || "");
                            break;
                        }
                    }
                    break;
                }
            }
            return t.type = "tv" === a ? "television" : "car browser" === a ? "car" : a, "Unknown" === t.brand && (t.brand = ""), t;
        };
    }
};
var $cdf7e442067abc24$var$$i = {}, $cdf7e442067abc24$var$bi = {
    Airties: {
        regex: "Airties",
        device: "tv",
        models: [
            {
                regex: "Airties; ?([^);/]+)",
                model: "$1"
            }
        ]
    },
    "ALDI NORD": {
        regex: "ALDINORD[;,]",
        device: "tv",
        model: ""
    },
    "ALDI S\xdcD": {
        regex: "ALDISUED[;,]",
        device: "tv",
        model: ""
    },
    "Altech UEC": {
        regex: "Altech UEC",
        device: "tv",
        models: [
            {
                regex: "Altech UEC; ?([^);/]+)",
                model: "$1"
            }
        ]
    },
    AOC: {
        regex: "AOC",
        device: "tv",
        models: [
            {
                regex: "(LE43S5970-20|S50856)",
                model: "$1"
            }
        ]
    },
    ARRIS: {
        regex: "ARRIS[;,]",
        device: "tv",
        models: [
            {
                regex: "FS-ARS-01B",
                model: "FS-ARS-01B"
            }
        ]
    },
    Atvio: {
        regex: "ATVIO",
        device: "tv",
        models: [
            {
                regex: "55D1620",
                model: "55D1620"
            }
        ]
    },
    BangOlufsen: {
        regex: "Bangolufsen",
        device: "tv",
        model: "BeoVision"
    },
    Blaupunkt: {
        regex: "Blaupunkt_UMC[;,]",
        device: "tv",
        models: [
            {
                regex: "LC-65CUG8052E",
                model: "LC-65CUG8052E"
            }
        ]
    },
    Bush: {
        regex: "BUSH[;,]",
        device: "tv",
        model: ""
    },
    Celcus: {
        regex: "CELCUS[;,]",
        device: "tv",
        model: ""
    },
    Changhong: {
        regex: "Changhong",
        device: "tv",
        models: [
            {
                regex: "Changhong; ?([^);/]+)",
                model: "$1"
            }
        ]
    },
    CreNova: {
        regex: "CreNova",
        device: "tv",
        model: "CNV001"
    },
    Digihome: {
        regex: "DIGIHOME[;,]",
        device: "tv",
        model: ""
    },
    DMM: {
        regex: "DMM",
        device: "tv",
        model: "Dreambox"
    },
    ELECTRONIA: {
        regex: "ELECTRONIA[;,]",
        device: "tv",
        model: ""
    },
    Essentielb: {
        regex: "ESSENTIELB[;,]",
        device: "tv",
        model: ""
    },
    Finlux: {
        regex: "FINLUX[;,]",
        device: "tv",
        model: ""
    },
    "F&U": {
        regex: "FU[;,]",
        device: "tv",
        model: ""
    },
    Fuego: {
        regex: "FUEGO[;,]",
        device: "tv",
        model: ""
    },
    GoGEN: {
        regex: "GOGEN[;,]",
        device: "tv",
        model: ""
    },
    Grundig: {
        regex: "(OWB|Grundig|Arcelik)",
        device: "tv",
        model: ""
    },
    Haier: {
        regex: "(?:HHW_)?HAIER",
        device: "tv",
        models: [
            {
                regex: "LE55X7000U",
                model: "LE55X7000U"
            }
        ]
    },
    "Hi-Level": {
        regex: "HI-LEVEL[;,]",
        device: "tv",
        model: ""
    },
    Hisense: {
        regex: "Hisense|Eurofins_Digital_Testing",
        device: "tv",
        models: [
            {
                regex: "50ADEVTOOL",
                model: "50ADEVTOOL"
            },
            {
                regex: "50A683FEVS",
                model: "50A683FEVS"
            },
            {
                regex: "55A6100EE",
                model: "55A6100EE"
            },
            {
                regex: "55U62QGAVT",
                model: "55U62QGAVT"
            },
            {
                regex: "50A6502EA",
                model: "50A6502EA"
            },
            {
                regex: "MICALIDVB6886",
                model: "MICALIDVB6886"
            },
            {
                regex: "(L[A-Z]{2,3}[0-9]{2}[A-Z][0-9]{3,4}[A-Z]{0,6}[0-9]?[A-Z]?)",
                model: "$1"
            },
            {
                regex: "(H[A-Z]?[0-9]{2}[A-Z][0-9]{3,4}[A-Z]{0,4})",
                model: "$1"
            }
        ]
    },
    Hitachi: {
        regex: "Hitachi[;,]",
        device: "tv",
        models: [
            {
                regex: "49D2900",
                model: "49D2900"
            }
        ]
    },
    Horizon: {
        regex: "HORIZON[;,]",
        device: "tv",
        model: ""
    },
    Hotel: {
        regex: "HOTEL[;,]",
        device: "tv",
        model: ""
    },
    Humax: {
        regex: "Humax",
        device: "tv",
        models: [
            {
                regex: "(HD-FOX C|HD (FOX\\+|NANO)|iCord (HD\\+|MINI|Cable)|(CX|IR)HD-5100(C|S)|HM9503HD)",
                model: "$1"
            },
            {
                regex: "HMS1000S",
                model: "HMS-1000S"
            },
            {
                regex: "Humax; ([^);/]+)",
                model: "$1"
            }
        ]
    },
    Hyundai: {
        regex: "HYUNDAI[;,]",
        device: "tv",
        model: ""
    },
    Ikea: {
        regex: "Ikea",
        device: "tv",
        model: ""
    },
    Intek: {
        regex: "Intek",
        device: "tv",
        models: [
            {
                regex: "(Vantage|VT-100|VT-1)",
                model: "$1"
            }
        ]
    },
    Inverto: {
        regex: "Inverto",
        device: "tv",
        models: [
            {
                regex: "inverto; ([^);/]+)",
                model: "$1"
            },
            {
                regex: "(Volksbox Web Edition|Volksbox Essential|Volksbox II|Volksbox)",
                model: "$1"
            }
        ]
    },
    JVC: {
        regex: "AFTSO001|JVC[;,]",
        device: "tv",
        models: [
            {
                regex: "AFTSO001",
                model: "4K (2019)"
            }
        ]
    },
    Kalley: {
        regex: "KALLEY[;,]",
        device: "tv",
        models: [
            {
                regex: "32D1620",
                model: "32D1620"
            }
        ]
    },
    KUBO: {
        regex: "KUBO[;,]",
        device: "tv",
        model: ""
    },
    Laurus: {
        regex: "LAURUS[;,]",
        device: "tv",
        model: ""
    },
    LG: {
        regex: "LGE",
        device: "tv",
        models: [
            {
                regex: "XU43WT180N",
                model: "XU43WT180N"
            },
            {
                regex: "43LJ614V-ZA",
                model: "43LJ614V-ZA"
            },
            {
                regex: "55SK850V-ZA",
                model: "55SK850V-ZA"
            },
            {
                regex: "KEY0000213F1z",
                model: "KEY0000213F1z"
            },
            {
                regex: "KEY0000213F",
                model: "KEY0000213F"
            },
            {
                regex: "KEY000000(2E|2F|3B|3F)",
                model: "KEY000000$1"
            },
            {
                regex: "(NetCast [0-9]{1}.[0-9]{1}|GLOBAL_PLAT3)",
                model: "$1"
            },
            {
                regex: "(OLED[0-9]{2}[A-Z0-9]{3}[A-Z]{2})",
                model: "$1"
            },
            {
                regex: "(OLED[0-9]{2}[A-Z][0-9][A-Z])",
                model: "$1"
            },
            {
                regex: "(OLED[0-9]{2}[A-Z0-9]{2})",
                model: "$1"
            },
            {
                regex: "([0-9]{2}[A-Z]{2}[0-9]{4}[A-Z0-9]{1}[A-Z]{2})",
                model: "$1"
            },
            {
                regex: "([0-9]{2}NANO[0-9]{3}[A-Z]{2})",
                model: "$1"
            },
            {
                regex: "([0-9]{2}NANO[0-9]{2})",
                model: "$1"
            },
            {
                regex: "LGE;? ?([0-9]{2}[A-Z]{2}[0-9]{2,4}[A-Z]?)",
                model: "$1"
            },
            {
                regex: "LM21U",
                model: "LM21U"
            },
            {
                regex: "32LM",
                model: "32LM"
            }
        ]
    },
    Lifemaxx: {
        regex: "Lifemaxx[;,]",
        device: "tv",
        model: ""
    },
    Linsar: {
        regex: "LINSAR[;,]",
        device: "tv",
        model: ""
    },
    Loewe: {
        regex: "Loewe",
        device: "tv",
        models: [
            {
                regex: "([A-Z]{2}[0-9]{3})",
                model: "$1"
            }
        ]
    },
    Luxor: {
        regex: "LUXOR[;,]",
        device: "tv",
        model: ""
    },
    Manhattan: {
        regex: "Manhattan",
        device: "tv",
        models: [
            {
                regex: "T3",
                model: "T3"
            }
        ]
    },
    MediaTek: {
        regex: "MTK|MediaTek;",
        device: "tv",
        models: [
            {
                regex: "(MT[0-9]{4})",
                model: "$1"
            }
        ]
    },
    Medion: {
        regex: "Medion",
        device: "tv",
        model: ""
    },
    Miray: {
        regex: "MIRAY",
        device: "tv",
        models: [
            {
                regex: "LEDM-322NIP",
                model: "LEDM-322NIP"
            }
        ]
    },
    MStar: {
        regex: "MStar[;,]",
        device: "tv",
        models: [
            {
                regex: "([24])KTV18",
                model: "$1KTV18"
            }
        ]
    },
    MTC: {
        regex: "MTC[;,]",
        device: "tv",
        models: [
            {
                regex: "([24])K_Android_TV_V01",
                model: "$1K Android TV"
            }
        ]
    },
    Nordmende: {
        regex: "NORDMENDE[;,]",
        device: "tv",
        model: ""
    },
    Metz: {
        regex: "Metz",
        device: "tv",
        model: ""
    },
    Ok: {
        regex: "OK[;,]",
        device: "tv",
        model: ""
    },
    Panasonic: {
        regex: "Panasonic",
        device: "tv",
        models: [
            {
                regex: "VIERA (201[1-9])",
                model: "VIERA ($1)"
            },
            {
                regex: "(DIGA [A-Z]{1}[0-9]{4})",
                model: "$1"
            },
            {
                regex: "DIGA Webkit ([A-Z]{1}[0-9]{4})",
                model: "DIGA $1"
            },
            {
                regex: "SmartTV(201[89]|202[0-1])",
                model: "Smart TV ($1)"
            }
        ]
    },
    PEAQ: {
        regex: "PEAQ",
        device: "tv",
        model: ""
    },
    Philips: {
        regex: "Philips|NETTV/",
        device: "tv",
        models: [
            {
                regex: "Philips[,;] ?((?! )[^),;/]+)",
                model: "$1"
            },
            {
                regex: "NETTV/[0-9\\.]{5}",
                model: "NetTV Series"
            }
        ]
    },
    Polaroid: {
        regex: "POLAROID[;,]",
        device: "tv",
        model: ""
    },
    PROFiLO: {
        regex: "PROFILO[;,]",
        device: "tv",
        model: ""
    },
    Qilive: {
        regex: "QILIVE[;,]",
        device: "tv",
        model: ""
    },
    REGAL: {
        regex: "REGAL[;,]",
        device: "tv",
        model: ""
    },
    Saba: {
        regex: "Saba[;,]",
        device: "tv",
        model: ""
    },
    Salora: {
        regex: "Salora[;,]",
        device: "tv",
        model: ""
    },
    Samsung: {
        regex: "Samsung|Maple_2011",
        device: "tv",
        models: [
            {
                regex: "SmartTV(201[2-9]|202[0-1]):([^);/]+)",
                model: "$2"
            },
            {
                regex: "SmartTV(201[2-9]|202[0-1])",
                model: "Smart TV ($1)"
            },
            {
                regex: "Maple_2011",
                model: "Smart TV (2011)"
            }
        ]
    },
    SCBC: {
        regex: "SCBC[;,]",
        device: "tv",
        models: [
            {
                regex: "SCBC586",
                model: "SCBC586"
            },
            {
                regex: "43D1850",
                model: "43D1850"
            }
        ]
    },
    SEG: {
        regex: "SEG[;,]",
        device: "tv",
        model: ""
    },
    Selevision: {
        regex: "Selevision",
        device: "tv",
        models: [
            {
                regex: "Selevision; (?:Selevision )?([^);/]+)",
                model: "$1"
            },
            {
                regex: "(EMC1000i)",
                model: "$1"
            }
        ]
    },
    Sharp: {
        regex: "(?:UMC-)?Sharp",
        device: "tv",
        models: [
            {
                regex: "Sharp[,;] ?((?! |HbbTV)[^),;/]+)",
                model: "$1"
            },
            {
                regex: "(LE[0-9]{3}[A-Z]{0,3})",
                model: "$1"
            },
            {
                regex: "LC-([^);/]+)",
                model: "LC-$1"
            },
            {
                regex: "BLA-43",
                model: "BLA-43"
            }
        ]
    },
    Skyworth: {
        regex: "Sky_worth",
        device: "tv",
        models: [
            {
                regex: "Sky_worth;([^);/]+)",
                model: "$1"
            }
        ]
    },
    Smart: {
        regex: "Smart[;,]",
        device: "tv",
        models: [
            {
                regex: "Smart; ([^);/]+)",
                model: "$1"
            },
            {
                regex: "([A-Z]{2}[0-9]{2}|ZAPPIX)",
                model: "$1"
            }
        ]
    },
    Sony: {
        regex: "Sony",
        device: "tv",
        models: [
            {
                regex: "KDL-GR1",
                model: "KDL-GR1"
            },
            {
                regex: "KDL-GN([56])",
                model: "KDL-GN$1"
            },
            {
                regex: "BRAVIA (VH1|4K VH2)",
                model: "BRAVIA $1"
            },
            {
                regex: "(KDL?-?[0-9]{2}[A-Z]{1}[0-9]{4}[A-Z]{1})",
                model: "$1"
            },
            {
                regex: "(KDL?-?[0-9]{2}[A-Z]{1}[0-9]{3}[A-Z]{1})",
                model: "$1"
            },
            {
                regex: "(KDL?-?[0-9]{2}[A-Z]{1,2}[0-9]{1,5})",
                model: "$1"
            }
        ]
    },
    SWTV: {
        regex: "SWTV[;,]",
        device: "tv",
        models: [
            {
                regex: "SKWE20E21",
                model: "SKWE20E21"
            }
        ]
    },
    "TD Systems": {
        regex: "TDSystems[;,]",
        device: "tv",
        models: [
            {
                regex: "SmartTV(2019|2020)",
                model: "Smart TV ($1)"
            }
        ]
    },
    Technicolor: {
        regex: "Technicolor",
        device: "tv",
        models: [
            {
                regex: "uzw4054ttg",
                model: "UZW4054TTG"
            }
        ]
    },
    Technika: {
        regex: "TECHNIKA[;,]",
        device: "tv",
        model: ""
    },
    TechniSat: {
        regex: "TechniSat",
        device: "tv",
        models: [
            {
                regex: "((DigiCorder|MultyVision|Digit) (ISIO S|ISIO C|ISIO))",
                model: "$1"
            }
        ]
    },
    TechnoTrend: {
        regex: "TechnoTrend",
        device: "tv",
        models: [
            {
                regex: "([A-Z]{1}-[0-9]{3})",
                model: "$1"
            }
        ]
    },
    Techwood: {
        regex: "Techwood[;,]",
        device: "tv",
        model: ""
    },
    Telefunken: {
        regex: "Telefunken",
        device: "tv",
        model: ""
    },
    TCL: {
        regex: "TCL",
        device: "tv",
        models: [
            {
                regex: "(32D1820|(?:39|55)D2900|32D2930|(?:32|43)S4900)",
                model: "$1"
            }
        ]
    },
    Thomson: {
        regex: "THOMSON[,]?|THOM",
        device: "tv",
        models: [
            {
                regex: "(TB28D19DHS-01|T28D18SFS-01B)",
                model: '$1 28.0"'
            },
            {
                regex: "(T32RTM5040|T32D18SFS-01B)",
                model: '$1 32.0"'
            },
            {
                regex: "(T43FSL5031|T43D18SFS-01B)",
                model: '$1 43.0"'
            },
            {
                regex: "(T40D18SFS-01B)",
                model: '$1 40.0"'
            },
            {
                regex: "(T49D18SFS-01B)",
                model: '$1 49.0"'
            },
            {
                regex: "(T55D18[SD]FS-01B)",
                model: '$1 55.0"'
            },
            {
                regex: "40FB5426",
                model: "40FB5426"
            }
        ]
    },
    TOKYO: {
        regex: "TOKYO[;,]",
        device: "tv",
        models: [
            {
                regex: "TOKTCLED32S",
                model: "TOKTCLED32S"
            }
        ]
    },
    Toshiba: {
        regex: "Toshiba",
        device: "tv",
        models: [
            {
                regex: "40L2600",
                model: "40L2600"
            },
            {
                regex: "(([0-9]{2}|DTV_)[A-Z]{2}[0-9]{1,3})",
                model: "$1"
            }
        ]
    },
    Videoweb: {
        regex: "videoweb|tv2n",
        device: "tv",
        models: [
            {
                regex: "(tv2n)",
                model: "$1"
            },
            {
                regex: "(videowebtv)",
                model: "VideoWeb TV"
            }
        ]
    },
    VOX: {
        regex: "VOX[;,]",
        device: "tv",
        model: ""
    },
    WELLINGTON: {
        regex: "WELLINGTON[;,]",
        device: "tv",
        model: ""
    },
    "X.Vision": {
        regex: "X-VISION[;,]",
        device: "tv",
        model: ""
    },
    Vestel: {
        regex: "(?:Vestel.+VESTEL|VESTEL;)",
        device: "tv",
        model: ""
    }
}, $cdf7e442067abc24$var$Ai = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$$i, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$fi = $cdf7e442067abc24$var$Ai($cdf7e442067abc24$var$bi), $cdf7e442067abc24$var$Mi = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$Pi = $cdf7e442067abc24$var$nl, $cdf7e442067abc24$var$Ti = $cdf7e442067abc24$var$xi;
$cdf7e442067abc24$var$$i.default = class {
    constructor(){
        this.parse = (e)=>{
            var r = {
                type: "",
                brand: "",
                model: ""
            };
            if (this.isHbbTv(e)) for (var [o, t] of (r.type = "television", Object.entries($cdf7e442067abc24$var$fi.default))){
                var a = $cdf7e442067abc24$var$Pi.userAgentParser(t.regex, e);
                if (a) {
                    if (r.brand = o, "model" in t && t.model) r.model = $cdf7e442067abc24$var$Ti.buildModel($cdf7e442067abc24$var$Mi.variableReplacement(t.model, a)).trim();
                    else if ("models" in t && t.models) for (const o of t.models){
                        var l = $cdf7e442067abc24$var$Pi.userAgentParser(o.regex, e);
                        if (l) {
                            r.model = $cdf7e442067abc24$var$Ti.buildModel($cdf7e442067abc24$var$Mi.variableReplacement(o.model, l)).trim();
                            break;
                        }
                    }
                    break;
                }
            }
            return r;
        }, this.isHbbTv = (e)=>$cdf7e442067abc24$var$Pi.userAgentParser("HbbTV/([1-9]{1}(?:.[0-9]{1}){1,2})", e);
    }
};
var $cdf7e442067abc24$var$_i = {}, $cdf7e442067abc24$var$yi = {
    Tesla: {
        regex: "(?:Tesla/[0-9.]+|QtCarBrowser)",
        device: "car browser",
        models: [
            {
                regex: "QtCarBrowser",
                model: "Model S"
            },
            {
                regex: "Tesla/[0-9.]+",
                model: ""
            }
        ]
    },
    "MAC AUDIO": {
        regex: "Mac Audio Spro",
        device: "car browser",
        models: [
            {
                regex: "Spro",
                model: "S Pro"
            }
        ]
    },
    Topway: {
        regex: "sp9853i_1h10_vmm",
        device: "car browser",
        models: [
            {
                regex: "sp9853i_1h10_vmm",
                model: "TS9"
            }
        ]
    }
}, $cdf7e442067abc24$var$wi = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$_i, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$Gi = $cdf7e442067abc24$var$wi($cdf7e442067abc24$var$yi), $cdf7e442067abc24$var$Li = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$Ci = $cdf7e442067abc24$var$nl;
$cdf7e442067abc24$var$_i.default = class {
    constructor(){
        this.parse = (e)=>{
            var r, o, t = {
                type: "",
                brand: "",
                model: ""
            };
            for ([r, o] of Object.entries($cdf7e442067abc24$var$Gi.default))if ($cdf7e442067abc24$var$Ci.userAgentParser(o.regex, e)) {
                t.type = "car", t.brand = r;
                for (const r of o.models){
                    var a = $cdf7e442067abc24$var$Ci.userAgentParser(r.regex, e);
                    a && (t.model = $cdf7e442067abc24$var$Li.variableReplacement(r.model, a).trim());
                }
                break;
            }
            return t;
        };
    }
};
var $cdf7e442067abc24$var$Bi = {}, $cdf7e442067abc24$var$Ei = {
    Archos: {
        regex: "Archos.*GAMEPAD([2]?)",
        device: "console",
        model: "Gamepad $1"
    },
    Microsoft: {
        regex: "Xbox",
        device: "console",
        models: [
            {
                regex: "Xbox Series X",
                model: "Xbox Series X"
            },
            {
                regex: "Xbox One X",
                model: "Xbox One X"
            },
            {
                regex: "Xbox One",
                model: "Xbox One"
            },
            {
                regex: "XBOX_ONE_ED",
                model: "Xbox One S"
            },
            {
                regex: "Xbox",
                model: "Xbox 360"
            }
        ]
    },
    Nintendo: {
        regex: "Nintendo (([3]?DS[i]?)|Wii[U]?|Switch)",
        device: "console",
        model: "$1"
    },
    OUYA: {
        regex: "OUYA",
        device: "console",
        model: "OUYA"
    },
    Sega: {
        regex: "Dreamcast",
        device: "console",
        model: "Dreamcast"
    },
    Sony: {
        regex: "PlayStation (3|4 Pro|4|Portable|Vita)",
        device: "console",
        model: "PlayStation $1"
    }
}, $cdf7e442067abc24$var$Ni = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$Bi, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$Oi = $cdf7e442067abc24$var$Ni($cdf7e442067abc24$var$Ei), $cdf7e442067abc24$var$Ii = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$ki = $cdf7e442067abc24$var$nl;
$cdf7e442067abc24$var$Bi.default = class {
    constructor(){
        this.parse = (e)=>{
            var r, o, t = {
                type: "",
                brand: "",
                model: ""
            };
            for ([r, o] of Object.entries($cdf7e442067abc24$var$Oi.default)){
                var a = $cdf7e442067abc24$var$ki.userAgentParser(o.regex, e);
                if (a) {
                    if (t.type = o.device, t.brand = r, "model" in o && o.model) t.model = $cdf7e442067abc24$var$Ii.variableReplacement(o.model, a).trim();
                    else if ("models" in o && o.models) for (const r of o.models){
                        var l = $cdf7e442067abc24$var$ki.userAgentParser(r.regex, e);
                        if (l) {
                            t.model = $cdf7e442067abc24$var$Ii.variableReplacement(r.model, l).trim();
                            break;
                        }
                    }
                    break;
                }
            }
            return t;
        };
    }
};
var $cdf7e442067abc24$var$Xi = {}, $cdf7e442067abc24$var$Di = {
    Acer: {
        regex: "FBMD/(?:Aspire E5-421G|Z5WAL|One S1003);",
        device: "desktop",
        models: [
            {
                regex: "FBMD/Aspire E5-421G;",
                model: "Aspire E5-421G"
            },
            {
                regex: "FBMD/Z5WAL;",
                model: "Aspire E5-511"
            },
            {
                regex: "FBMD/One S1003;",
                model: "One 10"
            }
        ]
    },
    Asus: {
        regex: "FBMD/(?:K50IN|K54L|T100HAN|T103HAF|UX360CAK|X550LB|X553MA|X555LN|X556UQK);",
        device: "desktop",
        models: [
            {
                regex: "FBMD/K50IN;",
                model: "K50IN"
            },
            {
                regex: "FBMD/K54L;",
                model: "K54L"
            },
            {
                regex: "FBMD/T100HAN;",
                model: "Transformer Book"
            },
            {
                regex: "FBMD/T103HAF;",
                model: "Transformer Mini"
            },
            {
                regex: "FBMD/UX360CAK;",
                model: "ZenBook Flip"
            },
            {
                regex: "FBMD/X550LB;",
                model: "X550LB"
            },
            {
                regex: "FBMD/X553MA;",
                model: "X553MA"
            },
            {
                regex: "FBMD/X555LN;",
                model: "X555LN"
            },
            {
                regex: "FBMD/X556UQK;",
                model: "X556UQK"
            }
        ]
    },
    Dell: {
        regex: "FBMD/(?:Latitude E4300|Inspiron 3541|XPS 15 95[35]0);",
        device: "desktop",
        models: [
            {
                regex: "Latitude E4300",
                model: "Latitude E4300"
            },
            {
                regex: "Inspiron 3541",
                model: "Inspiron 3541"
            },
            {
                regex: "XPS 15 9530",
                model: "XPS 15 9530"
            },
            {
                regex: "XPS 15 9550",
                model: "XPS 15 9550"
            }
        ]
    },
    HP: {
        regex: "FBMD/((?:Compaq|HP) |23-f364)",
        device: "desktop",
        models: [
            {
                regex: "Compaq Presario CQ61 Notebook PC",
                model: "Compaq Presario CQ61"
            },
            {
                regex: "HP Pavilion x2 Detachable",
                model: "Pavilion x2"
            },
            {
                regex: "HP Laptop 15-bs0xx",
                model: "15 Laptop PC"
            },
            {
                regex: "HP ENVY x360 Convertible 15-bp0xx",
                model: "ENVY x360 Convertible PC"
            },
            {
                regex: "HP EliteBook (25[67]0p)",
                model: "EliteBook $1"
            },
            {
                regex: "HP ProBook (440 G5|6[35]60b)",
                model: "ProBook $1"
            },
            {
                regex: "HP Pavilion dv6 Notebook PC",
                model: "Pavilion dv6"
            },
            {
                regex: "HP Pavilion Notebook",
                model: "Pavilion"
            },
            {
                regex: "HP Spectre x360 Convertible",
                model: "Spectre x360"
            },
            {
                regex: "HP Pavilion All-in-One 24-r0xx",
                model: "Pavilion 24-r0xx All-in-One Desktop PC",
                device: "desktop"
            },
            {
                regex: "23-f364",
                model: "Pavilion TouchSmart 23-f364 All-in-One Desktop PC",
                device: "desktop"
            }
        ]
    },
    Lenovo: {
        regex: "FBMD/(?:37021C5|80E5|80SM|80VR);",
        device: "desktop",
        models: [
            {
                regex: "FBMD/37021C5;",
                model: "ThinkPad Helix 3702"
            },
            {
                regex: "FBMD/80E5;",
                model: "G50-80"
            },
            {
                regex: "FBMD/80SM;",
                model: "Ideapad 310-15ISK"
            },
            {
                regex: "FBMD/80VR;",
                model: "Legion Y720"
            }
        ]
    },
    Schneider: {
        regex: "FBMD/SCL141CTP;",
        device: "desktop",
        model: 'Notebook 14" Cherry Trail'
    },
    Thomson: {
        regex: "FBMD/TH360R12.32CTW;",
        device: "desktop",
        model: "Prestige TH-360R12.32CTW"
    },
    Toshiba: {
        regex: "FBMD/Satellite ",
        device: "desktop",
        models: [
            {
                regex: "Satellite (A[25]00|C650|C855|L650|S855)",
                model: "Satellite $1"
            },
            {
                regex: "Satellite ([^;\\)]+);",
                model: "Satellite $1"
            }
        ]
    }
}, $cdf7e442067abc24$var$Ri = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$Xi, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$Fi = $cdf7e442067abc24$var$Ri($cdf7e442067abc24$var$Di), $cdf7e442067abc24$var$Vi = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$Hi = $cdf7e442067abc24$var$nl, $cdf7e442067abc24$var$Ui = $cdf7e442067abc24$var$xi;
$cdf7e442067abc24$var$Xi.default = class {
    constructor(){
        this.parse = (e)=>{
            var r = {
                type: "",
                brand: "",
                model: ""
            };
            if ($cdf7e442067abc24$var$Hi.userAgentParser("FBMD/", e)) for (var [o, t] of Object.entries($cdf7e442067abc24$var$Fi.default)){
                var a = $cdf7e442067abc24$var$Hi.userAgentParser(t.regex, e);
                if (a) {
                    if (r.type = "desktop", r.brand = o, "model" in t && t.model) r.model = $cdf7e442067abc24$var$Ui.buildModel($cdf7e442067abc24$var$Vi.variableReplacement(t.model, a)).trim();
                    else if ("models" in t && t.models) for (const o of t.models){
                        var l = $cdf7e442067abc24$var$Hi.userAgentParser(o.regex, e);
                        l && (r.model = $cdf7e442067abc24$var$Vi.variableReplacement(o.model, l).trim());
                    }
                    break;
                }
            }
            return r;
        };
    }
};
var $cdf7e442067abc24$var$Ki = {}, $cdf7e442067abc24$var$Wi = {
    Apple: {
        regex: "(?:Apple-)?iPod",
        device: "portable media player",
        models: [
            {
                regex: "(?:Apple-)?iPod1[C,]1",
                model: "iPod Touch 1G"
            },
            {
                regex: "(?:Apple-)?iPod2[C,]1",
                model: "iPod Touch 2G"
            },
            {
                regex: "(?:Apple-)?iPod3[C,]1",
                model: "iPod Touch 3"
            },
            {
                regex: "(?:Apple-)?iPod4[C,]1",
                model: "iPod Touch 4"
            },
            {
                regex: "(?:Apple-)?iPod5[C,]1",
                model: "iPod Touch 5"
            },
            {
                regex: "(?:Apple-)?iPod7[C,]1",
                model: "iPod Touch 6"
            },
            {
                regex: "(?:Apple-)?iPod",
                model: "iPod Touch"
            }
        ]
    },
    Cowon: {
        regex: "COWON ([^;/]+) Build",
        device: "portable media player",
        model: "$1"
    },
    Microsoft: {
        regex: "Microsoft ZuneHD",
        device: "portable media player",
        model: "Zune HD"
    },
    Panasonic: {
        regex: "(SV-MV100)",
        device: "portable media player",
        model: "$1"
    },
    Samsung: {
        regex: "YP-(G[SIPB]?1|G[57]0|GB70D)",
        device: "portable media player",
        models: [
            {
                regex: "YP-G[B]?1",
                model: "Galaxy Player 4.0"
            },
            {
                regex: "YP-G70",
                model: "Galaxy Player 5.0"
            },
            {
                regex: "YP-GS1",
                model: "Galaxy Player 3.6"
            },
            {
                regex: "YP-GI1",
                model: "Galaxy Player 4.2"
            },
            {
                regex: "YP-GP1",
                model: "Galaxy Player 5.8"
            },
            {
                regex: "YP-G50",
                model: "Galaxy Player 50"
            },
            {
                regex: "YP-GB70D",
                model: "Galaxy Player 70 Plus"
            }
        ]
    },
    Wizz: {
        regex: "(DV-PTB1080)(?:[);/ ]|$)",
        device: "portable media player",
        model: "$1"
    },
    SONOS: {
        regex: "Sonos/.+\\((?:ZP.+)\\)|Sonos;",
        device: "portable media player",
        models: [
            {
                regex: "\\((ZPS(?:[13569]|1[1-578]|2[03])|ZP90)\\)",
                model: "$1"
            },
            {
                regex: "Sonos;Play5;",
                model: "Play:5"
            },
            {
                regex: "Sonos;One;",
                model: "One"
            }
        ]
    }
}, $cdf7e442067abc24$var$Zi = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$Ki, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$Qi = $cdf7e442067abc24$var$Zi($cdf7e442067abc24$var$Wi), $cdf7e442067abc24$var$zi = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$Yi = $cdf7e442067abc24$var$nl;
$cdf7e442067abc24$var$Ki.default = class {
    constructor(){
        this.parse = (e)=>{
            var r, o, t = {
                type: "",
                brand: "",
                model: ""
            };
            for ([r, o] of Object.entries($cdf7e442067abc24$var$Qi.default)){
                var a = $cdf7e442067abc24$var$Yi.userAgentParser(o.regex, e);
                if (a) {
                    if (t.type = o.device, t.brand = r, "model" in o && o.model) t.model = $cdf7e442067abc24$var$zi.variableReplacement(o.model, a).trim();
                    else if ("models" in o && o.models) for (const r of o.models){
                        var l = $cdf7e442067abc24$var$Yi.userAgentParser(r.regex, e);
                        if (l) {
                            t.model = $cdf7e442067abc24$var$zi.variableReplacement(r.model, l).trim();
                            break;
                        }
                    }
                    break;
                }
            }
            return t;
        };
    }
};
var $cdf7e442067abc24$var$Ji = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$ai, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$ji = $cdf7e442067abc24$var$Ji($cdf7e442067abc24$var$li), $cdf7e442067abc24$var$qi = $cdf7e442067abc24$var$Ji($cdf7e442067abc24$var$gi), $cdf7e442067abc24$var$en = $cdf7e442067abc24$var$Ji($cdf7e442067abc24$var$$i), $cdf7e442067abc24$var$rn = $cdf7e442067abc24$var$Ji($cdf7e442067abc24$var$_i), $cdf7e442067abc24$var$on = $cdf7e442067abc24$var$Ji($cdf7e442067abc24$var$Bi), $cdf7e442067abc24$var$tn = $cdf7e442067abc24$var$Ji($cdf7e442067abc24$var$Xi), $cdf7e442067abc24$var$an = $cdf7e442067abc24$var$Ji($cdf7e442067abc24$var$Ki), $cdf7e442067abc24$var$ln = [
    $cdf7e442067abc24$var$on.default,
    $cdf7e442067abc24$var$rn.default,
    $cdf7e442067abc24$var$ji.default,
    $cdf7e442067abc24$var$en.default,
    $cdf7e442067abc24$var$an.default,
    $cdf7e442067abc24$var$qi.default,
    $cdf7e442067abc24$var$tn.default
];
$cdf7e442067abc24$var$ai.default = class {
    constructor(){
        this.parse = (e)=>{
            for (const o of $cdf7e442067abc24$var$ln){
                var r = (new o).parse(e);
                if ("" !== r.type) return r;
            }
            return null;
        };
    }
};
var $cdf7e442067abc24$var$nn = {}, $cdf7e442067abc24$var$dn = {
    operatingSystem: {
        AIX: "AIX",
        AND: "Android",
        AMG: "AmigaOS",
        ATV: "Apple TV",
        ARL: "Arch Linux",
        BTR: "BackTrack",
        SBA: "Bada",
        BEO: "BeOS",
        BLB: "BlackBerry OS",
        QNX: "BlackBerry Tablet OS",
        BMP: "Brew",
        CES: "CentOS",
        COS: "Chrome OS",
        CYN: "CyanogenMod",
        DEB: "Debian",
        DEE: "Deepin",
        DFB: "DragonFly",
        FED: "Fedora",
        FOS: "Firefox OS",
        FIR: "Fire OS",
        FRE: "Freebox",
        BSD: "FreeBSD",
        FYD: "FydeOS",
        GNT: "Gentoo",
        GTV: "Google TV",
        HPX: "HP-UX",
        HAI: "Haiku OS",
        IRI: "IRIX",
        INF: "Inferno",
        KOS: "KaiOS",
        KNO: "Knoppix",
        KBT: "Kubuntu",
        LIN: "GNU/Linux",
        LBT: "Lubuntu",
        VLN: "VectorLinux",
        MAC: "Mac",
        MAE: "Maemo",
        MDR: "Mandriva",
        SMG: "MeeGo",
        MCD: "MocorDroid",
        MIN: "Mint",
        MLD: "MildWild",
        MOR: "MorphOS",
        NBS: "NetBSD",
        MTK: "MTK / Nucleus",
        MRE: "MRE",
        WII: "Nintendo",
        NDS: "Nintendo Mobile",
        OS2: "OS/2",
        T64: "OSF1",
        OBS: "OpenBSD",
        ORD: "Ordissimo",
        PSP: "PlayStation Portable",
        PS3: "PlayStation",
        RHT: "Red Hat",
        ROS: "RISC OS",
        RSO: "Rosa",
        REM: "Remix OS",
        RZD: "RazoDroiD",
        SAB: "Sabayon",
        SSE: "SUSE",
        SAF: "Sailfish OS",
        SEE: "SeewoOS",
        SLW: "Slackware",
        SOS: "Solaris",
        SYL: "Syllable",
        SYM: "Symbian",
        SYS: "Symbian OS",
        S40: "Symbian OS Series 40",
        S60: "Symbian OS Series 60",
        SY3: "Symbian^3",
        TDX: "ThreadX",
        TIZ: "Tizen",
        TOS: "TmaxOS",
        UBT: "Ubuntu",
        WAS: "watchOS",
        WTV: "WebTV",
        WHS: "Whale OS",
        WIN: "Windows",
        WCE: "Windows CE",
        WIO: "Windows IoT",
        WMO: "Windows Mobile",
        WPH: "Windows Phone",
        WRT: "Windows RT",
        XBX: "Xbox",
        XBT: "Xubuntu",
        YNS: "YunOs",
        IOS: "iOS",
        POS: "palmOS",
        WOS: "webOS"
    },
    osFamilies: {
        Android: [
            "AND",
            "CYN",
            "FIR",
            "REM",
            "RZD",
            "MLD",
            "MCD",
            "YNS"
        ],
        AmigaOS: [
            "AMG",
            "MOR"
        ],
        "Apple TV": [
            "ATV"
        ],
        BlackBerry: [
            "BLB",
            "QNX"
        ],
        Brew: [
            "BMP"
        ],
        BeOS: [
            "BEO",
            "HAI"
        ],
        "Chrome OS": [
            "COS",
            "FYD",
            "SEE"
        ],
        "Firefox OS": [
            "FOS",
            "KOS"
        ],
        "Gaming Console": [
            "WII",
            "PS3"
        ],
        "Google TV": [
            "GTV"
        ],
        IBM: [
            "OS2"
        ],
        iOS: [
            "IOS",
            "WAS"
        ],
        "RISC OS": [
            "ROS"
        ],
        "GNU/Linux": [
            "LIN",
            "ARL",
            "DEB",
            "KNO",
            "MIN",
            "UBT",
            "KBT",
            "XBT",
            "LBT",
            "FED",
            "RHT",
            "VLN",
            "MDR",
            "GNT",
            "SAB",
            "SLW",
            "SSE",
            "CES",
            "BTR",
            "SAF",
            "ORD",
            "TOS",
            "RSO",
            "DEE",
            "FRE"
        ],
        Mac: [
            "MAC"
        ],
        "Mobile Gaming Console": [
            "PSP",
            "NDS",
            "XBX"
        ],
        "Real-time OS": [
            "MTK",
            "TDX",
            "MRE"
        ],
        "Other Mobile": [
            "WOS",
            "POS",
            "SBA",
            "TIZ",
            "SMG",
            "MAE"
        ],
        Symbian: [
            "SYM",
            "SYS",
            "SY3",
            "S60",
            "S40"
        ],
        Unix: [
            "SOS",
            "AIX",
            "HPX",
            "BSD",
            "NBS",
            "OBS",
            "DFB",
            "SYL",
            "IRI",
            "T64",
            "INF"
        ],
        WebTV: [
            "WTV"
        ],
        Windows: [
            "WIN"
        ],
        "Windows Mobile": [
            "WPH",
            "WMO",
            "WCE",
            "WRT",
            "WIO"
        ],
        "Other Smart TV": [
            "WHS"
        ]
    }
}, $cdf7e442067abc24$var$sn = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$nn, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$mn = $cdf7e442067abc24$var$sn([
    {
        regex: "Grid OS (\\d+[\\.\\d]+)",
        name: "GridOS",
        version: "$1"
    },
    {
        regex: "CaixaMagica",
        name: "Caixa M\xe1gica",
        version: ""
    },
    {
        regex: "Mageia; Linux",
        name: "Mageia",
        version: ""
    },
    {
        regex: "(?:WH|WhaleTV/)(\\d+[\\.\\d]+)",
        name: "Whale OS",
        version: "$1"
    },
    {
        regex: "Tizen[ /]?(\\d+[\\.\\d]+)?",
        name: "Tizen",
        version: "$1"
    },
    {
        regex: "Sailfish|Jolla",
        name: "Sailfish OS",
        version: ""
    },
    {
        regex: "(?:Ali)?YunOS[ /]?(\\d+[\\.\\d]+)?",
        name: "YunOS",
        version: "$1"
    },
    {
        regex: "Windows Phone;FBSV/(\\d+[\\.\\d]+)",
        name: "Windows Phone",
        version: "$1"
    },
    {
        regex: "(?:Windows Phone (?:OS)?|wds)[ /]?(\\d+[\\.\\d]+)",
        name: "Windows Phone",
        version: "$1"
    },
    {
        regex: "XBLWP7|Windows Phone",
        name: "Windows Phone",
        version: ""
    },
    {
        regex: "Windows CE(?: (\\d+[\\.\\d]+))?",
        name: "Windows CE",
        version: "$1"
    },
    {
        regex: "(?:IEMobile|Windows ?Mobile)(?: (\\d+[\\.\\d]+))?",
        name: "Windows Mobile",
        version: "$1"
    },
    {
        regex: "Windows NT 6.2; ARM;",
        name: "Windows RT",
        version: ""
    },
    {
        regex: "Windows NT 6.3; ARM;",
        name: "Windows RT",
        version: "8.1"
    },
    {
        regex: "Windows IoT 10.0",
        name: "Windows IoT",
        version: "10"
    },
    {
        regex: "KAIOS(?:/(\\d+[\\.\\d]+))?",
        name: "KaiOS",
        version: "$1"
    },
    {
        regex: "RazoDroiD(?: v(\\d+[\\.\\d]*))?",
        name: "RazoDroiD",
        version: "$1"
    },
    {
        regex: "MildWild(?: CM-(\\d+[\\.\\d]*))?",
        name: "MildWild",
        version: "$1"
    },
    {
        regex: "CyanogenMod(?:[\\-/](?:CM)?(\\d+[\\.\\d]*))?",
        name: "CyanogenMod",
        version: "$1"
    },
    {
        regex: "(?:.*_)?MocorDroid(?:(\\d+[\\.\\d]*))?",
        name: "MocorDroid",
        version: "$1"
    },
    {
        regex: "Fire OS(?:/(\\d+[\\.\\d]*))?",
        name: "Fire OS",
        version: "$1"
    },
    {
        regex: "AFTSO001",
        name: "Fire OS",
        version: "7"
    },
    {
        regex: "FydeOS",
        name: "FydeOS",
        version: ""
    },
    {
        regex: "(?:Podbean|Podimo)(?:.+)?/Android",
        name: "Android",
        version: ""
    },
    {
        regex: "Pinterest for Android/.+; (\\d(?:[\\d\\.]+)?)\\)$",
        name: "Android",
        version: "$1"
    },
    {
        regex: "Android; (\\d+[\\.\\d]*); Mobile;",
        name: "Android",
        version: "$1"
    },
    {
        regex: "[ ]([\\d\\.]+)\\) AppleWebKit.*ROBLOX Android App",
        name: "Android",
        version: "$1"
    },
    {
        regex: "(?:(?:Orca-)?Android|Adr)[ /]?(?:[a-z]+ )?(\\d+[\\.\\d]*)",
        name: "Android",
        version: "$1"
    },
    {
        regex: "(?:Allview_TX1_Quasar|Cosmote_My_mini_Tab) (\\d+[\\.\\d]*)",
        name: "Android",
        version: "$1"
    },
    {
        regex: "Android ?(?:jelly bean|Kit Kat|S.O. Ginger Bread|The FireCyano|:) (\\d+[\\.\\d]*)",
        name: "Android",
        version: "$1"
    },
    {
        regex: "(?:Orca-Android|FB4A).*FBSV/(\\d+[\\.\\d]*);",
        name: "Android",
        version: "$1"
    },
    {
        regex: " Adr |Android|Silk-Accelerated=[a-z]{4,5}",
        name: "Android",
        version: ""
    },
    {
        regex: "(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)",
        name: "Android",
        version: "$1"
    },
    {
        regex: "BeyondPod|AntennaPod|Podkicker|DoggCatcher|Player FM|okhttp|Podcatcher Deluxe|.+K_?Android_?TV_|Sonos/.+\\(ACR_",
        name: "Android",
        version: ""
    },
    {
        regex: "Linux; Andr0id[; ](\\d+[\\.\\d]*)",
        name: "Android",
        version: "$1"
    },
    {
        regex: "Linux; diordnA[; ](\\d+[\\.\\d]*)",
        name: "Android",
        version: "$1"
    },
    {
        regex: "AmigaOS[ ]?(\\d+[\\.\\d]+)",
        name: "AmigaOS",
        version: "$1"
    },
    {
        regex: "AmigaOS|AmigaVoyager|Amiga-AWeb",
        name: "AmigaOS",
        version: ""
    },
    {
        regex: "ThreadX(?:/(\\d+[\\.\\d]*))?",
        name: "ThreadX",
        version: "$1"
    },
    {
        regex: "Nucleus(?:(?: |/v?)(\\d+[\\.\\d]*))?",
        name: "MTK / Nucleus",
        version: "$1"
    },
    {
        regex: "MTK(?:(?: |/v?)(\\d+[\\.\\d]*))?",
        name: "MTK / Nucleus",
        version: "$1"
    },
    {
        regex: "MRE/(\\d+)\\.(\\d+).*;MAUI",
        name: "MRE",
        version: "$1.$2"
    },
    {
        regex: "dvkbuntu",
        name: "DVKBuntu",
        version: ""
    },
    {
        regex: "Helio/(\\d+[\\.\\d]+)",
        name: "Lumin OS",
        version: "$1"
    },
    {
        regex: "HasCodingOs (\\d+[\\.\\d]+)",
        name: "HasCodingOS",
        version: "$1"
    },
    {
        regex: "PCLinuxOS/(\\d+[\\.\\d]+)",
        name: "PCLinuxOS",
        version: "$1"
    },
    {
        regex: "(Ordissimo|webissimo3)",
        name: "Ordissimo",
        version: ""
    },
    {
        regex: "(?:Win|Sistema )Fenix",
        name: "Fenix",
        version: ""
    },
    {
        regex: "TOS; Linux",
        name: "TmaxOS",
        version: ""
    },
    {
        regex: "Maemo",
        name: "Maemo",
        version: ""
    },
    {
        regex: "Arch ?Linux(?:[ /\\-](\\d+[\\.\\d]+))?",
        name: "Arch Linux",
        version: "$1"
    },
    {
        regex: "VectorLinux(?: package)?(?:[ /\\-](\\d+[\\.\\d]+))?",
        name: "VectorLinux",
        version: "$1"
    },
    {
        regex: "Linux; .*((?:Debian|Knoppix|Mint|Ubuntu|Kubuntu|Xubuntu|Lubuntu|Fedora|Red Hat|Mandriva|Gentoo|Sabayon|Slackware|SUSE|CentOS|BackTrack))[ /](\\d+[\\.\\d]+)",
        name: "$1",
        version: "$2"
    },
    {
        regex: "Deepin[ /](\\d+[\\.\\d]+)",
        name: "Deepin",
        version: "$1"
    },
    {
        regex: "(Debian|Knoppix|Mint(?! Browser)|Ubuntu|Kubuntu|Xubuntu|Lubuntu|Fedora|Red Hat|Mandriva|Gentoo|Sabayon|Slackware|SUSE|CentOS|BackTrack|Freebox)(?:(?: Enterprise)? Linux)?(?:[ /\\-](\\d+[\\.\\d]+))?",
        name: "$1",
        version: "$2"
    },
    {
        regex: "OS ROSA; Linux",
        name: "Rosa",
        version: ""
    },
    {
        regex: "WEBOS(\\d+[\\.\\d]+)",
        name: "webOS",
        version: "$1"
    },
    {
        regex: "Web0S; Linux/SmartTV.+Chrome/68",
        name: "webOS",
        version: "5"
    },
    {
        regex: "Web0S; Linux/SmartTV.+Chrome/53",
        name: "webOS",
        version: "4"
    },
    {
        regex: "Web0S; Linux/SmartTV.+Chrome/38",
        name: "webOS",
        version: "3"
    },
    {
        regex: "Web0S; Linux/SmartTV.+Safari/538",
        name: "webOS",
        version: "2"
    },
    {
        regex: "Web0S; Linux/SmartTV.+Safari/537",
        name: "webOS",
        version: "1"
    },
    {
        regex: "(?:Web0S; .*WEBOS|webOS|web0S|Palm webOS|hpwOS)(?:[/]?(\\d+[\\.\\d]+))?",
        name: "webOS",
        version: "$1"
    },
    {
        regex: "(?:PalmOS|Palm OS)(?:[/ ](\\d+[\\.\\d]+))?|Palm",
        name: "palmOS",
        version: "$1"
    },
    {
        regex: "Xiino(?:.*v\\. (\\d+[\\.\\d]+))?",
        name: "palmOS",
        version: "$1"
    },
    {
        regex: "MorphOS(?:[ /](\\d+[\\.\\d]+))?",
        name: "MorphOS",
        version: "$1"
    },
    {
        regex: "FBW.+FBSV/(\\d+[\\.\\d]*);",
        name: "Windows",
        version: "$1"
    },
    {
        regex: "mingw32",
        name: "Windows",
        version: ""
    },
    {
        regex: "Windows/(\\d+\\.\\d+)",
        name: "Windows",
        version: "$1"
    },
    {
        regex: "CYGWIN_NT-10.0|Windows NT 10.0|Windows 10",
        name: "Windows",
        version: "10"
    },
    {
        regex: "CYGWIN_NT-6.4|Windows NT 6.4|Windows 10|win10",
        name: "Windows",
        version: "10"
    },
    {
        regex: "CYGWIN_NT-6.3|Windows NT 6.3|Windows 8.1",
        name: "Windows",
        version: "8.1"
    },
    {
        regex: "CYGWIN_NT-6.2|Windows NT 6.2|Windows 8",
        name: "Windows",
        version: "8"
    },
    {
        regex: "CYGWIN_NT-6.1|Windows NT 6.1|Windows 7|win7",
        name: "Windows",
        version: "7"
    },
    {
        regex: "CYGWIN_NT-6.0|Windows NT 6.0|Windows Vista",
        name: "Windows",
        version: "Vista"
    },
    {
        regex: "CYGWIN_NT-5.2|Windows NT 5.2|Windows Server 2003 / XP x64",
        name: "Windows",
        version: "Server 2003"
    },
    {
        regex: "CYGWIN_NT-5.1|Windows NT 5.1|Windows XP",
        name: "Windows",
        version: "XP"
    },
    {
        regex: "CYGWIN_NT-5.0|Windows NT 5.0|Windows 2000",
        name: "Windows",
        version: "2000"
    },
    {
        regex: "CYGWIN_NT-4.0|Windows NT 4.0|WinNT|Windows NT",
        name: "Windows",
        version: "NT"
    },
    {
        regex: "CYGWIN_ME-4.90|Win 9x 4.90|Windows ME",
        name: "Windows",
        version: "ME"
    },
    {
        regex: "CYGWIN_98-4.10|Win98|Windows 98",
        name: "Windows",
        version: "98"
    },
    {
        regex: "CYGWIN_95-4.0|Win32|Win95|Windows 95|Windows_95",
        name: "Windows",
        version: "95"
    },
    {
        regex: "Windows 3.1",
        name: "Windows",
        version: "3.1"
    },
    {
        regex: "Windows",
        name: "Windows",
        version: ""
    },
    {
        regex: "Haiku",
        name: "Haiku OS",
        version: ""
    },
    {
        regex: "(?:Watch1,[12]/|Watch OS,|watchOS[ /])(\\d+[\\.\\d]*)",
        name: "watchOS",
        version: "$1"
    },
    {
        regex: "iPad/([89]|1[012]).(\\d+[\\.\\d]*)",
        name: "iOS",
        version: "$1.$2"
    },
    {
        regex: "Pinterest for iOS/.+; (\\d(?:[\\d\\.]+)?)\\)$",
        name: "iOS",
        version: "$1"
    },
    {
        regex: "CFNetwork/.+ Darwin/20.4.0(?!.*x86_64)",
        name: "iOS",
        version: "14.5"
    },
    {
        regex: "CFNetwork/.+ Darwin/20.3.0(?!.*x86_64)",
        name: "iOS",
        version: "14.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/20.2.0(?!.*x86_64)",
        name: "iOS",
        version: "14.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/20.1.0(?!.*x86_64)",
        name: "iOS",
        version: "14.2"
    },
    {
        regex: "CFNetwork/.+ Darwin/20.0.0(?!.*x86_64)",
        name: "iOS",
        version: "14.0"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.6.0(?!.*x86_64)",
        name: "iOS",
        version: "13.6"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.5.0(?!.*x86_64)",
        name: "iOS",
        version: "13.5"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.4.0(?!.*x86_64)",
        name: "iOS",
        version: "13.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.3.0(?!.*x86_64)",
        name: "iOS",
        version: "13.3.1"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.2.0(?!.*x86_64)",
        name: "iOS",
        version: "13.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.0.0(?!.*x86_64)",
        name: "iOS",
        version: "13.0"
    },
    {
        regex: "CFNetwork/.+ Darwin/18.7.0(?!.*x86_64)",
        name: "iOS",
        version: "12.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/18.6.0(?!.*x86_64)",
        name: "iOS",
        version: "12.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/18.5.0(?!.*x86_64)",
        name: "iOS",
        version: "12.2"
    },
    {
        regex: "CFNetwork/.+ Darwin/18.2.0(?!.*x86_64)",
        name: "iOS",
        version: "12.1"
    },
    {
        regex: "CFNetwork/.+ Darwin/18.0.0(?!.*x86_64)",
        name: "iOS",
        version: "12.0"
    },
    {
        regex: "CFNetwork/.+ Darwin/17.7.0(?!.*x86_64)",
        name: "iOS",
        version: "11.4.1"
    },
    {
        regex: "CFNetwork/.+ Darwin/17.6.0(?!.*x86_64)",
        name: "iOS",
        version: "11.4"
    },
    {
        regex: "CFNetwork/889(?!.*x86_64)",
        name: "iOS",
        version: "11.1"
    },
    {
        regex: "CFNetwork/887(?!.*x86_64)",
        name: "iOS",
        version: "11.0"
    },
    {
        regex: "CFNetwork/811(?!.*x86_64)",
        name: "iOS",
        version: "10.3"
    },
    {
        regex: "CFNetwork/808\\.3",
        name: "iOS",
        version: "10.3"
    },
    {
        regex: "CFNetwork/808\\.2",
        name: "iOS",
        version: "10.2"
    },
    {
        regex: "CFNetwork/808\\.1",
        name: "iOS",
        version: "10.1"
    },
    {
        regex: "CFNetwork/808\\.0",
        name: "iOS",
        version: "10.0"
    },
    {
        regex: "CFNetwork/808",
        name: "iOS",
        version: "10"
    },
    {
        regex: "CFNetwork/758\\.4\\.3",
        name: "iOS",
        version: "9.3.2"
    },
    {
        regex: "CFNetwork/758\\.3\\.15",
        name: "iOS",
        version: "9.3"
    },
    {
        regex: "CFNetwork/758\\.2\\.[78]",
        name: "iOS",
        version: "9.2"
    },
    {
        regex: "CFNetwork/758\\.1\\.6",
        name: "iOS",
        version: "9.1"
    },
    {
        regex: "CFNetwork/758\\.0\\.2",
        name: "iOS",
        version: "9.0"
    },
    {
        regex: "CFNetwork/711\\.5\\.6",
        name: "iOS",
        version: "8.4.1"
    },
    {
        regex: "CFNetwork/711\\.4\\.6",
        name: "iOS",
        version: "8.4"
    },
    {
        regex: "CFNetwork/711\\.3\\.18",
        name: "iOS",
        version: "8.3"
    },
    {
        regex: "CFNetwork/711\\.2\\.23",
        name: "iOS",
        version: "8.2"
    },
    {
        regex: "CFNetwork/711\\.1\\.1[26]",
        name: "iOS",
        version: "8.1"
    },
    {
        regex: "CFNetwork/711\\.0\\.6",
        name: "iOS",
        version: "8.0"
    },
    {
        regex: "CFNetwork/672\\.1",
        name: "iOS",
        version: "7.1"
    },
    {
        regex: "CFNetwork/672\\.0",
        name: "iOS",
        version: "7.0"
    },
    {
        regex: "CFNetwork/609\\.1",
        name: "iOS",
        version: "6.1"
    },
    {
        regex: "CFNetwork/60[29]",
        name: "iOS",
        version: "6.0"
    },
    {
        regex: "CFNetwork/548\\.1",
        name: "iOS",
        version: "5.1"
    },
    {
        regex: "CFNetwork/548\\.0",
        name: "iOS",
        version: "5.0"
    },
    {
        regex: "CFNetwork/485\\.13",
        name: "iOS",
        version: "4.3"
    },
    {
        regex: "CFNetwork/485\\.12",
        name: "iOS",
        version: "4.2"
    },
    {
        regex: "CFNetwork/485\\.10",
        name: "iOS",
        version: "4.1"
    },
    {
        regex: "CFNetwork/485\\.2",
        name: "iOS",
        version: "4.0"
    },
    {
        regex: "CFNetwork/467\\.12",
        name: "iOS",
        version: "3.2"
    },
    {
        regex: "CFNetwork/459",
        name: "iOS",
        version: "3.1"
    },
    {
        regex: "iPhone/(\\d+[\\.\\d]*) hw/",
        name: "iOS",
        version: "$1"
    },
    {
        regex: "iOS(\\d+\\.\\d+\\.\\d+)",
        name: "iOS",
        version: "$1"
    },
    {
        regex: "iOS(\\d+)\\.(\\d+)0",
        name: "iOS",
        version: "$1.$2"
    },
    {
        regex: "iPhone OS ([0-9]{1})([0-9]{1})([0-9]{1})",
        name: "iOS",
        version: "$1.$2.$3"
    },
    {
        regex: "(?:CPU OS|iPh(?:one)?[ _]OS|iOS)[ _/](\\d+(?:[_\\.]\\d+)*)",
        name: "iOS",
        version: "$1"
    },
    {
        regex: "(?:FBIOS|Messenger(?:Lite)?ForiOS).*FBSV/ ?(\\d+[\\.\\d]*);",
        name: "iOS",
        version: "$1"
    },
    {
        regex: "(?:Apple-)?(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\d+\\.\\d+)|; Opera)?",
        name: "iOS",
        version: "$1"
    },
    {
        regex: "(?:Podcasts/(?:[\\d\\.]+)|Instacast(?:HD)?/(?:\\d\\.[\\d\\.abc]+)|Pocket Casts, iOS|\\(iOS\\)|iOS; Opera|Overcast|Castro|Podcat|iCatcher|RSSRadio/|MobileSafari/)(?!.*x86_64)",
        name: "iOS",
        version: ""
    },
    {
        regex: "iTunes-(iPod|iPad|iPhone)/(?:[\\d\\.]+)",
        name: "iOS",
        version: ""
    },
    {
        regex: "iOS/Version ([\\d\\.]+)",
        name: "iOS",
        version: "$1"
    },
    {
        regex: "Sonos/.+\\(ICRU_",
        name: "iOS",
        version: ""
    },
    {
        regex: "CFNetwork/.+ Darwin/20.2.0.*(x86_64)|(x86_64-apple-)?darwin20.2.0",
        name: "Mac",
        version: "11.1"
    },
    {
        regex: "CFNetwork/.+ Darwin/20.[01].0.*(x86_64)|(x86_64-apple-)?darwin20.[01].0",
        name: "Mac",
        version: "11.0"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.6.0.*(x86_64)|(x86_64-apple-)?darwin19.6.0",
        name: "Mac",
        version: "10.15.6"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.5.0.*(x86_64)|(x86_64-apple-)?darwin19.5.0",
        name: "Mac",
        version: "10.15.5"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.4.0.*(x86_64)|(x86_64-apple-)?darwin19.4.0",
        name: "Mac",
        version: "10.15.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.3.0.*(x86_64)|(x86_64-apple-)?darwin19.3.0",
        name: "Mac",
        version: "10.15.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/19.2.0.*(x86_64)|(x86_64-apple-)?darwin19.2.0",
        name: "Mac",
        version: "10.15.2"
    },
    {
        regex: "CFNetwork/(?:108[258]|109[18]|1103).*(x86_64)",
        name: "Mac",
        version: "10.15"
    },
    {
        regex: "CFNetwork/.+ Darwin/18.2.0.*(x86_64)|(x86_64-apple-)?darwin18.2.0",
        name: "Mac",
        version: "10.14.1"
    },
    {
        regex: "CFNetwork/(?:96[29]|97[14568]).*(x86_64)",
        name: "Mac",
        version: "10.14"
    },
    {
        regex: "CFNetwork/.+ Darwin/17.7.0.*(x86_64)|(x86_64-apple-)?darwin17.7.0",
        name: "Mac",
        version: "10.13.6"
    },
    {
        regex: "CFNetwork/.+ Darwin/17.6.0.*(x86_64)|(x86_64-apple-)?darwin17.6.0",
        name: "Mac",
        version: "10.13.5"
    },
    {
        regex: "CFNetwork/.+ Darwin/17.5.0.*(x86_64)|(x86_64-apple-)?darwin17.5.0",
        name: "Mac",
        version: "10.13.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/17.4.0.*(x86_64)|(x86_64-apple-)?darwin17.4.0",
        name: "Mac",
        version: "10.13.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/17.3.0.*(x86_64)|(x86_64-apple-)?darwin17.3.0",
        name: "Mac",
        version: "10.13.2"
    },
    {
        regex: "CFNetwork/.+ Darwin/17.2.0.*(x86_64)|(x86_64-apple-)?darwin17.2.0",
        name: "Mac",
        version: "10.13.1"
    },
    {
        regex: "CFNetwork/(?:887|889|893|897|901|902).*(x86_64)",
        name: "Mac",
        version: "10.13"
    },
    {
        regex: "CFNetwork/.+ Darwin/16.7.0.*(x86_64)|(x86_64-apple-)?darwin16.7.0",
        name: "Mac",
        version: "10.12.6"
    },
    {
        regex: "CFNetwork/.+ Darwin/16.6.0.*(x86_64)|(x86_64-apple-)?darwin16.6.0",
        name: "Mac",
        version: "10.12.5"
    },
    {
        regex: "CFNetwork/.+ Darwin/16.5.0.*(x86_64)|(x86_64-apple-)?darwin16.5.0",
        name: "Mac",
        version: "10.12.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/16.3.0.*(x86_64)|(x86_64-apple-)?darwin16.3.0",
        name: "Mac",
        version: "10.12.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/16.2.0.*(x86_64)|(x86_64-apple-)?darwin16.2.0",
        name: "Mac",
        version: "10.12.2"
    },
    {
        regex: "CFNetwork/.+ Darwin/16.1.0.*(x86_64)|(x86_64-apple-)?darwin16.1.0",
        name: "Mac",
        version: "10.12.1"
    },
    {
        regex: "CFNetwork/811.*(x86_64)",
        name: "Mac",
        version: "10.12"
    },
    {
        regex: "CFNetwork/807",
        name: "Mac",
        version: "10.12"
    },
    {
        regex: "CFNetwork/.+ Darwin/15.6.0.*(x86_64)|(x86_64-apple-)?darwin15.6.0",
        name: "Mac",
        version: "10.11.6"
    },
    {
        regex: "CFNetwork/.+ Darwin/15.5.0.*(x86_64)|(x86_64-apple-)?darwin15.5.0",
        name: "Mac",
        version: "10.11.5"
    },
    {
        regex: "CFNetwork/.+ Darwin/15.4.0.*(x86_64)|(x86_64-apple-)?darwin15.4.0",
        name: "Mac",
        version: "10.11.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/15.3.0.*(x86_64)|(x86_64-apple-)?darwin15.3.0",
        name: "Mac",
        version: "10.11.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/15.2.0.*(x86_64)|(x86_64-apple-)?darwin15.2.0",
        name: "Mac",
        version: "10.11.2"
    },
    {
        regex: "CFNetwork/760",
        name: "Mac",
        version: "10.11"
    },
    {
        regex: "CFNetwork/.+ Darwin/14.5.0.*(x86_64)|(x86_64-apple-)?darwin14.5.0",
        name: "Mac",
        version: "10.10.5"
    },
    {
        regex: "CFNetwork/.+ Darwin/14.4.0.*(x86_64)|(x86_64-apple-)?darwin14.4.0",
        name: "Mac",
        version: "10.10.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/14.3.0.*(x86_64)|(x86_64-apple-)?darwin14.3.0",
        name: "Mac",
        version: "10.10.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/14.1.0.*(x86_64)|(x86_64-apple-)?darwin14.1.0",
        name: "Mac",
        version: "10.10.2"
    },
    {
        regex: "CFNetwork/720",
        name: "Mac",
        version: "10.10"
    },
    {
        regex: "CFNetwork/.+ Darwin/13.4.0.*(x86_64)|(x86_64-apple-)?darwin13.4.0",
        name: "Mac",
        version: "10.9.5"
    },
    {
        regex: "CFNetwork/.+ Darwin/13.3.0.*(x86_64)|(x86_64-apple-)?darwin13.3.0",
        name: "Mac",
        version: "10.9.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/13.2.0.*(x86_64)|(x86_64-apple-)?darwin13.2.0",
        name: "Mac",
        version: "10.9.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/13.1.0.*(x86_64)|(x86_64-apple-)?darwin13.1.0",
        name: "Mac",
        version: "10.9.2"
    },
    {
        regex: "CFNetwork/673",
        name: "Mac",
        version: "10.9"
    },
    {
        regex: "CFNetwork/.+ Darwin/12.5.0.*(x86_64)|(x86_64-apple-)?darwin12.5.0",
        name: "Mac",
        version: "10.8.5"
    },
    {
        regex: "CFNetwork/.+ Darwin/12.4.0.*(x86_64)|(x86_64-apple-)?darwin12.4.0",
        name: "Mac",
        version: "10.8.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/12.3.0.*(x86_64)|(x86_64-apple-)?darwin12.3.0",
        name: "Mac",
        version: "10.8.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/12.2.0.*(x86_64)|(x86_64-apple-)?darwin12.2.0",
        name: "Mac",
        version: "10.8.2"
    },
    {
        regex: "CFNetwork/.+ Darwin/12.1.0.*(x86_64)|(x86_64-apple-)?darwin12.1.0",
        name: "Mac",
        version: "10.8.1"
    },
    {
        regex: "CFNetwork/596",
        name: "Mac",
        version: "10.8"
    },
    {
        regex: "CFNetwork/.+ Darwin/11.5.0.*(x86_64)|(x86_64-apple-)?darwin11.5.0",
        name: "Mac",
        version: "10.7.5"
    },
    {
        regex: "CFNetwork/.+ Darwin/11.4.0.*(x86_64)|(x86_64-apple-)?darwin11.4.0",
        name: "Mac",
        version: "10.7.4"
    },
    {
        regex: "CFNetwork/.+ Darwin/11.3.0.*(x86_64)|(x86_64-apple-)?darwin11.3.0",
        name: "Mac",
        version: "10.7.3"
    },
    {
        regex: "CFNetwork/.+ Darwin/11.2.0.*(x86_64)|(x86_64-apple-)?darwin11.2.0",
        name: "Mac",
        version: "10.7.2"
    },
    {
        regex: "CFNetwork/.+ Darwin/11.1.0.*(x86_64)|(x86_64-apple-)?darwin11.1.0",
        name: "Mac",
        version: "10.7.1"
    },
    {
        regex: "CFNetwork/520",
        name: "Mac",
        version: "10.7"
    },
    {
        regex: "CFNetwork/454",
        name: "Mac",
        version: "10.6"
    },
    {
        regex: "CFNetwork/(?:438|422|339|330|221|220|217)",
        name: "Mac",
        version: "10.5"
    },
    {
        regex: "CFNetwork/12[89]",
        name: "Mac",
        version: "10.4"
    },
    {
        regex: "CFNetwork/1\\.2",
        name: "Mac",
        version: "10.3"
    },
    {
        regex: "CFNetwork/1\\.1",
        name: "Mac",
        version: "10.2"
    },
    {
        regex: "Mac[ +]OS[ +]?X(?:[ /](?:Version )?(\\d+(?:[_\\.]\\d+)+))?",
        name: "Mac",
        version: "$1"
    },
    {
        regex: "Mac (?:OS/)?(\\d+(?:[_\\.]\\d+)+)",
        name: "Mac",
        version: "$1"
    },
    {
        regex: "macOS/(\\d+[\\.\\d]+)",
        name: "Mac",
        version: "$1"
    },
    {
        regex: "Darwin|Macintosh|Mac_PowerPC|PPC|Mac PowerPC|iMac|MacBook|macOS|Sonos/.+\\(MDCR_",
        name: "Mac",
        version: ""
    },
    {
        regex: "SeewoOS x86_64 (\\d+[\\.\\d]+)",
        name: "SeewoOS",
        version: "$1"
    },
    {
        regex: "CrOS [a-z0-9_]+ .* Chrome/(\\d+[\\.\\d]+)",
        name: "Chrome OS",
        version: "$1"
    },
    {
        regex: "(?:BB10;.+Version|Black[Bb]erry[0-9a-z]+|Black[Bb]erry.+Version)/(\\d+[\\.\\d]+)",
        name: "BlackBerry OS",
        version: "$1"
    },
    {
        regex: "RIM Tablet OS (\\d+[\\.\\d]+)",
        name: "BlackBerry Tablet OS",
        version: "$1"
    },
    {
        regex: "RIM Tablet OS|QNX|Play[Bb]ook",
        name: "BlackBerry Tablet OS",
        version: ""
    },
    {
        regex: "BlackBerry",
        name: "BlackBerry OS",
        version: ""
    },
    {
        regex: "bPod",
        name: "BlackBerry OS",
        version: ""
    },
    {
        regex: "BeOS",
        name: "BeOS",
        version: ""
    },
    {
        regex: "Symbian/3.+NokiaBrowser/7\\.3",
        name: "Symbian^3",
        version: "Anna"
    },
    {
        regex: "Symbian/3.+NokiaBrowser/7\\.4",
        name: "Symbian^3",
        version: "Belle"
    },
    {
        regex: "Symbian/3",
        name: "Symbian^3",
        version: ""
    },
    {
        regex: "(?:Series ?60|SymbOS|S60)(?:[ /]?(\\d+[\\.\\d]+|V\\d+))?",
        name: "Symbian OS Series 60",
        version: "$1"
    },
    {
        regex: "Series40",
        name: "Symbian OS Series 40",
        version: ""
    },
    {
        regex: "SymbianOS/(\\d+[\\.\\d]+)",
        name: "Symbian OS",
        version: "$1"
    },
    {
        regex: "MeeGo|WeTab",
        name: "MeeGo",
        version: ""
    },
    {
        regex: "Symbian(?: OS)?|SymbOS",
        name: "Symbian OS",
        version: ""
    },
    {
        regex: "Nokia",
        name: "Symbian",
        version: ""
    },
    {
        regex: "(?:Mobile|Tablet);.+Firefox/\\d+\\.\\d+",
        name: "Firefox OS",
        version: ""
    },
    {
        regex: "RISC OS(?:-NC)?(?:[ /](\\d+[\\.\\d]+))?",
        name: "RISC OS",
        version: "$1"
    },
    {
        regex: "Inferno(?:[ /](\\d+[\\.\\d]+))?",
        name: "Inferno",
        version: "$1"
    },
    {
        regex: "bada(?:[ /](\\d+[\\.\\d]+))?",
        name: "Bada",
        version: "$1"
    },
    {
        regex: "(?:Brew(?!-Applet)(?: MP)?|BMP)(?:[ /](\\d+[\\.\\d]+))?",
        name: "Brew",
        version: "$1"
    },
    {
        regex: "GoogleTV(?:[ /](\\d+[\\.\\d]+))?",
        name: "Google TV",
        version: "$1"
    },
    {
        regex: "AppleTV(?:/?(\\d+[\\.\\d]+))?",
        name: "Apple TV",
        version: "$1"
    },
    {
        regex: "WebTV/(\\d+[\\.\\d]+)",
        name: "WebTV",
        version: "$1"
    },
    {
        regex: "RemixOS 5.1.1",
        name: "Remix OS",
        version: "1"
    },
    {
        regex: "RemixOS 6.0",
        name: "Remix OS",
        version: "2"
    },
    {
        regex: "RemixOS",
        name: "Remix OS",
        version: ""
    },
    {
        regex: "(?:SunOS|Solaris)(?:[/ ](\\d+[\\.\\d]+))?",
        name: "Solaris",
        version: "$1"
    },
    {
        regex: "AIX(?:[/ ]?(\\d+[\\.\\d]+))?",
        name: "AIX",
        version: "$1"
    },
    {
        regex: "HP-UX(?:[/ ]?(\\d+[\\.\\d]+))?",
        name: "HP-UX",
        version: "$1"
    },
    {
        regex: "FreeBSD(?:[/ ]?(\\d+[\\.\\d]+))?",
        name: "FreeBSD",
        version: "$1"
    },
    {
        regex: "NetBSD(?:[/ ]?(\\d+[\\.\\d]+))?",
        name: "NetBSD",
        version: "$1"
    },
    {
        regex: "OpenBSD(?:[/ ]?(\\d+[\\.\\d]+))?",
        name: "OpenBSD",
        version: "$1"
    },
    {
        regex: "DragonFly(?:[/ ]?(\\d+[\\.\\d]+))?",
        name: "DragonFly",
        version: "$1"
    },
    {
        regex: "Syllable(?:[/ ]?(\\d+[\\.\\d]+))?",
        name: "Syllable",
        version: "$1"
    },
    {
        regex: "IRIX(?:;64)?(?:[/ ]?(\\d+[\\.\\d]+))",
        name: "IRIX",
        version: "$1"
    },
    {
        regex: "OSF1(?:[/ ]?v?(\\d+[\\.\\d]+))?",
        name: "OSF1",
        version: "$1"
    },
    {
        regex: "Nintendo (Wii|Switch)",
        name: "Nintendo",
        version: "$1"
    },
    {
        regex: "PlayStation ?([34])",
        name: "PlayStation",
        version: "$1"
    },
    {
        regex: "Xbox|KIN\\.(?:One|Two)",
        name: "Xbox",
        version: "360"
    },
    {
        regex: "Nitro|Nintendo ([3]?DS[i]?)",
        name: "Nintendo Mobile",
        version: "$1"
    },
    {
        regex: "PlayStation ((?:Portable|Vita))",
        name: "PlayStation Portable",
        version: "$1"
    },
    {
        regex: "OS/2",
        name: "OS/2",
        version: ""
    },
    {
        regex: "Linux(?:OS)?[^a-z]",
        name: "GNU/Linux",
        version: ""
    }
]), $cdf7e442067abc24$var$gn = $cdf7e442067abc24$var$tl, $cdf7e442067abc24$var$cn = $cdf7e442067abc24$var$il, $cdf7e442067abc24$var$xn = $cdf7e442067abc24$var$nl, $cdf7e442067abc24$var$un = $cdf7e442067abc24$var$sn($cdf7e442067abc24$var$dn), $cdf7e442067abc24$var$pn = [
    "AmigaOS",
    "IBM",
    "GNU/Linux",
    "Mac",
    "Unix",
    "Windows",
    "BeOS",
    "Chrome OS"
], $cdf7e442067abc24$var$hn = $cdf7e442067abc24$var$un.default.operatingSystem, $cdf7e442067abc24$var$Sn = $cdf7e442067abc24$var$un.default.osFamilies;
class $cdf7e442067abc24$var$vn {
    constructor(e){
        this.options = {
            versionTruncation: 1
        }, this.parse = (e)=>{
            var r = {
                name: "",
                version: "",
                platform: this.parsePlatform(e)
            };
            for (const t of $cdf7e442067abc24$var$mn.default){
                var o = $cdf7e442067abc24$var$xn.userAgentParser(t.regex, e);
                if (o) return r.name = $cdf7e442067abc24$var$cn.variableReplacement(t.name, o), r.version = $cdf7e442067abc24$var$gn.formatVersion($cdf7e442067abc24$var$cn.variableReplacement(t.version, o), this.options.versionTruncation), "lubuntu" === r.name && (r.name = "Lubuntu"), "debian" === r.name && (r.name = "Debian"), "YunOS" === r.name && (r.name = "YunOs"), r;
            }
            return null;
        }, this.parsePlatform = (e)=>$cdf7e442067abc24$var$xn.userAgentParser("arm|aarch64|Watch ?OS|Watch1,[12]", e) ? "ARM" : $cdf7e442067abc24$var$xn.userAgentParser("mips", e) ? "MIPS" : $cdf7e442067abc24$var$xn.userAgentParser("sh4", e) ? "SuperH" : $cdf7e442067abc24$var$xn.userAgentParser("WOW64|x64|win64|amd64|x86_?64", e) ? "x64" : $cdf7e442067abc24$var$xn.userAgentParser("(?:i[0-9]|x)86|i86pc", e) ? "x86" : "", this.options = Object.assign(Object.assign({}, this.options), e);
    }
}
($cdf7e442067abc24$var$nn.default = $cdf7e442067abc24$var$vn).getDesktopOsArray = ()=>$cdf7e442067abc24$var$pn, $cdf7e442067abc24$var$vn.getOsFamily = (e)=>{
    var r, o, t = $cdf7e442067abc24$var$vn.getOsShortName(e);
    for ([r, o] of Object.entries($cdf7e442067abc24$var$Sn))if (o.includes(t)) return r;
    return "";
}, $cdf7e442067abc24$var$vn.getOsShortName = (e)=>{
    for (var [r, o] of Object.entries($cdf7e442067abc24$var$hn))if (o === e) return r;
    return "";
};
var $cdf7e442067abc24$var$$n = {}, $cdf7e442067abc24$var$bn = {
    Dell: [
        "MDDR(JS)?",
        "MDDC(JS)?",
        "MDDS(JS)?"
    ],
    Acer: [
        "MAAR(JS)?"
    ],
    Sony: [
        "MASE(JS)?",
        "MASP(JS)?",
        "MASA(JS)?"
    ],
    Asus: [
        "MAAU",
        "NP0[26789]",
        "ASJB",
        "ASU2(JS)?"
    ],
    Samsung: [
        "MASM(JS)?",
        "SMJB"
    ],
    Lenovo: [
        "MALC(JS)?",
        "MALE(JS)?",
        "MALN(JS)?",
        "LCJB",
        "LEN2"
    ],
    Toshiba: [
        "MATM(JS)?",
        "MATB(JS)?",
        "MATP(JS)?",
        "TNJB",
        "TAJB"
    ],
    Medion: [
        "MAMD"
    ],
    MSI: [
        "MAMI(JS)?",
        "MAM3"
    ],
    Gateway: [
        "MAGW(JS)?"
    ],
    Fujitsu: [
        "MAFS(JS)?",
        "FSJB"
    ],
    Compaq: [
        "CPDTDF",
        "CPNTDF(JS?)",
        "CMNTDF(JS)?",
        "CMDTDF(JS)?"
    ],
    HP: [
        "HPCMHP",
        "HPNTDF(JS)?",
        "HPDTDF(JS)?"
    ],
    Hyrican: [
        "MANM(JS)?"
    ],
    Ordissimo: [
        "Ordissimo",
        "webissimo3"
    ]
}, $cdf7e442067abc24$var$An = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
Object.defineProperty($cdf7e442067abc24$var$$n, "__esModule", {
    value: !0
});
const $cdf7e442067abc24$var$fn = $cdf7e442067abc24$var$An($cdf7e442067abc24$var$bn), $cdf7e442067abc24$var$Mn = $cdf7e442067abc24$var$nl;
$cdf7e442067abc24$var$$n.default = class {
    constructor(){
        this.parse = (e)=>{
            for (var [r, o] of Object.entries($cdf7e442067abc24$var$fn.default))for (const t of o)if ($cdf7e442067abc24$var$Mn.userAgentParser(t, e)) return r;
            return "";
        };
    }
};
var $cdf7e442067abc24$var$Pn = $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
};
const $cdf7e442067abc24$var$Tn = $cdf7e442067abc24$var$Pn([
    {
        regex: "360Spider(-Image|-Video)?",
        name: "360Spider",
        category: "Search bot",
        url: "https://www.so.com/help/help_3_2.html",
        producer: {
            name: "Online Media Group, Inc.",
            url: ""
        }
    },
    {
        regex: "Aboundex",
        name: "Aboundexbot",
        category: "Search bot",
        url: "http://www.aboundex.com/crawler/",
        producer: {
            name: "Aboundex.com",
            url: "http://www.aboundex.com"
        }
    },
    {
        regex: "AcoonBot",
        name: "Acoon",
        category: "Search bot",
        url: "http://www.acoon.de/robot.asp",
        producer: {
            name: "Acoon GmbH",
            url: "http://www.acoon.de"
        }
    },
    {
        regex: "AddThis\\.com",
        name: "AddThis.com",
        category: "Social Media Agent",
        url: "",
        producer: {
            name: "Clearspring Technologies, Inc.",
            url: "http://www.clearspring.com"
        }
    },
    {
        regex: "AhrefsBot",
        name: "aHrefs Bot",
        category: "Crawler",
        url: "https://ahrefs.com/robot",
        producer: {
            name: "Ahrefs Pte Ltd",
            url: "https://ahrefs.com/robot"
        }
    },
    {
        regex: "ia_archiver|alexabot|verifybot",
        name: "Alexa Crawler",
        category: "Search bot",
        url: "https://support.alexa.com/hc/en-us/sections/200100794-Crawlers",
        producer: {
            name: "Alexa Internet",
            url: "https://www.alexa.com"
        }
    },
    {
        regex: "alexa site audit",
        name: "Alexa Site Audit",
        category: "Site Monitor",
        url: "https://support.alexa.com/hc/en-us/articles/200450194",
        producer: {
            name: "Alexa Internet",
            url: "https://www.alexa.com"
        }
    },
    {
        regex: "Amazon[ -]Route ?53[ -]Health[ -]Check[ -]Service",
        name: "Amazon Route53 Health Check",
        category: "Service Agent",
        producer: {
            name: "Amazon Web Services",
            url: "https://aws.amazon.com/"
        }
    },
    {
        regex: "AmorankSpider",
        name: "Amorank Spider",
        category: "Crawler",
        url: "http://amorank.com/webcrawler.html",
        producer: {
            name: "Amorank",
            url: "http://www.amorank.com"
        }
    },
    {
        regex: "ApacheBench",
        name: "ApacheBench",
        category: "Benchmark",
        url: "https://httpd.apache.org/docs/2.4/programs/ab.html",
        producer: {
            name: "The Apache Software Foundation",
            url: "https://www.apache.org/foundation/"
        }
    },
    {
        regex: "Applebot",
        name: "Applebot",
        category: "Crawler",
        url: "https://support.apple.com/en-us/HT204683",
        producer: {
            name: "Apple Inc",
            url: "https://www.apple.com"
        }
    },
    {
        regex: "AppSignalBot",
        name: "AppSignalBot",
        category: "Site Monitor",
        url: "https://docs.appsignal.com/uptime-monitoring/",
        producer: {
            name: "AppSignal",
            url: "https://appsignal.com/"
        }
    },
    {
        regex: "Arachni",
        name: "Arachni",
        category: "Security Checker",
        url: "https://www.arachni-scanner.com/",
        producer: {
            name: "Sarosys LLC",
            url: "https://www.sarosys.com/"
        }
    },
    {
        regex: "AspiegelBot",
        name: "AspiegelBot",
        category: "Crawler",
        url: "https://aspiegel.com/",
        producer: {
            name: "Huawei",
            url: "https://www.huawei.com/"
        }
    },
    {
        regex: "Castro 2, Episode Duration Lookup",
        name: "Castro 2",
        category: "Service Agent",
        url: "http://supertop.co/castro/",
        producer: {
            name: "Supertop",
            url: "http://supertop.co"
        }
    },
    {
        regex: "Curious George",
        name: "Analytics SEO Crawler",
        category: "Crawler",
        url: "http://www.analyticsseo.com/crawler",
        producer: {
            name: "Analytics SEO",
            url: "http://www.analyticsseo.com"
        }
    },
    {
        regex: "archive\\.org_bot|special_archiver",
        name: "archive.org bot",
        category: "Crawler",
        url: "https://archive.org/details/archive.org_bot",
        producer: {
            name: "The Internet Archive",
            url: "https://archive.org"
        }
    },
    {
        regex: "Ask Jeeves/Teoma",
        name: "Ask Jeeves",
        category: "Search bot",
        url: "",
        producer: {
            name: "Ask Jeeves Inc.",
            url: "http://www.ask.com"
        }
    },
    {
        regex: "Backlink-Check\\.de",
        name: "Backlink-Check.de",
        category: "Crawler",
        url: "http://www.backlink-check.de/bot.html",
        producer: {
            name: "Mediagreen Medienservice",
            url: "http://www.backlink-check.de"
        }
    },
    {
        regex: "BacklinkCrawler",
        name: "BacklinkCrawler",
        category: "Crawler",
        url: "http://www.backlinktest.com/crawler.html",
        producer: {
            name: "2.0Promotion GbR",
            url: "http://www.backlinktest.com"
        }
    },
    {
        regex: "baiduspider(-image)?|baidu Transcoder|baidu.*spider",
        name: "Baidu Spider",
        category: "Search bot",
        url: "http://www.baidu.com/search/spider.htm",
        producer: {
            name: "Baidu",
            url: "http://www.baidu.com"
        }
    },
    {
        regex: "BazQux",
        name: "BazQux Reader",
        url: "https://bazqux.com/fetcher",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "MSNBot|msrbot|bingbot|BingPreview|msnbot-(UDiscovery|NewsBlogs)|adidxbot",
        name: "BingBot",
        category: "Search bot",
        url: "http://search.msn.com/msnbot.htmn",
        producer: {
            name: "Microsoft Corporation",
            url: "http://www.microsoft.com"
        }
    },
    {
        regex: "Blekkobot",
        name: "Blekkobot",
        category: "Search bot",
        url: "http://blekko.com/about/blekkobot",
        producer: {
            name: "Blekko",
            url: "http://blekko.com"
        }
    },
    {
        regex: "BLEXBot(Test)?",
        name: "BLEXBot Crawler",
        category: "Crawler",
        url: "http://webmeup-crawler.com",
        producer: {
            name: "WebMeUp",
            url: "http://webmeup.com"
        }
    },
    {
        regex: "Bloglovin",
        name: "Bloglovin",
        url: "http://www.bloglovin.com",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "Blogtrottr",
        name: "Blogtrottr",
        url: "",
        category: "Feed Fetcher",
        producer: {
            name: "Blogtrottr Ltd",
            url: "https://blogtrottr.com/"
        }
    },
    {
        regex: "BoardReader Blog Indexer",
        name: "BoardReader Blog Indexer",
        category: "Crawler",
        producer: {
            name: "BoardReader",
            url: "https://boardreader.com/"
        }
    },
    {
        regex: "BountiiBot",
        name: "Bountii Bot",
        category: "Search bot",
        url: "http://bountii.com/contact.php",
        producer: {
            name: "Bountii Inc.",
            url: "http://bountii.com"
        }
    },
    {
        regex: "Browsershots",
        name: "Browsershots",
        category: "Service Agent",
        url: "http://browsershots.org/faq",
        producer: {
            name: "Browsershots.org",
            url: "http://browsershots.org"
        }
    },
    {
        regex: "BUbiNG",
        name: "BUbiNG",
        category: "Crawler",
        url: "http://law.di.unimi.it/BUbiNG.html",
        producer: {
            name: "The Laboratory for Web Algorithmics (LAW)",
            url: "http://law.di.unimi.it/software.php#buging"
        }
    },
    {
        regex: "(?<!HTC)[ _]Butterfly/",
        name: "Butterfly Robot",
        category: "Search bot",
        url: "http://labs.topsy.com/butterfly",
        producer: {
            name: "Topsy Labs",
            url: "http://labs.topsy.com"
        }
    },
    {
        regex: "CareerBot",
        name: "CareerBot",
        category: "Crawler",
        url: "http://www.career-x.de/bot.html",
        producer: {
            name: "career-x GmbH",
            url: "http://www.career-x.de"
        }
    },
    {
        regex: "CCBot",
        name: "ccBot crawler",
        category: "Crawler",
        url: "http://commoncrawl.org/faq/",
        producer: {
            name: "reddit inc.",
            url: "http://www.reddit.com"
        }
    },
    {
        regex: "Cliqzbot",
        name: "Cliqzbot",
        category: "Crawler",
        url: "http://cliqz.com/company/cliqzbot",
        producer: {
            name: "10betterpages GmbH",
            url: "http://cliqz.com"
        }
    },
    {
        regex: "Cloudflare-AMP",
        name: "CloudFlare AMP Fetcher",
        category: "Crawler",
        url: "https://amp.cloudflare.com/doc/fetcher.html",
        producer: {
            name: "CloudFlare",
            url: "http://www.cloudflare.com"
        }
    },
    {
        regex: "CloudflareDiagnostics",
        name: "Cloudflare Diagnostics",
        category: "Site Monitor",
        url: "https://www.cloudflare.com/",
        producer: {
            name: "Cloudflare",
            url: "https://www.cloudflare.com"
        }
    },
    {
        regex: "CloudFlare-AlwaysOnline",
        name: "CloudFlare Always Online",
        category: "Site Monitor",
        url: "http://www.cloudflare.com/always-online",
        producer: {
            name: "CloudFlare",
            url: "http://www.cloudflare.com"
        }
    },
    {
        regex: "coccoc.com",
        name: "C\u1ED1c C\u1ED1c Bot",
        url: "https://help.coccoc.com/en/search-engine/coccoc-robots",
        category: "Search bot",
        producer: {
            name: "C\u1ED1c C\u1ED1c",
            url: "https://coccoc.com/"
        }
    },
    {
        regex: "collectd",
        name: "Collectd",
        url: "https://collectd.org/",
        category: "Site Monitor",
        producer: {
            name: "Collectd",
            url: "https://collectd.org/"
        }
    },
    {
        regex: "CommaFeed",
        name: "CommaFeed",
        url: "http://www.commafeed.com",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "CSS Certificate Spider",
        name: "CSS Certificate Spider",
        category: "Crawler",
        url: "http://www.css-security.com/certificatespider/",
        producer: {
            name: "Certified Security Solutions",
            url: "https://www.css-security.com/company/about-us/"
        }
    },
    {
        regex: "Datadog Agent",
        name: "Datadog Agent",
        url: "https://github.com/DataDog/dd-agent",
        category: "Site Monitor",
        producer: {
            name: "Datadog",
            url: "https://www.datadoghq.com/"
        }
    },
    {
        regex: "Datanyze",
        name: "Datanyze",
        url: "",
        category: "Crawler",
        producer: {
            name: "Datanyze",
            url: "https://www.datanyze.com"
        }
    },
    {
        regex: "Dataprovider",
        name: "Dataprovider",
        category: "Crawler",
        url: "",
        producer: {
            name: "Dataprovider B.V.",
            url: "https://www.dataprovider.com/"
        }
    },
    {
        regex: "Daum(oa)?[ /][0-9]",
        name: "Daum",
        category: "Search bot",
        url: "http://tab.search.daum.net/aboutWebSearch_en.html",
        producer: {
            name: "Daum Communications Corp.",
            url: "http://www.kakaocorp.com/main"
        }
    },
    {
        regex: "Dazoobot",
        name: "Dazoobot",
        category: "Search bot",
        url: "",
        producer: {
            name: "DAZOO.FR",
            url: "http://dazoo.fr"
        }
    },
    {
        regex: "discobot(-news)?",
        name: "Discobot",
        category: "Search bot",
        url: "http://discoveryengine.com/discobot.html",
        producer: {
            name: "Discovery Engine",
            url: "http://discoveryengine.com"
        }
    },
    {
        regex: "Domain Re-Animator Bot|support@domainreanimator.com",
        name: "Domain Re-Animator Bot",
        category: "Crawler",
        url: "",
        producer: {
            name: "Domain Re-Animator, LLC",
            url: "http://domainreanimator.com"
        }
    },
    {
        regex: "DotBot",
        name: "DotBot",
        category: "Crawler",
        url: "http://www.opensiteexplorer.org/dotbot",
        producer: {
            name: "SEOmoz, Inc.",
            url: "http://moz.com/"
        }
    },
    {
        regex: "DuckDuck(?:Go-Favicons-)?Bot",
        name: "DuckDuckGo Bot",
        category: "Search bot",
        url: "https://duckduckgo.com/duckduckbot",
        producer: {
            name: "DuckDuckGo",
            url: "https://duckduckgo.com/"
        }
    },
    {
        regex: "EasouSpider",
        name: "Easou Spider",
        category: "Search bot",
        url: "http://www.easou.com/search/spider.html",
        producer: {
            name: "easou ICP",
            url: "http://www.easou.com"
        }
    },
    {
        regex: "eCairn-Grabber",
        name: "eCairn-Grabber",
        category: "Crawler",
        producer: {
            name: "eCairn",
            url: "https://ecairn.com"
        }
    },
    {
        regex: "EMail Exractor",
        name: "EMail Exractor",
        category: "Crawler",
        url: "",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "evc-batch",
        name: "evc-batch",
        category: "Crawler",
        url: "",
        producer: {
            name: "eVenture Capital Partners II, LLC",
            url: "http://www.eventures.vc/"
        }
    },
    {
        regex: "Exabot(-Thumbnails|-Images)?|ExaleadCloudview",
        name: "ExaBot",
        category: "Crawler",
        url: "http://www.exabot.com/go/robot",
        producer: {
            name: "Dassault Syst\xe8mes",
            url: "http://www.3ds.com"
        }
    },
    {
        regex: "ExactSeek Crawler",
        name: "ExactSeek Crawler",
        category: "Search bot",
        url: "http://www.exactseek.com",
        producer: {
            name: "Jayde Online, Inc.",
            url: "http://www.jaydeonlineinc.com"
        }
    },
    {
        regex: "Ezooms",
        name: "Ezooms",
        category: "Crawler",
        url: "",
        producer: {
            name: "SEOmoz, Inc.",
            url: "http://moz.com/"
        }
    },
    {
        regex: "facebookexternalhit|facebookplatform|facebookexternalua",
        name: "Facebook External Hit",
        category: "Social Media Agent",
        url: "https://www.facebook.com/externalhit_uatext.php",
        producer: {
            name: "Facebook",
            url: "http://www.facebook.com"
        }
    },
    {
        regex: "Feedbin",
        name: "Feedbin",
        url: "http://feedbin.com/",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "FeedBurner",
        name: "FeedBurner",
        url: "http://www.feedburner.com",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "Feed Wrangler",
        name: "Feed Wrangler",
        url: "https://feedwrangler.net/",
        category: "Feed Fetcher",
        producer: {
            name: "David Smith & Developing Perspective, LLC",
            url: "https://david-smith.org"
        }
    },
    {
        regex: "(Meta)?Feedly(Bot|App)?",
        name: "Feedly",
        url: "http://www.feedly.com",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "Feedspot",
        name: "Feedspot",
        url: "http://www.feedspot.com",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "Fever/[0-9]",
        name: "Fever",
        url: "http://feedafever.com/",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "FlipboardProxy|FlipboardRSS",
        name: "Flipboard",
        url: "http://flipboard.com/browserproxy",
        category: "Feed Fetcher",
        producer: {
            name: "Flipboard",
            url: "http://flipboard.com/"
        }
    },
    {
        regex: "Findxbot",
        name: "Findxbot",
        category: "Crawler",
        url: "http://www.findxbot.com"
    },
    {
        regex: "FreshRSS",
        name: "FreshRSS",
        category: "Feed Fetcher",
        url: "https://freshrss.org/"
    },
    {
        regex: "Genieo",
        name: "Genieo Web filter",
        category: "",
        url: "http://www.genieo.com/webfilter.html",
        producer: {
            name: "Genieo",
            url: "http://www.genieo.com"
        }
    },
    {
        regex: "GigablastOpenSource",
        name: "Gigablast",
        category: "Search bot",
        url: "https://github.com/gigablast/open-source-search-engine",
        producer: {
            name: "Matt Wells",
            url: "http://www.gigablast.com/faq.html"
        }
    },
    {
        regex: "Gluten Free Crawler",
        name: "Gluten Free Crawler",
        category: "Crawler",
        url: "http://glutenfreepleasure.com/",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "ichiro/mobile goo",
        name: "Goo",
        category: "Search bot",
        url: "http://search.goo.ne.jp/option/use/sub4/sub4-1",
        producer: {
            name: "NTT Resonant",
            url: "http://goo.ne.jp"
        }
    },
    {
        regex: "Google Favicon",
        name: "Google Favicon",
        category: "Crawler"
    },
    {
        regex: "Google Search Console",
        name: "Google Search Console",
        category: "Crawler",
        url: "https://search.google.com/search-console/about",
        producer: {
            name: "Google Inc.",
            url: "http://www.google.com"
        }
    },
    {
        regex: "Google Page Speed Insights",
        name: "Google PageSpeed Insights",
        category: "Site Monitor",
        url: "http://developers.google.com/speed/pagespeed/insights/",
        producer: {
            name: "Google Inc.",
            url: "http://www.google.com"
        }
    },
    {
        regex: "google_partner_monitoring",
        name: "Google Partner Monitoring",
        category: "Site Monitor",
        url: "",
        producer: {
            name: "Google Inc.",
            url: "http://www.google.com"
        }
    },
    {
        regex: "Google-Cloud-Scheduler",
        name: "Google Cloud Scheduler",
        category: "Crawler",
        url: "https://cloud.google.com/scheduler",
        producer: {
            name: "Google Inc.",
            url: "https://www.google.com"
        }
    },
    {
        regex: "Google-Structured-Data-Testing-Tool",
        name: "Google Structured Data Testing Tool",
        category: "Validator",
        url: "https://search.google.com/structured-data/testing-tool",
        producer: {
            name: "Google Inc.",
            url: "http://www.google.com"
        }
    },
    {
        regex: "GoogleStackdriverMonitoring",
        name: "Google Stackdriver Monitoring",
        category: "Site Monitor",
        url: "https://cloud.google.com/monitoring",
        producer: {
            name: "Google Inc.",
            url: "https://www.google.com"
        }
    },
    {
        regex: "via ggpht\\.com GoogleImageProxy",
        name: "Gmail Image Proxy",
        category: "Crawler",
        url: "",
        producer: {
            name: "Google Inc.",
            url: "http://www.google.com"
        }
    },
    {
        regex: "SeznamEmailProxy",
        name: "Seznam Email Proxy",
        category: "Crawler",
        url: "",
        producer: {
            name: "Seznam.cz, a.s.",
            url: "http://www.seznam.cz/"
        }
    },
    {
        regex: "Seznam-Zbozi-robot",
        name: "Seznam Zbozi.cz",
        category: "Crawler",
        url: "",
        producer: {
            name: "Seznam.cz, a.s.",
            url: "https://www.zbozi.cz/"
        }
    },
    {
        regex: "Heurekabot-Feed",
        name: "Heureka Feed",
        category: "Crawler",
        url: "https://sluzby.heureka.cz/napoveda/heurekabot/",
        producer: {
            name: "Heureka.cz, a.s.",
            url: "https://www.heureka.cz/"
        }
    },
    {
        regex: "ShopAlike",
        name: "ShopAlike",
        category: "Crawler",
        url: "",
        producer: {
            name: "Visual Meta",
            url: "https://www.shopalike.cz/"
        }
    },
    {
        regex: "AdsBot-Google(-Mobile)?|Adwords-(DisplayAds|Express|Instant)|Google Web Preview|Google[ -]Publisher[ -]Plugin|Google-(Ads-Qualify|Adwords|AMPHTML|Assess|HotelAdsVerifier|Read-Aloud|Shopping-Quality|Site-Verification|speakr|Test|Youtube-Links)|(APIs|DuplexWeb|Feedfetcher|Mediapartners)-Google|Googlebot(-Mobile|-Image|-Video|-News)?|GoogleProducer|Google.*/\\+/web/snippet",
        name: "Googlebot",
        category: "Search bot",
        url: "http://www.google.com/bot.html",
        producer: {
            name: "Google Inc.",
            url: "http://www.google.com"
        }
    },
    {
        regex: "heritrix",
        name: "Heritrix",
        category: "Crawler",
        url: "https://webarchive.jira.com/wiki/display/Heritrix/Heritrix",
        producer: {
            name: "The Internet Archive",
            url: "https://archive.org"
        }
    },
    {
        regex: "HubSpot ",
        name: "HubSpot",
        category: "Crawler",
        producer: {
            name: "HubSpot Inc.",
            url: "https://www.hubspot.com"
        }
    },
    {
        regex: "HTTPMon",
        name: "HTTPMon",
        category: "Site Monitor",
        url: "http://www.httpmon.com",
        producer: {
            name: "towards GmbH",
            url: "http://www.towards.ch/"
        }
    },
    {
        regex: "ICC-Crawler",
        name: "ICC-Crawler",
        category: "Crawler",
        url: "http://www.nict.go.jp/en/univ-com/plan/crawl.html",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "inoreader.com",
        name: "inoreader",
        category: "Feed Reader",
        url: "https://www.inoreader.com"
    },
    {
        regex: "iisbot",
        name: "IIS Site Analysis",
        category: "Crawler",
        url: "http://www.iis.net/iisbot.html",
        producer: {
            name: "Microsoft Corporation",
            url: "http://www.microsoft.com"
        }
    },
    {
        regex: "ips-agent",
        name: "IPS Agent",
        category: "Crawler",
        producer: {
            name: "VeriSign, Inc",
            url: "http://www.verisign.com/"
        }
    },
    {
        regex: "IP-Guide\\.com",
        name: "IP-Guide Crawler",
        category: "Crawler",
        url: "",
        producer: {
            name: "",
            url: "https://ip-guide.com"
        }
    },
    {
        regex: "kouio",
        name: "Kouio",
        url: "http://kouio.com/",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "larbin",
        name: "Larbin web crawler",
        category: "Crawler",
        url: "http://larbin.sourceforge.net",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "([A-z0-9]*)-Lighthouse",
        name: "Lighthouse",
        category: "Site Monitor",
        url: "https://developers.google.com/web/tools/lighthouse",
        producer: {
            name: "Lighthouse",
            url: "https://developers.google.com/web/tools/lighthouse"
        }
    },
    {
        regex: "linkdexbot(-mobile)?|linkdex\\.com",
        name: "Linkdex Bot",
        category: "Search bot",
        url: "http://www.linkdex.com/bots",
        producer: {
            name: "Mojeek Ltd.",
            url: "http://www.mojeek.com"
        }
    },
    {
        regex: "LinkedInBot",
        name: "LinkedIn Bot",
        category: "Social Media Agent",
        url: "http://www.linkedin.com",
        producer: {
            name: "LinkedIn",
            url: "http://www.linkedin.com"
        }
    },
    {
        regex: "ltx71",
        name: "LTX71",
        url: "http://ltx71.com/",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "Mail\\.RU(_Bot)?",
        name: "Mail.Ru Bot",
        category: "Search bot",
        url: "http://help.mail.ru/webmaster/indexing/robots/types_robots",
        producer: {
            name: "Mail.Ru Group",
            url: "http://corp.mail.ru"
        }
    },
    {
        regex: "magpie-crawler",
        name: "Magpie-Crawler",
        category: "Social Media Agent",
        url: "http://www.brandwatch.com/magpie-crawler/",
        producer: {
            name: "Brandwatch",
            url: "http://www.brandwatch.com"
        }
    },
    {
        regex: "MagpieRSS",
        name: "MagpieRSS",
        url: "http://magpierss.sourceforge.net/",
        category: "Feed Parser",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "masscan",
        name: "masscan",
        url: "https://github.com/robertdavidgraham/masscan",
        category: "Crawler",
        producer: {
            name: "Robert Graham",
            url: "https://github.com/robertdavidgraham"
        }
    },
    {
        regex: "Mastodon/",
        name: "Mastodon Bot",
        category: "Social Media Agent"
    },
    {
        regex: "meanpathbot",
        name: "Meanpath Bot",
        category: "Search bot",
        url: "http://www.meanpath.com/meanpathbot.html",
        producer: {
            name: "Meanpath",
            url: "http://www.meanpath.com"
        }
    },
    {
        regex: "MetaJobBot",
        name: "MetaJobBot",
        category: "Crawler",
        url: "http://www.metajob.at/the/crawler",
        producer: {
            name: "MetaJob",
            url: "http://www.metajob.at"
        }
    },
    {
        regex: "MetaInspector",
        name: "MetaInspector",
        category: "Crawler",
        url: "https://github.com/jaimeiniesta/metainspector"
    },
    {
        regex: "MixrankBot",
        name: "Mixrank Bot",
        category: "Crawler",
        url: "http://mixrank.com",
        producer: {
            name: "Online Media Group, Inc.",
            url: ""
        }
    },
    {
        regex: "MJ12bot",
        name: "MJ12 Bot",
        category: "Search bot",
        url: "http://majestic12.co.uk/bot.php",
        producer: {
            name: "Majestic-12",
            url: "http://majestic12.co.uk"
        }
    },
    {
        regex: "Mnogosearch",
        name: "Mnogosearch",
        category: "Search bot",
        url: "http://www.mnogosearch.org/",
        producer: {
            name: "Lavtech.Com Corp.",
            url: ""
        }
    },
    {
        regex: "MojeekBot",
        name: "MojeekBot",
        category: "Search bot",
        url: "http://www.mojeek.com/bot.html",
        producer: {
            name: "Mojeek Ltd.",
            url: "http://www.mojeek.com"
        }
    },
    {
        regex: "munin",
        name: "Munin",
        category: "Site Monitor",
        url: "http://munin-monitoring.org/",
        producer: {
            name: "Munin",
            url: "http://munin-monitoring.org/"
        }
    },
    {
        regex: "NalezenCzBot",
        name: "NalezenCzBot",
        category: "Crawler",
        url: "http://www.nalezen.cz/about-crawler",
        producer: {
            name: "Jaroslav Kubo\u0161",
            url: ""
        }
    },
    {
        regex: "check_http/v",
        name: "Nagios check_http",
        category: "Site Monitor",
        url: "https://nagios.org",
        producer: {
            name: "Nagios Plugins Development Team",
            url: "https://nagios.org"
        }
    },
    {
        regex: "nbertaupete95\\(at\\)gmail.com",
        name: "nbertaupete95",
        category: "Crawler"
    },
    {
        regex: "Netcraft( Web Server Survey| SSL Server Survey|SurveyAgent)",
        name: "Netcraft Survey Bot",
        category: "Search bot",
        url: "",
        producer: {
            name: "Netcraft",
            url: "http://www.netcraft.com"
        }
    },
    {
        regex: "netEstate NE Crawler",
        name: "netEstate",
        category: "Crawler",
        url: "http://www.website-datenbank.de/Impressum",
        producer: {
            name: "netEstate GmbH",
            url: "https://www.netestate.de/en/"
        }
    },
    {
        regex: "Netvibes",
        name: "Netvibes",
        url: "http://www.netvibes.com/",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "NewsBlur .*(Fetcher|Finder)",
        name: "NewsBlur",
        url: "http://www.newsblur.com",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "NewsGatorOnline",
        name: "NewsGator",
        url: "http://www.newsgator.com",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "nlcrawler",
        name: "NLCrawler",
        category: "Crawler",
        url: "",
        producer: {
            name: "Northern Light",
            url: "http://northernlight.com"
        }
    },
    {
        regex: "Nmap Scripting Engine",
        name: "Nmap",
        category: "Security Checker",
        url: "https://nmap.org/book/nse.html",
        producer: {
            name: "Nmap",
            url: "https://nmap.org/"
        }
    },
    {
        regex: "Nuzzel",
        name: "Nuzzel",
        category: "Crawler",
        producer: {
            name: "Nuzzel",
            url: "https://www.nuzzel.com/"
        }
    },
    {
        regex: "Octopus [0-9]",
        name: "Octopus"
    },
    {
        regex: "omgili(?:bot)?",
        name: "Omgili bot",
        category: "Search bot",
        url: "http://www.omgili.com/Crawler.html",
        producer: {
            name: "Omgili",
            url: "http://www.omgili.com"
        }
    },
    {
        regex: "OpenindexSpider",
        name: "Openindex Spider",
        category: "Search bot",
        url: "http://www.openindex.io/en/webmasters/spider.html",
        producer: {
            name: "Openindex B.V.",
            url: "http://www.openindex.io"
        }
    },
    {
        regex: "spbot",
        name: "OpenLinkProfiler",
        category: "Crawler",
        url: "http://openlinkprofiler.org/bot",
        producer: {
            name: "Axandra GmbH",
            url: "http://www.axandra.com"
        }
    },
    {
        regex: "OpenWebSpider",
        name: "OpenWebSpider",
        category: "Crawler",
        url: "http://www.openwebspider.org",
        producer: {
            name: "OpenWebSpider Lab",
            url: "http://lab.openwebspider.org"
        }
    },
    {
        regex: "OrangeBot|VoilaBot",
        name: "Orange Bot",
        category: "Search bot",
        url: "http://lemoteur.orange.fr",
        producer: {
            name: "Orange",
            url: "http://www.orange.fr"
        }
    },
    {
        regex: "PaperLiBot",
        name: "PaperLiBot",
        category: "Search bot",
        url: "http://support.paper.li/entries/20023257-what-is-paper-li",
        producer: {
            name: "Smallrivers SA",
            url: "http://www.paper.li"
        }
    },
    {
        regex: "phantomas/",
        name: "Phantomas",
        category: "Site Monitor",
        url: "https://github.com/macbre/phantomas"
    },
    {
        regex: "phpservermon",
        name: "PHP Server Monitor",
        category: "Site Monitor",
        url: "https://github.com/phpservermon/phpservermon",
        producer: {
            name: "PHP Server Monitor",
            url: "http://www.phpservermonitor.org/"
        }
    },
    {
        regex: "PocketParser",
        name: "PocketParser",
        category: "Read-it-later Service",
        url: "https://getpocket.com/pocketparser_ua",
        producer: {
            name: "Pocket",
            url: "https://getpocket.com/"
        }
    },
    {
        regex: "PritTorrent",
        name: "PritTorrent",
        category: "Crawler",
        url: "https://github.com/astro/prittorrent",
        producer: {
            name: "Bitlove",
            url: "http://bitlove.org/"
        }
    },
    {
        regex: "PRTG Network Monitor",
        name: "PRTG Network Monitor",
        category: "Network Monitor",
        url: "https://www.paessler.com/prtg",
        producer: {
            name: "Paessler AG",
            url: "https://www.paessler.com"
        }
    },
    {
        regex: "psbot(-page)?",
        name: "Picsearch bot",
        category: "Search bot",
        url: "http://www.picsearch.com/bot.html",
        producer: {
            name: "Picsearch",
            url: "http://www.picsearch.com"
        }
    },
    {
        regex: "Pingdom(?:\\.com|TMS)",
        name: "Pingdom Bot",
        category: "Site Monitor",
        url: "",
        producer: {
            name: "Pingdom AB",
            url: "https://www.pingdom.com"
        }
    },
    {
        regex: "Quora Link Preview",
        name: "Quora Link Preview",
        category: "Crawler",
        url: "",
        producer: {
            name: "Quora",
            url: "http://www.quora.com"
        }
    },
    {
        regex: "Quora-Bot",
        name: "Quora Bot",
        category: "Crawler",
        url: "",
        producer: {
            name: "Quora",
            url: "https://www.quora.com/"
        }
    },
    {
        regex: "RamblerMail",
        name: "RamblerMail Image Proxy",
        category: "Crawler",
        url: "",
        producer: {
            name: "Rambler&Co",
            url: "https://rambler-co.ru/"
        }
    },
    {
        regex: "QuerySeekerSpider",
        name: "QuerySeekerSpider",
        category: "Crawler",
        url: "http://queryseeker.com/bot.html",
        producer: {
            name: "QueryEye Inc.",
            url: "http://queryeye.com"
        }
    },
    {
        regex: "Qwantify",
        name: "Qwantify",
        category: "Crawler",
        url: "https://www.qwant.com/",
        producer: {
            name: "Qwant Corporation",
            url: "https://www.qwant.com/"
        }
    },
    {
        regex: "Rainmeter",
        name: "Rainmeter",
        category: "Crawler",
        url: "https://www.rainmeter.net"
    },
    {
        regex: "redditbot",
        name: "Reddit Bot",
        category: "Social Media Agent",
        url: "http://www.reddit.com/feedback",
        producer: {
            name: "reddit inc.",
            url: "http://www.reddit.com"
        }
    },
    {
        regex: "Riddler",
        name: "Riddler",
        category: "Security search bot",
        url: "https://riddler.io/about",
        producer: {
            name: "F-Secure",
            url: "https://www.f-secure.com"
        }
    },
    {
        regex: "rogerbot",
        name: "Rogerbot",
        category: "Crawler",
        url: "http://moz.com/help/pro/what-is-rogerbot-",
        producer: {
            name: "SEOmoz, Inc.",
            url: "http://moz.com/"
        }
    },
    {
        regex: "ROI Hunter",
        name: "ROI Hunter",
        category: "Crawler",
        url: "",
        producer: {
            name: "Roihunter a.s.",
            url: "http://roihunter.com/"
        }
    },
    {
        regex: "SafeDNSBot",
        name: "SafeDNSBot",
        category: "Crawler",
        url: "https://www.safedns.com/searchbot",
        producer: {
            name: "SafeDNS, Inc.",
            url: "https://www.safedns.com/"
        }
    },
    {
        regex: "Scrapy",
        name: "Scrapy",
        category: "Crawler",
        url: "http://scrapy.org"
    },
    {
        regex: "Screaming Frog SEO Spider",
        name: "Screaming Frog SEO Spider",
        category: "Crawler",
        url: "http://www.screamingfrog.co.uk/seo-spider",
        producer: {
            name: "Screaming Frog Ltd",
            url: "http://www.screamingfrog.co.uk"
        }
    },
    {
        regex: "ScreenerBot",
        name: "ScreenerBot",
        category: "Crawler",
        url: "http://www.screenerbot.com",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "SemrushBot",
        name: "Semrush Bot",
        category: "Crawler",
        url: "http://www.semrush.com/bot.html",
        producer: {
            name: "SEMrush",
            url: "http://www.semrush.com"
        }
    },
    {
        regex: "SensikaBot",
        name: "Sensika Bot",
        category: "",
        url: "",
        producer: {
            name: "Sensika",
            url: "http://sensika.com"
        }
    },
    {
        regex: "SEOENG(World)?Bot",
        name: "SEOENGBot",
        category: "Crawler",
        url: "http://www.seoengine.com/seoengbot.htm",
        producer: {
            name: "SEO Engine",
            url: "http://www.seoengine.com"
        }
    },
    {
        regex: "SEOkicks-Robot",
        name: "SEOkicks-Robot",
        category: "Crawler",
        url: "http://www.seokicks.de/robot.html",
        producer: {
            name: "SEOkicks",
            url: "https://www.seokicks.de/"
        }
    },
    {
        regex: "seoscanners\\.net",
        name: "Seoscanners.net",
        category: "Crawler",
        url: ""
    },
    {
        regex: "SkypeUriPreview",
        name: "Skype URI Preview",
        category: "Service Agent",
        url: "",
        producer: {
            name: "Skype Communications S.\xe0.r.l.",
            url: "https://www.skype.com"
        }
    },
    {
        regex: "SeznamBot|SklikBot|Seznam screenshot-generator",
        name: "Seznam Bot",
        category: "Search bot",
        url: "http://www.mapy.cz/cz/seznambot.html",
        producer: {
            name: "Seznam.cz, a.s.",
            url: "http://www.seznam.cz/"
        }
    },
    {
        regex: "shopify-partner-homepage-scraper",
        name: "Shopify Partner",
        category: "Crawler",
        url: "https://www.shopify.com/partners",
        producer: {
            name: "Shopify",
            url: "https://www.shopify.com/"
        }
    },
    {
        regex: "ShopWiki",
        name: "ShopWiki",
        category: "Search tools",
        url: "http://www.shopwiki.com/wiki/Help:Bot",
        producer: {
            name: "ShopWiki Corp.",
            url: "http://www.shopwiki.com"
        }
    },
    {
        regex: "SilverReader",
        name: "SilverReader",
        url: "http://silverreader.com",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "SimplePie",
        name: "SimplePie",
        url: "http://www.simplepie.org",
        category: "Feed Parser",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "SISTRIX Crawler",
        name: "SISTRIX Crawler",
        category: "Crawler",
        url: "http://crawler.sistrix.net",
        producer: {
            name: "SISTRIX GmbH",
            url: "http://www.sistrix.de"
        }
    },
    {
        regex: "compatible; (?:SISTRIX )?Optimizer",
        name: "SISTRIX Optimizer",
        category: "Crawler",
        url: "https://optimizer.sistrix.com",
        producer: {
            name: "SISTRIX GmbH",
            url: "http://www.sistrix.de"
        }
    },
    {
        regex: "SiteSucker",
        name: "SiteSucker",
        category: "Crawler",
        url: "http://ricks-apps.com/osx/sitesucker/"
    },
    {
        regex: "sixy.ch",
        name: "Sixy.ch",
        category: "Site Monitor",
        url: "http://sixy.ch",
        producer: {
            name: "Manuel Kasper",
            url: "https://neon1.net/"
        }
    },
    {
        regex: "Slackbot|Slack-ImgProxy",
        name: "Slackbot",
        category: "Crawler",
        url: "https://api.slack.com/robots",
        producer: {
            name: "Slack Technologies",
            url: "http://slack.com"
        }
    },
    {
        regex: "(Sogou (web|inst|Pic) spider)|New-Sogou-Spider",
        name: "Sogou Spider",
        category: "Search bot",
        url: "http://www.sogou.com/docs/help/webmasters.htm",
        producer: {
            name: "Sohu, Inc.",
            url: "http://www.sogou.com"
        }
    },
    {
        regex: "Sosospider|Sosoimagespider",
        name: "Soso Spider",
        category: "Search bot",
        url: "http://help.soso.com/webspider.htm",
        producer: {
            name: "Tencent Holdings",
            url: "http://www.soso.com"
        }
    },
    {
        regex: "Sprinklr",
        name: "Sprinklr",
        category: "Crawler",
        url: "",
        producer: {
            name: "Sprinklr, Inc.",
            url: "https://www.sprinklr.com/"
        }
    },
    {
        regex: "sqlmap/",
        name: "sqlmap",
        category: "Security Checker",
        url: "http://sqlmap.org/",
        producer: {
            name: "sqlmap",
            url: "http://sqlmap.org/"
        }
    },
    {
        regex: "SSL Labs",
        name: "SSL Labs",
        category: "Validator",
        url: "https://www.ssllabs.com/about/assessment.html",
        producer: {
            name: "SSL Labs",
            url: "https://www.ssllabs.com/about/assessment.html"
        }
    },
    {
        regex: "StatusCake",
        name: "StatusCake",
        category: "Site Monitor",
        url: "https://www.statuscake.com",
        producer: {
            name: "StatusCake",
            url: "https://www.statuscake.com"
        }
    },
    {
        regex: "Superfeedr bot",
        name: "Superfeedr Bot",
        category: "Feed Fetcher",
        url: "",
        producer: {
            name: "Superfeedr",
            url: "https://superfeedr.com/"
        }
    },
    {
        regex: "Sparkler/[0-9]",
        name: "Sparkler",
        category: "Crawler",
        url: "https://github.com/USCDataScience/sparkler"
    },
    {
        regex: "Spinn3r",
        name: "Spinn3r",
        category: "Crawler",
        url: "http://spinn3r.com/robot",
        producer: {
            name: "Tailrank Inc",
            url: "http://spinn3r.com"
        }
    },
    {
        regex: "SputnikBot",
        name: "Sputnik Bot",
        category: "Crawler",
        url: ""
    },
    {
        regex: "SputnikFaviconBot",
        name: "Sputnik Favicon Bot",
        category: "Crawler",
        url: ""
    },
    {
        regex: "SputnikImageBot",
        name: "Sputnik Image Bot",
        category: "Crawler",
        url: ""
    },
    {
        regex: "SurveyBot",
        name: "Survey Bot",
        category: "Search bot",
        url: "http://www.domaintools.com/webmasters/surveybot.php",
        producer: {
            name: "Domain Tools",
            url: "http://www.domaintools.com"
        }
    },
    {
        regex: "TarmotGezgin",
        name: "Tarmot Gezgin",
        url: "http://www.tarmot.com/gezgin/",
        category: "Search bot"
    },
    {
        regex: "TelegramBot",
        name: "TelegramBot",
        url: "https://telegram.org/blog/bot-revolution"
    },
    {
        regex: "TLSProbe",
        name: "TLSProbe",
        url: "https://scan.trustnet.venafi.com/",
        category: "Security search bot",
        producer: {
            name: "Venafi TrustNet",
            url: "https://www.venafi.com"
        }
    },
    {
        regex: "TinEye-bot",
        name: "TinEye Crawler",
        category: "Search bot",
        url: "http://www.tineye.com/crawler.html",
        producer: {
            name: "Id\xe9e Inc.",
            url: "http://ideeinc.com"
        }
    },
    {
        regex: "Tiny Tiny RSS",
        name: "Tiny Tiny RSS",
        url: "http://tt-rss.org",
        category: "Feed Fetcher",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "theoldreader.com",
        name: "theoldreader",
        category: "Feed Reader",
        url: "https://theoldreader.com"
    },
    {
        regex: "trendictionbot",
        name: "Trendiction Bot",
        category: "Crawler",
        url: "http://www.trendiction.de/bot",
        producer: {
            name: "Talkwalker Inc.",
            url: "http://www.talkwalker.com"
        }
    },
    {
        regex: "TurnitinBot",
        name: "TurnitinBot",
        category: "Crawler",
        url: "http://www.turnitin.com/robot/crawlerinfo.html",
        producer: {
            name: "iParadigms, LLC.",
            url: "http://www.turnitin.com"
        }
    },
    {
        regex: "TweetedTimes Bot",
        name: "TweetedTimes Bot",
        category: "Crawler",
        url: "http://tweetedtimes.com",
        producer: {
            name: "TweetedTimes",
            url: "http://tweetedtimes.com/"
        }
    },
    {
        regex: "TweetmemeBot",
        name: "Tweetmeme Bot",
        category: "Crawler",
        url: "http://tweetmeme.com/",
        producer: {
            name: "Mediasift",
            url: ""
        }
    },
    {
        regex: "Twingly Recon",
        name: "Twingly Recon",
        category: "Crawler",
        producer: {
            name: "Twingly",
            url: "https://www.twingly.com"
        }
    },
    {
        regex: "Twitterbot",
        name: "Twitterbot",
        category: "Social Media Agent",
        url: "https://dev.twitter.com/docs/cards/getting-started",
        producer: {
            name: "Twitter",
            url: "http://www.twitter.com"
        }
    },
    {
        regex: "UniversalFeedParser",
        name: "UniversalFeedParser",
        category: "Feed Fetcher",
        url: "https://github.com/kurtmckee/feedparser",
        producer: {
            name: "Kurt McKee",
            url: "https://github.com/kurtmckee"
        }
    },
    {
        regex: "via secureurl\\.fwdcdn\\.com",
        name: "UkrNet Mail Proxy",
        category: "Crawler",
        url: "",
        producer: {
            name: "UkrNet Ltd",
            url: "https://www.ukr.net/"
        }
    },
    {
        regex: "Uptimebot",
        name: "Uptimebot",
        category: "Site Monitor",
        url: "https://uptime.com/uptimebot",
        producer: {
            name: "Uptime",
            url: "https://uptime.com"
        }
    },
    {
        regex: "UptimeRobot",
        name: "Uptime Robot",
        category: "Site Monitor",
        url: "",
        producer: {
            name: "Uptime Robot",
            url: "http://uptimerobot.com"
        }
    },
    {
        regex: "URLAppendBot",
        name: "URLAppendBot",
        category: "Crawler",
        url: "http://www.profound.net/urlappendbot.html",
        producer: {
            name: "Profound Networks",
            url: "http://www.profound.net"
        }
    },
    {
        regex: "Vagabondo",
        name: "Vagabondo",
        category: "Crawler",
        url: "",
        producer: {
            name: "WiseGuys",
            url: "http://www.wise-guys.nl/"
        }
    },
    {
        regex: "vkShare; ",
        name: "VK Share Button",
        category: "Crawler",
        url: "http://vk.com/dev/Share",
        producer: {
            name: "VK",
            url: "http://vk.com/"
        }
    },
    {
        regex: "VSMCrawler",
        name: "Visual Site Mapper Crawler",
        category: "Crawler",
        url: "http://www.visualsitemapper.com/crawler",
        producer: {
            name: "Alentum Software Ltd.",
            url: "http://www.alentum.com"
        }
    },
    {
        regex: "Jigsaw",
        name: "W3C CSS Validator",
        category: "Validator",
        url: "http://jigsaw.w3.org/css-validator",
        producer: {
            name: "W3C",
            url: "http://www.w3.org"
        }
    },
    {
        regex: "W3C_I18n-Checker",
        name: "W3C I18N Checker",
        category: "Validator",
        url: "http://validator.w3.org/i18n-checker",
        producer: {
            name: "W3C",
            url: "http://www.w3.org"
        }
    },
    {
        regex: "W3C-checklink",
        name: "W3C Link Checker",
        category: "Validator",
        url: "http://validator.w3.org/checklink",
        producer: {
            name: "W3C",
            url: "http://www.w3.org"
        }
    },
    {
        regex: "W3C_Validator|Validator.nu",
        name: "W3C Markup Validation Service",
        category: "Validator",
        url: "http://validator.w3.org/services",
        producer: {
            name: "W3C",
            url: "http://www.w3.org"
        }
    },
    {
        regex: "W3C-mobileOK",
        name: "W3C MobileOK Checker",
        category: "Validator",
        url: "http://validator.w3.org/mobile",
        producer: {
            name: "W3C",
            url: "http://www.w3.org"
        }
    },
    {
        regex: "W3C_Unicorn",
        name: "W3C Unified Validator",
        category: "Validator",
        url: "http://validator.w3.org/unicorn",
        producer: {
            name: "W3C",
            url: "http://www.w3.org"
        }
    },
    {
        regex: "Wappalyzer",
        name: "Wappalyzer",
        url: "https://github.com/AliasIO/Wappalyzer",
        producer: {
            name: "AliasIO",
            url: "https://github.com/AliasIO"
        }
    },
    {
        regex: "PTST/",
        name: "WebPageTest",
        category: "Site Monitor",
        url: "https://www.webpagetest.org"
    },
    {
        regex: "WeSEE(:Search)?",
        name: "WeSEE:Search",
        category: "Search bot",
        url: "http://www.wesee.com/bot",
        producer: {
            name: "WeSEE Ltd",
            url: "http://www.wesee.com"
        }
    },
    {
        regex: "WebbCrawler",
        name: "WebbCrawler",
        category: "Crawler",
        url: "http://badcheese.com/crawler.html",
        producer: {
            name: "Steve Webb",
            url: "http://badcheese.com"
        }
    },
    {
        regex: "websitepulse[+ ]checker",
        name: "WebSitePulse",
        category: "Site Monitor",
        url: "http://badcheese.com/crawler.html",
        producer: {
            name: "WebSitePulse",
            url: "http://www.websitepulse.com/"
        }
    },
    {
        regex: "WordPress",
        name: "WordPress",
        category: "Service Agent",
        url: "https://wordpress.org/",
        producer: {
            name: "Wordpress.org",
            url: "https://wordpress.org/"
        }
    },
    {
        regex: "Wotbox",
        name: "Wotbox",
        category: "Search bot",
        url: "http://www.wotbox.com/bot/",
        producer: {
            name: "Wotbox",
            url: "http://www.wotbox.com"
        }
    },
    {
        regex: "XenForo",
        name: "XenForo",
        category: "Service Agent",
        url: "https://xenforo.com/",
        producer: {
            name: "XenForo Ltd.",
            url: "https://xenforo.com/"
        }
    },
    {
        regex: "yacybot",
        name: "YaCy",
        category: "Search bot",
        url: "http://yacy.net/bot.html",
        producer: {
            name: "YaCy",
            url: "http://yacy.net"
        }
    },
    {
        regex: "Yahoo! Slurp|Yahoo!-AdCrawler",
        name: "Yahoo! Slurp",
        category: "Search bot",
        url: "http://help.yahoo.com/ysearch/slurp",
        producer: {
            name: "Yahoo! Inc.",
            url: "http://www.yahoo.com"
        }
    },
    {
        regex: "Yahoo Link Preview|Yahoo:LinkExpander:Slingstone",
        name: "Yahoo! Link Preview",
        category: "Crawler",
        url: "https://help.yahoo.com/kb/mail/yahoo-link-preview-SLN23615.html",
        producer: {
            name: "Yahoo! Inc.",
            url: "http://www.yahoo.com"
        }
    },
    {
        regex: "YahooMailProxy",
        name: "Yahoo! Mail Proxy",
        category: "Service Agent",
        url: "https://help.yahoo.com/kb/yahoo-mail-proxy-SLN28749.html",
        producer: {
            name: "Yahoo! Inc.",
            url: "http://www.yahoo.com"
        }
    },
    {
        regex: "YahooCacheSystem",
        name: "Yahoo! Cache System",
        category: "Crawler",
        url: "",
        producer: {
            name: "Yahoo! Inc.",
            url: "http://www.yahoo.com"
        }
    },
    {
        regex: "Y!J-BRW",
        name: "Yahoo! Japan BRW",
        category: "Crawler",
        url: "https://www.yahoo-help.jp/app/answers/detail/p/595/a_id/42716/~/\u30A6\u30A7\u30D6\u30DA\u30FC\u30B8\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u30B7\u30B9\u30C6\u30E0\u306E\u30E6\u30FC\u30B6\u30FC\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u306B\u3064\u3044\u3066",
        producer: {
            name: "Yahoo! Japan Corp.",
            url: "https://www.yahoo.co.jp/"
        }
    },
    {
        regex: "Yandex(SpravBot|ScreenshotBot|MobileBot|AccessibilityBot|ForDomain|Vertis|Market|Catalog|Calendar|Sitelinks|AdNet|Pagechecker|Webmaster|Media|Video|Bot|Images|Antivirus|Direct|Blogs|Favicons|ImageResizer|Verticals|News(links)?|Metrika|\\.Gazeta Bot)|YaDirectFetcher|YandexTurbo|YandexTracker|YandexSearchShop|YandexRCA|YandexPartner|YandexOntoDBAPI|YandexOntoDB|YandexMobileScreenShotBot",
        name: "Yandex Bot",
        category: "Search bot",
        url: "http://www.yandex.com/bots",
        producer: {
            name: "Yandex LLC",
            url: "http://company.yandex.com"
        }
    },
    {
        regex: "Yeti|NaverJapan",
        name: "Yeti/Naverbot",
        category: "Search bot",
        url: "http://help.naver.com/robots/",
        producer: {
            name: "Naver",
            url: "http://www.naver.com"
        }
    },
    {
        regex: "YoudaoBot",
        name: "Youdao Bot",
        category: "Search bot",
        url: "http://www.youdao.com/help/webmaster/spider",
        producer: {
            name: "NetEase, Inc.",
            url: "http://corp.163.com"
        }
    },
    {
        regex: "YOURLS v[0-9]",
        name: "Yourls",
        category: "Crawler",
        url: "http://yourls.org"
    },
    {
        regex: "YRSpider|YYSpider",
        name: "Yunyun Bot",
        category: "Search bot",
        url: "http://www.yunyun.com/SiteInfo.php?r=about",
        producer: {
            name: "YunYun",
            url: "http://www.yunyun.com"
        }
    },
    {
        regex: "zgrab",
        name: "zgrab",
        category: "Security Checker",
        url: "https://github.com/zmap/zgrab"
    },
    {
        regex: "Zookabot",
        name: "Zookabot",
        category: "Crawler",
        url: "http://zookabot.com",
        producer: {
            name: "Hwacha ApS",
            url: "http://hwacha.dk"
        }
    },
    {
        regex: "ZumBot",
        name: "ZumBot",
        category: "Search bot",
        url: "http://help.zum.com/inquiry",
        producer: {
            name: "ZUM internet",
            url: "http://www.zuminternet.com/"
        }
    },
    {
        regex: "YottaaMonitor",
        name: "Yottaa Site Monitor",
        category: "Site Monitor",
        url: "http://www.yottaa.com/products/site-monitor",
        producer: {
            name: "Yottaa",
            url: "http://www.yottaa.com/"
        }
    },
    {
        regex: "Yahoo Ad monitoring.*yahoo-ad-monitoring-SLN24857.*",
        name: "Yahoo Gemini",
        category: "Crawler",
        url: "https://help.yahoo.com/kb/yahoo-ad-monitoring-SLN24857.html",
        producer: {
            name: "Yahoo! Inc.",
            url: "http://www.yahoo.com"
        }
    },
    {
        regex: ".*Java.*outbrain",
        name: "Outbrain",
        category: "Crawler",
        url: "",
        producer: {
            name: "Outbrain",
            url: "http://www.outbrain.com/"
        }
    },
    {
        regex: "HubPages.*crawlingpolicy",
        name: "HubPages",
        category: "Crawler",
        url: "http://hubpages.com/help/crawlingpolicy",
        producer: {
            name: "HubPages",
            url: "http://hubpages.com/"
        }
    },
    {
        regex: "Pinterest(bot)?/\\d\\.\\d.*www\\.pinterest\\.com.*",
        name: "Pinterest",
        url: "http://www.pinterest.com/bot.html",
        category: "Crawler",
        producer: {
            name: "Pinterest",
            url: "http://www.pinterest.com/"
        }
    },
    {
        regex: "Site24x7",
        name: "Site24x7 Website Monitoring",
        category: "Site Monitor",
        url: "https://www.site24x7.com/site24x7-faq.html",
        producer: {
            name: "Site24x7",
            url: "https://www.site24x7.com"
        }
    },
    {
        regex: "s~snapchat-proxy",
        name: "Snapchat Proxy",
        category: "Crawler",
        url: "https://www.snapchat.com",
        producer: {
            name: "Snapchat Inc.",
            url: "https://www.snapchat.com"
        }
    },
    {
        regex: "Let's Encrypt validation server",
        name: "Let's Encrypt Validation",
        category: "Service Agent",
        url: "https://letsencrypt.org/how-it-works/",
        producer: {
            name: "Let's Encrypt",
            url: "https://letsencrypt.org"
        }
    },
    {
        regex: "GrapeshotCrawler",
        name: "Grapeshot",
        category: "Crawler",
        url: "https://www.grapeshot.com/crawler",
        producer: {
            name: "Grapeshot",
            url: "https://www.grapeshot.com"
        }
    },
    {
        regex: "www\\.monitor\\.us",
        name: "Monitor.Us",
        category: "Site Monitor",
        url: "http://www.monitor.us",
        producer: {
            name: "Monitor.Us",
            url: "http://www.monitor.us"
        }
    },
    {
        regex: "Catchpoint( bot)?",
        name: "Catchpoint",
        category: "Site Monitor",
        url: "",
        producer: {
            name: "Catchpoint Systems",
            url: "http://www.catchpoint.com/"
        }
    },
    {
        regex: "bitlybot",
        name: "BitlyBot",
        category: "Crawler",
        url: "https://bitly.com",
        producer: {
            name: "Bitly, Inc.",
            url: "https://bitly.com"
        }
    },
    {
        regex: "Zao/",
        name: "Zao",
        category: "Crawler"
    },
    {
        regex: "lycos",
        name: "Lycos"
    },
    {
        regex: "Slurp",
        name: "Inktomi Slurp"
    },
    {
        regex: "Speedy Spider",
        name: "Speedy"
    },
    {
        regex: "ScoutJet",
        name: "ScoutJet"
    },
    {
        regex: "nrsbot|netresearch",
        name: "NetResearchServer"
    },
    {
        regex: "scooter",
        name: "Scooter"
    },
    {
        regex: "gigabot",
        name: "Gigabot"
    },
    {
        regex: "charlotte",
        name: "Charlotte"
    },
    {
        regex: "Pompos",
        name: "Pompos"
    },
    {
        regex: "ichiro",
        name: "ichiro"
    },
    {
        regex: "PagePeeker",
        name: "PagePeeker"
    },
    {
        regex: "WebThumbnail",
        name: "WebThumbnail"
    },
    {
        regex: "Willow Internet Crawler",
        name: "Willow Internet Crawler"
    },
    {
        regex: "EmailWolf",
        name: "EmailWolf"
    },
    {
        regex: "NetLyzer FastProbe",
        name: "NetLyzer FastProbe"
    },
    {
        regex: "AdMantX.*admantx\\.com",
        name: "ADMantX"
    },
    {
        regex: "Server Density Service Monitoring.*",
        name: "Server Density"
    },
    {
        regex: "RSSRadio \\(Push Notification Scanner;support@dorada\\.co\\.uk\\)",
        name: "RSSRadio Bot"
    },
    {
        regex: "(A6-Indexer|nuhk|TsolCrawler|Yammybot|Openbot|Gulper Web Bot|grub-client|Download Demon|SearchExpress|Microsoft URL Control|borg|altavista|dataminr.com|tweetedtimes.com|TrendsmapResolver|teoma|blitzbot|oegp|furlbot|http%20client|polybot|htdig|mogimogi|larbin|scrubby|searchsight|seekbot|semanticdiscovery|snappy|vortex(?! Build)|zeal|fast-webcrawler|converacrawler|dataparksearch|findlinks|BrowserMob|HttpMonitor|ThumbShotsBot|URL2PNG|ZooShot|GomezA|Google SketchUp|Read%20Later|RackspaceBot|robots|SeopultContentAnalyzer|7Siters|centuryb.o.t9|InterNaetBoten|EasyBib AutoCite|Bidtellect|tomnomnom/meg)",
        name: "Generic Bot"
    },
    {
        regex: "^sentry",
        name: "Sentry Bot",
        producer: {
            name: "Sentry",
            url: "https://sentry.io"
        }
    },
    {
        regex: "^Spotify",
        name: "Spotify",
        producer: {
            name: "Spotify",
            url: "https://www.spotify.com"
        }
    },
    {
        regex: "The Knowledge AI",
        name: "The Knowledge AI",
        category: "Crawler"
    },
    {
        regex: "Embedly",
        name: "Embedly",
        category: "Crawler",
        url: "https://support.embed.ly/hc/en-us",
        producer: {
            name: "A Medium, Corp.",
            url: "https://medium.com/"
        }
    },
    {
        regex: "BrandVerity",
        name: "BrandVerity",
        category: "Crawler",
        url: "https://www.brandverity.com/why-is-brandverity-visiting-me",
        producer: {
            name: "BrandVerity, Inc.",
            url: "https://www.brandverity.com/"
        }
    },
    {
        regex: "Kaspersky Lab CFR link resolver",
        name: "Kaspersky",
        category: "Security Checker",
        url: "https://www.kaspersky.com/",
        producer: {
            name: "AO Kaspersky Lab",
            url: "https://www.kaspersky.com/"
        }
    },
    {
        regex: "eZ Publish Link Validator",
        name: "eZ Publish Link Validator",
        category: "Crawler",
        url: "https://ez.no/",
        producer: {
            name: "eZ Systems AS",
            url: "https://ez.no/"
        }
    },
    {
        regex: "woorankreview",
        name: "WooRank",
        category: "Search bot",
        url: "https://www.woorank.com/",
        producer: {
            name: "WooRank sprl",
            url: "https://www.woorank.com/"
        }
    },
    {
        regex: "(Match|LinkCheck) by Siteimprove.com",
        name: "Siteimprove",
        category: "Search bot",
        url: "https://siteimprove.com/",
        producer: {
            name: "Siteimprove GmbH",
            url: "https://siteimprove.com/"
        }
    },
    {
        regex: "CATExplorador",
        name: "CATExplorador",
        category: "Search bot",
        url: "https://fundacio.cat/ca/domini/",
        producer: {
            name: "Fundaci\xf3 puntCAT",
            url: "https://fundacio.cat/ca/domini/"
        }
    },
    {
        regex: "Buck",
        name: "Buck",
        category: "Search bot",
        url: "https://hypefactors.com/",
        producer: {
            name: "Hypefactors A/S",
            url: "https://hypefactors.com/"
        }
    },
    {
        regex: "tracemyfile",
        name: "TraceMyFile",
        category: "Search bot",
        url: "https://www.tracemyfile.com/",
        producer: {
            name: "Idee Inc.",
            url: "http://ideeinc.com/"
        }
    },
    {
        regex: "zelist.ro feed parser",
        name: "Ze List",
        url: "https://www.zelist.ro/",
        category: "Feed Fetcher",
        producer: {
            name: "Treeworks SRL",
            url: "https://www.tree.ro/"
        }
    },
    {
        regex: "weborama-fetcher",
        name: "Weborama",
        category: "Search bot",
        url: "https://weborama.com/",
        producer: {
            name: "Weborama SA",
            url: "https://weborama.com/"
        }
    },
    {
        regex: "BoardReader Favicon Fetcher",
        name: "BoardReader",
        category: "Search bot",
        url: "https://boardreader.com/",
        producer: {
            name: "Effyis Inc",
            url: "https://boardreader.com/"
        }
    },
    {
        regex: "IDG/IT",
        name: "IDG/IT",
        category: "Search bot",
        url: "https://spaziodati.eu/",
        producer: {
            name: "SpazioDati S.r.l.",
            url: "https://spaziodati.eu/"
        }
    },
    {
        regex: "Bytespider",
        name: "Bytespider",
        category: "Search bot",
        url: "https://bytedance.com/",
        producer: {
            name: "ByteDance Ltd.",
            url: "https://bytedance.com/"
        }
    },
    {
        regex: "WikiDo",
        name: "WikiDo",
        category: "Search bot",
        url: "https://www.wikido.com/",
        producer: {
            name: "Fotolitografie Fiorentine di Becchi Antonio s.n.c.",
            url: "https://www.wikido.com/"
        }
    },
    {
        regex: "AwarioSmartBot",
        name: "Awario",
        category: "Search bot",
        url: "https://awario.com/bots.html",
        producer: {
            name: "Awario",
            url: "https://awario.com/"
        }
    },
    {
        regex: "AwarioRssBot",
        name: "Awario",
        category: "Feed Fetcher",
        url: "https://awario.com/bots.html",
        producer: {
            name: "Awario",
            url: "https://awario.com/"
        }
    },
    {
        regex: "oBot",
        name: "oBot",
        category: "Search bot",
        url: "https://www.xforce-security.com/crawler/",
        producer: {
            name: "IBM Germany Research & Development GmbH",
            url: "https://exchange.xforce.ibmcloud.com/"
        }
    },
    {
        regex: "SMTBot",
        name: "SMTBot",
        category: "Search bot",
        url: "https://www.similartech.com/smtbot",
        producer: {
            name: "SimilarTech Ltd.",
            url: "https://www.similartech.com/"
        }
    },
    {
        regex: "LCC",
        name: "LCC",
        category: "Search bot",
        url: "https://corpora.uni-leipzig.de/crawler_faq.html",
        producer: {
            name: "Universit\xe4t Leipzig",
            url: "https://www.uni-leipzig.de/"
        }
    },
    {
        regex: "Startpagina-Linkchecker",
        name: "Startpagina Linkchecker",
        category: "Search bot",
        url: "https://www.startpagina.nl/linkchecker",
        producer: {
            name: "Startpagina B.V.",
            url: "https://www.startpagina.nl/"
        }
    },
    {
        regex: "GTmetrix",
        name: "GTmetrix",
        category: "Crawler",
        url: "https://gtmetrix.com/",
        producer: {
            name: "Carbon60 Operating Co. Ltd.",
            url: "https://www.carbon60.com/"
        }
    },
    {
        regex: "Nutch",
        name: "Nutch-based Bot",
        category: "Crawler",
        url: "https://nutch.apache.org",
        producer: {
            name: "The Apache Software Foundation",
            url: "https://www.apache.org/foundation/"
        }
    },
    {
        regex: "Seobility",
        name: "Seobility",
        category: "Crawler",
        url: "https://www.seobility.net/en/faq/?category=crawling#!aboutourbot"
    },
    {
        regex: "Vercelbot",
        name: "Vercel Bot",
        category: "Service bot",
        url: "https://vercel.com"
    },
    {
        regex: "Grammarly",
        name: "Grammarly",
        category: "Service bot",
        url: "https://www.grammarly.com"
    },
    {
        regex: "Robozilla",
        name: "Robozilla",
        category: "Crawler"
    },
    {
        regex: "Domains Project",
        name: "Domains Project",
        category: "Crawler",
        url: "https://domainsproject.org"
    },
    {
        regex: "PetalBot",
        name: "Petal Bot",
        category: "Crawler",
        url: "https://aspiegel.com/petalbot"
    },
    {
        regex: "SerendeputyBot",
        name: "Serendeputy Bot",
        category: "Crawler",
        url: "https://serendeputy.com/about/serendeputy-bot"
    },
    {
        regex: "ias-va.*admantx.*service-fetcher",
        name: "ADmantX Service Fetcher",
        category: "Service bot",
        url: "https://www.admantx.com/service-fetcher.html"
    },
    {
        regex: "SemanticScholarBot",
        name: "Semantic Scholar Bot",
        category: "Crawler",
        url: "https://www.semanticscholar.org/crawler"
    },
    {
        regex: "VelenPublicWebCrawler",
        name: "Velen Public Web Crawler",
        category: "Crawler",
        url: "https://hunter.io/robot"
    },
    {
        regex: "Barkrowler",
        name: "Barkrowler",
        category: "Crawler",
        url: "http://www.exensa.com/crawl"
    },
    {
        regex: "BDCbot",
        name: "BDCbot",
        category: "Crawler",
        url: "https://bigweb.bigdatacorp.com.br/pages/faq.aspx",
        producer: {
            name: "BIG Data Solucoes Em Tecnologia de Informatica LTDA",
            url: "https://bigdatacorp.com.br/"
        }
    },
    {
        regex: "adbeat",
        name: "Adbeat",
        category: "Crawler",
        url: "https://www.adbeat.com/operation_policy",
        producer: {
            name: "PPC Labs LLC",
            url: "https://www.adbeat.com/"
        }
    },
    {
        regex: "BW/(?:(\\d+[\\.\\d]+))",
        name: "BuiltWith",
        category: "Crawler",
        url: "https://builtwith.com/biup",
        producer: {
            name: "BuiltWith Pty Ltd",
            url: "https://builtwith.com/"
        }
    },
    {
        regex: "https://whatis.contentkingapp.com",
        name: "ContentKing",
        category: "Site Monitor",
        url: "https://whatis.contentkingapp.com/",
        producer: {
            name: "ContentKing BV",
            url: "https://www.contentkingapp.com/"
        }
    },
    {
        regex: "MicroAdBot",
        name: "MicroAdBot",
        category: "Crawler",
        url: "https://www.microad.co.jp/",
        producer: {
            name: "MicroAd, Inc.",
            url: "https://www.microad.co.jp/"
        }
    },
    {
        regex: "PingAdmin.Ru",
        name: "PingAdmin.Ru",
        category: "Site Monitor",
        url: "https://ping-admin.ru/"
    },
    {
        regex: "notifyninja.+monitoring",
        name: "Notify Ninja",
        category: "Site Monitor",
        url: "http://notifyninja.com"
    },
    {
        regex: "WebDataStats",
        name: "WebDataStats",
        category: "Crawler",
        url: "https://webdatastats.com/policy.html",
        producer: {
            name: "WebTehRazrabotka LLC",
            url: "https://webdatastats.com/"
        }
    },
    {
        regex: "parse.ly scraper",
        name: "parse.ly",
        category: "Crawler",
        url: "https://www.parse.ly/help/integration/crawler",
        producer: {
            name: "Parsely, Inc.",
            url: "https://www.parse.ly/"
        }
    },
    {
        regex: "Nimbostratus-Bot",
        name: "Nimbostratus Bot",
        category: "Site Monitor",
        url: "http://cloudsystemnetworks.com"
    },
    {
        regex: "HeartRails_Capture/\\d",
        name: "Heart Rails Capture",
        category: "Service Agent",
        url: "http://capture.heartrails.com"
    },
    {
        regex: "Project-Resonance",
        name: "Project Resonance",
        category: "Crawler",
        url: "http://project-resonance.com"
    },
    {
        regex: "DataXu/\\d",
        name: "DataXu",
        category: "Service Agent",
        url: "https://advertising.roku.com/dataxu",
        producer: {
            name: "Roku, Inc.",
            url: "https://roku.com"
        }
    },
    {
        regex: "Cocolyzebot",
        name: "Cocolyzebot",
        category: "Crawler",
        url: "https://cocolyze.com/en/cocolyzebot",
        producer: {
            name: "VSI INNOVATION SAS",
            url: "https://vsi-innovation.com/"
        }
    },
    {
        regex: "veryhip",
        name: "VeryHip",
        category: "Crawler",
        url: "https://veryhip.com/",
        producer: {
            name: "VeryHip",
            url: "https://veryhip.com/"
        }
    },
    {
        regex: "LinkpadBot",
        name: "LinkpadBot",
        category: "Crawler",
        url: "https://www.linkpad.org/",
        producer: {
            name: "Solomono LLC",
            url: "https://www.linkpad.org/"
        }
    },
    {
        regex: "MuscatFerret",
        name: "MuscatFerret",
        category: "Crawler",
        url: "http://www.webtop.com/"
    },
    {
        regex: "PageThing.com",
        name: "PageThing",
        category: "Crawler",
        url: "https://www.pagething.com/",
        producer: {
            name: "SPECIALNOISE LTD",
            url: "https://www.specialnoise.com/"
        }
    },
    {
        regex: "ArchiveBox",
        name: "ArchiveBox",
        url: "https://archivebox.io/",
        category: "Crawler",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "Choosito",
        name: "Choosito",
        url: "https://www.choosito.com/",
        category: "Crawler",
        producer: {
            name: "Choosito! Inc.",
            url: "https://www.choosito.com/"
        }
    },
    {
        regex: "datagnionbot",
        name: "datagnionbot",
        url: "https://www.datagnion.com/bot.html",
        category: "Crawler",
        producer: {
            name: "DATAGNION GMBH",
            url: "https://www.datagnion.com/"
        }
    },
    {
        regex: "WhatCMS",
        name: "WhatCMS",
        url: "https://whatcms.org/",
        category: "Crawler",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "httpx",
        name: "httpx",
        url: "https://github.com/projectdiscovery/httpx",
        category: "Crawler",
        producer: {
            name: "",
            url: ""
        }
    },
    {
        regex: "scaninfo@expanseinc.com",
        name: "Expanse",
        category: "Security Checker",
        url: "https://expanse.co/",
        producer: {
            name: "Expanse Inc.",
            url: "https://expanse.co/"
        }
    },
    {
        regex: "HuaweiWebCatBot",
        name: "HuaweiWebCatBot",
        category: "Crawler",
        url: "https://isecurity.huawei.com",
        producer: {
            name: "Huawei Technologies Co., Ltd.",
            url: "https://huawei.com"
        }
    },
    {
        regex: "Hatena-Favicon",
        name: "Hatena Favicon",
        category: "Crawler",
        url: "https://www.hatena.ne.jp/faq/",
        producer: {
            name: "Hatena Co., Ltd.",
            url: "https://www.hatena.ne.jp"
        }
    },
    {
        regex: "RyowlEngine/(\\d+)",
        name: "Ryowl",
        category: "Crawler",
        url: "https://ryowl.org"
    },
    {
        regex: "OdklBot/(\\d+)",
        name: "Odnoklassniki Bot",
        category: "Crawler",
        url: "https://odnoklassniki.ru"
    },
    {
        regex: "Mediatoolkitbot",
        name: "Mediatoolkit Bot",
        category: "Crawler",
        url: "https://mediatoolkit.com"
    },
    {
        regex: "ZoominfoBot",
        name: "ZoominfoBot",
        category: "Crawler",
        url: "https://www.zoominfo.com"
    },
    {
        regex: "WeViKaBot/([\\d+\\.])",
        name: "WeViKaBot",
        category: "Crawler",
        url: "http://www.wevika.de"
    },
    {
        regex: "SEOkicks",
        name: "SEOkicks",
        category: "Crawler",
        url: "https://www.seokicks.de/robot.html"
    },
    {
        regex: "Plukkie/([\\d+\\.])",
        name: "Plukkie",
        category: "Crawler",
        url: "http://www.botje.com/plukkie.htm"
    },
    {
        regex: "proximic;",
        name: "Comscore",
        category: "Crawler",
        url: "https://www.comscore.com/Web-Crawler"
    },
    {
        regex: "SurdotlyBot/([\\d+\\.])",
        name: "SurdotlyBot",
        category: "Crawler",
        url: "http://sur.ly/bot.html"
    },
    {
        regex: "Gowikibot/([\\d+\\.])",
        name: "Gowikibot",
        category: "Crawler",
        url: "http:/www.gowikibot.com"
    },
    {
        regex: "SabsimBot/([\\d+\\.])",
        name: "SabsimBot",
        category: "Crawler",
        url: "https://sabsim.com"
    },
    {
        regex: "LumtelBot/([\\d+\\.])",
        name: "LumtelBot",
        category: "Crawler",
        url: "https://umtel.com"
    },
    {
        regex: "PiplBot",
        name: "PiplBot",
        category: "Crawler",
        url: "http://www.pipl.com/bot"
    },
    {
        regex: "woobot/([\\d+\\.])",
        name: "WooRank",
        category: "Crawler",
        url: "https://www.woorank.com/bot"
    },
    {
        regex: "[a-z0-9\\-_]*((?<!cu|power[ _]|m[ _])bot(?![ _]TAB|[ _]?5[0-9])|crawler|crawl|checker|archiver|transcoder|spider)([^a-z]|$)",
        name: "Generic Bot"
    }
]), $cdf7e442067abc24$var$_n = $cdf7e442067abc24$var$nl;
var $cdf7e442067abc24$var$yn = class {
    constructor(){
        this.parse = (e)=>{
            var r;
            for (const o of $cdf7e442067abc24$var$Tn.default)if ($cdf7e442067abc24$var$_n.userAgentParser(o.regex, e)) return {
                name: o.name,
                category: o.category || "",
                url: o.url || "",
                producer: {
                    name: (null == (r = null == (r = o) ? void 0 : r.producer) ? void 0 : r.name) || "",
                    url: (null == (r = null == (r = o) ? void 0 : r.producer) ? void 0 : r.url) || ""
                }
            };
            return null;
        };
    }
}, $cdf7e442067abc24$var$wn = {}, $cdf7e442067abc24$var$Gn = (Object.defineProperty($cdf7e442067abc24$var$wn, "__esModule", {
    value: !0
}), $cdf7e442067abc24$var$wn.versionCompare = (e, r, o)=>{
    let t;
    var a;
    let l = 0;
    const i = {
        dev: -6,
        alpha: -5,
        a: -5,
        beta: -4,
        b: -4,
        RC: -3,
        rc: -3,
        "#": -2,
        p: 1,
        pl: 1
    };
    var n = (e)=>(e = (e = ("" + e).replace(/[_\-+]/g, ".")).replace(/([^.\d]+)/g, ".$1.").replace(/\.{2,}/g, ".")).length ? e.split(".") : [
            -8
        ], d = (e)=>e ? isNaN(e) ? i[e] || -7 : parseInt(e, 10) : 0;
    for(e = n(e), r = n(r), a = Math.max(e.length, r.length), t = 0; t < a; t++)if (e[t] !== r[t]) {
        if (e[t] = d(e[t]), r[t] = d(r[t]), e[t] < r[t]) {
            l = -1;
            break;
        }
        if (e[t] > r[t]) {
            l = 1;
            break;
        }
    }
    if (!o) return l;
    switch(o){
        case ">":
        case "gt":
            return 0 < l;
        case ">=":
        case "ge":
            return 0 <= l;
        case "<=":
        case "le":
            return l <= 0;
        case "===":
        case "=":
        case "eq":
            return 0 === l;
        case "<>":
        case "!==":
        case "ne":
            return 0 !== l;
        case "":
        case "<":
        case "lt":
            return l < 0;
        default:
            return null;
    }
}, $cdf7e442067abc24$var$zo && $cdf7e442067abc24$var$zo.__importDefault || function(e) {
    return e && e.__esModule ? e : {
        default: e
    };
});
const $cdf7e442067abc24$var$Ln = $cdf7e442067abc24$var$Gn($cdf7e442067abc24$var$rl), $cdf7e442067abc24$var$Cn = $cdf7e442067abc24$var$Gn($cdf7e442067abc24$var$ai), $cdf7e442067abc24$var$Bn = $cdf7e442067abc24$var$Gn($cdf7e442067abc24$var$nn), $cdf7e442067abc24$var$En = $cdf7e442067abc24$var$Gn($cdf7e442067abc24$var$$n), $cdf7e442067abc24$var$Nn = $cdf7e442067abc24$var$Gn($cdf7e442067abc24$var$ol), $cdf7e442067abc24$var$On = $cdf7e442067abc24$var$yn, $cdf7e442067abc24$var$In = $cdf7e442067abc24$var$nl, $cdf7e442067abc24$var$kn = $cdf7e442067abc24$var$wn;
class $cdf7e442067abc24$var$Xn {
    constructor(e){
        this.options = {
            skipBotDetection: !1,
            versionTruncation: 1
        }, this.parse = (e)=>{
            var r = {
                client: this.clientParser.parse(e),
                os: this.operatingSystemParser.parse(e),
                device: this.deviceParser.parse(e),
                bot: this.options.skipBotDetection ? null : this.botParser.parse(e)
            }, o = null == (o = r.os) ? void 0 : o.name, t = null == (t = r.os) ? void 0 : t.version, a = $cdf7e442067abc24$var$Bn.default.getOsFamily(o || ""), l = (null != (l = r.device) && l.brand || (l = this.vendorFragmentParser.parse(e)) && (r.device || (r.device = this.createDeviceObject()), r.device.brand = l), null != (l = r.device) && l.brand || ![
                "Apple TV",
                "watchOS",
                "iOS",
                "Mac"
            ].includes(o || "") || (r.device || (r.device = this.createDeviceObject()), r.device.brand = "Apple"), null != (l = r.device) && l.type || "Android" !== a || !$cdf7e442067abc24$var$In.userAgentParser("Chrome/[\\.0-9]*", e) || ($cdf7e442067abc24$var$In.userAgentParser("Chrome/[.0-9]* (?:Mobile|eliboM)", e) ? (r.device || (r.device = this.createDeviceObject()), r.device.type = "smartphone") : $cdf7e442067abc24$var$In.userAgentParser("Chrome/[.0-9]* (?!Mobile)", e) && (r.device || (r.device = this.createDeviceObject()), r.device.type = "tablet")), (null != (l = r.device) && l.type || !this.hasAndroidTabletFragment(e)) && !$cdf7e442067abc24$var$In.userAgentParser("Opera Tablet", e) || (r.device || (r.device = this.createDeviceObject()), r.device.type = "tablet"), null != (l = r.device) && l.type || !this.hasAndroidMobileFragment(e) || (r.device || (r.device = this.createDeviceObject()), r.device.type = "smartphone"), null != (l = r.device) && l.type || "Android" !== o || "" === t || (-1 === $cdf7e442067abc24$var$kn.versionCompare(t, "2.0") ? (r.device || (r.device = this.createDeviceObject()), r.device.type = "smartphone") : 0 <= $cdf7e442067abc24$var$kn.versionCompare(t, "3.0") && -1 === $cdf7e442067abc24$var$kn.versionCompare(t, "4.0") && (r.device || (r.device = this.createDeviceObject()), r.device.type = "tablet")), "feature phone" === (null == (l = r.device) ? void 0 : l.type) && "Android" === a && (r.device.type = "smartphone"), null != (l = r.device) && l.type || !this.isToucheEnabled(e) || !("Windows RT" === o || "Windows" === o && 0 <= $cdf7e442067abc24$var$kn.versionCompare(t, "8.0")) || (r.device || (r.device = this.createDeviceObject()), r.device.type = "tablet"), $cdf7e442067abc24$var$In.userAgentParser("Opera TV Store", e) && (r.device || (r.device = this.createDeviceObject()), r.device.type = "television"), $cdf7e442067abc24$var$In.userAgentParser("SmartTV|Tizen.+ TV .+$", e) && (r.device || (r.device = this.createDeviceObject()), r.device.type = "television"), null != (l = r.device) && l.type || ![
                "Kylo",
                "Espial TV Browser"
            ].includes((null == (o = r.client) ? void 0 : o.name) || "") || (r.device || (r.device = this.createDeviceObject()), r.device.type = "television"), "desktop" !== (null == (t = r.device) ? void 0 : t.type) && null !== $cdf7e442067abc24$var$In.userAgentParser("Desktop", e) && this.hasDesktopFragment(e));
            return l && (r.device || (r.device = this.createDeviceObject()), r.device.type = "desktop"), null != (o = r.device) && o.type || !this.isDesktop(r, a) || (r.device || (r.device = this.createDeviceObject()), r.device.type = "desktop"), r;
        }, this.hasAndroidMobileFragment = (e)=>$cdf7e442067abc24$var$In.userAgentParser("Android( [.0-9]+)?; Mobile;", e), this.hasAndroidTabletFragment = (e)=>$cdf7e442067abc24$var$In.userAgentParser("Android( [.0-9]+)?; Tablet;", e), this.hasDesktopFragment = (e)=>$cdf7e442067abc24$var$In.userAgentParser("Desktop (x(?:32|64)|WOW64);", e), this.isDesktop = (e, r)=>!!e.os && !this.usesMobileBrowser(e.client) && $cdf7e442067abc24$var$Bn.default.getDesktopOsArray().includes(r), this.usesMobileBrowser = (e)=>{
            var r;
            return !!e && "browser" === (null == (r = e) ? void 0 : r.type) && $cdf7e442067abc24$var$Nn.default.isMobileOnlyBrowser(null == (r = e) ? void 0 : r.name);
        }, this.isToucheEnabled = (e)=>$cdf7e442067abc24$var$In.userAgentParser("Touch", e), this.createDeviceObject = ()=>({
                type: "",
                brand: "",
                model: ""
            }), this.options = Object.assign(Object.assign({}, this.options), e), this.clientParser = new $cdf7e442067abc24$var$Ln.default(this.options), this.deviceParser = new $cdf7e442067abc24$var$Cn.default, this.operatingSystemParser = new $cdf7e442067abc24$var$Bn.default(this.options), this.vendorFragmentParser = new $cdf7e442067abc24$var$En.default, this.botParser = new $cdf7e442067abc24$var$On;
    }
}
var $cdf7e442067abc24$var$Dn, $cdf7e442067abc24$var$Rn, $cdf7e442067abc24$var$Fn, $cdf7e442067abc24$var$Vn, $cdf7e442067abc24$var$Hn = function(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}($cdf7e442067abc24$var$Xn);
let $cdf7e442067abc24$var$Un, $cdf7e442067abc24$var$Kn = "00:00";
const $cdf7e442067abc24$var$Wn = 1;
let $cdf7e442067abc24$var$Zn;
function $cdf7e442067abc24$var$Qn(e, r, o) {
    $cdf7e442067abc24$var$Jn.start().then(()=>{
        e && e(!0), $cdf7e442067abc24$var$Un = new Date, function(e) {
            $cdf7e442067abc24$var$Kn = "00:00", e($cdf7e442067abc24$var$Kn), $cdf7e442067abc24$var$Zn = setInterval(()=>{
                $cdf7e442067abc24$var$Kn = function(e) {
                    e = (new Date).getTime() - e.getTime();
                    var r = (e /= 1e3, Math.floor(e % 60)), o = (e = Math.floor(e / 60)) % 60, t = (e = Math.floor(e / 60)) % 24;
                    e = e = Math.floor(e / 24), t += 24 * e;
                    return 0 == t ? $cdf7e442067abc24$var$Yn(o, 2) + ":" + $cdf7e442067abc24$var$Yn(r, 2) : $cdf7e442067abc24$var$Yn(t, 2) + ":" + $cdf7e442067abc24$var$Yn(o, 2) + ":" + $cdf7e442067abc24$var$Yn(r, 2);
                }($cdf7e442067abc24$var$Un), e($cdf7e442067abc24$var$Kn), function() {
                    var e = $cdf7e442067abc24$var$Kn.split(":"), r = "0" + $cdf7e442067abc24$var$Wn;
                    return 3 === e.length && e[0] === r;
                }() && $cdf7e442067abc24$var$zn(null);
            }, 1e3);
        }(o);
    }).catch((e)=>{
        switch(e.message.includes("mediaDevices API or getUserMedia method is not supported in this browser.") && r && r(!0), console.log(e), e.name){
            case "AbortError":
                console.log("An AbortError has occurred.");
                break;
            case "NotAllowedError":
                console.log("A NotAllowedError has occurred. User might have denied permission.");
                break;
            case "NotFoundError":
                console.log("A NotFoundError has occurred.");
                break;
            case "NotReadableError":
                console.log("A NotReadableError has occurred.");
                break;
            case "SecurityError":
                console.log("A SecurityError has occurred.");
                break;
            case "TypeError":
                console.log("A TypeError has occurred.");
                break;
            case "InvalidStateError":
                console.log("An InvalidStateError has occurred.");
                break;
            case "UnknownError":
                console.log("An UnknownError has occurred.");
                break;
            default:
                console.log("An error occurred with the error name " + e.name);
        }
    });
}
function $cdf7e442067abc24$var$zn(e) {
    $cdf7e442067abc24$var$Jn.stop().then((r)=>{
        clearInterval($cdf7e442067abc24$var$Zn), e && e(r);
    }).catch((e)=>{
        "InvalidStateError" === e.name ? console.log("An InvalidStateError has occurred.") : console.log("An error occurred with the error name " + e.name);
    });
}
function $cdf7e442067abc24$var$Yn(e, r) {
    return ("" + e).padStart(r, "0");
}
const $cdf7e442067abc24$var$Jn = {
    audioBlobs: [],
    mediaRecorder: null,
    streamBeingCaptured: null,
    start: function() {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            var e = new $cdf7e442067abc24$var$Hn, r = navigator.userAgent;
            const o = "Mobile Safari" === e.parse(r).client?.name;
            return navigator.mediaDevices.getUserMedia({
                audio: !0
            }).then((e)=>{
                $cdf7e442067abc24$var$Jn.streamBeingCaptured = e, $cdf7e442067abc24$var$Jn.mediaRecorder = new MediaRecorder(e), $cdf7e442067abc24$var$Jn.audioBlobs = [], $cdf7e442067abc24$var$Jn.mediaRecorder.addEventListener("dataavailable", (e)=>{
                    $cdf7e442067abc24$var$Jn.audioBlobs.push(e.data);
                }), o ? $cdf7e442067abc24$var$Jn.mediaRecorder.start(1e3) : $cdf7e442067abc24$var$Jn.mediaRecorder.start();
            });
        }
        return Promise.reject(new Error("mediaDevices API or getUserMedia method is not supported in this browser."));
    },
    stop: function() {
        return new Promise((e)=>{
            const r = $cdf7e442067abc24$var$Jn.mediaRecorder?.mimeType;
            $cdf7e442067abc24$var$Jn.mediaRecorder?.addEventListener("stop", ()=>{
                var o = new Blob($cdf7e442067abc24$var$Jn.audioBlobs, {
                    type: r
                });
                e(o);
            }), $cdf7e442067abc24$var$Jn.cancel();
        });
    },
    cancel: function() {
        $cdf7e442067abc24$var$Jn.mediaRecorder?.stop(), $cdf7e442067abc24$var$Jn.stopStream(), $cdf7e442067abc24$var$Jn.resetRecordingProperties();
    },
    stopStream: function() {
        $cdf7e442067abc24$var$Jn.streamBeingCaptured?.getTracks().forEach((e)=>e.stop());
    },
    resetRecordingProperties: function() {
        $cdf7e442067abc24$var$Jn.mediaRecorder = null, $cdf7e442067abc24$var$Jn.streamBeingCaptured = null;
    }
}, $cdf7e442067abc24$var$jn = (($cdf7e442067abc24$var$rd = $cdf7e442067abc24$var$Dn = $cdf7e442067abc24$var$Dn || {}).assertEqual = (e)=>e, $cdf7e442067abc24$var$rd.assertIs = function(e) {}, $cdf7e442067abc24$var$rd.assertNever = function(e) {
    throw new Error;
}, $cdf7e442067abc24$var$rd.arrayToEnum = (e)=>{
    var r = {};
    for (const o of e)r[o] = o;
    return r;
}, $cdf7e442067abc24$var$rd.getValidEnumValues = (e)=>{
    var r = {};
    for (const o of $cdf7e442067abc24$var$rd.objectKeys(e).filter((r)=>"number" != typeof e[e[r]]))r[o] = e[o];
    return $cdf7e442067abc24$var$rd.objectValues(r);
}, $cdf7e442067abc24$var$rd.objectValues = (e)=>$cdf7e442067abc24$var$rd.objectKeys(e).map(function(r) {
        return e[r];
    }), $cdf7e442067abc24$var$rd.objectKeys = "function" == typeof Object.keys ? (e)=>Object.keys(e) : (e)=>{
    var r = [];
    for(const o in e)Object.prototype.hasOwnProperty.call(e, o) && r.push(o);
    return r;
}, $cdf7e442067abc24$var$rd.find = (e, r)=>{
    for (const o of e)if (r(o)) return o;
}, $cdf7e442067abc24$var$rd.isInteger = "function" == typeof Number.isInteger ? (e)=>Number.isInteger(e) : (e)=>"number" == typeof e && isFinite(e) && Math.floor(e) === e, $cdf7e442067abc24$var$rd.joinValues = function(e, r = " | ") {
    return e.map((e)=>"string" == typeof e ? `'${e}'` : e).join(r);
}, $cdf7e442067abc24$var$rd.jsonStringifyReplacer = (e, r)=>"bigint" == typeof r ? r.toString() : r, ($cdf7e442067abc24$var$Rn || ($cdf7e442067abc24$var$Rn = {})).mergeShapes = (e, r)=>({
        ...e,
        ...r
    }), $cdf7e442067abc24$var$Dn.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
])), $cdf7e442067abc24$var$qn = (e)=>{
    switch(typeof e){
        case "undefined":
            return $cdf7e442067abc24$var$jn.undefined;
        case "string":
            return $cdf7e442067abc24$var$jn.string;
        case "number":
            return isNaN(e) ? $cdf7e442067abc24$var$jn.nan : $cdf7e442067abc24$var$jn.number;
        case "boolean":
            return $cdf7e442067abc24$var$jn.boolean;
        case "function":
            return $cdf7e442067abc24$var$jn.function;
        case "bigint":
            return $cdf7e442067abc24$var$jn.bigint;
        case "symbol":
            return $cdf7e442067abc24$var$jn.symbol;
        case "object":
            return Array.isArray(e) ? $cdf7e442067abc24$var$jn.array : null === e ? $cdf7e442067abc24$var$jn.null : e.then && "function" == typeof e.then && e.catch && "function" == typeof e.catch ? $cdf7e442067abc24$var$jn.promise : "undefined" != typeof Map && e instanceof Map ? $cdf7e442067abc24$var$jn.map : "undefined" != typeof Set && e instanceof Set ? $cdf7e442067abc24$var$jn.set : "undefined" != typeof Date && e instanceof Date ? $cdf7e442067abc24$var$jn.date : $cdf7e442067abc24$var$jn.object;
        default:
            return $cdf7e442067abc24$var$jn.unknown;
    }
}, $cdf7e442067abc24$var$ed = $cdf7e442067abc24$var$Dn.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
var $cdf7e442067abc24$var$rd;
class $cdf7e442067abc24$var$od extends Error {
    constructor(e){
        super(), this.issues = [], this.addIssue = (e)=>{
            this.issues = [
                ...this.issues,
                e
            ];
        }, this.addIssues = (e = [])=>{
            this.issues = [
                ...this.issues,
                ...e
            ];
        };
        var r = new.target.prototype;
        Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
    }
    get errors() {
        return this.issues;
    }
    format(e) {
        const r = e || function(e) {
            return e.message;
        }, o = {
            _errors: []
        }, t = (e)=>{
            for (const l of e.issues)if ("invalid_union" === l.code) l.unionErrors.map(t);
            else if ("invalid_return_type" === l.code) t(l.returnTypeError);
            else if ("invalid_arguments" === l.code) t(l.argumentsError);
            else if (0 === l.path.length) o._errors.push(r(l));
            else {
                let e = o, t = 0;
                for(; t < l.path.length;){
                    var a = l.path[t];
                    t === l.path.length - 1 ? (e[a] = e[a] || {
                        _errors: []
                    }, e[a]._errors.push(r(l))) : e[a] = e[a] || {
                        _errors: []
                    }, e = e[a], t++;
                }
            }
        };
        return t(this), o;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $cdf7e442067abc24$var$Dn.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return 0 === this.issues.length;
    }
    flatten(e = (e)=>e.message) {
        var r = {}, o = [];
        for (const t of this.issues)(0 < t.path.length ? (r[t.path[0]] = r[t.path[0]] || [], r[t.path[0]]) : o).push(e(t));
        return {
            formErrors: o,
            fieldErrors: r
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$cdf7e442067abc24$var$od.create = (e)=>new $cdf7e442067abc24$var$od(e);
const $cdf7e442067abc24$var$td = (e, r)=>{
    let o;
    switch(e.code){
        case $cdf7e442067abc24$var$ed.invalid_type:
            o = e.received === $cdf7e442067abc24$var$jn.undefined ? "Required" : `Expected ${e.expected}, received ` + e.received;
            break;
        case $cdf7e442067abc24$var$ed.invalid_literal:
            o = "Invalid literal value, expected " + JSON.stringify(e.expected, $cdf7e442067abc24$var$Dn.jsonStringifyReplacer);
            break;
        case $cdf7e442067abc24$var$ed.unrecognized_keys:
            o = "Unrecognized key(s) in object: " + $cdf7e442067abc24$var$Dn.joinValues(e.keys, ", ");
            break;
        case $cdf7e442067abc24$var$ed.invalid_union:
            o = "Invalid input";
            break;
        case $cdf7e442067abc24$var$ed.invalid_union_discriminator:
            o = "Invalid discriminator value. Expected " + $cdf7e442067abc24$var$Dn.joinValues(e.options);
            break;
        case $cdf7e442067abc24$var$ed.invalid_enum_value:
            o = `Invalid enum value. Expected ${$cdf7e442067abc24$var$Dn.joinValues(e.options)}, received '${e.received}'`;
            break;
        case $cdf7e442067abc24$var$ed.invalid_arguments:
            o = "Invalid function arguments";
            break;
        case $cdf7e442067abc24$var$ed.invalid_return_type:
            o = "Invalid function return type";
            break;
        case $cdf7e442067abc24$var$ed.invalid_date:
            o = "Invalid date";
            break;
        case $cdf7e442067abc24$var$ed.invalid_string:
            "object" == typeof e.validation ? "includes" in e.validation ? (o = `Invalid input: must include "${e.validation.includes}"`, "number" == typeof e.validation.position && (o = o + " at one or more positions greater than or equal to " + e.validation.position)) : "startsWith" in e.validation ? o = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? o = `Invalid input: must end with "${e.validation.endsWith}"` : $cdf7e442067abc24$var$Dn.assertNever(e.validation) : o = "regex" !== e.validation ? "Invalid " + e.validation : "Invalid";
            break;
        case $cdf7e442067abc24$var$ed.too_small:
            o = "array" === e.type ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : "string" === e.type ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : "number" === e.type ? "Number must be " + (e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than ") + e.minimum : "date" === e.type ? "Date must be " + (e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than ") + new Date(Number(e.minimum)) : "Invalid input";
            break;
        case $cdf7e442067abc24$var$ed.too_big:
            o = "array" === e.type ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : "string" === e.type ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : "number" === e.type ? `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ` + e.maximum : "bigint" === e.type ? `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ` + e.maximum : "date" === e.type ? `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ` + new Date(Number(e.maximum)) : "Invalid input";
            break;
        case $cdf7e442067abc24$var$ed.custom:
            o = "Invalid input";
            break;
        case $cdf7e442067abc24$var$ed.invalid_intersection_types:
            o = "Intersection results could not be merged";
            break;
        case $cdf7e442067abc24$var$ed.not_multiple_of:
            o = "Number must be a multiple of " + e.multipleOf;
            break;
        case $cdf7e442067abc24$var$ed.not_finite:
            o = "Number must be finite";
            break;
        default:
            o = r.defaultError, $cdf7e442067abc24$var$Dn.assertNever(e);
    }
    return {
        message: o
    };
};
let $cdf7e442067abc24$var$ad = $cdf7e442067abc24$var$td;
function $cdf7e442067abc24$var$ld() {
    return $cdf7e442067abc24$var$ad;
}
const $cdf7e442067abc24$var$id = (e)=>{
    var { data: r, path: e, errorMaps: o, issueData: t } = e, a = (e = [
        ...e,
        ...t.path || []
    ], {
        ...t,
        path: e
    });
    let l = "";
    for (const e of o.filter((e)=>!!e).slice().reverse())l = e(a, {
        data: r,
        defaultError: l
    }).message;
    return {
        ...t,
        path: e,
        message: t.message || l
    };
};
function $cdf7e442067abc24$var$nd(e, r) {
    r = $cdf7e442067abc24$var$id({
        issueData: r,
        data: e.data,
        path: e.path,
        errorMaps: [
            e.common.contextualErrorMap,
            e.schemaErrorMap,
            $cdf7e442067abc24$var$ld(),
            $cdf7e442067abc24$var$td
        ].filter((e)=>!!e)
    }), e.common.issues.push(r);
}
class $cdf7e442067abc24$var$dd {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        "valid" === this.value && (this.value = "dirty");
    }
    abort() {
        "aborted" !== this.value && (this.value = "aborted");
    }
    static mergeArray(e, r) {
        var o = [];
        for (const t of r){
            if ("aborted" === t.status) return $cdf7e442067abc24$var$sd;
            "dirty" === t.status && e.dirty(), o.push(t.value);
        }
        return {
            status: e.value,
            value: o
        };
    }
    static async mergeObjectAsync(e, r) {
        var o = [];
        for (const e of r)o.push({
            key: await e.key,
            value: await e.value
        });
        return $cdf7e442067abc24$var$dd.mergeObjectSync(e, o);
    }
    static mergeObjectSync(e, r) {
        var o = {};
        for (const l of r){
            var { key: t, value: a } = l;
            if ("aborted" === t.status) return $cdf7e442067abc24$var$sd;
            if ("aborted" === a.status) return $cdf7e442067abc24$var$sd;
            "dirty" === t.status && e.dirty(), "dirty" === a.status && e.dirty(), "__proto__" === t.value || void 0 === a.value && !l.alwaysSet || (o[t.value] = a.value);
        }
        return {
            status: e.value,
            value: o
        };
    }
}
const $cdf7e442067abc24$var$sd = Object.freeze({
    status: "aborted"
}), $cdf7e442067abc24$var$md = (e)=>({
        status: "dirty",
        value: e
    }), $cdf7e442067abc24$var$gd = (e)=>({
        status: "valid",
        value: e
    }), $cdf7e442067abc24$var$cd = (e)=>"aborted" === e.status, $cdf7e442067abc24$var$xd = (e)=>"dirty" === e.status, $cdf7e442067abc24$var$ud = (e)=>"valid" === e.status, $cdf7e442067abc24$var$pd = (e)=>"undefined" != typeof Promise && e instanceof Promise;
!function(e) {
    e.errToObj = (e)=>"string" == typeof e ? {
            message: e
        } : e || {}, e.toString = (e)=>"string" == typeof e ? e : null == e ? void 0 : e.message;
}($cdf7e442067abc24$var$Fn = $cdf7e442067abc24$var$Fn || {});
class $cdf7e442067abc24$var$hd {
    constructor(e, r, o, t){
        this._cachedPath = [], this.parent = e, this.data = r, this._path = o, this._key = t;
    }
    get path() {
        return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
    }
}
const $cdf7e442067abc24$var$Sd = (e, r)=>{
    if ($cdf7e442067abc24$var$ud(r)) return {
        success: !0,
        data: r.value
    };
    if (e.common.issues.length) return {
        success: !1,
        get error () {
            var r1;
            return this._error || (r1 = new $cdf7e442067abc24$var$od(e.common.issues), this._error = r1), this._error;
        }
    };
    throw new Error("Validation failed but no issues detected.");
};
function $cdf7e442067abc24$var$vd(e) {
    if (!e) return {};
    const { errorMap: r, invalid_type_error: o, required_error: t, description: a } = e;
    if (r && (o || t)) throw new Error('Can\'t use "invalid_type_error" or "required_error" in conjunction with custom error map.');
    return r ? {
        errorMap: r,
        description: a
    } : {
        errorMap: (e, r)=>"invalid_type" !== e.code ? {
                message: r.defaultError
            } : void 0 === r.data ? {
                message: null != t ? t : r.defaultError
            } : {
                message: null != o ? o : r.defaultError
            },
        description: a
    };
}
class $cdf7e442067abc24$var$$d {
    constructor(e){
        this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(e) {
        return $cdf7e442067abc24$var$qn(e.data);
    }
    _getOrReturnCtx(e, r) {
        return r || {
            common: e.parent.common,
            data: e.data,
            parsedType: $cdf7e442067abc24$var$qn(e.data),
            schemaErrorMap: this._def.errorMap,
            path: e.path,
            parent: e.parent
        };
    }
    _processInputParams(e) {
        return {
            status: new $cdf7e442067abc24$var$dd,
            ctx: {
                common: e.parent.common,
                data: e.data,
                parsedType: $cdf7e442067abc24$var$qn(e.data),
                schemaErrorMap: this._def.errorMap,
                path: e.path,
                parent: e.parent
            }
        };
    }
    _parseSync(e) {
        if (e = this._parse(e), $cdf7e442067abc24$var$pd(e)) throw new Error("Synchronous parse encountered promise.");
        return e;
    }
    _parseAsync(e) {
        return e = this._parse(e), Promise.resolve(e);
    }
    parse(e, r) {
        if ((e = this.safeParse(e, r)).success) return e.data;
        throw e.error;
    }
    safeParse(e, r) {
        var o = {
            common: {
                issues: [],
                async: null != (o = null == r ? void 0 : r.async) && o,
                contextualErrorMap: null == r ? void 0 : r.errorMap
            },
            path: (null == r ? void 0 : r.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: e,
            parsedType: $cdf7e442067abc24$var$qn(e)
        };
        r = this._parseSync({
            data: e,
            path: o.path,
            parent: o
        });
        return $cdf7e442067abc24$var$Sd(o, r);
    }
    async parseAsync(e, r) {
        if ((e = await this.safeParseAsync(e, r)).success) return e.data;
        throw e.error;
    }
    async safeParseAsync(e, r) {
        return r = {
            common: {
                issues: [],
                contextualErrorMap: null == r ? void 0 : r.errorMap,
                async: !0
            },
            path: (null == r ? void 0 : r.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: e,
            parsedType: $cdf7e442067abc24$var$qn(e)
        }, e = this._parse({
            data: e,
            path: r.path,
            parent: r
        }), e = await ($cdf7e442067abc24$var$pd(e) ? e : Promise.resolve(e)), $cdf7e442067abc24$var$Sd(r, e);
    }
    refine(e, r) {
        return this._refinement((o, t)=>{
            var a = e(o);
            const l = ()=>{
                var e;
                return t.addIssue({
                    code: $cdf7e442067abc24$var$ed.custom,
                    ...(e = o, "string" == typeof r || void 0 === r ? {
                        message: r
                    } : "function" == typeof r ? r(e) : r)
                });
            };
            return "undefined" != typeof Promise && a instanceof Promise ? a.then((e)=>!!e || (l(), !1)) : !!a || (l(), !1);
        });
    }
    refinement(e, r) {
        return this._refinement((o, t)=>!!e(o) || (t.addIssue("function" == typeof r ? r(o, t) : r), !1));
    }
    _refinement(e) {
        return new $cdf7e442067abc24$var$ds({
            schema: this,
            typeName: $cdf7e442067abc24$var$Vn.ZodEffects,
            effect: {
                type: "refinement",
                refinement: e
            }
        });
    }
    superRefine(e) {
        return this._refinement(e);
    }
    optional() {
        return $cdf7e442067abc24$var$ss.create(this, this._def);
    }
    nullable() {
        return $cdf7e442067abc24$var$ms.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $cdf7e442067abc24$var$Hd.create(this, this._def);
    }
    promise() {
        return $cdf7e442067abc24$var$ns.create(this, this._def);
    }
    or(e) {
        return $cdf7e442067abc24$var$Wd.create([
            this,
            e
        ], this._def);
    }
    and(e) {
        return $cdf7e442067abc24$var$Yd.create(this, e, this._def);
    }
    transform(e) {
        return new $cdf7e442067abc24$var$ds({
            ...$cdf7e442067abc24$var$vd(this._def),
            schema: this,
            typeName: $cdf7e442067abc24$var$Vn.ZodEffects,
            effect: {
                type: "transform",
                transform: e
            }
        });
    }
    default(e) {
        var r = "function" == typeof e ? e : ()=>e;
        return new $cdf7e442067abc24$var$gs({
            ...$cdf7e442067abc24$var$vd(this._def),
            innerType: this,
            defaultValue: r,
            typeName: $cdf7e442067abc24$var$Vn.ZodDefault
        });
    }
    brand() {
        return new $cdf7e442067abc24$var$ps({
            typeName: $cdf7e442067abc24$var$Vn.ZodBranded,
            type: this,
            ...$cdf7e442067abc24$var$vd(this._def)
        });
    }
    catch(e) {
        var r = "function" == typeof e ? e : ()=>e;
        return new $cdf7e442067abc24$var$cs({
            ...$cdf7e442067abc24$var$vd(this._def),
            innerType: this,
            catchValue: r,
            typeName: $cdf7e442067abc24$var$Vn.ZodCatch
        });
    }
    describe(e) {
        return new this.constructor({
            ...this._def,
            description: e
        });
    }
    pipe(e) {
        return $cdf7e442067abc24$var$hs.create(this, e);
    }
    readonly() {
        return $cdf7e442067abc24$var$Ss.create(this);
    }
    isOptional() {
        return this.safeParse(void 0).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $cdf7e442067abc24$var$bd = /^c[^\s-]{8,}$/i, $cdf7e442067abc24$var$Ad = /^[a-z][a-z0-9]*$/, $cdf7e442067abc24$var$fd = /^[0-9A-HJKMNP-TV-Z]{26}$/, $cdf7e442067abc24$var$Md = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, $cdf7e442067abc24$var$Pd = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
let $cdf7e442067abc24$var$Td;
const $cdf7e442067abc24$var$_d = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, $cdf7e442067abc24$var$yd = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, $cdf7e442067abc24$var$wd = (e)=>e.precision ? e.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}Z$`) : 0 === e.precision ? e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function $cdf7e442067abc24$var$Gd(e, r) {
    return !("v4" !== r && r || !$cdf7e442067abc24$var$_d.test(e)) || !("v6" !== r && r || !$cdf7e442067abc24$var$yd.test(e));
}
class $cdf7e442067abc24$var$Ld extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== $cdf7e442067abc24$var$jn.string) {
            const r = this._getOrReturnCtx(e);
            return $cdf7e442067abc24$var$nd(r, {
                code: $cdf7e442067abc24$var$ed.invalid_type,
                expected: $cdf7e442067abc24$var$jn.string,
                received: r.parsedType
            }), $cdf7e442067abc24$var$sd;
        }
        var r = new $cdf7e442067abc24$var$dd;
        let o;
        for (const l of this._def.checks)if ("min" === l.kind) e.data.length < l.value && ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            code: $cdf7e442067abc24$var$ed.too_small,
            minimum: l.value,
            type: "string",
            inclusive: !0,
            exact: !1,
            message: l.message
        }), r.dirty());
        else if ("max" === l.kind) e.data.length > l.value && ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            code: $cdf7e442067abc24$var$ed.too_big,
            maximum: l.value,
            type: "string",
            inclusive: !0,
            exact: !1,
            message: l.message
        }), r.dirty());
        else if ("length" === l.kind) {
            var t = e.data.length > l.value, a = e.data.length < l.value;
            (t || a) && (o = this._getOrReturnCtx(e, o), t ? $cdf7e442067abc24$var$nd(o, {
                code: $cdf7e442067abc24$var$ed.too_big,
                maximum: l.value,
                type: "string",
                inclusive: !0,
                exact: !0,
                message: l.message
            }) : a && $cdf7e442067abc24$var$nd(o, {
                code: $cdf7e442067abc24$var$ed.too_small,
                minimum: l.value,
                type: "string",
                inclusive: !0,
                exact: !0,
                message: l.message
            }), r.dirty());
        } else if ("email" === l.kind) $cdf7e442067abc24$var$Pd.test(e.data) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            validation: "email",
            code: $cdf7e442067abc24$var$ed.invalid_string,
            message: l.message
        }), r.dirty());
        else if ("emoji" === l.kind) ($cdf7e442067abc24$var$Td = $cdf7e442067abc24$var$Td || new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u")).test(e.data) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            validation: "emoji",
            code: $cdf7e442067abc24$var$ed.invalid_string,
            message: l.message
        }), r.dirty());
        else if ("uuid" === l.kind) $cdf7e442067abc24$var$Md.test(e.data) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            validation: "uuid",
            code: $cdf7e442067abc24$var$ed.invalid_string,
            message: l.message
        }), r.dirty());
        else if ("cuid" === l.kind) $cdf7e442067abc24$var$bd.test(e.data) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            validation: "cuid",
            code: $cdf7e442067abc24$var$ed.invalid_string,
            message: l.message
        }), r.dirty());
        else if ("cuid2" === l.kind) $cdf7e442067abc24$var$Ad.test(e.data) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            validation: "cuid2",
            code: $cdf7e442067abc24$var$ed.invalid_string,
            message: l.message
        }), r.dirty());
        else if ("ulid" === l.kind) $cdf7e442067abc24$var$fd.test(e.data) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            validation: "ulid",
            code: $cdf7e442067abc24$var$ed.invalid_string,
            message: l.message
        }), r.dirty());
        else if ("url" === l.kind) try {
            new URL(e.data);
        } catch (t) {
            $cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
                validation: "url",
                code: $cdf7e442067abc24$var$ed.invalid_string,
                message: l.message
            }), r.dirty();
        }
        else "regex" === l.kind ? (l.regex.lastIndex = 0, l.regex.test(e.data) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            validation: "regex",
            code: $cdf7e442067abc24$var$ed.invalid_string,
            message: l.message
        }), r.dirty())) : "trim" === l.kind ? e.data = e.data.trim() : "includes" === l.kind ? e.data.includes(l.value, l.position) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            code: $cdf7e442067abc24$var$ed.invalid_string,
            validation: {
                includes: l.value,
                position: l.position
            },
            message: l.message
        }), r.dirty()) : "toLowerCase" === l.kind ? e.data = e.data.toLowerCase() : "toUpperCase" === l.kind ? e.data = e.data.toUpperCase() : "startsWith" === l.kind ? e.data.startsWith(l.value) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            code: $cdf7e442067abc24$var$ed.invalid_string,
            validation: {
                startsWith: l.value
            },
            message: l.message
        }), r.dirty()) : "endsWith" === l.kind ? e.data.endsWith(l.value) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            code: $cdf7e442067abc24$var$ed.invalid_string,
            validation: {
                endsWith: l.value
            },
            message: l.message
        }), r.dirty()) : "datetime" === l.kind ? $cdf7e442067abc24$var$wd(l).test(e.data) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            code: $cdf7e442067abc24$var$ed.invalid_string,
            validation: "datetime",
            message: l.message
        }), r.dirty()) : "ip" === l.kind ? $cdf7e442067abc24$var$Gd(e.data, l.version) || ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            validation: "ip",
            code: $cdf7e442067abc24$var$ed.invalid_string,
            message: l.message
        }), r.dirty()) : $cdf7e442067abc24$var$Dn.assertNever(l);
        return {
            status: r.value,
            value: e.data
        };
    }
    _regex(e, r, o) {
        return this.refinement((r)=>e.test(r), {
            validation: r,
            code: $cdf7e442067abc24$var$ed.invalid_string,
            ...$cdf7e442067abc24$var$Fn.errToObj(o)
        });
    }
    _addCheck(e) {
        return new $cdf7e442067abc24$var$Ld({
            ...this._def,
            checks: [
                ...this._def.checks,
                e
            ]
        });
    }
    email(e) {
        return this._addCheck({
            kind: "email",
            ...$cdf7e442067abc24$var$Fn.errToObj(e)
        });
    }
    url(e) {
        return this._addCheck({
            kind: "url",
            ...$cdf7e442067abc24$var$Fn.errToObj(e)
        });
    }
    emoji(e) {
        return this._addCheck({
            kind: "emoji",
            ...$cdf7e442067abc24$var$Fn.errToObj(e)
        });
    }
    uuid(e) {
        return this._addCheck({
            kind: "uuid",
            ...$cdf7e442067abc24$var$Fn.errToObj(e)
        });
    }
    cuid(e) {
        return this._addCheck({
            kind: "cuid",
            ...$cdf7e442067abc24$var$Fn.errToObj(e)
        });
    }
    cuid2(e) {
        return this._addCheck({
            kind: "cuid2",
            ...$cdf7e442067abc24$var$Fn.errToObj(e)
        });
    }
    ulid(e) {
        return this._addCheck({
            kind: "ulid",
            ...$cdf7e442067abc24$var$Fn.errToObj(e)
        });
    }
    ip(e) {
        return this._addCheck({
            kind: "ip",
            ...$cdf7e442067abc24$var$Fn.errToObj(e)
        });
    }
    datetime(e) {
        var r;
        return "string" == typeof e ? this._addCheck({
            kind: "datetime",
            precision: null,
            offset: !1,
            message: e
        }) : this._addCheck({
            kind: "datetime",
            precision: void 0 === (null == e ? void 0 : e.precision) ? null : null == e ? void 0 : e.precision,
            offset: null != (r = null == e ? void 0 : e.offset) && r,
            ...$cdf7e442067abc24$var$Fn.errToObj(null == e ? void 0 : e.message)
        });
    }
    regex(e, r) {
        return this._addCheck({
            kind: "regex",
            regex: e,
            ...$cdf7e442067abc24$var$Fn.errToObj(r)
        });
    }
    includes(e, r) {
        return this._addCheck({
            kind: "includes",
            value: e,
            position: null == r ? void 0 : r.position,
            ...$cdf7e442067abc24$var$Fn.errToObj(null == r ? void 0 : r.message)
        });
    }
    startsWith(e, r) {
        return this._addCheck({
            kind: "startsWith",
            value: e,
            ...$cdf7e442067abc24$var$Fn.errToObj(r)
        });
    }
    endsWith(e, r) {
        return this._addCheck({
            kind: "endsWith",
            value: e,
            ...$cdf7e442067abc24$var$Fn.errToObj(r)
        });
    }
    min(e, r) {
        return this._addCheck({
            kind: "min",
            value: e,
            ...$cdf7e442067abc24$var$Fn.errToObj(r)
        });
    }
    max(e, r) {
        return this._addCheck({
            kind: "max",
            value: e,
            ...$cdf7e442067abc24$var$Fn.errToObj(r)
        });
    }
    length(e, r) {
        return this._addCheck({
            kind: "length",
            value: e,
            ...$cdf7e442067abc24$var$Fn.errToObj(r)
        });
    }
    nonempty(e) {
        return this.min(1, $cdf7e442067abc24$var$Fn.errToObj(e));
    }
    trim() {
        return new $cdf7e442067abc24$var$Ld({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $cdf7e442067abc24$var$Ld({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $cdf7e442067abc24$var$Ld({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((e)=>"datetime" === e.kind);
    }
    get isEmail() {
        return !!this._def.checks.find((e)=>"email" === e.kind);
    }
    get isURL() {
        return !!this._def.checks.find((e)=>"url" === e.kind);
    }
    get isEmoji() {
        return !!this._def.checks.find((e)=>"emoji" === e.kind);
    }
    get isUUID() {
        return !!this._def.checks.find((e)=>"uuid" === e.kind);
    }
    get isCUID() {
        return !!this._def.checks.find((e)=>"cuid" === e.kind);
    }
    get isCUID2() {
        return !!this._def.checks.find((e)=>"cuid2" === e.kind);
    }
    get isULID() {
        return !!this._def.checks.find((e)=>"ulid" === e.kind);
    }
    get isIP() {
        return !!this._def.checks.find((e)=>"ip" === e.kind);
    }
    get minLength() {
        let e = null;
        for (const r of this._def.checks)"min" === r.kind && (null === e || r.value > e) && (e = r.value);
        return e;
    }
    get maxLength() {
        let e = null;
        for (const r of this._def.checks)"max" === r.kind && (null === e || r.value < e) && (e = r.value);
        return e;
    }
}
function $cdf7e442067abc24$var$Cd(e, r) {
    var o = (e.toString().split(".")[1] || "").length, t = (r.toString().split(".")[1] || "").length;
    o = t < o ? o : t;
    return parseInt(e.toFixed(o).replace(".", "")) % parseInt(r.toFixed(o).replace(".", "")) / Math.pow(10, o);
}
$cdf7e442067abc24$var$Ld.create = (e)=>{
    var r;
    return new $cdf7e442067abc24$var$Ld({
        checks: [],
        typeName: $cdf7e442067abc24$var$Vn.ZodString,
        coerce: null != (r = null == e ? void 0 : e.coerce) && r,
        ...$cdf7e442067abc24$var$vd(e)
    });
};
class $cdf7e442067abc24$var$Bd extends $cdf7e442067abc24$var$$d {
    constructor(){
        super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
    }
    _parse(e) {
        if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== $cdf7e442067abc24$var$jn.number) {
            const r = this._getOrReturnCtx(e);
            return $cdf7e442067abc24$var$nd(r, {
                code: $cdf7e442067abc24$var$ed.invalid_type,
                expected: $cdf7e442067abc24$var$jn.number,
                received: r.parsedType
            }), $cdf7e442067abc24$var$sd;
        }
        let r;
        var o = new $cdf7e442067abc24$var$dd;
        for (const t of this._def.checks)"int" === t.kind ? $cdf7e442067abc24$var$Dn.isInteger(e.data) || ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e, r), {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: "integer",
            received: "float",
            message: t.message
        }), o.dirty()) : "min" === t.kind ? (t.inclusive ? e.data < t.value : e.data <= t.value) && ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e, r), {
            code: $cdf7e442067abc24$var$ed.too_small,
            minimum: t.value,
            type: "number",
            inclusive: t.inclusive,
            exact: !1,
            message: t.message
        }), o.dirty()) : "max" === t.kind ? (t.inclusive ? e.data > t.value : e.data >= t.value) && ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e, r), {
            code: $cdf7e442067abc24$var$ed.too_big,
            maximum: t.value,
            type: "number",
            inclusive: t.inclusive,
            exact: !1,
            message: t.message
        }), o.dirty()) : "multipleOf" === t.kind ? 0 !== $cdf7e442067abc24$var$Cd(e.data, t.value) && ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e, r), {
            code: $cdf7e442067abc24$var$ed.not_multiple_of,
            multipleOf: t.value,
            message: t.message
        }), o.dirty()) : "finite" === t.kind ? Number.isFinite(e.data) || ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e, r), {
            code: $cdf7e442067abc24$var$ed.not_finite,
            message: t.message
        }), o.dirty()) : $cdf7e442067abc24$var$Dn.assertNever(t);
        return {
            status: o.value,
            value: e.data
        };
    }
    gte(e, r) {
        return this.setLimit("min", e, !0, $cdf7e442067abc24$var$Fn.toString(r));
    }
    gt(e, r) {
        return this.setLimit("min", e, !1, $cdf7e442067abc24$var$Fn.toString(r));
    }
    lte(e, r) {
        return this.setLimit("max", e, !0, $cdf7e442067abc24$var$Fn.toString(r));
    }
    lt(e, r) {
        return this.setLimit("max", e, !1, $cdf7e442067abc24$var$Fn.toString(r));
    }
    setLimit(e, r, o, t) {
        return new $cdf7e442067abc24$var$Bd({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: e,
                    value: r,
                    inclusive: o,
                    message: $cdf7e442067abc24$var$Fn.toString(t)
                }
            ]
        });
    }
    _addCheck(e) {
        return new $cdf7e442067abc24$var$Bd({
            ...this._def,
            checks: [
                ...this._def.checks,
                e
            ]
        });
    }
    int(e) {
        return this._addCheck({
            kind: "int",
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    positive(e) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: !1,
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    negative(e) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: !1,
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    nonpositive(e) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: !0,
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    nonnegative(e) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: !0,
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    multipleOf(e, r) {
        return this._addCheck({
            kind: "multipleOf",
            value: e,
            message: $cdf7e442067abc24$var$Fn.toString(r)
        });
    }
    finite(e) {
        return this._addCheck({
            kind: "finite",
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    safe(e) {
        return this._addCheck({
            kind: "min",
            inclusive: !0,
            value: Number.MIN_SAFE_INTEGER,
            message: $cdf7e442067abc24$var$Fn.toString(e)
        })._addCheck({
            kind: "max",
            inclusive: !0,
            value: Number.MAX_SAFE_INTEGER,
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    get minValue() {
        let e = null;
        for (const r of this._def.checks)"min" === r.kind && (null === e || r.value > e) && (e = r.value);
        return e;
    }
    get maxValue() {
        let e = null;
        for (const r of this._def.checks)"max" === r.kind && (null === e || r.value < e) && (e = r.value);
        return e;
    }
    get isInt() {
        return !!this._def.checks.find((e)=>"int" === e.kind || "multipleOf" === e.kind && $cdf7e442067abc24$var$Dn.isInteger(e.value));
    }
    get isFinite() {
        let e = null, r = null;
        for (const o of this._def.checks){
            if ("finite" === o.kind || "int" === o.kind || "multipleOf" === o.kind) return !0;
            "min" === o.kind ? (null === r || o.value > r) && (r = o.value) : "max" === o.kind && (null === e || o.value < e) && (e = o.value);
        }
        return Number.isFinite(r) && Number.isFinite(e);
    }
}
$cdf7e442067abc24$var$Bd.create = (e)=>new $cdf7e442067abc24$var$Bd({
        checks: [],
        typeName: $cdf7e442067abc24$var$Vn.ZodNumber,
        coerce: (null == e ? void 0 : e.coerce) || !1,
        ...$cdf7e442067abc24$var$vd(e)
    });
class $cdf7e442067abc24$var$Ed extends $cdf7e442067abc24$var$$d {
    constructor(){
        super(...arguments), this.min = this.gte, this.max = this.lte;
    }
    _parse(e) {
        if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== $cdf7e442067abc24$var$jn.bigint) {
            const r = this._getOrReturnCtx(e);
            return $cdf7e442067abc24$var$nd(r, {
                code: $cdf7e442067abc24$var$ed.invalid_type,
                expected: $cdf7e442067abc24$var$jn.bigint,
                received: r.parsedType
            }), $cdf7e442067abc24$var$sd;
        }
        let r;
        var o = new $cdf7e442067abc24$var$dd;
        for (const t of this._def.checks)"min" === t.kind ? (t.inclusive ? e.data < t.value : e.data <= t.value) && ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e, r), {
            code: $cdf7e442067abc24$var$ed.too_small,
            type: "bigint",
            minimum: t.value,
            inclusive: t.inclusive,
            message: t.message
        }), o.dirty()) : "max" === t.kind ? (t.inclusive ? e.data > t.value : e.data >= t.value) && ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e, r), {
            code: $cdf7e442067abc24$var$ed.too_big,
            type: "bigint",
            maximum: t.value,
            inclusive: t.inclusive,
            message: t.message
        }), o.dirty()) : "multipleOf" === t.kind ? e.data % t.value !== BigInt(0) && ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e, r), {
            code: $cdf7e442067abc24$var$ed.not_multiple_of,
            multipleOf: t.value,
            message: t.message
        }), o.dirty()) : $cdf7e442067abc24$var$Dn.assertNever(t);
        return {
            status: o.value,
            value: e.data
        };
    }
    gte(e, r) {
        return this.setLimit("min", e, !0, $cdf7e442067abc24$var$Fn.toString(r));
    }
    gt(e, r) {
        return this.setLimit("min", e, !1, $cdf7e442067abc24$var$Fn.toString(r));
    }
    lte(e, r) {
        return this.setLimit("max", e, !0, $cdf7e442067abc24$var$Fn.toString(r));
    }
    lt(e, r) {
        return this.setLimit("max", e, !1, $cdf7e442067abc24$var$Fn.toString(r));
    }
    setLimit(e, r, o, t) {
        return new $cdf7e442067abc24$var$Ed({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: e,
                    value: r,
                    inclusive: o,
                    message: $cdf7e442067abc24$var$Fn.toString(t)
                }
            ]
        });
    }
    _addCheck(e) {
        return new $cdf7e442067abc24$var$Ed({
            ...this._def,
            checks: [
                ...this._def.checks,
                e
            ]
        });
    }
    positive(e) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: !1,
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    negative(e) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: !1,
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    nonpositive(e) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: !0,
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    nonnegative(e) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: !0,
            message: $cdf7e442067abc24$var$Fn.toString(e)
        });
    }
    multipleOf(e, r) {
        return this._addCheck({
            kind: "multipleOf",
            value: e,
            message: $cdf7e442067abc24$var$Fn.toString(r)
        });
    }
    get minValue() {
        let e = null;
        for (const r of this._def.checks)"min" === r.kind && (null === e || r.value > e) && (e = r.value);
        return e;
    }
    get maxValue() {
        let e = null;
        for (const r of this._def.checks)"max" === r.kind && (null === e || r.value < e) && (e = r.value);
        return e;
    }
}
$cdf7e442067abc24$var$Ed.create = (e)=>{
    var r;
    return new $cdf7e442067abc24$var$Ed({
        checks: [],
        typeName: $cdf7e442067abc24$var$Vn.ZodBigInt,
        coerce: null != (r = null == e ? void 0 : e.coerce) && r,
        ...$cdf7e442067abc24$var$vd(e)
    });
};
class $cdf7e442067abc24$var$Nd extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r;
        return this._def.coerce && (e.data = Boolean(e.data)), this._getType(e) !== $cdf7e442067abc24$var$jn.boolean ? ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e), {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.boolean,
            received: r.parsedType
        }), $cdf7e442067abc24$var$sd) : $cdf7e442067abc24$var$gd(e.data);
    }
}
$cdf7e442067abc24$var$Nd.create = (e)=>new $cdf7e442067abc24$var$Nd({
        typeName: $cdf7e442067abc24$var$Vn.ZodBoolean,
        coerce: (null == e ? void 0 : e.coerce) || !1,
        ...$cdf7e442067abc24$var$vd(e)
    });
class $cdf7e442067abc24$var$Od extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== $cdf7e442067abc24$var$jn.date) {
            const r = this._getOrReturnCtx(e);
            return $cdf7e442067abc24$var$nd(r, {
                code: $cdf7e442067abc24$var$ed.invalid_type,
                expected: $cdf7e442067abc24$var$jn.date,
                received: r.parsedType
            }), $cdf7e442067abc24$var$sd;
        }
        if (isNaN(e.data.getTime())) return $cdf7e442067abc24$var$nd(this._getOrReturnCtx(e), {
            code: $cdf7e442067abc24$var$ed.invalid_date
        }), $cdf7e442067abc24$var$sd;
        var r = new $cdf7e442067abc24$var$dd;
        let o;
        for (const t of this._def.checks)"min" === t.kind ? e.data.getTime() < t.value && ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            code: $cdf7e442067abc24$var$ed.too_small,
            message: t.message,
            inclusive: !0,
            exact: !1,
            minimum: t.value,
            type: "date"
        }), r.dirty()) : "max" === t.kind ? e.data.getTime() > t.value && ($cdf7e442067abc24$var$nd(o = this._getOrReturnCtx(e, o), {
            code: $cdf7e442067abc24$var$ed.too_big,
            message: t.message,
            inclusive: !0,
            exact: !1,
            maximum: t.value,
            type: "date"
        }), r.dirty()) : $cdf7e442067abc24$var$Dn.assertNever(t);
        return {
            status: r.value,
            value: new Date(e.data.getTime())
        };
    }
    _addCheck(e) {
        return new $cdf7e442067abc24$var$Od({
            ...this._def,
            checks: [
                ...this._def.checks,
                e
            ]
        });
    }
    min(e, r) {
        return this._addCheck({
            kind: "min",
            value: e.getTime(),
            message: $cdf7e442067abc24$var$Fn.toString(r)
        });
    }
    max(e, r) {
        return this._addCheck({
            kind: "max",
            value: e.getTime(),
            message: $cdf7e442067abc24$var$Fn.toString(r)
        });
    }
    get minDate() {
        let e = null;
        for (const r of this._def.checks)"min" === r.kind && (null === e || r.value > e) && (e = r.value);
        return null != e ? new Date(e) : null;
    }
    get maxDate() {
        let e = null;
        for (const r of this._def.checks)"max" === r.kind && (null === e || r.value < e) && (e = r.value);
        return null != e ? new Date(e) : null;
    }
}
$cdf7e442067abc24$var$Od.create = (e)=>new $cdf7e442067abc24$var$Od({
        checks: [],
        coerce: (null == e ? void 0 : e.coerce) || !1,
        typeName: $cdf7e442067abc24$var$Vn.ZodDate,
        ...$cdf7e442067abc24$var$vd(e)
    });
class $cdf7e442067abc24$var$Id extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r;
        return this._getType(e) !== $cdf7e442067abc24$var$jn.symbol ? ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e), {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.symbol,
            received: r.parsedType
        }), $cdf7e442067abc24$var$sd) : $cdf7e442067abc24$var$gd(e.data);
    }
}
$cdf7e442067abc24$var$Id.create = (e)=>new $cdf7e442067abc24$var$Id({
        typeName: $cdf7e442067abc24$var$Vn.ZodSymbol,
        ...$cdf7e442067abc24$var$vd(e)
    });
class $cdf7e442067abc24$var$kd extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r;
        return this._getType(e) !== $cdf7e442067abc24$var$jn.undefined ? ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e), {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.undefined,
            received: r.parsedType
        }), $cdf7e442067abc24$var$sd) : $cdf7e442067abc24$var$gd(e.data);
    }
}
$cdf7e442067abc24$var$kd.create = (e)=>new $cdf7e442067abc24$var$kd({
        typeName: $cdf7e442067abc24$var$Vn.ZodUndefined,
        ...$cdf7e442067abc24$var$vd(e)
    });
class $cdf7e442067abc24$var$Xd extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r;
        return this._getType(e) !== $cdf7e442067abc24$var$jn.null ? ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e), {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.null,
            received: r.parsedType
        }), $cdf7e442067abc24$var$sd) : $cdf7e442067abc24$var$gd(e.data);
    }
}
$cdf7e442067abc24$var$Xd.create = (e)=>new $cdf7e442067abc24$var$Xd({
        typeName: $cdf7e442067abc24$var$Vn.ZodNull,
        ...$cdf7e442067abc24$var$vd(e)
    });
class $cdf7e442067abc24$var$Dd extends $cdf7e442067abc24$var$$d {
    constructor(){
        super(...arguments), this._any = !0;
    }
    _parse(e) {
        return $cdf7e442067abc24$var$gd(e.data);
    }
}
$cdf7e442067abc24$var$Dd.create = (e)=>new $cdf7e442067abc24$var$Dd({
        typeName: $cdf7e442067abc24$var$Vn.ZodAny,
        ...$cdf7e442067abc24$var$vd(e)
    });
class $cdf7e442067abc24$var$Rd extends $cdf7e442067abc24$var$$d {
    constructor(){
        super(...arguments), this._unknown = !0;
    }
    _parse(e) {
        return $cdf7e442067abc24$var$gd(e.data);
    }
}
$cdf7e442067abc24$var$Rd.create = (e)=>new $cdf7e442067abc24$var$Rd({
        typeName: $cdf7e442067abc24$var$Vn.ZodUnknown,
        ...$cdf7e442067abc24$var$vd(e)
    });
class $cdf7e442067abc24$var$Fd extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        return $cdf7e442067abc24$var$nd(e = this._getOrReturnCtx(e), {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.never,
            received: e.parsedType
        }), $cdf7e442067abc24$var$sd;
    }
}
$cdf7e442067abc24$var$Fd.create = (e)=>new $cdf7e442067abc24$var$Fd({
        typeName: $cdf7e442067abc24$var$Vn.ZodNever,
        ...$cdf7e442067abc24$var$vd(e)
    });
class $cdf7e442067abc24$var$Vd extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r;
        return this._getType(e) !== $cdf7e442067abc24$var$jn.undefined ? ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e), {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.void,
            received: r.parsedType
        }), $cdf7e442067abc24$var$sd) : $cdf7e442067abc24$var$gd(e.data);
    }
}
$cdf7e442067abc24$var$Vd.create = (e)=>new $cdf7e442067abc24$var$Vd({
        typeName: $cdf7e442067abc24$var$Vn.ZodVoid,
        ...$cdf7e442067abc24$var$vd(e)
    });
class $cdf7e442067abc24$var$Hd extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        const { ctx: r, status: o } = this._processInputParams(e), t = this._def;
        var a;
        return r.parsedType !== $cdf7e442067abc24$var$jn.array ? ($cdf7e442067abc24$var$nd(r, {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.array,
            received: r.parsedType
        }), $cdf7e442067abc24$var$sd) : (null !== t.exactLength && (e = r.data.length > t.exactLength.value, a = r.data.length < t.exactLength.value, e || a) && ($cdf7e442067abc24$var$nd(r, {
            code: e ? $cdf7e442067abc24$var$ed.too_big : $cdf7e442067abc24$var$ed.too_small,
            minimum: a ? t.exactLength.value : void 0,
            maximum: e ? t.exactLength.value : void 0,
            type: "array",
            inclusive: !0,
            exact: !0,
            message: t.exactLength.message
        }), o.dirty()), null !== t.minLength && r.data.length < t.minLength.value && ($cdf7e442067abc24$var$nd(r, {
            code: $cdf7e442067abc24$var$ed.too_small,
            minimum: t.minLength.value,
            type: "array",
            inclusive: !0,
            exact: !1,
            message: t.minLength.message
        }), o.dirty()), null !== t.maxLength && r.data.length > t.maxLength.value && ($cdf7e442067abc24$var$nd(r, {
            code: $cdf7e442067abc24$var$ed.too_big,
            maximum: t.maxLength.value,
            type: "array",
            inclusive: !0,
            exact: !1,
            message: t.maxLength.message
        }), o.dirty()), r.common.async ? Promise.all([
            ...r.data
        ].map((e, o)=>t.type._parseAsync(new $cdf7e442067abc24$var$hd(r, e, r.path, o)))).then((e)=>$cdf7e442067abc24$var$dd.mergeArray(o, e)) : (a = [
            ...r.data
        ].map((e, o)=>t.type._parseSync(new $cdf7e442067abc24$var$hd(r, e, r.path, o))), $cdf7e442067abc24$var$dd.mergeArray(o, a)));
    }
    get element() {
        return this._def.type;
    }
    min(e, r) {
        return new $cdf7e442067abc24$var$Hd({
            ...this._def,
            minLength: {
                value: e,
                message: $cdf7e442067abc24$var$Fn.toString(r)
            }
        });
    }
    max(e, r) {
        return new $cdf7e442067abc24$var$Hd({
            ...this._def,
            maxLength: {
                value: e,
                message: $cdf7e442067abc24$var$Fn.toString(r)
            }
        });
    }
    length(e, r) {
        return new $cdf7e442067abc24$var$Hd({
            ...this._def,
            exactLength: {
                value: e,
                message: $cdf7e442067abc24$var$Fn.toString(r)
            }
        });
    }
    nonempty(e) {
        return this.min(1, e);
    }
}
function $cdf7e442067abc24$var$Ud(e) {
    if (e instanceof $cdf7e442067abc24$var$Kd) {
        const o = {};
        for(const t in e.shape){
            var r = e.shape[t];
            o[t] = $cdf7e442067abc24$var$ss.create($cdf7e442067abc24$var$Ud(r));
        }
        return new $cdf7e442067abc24$var$Kd({
            ...e._def,
            shape: ()=>o
        });
    }
    return e instanceof $cdf7e442067abc24$var$Hd ? new $cdf7e442067abc24$var$Hd({
        ...e._def,
        type: $cdf7e442067abc24$var$Ud(e.element)
    }) : e instanceof $cdf7e442067abc24$var$ss ? $cdf7e442067abc24$var$ss.create($cdf7e442067abc24$var$Ud(e.unwrap())) : e instanceof $cdf7e442067abc24$var$ms ? $cdf7e442067abc24$var$ms.create($cdf7e442067abc24$var$Ud(e.unwrap())) : e instanceof $cdf7e442067abc24$var$Jd ? $cdf7e442067abc24$var$Jd.create(e.items.map((e)=>$cdf7e442067abc24$var$Ud(e))) : e;
}
$cdf7e442067abc24$var$Hd.create = (e, r)=>new $cdf7e442067abc24$var$Hd({
        type: e,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $cdf7e442067abc24$var$Vn.ZodArray,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$Kd extends $cdf7e442067abc24$var$$d {
    constructor(){
        super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
    }
    _getCached() {
        var e, r;
        return null !== this._cached ? this._cached : (e = this._def.shape(), r = $cdf7e442067abc24$var$Dn.objectKeys(e), this._cached = {
            shape: e,
            keys: r
        });
    }
    _parse(e) {
        if (this._getType(e) !== $cdf7e442067abc24$var$jn.object) {
            const r = this._getOrReturnCtx(e);
            return $cdf7e442067abc24$var$nd(r, {
                code: $cdf7e442067abc24$var$ed.invalid_type,
                expected: $cdf7e442067abc24$var$jn.object,
                received: r.parsedType
            }), $cdf7e442067abc24$var$sd;
        }
        const { status: r, ctx: o } = this._processInputParams(e);
        var { shape: t, keys: a } = this._getCached(), l = [];
        if (!(this._def.catchall instanceof $cdf7e442067abc24$var$Fd && "strip" === this._def.unknownKeys)) for(const e in o.data)a.includes(e) || l.push(e);
        const i = [];
        for (const e of a){
            var n = t[e], d = o.data[e];
            i.push({
                key: {
                    status: "valid",
                    value: e
                },
                value: n._parse(new $cdf7e442067abc24$var$hd(o, d, o.path, e)),
                alwaysSet: e in o.data
            });
        }
        if (this._def.catchall instanceof $cdf7e442067abc24$var$Fd) {
            if ("passthrough" === (e = this._def.unknownKeys)) for (const e of l)i.push({
                key: {
                    status: "valid",
                    value: e
                },
                value: {
                    status: "valid",
                    value: o.data[e]
                }
            });
            else if ("strict" === e) 0 < l.length && ($cdf7e442067abc24$var$nd(o, {
                code: $cdf7e442067abc24$var$ed.unrecognized_keys,
                keys: l
            }), r.dirty());
            else if ("strip" !== e) throw new Error("Internal ZodObject error: invalid unknownKeys value.");
        } else {
            var s = this._def.catchall;
            for (const e of l){
                var m = o.data[e];
                i.push({
                    key: {
                        status: "valid",
                        value: e
                    },
                    value: s._parse(new $cdf7e442067abc24$var$hd(o, m, o.path, e)),
                    alwaysSet: e in o.data
                });
            }
        }
        return o.common.async ? Promise.resolve().then(async ()=>{
            var e = [];
            for (const o of i){
                var r = await o.key;
                e.push({
                    key: r,
                    value: await o.value,
                    alwaysSet: o.alwaysSet
                });
            }
            return e;
        }).then((e)=>$cdf7e442067abc24$var$dd.mergeObjectSync(r, e)) : $cdf7e442067abc24$var$dd.mergeObjectSync(r, i);
    }
    get shape() {
        return this._def.shape();
    }
    strict(e) {
        return $cdf7e442067abc24$var$Fn.errToObj, new $cdf7e442067abc24$var$Kd({
            ...this._def,
            unknownKeys: "strict",
            ...void 0 !== e ? {
                errorMap: (r, o)=>{
                    var t, a = null != (t = null == (t = (a = this._def).errorMap) ? void 0 : t.call(a, r, o).message) ? t : o.defaultError;
                    return "unrecognized_keys" === r.code ? {
                        message: null != (t = $cdf7e442067abc24$var$Fn.errToObj(e).message) ? t : a
                    } : {
                        message: a
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $cdf7e442067abc24$var$Kd({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $cdf7e442067abc24$var$Kd({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    extend(e) {
        return new $cdf7e442067abc24$var$Kd({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...e
                })
        });
    }
    merge(e) {
        return new $cdf7e442067abc24$var$Kd({
            unknownKeys: e._def.unknownKeys,
            catchall: e._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...e._def.shape()
                }),
            typeName: $cdf7e442067abc24$var$Vn.ZodObject
        });
    }
    setKey(e, r) {
        return this.augment({
            [e]: r
        });
    }
    catchall(e) {
        return new $cdf7e442067abc24$var$Kd({
            ...this._def,
            catchall: e
        });
    }
    pick(e) {
        const r = {};
        return $cdf7e442067abc24$var$Dn.objectKeys(e).forEach((o)=>{
            e[o] && this.shape[o] && (r[o] = this.shape[o]);
        }), new $cdf7e442067abc24$var$Kd({
            ...this._def,
            shape: ()=>r
        });
    }
    omit(e) {
        const r = {};
        return $cdf7e442067abc24$var$Dn.objectKeys(this.shape).forEach((o)=>{
            e[o] || (r[o] = this.shape[o]);
        }), new $cdf7e442067abc24$var$Kd({
            ...this._def,
            shape: ()=>r
        });
    }
    deepPartial() {
        return $cdf7e442067abc24$var$Ud(this);
    }
    partial(e) {
        const r = {};
        return $cdf7e442067abc24$var$Dn.objectKeys(this.shape).forEach((o)=>{
            var t = this.shape[o];
            e && !e[o] ? r[o] = t : r[o] = t.optional();
        }), new $cdf7e442067abc24$var$Kd({
            ...this._def,
            shape: ()=>r
        });
    }
    required(e) {
        const r = {};
        return $cdf7e442067abc24$var$Dn.objectKeys(this.shape).forEach((o)=>{
            if (e && !e[o]) r[o] = this.shape[o];
            else {
                let e = this.shape[o];
                for(; e instanceof $cdf7e442067abc24$var$ss;)e = e._def.innerType;
                r[o] = e;
            }
        }), new $cdf7e442067abc24$var$Kd({
            ...this._def,
            shape: ()=>r
        });
    }
    keyof() {
        return $cdf7e442067abc24$var$as($cdf7e442067abc24$var$Dn.objectKeys(this.shape));
    }
}
$cdf7e442067abc24$var$Kd.create = (e, r)=>new $cdf7e442067abc24$var$Kd({
        shape: ()=>e,
        unknownKeys: "strip",
        catchall: $cdf7e442067abc24$var$Fd.create(),
        typeName: $cdf7e442067abc24$var$Vn.ZodObject,
        ...$cdf7e442067abc24$var$vd(r)
    }), $cdf7e442067abc24$var$Kd.strictCreate = (e, r)=>new $cdf7e442067abc24$var$Kd({
        shape: ()=>e,
        unknownKeys: "strict",
        catchall: $cdf7e442067abc24$var$Fd.create(),
        typeName: $cdf7e442067abc24$var$Vn.ZodObject,
        ...$cdf7e442067abc24$var$vd(r)
    }), $cdf7e442067abc24$var$Kd.lazycreate = (e, r)=>new $cdf7e442067abc24$var$Kd({
        shape: e,
        unknownKeys: "strip",
        catchall: $cdf7e442067abc24$var$Fd.create(),
        typeName: $cdf7e442067abc24$var$Vn.ZodObject,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$Wd extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        const r = this._processInputParams(e).ctx;
        if (e = this._def.options, r.common.async) return Promise.all(e.map(async (e)=>{
            var o = {
                ...r,
                common: {
                    ...r.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await e._parseAsync({
                    data: r.data,
                    path: r.path,
                    parent: o
                }),
                ctx: o
            };
        })).then(function(e) {
            for (const r of e)if ("valid" === r.result.status) return r.result;
            for (const o of e)if ("dirty" === o.result.status) return r.common.issues.push(...o.ctx.common.issues), o.result;
            return e = e.map((e)=>new $cdf7e442067abc24$var$od(e.ctx.common.issues)), $cdf7e442067abc24$var$nd(r, {
                code: $cdf7e442067abc24$var$ed.invalid_union,
                unionErrors: e
            }), $cdf7e442067abc24$var$sd;
        });
        {
            let l;
            var o = [];
            for (const i of e){
                var t = {
                    ...r,
                    common: {
                        ...r.common,
                        issues: []
                    },
                    parent: null
                }, a = i._parseSync({
                    data: r.data,
                    path: r.path,
                    parent: t
                });
                if ("valid" === a.status) return a;
                "dirty" === a.status && (l = l || {
                    result: a,
                    ctx: t
                }), t.common.issues.length && o.push(t.common.issues);
            }
            return l ? (r.common.issues.push(...l.ctx.common.issues), l.result) : (e = o.map((e)=>new $cdf7e442067abc24$var$od(e)), $cdf7e442067abc24$var$nd(r, {
                code: $cdf7e442067abc24$var$ed.invalid_union,
                unionErrors: e
            }), $cdf7e442067abc24$var$sd);
        }
    }
    get options() {
        return this._def.options;
    }
}
$cdf7e442067abc24$var$Wd.create = (e, r)=>new $cdf7e442067abc24$var$Wd({
        options: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodUnion,
        ...$cdf7e442067abc24$var$vd(r)
    });
const $cdf7e442067abc24$var$Zd = (e)=>e instanceof $cdf7e442067abc24$var$os ? $cdf7e442067abc24$var$Zd(e.schema) : e instanceof $cdf7e442067abc24$var$ds ? $cdf7e442067abc24$var$Zd(e.innerType()) : e instanceof $cdf7e442067abc24$var$ts ? [
        e.value
    ] : e instanceof $cdf7e442067abc24$var$ls ? e.options : e instanceof $cdf7e442067abc24$var$is ? Object.keys(e.enum) : e instanceof $cdf7e442067abc24$var$gs ? $cdf7e442067abc24$var$Zd(e._def.innerType) : e instanceof $cdf7e442067abc24$var$kd ? [
        void 0
    ] : e instanceof $cdf7e442067abc24$var$Xd ? [
        null
    ] : null;
class $cdf7e442067abc24$var$Qd extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r, o;
        return (e = this._processInputParams(e).ctx).parsedType !== $cdf7e442067abc24$var$jn.object ? ($cdf7e442067abc24$var$nd(e, {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.object,
            received: e.parsedType
        }), $cdf7e442067abc24$var$sd) : (r = this.discriminator, o = e.data[r], (o = this.optionsMap.get(o)) ? e.common.async ? o._parseAsync({
            data: e.data,
            path: e.path,
            parent: e
        }) : o._parseSync({
            data: e.data,
            path: e.path,
            parent: e
        }) : ($cdf7e442067abc24$var$nd(e, {
            code: $cdf7e442067abc24$var$ed.invalid_union_discriminator,
            options: Array.from(this.optionsMap.keys()),
            path: [
                r
            ]
        }), $cdf7e442067abc24$var$sd));
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    static create(e, r, o) {
        var t = new Map;
        for (const o of r){
            var a = $cdf7e442067abc24$var$Zd(o.shape[e]);
            if (!a) throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
            for (const r of a){
                if (t.has(r)) throw new Error(`Discriminator property ${String(e)} has duplicate value ` + String(r));
                t.set(r, o);
            }
        }
        return new $cdf7e442067abc24$var$Qd({
            typeName: $cdf7e442067abc24$var$Vn.ZodDiscriminatedUnion,
            discriminator: e,
            options: r,
            optionsMap: t,
            ...$cdf7e442067abc24$var$vd(o)
        });
    }
}
function $cdf7e442067abc24$var$zd(e, r) {
    var o = $cdf7e442067abc24$var$qn(e), t = $cdf7e442067abc24$var$qn(r);
    if (e === r) return {
        valid: !0,
        data: e
    };
    if (o === $cdf7e442067abc24$var$jn.object && t === $cdf7e442067abc24$var$jn.object) {
        const o = $cdf7e442067abc24$var$Dn.objectKeys(r);
        var a = $cdf7e442067abc24$var$Dn.objectKeys(e).filter((e)=>-1 !== o.indexOf(e)), l = {
            ...e,
            ...r
        };
        for (const o of a){
            var i = $cdf7e442067abc24$var$zd(e[o], r[o]);
            if (!i.valid) return {
                valid: !1
            };
            l[o] = i.data;
        }
        return {
            valid: !0,
            data: l
        };
    }
    if (o !== $cdf7e442067abc24$var$jn.array || t !== $cdf7e442067abc24$var$jn.array) return o === $cdf7e442067abc24$var$jn.date && t === $cdf7e442067abc24$var$jn.date && +e == +r ? {
        valid: !0,
        data: e
    } : {
        valid: !1
    };
    if (e.length !== r.length) return {
        valid: !1
    };
    var n = [];
    for(let o = 0; o < e.length; o++){
        var d = $cdf7e442067abc24$var$zd(e[o], r[o]);
        if (!d.valid) return {
            valid: !1
        };
        n.push(d.data);
    }
    return {
        valid: !0,
        data: n
    };
}
class $cdf7e442067abc24$var$Yd extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        const { status: r, ctx: o } = this._processInputParams(e), t = (e, t)=>{
            var a;
            return $cdf7e442067abc24$var$cd(e) || $cdf7e442067abc24$var$cd(t) ? $cdf7e442067abc24$var$sd : (a = $cdf7e442067abc24$var$zd(e.value, t.value)).valid ? (($cdf7e442067abc24$var$xd(e) || $cdf7e442067abc24$var$xd(t)) && r.dirty(), {
                status: r.value,
                value: a.data
            }) : ($cdf7e442067abc24$var$nd(o, {
                code: $cdf7e442067abc24$var$ed.invalid_intersection_types
            }), $cdf7e442067abc24$var$sd);
        };
        return o.common.async ? Promise.all([
            this._def.left._parseAsync({
                data: o.data,
                path: o.path,
                parent: o
            }),
            this._def.right._parseAsync({
                data: o.data,
                path: o.path,
                parent: o
            })
        ]).then(([e, r])=>t(e, r)) : t(this._def.left._parseSync({
            data: o.data,
            path: o.path,
            parent: o
        }), this._def.right._parseSync({
            data: o.data,
            path: o.path,
            parent: o
        }));
    }
}
$cdf7e442067abc24$var$Yd.create = (e, r, o)=>new $cdf7e442067abc24$var$Yd({
        left: e,
        right: r,
        typeName: $cdf7e442067abc24$var$Vn.ZodIntersection,
        ...$cdf7e442067abc24$var$vd(o)
    });
class $cdf7e442067abc24$var$Jd extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        const { status: r, ctx: o } = this._processInputParams(e);
        return o.parsedType !== $cdf7e442067abc24$var$jn.array ? ($cdf7e442067abc24$var$nd(o, {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.array,
            received: o.parsedType
        }), $cdf7e442067abc24$var$sd) : o.data.length < this._def.items.length ? ($cdf7e442067abc24$var$nd(o, {
            code: $cdf7e442067abc24$var$ed.too_small,
            minimum: this._def.items.length,
            inclusive: !0,
            exact: !1,
            type: "array"
        }), $cdf7e442067abc24$var$sd) : (!this._def.rest && o.data.length > this._def.items.length && ($cdf7e442067abc24$var$nd(o, {
            code: $cdf7e442067abc24$var$ed.too_big,
            maximum: this._def.items.length,
            inclusive: !0,
            exact: !1,
            type: "array"
        }), r.dirty()), e = [
            ...o.data
        ].map((e, r)=>{
            var t = this._def.items[r] || this._def.rest;
            return t ? t._parse(new $cdf7e442067abc24$var$hd(o, e, o.path, r)) : null;
        }).filter((e)=>!!e), o.common.async ? Promise.all(e).then((e)=>$cdf7e442067abc24$var$dd.mergeArray(r, e)) : $cdf7e442067abc24$var$dd.mergeArray(r, e));
    }
    get items() {
        return this._def.items;
    }
    rest(e) {
        return new $cdf7e442067abc24$var$Jd({
            ...this._def,
            rest: e
        });
    }
}
$cdf7e442067abc24$var$Jd.create = (e, r)=>{
    if (Array.isArray(e)) return new $cdf7e442067abc24$var$Jd({
        items: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodTuple,
        rest: null,
        ...$cdf7e442067abc24$var$vd(r)
    });
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
};
class $cdf7e442067abc24$var$jd extends $cdf7e442067abc24$var$$d {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(e) {
        var { status: e, ctx: r } = this._processInputParams(e);
        if (r.parsedType !== $cdf7e442067abc24$var$jn.object) return $cdf7e442067abc24$var$nd(r, {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.object,
            received: r.parsedType
        }), $cdf7e442067abc24$var$sd;
        var o = [], t = this._def.keyType, a = this._def.valueType;
        for(const e in r.data)o.push({
            key: t._parse(new $cdf7e442067abc24$var$hd(r, e, r.path, e)),
            value: a._parse(new $cdf7e442067abc24$var$hd(r, r.data[e], r.path, e))
        });
        return r.common.async ? $cdf7e442067abc24$var$dd.mergeObjectAsync(e, o) : $cdf7e442067abc24$var$dd.mergeObjectSync(e, o);
    }
    get element() {
        return this._def.valueType;
    }
    static create(e, r, o) {
        return new $cdf7e442067abc24$var$jd(r instanceof $cdf7e442067abc24$var$$d ? {
            keyType: e,
            valueType: r,
            typeName: $cdf7e442067abc24$var$Vn.ZodRecord,
            ...$cdf7e442067abc24$var$vd(o)
        } : {
            keyType: $cdf7e442067abc24$var$Ld.create(),
            valueType: e,
            typeName: $cdf7e442067abc24$var$Vn.ZodRecord,
            ...$cdf7e442067abc24$var$vd(r)
        });
    }
}
class $cdf7e442067abc24$var$qd extends $cdf7e442067abc24$var$$d {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(e) {
        const { status: r, ctx: o } = this._processInputParams(e);
        if (o.parsedType !== $cdf7e442067abc24$var$jn.map) return $cdf7e442067abc24$var$nd(o, {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.map,
            received: o.parsedType
        }), $cdf7e442067abc24$var$sd;
        const t = this._def.keyType, a = this._def.valueType, l = [
            ...o.data.entries()
        ].map(([e, r], l)=>({
                key: t._parse(new $cdf7e442067abc24$var$hd(o, e, o.path, [
                    l,
                    "key"
                ])),
                value: a._parse(new $cdf7e442067abc24$var$hd(o, r, o.path, [
                    l,
                    "value"
                ]))
            }));
        if (o.common.async) {
            const e = new Map;
            return Promise.resolve().then(async ()=>{
                for (const a of l){
                    var o = await a.key, t = await a.value;
                    if ("aborted" === o.status || "aborted" === t.status) return $cdf7e442067abc24$var$sd;
                    "dirty" !== o.status && "dirty" !== t.status || r.dirty(), e.set(o.value, t.value);
                }
                return {
                    status: r.value,
                    value: e
                };
            });
        }
        var i = new Map;
        for (const e of l){
            var n = e.key, d = e.value;
            if ("aborted" === n.status || "aborted" === d.status) return $cdf7e442067abc24$var$sd;
            "dirty" !== n.status && "dirty" !== d.status || r.dirty(), i.set(n.value, d.value);
        }
        return {
            status: r.value,
            value: i
        };
    }
}
$cdf7e442067abc24$var$qd.create = (e, r, o)=>new $cdf7e442067abc24$var$qd({
        valueType: r,
        keyType: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodMap,
        ...$cdf7e442067abc24$var$vd(o)
    });
class $cdf7e442067abc24$var$es extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        const { status: r, ctx: o } = this._processInputParams(e);
        if (o.parsedType !== $cdf7e442067abc24$var$jn.set) return $cdf7e442067abc24$var$nd(o, {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.set,
            received: o.parsedType
        }), $cdf7e442067abc24$var$sd;
        null !== (e = this._def).minSize && o.data.size < e.minSize.value && ($cdf7e442067abc24$var$nd(o, {
            code: $cdf7e442067abc24$var$ed.too_small,
            minimum: e.minSize.value,
            type: "set",
            inclusive: !0,
            exact: !1,
            message: e.minSize.message
        }), r.dirty()), null !== e.maxSize && o.data.size > e.maxSize.value && ($cdf7e442067abc24$var$nd(o, {
            code: $cdf7e442067abc24$var$ed.too_big,
            maximum: e.maxSize.value,
            type: "set",
            inclusive: !0,
            exact: !1,
            message: e.maxSize.message
        }), r.dirty());
        const t = this._def.valueType;
        function a(e) {
            var o = new Set;
            for (const t of e){
                if ("aborted" === t.status) return $cdf7e442067abc24$var$sd;
                "dirty" === t.status && r.dirty(), o.add(t.value);
            }
            return {
                status: r.value,
                value: o
            };
        }
        return e = [
            ...o.data.values()
        ].map((e, r)=>t._parse(new $cdf7e442067abc24$var$hd(o, e, o.path, r))), o.common.async ? Promise.all(e).then((e)=>a(e)) : a(e);
    }
    min(e, r) {
        return new $cdf7e442067abc24$var$es({
            ...this._def,
            minSize: {
                value: e,
                message: $cdf7e442067abc24$var$Fn.toString(r)
            }
        });
    }
    max(e, r) {
        return new $cdf7e442067abc24$var$es({
            ...this._def,
            maxSize: {
                value: e,
                message: $cdf7e442067abc24$var$Fn.toString(r)
            }
        });
    }
    size(e, r) {
        return this.min(e, r).max(e, r);
    }
    nonempty(e) {
        return this.min(1, e);
    }
}
$cdf7e442067abc24$var$es.create = (e, r)=>new $cdf7e442067abc24$var$es({
        valueType: e,
        minSize: null,
        maxSize: null,
        typeName: $cdf7e442067abc24$var$Vn.ZodSet,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$rs extends $cdf7e442067abc24$var$$d {
    constructor(){
        super(...arguments), this.validate = this.implement;
    }
    _parse(e) {
        const r = this._processInputParams(e).ctx;
        if (r.parsedType !== $cdf7e442067abc24$var$jn.function) return $cdf7e442067abc24$var$nd(r, {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.function,
            received: r.parsedType
        }), $cdf7e442067abc24$var$sd;
        function o(e, o) {
            return $cdf7e442067abc24$var$id({
                data: e,
                path: r.path,
                errorMaps: [
                    r.common.contextualErrorMap,
                    r.schemaErrorMap,
                    $cdf7e442067abc24$var$ld(),
                    $cdf7e442067abc24$var$td
                ].filter((e)=>!!e),
                issueData: {
                    code: $cdf7e442067abc24$var$ed.invalid_arguments,
                    argumentsError: o
                }
            });
        }
        function t(e, o) {
            return $cdf7e442067abc24$var$id({
                data: e,
                path: r.path,
                errorMaps: [
                    r.common.contextualErrorMap,
                    r.schemaErrorMap,
                    $cdf7e442067abc24$var$ld(),
                    $cdf7e442067abc24$var$td
                ].filter((e)=>!!e),
                issueData: {
                    code: $cdf7e442067abc24$var$ed.invalid_return_type,
                    returnTypeError: o
                }
            });
        }
        const a = {
            errorMap: r.common.contextualErrorMap
        }, l = r.data;
        if (this._def.returns instanceof $cdf7e442067abc24$var$ns) {
            const e = this;
            return $cdf7e442067abc24$var$gd(async function(...r) {
                const i = new $cdf7e442067abc24$var$od([]);
                var n = await e._def.args.parseAsync(r, a).catch((e)=>{
                    throw i.addIssue(o(r, e)), i;
                });
                const d = await Reflect.apply(l, this, n);
                return await e._def.returns._def.type.parseAsync(d, a).catch((e)=>{
                    throw i.addIssue(t(d, e)), i;
                });
            });
        }
        {
            const e = this;
            return $cdf7e442067abc24$var$gd(function(...r) {
                var i = e._def.args.safeParse(r, a);
                if (!i.success) throw new $cdf7e442067abc24$var$od([
                    o(r, i.error)
                ]);
                if (r = Reflect.apply(l, this, i.data), (i = e._def.returns.safeParse(r, a)).success) return i.data;
                throw new $cdf7e442067abc24$var$od([
                    t(r, i.error)
                ]);
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...e) {
        return new $cdf7e442067abc24$var$rs({
            ...this._def,
            args: $cdf7e442067abc24$var$Jd.create(e).rest($cdf7e442067abc24$var$Rd.create())
        });
    }
    returns(e) {
        return new $cdf7e442067abc24$var$rs({
            ...this._def,
            returns: e
        });
    }
    implement(e) {
        return this.parse(e);
    }
    strictImplement(e) {
        return this.parse(e);
    }
    static create(e, r, o) {
        return new $cdf7e442067abc24$var$rs({
            args: e || $cdf7e442067abc24$var$Jd.create([]).rest($cdf7e442067abc24$var$Rd.create()),
            returns: r || $cdf7e442067abc24$var$Rd.create(),
            typeName: $cdf7e442067abc24$var$Vn.ZodFunction,
            ...$cdf7e442067abc24$var$vd(o)
        });
    }
}
class $cdf7e442067abc24$var$os extends $cdf7e442067abc24$var$$d {
    get schema() {
        return this._def.getter();
    }
    _parse(e) {
        return e = this._processInputParams(e).ctx, this._def.getter()._parse({
            data: e.data,
            path: e.path,
            parent: e
        });
    }
}
$cdf7e442067abc24$var$os.create = (e, r)=>new $cdf7e442067abc24$var$os({
        getter: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodLazy,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$ts extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r;
        return e.data !== this._def.value ? ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e), {
            received: r.data,
            code: $cdf7e442067abc24$var$ed.invalid_literal,
            expected: this._def.value
        }), $cdf7e442067abc24$var$sd) : {
            status: "valid",
            value: e.data
        };
    }
    get value() {
        return this._def.value;
    }
}
function $cdf7e442067abc24$var$as(e, r) {
    return new $cdf7e442067abc24$var$ls({
        values: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodEnum,
        ...$cdf7e442067abc24$var$vd(r)
    });
}
$cdf7e442067abc24$var$ts.create = (e, r)=>new $cdf7e442067abc24$var$ts({
        value: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodLiteral,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$ls extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r, o;
        return "string" != typeof e.data ? (o = this._getOrReturnCtx(e), r = this._def.values, $cdf7e442067abc24$var$nd(o, {
            expected: $cdf7e442067abc24$var$Dn.joinValues(r),
            received: o.parsedType,
            code: $cdf7e442067abc24$var$ed.invalid_type
        }), $cdf7e442067abc24$var$sd) : -1 === this._def.values.indexOf(e.data) ? (r = this._getOrReturnCtx(e), o = this._def.values, $cdf7e442067abc24$var$nd(r, {
            received: r.data,
            code: $cdf7e442067abc24$var$ed.invalid_enum_value,
            options: o
        }), $cdf7e442067abc24$var$sd) : $cdf7e442067abc24$var$gd(e.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        var e = {};
        for (const r of this._def.values)e[r] = r;
        return e;
    }
    get Values() {
        var e = {};
        for (const r of this._def.values)e[r] = r;
        return e;
    }
    get Enum() {
        var e = {};
        for (const r of this._def.values)e[r] = r;
        return e;
    }
    extract(e) {
        return $cdf7e442067abc24$var$ls.create(e);
    }
    exclude(e) {
        return $cdf7e442067abc24$var$ls.create(this.options.filter((r)=>!e.includes(r)));
    }
}
$cdf7e442067abc24$var$ls.create = $cdf7e442067abc24$var$as;
class $cdf7e442067abc24$var$is extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r, o = $cdf7e442067abc24$var$Dn.getValidEnumValues(this._def.values), t = this._getOrReturnCtx(e);
        return t.parsedType !== $cdf7e442067abc24$var$jn.string && t.parsedType !== $cdf7e442067abc24$var$jn.number ? (r = $cdf7e442067abc24$var$Dn.objectValues(o), $cdf7e442067abc24$var$nd(t, {
            expected: $cdf7e442067abc24$var$Dn.joinValues(r),
            received: t.parsedType,
            code: $cdf7e442067abc24$var$ed.invalid_type
        }), $cdf7e442067abc24$var$sd) : -1 === o.indexOf(e.data) ? (r = $cdf7e442067abc24$var$Dn.objectValues(o), $cdf7e442067abc24$var$nd(t, {
            received: t.data,
            code: $cdf7e442067abc24$var$ed.invalid_enum_value,
            options: r
        }), $cdf7e442067abc24$var$sd) : $cdf7e442067abc24$var$gd(e.data);
    }
    get enum() {
        return this._def.values;
    }
}
$cdf7e442067abc24$var$is.create = (e, r)=>new $cdf7e442067abc24$var$is({
        values: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodNativeEnum,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$ns extends $cdf7e442067abc24$var$$d {
    unwrap() {
        return this._def.type;
    }
    _parse(e) {
        const r = this._processInputParams(e).ctx;
        return r.parsedType !== $cdf7e442067abc24$var$jn.promise && !1 === r.common.async ? ($cdf7e442067abc24$var$nd(r, {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.promise,
            received: r.parsedType
        }), $cdf7e442067abc24$var$sd) : (e = r.parsedType === $cdf7e442067abc24$var$jn.promise ? r.data : Promise.resolve(r.data), $cdf7e442067abc24$var$gd(e.then((e)=>this._def.type.parseAsync(e, {
                path: r.path,
                errorMap: r.common.contextualErrorMap
            }))));
    }
}
$cdf7e442067abc24$var$ns.create = (e, r)=>new $cdf7e442067abc24$var$ns({
        type: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodPromise,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$ds extends $cdf7e442067abc24$var$$d {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $cdf7e442067abc24$var$Vn.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(e) {
        const { status: r, ctx: o } = this._processInputParams(e), t = this._def.effect || null, a = {
            addIssue: (e)=>{
                $cdf7e442067abc24$var$nd(o, e), e.fatal ? r.abort() : r.dirty();
            },
            get path () {
                return o.path;
            }
        };
        if (a.addIssue = a.addIssue.bind(a), "preprocess" === t.type) return e = t.transform(o.data, a), o.common.issues.length ? {
            status: "dirty",
            value: o.data
        } : o.common.async ? Promise.resolve(e).then((e)=>this._def.schema._parseAsync({
                data: e,
                path: o.path,
                parent: o
            })) : this._def.schema._parseSync({
            data: e,
            path: o.path,
            parent: o
        });
        if ("refinement" === t.type) {
            const l = (e)=>{
                var r = t.refinement(e, a);
                if (o.common.async) return Promise.resolve(r);
                if (r instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return e;
            };
            return !1 === o.common.async ? "aborted" === (e = this._def.schema._parseSync({
                data: o.data,
                path: o.path,
                parent: o
            })).status ? $cdf7e442067abc24$var$sd : ("dirty" === e.status && r.dirty(), l(e.value), {
                status: r.value,
                value: e.value
            }) : this._def.schema._parseAsync({
                data: o.data,
                path: o.path,
                parent: o
            }).then((e)=>"aborted" === e.status ? $cdf7e442067abc24$var$sd : ("dirty" === e.status && r.dirty(), l(e.value).then(()=>({
                        status: r.value,
                        value: e.value
                    }))));
        }
        if ("transform" === t.type) {
            if (!1 !== o.common.async) return this._def.schema._parseAsync({
                data: o.data,
                path: o.path,
                parent: o
            }).then((e)=>$cdf7e442067abc24$var$ud(e) ? Promise.resolve(t.transform(e.value, a)).then((e)=>({
                        status: r.value,
                        value: e
                    })) : e);
            if (e = this._def.schema._parseSync({
                data: o.data,
                path: o.path,
                parent: o
            }), !$cdf7e442067abc24$var$ud(e)) return e;
            if ((e = t.transform(e.value, a)) instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
            return {
                status: r.value,
                value: e
            };
        }
        $cdf7e442067abc24$var$Dn.assertNever(t);
    }
}
$cdf7e442067abc24$var$ds.create = (e, r, o)=>new $cdf7e442067abc24$var$ds({
        schema: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodEffects,
        effect: r,
        ...$cdf7e442067abc24$var$vd(o)
    }), $cdf7e442067abc24$var$ds.createWithPreprocess = (e, r, o)=>new $cdf7e442067abc24$var$ds({
        schema: r,
        effect: {
            type: "preprocess",
            transform: e
        },
        typeName: $cdf7e442067abc24$var$Vn.ZodEffects,
        ...$cdf7e442067abc24$var$vd(o)
    });
class $cdf7e442067abc24$var$ss extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        return this._getType(e) === $cdf7e442067abc24$var$jn.undefined ? $cdf7e442067abc24$var$gd(void 0) : this._def.innerType._parse(e);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$cdf7e442067abc24$var$ss.create = (e, r)=>new $cdf7e442067abc24$var$ss({
        innerType: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodOptional,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$ms extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        return this._getType(e) === $cdf7e442067abc24$var$jn.null ? $cdf7e442067abc24$var$gd(null) : this._def.innerType._parse(e);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$cdf7e442067abc24$var$ms.create = (e, r)=>new $cdf7e442067abc24$var$ms({
        innerType: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodNullable,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$gs extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        let r = (e = this._processInputParams(e).ctx).data;
        return e.parsedType === $cdf7e442067abc24$var$jn.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
            data: r,
            path: e.path,
            parent: e
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$cdf7e442067abc24$var$gs.create = (e, r)=>new $cdf7e442067abc24$var$gs({
        innerType: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodDefault,
        defaultValue: "function" == typeof r.default ? r.default : ()=>r.default,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$cs extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        e = this._processInputParams(e).ctx;
        const r = {
            ...e,
            common: {
                ...e.common,
                issues: []
            }
        };
        return e = this._def.innerType._parse({
            data: r.data,
            path: r.path,
            parent: {
                ...r
            }
        }), $cdf7e442067abc24$var$pd(e) ? e.then((e)=>({
                status: "valid",
                value: "valid" === e.status ? e.value : this._def.catchValue({
                    get error () {
                        return new $cdf7e442067abc24$var$od(r.common.issues);
                    },
                    input: r.data
                })
            })) : {
            status: "valid",
            value: "valid" === e.status ? e.value : this._def.catchValue({
                get error () {
                    return new $cdf7e442067abc24$var$od(r.common.issues);
                },
                input: r.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$cdf7e442067abc24$var$cs.create = (e, r)=>new $cdf7e442067abc24$var$cs({
        innerType: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodCatch,
        catchValue: "function" == typeof r.catch ? r.catch : ()=>r.catch,
        ...$cdf7e442067abc24$var$vd(r)
    });
class $cdf7e442067abc24$var$xs extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r;
        return this._getType(e) !== $cdf7e442067abc24$var$jn.nan ? ($cdf7e442067abc24$var$nd(r = this._getOrReturnCtx(e), {
            code: $cdf7e442067abc24$var$ed.invalid_type,
            expected: $cdf7e442067abc24$var$jn.nan,
            received: r.parsedType
        }), $cdf7e442067abc24$var$sd) : {
            status: "valid",
            value: e.data
        };
    }
}
$cdf7e442067abc24$var$xs.create = (e)=>new $cdf7e442067abc24$var$xs({
        typeName: $cdf7e442067abc24$var$Vn.ZodNaN,
        ...$cdf7e442067abc24$var$vd(e)
    });
const $cdf7e442067abc24$var$us = Symbol("zod_brand");
class $cdf7e442067abc24$var$ps extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        var r = (e = this._processInputParams(e).ctx).data;
        return this._def.type._parse({
            data: r,
            path: e.path,
            parent: e
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $cdf7e442067abc24$var$hs extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        const { status: r, ctx: o } = this._processInputParams(e);
        return o.common.async ? (async ()=>{
            var e = await this._def.in._parseAsync({
                data: o.data,
                path: o.path,
                parent: o
            });
            return "aborted" === e.status ? $cdf7e442067abc24$var$sd : "dirty" === e.status ? (r.dirty(), $cdf7e442067abc24$var$md(e.value)) : this._def.out._parseAsync({
                data: e.value,
                path: o.path,
                parent: o
            });
        })() : "aborted" === (e = this._def.in._parseSync({
            data: o.data,
            path: o.path,
            parent: o
        })).status ? $cdf7e442067abc24$var$sd : "dirty" === e.status ? (r.dirty(), {
            status: "dirty",
            value: e.value
        }) : this._def.out._parseSync({
            data: e.value,
            path: o.path,
            parent: o
        });
    }
    static create(e, r) {
        return new $cdf7e442067abc24$var$hs({
            in: e,
            out: r,
            typeName: $cdf7e442067abc24$var$Vn.ZodPipeline
        });
    }
}
class $cdf7e442067abc24$var$Ss extends $cdf7e442067abc24$var$$d {
    _parse(e) {
        return e = this._def.innerType._parse(e), $cdf7e442067abc24$var$ud(e) && (e.value = Object.freeze(e.value)), e;
    }
}
$cdf7e442067abc24$var$Ss.create = (e, r)=>new $cdf7e442067abc24$var$Ss({
        innerType: e,
        typeName: $cdf7e442067abc24$var$Vn.ZodReadonly,
        ...$cdf7e442067abc24$var$vd(r)
    });
const $cdf7e442067abc24$var$vs = (e, r = {}, o)=>e ? $cdf7e442067abc24$var$Dd.create().superRefine((t, a)=>{
        var l;
        e(t) || (l = null == (l = null != (l = (t = "function" == typeof r ? r(t) : "string" == typeof r ? {
            message: r
        } : r).fatal) ? l : o) || l, a.addIssue({
            code: "custom",
            ..."string" == typeof t ? {
                message: t
            } : t,
            fatal: l
        }));
    }) : $cdf7e442067abc24$var$Dd.create(), $cdf7e442067abc24$var$$s = {
    object: $cdf7e442067abc24$var$Kd.lazycreate
}, $cdf7e442067abc24$var$bs = (function(e) {
    e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
}($cdf7e442067abc24$var$Vn = $cdf7e442067abc24$var$Vn || {}), (e, r = {
    message: "Input not instance of " + e.name
})=>$cdf7e442067abc24$var$vs((r)=>r instanceof e, r)), $cdf7e442067abc24$var$As = $cdf7e442067abc24$var$Ld.create, $cdf7e442067abc24$var$fs = $cdf7e442067abc24$var$Bd.create, $cdf7e442067abc24$var$Ms = $cdf7e442067abc24$var$xs.create, $cdf7e442067abc24$var$Ps = $cdf7e442067abc24$var$Ed.create, $cdf7e442067abc24$var$Ts = $cdf7e442067abc24$var$Nd.create, $cdf7e442067abc24$var$_s = $cdf7e442067abc24$var$Od.create, $cdf7e442067abc24$var$ys = $cdf7e442067abc24$var$Id.create, $cdf7e442067abc24$var$ws = $cdf7e442067abc24$var$kd.create, $cdf7e442067abc24$var$Gs = $cdf7e442067abc24$var$Xd.create, $cdf7e442067abc24$var$Ls = $cdf7e442067abc24$var$Dd.create, $cdf7e442067abc24$var$Cs = $cdf7e442067abc24$var$Rd.create, $cdf7e442067abc24$var$Bs = $cdf7e442067abc24$var$Fd.create, $cdf7e442067abc24$var$Es = $cdf7e442067abc24$var$Vd.create, $cdf7e442067abc24$var$Ns = $cdf7e442067abc24$var$Hd.create, $cdf7e442067abc24$var$Os = $cdf7e442067abc24$var$Kd.create, $cdf7e442067abc24$var$Is = $cdf7e442067abc24$var$Kd.strictCreate, $cdf7e442067abc24$var$ks = $cdf7e442067abc24$var$Wd.create, $cdf7e442067abc24$var$Xs = $cdf7e442067abc24$var$Qd.create, $cdf7e442067abc24$var$Ds = $cdf7e442067abc24$var$Yd.create, $cdf7e442067abc24$var$Rs = $cdf7e442067abc24$var$Jd.create, $cdf7e442067abc24$var$Fs = $cdf7e442067abc24$var$jd.create, $cdf7e442067abc24$var$Vs = $cdf7e442067abc24$var$qd.create, $cdf7e442067abc24$var$Hs = $cdf7e442067abc24$var$es.create, $cdf7e442067abc24$var$Us = $cdf7e442067abc24$var$rs.create, $cdf7e442067abc24$var$Ks = $cdf7e442067abc24$var$os.create, $cdf7e442067abc24$var$Ws = $cdf7e442067abc24$var$ts.create, $cdf7e442067abc24$var$Zs = $cdf7e442067abc24$var$ls.create, $cdf7e442067abc24$var$Qs = $cdf7e442067abc24$var$is.create, $cdf7e442067abc24$var$zs = $cdf7e442067abc24$var$ns.create, $cdf7e442067abc24$var$Ys = $cdf7e442067abc24$var$ds.create, $cdf7e442067abc24$var$Js = $cdf7e442067abc24$var$ss.create, $cdf7e442067abc24$var$js = $cdf7e442067abc24$var$ms.create, $cdf7e442067abc24$var$qs = $cdf7e442067abc24$var$ds.createWithPreprocess, $cdf7e442067abc24$var$em = $cdf7e442067abc24$var$hs.create, $cdf7e442067abc24$var$rm = {
    string: (e)=>$cdf7e442067abc24$var$Ld.create({
            ...e,
            coerce: !0
        }),
    number: (e)=>$cdf7e442067abc24$var$Bd.create({
            ...e,
            coerce: !0
        }),
    boolean: (e)=>$cdf7e442067abc24$var$Nd.create({
            ...e,
            coerce: !0
        }),
    bigint: (e)=>$cdf7e442067abc24$var$Ed.create({
            ...e,
            coerce: !0
        }),
    date: (e)=>$cdf7e442067abc24$var$Od.create({
            ...e,
            coerce: !0
        })
}, $cdf7e442067abc24$var$om = $cdf7e442067abc24$var$sd;
var $cdf7e442067abc24$var$tm = Object.freeze({
    __proto__: null,
    defaultErrorMap: $cdf7e442067abc24$var$td,
    setErrorMap: function(e) {
        $cdf7e442067abc24$var$ad = e;
    },
    getErrorMap: $cdf7e442067abc24$var$ld,
    makeIssue: $cdf7e442067abc24$var$id,
    EMPTY_PATH: [],
    addIssueToContext: $cdf7e442067abc24$var$nd,
    ParseStatus: $cdf7e442067abc24$var$dd,
    INVALID: $cdf7e442067abc24$var$sd,
    DIRTY: $cdf7e442067abc24$var$md,
    OK: $cdf7e442067abc24$var$gd,
    isAborted: $cdf7e442067abc24$var$cd,
    isDirty: $cdf7e442067abc24$var$xd,
    isValid: $cdf7e442067abc24$var$ud,
    isAsync: $cdf7e442067abc24$var$pd,
    get util () {
        return $cdf7e442067abc24$var$Dn;
    },
    get objectUtil () {
        return $cdf7e442067abc24$var$Rn;
    },
    ZodParsedType: $cdf7e442067abc24$var$jn,
    getParsedType: $cdf7e442067abc24$var$qn,
    ZodType: $cdf7e442067abc24$var$$d,
    ZodString: $cdf7e442067abc24$var$Ld,
    ZodNumber: $cdf7e442067abc24$var$Bd,
    ZodBigInt: $cdf7e442067abc24$var$Ed,
    ZodBoolean: $cdf7e442067abc24$var$Nd,
    ZodDate: $cdf7e442067abc24$var$Od,
    ZodSymbol: $cdf7e442067abc24$var$Id,
    ZodUndefined: $cdf7e442067abc24$var$kd,
    ZodNull: $cdf7e442067abc24$var$Xd,
    ZodAny: $cdf7e442067abc24$var$Dd,
    ZodUnknown: $cdf7e442067abc24$var$Rd,
    ZodNever: $cdf7e442067abc24$var$Fd,
    ZodVoid: $cdf7e442067abc24$var$Vd,
    ZodArray: $cdf7e442067abc24$var$Hd,
    ZodObject: $cdf7e442067abc24$var$Kd,
    ZodUnion: $cdf7e442067abc24$var$Wd,
    ZodDiscriminatedUnion: $cdf7e442067abc24$var$Qd,
    ZodIntersection: $cdf7e442067abc24$var$Yd,
    ZodTuple: $cdf7e442067abc24$var$Jd,
    ZodRecord: $cdf7e442067abc24$var$jd,
    ZodMap: $cdf7e442067abc24$var$qd,
    ZodSet: $cdf7e442067abc24$var$es,
    ZodFunction: $cdf7e442067abc24$var$rs,
    ZodLazy: $cdf7e442067abc24$var$os,
    ZodLiteral: $cdf7e442067abc24$var$ts,
    ZodEnum: $cdf7e442067abc24$var$ls,
    ZodNativeEnum: $cdf7e442067abc24$var$is,
    ZodPromise: $cdf7e442067abc24$var$ns,
    ZodEffects: $cdf7e442067abc24$var$ds,
    ZodTransformer: $cdf7e442067abc24$var$ds,
    ZodOptional: $cdf7e442067abc24$var$ss,
    ZodNullable: $cdf7e442067abc24$var$ms,
    ZodDefault: $cdf7e442067abc24$var$gs,
    ZodCatch: $cdf7e442067abc24$var$cs,
    ZodNaN: $cdf7e442067abc24$var$xs,
    BRAND: $cdf7e442067abc24$var$us,
    ZodBranded: $cdf7e442067abc24$var$ps,
    ZodPipeline: $cdf7e442067abc24$var$hs,
    ZodReadonly: $cdf7e442067abc24$var$Ss,
    custom: $cdf7e442067abc24$var$vs,
    Schema: $cdf7e442067abc24$var$$d,
    ZodSchema: $cdf7e442067abc24$var$$d,
    late: $cdf7e442067abc24$var$$s,
    get ZodFirstPartyTypeKind () {
        return $cdf7e442067abc24$var$Vn;
    },
    coerce: $cdf7e442067abc24$var$rm,
    any: $cdf7e442067abc24$var$Ls,
    array: $cdf7e442067abc24$var$Ns,
    bigint: $cdf7e442067abc24$var$Ps,
    boolean: $cdf7e442067abc24$var$Ts,
    date: $cdf7e442067abc24$var$_s,
    discriminatedUnion: $cdf7e442067abc24$var$Xs,
    effect: $cdf7e442067abc24$var$Ys,
    enum: $cdf7e442067abc24$var$Zs,
    function: $cdf7e442067abc24$var$Us,
    instanceof: $cdf7e442067abc24$var$bs,
    intersection: $cdf7e442067abc24$var$Ds,
    lazy: $cdf7e442067abc24$var$Ks,
    literal: $cdf7e442067abc24$var$Ws,
    map: $cdf7e442067abc24$var$Vs,
    nan: $cdf7e442067abc24$var$Ms,
    nativeEnum: $cdf7e442067abc24$var$Qs,
    never: $cdf7e442067abc24$var$Bs,
    null: $cdf7e442067abc24$var$Gs,
    nullable: $cdf7e442067abc24$var$js,
    number: $cdf7e442067abc24$var$fs,
    object: $cdf7e442067abc24$var$Os,
    oboolean: ()=>$cdf7e442067abc24$var$Ts().optional(),
    onumber: ()=>$cdf7e442067abc24$var$fs().optional(),
    optional: $cdf7e442067abc24$var$Js,
    ostring: ()=>$cdf7e442067abc24$var$As().optional(),
    pipeline: $cdf7e442067abc24$var$em,
    preprocess: $cdf7e442067abc24$var$qs,
    promise: $cdf7e442067abc24$var$zs,
    record: $cdf7e442067abc24$var$Fs,
    set: $cdf7e442067abc24$var$Hs,
    strictObject: $cdf7e442067abc24$var$Is,
    string: $cdf7e442067abc24$var$As,
    symbol: $cdf7e442067abc24$var$ys,
    transformer: $cdf7e442067abc24$var$Ys,
    tuple: $cdf7e442067abc24$var$Rs,
    undefined: $cdf7e442067abc24$var$ws,
    union: $cdf7e442067abc24$var$ks,
    unknown: $cdf7e442067abc24$var$Cs,
    void: $cdf7e442067abc24$var$Es,
    NEVER: $cdf7e442067abc24$var$om,
    ZodIssueCode: $cdf7e442067abc24$var$ed,
    quotelessJson: (e)=>JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:"),
    ZodError: $cdf7e442067abc24$var$od
});
const $cdf7e442067abc24$var$am = $cdf7e442067abc24$var$ge('<span class="flex items-center gap-2">Saving...'), $cdf7e442067abc24$var$lm = $cdf7e442067abc24$var$ge("<span>Submit"), $cdf7e442067abc24$var$im = ()=>{
    var e, r;
    return r = (e = $cdf7e442067abc24$var$am()).firstChild, $cdf7e442067abc24$var$$e(e, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Or, {
        class: "text-white"
    }), r), e;
}, $cdf7e442067abc24$var$nm = (e)=>$cdf7e442067abc24$var$z($cdf7e442067abc24$var$Er, $cdf7e442067abc24$var$q({
        get sendButtonColor () {
            return e.buttonColor;
        },
        type: "submit",
        get isDisabled () {
            return e.isDisabled || e.isLoading;
        },
        class: "m-0 h-14 flex items-center justify-center"
    }, e, {
        get children () {
            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                get when () {
                    return !e.isLoading;
                },
                get fallback () {
                    return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$im, {});
                },
                get children () {
                    var e1 = $cdf7e442067abc24$var$lm();
                    return e1.style.setProperty("font-family", "Poppins, sans-serif"), e1;
                }
            });
        }
    })), $cdf7e442067abc24$var$dm = $cdf7e442067abc24$var$ge('<div class="flex flex-row justify-start mb-2 items-start host-container"><div class="px-4 py-2 ml-2 max-w-full chatbot-host-bubble prose" data-testid="host-bubble">'), $cdf7e442067abc24$var$sm = $cdf7e442067abc24$var$ge('<div class="flex flex-col gap-2"><span>'), $cdf7e442067abc24$var$mm = $cdf7e442067abc24$var$ge('<form class="flex flex-col gap-2"><span></span><div class="flex flex-col gap-2 w-full"><div class="flex items-center justify-end gap-1">'), $cdf7e442067abc24$var$gm = $cdf7e442067abc24$var$ge('<div class="w-full flex flex-col items-start justify-start gap-1"><div class="w-full flex items-center justify-between chatbot-input border border-[#eeeeee]"><input class="focus:outline-none bg-transparent px-4 py-4 flex-1 w-full h-full min-h-[56px] max-h-[128px] text-input disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 " placeholder="Name" name="name">'), $cdf7e442067abc24$var$cm = $cdf7e442067abc24$var$ge('<span class="text-sm text-red-500">'), $cdf7e442067abc24$var$xm = $cdf7e442067abc24$var$ge('<div class="w-full flex flex-col items-start justify-start gap-1"><div class="w-full flex items-center justify-between chatbot-input border border-[#eeeeee]"><input class="focus:outline-none bg-transparent px-4 py-4 flex-1 w-full h-full min-h-[56px] max-h-[128px] text-input disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 " type="email" placeholder="Email Address" name="email">'), $cdf7e442067abc24$var$um = $cdf7e442067abc24$var$ge('<div class="w-full flex flex-col items-start justify-start gap-1"><div class="w-full flex items-center justify-between chatbot-input border border-[#eeeeee]"><input class="focus:outline-none bg-transparent px-4 py-4 flex-1 w-full h-full min-h-[56px] max-h-[128px] text-input disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 " type="number" placeholder="Phone Number" name="phone">'), $cdf7e442067abc24$var$pm = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/), $cdf7e442067abc24$var$hm = $cdf7e442067abc24$var$tm.object({
    name: $cdf7e442067abc24$var$tm.string().min(2, "Name is too short").optional(),
    email: $cdf7e442067abc24$var$tm.string().email("Please provide a valid email").optional(),
    phone: $cdf7e442067abc24$var$tm.string().min(5, "Phone number is too short").regex($cdf7e442067abc24$var$pm, "Invalid Number!").optional()
}), $cdf7e442067abc24$var$Sm = (e)=>{
    const [r, o] = $cdf7e442067abc24$var$f(""), [t, a] = $cdf7e442067abc24$var$f(""), [l, i] = $cdf7e442067abc24$var$f(""), [n, d] = $cdf7e442067abc24$var$f(!1), [s, m] = $cdf7e442067abc24$var$f(), g = async (o)=>{
        o.preventDefault(), d(!0);
        var a;
        o = Object.fromEntries(new FormData(o.currentTarget));
        (o = $cdf7e442067abc24$var$hm.safeParse(o)).success ? (a = {
            chatflowid: e.chatflowid,
            chatId: e.chatId,
            name: r(),
            email: t(),
            phone: l()
        }, (await (({ apiHost: e = "http://localhost:3000", body: r, onRequest: o })=>$cdf7e442067abc24$var$Oe({
                method: "POST",
                url: e + "/api/v1/leads/",
                body: r,
                onRequest: o
            }))({
            apiHost: e.apiHost,
            body: a
        })).data && ($cdf7e442067abc24$var$Ie(e.chatflowid, e.chatId, {
            lead: {
                name: r(),
                email: t(),
                phone: l()
            }
        }), e.setIsLeadSaved(!0), e.setLeadEmail(t()))) : (a = o.error.flatten(), m(a.fieldErrors)), d(!1);
    };
    {
        const d = $cdf7e442067abc24$var$dm(), m = d.firstChild;
        return d.style.setProperty("margin-right", "50px"), $cdf7e442067abc24$var$$e(d, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return e.showAvatar;
            },
            get children () {
                return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$go, {
                    get initialAvatarSrc () {
                        return e.avatarSrc;
                    }
                });
            }
        }), m), m.style.setProperty("border-radius", "6px"), $cdf7e442067abc24$var$$e(m, (()=>{
            const d = $cdf7e442067abc24$var$T(()=>!(!e.isLeadSaved && !$cdf7e442067abc24$var$ke(e.chatflowid)?.lead));
            return ()=>{
                var m, c, x, u;
                return d() ? ((u = (x = $cdf7e442067abc24$var$sm()).firstChild).style.setProperty("white-space", "pre-line"), $cdf7e442067abc24$var$$e(u, ()=>e.leadsConfig?.successMessage || "Thank you for submitting your contact information."), x) : (c = (m = (x = (u = $cdf7e442067abc24$var$mm()).firstChild).nextSibling).firstChild, u.addEventListener("submit", g), x.style.setProperty("white-space", "pre-line"), $cdf7e442067abc24$var$$e(x, ()=>e.leadsConfig?.title || "Let us know where we can reach you:"), $cdf7e442067abc24$var$$e(m, (()=>{
                    const t = $cdf7e442067abc24$var$T(()=>!!e.leadsConfig?.name);
                    return ()=>t() && (()=>{
                            const e = $cdf7e442067abc24$var$gm(), t = e.firstChild.firstChild;
                            return t.addEventListener("change", (e)=>o(e.currentTarget.value)), t.style.setProperty("width", "100%"), $cdf7e442067abc24$var$$e(e, (()=>{
                                const e = $cdf7e442067abc24$var$T(()=>!(!s() || !s()?.name));
                                return ()=>{
                                    var r;
                                    return e() && ($cdf7e442067abc24$var$$e(r = $cdf7e442067abc24$var$cm(), ()=>s()?.name[0]), r);
                                };
                            })(), null), $cdf7e442067abc24$var$M(()=>t.value = r()), e;
                        })();
                })(), c), $cdf7e442067abc24$var$$e(m, (()=>{
                    const r = $cdf7e442067abc24$var$T(()=>!!e.leadsConfig?.email);
                    return ()=>r() && (()=>{
                            const e = $cdf7e442067abc24$var$xm(), r = e.firstChild.firstChild;
                            return r.addEventListener("change", (e)=>a(e.currentTarget.value)), r.style.setProperty("width", "100%"), $cdf7e442067abc24$var$$e(e, (()=>{
                                const e = $cdf7e442067abc24$var$T(()=>!(!s() || !s()?.email));
                                return ()=>{
                                    var r;
                                    return e() && ($cdf7e442067abc24$var$$e(r = $cdf7e442067abc24$var$cm(), ()=>s()?.email[0]), r);
                                };
                            })(), null), $cdf7e442067abc24$var$M(()=>r.value = t()), e;
                        })();
                })(), c), $cdf7e442067abc24$var$$e(m, (()=>{
                    const r = $cdf7e442067abc24$var$T(()=>!!e.leadsConfig?.phone);
                    return ()=>r() && (()=>{
                            const e = $cdf7e442067abc24$var$um(), r = e.firstChild.firstChild;
                            return r.addEventListener("change", (e)=>i(e.target.value)), r.style.setProperty("width", "100%"), $cdf7e442067abc24$var$$e(e, (()=>{
                                const e = $cdf7e442067abc24$var$T(()=>!(!s() || !s()?.phone));
                                return ()=>{
                                    var r;
                                    return e() && ($cdf7e442067abc24$var$$e(r = $cdf7e442067abc24$var$cm(), ()=>s()?.phone[0]), r);
                                };
                            })(), null), $cdf7e442067abc24$var$M(()=>r.value = l()), e;
                        })();
                })(), c), $cdf7e442067abc24$var$$e(c, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$nm, {
                    get buttonColor () {
                        return e.sendButtonColor;
                    },
                    get isLoading () {
                        return n();
                    }
                })), u);
            };
        })()), $cdf7e442067abc24$var$M((r)=>{
            var o = e.backgroundColor ?? "#f7f8ff", t = e.textColor ?? "#303235", a = e.fontSize ? e.fontSize + "px" : "16px";
            return o !== r._v$ && (null != (r._v$ = o) ? m.style.setProperty("background-color", o) : m.style.removeProperty("background-color")), t !== r._v$2 && (null != (r._v$2 = t) ? m.style.setProperty("color", t) : m.style.removeProperty("color")), a !== r._v$3 && (null != (r._v$3 = a) ? m.style.setProperty("font-size", a) : m.style.removeProperty("font-size")), r;
        }, {
            _v$: void 0,
            _v$2: void 0,
            _v$3: void 0
        }), d;
    }
}, $cdf7e442067abc24$var$vm = $cdf7e442067abc24$var$ge('<div data-modal-target="defaultModal" data-modal-toggle="defaultModal" class="flex justify-start items-start animate-fade-in gap-1 host-container hover:brightness-90 active:brightness-75"><span class="px-2 py-1 whitespace-pre-wrap max-w-full chatbot-host-bubble border" data-testid="host-bubble">'), $cdf7e442067abc24$var$$m = (e)=>{
    {
        const r = $cdf7e442067abc24$var$vm(), o = r.firstChild;
        return r.$$click = ()=>e.onPromptClick?.(), o.style.setProperty("width", "max-content"), o.style.setProperty("border-radius", "15px"), o.style.setProperty("cursor", "pointer"), $cdf7e442067abc24$var$$e(o, ()=>e.prompt), $cdf7e442067abc24$var$M(()=>(e.starterPromptFontSize && e.starterPromptFontSize, o.style.setProperty("font-size", e.starterPromptFontSize ? e.starterPromptFontSize + "px" : "15px"))), r;
    }
};
function $cdf7e442067abc24$var$bm(e) {
    let r, o, t, a = !1;
    return function(l) {
        void 0 === r ? (r = l, o = 0, t = -1) : r = function(e, r) {
            var o = new Uint8Array(e.length + r.length);
            return o.set(e), o.set(r, e.length), o;
        }(r, l);
        var i = r.length;
        let n = 0;
        for(; o < i;){
            a && (10 === r[o] && (n = ++o), a = !1);
            let l = -1;
            for(; o < i && -1 === l; ++o)switch(r[o]){
                case 58:
                    -1 === t && (t = o - n);
                    break;
                case 13:
                    a = !0;
                case 10:
                    l = o;
            }
            if (-1 === l) break;
            e(r.subarray(n, l), t), n = o, t = -1;
        }
        n === i ? r = void 0 : 0 !== n && (r = r.subarray(n), o -= n);
    };
}
$cdf7e442067abc24$var$ce([
    "click"
]);
var $cdf7e442067abc24$var$Am = undefined && undefined.__rest || function(e, r) {
    var o = {};
    for(a in e)Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (o[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var t = 0, a = Object.getOwnPropertySymbols(e); t < a.length; t++)r.indexOf(a[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[t]) && (o[a[t]] = e[a[t]]);
    return o;
};
const $cdf7e442067abc24$var$fm = "text/event-stream", $cdf7e442067abc24$var$Mm = "last-event-id";
function $cdf7e442067abc24$var$Pm(e, r) {
    var { signal: o, headers: t, onopen: a, onmessage: l, onclose: i, onerror: n, openWhenHidden: d, fetch: s } = r, m = $cdf7e442067abc24$var$Am(r, [
        "signal",
        "headers",
        "onopen",
        "onmessage",
        "onclose",
        "onerror",
        "openWhenHidden",
        "fetch"
    ]);
    return new Promise((r, g)=>{
        const c = Object.assign({}, t);
        let x;
        function u() {
            x.abort(), document.hidden || b();
        }
        c.accept || (c.accept = $cdf7e442067abc24$var$fm), d || document.addEventListener("visibilitychange", u);
        let p = 1e3, h = 0;
        function S() {
            document.removeEventListener("visibilitychange", u), window.clearTimeout(h), x.abort();
        }
        null != o && o.addEventListener("abort", ()=>{
            S(), r();
        });
        const v = null != s ? s : window.fetch, $ = null != a ? a : $cdf7e442067abc24$var$Tm;
        async function b() {
            var o;
            x = new AbortController;
            try {
                var t = await v(e, Object.assign(Object.assign({}, m), {
                    headers: c,
                    signal: x.signal
                }));
                await $(t), await async function(e, r) {
                    for(var o, t = e.getReader(); !(o = await t.read()).done;)r(o.value);
                }(t.body, $cdf7e442067abc24$var$bm(function(e, r, o) {
                    let t = {
                        data: "",
                        event: "",
                        id: "",
                        retry: void 0
                    };
                    const a = new TextDecoder;
                    return function(l, i) {
                        if (0 === l.length) null != o && o(t), t = {
                            data: "",
                            event: "",
                            id: "",
                            retry: void 0
                        };
                        else if (0 < i) {
                            var n = a.decode(l.subarray(0, i)), d = (i += 32 === l[i + 1] ? 2 : 1, a.decode(l.subarray(i)));
                            switch(n){
                                case "data":
                                    t.data = t.data ? t.data + "\n" + d : d;
                                    break;
                                case "event":
                                    t.event = d;
                                    break;
                                case "id":
                                    e(t.id = d);
                                    break;
                                case "retry":
                                    var s = parseInt(d, 10);
                                    isNaN(s) || r(t.retry = s);
                            }
                        }
                    };
                }((e)=>{
                    e ? c[$cdf7e442067abc24$var$Mm] = e : delete c[$cdf7e442067abc24$var$Mm];
                }, (e)=>{
                    p = e;
                }, l))), null != i && i(), S(), r();
            } catch (t) {
                if (!x.signal.aborted) try {
                    var a = null != (o = null == n ? void 0 : n(t)) ? o : p;
                    window.clearTimeout(h), h = window.setTimeout(b, a);
                } catch (t) {
                    S(), g(t);
                }
            }
        }
        b();
    });
}
function $cdf7e442067abc24$var$Tm(e) {
    if (null == (e = e.headers.get("content-type")) || !e.startsWith($cdf7e442067abc24$var$fm)) throw new Error(`Expected content-type to be ${$cdf7e442067abc24$var$fm}, Actual: ` + e);
}
const $cdf7e442067abc24$var$_m = $cdf7e442067abc24$var$ge('<div class="fixed inset-0 rounded-lg flex items-center justify-center backdrop-blur-sm z-50"><div class="p-6 rounded-lg shadow-lg max-w-md w-full text-center mx-4 font-sans"><h2 class="text-xl font-semibold mb-4 flex justify-center items-center">Your Feedback</h2><textarea class="w-full p-2 border border-gray-300 rounded-md mb-4" rows="4" placeholder="Please provide your feedback..."></textarea><div class="flex justify-center space-x-4"><button class="font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline">Cancel</button><button class="font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline">Submit'), $cdf7e442067abc24$var$ym = $cdf7e442067abc24$var$ge('<div class="w-full h-full flex flex-col items-center justify-center px-4 py-8 rounded-lg"><div class="w-full max-w-md bg-white shadow-lg rounded-lg overflow-hidden"><div class="p-6"><h2 class="text-xl font-bold mb-2"></h2><form class="space-y-4"><div class="pt-4"><button type="submit" class="w-full py-2 px-4 text-white font-semibold rounded-md focus:outline-none transition duration-300 ease-in-out">Submit'), $cdf7e442067abc24$var$wm = $cdf7e442067abc24$var$ge('<p class="text-gray-600 mb-6">'), $cdf7e442067abc24$var$Gm = $cdf7e442067abc24$var$ge('<div class="space-y-2"><label class="block text-sm font-medium">'), $cdf7e442067abc24$var$Lm = $cdf7e442067abc24$var$ge('<input type="text" class="w-full px-3 py-2 rounded-md focus:outline-none" required>'), $cdf7e442067abc24$var$Cm = $cdf7e442067abc24$var$ge('<input type="number" class="w-full px-3 py-2 rounded-md focus:outline-none" required>'), $cdf7e442067abc24$var$Bm = $cdf7e442067abc24$var$ge('<div class="flex items-center"><input type="checkbox" class="h-4 w-4 rounded text-blue-600 focus:ring-blue-500"><span class="ml-2">Yes'), $cdf7e442067abc24$var$Em = $cdf7e442067abc24$var$ge('<select class="w-full px-3 py-2 rounded-md focus:outline-none" required><option value="">Select an option'), $cdf7e442067abc24$var$Nm = $cdf7e442067abc24$var$ge("<option>"), $cdf7e442067abc24$var$Om = $cdf7e442067abc24$var$ge('<button class="group w-12 h-12 flex items-center justify-center relative rounded-[10px] overflow-hidden transition-colors duration-200"><img class="w-full h-full bg-cover"><span class="absolute hidden group-hover:flex items-center justify-center z-10 w-full h-full top-0 left-0 bg-black/10 rounded-[10px] transition-colors duration-200">'), $cdf7e442067abc24$var$Im = $cdf7e442067abc24$var$ge('<div class="inline-flex basis-auto flex-grow-0 flex-shrink-0 justify-between items-center rounded-xl h-12 p-1 mr-1 bg-gray-500"><audio class="block bg-cover bg-center w-full h-full rounded-none text-transparent" controls></audio><button class="w-7 h-7 flex items-center justify-center bg-transparent p-1">'), $cdf7e442067abc24$var$km = $cdf7e442067abc24$var$ge('<div class="w-full flex flex-row flex-wrap px-5 py-[10px] gap-2">'), $cdf7e442067abc24$var$Xm = $cdf7e442067abc24$var$ge('<div class="flex items-center gap-1 px-5"><span class="text-sm text-gray-700">Try these prompts'), $cdf7e442067abc24$var$Dm = $cdf7e442067abc24$var$ge('<div class="w-full flex items-center justify-start gap-2 px-5 pt-2 border-t border-[#eeeeee]">'), $cdf7e442067abc24$var$Rm = $cdf7e442067abc24$var$ge('<div><div class="flex flex-col w-full h-full justify-start z-0"><div class="overflow-y-scroll flex flex-col flex-grow min-w-full w-full px-3 pt-[70px] relative scrollable-container chatbot-chat-view scroll-smooth"></div><div class="w-full px-5 pt-2 pb-1">'), $cdf7e442067abc24$var$Fm = $cdf7e442067abc24$var$ge('<div class="absolute top-0 left-0 bottom-0 right-0 w-full h-full z-50">'), $cdf7e442067abc24$var$Vm = $cdf7e442067abc24$var$ge('<div class="absolute top-0 left-0 bottom-0 right-0 flex flex-col items-center justify-center bg-black/60 backdrop-blur-sm text-white z-40 gap-2 border-2 border-dashed"><h2 class="text-xl font-semibold">Drop here to upload'), $cdf7e442067abc24$var$Hm = $cdf7e442067abc24$var$ge("<span>"), $cdf7e442067abc24$var$Um = $cdf7e442067abc24$var$ge("<span>Max Allowed Size: <!> MB"), $cdf7e442067abc24$var$Km = $cdf7e442067abc24$var$ge("<div>"), $cdf7e442067abc24$var$Wm = $cdf7e442067abc24$var$ge('<span class="px-3 whitespace-pre-wrap font-semibold max-w-full">'), $cdf7e442067abc24$var$Zm = $cdf7e442067abc24$var$ge("<span>Clear"), $cdf7e442067abc24$var$Qm = $cdf7e442067abc24$var$ge('<div class="flex flex-row items-center w-full h-[50px] absolute top-0 left-0 z-10"><div>'), $cdf7e442067abc24$var$zm = $cdf7e442067abc24$var$ge('<div class="w-full flex items-center justify-between p-4 border border-[#eeeeee]"><div class="w-full flex items-center justify-between gap-3"><span class="text-base">To record audio, use modern browsers like Chrome or Firefox that support audio recording.</span><button class="py-2 px-4 justify-center flex items-center bg-red-500 text-white rounded-md" type="button">Okay'), $cdf7e442067abc24$var$Ym = $cdf7e442067abc24$var$ge("<span>Send"), $cdf7e442067abc24$var$Jm = $cdf7e442067abc24$var$ge('<div class="h-[58px] flex items-center justify-between chatbot-input border border-[#eeeeee]" data-testid="input"><div class="flex items-center gap-3 px-4 py-2"><span></span><span></span></div><div class="flex items-center">'), $cdf7e442067abc24$var$jm = $cdf7e442067abc24$var$ge('<span class="ml-1.5">Sending...'), $cdf7e442067abc24$var$qm = "Hi there! How can I help?", $cdf7e442067abc24$var$eg = "#ffffff", $cdf7e442067abc24$var$rg = "#303235", $cdf7e442067abc24$var$og = (e)=>$cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return e.isOpen;
        },
        get children () {
            const r = $cdf7e442067abc24$var$_m(), o = r.firstChild, t = o.firstChild.nextSibling, a = t.nextSibling.firstChild, l = a.nextSibling;
            return r.style.setProperty("background", "rgba(0, 0, 0, 0.4)"), o.style.setProperty("background", "white"), o.style.setProperty("color", "black"), t.$$input = (r)=>e.setFeedbackValue(r.target.value), $cdf7e442067abc24$var$pe(a, "click", e.onClose, !0), a.style.setProperty("background", "#ef4444"), a.style.setProperty("color", "white"), $cdf7e442067abc24$var$pe(l, "click", e.onSubmit, !0), l.style.setProperty("background", "#3b82f6"), l.style.setProperty("color", "white"), $cdf7e442067abc24$var$M(()=>t.value = e.feedbackValue), r;
        }
    }), $cdf7e442067abc24$var$tg = (e)=>{
    const [r, o] = $cdf7e442067abc24$var$f({}), t = (e, r)=>{
        o((o)=>({
                ...o,
                [e]: r
            }));
    }, a = (o)=>{
        o.preventDefault(), e.onSubmit(r());
    };
    {
        const r = $cdf7e442067abc24$var$ym(), o = r.firstChild, l = o.firstChild, i = l.firstChild, n = i.nextSibling, d = n.firstChild, s = d.firstChild;
        return r.style.setProperty("font-family", "Poppins, sans-serif"), o.style.setProperty("font-family", "Poppins, sans-serif"), $cdf7e442067abc24$var$$e(i, ()=>e.title), $cdf7e442067abc24$var$$e(l, (()=>{
            const r = $cdf7e442067abc24$var$T(()=>!!e.description);
            return ()=>r() && (()=>{
                    const r = $cdf7e442067abc24$var$wm();
                    return $cdf7e442067abc24$var$$e(r, ()=>e.description), $cdf7e442067abc24$var$M(()=>null != (e.textColor || $cdf7e442067abc24$var$rg) ? r.style.setProperty("color", e.textColor || $cdf7e442067abc24$var$rg) : r.style.removeProperty("color")), r;
                })();
        })(), n), n.addEventListener("submit", a), $cdf7e442067abc24$var$$e(n, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
            get each () {
                return e.inputParams;
            },
            children: (e)=>{
                var r;
                return $cdf7e442067abc24$var$$e((r = $cdf7e442067abc24$var$Gm()).firstChild, ()=>e.label), $cdf7e442067abc24$var$$e(r, (()=>{
                    const r = $cdf7e442067abc24$var$T(()=>"string" === e.type);
                    return ()=>r() && (()=>{
                            const r = $cdf7e442067abc24$var$Lm();
                            return r.$$input = (r)=>t(e.name, r.target.value), r.addEventListener("blur", (e)=>e.target.style.border = "1px solid #9ca3af"), r.addEventListener("focus", (e)=>e.target.style.border = "1px solid #3b82f6"), r.style.setProperty("border", "1px solid #9ca3af"), r.style.setProperty("border-radius", "0.375rem"), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "name", e.name)), r;
                        })();
                })(), null), $cdf7e442067abc24$var$$e(r, (()=>{
                    const r = $cdf7e442067abc24$var$T(()=>"number" === e.type);
                    return ()=>r() && (()=>{
                            const r = $cdf7e442067abc24$var$Cm();
                            return r.$$input = (r)=>t(e.name, parseFloat(r.target.value)), r.addEventListener("blur", (e)=>e.target.style.border = "1px solid #9ca3af"), r.addEventListener("focus", (e)=>e.target.style.border = "1px solid #3b82f6"), r.style.setProperty("border", "1px solid #9ca3af"), r.style.setProperty("border-radius", "0.375rem"), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "name", e.name)), r;
                        })();
                })(), null), $cdf7e442067abc24$var$$e(r, (()=>{
                    const r = $cdf7e442067abc24$var$T(()=>"boolean" === e.type);
                    return ()=>r() && (()=>{
                            const r = $cdf7e442067abc24$var$Bm(), o = r.firstChild;
                            return o.addEventListener("change", (r)=>t(e.name, r.target.checked)), o.style.setProperty("border", "1px solid #9ca3af"), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(o, "name", e.name)), r;
                        })();
                })(), null), $cdf7e442067abc24$var$$e(r, (()=>{
                    const r = $cdf7e442067abc24$var$T(()=>"options" === e.type);
                    return ()=>r() && (()=>{
                            const r = $cdf7e442067abc24$var$Em();
                            return r.firstChild, r.addEventListener("change", (r)=>t(e.name, r.target.value)), r.addEventListener("blur", (e)=>e.target.style.border = "1px solid #9ca3af"), r.addEventListener("focus", (e)=>e.target.style.border = "1px solid #3b82f6"), r.style.setProperty("border", "1px solid #9ca3af"), r.style.setProperty("border-radius", "0.375rem"), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                                get each () {
                                    return e.options;
                                },
                                children: (e)=>{
                                    {
                                        const r = $cdf7e442067abc24$var$Nm();
                                        return $cdf7e442067abc24$var$$e(r, ()=>e.label), $cdf7e442067abc24$var$M(()=>r.value = e.name), r;
                                    }
                                }
                            }), null), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "name", e.name)), r;
                        })();
                })(), null), r;
            }
        }), d), $cdf7e442067abc24$var$M((t)=>{
            var a = e.fontSize ? e.fontSize + "px" : "16px", l = e.parentBackgroundColor || $cdf7e442067abc24$var$eg, i = e.textColor || $cdf7e442067abc24$var$rg, n = e.fontSize ? e.fontSize + "px" : "16px", d = e.backgroundColor || $cdf7e442067abc24$var$eg, m = e.textColor || $cdf7e442067abc24$var$rg, g = e.sendButtonColor || "#3B81F6";
            return a !== t._v$ && (null != (t._v$ = a) ? r.style.setProperty("font-size", a) : r.style.removeProperty("font-size")), l !== t._v$2 && (null != (t._v$2 = l) ? r.style.setProperty("background", l) : r.style.removeProperty("background")), i !== t._v$3 && (null != (t._v$3 = i) ? r.style.setProperty("color", i) : r.style.removeProperty("color")), n !== t._v$4 && (null != (t._v$4 = n) ? o.style.setProperty("font-size", n) : o.style.removeProperty("font-size")), d !== t._v$5 && (null != (t._v$5 = d) ? o.style.setProperty("background", d) : o.style.removeProperty("background")), m !== t._v$6 && (null != (t._v$6 = m) ? o.style.setProperty("color", m) : o.style.removeProperty("color")), g !== t._v$7 && (null != (t._v$7 = g) ? s.style.setProperty("background-color", g) : s.style.removeProperty("background-color")), t;
        }, {
            _v$: void 0,
            _v$2: void 0,
            _v$3: void 0,
            _v$4: void 0,
            _v$5: void 0,
            _v$6: void 0,
            _v$7: void 0
        }), r;
    }
}, $cdf7e442067abc24$var$ag = (e)=>{
    const r = $cdf7e442067abc24$var$q({
        showTitle: !0
    }, e);
    let o, t;
    const [a, l] = $cdf7e442067abc24$var$f(""), [i, n] = $cdf7e442067abc24$var$f(!1), [d, s] = $cdf7e442067abc24$var$f(!1), [m, g] = $cdf7e442067abc24$var$f({}), [c, x] = $cdf7e442067abc24$var$f([
        {
            message: r.welcomeMessage ?? $cdf7e442067abc24$var$qm,
            type: "apiMessage"
        }
    ], {
        equals: !1
    }), [u, p] = $cdf7e442067abc24$var$f(!1), [h, S] = $cdf7e442067abc24$var$f(""), [, v] = $cdf7e442067abc24$var$f(!1), [$, b] = $cdf7e442067abc24$var$f([], {
        equals: !1
    }), [A, G] = $cdf7e442067abc24$var$f(!1), [L, C] = $cdf7e442067abc24$var$f(!1), [B, E] = $cdf7e442067abc24$var$f(), [N, O] = $cdf7e442067abc24$var$f(), [I, k] = $cdf7e442067abc24$var$f(!1), [X, D] = $cdf7e442067abc24$var$f(""), [R, F] = $cdf7e442067abc24$var$f(!1), [V, H] = $cdf7e442067abc24$var$f(!1), [U, K] = $cdf7e442067abc24$var$f(""), [W, Z] = $cdf7e442067abc24$var$f(null), [Q, Y] = $cdf7e442067abc24$var$f(""), [J, j] = $cdf7e442067abc24$var$f(""), [ee, te] = $cdf7e442067abc24$var$f(""), [ae, le] = $cdf7e442067abc24$var$f(""), [ie, ne] = ($cdf7e442067abc24$var$f({}), $cdf7e442067abc24$var$f([])), [de, se] = $cdf7e442067abc24$var$f([]), [me, ge] = $cdf7e442067abc24$var$f("00:00"), [ce, pe] = $cdf7e442067abc24$var$f(!1), [he, Se] = $cdf7e442067abc24$var$f(!1), [be, Ae] = $cdf7e442067abc24$var$f(!1), [fe, Me] = $cdf7e442067abc24$var$f(!1), [Pe, Te] = $cdf7e442067abc24$var$f([]), [_e, ye] = $cdf7e442067abc24$var$f(!1), [we, Ge] = $cdf7e442067abc24$var$f([]), [Le, Ce] = $cdf7e442067abc24$var$f("*"), [Be, Ee] = $cdf7e442067abc24$var$f({}), [Ne, Xe] = $cdf7e442067abc24$var$f({}), [De, Re] = $cdf7e442067abc24$var$f({}), [Fe, Ve] = $cdf7e442067abc24$var$f(!1), [He, Ue] = $cdf7e442067abc24$var$f({
        mediaSource: null,
        sourceBuffer: null,
        audio: null,
        chunkQueue: [],
        isBuffering: !1,
        audioFormat: null,
        abortController: null
    });
    let Ke = !1, We = null;
    $cdf7e442067abc24$var$T(()=>{
        var e = r.chatflowConfig?.vars?.customerId;
        S(e ? e.toString() + "+" + $cdf7e442067abc24$var$ze() : $cdf7e442067abc24$var$ze());
    }), $cdf7e442067abc24$var$y(()=>{
        if (e?.observersConfig) {
            const { observeUserInput: r, observeLoading: o, observeMessages: t } = e.observersConfig;
            "function" == typeof r && $cdf7e442067abc24$var$T(()=>{
                r(a());
            }), "function" == typeof o && $cdf7e442067abc24$var$T(()=>{
                o(i());
            }), "function" == typeof t && $cdf7e442067abc24$var$T(()=>{
                t(c());
            });
        }
    });
    const Ze = ()=>{
        setTimeout(()=>{
            o?.scrollTo(0, o.scrollHeight);
        }, 50);
    }, Qe = (e)=>{
        Ke = e, We && (clearTimeout(We), We = null), e && (We = setTimeout(()=>{
            Ke = !1, We = null;
        }, 300));
    }, Ye = (e)=>{
        e = e.map((e)=>{
            var r;
            return e.fileUploads ? (r = e?.fileUploads.map((e)=>({
                    type: e.type,
                    name: e.name,
                    mime: e.mime
                })), {
                ...e,
                fileUploads: r
            }) : e;
        }), $cdf7e442067abc24$var$Ie(r.chatflowid, h(), {
            chatHistory: e
        });
    };
    let Je;
    const qe = ()=>{
        if (r.textInput?.receiveMessageSound) {
            let e = "https://cdn.jsdelivr.net/gh/FlowiseAI/FlowiseChatEmbed@latest/src/assets/receive_message.mp3";
            r.textInput?.receiveSoundLocation && (e = r.textInput?.receiveSoundLocation), (Je = new Audio(e)).play();
        }
    };
    let er = !1;
    const rr = (e = "Oops! There seems to be an error. Please try again.", o)=>{
        let t = e;
        !o && r.errorMessage && (t = r.errorMessage), x((e)=>(e = [
                ...e,
                {
                    message: t,
                    type: "apiMessage"
                }
            ], Ye(e), e)), n(!1), l(""), Ge([]), Ze();
    }, or = ()=>{
        F(!1), ((e, r, o)=>{
            var t = new Date;
            t.setTime(t.getTime() + 24 * o * 3600000), o = "expires=" + t.toUTCString(), document.cookie = e + "=" + r + ";" + o + ";path=/";
        })("chatbotDisclaimer", "true", 365);
    }, tr = (e)=>{
        nr(e);
    }, ar = (e, r)=>{
        e.chatId && S(e.chatId), e.chatMessageId && x((r)=>("apiMessage" === (r = [
                ...$cdf7e442067abc24$var$qo.cloneDeep(r)
            ])[r.length - 1].type && (r[r.length - 1].messageId = e.chatMessageId), Ye(r), r)), "" === r && e.question && x((r)=>("apiMessage" !== (r = [
                ...$cdf7e442067abc24$var$qo.cloneDeep(r)
            ])[r.length - 2].type && (r[r.length - 2].message = e.question, Ye(r)), r)), e.followUpPrompts && (x((r)=>("userMessage" !== (r = [
                ...$cdf7e442067abc24$var$qo.cloneDeep(r)
            ])[r.length - 1].type && (r[r.length - 1].followUpPrompts = e.followUpPrompts, Ye(r)), r)), Te(JSON.parse(e.followUpPrompts)));
    }, lr = ()=>{
        n(!1), l(""), Ge([]), er = !1, setTimeout(()=>{
            Ze();
        }, 100);
    }, ir = async (e)=>{
        if (we().length) {
            if (L()) {
                var o = we().filter((e)=>"file:full" === e.type);
                if (0 < o.length) {
                    var t = new FormData;
                    for (const e of o)t.append("files", e.file);
                    if (t.append("chatId", h()), o = await (({ chatflowid: e, apiHost: r = "http://localhost:3000", formData: o, onRequest: t })=>$cdf7e442067abc24$var$Oe({
                            method: "POST",
                            url: r + `/api/v1/attachments/${e}/` + o.get("chatId"),
                            formData: o,
                            headers: {
                                "Content-Type": "multipart/form-data"
                            },
                            onRequest: t
                        }))({
                        chatflowid: r.chatflowid,
                        apiHost: r.apiHost,
                        formData: t
                    }), !o.data) throw new Error("Unable to upload documents");
                    for (const r of o.data){
                        var a = r.content;
                        const o = r.name;
                        var l = e.findIndex((e)=>e.name === o);
                        -1 !== l && (e[l] = {
                            ...e[l],
                            data: a,
                            name: o,
                            type: "file:full"
                        });
                    }
                }
            } else if (B()?.isRAGFileUploadAllowed && (o = we().filter((e)=>"file:rag" === e.type), 0 < o.length)) {
                var i = new FormData;
                for (const e of o)i.append("files", e.file);
                if (i.append("chatId", h()), !(await (({ chatflowid: e, apiHost: r = "http://localhost:3000", formData: o, onRequest: t })=>$cdf7e442067abc24$var$Oe({
                        method: "POST",
                        url: r + "/api/v1/vector/upsert/" + e,
                        formData: o,
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        onRequest: t
                    }))({
                    chatflowid: r.chatflowid,
                    apiHost: r.apiHost,
                    formData: i
                })).data) throw new Error("Unable to upload documents");
                await new Promise((e)=>setTimeout(e, 2500)), e = e.map((e)=>({
                        ...e,
                        type: "file:rag"
                    }));
            }
        }
        return e;
    }, nr = async (e, o, t)=>{
        if ("string" == typeof e && "" === e.trim()) {
            var a = 0 < de().filter((e)=>!e.mime.startsWith("image") && "audio" !== e.type).length;
            if (!de().length || de().length && a) return;
        }
        let i = {}, d = ("object" == typeof e && (i = e, e = Object.entries(e).map(([e, r])=>e + ": " + r).join("\n")), n(!0), Ze(), de().map((e)=>({
                data: e.data,
                type: e.type,
                name: e.name,
                mime: e.mime
            })));
        try {
            d = await ir(d);
        } catch (o) {
            return void rr("Unable to upload documents", !0);
        }
        if (de().forEach((e)=>URL.revokeObjectURL(e.preview)), se([]), x((r)=>(r = [
                ...r,
                {
                    message: e,
                    type: "userMessage",
                    fileUploads: d
                }
            ], Ye(r), r)), a = {
            question: e,
            chatId: h()
        }, "formInput" === J() && (a.form = i, delete a.question), d && 0 < d.length && (a.uploads = d), r.chatflowConfig && (a.overrideConfig = r.chatflowConfig), X() && (a.leadEmail = X()), o && (a.action = o), t && (a.humanInput = t), u()) (async (e, o)=>{
            const t = o.chatId, a = o.question;
            o.streaming = !0, $cdf7e442067abc24$var$Pm(r.apiHost + "/api/v1/prediction/" + e, {
                openWhenHidden: !0,
                method: "POST",
                body: JSON.stringify(o),
                headers: {
                    "Content-Type": "application/json"
                },
                async onopen (e) {
                    var r;
                    if (!e.ok || !e.headers.get("content-type")?.startsWith($cdf7e442067abc24$var$fm)) throw 429 === e.status ? (r = await e.text() ?? "Too many requests. Please try again later.", rr(r, !0), new Error(r)) : 403 === e.status ? (r = await e.text() ?? "Unauthorized", rr(r), new Error(r)) : 401 === e.status ? (r = await e.text() ?? "Unauthenticated", rr(r), new Error(r)) : new Error;
                },
                async onmessage (o) {
                    var l, i, n, d, s, m, g, c, u, p, h = JSON.parse(o.data);
                    switch(h.event){
                        case "start":
                            x((e)=>[
                                    ...e,
                                    {
                                        message: "",
                                        type: "apiMessage"
                                    }
                                ]);
                            break;
                        case "token":
                            p = h.data, x((e)=>("userMessage" !== (e = [
                                    ...$cdf7e442067abc24$var$qo.cloneDeep(e)
                                ])[e.length - 1].type && p && (e[e.length - 1].message += p, e[e.length - 1].rating = void 0, e[e.length - 1].dateTime = (new Date).toISOString(), er || (qe(), er = !0), Ye(e)), e));
                            break;
                        case "sourceDocuments":
                            u = h.data, x((e)=>{
                                var r = e.map((r, o)=>o === e.length - 1 ? {
                                        ...r,
                                        sourceDocuments: u
                                    } : r);
                                return Ye(r), [
                                    ...r
                                ];
                            });
                            break;
                        case "usedTools":
                            c = h.data, x((e)=>("userMessage" !== (e = [
                                    ...$cdf7e442067abc24$var$qo.cloneDeep(e)
                                ])[e.length - 1].type && (e[e.length - 1].usedTools = c, Ye(e)), e));
                            break;
                        case "fileAnnotations":
                            g = h.data, x((e)=>("userMessage" !== (e = [
                                    ...$cdf7e442067abc24$var$qo.cloneDeep(e)
                                ])[e.length - 1].type && (e[e.length - 1].fileAnnotations = g, Ye(e)), e));
                            break;
                        case "agentReasoning":
                            m = h.data, x((e)=>{
                                var r = e.map((r, o)=>o === e.length - 1 ? {
                                        ...r,
                                        agentReasoning: "string" == typeof m ? JSON.parse(m) : m
                                    } : r);
                                return Ye(r), [
                                    ...r
                                ];
                            });
                            break;
                        case "agentFlowEvent":
                            "INPROGRESS" === (s = h.data) ? x((e)=>[
                                    ...e,
                                    {
                                        message: "",
                                        type: "apiMessage",
                                        agentFlowEventStatus: s
                                    }
                                ]) : x((e)=>("userMessage" !== (e = [
                                    ...$cdf7e442067abc24$var$qo.cloneDeep(e)
                                ])[e.length - 1].type && (e[e.length - 1].agentFlowEventStatus = s), e));
                            break;
                        case "agentFlowExecutedData":
                            d = h.data, x((e)=>("userMessage" !== (e = [
                                    ...$cdf7e442067abc24$var$qo.cloneDeep(e)
                                ])[e.length - 1].type && (e[e.length - 1].agentFlowExecutedData = d, Ye(e)), e));
                            break;
                        case "action":
                            n = h.data, x((e)=>{
                                var r = e.map((r, o)=>o === e.length - 1 ? {
                                        ...r,
                                        action: "string" == typeof n ? JSON.parse(n) : n
                                    } : r);
                                return Ye(r), [
                                    ...r
                                ];
                            });
                            break;
                        case "artifacts":
                            i = h.data, x((e)=>("userMessage" !== (e = [
                                    ...$cdf7e442067abc24$var$qo.cloneDeep(e)
                                ])[e.length - 1].type && (e[e.length - 1].artifacts = i, Ye(e)), e));
                            break;
                        case "metadata":
                            ar(h.data, a);
                            break;
                        case "error":
                            l = h.data, x((e)=>((e = [
                                    ...$cdf7e442067abc24$var$qo.cloneDeep(e)
                                ]).push({
                                    message: r.errorMessage || l,
                                    type: "apiMessage"
                                }), Ye(e), e));
                            break;
                        case "abort":
                            v(!1), kr(), x((e)=>{
                                var r;
                                return "userMessage" !== (e = [
                                    ...$cdf7e442067abc24$var$qo.cloneDeep(e)
                                ])[e.length - 1].type && (r = e[e.length - 1].agentReasoning) && 0 < r.length && (e[e.length - 1].agentReasoning = r.filter((e)=>!e.nextAgent)), e;
                            }), lr();
                            break;
                        case "end":
                            $cdf7e442067abc24$var$Ie(e, t), lr();
                            break;
                        case "tts_start":
                            yr(h.data);
                            break;
                        case "tts_data":
                            Gr(h.data.audioChunk);
                            break;
                        case "tts_end":
                            Lr();
                            break;
                        case "tts_abort":
                            {
                                const e = h.data.chatMessageId;
                                Or(e);
                            }
                    }
                },
                async onclose () {
                    lr();
                },
                onerror (e) {
                    throw console.error("EventSource Error: ", e), lr(), e;
                }
            });
        })(r.chatflowid, a);
        else {
            if (o = await (({ chatflowid: e, apiHost: r = "http://localhost:3000", body: o, onRequest: t })=>$cdf7e442067abc24$var$Oe({
                    method: "POST",
                    url: r + "/api/v1/prediction/" + e,
                    body: o,
                    onRequest: t
                }))({
                chatflowid: r.chatflowid,
                apiHost: r.apiHost,
                body: a,
                onRequest: r.onRequest
            }), o.data) {
                const r = o.data;
                let t = "";
                t = r.text || (r.json ? JSON.stringify(r.json, null, 2) : JSON.stringify(r, null, 2)), r?.chatId && S(r.chatId), qe(), x((e)=>{
                    e = [
                        ...$cdf7e442067abc24$var$qo.cloneDeep(e)
                    ];
                    var o = {
                        message: t,
                        id: r?.chatMessageId,
                        sourceDocuments: r?.sourceDocuments,
                        usedTools: r?.usedTools,
                        fileAnnotations: r?.fileAnnotations,
                        agentReasoning: r?.agentReasoning,
                        agentFlowExecutedData: r?.agentFlowExecutedData,
                        action: r?.action,
                        artifacts: r?.artifacts,
                        type: "apiMessage",
                        feedback: null,
                        dateTime: (new Date).toISOString()
                    };
                    return e.push(o), Ye(e), e;
                }), ar(r, e), n(!1), l(""), Ge([]), Ze();
            }
            if (o.error) return t = o.error, console.error(t), "object" == typeof t ? void rr("Error: " + t?.message.replaceAll("Error:", " ")) : "string" == typeof t ? void rr(t) : void rr();
        }
        d && 0 < d.length && x((e)=>{
            var r = e.map((r, o)=>o === e.length - 2 && "userMessage" === r.type && r.fileUploads ? (o = r?.fileUploads.map((e)=>({
                        type: e.type,
                        name: e.name,
                        mime: e.mime
                    })), {
                    ...r,
                    fileUploads: o
                }) : r);
            return Ye(r), [
                ...r
            ];
        });
    }, dr = (e, r = "", o = "")=>{
        let t = Q();
        o && (t = o), o = r || t.charAt(0).toUpperCase() + t.slice(1), nr(o, void 0, {
            type: t,
            startNodeId: e?.nodeId,
            feedback: r
        });
    }, sr = ()=>{
        W() && (dr(W(), U()), H(!1), K(""), Z(null), Y(""));
    }, mr = ()=>{
        try {
            ((e)=>{
                var r = localStorage.getItem(e + "_EXTERNAL");
                if (r) try {
                    var o, t = JSON.parse(r);
                    t.lead ? (o = {
                        lead: t.lead
                    }, localStorage.removeItem(e + "_EXTERNAL"), localStorage.setItem(e + "_EXTERNAL", JSON.stringify(o))) : localStorage.removeItem(e + "_EXTERNAL");
                } catch (e) {}
            })(r.chatflowid), S(r.chatflowConfig?.vars?.customerId ? (r.chatflowConfig?.vars).customerId.toString() + "+" + $cdf7e442067abc24$var$ze() : $cdf7e442067abc24$var$ze()), Ge([]);
            var e = [
                {
                    message: r.welcomeMessage ?? $cdf7e442067abc24$var$qm,
                    type: "apiMessage"
                }
            ];
            N()?.status && !$cdf7e442067abc24$var$ke(r.chatflowid)?.lead && e.push({
                message: "",
                type: "leadCaptureMessage"
            }), x(e);
        } catch (r) {
            e = r.response.data || r.response.status + ": " + r.response.statusText, console.error("error: " + e);
        }
    };
    $cdf7e442067abc24$var$y(()=>{
        if (r.clearChatOnReload) return mr(), window.addEventListener("beforeunload", mr), ()=>{
            window.removeEventListener("beforeunload", mr);
        };
    }), $cdf7e442067abc24$var$P(()=>{
        if (r.starterPrompts) {
            let e;
            return e = Array.isArray(r.starterPrompts) ? r.starterPrompts : Object.values(r.starterPrompts).map((e)=>e.prompt), b(e.filter((e)=>"" !== e));
        }
    }), $cdf7e442067abc24$var$P(()=>{
        c() && 1 < c().length && !Ke && setTimeout(()=>{
            o?.scrollTo(0, o.scrollHeight);
        }, 400);
    }), $cdf7e442067abc24$var$P(()=>{
        r.fontSize && t && (t.style.fontSize = r.fontSize + "px");
    }), $cdf7e442067abc24$var$P(async ()=>{
        r.disclaimer && "true" != ((e)=>{
            var r = e + "=", o = decodeURIComponent(document.cookie).split(";");
            for(let e = 0; e < o.length; e++){
                let t = o[e];
                for(; " " === t.charAt(0);)t = t.substring(1);
                if (0 === t.indexOf(r)) return t.substring(r.length, t.length);
            }
            return "";
        })("chatbotDisclaimer") ? F(!0) : F(!1);
        var e = ((e = $cdf7e442067abc24$var$ke(r.chatflowid)) && Object.keys(e).length && (e.chatId && S(e.chatId), (o = e.lead) && (k(!!o), D(o.email)), o = (0 < e?.chatHistory?.length ? e.chatHistory?.map((e)=>{
            var r = {
                messageId: e?.messageId,
                message: e.message,
                type: e.type,
                rating: e.rating,
                dateTime: e.dateTime
            };
            return e.sourceDocuments && (r.sourceDocuments = e.sourceDocuments), e.fileAnnotations && (r.fileAnnotations = e.fileAnnotations), e.fileUploads && (r.fileUploads = e.fileUploads), e.agentReasoning && (r.agentReasoning = e.agentReasoning), e.action && (r.action = e.action), e.artifacts && (r.artifacts = e.artifacts), e.followUpPrompts && (r.followUpPrompts = e.followUpPrompts), e.execution && e.execution.executionData && (r.agentFlowExecutedData = "string" == typeof e.execution.executionData ? JSON.parse(e.execution.executionData) : e.execution.executionData), e.agentFlowExecutedData && (r.agentFlowExecutedData = "string" == typeof e.agentFlowExecutedData ? JSON.parse(e.agentFlowExecutedData) : e.agentFlowExecutedData), r;
        }) : [
            {
                message: r.welcomeMessage ?? $cdf7e442067abc24$var$qm,
                type: "apiMessage"
            }
        ]).filter((e)=>"leadCaptureMessage" !== e.type), x([
            ...o
        ])), await (({ chatflowid: e, apiHost: r = "http://localhost:3000", onRequest: o })=>$cdf7e442067abc24$var$Oe({
                method: "GET",
                url: r + "/api/v1/chatflows-streaming/" + e,
                onRequest: o
            }))({
            chatflowid: r.chatflowid,
            apiHost: r.apiHost,
            onRequest: r.onRequest
        })).data, o = (e && p(e?.isStreaming ?? !1), await (({ chatflowid: e, apiHost: r = "http://localhost:3000", onRequest: o })=>$cdf7e442067abc24$var$Oe({
                method: "GET",
                url: r + "/api/v1/public-chatbotConfig/" + e,
                onRequest: o
            }))({
            chatflowid: r.chatflowid,
            apiHost: r.apiHost,
            onRequest: r.onRequest
        }));
        if (o.data) {
            const a = o.data;
            if (a.flowData && (e = (JSON.parse(a.flowData).nodes ?? []).find((e)=>"startAgentflow" === e.data.name))) {
                o = e.data.inputs?.startInputType;
                var t = (j(o), e.data.inputs?.formInputTypes);
                if ("formInput" === o && t && 0 < t.length) {
                    for (const e of t)"options" === e.type && (e.options = e.addOptions.map((e)=>({
                            label: e.option,
                            name: e.option
                        })));
                    ne(t), te(e.data.inputs?.formTitle), le(e.data.inputs?.formDescription);
                }
            }
            if ((!r.starterPrompts || 0 === r.starterPrompts?.length) && a.starterPrompts) {
                const e = [];
                Object.getOwnPropertyNames(a.starterPrompts).forEach((r)=>{
                    e.push(a.starterPrompts[r].prompt);
                }), b(e.filter((e)=>"" !== e));
            }
            a.chatFeedback && (o = a.chatFeedback.status, G(o)), a.uploads && E(a.uploads), a.leads && (O(a.leads), a.leads?.status) && !$cdf7e442067abc24$var$ke(r.chatflowid)?.lead && x((e)=>[
                    ...e,
                    {
                        message: "",
                        type: "leadCaptureMessage"
                    }
                ]), a.followUpPrompts && Me(a.followUpPrompts.status), a.fullFileUpload && (C(a.fullFileUpload.status), a.fullFileUpload?.allowedUploadFileTypes) && Ce(a.fullFileUpload?.allowedUploadFileTypes), Ve(!!a.isTTSEnabled);
        }
        return ()=>{
            l(""), Ge([]), n(!1), x([
                {
                    message: r.welcomeMessage ?? $cdf7e442067abc24$var$qm,
                    type: "apiMessage"
                }
            ]);
        };
    });
    let gr = null, xr = null;
    $cdf7e442067abc24$var$P(()=>{
        var e = He();
        gr && gr !== e.sourceBuffer && xr && (gr.removeEventListener("updateend", xr), gr = null, xr = null), e.sourceBuffer && e.sourceBuffer !== gr && (e = e.sourceBuffer, gr = e, xr = ()=>{
            Ue((e)=>({
                    ...e,
                    isBuffering: !1
                })), setTimeout(()=>_r(), 0);
        }, e.addEventListener("updateend", xr));
    }), $cdf7e442067abc24$var$w(()=>{
        Br(), We && (clearTimeout(We), We = null);
    }), $cdf7e442067abc24$var$P(()=>{
        var e;
        fe() && 0 < c().length && ("apiMessage" === (e = c()[c().length - 1]).type && e.followUpPrompts ? Te(JSON.parse(e.followUpPrompts)) : "userMessage" === e.type && Te([]));
    });
    const ur = (e)=>{
        let r = "";
        var o = e.type.indexOf(";");
        r = -1 === o ? e.type : e.type.substring(0, o);
        const t = new FileReader;
        t.readAsDataURL(e), t.onloadend = ()=>{
            const e = {
                data: t.result,
                preview: "../assets/wave-sound.jpg",
                type: "audio",
                name: `audio_${Date.now()}.wav`,
                mime: r
            };
            se((r)=>[
                    ...r,
                    e
                ]);
        };
    }, pr = (e)=>{
        let r = !1;
        if (B() && B()?.isImageUploadAllowed && B()?.imgUploadSizeAndTypes) {
            const o = e.type, t = e.size / 1024 / 1024;
            B()?.imgUploadSizeAndTypes.map((e)=>{
                e.fileTypes.includes(o) && t <= e.maxUploadSize && (r = !0);
            });
        }
        if (L()) return !0;
        if (B() && B()?.isRAGFileUploadAllowed && B()?.fileUploadSizeAndTypes) {
            const o = e.name.split(".").pop();
            o && B()?.fileUploadSizeAndTypes.map((e)=>{
                (1 === e.fileTypes.length && "*" === e.fileTypes[0] || e.fileTypes.includes("." + o)) && (r = !0);
            });
        }
        return r || alert("Cannot upload file. Kindly check the allowed file types and maximum allowed size."), r;
    }, hr = async (e)=>{
        if ((e = e.target.files) && 0 !== e.length) {
            var r = [], o = [];
            for (const t of e){
                if (!1 === pr(t)) return;
                t.type && B()?.imgUploadSizeAndTypes.map((e)=>e.fileTypes).join(",").includes(t.type) || o.push({
                    file: t,
                    type: L() ? "file:full" : "file:rag"
                });
                const e = new FileReader, a = t.name;
                r.push(new Promise((r)=>{
                    e.onload = (e)=>{
                        e?.target?.result && (e = e.target.result, r({
                            data: e,
                            preview: URL.createObjectURL(t),
                            type: "file",
                            name: a,
                            mime: t.type
                        }));
                    }, e.readAsDataURL(t);
                }));
            }
            const t = await Promise.all(r);
            Ge(o), se((e)=>[
                    ...e,
                    ...t
                ]);
        }
    }, Sr = ()=>!!L() || !!B()?.isRAGFileUploadAllowed, vr = (e)=>{
        (B()?.isImageUploadAllowed || Sr()) && (e.preventDefault(), e.stopPropagation(), "dragenter" === e.type || "dragover" === e.type ? ye(!0) : "dragleave" === e.type && ye(!1));
    }, $r = async (e)=>{
        B(), e.preventDefault(), ye(!1);
        var r = [], o = [];
        if (e.dataTransfer && 0 < e.dataTransfer.files.length) {
            for (const t of e.dataTransfer.files){
                if (!1 === pr(t)) return;
                t.type && B()?.imgUploadSizeAndTypes.map((e)=>e.fileTypes).join(",").includes(t.type) || o.push({
                    file: t,
                    type: L() ? "file:full" : "file:rag"
                });
                const e = new FileReader, a = t.name;
                r.push(new Promise((r)=>{
                    e.onload = (e)=>{
                        if (e?.target?.result) {
                            let o;
                            e = e.target.result, t.type.startsWith("audio/") ? o = "../assets/wave-sound.jpg" : t.type.startsWith("image/") && (o = URL.createObjectURL(t)), r({
                                data: e,
                                preview: o,
                                type: "file",
                                name: a,
                                mime: t.type
                            });
                        }
                    }, e.readAsDataURL(t);
                }));
            }
            const t = await Promise.all(r);
            Ge(o), se((e)=>[
                    ...e,
                    ...t
                ]);
        }
        if (e.dataTransfer && e.dataTransfer.items) for (const r of e.dataTransfer.items)"string" === r.kind && r.type.match("^text/uri-list") ? r.getAsString((e)=>{
            const r = {
                data: e,
                preview: e,
                type: "url",
                name: e.substring(e.lastIndexOf("/") + 1),
                mime: ""
            };
            se((e)=>[
                    ...e,
                    r
                ]);
        }) : "string" === r.kind && r.type.match("^text/html") && r.getAsString((e)=>{
            if (-1 !== e.indexOf("href")) {
                const r = {
                    data: e = (e = e.substring(e.indexOf("href") + 6)).substring(0, e.indexOf('"')),
                    preview: e,
                    type: "url",
                    name: e.substring(e.lastIndexOf("/") + 1),
                    mime: ""
                };
                se((e)=>[
                        ...e,
                        r
                    ]);
            }
        });
    }, Ar = (e)=>{
        "file" === e.type && URL.revokeObjectURL(e.preview), se(de().filter((r)=>r !== e));
    }, fr = ()=>{
        pe(!0), $cdf7e442067abc24$var$Qn(pe, Se, ge);
    }, Mr = ()=>{
        he || ($cdf7e442067abc24$var$Jn.cancel(), clearInterval($cdf7e442067abc24$var$Zn)), pe(!1), Se(!1);
    }, Pr = async ()=>{
        Ae(!0), $cdf7e442067abc24$var$zn(ur);
    }, Tr = ()=>{
        var e = c();
        return !!(i() || !r.chatflowid || N()?.status && !I() || e[e.length - 1].action && 0 < Object.keys(e[e.length - 1].action).length);
    }, _r = ()=>{
        var e = He();
        if (e.sourceBuffer && !e.sourceBuffer.updating && 0 !== e.chunkQueue.length) {
            var r = e.chunkQueue[0];
            if (r) try {
                e.sourceBuffer.appendBuffer(r), Ue((e)=>({
                        ...e,
                        chunkQueue: e.chunkQueue.slice(1),
                        isBuffering: !0
                    }));
            } catch (e) {
                console.error("Error appending chunk to buffer:", e);
            }
        }
    }, yr = (e)=>{
        Qe(!0), kr(), Ee((r)=>({
                ...r,
                [e.chatMessageId]: !0
            })), x((r)=>{
            var o, t = (r = [
                ...$cdf7e442067abc24$var$qo.cloneDeep(r)
            ])[r.length - 1];
            return "userMessage" !== t.type && ((o = t.id || t.messageId) ? t.id || (r[r.length - 1].id = o) : r[r.length - 1].id = e.chatMessageId), r;
        }), Ue({
            mediaSource: null,
            sourceBuffer: null,
            audio: null,
            chunkQueue: [],
            isBuffering: !1,
            audioFormat: e.format,
            abortController: null
        }), setTimeout(()=>Cr(e), 100);
    }, Gr = (e)=>{
        try {
            const r = Uint8Array.from(atob(e), (e)=>e.charCodeAt(0));
            Ue((e)=>{
                var o = {
                    ...e,
                    chunkQueue: [
                        ...e.chunkQueue,
                        r
                    ]
                };
                return e.sourceBuffer && !e.sourceBuffer.updating && setTimeout(()=>_r(), 0), o;
            });
        } catch (e) {
            console.error("Error handling TTS data chunk:", e);
        }
    }, Lr = ()=>{
        var e = He();
        if (e.mediaSource && "open" === e.mediaSource.readyState) try {
            if (e.sourceBuffer && 0 < e.chunkQueue.length && !e.sourceBuffer.updating) {
                const r = [
                    ...e.chunkQueue
                ];
                r.forEach((e, o)=>{
                    setTimeout(()=>{
                        var t = He();
                        if (t.sourceBuffer && !t.sourceBuffer.updating) try {
                            t.sourceBuffer.appendBuffer(e), o === r.length - 1 && setTimeout(()=>{
                                var e = He();
                                e.mediaSource && "open" === e.mediaSource.readyState && e.mediaSource.endOfStream();
                            }, 100);
                        } catch (t) {
                            console.error("Error appending remaining chunk:", t);
                        }
                    }, 50 * o);
                }), Ue((e)=>({
                        ...e,
                        chunkQueue: []
                    }));
            } else e.sourceBuffer && !e.sourceBuffer.updating ? e.mediaSource.endOfStream() : e.sourceBuffer && e.sourceBuffer.addEventListener("updateend", ()=>{
                var e = He();
                e.mediaSource && "open" === e.mediaSource.readyState && e.mediaSource.endOfStream();
            }, {
                once: !0
            });
        } catch (e) {
            console.error("Error ending TTS stream:", e);
        }
    }, Cr = (e)=>{
        try {
            const r = new MediaSource, o = new Audio;
            o.preload = "none", o.autoplay = !1, o.src = URL.createObjectURL(r), r.addEventListener("sourceopen", ()=>{
                try {
                    e.format;
                    var t = "audio/mpeg";
                    if (MediaSource.isTypeSupported(t)) {
                        const e = r.addSourceBuffer(t);
                        Ue((t)=>({
                                ...t,
                                mediaSource: r,
                                sourceBuffer: e,
                                audio: o
                            })), o.play().catch((e)=>{
                            console.error("Error starting audio playback:", e), Br();
                        });
                    } else console.error("MediaSource does not support MIME type:", t);
                } catch (t) {
                    console.error("Error setting up source buffer:", t), console.error("MediaSource readyState:", r.readyState), Br();
                }
            }), o.addEventListener("playing", ()=>{
                Ee((r)=>(delete (r = {
                        ...r
                    })[e.chatMessageId], r)), Xe((r)=>({
                        ...r,
                        [e.chatMessageId]: !0
                    }));
            }), o.addEventListener("ended", ()=>{
                Xe((r)=>(delete (r = {
                        ...r
                    })[e.chatMessageId], r)), Br();
            }), o.addEventListener("error", (r)=>{
                console.error("Audio error during TTS playback:", r), Ee((r)=>(delete (r = {
                        ...r
                    })[e.chatMessageId], r)), Xe((r)=>(delete (r = {
                        ...r
                    })[e.chatMessageId], r)), Br();
            });
        } catch (r) {
            console.error("Error initializing TTS streaming:", r), Ee((r)=>(delete (r = {
                    ...r
                })[e.chatMessageId], r));
        }
    }, Br = ()=>{
        var e, r, o = He();
        if (o.abortController && o.abortController.abort(), o.audio && (o.audio.pause(), o.audio.currentTime = 0, o.audio.removeAttribute("src"), o.audio.load(), o.audio.src && URL.revokeObjectURL(o.audio.src), o.audio.removeEventListener("playing", ()=>console.log("Playing")), o.audio.removeEventListener("ended", ()=>console.log("Ended"))), o.sourceBuffer) {
            if (o.sourceBuffer.updating) try {
                o.sourceBuffer.abort();
            } catch (e) {}
            try {
                0 < o.sourceBuffer.buffered.length && (e = o.sourceBuffer.buffered.start(0), r = o.sourceBuffer.buffered.end(o.sourceBuffer.buffered.length - 1), o.sourceBuffer.remove(e, r));
            } catch (e) {}
            o.sourceBuffer.onupdateend && (o.sourceBuffer.removeEventListener("updateend", o.sourceBuffer.onupdateend), o.sourceBuffer.onupdateend = null);
        }
        if (o.mediaSource) {
            if ("open" === o.mediaSource.readyState) try {
                o.sourceBuffer && 0 < o.mediaSource.sourceBuffers.length && o.mediaSource.removeSourceBuffer(o.sourceBuffer), o.mediaSource.endOfStream();
            } catch (e) {}
            o.mediaSource.removeEventListener("sourceopen", ()=>console.log("removed source open event listener"));
        }
        Ue({
            mediaSource: null,
            sourceBuffer: null,
            audio: null,
            chunkQueue: [],
            isBuffering: !1,
            audioFormat: null,
            abortController: null
        });
    }, Or = (e)=>{
        var r;
        ((r = ((r = De())[e] && (r[e].pause(), r[e].currentTime = 0, r[e].src = "", r[e].load(), Re((r)=>(delete (r = {
                ...r
            })[e], r))), He())).audio || r.mediaSource || r.sourceBuffer) && Br(), Xe((r)=>(delete (r = {
                ...r
            })[e], r)), Ee((r)=>(delete (r = {
                ...r
            })[e], r));
    }, Ir = async (e)=>{
        Qe(!0);
        try {
            await $cdf7e442067abc24$var$je({
                apiHost: r.apiHost,
                body: {
                    chatflowId: r.chatflowid,
                    chatId: h(),
                    chatMessageId: e
                },
                onRequest: r.onRequest
            });
        } catch (r) {
            console.warn(`Error aborting TTS for message ${e}:`, r);
        }
        Or(e);
    }, kr = ()=>{
        const e = De();
        Object.keys(e).forEach((r)=>{
            e[r] && (e[r].pause(), e[r].currentTime = 0, e[r].src = "", e[r].load());
        }), Re({});
        var r = He();
        r.abortController && r.abortController.abort(), Br(), Xe({}), Ee({});
    }, Xr = async (e, o)=>{
        if (!(t = Be())[e]) {
            var t = Ne(), a = De()[e];
            if (t[e] || a) await Ir(e);
            else {
                Qe(!0);
                for (const e of Object.keys(Be()).concat(Object.keys(Ne())))try {
                    await $cdf7e442067abc24$var$je({
                        apiHost: r.apiHost,
                        body: {
                            chatflowId: r.chatflowid,
                            chatId: h(),
                            chatMessageId: e
                        },
                        onRequest: r.onRequest
                    });
                } catch (o) {
                    console.warn(`Error aborting TTS for message ${e}:`, o);
                }
                await 0, kr(), yr({
                    chatMessageId: e,
                    format: "mp3"
                });
                try {
                    const t = new AbortController;
                    Ue((e)=>({
                            ...e,
                            abortController: t
                        }));
                    var l = await (async ({ apiHost: e = "http://localhost:3000", body: r, onRequest: o, signal: t })=>(r = {
                            method: "POST",
                            mode: "cors",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(r),
                            signal: t
                        }, o && await o(r), fetch(e + "/api/v1/text-to-speech/generate", r)))({
                        apiHost: r.apiHost,
                        body: {
                            chatId: h(),
                            chatflowId: r.chatflowid,
                            chatMessageId: e,
                            text: o
                        },
                        onRequest: r.onRequest,
                        signal: t.signal
                    });
                    if (!l.ok) throw new Error("TTS request failed: " + l.status);
                    var i = l.body?.getReader(), n = new TextDecoder;
                    if (i) {
                        let e = "", r = !1;
                        for(; !r && !t.signal.aborted;){
                            var d = await i.read();
                            if (r = d.done) break;
                            var s = d.value, m = (e += n.decode(s, {
                                stream: !0
                            })).split("\n");
                            e = m.pop() || "";
                            for (const e of m)if (e.trim() && e.startsWith("data: ")) try {
                                var g = e.slice(6);
                                if ("[DONE]" === g) break;
                                var c = JSON.parse(g);
                                switch(c.event){
                                    case "tts_start":
                                        break;
                                    case "tts_data":
                                        t.signal.aborted || Gr(c.data.audioChunk);
                                        break;
                                    case "tts_end":
                                        t.signal.aborted || Lr();
                                }
                            } catch (o) {
                                console.error("Error parsing SSE event:", o);
                            }
                        }
                    }
                } catch (o) {
                    "AbortError" === o.name || (console.error("Error with TTS:", o), Ee((r)=>(delete (r = {
                            ...r
                        })[e], r)), Xe((r)=>(delete (r = {
                            ...r
                        })[e], r))), Or(e);
                } finally{
                    Ee((r)=>(delete (r = {
                            ...r
                        })[e], r));
                }
            }
        }
    };
    return $cdf7e442067abc24$var$P(function(e, r, o) {
        const t = Array.isArray(e);
        let a, l = o && o.defer;
        return (o)=>{
            let i;
            if (t) {
                i = Array(e.length);
                for(let r = 0; r < e.length; r++)i[r] = e[r]();
            } else i = e();
            var n;
            if (!l) return n = $cdf7e442067abc24$var$_(()=>r(i, a, o)), a = i, n;
            l = !1;
        };
    }(de, (e)=>{
        var r = 0 < e.filter((e)=>"audio" === e.type).length;
        return 1 <= e.length && r && (pe(!1), Se(!1), tr("")), ()=>{
            se([]);
        };
    })), [
        $cdf7e442067abc24$var$T((()=>{
            const n = $cdf7e442067abc24$var$T(()=>!("formInput" !== J() || 1 !== c().length));
            return ()=>{
                if (n()) return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$tg, {
                    get title () {
                        return ee();
                    },
                    get description () {
                        return ae();
                    },
                    get inputParams () {
                        return ie();
                    },
                    onSubmit: (e)=>nr(e),
                    get parentBackgroundColor () {
                        return r?.backgroundColor;
                    },
                    get backgroundColor () {
                        return r?.formBackgroundColor;
                    },
                    get textColor () {
                        return r?.formTextColor || r.botMessage?.textColor;
                    },
                    get sendButtonColor () {
                        return r.textInput?.sendButtonColor;
                    },
                    get fontSize () {
                        return r.fontSize;
                    }
                });
                {
                    const n = $cdf7e442067abc24$var$Rm(), m = n.firstChild, u = m.firstChild, p = u.nextSibling;
                    n.addEventListener("dragenter", vr);
                    var d = t;
                    return "function" == typeof d ? $cdf7e442067abc24$var$ve(d, n) : t = n, $cdf7e442067abc24$var$$e(n, (()=>{
                        const e = $cdf7e442067abc24$var$T(()=>!!_e());
                        return ()=>{
                            var r;
                            return e() && ((r = $cdf7e442067abc24$var$Fm()).addEventListener("drop", $r), r.addEventListener("dragover", vr), r.addEventListener("dragend", vr), r.addEventListener("dragleave", vr), r.addEventListener("dragenter", vr), r);
                        };
                    })(), m), $cdf7e442067abc24$var$$e(n, (()=>{
                        const e = $cdf7e442067abc24$var$T(()=>!(!_e() || !B()?.isImageUploadAllowed && !Sr()));
                        return ()=>e() && (()=>{
                                const e = $cdf7e442067abc24$var$Vm();
                                return e.firstChild, $cdf7e442067abc24$var$$e(e, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                                    get each () {
                                        return [
                                            ...B()?.imgUploadSizeAndTypes || [],
                                            ...B()?.fileUploadSizeAndTypes || []
                                        ];
                                    },
                                    children: (e)=>{
                                        var r;
                                        return [
                                            ($cdf7e442067abc24$var$$e(r = $cdf7e442067abc24$var$Hm(), ()=>e.fileTypes?.join(", ")), r),
                                            $cdf7e442067abc24$var$T((()=>{
                                                const r = $cdf7e442067abc24$var$T(()=>!!e.maxUploadSize);
                                                return ()=>{
                                                    var o, t;
                                                    return r() && ((t = (o = $cdf7e442067abc24$var$Um()).firstChild.nextSibling).nextSibling, $cdf7e442067abc24$var$$e(o, ()=>e.maxUploadSize, t), o);
                                                };
                                            })())
                                        ];
                                    }
                                }), null), $cdf7e442067abc24$var$M(()=>null != r.bubbleBackgroundColor ? e.style.setProperty("border-color", r.bubbleBackgroundColor) : e.style.removeProperty("border-color")), e;
                            })();
                    })(), m), $cdf7e442067abc24$var$$e(n, (()=>{
                        const e = $cdf7e442067abc24$var$T(()=>!!r.showTitle);
                        return ()=>{
                            if (e()) {
                                const e = $cdf7e442067abc24$var$Qm(), o = e.firstChild;
                                return $cdf7e442067abc24$var$$e(e, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                                    get when () {
                                        return r.titleAvatarSrc;
                                    },
                                    get children () {
                                        var e1;
                                        return [
                                            ((e1 = $cdf7e442067abc24$var$Km()).style.setProperty("width", "15px"), e1),
                                            $cdf7e442067abc24$var$z($cdf7e442067abc24$var$go, {
                                                get initialAvatarSrc () {
                                                    return r.titleAvatarSrc;
                                                }
                                            })
                                        ];
                                    }
                                }), o), $cdf7e442067abc24$var$$e(e, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                                    get when () {
                                        return r.title;
                                    },
                                    get children () {
                                        var e2 = $cdf7e442067abc24$var$Wm();
                                        return $cdf7e442067abc24$var$$e(e2, ()=>r.title), e2;
                                    }
                                }), o), o.style.setProperty("flex", "1"), $cdf7e442067abc24$var$$e(e, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Nr, {
                                    get sendButtonColor () {
                                        return r.bubbleTextColor;
                                    },
                                    type: "button",
                                    get isDisabled () {
                                        return 1 === c().length;
                                    },
                                    class: "my-2 ml-2",
                                    "on:click": mr,
                                    get children () {
                                        var e3 = $cdf7e442067abc24$var$Zm();
                                        return e3.style.setProperty("font-family", "Poppins, sans-serif"), e3;
                                    }
                                }), null), $cdf7e442067abc24$var$M((o)=>{
                                    var t = r.titleBackgroundColor || r.bubbleBackgroundColor || "#3B81F6", a = r.titleTextColor || r.bubbleTextColor || $cdf7e442067abc24$var$eg, l = r.isFullPage ? "0px" : "6px", i = r.isFullPage ? "0px" : "6px";
                                    return t !== o._v$10 && (null != (o._v$10 = t) ? e.style.setProperty("background", t) : e.style.removeProperty("background")), a !== o._v$11 && (null != (o._v$11 = a) ? e.style.setProperty("color", a) : e.style.removeProperty("color")), l !== o._v$12 && (null != (o._v$12 = l) ? e.style.setProperty("border-top-left-radius", l) : e.style.removeProperty("border-top-left-radius")), i !== o._v$13 && (null != (o._v$13 = i) ? e.style.setProperty("border-top-right-radius", i) : e.style.removeProperty("border-top-right-radius")), o;
                                }, {
                                    _v$10: void 0,
                                    _v$11: void 0,
                                    _v$12: void 0,
                                    _v$13: void 0
                                }), e;
                            }
                            return null;
                        };
                    })(), m), "function" == typeof (d = o) ? $cdf7e442067abc24$var$ve(d, u) : o = u, $cdf7e442067abc24$var$$e(u, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                        get each () {
                            return [
                                ...c()
                            ];
                        },
                        children: (e, o)=>[
                                $cdf7e442067abc24$var$T((()=>{
                                    const o = $cdf7e442067abc24$var$T(()=>"userMessage" === e.type);
                                    return ()=>o() && $cdf7e442067abc24$var$z($cdf7e442067abc24$var$No, {
                                            message: e,
                                            get apiHost () {
                                                return r.apiHost;
                                            },
                                            get chatflowid () {
                                                return r.chatflowid;
                                            },
                                            get chatId () {
                                                return h();
                                            },
                                            get backgroundColor () {
                                                return r.userMessage?.backgroundColor;
                                            },
                                            get textColor () {
                                                return r.userMessage?.textColor;
                                            },
                                            get showAvatar () {
                                                return r.userMessage?.showAvatar;
                                            },
                                            get avatarSrc () {
                                                return r.userMessage?.avatarSrc;
                                            },
                                            get fontSize () {
                                                return r.fontSize;
                                            },
                                            get renderHTML () {
                                                return r.renderHTML;
                                            }
                                        });
                                })()),
                                $cdf7e442067abc24$var$T((()=>{
                                    const t = $cdf7e442067abc24$var$T(()=>"apiMessage" === e.type);
                                    return ()=>t() && $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Oa, {
                                            message: e,
                                            get fileAnnotations () {
                                                return e.fileAnnotations;
                                            },
                                            get chatflowid () {
                                                return r.chatflowid;
                                            },
                                            get chatId () {
                                                return h();
                                            },
                                            get apiHost () {
                                                return r.apiHost;
                                            },
                                            get backgroundColor () {
                                                return r.botMessage?.backgroundColor;
                                            },
                                            get textColor () {
                                                return r.botMessage?.textColor;
                                            },
                                            get feedbackColor () {
                                                return r.feedback?.color;
                                            },
                                            get showAvatar () {
                                                return r.botMessage?.showAvatar;
                                            },
                                            get avatarSrc () {
                                                return r.botMessage?.avatarSrc;
                                            },
                                            get chatFeedbackStatus () {
                                                return A();
                                            },
                                            get fontSize () {
                                                return r.fontSize;
                                            },
                                            get isLoading () {
                                                return $cdf7e442067abc24$var$T(()=>!!i())() && o() === c().length - 1;
                                            },
                                            get showAgentMessages () {
                                                return r.showAgentMessages;
                                            },
                                            handleActionClick: (e, r)=>(async (e, r)=>{
                                                    var o;
                                                    l(e.label), x((e)=>{
                                                        var r = e.map((r, o)=>o === e.length - 1 ? {
                                                                ...r,
                                                                action: null
                                                            } : r);
                                                        return Ye(r), [
                                                            ...r
                                                        ];
                                                    }), e.type.includes("agentflowv2") ? (o = e.type.includes("approve") ? "proceed" : "reject", Y(o), r && r.data && r.data.input && r.data.input.humanInputEnableFeedback ? (Z(r.data), H(!0)) : r && dr(r.data, "", o)) : nr(e.label, r);
                                                })(e, r),
                                            get sourceDocsTitle () {
                                                return r.sourceDocsTitle;
                                            },
                                            handleSourceDocumentsClick: (e)=>{
                                                g(e), s(!0);
                                            },
                                            get dateTimeToggle () {
                                                return r.dateTimeToggle;
                                            },
                                            get renderHTML () {
                                                return r.renderHTML;
                                            },
                                            get isTTSEnabled () {
                                                return Fe();
                                            },
                                            get isTTSLoading () {
                                                return Be();
                                            },
                                            get isTTSPlaying () {
                                                return Ne();
                                            },
                                            handleTTSClick: Xr,
                                            handleTTSStop: Ir
                                        });
                                })()),
                                $cdf7e442067abc24$var$T((()=>{
                                    const o = $cdf7e442067abc24$var$T(()=>!("leadCaptureMessage" !== e.type || !N()?.status || $cdf7e442067abc24$var$ke(r.chatflowid)?.lead));
                                    return ()=>o() && $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Sm, {
                                            message: e,
                                            get chatflowid () {
                                                return r.chatflowid;
                                            },
                                            get chatId () {
                                                return h();
                                            },
                                            get apiHost () {
                                                return r.apiHost;
                                            },
                                            get backgroundColor () {
                                                return r.botMessage?.backgroundColor;
                                            },
                                            get textColor () {
                                                return r.botMessage?.textColor;
                                            },
                                            get fontSize () {
                                                return r.fontSize;
                                            },
                                            get showAvatar () {
                                                return r.botMessage?.showAvatar;
                                            },
                                            get avatarSrc () {
                                                return r.botMessage?.avatarSrc;
                                            },
                                            get leadsConfig () {
                                                return N();
                                            },
                                            get sendButtonColor () {
                                                return r.textInput?.sendButtonColor;
                                            },
                                            get isLeadSaved () {
                                                return I();
                                            },
                                            setIsLeadSaved: k,
                                            setLeadEmail: D
                                        });
                                })()),
                                $cdf7e442067abc24$var$T((()=>{
                                    const r = $cdf7e442067abc24$var$T(()=>!("userMessage" !== e.type || !i() || o() !== c().length - 1));
                                    return ()=>r() && $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Da, {});
                                })()),
                                $cdf7e442067abc24$var$T((()=>{
                                    const r = $cdf7e442067abc24$var$T(()=>!("apiMessage" !== e.type || "" !== e.message || !i() || o() !== c().length - 1));
                                    return ()=>r() && $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Da, {});
                                })())
                            ]
                    })), $cdf7e442067abc24$var$$e(m, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                        get when () {
                            return 1 === c().length;
                        },
                        get children () {
                            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                                get when () {
                                    return 0 < $().length;
                                },
                                get children () {
                                    var r1 = $cdf7e442067abc24$var$km();
                                    return $cdf7e442067abc24$var$$e(r1, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                                        get each () {
                                            return [
                                                ...$()
                                            ];
                                        },
                                        children: (r)=>$cdf7e442067abc24$var$z($cdf7e442067abc24$var$Fa, {
                                                prompt: r,
                                                onPromptClick: ()=>tr(r),
                                                get starterPromptFontSize () {
                                                    return e.starterPromptFontSize;
                                                }
                                            })
                                    })), r1;
                                }
                            });
                        }
                    }), p), $cdf7e442067abc24$var$$e(m, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                        get when () {
                            return $cdf7e442067abc24$var$T(()=>2 < c().length)() && fe();
                        },
                        get children () {
                            return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                                get when () {
                                    return 0 < Pe().length;
                                },
                                get children () {
                                    var r2, o1;
                                    return [
                                        (r2 = $cdf7e442067abc24$var$Xm(), o1 = r2.firstChild, $cdf7e442067abc24$var$$e(r2, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$wr, {
                                            class: "w-4 h-4"
                                        }), o1), r2),
                                        ($cdf7e442067abc24$var$$e(o1 = $cdf7e442067abc24$var$km(), $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                                            get each () {
                                                return [
                                                    ...Pe()
                                                ];
                                            },
                                            children: (r, o)=>$cdf7e442067abc24$var$z($cdf7e442067abc24$var$$m, {
                                                    prompt: r,
                                                    onPromptClick: ()=>{
                                                        var e;
                                                        return e = r, Te([]), void nr(e);
                                                    },
                                                    get starterPromptFontSize () {
                                                        return e.starterPromptFontSize;
                                                    }
                                                })
                                        })), o1)
                                    ];
                                }
                            });
                        }
                    }), p), $cdf7e442067abc24$var$$e(m, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                        get when () {
                            return 0 < de().length;
                        },
                        get children () {
                            var r3 = $cdf7e442067abc24$var$Dm();
                            return $cdf7e442067abc24$var$$e(r3, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$re, {
                                get each () {
                                    return [
                                        ...de()
                                    ];
                                },
                                children: (r)=>$cdf7e442067abc24$var$T(()=>{
                                        var t = r;
                                        if (t.mime.startsWith("image/")) {
                                            const e = $cdf7e442067abc24$var$Om(), r = e.firstChild, o = r.nextSibling;
                                            return e.$$click = ()=>Ar(t), $cdf7e442067abc24$var$$e(o, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$br, {})), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(r, "src", t.data)), e;
                                        }
                                        if (t.mime.startsWith("audio/")) {
                                            const r = $cdf7e442067abc24$var$Im(), a = r.firstChild, l = a.nextSibling;
                                            return l.$$click = ()=>Ar(t), $cdf7e442067abc24$var$$e(l, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$br, {
                                                color: "white"
                                            })), $cdf7e442067abc24$var$M((l)=>{
                                                var i = `${o ? e.isFullPage ? o?.offsetWidth / 4 : o?.offsetWidth / 2 : "200"}px`, n = t.data;
                                                return i !== l._v$8 && (null != (l._v$8 = i) ? r.style.setProperty("width", i) : r.style.removeProperty("width")), n !== l._v$9 && $cdf7e442067abc24$var$xe(a, "src", l._v$9 = n), l;
                                            }, {
                                                _v$8: void 0,
                                                _v$9: void 0
                                            }), r;
                                        }
                                        return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$io, {
                                            get disabled () {
                                                return Tr();
                                            },
                                            item: t,
                                            onDelete: ()=>Ar(t)
                                        });
                                    })
                            })), r3;
                        }
                    }), p), $cdf7e442067abc24$var$$e(p, (()=>{
                        const e = $cdf7e442067abc24$var$T(()=>!!ce());
                        return ()=>e() ? $cdf7e442067abc24$var$T((()=>{
                                const e = $cdf7e442067abc24$var$T(()=>!!he());
                                return ()=>{
                                    if (e()) return (o = $cdf7e442067abc24$var$zm()).firstChild.firstChild.nextSibling.$$click = ()=>Mr(), o;
                                    {
                                        const e = $cdf7e442067abc24$var$Jm(), o = e.firstChild, t = o.firstChild, a = t.nextSibling, l = o.nextSibling;
                                        return e.style.setProperty("margin", "auto"), $cdf7e442067abc24$var$$e(t, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$cr, {
                                            color: "red"
                                        })), $cdf7e442067abc24$var$$e(a, ()=>me() || "00:00"), $cdf7e442067abc24$var$$e(o, (()=>{
                                            const e = $cdf7e442067abc24$var$T(()=>!!be());
                                            return ()=>e() && $cdf7e442067abc24$var$jm();
                                        })(), null), $cdf7e442067abc24$var$$e(l, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$el, {
                                            get buttonColor () {
                                                return r.textInput?.sendButtonColor;
                                            },
                                            type: "button",
                                            class: "m-0",
                                            "on:click": Mr,
                                            get children () {
                                                var e1 = $cdf7e442067abc24$var$Ym();
                                                return e1.style.setProperty("font-family", "Poppins, sans-serif"), e1;
                                            }
                                        }), null), $cdf7e442067abc24$var$$e(l, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Er, {
                                            get sendButtonColor () {
                                                return r.textInput?.sendButtonColor;
                                            },
                                            type: "button",
                                            get isDisabled () {
                                                return i();
                                            },
                                            class: "m-0",
                                            "on:click": Pr,
                                            get children () {
                                                var e2 = $cdf7e442067abc24$var$Ym();
                                                return e2.style.setProperty("font-family", "Poppins, sans-serif"), e2;
                                            }
                                        }), null), $cdf7e442067abc24$var$M((o)=>{
                                            var t = r.textInput?.backgroundColor ?? $cdf7e442067abc24$var$eg, a = r.textInput?.textColor ?? $cdf7e442067abc24$var$rg;
                                            return t !== o._v$14 && (null != (o._v$14 = t) ? e.style.setProperty("background-color", t) : e.style.removeProperty("background-color")), a !== o._v$15 && (null != (o._v$15 = a) ? e.style.setProperty("color", a) : e.style.removeProperty("color")), o;
                                        }, {
                                            _v$14: void 0,
                                            _v$15: void 0
                                        }), e;
                                    }
                                    var o;
                                };
                            })()) : $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oo, {
                                get backgroundColor () {
                                    return r.textInput?.backgroundColor;
                                },
                                get textColor () {
                                    return r.textInput?.textColor;
                                },
                                get placeholder () {
                                    return r.textInput?.placeholder;
                                },
                                get sendButtonColor () {
                                    return r.textInput?.sendButtonColor;
                                },
                                get maxChars () {
                                    return r.textInput?.maxChars;
                                },
                                get maxCharsWarningMessage () {
                                    return r.textInput?.maxCharsWarningMessage;
                                },
                                get autoFocus () {
                                    return r.textInput?.autoFocus;
                                },
                                get fontSize () {
                                    return r.fontSize;
                                },
                                get disabled () {
                                    return Tr();
                                },
                                get inputValue () {
                                    return a();
                                },
                                onInputChange: (e)=>l(e),
                                onSubmit: nr,
                                get uploadsConfig () {
                                    return B();
                                },
                                get isFullFileUpload () {
                                    return L();
                                },
                                get fullFileUploadAllowedTypes () {
                                    return Le();
                                },
                                setPreviews: se,
                                onMicrophoneClicked: fr,
                                handleFileChange: hr,
                                get sendMessageSound () {
                                    return r.textInput?.sendMessageSound;
                                },
                                get sendSoundLocation () {
                                    return r.textInput?.sendSoundLocation;
                                },
                                enableInputHistory: !0,
                                maxHistorySize: 10
                            });
                    })()), $cdf7e442067abc24$var$$e(m, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Ka, {
                        get footer () {
                            return r.footer;
                        },
                        get badgeBackgroundColor () {
                            return r.badgeBackgroundColor;
                        },
                        get poweredByTextColor () {
                            return r.poweredByTextColor;
                        },
                        botContainer: t
                    }), null), $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$ue(n, "relative flex w-full h-full text-base overflow-hidden bg-cover bg-center flex-col items-center chatbot-container " + r.class)), n;
                }
            };
        })()),
        $cdf7e442067abc24$var$T((()=>{
            const e = $cdf7e442067abc24$var$T(()=>!!d());
            return ()=>e() && $cdf7e442067abc24$var$z($cdf7e442067abc24$var$za, {
                    get isOpen () {
                        return d();
                    },
                    get value () {
                        return m();
                    },
                    onClose: ()=>s(!1)
                });
        })()),
        $cdf7e442067abc24$var$T((()=>{
            const e = $cdf7e442067abc24$var$T(()=>!!R());
            return ()=>e() && $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ja, {
                    get isOpen () {
                        return R();
                    },
                    onAccept: or,
                    get title () {
                        return r.disclaimer?.title;
                    },
                    get message () {
                        return r.disclaimer?.message;
                    },
                    get textColor () {
                        return r.disclaimer?.textColor;
                    },
                    get buttonColor () {
                        return r.disclaimer?.buttonColor;
                    },
                    get buttonText () {
                        return r.disclaimer?.buttonText;
                    },
                    get buttonTextColor () {
                        return r.disclaimer?.buttonTextColor;
                    },
                    get blurredBackgroundColor () {
                        return r.disclaimer?.blurredBackgroundColor;
                    },
                    get backgroundColor () {
                        return r.disclaimer?.backgroundColor;
                    },
                    get denyButtonBgColor () {
                        return r.disclaimer?.denyButtonBgColor;
                    },
                    get denyButtonText () {
                        return r.disclaimer?.denyButtonText;
                    },
                    get onDeny () {
                        return r.closeBot;
                    },
                    get isFullPage () {
                        return r.isFullPage;
                    }
                });
        })()),
        $cdf7e442067abc24$var$T((()=>{
            const e = $cdf7e442067abc24$var$T(()=>!!V());
            return ()=>e() && $cdf7e442067abc24$var$z($cdf7e442067abc24$var$og, {
                    get isOpen () {
                        return V();
                    },
                    onClose: ()=>{
                        H(!1), sr();
                    },
                    onSubmit: sr,
                    get feedbackValue () {
                        return U();
                    },
                    setFeedbackValue: (e)=>K(e)
                });
        })())
    ];
}, $cdf7e442067abc24$var$lg = ($cdf7e442067abc24$var$ce([
    "input",
    "click"
]), $cdf7e442067abc24$var$ge('<div class="tooltip">')), $cdf7e442067abc24$var$ig = (e)=>{
    var r = e.tooltipMessage ?? "Hi There \uD83D\uDC4B!";
    const o = e.tooltipBackgroundColor ?? "black", t = e.tooltipTextColor ?? "white", a = `${e.tooltipFontSize ?? 16}px`, l = 20 < r.length ? r.split(" ").reduce((e, r)=>{
        var o = e[e.length - 1];
        return o && o.join(" ").length + r.length <= 20 ? o.push(r) : e.push([
            r
        ]), e;
    }, [
        []
    ]).map((e)=>e.join(" ")).join("\n") : r;
    return $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
        get when () {
            return e.showTooltip;
        },
        get children () {
            const r = $cdf7e442067abc24$var$lg();
            return null != o ? r.style.setProperty("--tooltip-background-color", o) : r.style.removeProperty("--tooltip-background-color"), null != t ? r.style.setProperty("--tooltip-text-color", t) : r.style.removeProperty("--tooltip-text-color"), null != a ? r.style.setProperty("--tooltip-font-size", a) : r.style.removeProperty("--tooltip-font-size"), $cdf7e442067abc24$var$$e(r, l), $cdf7e442067abc24$var$M((o)=>{
                var t = `calc(${e.position.right}px + 20px)`, a = e.position.bottom + e.buttonSize + 10 + "px";
                return t !== o._v$ && (null != (o._v$ = t) ? r.style.setProperty("right", t) : r.style.removeProperty("right")), a !== o._v$2 && (null != (o._v$2 = a) ? r.style.setProperty("bottom", a) : r.style.removeProperty("bottom")), o;
            }, {
                _v$: void 0,
                _v$2: void 0
            }), r;
        }
    });
}, $cdf7e442067abc24$var$ng = $cdf7e442067abc24$var$ge("<style>"), $cdf7e442067abc24$var$dg = $cdf7e442067abc24$var$ge('<button class="py-2 pr-3 absolute top-0 right-[-8px] m-[6px] bg-transparent text-white rounded-full z-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:brightness-100 transition-all filter hover:brightness-90 active:brightness-75" title="Close Chat"><svg viewBox="0 0 24 24" width="24" height="24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z">'), $cdf7e442067abc24$var$sg = $cdf7e442067abc24$var$ge('<div class="relative h-full">'), $cdf7e442067abc24$var$mg = $cdf7e442067abc24$var$ge('<div part="bot">'), $cdf7e442067abc24$var$gg = "white", $cdf7e442067abc24$var$cg = (e)=>{
    const [r] = $cdf7e442067abc24$var$ee(e, [
        "theme"
    ]), [o, t] = $cdf7e442067abc24$var$f(!1), [a, l] = $cdf7e442067abc24$var$f(!1), [i, n] = $cdf7e442067abc24$var$f({
        bottom: r.theme?.button?.bottom ?? 20,
        right: r.theme?.button?.right ?? 20
    }), d = ()=>{
        t(!1);
    };
    var s;
    $cdf7e442067abc24$var$w(()=>{
        l(!1);
    });
    const m = $cdf7e442067abc24$var$Xe(e.theme?.button?.size), g = (e.theme?.button?.bottom ?? 20) + m + 10, c = ($cdf7e442067abc24$var$P(()=>{
        const e = document.createElement("meta");
        return e.name = "viewport", e.content = "width=device-width, initial-scale=1.0, interactive-widget=resizes-content", document.head.appendChild(e), ()=>{
            document.head.removeChild(e);
        };
    }), r.theme?.tooltip?.showTooltip ?? !1);
    return [
        $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return e.theme?.customCSS;
            },
            get children () {
                var r1 = $cdf7e442067abc24$var$ng();
                return $cdf7e442067abc24$var$$e(r1, ()=>e.theme?.customCSS), r1;
            }
        }),
        ($cdf7e442067abc24$var$$e(s = $cdf7e442067abc24$var$ng(), $cdf7e442067abc24$var$Be), s),
        $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ig, {
            get showTooltip () {
                return c && !o();
            },
            get position () {
                return i();
            },
            buttonSize: m,
            get tooltipMessage () {
                return r.theme?.tooltip?.tooltipMessage;
            },
            get tooltipBackgroundColor () {
                return r.theme?.tooltip?.tooltipBackgroundColor;
            },
            get tooltipTextColor () {
                return r.theme?.tooltip?.tooltipTextColor;
            },
            get tooltipFontSize () {
                return r.theme?.tooltip?.tooltipFontSize;
            }
        }),
        $cdf7e442067abc24$var$z($cdf7e442067abc24$var$Ve, $cdf7e442067abc24$var$q(()=>r.theme?.button, {
            toggleBot: ()=>{
                o() ? d() : (a() || l(!0), t(!0));
            },
            get isBotOpened () {
                return o();
            },
            setButtonPosition: n,
            get dragAndDrop () {
                return r.theme?.button?.dragAndDrop ?? !1;
            },
            get autoOpen () {
                return r.theme?.button?.autoWindowOpen?.autoOpen ?? !1;
            },
            get openDelay () {
                return r.theme?.button?.autoWindowOpen?.openDelay;
            },
            get autoOpenOnMobile () {
                return r.theme?.button?.autoWindowOpen?.autoOpenOnMobile ?? !1;
            }
        })),
        (()=>{
            const t = $cdf7e442067abc24$var$mg();
            return t.style.setProperty("transition", "transform 200ms cubic-bezier(0, 1.2, 1, 1), opacity 150ms ease-out"), t.style.setProperty("transform-origin", "bottom right"), t.style.setProperty("box-shadow", "rgb(0 0 0 / 16%) 0px 5px 40px"), t.style.setProperty("background-size", "cover"), t.style.setProperty("background-position", "center"), t.style.setProperty("background-repeat", "no-repeat"), t.style.setProperty("z-index", "42424242"), $cdf7e442067abc24$var$$e(t, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                get when () {
                    return a();
                },
                get children () {
                    var t1 = $cdf7e442067abc24$var$sg();
                    return $cdf7e442067abc24$var$$e(t1, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
                        get when () {
                            return o();
                        },
                        get children () {
                            const e = $cdf7e442067abc24$var$dg(), o = e.firstChild.firstChild;
                            return e.$$click = d, $cdf7e442067abc24$var$M(()=>$cdf7e442067abc24$var$xe(o, "fill", r.theme?.button?.iconColor ?? $cdf7e442067abc24$var$gg)), e;
                        }
                    }), null), $cdf7e442067abc24$var$$e(t1, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ag, {
                        get backgroundColor () {
                            return r.theme?.chatWindow?.backgroundColor;
                        },
                        get formBackgroundColor () {
                            return r.theme?.form?.backgroundColor;
                        },
                        get formTextColor () {
                            return r.theme?.form?.textColor;
                        },
                        get badgeBackgroundColor () {
                            return r.theme?.chatWindow?.backgroundColor;
                        },
                        get bubbleBackgroundColor () {
                            return r.theme?.button?.backgroundColor ?? "#3B81F6";
                        },
                        get bubbleTextColor () {
                            return r.theme?.button?.iconColor ?? $cdf7e442067abc24$var$gg;
                        },
                        get showTitle () {
                            return r.theme?.chatWindow?.showTitle;
                        },
                        get showAgentMessages () {
                            return r.theme?.chatWindow?.showAgentMessages;
                        },
                        get title () {
                            return r.theme?.chatWindow?.title;
                        },
                        get titleAvatarSrc () {
                            return r.theme?.chatWindow?.titleAvatarSrc;
                        },
                        get titleTextColor () {
                            return r.theme?.chatWindow?.titleTextColor;
                        },
                        get titleBackgroundColor () {
                            return r.theme?.chatWindow?.titleBackgroundColor;
                        },
                        get welcomeMessage () {
                            return r.theme?.chatWindow?.welcomeMessage;
                        },
                        get errorMessage () {
                            return r.theme?.chatWindow?.errorMessage;
                        },
                        get poweredByTextColor () {
                            return r.theme?.chatWindow?.poweredByTextColor;
                        },
                        get textInput () {
                            return r.theme?.chatWindow?.textInput;
                        },
                        get botMessage () {
                            return r.theme?.chatWindow?.botMessage;
                        },
                        get userMessage () {
                            return r.theme?.chatWindow?.userMessage;
                        },
                        get feedback () {
                            return r.theme?.chatWindow?.feedback;
                        },
                        get fontSize () {
                            return r.theme?.chatWindow?.fontSize;
                        },
                        get footer () {
                            return r.theme?.chatWindow?.footer;
                        },
                        get sourceDocsTitle () {
                            return r.theme?.chatWindow?.sourceDocsTitle;
                        },
                        get starterPrompts () {
                            return r.theme?.chatWindow?.starterPrompts;
                        },
                        get starterPromptFontSize () {
                            return r.theme?.chatWindow?.starterPromptFontSize;
                        },
                        get chatflowid () {
                            return e.chatflowid;
                        },
                        get chatflowConfig () {
                            return e.chatflowConfig;
                        },
                        get apiHost () {
                            return e.apiHost;
                        },
                        get onRequest () {
                            return e.onRequest;
                        },
                        get observersConfig () {
                            return e.observersConfig;
                        },
                        get clearChatOnReload () {
                            return r.theme?.chatWindow?.clearChatOnReload;
                        },
                        get disclaimer () {
                            return r.theme?.disclaimer;
                        },
                        get dateTimeToggle () {
                            return r.theme?.chatWindow?.dateTimeToggle;
                        },
                        get renderHTML () {
                            return e.theme?.chatWindow?.renderHTML;
                        },
                        closeBot: d
                    }), null), t1;
                }
            })), $cdf7e442067abc24$var$M((e)=>{
                var a = r.theme?.chatWindow?.height ? r.theme?.chatWindow?.height.toString() + "px" : "calc(100% - 150px)", l = r.theme?.chatWindow?.width ? r.theme?.chatWindow?.width.toString() + "px" : void 0, n = o() ? "scale3d(1, 1, 1)" : "scale3d(0, 0, 1)", d = r.theme?.chatWindow?.backgroundColor || "#ffffff", s = r.theme?.chatWindow?.backgroundImage ? `url(${r.theme?.chatWindow?.backgroundImage})` : "none", c = Math.min(i().bottom + m + 10, window.innerHeight - g) + "px", x = Math.max(0, Math.min(i().right, window.innerWidth - (r.theme?.chatWindow?.width ?? 410) - 10)) + "px", u = "fixed sm:right-5 rounded-lg w-full sm:w-[400px] max-h-[704px]" + (o() ? " opacity-1" : " opacity-0 pointer-events-none") + ` bottom-${g}px`;
                return a !== e._v$ && (null != (e._v$ = a) ? t.style.setProperty("height", a) : t.style.removeProperty("height")), l !== e._v$2 && (null != (e._v$2 = l) ? t.style.setProperty("width", l) : t.style.removeProperty("width")), n !== e._v$3 && (null != (e._v$3 = n) ? t.style.setProperty("transform", n) : t.style.removeProperty("transform")), d !== e._v$4 && (null != (e._v$4 = d) ? t.style.setProperty("background-color", d) : t.style.removeProperty("background-color")), s !== e._v$5 && (null != (e._v$5 = s) ? t.style.setProperty("background-image", s) : t.style.removeProperty("background-image")), c !== e._v$6 && (null != (e._v$6 = c) ? t.style.setProperty("bottom", c) : t.style.removeProperty("bottom")), x !== e._v$7 && (null != (e._v$7 = x) ? t.style.setProperty("right", x) : t.style.removeProperty("right")), u !== e._v$8 && $cdf7e442067abc24$var$ue(t, e._v$8 = u), e;
            }, {
                _v$: void 0,
                _v$2: void 0,
                _v$3: void 0,
                _v$4: void 0,
                _v$5: void 0,
                _v$6: void 0,
                _v$7: void 0,
                _v$8: void 0
            }), t;
        })()
    ];
}, $cdf7e442067abc24$var$xg = ($cdf7e442067abc24$var$ce([
    "click"
]), $cdf7e442067abc24$var$ge("<style>")), $cdf7e442067abc24$var$ug = $cdf7e442067abc24$var$ge("<div>"), $cdf7e442067abc24$var$pg = (e, { element: r })=>{
    const [o, t] = $cdf7e442067abc24$var$f(!1), a = new IntersectionObserver((e)=>{
        e.some((e)=>e.isIntersecting) && (t(!0), document.body.style.margin = "0", document.documentElement.style.padding = "0", e = document.querySelector('meta[name="viewport"]')) && e.setAttribute("content", "width=device-width, initial-scale=1.0, interactive-widget=resizes-content");
    });
    var l;
    return $cdf7e442067abc24$var$y(()=>{
        a.observe(r);
    }), $cdf7e442067abc24$var$w(()=>{
        a.disconnect(), document.body.style.margin = "", document.documentElement.style.padding = "";
        var e = document.querySelector('meta[name="viewport"]');
        e && e.setAttribute("content", "width=device-width, initial-scale=1.0");
    }), [
        $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return e.theme?.customCSS;
            },
            get children () {
                var r1 = $cdf7e442067abc24$var$xg();
                return $cdf7e442067abc24$var$$e(r1, ()=>e.theme?.customCSS), r1;
            }
        }),
        ($cdf7e442067abc24$var$$e(l = $cdf7e442067abc24$var$xg(), $cdf7e442067abc24$var$Be), l),
        $cdf7e442067abc24$var$z($cdf7e442067abc24$var$oe, {
            get when () {
                return o();
            },
            get children () {
                const r = $cdf7e442067abc24$var$ug();
                return r.style.setProperty("margin", "0px"), r.style.setProperty("overflow", "hidden"), $cdf7e442067abc24$var$$e(r, $cdf7e442067abc24$var$z($cdf7e442067abc24$var$ag, {
                    get backgroundColor () {
                        return e.theme?.chatWindow?.backgroundColor;
                    },
                    get formBackgroundColor () {
                        return e.theme?.form?.backgroundColor;
                    },
                    get formTextColor () {
                        return e.theme?.form?.textColor;
                    },
                    get badgeBackgroundColor () {
                        return e.theme?.chatWindow?.backgroundColor;
                    },
                    get bubbleBackgroundColor () {
                        return e.theme?.button?.backgroundColor ?? "#3B81F6";
                    },
                    get bubbleTextColor () {
                        return e.theme?.button?.iconColor ?? "white";
                    },
                    get showTitle () {
                        return e.theme?.chatWindow?.showTitle;
                    },
                    get showAgentMessages () {
                        return e.theme?.chatWindow?.showAgentMessages;
                    },
                    get title () {
                        return e.theme?.chatWindow?.title;
                    },
                    get titleAvatarSrc () {
                        return e.theme?.chatWindow?.titleAvatarSrc;
                    },
                    get titleTextColor () {
                        return e.theme?.chatWindow?.titleTextColor;
                    },
                    get titleBackgroundColor () {
                        return e.theme?.chatWindow?.titleBackgroundColor;
                    },
                    get welcomeMessage () {
                        return e.theme?.chatWindow?.welcomeMessage;
                    },
                    get errorMessage () {
                        return e.theme?.chatWindow?.errorMessage;
                    },
                    get poweredByTextColor () {
                        return e.theme?.chatWindow?.poweredByTextColor;
                    },
                    get textInput () {
                        return e.theme?.chatWindow?.textInput;
                    },
                    get botMessage () {
                        return e.theme?.chatWindow?.botMessage;
                    },
                    get userMessage () {
                        return e.theme?.chatWindow?.userMessage;
                    },
                    get feedback () {
                        return e.theme?.chatWindow?.feedback;
                    },
                    get fontSize () {
                        return e.theme?.chatWindow?.fontSize;
                    },
                    get footer () {
                        return e.theme?.chatWindow?.footer;
                    },
                    get starterPrompts () {
                        return e.theme?.chatWindow?.starterPrompts;
                    },
                    get chatflowid () {
                        return e.chatflowid;
                    },
                    get chatflowConfig () {
                        return e.chatflowConfig;
                    },
                    get apiHost () {
                        return e.apiHost;
                    },
                    get onRequest () {
                        return e.onRequest;
                    },
                    isFullPage: !0,
                    get observersConfig () {
                        return e.observersConfig;
                    },
                    get starterPromptFontSize () {
                        return e.theme?.chatWindow?.starterPromptFontSize;
                    },
                    get clearChatOnReload () {
                        return e.theme?.chatWindow?.clearChatOnReload;
                    },
                    get disclaimer () {
                        return e.theme?.disclaimer;
                    },
                    get dateTimeToggle () {
                        return e.theme?.chatWindow?.dateTimeToggle;
                    },
                    get renderHTML () {
                        return e.theme?.chatWindow?.renderHTML;
                    }
                })), $cdf7e442067abc24$var$M((o)=>{
                    var t = e.theme?.chatWindow?.backgroundColor || "#ffffff", a = e.theme?.chatWindow?.height ? e.theme?.chatWindow?.height.toString() + "px" : "100dvh", l = e.theme?.chatWindow?.width ? e.theme?.chatWindow?.width.toString() + "px" : "100%";
                    return t !== o._v$ && (null != (o._v$ = t) ? r.style.setProperty("background-color", t) : r.style.removeProperty("background-color")), a !== o._v$2 && (null != (o._v$2 = a) ? r.style.setProperty("height", a) : r.style.removeProperty("height")), l !== o._v$3 && (null != (o._v$3 = l) ? r.style.setProperty("width", l) : r.style.removeProperty("width")), o;
                }, {
                    _v$: void 0,
                    _v$2: void 0,
                    _v$3: void 0
                }), r;
            }
        })
    ];
};
let $cdf7e442067abc24$var$hg;
const $cdf7e442067abc24$var$Sg = (e)=>{
    $cdf7e442067abc24$var$$g();
    let r = e.id ? document.getElementById(e.id) : document.querySelector("flowise-fullchatbot");
    r ? Object.assign(r, e) : (r = document.createElement("flowise-fullchatbot"), Object.assign(r, e), document.body.appendChild(r)), $cdf7e442067abc24$var$hg = r;
}, $cdf7e442067abc24$var$vg = (e)=>{
    $cdf7e442067abc24$var$$g();
    var r = document.createElement("flowise-chatbot");
    Object.assign(r, e), document.body.appendChild(r), $cdf7e442067abc24$var$hg = r;
}, $cdf7e442067abc24$var$$g = ()=>{
    $cdf7e442067abc24$var$hg?.remove();
}, $cdf7e442067abc24$export$2e2bcd8739ae039 = ("undefined" != typeof window && ($cdf7e442067abc24$var$Le("flowise-fullchatbot", $cdf7e442067abc24$var$Ce, $cdf7e442067abc24$var$pg), $cdf7e442067abc24$var$Le("flowise-chatbot", $cdf7e442067abc24$var$Ce, $cdf7e442067abc24$var$cg)), {
    initFull: $cdf7e442067abc24$var$Sg,
    init: $cdf7e442067abc24$var$vg,
    destroy: $cdf7e442067abc24$var$$g
});
((e)=>{
    "undefined" != typeof window && (window.Chatbot = {
        ...e
    });
})($cdf7e442067abc24$export$2e2bcd8739ae039);


const $e640bef1966ab6d6$var$DealDBPage = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    (0, $8nGP5.useEffect)(()=>{
        (0, $b2432f43c421c848$export$7a667d08ed65fa47)().store_audit_entry('VIEW_PAGE_DB', {
            page: 'DealDBPage'
        });
        (0, $cdf7e442067abc24$export$2e2bcd8739ae039).destroy();
    }, []);
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)("div", {
            className: "d-flex justify-content-center",
            style: {
                height: '100%'
            },
            children: [
                (0, $kSbwP.jsx)((0, $c852cf41bf4911ee$export$e7b94983f4222b90), {}),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "column",
                    className: "h-100 w-100",
                    children: [
                        (0, $kSbwP.jsx)((0, $77d5878715146af4$export$8b251419efc915eb), {
                            disableTicker: true,
                            showNewDeal: true
                        }),
                        (0, $kSbwP.jsx)((0, $a283eceebd9e41ec$export$632b367007f30628), {})
                    ]
                })
            ]
        })
    });
});
var $e640bef1966ab6d6$export$2e2bcd8739ae039 = $e640bef1966ab6d6$var$DealDBPage;



var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");





var $kSbwP = parcelRequire("kSbwP");

var $cd99893578b74628$export$1ca1ec8b29a4ce27;
var $cd99893578b74628$export$92c1809b3cc2873b;
var $cd99893578b74628$export$2346bec13f6779ca;
var $cd99893578b74628$export$bbdcaa338759c4ca;
var $cd99893578b74628$export$37cb010dc91d621e;
$cd99893578b74628$export$1ca1ec8b29a4ce27 = `bR3D2G_icon`;
$cd99893578b74628$export$92c1809b3cc2873b = `bR3D2G_scoreCard`;
$cd99893578b74628$export$2346bec13f6779ca = `bR3D2G_scoreLabel`;
$cd99893578b74628$export$bbdcaa338759c4ca = `bR3D2G_scoreNumber`;
$cd99893578b74628$export$37cb010dc91d621e = `bR3D2G_scoreText`;



const $e3b40bd6db1f40c5$export$e705734ce644674d = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    var icon = 'bi bi-check';
    var text = 'Strong';
    var color = '#00A171';
    if (p.score == null) debugger;
    var score = parseInt(p.score.toString());
    var scoreDisplay = score.toString();
    if (score > 85) ;
    else if (p.score == -1) {
        icon = 'bi bi-dash';
        text = 'No Data';
        color = '#6C757D';
        scoreDisplay = '--';
    } else if (score > 55) {
        // Medium
        icon = 'bi bi-dash';
        text = 'Medium';
        color = '#FF9F00';
    } else {
        // Weak
        icon = 'bi bi-x';
        text = 'Weak';
        color = '#DD2222';
    }
    // Check if we should show dots instead of score
    const shouldShowDots = p.score == -1 || isNaN(score);
    const finalScoreDisplay = shouldShowDots ? '...' : scoreDisplay;
    var iconCls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('bi', icon, $cd99893578b74628$export$1ca1ec8b29a4ce27);
    return (0, $kSbwP.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($cd99893578b74628$export$92c1809b3cc2873b, p.className),
        children: [
            (0, $kSbwP.jsx)("i", {
                className: iconCls,
                style: {
                    color: color
                }
            }),
            (0, $kSbwP.jsxs)("div", {
                className: $cd99893578b74628$export$37cb010dc91d621e,
                children: [
                    (0, $kSbwP.jsx)("span", {
                        className: $cd99893578b74628$export$bbdcaa338759c4ca,
                        style: {
                            color: color
                        },
                        children: finalScoreDisplay
                    }),
                    (0, $kSbwP.jsx)("span", {
                        className: $cd99893578b74628$export$2346bec13f6779ca,
                        style: {
                            color: color
                        },
                        children: text
                    })
                ]
            })
        ]
    });
});




var $kSbwP = parcelRequire("kSbwP");
var $05cd79ec61a0a305$export$d13f5cc425f7d974;
var $05cd79ec61a0a305$export$40a9eeef55665a40;
var $05cd79ec61a0a305$export$8fe35dc8637e3206;
var $05cd79ec61a0a305$export$93b7586d956c930e;
var $05cd79ec61a0a305$export$9218fcc08fed1387;
var $05cd79ec61a0a305$export$4f9756682a863729;
var $05cd79ec61a0a305$export$a3fef09eac1baa75;
var $05cd79ec61a0a305$export$736b6cf572925334;
var $05cd79ec61a0a305$export$f843afa9e9b53052;
var $05cd79ec61a0a305$export$417d8c6682ca6007;
var $05cd79ec61a0a305$export$a62276682e66b561;
var $05cd79ec61a0a305$export$91ebb600d7a82645;
var $05cd79ec61a0a305$export$ae78d338ad66ff90;
var $05cd79ec61a0a305$export$b8972b998723d602;
var $05cd79ec61a0a305$export$13925b5cf10ba292;
var $05cd79ec61a0a305$export$e63129c0d9da4beb;
$05cd79ec61a0a305$export$d13f5cc425f7d974 = `_8RP5ba_columnHeader`;
$05cd79ec61a0a305$export$40a9eeef55665a40 = `_8RP5ba_defaultPadding`;
$05cd79ec61a0a305$export$8fe35dc8637e3206 = `_8RP5ba_dollar`;
$05cd79ec61a0a305$export$93b7586d956c930e = `_8RP5ba_dropShadow`;
$05cd79ec61a0a305$export$9218fcc08fed1387 = `_8RP5ba_editHandIcon`;
$05cd79ec61a0a305$export$4f9756682a863729 = `_8RP5ba_editable`;
$05cd79ec61a0a305$export$a3fef09eac1baa75 = `_8RP5ba_edited`;
$05cd79ec61a0a305$export$736b6cf572925334 = `_8RP5ba_modified_data`;
$05cd79ec61a0a305$export$f843afa9e9b53052 = `_8RP5ba_panelImage`;
$05cd79ec61a0a305$export$417d8c6682ca6007 = `_8RP5ba_rowLabel`;
$05cd79ec61a0a305$export$a62276682e66b561 = `_8RP5ba_rowValue`;
$05cd79ec61a0a305$export$91ebb600d7a82645 = `_8RP5ba_rowValueBoolean`;
$05cd79ec61a0a305$export$ae78d338ad66ff90 = `_8RP5ba_scaleInOut`;
$05cd79ec61a0a305$export$b8972b998723d602 = `_8RP5ba_shadow`;
$05cd79ec61a0a305$export$13925b5cf10ba292 = `_8RP5ba_small-shadow`;
$05cd79ec61a0a305$export$e63129c0d9da4beb = `_8RP5ba_source_page_entry`;



class $d121fd2a7a5df6ff$export$3d23a8262daf519 {
    static label(field) {
        return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            justify: "center",
            alignItems: "start",
            className: $05cd79ec61a0a305$export$417d8c6682ca6007,
            fillCell: true,
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: "title",
                    children: field.display
                }),
                field.description && (0, $kSbwP.jsx)("div", {
                    className: "desc",
                    children: field.description
                })
            ]
        });
    }
    static percent_label(field) {
        return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            justify: "center",
            alignItems: "start",
            className: $05cd79ec61a0a305$export$417d8c6682ca6007,
            fillCell: true,
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: "title",
                    children: (0, $kSbwP.jsx)("i", {
                        children: field.display
                    })
                }),
                field.description && (0, $kSbwP.jsx)("div", {
                    className: "desc",
                    children: field.description
                })
            ]
        });
    }
}



var $kSbwP = parcelRequire("kSbwP");




var $16a7a55287ab506a$exports = {};
$16a7a55287ab506a$exports = new URL("hand-edit-icon.0cb414cb.svg", import.meta.url).toString();





var $kSbwP = parcelRequire("kSbwP");
const $8421c2e6c1303cf8$export$1f54913ccc4368b1 = (props)=>{
    const align = props.alignItems || 'center';
    const justify = props.justifyContent || 'center';
    const cls = props.className || '';
    const style = props.style || {};
    return (0, $kSbwP.jsx)("div", {
        className: cls,
        style: Object.assign({
            display: 'flex',
            position: 'relative',
            alignItems: align,
            justifyContent: justify
        }, style),
        onClick: ()=>{
            props.onClick && props.onClick();
        },
        onDoubleClick: ()=>{
            props.onDoubleClick && props.onDoubleClick();
        },
        children: props.children
    });
};



var $gpaur = parcelRequire("gpaur");
let $7d2817d1c3724d77$var$removeClassTimeout = null;
class $7d2817d1c3724d77$export$2fae71e1297dd07b {
    static sources(row, col, data) {
        //Pencil edit icon
        const pencilEditIcon = (0, $kSbwP.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($16a7a55287ab506a$exports))),
            alt: "edit",
            className: $05cd79ec61a0a305$export$e63129c0d9da4beb + ' ' + $05cd79ec61a0a305$export$9218fcc08fed1387,
            onClick: ()=>{
                function removeRule() {
                    const stylesheet = document.styleSheets[0];
                    for(let i = 0; i < stylesheet.cssRules.length; i++)if (stylesheet.cssRules[i].selectorText === '.modified_js_tweaked') {
                        stylesheet.deleteRule(i);
                        break; // Stop after deleting
                    }
                }
                removeRule();
                setTimeout(()=>{
                    const stylesheet = document.styleSheets[0];
                    stylesheet.insertRule('.modified_js_tweaked {     animation: colorEditedFieldsAnimation 1s 1; animation-timing-function: ease-in-out; }', stylesheet.cssRules.length);
                }, 10);
                if ($7d2817d1c3724d77$var$removeClassTimeout) clearTimeout($7d2817d1c3724d77$var$removeClassTimeout);
                $7d2817d1c3724d77$var$removeClassTimeout = setTimeout(()=>{
                    removeRule();
                }, 10000);
            }
        }, "hand_icon");
        if (row.dontShowSources) data = [];
        const items = [];
        if (!Array.isArray(data)) data = [];
        // Pencil icon removed - using underline instead for edited values
        const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        const isSourceEdited = (()=>{
            if (row.editable && storeUI.showEditedUnderlines) {
                var q = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
                return q.isValueEditedAtAll(row.field.source) || q.isValueEditedAtAll(row.field.source + '_page_source');
            }
            return false;
        })();
        data.map((page, index)=>{
            const sourceClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($05cd79ec61a0a305$export$e63129c0d9da4beb, {
                [$05cd79ec61a0a305$export$a3fef09eac1baa75]: isSourceEdited
            });
            items.push((0, $kSbwP.jsx)("div", {
                className: sourceClasses,
                onClick: ()=>{
                    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
                    uiStore.requestPdfImagePage(page);
                },
                children: (0, $kSbwP.jsx)((0, $8421c2e6c1303cf8$export$1f54913ccc4368b1), {
                    children: page
                })
            }, page));
        });
        var isModified = false;
        if (row.editable) {
            var q = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
            if (q.isValueEditedAtAll(row.field.source + '_page_source')) isModified = true;
        }
        const containerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
            [$05cd79ec61a0a305$export$4f9756682a863729]: row.editable,
            [$05cd79ec61a0a305$export$736b6cf572925334]: isModified,
            ['modified_js_tweaked']: isModified
        });
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            justify: "start",
            alignItems: "center",
            className: containerClasses,
            style: {
                minWidth: 100
            },
            wrap: "wrap",
            children: items
        });
    }
    static button(display, onClick, data = null, isEnabled = true) {
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
            'fade-in': isEnabled
        });
        return (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
            variant: "light",
            onClick: ()=>onClick(data),
            style: {
                width: '70px',
                opacity: 0
            },
            className: cls,
            disabled: !isEnabled,
            children: display
        });
    }
    static percent(row, col, data) {
        const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        var isModified = false;
        if (row.editable && storeUI.showEditedUnderlines) {
            var q = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
            if (q.isValueEditedByRowCol(row, col)) isModified = true;
        }
        const containerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
            [$05cd79ec61a0a305$export$4f9756682a863729]: row.editable,
            [$05cd79ec61a0a305$export$736b6cf572925334]: isModified,
            ['modified_js_tweaked']: isModified
        });
        const valueClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($05cd79ec61a0a305$export$a62276682e66b561, {
            [$05cd79ec61a0a305$export$4f9756682a863729]: row.editable,
            [$05cd79ec61a0a305$export$736b6cf572925334]: isModified,
            [$05cd79ec61a0a305$export$a3fef09eac1baa75]: isModified,
            ['modified_js_tweaked']: isModified
        });
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            justify: "center",
            alignItems: "center",
            className: containerClasses,
            children: (0, $kSbwP.jsx)("div", {
                className: valueClasses,
                children: (0, $kSbwP.jsx)("i", {
                    children: data.toString()
                })
            })
        });
    }
    static score(row, col, data) {
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            alignItems: "center",
            justify: 'center',
            children: (0, $kSbwP.jsx)((0, $33ac36ca38f3f8d0$export$5fb755babf77fa30), {
                score: data
            })
        });
    }
    static dollar(row, col, data) {
        return $7d2817d1c3724d77$export$2fae71e1297dd07b.value(row, col, data /* , style.dollar */ );
    }
    static value(row, col, data, className) {
        const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        var isModified = false;
        if (row.editable && storeUI.showEditedUnderlines) {
            var q = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
            if (q.isValueEditedByRowCol(row, col)) isModified = true;
        }
        const containerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
            [$05cd79ec61a0a305$export$4f9756682a863729]: row.editable,
            [$05cd79ec61a0a305$export$736b6cf572925334]: isModified,
            ['modified_js_tweaked']: isModified,
            [className || '']: className !== undefined
        });
        const isEdited = (()=>{
            if (row.editable && storeUI.showEditedUnderlines) {
                var q = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
                return q.isValueEditedByRowCol(row, col);
            }
            return false;
        })();
        const valueClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($05cd79ec61a0a305$export$a62276682e66b561, {
            [$05cd79ec61a0a305$export$4f9756682a863729]: row.editable,
            [$05cd79ec61a0a305$export$a3fef09eac1baa75]: isEdited
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gpaur)))(data, `data is not null or undefined: ${row.field.source} ${col.column.source}`);
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            alignItems: "center",
            className: containerClasses,
            children: (0, $kSbwP.jsx)("div", {
                className: valueClasses,
                children: data.toString()
            })
        });
    }
    static custom(render) {
        const valueClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($05cd79ec61a0a305$export$a62276682e66b561);
        return (row, col, data)=>{
            return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                fillCell: true,
                alignItems: "center",
                className: valueClasses,
                children: render(row, col, data)
            });
        };
    }
    static icon(row, col, data) {
        return (0, $kSbwP.jsx)("div", {
            children: " PDF "
        });
    }
    static booleanCentered(row, col, data, centerIcon = false) {
        return $7d2817d1c3724d77$export$2fae71e1297dd07b.boolean(row, col, data, true);
    }
    static boolean(row, col, data, centerIcon = false) {
        const yes = (0, $kSbwP.jsx)("i", {
            className: "bi bi-check"
        });
        const no = (0, $kSbwP.jsx)("i", {
            className: "bi bi-x"
        });
        const unsure = (0, $kSbwP.jsx)("i", {
            className: "bi bi-question"
        });
        const icon = data === true || data === 1 ? yes : data === false ? no : unsure;
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            alignItems: "center",
            justify: centerIcon ? 'center' : 'start',
            children: (0, $kSbwP.jsx)("div", {
                className: $05cd79ec61a0a305$export$91ebb600d7a82645,
                children: icon
            })
        });
    }
}



var $kSbwP = parcelRequire("kSbwP");

var $kSbwP = parcelRequire("kSbwP");

var $cbaa28af8904e717$export$23e48554307a3492;
var $cbaa28af8904e717$export$181ff85155496734;
var $cbaa28af8904e717$export$9579a76b7b70a45f;
$cbaa28af8904e717$export$23e48554307a3492 = `fejckW_editIndustry`;
$cbaa28af8904e717$export$181ff85155496734 = `fejckW_textInput`;
$cbaa28af8904e717$export$9579a76b7b70a45f = `fejckW_typeahead-industry-edit`;




const $68d2907db623a0aa$var$TextBoxEditor = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    return (0, $kSbwP.jsx)("input", {
        autoFocus: true,
        type: "text",
        value: p.val.editCellValue,
        className: $cbaa28af8904e717$export$181ff85155496734,
        style: {
            width: '100%'
        },
        onFocus: (e)=>{
            // Seleciona automaticamente todo o conteúdo
            e.target.select();
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter') {
                const newValue = e.target.value;
                p.val.editCellValue = newValue;
                p.onEdit(newValue, true);
            }
        },
        onInput: (e)=>{
            const newValue = e.target.value;
            p.val.editCellValue = newValue;
        }
    });
});
const $68d2907db623a0aa$var$IndustryEditor = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const industry = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)().industryTypes;
    const options = industry.map((industry)=>{
        var name = industry.name;
        return {
            label: name,
            value: name,
            industry: name
        };
    });
    return (0, $kSbwP.jsx)((0, $987409511f795a07$export$2e2bcd8739ae039), {
        className: $cbaa28af8904e717$export$23e48554307a3492,
        dropup: true,
        id: "typeahead-industry-edit",
        labelKey: "label",
        positionFixed: true,
        onChange: (selected)=>{
            if (selected.length > 0) p.onEdit(selected[0]['value'], true);
        },
        options: options,
        placeholder: p.val.editCellValue,
        open: true
    });
});
const $68d2907db623a0aa$var$SubIndustryEditor = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const industry = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)().industryTypes;
    const industryValue = p.val.dealData['industry'];
    const subIndustry = industry.find((industry)=>industry.name == industryValue).subtypes;
    const options = subIndustry.map((industry)=>{
        var name = industry.name;
        return {
            label: name,
            value: name,
            industry: name
        };
    });
    return (0, $kSbwP.jsx)((0, $987409511f795a07$export$2e2bcd8739ae039), {
        className: $cbaa28af8904e717$export$23e48554307a3492,
        dropup: true,
        id: "typeahead-industry-edit",
        labelKey: "label",
        positionFixed: true,
        onChange: (selected)=>{
            if (selected.length > 0) p.onEdit(selected[0]['value'], true);
        },
        options: options,
        placeholder: p.val.editCellValue,
        open: true
    });
});
class $68d2907db623a0aa$export$44b5115104b4b812 {
}
Object.defineProperty($68d2907db623a0aa$export$44b5115104b4b812, "textbox", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (api)=>{
        return (0, $kSbwP.jsx)($68d2907db623a0aa$var$TextBoxEditor, Object.assign({}, api));
    }
});
Object.defineProperty($68d2907db623a0aa$export$44b5115104b4b812, "industry", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (api)=>{
        return (0, $kSbwP.jsx)($68d2907db623a0aa$var$IndustryEditor, Object.assign({}, api));
    }
});
Object.defineProperty($68d2907db623a0aa$export$44b5115104b4b812, "subIndustry", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (api)=>{
        return (0, $kSbwP.jsx)($68d2907db623a0aa$var$SubIndustryEditor, Object.assign({}, api));
    }
});





var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");
var $0a90de210c8d2546$exports = {};

$parcel$export($0a90de210c8d2546$exports, "defaultPadding", function () { return $0a90de210c8d2546$export$40a9eeef55665a40; }, function (v) { return $0a90de210c8d2546$export$40a9eeef55665a40 = v; });
$parcel$export($0a90de210c8d2546$exports, "disable_round_edges", function () { return $0a90de210c8d2546$export$486b53607e7afa2e; }, function (v) { return $0a90de210c8d2546$export$486b53607e7afa2e = v; });
$parcel$export($0a90de210c8d2546$exports, "dropShadow", function () { return $0a90de210c8d2546$export$93b7586d956c930e; }, function (v) { return $0a90de210c8d2546$export$93b7586d956c930e = v; });
$parcel$export($0a90de210c8d2546$exports, "gridContainer", function () { return $0a90de210c8d2546$export$711e2b273dbb00ac; }, function (v) { return $0a90de210c8d2546$export$711e2b273dbb00ac = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_1", function () { return $0a90de210c8d2546$export$e894550936196378; }, function (v) { return $0a90de210c8d2546$export$e894550936196378 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_10", function () { return $0a90de210c8d2546$export$76d0c5c9f1bcd33; }, function (v) { return $0a90de210c8d2546$export$76d0c5c9f1bcd33 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_11", function () { return $0a90de210c8d2546$export$9e6e44a433024d6d; }, function (v) { return $0a90de210c8d2546$export$9e6e44a433024d6d = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_12", function () { return $0a90de210c8d2546$export$69b0a233bc8d9471; }, function (v) { return $0a90de210c8d2546$export$69b0a233bc8d9471 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_13", function () { return $0a90de210c8d2546$export$b0b08b4cb457fb4b; }, function (v) { return $0a90de210c8d2546$export$b0b08b4cb457fb4b = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_14", function () { return $0a90de210c8d2546$export$8b7a67e609fa7876; }, function (v) { return $0a90de210c8d2546$export$8b7a67e609fa7876 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_15", function () { return $0a90de210c8d2546$export$8f32fb792fd5de35; }, function (v) { return $0a90de210c8d2546$export$8f32fb792fd5de35 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_16", function () { return $0a90de210c8d2546$export$1a6f885bbce36133; }, function (v) { return $0a90de210c8d2546$export$1a6f885bbce36133 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_17", function () { return $0a90de210c8d2546$export$ad03ba2e139bc2ee; }, function (v) { return $0a90de210c8d2546$export$ad03ba2e139bc2ee = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_18", function () { return $0a90de210c8d2546$export$3eecb192f21c7b5c; }, function (v) { return $0a90de210c8d2546$export$3eecb192f21c7b5c = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_19", function () { return $0a90de210c8d2546$export$29b2c50d1c249b17; }, function (v) { return $0a90de210c8d2546$export$29b2c50d1c249b17 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_2", function () { return $0a90de210c8d2546$export$8662788fffc45d3d; }, function (v) { return $0a90de210c8d2546$export$8662788fffc45d3d = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_20", function () { return $0a90de210c8d2546$export$7321992e2bb5e119; }, function (v) { return $0a90de210c8d2546$export$7321992e2bb5e119 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_3", function () { return $0a90de210c8d2546$export$cf04fc74071f77de; }, function (v) { return $0a90de210c8d2546$export$cf04fc74071f77de = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_4", function () { return $0a90de210c8d2546$export$5196ecb7b39dfed7; }, function (v) { return $0a90de210c8d2546$export$5196ecb7b39dfed7 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_5", function () { return $0a90de210c8d2546$export$41b3ffe2771e76cf; }, function (v) { return $0a90de210c8d2546$export$41b3ffe2771e76cf = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_6", function () { return $0a90de210c8d2546$export$7e320dd60220241b; }, function (v) { return $0a90de210c8d2546$export$7e320dd60220241b = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_7", function () { return $0a90de210c8d2546$export$c6e650e8135abfab; }, function (v) { return $0a90de210c8d2546$export$c6e650e8135abfab = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_8", function () { return $0a90de210c8d2546$export$4175ce7efd6e9ec1; }, function (v) { return $0a90de210c8d2546$export$4175ce7efd6e9ec1 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_9", function () { return $0a90de210c8d2546$export$57c61f2397272657; }, function (v) { return $0a90de210c8d2546$export$57c61f2397272657 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_end", function () { return $0a90de210c8d2546$export$e85318e035c52c7c; }, function (v) { return $0a90de210c8d2546$export$e85318e035c52c7c = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_start", function () { return $0a90de210c8d2546$export$ff6a8ffa07d93f02; }, function (v) { return $0a90de210c8d2546$export$ff6a8ffa07d93f02 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_item", function () { return $0a90de210c8d2546$export$c358ddc4badb7c84; }, function (v) { return $0a90de210c8d2546$export$c358ddc4badb7c84 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_1", function () { return $0a90de210c8d2546$export$73071494e5833cb; }, function (v) { return $0a90de210c8d2546$export$73071494e5833cb = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_10", function () { return $0a90de210c8d2546$export$f87cbfa5083ffea1; }, function (v) { return $0a90de210c8d2546$export$f87cbfa5083ffea1 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_11", function () { return $0a90de210c8d2546$export$b8a875b3bf2b6497; }, function (v) { return $0a90de210c8d2546$export$b8a875b3bf2b6497 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_12", function () { return $0a90de210c8d2546$export$aae58836b4de9cac; }, function (v) { return $0a90de210c8d2546$export$aae58836b4de9cac = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_13", function () { return $0a90de210c8d2546$export$57b78e3d40e397e4; }, function (v) { return $0a90de210c8d2546$export$57b78e3d40e397e4 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_14", function () { return $0a90de210c8d2546$export$bff6ba74fefffa10; }, function (v) { return $0a90de210c8d2546$export$bff6ba74fefffa10 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_15", function () { return $0a90de210c8d2546$export$8c72aec5d3e76045; }, function (v) { return $0a90de210c8d2546$export$8c72aec5d3e76045 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_16", function () { return $0a90de210c8d2546$export$7b344b17e6ef98ac; }, function (v) { return $0a90de210c8d2546$export$7b344b17e6ef98ac = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_17", function () { return $0a90de210c8d2546$export$39347543b3ff02df; }, function (v) { return $0a90de210c8d2546$export$39347543b3ff02df = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_18", function () { return $0a90de210c8d2546$export$df6733bcdadf6242; }, function (v) { return $0a90de210c8d2546$export$df6733bcdadf6242 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_19", function () { return $0a90de210c8d2546$export$992d889614beca52; }, function (v) { return $0a90de210c8d2546$export$992d889614beca52 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_2", function () { return $0a90de210c8d2546$export$2a10cd6da3d1bdae; }, function (v) { return $0a90de210c8d2546$export$2a10cd6da3d1bdae = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_20", function () { return $0a90de210c8d2546$export$b2e47302835cde6c; }, function (v) { return $0a90de210c8d2546$export$b2e47302835cde6c = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_3", function () { return $0a90de210c8d2546$export$8a5c95d5a153e064; }, function (v) { return $0a90de210c8d2546$export$8a5c95d5a153e064 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_4", function () { return $0a90de210c8d2546$export$88648ed041c8c49e; }, function (v) { return $0a90de210c8d2546$export$88648ed041c8c49e = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_5", function () { return $0a90de210c8d2546$export$405e84483889de82; }, function (v) { return $0a90de210c8d2546$export$405e84483889de82 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_6", function () { return $0a90de210c8d2546$export$442feee28a216471; }, function (v) { return $0a90de210c8d2546$export$442feee28a216471 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_7", function () { return $0a90de210c8d2546$export$d0e7718a69538409; }, function (v) { return $0a90de210c8d2546$export$d0e7718a69538409 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_8", function () { return $0a90de210c8d2546$export$edd4044cdf20e596; }, function (v) { return $0a90de210c8d2546$export$edd4044cdf20e596 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_9", function () { return $0a90de210c8d2546$export$efd9ca471bfe7c58; }, function (v) { return $0a90de210c8d2546$export$efd9ca471bfe7c58 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_last", function () { return $0a90de210c8d2546$export$3d53354eb0909d0f; }, function (v) { return $0a90de210c8d2546$export$3d53354eb0909d0f = v; });
$parcel$export($0a90de210c8d2546$exports, "headerRow", function () { return $0a90de210c8d2546$export$faed4863136ce212; }, function (v) { return $0a90de210c8d2546$export$faed4863136ce212 = v; });
$parcel$export($0a90de210c8d2546$exports, "panelImage", function () { return $0a90de210c8d2546$export$f843afa9e9b53052; }, function (v) { return $0a90de210c8d2546$export$f843afa9e9b53052 = v; });
$parcel$export($0a90de210c8d2546$exports, "scaleInOut", function () { return $0a90de210c8d2546$export$ae78d338ad66ff90; }, function (v) { return $0a90de210c8d2546$export$ae78d338ad66ff90 = v; });
$parcel$export($0a90de210c8d2546$exports, "shadow", function () { return $0a90de210c8d2546$export$b8972b998723d602; }, function (v) { return $0a90de210c8d2546$export$b8972b998723d602 = v; });
$parcel$export($0a90de210c8d2546$exports, "small-shadow", function () { return $0a90de210c8d2546$export$13925b5cf10ba292; }, function (v) { return $0a90de210c8d2546$export$13925b5cf10ba292 = v; });
var $0a90de210c8d2546$export$40a9eeef55665a40;
var $0a90de210c8d2546$export$486b53607e7afa2e;
var $0a90de210c8d2546$export$93b7586d956c930e;
var $0a90de210c8d2546$export$711e2b273dbb00ac;
var $0a90de210c8d2546$export$e894550936196378;
var $0a90de210c8d2546$export$76d0c5c9f1bcd33;
var $0a90de210c8d2546$export$9e6e44a433024d6d;
var $0a90de210c8d2546$export$69b0a233bc8d9471;
var $0a90de210c8d2546$export$b0b08b4cb457fb4b;
var $0a90de210c8d2546$export$8b7a67e609fa7876;
var $0a90de210c8d2546$export$8f32fb792fd5de35;
var $0a90de210c8d2546$export$1a6f885bbce36133;
var $0a90de210c8d2546$export$ad03ba2e139bc2ee;
var $0a90de210c8d2546$export$3eecb192f21c7b5c;
var $0a90de210c8d2546$export$29b2c50d1c249b17;
var $0a90de210c8d2546$export$8662788fffc45d3d;
var $0a90de210c8d2546$export$7321992e2bb5e119;
var $0a90de210c8d2546$export$cf04fc74071f77de;
var $0a90de210c8d2546$export$5196ecb7b39dfed7;
var $0a90de210c8d2546$export$41b3ffe2771e76cf;
var $0a90de210c8d2546$export$7e320dd60220241b;
var $0a90de210c8d2546$export$c6e650e8135abfab;
var $0a90de210c8d2546$export$4175ce7efd6e9ec1;
var $0a90de210c8d2546$export$57c61f2397272657;
var $0a90de210c8d2546$export$e85318e035c52c7c;
var $0a90de210c8d2546$export$ff6a8ffa07d93f02;
var $0a90de210c8d2546$export$c358ddc4badb7c84;
var $0a90de210c8d2546$export$73071494e5833cb;
var $0a90de210c8d2546$export$f87cbfa5083ffea1;
var $0a90de210c8d2546$export$b8a875b3bf2b6497;
var $0a90de210c8d2546$export$aae58836b4de9cac;
var $0a90de210c8d2546$export$57b78e3d40e397e4;
var $0a90de210c8d2546$export$bff6ba74fefffa10;
var $0a90de210c8d2546$export$8c72aec5d3e76045;
var $0a90de210c8d2546$export$7b344b17e6ef98ac;
var $0a90de210c8d2546$export$39347543b3ff02df;
var $0a90de210c8d2546$export$df6733bcdadf6242;
var $0a90de210c8d2546$export$992d889614beca52;
var $0a90de210c8d2546$export$2a10cd6da3d1bdae;
var $0a90de210c8d2546$export$b2e47302835cde6c;
var $0a90de210c8d2546$export$8a5c95d5a153e064;
var $0a90de210c8d2546$export$88648ed041c8c49e;
var $0a90de210c8d2546$export$405e84483889de82;
var $0a90de210c8d2546$export$442feee28a216471;
var $0a90de210c8d2546$export$d0e7718a69538409;
var $0a90de210c8d2546$export$edd4044cdf20e596;
var $0a90de210c8d2546$export$efd9ca471bfe7c58;
var $0a90de210c8d2546$export$3d53354eb0909d0f;
var $0a90de210c8d2546$export$faed4863136ce212;
var $0a90de210c8d2546$export$f843afa9e9b53052;
var $0a90de210c8d2546$export$ae78d338ad66ff90;
var $0a90de210c8d2546$export$b8972b998723d602;
var $0a90de210c8d2546$export$13925b5cf10ba292;
$0a90de210c8d2546$export$40a9eeef55665a40 = `SEVMuW_defaultPadding`;
$0a90de210c8d2546$export$486b53607e7afa2e = `SEVMuW_disable_round_edges`;
$0a90de210c8d2546$export$93b7586d956c930e = `SEVMuW_dropShadow`;
$0a90de210c8d2546$export$711e2b273dbb00ac = `SEVMuW_gridContainer`;
$0a90de210c8d2546$export$e894550936196378 = `SEVMuW_grid_col_1`;
$0a90de210c8d2546$export$76d0c5c9f1bcd33 = `SEVMuW_grid_col_10`;
$0a90de210c8d2546$export$9e6e44a433024d6d = `SEVMuW_grid_col_11`;
$0a90de210c8d2546$export$69b0a233bc8d9471 = `SEVMuW_grid_col_12`;
$0a90de210c8d2546$export$b0b08b4cb457fb4b = `SEVMuW_grid_col_13`;
$0a90de210c8d2546$export$8b7a67e609fa7876 = `SEVMuW_grid_col_14`;
$0a90de210c8d2546$export$8f32fb792fd5de35 = `SEVMuW_grid_col_15`;
$0a90de210c8d2546$export$1a6f885bbce36133 = `SEVMuW_grid_col_16`;
$0a90de210c8d2546$export$ad03ba2e139bc2ee = `SEVMuW_grid_col_17`;
$0a90de210c8d2546$export$3eecb192f21c7b5c = `SEVMuW_grid_col_18`;
$0a90de210c8d2546$export$29b2c50d1c249b17 = `SEVMuW_grid_col_19`;
$0a90de210c8d2546$export$8662788fffc45d3d = `SEVMuW_grid_col_2`;
$0a90de210c8d2546$export$7321992e2bb5e119 = `SEVMuW_grid_col_20`;
$0a90de210c8d2546$export$cf04fc74071f77de = `SEVMuW_grid_col_3`;
$0a90de210c8d2546$export$5196ecb7b39dfed7 = `SEVMuW_grid_col_4`;
$0a90de210c8d2546$export$41b3ffe2771e76cf = `SEVMuW_grid_col_5`;
$0a90de210c8d2546$export$7e320dd60220241b = `SEVMuW_grid_col_6`;
$0a90de210c8d2546$export$c6e650e8135abfab = `SEVMuW_grid_col_7`;
$0a90de210c8d2546$export$4175ce7efd6e9ec1 = `SEVMuW_grid_col_8`;
$0a90de210c8d2546$export$57c61f2397272657 = `SEVMuW_grid_col_9`;
$0a90de210c8d2546$export$e85318e035c52c7c = `SEVMuW_grid_col_end`;
$0a90de210c8d2546$export$ff6a8ffa07d93f02 = `SEVMuW_grid_col_start`;
$0a90de210c8d2546$export$c358ddc4badb7c84 = `SEVMuW_grid_item`;
$0a90de210c8d2546$export$73071494e5833cb = `SEVMuW_grid_row_1`;
$0a90de210c8d2546$export$f87cbfa5083ffea1 = `SEVMuW_grid_row_10`;
$0a90de210c8d2546$export$b8a875b3bf2b6497 = `SEVMuW_grid_row_11`;
$0a90de210c8d2546$export$aae58836b4de9cac = `SEVMuW_grid_row_12`;
$0a90de210c8d2546$export$57b78e3d40e397e4 = `SEVMuW_grid_row_13`;
$0a90de210c8d2546$export$bff6ba74fefffa10 = `SEVMuW_grid_row_14`;
$0a90de210c8d2546$export$8c72aec5d3e76045 = `SEVMuW_grid_row_15`;
$0a90de210c8d2546$export$7b344b17e6ef98ac = `SEVMuW_grid_row_16`;
$0a90de210c8d2546$export$39347543b3ff02df = `SEVMuW_grid_row_17`;
$0a90de210c8d2546$export$df6733bcdadf6242 = `SEVMuW_grid_row_18`;
$0a90de210c8d2546$export$992d889614beca52 = `SEVMuW_grid_row_19`;
$0a90de210c8d2546$export$2a10cd6da3d1bdae = `SEVMuW_grid_row_2`;
$0a90de210c8d2546$export$b2e47302835cde6c = `SEVMuW_grid_row_20`;
$0a90de210c8d2546$export$8a5c95d5a153e064 = `SEVMuW_grid_row_3`;
$0a90de210c8d2546$export$88648ed041c8c49e = `SEVMuW_grid_row_4`;
$0a90de210c8d2546$export$405e84483889de82 = `SEVMuW_grid_row_5`;
$0a90de210c8d2546$export$442feee28a216471 = `SEVMuW_grid_row_6`;
$0a90de210c8d2546$export$d0e7718a69538409 = `SEVMuW_grid_row_7`;
$0a90de210c8d2546$export$edd4044cdf20e596 = `SEVMuW_grid_row_8`;
$0a90de210c8d2546$export$efd9ca471bfe7c58 = `SEVMuW_grid_row_9`;
$0a90de210c8d2546$export$3d53354eb0909d0f = `SEVMuW_grid_row_last`;
$0a90de210c8d2546$export$faed4863136ce212 = `SEVMuW_headerRow`;
$0a90de210c8d2546$export$f843afa9e9b53052 = `SEVMuW_panelImage`;
$0a90de210c8d2546$export$ae78d338ad66ff90 = `SEVMuW_scaleInOut`;
$0a90de210c8d2546$export$b8972b998723d602 = `SEVMuW_shadow`;
$0a90de210c8d2546$export$13925b5cf10ba292 = `SEVMuW_small-shadow`;





var $58be81631dcdd257$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $58be81631dcdd257$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $58be81631dcdd257$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $58be81631dcdd257$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $58be81631dcdd257$export$db6c4f5cbda21d5d = (()=>{
    var _a, _EditTableStore_dealData_accessor_storage, _EditTableStore_editCellValue_accessor_storage, _EditTableStore_editCellId_accessor_storage;
    let _dealData_decorators;
    let _dealData_initializers = [];
    let _dealData_extraInitializers = [];
    let _editCellValue_decorators;
    let _editCellValue_initializers = [];
    let _editCellValue_extraInitializers = [];
    let _editCellId_decorators;
    let _editCellId_initializers = [];
    let _editCellId_extraInitializers = [];
    return _a = class EditTableStore {
        get dealData() {
            return $58be81631dcdd257$var$__classPrivateFieldGet(this, _EditTableStore_dealData_accessor_storage, "f");
        }
        set dealData(value) {
            $58be81631dcdd257$var$__classPrivateFieldSet(this, _EditTableStore_dealData_accessor_storage, value, "f");
        }
        get editCellValue() {
            return $58be81631dcdd257$var$__classPrivateFieldGet(this, _EditTableStore_editCellValue_accessor_storage, "f");
        }
        set editCellValue(value) {
            $58be81631dcdd257$var$__classPrivateFieldSet(this, _EditTableStore_editCellValue_accessor_storage, value, "f");
        }
        get editCellId() {
            return $58be81631dcdd257$var$__classPrivateFieldGet(this, _EditTableStore_editCellId_accessor_storage, "f");
        }
        set editCellId(value) {
            $58be81631dcdd257$var$__classPrivateFieldSet(this, _EditTableStore_editCellId_accessor_storage, value, "f");
        }
        constructor(){
            _EditTableStore_dealData_accessor_storage.set(this, $58be81631dcdd257$var$__runInitializers(this, _dealData_initializers, null));
            _EditTableStore_editCellValue_accessor_storage.set(this, ($58be81631dcdd257$var$__runInitializers(this, _dealData_extraInitializers), $58be81631dcdd257$var$__runInitializers(this, _editCellValue_initializers, null)));
            _EditTableStore_editCellId_accessor_storage.set(this, ($58be81631dcdd257$var$__runInitializers(this, _editCellValue_extraInitializers), $58be81631dcdd257$var$__runInitializers(this, _editCellId_initializers, null)));
            $58be81631dcdd257$var$__runInitializers(this, _editCellId_extraInitializers);
        }
    }, _EditTableStore_dealData_accessor_storage = new WeakMap(), _EditTableStore_editCellValue_accessor_storage = new WeakMap(), _EditTableStore_editCellId_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _dealData_decorators = [
            (0, $T5IcR.observable)
        ];
        _editCellValue_decorators = [
            (0, $T5IcR.observable)
        ];
        _editCellId_decorators = [
            (0, $T5IcR.observable)
        ];
        $58be81631dcdd257$var$__esDecorate(_a, null, _dealData_decorators, {
            kind: "accessor",
            name: "dealData",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealData" in obj,
                get: (obj)=>obj.dealData,
                set: (obj, value)=>{
                    obj.dealData = value;
                }
            },
            metadata: _metadata
        }, _dealData_initializers, _dealData_extraInitializers);
        $58be81631dcdd257$var$__esDecorate(_a, null, _editCellValue_decorators, {
            kind: "accessor",
            name: "editCellValue",
            static: false,
            private: false,
            access: {
                has: (obj)=>"editCellValue" in obj,
                get: (obj)=>obj.editCellValue,
                set: (obj, value)=>{
                    obj.editCellValue = value;
                }
            },
            metadata: _metadata
        }, _editCellValue_initializers, _editCellValue_extraInitializers);
        $58be81631dcdd257$var$__esDecorate(_a, null, _editCellId_decorators, {
            kind: "accessor",
            name: "editCellId",
            static: false,
            private: false,
            access: {
                has: (obj)=>"editCellId" in obj,
                get: (obj)=>obj.editCellId,
                set: (obj, value)=>{
                    obj.editCellId = value;
                }
            },
            metadata: _metadata
        }, _editCellId_initializers, _editCellId_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
// Cell Selection Checkbox component
const $58be81631dcdd257$var$SelectionCheckbox = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(({ fieldName: fieldName })=>{
    const selectionStore = (0, $ffb64b99b5e6ea0e$export$4b4c417a6113a34c)();
    const isSelected = selectionStore.isFieldSelected(fieldName);
    // Force re-render on isSelectionModeActive changes
    const [, forceUpdate] = (0, $8nGP5.useState)({});
    // Update when selection mode or selected fields change
    (0, $8nGP5.useEffect)(()=>{
        const timer = setInterval(()=>{
            forceUpdate({});
        }, 100);
        return ()=>clearInterval(timer);
    }, []);
    // Log to help debug
    //console.log(`Rendering checkbox for ${fieldName}: isSelected=${isSelected}`);
    return (0, $kSbwP.jsx)("input", {
        type: "checkbox",
        checked: isSelected,
        onChange: ()=>{
            console.log(`Toggling selection for ${fieldName} from ${isSelected} to ${!isSelected}`);
            selectionStore.toggleSelection(fieldName);
            forceUpdate({});
        },
        style: {
            margin: 0,
            position: 'absolute',
            left: '5px',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 100,
            // Visual style to make it more noticeable
            width: '16px',
            height: '16px',
            accentColor: '#1976d2'
        }
    });
});
const $58be81631dcdd257$export$5dd4673b7f9fa87b = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    const [editValueStore] = (0, $8nGP5.useState)(new $58be81631dcdd257$export$db6c4f5cbda21d5d());
    const [editCellRefresh, setEditCellRefreshUI] = (0, $8nGP5.useState)(null);
    const selectionStore = (0, $ffb64b99b5e6ea0e$export$4b4c417a6113a34c)();
    const isSelectionModeActive = selectionStore.isSelectionModeActive;
    const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const skipHeadeRow = props.noHeaderRow === true;
    const skipRowLabel = props.skipLabelInRow === true;
    function onKeyDown(e) {
        if (editValueStore.editCellId == null) return;
        if (e.key === 'Tab' || e.key == 'ArrowUp' || e.key == 'ArrowDown') {
            e.preventDefault();
            saveCurrentEdit();
            const columnsInRow = props.columns.length;
            const editCellId = editValueStore.editCellId;
            var nextColumnIndex = editCellId.colIndex;
            var nextRowIndex = editCellId.rowIndex;
            if (e.shiftKey) {
                nextColumnIndex -= 1;
                if (nextColumnIndex < 0) nextColumnIndex = 0;
            } else if (e.key == 'ArrowUp') for(let i = 0; i < rows.length; i++){
                nextRowIndex -= 1;
                if (nextRowIndex <= -1) return;
                if (props.rows[nextRowIndex].editable) break;
            }
            else if (e.key == 'ArrowDown') for(let i = 0; i < rows.length; i++){
                nextRowIndex += 1;
                if (nextRowIndex >= props.rows.length) return;
                if (props.rows[nextRowIndex].editable) break;
            }
            else if (e.key == 'Tab') {
                nextColumnIndex += 1;
                if (nextColumnIndex >= columnsInRow) nextColumnIndex -= 1;
            } else if (e.key == 'Enter') setCellEditMode(null);
            var newRow = props.rows[nextRowIndex];
            var newCol = props.columns[nextColumnIndex];
            setCellEditMode({
                row: newRow,
                col: newCol,
                rowIndex: nextRowIndex,
                colIndex: nextColumnIndex
            });
        } else if (e.key === 'Escape') setCellEditMode(null);
        else if (e.key === 'Delete') {
            const editCellId = editValueStore.editCellId;
            props.onEditField(editCellId.row, editCellId.col, null, editCellId.rowIndex);
            setCellEditMode(null);
        }
    }
    (0, $8nGP5.useEffect)(()=>{
        const handleClickOutside = (e)=>{
            if (editValueStore.editCellId) {
                const target = e.target;
                // Check if click is outside the table or on a different cell
                const isInTable = target.closest('.grid_item');
                if (!isInTable || !target.closest('input')) {
                    saveCurrentEdit();
                    setCellEditMode(null);
                }
            }
        };
        document.addEventListener('keydown', onKeyDown);
        document.addEventListener('click', handleClickOutside);
        return ()=>{
            document.removeEventListener('keydown', onKeyDown);
            document.removeEventListener('click', handleClickOutside);
        };
    }, [
        editValueStore.editCellId,
        editValueStore.editCellValue
    ]);
    const setCellEditMode = (cellId)=>{
        const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
        editValueStore.editCellId = cellId;
        setEditCellRefreshUI(editValueStore.editCellId);
        if (cellId == null) {
            setValueForEditCell('SHOULD_NOT_SEE');
            // Hide underlines when exiting edit mode
            storeUI.showEditedUnderlines = false;
            return;
        }
        editValueStore.dealData = (0, $T5IcR.toJS)(store.query.activeReport);
        const valFn = cellId.col.overrideValue || cellId.row.value;
        let newEditValue = valFn(cellId.row.field, cellId.col.column);
        setValueForEditCell(newEditValue);
    };
    const saveCurrentEdit = ()=>{
        const val = editValueStore.editCellValue;
        const editCellId = editValueStore.editCellId;
        if (props.onEditField) props.onEditField(editCellId.row, editCellId.col, val, editCellId.rowIndex);
    };
    const setValueForEditCell = (value)=>{
        if (value == null || value.toString() == 'NaN' || value.toString() == 'N\\A' || value.toString() == 'N/A') value = '';
        editValueStore.editCellValue = value;
    };
    const disableRoundEdges = props.disable_round_edges === true;
    const elementsToGridRow = (row, rowData, elements, classesToAdd = [], rowPosition = [
        'none'
    ], rowAttributes = {})=>{
        return elements.map((el, index)=>{
            var _a;
            var cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($0a90de210c8d2546$exports.grid_item, $0a90de210c8d2546$exports[`grid_row_${row}`], $0a90de210c8d2546$exports[`grid_col_${index + 1}`], `grid_row_${row}`, `grid_col_${index + 1}`, {
                even_row: row % 2 === 0
            }, {
                odd_row: row % 2 === 1
            }, ...classesToAdd, {
                [$0a90de210c8d2546$exports.grid_col_start]: index === 0
            }, {
                [$0a90de210c8d2546$exports.grid_col_end]: index === elements.length - 1
            }, {
                [$0a90de210c8d2546$exports.grid_row_first]: rowPosition.includes('start')
            }, {
                [$0a90de210c8d2546$exports.grid_row_last]: rowPosition.includes('end')
            }, {
                [$0a90de210c8d2546$exports.disable_round_edges]: disableRoundEdges
            });
            const cellAttributes = Object.assign({}, rowAttributes);
            if (index === 0 && rowData && ((_a = rowData.field) === null || _a === void 0 ? void 0 : _a.source)) cellAttributes['data-field-name'] = rowData.field.source;
            return (0, $kSbwP.jsx)("div", Object.assign({
                className: cls,
                onClick: ()=>{
                    if (rowData && rowData.onClick && !rowData.editable) rowData.onClick(rowData);
                }
            }, cellAttributes, {
                children: el
            }), 'Row_' + row + '_' + index);
        });
    };
    const rows = [];
    if (!skipHeadeRow) {
        const headerLabels = [
            (0, $kSbwP.jsx)("div", {
                children: props.topLeftCellText
            }),
            ...props.columns.map((col)=>{
                const el = col.header ? col.header(col) : (0, $kSbwP.jsx)("div", {
                    children: col.column.display
                });
                return (0, $kSbwP.jsx)("div", {
                    children: el
                }, col.column.source);
            })
        ];
        rows.push(elementsToGridRow(1, null, headerLabels, [
            $0a90de210c8d2546$exports.headerRow
        ]));
    }
    props.rows.forEach((row, rowIndex)=>{
        if (row.skipRow) return;
        const newRow = [];
        if (!skipRowLabel) {
            // Render the label column with checkbox if in selection mode
            const labelContent = row.label ? row.label(row.field) : row.field.display;
            const labelWrapper = isSelectionModeActive ? (0, $kSbwP.jsxs)("div", {
                style: {
                    position: 'relative',
                    paddingLeft: '25px'
                },
                children: [
                    (0, $kSbwP.jsx)($58be81631dcdd257$var$SelectionCheckbox, {
                        fieldName: row.field.source
                    }),
                    labelContent
                ]
            }) : labelContent;
            newRow.push(labelWrapper);
        }
        props.columns.forEach((col, colIndex)=>{
            var _a, _b;
            const isRowEditable = row.editable;
            const columnsInRow = props.columns.length;
            const cellId = {
                row: row,
                col: col,
                rowIndex: rowIndex,
                colIndex: colIndex
            };
            const editCellId = editValueStore.editCellId;
            const editMode = editCellId && editCellId.rowIndex == rowIndex && editCellId.colIndex == colIndex;
            let val = '-';
            let val_noformatting = '-';
            const valFn = col.overrideValue || row.value;
            try {
                val = valFn(row.field, col.column);
                val_noformatting = val;
                if (!editMode) {
                    if (col.overrideFormatting) val = col.overrideFormatting(val);
                    else if (row.formatter && col.dontUseRowFormatting !== true) val = row.formatter(val);
                }
            } catch (e) {
                console.log('Error in PanelTable', e);
                val = '-';
            }
            const createEl = col.element || row.element;
            const createEditor = col.editor || row.editor || (0, $68d2907db623a0aa$export$44b5115104b4b812).textbox;
            const onEditApi = (value, save)=>{
                setValueForEditCell(value);
                if (save) {
                    saveCurrentEdit();
                    setCellEditMode(null);
                }
            };
            const editApi = {
                row: row,
                col: col,
                val: editValueStore,
                onEdit: onEditApi
            };
            const justifyContent = ((_a = col === null || col === void 0 ? void 0 : col.style) === null || _a === void 0 ? void 0 : _a.justifyContent) || 'center';
            const alignItems = ((_b = col === null || col === void 0 ? void 0 : col.style) === null || _b === void 0 ? void 0 : _b.alignItems) || 'center';
            const newEl = (0, $kSbwP.jsx)("div", {
                style: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: justifyContent,
                    alignItems: alignItems
                },
                onDoubleClick: (e)=>{
                    if (props.onEditField && row.editable && !editMode) {
                        // Don't make Source columns editable
                        const createEl = col.element || row.element;
                        const isSourceColumn = createEl === (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources;
                        if (!isSourceColumn) {
                            e.stopPropagation();
                            storeUI.showEditedUnderlines = true;
                            setCellEditMode({
                                row: row,
                                col: col,
                                rowIndex: rowIndex,
                                colIndex: colIndex
                            });
                        }
                    }
                },
                children: editMode ? createEditor(editApi) : createEl(row, col, val)
            }, colIndex);
            newRow.push(newEl);
        });
        const rowPosition = [];
        const isFirstRow = rowIndex === 0;
        if (isFirstRow) rowPosition.push('start');
        const isLastRow = rowIndex === props.rows.length - 1;
        if (isLastRow) rowPosition.push('end');
        const rowAttributes = {};
        rows.push(elementsToGridRow(rows.length + 1, row, newRow, [], rowPosition, rowAttributes));
    });
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($0a90de210c8d2546$exports.gridContainer, props.className);
    return (0, $kSbwP.jsx)("div", {
        className: cls,
        children: rows
    });
});



class $7403a76d892238e8$export$8b849e0e30783f61 {
}
Object.defineProperty($7403a76d892238e8$export$8b849e0e30783f61, "findCompaniesToCompare", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (reportId, maxReturn = 2)=>{
        const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
        const clientStore = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
        const q = store.createDataAccess(reportId);
        if (q == null) return [];
        const companies = Object.keys(store.reportDataDB).filter((reportId)=>{
            if (store.reportDataDB[reportId].status != 'completed') return false;
            // Apply demo filter
            const filter_settings = clientStore.filterCompaniesForDemo;
            if (clientStore.isDemoFilterOn && filter_settings != null) {
                if (filter_settings[reportId] !== true) return false;
            }
            return true;
        });
        const fullMatch = [];
        const partialMatch = [];
        const noMatch = [];
        const industry = q.value('industry');
        const subIndustry = q.value('industrySubType');
        companies.forEach((reportId)=>{
            const compA = store.createDataAccess(reportId);
            const otherIndustry = compA.value('industry');
            const otherSub = compA.value('industrySubType');
            if (store.selectedReportId == reportId) return;
            if (compA.report_has_pdf != true) return;
            if (industry == otherIndustry && subIndustry == otherSub) fullMatch.push(reportId);
            else if (industry == otherIndustry) partialMatch.push(reportId);
            else noMatch.push(reportId);
        });
        var allCompanies = fullMatch.concat(partialMatch).concat(noMatch);
        return allCompanies.slice(0, maxReturn);
    }
});



class $7e550ef9293629bd$export$2044ca5e7e8cae3 {
    constructor(industry, subIndustry){
        Object.defineProperty(this, "industry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: industry
        });
        Object.defineProperty(this, "subIndustry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: subIndustry
        });
        Object.defineProperty(this, "companies", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
        const allDeals = Object.keys(store.reportDataDB);
        allDeals.forEach((deal)=>{
            const q = store.createDataAccess(deal);
            if (q) {
                const industry = q.value('industry');
                const subIndustry = q.value('industrySubType');
                if (industry === this.industry && subIndustry === this.subIndustry) this.companies.push(q);
            }
        });
    }
    value(fieldName) {
        if (fieldName == 'company_name') return this.industry;
        if (fieldName == 'industry') return this.industry;
        if (fieldName == 'industrySubType') return this.subIndustry;
        return 'N/A';
    }
    scoreBySection(section) {
        var valuesUsed = 0;
        var valuesTotalAccumlated = 0;
        this.companies.forEach((company)=>{
            const val = company.scoreBySection(section);
            if (val != null) {
                valuesUsed++;
                valuesTotalAccumlated += val;
            }
        });
        return valuesUsed > 0 ? (valuesTotalAccumlated / valuesUsed).toFixed(2) : -1;
    }
    score() {
        var valuesUsed = 0;
        var valuesTotalAccumlated = 0;
        this.companies.forEach((company)=>{
            const val = company.score();
            if (val != -1) {
                valuesUsed++;
                valuesTotalAccumlated += val;
            }
        });
        return valuesUsed > 0 ? (valuesTotalAccumlated / valuesUsed).toFixed(2) : -1;
    }
    returnYearsAverageCagr(cagr) {
        var ret = {};
        for(var year = 3; year <= 5; year++){
            var valuesUsed = [];
            this.companies.forEach((company)=>{
                const val = cagr == 'organic' ? company.organicCagr(year) : company.projectedCagr(year);
                if (val != 'N/A' && !isNaN(val)) valuesUsed.push(val);
            });
            ret[year] = this.trimmedAverage(valuesUsed);
        }
        return ret;
    }
    trimmedAverage(values) {
        if (values.length == 0) return "N/A";
        if (values.length < 4) return values.reduce((acc, val)=>acc + val, 0) / values.length;
        const sorted = [
            ...values
        ].sort((a, b)=>a - b);
        const count = sorted.length;
        const lower = Math.floor(count * 0.25);
        const upper = Math.ceil(count * 0.75);
        const middle = sorted.slice(lower, upper); // middle 50%
        const sum = middle.reduce((acc, val)=>acc + val, 0);
        return sum / middle.length;
    }
    get_extended_value_float(fieldName) {
        if (fieldName == 'recurring_revenue_summary') return 'N/A';
        if (fieldName == 'organic_cagr_N_years' || fieldName == 'projected_organic_cagr_N_years') {
            const cagrType = fieldName == 'organic_cagr_N_years' ? 'organic' : 'projected';
            return this.returnYearsAverageCagr(cagrType);
        }
        var valuesUsed = [];
        this.companies.forEach((company)=>{
            const val = company.get_extended_value_float(fieldName);
            if (val != 'N/A' && !isNaN(val)) valuesUsed.push(val);
        });
        return this.trimmedAverage(valuesUsed);
    }
}








var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");
var $1b1a012ab27d0a02$exports = {};
$1b1a012ab27d0a02$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":696,\"op\":762,\"w\":600,\"h\":600,\"nm\":\"Final\",\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ind\":3,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[200,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":20,\"op\":1520,\"st\":20},{\"ind\":4,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[250,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":30,\"op\":1530,\"st\":30},{\"ind\":5,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":40,\"op\":1540,\"st\":40},{\"ind\":6,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[350,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":50,\"op\":1550,\"st\":50},{\"ind\":7,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[400,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":60,\"op\":1560,\"st\":60},{\"ind\":8,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[450,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":70,\"op\":1570,\"st\":70},{\"ind\":9,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[500,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":80,\"op\":1580,\"st\":80}]},{\"id\":\"comp_1\",\"layers\":[{\"ind\":1,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":632,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":645,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":657,\"s\":[30]},{\"t\":680,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,415,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1.298]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,0.845]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.057]},\"t\":632,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.645]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0.143]},\"t\":645,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":657,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":699,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":714,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":726,\"s\":[100,100,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0},{\"ind\":2,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":680,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":697,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":710,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":722,\"s\":[30]},{\"t\":745,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,171,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":634,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":647,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":659,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":697,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":710,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":722,\"s\":[55,55,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":-65,\"op\":1435,\"st\":-65}]},{\"id\":\"comp_2\",\"layers\":[{\"ind\":1,\"ty\":4,\"nm\":\"Round 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-74,-14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[129,129,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[60,60]},\"p\":{\"a\":0,\"k\":[0,0]},\"nm\":\"Ellipse Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.831,0.851,0.878,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-74,-14]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\"}],\"ip\":0,\"op\":1500,\"st\":0}]}],\"layers\":[{\"ind\":2,\"ty\":0,\"nm\":\"sequance\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[248,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0}],\"markers\":[]}");



const $3025be2fbc4fcb83$export$9626faa1e0fab265 = (props)=>{
    const [isLoaded, setIsLoaded] = (0, $8nGP5.useState)(false);
    const defaultOptionsLottie = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($1b1a012ab27d0a02$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            !isLoaded && (0, $kSbwP.jsx)("div", {
                className: props.className,
                children: (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
                    options: defaultOptionsLottie
                })
            }),
            (0, $kSbwP.jsx)("img", {
                src: props.src,
                alt: "placeholder",
                className: props.className,
                onLoad: ()=>{
                    setIsLoaded(true);
                }
            })
        ]
    });
};



var $kSbwP = parcelRequire("kSbwP");

var $d75ef6ac4f58ae92$export$40a9eeef55665a40;
var $d75ef6ac4f58ae92$export$93b7586d956c930e;
var $d75ef6ac4f58ae92$export$f843afa9e9b53052;
var $d75ef6ac4f58ae92$export$296fb8e7af4c4a4d;
var $d75ef6ac4f58ae92$export$ae78d338ad66ff90;
var $d75ef6ac4f58ae92$export$b8972b998723d602;
var $d75ef6ac4f58ae92$export$13925b5cf10ba292;
$d75ef6ac4f58ae92$export$40a9eeef55665a40 = `_Czy6G_defaultPadding`;
$d75ef6ac4f58ae92$export$93b7586d956c930e = `_Czy6G_dropShadow`;
$d75ef6ac4f58ae92$export$f843afa9e9b53052 = `_Czy6G_panelImage`;
$d75ef6ac4f58ae92$export$296fb8e7af4c4a4d = `_Czy6G_panelRowTitle`;
$d75ef6ac4f58ae92$export$ae78d338ad66ff90 = `_Czy6G_scaleInOut`;
$d75ef6ac4f58ae92$export$b8972b998723d602 = `_Czy6G_shadow`;
$d75ef6ac4f58ae92$export$13925b5cf10ba292 = `_Czy6G_small-shadow`;



const $308b83e7da0f0dd7$export$86de09faaa70680d = (props)=>{
    const container = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(props.containerClassName);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($d75ef6ac4f58ae92$export$296fb8e7af4c4a4d, props.className);
    return (0, $kSbwP.jsxs)((0, $8421c2e6c1303cf8$export$1f54913ccc4368b1), {
        className: container,
        children: [
            props.children ? props.children : '',
            (0, $kSbwP.jsx)("div", {
                className: cls,
                children: props.title
            })
        ]
    });
};




var $kSbwP = parcelRequire("kSbwP");
var $fe9c1753b605cc93$exports = {};
var $52f1f760ddc2d0b4$exports = {};
$52f1f760ddc2d0b4$exports = new URL("concentration.b319fb3b.png", import.meta.url).toString();


var $5aae6e62e13a55d0$exports = {};
$5aae6e62e13a55d0$exports = new URL("ebitda_performance.2268d70b.png", import.meta.url).toString();


var $17a03a65bf732fe9$exports = {};
$17a03a65bf732fe9$exports = new URL("fcf_profile.36dff1fa.png", import.meta.url).toString();


var $e0f07120861a124d$exports = {};
$e0f07120861a124d$exports = new URL("market_size_and_performance.92da13ac.png", import.meta.url).toString();


var $ae14c6fe244c0158$exports = {};
$ae14c6fe244c0158$exports = new URL("other.e3eaa9be.png", import.meta.url).toString();


var $0c461bc47e13811e$exports = {};
$0c461bc47e13811e$exports = new URL("overview.1c4cc915.png", import.meta.url).toString();


var $fcf4311ca195abd4$exports = {};
$fcf4311ca195abd4$exports = new URL("revenue_performance.db5c8439.png", import.meta.url).toString();


$fe9c1753b605cc93$exports = {
    "concentration": $52f1f760ddc2d0b4$exports,
    "ebitda_performance": $5aae6e62e13a55d0$exports,
    "fcf_profile": $17a03a65bf732fe9$exports,
    "market_size_and_performance": $e0f07120861a124d$exports,
    "other": $ae14c6fe244c0158$exports,
    "overview": $0c461bc47e13811e$exports,
    "revenue_performance": $fcf4311ca195abd4$exports
};


var $454bde0f68041a40$exports = {};
var $0ae8c996dc2ce47f$exports = {};
$0ae8c996dc2ce47f$exports = new URL("concentration.7d597663.svg", import.meta.url).toString();


var $cf7ceea5fb0b77e4$exports = {};
$cf7ceea5fb0b77e4$exports = new URL("ebitda_performance.d2e303be.svg", import.meta.url).toString();


var $23d8162132f92511$exports = {};
$23d8162132f92511$exports = new URL("fcf_profile.4ba5e38a.svg", import.meta.url).toString();


var $a854b3a6f4af46b9$exports = {};
$a854b3a6f4af46b9$exports = new URL("market_size_and_performance.fd9c2e5e.svg", import.meta.url).toString();


var $0cd44b6c402adc61$exports = {};
$0cd44b6c402adc61$exports = new URL("other.80576dc7.svg", import.meta.url).toString();


var $0fedb91591ed7a98$exports = {};
$0fedb91591ed7a98$exports = new URL("overview.a1b80899.svg", import.meta.url).toString();


var $8a66b0c296e6e3ad$exports = {};
$8a66b0c296e6e3ad$exports = new URL("revenue_performance.82890e81.svg", import.meta.url).toString();


$454bde0f68041a40$exports = {
    "concentration": $0ae8c996dc2ce47f$exports,
    "ebitda_performance": $cf7ceea5fb0b77e4$exports,
    "fcf_profile": $23d8162132f92511$exports,
    "market_size_and_performance": $a854b3a6f4af46b9$exports,
    "other": $0cd44b6c402adc61$exports,
    "overview": $0fedb91591ed7a98$exports,
    "revenue_performance": $8a66b0c296e6e3ad$exports
};


var $3d82e178f5213798$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3d82e178f5213798$var$base64_lookup = {};
const $3d82e178f5213798$export$ef2b607153f69518 = (section)=>{
    if (!$454bde0f68041a40$exports[section]) return null;
    return $454bde0f68041a40$exports[section];
};
function $3d82e178f5213798$var$urlToBase64(url) {
    return $3d82e178f5213798$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield fetch(url);
        const blob = yield response.blob();
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>resolve(reader.result); // base64 string
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    });
}
var $3d82e178f5213798$var$base64_lookup = {};
const $3d82e178f5213798$var$fetch_base64 = ()=>$3d82e178f5213798$var$__awaiter(void 0, void 0, void 0, function*() {
        for (const key of Object.keys($fe9c1753b605cc93$exports))$3d82e178f5213798$var$base64_lookup[key] = yield $3d82e178f5213798$var$urlToBase64($fe9c1753b605cc93$exports[key]);
    });
$3d82e178f5213798$var$fetch_base64();
const $3d82e178f5213798$export$13941a4af6282a89 = (section)=>{
    if (!$3d82e178f5213798$var$base64_lookup[section]) return null;
    return $3d82e178f5213798$var$base64_lookup[section];
};
const $3d82e178f5213798$export$ab8815222a429372 = (p)=>{
    return (0, $kSbwP.jsx)("div", {
        className: p.className,
        children: (0, $kSbwP.jsx)("img", {
            src: $fe9c1753b605cc93$exports[p.section]
        })
    });
};



var $e8cfe043fdb0cc46$export$49b67a8b77a2f86;
var $e8cfe043fdb0cc46$export$8809b6c1d844b52e;
var $e8cfe043fdb0cc46$export$6b2d426110a11d7a;
var $e8cfe043fdb0cc46$export$a38dc554151ff661;
var $e8cfe043fdb0cc46$export$42e4a6ed1eb5a52e;
var $e8cfe043fdb0cc46$export$5c219a65934d4b9c;
var $e8cfe043fdb0cc46$export$a9201b0f321cc198;
var $e8cfe043fdb0cc46$export$85ce76fe7fec44bf;
var $e8cfe043fdb0cc46$export$e730f6987ad4283b;
var $e8cfe043fdb0cc46$export$c544e8a82a189fe0;
var $e8cfe043fdb0cc46$export$5af45bc883ccaf0a;
var $e8cfe043fdb0cc46$export$ddf717dd8f3b07f7;
var $e8cfe043fdb0cc46$export$fdf38cda73dd5881;
var $e8cfe043fdb0cc46$export$71039ff750dc3c07;
var $e8cfe043fdb0cc46$export$748697c599bd33dd;
var $e8cfe043fdb0cc46$export$2dd75df9bbd1a5f4;
var $e8cfe043fdb0cc46$export$241ce4c9cedba8f6;
var $e8cfe043fdb0cc46$export$7f5c732b9b47a4b8;
var $e8cfe043fdb0cc46$export$41fc6278a3c14d73;
var $e8cfe043fdb0cc46$export$6633e83f4afff9ea;
var $e8cfe043fdb0cc46$export$637f169d296cfe12;
var $e8cfe043fdb0cc46$export$524c9eca7362778b;
var $e8cfe043fdb0cc46$export$64b67e74237b10b9;
var $e8cfe043fdb0cc46$export$daaf31466ad29ead;
var $e8cfe043fdb0cc46$export$9ba80d992c64273b;
var $e8cfe043fdb0cc46$export$8d776830dbcce823;
var $e8cfe043fdb0cc46$export$4087c73cbd989252;
$e8cfe043fdb0cc46$export$49b67a8b77a2f86 = `yzAg9a_addCardButton`;
$e8cfe043fdb0cc46$export$8809b6c1d844b52e = `yzAg9a_addCardText`;
$e8cfe043fdb0cc46$export$6b2d426110a11d7a = `yzAg9a_cardContainer`;
$e8cfe043fdb0cc46$export$a38dc554151ff661 = `yzAg9a_companyHeaderElement`;
$e8cfe043fdb0cc46$export$42e4a6ed1eb5a52e = `yzAg9a_companyLogo`;
$e8cfe043fdb0cc46$export$5c219a65934d4b9c = `yzAg9a_companyNameLabel`;
$e8cfe043fdb0cc46$export$a9201b0f321cc198 = `yzAg9a_dealCategoryScore`;
$e8cfe043fdb0cc46$export$85ce76fe7fec44bf = `yzAg9a_dealScoreCard`;
$e8cfe043fdb0cc46$export$e730f6987ad4283b = `yzAg9a_dealThumbScore`;
$e8cfe043fdb0cc46$export$c544e8a82a189fe0 = `yzAg9a_diamondIcon`;
$e8cfe043fdb0cc46$export$5af45bc883ccaf0a = `yzAg9a_industryCard`;
$e8cfe043fdb0cc46$export$ddf717dd8f3b07f7 = `yzAg9a_industryIcon`;
$e8cfe043fdb0cc46$export$fdf38cda73dd5881 = `yzAg9a_industryLabel`;
$e8cfe043fdb0cc46$export$71039ff750dc3c07 = `yzAg9a_industryScore`;
$e8cfe043fdb0cc46$export$748697c599bd33dd = `yzAg9a_industrySection`;
$e8cfe043fdb0cc46$export$2dd75df9bbd1a5f4 = `yzAg9a_industrySubType`;
$e8cfe043fdb0cc46$export$241ce4c9cedba8f6 = `yzAg9a_industryValue`;
$e8cfe043fdb0cc46$export$7f5c732b9b47a4b8 = `yzAg9a_industryValues`;
$e8cfe043fdb0cc46$export$41fc6278a3c14d73 = `yzAg9a_noDataAvail`;
$e8cfe043fdb0cc46$export$6633e83f4afff9ea = `yzAg9a_panelTableCompanies`;
$e8cfe043fdb0cc46$export$637f169d296cfe12 = `yzAg9a_panelTableStyle`;
$e8cfe043fdb0cc46$export$524c9eca7362778b = `yzAg9a_panelTableStyleRelativeContainer`;
$e8cfe043fdb0cc46$export$64b67e74237b10b9 = `yzAg9a_panelTableStyleScoreLine`;
$e8cfe043fdb0cc46$export$daaf31466ad29ead = `yzAg9a_panelTitle`;
$e8cfe043fdb0cc46$export$9ba80d992c64273b = `yzAg9a_panelTitleText`;
$e8cfe043fdb0cc46$export$8d776830dbcce823 = `yzAg9a_removeButton`;
$e8cfe043fdb0cc46$export$4087c73cbd989252 = `yzAg9a_sectionIcon`;


var $5629e6120e100578$exports = {};
$5629e6120e100578$exports = new URL("industry_icon.30d7df5b.svg", import.meta.url).toString();




var $fgQ0V = parcelRequire("fgQ0V");

var $8nGP5 = parcelRequire("8nGP5");






var $eb61065bad00bf9b$var$size;
function $eb61065bad00bf9b$export$2e2bcd8739ae039(recalc) {
    if (!$eb61065bad00bf9b$var$size && $eb61065bad00bf9b$var$size !== 0 || recalc) {
        if (0, $53e6d5b016eb161e$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $eb61065bad00bf9b$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $eb61065bad00bf9b$var$size;
}



var $8nGP5 = parcelRequire("8nGP5");
function $dd85a49ad087ea71$export$2e2bcd8739ae039() {
    return (0, $8nGP5.useState)(null);
}



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $23fd7cfebae531bc$var$useCommittedRef(value) {
    const ref = (0, $8nGP5.useRef)(value);
    (0, $8nGP5.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $23fd7cfebae531bc$export$2e2bcd8739ae039 = $23fd7cfebae531bc$var$useCommittedRef;


function $129f7f7db7f8a1a4$export$2e2bcd8739ae039(fn) {
    const ref = (0, $23fd7cfebae531bc$export$2e2bcd8739ae039)(fn);
    return (0, $8nGP5.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $8nGP5 = parcelRequire("8nGP5");
const $e2bab6b473f544db$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $e2bab6b473f544db$export$c9058316764c140e(refA, refB) {
    const a = $e2bab6b473f544db$var$toFnRef(refA);
    const b = $e2bab6b473f544db$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $e2bab6b473f544db$var$useMergedRefs(refA, refB) {
    return (0, $8nGP5.useMemo)(()=>$e2bab6b473f544db$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $e2bab6b473f544db$export$2e2bcd8739ae039 = $e2bab6b473f544db$var$useMergedRefs;



var $8nGP5 = parcelRequire("8nGP5");
function $a3fda4e009a690ff$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $8nGP5.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $8nGP5 = parcelRequire("8nGP5");
function $05980fa951c421ef$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $a3fda4e009a690ff$export$2e2bcd8739ae039)(fn);
    (0, $8nGP5.useEffect)(()=>()=>onUnmount.current(), []);
}



function $32111235bb00f3df$export$2e2bcd8739ae039(node) {
    var doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $7f1da6e4e2ccffac$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $32111235bb00f3df$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $93dc448587824ba2$var$rUpper = /([A-Z])/g;
function $93dc448587824ba2$export$2e2bcd8739ae039(string) {
    return string.replace($93dc448587824ba2$var$rUpper, '-$1').toLowerCase();
}


var $fc9e0f35a4611ba5$var$msPattern = /^ms-/;
function $fc9e0f35a4611ba5$export$2e2bcd8739ae039(string) {
    return (0, $93dc448587824ba2$export$2e2bcd8739ae039)(string).replace($fc9e0f35a4611ba5$var$msPattern, '-ms-');
}


var $8daf33ed3a5b05b4$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $8daf33ed3a5b05b4$export$2e2bcd8739ae039(value) {
    return !!(value && $8daf33ed3a5b05b4$var$supportedTransforms.test(value));
}


function $6a01e84b1d47be46$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(property)) || (0, $7f1da6e4e2ccffac$export$2e2bcd8739ae039)(node).getPropertyValue((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(key));
        else if ((0, $8daf33ed3a5b05b4$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $6a01e84b1d47be46$export$2e2bcd8739ae039 = $6a01e84b1d47be46$var$style;



/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $3d98db97c6f46e5c$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $8061db448c42d261$var$parseDuration(node) {
    var str = (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $8061db448c42d261$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $3d98db97c6f46e5c$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $8061db448c42d261$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $8061db448c42d261$var$parseDuration(element) || 0;
    var removeEmulate = $8061db448c42d261$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}



var $8nGP5 = parcelRequire("8nGP5");

function $6efacf96f2f861d9$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}






var $8nGP5 = parcelRequire("8nGP5");

var $fCKK7 = parcelRequire("fCKK7");

var $8nGP5 = parcelRequire("8nGP5");
function $3c50a1c9e4ee53df$export$2e2bcd8739ae039() {
    const mounted = (0, $8nGP5.useRef)(true);
    const isMounted = (0, $8nGP5.useRef)(()=>mounted.current);
    (0, $8nGP5.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $8nGP5 = parcelRequire("8nGP5");
function $9de23d41be037aba$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $8nGP5.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $8nGP5 = parcelRequire("8nGP5");
function $de03566a141af7e0$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $9de23d41be037aba$export$2e2bcd8739ae039)(fn);
    (0, $8nGP5.useEffect)(()=>()=>onUnmount.current(), []);
}



var $8nGP5 = parcelRequire("8nGP5");
function $1cfe1a1d2e5bf439$export$2e2bcd8739ae039(value) {
    const ref = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}




const $19eda73d643e0be8$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $19eda73d643e0be8$export$635202801f9383a0 = `rrUi`;
function $19eda73d643e0be8$export$5cc3b7b83e34ade7(property) {
    return `${$19eda73d643e0be8$export$fd7bcb7e9bef4e8a}${property}`;
}
function $19eda73d643e0be8$export$7776c0a7cd2eb3e0(property) {
    return `${$19eda73d643e0be8$export$635202801f9383a0}${property}`;
}


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $46848d7ceeaea2db$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $552cb07f9c689b45$export$1a88c12b8b979fa0 = (0, $19eda73d643e0be8$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $552cb07f9c689b45$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $46848d7ceeaea2db$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($552cb07f9c689b45$export$1a88c12b8b979fa0, '');
        (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($552cb07f9c689b45$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $552cb07f9c689b45$export$2e2bcd8739ae039 = $552cb07f9c689b45$var$ModalManager;





var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

const $67b55d196373d367$var$Context = /*#__PURE__*/ (0, $8nGP5.createContext)((0, $53e6d5b016eb161e$export$2e2bcd8739ae039) ? window : undefined);
const $67b55d196373d367$export$f7d306aeb1cf5fbc = $67b55d196373d367$var$Context.Provider;
function $67b55d196373d367$export$2e2bcd8739ae039() {
    return (0, $8nGP5.useContext)($67b55d196373d367$var$Context);
}


const $817b88310a2bf6f9$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $53e6d5b016eb161e$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $817b88310a2bf6f9$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $67b55d196373d367$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $8nGP5.useState)(()=>$817b88310a2bf6f9$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $817b88310a2bf6f9$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $8nGP5.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $8nGP5.useEffect)(()=>{
        const nextRef = $817b88310a2bf6f9$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}




var $8nGP5 = parcelRequire("8nGP5");
const $d4f8bf939aa0eef9$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $d4f8bf939aa0eef9$export$c9058316764c140e(refA, refB) {
    const a = $d4f8bf939aa0eef9$var$toFnRef(refA);
    const b = $d4f8bf939aa0eef9$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $d4f8bf939aa0eef9$var$useMergedRefs(refA, refB) {
    return (0, $8nGP5.useMemo)(()=>$d4f8bf939aa0eef9$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $d4f8bf939aa0eef9$export$2e2bcd8739ae039 = $d4f8bf939aa0eef9$var$useMergedRefs;




var $8nGP5 = parcelRequire("8nGP5");
const $29dbdd8a46c7ba41$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $29dbdd8a46c7ba41$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $29dbdd8a46c7ba41$export$2e2bcd8739ae039 = $29dbdd8a46c7ba41$var$isDOM || $29dbdd8a46c7ba41$var$isReactNative ? (0, $8nGP5.useLayoutEffect) : (0, $8nGP5.useEffect);



var $8nGP5 = parcelRequire("8nGP5");



var $8nGP5 = parcelRequire("8nGP5");

function $33ca0dc5077d1d37$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $8nGP5.useRef)(null);
    const hasEnteredRef = (0, $8nGP5.useRef)(inProp);
    const handleExited = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)(onExited);
    (0, $8nGP5.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $d4f8bf939aa0eef9$export$2e2bcd8739ae039)(ref, (0, $408b7150cc48713e$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $8nGP5.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $33ca0dc5077d1d37$export$2e2bcd8739ae039 = $33ca0dc5077d1d37$var$NoopTransition;



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");


const $a0ff899740a9b78a$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $a0ff899740a9b78a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a0ff899740a9b78a$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $a0ff899740a9b78a$var$_objectWithoutPropertiesLoose(_ref, $a0ff899740a9b78a$var$_excluded);
    const nodeRef = (0, $8nGP5.useRef)(null);
    const mergedRef = (0, $d4f8bf939aa0eef9$export$2e2bcd8739ae039)(nodeRef, (0, $408b7150cc48713e$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $8nGP5.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $8nGP5.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $8nGP5.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $8nGP5.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $8nGP5.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $8nGP5.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $8nGP5.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $8nGP5.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



var $kSbwP = parcelRequire("kSbwP");
const $76392ad25aa56c15$var$_excluded = [
    "component"
];
function $76392ad25aa56c15$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $76392ad25aa56c15$var$RTGTransition = /*#__PURE__*/ $8nGP5.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $76392ad25aa56c15$var$_objectWithoutPropertiesLoose(_ref, $76392ad25aa56c15$var$_excluded);
    const transitionProps = (0, $a0ff899740a9b78a$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $76392ad25aa56c15$export$2e2bcd8739ae039 = $76392ad25aa56c15$var$RTGTransition;




var $kSbwP = parcelRequire("kSbwP");
function $f2e2556fd867f756$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $8nGP5.useRef)(null);
    const isInitialRef = (0, $8nGP5.useRef)(true);
    const handleTransition = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)(onTransition);
    (0, $29dbdd8a46c7ba41$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $29dbdd8a46c7ba41$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $f2e2556fd867f756$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $8nGP5.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $f2e2556fd867f756$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $d4f8bf939aa0eef9$export$2e2bcd8739ae039)(ref, (0, $408b7150cc48713e$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $8nGP5.cloneElement)(children, {
        ref: combinedRef
    });
}
function $f2e2556fd867f756$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $76392ad25aa56c15$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $kSbwP.jsx)($f2e2556fd867f756$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $33ca0dc5077d1d37$export$2e2bcd8739ae039), Object.assign({}, props));
}




var $kSbwP = parcelRequire("kSbwP");
const $a992c6d2ca511b6e$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $a992c6d2ca511b6e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $a992c6d2ca511b6e$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $a992c6d2ca511b6e$var$getManager(window) {
    if (!$a992c6d2ca511b6e$var$manager) $a992c6d2ca511b6e$var$manager = new (0, $552cb07f9c689b45$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $a992c6d2ca511b6e$var$manager;
}
function $a992c6d2ca511b6e$var$useModalManager(provided) {
    const window = (0, $67b55d196373d367$export$2e2bcd8739ae039)();
    const modalManager = provided || $a992c6d2ca511b6e$var$getManager(window);
    const modal = (0, $8nGP5.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $8nGP5.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $8nGP5.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $a992c6d2ca511b6e$var$Modal = /*#__PURE__*/ (0, $8nGP5.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $kSbwP.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $a992c6d2ca511b6e$var$_objectWithoutPropertiesLoose(_ref, $a992c6d2ca511b6e$var$_excluded);
    const ownerWindow = (0, $67b55d196373d367$export$2e2bcd8739ae039)();
    const container = (0, $817b88310a2bf6f9$export$2e2bcd8739ae039)(containerRef);
    const modal = $a992c6d2ca511b6e$var$useModalManager(providedManager);
    const isMounted = (0, $3c50a1c9e4ee53df$export$2e2bcd8739ae039)();
    const prevShow = (0, $1cfe1a1d2e5bf439$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $8nGP5.useState)(!show);
    const lastFocusRef = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $53e6d5b016eb161e$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $6efacf96f2f861d9$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $6efacf96f2f861d9$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $8nGP5.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $8nGP5.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $de03566a141af7e0$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $6efacf96f2f861d9$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $408b7150cc48713e$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $8nGP5.useRef)();
    const removeKeydownListenerRef = (0, $8nGP5.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $kSbwP.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $8nGP5.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $f2e2556fd867f756$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $f2e2556fd867f756$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).createPortal(/*#__PURE__*/ (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$a992c6d2ca511b6e$var$Modal.displayName = 'Modal';
var $a992c6d2ca511b6e$export$2e2bcd8739ae039 = Object.assign($a992c6d2ca511b6e$var$Modal, {
    Manager: (0, $552cb07f9c689b45$export$2e2bcd8739ae039)
});


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $720e403436e1555a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $abf72811607b651f$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $720e403436e1555a$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}



var $0a134cba80b47542$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $0a134cba80b47542$export$2e2bcd8739ae039(element, selector) {
    return $0a134cba80b47542$var$toArray(element.querySelectorAll(selector));
}


function $37a47d2269fc3066$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $37a47d2269fc3066$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $37a47d2269fc3066$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $37a47d2269fc3066$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $87d9e6f6f2272868$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $87d9e6f6f2272868$var$BootstrapModalManager extends (0, $552cb07f9c689b45$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $abf72811607b651f$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $87d9e6f6f2272868$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $87d9e6f6f2272868$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $87d9e6f6f2272868$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $37a47d2269fc3066$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $87d9e6f6f2272868$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $87d9e6f6f2272868$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $87d9e6f6f2272868$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $87d9e6f6f2272868$var$sharedManager;
function $87d9e6f6f2272868$export$a03641438014b436(options) {
    if (!$87d9e6f6f2272868$var$sharedManager) $87d9e6f6f2272868$var$sharedManager = new $87d9e6f6f2272868$var$BootstrapModalManager(options);
    return $87d9e6f6f2272868$var$sharedManager;
}
var $87d9e6f6f2272868$export$2e2bcd8739ae039 = $87d9e6f6f2272868$var$BootstrapModalManager;




var $8nGP5 = parcelRequire("8nGP5");

var $4paKp = parcelRequire("4paKp");



function $eec92eddb9cff3d6$var$parseDuration(node, property) {
    const str = (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $eec92eddb9cff3d6$export$2e2bcd8739ae039(element, handler) {
    const duration = $eec92eddb9cff3d6$var$parseDuration(element, 'transitionDuration');
    const delay = $eec92eddb9cff3d6$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $8061db448c42d261$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $94957a6bb9755a13$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $8nGP5 = parcelRequire("8nGP5");

var $4paKp = parcelRequire("4paKp");


var $fCKK7 = parcelRequire("fCKK7");
function $3946f1acb962737a$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



var $kSbwP = parcelRequire("kSbwP");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $c2b457a9716bf39a$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $8nGP5.useRef)(null);
    const mergedRef = (0, $e2bab6b473f544db$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $3946f1acb962737a$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $8nGP5.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $8nGP5.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $8nGP5.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $8nGP5.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $8nGP5.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $8nGP5.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $8nGP5.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $4paKp.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $c2b457a9716bf39a$export$2e2bcd8739ae039 = $c2b457a9716bf39a$var$TransitionWrapper;



var $kSbwP = parcelRequire("kSbwP");
const $fd60cdcd5f9eb8a2$var$fadeStyles = {
    [(0, $4paKp.ENTERING)]: 'show',
    [(0, $4paKp.ENTERED)]: 'show'
};
const $fd60cdcd5f9eb8a2$var$Fade = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $8nGP5.useCallback)((node, isAppearing)=>{
        (0, $94957a6bb9755a13$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $c2b457a9716bf39a$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $eec92eddb9cff3d6$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $408b7150cc48713e$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $8nGP5.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('fade', className, children.props.className, $fd60cdcd5f9eb8a2$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$fd60cdcd5f9eb8a2$var$Fade.displayName = 'Fade';
var $fd60cdcd5f9eb8a2$export$2e2bcd8739ae039 = $fd60cdcd5f9eb8a2$var$Fade;



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $d14e4ebe877d3338$var$ModalBody = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$d14e4ebe877d3338$var$ModalBody.displayName = 'ModalBody';
var $d14e4ebe877d3338$export$2e2bcd8739ae039 = $d14e4ebe877d3338$var$ModalBody;



var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $3ac4174ede748b66$var$ModalContext = /*#__PURE__*/ $8nGP5.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $3ac4174ede748b66$export$2e2bcd8739ae039 = $3ac4174ede748b66$var$ModalContext;




var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
"use client";
const $228e13bc647c9363$var$ModalDialog = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $kSbwP.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $kSbwP.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$228e13bc647c9363$var$ModalDialog.displayName = 'ModalDialog';
var $228e13bc647c9363$export$2e2bcd8739ae039 = $228e13bc647c9363$var$ModalDialog;



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $074c9208572777ca$var$ModalFooter = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$074c9208572777ca$var$ModalFooter.displayName = 'ModalFooter';
var $074c9208572777ca$export$2e2bcd8739ae039 = $074c9208572777ca$var$ModalFooter;




var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");


var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
const $e0958d1cf5d09ae0$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOf([
        'white'
    ])
};
const $e0958d1cf5d09ae0$var$CloseButton = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $kSbwP.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$e0958d1cf5d09ae0$var$CloseButton.displayName = 'CloseButton';
$e0958d1cf5d09ae0$var$CloseButton.propTypes = $e0958d1cf5d09ae0$var$propTypes;
var $e0958d1cf5d09ae0$export$2e2bcd8739ae039 = $e0958d1cf5d09ae0$var$CloseButton;




var $kSbwP = parcelRequire("kSbwP");
"use client";
const $518ad274ab05ffc5$var$AbstractModalHeader = /*#__PURE__*/ $8nGP5.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $8nGP5.useContext)((0, $3ac4174ede748b66$export$2e2bcd8739ae039));
    const handleClick = (0, $129f7f7db7f8a1a4$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $kSbwP.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $kSbwP.jsx)((0, $e0958d1cf5d09ae0$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $518ad274ab05ffc5$export$2e2bcd8739ae039 = $518ad274ab05ffc5$var$AbstractModalHeader;



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $3446e3cddf8a2bfb$var$ModalHeader = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $518ad274ab05ffc5$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$3446e3cddf8a2bfb$var$ModalHeader.displayName = 'ModalHeader';
var $3446e3cddf8a2bfb$export$2e2bcd8739ae039 = $3446e3cddf8a2bfb$var$ModalHeader;



var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
var $55e39b9a06867ca6$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $8nGP5.forwardRef((p, ref)=>/*#__PURE__*/ (0, $kSbwP.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(p.className, className)
        }));




var $kSbwP = parcelRequire("kSbwP");
"use client";
const $53fd9455bbf7b5b6$var$DivStyledAsH4 = (0, $55e39b9a06867ca6$export$2e2bcd8739ae039)('h4');
const $53fd9455bbf7b5b6$var$ModalTitle = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $53fd9455bbf7b5b6$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$53fd9455bbf7b5b6$var$ModalTitle.displayName = 'ModalTitle';
var $53fd9455bbf7b5b6$export$2e2bcd8739ae039 = $53fd9455bbf7b5b6$var$ModalTitle;




var $kSbwP = parcelRequire("kSbwP");
"use client";
/* eslint-disable no-use-before-define, react/no-multi-comp */ function $58851437c2fcbc16$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $fd60cdcd5f9eb8a2$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $58851437c2fcbc16$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $fd60cdcd5f9eb8a2$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
/* eslint-enable no-use-before-define */ const $58851437c2fcbc16$var$Modal = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $228e13bc647c9363$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $8nGP5.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $8nGP5.useState)(false);
    const waitingForMouseUpRef = (0, $8nGP5.useRef)(false);
    const ignoreBackdropClickRef = (0, $8nGP5.useRef)(false);
    const removeStaticModalAnimationRef = (0, $8nGP5.useRef)(null);
    const [modal, setModalRef] = (0, $dd85a49ad087ea71$export$2e2bcd8739ae039)();
    const mergedRef = (0, $e2bab6b473f544db$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $129f7f7db7f8a1a4$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $58df59260255f5cd$export$35e511eefa30ac5a)();
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $8nGP5.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $87d9e6f6f2272868$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $53e6d5b016eb161e$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $eb61065bad00bf9b$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $eb61065bad00bf9b$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $129f7f7db7f8a1a4$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $05980fa951c421ef$export$2e2bcd8739ae039)(()=>{
        (0, $bf50d51abf54f84c$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $8061db448c42d261$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $39288ac6dc5c98da$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $bf50d51abf54f84c$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $8nGP5.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $kSbwP.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $kSbwP.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $3ac4174ede748b66$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $a992c6d2ca511b6e$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $58851437c2fcbc16$var$DialogTransition : undefined,
            backdropTransition: animation ? $58851437c2fcbc16$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$58851437c2fcbc16$var$Modal.displayName = 'Modal';
var $58851437c2fcbc16$export$2e2bcd8739ae039 = Object.assign($58851437c2fcbc16$var$Modal, {
    Body: (0, $d14e4ebe877d3338$export$2e2bcd8739ae039),
    Header: (0, $3446e3cddf8a2bfb$export$2e2bcd8739ae039),
    Title: (0, $53fd9455bbf7b5b6$export$2e2bcd8739ae039),
    Footer: (0, $074c9208572777ca$export$2e2bcd8739ae039),
    Dialog: (0, $228e13bc647c9363$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});



var $kSbwP = parcelRequire("kSbwP");




var $8nGP5 = parcelRequire("8nGP5");
var $ad863d1fe94b2dca$export$34e0f9847d4c02dd;
var $ad863d1fe94b2dca$export$9ba0cfb8fa4ba68e;
var $ad863d1fe94b2dca$export$f6471a94714eac4f;
$ad863d1fe94b2dca$export$34e0f9847d4c02dd = "container_8a01dc";
$ad863d1fe94b2dca$export$9ba0cfb8fa4ba68e = "dealsList_8a01dc";
$ad863d1fe94b2dca$export$f6471a94714eac4f = "noDealsMessage_8a01dc";



var $kSbwP = parcelRequire("kSbwP");


var $fgQ0V = parcelRequire("fgQ0V");


var $8nGP5 = parcelRequire("8nGP5");



var $afca4ba0a48f0a65$export$37c8efd0a1d7c4c5;
var $afca4ba0a48f0a65$export$d76128d007d19019;
var $afca4ba0a48f0a65$export$f2ea4ab276c3e3fa;
$afca4ba0a48f0a65$export$37c8efd0a1d7c4c5 = `_1rmtOa_industrySearch`;
$afca4ba0a48f0a65$export$d76128d007d19019 = `_1rmtOa_search`;
$afca4ba0a48f0a65$export$f2ea4ab276c3e3fa = `_1rmtOa_searchBar`;


const $c835f8fd4338c73e$export$cb3868da59be7632 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const clientStore = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
    const [multiSelectionsIndustry, setMultiSelectionsIndustry] = (0, $8nGP5.useState)([]);
    const [textSearch, setTextSearch] = (0, $8nGP5.useState)(ui.dealPageNameSearch);
    const setTextSearchDebounce = (0, $fgQ0V.debounce)((text)=>{
        ui.dealPageNameSearch = text;
    }, 300);
    const updateSelectionIndustry = (selected)=>{
        var updated = [];
        selected.forEach((selection)=>{
            if (!updated.find((item)=>item.value == selection.value)) updated.push({
                label: selection.label,
                value: selection.value
            });
        });
        setMultiSelectionsIndustry(updated);
    };
    // Update UI store when industry selections change
    (0, $8nGP5.useEffect)(()=>{
        const filter = multiSelectionsIndustry.map((selection)=>{
            const [type, value] = selection.value.split(':');
            return {
                type: type === 'CAT' ? 'category' : 'sub_category',
                value: value
            };
        });
        ui.dealPageIndustrySearch = filter;
    }, [
        multiSelectionsIndustry
    ]);
    const filterBy = (option, ticker)=>{
        return option.label.toLowerCase().indexOf(ticker.text.toLowerCase()) > -1;
    };
    const braileSpacing = "\u2800  ";
    var options = [];
    const industry = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)().industryTypes;
    industry.forEach((industry)=>{
        var name = industry.name;
        options.push({
            label: name,
            value: 'CAT:' + name,
            industry: name,
            type: 'category'
        });
        industry.subtypes.forEach((sub_industry)=>{
            options.push({
                label: braileSpacing + sub_industry.name,
                value: 'SUB:' + sub_industry.name,
                industry: name,
                type: 'subcategory'
            });
        });
    });
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "row",
        className: $afca4ba0a48f0a65$export$f2ea4ab276c3e3fa,
        children: [
            (0, $kSbwP.jsx)("input", {
                type: "text",
                className: $afca4ba0a48f0a65$export$d76128d007d19019,
                value: textSearch,
                onInput: (e)=>{
                    setTextSearch(e.currentTarget.value);
                    setTextSearchDebounce(e.currentTarget.value);
                },
                placeholder: "Filter by name"
            }),
            (0, $kSbwP.jsx)("div", {
                className: $afca4ba0a48f0a65$export$37c8efd0a1d7c4c5,
                children: (0, $kSbwP.jsx)((0, $987409511f795a07$export$2e2bcd8739ae039), {
                    id: "industry-search",
                    filterBy: filterBy,
                    options: options,
                    placeholder: "Filter by Industry",
                    onChange: updateSelectionIndustry,
                    selected: multiSelectionsIndustry,
                    multiple: true
                })
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");



var $c80b2b194ff1d582$export$e8c9778bf415dd08;
var $c80b2b194ff1d582$export$d049a13fc4149044;
var $c80b2b194ff1d582$export$f3cbcc6ad82435d7;
var $c80b2b194ff1d582$export$becc9140d0e846f8;
var $c80b2b194ff1d582$export$fb184b623420d9be;
$c80b2b194ff1d582$export$e8c9778bf415dd08 = `ILtJUa_divider`;
$c80b2b194ff1d582$export$d049a13fc4149044 = `ILtJUa_industry`;
$c80b2b194ff1d582$export$f3cbcc6ad82435d7 = `ILtJUa_overview`;
$c80b2b194ff1d582$export$becc9140d0e846f8 = `ILtJUa_thumb`;
$c80b2b194ff1d582$export$fb184b623420d9be = `ILtJUa_title`;


const $89dd179b54b13253$export$8832a5f5671b8826 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = store.createDataAccess(p.name);
    const companyName = query.value('company_name');
    const industry = query.value('industry');
    const sub_industry = query.value('industrySubType');
    const companyDesc = query.value('company_overview_short');
    const industry_display = sub_industry ? `${industry} - ${sub_industry}` : industry;
    return (0, $kSbwP.jsx)("div", {
        className: $c80b2b194ff1d582$export$becc9140d0e846f8,
        onClick: ()=>{
            var _a;
            return (_a = p.onSelect) === null || _a === void 0 ? void 0 : _a.call(p, p.name);
        },
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $c80b2b194ff1d582$export$fb184b623420d9be,
                    children: companyName
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $c80b2b194ff1d582$export$d049a13fc4149044,
                    children: industry_display
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $c80b2b194ff1d582$export$e8c9778bf415dd08
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $c80b2b194ff1d582$export$f3cbcc6ad82435d7,
                    children: companyDesc
                })
            ]
        })
    });
});


const $20dd9c5d79447fd3$export$49c0ae12ded1f0dd = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const clientStore = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
    const excludeDeals = props.excludeDeals || [];
    (0, $8nGP5.useEffect)(()=>{
        uiStore.dealPageIndustrySearch = [];
        uiStore.dealPageNameSearch = '';
    }, []);
    const dealKeys = Object.keys(store.reportDataDB);
    var filtered = dealKeys.filter((deal)=>{
        // Filter out excluded deals (active company and already selected companies)
        if (excludeDeals.includes(deal)) return false;
        var e = store.reportDataDB[deal];
        if (e.status != 'completed') return false;
        // Apply demo filter
        const filter_settings = clientStore.filterCompaniesForDemo;
        if (clientStore.isDemoFilterOn && filter_settings != null) {
            if (filter_settings[deal] !== true) return false;
        }
        var dataAccess = store.createDataAccess(deal);
        const companyName = dataAccess.companyName;
        const matchCompanyName = companyName.toLowerCase().includes(uiStore.dealPageNameSearch.toLowerCase()) || uiStore.dealPageNameSearch == '';
        const filter = uiStore.dealPageIndustrySearch;
        var industry = dataAccess.value('industry');
        var sub_industry = dataAccess.value('industrySubType');
        if (!dataAccess.report_has_pdf) return false;
        var matchIndustry = false;
        if (filter.length == 0) matchIndustry = true;
        else filter.forEach((filterItem)=>{
            if (filterItem.type == 'category') {
                if (filterItem.value == industry) matchIndustry = true;
            } else if (filterItem.type == 'sub_category') {
                if (filterItem.value == sub_industry) matchIndustry = true;
            }
        });
        return matchCompanyName && matchIndustry;
    });
    filtered = filtered.sort((a, b)=>{
        const aName = store.reportDataDB[a].company_name;
        const bName = store.reportDataDB[b].company_name;
        return aName.localeCompare(bName);
    });
    const deals = filtered.map((deal)=>(0, $kSbwP.jsx)((0, $89dd179b54b13253$export$8832a5f5671b8826), {
            name: deal,
            onSelect: props.onDealSelect
        }, deal));
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        className: $ad863d1fe94b2dca$export$34e0f9847d4c02dd,
        children: [
            (0, $kSbwP.jsx)((0, $c835f8fd4338c73e$export$cb3868da59be7632), {}),
            (0, $kSbwP.jsx)("div", {
                className: $ad863d1fe94b2dca$export$9ba0cfb8fa4ba68e,
                children: deals.length > 0 ? deals : (0, $kSbwP.jsx)("div", {
                    className: $ad863d1fe94b2dca$export$f6471a94714eac4f,
                    children: "No available deals to select"
                })
            })
        ]
    });
});



var $fCKK7 = parcelRequire("fCKK7");
const $5a1995dee7b5d277$export$a928f7cf0495745d = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const clientStore = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const [showComparableSearch, setShowComparableSearch] = (0, $8nGP5.useState)(false);
    const [comparableClickedPosition, setComparableClickedPosition] = (0, $8nGP5.useState)(null);
    const INDUSTRY_AVG_ID = 'INDUSTRY_AVERAGE';
    const SECTIONS_SHOW_NOT_SCORED = [
        'overview'
    ];
    if (store.selectedReportId == '' || store.query == null) return null;
    const q = store.query;
    const getQ = (reportId)=>{
        if (reportId === 'ADD_BUTTON') return null;
        if (reportId === INDUSTRY_AVG_ID) return aggAccess;
        return store.createDataAccess(reportId);
    };
    const handleRemoveComparable = (position)=>{
        const updatedComparables = [
            ...store.userComparables
        ];
        updatedComparables[position] = null;
        while(updatedComparables.length < 2)updatedComparables.push(null);
        store.saveUserComparables(store.selectedReportId, updatedComparables);
    };
    const handleComparableSelect = (dealId)=>{
        if (comparableClickedPosition === null) return;
        const updatedComparables = [
            ...store.userComparables
        ];
        updatedComparables[comparableClickedPosition] = dealId;
        while(updatedComparables.length < 2)updatedComparables.push(null);
        store.saveUserComparables(store.selectedReportId, updatedComparables);
        setShowComparableSearch(false);
        setComparableClickedPosition(null);
    };
    // Load default comparables if none exist
    (0, $8nGP5.useEffect)(()=>{
        if (store.selectedReportId && !store.allUserComparables[store.selectedReportId]) {
            const defaultComparables = (0, $7403a76d892238e8$export$8b849e0e30783f61).findCompaniesToCompare(store.selectedReportId, 2);
            store.initializeUserComparables(store.selectedReportId, defaultComparables);
        }
    }, [
        store.selectedReportId
    ]);
    const companies = [
        store.selectedReportId,
        ...store.userComparables.filter((dealId)=>dealId !== null && dealId !== undefined)
    ];
    // Create an array of columns with fixed positions
    const columnsData = [
        store.selectedReportId,
        ...store.userComparables,
        INDUSTRY_AVG_ID
    ];
    const dataAccess = {
        string: (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)
    };
    const mainDeal = store.createDataAccess(store.selectedReportId);
    const aggAccess = new (0, $7e550ef9293629bd$export$2044ca5e7e8cae3)(mainDeal.value('industry'), mainDeal.value('industrySubType'));
    companies.forEach((company)=>{
        if (company == INDUSTRY_AVG_ID) return;
        const query = getQ(company);
        dataAccess[company] = query;
    });
    const getElement = (fieldName, rule)=>{
        const cagrPercentElement = (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).custom((row, col, data)=>{
            var typed = data;
            var keys = Object.keys(typed).sort();
            var children = [];
            for(let i = 0; i < keys.length; i++){
                const yearIndex = keys[i];
                const value = typed[yearIndex];
                // Skip entries with 0 years as they represent no data
                if (value != null && parseInt(yearIndex) > 0) {
                    var valDisplay = value == 'N/A' ? 'N/A' : (0, $7fbd760f3c05e83d$export$e440a706af0c0216)(value.toString());
                    children.push((0, $kSbwP.jsxs)((0, $8nGP5.Fragment), {
                        children: [
                            (0, $kSbwP.jsx)("div", {
                                children: valDisplay
                            }),
                            (0, $kSbwP.jsxs)("div", {
                                children: [
                                    "(",
                                    yearIndex,
                                    " years) "
                                ]
                            }, yearIndex),
                            (0, $kSbwP.jsx)("div", {
                                className: "w-100"
                            })
                        ]
                    }, yearIndex));
                }
            }
            // If no valid entries were found, display a simple dash
            if (children.length === 0) return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "row",
                justify: "center",
                fillCell: true,
                wrap: "wrap",
                children: (0, $kSbwP.jsx)("div", {
                    children: "-"
                })
            });
            return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "row",
                justify: "center",
                fillCell: true,
                wrap: "wrap",
                style: {
                    gap: '5px'
                },
                children: children
            });
        });
        const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
        const rules = (0, $9b879bbdd76f7296$export$f65e0b130162f295)();
        if (e.t == 'bool') return (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).booleanCentered;
        else if (e.t == '%') {
            if (rule.dataPick != null) return cagrPercentElement;
            return (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent;
        } else return (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value;
    };
    const getLabel = (fieldName)=>{
        const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
        if (e.t == '%') return (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label;
        else return (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label;
    };
    const formatPercentWithYear = (data)=>{
        if (!data && data !== 0) data = '';
        if ((0, $fgQ0V.isString)(data)) return data;
        const v = data;
        return `${(0, $7fbd760f3c05e83d$export$e440a706af0c0216)(v.value.toString())} (${v.years} years)`;
    };
    const getFormatter = (fieldName, rule)=>{
        const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
        if (e.t == '%') {
            if (rule.dataPick != null) return 0, $1ac83566e6b5504b$export$8c8c9051f21dcdc2;
            if (e.scale == 100) return 0, $1ac83566e6b5504b$export$23be700726d3a499;
            return 0, $1ac83566e6b5504b$export$32e6b1ae352e94d6;
        } else if (e.t == 'bool' || e.t == 'str') return null;
        else return 0, $1ac83566e6b5504b$export$40333d0facc9092d;
    };
    var scoreStore = (0, $9b879bbdd76f7296$export$5bbef306d29b8236)();
    const fieldsGroup = scoreStore.COMPARE_FIELDS_GROUPS;
    const genColumn = (reportId, position)=>{
        // If position is for a comparable (1 or 2) and reportId is null, show Add Deal button
        if ((position === 1 || position === 2) && reportId === null) return {
            column: {
                source: 'ADD_BUTTON',
                display: null
            },
            header: ()=>(0, $kSbwP.jsx)("button", {
                    className: $e8cfe043fdb0cc46$export$49b67a8b77a2f86,
                    onClick: ()=>{
                        // Pass the position where the user clicked
                        setComparableClickedPosition(position - 1);
                        setShowComparableSearch(true);
                    },
                    title: `Add comparable in position ${position}`,
                    children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "column",
                        alignItems: "center",
                        justify: "center",
                        style: {
                            height: '100%'
                        },
                        children: [
                            (0, $kSbwP.jsx)("i", {
                                className: "bi bi-plus-lg",
                                style: {
                                    fontSize: '32px',
                                    color: '#0066FF'
                                }
                            }),
                            (0, $kSbwP.jsx)("div", {
                                className: $e8cfe043fdb0cc46$export$8809b6c1d844b52e,
                                children: "Add Deal"
                            })
                        ]
                    })
                })
        };
        return {
            column: {
                source: reportId,
                display: null
            },
            header: (col)=>{
                const q = getQ(col.column.source);
                if (!q && col.column.source !== INDUSTRY_AVG_ID) return null;
                const name = (q === null || q === void 0 ? void 0 : q.value('company_name')) || (col.column.source === INDUSTRY_AVG_ID ? 'Industry Average' : 'Unknown Company');
                let logoURL = null;
                if (col.column.source === INDUSTRY_AVG_ID) logoURL = (0, (/*@__PURE__*/$parcel$interopDefault($5629e6120e100578$exports)));
                else logoURL = q === null || q === void 0 ? void 0 : q.value('logoURL');
                return (0, $kSbwP.jsxs)("div", {
                    className: $e8cfe043fdb0cc46$export$6b2d426110a11d7a,
                    children: [
                        (position === 1 || position === 2) && reportId !== null && (0, $kSbwP.jsx)("button", {
                            onClick: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                handleRemoveComparable(position - 1); // Adjust position for store array
                            },
                            className: $e8cfe043fdb0cc46$export$8d776830dbcce823,
                            title: `Remove comparable from position ${position}`,
                            children: (0, $kSbwP.jsx)("i", {
                                className: "bi bi-x-lg",
                                style: {
                                    color: '#DD2222'
                                }
                            })
                        }),
                        (0, $kSbwP.jsx)("a", {
                            href: `${col.column.source}`,
                            style: {
                                textDecoration: 'none',
                                cursor: col.column.source === INDUSTRY_AVG_ID ? 'default' : 'pointer'
                            },
                            className: "companyNameLabel",
                            onClick: (e)=>{
                                e.preventDefault();
                                if (col.column.source === INDUSTRY_AVG_ID) return;
                                navUtils.toReport(col.column.source);
                            },
                            children: (0, $kSbwP.jsxs)("div", {
                                className: `${$e8cfe043fdb0cc46$export$a38dc554151ff661} ${reportId === INDUSTRY_AVG_ID ? $e8cfe043fdb0cc46$export$5af45bc883ccaf0a : ''}`,
                                children: [
                                    clientStore.showAggregateScores && q && (0, $kSbwP.jsx)((0, $e3b40bd6db1f40c5$export$e705734ce644674d), {
                                        score: q.score(),
                                        className: `${$e8cfe043fdb0cc46$export$85ce76fe7fec44bf} ${reportId === INDUSTRY_AVG_ID ? $e8cfe043fdb0cc46$export$71039ff750dc3c07 : ''}`
                                    }),
                                    reportId === INDUSTRY_AVG_ID ? (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                                        direction: "column",
                                        alignItems: "center",
                                        justify: "center",
                                        style: {
                                            height: '100%',
                                            paddingTop: '30px',
                                            gap: '4px'
                                        },
                                        children: [
                                            logoURL && (0, $kSbwP.jsx)((0, $3025be2fbc4fcb83$export$9626faa1e0fab265), {
                                                src: logoURL,
                                                className: $e8cfe043fdb0cc46$export$42e4a6ed1eb5a52e
                                            }),
                                            q ? (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
                                                children: [
                                                    (0, $kSbwP.jsx)("div", {
                                                        className: $e8cfe043fdb0cc46$export$5c219a65934d4b9c,
                                                        children: q.value('industry')
                                                    }),
                                                    (0, $kSbwP.jsx)("div", {
                                                        className: $e8cfe043fdb0cc46$export$2dd75df9bbd1a5f4,
                                                        children: q.value('industrySubType')
                                                    })
                                                ]
                                            }) : (0, $kSbwP.jsx)("div", {
                                                className: $e8cfe043fdb0cc46$export$5c219a65934d4b9c,
                                                children: name
                                            })
                                        ]
                                    }) : (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                                        direction: "column",
                                        alignItems: "center",
                                        justify: "between",
                                        style: {
                                            height: '100%',
                                            paddingTop: '30px'
                                        },
                                        children: [
                                            (0, $kSbwP.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    gap: '4px'
                                                },
                                                children: [
                                                    (0, $kSbwP.jsx)("div", {
                                                        className: $e8cfe043fdb0cc46$export$5c219a65934d4b9c,
                                                        children: name
                                                    }),
                                                    (0, $kSbwP.jsx)("div", {
                                                        className: $e8cfe043fdb0cc46$export$c544e8a82a189fe0,
                                                        children: (0, $kSbwP.jsx)("i", {
                                                            className: "bi bi-diamond-fill"
                                                        })
                                                    })
                                                ]
                                            }),
                                            logoURL && (0, $kSbwP.jsx)((0, $3025be2fbc4fcb83$export$9626faa1e0fab265), {
                                                src: logoURL,
                                                className: $e8cfe043fdb0cc46$export$42e4a6ed1eb5a52e
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        };
    };
    // Create columns array with fixed positions
    const columns = columnsData.map((reportId, index)=>genColumn(reportId, index));
    const fieldsToRows = (group)=>{
        const fields = group.fields;
        const rules = (0, $9b879bbdd76f7296$export$f65e0b130162f295)();
        return fields.map((fieldName)=>{
            const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
            const rule = (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_score_rule_by_fieldname(group.sectionId, fieldName);
            (0, $3d71a0e5fc49a3ca$exports.assert)(e != null, `Field ${fieldName} not found in fieldsNameLookup`);
            return {
                field: {
                    source: null,
                    display: e.display
                },
                value: (_field, column)=>{
                    // if (
                    //     fieldName ==
                    //     'projected_organic_cagr_3_years_minus_tam_growth'
                    // ) {
                    //     debugger;
                    // }
                    const q = getQ(column.source);
                    if (e.t == 'str') {
                        if (fieldName.indexOf('extended_') == 0) return q.get_extended_value_float(fieldName);
                        return q.value(fieldName);
                    }
                    return q.get_extended_value_float(fieldName);
                },
                label: getLabel(fieldName),
                formatter: getFormatter(fieldName, rule),
                element: getElement(fieldName, rule)
            };
        });
    };
    const groupTables = fieldsGroup.map((group, i)=>{
        const sectionScoreRow = {
            field: {
                source: null,
                display: ''
            },
            value: (_field, column)=>{
                const q = getQ(column.source);
                var ret = q.scoreBySection(group.sectionId);
                if (ret == -1) return '-';
                return ret;
            },
            formatter: (0, $1ac83566e6b5504b$export$32e6b1ae352e94d6),
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label,
            element: (row, col, data)=>{
                if (!clientStore.showAggregateScores) return null;
                const score = data == '-' ? -1 : data;
                return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    fillCell: true,
                    alignItems: "center",
                    justify: "center",
                    children: (0, $kSbwP.jsx)((0, $33ac36ca38f3f8d0$export$5fb755babf77fa30), {
                        score: score
                    })
                });
            }
        };
        const groupRows = [
            ...fieldsToRows(group)
        ];
        var shouldShow = companies.some((reportId)=>{
            if (reportId == INDUSTRY_AVG_ID) return false;
            if (SECTIONS_SHOW_NOT_SCORED.includes(group.sectionId)) return true;
            var scoreUtils = new (0, $9b879bbdd76f7296$export$39c49a915ff7ed37)(getQ(reportId));
            if (scoreUtils.is_section_used_for_scoring_by_id(group.sectionId)) return true;
            return false;
        });
        const titlePanel = (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
            title: (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_section_name(group.sectionId),
            className: $e8cfe043fdb0cc46$export$9ba80d992c64273b,
            containerClassName: $e8cfe043fdb0cc46$export$daaf31466ad29ead,
            children: (0, $kSbwP.jsx)((0, $3d82e178f5213798$export$ab8815222a429372), {
                section: group.sectionId,
                className: $e8cfe043fdb0cc46$export$4087c73cbd989252
            })
        }, 'title_' + group.sectionId);
        if (!shouldShow) return (0, $kSbwP.jsxs)("div", {
            children: [
                titlePanel,
                (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    justify: "center",
                    children: (0, $kSbwP.jsx)("div", {
                        className: $e8cfe043fdb0cc46$export$41fc6278a3c14d73,
                        children: "No Data Available"
                    })
                })
            ]
        }, 'group_nodata_' + i);
        return (0, $kSbwP.jsxs)("div", {
            children: [
                titlePanel,
                !SECTIONS_SHOW_NOT_SCORED.includes(group.sectionId) && (0, $kSbwP.jsx)("div", {
                    className: $e8cfe043fdb0cc46$export$524c9eca7362778b,
                    children: (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                        columns: columns,
                        rows: [
                            sectionScoreRow
                        ],
                        disable_round_edges: true,
                        className: $e8cfe043fdb0cc46$export$64b67e74237b10b9,
                        noHeaderRow: true
                    })
                }),
                (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                    columns: columns,
                    rows: groupRows,
                    disable_round_edges: true,
                    className: $e8cfe043fdb0cc46$export$637f169d296cfe12,
                    noHeaderRow: true
                })
            ]
        }, 'group_report_' + i);
    });
    const headersTableStyle = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e8cfe043fdb0cc46$export$637f169d296cfe12, $e8cfe043fdb0cc46$export$6633e83f4afff9ea);
    // Create industry row
    const industryRow = {
        field: {
            source: null,
            display: ''
        },
        value: (_field, column)=>{
            const q = getQ(column.source);
            if (column.source === INDUSTRY_AVG_ID) return 'Industry Average';
            return (q === null || q === void 0 ? void 0 : q.value('industry')) || '-';
        },
        formatter: (0, $1ac83566e6b5504b$export$91991769c57c29a),
        element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value
    };
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            fillCell: true,
            children: [
                (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                    columns: columns,
                    rows: [],
                    disable_round_edges: true,
                    className: headersTableStyle
                }),
                showComparableSearch && /*#__PURE__*/ (0, $fCKK7.createPortal)((0, $kSbwP.jsxs)((0, $58851437c2fcbc16$export$2e2bcd8739ae039), {
                    show: true,
                    onHide: ()=>{
                        setShowComparableSearch(false);
                        setComparableClickedPosition(null);
                    },
                    size: "lg",
                    children: [
                        (0, $kSbwP.jsx)((0, $58851437c2fcbc16$export$2e2bcd8739ae039).Header, {
                            closeButton: true,
                            children: (0, $kSbwP.jsx)((0, $58851437c2fcbc16$export$2e2bcd8739ae039).Title, {
                                children: "Add Comparable Deal"
                            })
                        }),
                        (0, $kSbwP.jsx)((0, $58851437c2fcbc16$export$2e2bcd8739ae039).Body, {
                            children: (0, $kSbwP.jsx)((0, $20dd9c5d79447fd3$export$49c0ae12ded1f0dd), {
                                onDealSelect: handleComparableSelect,
                                excludeDeals: [
                                    store.selectedReportId,
                                    ...store.userComparables.filter((dealId)=>dealId !== null && dealId !== undefined)
                                ]
                            })
                        })
                    ]
                }), document.body),
                (0, $kSbwP.jsxs)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                    children: [
                        groupTables,
                        (0, $kSbwP.jsx)("div", {
                            style: {
                                width: '100%',
                                height: '100px'
                            }
                        })
                    ]
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");





var $kSbwP = parcelRequire("kSbwP");




var $8nGP5 = parcelRequire("8nGP5");
/**
 * @fileOverview Bar Chart
 */ 




var $22df2ac19736874d$export$94aefc399ef206a9 = (0, $3cb8ecafb87115bc$export$77871aede60e6838)({
    chartName: 'BarChart',
    GraphicalChild: (0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $f4dd95f529f72065$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $0a6c1adc00c46590$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $b57066fd5661be22$export$ece7de1383db5ac)
});


var $4be1ee3c8ca80a36$export$fb184b623420d9be;
var $4be1ee3c8ca80a36$export$d866e82dddc7abe3;
$4be1ee3c8ca80a36$export$fb184b623420d9be = `pcyrpa_title`;
$4be1ee3c8ca80a36$export$d866e82dddc7abe3 = `pcyrpa_titleUnderline`;






var $a04e8dca7e1102b6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Helper function to create white logo version
const $a04e8dca7e1102b6$var$createWhiteLogo = (logoURL)=>{
    return new Promise((resolve)=>{
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = ()=>{
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            // Draw original image
            ctx.drawImage(img, 0, 0);
            // Get image data
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            // First pass: analyze if logo has meaningful dark content to convert
            let visiblePixels = 0;
            let darkPixels = 0;
            let veryLightPixels = 0;
            for(let i = 0; i < data.length; i += 4){
                const r = data[i];
                const g = data[i + 1];
                const b = data[i + 2];
                const alpha = data[i + 3];
                if (alpha > 50) {
                    // Only count visible pixels
                    visiblePixels++;
                    const gray = 0.299 * r + 0.587 * g + 0.114 * b;
                    if (gray < 128) // Dark pixels that would be converted to white
                    darkPixels++;
                    else if (gray > 220) // Very light pixels (almost white)
                    veryLightPixels++;
                }
            }
            // If logo has very few dark pixels to convert AND is mostly very light, don't convert
            const darkRatio = visiblePixels > 0 ? darkPixels / visiblePixels : 0;
            const veryLightRatio = visiblePixels > 0 ? veryLightPixels / visiblePixels : 0;
            // Only skip conversion if there's very little dark content (<10%) AND mostly very light (>80%)
            if (darkRatio < 0.1 && veryLightRatio > 0.8) {
                resolve(logoURL); // Return original logo
                return;
            }
            // Convert to white version
            for(let i = 0; i < data.length; i += 4){
                const r = data[i];
                const g = data[i + 1];
                const b = data[i + 2];
                const alpha = data[i + 3];
                // Convert to grayscale
                const gray = 0.299 * r + 0.587 * g + 0.114 * b;
                // If pixel is not transparent, make it white or transparent based on darkness
                if (alpha > 0) {
                    if (gray < 128) {
                        // Dark pixels become white
                        data[i] = 255; // R
                        data[i + 1] = 255; // G
                        data[i + 2] = 255; // B
                        data[i + 3] = alpha; // Keep original alpha
                    } else // Light pixels become transparent
                    data[i + 3] = 0;
                }
            }
            // Put modified data back
            ctx.putImageData(imageData, 0, 0);
            // Convert to data URL
            resolve(canvas.toDataURL());
        };
        img.onerror = ()=>resolve(logoURL); // Fallback to original
        img.src = logoURL;
    });
};
const $a04e8dca7e1102b6$export$bf43f5ad66c8bc17 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const nav = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const [ref, bounds] = (0, $7e7ca35815405df8$export$2e2bcd8739ae039)();
    const [clickedEntry, setClickedEntry] = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useState({
        id: ''
    });
    const [whiteLogos, setWhiteLogos] = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useState({});
    const scoreStore = (0, $9b879bbdd76f7296$export$5bbef306d29b8236)();
    var groups = scoreStore.SCORE_FIELDS_GROUPS;
    var data = [];
    // Process logos to white versions
    (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useEffect(()=>{
        const processLogos = ()=>$a04e8dca7e1102b6$var$__awaiter(void 0, void 0, void 0, function*() {
                const logoPromises = {};
                companies.forEach((reportId)=>{
                    const q = store.createDataAccess(reportId);
                    if (q) {
                        const logoURL = q.value('logoURL');
                        if (logoURL && !whiteLogos[reportId]) logoPromises[reportId] = $a04e8dca7e1102b6$var$createWhiteLogo(logoURL);
                    }
                });
                const logoResults = yield Promise.all(Object.entries(logoPromises).map((_a)=>$a04e8dca7e1102b6$var$__awaiter(void 0, [
                        _a
                    ], void 0, function*([reportId, promise]) {
                        return {
                            reportId: reportId,
                            whiteLogo: yield promise
                        };
                    })));
                const newWhiteLogos = Object.assign({}, whiteLogos);
                logoResults.forEach(({ reportId: reportId, whiteLogo: whiteLogo })=>{
                    newWhiteLogos[reportId] = whiteLogo;
                });
                setWhiteLogos(newWhiteLogos);
            });
        processLogos();
    }, [
        p.companies,
        p.reportId
    ]);
    var companies = [
        p.reportId,
        ...p.companies
    ];
    companies.forEach((reportId)=>{
        var companyEntry = {};
        var q = store.createDataAccess(reportId);
        if (q == null) return;
        companyEntry['id'] = reportId;
        companyEntry['name'] = q.value('company_name');
        companyEntry['Score'] = q.score();
        companyEntry['logo'] = q.value('logoURL');
        if (companyEntry['Score'] == -1) return;
        data.push(companyEntry);
    });
    const renderCustomAxisTick = ({ x: x, y: y, payload: payload, visibleTicksCount: visibleTicksCount })=>{
        const originalLogoURL = data[payload.index].logo;
        const reportId = data[payload.index].id;
        const logoURL = whiteLogos[reportId] || originalLogoURL;
        const barWidth = Math.floor(bounds.width / (data.length + 1) * 0.6); // Approximate way if chart width is known
        // Smart text handling for long names
        const maxCharsPerLine = Math.max(8, Math.floor(barWidth / 8)); // Adjust based on bar width
        const companyName = payload.value;
        const words = companyName.split(' ');
        // If name is too long, try to break into multiple lines
        let displayLines = [];
        if (companyName.length > maxCharsPerLine && words.length > 1) {
            // Try to split into 2 lines
            let line1 = '';
            let line2 = '';
            let currentLine = 1;
            for (const word of words)if (currentLine === 1 && (line1 + word).length <= maxCharsPerLine) line1 += (line1 ? ' ' : '') + word;
            else {
                currentLine = 2;
                line2 += (line2 ? ' ' : '') + word;
            }
            if (line1) displayLines.push(line1);
            if (line2) displayLines.push(line2);
        } else if (companyName.length > maxCharsPerLine) // Single word too long - truncate with ellipsis
        displayLines.push(companyName.substring(0, maxCharsPerLine - 1) + "\u2026");
        else // Name fits on one line
        displayLines.push(companyName);
        const imageWidth = barWidth;
        const imageHeight = barWidth * 0.75;
        var img = (0, $kSbwP.jsx)("image", {
            opacity: 1,
            href: logoURL,
            width: barWidth,
            height: barWidth * 0.75,
            preserveAspectRatio: "xMidYMax meet"
        });
        return (0, $kSbwP.jsxs)("g", {
            transform: `translate(${x},${y})`,
            children: [
                (0, $kSbwP.jsx)("svg", {
                    x: -barWidth / 2,
                    y: -30 - imageHeight,
                    width: imageWidth,
                    height: imageHeight,
                    children: img
                }),
                displayLines.map((line, lineIndex)=>(0, $kSbwP.jsx)("text", {
                        fontSize: "14",
                        fontFamily: "Hanken Grotesk",
                        fontWeight: "700",
                        x: 0,
                        y: 25 + lineIndex * 16,
                        textAnchor: "middle",
                        fill: "#323B48",
                        children: line
                    }, lineIndex))
            ]
        });
    };
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            fillCell: true,
            children: [
                (0, $kSbwP.jsx)("div", {
                    ref: ref,
                    style: {
                        height: '100%',
                        width: '100%',
                        position: 'absolute',
                        opacity: 0
                    }
                }),
                (0, $kSbwP.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($4be1ee3c8ca80a36$export$fb184b623420d9be, $4be1ee3c8ca80a36$export$d866e82dddc7abe3),
                    children: "Benchmarking"
                }),
                (0, $kSbwP.jsx)((0, $65a9db7fe004392a$export$e60a4704009a0009), {
                    id: "benchmarking-chart",
                    width: "100%",
                    height: "100%",
                    children: (0, $kSbwP.jsxs)((0, $22df2ac19736874d$export$94aefc399ef206a9), {
                        width: 500,
                        height: 300,
                        data: data,
                        margin: {
                            top: 40,
                            left: 20,
                            right: 20,
                            bottom: 20
                        },
                        children: [
                            (0, $kSbwP.jsx)((0, $836f11cfcda8d642$export$6440e27b9f186856), {
                                vertical: false,
                                horizontal: true,
                                strokeDasharray: "3 3"
                            }),
                            (0, $kSbwP.jsx)((0, $0a6c1adc00c46590$export$f96c4024c52de8f4), {
                                tick: {
                                    fontSize: 16,
                                    fontFamily: 'Hanken Grotesk',
                                    fontWeight: 700,
                                    fill: '#323B48'
                                },
                                tickFormatter: (value)=>`${value}%`
                            }),
                            (0, $kSbwP.jsx)((0, $c1ee5960bb8c7c28$export$28c660c63b792dea), {}),
                            (0, $kSbwP.jsxs)((0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1), {
                                dataKey: 'Score',
                                stackId: "a",
                                radius: [
                                    4,
                                    4,
                                    0,
                                    0
                                ],
                                children: [
                                    data.map((entry, index)=>(0, $kSbwP.jsx)((0, $94307f62a0d95f57$export$f6f0c3fe4ec306ea), {
                                            fill: entry.id === p.reportId ? '#133971' : '#A29F93',
                                            stroke: clickedEntry.id === entry.id ? '#212529' : 'none',
                                            strokeWidth: 2,
                                            onClick: ()=>{
                                                if (entry.id == p.reportId) return;
                                                setClickedEntry({
                                                    id: entry.id
                                                });
                                                setTimeout(()=>{
                                                    setClickedEntry({
                                                        id: ''
                                                    });
                                                    nav.toReport(entry.id);
                                                }, 5);
                                            }
                                        }, `cell-${index}`)),
                                    (0, $kSbwP.jsx)((0, $e476a06be597057a$export$835fcf23ab7bf88), {
                                        dataKey: "Score",
                                        position: "insideTop",
                                        formatter: (v)=>v + '%',
                                        offset: 10,
                                        fill: "white",
                                        stroke: "transparent",
                                        style: {
                                            fontSize: '14px',
                                            fontFamily: 'Hanken Grotesk',
                                            fontWeight: 400
                                        }
                                    })
                                ]
                            }),
                            (0, $kSbwP.jsx)((0, $f4dd95f529f72065$export$ea77231de273b52d), {
                                dataKey: "name",
                                tick: renderCustomAxisTick,
                                interval: 0
                            })
                        ]
                    })
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");








const $79f88d7943aea7e8$export$c2e12a891bea2f25 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const q = store.createDataAccess(p.reportId);
    const hideUnderline = p.hideUnderline === true;
    if (q == null) return null;
    var scoreUtils = new (0, $9b879bbdd76f7296$export$39c49a915ff7ed37)(q);
    var scoreStore = (0, $9b879bbdd76f7296$export$5bbef306d29b8236)();
    var groups = scoreStore.SCORE_FIELDS_GROUPS;
    var data = [];
    const GEN_SCORE_ID = 'ALL';
    const scoreTotal = scoreUtils.calcScorePercentile();
    data.push({
        sectionId: GEN_SCORE_ID,
        name: 'Overall Score',
        Score: scoreTotal ? (scoreTotal * 100).toFixed(0) : 'N/A'
    });
    groups.forEach((group)=>{
        if (scoreUtils.is_section_used_for_scoring_by_id(group.sectionId)) data.push({
            sectionId: group.sectionId,
            name: (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_section_name(group.sectionId),
            Score: (scoreUtils.calcSectionPercentileById(group.sectionId) * 100).toFixed(0)
        });
    });
    const renderCustomAxisTick = ({ x: x, y: y, payload: payload })=>{
        const sectionId = payload.value == GEN_SCORE_ID ? 'overview' : payload.value;
        //const icon = GetSectionIconUrl(sectionId);
        const icon = (0, $3d82e178f5213798$export$13941a4af6282a89)(sectionId);
        const sectionName = data.find((section)=>section.sectionId === payload.value).name.split(' ')[0];
        return (0, $kSbwP.jsxs)("g", {
            transform: `translate(${x},${y})`,
            children: [
                (0, $kSbwP.jsx)("text", {
                    fontSize: "12",
                    fontFamily: "Hanken Grotesk",
                    x: -10,
                    y: 5,
                    textAnchor: "end",
                    fill: "#323B48",
                    fontWeight: "700",
                    ref: (node)=>{
                        if (node) {
                            const textWidth = node.getComputedTextLength();
                            // Posiciona o ícone para terminar onde o texto termina (-10)
                            // Como o ícone tem 20px de largura, começamos em -30
                            const iconX = -30;
                            const iconElement = node.parentElement.querySelector('image');
                            if (iconElement) iconElement.setAttribute('x', String(iconX));
                        }
                    },
                    children: sectionName
                }),
                (0, $kSbwP.jsx)("image", {
                    href: icon,
                    x: -30,
                    y: -30,
                    width: 20,
                    height: 20
                })
            ]
        });
    };
    const titleCls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($4be1ee3c8ca80a36$export$fb184b623420d9be, {
        [$4be1ee3c8ca80a36$export$d866e82dddc7abe3]: !hideUnderline
    });
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        fillCell: true,
        children: [
            (0, $kSbwP.jsx)("div", {
                className: titleCls,
                children: "Score Summary"
            }),
            (0, $kSbwP.jsx)((0, $65a9db7fe004392a$export$e60a4704009a0009), {
                id: "score-chart",
                width: "100%",
                height: "100%",
                children: (0, $kSbwP.jsxs)((0, $22df2ac19736874d$export$94aefc399ef206a9), {
                    layout: "vertical",
                    width: 500,
                    height: 300,
                    data: data,
                    margin: {
                        top: 40,
                        left: 20,
                        right: 20,
                        bottom: 20
                    },
                    barGap: 5,
                    barCategoryGap: 10,
                    children: [
                        (0, $kSbwP.jsx)((0, $836f11cfcda8d642$export$6440e27b9f186856), {
                            vertical: true,
                            horizontal: false,
                            strokeDasharray: "3 3"
                        }),
                        (0, $kSbwP.jsx)((0, $f4dd95f529f72065$export$ea77231de273b52d), {
                            type: "number",
                            domain: [
                                0,
                                'dataMax'
                            ],
                            allowDataOverflow: true,
                            ticks: [
                                0,
                                25,
                                50,
                                75,
                                100
                            ],
                            tick: {
                                fontSize: 14,
                                fontFamily: 'Hanken Grotesk',
                                fontWeight: 700,
                                fill: '#323B48'
                            },
                            tickFormatter: (value)=>`${value}%`
                        }),
                        (0, $kSbwP.jsx)((0, $0a6c1adc00c46590$export$f96c4024c52de8f4), {
                            dataKey: "sectionId",
                            type: "category",
                            tick: renderCustomAxisTick
                        }),
                        (0, $kSbwP.jsx)((0, $c1ee5960bb8c7c28$export$28c660c63b792dea), {
                            labelFormatter: (value)=>{
                                return data.find((section)=>section.sectionId === value).name;
                            },
                            formatter: (value, name, props)=>`${value}%`
                        }),
                        (0, $kSbwP.jsxs)((0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1), {
                            dataKey: "Score",
                            radius: [
                                0,
                                4,
                                4,
                                0
                            ],
                            maxBarSize: 100,
                            children: [
                                data.map((entry, index)=>(0, $kSbwP.jsx)((0, $94307f62a0d95f57$export$f6f0c3fe4ec306ea), {
                                        fill: entry.sectionId === GEN_SCORE_ID ? '#A29F93' : '#133971'
                                    }, `cell-${index}`)),
                                (0, $kSbwP.jsx)((0, $e476a06be597057a$export$835fcf23ab7bf88), {
                                    dataKey: "Score",
                                    position: "insideRight",
                                    formatter: (v)=>v + '%',
                                    fill: "white",
                                    style: {
                                        fontSize: '14px',
                                        fontFamily: 'Hanken Grotesk',
                                        fontWeight: 400
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");


var $b1ab14b7ed695c47$export$40a9eeef55665a40;
var $b1ab14b7ed695c47$export$93b7586d956c930e;
var $b1ab14b7ed695c47$export$38e42c68cf43b5d4;
var $b1ab14b7ed695c47$export$16e88e5cb1eec977;
var $b1ab14b7ed695c47$export$f843afa9e9b53052;
var $b1ab14b7ed695c47$export$ae78d338ad66ff90;
var $b1ab14b7ed695c47$export$a3a773c2b0a58e0d;
var $b1ab14b7ed695c47$export$b8972b998723d602;
var $b1ab14b7ed695c47$export$13925b5cf10ba292;
var $b1ab14b7ed695c47$export$fb184b623420d9be;
$b1ab14b7ed695c47$export$40a9eeef55665a40 = `USuRvW_defaultPadding`;
$b1ab14b7ed695c47$export$93b7586d956c930e = `USuRvW_dropShadow`;
$b1ab14b7ed695c47$export$38e42c68cf43b5d4 = `USuRvW_header`;
$b1ab14b7ed695c47$export$16e88e5cb1eec977 = `USuRvW_metadataContainer`;
$b1ab14b7ed695c47$export$f843afa9e9b53052 = `USuRvW_panelImage`;
$b1ab14b7ed695c47$export$ae78d338ad66ff90 = `USuRvW_scaleInOut`;
$b1ab14b7ed695c47$export$a3a773c2b0a58e0d = `USuRvW_seperatorFields`;
$b1ab14b7ed695c47$export$b8972b998723d602 = `USuRvW_shadow`;
$b1ab14b7ed695c47$export$13925b5cf10ba292 = `USuRvW_small-shadow`;
$b1ab14b7ed695c47$export$fb184b623420d9be = `USuRvW_title`;




var $kSbwP = parcelRequire("kSbwP");

var $85f5da2e80edabb8$export$34e0f9847d4c02dd;
var $85f5da2e80edabb8$export$fb184b623420d9be;
var $85f5da2e80edabb8$export$2ab9a8f9f1186f14;
$85f5da2e80edabb8$export$34e0f9847d4c02dd = `pezUqG_container`;
$85f5da2e80edabb8$export$fb184b623420d9be = `pezUqG_title`;
$85f5da2e80edabb8$export$2ab9a8f9f1186f14 = `pezUqG_value`;



const $ccf4ab5e114879a2$export$9c5e83992d724a63 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        alignItems: "start",
        className: $85f5da2e80edabb8$export$34e0f9847d4c02dd,
        children: [
            (0, $kSbwP.jsxs)("div", {
                className: $85f5da2e80edabb8$export$fb184b623420d9be,
                children: [
                    " ",
                    p.label,
                    " "
                ]
            }),
            (0, $kSbwP.jsx)("div", {
                className: $85f5da2e80edabb8$export$2ab9a8f9f1186f14,
                children: p.value
            })
        ]
    });
});


const $f20b217cc7daff5d$export$f20f69a59ceebf9d = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = store.query;
    if (!query) return null;
    const error = store.errorMessageTicker;
    const metaFields = [
        {
            label: 'Founded:',
            value: query.value('year_founded')
        },
        {
            label: 'CEO',
            value: query.value('company_ceo')
        },
        {
            label: 'HQ',
            value: query.value('hq_location')
        },
        {
            label: 'Industry',
            value: query.value('industry')
        },
        {
            label: 'Sub-industry',
            value: query.value('industrySubType')
        }
    ];
    const values = [];
    metaFields.forEach((field, index)=>{
        values.push((0, $kSbwP.jsx)((0, $ccf4ab5e114879a2$export$9c5e83992d724a63), {
            label: field.label,
            value: field.value
        }, field.label));
        if (index < metaFields.length - 1) values.push((0, $kSbwP.jsx)("div", {
            className: $b1ab14b7ed695c47$export$a3a773c2b0a58e0d,
            children: (0, $kSbwP.jsx)("i", {
                className: "bi bi-dot"
            })
        }, 'sep_' + field.label));
    });
    return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        className: $b1ab14b7ed695c47$export$38e42c68cf43b5d4,
        children: (0, $kSbwP.jsx)("div", {
            className: $b1ab14b7ed695c47$export$16e88e5cb1eec977,
            children: values
        })
    });
});





var $kSbwP = parcelRequire("kSbwP");



var $8nGP5 = parcelRequire("8nGP5");
/**
 * @fileOverview Composed Chart
 */ 

var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");














var $1b8fe288515e608e$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
], $1b8fe288515e608e$var$_excluded2 = [
    "key"
];
var $1b8fe288515e608e$var$_Area;
function $1b8fe288515e608e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1b8fe288515e608e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1b8fe288515e608e$var$_typeof(o);
}
function $1b8fe288515e608e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1b8fe288515e608e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1b8fe288515e608e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1b8fe288515e608e$var$_extends() {
    $1b8fe288515e608e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1b8fe288515e608e$var$_extends.apply(this, arguments);
}
function $1b8fe288515e608e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b8fe288515e608e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b8fe288515e608e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1b8fe288515e608e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b8fe288515e608e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1b8fe288515e608e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1b8fe288515e608e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1b8fe288515e608e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1b8fe288515e608e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1b8fe288515e608e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1b8fe288515e608e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1b8fe288515e608e$var$_callSuper(t, o, e) {
    return o = $1b8fe288515e608e$var$_getPrototypeOf(o), $1b8fe288515e608e$var$_possibleConstructorReturn(t, $1b8fe288515e608e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $1b8fe288515e608e$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $1b8fe288515e608e$var$_possibleConstructorReturn(self, call) {
    if (call && ($1b8fe288515e608e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1b8fe288515e608e$var$_assertThisInitialized(self);
}
function $1b8fe288515e608e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1b8fe288515e608e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1b8fe288515e608e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1b8fe288515e608e$var$_getPrototypeOf(o) {
    $1b8fe288515e608e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1b8fe288515e608e$var$_getPrototypeOf(o);
}
function $1b8fe288515e608e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1b8fe288515e608e$var$_setPrototypeOf(subClass, superClass);
}
function $1b8fe288515e608e$var$_setPrototypeOf(o, p) {
    $1b8fe288515e608e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1b8fe288515e608e$var$_setPrototypeOf(o, p);
}
function $1b8fe288515e608e$var$_defineProperty(obj, key, value) {
    key = $1b8fe288515e608e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1b8fe288515e608e$var$_toPropertyKey(t) {
    var i = $1b8fe288515e608e$var$_toPrimitive(t, "string");
    return "symbol" == $1b8fe288515e608e$var$_typeof(i) ? i : i + "";
}
function $1b8fe288515e608e$var$_toPrimitive(t, r) {
    if ("object" != $1b8fe288515e608e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1b8fe288515e608e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1b8fe288515e608e$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    function Area() {
        var _this;
        $1b8fe288515e608e$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $1b8fe288515e608e$var$_callSuper(this, Area, [].concat(args));
        $1b8fe288515e608e$var$_defineProperty(_this, "state", {
            isAnimationFinished: true
        });
        $1b8fe288515e608e$var$_defineProperty(_this, "id", (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts-area-'));
        $1b8fe288515e608e$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $1b8fe288515e608e$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $1b8fe288515e608e$var$_inherits(Area, _PureComponent);
    return $1b8fe288515e608e$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $1b8fe288515e608e$var$_objectSpread($1b8fe288515e608e$var$_objectSpread($1b8fe288515e608e$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        dataKey: dataKey,
                        value: entry.value,
                        payload: entry.payload,
                        points: points
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $1b8fe288515e608e$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxY = Math.max(baseLine, maxY);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxX = Math.max(baseLine, maxX);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === 'vertical') return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $1b8fe288515e608e$var$_objectWithoutProperties(_this$props4, $1b8fe288515e608e$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1371972ac018f8f3$export$b0e83c3ef8d2db1), $1b8fe288515e608e$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== 'none' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1371972ac018f8f3$export$b0e83c3ef8d2db1), $1b8fe288515e608e$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== 'none' && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1371972ac018f8f3$export$b0e83c3ef8d2db1), $1b8fe288515e608e$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $32fd8300d9e7a1d4$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $1b8fe288515e608e$var$_objectSpread($1b8fe288515e608e$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') {
                            var interpolator = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(baseLine)) {
                            var _interpolator = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $1b8fe288515e608e$var$_objectSpread($1b8fe288515e608e$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $ajIhI.default)('recharts-area', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $8b99c43c69c5c37b$export$392f6c9701718a4e)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $e476a06be597057a$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$1b8fe288515e608e$var$_Area = $1b8fe288515e608e$export$ea1a111407f37557;
$1b8fe288515e608e$var$_defineProperty($1b8fe288515e608e$export$ea1a111407f37557, "displayName", 'Area');
$1b8fe288515e608e$var$_defineProperty($1b8fe288515e608e$export$ea1a111407f37557, "defaultProps", {
    stroke: '#3182bd',
    fill: '#3182bd',
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'line',
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
});
$1b8fe288515e608e$var$_defineProperty($1b8fe288515e608e$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseValue) && typeof baseValue === 'number') return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return domainMin;
        if (baseValue === 'dataMax') return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
});
$1b8fe288515e608e$var$_defineProperty($1b8fe288515e608e$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $1b8fe288515e608e$var$_Area.getBaseValue(props, item, xAxis, yAxis);
    var isHorizontalLayout = layout === 'horizontal';
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = value[1] == null || hasStack && (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, dataKey) == null;
        if (isHorizontalLayout) return {
            x: (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) return {
            x: entry.x,
            y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
        return {
            x: x != null ? xAxis.scale(x) : null,
            y: entry.y
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
    return $1b8fe288515e608e$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$1b8fe288515e608e$var$_defineProperty($1b8fe288515e608e$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) dotItem = option(props);
    else {
        var className = (0, $ajIhI.default)('recharts-area-dot', typeof option !== 'boolean' ? option.className : '');
        var key = props.key, rest = $1b8fe288515e608e$var$_objectWithoutProperties(props, $1b8fe288515e608e$var$_excluded2);
        dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $5c4d5cf43eecf2f0$export$d046b3c4a416f60d), $1b8fe288515e608e$var$_extends({}, rest, {
            key: key,
            className: className
        }));
    }
    return dotItem;
});





var $8nGP5 = parcelRequire("8nGP5");





var $ajIhI = parcelRequire("ajIhI");





var $8nGP5 = parcelRequire("8nGP5");
function $01500a896f6ae02c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $01500a896f6ae02c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $01500a896f6ae02c$var$_typeof(o);
}
function $01500a896f6ae02c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $01500a896f6ae02c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $01500a896f6ae02c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $01500a896f6ae02c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $01500a896f6ae02c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $01500a896f6ae02c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $01500a896f6ae02c$var$_callSuper(t, o, e) {
    return o = $01500a896f6ae02c$var$_getPrototypeOf(o), $01500a896f6ae02c$var$_possibleConstructorReturn(t, $01500a896f6ae02c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $01500a896f6ae02c$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $01500a896f6ae02c$var$_possibleConstructorReturn(self, call) {
    if (call && ($01500a896f6ae02c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $01500a896f6ae02c$var$_assertThisInitialized(self);
}
function $01500a896f6ae02c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $01500a896f6ae02c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($01500a896f6ae02c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $01500a896f6ae02c$var$_getPrototypeOf(o) {
    $01500a896f6ae02c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $01500a896f6ae02c$var$_getPrototypeOf(o);
}
function $01500a896f6ae02c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $01500a896f6ae02c$var$_setPrototypeOf(subClass, superClass);
}
function $01500a896f6ae02c$var$_setPrototypeOf(o, p) {
    $01500a896f6ae02c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $01500a896f6ae02c$var$_setPrototypeOf(o, p);
}
function $01500a896f6ae02c$var$_defineProperty(obj, key, value) {
    key = $01500a896f6ae02c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $01500a896f6ae02c$var$_toPropertyKey(t) {
    var i = $01500a896f6ae02c$var$_toPrimitive(t, "string");
    return "symbol" == $01500a896f6ae02c$var$_typeof(i) ? i : i + "";
}
function $01500a896f6ae02c$var$_toPrimitive(t, r) {
    if ("object" != $01500a896f6ae02c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $01500a896f6ae02c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $01500a896f6ae02c$export$2363a7fa7edfe988 = /*#__PURE__*/ function(_React$Component) {
    function ZAxis() {
        $01500a896f6ae02c$var$_classCallCheck(this, ZAxis);
        return $01500a896f6ae02c$var$_callSuper(this, ZAxis, arguments);
    }
    $01500a896f6ae02c$var$_inherits(ZAxis, _React$Component);
    return $01500a896f6ae02c$var$_createClass(ZAxis, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$01500a896f6ae02c$var$_defineProperty($01500a896f6ae02c$export$2363a7fa7edfe988, "displayName", 'ZAxis');
$01500a896f6ae02c$var$_defineProperty($01500a896f6ae02c$export$2363a7fa7edfe988, "defaultProps", {
    zAxisId: 0,
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number'
});









var $8nGP5 = parcelRequire("8nGP5");


var $ae3fae625d10f6ae$var$_excluded = [
    "option",
    "isActive"
];
function $ae3fae625d10f6ae$var$_extends() {
    $ae3fae625d10f6ae$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ae3fae625d10f6ae$var$_extends.apply(this, arguments);
}
function $ae3fae625d10f6ae$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ae3fae625d10f6ae$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ae3fae625d10f6ae$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ae3fae625d10f6ae$export$569fa72fa47640a8(_ref) {
    var option = _ref.option, isActive = _ref.isActive, props = $ae3fae625d10f6ae$var$_objectWithoutProperties(_ref, $ae3fae625d10f6ae$var$_excluded);
    if (typeof option === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2be7c72ce33b6679$export$6428a7f2611ef1fa), $ae3fae625d10f6ae$var$_extends({
        option: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1a06a1b516e783f8$export$fa456266707bf4e4), $ae3fae625d10f6ae$var$_extends({
            type: option
        }, props)),
        isActive: isActive,
        shapeType: "symbols"
    }, props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2be7c72ce33b6679$export$6428a7f2611ef1fa), $ae3fae625d10f6ae$var$_extends({
        option: option,
        isActive: isActive,
        shapeType: "symbols"
    }, props));
}


var $4fc838ae16b87d1b$var$_Scatter;
function $4fc838ae16b87d1b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4fc838ae16b87d1b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4fc838ae16b87d1b$var$_typeof(o);
}
function $4fc838ae16b87d1b$var$_extends() {
    $4fc838ae16b87d1b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4fc838ae16b87d1b$var$_extends.apply(this, arguments);
}
function $4fc838ae16b87d1b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4fc838ae16b87d1b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4fc838ae16b87d1b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4fc838ae16b87d1b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4fc838ae16b87d1b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4fc838ae16b87d1b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4fc838ae16b87d1b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4fc838ae16b87d1b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4fc838ae16b87d1b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc838ae16b87d1b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc838ae16b87d1b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4fc838ae16b87d1b$var$_callSuper(t, o, e) {
    return o = $4fc838ae16b87d1b$var$_getPrototypeOf(o), $4fc838ae16b87d1b$var$_possibleConstructorReturn(t, $4fc838ae16b87d1b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $4fc838ae16b87d1b$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $4fc838ae16b87d1b$var$_possibleConstructorReturn(self, call) {
    if (call && ($4fc838ae16b87d1b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4fc838ae16b87d1b$var$_assertThisInitialized(self);
}
function $4fc838ae16b87d1b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4fc838ae16b87d1b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4fc838ae16b87d1b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $4fc838ae16b87d1b$var$_getPrototypeOf(o) {
    $4fc838ae16b87d1b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4fc838ae16b87d1b$var$_getPrototypeOf(o);
}
function $4fc838ae16b87d1b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4fc838ae16b87d1b$var$_setPrototypeOf(subClass, superClass);
}
function $4fc838ae16b87d1b$var$_setPrototypeOf(o, p) {
    $4fc838ae16b87d1b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4fc838ae16b87d1b$var$_setPrototypeOf(o, p);
}
function $4fc838ae16b87d1b$var$_defineProperty(obj, key, value) {
    key = $4fc838ae16b87d1b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4fc838ae16b87d1b$var$_toPropertyKey(t) {
    var i = $4fc838ae16b87d1b$var$_toPrimitive(t, "string");
    return "symbol" == $4fc838ae16b87d1b$var$_typeof(i) ? i : i + "";
}
function $4fc838ae16b87d1b$var$_toPrimitive(t, r) {
    if ("object" != $4fc838ae16b87d1b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4fc838ae16b87d1b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4fc838ae16b87d1b$export$1c460fb4285edadc = /*#__PURE__*/ function(_PureComponent) {
    function Scatter() {
        var _this;
        $4fc838ae16b87d1b$var$_classCallCheck(this, Scatter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $4fc838ae16b87d1b$var$_callSuper(this, Scatter, [].concat(args));
        $4fc838ae16b87d1b$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $4fc838ae16b87d1b$var$_defineProperty(_this, "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
        });
        $4fc838ae16b87d1b$var$_defineProperty(_this, "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
        });
        $4fc838ae16b87d1b$var$_defineProperty(_this, "id", (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts-scatter-'));
        return _this;
    }
    $4fc838ae16b87d1b$var$_inherits(Scatter, _PureComponent);
    return $4fc838ae16b87d1b$var$_createClass(Scatter, [
        {
            key: "renderSymbolsStatically",
            value: function renderSymbolsStatically(points) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, activeShape = _this$props.activeShape, activeIndex = _this$props.activeIndex;
                var baseProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                return points.map(function(entry, i) {
                    var isActive = activeIndex === i;
                    var option = isActive ? activeShape : shape;
                    var props = $4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread({}, baseProps), entry);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $4fc838ae16b87d1b$var$_extends({
                        className: "recharts-scatter-symbol",
                        key: "symbol-".concat(entry === null || entry === void 0 ? void 0 : entry.cx, "-").concat(entry === null || entry === void 0 ? void 0 : entry.cy, "-").concat(entry === null || entry === void 0 ? void 0 : entry.size, "-").concat(i)
                    }, (0, $f1d44a0cc6cff721$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        role: "img"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ae3fae625d10f6ae$export$569fa72fa47640a8), $4fc838ae16b87d1b$var$_extends({
                        option: option,
                        isActive: isActive,
                        key: "symbol-".concat(i)
                    }, props)));
                });
            }
        },
        {
            key: "renderSymbolsWithAnimation",
            value: function renderSymbolsWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, points = _this$props2.points, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevPoints = this.state.prevPoints;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $32fd8300d9e7a1d4$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = points.map(function(entry, index) {
                        var prev = prevPoints && prevPoints[index];
                        if (prev) {
                            var interpolatorCx = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.cx, entry.cx);
                            var interpolatorCy = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.cy, entry.cy);
                            var interpolatorSize = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.size, entry.size);
                            return $4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread({}, entry), {}, {
                                cx: interpolatorCx(t),
                                cy: interpolatorCy(t),
                                size: interpolatorSize(t)
                            });
                        }
                        var interpolator = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(0, entry.size);
                        return $4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread({}, entry), {}, {
                            size: interpolator(t)
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), null, _this3.renderSymbolsStatically(stepData));
                });
            }
        },
        {
            key: "renderSymbols",
            value: function renderSymbols() {
                var _this$props3 = this.props, points = _this$props3.points, isAnimationActive = _this$props3.isAnimationActive;
                var prevPoints = this.state.prevPoints;
                if (isAnimationActive && points && points.length && (!prevPoints || !(0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(prevPoints, points))) return this.renderSymbolsWithAnimation();
                return this.renderSymbolsStatically(points);
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar() {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props4 = this.props, points = _this$props4.points, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, children = _this$props4.children;
                var errorBarItems = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $d0e02a4abf979d13$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                return errorBarItems.map(function(item, i) {
                    var _item$props = item.props, direction = _item$props.direction, errorDataKey = _item$props.dataKey;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(item, {
                        key: "".concat(direction, "-").concat(errorDataKey, "-").concat(points[i]),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: direction === 'x' ? 'vertical' : 'horizontal',
                        dataPointFormatter: function dataPointFormatter(dataPoint, dataKey) {
                            return {
                                x: dataPoint.cx,
                                y: dataPoint.cy,
                                value: direction === 'x' ? +dataPoint.node.x : +dataPoint.node.y,
                                errorVal: (0, $cc31aced37ecb634$export$f97fc4a450f29a)(dataPoint, dataKey)
                            };
                        }
                    });
                });
            }
        },
        {
            key: "renderLine",
            value: function renderLine() {
                var _this$props5 = this.props, points = _this$props5.points, line = _this$props5.line, lineType = _this$props5.lineType, lineJointType = _this$props5.lineJointType;
                var scatterProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                var customLineProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(line, false);
                var linePoints, lineItem;
                if (lineType === 'joint') linePoints = points.map(function(entry) {
                    return {
                        x: entry.cx,
                        y: entry.cy
                    };
                });
                else if (lineType === 'fitting') {
                    var _getLinearRegression = (0, $3d08f6c3b4eab1e3$export$484982720961754e)(points), xmin = _getLinearRegression.xmin, xmax = _getLinearRegression.xmax, a = _getLinearRegression.a, b = _getLinearRegression.b;
                    var linearExp = function linearExp(x) {
                        return a * x + b;
                    };
                    linePoints = [
                        {
                            x: xmin,
                            y: linearExp(xmin)
                        },
                        {
                            x: xmax,
                            y: linearExp(xmax)
                        }
                    ];
                }
                var lineProps = $4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread({}, scatterProps), {}, {
                    fill: 'none',
                    stroke: scatterProps && scatterProps.fill
                }, customLineProps), {}, {
                    points: linePoints
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(line)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(line, lineProps);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(line)) lineItem = line(lineProps);
                else lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1371972ac018f8f3$export$b0e83c3ef8d2db1), $4fc838ae16b87d1b$var$_extends({}, lineProps, {
                    type: lineJointType
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: "recharts-scatter-line",
                    key: "recharts-scatter-line"
                }, lineItem);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, points = _this$props6.points, line = _this$props6.line, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, id = _this$props6.id, isAnimationActive = _this$props6.isAnimationActive;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $ajIhI.default)('recharts-scatter', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: layerClass,
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    key: "recharts-scatter-symbols"
                }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && (0, $e476a06be597057a$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$4fc838ae16b87d1b$var$_Scatter = $4fc838ae16b87d1b$export$1c460fb4285edadc;
$4fc838ae16b87d1b$var$_defineProperty($4fc838ae16b87d1b$export$1c460fb4285edadc, "displayName", 'Scatter');
$4fc838ae16b87d1b$var$_defineProperty($4fc838ae16b87d1b$export$1c460fb4285edadc, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    zAxisId: 0,
    legendType: 'circle',
    lineType: 'joint',
    lineJointType: 'linear',
    data: [],
    shape: 'circle',
    hide: false,
    isAnimationActive: !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'linear'
});
/**
 * Compose the data of each group
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $4fc838ae16b87d1b$var$_defineProperty($4fc838ae16b87d1b$export$1c460fb4285edadc, "getComposedData", function(_ref2) {
    var xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, zAxis = _ref2.zAxis, item = _ref2.item, displayedData = _ref2.displayedData, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, offset = _ref2.offset;
    var tooltipType = item.props.tooltipType;
    var cells = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(item.props.children, (0, $94307f62a0d95f57$export$f6f0c3fe4ec306ea));
    var xAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
    var yAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
    var zAxisDataKey = zAxis && zAxis.dataKey;
    var defaultRangeZ = zAxis ? zAxis.range : (0, $01500a896f6ae02c$export$2363a7fa7edfe988).defaultProps.range;
    var defaultZ = defaultRangeZ && defaultRangeZ[0];
    var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
    var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
    var points = displayedData.map(function(entry, index) {
        var x = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, xAxisDataKey);
        var y = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, yAxisDataKey);
        var z = !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(zAxisDataKey) && (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, zAxisDataKey) || '-';
        var tooltipPayload = [
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
                unit: xAxis.unit || '',
                value: x,
                payload: entry,
                dataKey: xAxisDataKey,
                type: tooltipType
            },
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
                unit: yAxis.unit || '',
                value: y,
                payload: entry,
                dataKey: yAxisDataKey,
                type: tooltipType
            }
        ];
        if (z !== '-') tooltipPayload.push({
            name: zAxis.name || zAxis.dataKey,
            unit: zAxis.unit || '',
            value: z,
            payload: entry,
            dataKey: zAxisDataKey,
            type: tooltipType
        });
        var cx = (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
            axis: xAxis,
            ticks: xAxisTicks,
            bandSize: xBandSize,
            entry: entry,
            index: index,
            dataKey: xAxisDataKey
        });
        var cy = (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: yBandSize,
            entry: entry,
            index: index,
            dataKey: yAxisDataKey
        });
        var size = z !== '-' ? zAxis.scale(z) : defaultZ;
        var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
        return $4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread({}, entry), {}, {
            cx: cx,
            cy: cy,
            x: cx - radius,
            y: cy - radius,
            xAxis: xAxis,
            yAxis: yAxis,
            zAxis: zAxis,
            width: 2 * radius,
            height: 2 * radius,
            size: size,
            node: {
                x: x,
                y: y,
                z: z
            },
            tooltipPayload: tooltipPayload,
            tooltipPosition: {
                x: cx,
                y: cy
            },
            payload: entry
        }, cells && cells[index] && cells[index].props);
    });
    return $4fc838ae16b87d1b$var$_objectSpread({
        points: points
    }, offset);
});






var $ccba25d6b178ab5a$export$f881f4f9e4007a57 = (0, $3cb8ecafb87115bc$export$77871aede60e6838)({
    chartName: 'ComposedChart',
    GraphicalChild: [
        (0, $a0158cc2cd24124f$export$17d680238e50603e),
        (0, $1b8fe288515e608e$export$ea1a111407f37557),
        (0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1),
        (0, $4fc838ae16b87d1b$export$1c460fb4285edadc)
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $f4dd95f529f72065$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $0a6c1adc00c46590$export$f96c4024c52de8f4)
        },
        {
            axisType: 'zAxis',
            AxisComp: (0, $01500a896f6ae02c$export$2363a7fa7edfe988)
        }
    ],
    formatAxisMap: (0, $b57066fd5661be22$export$ece7de1383db5ac)
});





var $T5IcR = parcelRequire("T5IcR");

var $kSbwP = parcelRequire("kSbwP");


var $fgQ0V = parcelRequire("fgQ0V");
class $36ec24632073ba4a$export$41830d6935700b58 {
    //243a5c  657e96
    static genColorGradientHorizontal(id, colors) {
        return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
            children: (0, $kSbwP.jsxs)("linearGradient", {
                id: id,
                x1: "0",
                y1: "0",
                x2: "1",
                y2: "1",
                children: [
                    (0, $kSbwP.jsx)("stop", {
                        offset: "0%",
                        stopColor: colors[0],
                        stopOpacity: 1
                    }),
                    (0, $kSbwP.jsx)("stop", {
                        offset: "30%",
                        stopColor: colors[0],
                        stopOpacity: 1
                    }),
                    (0, $kSbwP.jsx)("stop", {
                        offset: "100%",
                        stopColor: colors[1],
                        stopOpacity: 1
                    })
                ]
            })
        });
    }
}
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "SHADOW_FILTER", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'drop-shadow(3px 1px 4px rgba(0, 0, 0, 0.5))'
});
//    static GOLD_COLOR = ['#bfae5a', '#d9c666'];
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "GOLD_COLOR", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [
        '#bfae5a',
        '#b8a858'
    ]
});
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "BLUE_COLOR", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [
        '#243a5c',
        '#657e96'
    ]
});
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "getBarGradient", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: ()=>{
        return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
            children: [
                $36ec24632073ba4a$export$41830d6935700b58.genColorGradientHorizontal('barGradientBlue', $36ec24632073ba4a$export$41830d6935700b58.BLUE_COLOR),
                $36ec24632073ba4a$export$41830d6935700b58.genColorGradientHorizontal('barGradientGold', $36ec24632073ba4a$export$41830d6935700b58.GOLD_COLOR)
            ]
        });
    }
});
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "formatCurrency", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (v)=>{
        if ((0, $fgQ0V.isString)(v)) v = (0, $7fbd760f3c05e83d$export$c0080068ec287465)(v);
        if (v == 0 || isNaN(v)) return 'N/A';
        return '$' + v.toFixed(0);
    }
});
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "formatPercent", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (v)=>{
        if (v == 0 || isNaN(v)) return 'N/A';
        return v.toFixed(0) + '%';
    }
});





var $99f5eb6d5fa6a0d1$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $99f5eb6d5fa6a0d1$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $99f5eb6d5fa6a0d1$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $99f5eb6d5fa6a0d1$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $99f5eb6d5fa6a0d1$export$511e1bd5c301e07a = (()=>{
    var _a, _TickInfo_tickSize_accessor_storage;
    let _tickSize_decorators;
    let _tickSize_initializers = [];
    let _tickSize_extraInitializers = [];
    return _a = class TickInfo {
        get tickSize() {
            return $99f5eb6d5fa6a0d1$var$__classPrivateFieldGet(this, _TickInfo_tickSize_accessor_storage, "f");
        }
        set tickSize(value) {
            $99f5eb6d5fa6a0d1$var$__classPrivateFieldSet(this, _TickInfo_tickSize_accessor_storage, value, "f");
        }
        constructor(){
            _TickInfo_tickSize_accessor_storage.set(this, $99f5eb6d5fa6a0d1$var$__runInitializers(this, _tickSize_initializers, 0));
            $99f5eb6d5fa6a0d1$var$__runInitializers(this, _tickSize_extraInitializers);
        }
    }, _TickInfo_tickSize_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _tickSize_decorators = [
            (0, $T5IcR.observable)
        ];
        $99f5eb6d5fa6a0d1$var$__esDecorate(_a, null, _tickSize_decorators, {
            kind: "accessor",
            name: "tickSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"tickSize" in obj,
                get: (obj)=>obj.tickSize,
                set: (obj, value)=>{
                    obj.tickSize = value;
                }
            },
            metadata: _metadata
        }, _tickSize_initializers, _tickSize_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $99f5eb6d5fa6a0d1$export$8c1b2de0367e9a6e = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    var _a;
    const [ref, bounds] = (0, $7e7ca35815405df8$export$2e2bcd8739ae039)();
    const tickInfo = (0, $8nGP5.useRef)({
        firstTick: 0,
        secondTick: 0
    });
    const [tickStore] = (0, $8nGP5.useState)(new $99f5eb6d5fa6a0d1$export$511e1bd5c301e07a());
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const q = store.createDataAccess(p.reportId);
    const prefEbitdaType = q === null || q === void 0 ? void 0 : q.selectedEbitdaType;
    var schemaLookupName = 'Adjusted EBITDA';
    (_a = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[prefEbitdaType]['display']) !== null && _a !== void 0 && _a;
    const NAME_LOOKUP = {
        adj_ebitda_margin: `${schemaLookupName} Margin`,
        EBITDA: schemaLookupName,
        Revenue: 'Revenue'
    };
    if (q == null) return null;
    var data = [];
    var { from: from, to: to } = q.getReportYearRange();
    const maxYears = 11;
    if (to - from > maxYears) from = to - maxYears;
    const ebitdaType = q.selectedEbitdaType;
    for(var year = from; year <= to; year++){
        var yearEntry = {};
        const isActualized = q.getIsYearActualized(year);
        const letter = isActualized ? 'A' : 'P';
        yearEntry['year'] = year + letter;
        yearEntry['Revenue'] = q.valueByYear('net_revenue_per_year', year);
        if (yearEntry['Revenue'] == 'N/A') yearEntry['Revenue'] = 0;
        else yearEntry['Revenue'] = parseFloat(yearEntry['Revenue']);
        yearEntry['EBITDA'] = q.valueByYear(prefEbitdaType, year);
        if (yearEntry['EBITDA'] == 'N/A') {
            var ebitda = q.valueByYear('ebitda_per_year', year);
            if (ebitda != 'N/A') yearEntry['EBITDA'] = ebitda;
            else yearEntry['EBITDA'] = 0;
        } else yearEntry['EBITDA'] = parseFloat(yearEntry['EBITDA']);
        yearEntry['adj_ebitda_margin'] = q.selectedEbitdaMargin(year);
        if (yearEntry['adj_ebitda_margin'] == 'N/A') {
            var ebitdaMargin = q.ebitdaMargin(year);
            if (ebitdaMargin != 'N/A') yearEntry['adj_ebitda_margin'] = ebitdaMargin;
        }
        if (yearEntry['adj_ebitda_margin'] != 'N/A') yearEntry['adj_ebitda_margin'] *= 100;
        data.push(yearEntry);
    }
    const CustomYearLabelsTick = (params)=>{
        if (params.index === 0) tickInfo.current.firstTick = params.x;
        else if (params.index === 1) {
            tickInfo.current.secondTick = params.x;
            const diff = tickInfo.current.secondTick - tickInfo.current.firstTick;
            tickStore.tickSize = diff;
        }
        const { x: x, y: y, payload: payload } = params;
        const bandWidth = tickStore.tickSize;
        return (0, $kSbwP.jsx)("text", {
            x: x + bandWidth / 2,
            y: y + 14,
            fontSize: "14",
            fontFamily: "Hanken Grotesk",
            fontWeight: "700",
            fill: "#323B48",
            textAnchor: "middle",
            children: payload.value
        });
    };
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)("div", {
                ref: ref,
                style: {
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    visibility: 'hidden'
                }
            }),
            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "column",
                fillCell: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($4be1ee3c8ca80a36$export$fb184b623420d9be, $4be1ee3c8ca80a36$export$d866e82dddc7abe3),
                        children: "Financial Overview"
                    }),
                    (0, $kSbwP.jsx)((0, $65a9db7fe004392a$export$e60a4704009a0009), {
                        id: "revenue-chart",
                        width: "100%",
                        height: bounds.height - 100,
                        onResize: ()=>{
                            tickInfo.current = {
                                firstTick: 0,
                                secondTick: 0
                            };
                            tickStore.tickSize = 0;
                        },
                        children: (0, $kSbwP.jsxs)((0, $ccba25d6b178ab5a$export$f881f4f9e4007a57), {
                            data: data,
                            margin: {
                                top: 40,
                                left: 20,
                                right: 20,
                                bottom: 20
                            },
                            children: [
                                (0, $kSbwP.jsx)((0, $836f11cfcda8d642$export$6440e27b9f186856), {
                                    stroke: "#F9FAFB"
                                }),
                                (0, $kSbwP.jsx)((0, $0a6c1adc00c46590$export$f96c4024c52de8f4), {
                                    domain: [
                                        0,
                                        'auto'
                                    ],
                                    yAxisId: "left",
                                    tickFormatter: (value)=>`$${value.toFixed()}M`,
                                    interval: "preserveStartEnd",
                                    tick: {
                                        fontSize: 16,
                                        fontFamily: 'Hanken Grotesk',
                                        fontWeight: 700,
                                        fill: '#323B48'
                                    }
                                }),
                                (0, $kSbwP.jsx)((0, $0a6c1adc00c46590$export$f96c4024c52de8f4), {
                                    yAxisId: "right",
                                    hide: true
                                }),
                                (0, $kSbwP.jsx)((0, $06340f5273236c74$export$ed247974535929c7), {
                                    verticalAlign: "bottom",
                                    formatter: (v)=>{
                                        return NAME_LOOKUP[v];
                                    },
                                    wrapperStyle: {
                                        fontFamily: 'Hanken Grotesk',
                                        fontSize: 12
                                    }
                                }),
                                (0, $kSbwP.jsx)((0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1), {
                                    dataKey: "Revenue",
                                    fill: "#A29F93",
                                    yAxisId: "left",
                                    radius: [
                                        4,
                                        4,
                                        0,
                                        0
                                    ],
                                    children: (0, $kSbwP.jsx)((0, $e476a06be597057a$export$835fcf23ab7bf88), {
                                        dataKey: "Revenue",
                                        position: "top",
                                        formatter: (0, $36ec24632073ba4a$export$41830d6935700b58).formatCurrency,
                                        offset: 5,
                                        fill: "black"
                                    })
                                }),
                                (0, $kSbwP.jsx)((0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1), {
                                    dataKey: "EBITDA",
                                    fill: "#133971",
                                    yAxisId: "left",
                                    radius: [
                                        4,
                                        4,
                                        0,
                                        0
                                    ],
                                    children: (0, $kSbwP.jsx)((0, $e476a06be597057a$export$835fcf23ab7bf88), {
                                        dataKey: "EBITDA",
                                        position: "top",
                                        formatter: (0, $36ec24632073ba4a$export$41830d6935700b58).formatCurrency,
                                        offset: 10,
                                        fill: "black"
                                    })
                                }),
                                (0, $kSbwP.jsx)((0, $a0158cc2cd24124f$export$17d680238e50603e), {
                                    type: "monotone",
                                    dataKey: "adj_ebitda_margin",
                                    stroke: "#A29F93",
                                    yAxisId: "right",
                                    children: (0, $kSbwP.jsx)((0, $e476a06be597057a$export$835fcf23ab7bf88), {
                                        dataKey: "adj_ebitda_margin",
                                        position: "top",
                                        formatter: (0, $36ec24632073ba4a$export$41830d6935700b58).formatPercent,
                                        fill: "black",
                                        offset: 10
                                    })
                                }),
                                (0, $kSbwP.jsx)((0, $c1ee5960bb8c7c28$export$28c660c63b792dea), {
                                    formatter: (v, name, payload)=>{
                                        switch(name){
                                            case 'adj_ebitda_margin':
                                                return [
                                                    (0, $36ec24632073ba4a$export$41830d6935700b58).formatPercent(v),
                                                    NAME_LOOKUP[name]
                                                ];
                                            case 'EBITDA':
                                                return [
                                                    (0, $36ec24632073ba4a$export$41830d6935700b58).formatCurrency(v),
                                                    NAME_LOOKUP[name]
                                                ];
                                            default:
                                                return [
                                                    (0, $36ec24632073ba4a$export$41830d6935700b58).formatCurrency(v),
                                                    NAME_LOOKUP[name]
                                                ];
                                        }
                                    }
                                }),
                                (0, $kSbwP.jsx)((0, $f4dd95f529f72065$export$ea77231de273b52d), {
                                    dataKey: "year",
                                    scale: "band",
                                    interval: "preserveStartEnd",
                                    tick: CustomYearLabelsTick
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
});



var $ee30843c79a5ac9f$export$22bfcd3d1db18b5f;
var $ee30843c79a5ac9f$export$81b027d87c35c7d7;
var $ee30843c79a5ac9f$export$2c2a2abcc3f632c7;
var $ee30843c79a5ac9f$export$2e9d4015cc5122af;
var $ee30843c79a5ac9f$export$c0d9370d587dcb77;
var $ee30843c79a5ac9f$export$981ce638514edf;
var $ee30843c79a5ac9f$export$a43cf604e12f3b17;
var $ee30843c79a5ac9f$export$d0b56ec104a7253e;
var $ee30843c79a5ac9f$export$4a2bd288272bd4d7;
var $ee30843c79a5ac9f$export$b848b6ed1647f90b;
var $ee30843c79a5ac9f$export$9811695268b4512a;
var $ee30843c79a5ac9f$export$77e1a7f08c658c71;
var $ee30843c79a5ac9f$export$6ab6556e37faa800;
var $ee30843c79a5ac9f$export$b0ce9785e3d6acd3;
var $ee30843c79a5ac9f$export$cbd85c6fd71fcbf2;
var $ee30843c79a5ac9f$export$b8c2d43efb3dfbec;
var $ee30843c79a5ac9f$export$a838e282bcfe2bc8;
var $ee30843c79a5ac9f$export$7c6ea5732f94c86b;
var $ee30843c79a5ac9f$export$fb184b623420d9be;
var $ee30843c79a5ac9f$export$4e6f96734dfe12f4;
$ee30843c79a5ac9f$export$22bfcd3d1db18b5f = `BtxznG_box_container`;
$ee30843c79a5ac9f$export$81b027d87c35c7d7 = `BtxznG_box_list_entry`;
$ee30843c79a5ac9f$export$2c2a2abcc3f632c7 = `BtxznG_citationNumber`;
$ee30843c79a5ac9f$export$2e9d4015cc5122af = `BtxznG_dueDiligenceIcon`;
$ee30843c79a5ac9f$export$c0d9370d587dcb77 = `BtxznG_infoIcon`;
$ee30843c79a5ac9f$export$981ce638514edf = `BtxznG_infoIconWrapper`;
$ee30843c79a5ac9f$export$a43cf604e12f3b17 = `BtxznG_minHeight`;
$ee30843c79a5ac9f$export$d0b56ec104a7253e = `BtxznG_noData`;
$ee30843c79a5ac9f$export$4a2bd288272bd4d7 = `BtxznG_panelPaddingLeft`;
$ee30843c79a5ac9f$export$b848b6ed1647f90b = `BtxznG_panelPaddingRight`;
$ee30843c79a5ac9f$export$9811695268b4512a = `BtxznG_sourceItem`;
$ee30843c79a5ac9f$export$77e1a7f08c658c71 = `BtxznG_sourceLink`;
$ee30843c79a5ac9f$export$6ab6556e37faa800 = `BtxznG_sourceNumber`;
$ee30843c79a5ac9f$export$b0ce9785e3d6acd3 = `BtxznG_sourceText`;
$ee30843c79a5ac9f$export$cbd85c6fd71fcbf2 = `BtxznG_sourceTextNoLink`;
$ee30843c79a5ac9f$export$b8c2d43efb3dfbec = `BtxznG_sourcesList`;
$ee30843c79a5ac9f$export$a838e282bcfe2bc8 = `BtxznG_sourcesSection`;
$ee30843c79a5ac9f$export$7c6ea5732f94c86b = `BtxznG_sourcesTitle`;
$ee30843c79a5ac9f$export$fb184b623420d9be = `BtxznG_title`;
$ee30843c79a5ac9f$export$4e6f96734dfe12f4 = `BtxznG_tooltip`;



var $9969ffd600cf868e$exports = {};
$9969ffd600cf868e$exports = new URL("we_like.0a7707e9.svg", import.meta.url).toString();


var $1cc2d21ea6c4e775$exports = {};
$1cc2d21ea6c4e775$exports = new URL("key_risks.daa734dd.svg", import.meta.url).toString();


var $0e7025e7da554178$exports = {};
$0e7025e7da554178$exports = new URL("due_diligence.ad039bf5.svg", import.meta.url).toString();


const $032f62a52fec71db$var$GAP_SIZE = 15;
// Helper function to strip all citations and markdown links from text
const $032f62a52fec71db$var$stripCitationsAndMarkdown = (text)=>{
    if (!text) return text;
    let cleanText = text;
    // Remove superscript citations (¹²³⁴⁵⁶⁷⁸⁹⁰)
    cleanText = cleanText.replace(/[\u00B9\u00B2\u00B3\u2074\u2075\u2076\u2077\u2078\u2079\u2070]+/g, '');
    // Remove bracket citations [1], [2], etc.
    cleanText = cleanText.replace(/\[\d+\]/g, '');
    // Remove markdown links [Text](url) -> Text
    cleanText = cleanText.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
    // Remove standalone "Source" word at the end of sentences or text
    cleanText = cleanText.replace(/\.\s*Source\s*$/gi, '.');
    cleanText = cleanText.replace(/\s+Source\s*$/gi, '');
    return cleanText.trim();
};
const $032f62a52fec71db$export$cf41dafb96c88991 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    var _a;
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const clientStore = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const reportId = store.selectedReportId;
    const compareList = (0, $7403a76d892238e8$export$8b849e0e30783f61).findCompaniesToCompare(reportId, 4);
    const do_we_have_pdf = store.query.report_has_pdf;
    const enableSourcing = clientStore.enableSourcing;
    const showPotentialCustomers = clientStore.showPotentialCustomers;
    const flowise_filled = {
        opportunity: null,
        business_overview: null,
        market_description: null,
        market_size: null,
        core_product_services: null,
        key_customers: null,
        potential_customers: null,
        competitor_segments: null,
        what_we_like: null,
        key_risks: null,
        diligence: null
    };
    var flowise = (_a = store.report_flowise) !== null && _a !== void 0 ? _a : flowise_filled;
    const output_list_generic = (list, num_per_row = 4, className = '', gapSize, createElement, noDataMessage)=>{
        if (!list || list.length === 0) return (0, $kSbwP.jsx)(NoDataElement, {
            message: noDataMessage
        });
        return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
            children: (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                wrap: "wrap",
                style: {
                    width: '100%',
                    gap: `${gapSize}px`,
                    rowGap: `${gapSize}px`,
                    paddingBottom: '20px'
                },
                className: className,
                children: list.map((item, i)=>createElement(item))
            })
        });
    };
    const output_boxes = (list, num_per_row = 4)=>{
        return output_list_generic(list, num_per_row, '', $032f62a52fec71db$var$GAP_SIZE, (e)=>{
            return (0, $kSbwP.jsxs)("div", {
                style: {
                    width: `calc(${100 / num_per_row}% - ${$032f62a52fec71db$var$GAP_SIZE}px)`
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($ee30843c79a5ac9f$export$81b027d87c35c7d7, $ee30843c79a5ac9f$export$22bfcd3d1db18b5f),
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: "title",
                        children: e.title
                    }),
                    e.description
                ]
            }, e.title);
        });
    };
    const output_boxes_with_links = (list, num_per_row = 1, noDataMessage)=>{
        return output_list_generic(list, num_per_row, '', $032f62a52fec71db$var$GAP_SIZE, (e)=>{
            // If sourcing is disabled, strip all markdown and don't show Source button
            if (!enableSourcing) {
                const cleanDescription = $032f62a52fec71db$var$stripCitationsAndMarkdown(e.description);
                return (0, $kSbwP.jsxs)("div", {
                    style: {
                        width: `calc(${100 / num_per_row}% - ${$032f62a52fec71db$var$GAP_SIZE}px)`
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($ee30843c79a5ac9f$export$81b027d87c35c7d7, $ee30843c79a5ac9f$export$22bfcd3d1db18b5f),
                    children: [
                        (0, $kSbwP.jsx)("div", {
                            className: "title",
                            children: e.title
                        }),
                        (0, $kSbwP.jsx)("div", {
                            children: cleanDescription
                        })
                    ]
                }, e.title);
            }
            // Extract link and description text from markdown format [description](url)
            const extractLinkData = (text)=>{
                if (!text) return {
                    cleanText: '',
                    link: null
                };
                const linkMatch = text.match(/\[([^\]]+)\]\(([^\)]+)\)/);
                if (linkMatch) {
                    // Remove the entire markdown link [text](url) from the description
                    const cleanText = text.replace(/\[([^\]]+)\]\(([^\)]+)\)/, '').trim();
                    return {
                        cleanText: cleanText,
                        link: linkMatch[2] // URL inside (...) is the source link
                    };
                }
                return {
                    cleanText: text,
                    link: null
                };
            };
            const { cleanText: cleanText, link: link } = extractLinkData(e.description);
            return (0, $kSbwP.jsxs)("div", {
                style: {
                    width: `calc(${100 / num_per_row}% - ${$032f62a52fec71db$var$GAP_SIZE}px)`
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($ee30843c79a5ac9f$export$81b027d87c35c7d7, $ee30843c79a5ac9f$export$22bfcd3d1db18b5f),
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: "title",
                        children: e.title
                    }),
                    (0, $kSbwP.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '10px'
                        },
                        children: [
                            (0, $kSbwP.jsx)("div", {
                                style: {
                                    flex: 1
                                },
                                children: cleanText
                            }),
                            link && (0, $kSbwP.jsxs)("a", {
                                href: link,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: $ee30843c79a5ac9f$export$77e1a7f08c658c71,
                                title: "View source",
                                children: [
                                    (0, $kSbwP.jsxs)("svg", {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        style: {
                                            marginRight: '4px'
                                        },
                                        children: [
                                            (0, $kSbwP.jsx)("path", {
                                                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                                            }),
                                            (0, $kSbwP.jsx)("polyline", {
                                                points: "15 3 21 3 21 9"
                                            }),
                                            (0, $kSbwP.jsx)("line", {
                                                x1: "10",
                                                y1: "14",
                                                x2: "21",
                                                y2: "3"
                                            })
                                        ]
                                    }),
                                    "Source"
                                ]
                            })
                        ]
                    })
                ]
            }, e.title);
        }, noDataMessage);
    };
    // Helper to render text with inline citations (for list items like What We Like, Key Risks)
    const renderTextWithInlineCitations = (item)=>{
        if (!item.description) return null;
        // If sourcing is disabled, strip citations and render plain text
        if (!enableSourcing) return (0, $kSbwP.jsx)("div", {
            children: $032f62a52fec71db$var$stripCitationsAndMarkdown(item.description)
        });
        // Check if item has sources (new format with citations)
        if (item.sources && Array.isArray(item.sources)) {
            const description = item.description;
            const sources = item.sources;
            // Split text by citation markers and create clickable citations
            const parts = [];
            const citationRegex = /[\u00B9\u00B2\u00B3\u2074\u2075\u2076\u2077\u2078\u2079\u2070]+/g;
            let lastIndex = 0;
            let match;
            while((match = citationRegex.exec(description)) !== null){
                // Add text before citation
                if (match.index > lastIndex) parts.push(description.substring(lastIndex, match.index));
                // Convert superscript back to number
                const superToNum = {
                    '\u00B9': '1',
                    '\u00B2': '2',
                    '\u00B3': '3',
                    '\u2074': '4',
                    '\u2075': '5',
                    '\u2076': '6',
                    '\u2077': '7',
                    '\u2078': '8',
                    '\u2079': '9',
                    '\u2070': '0'
                };
                const numStr = match[0].split('').map((c)=>superToNum[c] || c).join('');
                const sourceId = parseInt(numStr);
                const source = sources.find((s)=>s.id === sourceId);
                // Add clickable citation
                if (source && source.url) parts.push((0, $kSbwP.jsx)("a", {
                    href: source.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: $ee30843c79a5ac9f$export$2c2a2abcc3f632c7,
                    title: source.name,
                    children: match[0]
                }, `citation-${sourceId}-${match.index}`));
                else parts.push((0, $kSbwP.jsx)("span", {
                    className: $ee30843c79a5ac9f$export$2c2a2abcc3f632c7,
                    children: match[0]
                }, `citation-${sourceId}-${match.index}`));
                lastIndex = match.index + match[0].length;
            }
            // Add remaining text
            if (lastIndex < description.length) parts.push(description.substring(lastIndex));
            return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
                children: [
                    (0, $kSbwP.jsx)("div", {
                        children: parts.length > 0 ? parts : description
                    }),
                    sources.length > 0 && (0, $kSbwP.jsxs)("div", {
                        className: $ee30843c79a5ac9f$export$a838e282bcfe2bc8,
                        style: {
                            marginTop: '12px'
                        },
                        children: [
                            (0, $kSbwP.jsx)("div", {
                                className: $ee30843c79a5ac9f$export$7c6ea5732f94c86b,
                                children: "Sources"
                            }),
                            (0, $kSbwP.jsx)("div", {
                                className: $ee30843c79a5ac9f$export$b8c2d43efb3dfbec,
                                children: sources.map((source)=>(0, $kSbwP.jsxs)("div", {
                                        className: $ee30843c79a5ac9f$export$9811695268b4512a,
                                        children: [
                                            (0, $kSbwP.jsx)("span", {
                                                className: $ee30843c79a5ac9f$export$6ab6556e37faa800,
                                                children: toSuperscript(source.id)
                                            }),
                                            source.url ? (0, $kSbwP.jsx)("a", {
                                                href: source.url,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: $ee30843c79a5ac9f$export$b0ce9785e3d6acd3,
                                                children: source.name
                                            }) : (0, $kSbwP.jsx)("span", {
                                                className: $ee30843c79a5ac9f$export$cbd85c6fd71fcbf2,
                                                children: source.name
                                            })
                                        ]
                                    }, source.id))
                            })
                        ]
                    })
                ]
            });
        }
        // Old format - plain text
        return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
            children: item.description
        });
    };
    const output_we_like = (list, iconSrc)=>{
        const num_per_row = 1;
        const gapsize = 5;
        return output_list_generic(list, num_per_row, $ee30843c79a5ac9f$export$22bfcd3d1db18b5f, gapsize, (e)=>{
            return (0, $kSbwP.jsx)("div", {
                style: {
                    width: `calc(${100 / num_per_row}% - ${gapsize}px)`,
                    padding: '5px'
                },
                className: $ee30843c79a5ac9f$export$81b027d87c35c7d7,
                children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "column",
                    children: [
                        (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            style: {
                                gap: `${gapsize}px`
                            },
                            alignItems: "center",
                            children: [
                                (0, $kSbwP.jsx)("img", {
                                    src: iconSrc,
                                    alt: "We Like",
                                    style: {
                                        paddingRight: '10px',
                                        transform: 'translateY(1px)'
                                    }
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    className: "text",
                                    style: {
                                        fontSize: '18px'
                                    },
                                    children: e.title
                                })
                            ]
                        }),
                        (0, $kSbwP.jsx)("div", {
                            className: "text",
                            style: {
                                paddingLeft: '35px'
                            },
                            children: renderTextWithInlineCitations(e)
                        })
                    ]
                })
            }, e.title);
        });
    };
    const parseDiligenceDescription = (text)=>{
        var _a, _b, _c;
        if (!text) return null;
        const detailedMatch = text.match(/\*\*\[DETAILED\]\*\*(.*?)(?=\*\*\[|$)/s);
        const relevanceMatch = text.match(/\*\*\[RELEVANCE\]\*\*(.*?)(?=\*\*\[|$)/s);
        const believesMatch = text.match(/\*\*\[BELIEVES\]\*\*(.*?)(?=\*\*\[|$)/s);
        return {
            detailed: ((_a = detailedMatch === null || detailedMatch === void 0 ? void 0 : detailedMatch[1]) === null || _a === void 0 ? void 0 : _a.trim()) || '',
            relevance: ((_b = relevanceMatch === null || relevanceMatch === void 0 ? void 0 : relevanceMatch[1]) === null || _b === void 0 ? void 0 : _b.trim()) || '',
            believes: ((_c = believesMatch === null || believesMatch === void 0 ? void 0 : believesMatch[1]) === null || _c === void 0 ? void 0 : _c.trim()) || ''
        };
    };
    const output_due_diligence = (list)=>{
        const num_per_row = 2;
        return output_list_generic(list, num_per_row, '', $032f62a52fec71db$var$GAP_SIZE, (e)=>{
            const sections = parseDiligenceDescription(e.description);
            // If no sections found, fallback to original rendering
            if (!sections || !sections.detailed && !sections.relevance && !sections.believes) return (0, $kSbwP.jsx)("div", {
                style: {
                    width: `calc(${100 / num_per_row}% - 10px)`,
                    padding: '20px'
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($ee30843c79a5ac9f$export$81b027d87c35c7d7, $ee30843c79a5ac9f$export$22bfcd3d1db18b5f),
                children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    style: {
                        gap: '20px'
                    },
                    alignItems: "center",
                    children: [
                        (0, $kSbwP.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0e7025e7da554178$exports))),
                            alt: "Due Diligence",
                            className: $ee30843c79a5ac9f$export$2e9d4015cc5122af
                        }),
                        (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            direction: "column",
                            children: [
                                (0, $kSbwP.jsx)("div", {
                                    className: "title",
                                    children: e.title
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    className: "text",
                                    children: e.description
                                })
                            ]
                        })
                    ]
                })
            }, e.title);
            // New structured rendering with sections
            return (0, $kSbwP.jsx)("div", {
                style: {
                    width: `calc(${100 / num_per_row}% - 10px)`,
                    padding: '20px'
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($ee30843c79a5ac9f$export$81b027d87c35c7d7, $ee30843c79a5ac9f$export$22bfcd3d1db18b5f),
                children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    style: {
                        gap: '15px'
                    },
                    alignItems: "flex-start",
                    children: [
                        (0, $kSbwP.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0e7025e7da554178$exports))),
                            alt: "Due Diligence",
                            className: $ee30843c79a5ac9f$export$2e9d4015cc5122af,
                            style: {
                                marginTop: '2px'
                            }
                        }),
                        (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            direction: "column",
                            style: {
                                flex: 1,
                                gap: '12px'
                            },
                            children: [
                                (0, $kSbwP.jsx)("div", {
                                    className: "title",
                                    children: e.title
                                }),
                                sections.believes && (0, $kSbwP.jsxs)("div", {
                                    children: [
                                        (0, $kSbwP.jsx)("div", {
                                            style: {
                                                fontWeight: 600,
                                                marginBottom: '4px',
                                                fontSize: '14px'
                                            },
                                            children: "Need-to-Believe:"
                                        }),
                                        (0, $kSbwP.jsx)("div", {
                                            className: "text",
                                            children: renderTextWithInlineCitations({
                                                description: sections.believes,
                                                sources: e.sources
                                            })
                                        })
                                    ]
                                }),
                                sections.relevance && (0, $kSbwP.jsxs)("div", {
                                    children: [
                                        (0, $kSbwP.jsx)("div", {
                                            style: {
                                                fontWeight: 600,
                                                marginBottom: '4px',
                                                fontSize: '14px'
                                            },
                                            children: "Deal Relevance:"
                                        }),
                                        (0, $kSbwP.jsx)("div", {
                                            className: "text",
                                            children: renderTextWithInlineCitations({
                                                description: sections.relevance,
                                                sources: e.sources
                                            })
                                        })
                                    ]
                                }),
                                sections.detailed && (0, $kSbwP.jsxs)("div", {
                                    children: [
                                        (0, $kSbwP.jsx)("div", {
                                            style: {
                                                fontWeight: 600,
                                                marginBottom: '4px',
                                                fontSize: '14px'
                                            },
                                            children: "Diligence Objective:"
                                        }),
                                        (0, $kSbwP.jsx)("div", {
                                            className: "text",
                                            children: renderTextWithInlineCitations({
                                                description: sections.detailed,
                                                sources: e.sources
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, e.title);
        });
    };
    const NoDataElement = (props)=>{
        const defaultMessage = "No Data Available";
        return (0, $kSbwP.jsx)("div", {
            className: $ee30843c79a5ac9f$export$d0b56ec104a7253e,
            children: (props === null || props === void 0 ? void 0 : props.message) || defaultMessage
        });
    };
    const NoDataWrapper = (text)=>{
        if (!text || text.trim().length === 0) return (0, $kSbwP.jsx)(NoDataElement, {});
        return text;
    };
    // Superscript characters for citations
    const superscriptDigits = {
        1: '\u00B9',
        2: '\u00B2',
        3: '\u00B3',
        4: '\u2074',
        5: '\u2075',
        6: '\u2076',
        7: '\u2077',
        8: '\u2078',
        9: '\u2079',
        0: '\u2070'
    };
    const toSuperscript = (num)=>{
        return num.toString().split('').map((d)=>superscriptDigits[parseInt(d)] || d).join('');
    };
    // Parse text field with sources (backward compatible: string or object)
    const parseTextWithSources = (data)=>{
        if (!data) return {
            text: '',
            sources: []
        };
        // Old format: plain string
        if (typeof data === 'string') {
            const text = enableSourcing ? data : $032f62a52fec71db$var$stripCitationsAndMarkdown(data);
            return {
                text: text,
                sources: []
            };
        }
        // New format: object with text and sources
        const text = data.text || '';
        const sources = data.sources || [];
        // If sourcing is disabled, strip all citations and return empty sources
        if (!enableSourcing) return {
            text: $032f62a52fec71db$var$stripCitationsAndMarkdown(text),
            sources: []
        };
        return {
            text: text,
            sources: sources
        };
    };
    // Component to render text with inline citations (generic, works for any text field)
    const TextWithCitations = ({ data: data })=>{
        const { text: text, sources: sources } = parseTextWithSources(data);
        if (!text || text.trim().length === 0) return (0, $kSbwP.jsx)(NoDataElement, {});
        // If no sources, render plain text (backward compatible)
        if (sources.length === 0) return (0, $kSbwP.jsx)("div", {
            children: text
        });
        // Render text with clickable citation numbers
        const renderTextWithCitations = ()=>{
            // Replace citation markers (¹²³ etc) with clickable spans
            const parts = [];
            let lastIndex = 0;
            // Match superscript numbers in text (¹ ² ³ etc or regular digits after special markers)
            const citationRegex = /[\u00B9\u00B2\u00B3\u2074\u2075\u2076\u2077\u2078\u2079\u2070]+/g;
            let match;
            while((match = citationRegex.exec(text)) !== null){
                // Add text before citation
                if (match.index > lastIndex) parts.push(text.substring(lastIndex, match.index));
                // Convert superscript back to number to find source
                const superToNum = {
                    '\u00B9': '1',
                    '\u00B2': '2',
                    '\u00B3': '3',
                    '\u2074': '4',
                    '\u2075': '5',
                    '\u2076': '6',
                    '\u2077': '7',
                    '\u2078': '8',
                    '\u2079': '9',
                    '\u2070': '0'
                };
                const numStr = match[0].split('').map((c)=>superToNum[c] || c).join('');
                const sourceId = parseInt(numStr);
                const source = sources.find((s)=>s.id === sourceId);
                // Add clickable citation
                if (source && source.url) parts.push((0, $kSbwP.jsx)("a", {
                    href: source.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: $ee30843c79a5ac9f$export$2c2a2abcc3f632c7,
                    title: source.name,
                    children: match[0]
                }, `citation-${sourceId}-${match.index}`));
                else parts.push((0, $kSbwP.jsx)("span", {
                    className: $ee30843c79a5ac9f$export$2c2a2abcc3f632c7,
                    children: match[0]
                }, `citation-${sourceId}-${match.index}`));
                lastIndex = match.index + match[0].length;
            }
            // Add remaining text
            if (lastIndex < text.length) parts.push(text.substring(lastIndex));
            return parts.length > 0 ? parts : text;
        };
        return (0, $kSbwP.jsxs)("div", {
            children: [
                (0, $kSbwP.jsx)("div", {
                    children: renderTextWithCitations()
                }),
                (0, $kSbwP.jsxs)("div", {
                    className: $ee30843c79a5ac9f$export$a838e282bcfe2bc8,
                    children: [
                        (0, $kSbwP.jsx)("div", {
                            className: $ee30843c79a5ac9f$export$7c6ea5732f94c86b,
                            children: "Sources"
                        }),
                        (0, $kSbwP.jsx)("div", {
                            className: $ee30843c79a5ac9f$export$b8c2d43efb3dfbec,
                            children: sources.map((source)=>(0, $kSbwP.jsxs)("div", {
                                    className: $ee30843c79a5ac9f$export$9811695268b4512a,
                                    children: [
                                        (0, $kSbwP.jsx)("span", {
                                            className: $ee30843c79a5ac9f$export$6ab6556e37faa800,
                                            children: toSuperscript(source.id)
                                        }),
                                        source.url ? (0, $kSbwP.jsx)("a", {
                                            href: source.url,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: $ee30843c79a5ac9f$export$b0ce9785e3d6acd3,
                                            children: source.name
                                        }) : (0, $kSbwP.jsx)("span", {
                                            className: $ee30843c79a5ac9f$export$cbd85c6fd71fcbf2,
                                            children: source.name
                                        })
                                    ]
                                }, source.id))
                        })
                    ]
                })
            ]
        });
    };
    const lineTitle = (title)=>{
        return (0, $kSbwP.jsx)("div", {
            className: $ee30843c79a5ac9f$export$fb184b623420d9be,
            children: title
        });
    };
    const lineTitleWithInfo = (title, tooltipText)=>{
        return (0, $kSbwP.jsxs)("div", {
            className: $ee30843c79a5ac9f$export$fb184b623420d9be,
            children: [
                title,
                (0, $kSbwP.jsxs)("span", {
                    className: $ee30843c79a5ac9f$export$981ce638514edf,
                    children: [
                        (0, $kSbwP.jsxs)("svg", {
                            className: $ee30843c79a5ac9f$export$c0d9370d587dcb77,
                            width: "18",
                            height: "18",
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            children: [
                                (0, $kSbwP.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    fill: "none"
                                }),
                                (0, $kSbwP.jsx)("text", {
                                    x: "12",
                                    y: "17",
                                    textAnchor: "middle",
                                    fontSize: "14",
                                    fontWeight: "600",
                                    fill: "currentColor",
                                    fontFamily: "Arial, sans-serif",
                                    children: "i"
                                })
                            ]
                        }),
                        (0, $kSbwP.jsx)("div", {
                            className: $ee30843c79a5ac9f$export$4e6f96734dfe12f4,
                            children: tooltipText
                        })
                    ]
                })
            ]
        });
    };
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        fillCell: true,
        children: [
            do_we_have_pdf && (0, $kSbwP.jsx)((0, $f20b217cc7daff5d$export$f20f69a59ceebf9d), {}),
            (0, $kSbwP.jsxs)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                children: [
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "row",
                        style: {
                            width: '100%',
                            minHeight: '450px'
                        },
                        children: [
                            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                                direction: "column",
                                style: {
                                    flex: 1
                                },
                                children: [
                                    lineTitle('Summary of the Opportunity'),
                                    (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                        className: $ee30843c79a5ac9f$export$b848b6ed1647f90b,
                                        children: (0, $kSbwP.jsx)(TextWithCitations, {
                                            data: flowise.opportunity
                                        })
                                    }),
                                    (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                        className: $ee30843c79a5ac9f$export$b848b6ed1647f90b,
                                        children: [
                                            lineTitle('Business Overview'),
                                            (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                                className: $ee30843c79a5ac9f$export$b848b6ed1647f90b,
                                                children: flowise.business_overview ? (0, $kSbwP.jsx)(TextWithCitations, {
                                                    data: flowise.business_overview
                                                }) : store.companyOverview
                                            })
                                        ]
                                    })
                                ]
                            }),
                            do_we_have_pdf && (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: $ee30843c79a5ac9f$export$4a2bd288272bd4d7,
                                style: {
                                    flex: 1
                                },
                                children: (0, $kSbwP.jsx)((0, $99f5eb6d5fa6a0d1$export$8c1b2de0367e9a6e), {
                                    reportId: reportId
                                })
                            })
                        ]
                    }),
                    (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "row",
                        style: {
                            width: '100%',
                            minHeight: '200px'
                        },
                        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            direction: "column",
                            children: [
                                lineTitle('Core Products / Services'),
                                output_boxes_with_links(flowise.core_product_services, 4)
                            ]
                        })
                    }),
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "row",
                        style: {
                            width: '100%',
                            minHeight: '450px'
                        },
                        children: [
                            (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: showPotentialCustomers ? $ee30843c79a5ac9f$export$b848b6ed1647f90b : '',
                                children: [
                                    lineTitleWithInfo('Key Customers', "Key Customers are companies confirmed as clients through direct, verifiable evidence found during research. Valid sources include customer testimonials on the target company's website, press releases naming specific customers, news articles about partnerships or contracts, and published case studies. Each customer listed has been validated with a cited source."),
                                    (0, $kSbwP.jsx)("div", {
                                        children: output_boxes_with_links(flowise.key_customers, 1, "No confirmed customers found in public sources. Verification requires published testimonials, case studies, or press releases.")
                                    })
                                ]
                            }),
                            showPotentialCustomers && (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: $ee30843c79a5ac9f$export$b848b6ed1647f90b,
                                children: [
                                    lineTitleWithInfo('Potential Customers', "Potential Customers are high-probability prospects identified via market and competitive analysis. We identify them by finding key customers of direct competitors, pinpointing companies in high-demand market segments, or determining a strategic fit based on industry trends. The source for each prospect cites the specific public data, like a competitor's report or market analysis, that supports the identification."),
                                    (0, $kSbwP.jsx)("div", {
                                        children: output_boxes_with_links(flowise.potential_customers, 1, "No prospects identified through public research. Identification requires competitor data, market reports, or industry analysis available online.")
                                    })
                                ]
                            })
                        ]
                    }),
                    do_we_have_pdf && (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "row",
                        style: {
                            width: '100%'
                        },
                        children: [
                            (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($ee30843c79a5ac9f$export$b848b6ed1647f90b, $ee30843c79a5ac9f$export$a43cf604e12f3b17),
                                children: (0, $kSbwP.jsx)((0, $79f88d7943aea7e8$export$c2e12a891bea2f25), {
                                    reportId: reportId
                                })
                            }),
                            (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($ee30843c79a5ac9f$export$b848b6ed1647f90b, $ee30843c79a5ac9f$export$a43cf604e12f3b17),
                                children: (0, $kSbwP.jsx)((0, $a04e8dca7e1102b6$export$bf43f5ad66c8bc17), {
                                    reportId: reportId,
                                    companies: compareList
                                })
                            })
                        ]
                    }),
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "row",
                        style: {
                            width: '100%',
                            minHeight: '450px'
                        },
                        children: [
                            (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: $ee30843c79a5ac9f$export$b848b6ed1647f90b,
                                children: [
                                    lineTitle('Market Description'),
                                    (0, $kSbwP.jsx)(TextWithCitations, {
                                        data: flowise.market_description
                                    })
                                ]
                            }),
                            (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: $ee30843c79a5ac9f$export$b848b6ed1647f90b,
                                children: [
                                    lineTitle('Market Size & Growth'),
                                    (0, $kSbwP.jsx)(TextWithCitations, {
                                        data: flowise.market_size
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "row",
                        style: {
                            width: '100%',
                            minHeight: '200px'
                        },
                        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            direction: "column",
                            children: [
                                lineTitle('Competitor Segments'),
                                output_boxes_with_links(flowise.competitor_segments, 4)
                            ]
                        })
                    }),
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "row",
                        style: {
                            width: '100%',
                            paddingBottom: '20px'
                        },
                        children: [
                            (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: $ee30843c79a5ac9f$export$b848b6ed1647f90b,
                                children: [
                                    lineTitle('What We Like'),
                                    output_we_like(flowise.what_we_like, (0, (/*@__PURE__*/$parcel$interopDefault($9969ffd600cf868e$exports))))
                                ]
                            }),
                            (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: $ee30843c79a5ac9f$export$b848b6ed1647f90b,
                                children: [
                                    lineTitle('Key Risks'),
                                    output_we_like(flowise.key_risks, (0, (/*@__PURE__*/$parcel$interopDefault($1cc2d21ea6c4e775$exports))))
                                ]
                            })
                        ]
                    }),
                    (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "row",
                        style: {
                            width: '100%',
                            minHeight: '200px'
                        },
                        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            direction: "column",
                            children: [
                                lineTitle('Focus Areas for Due Diligence'),
                                output_due_diligence(flowise.diligence)
                            ]
                        })
                    })
                ]
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");





var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");




var $gpaur = parcelRequire("gpaur");

var $fgQ0V = parcelRequire("fgQ0V");


var $8nGP5 = parcelRequire("8nGP5");
var $3456e24de238680b$exports = {};
"use strict";
var $63db96f421ff80ad$exports = {};
"use strict";
Object.defineProperty($63db96f421ff80ad$exports, "__esModule", {
    value: true
});
Object.defineProperty($63db96f421ff80ad$exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $63db96f421ff80ad$var$_DraggableCore.default;
    }
});
$63db96f421ff80ad$exports.default = void 0;

var $63db96f421ff80ad$var$React = $63db96f421ff80ad$var$_interopRequireWildcard((parcelRequire("8nGP5")));

var $63db96f421ff80ad$var$_propTypes = $63db96f421ff80ad$var$_interopRequireDefault((parcelRequire("ebCsu")));

var $63db96f421ff80ad$var$_reactDom = $63db96f421ff80ad$var$_interopRequireDefault((parcelRequire("fCKK7")));

var $63db96f421ff80ad$var$_clsx = $63db96f421ff80ad$var$_interopRequireDefault((parcelRequire("4kfzs")));

var $9aSVH = parcelRequire("9aSVH");

var $fbPNc = parcelRequire("fbPNc");

var $7i6sP = parcelRequire("7i6sP");

var $63db96f421ff80ad$var$_DraggableCore = $63db96f421ff80ad$var$_interopRequireDefault((parcelRequire("eBJyY")));

var $63db96f421ff80ad$var$_log = $63db96f421ff80ad$var$_interopRequireDefault((parcelRequire("iI5jz")));
function $63db96f421ff80ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $63db96f421ff80ad$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($63db96f421ff80ad$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $63db96f421ff80ad$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $63db96f421ff80ad$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $63db96f421ff80ad$var$_extends() {
    $63db96f421ff80ad$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63db96f421ff80ad$var$_extends.apply(this, arguments);
}
function $63db96f421ff80ad$var$_defineProperty(obj, key, value) {
    key = $63db96f421ff80ad$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $63db96f421ff80ad$var$_toPropertyKey(arg) {
    var key = $63db96f421ff80ad$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $63db96f421ff80ad$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $63db96f421ff80ad$var$Draggable extends $63db96f421ff80ad$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $63db96f421ff80ad$var$_log.default)('Draggable: getDerivedStateFromProps %j', {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $63db96f421ff80ad$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $63db96f421ff80ad$var$_log.default)('Draggable: onDragStart: %j', coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $fbPNc.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $63db96f421ff80ad$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $63db96f421ff80ad$var$_log.default)('Draggable: onDrag: %j', coreData);
            const uiData = (0, $fbPNc.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $fbPNc.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $63db96f421ff80ad$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $fbPNc.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $63db96f421ff80ad$var$_log.default)('Draggable: onDragStop: %j', coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props$nodeRef$c, _this$props;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $63db96f421ff80ad$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $fbPNc.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $fbPNc.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $9aSVH.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $9aSVH.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $63db96f421ff80ad$var$_clsx.default)(children.props.className || '', defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $63db96f421ff80ad$var$React.createElement($63db96f421ff80ad$var$_DraggableCore.default, $63db96f421ff80ad$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $63db96f421ff80ad$var$React.cloneElement($63db96f421ff80ad$var$React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
}
$63db96f421ff80ad$exports.default = $63db96f421ff80ad$var$Draggable;
$63db96f421ff80ad$var$_defineProperty($63db96f421ff80ad$var$Draggable, "displayName", 'Draggable');
$63db96f421ff80ad$var$_defineProperty($63db96f421ff80ad$var$Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...$63db96f421ff80ad$var$_DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $63db96f421ff80ad$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $63db96f421ff80ad$var$_propTypes.default.oneOfType([
        $63db96f421ff80ad$var$_propTypes.default.shape({
            left: $63db96f421ff80ad$var$_propTypes.default.number,
            right: $63db96f421ff80ad$var$_propTypes.default.number,
            top: $63db96f421ff80ad$var$_propTypes.default.number,
            bottom: $63db96f421ff80ad$var$_propTypes.default.number
        }),
        $63db96f421ff80ad$var$_propTypes.default.string,
        $63db96f421ff80ad$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $63db96f421ff80ad$var$_propTypes.default.string,
    defaultClassNameDragging: $63db96f421ff80ad$var$_propTypes.default.string,
    defaultClassNameDragged: $63db96f421ff80ad$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $63db96f421ff80ad$var$_propTypes.default.shape({
        x: $63db96f421ff80ad$var$_propTypes.default.number,
        y: $63db96f421ff80ad$var$_propTypes.default.number
    }),
    positionOffset: $63db96f421ff80ad$var$_propTypes.default.shape({
        x: $63db96f421ff80ad$var$_propTypes.default.oneOfType([
            $63db96f421ff80ad$var$_propTypes.default.number,
            $63db96f421ff80ad$var$_propTypes.default.string
        ]),
        y: $63db96f421ff80ad$var$_propTypes.default.oneOfType([
            $63db96f421ff80ad$var$_propTypes.default.number,
            $63db96f421ff80ad$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $63db96f421ff80ad$var$_propTypes.default.shape({
        x: $63db96f421ff80ad$var$_propTypes.default.number,
        y: $63db96f421ff80ad$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $7i6sP.dontSetMe,
    style: $7i6sP.dontSetMe,
    transform: $7i6sP.dontSetMe
});
$63db96f421ff80ad$var$_defineProperty($63db96f421ff80ad$var$Draggable, "defaultProps", {
    ...$63db96f421ff80ad$var$_DraggableCore.default.defaultProps,
    axis: 'both',
    bounds: false,
    defaultClassName: 'react-draggable',
    defaultClassNameDragging: 'react-draggable-dragging',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});


var $3456e24de238680b$require$Draggable = $63db96f421ff80ad$exports.default;
var $3456e24de238680b$require$DraggableCore = $63db96f421ff80ad$exports.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
$3456e24de238680b$exports = $3456e24de238680b$require$Draggable;
$3456e24de238680b$exports.default = $3456e24de238680b$require$Draggable;
$3456e24de238680b$exports.DraggableCore = $3456e24de238680b$require$DraggableCore;




var $e57608b234d6aa05$export$a67ff6543f6b99a8;
var $e57608b234d6aa05$export$c746a5152d4ba26c;
$e57608b234d6aa05$export$a67ff6543f6b99a8 = `Bk_YHG_dragIconStyle`;
$e57608b234d6aa05$export$c746a5152d4ba26c = `Bk_YHG_draggable`;


var $ef0783079b2118bf$exports = {};
$ef0783079b2118bf$exports = new URL("dragIcon.481a3c08.svg", import.meta.url).toString();



const $9583d2c91dbe771f$export$3ccee0cf1acf5f70 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    const spaceBetween = props.spaceBetween || 20;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.toArray(props.children);
    (0, (/*@__PURE__*/$parcel$interopDefault($gpaur)))(children.length === 2, 'Must be 2 children');
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const nav = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const [highlightDrag, setHighlightDrag] = (0, $8nGP5.useState)(false);
    const [contentSize, setContentSize] = (0, $8nGP5.useState)(uiStore.currentSplitRatioDetailView);
    const setContentSizeThrottle = (0, $8nGP5.useCallback)((0, $fgQ0V.throttle)((size)=>{
        setContentSize(size);
    }, 50), []);
    const [dragPosX, setDragPosX] = (0, $8nGP5.useState)(0);
    const [ref, bounds] = (0, $7e7ca35815405df8$export$2e2bcd8739ae039)();
    const winWidth = bounds.width;
    const repositionDragable = ()=>{
        setDragPosX(winWidth * (contentSize / 100));
    };
    const resizeRefCallback = (0, $8nGP5.useRef)(()=>{});
    resizeRefCallback.current = repositionDragable;
    const draggableSpring = (0, $21cbb88cff39ec52$export$ab73804b080feffc)(0, {
        onChange: (val)=>{
            const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
            setContentSize(val);
        },
        onRest: (val)=>{
            resizeRefCallback.current();
        }
    });
    (0, $8nGP5.useEffect)(()=>{
        uiStore.currentSplitRatioDetailView = contentSize;
    }, [
        contentSize
    ]);
    (0, $8nGP5.useEffect)(()=>{
        repositionDragable();
    }, [
        winWidth
    ]);
    if (!store.query) return null;
    const size = [
        contentSize,
        100 - contentSize
    ];
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            winWidth > 0 && (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3456e24de238680b$exports))), {
                axis: "x",
                handle: ".handle",
                bounds: {
                    left: 400,
                    right: winWidth - 400
                },
                positionOffset: {
                    x: -5,
                    y: 30
                },
                // position={{
                //     x: dragPos,
                //     y: 0
                // }}
                //position={{ x: dragPosX, y: 0 }}
                position: {
                    x: dragPosX,
                    y: 0
                },
                onDrag: (e, data)=>{
                    //Maybe add callback later if becomes messy not really draggable responsability
                    var pdfs = document.getElementsByClassName('pdf-viewer');
                    for(var i = 0; i < pdfs.length; i++){
                        const pdf = pdfs[i];
                        pdf.style.pointerEvents = 'none';
                    }
                    var x = data.x;
                    var mouseX = data.lastX;
                    var normalized = data.x / winWidth;
                    // console.log(
                    //     'DRAGGING: ' + x + ' ' + mouseX + ' ' + winWidth
                    // );
                    const viewSize = normalized * 100;
                    setContentSizeThrottle(viewSize);
                },
                onStop: (e, data)=>{
                    //console.log('STOP DRAG: ', data.x);
                    var normalized = data.x / winWidth;
                    const viewSize = normalized * 100;
                    setContentSize(viewSize);
                    repositionDragable();
                    var pdfs = document.getElementsByClassName('pdf-viewer');
                    for(var i = 0; i < pdfs.length; i++){
                        const pdf = pdfs[i];
                        pdf.style.pointerEvents = 'auto';
                    }
                },
                children: (0, $kSbwP.jsx)("div", {
                    className: 'handle ' + $e57608b234d6aa05$export$c746a5152d4ba26c,
                    style: {
                        zIndex: 60000,
                        position: 'absolute',
                        height: 'calc(100vh - 220px)',
                        cursor: 'col-resize !important'
                    },
                    onMouseEnter: ()=>{
                        setHighlightDrag(true);
                    },
                    onMouseLeave: ()=>{
                        setHighlightDrag(false);
                    },
                    onDoubleClick: ()=>{
                        const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
                        if (80 - contentSize < 1) draggableSpring.set(contentSize).start(50);
                        else draggableSpring.set(contentSize).start(80);
                    },
                    children: (0, $kSbwP.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ef0783079b2118bf$exports))),
                        style: {
                            pointerEvents: 'none',
                            transform: 'scale(0.9)',
                            opacity: 0
                        }
                    })
                })
            }),
            (0, $kSbwP.jsx)("div", {
                ref: ref,
                style: {
                    width: '100%',
                    height: '100%'
                },
                children: (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "column",
                    fillCell: true,
                    children: (0, $kSbwP.jsxs)((0, $c94930c253f3e81f$export$f836382419f64c98), {
                        layoutPercent: size,
                        spaceBetween: spaceBetween,
                        children: [
                            props.children[0],
                            (0, $kSbwP.jsxs)("div", {
                                style: {
                                    width: '100%',
                                    height: '100%'
                                },
                                children: [
                                    (0, $kSbwP.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ef0783079b2118bf$exports))),
                                        className: $e57608b234d6aa05$export$a67ff6543f6b99a8,
                                        style: {
                                            filter: highlightDrag ? 'brightness(95%)' : 'none'
                                        }
                                    }),
                                    props.children[1]
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");

var $5ad47f50ec623be3$export$40a9eeef55665a40;
var $5ad47f50ec623be3$export$93b7586d956c930e;
var $5ad47f50ec623be3$export$f843afa9e9b53052;
var $5ad47f50ec623be3$export$b8bcb06145f9bb8a;
var $5ad47f50ec623be3$export$ae78d338ad66ff90;
var $5ad47f50ec623be3$export$b8972b998723d602;
var $5ad47f50ec623be3$export$13925b5cf10ba292;
$5ad47f50ec623be3$export$40a9eeef55665a40 = `oAoGMG_defaultPadding`;
$5ad47f50ec623be3$export$93b7586d956c930e = `oAoGMG_dropShadow`;
$5ad47f50ec623be3$export$f843afa9e9b53052 = `oAoGMG_panelImage`;
$5ad47f50ec623be3$export$b8bcb06145f9bb8a = `oAoGMG_panelRowHeader`;
$5ad47f50ec623be3$export$ae78d338ad66ff90 = `oAoGMG_scaleInOut`;
$5ad47f50ec623be3$export$b8972b998723d602 = `oAoGMG_shadow`;
$5ad47f50ec623be3$export$13925b5cf10ba292 = `oAoGMG_small-shadow`;


const $2b38151664cc4c33$export$968713404ca1c9aa = (props)=>{
    var icon = (0, $kSbwP.jsx)("i", {
        className: "bi bi-clipboard"
    });
    if (props.iconUrl) icon = (0, $kSbwP.jsx)("img", {
        src: props.iconUrl,
        alt: "icon"
    });
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        className: $5ad47f50ec623be3$export$b8bcb06145f9bb8a,
        children: [
            icon,
            (0, $kSbwP.jsx)("div", {
                className: "flex-grow-1",
                children: props.title
            }),
            (0, $kSbwP.jsx)("div", {})
        ]
    });
};













const $b8332ea8355e1651$var$convStringToSerializeType = (field, newValue)=>{
    //'$' | '%' | 'year' | 'str' | 'bool'
    if (newValue === null) return null;
    switch(field.t){
        case '$':
        case '%':
            return parseFloat(newValue);
        case 'str':
            return newValue;
        case 'bool':
            return newValue == 1 || newValue == 'true' ? true : false;
        case 'array':
            return newValue.split(',');
        default:
            return newValue;
    }
};
const $b8332ea8355e1651$var$update_override = (tickerId, path, val, originalValue)=>{
    if (val === null || val == originalValue) (0, $b2432f43c421c848$export$7a667d08ed65fa47)().remove_override(tickerId, path);
    else (0, $b2432f43c421c848$export$7a667d08ed65fa47)().store_override(tickerId, path, val.toString());
};
const $b8332ea8355e1651$export$ecde49fefbe76021 = (row, column, newValue, rowIndex)=>{
    var _a, _b;
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const rowField = row.field;
    const colField = column.column;
    const schema = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71);
    const data = new (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)(store.activeReportOriginal, {}, 'edit_report_field');
    const f = schema[rowField.source];
    let val_db = null;
    if ((_a = f.yearly) !== null && _a !== void 0 ? _a : false) val_db = data.valueByYear(rowField.source, parseInt(colField.source));
    else val_db = data.value(rowField.source);
    try {
        if (colField.display === 'Source') {
            //Special case
            //This is source column, Update based on column not row
            const overidePath = `${rowField.source}_page_source`;
            $b8332ea8355e1651$var$update_override(store.selectedReportId, overidePath, newValue ? newValue.toString() : null, val_db);
            return;
        }
        const convValue = $b8332ea8355e1651$var$convStringToSerializeType(f, newValue);
        if ((_b = f.yearly) !== null && _b !== void 0 ? _b : false) {
            const year = parseInt(colField.source);
            const overidePath = `${rowField.source}/${year.toString()}`;
            $b8332ea8355e1651$var$update_override(store.selectedReportId, overidePath, convValue, val_db);
        } else {
            //value
            const overidePath = `${rowField.source}`;
            $b8332ea8355e1651$var$update_override(store.selectedReportId, overidePath, convValue, val_db);
        }
    } catch (e) {
        console.log('Error onEditReportField', e);
    }
};


const $79da148714874de1$export$58cad4665f64d293 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = store.query;
    const data = query.activeReport;
    if (!data) return null;
    const cols = [
        {
            column: {
                source: null,
                display: 'Value'
            }
        },
        {
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            editor: (0, $68d2907db623a0aa$export$44b5115104b4b812).textbox,
            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];
    const genRow = (fieldName, display, formatter, extra)=>{
        return Object.assign({
            editable: true,
            field: {
                source: fieldName,
                display: display
            },
            value: (_field, column)=>{
                return query.value(fieldName);
            },
            formatter: formatter,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label,
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent
        }, extra);
    };
    //    var industry =
    //    query.value('industry') + ', ' + query.value('industrySubType');
    const editableFields = [
        {
            field: 'company_name',
            display: 'Company Name'
        },
        {
            field: 'company_ceo',
            display: 'Company CEO'
        },
        {
            field: 'hq_location',
            display: 'HQ Location'
        },
        {
            field: 'year_founded',
            display: 'Year Founded'
        }
    ];
    const rows = editableFields.map((e)=>{
        return genRow(e.field, e.display, (0, $1ac83566e6b5504b$export$91991769c57c29a), {
            editor: (0, $68d2907db623a0aa$export$44b5115104b4b812).textbox
        });
    });
    return (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        shadow: true,
        children: [
            (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                title: "Business Overview"
            }),
            (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                columns: cols,
                rows: rows,
                onEditField: (0, $b8332ea8355e1651$export$ecde49fefbe76021)
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");
var $8eab6c38cd7d6be7$export$40a9eeef55665a40;
var $8eab6c38cd7d6be7$export$93b7586d956c930e;
var $8eab6c38cd7d6be7$export$f843afa9e9b53052;
var $8eab6c38cd7d6be7$export$deba8b5170183922;
var $8eab6c38cd7d6be7$export$ae78d338ad66ff90;
var $8eab6c38cd7d6be7$export$b8972b998723d602;
var $8eab6c38cd7d6be7$export$13925b5cf10ba292;
$8eab6c38cd7d6be7$export$40a9eeef55665a40 = `xMsl9q_defaultPadding`;
$8eab6c38cd7d6be7$export$93b7586d956c930e = `xMsl9q_dropShadow`;
$8eab6c38cd7d6be7$export$f843afa9e9b53052 = `xMsl9q_panelImage`;
$8eab6c38cd7d6be7$export$deba8b5170183922 = `xMsl9q_panelRowDivier`;
$8eab6c38cd7d6be7$export$ae78d338ad66ff90 = `xMsl9q_scaleInOut`;
$8eab6c38cd7d6be7$export$b8972b998723d602 = `xMsl9q_shadow`;
$8eab6c38cd7d6be7$export$13925b5cf10ba292 = `xMsl9q_small-shadow`;


const $fe065f57c6129e2d$export$789f086b167f93b9 = ()=>{
    return (0, $kSbwP.jsx)("div", {
        className: $8eab6c38cd7d6be7$export$deba8b5170183922
    });
};






var $kSbwP = parcelRequire("kSbwP");

var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

const $4a29e112f87df826$export$3247f956c2135754 = (props)=>{
    const [ref, bounds] = (0, $7e7ca35815405df8$export$2e2bcd8739ae039)();
    (0, $8nGP5.useEffect)(()=>{
        props.onResize(bounds);
    }, [
        bounds
    ]);
    return (0, $kSbwP.jsx)("div", {
        ref: ref,
        style: {
            width: '100%',
            height: '1px',
            position: 'absolute'
        }
    });
};






var $fgQ0V = parcelRequire("fgQ0V");


var $8nGP5 = parcelRequire("8nGP5");






var $4d8f71986a24a2e8$export$3dc43a2aec770a90;
$4d8f71986a24a2e8$export$3dc43a2aec770a90 = `Peievq_panelYearly`;



const $bbf930a6e7328633$export$89f5e9b3190f357b = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const yearsShow = (0, $8f024b03d9af7c67$export$d842a17955610ca9)().detailsViewYearsToShow;
    const minPixelsPerEntry = 100;
    //const maxYearsInReport = 8;
    const setYears = (0, $8nGP5.useCallback)((0, $fgQ0V.throttle)((year)=>{
        (0, $8f024b03d9af7c67$export$d842a17955610ca9)().detailsViewYearsToShow = year;
    }, 800, {
        leading: false,
        trailing: true
    }), []);
    const onResize = (size)=>{
        if (size.width == 0) return;
        const calcYears = Math.ceil((size.width - 450) / minPixelsPerEntry);
        if (yearsShow !== calcYears) setYears(calcYears);
    };
    const maxYearsInReport = yearsShow;
    //console.log(maxYearsInReport);
    const query = store.query;
    const reportData = query.activeReport;
    // const findByYearSection = (
    //     req: SectionValueByYearRequest,
    //     yearOffset?: number
    // ) => {
    //     return (field: TableField, column: TableField) => {
    //         const year = parseInt(column.source) + (yearOffset ?? 0);
    //         return query.valueBySection({
    //             section: req.section,
    //             field: req.field,
    //             year
    //         });
    //     };
    // };
    const findByYear = (yearOffset = 0)=>{
        return (field, column)=>{
            const year = parseInt(column.source) + yearOffset;
            return query.valueByYear(field.source, year);
        };
    };
    const findByYearDivideByRevenue = (yearOffset = 0)=>{
        return (field, column)=>{
            const year = parseInt(column.source) + yearOffset;
            const fieldValue = query.valueByYear(field.source, year);
            const revenue = query.valueByYear('net_revenue_per_year', year);
            if (fieldValue === 'N/A' || revenue === 'N/A') return 'N/A';
            return fieldValue / revenue;
        };
    };
    const createColumnsYears = (fromYear, toYear)=>{
        var _a;
        const actualizedYears = (_a = reportData['list_years_actualized_revenue']) !== null && _a !== void 0 ? _a : [];
        const minActualizedYear = Math.min(...actualizedYears);
        const cols = [];
        for(let year = fromYear; year <= toYear; year++){
            const isActualized = actualizedYears.includes(year) || year <= minActualizedYear;
            const letter = isActualized ? 'A' : 'P';
            cols.push({
                column: {
                    source: year.toString(),
                    display: year.toString() + letter
                }
            });
        }
        return cols;
    };
    const getReportYearRange = ()=>{
        if (!reportData) return {
            from: 0,
            to: 0
        };
        var minYear = -1;
        var maxYear = -1;
        const fields = [
            'net_revenue_per_year',
            'ebitda_per_year'
        ];
        fields.forEach((field)=>{
            const list = reportData[field];
            if (!list || Array.isArray(list) === false) return;
            const years = list.map((item)=>parseInt(item.year));
            const min = Math.min(...years);
            const max = Math.max(...years);
            if (minYear == -1 || min < minYear) minYear = min;
            if (maxYear == -1 || max > maxYear) maxYear = max;
        });
        //minYear = 2003;
        if (maxYear - minYear > maxYearsInReport) {
            const trim = maxYear - minYear - maxYearsInReport + 1;
            return {
                from: minYear + trim,
                to: maxYear
            };
        }
        //console.log(minYear, maxYear);
        return {
            from: minYear,
            to: maxYear
        };
    };
    const tableRange = getReportYearRange();
    const columns = [
        ...createColumnsYears(tableRange.from, tableRange.to),
        {
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];
    const defaults = {
        label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
        formatter: (0, $1ac83566e6b5504b$export$40333d0facc9092d),
        element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).dollar,
        editable: true
    };
    const defaultsPercent = {
        label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label,
        formatter: (0, $1ac83566e6b5504b$export$32e6b1ae352e94d6),
        element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent
    };
    const makeRow = (fieldName, hideRowNoData = false)=>{
        var _a;
        const hasData = query.anyValue(fieldName);
        const display = (_a = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName]['display']) !== null && _a !== void 0 ? _a : fieldName;
        const row = Object.assign(Object.assign({}, defaults), {
            skipRow: !hasData && hideRowNoData,
            field: {
                source: fieldName,
                display: display
            },
            value: findByYear()
        });
        return row;
    };
    const makeEbitdaRows = (fieldName)=>{
        var _a;
        const hasData = query.anyValue(fieldName);
        const display = (_a = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName]['display']) !== null && _a !== void 0 ? _a : fieldName;
        if (!hasData) return null;
        const ebitdaValuesRow = Object.assign(Object.assign({}, defaults), {
            field: {
                source: fieldName,
                display: display
            },
            value: findByYear()
        });
        const ebitdaMarginRow = Object.assign(Object.assign({}, defaultsPercent), {
            field: {
                source: fieldName,
                display: display + ' Margin'
            },
            value: findByYearDivideByRevenue()
        });
        return [
            ebitdaValuesRow,
            ebitdaMarginRow
        ];
    };
    // const makeSectionRow = (req: SectionFieldRequest) => {
    //     return {
    //         ...defaults,
    //         field: {
    //             source: `${req.section}.${req.field}`,
    //             display: query.labelBySection(req)
    //         },
    //         value: findByYearSection({ ...req })
    //     };
    // };
    const ebitdaKeys = (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9).EBITDA_TYPES;
    const ebitdaRows = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).flatMap(ebitdaKeys, (key)=>makeEbitdaRows(key) || []);
    const get_capitalized_software = (f, c)=>{
        const year = parseInt(c.source);
        const getValue = (field)=>{
            const value = query.valueByYear(field, year);
            return value === 'N/A' ? 0 : value;
        };
        const override = query.valueByYear('capitalized_software_override', year);
        if (override !== 'N/A') return (0, $7fbd760f3c05e83d$export$c0080068ec287465)(override);
        const capitalizedSoftware = getValue('capitalized_software');
        const capitalized_application_development = getValue('capitalized_application_development');
        const capitalized_rnd = getValue('capitalized_rnd');
        const total = capitalizedSoftware + capitalized_application_development + capitalized_rnd;
        if (total === 0) return null;
        return total;
    };
    const get_capex_plus_software = (f, c)=>{
        var _a;
        const year = parseInt(c.source);
        const capitalized = (_a = get_capitalized_software(f, c)) !== null && _a !== void 0 ? _a : 0;
        const capex = query.valueByYear('capex_per_year', year);
        if (capex === 'N/A') return 'N/A';
        return capex + capitalized;
    };
    const makeFieldRow = (data, type, valFn, extend = {})=>{
        const valueCallback = valFn === 'by_year' ? findByYear(0) : findByYearDivideByRevenue(0);
        const defValues = type === 'dollar' ? defaults : defaultsPercent;
        return Object.assign(Object.assign(Object.assign({}, defValues), {
            field: {
                source: data.source,
                display: data.display
            },
            value: valueCallback
        }), extend);
    };
    const makeDollarRow = (source, display, extra = {})=>{
        return makeFieldRow({
            source: source,
            display: display
        }, 'dollar', 'by_year', Object.assign({
            editable: true
        }, extra));
    };
    const makePercentRowByRevenue = (source, display, extra = {})=>{
        return makeFieldRow({
            source: source,
            display: display
        }, 'percent', 'by_year_divide_by_revenue', Object.assign({
            editable: false
        }, extra));
    };
    const rows = [
        makeDollarRow('net_revenue_per_year', 'Revenue'),
        makePercentRowByRevenue('net_revenue_per_year', 'Revenue Growth', {
            value: (c, f)=>{
                const thisYear = findByYear()(c, f);
                const lastYear = findByYear(-1)(c, f);
                if (thisYear === 'N/A' || lastYear === 'N/A') return 'N/A';
                const growth = (thisYear - lastYear) / lastYear;
                return growth;
            }
        }),
        makeDollarRow('gross_profit_per_year', 'Gross Profit'),
        makePercentRowByRevenue('gross_profit_per_year', 'Gross Margin'),
        makeDollarRow('ebitda_per_year', 'EBITDA'),
        makePercentRowByRevenue('ebitda_per_year', 'EBITDA Margin'),
        makeDollarRow('adjusted_ebitda_per_year', 'Adj. EBITDA'),
        makePercentRowByRevenue('adjusted_ebitda_per_year', 'Adj. EBITDA Margin'),
        // ...ebitdaRows,
        makePercentRowByRevenue('gross_retention_lost_only_per_year', 'Gross Retention (Lost Only)', {
            editable: true,
            value: findByYear(),
            formatter: (0, $1ac83566e6b5504b$export$23be700726d3a499)
        }),
        makePercentRowByRevenue('net_retention_yearly', 'Net Retention', {
            editable: true,
            value: findByYear(),
            formatter: (0, $1ac83566e6b5504b$export$23be700726d3a499)
        }),
        makeDollarRow('total_current_assets_yearly', 'Current Assets'),
        makeDollarRow('total_current_liabilities_yearly', 'Current Liabilities'),
        makePercentRowByRevenue(null, 'NWC Ratio, % of Revenue', {
            value: (f, c)=>{
                const year = parseInt(c.source);
                const assets = query.valueByYear('total_current_assets_yearly', year);
                const Liabilities = query.valueByYear('total_current_liabilities_yearly', year);
                const revenue = query.valueByYear('net_revenue_per_year', year);
                if (assets === 'N/A' || Liabilities === 'N/A' || revenue === 'N/A') return 'N/A';
                return (assets - Liabilities) / revenue;
            }
        }),
        makeDollarRow('capex_per_year', 'Capex'),
        makePercentRowByRevenue('capex_per_year', 'Capex, % of Revenue'),
        makeDollarRow('capitalized_software_override', "\u2060Capitalized Development Costs", {
            //Note we hack this 'field display name' to connect to sources in data access utils
            editable: true,
            value: get_capitalized_software
        }),
        makeDollarRow(null, "\u2060CapEx (incl Capitalized Development Costs)", {
            editable: false,
            value: get_capex_plus_software
        }),
        makePercentRowByRevenue(null, 'CapEx (incl Capitalized Development Costs), as a % of revenue', {
            editable: false,
            value: (f, c)=>{
                //Special case where we edit a field but if not bring a grouped value
                const year = parseInt(c.source);
                const totalCapex = get_capex_plus_software(f, c);
                const revenue = query.valueByYear('net_revenue_per_year', year);
                if (totalCapex === 'N/A' || revenue === 'N/A') return 'N/A';
                return totalCapex / revenue;
            }
        }),
        makeDollarRow('maintenance_capex_per_year', 'Maintenance CapEx'),
        makeDollarRow(null, 'Free Cash Flow (FCF)', {
            editable: false,
            value: (f, c)=>{
                const year = parseInt(c.source);
                return query.free_cash_flow(year);
            }
        }),
        makePercentRowByRevenue(null, 'FCF Conversion, % of Adj. EBITDA', {
            value: (f, c)=>{
                const year = parseInt(c.source);
                return query.fcf_conversion_ebitda(year);
            }
        })
    ];
    const ebitda = query.value('ebitda');
    if (ebitda) {
        var keys = Object.keys(ebitda);
        for(var k in keys){
            const key = keys[k];
        }
    }
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)((0, $4a29e112f87df826$export$3247f956c2135754), {
                onResize: onResize
            }),
            (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
                title: "General"
            }),
            (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                className: $4d8f71986a24a2e8$export$3dc43a2aec770a90,
                topLeftCellText: "($ in Millions)",
                columns: columns,
                rows: rows,
                disable_round_edges: true,
                onEditField: (0, $b8332ea8355e1651$export$ecde49fefbe76021)
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");








const $fc006c6fb6bc2c1f$export$e5d899bd293071b8 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const { query: query } = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const columns = [
        {
            column: {
                source: '',
                display: 'Value'
            }
        },
        {
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];
    const makeRow = (fieldName, display, formatter)=>{
        return {
            field: {
                source: fieldName,
                display: display
            },
            value: (_field, _column)=>{
                return query.value(fieldName);
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            formatter: formatter
        };
    };
    const rows = [
        {
            field: {
                source: 'recurring_revenue_summary',
                display: 'Contractual Revenue'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).boolean,
            value: (field, _column)=>{
                return query.value(field.source);
            },
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            //editor: ValueEditor.boolean,
            editable: true
        },
        makeRow('does_not_exist', 'Payback Period for Growth Capex', (0, $1ac83566e6b5504b$export$40333d0facc9092d))
    ];
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
                title: "Key Metrics"
            }),
            (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                columns: columns,
                rows: rows,
                onEditField: (0, $b8332ea8355e1651$export$ecde49fefbe76021)
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");






const $c419de567f6a7798$export$4cf3faa507b81a0a = ()=>{
    const data = {};
    const query = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
    const cols = [
        {
            column: {
                source: '2',
                display: '2 Years'
            }
        },
        {
            column: {
                source: '3',
                display: '3 Years'
            }
        },
        {
            column: {
                source: '4',
                display: '4 Years'
            }
        },
        {
            column: {
                source: '5',
                display: '5 Years'
            }
        },
        {
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];
    const rowDefaults = {
        element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent,
        label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label,
        formatter: (data)=>(0, $7fbd760f3c05e83d$export$e440a706af0c0216)(data.toString())
    };
    const rows = [
        Object.assign(Object.assign({}, rowDefaults), {
            field: {
                source: 'net_revenue_per_year',
                display: 'Historical Organic CAGR'
            },
            value: (field, column)=>{
                const yearCalc = parseInt(column.source);
                return query.organicCagr(yearCalc);
            }
        }),
        Object.assign(Object.assign({}, rowDefaults), {
            field: {
                source: 'net_revenue_per_year',
                display: 'Projected Organic CAGR'
            },
            value: (field, column)=>{
                const yearCalc = parseInt(column.source);
                return query.projectedCagr(yearCalc);
            }
        })
    ];
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
                title: "Revenue CAGRs"
            }),
            (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                columns: cols,
                rows: rows,
                disable_round_edges: true
            })
        ]
    });
};



const $9f7291a9219114ca$export$8a60f67e01e6fb31 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const data = store.query.activeReport;
    if (!data) return null;
    const icon = (0, $3d82e178f5213798$export$ef2b607153f69518)('revenue_performance');
    return (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        shadow: true,
        children: [
            (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                title: "Financials",
                iconUrl: icon
            }),
            (0, $kSbwP.jsx)((0, $bbf930a6e7328633$export$89f5e9b3190f357b), {}),
            (0, $kSbwP.jsx)((0, $fe065f57c6129e2d$export$789f086b167f93b9), {}),
            (0, $kSbwP.jsx)((0, $c419de567f6a7798$export$4cf3faa507b81a0a), {}),
            (0, $kSbwP.jsx)((0, $fe065f57c6129e2d$export$789f086b167f93b9), {}),
            (0, $kSbwP.jsx)((0, $fc006c6fb6bc2c1f$export$e5d899bd293071b8), {})
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");











const $b1fe1211f58e7da7$export$5b854e326c825364 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = store.query;
    const data = query.activeReport;
    if (!data) return null;
    const cols = [
        {
            column: {
                source: null,
                display: 'Value'
            }
        },
        {
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            editor: (0, $68d2907db623a0aa$export$44b5115104b4b812).textbox,
            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];
    const genRow = (fieldName, display, formatter, extra)=>{
        return Object.assign({
            editable: true,
            field: {
                source: fieldName,
                display: display
            },
            value: (_field, column)=>{
                return query.value(fieldName);
            },
            formatter: formatter,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label,
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent
        }, extra);
    };
    //    var industry =
    //    query.value('industry') + ', ' + query.value('industrySubType');
    const rows = [
        genRow('market_share', 'Market Share', (0, $1ac83566e6b5504b$export$23be700726d3a499)),
        genRow('historical_market_growth', 'Historical Market Growth', (0, $1ac83566e6b5504b$export$23be700726d3a499)),
        genRow('projected_market_growth', 'Projected Market Growth', (0, $1ac83566e6b5504b$export$23be700726d3a499)),
        genRow('total_addressable_market', 'Total Addressable Market', (0, $1ac83566e6b5504b$export$ce7cfd4f28e6833)(' Bil.'), {
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value
        }),
        genRow('industry', 'Industry', (0, $1ac83566e6b5504b$export$91991769c57c29a), {
            editor: (0, $68d2907db623a0aa$export$44b5115104b4b812).industry
        }),
        genRow('industrySubType', 'Sub-industry', (0, $1ac83566e6b5504b$export$91991769c57c29a), {
            editor: (0, $68d2907db623a0aa$export$44b5115104b4b812).subIndustry
        })
    ];
    const icon = (0, $3d82e178f5213798$export$ef2b607153f69518)('market_size_and_performance');
    return (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        shadow: true,
        children: [
            (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                title: "Industry",
                iconUrl: icon
            }),
            (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                columns: cols,
                rows: rows,
                onEditField: (0, $b8332ea8355e1651$export$ecde49fefbe76021)
            })
        ]
    });
});




var $kSbwP = parcelRequire("kSbwP");



var $T5IcR = parcelRequire("T5IcR");


var $8nGP5 = parcelRequire("8nGP5");


var $83348bebf1460cdb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $83348bebf1460cdb$export$9d5f8324718c22d1 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    const pdfRef = (0, $8nGP5.useRef)(null);
    const [pdfViewer, setPdfViewer] = (0, $8nGP5.useState)(null);
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const searchedTerms = (0, $8nGP5.useRef)([]);
    (0, $8nGP5.useEffect)(()=>{
        uiStore.resetViewerRequests();
    }, []);
    (0, $8nGP5.useEffect)(()=>{
        // @ts-ignore
        if (!window.AdobeDC) return;
        if (pdfRef.current == null) return;
        const pdfFile = (0, $T5IcR.toJS)(props.pdfUrl);
        const companyName = (0, $T5IcR.toJS)(props.title_display);
        if (!pdfFile || pdfFile == '') return;
        //LOCALHOST KEY 95c70d4882b846f7899dbcd35e0ce896
        const isLocalhost = window.location.href.indexOf('localhost') > -1;
        var localhost_key = '2042181d883b4bddaabbc5930d48b302';
        var pdf_key = isLocalhost ? localhost_key : (0, $3d79bba9fc178656$export$b3611e87cd5ba6ce)().pdfViewerKey;
        // @ts-ignore
        var adobeDCView = new AdobeDC.View({
            clientId: pdf_key,
            divId: 'adobe-dc-view'
        });
        var previewFilePromise = adobeDCView.previewFile({
            content: {
                location: {
                    url: pdfFile
                }
            },
            metaData: {
                fileName: companyName
            }
        }, {
            embedMode: 'FULL_WINDOW',
            enableFormFilling: false,
            showAnnotationTools: false,
            showZoomControl: true,
            defaultViewMode: 'FIT_PAGE',
            focusOnRendering: false
        });
        previewFilePromise.then((adobeViewer)=>{
            setPdfViewer(adobeViewer);
        });
    }, [
        pdfRef,
        props.pdfUrl,
        props.title_display
    ]);
    (0, $8nGP5.useEffect)(function processPdfRequest() {
        const { page: page, highlightTexts: highlightTexts } = uiStore.pdfRequest;
        const clearTerms = ()=>{
            for(const i in searchedTerms.current){
                const term = searchedTerms.current[i];
                term.clear();
            }
        };
        searchedTerms.current = [];
        const doSearch = ()=>$83348bebf1460cdb$var$__awaiter(this, void 0, void 0, function*() {
                if (highlightTexts.length > 0 && pdfViewer != null) {
                    const api = yield pdfViewer.getAPIs();
                    for(const i in highlightTexts){
                        const term = highlightTexts[i];
                        const highlightRet = yield api.search(term);
                        searchedTerms.current.push(term);
                    }
                }
            });
        const gotoPage = ()=>$83348bebf1460cdb$var$__awaiter(this, void 0, void 0, function*() {
                if (page != -1 && pdfViewer != null) pdfViewer.getAPIs().then((apis)=>{
                    apis.gotoLocation(page, 0, 0).then((result)=>console.log(result)).catch((error)=>console.log(error));
                });
            });
        function doWork() {
            return $83348bebf1460cdb$var$__awaiter(this, void 0, void 0, function*() {
                gotoPage();
                if (highlightTexts.length > 0) yield doSearch();
                gotoPage();
            });
        }
        doWork();
    }, [
        uiStore.pdfRequest
    ]);
    return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        fillCell: true,
        children: (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
            shadow: true,
            children: (0, $kSbwP.jsx)("div", {
                ref: pdfRef,
                id: "adobe-dc-view",
                className: "pdf-viewer",
                style: {
                    zIndex: 6000,
                    borderRadius: '20px'
                }
            })
        })
    });
});




var $kSbwP = parcelRequire("kSbwP");







var $fgQ0V = parcelRequire("fgQ0V");



var $4bdb7d1d6cbc10d4$export$637f169d296cfe12;
$4bdb7d1d6cbc10d4$export$637f169d296cfe12 = `mE7S0q_panelTableStyle`;




const $3ffe40629fb9765e$export$a470e850d1c2e97c = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
    const getCustomersTable = ()=>{
        const customers = query.top_customers;
        if (!customers) return null;
        const colPercent = {
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent,
            overrideFormatting: (0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)
        };
        const rowDefaults = {
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            formatter: (data)=>(0, $1ac83566e6b5504b$export$40333d0facc9092d)(data.toString())
        };
        const getYearRange = ()=>{
            const years = [];
            for (const customer of customers)for(const k in customer.revenue){
                const e = customer.revenue[k];
                if (e.year > 0 && years.includes(e.year) === false) years.push(e.year);
            }
            return {
                minYear: (0, $fgQ0V.min)(years),
                maxYear: (0, $fgQ0V.max)(years)
            };
        };
        const ALL_YEAR_CUSTOMER_INDEX = -1;
        const { minYear: minYear, maxYear: maxYear } = getYearRange();
        const customerOrder = customers.map((c, index)=>({
                name: c.name,
                index: index
            })).sort((a, b)=>{
            var _a, _b;
            const aRev = (_a = customers[a.index]['revenue'].find((e)=>e.year === maxYear)) === null || _a === void 0 ? void 0 : _a.revenue;
            const bRev = (_b = customers[b.index]['revenue'].find((e)=>e.year === maxYear)) === null || _b === void 0 ? void 0 : _b.revenue;
            if (aRev === undefined || bRev === undefined) return 0;
            return bRev - aRev; // Sort by revenue in descending order
        }).map((c)=>c.index);
        customerOrder.push(ALL_YEAR_CUSTOMER_INDEX);
        const cols_customers = [];
        for(let i = minYear; i <= maxYear; i++){
            cols_customers.push({
                column: {
                    source: i.toString(),
                    display: i.toString()
                }
            });
            cols_customers.push(Object.assign({
                column: {
                    source: i.toString(),
                    display: '%'
                },
                overrideValue: (field, column)=>{
                    const year = parseInt(column.source);
                    const customerIndex = parseInt(field.source);
                    var rev = getCustomerRevenue(customerIndex, year);
                    var totalRev = query.valueByYear('net_revenue_per_year', year);
                    if (totalRev == 'N/A' || rev == 0) return '-';
                    return rev / totalRev;
                }
            }, colPercent));
        }
        cols_customers.push({
            header: (col)=>{
                return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    fillCell: true,
                    justify: "start",
                    children: col.column.display
                });
            },
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            dontUseRowFormatting: true,
            overrideValue: (field, column)=>{
                const customerIndex = parseInt(field.source);
                const customer = customers[customerIndex];
                if (!customer) return [];
                return customer.page_sources;
            }
        });
        const getCustomerRevenue = (customerIndex, year)=>{
            var _a, _b;
            if (customerIndex === ALL_YEAR_CUSTOMER_INDEX) return (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V)))(customers).flatMap((c)=>c.revenue).filter((e)=>e.year === year).reduce((acc, e)=>acc + (e.revenue || 0), 0);
            const customer = customers[customerIndex];
            if (!customer) return 0;
            return (_b = (_a = customer.revenue.find((e)=>e.year === year)) === null || _a === void 0 ? void 0 : _a.revenue) !== null && _b !== void 0 ? _b : 0;
        };
        const rows_customers = [];
        for(let i in customerOrder){
            const customerIndex = customerOrder[i];
            const customerName = customerIndex == ALL_YEAR_CUSTOMER_INDEX ? 'Totals' : customers[customerIndex].name;
            const row = Object.assign({
                field: {
                    source: customerIndex.toString(),
                    display: customerName
                },
                value: (field, column)=>{
                    const year = parseInt(column.source);
                    const customerIndex = parseInt(field.source);
                    var rev = getCustomerRevenue(customerIndex, year);
                    if (rev == 0) return '-';
                    return rev;
                }
            }, rowDefaults);
            rows_customers.push(row);
        }
        return (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
            className: $4bdb7d1d6cbc10d4$export$637f169d296cfe12,
            topLeftCellText: "($ in Millions)",
            columns: cols_customers,
            rows: rows_customers,
            disable_round_edges: true,
            onEditField: (row, column, newValue, rowIndex)=>{
                console.log('Edit field', row, column, newValue, rowIndex);
            }
        });
    };
    const getTopCustomersRevenueGroup = ()=>{
        const colPercent = {
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent,
            overrideFormatting: (0, $1ac83566e6b5504b$export$23be700726d3a499)
        };
        const rowDefaults = {
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            formatter: (data)=>(0, $1ac83566e6b5504b$export$40333d0facc9092d)(data.toString()),
            editable: true
        };
        const getYearRange = ()=>{
            const reportYear = query.actualYear() || new Date().getFullYear();
            return {
                minYear: reportYear - 2,
                maxYear: reportYear + 1
            };
        };
        const { minYear: minYear, maxYear: maxYear } = getYearRange();
        const cols_top_rev_by_year = [];
        for(let i = minYear; i <= maxYear; i++)cols_top_rev_by_year.push(Object.assign({
            column: {
                source: i.toString(),
                display: `${i}`
            }
        }, colPercent));
        cols_top_rev_by_year.push({
            header: (col)=>{
                return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    fillCell: true,
                    justify: "start",
                    children: col.column.display
                });
            },
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            dontUseRowFormatting: true,
            overrideValue: (field, column)=>{
                const groupSources = query.sources(field, column);
                if (groupSources.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).uniq(query.top_customers.flatMap((c)=>c.page_sources));
                return groupSources;
            }
        });
        const getTopCustomerRevenueShare = (customersCount)=>{
            return (field, column)=>{
                const year = parseInt(column.source);
                const val = query.valueByYear(field.source, year);
                if (val === 'N/A') //If not available we try to calc based on customers
                {
                    if (query.top_customers) {
                        const totalRevTopCustomers = query.top_customers.flatMap((c)=>c.revenue).filter((e)=>e.year === year).sort((a, b)=>(b.revenue || 0) - (a.revenue || 0)).slice(0, customersCount);
                        if (totalRevTopCustomers.find((e)=>e.revenue === 0)) return 'N/A';
                        const isMinimumCustomersCount = totalRevTopCustomers.length >= customersCount;
                        if (!isMinimumCustomersCount) return 'N/A';
                        const finalTotalRevenue = totalRevTopCustomers.reduce((acc, e)=>acc + (e.revenue || 0), 0);
                        const totalRev = query.valueByYear('net_revenue_per_year', year);
                        if (totalRev === 'N/A' || totalRev === 0 || finalTotalRevenue === 0) return 'N/A';
                        return (finalTotalRevenue / totalRev * 100).toFixed(2);
                    }
                }
                return val;
            };
        };
        const rows_top_10_customers = [
            Object.assign({
                field: {
                    source: 'top_1_customers_revenue_percentage',
                    display: 'Top 1 Customers Revenue %'
                },
                value: getTopCustomerRevenueShare(1)
            }, rowDefaults),
            Object.assign({
                field: {
                    source: 'top_10_customers_revenue_percentage',
                    display: 'Top 10 Customers Revenue %'
                },
                value: getTopCustomerRevenueShare(10)
            }, rowDefaults)
        ];
        return (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
            className: $4bdb7d1d6cbc10d4$export$637f169d296cfe12,
            topLeftCellText: "",
            columns: cols_top_rev_by_year,
            rows: rows_top_10_customers,
            onEditField: (0, $b8332ea8355e1651$export$ecde49fefbe76021)
        });
    };
    const customersTable = getCustomersTable();
    const topCustomersTable = getTopCustomersRevenueGroup();
    const icon = (0, $3d82e178f5213798$export$ef2b607153f69518)('concentration');
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
            children: [
                (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                    title: "Customers",
                    iconUrl: icon
                }),
                store.showAdminConsole && customersTable,
                topCustomersTable
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");







var $fgQ0V = parcelRequire("fgQ0V");





const $e6d261c3e5883ed7$export$4de8da231a32af27 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
    const getCompanyAcquisitionsTable = ()=>{
        const acquisitions = query.company_acquisitions;
        if (!acquisitions) return null;
        const rowDefaults = {
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            formatter: (data)=>(0, $1ac83566e6b5504b$export$40333d0facc9092d)(data.toString())
        };
        const getYearRange = ()=>{
            const years = [];
            for (const customer of acquisitions)for(const k in customer.ebitda){
                const e = customer.ebitda[k];
                if (e.year > 0 && years.includes(e.year) === false) years.push(e.year);
            }
            return {
                minYear: (0, $fgQ0V.min)(years),
                maxYear: (0, $fgQ0V.max)(years)
            };
        };
        const ALL_YEAR_CUSTOMER_INDEX = -1;
        const { minYear: minYear, maxYear: maxYear } = getYearRange();
        const customerOrder = acquisitions.map((c, index)=>({
                name: c.name,
                index: index
            })).sort((a, b)=>{
            var _a, _b;
            const aEbitda = (_a = acquisitions[a.index]['ebitda'].find((e)=>e.year === maxYear)) === null || _a === void 0 ? void 0 : _a.ebitda;
            const bEbitda = (_b = acquisitions[b.index]['ebitda'].find((e)=>e.year === maxYear)) === null || _b === void 0 ? void 0 : _b.ebitda;
            if (aEbitda === undefined || bEbitda === undefined) return 0;
            return bEbitda - aEbitda; // Sort by revenue in descending order
        }).map((c)=>c.index);
        customerOrder.push(ALL_YEAR_CUSTOMER_INDEX);
        const cols_companies_bought = [];
        for(let i = minYear; i <= maxYear; i++)cols_companies_bought.push({
            column: {
                source: i.toString(),
                display: i.toString()
            }
        });
        cols_companies_bought.push({
            header: (col)=>{
                return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    fillCell: true,
                    justify: "start",
                    children: col.column.display
                });
            },
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            dontUseRowFormatting: true,
            overrideValue: (field, column)=>{
                return []; //Not done yet
            }
        });
        const getCustomerEbitda = (customerIndex, year)=>{
            var _a, _b;
            if (customerIndex === ALL_YEAR_CUSTOMER_INDEX) return (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V)))(acquisitions).flatMap((c)=>c.ebitda).filter((e)=>e.year === year).reduce((acc, e)=>acc + (e.ebitda || 0), 0);
            const customer = acquisitions[customerIndex];
            if (!customer) return 0;
            return (_b = (_a = customer.ebitda.find((e)=>e.year === year)) === null || _a === void 0 ? void 0 : _a.ebitda) !== null && _b !== void 0 ? _b : 0;
        };
        const rows_customers = [];
        for(let i in customerOrder){
            const customerIndex = customerOrder[i];
            const customerName = customerIndex == ALL_YEAR_CUSTOMER_INDEX ? 'Totals' : acquisitions[customerIndex].name;
            const row = Object.assign({
                field: {
                    source: customerIndex.toString(),
                    display: customerName
                },
                value: (field, column)=>{
                    const year = parseInt(column.source);
                    const customerIndex = parseInt(field.source);
                    var rev = getCustomerEbitda(customerIndex, year);
                    if (rev == 0) return '-';
                    return rev;
                }
            }, rowDefaults);
            rows_customers.push(row);
        }
        return (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
            topLeftCellText: "($ in Millions)",
            columns: cols_companies_bought,
            rows: rows_customers,
            disable_round_edges: true,
            onEditField: (row, column, newValue, rowIndex)=>{
                console.log('Edit field', row, column, newValue, rowIndex);
            }
        });
    };
    const getAcquisitionTablePerYear = ()=>{
        const rowDefaults = {
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            formatter: (data)=>(0, $1ac83566e6b5504b$export$40333d0facc9092d)(data.toString()),
            editable: true
        };
        const rowPercentDefaults = {
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            formatter: (data)=>(0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)(data.toString()),
            editable: false
        };
        const getYearRange = ()=>{
            const reportYear = query.actualYear() || new Date().getFullYear();
            return {
                minYear: reportYear - 2,
                maxYear: reportYear + 1
            };
        };
        const { minYear: minYear, maxYear: maxYear } = getYearRange();
        const cols_acquisition_per_year = [];
        for(let i = minYear; i <= maxYear; i++)cols_acquisition_per_year.push({
            column: {
                source: i.toString(),
                display: `${i}`
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).dollar
        });
        cols_acquisition_per_year.push({
            header: (col)=>{
                return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    fillCell: true,
                    justify: "start",
                    children: col.column.display
                });
            },
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            dontUseRowFormatting: true,
            overrideValue: (field, column)=>{
                const groupSources = query.sources(field, column);
                if (groupSources.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).uniq(query.top_customers.flatMap((c)=>c.page_sources));
                return groupSources;
            }
        });
        const getAcquisitionEbitdaPerYear = (field, column)=>{
            const year = parseInt(column.source);
            const val = query.valueByYear('acquisition_ebitda_per_year', year);
            if (val === 'N/A') //If not available we try to calc based on entires in
            {
                if (query.company_acquisitions) {
                    const totalEbitdaAcquisitions = query.company_acquisitions.flatMap((c)=>c.ebitda).filter((e)=>e.year === year);
                    const finalTotalEbitda = totalEbitdaAcquisitions.reduce((acc, e)=>acc + (e.ebitda || 0), 0);
                    if (finalTotalEbitda === 0) return 'N/A';
                    return finalTotalEbitda.toFixed(2);
                }
            }
            return val;
        };
        const row_acquisition_per_year = [
            Object.assign({
                field: {
                    source: 'acquisition_ebitda_per_year',
                    display: 'Total Acquisitions EBITDA'
                },
                value: getAcquisitionEbitdaPerYear
            }, rowDefaults),
            Object.assign({
                field: {
                    source: null,
                    display: 'Total Acquisitions EBITDA % of EBITDA'
                },
                value: (data, column)=>{
                    const acqEbitda = getAcquisitionEbitdaPerYear(data, column);
                    if (acqEbitda === 'N/A') return 'N/A';
                    const year = parseInt(column.source);
                    const ebitdaPerYear = query.valueByYear('adjusted_ebitda_per_year', year);
                    if (ebitdaPerYear === 'N/A') return 'N/A';
                    const percent = parseFloat(acqEbitda) / parseFloat(ebitdaPerYear);
                    return percent;
                }
            }, rowPercentDefaults)
        ];
        return (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
            topLeftCellText: "",
            columns: cols_acquisition_per_year,
            rows: row_acquisition_per_year,
            onEditField: (0, $b8332ea8355e1651$export$ecde49fefbe76021)
        });
    };
    const companyAcquisitions = getCompanyAcquisitionsTable();
    const acquisitionsTotal = getAcquisitionTablePerYear();
    const icon = (0, $3d82e178f5213798$export$ef2b607153f69518)('concentration');
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
            children: [
                (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                    title: "Acquisitions EBITDA",
                    iconUrl: icon
                }),
                store.showAdminConsole && companyAcquisitions,
                acquisitionsTotal
            ]
        })
    });
});


const $cb32edb7d568785b$export$a65eea1eaa5f8fa3 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const q = store.query;
    const nav = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const showBeta = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)().showBetaFeatures;
    (0, $8nGP5.useEffect)(function auditReportView() {
        (0, $b2432f43c421c848$export$7a667d08ed65fa47)().store_audit_entry('VIEW_PAGE_DEAL', {
            page: 'DealView',
            deal_id: store.selectedReportId,
            url: window.location.href
        });
    }, [
        store.selectedReportId
    ]);
    if (!store.query) return null;
    const pdfUrl = store.query.value('pdf');
    const companyName = store.query.value('company_name');
    return (0, $kSbwP.jsxs)((0, $9583d2c91dbe771f$export$3ccee0cf1acf5f70), {
        spaceBetween: 12,
        children: [
            (0, $kSbwP.jsx)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                enableHideScrollUntilMouseOver: true,
                children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "column",
                    style: {
                        gap: '20px',
                        position: 'relative'
                    },
                    children: [
                        (0, $kSbwP.jsx)((0, $9f7291a9219114ca$export$8a60f67e01e6fb31), {}),
                        showBeta && (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
                            children: [
                                (0, $kSbwP.jsx)((0, $3ffe40629fb9765e$export$a470e850d1c2e97c), {}),
                                (0, $kSbwP.jsx)((0, $e6d261c3e5883ed7$export$4de8da231a32af27), {})
                            ]
                        }),
                        (0, $kSbwP.jsx)((0, $b1fe1211f58e7da7$export$5b854e326c825364), {}),
                        (0, $kSbwP.jsx)((0, $79da148714874de1$export$58cad4665f64d293), {})
                    ]
                })
            }),
            (0, $kSbwP.jsx)((0, $83348bebf1460cdb$export$9d5f8324718c22d1), {
                pdfUrl: q.pdfViewUrl,
                title_display: q.companyName
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");












var $kSbwP = parcelRequire("kSbwP");


var $e6db7b46041a73ca$export$2d85d542e52be912;
var $e6db7b46041a73ca$export$2704a0b14f0ac358;
var $e6db7b46041a73ca$export$d2c0f94b95255e43;
var $e6db7b46041a73ca$export$b0da26f11a7d688b;
var $e6db7b46041a73ca$export$134f3e5d09df31a8;
var $e6db7b46041a73ca$export$1237798dc640739a;
var $e6db7b46041a73ca$export$479c4ede0cd2ddba;
var $e6db7b46041a73ca$export$3640fc85e5cb69d6;
var $e6db7b46041a73ca$export$cbaa55241f9795b8;
var $e6db7b46041a73ca$export$51758937339cdf8a;
var $e6db7b46041a73ca$export$d990f29413e4836c;
var $e6db7b46041a73ca$export$bb4532791996264d;
var $e6db7b46041a73ca$export$af5728fd7085c3ad;
var $e6db7b46041a73ca$export$268c0241a24ad0ec;
var $e6db7b46041a73ca$export$a52b030935ae9ca9;
var $e6db7b46041a73ca$export$4e6f96734dfe12f4;
var $e6db7b46041a73ca$export$c4b341013b576107;
var $e6db7b46041a73ca$export$b92f1b4ea687fd3d;
var $e6db7b46041a73ca$export$baf8e363c9bd46ec;
var $e6db7b46041a73ca$export$64c36945836d3acb;
$e6db7b46041a73ca$export$2d85d542e52be912 = `mh-S_q_centerLabel`;
$e6db7b46041a73ca$export$2704a0b14f0ac358 = `mh-S_q_edgeLine`;
$e6db7b46041a73ca$export$d2c0f94b95255e43 = `mh-S_q_edgeLineGreen`;
$e6db7b46041a73ca$export$b0da26f11a7d688b = `mh-S_q_edgeLineRed`;
$e6db7b46041a73ca$export$134f3e5d09df31a8 = `mh-S_q_grayFilter`;
$e6db7b46041a73ca$export$1237798dc640739a = `mh-S_q_label`;
$e6db7b46041a73ca$export$479c4ede0cd2ddba = `mh-S_q_leftLabel`;
$e6db7b46041a73ca$export$3640fc85e5cb69d6 = `mh-S_q_middleLabel`;
$e6db7b46041a73ca$export$cbaa55241f9795b8 = `mh-S_q_rightLabel`;
$e6db7b46041a73ca$export$51758937339cdf8a = `mh-S_q_scoreLine`;
$e6db7b46041a73ca$export$d990f29413e4836c = `mh-S_q_scoreLineContainer`;
$e6db7b46041a73ca$export$bb4532791996264d = `mh-S_q_scoreLineEntry`;
$e6db7b46041a73ca$export$af5728fd7085c3ad = `mh-S_q_scoreLineGreaterThan`;
$e6db7b46041a73ca$export$268c0241a24ad0ec = `mh-S_q_scoreLineRangedGradient`;
$e6db7b46041a73ca$export$a52b030935ae9ca9 = `mh-S_q_textEntry`;
$e6db7b46041a73ca$export$4e6f96734dfe12f4 = `mh-S_q_tooltip`;
$e6db7b46041a73ca$export$c4b341013b576107 = `mh-S_q_tooltipGreen`;
$e6db7b46041a73ca$export$b92f1b4ea687fd3d = `mh-S_q_tooltipRed`;
$e6db7b46041a73ca$export$baf8e363c9bd46ec = `mh-S_q_tooltipYellow`;
$e6db7b46041a73ca$export$64c36945836d3acb = `mh-S_q_tooltip_tip`;


const $21ac4e76fef0eb4d$export$7a5a0d6d8fafcf23 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const disp = p.display;
    //score range is 0 to 1
    //0 - 0.15 IS under - > right in center no scaling
    //0.15 - 0.85 is in range -> scale to 0 - 1
    //0.85 - 1 is over -> right in center no scaling
    const edge = 0.1; //Note CSS also defined this value as --edge-range: 10%;
    const halfEdge = edge / 2;
    var tooltipColor = null;
    const noCls = $e6db7b46041a73ca$export$b92f1b4ea687fd3d;
    const yesCls = $e6db7b46041a73ca$export$c4b341013b576107;
    const entries = p.entries.map((entry, i)=>{
        var classTooltip = null;
        var posX = -1;
        const r = p.rule;
        var dist = (entry.rawValue - r.range[0]) / (r.range[1] - r.range[0]);
        if (dist > 1.1) posX = 1 - halfEdge;
        else if (dist < 0.0) posX = halfEdge;
        else posX = edge + dist * (1 - edge * 2);
        if (!entry.didScore) classTooltip = noCls;
        else classTooltip = yesCls;
        //}
        const posXStr = (posX * 100).toFixed(0).toString() + '%';
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$bb4532791996264d, classTooltip, $e6db7b46041a73ca$export$64c36945836d3acb);
        return (0, $kSbwP.jsx)("div", {
            className: cls,
            style: {
                left: posXStr
            },
            children: disp.value
        }, i);
    });
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$51758937339cdf8a, $e6db7b46041a73ca$export$af5728fd7085c3ad, p.className);
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsx)("div", {
            className: $e6db7b46041a73ca$export$d990f29413e4836c,
            children: (0, $kSbwP.jsxs)("div", {
                className: cls,
                children: [
                    (0, $kSbwP.jsxs)("div", {
                        className: $e6db7b46041a73ca$export$3640fc85e5cb69d6,
                        children: [
                            '>',
                            " ",
                            disp.center
                        ]
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$479c4ede0cd2ddba,
                        children: disp.min
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$cbaa55241f9795b8,
                        children: disp.max
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$d2c0f94b95255e43
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$b0da26f11a7d688b
                    }),
                    entries
                ]
            })
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");



const $fdaccb990ee1a680$export$3422dd3ad07f2311 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const minValue = p.display.min;
    const maxValue = p.display.max;
    const valDisplay = p.display.value;
    //score range is 0 to 1
    //0 - 0.15 IS under - > right in center no scaling
    //0.15 - 0.85 is in range -> scale to 0 - 1
    //0.85 - 1 is over -> right in center no scaling
    const edge = 0.1; //Note CSS also defined this value as --edge-range: 10%;
    const halfEdge = edge / 2;
    var tooltipColor = null;
    const redCls = $e6db7b46041a73ca$export$b92f1b4ea687fd3d;
    const yellowCls = $e6db7b46041a73ca$export$baf8e363c9bd46ec;
    const greenCls = $e6db7b46041a73ca$export$c4b341013b576107;
    const entries = p.entries.map((entry, i)=>{
        var classTooltip = null;
        var posX = -1;
        if (entry.type == 'under') {
            posX = halfEdge;
            classTooltip = redCls;
        } else if (entry.type == 'over') {
            posX = 1 - halfEdge;
            classTooltip = greenCls;
        } else {
            posX = edge + entry.score * (1 - edge * 2);
            classTooltip = null;
            var scoreInt = parseInt((entry.score * 100).toString());
            if (scoreInt > 85) classTooltip = greenCls;
            else if (scoreInt > 55) classTooltip = yellowCls;
            else classTooltip = redCls;
        }
        const posXStr = (posX * 100).toFixed(0).toString() + '%';
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$bb4532791996264d, classTooltip, $e6db7b46041a73ca$export$64c36945836d3acb);
        return (0, $kSbwP.jsx)("div", {
            className: cls,
            style: {
                left: posXStr
            },
            children: valDisplay
        }, i);
    });
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$51758937339cdf8a, $e6db7b46041a73ca$export$268c0241a24ad0ec, p.className);
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsx)("div", {
            className: $e6db7b46041a73ca$export$d990f29413e4836c,
            children: (0, $kSbwP.jsxs)("div", {
                className: cls,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$479c4ede0cd2ddba,
                        children: minValue
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$cbaa55241f9795b8,
                        children: maxValue
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$2d85d542e52be912,
                        children: p.display.centerText
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$d2c0f94b95255e43
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$b0da26f11a7d688b
                    }),
                    entries
                ]
            })
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");



const $5c49efab054a1b57$export$82045baefac896dc = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$51758937339cdf8a);
    const noCls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$a52b030935ae9ca9, $e6db7b46041a73ca$export$b92f1b4ea687fd3d, {
        [$e6db7b46041a73ca$export$134f3e5d09df31a8]: p.didScore === null || p.didScore === true
    });
    const yesCls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$a52b030935ae9ca9, $e6db7b46041a73ca$export$c4b341013b576107, {
        [$e6db7b46041a73ca$export$134f3e5d09df31a8]: p.didScore === null || p.didScore === false
    });
    const yesTooltip = (0, $kSbwP.jsx)("div", {
        className: yesCls,
        style: {
            left: '60%'
        },
        children: "YES"
    });
    const noTooltip = (0, $kSbwP.jsx)("div", {
        className: noCls,
        style: {
            left: '40%'
        },
        children: "NO"
    });
    const classContainer = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$d990f29413e4836c, p.className);
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)("div", {
            className: classContainer,
            children: [
                yesTooltip,
                noTooltip
            ]
        })
    });
});




var $da302f328e83b849$export$a38dc554151ff661;
var $da302f328e83b849$export$42e4a6ed1eb5a52e;
var $da302f328e83b849$export$5c219a65934d4b9c;
var $da302f328e83b849$export$e730f6987ad4283b;
var $da302f328e83b849$export$41fc6278a3c14d73;
var $da302f328e83b849$export$2f9904c7e241cf9;
var $da302f328e83b849$export$6633e83f4afff9ea;
var $da302f328e83b849$export$637f169d296cfe12;
var $da302f328e83b849$export$daaf31466ad29ead;
var $da302f328e83b849$export$9ba80d992c64273b;
var $da302f328e83b849$export$4087c73cbd989252;
var $da302f328e83b849$export$45f85e82cb24606f;
$da302f328e83b849$export$a38dc554151ff661 = `nyntOq_companyHeaderElement`;
$da302f328e83b849$export$42e4a6ed1eb5a52e = `nyntOq_companyLogo`;
$da302f328e83b849$export$5c219a65934d4b9c = `nyntOq_companyNameLabel`;
$da302f328e83b849$export$e730f6987ad4283b = `nyntOq_dealThumbScore`;
$da302f328e83b849$export$41fc6278a3c14d73 = `nyntOq_noDataAvail`;
$da302f328e83b849$export$2f9904c7e241cf9 = `nyntOq_notScoredGray`;
$da302f328e83b849$export$6633e83f4afff9ea = `nyntOq_panelTableCompanies`;
$da302f328e83b849$export$637f169d296cfe12 = `nyntOq_panelTableStyle`;
$da302f328e83b849$export$daaf31466ad29ead = `nyntOq_panelTitle`;
$da302f328e83b849$export$9ba80d992c64273b = `nyntOq_panelTitleText`;
$da302f328e83b849$export$4087c73cbd989252 = `nyntOq_sectionIcon`;
$da302f328e83b849$export$45f85e82cb24606f = `nyntOq_showNonUsedCheckbox`;



var $8nGP5 = parcelRequire("8nGP5");

const $36c6fce940b0e7aa$export$210595a4b4a710d0 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const [showNonUsed, setShowNonUsed] = (0, $8nGP5.useState)(false);
    if (store.selectedReportId == '' || store.query == null) return null;
    const companyId = store.selectedReportId;
    const q = store.query;
    const scoreUtils = new (0, $9b879bbdd76f7296$export$39c49a915ff7ed37)(q);
    const getLabel = (fieldName)=>{
        const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
        if (e.t == '%') return (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label;
        else return (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label;
    };
    const getFormatter = (fieldName)=>{
        const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
        if (e.t == '%') {
            if (e.scale == 100) return 0, $1ac83566e6b5504b$export$23be700726d3a499;
            return 0, $1ac83566e6b5504b$export$32e6b1ae352e94d6;
        } else if (e.t == 'bool') return null;
        else return 0, $1ac83566e6b5504b$export$40333d0facc9092d;
    };
    var scoreStore = (0, $9b879bbdd76f7296$export$5bbef306d29b8236)();
    const fieldsGroup = scoreStore.SCORE_FIELDS_GROUPS;
    const getSectionIdAndFieldNameByRow = (row)=>{
        const split = row.source.split('.');
        const sectionId = split[0];
        const fieldName = split[1];
        return {
            sectionId: sectionId,
            fieldName: fieldName
        };
    };
    const getRuleData = (row)=>{
        const { sectionId: sectionId, fieldName: fieldName } = getSectionIdAndFieldNameByRow(row);
        const rule = (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_score_rule_by_fieldname(sectionId, fieldName);
        const rawValue = scoreUtils.get_extended_float_for_scoring(rule);
        var ruleScore = 0;
        var isUsed = false;
        if (scoreUtils.is_rule_used_for_scoring(rule)) {
            ruleScore = scoreUtils.do_rule_score(rule);
            isUsed = true;
        }
        const scoreWeight = scoreUtils.get_rule_weight(sectionId, rule);
        return {
            sectionId: sectionId,
            fieldName: fieldName,
            val: rawValue,
            rule: rule,
            ruleScore: ruleScore,
            scoreWeight: scoreWeight,
            isUsed: isUsed
        };
    };
    const getRangedScore = (data)=>{
        var _a;
        const { val: val, rule: rule, ruleScore: ruleScore, fieldName: fieldName } = data;
        const isScored = scoreUtils.is_rule_used_for_scoring(rule);
        var scoreEntries = [];
        var cls = '';
        if (isScored) {
            const score_not_scaled = scoreUtils.do_rule_score(rule, false);
            var scoreType = 'in-range';
            if (score_not_scaled > 1) scoreType = 'over';
            else if (score_not_scaled < 0) scoreType = 'under';
            const scoreEntry = {
                score: ruleScore,
                type: scoreType
            };
            scoreEntries.push(scoreEntry);
        } else cls = $da302f328e83b849$export$2f9904c7e241cf9;
        const formatter = (_a = getFormatter(fieldName)) !== null && _a !== void 0 ? _a : (0, $1ac83566e6b5504b$export$8c8c9051f21dcdc2);
        return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
            children: (0, $kSbwP.jsx)((0, $fdaccb990ee1a680$export$3422dd3ad07f2311), {
                className: cls,
                entries: scoreEntries,
                display: {
                    min: formatter(rule.range[rule.inverse_score ? 1 : 0]),
                    max: formatter(rule.range[rule.inverse_score ? 0 : 1]),
                    centerText: rule.inverse_score ? '(lower is better)' : '',
                    value: formatter(val)
                }
            })
        });
    };
    const getBooleanScore = (data)=>{
        const { ruleScore: ruleScore } = data;
        var didScore = null;
        if (data.isUsed) didScore = ruleScore > 0;
        return (0, $kSbwP.jsx)((0, $5c49efab054a1b57$export$82045baefac896dc), {
            didScore: didScore
        });
    };
    const getGreaterThanScore = (data)=>{
        var _a;
        const { val: val, rule: rule, ruleScore: ruleScore, fieldName: fieldName } = data;
        const entries = [];
        var cls = '';
        if (data.isUsed) {
            const scoreEntry = {
                didScore: ruleScore > 0,
                rawValue: val
            };
            entries.push(scoreEntry);
        } else cls = $da302f328e83b849$export$2f9904c7e241cf9;
        const formatter = (_a = getFormatter(fieldName)) !== null && _a !== void 0 ? _a : (0, $1ac83566e6b5504b$export$8c8c9051f21dcdc2);
        var threshold_label = formatter(rule.threshold);
        if (rule.threshold_display != null) threshold_label = rule.threshold_display;
        return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
            children: (0, $kSbwP.jsx)((0, $21ac4e76fef0eb4d$export$7a5a0d6d8fafcf23), {
                className: cls,
                rule: rule,
                entries: entries,
                display: {
                    center: threshold_label,
                    min: formatter(rule.range[0]),
                    max: formatter(rule.range[1]),
                    value: formatter(val)
                }
            })
        });
    };
    const columns = [
        {
            column: {
                source: null,
                display: 'Score Visualized'
            },
            overrideValue: (row, col)=>{
                return null;
            },
            element: (row, col, data)=>{
                const ruleData = getRuleData(row.field);
                if (ruleData.val == 'N/A' && !showNonUsed) return null;
                const t = ruleData.rule.check;
                var el = null;
                if (t == 'range') el = getRangedScore(ruleData);
                else if (t == 'greater_than') el = getGreaterThanScore(ruleData);
                else if (t == 'boolean') el = getBooleanScore(ruleData);
                return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    justify: "center",
                    alignItems: "center",
                    fillCell: true,
                    children: el
                });
            }
        },
        {
            column: {
                source: null,
                display: 'Percentile'
            },
            overrideValue: (row, col)=>{
                const { ruleScore: ruleScore, isUsed: isUsed } = getRuleData(row);
                if (!isUsed) return '-';
                return ruleScore != null ? (0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)(ruleScore) : '-';
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value
        },
        {
            column: {
                source: null,
                display: 'Weight'
            },
            overrideValue: (row, col)=>{
                const { scoreWeight: scoreWeight, ruleScore: ruleScore, isUsed: isUsed } = getRuleData(row);
                if (!isUsed) return '-';
                return `${(0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)(ruleScore * scoreWeight).replace('%', '')}/${(0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)(scoreWeight)}`;
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent
        }
    ];
    const fieldsToRows = (group)=>{
        var rows = [];
        group.fields.forEach((fieldName)=>{
            var _a;
            const rule = (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_score_rule_by_fieldname(group.sectionId, fieldName);
            if (rule.check == 'none' || rule.disabled) return;
            if (!scoreUtils.is_rule_used_for_scoring(rule) && !showNonUsed) return;
            const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
            (0, $3d71a0e5fc49a3ca$exports.assert)(e != null, `Field ${fieldName} not found in fieldsNameLookup`);
            var display = e.display;
            if (e.dynDisplay) display = q.formatExtendedValueDisplay(e.dynDisplay);
            if (e.dynDisplayPrefix) {
                const dynDisp = e.dynDisplayPrefix.replace('$DATA_PICK_KEY', (_a = scoreUtils.get_datapick_key_for_rule(rule)) !== null && _a !== void 0 ? _a : 'N/A');
                display = dynDisp + display;
            }
            rows.push({
                field: {
                    source: `${group.sectionId}.${fieldName}`,
                    display: display
                },
                label: getLabel(fieldName)
            });
        });
        return rows;
    };
    const groupTables = fieldsGroup.map((group, i)=>{
        const groupRows = fieldsToRows(group);
        if (groupRows.length == 0) return (0, $kSbwP.jsxs)("div", {
            children: [
                (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
                    title: (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_section_name(group.sectionId),
                    containerClassName: $da302f328e83b849$export$daaf31466ad29ead,
                    className: $da302f328e83b849$export$9ba80d992c64273b,
                    children: (0, $kSbwP.jsx)((0, $3d82e178f5213798$export$ab8815222a429372), {
                        section: group.sectionId,
                        className: $da302f328e83b849$export$4087c73cbd989252
                    })
                }),
                (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    justify: "center",
                    children: (0, $kSbwP.jsx)("div", {
                        className: $da302f328e83b849$export$41fc6278a3c14d73,
                        children: "No Data Available"
                    })
                })
            ]
        }, 'nodata_' + i);
        const sectionWorthIn100 = group.section_worth / scoreUtils.get_max_points_based_on_sections_used() * 100;
        var points = scoreUtils.calcSectionPercentileById(group.sectionId) * sectionWorthIn100;
        if (isNaN(points)) points = 0;
        return (0, $kSbwP.jsxs)("div", {
            children: [
                (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
                    title: `${(0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_section_name(group.sectionId)} (${points.toFixed(0)}/${sectionWorthIn100.toFixed(0)}%)`,
                    containerClassName: $da302f328e83b849$export$daaf31466ad29ead,
                    className: $da302f328e83b849$export$9ba80d992c64273b,
                    children: (0, $kSbwP.jsx)((0, $3d82e178f5213798$export$ab8815222a429372), {
                        section: group.sectionId,
                        className: $da302f328e83b849$export$4087c73cbd989252
                    })
                }),
                (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                    columns: columns,
                    rows: groupRows,
                    disable_round_edges: true,
                    className: $da302f328e83b849$export$637f169d296cfe12
                })
            ]
        }, group.sectionId);
    });
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
            children: [
                (0, $kSbwP.jsx)((0, $d71aa867ac678319$export$2e2bcd8739ae039), {
                    className: $da302f328e83b849$export$45f85e82cb24606f,
                    checked: showNonUsed,
                    onChange: (newState)=>{
                        setShowNonUsed(newState);
                    },
                    label: "Show Inactive Metrics"
                }),
                groupTables
            ]
        })
    });
});




var $kSbwP = parcelRequire("kSbwP");
var $61121807bb170a75$exports = {};
var $ffeab065243932f9$exports = {};
$ffeab065243932f9$exports = new URL("chatgpt.2e7eab8d.svg", import.meta.url).toString();


var $3255f81d6d6079ae$exports = {};
$3255f81d6d6079ae$exports = new URL("sparkle.c93894f3.svg", import.meta.url).toString();


var $99bd3ea26066b3a8$exports = {};
$99bd3ea26066b3a8$exports = new URL("task-checkmark.2563595b.svg", import.meta.url).toString();


var $e0149989efb8f64a$exports = {};
$e0149989efb8f64a$exports = new URL("task-circle.45172d54.svg", import.meta.url).toString();


var $13fe57fa05599ca2$exports = {};
$13fe57fa05599ca2$exports = new URL("task-locked.25b44aaa.svg", import.meta.url).toString();


var $81ca9def391a04c1$exports = {};
$81ca9def391a04c1$exports = new URL("task-paused.9c823c90.svg", import.meta.url).toString();


var $a4f3093fdf52c522$exports = {};
$a4f3093fdf52c522$exports = new URL("task-working.b9e6de61.svg", import.meta.url).toString();


$61121807bb170a75$exports = {
    "chatgpt": $ffeab065243932f9$exports,
    "sparkle": $3255f81d6d6079ae$exports,
    "task-checkmark": $99bd3ea26066b3a8$exports,
    "task-circle": $e0149989efb8f64a$exports,
    "task-locked": $13fe57fa05599ca2$exports,
    "task-paused": $81ca9def391a04c1$exports,
    "task-working": $a4f3093fdf52c522$exports
};


const $8f0ee97a3ff3e474$export$dedbf5c8cc754a98 = (section)=>{
    if (!$61121807bb170a75$exports[section]) return null;
    return $61121807bb170a75$exports[section];
};
const $8f0ee97a3ff3e474$export$f04a61298a47a40f = (p)=>{
    return (0, $kSbwP.jsx)("div", {
        className: p.className,
        children: (0, $kSbwP.jsx)("img", {
            src: $61121807bb170a75$exports[p.icon]
        })
    });
};







var $8nGP5 = parcelRequire("8nGP5");

var $ebCsu = parcelRequire("ebCsu");
parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
function $8a9f11900e15f558$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8a9f11900e15f558$var$_toPropertyKey(arg) {
    var key = $8a9f11900e15f558$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8a9f11900e15f558$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8a9f11900e15f558$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $8a9f11900e15f558$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $8nGP5.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $8nGP5.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $8nGP5.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $8a9f11900e15f558$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $8a9f11900e15f558$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $8a9f11900e15f558$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($8a9f11900e15f558$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $8a9f11900e15f558$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}



var $8nGP5 = parcelRequire("8nGP5");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $0d357fab303a549b$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $0d357fab303a549b$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createContext($0d357fab303a549b$var$$b5e257d569688ac6$var$defaultContext);
const $0d357fab303a549b$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createContext(false);
// This is only used in React < 18.
function $0d357fab303a549b$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $8nGP5.useContext)($0d357fab303a549b$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $0d357fab303a549b$var$$b5e257d569688ac6$var$useCounter(cur === $0d357fab303a549b$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $8nGP5.useState)(true);
    let value = (0, $8nGP5.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $0d357fab303a549b$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $8nGP5.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($0d357fab303a549b$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($0d357fab303a549b$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $0d357fab303a549b$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $0d357fab303a549b$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($0d357fab303a549b$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $0d357fab303a549b$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $0d357fab303a549b$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $0d357fab303a549b$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $8nGP5.useContext)($0d357fab303a549b$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $8nGP5.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $0d357fab303a549b$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $0d357fab303a549b$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $0d357fab303a549b$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $0d357fab303a549b$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $8nGP5.useContext)($0d357fab303a549b$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $0d357fab303a549b$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $0d357fab303a549b$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useId();
    let [didSSR] = (0, $8nGP5.useState)($0d357fab303a549b$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$0d357fab303a549b$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $0d357fab303a549b$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5)))['useId'] === 'function' ? $0d357fab303a549b$var$$b5e257d569688ac6$var$useModernSSRSafeId : $0d357fab303a549b$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $0d357fab303a549b$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $0d357fab303a549b$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $0d357fab303a549b$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $0d357fab303a549b$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5)))['useSyncExternalStore']($0d357fab303a549b$var$$b5e257d569688ac6$var$subscribe, $0d357fab303a549b$var$$b5e257d569688ac6$var$getSnapshot, $0d357fab303a549b$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $8nGP5.useContext)($0d357fab303a549b$var$$b5e257d569688ac6$var$IsSSRContext);
}



var $8nGP5 = parcelRequire("8nGP5");
const $98974a755a399e05$var$TabContext = /*#__PURE__*/ $8nGP5.createContext(null);
var $98974a755a399e05$export$2e2bcd8739ae039 = $98974a755a399e05$var$TabContext;



var $8nGP5 = parcelRequire("8nGP5");
const $b6815e582002ff29$var$SelectableContext = /*#__PURE__*/ $8nGP5.createContext(null);
const $b6815e582002ff29$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $b6815e582002ff29$export$2e2bcd8739ae039 = $b6815e582002ff29$var$SelectableContext;



var $8nGP5 = parcelRequire("8nGP5");




var $kSbwP = parcelRequire("kSbwP");
const $64e8818b41ff2456$var$_excluded = [
    "active",
    "eventKey",
    "mountOnEnter",
    "transition",
    "unmountOnExit",
    "role",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
], $64e8818b41ff2456$var$_excluded2 = [
    "activeKey",
    "getControlledId",
    "getControllerId"
], $64e8818b41ff2456$var$_excluded3 = [
    "as"
];
function $64e8818b41ff2456$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $64e8818b41ff2456$export$fae0121b5afe572d(_ref) {
    let { active: active, eventKey: eventKey, mountOnEnter: mountOnEnter, transition: transition, unmountOnExit: unmountOnExit, role: role = 'tabpanel', onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited } = _ref, props = $64e8818b41ff2456$var$_objectWithoutPropertiesLoose(_ref, $64e8818b41ff2456$var$_excluded);
    const context = (0, $8nGP5.useContext)((0, $98974a755a399e05$export$2e2bcd8739ae039));
    if (!context) return [
        Object.assign({}, props, {
            role: role
        }),
        {
            eventKey: eventKey,
            isActive: active,
            mountOnEnter: mountOnEnter,
            transition: transition,
            unmountOnExit: unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
    const { activeKey: activeKey, getControlledId: getControlledId, getControllerId: getControllerId } = context, rest = $64e8818b41ff2456$var$_objectWithoutPropertiesLoose(context, $64e8818b41ff2456$var$_excluded2);
    const key = (0, $b6815e582002ff29$export$eef49b42fde998a3)(eventKey);
    return [
        Object.assign({}, props, {
            role: role,
            id: getControlledId(eventKey),
            'aria-labelledby': getControllerId(eventKey)
        }),
        {
            eventKey: eventKey,
            isActive: active == null && key != null ? (0, $b6815e582002ff29$export$eef49b42fde998a3)(activeKey) === key : active,
            transition: transition || rest.transition,
            mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
            unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
}
const $64e8818b41ff2456$var$TabPanel = /*#__PURE__*/ $8nGP5.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref)=>{
    let { as: Component = 'div' } = _ref2, props = $64e8818b41ff2456$var$_objectWithoutPropertiesLoose(_ref2, $64e8818b41ff2456$var$_excluded3);
    const [tabPanelProps, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $33ca0dc5077d1d37$export$2e2bcd8739ae039) }] = $64e8818b41ff2456$export$fae0121b5afe572d(props);
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $98974a755a399e05$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $b6815e582002ff29$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)(Component, Object.assign({}, tabPanelProps, {
                    ref: ref,
                    hidden: !isActive,
                    "aria-hidden": !isActive
                }))
            })
        })
    });
});
$64e8818b41ff2456$var$TabPanel.displayName = 'TabPanel';
var $64e8818b41ff2456$export$2e2bcd8739ae039 = $64e8818b41ff2456$var$TabPanel;



var $kSbwP = parcelRequire("kSbwP");
const $852a159ce97d8a68$var$Tabs = (props)=>{
    const { id: userId, generateChildId: generateCustomChildId, onSelect: propsOnSelect, activeKey: propsActiveKey, defaultActiveKey: defaultActiveKey, transition: transition, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, children: children } = props;
    const [activeKey, onSelect] = (0, $8a9f11900e15f558$export$2ee51287a16ca325)(propsActiveKey, defaultActiveKey, propsOnSelect);
    const id = (0, $0d357fab303a549b$export$619500959fc48b26)(userId);
    const generateChildId = (0, $8nGP5.useMemo)(()=>generateCustomChildId || ((key, type)=>id ? `${id}-${type}-${key}` : null), [
        id,
        generateCustomChildId
    ]);
    const tabContext = (0, $8nGP5.useMemo)(()=>({
            onSelect: onSelect,
            activeKey: activeKey,
            transition: transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: (key)=>generateChildId(key, 'tabpane'),
            getControllerId: (key)=>generateChildId(key, 'tab')
        }), [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $98974a755a399e05$export$2e2bcd8739ae039).Provider, {
        value: tabContext,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $b6815e582002ff29$export$2e2bcd8739ae039).Provider, {
            value: onSelect || null,
            children: children
        })
    });
};
$852a159ce97d8a68$var$Tabs.Panel = (0, $64e8818b41ff2456$export$2e2bcd8739ae039);
var $852a159ce97d8a68$export$2e2bcd8739ae039 = $852a159ce97d8a68$var$Tabs;




function $e4afdfae98d48b5f$export$2e2bcd8739ae039(transition) {
    if (typeof transition === 'boolean') return transition ? (0, $fd60cdcd5f9eb8a2$export$2e2bcd8739ae039) : (0, $33ca0dc5077d1d37$export$2e2bcd8739ae039);
    return transition;
}



var $kSbwP = parcelRequire("kSbwP");
const $4912912dcf00204c$var$TabContainer = ({ transition: transition, ...props })=>/*#__PURE__*/ (0, $kSbwP.jsx)((0, $852a159ce97d8a68$export$2e2bcd8739ae039), {
        ...props,
        transition: (0, $e4afdfae98d48b5f$export$2e2bcd8739ae039)(transition)
    });
$4912912dcf00204c$var$TabContainer.displayName = 'TabContainer';
var $4912912dcf00204c$export$2e2bcd8739ae039 = $4912912dcf00204c$var$TabContainer;



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $62e2824f5e989448$var$TabContent = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'tab-content');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$62e2824f5e989448$var$TabContent.displayName = 'TabContent';
var $62e2824f5e989448$export$2e2bcd8739ae039 = $62e2824f5e989448$var$TabContent;




var $8nGP5 = parcelRequire("8nGP5");







var $kSbwP = parcelRequire("kSbwP");
"use client";
const $38ab0eebfadc3eb1$var$TabPane = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, transition: transition, ...props }, ref)=>{
    const [{ className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', ...rest }, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $fd60cdcd5f9eb8a2$export$2e2bcd8739ae039) }] = (0, $64e8818b41ff2456$export$fae0121b5afe572d)({
        ...props,
        transition: (0, $e4afdfae98d48b5f$export$2e2bcd8739ae039)(transition)
    });
    const prefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'tab-pane');
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $98974a755a399e05$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $b6815e582002ff29$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
                    ...rest,
                    ref: ref,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, isActive && 'active')
                })
            })
        })
    });
});
$38ab0eebfadc3eb1$var$TabPane.displayName = 'TabPane';
var $38ab0eebfadc3eb1$export$2e2bcd8739ae039 = $38ab0eebfadc3eb1$var$TabPane;


/* eslint-disable react/no-unused-prop-types */ const $da2e6657088436c3$var$propTypes = {
    eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number
    ]),
    /**
   * Content for the tab title.
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node.isRequired,
    /**
   * The disabled state of the tab.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Class to pass to the underlying nav link.
   */ tabClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    /**
   * Object containing attributes to pass to underlying nav link.
   */ tabAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object
};
const $da2e6657088436c3$var$Tab = ()=>{
    throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
};
$da2e6657088436c3$var$Tab.propTypes = $da2e6657088436c3$var$propTypes;
var $da2e6657088436c3$export$2e2bcd8739ae039 = Object.assign($da2e6657088436c3$var$Tab, {
    Container: (0, $4912912dcf00204c$export$2e2bcd8739ae039),
    Content: (0, $62e2824f5e989448$export$2e2bcd8739ae039),
    Pane: (0, $38ab0eebfadc3eb1$export$2e2bcd8739ae039)
});

parcelRequire("8nGP5");

var $1TGTA = parcelRequire("1TGTA");

var $8D9Xw = parcelRequire("8D9Xw");

var $8nGP5 = parcelRequire("8nGP5");

var $647ee895478c368b$var$noop = function noop() {};
function $647ee895478c368b$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $647ee895478c368b$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $647ee895478c368b$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$647ee895478c368b$export$26cbf8c37e721e67(prop)] = $647ee895478c368b$var$noop;
        var handler;
    });
    return propTypes;
}
function $647ee895478c368b$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $647ee895478c368b$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $647ee895478c368b$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $73f69c1bcfac1e92$var$_toPropertyKey(arg) {
    var key = $73f69c1bcfac1e92$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $73f69c1bcfac1e92$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $73f69c1bcfac1e92$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $8nGP5.useRef)(propValue !== undefined);
    var _useState = (0, $8nGP5.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $8nGP5.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $73f69c1bcfac1e92$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$647ee895478c368b$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $8D9Xw.default)(_ref, [
            $647ee895478c368b$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($73f69c1bcfac1e92$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $73f69c1bcfac1e92$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $1TGTA.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}



var $8D9Xw = parcelRequire("8D9Xw");

var $1TGTA = parcelRequire("1TGTA");

var $79bU5 = parcelRequire("79bU5");

var $8nGP5 = parcelRequire("8nGP5");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $e60c074f0cb8bafe$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $e60c074f0cb8bafe$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $e60c074f0cb8bafe$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$e60c074f0cb8bafe$var$componentWillMount.__suppressDeprecationWarning = true;
$e60c074f0cb8bafe$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$e60c074f0cb8bafe$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $e60c074f0cb8bafe$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $e60c074f0cb8bafe$var$componentWillMount;
        prototype.componentWillReceiveProps = $e60c074f0cb8bafe$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $e60c074f0cb8bafe$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $7dda9526ac49e80d$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $7dda9526ac49e80d$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $647ee895478c368b$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($647ee895478c368b$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($250d2e1099d426ec$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $79bU5.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $1TGTA.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$647ee895478c368b$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $1TGTA.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$647ee895478c368b$export$12ae2baa35bd9b8b(props, key) && $647ee895478c368b$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$647ee895478c368b$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $8D9Xw.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(Component, (0, $1TGTA.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
    (0, $e60c074f0cb8bafe$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $1TGTA.default)({
        innerRef: function innerRef() {}
    }, $647ee895478c368b$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(UncontrolledComponent, (0, $1TGTA.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $7dda9526ac49e80d$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $7dda9526ac49e80d$export$2e2bcd8739ae039(newComponent, (0, $1TGTA.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}







var $8nGP5 = parcelRequire("8nGP5");



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
function $4c1c7387d84288cf$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $8nGP5.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}




var $8nGP5 = parcelRequire("8nGP5");
const $8a692f3a0d7be11a$var$NavContext = /*#__PURE__*/ $8nGP5.createContext(null);
$8a692f3a0d7be11a$var$NavContext.displayName = 'NavContext';
var $8a692f3a0d7be11a$export$2e2bcd8739ae039 = $8a692f3a0d7be11a$var$NavContext;






var $8nGP5 = parcelRequire("8nGP5");







var $kSbwP = parcelRequire("kSbwP");
const $95c028ef3a76bf30$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $95c028ef3a76bf30$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $95c028ef3a76bf30$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $8nGP5.useContext)((0, $b6815e582002ff29$export$2e2bcd8739ae039));
    const navContext = (0, $8nGP5.useContext)((0, $8a692f3a0d7be11a$export$2e2bcd8739ae039));
    const tabContext = (0, $8nGP5.useContext)((0, $98974a755a399e05$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $19eda73d643e0be8$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $95c028ef3a76bf30$var$NavItem = /*#__PURE__*/ $8nGP5.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $ec9fcdd42cb47dac$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $95c028ef3a76bf30$var$_objectWithoutPropertiesLoose(_ref, $95c028ef3a76bf30$var$_excluded);
    const [props, meta] = $95c028ef3a76bf30$export$d7a68693710982a(Object.assign({
        key: (0, $b6815e582002ff29$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $19eda73d643e0be8$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$95c028ef3a76bf30$var$NavItem.displayName = 'NavItem';
var $95c028ef3a76bf30$export$2e2bcd8739ae039 = $95c028ef3a76bf30$var$NavItem;



var $kSbwP = parcelRequire("kSbwP");
const $372a67ea8947bcd9$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $372a67ea8947bcd9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $372a67ea8947bcd9$var$noop = ()=>{};
const $372a67ea8947bcd9$var$EVENT_KEY_ATTR = (0, $19eda73d643e0be8$export$5cc3b7b83e34ade7)('event-key');
const $372a67ea8947bcd9$var$Nav = /*#__PURE__*/ $8nGP5.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $372a67ea8947bcd9$var$_objectWithoutPropertiesLoose(_ref, $372a67ea8947bcd9$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $4c1c7387d84288cf$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $8nGP5.useRef)(false);
    const parentOnSelect = (0, $8nGP5.useContext)((0, $b6815e582002ff29$export$2e2bcd8739ae039));
    const tabContext = (0, $8nGP5.useContext)((0, $98974a755a399e05$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $8nGP5.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $0a134cba80b47542$export$2e2bcd8739ae039)(currentListNode, `[${$372a67ea8947bcd9$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $19eda73d643e0be8$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $8nGP5.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$372a67ea8947bcd9$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $d4f8bf939aa0eef9$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $b6815e582002ff29$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $8a692f3a0d7be11a$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $b6815e582002ff29$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $372a67ea8947bcd9$var$noop,
                getControllerId: getControllerId || $372a67ea8947bcd9$var$noop
            },
            children: /*#__PURE__*/ (0, $kSbwP.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$372a67ea8947bcd9$var$Nav.displayName = 'Nav';
var $372a67ea8947bcd9$export$2e2bcd8739ae039 = Object.assign($372a67ea8947bcd9$var$Nav, {
    Item: (0, $95c028ef3a76bf30$export$2e2bcd8739ae039)
});




var $8nGP5 = parcelRequire("8nGP5");
"use client";
// TODO: check
const $aebdd086d603c190$var$context = /*#__PURE__*/ $8nGP5.createContext(null);
$aebdd086d603c190$var$context.displayName = 'NavbarContext';
var $aebdd086d603c190$export$2e2bcd8739ae039 = $aebdd086d603c190$var$context;



var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $d8c690ad9b65c281$var$context = /*#__PURE__*/ $8nGP5.createContext(null);
$d8c690ad9b65c281$var$context.displayName = 'CardHeaderContext';
var $d8c690ad9b65c281$export$2e2bcd8739ae039 = $d8c690ad9b65c281$var$context;



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $9e12f8cda019dc0d$var$NavItem = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$9e12f8cda019dc0d$var$NavItem.displayName = 'NavItem';
var $9e12f8cda019dc0d$export$2e2bcd8739ae039 = $9e12f8cda019dc0d$var$NavItem;




var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
function $40d7663930fda29e$export$2e2bcd8739ae039() {
    return (0, $8nGP5.useState)(null);
}





var $8nGP5 = parcelRequire("8nGP5");

function $ddb328620523d7d4$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)(listener);
    (0, $8nGP5.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $8nGP5 = parcelRequire("8nGP5");
function $c2311523b6c9392f$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $8nGP5.useCallback)(()=>document, []);
    return (0, $ddb328620523d7d4$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $8nGP5 = parcelRequire("8nGP5");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $1702086ddd03cbf5$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $9e2b25d42636a35a$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $9e2b25d42636a35a$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $8nGP5.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $1702086ddd03cbf5$export$2e2bcd8739ae039 = $1702086ddd03cbf5$var$useInterval;



var $8nGP5 = parcelRequire("8nGP5");

function $1cd9a130e8e0cb0f$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $9e2b25d42636a35a$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $9e2b25d42636a35a$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $8nGP5.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $1cd9a130e8e0cb0f$export$2e2bcd8739ae039 = $1cd9a130e8e0cb0f$var$useRafInterval;



var $8nGP5 = parcelRequire("8nGP5");
function $a0f38e4341df4339$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $8nGP5.useState)(initialState);
    const updater = (0, $8nGP5.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $3a783e1604888c03$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $a0f38e4341df4339$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $8nGP5 = parcelRequire("8nGP5");
function $73aaedc5fcd628d4$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $8nGP5.useState)({
        image: null,
        error: null
    });
    (0, $8nGP5.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $8nGP5 = parcelRequire("8nGP5");

const $928b453020f54ed5$var$targetMap = new WeakMap();
let $928b453020f54ed5$var$resizeObserver;
function $928b453020f54ed5$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $928b453020f54ed5$var$resizeObserver = $928b453020f54ed5$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $928b453020f54ed5$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $928b453020f54ed5$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $8nGP5.useState)(null);
    (0, $29dbdd8a46c7ba41$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $928b453020f54ed5$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $928b453020f54ed5$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $928b453020f54ed5$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






var $kSbwP = parcelRequire("kSbwP");
const $3ee635a80f9ab5d2$var$_excluded = [
    "onKeyDown"
];
function $3ee635a80f9ab5d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $3ee635a80f9ab5d2$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $3ee635a80f9ab5d2$var$Anchor = /*#__PURE__*/ $8nGP5.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $3ee635a80f9ab5d2$var$_objectWithoutPropertiesLoose(_ref, $3ee635a80f9ab5d2$var$_excluded);
    const [buttonProps] = (0, $ec9fcdd42cb47dac$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($3ee635a80f9ab5d2$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $kSbwP.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $kSbwP.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$3ee635a80f9ab5d2$var$Anchor.displayName = 'Anchor';
var $3ee635a80f9ab5d2$export$2e2bcd8739ae039 = $3ee635a80f9ab5d2$var$Anchor;






var $kSbwP = parcelRequire("kSbwP");
"use client";
const $77702607ee254822$var$NavLink = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $3ee635a80f9ab5d2$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $95c028ef3a76bf30$export$d7a68693710982a)({
        key: (0, $b6815e582002ff29$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$77702607ee254822$var$NavLink.displayName = 'NavLink';
var $77702607ee254822$export$2e2bcd8739ae039 = $77702607ee254822$var$NavLink;



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $b7959bc89ddb02a8$var$Nav = /*#__PURE__*/ $8nGP5.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $73f69c1bcfac1e92$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $8nGP5.useContext)((0, $aebdd086d603c190$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $8nGP5.useContext)((0, $d8c690ad9b65c281$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $372a67ea8947bcd9$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$b7959bc89ddb02a8$var$Nav.displayName = 'Nav';
var $b7959bc89ddb02a8$export$2e2bcd8739ae039 = Object.assign($b7959bc89ddb02a8$var$Nav, {
    Item: (0, $9e12f8cda019dc0d$export$2e2bcd8739ae039),
    Link: (0, $77702607ee254822$export$2e2bcd8739ae039)
});









var $kSbwP = parcelRequire("kSbwP");
function $ffe5cb04ab1a077a$var$getDefaultActiveKey(children) {
    let defaultActiveKey;
    (0, $53f1ebcf35f12b2a$export$4b80e395e36b5a56)(children, (child)=>{
        if (defaultActiveKey == null) defaultActiveKey = child.props.eventKey;
    });
    return defaultActiveKey;
}
function $ffe5cb04ab1a077a$var$renderTab(child) {
    const { title: title, eventKey: eventKey, disabled: disabled, tabClassName: tabClassName, tabAttrs: tabAttrs, id: id } = child.props;
    if (title == null) return null;
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $9e12f8cda019dc0d$export$2e2bcd8739ae039), {
        as: "li",
        role: "presentation",
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $77702607ee254822$export$2e2bcd8739ae039), {
            as: "button",
            type: "button",
            eventKey: eventKey,
            disabled: disabled,
            id: id,
            className: tabClassName,
            ...tabAttrs,
            children: title
        })
    });
}
const $ffe5cb04ab1a077a$var$Tabs = (props)=>{
    const { id: id, onSelect: onSelect, transition: transition, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, variant: variant = 'tabs', children: children, activeKey: activeKey = $ffe5cb04ab1a077a$var$getDefaultActiveKey(children), ...controlledProps } = (0, $73f69c1bcfac1e92$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    return /*#__PURE__*/ (0, $kSbwP.jsxs)((0, $852a159ce97d8a68$export$2e2bcd8739ae039), {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        transition: (0, $e4afdfae98d48b5f$export$2e2bcd8739ae039)(transition),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: [
            /*#__PURE__*/ (0, $kSbwP.jsx)((0, $b7959bc89ddb02a8$export$2e2bcd8739ae039), {
                id: id,
                ...controlledProps,
                role: "tablist",
                as: "ul",
                variant: variant,
                children: (0, $53f1ebcf35f12b2a$export$871de8747c9eaa88)(children, $ffe5cb04ab1a077a$var$renderTab)
            }),
            /*#__PURE__*/ (0, $kSbwP.jsx)((0, $62e2824f5e989448$export$2e2bcd8739ae039), {
                children: (0, $53f1ebcf35f12b2a$export$871de8747c9eaa88)(children, (child)=>{
                    const childProps = {
                        ...child.props
                    };
                    delete childProps.title;
                    delete childProps.disabled;
                    delete childProps.tabClassName;
                    delete childProps.tabAttrs;
                    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $38ab0eebfadc3eb1$export$2e2bcd8739ae039), {
                        ...childProps
                    });
                })
            })
        ]
    });
};
$ffe5cb04ab1a077a$var$Tabs.displayName = 'Tabs';
var $ffe5cb04ab1a077a$export$2e2bcd8739ae039 = $ffe5cb04ab1a077a$var$Tabs;




var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");



var $8nGP5 = parcelRequire("8nGP5");



var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");











var $3e24f02855c82492$export$40a9eeef55665a40;
var $3e24f02855c82492$export$93b7586d956c930e;
var $3e24f02855c82492$export$f843afa9e9b53052;
var $3e24f02855c82492$export$637f169d296cfe12;
var $3e24f02855c82492$export$ae78d338ad66ff90;
var $3e24f02855c82492$export$b8972b998723d602;
var $3e24f02855c82492$export$13925b5cf10ba292;
var $3e24f02855c82492$export$a59643d115b68bf0;
$3e24f02855c82492$export$40a9eeef55665a40 = `aLngCa_defaultPadding`;
$3e24f02855c82492$export$93b7586d956c930e = `aLngCa_dropShadow`;
$3e24f02855c82492$export$f843afa9e9b53052 = `aLngCa_panelImage`;
$3e24f02855c82492$export$637f169d296cfe12 = `aLngCa_panelTableStyle`;
$3e24f02855c82492$export$ae78d338ad66ff90 = `aLngCa_scaleInOut`;
$3e24f02855c82492$export$b8972b998723d602 = `aLngCa_shadow`;
$3e24f02855c82492$export$13925b5cf10ba292 = `aLngCa_small-shadow`;
$3e24f02855c82492$export$a59643d115b68bf0 = `aLngCa_uploadButton`;




var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $fe673f8fa917fb72$export$a3579ca508007a95 = (0, $8nGP5.createContext)({});



var $8nGP5 = parcelRequire("8nGP5");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $9605b32971d7a0ac$export$fe4300aa8eebea86(init) {
    const ref = (0, $8nGP5.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $8nGP5 = parcelRequire("8nGP5");
const $93e8e69246a44ea3$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $b01929a085d77867$export$700979bc83e7db82 = (0, $93e8e69246a44ea3$export$4e09c449d6c407f7) ? (0, $8nGP5.useLayoutEffect) : (0, $8nGP5.useEffect);



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
"use client";
/**
 * @public
 */ const $1593525ca75f11c2$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $8nGP5.createContext)(null);




var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
"use client";
/**
 * @public
 */ const $713455ea2968d220$export$22a697fb29aac98d = (0, $8nGP5.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});


"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $75ea0e6a727bb6fe$var$PopChildMeasure extends $8nGP5.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const parent = element.offsetParent;
            const parentWidth = parent instanceof HTMLElement ? parent.offsetWidth || 0 : 0;
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $75ea0e6a727bb6fe$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent, anchorX: anchorX }) {
    const id = (0, $8nGP5.useId)();
    const ref = (0, $8nGP5.useRef)(null);
    const size = (0, $8nGP5.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0
    });
    const { nonce: nonce } = (0, $8nGP5.useContext)((0, $713455ea2968d220$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $8nGP5.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left, right: right } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        const x = anchorX === "left" ? `left: ${left}` : `right: ${right}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            top: ${top}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $kSbwP.jsx)($75ea0e6a727bb6fe$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $8nGP5.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $afce8636512d97d7$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode, anchorX: anchorX })=>{
    const presenceChildren = (0, $9605b32971d7a0ac$export$fe4300aa8eebea86)($afce8636512d97d7$var$newChildrenMap);
    const id = (0, $8nGP5.useId)();
    let isReusedContext = true;
    let context = (0, $8nGP5.useMemo)(()=>{
        isReusedContext = false;
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        };
    }, [
        isPresent,
        presenceChildren,
        onExitComplete
    ]);
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ if (presenceAffectsLayout && isReusedContext) context = {
        ...context
    };
    (0, $8nGP5.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $8nGP5.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $kSbwP.jsx)((0, $75ea0e6a727bb6fe$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        anchorX: anchorX,
        children: children
    });
    return (0, $kSbwP.jsx)((0, $1593525ca75f11c2$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $afce8636512d97d7$var$newChildrenMap() {
    return new Map();
}



var $8nGP5 = parcelRequire("8nGP5");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $9faef52cd3d976c5$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $8nGP5.useContext)((0, $1593525ca75f11c2$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $8nGP5.useId)();
    (0, $8nGP5.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $8nGP5.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $9faef52cd3d976c5$export$8249053f690ea39a() {
    return $9faef52cd3d976c5$export$ee27c052bca048fb((0, $8nGP5.useContext)((0, $1593525ca75f11c2$export$f224e4635b6f8ce2)));
}
function $9faef52cd3d976c5$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $8nGP5 = parcelRequire("8nGP5");
const $7152cc5adae8a187$export$10e61aed958678dd = (child)=>child.key || "";
function $7152cc5adae8a187$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $8nGP5.Children).forEach(children, (child)=>{
        if ((0, $8nGP5.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}


"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $ae648d2f07b96262$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false, anchorX: anchorX = "left" })=>{
    const [isParentPresent, safeToRemove] = (0, $9faef52cd3d976c5$export$2a8c16d82a0a0e26)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $8nGP5.useMemo)(()=>(0, $7152cc5adae8a187$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $7152cc5adae8a187$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $8nGP5.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $8nGP5.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $9605b32971d7a0ac$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $8nGP5.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $8nGP5.useState)(presentChildren);
    (0, $b01929a085d77867$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $7152cc5adae8a187$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $7152cc5adae8a187$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $7152cc5adae8a187$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $8nGP5.useContext)((0, $fe673f8fa917fb72$export$a3579ca508007a95));
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $7152cc5adae8a187$export$10e61aed958678dd)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender?.();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && safeToRemove?.();
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $kSbwP.jsx)((0, $afce8636512d97d7$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                children: child
            }, key);
        })
    });
};


function $75379e3c6646eee5$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $b5fd1366b4f513fc$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


function $b4ca5246706cedf8$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $b4ca5246706cedf8$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $b4ca5246706cedf8$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $b4ca5246706cedf8$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $a3c3fdef404d6960$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $b4ca5246706cedf8$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $e2038ba4791abdb2$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};



const $8598012ceea23d02$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $72eda7ec592d7d0a$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $7827449dd5abbcaf$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $72eda7ec592d7d0a$export$84ce9a476f53d110).value) (0, $72eda7ec592d7d0a$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $b9fc7a6113852335$export$dd826089e3c5e502 = {};


const $7f97733e1a341afa$var$maxElapsed = 40;
function $7f97733e1a341afa$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $8598012ceea23d02$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $7827449dd5abbcaf$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $b9fc7a6113852335$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $b9fc7a6113852335$export$dd826089e3c5e502).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $7f97733e1a341afa$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $8598012ceea23d02$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $8598012ceea23d02$export$71ecace0a033b35a).length; i++)steps[(0, $8598012ceea23d02$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


/*#__NO_SIDE_EFFECTS__*/ const $98e835e3ea32c222$export$8793edee2d425525 = (any)=>any;


const { schedule: $387e962b4829eb62$export$2cef06c20297c17d, cancel: $387e962b4829eb62$export$ec99c0ef4978dccb, state: $387e962b4829eb62$export$fff89137e9e818ce, steps: $387e962b4829eb62$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $7f97733e1a341afa$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $98e835e3ea32c222$export$8793edee2d425525), true);



let $5d2a0d34ff92fdfa$var$now;
function $5d2a0d34ff92fdfa$var$clearTime() {
    $5d2a0d34ff92fdfa$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($5d2a0d34ff92fdfa$var$now === undefined) $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1.set((0, $387e962b4829eb62$export$fff89137e9e818ce).isProcessing || (0, $b9fc7a6113852335$export$dd826089e3c5e502).useManualTiming ? (0, $387e962b4829eb62$export$fff89137e9e818ce).timestamp : performance.now());
        return $5d2a0d34ff92fdfa$var$now;
    },
    set: (newTime)=>{
        $5d2a0d34ff92fdfa$var$now = newTime;
        queueMicrotask($5d2a0d34ff92fdfa$var$clearTime);
    }
};




function $3ac88bbc51d0aa7f$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $3ac88bbc51d0aa7f$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $3ac88bbc51d0aa7f$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $b1158bcc94bc3a85$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $3ac88bbc51d0aa7f$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $3ac88bbc51d0aa7f$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $2f4f15d53a3f209b$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $9d12ee7f3a872cfa$var$MAX_VELOCITY_DELTA = 30;
const $9d12ee7f3a872cfa$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $9d12ee7f3a872cfa$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $9d12ee7f3a872cfa$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "12.8.0";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $9d12ee7f3a872cfa$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $b1158bcc94bc3a85$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $387e962b4829eb62$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (v === "none") console.trace();
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($9d12ee7f3a872cfa$export$67fcd818a264039d.current) $9d12ee7f3a872cfa$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $9d12ee7f3a872cfa$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $9d12ee7f3a872cfa$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $2f4f15d53a3f209b$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $9d12ee7f3a872cfa$export$ce8bdc721e76545f(init, options) {
    return new $9d12ee7f3a872cfa$export$8cea36d14ee64562(init, options);
}


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $4b98a530c5a7abf5$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $9d12ee7f3a872cfa$export$ce8bdc721e76545f)(value));
}
function $4b98a530c5a7abf5$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $e2038ba4791abdb2$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $4b98a530c5a7abf5$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $a3c3fdef404d6960$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $4b98a530c5a7abf5$var$resolveFinalValueInKeyframes(target[key]);
        $4b98a530c5a7abf5$var$setMotionValue(visualElement, key, value);
    }
}


const $221a83d60cc317b6$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $15ff1efbe75c127e$export$98397f3adbf6259f(value) {
    return Boolean((0, $221a83d60cc317b6$export$605d60a2578142d3)(value) && value.add);
}



function $53658f9dcd580ff0$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $15ff1efbe75c127e$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $b9fc7a6113852335$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $b9fc7a6113852335$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}


/**
 * Convert camelCase to dash-case properties.
 */ const $535a806ef4f02e20$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $af2bab59b9c2447e$export$ed7b8fa9dbf0105d = "framerAppearId";
const $af2bab59b9c2447e$export$8592e1c077c890a6 = "data-" + (0, $535a806ef4f02e20$export$9fd24a634729c672)($af2bab59b9c2447e$export$ed7b8fa9dbf0105d);


function $69e77113a9a4699d$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $af2bab59b9c2447e$export$8592e1c077c890a6];
}


const $c3b4f50b138c992b$var$isNotNull = (value)=>value !== null;
function $c3b4f50b138c992b$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($c3b4f50b138c992b$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


/**
 * Generate a list of every possible transform key.
 */ const $e2c1c6a0eb7f78a4$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $e2c1c6a0eb7f78a4$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set($e2c1c6a0eb7f78a4$export$280dc01950909d86))();


const $ec70854e9ee72ea6$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $ec70854e9ee72ea6$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $ec70854e9ee72ea6$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $ec70854e9ee72ea6$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $ec70854e9ee72ea6$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $ec70854e9ee72ea6$var$keyframesTransition;
    else if ((0, $e2c1c6a0eb7f78a4$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $ec70854e9ee72ea6$var$criticallyDampedSpring(keyframes[1]) : $ec70854e9ee72ea6$var$underDampedSpring;
    return $ec70854e9ee72ea6$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $3965999e3153758d$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


function $fdeb65bc6ac4f138$export$7c1391340308742e(transition, key) {
    return transition?.[key] ?? transition?.["default"] ?? transition;
}


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;






const $f5260c4617872a79$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};


const $d89df85a698547c2$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $d89df85a698547c2$export$9de1236619d9e756 = /*@__PURE__*/ $d89df85a698547c2$var$checkStringStartsWith("--");
const $d89df85a698547c2$var$startsAsVariableToken = /*@__PURE__*/ $d89df85a698547c2$var$checkStringStartsWith("var(--");
const $d89df85a698547c2$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $d89df85a698547c2$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $d89df85a698547c2$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $d89df85a698547c2$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


const $53314770db5036ad$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $f3163905ab1292a5$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $f3163905ab1292a5$export$58f0f39f63f3cf42 = {
    ...$f3163905ab1292a5$export$98e628dec113755e,
    transform: (v)=>(0, $53314770db5036ad$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $f3163905ab1292a5$export$dcdf75081b88279d = {
    ...$f3163905ab1292a5$export$98e628dec113755e,
    default: 1
};


// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $6c8a47fbd5319dc4$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $b0f17c1e240ca22d$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $331bbb9af26a1ff3$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $70f7859169a99cce$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $3d0a8aa6e95a8f45$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $70f7859169a99cce$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $331bbb9af26a1ff3$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $3d0a8aa6e95a8f45$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $b0f17c1e240ca22d$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };



const $bd00fa920b93c55a$var$clampRgbUnit = (v)=>(0, $53314770db5036ad$export$7d15b64cf5a3a4c4)(0, 255, v);
const $bd00fa920b93c55a$export$7a99c86b5b1f4c9e = {
    ...(0, $f3163905ab1292a5$export$98e628dec113755e),
    transform: (v)=>Math.round($bd00fa920b93c55a$var$clampRgbUnit(v))
};
const $bd00fa920b93c55a$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $3d0a8aa6e95a8f45$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $3d0a8aa6e95a8f45$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $bd00fa920b93c55a$export$7a99c86b5b1f4c9e.transform(red) + ", " + $bd00fa920b93c55a$export$7a99c86b5b1f4c9e.transform(green) + ", " + $bd00fa920b93c55a$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $6c8a47fbd5319dc4$export$83d2e9e3e4ee39ed)((0, $f3163905ab1292a5$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $6cd6e504865099ca$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $6cd6e504865099ca$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $3d0a8aa6e95a8f45$export$2c8400d58aca05e)("#"),
    parse: $6cd6e504865099ca$var$parseHex,
    transform: (0, $bd00fa920b93c55a$export$4e46ac54fc82cf3b).transform
};



/*#__NO_SIDE_EFFECTS__*/ const $6b744e05f0de4bfc$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $6b744e05f0de4bfc$export$41fc368e1a942b97 = /*@__PURE__*/ $6b744e05f0de4bfc$var$createUnitType("deg");
const $6b744e05f0de4bfc$export$626336c2cd4b14de = /*@__PURE__*/ $6b744e05f0de4bfc$var$createUnitType("%");
const $6b744e05f0de4bfc$export$91c0eda1d06bf008 = /*@__PURE__*/ $6b744e05f0de4bfc$var$createUnitType("px");
const $6b744e05f0de4bfc$export$f91e8c45a95a32f2 = /*@__PURE__*/ $6b744e05f0de4bfc$var$createUnitType("vh");
const $6b744e05f0de4bfc$export$aed3d7b7d206c196 = /*@__PURE__*/ $6b744e05f0de4bfc$var$createUnitType("vw");
const $6b744e05f0de4bfc$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$6b744e05f0de4bfc$export$626336c2cd4b14de,
        parse: (v)=>$6b744e05f0de4bfc$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$6b744e05f0de4bfc$export$626336c2cd4b14de.transform(v * 100)
    }))();




const $571bccc38400ead9$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $3d0a8aa6e95a8f45$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $3d0a8aa6e95a8f45$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $6b744e05f0de4bfc$export$626336c2cd4b14de).transform((0, $6c8a47fbd5319dc4$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $6b744e05f0de4bfc$export$626336c2cd4b14de).transform((0, $6c8a47fbd5319dc4$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $6c8a47fbd5319dc4$export$83d2e9e3e4ee39ed)((0, $f3163905ab1292a5$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $758878c83ce9baef$export$35e9368ef982300f = {
    test: (v)=>(0, $bd00fa920b93c55a$export$4e46ac54fc82cf3b).test(v) || (0, $6cd6e504865099ca$export$834dfc94dde4b3d8).test(v) || (0, $571bccc38400ead9$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $bd00fa920b93c55a$export$4e46ac54fc82cf3b).test(v)) return (0, $bd00fa920b93c55a$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $571bccc38400ead9$export$810b04175080204c).test(v)) return (0, $571bccc38400ead9$export$810b04175080204c).parse(v);
        else return (0, $6cd6e504865099ca$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $bd00fa920b93c55a$export$4e46ac54fc82cf3b).transform(v) : (0, $571bccc38400ead9$export$810b04175080204c).transform(v);
    }
};



const $8db173fc048d26a3$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $70bb888b16a48b09$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $b0f17c1e240ca22d$export$2444ca58c08448e4))?.length || 0) + (v.match((0, $8db173fc048d26a3$export$740b69c5fad25dba))?.length || 0) > 0;
}
const $70bb888b16a48b09$var$NUMBER_TOKEN = "number";
const $70bb888b16a48b09$var$COLOR_TOKEN = "color";
const $70bb888b16a48b09$var$VAR_TOKEN = "var";
const $70bb888b16a48b09$var$VAR_FUNCTION_TOKEN = "var(";
const $70bb888b16a48b09$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $70bb888b16a48b09$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $70bb888b16a48b09$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($70bb888b16a48b09$var$complexRegex, (parsedValue)=>{
        if ((0, $758878c83ce9baef$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($70bb888b16a48b09$var$COLOR_TOKEN);
            values.push((0, $758878c83ce9baef$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($70bb888b16a48b09$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($70bb888b16a48b09$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($70bb888b16a48b09$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $70bb888b16a48b09$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($70bb888b16a48b09$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $70bb888b16a48b09$var$parseComplexValue(v) {
    return $70bb888b16a48b09$export$b61fc7c44bf646d5(v).values;
}
function $70bb888b16a48b09$var$createTransformer(source) {
    const { split: split, types: types } = $70bb888b16a48b09$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $70bb888b16a48b09$var$NUMBER_TOKEN) output += (0, $6c8a47fbd5319dc4$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $70bb888b16a48b09$var$COLOR_TOKEN) output += (0, $758878c83ce9baef$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $70bb888b16a48b09$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $70bb888b16a48b09$var$getAnimatableNone(v) {
    const parsed = $70bb888b16a48b09$var$parseComplexValue(v);
    const transformer = $70bb888b16a48b09$var$createTransformer(v);
    return transformer(parsed.map($70bb888b16a48b09$var$convertNumbersToZero));
}
const $70bb888b16a48b09$export$83a0e34f1302825b = {
    test: $70bb888b16a48b09$var$test,
    parse: $70bb888b16a48b09$var$parseComplexValue,
    createTransformer: $70bb888b16a48b09$var$createTransformer,
    getAnimatableNone: $70bb888b16a48b09$var$getAnimatableNone
};




// Adapted from https://gist.github.com/mjackson/5311256
function $a45e3eb862b942bb$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $a45e3eb862b942bb$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $a45e3eb862b942bb$var$hueToRgb(p, q, hue + 1 / 3);
        green = $a45e3eb862b942bb$var$hueToRgb(p, q, hue);
        blue = $a45e3eb862b942bb$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $878ec130adb8085b$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $79a02208d9f4fe13$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


let $4297b76cbf8999fe$export$491112666e282270 = ()=>{};
let $4297b76cbf8999fe$export$f5708dca728d7177 = ()=>{};
var $4297b76cbf8999fe$var$check, $4297b76cbf8999fe$var$message, $4297b76cbf8999fe$var$check1, $4297b76cbf8999fe$var$message1;


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $f1d4a0cfe83995fa$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $f1d4a0cfe83995fa$var$colorTypes = [
    (0, $6cd6e504865099ca$export$834dfc94dde4b3d8),
    (0, $bd00fa920b93c55a$export$4e46ac54fc82cf3b),
    (0, $571bccc38400ead9$export$810b04175080204c)
];
const $f1d4a0cfe83995fa$var$getColorType = (v)=>$f1d4a0cfe83995fa$var$colorTypes.find((type)=>type.test(v));
function $f1d4a0cfe83995fa$var$asRGBA(color) {
    const type = $f1d4a0cfe83995fa$var$getColorType(color);
    (0, $4297b76cbf8999fe$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $571bccc38400ead9$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $a45e3eb862b942bb$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $f1d4a0cfe83995fa$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $f1d4a0cfe83995fa$var$asRGBA(from);
    const toRGBA = $f1d4a0cfe83995fa$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $878ec130adb8085b$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $f1d4a0cfe83995fa$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $f1d4a0cfe83995fa$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $f1d4a0cfe83995fa$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $bd00fa920b93c55a$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $08ebc04a1fd1619a$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $08ebc04a1fd1619a$export$fed62ccc3fb1a568(origin, target) {
    if ($08ebc04a1fd1619a$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $4a29a1eea6795867$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $4a29a1eea6795867$export$a4627e546088548d = (...transformers)=>transformers.reduce($4a29a1eea6795867$var$combineFunctions);



function $2907638fa725b207$var$mixNumber(a, b) {
    return (p)=>(0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $2907638fa725b207$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $2907638fa725b207$var$mixNumber;
    else if (typeof a === "string") return (0, $d89df85a698547c2$export$31f9caa2600b5723)(a) ? (0, $878ec130adb8085b$export$a6f92d4bae65c0f1) : (0, $758878c83ce9baef$export$35e9368ef982300f).test(a) ? (0, $f1d4a0cfe83995fa$export$51e568cf5c039bac) : $2907638fa725b207$export$65516310a87d8205;
    else if (Array.isArray(a)) return $2907638fa725b207$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $758878c83ce9baef$export$35e9368ef982300f).test(a) ? (0, $f1d4a0cfe83995fa$export$51e568cf5c039bac) : $2907638fa725b207$export$ebc23b6840c51ba1;
    return 0, $878ec130adb8085b$export$a6f92d4bae65c0f1;
}
function $2907638fa725b207$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$2907638fa725b207$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $2907638fa725b207$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $2907638fa725b207$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $2907638fa725b207$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $2907638fa725b207$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $70bb888b16a48b09$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $70bb888b16a48b09$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $70bb888b16a48b09$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $08ebc04a1fd1619a$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $08ebc04a1fd1619a$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $08ebc04a1fd1619a$export$fed62ccc3fb1a568)(origin, target);
        return (0, $4a29a1eea6795867$export$a4627e546088548d)($2907638fa725b207$export$3bbefa2f402845c4($2907638fa725b207$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $4297b76cbf8999fe$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $878ec130adb8085b$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $b3de80e9c2a3529b$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $2907638fa725b207$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $d8ff9e175f27c78e$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $387e962b4829eb62$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $387e962b4829eb62$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $387e962b4829eb62$export$fff89137e9e818ce).isProcessing ? (0, $387e962b4829eb62$export$fff89137e9e818ce).timestamp : (0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now()
    };
};


const $ba9800f2e69babe2$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing(i / (numPoints - 1)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $6e76feaccc44a22d$export$f4ff70a5b4808fd8 = 20000;
function $6e76feaccc44a22d$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $6e76feaccc44a22d$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $6e76feaccc44a22d$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $1b6c1d95a1d2e658$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $6e76feaccc44a22d$export$cbdd6b3d40ea54e2)(generator), (0, $6e76feaccc44a22d$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f)(duration)
    };
}



const $d37b9691cdb75abf$var$velocitySampleDuration = 5; // ms
function $d37b9691cdb75abf$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $d37b9691cdb75abf$var$velocitySampleDuration, 0);
    return (0, $2f4f15d53a3f209b$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $5d86d89ce346a8c0$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};






const $91ae4b5ae0cb9044$var$safeMin = 0.001;
function $91ae4b5ae0cb9044$export$b15f158dc6d6f458({ duration: duration = (0, $5d86d89ce346a8c0$export$86436497e7b05d16).duration, bounce: bounce = (0, $5d86d89ce346a8c0$export$86436497e7b05d16).bounce, velocity: velocity = (0, $5d86d89ce346a8c0$export$86436497e7b05d16).velocity, mass: mass = (0, $5d86d89ce346a8c0$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $4297b76cbf8999fe$export$491112666e282270)(duration <= (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)((0, $5d86d89ce346a8c0$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $53314770db5036ad$export$7d15b64cf5a3a4c4)((0, $5d86d89ce346a8c0$export$86436497e7b05d16).minDamping, (0, $5d86d89ce346a8c0$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $53314770db5036ad$export$7d15b64cf5a3a4c4)((0, $5d86d89ce346a8c0$export$86436497e7b05d16).minDuration, (0, $5d86d89ce346a8c0$export$86436497e7b05d16).maxDuration, (0, $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $91ae4b5ae0cb9044$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $91ae4b5ae0cb9044$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $91ae4b5ae0cb9044$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $91ae4b5ae0cb9044$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$91ae4b5ae0cb9044$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $91ae4b5ae0cb9044$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $5d86d89ce346a8c0$export$86436497e7b05d16).stiffness,
        damping: (0, $5d86d89ce346a8c0$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $91ae4b5ae0cb9044$var$rootIterations = 12;
function $91ae4b5ae0cb9044$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $91ae4b5ae0cb9044$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $91ae4b5ae0cb9044$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}




const $51cfe9f8253dcf1f$var$durationKeys = [
    "duration",
    "bounce"
];
const $51cfe9f8253dcf1f$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $51cfe9f8253dcf1f$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $51cfe9f8253dcf1f$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $5d86d89ce346a8c0$export$86436497e7b05d16).velocity,
        stiffness: (0, $5d86d89ce346a8c0$export$86436497e7b05d16).stiffness,
        damping: (0, $5d86d89ce346a8c0$export$86436497e7b05d16).damping,
        mass: (0, $5d86d89ce346a8c0$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$51cfe9f8253dcf1f$var$isSpringType(options, $51cfe9f8253dcf1f$var$physicsKeys) && $51cfe9f8253dcf1f$var$isSpringType(options, $51cfe9f8253dcf1f$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $53314770db5036ad$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $5d86d89ce346a8c0$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $91ae4b5ae0cb9044$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $5d86d89ce346a8c0$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $51cfe9f8253dcf1f$export$b36281d89752ae66(optionsOrVisualDuration = (0, $5d86d89ce346a8c0$export$86436497e7b05d16).visualDuration, bounce = (0, $5d86d89ce346a8c0$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $51cfe9f8253dcf1f$var$getSpringOptions({
        ...options,
        velocity: -(0, $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $5d86d89ce346a8c0$export$86436497e7b05d16).restSpeed.granular : (0, $5d86d89ce346a8c0$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $5d86d89ce346a8c0$export$86436497e7b05d16).restDelta.granular : (0, $5d86d89ce346a8c0$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $91ae4b5ae0cb9044$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = t === 0 ? initialVelocity : 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $d37b9691cdb75abf$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $6e76feaccc44a22d$export$cbdd6b3d40ea54e2)(generator), (0, $6e76feaccc44a22d$export$f4ff70a5b4808fd8));
            const easing = (0, $ba9800f2e69babe2$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$51cfe9f8253dcf1f$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $1b6c1d95a1d2e658$export$7f1511d09ee75a99)(options, 100, $51cfe9f8253dcf1f$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};



function $46b263a46f4228c7$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $51cfe9f8253dcf1f$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $d37b9691cdb75abf$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}








/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $2f2f4493db258fd8$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


function $5d2a272b1d70d7d9$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $b9fc7a6113852335$export$dd826089e3c5e502).mix || (0, $b3de80e9c2a3529b$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $98e835e3ea32c222$export$8793edee2d425525) : ease;
            mixer = (0, $4a29a1eea6795867$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $5d2a272b1d70d7d9$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $4297b76cbf8999fe$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $5d2a272b1d70d7d9$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $2f2f4493db258fd8$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $53314770db5036ad$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $a4ae153985e19ce7$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $2f2f4493db258fd8$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $d86ec89ee73840cf$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $a4ae153985e19ce7$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $ff90b85bc63e2fd7$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $520d9e6e437a738b$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $520d9e6e437a738b$var$subdivisionPrecision = 0.0000001;
const $520d9e6e437a738b$var$subdivisionMaxIterations = 12;
function $520d9e6e437a738b$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $520d9e6e437a738b$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $520d9e6e437a738b$var$subdivisionPrecision && ++i < $520d9e6e437a738b$var$subdivisionMaxIterations);
    return currentT;
}
function $520d9e6e437a738b$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $98e835e3ea32c222$export$8793edee2d425525;
    const getTForX = (aX)=>$520d9e6e437a738b$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $520d9e6e437a738b$var$calcBezier(getTForX(t), mY1, mY2);
}


const $2ff4da10c719cede$export$929e5a82286172a6 = /*@__PURE__*/ (0, $520d9e6e437a738b$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $2ff4da10c719cede$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $520d9e6e437a738b$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $2ff4da10c719cede$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $520d9e6e437a738b$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $c9e1d6455b8dde10$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};





// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $040a0b355f905cc9$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $7d7177b21e7a376c$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $1aba0cabb3c9686a$export$77edfce482316a60 = /*@__PURE__*/ (0, $520d9e6e437a738b$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $1aba0cabb3c9686a$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $7d7177b21e7a376c$export$2c07eeff45156d4d)($1aba0cabb3c9686a$export$77edfce482316a60);
const $1aba0cabb3c9686a$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $040a0b355f905cc9$export$f946554fb8aeaf0d)($1aba0cabb3c9686a$export$b01116c84cdfe1a2);


const $d0cf894cd19318e7$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $1aba0cabb3c9686a$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $ee47a657ec5a96c1$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $ee47a657ec5a96c1$export$c8d67a19199d1a50 = (0, $7d7177b21e7a376c$export$2c07eeff45156d4d)($ee47a657ec5a96c1$export$e444123e42d03385);
const $ee47a657ec5a96c1$export$30d3455eee55bed5 = (0, $040a0b355f905cc9$export$f946554fb8aeaf0d)($ee47a657ec5a96c1$export$e444123e42d03385);




const $ce6a0fe238ac4e46$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $11fe471a658c980a$var$easingLookup = {
    linear: (0, $98e835e3ea32c222$export$8793edee2d425525),
    easeIn: $2ff4da10c719cede$export$929e5a82286172a6,
    easeInOut: $2ff4da10c719cede$export$c07234257a03d5e9,
    easeOut: $2ff4da10c719cede$export$57636bb43b1ccbb0,
    circIn: $ee47a657ec5a96c1$export$e444123e42d03385,
    circInOut: $ee47a657ec5a96c1$export$30d3455eee55bed5,
    circOut: $ee47a657ec5a96c1$export$c8d67a19199d1a50,
    backIn: $1aba0cabb3c9686a$export$b01116c84cdfe1a2,
    backInOut: $1aba0cabb3c9686a$export$ddc5fd596f6c71b2,
    backOut: $1aba0cabb3c9686a$export$77edfce482316a60,
    anticipate: $d0cf894cd19318e7$export$6b0af63b873d419e
};
const $11fe471a658c980a$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $11fe471a658c980a$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $ce6a0fe238ac4e46$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $4297b76cbf8999fe$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $520d9e6e437a738b$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($11fe471a658c980a$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $4297b76cbf8999fe$export$f5708dca728d7177)($11fe471a658c980a$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $11fe471a658c980a$var$easingLookup[definition];
    }
    return definition;
};


function $777d9acbdb61325d$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $2ff4da10c719cede$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $777d9acbdb61325d$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $c9e1d6455b8dde10$export$216948827bbdc797)(ease) ? ease.map((0, $11fe471a658c980a$export$ef97fe084f156ca4)) : (0, $11fe471a658c980a$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $ff90b85bc63e2fd7$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $d86ec89ee73840cf$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $5d2a272b1d70d7d9$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $777d9acbdb61325d$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



const $45bf8817072d6cf6$var$isNotNull = (value)=>value !== null;
function $45bf8817072d6cf6$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($45bf8817072d6cf6$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





const $e555b124bad2c384$var$transitionTypeMap = {
    decay: (0, $46b263a46f4228c7$export$ee3ff3a17106998),
    inertia: $46b263a46f4228c7$export$ee3ff3a17106998,
    tween: (0, $777d9acbdb61325d$export$d25ddfdf17c3ad3e),
    keyframes: (0, $777d9acbdb61325d$export$d25ddfdf17c3ad3e),
    spring: $51cfe9f8253dcf1f$export$b36281d89752ae66
};
function $e555b124bad2c384$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $e555b124bad2c384$var$transitionTypeMap[transition.type];
}


class $7019636767a835b3$export$655db786091c33e0 {
    constructor(){
        this.count = 0;
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this.count++;
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}






const $6d6766af1a2993e6$var$percentToProgress = (percent)=>percent / 100;
class $6d6766af1a2993e6$export$3394f837405475c7 extends (0, $7019636767a835b3$export$655db786091c33e0) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now()) this.tick((0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        (0, $f5260c4617872a79$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $e555b124bad2c384$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $777d9acbdb61325d$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $777d9acbdb61325d$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $777d9acbdb61325d$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $4a29a1eea6795867$export$a4627e546088548d)($6d6766af1a2993e6$var$percentToProgress, (0, $b3de80e9c2a3529b$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $6e76feaccc44a22d$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $53314770db5036ad$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mixKeyframes) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $46b263a46f4228c7$export$ee3ff3a17106998)) state.value = (0, $45bf8817072d6cf6$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get time() {
        return (0, $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        this.updateTime((0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now());
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $d8ff9e175f27c78e$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $f5260c4617872a79$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        return timeline.observe(this);
    }
}
// Legacy function support
function $6d6766af1a2993e6$export$ee9b76de7353d815(options) {
    return new $6d6766af1a2993e6$export$3394f837405475c7(options);
}



function $a56752e595bfb5f5$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}


const $77539a1b389798aa$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $77539a1b389798aa$var$rotate = (v)=>{
    const angle = $77539a1b389798aa$var$radToDeg(Math.atan2(v[1], v[0]));
    return $77539a1b389798aa$var$rebaseAngle(angle);
};
const $77539a1b389798aa$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $77539a1b389798aa$var$rotate,
    rotateZ: $77539a1b389798aa$var$rotate,
    skewX: (v)=>$77539a1b389798aa$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$77539a1b389798aa$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $77539a1b389798aa$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $77539a1b389798aa$var$rotateZ = $77539a1b389798aa$var$rotate;
const $77539a1b389798aa$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $77539a1b389798aa$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $77539a1b389798aa$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $77539a1b389798aa$var$scaleX,
    scaleY: $77539a1b389798aa$var$scaleY,
    scale: (v)=>($77539a1b389798aa$var$scaleX(v) + $77539a1b389798aa$var$scaleY(v)) / 2,
    rotateX: (v)=>$77539a1b389798aa$var$rebaseAngle($77539a1b389798aa$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$77539a1b389798aa$var$rebaseAngle($77539a1b389798aa$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $77539a1b389798aa$var$rotateZ,
    rotate: $77539a1b389798aa$var$rotateZ,
    skewX: (v)=>$77539a1b389798aa$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$77539a1b389798aa$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $77539a1b389798aa$var$defaultTransformValue(name) {
    return name.includes("scale") ? 1 : 0;
}
function $77539a1b389798aa$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $77539a1b389798aa$var$defaultTransformValue(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $77539a1b389798aa$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $77539a1b389798aa$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $77539a1b389798aa$var$defaultTransformValue(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($77539a1b389798aa$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $77539a1b389798aa$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $77539a1b389798aa$export$f9111f9e16b73a26(transform, name);
};
function $77539a1b389798aa$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}





const $b05d7afcfc74671f$export$8e5250d1aa9bf370 = (v)=>v === (0, $f3163905ab1292a5$export$98e628dec113755e) || v === (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008);
const $b05d7afcfc74671f$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $b05d7afcfc74671f$var$nonTranslationalTransformKeys = (0, $e2c1c6a0eb7f78a4$export$280dc01950909d86).filter((key)=>!$b05d7afcfc74671f$var$transformKeys.has(key));
function $b05d7afcfc74671f$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $b05d7afcfc74671f$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $b05d7afcfc74671f$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $77539a1b389798aa$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $77539a1b389798aa$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$b05d7afcfc74671f$export$781d46a8aa670d52.translateX = $b05d7afcfc74671f$export$781d46a8aa670d52.x;
$b05d7afcfc74671f$export$781d46a8aa670d52.translateY = $b05d7afcfc74671f$export$781d46a8aa670d52.y;



const $4288128b38ea7b9e$var$toResolve = new Set();
let $4288128b38ea7b9e$var$isScheduled = false;
let $4288128b38ea7b9e$var$anyNeedsMeasurement = false;
let $4288128b38ea7b9e$var$isForced = false;
function $4288128b38ea7b9e$var$measureAllKeyframes() {
    if ($4288128b38ea7b9e$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($4288128b38ea7b9e$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $b05d7afcfc74671f$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $4288128b38ea7b9e$var$anyNeedsMeasurement = false;
    $4288128b38ea7b9e$var$isScheduled = false;
    $4288128b38ea7b9e$var$toResolve.forEach((resolver)=>resolver.complete($4288128b38ea7b9e$var$isForced));
    $4288128b38ea7b9e$var$toResolve.clear();
}
function $4288128b38ea7b9e$var$readAllKeyframes() {
    $4288128b38ea7b9e$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $4288128b38ea7b9e$var$anyNeedsMeasurement = true;
    });
}
function $4288128b38ea7b9e$export$78b96d2a12593b05() {
    $4288128b38ea7b9e$var$isForced = true;
    $4288128b38ea7b9e$var$readAllKeyframes();
    $4288128b38ea7b9e$var$measureAllKeyframes();
    $4288128b38ea7b9e$var$isForced = false;
}
class $4288128b38ea7b9e$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $4288128b38ea7b9e$var$toResolve.add(this);
            if (!$4288128b38ea7b9e$var$isScheduled) {
                $4288128b38ea7b9e$var$isScheduled = true;
                (0, $387e962b4829eb62$export$2cef06c20297c17d).read($4288128b38ea7b9e$var$readAllKeyframes);
                (0, $387e962b4829eb62$export$2cef06c20297c17d).resolveKeyframes($4288128b38ea7b9e$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $a56752e595bfb5f5$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForced = false) {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForced);
        $4288128b38ea7b9e$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $4288128b38ea7b9e$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}



const $b63967b37a6d8a3e$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $e23b6c5195e539e4$export$37a5fde709c1db82(element, name, value) {
    (0, $b63967b37a6d8a3e$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $a62861c70e1d799a$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $e4df37fbc49b12fc$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $a62861c70e1d799a$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);






/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $953b53254c12d8bb$export$e3ad02c335474dee = {};



function $ee3571ad97bd1383$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $a62861c70e1d799a$export$7c73462e0d25e514)(callback);
    return ()=>(0, $953b53254c12d8bb$export$e3ad02c335474dee)[supportsFlag] ?? memoized();
}


const $773b85051268e6bb$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $ee3571ad97bd1383$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $82f10475d0333a1b$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $6581fea2cf4a26d2$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $82f10475d0333a1b$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $82f10475d0333a1b$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $82f10475d0333a1b$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $82f10475d0333a1b$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};



function $3494155ec4acce34$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $773b85051268e6bb$export$866c1d07a1ac2ab)() ? (0, $ba9800f2e69babe2$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $ce6a0fe238ac4e46$export$ff43f99925d7366b)(easing)) return (0, $82f10475d0333a1b$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$3494155ec4acce34$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $6581fea2cf4a26d2$export$2cf569f5e2221176).easeOut);
    else return (0, $6581fea2cf4a26d2$export$2cf569f5e2221176)[easing];
}


function $9dc9e24cb6176c26$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $3494155ec4acce34$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $72eda7ec592d7d0a$export$84ce9a476f53d110).value) (0, $f5260c4617872a79$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $72eda7ec592d7d0a$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $f5260c4617872a79$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}



function $8548e65d7c5f9cf6$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}


function $8d31cd496d258fbc$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $8548e65d7c5f9cf6$export$6ab7812f1bac68be)(type) && (0, $773b85051268e6bb$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}





/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $676ec2f704af4416$export$6c0f9803d8aa7219 extends (0, $7019636767a835b3$export$655db786091c33e0) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $4297b76cbf8999fe$export$f5708dca728d7177)(typeof options.type !== "string", `animateMini doesn't support "type" as a string. Did you mean to import { spring } from "motion"?`);
        const transition = (0, $8d31cd496d258fbc$export$a31269144d66b4a)(options);
        this.animation = (0, $9dc9e24cb6176c26$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $45bf8817072d6cf6$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                else /**
                     * If we can, we want to commit the final style as set by the user,
                     * rather than the computed keyframe value supplied by the animation.
                     */ (0, $e23b6c5195e539e4$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        if (!this.isPseudoElement) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get time() {
        return (0, $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        this.finishedTime = null;
        this.animation.currentTime = (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(newTime);
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $e4df37fbc49b12fc$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            return 0, $98e835e3ea32c222$export$8793edee2d425525;
        } else return observe(this);
    }
}






const $6766af96301ab282$var$unsupportedEasingFunctions = {
    anticipate: $d0cf894cd19318e7$export$6b0af63b873d419e,
    backInOut: $1aba0cabb3c9686a$export$ddc5fd596f6c71b2,
    circInOut: $ee47a657ec5a96c1$export$30d3455eee55bed5
};
function $6766af96301ab282$var$isUnsupportedEase(key) {
    return key in $6766af96301ab282$var$unsupportedEasingFunctions;
}
function $6766af96301ab282$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $6766af96301ab282$var$isUnsupportedEase(transition.ease)) transition.ease = $6766af96301ab282$var$unsupportedEasingFunctions[transition.ease];
}



/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $da090a6a72ec7802$var$sampleDelta = 10; //ms
class $da090a6a72ec7802$export$bd2cd6a048093d96 extends (0, $676ec2f704af4416$export$6c0f9803d8aa7219) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $6766af96301ab282$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $e555b124bad2c384$export$98db6ef1242dfa2)(options);
        super(options);
        if (options.startTime) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $6d6766af1a2993e6$export$3394f837405475c7)({
            ...options,
            autoplay: false
        });
        const sampleTime = (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(this.finishedTime ?? this.time);
        motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $da090a6a72ec7802$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $da090a6a72ec7802$var$sampleDelta);
        sampleAnimation.stop();
    }
}




/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $56a24db5d6299c47$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $70bb888b16a48b09$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};



function $376879d069315f98$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $376879d069315f98$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $56a24db5d6299c47$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $56a24db5d6299c47$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $4297b76cbf8999fe$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $376879d069315f98$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $8548e65d7c5f9cf6$export$6ab7812f1bac68be)(type)) && velocity;
}




/**
 * A list of values that can be hardware-accelerated.
 */ const $3bce63c576f09c3d$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
const $3bce63c576f09c3d$var$supportsWaapi = /*@__PURE__*/ (0, $a62861c70e1d799a$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $3bce63c576f09c3d$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
    if (!motionValue || !motionValue.owner || !(motionValue.owner.current instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $3bce63c576f09c3d$var$supportsWaapi() && name && $3bce63c576f09c3d$var$acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}




/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $451bd42403650c47$var$MAX_RESOLVE_DELAY = 40;
class $451bd42403650c47$export$b9855e2a7dee3dd2 extends (0, $7019636767a835b3$export$655db786091c33e0) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            } else this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $4288128b38ea7b9e$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate, onComplete: onComplete } = options;
        this.resolvedAt = (0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $376879d069315f98$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            if ((0, $b9fc7a6113852335$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate?.((0, $45bf8817072d6cf6$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            options.duration = 0;
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first commited frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $451bd42403650c47$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ const animation = !isHandoff && (0, $3bce63c576f09c3d$export$ea92bde116fda821)(resolvedOptions) ? new (0, $da090a6a72ec7802$export$bd2cd6a048093d96)({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current
        }) : new (0, $6d6766af1a2993e6$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>{
            onComplete?.();
            this.notifyFinished();
        }).catch((0, $98e835e3ea32c222$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) (0, $4288128b38ea7b9e$export$78b96d2a12593b05)();
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        this.animation.cancel();
    }
}


const $178708fc54954dc1$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $fdeb65bc6ac4f138$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $3965999e3153758d$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $ec70854e9ee72ea6$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $b9fc7a6113852335$export$dd826089e3c5e502).instantAnimations || (0, $b9fc7a6113852335$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $c3b4f50b138c992b$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $387e962b4829eb62$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return new (0, $451bd42403650c47$export$b9855e2a7dee3dd2)(options);
    };





const $352b1be5144973e1$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $e2c1c6a0eb7f78a4$export$280dc01950909d86)
]);


/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $da8edcf7816ad614$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $da8edcf7816ad614$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $da8edcf7816ad614$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $fdeb65bc6ac4f138$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $69e77113a9a4699d$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $387e962b4829eb62$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $53658f9dcd580ff0$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $178708fc54954dc1$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $352b1be5144973e1$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $387e962b4829eb62$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $4b98a530c5a7abf5$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $7d3151800ad69edb$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $a3c3fdef404d6960$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $da8edcf7816ad614$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $7d3151800ad69edb$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $7d3151800ad69edb$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($7d3151800ad69edb$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($7d3151800ad69edb$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $7d3151800ad69edb$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $8f0b658b69b4af21$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $7d3151800ad69edb$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $7d3151800ad69edb$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $a3c3fdef404d6960$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $da8edcf7816ad614$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}




function $23a35d3b7816bb71$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $27eabd82e5f8bb03$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $7ef2354f04fdc0a2$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $7ef2354f04fdc0a2$export$1405a65085f40b9 = [
    "initial",
    ...$7ef2354f04fdc0a2$export$16e45afcc206d3a8
];


const $ae253654352505f4$var$numVariantProps = (0, $7ef2354f04fdc0a2$export$1405a65085f40b9).length;
function $ae253654352505f4$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $ae253654352505f4$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $ae253654352505f4$var$numVariantProps; i++){
        const name = (0, $7ef2354f04fdc0a2$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $27eabd82e5f8bb03$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}





const $2d97873b6092ec8d$var$reversePriorityOrder = [
    ...(0, $7ef2354f04fdc0a2$export$16e45afcc206d3a8)
].reverse();
const $2d97873b6092ec8d$var$numAnimationTypes = (0, $7ef2354f04fdc0a2$export$16e45afcc206d3a8).length;
function $2d97873b6092ec8d$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $8f0b658b69b4af21$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $2d97873b6092ec8d$export$bb53502b7a672aa8(visualElement) {
    let animate = $2d97873b6092ec8d$var$animateList(visualElement);
    let state = $2d97873b6092ec8d$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, $a3c3fdef404d6960$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $ae253654352505f4$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $2d97873b6092ec8d$var$numAnimationTypes; i++){
            const type = $2d97873b6092ec8d$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $27eabd82e5f8bb03$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $b5fd1366b4f513fc$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $2d97873b6092ec8d$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $e2038ba4791abdb2$export$9153ad4c4999f4a0)(next) && (0, $e2038ba4791abdb2$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $23a35d3b7816bb71$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $a3c3fdef404d6960$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $2d97873b6092ec8d$var$createState();
            isInitialRender = true;
        }
    };
}
function $2d97873b6092ec8d$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $23a35d3b7816bb71$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $2d97873b6092ec8d$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $2d97873b6092ec8d$var$createState() {
    return {
        animate: $2d97873b6092ec8d$var$createTypeState(true),
        whileInView: $2d97873b6092ec8d$var$createTypeState(),
        whileHover: $2d97873b6092ec8d$var$createTypeState(),
        whileTap: $2d97873b6092ec8d$var$createTypeState(),
        whileDrag: $2d97873b6092ec8d$var$createTypeState(),
        whileFocus: $2d97873b6092ec8d$var$createTypeState(),
        exit: $2d97873b6092ec8d$var$createTypeState()
    };
}


class $8305ccdccd0afa75$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $302e0b9ddebe011b$export$b45b3fe5caabdca extends (0, $8305ccdccd0afa75$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $2d97873b6092ec8d$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $b5fd1366b4f513fc$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
}



let $7c402878e64a6fb2$var$id = 0;
class $7c402878e64a6fb2$export$4989d1eb6104cc6c extends (0, $8305ccdccd0afa75$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $7c402878e64a6fb2$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $8e327b7630ac71bb$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $302e0b9ddebe011b$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $7c402878e64a6fb2$export$4989d1eb6104cc6c)
    }
};




function $c2b290304dc86347$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



const $6b9d13dad1edc8a6$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $29307a8560aca68e$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $29307a8560aca68e$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $6b9d13dad1edc8a6$export$a4cf9c8a4b063a6e)(event) && handler(event, $29307a8560aca68e$export$12f84bb882d06e1a(event));
};


function $32f4257e9e05c8c9$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $c2b290304dc86347$export$b1d829ddf82884aa)(target, eventName, (0, $29307a8560aca68e$export$c404e80f92c98d29)(handler), options);
}



/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $f71b7cff5a15c37a$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $f71b7cff5a15c37a$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $f71b7cff5a15c37a$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



const $0fb6be4162a48d3b$var$SCALE_PRECISION = 0.0001;
const $0fb6be4162a48d3b$var$SCALE_MIN = 1 - $0fb6be4162a48d3b$var$SCALE_PRECISION;
const $0fb6be4162a48d3b$var$SCALE_MAX = 1 + $0fb6be4162a48d3b$var$SCALE_PRECISION;
const $0fb6be4162a48d3b$var$TRANSLATE_PRECISION = 0.01;
const $0fb6be4162a48d3b$var$TRANSLATE_MIN = 0 - $0fb6be4162a48d3b$var$TRANSLATE_PRECISION;
const $0fb6be4162a48d3b$var$TRANSLATE_MAX = 0 + $0fb6be4162a48d3b$var$TRANSLATE_PRECISION;
function $0fb6be4162a48d3b$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $0fb6be4162a48d3b$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $0fb6be4162a48d3b$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $0fb6be4162a48d3b$export$c1c127004b72a37(target) / $0fb6be4162a48d3b$export$c1c127004b72a37(source);
    delta.translate = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $0fb6be4162a48d3b$var$SCALE_MIN && delta.scale <= $0fb6be4162a48d3b$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $0fb6be4162a48d3b$var$TRANSLATE_MIN && delta.translate <= $0fb6be4162a48d3b$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $0fb6be4162a48d3b$export$c0d25e96fc67d310(delta, source, target, origin) {
    $0fb6be4162a48d3b$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $0fb6be4162a48d3b$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $0fb6be4162a48d3b$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $0fb6be4162a48d3b$export$c1c127004b72a37(relative);
}
function $0fb6be4162a48d3b$export$426154f9d100f99(target, relative, parent) {
    $0fb6be4162a48d3b$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $0fb6be4162a48d3b$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $0fb6be4162a48d3b$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $0fb6be4162a48d3b$export$c1c127004b72a37(layout);
}
function $0fb6be4162a48d3b$export$2785bfcc929c5650(target, layout, parent) {
    $0fb6be4162a48d3b$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $0fb6be4162a48d3b$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}


const $b43337738e14403c$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $b43337738e14403c$export$3d227df54007d73a = ()=>({
        x: $b43337738e14403c$export$ff25708b37f72782(),
        y: $b43337738e14403c$export$ff25708b37f72782()
    });
const $b43337738e14403c$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $b43337738e14403c$export$6459fc9e86be362e = ()=>({
        x: $b43337738e14403c$export$6db76765312617ac(),
        y: $b43337738e14403c$export$6db76765312617ac()
    });


function $c1e0d2c734b3a4bd$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}



function $ed526c04b08ff5a7$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $ed526c04b08ff5a7$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$ed526c04b08ff5a7$var$isIdentityScale(scale) || !$ed526c04b08ff5a7$var$isIdentityScale(scaleX) || !$ed526c04b08ff5a7$var$isIdentityScale(scaleY);
}
function $ed526c04b08ff5a7$export$a545127cf1fbb600(values) {
    return $ed526c04b08ff5a7$export$bdf30dca883ea463(values) || $ed526c04b08ff5a7$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $ed526c04b08ff5a7$export$bf80f5f8f4dc327f(values) {
    return $ed526c04b08ff5a7$var$is2DTranslate(values.x) || $ed526c04b08ff5a7$var$is2DTranslate(values.y);
}
function $ed526c04b08ff5a7$var$is2DTranslate(value) {
    return value && value !== "0%";
}



/**
 * Scales a point based on a factor and an originPoint
 */ function $ef7ebabe57c445da$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $ef7ebabe57c445da$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $ef7ebabe57c445da$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $ef7ebabe57c445da$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $ef7ebabe57c445da$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $ef7ebabe57c445da$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $ef7ebabe57c445da$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $ef7ebabe57c445da$export$d80074982803af5c(box, { x: x, y: y }) {
    $ef7ebabe57c445da$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $ef7ebabe57c445da$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $ef7ebabe57c445da$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $ef7ebabe57c445da$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $ef7ebabe57c445da$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $ef7ebabe57c445da$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $ef7ebabe57c445da$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $ed526c04b08ff5a7$export$a545127cf1fbb600)(node.latestValues)) $ef7ebabe57c445da$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $ef7ebabe57c445da$var$TREE_SCALE_SNAP_MAX && treeScale.x > $ef7ebabe57c445da$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $ef7ebabe57c445da$var$TREE_SCALE_SNAP_MAX && treeScale.y > $ef7ebabe57c445da$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $ef7ebabe57c445da$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $ef7ebabe57c445da$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $ef7ebabe57c445da$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $ef7ebabe57c445da$export$58b16271041fbfb(box, transform) {
    $ef7ebabe57c445da$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $ef7ebabe57c445da$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $24ab0e0e24b64287$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $f71b7cff5a15c37a$export$d3955c6a8f65a36b)((0, $f71b7cff5a15c37a$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $24ab0e0e24b64287$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $24ab0e0e24b64287$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $ef7ebabe57c445da$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $ef7ebabe57c445da$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}


// Fixes https://github.com/motiondivision/motion/issues/2270
const $9eb31b6070aac940$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};


function $26ef0d60d3b80944$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $2bc8b7a73e822ef4$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $2bc8b7a73e822ef4$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $2bc8b7a73e822ef4$export$9f17032d917177de(a.x, b.x);
    const yDelta = $2bc8b7a73e822ef4$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}






/**
 * @internal
 */ class $95477f804f3531f6$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $95477f804f3531f6$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $2bc8b7a73e822ef4$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $387e962b4829eb62$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $95477f804f3531f6$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $387e962b4829eb62$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $95477f804f3531f6$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $95477f804f3531f6$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $6b9d13dad1edc8a6$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $29307a8560aca68e$export$12f84bb882d06e1a)(event);
        const initialInfo = $95477f804f3531f6$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $387e962b4829eb62$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $95477f804f3531f6$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $4a29a1eea6795867$export$a4627e546088548d)((0, $32f4257e9e05c8c9$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $32f4257e9e05c8c9$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $32f4257e9e05c8c9$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $387e962b4829eb62$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $95477f804f3531f6$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $95477f804f3531f6$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $95477f804f3531f6$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $95477f804f3531f6$var$subtractPoint(point, $95477f804f3531f6$var$lastDevicePoint(history)),
        offset: $95477f804f3531f6$var$subtractPoint(point, $95477f804f3531f6$var$startDevicePoint(history)),
        velocity: $95477f804f3531f6$var$getVelocity(history, 0.1)
    };
}
function $95477f804f3531f6$var$startDevicePoint(history) {
    return history[0];
}
function $95477f804f3531f6$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $95477f804f3531f6$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $95477f804f3531f6$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $b83ad11c9f2f0e28$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}






/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $61f19d02068772a9$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $61f19d02068772a9$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $61f19d02068772a9$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $61f19d02068772a9$export$690c180aa5775042(layoutBox.x, left, right),
        y: $61f19d02068772a9$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $61f19d02068772a9$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $61f19d02068772a9$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $61f19d02068772a9$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $61f19d02068772a9$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $61f19d02068772a9$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $0fb6be4162a48d3b$export$c1c127004b72a37)(source);
    const targetLength = (0, $0fb6be4162a48d3b$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $2f2f4493db258fd8$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $2f2f4493db258fd8$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $53314770db5036ad$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $61f19d02068772a9$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $61f19d02068772a9$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $61f19d02068772a9$export$7c5eaef8f4723d22(dragElastic = $61f19d02068772a9$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $61f19d02068772a9$export$a3366d3bac43a742;
    return {
        x: $61f19d02068772a9$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $61f19d02068772a9$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $61f19d02068772a9$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $61f19d02068772a9$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $61f19d02068772a9$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $61f19d02068772a9$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}




const $b072a71ba39cda28$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $b072a71ba39cda28$export$1b3dd616664938e4() {
    return $b072a71ba39cda28$export$9e9bc3c487fccc00.x || $b072a71ba39cda28$export$9e9bc3c487fccc00.y;
}


function $7408f4a517190c0d$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $b072a71ba39cda28$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $b072a71ba39cda28$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $b072a71ba39cda28$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $b072a71ba39cda28$export$9e9bc3c487fccc00).x || (0, $b072a71ba39cda28$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $b072a71ba39cda28$export$9e9bc3c487fccc00).x = (0, $b072a71ba39cda28$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $b072a71ba39cda28$export$9e9bc3c487fccc00).x = (0, $b072a71ba39cda28$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}




const $fff748d1b7bcc679$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $fff748d1b7bcc679$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $b43337738e14403c$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $29307a8560aca68e$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $7408f4a517190c0d$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $6b744e05f0de4bfc$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $0fb6be4162a48d3b$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $387e962b4829eb62$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $53658f9dcd580ff0$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $fff748d1b7bcc679$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>this.getAnimationState(axis) === "paused" && this.getAxisMotionValue(axis).animation?.play());
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $95477f804f3531f6$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $9eb31b6070aac940$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $387e962b4829eb62$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$fff748d1b7bcc679$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $61f19d02068772a9$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $26ef0d60d3b80944$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $61f19d02068772a9$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $61f19d02068772a9$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $61f19d02068772a9$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $26ef0d60d3b80944$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $4297b76cbf8999fe$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $24ab0e0e24b64287$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $61f19d02068772a9$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $f71b7cff5a15c37a$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $f71b7cff5a15c37a$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>{
            if (!$fff748d1b7bcc679$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $53658f9dcd580ff0$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $178708fc54954dc1$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).animation?.pause());
    }
    getAnimationState(axis) {
        return this.getAxisMotionValue(axis).animation?.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$fff748d1b7bcc679$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $26ef0d60d3b80944$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $61f19d02068772a9$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>{
            if (!$fff748d1b7bcc679$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $fff748d1b7bcc679$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $32f4257e9e05c8c9$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $26ef0d60d3b80944$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $387e962b4829eb62$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $c2b290304dc86347$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $61f19d02068772a9$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $fff748d1b7bcc679$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $fff748d1b7bcc679$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}



class $c1710e96d57da108$export$5d97dc2872682820 extends (0, $8305ccdccd0afa75$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $98e835e3ea32c222$export$8793edee2d425525);
        this.removeListeners = (0, $98e835e3ea32c222$export$8793edee2d425525);
        this.controls = new (0, $fff748d1b7bcc679$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $98e835e3ea32c222$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $9ec1d4365cbedab6$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $387e962b4829eb62$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $9ec1d4365cbedab6$export$b4f8f1ee75ce5859 extends (0, $8305ccdccd0afa75$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $98e835e3ea32c222$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $95477f804f3531f6$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $9eb31b6070aac940$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $9ec1d4365cbedab6$var$asyncHandler(onPanSessionStart),
            onStart: $9ec1d4365cbedab6$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $387e962b4829eb62$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $32f4257e9e05c8c9$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");



var $8nGP5 = parcelRequire("8nGP5");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $ddc51028fed2934d$export$da5f7b802957459a = (0, $8nGP5.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $9ce6b82f3d4768ba$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $ae38286a175dfa67$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $ae38286a175dfa67$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $6b744e05f0de4bfc$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $ae38286a175dfa67$export$fafff692be55225d(latest, node.target.x);
        const y = $ae38286a175dfa67$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $5f2184c7303769f4$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $70bb888b16a48b09$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $70bb888b16a48b09$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};



const $4dc2913629c0d77a$export$91ddd985b97788d1 = {};
function $4dc2913629c0d77a$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $4dc2913629c0d77a$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $d89df85a698547c2$export$9de1236619d9e756)(key)) $4dc2913629c0d77a$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}




const { schedule: $6a60ded26411f128$export$bb76eed83315504c, cancel: $6a60ded26411f128$export$3252729004b8456e } = /* @__PURE__ */ (0, $7f97733e1a341afa$export$510b0596a933801a)(queueMicrotask, false);


"use client";
class $d0d020f3457791dd$var$MeasureLayoutWithContext extends (0, $8nGP5.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $4dc2913629c0d77a$export$de9e7791c71225fd)($d0d020f3457791dd$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $9ce6b82f3d4768ba$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $387e962b4829eb62$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $6a60ded26411f128$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $d0d020f3457791dd$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $9faef52cd3d976c5$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $8nGP5.useContext)((0, $fe673f8fa917fb72$export$a3579ca508007a95));
    return (0, $kSbwP.jsx)($d0d020f3457791dd$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $8nGP5.useContext)((0, $ddc51028fed2934d$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $d0d020f3457791dd$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $ae38286a175dfa67$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $ae38286a175dfa67$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $ae38286a175dfa67$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $ae38286a175dfa67$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $ae38286a175dfa67$export$5eafb6257a5844c),
    boxShadow: (0, $5f2184c7303769f4$export$eb0bc629e74dcf8)
};





function $844f184c116daed3$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $221a83d60cc317b6$export$605d60a2578142d3)(value) ? value : (0, $9d12ee7f3a872cfa$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $178708fc54954dc1$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}



function $00eb26c2fb0e3a30$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}


const $675b68b52e64edc2$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;



class $1a3dd4c0dd4c5c9c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $3ac88bbc51d0aa7f$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $3ac88bbc51d0aa7f$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $675b68b52e64edc2$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $943c7982581d34e3$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $387e962b4829eb62$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $387e962b4829eb62$export$2cef06c20297c17d).setup(checkElapsed, true);
    return ()=>(0, $387e962b4829eb62$export$ec99c0ef4978dccb)(checkElapsed);
}
function $943c7982581d34e3$export$fcd451ca460f8a2a(callback, timeout) {
    return $943c7982581d34e3$export$1391212d75b2ee65(callback, (0, $b83ad11c9f2f0e28$export$fc3e7e8557f8c8c7)(timeout));
}



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $3aaa520a322b6f4b$export$fcc2206ecb6d74b(value) {
    return (0, $221a83d60cc317b6$export$605d60a2578142d3)(value) ? value.get() : value;
}







const $1746ab8ffa418a13$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $1746ab8ffa418a13$var$numBorders = $1746ab8ffa418a13$var$borders.length;
const $1746ab8ffa418a13$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $1746ab8ffa418a13$var$isPx = (value)=>typeof value === "number" || (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008).test(value);
function $1746ab8ffa418a13$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(0, lead.opacity ?? 1, $1746ab8ffa418a13$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, 0, $1746ab8ffa418a13$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $1746ab8ffa418a13$var$numBorders; i++){
        const borderLabel = `border${$1746ab8ffa418a13$var$borders[i]}Radius`;
        let followRadius = $1746ab8ffa418a13$var$getRadius(follow, borderLabel);
        let leadRadius = $1746ab8ffa418a13$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $1746ab8ffa418a13$var$isPx(followRadius) === $1746ab8ffa418a13$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)($1746ab8ffa418a13$var$asNumber(followRadius), $1746ab8ffa418a13$var$asNumber(leadRadius), progress), 0);
            if ((0, $6b744e05f0de4bfc$export$626336c2cd4b14de).test(leadRadius) || (0, $6b744e05f0de4bfc$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $1746ab8ffa418a13$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $1746ab8ffa418a13$var$easeCrossfadeIn = /*@__PURE__*/ $1746ab8ffa418a13$var$compress(0, 0.5, (0, $ee47a657ec5a96c1$export$c8d67a19199d1a50));
const $1746ab8ffa418a13$var$easeCrossfadeOut = /*@__PURE__*/ $1746ab8ffa418a13$var$compress(0.5, 0.95, (0, $98e835e3ea32c222$export$8793edee2d425525));
function $1746ab8ffa418a13$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $2f2f4493db258fd8$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $213e06d7217b780e$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $213e06d7217b780e$export$c53fd88f45d77e4b(box, originBox) {
    $213e06d7217b780e$export$a0230ae482601ae8(box.x, originBox.x);
    $213e06d7217b780e$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $213e06d7217b780e$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $39862aaa6869a5e8$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $ef7ebabe57c445da$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $ef7ebabe57c445da$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $39862aaa6869a5e8$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $6b744e05f0de4bfc$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $39862aaa6869a5e8$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $39862aaa6869a5e8$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $39862aaa6869a5e8$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $39862aaa6869a5e8$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $39862aaa6869a5e8$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $39862aaa6869a5e8$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $39862aaa6869a5e8$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $39862aaa6869a5e8$export$42b76f1d0d16d5b(box.x, transforms, $39862aaa6869a5e8$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $39862aaa6869a5e8$export$42b76f1d0d16d5b(box.y, transforms, $39862aaa6869a5e8$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $556830e5faab5d37$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $556830e5faab5d37$export$a7ec7642fe550fb6(delta) {
    return $556830e5faab5d37$var$isAxisDeltaZero(delta.x) && $556830e5faab5d37$var$isAxisDeltaZero(delta.y);
}
function $556830e5faab5d37$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $556830e5faab5d37$export$8d5cf76bb7daff09(a, b) {
    return $556830e5faab5d37$export$7a9a6f114ddd0fdb(a.x, b.x) && $556830e5faab5d37$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $556830e5faab5d37$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $556830e5faab5d37$export$ef641b782d85522(a, b) {
    return $556830e5faab5d37$export$22adf28bfca1c186(a.x, b.x) && $556830e5faab5d37$export$22adf28bfca1c186(a.y, b.y);
}
function $556830e5faab5d37$export$c5706146bc63213(box) {
    return (0, $0fb6be4162a48d3b$export$c1c127004b72a37)(box.x) / (0, $0fb6be4162a48d3b$export$c1c127004b72a37)(box.y);
}
function $556830e5faab5d37$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $408986eae9d0b280$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $3ac88bbc51d0aa7f$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $3ac88bbc51d0aa7f$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $75ef2ae43e80a3af$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}















const $5613b494116db61b$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $5613b494116db61b$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $5613b494116db61b$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $5613b494116db61b$var$animationTarget = 1000;
let $5613b494116db61b$var$id = 0;
function $5613b494116db61b$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $5613b494116db61b$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $69e77113a9a4699d$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $387e962b4829eb62$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $5613b494116db61b$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $5613b494116db61b$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $5613b494116db61b$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $72eda7ec592d7d0a$export$84ce9a476f53d110).value) $5613b494116db61b$var$metrics.nodes = $5613b494116db61b$var$metrics.calculatedTargetDeltas = $5613b494116db61b$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($5613b494116db61b$export$131f2f0cc5fe9609);
                this.nodes.forEach($5613b494116db61b$var$resolveTargetDelta);
                this.nodes.forEach($5613b494116db61b$var$calcProjection);
                this.nodes.forEach($5613b494116db61b$export$c2664f37bc951031);
                if ((0, $72eda7ec592d7d0a$export$84ce9a476f53d110).addProjectionMetrics) (0, $72eda7ec592d7d0a$export$84ce9a476f53d110).addProjectionMetrics($5613b494116db61b$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $1a3dd4c0dd4c5c9c$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $b1158bcc94bc3a85$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $00eb26c2fb0e3a30$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $943c7982581d34e3$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $9ce6b82f3d4768ba$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $9ce6b82f3d4768ba$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($5613b494116db61b$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $5613b494116db61b$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $556830e5faab5d37$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $fdeb65bc6ac4f138$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $5613b494116db61b$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $387e962b4829eb62$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($5613b494116db61b$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $5613b494116db61b$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($5613b494116db61b$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($5613b494116db61b$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($5613b494116db61b$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($5613b494116db61b$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($5613b494116db61b$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now();
            (0, $387e962b4829eb62$export$fff89137e9e818ce).delta = (0, $53314770db5036ad$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $387e962b4829eb62$export$fff89137e9e818ce).timestamp);
            (0, $387e962b4829eb62$export$fff89137e9e818ce).timestamp = now;
            (0, $387e962b4829eb62$export$fff89137e9e818ce).isProcessing = true;
            (0, $387e962b4829eb62$export$1811c3a7e3af92f0).update.process((0, $387e962b4829eb62$export$fff89137e9e818ce));
            (0, $387e962b4829eb62$export$1811c3a7e3af92f0).preRender.process((0, $387e962b4829eb62$export$fff89137e9e818ce));
            (0, $387e962b4829eb62$export$1811c3a7e3af92f0).render.process((0, $387e962b4829eb62$export$fff89137e9e818ce));
            (0, $387e962b4829eb62$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $6a60ded26411f128$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($5613b494116db61b$var$clearSnapshot);
            this.sharedNodes.forEach($5613b494116db61b$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $387e962b4829eb62$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $387e962b4829eb62$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $0fb6be4162a48d3b$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $0fb6be4162a48d3b$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $b43337738e14403c$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $556830e5faab5d37$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $ed526c04b08ff5a7$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $5613b494116db61b$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $b43337738e14403c$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some($5613b494116db61b$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $ef7ebabe57c445da$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $ef7ebabe57c445da$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $b43337738e14403c$export$6459fc9e86be362e)();
            (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $ef7ebabe57c445da$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $ef7ebabe57c445da$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $b43337738e14403c$export$6459fc9e86be362e)();
            (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $ef7ebabe57c445da$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $ed526c04b08ff5a7$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $ef7ebabe57c445da$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $ed526c04b08ff5a7$export$a545127cf1fbb600)(this.latestValues)) (0, $ef7ebabe57c445da$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $b43337738e14403c$export$6459fc9e86be362e)();
            (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $ed526c04b08ff5a7$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $ed526c04b08ff5a7$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $b43337738e14403c$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $39862aaa6869a5e8$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $ed526c04b08ff5a7$export$a545127cf1fbb600)(this.latestValues)) (0, $39862aaa6869a5e8$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $387e962b4829eb62$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $387e962b4829eb62$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $b43337738e14403c$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $b43337738e14403c$export$6459fc9e86be362e)();
                    (0, $0fb6be4162a48d3b$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $b43337738e14403c$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $b43337738e14403c$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $0fb6be4162a48d3b$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $ef7ebabe57c445da$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $b43337738e14403c$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $b43337738e14403c$export$6459fc9e86be362e)();
                    (0, $0fb6be4162a48d3b$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $72eda7ec592d7d0a$export$84ce9a476f53d110).value) $5613b494116db61b$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $ed526c04b08ff5a7$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $ed526c04b08ff5a7$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $387e962b4829eb62$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $ef7ebabe57c445da$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $b43337738e14403c$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $213e06d7217b780e$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $213e06d7217b780e$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $0fb6be4162a48d3b$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $556830e5faab5d37$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $556830e5faab5d37$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $72eda7ec592d7d0a$export$84ce9a476f53d110).value) $5613b494116db61b$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $b43337738e14403c$export$3d227df54007d73a)();
            this.projectionDelta = (0, $b43337738e14403c$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $b43337738e14403c$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $b43337738e14403c$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $b43337738e14403c$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($5613b494116db61b$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $5613b494116db61b$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $5613b494116db61b$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $0fb6be4162a48d3b$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $5613b494116db61b$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $556830e5faab5d37$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $b43337738e14403c$export$6459fc9e86be362e)();
                    (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $1746ab8ffa418a13$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $387e962b4829eb62$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $387e962b4829eb62$export$2cef06c20297c17d).update(()=>{
                (0, $9ce6b82f3d4768ba$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                (0, $f5260c4617872a79$export$d921fb2475e2900c).layout++;
                this.currentAnimation = (0, $844f184c116daed3$export$335a17c977067b99)(0, $5613b494116db61b$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $f5260c4617872a79$export$d921fb2475e2900c).layout--;
                    },
                    onComplete: ()=>{
                        (0, $f5260c4617872a79$export$d921fb2475e2900c).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($5613b494116db61b$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $5613b494116db61b$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $b43337738e14403c$export$6459fc9e86be362e)();
                const xLength = (0, $0fb6be4162a48d3b$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $0fb6be4162a48d3b$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $213e06d7217b780e$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $ef7ebabe57c445da$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $0fb6be4162a48d3b$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $408986eae9d0b280$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $5613b494116db61b$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $5613b494116db61b$var$transformAxes.length; i++){
                $5613b494116db61b$var$resetDistortingTransform(`rotate${$5613b494116db61b$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $5613b494116db61b$var$resetDistortingTransform(`skew${$5613b494116db61b$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $5613b494116db61b$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $3aaa520a322b6f4b$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $3aaa520a322b6f4b$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $ed526c04b08ff5a7$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $75ef2ae43e80a3af$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $4dc2913629c0d77a$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $4dc2913629c0d77a$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $3aaa520a322b6f4b$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach($5613b494116db61b$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $5613b494116db61b$var$updateLayout(node) {
    node.updateLayout();
}
function $5613b494116db61b$var$notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $0fb6be4162a48d3b$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($5613b494116db61b$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $c1e0d2c734b3a4bd$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $0fb6be4162a48d3b$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $b43337738e14403c$export$3d227df54007d73a)();
        (0, $0fb6be4162a48d3b$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $b43337738e14403c$export$3d227df54007d73a)();
        if (isShared) (0, $0fb6be4162a48d3b$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $0fb6be4162a48d3b$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $556830e5faab5d37$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $b43337738e14403c$export$6459fc9e86be362e)();
                    (0, $0fb6be4162a48d3b$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $b43337738e14403c$export$6459fc9e86be362e)();
                    (0, $0fb6be4162a48d3b$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $556830e5faab5d37$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $5613b494116db61b$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $72eda7ec592d7d0a$export$84ce9a476f53d110).value) $5613b494116db61b$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $5613b494116db61b$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $5613b494116db61b$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $5613b494116db61b$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $5613b494116db61b$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $5613b494116db61b$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $5613b494116db61b$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $5613b494116db61b$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $5613b494116db61b$var$calcProjection(node) {
    node.calcProjection();
}
function $5613b494116db61b$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $5613b494116db61b$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $5613b494116db61b$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $5613b494116db61b$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $79a02208d9f4fe13$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $5613b494116db61b$export$6ffd3e6ae339a132(output, from, to, p) {
    $5613b494116db61b$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $5613b494116db61b$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $5613b494116db61b$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $5613b494116db61b$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $5613b494116db61b$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $5613b494116db61b$var$roundPoint = $5613b494116db61b$var$userAgentContains("applewebkit/") && !$5613b494116db61b$var$userAgentContains("chrome/") ? Math.round : (0, $98e835e3ea32c222$export$8793edee2d425525);
function $5613b494116db61b$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $5613b494116db61b$var$roundPoint(axis.min);
    axis.max = $5613b494116db61b$var$roundPoint(axis.max);
}
function $5613b494116db61b$var$roundBox(box) {
    $5613b494116db61b$var$roundAxis(box.x);
    $5613b494116db61b$var$roundAxis(box.y);
}
function $5613b494116db61b$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $0fb6be4162a48d3b$export$28d0384c4b79bde2)((0, $556830e5faab5d37$export$c5706146bc63213)(snapshot), (0, $556830e5faab5d37$export$c5706146bc63213)(layout), 0.2);
}
function $5613b494116db61b$var$checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}




const $d946b1b824e9d073$export$2d029a49a09b6177 = (0, $5613b494116db61b$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $c2b290304dc86347$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $813d015a6d96f3da$export$b91509fcf893b648 = {
    current: undefined
};
const $813d015a6d96f3da$export$b61a9eb3dbde8858 = (0, $5613b494116db61b$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$813d015a6d96f3da$export$b91509fcf893b648.current) {
            const documentNode = new (0, $d946b1b824e9d073$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $813d015a6d96f3da$export$b91509fcf893b648.current = documentNode;
        }
        return $813d015a6d96f3da$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $4bcbc6f055679bbd$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $9ec1d4365cbedab6$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $c1710e96d57da108$export$5d97dc2872682820),
        ProjectionNode: (0, $813d015a6d96f3da$export$b61a9eb3dbde8858),
        MeasureLayout: $d0d020f3457791dd$export$779f5fb01ad751cd
    }
};





function $61a45cf96fa79e15$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $38548479cf8b1f6a$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $61a45cf96fa79e15$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $18209740d8becc1a$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $b072a71ba39cda28$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $18209740d8becc1a$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $38548479cf8b1f6a$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!$18209740d8becc1a$var$isValidHover(enterEvent)) return;
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!$18209740d8becc1a$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}



function $626d8c5443433aec$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $387e962b4829eb62$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $29307a8560aca68e$export$12f84bb882d06e1a)(event)));
}
class $626d8c5443433aec$export$93a81ea037eac456 extends (0, $8305ccdccd0afa75$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $18209740d8becc1a$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $626d8c5443433aec$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$626d8c5443433aec$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $eafb3942fd601eb7$export$d4826db40d47595b extends (0, $8305ccdccd0afa75$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $4a29a1eea6795867$export$a4627e546088548d)((0, $c2b290304dc86347$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $c2b290304dc86347$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}





/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $fa293858d91b2676$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $fa293858d91b2676$export$e841ada32ff745b(parent, child.parentElement);
};




const $0f74226ab872a8e5$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $0f74226ab872a8e5$export$5f6976e2f961e8b7(element) {
    return $0f74226ab872a8e5$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


const $7af08d4fbed3f667$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $44bc8be24bac6255$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $44bc8be24bac6255$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $44bc8be24bac6255$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $44bc8be24bac6255$var$filterEvents(()=>{
        if ((0, $7af08d4fbed3f667$export$7987404a4e35b84b).has(element)) return;
        $44bc8be24bac6255$var$firePointerEvent(element, "down");
        const handleKeyup = $44bc8be24bac6255$var$filterEvents(()=>{
            $44bc8be24bac6255$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$44bc8be24bac6255$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $72aac17210c8ec52$var$isValidPressEvent(event) {
    return (0, $6b9d13dad1edc8a6$export$a4cf9c8a4b063a6e)(event) && !(0, $b072a71ba39cda28$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $72aac17210c8ec52$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $38548479cf8b1f6a$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$72aac17210c8ec52$var$isValidPressEvent(startEvent) || (0, $7af08d4fbed3f667$export$7987404a4e35b84b).has(target)) return;
        (0, $7af08d4fbed3f667$export$7987404a4e35b84b).add(target);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if (!$72aac17210c8ec52$var$isValidPressEvent(endEvent) || !(0, $7af08d4fbed3f667$export$7987404a4e35b84b).has(target)) return;
            (0, $7af08d4fbed3f667$export$7987404a4e35b84b).delete(target);
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $fa293858d91b2676$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if (target instanceof HTMLElement) {
            target.addEventListener("focus", (event)=>(0, $44bc8be24bac6255$export$4b5790288fe12a79)(event, eventOptions));
            if (!(0, $0f74226ab872a8e5$export$5f6976e2f961e8b7)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}



function $c1a28ae3a75c3b4f$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $387e962b4829eb62$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $29307a8560aca68e$export$12f84bb882d06e1a)(event)));
}
class $c1a28ae3a75c3b4f$export$f026abdbba7f0c9e extends (0, $8305ccdccd0afa75$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $72aac17210c8ec52$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $c1a28ae3a75c3b4f$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$c1a28ae3a75c3b4f$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $8dfac5cba5ea88a3$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $8dfac5cba5ea88a3$var$observers = new WeakMap();
const $8dfac5cba5ea88a3$var$fireObserverCallback = (entry)=>{
    const callback = $8dfac5cba5ea88a3$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $8dfac5cba5ea88a3$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($8dfac5cba5ea88a3$var$fireObserverCallback);
};
function $8dfac5cba5ea88a3$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$8dfac5cba5ea88a3$var$observers.has(lookupRoot)) $8dfac5cba5ea88a3$var$observers.set(lookupRoot, {});
    const rootObservers = $8dfac5cba5ea88a3$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($8dfac5cba5ea88a3$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $8dfac5cba5ea88a3$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $8dfac5cba5ea88a3$var$initIntersectionObserver(options);
    $8dfac5cba5ea88a3$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $8dfac5cba5ea88a3$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $67cf2e0fb508babc$var$thresholdNames = {
    some: 0,
    all: 1
};
class $67cf2e0fb508babc$export$150851c8cc2f0c72 extends (0, $8305ccdccd0afa75$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $67cf2e0fb508babc$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $8dfac5cba5ea88a3$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($67cf2e0fb508babc$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $67cf2e0fb508babc$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $6869d559f90707f3$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $67cf2e0fb508babc$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $c1a28ae3a75c3b4f$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $eafb3942fd601eb7$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $626d8c5443433aec$export$93a81ea037eac456)
    }
};




const $85f5ba52203f4c65$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $813d015a6d96f3da$export$b61a9eb3dbde8858),
        MeasureLayout: $d0d020f3457791dd$export$779f5fb01ad751cd
    }
};



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $aa5403a3d7956be6$export$40f10139ecf1f171 = (0, $8nGP5.createContext)({
    strict: false
});




var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $87a9e6e364e49f20$export$2285bbca2c666415 = /* @__PURE__ */ (0, $8nGP5.createContext)({});



var $8nGP5 = parcelRequire("8nGP5");




function $ef5673eafa494c8f$export$4b3c3bd8d910d78d(props) {
    return (0, $b5fd1366b4f513fc$export$aa71198ceeaf53ce)(props.animate) || (0, $7ef2354f04fdc0a2$export$1405a65085f40b9).some((name)=>(0, $27eabd82e5f8bb03$export$720b90e312cea233)(props[name]));
}
function $ef5673eafa494c8f$export$ce46fa4165cdec40(props) {
    return Boolean($ef5673eafa494c8f$export$4b3c3bd8d910d78d(props) || props.variants);
}



function $c5ff92110f05c37c$export$12fc32fc096a04a3(props, context) {
    if ((0, $ef5673eafa494c8f$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $27eabd82e5f8bb03$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $27eabd82e5f8bb03$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $9af18525f2ea631b$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $c5ff92110f05c37c$export$12fc32fc096a04a3)(props, (0, $8nGP5.useContext)((0, $87a9e6e364e49f20$export$2285bbca2c666415)));
    return (0, $8nGP5.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $9af18525f2ea631b$var$variantLabelsAsDependency(initial),
        $9af18525f2ea631b$var$variantLabelsAsDependency(animate)
    ]);
}
function $9af18525f2ea631b$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}



const $9a239a7082c4a4f0$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $9a239a7082c4a4f0$export$65570e08d843624d = {};
for(const key in $9a239a7082c4a4f0$var$featureProps)$9a239a7082c4a4f0$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$9a239a7082c4a4f0$var$featureProps[key].some((name)=>!!props[name])
};



function $2b73e9d4e7da70e1$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $9a239a7082c4a4f0$export$65570e08d843624d)[key] = {
        ...(0, $9a239a7082c4a4f0$export$65570e08d843624d)[key],
        ...features[key]
    };
}


const $94a8289608c66b15$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $8nGP5 = parcelRequire("8nGP5");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $66d747fea638601b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $8nGP5.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $26ef0d60d3b80944$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $8nGP5 = parcelRequire("8nGP5");









function $a68e16eadc177155$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $8nGP5.useContext)((0, $87a9e6e364e49f20$export$2285bbca2c666415));
    const lazyContext = (0, $8nGP5.useContext)((0, $aa5403a3d7956be6$export$40f10139ecf1f171));
    const presenceContext = (0, $8nGP5.useContext)((0, $1593525ca75f11c2$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $8nGP5.useContext)((0, $713455ea2968d220$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $8nGP5.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $8nGP5.useContext)((0, $ddc51028fed2934d$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $a68e16eadc177155$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $8nGP5.useRef)(false);
    (0, $8nGP5.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $af2bab59b9c2447e$export$8592e1c077c890a6];
    const wantsHandoff = (0, $8nGP5.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, $b01929a085d77867$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $6a60ded26411f128$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $8nGP5.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $a68e16eadc177155$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $a68e16eadc177155$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $26ef0d60d3b80944$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $a68e16eadc177155$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $a68e16eadc177155$var$getClosestProjectingNode(visualElement.parent);
}



"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $9e6354a41764fe36$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $2b73e9d4e7da70e1$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $8nGP5.useContext)((0, $713455ea2968d220$export$22a697fb29aac98d)),
            ...props,
            layoutId: $9e6354a41764fe36$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $9af18525f2ea631b$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $93e8e69246a44ea3$export$4e09c449d6c407f7)) {
            $9e6354a41764fe36$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $9e6354a41764fe36$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $a68e16eadc177155$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $kSbwP.jsxs)((0, $87a9e6e364e49f20$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $kSbwP.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $66d747fea638601b$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    MotionComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, $8nGP5.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $94a8289608c66b15$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $9e6354a41764fe36$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $8nGP5.useContext)((0, $fe673f8fa917fb72$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $9e6354a41764fe36$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $8nGP5.useContext)((0, $aa5403a3d7956be6$export$40f10139ecf1f171)).strict;
}
function $9e6354a41764fe36$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $9a239a7082c4a4f0$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");


function $ef53c79b63d755d8$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $e2c1c6a0eb7f78a4$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $4dc2913629c0d77a$export$91ddd985b97788d1)[key] || key === "opacity");
}




/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $5d013abd14b7c19e$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $bb241ba47263b383$export$7d260a2a5f8bc19e = {
    ...(0, $f3163905ab1292a5$export$98e628dec113755e),
    transform: Math.round
};






const $4a78e04303bbe3e5$export$f2e4285fee37e26 = {
    rotate: (0, $6b744e05f0de4bfc$export$41fc368e1a942b97),
    rotateX: (0, $6b744e05f0de4bfc$export$41fc368e1a942b97),
    rotateY: (0, $6b744e05f0de4bfc$export$41fc368e1a942b97),
    rotateZ: (0, $6b744e05f0de4bfc$export$41fc368e1a942b97),
    scale: $f3163905ab1292a5$export$dcdf75081b88279d,
    scaleX: (0, $f3163905ab1292a5$export$dcdf75081b88279d),
    scaleY: (0, $f3163905ab1292a5$export$dcdf75081b88279d),
    scaleZ: (0, $f3163905ab1292a5$export$dcdf75081b88279d),
    skew: (0, $6b744e05f0de4bfc$export$41fc368e1a942b97),
    skewX: (0, $6b744e05f0de4bfc$export$41fc368e1a942b97),
    skewY: (0, $6b744e05f0de4bfc$export$41fc368e1a942b97),
    distance: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    translateX: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    translateY: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    translateZ: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    x: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    y: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    z: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    perspective: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    transformPerspective: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    opacity: (0, $f3163905ab1292a5$export$58f0f39f63f3cf42),
    originX: (0, $6b744e05f0de4bfc$export$44e2e1705876d7ed),
    originY: (0, $6b744e05f0de4bfc$export$44e2e1705876d7ed),
    originZ: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008)
};


const $f626fe36b04fe011$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    borderTopWidth: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    borderRightWidth: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    borderRadius: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    radius: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    maxWidth: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    height: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    maxHeight: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    top: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    right: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    bottom: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    left: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    paddingTop: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    paddingRight: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    paddingBottom: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    paddingLeft: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    margin: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    marginTop: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    marginRight: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    marginBottom: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    marginLeft: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    ...(0, $4a78e04303bbe3e5$export$f2e4285fee37e26),
    zIndex: (0, $bb241ba47263b383$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $f3163905ab1292a5$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $f3163905ab1292a5$export$58f0f39f63f3cf42),
    numOctaves: (0, $bb241ba47263b383$export$7d260a2a5f8bc19e)
};


const $009708e30b40c120$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $009708e30b40c120$var$numTransforms = (0, $e2c1c6a0eb7f78a4$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $009708e30b40c120$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $009708e30b40c120$var$numTransforms; i++){
        const key = (0, $e2c1c6a0eb7f78a4$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $5d013abd14b7c19e$export$453ef540a9a1bd6b)(value, (0, $f626fe36b04fe011$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $009708e30b40c120$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $f0874d9e3dd1a697$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $e2c1c6a0eb7f78a4$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $d89df85a698547c2$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $5d013abd14b7c19e$export$453ef540a9a1bd6b)(value, (0, $f626fe36b04fe011$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $009708e30b40c120$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $2415b7777d8a1ba7$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $a3e77b3807c9985b$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $221a83d60cc317b6$export$605d60a2578142d3)(source[key]) && !(0, $ef53c79b63d755d8$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $a3e77b3807c9985b$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $8nGP5.useMemo)(()=>{
        const state = (0, $2415b7777d8a1ba7$export$8940b483cf52eeda)();
        (0, $f0874d9e3dd1a697$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $a3e77b3807c9985b$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $a3e77b3807c9985b$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $a3e77b3807c9985b$var$useInitialMotionValues(props, visualState));
    return style;
}
function $a3e77b3807c9985b$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $a3e77b3807c9985b$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $0dfede93d1e1136e$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $0dfede93d1e1136e$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $0dfede93d1e1136e$var$validMotionProps.has(key);
}


let $790bf7bef303b2f0$var$shouldForward = (key)=>!(0, $0dfede93d1e1136e$export$2f9c46555243bf04)(key);
function $790bf7bef303b2f0$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $790bf7bef303b2f0$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $0dfede93d1e1136e$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $790bf7bef303b2f0$export$59d6962c470509a5((parcelRequire("4kwnA")).default);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $790bf7bef303b2f0$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($790bf7bef303b2f0$var$shouldForward(key) || forwardMotionProps === true && (0, $0dfede93d1e1136e$export$2f9c46555243bf04)(key) || !isDom && !(0, $0dfede93d1e1136e$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $273c677e66eec3d9$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $13d096ec2866c028$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $273c677e66eec3d9$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



var $8nGP5 = parcelRequire("8nGP5");



const $0576f3ca76ab86e3$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $0576f3ca76ab86e3$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $0576f3ca76ab86e3$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $0576f3ca76ab86e3$var$dashKeys : $0576f3ca76ab86e3$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}



function $95944a5bc8633925$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $95944a5bc8633925$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $95944a5bc8633925$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $95944a5bc8633925$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $f82eed7e52359908$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $f0874d9e3dd1a697$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $95944a5bc8633925$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $0576f3ca76ab86e3$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $2f5a1fc1585b49ba$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $2415b7777d8a1ba7$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $ec53bb4a809701f5$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $332f4460f0c79816$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $8nGP5.useMemo)(()=>{
        const state = (0, $2f5a1fc1585b49ba$export$41be8b43e1c4d4f9)();
        (0, $f82eed7e52359908$export$5475d24f125d7053)(state, visualState, (0, $ec53bb4a809701f5$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $a3e77b3807c9985b$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $5ccd209805384657$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $13d096ec2866c028$export$88f3fc2fd3766989)(Component) ? (0, $332f4460f0c79816$export$84309c4f53cb1bd5) : (0, $a3e77b3807c9985b$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $790bf7bef303b2f0$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $8nGP5.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $8nGP5.useMemo)(()=>(0, $221a83d60cc317b6$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $8nGP5.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}




var $8nGP5 = parcelRequire("8nGP5");







function $1ff063e4e08e7832$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onUpdate: onUpdate }, props, context, presenceContext) {
    const state = {
        latestValues: $1ff063e4e08e7832$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onUpdate) {
        /**
         * onMount works without the VisualElement because it could be
         * called before the VisualElement payload has been hydrated.
         * (e.g. if someone is using m components <m.circle />)
         */ state.onMount = (instance)=>onUpdate({
                props: props,
                current: instance,
                ...state
            });
        state.onUpdate = (visualElement)=>onUpdate(visualElement);
    }
    return state;
}
const $1ff063e4e08e7832$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $8nGP5.useContext)((0, $87a9e6e364e49f20$export$2285bbca2c666415));
        const presenceContext = (0, $8nGP5.useContext)((0, $1593525ca75f11c2$export$f224e4635b6f8ce2));
        const make = ()=>$1ff063e4e08e7832$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $9605b32971d7a0ac$export$fe4300aa8eebea86)(make);
    };
function $1ff063e4e08e7832$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $3aaa520a322b6f4b$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $ef5673eafa494c8f$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $ef5673eafa494c8f$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $b5fd1366b4f513fc$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $b4ca5246706cedf8$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}




function $b52ed3dbb049aaf7$export$16da615486abaa45(props, prevProps, visualElement) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $221a83d60cc317b6$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $221a83d60cc317b6$export$605d60a2578142d3)(prevProps.style[key]) || (0, $ef53c79b63d755d8$export$6d27ce8e3de1c3cf)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}



const $57e1f62c9a4397b0$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $1ff063e4e08e7832$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $b52ed3dbb049aaf7$export$16da615486abaa45,
        createRenderState: (0, $2415b7777d8a1ba7$export$8940b483cf52eeda)
    })
};






function $dc0b91a944ffaa48$export$c01c3c7cdbf4420c(instance, renderState) {
    try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
    } catch (e) {
        // Most likely trying to measure an unrendered element under Firefox
        renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}



function $41db6385064bce06$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $5c1fea87700c5fa8$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $652d389c469f9d0b$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $41db6385064bce06$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $5c1fea87700c5fa8$export$28931db5d57958e5).has(key) ? (0, $535a806ef4f02e20$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $cfca0d243c2a2888$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $b52ed3dbb049aaf7$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $221a83d60cc317b6$export$605d60a2578142d3)(props[key]) || (0, $221a83d60cc317b6$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $e2c1c6a0eb7f78a4$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}




const $4171197922c83279$var$layoutProps = [
    "x",
    "y",
    "width",
    "height",
    "cx",
    "cy",
    "r"
];
const $4171197922c83279$export$44dabd3fae512e85 = {
    useVisualState: (0, $1ff063e4e08e7832$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $cfca0d243c2a2888$export$16da615486abaa45),
        createRenderState: (0, $2f5a1fc1585b49ba$export$41be8b43e1c4d4f9),
        onUpdate: ({ props: props, prevProps: prevProps, current: current, renderState: renderState, latestValues: latestValues })=>{
            if (!current) return;
            let hasTransform = !!props.drag;
            if (!hasTransform) {
                for(const key in latestValues)if ((0, $e2c1c6a0eb7f78a4$export$7b42a0094fb00b6e).has(key)) {
                    hasTransform = true;
                    break;
                }
            }
            if (!hasTransform) return;
            let needsMeasure = !prevProps;
            if (prevProps) /**
                 * Check the layout props for changes, if any are found we need to
                 * measure the element again.
                 */ for(let i = 0; i < $4171197922c83279$var$layoutProps.length; i++){
                const key = $4171197922c83279$var$layoutProps[i];
                if (props[key] !== prevProps[key]) needsMeasure = true;
            }
            if (!needsMeasure) return;
            (0, $387e962b4829eb62$export$2cef06c20297c17d).read(()=>{
                (0, $dc0b91a944ffaa48$export$c01c3c7cdbf4420c)(current, renderState);
                (0, $387e962b4829eb62$export$2cef06c20297c17d).render(()=>{
                    (0, $f82eed7e52359908$export$5475d24f125d7053)(renderState, latestValues, (0, $ec53bb4a809701f5$export$6328ce7565ea1049)(current.tagName), props.transformTemplate);
                    (0, $652d389c469f9d0b$export$c5f8399d19a7394b)(current, renderState);
                });
            });
        }
    })
};


function $a15ba4523f4afb0b$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $13d096ec2866c028$export$88f3fc2fd3766989)(Component) ? (0, $4171197922c83279$export$44dabd3fae512e85) : (0, $57e1f62c9a4397b0$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $5ccd209805384657$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $9e6354a41764fe36$export$c3ad4a902bccc2d8)(config);
    };
}



var $8nGP5 = parcelRequire("8nGP5");





// Does this device prefer reduced motion? Returns `null` server-side.
const $b9fd308fb80080ff$export$ff7706047246b98b = {
    current: null
};
const $b9fd308fb80080ff$export$6476d16e2fd2d0db = {
    current: false
};


function $12b64d959b51e03f$export$ca9f41fb23dded3d() {
    (0, $b9fd308fb80080ff$export$6476d16e2fd2d0db).current = true;
    if (!(0, $93e8e69246a44ea3$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $b9fd308fb80080ff$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $b9fd308fb80080ff$export$ff7706047246b98b).current = false;
}




const $12f50e0aaf86a1bf$export$bc2a978a17abfdde = new WeakMap();






function $8bb8b1e65a5d26c0$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $221a83d60cc317b6$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $221a83d60cc317b6$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $9d12ee7f3a872cfa$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $9d12ee7f3a872cfa$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}









/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $315d917b92f176e9$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $b728879e58e88ea9$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);




/**
 * ValueType for "auto"
 */ const $ebc7194e12a74cd2$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};




/**
 * Tests a provided value against a ValueType
 */ const $07f968c230041b87$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $37c1943a59f280a0$export$d176691c1998a1f5 = [
    (0, $f3163905ab1292a5$export$98e628dec113755e),
    (0, $6b744e05f0de4bfc$export$91c0eda1d06bf008),
    (0, $6b744e05f0de4bfc$export$626336c2cd4b14de),
    (0, $6b744e05f0de4bfc$export$41fc368e1a942b97),
    (0, $6b744e05f0de4bfc$export$aed3d7b7d206c196),
    (0, $6b744e05f0de4bfc$export$f91e8c45a95a32f2),
    (0, $ebc7194e12a74cd2$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $37c1943a59f280a0$export$eefdd52e3ccae428 = (v)=>$37c1943a59f280a0$export$d176691c1998a1f5.find((0, $07f968c230041b87$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $9381d1f97410d723$var$valueTypes = [
    ...(0, $37c1943a59f280a0$export$d176691c1998a1f5),
    (0, $758878c83ce9baef$export$35e9368ef982300f),
    (0, $70bb888b16a48b09$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $9381d1f97410d723$export$950e7e59ea1ffed7 = (v)=>$9381d1f97410d723$var$valueTypes.find((0, $07f968c230041b87$export$6eae4d0a6a7ca7cd)(v));






/**
 * Properties that should default to 1 or 100%
 */ const $1e608d6ab6e1ff7e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $1e608d6ab6e1ff7e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $b0f17c1e240ca22d$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $1e608d6ab6e1ff7e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $1e608d6ab6e1ff7e$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $1e608d6ab6e1ff7e$export$3dea766d36a8935f = {
    ...(0, $70bb888b16a48b09$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($1e608d6ab6e1ff7e$var$functionRegex);
        return functions ? functions.map($1e608d6ab6e1ff7e$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $341cf6864f7aebdc$export$98cd7c72c5a731fb = {
    ...(0, $f626fe36b04fe011$export$eec14432cd1cb67b),
    color: // Color props
    $758878c83ce9baef$export$35e9368ef982300f,
    backgroundColor: (0, $758878c83ce9baef$export$35e9368ef982300f),
    outlineColor: (0, $758878c83ce9baef$export$35e9368ef982300f),
    fill: (0, $758878c83ce9baef$export$35e9368ef982300f),
    stroke: (0, $758878c83ce9baef$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $758878c83ce9baef$export$35e9368ef982300f),
    borderTopColor: (0, $758878c83ce9baef$export$35e9368ef982300f),
    borderRightColor: (0, $758878c83ce9baef$export$35e9368ef982300f),
    borderBottomColor: (0, $758878c83ce9baef$export$35e9368ef982300f),
    borderLeftColor: (0, $758878c83ce9baef$export$35e9368ef982300f),
    filter: $1e608d6ab6e1ff7e$export$3dea766d36a8935f,
    WebkitFilter: (0, $1e608d6ab6e1ff7e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $341cf6864f7aebdc$export$67d1babe0338d23b = (key)=>$341cf6864f7aebdc$export$98cd7c72c5a731fb[key];


function $b3df530fbdb3d517$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $341cf6864f7aebdc$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $1e608d6ab6e1ff7e$export$3dea766d36a8935f)) defaultValueType = (0, $70bb888b16a48b09$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



const $d494b624afe98249$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $d494b624afe98249$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $4288128b38ea7b9e$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $5d2a0d34ff92fdfa$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $387e962b4829eb62$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState, onUpdate: onUpdate } = visualState;
        this.onUpdate = onUpdate;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $ef5673eafa494c8f$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $ef5673eafa494c8f$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $221a83d60cc317b6$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $12f50e0aaf86a1bf$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $b9fd308fb80080ff$export$6476d16e2fd2d0db).current) (0, $12b64d959b51e03f$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $b9fd308fb80080ff$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $387e962b4829eb62$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $387e962b4829eb62$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $e2c1c6a0eb7f78a4$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $387e962b4829eb62$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $9a239a7082c4a4f0$export$65570e08d843624d){
            const featureDefinition = (0, $9a239a7082c4a4f0$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $b43337738e14403c$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $d494b624afe98249$var$propEventHandlers.length; i++){
            const key = $d494b624afe98249$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $8bb8b1e65a5d26c0$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
        this.onUpdate && this.onUpdate(this);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $9d12ee7f3a872cfa$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $315d917b92f176e9$export$65583ed5a868f2d9)(value) || (0, $b728879e58e88ea9$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $9381d1f97410d723$export$950e7e59ea1ffed7)(value) && (0, $70bb888b16a48b09$export$83a0e34f1302825b).test(target)) value = (0, $b3df530fbdb3d517$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $221a83d60cc317b6$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $221a83d60cc317b6$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $b4ca5246706cedf8$export$d68f140c4d9b48bc)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $221a83d60cc317b6$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $b1158bcc94bc3a85$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}







/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $e3a421377b26a85e$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $e3a421377b26a85e$export$b9f0c1f373aee2b0(current) {
    const match = $e3a421377b26a85e$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $e3a421377b26a85e$var$maxDepth = 4;
function $e3a421377b26a85e$export$289398774300c991(current, element, depth = 1) {
    (0, $4297b76cbf8999fe$export$f5708dca728d7177)(depth <= $e3a421377b26a85e$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $e3a421377b26a85e$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $315d917b92f176e9$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $d89df85a698547c2$export$31f9caa2600b5723)(fallback) ? $e3a421377b26a85e$export$289398774300c991(fallback, element, depth + 1) : fallback;
}





function $eba7ff1bfd9bac1b$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $b728879e58e88ea9$export$ade84c85e44a6cb1)(value);
    else return true;
}




/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $8108f9aa8f5e9870$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $8108f9aa8f5e9870$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$8108f9aa8f5e9870$var$invalidTemplates.has(keyframe) && (0, $70bb888b16a48b09$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $b3df530fbdb3d517$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $0b2d55e836a983dc$export$4983792d11b61017 extends (0, $4288128b38ea7b9e$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $d89df85a698547c2$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $e3a421377b26a85e$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $352b1be5144973e1$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $37c1943a59f280a0$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $37c1943a59f280a0$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $b05d7afcfc74671f$export$8e5250d1aa9bf370)(originType) && (0, $b05d7afcfc74671f$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $eba7ff1bfd9bac1b$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $8108f9aa8f5e9870$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $b05d7afcfc74671f$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $b05d7afcfc74671f$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


class $3abf0c76ef714a9d$export$e49735c2a366bdc7 extends (0, $d494b624afe98249$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $0b2d55e836a983dc$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $221a83d60cc317b6$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}








function $eafd2472f96695d2$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $eafd2472f96695d2$export$23fea75b03ac16b3 extends (0, $3abf0c76ef714a9d$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $41db6385064bce06$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $e2c1c6a0eb7f78a4$export$7b42a0094fb00b6e).has(key)) return (0, $77539a1b389798aa$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $eafd2472f96695d2$export$3735103072e4a80(instance);
            const value = ((0, $d89df85a698547c2$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $24ab0e0e24b64287$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $f0874d9e3dd1a697$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $b52ed3dbb049aaf7$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}














class $f33d86a5a15f43af$export$86bcdffbaf733d84 extends (0, $3abf0c76ef714a9d$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $b43337738e14403c$export$6459fc9e86be362e);
        this.updateDimensions = ()=>{
            if (this.current && !this.renderState.dimensions) (0, $dc0b91a944ffaa48$export$c01c3c7cdbf4420c)(this.current, this.renderState);
        };
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $e2c1c6a0eb7f78a4$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $341cf6864f7aebdc$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $5c1fea87700c5fa8$export$28931db5d57958e5).has(key) ? (0, $535a806ef4f02e20$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $cfca0d243c2a2888$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    onBindTransform() {
        if (this.current && !this.renderState.dimensions) (0, $387e962b4829eb62$export$2cef06c20297c17d).postRender(this.updateDimensions);
    }
    build(renderState, latestValues, props) {
        (0, $f82eed7e52359908$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $652d389c469f9d0b$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $ec53bb4a809701f5$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $b7d313b49ffe579b$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $13d096ec2866c028$export$88f3fc2fd3766989)(Component) ? new (0, $f33d86a5a15f43af$export$86bcdffbaf733d84)(options) : new (0, $eafd2472f96695d2$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $8nGP5.Fragment)
    });
};


const $8ba6d514c7d4d15c$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $a15ba4523f4afb0b$export$d86feac869a7f0d5)({
    ...(0, $8e327b7630ac71bb$export$7f9953c70dacfd7f),
    ...(0, $6869d559f90707f3$export$e5b72898e5a201f1),
    ...(0, $4bcbc6f055679bbd$export$d7d5d435647ed5a0),
    ...(0, $85f5ba52203f4c65$export$b3219800bda33a1f)
}, (0, $b7d313b49ffe579b$export$56ba0183203348f5));


const $6cfc56d35eab895f$export$e25e478948902b8b = /*@__PURE__*/ (0, $75379e3c6646eee5$export$3af29c0efb268f04)((0, $8ba6d514c7d4d15c$export$46b7e4b9dc6110c3));



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

var $2DQiR = parcelRequire("2DQiR");
const $c4a354b5f13f3380$export$3ac10165e82bcbe7 = (props)=>{
    const containerRef = (0, $8nGP5.useRef)(null);
    const lottieInstance = (0, $8nGP5.useRef)(null);
    const animationData = props.data;
    const callbackRef = (0, $8nGP5.useRef)(props.onFrame);
    (0, $8nGP5.useEffect)(()=>{
        callbackRef.current = props.onFrame;
    }, [
        props.onFrame
    ]);
    (0, $8nGP5.useEffect)(()=>{
        var _a;
        if (containerRef.current) {
            console.log('Create LOTTIE');
            lottieInstance.current = (0, (/*@__PURE__*/$parcel$interopDefault($2DQiR))).loadAnimation({
                container: containerRef.current,
                renderer: 'svg',
                autoplay: true,
                animationData: animationData
            });
        }
        const onEnterFrame = ()=>{
            var _a;
            const animation = lottieInstance.current;
            if (callbackRef.current) (_a = callbackRef.current) === null || _a === void 0 || _a.call(callbackRef, animation);
        };
        (_a = lottieInstance.current) === null || _a === void 0 || _a.addEventListener('enterFrame', onEnterFrame);
        return ()=>{
            var _a, _b;
            (_a = lottieInstance.current) === null || _a === void 0 || _a.removeEventListener('enterFrame', onEnterFrame);
            (_b = lottieInstance.current) === null || _b === void 0 || _b.destroy();
        };
    }, [
        containerRef.current,
        animationData
    ]);
    const play = ()=>{
        var _a;
        return (_a = lottieInstance.current) === null || _a === void 0 ? void 0 : _a.play();
    };
    const pause = ()=>{
        var _a;
        return (_a = lottieInstance.current) === null || _a === void 0 ? void 0 : _a.pause();
    };
    const stop = ()=>{
        var _a;
        return (_a = lottieInstance.current) === null || _a === void 0 ? void 0 : _a.stop();
    };
    const goToFrame = (frame)=>{
        var _a;
        return (_a = lottieInstance.current) === null || _a === void 0 ? void 0 : _a.goToAndStop(frame, true);
    };
    return (0, $kSbwP.jsx)("div", {
        onClick: props.onClick,
        style: {
            width: props.width,
            height: props.height
        },
        children: (0, $kSbwP.jsx)("div", {
            ref: containerRef
        })
    });
};



var $a543ba419c39c04a$exports = {};
$a543ba419c39c04a$exports = JSON.parse('{"v":"5.6.10","fr":60,"ip":0,"op":211,"w":1500,"h":1500,"nm":"Composicao  Cheked SB","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"check contornos","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[732.561,693.224,0],"ix":2},"a":{"a":0,"k":[562.5,1218,0],"ix":1},"s":{"a":0,"k":[46.002,46.002,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[387.664,-266.519],[-145.373,266.519],[-387.664,24.229]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":200,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[624.336,1356.333],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":150,"s":[30,30],"e":[100.956,100.956]},{"t":181}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Grupo 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":100,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":150,"s":[100],"e":[0]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Aparar caminhos 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Tracos 12","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":690,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Tracos 11","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":660,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Tracos 10","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":630,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Tracos 9","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":600,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Tracos 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":570,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Tracos 7","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":540,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Tracos 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":510,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Tracos 5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":480,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Tracos 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":450,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Tracos 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":420,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Tracos 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":390,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Tracos","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":360,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"Ellipse Success","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[750,750,0],"ix":2},"a":{"a":0,"k":[15,-11,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":25,"s":[400,400],"e":[300,300]},{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":35,"s":[300,300],"e":[400,400]},{"t":53}],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Caminho da elipse 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588237047,0.878431379795,0.560784339905,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[15,-11],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Elipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0],"e":[100]},{"t":25}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Borda","mn":"ADBE Vector Graphic - Stroke","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"Ellipse Expand","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[750,750,0],"ix":2},"a":{"a":0,"k":[15,-11,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":150,"s":[100,100],"e":[899,899]},{"t":181}],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Caminho da elipse 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":4},"o":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":150,"s":[0],"e":[100]},{"t":181}],"ix":5},"r":1,"bm":0,"nm":"Preenchimento 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[15,-11],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Elipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"Ellipse Initial","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[750,750,0],"ix":2},"a":{"a":0,"k":[15,-11,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":137,"s":[900,900],"e":[700,700]},{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":150,"s":[700,700],"e":[900,900]},{"t":181}],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Caminho da elipse 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":50,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[15,-11],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Elipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":91,"s":[0.1],"e":[100]},{"t":137}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":50,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Borda","mn":"ADBE Vector Graphic - Stroke","hd":false}],"ip":91,"op":391,"st":91,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"Initial Loading","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[750,750,0],"ix":2},"a":{"a":0,"k":[15,-11,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[900,900],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Caminho da elipse 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.203921568627,0.121568627451,0.592156862745,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":50,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[15,-11],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Elipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0],"e":[99.9]},{"t":90}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0.1],"e":[100]},{"t":86}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.203921568627,0.121568627451,0.592156862745,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":50,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Borda","mn":"ADBE Vector Graphic - Stroke","hd":false}],"ip":0,"op":91,"st":0,"bm":0}],"markers":[]}');


var $d8d03341d2feac10$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d8d03341d2feac10$var$getIsFileReady = (doc)=>{
    if (doc.status == 'error') return true;
    if (doc.status == 'completed') {
        if ((doc === null || doc === void 0 ? void 0 : doc.ragStatus) == 'completed') return true;
    }
    return false;
};
const $d8d03341d2feac10$var$ProcessingAnimation = ()=>{
    const [isPresent, safeToRemove] = (0, $9faef52cd3d976c5$export$2a8c16d82a0a0e26)();
    const [didFinishAnimation, setDidFinishAnimation] = (0, $8nGP5.useState)(false);
    const isAnimOut = !isPresent;
    const onEnterFrame = (lottie)=>{
        const frame = lottie.currentFrame;
        if (isPresent && frame > 84) lottie.goToAndPlay(0, true);
        else if (frame > 200) {
            lottie.goToAndStop(200, true);
            setTimeout(()=>{
                setDidFinishAnimation(true);
            }, 500);
        }
    };
    (0, $8nGP5.useEffect)(()=>{
        if (!isPresent && didFinishAnimation) safeToRemove();
    }, [
        isPresent,
        didFinishAnimation
    ]);
    return (0, $kSbwP.jsx)((0, $c4a354b5f13f3380$export$3ac10165e82bcbe7), {
        width: 50,
        height: 50,
        data: (0, (/*@__PURE__*/$parcel$interopDefault($a543ba419c39c04a$exports))),
        onFrame: onEnterFrame
    });
};
const $d8d03341d2feac10$var$ProjectFileButtons = (props)=>{
    const viewBtn = (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).button('View', (file)=>{
        props.onView();
    });
    function makeDeleteButton(isEnabled) {
        return (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).button('Delete', (file)=>{
            props.onDelete();
        }, null, isEnabled);
    }
    const deleteBtn = makeDeleteButton(props.deleteEnabled);
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        fillCell: true,
        justify: "around",
        style: {
            gap: '10px',
            marginRight: '5px'
        },
        children: [
            viewBtn,
            deleteBtn
        ]
    });
};
const $d8d03341d2feac10$export$3605042b726118fb = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    var _a;
    const [loadedOnMount, setLoadedOnMount] = (0, $8nGP5.useState)(null);
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const projectFilesRaw = ((_a = store.projectFiles) === null || _a === void 0 ? void 0 : _a.files) || {};
    const knowledgeFiles = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().projectKnowledgeFiles || {};
    const projectFileKeys = Object.keys(projectFilesRaw);
    const knowledgeFileKeys = Object.keys(knowledgeFiles);
    if (loadedOnMount == null) {
        var loaded = {};
        projectFileKeys.forEach((key)=>{
            const file = projectFilesRaw[key];
            loaded[key] = $d8d03341d2feac10$var$getIsFileReady(file);
        });
        knowledgeFileKeys.forEach((key)=>{
            loaded[key] = true;
        });
        setLoadedOnMount(loaded);
    }
    const query = store.query;
    const reportId = store.selectedReportId;
    const companyName = store.query.companyName;
    const targetUploadStorage = {
        type: 'rag',
        reportId: reportId
    };
    function seeProjectFile(fileKey) {
        if (fileKey === store.selectedReportId) props.requestSeeFile(query.value('pdfViewUrl'), fileKey);
        else {
            const fileUrl = projectFilesRaw[fileKey].url;
            props.requestSeeFile(fileUrl, fileKey);
        }
    }
    function seeKnowledgeFile(fileKey) {
        const f = knowledgeFiles[fileKey];
        props.requestSeeFile(f.url, f.fileName);
    }
    function deleteFile(fileKey) {
        const areYouSure = window.confirm('Are you sure you want to delete this file? ' + fileKey);
        function deleteFile() {
            return $d8d03341d2feac10$var$__awaiter(this, void 0, void 0, function*() {
                const storage = (0, $fa12c9399a1a76ec$export$39e0a5bed87a3667)();
                const deleteFileName = projectFilesRaw[fileKey].filename;
                storage.deleteFileFromStorage(targetUploadStorage, deleteFileName);
                const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                fb.deleteProjectFile(reportId, fileKey);
                fb.triggerScanRagFiles();
            });
        }
        if (areYouSure) deleteFile();
    }
    const columns = [
        {
            column: {
                source: null,
                display: 'Topics'
            },
            style: {
                justifyContent: 'start',
                alignItems: 'start'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            overrideValue: (field, column)=>{
                var _a, _b;
                const doc = projectFilesRaw[field.source];
                if (doc.status === 'error') return [
                    'Failed to process file'
                ];
                return (_b = (_a = doc === null || doc === void 0 ? void 0 : doc.summary) === null || _a === void 0 ? void 0 : _a.topics) !== null && _b !== void 0 ? _b : [];
            }
        },
        {
            column: {
                source: 'saveKey',
                display: 'View'
            },
            element: (row, col, data)=>{
                const doc = projectFilesRaw[row.field.source];
                const isFileReady = $d8d03341d2feac10$var$getIsFileReady(doc);
                var elm = null;
                const baseMotionConfig = {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    }
                };
                if (isFileReady) {
                    const delay = loadedOnMount[row.field.source] ? 0 : 5.0;
                    if (delay > 0) console.log('delay', delay, row.field.source);
                    elm = /*#__PURE__*/ (0, $8nGP5.createElement)((0, $6cfc56d35eab895f$export$e25e478948902b8b).div, Object.assign({}, baseMotionConfig, {
                        key: doc.saveKey,
                        transition: {
                            duration: 0.3,
                            delay: delay
                        }
                    }), (0, $kSbwP.jsx)($d8d03341d2feac10$var$ProjectFileButtons, {
                        onView: ()=>{
                            seeProjectFile(doc.saveKey);
                        },
                        onDelete: ()=>{
                            deleteFile(doc.saveKey);
                            if (loadedOnMount[doc.saveKey]) setLoadedOnMount(Object.assign(Object.assign({}, loadedOnMount), {
                                [doc.saveKey]: false
                            }));
                        },
                        deleteEnabled: doc.saveKey !== reportId && doc.saveKey !== `${reportId}_Flightline`
                    }));
                } else {
                    const variants = {
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 1
                        },
                        exit: {
                            opacity: 0,
                            transition: {
                                duration: 0.3,
                                delay: 4.5
                            } // delay out
                        }
                    };
                    elm = (0, $kSbwP.jsx)((0, $6cfc56d35eab895f$export$e25e478948902b8b).div, {
                        initial: "initial",
                        animate: "animate",
                        exit: "exit",
                        variants: variants,
                        children: (0, $kSbwP.jsx)($d8d03341d2feac10$var$ProcessingAnimation, {})
                    }, doc.saveKey + '_animation');
                }
                return (0, $kSbwP.jsx)((0, $ae648d2f07b96262$export$3ae376d12526dd6f), {
                    mode: "popLayout",
                    children: elm
                });
            }
        }
    ];
    const columnsProjFiles = [
        {
            column: {
                source: null,
                display: 'Overview'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value,
            overrideValue: (field, column)=>{
                var _a;
                const doc = knowledgeFiles[field.source];
                return (_a = doc === null || doc === void 0 ? void 0 : doc.overview) !== null && _a !== void 0 ? _a : 'N/A';
            }
        },
        {
            column: {
                source: 'saveKey',
                display: 'View'
            },
            element: (row, col, data)=>{
                const doc = knowledgeFiles[row.field.source];
                var elm = null;
                const baseMotionConfig = {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    }
                };
                elm = /*#__PURE__*/ (0, $8nGP5.createElement)((0, $6cfc56d35eab895f$export$e25e478948902b8b).div, Object.assign({}, baseMotionConfig, {
                    key: doc.saveKey,
                    transition: {
                        duration: 0.3
                    }
                }), (0, $kSbwP.jsx)($d8d03341d2feac10$var$ProjectFileButtons, {
                    onView: ()=>{
                        seeKnowledgeFile(doc.saveKey);
                    },
                    onDelete: ()=>{},
                    deleteEnabled: false
                }));
                return (0, $kSbwP.jsx)((0, $ae648d2f07b96262$export$3ae376d12526dd6f), {
                    mode: "popLayout",
                    children: elm
                });
            }
        }
    ];
    projectFileKeys.sort((a, b)=>{
        var _a, _b, _c, _d, _e, _f;
        if (a === store.selectedReportId) return -1;
        if (b === store.selectedReportId) return 1;
        var bDate = new Date((_c = (_b = (_a = projectFilesRaw[b]) === null || _a === void 0 ? void 0 : _a.summary) === null || _b === void 0 ? void 0 : _b.created_at) !== null && _c !== void 0 ? _c : 0);
        var aDate = new Date((_f = (_e = (_d = projectFilesRaw[a]) === null || _d === void 0 ? void 0 : _d.summary) === null || _e === void 0 ? void 0 : _e.created_at) !== null && _f !== void 0 ? _f : 0);
        return bDate.getTime() - aDate.getTime();
    });
    const projectFiles = projectFileKeys.map((fileKey)=>{
        function makeLabelsRow(fileKey) {
            var _a, _b;
            const file = projectFilesRaw[fileKey];
            return {
                field: {
                    source: file === null || file === void 0 ? void 0 : file.saveKey,
                    display: (file === null || file === void 0 ? void 0 : file.filename) ? file.filename.replace('.pdf', '') : 'Unknown File',
                    description: (_b = (_a = file === null || file === void 0 ? void 0 : file.summary) === null || _a === void 0 ? void 0 : _a.created_at) !== null && _b !== void 0 ? _b : 'N/A'
                },
                value: (_field, column)=>{
                    var _a;
                    try {
                        if (column.source) {
                            if (column.source === 'created_at') {
                                var ret = file.summary[column.source];
                                return ret !== null && ret !== void 0 ? ret : '';
                            } else return (_a = file[column.source]) !== null && _a !== void 0 ? _a : 'N/A';
                        }
                    } catch (_b) {
                        return 'N/A';
                    }
                },
                // onClick: () => {
                //     props.requestSeeFile(file.url, file.filename);
                // },
                label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
                element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value
            };
        }
        const clsValues = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($3e24f02855c82492$export$637f169d296cfe12);
        return (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
            className: clsValues,
            columns: columns,
            rows: [
                makeLabelsRow(fileKey)
            ],
            noHeaderRow: true
        }, fileKey);
    });
    const knowledgeFilesList = knowledgeFileKeys.map((fileKey)=>{
        const file = knowledgeFiles[fileKey];
        function makeLabelsRow(fileKey) {
            var _a;
            const industry = (_a = file === null || file === void 0 ? void 0 : file.industry) !== null && _a !== void 0 ? _a : '';
            return {
                field: {
                    source: fileKey,
                    display: file.fileName,
                    description: industry
                },
                value: (_field, column)=>{
                    var _a;
                    try {
                        if (column.source) {
                            if (column.source === 'created_at') return '';
                            else return (_a = file[column.source]) !== null && _a !== void 0 ? _a : 'N/A';
                        }
                    } catch (_b) {
                        return 'N/A';
                    }
                },
                // onClick: () => {
                //     props.requestSeeFile(file.url, file.filename);
                // },
                label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
                element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value
            };
        }
        const clsValues = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($3e24f02855c82492$export$637f169d296cfe12);
        return (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
            className: clsValues,
            columns: columnsProjFiles,
            rows: [
                makeLabelsRow(fileKey)
            ],
            noHeaderRow: true
        }, fileKey);
    });
    const allFiles = projectFiles.concat(knowledgeFilesList);
    return(// <ScrollPanel
    //     enableHideScrollUntilMouseOver={true}
    //     disableKeyboardScroll={true}
    // >
    (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        fillCell: true,
        shadow: true,
        children: (0, $kSbwP.jsxs)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
            disableKeyboardScroll: true,
            style: {
                paddingRight: '0px'
            },
            children: [
                (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                    title: "Project Files"
                }),
                (0, $kSbwP.jsx)((0, $ae648d2f07b96262$export$3ae376d12526dd6f), {
                    children: allFiles.map((file, index)=>{
                        return (0, $kSbwP.jsx)((0, $6cfc56d35eab895f$export$e25e478948902b8b).div, {
                            initial: {
                                opacity: 0,
                                x: -10
                            },
                            animate: {
                                opacity: 1,
                                x: 0
                            },
                            exit: {
                                opacity: 0,
                                x: -10
                            },
                            transition: {
                                duration: 0.3,
                                delay: index * 0.1
                            },
                            children: file
                        }, file.key);
                    })
                }),
                (0, $kSbwP.jsx)((0, $d39d5626a2a26fe7$export$6b45509f74bc6382), {
                    className: $3e24f02855c82492$export$a59643d115b68bf0,
                    display: `+ File`,
                    toasterMessage: `${companyName}: %name%`,
                    storageTarget: targetUploadStorage,
                    onUpload: (fileName)=>{
                        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                        fb.addDummyProjectFile(reportId, fileName);
                        fb.triggerScanRagFiles();
                    }
                })
            ]
        })
    }));
});



var $kSbwP = parcelRequire("kSbwP");



var $8nGP5 = parcelRequire("8nGP5");
var $7b2532dd8cbc8ada$exports = {};
$7b2532dd8cbc8ada$exports = new URL("back2.7df4d33c.svg", import.meta.url).toString();


var $484b37a85d2f6285$export$8d6d009d1f06226e;
var $484b37a85d2f6285$export$40a9eeef55665a40;
var $484b37a85d2f6285$export$93b7586d956c930e;
var $484b37a85d2f6285$export$f843afa9e9b53052;
var $484b37a85d2f6285$export$ae78d338ad66ff90;
var $484b37a85d2f6285$export$b8972b998723d602;
var $484b37a85d2f6285$export$13925b5cf10ba292;
var $484b37a85d2f6285$export$adaf8a367aa41030;
$484b37a85d2f6285$export$8d6d009d1f06226e = `Vp5udq_backButton`;
$484b37a85d2f6285$export$40a9eeef55665a40 = `Vp5udq_defaultPadding`;
$484b37a85d2f6285$export$93b7586d956c930e = `Vp5udq_dropShadow`;
$484b37a85d2f6285$export$f843afa9e9b53052 = `Vp5udq_panelImage`;
$484b37a85d2f6285$export$ae78d338ad66ff90 = `Vp5udq_scaleInOut`;
$484b37a85d2f6285$export$b8972b998723d602 = `Vp5udq_shadow`;
$484b37a85d2f6285$export$13925b5cf10ba292 = `Vp5udq_small-shadow`;
$484b37a85d2f6285$export$adaf8a367aa41030 = `Vp5udq_switchView`;





const $16de201126bc302c$export$b5d5cf8927ab7262 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.toArray(props.children);
    (0, $3d71a0e5fc49a3ca$exports.assert)(children.length > props.activeView, 'Active view is out of range');
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    (0, $8nGP5.useEffect)(()=>{
        if (uiStore.isKeyEscapeDown && props.activeView > 0) props.onBack();
    }, [
        uiStore.isKeyEscapeDown
    ]);
    const childrenView = children.map((child, index)=>{
        return (0, $kSbwP.jsx)("div", {
            className: $484b37a85d2f6285$export$adaf8a367aa41030,
            style: {
                opacity: index === props.activeView ? 1 : 0,
                pointerEvents: index === props.activeView ? 'auto' : 'none',
                zIndex: index === props.activeView ? 10000 : 0
            },
            children: child
        }, index);
    });
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            style: {
                position: 'relative'
            },
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $484b37a85d2f6285$export$8d6d009d1f06226e,
                    onClick: props.onBack,
                    style: {
                        opacity: props.activeView === 0 ? 0 : 1
                    },
                    children: (0, $kSbwP.jsxs)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        variant: "light",
                        children: [
                            (0, $kSbwP.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7b2532dd8cbc8ada$exports)))
                            }),
                            "Back"
                        ]
                    })
                }),
                childrenView
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");





var $kSbwP = parcelRequire("kSbwP");

var $kSbwP = parcelRequire("kSbwP");

var $de360348d8e02af4$export$d110acd1eb4bf5ee;
var $de360348d8e02af4$export$c945096f7c61efa;
var $de360348d8e02af4$export$d531d37146cc5d63;
var $de360348d8e02af4$export$82e6205b15e6c637;
$de360348d8e02af4$export$d110acd1eb4bf5ee = `LLS8Uq_chatMessage`;
$de360348d8e02af4$export$c945096f7c61efa = `LLS8Uq_chatmessage`;
$de360348d8e02af4$export$d531d37146cc5d63 = `LLS8Uq_citation_class`;
$de360348d8e02af4$export$82e6205b15e6c637 = `LLS8Uq_fadeIn`;
$de360348d8e02af4$export$82e6205b15e6c637;








var $8nGP5 = parcelRequire("8nGP5");

const $a311b708b00f39ea$export$423c13fd52bec8ad = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const contentRef = (0, $8nGP5.useRef)(null);
    const [activeContent, setActiveContent] = (0, $8nGP5.useState)(null);
    const msg = p.msg;
    const firmURL = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().firmInfo.logoURL;
    const clssses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($de360348d8e02af4$export$c945096f7c61efa, 'fade-in');
    const msgId = p.msgId;
    const companyId = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().selectedReportId;
    const buildTooltipId = (citationDisplayId)=>{
        return `tooltip_${companyId}_${citationDisplayId}`;
    };
    if (msg.isMe) return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            className: clssses,
            direction: "column",
            children: [
                (0, $kSbwP.jsx)("div", {
                    style: {
                        height: '50px',
                        alignSelf: 'end',
                        marginBottom: '10px'
                    },
                    children: (0, $kSbwP.jsx)("img", {
                        height: 50,
                        width: 200,
                        src: firmURL,
                        style: {
                            objectFit: 'contain',
                            objectPosition: 'right',
                            height: '100%'
                        }
                    })
                }),
                (0, $kSbwP.jsx)("div", {
                    style: {
                        textAlign: 'right',
                        marginRight: '10px',
                        alignSelf: 'end'
                    },
                    children: msg.message
                })
            ]
        })
    });
    const convertMarkdown = (markdown)=>{
        if (!markdown) return 'ERROR: No message content';
        const cls = $de360348d8e02af4$export$d531d37146cc5d63;
        const rawHtmlWithDefault = (0, $e0f2436fd88d0d31$exports.marked).parse(markdown);
        var matchCounter = 0;
        const finalOutput = rawHtmlWithDefault.replace(/(\[.*?\])/g, (match, p1)=>{
            const p2 = p1.replace(/[\[\]]/g, '');
            matchCounter++;
            const tooltipId = buildTooltipId(p2);
            return `<a class='${cls}' data-tooltip-id="${tooltipId}">${matchCounter}</a>`;
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($4a6c6cd3ba57d1fc$exports))).sanitize(finalOutput);
    };
    const formatterHTML = convertMarkdown(msg.message);
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            className: clssses,
            direction: "row",
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: "p-3",
                    style: {
                        height: '50px'
                    },
                    children: (0, $kSbwP.jsx)((0, $bc783706f3494468$export$7707107edd1bbb83), {})
                }),
                (0, $kSbwP.jsx)("div", {
                    ref: contentRef,
                    className: "flex-grow-1 p-4 align-self-center",
                    style: {
                        marginLeft: '0px'
                    },
                    children: (0, $kSbwP.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: formatterHTML
                        }
                    })
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");

var $066f6cd7ccd30cf5$exports = {};
$066f6cd7ccd30cf5$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":696,\"op\":762,\"w\":600,\"h\":600,\"nm\":\"Final\",\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ind\":3,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[200,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":20,\"op\":1520,\"st\":20},{\"ind\":4,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[250,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":30,\"op\":1530,\"st\":30},{\"ind\":5,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":40,\"op\":1540,\"st\":40},{\"ind\":6,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[350,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":50,\"op\":1550,\"st\":50},{\"ind\":7,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[400,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":60,\"op\":1560,\"st\":60},{\"ind\":8,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[450,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":70,\"op\":1570,\"st\":70},{\"ind\":9,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[500,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":80,\"op\":1580,\"st\":80}]},{\"id\":\"comp_1\",\"layers\":[{\"ind\":1,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":632,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":645,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":657,\"s\":[30]},{\"t\":680,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,415,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1.298]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,0.845]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.057]},\"t\":632,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.645]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0.143]},\"t\":645,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":657,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":699,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":714,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":726,\"s\":[100,100,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0},{\"ind\":2,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":680,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":697,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":710,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":722,\"s\":[30]},{\"t\":745,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,171,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":634,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":647,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":659,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":697,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":710,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":722,\"s\":[55,55,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":-65,\"op\":1435,\"st\":-65}]},{\"id\":\"comp_2\",\"layers\":[{\"ind\":1,\"ty\":4,\"nm\":\"Round 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-74,-14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[129,129,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[60,60]},\"p\":{\"a\":0,\"k\":[0,0]},\"nm\":\"Ellipse Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.831,0.851,0.878,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-74,-14]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\"}],\"ip\":0,\"op\":1500,\"st\":0}]}],\"layers\":[{\"ind\":2,\"ty\":0,\"nm\":\"sequance\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[248,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0}],\"markers\":[]}");


const $3d4818c14c5a7ecb$export$cd092c96f205fe24 = (p)=>{
    const w = p.width || 400;
    const h = p.height || 400;
    const defaultOptions = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($066f6cd7ccd30cf5$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
        options: defaultOptions,
        height: h,
        width: w
    });
};







/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/ 
var $8nGP5 = parcelRequire("8nGP5");



var $djlMn = parcelRequire("djlMn");
const $942bda25fff5377e$var$h = "react-tooltip-core-styles", $942bda25fff5377e$var$w = "react-tooltip-base-styles", $942bda25fff5377e$var$b = {
    core: !1,
    base: !1
};
function $942bda25fff5377e$var$S({ css: e, id: t = $942bda25fff5377e$var$w, type: o = "base", ref: l }) {
    var r, n;
    if (!e || "undefined" == typeof document || $942bda25fff5377e$var$b[o]) return;
    if ("core" === o && "undefined" != typeof $djlMn && (null === (r = null === $djlMn || void 0 === $djlMn ? void 0 : $djlMn.env) || void 0 === r ? void 0 : r.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
    if ("base" !== o && "undefined" != typeof $djlMn && (null === (n = null === $djlMn || void 0 === $djlMn ? void 0 : $djlMn.env) || void 0 === n ? void 0 : n.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
    "core" === o && (t = $942bda25fff5377e$var$h), l || (l = {});
    const { insertAt: i } = l;
    if (document.getElementById(t)) return;
    const c = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.id = t, s.type = "text/css", "top" === i && c.firstChild ? c.insertBefore(s, c.firstChild) : c.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e)), $942bda25fff5377e$var$b[o] = !0;
}
function $942bda25fff5377e$export$afe978aceb0adefd({ type: e = "base", id: t = $942bda25fff5377e$var$w } = {}) {
    if (!$942bda25fff5377e$var$b[e]) return;
    "core" === e && (t = $942bda25fff5377e$var$h);
    const o = document.getElementById(t);
    "style" === (null == o ? void 0 : o.tagName) ? null == o || o.remove() : console.warn(`[react-tooltip] Failed to remove 'style' element with id '${t}'. Call \`injectStyle()\` first`), $942bda25fff5377e$var$b[e] = !1;
}
const $942bda25fff5377e$var$E = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: o = null, place: l = "top", offset: r = 10, strategy: n = "absolute", middlewares: i = [
    (0, $322acf408b6b8401$export$cc800923e997bb8)(Number(r)),
    (0, $322acf408b6b8401$export$8a83211c878a3f1f)({
        fallbackAxisSideDirection: "start"
    }),
    (0, $322acf408b6b8401$export$fba63a578e423eb)({
        padding: 5
    })
], border: c })=>{
    if (!e) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: l
    };
    if (null === t) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: l
    };
    const s = i;
    return o ? (s.push((0, $322acf408b6b8401$export$f2120bbfa5450bd2)({
        element: o,
        padding: 5
    })), (0, $322acf408b6b8401$export$48a53dcb22e581d0)(e, t, {
        placement: l,
        strategy: n,
        middleware: s
    }).then(({ x: e, y: t, placement: o, middlewareData: l })=>{
        var r, n;
        const i = {
            left: `${e}px`,
            top: `${t}px`,
            border: c
        }, { x: s, y: a } = null !== (r = l.arrow) && void 0 !== r ? r : {
            x: 0,
            y: 0
        }, u = null !== (n = ({
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        })[o.split("-")[0]]) && void 0 !== n ? n : "bottom", d = c && {
            borderBottom: c,
            borderRight: c
        };
        let p = 0;
        if (c) {
            const e = `${c}`.match(/(\d+)px/);
            p = (null == e ? void 0 : e[1]) ? Number(e[1]) : 1;
        }
        return {
            tooltipStyles: i,
            tooltipArrowStyles: {
                left: null != s ? `${s}px` : "",
                top: null != a ? `${a}px` : "",
                right: "",
                bottom: "",
                ...d,
                [u]: `-${4 + p}px`
            },
            place: o
        };
    })) : (0, $322acf408b6b8401$export$48a53dcb22e581d0)(e, t, {
        placement: "bottom",
        strategy: n,
        middleware: s
    }).then(({ x: e, y: t, placement: o })=>({
            tooltipStyles: {
                left: `${e}px`,
                top: `${t}px`
            },
            tooltipArrowStyles: {},
            place: o
        }));
}, $942bda25fff5377e$var$A = (e, t)=>!("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), $942bda25fff5377e$var$_ = (e, t, o)=>{
    let l = null;
    const r = function(...r) {
        const n = ()=>{
            l = null, o || e.apply(this, r);
        };
        o && !l && (e.apply(this, r), l = setTimeout(n, t)), o || (l && clearTimeout(l), l = setTimeout(n, t));
    };
    return r.cancel = ()=>{
        l && (clearTimeout(l), l = null);
    }, r;
}, $942bda25fff5377e$var$O = (e)=>null !== e && !Array.isArray(e) && "object" == typeof e, $942bda25fff5377e$var$k = (e, t)=>{
    if (e === t) return !0;
    if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((e, o)=>$942bda25fff5377e$var$k(e, t[o]));
    if (Array.isArray(e) !== Array.isArray(t)) return !1;
    if (!$942bda25fff5377e$var$O(e) || !$942bda25fff5377e$var$O(t)) return e === t;
    const o = Object.keys(e), l = Object.keys(t);
    return o.length === l.length && o.every((o)=>$942bda25fff5377e$var$k(e[o], t[o]));
}, $942bda25fff5377e$var$T = (e)=>{
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    const t = getComputedStyle(e);
    return [
        "overflow",
        "overflow-x",
        "overflow-y"
    ].some((e)=>{
        const o = t.getPropertyValue(e);
        return "auto" === o || "scroll" === o;
    });
}, $942bda25fff5377e$var$L = (e)=>{
    if (!e) return null;
    let t = e.parentElement;
    for(; t;){
        if ($942bda25fff5377e$var$T(t)) return t;
        t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
}, $942bda25fff5377e$var$C = "undefined" != typeof window ? (0, $8nGP5.useLayoutEffect) : (0, $8nGP5.useEffect), $942bda25fff5377e$var$R = (e)=>{
    e.current && (clearTimeout(e.current), e.current = null);
}, $942bda25fff5377e$var$x = "DEFAULT_TOOLTIP_ID", $942bda25fff5377e$var$N = {
    anchorRefs: new Set,
    activeAnchor: {
        current: null
    },
    attach: ()=>{},
    detach: ()=>{},
    setActiveAnchor: ()=>{}
}, $942bda25fff5377e$var$$ = (0, $8nGP5.createContext)({
    getTooltipData: ()=>$942bda25fff5377e$var$N
}), $942bda25fff5377e$export$f78649fb9ca566b8 = ({ children: t })=>{
    const [o, l] = (0, $8nGP5.useState)({
        [$942bda25fff5377e$var$x]: new Set
    }), [c, s] = (0, $8nGP5.useState)({
        [$942bda25fff5377e$var$x]: {
            current: null
        }
    }), a = (e, ...t)=>{
        l((o)=>{
            var l;
            const r = null !== (l = o[e]) && void 0 !== l ? l : new Set;
            return t.forEach((e)=>r.add(e)), {
                ...o,
                [e]: new Set(r)
            };
        });
    }, u = (e, ...t)=>{
        l((o)=>{
            const l = o[e];
            return l ? (t.forEach((e)=>l.delete(e)), {
                ...o
            }) : o;
        });
    }, d = (0, $8nGP5.useCallback)((e = $942bda25fff5377e$var$x)=>{
        var t, l;
        return {
            anchorRefs: null !== (t = o[e]) && void 0 !== t ? t : new Set,
            activeAnchor: null !== (l = c[e]) && void 0 !== l ? l : {
                current: null
            },
            attach: (...t)=>a(e, ...t),
            detach: (...t)=>u(e, ...t),
            setActiveAnchor: (t)=>((e, t)=>{
                    s((o)=>{
                        var l;
                        return (null === (l = o[e]) || void 0 === l ? void 0 : l.current) === t.current ? o : {
                            ...o,
                            [e]: t
                        };
                    });
                })(e, t)
        };
    }, [
        o,
        c,
        a,
        u
    ]), p = (0, $8nGP5.useMemo)(()=>({
            getTooltipData: d
        }), [
        d
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($942bda25fff5377e$var$$.Provider, {
        value: p
    }, t);
};
function $942bda25fff5377e$var$j(e = $942bda25fff5377e$var$x) {
    return (0, $8nGP5.useContext)($942bda25fff5377e$var$$).getTooltipData(e);
}
const $942bda25fff5377e$export$57a09c4864b20b90 = ({ tooltipId: t, children: l, className: r, place: n, content: i, html: c, variant: a, offset: u, wrapper: d, events: p, positionStrategy: v, delayShow: m, delayHide: f })=>{
    const { attach: h, detach: w } = $942bda25fff5377e$var$j(t), b = (0, $8nGP5.useRef)(null);
    return (0, $8nGP5.useEffect)(()=>(h(b), ()=>{
            w(b);
        }), []), (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
        ref: b,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))("react-tooltip-wrapper", r),
        "data-tooltip-place": n,
        "data-tooltip-content": i,
        "data-tooltip-html": c,
        "data-tooltip-variant": a,
        "data-tooltip-offset": u,
        "data-tooltip-wrapper": d,
        "data-tooltip-events": p,
        "data-tooltip-position-strategy": v,
        "data-tooltip-delay-show": m,
        "data-tooltip-delay-hide": f
    }, l);
};
var $942bda25fff5377e$var$z = {
    tooltip: "core-styles-module_tooltip__3vRRp",
    fixed: "core-styles-module_fixed__pcSol",
    arrow: "core-styles-module_arrow__cvMwQ",
    noArrow: "core-styles-module_noArrow__xock6",
    clickable: "core-styles-module_clickable__ZuTTB",
    show: "core-styles-module_show__Nt9eE",
    closing: "core-styles-module_closing__sGnxF"
}, $942bda25fff5377e$var$D = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
};
const $942bda25fff5377e$var$q = ({ forwardRef: t, id: l, className: i, classNameArrow: c, variant: u = "dark", anchorId: d, anchorSelect: p, place: v = "top", offset: m = 10, events: h = [
    "hover"
], openOnClick: w = !1, positionStrategy: b = "absolute", middlewares: S, wrapper: g, delayShow: A = 0, delayHide: O = 0, float: T = !1, hidden: x = !1, noArrow: N = !1, clickable: $ = !1, closeOnEsc: I = !1, closeOnScroll: B = !1, closeOnResize: q = !1, openEvents: H, closeEvents: M, globalCloseEvents: W, imperativeModeOnly: P, style: V, position: F, afterShow: K, afterHide: U, disableTooltip: X, content: Y, contentWrapperRef: G, isOpen: Z, defaultIsOpen: J = !1, setIsOpen: Q, activeAnchor: ee, setActiveAnchor: te, border: oe, opacity: le, arrowColor: re, role: ne = "tooltip" })=>{
    var ie;
    const ce = (0, $8nGP5.useRef)(null), se = (0, $8nGP5.useRef)(null), ae = (0, $8nGP5.useRef)(null), ue = (0, $8nGP5.useRef)(null), de = (0, $8nGP5.useRef)(null), [pe, ve] = (0, $8nGP5.useState)({
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: v
    }), [me, fe] = (0, $8nGP5.useState)(!1), [ye, he] = (0, $8nGP5.useState)(!1), [we, be] = (0, $8nGP5.useState)(null), Se = (0, $8nGP5.useRef)(!1), ge = (0, $8nGP5.useRef)(null), { anchorRefs: Ee, setActiveAnchor: Ae } = $942bda25fff5377e$var$j(l), _e = (0, $8nGP5.useRef)(!1), [Oe, ke] = (0, $8nGP5.useState)([]), Te = (0, $8nGP5.useRef)(!1), Le = w || h.includes("click"), Ce = Le || (null == H ? void 0 : H.click) || (null == H ? void 0 : H.dblclick) || (null == H ? void 0 : H.mousedown), Re = H ? {
        ...H
    } : {
        mouseover: !0,
        focus: !0,
        mouseenter: !1,
        click: !1,
        dblclick: !1,
        mousedown: !1
    };
    !H && Le && Object.assign(Re, {
        mouseenter: !1,
        focus: !1,
        mouseover: !1,
        click: !0
    });
    const xe = M ? {
        ...M
    } : {
        mouseout: !0,
        blur: !0,
        mouseleave: !1,
        click: !1,
        dblclick: !1,
        mouseup: !1
    };
    !M && Le && Object.assign(xe, {
        mouseleave: !1,
        blur: !1,
        mouseout: !1
    });
    const Ne = W ? {
        ...W
    } : {
        escape: I || !1,
        scroll: B || !1,
        resize: q || !1,
        clickOutsideAnchor: Ce || !1
    };
    P && (Object.assign(Re, {
        mouseover: !1,
        focus: !1,
        mouseenter: !1,
        click: !1,
        dblclick: !1,
        mousedown: !1
    }), Object.assign(xe, {
        mouseout: !1,
        blur: !1,
        mouseleave: !1,
        click: !1,
        dblclick: !1,
        mouseup: !1
    }), Object.assign(Ne, {
        escape: !1,
        scroll: !1,
        resize: !1,
        clickOutsideAnchor: !1
    })), $942bda25fff5377e$var$C(()=>(Te.current = !0, ()=>{
            Te.current = !1;
        }), []);
    const $e = (e)=>{
        Te.current && (e && he(!0), setTimeout(()=>{
            Te.current && (null == Q || Q(e), void 0 === Z && fe(e));
        }, 10));
    };
    (0, $8nGP5.useEffect)(()=>{
        if (void 0 === Z) return ()=>null;
        Z && he(!0);
        const e = setTimeout(()=>{
            fe(Z);
        }, 10);
        return ()=>{
            clearTimeout(e);
        };
    }, [
        Z
    ]), (0, $8nGP5.useEffect)(()=>{
        if (me !== Se.current) {
            if ($942bda25fff5377e$var$R(de), Se.current = me, me) null == K || K();
            else {
                const e = ((e)=>{
                    const t = e.match(/^([\d.]+)(ms|s)$/);
                    if (!t) return 0;
                    const [, o, l] = t;
                    return Number(o) * ("ms" === l ? 1 : 1e3);
                })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
                de.current = setTimeout(()=>{
                    he(!1), be(null), null == U || U();
                }, e + 25);
            }
        }
    }, [
        me
    ]);
    const Ie = (e)=>{
        ve((t)=>$942bda25fff5377e$var$k(t, e) ? t : e);
    }, je = (e = A)=>{
        $942bda25fff5377e$var$R(ae), ye ? $e(!0) : ae.current = setTimeout(()=>{
            $e(!0);
        }, e);
    }, Be = (e = O)=>{
        $942bda25fff5377e$var$R(ue), ue.current = setTimeout(()=>{
            _e.current || $e(!1);
        }, e);
    }, ze = (e)=>{
        var t;
        if (!e) return;
        const o = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == o ? void 0 : o.isConnected)) return te(null), void Ae({
            current: null
        });
        A ? je() : $e(!0), te(o), Ae({
            current: o
        }), $942bda25fff5377e$var$R(ue);
    }, De = ()=>{
        $ ? Be(O || 100) : O ? Be() : $e(!1), $942bda25fff5377e$var$R(ae);
    }, qe = ({ x: e, y: t })=>{
        var o;
        const l = {
            getBoundingClientRect: ()=>({
                    x: e,
                    y: t,
                    width: 0,
                    height: 0,
                    top: t,
                    left: e,
                    right: e,
                    bottom: t
                })
        };
        $942bda25fff5377e$var$E({
            place: null !== (o = null == we ? void 0 : we.place) && void 0 !== o ? o : v,
            offset: m,
            elementReference: l,
            tooltipReference: ce.current,
            tooltipArrowReference: se.current,
            strategy: b,
            middlewares: S,
            border: oe
        }).then((e)=>{
            Ie(e);
        });
    }, He = (e)=>{
        if (!e) return;
        const t = e, o = {
            x: t.clientX,
            y: t.clientY
        };
        qe(o), ge.current = o;
    }, Me = (e)=>{
        var t;
        if (!me) return;
        const o = e.target;
        if (!o.isConnected) return;
        if (null === (t = ce.current) || void 0 === t ? void 0 : t.contains(o)) return;
        [
            document.querySelector(`[id='${d}']`),
            ...Oe
        ].some((e)=>null == e ? void 0 : e.contains(o)) || ($e(!1), $942bda25fff5377e$var$R(ae));
    }, We = $942bda25fff5377e$var$_(ze, 50, !0), Pe = $942bda25fff5377e$var$_(De, 50, !0), Ve = (e)=>{
        Pe.cancel(), We(e);
    }, Fe = ()=>{
        We.cancel(), Pe();
    }, Ke = (0, $8nGP5.useCallback)(()=>{
        var e, t;
        const o = null !== (e = null == we ? void 0 : we.position) && void 0 !== e ? e : F;
        o ? qe(o) : T ? ge.current && qe(ge.current) : (null == ee ? void 0 : ee.isConnected) && $942bda25fff5377e$var$E({
            place: null !== (t = null == we ? void 0 : we.place) && void 0 !== t ? t : v,
            offset: m,
            elementReference: ee,
            tooltipReference: ce.current,
            tooltipArrowReference: se.current,
            strategy: b,
            middlewares: S,
            border: oe
        }).then((e)=>{
            Te.current && Ie(e);
        });
    }, [
        me,
        ee,
        Y,
        V,
        v,
        null == we ? void 0 : we.place,
        m,
        b,
        F,
        null == we ? void 0 : we.position,
        T
    ]);
    (0, $8nGP5.useEffect)(()=>{
        var e, t;
        const o = new Set(Ee);
        Oe.forEach((e)=>{
            (null == X ? void 0 : X(e)) || o.add({
                current: e
            });
        });
        const l = document.querySelector(`[id='${d}']`);
        l && !(null == X ? void 0 : X(l)) && o.add({
            current: l
        });
        const r = ()=>{
            $e(!1);
        }, n = $942bda25fff5377e$var$L(ee), i = $942bda25fff5377e$var$L(ce.current);
        Ne.scroll && (window.addEventListener("scroll", r), null == n || n.addEventListener("scroll", r), null == i || i.addEventListener("scroll", r));
        let c = null;
        Ne.resize ? window.addEventListener("resize", r) : ee && ce.current && (c = (0, $322acf408b6b8401$export$deee3a793edee05f)(ee, ce.current, Ke, {
            ancestorResize: !0,
            elementResize: !0,
            layoutShift: !0
        }));
        const s = (e)=>{
            "Escape" === e.key && $e(!1);
        };
        Ne.escape && window.addEventListener("keydown", s), Ne.clickOutsideAnchor && window.addEventListener("click", Me);
        const a = [], u = (e)=>Boolean((null == e ? void 0 : e.target) && (null == ee ? void 0 : ee.contains(e.target))), p = (e)=>{
            me && u(e) || ze(e);
        }, v = (e)=>{
            me && u(e) && De();
        }, m = [
            "mouseover",
            "mouseout",
            "mouseenter",
            "mouseleave",
            "focus",
            "blur"
        ], y = [
            "click",
            "dblclick",
            "mousedown",
            "mouseup"
        ];
        Object.entries(Re).forEach(([e, t])=>{
            t && (m.includes(e) ? a.push({
                event: e,
                listener: Ve
            }) : y.includes(e) && a.push({
                event: e,
                listener: p
            }));
        }), Object.entries(xe).forEach(([e, t])=>{
            t && (m.includes(e) ? a.push({
                event: e,
                listener: Fe
            }) : y.includes(e) && a.push({
                event: e,
                listener: v
            }));
        }), T && a.push({
            event: "pointermove",
            listener: He
        });
        const h = ()=>{
            _e.current = !0;
        }, w = ()=>{
            _e.current = !1, De();
        }, b = $ && (xe.mouseout || xe.mouseleave);
        return b && (null === (e = ce.current) || void 0 === e || e.addEventListener("mouseover", h), null === (t = ce.current) || void 0 === t || t.addEventListener("mouseout", w)), a.forEach(({ event: e, listener: t })=>{
            o.forEach((o)=>{
                var l;
                null === (l = o.current) || void 0 === l || l.addEventListener(e, t);
            });
        }), ()=>{
            var e, t;
            Ne.scroll && (window.removeEventListener("scroll", r), null == n || n.removeEventListener("scroll", r), null == i || i.removeEventListener("scroll", r)), Ne.resize ? window.removeEventListener("resize", r) : null == c || c(), Ne.clickOutsideAnchor && window.removeEventListener("click", Me), Ne.escape && window.removeEventListener("keydown", s), b && (null === (e = ce.current) || void 0 === e || e.removeEventListener("mouseover", h), null === (t = ce.current) || void 0 === t || t.removeEventListener("mouseout", w)), a.forEach(({ event: e, listener: t })=>{
                o.forEach((o)=>{
                    var l;
                    null === (l = o.current) || void 0 === l || l.removeEventListener(e, t);
                });
            });
        };
    }, [
        ee,
        Ke,
        ye,
        Ee,
        Oe,
        H,
        M,
        W,
        Le,
        A,
        O
    ]), (0, $8nGP5.useEffect)(()=>{
        var e, t;
        let o = null !== (t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p) && void 0 !== t ? t : "";
        !o && l && (o = `[data-tooltip-id='${l.replace(/'/g, "\\'")}']`);
        const r = new MutationObserver((e)=>{
            const t = [], r = [];
            e.forEach((e)=>{
                if ("attributes" === e.type && "data-tooltip-id" === e.attributeName) e.target.getAttribute("data-tooltip-id") === l ? t.push(e.target) : e.oldValue === l && r.push(e.target);
                if ("childList" === e.type) {
                    if (ee) {
                        const t = [
                            ...e.removedNodes
                        ].filter((e)=>1 === e.nodeType);
                        if (o) try {
                            r.push(...t.filter((e)=>e.matches(o))), r.push(...t.flatMap((e)=>[
                                    ...e.querySelectorAll(o)
                                ]));
                        } catch (e) {}
                        t.some((e)=>{
                            var t;
                            return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, ee)) && (he(!1), $e(!1), te(null), $942bda25fff5377e$var$R(ae), $942bda25fff5377e$var$R(ue), !0);
                        });
                    }
                    if (o) try {
                        const l = [
                            ...e.addedNodes
                        ].filter((e)=>1 === e.nodeType);
                        t.push(...l.filter((e)=>e.matches(o))), t.push(...l.flatMap((e)=>[
                                ...e.querySelectorAll(o)
                            ]));
                    } catch (e) {}
                }
            }), (t.length || r.length) && ke((e)=>[
                    ...e.filter((e)=>!r.includes(e)),
                    ...t
                ]);
        });
        return r.observe(document.body, {
            childList: !0,
            subtree: !0,
            attributes: !0,
            attributeFilter: [
                "data-tooltip-id"
            ],
            attributeOldValue: !0
        }), ()=>{
            r.disconnect();
        };
    }, [
        l,
        p,
        null == we ? void 0 : we.anchorSelect,
        ee
    ]), (0, $8nGP5.useEffect)(()=>{
        Ke();
    }, [
        Ke
    ]), (0, $8nGP5.useEffect)(()=>{
        if (!(null == G ? void 0 : G.current)) return ()=>null;
        const e = new ResizeObserver(()=>{
            setTimeout(()=>Ke());
        });
        return e.observe(G.current), ()=>{
            e.disconnect();
        };
    }, [
        Y,
        null == G ? void 0 : G.current
    ]), (0, $8nGP5.useEffect)(()=>{
        var e;
        const t = document.querySelector(`[id='${d}']`), o = [
            ...Oe,
            t
        ];
        ee && o.includes(ee) || te(null !== (e = Oe[0]) && void 0 !== e ? e : t);
    }, [
        d,
        Oe,
        ee
    ]), (0, $8nGP5.useEffect)(()=>(J && $e(!0), ()=>{
            $942bda25fff5377e$var$R(ae), $942bda25fff5377e$var$R(ue);
        }), []), (0, $8nGP5.useEffect)(()=>{
        var e;
        let t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p;
        if (!t && l && (t = `[data-tooltip-id='${l.replace(/'/g, "\\'")}']`), t) try {
            const e = Array.from(document.querySelectorAll(t));
            ke(e);
        } catch (e) {
            ke([]);
        }
    }, [
        l,
        p,
        null == we ? void 0 : we.anchorSelect
    ]), (0, $8nGP5.useEffect)(()=>{
        ae.current && ($942bda25fff5377e$var$R(ae), je(A));
    }, [
        A
    ]);
    const Ue = null !== (ie = null == we ? void 0 : we.content) && void 0 !== ie ? ie : Y, Xe = me && Object.keys(pe.tooltipStyles).length > 0;
    return (0, $8nGP5.useImperativeHandle)(t, ()=>({
            open: (e)=>{
                if (null == e ? void 0 : e.anchorSelect) try {
                    document.querySelector(e.anchorSelect);
                } catch (t) {
                    return void console.warn(`[react-tooltip] "${e.anchorSelect}" is not a valid CSS selector`);
                }
                be(null != e ? e : null), (null == e ? void 0 : e.delay) ? je(e.delay) : $e(!0);
            },
            close: (e)=>{
                (null == e ? void 0 : e.delay) ? Be(e.delay) : $e(!1);
            },
            activeAnchor: ee,
            place: pe.place,
            isOpen: Boolean(ye && !x && Ue && Xe)
        })), ye && !x && Ue ? (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(g, {
        id: l,
        role: ne,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))("react-tooltip", $942bda25fff5377e$var$z.tooltip, $942bda25fff5377e$var$D.tooltip, $942bda25fff5377e$var$D[u], i, `react-tooltip__place-${pe.place}`, $942bda25fff5377e$var$z[Xe ? "show" : "closing"], Xe ? "react-tooltip__show" : "react-tooltip__closing", "fixed" === b && $942bda25fff5377e$var$z.fixed, $ && $942bda25fff5377e$var$z.clickable),
        onTransitionEnd: (e)=>{
            $942bda25fff5377e$var$R(de), me || "opacity" !== e.propertyName || (he(!1), be(null), null == U || U());
        },
        style: {
            ...V,
            ...pe.tooltipStyles,
            opacity: void 0 !== le && Xe ? le : void 0
        },
        ref: ce
    }, Ue, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(g, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))("react-tooltip-arrow", $942bda25fff5377e$var$z.arrow, $942bda25fff5377e$var$D.arrow, c, N && $942bda25fff5377e$var$z.noArrow),
        style: {
            ...pe.tooltipArrowStyles,
            background: re ? `linear-gradient(to right bottom, transparent 50%, ${re} 50%)` : void 0
        },
        ref: se
    })) : null;
}, $942bda25fff5377e$var$H = ({ content: t })=>(0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: t
        }
    }), $942bda25fff5377e$export$28c660c63b792dea = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef(({ id: t, anchorId: l, anchorSelect: n, content: i, html: c, render: a, className: u, classNameArrow: d, variant: p = "dark", place: v = "top", offset: m = 10, wrapper: f = "div", children: h = null, events: w = [
    "hover"
], openOnClick: b = !1, positionStrategy: S = "absolute", middlewares: g, delayShow: E = 0, delayHide: _ = 0, float: O = !1, hidden: k = !1, noArrow: T = !1, clickable: L = !1, closeOnEsc: C = !1, closeOnScroll: R = !1, closeOnResize: x = !1, openEvents: N, closeEvents: $, globalCloseEvents: I, imperativeModeOnly: B = !1, style: z, position: D, isOpen: M, defaultIsOpen: W = !1, disableStyleInjection: P = !1, border: V, opacity: F, arrowColor: K, setIsOpen: U, afterShow: X, afterHide: Y, disableTooltip: G, role: Z = "tooltip" }, J)=>{
    const [Q, ee] = (0, $8nGP5.useState)(i), [te, oe] = (0, $8nGP5.useState)(c), [le, re] = (0, $8nGP5.useState)(v), [ne, ie] = (0, $8nGP5.useState)(p), [ce, se] = (0, $8nGP5.useState)(m), [ae, ue] = (0, $8nGP5.useState)(E), [de, pe] = (0, $8nGP5.useState)(_), [ve, me] = (0, $8nGP5.useState)(O), [fe, ye] = (0, $8nGP5.useState)(k), [he, we] = (0, $8nGP5.useState)(f), [be, Se] = (0, $8nGP5.useState)(w), [ge, Ee] = (0, $8nGP5.useState)(S), [Ae, _e] = (0, $8nGP5.useState)(null), [Oe, ke] = (0, $8nGP5.useState)(null), Te = (0, $8nGP5.useRef)(P), { anchorRefs: Le, activeAnchor: Ce } = $942bda25fff5377e$var$j(t), Re = (e)=>null == e ? void 0 : e.getAttributeNames().reduce((t, o)=>{
            var l;
            if (o.startsWith("data-tooltip-")) t[o.replace(/^data-tooltip-/, "")] = null !== (l = null == e ? void 0 : e.getAttribute(o)) && void 0 !== l ? l : null;
            return t;
        }, {}), xe = (e)=>{
        const t = {
            place: (e)=>{
                var t;
                re(null !== (t = e) && void 0 !== t ? t : v);
            },
            content: (e)=>{
                ee(null != e ? e : i);
            },
            html: (e)=>{
                oe(null != e ? e : c);
            },
            variant: (e)=>{
                var t;
                ie(null !== (t = e) && void 0 !== t ? t : p);
            },
            offset: (e)=>{
                se(null === e ? m : Number(e));
            },
            wrapper: (e)=>{
                var t;
                we(null !== (t = e) && void 0 !== t ? t : f);
            },
            events: (e)=>{
                const t = null == e ? void 0 : e.split(" ");
                Se(null != t ? t : w);
            },
            "position-strategy": (e)=>{
                var t;
                Ee(null !== (t = e) && void 0 !== t ? t : S);
            },
            "delay-show": (e)=>{
                ue(null === e ? E : Number(e));
            },
            "delay-hide": (e)=>{
                pe(null === e ? _ : Number(e));
            },
            float: (e)=>{
                me(null === e ? O : "true" === e);
            },
            hidden: (e)=>{
                ye(null === e ? k : "true" === e);
            },
            "class-name": (e)=>{
                _e(e);
            }
        };
        Object.values(t).forEach((e)=>e(null)), Object.entries(e).forEach(([e, o])=>{
            var l;
            null === (l = t[e]) || void 0 === l || l.call(t, o);
        });
    };
    (0, $8nGP5.useEffect)(()=>{
        ee(i);
    }, [
        i
    ]), (0, $8nGP5.useEffect)(()=>{
        oe(c);
    }, [
        c
    ]), (0, $8nGP5.useEffect)(()=>{
        re(v);
    }, [
        v
    ]), (0, $8nGP5.useEffect)(()=>{
        ie(p);
    }, [
        p
    ]), (0, $8nGP5.useEffect)(()=>{
        se(m);
    }, [
        m
    ]), (0, $8nGP5.useEffect)(()=>{
        ue(E);
    }, [
        E
    ]), (0, $8nGP5.useEffect)(()=>{
        pe(_);
    }, [
        _
    ]), (0, $8nGP5.useEffect)(()=>{
        me(O);
    }, [
        O
    ]), (0, $8nGP5.useEffect)(()=>{
        ye(k);
    }, [
        k
    ]), (0, $8nGP5.useEffect)(()=>{
        Ee(S);
    }, [
        S
    ]), (0, $8nGP5.useEffect)(()=>{
        Te.current !== P && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [
        P
    ]), (0, $8nGP5.useEffect)(()=>{
        "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
            detail: {
                disableCore: "core" === P,
                disableBase: P
            }
        }));
    }, []), (0, $8nGP5.useEffect)(()=>{
        var e;
        const o = new Set(Le);
        let r = n;
        if (!r && t && (r = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), r) try {
            document.querySelectorAll(r).forEach((e)=>{
                o.add({
                    current: e
                });
            });
        } catch (e) {
            console.warn(`[react-tooltip] "${r}" is not a valid CSS selector`);
        }
        const i = document.querySelector(`[id='${l}']`);
        if (i && o.add({
            current: i
        }), !o.size) return ()=>null;
        const c = null !== (e = null != Oe ? Oe : i) && void 0 !== e ? e : Ce.current, s = new MutationObserver((e)=>{
            e.forEach((e)=>{
                var t;
                if (!c || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
                const o = Re(c);
                xe(o);
            });
        }), a = {
            attributes: !0,
            childList: !1,
            subtree: !1
        };
        if (c) {
            const e = Re(c);
            xe(e), s.observe(c, a);
        }
        return ()=>{
            s.disconnect();
        };
    }, [
        Le,
        Ce,
        Oe,
        l,
        n
    ]), (0, $8nGP5.useEffect)(()=>{
        (null == z ? void 0 : z.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), V && !$942bda25fff5377e$var$A("border", `${V}`) && console.warn(`[react-tooltip] "${V}" is not a valid \`border\`.`), (null == z ? void 0 : z.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), F && !$942bda25fff5377e$var$A("opacity", `${F}`) && console.warn(`[react-tooltip] "${F}" is not a valid \`opacity\`.`);
    }, []);
    let Ne = h;
    const $e = (0, $8nGP5.useRef)(null);
    if (a) {
        const t = a({
            content: (null == Oe ? void 0 : Oe.getAttribute("data-tooltip-content")) || Q || null,
            activeAnchor: Oe
        });
        Ne = t ? (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
            ref: $e,
            className: "react-tooltip-content-wrapper"
        }, t) : null;
    } else Q && (Ne = Q);
    te && (Ne = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($942bda25fff5377e$var$H, {
        content: te
    }));
    const Ie = {
        forwardRef: J,
        id: t,
        anchorId: l,
        anchorSelect: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(u, Ae),
        classNameArrow: d,
        content: Ne,
        contentWrapperRef: $e,
        place: le,
        variant: ne,
        offset: ce,
        wrapper: he,
        events: be,
        openOnClick: b,
        positionStrategy: ge,
        middlewares: g,
        delayShow: ae,
        delayHide: de,
        float: ve,
        hidden: fe,
        noArrow: T,
        clickable: L,
        closeOnEsc: C,
        closeOnScroll: R,
        closeOnResize: x,
        openEvents: N,
        closeEvents: $,
        globalCloseEvents: I,
        imperativeModeOnly: B,
        style: z,
        position: D,
        isOpen: M,
        defaultIsOpen: W,
        border: V,
        opacity: F,
        arrowColor: K,
        setIsOpen: U,
        afterShow: X,
        afterHide: Y,
        disableTooltip: G,
        activeAnchor: Oe,
        setActiveAnchor: (e)=>ke(e),
        role: Z
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($942bda25fff5377e$var$q, {
        ...Ie
    });
});
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", (e)=>{
    e.detail.disableCore || $942bda25fff5377e$var$S({
        css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}`,
        type: "core"
    }), e.detail.disableBase || $942bda25fff5377e$var$S({
        css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,
        type: "base"
    });
});


var $735d77216d8facec$export$d531d37146cc5d63;
var $735d77216d8facec$export$e7ab66df97d7c425;
$735d77216d8facec$export$d531d37146cc5d63 = `K2Hpaa_citation_class`;
$735d77216d8facec$export$e7ab66df97d7c425 = `K2Hpaa_scrollFadeContent`;



var $8nGP5 = parcelRequire("8nGP5");
const $66ce6f036b68f5b9$export$42499dcdbb97379f = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    //use id to fetch chat
    const messageData = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().reportChatHistory;
    const citationsList = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().reportChatCitationsHistory;
    const keys = Object.keys(messageData).sort();
    //Bit awkward to put effect after fetching data from store
    (0, $8nGP5.useEffect)(()=>{
        const chatScroll = document.getElementById('chat-scroll');
        if (chatScroll) setTimeout(()=>{
            chatScroll.scrollTop = chatScroll.scrollHeight;
        }, 50);
    }, [
        keys.length
    ]);
    const reportId = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().selectedReportId;
    const messages = [];
    var isLastMessageMe = false;
    keys.forEach((msgId)=>{
        const msg = messageData[msgId];
        if (msg.isMe) {
            isLastMessageMe = true;
            messages.push((0, $kSbwP.jsx)((0, $a311b708b00f39ea$export$423c13fd52bec8ad), {
                msg: msg,
                msgId: msgId
            }, msgId));
            if (msg.response) {
                isLastMessageMe = false;
                //Kinda ugly
                const msgResponse = {
                    isMe: false,
                    message: msg.response,
                    date: new Date(),
                    processed: true,
                    raw: msg.raw
                };
                messages.push((0, $kSbwP.jsx)((0, $a311b708b00f39ea$export$423c13fd52bec8ad), {
                    msg: msgResponse,
                    msgId: msgId
                }, msgId + '_response'));
            }
        } else messages.push((0, $kSbwP.jsx)((0, $a311b708b00f39ea$export$423c13fd52bec8ad), {
            msg: msg,
            msgId: msgId
        }, msgId + '_server'));
    });
    if (isLastMessageMe) messages.push((0, $kSbwP.jsx)("div", {
        className: "fade-in",
        children: (0, $kSbwP.jsx)((0, $3d4818c14c5a7ecb$export$cd092c96f205fe24), {
            width: 200,
            height: 100
        })
    }, "animation"));
    const buildTooltipId = (citationDisplayId)=>{
        return `tooltip_${reportId}_${citationDisplayId}`;
    };
    const makeTooltip = (text, tooltipId)=>{
        const finalId = buildTooltipId(tooltipId);
        const parsed = (0, $d8669940f261b2b4$export$f31d32bd04711717)(text);
        return (0, $kSbwP.jsx)((0, $942bda25fff5377e$export$28c660c63b792dea), {
            clickable: true,
            id: finalId,
            style: {
                maxHeight: '400px',
                maxWidth: '600px',
                zIndex: 9999,
                position: 'absolute'
            },
            children: (0, $kSbwP.jsx)("div", {
                style: {
                    overflow: 'auto',
                    maxHeight: '400px',
                    maxWidth: '600px',
                    scrollbarColor: '#eaecf0 transparent',
                    scrollbarWidth: 'thin'
                },
                dangerouslySetInnerHTML: {
                    __html: parsed
                }
            })
        }, finalId);
    };
    var tooltips = [];
    if (citationsList) {
        //data-tooltip-id="my-tooltip
        for(var citationId in citationsList)try {
            const toolGenId = citationId;
            var text = citationsList[citationId];
            tooltips.push(makeTooltip(text, toolGenId));
        } catch (e) {
            console.error('Error in tooltip generation', e);
            console.error('Citation:', citationId);
        //return null;
        }
    }
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)("div", {
                style: {
                    position: 'absolute',
                    width: '100%',
                    height: '0px',
                    zIndex: 100000
                },
                children: tooltips
            }),
            (0, $kSbwP.jsx)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                onLoadScrollToEnd: true,
                id: "chat-scroll",
                className: $735d77216d8facec$export$e7ab66df97d7c425,
                children: (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "column",
                    justify: "end",
                    children: messages
                })
            })
        ]
    });
});



var $97a4632ec479489e$export$b7e3ae3d7c15e42e;
var $97a4632ec479489e$export$2ed7b5e39bba01d1;
var $97a4632ec479489e$export$defe85febe8b728c;
var $97a4632ec479489e$export$981437eb56fae58a;
$97a4632ec479489e$export$b7e3ae3d7c15e42e = `giecvG_input`;
$97a4632ec479489e$export$2ed7b5e39bba01d1 = `giecvG_inputLineOffset`;
$97a4632ec479489e$export$defe85febe8b728c = `giecvG_messages`;
$97a4632ec479489e$export$981437eb56fae58a = `giecvG_sendButton`;



var $8nGP5 = parcelRequire("8nGP5");

const $70486436adddb424$export$fce4baf3ef34624f = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const [inputText, setInputValue] = (0, $8nGP5.useState)('');
    const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const refInput = (0, $8nGP5.useRef)(null);
    const ragAPI = store.ragAPI;
    const history = store.reportChatHistory;
    var totalMessages = 0;
    for(const key in history){
        var msg = history[key];
        totalMessages += 1;
        if (msg.processed) totalMessages += 1;
    }
    const onClickSend = ()=>{
        if (ui.chatWaitingForResponse) return;
        const input = refInput.current.value;
        if (input.length == 0) return;
        ragAPI.sendMessage(input);
        setInputValue('');
    };
    const waitingForReply = (0, $kSbwP.jsxs)("i", {
        children: [
            (0, $kSbwP.jsx)("div", {
                className: "spinner-border spinner-border-sm",
                role: "status",
                style: {
                    animationDuration: '1.25s',
                    width: '20px',
                    height: '20px'
                }
            }),
            ' ',
            "Send"
        ]
    });
    const sendButtonContent = (0, $kSbwP.jsxs)("i", {
        className: "bi bi-send",
        onClick: ()=>{
            onClickSend();
        },
        children: [
            ' ',
            "Send"
        ]
    });
    const sendButton = (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
        className: $97a4632ec479489e$export$981437eb56fae58a,
        children: ui.chatWaitingForResponse ? waitingForReply : sendButtonContent
    });
    return (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        shadow: true,
        fillCell: true,
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            fillCell: true,
            children: [
                store.showAdminConsole && (0, $kSbwP.jsx)("input", {
                    type: "button",
                    value: "Clear Chat",
                    style: {
                        position: 'absolute',
                        right: '10px',
                        top: '-100px',
                        zIndex: 100000
                    },
                    onClick: ()=>{
                        var areYouSure = window.confirm("** Clear Chat: Are you sure ?\r\nReport Name:" + store.selectedReportId + '\r\nCompany: ' + store.query.value('company_name'));
                        if (areYouSure) {
                            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                            fb.clear_chat(store.selectedReportId);
                        }
                    }
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $97a4632ec479489e$export$defe85febe8b728c,
                    children: (0, $kSbwP.jsx)((0, $66ce6f036b68f5b9$export$42499dcdbb97379f), {
                        companyId: store.selectedReportId
                    })
                }),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    className: $97a4632ec479489e$export$2ed7b5e39bba01d1,
                    children: [
                        (0, $kSbwP.jsx)("div", {
                            className: $97a4632ec479489e$export$b7e3ae3d7c15e42e,
                            children: (0, $kSbwP.jsx)("input", {
                                ref: refInput,
                                type: "text",
                                value: inputText,
                                placeholder: "Enter a question",
                                autoFocus: true,
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter') onClickSend();
                                },
                                onChange: (e)=>{
                                    setInputValue(e.currentTarget.value);
                                }
                            })
                        }),
                        sendButton
                    ]
                })
            ]
        })
    });
});


const $2c12f2027963d4ec$export$bfa9586c766696c1 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const [view, setView] = (0, $8nGP5.useState)(0);
    const [pdfData, setPdfUrl] = (0, $8nGP5.useState)({
        url: null,
        displayName: null
    });
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = store.query;
    const requestSeeFile = (pdfUrl, displayName)=>{
        setPdfUrl({
            url: pdfUrl,
            displayName: displayName
        });
        setView(1);
    };
    return (0, $kSbwP.jsxs)((0, $9583d2c91dbe771f$export$3ccee0cf1acf5f70), {
        spaceBetween: 30,
        children: [
            (0, $kSbwP.jsxs)((0, $16de201126bc302c$export$b5d5cf8927ab7262), {
                activeView: view,
                onBack: ()=>setView(0),
                children: [
                    (0, $kSbwP.jsx)((0, $d8d03341d2feac10$export$3605042b726118fb), {
                        requestSeeFile: requestSeeFile
                    }),
                    (0, $kSbwP.jsx)((0, $83348bebf1460cdb$export$9d5f8324718c22d1), {
                        pdfUrl: pdfData.url,
                        title_display: pdfData.displayName
                    })
                ]
            }),
            (0, $kSbwP.jsx)((0, $70486436adddb424$export$fce4baf3ef34624f), {})
        ]
    });
});





const $3ec5e27b9e361204$var$DealChat = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const { id: id } = (0, $48e5d1fb97c993cc$export$99eaa27ddbbb95ef)();
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsx)((0, $2c12f2027963d4ec$export$bfa9586c766696c1), {})
    });
});
var $3ec5e27b9e361204$export$2e2bcd8739ae039 = $3ec5e27b9e361204$var$DealChat;



var $kSbwP = parcelRequire("kSbwP");






var $8nGP5 = parcelRequire("8nGP5");


var $fX8pL = parcelRequire("fX8pL");
const $bdf541de82c12deb$export$545ae5664744585d = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const [reportData, setReportData] = (0, $8nGP5.useState)(null);
    const show_deep_research = false;
    (0, $8nGP5.useEffect)(()=>{
        const companyId = store.selectedReportId;
        const report_type = store.query.report_has_pdf ? 'insight_report_with_cim' : 'insight_report_no_cim';
        const target = `report_runs/${report_type}/${companyId}`;
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)((0, $e0be213f695400f3$export$d0dd861204d0bf72)(), target);
        const unsub = (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r, (data)=>{
            setReportData(data.val());
        });
        return ()=>unsub();
    }, []);
    //var dashboard_vars = [];
    var deep_research = [];
    var run_variables = [];
    // try {
    //     const vars = JSON.parse(data?.vars['final_report_flowise'].value);
    //     const var_keys = Object.keys(vars);
    //     dashboard_vars = var_keys.map(key => {
    //         return (
    //             <tr key={key} style={{ borderTop: '1px solid #ccc' }}>
    //                 <td valign="top">{key}</td>
    //                 <td>{vars[key]}</td>
    //             </tr>
    //         );
    //     });
    // } catch (e) {}
    if ((reportData === null || reportData === void 0 ? void 0 : reportData.deep_research) && show_deep_research) {
        const deepResearch = reportData.deep_research;
        let keys = Object.keys(deepResearch).sort();
        for (let k of keys){
            const rawHtmlWithDefault = (0, $e0f2436fd88d0d31$exports.marked).parse(deepResearch[k]['results']);
            let sanitizedHtml = (0, (/*@__PURE__*/$parcel$interopDefault($4a6c6cd3ba57d1fc$exports))).sanitize(rawHtmlWithDefault);
            deep_research.push((0, $kSbwP.jsxs)("tr", {
                style: {
                    borderTop: '1px solid #ccc'
                },
                children: [
                    (0, $kSbwP.jsx)("td", {
                        valign: "top",
                        children: k
                    }),
                    (0, $kSbwP.jsx)("td", {
                        children: (0, $kSbwP.jsx)("div", {
                            style: {
                                maxWidth: '1200px'
                            },
                            dangerouslySetInnerHTML: {
                                __html: sanitizedHtml
                            }
                        })
                    })
                ]
            }, k));
        }
    }
    if (reportData === null || reportData === void 0 ? void 0 : reportData.vars) {
        const runVars = reportData.vars;
        let keys = Object.keys(runVars).sort();
        const parseData = (s)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($fX8pL)))(s.slice(0, 23));
        };
        keys.sort((a, b)=>{
            const aDate = parseData(runVars[a]['updated_at']);
            const bDate = parseData(runVars[b]['updated_at']);
            return bDate.valueOf() - aDate.valueOf();
        });
        for (let k of keys){
            const rawHtmlWithDefault = (0, $e0f2436fd88d0d31$exports.marked).parse(runVars[k]['value']);
            const updatedAt = runVars[k]['updated_at'];
            const date = (0, (/*@__PURE__*/$parcel$interopDefault($fX8pL)))(updatedAt.slice(0, 23));
            let sanitizedHtml = (0, (/*@__PURE__*/$parcel$interopDefault($4a6c6cd3ba57d1fc$exports))).sanitize(rawHtmlWithDefault);
            run_variables.push((0, $kSbwP.jsxs)("tr", {
                style: {
                    borderTop: '1px solid #ccc'
                },
                children: [
                    (0, $kSbwP.jsx)("td", {
                        valign: "top",
                        children: k
                    }),
                    (0, $kSbwP.jsx)("td", {
                        children: (0, $kSbwP.jsx)("div", {
                            style: {
                                maxWidth: '1200px'
                            },
                            dangerouslySetInnerHTML: {
                                __html: sanitizedHtml
                            }
                        })
                    }),
                    (0, $kSbwP.jsx)("td", {
                        valign: "top",
                        children: date.format('YYYY-MM-DD HH:mm:ss')
                    })
                ]
            }, k));
        }
    }
    return (0, $kSbwP.jsxs)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
        children: [
            (0, $kSbwP.jsx)("h1", {
                children: "Run Variables"
            }),
            (0, $kSbwP.jsx)("table", {
                style: {
                    top: '50px',
                    position: 'relative'
                },
                children: (0, $kSbwP.jsx)("tbody", {
                    children: run_variables
                })
            }),
            (0, $kSbwP.jsx)("h1", {
                style: {
                    marginTop: '100px'
                },
                children: "Deep Research"
            }),
            (0, $kSbwP.jsx)("table", {
                style: {
                    top: '50px',
                    position: 'relative'
                },
                children: (0, $kSbwP.jsx)("tbody", {
                    children: deep_research
                })
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");






var $8nGP5 = parcelRequire("8nGP5");


var $fX8pL = parcelRequire("fX8pL");
var $295a73179afb4d83$export$21fe5488f05bf4cb;
var $295a73179afb4d83$export$40a9eeef55665a40;
var $295a73179afb4d83$export$93b7586d956c930e;
var $295a73179afb4d83$export$2cece91fc5e33627;
var $295a73179afb4d83$export$d95d4af6b64d3876;
var $295a73179afb4d83$export$db04d0c188bf999;
var $295a73179afb4d83$export$b4b29ca9047f4b63;
var $295a73179afb4d83$export$faed4863136ce212;
var $295a73179afb4d83$export$3a19be6a851c8d0f;
var $295a73179afb4d83$export$4a4f1f3722929a1d;
var $295a73179afb4d83$export$cf9ec9cf2e32c8df;
var $295a73179afb4d83$export$d51118ac1e4f8b69;
var $295a73179afb4d83$export$6345f05b0810a26b;
var $295a73179afb4d83$export$f843afa9e9b53052;
var $295a73179afb4d83$export$ae78d338ad66ff90;
var $295a73179afb4d83$export$b8972b998723d602;
var $295a73179afb4d83$export$13925b5cf10ba292;
var $295a73179afb4d83$export$f2d5245d66b09437;
var $295a73179afb4d83$export$ce666bf02318c957;
var $295a73179afb4d83$export$c3f9788a1ddcf2d9;
var $295a73179afb4d83$export$fe99ef867cf7376a;
var $295a73179afb4d83$export$12cad5d27381d595;
$295a73179afb4d83$export$21fe5488f05bf4cb = `FDvOMq_dateColumn`;
$295a73179afb4d83$export$40a9eeef55665a40 = `FDvOMq_defaultPadding`;
$295a73179afb4d83$export$93b7586d956c930e = `FDvOMq_dropShadow`;
$295a73179afb4d83$export$2cece91fc5e33627 = `FDvOMq_expandedContent`;
$295a73179afb4d83$export$d95d4af6b64d3876 = `FDvOMq_headerDate`;
$295a73179afb4d83$export$db04d0c188bf999 = `FDvOMq_headerModule`;
$295a73179afb4d83$export$b4b29ca9047f4b63 = `FDvOMq_headerOutput`;
$295a73179afb4d83$export$faed4863136ce212 = `FDvOMq_headerRow`;
$295a73179afb4d83$export$3a19be6a851c8d0f = `FDvOMq_moduleColumn`;
$295a73179afb4d83$export$4a4f1f3722929a1d = `FDvOMq_moduleName`;
$295a73179afb4d83$export$cf9ec9cf2e32c8df = `FDvOMq_outputColumn`;
$295a73179afb4d83$export$d51118ac1e4f8b69 = `FDvOMq_outputContainer`;
$295a73179afb4d83$export$6345f05b0810a26b = `FDvOMq_outputsTable`;
$295a73179afb4d83$export$f843afa9e9b53052 = `FDvOMq_panelImage`;
$295a73179afb4d83$export$ae78d338ad66ff90 = `FDvOMq_scaleInOut`;
$295a73179afb4d83$export$b8972b998723d602 = `FDvOMq_shadow`;
$295a73179afb4d83$export$13925b5cf10ba292 = `FDvOMq_small-shadow`;
$295a73179afb4d83$export$f2d5245d66b09437 = `FDvOMq_tableContainer`;
$295a73179afb4d83$export$ce666bf02318c957 = `FDvOMq_tableRow`;
$295a73179afb4d83$export$c3f9788a1ddcf2d9 = `FDvOMq_toggleButton`;
$295a73179afb4d83$export$fe99ef867cf7376a = `FDvOMq_truncateIndicator`;
$295a73179afb4d83$export$12cad5d27381d595 = `FDvOMq_truncatedContent`;


const $1184cd0a0bdb0038$export$25cd42cac3084109 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const tasksStore = (0, $8f024b03d9af7c67$export$c2ad39067c031726)();
    const [varsData, setVarsData] = (0, $8nGP5.useState)({});
    const [historyData, setHistoryData] = (0, $8nGP5.useState)({});
    const [expandedVars, setExpandedVars] = (0, $8nGP5.useState)(new Set());
    const companyId = store.selectedReportId;
    // Fetch variables from /flowtasks/vars/{companyId}
    (0, $8nGP5.useEffect)(()=>{
        if (!companyId) return;
        const varsPath = `flowtasks/vars/${companyId}`;
        const varsRef = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)((0, $e0be213f695400f3$export$d0dd861204d0bf72)(), varsPath);
        const unsubVars = (0, $e0be213f695400f3$export$ad30f661f41f4d90)(varsRef, (data)=>{
            setVarsData(data.val() || {});
        });
        return ()=>unsubVars();
    }, [
        companyId
    ]);
    // Fetch history for timestamps from /flowtasks/history/{companyId}
    (0, $8nGP5.useEffect)(()=>{
        if (!companyId) return;
        const historyPath = `flowtasks/history/${companyId}`;
        const historyRef = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)((0, $e0be213f695400f3$export$d0dd861204d0bf72)(), historyPath);
        const unsubHistory = (0, $e0be213f695400f3$export$ad30f661f41f4d90)(historyRef, (data)=>{
            setHistoryData(data.val() || {});
        });
        return ()=>unsubHistory();
    }, [
        companyId
    ]);
    // Variable name mapping
    const variableNameMapping = {
        v_identify_industry: 'Identify Industry',
        v_industry_history: 'Industry History',
        v_competitive_landscape: 'Competitive Landscape'
    };
    // Get timestamp for a variable by finding its task via defs
    const getTimestampForVariable = (variableName)=>{
        // Find task that saves to this variable
        const taskDefs = tasksStore.tasksDefinitions;
        let taskId = null;
        for(const tid in taskDefs)if (taskDefs[tid].save_to === variableName) {
            taskId = tid;
            break;
        }
        if (!taskId || !historyData[taskId]) return 'N/A';
        // Get last result from history
        const taskHistory = historyData[taskId];
        const results = taskHistory.results;
        if (!results || results.length === 0) return 'N/A';
        // Get the most recent result (last in array)
        const lastResult = results[results.length - 1];
        const createdDate = lastResult.createdDate;
        if (!createdDate) return 'N/A';
        // Format as YYYY-MM-DD HH:mm:ss
        return (0, (/*@__PURE__*/$parcel$interopDefault($fX8pL)))(createdDate).format('YYYY-MM-DD HH:mm:ss');
    };
    // Toggle expand/collapse for a variable
    const toggleExpand = (variableName)=>{
        setExpandedVars((prev)=>{
            const newSet = new Set(prev);
            if (newSet.has(variableName)) newSet.delete(variableName);
            else newSet.add(variableName);
            return newSet;
        });
    };
    // Build variable list dynamically from all variables in Firebase
    const variables = [];
    for(const varName in varsData)variables.push({
        variableName: varName,
        humanReadableName: variableNameMapping[varName] || varName,
        content: varsData[varName],
        timestamp: getTimestampForVariable(varName)
    });
    // Sort by timestamp (most recent first)
    variables.sort((a, b)=>{
        if (a.timestamp === 'N/A') return 1;
        if (b.timestamp === 'N/A') return -1;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fX8pL)))(b.timestamp, 'YYYY-MM-DD HH:mm:ss').valueOf() - (0, (/*@__PURE__*/$parcel$interopDefault($fX8pL)))(a.timestamp, 'YYYY-MM-DD HH:mm:ss').valueOf();
    });
    const tableRows = variables.map((varData)=>{
        const isExpanded = expandedVars.has(varData.variableName);
        // Render full content or preview based on expansion state
        const contentToShow = isExpanded ? varData.content : varData.content.substring(0, 300);
        const rawHtml = (0, $e0f2436fd88d0d31$exports.marked).parse(contentToShow);
        const sanitizedHtml = (0, (/*@__PURE__*/$parcel$interopDefault($4a6c6cd3ba57d1fc$exports))).sanitize(rawHtml);
        return (0, $kSbwP.jsxs)("tr", {
            className: $295a73179afb4d83$export$ce666bf02318c957,
            children: [
                (0, $kSbwP.jsx)("td", {
                    valign: "top",
                    className: $295a73179afb4d83$export$3a19be6a851c8d0f,
                    children: (0, $kSbwP.jsx)("div", {
                        className: $295a73179afb4d83$export$4a4f1f3722929a1d,
                        children: varData.humanReadableName
                    })
                }),
                (0, $kSbwP.jsx)("td", {
                    className: $295a73179afb4d83$export$cf9ec9cf2e32c8df,
                    children: (0, $kSbwP.jsxs)("div", {
                        className: $295a73179afb4d83$export$d51118ac1e4f8b69,
                        children: [
                            (0, $kSbwP.jsx)("div", {
                                className: isExpanded ? $295a73179afb4d83$export$2cece91fc5e33627 : $295a73179afb4d83$export$12cad5d27381d595,
                                dangerouslySetInnerHTML: {
                                    __html: sanitizedHtml
                                }
                            }),
                            !isExpanded && (0, $kSbwP.jsx)("div", {
                                className: $295a73179afb4d83$export$fe99ef867cf7376a,
                                children: "..."
                            }),
                            (0, $kSbwP.jsx)("button", {
                                className: $295a73179afb4d83$export$c3f9788a1ddcf2d9,
                                onClick: ()=>toggleExpand(varData.variableName),
                                children: isExpanded ? "\u25B2 Show less" : "\u25BC Show more"
                            })
                        ]
                    })
                }),
                (0, $kSbwP.jsx)("td", {
                    valign: "top",
                    className: $295a73179afb4d83$export$21fe5488f05bf4cb,
                    children: varData.timestamp
                })
            ]
        }, varData.variableName);
    });
    return (0, $kSbwP.jsx)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
        children: (0, $kSbwP.jsx)("div", {
            className: $295a73179afb4d83$export$f2d5245d66b09437,
            children: (0, $kSbwP.jsxs)("table", {
                className: $295a73179afb4d83$export$6345f05b0810a26b,
                children: [
                    (0, $kSbwP.jsx)("thead", {
                        children: (0, $kSbwP.jsxs)("tr", {
                            className: $295a73179afb4d83$export$faed4863136ce212,
                            children: [
                                (0, $kSbwP.jsx)("th", {
                                    className: $295a73179afb4d83$export$db04d0c188bf999,
                                    children: "Module"
                                }),
                                (0, $kSbwP.jsx)("th", {
                                    className: $295a73179afb4d83$export$b4b29ca9047f4b63,
                                    children: "Output"
                                }),
                                (0, $kSbwP.jsx)("th", {
                                    className: $295a73179afb4d83$export$d95d4af6b64d3876,
                                    children: "Date"
                                })
                            ]
                        })
                    }),
                    (0, $kSbwP.jsx)("tbody", {
                        children: tableRows
                    })
                ]
            })
        })
    });
});


var $77305530f3e91b71$export$34e0f9847d4c02dd;
var $77305530f3e91b71$export$40a9eeef55665a40;
var $77305530f3e91b71$export$93b7586d956c930e;
var $77305530f3e91b71$export$ace87c730273fd9b;
var $77305530f3e91b71$export$2596e628ba7811d4;
var $77305530f3e91b71$export$f843afa9e9b53052;
var $77305530f3e91b71$export$ae78d338ad66ff90;
var $77305530f3e91b71$export$b8972b998723d602;
var $77305530f3e91b71$export$13925b5cf10ba292;
var $77305530f3e91b71$export$573c7ff860a6ccf1;
$77305530f3e91b71$export$34e0f9847d4c02dd = `HLHa5a_container`;
$77305530f3e91b71$export$40a9eeef55665a40 = `HLHa5a_defaultPadding`;
$77305530f3e91b71$export$93b7586d956c930e = `HLHa5a_dropShadow`;
$77305530f3e91b71$export$ace87c730273fd9b = `HLHa5a_gptIcon`;
$77305530f3e91b71$export$2596e628ba7811d4 = `HLHa5a_gptTabLabel`;
$77305530f3e91b71$export$f843afa9e9b53052 = `HLHa5a_panelImage`;
$77305530f3e91b71$export$ae78d338ad66ff90 = `HLHa5a_scaleInOut`;
$77305530f3e91b71$export$ae78d338ad66ff90;
$77305530f3e91b71$export$b8972b998723d602 = `HLHa5a_shadow`;
$77305530f3e91b71$export$13925b5cf10ba292 = `HLHa5a_small-shadow`;
$77305530f3e91b71$export$573c7ff860a6ccf1 = `HLHa5a_tabsShadow`;




var $kSbwP = parcelRequire("kSbwP");


var $9b89afd40a11db4c$export$52aab205873de00;
var $9b89afd40a11db4c$export$40a9eeef55665a40;
var $9b89afd40a11db4c$export$93b7586d956c930e;
var $9b89afd40a11db4c$export$bb6071b14b858c09;
var $9b89afd40a11db4c$export$36119d9cfb98ac62;
var $9b89afd40a11db4c$export$f843afa9e9b53052;
var $9b89afd40a11db4c$export$ae78d338ad66ff90;
var $9b89afd40a11db4c$export$b8972b998723d602;
var $9b89afd40a11db4c$export$13925b5cf10ba292;
var $9b89afd40a11db4c$export$5f217e3ac2fbd516;
var $9b89afd40a11db4c$export$f9d670a2c917574a;
var $9b89afd40a11db4c$export$b43f5e8df4a506eb;
var $9b89afd40a11db4c$export$ed1fa8703812b9d3;
var $9b89afd40a11db4c$export$a7221d5760176504;
var $9b89afd40a11db4c$export$1664ae65e1862c28;
var $9b89afd40a11db4c$export$527502d3ae4d76aa;
var $9b89afd40a11db4c$export$8c1eebe614da3d62;
$9b89afd40a11db4c$export$52aab205873de00 = `EzDQUG_clearButton`;
$9b89afd40a11db4c$export$40a9eeef55665a40 = `EzDQUG_defaultPadding`;
$9b89afd40a11db4c$export$93b7586d956c930e = `EzDQUG_dropShadow`;
$9b89afd40a11db4c$export$bb6071b14b858c09 = `EzDQUG_flexsContainer`;
$9b89afd40a11db4c$export$36119d9cfb98ac62 = `EzDQUG_iconSize`;
$9b89afd40a11db4c$export$f843afa9e9b53052 = `EzDQUG_panelImage`;
$9b89afd40a11db4c$export$ae78d338ad66ff90 = `EzDQUG_scaleInOut`;
$9b89afd40a11db4c$export$b8972b998723d602 = `EzDQUG_shadow`;
$9b89afd40a11db4c$export$13925b5cf10ba292 = `EzDQUG_small-shadow`;
$9b89afd40a11db4c$export$5f217e3ac2fbd516 = `EzDQUG_taskBox`;
$9b89afd40a11db4c$export$f9d670a2c917574a = `EzDQUG_taskBoxContent`;
$9b89afd40a11db4c$export$b43f5e8df4a506eb = `EzDQUG_taskGroup`;
$9b89afd40a11db4c$export$ed1fa8703812b9d3 = `EzDQUG_taskGroupTitle`;
$9b89afd40a11db4c$export$a7221d5760176504 = `EzDQUG_taskIcon`;
$9b89afd40a11db4c$export$1664ae65e1862c28 = `EzDQUG_taskStatus`;
$9b89afd40a11db4c$export$527502d3ae4d76aa = `EzDQUG_taskTitle`;
$9b89afd40a11db4c$export$8c1eebe614da3d62 = `EzDQUG_taskViewContainer`;





var $kSbwP = parcelRequire("kSbwP");





var $kSbwP = parcelRequire("kSbwP");




var $8nGP5 = parcelRequire("8nGP5");




var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");





var $8nGP5 = parcelRequire("8nGP5");


const $caad7ae563f83b65$export$691753b6c78cf4e8 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    const contentRef = (0, $8nGP5.useRef)(null);
    const clssses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($de360348d8e02af4$export$c945096f7c61efa, 'fade-in');
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            className: clssses,
            direction: "row",
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: "p-3",
                    style: {
                        height: '50px'
                    },
                    children: (0, $kSbwP.jsx)((0, $bc783706f3494468$export$7707107edd1bbb83), {})
                }),
                (0, $kSbwP.jsxs)("div", {
                    ref: contentRef,
                    className: "flex-grow-1 p-4 align-self-center",
                    style: {
                        marginLeft: '0px'
                    },
                    children: [
                        (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                            variant: "success",
                            className: "me-3",
                            onClick: ()=>{
                                p.onApprove(true);
                            },
                            children: "Approve"
                        }),
                        (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                            variant: "danger",
                            onClick: ()=>{
                                p.onApprove(false);
                            },
                            children: "Reject"
                        })
                    ]
                })
            ]
        })
    });
});









var $8nGP5 = parcelRequire("8nGP5");
var $df203c9f7a7d2a8c$export$d531d37146cc5d63;
var $df203c9f7a7d2a8c$export$e7ab66df97d7c425;
$df203c9f7a7d2a8c$export$d531d37146cc5d63 = `-e628W_citation_class`;
$df203c9f7a7d2a8c$export$e7ab66df97d7c425 = `-e628W_scrollFadeContent`;



const $57d4f9ffad8e3081$export$68487f78edd43797 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    //use id to fetch chat
    const { reportId: reportId, taskId: taskId, showWaitingAnimation: showWaitingAnimation } = p;
    const [chatContent, setChatContent] = (0, $8nGP5.useState)(null);
    const taskDef = (0, $8f024b03d9af7c67$export$c2ad39067c031726)().get_task_definition(taskId);
    (0, $8nGP5.useEffect)(function fetchTaskContent() {
        const path = `/flowtasks/history/${reportId}/${taskId}/results`;
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(fb.db, path);
        const unsub = (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r, (snapshot)=>{
            const data = snapshot.val();
            console.log('TaskChatPanel: fetched task chat data:', data);
            setChatContent(data);
        });
        return ()=>{
            unsub();
        };
    }, [
        taskId
    ]);
    const messageData = chatContent !== null && chatContent !== void 0 ? chatContent : [];
    //Bit awkward to put effect after fetching data from store
    (0, $8nGP5.useEffect)(()=>{
        const chatScroll = document.getElementById('chat-scroll');
        if (chatScroll) setTimeout(()=>{
            chatScroll.scrollTop = chatScroll.scrollHeight;
        }, 50);
    }, [
        messageData.length,
        showWaitingAnimation
    ]);
    const handleApprove = (didApprove)=>{
        var text = '';
        if (!didApprove) text = prompt('Please provide a reason for rejection:', 'Reject');
        if (text == '' || text == null) text = '-';
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        fb.flowtask_add_prompt_job(reportId, taskId, {
            content: text,
            approve: didApprove
        });
    };
    const messages = [];
    const msgHistory = messageData.map((msg)=>{
        return {
            role: msg.role,
            content: msg.content,
            fileUploads: msg.fileUploads || [],
            action: msg.action || null,
            state: msg.state || null
        };
    });
    msgHistory.forEach((msg, index)=>{
        const msgId = 'msg_' + index;
        const isUserMessage = msg['role'] == 'userMessage';
        //const msg: any = messageData[msgId];
        if (isUserMessage) {
            const questionText = msg['content'];
            const msgUser = {
                isMe: true,
                message: questionText,
                date: new Date(),
                processed: true
            };
            messages.push((0, $kSbwP.jsx)((0, $a311b708b00f39ea$export$423c13fd52bec8ad), {
                msg: msgUser,
                msgId: msgId
            }, msgId));
        } else {
            // if (msg.status == 'STOPPED') {
            //     //add a YES\NO button
            //     messages.push(
            //         <ChatMessageApproveReject
            //             onApprove={didApprove => {
            //                 handleApprove(didApprove);
            //             }}
            //             msgId={msgId}
            //             key={msgId + '_approve_reject'}
            //         />
            //     );
            // } else {
            const msgResponse = {
                isMe: false,
                message: msg['content'],
                date: new Date(),
                processed: true
            };
            messages.push((0, $kSbwP.jsx)((0, $a311b708b00f39ea$export$423c13fd52bec8ad), {
                msg: msgResponse,
                msgId: msgId
            }, msgId + '_server'));
        }
    });
    const lastMessage = msgHistory[msgHistory.length - 1] || null;
    if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.action) != null) messages.push((0, $kSbwP.jsx)((0, $caad7ae563f83b65$export$691753b6c78cf4e8), {
        onApprove: (didApprove)=>{
            handleApprove(didApprove);
        }
    }, 'appprove_reject_id'));
    if (messages.length === 0) {
        const msg_starting_text = {
            isMe: false,
            message: taskDef.starting_text,
            date: new Date(),
            processed: true
        };
        messages.push((0, $kSbwP.jsx)((0, $a311b708b00f39ea$export$423c13fd52bec8ad), {
            msg: msg_starting_text,
            msgId: "start_message"
        }, "start_message"));
    }
    if (showWaitingAnimation) messages.push((0, $kSbwP.jsx)("div", {
        className: "fade-in",
        children: (0, $kSbwP.jsx)((0, $3d4818c14c5a7ecb$export$cd092c96f205fe24), {
            width: 200,
            height: 100
        })
    }, "animation"));
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsx)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
            onLoadScrollToEnd: true,
            id: "chat-scroll",
            className: $df203c9f7a7d2a8c$export$e7ab66df97d7c425,
            children: (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "column",
                justify: "end",
                children: messages
            })
        })
    });
});


var $9ce4b54979a341db$export$52aab205873de00;
var $9ce4b54979a341db$export$92696448da9ca491;
var $9ce4b54979a341db$export$40a9eeef55665a40;
var $9ce4b54979a341db$export$93b7586d956c930e;
var $9ce4b54979a341db$export$b7e3ae3d7c15e42e;
var $9ce4b54979a341db$export$2ed7b5e39bba01d1;
var $9ce4b54979a341db$export$defe85febe8b728c;
var $9ce4b54979a341db$export$f843afa9e9b53052;
var $9ce4b54979a341db$export$ae78d338ad66ff90;
var $9ce4b54979a341db$export$981437eb56fae58a;
var $9ce4b54979a341db$export$b8972b998723d602;
var $9ce4b54979a341db$export$13925b5cf10ba292;
var $9ce4b54979a341db$export$527502d3ae4d76aa;
$9ce4b54979a341db$export$52aab205873de00 = `imxWtG_clearButton`;
$9ce4b54979a341db$export$92696448da9ca491 = `imxWtG_customShadow`;
$9ce4b54979a341db$export$40a9eeef55665a40 = `imxWtG_defaultPadding`;
$9ce4b54979a341db$export$93b7586d956c930e = `imxWtG_dropShadow`;
$9ce4b54979a341db$export$b7e3ae3d7c15e42e = `imxWtG_input`;
$9ce4b54979a341db$export$2ed7b5e39bba01d1 = `imxWtG_inputLineOffset`;
$9ce4b54979a341db$export$defe85febe8b728c = `imxWtG_messages`;
$9ce4b54979a341db$export$f843afa9e9b53052 = `imxWtG_panelImage`;
$9ce4b54979a341db$export$ae78d338ad66ff90 = `imxWtG_scaleInOut`;
$9ce4b54979a341db$export$981437eb56fae58a = `imxWtG_sendButton`;
$9ce4b54979a341db$export$b8972b998723d602 = `imxWtG_shadow`;
$9ce4b54979a341db$export$13925b5cf10ba292 = `imxWtG_small-shadow`;
$9ce4b54979a341db$export$527502d3ae4d76aa = `imxWtG_taskTitle`;


const $a829f99a144e5f25$export$dd41e3d6e17fb547 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((p)=>{
    var _a, _b;
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const { taskId: taskId } = p;
    const reportId = store.selectedReportId;
    const task = (0, $8f024b03d9af7c67$export$c2ad39067c031726)().get_task_definition(taskId);
    const [inputText, setInputValue] = (0, $8nGP5.useState)('');
    const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const refInput = (0, $8nGP5.useRef)(null);
    const onClickSend = ()=>{
        if (ui.chatWaitingForResponse) return;
        const input = refInput.current.value;
        if (input.length == 0) return;
        console.log('Sending message to flow_id:', task.flow_id, 'message:', input);
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        const reportId = store.selectedReportId;
        fb.flowtask_add_prompt_job(reportId, taskId, {
            content: input
        });
        setInputValue('');
    };
    const onClickClear = ()=>{
        if (ui.chatWaitingForResponse) return;
        const areYouSure = window.confirm('Are you sure you want to clear the chat history? This action cannot be undone.');
        if (!areYouSure) return;
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        fb.flowtask_add_clear_job(reportId, taskId);
    };
    const waitingForReply = (0, $kSbwP.jsxs)("i", {
        children: [
            (0, $kSbwP.jsx)("div", {
                className: "spinner-border spinner-border-sm",
                role: "status",
                style: {
                    animationDuration: '1.25s',
                    width: '20px',
                    height: '20px'
                }
            }),
            ' '
        ]
    });
    const sendButtonContent = (0, $kSbwP.jsxs)("i", {
        className: "bi bi-send",
        onClick: ()=>{
            onClickSend();
        },
        children: [
            ' ',
            "Send"
        ]
    });
    const taskState = (_b = (_a = store.flowTaskState) === null || _a === void 0 ? void 0 : _a[reportId]) === null || _b === void 0 ? void 0 : _b[taskId];
    const isWaitingReply = taskState != null && (taskState === null || taskState === void 0 ? void 0 : taskState.status) != 'completed' && (taskState === null || taskState === void 0 ? void 0 : taskState.status) != 'failed';
    const clearButtonContent = (0, $kSbwP.jsx)("i", {
        className: "bi bi-trash",
        style: {
            color: 'black'
        },
        onClick: ()=>{
            onClickClear();
        }
    });
    const sendButton = (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
        className: $9ce4b54979a341db$export$981437eb56fae58a,
        children: isWaitingReply ? waitingForReply : sendButtonContent
    });
    const clearButton = (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
        className: $9ce4b54979a341db$export$52aab205873de00,
        children: clearButtonContent
    });
    const taskTitle = (0, $kSbwP.jsxs)("div", {
        className: $9ce4b54979a341db$export$527502d3ae4d76aa,
        children: [
            (0, $kSbwP.jsx)("span", {
                className: "taskSectionTitle",
                children: "Section Name / "
            }),
            (0, $kSbwP.jsx)("span", {
                className: "taskNameTitle",
                children: task.name
            })
        ]
    });
    return (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        fillCell: true,
        className: $9ce4b54979a341db$export$92696448da9ca491,
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            fillCell: true,
            children: [
                clearButton,
                taskTitle,
                (0, $kSbwP.jsx)("div", {
                    className: $9ce4b54979a341db$export$defe85febe8b728c,
                    children: (0, $kSbwP.jsx)((0, $57d4f9ffad8e3081$export$68487f78edd43797), {
                        showWaitingAnimation: isWaitingReply,
                        reportId: store.selectedReportId,
                        taskId: taskId
                    })
                }),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    className: $9ce4b54979a341db$export$2ed7b5e39bba01d1,
                    children: [
                        (0, $kSbwP.jsx)("div", {
                            className: $9ce4b54979a341db$export$b7e3ae3d7c15e42e,
                            children: (0, $kSbwP.jsx)("input", {
                                ref: refInput,
                                type: "text",
                                value: inputText,
                                placeholder: "Enter a question",
                                autoFocus: true,
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter') onClickSend();
                                },
                                onChange: (e)=>{
                                    setInputValue(e.currentTarget.value);
                                }
                            })
                        }),
                        sendButton
                    ]
                })
            ]
        })
    });
});


var $f5c752514b55b3c1$export$4f600edeed4a6cbe;
var $f5c752514b55b3c1$export$3991a4843f4f2866;
var $f5c752514b55b3c1$export$21538155235e2fd6;
var $f5c752514b55b3c1$export$4dc5ea6f543a85a;
var $f5c752514b55b3c1$export$b9a5562bb7cb9dad;
var $f5c752514b55b3c1$export$e63b7d3ffe65465e;
var $f5c752514b55b3c1$export$4ee9ac810b9acf1c;
var $f5c752514b55b3c1$export$4c774ff827a98dc8;
var $f5c752514b55b3c1$export$633f5423b2e46a1d;
var $f5c752514b55b3c1$export$6e674f1bde6af435;
$f5c752514b55b3c1$export$4f600edeed4a6cbe = `qKXDwW_back_button`;
$f5c752514b55b3c1$export$3991a4843f4f2866 = `qKXDwW_back_to_workstreams`;
$f5c752514b55b3c1$export$21538155235e2fd6 = `qKXDwW_inner_title`;
$f5c752514b55b3c1$export$4dc5ea6f543a85a = `qKXDwW_is_var_saved`;
$f5c752514b55b3c1$export$b9a5562bb7cb9dad = `qKXDwW_line_icon`;
$f5c752514b55b3c1$export$e63b7d3ffe65465e = `qKXDwW_line_text`;
$f5c752514b55b3c1$export$4ee9ac810b9acf1c = `qKXDwW_prework_list`;
$f5c752514b55b3c1$export$4c774ff827a98dc8 = `qKXDwW_round_border_container`;
$f5c752514b55b3c1$export$633f5423b2e46a1d = `qKXDwW_saved_outputs`;
$f5c752514b55b3c1$export$6e674f1bde6af435 = `qKXDwW_steps_list`;


var $1722a581fb9c1b92$exports = {};
$1722a581fb9c1b92$exports = new URL("checkmark.2563595b.svg", import.meta.url).toString();


var $2cd734f563dad521$exports = {};
$2cd734f563dad521$exports = new URL("circle.45172d54.svg", import.meta.url).toString();


var $ee616e7535ff9da4$exports = {};
$ee616e7535ff9da4$exports = new URL("paused.9c823c90.svg", import.meta.url).toString();


var $443d959cad801dfe$exports = {};
$443d959cad801dfe$exports = new URL("working.b9e6de61.svg", import.meta.url).toString();



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");





const $62969a3f62bcdee7$export$10f6546ba964a301 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)((props)=>{
    const rawHtmlWithDefault = (0, $e0f2436fd88d0d31$exports.marked).parse(props.variableValue);
    let sanitizedHtml = (0, (/*@__PURE__*/$parcel$interopDefault($4a6c6cd3ba57d1fc$exports))).sanitize(rawHtmlWithDefault);
    return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        fillCell: true,
        direction: "column",
        children: (0, $kSbwP.jsx)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
            children: (0, $kSbwP.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: sanitizedHtml
                }
            })
        })
    });
});


const $06a48dc3d9a89e6f$export$47461fbb57013db4 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(({ onClickBack: onClickBack })=>{
    var _a;
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const taskId = store.selectedTaskId || 'identify_industry';
    const taskStore = (0, $8f024b03d9af7c67$export$c2ad39067c031726)();
    const query = store.query;
    const active_task_id = taskId;
    const task = taskStore.get_task_definition(active_task_id);
    const [storedTasksVars, setStoredVariables] = (0, $8nGP5.useState)(null);
    (0, $8nGP5.useEffect)(function fetchTaskContent() {
        const path = `/flowtasks/vars/${reportId}`;
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(fb.db, path);
        const unsub = (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r, (snapshot)=>{
            const data = snapshot.val();
            console.log('TaskPage: fetched stored variables:', data);
            setStoredVariables(data);
        });
        return ()=>{
            unsub();
        };
    }, [
        active_task_id
    ]);
    if (!task) return (0, $kSbwP.jsxs)("div", {
        children: [
            "Task not found: ",
            active_task_id
        ]
    });
    const reportId = store.selectedReportId;
    const tasksState = store.activeReportTasksState;
    const taskState = tasksState.getTaskQuery(active_task_id);
    const active_step = taskState.activeStep;
    const is_complete = taskState.isComplete;
    const var_exists = (storedTasksVars !== null && storedTasksVars !== void 0 ? storedTasksVars : {}).hasOwnProperty(task.save_to);
    const onShowVariable = ()=>{
        if (!var_exists) return;
        const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        uiStore.modal = {
            title: 'Variable: ' + task.save_to,
            el: (0, $kSbwP.jsx)((0, $62969a3f62bcdee7$export$10f6546ba964a301), {
                variableName: task.save_to,
                variableValue: storedTasksVars[task.save_to]
            })
        };
    };
    const prework_vars_list = (_a = task.prerequisite_variable) !== null && _a !== void 0 ? _a : [
        {
            name: '',
            display: 'None'
        }
    ];
    const prework_vars = prework_vars_list.map((var_obj, index)=>{
        const is_var_ready = !taskState.isLocked;
        var icon = is_var_ready ? (0, (/*@__PURE__*/$parcel$interopDefault($1722a581fb9c1b92$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($2cd734f563dad521$exports)));
        return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            alignItems: "center",
            children: [
                (0, $kSbwP.jsx)("img", {
                    src: icon,
                    className: $f5c752514b55b3c1$export$b9a5562bb7cb9dad
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $f5c752514b55b3c1$export$e63b7d3ffe65465e,
                    children: var_obj.display
                })
            ]
        }, 'prework_' + index);
    });
    const inner_steps = task.inner_steps_names.map((step_name, index)=>{
        const isCurrentStep = index + 1 == Number(active_step);
        const isDone = index + 1 < Number(active_step) || is_complete;
        var icon = null;
        if (isCurrentStep && !is_complete) icon = taskState.status == 'in_progress' ? (0, (/*@__PURE__*/$parcel$interopDefault($443d959cad801dfe$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ee616e7535ff9da4$exports)));
        else icon = isDone ? (0, (/*@__PURE__*/$parcel$interopDefault($1722a581fb9c1b92$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($2cd734f563dad521$exports)));
        return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            alignItems: "center",
            children: [
                (0, $kSbwP.jsx)("img", {
                    src: icon,
                    className: $f5c752514b55b3c1$export$b9a5562bb7cb9dad
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $f5c752514b55b3c1$export$e63b7d3ffe65465e,
                    children: step_name
                })
            ]
        }, 'step_' + index);
    });
    return (0, $kSbwP.jsxs)((0, $c94930c253f3e81f$export$f836382419f64c98), {
        spaceBetween: 0,
        layoutPercent: [
            25,
            75
        ],
        children: [
            (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "column",
                fillCell: true,
                children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "column",
                    className: $f5c752514b55b3c1$export$4c774ff827a98dc8,
                    fillCell: true,
                    children: [
                        (0, $kSbwP.jsxs)("div", {
                            className: $f5c752514b55b3c1$export$3991a4843f4f2866,
                            children: [
                                (0, $kSbwP.jsx)("button", {
                                    className: $f5c752514b55b3c1$export$4f600edeed4a6cbe,
                                    onClick: ()=>{
                                        if (onClickBack) onClickBack();
                                    },
                                    children: (0, $kSbwP.jsx)("i", {
                                        className: "bi bi-arrow-left",
                                        style: {
                                            color: 'white',
                                            fontSize: '14px',
                                            position: 'relative',
                                            top: '-1px'
                                        }
                                    })
                                }),
                                "Back to workstreams"
                            ]
                        }),
                        (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            direction: "column",
                            className: $f5c752514b55b3c1$export$4ee9ac810b9acf1c,
                            children: [
                                (0, $kSbwP.jsx)("div", {
                                    className: $f5c752514b55b3c1$export$21538155235e2fd6,
                                    children: "Pre-work items"
                                }),
                                prework_vars
                            ]
                        }),
                        (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            direction: "column",
                            className: $f5c752514b55b3c1$export$6e674f1bde6af435,
                            children: [
                                (0, $kSbwP.jsx)("div", {
                                    className: $f5c752514b55b3c1$export$21538155235e2fd6,
                                    children: "Work items"
                                }),
                                inner_steps
                            ]
                        }),
                        (0, $kSbwP.jsx)("div", {
                            style: {
                                flexGrow: 1
                            }
                        }),
                        (0, $kSbwP.jsx)("div", {
                            className: $f5c752514b55b3c1$export$633f5423b2e46a1d,
                            children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                                fillCell: true,
                                style: {
                                    padding: 5,
                                    paddingTop: 8
                                },
                                children: [
                                    (0, $kSbwP.jsx)("div", {
                                        className: $f5c752514b55b3c1$export$4dc5ea6f543a85a,
                                        onClick: ()=>{
                                            onShowVariable();
                                        },
                                        children: var_exists ? '1' : '0'
                                    }),
                                    (0, $kSbwP.jsx)("div", {
                                        style: {
                                            flexGrow: 1
                                        }
                                    }),
                                    (0, $kSbwP.jsx)("div", {
                                        className: $f5c752514b55b3c1$export$e63b7d3ffe65465e,
                                        style: {
                                            paddingRight: '3px'
                                        },
                                        children: "Saved Outputs"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            (0, $kSbwP.jsx)((0, $a829f99a144e5f25$export$dd41e3d6e17fb547), {
                taskId: active_task_id
            })
        ]
    });
});



var $8nGP5 = parcelRequire("8nGP5");

const $64bfdc096d32697e$export$a253069458bee89c = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const taskStore = (0, $8f024b03d9af7c67$export$c2ad39067c031726)();
    const [taskPageOpen, setTaskPageOpen] = (0, $8nGP5.useState)(false);
    const tasksState = store.activeReportTasksState;
    const makeTaskGroup = (title, taskIdsList)=>{
        const tasks = taskIdsList.map((taskId)=>{
            const taskState = tasksState.getTaskQuery(taskId);
            //getTaskData(taskId);
            const taskDefinition = taskStore.get_task_definition(taskId);
            //defaults for static UI
            var totalSteps = 3;
            var isTaskComplete = false;
            var activeStep = 1;
            var taskName = taskId;
            var icon = 'task-locked';
            if (taskDefinition) {
                totalSteps = taskDefinition.inner_steps_names.length;
                taskName = taskDefinition.name;
            }
            if (taskState) {
                isTaskComplete = taskState.isComplete;
                activeStep = taskState.activeStep;
                const taskStatus = taskState.status;
                if (taskState.isLocked) icon = 'task-locked';
                else if (isTaskComplete) icon = 'task-checkmark';
                else if (taskStatus == 'in_progress') icon = 'task-working';
                else icon = 'task-paused'; //# or locked ?
            }
            var workItemsString = `${activeStep}/${totalSteps} Work items completed`;
            return (0, $kSbwP.jsx)("div", {
                className: $9b89afd40a11db4c$export$5f217e3ac2fbd516,
                children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    fillCell: true,
                    direction: "row",
                    className: $9b89afd40a11db4c$export$f9d670a2c917574a,
                    children: [
                        (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            direction: "column",
                            fillCell: true,
                            children: [
                                (0, $kSbwP.jsx)("div", {
                                    className: $9b89afd40a11db4c$export$527502d3ae4d76aa,
                                    onClick: ()=>{
                                        if (!taskDefinition) return;
                                        store.selectedTaskId = taskId;
                                        setTaskPageOpen(true);
                                    },
                                    children: taskName
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    style: {
                                        flexGrow: 1
                                    }
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    className: $9b89afd40a11db4c$export$1664ae65e1862c28,
                                    children: workItemsString
                                })
                            ]
                        }),
                        (0, $kSbwP.jsx)("div", {
                            className: $9b89afd40a11db4c$export$a7221d5760176504,
                            children: (0, $kSbwP.jsx)("img", {
                                src: (0, $8f0ee97a3ff3e474$export$dedbf5c8cc754a98)(icon),
                                className: $9b89afd40a11db4c$export$36119d9cfb98ac62
                            })
                        })
                    ]
                })
            }, taskId);
        });
        return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            direction: "column",
            className: $9b89afd40a11db4c$export$b43f5e8df4a506eb,
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $9b89afd40a11db4c$export$ed1fa8703812b9d3,
                    children: title
                }),
                tasks
            ]
        });
    };
    const onClickClear = ()=>{
        const areYouSure = window.confirm('Are you sure you want to clear?');
        if (!areYouSure) return;
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        const reportId = store.selectedReportId;
        const tasksToClear = [
            'identify_industry',
            'competitive_landscape',
            'industry_history'
        ];
        for (const taskId of tasksToClear)fb.flowtask_add_clear_job(reportId, taskId);
    };
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)("i", {
                className: "bi bi-trash " + $9b89afd40a11db4c$export$52aab205873de00,
                style: {
                    color: 'black',
                    display: taskPageOpen ? 'none' : 'block'
                },
                onClick: ()=>{
                    onClickClear();
                }
            }),
            (0, $kSbwP.jsx)("div", {
                className: $9b89afd40a11db4c$export$8c1eebe614da3d62,
                style: {
                    display: taskPageOpen ? 'block' : 'none'
                },
                children: (0, $kSbwP.jsx)((0, $06a48dc3d9a89e6f$export$47461fbb57013db4), {
                    onClickBack: ()=>{
                        setTaskPageOpen(false);
                    }
                })
            }),
            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "row",
                className: $9b89afd40a11db4c$export$bb6071b14b858c09,
                children: [
                    makeTaskGroup('Market', [
                        'identify_industry',
                        'industry_history',
                        'Size & Growth',
                        'Segmentation',
                        'Headwinds & Tailwinds',
                        'Value chain'
                    ]),
                    makeTaskGroup('Company', [
                        'Business overview',
                        'Opportunity overview',
                        'Customers',
                        'History',
                        'Management'
                    ]),
                    makeTaskGroup('Voice of the Customer', [
                        'Purchasing process',
                        'Channel references',
                        'Key purchasing criteria'
                    ]),
                    makeTaskGroup('Competitive landscape', [
                        'competitive_landscape',
                        'Entry barriers'
                    ]),
                    makeTaskGroup('What we need to believe', [
                        'Size & Growth',
                        'Segmentation',
                        'Headwinds & Tailwinds',
                        'Value chain'
                    ])
                ]
            })
        ]
    });
});



const $dd142b8584fa3691$var$DealView = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    var _a, _b;
    const { id: id } = (0, $48e5d1fb97c993cc$export$99eaa27ddbbb95ef)();
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const clientStore = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    (0, $8nGP5.useEffect)(()=>{
        if (!store.isLoaded) return;
        if (!store.reportDataDB.hasOwnProperty(id)) navUtils.home();
    }, [
        store.isLoaded
    ]);
    (0, $3e7d8e12b3f432b0$export$4ec57c364807b0e9)('DEAL_VIEW', ()=>{
        uiStore.resetDealView();
    });
    (0, $8f024b03d9af7c67$export$d2d3ee67e04f6bd9)((_b = (_a = store.query) === null || _a === void 0 ? void 0 : _a.value('company_name')) !== null && _b !== void 0 ? _b : '');
    (0, $8nGP5.useEffect)(()=>{
        if (id) {
            console.log('Setting report id to', id);
            store.selectedReportId = id;
        }
    }, [
        id
    ]);
    (0, $8nGP5.useEffect)(()=>{
        if (!uiStore.isKeyTabDown) return;
        const values = Object.values((0, $8f024b03d9af7c67$export$74848b9d4d66d1d3));
        const currentIndex = values.indexOf(uiStore.dealViewTab);
        uiStore.dealViewTab = values[(currentIndex + (uiStore.isKeyShiftKeyDown ? -1 : 1) + values.length) % values.length];
    }, [
        uiStore.isKeyTabDown
    ]);
    if (store.query == null) return null;
    const do_we_have_pdf = store.query.report_has_pdf;
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)("div", {
            className: 'd-flex justify-content-center',
            style: {
                height: '100%'
            },
            children: [
                (0, $kSbwP.jsx)((0, $c852cf41bf4911ee$export$e7b94983f4222b90), {}),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "column",
                    className: 'h-100 w-100',
                    children: [
                        (0, $kSbwP.jsx)((0, $77d5878715146af4$export$8b251419efc915eb), {
                            disableTicker: true,
                            showDealDbLink: true,
                            showScore: (0, clientStore.showAggregateScores) && do_we_have_pdf,
                            showShadow: false
                        }),
                        (0, $kSbwP.jsx)("div", {
                            className: $77305530f3e91b71$export$573c7ff860a6ccf1,
                            style: {
                                opacity: uiStore.dealViewTab != (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).FLOWISE_CHAT ? 1.0 : 0.0
                            }
                        }),
                        (0, $kSbwP.jsxs)((0, $ffe5cb04ab1a077a$export$2e2bcd8739ae039), {
                            activeKey: uiStore.dealViewTab,
                            variant: "underline",
                            className: 'dealViewTabs',
                            onSelect: (k)=>uiStore.dealViewTab = k,
                            mountOnEnter: true,
                            unmountOnExit: true,
                            children: [
                                (0, $kSbwP.jsx)((0, $da2e6657088436c3$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).DASHBOARD,
                                    title: "Dashboard",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $032f62a52fec71db$export$cf41dafb96c88991), {})
                                }),
                                do_we_have_pdf && (0, $kSbwP.jsx)((0, $da2e6657088436c3$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).DETAILS,
                                    title: "Deal Details",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $cb32edb7d568785b$export$a65eea1eaa5f8fa3), {})
                                }),
                                do_we_have_pdf && (0, $kSbwP.jsx)((0, $da2e6657088436c3$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).COMPARE,
                                    title: "Benchmark & Comps",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $5a1995dee7b5d277$export$a928f7cf0495745d), {})
                                }),
                                do_we_have_pdf && (0, $kSbwP.jsx)((0, $da2e6657088436c3$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).SCORE_BREAKDOWN,
                                    title: "Score Details",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $36c6fce940b0e7aa$export$210595a4b4a710d0), {})
                                }),
                                clientStore.showWorkstreams && (0, $kSbwP.jsx)((0, $da2e6657088436c3$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).WORKSTREAMS,
                                    title: "Workstreams",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    style: {
                                        paddingTop: 10
                                    },
                                    children: (0, $kSbwP.jsx)((0, $64bfdc096d32697e$export$a253069458bee89c), {})
                                }),
                                (0, $kSbwP.jsx)((0, $da2e6657088436c3$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).CHAT,
                                    title: (0, $kSbwP.jsxs)("div", {
                                        className: $77305530f3e91b71$export$2596e628ba7811d4 + ' nav-link',
                                        children: [
                                            "AI Chat",
                                            (0, $kSbwP.jsx)((0, $8f0ee97a3ff3e474$export$f04a61298a47a40f), {
                                                icon: "sparkle",
                                                className: $77305530f3e91b71$export$ace87c730273fd9b
                                            })
                                        ]
                                    }),
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $3ec5e27b9e361204$export$2e2bcd8739ae039), {})
                                }),
                                store.isAdmin && store.showAdminConsole && (0, $kSbwP.jsx)((0, $da2e6657088436c3$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).FLOWISE,
                                    title: "Flowise Debug",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $bdf541de82c12deb$export$545ae5664744585d), {})
                                }),
                                clientStore.showOutputsTab && (0, $kSbwP.jsx)((0, $da2e6657088436c3$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).OUTPUTS,
                                    title: "Outputs",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $1184cd0a0bdb0038$export$25cd42cac3084109), {})
                                })
                            ]
                        }),
                        (0, $kSbwP.jsx)("div", {
                            className: $77305530f3e91b71$export$34e0f9847d4c02dd
                        })
                    ]
                })
            ]
        })
    });
});
var $dd142b8584fa3691$export$2e2bcd8739ae039 = $dd142b8584fa3691$var$DealView;



var $kSbwP = parcelRequire("kSbwP");





var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $979db26205690177$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $979db26205690177$export$548b5965aa310fce = (path)=>{
    const [folderContent, setFolderContent] = (0, $8nGP5.useState)(null);
    const [isLoading, setIsLoading] = (0, $8nGP5.useState)(true);
    const refreshFolder = ()=>$979db26205690177$var$__awaiter(void 0, void 0, void 0, function*() {
            const adapter = (0, $fa12c9399a1a76ec$export$39e0a5bed87a3667)();
            const folder = yield adapter.getListFolderContent(path);
            setIsLoading(false);
            setFolderContent(folder);
        });
    (0, $8nGP5.useEffect)(()=>{
        refreshFolder();
    }, [
        path
    ]);
    return {
        folderContent: folderContent,
        refreshFolder: refreshFolder,
        isLoading: isLoading
    };
};



var $kSbwP = parcelRequire("kSbwP");


var $8nGP5 = parcelRequire("8nGP5");



const $a570357442173b6b$export$ae4b6665feddc7b9 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(/*#__PURE__*/ (0, $8nGP5.forwardRef)((props, ref)=>{
    const [tagStore] = (0, $8nGP5.useState)(new (0, $9640fc307de8e8aa$export$22c8bd8fd228c58a)());
    (0, $8nGP5.useImperativeHandle)(ref, ()=>({
            loadTags: (tagged)=>{
                tagStore.taggedIds = tagged;
            },
            getTags: ()=>{
                return tagStore.taggedIds;
            }
        }), []);
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        wrap: "wrap",
        justify: "start",
        className: "w-100",
        style: {
            gap: '20px',
            padding: '20px'
        },
        children: [
            (0, $kSbwP.jsx)("div", {
                className: "w-100",
                style: {
                    fontSize: '20px',
                    fontWeight: '600'
                },
                children: "Tag Editor"
            }),
            (0, $kSbwP.jsx)("div", {
                className: "w-100",
                style: {
                    height: '300px'
                },
                children: (0, $kSbwP.jsx)((0, $9640fc307de8e8aa$export$b3f69e2b6baaff4f), {
                    tagStore: tagStore,
                    allowSelectAll: true
                })
            }),
            (0, $kSbwP.jsx)("div", {
                className: "w-100"
            })
        ]
    });
}));



var $kSbwP = parcelRequire("kSbwP");



var $8nGP5 = parcelRequire("8nGP5");
var $5f18f0218c40e467$exports = {};
"use strict";
"use client";

var $1yHiF = parcelRequire("1yHiF");
var $5f18f0218c40e467$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($5f18f0218c40e467$exports, "__esModule", {
    value: true
});
$5f18f0218c40e467$exports.default = void 0;

var $5f18f0218c40e467$var$_createSvgIcon = $5f18f0218c40e467$require$_interopRequireDefault((parcelRequire("4TUCe")));

var $kSbwP = parcelRequire("kSbwP");
var $5f18f0218c40e467$var$_default = $5f18f0218c40e467$exports.default = (0, $5f18f0218c40e467$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), 'Done');


var $0575741398557029$exports = {};
"use strict";
"use client";

var $1yHiF = parcelRequire("1yHiF");
var $0575741398557029$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($0575741398557029$exports, "__esModule", {
    value: true
});
$0575741398557029$exports.default = void 0;

var $0575741398557029$var$_createSvgIcon = $0575741398557029$require$_interopRequireDefault((parcelRequire("4TUCe")));

var $kSbwP = parcelRequire("kSbwP");
var $0575741398557029$var$_default = $0575741398557029$exports.default = (0, $0575741398557029$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');



var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");

var $4F19u = parcelRequire("4F19u");

var $gLbll = parcelRequire("gLbll");
parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");

var $4F19u = parcelRequire("4F19u");

var $eUhyY = parcelRequire("eUhyY");
var $a7a34a8980a1ff5d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eUhyY)));



var $8GVXe = parcelRequire("8GVXe");

var $cCZAW = parcelRequire("cCZAW");

var $cfKeZ = parcelRequire("cfKeZ");

var $gLbll = parcelRequire("gLbll");
const $df90ea633b4d002a$var$common = {
    black: '#000',
    white: '#fff'
};
var $df90ea633b4d002a$export$2e2bcd8739ae039 = $df90ea633b4d002a$var$common;


const $d0ce86b62424d17b$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $d0ce86b62424d17b$export$2e2bcd8739ae039 = $d0ce86b62424d17b$var$grey;


const $c3ec2df6928e20b8$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $c3ec2df6928e20b8$export$2e2bcd8739ae039 = $c3ec2df6928e20b8$var$purple;


const $53135aa2f31ddcd2$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $53135aa2f31ddcd2$export$2e2bcd8739ae039 = $53135aa2f31ddcd2$var$red;


const $b82a76d007fd64b3$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $b82a76d007fd64b3$export$2e2bcd8739ae039 = $b82a76d007fd64b3$var$orange;


const $9854aa8ef6b55d05$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $9854aa8ef6b55d05$export$2e2bcd8739ae039 = $9854aa8ef6b55d05$var$blue;


const $c751e811d88486ab$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $c751e811d88486ab$export$2e2bcd8739ae039 = $c751e811d88486ab$var$lightBlue;


const $b62a6a7d275423b7$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $b62a6a7d275423b7$export$2e2bcd8739ae039 = $b62a6a7d275423b7$var$green;


function $5c28be378ea0b2ac$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $df90ea633b4d002a$export$2e2bcd8739ae039).white,
            default: (0, $df90ea633b4d002a$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $5c28be378ea0b2ac$export$a43af521ac8c3202 = $5c28be378ea0b2ac$var$getLight();
function $5c28be378ea0b2ac$var$getDark() {
    return {
        text: {
            primary: (0, $df90ea633b4d002a$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $df90ea633b4d002a$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $5c28be378ea0b2ac$export$55ce6f3a06c59543 = $5c28be378ea0b2ac$var$getDark();
function $5c28be378ea0b2ac$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $gLbll.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $gLbll.darken)(intent.main, tonalOffsetDark);
    }
}
function $5c28be378ea0b2ac$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9854aa8ef6b55d05$export$2e2bcd8739ae039)[200],
        light: (0, $9854aa8ef6b55d05$export$2e2bcd8739ae039)[50],
        dark: (0, $9854aa8ef6b55d05$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $9854aa8ef6b55d05$export$2e2bcd8739ae039)[700],
        light: (0, $9854aa8ef6b55d05$export$2e2bcd8739ae039)[400],
        dark: (0, $9854aa8ef6b55d05$export$2e2bcd8739ae039)[800]
    };
}
function $5c28be378ea0b2ac$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $c3ec2df6928e20b8$export$2e2bcd8739ae039)[200],
        light: (0, $c3ec2df6928e20b8$export$2e2bcd8739ae039)[50],
        dark: (0, $c3ec2df6928e20b8$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $c3ec2df6928e20b8$export$2e2bcd8739ae039)[500],
        light: (0, $c3ec2df6928e20b8$export$2e2bcd8739ae039)[300],
        dark: (0, $c3ec2df6928e20b8$export$2e2bcd8739ae039)[700]
    };
}
function $5c28be378ea0b2ac$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $53135aa2f31ddcd2$export$2e2bcd8739ae039)[500],
        light: (0, $53135aa2f31ddcd2$export$2e2bcd8739ae039)[300],
        dark: (0, $53135aa2f31ddcd2$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $53135aa2f31ddcd2$export$2e2bcd8739ae039)[700],
        light: (0, $53135aa2f31ddcd2$export$2e2bcd8739ae039)[400],
        dark: (0, $53135aa2f31ddcd2$export$2e2bcd8739ae039)[800]
    };
}
function $5c28be378ea0b2ac$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $c751e811d88486ab$export$2e2bcd8739ae039)[400],
        light: (0, $c751e811d88486ab$export$2e2bcd8739ae039)[300],
        dark: (0, $c751e811d88486ab$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $c751e811d88486ab$export$2e2bcd8739ae039)[700],
        light: (0, $c751e811d88486ab$export$2e2bcd8739ae039)[500],
        dark: (0, $c751e811d88486ab$export$2e2bcd8739ae039)[900]
    };
}
function $5c28be378ea0b2ac$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $b62a6a7d275423b7$export$2e2bcd8739ae039)[400],
        light: (0, $b62a6a7d275423b7$export$2e2bcd8739ae039)[300],
        dark: (0, $b62a6a7d275423b7$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $b62a6a7d275423b7$export$2e2bcd8739ae039)[800],
        light: (0, $b62a6a7d275423b7$export$2e2bcd8739ae039)[500],
        dark: (0, $b62a6a7d275423b7$export$2e2bcd8739ae039)[900]
    };
}
function $5c28be378ea0b2ac$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $b82a76d007fd64b3$export$2e2bcd8739ae039)[400],
        light: (0, $b82a76d007fd64b3$export$2e2bcd8739ae039)[300],
        dark: (0, $b82a76d007fd64b3$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $b82a76d007fd64b3$export$2e2bcd8739ae039)[500],
        dark: (0, $b82a76d007fd64b3$export$2e2bcd8739ae039)[900]
    };
}
function $5c28be378ea0b2ac$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $5c28be378ea0b2ac$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $5c28be378ea0b2ac$var$getDefaultSecondary(mode);
    const error = palette.error || $5c28be378ea0b2ac$var$getDefaultError(mode);
    const info = palette.info || $5c28be378ea0b2ac$var$getDefaultInfo(mode);
    const success = palette.success || $5c28be378ea0b2ac$var$getDefaultSuccess(mode);
    const warning = palette.warning || $5c28be378ea0b2ac$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $gLbll.getContrastRatio)(background, $5c28be378ea0b2ac$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $5c28be378ea0b2ac$export$55ce6f3a06c59543.text.primary : $5c28be378ea0b2ac$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($cCZAW)))(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($cCZAW)))(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $5c28be378ea0b2ac$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $5c28be378ea0b2ac$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $5c28be378ea0b2ac$var$getLight();
    else if (mode === 'dark') modeHydrated = $5c28be378ea0b2ac$var$getDark();
    const paletteOutput = (0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))({
        // A collection of common colors.
        common: {
            ...(0, $df90ea633b4d002a$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $d0ce86b62424d17b$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}



var $cCZAW = parcelRequire("cCZAW");

var $cfKeZ = parcelRequire("cfKeZ");

var $dMm7J = parcelRequire("dMm7J");
var $kfZ7E = parcelRequire("kfZ7E");

var $6QfFh = parcelRequire("6QfFh");

var $58o68 = parcelRequire("58o68");

var $jNnBr = parcelRequire("jNnBr");

var $gLbll = parcelRequire("gLbll");

var $cCZAW = parcelRequire("cCZAW");

var $cfKeZ = parcelRequire("cfKeZ");

var $jNnBr = parcelRequire("jNnBr");

var $l5tdw = parcelRequire("l5tdw");

function $6a4ddfbc4ae51807$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




var $cfKeZ = parcelRequire("cfKeZ");
function $dec57e63336888e6$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $dec57e63336888e6$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $dec57e63336888e6$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $dec57e63336888e6$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $dec57e63336888e6$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $dec57e63336888e6$var$defaultFontFamily ? {
                letterSpacing: `${$dec57e63336888e6$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $dec57e63336888e6$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $dec57e63336888e6$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $22f739be18fee90c$var$shadowKeyUmbraOpacity = 0.2;
const $22f739be18fee90c$var$shadowKeyPenumbraOpacity = 0.14;
const $22f739be18fee90c$var$shadowAmbientShadowOpacity = 0.12;
function $22f739be18fee90c$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$22f739be18fee90c$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$22f739be18fee90c$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$22f739be18fee90c$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $22f739be18fee90c$var$shadows = [
    'none',
    $22f739be18fee90c$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $22f739be18fee90c$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $22f739be18fee90c$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $22f739be18fee90c$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $22f739be18fee90c$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $22f739be18fee90c$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $22f739be18fee90c$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $22f739be18fee90c$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $22f739be18fee90c$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $22f739be18fee90c$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $22f739be18fee90c$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $22f739be18fee90c$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $22f739be18fee90c$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $22f739be18fee90c$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $22f739be18fee90c$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $22f739be18fee90c$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $22f739be18fee90c$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $22f739be18fee90c$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $22f739be18fee90c$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $22f739be18fee90c$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $22f739be18fee90c$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $22f739be18fee90c$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $22f739be18fee90c$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $22f739be18fee90c$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $22f739be18fee90c$export$2e2bcd8739ae039 = $22f739be18fee90c$var$shadows;


// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $b14fa814bc719a23$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $b14fa814bc719a23$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $b14fa814bc719a23$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $b14fa814bc719a23$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $b14fa814bc719a23$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$b14fa814bc719a23$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$b14fa814bc719a23$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $b14fa814bc719a23$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $b14fa814bc719a23$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $b14fa814bc719a23$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $011d90cfecd8696b$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $011d90cfecd8696b$export$2e2bcd8739ae039 = $011d90cfecd8696b$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
var $cfKeZ = parcelRequire("cfKeZ");
function $2a66d3332d148d1d$var$isSerializable(val) {
    return (0, $cfKeZ.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $2a66d3332d148d1d$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$2a66d3332d148d1d$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $cfKeZ.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}


function $28b88bd934652998$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($cCZAW)))(20));
    const palette = (0, $5c28be378ea0b2ac$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, (/*@__PURE__*/$parcel$interopDefault($l5tdw)))(options);
    let muiTheme = (0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(systemTheme, {
        mixins: (0, $6a4ddfbc4ae51807$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $22f739be18fee90c$export$2e2bcd8739ae039).slice(),
        typography: (0, $dec57e63336888e6$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $b14fa814bc719a23$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $011d90cfecd8696b$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $jNnBr.unstable_defaultSxConfig),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jNnBr)))({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $2a66d3332d148d1d$export$32c2afa5f91892aa); // for Pigment CSS integration
    return muiTheme;
}
var $28b88bd934652998$export$2e2bcd8739ae039 = $28b88bd934652998$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $a40d4a3b1112e00b$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $32691c9802a0540a$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $a40d4a3b1112e00b$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $32691c9802a0540a$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $32691c9802a0540a$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $32691c9802a0540a$var$defaultDarkOverlays : [];
}
function $32691c9802a0540a$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $5c28be378ea0b2ac$export$2e2bcd8739ae039)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$32691c9802a0540a$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $32691c9802a0540a$export$dd191566510330d3(palette.mode),
        ...rest
    };
}


function $50c876385592aa2f$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $37c66eea531cee45$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $37c66eea531cee45$export$2e2bcd8739ae039 = $37c66eea531cee45$var$excludeVariablesFromRoot;


var $f6e270bc1a5dfd1a$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $37c66eea531cee45$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };



function $bc39f0f86b4dc1f9$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $bc39f0f86b4dc1f9$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $bc39f0f86b4dc1f9$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $gLbll.hslToRgb)(color);
}
function $bc39f0f86b4dc1f9$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $gLbll.private_safeColorChannel)($bc39f0f86b4dc1f9$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $bc39f0f86b4dc1f9$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $bc39f0f86b4dc1f9$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $bc39f0f86b4dc1f9$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $kfZ7E.default)(cssVarPrefix);
function $bc39f0f86b4dc1f9$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $32691c9802a0540a$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $28b88bd934652998$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $32691c9802a0540a$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $32691c9802a0540a$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $bc39f0f86b4dc1f9$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $50c876385592aa2f$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $bc39f0f86b4dc1f9$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($cCZAW)))(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $bc39f0f86b4dc1f9$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $bc39f0f86b4dc1f9$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $bc39f0f86b4dc1f9$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $58o68.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $bc39f0f86b4dc1f9$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $bc39f0f86b4dc1f9$var$setColor(palette.common, 'background', '#fff');
            $bc39f0f86b4dc1f9$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $bc39f0f86b4dc1f9$var$setColor(palette.common, 'background', '#000');
            $bc39f0f86b4dc1f9$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $bc39f0f86b4dc1f9$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'errorColor', (0, $gLbll.private_safeDarken)(palette.error.light, 0.6));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'infoColor', (0, $gLbll.private_safeDarken)(palette.info.light, 0.6));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'successColor', (0, $gLbll.private_safeDarken)(palette.success.light, 0.6));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'warningColor', (0, $gLbll.private_safeDarken)(palette.warning.light, 0.6));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'errorFilledColor', $bc39f0f86b4dc1f9$var$silent(()=>palette.getContrastText(palette.error.main)));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'infoFilledColor', $bc39f0f86b4dc1f9$var$silent(()=>palette.getContrastText(palette.info.main)));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'successFilledColor', $bc39f0f86b4dc1f9$var$silent(()=>palette.getContrastText(palette.success.main)));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'warningFilledColor', $bc39f0f86b4dc1f9$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'errorStandardBg', (0, $gLbll.private_safeLighten)(palette.error.light, 0.9));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'infoStandardBg', (0, $gLbll.private_safeLighten)(palette.info.light, 0.9));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'successStandardBg', (0, $gLbll.private_safeLighten)(palette.success.light, 0.9));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'warningStandardBg', (0, $gLbll.private_safeLighten)(palette.warning.light, 0.9));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $bc39f0f86b4dc1f9$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $bc39f0f86b4dc1f9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $bc39f0f86b4dc1f9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'primaryBg', (0, $gLbll.private_safeLighten)(palette.primary.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $gLbll.private_safeLighten)(palette.secondary.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'errorBg', (0, $gLbll.private_safeLighten)(palette.error.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'infoBg', (0, $gLbll.private_safeLighten)(palette.info.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'successBg', (0, $gLbll.private_safeLighten)(palette.success.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'warningBg', (0, $gLbll.private_safeLighten)(palette.warning.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'primaryTrack', (0, $gLbll.private_safeLighten)(palette.primary.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'secondaryTrack', (0, $gLbll.private_safeLighten)(palette.secondary.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'errorTrack', (0, $gLbll.private_safeLighten)(palette.error.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'infoTrack', (0, $gLbll.private_safeLighten)(palette.info.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'successTrack', (0, $gLbll.private_safeLighten)(palette.success.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'warningTrack', (0, $gLbll.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $gLbll.private_safeEmphasize)(palette.background.default, 0.8);
            $bc39f0f86b4dc1f9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $bc39f0f86b4dc1f9$var$setColor(palette.SnackbarContent, 'color', $bc39f0f86b4dc1f9$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $bc39f0f86b4dc1f9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $gLbll.private_safeEmphasize)(palette.background.paper, 0.15));
            $bc39f0f86b4dc1f9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $bc39f0f86b4dc1f9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $gLbll.private_safeLighten)(palette.primary.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $gLbll.private_safeLighten)(palette.secondary.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'errorDisabledColor', (0, $gLbll.private_safeLighten)(palette.error.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'infoDisabledColor', (0, $gLbll.private_safeLighten)(palette.info.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'successDisabledColor', (0, $gLbll.private_safeLighten)(palette.success.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'warningDisabledColor', (0, $gLbll.private_safeLighten)(palette.warning.main, 0.62));
            $bc39f0f86b4dc1f9$var$setColor(palette.TableCell, 'border', (0, $gLbll.private_safeLighten)((0, $gLbll.private_safeAlpha)(palette.divider, 1), 0.88));
            $bc39f0f86b4dc1f9$var$setColor(palette.Tooltip, 'bg', (0, $gLbll.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'errorColor', (0, $gLbll.private_safeLighten)(palette.error.light, 0.6));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'infoColor', (0, $gLbll.private_safeLighten)(palette.info.light, 0.6));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'successColor', (0, $gLbll.private_safeLighten)(palette.success.light, 0.6));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'warningColor', (0, $gLbll.private_safeLighten)(palette.warning.light, 0.6));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'errorFilledColor', $bc39f0f86b4dc1f9$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'infoFilledColor', $bc39f0f86b4dc1f9$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'successFilledColor', $bc39f0f86b4dc1f9$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'warningFilledColor', $bc39f0f86b4dc1f9$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'errorStandardBg', (0, $gLbll.private_safeDarken)(palette.error.light, 0.9));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'infoStandardBg', (0, $gLbll.private_safeDarken)(palette.info.light, 0.9));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'successStandardBg', (0, $gLbll.private_safeDarken)(palette.success.light, 0.9));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'warningStandardBg', (0, $gLbll.private_safeDarken)(palette.warning.light, 0.9));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $bc39f0f86b4dc1f9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $bc39f0f86b4dc1f9$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $bc39f0f86b4dc1f9$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $bc39f0f86b4dc1f9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $bc39f0f86b4dc1f9$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $bc39f0f86b4dc1f9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $bc39f0f86b4dc1f9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'primaryBg', (0, $gLbll.private_safeDarken)(palette.primary.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $gLbll.private_safeDarken)(palette.secondary.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'errorBg', (0, $gLbll.private_safeDarken)(palette.error.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'infoBg', (0, $gLbll.private_safeDarken)(palette.info.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'successBg', (0, $gLbll.private_safeDarken)(palette.success.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.LinearProgress, 'warningBg', (0, $gLbll.private_safeDarken)(palette.warning.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'primaryTrack', (0, $gLbll.private_safeDarken)(palette.primary.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'secondaryTrack', (0, $gLbll.private_safeDarken)(palette.secondary.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'errorTrack', (0, $gLbll.private_safeDarken)(palette.error.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'infoTrack', (0, $gLbll.private_safeDarken)(palette.info.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'successTrack', (0, $gLbll.private_safeDarken)(palette.success.main, 0.5));
            $bc39f0f86b4dc1f9$var$setColor(palette.Slider, 'warningTrack', (0, $gLbll.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $gLbll.private_safeEmphasize)(palette.background.default, 0.98);
            $bc39f0f86b4dc1f9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $bc39f0f86b4dc1f9$var$setColor(palette.SnackbarContent, 'color', $bc39f0f86b4dc1f9$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $bc39f0f86b4dc1f9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $gLbll.private_safeEmphasize)(palette.background.paper, 0.15));
            $bc39f0f86b4dc1f9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $bc39f0f86b4dc1f9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $gLbll.private_safeDarken)(palette.primary.main, 0.55));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $gLbll.private_safeDarken)(palette.secondary.main, 0.55));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'errorDisabledColor', (0, $gLbll.private_safeDarken)(palette.error.main, 0.55));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'infoDisabledColor', (0, $gLbll.private_safeDarken)(palette.info.main, 0.55));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'successDisabledColor', (0, $gLbll.private_safeDarken)(palette.success.main, 0.55));
            $bc39f0f86b4dc1f9$var$setColor(palette.Switch, 'warningDisabledColor', (0, $gLbll.private_safeDarken)(palette.warning.main, 0.55));
            $bc39f0f86b4dc1f9$var$setColor(palette.TableCell, 'border', (0, $gLbll.private_safeDarken)((0, $gLbll.private_safeAlpha)(palette.divider, 1), 0.68));
            $bc39f0f86b4dc1f9$var$setColor(palette.Tooltip, 'bg', (0, $gLbll.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $bc39f0f86b4dc1f9$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $bc39f0f86b4dc1f9$var$setColorChannel(palette.background, 'paper');
        $bc39f0f86b4dc1f9$var$setColorChannel(palette.common, 'background');
        $bc39f0f86b4dc1f9$var$setColorChannel(palette.common, 'onBackground');
        $bc39f0f86b4dc1f9$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $bc39f0f86b4dc1f9$var$setColor(palette[color], 'mainChannel', (0, $gLbll.private_safeColorChannel)($bc39f0f86b4dc1f9$var$toRgb(colors.main)));
                if (colors.light) $bc39f0f86b4dc1f9$var$setColor(palette[color], 'lightChannel', (0, $gLbll.private_safeColorChannel)($bc39f0f86b4dc1f9$var$toRgb(colors.light)));
                if (colors.dark) $bc39f0f86b4dc1f9$var$setColor(palette[color], 'darkChannel', (0, $gLbll.private_safeColorChannel)($bc39f0f86b4dc1f9$var$toRgb(colors.dark)));
                if (colors.contrastText) $bc39f0f86b4dc1f9$var$setColor(palette[color], 'contrastTextChannel', (0, $gLbll.private_safeColorChannel)($bc39f0f86b4dc1f9$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $bc39f0f86b4dc1f9$var$setColorChannel(palette[color], 'primary');
                    $bc39f0f86b4dc1f9$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $bc39f0f86b4dc1f9$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $bc39f0f86b4dc1f9$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $f6e270bc1a5dfd1a$export$2e2bcd8739ae039)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $58o68.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $dMm7J.default)(input.spacing, (0, $6QfFh.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $58o68.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $jNnBr.unstable_defaultSxConfig),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jNnBr)))({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $2a66d3332d148d1d$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $9f420798628fb202$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $5c28be378ea0b2ac$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $9f420798628fb202$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $28b88bd934652998$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $28b88bd934652998$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $9f420798628fb202$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $9f420798628fb202$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $bc39f0f86b4dc1f9$export$2e2bcd8739ae039)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}


'use client';
const $65f85c7db41c8d14$var$defaultTheme = (0, $9f420798628fb202$export$2e2bcd8739ae039)();
var $65f85c7db41c8d14$export$2e2bcd8739ae039 = $65f85c7db41c8d14$var$defaultTheme;


var $1a9f48aa20662b65$export$2e2bcd8739ae039 = '$$material';


// copied from @mui/system/createStyled
function $1b4b91ac760af90d$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $1b4b91ac760af90d$export$2e2bcd8739ae039 = $1b4b91ac760af90d$var$slotShouldForwardProp;


const $576bf96a6420560d$var$rootShouldForwardProp = (prop)=>(0, $1b4b91ac760af90d$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $576bf96a6420560d$export$2e2bcd8739ae039 = $576bf96a6420560d$var$rootShouldForwardProp;



'use client';
const $ca8d320b3bc9b4f3$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($8GVXe)))({
    themeId: (0, $1a9f48aa20662b65$export$2e2bcd8739ae039),
    defaultTheme: $65f85c7db41c8d14$export$2e2bcd8739ae039,
    rootShouldForwardProp: $576bf96a6420560d$export$2e2bcd8739ae039
});
var $ca8d320b3bc9b4f3$export$2e2bcd8739ae039 = $ca8d320b3bc9b4f3$var$styled;



var $jjdRO = parcelRequire("jjdRO");
const $95cfc8af545861f7$var$memoTheme = (0, $jjdRO.default);
var $95cfc8af545861f7$export$2e2bcd8739ae039 = $95cfc8af545861f7$var$memoTheme;


parcelRequire("8nGP5");


var $dIKpX = parcelRequire("dIKpX");

var $kSbwP = parcelRequire("kSbwP");
'use client';
function $57009fa7e4cf4a1e$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dIKpX))), {
        ...props
    });
}
var $57009fa7e4cf4a1e$export$2e2bcd8739ae039 = $57009fa7e4cf4a1e$var$DefaultPropsProvider;
function $57009fa7e4cf4a1e$export$2440da353cedad43(params) {
    return (0, $dIKpX.useDefaultProps)(params);
}



var $4bI4C = parcelRequire("4bI4C");

var $4E9MM = parcelRequire("4E9MM");
function $c6d89c39b447c1ab$export$c7c50641356bdfa5(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4E9MM)))('MuiSvgIcon', slot);
}
const $c6d89c39b447c1ab$var$svgIconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($4bI4C)))('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $c6d89c39b447c1ab$export$2e2bcd8739ae039 = $c6d89c39b447c1ab$var$svgIconClasses;



var $kSbwP = parcelRequire("kSbwP");
'use client';
const $9f23953caf8aa53c$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($4F19u)))(slots, (0, $c6d89c39b447c1ab$export$c7c50641356bdfa5), classes);
};
const $9f23953caf8aa53c$var$SvgIconRoot = (0, $ca8d320b3bc9b4f3$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $95cfc8af545861f7$export$2e2bcd8739ae039)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $9f23953caf8aa53c$var$SvgIcon = /*#__PURE__*/ $8nGP5.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $57009fa7e4cf4a1e$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $8nGP5.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $9f23953caf8aa53c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $kSbwP.jsxs)($9f23953caf8aa53c$var$SvgIconRoot, {
        as: component,
        className: (0, $ajIhI.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $kSbwP.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$9f23953caf8aa53c$var$SvgIcon.muiName = 'SvgIcon';
var $9f23953caf8aa53c$export$2e2bcd8739ae039 = $9f23953caf8aa53c$var$SvgIcon;



var $kSbwP = parcelRequire("kSbwP");
'use client';
function $332812d7b7360635$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $9f23953caf8aa53c$export$2e2bcd8739ae039), {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $9f23953caf8aa53c$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $8nGP5.memo(/*#__PURE__*/ $8nGP5.forwardRef(Component));
}



var $kSbwP = parcelRequire("kSbwP");
'use client';
var $9e20f0e61afe4fc0$export$2e2bcd8739ae039 = (0, $332812d7b7360635$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');



var $7uWLa = parcelRequire("7uWLa");
'use client';
var $fbbe88fe4a36c3a7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7uWLa)));





var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");



var $4F19u = parcelRequire("4F19u");

var $jLOre = parcelRequire("jLOre");




var $5xdHV = parcelRequire("5xdHV");
'use client';
var $c88fc425f3df735c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5xdHV)));



var $8nGP5 = parcelRequire("8nGP5");

var $3MjpJ = parcelRequire("3MjpJ");
'use client';
class $50e65500e11d7e9c$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $50e65500e11d7e9c$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, (/*@__PURE__*/$parcel$interopDefault($3MjpJ)))($50e65500e11d7e9c$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $8nGP5.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $8nGP5.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $50e65500e11d7e9c$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $50e65500e11d7e9c$export$2e2bcd8739ae039() {
    return $50e65500e11d7e9c$export$f5de0641c7db4154.use();
}
function $50e65500e11d7e9c$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $8nGP5 = parcelRequire("8nGP5");


var $b7Gxh = parcelRequire("b7Gxh");

var $ajIhI = parcelRequire("ajIhI");

var $kuuLw = parcelRequire("kuuLw");

var $bj8tp = parcelRequire("bj8tp");


var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");

var $kSbwP = parcelRequire("kSbwP");
'use client';
function $f8d63a65032c4cb1$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $8nGP5.useState(false);
    const rippleClassName = (0, $ajIhI.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $ajIhI.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $8nGP5.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)("span", {
            className: childClassName
        })
    });
}
var $f8d63a65032c4cb1$export$2e2bcd8739ae039 = $f8d63a65032c4cb1$var$Ripple;



var $4bI4C = parcelRequire("4bI4C");

var $4E9MM = parcelRequire("4E9MM");
function $09d73d943816fd3e$export$b464606f735ab902(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4E9MM)))('MuiTouchRipple', slot);
}
const $09d73d943816fd3e$var$touchRippleClasses = (0, (/*@__PURE__*/$parcel$interopDefault($4bI4C)))('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $09d73d943816fd3e$export$2e2bcd8739ae039 = $09d73d943816fd3e$var$touchRippleClasses;



var $kSbwP = parcelRequire("kSbwP");
'use client';
const $7e0f03ab797403f0$var$DURATION = 550;
const $7e0f03ab797403f0$export$95d0c9356b2231a3 = 80;
const $7e0f03ab797403f0$var$enterKeyframe = (0, $bj8tp.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $7e0f03ab797403f0$var$exitKeyframe = (0, $bj8tp.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $7e0f03ab797403f0$var$pulsateKeyframe = (0, $bj8tp.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $7e0f03ab797403f0$export$f6b7418508c72c25 = (0, $ca8d320b3bc9b4f3$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $7e0f03ab797403f0$export$676cfe7b12693c4b = (0, $ca8d320b3bc9b4f3$export$2e2bcd8739ae039)((0, $f8d63a65032c4cb1$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $09d73d943816fd3e$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$7e0f03ab797403f0$var$enterKeyframe};
    animation-duration: ${$7e0f03ab797403f0$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $09d73d943816fd3e$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $09d73d943816fd3e$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $09d73d943816fd3e$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$7e0f03ab797403f0$var$exitKeyframe};
    animation-duration: ${$7e0f03ab797403f0$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $09d73d943816fd3e$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$7e0f03ab797403f0$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $7e0f03ab797403f0$var$TouchRipple = /*#__PURE__*/ $8nGP5.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $57009fa7e4cf4a1e$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $8nGP5.useState([]);
    const nextKey = $8nGP5.useRef(0);
    const rippleCallback = $8nGP5.useRef(null);
    $8nGP5.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $8nGP5.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, (/*@__PURE__*/$parcel$interopDefault($kuuLw)))();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $8nGP5.useRef(null);
    const container = $8nGP5.useRef(null);
    const startCommit = $8nGP5.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $kSbwP.jsx)($7e0f03ab797403f0$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $ajIhI.default)(classes.ripple, (0, $09d73d943816fd3e$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $ajIhI.default)(classes.rippleVisible, (0, $09d73d943816fd3e$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $ajIhI.default)(classes.ripplePulsate, (0, $09d73d943816fd3e$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $ajIhI.default)(classes.child, (0, $09d73d943816fd3e$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $ajIhI.default)(classes.childLeaving, (0, $09d73d943816fd3e$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $ajIhI.default)(classes.childPulsate, (0, $09d73d943816fd3e$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $7e0f03ab797403f0$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $8nGP5.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($7e0f03ab797403f0$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $8nGP5.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $8nGP5.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $8nGP5.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($7e0f03ab797403f0$export$f6b7418508c72c25, {
        className: (0, $ajIhI.default)((0, $09d73d943816fd3e$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $b7Gxh.default), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $7e0f03ab797403f0$export$2e2bcd8739ae039 = $7e0f03ab797403f0$var$TouchRipple;



var $4bI4C = parcelRequire("4bI4C");

var $4E9MM = parcelRequire("4E9MM");
function $d47b709bef8947c0$export$fccb0498dcd99783(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4E9MM)))('MuiButtonBase', slot);
}
const $d47b709bef8947c0$var$buttonBaseClasses = (0, (/*@__PURE__*/$parcel$interopDefault($4bI4C)))('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $d47b709bef8947c0$export$2e2bcd8739ae039 = $d47b709bef8947c0$var$buttonBaseClasses;



var $kSbwP = parcelRequire("kSbwP");
'use client';
const $928a3c9e9c787726$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($4F19u)))(slots, (0, $d47b709bef8947c0$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $928a3c9e9c787726$export$7ec0dcc5e3cdcd36 = (0, $ca8d320b3bc9b4f3$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $d47b709bef8947c0$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $928a3c9e9c787726$var$ButtonBase = /*#__PURE__*/ $8nGP5.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $57009fa7e4cf4a1e$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $8nGP5.useRef(null);
    const ripple = (0, $50e65500e11d7e9c$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $fbbe88fe4a36c3a7$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $8nGP5.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $8nGP5.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $8nGP5.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $928a3c9e9c787726$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $928a3c9e9c787726$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $928a3c9e9c787726$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $928a3c9e9c787726$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $928a3c9e9c787726$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $928a3c9e9c787726$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $928a3c9e9c787726$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $928a3c9e9c787726$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $928a3c9e9c787726$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jLOre)))(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $c88fc425f3df735c$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jLOre)))(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $c88fc425f3df735c$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $c88fc425f3df735c$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $fbbe88fe4a36c3a7$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $928a3c9e9c787726$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $kSbwP.jsxs)($928a3c9e9c787726$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $ajIhI.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $kSbwP.jsx)((0, $7e0f03ab797403f0$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $928a3c9e9c787726$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $c88fc425f3df735c$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $928a3c9e9c787726$export$2e2bcd8739ae039 = $928a3c9e9c787726$var$ButtonBase;




/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $1332ff44a298c860$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $1332ff44a298c860$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$1332ff44a298c860$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $1332ff44a298c860$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $1332ff44a298c860$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}




var $4bI4C = parcelRequire("4bI4C");

var $4E9MM = parcelRequire("4E9MM");
function $0892cdf15094fe68$export$31444911e4ee6fdd(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4E9MM)))('MuiChip', slot);
}
const $0892cdf15094fe68$var$chipClasses = (0, (/*@__PURE__*/$parcel$interopDefault($4bI4C)))('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $0892cdf15094fe68$export$2e2bcd8739ae039 = $0892cdf15094fe68$var$chipClasses;



var $kSbwP = parcelRequire("kSbwP");
'use client';
const $e1908ab799a51708$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`,
            `${variant}${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`
        ],
        label: [
            'label',
            `label${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(size)}`,
            `avatarColor${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(size)}`,
            `iconColor${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(size)}`,
            `deleteIconColor${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`,
            `deleteIcon${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(variant)}Color${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($4F19u)))(slots, (0, $0892cdf15094fe68$export$31444911e4ee6fdd), classes);
};
const $e1908ab799a51708$var$ChipRoot = (0, $ca8d320b3bc9b4f3$export$2e2bcd8739ae039)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(iconColor)}`]
            },
            {
                [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(variant)}Color${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`]
            },
            styles.root,
            styles[`size${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(size)}`],
            styles[`color${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`]
        ];
    }
})((0, $95cfc8af545861f7$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $gLbll.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $gLbll.alpha)(theme.palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1332ff44a298c860$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].contrastTextChannel} / 0.7)` : (0, $gLbll.alpha)(theme.palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $gLbll.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1332ff44a298c860$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $gLbll.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
                    },
                    [`&.${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $gLbll.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1332ff44a298c860$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1332ff44a298c860$export$2e2bcd8739ae039)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $gLbll.alpha)(theme.palette[color].main, 0.7)}`,
                        [`&.${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).clickable}:hover`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $gLbll.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        },
                        [`&.${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $gLbll.alpha)(theme.palette[color].main, theme.palette.action.focusOpacity)
                        },
                        [`& .${(0, $0892cdf15094fe68$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $gLbll.alpha)(theme.palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $e1908ab799a51708$var$ChipLabel = (0, $ca8d320b3bc9b4f3$export$2e2bcd8739ae039)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $e1908ab799a51708$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $e1908ab799a51708$var$Chip = /*#__PURE__*/ $8nGP5.forwardRef(function Chip(inProps, ref) {
    const props = (0, $57009fa7e4cf4a1e$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, // TODO v6: Rename to `focusableWhenDisabled`.
    ...other } = props;
    const chipRef = $8nGP5.useRef(null);
    const handleRef = (0, $fbbe88fe4a36c3a7$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $e1908ab799a51708$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $e1908ab799a51708$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $928a3c9e9c787726$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $8nGP5.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $e1908ab799a51708$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $928a3c9e9c787726$export$2e2bcd8739ae039) ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $8nGP5.isValidElement(deleteIconProp) ? /*#__PURE__*/ $8nGP5.cloneElement(deleteIconProp, {
        className: (0, $ajIhI.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $kSbwP.jsx)((0, $9e20f0e61afe4fc0$export$2e2bcd8739ae039), {
        className: (0, $ajIhI.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $8nGP5.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $8nGP5.cloneElement(avatarProp, {
        className: (0, $ajIhI.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $8nGP5.isValidElement(iconProp)) icon = /*#__PURE__*/ $8nGP5.cloneElement(iconProp, {
        className: (0, $ajIhI.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $kSbwP.jsxs)($e1908ab799a51708$var$ChipRoot, {
        as: component,
        className: (0, $ajIhI.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState,
        ...moreProps,
        ...other,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $kSbwP.jsx)($e1908ab799a51708$var$ChipLabel, {
                className: (0, $ajIhI.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $e1908ab799a51708$export$2e2bcd8739ae039 = $e1908ab799a51708$var$Chip;



var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");

var $cfKeZ = parcelRequire("cfKeZ");

var $4E9MM = parcelRequire("4E9MM");

var $4F19u = parcelRequire("4F19u");

var $8gY7h = parcelRequire("8gY7h");

var $cfKeZ = parcelRequire("cfKeZ");

var $eUhyY = parcelRequire("eUhyY");

var $2iJqU = parcelRequire("2iJqU");

var $Elngy = parcelRequire("Elngy");

var $jxonz = parcelRequire("jxonz");

var $7EwlR = parcelRequire("7EwlR");
const $dbb49f1a0337c201$export$35e57303dbd8a66 = (0, $Elngy.default)();
function $dbb49f1a0337c201$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $dbb49f1a0337c201$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $dbb49f1a0337c201$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $dbb49f1a0337c201$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $dbb49f1a0337c201$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$dbb49f1a0337c201$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $dbb49f1a0337c201$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $dbb49f1a0337c201$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $dbb49f1a0337c201$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $dbb49f1a0337c201$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $dbb49f1a0337c201$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $dbb49f1a0337c201$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $dbb49f1a0337c201$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $8gY7h.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $jxonz.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $dbb49f1a0337c201$var$defaultOverridesResolver($dbb49f1a0337c201$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $dbb49f1a0337c201$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($dbb49f1a0337c201$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $8gY7h.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $dbb49f1a0337c201$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === 'function' && style.__emotion_real !== style) return function styleFunctionProcessor(props) {
                return $dbb49f1a0337c201$var$processStyle(props, style);
            };
            if ((0, $cfKeZ.isPlainObject)(style)) {
                const serialized = (0, $7EwlR.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $dbb49f1a0337c201$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $dbb49f1a0337c201$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $dbb49f1a0337c201$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push((0, $jxonz.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $dbb49f1a0337c201$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, (/*@__PURE__*/$parcel$interopDefault($eUhyY)))(componentSlot || '')}`;
    return `Styled(${(0, (/*@__PURE__*/$parcel$interopDefault($2iJqU)))(tag)})`;
}
function $dbb49f1a0337c201$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $dbb49f1a0337c201$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $dbb49f1a0337c201$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $dbb49f1a0337c201$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}


const $4e8d7392acd5a7a7$var$styled = (0, $dbb49f1a0337c201$export$2e2bcd8739ae039)();
var $4e8d7392acd5a7a7$export$2e2bcd8739ae039 = $4e8d7392acd5a7a7$var$styled;



var $9Blzt = parcelRequire("9Blzt");
function $443b741cee575a4e$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Blzt)))(theme.components[name].defaultProps, props);
}



var $hk9Pq = parcelRequire("hk9Pq");
'use client';
function $125b4a9d5ab2ee6b$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $hk9Pq.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $443b741cee575a4e$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
}



var $cfKeZ = parcelRequire("cfKeZ");

var $jakrK = parcelRequire("jakrK");
const $0c98f1bba0d53c13$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $jakrK.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $0c98f1bba0d53c13$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $0c98f1bba0d53c13$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $cfKeZ.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}



var $Elngy = parcelRequire("Elngy");

var $6m0u5 = parcelRequire("6m0u5");

var $WqQl4 = parcelRequire("WqQl4");

var $kSbwP = parcelRequire("kSbwP");
'use client';
const $440d34e79c7a3a22$var$defaultTheme = (0, $Elngy.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $440d34e79c7a3a22$var$defaultCreateStyledComponent = (0, $4e8d7392acd5a7a7$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $440d34e79c7a3a22$var$useThemePropsDefault(props) {
    return (0, $125b4a9d5ab2ee6b$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $440d34e79c7a3a22$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $440d34e79c7a3a22$var$joinChildren(children, separator) {
    const childrenArray = $8nGP5.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $8nGP5.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $440d34e79c7a3a22$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $440d34e79c7a3a22$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $6m0u5.handleBreakpoints)({
            theme: theme
        }, (0, $6m0u5.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $WqQl4.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $6m0u5.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $6m0u5.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $WqQl4.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$440d34e79c7a3a22$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $WqQl4.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(styles, (0, $6m0u5.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $6m0u5.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $440d34e79c7a3a22$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $440d34e79c7a3a22$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $440d34e79c7a3a22$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($4F19u)))(slots, (slot)=>(0, (/*@__PURE__*/$parcel$interopDefault($4E9MM)))(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($440d34e79c7a3a22$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $8nGP5.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $0c98f1bba0d53c13$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $kSbwP.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $ajIhI.default)(classes.root, className),
            ...other,
            children: divider ? $440d34e79c7a3a22$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}




'use client';
const $bf55a801ba90eca2$var$Stack = (0, $440d34e79c7a3a22$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $ca8d320b3bc9b4f3$export$2e2bcd8739ae039)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $57009fa7e4cf4a1e$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $bf55a801ba90eca2$export$2e2bcd8739ae039 = $bf55a801ba90eca2$var$Stack;


var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");

var $4F19u = parcelRequire("4F19u");
parcelRequire("8nGP5");

var $jNnBr = parcelRequire("jNnBr");

parcelRequire("8nGP5");


var $fUKUp = parcelRequire("fUKUp");



var $kSbwP = parcelRequire("kSbwP");
'use client';
function $6c56722b019b1c8d$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $fUKUp.default), {
        ...props,
        defaultTheme: (0, $65f85c7db41c8d14$export$2e2bcd8739ae039),
        themeId: (0, $1a9f48aa20662b65$export$2e2bcd8739ae039)
    });
}
var $6c56722b019b1c8d$export$2e2bcd8739ae039 = $6c56722b019b1c8d$var$GlobalStyles;



var $kSbwP = parcelRequire("kSbwP");

var $bj8tp = parcelRequire("bj8tp");

function $26dcb0a4fedc37d6$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $kSbwP.jsx)((0, $6c56722b019b1c8d$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $26dcb0a4fedc37d6$export$7e7f5719ff4debb1() {
    return 0, $jNnBr.extendSxProp;
}







var $4bI4C = parcelRequire("4bI4C");

var $4E9MM = parcelRequire("4E9MM");
function $816c344a63b98752$export$24c1f8f60cbac79e(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4E9MM)))('MuiTypography', slot);
}
const $816c344a63b98752$var$typographyClasses = (0, (/*@__PURE__*/$parcel$interopDefault($4bI4C)))('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $816c344a63b98752$export$2e2bcd8739ae039 = $816c344a63b98752$var$typographyClasses;



var $kSbwP = parcelRequire("kSbwP");
'use client';
const $ab90ebace5b2582a$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $ab90ebace5b2582a$var$extendSxProp = (0, $26dcb0a4fedc37d6$export$7e7f5719ff4debb1)();
const $ab90ebace5b2582a$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($4F19u)))(slots, (0, $816c344a63b98752$export$24c1f8f60cbac79e), classes);
};
const $ab90ebace5b2582a$export$140e2f5526d3cad8 = (0, $ca8d320b3bc9b4f3$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $95cfc8af545861f7$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $1332ff44a298c860$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $a7a34a8980a1ff5d$export$2e2bcd8739ae039)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $ab90ebace5b2582a$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $ab90ebace5b2582a$var$Typography = /*#__PURE__*/ $8nGP5.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $57009fa7e4cf4a1e$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$ab90ebace5b2582a$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $ab90ebace5b2582a$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $ab90ebace5b2582a$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $ab90ebace5b2582a$var$defaultVariantMapping[variant]) || 'span';
    const classes = $ab90ebace5b2582a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($ab90ebace5b2582a$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $ajIhI.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $ab90ebace5b2582a$export$2e2bcd8739ae039 = $ab90ebace5b2582a$var$Typography;


var $903d28d692c77697$exports = {};
"use strict";
Object.defineProperty($903d28d692c77697$exports, "__esModule", {
    value: true
});
Object.defineProperty($903d28d692c77697$exports, "TreeItem", {
    enumerable: true,
    get: function() {
        return $17712d5d99762f43$exports.TreeItem;
    }
});
Object.defineProperty($903d28d692c77697$exports, "TreeItemCheckbox", {
    enumerable: true,
    get: function() {
        return $17712d5d99762f43$exports.TreeItemCheckbox;
    }
});
Object.defineProperty($903d28d692c77697$exports, "TreeItemContent", {
    enumerable: true,
    get: function() {
        return $17712d5d99762f43$exports.TreeItemContent;
    }
});
Object.defineProperty($903d28d692c77697$exports, "TreeItemGroupTransition", {
    enumerable: true,
    get: function() {
        return $17712d5d99762f43$exports.TreeItemGroupTransition;
    }
});
Object.defineProperty($903d28d692c77697$exports, "TreeItemIconContainer", {
    enumerable: true,
    get: function() {
        return $17712d5d99762f43$exports.TreeItemIconContainer;
    }
});
Object.defineProperty($903d28d692c77697$exports, "TreeItemLabel", {
    enumerable: true,
    get: function() {
        return $17712d5d99762f43$exports.TreeItemLabel;
    }
});
Object.defineProperty($903d28d692c77697$exports, "TreeItemRoot", {
    enumerable: true,
    get: function() {
        return $17712d5d99762f43$exports.TreeItemRoot;
    }
});
Object.defineProperty($903d28d692c77697$exports, "getTreeItemUtilityClass", {
    enumerable: true,
    get: function() {
        return $5ea0623dc4236a37$exports.getTreeItemUtilityClass;
    }
});
Object.defineProperty($903d28d692c77697$exports, "treeItemClasses", {
    enumerable: true,
    get: function() {
        return $5ea0623dc4236a37$exports.treeItemClasses;
    }
});
var $17712d5d99762f43$exports = {};
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $17712d5d99762f43$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $17712d5d99762f43$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($17712d5d99762f43$exports, "__esModule", {
    value: true
});
$17712d5d99762f43$exports.TreeItemRoot = $17712d5d99762f43$exports.TreeItemLoadingContainer = $17712d5d99762f43$exports.TreeItemLabel = $17712d5d99762f43$exports.TreeItemIconContainer = $17712d5d99762f43$exports.TreeItemGroupTransition = $17712d5d99762f43$exports.TreeItemErrorContainer = $17712d5d99762f43$exports.TreeItemContent = $17712d5d99762f43$exports.TreeItemCheckbox = $17712d5d99762f43$exports.TreeItem = void 0;

var $17712d5d99762f43$var$_objectWithoutPropertiesLoose2 = $17712d5d99762f43$require$_interopRequireDefault((parcelRequire("68UY6")));

var $17712d5d99762f43$var$_extends2 = $17712d5d99762f43$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $17712d5d99762f43$var$React = $17712d5d99762f43$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $17712d5d99762f43$var$_propTypes = $17712d5d99762f43$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $17712d5d99762f43$var$_clsx = $17712d5d99762f43$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $17712d5d99762f43$var$_CircularProgress = $17712d5d99762f43$require$_interopRequireDefault((parcelRequire("37mRE")));

var $17712d5d99762f43$var$_unsupportedProp = $17712d5d99762f43$require$_interopRequireDefault((parcelRequire("lalIu")));
var $eb77af00bcd819bc$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $eb77af00bcd819bc$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $eb77af00bcd819bc$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($eb77af00bcd819bc$exports, "__esModule", {
    value: true
});
var $eb77af00bcd819bc$var$_exportNames = {
    experimental_sx: true,
    THEME_ID: true,
    adaptV4Theme: true,
    hexToRgb: true,
    rgbToHex: true,
    hslToRgb: true,
    decomposeColor: true,
    recomposeColor: true,
    getContrastRatio: true,
    getLuminance: true,
    emphasize: true,
    alpha: true,
    darken: true,
    lighten: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    unstable_createBreakpoints: true,
    createTheme: true,
    unstable_createMuiStrictModeTheme: true,
    createStyles: true,
    unstable_getUnit: true,
    unstable_toUnitless: true,
    responsiveFontSizes: true,
    createTransitions: true,
    duration: true,
    easing: true,
    createColorScheme: true,
    useTheme: true,
    useThemeProps: true,
    styled: true,
    ThemeProvider: true,
    makeStyles: true,
    withStyles: true,
    withTheme: true,
    extendTheme: true,
    experimental_extendTheme: true,
    getOverlayAlpha: true,
    shouldSkipGeneratingVar: true,
    private_createTypography: true,
    private_createMixins: true,
    private_excludeVariablesFromRoot: true
};
Object.defineProperty($eb77af00bcd819bc$exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $gbhcr.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "THEME_ID", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_identifier.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_ThemeProvider.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "adaptV4Theme", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_adaptV4Theme.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "alpha", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$58f0f39f63f3cf42;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "createColorScheme", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_createColorScheme.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "createStyles", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_createStyles.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_createTheme.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "createTransitions", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_createTransitions.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "css", {
    enumerable: true,
    get: function() {
        return $bj8tp.css;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "darken", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$4b073707ff63303;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "decomposeColor", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$677b39864803984e;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "duration", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_createTransitions.duration;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "easing", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_createTransitions.easing;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "emphasize", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$e665714f76e581fd;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "experimental_extendTheme", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_experimental_extendTheme.default;
    }
});
$eb77af00bcd819bc$exports.experimental_sx = $eb77af00bcd819bc$var$experimental_sx;
Object.defineProperty($eb77af00bcd819bc$exports, "extendTheme", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_createThemeWithVars.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "getContrastRatio", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$d061e26956a60b0a;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "getLuminance", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$c852d90bf7403b62;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "getOverlayAlpha", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_getOverlayAlpha.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "hexToRgb", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$5a544e13ad4e1fa5;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "hslToRgb", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$29fb7152bd3f781a;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $bj8tp.keyframes;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "lighten", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$c0816ed86df316af;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "makeStyles", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_makeStyles.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "private_createMixins", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_createMixins.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "private_createTypography", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_createTypography.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "private_excludeVariablesFromRoot", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_excludeVariablesFromRoot.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "recomposeColor", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$211a73f2b8c10ce4;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "responsiveFontSizes", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_responsiveFontSizes.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "rgbToHex", {
    enumerable: true,
    get: function() {
        return $8fb953bfe4328390$export$34d09c4a771c46ef;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "shouldSkipGeneratingVar", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_shouldSkipGeneratingVar.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "styled", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_styled.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $361f20770d5c6a17$exports.unstable_createBreakpoints;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "unstable_createMuiStrictModeTheme", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_createMuiStrictModeTheme.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "unstable_getUnit", {
    enumerable: true,
    get: function() {
        return $eRNf4.getUnit;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "unstable_toUnitless", {
    enumerable: true,
    get: function() {
        return $eRNf4.toUnitless;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_useTheme.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_useThemeProps.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "withStyles", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_withStyles.default;
    }
});
Object.defineProperty($eb77af00bcd819bc$exports, "withTheme", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$var$_withTheme.default;
    }
});

var $eb77af00bcd819bc$var$_formatMuiErrorMessage = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $eb77af00bcd819bc$var$_identifier = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("Ho9ot")));

var $eb77af00bcd819bc$var$_adaptV4Theme = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("fwOL7")));

var $cCZAW = parcelRequire("cCZAW");

var $hxVqe = parcelRequire("hxVqe");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $8fb953bfe4328390$var$clampWrapper(value, min = 0, max = 1) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hxVqe)))(value, min, max);
}
function $8fb953bfe4328390$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $8fb953bfe4328390$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $8fb953bfe4328390$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $8fb953bfe4328390$export$677b39864803984e($8fb953bfe4328390$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($cCZAW)))(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($cCZAW)))(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $8fb953bfe4328390$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $8fb953bfe4328390$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $8fb953bfe4328390$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $8fb953bfe4328390$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $8fb953bfe4328390$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $8fb953bfe4328390$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $8fb953bfe4328390$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$8fb953bfe4328390$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $8fb953bfe4328390$export$29fb7152bd3f781a(color) {
    color = $8fb953bfe4328390$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $8fb953bfe4328390$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $8fb953bfe4328390$export$c852d90bf7403b62(color) {
    color = $8fb953bfe4328390$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $8fb953bfe4328390$export$677b39864803984e($8fb953bfe4328390$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $8fb953bfe4328390$export$d061e26956a60b0a(foreground, background) {
    const lumA = $8fb953bfe4328390$export$c852d90bf7403b62(foreground);
    const lumB = $8fb953bfe4328390$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $8fb953bfe4328390$export$58f0f39f63f3cf42(color, value) {
    color = $8fb953bfe4328390$export$677b39864803984e(color);
    value = $8fb953bfe4328390$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $8fb953bfe4328390$export$211a73f2b8c10ce4(color);
}
function $8fb953bfe4328390$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $8fb953bfe4328390$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $8fb953bfe4328390$export$4b073707ff63303(color, coefficient) {
    color = $8fb953bfe4328390$export$677b39864803984e(color);
    coefficient = $8fb953bfe4328390$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $8fb953bfe4328390$export$211a73f2b8c10ce4(color);
}
function $8fb953bfe4328390$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $8fb953bfe4328390$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $8fb953bfe4328390$export$c0816ed86df316af(color, coefficient) {
    color = $8fb953bfe4328390$export$677b39864803984e(color);
    coefficient = $8fb953bfe4328390$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $8fb953bfe4328390$export$211a73f2b8c10ce4(color);
}
function $8fb953bfe4328390$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $8fb953bfe4328390$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $8fb953bfe4328390$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $8fb953bfe4328390$export$c852d90bf7403b62(color) > 0.5 ? $8fb953bfe4328390$export$4b073707ff63303(color, coefficient) : $8fb953bfe4328390$export$c0816ed86df316af(color, coefficient);
}
function $8fb953bfe4328390$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $8fb953bfe4328390$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $8fb953bfe4328390$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $8fb953bfe4328390$export$677b39864803984e(background);
    const overlayColor = $8fb953bfe4328390$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $8fb953bfe4328390$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


var $bj8tp = parcelRequire("bj8tp");
var $gbhcr = parcelRequire("gbhcr");
var $361f20770d5c6a17$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $361f20770d5c6a17$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($361f20770d5c6a17$exports, "__esModule", {
    value: true
});
Object.defineProperty($361f20770d5c6a17$exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $361f20770d5c6a17$var$_createBreakpoints.default;
    }
});

var $361f20770d5c6a17$var$_createBreakpoints = $361f20770d5c6a17$require$_interopRequireDefault((parcelRequire("crgFF")));



var $eb77af00bcd819bc$var$_createTheme = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("dQ1bf")));

var $eb77af00bcd819bc$var$_createMuiStrictModeTheme = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("hYdxP")));

var $eb77af00bcd819bc$var$_createStyles = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("2STuI")));

var $eRNf4 = parcelRequire("eRNf4");

var $eb77af00bcd819bc$var$_responsiveFontSizes = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("hzWsq")));

var $eb77af00bcd819bc$var$_createTransitions = $eb77af00bcd819bc$require$_interopRequireWildcard((parcelRequire("3R9Iy")));

var $eb77af00bcd819bc$var$_createColorScheme = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("4DQJV")));

var $eb77af00bcd819bc$var$_useTheme = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("kYavH")));

var $eb77af00bcd819bc$var$_useThemeProps = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("6HsQe")));

var $eb77af00bcd819bc$var$_styled = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("dq4m7")));

var $eb77af00bcd819bc$var$_ThemeProvider = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("5LlAU")));

var $eb77af00bcd819bc$var$_makeStyles = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("lZ3Sv")));

var $eb77af00bcd819bc$var$_withStyles = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("2my3N")));

var $eb77af00bcd819bc$var$_withTheme = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("dWI9K")));

var $bgduR = parcelRequire("bgduR");
Object.keys($bgduR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($eb77af00bcd819bc$var$_exportNames, key)) return;
    if (key in $eb77af00bcd819bc$exports && $eb77af00bcd819bc$exports[key] === $bgduR[key]) return;
    Object.defineProperty($eb77af00bcd819bc$exports, key, {
        enumerable: true,
        get: function() {
            return $bgduR[key];
        }
    });
});

var $eb77af00bcd819bc$var$_createThemeWithVars = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("bODXu")));

var $eb77af00bcd819bc$var$_experimental_extendTheme = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("hqQxy")));

var $eb77af00bcd819bc$var$_getOverlayAlpha = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("7cuWF")));

var $eb77af00bcd819bc$var$_shouldSkipGeneratingVar = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("024TL")));

var $eb77af00bcd819bc$var$_createTypography = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("64QfU")));

var $eb77af00bcd819bc$var$_createMixins = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("2p16W")));

var $eb77af00bcd819bc$var$_excludeVariablesFromRoot = $eb77af00bcd819bc$require$_interopRequireDefault((parcelRequire("902eJ")));
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
function $eb77af00bcd819bc$var$experimental_sx() {
    throw new Error((0, $eb77af00bcd819bc$var$_formatMuiErrorMessage.default)(19));
} // The legacy utilities from @mui/styles
 // These are just empty functions that throws when invoked
 // TODO: Remove in v7
 // Private methods for creating parts of the theme



var $17712d5d99762f43$var$_Collapse = $17712d5d99762f43$require$_interopRequireDefault((parcelRequire("64RUw")));

var $17712d5d99762f43$var$_Checkbox = $17712d5d99762f43$require$_interopRequireDefault((parcelRequire("7qdWX")));

var $17712d5d99762f43$var$_useSlotProps = $17712d5d99762f43$require$_interopRequireDefault((parcelRequire("k3QMn")));

var $8GVXe = parcelRequire("8GVXe");

var $17712d5d99762f43$var$_composeClasses = $17712d5d99762f43$require$_interopRequireDefault((parcelRequire("4F19u")));
var $78255dd8255477c5$exports = {};
"use strict";
Object.defineProperty($78255dd8255477c5$exports, "__esModule", {
    value: true
});
$78255dd8255477c5$exports.createUseThemeProps = $78255dd8255477c5$var$createUseThemeProps;
Object.defineProperty($78255dd8255477c5$exports, "styled", {
    enumerable: true,
    get: function() {
        return $eb77af00bcd819bc$exports.styled;
    }
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $78255dd8255477c5$var$createUseThemeProps(name) {
    return $eb77af00bcd819bc$exports.useThemeProps;
}


var $9f588e9af86237d9$exports = {};
"use strict";
Object.defineProperty($9f588e9af86237d9$exports, "__esModule", {
    value: true
});
Object.defineProperty($9f588e9af86237d9$exports, "useTreeItem", {
    enumerable: true,
    get: function() {
        return $5d386d06cd366eb3$exports.useTreeItem;
    }
});
var $5d386d06cd366eb3$exports = {};
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $5d386d06cd366eb3$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $5d386d06cd366eb3$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($5d386d06cd366eb3$exports, "__esModule", {
    value: true
});
$5d386d06cd366eb3$exports.useTreeItem = void 0;

var $5d386d06cd366eb3$var$_extends2 = $5d386d06cd366eb3$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $5d386d06cd366eb3$var$React = $5d386d06cd366eb3$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $5d386d06cd366eb3$var$_extractEventHandlers = $5d386d06cd366eb3$require$_interopRequireDefault((parcelRequire("9ds9N")));

var $5d386d06cd366eb3$var$_useForkRef = $5d386d06cd366eb3$require$_interopRequireDefault((parcelRequire("7uWLa")));
var $33114ec9c2f70325$exports = {};
"use strict";
Object.defineProperty($33114ec9c2f70325$exports, "__esModule", {
    value: true
});
Object.defineProperty($33114ec9c2f70325$exports, "TreeViewProvider", {
    enumerable: true,
    get: function() {
        return $743019f9471d8d92$exports.TreeViewProvider;
    }
});
Object.defineProperty($33114ec9c2f70325$exports, "useTreeViewContext", {
    enumerable: true,
    get: function() {
        return $c25fee9f21dde4f7$exports.useTreeViewContext;
    }
});
var $743019f9471d8d92$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $743019f9471d8d92$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($743019f9471d8d92$exports, "__esModule", {
    value: true
});
$743019f9471d8d92$exports.TreeViewProvider = $743019f9471d8d92$var$TreeViewProvider;

var $743019f9471d8d92$var$React = $743019f9471d8d92$require$_interopRequireWildcard((parcelRequire("8nGP5")));
var $c25fee9f21dde4f7$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $c25fee9f21dde4f7$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($c25fee9f21dde4f7$exports, "__esModule", {
    value: true
});
$c25fee9f21dde4f7$exports.useTreeViewContext = $c25fee9f21dde4f7$exports.TreeViewContext = void 0;

var $c25fee9f21dde4f7$var$React = $c25fee9f21dde4f7$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * @ignore - internal component.
 */ const $c25fee9f21dde4f7$var$TreeViewContext = $c25fee9f21dde4f7$exports.TreeViewContext = /*#__PURE__*/ $c25fee9f21dde4f7$var$React.createContext(null);
const $c25fee9f21dde4f7$var$useTreeViewContext = ()=>{
    const context = $c25fee9f21dde4f7$var$React.useContext($c25fee9f21dde4f7$var$TreeViewContext);
    if (context == null) throw new Error([
        'MUI X: Could not find the Tree View context.',
        'It looks like you rendered your component outside of a SimpleTreeView or RichTreeView parent component.',
        'This can also happen if you are bundling multiple versions of the Tree View.'
    ].join('\n'));
    return context;
};
$c25fee9f21dde4f7$exports.useTreeViewContext = $c25fee9f21dde4f7$var$useTreeViewContext;


var $d712ba72daa2f7ea$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $d712ba72daa2f7ea$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($d712ba72daa2f7ea$exports, "__esModule", {
    value: true
});
$d712ba72daa2f7ea$exports.useTreeViewStyleContext = $d712ba72daa2f7ea$exports.TreeViewStyleContext = void 0;

var $d712ba72daa2f7ea$var$React = $d712ba72daa2f7ea$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * @ignore - internal component.
 */ const $d712ba72daa2f7ea$var$TreeViewStyleContext = $d712ba72daa2f7ea$exports.TreeViewStyleContext = /*#__PURE__*/ $d712ba72daa2f7ea$var$React.createContext({
    classes: {},
    slots: {},
    slotProps: {}
});
const $d712ba72daa2f7ea$var$useTreeViewStyleContext = ()=>{
    return $d712ba72daa2f7ea$var$React.useContext($d712ba72daa2f7ea$var$TreeViewStyleContext);
};
$d712ba72daa2f7ea$exports.useTreeViewStyleContext = $d712ba72daa2f7ea$var$useTreeViewStyleContext;



var $kSbwP = parcelRequire("kSbwP");
const $743019f9471d8d92$var$EMPTY_OBJECT = {};
/**
 * Sets up the contexts for the underlying Tree Item components.
 *
 * @ignore - do not document.
 */ function $743019f9471d8d92$var$TreeViewProvider(props) {
    const { contextValue: contextValue, classes: classes = $743019f9471d8d92$var$EMPTY_OBJECT, slots: slots = $743019f9471d8d92$var$EMPTY_OBJECT, slotProps: slotProps = $743019f9471d8d92$var$EMPTY_OBJECT, children: children } = props;
    const styleContextValue = $743019f9471d8d92$var$React.useMemo(()=>({
            classes: classes,
            slots: {
                collapseIcon: slots.collapseIcon,
                expandIcon: slots.expandIcon,
                endIcon: slots.endIcon
            },
            slotProps: {
                collapseIcon: slotProps.collapseIcon,
                expandIcon: slotProps.expandIcon,
                endIcon: slotProps.endIcon
            }
        }), [
        classes,
        slots.collapseIcon,
        slots.expandIcon,
        slots.endIcon,
        slotProps.collapseIcon,
        slotProps.expandIcon,
        slotProps.endIcon
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($c25fee9f21dde4f7$exports.TreeViewContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)($d712ba72daa2f7ea$exports.TreeViewStyleContext.Provider, {
            value: styleContextValue,
            children: contextValue.wrapRoot({
                children: children
            })
        })
    });
}





var $34f61e46418c653f$exports = {};
"use strict";
Object.defineProperty($34f61e46418c653f$exports, "__esModule", {
    value: true
});
Object.defineProperty($34f61e46418c653f$exports, "useTreeItemUtils", {
    enumerable: true,
    get: function() {
        return $d9f78308a67a5da5$exports.useTreeItemUtils;
    }
});
var $d9f78308a67a5da5$exports = {};
"use strict";
'use client';
Object.defineProperty($d9f78308a67a5da5$exports, "__esModule", {
    value: true
});
$d9f78308a67a5da5$exports.useTreeItemUtils = $d9f78308a67a5da5$exports.itemHasChildren = void 0;

var $8407f8bcbbd0da1e$exports = {};
"use strict";
Object.defineProperty($8407f8bcbbd0da1e$exports, "__esModule", {
    value: true
});
Object.defineProperty($8407f8bcbbd0da1e$exports, "useTreeViewLabel", {
    enumerable: true,
    get: function() {
        return $8a56bf7d47375a69$exports.useTreeViewLabel;
    }
});
var $8a56bf7d47375a69$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $8a56bf7d47375a69$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($8a56bf7d47375a69$exports, "__esModule", {
    value: true
});
$8a56bf7d47375a69$exports.useTreeViewLabel = void 0;

var $8a56bf7d47375a69$var$_extends2 = $8a56bf7d47375a69$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $8a56bf7d47375a69$var$_useEnhancedEffect = $8a56bf7d47375a69$require$_interopRequireDefault((parcelRequire("jMi8t")));
var $9bceea94b250abf7$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $9bceea94b250abf7$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($9bceea94b250abf7$exports, "__esModule", {
    value: true
});
$9bceea94b250abf7$exports.useTreeViewLabelItemPlugin = void 0;

var $9bceea94b250abf7$var$React = $9bceea94b250abf7$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $c1fb9b8a48f92cf3$exports = {};
"use strict";
Object.defineProperty($c1fb9b8a48f92cf3$exports, "__esModule", {
    value: true
});
$c1fb9b8a48f92cf3$exports.useSelector = void 0;
var $6b1fc6b5623be35e$exports = {};
'use strict';

$6b1fc6b5623be35e$exports = (parcelRequire("htUof"));


const $c1fb9b8a48f92cf3$var$defaultCompare = Object.is;
const $c1fb9b8a48f92cf3$var$useSelector = (store, selector, args, equals = $c1fb9b8a48f92cf3$var$defaultCompare)=>{
    const selectorWithArgs = (state)=>selector(state, args);
    return (0, $6b1fc6b5623be35e$exports.useSyncExternalStoreWithSelector)(store.subscribe, store.getSnapshot, store.getSnapshot, selectorWithArgs, equals);
};
$c1fb9b8a48f92cf3$exports.useSelector = $c1fb9b8a48f92cf3$var$useSelector;


var $d01956c8abb69943$exports = {};
"use strict";
Object.defineProperty($d01956c8abb69943$exports, "__esModule", {
    value: true
});
$d01956c8abb69943$exports.selectorIsItemEditable = $d01956c8abb69943$exports.selectorIsItemBeingEdited = $d01956c8abb69943$exports.selectorIsAnyItemBeingEdited = void 0;
var $2914ab2a8d092ccd$exports = {};
"use strict";
Object.defineProperty($2914ab2a8d092ccd$exports, "__esModule", {
    value: true
});
$2914ab2a8d092ccd$exports.createSelector = void 0;
var $90730c39e9f007a7$var$__defProp = Object.defineProperty;
var $90730c39e9f007a7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $90730c39e9f007a7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $90730c39e9f007a7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $90730c39e9f007a7$var$__defNormalProp = (obj, key, value)=>key in obj ? $90730c39e9f007a7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $90730c39e9f007a7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($90730c39e9f007a7$var$__hasOwnProp.call(b, prop)) $90730c39e9f007a7$var$__defNormalProp(a, prop, b[prop]);
    if ($90730c39e9f007a7$var$__getOwnPropSymbols) {
        for (var prop of $90730c39e9f007a7$var$__getOwnPropSymbols(b))if ($90730c39e9f007a7$var$__propIsEnum.call(b, prop)) $90730c39e9f007a7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $90730c39e9f007a7$var$__publicField = (obj, key, value)=>{
    $90730c39e9f007a7$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $90730c39e9f007a7$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $90730c39e9f007a7$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $90730c39e9f007a7$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $90730c39e9f007a7$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($90730c39e9f007a7$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $90730c39e9f007a7$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $90730c39e9f007a7$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $90730c39e9f007a7$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $90730c39e9f007a7$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $90730c39e9f007a7$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $90730c39e9f007a7$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $90730c39e9f007a7$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $90730c39e9f007a7$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $90730c39e9f007a7$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $90730c39e9f007a7$var$__spreadValues($90730c39e9f007a7$var$__spreadValues({}, $90730c39e9f007a7$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $90730c39e9f007a7$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $90730c39e9f007a7$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $90730c39e9f007a7$var$$REVISION = 0;
var $90730c39e9f007a7$var$CURRENT_TRACKER = null;
var $90730c39e9f007a7$var$Cell = class {
    constructor(initialValue, isEqual = $90730c39e9f007a7$var$tripleEq){
        $90730c39e9f007a7$var$__publicField(this, "revision", $90730c39e9f007a7$var$$REVISION);
        $90730c39e9f007a7$var$__publicField(this, "_value");
        $90730c39e9f007a7$var$__publicField(this, "_lastValue");
        $90730c39e9f007a7$var$__publicField(this, "_isEqual", $90730c39e9f007a7$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $90730c39e9f007a7$var$CURRENT_TRACKER == null || $90730c39e9f007a7$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$90730c39e9f007a7$var$$REVISION;
    }
};
function $90730c39e9f007a7$var$tripleEq(a, b) {
    return a === b;
}
var $90730c39e9f007a7$var$TrackingCache = class {
    constructor(fn){
        $90730c39e9f007a7$var$__publicField(this, "_cachedValue");
        $90730c39e9f007a7$var$__publicField(this, "_cachedRevision", -1);
        $90730c39e9f007a7$var$__publicField(this, "_deps", []);
        $90730c39e9f007a7$var$__publicField(this, "hits", 0);
        $90730c39e9f007a7$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $90730c39e9f007a7$var$CURRENT_TRACKER;
            $90730c39e9f007a7$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $90730c39e9f007a7$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $90730c39e9f007a7$var$CURRENT_TRACKER == null || $90730c39e9f007a7$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $90730c39e9f007a7$var$getValue(cell) {
    if (!(cell instanceof $90730c39e9f007a7$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $90730c39e9f007a7$var$setValue(storage, value) {
    if (!(storage instanceof $90730c39e9f007a7$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $90730c39e9f007a7$var$createCell(initialValue, isEqual = $90730c39e9f007a7$var$tripleEq) {
    return new $90730c39e9f007a7$var$Cell(initialValue, isEqual);
}
function $90730c39e9f007a7$var$createCache(fn) {
    $90730c39e9f007a7$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $90730c39e9f007a7$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $90730c39e9f007a7$var$neverEq = (a, b)=>false;
function $90730c39e9f007a7$var$createTag() {
    return $90730c39e9f007a7$var$createCell(null, $90730c39e9f007a7$var$neverEq);
}
function $90730c39e9f007a7$var$dirtyTag(tag, value) {
    $90730c39e9f007a7$var$setValue(tag, value);
}
var $90730c39e9f007a7$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $90730c39e9f007a7$var$createTag();
    $90730c39e9f007a7$var$getValue(tag);
};
var $90730c39e9f007a7$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $90730c39e9f007a7$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $90730c39e9f007a7$var$REDUX_PROXY_LABEL = Symbol();
var $90730c39e9f007a7$var$nextId = 0;
var $90730c39e9f007a7$var$proto = Object.getPrototypeOf({});
var $90730c39e9f007a7$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $90730c39e9f007a7$var$__publicField(this, "proxy", new Proxy(this, $90730c39e9f007a7$var$objectProxyHandler));
        $90730c39e9f007a7$var$__publicField(this, "tag", $90730c39e9f007a7$var$createTag());
        $90730c39e9f007a7$var$__publicField(this, "tags", {});
        $90730c39e9f007a7$var$__publicField(this, "children", {});
        $90730c39e9f007a7$var$__publicField(this, "collectionTag", null);
        $90730c39e9f007a7$var$__publicField(this, "id", $90730c39e9f007a7$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $90730c39e9f007a7$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $90730c39e9f007a7$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $90730c39e9f007a7$var$createNode(childValue);
                if (childNode.tag) $90730c39e9f007a7$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $90730c39e9f007a7$var$createTag();
                    tag.value = childValue;
                }
                $90730c39e9f007a7$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $90730c39e9f007a7$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $90730c39e9f007a7$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $90730c39e9f007a7$var$__publicField(this, "proxy", new Proxy([
            this
        ], $90730c39e9f007a7$var$arrayProxyHandler));
        $90730c39e9f007a7$var$__publicField(this, "tag", $90730c39e9f007a7$var$createTag());
        $90730c39e9f007a7$var$__publicField(this, "tags", {});
        $90730c39e9f007a7$var$__publicField(this, "children", {});
        $90730c39e9f007a7$var$__publicField(this, "collectionTag", null);
        $90730c39e9f007a7$var$__publicField(this, "id", $90730c39e9f007a7$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $90730c39e9f007a7$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $90730c39e9f007a7$var$consumeCollection(node);
        return $90730c39e9f007a7$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $90730c39e9f007a7$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $90730c39e9f007a7$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $90730c39e9f007a7$var$objectProxyHandler.has(node, prop);
    }
};
function $90730c39e9f007a7$var$createNode(value) {
    if (Array.isArray(value)) return new $90730c39e9f007a7$var$ArrayTreeNode(value);
    return new $90730c39e9f007a7$var$ObjectTreeNode(value);
}
function $90730c39e9f007a7$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $90730c39e9f007a7$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $90730c39e9f007a7$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $90730c39e9f007a7$var$dirtyCollection(node);
            $90730c39e9f007a7$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $90730c39e9f007a7$var$updateNode(childNode, newChildValue);
        else {
            $90730c39e9f007a7$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $90730c39e9f007a7$var$deleteNode(node) {
    if (node.tag) $90730c39e9f007a7$var$dirtyTag(node.tag, null);
    $90730c39e9f007a7$var$dirtyCollection(node);
    for(const key in node.tags)$90730c39e9f007a7$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$90730c39e9f007a7$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $90730c39e9f007a7$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $90730c39e9f007a7$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $90730c39e9f007a7$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $90730c39e9f007a7$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $90730c39e9f007a7$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $90730c39e9f007a7$export$3f025202a230c6dd = (a, b)=>a === b;
function $90730c39e9f007a7$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $90730c39e9f007a7$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $90730c39e9f007a7$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $90730c39e9f007a7$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $90730c39e9f007a7$var$createSingletonCache(comparator) : $90730c39e9f007a7$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $90730c39e9f007a7$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $90730c39e9f007a7$export$c8f9cf88d9fdee55(func) {
    const node = $90730c39e9f007a7$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $90730c39e9f007a7$var$createCacheKeyComparator($90730c39e9f007a7$export$3f025202a230c6dd);
    const cache = $90730c39e9f007a7$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $90730c39e9f007a7$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $90730c39e9f007a7$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $90730c39e9f007a7$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $90730c39e9f007a7$var$StrongRef;
var $90730c39e9f007a7$var$UNTERMINATED = 0;
var $90730c39e9f007a7$var$TERMINATED = 1;
function $90730c39e9f007a7$var$createCacheNode() {
    return {
        s: $90730c39e9f007a7$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $90730c39e9f007a7$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $90730c39e9f007a7$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $90730c39e9f007a7$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $90730c39e9f007a7$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $90730c39e9f007a7$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $90730c39e9f007a7$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $90730c39e9f007a7$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $90730c39e9f007a7$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $90730c39e9f007a7$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $90730c39e9f007a7$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $90730c39e9f007a7$var$__spreadValues($90730c39e9f007a7$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $90730c39e9f007a7$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $90730c39e9f007a7$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $90730c39e9f007a7$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $90730c39e9f007a7$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $90730c39e9f007a7$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $90730c39e9f007a7$export$595d22ed68ca2841 = /* @__PURE__ */ $90730c39e9f007a7$export$5943f4447f6ef248($90730c39e9f007a7$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $90730c39e9f007a7$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $90730c39e9f007a7$export$595d22ed68ca2841)=>{
    $90730c39e9f007a7$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$90730c39e9f007a7$export$75979cfcd91bf38f
});


const $2914ab2a8d092ccd$var$reselectCreateSelector = (0, $90730c39e9f007a7$export$5943f4447f6ef248)({
    memoize: $90730c39e9f007a7$export$d8ead1d92249919b,
    memoizeOptions: {
        maxSize: 1,
        equalityCheck: Object.is
    }
});
const $2914ab2a8d092ccd$var$cache = new WeakMap();
/**
 * Type of a selector that take the whole tree view state as input and returns a value based on a required plugin.
 */ /**
 * Type of a selector that take the whole tree view state as input and returns a value based on an optional plugin.
 */ /**
 * Method wrapping reselect's createSelector to provide caching for tree view instances.
 *
 */ const $2914ab2a8d092ccd$var$createSelector = (...createSelectorArgs)=>{
    const selector = (state, selectorArgs)=>{
        const cacheKey = state.cacheKey;
        // If there is no cache for the current tree view instance, create one.
        let cacheForCurrentTreeViewInstance = $2914ab2a8d092ccd$var$cache.get(cacheKey);
        if (!cacheForCurrentTreeViewInstance) {
            cacheForCurrentTreeViewInstance = new Map();
            $2914ab2a8d092ccd$var$cache.set(cacheKey, cacheForCurrentTreeViewInstance);
        }
        // If there is a cached selector, execute it.
        const cachedSelector = cacheForCurrentTreeViewInstance.get(createSelectorArgs);
        if (cachedSelector) return cachedSelector(state, selectorArgs);
        // Otherwise, create a new selector and cache it and execute it.
        const fn = $2914ab2a8d092ccd$var$reselectCreateSelector(...createSelectorArgs);
        cacheForCurrentTreeViewInstance.set(createSelectorArgs, fn);
        return fn(state, selectorArgs);
    };
    return selector;
};
$2914ab2a8d092ccd$exports.createSelector = $2914ab2a8d092ccd$var$createSelector;


var $4bf621410ffd294f$exports = {};
"use strict";
Object.defineProperty($4bf621410ffd294f$exports, "__esModule", {
    value: true
});
$4bf621410ffd294f$exports.selectorItemParentId = $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds = $4bf621410ffd294f$exports.selectorItemModel = $4bf621410ffd294f$exports.selectorItemMetaLookup = $4bf621410ffd294f$exports.selectorItemMeta = $4bf621410ffd294f$exports.selectorItemIndex = $4bf621410ffd294f$exports.selectorItemDepth = $4bf621410ffd294f$exports.selectorIsTreeViewLoading = $4bf621410ffd294f$exports.selectorIsItemDisabled = $4bf621410ffd294f$exports.selectorGetTreeViewError = $4bf621410ffd294f$exports.selectorDisabledItemFocusable = $4bf621410ffd294f$exports.selectorCanItemBeFocused = void 0;

var $2abc8533f192485b$exports = {};
"use strict";
Object.defineProperty($2abc8533f192485b$exports, "__esModule", {
    value: true
});
$2abc8533f192485b$exports.isItemDisabled = $2abc8533f192485b$exports.buildSiblingIndexes = $2abc8533f192485b$exports.TREE_VIEW_ROOT_PARENT_ID = void 0;
const $2abc8533f192485b$var$TREE_VIEW_ROOT_PARENT_ID = $2abc8533f192485b$exports.TREE_VIEW_ROOT_PARENT_ID = '__TREE_VIEW_ROOT_PARENT_ID__';
const $2abc8533f192485b$var$buildSiblingIndexes = (siblings)=>{
    const siblingsIndexLookup = {};
    siblings.forEach((childId, index)=>{
        siblingsIndexLookup[childId] = index;
    });
    return siblingsIndexLookup;
};
/**
 * Check if an item is disabled.
 * This method should only be used in selectors that are checking if several items are disabled.
 * Otherwise, use the `selectorIsItemDisabled` selector.
 * @returns
 */ $2abc8533f192485b$exports.buildSiblingIndexes = $2abc8533f192485b$var$buildSiblingIndexes;
const $2abc8533f192485b$var$isItemDisabled = (itemMetaLookup, itemId)=>{
    if (itemId == null) return false;
    let itemMeta = itemMetaLookup[itemId];
    // This can be called before the item has been added to the item map.
    if (!itemMeta) return false;
    if (itemMeta.disabled) return true;
    while(itemMeta.parentId != null){
        itemMeta = itemMetaLookup[itemMeta.parentId];
        if (!itemMeta) return false;
        if (itemMeta.disabled) return true;
    }
    return false;
};
$2abc8533f192485b$exports.isItemDisabled = $2abc8533f192485b$var$isItemDisabled;


const $4bf621410ffd294f$var$selectorTreeViewItemsState = (state)=>state.items;
/**
 * Get the loading state for the Tree View.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @returns {boolean} The loading state for the Tree View.
 */ const $4bf621410ffd294f$var$selectorIsTreeViewLoading = $4bf621410ffd294f$exports.selectorIsTreeViewLoading = (0, $2914ab2a8d092ccd$exports.createSelector)($4bf621410ffd294f$var$selectorTreeViewItemsState, (items)=>items.loading);
/**
 * Get the error state for the Tree View.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @returns {boolean} The error state for the Tree View.
 */ const $4bf621410ffd294f$var$selectorGetTreeViewError = $4bf621410ffd294f$exports.selectorGetTreeViewError = (0, $2914ab2a8d092ccd$exports.createSelector)($4bf621410ffd294f$var$selectorTreeViewItemsState, (items)=>items.error);
/**
 * Get the meta-information of all items.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @returns {TreeViewItemMetaLookup} The meta-information of all items.
 */ const $4bf621410ffd294f$var$selectorItemMetaLookup = $4bf621410ffd294f$exports.selectorItemMetaLookup = (0, $2914ab2a8d092ccd$exports.createSelector)($4bf621410ffd294f$var$selectorTreeViewItemsState, (items)=>items.itemMetaLookup);
const $4bf621410ffd294f$var$EMPTY_CHILDREN = [];
/**
 * Get the ordered children ids of a given item.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the children of.
 * @returns {TreeViewItemId[]} The ordered children ids of the item.
 */ const $4bf621410ffd294f$var$selectorItemOrderedChildrenIds = $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$var$selectorTreeViewItemsState,
    (_, itemId)=>itemId
], (itemsState, itemId)=>itemsState.itemOrderedChildrenIdsLookup[itemId ?? $2abc8533f192485b$exports.TREE_VIEW_ROOT_PARENT_ID] ?? $4bf621410ffd294f$var$EMPTY_CHILDREN);
/**
 * Get the model of an item.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the model of.
 * @returns {R} The model of the item.
 */ const $4bf621410ffd294f$var$selectorItemModel = $4bf621410ffd294f$exports.selectorItemModel = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$var$selectorTreeViewItemsState,
    (_, itemId)=>itemId
], (itemsState, itemId)=>itemsState.itemModelLookup[itemId]);
/**
 * Get the meta-information of an item.
 * Check the `TreeViewItemMeta` type for more information.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>}
 * @param {TreeViewItemId} itemId The id of the item to get the meta-information of.
 * @returns {TreeViewItemMeta | null} The meta-information of the item.
 */ const $4bf621410ffd294f$var$selectorItemMeta = $4bf621410ffd294f$exports.selectorItemMeta = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$var$selectorItemMetaLookup,
    (_, itemId)=>itemId
], (itemMetaLookup, itemId)=>itemMetaLookup[itemId ?? $2abc8533f192485b$exports.TREE_VIEW_ROOT_PARENT_ID] ?? null);
/**
 * Check if an item is disabled.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to check.
 * @returns {boolean} `true` if the item is disabled, `false` otherwise.
 */ const $4bf621410ffd294f$var$selectorIsItemDisabled = $4bf621410ffd294f$exports.selectorIsItemDisabled = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$var$selectorItemMetaLookup,
    (_, itemId)=>itemId
], $2abc8533f192485b$exports.isItemDisabled);
/**
 * Get the index of an item in its parent's children.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the index of.
 * @returns {number} The index of the item in its parent's children.
 */ const $4bf621410ffd294f$var$selectorItemIndex = $4bf621410ffd294f$exports.selectorItemIndex = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$var$selectorTreeViewItemsState,
    $4bf621410ffd294f$var$selectorItemMeta
], (itemsState, itemMeta)=>{
    if (itemMeta == null) return -1;
    const parentIndexes = itemsState.itemChildrenIndexesLookup[itemMeta.parentId ?? $2abc8533f192485b$exports.TREE_VIEW_ROOT_PARENT_ID];
    return parentIndexes[itemMeta.id];
});
/**
 * Get the id of the parent of an item.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the parent id of.
 * @returns {TreeViewItemId | null} The id of the parent of the item.
 */ const $4bf621410ffd294f$var$selectorItemParentId = $4bf621410ffd294f$exports.selectorItemParentId = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$var$selectorItemMeta
], (itemMeta)=>itemMeta?.parentId ?? null);
/**
 * Get the depth of an item (items at the root level have a depth of 0).
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the depth of.
 * @returns {number} The depth of the item.
 */ const $4bf621410ffd294f$var$selectorItemDepth = $4bf621410ffd294f$exports.selectorItemDepth = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$var$selectorItemMeta
], (itemMeta)=>itemMeta?.depth ?? 0);
/**
 * Check if the disabled items are focusable.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @returns {boolean} Whether the disabled items are focusable.
 */ const $4bf621410ffd294f$var$selectorDisabledItemFocusable = $4bf621410ffd294f$exports.selectorDisabledItemFocusable = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$var$selectorTreeViewItemsState
], (itemsState)=>itemsState.disabledItemsFocusable);
const $4bf621410ffd294f$var$selectorCanItemBeFocused = $4bf621410ffd294f$exports.selectorCanItemBeFocused = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$var$selectorDisabledItemFocusable,
    $4bf621410ffd294f$var$selectorIsItemDisabled
], (disabledItemsFocusable, isDisabled)=>{
    if (disabledItemsFocusable) return true;
    return !isDisabled;
});


const $d01956c8abb69943$var$selectorTreeViewLabelState = (state)=>state.label;
/**
 * Check if an item is editable.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to check.
 * @returns {boolean} `true` if the item is editable, `false` otherwise.
 */ const $d01956c8abb69943$var$selectorIsItemEditable = $d01956c8abb69943$exports.selectorIsItemEditable = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $d01956c8abb69943$var$selectorTreeViewLabelState,
    (state, itemId)=>(0, $4bf621410ffd294f$exports.selectorItemModel)(state, itemId)
], (labelState, itemModel)=>{
    if (!itemModel || !labelState) return false;
    if (typeof labelState.isItemEditable === 'boolean') return labelState.isItemEditable;
    return labelState.isItemEditable(itemModel);
});
/**
 * Check if the given item is being edited.
 * @param {TreeViewState<[UseTreeViewLabelSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to check.
 * @returns {boolean} `true` if the item is being edited, `false` otherwise.
 */ const $d01956c8abb69943$var$selectorIsItemBeingEdited = $d01956c8abb69943$exports.selectorIsItemBeingEdited = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $d01956c8abb69943$var$selectorTreeViewLabelState,
    (_, itemId)=>itemId
], (labelState, itemId)=>itemId ? labelState?.editedItemId === itemId : false);
/**
 * Check if an item is being edited.
 * @param {TreeViewState<[UseTreeViewLabelSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if an item is being edited, `false` otherwise.
 */ const $d01956c8abb69943$var$selectorIsAnyItemBeingEdited = $d01956c8abb69943$exports.selectorIsAnyItemBeingEdited = (0, $2914ab2a8d092ccd$exports.createSelector)($d01956c8abb69943$var$selectorTreeViewLabelState, (labelState)=>!!labelState?.editedItemId);


const $9bceea94b250abf7$var$useTreeViewLabelItemPlugin = ({ props: props })=>{
    const { store: store } = (0, $33114ec9c2f70325$exports.useTreeViewContext)();
    const { label: label, itemId: itemId } = props;
    const [labelInputValue, setLabelInputValue] = $9bceea94b250abf7$var$React.useState(label);
    const isItemEditable = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $d01956c8abb69943$exports.selectorIsItemEditable, itemId);
    const isItemBeingEdited = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $d01956c8abb69943$exports.selectorIsItemBeingEdited, itemId);
    $9bceea94b250abf7$var$React.useEffect(()=>{
        if (!isItemBeingEdited) setLabelInputValue(label);
    }, [
        isItemBeingEdited,
        label
    ]);
    return {
        propsEnhancers: {
            label: ()=>({
                    editable: isItemEditable
                }),
            labelInput: ({ externalEventHandlers: externalEventHandlers, interactions: interactions })=>{
                if (!isItemEditable) return {};
                const handleKeydown = (event)=>{
                    externalEventHandlers.onKeyDown?.(event);
                    if (event.defaultMuiPrevented) return;
                    const target = event.target;
                    if (event.key === 'Enter' && target.value) interactions.handleSaveItemLabel(event, target.value);
                    else if (event.key === 'Escape') interactions.handleCancelItemLabelEditing(event);
                };
                const handleBlur = (event)=>{
                    externalEventHandlers.onBlur?.(event);
                    if (event.defaultMuiPrevented) return;
                    if (event.target.value) interactions.handleSaveItemLabel(event, event.target.value);
                };
                const handleInputChange = (event)=>{
                    externalEventHandlers.onChange?.(event);
                    setLabelInputValue(event.target.value);
                };
                return {
                    value: labelInputValue ?? '',
                    'data-element': 'labelInput',
                    onChange: handleInputChange,
                    onKeyDown: handleKeydown,
                    onBlur: handleBlur,
                    autoFocus: true,
                    type: 'text'
                };
            }
        }
    };
};
$9bceea94b250abf7$exports.useTreeViewLabelItemPlugin = $9bceea94b250abf7$var$useTreeViewLabelItemPlugin;


const $8a56bf7d47375a69$var$useTreeViewLabel = ({ store: store, params: params })=>{
    const setEditedItemId = (editedItemId)=>{
        store.update((prevState)=>(0, $8a56bf7d47375a69$var$_extends2.default)({}, prevState, {
                label: (0, $8a56bf7d47375a69$var$_extends2.default)({}, prevState.label, {
                    editedItemId: editedItemId
                })
            }));
    };
    const updateItemLabel = (itemId, label)=>{
        if (!label) throw new Error([
            'MUI X: The Tree View component requires all items to have a `label` property.',
            'The label of an item cannot be empty.',
            itemId
        ].join('\n'));
        store.update((prevState)=>{
            const item = prevState.items.itemMetaLookup[itemId];
            if (item.label !== label) return (0, $8a56bf7d47375a69$var$_extends2.default)({}, prevState, {
                items: (0, $8a56bf7d47375a69$var$_extends2.default)({}, prevState.items, {
                    itemMetaLookup: (0, $8a56bf7d47375a69$var$_extends2.default)({}, prevState.items.itemMetaLookup, {
                        [itemId]: (0, $8a56bf7d47375a69$var$_extends2.default)({}, item, {
                            label: label
                        })
                    })
                })
            });
            return prevState;
        });
        if (params.onItemLabelChange) params.onItemLabelChange(itemId, label);
    };
    (0, $8a56bf7d47375a69$var$_useEnhancedEffect.default)(()=>{
        store.update((prevState)=>(0, $8a56bf7d47375a69$var$_extends2.default)({}, prevState, {
                label: (0, $8a56bf7d47375a69$var$_extends2.default)({}, prevState.label, {
                    isItemEditable: params.isItemEditable
                })
            }));
    }, [
        store,
        params.isItemEditable
    ]);
    return {
        instance: {
            setEditedItemId: setEditedItemId,
            updateItemLabel: updateItemLabel
        },
        publicAPI: {
            updateItemLabel: updateItemLabel
        }
    };
};
$8a56bf7d47375a69$exports.useTreeViewLabel = $8a56bf7d47375a69$var$useTreeViewLabel;
$8a56bf7d47375a69$var$useTreeViewLabel.itemPlugin = $9bceea94b250abf7$exports.useTreeViewLabelItemPlugin;
$8a56bf7d47375a69$var$useTreeViewLabel.getDefaultizedParams = ({ params: params })=>(0, $8a56bf7d47375a69$var$_extends2.default)({}, params, {
        isItemEditable: params.isItemEditable ?? false
    });
$8a56bf7d47375a69$var$useTreeViewLabel.getInitialState = (params)=>({
        label: {
            isItemEditable: params.isItemEditable,
            editedItemId: null
        }
    });
$8a56bf7d47375a69$var$useTreeViewLabel.params = {
    onItemLabelChange: true,
    isItemEditable: true
};




var $d8bebe0ab57a7f3c$exports = {};
"use strict";
Object.defineProperty($d8bebe0ab57a7f3c$exports, "__esModule", {
    value: true
});
$d8bebe0ab57a7f3c$exports.hasPlugin = void 0;
const $d8bebe0ab57a7f3c$var$hasPlugin = (instance, plugin)=>{
    const plugins = instance.getAvailablePlugins();
    return plugins.has(plugin);
};
$d8bebe0ab57a7f3c$exports.hasPlugin = $d8bebe0ab57a7f3c$var$hasPlugin;



var $78cc7d98a5cf23b4$exports = {};
"use strict";
Object.defineProperty($78cc7d98a5cf23b4$exports, "__esModule", {
    value: true
});
$78cc7d98a5cf23b4$exports.selectorItemExpansionTrigger = $78cc7d98a5cf23b4$exports.selectorIsItemExpanded = $78cc7d98a5cf23b4$exports.selectorIsItemExpandable = $78cc7d98a5cf23b4$exports.selectorExpandedItemsMap = $78cc7d98a5cf23b4$exports.selectorExpandedItems = void 0;


const $78cc7d98a5cf23b4$var$selectorExpansion = (state)=>state.expansion;
/**
 * Get the expanded items.
 * @param {TreeViewState<[UseTreeViewExpansionSignature]>} state The state of the tree view.
 * @returns {TreeViewItemId[]} The expanded items.
 */ const $78cc7d98a5cf23b4$var$selectorExpandedItems = $78cc7d98a5cf23b4$exports.selectorExpandedItems = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $78cc7d98a5cf23b4$var$selectorExpansion
], (expansionState)=>expansionState.expandedItems);
/**
 * Get the expanded items as a Map.
 * @param {TreeViewState<[UseTreeViewExpansionSignature]>} state The state of the tree view.
 * @returns {TreeViewExpansionValue} The expanded items as a Map.
 */ const $78cc7d98a5cf23b4$var$selectorExpandedItemsMap = $78cc7d98a5cf23b4$exports.selectorExpandedItemsMap = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $78cc7d98a5cf23b4$var$selectorExpandedItems
], (expandedItems)=>{
    const expandedItemsMap = new Map();
    expandedItems.forEach((id)=>{
        expandedItemsMap.set(id, true);
    });
    return expandedItemsMap;
});
/**
 * Check if an item is expanded.
 * @param {TreeViewState<[UseTreeViewExpansionSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if the item is expanded, `false` otherwise.
 */ const $78cc7d98a5cf23b4$var$selectorIsItemExpanded = $78cc7d98a5cf23b4$exports.selectorIsItemExpanded = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $78cc7d98a5cf23b4$var$selectorExpandedItemsMap,
    (_, itemId)=>itemId
], (expandedItemsMap, itemId)=>expandedItemsMap.has(itemId));
/**
 * Check if an item is expandable.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if the item is expandable, `false` otherwise.
 */ const $78cc7d98a5cf23b4$var$selectorIsItemExpandable = $78cc7d98a5cf23b4$exports.selectorIsItemExpandable = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$exports.selectorItemMeta
], (itemMeta)=>itemMeta?.expandable ?? false);
/**
 * Get the slot that triggers the item's expansion when clicked.
 * @param {TreeViewState<[UseTreeViewExpansionSignature]>} state The state of the tree view.
 * @returns {'content' | 'iconContainer'} The slot that triggers the item's expansion when clicked. Is `null` if the item is not expandable.
 */ const $78cc7d98a5cf23b4$var$selectorItemExpansionTrigger = $78cc7d98a5cf23b4$exports.selectorItemExpansionTrigger = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $78cc7d98a5cf23b4$var$selectorExpansion
], (expansionState)=>expansionState.expansionTrigger);


var $adfd4ba063607d91$exports = {};
"use strict";
Object.defineProperty($adfd4ba063607d91$exports, "__esModule", {
    value: true
});
$adfd4ba063607d91$exports.selectorIsItemTheDefaultFocusableItem = $adfd4ba063607d91$exports.selectorIsItemFocused = $adfd4ba063607d91$exports.selectorFocusedItemId = $adfd4ba063607d91$exports.selectorDefaultFocusableItemId = void 0;

var $88945f81c6be66ca$exports = {};
"use strict";
Object.defineProperty($88945f81c6be66ca$exports, "__esModule", {
    value: true
});
$88945f81c6be66ca$exports.selectorSelectionPropagationRules = $88945f81c6be66ca$exports.selectorSelectionModelArray = $88945f81c6be66ca$exports.selectorSelectionModel = $88945f81c6be66ca$exports.selectorIsSelectionEnabled = $88945f81c6be66ca$exports.selectorIsMultiSelectEnabled = $88945f81c6be66ca$exports.selectorIsItemSelectionEnabled = $88945f81c6be66ca$exports.selectorIsItemSelected = $88945f81c6be66ca$exports.selectorIsCheckboxSelectionEnabled = void 0;


const $88945f81c6be66ca$var$selectorTreeViewSelectionState = (state)=>state.selection;
/**
 * Get the selected items.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {TreeViewSelectionValue<boolean>} The selected items.
 */ const $88945f81c6be66ca$var$selectorSelectionModel = $88945f81c6be66ca$exports.selectorSelectionModel = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $88945f81c6be66ca$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.selectedItems);
/**
 * Get the selected items as an array.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {TreeViewItemId[]} The selected items as an array.
 */ const $88945f81c6be66ca$var$selectorSelectionModelArray = $88945f81c6be66ca$exports.selectorSelectionModelArray = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $88945f81c6be66ca$var$selectorSelectionModel
], (selectedItems)=>{
    if (Array.isArray(selectedItems)) return selectedItems;
    if (selectedItems != null) return [
        selectedItems
    ];
    return [];
});
/**
 * Get the selected items as a map.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {Map<TreeViewItemId, true>} The selected items as a Map.
 */ const $88945f81c6be66ca$var$selectorSelectionModelMap = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $88945f81c6be66ca$var$selectorSelectionModelArray
], (selectedItems)=>{
    const selectedItemsMap = new Map();
    selectedItems.forEach((id)=>{
        selectedItemsMap.set(id, true);
    });
    return selectedItemsMap;
});
/**
 * Check if an item is selected.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if the item is selected, `false` otherwise.
 */ const $88945f81c6be66ca$var$selectorIsItemSelected = $88945f81c6be66ca$exports.selectorIsItemSelected = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $88945f81c6be66ca$var$selectorSelectionModelMap,
    (_, itemId)=>itemId
], (selectedItemsMap, itemId)=>selectedItemsMap.has(itemId));
/**
 * Check if multi selection is enabled.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if multi selection is enabled, `false` otherwise.
 */ const $88945f81c6be66ca$var$selectorIsMultiSelectEnabled = $88945f81c6be66ca$exports.selectorIsMultiSelectEnabled = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $88945f81c6be66ca$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.isEnabled && selectionState.isMultiSelectEnabled);
/**
 * Check if selection is enabled.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if selection is enabled, `false` otherwise.
 */ const $88945f81c6be66ca$var$selectorIsSelectionEnabled = $88945f81c6be66ca$exports.selectorIsSelectionEnabled = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $88945f81c6be66ca$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.isEnabled);
/**
 * Check if checkbox selection is enabled.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if checkbox selection is enabled, `false` otherwise.
 */ const $88945f81c6be66ca$var$selectorIsCheckboxSelectionEnabled = $88945f81c6be66ca$exports.selectorIsCheckboxSelectionEnabled = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $88945f81c6be66ca$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.isCheckboxSelectionEnabled);
/**
 * Check if selection is enabled for an item (if selection is enabled and if the item is not disabled).
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @param {string} itemId The id of the item to check.
 * @returns {boolean} `true` if selection is enabled for the item, `false` otherwise.
 */ const $88945f81c6be66ca$var$selectorIsItemSelectionEnabled = $88945f81c6be66ca$exports.selectorIsItemSelectionEnabled = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $4bf621410ffd294f$exports.selectorIsItemDisabled,
    $88945f81c6be66ca$var$selectorIsSelectionEnabled
], (isItemDisabled, isSelectionEnabled)=>isSelectionEnabled && !isItemDisabled);
/**
 * Get the selection propagation rules.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {TreeViewSelectionPropagation} The selection propagation rules.
 */ const $88945f81c6be66ca$var$selectorSelectionPropagationRules = $88945f81c6be66ca$exports.selectorSelectionPropagationRules = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $88945f81c6be66ca$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.selectionPropagation);





const $adfd4ba063607d91$var$selectorTreeViewFocusState = (state)=>state.focus;
/**
 * Get the item that should be sequentially focusable (usually with the Tab key).
 * At any point in time, there is a single item that can be sequentially focused in the Tree View.
 * This item is the first selected item (that is both visible and navigable), if any, or the first navigable item if no item is selected.
 * @param {TreeViewState<[UseTreeViewFocusSignature]>} state The state of the tree view.
 * @returns {TreeViewItemId | null} The id of the item that should be sequentially focusable.
 */ const $adfd4ba063607d91$var$selectorDefaultFocusableItemId = $adfd4ba063607d91$exports.selectorDefaultFocusableItemId = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $88945f81c6be66ca$exports.selectorSelectionModelArray,
    $78cc7d98a5cf23b4$exports.selectorExpandedItemsMap,
    $4bf621410ffd294f$exports.selectorItemMetaLookup,
    $4bf621410ffd294f$exports.selectorDisabledItemFocusable,
    (state)=>(0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, null)
], (selectedItems, expandedItemsMap, itemMetaLookup, disabledItemsFocusable, orderedRootItemIds)=>{
    const firstSelectedItem = selectedItems.find((itemId)=>{
        if (!disabledItemsFocusable && (0, $2abc8533f192485b$exports.isItemDisabled)(itemMetaLookup, itemId)) return false;
        const itemMeta = itemMetaLookup[itemId];
        return itemMeta && (itemMeta.parentId == null || expandedItemsMap.has(itemMeta.parentId));
    });
    if (firstSelectedItem != null) return firstSelectedItem;
    const firstNavigableItem = orderedRootItemIds.find((itemId)=>disabledItemsFocusable || !(0, $2abc8533f192485b$exports.isItemDisabled)(itemMetaLookup, itemId));
    if (firstNavigableItem != null) return firstNavigableItem;
    return null;
});
/**
 * Check if an item is the default focusable item.
 * @param {TreeViewState<[UseTreeViewFocusSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to check.
 * @returns {boolean} `true` if the item is the default focusable item, `false` otherwise.
 */ const $adfd4ba063607d91$var$selectorIsItemTheDefaultFocusableItem = $adfd4ba063607d91$exports.selectorIsItemTheDefaultFocusableItem = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $adfd4ba063607d91$var$selectorDefaultFocusableItemId,
    (_, itemId)=>itemId
], (defaultFocusableItemId, itemId)=>defaultFocusableItemId === itemId);
/**
 * Get the id of the item that is currently focused.
 * @param {TreeViewState<[UseTreeViewFocusSignature]>} state The state of the tree view.
 * @returns {TreeViewItemId | null} The id of the item that is currently focused.
 */ const $adfd4ba063607d91$var$selectorFocusedItemId = $adfd4ba063607d91$exports.selectorFocusedItemId = (0, $2914ab2a8d092ccd$exports.createSelector)($adfd4ba063607d91$var$selectorTreeViewFocusState, (focus)=>focus.focusedItemId);
/**
 * Check if an item is focused.
 * @param {TreeViewState<[UseTreeViewFocusSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to check.
 * @returns {boolean} `true` if the item is focused, `false` otherwise.
 */ const $adfd4ba063607d91$var$selectorIsItemFocused = $adfd4ba063607d91$exports.selectorIsItemFocused = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $adfd4ba063607d91$var$selectorFocusedItemId,
    (_, itemId)=>itemId
], (focusedItemId, itemId)=>focusedItemId === itemId);




var $5e0d3f346dd83f6e$exports = {};
"use strict";
Object.defineProperty($5e0d3f346dd83f6e$exports, "__esModule", {
    value: true
});
$5e0d3f346dd83f6e$exports.selectorIsLazyLoadingEnabled = $5e0d3f346dd83f6e$exports.selectorIsItemLoading = $5e0d3f346dd83f6e$exports.selectorGetTreeItemError = $5e0d3f346dd83f6e$exports.selectorDataSourceState = void 0;

const $5e0d3f346dd83f6e$var$selectorLazyLoading = (state)=>state.lazyLoading;
const $5e0d3f346dd83f6e$var$selectorLazyLoadingOptional = (state)=>state.lazyLoading;
const $5e0d3f346dd83f6e$var$selectorDataSourceState = $5e0d3f346dd83f6e$exports.selectorDataSourceState = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $5e0d3f346dd83f6e$var$selectorLazyLoading
], (lazyLoading)=>lazyLoading.dataSource);
/**
 * Check if lazy loading is enabled.
 * @param {TreeViewState<[UseTreeViewLazyLoadingSignature]>} state The state of the tree view.
 * @returns {boolean} True if lazy loading is enabled, false if it isn't.
 */ const $5e0d3f346dd83f6e$var$selectorIsLazyLoadingEnabled = $5e0d3f346dd83f6e$exports.selectorIsLazyLoadingEnabled = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $5e0d3f346dd83f6e$var$selectorLazyLoadingOptional
], (lazyLoading)=>!!lazyLoading?.enabled);
/**
 * Get the loading state for a tree item.
 * @param {TreeViewState<[UseTreeViewLazyLoadingSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the loading state of.
 * @returns {boolean} The loading state for the Tree Item.
 */ const $5e0d3f346dd83f6e$var$selectorIsItemLoading = $5e0d3f346dd83f6e$exports.selectorIsItemLoading = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $5e0d3f346dd83f6e$var$selectorDataSourceState,
    (_, itemId)=>itemId
], (dataSourceState, itemId)=>dataSourceState.loading[itemId] || false);
/**
 * Get the error for a tree item.
 * @param {TreeViewState<[UseTreeViewLazyLoadingSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the error for.
 * @returns {boolean} The error for the Tree Item.
 */ const $5e0d3f346dd83f6e$var$selectorGetTreeItemError = $5e0d3f346dd83f6e$exports.selectorGetTreeItemError = (0, $2914ab2a8d092ccd$exports.createSelector)([
    $5e0d3f346dd83f6e$var$selectorDataSourceState,
    (_, itemId)=>itemId
], (dataSourceState, itemId)=>dataSourceState.errors[itemId] || null);



/**
 * Plugins that need to be present in the Tree View in order for `useTreeItemUtils` to work correctly.
 */ /**
 * Plugins that `useTreeItemUtils` can use if they are present, but are not required.
 */ const $d9f78308a67a5da5$var$itemHasChildren = (reactChildren)=>{
    if (Array.isArray(reactChildren)) return reactChildren.length > 0 && reactChildren.some($d9f78308a67a5da5$var$itemHasChildren);
    return Boolean(reactChildren);
};
$d9f78308a67a5da5$exports.itemHasChildren = $d9f78308a67a5da5$var$itemHasChildren;
const $d9f78308a67a5da5$var$useTreeItemUtils = ({ itemId: itemId, children: children })=>{
    const { instance: instance, store: store, publicAPI: publicAPI } = (0, $33114ec9c2f70325$exports.useTreeViewContext)();
    const isItemExpandable = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $78cc7d98a5cf23b4$exports.selectorIsItemExpandable, itemId);
    const isLazyLoadingEnabled = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $5e0d3f346dd83f6e$exports.selectorIsLazyLoadingEnabled);
    const isMultiSelectEnabled = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $88945f81c6be66ca$exports.selectorIsMultiSelectEnabled);
    const loading = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, (state)=>isLazyLoadingEnabled ? (0, $5e0d3f346dd83f6e$exports.selectorIsItemLoading)(state, itemId) : false);
    const error = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, (state)=>isLazyLoadingEnabled ? Boolean((0, $5e0d3f346dd83f6e$exports.selectorGetTreeItemError)(state, itemId)) : false);
    const isExpandable = $d9f78308a67a5da5$var$itemHasChildren(children) || isItemExpandable;
    const isExpanded = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded, itemId);
    const isFocused = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $adfd4ba063607d91$exports.selectorIsItemFocused, itemId);
    const isSelected = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $88945f81c6be66ca$exports.selectorIsItemSelected, itemId);
    const isDisabled = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $4bf621410ffd294f$exports.selectorIsItemDisabled, itemId);
    const isEditing = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $d01956c8abb69943$exports.selectorIsItemBeingEdited, itemId);
    const isEditable = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $d01956c8abb69943$exports.selectorIsItemEditable, itemId);
    const status = {
        expandable: isExpandable,
        expanded: isExpanded,
        focused: isFocused,
        selected: isSelected,
        disabled: isDisabled,
        editing: isEditing,
        editable: isEditable,
        loading: loading,
        error: error
    };
    const handleExpansion = (event)=>{
        if (status.disabled) return;
        if (!status.focused) instance.focusItem(event, itemId);
        const multiple = isMultiSelectEnabled && (event.shiftKey || event.ctrlKey || event.metaKey);
        // If already expanded and trying to toggle selection don't close
        if (status.expandable && !(multiple && (0, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded)(store.value, itemId))) // make sure the children selection is propagated again
        instance.setItemExpansion({
            event: event,
            itemId: itemId
        });
    };
    const handleSelection = (event)=>{
        if (status.disabled) return;
        if (!status.focused && !status.editing) instance.focusItem(event, itemId);
        const multiple = isMultiSelectEnabled && (event.shiftKey || event.ctrlKey || event.metaKey);
        if (multiple) {
            if (event.shiftKey) instance.expandSelectionRange(event, itemId);
            else instance.setItemSelection({
                event: event,
                itemId: itemId,
                keepExistingSelection: true
            });
        } else instance.setItemSelection({
            event: event,
            itemId: itemId,
            shouldBeSelected: true
        });
    };
    const handleCheckboxSelection = (event)=>{
        const hasShift = event.nativeEvent.shiftKey;
        if (isMultiSelectEnabled && hasShift) instance.expandSelectionRange(event, itemId);
        else instance.setItemSelection({
            event: event,
            itemId: itemId,
            keepExistingSelection: isMultiSelectEnabled,
            shouldBeSelected: event.target.checked
        });
    };
    const toggleItemEditing = ()=>{
        if (!(0, $d8bebe0ab57a7f3c$exports.hasPlugin)(instance, $8407f8bcbbd0da1e$exports.useTreeViewLabel)) return;
        if (isEditable) {
            if (isEditing) instance.setEditedItemId(null);
            else instance.setEditedItemId(itemId);
        }
    };
    const handleSaveItemLabel = (event, newLabel)=>{
        if (!(0, $d8bebe0ab57a7f3c$exports.hasPlugin)(instance, $8407f8bcbbd0da1e$exports.useTreeViewLabel)) return;
        // As a side effect of `instance.focusItem` called here and in `handleCancelItemLabelEditing` the `labelInput` is blurred
        // The `onBlur` event is triggered, which calls `handleSaveItemLabel` again.
        // To avoid creating an unwanted behavior we need to check if the item is being edited before calling `updateItemLabel`
        if ((0, $d01956c8abb69943$exports.selectorIsItemBeingEdited)(store.value, itemId)) {
            instance.updateItemLabel(itemId, newLabel);
            toggleItemEditing();
            instance.focusItem(event, itemId);
        }
    };
    const handleCancelItemLabelEditing = (event)=>{
        if (!(0, $d8bebe0ab57a7f3c$exports.hasPlugin)(instance, $8407f8bcbbd0da1e$exports.useTreeViewLabel)) return;
        if ((0, $d01956c8abb69943$exports.selectorIsItemBeingEdited)(store.value, itemId)) {
            toggleItemEditing();
            instance.focusItem(event, itemId);
        }
    };
    const interactions = {
        handleExpansion: handleExpansion,
        handleSelection: handleSelection,
        handleCheckboxSelection: handleCheckboxSelection,
        toggleItemEditing: toggleItemEditing,
        handleSaveItemLabel: handleSaveItemLabel,
        handleCancelItemLabelEditing: handleCancelItemLabelEditing
    };
    return {
        interactions: interactions,
        status: status,
        publicAPI: publicAPI
    };
};
$d9f78308a67a5da5$exports.useTreeItemUtils = $d9f78308a67a5da5$var$useTreeItemUtils;




var $9404cf4078b79adc$exports = {};
"use strict";
Object.defineProperty($9404cf4078b79adc$exports, "__esModule", {
    value: true
});
Object.defineProperty($9404cf4078b79adc$exports, "TreeViewItemDepthContext", {
    enumerable: true,
    get: function() {
        return $8fc9a691b82ab040$exports.TreeViewItemDepthContext;
    }
});
var $8fc9a691b82ab040$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $8fc9a691b82ab040$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($8fc9a691b82ab040$exports, "__esModule", {
    value: true
});
$8fc9a691b82ab040$exports.TreeViewItemDepthContext = void 0;

var $8fc9a691b82ab040$var$React = $8fc9a691b82ab040$require$_interopRequireWildcard((parcelRequire("8nGP5")));
const $8fc9a691b82ab040$var$TreeViewItemDepthContext = $8fc9a691b82ab040$exports.TreeViewItemDepthContext = /*#__PURE__*/ $8fc9a691b82ab040$var$React.createContext(()=>-1);




var $a47de7ff1c218ad9$exports = {};
"use strict";
Object.defineProperty($a47de7ff1c218ad9$exports, "__esModule", {
    value: true
});
$a47de7ff1c218ad9$exports.isTargetInDescendants = $a47de7ff1c218ad9$exports.getPreviousNavigableItem = $a47de7ff1c218ad9$exports.getNonDisabledItemsInRange = $a47de7ff1c218ad9$exports.getNextNavigableItem = $a47de7ff1c218ad9$exports.getLastNavigableItem = $a47de7ff1c218ad9$exports.getFirstNavigableItem = $a47de7ff1c218ad9$exports.getAllNavigableItems = $a47de7ff1c218ad9$exports.findOrderInTremauxTree = void 0;


const $a47de7ff1c218ad9$var$getLastNavigableItemInArray = (state, items)=>{
    // Equivalent to Array.prototype.findLastIndex
    let itemIndex = items.length - 1;
    while(itemIndex >= 0 && !(0, $4bf621410ffd294f$exports.selectorCanItemBeFocused)(state, items[itemIndex]))itemIndex -= 1;
    if (itemIndex === -1) return undefined;
    return items[itemIndex];
};
const $a47de7ff1c218ad9$var$getPreviousNavigableItem = (state, itemId)=>{
    const itemMeta = (0, $4bf621410ffd294f$exports.selectorItemMeta)(state, itemId);
    if (!itemMeta) return null;
    const siblings = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, itemMeta.parentId);
    const itemIndex = (0, $4bf621410ffd294f$exports.selectorItemIndex)(state, itemId);
    // TODO: What should we do if the parent is not navigable?
    if (itemIndex === 0) return itemMeta.parentId;
    // Finds the previous navigable sibling.
    let previousNavigableSiblingIndex = itemIndex - 1;
    while(!(0, $4bf621410ffd294f$exports.selectorCanItemBeFocused)(state, siblings[previousNavigableSiblingIndex]) && previousNavigableSiblingIndex >= 0)previousNavigableSiblingIndex -= 1;
    if (previousNavigableSiblingIndex === -1) {
        // If we are at depth 0, then it means all the items above the current item are not navigable.
        if (itemMeta.parentId == null) return null;
        // Otherwise, we can try to go up a level and find the previous navigable item.
        return $a47de7ff1c218ad9$var$getPreviousNavigableItem(state, itemMeta.parentId);
    }
    // Finds the last navigable ancestor of the previous navigable sibling.
    let currentItemId = siblings[previousNavigableSiblingIndex];
    let lastNavigableChild = $a47de7ff1c218ad9$var$getLastNavigableItemInArray(state, (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, currentItemId));
    while((0, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded)(state, currentItemId) && lastNavigableChild != null){
        currentItemId = lastNavigableChild;
        lastNavigableChild = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, currentItemId).find((childId)=>(0, $4bf621410ffd294f$exports.selectorCanItemBeFocused)(state, childId));
    }
    return currentItemId;
};
$a47de7ff1c218ad9$exports.getPreviousNavigableItem = $a47de7ff1c218ad9$var$getPreviousNavigableItem;
const $a47de7ff1c218ad9$var$getNextNavigableItem = (state, itemId)=>{
    // If the item is expanded and has some navigable children, return the first of them.
    if ((0, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded)(state, itemId)) {
        const firstNavigableChild = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, itemId).find((childId)=>(0, $4bf621410ffd294f$exports.selectorCanItemBeFocused)(state, childId));
        if (firstNavigableChild != null) return firstNavigableChild;
    }
    let itemMeta = (0, $4bf621410ffd294f$exports.selectorItemMeta)(state, itemId);
    while(itemMeta != null){
        // Try to find the first navigable sibling after the current item.
        const siblings = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, itemMeta.parentId);
        const currentItemIndex = (0, $4bf621410ffd294f$exports.selectorItemIndex)(state, itemMeta.id);
        if (currentItemIndex < siblings.length - 1) {
            let nextItemIndex = currentItemIndex + 1;
            while(!(0, $4bf621410ffd294f$exports.selectorCanItemBeFocused)(state, siblings[nextItemIndex]) && nextItemIndex < siblings.length - 1)nextItemIndex += 1;
            if ((0, $4bf621410ffd294f$exports.selectorCanItemBeFocused)(state, siblings[nextItemIndex])) return siblings[nextItemIndex];
        }
        // If the sibling does not exist, go up a level to the parent and try again.
        itemMeta = (0, $4bf621410ffd294f$exports.selectorItemMeta)(state, itemMeta.parentId);
    }
    return null;
};
$a47de7ff1c218ad9$exports.getNextNavigableItem = $a47de7ff1c218ad9$var$getNextNavigableItem;
const $a47de7ff1c218ad9$var$getLastNavigableItem = (state)=>{
    let itemId = null;
    while(itemId == null || (0, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded)(state, itemId)){
        const children = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, itemId);
        const lastNavigableChild = $a47de7ff1c218ad9$var$getLastNavigableItemInArray(state, children);
        // The item has no navigable children.
        if (lastNavigableChild == null) return itemId;
        itemId = lastNavigableChild;
    }
    return itemId;
};
$a47de7ff1c218ad9$exports.getLastNavigableItem = $a47de7ff1c218ad9$var$getLastNavigableItem;
const $a47de7ff1c218ad9$var$getFirstNavigableItem = (state)=>(0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, null).find((itemId)=>(0, $4bf621410ffd294f$exports.selectorCanItemBeFocused)(state, itemId));
/**
 * This is used to determine the start and end of a selection range so
 * we can get the items between the two border items.
 *
 * It finds the items' common ancestor using
 * a naive implementation of a lowest common ancestor algorithm
 * (https://en.wikipedia.org/wiki/Lowest_common_ancestor).
 * Then compares the ancestor's 2 children that are ancestors of itemA and ItemB
 * so we can compare their indexes to work out which item comes first in a depth first search.
 * (https://en.wikipedia.org/wiki/Depth-first_search)
 *
 * Another way to put it is which item is shallower in a trémaux tree
 * https://en.wikipedia.org/wiki/Tr%C3%A9maux_tree
 */ $a47de7ff1c218ad9$exports.getFirstNavigableItem = $a47de7ff1c218ad9$var$getFirstNavigableItem;
const $a47de7ff1c218ad9$var$findOrderInTremauxTree = (state, itemAId, itemBId)=>{
    if (itemAId === itemBId) return [
        itemAId,
        itemBId
    ];
    const itemMetaA = (0, $4bf621410ffd294f$exports.selectorItemMeta)(state, itemAId);
    const itemMetaB = (0, $4bf621410ffd294f$exports.selectorItemMeta)(state, itemBId);
    if (!itemMetaA || !itemMetaB) return [
        itemAId,
        itemBId
    ];
    if (itemMetaA.parentId === itemMetaB.id || itemMetaB.parentId === itemMetaA.id) return itemMetaB.parentId === itemMetaA.id ? [
        itemMetaA.id,
        itemMetaB.id
    ] : [
        itemMetaB.id,
        itemMetaA.id
    ];
    const aFamily = [
        itemMetaA.id
    ];
    const bFamily = [
        itemMetaB.id
    ];
    let aAncestor = itemMetaA.parentId;
    let bAncestor = itemMetaB.parentId;
    let aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
    let bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
    let continueA = true;
    let continueB = true;
    while(!bAncestorIsCommon && !aAncestorIsCommon){
        if (continueA) {
            aFamily.push(aAncestor);
            aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
            continueA = aAncestor !== null;
            if (!aAncestorIsCommon && continueA) aAncestor = (0, $4bf621410ffd294f$exports.selectorItemParentId)(state, aAncestor);
        }
        if (continueB && !aAncestorIsCommon) {
            bFamily.push(bAncestor);
            bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
            continueB = bAncestor !== null;
            if (!bAncestorIsCommon && continueB) bAncestor = (0, $4bf621410ffd294f$exports.selectorItemParentId)(state, bAncestor);
        }
    }
    const commonAncestor = aAncestorIsCommon ? aAncestor : bAncestor;
    const ancestorFamily = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, commonAncestor);
    const aSide = aFamily[aFamily.indexOf(commonAncestor) - 1];
    const bSide = bFamily[bFamily.indexOf(commonAncestor) - 1];
    return ancestorFamily.indexOf(aSide) < ancestorFamily.indexOf(bSide) ? [
        itemAId,
        itemBId
    ] : [
        itemBId,
        itemAId
    ];
};
$a47de7ff1c218ad9$exports.findOrderInTremauxTree = $a47de7ff1c218ad9$var$findOrderInTremauxTree;
const $a47de7ff1c218ad9$var$getNonDisabledItemsInRange = (state, itemAId, itemBId)=>{
    const getNextItem = (itemId)=>{
        // If the item is expanded and has some children, return the first of them.
        if ((0, $78cc7d98a5cf23b4$exports.selectorIsItemExpandable)(state, itemId) && (0, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded)(state, itemId)) return (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, itemId)[0];
        let itemMeta = (0, $4bf621410ffd294f$exports.selectorItemMeta)(state, itemId);
        while(itemMeta != null){
            // Try to find the first navigable sibling after the current item.
            const siblings = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, itemMeta.parentId);
            const currentItemIndex = (0, $4bf621410ffd294f$exports.selectorItemIndex)(state, itemMeta.id);
            if (currentItemIndex < siblings.length - 1) return siblings[currentItemIndex + 1];
            // If the item is the last of its siblings, go up a level to the parent and try again.
            itemMeta = itemMeta.parentId ? (0, $4bf621410ffd294f$exports.selectorItemMeta)(state, itemMeta.parentId) : null;
        }
        throw new Error('Invalid range');
    };
    const [first, last] = $a47de7ff1c218ad9$var$findOrderInTremauxTree(state, itemAId, itemBId);
    const items = [
        first
    ];
    let current = first;
    while(current !== last){
        current = getNextItem(current);
        if (!(0, $4bf621410ffd294f$exports.selectorIsItemDisabled)(state, current)) items.push(current);
    }
    return items;
};
$a47de7ff1c218ad9$exports.getNonDisabledItemsInRange = $a47de7ff1c218ad9$var$getNonDisabledItemsInRange;
const $a47de7ff1c218ad9$var$getAllNavigableItems = (state)=>{
    let item = $a47de7ff1c218ad9$var$getFirstNavigableItem(state);
    const navigableItems = [];
    while(item != null){
        navigableItems.push(item);
        item = $a47de7ff1c218ad9$var$getNextNavigableItem(state, item);
    }
    return navigableItems;
};
/**
 * Checks if the target is in a descendant of this item.
 * This can prevent from firing some logic on the ancestors on the interacted item when the event handler is on the root.
 * @param {HTMLElement} target The target to check
 * @param {HTMLElement | null} itemRoot The root of the item to check if the event target is in its descendants
 * @returns {boolean} Whether the target is in a descendant of this item
 */ $a47de7ff1c218ad9$exports.getAllNavigableItems = $a47de7ff1c218ad9$var$getAllNavigableItems;
const $a47de7ff1c218ad9$var$isTargetInDescendants = (target, itemRoot)=>{
    return itemRoot !== target.closest('*[role="treeitem"]');
};
$a47de7ff1c218ad9$exports.isTargetInDescendants = $a47de7ff1c218ad9$var$isTargetInDescendants;




var $93de18c67dbb3a30$exports = {};
"use strict";
Object.defineProperty($93de18c67dbb3a30$exports, "__esModule", {
    value: true
});
$93de18c67dbb3a30$exports.generateTreeItemIdAttribute = $93de18c67dbb3a30$exports.createTreeViewDefaultId = void 0;
let $93de18c67dbb3a30$var$globalTreeViewDefaultId = 0;
const $93de18c67dbb3a30$var$createTreeViewDefaultId = ()=>{
    $93de18c67dbb3a30$var$globalTreeViewDefaultId += 1;
    return `mui-tree-view-${$93de18c67dbb3a30$var$globalTreeViewDefaultId}`;
};
/**
 * Generate the id attribute (i.e.: the `id` attribute passed to the DOM element) of a Tree Item.
 * If the user explicitly defined an id attribute, it will be returned.
 * Otherwise, the method creates a unique id for the item based on the Tree View id attribute and the item `itemId`
 * @param {object} params The parameters to determine the id attribute of the item.
 * @param {TreeViewItemId} params.itemId The id of the item to get the id attribute of.
 * @param {string | undefined} params.idAttribute The id attribute of the item if explicitly defined by the user.
 * @param {string} params.treeId The id attribute of the Tree View.
 * @returns {string} The id attribute of the item.
 */ $93de18c67dbb3a30$exports.createTreeViewDefaultId = $93de18c67dbb3a30$var$createTreeViewDefaultId;
const $93de18c67dbb3a30$var$generateTreeItemIdAttribute = ({ id: id, treeId: treeId = '', itemId: itemId })=>{
    if (id != null) return id;
    return `${treeId}-${itemId}`;
};
$93de18c67dbb3a30$exports.generateTreeItemIdAttribute = $93de18c67dbb3a30$var$generateTreeItemIdAttribute;



var $8891880caf94d5b0$exports = {};
"use strict";
Object.defineProperty($8891880caf94d5b0$exports, "__esModule", {
    value: true
});
$8891880caf94d5b0$exports.selectorTreeViewId = void 0;

const $8891880caf94d5b0$var$selectorTreeViewIdState = (state)=>state.id;
/**
 * Get the id attribute of the tree view.
 * @param {TreeViewState<[UseTreeViewIdSignature]>} state The state of the tree view.
 * @returns {string} The id attribute of the tree view.
 */ const $8891880caf94d5b0$var$selectorTreeViewId = $8891880caf94d5b0$exports.selectorTreeViewId = (0, $2914ab2a8d092ccd$exports.createSelector)($8891880caf94d5b0$var$selectorTreeViewIdState, (idState)=>idState.treeId);




const $5d386d06cd366eb3$var$useTreeItem = (parameters)=>{
    const { runItemPlugins: runItemPlugins, instance: instance, publicAPI: publicAPI, store: store } = (0, $33114ec9c2f70325$exports.useTreeViewContext)();
    const depthContext = $5d386d06cd366eb3$var$React.useContext($9404cf4078b79adc$exports.TreeViewItemDepthContext);
    const depth = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, (...params)=>{
        if (typeof depthContext === 'function') return depthContext(...params);
        return depthContext;
    }, parameters.itemId);
    const { id: id, itemId: itemId, label: label, children: children, rootRef: rootRef } = parameters;
    const { rootRef: pluginRootRef, contentRef: contentRef, propsEnhancers: propsEnhancers } = runItemPlugins(parameters);
    const { interactions: interactions, status: status } = (0, $34f61e46418c653f$exports.useTreeItemUtils)({
        itemId: itemId,
        children: children
    });
    const rootRefObject = $5d386d06cd366eb3$var$React.useRef(null);
    const contentRefObject = $5d386d06cd366eb3$var$React.useRef(null);
    const handleRootRef = (0, $5d386d06cd366eb3$var$_useForkRef.default)(rootRef, pluginRootRef, rootRefObject);
    const handleContentRef = (0, $5d386d06cd366eb3$var$_useForkRef.default)(contentRef, contentRefObject);
    const checkboxRef = $5d386d06cd366eb3$var$React.useRef(null);
    const treeId = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $8891880caf94d5b0$exports.selectorTreeViewId);
    const isSelectionEnabledForItem = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $88945f81c6be66ca$exports.selectorIsItemSelectionEnabled, itemId);
    const isCheckboxSelectionEnabled = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $88945f81c6be66ca$exports.selectorIsCheckboxSelectionEnabled);
    const idAttribute = (0, $93de18c67dbb3a30$exports.generateTreeItemIdAttribute)({
        itemId: itemId,
        treeId: treeId,
        id: id
    });
    const shouldBeAccessibleWithTab = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $adfd4ba063607d91$exports.selectorIsItemTheDefaultFocusableItem, itemId);
    const sharedPropsEnhancerParams = {
        rootRefObject: rootRefObject,
        contentRefObject: contentRefObject,
        interactions: interactions
    };
    const createRootHandleFocus = (otherHandlers)=>(event)=>{
            otherHandlers.onFocus?.(event);
            if (event.defaultMuiPrevented) return;
            if (!status.focused && (0, $4bf621410ffd294f$exports.selectorCanItemBeFocused)(store.value, itemId) && event.currentTarget === event.target) instance.focusItem(event, itemId);
        };
    const createRootHandleBlur = (otherHandlers)=>(event)=>{
            otherHandlers.onBlur?.(event);
            if (event.defaultMuiPrevented) return;
            const rootElement = instance.getItemDOMElement(itemId);
            // Don't blur the root when switching to editing mode
            // the input that triggers the root blur can be either the relatedTarget (when entering editing state) or the target (when exiting editing state)
            // when we enter the editing state, we focus the input -> we don't want to remove the focused item from the state
            if (status.editing || // we can exit the editing state by clicking outside the input (within the Tree Item) or by pressing Enter or Escape -> we don't want to remove the focused item from the state in these cases
            // we can also exit the editing state by clicking on the root itself -> want to remove the focused item from the state in this case
            event.relatedTarget && (0, $a47de7ff1c218ad9$exports.isTargetInDescendants)(event.relatedTarget, rootElement) && (event.target && event.target?.dataset?.element === 'labelInput' && (0, $a47de7ff1c218ad9$exports.isTargetInDescendants)(event.target, rootElement) || event.relatedTarget?.dataset?.element === 'labelInput')) return;
            instance.removeFocusedItem();
        };
    const createRootHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            if (event.defaultMuiPrevented || event.target?.dataset?.element === 'labelInput') return;
            instance.handleItemKeyDown(event, itemId);
        };
    const createLabelHandleDoubleClick = (otherHandlers)=>(event)=>{
            otherHandlers.onDoubleClick?.(event);
            if (event.defaultMuiPrevented) return;
            interactions.toggleItemEditing();
        };
    const createContentHandleClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            instance.handleItemClick(event, itemId);
            if (event.defaultMuiPrevented || checkboxRef.current?.contains(event.target)) return;
            if ((0, $78cc7d98a5cf23b4$exports.selectorItemExpansionTrigger)(store.value) === 'content') interactions.handleExpansion(event);
            if (!isCheckboxSelectionEnabled) interactions.handleSelection(event);
        };
    const createContentHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (event.defaultMuiPrevented) return;
            // Prevent text selection
            if (event.shiftKey || event.ctrlKey || event.metaKey || status.disabled) event.preventDefault();
        };
    const createIconContainerHandleClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.defaultMuiPrevented) return;
            if ((0, $78cc7d98a5cf23b4$exports.selectorItemExpansionTrigger)(store.value) === 'iconContainer') interactions.handleExpansion(event);
        };
    const getContextProviderProps = ()=>({
            itemId: itemId,
            id: id
        });
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $5d386d06cd366eb3$var$_extends2.default)({}, (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(parameters), (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(externalProps));
        // https://www.w3.org/WAI/ARIA/apg/patterns/treeview/
        let ariaSelected;
        if (status.selected) // - each selected node has aria-selected set to true.
        ariaSelected = true;
        else if (!isSelectionEnabledForItem) // - if the tree contains nodes that are not selectable, aria-selected is not present on those nodes.
        ariaSelected = undefined;
        else // - all nodes that are selectable but not selected have aria-selected set to false.
        ariaSelected = false;
        const props = (0, $5d386d06cd366eb3$var$_extends2.default)({}, externalEventHandlers, {
            ref: handleRootRef,
            role: 'treeitem',
            tabIndex: shouldBeAccessibleWithTab ? 0 : -1,
            id: idAttribute,
            'aria-expanded': status.expandable ? status.expanded : undefined,
            'aria-selected': ariaSelected,
            'aria-disabled': status.disabled || undefined
        }, externalProps, {
            style: (0, $5d386d06cd366eb3$var$_extends2.default)({}, externalProps.style ?? {}, {
                '--TreeView-itemDepth': depth
            }),
            onFocus: createRootHandleFocus(externalEventHandlers),
            onBlur: createRootHandleBlur(externalEventHandlers),
            onKeyDown: createRootHandleKeyDown(externalEventHandlers)
        });
        const enhancedRootProps = propsEnhancers.root?.((0, $5d386d06cd366eb3$var$_extends2.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $5d386d06cd366eb3$var$_extends2.default)({}, props, enhancedRootProps);
    };
    const getContentProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(externalProps);
        const props = (0, $5d386d06cd366eb3$var$_extends2.default)({}, externalEventHandlers, externalProps, {
            ref: handleContentRef,
            onClick: createContentHandleClick(externalEventHandlers),
            onMouseDown: createContentHandleMouseDown(externalEventHandlers),
            status: status
        });
        [
            'expanded',
            'selected',
            'focused',
            'disabled',
            'editing',
            'editable'
        ].forEach((key)=>{
            if (status[key]) props[`data-${key}`] = '';
        });
        const enhancedContentProps = propsEnhancers.content?.((0, $5d386d06cd366eb3$var$_extends2.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $5d386d06cd366eb3$var$_extends2.default)({}, props, enhancedContentProps);
    };
    const getCheckboxProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(externalProps);
        const props = (0, $5d386d06cd366eb3$var$_extends2.default)({}, externalEventHandlers, {
            ref: checkboxRef
        }, externalProps);
        const enhancedCheckboxProps = propsEnhancers.checkbox?.((0, $5d386d06cd366eb3$var$_extends2.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $5d386d06cd366eb3$var$_extends2.default)({}, props, enhancedCheckboxProps);
    };
    const getLabelProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $5d386d06cd366eb3$var$_extends2.default)({}, (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(externalProps));
        const props = (0, $5d386d06cd366eb3$var$_extends2.default)({}, externalEventHandlers, {
            children: label
        }, externalProps, {
            onDoubleClick: createLabelHandleDoubleClick(externalEventHandlers)
        });
        const enhancedLabelProps = propsEnhancers.label?.((0, $5d386d06cd366eb3$var$_extends2.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $5d386d06cd366eb3$var$_extends2.default)({}, enhancedLabelProps, props);
    };
    const getLabelInputProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(externalProps);
        const enhancedLabelInputProps = propsEnhancers.labelInput?.((0, $5d386d06cd366eb3$var$_extends2.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $5d386d06cd366eb3$var$_extends2.default)({}, externalProps, enhancedLabelInputProps);
    };
    const getIconContainerProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(externalProps);
        return (0, $5d386d06cd366eb3$var$_extends2.default)({}, externalEventHandlers, externalProps, {
            onClick: createIconContainerHandleClick(externalEventHandlers)
        });
    };
    const getErrorContainerProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(externalProps);
        return (0, $5d386d06cd366eb3$var$_extends2.default)({}, externalEventHandlers, externalProps);
    };
    const getLoadingContainerProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(externalProps);
        return (0, $5d386d06cd366eb3$var$_extends2.default)({
            size: '12px',
            thickness: 6
        }, externalEventHandlers, externalProps);
    };
    const getGroupTransitionProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(externalProps);
        const response = (0, $5d386d06cd366eb3$var$_extends2.default)({}, externalEventHandlers, {
            unmountOnExit: true,
            component: 'ul',
            role: 'group',
            in: status.expanded,
            children: children
        }, externalProps);
        return response;
    };
    const getDragAndDropOverlayProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $5d386d06cd366eb3$var$_extractEventHandlers.default)(externalProps);
        const enhancedDragAndDropOverlayProps = propsEnhancers.dragAndDropOverlay?.((0, $5d386d06cd366eb3$var$_extends2.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $5d386d06cd366eb3$var$_extends2.default)({}, externalProps, enhancedDragAndDropOverlayProps);
    };
    return {
        getContextProviderProps: getContextProviderProps,
        getRootProps: getRootProps,
        getContentProps: getContentProps,
        getGroupTransitionProps: getGroupTransitionProps,
        getIconContainerProps: getIconContainerProps,
        getCheckboxProps: getCheckboxProps,
        getLabelProps: getLabelProps,
        getLabelInputProps: getLabelInputProps,
        getDragAndDropOverlayProps: getDragAndDropOverlayProps,
        getErrorContainerProps: getErrorContainerProps,
        getLoadingContainerProps: getLoadingContainerProps,
        rootRef: handleRootRef,
        status: status,
        publicAPI: publicAPI
    };
};
$5d386d06cd366eb3$exports.useTreeItem = $5d386d06cd366eb3$var$useTreeItem;




var $5ea0623dc4236a37$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $5ea0623dc4236a37$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($5ea0623dc4236a37$exports, "__esModule", {
    value: true
});
$5ea0623dc4236a37$exports.getTreeItemUtilityClass = $5ea0623dc4236a37$var$getTreeItemUtilityClass;
$5ea0623dc4236a37$exports.treeItemClasses = void 0;

var $5ea0623dc4236a37$var$_generateUtilityClass = $5ea0623dc4236a37$require$_interopRequireDefault((parcelRequire("4E9MM")));

var $5ea0623dc4236a37$var$_generateUtilityClasses = $5ea0623dc4236a37$require$_interopRequireDefault((parcelRequire("4bI4C")));
function $5ea0623dc4236a37$var$getTreeItemUtilityClass(slot) {
    return (0, $5ea0623dc4236a37$var$_generateUtilityClass.default)('MuiTreeItem', slot);
}
const $5ea0623dc4236a37$var$treeItemClasses = $5ea0623dc4236a37$exports.treeItemClasses = (0, $5ea0623dc4236a37$var$_generateUtilityClasses.default)('MuiTreeItem', [
    'root',
    'content',
    'groupTransition',
    'iconContainer',
    'label',
    'checkbox',
    'labelInput',
    'dragAndDropOverlay',
    'errorIcon',
    'loadingIcon',
    // State classes, will be replaced by data-attrs in the next major
    'expanded',
    'selected',
    'focused',
    'disabled',
    'editable',
    'editing'
]);


var $fc167e51bb2c93e8$exports = {};
"use strict";
Object.defineProperty($fc167e51bb2c93e8$exports, "__esModule", {
    value: true
});
Object.defineProperty($fc167e51bb2c93e8$exports, "TreeItemIcon", {
    enumerable: true,
    get: function() {
        return $55b7f5d3d39613b9$exports.TreeItemIcon;
    }
});
var $55b7f5d3d39613b9$exports = {};
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $55b7f5d3d39613b9$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $55b7f5d3d39613b9$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($55b7f5d3d39613b9$exports, "__esModule", {
    value: true
});
$55b7f5d3d39613b9$exports.TreeItemIcon = $55b7f5d3d39613b9$var$TreeItemIcon;

var $55b7f5d3d39613b9$var$_extends2 = $55b7f5d3d39613b9$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $55b7f5d3d39613b9$var$React = $55b7f5d3d39613b9$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $55b7f5d3d39613b9$var$_propTypes = $55b7f5d3d39613b9$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $55b7f5d3d39613b9$var$_resolveComponentProps = $55b7f5d3d39613b9$require$_interopRequireDefault((parcelRequire("iselN")));

var $55b7f5d3d39613b9$var$_useSlotProps = $55b7f5d3d39613b9$require$_interopRequireDefault((parcelRequire("k3QMn")));

var $217522ce5962aae8$exports = {};
"use strict";
Object.defineProperty($217522ce5962aae8$exports, "__esModule", {
    value: true
});
var $1110b0c686684fc0$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $1110b0c686684fc0$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($1110b0c686684fc0$exports, "__esModule", {
    value: true
});
$1110b0c686684fc0$exports.TreeViewExpandIcon = $1110b0c686684fc0$exports.TreeViewCollapseIcon = void 0;

var $3v6Pw = parcelRequire("3v6Pw");

var $1110b0c686684fc0$var$React = $1110b0c686684fc0$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $kSbwP = parcelRequire("kSbwP");
const $1110b0c686684fc0$var$TreeViewExpandIcon = $1110b0c686684fc0$exports.TreeViewExpandIcon = (0, $3v6Pw.createSvgIcon)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'TreeViewExpandIcon');
const $1110b0c686684fc0$var$TreeViewCollapseIcon = $1110b0c686684fc0$exports.TreeViewCollapseIcon = (0, $3v6Pw.createSvgIcon)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'TreeViewCollapseIcon');


Object.keys($1110b0c686684fc0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $217522ce5962aae8$exports && $217522ce5962aae8$exports[key] === $1110b0c686684fc0$exports[key]) return;
    Object.defineProperty($217522ce5962aae8$exports, key, {
        enumerable: true,
        get: function() {
            return $1110b0c686684fc0$exports[key];
        }
    });
});



var $kSbwP = parcelRequire("kSbwP");
function $55b7f5d3d39613b9$var$TreeItemIcon(props) {
    const { slots: slotsFromTreeItem, slotProps: slotPropsFromTreeItem, status: status } = props;
    const { slots: slotsFromTreeView, slotProps: slotPropsFromTreeView } = (0, $d712ba72daa2f7ea$exports.useTreeViewStyleContext)();
    const slots = {
        collapseIcon: slotsFromTreeItem?.collapseIcon ?? slotsFromTreeView.collapseIcon ?? $217522ce5962aae8$exports.TreeViewCollapseIcon,
        expandIcon: slotsFromTreeItem?.expandIcon ?? slotsFromTreeView.expandIcon ?? $217522ce5962aae8$exports.TreeViewExpandIcon,
        endIcon: slotsFromTreeItem?.endIcon ?? slotsFromTreeView.endIcon,
        icon: slotsFromTreeItem?.icon
    };
    let iconName;
    if (slots?.icon) iconName = 'icon';
    else if (status.expandable) {
        if (status.expanded) iconName = 'collapseIcon';
        else iconName = 'expandIcon';
    } else iconName = 'endIcon';
    const Icon = slots[iconName];
    const iconProps = (0, $55b7f5d3d39613b9$var$_useSlotProps.default)({
        elementType: Icon,
        externalSlotProps: (tempOwnerState)=>(0, $55b7f5d3d39613b9$var$_extends2.default)({}, (0, $55b7f5d3d39613b9$var$_resolveComponentProps.default)(slotPropsFromTreeView[iconName], tempOwnerState), (0, $55b7f5d3d39613b9$var$_resolveComponentProps.default)(slotPropsFromTreeItem?.[iconName], tempOwnerState)),
        // TODO: Add proper ownerState
        ownerState: {}
    });
    if (!Icon) return null;
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Icon, (0, $55b7f5d3d39613b9$var$_extends2.default)({}, iconProps));
}




var $f9264c19e436ee7b$exports = {};
"use strict";
Object.defineProperty($f9264c19e436ee7b$exports, "__esModule", {
    value: true
});
Object.defineProperty($f9264c19e436ee7b$exports, "TreeItemDragAndDropOverlay", {
    enumerable: true,
    get: function() {
        return $cb8ed4cf21a3cd37$exports.TreeItemDragAndDropOverlay;
    }
});
var $cb8ed4cf21a3cd37$exports = {};
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $cb8ed4cf21a3cd37$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $cb8ed4cf21a3cd37$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($cb8ed4cf21a3cd37$exports, "__esModule", {
    value: true
});
$cb8ed4cf21a3cd37$exports.TreeItemDragAndDropOverlay = $cb8ed4cf21a3cd37$var$TreeItemDragAndDropOverlay;

var $cb8ed4cf21a3cd37$var$_extends2 = $cb8ed4cf21a3cd37$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $cb8ed4cf21a3cd37$var$React = $cb8ed4cf21a3cd37$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $cb8ed4cf21a3cd37$var$_propTypes = $cb8ed4cf21a3cd37$require$_interopRequireDefault((parcelRequire("ebCsu")));


var $8GVXe = parcelRequire("8GVXe");


var $kSbwP = parcelRequire("kSbwP");
const $cb8ed4cf21a3cd37$var$TreeItemDragAndDropOverlayRoot = (0, $78255dd8255477c5$exports.styled)('div', {
    name: 'MuiTreeItemDragAndDropOverlay',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8GVXe.shouldForwardProp)(prop) && prop !== 'action'
})(({ theme: theme })=>({
        position: 'absolute',
        left: 0,
        display: 'flex',
        top: 0,
        bottom: 0,
        right: 0,
        pointerEvents: 'none',
        variants: [
            {
                props: {
                    action: 'make-child'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
                    borderRadius: theme.shape.borderRadius,
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.darkChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $eb77af00bcd819bc$exports.alpha)(theme.palette.primary.dark, theme.palette.action.focusOpacity)
                }
            },
            {
                props: {
                    action: 'reorder-above'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
                    borderTop: `1px solid ${(theme.vars || theme).palette.action.active}`
                }
            },
            {
                props: {
                    action: 'reorder-below'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
                    borderBottom: `1px solid ${(theme.vars || theme).palette.action.active}`
                }
            },
            {
                props: {
                    action: 'move-to-parent'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * calc(var(--TreeView-itemDepth) - 1))',
                    borderBottom: `1px solid ${(theme.vars || theme).palette.action.active}`
                }
            }
        ]
    }));
function $cb8ed4cf21a3cd37$var$TreeItemDragAndDropOverlay(props) {
    if (props.action == null) return null;
    return /*#__PURE__*/ (0, $kSbwP.jsx)($cb8ed4cf21a3cd37$var$TreeItemDragAndDropOverlayRoot, (0, $cb8ed4cf21a3cd37$var$_extends2.default)({}, props));
}




var $4798f2bc20877e0e$exports = {};
"use strict";
Object.defineProperty($4798f2bc20877e0e$exports, "__esModule", {
    value: true
});
Object.defineProperty($4798f2bc20877e0e$exports, "TreeItemProvider", {
    enumerable: true,
    get: function() {
        return $a2658d78d5d6bb66$exports.TreeItemProvider;
    }
});
var $a2658d78d5d6bb66$exports = {};
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $a2658d78d5d6bb66$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $a2658d78d5d6bb66$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($a2658d78d5d6bb66$exports, "__esModule", {
    value: true
});
$a2658d78d5d6bb66$exports.TreeItemProvider = $a2658d78d5d6bb66$var$TreeItemProvider;

var $a2658d78d5d6bb66$var$React = $a2658d78d5d6bb66$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $a2658d78d5d6bb66$var$_propTypes = $a2658d78d5d6bb66$require$_interopRequireDefault((parcelRequire("ebCsu")));





var $kSbwP = parcelRequire("kSbwP");
function $a2658d78d5d6bb66$var$TreeItemProvider(props) {
    const { children: children, itemId: itemId, id: id } = props;
    const { wrapItem: wrapItem, instance: instance, store: store } = (0, $33114ec9c2f70325$exports.useTreeViewContext)();
    const treeId = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $8891880caf94d5b0$exports.selectorTreeViewId);
    const idAttribute = (0, $93de18c67dbb3a30$exports.generateTreeItemIdAttribute)({
        itemId: itemId,
        treeId: treeId,
        id: id
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)($a2658d78d5d6bb66$var$React.Fragment, {
        children: wrapItem({
            children: children,
            itemId: itemId,
            instance: instance,
            idAttribute: idAttribute
        })
    });
}




var $fedcfac1446f1a54$exports = {};
"use strict";
Object.defineProperty($fedcfac1446f1a54$exports, "__esModule", {
    value: true
});
Object.defineProperty($fedcfac1446f1a54$exports, "TreeItemLabelInput", {
    enumerable: true,
    get: function() {
        return $b1d3cdf5819a82c1$exports.TreeItemLabelInput;
    }
});
var $b1d3cdf5819a82c1$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b1d3cdf5819a82c1$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($b1d3cdf5819a82c1$exports, "__esModule", {
    value: true
});
$b1d3cdf5819a82c1$exports.TreeItemLabelInput = void 0;

var $b1d3cdf5819a82c1$var$_extends2 = $b1d3cdf5819a82c1$require$_interopRequireDefault((parcelRequire("8tsi7")));

/**
 * @ignore - internal component.
 */ const $b1d3cdf5819a82c1$var$TreeItemLabelInput = $b1d3cdf5819a82c1$exports.TreeItemLabelInput = (0, $78255dd8255477c5$exports.styled)('input', {
    name: 'MuiTreeItem',
    slot: 'LabelInput',
    overridesResolver: (props, styles)=>styles.labelInput
})(({ theme: theme })=>(0, $b1d3cdf5819a82c1$var$_extends2.default)({}, theme.typography.body1, {
        width: '100%',
        backgroundColor: (theme.vars || theme).palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        border: 'none',
        padding: '0 2px',
        boxSizing: 'border-box',
        '&:focus': {
            outline: `1px solid ${(theme.vars || theme).palette.primary.main}`
        }
    }));






var $kSbwP = parcelRequire("kSbwP");
const $17712d5d99762f43$var$_excluded = [
    "visible"
], $17712d5d99762f43$var$_excluded2 = [
    "id",
    "itemId",
    "label",
    "disabled",
    "children",
    "slots",
    "slotProps",
    "classes"
];
const $17712d5d99762f43$var$useThemeProps = (0, $78255dd8255477c5$exports.createUseThemeProps)('MuiTreeItem');
const $17712d5d99762f43$var$TreeItemRoot = $17712d5d99762f43$exports.TreeItemRoot = (0, $78255dd8255477c5$exports.styled)('li', {
    name: 'MuiTreeItem',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    outline: 0
});
const $17712d5d99762f43$var$TreeItemContent = $17712d5d99762f43$exports.TreeItemContent = (0, $78255dd8255477c5$exports.styled)('div', {
    name: 'MuiTreeItem',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content,
    shouldForwardProp: (prop)=>(0, $8GVXe.shouldForwardProp)(prop) && prop !== 'status'
})(({ theme: theme })=>({
        padding: theme.spacing(0.5, 1),
        paddingLeft: `calc(${theme.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`,
        borderRadius: theme.shape.borderRadius,
        width: '100%',
        boxSizing: 'border-box',
        // prevent width + padding to overflow
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        '&[data-disabled]': {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            backgroundColor: 'transparent'
        },
        '&[data-focused]': {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        '&[data-selected]': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $eb77af00bcd819bc$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $eb77af00bcd819bc$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $eb77af00bcd819bc$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                }
            }
        },
        '&[data-selected][data-focused]': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $eb77af00bcd819bc$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }));
const $17712d5d99762f43$var$TreeItemLabel = $17712d5d99762f43$exports.TreeItemLabel = (0, $78255dd8255477c5$exports.styled)('div', {
    name: 'MuiTreeItem',
    slot: 'Label',
    overridesResolver: (props, styles)=>styles.label,
    shouldForwardProp: (prop)=>(0, $8GVXe.shouldForwardProp)(prop) && prop !== 'editable'
})(({ theme: theme })=>(0, $17712d5d99762f43$var$_extends2.default)({
        width: '100%',
        boxSizing: 'border-box',
        // prevent width + padding to overflow
        // fixes overflow - see https://github.com/mui/material-ui/issues/27372
        minWidth: 0,
        position: 'relative',
        overflow: 'hidden'
    }, theme.typography.body1, {
        variants: [
            {
                props: ({ editable: editable })=>editable,
                style: {
                    paddingLeft: '2px'
                }
            }
        ]
    }));
const $17712d5d99762f43$var$TreeItemIconContainer = $17712d5d99762f43$exports.TreeItemIconContainer = (0, $78255dd8255477c5$exports.styled)('div', {
    name: 'MuiTreeItem',
    slot: 'IconContainer',
    overridesResolver: (props, styles)=>styles.iconContainer
})({
    width: 16,
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    position: 'relative',
    '& svg': {
        fontSize: 18
    }
});
const $17712d5d99762f43$var$TreeItemGroupTransition = $17712d5d99762f43$exports.TreeItemGroupTransition = (0, $78255dd8255477c5$exports.styled)($17712d5d99762f43$var$_Collapse.default, {
    name: 'MuiTreeItem',
    slot: 'GroupTransition',
    overridesResolver: (props, styles)=>styles.groupTransition
})({
    margin: 0,
    padding: 0
});
const $17712d5d99762f43$var$TreeItemErrorContainer = $17712d5d99762f43$exports.TreeItemErrorContainer = (0, $78255dd8255477c5$exports.styled)('div', {
    name: 'MuiTreeItem',
    slot: 'ErrorIcon',
    overridesResolver: (props, styles)=>styles.errorIcon
})({
    position: 'absolute',
    right: -3,
    width: 7,
    height: 7,
    borderRadius: '50%',
    backgroundColor: 'red'
});
const $17712d5d99762f43$var$TreeItemLoadingContainer = $17712d5d99762f43$exports.TreeItemLoadingContainer = (0, $78255dd8255477c5$exports.styled)($17712d5d99762f43$var$_CircularProgress.default, {
    name: 'MuiTreeItem',
    slot: 'LoadingIcon',
    overridesResolver: (props, styles)=>styles.loadingIcon
})({
    color: 'text.primary'
});
const $17712d5d99762f43$var$TreeItemCheckbox = $17712d5d99762f43$exports.TreeItemCheckbox = (0, $78255dd8255477c5$exports.styled)(/*#__PURE__*/ $17712d5d99762f43$var$React.forwardRef((props, ref)=>{
    const { visible: visible } = props, other = (0, $17712d5d99762f43$var$_objectWithoutPropertiesLoose2.default)(props, $17712d5d99762f43$var$_excluded);
    if (!visible) return null;
    return /*#__PURE__*/ (0, $kSbwP.jsx)($17712d5d99762f43$var$_Checkbox.default, (0, $17712d5d99762f43$var$_extends2.default)({}, other, {
        ref: ref
    }));
}), {
    name: 'MuiTreeItem',
    slot: 'Checkbox',
    overridesResolver: (props, styles)=>styles.checkbox
})({
    padding: 0
});
const $17712d5d99762f43$var$useUtilityClasses = (classesProp)=>{
    const { classes: classesFromTreeView } = (0, $d712ba72daa2f7ea$exports.useTreeViewStyleContext)();
    const classes = (0, $17712d5d99762f43$var$_extends2.default)({}, classesProp, {
        root: (0, $17712d5d99762f43$var$_clsx.default)(classesProp?.root, classesFromTreeView.root),
        content: (0, $17712d5d99762f43$var$_clsx.default)(classesProp?.content, classesFromTreeView.itemContent),
        iconContainer: (0, $17712d5d99762f43$var$_clsx.default)(classesProp?.iconContainer, classesFromTreeView.itemIconContainer),
        checkbox: (0, $17712d5d99762f43$var$_clsx.default)(classesProp?.checkbox, classesFromTreeView.itemCheckbox),
        label: (0, $17712d5d99762f43$var$_clsx.default)(classesProp?.label, classesFromTreeView.itemLabel),
        groupTransition: (0, $17712d5d99762f43$var$_clsx.default)(classesProp?.groupTransition, classesFromTreeView.itemGroupTransition),
        labelInput: (0, $17712d5d99762f43$var$_clsx.default)(classesProp?.labelInput, classesFromTreeView.itemLabelInput),
        dragAndDropOverlay: (0, $17712d5d99762f43$var$_clsx.default)(classesProp?.dragAndDropOverlay, classesFromTreeView.itemDragAndDropOverlay),
        errorIcon: (0, $17712d5d99762f43$var$_clsx.default)(classesProp?.errorIcon, classesFromTreeView.itemErrorIcon),
        loadingIcon: (0, $17712d5d99762f43$var$_clsx.default)(classesProp?.loadingIcon, classesFromTreeView.itemLoadingIcon)
    });
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ],
        iconContainer: [
            'iconContainer'
        ],
        checkbox: [
            'checkbox'
        ],
        label: [
            'label'
        ],
        groupTransition: [
            'groupTransition'
        ],
        labelInput: [
            'labelInput'
        ],
        dragAndDropOverlay: [
            'dragAndDropOverlay'
        ],
        errorIcon: [
            'errorIcon'
        ],
        loadingIcon: [
            'loadingIcon'
        ],
        expanded: [
            'expanded'
        ],
        editing: [
            'editing'
        ],
        editable: [
            'editable'
        ],
        selected: [
            'selected'
        ],
        focused: [
            'focused'
        ],
        disabled: [
            'disabled'
        ]
    };
    return (0, $17712d5d99762f43$var$_composeClasses.default)(slots, $5ea0623dc4236a37$exports.getTreeItemUtilityClass, classes);
};
/**
 *
 * Demos:
 *
 * - [Tree View](https://mui.com/x/react-tree-view/)
 *
 * API:
 *
 * - [TreeItem API](https://mui.com/x/api/tree-view/tree-item-2/)
 */ const $17712d5d99762f43$var$TreeItem = $17712d5d99762f43$exports.TreeItem = /*#__PURE__*/ $17712d5d99762f43$var$React.forwardRef(function TreeItem(inProps, forwardedRef) {
    const props = $17712d5d99762f43$var$useThemeProps({
        props: inProps,
        name: 'MuiTreeItem'
    });
    const { id: id, itemId: itemId, label: label, disabled: disabled, children: children, slots: slots = {}, slotProps: slotProps = {}, classes: classesProp } = props, other = (0, $17712d5d99762f43$var$_objectWithoutPropertiesLoose2.default)(props, $17712d5d99762f43$var$_excluded2);
    const { getContextProviderProps: getContextProviderProps, getRootProps: getRootProps, getContentProps: getContentProps, getIconContainerProps: getIconContainerProps, getCheckboxProps: getCheckboxProps, getLabelProps: getLabelProps, getGroupTransitionProps: getGroupTransitionProps, getLabelInputProps: getLabelInputProps, getDragAndDropOverlayProps: getDragAndDropOverlayProps, getErrorContainerProps: getErrorContainerProps, getLoadingContainerProps: getLoadingContainerProps, status: status } = (0, $9f588e9af86237d9$exports.useTreeItem)({
        id: id,
        itemId: itemId,
        children: children,
        label: label,
        disabled: disabled
    });
    const classes = $17712d5d99762f43$var$useUtilityClasses(classesProp);
    const Root = slots.root ?? $17712d5d99762f43$var$TreeItemRoot;
    const rootProps = (0, $17712d5d99762f43$var$_useSlotProps.default)({
        elementType: Root,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        externalSlotProps: slotProps.root,
        additionalProps: {
            ref: forwardedRef
        },
        ownerState: {},
        className: classes.root
    });
    const Content = slots.content ?? $17712d5d99762f43$var$TreeItemContent;
    const contentProps = (0, $17712d5d99762f43$var$_useSlotProps.default)({
        elementType: Content,
        getSlotProps: getContentProps,
        externalSlotProps: slotProps.content,
        ownerState: {},
        className: (0, $17712d5d99762f43$var$_clsx.default)(classes.content, status.expanded && classes.expanded, status.selected && classes.selected, status.focused && classes.focused, status.disabled && classes.disabled, status.editing && classes.editing, status.editable && classes.editable)
    });
    const IconContainer = slots.iconContainer ?? $17712d5d99762f43$var$TreeItemIconContainer;
    const iconContainerProps = (0, $17712d5d99762f43$var$_useSlotProps.default)({
        elementType: IconContainer,
        getSlotProps: getIconContainerProps,
        externalSlotProps: slotProps.iconContainer,
        ownerState: {},
        className: classes.iconContainer
    });
    const Label = slots.label ?? $17712d5d99762f43$var$TreeItemLabel;
    const labelProps = (0, $17712d5d99762f43$var$_useSlotProps.default)({
        elementType: Label,
        getSlotProps: getLabelProps,
        externalSlotProps: slotProps.label,
        ownerState: {},
        className: classes.label
    });
    const Checkbox = slots.checkbox ?? $17712d5d99762f43$var$TreeItemCheckbox;
    const checkboxProps = (0, $17712d5d99762f43$var$_useSlotProps.default)({
        elementType: Checkbox,
        getSlotProps: getCheckboxProps,
        externalSlotProps: slotProps.checkbox,
        ownerState: {},
        className: classes.checkbox
    });
    const GroupTransition = slots.groupTransition ?? undefined;
    const groupTransitionProps = (0, $17712d5d99762f43$var$_useSlotProps.default)({
        elementType: GroupTransition,
        getSlotProps: getGroupTransitionProps,
        externalSlotProps: slotProps.groupTransition,
        ownerState: {},
        className: classes.groupTransition
    });
    const LabelInput = slots.labelInput ?? $fedcfac1446f1a54$exports.TreeItemLabelInput;
    const labelInputProps = (0, $17712d5d99762f43$var$_useSlotProps.default)({
        elementType: LabelInput,
        getSlotProps: getLabelInputProps,
        externalSlotProps: slotProps.labelInput,
        ownerState: {},
        className: classes.labelInput
    });
    const DragAndDropOverlay = slots.dragAndDropOverlay ?? $f9264c19e436ee7b$exports.TreeItemDragAndDropOverlay;
    const dragAndDropOverlayProps = (0, $17712d5d99762f43$var$_useSlotProps.default)({
        elementType: DragAndDropOverlay,
        getSlotProps: getDragAndDropOverlayProps,
        externalSlotProps: slotProps.dragAndDropOverlay,
        ownerState: {},
        className: classes.dragAndDropOverlay
    });
    const ErrorIcon = slots.errorIcon ?? $17712d5d99762f43$var$TreeItemErrorContainer;
    const errorContainerProps = (0, $17712d5d99762f43$var$_useSlotProps.default)({
        elementType: ErrorIcon,
        getSlotProps: getErrorContainerProps,
        externalSlotProps: slotProps.errorIcon,
        ownerState: {},
        className: classes.errorIcon
    });
    const LoadingIcon = slots.loadingIcon ?? $17712d5d99762f43$var$TreeItemLoadingContainer;
    const loadingContainerProps = (0, $17712d5d99762f43$var$_useSlotProps.default)({
        elementType: LoadingIcon,
        getSlotProps: getLoadingContainerProps,
        externalSlotProps: slotProps.loadingIcon,
        ownerState: {},
        className: classes.loadingIcon
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)($4798f2bc20877e0e$exports.TreeItemProvider, (0, $17712d5d99762f43$var$_extends2.default)({}, getContextProviderProps(), {
        children: /*#__PURE__*/ (0, $kSbwP.jsxs)(Root, (0, $17712d5d99762f43$var$_extends2.default)({}, rootProps, {
            children: [
                /*#__PURE__*/ (0, $kSbwP.jsxs)(Content, (0, $17712d5d99762f43$var$_extends2.default)({}, contentProps, {
                    children: [
                        /*#__PURE__*/ (0, $kSbwP.jsxs)(IconContainer, (0, $17712d5d99762f43$var$_extends2.default)({}, iconContainerProps, {
                            children: [
                                status.error && /*#__PURE__*/ (0, $kSbwP.jsx)(ErrorIcon, (0, $17712d5d99762f43$var$_extends2.default)({}, errorContainerProps)),
                                status.loading ? /*#__PURE__*/ (0, $kSbwP.jsx)(LoadingIcon, (0, $17712d5d99762f43$var$_extends2.default)({}, loadingContainerProps)) : /*#__PURE__*/ (0, $kSbwP.jsx)($fc167e51bb2c93e8$exports.TreeItemIcon, {
                                    status: status,
                                    slots: slots,
                                    slotProps: slotProps
                                })
                            ]
                        })),
                        /*#__PURE__*/ (0, $kSbwP.jsx)(Checkbox, (0, $17712d5d99762f43$var$_extends2.default)({}, checkboxProps)),
                        status.editing ? /*#__PURE__*/ (0, $kSbwP.jsx)(LabelInput, (0, $17712d5d99762f43$var$_extends2.default)({}, labelInputProps)) : /*#__PURE__*/ (0, $kSbwP.jsx)(Label, (0, $17712d5d99762f43$var$_extends2.default)({}, labelProps)),
                        /*#__PURE__*/ (0, $kSbwP.jsx)(DragAndDropOverlay, (0, $17712d5d99762f43$var$_extends2.default)({}, dragAndDropOverlayProps))
                    ]
                })),
                children && /*#__PURE__*/ (0, $kSbwP.jsx)($17712d5d99762f43$var$TreeItemGroupTransition, (0, $17712d5d99762f43$var$_extends2.default)({
                    as: GroupTransition
                }, groupTransitionProps))
            ]
        }))
    }));
});





var $ecb5096a87a10a64$exports = {};
"use strict";
Object.defineProperty($ecb5096a87a10a64$exports, "__esModule", {
    value: true
});
Object.defineProperty($ecb5096a87a10a64$exports, "useTreeItemModel", {
    enumerable: true,
    get: function() {
        return $3f67d41be2ca114a$exports.useTreeItemModel;
    }
});
Object.defineProperty($ecb5096a87a10a64$exports, "useTreeItemUtils", {
    enumerable: true,
    get: function() {
        return $34f61e46418c653f$exports.useTreeItemUtils;
    }
});
Object.defineProperty($ecb5096a87a10a64$exports, "useTreeViewApiRef", {
    enumerable: true,
    get: function() {
        return $c59b11ba7478f512$exports.useTreeViewApiRef;
    }
});
var $c59b11ba7478f512$exports = {};
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $c59b11ba7478f512$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($c59b11ba7478f512$exports, "__esModule", {
    value: true
});
$c59b11ba7478f512$exports.useTreeViewApiRef = void 0;

var $c59b11ba7478f512$var$React = $c59b11ba7478f512$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * Hook that instantiates a [[TreeViewApiRef]].
 */ const $c59b11ba7478f512$var$useTreeViewApiRef = ()=>$c59b11ba7478f512$var$React.useRef(undefined);
$c59b11ba7478f512$exports.useTreeViewApiRef = $c59b11ba7478f512$var$useTreeViewApiRef;



var $3f67d41be2ca114a$exports = {};
"use strict";
'use client';
Object.defineProperty($3f67d41be2ca114a$exports, "__esModule", {
    value: true
});
$3f67d41be2ca114a$exports.useTreeItemModel = void 0;



const $3f67d41be2ca114a$var$useTreeItemModel = (itemId)=>{
    const { store: store } = (0, $33114ec9c2f70325$exports.useTreeViewContext)();
    return (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $4bf621410ffd294f$exports.selectorItemModel, itemId);
};
$3f67d41be2ca114a$exports.useTreeItemModel = $3f67d41be2ca114a$var$useTreeItemModel;




var $0608756385ff06a8$exports = {};
"use strict";
"use client";

var $1yHiF = parcelRequire("1yHiF");
var $0608756385ff06a8$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($0608756385ff06a8$exports, "__esModule", {
    value: true
});
$0608756385ff06a8$exports.default = void 0;

var $0608756385ff06a8$var$_createSvgIcon = $0608756385ff06a8$require$_interopRequireDefault((parcelRequire("4TUCe")));

var $kSbwP = parcelRequire("kSbwP");
var $0608756385ff06a8$var$_default = $0608756385ff06a8$exports.default = (0, $0608756385ff06a8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-5 14H7v-2h7zm3-4H7v-2h10zm0-4H7V7h10z"
}), 'Article');


var $c6e118bb06a6e33f$exports = {};
"use strict";
"use client";

var $1yHiF = parcelRequire("1yHiF");
var $c6e118bb06a6e33f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($c6e118bb06a6e33f$exports, "__esModule", {
    value: true
});
$c6e118bb06a6e33f$exports.default = void 0;

var $c6e118bb06a6e33f$var$_createSvgIcon = $c6e118bb06a6e33f$require$_interopRequireDefault((parcelRequire("4TUCe")));

var $kSbwP = parcelRequire("kSbwP");
var $c6e118bb06a6e33f$var$_default = $c6e118bb06a6e33f$exports.default = (0, $c6e118bb06a6e33f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m0 12H4V8h16z"
}), 'FolderOpen');


var $36ece994f43249dc$exports = {};
"use strict";
"use client";

var $1yHiF = parcelRequire("1yHiF");
var $36ece994f43249dc$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($36ece994f43249dc$exports, "__esModule", {
    value: true
});
$36ece994f43249dc$exports.default = void 0;

var $36ece994f43249dc$var$_createSvgIcon = $36ece994f43249dc$require$_interopRequireDefault((parcelRequire("4TUCe")));

var $kSbwP = parcelRequire("kSbwP");
var $36ece994f43249dc$var$_default = $36ece994f43249dc$exports.default = (0, $36ece994f43249dc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8z"
}), 'FolderRounded');




var $c65f25eba0931d0a$exports = {};
"use strict";
Object.defineProperty($c65f25eba0931d0a$exports, "__esModule", {
    value: true
});
var $c65f25eba0931d0a$var$_exportNames = {
    RICH_TREE_VIEW_PLUGINS: true
};
Object.defineProperty($c65f25eba0931d0a$exports, "RICH_TREE_VIEW_PLUGINS", {
    enumerable: true,
    get: function() {
        return $b1cfd327c7e0ce2d$exports.RICH_TREE_VIEW_PLUGINS;
    }
});
var $bc7ed93b333a9eaa$exports = {};
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $bc7ed93b333a9eaa$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $bc7ed93b333a9eaa$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($bc7ed93b333a9eaa$exports, "__esModule", {
    value: true
});
$bc7ed93b333a9eaa$exports.RichTreeViewRoot = $bc7ed93b333a9eaa$exports.RichTreeView = void 0;

var $bc7ed93b333a9eaa$var$_extends2 = $bc7ed93b333a9eaa$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $bc7ed93b333a9eaa$var$_objectWithoutPropertiesLoose2 = $bc7ed93b333a9eaa$require$_interopRequireDefault((parcelRequire("68UY6")));

var $bc7ed93b333a9eaa$var$React = $bc7ed93b333a9eaa$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $bc7ed93b333a9eaa$var$_propTypes = $bc7ed93b333a9eaa$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $bc7ed93b333a9eaa$var$_Alert = $bc7ed93b333a9eaa$require$_interopRequireDefault((parcelRequire("jn4Is")));

var $bc7ed93b333a9eaa$var$_Typography = $bc7ed93b333a9eaa$require$_interopRequireDefault((parcelRequire("by9f1")));

var $bc7ed93b333a9eaa$var$_composeClasses = $bc7ed93b333a9eaa$require$_interopRequireDefault((parcelRequire("4F19u")));

var $bc7ed93b333a9eaa$var$_useSlotProps = $bc7ed93b333a9eaa$require$_interopRequireDefault((parcelRequire("k3QMn")));

var $97a7d95f69a0fbdb$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $97a7d95f69a0fbdb$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($97a7d95f69a0fbdb$exports, "__esModule", {
    value: true
});
$97a7d95f69a0fbdb$exports.getRichTreeViewUtilityClass = $97a7d95f69a0fbdb$var$getRichTreeViewUtilityClass;
$97a7d95f69a0fbdb$exports.richTreeViewClasses = void 0;

var $97a7d95f69a0fbdb$var$_generateUtilityClass = $97a7d95f69a0fbdb$require$_interopRequireDefault((parcelRequire("4E9MM")));

var $97a7d95f69a0fbdb$var$_generateUtilityClasses = $97a7d95f69a0fbdb$require$_interopRequireDefault((parcelRequire("4bI4C")));
function $97a7d95f69a0fbdb$var$getRichTreeViewUtilityClass(slot) {
    return (0, $97a7d95f69a0fbdb$var$_generateUtilityClass.default)('MuiRichTreeView', slot);
}
const $97a7d95f69a0fbdb$var$richTreeViewClasses = $97a7d95f69a0fbdb$exports.richTreeViewClasses = (0, $97a7d95f69a0fbdb$var$_generateUtilityClasses.default)('MuiRichTreeView', [
    'root',
    'item',
    'itemContent',
    'itemGroupTransition',
    'itemIconContainer',
    'itemLabel',
    'itemCheckbox',
    'itemLabelInput'
]);



var $a2f703e2dc17e62b$exports = {};
"use strict";
Object.defineProperty($a2f703e2dc17e62b$exports, "__esModule", {
    value: true
});
Object.defineProperty($a2f703e2dc17e62b$exports, "useTreeView", {
    enumerable: true,
    get: function() {
        return $087c7cfcad7ef5c6$exports.useTreeView;
    }
});
var $087c7cfcad7ef5c6$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $087c7cfcad7ef5c6$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $087c7cfcad7ef5c6$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($087c7cfcad7ef5c6$exports, "__esModule", {
    value: true
});
$087c7cfcad7ef5c6$exports.useTreeView = void 0;
$087c7cfcad7ef5c6$exports.useTreeViewApiInitialization = $087c7cfcad7ef5c6$var$useTreeViewApiInitialization;

var $087c7cfcad7ef5c6$var$_extends2 = $087c7cfcad7ef5c6$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $087c7cfcad7ef5c6$var$React = $087c7cfcad7ef5c6$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $087c7cfcad7ef5c6$var$_useForkRef = $087c7cfcad7ef5c6$require$_interopRequireDefault((parcelRequire("7uWLa")));
var $ae840de7471f05d0$exports = {};
"use strict";
Object.defineProperty($ae840de7471f05d0$exports, "__esModule", {
    value: true
});
Object.defineProperty($ae840de7471f05d0$exports, "TREE_VIEW_CORE_PLUGINS", {
    enumerable: true,
    get: function() {
        return $1ce23e58d4bf1e58$exports.TREE_VIEW_CORE_PLUGINS;
    }
});
var $1ce23e58d4bf1e58$exports = {};
"use strict";
Object.defineProperty($1ce23e58d4bf1e58$exports, "__esModule", {
    value: true
});
$1ce23e58d4bf1e58$exports.TREE_VIEW_CORE_PLUGINS = void 0;
var $7a5d7887e24e278d$exports = {};
"use strict";
Object.defineProperty($7a5d7887e24e278d$exports, "__esModule", {
    value: true
});
Object.defineProperty($7a5d7887e24e278d$exports, "useTreeViewInstanceEvents", {
    enumerable: true,
    get: function() {
        return $2defa0931ca4c4c9$exports.useTreeViewInstanceEvents;
    }
});
var $2defa0931ca4c4c9$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $2defa0931ca4c4c9$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($2defa0931ca4c4c9$exports, "__esModule", {
    value: true
});
$2defa0931ca4c4c9$exports.useTreeViewInstanceEvents = void 0;

var $2defa0931ca4c4c9$var$React = $2defa0931ca4c4c9$require$_interopRequireWildcard((parcelRequire("8nGP5")));
var $bed767915886babb$exports = {};
"use strict";
Object.defineProperty($bed767915886babb$exports, "__esModule", {
    value: true
});
Object.defineProperty($bed767915886babb$exports, "EventManager", {
    enumerable: true,
    get: function() {
        return $c9e8f41ed5873075$exports.EventManager;
    }
});
var $c9e8f41ed5873075$exports = {};
"use strict";
Object.defineProperty($c9e8f41ed5873075$exports, "__esModule", {
    value: true
});
$c9e8f41ed5873075$exports.EventManager = void 0;
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $c9e8f41ed5873075$var$EventManager {
    constructor(){
        this.maxListeners = 20;
        this.warnOnce = false;
        this.events = {};
    }
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}
$c9e8f41ed5873075$exports.EventManager = $c9e8f41ed5873075$var$EventManager;




const $2defa0931ca4c4c9$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
const $2defa0931ca4c4c9$var$useTreeViewInstanceEvents = ()=>{
    const [eventManager] = $2defa0931ca4c4c9$var$React.useState(()=>new $bed767915886babb$exports.EventManager());
    const publishEvent = $2defa0931ca4c4c9$var$React.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($2defa0931ca4c4c9$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        eventManager.emit(name, params, event);
    }, [
        eventManager
    ]);
    const subscribeEvent = $2defa0931ca4c4c9$var$React.useCallback((event, handler)=>{
        eventManager.on(event, handler);
        return ()=>{
            eventManager.removeListener(event, handler);
        };
    }, [
        eventManager
    ]);
    return {
        instance: {
            $$publishEvent: publishEvent,
            $$subscribeEvent: subscribeEvent
        }
    };
};
$2defa0931ca4c4c9$exports.useTreeViewInstanceEvents = $2defa0931ca4c4c9$var$useTreeViewInstanceEvents;
$2defa0931ca4c4c9$var$useTreeViewInstanceEvents.params = {};




var $5959bdf17532aba1$exports = {};
"use strict";
Object.defineProperty($5959bdf17532aba1$exports, "__esModule", {
    value: true
});
Object.defineProperty($5959bdf17532aba1$exports, "useTreeViewOptionalPlugins", {
    enumerable: true,
    get: function() {
        return $565c96f842037a39$exports.useTreeViewOptionalPlugins;
    }
});
var $565c96f842037a39$exports = {};
"use strict";
Object.defineProperty($565c96f842037a39$exports, "__esModule", {
    value: true
});
$565c96f842037a39$exports.useTreeViewOptionalPlugins = void 0;
const $565c96f842037a39$var$useTreeViewOptionalPlugins = ({ plugins: plugins })=>{
    const pluginSet = new Set(plugins);
    const getAvailablePlugins = ()=>pluginSet;
    return {
        instance: {
            getAvailablePlugins: getAvailablePlugins
        }
    };
};
$565c96f842037a39$exports.useTreeViewOptionalPlugins = $565c96f842037a39$var$useTreeViewOptionalPlugins;
$565c96f842037a39$var$useTreeViewOptionalPlugins.params = {};




var $57e244b07cf7583a$exports = {};
"use strict";
Object.defineProperty($57e244b07cf7583a$exports, "__esModule", {
    value: true
});
Object.defineProperty($57e244b07cf7583a$exports, "useTreeViewId", {
    enumerable: true,
    get: function() {
        return $3cb9685ba43cc8d7$exports.useTreeViewId;
    }
});
var $3cb9685ba43cc8d7$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $3cb9685ba43cc8d7$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $3cb9685ba43cc8d7$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($3cb9685ba43cc8d7$exports, "__esModule", {
    value: true
});
$3cb9685ba43cc8d7$exports.useTreeViewId = void 0;

var $3cb9685ba43cc8d7$var$_extends2 = $3cb9685ba43cc8d7$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $3cb9685ba43cc8d7$var$React = $3cb9685ba43cc8d7$require$_interopRequireWildcard((parcelRequire("8nGP5")));



const $3cb9685ba43cc8d7$var$useTreeViewId = ({ params: params, store: store })=>{
    $3cb9685ba43cc8d7$var$React.useEffect(()=>{
        store.update((prevState)=>{
            if (params.id === prevState.id.providedTreeId && prevState.id.treeId !== undefined) return prevState;
            return (0, $3cb9685ba43cc8d7$var$_extends2.default)({}, prevState, {
                id: (0, $3cb9685ba43cc8d7$var$_extends2.default)({}, prevState.id, {
                    treeId: params.id ?? (0, $93de18c67dbb3a30$exports.createTreeViewDefaultId)()
                })
            });
        });
    }, [
        store,
        params.id
    ]);
    const treeId = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $8891880caf94d5b0$exports.selectorTreeViewId);
    return {
        getRootProps: ()=>({
                id: treeId
            })
    };
};
$3cb9685ba43cc8d7$exports.useTreeViewId = $3cb9685ba43cc8d7$var$useTreeViewId;
$3cb9685ba43cc8d7$var$useTreeViewId.params = {
    id: true
};
$3cb9685ba43cc8d7$var$useTreeViewId.getInitialState = ({ id: id })=>({
        id: {
            treeId: undefined,
            providedTreeId: id
        }
    });




/**
 * Internal plugins that create the tools used by the other plugins.
 * These plugins are used by the Tree View components.
 */ const $1ce23e58d4bf1e58$var$TREE_VIEW_CORE_PLUGINS = $1ce23e58d4bf1e58$exports.TREE_VIEW_CORE_PLUGINS = [
    $7a5d7887e24e278d$exports.useTreeViewInstanceEvents,
    $5959bdf17532aba1$exports.useTreeViewOptionalPlugins,
    $57e244b07cf7583a$exports.useTreeViewId
];




var $0eb8376e93576208$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $0eb8376e93576208$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($0eb8376e93576208$exports, "__esModule", {
    value: true
});
$0eb8376e93576208$exports.extractPluginParamsFromProps = void 0;

var $0eb8376e93576208$var$_objectWithoutPropertiesLoose2 = $0eb8376e93576208$require$_interopRequireDefault((parcelRequire("68UY6")));
const $0eb8376e93576208$var$_excluded = [
    "apiRef",
    "experimentalFeatures"
];
const $0eb8376e93576208$var$extractPluginParamsFromProps = (_ref)=>{
    let { props: { apiRef: apiRef, experimentalFeatures: inExperimentalFeatures }, plugins: plugins } = _ref, props = (0, $0eb8376e93576208$var$_objectWithoutPropertiesLoose2.default)(_ref.props, $0eb8376e93576208$var$_excluded);
    const paramsLookup = {};
    plugins.forEach((plugin)=>{
        Object.assign(paramsLookup, plugin.params);
    });
    const pluginParams = {};
    const forwardedProps = {};
    Object.keys(props).forEach((propName)=>{
        const prop = props[propName];
        if (paramsLookup[propName]) pluginParams[propName] = prop;
        else forwardedProps[propName] = prop;
    });
    const experimentalFeatures = inExperimentalFeatures ?? {};
    const defaultizedPluginParams = plugins.reduce((acc, plugin)=>{
        if (plugin.getDefaultizedParams) return plugin.getDefaultizedParams({
            params: acc,
            experimentalFeatures: experimentalFeatures
        });
        return acc;
    }, pluginParams);
    return {
        apiRef: apiRef,
        forwardedProps: forwardedProps,
        pluginParams: defaultizedPluginParams,
        experimentalFeatures: experimentalFeatures
    };
};
$0eb8376e93576208$exports.extractPluginParamsFromProps = $0eb8376e93576208$var$extractPluginParamsFromProps;


var $ccda82f80cdad8d4$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $ccda82f80cdad8d4$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($ccda82f80cdad8d4$exports, "__esModule", {
    value: true
});
$ccda82f80cdad8d4$exports.useTreeViewBuildContext = void 0;

var $ccda82f80cdad8d4$var$React = $ccda82f80cdad8d4$require$_interopRequireWildcard((parcelRequire("8nGP5")));
const $ccda82f80cdad8d4$var$useTreeViewBuildContext = ({ plugins: plugins, instance: instance, publicAPI: publicAPI, store: store, rootRef: rootRef })=>{
    const runItemPlugins = $ccda82f80cdad8d4$var$React.useCallback((itemPluginProps)=>{
        let finalRootRef = null;
        let finalContentRef = null;
        const pluginPropEnhancers = [];
        const pluginPropEnhancersNames = {};
        plugins.forEach((plugin)=>{
            if (!plugin.itemPlugin) return;
            const itemPluginResponse = plugin.itemPlugin({
                props: itemPluginProps,
                rootRef: finalRootRef,
                contentRef: finalContentRef
            });
            if (itemPluginResponse?.rootRef) finalRootRef = itemPluginResponse.rootRef;
            if (itemPluginResponse?.contentRef) finalContentRef = itemPluginResponse.contentRef;
            if (itemPluginResponse?.propsEnhancers) {
                pluginPropEnhancers.push(itemPluginResponse.propsEnhancers);
                // Prepare a list of all the slots which are enhanced by at least one plugin
                Object.keys(itemPluginResponse.propsEnhancers).forEach((propsEnhancerName)=>{
                    pluginPropEnhancersNames[propsEnhancerName] = true;
                });
            }
        });
        const resolvePropsEnhancer = (currentSlotName)=>(currentSlotParams)=>{
                const enhancedProps = {};
                pluginPropEnhancers.forEach((propsEnhancersForCurrentPlugin)=>{
                    const propsEnhancerForCurrentPluginAndSlot = propsEnhancersForCurrentPlugin[currentSlotName];
                    if (propsEnhancerForCurrentPluginAndSlot != null) Object.assign(enhancedProps, propsEnhancerForCurrentPluginAndSlot(currentSlotParams));
                });
                return enhancedProps;
            };
        const propsEnhancers = Object.fromEntries(Object.keys(pluginPropEnhancersNames).map((propEnhancerName)=>[
                propEnhancerName,
                resolvePropsEnhancer(propEnhancerName)
            ]));
        return {
            contentRef: finalContentRef,
            rootRef: finalRootRef,
            propsEnhancers: propsEnhancers
        };
    }, [
        plugins
    ]);
    const wrapItem = $ccda82f80cdad8d4$var$React.useCallback(({ itemId: itemId, children: children, idAttribute: idAttribute })=>{
        let finalChildren = children;
        // The wrappers are reversed to ensure that the first wrapper is the outermost one.
        for(let i = plugins.length - 1; i >= 0; i -= 1){
            const plugin = plugins[i];
            if (plugin.wrapItem) finalChildren = plugin.wrapItem({
                instance: instance,
                itemId: itemId,
                children: finalChildren,
                idAttribute: idAttribute
            });
        }
        return finalChildren;
    }, [
        plugins,
        instance
    ]);
    const wrapRoot = $ccda82f80cdad8d4$var$React.useCallback(({ children: children })=>{
        let finalChildren = children;
        // The wrappers are reversed to ensure that the first wrapper is the outermost one.
        for(let i = plugins.length - 1; i >= 0; i -= 1){
            const plugin = plugins[i];
            if (plugin.wrapRoot) finalChildren = plugin.wrapRoot({
                children: finalChildren
            });
        }
        return finalChildren;
    }, [
        plugins
    ]);
    return $ccda82f80cdad8d4$var$React.useMemo(()=>({
            runItemPlugins: runItemPlugins,
            wrapItem: wrapItem,
            wrapRoot: wrapRoot,
            instance: instance,
            publicAPI: publicAPI,
            store: store,
            rootRef: rootRef
        }), [
        runItemPlugins,
        wrapItem,
        wrapRoot,
        instance,
        publicAPI,
        store,
        rootRef
    ]);
};
$ccda82f80cdad8d4$exports.useTreeViewBuildContext = $ccda82f80cdad8d4$var$useTreeViewBuildContext;


var $e5532e1b16d3c851$exports = {};
"use strict";
Object.defineProperty($e5532e1b16d3c851$exports, "__esModule", {
    value: true
});
$e5532e1b16d3c851$exports.TreeViewStore = void 0;
class $e5532e1b16d3c851$var$TreeViewStore {
    constructor(value){
        this.value = void 0;
        this.listeners = void 0;
        this.subscribe = (fn)=>{
            this.listeners.add(fn);
            return ()=>{
                this.listeners.delete(fn);
            };
        };
        this.getSnapshot = ()=>{
            return this.value;
        };
        this.update = (updater)=>{
            const newState = updater(this.value);
            if (newState !== this.value) {
                this.value = newState;
                this.listeners.forEach((l)=>l(newState));
            }
        };
        this.value = value;
        this.listeners = new Set();
    }
}
$e5532e1b16d3c851$exports.TreeViewStore = $e5532e1b16d3c851$var$TreeViewStore;


function $087c7cfcad7ef5c6$var$initializeInputApiRef(inputApiRef) {
    if (inputApiRef.current == null) inputApiRef.current = {};
    return inputApiRef;
}
function $087c7cfcad7ef5c6$var$useTreeViewApiInitialization(inputApiRef) {
    const fallbackPublicApiRef = $087c7cfcad7ef5c6$var$React.useRef({});
    if (inputApiRef) return $087c7cfcad7ef5c6$var$initializeInputApiRef(inputApiRef);
    return fallbackPublicApiRef;
}
let $087c7cfcad7ef5c6$var$globalId = 0;
/**
 * This is the main hook that sets the plugin system up for the tree-view.
 *
 * It manages the data used to create the tree-view.
 *
 * @param plugins All the plugins that will be used in the tree-view.
 * @param props The props passed to the tree-view.
 * @param rootRef The ref of the root element.
 */ const $087c7cfcad7ef5c6$var$useTreeView = ({ plugins: inPlugins, rootRef: rootRef, props: props })=>{
    const plugins = $087c7cfcad7ef5c6$var$React.useMemo(()=>[
            ...$ae840de7471f05d0$exports.TREE_VIEW_CORE_PLUGINS,
            ...inPlugins
        ], [
        inPlugins
    ]);
    const { pluginParams: pluginParams, forwardedProps: forwardedProps, apiRef: apiRef, experimentalFeatures: experimentalFeatures } = (0, $0eb8376e93576208$exports.extractPluginParamsFromProps)({
        plugins: plugins,
        props: props
    });
    const instanceRef = $087c7cfcad7ef5c6$var$React.useRef({});
    const instance = instanceRef.current;
    const publicAPI = $087c7cfcad7ef5c6$var$useTreeViewApiInitialization(apiRef);
    const innerRootRef = $087c7cfcad7ef5c6$var$React.useRef(null);
    const handleRootRef = (0, $087c7cfcad7ef5c6$var$_useForkRef.default)(innerRootRef, rootRef);
    const storeRef = $087c7cfcad7ef5c6$var$React.useRef(null);
    if (storeRef.current == null) {
        $087c7cfcad7ef5c6$var$globalId += 1;
        const initialState = {
            cacheKey: {
                id: $087c7cfcad7ef5c6$var$globalId
            }
        };
        plugins.forEach((plugin)=>{
            if (plugin.getInitialState) Object.assign(initialState, plugin.getInitialState(pluginParams));
        });
        storeRef.current = new $e5532e1b16d3c851$exports.TreeViewStore(initialState);
    }
    const contextValue = (0, $ccda82f80cdad8d4$exports.useTreeViewBuildContext)({
        plugins: plugins,
        instance: instance,
        publicAPI: publicAPI.current,
        store: storeRef.current,
        rootRef: innerRootRef
    });
    const rootPropsGetters = [];
    const runPlugin = (plugin)=>{
        const pluginResponse = plugin({
            instance: instance,
            params: pluginParams,
            experimentalFeatures: experimentalFeatures,
            rootRef: innerRootRef,
            plugins: plugins,
            store: storeRef.current
        });
        if (pluginResponse.getRootProps) rootPropsGetters.push(pluginResponse.getRootProps);
        if (pluginResponse.publicAPI) Object.assign(publicAPI.current, pluginResponse.publicAPI);
        if (pluginResponse.instance) Object.assign(instance, pluginResponse.instance);
    };
    plugins.forEach(runPlugin);
    const getRootProps = (otherHandlers = {})=>{
        const rootProps = (0, $087c7cfcad7ef5c6$var$_extends2.default)({
            role: 'tree'
        }, forwardedProps, otherHandlers, {
            ref: handleRootRef
        });
        rootPropsGetters.forEach((rootPropsGetter)=>{
            Object.assign(rootProps, rootPropsGetter(otherHandlers));
        });
        return rootProps;
    };
    return {
        getRootProps: getRootProps,
        rootRef: handleRootRef,
        contextValue: contextValue
    };
};
$087c7cfcad7ef5c6$exports.useTreeView = $087c7cfcad7ef5c6$var$useTreeView;





var $b1cfd327c7e0ce2d$exports = {};
"use strict";
Object.defineProperty($b1cfd327c7e0ce2d$exports, "__esModule", {
    value: true
});
$b1cfd327c7e0ce2d$exports.RICH_TREE_VIEW_PLUGINS = void 0;
var $4bbff37830facd37$exports = {};
"use strict";
Object.defineProperty($4bbff37830facd37$exports, "__esModule", {
    value: true
});
Object.defineProperty($4bbff37830facd37$exports, "TREE_VIEW_ROOT_PARENT_ID", {
    enumerable: true,
    get: function() {
        return $2abc8533f192485b$exports.TREE_VIEW_ROOT_PARENT_ID;
    }
});
Object.defineProperty($4bbff37830facd37$exports, "buildSiblingIndexes", {
    enumerable: true,
    get: function() {
        return $2abc8533f192485b$exports.buildSiblingIndexes;
    }
});
Object.defineProperty($4bbff37830facd37$exports, "useTreeViewItems", {
    enumerable: true,
    get: function() {
        return $105a531cf9fa8a7d$exports.useTreeViewItems;
    }
});
var $105a531cf9fa8a7d$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $105a531cf9fa8a7d$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $105a531cf9fa8a7d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($105a531cf9fa8a7d$exports, "__esModule", {
    value: true
});
$105a531cf9fa8a7d$exports.useTreeViewItems = void 0;

var $105a531cf9fa8a7d$var$_extends2 = $105a531cf9fa8a7d$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $105a531cf9fa8a7d$var$React = $105a531cf9fa8a7d$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $105a531cf9fa8a7d$var$_useEventCallback = $105a531cf9fa8a7d$require$_interopRequireDefault((parcelRequire("5xdHV")));
var $1d486927ef52436a$exports = {};
"use strict";
Object.defineProperty($1d486927ef52436a$exports, "__esModule", {
    value: true
});
$1d486927ef52436a$exports.publishTreeViewEvent = void 0;
const $1d486927ef52436a$var$publishTreeViewEvent = (instance, eventName, params)=>{
    instance.$$publishEvent(eventName, params);
};
$1d486927ef52436a$exports.publishTreeViewEvent = $1d486927ef52436a$var$publishTreeViewEvent;








var $kSbwP = parcelRequire("kSbwP");
const $105a531cf9fa8a7d$var$checkId = (id, item, itemMetaLookup)=>{
    if (id == null) throw new Error([
        'MUI X: The Tree View component requires all items to have a unique `id` property.',
        'Alternatively, you can use the `getItemId` prop to specify a custom id for each item.',
        'An item was provided without id in the `items` prop:',
        JSON.stringify(item)
    ].join('\n'));
    if (itemMetaLookup[id] != null) throw new Error([
        'MUI X: The Tree View component requires all items to have a unique `id` property.',
        'Alternatively, you can use the `getItemId` prop to specify a custom id for each item.',
        `Two items were provided with the same id in the \`items\` prop: "${id}"`
    ].join('\n'));
};
const $105a531cf9fa8a7d$var$processItemsLookups = ({ disabledItemsFocusable: disabledItemsFocusable, items: items, isItemDisabled: isItemDisabled, getItemLabel: getItemLabel, getItemId: getItemId, initialDepth: initialDepth = 0, initialParentId: initialParentId = null, getChildrenCount: getChildrenCount, ignoreChildren: ignoreChildren = false })=>{
    const itemMetaLookup = {};
    const itemModelLookup = {};
    const itemOrderedChildrenIdsLookup = {
        [$2abc8533f192485b$exports.TREE_VIEW_ROOT_PARENT_ID]: []
    };
    const processItem = (item, depth, parentId)=>{
        const id = getItemId ? getItemId(item) : item.id;
        $105a531cf9fa8a7d$var$checkId(id, item, itemMetaLookup);
        const label = getItemLabel ? getItemLabel(item) : item.label;
        if (label == null) throw new Error([
            'MUI X: The Tree View component requires all items to have a `label` property.',
            'Alternatively, you can use the `getItemLabel` prop to specify a custom label for each item.',
            'An item was provided without label in the `items` prop:',
            JSON.stringify(item)
        ].join('\n'));
        itemMetaLookup[id] = {
            id: id,
            label: label,
            parentId: parentId,
            idAttribute: undefined,
            expandable: getChildrenCount ? getChildrenCount(item) > 0 : !!item.children?.length,
            disabled: isItemDisabled ? isItemDisabled(item) : false,
            depth: depth
        };
        itemModelLookup[id] = item;
        const parentIdWithDefault = parentId ?? $2abc8533f192485b$exports.TREE_VIEW_ROOT_PARENT_ID;
        if (!itemOrderedChildrenIdsLookup[parentIdWithDefault]) itemOrderedChildrenIdsLookup[parentIdWithDefault] = [];
        itemOrderedChildrenIdsLookup[parentIdWithDefault].push(id);
        // if lazy loading is enabled, we don't want to process children passed through the `items` prop
        if (!ignoreChildren) item.children?.forEach((child)=>processItem(child, depth + 1, id));
    };
    items?.forEach((item)=>processItem(item, initialDepth, initialParentId));
    const itemChildrenIndexesLookup = {};
    Object.keys(itemOrderedChildrenIdsLookup).forEach((parentId)=>{
        itemChildrenIndexesLookup[parentId] = (0, $2abc8533f192485b$exports.buildSiblingIndexes)(itemOrderedChildrenIdsLookup[parentId]);
    });
    return {
        disabledItemsFocusable: disabledItemsFocusable,
        itemMetaLookup: itemMetaLookup,
        itemModelLookup: itemModelLookup,
        itemOrderedChildrenIdsLookup: itemOrderedChildrenIdsLookup,
        itemChildrenIndexesLookup: itemChildrenIndexesLookup
    };
};
const $105a531cf9fa8a7d$var$useTreeViewItems = ({ instance: instance, params: params, store: store })=>{
    const getItem = $105a531cf9fa8a7d$var$React.useCallback((itemId)=>(0, $4bf621410ffd294f$exports.selectorItemModel)(store.value, itemId), [
        store
    ]);
    const getParentId = $105a531cf9fa8a7d$var$React.useCallback((itemId)=>{
        const itemMeta = (0, $4bf621410ffd294f$exports.selectorItemMeta)(store.value, itemId);
        return itemMeta?.parentId || null;
    }, [
        store
    ]);
    const setTreeViewLoading = (0, $105a531cf9fa8a7d$var$_useEventCallback.default)((isLoading)=>{
        store.update((prevState)=>(0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState, {
                items: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState.items, {
                    loading: isLoading
                })
            }));
    });
    const setTreeViewError = (0, $105a531cf9fa8a7d$var$_useEventCallback.default)((error)=>{
        store.update((prevState)=>(0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState, {
                items: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState.items, {
                    error: error
                })
            }));
    });
    const setIsItemDisabled = (0, $105a531cf9fa8a7d$var$_useEventCallback.default)(({ itemId: itemId, shouldBeDisabled: shouldBeDisabled })=>{
        store.update((prevState)=>{
            if (!prevState.items.itemMetaLookup[itemId]) return prevState;
            const itemMetaLookup = (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState.items.itemMetaLookup);
            itemMetaLookup[itemId] = (0, $105a531cf9fa8a7d$var$_extends2.default)({}, itemMetaLookup[itemId], {
                disabled: shouldBeDisabled ?? !itemMetaLookup[itemId].disabled
            });
            return (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState, {
                items: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState.items, {
                    itemMetaLookup: itemMetaLookup
                })
            });
        });
    });
    const getItemTree = $105a531cf9fa8a7d$var$React.useCallback(()=>{
        const getItemFromItemId = (itemId)=>{
            const item = (0, $4bf621410ffd294f$exports.selectorItemModel)(store.value, itemId);
            const newChildren = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(store.value, itemId);
            if (newChildren.length > 0) item.children = newChildren.map(getItemFromItemId);
            else delete item.children;
            return item;
        };
        return (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(store.value, null).map(getItemFromItemId);
    }, [
        store
    ]);
    const getItemOrderedChildrenIds = $105a531cf9fa8a7d$var$React.useCallback((itemId)=>(0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(store.value, itemId), [
        store
    ]);
    const getItemDOMElement = (itemId)=>{
        const itemMeta = (0, $4bf621410ffd294f$exports.selectorItemMeta)(store.value, itemId);
        if (itemMeta == null) return null;
        const idAttribute = (0, $93de18c67dbb3a30$exports.generateTreeItemIdAttribute)({
            treeId: (0, $8891880caf94d5b0$exports.selectorTreeViewId)(store.value),
            itemId: itemId,
            id: itemMeta.idAttribute
        });
        return document.getElementById(idAttribute);
    };
    const areItemUpdatesPreventedRef = $105a531cf9fa8a7d$var$React.useRef(false);
    const preventItemUpdates = $105a531cf9fa8a7d$var$React.useCallback(()=>{
        areItemUpdatesPreventedRef.current = true;
    }, []);
    const areItemUpdatesPrevented = $105a531cf9fa8a7d$var$React.useCallback(()=>areItemUpdatesPreventedRef.current, []);
    const addItems = ({ items: items, parentId: parentId, depth: depth, getChildrenCount: getChildrenCount })=>{
        if (items) {
            const newState = $105a531cf9fa8a7d$var$processItemsLookups({
                disabledItemsFocusable: params.disabledItemsFocusable,
                items: items,
                isItemDisabled: params.isItemDisabled,
                getItemId: params.getItemId,
                getItemLabel: params.getItemLabel,
                getChildrenCount: getChildrenCount,
                initialDepth: depth,
                initialParentId: parentId,
                ignoreChildren: true
            });
            store.update((prevState)=>{
                let newItems;
                if (parentId) newItems = {
                    itemModelLookup: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState.items.itemModelLookup, newState.itemModelLookup),
                    itemMetaLookup: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState.items.itemMetaLookup, newState.itemMetaLookup),
                    itemOrderedChildrenIdsLookup: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, newState.itemOrderedChildrenIdsLookup, prevState.items.itemOrderedChildrenIdsLookup),
                    itemChildrenIndexesLookup: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, newState.itemChildrenIndexesLookup, prevState.items.itemChildrenIndexesLookup)
                };
                else newItems = {
                    itemModelLookup: newState.itemModelLookup,
                    itemMetaLookup: newState.itemMetaLookup,
                    itemOrderedChildrenIdsLookup: newState.itemOrderedChildrenIdsLookup,
                    itemChildrenIndexesLookup: newState.itemChildrenIndexesLookup
                };
                Object.values(prevState.items.itemMetaLookup).forEach((item)=>{
                    if (!newState.itemMetaLookup[item.id]) (0, $1d486927ef52436a$exports.publishTreeViewEvent)(instance, 'removeItem', {
                        id: item.id
                    });
                });
                return (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState, {
                    items: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState.items, newItems)
                });
            });
        }
    };
    const removeChildren = (parentId)=>{
        store.update((prevState)=>{
            if (!parentId) return (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState, {
                items: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState.items, {
                    itemMetaLookup: {},
                    itemOrderedChildrenIdsLookup: {},
                    itemChildrenIndexesLookup: {}
                })
            });
            const newMetaMap = Object.keys(prevState.items.itemMetaLookup).reduce((acc, key)=>{
                const item = prevState.items.itemMetaLookup[key];
                if (item.parentId === parentId) {
                    (0, $1d486927ef52436a$exports.publishTreeViewEvent)(instance, 'removeItem', {
                        id: item.id
                    });
                    return acc;
                }
                return (0, $105a531cf9fa8a7d$var$_extends2.default)({}, acc, {
                    [item.id]: item
                });
            }, {});
            const newItemOrderedChildrenIdsLookup = prevState.items.itemOrderedChildrenIdsLookup;
            const newItemChildrenIndexesLookup = prevState.items.itemChildrenIndexesLookup;
            delete newItemChildrenIndexesLookup[parentId];
            delete newItemOrderedChildrenIdsLookup[parentId];
            return (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState, {
                items: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState.items, {
                    itemMetaLookup: newMetaMap,
                    itemOrderedChildrenIdsLookup: newItemOrderedChildrenIdsLookup,
                    itemChildrenIndexesLookup: newItemChildrenIndexesLookup
                })
            });
        });
    };
    $105a531cf9fa8a7d$var$React.useEffect(()=>{
        if (instance.areItemUpdatesPrevented()) return;
        store.update((prevState)=>{
            const newState = $105a531cf9fa8a7d$var$processItemsLookups({
                disabledItemsFocusable: params.disabledItemsFocusable,
                items: params.items,
                isItemDisabled: params.isItemDisabled,
                getItemId: params.getItemId,
                getItemLabel: params.getItemLabel
            });
            Object.values(prevState.items.itemMetaLookup).forEach((item)=>{
                if (!newState.itemMetaLookup[item.id]) (0, $1d486927ef52436a$exports.publishTreeViewEvent)(instance, 'removeItem', {
                    id: item.id
                });
            });
            return (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState, {
                items: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, prevState.items, newState)
            });
        });
    }, [
        instance,
        store,
        params.items,
        params.disabledItemsFocusable,
        params.isItemDisabled,
        params.getItemId,
        params.getItemLabel
    ]);
    // Wrap `props.onItemClick` with `useEventCallback` to prevent unneeded context updates.
    const handleItemClick = (0, $105a531cf9fa8a7d$var$_useEventCallback.default)((event, itemId)=>{
        if (params.onItemClick) params.onItemClick(event, itemId);
    });
    return {
        getRootProps: ()=>({
                style: {
                    '--TreeView-itemChildrenIndentation': typeof params.itemChildrenIndentation === 'number' ? `${params.itemChildrenIndentation}px` : params.itemChildrenIndentation
                }
            }),
        publicAPI: {
            getItem: getItem,
            getItemDOMElement: getItemDOMElement,
            getItemTree: getItemTree,
            getItemOrderedChildrenIds: getItemOrderedChildrenIds,
            setIsItemDisabled: setIsItemDisabled,
            getParentId: getParentId
        },
        instance: {
            getItemDOMElement: getItemDOMElement,
            preventItemUpdates: preventItemUpdates,
            areItemUpdatesPrevented: areItemUpdatesPrevented,
            addItems: addItems,
            setTreeViewLoading: setTreeViewLoading,
            setTreeViewError: setTreeViewError,
            removeChildren: removeChildren,
            handleItemClick: handleItemClick
        }
    };
};
$105a531cf9fa8a7d$exports.useTreeViewItems = $105a531cf9fa8a7d$var$useTreeViewItems;
$105a531cf9fa8a7d$var$useTreeViewItems.getInitialState = (params)=>({
        items: (0, $105a531cf9fa8a7d$var$_extends2.default)({}, $105a531cf9fa8a7d$var$processItemsLookups({
            disabledItemsFocusable: params.disabledItemsFocusable,
            items: params.items,
            isItemDisabled: params.isItemDisabled,
            getItemId: params.getItemId,
            getItemLabel: params.getItemLabel
        }), {
            loading: false,
            error: null
        })
    });
$105a531cf9fa8a7d$var$useTreeViewItems.getDefaultizedParams = ({ params: params })=>(0, $105a531cf9fa8a7d$var$_extends2.default)({}, params, {
        disabledItemsFocusable: params.disabledItemsFocusable ?? false,
        itemChildrenIndentation: params.itemChildrenIndentation ?? '12px'
    });
$105a531cf9fa8a7d$var$useTreeViewItems.wrapRoot = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kSbwP.jsx)($9404cf4078b79adc$exports.TreeViewItemDepthContext.Provider, {
        value: $4bf621410ffd294f$exports.selectorItemDepth,
        children: children
    });
};
$105a531cf9fa8a7d$var$useTreeViewItems.params = {
    disabledItemsFocusable: true,
    items: true,
    isItemDisabled: true,
    getItemLabel: true,
    getItemId: true,
    onItemClick: true,
    itemChildrenIndentation: true
};





var $bb3f97219f69a4af$exports = {};
"use strict";
Object.defineProperty($bb3f97219f69a4af$exports, "__esModule", {
    value: true
});
Object.defineProperty($bb3f97219f69a4af$exports, "useTreeViewExpansion", {
    enumerable: true,
    get: function() {
        return $32da8bcb3d57f104$exports.useTreeViewExpansion;
    }
});
var $32da8bcb3d57f104$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $32da8bcb3d57f104$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($32da8bcb3d57f104$exports, "__esModule", {
    value: true
});
$32da8bcb3d57f104$exports.useTreeViewExpansion = void 0;

var $32da8bcb3d57f104$var$_extends2 = $32da8bcb3d57f104$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $32da8bcb3d57f104$var$_useEventCallback = $32da8bcb3d57f104$require$_interopRequireDefault((parcelRequire("5xdHV")));

var $32da8bcb3d57f104$var$_useEnhancedEffect = $32da8bcb3d57f104$require$_interopRequireDefault((parcelRequire("jMi8t")));

var $9f0cee8be454cd94$exports = {};
"use strict";
Object.defineProperty($9f0cee8be454cd94$exports, "__esModule", {
    value: true
});
$9f0cee8be454cd94$exports.getExpansionTrigger = void 0;
const $9f0cee8be454cd94$var$getExpansionTrigger = ({ isItemEditable: isItemEditable, expansionTrigger: expansionTrigger })=>{
    if (expansionTrigger) return expansionTrigger;
    if (isItemEditable) return 'iconContainer';
    return 'content';
};
$9f0cee8be454cd94$exports.getExpansionTrigger = $9f0cee8be454cd94$var$getExpansionTrigger;




var $fa324c08752b24e3$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $fa324c08752b24e3$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($fa324c08752b24e3$exports, "__esModule", {
    value: true
});
$fa324c08752b24e3$exports.useAssertModelConsistency = void 0;
var $d73676d7d94c237f$exports = {};
"use strict";
Object.defineProperty($d73676d7d94c237f$exports, "__esModule", {
    value: true
});
Object.defineProperty($d73676d7d94c237f$exports, "clearWarningsCache", {
    enumerable: true,
    get: function() {
        return $5f159749fec4c9a6$exports.clearWarningsCache;
    }
});
Object.defineProperty($d73676d7d94c237f$exports, "warnOnce", {
    enumerable: true,
    get: function() {
        return $5f159749fec4c9a6$exports.warnOnce;
    }
});
var $5f159749fec4c9a6$exports = {};
"use strict";
Object.defineProperty($5f159749fec4c9a6$exports, "__esModule", {
    value: true
});
$5f159749fec4c9a6$exports.clearWarningsCache = $5f159749fec4c9a6$var$clearWarningsCache;
$5f159749fec4c9a6$exports.warnOnce = $5f159749fec4c9a6$var$warnOnce;
const $5f159749fec4c9a6$var$warnedOnceCache = new Set();
/**
 * Logs a message to the console on development mode. The warning will only be logged once.
 *
 * The message is the log's cache key. Two identical messages will only be logged once.
 *
 * This function is a no-op in production.
 *
 * @param message the message to log
 * @param gravity the gravity of the warning. Defaults to `'warning'`.
 * @returns
 */ function $5f159749fec4c9a6$var$warnOnce(message, gravity = 'warning') {
    return;
}
function $5f159749fec4c9a6$var$clearWarningsCache() {
    $5f159749fec4c9a6$var$warnedOnceCache.clear();
}





var $fa324c08752b24e3$var$React = $fa324c08752b24e3$require$_interopRequireWildcard((parcelRequire("8nGP5")));
function $fa324c08752b24e3$var$useAssertModelConsistencyOutsideOfProduction(parameters) {
    const { state: state, controlled: controlled, defaultValue: defaultValue } = parameters;
    const [{ initialDefaultValue: initialDefaultValue, isControlled: isControlled }] = $fa324c08752b24e3$var$React.useState({
        initialDefaultValue: defaultValue,
        isControlled: controlled !== undefined
    });
    if (isControlled !== (controlled !== undefined)) (0, $d73676d7d94c237f$exports.warnOnce)([
        `MUI X: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of Tree View to be ${isControlled ? 'un' : ''}controlled.`,
        'Elements should not switch from uncontrolled to controlled (or vice versa).',
        `Decide between using a controlled or uncontrolled ${state} ` + 'element for the lifetime of the component.',
        "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
        'More info: https://fb.me/react-controlled-components'
    ], 'error');
    if (JSON.stringify(initialDefaultValue) !== JSON.stringify(defaultValue)) (0, $d73676d7d94c237f$exports.warnOnce)([
        `MUI X: A component is changing the default ${state} state of an uncontrolled Tree View after being initialized. ` + `To suppress this warning opt to use a controlled Tree View.`
    ], 'error');
}
const $fa324c08752b24e3$var$useAssertModelConsistency = $fa324c08752b24e3$exports.useAssertModelConsistency = ()=>{};


const $32da8bcb3d57f104$var$useTreeViewExpansion = ({ instance: instance, store: store, params: params })=>{
    (0, $fa324c08752b24e3$exports.useAssertModelConsistency)({
        state: 'expandedItems',
        controlled: params.expandedItems,
        defaultValue: params.defaultExpandedItems
    });
    (0, $32da8bcb3d57f104$var$_useEnhancedEffect.default)(()=>{
        store.update((prevState)=>{
            const newExpansionTrigger = (0, $9f0cee8be454cd94$exports.getExpansionTrigger)({
                isItemEditable: params.isItemEditable,
                expansionTrigger: params.expansionTrigger
            });
            if (prevState.expansion.expansionTrigger === newExpansionTrigger) return prevState;
            return (0, $32da8bcb3d57f104$var$_extends2.default)({}, prevState, {
                expansion: (0, $32da8bcb3d57f104$var$_extends2.default)({}, prevState.expansion, {
                    expansionTrigger: newExpansionTrigger
                })
            });
        });
    }, [
        store,
        params.isItemEditable,
        params.expansionTrigger
    ]);
    const setExpandedItems = (event, value)=>{
        if (params.expandedItems === undefined) store.update((prevState)=>(0, $32da8bcb3d57f104$var$_extends2.default)({}, prevState, {
                expansion: (0, $32da8bcb3d57f104$var$_extends2.default)({}, prevState.expansion, {
                    expandedItems: value
                })
            }));
        params.onExpandedItemsChange?.(event, value);
    };
    const applyItemExpansion = (0, $32da8bcb3d57f104$var$_useEventCallback.default)(({ itemId: itemId, event: event, shouldBeExpanded: shouldBeExpanded })=>{
        const oldExpanded = (0, $78cc7d98a5cf23b4$exports.selectorExpandedItems)(store.value);
        let newExpanded;
        if (shouldBeExpanded) newExpanded = [
            itemId
        ].concat(oldExpanded);
        else newExpanded = oldExpanded.filter((id)=>id !== itemId);
        if (params.onItemExpansionToggle) params.onItemExpansionToggle(event, itemId, shouldBeExpanded);
        setExpandedItems(event, newExpanded);
    });
    const setItemExpansion = (0, $32da8bcb3d57f104$var$_useEventCallback.default)(({ itemId: itemId, event: event = null, shouldBeExpanded: shouldBeExpanded })=>{
        const isExpandedBefore = (0, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded)(store.value, itemId);
        const cleanShouldBeExpanded = shouldBeExpanded ?? !isExpandedBefore;
        if (isExpandedBefore === cleanShouldBeExpanded) return;
        const eventParameters = {
            isExpansionPrevented: false,
            shouldBeExpanded: cleanShouldBeExpanded,
            event: event,
            itemId: itemId
        };
        (0, $1d486927ef52436a$exports.publishTreeViewEvent)(instance, 'beforeItemToggleExpansion', eventParameters);
        if (eventParameters.isExpansionPrevented) return;
        instance.applyItemExpansion({
            itemId: itemId,
            event: event,
            shouldBeExpanded: cleanShouldBeExpanded
        });
    });
    const expandAllSiblings = (event, itemId)=>{
        const itemMeta = (0, $4bf621410ffd294f$exports.selectorItemMeta)(store.value, itemId);
        if (itemMeta == null) return;
        const siblings = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(store.value, itemMeta.parentId);
        const diff = siblings.filter((child)=>(0, $78cc7d98a5cf23b4$exports.selectorIsItemExpandable)(store.value, child) && !(0, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded)(store.value, child));
        const newExpanded = (0, $78cc7d98a5cf23b4$exports.selectorExpandedItems)(store.value).concat(diff);
        if (diff.length > 0) {
            if (params.onItemExpansionToggle) diff.forEach((newlyExpandedItemId)=>{
                params.onItemExpansionToggle(event, newlyExpandedItemId, true);
            });
            setExpandedItems(event, newExpanded);
        }
    };
    /**
   * Update the controlled model when the `expandedItems` prop changes.
   */ (0, $32da8bcb3d57f104$var$_useEnhancedEffect.default)(()=>{
        const expandedItems = params.expandedItems;
        if (expandedItems !== undefined) store.update((prevState)=>(0, $32da8bcb3d57f104$var$_extends2.default)({}, prevState, {
                expansion: (0, $32da8bcb3d57f104$var$_extends2.default)({}, prevState.expansion, {
                    expandedItems: expandedItems
                })
            }));
    }, [
        store,
        params.expandedItems
    ]);
    return {
        publicAPI: {
            setItemExpansion: setItemExpansion
        },
        instance: {
            setItemExpansion: setItemExpansion,
            applyItemExpansion: applyItemExpansion,
            expandAllSiblings: expandAllSiblings
        }
    };
};
$32da8bcb3d57f104$exports.useTreeViewExpansion = $32da8bcb3d57f104$var$useTreeViewExpansion;
const $32da8bcb3d57f104$var$DEFAULT_EXPANDED_ITEMS = [];
$32da8bcb3d57f104$var$useTreeViewExpansion.getDefaultizedParams = ({ params: params })=>(0, $32da8bcb3d57f104$var$_extends2.default)({}, params, {
        defaultExpandedItems: params.defaultExpandedItems ?? $32da8bcb3d57f104$var$DEFAULT_EXPANDED_ITEMS
    });
$32da8bcb3d57f104$var$useTreeViewExpansion.getInitialState = (params)=>({
        expansion: {
            expandedItems: params.expandedItems === undefined ? params.defaultExpandedItems : params.expandedItems,
            expansionTrigger: (0, $9f0cee8be454cd94$exports.getExpansionTrigger)(params)
        }
    });
$32da8bcb3d57f104$var$useTreeViewExpansion.params = {
    expandedItems: true,
    defaultExpandedItems: true,
    onExpandedItemsChange: true,
    onItemExpansionToggle: true,
    expansionTrigger: true
};




var $4a09efe287eb143c$exports = {};
"use strict";
Object.defineProperty($4a09efe287eb143c$exports, "__esModule", {
    value: true
});
Object.defineProperty($4a09efe287eb143c$exports, "useTreeViewSelection", {
    enumerable: true,
    get: function() {
        return $ad7506f8b178de75$exports.useTreeViewSelection;
    }
});
var $ad7506f8b178de75$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $ad7506f8b178de75$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $ad7506f8b178de75$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($ad7506f8b178de75$exports, "__esModule", {
    value: true
});
$ad7506f8b178de75$exports.useTreeViewSelection = void 0;

var $ad7506f8b178de75$var$_extends2 = $ad7506f8b178de75$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $ad7506f8b178de75$var$React = $ad7506f8b178de75$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $ad7506f8b178de75$var$_useEnhancedEffect = $ad7506f8b178de75$require$_interopRequireDefault((parcelRequire("jMi8t")));

var $37876495730532b2$exports = {};
"use strict";
Object.defineProperty($37876495730532b2$exports, "__esModule", {
    value: true
});
$37876495730532b2$exports.propagateSelection = $37876495730532b2$exports.getLookupFromArray = $37876495730532b2$exports.getAddedAndRemovedItems = void 0;


const $37876495730532b2$var$getLookupFromArray = (array)=>{
    const lookup = {};
    array.forEach((itemId)=>{
        lookup[itemId] = true;
    });
    return lookup;
};
$37876495730532b2$exports.getLookupFromArray = $37876495730532b2$var$getLookupFromArray;
const $37876495730532b2$var$getAddedAndRemovedItems = ({ store: store, oldModel: oldModel, newModel: newModel })=>{
    const newModelMap = new Map();
    newModel.forEach((id)=>{
        newModelMap.set(id, true);
    });
    return {
        added: newModel.filter((itemId)=>!(0, $88945f81c6be66ca$exports.selectorIsItemSelected)(store.value, itemId)),
        removed: oldModel.filter((itemId)=>!newModelMap.has(itemId))
    };
};
$37876495730532b2$exports.getAddedAndRemovedItems = $37876495730532b2$var$getAddedAndRemovedItems;
const $37876495730532b2$var$propagateSelection = ({ store: store, selectionPropagation: selectionPropagation, newModel: newModel, oldModel: oldModel, additionalItemsToPropagate: additionalItemsToPropagate })=>{
    if (!selectionPropagation.descendants && !selectionPropagation.parents) return newModel;
    let shouldRegenerateModel = false;
    const newModelLookup = $37876495730532b2$var$getLookupFromArray(newModel);
    const changes = $37876495730532b2$var$getAddedAndRemovedItems({
        store: store,
        newModel: newModel,
        oldModel: oldModel
    });
    additionalItemsToPropagate?.forEach((itemId)=>{
        if (newModelLookup[itemId]) {
            if (!changes.added.includes(itemId)) changes.added.push(itemId);
        } else if (!changes.removed.includes(itemId)) changes.removed.push(itemId);
    });
    changes.added.forEach((addedItemId)=>{
        if (selectionPropagation.descendants) {
            const selectDescendants = (itemId)=>{
                if (itemId !== addedItemId) {
                    shouldRegenerateModel = true;
                    newModelLookup[itemId] = true;
                }
                (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(store.value, itemId).forEach(selectDescendants);
            };
            selectDescendants(addedItemId);
        }
        if (selectionPropagation.parents) {
            const checkAllDescendantsSelected = (itemId)=>{
                if (!newModelLookup[itemId]) return false;
                const children = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(store.value, itemId);
                return children.every(checkAllDescendantsSelected);
            };
            const selectParents = (itemId)=>{
                const parentId = (0, $4bf621410ffd294f$exports.selectorItemParentId)(store.value, itemId);
                if (parentId == null) return;
                const siblings = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(store.value, parentId);
                if (siblings.every(checkAllDescendantsSelected)) {
                    shouldRegenerateModel = true;
                    newModelLookup[parentId] = true;
                    selectParents(parentId);
                }
            };
            selectParents(addedItemId);
        }
    });
    changes.removed.forEach((removedItemId)=>{
        if (selectionPropagation.parents) {
            let parentId = (0, $4bf621410ffd294f$exports.selectorItemParentId)(store.value, removedItemId);
            while(parentId != null){
                if (newModelLookup[parentId]) {
                    shouldRegenerateModel = true;
                    delete newModelLookup[parentId];
                }
                parentId = (0, $4bf621410ffd294f$exports.selectorItemParentId)(store.value, parentId);
            }
        }
        if (selectionPropagation.descendants) {
            const deSelectDescendants = (itemId)=>{
                if (itemId !== removedItemId) {
                    shouldRegenerateModel = true;
                    delete newModelLookup[itemId];
                }
                (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(store.value, itemId).forEach(deSelectDescendants);
            };
            deSelectDescendants(removedItemId);
        }
    });
    return shouldRegenerateModel ? Object.keys(newModelLookup) : newModel;
};
$37876495730532b2$exports.propagateSelection = $37876495730532b2$var$propagateSelection;



var $b7b1e3e5e8c20b7b$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b7b1e3e5e8c20b7b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($b7b1e3e5e8c20b7b$exports, "__esModule", {
    value: true
});
$b7b1e3e5e8c20b7b$exports.useTreeViewSelectionItemPlugin = void 0;

var $b7b1e3e5e8c20b7b$var$_extends2 = $b7b1e3e5e8c20b7b$require$_interopRequireDefault((parcelRequire("8tsi7")));
var $f0b064c06f5dfbf7$exports = {};
"use strict";
Object.defineProperty($f0b064c06f5dfbf7$exports, "__esModule", {
    value: true
});
Object.defineProperty($f0b064c06f5dfbf7$exports, "fastObjectShallowCompare", {
    enumerable: true,
    get: function() {
        return $c745bc340c5cfbe3$exports.fastObjectShallowCompare;
    }
});
var $c745bc340c5cfbe3$exports = {};
"use strict";
Object.defineProperty($c745bc340c5cfbe3$exports, "__esModule", {
    value: true
});
$c745bc340c5cfbe3$exports.fastObjectShallowCompare = $c745bc340c5cfbe3$var$fastObjectShallowCompare;
const $c745bc340c5cfbe3$var$is = Object.is;
/**
 * Fast shallow compare for objects.
 * @returns true if objects are equal.
 */ function $c745bc340c5cfbe3$var$fastObjectShallowCompare(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    /* eslint-disable guard-for-in */ for(const key in a){
        aLength += 1;
        if (!$c745bc340c5cfbe3$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */ for(const _ in b)bLength += 1;
    return aLength === bLength;
}








function $b7b1e3e5e8c20b7b$var$selectorItemCheckboxStatus(state, itemId) {
    const isCheckboxSelectionEnabled = (0, $88945f81c6be66ca$exports.selectorIsCheckboxSelectionEnabled)(state);
    const isSelectionEnabledForItem = (0, $88945f81c6be66ca$exports.selectorIsItemSelectionEnabled)(state, itemId);
    if ((0, $88945f81c6be66ca$exports.selectorIsItemSelected)(state, itemId)) return {
        disabled: !isSelectionEnabledForItem,
        visible: isCheckboxSelectionEnabled,
        indeterminate: false,
        checked: true
    };
    const children = (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, itemId);
    if (children.length === 0) return {
        disabled: !isSelectionEnabledForItem,
        visible: isCheckboxSelectionEnabled,
        indeterminate: false,
        checked: false
    };
    let hasSelectedDescendant = false;
    let hasUnSelectedDescendant = false;
    const traverseDescendants = (itemToTraverseId)=>{
        if (itemToTraverseId !== itemId) {
            if ((0, $88945f81c6be66ca$exports.selectorIsItemSelected)(state, itemToTraverseId)) hasSelectedDescendant = true;
            else hasUnSelectedDescendant = true;
        }
        (0, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds)(state, itemToTraverseId).forEach(traverseDescendants);
    };
    traverseDescendants(itemId);
    return {
        disabled: !isSelectionEnabledForItem,
        visible: isCheckboxSelectionEnabled,
        indeterminate: hasSelectedDescendant && hasUnSelectedDescendant,
        checked: (0, $88945f81c6be66ca$exports.selectorSelectionPropagationRules)(state).parents ? hasSelectedDescendant && !hasUnSelectedDescendant : false
    };
}
const $b7b1e3e5e8c20b7b$var$useTreeViewSelectionItemPlugin = ({ props: props })=>{
    const { itemId: itemId } = props;
    const { store: store } = (0, $33114ec9c2f70325$exports.useTreeViewContext)();
    const checkboxStatus = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $b7b1e3e5e8c20b7b$var$selectorItemCheckboxStatus, itemId, $f0b064c06f5dfbf7$exports.fastObjectShallowCompare);
    return {
        propsEnhancers: {
            checkbox: ({ externalEventHandlers: externalEventHandlers, interactions: interactions })=>{
                const handleChange = (event)=>{
                    externalEventHandlers.onChange?.(event);
                    if (event.defaultMuiPrevented) return;
                    if (!(0, $88945f81c6be66ca$exports.selectorIsItemSelectionEnabled)(store.value, itemId)) return;
                    interactions.handleCheckboxSelection(event);
                };
                return (0, $b7b1e3e5e8c20b7b$var$_extends2.default)({
                    tabIndex: -1,
                    onChange: handleChange
                }, checkboxStatus);
            }
        }
    };
};
$b7b1e3e5e8c20b7b$exports.useTreeViewSelectionItemPlugin = $b7b1e3e5e8c20b7b$var$useTreeViewSelectionItemPlugin;



const $ad7506f8b178de75$var$useTreeViewSelection = ({ store: store, params: params })=>{
    (0, $fa324c08752b24e3$exports.useAssertModelConsistency)({
        state: 'selectedItems',
        controlled: params.selectedItems,
        defaultValue: params.defaultSelectedItems
    });
    const lastSelectedItem = $ad7506f8b178de75$var$React.useRef(null);
    const lastSelectedRange = $ad7506f8b178de75$var$React.useRef({});
    const setSelectedItems = (event, newModel, additionalItemsToPropagate)=>{
        const oldModel = (0, $88945f81c6be66ca$exports.selectorSelectionModel)(store.value);
        let cleanModel;
        const isMultiSelectEnabled = (0, $88945f81c6be66ca$exports.selectorIsMultiSelectEnabled)(store.value);
        if (isMultiSelectEnabled && (params.selectionPropagation.descendants || params.selectionPropagation.parents)) cleanModel = (0, $37876495730532b2$exports.propagateSelection)({
            store: store,
            selectionPropagation: params.selectionPropagation,
            newModel: newModel,
            oldModel: oldModel,
            additionalItemsToPropagate: additionalItemsToPropagate
        });
        else cleanModel = newModel;
        if (params.onItemSelectionToggle) {
            if (isMultiSelectEnabled) {
                const changes = (0, $37876495730532b2$exports.getAddedAndRemovedItems)({
                    store: store,
                    newModel: cleanModel,
                    oldModel: oldModel
                });
                if (params.onItemSelectionToggle) {
                    changes.added.forEach((itemId)=>{
                        params.onItemSelectionToggle(event, itemId, true);
                    });
                    changes.removed.forEach((itemId)=>{
                        params.onItemSelectionToggle(event, itemId, false);
                    });
                }
            } else if (params.onItemSelectionToggle && cleanModel !== oldModel) {
                if (oldModel != null) params.onItemSelectionToggle(event, oldModel, false);
                if (cleanModel != null) params.onItemSelectionToggle(event, cleanModel, true);
            }
        }
        if (params.selectedItems === undefined) store.update((prevState)=>(0, $ad7506f8b178de75$var$_extends2.default)({}, prevState, {
                selection: (0, $ad7506f8b178de75$var$_extends2.default)({}, prevState.selection, {
                    selectedItems: cleanModel
                })
            }));
        params.onSelectedItemsChange?.(event, cleanModel);
    };
    const setItemSelection = ({ itemId: itemId, event: event = null, keepExistingSelection: keepExistingSelection = false, shouldBeSelected: shouldBeSelected })=>{
        if (!(0, $88945f81c6be66ca$exports.selectorIsSelectionEnabled)(store.value)) return;
        let newSelected;
        const isMultiSelectEnabled = (0, $88945f81c6be66ca$exports.selectorIsMultiSelectEnabled)(store.value);
        if (keepExistingSelection) {
            const oldSelected = (0, $88945f81c6be66ca$exports.selectorSelectionModelArray)(store.value);
            const isSelectedBefore = (0, $88945f81c6be66ca$exports.selectorIsItemSelected)(store.value, itemId);
            if (isSelectedBefore && (shouldBeSelected === false || shouldBeSelected == null)) newSelected = oldSelected.filter((id)=>id !== itemId);
            else if (!isSelectedBefore && (shouldBeSelected === true || shouldBeSelected == null)) newSelected = [
                itemId
            ].concat(oldSelected);
            else newSelected = oldSelected;
        } else // eslint-disable-next-line no-lonely-if
        if (shouldBeSelected === false || shouldBeSelected == null && (0, $88945f81c6be66ca$exports.selectorIsItemSelected)(store.value, itemId)) newSelected = isMultiSelectEnabled ? [] : null;
        else newSelected = isMultiSelectEnabled ? [
            itemId
        ] : itemId;
        setSelectedItems(event, newSelected, // If shouldBeSelected === selectorIsItemSelected(store, itemId), we still want to propagate the select.
        // This is useful when the element is in an indeterminate state.
        [
            itemId
        ]);
        lastSelectedItem.current = itemId;
        lastSelectedRange.current = {};
    };
    const selectRange = (event, [start, end])=>{
        const isMultiSelectEnabled = (0, $88945f81c6be66ca$exports.selectorIsMultiSelectEnabled)(store.value);
        if (!isMultiSelectEnabled) return;
        let newSelectedItems = (0, $88945f81c6be66ca$exports.selectorSelectionModelArray)(store.value).slice();
        // If the last selection was a range selection,
        // remove the items that were part of the last range from the model
        if (Object.keys(lastSelectedRange.current).length > 0) newSelectedItems = newSelectedItems.filter((id)=>!lastSelectedRange.current[id]);
        // Add to the model the items that are part of the new range and not already part of the model.
        const selectedItemsLookup = (0, $37876495730532b2$exports.getLookupFromArray)(newSelectedItems);
        const range = (0, $a47de7ff1c218ad9$exports.getNonDisabledItemsInRange)(store.value, start, end);
        const itemsToAddToModel = range.filter((id)=>!selectedItemsLookup[id]);
        newSelectedItems = newSelectedItems.concat(itemsToAddToModel);
        setSelectedItems(event, newSelectedItems);
        lastSelectedRange.current = (0, $37876495730532b2$exports.getLookupFromArray)(range);
    };
    const expandSelectionRange = (event, itemId)=>{
        if (lastSelectedItem.current != null) {
            const [start, end] = (0, $a47de7ff1c218ad9$exports.findOrderInTremauxTree)(store.value, itemId, lastSelectedItem.current);
            selectRange(event, [
                start,
                end
            ]);
        }
    };
    const selectRangeFromStartToItem = (event, itemId)=>{
        selectRange(event, [
            (0, $a47de7ff1c218ad9$exports.getFirstNavigableItem)(store.value),
            itemId
        ]);
    };
    const selectRangeFromItemToEnd = (event, itemId)=>{
        selectRange(event, [
            itemId,
            (0, $a47de7ff1c218ad9$exports.getLastNavigableItem)(store.value)
        ]);
    };
    const selectAllNavigableItems = (event)=>{
        const isMultiSelectEnabled = (0, $88945f81c6be66ca$exports.selectorIsMultiSelectEnabled)(store.value);
        if (!isMultiSelectEnabled) return;
        const navigableItems = (0, $a47de7ff1c218ad9$exports.getAllNavigableItems)(store.value);
        setSelectedItems(event, navigableItems);
        lastSelectedRange.current = (0, $37876495730532b2$exports.getLookupFromArray)(navigableItems);
    };
    const selectItemFromArrowNavigation = (event, currentItem, nextItem)=>{
        const isMultiSelectEnabled = (0, $88945f81c6be66ca$exports.selectorIsMultiSelectEnabled)(store.value);
        if (!isMultiSelectEnabled) return;
        let newSelectedItems = (0, $88945f81c6be66ca$exports.selectorSelectionModelArray)(store.value).slice();
        if (Object.keys(lastSelectedRange.current).length === 0) {
            newSelectedItems.push(nextItem);
            lastSelectedRange.current = {
                [currentItem]: true,
                [nextItem]: true
            };
        } else {
            if (!lastSelectedRange.current[currentItem]) lastSelectedRange.current = {};
            if (lastSelectedRange.current[nextItem]) {
                newSelectedItems = newSelectedItems.filter((id)=>id !== currentItem);
                delete lastSelectedRange.current[currentItem];
            } else {
                newSelectedItems.push(nextItem);
                lastSelectedRange.current[nextItem] = true;
            }
        }
        setSelectedItems(event, newSelectedItems);
    };
    (0, $ad7506f8b178de75$var$_useEnhancedEffect.default)(()=>{
        store.update((prevState)=>(0, $ad7506f8b178de75$var$_extends2.default)({}, prevState, {
                selection: {
                    selectedItems: params.selectedItems === undefined ? prevState.selection.selectedItems : params.selectedItems,
                    isEnabled: !params.disableSelection,
                    isMultiSelectEnabled: params.multiSelect,
                    isCheckboxSelectionEnabled: params.checkboxSelection,
                    selectionPropagation: {
                        descendants: params.selectionPropagation.descendants,
                        parents: params.selectionPropagation.parents
                    }
                }
            }));
    }, [
        store,
        params.selectedItems,
        params.multiSelect,
        params.checkboxSelection,
        params.disableSelection,
        params.selectionPropagation.descendants,
        params.selectionPropagation.parents
    ]);
    return {
        getRootProps: ()=>({
                'aria-multiselectable': params.multiSelect
            }),
        publicAPI: {
            setItemSelection: setItemSelection
        },
        instance: {
            setItemSelection: setItemSelection,
            selectAllNavigableItems: selectAllNavigableItems,
            expandSelectionRange: expandSelectionRange,
            selectRangeFromStartToItem: selectRangeFromStartToItem,
            selectRangeFromItemToEnd: selectRangeFromItemToEnd,
            selectItemFromArrowNavigation: selectItemFromArrowNavigation
        }
    };
};
$ad7506f8b178de75$exports.useTreeViewSelection = $ad7506f8b178de75$var$useTreeViewSelection;
$ad7506f8b178de75$var$useTreeViewSelection.itemPlugin = $b7b1e3e5e8c20b7b$exports.useTreeViewSelectionItemPlugin;
const $ad7506f8b178de75$var$DEFAULT_SELECTED_ITEMS = [];
const $ad7506f8b178de75$var$EMPTY_SELECTION_PROPAGATION = {};
$ad7506f8b178de75$var$useTreeViewSelection.getDefaultizedParams = ({ params: params })=>(0, $ad7506f8b178de75$var$_extends2.default)({}, params, {
        disableSelection: params.disableSelection ?? false,
        multiSelect: params.multiSelect ?? false,
        checkboxSelection: params.checkboxSelection ?? false,
        defaultSelectedItems: params.defaultSelectedItems ?? (params.multiSelect ? $ad7506f8b178de75$var$DEFAULT_SELECTED_ITEMS : null),
        selectionPropagation: params.selectionPropagation ?? $ad7506f8b178de75$var$EMPTY_SELECTION_PROPAGATION
    });
$ad7506f8b178de75$var$useTreeViewSelection.getInitialState = (params)=>({
        selection: {
            selectedItems: params.selectedItems === undefined ? params.defaultSelectedItems : params.selectedItems,
            isEnabled: !params.disableSelection,
            isMultiSelectEnabled: params.multiSelect,
            isCheckboxSelectionEnabled: params.checkboxSelection,
            selectionPropagation: params.selectionPropagation
        }
    });
$ad7506f8b178de75$var$useTreeViewSelection.params = {
    disableSelection: true,
    multiSelect: true,
    checkboxSelection: true,
    defaultSelectedItems: true,
    selectedItems: true,
    onSelectedItemsChange: true,
    onItemSelectionToggle: true,
    selectionPropagation: true
};




var $955b1075fa22554c$exports = {};
"use strict";
Object.defineProperty($955b1075fa22554c$exports, "__esModule", {
    value: true
});
Object.defineProperty($955b1075fa22554c$exports, "useTreeViewFocus", {
    enumerable: true,
    get: function() {
        return $39e8e814e540874e$exports.useTreeViewFocus;
    }
});
var $39e8e814e540874e$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $39e8e814e540874e$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($39e8e814e540874e$exports, "__esModule", {
    value: true
});
$39e8e814e540874e$exports.useTreeViewFocus = void 0;

var $39e8e814e540874e$var$_extends2 = $39e8e814e540874e$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $39e8e814e540874e$var$_useEventCallback = $39e8e814e540874e$require$_interopRequireDefault((parcelRequire("5xdHV")));
var $2d2047c0242b0fe6$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $2d2047c0242b0fe6$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($2d2047c0242b0fe6$exports, "__esModule", {
    value: true
});
$2d2047c0242b0fe6$exports.createUseInstanceEventHandler = $2d2047c0242b0fe6$var$createUseInstanceEventHandler;
$2d2047c0242b0fe6$exports.useInstanceEventHandler = $2d2047c0242b0fe6$exports.unstable_resetCleanupTracking = void 0;

var $2d2047c0242b0fe6$var$React = $2d2047c0242b0fe6$require$_interopRequireWildcard((parcelRequire("8nGP5")));
var $b3b94d2af6b2d6b1$exports = {};
"use strict";
Object.defineProperty($b3b94d2af6b2d6b1$exports, "__esModule", {
    value: true
});
$b3b94d2af6b2d6b1$exports.TimerBasedCleanupTracking = void 0;
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $b3b94d2af6b2d6b1$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $b3b94d2af6b2d6b1$var$TimerBasedCleanupTracking {
    constructor(timeout = $b3b94d2af6b2d6b1$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = $b3b94d2af6b2d6b1$var$CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}
$b3b94d2af6b2d6b1$exports.TimerBasedCleanupTracking = $b3b94d2af6b2d6b1$var$TimerBasedCleanupTracking;


var $ddb64aa770cc81d7$exports = {};
"use strict";
Object.defineProperty($ddb64aa770cc81d7$exports, "__esModule", {
    value: true
});
$ddb64aa770cc81d7$exports.FinalizationRegistryBasedCleanupTracking = void 0;
class $ddb64aa770cc81d7$var$FinalizationRegistryBasedCleanupTracking {
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === 'function') unsubscribe();
        });
    }
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    // eslint-disable-next-line class-methods-use-this
    reset() {}
}
$ddb64aa770cc81d7$exports.FinalizationRegistryBasedCleanupTracking = $ddb64aa770cc81d7$var$FinalizationRegistryBasedCleanupTracking;


// We use class to make it easier to detect in heap snapshots by name
class $2d2047c0242b0fe6$var$ObjectToBeRetainedByReact {
}
// Based on https://github.com/Bnaya/use-dispose-uncommitted/blob/main/src/finalization-registry-based-impl.ts
// Check https://github.com/facebook/react/issues/15317 to get more information
function $2d2047c0242b0fe6$var$createUseInstanceEventHandler(registryContainer) {
    let cleanupTokensCounter = 0;
    return function useInstanceEventHandler(instance, eventName, handler) {
        if (registryContainer.registry === null) registryContainer.registry = typeof FinalizationRegistry !== 'undefined' ? new $ddb64aa770cc81d7$exports.FinalizationRegistryBasedCleanupTracking() : new $b3b94d2af6b2d6b1$exports.TimerBasedCleanupTracking();
        const [objectRetainedByReact] = $2d2047c0242b0fe6$var$React.useState(new $2d2047c0242b0fe6$var$ObjectToBeRetainedByReact());
        const subscription = $2d2047c0242b0fe6$var$React.useRef(null);
        const handlerRef = $2d2047c0242b0fe6$var$React.useRef(undefined);
        handlerRef.current = handler;
        const cleanupTokenRef = $2d2047c0242b0fe6$var$React.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event)=>{
                if (!event.defaultMuiPrevented) handlerRef.current?.(params, event);
            };
            subscription.current = instance.$$subscribeEvent(eventName, enhancedHandler);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
            ()=>{
                subscription.current?.();
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        $2d2047c0242b0fe6$var$React.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event)=>{
                    if (!event.defaultMuiPrevented) handlerRef.current?.(params, event);
                };
                subscription.current = instance.$$subscribeEvent(eventName, enhancedHandler);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                // If the effect was called, it means that this render was committed
                // so we can trust the cleanup function to remove the listener.
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                subscription.current?.();
                subscription.current = null;
            };
        }, [
            instance,
            eventName
        ]);
    };
}
const $2d2047c0242b0fe6$var$registryContainer = {
    registry: null
};
// eslint-disable-next-line @typescript-eslint/naming-convention
const $2d2047c0242b0fe6$var$unstable_resetCleanupTracking = ()=>{
    $2d2047c0242b0fe6$var$registryContainer.registry?.reset();
    $2d2047c0242b0fe6$var$registryContainer.registry = null;
};
$2d2047c0242b0fe6$exports.unstable_resetCleanupTracking = $2d2047c0242b0fe6$var$unstable_resetCleanupTracking;
const $2d2047c0242b0fe6$var$useInstanceEventHandler = $2d2047c0242b0fe6$exports.useInstanceEventHandler = $2d2047c0242b0fe6$var$createUseInstanceEventHandler($2d2047c0242b0fe6$var$registryContainer);





const $39e8e814e540874e$var$useTreeViewFocus = ({ instance: instance, params: params, store: store })=>{
    const setFocusedItemId = (0, $39e8e814e540874e$var$_useEventCallback.default)((itemId)=>{
        store.update((prevState)=>{
            const focusedItemId = (0, $adfd4ba063607d91$exports.selectorFocusedItemId)(prevState);
            if (focusedItemId === itemId) return prevState;
            return (0, $39e8e814e540874e$var$_extends2.default)({}, prevState, {
                focus: (0, $39e8e814e540874e$var$_extends2.default)({}, prevState.focus, {
                    focusedItemId: itemId
                })
            });
        });
    });
    const isItemVisible = (itemId)=>{
        const itemMeta = (0, $4bf621410ffd294f$exports.selectorItemMeta)(store.value, itemId);
        return itemMeta && (itemMeta.parentId == null || (0, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded)(store.value, itemMeta.parentId));
    };
    const innerFocusItem = (event, itemId)=>{
        const itemElement = instance.getItemDOMElement(itemId);
        if (itemElement) itemElement.focus();
        setFocusedItemId(itemId);
        if (params.onItemFocus) params.onItemFocus(event, itemId);
    };
    const focusItem = (0, $39e8e814e540874e$var$_useEventCallback.default)((event, itemId)=>{
        // If we receive an itemId, and it is visible, the focus will be set to it
        if (isItemVisible(itemId)) innerFocusItem(event, itemId);
    });
    const removeFocusedItem = (0, $39e8e814e540874e$var$_useEventCallback.default)(()=>{
        const focusedItemId = (0, $adfd4ba063607d91$exports.selectorFocusedItemId)(store.value);
        if (focusedItemId == null) return;
        const itemMeta = (0, $4bf621410ffd294f$exports.selectorItemMeta)(store.value, focusedItemId);
        if (itemMeta) {
            const itemElement = instance.getItemDOMElement(focusedItemId);
            if (itemElement) itemElement.blur();
        }
        setFocusedItemId(null);
    });
    (0, $2d2047c0242b0fe6$exports.useInstanceEventHandler)(instance, 'removeItem', ({ id: id })=>{
        const focusedItemId = (0, $adfd4ba063607d91$exports.selectorFocusedItemId)(store.value);
        const defaultFocusableItemId = (0, $adfd4ba063607d91$exports.selectorDefaultFocusableItemId)(store.value);
        if (focusedItemId === id && defaultFocusableItemId != null) innerFocusItem(null, defaultFocusableItemId);
    });
    const createRootHandleFocus = (otherHandlers)=>(event)=>{
            otherHandlers.onFocus?.(event);
            if (event.defaultMuiPrevented) return;
            // if the event bubbled (which is React specific) we don't want to steal focus
            const defaultFocusableItemId = (0, $adfd4ba063607d91$exports.selectorDefaultFocusableItemId)(store.value);
            if (event.target === event.currentTarget && defaultFocusableItemId != null) innerFocusItem(event, defaultFocusableItemId);
        };
    const createRootHandleBlur = (otherHandlers)=>(event)=>{
            otherHandlers.onBlur?.(event);
            if (event.defaultMuiPrevented) return;
            setFocusedItemId(null);
        };
    return {
        getRootProps: (otherHandlers)=>({
                onFocus: createRootHandleFocus(otherHandlers),
                onBlur: createRootHandleBlur(otherHandlers)
            }),
        publicAPI: {
            focusItem: focusItem
        },
        instance: {
            focusItem: focusItem,
            removeFocusedItem: removeFocusedItem
        }
    };
};
$39e8e814e540874e$exports.useTreeViewFocus = $39e8e814e540874e$var$useTreeViewFocus;
$39e8e814e540874e$var$useTreeViewFocus.getInitialState = ()=>({
        focus: {
            focusedItemId: null
        }
    });
$39e8e814e540874e$var$useTreeViewFocus.params = {
    onItemFocus: true
};




var $8ce1f98186cb2bad$exports = {};
"use strict";
Object.defineProperty($8ce1f98186cb2bad$exports, "__esModule", {
    value: true
});
Object.defineProperty($8ce1f98186cb2bad$exports, "useTreeViewKeyboardNavigation", {
    enumerable: true,
    get: function() {
        return $465a39a1c33e677a$exports.useTreeViewKeyboardNavigation;
    }
});
var $465a39a1c33e677a$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $465a39a1c33e677a$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $465a39a1c33e677a$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($465a39a1c33e677a$exports, "__esModule", {
    value: true
});
$465a39a1c33e677a$exports.useTreeViewKeyboardNavigation = void 0;

var $465a39a1c33e677a$var$React = $465a39a1c33e677a$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $KFXJz = parcelRequire("KFXJz");

var $465a39a1c33e677a$var$_useEventCallback = $465a39a1c33e677a$require$_interopRequireDefault((parcelRequire("5xdHV")));








function $465a39a1c33e677a$var$isPrintableKey(string) {
    return !!string && string.length === 1 && !!string.match(/\S/);
}
const $465a39a1c33e677a$var$useTreeViewKeyboardNavigation = ({ instance: instance, store: store, params: params })=>{
    const isRtl = (0, $KFXJz.useRtl)();
    const firstCharMap = $465a39a1c33e677a$var$React.useRef({});
    const updateFirstCharMap = (0, $465a39a1c33e677a$var$_useEventCallback.default)((callback)=>{
        firstCharMap.current = callback(firstCharMap.current);
    });
    const itemMetaLookup = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $4bf621410ffd294f$exports.selectorItemMetaLookup);
    $465a39a1c33e677a$var$React.useEffect(()=>{
        if (instance.areItemUpdatesPrevented()) return;
        const newFirstCharMap = {};
        const processItem = (item)=>{
            newFirstCharMap[item.id] = item.label.substring(0, 1).toLowerCase();
        };
        Object.values(itemMetaLookup).forEach(processItem);
        firstCharMap.current = newFirstCharMap;
    }, [
        itemMetaLookup,
        params.getItemId,
        instance
    ]);
    const getFirstMatchingItem = (itemId, query)=>{
        const cleanQuery = query.toLowerCase();
        const getNextItem = (itemIdToCheck)=>{
            const nextItemId = (0, $a47de7ff1c218ad9$exports.getNextNavigableItem)(store.value, itemIdToCheck);
            // We reached the end of the tree, check from the beginning
            if (nextItemId === null) return (0, $a47de7ff1c218ad9$exports.getFirstNavigableItem)(store.value);
            return nextItemId;
        };
        let matchingItemId = null;
        let currentItemId = getNextItem(itemId);
        const checkedItems = {};
        // The "!checkedItems[currentItemId]" condition avoids an infinite loop when there is no matching item.
        while(matchingItemId == null && !checkedItems[currentItemId])if (firstCharMap.current[currentItemId] === cleanQuery) matchingItemId = currentItemId;
        else {
            checkedItems[currentItemId] = true;
            currentItemId = getNextItem(currentItemId);
        }
        return matchingItemId;
    };
    const canToggleItemSelection = (itemId)=>(0, $88945f81c6be66ca$exports.selectorIsSelectionEnabled)(store.value) && !(0, $4bf621410ffd294f$exports.selectorIsItemDisabled)(store.value, itemId);
    const canToggleItemExpansion = (itemId)=>{
        return !(0, $4bf621410ffd294f$exports.selectorIsItemDisabled)(store.value, itemId) && (0, $78cc7d98a5cf23b4$exports.selectorIsItemExpandable)(store.value, itemId);
    };
    // ARIA specification: https://www.w3.org/WAI/ARIA/apg/patterns/treeview/#keyboardinteraction
    const handleItemKeyDown = async (event, itemId)=>{
        if (event.defaultMuiPrevented) return;
        if (event.altKey || (0, $a47de7ff1c218ad9$exports.isTargetInDescendants)(event.target, event.currentTarget)) return;
        const ctrlPressed = event.ctrlKey || event.metaKey;
        const key = event.key;
        const isMultiSelectEnabled = (0, $88945f81c6be66ca$exports.selectorIsMultiSelectEnabled)(store.value);
        // eslint-disable-next-line default-case
        switch(true){
            // Select the item when pressing "Space"
            case key === ' ' && canToggleItemSelection(itemId):
                event.preventDefault();
                if (isMultiSelectEnabled && event.shiftKey) instance.expandSelectionRange(event, itemId);
                else instance.setItemSelection({
                    event: event,
                    itemId: itemId,
                    keepExistingSelection: isMultiSelectEnabled,
                    shouldBeSelected: undefined
                });
                break;
            // If the focused item has children, we expand it.
            // If the focused item has no children, we select it.
            case key === 'Enter':
                if ((0, $d8bebe0ab57a7f3c$exports.hasPlugin)(instance, $8407f8bcbbd0da1e$exports.useTreeViewLabel) && (0, $d01956c8abb69943$exports.selectorIsItemEditable)(store.value, itemId) && !(0, $d01956c8abb69943$exports.selectorIsItemBeingEdited)(store.value, itemId)) instance.setEditedItemId(itemId);
                else if (canToggleItemExpansion(itemId)) {
                    instance.setItemExpansion({
                        event: event,
                        itemId: itemId
                    });
                    event.preventDefault();
                } else if (canToggleItemSelection(itemId)) {
                    if (isMultiSelectEnabled) {
                        event.preventDefault();
                        instance.setItemSelection({
                            event: event,
                            itemId: itemId,
                            keepExistingSelection: true
                        });
                    } else if (!(0, $88945f81c6be66ca$exports.selectorIsItemSelected)(store.value, itemId)) {
                        instance.setItemSelection({
                            event: event,
                            itemId: itemId
                        });
                        event.preventDefault();
                    }
                }
                break;
            // Focus the next focusable item
            case key === 'ArrowDown':
                {
                    const nextItem = (0, $a47de7ff1c218ad9$exports.getNextNavigableItem)(store.value, itemId);
                    if (nextItem) {
                        event.preventDefault();
                        instance.focusItem(event, nextItem);
                        // Multi select behavior when pressing Shift + ArrowDown
                        // Toggles the selection state of the next item
                        if (isMultiSelectEnabled && event.shiftKey && canToggleItemSelection(nextItem)) instance.selectItemFromArrowNavigation(event, itemId, nextItem);
                    }
                    break;
                }
            // Focuses the previous focusable item
            case key === 'ArrowUp':
                {
                    const previousItem = (0, $a47de7ff1c218ad9$exports.getPreviousNavigableItem)(store.value, itemId);
                    if (previousItem) {
                        event.preventDefault();
                        instance.focusItem(event, previousItem);
                        // Multi select behavior when pressing Shift + ArrowUp
                        // Toggles the selection state of the previous item
                        if (isMultiSelectEnabled && event.shiftKey && canToggleItemSelection(previousItem)) instance.selectItemFromArrowNavigation(event, itemId, previousItem);
                    }
                    break;
                }
            // If the focused item is expanded, we move the focus to its first child
            // If the focused item is collapsed and has children, we expand it
            case key === 'ArrowRight' && !isRtl || key === 'ArrowLeft' && isRtl:
                if (ctrlPressed) return;
                if ((0, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded)(store.value, itemId)) {
                    const nextItemId = (0, $a47de7ff1c218ad9$exports.getNextNavigableItem)(store.value, itemId);
                    if (nextItemId) {
                        instance.focusItem(event, nextItemId);
                        event.preventDefault();
                    }
                } else if (canToggleItemExpansion(itemId)) {
                    instance.setItemExpansion({
                        event: event,
                        itemId: itemId
                    });
                    event.preventDefault();
                }
                break;
            // If the focused item is expanded, we collapse it
            // If the focused item is collapsed and has a parent, we move the focus to this parent
            case key === 'ArrowLeft' && !isRtl || key === 'ArrowRight' && isRtl:
                if (ctrlPressed) return;
                if (canToggleItemExpansion(itemId) && (0, $78cc7d98a5cf23b4$exports.selectorIsItemExpanded)(store.value, itemId)) {
                    instance.setItemExpansion({
                        event: event,
                        itemId: itemId
                    });
                    event.preventDefault();
                } else {
                    const parent = (0, $4bf621410ffd294f$exports.selectorItemParentId)(store.value, itemId);
                    if (parent) {
                        instance.focusItem(event, parent);
                        event.preventDefault();
                    }
                }
                break;
            // Focuses the first item in the tree
            case key === 'Home':
                // Multi select behavior when pressing Ctrl + Shift + Home
                // Selects the focused item and all items up to the first item.
                if (canToggleItemSelection(itemId) && isMultiSelectEnabled && ctrlPressed && event.shiftKey) instance.selectRangeFromStartToItem(event, itemId);
                else instance.focusItem(event, (0, $a47de7ff1c218ad9$exports.getFirstNavigableItem)(store.value));
                event.preventDefault();
                break;
            // Focuses the last item in the tree
            case key === 'End':
                // Multi select behavior when pressing Ctrl + Shirt + End
                // Selects the focused item and all the items down to the last item.
                if (canToggleItemSelection(itemId) && isMultiSelectEnabled && ctrlPressed && event.shiftKey) instance.selectRangeFromItemToEnd(event, itemId);
                else instance.focusItem(event, (0, $a47de7ff1c218ad9$exports.getLastNavigableItem)(store.value));
                event.preventDefault();
                break;
            // Expand all siblings that are at the same level as the focused item
            case key === '*':
                instance.expandAllSiblings(event, itemId);
                event.preventDefault();
                break;
            // Multi select behavior when pressing Ctrl + a
            // Selects all the items
            case String.fromCharCode(event.keyCode) === 'A' && ctrlPressed && isMultiSelectEnabled && (0, $88945f81c6be66ca$exports.selectorIsSelectionEnabled)(store.value):
                instance.selectAllNavigableItems(event);
                event.preventDefault();
                break;
            // Type-ahead
            // TODO: Support typing multiple characters
            case !ctrlPressed && !event.shiftKey && $465a39a1c33e677a$var$isPrintableKey(key):
                {
                    const matchingItem = getFirstMatchingItem(itemId, key);
                    if (matchingItem != null) {
                        instance.focusItem(event, matchingItem);
                        event.preventDefault();
                    }
                    break;
                }
        }
    };
    return {
        instance: {
            updateFirstCharMap: updateFirstCharMap,
            handleItemKeyDown: handleItemKeyDown
        }
    };
};
$465a39a1c33e677a$exports.useTreeViewKeyboardNavigation = $465a39a1c33e677a$var$useTreeViewKeyboardNavigation;
$465a39a1c33e677a$var$useTreeViewKeyboardNavigation.params = {};





const $b1cfd327c7e0ce2d$var$RICH_TREE_VIEW_PLUGINS = $b1cfd327c7e0ce2d$exports.RICH_TREE_VIEW_PLUGINS = [
    $4bbff37830facd37$exports.useTreeViewItems,
    $bb3f97219f69a4af$exports.useTreeViewExpansion,
    $4a09efe287eb143c$exports.useTreeViewSelection,
    $955b1075fa22554c$exports.useTreeViewFocus,
    $8ce1f98186cb2bad$exports.useTreeViewKeyboardNavigation,
    $8407f8bcbbd0da1e$exports.useTreeViewLabel
]; // We can't infer this type from the plugin, otherwise we would lose the generics.


var $be89747494d8664c$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $be89747494d8664c$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $be89747494d8664c$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($be89747494d8664c$exports, "__esModule", {
    value: true
});
$be89747494d8664c$exports.RichTreeViewItems = $be89747494d8664c$var$RichTreeViewItems;

var $be89747494d8664c$var$_extends2 = $be89747494d8664c$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $be89747494d8664c$var$_objectWithoutPropertiesLoose2 = $be89747494d8664c$require$_interopRequireDefault((parcelRequire("68UY6")));

var $be89747494d8664c$var$React = $be89747494d8664c$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $be89747494d8664c$var$_useSlotProps2 = $be89747494d8664c$require$_interopRequireDefault((parcelRequire("k3QMn")));






var $kSbwP = parcelRequire("kSbwP");
const $be89747494d8664c$var$_excluded = [
    "ownerState"
];
const $be89747494d8664c$var$RichTreeViewItemsContext = /*#__PURE__*/ $be89747494d8664c$var$React.createContext(null);
const $be89747494d8664c$var$WrappedTreeItem = /*#__PURE__*/ $be89747494d8664c$var$React.memo(function WrappedTreeItem({ itemSlot: itemSlot, itemSlotProps: itemSlotProps, itemId: itemId }) {
    const renderItemForRichTreeView = $be89747494d8664c$var$React.useContext($be89747494d8664c$var$RichTreeViewItemsContext);
    const { store: store } = (0, $33114ec9c2f70325$exports.useTreeViewContext)();
    const itemMeta = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $4bf621410ffd294f$exports.selectorItemMeta, itemId);
    const children = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds, itemId);
    const Item = itemSlot ?? $903d28d692c77697$exports.TreeItem;
    const _useSlotProps = (0, $be89747494d8664c$var$_useSlotProps2.default)({
        elementType: Item,
        externalSlotProps: itemSlotProps,
        additionalProps: {
            label: itemMeta?.label,
            id: itemMeta?.idAttribute,
            itemId: itemId
        },
        ownerState: {
            itemId: itemId,
            label: itemMeta?.label
        }
    }), itemProps = (0, $be89747494d8664c$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $be89747494d8664c$var$_excluded);
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Item, (0, $be89747494d8664c$var$_extends2.default)({}, itemProps, {
        children: children?.map(renderItemForRichTreeView)
    }));
}, $f0b064c06f5dfbf7$exports.fastObjectShallowCompare);
function $be89747494d8664c$var$RichTreeViewItems(props) {
    const { slots: slots, slotProps: slotProps } = props;
    const { store: store } = (0, $33114ec9c2f70325$exports.useTreeViewContext)();
    const itemSlot = slots?.item;
    const itemSlotProps = slotProps?.item;
    const items = (0, $c1fb9b8a48f92cf3$exports.useSelector)(store, $4bf621410ffd294f$exports.selectorItemOrderedChildrenIds, null);
    const renderItem = $be89747494d8664c$var$React.useCallback((itemId)=>{
        return /*#__PURE__*/ (0, $kSbwP.jsx)($be89747494d8664c$var$WrappedTreeItem, {
            itemSlot: itemSlot,
            itemSlotProps: itemSlotProps,
            itemId: itemId
        }, itemId);
    }, [
        itemSlot,
        itemSlotProps
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($be89747494d8664c$var$RichTreeViewItemsContext.Provider, {
        value: renderItem,
        children: items.map(renderItem)
    });
}





var $kSbwP = parcelRequire("kSbwP");
const $bc7ed93b333a9eaa$var$_excluded = [
    "slots",
    "slotProps"
];
const $bc7ed93b333a9eaa$var$useThemeProps = (0, $78255dd8255477c5$exports.createUseThemeProps)('MuiRichTreeView');
const $bc7ed93b333a9eaa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $bc7ed93b333a9eaa$var$React.useMemo(()=>{
        const slots = {
            root: [
                'root'
            ],
            item: [
                'item'
            ],
            itemContent: [
                'itemContent'
            ],
            itemGroupTransition: [
                'itemGroupTransition'
            ],
            itemIconContainer: [
                'itemIconContainer'
            ],
            itemLabel: [
                'itemLabel'
            ],
            itemLabelInput: [
                'itemLabelInput'
            ],
            itemCheckbox: [
                'itemCheckbox'
            ]
        };
        return (0, $bc7ed93b333a9eaa$var$_composeClasses.default)(slots, $97a7d95f69a0fbdb$exports.getRichTreeViewUtilityClass, classes);
    }, [
        classes
    ]);
};
const $bc7ed93b333a9eaa$var$RichTreeViewRoot = $bc7ed93b333a9eaa$exports.RichTreeViewRoot = (0, $78255dd8255477c5$exports.styled)('ul', {
    name: 'MuiRichTreeView',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 0,
    margin: 0,
    listStyle: 'none',
    outline: 0,
    position: 'relative'
});
/**
 *
 * Demos:
 *
 * - [Tree View](https://mui.com/x/react-tree-view/)
 *
 * API:
 *
 * - [RichTreeView API](https://mui.com/x/api/tree-view/rich-tree-view/)
 */ const $bc7ed93b333a9eaa$var$RichTreeView = $bc7ed93b333a9eaa$exports.RichTreeView = /*#__PURE__*/ $bc7ed93b333a9eaa$var$React.forwardRef(function RichTreeView(inProps, ref) {
    const props = $bc7ed93b333a9eaa$var$useThemeProps({
        props: inProps,
        name: 'MuiRichTreeView'
    });
    const { slots: slots, slotProps: slotProps } = props, other = (0, $bc7ed93b333a9eaa$var$_objectWithoutPropertiesLoose2.default)(props, $bc7ed93b333a9eaa$var$_excluded);
    const { getRootProps: getRootProps, contextValue: contextValue } = (0, $a2f703e2dc17e62b$exports.useTreeView)({
        plugins: $b1cfd327c7e0ce2d$exports.RICH_TREE_VIEW_PLUGINS,
        rootRef: ref,
        props: other
    });
    const isLoading = (0, $c1fb9b8a48f92cf3$exports.useSelector)(contextValue.store, $4bf621410ffd294f$exports.selectorIsTreeViewLoading);
    const treeViewError = (0, $c1fb9b8a48f92cf3$exports.useSelector)(contextValue.store, $4bf621410ffd294f$exports.selectorGetTreeViewError);
    const classes = $bc7ed93b333a9eaa$var$useUtilityClasses(props);
    const Root = slots?.root ?? $bc7ed93b333a9eaa$var$RichTreeViewRoot;
    const rootProps = (0, $bc7ed93b333a9eaa$var$_useSlotProps.default)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        className: classes.root,
        getSlotProps: getRootProps,
        ownerState: props
    });
    if (isLoading) return /*#__PURE__*/ (0, $kSbwP.jsx)($bc7ed93b333a9eaa$var$_Typography.default, {
        children: "Loading..."
    });
    if (treeViewError) return /*#__PURE__*/ (0, $kSbwP.jsx)($bc7ed93b333a9eaa$var$_Alert.default, {
        severity: "error",
        children: treeViewError.message
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)($33114ec9c2f70325$exports.TreeViewProvider, {
        contextValue: contextValue,
        classes: classes,
        slots: slots,
        slotProps: slotProps,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)(Root, (0, $bc7ed93b333a9eaa$var$_extends2.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $kSbwP.jsx)($be89747494d8664c$exports.RichTreeViewItems, {
                slots: slots,
                slotProps: slotProps
            })
        }))
    });
});


Object.keys($bc7ed93b333a9eaa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c65f25eba0931d0a$var$_exportNames, key)) return;
    if (key in $c65f25eba0931d0a$exports && $c65f25eba0931d0a$exports[key] === $bc7ed93b333a9eaa$exports[key]) return;
    Object.defineProperty($c65f25eba0931d0a$exports, key, {
        enumerable: true,
        get: function() {
            return $bc7ed93b333a9eaa$exports[key];
        }
    });
});

Object.keys($97a7d95f69a0fbdb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c65f25eba0931d0a$var$_exportNames, key)) return;
    if (key in $c65f25eba0931d0a$exports && $c65f25eba0931d0a$exports[key] === $97a7d95f69a0fbdb$exports[key]) return;
    Object.defineProperty($c65f25eba0931d0a$exports, key, {
        enumerable: true,
        get: function() {
            return $97a7d95f69a0fbdb$exports[key];
        }
    });
});





var $8265ed952e0c8e93$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8265ed952e0c8e93$export$66254a40dc283f77 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(/*#__PURE__*/ (0, $8nGP5.forwardRef)((props, ref)=>{
    const { folderContent: folderContent } = props;
    const ROOT_FOLDER = 'knowledge';
    const [expandedTree, setExpandedTree] = (0, $8nGP5.useState)([
        ROOT_FOLDER
    ]);
    const [treeItems, setFolderTreeItems] = (0, $8nGP5.useState)([]);
    const [selectedIds, setSelectedIds] = (0, $8nGP5.useState)([]);
    const { refreshFolder: refreshFolder } = props;
    (0, $8nGP5.useImperativeHandle)(ref, ()=>({
            getSelectedItems: ()=>{
                return selectedIds;
            },
            getTreeItems: ()=>{
                return treeItems;
            }
        }), [
        selectedIds,
        treeItems
    ]);
    const onCreateFolder = (storageTarget)=>{
        const newFolder = prompt('Enter folder name', 'New Folder');
        const doWork = ()=>$8265ed952e0c8e93$var$__awaiter(void 0, void 0, void 0, function*() {
                const storage = (0, $fa12c9399a1a76ec$export$39e0a5bed87a3667)();
                yield storage.createFolder(storageTarget, newFolder);
                refreshFolder();
            });
        if (newFolder) doWork();
    };
    const onDeleteFolder = (storageTarget)=>{
        const areYouSure = confirm(`Are you sure you want to delete this folder? \r\n *** ${storageTarget.folder} ***`);
        const doWork = ()=>$8265ed952e0c8e93$var$__awaiter(void 0, void 0, void 0, function*() {
                const storage = (0, $fa12c9399a1a76ec$export$39e0a5bed87a3667)();
                yield storage.deleteFolder(storageTarget);
                refreshFolder();
            });
        if (areYouSure) doWork();
    };
    const onDeleteFile = (storagePath)=>{
        const areYouSure = confirm(`Are you sure you want to delete this file?: \r\n *** ${storagePath} ***`);
        const doWork = ()=>$8265ed952e0c8e93$var$__awaiter(void 0, void 0, void 0, function*() {
                const storage = (0, $fa12c9399a1a76ec$export$39e0a5bed87a3667)();
                yield storage.deleteKnowledgeFile(storagePath);
                refreshFolder();
            });
        if (areYouSure) doWork();
    };
    const handleToggleTree = (event, itemIds)=>{
        if (itemIds.indexOf(ROOT_FOLDER) === -1) itemIds.push(ROOT_FOLDER);
        setExpandedTree(itemIds);
    };
    const getTagsFolder = (folder)=>{
        const tags = [];
        folder.files.forEach((file)=>{
            const fileTags = getTags(file.path);
            fileTags.forEach((tag)=>{
                if (!tags.find((t)=>t.value === tag.value)) tags.push(tag);
            });
        });
        folder.folders.forEach((subFolder)=>{
            const subTags = getTagsFolder(subFolder);
            subTags.forEach((tag)=>{
                if (!tags.find((t)=>t.value === tag.value)) tags.push(tag);
            });
        });
        return tags;
    };
    const getRagStatus = (path)=>{
        const sanitized = (0, $b2432f43c421c848$export$5a1443b88cb7b0d4)(path);
        const entry = props.knowledgeFilesDB[sanitized];
        if (entry && entry.ragStatus) return entry.ragStatus;
        else return 'not-started';
    };
    const getTags = (path)=>{
        var _a;
        const sanitized = (0, $b2432f43c421c848$export$5a1443b88cb7b0d4)(path);
        const entry = props.knowledgeFilesDB[sanitized];
        if (entry) return (_a = entry.tags) !== null && _a !== void 0 ? _a : [];
        else return [];
    };
    const makeFileTree = (folder)=>{
        const buildFile = (item)=>{
            const tags = getTags(item.path);
            const ragStatus = getRagStatus(item.path);
            return {
                id: item.path,
                label: item.fileName,
                path: item.path,
                type: 'file',
                tags: tags,
                ragStatus: ragStatus
            };
        };
        const buildFolder = (folder)=>{
            const files = folder.files.map((file)=>buildFile(file));
            const tags = getTagsFolder(folder);
            const children = folder.folders.map((subFolder)=>buildFolder(subFolder));
            return {
                id: folder.path,
                path: folder.path,
                label: folder.name,
                children: children.concat(files),
                type: 'folder',
                tags: tags
            };
        };
        return buildFolder(folder);
    };
    (0, $8nGP5.useEffect)(()=>{
        if (folderContent) {
            const treeItems = makeFileTree(folderContent);
            setFolderTreeItems([
                treeItems
            ]);
        }
    }, [
        folderContent,
        props.knowledgeFilesDB
    ]);
    function CustomIcon(props) {
        const { isOpen: isOpen, type: type, className: className } = props;
        return (0, $kSbwP.jsx)("div", {
            className: className,
            children: type === 'folder' ? isOpen ? (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c6e118bb06a6e33f$exports))), {}) : (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($36ece994f43249dc$exports))), {}) : (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0608756385ff06a8$exports))), {})
        });
    }
    function CustomLabel(props) {
        const { children: children, className: className, type: type, tags: tags } = props;
        const uploadPath = props.path.replace(/^knowledge\/?/, '');
        const folderRender = (uploadFolder)=>{
            return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
                children: [
                    (0, $kSbwP.jsx)((0, $d39d5626a2a26fe7$export$6b45509f74bc6382), {
                        display: `Upload`,
                        storageTarget: {
                            type: 'knowledge_base',
                            folder: uploadFolder
                        },
                        toasterMessage: "Uploading Knowledge: %name%",
                        onUpload: (fileName)=>{
                            refreshFolder();
                        }
                    }, "upload"),
                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        variant: "light",
                        onClick: ()=>{
                            onCreateFolder({
                                type: 'knowledge_base',
                                folder: uploadFolder
                            });
                        },
                        children: "+ Folder"
                    }, "create-folder"),
                    uploadFolder !== '' && (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                        variant: "danger",
                        onClick: ()=>{
                            onDeleteFolder({
                                type: 'knowledge_base',
                                folder: uploadFolder
                            });
                        },
                        children: "Delete"
                    }, "delete-folder")
                ]
            });
        };
        const renderFile = (fileTags, ragStatus)=>{
            const tagsEl = tags.map((tag)=>{
                const color = tag.value.indexOf('::') == -1 ? 'primary' : 'secondary';
                const name = tag.value.split('::');
                return (0, $kSbwP.jsx)((0, $e1908ab799a51708$export$2e2bcd8739ae039), {
                    label: name[name.length - 1],
                    color: color
                }, `chip_${tag.value}`);
            });
            const ragStatusEl = props.ragStatus == 'completed' ? (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5f18f0218c40e467$exports))), {
                color: "success"
            }, "done-icon") : (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0575741398557029$exports))), {
                color: "error"
            }, "clear-icon");
            const deleteButton = (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                variant: "danger",
                onClick: ()=>{
                    onDeleteFile(props.path);
                },
                children: "Delete"
            }, "delete-folder");
            return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
                children: [
                    tagsEl,
                    ragStatusEl,
                    deleteButton
                ]
            });
        };
        return (0, $kSbwP.jsx)("div", {
            className: className,
            children: (0, $kSbwP.jsxs)((0, $bf55a801ba90eca2$export$2e2bcd8739ae039), {
                direction: "row",
                spacing: 1,
                alignItems: "center",
                children: [
                    (0, $kSbwP.jsx)((0, $ab90ebace5b2582a$export$2e2bcd8739ae039), {
                        children: children
                    }),
                    type === 'folder' && folderRender(uploadPath),
                    type === 'file' && renderFile(tags, props.ragStatus)
                ]
            })
        });
    }
    const CustomTreeItem = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function CustomTreeItem(props, ref) {
        const { status: status } = (0, $9f588e9af86237d9$exports.useTreeItem)(props);
        const item = (0, $ecb5096a87a10a64$exports.useTreeItemModel)(props.itemId);
        return (0, $kSbwP.jsx)((0, $903d28d692c77697$exports.TreeItem), Object.assign({}, props, {
            ref: ref,
            slots: {
                label: CustomLabel,
                iconContainer: CustomIcon
            },
            slotProps: {
                label: {
                    label: item.type,
                    type: item.type,
                    path: item.path,
                    tags: item.tags,
                    ragStatus: item.ragStatus
                },
                iconContainer: {
                    isOpen: status.expanded,
                    type: item.type
                }
            }
        }));
    });
    return (0, $kSbwP.jsx)((0, $c65f25eba0931d0a$exports.RichTreeView), {
        expandedItems: expandedTree,
        checkboxSelection: true,
        onExpandedItemsChange: handleToggleTree,
        multiSelect: true,
        selectionPropagation: {
            descendants: true,
            parents: false
        },
        onSelectedItemsChange: (e, ids)=>{
            setSelectedIds(ids);
        },
        items: treeItems,
        slots: {
            item: CustomTreeItem
        }
    });
}));



var $kSbwP = parcelRequire("kSbwP");



const $2e2f47867b2bdad5$export$fe6c4c21907e19c4 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const defaultOptions = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($1e22e536e4ef8476$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return (0, $kSbwP.jsx)("div", {
        className: "fade-in",
        style: {
            animationDelay: '0.45s'
        },
        children: (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
            options: defaultOptions,
            height: 400,
            width: 400
        })
    });
});





var $T5IcR = parcelRequire("T5IcR");


const $98c5ba02ccfb6ac5$var$KnowledgeBase = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const knowledgeFileDB = store.knowledgeFilesDB;
    const ROOT_FOLDER = 'knowledge';
    (0, $8f024b03d9af7c67$export$d2d3ee67e04f6bd9)('Knowledge Base');
    const { folderContent: folderContent, refreshFolder: refreshFolder, isLoading: isLoading } = (0, $979db26205690177$export$548b5965aa310fce)(ROOT_FOLDER);
    const treeAPI = (0, $8nGP5.useRef)(null);
    const taggingAPI = (0, $8nGP5.useRef)(null);
    function flattenTree(items) {
        return items.flatMap((item)=>{
            var _a;
            const children = (_a = item.children) !== null && _a !== void 0 ? _a : [];
            return [
                item,
                ...flattenTree(children)
            ];
        });
    }
    const getSelectedItems = ()=>{
        const selectedIds = treeAPI.current.getSelectedItems();
        const treeItems = treeAPI.current.getTreeItems();
        const flatTreeItems = flattenTree(treeItems);
        const entries = selectedIds.map((id)=>{
            const item = flatTreeItems.find((item)=>item.id === id);
            return {
                id: item.id,
                path: item.path,
                type: item.type,
                tags: item.tags
            };
        });
        return entries;
    };
    const onClickDeleteSelectedRealtimeEntries = ()=>{
        const entries = getSelectedItems();
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        entries.forEach((entry)=>{
            if (entry.type === 'file') fb.deleteKnowledgeFileDbEntry(entry.path);
        });
    };
    const onClickSave = ()=>{
        const entries = getSelectedItems();
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        const tags = taggingAPI.current.getTags();
        entries.forEach((entry)=>{
            if (entry.type === 'file') fb.setKnowledgeFileTags(entry.path, (0, $T5IcR.toJS)(tags));
        });
    //alert(JSON.stringify(entries, null, 2));
    };
    const onClickLoad = ()=>{
        var _a;
        const tags = [];
        const entries = getSelectedItems();
        entries.forEach((entry)=>{
            var _a, _b;
            if (entry.type === 'file') {
                const sanitized = (0, $b2432f43c421c848$export$5a1443b88cb7b0d4)(entry.path);
                const entryTags = (_b = (_a = knowledgeFileDB[sanitized]) === null || _a === void 0 ? void 0 : _a.tags) !== null && _b !== void 0 ? _b : [];
                entryTags.forEach((tag)=>{
                    if (!tags.find((t)=>t.value === tag.value)) tags.push(tag);
                });
            }
        });
        (_a = taggingAPI.current) === null || _a === void 0 || _a.loadTags(tags);
    };
    if (isLoading) return (0, $kSbwP.jsx)((0, $2e2f47867b2bdad5$export$fe6c4c21907e19c4), {});
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)((0, $77d5878715146af4$export$8b251419efc915eb), {
                disableTicker: true,
                showNewDeal: true
            }),
            (0, $kSbwP.jsxs)((0, $c94930c253f3e81f$export$f836382419f64c98), {
                layoutPercent: [
                    70,
                    30
                ],
                children: [
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "column",
                        fillCell: true,
                        children: [
                            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                                direction: "row",
                                style: {
                                    gap: '20px',
                                    padding: '10px'
                                },
                                children: [
                                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                        variant: "dark",
                                        onClick: onClickSave,
                                        children: "Save TAGS"
                                    }),
                                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                        variant: "dark",
                                        onClick: onClickLoad,
                                        children: "Load TAGS"
                                    }),
                                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                        variant: "danger",
                                        onClick: onClickDeleteSelectedRealtimeEntries,
                                        children: "Delete Entries"
                                    }),
                                    (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        onClick: ()=>{
                                            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                                            fb.triggerKnowledgeFilesImport();
                                        },
                                        children: "RAG Import"
                                    })
                                ]
                            }),
                            (0, $kSbwP.jsx)("div", {
                                style: {
                                    width: '100%',
                                    height: '80%'
                                },
                                children: (0, $kSbwP.jsx)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                                    children: (0, $kSbwP.jsx)((0, $8265ed952e0c8e93$export$66254a40dc283f77), {
                                        ref: treeAPI,
                                        folderContent: folderContent,
                                        knowledgeFilesDB: knowledgeFileDB,
                                        refreshFolder: refreshFolder
                                    })
                                })
                            })
                        ]
                    }),
                    (0, $kSbwP.jsx)((0, $a570357442173b6b$export$ae4b6665feddc7b9), {
                        ref: taggingAPI
                    })
                ]
            })
        ]
    });
});
var $98c5ba02ccfb6ac5$export$2e2bcd8739ae039 = $98c5ba02ccfb6ac5$var$KnowledgeBase;



var $kSbwP = parcelRequire("kSbwP");






var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
"use client";
const $42552e716cffd895$var$Container = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$42552e716cffd895$var$Container.displayName = 'Container';
var $42552e716cffd895$export$2e2bcd8739ae039 = $42552e716cffd895$var$Container;



var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
"use client";
const $fdb4b2f3b16739b1$var$Row = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $58df59260255f5cd$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $58df59260255f5cd$export$8970c8db816a5863)();
    const minBreakpoint = (0, $58df59260255f5cd$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$fdb4b2f3b16739b1$var$Row.displayName = 'Row';
var $fdb4b2f3b16739b1$export$2e2bcd8739ae039 = $fdb4b2f3b16739b1$var$Row;



var $e5930515877dc472$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $e5930515877dc472$var$LoginPage = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const { id: id } = (0, $48e5d1fb97c993cc$export$99eaa27ddbbb95ef)();
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const navigate = (0, $48e5d1fb97c993cc$export$9770f232ac06a008)();
    const [loginEmail, setLoginEmail] = (0, $8nGP5.useState)('');
    const [loginPassword, setLoginPassword] = (0, $8nGP5.useState)('');
    const [resetEmail, setResetEmail] = (0, $8nGP5.useState)('');
    const [authState, setAuthState] = (0, $8nGP5.useState)(false);
    (0, $8nGP5.useEffect)(()=>{
        const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        uiStore.disableLoading = true;
        // Set up navigation callback for Firebase adapter
        (0, $b2432f43c421c848$export$7a667d08ed65fa47)().setNavigationCallback((path)=>{
            // Re-enable loading when navigating away from login
            if (path === '/') uiStore.disableLoading = false;
            navigate(path);
        });
    }, [
        navigate
    ]);
    (0, $8nGP5.useEffect)(()=>{
        const auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)((0, $b2432f43c421c848$export$7a667d08ed65fa47)().app);
        const unsubscribe = auth.onAuthStateChanged((user)=>{
            if (user) {
                setAuthState(true);
                // Add delay to show green status before redirecting
                setTimeout(()=>{
                    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    // Set loading state BEFORE navigation to prevent flicker
                    uiStore.disableLoading = false;
                    uiStore.forceLoading = true;
                    navigate('/');
                    // Clear force loading after showing loading screen
                    setTimeout(()=>{
                        uiStore.forceLoading = false;
                    }, 2000); // Show loading for 2 seconds
                }, 750);
            } else setAuthState(false);
        });
        return ()=>unsubscribe();
    }, [
        navigate
    ]);
    const login = ()=>$e5930515877dc472$var$__awaiter(void 0, void 0, void 0, function*() {
            const auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)((0, $b2432f43c421c848$export$7a667d08ed65fa47)().app);
            try {
                const user = yield (0, $402d0a489f4b5d89$export$555508cbc6add439)(auth, loginEmail, loginPassword);
                if (user) (0, $b2432f43c421c848$export$7a667d08ed65fa47)().store_audit_entry('LOGIN');
            } catch (e) {
                alert('Invalid user/pass');
            }
        });
    const handleSubmit = (e)=>{
        e.preventDefault();
        login();
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') login();
    };
    const sendReset = ()=>{
        const auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)((0, $b2432f43c421c848$export$7a667d08ed65fa47)().app);
        (0, $402d0a489f4b5d89$export$a8550f7dbe79f93a)(auth, resetEmail);
        alert('Reset email sent');
    };
    const logout = ()=>{
        const auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)((0, $b2432f43c421c848$export$7a667d08ed65fa47)().app);
        auth.signOut();
    };
    const loggedIn = (0, $kSbwP.jsx)("i", {
        style: {
            color: 'green',
            left: 5,
            top: 3,
            position: 'relative'
        },
        className: "bi bi-check-circle"
    });
    const loggedOut = (0, $kSbwP.jsx)("i", {
        style: {
            color: 'red',
            left: 5,
            top: 3,
            position: 'relative'
        },
        className: "bi bi-x-circle"
    });
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsxs)((0, $42552e716cffd895$export$2e2bcd8739ae039), {
                className: "w-100 h-100",
                children: [
                    (0, $kSbwP.jsx)((0, $fdb4b2f3b16739b1$export$2e2bcd8739ae039), {
                        className: "d-flex justify-content-between",
                        children: (0, $kSbwP.jsx)((0, $3122a95e939cfe17$export$2e2bcd8739ae039), {
                            children: (0, $kSbwP.jsx)((0, $77d5878715146af4$export$8b251419efc915eb), {
                                showNewDeal: false
                            })
                        })
                    }),
                    (0, $kSbwP.jsx)((0, $fdb4b2f3b16739b1$export$2e2bcd8739ae039), {
                        children: (0, $kSbwP.jsxs)((0, $3122a95e939cfe17$export$2e2bcd8739ae039), {
                            style: {
                                textAlign: 'center',
                                fontSize: 25
                            },
                            children: [
                                "Login Status: ",
                                authState ? loggedIn : loggedOut
                            ]
                        })
                    }),
                    (0, $kSbwP.jsxs)((0, $fdb4b2f3b16739b1$export$2e2bcd8739ae039), {
                        className: "pt-5",
                        children: [
                            (0, $kSbwP.jsx)((0, $3122a95e939cfe17$export$2e2bcd8739ae039), {
                                xs: 2
                            }),
                            (0, $kSbwP.jsx)((0, $3122a95e939cfe17$export$2e2bcd8739ae039), {
                                children: (0, $kSbwP.jsxs)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039), {
                                    onSubmit: handleSubmit,
                                    children: [
                                        (0, $kSbwP.jsxs)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            controlId: "exampleForm.ControlInput1",
                                            children: [
                                                (0, $kSbwP.jsx)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039).Label, {
                                                    children: "Email address"
                                                }),
                                                (0, $kSbwP.jsx)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039).Control, {
                                                    type: "email",
                                                    placeholder: "name@example.com",
                                                    onChange: (e)=>setLoginEmail(e.target.value),
                                                    onKeyDown: handleKeyDown
                                                }),
                                                (0, $kSbwP.jsx)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039).Label, {
                                                    className: "pt-2",
                                                    children: "Password"
                                                }),
                                                (0, $kSbwP.jsx)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039).Control, {
                                                    type: "password",
                                                    placeholder: "...",
                                                    onChange: (e)=>setLoginPassword(e.target.value),
                                                    onKeyDown: handleKeyDown
                                                })
                                            ]
                                        }),
                                        (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                            variant: "primary",
                                            type: "submit",
                                            children: "Login"
                                        })
                                    ]
                                })
                            }),
                            (0, $kSbwP.jsx)((0, $3122a95e939cfe17$export$2e2bcd8739ae039), {
                                xs: 1
                            }),
                            (0, $kSbwP.jsx)((0, $3122a95e939cfe17$export$2e2bcd8739ae039), {
                                children: (0, $kSbwP.jsxs)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $kSbwP.jsxs)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            controlId: "exampleForm.ControlInput1",
                                            children: [
                                                (0, $kSbwP.jsx)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039).Label, {
                                                    children: "Email address"
                                                }),
                                                (0, $kSbwP.jsx)((0, $ca5560d48e2c2703$export$2e2bcd8739ae039).Control, {
                                                    type: "email",
                                                    placeholder: "name@example.com",
                                                    onChange: (e)=>setResetEmail(e.target.value)
                                                })
                                            ]
                                        }),
                                        (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                                            variant: "primary",
                                            onClick: sendReset,
                                            children: "Reset"
                                        })
                                    ]
                                })
                            }),
                            (0, $kSbwP.jsx)((0, $3122a95e939cfe17$export$2e2bcd8739ae039), {
                                xs: 2
                            })
                        ]
                    })
                ]
            }),
            (0, $kSbwP.jsx)((0, $e3fe232d2b1bc057$export$2e2bcd8739ae039), {
                variant: "primary",
                onClick: logout,
                style: {
                    position: 'absolute',
                    right: 0,
                    bottom: 0
                },
                children: "Logout"
            })
        ]
    });
});
var $e5930515877dc472$export$2e2bcd8739ae039 = $e5930515877dc472$var$LoginPage;



var $kSbwP = parcelRequire("kSbwP");



const $e9bf3b3771eb1a0c$export$c9554889b3e706cd = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    var _a, _b, _c, _d;
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const show = uiStore.modal != null;
    const el = (_b = (_a = uiStore.modal) === null || _a === void 0 ? void 0 : _a.el) !== null && _b !== void 0 ? _b : null;
    const handleClose = ()=>{
        uiStore.modal = null;
    };
    const title = (_d = (_c = uiStore.modal) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : '';
    const transcript = 'text';
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $58851437c2fcbc16$export$2e2bcd8739ae039), {
            show: show,
            onHide: handleClose,
            children: [
                (0, $kSbwP.jsx)((0, $58851437c2fcbc16$export$2e2bcd8739ae039).Header, {
                    closeButton: true,
                    children: (0, $kSbwP.jsx)((0, $58851437c2fcbc16$export$2e2bcd8739ae039).Title, {
                        children: title
                    })
                }),
                (0, $kSbwP.jsx)((0, $58851437c2fcbc16$export$2e2bcd8739ae039).Body, {
                    style: {
                        padding: '20px'
                    },
                    children: el
                }),
                (0, $kSbwP.jsx)((0, $58851437c2fcbc16$export$2e2bcd8739ae039).Footer, {})
            ]
        })
    });
});
var $e9bf3b3771eb1a0c$export$2e2bcd8739ae039 = $e9bf3b3771eb1a0c$export$c9554889b3e706cd;



var $kSbwP = parcelRequire("kSbwP");






var $8nGP5 = parcelRequire("8nGP5");


var $fX8pL = parcelRequire("fX8pL");
const $067ce2880602a7cb$export$b1dfb4c20e92c19a = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const [reportData, setReportData] = (0, $8nGP5.useState)(null);
    (0, $8nGP5.useEffect)(()=>{
        const companyId = 'profile_aqualisco';
        const report_type = 'build_company_profile';
        const target = `report_runs/${report_type}/${companyId}`;
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)((0, $e0be213f695400f3$export$d0dd861204d0bf72)(), target);
        const unsub = (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r, (data)=>{
            setReportData(data.val());
        });
        return ()=>unsub();
    }, []);
    var run_variables = [];
    if (reportData === null || reportData === void 0 ? void 0 : reportData.vars) {
        const runVars = reportData.vars;
        let keys = Object.keys(runVars).sort();
        const parseData = (s)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($fX8pL)))(s.slice(0, 23));
        };
        keys.sort((a, b)=>{
            const aDate = parseData(runVars[a]['updated_at']);
            const bDate = parseData(runVars[b]['updated_at']);
            return bDate.valueOf() - aDate.valueOf();
        });
        for (let k of keys){
            const rawHtmlWithDefault = (0, $e0f2436fd88d0d31$exports.marked).parse(runVars[k]['value']);
            const updatedAt = runVars[k]['updated_at'];
            const date = (0, (/*@__PURE__*/$parcel$interopDefault($fX8pL)))(updatedAt.slice(0, 23));
            let sanitizedHtml = (0, (/*@__PURE__*/$parcel$interopDefault($4a6c6cd3ba57d1fc$exports))).sanitize(rawHtmlWithDefault);
            run_variables.push((0, $kSbwP.jsxs)("tr", {
                style: {
                    borderTop: '1px solid #ccc'
                },
                children: [
                    (0, $kSbwP.jsx)("td", {
                        valign: "top",
                        children: k
                    }),
                    (0, $kSbwP.jsx)("td", {
                        children: (0, $kSbwP.jsx)("div", {
                            style: {
                                maxWidth: '1200px'
                            },
                            dangerouslySetInnerHTML: {
                                __html: sanitizedHtml
                            }
                        })
                    }),
                    (0, $kSbwP.jsx)("td", {
                        valign: "top",
                        children: date.format('YYYY-MM-DD HH:mm:ss')
                    })
                ]
            }, k));
        }
    }
    return (0, $kSbwP.jsxs)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
        children: [
            (0, $kSbwP.jsx)("h1", {
                children: "Run Variables"
            }),
            (0, $kSbwP.jsx)("table", {
                style: {
                    top: '50px',
                    position: 'relative'
                },
                children: (0, $kSbwP.jsx)("tbody", {
                    children: run_variables
                })
            })
        ]
    });
});


const $325af5f10b3faac7$var$maintenancePage = (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
    style: {
        backgroundColor: 'white'
    },
    fillCell: true,
    direction: "column",
    justify: "center",
    alignItems: "center",
    children: (0, $kSbwP.jsx)("div", {
        style: {
            transform: 'scale(2)'
        },
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            justify: "center",
            alignItems: "center",
            children: [
                (0, $kSbwP.jsx)((0, $bc783706f3494468$export$e6ff31bff12b7ff4), {}),
                (0, $kSbwP.jsx)("div", {
                    style: {
                        fontSize: '20px',
                        marginTop: '15px'
                    },
                    children: "We are currently upgrading!"
                })
            ]
        })
    })
});
const $325af5f10b3faac7$var$NavigationSetup = ()=>{
    const navigate = (0, $48e5d1fb97c993cc$export$9770f232ac06a008)();
    (0, $8nGP5.useEffect)(()=>{
        // Set up navigation callback for Firebase adapter
        (0, $b2432f43c421c848$export$7a667d08ed65fa47)().setNavigationCallback((path)=>{
            // Re-enable loading when navigating to main pages
            if (path === '/') {
                const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
                // Force loading state for visual transition
                uiStore.disableLoading = false;
                uiStore.forceLoading = true;
                // Clear force loading after transition
                setTimeout(()=>{
                    uiStore.forceLoading = false;
                }, 2000); // Show loading for 2 seconds
            }
            navigate(path);
        });
    }, [
        navigate
    ]);
    return null;
};
const $325af5f10b3faac7$export$953c2efc134d7f79 = (0, $f2729dedef021789$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const selectionStore = (0, $ffb64b99b5e6ea0e$export$4b4c417a6113a34c)();
    const clientSettings = (0, $8f024b03d9af7c67$export$30eb9424ed49720f)();
    (0, $8nGP5.useEffect)(()=>{
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
                storeUI.onKeyUpReset();
            }
        });
        document.addEventListener('keydown', (e)=>{
            const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
            //key for back?
            // if (e.key === 'Backspace') {
            //     if (
            //         (e.currentTarget as any).activeElement.localName ==
            //             'input' ||
            //         (e.currentTarget as any).activeElement.localName ==
            //             'textarea'
            //     ) {
            //         return;
            //     }
            //     window.history.back();
            // }
            if (e.ctrlKey && e.key.toLowerCase() === 'q') {
                const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                store.showAdminConsoleFromKeyboardShortcut = !store.showAdminConsoleFromKeyboardShortcut;
            }
            if (e.ctrlKey) storeUI.isKeyControlKeyDown = true;
            if (e.key === 'PageUp') storeUI.scrolling = 'UP';
            else if (e.key === 'PageDown') storeUI.scrolling = 'DOWN';
            else storeUI.scrolling = 'NONE';
            if (e.key == 'Tab') {
                if (e.currentTarget.activeElement.localName == 'input' || e.currentTarget.activeElement.localName == 'textarea') return;
                e.preventDefault();
                storeUI.isKeyShiftKeyDown = e.shiftKey;
                storeUI.isKeyTabDown = true;
            }
            if (e.key == 'Escape') {
                e.preventDefault();
                storeUI.isKeyEscapeDown = true;
            }
        });
        document.addEventListener('keyup', (e)=>{
            const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
            storeUI.onKeyUpReset();
        });
    }, []);
    if (clientSettings.isMaintenanceOn && !store.isAdmin) return $325af5f10b3faac7$var$maintenancePage;
    const hrefContainsLogin = window.location.href.includes('/login');
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            clientSettings.isMaintenanceOn && (0, $kSbwP.jsx)("div", {
                style: {
                    color: 'white',
                    fontSize: '20px',
                    position: 'absolute',
                    backgroundColor: 'red',
                    zIndex: 100000000
                },
                children: "MAINTENANCE MODE IS ENABLED"
            }),
            (0, $kSbwP.jsx)((0, $8f0b3b9abdff19ee$export$f2815235e76a62b9), {
                position: "bottom-right",
                style: {
                    zIndex: 100000000,
                    textAlign: 'right'
                }
            }),
            (0, $kSbwP.jsx)((0, $96c137ca70850e28$export$7a45779be0c29756), {}),
            (0, $kSbwP.jsx)((0, $7cf10799ed69235a$export$669f6ea7d267feaf), {}),
            (0, $kSbwP.jsx)((0, $e9bf3b3771eb1a0c$export$2e2bcd8739ae039), {}),
            (0, $kSbwP.jsxs)((0, $fd869777ac1b5d3c$export$9ba4e89fdfa1fc54), {
                children: [
                    (0, $kSbwP.jsx)($325af5f10b3faac7$var$NavigationSetup, {}),
                    (0, $kSbwP.jsxs)((0, $48e5d1fb97c993cc$export$3565eb3d00ca5a74), {
                        children: [
                            (0, $kSbwP.jsx)((0, $48e5d1fb97c993cc$export$e7b0ac011bb776c6), {
                                path: "/profile_debug",
                                element: store.isLoaded && !(0, $8f024b03d9af7c67$export$d842a17955610ca9)().forceLoading ? (0, $kSbwP.jsx)((0, $067ce2880602a7cb$export$b1dfb4c20e92c19a), {}) : null
                            }),
                            (0, $kSbwP.jsx)((0, $48e5d1fb97c993cc$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: store.isLoaded && !(0, $8f024b03d9af7c67$export$d842a17955610ca9)().forceLoading ? (0, $kSbwP.jsx)((0, $e640bef1966ab6d6$export$2e2bcd8739ae039), {}) : null
                            }),
                            (0, $kSbwP.jsx)((0, $48e5d1fb97c993cc$export$e7b0ac011bb776c6), {
                                path: "/login",
                                element: (0, $kSbwP.jsx)((0, $e5930515877dc472$export$2e2bcd8739ae039), {})
                            }),
                            (0, $kSbwP.jsx)((0, $48e5d1fb97c993cc$export$e7b0ac011bb776c6), {
                                path: "/:id",
                                element: store.isLoaded && !(0, $8f024b03d9af7c67$export$d842a17955610ca9)().forceLoading ? (0, $kSbwP.jsx)((0, $dd142b8584fa3691$export$2e2bcd8739ae039), {}) : null
                            }),
                            (0, $kSbwP.jsx)((0, $48e5d1fb97c993cc$export$e7b0ac011bb776c6), {
                                path: "/knowledge",
                                element: store.isLoaded && !(0, $8f024b03d9af7c67$export$d842a17955610ca9)().forceLoading ? (0, $kSbwP.jsx)((0, $98c5ba02ccfb6ac5$export$2e2bcd8739ae039), {}) : null
                            }),
                            (0, $kSbwP.jsx)((0, $48e5d1fb97c993cc$export$e7b0ac011bb776c6), {
                                path: "/admin/backtesting",
                                element: store.isLoaded && !(0, $8f024b03d9af7c67$export$d842a17955610ca9)().forceLoading && store.isAdmin ? (0, $kSbwP.jsx)((0, $613bef4b407d3331$export$5be27499c82e15a7), {}) : null
                            })
                        ]
                    })
                ]
            }),
            selectionStore.isSelectionModeActive && (0, $kSbwP.jsx)((0, $92cbda2f3abbf0b8$export$980520e7688d5821), {})
        ]
    });
});





const $861e84080756a67e$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $861e84080756a67e$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $861e84080756a67e$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $861e84080756a67e$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $861e84080756a67e$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $861e84080756a67e$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $861e84080756a67e$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $861e84080756a67e$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($861e84080756a67e$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $861e84080756a67e$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $861e84080756a67e$export$2d8f5188773bcddd(integration) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $861e84080756a67e$export$2323046b9414659f(fn) {
    return fn;
}





const $879ff71665c6eecc$var$INTEGRATION_NAME = 'Dedupe';
const $879ff71665c6eecc$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $879ff71665c6eecc$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($879ff71665c6eecc$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $879ff71665c6eecc$export$6d39aa44cd0c7567 = (0, $861e84080756a67e$export$2323046b9414659f)($879ff71665c6eecc$var$_dedupeIntegration);
/** only exported for tests. */ function $879ff71665c6eecc$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($879ff71665c6eecc$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($879ff71665c6eecc$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $879ff71665c6eecc$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$879ff71665c6eecc$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$879ff71665c6eecc$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $879ff71665c6eecc$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $879ff71665c6eecc$var$_getExceptionFromEvent(previousEvent);
    const currentException = $879ff71665c6eecc$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$879ff71665c6eecc$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$879ff71665c6eecc$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $879ff71665c6eecc$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $6eb7fa2c12e5f94a$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $6eb7fa2c12e5f94a$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $879ff71665c6eecc$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $879ff71665c6eecc$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}




let $8c14f7174ada528d$var$originalFunctionToString;
const $8c14f7174ada528d$var$INTEGRATION_NAME = 'FunctionToString';
const $8c14f7174ada528d$var$SETUP_CLIENTS = new WeakMap();
const $8c14f7174ada528d$var$_functionToStringIntegration = ()=>{
    return {
        name: $8c14f7174ada528d$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $8c14f7174ada528d$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $331e7a423c1d6bab$export$e6cc1e135e2092e5)(this);
                    const context = $8c14f7174ada528d$var$SETUP_CLIENTS.has((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $8c14f7174ada528d$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $8c14f7174ada528d$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $8c14f7174ada528d$export$7918117e9202e4fb = (0, $861e84080756a67e$export$2323046b9414659f)($8c14f7174ada528d$var$_functionToStringIntegration);



/** Regular expression used to parse a Dsn. */ const $843b0da08619aa63$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $843b0da08619aa63$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $843b0da08619aa63$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $843b0da08619aa63$export$b892860177f70a30(str) {
    const match = $843b0da08619aa63$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $50107229405f0b55$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $843b0da08619aa63$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $843b0da08619aa63$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $843b0da08619aa63$var$validateDsn(dsn) {
    if (!(0, $32dbb9c779accb6e$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$843b0da08619aa63$var$isValidProtocol(protocol)) {
        (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $843b0da08619aa63$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $843b0da08619aa63$export$b892860177f70a30(from) : $843b0da08619aa63$var$dsnFromComponents(from);
    if (!components || !$843b0da08619aa63$var$validateDsn(components)) return undefined;
    return components;
}


const $1b878ff624a14448$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $1b878ff624a14448$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $1b878ff624a14448$var$_getIngestEndpoint(dsn) {
    return `${$1b878ff624a14448$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $1b878ff624a14448$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $1b878ff624a14448$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $1b878ff624a14448$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$1b878ff624a14448$var$_getIngestEndpoint(dsn)}?${$1b878ff624a14448$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $1b878ff624a14448$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $843b0da08619aa63$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$1b878ff624a14448$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $843b0da08619aa63$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}






/**
 * Get a list of possible event messages from a Sentry event.
 */ function $0074d0f077bfa8f4$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $9230543946cecc48$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $9230543946cecc48$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $9230543946cecc48$export$9a84f518c163c552 = (0, $861e84080756a67e$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $9230543946cecc48$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $9230543946cecc48$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $9230543946cecc48$var$_mergeOptions(options, clientOptions);
            }
            return $9230543946cecc48$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $9230543946cecc48$export$cb3c5c2ceb9818ba = (0, $861e84080756a67e$export$2323046b9414659f)((options = {})=>{
    return {
        ...$9230543946cecc48$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $9230543946cecc48$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $9230543946cecc48$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $9230543946cecc48$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($9230543946cecc48$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($9230543946cecc48$var$_isUselessError(event)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($9230543946cecc48$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}.\nUrl: ${$9230543946cecc48$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$9230543946cecc48$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}.\nUrl: ${$9230543946cecc48$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($9230543946cecc48$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $9230543946cecc48$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $0074d0f077bfa8f4$export$d55a97c329cacfcc)(event).some((message)=>(0, $404b08ff2be9997a$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $9230543946cecc48$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $404b08ff2be9997a$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $9230543946cecc48$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $9230543946cecc48$var$_getEventFilterUrl(event);
    return !url ? false : (0, $404b08ff2be9997a$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $9230543946cecc48$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $9230543946cecc48$var$_getEventFilterUrl(event);
    return !url ? true : (0, $404b08ff2be9997a$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $9230543946cecc48$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $9230543946cecc48$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $9230543946cecc48$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $9230543946cecc48$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $62a36d7bdb68e8f6$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $f24718adf40977d4$export$16a28057038b10ef) (0, $50107229405f0b55$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $50107229405f0b55$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $62a36d7bdb68e8f6$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $62a36d7bdb68e8f6$export$ecb76f41d43c0e43(client) {
    (0, $7579005d8c799ca0$export$c7be4b0125a10cba)().setClient(client);
}




const $454364c661d00d30$var$WINDOW = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$67fc34576016d6ec() {
    return 'history' in $454364c661d00d30$var$WINDOW && !!$454364c661d00d30$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $454364c661d00d30$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $454364c661d00d30$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $454364c661d00d30$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$454364c661d00d30$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($454364c661d00d30$export$d5f608b368e73f38($454364c661d00d30$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $454364c661d00d30$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $454364c661d00d30$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$531055a6c684a70a() {
    return 'ReportingObserver' in $454364c661d00d30$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$454364c661d00d30$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}












/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $b04b40088fe5ea6b$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $b04b40088fe5ea6b$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $b04b40088fe5ea6b$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $b04b40088fe5ea6b$export$604a45d95a155e2b(envelope, types) {
    return $b04b40088fe5ea6b$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $b04b40088fe5ea6b$var$encodeUTF8(input) {
    const carrier = (0, $69b66c77e999bb3b$export$c8bfa33e4e8ae492)((0, $4546c9f85d024500$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $b04b40088fe5ea6b$var$decodeUTF8(input) {
    const carrier = (0, $69b66c77e999bb3b$export$c8bfa33e4e8ae492)((0, $4546c9f85d024500$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $b04b40088fe5ea6b$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $b04b40088fe5ea6b$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $b04b40088fe5ea6b$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $81e4dea968b0d498$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $b04b40088fe5ea6b$var$concatBuffers(parts);
}
function $b04b40088fe5ea6b$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $b04b40088fe5ea6b$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $b04b40088fe5ea6b$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($b04b40088fe5ea6b$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $b04b40088fe5ea6b$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $b04b40088fe5ea6b$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $b04b40088fe5ea6b$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $b04b40088fe5ea6b$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    otel_log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $b04b40088fe5ea6b$export$b11169581eeaf237(type) {
    return $b04b40088fe5ea6b$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $b04b40088fe5ea6b$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $b04b40088fe5ea6b$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $843b0da08619aa63$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $a0a857ad29b67515$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $a0a857ad29b67515$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $b04b40088fe5ea6b$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $843b0da08619aa63$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $a0a857ad29b67515$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $b04b40088fe5ea6b$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $a0a857ad29b67515$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $b04b40088fe5ea6b$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $a0a857ad29b67515$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $e872f90a02880534$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $843b0da08619aa63$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $8001bfb4d6603905$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $8001bfb4d6603905$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $8001bfb4d6603905$export$92d8c23565496537);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $b04b40088fe5ea6b$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(headers, items);
}







/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $b6a910e07cb72210$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $b99b0aced21a41e0$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}














/**
 * Converts a transaction event to a span JSON object.
 */ function $854fb525ddc2ad53$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $a0fd9313f4cb718b$export$1efec95406bbe327],
        exclusive_time: data?.[0, $a0fd9313f4cb718b$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $854fb525ddc2ad53$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $a0fd9313f4cb718b$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $a0fd9313f4cb718b$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}



const $1b3e1f4ebe4b3dca$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $1b3e1f4ebe4b3dca$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $1b3e1f4ebe4b3dca$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $1b3e1f4ebe4b3dca$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $1b3e1f4ebe4b3dca$var$_makeInternalError(message) {
    return {
        message: message,
        [$1b3e1f4ebe4b3dca$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $1b3e1f4ebe4b3dca$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$1b3e1f4ebe4b3dca$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $1b3e1f4ebe4b3dca$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $1b3e1f4ebe4b3dca$var$INTERNAL_ERROR_SYMBOL in error;
}
function $1b3e1f4ebe4b3dca$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $1b3e1f4ebe4b3dca$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $1b3e1f4ebe4b3dca$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $843b0da08619aa63$export$128827c3562ec0cb)(options.dsn);
        else (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $1b878ff624a14448$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $832931c5253c6f61$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $832931c5253c6f61$export$6de4ffac6a2f1098)(exception)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log($1b3e1f4ebe4b3dca$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $832931c5253c6f61$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $04327917d6f3444a$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $04327917d6f3444a$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $832931c5253c6f61$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $832931c5253c6f61$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log($1b3e1f4ebe4b3dca$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $933b7638f999d30c$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $861e84080756a67e$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $861e84080756a67e$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $a0a857ad29b67515$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $b04b40088fe5ea6b$export$d650323442802f6f)(env, (0, $b04b40088fe5ea6b$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $09c0eeb1390de562$export$849dbeeeda01ae98) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn($1b3e1f4ebe4b3dca$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn($1b3e1f4ebe4b3dca$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $a0a857ad29b67515$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $861e84080756a67e$export$51abed9797baa598)(this, integrations);
        (0, $861e84080756a67e$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $933b7638f999d30c$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $88d6af982193bd0a$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $84bc2afffc49348f$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $7579005d8c799ca0$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $e872f90a02880534$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)(), isolationScope = (0, $7579005d8c799ca0$export$68f3af03034c9e90)()) {
        if ((0, $f24718adf40977d4$export$16a28057038b10ef) && $1b3e1f4ebe4b3dca$var$isErrorEvent(event)) (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Captured error event \`${(0, $0074d0f077bfa8f4$export$d55a97c329cacfcc)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $f24718adf40977d4$export$16a28057038b10ef) {
                if ($1b3e1f4ebe4b3dca$var$_isDoNotSendEventError(reason)) (0, $50107229405f0b55$export$af88d00dbe7f521).log(reason.message);
                else if ($1b3e1f4ebe4b3dca$var$_isInternalError(reason)) (0, $50107229405f0b55$export$af88d00dbe7f521).warn(reason.message);
                else (0, $50107229405f0b55$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $1b3e1f4ebe4b3dca$var$isTransactionEvent(event);
        const isError = $1b3e1f4ebe4b3dca$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $cc2433bfd1c42bff$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $88d6af982193bd0a$export$78e43115b553f358)($1b3e1f4ebe4b3dca$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $1b3e1f4ebe4b3dca$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $1b3e1f4ebe4b3dca$var$processBeforeSend(this, options, prepared, hint);
            return $1b3e1f4ebe4b3dca$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $1b3e1f4ebe4b3dca$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($1b3e1f4ebe4b3dca$var$_isDoNotSendEventError(reason) || $1b3e1f4ebe4b3dca$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $1b3e1f4ebe4b3dca$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $b6a910e07cb72210$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $843b0da08619aa63$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $1b3e1f4ebe4b3dca$export$4f22f74eddb7716a = $1b3e1f4ebe4b3dca$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $1b3e1f4ebe4b3dca$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $04327917d6f3444a$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $04327917d6f3444a$export$53b83ca8eaab0383)(event) && event !== null) throw $1b3e1f4ebe4b3dca$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $1b3e1f4ebe4b3dca$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $04327917d6f3444a$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $1b3e1f4ebe4b3dca$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $1b3e1f4ebe4b3dca$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($1b3e1f4ebe4b3dca$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($1b3e1f4ebe4b3dca$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $854fb525ddc2ad53$export$d9c6b2464b0a687e)(processedEvent));
            if (!processedRootSpanJson) (0, $8001bfb4d6603905$export$d11691ff45a3e535)();
            else // update event with processed root span values
            processedEvent = (0, $e0d3e5565e99f13e$export$4950aa0f605343fb)(event, (0, $854fb525ddc2ad53$export$f2d8fce5ae150e92)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $8001bfb4d6603905$export$d11691ff45a3e535)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $1b3e1f4ebe4b3dca$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $1b3e1f4ebe4b3dca$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $1b3e1f4ebe4b3dca$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    const span = (0, $3384f12a46e56483$export$91f063ebb8eff307)(scope);
    const traceContext = span ? (0, $8001bfb4d6603905$export$46c6fbd1d265ebf0)(span) : (0, $7579005d8c799ca0$export$1e83db7ee4876dc4)(scope);
    const dynamicSamplingContext = span ? (0, $e872f90a02880534$export$a117f995597e25df)(span) : (0, $e872f90a02880534$export$89ef1736f08c6b2b)(client, scope);
    return [
        dynamicSamplingContext,
        traceContext
    ];
}




/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $dbda0c7ef1789297$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};





/**
 * Creates OTEL log envelope item for a serialized OTEL log.
 *
 * @param log - The serialized OTEL log to include in the envelope.
 * @returns The created OTEL log envelope item.
 */ function $0b84bbf39fcc01a6$export$3fb4f8e4a128d620(log) {
    return [
        {
            type: 'otel_log'
        },
        log
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $0b84bbf39fcc01a6$export$4324f1d0c59fd57b(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $843b0da08619aa63$export$44d472fbb931a776)(dsn);
    return (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(headers, logs.map($0b84bbf39fcc01a6$export$3fb4f8e4a128d620));
}




const $9cd0f6413ac3097d$var$MAX_LOG_BUFFER_SIZE = 100;
const $9cd0f6413ac3097d$var$CLIENT_TO_LOG_BUFFER_MAP = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $9cd0f6413ac3097d$export$84cb46f4adfc5d14(key, value) {
    switch(typeof value){
        case 'number':
            return {
                key: key,
                value: {
                    doubleValue: value
                }
            };
        case 'boolean':
            return {
                key: key,
                value: {
                    boolValue: value
                }
            };
        case 'string':
            return {
                key: key,
                value: {
                    stringValue: value
                }
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    key: key,
                    value: {
                        stringValue: stringValue
                    }
                };
            }
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $9cd0f6413ac3097d$export$3ab3d16b9eebd986(beforeLog, client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)(), scope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)()) {
    if (!client) {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $1b3e1f4ebe4b3dca$export$fb7d833b3fdedf5f)(client, scope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    if (release) processedLogAttributes['sentry.release'] = release;
    if (environment) processedLogAttributes['sentry.environment'] = environment;
    const { sdk: sdk } = client.getSdkMetadata() ?? {};
    if (sdk) {
        processedLogAttributes['sentry.sdk.name'] = sdk.name;
        processedLogAttributes['sentry.sdk.version'] = sdk.version;
    }
    const beforeLogMessage = beforeLog.message;
    if ((0, $04327917d6f3444a$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $3384f12a46e56483$export$91f063ebb8eff307)(scope);
    if (span) // Add the parent span ID to the log attributes for trace context
    processedLogAttributes['sentry.trace.parent_span_id'] = span.spanContext().spanId;
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    const log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        severityText: level,
        body: {
            stringValue: message
        },
        attributes: Object.entries(attributes).map(([key, value])=>$9cd0f6413ac3097d$export$84cb46f4adfc5d14(key, value)),
        timeUnixNano: `${new Date().getTime().toString()}000000`,
        traceId: traceContext?.trace_id,
        severityNumber: severityNumber ?? (0, $dbda0c7ef1789297$export$4fb50c0840d636d1)[level]
    };
    const logBuffer = $9cd0f6413ac3097d$var$CLIENT_TO_LOG_BUFFER_MAP.get(client);
    if (logBuffer === undefined) $9cd0f6413ac3097d$var$CLIENT_TO_LOG_BUFFER_MAP.set(client, [
        serializedLog
    ]);
    else {
        logBuffer.push(serializedLog);
        if (logBuffer.length > $9cd0f6413ac3097d$var$MAX_LOG_BUFFER_SIZE) $9cd0f6413ac3097d$export$f8ed83d3b6a0b504(client, logBuffer);
    }
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $9cd0f6413ac3097d$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $9cd0f6413ac3097d$var$CLIENT_TO_LOG_BUFFER_MAP.get(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $0b84bbf39fcc01a6$export$4324f1d0c59fd57b)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    logBuffer.length = 0;
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $662601301922d548$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $662601301922d548$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $97e636466ee42774$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c)
            })),
        version: (0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0003c7546bee8a58$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0003c7546bee8a58$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}



/**
 * This function creates an exception from a JavaScript Error
 */ function $49f9172a05aa7804$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $49f9172a05aa7804$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $49f9172a05aa7804$export$2e9ae379995d99e3(ex),
        value: $49f9172a05aa7804$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $49f9172a05aa7804$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $49f9172a05aa7804$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $81e4dea968b0d498$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $49f9172a05aa7804$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $04327917d6f3444a$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $49f9172a05aa7804$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $49f9172a05aa7804$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $49f9172a05aa7804$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $49f9172a05aa7804$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $49f9172a05aa7804$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $49f9172a05aa7804$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $49f9172a05aa7804$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $49f9172a05aa7804$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $49f9172a05aa7804$var$getSkipFirstStackStringLines(ex) {
    if (ex && $49f9172a05aa7804$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $49f9172a05aa7804$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $49f9172a05aa7804$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $49f9172a05aa7804$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $49f9172a05aa7804$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $49f9172a05aa7804$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($49f9172a05aa7804$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $49f9172a05aa7804$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $49f9172a05aa7804$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $49f9172a05aa7804$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $49f9172a05aa7804$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $49f9172a05aa7804$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $04327917d6f3444a$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $49f9172a05aa7804$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $04327917d6f3444a$export$ef9e2056653f0c8e)(exception) || (0, $04327917d6f3444a$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $49f9172a05aa7804$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $04327917d6f3444a$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $49f9172a05aa7804$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $832931c5253c6f61$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $04327917d6f3444a$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $49f9172a05aa7804$var$eventFromError(stackParser, exception);
    if ((0, $04327917d6f3444a$export$53b83ca8eaab0383)(exception) || (0, $04327917d6f3444a$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $49f9172a05aa7804$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $49f9172a05aa7804$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $832931c5253c6f61$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $49f9172a05aa7804$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $49f9172a05aa7804$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $04327917d6f3444a$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $49f9172a05aa7804$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $331e7a423c1d6bab$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $04327917d6f3444a$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $04327917d6f3444a$export$9671ea99bd126ace)(exception)) {
        const className = $49f9172a05aa7804$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $49f9172a05aa7804$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $49f9172a05aa7804$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



const $4344c5993a935327$export$56d8a8a25bd48b81 = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
let $4344c5993a935327$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $4344c5993a935327$export$b79738ab10c590b2() {
    return $4344c5993a935327$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $4344c5993a935327$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $4344c5993a935327$var$ignoreOnError++;
    setTimeout(()=>{
        $4344c5993a935327$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $4344c5993a935327$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $331e7a423c1d6bab$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$4344c5993a935327$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $4344c5993a935327$export$1265a142ff5ba165();
            (0, $7579005d8c799ca0$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $832931c5253c6f61$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $d0ea6cfcc1ddd989$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $331e7a423c1d6bab$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}


const $ee9a22ecd1aa84b2$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $ee9a22ecd1aa84b2$export$1df9218a526d318d extends (0, $1b3e1f4ebe4b3dca$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $4344c5993a935327$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $0003c7546bee8a58$export$8ad33f488b1ab046)();
        (0, $97e636466ee42774$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const client = this;
        const { sendDefaultPii: sendDefaultPii, _experiments: _experiments } = client._options;
        const enableLogs = _experiments?.enableLogs;
        if (opts.sendClientReports && (0, $4344c5993a935327$export$56d8a8a25bd48b81).document) (0, $4344c5993a935327$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $4344c5993a935327$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                this._flushOutcomes();
                if (enableLogs) (0, $9cd0f6413ac3097d$export$f8ed83d3b6a0b504)(client);
            }
        });
        if (enableLogs) {
            client.on('flush', ()=>{
                (0, $9cd0f6413ac3097d$export$f8ed83d3b6a0b504)(client);
            });
            client.on('afterCaptureLog', ()=>{
                if (client._logFlushIdleTimeout) clearTimeout(client._logFlushIdleTimeout);
                client._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $9cd0f6413ac3097d$export$f8ed83d3b6a0b504)(client);
                }, $ee9a22ecd1aa84b2$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            client.on('postprocessEvent', (0, $662601301922d548$export$3e12ad68afa434ac));
            client.on('beforeSendSession', (0, $662601301922d548$export$e8e2d07ba63e2b6c));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $49f9172a05aa7804$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $49f9172a05aa7804$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2d9d70da08177dd3$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






// We keep the handlers globally
const $be735159016cae74$var$handlers = {};
const $be735159016cae74$var$instrumented = {};
/** Add a handler function. */ function $be735159016cae74$export$a4e09611e30da72e(type, handler) {
    $be735159016cae74$var$handlers[type] = $be735159016cae74$var$handlers[type] || [];
    $be735159016cae74$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $be735159016cae74$export$b17eab759a1cb5fe() {
    Object.keys($be735159016cae74$var$handlers).forEach((key)=>{
        $be735159016cae74$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $be735159016cae74$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$be735159016cae74$var$instrumented[type]) {
        $be735159016cae74$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $be735159016cae74$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $be735159016cae74$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}



const $5f3c0b8987a9c625$export$56d8a8a25bd48b81 = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);


const $021562726ff72538$var$DEBOUNCE_DURATION = 1000;
let $021562726ff72538$var$debounceTimerID;
let $021562726ff72538$var$lastCapturedEventType;
let $021562726ff72538$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $021562726ff72538$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $021562726ff72538$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $021562726ff72538$export$3014bbf0af0e1d4a() {
    if (!(0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $be735159016cae74$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $021562726ff72538$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $021562726ff72538$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $021562726ff72538$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $021562726ff72538$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $021562726ff72538$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $021562726ff72538$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $021562726ff72538$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $021562726ff72538$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($021562726ff72538$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(target, '_sentryId', (0, $832931c5253c6f61$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$021562726ff72538$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $021562726ff72538$var$lastCapturedEventType = event.type;
            $021562726ff72538$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($021562726ff72538$var$debounceTimerID);
        $021562726ff72538$var$debounceTimerID = (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).setTimeout(()=>{
            $021562726ff72538$var$lastCapturedEventTargetId = undefined;
            $021562726ff72538$var$lastCapturedEventType = undefined;
        }, $021562726ff72538$var$DEBOUNCE_DURATION);
    };
}
function $021562726ff72538$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



let $aa321501103bea56$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $aa321501103bea56$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $aa321501103bea56$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $aa321501103bea56$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $aa321501103bea56$var$lastHref;
        $aa321501103bea56$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $be735159016cae74$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $454364c661d00d30$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $aa321501103bea56$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $aa321501103bea56$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $be735159016cae74$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}



const $0a61ddeb01dceb07$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0a61ddeb01dceb07$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $0a61ddeb01dceb07$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $0a61ddeb01dceb07$export$c67d533bf77cbf54() {
    if (!(0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $04327917d6f3444a$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $0a61ddeb01dceb07$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$0a61ddeb01dceb07$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$0a61ddeb01dceb07$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $be735159016cae74$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$0a61ddeb01dceb07$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $04327917d6f3444a$export$844ec244b1367d54)(header) && (0, $04327917d6f3444a$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$0a61ddeb01dceb07$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $be735159016cae74$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $0a61ddeb01dceb07$var$parseXhrUrlArg(url) {
    if ((0, $04327917d6f3444a$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $e56315d488d5f830$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $e56315d488d5f830$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $7579005d8c799ca0$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $e56315d488d5f830$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $b99b0aced21a41e0$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $50107229405f0b55$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $204766ed52e0ca74$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $204766ed52e0ca74$var$instrumentConsole);
}
function $204766ed52e0ca74$var$instrumentConsole() {
    if (!('console' in (0, $4546c9f85d024500$export$f1a6cdb1459e81d1))) return;
    (0, $50107229405f0b55$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).console)) return;
        (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $4546c9f85d024500$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $50107229405f0b55$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $be735159016cae74$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $50107229405f0b55$export$77c4ce905194557b)[level];
                log?.apply((0, $4546c9f85d024500$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4793d2ef5a24aa18$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, ()=>$4793d2ef5a24aa18$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $4793d2ef5a24aa18$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, ()=>$4793d2ef5a24aa18$var$instrumentFetch($4793d2ef5a24aa18$var$streamHandler));
}
function $4793d2ef5a24aa18$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $454364c661d00d30$export$c82d238e23c40b21)()) return;
    (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $4546c9f85d024500$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $4793d2ef5a24aa18$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $4793d2ef5a24aa18$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $be735159016cae74$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $4546c9f85d024500$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $be735159016cae74$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $be735159016cae74$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $04327917d6f3444a$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $4793d2ef5a24aa18$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $4793d2ef5a24aa18$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $4793d2ef5a24aa18$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $be735159016cae74$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $4793d2ef5a24aa18$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $4793d2ef5a24aa18$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($4793d2ef5a24aa18$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $4793d2ef5a24aa18$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $4793d2ef5a24aa18$var$getUrlFromResource(url),
            method: $4793d2ef5a24aa18$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $4793d2ef5a24aa18$var$getUrlFromResource(arg),
        method: $4793d2ef5a24aa18$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $4793d2ef5a24aa18$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $04327917d6f3444a$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $e82b0b6d57f59f62$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $be7435a8b8909e7b$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $be7435a8b8909e7b$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $be7435a8b8909e7b$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.startsWith('/');
    const base = urlBase ?? (isRelative ? $be7435a8b8909e7b$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $be7435a8b8909e7b$export$5339fcdc8e2a427c(url) {
    if ($be7435a8b8909e7b$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $be7435a8b8909e7b$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $be7435a8b8909e7b$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $be7435a8b8909e7b$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $c107bbb6bc21618d$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $d447c48b9e08cd77$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $d447c48b9e08cd77$var$INTEGRATION_NAME = 'Breadcrumbs';
const $d447c48b9e08cd77$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $d447c48b9e08cd77$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $204766ed52e0ca74$export$1d6e0d073f9e6723)($d447c48b9e08cd77$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $021562726ff72538$export$5aeffd3db2cf9df7)($d447c48b9e08cd77$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $0a61ddeb01dceb07$export$26ace48dd54c9aea)($d447c48b9e08cd77$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $4793d2ef5a24aa18$export$f75d3c772c923df0)($d447c48b9e08cd77$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $aa321501103bea56$export$3f18c56c58114e75)($d447c48b9e08cd77$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $d447c48b9e08cd77$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $d447c48b9e08cd77$export$c079d904b326663a = (0, $861e84080756a67e$export$2323046b9414659f)($d447c48b9e08cd77$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $d447c48b9e08cd77$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        (0, $e56315d488d5f830$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $832931c5253c6f61$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $d447c48b9e08cd77$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $d447c48b9e08cd77$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$d447c48b9e08cd77$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$d447c48b9e08cd77$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $d447c48b9e08cd77$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $d447c48b9e08cd77$var$_isEvent(event) ? event.target : event;
            target = (0, $d2c922fb99362c48$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $d2c922fb99362c48$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $e56315d488d5f830$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $d447c48b9e08cd77$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $c107bbb6bc21618d$export$d771ef054122c30a)(handlerData.level),
            message: (0, $404b08ff2be9997a$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $404b08ff2be9997a$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $e56315d488d5f830$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $d447c48b9e08cd77$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $0a61ddeb01dceb07$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $e82b0b6d57f59f62$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $e56315d488d5f830$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $d447c48b9e08cd77$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $e56315d488d5f830$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $e82b0b6d57f59f62$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $e56315d488d5f830$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $d447c48b9e08cd77$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $be7435a8b8909e7b$export$7a5253c0f62e0150)((0, $4344c5993a935327$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $be7435a8b8909e7b$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $be7435a8b8909e7b$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $e56315d488d5f830$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $d447c48b9e08cd77$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $9a68cce3ce0bb193$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $9a68cce3ce0bb193$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $9a68cce3ce0bb193$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $9a68cce3ce0bb193$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $4344c5993a935327$export$56d8a8a25bd48b81), 'setTimeout', $9a68cce3ce0bb193$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $4344c5993a935327$export$56d8a8a25bd48b81), 'setInterval', $9a68cce3ce0bb193$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $4344c5993a935327$export$56d8a8a25bd48b81), 'requestAnimationFrame', $9a68cce3ce0bb193$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $4344c5993a935327$export$56d8a8a25bd48b81)) (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $9a68cce3ce0bb193$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $9a68cce3ce0bb193$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($9a68cce3ce0bb193$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $9a68cce3ce0bb193$export$59bfe9f1c76150e = (0, $861e84080756a67e$export$2323046b9414659f)($9a68cce3ce0bb193$var$_browserApiErrorsIntegration);
function $9a68cce3ce0bb193$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $4344c5993a935327$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $9a68cce3ce0bb193$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $4344c5993a935327$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $9a68cce3ce0bb193$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $331e7a423c1d6bab$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $4344c5993a935327$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $9a68cce3ce0bb193$var$_wrapEventTarget(target) {
    const globalObject = (0, $4344c5993a935327$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($9a68cce3ce0bb193$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $4344c5993a935327$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $4344c5993a935327$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $9a68cce3ce0bb193$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $731b2b8bc77077dd$export$1baa7880e357371c = (0, $861e84080756a67e$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $4344c5993a935327$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $d0ea6cfcc1ddd989$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $d0ea6cfcc1ddd989$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $aa321501103bea56$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $d0ea6cfcc1ddd989$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $d0ea6cfcc1ddd989$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




let $19d5d29938440538$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $19d5d29938440538$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $19d5d29938440538$var$instrumentError);
}
function $19d5d29938440538$var$instrumentError() {
    $19d5d29938440538$var$_oldOnErrorHandler = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $be735159016cae74$export$b18c893e424d3127)('error', handlerData);
        if ($19d5d29938440538$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $19d5d29938440538$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $35f9e1cc8c25e8dd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $35f9e1cc8c25e8dd$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $35f9e1cc8c25e8dd$var$instrumentUnhandledRejection);
}
function $35f9e1cc8c25e8dd$var$instrumentUnhandledRejection() {
    $35f9e1cc8c25e8dd$var$_oldOnUnhandledRejectionHandler = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $be735159016cae74$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($35f9e1cc8c25e8dd$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $35f9e1cc8c25e8dd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $c25e540eb2723260$var$INTEGRATION_NAME = 'GlobalHandlers';
const $c25e540eb2723260$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $c25e540eb2723260$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $c25e540eb2723260$var$_installGlobalOnErrorHandler(client);
                $c25e540eb2723260$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $c25e540eb2723260$var$_installGlobalOnUnhandledRejectionHandler(client);
                $c25e540eb2723260$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $c25e540eb2723260$export$66acc70e8cf2b71a = (0, $861e84080756a67e$export$2323046b9414659f)($c25e540eb2723260$var$_globalHandlersIntegration);
function $c25e540eb2723260$var$_installGlobalOnErrorHandler(client) {
    (0, $19d5d29938440538$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c25e540eb2723260$var$getOptions();
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client || (0, $4344c5993a935327$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $c25e540eb2723260$var$_enhanceEventWithInitialFrame((0, $49f9172a05aa7804$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $d0ea6cfcc1ddd989$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $c25e540eb2723260$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $35f9e1cc8c25e8dd$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c25e540eb2723260$var$getOptions();
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client || (0, $4344c5993a935327$export$b79738ab10c590b2)()) return;
        const error = $c25e540eb2723260$var$_getUnhandledRejectionError(e);
        const event = (0, $04327917d6f3444a$export$c3825b437cbdea5c)(error) ? $c25e540eb2723260$var$_eventFromRejectionWithPrimitive(error) : (0, $49f9172a05aa7804$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $d0ea6cfcc1ddd989$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $c25e540eb2723260$var$_getUnhandledRejectionError(error) {
    if ((0, $04327917d6f3444a$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $c25e540eb2723260$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $c25e540eb2723260$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $04327917d6f3444a$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $d2c922fb99362c48$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $c25e540eb2723260$var$globalHandlerLog(type) {
    (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $c25e540eb2723260$var$getOptions() {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $6abaf570de9c35b7$export$1378794447170364 = (0, $861e84080756a67e$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $4344c5993a935327$export$56d8a8a25bd48b81).navigator && !(0, $4344c5993a935327$export$56d8a8a25bd48b81).location && !(0, $4344c5993a935327$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request?.url || (0, $d2c922fb99362c48$export$1cfafeee2987818b)();
            const { referrer: referrer } = (0, $4344c5993a935327$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $4344c5993a935327$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request?.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $7e1a774b3ad20a6a$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $04327917d6f3444a$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $7e1a774b3ad20a6a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $7e1a774b3ad20a6a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $04327917d6f3444a$export$49034edbe6b62415)(error[key], Error)) {
        $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $7e1a774b3ad20a6a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $04327917d6f3444a$export$49034edbe6b62415)(childError, Error)) {
            $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $7e1a774b3ad20a6a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $e27823d35f485e68$var$DEFAULT_KEY = 'cause';
const $e27823d35f485e68$var$DEFAULT_LIMIT = 5;
const $e27823d35f485e68$var$INTEGRATION_NAME = 'LinkedErrors';
const $e27823d35f485e68$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $e27823d35f485e68$var$DEFAULT_LIMIT;
    const key = options.key || $e27823d35f485e68$var$DEFAULT_KEY;
    return {
        name: $e27823d35f485e68$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $7e1a774b3ad20a6a$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $49f9172a05aa7804$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $e27823d35f485e68$export$ebabb00eb7f3a395 = (0, $861e84080756a67e$export$2323046b9414659f)($e27823d35f485e68$var$_linkedErrorsIntegration);



// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $7acfd98b18348ab8$var$OPERA10_PRIORITY = 10;
const $7acfd98b18348ab8$var$OPERA11_PRIORITY = 20;
const $7acfd98b18348ab8$var$CHROME_PRIORITY = 30;
const $7acfd98b18348ab8$var$WINJS_PRIORITY = 40;
const $7acfd98b18348ab8$var$GECKO_PRIORITY = 50;
function $7acfd98b18348ab8$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $7acfd98b18348ab8$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $7acfd98b18348ab8$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $7acfd98b18348ab8$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $7acfd98b18348ab8$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $7acfd98b18348ab8$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $7acfd98b18348ab8$var$createFrame(filename, (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $7acfd98b18348ab8$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $7acfd98b18348ab8$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $7acfd98b18348ab8$var$extractSafariExtensionDetails(parts[1] || (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac), parts[2]);
        return $7acfd98b18348ab8$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $7acfd98b18348ab8$export$263a749fff749872 = [
    $7acfd98b18348ab8$var$CHROME_PRIORITY,
    $7acfd98b18348ab8$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $7acfd98b18348ab8$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $7acfd98b18348ab8$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $7acfd98b18348ab8$var$gecko = (line)=>{
    const parts = $7acfd98b18348ab8$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $7acfd98b18348ab8$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac);
        [func, filename] = $7acfd98b18348ab8$var$extractSafariExtensionDetails(func, filename);
        return $7acfd98b18348ab8$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $7acfd98b18348ab8$export$cdba47a5dd2804d = [
    $7acfd98b18348ab8$var$GECKO_PRIORITY,
    $7acfd98b18348ab8$var$gecko
];
const $7acfd98b18348ab8$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $7acfd98b18348ab8$var$winjs = (line)=>{
    const parts = $7acfd98b18348ab8$var$winjsRegex.exec(line);
    return parts ? $7acfd98b18348ab8$var$createFrame(parts[2], parts[1] || (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $7acfd98b18348ab8$export$179460296da408e8 = [
    $7acfd98b18348ab8$var$WINJS_PRIORITY,
    $7acfd98b18348ab8$var$winjs
];
const $7acfd98b18348ab8$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $7acfd98b18348ab8$var$opera10 = (line)=>{
    const parts = $7acfd98b18348ab8$var$opera10Regex.exec(line);
    return parts ? $7acfd98b18348ab8$var$createFrame(parts[2], parts[3] || (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $7acfd98b18348ab8$export$f892b52c880ffc7a = [
    $7acfd98b18348ab8$var$OPERA10_PRIORITY,
    $7acfd98b18348ab8$var$opera10
];
const $7acfd98b18348ab8$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $7acfd98b18348ab8$var$opera11 = (line)=>{
    const parts = $7acfd98b18348ab8$var$opera11Regex.exec(line);
    return parts ? $7acfd98b18348ab8$var$createFrame(parts[5], parts[3] || parts[4] || (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $7acfd98b18348ab8$export$af11af13f09fb0dc = [
    $7acfd98b18348ab8$var$OPERA11_PRIORITY,
    $7acfd98b18348ab8$var$opera11
];
const $7acfd98b18348ab8$export$7197c0fe6554c079 = [
    $7acfd98b18348ab8$export$263a749fff749872,
    $7acfd98b18348ab8$export$cdba47a5dd2804d
];
const $7acfd98b18348ab8$export$2b2b997d81bf3907 = (0, $6eb7fa2c12e5f94a$export$a5739666fb2d03d4)(...$7acfd98b18348ab8$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $7acfd98b18348ab8$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a1647adb6599c170$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $270d12994bf1f4ec$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $270d12994bf1f4ec$export$e464f4a514ac28a8(name) {
    const cached = $270d12994bf1f4ec$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $454364c661d00d30$export$d5f608b368e73f38)(impl)) return $270d12994bf1f4ec$var$cachedImplementations[name] = impl.bind((0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81));
    const document = (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $a1647adb6599c170$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $270d12994bf1f4ec$var$cachedImplementations[name] = impl.bind((0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $270d12994bf1f4ec$export$8aa36702e8c8978(name) {
    $270d12994bf1f4ec$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $270d12994bf1f4ec$export$e7aa7bc5c1b3cfb3(...rest) {
    return $270d12994bf1f4ec$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $270d12994bf1f4ec$export$831dc9f2ab0a617b(...rest) {
    return $270d12994bf1f4ec$export$e464f4a514ac28a8('setTimeout')(...rest);
}






const $d9d42f3ee1635225$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $d9d42f3ee1635225$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $88d6af982193bd0a$export$78e43115b553f358)($d9d42f3ee1635225$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $88d6af982193bd0a$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $9473eeeb360c214f$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $9473eeeb360c214f$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $9473eeeb360c214f$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $9473eeeb360c214f$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $9473eeeb360c214f$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $9473eeeb360c214f$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $9473eeeb360c214f$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $9473eeeb360c214f$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $3757232aff96d110$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $3757232aff96d110$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $d9d42f3ee1635225$export$85a4f67f852183e6)(options.bufferSize || $3757232aff96d110$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $b04b40088fe5ea6b$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $b04b40088fe5ea6b$export$b11169581eeaf237)(type);
            if ((0, $9473eeeb360c214f$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $b04b40088fe5ea6b$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $b04b40088fe5ea6b$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $b04b40088fe5ea6b$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $9473eeeb360c214f$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $d9d42f3ee1635225$export$c8667f1887a128dc)) {
                (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $925c7eb596cc6482$export$b2311068c46d7cc8(options, nativeFetch = (0, $270d12994bf1f4ec$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $270d12994bf1f4ec$export$8aa36702e8c8978)('fetch');
            return (0, $88d6af982193bd0a$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $270d12994bf1f4ec$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $88d6af982193bd0a$export$78e43115b553f358)(e);
        }
    }
    return (0, $3757232aff96d110$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $ce7e9b0fffbfaf16$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $9230543946cecc48$export$cb3c5c2ceb9818ba)(),
        (0, $8c14f7174ada528d$export$7918117e9202e4fb)(),
        (0, $9a68cce3ce0bb193$export$59bfe9f1c76150e)(),
        (0, $d447c48b9e08cd77$export$c079d904b326663a)(),
        (0, $c25e540eb2723260$export$66acc70e8cf2b71a)(),
        (0, $e27823d35f485e68$export$ebabb00eb7f3a395)(),
        (0, $879ff71665c6eecc$export$6d39aa44cd0c7567)(),
        (0, $6abaf570de9c35b7$export$1378794447170364)(),
        (0, $731b2b8bc77077dd$export$1baa7880e357371c)()
    ];
}
/** Exported only for tests. */ function $ce7e9b0fffbfaf16$export$4e107b20a7f977(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $ce7e9b0fffbfaf16$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $4344c5993a935327$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true
    };
    return {
        ...defaultOptions,
        ...$ce7e9b0fffbfaf16$var$dropTopLevelUndefinedKeys(optionsArg)
    };
}
/**
 * In contrast to the regular `dropUndefinedKeys` method,
 * this one does not deep-drop keys, but only on the top level.
 */ function $ce7e9b0fffbfaf16$var$dropTopLevelUndefinedKeys(obj) {
    const mutatetedObj = {};
    for (const k of Object.getOwnPropertyNames(obj)){
        const key = k;
        if (obj[key] !== undefined) mutatetedObj[key] = obj[key];
    }
    return mutatetedObj;
}
function $ce7e9b0fffbfaf16$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $4344c5993a935327$export$56d8a8a25bd48b81).window !== 'undefined' && (0, $4344c5993a935327$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject?.runtime?.id;
    const href = (0, $d2c922fb99362c48$export$1cfafeee2987818b)() || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $4344c5993a935327$export$56d8a8a25bd48b81) === (0, $4344c5993a935327$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $ce7e9b0fffbfaf16$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $ce7e9b0fffbfaf16$export$4e107b20a7f977(browserOptions);
    if (!options.skipBrowserExtensionCheck && $ce7e9b0fffbfaf16$var$shouldShowBrowserExtensionError()) {
        if (0, $2d9d70da08177dd3$export$16a28057038b10ef) (0, $50107229405f0b55$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if ((0, $2d9d70da08177dd3$export$16a28057038b10ef) && !(0, $454364c661d00d30$export$edf3cb81fd7d2a3e)()) (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    const clientOptions = {
        ...options,
        stackParser: (0, $6eb7fa2c12e5f94a$export$1d5cf88b347146d4)(options.stackParser || (0, $7acfd98b18348ab8$export$2b2b997d81bf3907)),
        integrations: (0, $861e84080756a67e$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $925c7eb596cc6482$export$b2311068c46d7cc8)
    };
    return (0, $62a36d7bdb68e8f6$export$5333c3f1c58d9bc1)((0, $ee9a22ecd1aa84b2$export$1df9218a526d318d), clientOptions);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $ce7e9b0fffbfaf16$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $4344c5993a935327$export$56d8a8a25bd48b81).document) {
        (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $d0ea6cfcc1ddd989$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $4344c5993a935327$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $1b878ff624a14448$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $4344c5993a935327$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $4344c5993a935327$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $4344c5993a935327$export$56d8a8a25bd48b81).document.head || (0, $4344c5993a935327$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $ce7e9b0fffbfaf16$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $ce7e9b0fffbfaf16$export$4e4d8b287d028b6b(callback) {
    callback();
}




var $8nGP5 = parcelRequire("8nGP5");

var $cSUBB = parcelRequire("cSUBB");
// Ensure we use the default export from hoist-non-react-statics if available,
// falling back to the module itself. This handles both ESM and CJS usage.
const $5ad43317f9410006$export$6c1f0397687d8b2 = $cSUBB.default || $cSUBB;


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $dde552c79915ef63$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





var $8nGP5 = parcelRequire("8nGP5");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $238dbbfae37bcc04$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $238dbbfae37bcc04$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $238dbbfae37bcc04$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($238dbbfae37bcc04$export$a87138b73900f5b((0, $8nGP5.version)) && (0, $04327917d6f3444a$export$e6127cc7fe7395c3)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $238dbbfae37bcc04$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $7579005d8c799ca0$export$ec58d9285c204497)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $d0ea6cfcc1ddd989$export$f5282963edea4a68)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $238dbbfae37bcc04$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $238dbbfae37bcc04$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}


const $36d6126caa675dd8$export$6ef4c0367e27f2d5 = 'unknown';
const $36d6126caa675dd8$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $36d6126caa675dd8$export$e926676385687eaf extends $8nGP5.Component {
    constructor(props){
        super(props);
        this.state = $36d6126caa675dd8$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on('afterSendEvent', (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $ce7e9b0fffbfaf16$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $7579005d8c799ca0$export$ec58d9285c204497)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $238dbbfae37bcc04$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: handled
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $ce7e9b0fffbfaf16$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $36d6126caa675dd8$var$INITIAL_STATE) // If the error boundary never encountered an error, call onUnmount with null values
            onUnmount(null, null, null);
            else // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
            // when the error boundary has already encountered an error.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
        // when the error boundary has already encountered an error.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onReset(error, componentStack, eventId);
        this.setState($36d6126caa675dd8$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        // `componentStack` is only null in the initial state, when no error has been captured.
        // If an error has been captured, `componentStack` will be a string.
        // We cannot check `state.error` because null can be thrown as an error.
        if (state.componentStack === null) return typeof children === 'function' ? children() : children;
        const element = typeof fallback === 'function' ? $8nGP5.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($8nGP5.isValidElement(element)) return element;
        if (fallback) (0, $dde552c79915ef63$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('fallback did not produce a valid ReactElement');
        // Fail gracefully if no fallback provided or is not valid
        return null;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $36d6126caa675dd8$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $36d6126caa675dd8$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$8nGP5.createElement($36d6126caa675dd8$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $8nGP5.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, $5ad43317f9410006$export$6c1f0397687d8b2)(Wrapped, WrappedComponent);
    return Wrapped;
}




var $8nGP5 = parcelRequire("8nGP5");
/**
 * Inits the React SDK
 */ function $dd2a0d6c025e4d96$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $97e636466ee42774$export$b9f95b027256052c)(opts, 'react');
    (0, $d0ea6cfcc1ddd989$export$2f04de43fe27971a)('react', {
        version: $8nGP5.version
    });
    return (0, $ce7e9b0fffbfaf16$export$2cd8252107eb640b)(opts);
}





const $b1b793d8911e6aa6$var$config = (0, $3d79bba9fc178656$export$b3611e87cd5ba6ce)();
const $b1b793d8911e6aa6$var$isProd = true;
if ($b1b793d8911e6aa6$var$isProd) {
    console.log('**** Sentry enabled ****');
    $dd2a0d6c025e4d96$export$2cd8252107eb640b({
        dsn: 'https://da20019de005c0cb1ea1e1f5fe326fb7@o4509184942407680.ingest.us.sentry.io/4509184943390720',
        environment: $b1b793d8911e6aa6$var$config.clientName
    });
}
(0, $b2432f43c421c848$export$7a667d08ed65fa47)().init();
(0, $de9addb89ca41b61$export$dfb5619354ba860)();
(0, $T5IcR.configure)({
    enforceActions: 'never'
});
self.addEventListener('unhandledrejection', ({ reason: reason })=>{
//const { message } = reason as Error;
//if (message) self.alert(message);
});
// const { serviceWorker } = window.navigator,
//     NODE_ENV = process.env.NODE_ENV || 'development';
// if (NODE_ENV !== 'development')
//     serviceWorker
//         ?.register('sw.js')
//         .then(serviceWorkerUpdate)
//         .then(worker => {
//             if (
//                 window.confirm(
//                     'New version of this Web App detected, update now?'
//                 )
//             )
//                 worker.postMessage({ type: 'SKIP_WAITING' });
//         });
// serviceWorker?.addEventListener('controllerchange', () =>
//     window.location.reload()
// );
const $b1b793d8911e6aa6$var$root = (0, $d87212bfbb9d55bf$export$882461b6382ed46c)(document.querySelector('#app'));
const $b1b793d8911e6aa6$var$errorPage = (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
    style: {
        backgroundColor: 'white'
    },
    fillCell: true,
    direction: "column",
    justify: "center",
    alignItems: "center",
    children: (0, $kSbwP.jsx)("div", {
        style: {
            transform: 'scale(2)'
        },
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            justify: "center",
            alignItems: "center",
            children: [
                (0, $kSbwP.jsx)((0, $bc783706f3494468$export$e6ff31bff12b7ff4), {}),
                (0, $kSbwP.jsx)("div", {
                    style: {
                        fontSize: '20px',
                        marginTop: '15px'
                    },
                    children: "An error has occurred."
                }),
                (0, $kSbwP.jsx)("div", {
                    style: {
                        fontSize: '8px'
                    },
                    children: "An automatic error report has been sent to Flightline."
                })
            ]
        })
    })
});
if ($b1b793d8911e6aa6$var$isProd) {
    const page = (0, $kSbwP.jsx)($36d6126caa675dd8$export$e926676385687eaf, {
        fallback: $b1b793d8911e6aa6$var$errorPage,
        children: (0, $kSbwP.jsx)((0, $325af5f10b3faac7$export$953c2efc134d7f79), {})
    });
    $b1b793d8911e6aa6$var$root.render(page);
} else $b1b793d8911e6aa6$var$root.render((0, $kSbwP.jsx)((0, $325af5f10b3faac7$export$953c2efc134d7f79), {}));


//# sourceMappingURL=index.5390efc4.js.map
